// Generated by lamdera-1.5.0-0.19.2 which includes the following package replacements:
// elm/browser: https://github.com/lamdera/elm-browser/commit/db440d144685f94979ffc47322e1a54b527e1510 (based on v1.0.2)
// elm/core: https://github.com/lamdera/elm-core/commit/efc76dcaf59b6fa80b7e7db1ca17652dc0aac5fc (based on v1.0.5)
// elm/html: https://github.com/lamdera/elm-html/commit/b35c476a69f0ba9bf8282d8c15df65e63aefea8f (based on v1.0.1)
// elm/virtual-dom: https://github.com/lamdera/elm-virtual-dom/commit/66fe2171254f4c284e6864ba2acaa972b7e16ff8 (based on v1.0.5)
(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'SeqSet_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'SeqSet')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $lamdera$containers$SeqSet$toList(value));
		}

		if (tag === 'SeqDict_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'SeqDict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $lamdera$containers$SeqDict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.start.line === region.end.line)
	{
		return 'on line ' + region.start.line;
	}
	return 'on lines ' + region.start.line + ' through ' + region.end.line;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	if (x.$ === 'SeqDict_elm_builtin')
	{
		x = $lamdera$containers$SeqDict$toList(x);
		y = $lamdera$containers$SeqDict$toList(y);
	}
	if (x.$ === 'SeqSet_elm_builtin')
	{
		x = $lamdera$containers$SeqSet$toList(x);
		y = $lamdera$containers$SeqSet$toList(y);
	}
	//*/

	/**/
	if (x.$ < -10)
	{
		x = $lamdera$containers$SeqDict$toList(x);
		y = $lamdera$containers$SeqDict$toList(y);
	}
	else if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (Object.prototype.hasOwnProperty.call(value, key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	var unwrapped = _Json_unwrap(value);
	if (!(key === 'toJSON' && typeof unwrapped === 'function'))
	{
		object[key] = unwrapped;
	}
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


var _JsArray2_empty = [];

var _JsArray2_singleton = function(val) {
    return [val];
};

var _JsArray2_length = function(arr) {
    return arr.length;
};

var _JsArray2_initialize = F3(function(size, offset, f) {
    var result = new Array(size);

    for (var i = 0; i < size; i++) {
        result[i] = f(offset + i);
    }

    return result;
});

var _JsArray2_initializeFromList = F2(function(max, ls) {
    var result = new Array(max);

    for (var i = 0; i < max && ls.ctor !== '[]'; i++) {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray2_unsafeGet = F2(function(idx, arr) {
    return arr[idx];
});

var _JsArray2_unsafeSet = F3(function(idx, val, arr) {
    var length = arr.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++) {
        result[i] = arr[i];
    }

    result[idx] = val;
    return result;
});

var _JsArray2_unsafeInsert = F3(function(idx, val, arr) {
    var length = arr.length;
    var result = new Array(length + 1);

    for (var i = 0; i < idx; i++) {
	result[i] = arr[i];
    }

    result[idx] = val;

    for (var i = idx; i < length; i++) {
	result[i + 1] = arr[i];
    }

    return result;
});

var _JsArray2_removeIndex = F2(function(idx, arr) {
    var length = arr.length;
    var result = new Array(length - 1);

    for (var i = 0; i < idx; i++) {
	result[i] = arr[i];
    }

    for (var i = idx + 1; i < length; i++) {
	result[i - 1] = arr[i];
    }

    return result;
});

var _JsArray2_push = F2(function(val, arr) {
    var length = arr.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++) {
        result[i] = arr[i];
    }

    result[length] = val;
    return result;
});

var _JsArray2_foldl = F3(function(f, acc, arr) {
    var length = arr.length;

    for (var i = 0; i < length; i++) {
        acc = A2(f, arr[i], acc);
    }

    return acc;
});

var _JsArray2_foldr = F3(function(f, acc, arr) {
    for (var i = arr.length - 1; i >= 0; i--) {
        acc = A2(f, arr[i], acc);
    }

    return acc;
});

var _JsArray2_map = F2(function(f, arr) {
    var length = arr.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++) {
        result[i] = f(arr[i]);
    }

    return result;
});

var _JsArray2_indexedMap = F3(function(f, offset, arr) {
    var length = arr.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++) {
        result[i] = A2(f, offset + i, arr[i]);
    }

    return result;
});

var _JsArray2_slice = F3(function(from, to, arr) {
    return arr.slice(from, to);
});

var _JsArray2_appendN = F3(function(n, dest, source) {
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length) {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++) {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++) {
        result[i + destLen] = source[i];
    }

    return result;
});


var _FNV_prime = 16777619;
var _FNV_offset = 2166136261;

function _FNV_hash(object) {
    switch (typeof object) {
    case 'string': return _FNV_hashString(object);
    case 'number': return _FNV_hashNum(object);
    case 'boolean': return object ? _FNV_hashNum(1) : _FNV_hashNum(0);
    case 'object': return _FNV_hashObj(object);
    default: return 0;
    }
}

function _FNV_hashString(str) {
    var current = _FNV_offset;

    for (var i = 0, len = str.length; i < len; i++) {
	current = (current ^ str.charCodeAt(i)) * _FNV_prime;
    }

    return current >>> 0;
}

function _FNV_hashNum(num) {
    return ((_FNV_offset ^ num) * _FNV_prime) >>> 0;
}

function _FNV_hashObj(obj) {
    var current = _FNV_offset;

    /**_UNUSED/
    if (obj.$ === 'Set_elm_builtin')
    {
        obj = $elm$core$Set$toList(obj);
    }
    if (obj.$ === 'RBNode_elm_builtin' || obj.$ === 'RBEmpty_elm_builtin')
    {
        obj = $elm$core$Dict$toList(obj);
    }
    if (obj.$ === 'SeqDict_elm_builtin')
    {
      obj = $lamdera$containers$SeqDict$toList(obj);
    }
    if (obj.$ === 'SeqSet_elm_builtin')
    {
      obj = $lamdera$containers$SeqSet$toList(obj);
    }
    //*/

    /**/
    if (obj.$ < 0)
    {
        if (obj.$ < -10)
        {
            obj = $lamdera$containers$SeqDict$toList(obj);
        }
        else
        {
            obj = $elm$core$Dict$toList(obj);
        }
    }
    //*/

    for (var key in obj) {
	current = (current ^ _FNV_hash(obj[key])) * _FNV_prime;
    }

    return current >>> 0;
}




// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
			// Here’s how `task.c` comes to existence:
			//
			// _Scheduler_binding(function (callback) {
			//     // Do stuff and use callback.
			//     // The below function is assigned to `task.c` by `_Scheduler_step`.
			//     return function() {
			//         // Do cleanup. Doesn’t use callback, but technically has it in scope.
			//     }
			// });
			//
			// Since `task.c` has that `callback` in scope, which eventually references
			// `sendToApp`, which has access to `model` etc., it’s important to remove it
			// after using it. Otherwise it can prevent a stopped app from being garbage collected.
			// `null` is the default value for `c` as seen in `_Scheduler_binding`.
			// It also doesn’t make sense to kill the same task twice anyway.
			task.c = null;
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}


// BYTES

function _Bytes_width(bytes)
{
	return bytes.byteLength;
}

var _Bytes_getHostEndianness = F2(function(le, be)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(new Uint8Array(new Uint32Array([1]))[0] === 1 ? le : be));
	});
});


// ENCODERS

function _Bytes_encode(encoder)
{
	var mutableBytes = new DataView(new ArrayBuffer($elm$bytes$Bytes$Encode$getWidth(encoder)));
	$elm$bytes$Bytes$Encode$write(encoder)(mutableBytes)(0);
	return mutableBytes;
}


// SIGNED INTEGERS

var _Bytes_write_i8  = F3(function(mb, i, n) { mb.setInt8(i, n); return i + 1; });
var _Bytes_write_i16 = F4(function(mb, i, n, isLE) { mb.setInt16(i, n, isLE); return i + 2; });
var _Bytes_write_i32 = F4(function(mb, i, n, isLE) { mb.setInt32(i, n, isLE); return i + 4; });


// UNSIGNED INTEGERS

var _Bytes_write_u8  = F3(function(mb, i, n) { mb.setUint8(i, n); return i + 1 ;});
var _Bytes_write_u16 = F4(function(mb, i, n, isLE) { mb.setUint16(i, n, isLE); return i + 2; });
var _Bytes_write_u32 = F4(function(mb, i, n, isLE) { mb.setUint32(i, n, isLE); return i + 4; });


// FLOATS

var _Bytes_write_f32 = F4(function(mb, i, n, isLE) { mb.setFloat32(i, n, isLE); return i + 4; });
var _Bytes_write_f64 = F4(function(mb, i, n, isLE) { mb.setFloat64(i, n, isLE); return i + 8; });


// BYTES

var _Bytes_write_bytes = F3(function(mb, offset, bytes)
{
	for (var i = 0, len = bytes.byteLength, limit = len - 4; i <= limit; i += 4)
	{
		mb.setUint32(offset + i, bytes.getUint32(i));
	}
	for (; i < len; i++)
	{
		mb.setUint8(offset + i, bytes.getUint8(i));
	}
	return offset + len;
});


// STRINGS

function _Bytes_getStringWidth(string)
{
	for (var width = 0, i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		width +=
			(code < 0x80) ? 1 :
			(code < 0x800) ? 2 :
			(code < 0xD800 || 0xDBFF < code) ? 3 : (i++, 4);
	}
	return width;
}

var _Bytes_write_string = F3(function(mb, offset, string)
{
	for (var i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		offset +=
			(code < 0x80)
				? (mb.setUint8(offset, code)
				, 1
				)
				:
			(code < 0x800)
				? (mb.setUint16(offset, 0xC080 /* 0b1100000010000000 */
					| (code >>> 6 & 0x1F /* 0b00011111 */) << 8
					| code & 0x3F /* 0b00111111 */)
				, 2
				)
				:
			(code < 0xD800 || 0xDBFF < code)
				? (mb.setUint16(offset, 0xE080 /* 0b1110000010000000 */
					| (code >>> 12 & 0xF /* 0b00001111 */) << 8
					| code >>> 6 & 0x3F /* 0b00111111 */)
				, mb.setUint8(offset + 2, 0x80 /* 0b10000000 */
					| code & 0x3F /* 0b00111111 */)
				, 3
				)
				:
			(code = (code - 0xD800) * 0x400 + string.charCodeAt(++i) - 0xDC00 + 0x10000
			, mb.setUint32(offset, 0xF0808080 /* 0b11110000100000001000000010000000 */
				| (code >>> 18 & 0x7 /* 0b00000111 */) << 24
				| (code >>> 12 & 0x3F /* 0b00111111 */) << 16
				| (code >>> 6 & 0x3F /* 0b00111111 */) << 8
				| code & 0x3F /* 0b00111111 */)
			, 4
			);
	}
	return offset;
});


// DECODER

var _Bytes_decode = F2(function(decoder, bytes)
{
	try {
		return $elm$core$Maybe$Just(A2(decoder, bytes, 0).b);
	} catch(e) {
		return $elm$core$Maybe$Nothing;
	}
});

var _Bytes_read_i8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getInt8(offset)); });
var _Bytes_read_i16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getInt16(offset, isLE)); });
var _Bytes_read_i32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getInt32(offset, isLE)); });
var _Bytes_read_u8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getUint8(offset)); });
var _Bytes_read_u16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getUint16(offset, isLE)); });
var _Bytes_read_u32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getUint32(offset, isLE)); });
var _Bytes_read_f32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getFloat32(offset, isLE)); });
var _Bytes_read_f64 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 8, bytes.getFloat64(offset, isLE)); });

var _Bytes_read_bytes = F3(function(len, bytes, offset)
{
	return _Utils_Tuple2(offset + len, new DataView(bytes.buffer, bytes.byteOffset + offset, len));
});

var _Bytes_read_string = F3(function(len, bytes, offset)
{
	var string = '';
	var end = offset + len;
	for (; offset < end;)
	{
		var byte = bytes.getUint8(offset++);
		string +=
			(byte < 128)
				? String.fromCharCode(byte)
				:
			((byte & 0xE0 /* 0b11100000 */) === 0xC0 /* 0b11000000 */)
				? String.fromCharCode((byte & 0x1F /* 0b00011111 */) << 6 | bytes.getUint8(offset++) & 0x3F /* 0b00111111 */)
				:
			((byte & 0xF0 /* 0b11110000 */) === 0xE0 /* 0b11100000 */)
				? String.fromCharCode(
					(byte & 0xF /* 0b00001111 */) << 12
					| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
					| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
				)
				:
				(byte =
					((byte & 0x7 /* 0b00000111 */) << 18
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 12
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
						| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
					) - 0x10000
				, String.fromCharCode(Math.floor(byte / 0x400) + 0xD800, byte % 0x400 + 0xDC00)
				);
	}
	return _Utils_Tuple2(offset, string);
});

var _Bytes_decodeFailure = F2(function() { throw 0; });


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.multiline) { flags += 'm'; }
	if (options.caseInsensitive) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F3(function(impl, flagDecoder, debugMetadata)
{
	var init = function(args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			null,
			null,
			null,
			function() { return function() {} },
			impl
		);
	};

	/**_UNUSED/
	init.hotReloadData = {
		impl: impl,
		platform_effectManagers: _Platform_effectManagers,
		scheduler_enqueue: _Scheduler_enqueue
	};
	//*/

	return init;
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, _init, _update, _subscriptions, stepperBuilder, impl)
{
	// Old versions of elm/browser do not send the `impl` – instead, they send parts of it separately.
	// Sending the whole object is required for hot reloading.
	if (!impl)
	{
		impl = {
			init: _init,
			update: _update,
			subscriptions: _subscriptions
		}
	}

	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = impl.init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model, true);
	var ports = _Platform_setupEffects(managers, sendToApp);
	var stopped = false;
	var callUpdate = { call: A2 }; // Lamdera
	var errorHandler = args && args['errorHandler']; // Lamdera

	function sendToApp(msg, viewMetadata)
	{
		if (stopped)
		{
			return;
		}
		try
		{
			var pair = callUpdate.call(impl.update, msg, model);
			stepper(model = pair.a, viewMetadata);
			_Platform_enqueueEffects(managers, pair.b, impl.subscriptions(model));
		}
		catch (error)
		{
			if (errorHandler)
			{
				errorHandler(error);
			}
			else
			{
				throw error;
			}
		}
	}

	// Initial draw. This used to be done as a side effect of calling `stepperBuilder`.
	// `stepper.shutdown` was introduced at the same time as moving the draw call here,
	// so we can use that to know if we should draw or not. Drawing here has two benefits:
	// Firstly, it’s easier to understand. No hidden side effects. The effects are concentrated here.
	// Secondly, drawing can have side effects, because of custom elements. Their `connectedCallback`s
	// fire while drawing, and can dispatch (synchronous) events which cause an update. That won’t
	// work if the draw happened during `stepperBuilder`, since `stepper` won’t be defined here yet.
	if (stepper.shutdown)
	{
		stepper(model, true);
	}

	// Apply `Cmd`s from `init`, and run `subscriptions` for the first time.
	_Platform_enqueueEffects(managers, initPair.b, impl.subscriptions(model));

	var detachedDomNode = undefined;

	var detachView = function()
	{
		// Make a second call to `app.detachView` do nothing.
		if (detachedDomNode !== undefined)
		{
			return detachedDomNode;
		}

		// Draw synchronously one last time in case we’re waiting for an animation frame.
		stepper(model, true);

		var stepperShutdown = stepper.shutdown;

		// Prevent new draw calls from being made.
		stepper = function() {};

		// Remove event listeners from the DOM.
		// This is only available in newer versions of elm/browser.
		// Also note that `_Platform_worker` does not provide it (since there’s no `view`).
		detachedDomNode = stepperShutdown ? stepperShutdown() : null;

		// Return the final DOM node produced by Elm (if any).
		// This is necessarily not the same DOM node as the app was mounted on,
		// since Elm might replace it, for example if the element type changes.
		return detachedDomNode;
	};

	var stop = function()
	{
		// Make a second call to `app.stop` do nothing.
		if (stopped)
		{
			return detachedDomNode;
		}

		// Stop view. This can trigger synchronous updates, which is why we haven’t stopped updates yet.
		detachView();

		// Stop update. (This makes us ignore messages.)
		stopped = true;

		// Stop subscriptions.
		_Platform_enqueueEffects(managers, _Platform_batch(_List_Nil), _Platform_batch(_List_Nil));

		// Same return value as `app.detachView`.
		return detachedDomNode;
	};

	var app = {
		detachView: detachView,
		stop: stop
	};

	if (ports)
	{
		app.ports = ports;
	}

	/**_UNUSED/
	app.hotReload = function(hotReloadData)
	{
		// Remove old subscriptions.
		_Platform_enqueueEffects(managers, _Platform_batch(_List_Nil), _Platform_batch(_List_Nil));

		// This function depends on local state, so we need to update it to the implementation from the new code.
		_Scheduler_enqueue = hotReloadData.scheduler_enqueue;

		// Setup any new effect managers.
		var newPorts = _Platform_hotReloadEffects(managers, ports, hotReloadData.platform_effectManagers, sendToApp);
		if (!ports && newPorts)
		{
			app.ports = newPorts;
		}
		ports = newPorts;

		// Replace view, update and subscriptions with implementations from the new code.
		for (var key in hotReloadData.impl)
		{
			impl[key] = hotReloadData.impl[key];
		}

		// Draw synchronously with the new view function.
		stepper(model, true);

		// Set up new subscriptions.
		_Platform_enqueueEffects(managers, _Platform_batch(_List_Nil), impl.subscriptions(model));
	};
	//*/

	if (typeof _Lamdera_inject === 'function')
	{
		_Lamdera_inject(app, callUpdate, function () { return model; }, sendToApp);
	}

	return app;
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			var data = manager.a(key, sendToApp);
			ports[key] = data.b;
			managers[key] = _Platform_instantiateManager(
				data.c,
				data.d,
				null,
				manager.e,
				manager.f,
				sendToApp
			);
		}
		else
		{
			managers[key] = _Platform_instantiateManager(
				manager.c,
				manager.d,
				manager.g,
				manager.e,
				manager.f,
				sendToApp
			);
		}
	}

	return ports;
}


function _Platform_hotReloadEffects(managers, ports, newEffectManagers, sendToApp)
{
	for (var key in newEffectManagers)
	{
		var manager = newEffectManagers[key];
		var existing = _Platform_effectManagers[key];

		if (manager.a)
		{
			// If a port already exists and is still outgoing or still incoming:
			if (existing && (manager.e && existing.e || manager.f && existing.f))
			{
				// Update its converter in case it has been changed to let different data through.
				existing.h = manager.h;
			}
			else
			{
				// Otherwise instantiate a new port. JavaScript already subscribed to the old port
				// won’t get any more data there (since the new Elm code never sends any).
				// JavaScript trying to send data through the old port won’t achieve anything,
				// since the new Elm code doesn’t have it in its subscriptions.
				_Platform_effectManagers[key] = manager;
				ports = ports || {};
				var data = manager.a(key, sendToApp);
				ports[key] = data.b;
				managers[key] = _Platform_instantiateManager(
					data.c,
					data.d,
					null,
					manager.e,
					manager.f,
					sendToApp
				);
			}
		}
		else if (!existing)
		{
			// Instantiate new, non-port effect managers.
			_Platform_effectManagers[key] = manager;
			managers[key] = _Platform_instantiateManager(
				manager.c,
				manager.d,
				manager.g,
				manager.e,
				manager.f,
				sendToApp
			);
		}
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		c: init,
		d: onEffects,
		g: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(init, onEffects, onSelfMsg, cmdMap, subMap, sendToApp)
{
	var router = {
		i: sendToApp,
		j: undefined
	};

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.k, value.l, state)
				: A3(onEffects, router, cmdMap ? value.k : value.l, state);
		}));
	}

	return router.j = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, init));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.i(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.j, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			m: home,
			n: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		o: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		p: tagger,
		q: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ r: managers, s: cmdBag, t: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.r, fx.s, fx.t);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { k: _List_Nil, l: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.m;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.n);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.o; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.q, effectsDict, {
				u: bag.p,
				v: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.v)
		{
			x = temp.u(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { k: _List_Nil, l: _List_Nil };

	isCmd
		? (effects.k = _List_Cons(newEffect, effects.k))
		: (effects.l = _List_Cons(newEffect, effects.l));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		h: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].h;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	var onEffects = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		c: init,
		d: onEffects,
		b: {
			subscribe: subscribe,
			unsubscribe: unsubscribe
		}
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		h: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].h;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	var onEffects = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return {
		c: init,
		d: onEffects,
		b: { send: send }
	};
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	if (!('Elm' in scope))
	{
		// Use `defineProperty` to make `.hot` non-enumerable, so that a for-in loop on `scope['Elm']`
		// only includes Elm modules. We use that below, and end user code might depend on it too.
		scope['Elm'] = Object.defineProperty({}, 'hot', {
			value: {
				// Usage example:
				//     const f = new Function(newCompiledElmCodeAsString);
				//     const newScope = {};
				//     f.call(newScope);
				//     Elm.hot.reload(newScope);
				reload: function(newScope)
				{
					// Update Elm modules.
					_Platform_mergeExportsHotReload(scope['Elm'], newScope['Elm']);

					// Update hot reload data.
					for (var key in newScope['Elm'].hot.w)
					{
						scope['Elm'].hot.w[key] = newScope['Elm'].hot.w[key];
					}

					// Make the _new_ code push to the _old_ list of reload functions,
					// and read hot reload data from the _old_ dict (which is always merged with the latest above).
					var reloadFunctions = newScope['Elm'].hot.x = scope['Elm'].hot.x;
					newScope['Elm'].hot.w = scope['Elm'].hot.w;

					// Reload all running Elm app instances.
					for (var i = 0; i < reloadFunctions.length; i++)
					{
						reloadFunctions[i]();
					}
				},
				x: [],
				w: {}
			}
		});
	}
	_Platform_mergeExportsDebug('Elm', scope['Elm'], exports);
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		var exp = exports[name];
		if (name == 'init')
		{
			if (name in obj)
			{
				_Debug_crash(6, moduleName)
			}
			else
			{
				obj[name] = _Platform_wrapInit(moduleName, exp);
				scope['Elm'].hot.w[moduleName] = exp.hotReloadData;
				delete exp.hotReloadData;
			}
		}
		else
		{
			_Platform_mergeExportsDebug(moduleName + '.' + name, obj[name] || (obj[name] = {}), exp);
		}
	}
}


function _Platform_mergeExportsHotReload(obj, exports)
{
	for (var name in exports)
	{
		(name in obj && name != 'init')
			? _Platform_mergeExportsHotReload(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_wrapInit(moduleName, init)
{
	return function(args)
	{
		var app = init(args);

		var hotReload = app.hotReload;
		delete app.hotReload;
		var reloadFunction = function ()
		{
			hotReload(scope['Elm'].hot.w[moduleName]);
		};
		scope['Elm'].hot.x.push(reloadFunction);

		var stop = app.stop;
		app.stop = function()
		{
			var index = scope['Elm'].hot.x.indexOf(reloadFunction);
			if (index !== -1)
			{
				scope['Elm'].hot.x.splice(index, 1);
			}
			return stop();
		};

		return app;
	};
}




// Double underscore sequences are replaced with single letters or numbers.
// Exactly which letter or number is used depends on the order the properties are first mentioned.
// This preserves the letters and numbers from v1.0.3 for compatibility with tools that assume those exact values.
// elm-explorations/test: https://github.com/elm-explorations/test/blob/d5eb84809de0f8bbf50303efd26889092c800609/src/Elm/Kernel/HtmlAsJson.js
// elm-pages: https://github.com/dillonkearns/elm-pages/blob/fa1d0347016e20917b412de5c3657c2e6e095087/generator/src/build.js#L642
// The list of names was extracted using the following commands:
// # Switch to the reference commit:
// git switch $old
// # Find all relevant double underscore tokens.
// grep --only --extended-regexp '_{2}[0-9a-z]\w+' src/Elm/Kernel/VirtualDom.js | awk '!visited[$0]++' >a.txt
// # Switch to the current commit:
// git switch $new
// # Exclude the below line, then find all relevant double underscore tokens.
// grep --invert-match void src/Elm/Kernel/VirtualDom.js | grep --only --extended-regexp '_{2}[0-9a-z]\w+' | awk '!visited[$0]++' >b.txt
// # Keep only the double underscore tokens from the reference commit that still exist.
// grep --fixed-strings --line-regexp --file=b.txt a.txt
void { 0: null, a: null, b: null, 1: null, c: null, d: null, e: null, f: null, 2: null, 3: null, g: null, h: null, i: null, 4: null, j: null, k: null, 5: null, l: null, m: null, 0: null, n: null, o: null, 1: null, 2: null, 3: null, 4: null, p: null, q: null };



// HELPERS


var _VirtualDom_everTranslated = false;

var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

function _VirtualDom_insertBefore(parent, child, reference)
{
	if (!(child.parentNode === parent && child.nextSibling === reference))
	{
		parent.insertBefore(child, reference);
	}
}

function _VirtualDom_insertAfter(parent, child, reference)
{
	if (!(child.parentNode === parent && child.previousSibling === reference))
	{
		parent.insertBefore(child, reference === null ? parent.firstChild : reference.nextSibling);
	}
}

function _VirtualDom_moveBefore_(parent, child, reference)
{
	if (!(child.parentNode === parent && child.nextSibling === reference))
	{
		parent.moveBefore(child, reference);
	}
}

function _VirtualDom_moveAfter_(parent, child, reference)
{
	if (!(child.parentNode === parent && child.previousSibling === reference))
	{
		parent.moveBefore(child, reference === null ? parent.firstChild : reference.nextSibling);
	}
}

var _VirtualDom_supports_moveBefore = typeof Element !== 'undefined' && typeof Element.prototype.moveBefore === 'function';

var _VirtualDom_moveBefore = _VirtualDom_supports_moveBefore ? _VirtualDom_moveBefore_ : _VirtualDom_insertBefore;

var _VirtualDom_moveAfter = _VirtualDom_supports_moveBefore ? _VirtualDom_moveAfter_ : _VirtualDom_insertAfter;

function _VirtualDom_remove(domNode)
{
	// An extension might have (re-)moved the element, so even if we have a
	// reference to the `parentDomNode` that _should_ be the parent, we can’t
	// just call `parentDomNode.removeChild(domNode)`. That throws an error if
	// the node is not a child of `parentDomNode`.
	var parentNode = domNode.parentNode;
	if (parentNode)
	{
		parentNode.removeChild(domNode);
	}
}

// A `tNode`, or “tree node”, is a tree structure that contains DOM nodes. The
// children are keyed by index for regular nodes, and by key for keyed nodes.
// This tree structure always matches the latest rendered virtual DOM tree,
// while the real DOM tree might have been modified by browser extensions, page
// translators and third party scripts. By using our own tree, we can guarantee
// access to the DOM nodes we need, even if someone else has changed the page.
function _VirtualDom_createTNode(domNode)
{
	return {
		r: domNode,
		s: Object.create(null)
	};
}

var _VirtualDom_init = F3(function(virtualNode, flagDecoder, debugMetadata)
{
	// NOTE: this function needs _Platform_export available to work

	var init = function(args)
	{
		/**/
		var node = args['node'];
		//*/
		/**_UNUSED/
		var node = args && args['node'] ? args['node'] : _Debug_crash(0);
		//*/

		var sendToApp = function() {};
		var tNode = _VirtualDom_createTNode(undefined);
		var nextNode = _VirtualDom_render(virtualNode, sendToApp, tNode);
		nextNode.elmTree = tNode;
		node.parentNode.replaceChild(nextNode, node);
		node = nextNode;

		var stopped = false;
		var detachView = function()
		{
			// Make a second call to `app.detachView` do nothing.
			if (stopped)
			{
				return node;
			}
			stopped = true;
			_VirtualDom_removeAllEventListeners(node);
			return node;
		};

		var app = {
			detachView: detachView,
			stop: detachView
		};

		/**_UNUSED/
		app.hotReload = function(hotReloadData)
		{
			node = _VirtualDom_applyPatches(node, virtualNode, hotReloadData.virtualNode, sendToApp);
			virtualNode = hotReloadData.virtualNode;
		};
		//*/

		return app;
	};

	/**_UNUSED/
	init.hotReloadData = {
		virtualNode: virtualNode
	};
	//*/

	return init;
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = []; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			kids.push(kidList.a);
		}

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			// Unused, only exists for backwards compatibility with:
			// https://github.com/elm-explorations/test/blob/9669a27d84fc29175364c7a60d5d700771a2801e/src/Test/Html/Internal/ElmHtml/InternalTypes.elm#L279
			// https://github.com/dillonkearns/elm-pages/blob/fa1d0347016e20917b412de5c3657c2e6e095087/src/Test/Html/Internal/ElmHtml/InternalTypes.elm#L281
			b: 0
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], kidsMap = Object.create(null); kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			var key = kid.a;
			// Handle duplicate keys by adding a postfix.
			while (key in kidsMap)
			{
				key += _VirtualDom_POSTFIX;
				kid = _Utils_Tuple2(key, kid.b);
			}
			kids.push(kid);
			kidsMap[key] = kid.b;
		}

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			// e holds the order and length of the kids.
			e: kids,
			// t is a dict from key to node.
			// Note when iterating JavaScript objects, numeric-looking keys come first.
			// So we need both e and t.
			// Another reason is backwards compatibility with:
			// https://github.com/elm-explorations/test/blob/d5eb84809de0f8bbf50303efd26889092c800609/src/Elm/Kernel/HtmlAsJson.js#L37
			// https://github.com/dillonkearns/elm-pages/blob/fa1d0347016e20917b412de5c3657c2e6e095087/generator/src/build.js#L675
			t: kidsMap,
			f: namespace,
			b: 0 // See _VirtualDom_nodeNS.
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 0 // See _VirtualDom_nodeNS.
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'outerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (
		(typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		||
		(Array.isArray(_Json_unwrap(value)) && _VirtualDom_RE_js_html.test(String(_Json_unwrap(value))))
	)
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		message: func(record.message),
		stopPropagation: record.stopPropagation,
		preventDefault: record.preventDefault
	}
});



// ORGANIZE FACTS


// This boolean is used to turn the `class` attribute into the `className` property only when needed for
// backwards compatibility with elm-exploration/test (which only looks for `className` since `Html.Attributes.class` used to be implemented that way):
// https://github.com/elm-explorations/test/blob/eef7f1aad0cc8c8b1434c678c757a1429fbcb9c7/src/Test/Html/Internal/ElmHtml/Query.elm#L265
// Why not just keep `Html.Attributes.class` implemented as `className` then? Well, `Html.Attributes.class`
// is better implemented as a `class` attribute rather than the `className` property because:
// - In SVG, `className` is read only and throws an error if assigned. Setting the `class` attribute works.
// - It’s easier to virtualize `class` since no special case mapping from `class` to `className` is needed.
// - Properties are diffed against the actual DOM node. If a third-party script or browser extension add an
//   extra class on an element, that would be removed the next time Elm renders, even if nothing changed
//   about that element. Attributes are diffed against the previous virtual DOM, making it more likely that
//   extra added classes survive for some time.
// - Properties are applied every render, even for lazy nodes, to make sure that for example `value` is up-to-date
//   (it might have been altered by the web page user by typing in some field). `Html.Attributes.class` is likely
//   one of the most used `Html.Attributes` functions in view code, and does not need to be applied every render.
//   So not doing that is a small performance win.
var _VirtualDom_elmExplorationsTestBackwardsCompatibility = typeof _Test_runThunk === 'function';


function _VirtualDom_organizeFacts(factList)
{
	var facts = {};

	// Mark all elements for virtualization of server rendered nodes – see `_VirtualDom_markerProperty`.
	facts[_VirtualDom_markerProperty] = true;

	for (; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_elmExplorationsTestBackwardsCompatibility
				? _VirtualDom_addClass(facts, 'className', value)
				: _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode, tNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode, tNode);
	}

	if (tag === 4)
	{
		return _VirtualDom_render(vNode.k, function (msg, isSync) { return eventNode(vNode.j(msg), isSync) }, tNode);
	}

	if (tag === 0)
	{
		var domNode = _VirtualDom_doc.createTextNode(vNode.a);
		tNode.r = domNode;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, {}, vNode.d);
		tNode.r = domNode;
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		var listener = _VirtualDom_divertHrefToApp(domNode);
		domNode.elmAf = listener;
		domNode.addEventListener('click', listener);
	}

	_VirtualDom_applyFacts(domNode, eventNode, {}, vNode.d);

	if (tag === 1)
	{
		for (var kids = vNode.e, i = 0; i < kids.length; i++)
		{
			var childTNode = _VirtualDom_createTNode(undefined);
			var childDomNode = _VirtualDom_render(kids[i], eventNode, childTNode);
			tNode.s[i] = childTNode;
			_VirtualDom_appendChild(domNode, childDomNode);
		}
	}
	else
	{
		for (var kids = vNode.e, i = 0; i < kids.length; i++)
		{
			var kid = kids[i];
			var childTNode = _VirtualDom_createTNode(undefined);
			var childDomNode = _VirtualDom_render(kid.b, eventNode, childTNode);
			tNode.s[kid.a] = childTNode;
			_VirtualDom_appendChild(domNode, childDomNode);
		}
	}

	tNode.r = domNode;

	return domNode;
}

// Like `_VirtualDom_render`, but:
// - Assumes that we have already gone through diffing.
// - Only re-renders text nodes.
function _VirtualDom_renderTranslated(vNode, eventNode, tNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_renderTranslated(vNode.k, eventNode, tNode);
	}

	if (tag === 4)
	{
		return _VirtualDom_renderTranslated(vNode.k, function (msg, isSync) { return eventNode(vNode.j(msg), isSync) }, tNode);
	}

	if (tag === 0)
	{
		var newNode = _VirtualDom_doc.createTextNode(vNode.a);
		tNode.r = newNode;
		return newNode;
	}

	return tNode.r;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, prevFacts, facts)
{
	// Since properties and attributes are sometimes linked, we need to remove old
	// ones before setting new ones. Otherwise we might set the `id` attribute and
	// then remove the `id` property, resulting in no id, for example.

	if (prevFacts.a1 !== undefined)
	{
		_VirtualDom_removeStyles(domNode, prevFacts.a1, facts.a1 || {});
	}

	// `_VirtualDom_organizeFacts` puts properties directly on the `facts` object,
	// instead of at `facts.a2` which would have been more reasonable. So
	// we pass the entire `facts` as the props, and `_VirtualDom_removeProps` needs
	// to ignore `a3` etc.
	// This results in that you can mess things up by setting properties called "a0" to "a4",
	// but it’s not a big deal.
	// We can’t fix this because of backwards compatibility with:
	// https://github.com/elm-explorations/test/blob/9669a27d84fc29175364c7a60d5d700771a2801e/src/Test/Html/Internal/ElmHtml/InternalTypes.elm#L328
	// https://github.com/dillonkearns/elm-pages/blob/fa1d0347016e20917b412de5c3657c2e6e095087/src/Test/Html/Internal/ElmHtml/InternalTypes.elm#L330
	_VirtualDom_removeProps(domNode, prevFacts, facts);

	if (prevFacts.a3 !== undefined)
	{
		_VirtualDom_removeAttrs(domNode, prevFacts.a3, facts.a3 || {});
	}

	if (prevFacts.a4 !== undefined)
	{
		_VirtualDom_removeAttrsNS(domNode, prevFacts.a4, facts.a4 || {});
	}

	// Then, apply new facts.

	if (facts.a1 !== undefined)
	{
		_VirtualDom_applyStyles(domNode, prevFacts.a1 || {}, facts.a1);
	}

	if (facts.a3 !== undefined)
	{
		_VirtualDom_applyAttrs(domNode, prevFacts.a3 || {}, facts.a3);
	}

	if (facts.a4 !== undefined)
	{
		_VirtualDom_applyAttrsNS(domNode, prevFacts.a4 || {}, facts.a4);
	}

	// Apply properties _after_ attributes. This means that if you set the same
	// thing both as a property and an attribute, the property wins. If the
	// attribute had won, the property would “win” during the next render,
	// since properties are diffed against the actual DOM node, while
	// attributes are diffed against the previous virtual node. So it's better
	// to let the property win right away.
	// See the comment at the `_VirtualDom_removeProps` call earlier in this
	// function for why we pass the entire `facts` object.
	_VirtualDom_applyProps(domNode, facts);

	// Finally, apply events. There is no separate phase for removing events.
	// Attributes and properties can't interfere with events, so it's fine.

	if (facts.a0 !== undefined || prevFacts.a0 !== undefined)
	{
		_VirtualDom_applyEvents(domNode, eventNode, facts.a0 || {});
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, prevStyles, styles)
{
	for (var key in styles)
	{
		var value = styles[key];
		if (value !== prevStyles[key])
		{
			// `.setProperty` must be used for `--custom-properties`.
			// Standard properties never start with a dash.
			// `.setProperty` requires for example 'border-radius' with a dash,
			// while both `.style['border-radius']` and `.style['borderRadius']` work.
			// Elm used to only use `.style`. In order to support existing code like
			// `Html.Attributes.style 'borderRadius' '5px'` we default to `.style`
			// and only use `.setProperty` if the property name starts with a dash.
			if (key.charCodeAt(0) === 45)
			{
				domNode.style.setProperty(key, value);
			}
			else
			{
				domNode.style[key] = value;
			}
		}
	}
}


function _VirtualDom_removeStyles(domNode, prevStyles, styles)
{
	for (var key in prevStyles)
	{
		if (!(key in styles))
		{
			// See `_VirtualDom_applyStyles`.
			if (key.charCodeAt(0) === 45)
			{
				domNode.style.removeProperty(key);
			}
			else
			{
				domNode.style[key] = '';
			}
		}
	}
}



// APPLY PROPS

function _VirtualDom_applyProps(domNode, props)
{
	for (var key in props)
	{
		// See `_VirtualDom_applyFacts` and `_VirtualDom_markerProperty` for why we need to filter these.
		if (key === 'a0' || key === 'a1' || key === 'a3' || key === 'a4' || key === _VirtualDom_markerProperty)
		{
			continue;
		}

		var value = props[key];
		// `value`, `checked`, `selected` and `selectedIndex` can all change via
		// user interactions, so for those it’s important to compare to the
		// actual DOM value. Because of that we compare against the actual DOM
		// node, rather than `prevProps`. Note that many properties are
		// normalized (to certain values, or to a full URL, for example), so if
		// you use properties they might be set on every render if you don't
		// supply the normalized form. `Html.Attributes` avoids this by
		// primarily using attributes.
		if (value !== domNode[key])
		{
			domNode[key] = value;
		}
	}
}


function _VirtualDom_removeProps(domNode, prevProps, props)
{
	for (var key in prevProps)
	{
		// See `_VirtualDom_applyFacts` and `_VirtualDom_markerProperty` for why we need to filter these.
		if (key === 'a0' || key === 'a1' || key === 'a3' || key === 'a4' || key === _VirtualDom_markerProperty)
		{
			continue;
		}

		if (!(key in props))
		{
			var value = prevProps[key];
			switch (typeof value)
			{
				// Most string properties default to the empty string.
				case 'string':
					domNode[key] = '';
					break;
				// Most boolean properties default to false.
				case 'boolean':
					domNode[key] = false;
					break;
				// For other types it's unclear what to do.
			}
			// Standard properties cannot be deleted, but it is not an error trying.
			// Non-standard properties can be deleted.
			delete domNode[key];
		}
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, prevAttrs, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		if (value !== prevAttrs[key])
		{
			domNode.setAttribute(key, value);
		}
	}
}


function _VirtualDom_removeAttrs(domNode, prevAttrs, attrs)
{
	for (var key in prevAttrs)
	{
		if (!(key in attrs))
		{
			domNode.removeAttribute(key);
		}
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, prevNsAttrs, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;
		var previous = prevNsAttrs[key];
		if (!previous)
		{
			domNode.setAttributeNS(namespace, key, value);
		}
		else if (previous.f !== namespace)
		{
			domNode.removeAttributeNS(previous.f, key);
			domNode.setAttributeNS(namespace, key, value);
		}
		else if (previous.o !== value)
		{
			domNode.setAttributeNS(namespace, key, value);
		}
	}
}


function _VirtualDom_removeAttrsNS(domNode, prevNsAttrs, nsAttrs)
{
	for (var key in prevNsAttrs)
	{
		if (!(key in nsAttrs))
		{
			domNode.removeAttributeNS(prevNsAttrs[key].f, key);
		}
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			delete allCallbacks[key];
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.p;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.p = newHandler;
				oldCallback.q = eventNode;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}

	for (key in allCallbacks)
	{
		if (!(key in events))
		{
			domNode.removeEventListener(key, allCallbacks[key]);
			delete allCallbacks[key];
		}
	}
}

function _VirtualDom_lazyUpdateEvents(domNode, eventNode)
{
	var allCallbacks = domNode.elmFs;

	if (allCallbacks)
	{
		for (var key in allCallbacks)
		{
			var oldCallback = allCallbacks[key];
			oldCallback.q = eventNode;
		}
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(initialEventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.p;
		var eventNode = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.message;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.stopPropagation;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.preventDefault) && event.preventDefault(),
			eventNode
		);
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.p = initialHandler;
	callback.q = initialEventNode;

	return callback;
}



// DIFF


function _VirtualDom_diff(_x, y)
{
	// Hack to provide the new virtual dom node to `_VirtualDom_applyPatches` without
	// making breaking changes to elm/browser.
	return y;
}

function _VirtualDom_diffHelp(x, y, eventNode, tNode)
{
	if (x === y)
	{
		return {
			r: _VirtualDom_quickVisit(x, y, eventNode, tNode),
			u: false,
			v: false
		};
	}

	// Remember: When virtualizing already existing DOM, we can’t know
	// where `map` and `lazy` nodes should be, and which ones are `Keyed`.
	// So it’s important to not redraw fully when just the new virtual dom node
	// is a `map` or `lazy` or `Keyed`, to avoid unnecessary DOM changes on startup.

	while (x.$ === 4)
	{
		x = x.k;
	}

	if (y.$ === 4)
	{
		return _VirtualDom_diffHelp(x, y.k, function (msg, isSync) { return eventNode(y.j(msg), isSync) }, tNode);
	}

	if (x.$ === 5)
	{
		if (y.$ === 5)
		{
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				// We still need to visit every node inside the lazy node, to
				// make sure that the event listeners get the current
				// `eventNode`, and to increase and reset counters. This is
				// cheaper than calling `view`, diffing and rendering at least.
				return {
					r: _VirtualDom_quickVisit(x, y, eventNode, tNode),
					u: false,
					v: false
				};
			}
			y.k = y.m();
			return _VirtualDom_diffHelp(x.k, y.k, eventNode, tNode);
		}
		else
		{
			return _VirtualDom_diffHelp(x.k, y, eventNode, tNode);
		}
	}

	if (y.$ === 5)
	{
		return _VirtualDom_diffHelp(x, y.k || (y.k = y.m()), eventNode, tNode);
	}

	var domNode = tNode.r;

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			x = _VirtualDom_upkey(x, y, tNode);
			xType = 2;
		}
		else if (xType === 2 && yType === 1)
		{
			x = _VirtualDom_dekey(x, tNode);
			xType = 1;
		}
		else
		{
			return _VirtualDom_applyPatchRedraw(x, y, eventNode, tNode);
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 0:
			if (x.a !== y.a)
			{
				// Text replaced or changed by translation plugins.
				if (!domNode.parentNode || domNode.data !== x.a)
				{
					return {
						r: domNode,
						u: true,
						v: false
					};
				}
				// Google Translate has a race condition-style bug where if you update the text
				// of a text node while it is fetching a translation for it, you’ll end up with
				// that out-of-date translation. So if we’ve ever detected a translation, it’s
				// no longer safe to update text nodes. Instead, we must replace them with new ones.
				// That’s slower, so we only switch to this method if needed.
				// See: https://issues.chromium.org/issues/393698470
				if (_VirtualDom_everTranslated)
				{
					var newNode = _VirtualDom_doc.createTextNode(y.a);
					tNode.r = newNode;
					domNode.parentNode.replaceChild(newNode, domNode);
					domNode = newNode;
				}
				else
				{
					domNode.data = y.a;
				}
			}
			return {
				r: domNode,
				u: false,
				v: false
			};

		case 1:
			return _VirtualDom_diffNodes(domNode, x, y, eventNode, tNode, _VirtualDom_diffKids);

		case 2:
			return _VirtualDom_diffNodes(domNode, x, y, eventNode, tNode, _VirtualDom_diffKeyedKids);

		case 3:
			if (x.h !== y.h)
			{
				return _VirtualDom_applyPatchRedraw(x, y, eventNode, tNode);
			}

			_VirtualDom_applyFacts(domNode, eventNode, x.d, y.d);

			var patch = y.i(x.g, y.g);
			patch && patch(domNode);

			return {
				r: domNode,
				u: false,
				v: false
			};
	}
}

// When we know that a node does not need updating, just quickly visit its children to:
// - Make sure that properties match the virtual node – they can be mutated by user actions, such as typing into an input.
//   `Html.Attributes` primarily uses attributes (not properties), so this shouldn’t take much time.
// - Update event listeners’ reference to the current `eventNode`.
function _VirtualDom_quickVisit(x, y, eventNode, tNode)
{
	switch (y.$)
	{
		case 4:
			return _VirtualDom_quickVisit(x.k, y.k, function (msg, isSync) { return eventNode(y.j(msg), isSync) }, tNode);

		case 5:
			return _VirtualDom_quickVisit(x.k, y.k, eventNode, tNode);
	}

	var domNode = tNode.r;

	switch (y.$)
	{
		case 0:
			return domNode;

		case 1:
			_VirtualDom_applyProps(domNode, y.d);
			_VirtualDom_lazyUpdateEvents(domNode, eventNode);
			for (var xKids = x.e, yKids = y.e, i = 0; i < yKids.length; i++)
			{
				_VirtualDom_quickVisit(xKids[i], yKids[i], eventNode, tNode.s[i]);
			}
			return domNode;

		case 2:
			_VirtualDom_applyProps(domNode, y.d);
			_VirtualDom_lazyUpdateEvents(domNode, eventNode);
			for (var xKids = x.e, yKids = y.e, i = 0; i < yKids.length; i++)
			{
				var xKid = xKids[i];
				var yKid = yKids[i];
				_VirtualDom_quickVisit(xKid.b, yKid.b, eventNode, tNode.s[yKid.a]);
			}
			return domNode;

		case 3:
			_VirtualDom_applyProps(domNode, y.d);
			_VirtualDom_lazyUpdateEvents(domNode, eventNode);
			return domNode;
	}
}

function _VirtualDom_diffNodes(domNode, x, y, eventNode, tNode, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		return _VirtualDom_applyPatchRedraw(x, y, eventNode, tNode);
	}

	_VirtualDom_applyFacts(domNode, eventNode, x.d, y.d);

	var translated = diffKids(domNode, x, y, eventNode, tNode);

	// If at least one kid was detected to have been translated (by Google Translate for example),
	// we need to go through all kids and actual DOM node children once more. If a text node
	// has been replaced by another with translated text, we don’t know _which_ text node it has
	// been replace by. We have to rerender _all_ text inside the element. This has the side benefit
	// of increasing the likelihood of getting a well-formed sentence after the translator re-translates
	// the text. Since different languages have different word order, it’s the best to translate
	// whole sentences at the minimum. It’s difficult to heuristically find a sentence or paragraph
	// though. “All the text directly inside this element” is the best we’ve got so far.
	if (translated)
	{
		_VirtualDom_everTranslated = true;

		for (var current = null, kids = y.e, i = kids.length - 1, j = domNode.childNodes.length - 1; i >= 0; i--)
		{
			var kid = kids[i];
			var vNode = y.$ === 2 ? kid.b : kid;

			// `child` is going to be one of:
			// - For text nodes: A new text node that isn’t inserted into the DOM.
			// - For other nodes: The already existing DOM node. An extension
			//   might have removed it, though, or moved it to another parent.
			var child = _VirtualDom_renderTranslated(vNode, eventNode, tNode.s[y.$ === 2 ? kid.a : i]);

			if (child.parentNode === domNode)
			{
				// Go through the actual children of `domNode` until we hit `child`,
				// which we just checked for sure is a child of `domNode`. We know
				// that all “our” kids are in the correct order.
				for (; j >= 0; j--)
				{
					current = domNode.childNodes[j];
					if (current === child)
					{
						j--;
						break;
					}
					// Any element we come across until we find `child` must be created by others,
					// or be text nodes created by us but abandoned in `_VirtualDom_renderTranslated`.
					// Remove all text nodes, and all font tags (most likely created by Google Translate).
					if (current.nodeType === 3 || current.localName === 'font')
					{
						domNode.removeChild(current);
					}
				}
			}
			else
			{
				// Most likely, we are inserting a new text node here.
				// It could also be an element (re-)moved by an extension.
				_VirtualDom_insertBefore(domNode, child, current);
				current = child;
			}
		}

		// If there are more elements before our first kid, go through them as well like above.
		for (; j >= 0; j--)
		{
			current = domNode.childNodes[j];
			if (current.nodeType === 3 || current.localName === 'font')
			{
				domNode.removeChild(current);
			}
		}
	}

	return {
		r: domNode,
		u: false,
		v: false
	};
}



// DIFF KIDS


function _VirtualDom_diffKids(parentDomNode, xParent, yParent, eventNode, tNode)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	var translated = false;
	var previousSibling = null;

	// PAIRWISE DIFF COMMON KIDS

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var diffReturn = _VirtualDom_diffHelp(xKids[i], yKids[i], eventNode, tNode.s[i]);
		var domNode = diffReturn.r;

		if (diffReturn.u)
		{
			translated = true;
		}

		if (diffReturn.v)
		{
			_VirtualDom_insertAfter(parentDomNode, domNode, previousSibling);
			previousSibling = domNode;
		}
		// An extension might have removed an element we have rendered before,
		// or moved it to another parent. In such cases, `parentDomNode.insertBefore(x, domNode)`
		// would throw errors. Keep the previous reference element in those cases – that should still
		// result in the correct element order, just with some element missing.
		else if (domNode.parentNode === parentDomNode)
		{
			previousSibling = domNode;
		}
	}

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		for (var i = yLen; i < xLen; i++)
		{
			_VirtualDom_remove(tNode.s[i].r);
			delete tNode.s[i];
		}
	}
	else if (xLen < yLen)
	{
		for (var i = xLen; i < yLen; i++)
		{
			var y = yKids[i];
			var childTNode = _VirtualDom_createTNode(undefined);
			var domNode = _VirtualDom_render(y, eventNode, childTNode);
			tNode.s[i] = childTNode;
			_VirtualDom_appendChild(parentDomNode, domNode);
		}
	}

	return translated;
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(parentDomNode, xParent, yParent, eventNode, tNode)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xKidsMap = xParent.t;
	var yKidsMap = yParent.t;

	var xIndexLower = 0;
	var yIndexLower = 0;
	var xIndexUpper = xKids.length - 1;
	var yIndexUpper = yKids.length - 1;

	var domNodeLower = null;
	var domNodeUpper = null;

	var translated = false;

	var handleDiffReturn = function (diffReturn, upper)
	{
		var domNode = diffReturn.r;

		if (diffReturn.u)
		{
			translated = true;
		}

		if (diffReturn.v)
		{
			if (upper)
			{
				_VirtualDom_insertBefore(parentDomNode, domNode, domNodeUpper);
				domNodeUpper = domNode;
			}
			else
			{
				_VirtualDom_insertAfter(parentDomNode, domNode, domNodeLower);
				domNodeLower = domNode;
			}
		}
		// An extension might have removed an element we have rendered before,
		// or moved it to another parent. In such cases, `parentDomNode.insertBefore(x, domNode)`
		// and `parentDomNode.moveBefore(x, domNode)` would throw errors. Keep the
		// previous reference element in those cases – that should still result in the correct
		// element order, just with some element missing.
		else if (domNode.parentNode === parentDomNode)
		{
			if (upper)
			{
				domNodeUpper = domNode;
			}
			else
			{
				domNodeLower = domNode;
			}
		}
	};

	while (true)
	{
		// Consume from the start until we get stuck.
		while (xIndexLower <= xIndexUpper && yIndexLower <= yIndexUpper)
		{
			var xKid = xKids[xIndexLower];
			var yKid = yKids[yIndexLower];
			var xKey = xKid.a;
			var yKey = yKid.a;
			var x = xKid.b;
			var y = yKid.b;

			if (xKey === yKey)
			{
				var diffReturn = _VirtualDom_diffHelp(x, y, eventNode, tNode.s[yKey]);
				xIndexLower++;
				yIndexLower++;
				handleDiffReturn(diffReturn, false);
				continue;
			}

			var xMoved = false;

			if (xKey in yKidsMap)
			{
				xMoved = true;
			}
			else
			{
				_VirtualDom_remove(tNode.s[xKey].r);
				delete tNode.s[xKey];
				xIndexLower++;
			}

			if (yKey in xKidsMap)
			{
				if (xMoved)
				{
					break;
				}
			}
			else
			{
				var childTNode = _VirtualDom_createTNode(undefined);
				var domNode = _VirtualDom_render(y, eventNode, childTNode);
				tNode.s[yKey] = childTNode;
				_VirtualDom_insertAfter(parentDomNode, domNode, domNodeLower);
				yIndexLower++;
				domNodeLower = domNode;
			}
		}

		// Consume from the end until we get stuck.
		while (xIndexUpper > xIndexLower && yIndexUpper > yIndexLower)
		{
			var xKid = xKids[xIndexUpper];
			var yKid = yKids[yIndexUpper];
			var xKey = xKid.a;
			var yKey = yKid.a;
			var x = xKid.b;
			var y = yKid.b;

			if (xKey === yKey)
			{
				var diffReturn = _VirtualDom_diffHelp(x, y, eventNode, tNode.s[yKey]);
				xIndexUpper--;
				yIndexUpper--;
				handleDiffReturn(diffReturn, true);
				continue;
			}

			var xMoved = false;

			if (xKey in yKidsMap)
			{
				xMoved = true;
			}
			else
			{
				_VirtualDom_remove(tNode.s[xKey].r);
				delete tNode.s[xKey];
				xIndexUpper--;
			}

			if (yKey in xKidsMap)
			{
				if (xMoved)
				{
					break;
				}
			}
			else
			{
				var childTNode = _VirtualDom_createTNode(undefined);
				var domNode = _VirtualDom_render(y, eventNode, childTNode);
				tNode.s[yKey] = childTNode;
				_VirtualDom_insertBefore(parentDomNode, domNode, domNodeUpper);
				yIndexUpper--;
				domNodeUpper = domNode;
			}
		}

		var swapped = false;

		// Check if the start or end can be unstuck by a swap.
		if (xIndexLower < xIndexUpper && yIndexLower < yIndexUpper)
		{
			var xKidLower = xKids[xIndexLower];
			var yKidLower = yKids[yIndexLower];
			var xKidUpper = xKids[xIndexUpper];
			var yKidUpper = yKids[yIndexUpper];

			var xKeyLower = xKidLower.a;
			var yKeyLower = yKidLower.a;
			var xKeyUpper = xKidUpper.a;
			var yKeyUpper = yKidUpper.a;

			if (xKeyLower === yKeyUpper)
			{
				var diffReturn = _VirtualDom_diffHelp(xKidLower.b, yKidUpper.b, eventNode, tNode.s[yKeyUpper]);
				xIndexLower++;
				yIndexUpper--;
				_VirtualDom_moveBefore(parentDomNode, diffReturn.r, domNodeUpper);
				handleDiffReturn(diffReturn, true);
				swapped = true;
			}

			if (xKeyUpper === yKeyLower)
			{
				var diffReturn = _VirtualDom_diffHelp(xKidUpper.b, yKidLower.b, eventNode, tNode.s[yKeyLower]);
				yIndexLower++;
				xIndexUpper--;
				_VirtualDom_moveAfter(parentDomNode, diffReturn.r, domNodeLower);
				handleDiffReturn(diffReturn, false);
				swapped = true;
			}
		}

		// If no swap, stop consuming from start and end.
		if (!swapped)
		{
			break;
		}
	}

	// For the remaining items in the new virtual DOM, diff with the corresponding
	// old virtual DOM node (if any) and move it into the correct place.
	// This might result in more moves than technically needed, but:
	// - Moving nodes isn’t that slow. Diffing algorithms aren’t free either.
	// - In browsers supporting `.moveBefore()` unnecessary moves have no unwanted side effects.
	// - Elm has never had a “perfect” implementation for Keyed, and this should not
	//   be worse than the previous implementation.
	for (; yIndexLower <= yIndexUpper; yIndexLower++)
	{
		var yKid = yKids[yIndexLower];
		var yKey = yKid.a;
		var y = yKid.b;
		if (yKey in xKidsMap)
		{
			var x = xKidsMap[yKey];
			var diffReturn = _VirtualDom_diffHelp(x, y, eventNode, tNode.s[yKey]);
			_VirtualDom_moveAfter(parentDomNode, diffReturn.r, domNodeLower);
			handleDiffReturn(diffReturn, false);
		}
		else
		{
			var childTNode = _VirtualDom_createTNode(undefined);
			var domNode = _VirtualDom_render(y, eventNode, childTNode);
			tNode.s[yKey] = childTNode;
			_VirtualDom_insertAfter(parentDomNode, domNode, domNodeLower);
			domNodeLower = domNode;
		}
	}

	// Remove the remaining old virtual DOM nodes that aren’t present in the new virtual DOM.
	for (; xIndexLower <= xIndexUpper; xIndexLower++)
	{
		var xKid = xKids[xIndexLower];
		var xKey = xKid.a;
		if (!(xKey in yKidsMap)) {
			_VirtualDom_remove(tNode.s[xKid.a].r);
			delete tNode.s[xKid.a];
		}
	}

	return translated;
}

var _VirtualDom_POSTFIX = '_elmW6BL';

function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, newVirtualNode, eventNode)
{
	// To avoid making breaking changes to elm/browser, we store the tNode on
	// the root DOM node instead of returning it.
	var tNode = rootDomNode.elmTree;

	var diffReturn = _VirtualDom_diffHelp(oldVirtualNode, newVirtualNode, eventNode, tNode);
	// We can’t do anything about `diffReturn.u` or
	// `diffReturn.v` here, because we don’t know the parent of the
	// root node. Note that `rootDomNode.parentNode` cannot be used, because if
	// the root node is a text node and it has been translated, it is most
	// likely replaced by other nodes (so the original node is not attached to
	// the DOM anymore). Returning `Html.text` at the top level of `view` and
	// expecting it to be translatable is a bit of an edge case anyway.
	var newDomNode = diffReturn.r;

	if (newDomNode !== rootDomNode)
	{
		delete rootDomNode.elmTree;
		newDomNode.elmTree = tNode;
	}

	return newDomNode;
}

function _VirtualDom_applyPatchRedraw(x, y, eventNode, tNode)
{
	var domNode = tNode.r;
	var parentNode = domNode.parentNode;
	var isTextNode = domNode.nodeType === 3;
	var newNode = _VirtualDom_render(y, eventNode, tNode);

	// An extension might have removed the element. In this case, we are redrawing because `x` and `y`
	// have changed a lot, implying that the structure has changed significantly, and that they can’t
	// be diffed normally. This means that the extension probably meant to remove the old element, but
	// not the new one, so return that this element is missing so that it can be re-inserted into the
	// parent. An example of this is Google Translate: It removes our text nodes and replaces them.
	// Later we might want to replace that text node with some element.
	if (parentNode)
	{
		parentNode.replaceChild(newNode, domNode);
		return {
			r: newNode,
			u: isTextNode && domNode.data !== x.a,
			v: false
		}
	}
	else
	{
		return {
			r: newNode,
			u: isTextNode,
			v: true
		}
	}
}

/*
This is a mapping between attribute names and their corresponding boolean properties,
and only the ones where the attribute name is different from the property name
(usually in casing – attributes are case insensitive, and returned lowercase).

The mapping currently only lists the ones that have dedicated functions in elm/html.

There are more though! Running the following code in the console gives more results:

[...new Set(Object.getOwnPropertyNames(window).filter(d => d.startsWith('HTML') || d === 'Node' || d === 'Element' || d === 'EventTarget').flatMap(d => {c = window[d]; m = c.name.match(/^HTML(\w+)Element$/); e = document.createElement(m ? m[1].replace('Anchor', 'a').replace('Paragraph', 'p').replace('Image', 'img').replace('Media', 'video').replace(/^([DOU])List$/, '$1l').toLowerCase() : 'div'); return Object.getOwnPropertyNames(c.prototype).filter(n => typeof e[n] === 'boolean')}))].filter(n => /[A-Z]/.test(n)).sort()

Potential candidates to support (should probably add to elm/html first):
disablePictureInPicture – video
playsInline – video
formNoValidate – button, input

Not useful with Elm:
noModule – script
shadowRootClonable – template
shadowRootDelegatesFocus – template
shadowRootSerializable – template

Legacy/deprecated:
allowFullscreen – iframe (use allow="fullscreen" instead)
allowPaymentRequest – iframe (use allow="payment" instead)
noHref - area (image maps)
noResize – frame (not iframe)
noShade – hr
trueSpeed – marquee

Special:
defaultChecked
defaultMuted
defaultSelected

No corresponding attribute:
disableRemotePlayback
isConnected
isContentEditable
preservesPitch
sharedStorageWritable
willValidate

Unclear:
adAuctionHeaders
browsingTopics

Regarding the special ones: `<input checked>` results in `.defaultChecked ===
true`. Similarly, setting `input.defaultChecked = true` results in
`input.outerHTML === '<input checked="">'`. `input.checked = true` does _not_
result in an attribute though: `.checked` has no corresponding attribute.
However, when serializing `Html.input [ Html.Attributes.checked True ] []` to
HTML, `<input checked>` is the most reasonable choice. So when virtualizing, we
actually want to turn the `checked` attribute back into a boolean "checked"
property in Elm (even if according to the DOM, it's `.defaultChecked`). Same
thing for `muted` and `selected`.
*/
var _VirtualDom_camelCaseBoolProperties = {
	novalidate: 'noValidate',
	readonly: 'readOnly',
	ismap: 'isMap'
};

// Used for server side rendering to keep track of which elements to
// virtualize. This is added to _all_ nodes (except text nodes) in
// `_VirtualDom_organizeFacts`. Server side rendering renders _all_ string and
// boolean facts as attributes, including this one. `_VirtualDom_applyProps`
// and `_VirtualDom_removeProps` _ignore_ this property, in order not to
// clutter the browser dev tools. `_VirtualDom_virtualize` only virtualizes
// children with this attribute. This way it knows which elements are “ours”
// and which were inserted by third-party scripts (before the virtualization
// took place). The root node is allowed not to have this attribute though, in
// order not to force everyone to put this attribute on the node they mount the
// Elm app on. During the first render after virtualization, we remove this
// attribute from all elements, to unclutter the browser console. That happens
// via `_VirtualDom_virtualize` virtualizing it as an _attribute_ (not a
// property) which, when compared to the result of `view`, is diffed for
// removal.
var _VirtualDom_markerProperty = 'data-elm';

function _VirtualDom_virtualize(node)
{
	// The debugger has always done `_VirtualDom_virtualize(document)` instead of
	// `_VirtualDom_virtualize(document.body)` by mistake. To be backwards compatible
	// with elm/browser, support that here.
	if (node === _VirtualDom_doc)
	{
		node = _VirtualDom_doc.body;
	}

	if (node.elmTree)
	{
		// The `console.error` lets the user more easily identify which node they passed.
		console.error('node.elmTree already exists:', node.elmTree, node);
		throw new Error('node.elmTree already exists!');
	}

	var tNode = _VirtualDom_createTNode(node);

	// Fall back to a text node as backwards compatibility. Elm has always
	// supported mounting onto any node, even comment nodes. Text nodes,
	// comment nodes, CDATA sections and processing instructions all implement
	// the `CharacterData` abstract interface, so representing them as a text
	// node should be fine. The whole document, doctypes and document fragments
	// are also nodes, but they are increasingly silly to render into and have
	// never worked with Elm.
	var vNode = _VirtualDom_virtualizeHelp(node, tNode) || _VirtualDom_text('');

	node.elmTree = tNode;

	return vNode;
}

function _VirtualDom_virtualizeHelp(node, tNode)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return undefined;
	}


	// ELEMENT NODES

	var tag = node.localName;
	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;

		// The `style` attribute and `node.style` are linked. While `node.style` contains
		// every single CSS property, it’s possible to loop over only the styles that have
		// been set via `node.style.length`. Unfortunately, `node.style` expands shorthand
		// properties and normalizes values. For example, `padding: 0` is turned into
		// `padding-top: 0px; padding-bottom: 0px; ...`.
		// The best bet is actually parsing the styles ourselves. Naively splitting on `;`
		// is not 100 % correct, for example it won’t work for `content: ";"`. It will work
		// in 99 % of cases though, since putting a semicolon in a value isn’t that common.
		// And even in those cases, nothing will break. We’ll just apply a few styles
		// unnecessarily at init.
		if (name === "style")
		{
			var parts = value.split(";");
			for (var j = parts.length; j--; )
			{
				var part = parts[j];
				var index = part.indexOf(":");
				if (index !== -1)
				{
					var cssKey = part.slice(0, index).trim();
					var cssValue = part.slice(index + 1).trim();
					attrList = _List_Cons(A2(_VirtualDom_style, cssKey, cssValue), attrList);
				}
			}
			continue;
		}

		var namespaceURI = attr.namespaceURI;
		var propertyName = _VirtualDom_camelCaseBoolProperties[name] || name;
		var propertyValue = node[propertyName];
		// Turning attributes into virtual DOM representations is not an exact science.
		// If someone runs an Elm `view` function and then serializes it to HTML, we need to guess:
		//
		// - how they chose to serialize it
		// - what the most likely virtual DOM representation is
		//
		// In elm/html, the convention is to use attributes rather than properties where possible,
		// which is good for virtualization – we can just turn most HTML attributes we find as-is
		// into virtual DOM attributes. But when we encounter `foo="bar"` we can’t know if it was
		// created using `Html.Attributes.attribute "foo" "bar"` or
		// `Html.Attributes.property "foo" (Json.Encode.string "bar")`.
		//
		// It's not the end of the world if we guess wrong, though, it just leads to a bit of
		// unnecessary DOM mutations on the first render.
		//
		// Do we need to use any of the functions in the “XSS ATTACK VECTOR CHECKS”
		// section while virtualizing? I don’t think so, because they will already
		// have executed at this point, and the first render will remove any disallowed
		// attributes.
		attrList = _List_Cons(
			// `Html.Attributes.value` sets the `.value` property to a string, because that’s the
			// only way to set the value of an input element. The `.value` property has no corresponding
			// attribute; the `value` attribute maps to the `.defaultValue` property. But when serializing,
			// the most likely way to do it is to serialize the `.value` property to the `value` attribute.
			name === 'value'
				? A2(_VirtualDom_property, name, value)
				:
			// Try to guess if the attribute comes from one of the functions
			// implemented using `boolProperty` in `Html.Attributes`.
			// See `Html.Attributes.spellcheck` for that exception.
			typeof propertyValue === 'boolean' && name !== 'spellcheck'
				? A2(_VirtualDom_property, propertyName, propertyValue)
				:
			// Otherwise, guess that it is an attribute. The user might have used `Html.Attributes.property`,
			// but there’s no way for us to know that.
			namespaceURI
				? A3(_VirtualDom_attributeNS, namespaceURI, name, value)
				: A2(_VirtualDom_attribute, name, value),
			attrList
		);
	}

	var namespace =
		node.namespaceURI === 'http://www.w3.org/1999/xhtml'
			? undefined
			: node.namespaceURI;
	var kidList = [];

	// To create a text area with default text in HTML:
	// - correct: <textarea>default text</textarea>
	// - wrong: <textarea value="default text"></textarea> (value="default text" does nothing.)
	// In the DOM, that becomes an `HTMLTextAreaElement`, with `.value === "default text"`.
	// It contains a single text node with the text `"default text"` too.
	// When the user types into the text area, `.value` changes, but the inner text node stays unchanged.
	// In Elm, you need to use `Html.textarea [ Html.Attributes.value myValue ] []` to be able to set the value.
	// All in all, this means that the most useful virtualization is:
	// - Skip any children (most likely a single text node), because the Elm code most likely set none.
	// - Pick up `.value`, even though it wasn’t set as an attribute in HTML – but most likely is a property set by the Elm code.
	// Note that in <textarea>, HTML isn’t parsed as usual – it is more of a plain text element.
	if (node.localName === 'textarea')
	{
		attrList = _List_Cons(
			A2(_VirtualDom_property, 'value', node.value),
			attrList
		);
	}
	else
	{
		for (var kids = node.childNodes, len = kids.length, i = 0; i < len; i++)
		{
			var kid = kids[i];

			// Only virtualize “our” elements – see `_VirtualDom_markerProperty`.
			if (kid.nodeType === 1 && !kid.hasAttribute(_VirtualDom_markerProperty))
			{
				continue;
			}

			var childTNode = _VirtualDom_createTNode(kid);
			var kidNode = _VirtualDom_virtualizeHelp(kid, childTNode);
			// `kidNode` is `undefined` for comment nodes – skip those. This allows
			// server side rendering to insert comments between two text nodes to
			// preserve them being parsed as two nodes, not as just one with the
			// text from both.
			if (kidNode)
			{
				var length = kidList.push(kidNode);
				tNode.s[length - 1] = childTNode;
			}
		}

		if (_VirtualDom_divertHrefToApp && node.localName === 'a')
		{
			var listener = _VirtualDom_divertHrefToApp(node);
			node.elmAf = listener;
			node.addEventListener('click', listener);
		}
	}

	// This returns the same structure as `_VirtualDom_nodeNS`, but avoids
	// calling that function, because then we can avoid constructing an
	// Elm list, reversing it, and then having `_VirtualDom_nodeNS` convert
	// that to a JS array.
	return {
		$: 1,
		c: tag,
		d: _VirtualDom_organizeFacts(attrList),
		e: kidList,
		f: namespace,
		b: 0
	};
}

function _VirtualDom_upkey(node, keyedNode, tNode) {
	var kids = node.e;
	var keyedKids = keyedNode.e;
	var len = kids.length;
	var keyedLen = keyedKids.length;
	var newKeyedKids = new Array(len);
	var newKidsMap = Object.create(null);
	var newChildren = Object.create(null);
	for (var i = 0; i < len; i++)
	{
		var kid = kids[i];
		var key;
		if (i < keyedLen)
		{
			key = keyedKids[i].a;
		}
		else
		{
			key = i + _VirtualDom_POSTFIX;
			// Handle duplicate keys by adding a postfix.
			while (key in newKidsMap)
			{
				key += _VirtualDom_POSTFIX;
			}
		}
		newKeyedKids[i] = _Utils_Tuple2(key, kid);
		newKidsMap[key] = kid;
		newChildren[key] = tNode.s[i];
	}
	tNode.s = newChildren;

	return {
		$: 2,
		c: node.c,
		d: node.d,
		e: newKeyedKids,
		t: newKidsMap,
		f: node.f,
		b: node.b
	};
}

function _VirtualDom_dekey(keyedNode, tNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	var newChildren = Object.create(null);
	for (var i = 0; i < len; i++)
	{
		var keyedKid = keyedKids[i];
		kids[i] = keyedKid.b;
		newChildren[i] = tNode.s[keyedKid.a];
	}
	tNode.s = newChildren;

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}

function _VirtualDom_removeAllEventListeners(rootDomNode)
{
	var tNode = rootDomNode.elmTree;

	// Allow mounting another Elm app on this DOM node.
	delete rootDomNode.elmTree;

	_VirtualDom_removeAllEventListenersHelp(tNode);
}

function _VirtualDom_removeAllEventListenersHelp(tNode)
{
	var domNode = tNode.r;
	var children = tNode.s;

	// Allow the DOM nodes to be virtualized by another Elm app.
	if (domNode.nodeType === 1)
	{
		domNode.setAttribute(_VirtualDom_markerProperty, '');
	}

	if (domNode.elmAf)
	{
		domNode.removeEventListener('click', domNode.elmAf);
		delete domNode.elmAf;
	}

	var allCallbacks = domNode.elmFs;
	if (allCallbacks)
	{
		for (var key in allCallbacks)
		{
			domNode.removeEventListener(key, allCallbacks[key]);
		}
		delete domNode.elmFs;
	}

	for (var key in children)
	{
		_VirtualDom_removeAllEventListenersHelp(children[key]);
	}
}

// Used by `_Debugger_document` to remove the corner when shutting down.
function _VirtualDom_removeLastElmChild(rootDomNode)
{
	var tNode = rootDomNode.elmTree;
	var children = tNode.s;
	var childNodes = rootDomNode.childNodes;
	for (var i = childNodes.length - 1; i >= 0; i--)
	{
		var childDomNode = childNodes[i];
		for (var key in children)
		{
			if (childDomNode === children[key].r)
			{
				rootDomNode.removeChild(childDomNode);
				delete children[key];
				return;
			}
		}
	}
}


var wireRefs = (function () {
  var refs = new Map();
  var counter = 0; // uInt32 max
  var f = {}
  f.add = function(obj) {
    counter++;
    refs.set(counter, obj);
    return counter;
  }
  f.getFinal = function(k) {
    let v = refs.get(k);
    refs.delete(k);
    return v;
  }
  f.clear = function() {
    refs = new Map();
  };
  f.all = function() {
    return [refs.keys(), refs];
  }
  return f;
})();

var _LamderaCodecs_encodeWithRef = function(a) {
  return wireRefs.add(a);
}

var _LamderaCodecs_decodeWithRef = function(ref) {
  return wireRefs.getFinal(ref);
}

var _LamderaCodecs_encodeBytes = function(s) { return _Lamdera_Json_wrap(s); }

function _Lamdera_Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Lamdera_Json_wrap(value) { return value; }

function _LamderaCodecs_Json_decodePrim(decoder) {
  return { $: 0, a: decoder };
}

var _LamderaCodecs_decodeBytes = _Json_decodePrim(function(value) {
  return (typeof value === 'object' && value instanceof DataView)
    ? $elm$core$Result$Ok(value)
    : _Json_expecting('a DataView', value) ;
    // : console.log('error: expecting DataView, got', value) ;
});

var _LamderaCodecs_debug = function(s) {
  console.log(s);
  return _Utils_Tuple0;
}

// Duplicate of _Bytes_decode that expects all bytes to be consumed,
// otherwise it fails to decode.
var _LamderaCodecs_bytesDecodeStrict = F2(function(decoder, bytes)
{
  try {
    var res = A2(decoder, bytes, 0);
    const w = bytes.byteLength;
    if (w !== res.a) {
      // For now just log issues, in future we'll actually fail on this case
      console.log(`❌ bytesDecodeStrict did not consume all bytes: length:${w}, consumed:${res.a}`, res.b, new Uint8Array(bytes.buffer));
    }
    return $elm$core$Maybe$Just(res.b);
  } catch(e) {
    console.log('❌ bytesDecodeStrict unexpected error:', e);
    return $elm$core$Maybe$Nothing;
  }
});




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}





// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F3(function(impl, flagDecoder, debugMetadata)
{
	var init = function(args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			// These three arguments are used by old versions of _Platform_initialize.
			// Newer versions ignore them.
			impl.init,
			impl.update,
			impl.subscriptions,
			function(sendToApp, initialModel, platformInitializeWillDoInitialDraw) {
				/**/
				var domNode = args['node'];
				//*/
				/**_UNUSED/
				var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
				//*/
				var currNode = _VirtualDom_virtualize(domNode);

				var stepper = _Browser_makeAnimator(function(model)
				{
					var nextNode = impl.view(model);
					var patches = _VirtualDom_diff(currNode, nextNode);
					domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
					currNode = nextNode;
				});

				stepper.shutdown = function()
				{
					// Older versions of elm/virtual-dom does not provide this function.
					if (typeof _VirtualDom_removeAllEventListeners === 'function')
					{
						_VirtualDom_removeAllEventListeners(domNode);
					}

					return domNode;
				};

				// The initial draw used to be a side effect of `stepperBuilder`.
				// Newer versions of `_Platform_initialize` do that instead.
				// Older versions don’t send the `platformInitializeWillDoInitialDraw`
				// parameter, which means that we need to do it here for compatibility.
				if (!platformInitializeWillDoInitialDraw)
				{
					stepper(initialModel, true);
				}

				return stepper;
			},
			// Only used by newer versions of _Platform_initialize.
			impl
		);
	};

	/**_UNUSED/
	init.hotReloadData = {
		impl: impl,
		platform_effectManagers: _Platform_effectManagers,
		scheduler_enqueue: _Scheduler_enqueue
	};
	//*/

	return init;
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F3(function(impl, flagDecoder, debugMetadata)
{
	var init = function(args)
	{
		return _Platform_initialize(
			flagDecoder,
			args,
			// These three arguments are used by old versions of _Platform_initialize.
			// Newer versions ignore them.
			impl.init,
			impl.update,
			impl.subscriptions,
			function(sendToApp, initialModel, platformInitializeWillDoInitialDraw) {
				var divertHrefToApp = impl.setup && impl.setup(sendToApp)
				var title = _VirtualDom_doc.title;
				var bodyNode = _VirtualDom_doc.body;
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var currNode = _VirtualDom_virtualize(bodyNode);
				_VirtualDom_divertHrefToApp = 0;

				var stepper = _Browser_makeAnimator(function(model)
				{
					_VirtualDom_divertHrefToApp = divertHrefToApp;
					var doc = impl.view(model);
					var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.body);
					var patches = _VirtualDom_diff(currNode, nextNode);
					bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
					currNode = nextNode;
					_VirtualDom_divertHrefToApp = 0;
					(title !== doc.title) && (_VirtualDom_doc.title = title = doc.title);
				});

				stepper.shutdown = function()
				{
					// Older versions of elm/virtual-dom does not provide this function.
					if (typeof _VirtualDom_removeAllEventListeners === 'function')
					{
						_VirtualDom_removeAllEventListeners(bodyNode);
					}

					if (impl.shutdown)
					{
						impl.shutdown();
					}

					return bodyNode;
				};

				// The initial draw used to be a side effect of `stepperBuilder`.
				// Newer versions of `_Platform_initialize` do that instead.
				// Older versions don’t send the `platformInitializeWillDoInitialDraw`
				// parameter, which means that we need to do it here for compatibility.
				if (!platformInitializeWillDoInitialDraw)
				{
					stepper(initialModel, true);
				}

				return stepper;
			},
			// Only used by newer versions of _Platform_initialize.
			impl
		);
	}

	/**_UNUSED/
	init.hotReloadData = {
		impl: impl,
		platform_effectManagers: _Platform_effectManagers,
		scheduler_enqueue: _Scheduler_enqueue
	};
	//*/

	return init;
});



// ANIMATION


var _Browser_requestAnimationFrame_queue = {};
var _Browser_inAnimationFrame = false;
var _Browser_pendingAnimationFrame = false;
var _Browser_requestAnimationFrame_id = 0;

function _Browser_cancelAnimationFrame(id)
{
	delete _Browser_requestAnimationFrame_queue[id];
}

function _Browser_requestAnimationFrame(callback)
{
	var id = _Browser_requestAnimationFrame_id;
	_Browser_requestAnimationFrame_id++;
	_Browser_requestAnimationFrame_queue[id] = callback;
	if (!_Browser_pendingAnimationFrame)
	{
		_Browser_pendingAnimationFrame = true;
		_Browser_requestAnimationFrame_raw(function() {
			_Browser_pendingAnimationFrame = false;
			_Browser_inAnimationFrame = true;
			var maxId = _Browser_requestAnimationFrame_id;
			for (var id2 in _Browser_requestAnimationFrame_queue)
			{
				if (id2 >= maxId)
				{
					break;
				}
				var callback = _Browser_requestAnimationFrame_queue[id2];
				delete _Browser_requestAnimationFrame_queue[id2];
				callback();
			}
			_Browser_inAnimationFrame = false;
		});
	}
	return id;
}

var _Browser_requestAnimationFrame_raw =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };

function _Browser_makeAnimator(draw)
{
	var model;

	// Whether `draw` is currently running. `draw` can cause side effects:
	// If the user renders a custom element, they can dispatch an event in
	// its `connectedCallback`, which happens synchronously. That causes
	// `update` to run while we’re in the middle of drawing, which then
	// causes another call to the returned function below. We can’t start
	// another draw while before the first one is finished.
	var drawing = false;

	// Whether we have already requested an animation frame for drawing.
	var pendingFrame = false;

	// Whether we have already requested to draw right after the current draw has finished.
	var pendingSync = false;

	function drawHelp()
	{
		// If we’re already drawing, wait until that draw is done.
		if (drawing)
		{
			pendingSync = true;
			return;
		}

		pendingFrame = false;
		pendingSync = false;
		drawing = true;
		draw(model);
		drawing = false;

		if (pendingSync)
		{
			drawHelp();
		}
	}

	function updateIfNeeded()
	{
		if (pendingFrame)
		{
			drawHelp();
		}
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		// When using `Browser.Events.onAnimationFrame` we already are
		// in an animation frame, so draw straight away. Otherwise we’ll
		// be drawing one frame late all the time.
		if (isSync || _Browser_inAnimationFrame)
		{
			drawHelp();
		}
		else if (!pendingFrame)
		{
			pendingFrame = true;
			_Browser_requestAnimationFrame(updateIfNeeded);
		}
	};
}



// APPLICATION


function _Browser_application(impl)
{
	// In plain Elm, `Browser.Navigation.Key` is the `key` function below.
	// Functions that take it, such as `Browser.Navigation.pushUrl`, call
	// that function to send an URL changed message to the app.
	// In Lamdera, `Browser.Navigation.Key` is a “useless” opaque value
	// that you just use as a “password” to `Browser.Navigation.pushUrl`
	// and friends. The actual function is stored in a semi-global variable
	// instead – `_Browser_key`. This means that a second application would
	// overwrite the first, but it doesn’t matter since both apps would
	// fight over `document.body` anyway. Instead, having `_Browser_key`
	// allows Wire-ing the model from an old app to a new without having to
	// do any complicated Wire stuff just for `Browser.Navigation.Key`, and
	// trying to update that `key` function to refer to stuff in the new app.
	var modelKey = { $: 0 };
	var key = function() { key.a(impl.onUrlChange(_Browser_getUrl())); };
	_Browser_key = key;

	return _Browser_document({
		setup: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download') && domNode.hasAttribute('href'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(impl.onUrlRequest(
						(next
							&& curr.protocol === next.protocol
							&& curr.host === next.host
							&& curr.port_.a === next.port_.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		shutdown: function()
		{
			_Browser_window.removeEventListener('popstate', key);
			_Browser_window.removeEventListener('hashchange', key);
			// Allow the app to be garbage collected.
			key.a = function() {};
			_Browser_key = null;
		},
		init: function(flags)
		{
			return A3(impl.init, flags, _Browser_getUrl(), modelKey);
		},
		// Unnecessary-looking wrapper functions are needed during development
		// for hot reloading. In production, we optimize slightly by omitting them.
		/**/
		view: impl.view,
		update: impl.update,
		subscriptions: impl.subscriptions
		//*/
		/**_UNUSED/
		view: function(model) { return impl.view(model); },
		update: F2(function(msg, model) { return A2(impl.update, msg, model); }),
		subscriptions: function(model) { return impl.subscriptions(model); }
		//*/
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_key = null;

var _Browser_go = F2(function(_key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		_Browser_key();
	}));
});

var _Browser_pushUrl = F2(function(_key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		_Browser_key();
	}));
});

var _Browser_replaceUrl = F2(function(_key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		_Browser_key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { hidden: 'hidden', change: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { hidden: 'mozHidden', change: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { hidden: 'msHidden', change: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { hidden: 'webkitHidden', change: 'webkitvisibilitychange' }
		: { hidden: 'hidden', change: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		scene: _Browser_getScene(),
		viewport: {
			x: _Browser_window.pageXOffset,
			y: _Browser_window.pageYOffset,
			width: _Browser_doc.documentElement.clientWidth,
			height: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		width: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		height: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			scene: {
				width: node.scrollWidth,
				height: node.scrollHeight
			},
			viewport: {
				x: node.scrollLeft,
				y: node.scrollTop,
				width: node.clientWidth,
				height: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			scene: _Browser_getScene(),
			viewport: {
				x: x,
				y: y,
				width: _Browser_doc.documentElement.clientWidth,
				height: _Browser_doc.documentElement.clientHeight
			},
			element: {
				x: x + rect.left,
				y: y + rect.top,
				width: rect.width,
				height: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.expect.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.expect.b, xhr)); });
		$elm$core$Maybe$isJust(request.tracker) && _Http_track(router, xhr, request.tracker.a);

		try {
			xhr.open(request.method, request.url, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.url));
		}

		_Http_configureRequest(xhr, request);

		request.body.a && xhr.setRequestHeader('Content-Type', request.body.a);
		xhr.send(request.body.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.headers; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.timeout.a || 0;
	xhr.responseType = request.expect.d;
	xhr.withCredentials = request.allowCookiesFromOtherDomains;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		url: xhr.responseURL,
		statusCode: xhr.status,
		statusText: xhr.statusText,
		headers: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			sent: event.loaded,
			size: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			received: event.loaded,
			size: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}

var _LamderaWebsocket_websockets = {};

var _LamderaWebsocket_uuid4 = function() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

var _LamderaWebsocket_createHandle = F2(function(router, url)
{
	return _Scheduler_binding(function(callback)
	{
	    try {

	    var id = _LamderaWebsocket_uuid4();

	    _LamderaWebsocket_websockets[id] =
            { websocket : null
            , hasListener : false
            , isClosed : false
            }

        console.log("Websocket: created handle");

        callback(_Scheduler_succeed(
            A2($lamdera$program_test$Websocket$connection, id, url)
        ));

        }
        catch (error) {
            console.log("Websocket: Exception in _LamderaWebsocket_createHandle. " + error);
        }
	});
});



var _LamderaWebsocket_sendString = F3(function(router, connection, data)
{
	return _Scheduler_binding(function(callback)
	{
	    try {

            var websocketData = _LamderaWebsocket_websockets[connection.a];
            if (websocketData || websocketData.isClosed) {
                if (websocketData.websocket) {
                    websocketData.websocket.send(data);
                    callback(_Scheduler_succeed(0));
                }
                else {
                    websocketData.websocket = new WebSocket(connection.b);

                    websocketData.websocket.addEventListener('close', function (event) {
                        try {
                            websocketData.websocket.isClosed = true;
                            console.log("Websocket: close happened in _LamderaWebsocket_sendString");
                            console.log(event);
                        }
                        catch (error) {
                            console.log("Websocket: Exception in _LamderaWebsocket_sendString close listener. " + error);
                        }
                    });

                    websocketData.websocket.addEventListener('error', function (event) {
                        try {
                            websocketData.websocket.isClosed = true;
                            console.log("Websocket: error happened in _LamderaWebsocket_sendString");
                            console.log(event);
                        }
                        catch (error) {
                            console.log("Websocket: Exception in _LamderaWebsocket_sendString error listener. " + error);
                        }
                    });

                    websocketData.websocket.addEventListener('open', function (event) {
                        try {
                            console.log("open");
                            console.log(event);
                            websocketData.websocket.send(data);
                        }
                        catch (error) {
                            console.log("Websocket: Exception in _LamderaWebsocket_sendString open listener. " + error);
                        }
                    });

                    websocketData.websocket.send(data);
                    callback(_Scheduler_succeed(0));
                }
            }
            else {
                callback(_Scheduler_fail($lamdera$program_test$Websocket$connectionClosed));
            }


        }
        catch (error) {
            console.log("Websocket: Exception in _LamderaWebsocket_sendString. " + error);
        }
	});
});

var _LamderaWebsocket_listen = F2(function(router, connection)
{
	return _Scheduler_binding(function(callback)
	{
	    try {
        var websocketData = _LamderaWebsocket_websockets[connection.a];

        function addListener() {
            websocketData.hasListener = true;

            websocketData.websocket.addEventListener('close', function (event) {
                try {
                    if (websocketData.isClosed === false) {

                        websocketData.websocket.isClosed = true;
                        console.log("Websocket: close happened in _LamderaWebsocket_listen");
                        console.log(event);
                        _Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(
                            connection,
                            A2($lamdera$program_test$Websocket$closedEvent, event.code, event.reason)
                        )));
                    }

                }
                catch (error) {
                    console.log("Websocket: Exception in _LamderaWebsocket_listen close listener. " + error);
                }
            });

            websocketData.websocket.addEventListener('error', function (event) {
                try {
                    if (websocketData.isClosed === false) {
                        websocketData.websocket.isClosed = true;
                        console.log("Websocket: error happened in _LamderaWebsocket_listen");
                        console.log(event);
                        _Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(
                            connection,
                            A2($lamdera$program_test$Websocket$closedEvent, 1006, event.message || "")
                        )));
                    }
                }
                catch (error) {
                    console.log("Websocket: Exception in _LamderaWebsocket_listen error listener. " + error);
                }
            });

            websocketData.websocket.addEventListener('message', function (event) {
                try {

                _Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(
                    connection,
                    $lamdera$program_test$Websocket$dataEvent(event.data)
                )));

                }
                catch (error) {
                    console.log("Websocket: Exception in _LamderaWebsocket_listen message listener. " + error);
                }
            });
        }

        if (websocketData) {
            if (websocketData.isClosed === false) {
                if (websocketData.websocket) {
                    if (websocketData.hasListener === false) {
                        addListener();
                    }
                }
                else {
                    websocketData.websocket = new WebSocket(connection.b);
                    addListener();
                }
            }
        }
        else {
            _LamderaWebsocket_websockets[connection.a] =
                { websocket : null
                , hasListener : false
                , isClosed : true
                }
            console.log("Websocket: close happened due to reset");
            _Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(
                connection,
                A2($lamdera$program_test$Websocket$closedEvent, 1005, "")
            )));
        }

        }
        catch (error) {
            console.log("Websocket: Exception in _LamderaWebsocket_listen. " + error);
        }

	});
});

var _LamderaWebsocket_close = F2(function(router, connection) {
    return _Scheduler_binding(function(callback)
    {
        try {

            var websocketData = _LamderaWebsocket_websockets[connection.a];

            console.log("Websocket: connection closed by user");

            if (websocketData) {
                websocketData.websocket.close();
                websocketData.isClosed = true;

                callback(_Scheduler_succeed(0));
            }
            else {
                callback(_Scheduler_succeed(0));
            }

        }
        catch (error) {
            console.log("Websocket: Exception in _LamderaWebsocket_close. " + error);
        }
    });
});


/*
 * Copyright (c) 2010 Mozilla Corporation
 * Copyright (c) 2010 Vladimir Vukicevic
 * Copyright (c) 2013 John Mayer
 * Copyright (c) 2018 Andrey Kuzmin
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
 */

// Vector2

var _MJS_v2 = F2(function(x, y) {
    return new Float64Array([x, y]);
});

var _MJS_v2getX = function(a) {
    return a[0];
};

var _MJS_v2getY = function(a) {
    return a[1];
};

var _MJS_v2setX = F2(function(x, a) {
    return new Float64Array([x, a[1]]);
});

var _MJS_v2setY = F2(function(y, a) {
    return new Float64Array([a[0], y]);
});

var _MJS_v2toRecord = function(a) {
    return { x: a[0], y: a[1] };
};

var _MJS_v2fromRecord = function(r) {
    return new Float64Array([r.x, r.y]);
};

var _MJS_v2add = F2(function(a, b) {
    var r = new Float64Array(2);
    r[0] = a[0] + b[0];
    r[1] = a[1] + b[1];
    return r;
});

var _MJS_v2sub = F2(function(a, b) {
    var r = new Float64Array(2);
    r[0] = a[0] - b[0];
    r[1] = a[1] - b[1];
    return r;
});

var _MJS_v2negate = function(a) {
    var r = new Float64Array(2);
    r[0] = -a[0];
    r[1] = -a[1];
    return r;
};

var _MJS_v2direction = F2(function(a, b) {
    var r = new Float64Array(2);
    r[0] = a[0] - b[0];
    r[1] = a[1] - b[1];
    var im = 1.0 / _MJS_v2lengthLocal(r);
    r[0] = r[0] * im;
    r[1] = r[1] * im;
    return r;
});

function _MJS_v2lengthLocal(a) {
    return Math.sqrt(a[0] * a[0] + a[1] * a[1]);
}
var _MJS_v2length = _MJS_v2lengthLocal;

var _MJS_v2lengthSquared = function(a) {
    return a[0] * a[0] + a[1] * a[1];
};

var _MJS_v2distance = F2(function(a, b) {
    var dx = a[0] - b[0];
    var dy = a[1] - b[1];
    return Math.sqrt(dx * dx + dy * dy);
});

var _MJS_v2distanceSquared = F2(function(a, b) {
    var dx = a[0] - b[0];
    var dy = a[1] - b[1];
    return dx * dx + dy * dy;
});

var _MJS_v2normalize = function(a) {
    var r = new Float64Array(2);
    var im = 1.0 / _MJS_v2lengthLocal(a);
    r[0] = a[0] * im;
    r[1] = a[1] * im;
    return r;
};

var _MJS_v2scale = F2(function(k, a) {
    var r = new Float64Array(2);
    r[0] = a[0] * k;
    r[1] = a[1] * k;
    return r;
});

var _MJS_v2dot = F2(function(a, b) {
    return a[0] * b[0] + a[1] * b[1];
});

// Vector3

var _MJS_v3temp1Local = new Float64Array(3);
var _MJS_v3temp2Local = new Float64Array(3);
var _MJS_v3temp3Local = new Float64Array(3);

var _MJS_v3 = F3(function(x, y, z) {
    return new Float64Array([x, y, z]);
});

var _MJS_v3getX = function(a) {
    return a[0];
};

var _MJS_v3getY = function(a) {
    return a[1];
};

var _MJS_v3getZ = function(a) {
    return a[2];
};

var _MJS_v3setX = F2(function(x, a) {
    return new Float64Array([x, a[1], a[2]]);
});

var _MJS_v3setY = F2(function(y, a) {
    return new Float64Array([a[0], y, a[2]]);
});

var _MJS_v3setZ = F2(function(z, a) {
    return new Float64Array([a[0], a[1], z]);
});

var _MJS_v3toRecord = function(a) {
    return { x: a[0], y: a[1], z: a[2] };
};

var _MJS_v3fromRecord = function(r) {
    return new Float64Array([r.x, r.y, r.z]);
};

var _MJS_v3add = F2(function(a, b) {
    var r = new Float64Array(3);
    r[0] = a[0] + b[0];
    r[1] = a[1] + b[1];
    r[2] = a[2] + b[2];
    return r;
});

function _MJS_v3subLocal(a, b, r) {
    if (r === undefined) {
        r = new Float64Array(3);
    }
    r[0] = a[0] - b[0];
    r[1] = a[1] - b[1];
    r[2] = a[2] - b[2];
    return r;
}
var _MJS_v3sub = F2(_MJS_v3subLocal);

var _MJS_v3negate = function(a) {
    var r = new Float64Array(3);
    r[0] = -a[0];
    r[1] = -a[1];
    r[2] = -a[2];
    return r;
};

function _MJS_v3directionLocal(a, b, r) {
    if (r === undefined) {
        r = new Float64Array(3);
    }
    return _MJS_v3normalizeLocal(_MJS_v3subLocal(a, b, r), r);
}
var _MJS_v3direction = F2(_MJS_v3directionLocal);

function _MJS_v3lengthLocal(a) {
    return Math.sqrt(a[0] * a[0] + a[1] * a[1] + a[2] * a[2]);
}
var _MJS_v3length = _MJS_v3lengthLocal;

var _MJS_v3lengthSquared = function(a) {
    return a[0] * a[0] + a[1] * a[1] + a[2] * a[2];
};

var _MJS_v3distance = F2(function(a, b) {
    var dx = a[0] - b[0];
    var dy = a[1] - b[1];
    var dz = a[2] - b[2];
    return Math.sqrt(dx * dx + dy * dy + dz * dz);
});

var _MJS_v3distanceSquared = F2(function(a, b) {
    var dx = a[0] - b[0];
    var dy = a[1] - b[1];
    var dz = a[2] - b[2];
    return dx * dx + dy * dy + dz * dz;
});

function _MJS_v3normalizeLocal(a, r) {
    if (r === undefined) {
        r = new Float64Array(3);
    }
    var im = 1.0 / _MJS_v3lengthLocal(a);
    r[0] = a[0] * im;
    r[1] = a[1] * im;
    r[2] = a[2] * im;
    return r;
}
var _MJS_v3normalize = _MJS_v3normalizeLocal;

var _MJS_v3scale = F2(function(k, a) {
    return new Float64Array([a[0] * k, a[1] * k, a[2] * k]);
});

var _MJS_v3dotLocal = function(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
};
var _MJS_v3dot = F2(_MJS_v3dotLocal);

function _MJS_v3crossLocal(a, b, r) {
    if (r === undefined) {
        r = new Float64Array(3);
    }
    r[0] = a[1] * b[2] - a[2] * b[1];
    r[1] = a[2] * b[0] - a[0] * b[2];
    r[2] = a[0] * b[1] - a[1] * b[0];
    return r;
}
var _MJS_v3cross = F2(_MJS_v3crossLocal);

var _MJS_v3mul4x4 = F2(function(m, v) {
    var w;
    var tmp = _MJS_v3temp1Local;
    var r = new Float64Array(3);

    tmp[0] = m[3];
    tmp[1] = m[7];
    tmp[2] = m[11];
    w = _MJS_v3dotLocal(v, tmp) + m[15];
    tmp[0] = m[0];
    tmp[1] = m[4];
    tmp[2] = m[8];
    r[0] = (_MJS_v3dotLocal(v, tmp) + m[12]) / w;
    tmp[0] = m[1];
    tmp[1] = m[5];
    tmp[2] = m[9];
    r[1] = (_MJS_v3dotLocal(v, tmp) + m[13]) / w;
    tmp[0] = m[2];
    tmp[1] = m[6];
    tmp[2] = m[10];
    r[2] = (_MJS_v3dotLocal(v, tmp) + m[14]) / w;
    return r;
});

// Vector4

var _MJS_v4 = F4(function(x, y, z, w) {
    return new Float64Array([x, y, z, w]);
});

var _MJS_v4getX = function(a) {
    return a[0];
};

var _MJS_v4getY = function(a) {
    return a[1];
};

var _MJS_v4getZ = function(a) {
    return a[2];
};

var _MJS_v4getW = function(a) {
    return a[3];
};

var _MJS_v4setX = F2(function(x, a) {
    return new Float64Array([x, a[1], a[2], a[3]]);
});

var _MJS_v4setY = F2(function(y, a) {
    return new Float64Array([a[0], y, a[2], a[3]]);
});

var _MJS_v4setZ = F2(function(z, a) {
    return new Float64Array([a[0], a[1], z, a[3]]);
});

var _MJS_v4setW = F2(function(w, a) {
    return new Float64Array([a[0], a[1], a[2], w]);
});

var _MJS_v4toRecord = function(a) {
    return { x: a[0], y: a[1], z: a[2], w: a[3] };
};

var _MJS_v4fromRecord = function(r) {
    return new Float64Array([r.x, r.y, r.z, r.w]);
};

var _MJS_v4add = F2(function(a, b) {
    var r = new Float64Array(4);
    r[0] = a[0] + b[0];
    r[1] = a[1] + b[1];
    r[2] = a[2] + b[2];
    r[3] = a[3] + b[3];
    return r;
});

var _MJS_v4sub = F2(function(a, b) {
    var r = new Float64Array(4);
    r[0] = a[0] - b[0];
    r[1] = a[1] - b[1];
    r[2] = a[2] - b[2];
    r[3] = a[3] - b[3];
    return r;
});

var _MJS_v4negate = function(a) {
    var r = new Float64Array(4);
    r[0] = -a[0];
    r[1] = -a[1];
    r[2] = -a[2];
    r[3] = -a[3];
    return r;
};

var _MJS_v4direction = F2(function(a, b) {
    var r = new Float64Array(4);
    r[0] = a[0] - b[0];
    r[1] = a[1] - b[1];
    r[2] = a[2] - b[2];
    r[3] = a[3] - b[3];
    var im = 1.0 / _MJS_v4lengthLocal(r);
    r[0] = r[0] * im;
    r[1] = r[1] * im;
    r[2] = r[2] * im;
    r[3] = r[3] * im;
    return r;
});

function _MJS_v4lengthLocal(a) {
    return Math.sqrt(a[0] * a[0] + a[1] * a[1] + a[2] * a[2] + a[3] * a[3]);
}
var _MJS_v4length = _MJS_v4lengthLocal;

var _MJS_v4lengthSquared = function(a) {
    return a[0] * a[0] + a[1] * a[1] + a[2] * a[2] + a[3] * a[3];
};

var _MJS_v4distance = F2(function(a, b) {
    var dx = a[0] - b[0];
    var dy = a[1] - b[1];
    var dz = a[2] - b[2];
    var dw = a[3] - b[3];
    return Math.sqrt(dx * dx + dy * dy + dz * dz + dw * dw);
});

var _MJS_v4distanceSquared = F2(function(a, b) {
    var dx = a[0] - b[0];
    var dy = a[1] - b[1];
    var dz = a[2] - b[2];
    var dw = a[3] - b[3];
    return dx * dx + dy * dy + dz * dz + dw * dw;
});

var _MJS_v4normalize = function(a) {
    var r = new Float64Array(4);
    var im = 1.0 / _MJS_v4lengthLocal(a);
    r[0] = a[0] * im;
    r[1] = a[1] * im;
    r[2] = a[2] * im;
    r[3] = a[3] * im;
    return r;
};

var _MJS_v4scale = F2(function(k, a) {
    var r = new Float64Array(4);
    r[0] = a[0] * k;
    r[1] = a[1] * k;
    r[2] = a[2] * k;
    r[3] = a[3] * k;
    return r;
});

var _MJS_v4dot = F2(function(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
});

// Matrix4

var _MJS_m4x4temp1Local = new Float64Array(16);
var _MJS_m4x4temp2Local = new Float64Array(16);

var _MJS_m4x4identity = new Float64Array([
    1.0, 0.0, 0.0, 0.0,
    0.0, 1.0, 0.0, 0.0,
    0.0, 0.0, 1.0, 0.0,
    0.0, 0.0, 0.0, 1.0
]);

var _MJS_m4x4fromRecord = function(r) {
    var m = new Float64Array(16);
    m[0] = r.m11;
    m[1] = r.m21;
    m[2] = r.m31;
    m[3] = r.m41;
    m[4] = r.m12;
    m[5] = r.m22;
    m[6] = r.m32;
    m[7] = r.m42;
    m[8] = r.m13;
    m[9] = r.m23;
    m[10] = r.m33;
    m[11] = r.m43;
    m[12] = r.m14;
    m[13] = r.m24;
    m[14] = r.m34;
    m[15] = r.m44;
    return m;
};

var _MJS_m4x4toRecord = function(m) {
    return {
        m11: m[0], m21: m[1], m31: m[2], m41: m[3],
        m12: m[4], m22: m[5], m32: m[6], m42: m[7],
        m13: m[8], m23: m[9], m33: m[10], m43: m[11],
        m14: m[12], m24: m[13], m34: m[14], m44: m[15]
    };
};

var _MJS_m4x4inverse = function(m) {
    var r = new Float64Array(16);

    r[0] = m[5] * m[10] * m[15] - m[5] * m[11] * m[14] - m[9] * m[6] * m[15] +
        m[9] * m[7] * m[14] + m[13] * m[6] * m[11] - m[13] * m[7] * m[10];
    r[4] = -m[4] * m[10] * m[15] + m[4] * m[11] * m[14] + m[8] * m[6] * m[15] -
        m[8] * m[7] * m[14] - m[12] * m[6] * m[11] + m[12] * m[7] * m[10];
    r[8] = m[4] * m[9] * m[15] - m[4] * m[11] * m[13] - m[8] * m[5] * m[15] +
        m[8] * m[7] * m[13] + m[12] * m[5] * m[11] - m[12] * m[7] * m[9];
    r[12] = -m[4] * m[9] * m[14] + m[4] * m[10] * m[13] + m[8] * m[5] * m[14] -
        m[8] * m[6] * m[13] - m[12] * m[5] * m[10] + m[12] * m[6] * m[9];
    r[1] = -m[1] * m[10] * m[15] + m[1] * m[11] * m[14] + m[9] * m[2] * m[15] -
        m[9] * m[3] * m[14] - m[13] * m[2] * m[11] + m[13] * m[3] * m[10];
    r[5] = m[0] * m[10] * m[15] - m[0] * m[11] * m[14] - m[8] * m[2] * m[15] +
        m[8] * m[3] * m[14] + m[12] * m[2] * m[11] - m[12] * m[3] * m[10];
    r[9] = -m[0] * m[9] * m[15] + m[0] * m[11] * m[13] + m[8] * m[1] * m[15] -
        m[8] * m[3] * m[13] - m[12] * m[1] * m[11] + m[12] * m[3] * m[9];
    r[13] = m[0] * m[9] * m[14] - m[0] * m[10] * m[13] - m[8] * m[1] * m[14] +
        m[8] * m[2] * m[13] + m[12] * m[1] * m[10] - m[12] * m[2] * m[9];
    r[2] = m[1] * m[6] * m[15] - m[1] * m[7] * m[14] - m[5] * m[2] * m[15] +
        m[5] * m[3] * m[14] + m[13] * m[2] * m[7] - m[13] * m[3] * m[6];
    r[6] = -m[0] * m[6] * m[15] + m[0] * m[7] * m[14] + m[4] * m[2] * m[15] -
        m[4] * m[3] * m[14] - m[12] * m[2] * m[7] + m[12] * m[3] * m[6];
    r[10] = m[0] * m[5] * m[15] - m[0] * m[7] * m[13] - m[4] * m[1] * m[15] +
        m[4] * m[3] * m[13] + m[12] * m[1] * m[7] - m[12] * m[3] * m[5];
    r[14] = -m[0] * m[5] * m[14] + m[0] * m[6] * m[13] + m[4] * m[1] * m[14] -
        m[4] * m[2] * m[13] - m[12] * m[1] * m[6] + m[12] * m[2] * m[5];
    r[3] = -m[1] * m[6] * m[11] + m[1] * m[7] * m[10] + m[5] * m[2] * m[11] -
        m[5] * m[3] * m[10] - m[9] * m[2] * m[7] + m[9] * m[3] * m[6];
    r[7] = m[0] * m[6] * m[11] - m[0] * m[7] * m[10] - m[4] * m[2] * m[11] +
        m[4] * m[3] * m[10] + m[8] * m[2] * m[7] - m[8] * m[3] * m[6];
    r[11] = -m[0] * m[5] * m[11] + m[0] * m[7] * m[9] + m[4] * m[1] * m[11] -
        m[4] * m[3] * m[9] - m[8] * m[1] * m[7] + m[8] * m[3] * m[5];
    r[15] = m[0] * m[5] * m[10] - m[0] * m[6] * m[9] - m[4] * m[1] * m[10] +
        m[4] * m[2] * m[9] + m[8] * m[1] * m[6] - m[8] * m[2] * m[5];

    var det = m[0] * r[0] + m[1] * r[4] + m[2] * r[8] + m[3] * r[12];

    if (det === 0) {
        return $elm$core$Maybe$Nothing;
    }

    det = 1.0 / det;

    for (var i = 0; i < 16; i = i + 1) {
        r[i] = r[i] * det;
    }

    return $elm$core$Maybe$Just(r);
};

var _MJS_m4x4inverseOrthonormal = function(m) {
    var r = _MJS_m4x4transposeLocal(m);
    var t = [m[12], m[13], m[14]];
    r[3] = r[7] = r[11] = 0;
    r[12] = -_MJS_v3dotLocal([r[0], r[4], r[8]], t);
    r[13] = -_MJS_v3dotLocal([r[1], r[5], r[9]], t);
    r[14] = -_MJS_v3dotLocal([r[2], r[6], r[10]], t);
    return r;
};

function _MJS_m4x4makeFrustumLocal(left, right, bottom, top, znear, zfar) {
    var r = new Float64Array(16);

    r[0] = 2 * znear / (right - left);
    r[1] = 0;
    r[2] = 0;
    r[3] = 0;
    r[4] = 0;
    r[5] = 2 * znear / (top - bottom);
    r[6] = 0;
    r[7] = 0;
    r[8] = (right + left) / (right - left);
    r[9] = (top + bottom) / (top - bottom);
    r[10] = -(zfar + znear) / (zfar - znear);
    r[11] = -1;
    r[12] = 0;
    r[13] = 0;
    r[14] = -2 * zfar * znear / (zfar - znear);
    r[15] = 0;

    return r;
}
var _MJS_m4x4makeFrustum = F6(_MJS_m4x4makeFrustumLocal);

var _MJS_m4x4makePerspective = F4(function(fovy, aspect, znear, zfar) {
    var ymax = znear * Math.tan(fovy * Math.PI / 360.0);
    var ymin = -ymax;
    var xmin = ymin * aspect;
    var xmax = ymax * aspect;

    return _MJS_m4x4makeFrustumLocal(xmin, xmax, ymin, ymax, znear, zfar);
});

function _MJS_m4x4makeOrthoLocal(left, right, bottom, top, znear, zfar) {
    var r = new Float64Array(16);

    r[0] = 2 / (right - left);
    r[1] = 0;
    r[2] = 0;
    r[3] = 0;
    r[4] = 0;
    r[5] = 2 / (top - bottom);
    r[6] = 0;
    r[7] = 0;
    r[8] = 0;
    r[9] = 0;
    r[10] = -2 / (zfar - znear);
    r[11] = 0;
    r[12] = -(right + left) / (right - left);
    r[13] = -(top + bottom) / (top - bottom);
    r[14] = -(zfar + znear) / (zfar - znear);
    r[15] = 1;

    return r;
}
var _MJS_m4x4makeOrtho = F6(_MJS_m4x4makeOrthoLocal);

var _MJS_m4x4makeOrtho2D = F4(function(left, right, bottom, top) {
    return _MJS_m4x4makeOrthoLocal(left, right, bottom, top, -1, 1);
});

function _MJS_m4x4mulLocal(a, b) {
    var r = new Float64Array(16);
    var a11 = a[0];
    var a21 = a[1];
    var a31 = a[2];
    var a41 = a[3];
    var a12 = a[4];
    var a22 = a[5];
    var a32 = a[6];
    var a42 = a[7];
    var a13 = a[8];
    var a23 = a[9];
    var a33 = a[10];
    var a43 = a[11];
    var a14 = a[12];
    var a24 = a[13];
    var a34 = a[14];
    var a44 = a[15];
    var b11 = b[0];
    var b21 = b[1];
    var b31 = b[2];
    var b41 = b[3];
    var b12 = b[4];
    var b22 = b[5];
    var b32 = b[6];
    var b42 = b[7];
    var b13 = b[8];
    var b23 = b[9];
    var b33 = b[10];
    var b43 = b[11];
    var b14 = b[12];
    var b24 = b[13];
    var b34 = b[14];
    var b44 = b[15];

    r[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
    r[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
    r[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
    r[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
    r[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
    r[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
    r[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
    r[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
    r[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
    r[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
    r[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
    r[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
    r[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
    r[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
    r[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
    r[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;

    return r;
}
var _MJS_m4x4mul = F2(_MJS_m4x4mulLocal);

var _MJS_m4x4mulAffine = F2(function(a, b) {
    var r = new Float64Array(16);
    var a11 = a[0];
    var a21 = a[1];
    var a31 = a[2];
    var a12 = a[4];
    var a22 = a[5];
    var a32 = a[6];
    var a13 = a[8];
    var a23 = a[9];
    var a33 = a[10];
    var a14 = a[12];
    var a24 = a[13];
    var a34 = a[14];

    var b11 = b[0];
    var b21 = b[1];
    var b31 = b[2];
    var b12 = b[4];
    var b22 = b[5];
    var b32 = b[6];
    var b13 = b[8];
    var b23 = b[9];
    var b33 = b[10];
    var b14 = b[12];
    var b24 = b[13];
    var b34 = b[14];

    r[0] = a11 * b11 + a12 * b21 + a13 * b31;
    r[1] = a21 * b11 + a22 * b21 + a23 * b31;
    r[2] = a31 * b11 + a32 * b21 + a33 * b31;
    r[3] = 0;
    r[4] = a11 * b12 + a12 * b22 + a13 * b32;
    r[5] = a21 * b12 + a22 * b22 + a23 * b32;
    r[6] = a31 * b12 + a32 * b22 + a33 * b32;
    r[7] = 0;
    r[8] = a11 * b13 + a12 * b23 + a13 * b33;
    r[9] = a21 * b13 + a22 * b23 + a23 * b33;
    r[10] = a31 * b13 + a32 * b23 + a33 * b33;
    r[11] = 0;
    r[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14;
    r[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24;
    r[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34;
    r[15] = 1;

    return r;
});

var _MJS_m4x4makeRotate = F2(function(angle, axis) {
    var r = new Float64Array(16);
    axis = _MJS_v3normalizeLocal(axis, _MJS_v3temp1Local);
    var x = axis[0];
    var y = axis[1];
    var z = axis[2];
    var c = Math.cos(angle);
    var c1 = 1 - c;
    var s = Math.sin(angle);

    r[0] = x * x * c1 + c;
    r[1] = y * x * c1 + z * s;
    r[2] = z * x * c1 - y * s;
    r[3] = 0;
    r[4] = x * y * c1 - z * s;
    r[5] = y * y * c1 + c;
    r[6] = y * z * c1 + x * s;
    r[7] = 0;
    r[8] = x * z * c1 + y * s;
    r[9] = y * z * c1 - x * s;
    r[10] = z * z * c1 + c;
    r[11] = 0;
    r[12] = 0;
    r[13] = 0;
    r[14] = 0;
    r[15] = 1;

    return r;
});

var _MJS_m4x4rotate = F3(function(angle, axis, m) {
    var r = new Float64Array(16);
    var im = 1.0 / _MJS_v3lengthLocal(axis);
    var x = axis[0] * im;
    var y = axis[1] * im;
    var z = axis[2] * im;
    var c = Math.cos(angle);
    var c1 = 1 - c;
    var s = Math.sin(angle);
    var xs = x * s;
    var ys = y * s;
    var zs = z * s;
    var xyc1 = x * y * c1;
    var xzc1 = x * z * c1;
    var yzc1 = y * z * c1;
    var t11 = x * x * c1 + c;
    var t21 = xyc1 + zs;
    var t31 = xzc1 - ys;
    var t12 = xyc1 - zs;
    var t22 = y * y * c1 + c;
    var t32 = yzc1 + xs;
    var t13 = xzc1 + ys;
    var t23 = yzc1 - xs;
    var t33 = z * z * c1 + c;
    var m11 = m[0], m21 = m[1], m31 = m[2], m41 = m[3];
    var m12 = m[4], m22 = m[5], m32 = m[6], m42 = m[7];
    var m13 = m[8], m23 = m[9], m33 = m[10], m43 = m[11];
    var m14 = m[12], m24 = m[13], m34 = m[14], m44 = m[15];

    r[0] = m11 * t11 + m12 * t21 + m13 * t31;
    r[1] = m21 * t11 + m22 * t21 + m23 * t31;
    r[2] = m31 * t11 + m32 * t21 + m33 * t31;
    r[3] = m41 * t11 + m42 * t21 + m43 * t31;
    r[4] = m11 * t12 + m12 * t22 + m13 * t32;
    r[5] = m21 * t12 + m22 * t22 + m23 * t32;
    r[6] = m31 * t12 + m32 * t22 + m33 * t32;
    r[7] = m41 * t12 + m42 * t22 + m43 * t32;
    r[8] = m11 * t13 + m12 * t23 + m13 * t33;
    r[9] = m21 * t13 + m22 * t23 + m23 * t33;
    r[10] = m31 * t13 + m32 * t23 + m33 * t33;
    r[11] = m41 * t13 + m42 * t23 + m43 * t33;
    r[12] = m14,
    r[13] = m24;
    r[14] = m34;
    r[15] = m44;

    return r;
});

function _MJS_m4x4makeScale3Local(x, y, z) {
    var r = new Float64Array(16);

    r[0] = x;
    r[1] = 0;
    r[2] = 0;
    r[3] = 0;
    r[4] = 0;
    r[5] = y;
    r[6] = 0;
    r[7] = 0;
    r[8] = 0;
    r[9] = 0;
    r[10] = z;
    r[11] = 0;
    r[12] = 0;
    r[13] = 0;
    r[14] = 0;
    r[15] = 1;

    return r;
}
var _MJS_m4x4makeScale3 = F3(_MJS_m4x4makeScale3Local);

var _MJS_m4x4makeScale = function(v) {
    return _MJS_m4x4makeScale3Local(v[0], v[1], v[2]);
};

var _MJS_m4x4scale3 = F4(function(x, y, z, m) {
    var r = new Float64Array(16);

    r[0] = m[0] * x;
    r[1] = m[1] * x;
    r[2] = m[2] * x;
    r[3] = m[3] * x;
    r[4] = m[4] * y;
    r[5] = m[5] * y;
    r[6] = m[6] * y;
    r[7] = m[7] * y;
    r[8] = m[8] * z;
    r[9] = m[9] * z;
    r[10] = m[10] * z;
    r[11] = m[11] * z;
    r[12] = m[12];
    r[13] = m[13];
    r[14] = m[14];
    r[15] = m[15];

    return r;
});

var _MJS_m4x4scale = F2(function(v, m) {
    var r = new Float64Array(16);
    var x = v[0];
    var y = v[1];
    var z = v[2];

    r[0] = m[0] * x;
    r[1] = m[1] * x;
    r[2] = m[2] * x;
    r[3] = m[3] * x;
    r[4] = m[4] * y;
    r[5] = m[5] * y;
    r[6] = m[6] * y;
    r[7] = m[7] * y;
    r[8] = m[8] * z;
    r[9] = m[9] * z;
    r[10] = m[10] * z;
    r[11] = m[11] * z;
    r[12] = m[12];
    r[13] = m[13];
    r[14] = m[14];
    r[15] = m[15];

    return r;
});

function _MJS_m4x4makeTranslate3Local(x, y, z) {
    var r = new Float64Array(16);

    r[0] = 1;
    r[1] = 0;
    r[2] = 0;
    r[3] = 0;
    r[4] = 0;
    r[5] = 1;
    r[6] = 0;
    r[7] = 0;
    r[8] = 0;
    r[9] = 0;
    r[10] = 1;
    r[11] = 0;
    r[12] = x;
    r[13] = y;
    r[14] = z;
    r[15] = 1;

    return r;
}
var _MJS_m4x4makeTranslate3 = F3(_MJS_m4x4makeTranslate3Local);

var _MJS_m4x4makeTranslate = function(v) {
    return _MJS_m4x4makeTranslate3Local(v[0], v[1], v[2]);
};

var _MJS_m4x4translate3 = F4(function(x, y, z, m) {
    var r = new Float64Array(16);
    var m11 = m[0];
    var m21 = m[1];
    var m31 = m[2];
    var m41 = m[3];
    var m12 = m[4];
    var m22 = m[5];
    var m32 = m[6];
    var m42 = m[7];
    var m13 = m[8];
    var m23 = m[9];
    var m33 = m[10];
    var m43 = m[11];

    r[0] = m11;
    r[1] = m21;
    r[2] = m31;
    r[3] = m41;
    r[4] = m12;
    r[5] = m22;
    r[6] = m32;
    r[7] = m42;
    r[8] = m13;
    r[9] = m23;
    r[10] = m33;
    r[11] = m43;
    r[12] = m11 * x + m12 * y + m13 * z + m[12];
    r[13] = m21 * x + m22 * y + m23 * z + m[13];
    r[14] = m31 * x + m32 * y + m33 * z + m[14];
    r[15] = m41 * x + m42 * y + m43 * z + m[15];

    return r;
});

var _MJS_m4x4translate = F2(function(v, m) {
    var r = new Float64Array(16);
    var x = v[0];
    var y = v[1];
    var z = v[2];
    var m11 = m[0];
    var m21 = m[1];
    var m31 = m[2];
    var m41 = m[3];
    var m12 = m[4];
    var m22 = m[5];
    var m32 = m[6];
    var m42 = m[7];
    var m13 = m[8];
    var m23 = m[9];
    var m33 = m[10];
    var m43 = m[11];

    r[0] = m11;
    r[1] = m21;
    r[2] = m31;
    r[3] = m41;
    r[4] = m12;
    r[5] = m22;
    r[6] = m32;
    r[7] = m42;
    r[8] = m13;
    r[9] = m23;
    r[10] = m33;
    r[11] = m43;
    r[12] = m11 * x + m12 * y + m13 * z + m[12];
    r[13] = m21 * x + m22 * y + m23 * z + m[13];
    r[14] = m31 * x + m32 * y + m33 * z + m[14];
    r[15] = m41 * x + m42 * y + m43 * z + m[15];

    return r;
});

var _MJS_m4x4makeLookAt = F3(function(eye, center, up) {
    var z = _MJS_v3directionLocal(eye, center, _MJS_v3temp1Local);
    var x = _MJS_v3normalizeLocal(_MJS_v3crossLocal(up, z, _MJS_v3temp2Local), _MJS_v3temp2Local);
    var y = _MJS_v3normalizeLocal(_MJS_v3crossLocal(z, x, _MJS_v3temp3Local), _MJS_v3temp3Local);
    var tm1 = _MJS_m4x4temp1Local;
    var tm2 = _MJS_m4x4temp2Local;

    tm1[0] = x[0];
    tm1[1] = y[0];
    tm1[2] = z[0];
    tm1[3] = 0;
    tm1[4] = x[1];
    tm1[5] = y[1];
    tm1[6] = z[1];
    tm1[7] = 0;
    tm1[8] = x[2];
    tm1[9] = y[2];
    tm1[10] = z[2];
    tm1[11] = 0;
    tm1[12] = 0;
    tm1[13] = 0;
    tm1[14] = 0;
    tm1[15] = 1;

    tm2[0] = 1; tm2[1] = 0; tm2[2] = 0; tm2[3] = 0;
    tm2[4] = 0; tm2[5] = 1; tm2[6] = 0; tm2[7] = 0;
    tm2[8] = 0; tm2[9] = 0; tm2[10] = 1; tm2[11] = 0;
    tm2[12] = -eye[0]; tm2[13] = -eye[1]; tm2[14] = -eye[2]; tm2[15] = 1;

    return _MJS_m4x4mulLocal(tm1, tm2);
});


function _MJS_m4x4transposeLocal(m) {
    var r = new Float64Array(16);

    r[0] = m[0]; r[1] = m[4]; r[2] = m[8]; r[3] = m[12];
    r[4] = m[1]; r[5] = m[5]; r[6] = m[9]; r[7] = m[13];
    r[8] = m[2]; r[9] = m[6]; r[10] = m[10]; r[11] = m[14];
    r[12] = m[3]; r[13] = m[7]; r[14] = m[11]; r[15] = m[15];

    return r;
}
var _MJS_m4x4transpose = _MJS_m4x4transposeLocal;

var _MJS_m4x4makeBasis = F3(function(vx, vy, vz) {
    var r = new Float64Array(16);

    r[0] = vx[0];
    r[1] = vx[1];
    r[2] = vx[2];
    r[3] = 0;
    r[4] = vy[0];
    r[5] = vy[1];
    r[6] = vy[2];
    r[7] = 0;
    r[8] = vz[0];
    r[9] = vz[1];
    r[10] = vz[2];
    r[11] = 0;
    r[12] = 0;
    r[13] = 0;
    r[14] = 0;
    r[15] = 1;

    return r;
});


var _WebGLFix_guid = 0;

function _WebGLFix_listEach(fn, list) {
  for (; list.b; list = list.b) {
    fn(list.a);
  }
}

function _WebGLFix_listLength(list) {
  var length = 0;
  for (; list.b; list = list.b) {
    length++;
  }
  return length;
}

var _WebGLFix_rAF = typeof requestAnimationFrame !== 'undefined' ?
  requestAnimationFrame :
  function (cb) { setTimeout(cb, 1000 / 60); };

// eslint-disable-next-line no-unused-vars
var _WebGLFix_entity = F5(function (settings, vert, frag, mesh, uniforms) {
  return {
    $: 0,
    a: settings,
    b: vert,
    c: frag,
    d: mesh,
    e: uniforms
  };
});

// eslint-disable-next-line no-unused-vars
var _WebGLFix_enableBlend = F2(function (cache, setting) {
  var blend = cache.blend;
  blend.toggle = cache.toggle;

  if (!blend.enabled) {
    cache.gl.enable(cache.gl.BLEND);
    blend.enabled = true;
  }

  // a   b   c   d   e   f   g h i j
  // eq1 f11 f12 eq2 f21 f22 r g b a
  if (blend.a !== setting.a || blend.d !== setting.d) {
    cache.gl.blendEquationSeparate(setting.a, setting.d);
    blend.a = setting.a;
    blend.d = setting.d;
  }
  if (blend.b !== setting.b || blend.c !== setting.c || blend.e !== setting.e || blend.f !== setting.f) {
    cache.gl.blendFuncSeparate(setting.b, setting.c, setting.e, setting.f);
    blend.b = setting.b;
    blend.c = setting.c;
    blend.e = setting.e;
    blend.f = setting.f;
  }
  if (blend.g !== setting.g || blend.h !== setting.h || blend.i !== setting.i || blend.j !== setting.j) {
    cache.gl.blendColor(setting.g, setting.h, setting.i, setting.j);
    blend.g = setting.g;
    blend.h = setting.h;
    blend.i = setting.i;
    blend.j = setting.j;
  }
});

// eslint-disable-next-line no-unused-vars
var _WebGLFix_enableDepthTest = F2(function (cache, setting) {
  var depthTest = cache.depthTest;
  depthTest.toggle = cache.toggle;

  if (!depthTest.enabled) {
    cache.gl.enable(cache.gl.DEPTH_TEST);
    depthTest.enabled = true;
  }

  // a    b    c    d
  // func mask near far
  if (depthTest.a !== setting.a) {
    cache.gl.depthFunc(setting.a);
    depthTest.a = setting.a;
  }
  if (depthTest.b !== setting.b) {
    cache.gl.depthMask(setting.b);
    depthTest.b = setting.b;
  }
  if (depthTest.c !== setting.c || depthTest.d !== setting.d) {
    cache.gl.depthRange(setting.c, setting.d);
    depthTest.c = setting.c;
    depthTest.d = setting.d;
  }
});

// eslint-disable-next-line no-unused-vars
var _WebGLFix_enableStencilTest = F2(function (cache, setting) {
  var stencilTest = cache.stencilTest;
  stencilTest.toggle = cache.toggle;

  if (!stencilTest.enabled) {
    cache.gl.enable(cache.gl.STENCIL_TEST);
    stencilTest.enabled = true;
  }

  // a   b    c         d     e     f      g      h     i     j      k
  // ref mask writeMask test1 fail1 zfail1 zpass1 test2 fail2 zfail2 zpass2
  if (stencilTest.d !== setting.d || stencilTest.a !== setting.a || stencilTest.b !== setting.b) {
    cache.gl.stencilFuncSeparate(cache.gl.FRONT, setting.d, setting.a, setting.b);
    stencilTest.d = setting.d;
    // a and b are set in the cache.gl.BACK diffing because they should be the same
  }
  if (stencilTest.e !== setting.e || stencilTest.f !== setting.f || stencilTest.g !== setting.g) {
    cache.gl.stencilOpSeparate(cache.gl.FRONT, setting.e, setting.f, setting.g);
    stencilTest.e = setting.e;
    stencilTest.f = setting.f;
    stencilTest.g = setting.g;
  }
  if (stencilTest.c !== setting.c) {
    cache.gl.stencilMask(setting.c);
    stencilTest.c = setting.c;
  }
  if (stencilTest.h !== setting.h || stencilTest.a !== setting.a || stencilTest.b !== setting.b) {
    cache.gl.stencilFuncSeparate(cache.gl.BACK, setting.h, setting.a, setting.b);
    stencilTest.h = setting.h;
    stencilTest.a = setting.a;
    stencilTest.b = setting.b;
  }
  if (stencilTest.i !== setting.i || stencilTest.j !== setting.j || stencilTest.k !== setting.k) {
    cache.gl.stencilOpSeparate(cache.gl.BACK, setting.i, setting.j, setting.k);
    stencilTest.i = setting.i;
    stencilTest.j = setting.j;
    stencilTest.k = setting.k;
  }
});

// eslint-disable-next-line no-unused-vars
var _WebGLFix_enableScissor = F2(function (cache, setting) {
  var scissor = cache.scissor;
  scissor.toggle = cache.toggle;

  if (!scissor.enabled) {
    cache.gl.enable(cache.gl.SCISSOR_TEST);
    scissor.enabled = true;
  }

  if (scissor.a !== setting.a || scissor.b !== setting.b || scissor.c !== setting.c || scissor.d !== setting.d) {
    cache.gl.scissor(setting.a, setting.b, setting.c, setting.d);
    scissor.a = setting.a;
    scissor.b = setting.b;
    scissor.c = setting.c;
    scissor.d = setting.d;
  }
});

// eslint-disable-next-line no-unused-vars
var _WebGLFix_enableColorMask = F2(function (cache, setting) {
  var colorMask = cache.colorMask;
  colorMask.toggle = cache.toggle;
  colorMask.enabled = true;

  if (colorMask.a !== setting.a || colorMask.b !== setting.b || colorMask.c !== setting.c || colorMask.d !== setting.d) {
    cache.gl.colorMask(setting.a, setting.b, setting.c, setting.d);
    colorMask.a = setting.a;
    colorMask.b = setting.b;
    colorMask.c = setting.c;
    colorMask.d = setting.d;
  }
});

// eslint-disable-next-line no-unused-vars
var _WebGLFix_enableCullFace = F2(function (cache, setting) {
  var cullFace = cache.cullFace;
  cullFace.toggle = cache.toggle;

  if (!cullFace.enabled) {
    cache.gl.enable(cache.gl.CULL_FACE);
    cullFace.enabled = true;
  }

  if (cullFace.a !== setting.a) {
    cache.gl.cullFace(setting.a);
    cullFace.a = setting.a;
  }
});

// eslint-disable-next-line no-unused-vars
var _WebGLFix_enablePolygonOffset = F2(function (cache, setting) {
  var polygonOffset = cache.polygonOffset;
  polygonOffset.toggle = cache.toggle;

  if (!polygonOffset.enabled) {
    cache.gl.enable(cache.gl.POLYGON_OFFSET_FILL);
    polygonOffset.enabled = true;
  }

  if (polygonOffset.a !== setting.a || polygonOffset.b !== setting.b) {
    cache.gl.polygonOffset(setting.a, setting.b);
    polygonOffset.a = setting.a;
    polygonOffset.b = setting.b;
  }
});

// eslint-disable-next-line no-unused-vars
var _WebGLFix_enableSampleCoverage = F2(function (cache, setting) {
  var sampleCoverage = cache.sampleCoverage;
  sampleCoverage.toggle = cache.toggle;

  if (!sampleCoverage.enabled) {
    cache.gl.enable(cache.gl.SAMPLE_COVERAGE);
    sampleCoverage.enabled = true;
  }

  if (sampleCoverage.a !== setting.a || sampleCoverage.b !== setting.b) {
    cache.gl.sampleCoverage(setting.a, setting.b);
    sampleCoverage.a = setting.a;
    sampleCoverage.b = setting.b;
  }
});

// eslint-disable-next-line no-unused-vars
var _WebGLFix_enableSampleAlphaToCoverage = function (cache) {
  var sampleAlphaToCoverage = cache.sampleAlphaToCoverage;
  sampleAlphaToCoverage.toggle = cache.toggle;

  if (!sampleAlphaToCoverage.enabled) {
    cache.gl.enable(cache.gl.SAMPLE_ALPHA_TO_COVERAGE);
    sampleAlphaToCoverage.enabled = true;
  }
};

var _WebGLFix_disableBlend = function (cache) {
  if (cache.blend.enabled) {
    cache.gl.disable(cache.gl.BLEND);
    cache.blend.enabled = false;
  }
};

var _WebGLFix_disableDepthTest = function (cache) {
  if (cache.depthTest.enabled) {
    cache.gl.disable(cache.gl.DEPTH_TEST);
    cache.depthTest.enabled = false;
  }
};

var _WebGLFix_disableStencilTest = function (cache) {
  if (cache.stencilTest.enabled) {
    cache.gl.disable(cache.gl.STENCIL_TEST);
    cache.stencilTest.enabled = false;
  }
};

var _WebGLFix_disableScissor = function (cache) {
  if (cache.scissor.enabled) {
    cache.gl.disable(cache.gl.SCISSOR_TEST);
    cache.scissor.enabled = false;
  }
};

var _WebGLFix_disableColorMask = function (cache) {
  var colorMask = cache.colorMask;
  if (!colorMask.a || !colorMask.b || !colorMask.c || !colorMask.d) {
    cache.gl.colorMask(true, true, true, true);
    colorMask.a = true;
    colorMask.b = true;
    colorMask.c = true;
    colorMask.d = true;
  }
};

var _WebGLFix_disableCullFace = function (cache) {
  cache.gl.disable(cache.gl.CULL_FACE);
};

var _WebGLFix_disablePolygonOffset = function (cache) {
  cache.gl.disable(cache.gl.POLYGON_OFFSET_FILL);
};

var _WebGLFix_disableSampleCoverage = function (cache) {
  cache.gl.disable(cache.gl.SAMPLE_COVERAGE);
};

var _WebGLFix_disableSampleAlphaToCoverage = function (cache) {
  cache.gl.disable(cache.gl.SAMPLE_ALPHA_TO_COVERAGE);
};

var _WebGLFix_settings = ['blend', 'depthTest', 'stencilTest', 'scissor', 'colorMask', 'cullFace', 'polygonOffset', 'sampleCoverage', 'sampleAlphaToCoverage'];
var _WebGLFix_disableFunctions = [_WebGLFix_disableBlend, _WebGLFix_disableDepthTest, _WebGLFix_disableStencilTest, _WebGLFix_disableScissor, _WebGLFix_disableColorMask, _WebGLFix_disableCullFace, _WebGLFix_disablePolygonOffset, _WebGLFix_disableSampleCoverage, _WebGLFix_disableSampleAlphaToCoverage];

function _WebGLFix_doCompile(gl, src, type) {
  var shader = gl.createShader(type);
  // Enable OES_standard_derivatives extension
  gl.shaderSource(shader, '#extension GL_OES_standard_derivatives : enable\n' + src);
  gl.compileShader(shader);
  return shader;
}

function _WebGLFix_doLink(gl, vshader, fshader) {
  var program = gl.createProgram();

  gl.attachShader(program, vshader);
  gl.attachShader(program, fshader);
  gl.linkProgram(program);
  if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
    throw ('Link failed: ' + gl.getProgramInfoLog(program) +
      '\nvs info-log: ' + gl.getShaderInfoLog(vshader) +
      '\nfs info-log: ' + gl.getShaderInfoLog(fshader));
  }

  return program;
}

function _WebGLFix_getAttributeInfo(gl, type) {
  switch (type) {
    case gl.FLOAT:
      return { size: 1, arraySize: 1, type: Float32Array, baseType: gl.FLOAT };
    case gl.FLOAT_VEC2:
      return { size: 2, arraySize: 1, type: Float32Array, baseType: gl.FLOAT };
    case gl.FLOAT_VEC3:
      return { size: 3, arraySize: 1, type: Float32Array, baseType: gl.FLOAT };
    case gl.FLOAT_VEC4:
      return { size: 4, arraySize: 1, type: Float32Array, baseType: gl.FLOAT };
    case gl.FLOAT_MAT4:
      return { size: 4, arraySize: 4, type: Float32Array, baseType: gl.FLOAT };
    case gl.INT:
      return { size: 1, arraySize: 1, type: Int32Array, baseType: gl.INT };
  }
}

/**
 *  Form the buffer for a given attribute.
 *
 *  @param {WebGLRenderingContext} gl context
 *  @param {WebGLActiveInfo} attribute the attribute to bind to.
 *         We use its name to grab the record by name and also to know
 *         how many elements we need to grab.
 *  @param {Mesh} mesh The mesh coming in from Elm.
 *  @param {Object} attributes The mapping between the attribute names and Elm fields
 *  @return {WebGLBuffer}
 */
function _WebGLFix_doBindAttribute(gl, attribute, mesh, attributes) {
  // The length of the number of vertices that
  // complete one 'thing' based on the drawing mode.
  // ie, 2 for Lines, 3 for Triangles, etc.
  var elemSize = mesh.a.elemSize;

  var idxKeys = [];
  for (var i = 0; i < elemSize; i++) {
    idxKeys.push(String.fromCharCode(97 + i));
  }

  function dataFill(data, cnt, fillOffset, elem, key) {
    var i;
    if (elemSize === 1) {
      for (i = 0; i < cnt; i++) {
        data[fillOffset++] = cnt === 1 ? elem[key] : elem[key][i];
      }
    } else {
      idxKeys.forEach(function (idx) {
        for (i = 0; i < cnt; i++) {
          data[fillOffset++] = cnt === 1 ? elem[idx][key] : elem[idx][key][i];
        }
      });
    }
  }

  var attributeInfo = _WebGLFix_getAttributeInfo(gl, attribute.type);

  if (attributeInfo === undefined) {
    throw new Error('No info available for: ' + attribute.type);
  }

  var dataIdx = 0;
  var dataOffset = attributeInfo.size * attributeInfo.arraySize * elemSize;
  var array = new attributeInfo.type(_WebGLFix_listLength(mesh.b) * dataOffset);

  _WebGLFix_listEach(function (elem) {
    dataFill(array, attributeInfo.size * attributeInfo.arraySize, dataIdx, elem, attributes[attribute.name] || attribute.name);
    dataIdx += dataOffset;
  }, mesh.b);

  var buffer = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
  gl.bufferData(gl.ARRAY_BUFFER, array, gl.STATIC_DRAW);
  return buffer;
}

/**
 *  This sets up the binding caching buffers.
 *
 *  We don't actually bind any buffers now except for the indices buffer.
 *  The problem with filling the buffers here is that it is possible to
 *  have a buffer shared between two webgl shaders;
 *  which could have different active attributes. If we bind it here against
 *  a particular program, we might not bind them all. That final bind is now
 *  done right before drawing.
 *
 *  @param {WebGLRenderingContext} gl context
 *  @param {Mesh} mesh a mesh object from Elm
 *  @return {Object} buffer - an object with the following properties
 *  @return {Number} buffer.numIndices
 *  @return {WebGLBuffer|null} buffer.indexBuffer - optional index buffer
 *  @return {Object} buffer.buffers - will be used to buffer attributes
 */
function _WebGLFix_doBindSetup(gl, mesh) {
  if (mesh.a.indexSize > 0) {
    var indexBuffer = gl.createBuffer();
    var indices = _WebGLFix_makeIndexedBuffer(mesh.c, mesh.a.indexSize);
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, indexBuffer);
    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, indices, gl.STATIC_DRAW);
    return {
      numIndices: indices.length,
      indexBuffer: indexBuffer,
      buffers: {}
    };
  } else {
    return {
      numIndices: mesh.a.elemSize * _WebGLFix_listLength(mesh.b),
      indexBuffer: null,
      buffers: {}
    };
  }
}

/**
 *  Create an indices array and fill it from indices
 *  based on the size of the index
 *
 *  @param {List} indicesList the list of indices
 *  @param {Number} indexSize the size of the index
 *  @return {Uint32Array} indices
 */
function _WebGLFix_makeIndexedBuffer(indicesList, indexSize) {
  var indices = new Uint32Array(_WebGLFix_listLength(indicesList) * indexSize);
  var fillOffset = 0;
  var i;
  _WebGLFix_listEach(function (elem) {
    if (indexSize === 1) {
      indices[fillOffset++] = elem;
    } else {
      for (i = 0; i < indexSize; i++) {
        indices[fillOffset++] = elem[String.fromCharCode(97 + i)];
      }
    }
  }, indicesList);
  return indices;
}

function _WebGLFix_getProgID(vertID, fragID) {
  return vertID + '#' + fragID;
}

var _WebGLFix_drawGL = F2(function (model, domNode) {
  var cache = model.f;
  var gl = cache.gl;

  if (!gl) {
    return domNode;
  }

  gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);

  if (!cache.depthTest.b) {
    gl.depthMask(true);
    cache.depthTest.b = true;
  }
  if (cache.stencilTest.c !== cache.STENCIL_WRITEMASK) {
    gl.stencilMask(cache.STENCIL_WRITEMASK);
    cache.stencilTest.c = cache.STENCIL_WRITEMASK;
  }
  _WebGLFix_disableScissor(cache);
  _WebGLFix_disableColorMask(cache);
  gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT | gl.STENCIL_BUFFER_BIT);

  function drawEntity(entity) {
    if (!entity.d.b.b) {
      return; // Empty list
    }

    var progid;
    var program;
    var i;

    if (entity.b.id && entity.c.id) {
      progid = _WebGLFix_getProgID(entity.b.id, entity.c.id);
      program = cache.programs[progid];
    }

    if (!program) {

      var vshader;
      if (entity.b.id) {
        vshader = cache.shaders[entity.b.id];
      } else {
        entity.b.id = _WebGLFix_guid++;
      }

      if (!vshader) {
        vshader = _WebGLFix_doCompile(gl, entity.b.src, gl.VERTEX_SHADER);
        cache.shaders[entity.b.id] = vshader;
      }

      var fshader;
      if (entity.c.id) {
        fshader = cache.shaders[entity.c.id];
      } else {
        entity.c.id = _WebGLFix_guid++;
      }

      if (!fshader) {
        fshader = _WebGLFix_doCompile(gl, entity.c.src, gl.FRAGMENT_SHADER);
        cache.shaders[entity.c.id] = fshader;
      }

      var glProgram = _WebGLFix_doLink(gl, vshader, fshader);

      program = {
        glProgram: glProgram,
        attributes: Object.assign({}, entity.b.attributes, entity.c.attributes),
        currentUniforms: {},
        activeAttributes: [],
        activeAttributeLocations: []
      };

      program.uniformSetters = _WebGLFix_createUniformSetters(
        gl,
        model,
        program,
        Object.assign({}, entity.b.uniforms, entity.c.uniforms)
      );

      var numActiveAttributes = gl.getProgramParameter(glProgram, gl.ACTIVE_ATTRIBUTES);
      for (i = 0; i < numActiveAttributes; i++) {
        var attribute = gl.getActiveAttrib(glProgram, i);
        var attribLocation = gl.getAttribLocation(glProgram, attribute.name);
        program.activeAttributes.push(attribute);
        program.activeAttributeLocations.push(attribLocation);
      }

      progid = _WebGLFix_getProgID(entity.b.id, entity.c.id);
      cache.programs[progid] = program;
    }

    if (cache.lastProgId !== progid) {
      gl.useProgram(program.glProgram);
      cache.lastProgId = progid;
    }

    _WebGLFix_setUniforms(program.uniformSetters, entity.e);

    var buffer = cache.buffers.get(entity.d);

    if (!buffer) {
      buffer = _WebGLFix_doBindSetup(gl, entity.d);
      cache.buffers.set(entity.d, buffer);
    }

    for (i = 0; i < program.activeAttributes.length; i++) {
      attribute = program.activeAttributes[i];
      attribLocation = program.activeAttributeLocations[i];

      if (buffer.buffers[attribute.name] === undefined) {
        buffer.buffers[attribute.name] = _WebGLFix_doBindAttribute(gl, attribute, entity.d, program.attributes);
      }
      gl.bindBuffer(gl.ARRAY_BUFFER, buffer.buffers[attribute.name]);

      var attributeInfo = _WebGLFix_getAttributeInfo(gl, attribute.type);
      if (attributeInfo.arraySize === 1) {
        gl.enableVertexAttribArray(attribLocation);
        gl.vertexAttribPointer(attribLocation, attributeInfo.size, attributeInfo.baseType, false, 0, 0);
      } else {
        // Point to four vec4 in case of mat4
        var offset = attributeInfo.size * 4; // float32 takes 4 bytes
        var stride = offset * attributeInfo.arraySize;
        for (var m = 0; m < attributeInfo.arraySize; m++) {
          gl.enableVertexAttribArray(attribLocation + m);
          gl.vertexAttribPointer(attribLocation + m, attributeInfo.size, attributeInfo.baseType, false, stride, offset * m);
        }
      }
    }

    // Apply all the new settings
    cache.toggle = !cache.toggle;
    _WebGLFix_listEach($lamdera$program_test$WebGLFix$Internal$enableSetting(cache), entity.a);
    // Disable the settings that were applied in the previous draw call
    for (i = 0; i < _WebGLFix_settings.length; i++) {
      var setting = cache[_WebGLFix_settings[i]];
      if (setting.toggle !== cache.toggle && setting.enabled) {
        _WebGLFix_disableFunctions[i](cache);
        setting.enabled = false;
        setting.toggle = cache.toggle;
      }
    }

    if (buffer.indexBuffer) {
      gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, buffer.indexBuffer);
      gl.drawElements(entity.d.a.mode, buffer.numIndices, gl.UNSIGNED_INT, 0);
    } else {
      gl.drawArrays(entity.d.a.mode, 0, buffer.numIndices);
    }
  }

  _WebGLFix_listEach(drawEntity, model.g);
  return domNode;
});

function _WebGLFix_createUniformSetters(gl, model, program, uniformsMap) {
  var glProgram = program.glProgram;
  var currentUniforms = program.currentUniforms;
  var textureCounter = 0;
  var cache = model.f;
  function createUniformSetter(glProgram, uniform) {
    var uniformName = uniform.name;
    var uniformLocation = gl.getUniformLocation(glProgram, uniformName);
    switch (uniform.type) {
      case gl.INT:
        return function (value) {
          if (currentUniforms[uniformName] !== value) {
            gl.uniform1i(uniformLocation, value);
            currentUniforms[uniformName] = value;
          }
        };
      case gl.FLOAT:
        return function (value) {
          if (currentUniforms[uniformName] !== value) {
            gl.uniform1f(uniformLocation, value);
            currentUniforms[uniformName] = value;
          }
        };
      case gl.FLOAT_VEC2:
        return function (value) {
          if (currentUniforms[uniformName] !== value) {
            gl.uniform2f(uniformLocation, value[0], value[1]);
            currentUniforms[uniformName] = value;
          }
        };
      case gl.FLOAT_VEC3:
        return function (value) {
          if (currentUniforms[uniformName] !== value) {
            gl.uniform3f(uniformLocation, value[0], value[1], value[2]);
            currentUniforms[uniformName] = value;
          }
        };
      case gl.FLOAT_VEC4:
        return function (value) {
          if (currentUniforms[uniformName] !== value) {
            gl.uniform4f(uniformLocation, value[0], value[1], value[2], value[3]);
            currentUniforms[uniformName] = value;
          }
        };
      case gl.FLOAT_MAT4:
        return function (value) {
          if (currentUniforms[uniformName] !== value) {
            gl.uniformMatrix4fv(uniformLocation, false, new Float32Array(value));
            currentUniforms[uniformName] = value;
          }
        };
      case gl.SAMPLER_2D:
        var currentTexture = textureCounter++;
        return function (texture) {
          gl.activeTexture(gl.TEXTURE0 + currentTexture);
          var tex = cache.textures.get(texture);
          if (!tex) {
            tex = texture.createTexture(gl);
            cache.textures.set(texture, tex);
          }
          gl.bindTexture(gl.TEXTURE_2D, tex);
          if (currentUniforms[uniformName] !== texture) {
            gl.uniform1i(uniformLocation, currentTexture);
            currentUniforms[uniformName] = texture;
          }
        };
      case gl.BOOL:
        return function (value) {
          if (currentUniforms[uniformName] !== value) {
            gl.uniform1i(uniformLocation, value);
            currentUniforms[uniformName] = value;
          }
        };
      default:
        return function () { };
    }
  }

  var uniformSetters = {};
  var numUniforms = gl.getProgramParameter(glProgram, gl.ACTIVE_UNIFORMS);
  for (var i = 0; i < numUniforms; i++) {
    var uniform = gl.getActiveUniform(glProgram, i);
    uniformSetters[uniformsMap[uniform.name] || uniform.name] = createUniformSetter(glProgram, uniform);
  }

  return uniformSetters;
}

function _WebGLFix_setUniforms(setters, values) {
  Object.keys(values).forEach(function (name) {
    var setter = setters[name];
    if (setter) {
      setter(values[name]);
    }
  });
}

// VIRTUAL-DOM WIDGET

// eslint-disable-next-line no-unused-vars
var _WebGLFix_toHtml = F3(function (options, factList, entities) {
  return _VirtualDom_custom(
    factList,
    {
      g: entities,
      f: {},
      h: options
    },
    _WebGLFix_render,
    _WebGLFix_diff
  );
});

// eslint-disable-next-line no-unused-vars
var _WebGLFix_enableAlpha = F2(function (options, option) {
  options.contextAttributes.alpha = true;
  options.contextAttributes.premultipliedAlpha = option.a;
});

// eslint-disable-next-line no-unused-vars
var _WebGLFix_enableDepth = F2(function (options, option) {
  options.contextAttributes.depth = true;
  options.sceneSettings.push(function (gl) {
    gl.clearDepth(option.a);
  });
});

// eslint-disable-next-line no-unused-vars
var _WebGLFix_enableStencil = F2(function (options, option) {
  options.contextAttributes.stencil = true;
  options.sceneSettings.push(function (gl) {
    gl.clearStencil(option.a);
  });
});

// eslint-disable-next-line no-unused-vars
var _WebGLFix_enableAntialias = F2(function (options, option) {
  options.contextAttributes.antialias = true;
});

// eslint-disable-next-line no-unused-vars
var _WebGLFix_enableClearColor = F2(function (options, option) {
  options.sceneSettings.push(function (gl) {
    gl.clearColor(option.a, option.b, option.c, option.d);
  });
});

// eslint-disable-next-line no-unused-vars
var _WebGLFix_enablePreserveDrawingBuffer = F2(function (options, option) {
  options.contextAttributes.preserveDrawingBuffer = true;
});

/**
 *  Creates canvas and schedules initial _WebGLFix_drawGL
 *  @param {Object} model
 *  @param {Object} model.f that may contain the following properties:
           gl, shaders, programs, buffers, textures
 *  @param {List<Option>} model.h list of options coming from Elm
 *  @param {List<Entity>} model.g list of entities coming from Elm
 *  @return {HTMLElement} <canvas> if WebGL is supported, otherwise a <div>
 */
function _WebGLFix_render(model) {
  var options = {
    contextAttributes: {
      alpha: false,
      depth: false,
      stencil: false,
      antialias: false,
      premultipliedAlpha: false,
      preserveDrawingBuffer: false
    },
    sceneSettings: []
  };

  _WebGLFix_listEach(function (option) {
    return A2($lamdera$program_test$WebGLFix$Internal$enableOption, options, option);
  }, model.h);

  var canvas = _VirtualDom_doc.createElement('canvas');
  var gl = canvas.getContext && (
    canvas.getContext('webgl', options.contextAttributes) ||
    canvas.getContext('experimental-webgl', options.contextAttributes)
  );

  if (gl && typeof WeakMap !== 'undefined') {
    options.sceneSettings.forEach(function (sceneSetting) {
      sceneSetting(gl);
    });

    // Activate extensions
    gl.getExtension('OES_standard_derivatives');
    gl.getExtension('OES_element_index_uint');
    gl.getExtension("EXT_frag_depth");

    model.f.gl = gl;

    // Cache the current settings in order to diff them to avoid redundant calls
    // https://emscripten.org/docs/optimizing/Optimizing-WebGL.html#avoid-redundant-calls
    model.f.toggle = false; // used to diff the settings from the previous and current draw calls
    model.f.blend = { enabled: false, toggle: false };
    model.f.depthTest = { enabled: false, toggle: false };
    model.f.stencilTest = { enabled: false, toggle: false };
    model.f.scissor = { enabled: false, toggle: false };
    model.f.colorMask = { enabled: false, toggle: false };
    model.f.cullFace = { enabled: false, toggle: false };
    model.f.polygonOffset = { enabled: false, toggle: false };
    model.f.sampleCoverage = { enabled: false, toggle: false };
    model.f.sampleAlphaToCoverage = { enabled: false, toggle: false };

    model.f.shaders = [];
    model.f.programs = {};
    model.f.lastProgId = null;
    model.f.buffers = new WeakMap();
    model.f.textures = new WeakMap();
    // Memorize the initial stencil write mask, because
    // browsers may have different number of stencil bits
    model.f.STENCIL_WRITEMASK = gl.getParameter(gl.STENCIL_WRITEMASK);

    // Render for the first time.
    // This has to be done in animation frame,
    // because the canvas is not in the DOM yet
    _WebGLFix_rAF(function () {
      return A2(_WebGLFix_drawGL, model, canvas);
    });

  } else {
    canvas = _VirtualDom_doc.createElement('div');
    canvas.innerHTML = '<a href="https://get.webgl.org/">Enable WebGL</a> to see this content!';
  }

  return canvas;
}

function _WebGLFix_diff(oldModel, newModel) {
  newModel.f = oldModel.f;
  return _WebGLFix_drawGL(newModel);
}

var xrSession = null;
var xrGl = null;
var xrReferenceSpace = null;
var xrModel = null;
var xrStartTime = 0;
var xrLastUpdate = 0;

//function _WebGLFix_setFrameRate(frameRate) {
//    return _Scheduler_binding(function (callback) {
//        session.updateTargetFrameRate( framerateList[0] ).then((a) => {
//
//        });
//    }
//}

function _WebGLFix_requestXrStart(options) {
    return _Scheduler_binding(function (callback) {
        if (xrSession) {
            callback(_Scheduler_fail($lamdera$program_test$Effect$Internal$AlreadyStarted));
        }
        else {
            if (navigator.xr) {
                navigator.xr.requestSession(
                    'immersive-vr', {
                        requiredFeatures: ["local-floor"],
                        optionalFeatures: ["bounded-floor"],
                    }).then((session) => {

                    xrStartTime = Date.now();
                    xrSession = session;
                    // Listen for the sessions 'end' event so we can respond if the user
                    // or UA ends the session for any reason.
                    session.addEventListener('end', (a) => {
                        xrSession = null;
                        xrGl = null;
                        xrReferenceSpace = null;
                        xrModel = null;
                    });

                    // Create a WebGL context to render with, initialized to be compatible
                    // with the XRDisplay we're presenting to.
                    var xrCanvas = document.createElement('canvas');

                    var contextAttributes = {
                          alpha: false,
                          depth: true,
                          stencil: false,
                          antialias: false,
                          premultipliedAlpha: false,
                          preserveDrawingBuffer: false,
                          xrCompatible: true
                        };

                    xrGl = xrCanvas.getContext('webgl', contextAttributes);

                    // Use the new WebGL context to create a XRWebGLLayer and set it as the
                    // sessions baseLayer. This allows any content rendered to the layer to
                    // be displayed on the XRDevice.
                    session.updateRenderState({ baseLayer: new XRWebGLLayer(session, xrGl) });

                    let xrStartData = {
                        boundary : $elm$core$Maybe$Nothing,
                        supportedFrameRates :
                            session.supportedFrameRates
                                ? _List_fromArray(session.supportedFrameRates)
                                : _List_fromArray([])
                        };

                    if (session.updateTargetFrameRate) {
                        session.updateTargetFrameRate(120);
                    }

                    session
                        .requestReferenceSpace('bounded-floor')
                        .then((boundedFloor) => {

                            xrReferenceSpace = boundedFloor;

                            xrModel = { f: {}, h: options };

                            xrRender(xrModel);

                            xrStartData.boundary = $elm$core$Maybe$Just(_List_fromArray(xrReferenceSpace.boundsGeometry.map((p) => { return A2(_MJS_v2, p.x, -p.z); })));
                            callback(_Scheduler_succeed(xrStartData));
                        })
                        .catch(() => {
                            session
                                .requestReferenceSpace('local-floor')
                                .then((localFloor) => {
                                    xrReferenceSpace = localFloor;

                                    xrModel = { f: {}, h: options };

                                    xrRender(xrModel);

                                    callback(_Scheduler_succeed(xrStartData));
                                });
                        });

                });
            }
            else {
                callback(_Scheduler_fail($lamdera$program_test$Effect$Internal$NotSupported));
            }
        }
    });
}


function getInputSources(session, frame, refSpace) {
    let inputs = []
    session.inputSources.forEach((inputSource) => {
        let pose = frame.getPose(inputSource.targetRaySpace, refSpace);

        let gamepad = inputSource.gamepad;

        let controller = {
            buttons : _List_fromArray(gamepad.buttons.map((button) => {
                    return { isPressed : button.pressed, isTouched : button.touched, value : button.value };
                }))
            , handedness : $lamdera$program_test$Effect$Internal$Unknown
            , mapping : gamepad.mapping
            , axes : _List_fromArray(gamepad.axes)
            , matrix : $elm$core$Maybe$Nothing
            };

        switch (inputSource.handedness) {
            case "left":
                controller.handedness = $lamdera$program_test$Effect$Internal$LeftHand
                break;
            case "right":
                controller.handedness = $lamdera$program_test$Effect$Internal$RightHand
                break;
        }

        if (pose) {
            controller.matrix = $elm$core$Maybe$Just(new Float64Array(pose.transform.matrix));
        }

        inputs.push(controller);
    });

    return _List_fromArray(inputs);
}

function _WebGLFix_xrEnd(a) {
    return _Scheduler_binding(function (callback) {
        if (xrSession) {
            xrSession.end().then((b) => callback(_Scheduler_succeed(0)));
        }
        else {
            callback(_Scheduler_succeed(0));
        }
    });
}

function _WebGLFix_renderXrFrame(entities) {
    return _Scheduler_binding(function (callback) {

        if (xrSession) {
            function notStarted(a) { callback(_Scheduler_fail($lamdera$program_test$Effect$Internal$XrSessionNotStarted)); }

            xrSession.addEventListener('end', notStarted );

            xrSession.requestAnimationFrame((time, frame) => {
                let pose = frame.getViewerPose(xrReferenceSpace);

                xrSession.removeEventListener('end', notStarted);

                if (pose) {
                    let inputs = getInputSources(xrSession, frame, xrReferenceSpace);

                    let glLayer = frame.session.renderState.baseLayer;

                    xrGl.bindFramebuffer(xrGl.FRAMEBUFFER, glLayer.framebuffer);
                    xrGl.clear(xrGl.COLOR_BUFFER_BIT | xrGl.DEPTH_BUFFER_BIT | xrGl.STENCIL_BUFFER_BIT);

                    let elmViews = [];

                    for (let view of pose.views) {
                        let viewport = glLayer.getViewport(view);

                        let transform = view.transform;
                        let elmView = { eye :
                              view.eye === "left"
                                  ? $lamdera$program_test$Effect$Internal$LeftEye
                                  : view.eye === "right"
                                      ? $lamdera$program_test$Effect$Internal$RightEye
                                      : $lamdera$program_test$Effect$Internal$OtherEye
                              , projectionMatrix : new Float64Array(view.projectionMatrix)
                              , viewMatrix : new Float64Array(transform.inverse.matrix)
                              };
                        elmViews.push(elmView);

                        xrGl.viewport(viewport.x, viewport.y, viewport.width, viewport.height);
                        xrDrawGL(entities({ time : xrStartTime + time, xrView : elmView, inputs : inputs }), xrModel);
                    }

                    //console.log(createImageFromFramebuffer(xrGl, 2064, 2208));

                    let poseData = { transform : new Float64Array(pose.transform.matrix)
                        , views : _List_fromArray(elmViews)
                        , time : xrStartTime + time
                        , boundary : $elm$core$Maybe$Nothing
                        , inputs : inputs
                        };

                    if (xrReferenceSpace.boundsGeometry) {
                         poseData.boundary = $elm$core$Maybe$Just(_List_fromArray(xrReferenceSpace.boundsGeometry.map((p) => { return A2(_MJS_v2, p.x, -p.z); })));
                    }

                    callback(_Scheduler_succeed(poseData));
                }
                else {
                    callback(_Scheduler_fail($lamdera$program_test$Effect$Internal$XrLostTracking));
                }

            });
        }
        else {
            callback(_Scheduler_fail($lamdera$program_test$Effect$Internal$XrSessionNotStarted));
        }
    });
}

/**
 *  Creates canvas and schedules initial _WebGLFix_drawGL
 *  @param {Object} model
 *  @param {Object} model.f that may contain the following properties:
           gl, shaders, programs, buffers, textures
 *  @param {List<Option>} model.h list of options coming from Elm
 */
function xrRender(model) {
  var options = {
    contextAttributes: {
      alpha: false,
      depth: false,
      stencil: false,
      antialias: false,
      premultipliedAlpha: false,
      preserveDrawingBuffer: false
    },
    sceneSettings: []
  };

  _WebGLFix_listEach(function (option) {
    return A2($lamdera$program_test$WebGLFix$Internal$enableOption, options, option);
  }, model.h);

  var gl = xrGl;

  // Activate extensions
  gl.getExtension('OES_standard_derivatives');
  gl.getExtension('OES_element_index_uint');
  gl.getExtension("EXT_frag_depth");

  if (gl && typeof WeakMap !== 'undefined') {
    options.sceneSettings.forEach(function (sceneSetting) {
      sceneSetting(gl);
    });

    model.f.gl = gl;

    // Cache the current settings in order to diff them to avoid redundant calls
    // https://emscripten.org/docs/optimizing/Optimizing-WebGL.html#avoid-redundant-calls
    model.f.toggle = false; // used to diff the settings from the previous and current draw calls
    model.f.blend = { enabled: false, toggle: false };
    model.f.depthTest = { enabled: false, toggle: false };
    model.f.stencilTest = { enabled: false, toggle: false };
    model.f.scissor = { enabled: false, toggle: false };
    model.f.colorMask = { enabled: false, toggle: false };
    model.f.cullFace = { enabled: false, toggle: false };
    model.f.polygonOffset = { enabled: false, toggle: false };
    model.f.sampleCoverage = { enabled: false, toggle: false };
    model.f.sampleAlphaToCoverage = { enabled: false, toggle: false };

    model.f.shaders = [];
    model.f.programs = {};
    model.f.lastProgId = null;
    model.f.buffers = new WeakMap();
    model.f.textures = new WeakMap();
    // Memorize the initial stencil write mask, because
    // browsers may have different number of stencil bits
    model.f.STENCIL_WRITEMASK = gl.getParameter(gl.STENCIL_WRITEMASK);
  }
}

var xrDrawGL = function (entities, model) {
  var cache = model.f;
  var gl = cache.gl;

  if (!cache.depthTest.b) {
    gl.depthMask(true);
    cache.depthTest.b = true;
  }
  if (cache.stencilTest.c !== cache.STENCIL_WRITEMASK) {
    gl.stencilMask(cache.STENCIL_WRITEMASK);
    cache.stencilTest.c = cache.STENCIL_WRITEMASK;
  }
  _WebGLFix_disableScissor(cache);
  _WebGLFix_disableColorMask(cache);


  function drawEntity(entity) {
    if (!entity.d.b.b) {
      return; // Empty list
    }

    var progid;
    var program;
    var i;

    if (entity.b.id && entity.c.id) {
      progid = _WebGLFix_getProgID(entity.b.id, entity.c.id);
      program = cache.programs[progid];
    }

    if (!program) {

      var vshader;
      if (entity.b.id) {
        vshader = cache.shaders[entity.b.id];
      } else {
        entity.b.id = _WebGLFix_guid++;
      }

      if (!vshader) {
        vshader = _WebGLFix_doCompile(gl, entity.b.src, gl.VERTEX_SHADER);
        cache.shaders[entity.b.id] = vshader;
      }

      var fshader;
      if (entity.c.id) {
        fshader = cache.shaders[entity.c.id];
      } else {
        entity.c.id = _WebGLFix_guid++;
      }

      if (!fshader) {
        fshader = _WebGLFix_doCompile(gl, entity.c.src, gl.FRAGMENT_SHADER);
        cache.shaders[entity.c.id] = fshader;
      }

      var glProgram = _WebGLFix_doLink(gl, vshader, fshader);

      program = {
        glProgram: glProgram,
        attributes: Object.assign({}, entity.b.attributes, entity.c.attributes),
        currentUniforms: {},
        activeAttributes: [],
        activeAttributeLocations: []
      };

      program.uniformSetters = _WebGLFix_createUniformSetters(
        gl,
        model,
        program,
        Object.assign({}, entity.b.uniforms, entity.c.uniforms)
      );

      var numActiveAttributes = gl.getProgramParameter(glProgram, gl.ACTIVE_ATTRIBUTES);
      for (i = 0; i < numActiveAttributes; i++) {
        var attribute = gl.getActiveAttrib(glProgram, i);
        var attribLocation = gl.getAttribLocation(glProgram, attribute.name);
        program.activeAttributes.push(attribute);
        program.activeAttributeLocations.push(attribLocation);
      }

      progid = _WebGLFix_getProgID(entity.b.id, entity.c.id);
      cache.programs[progid] = program;
    }

    if (cache.lastProgId !== progid) {
      gl.useProgram(program.glProgram);
      cache.lastProgId = progid;
    }

    _WebGLFix_setUniforms(program.uniformSetters, entity.e);

    var buffer = cache.buffers.get(entity.d);

    if (!buffer) {
      buffer = _WebGLFix_doBindSetup(gl, entity.d);
      cache.buffers.set(entity.d, buffer);
    }

    for (i = 0; i < program.activeAttributes.length; i++) {
      attribute = program.activeAttributes[i];
      attribLocation = program.activeAttributeLocations[i];

      if (buffer.buffers[attribute.name] === undefined) {
        buffer.buffers[attribute.name] = _WebGLFix_doBindAttribute(gl, attribute, entity.d, program.attributes);
      }
      gl.bindBuffer(gl.ARRAY_BUFFER, buffer.buffers[attribute.name]);

      var attributeInfo = _WebGLFix_getAttributeInfo(gl, attribute.type);
      if (attributeInfo.arraySize === 1) {
        gl.enableVertexAttribArray(attribLocation);
        gl.vertexAttribPointer(attribLocation, attributeInfo.size, attributeInfo.baseType, false, 0, 0);
      } else {
        // Point to four vec4 in case of mat4
        var offset = attributeInfo.size * 4; // float32 takes 4 bytes
        var stride = offset * attributeInfo.arraySize;
        for (var m = 0; m < attributeInfo.arraySize; m++) {
          gl.enableVertexAttribArray(attribLocation + m);
          gl.vertexAttribPointer(attribLocation + m, attributeInfo.size, attributeInfo.baseType, false, stride, offset * m);
        }
      }
    }

    // Apply all the new settings
    cache.toggle = !cache.toggle;
    _WebGLFix_listEach($lamdera$program_test$WebGLFix$Internal$enableSetting(cache), entity.a);
    // Disable the settings that were applied in the previous draw call
    for (i = 0; i < _WebGLFix_settings.length; i++) {
      var setting = cache[_WebGLFix_settings[i]];
      if (setting.toggle !== cache.toggle && setting.enabled) {
        _WebGLFix_disableFunctions[i](cache);
        setting.enabled = false;
        setting.toggle = cache.toggle;
      }
    }

    if (buffer.indexBuffer) {
      gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, buffer.indexBuffer);
      gl.drawElements(entity.d.a.mode, buffer.numIndices, gl.UNSIGNED_INT, 0);
    } else {
      gl.drawArrays(entity.d.a.mode, 0, buffer.numIndices);
    }
  }

  _WebGLFix_listEach(drawEntity, entities);
}


function createImageFromFramebuffer(gl, width, height) {
    // Read the contents of the framebuffer
    var data = new Uint8Array(width * height * 4);
    gl.readPixels(0, 0, width, height, gl.RGBA, gl.UNSIGNED_BYTE, data);

    // Create a 2D canvas to store the result
    var canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    var context = canvas.getContext('2d');

    // Copy the pixels to a 2D canvas
    var imageData = context.createImageData(width, height);
    imageData.data.set(data);
    context.putImageData(imageData, 0, 0);

    var img = new Image();
    return canvas.toDataURL();
}


function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}


// eslint-disable-next-line no-unused-vars
var _TextureFix_load = F7(function (magnify, mininify, horizontalWrap, verticalWrap, flipY, premultiplyAlpha, url) {
  var isMipmap = mininify !== 9728 && mininify !== 9729;
  return _Scheduler_binding(function (callback) {
    var img = new Image();
    function createTexture(gl) {
      var texture = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, texture);
      gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, flipY);
      gl.pixelStorei(gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, false);
      gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, premultiplyAlpha);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, img);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, magnify);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, mininify);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, horizontalWrap);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, verticalWrap);
      if (isMipmap) {
        gl.generateMipmap(gl.TEXTURE_2D);
      }
      gl.bindTexture(gl.TEXTURE_2D, null);
      return texture;
    }
    img.onload = function () {
      var width = img.width;
      var height = img.height;
      var widthPowerOfTwo = (width & (width - 1)) === 0;
      var heightPowerOfTwo = (height & (height - 1)) === 0;
      var isSizeValid = (widthPowerOfTwo && heightPowerOfTwo) || (
        !isMipmap
        && horizontalWrap === 33071 // clamp to edge
        && verticalWrap === 33071
      );
      if (isSizeValid) {
        callback(_Scheduler_succeed({
          $: 0,
          createTexture: createTexture,
          a: width,
          b: height
        }));
      } else {
        callback(_Scheduler_fail(A2(
          $lamdera$program_test$WebGLFix$Texture$SizeError,
          width,
          height
        )));
      }
    };
    img.onerror = function () {
      callback(_Scheduler_fail($lamdera$program_test$WebGLFix$Texture$LoadError));
    };
    if (url.slice(0, 5) !== 'data:') {
      img.crossOrigin = 'Anonymous';
    }
    img.src = url;
  });
});

// eslint-disable-next-line no-unused-vars
var _TextureFix_size = function (texture) {
  return _Utils_Tuple2(texture.a, texture.b);
};


//Texture Loading from Bytes

// eslint-disable-next-line no-unused-vars
var _TextureFix_loadBytes = F9(function (magnify, mininify, horizontalWrap, verticalWrap, flipY, width, height, tuple, bytes) {
  function createTexture(gl) {
    var texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, flipY);
    gl.pixelStorei(gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, false);
    gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, tuple.b);
    gl.texImage2D(gl.TEXTURE_2D, 0, tuple.a, width, height, 0, tuple.a, gl.UNSIGNED_BYTE, new Uint8Array(bytes.buffer));
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, magnify);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, mininify);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, horizontalWrap);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, verticalWrap);
    if (mininify !== 9728 && mininify !== 9729) {
      gl.generateMipmap(gl.TEXTURE_2D);
    }
    gl.bindTexture(gl.TEXTURE_2D, null);
    return texture;
  }
  return {
    $: 0,
    createTexture: createTexture,
    a: width,
    b: height
  };
});


function _Lamdera_unsafeCoerce(a)
{
	return a
}


var _Lamdera_debugS = F2(function(l, a)
{
	window.localStorage.setItem("lamdera-debug-" + l, JSON.stringify(a))
	return a
})


var _Lamdera_debugR = F2(function(l, oldRecord)
{
	var data = window.localStorage.getItem("lamdera-debug-" + l)

	if (data === null) {
		return $elm$core$Maybe$Nothing
	} else {
		var newRecord = {}
		var restoredFields = JSON.parse(data)
		for (var key in oldRecord) { newRecord[key] = oldRecord[key] }
		for (var key in restoredFields) { newRecord[key] = restoredFields[key] }
		return $elm$core$Maybe$Just(newRecord)
	}
})


var _Lamdera_debugD = function(l)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		localStorage.removeItem("lamdera-debug-" + l)
	}))
}

var _Lamdera_decoderBytes = _Json_decodePrim(function(value)
{
  try {
	if (typeof value === 'object' && value instanceof DataView) return $elm$core$Result$Ok(value)
	if (typeof value === 'object' && value instanceof Buffer) {
		// https://stackoverflow.com/a/31394257
		return $elm$core$Result$Ok(new DataView(value.buffer, value.byteOffset, value.byteLength))
	}
	return _Json_expecting('a DataView or Buffer', value);
  } catch (err) {
	return _Json_expecting('a DataView or Buffer, but got an exception', err.toString());
  }
});

var _Lamdera_log = F2(function (s, a) {
  console.log(`[log]`, s, a);
  return a
})
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr$ = function (func, baseCase, _v0) {
	var tree = _v0.c;
	var tail = _v0.d;
	var helper = F2(
		function (node, acc) {
			if (!node.$) {
				var subTree = node.a;
				return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
			} else {
				var values = node.a;
				return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
			}
		});
	return A3(
		$elm$core$Elm$JsArray$foldr,
		helper,
		A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
		tree);
};
var $elm$core$Array$foldr = F3($elm$core$Array$foldr$);
var $elm$core$Array$toList = function (array) {
	return $elm$core$Array$foldr$($elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr$ = function (func, acc, t) {
	foldr:
	while (true) {
		if (t.$ === -2) {
			return acc;
		} else {
			var key = t.b;
			var value = t.c;
			var left = t.d;
			var right = t.e;
			var $temp$acc = A3(
				func,
				key,
				value,
				$elm$core$Dict$foldr$(func, acc, right)),
				$temp$t = left;
			acc = $temp$acc;
			t = $temp$t;
			continue foldr;
		}
	}
};
var $elm$core$Dict$foldr = F3($elm$core$Dict$foldr$);
var $elm$core$Dict$toList = function (dict) {
	return $elm$core$Dict$foldr$(
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return $elm$core$Dict$foldr$(
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $elm$json$Json$Decode$Failure = F2($elm$json$Json$Decode$Failure$);
var $elm$json$Json$Decode$Field$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $elm$json$Json$Decode$Field = F2($elm$json$Json$Decode$Field$);
var $elm$json$Json$Decode$Index$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $elm$json$Json$Decode$Index = F2($elm$json$Json$Decode$Index$);
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join$ = function (sep, chunks) {
	return A2(
		_String_join,
		sep,
		_List_toArray(chunks));
};
var $elm$core$String$join = F2($elm$core$String$join$);
var $elm$core$String$split$ = function (sep, string) {
	return _List_fromArray(
		A2(_String_split, sep, string));
};
var $elm$core$String$split = F2($elm$core$String$split$);
var $elm$json$Json$Decode$indent = function (str) {
	return $elm$core$String$join$(
		'\u000A    ',
		$elm$core$String$split$('\u000A', str));
};
var $elm$core$List$foldl$ = function (func, acc, list) {
	foldl:
	while (true) {
		if (!list.b) {
			return acc;
		} else {
			var x = list.a;
			var xs = list.b;
			var $temp$acc = A2(func, x, acc),
				$temp$list = xs;
			acc = $temp$acc;
			list = $temp$list;
			continue foldl;
		}
	}
};
var $elm$core$List$foldl = F3($elm$core$List$foldl$);
var $elm$core$List$length = function (xs) {
	return $elm$core$List$foldl$(
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp$ = function (lo, hi, list) {
	rangeHelp:
	while (true) {
		if (_Utils_cmp(lo, hi) < 1) {
			var $temp$hi = hi - 1,
				$temp$list = A2($elm$core$List$cons, hi, list);
			hi = $temp$hi;
			list = $temp$list;
			continue rangeHelp;
		} else {
			return list;
		}
	}
};
var $elm$core$List$rangeHelp = F3($elm$core$List$rangeHelp$);
var $elm$core$List$range$ = function (lo, hi) {
	return $elm$core$List$rangeHelp$(lo, hi, _List_Nil);
};
var $elm$core$List$range = F2($elm$core$List$range$);
var $elm$core$List$indexedMap$ = function (f, xs) {
	return A3(
		$elm$core$List$map2,
		f,
		$elm$core$List$range$(
			0,
			$elm$core$List$length(xs) - 1),
		xs);
};
var $elm$core$List$indexedMap = F2($elm$core$List$indexedMap$);
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return $elm$core$List$foldl$($elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf$ = function (i, error) {
	return '\u000A\u000A(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
		$elm$json$Json$Decode$errorToString(error))));
};
var $elm$json$Json$Decode$errorOneOf = F2($elm$json$Json$Decode$errorOneOf$);
var $elm$json$Json$Decode$errorToString = function (error) {
	return $elm$json$Json$Decode$errorToStringHelp$(error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp$ = function (error, context) {
	errorToStringHelp:
	while (true) {
		switch (error.$) {
			case 0:
				var f = error.a;
				var err = error.b;
				var isSimple = function () {
					var _v1 = $elm$core$String$uncons(f);
					if (_v1.$ === 1) {
						return false;
					} else {
						var _v2 = _v1.a;
						var _char = _v2.a;
						var rest = _v2.b;
						return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
					}
				}();
				var fieldName = isSimple ? ('.' + f) : ('[\u0027' + (f + '\u0027]'));
				var $temp$error = err,
					$temp$context = A2($elm$core$List$cons, fieldName, context);
				error = $temp$error;
				context = $temp$context;
				continue errorToStringHelp;
			case 1:
				var i = error.a;
				var err = error.b;
				var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
				var $temp$error = err,
					$temp$context = A2($elm$core$List$cons, indexName, context);
				error = $temp$error;
				context = $temp$context;
				continue errorToStringHelp;
			case 2:
				var errors = error.a;
				if (!errors.b) {
					return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
						if (!context.b) {
							return '!';
						} else {
							return ' at json' + $elm$core$String$join$(
								'',
								$elm$core$List$reverse(context));
						}
					}();
				} else {
					if (!errors.b.b) {
						var err = errors.a;
						var $temp$error = err;
						error = $temp$error;
						continue errorToStringHelp;
					} else {
						var starter = function () {
							if (!context.b) {
								return 'Json.Decode.oneOf';
							} else {
								return 'The Json.Decode.oneOf at json' + $elm$core$String$join$(
									'',
									$elm$core$List$reverse(context));
							}
						}();
						var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
							$elm$core$List$length(errors)) + ' ways:'));
						return $elm$core$String$join$(
							'\u000A\u000A',
							A2(
								$elm$core$List$cons,
								introduction,
								$elm$core$List$indexedMap$($elm$json$Json$Decode$errorOneOf, errors)));
					}
				}
			default:
				var msg = error.a;
				var json = error.b;
				var introduction = function () {
					if (!context.b) {
						return 'Problem with the given value:\u000A\u000A';
					} else {
						return 'Problem with the value at json' + ($elm$core$String$join$(
							'',
							$elm$core$List$reverse(context)) + ':\u000A\u000A    ');
					}
				}();
				return introduction + ($elm$json$Json$Decode$indent(
					A2($elm$json$Json$Encode$encode, 4, json)) + ('\u000A\u000A' + msg));
		}
	}
};
var $elm$json$Json$Decode$errorToStringHelp = F2($elm$json$Json$Decode$errorToStringHelp$);
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin$ = function (a, b, c, d) {
	return {$: 0, a: a, b: b, c: c, d: d};
};
var $elm$core$Array$Array_elm_builtin = F4($elm$core$Array$Array_elm_builtin$);
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase$ = function (base, number) {
	return _Basics_log(number) / _Basics_log(base);
};
var $elm$core$Basics$logBase = F2($elm$core$Basics$logBase$);
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	$elm$core$Basics$logBase$(2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = $elm$core$Array$Array_elm_builtin$(0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL$ = function (f, x) {
	return f(x);
};
var $elm$core$Basics$apL = F2($elm$core$Basics$apL$);
var $elm$core$Basics$apR$ = function (x, f) {
	return f(x);
};
var $elm$core$Basics$apR = F2($elm$core$Basics$apR$);
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max$ = function (x, y) {
	return (_Utils_cmp(x, y) > 0) ? x : y;
};
var $elm$core$Basics$max = F2($elm$core$Basics$max$);
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes$ = function (nodes, acc) {
	compressNodes:
	while (true) {
		var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
		var node = _v0.a;
		var remainingNodes = _v0.b;
		var newAcc = A2(
			$elm$core$List$cons,
			$elm$core$Array$SubTree(node),
			acc);
		if (!remainingNodes.b) {
			return $elm$core$List$reverse(newAcc);
		} else {
			var $temp$nodes = remainingNodes,
				$temp$acc = newAcc;
			nodes = $temp$nodes;
			acc = $temp$acc;
			continue compressNodes;
		}
	}
};
var $elm$core$Array$compressNodes = F2($elm$core$Array$compressNodes$);
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder$ = function (nodeList, nodeListSize) {
	treeFromBuilder:
	while (true) {
		var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
		if (newNodeSize === 1) {
			return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
		} else {
			var $temp$nodeList = $elm$core$Array$compressNodes$(nodeList, _List_Nil),
				$temp$nodeListSize = newNodeSize;
			nodeList = $temp$nodeList;
			nodeListSize = $temp$nodeListSize;
			continue treeFromBuilder;
		}
	}
};
var $elm$core$Array$treeFromBuilder = F2($elm$core$Array$treeFromBuilder$);
var $elm$core$Array$builderToArray$ = function (reverseNodeList, builder) {
	if (!builder.nodeListSize) {
		return $elm$core$Array$Array_elm_builtin$(
			$elm$core$Elm$JsArray$length(builder.tail),
			$elm$core$Array$shiftStep,
			$elm$core$Elm$JsArray$empty,
			builder.tail);
	} else {
		var treeLen = builder.nodeListSize * $elm$core$Array$branchFactor;
		var depth = $elm$core$Basics$floor(
			$elm$core$Basics$logBase$($elm$core$Array$branchFactor, treeLen - 1));
		var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.nodeList) : builder.nodeList;
		var tree = $elm$core$Array$treeFromBuilder$(correctNodeList, builder.nodeListSize);
		return $elm$core$Array$Array_elm_builtin$(
			$elm$core$Elm$JsArray$length(builder.tail) + treeLen,
			$elm$core$Basics$max$(5, depth * $elm$core$Array$shiftStep),
			tree,
			builder.tail);
	}
};
var $elm$core$Array$builderToArray = F2($elm$core$Array$builderToArray$);
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp$ = function (fn, fromIndex, len, nodeList, tail) {
	initializeHelp:
	while (true) {
		if (fromIndex < 0) {
			return $elm$core$Array$builderToArray$(
				false,
				{nodeList: nodeList, nodeListSize: (len / $elm$core$Array$branchFactor) | 0, tail: tail});
		} else {
			var leaf = $elm$core$Array$Leaf(
				A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
			var $temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
				$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList);
			fromIndex = $temp$fromIndex;
			nodeList = $temp$nodeList;
			continue initializeHelp;
		}
	}
};
var $elm$core$Array$initializeHelp = F5($elm$core$Array$initializeHelp$);
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize$ = function (len, fn) {
	if (len <= 0) {
		return $elm$core$Array$empty;
	} else {
		var tailLen = len % $elm$core$Array$branchFactor;
		var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
		var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
		return $elm$core$Array$initializeHelp$(fn, initialFromIndex, len, _List_Nil, tail);
	}
};
var $elm$core$Array$initialize = F2($elm$core$Array$initialize$);
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $ianmackenzie$elm_units$Quantity$Quantity = $elm$core$Basics$identity;
var $ianmackenzie$elm_units$Quantity$zero = 0;
var $author$project$Audio$audioDefaultConfig = {loop: $elm$core$Maybe$Nothing, playbackRate: 1, startAt: $ianmackenzie$elm_units$Quantity$zero};
var $author$project$Audio$BasicAudio = function (a) {
	return {$: 1, a: a};
};
var $author$project$Audio$audioWithConfig$ = function (audioSettings, source, startTime) {
	return $author$project$Audio$BasicAudio(
		{settings: audioSettings, source: source, startTime: startTime});
};
var $author$project$Audio$audioWithConfig = F3($author$project$Audio$audioWithConfig$);
var $author$project$Audio$audio$ = function (source, startTime) {
	return $author$project$Audio$audioWithConfig$($author$project$Audio$audioDefaultConfig, source, startTime);
};
var $author$project$Audio$audio = F2($author$project$Audio$audio$);
var $author$project$Audio$Group = function (a) {
	return {$: 0, a: a};
};
var $author$project$Audio$group = function (audios) {
	return $author$project$Audio$Group(audios);
};
var $author$project$Audio$silence = $author$project$Audio$group(_List_Nil);
var $author$project$Go$audio$ = function (popSound, model) {
	var _v0 = model.lastPlacedStone;
	if (!_v0.$) {
		var placedAt = _v0.a;
		return $author$project$Audio$audio$(popSound, placedAt);
	} else {
		return $author$project$Audio$silence;
	}
};
var $author$project$Go$audio = F2($author$project$Go$audio$);
var $ianmackenzie$elm_units$Duration$inSeconds = function (_v0) {
	var numSeconds = _v0;
	return numSeconds;
};
var $ianmackenzie$elm_units$Duration$inMilliseconds = function (duration) {
	return $ianmackenzie$elm_units$Duration$inSeconds(duration) * 1000;
};
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$core$Basics$round = _Basics_round;
var $ianmackenzie$elm_units$Duration$addTo$ = function (time, duration) {
	return $elm$time$Time$millisToPosix(
		$elm$time$Time$posixToMillis(time) + $elm$core$Basics$round(
			$ianmackenzie$elm_units$Duration$inMilliseconds(duration)));
};
var $ianmackenzie$elm_units$Duration$addTo = F2($ianmackenzie$elm_units$Duration$addTo$);
var $elmcraft$core_extra$List$Extra$find$ = function (predicate, list) {
	find:
	while (true) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var first = list.a;
			var rest = list.b;
			if (predicate(first)) {
				return $elm$core$Maybe$Just(first);
			} else {
				var $temp$list = rest;
				list = $temp$list;
				continue find;
			}
		}
	}
};
var $elmcraft$core_extra$List$Extra$find = F2($elmcraft$core_extra$List$Extra$find$);
var $mgold$elm_nonempty_list$List$Nonempty$toList = function (_v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return A2($elm$core$List$cons, x, xs);
};
var $author$project$WordSpellingGame$getPlayer$ = function (userId, shared) {
	return $elmcraft$core_extra$List$Extra$find$(
		function (player) {
			return _Utils_eq(player.userId, userId);
		},
		$mgold$elm_nonempty_list$List$Nonempty$toList(shared.players));
};
var $author$project$WordSpellingGame$getPlayer = F2($author$project$WordSpellingGame$getPlayer$);
var $elm$core$List$foldrHelper$ = function (fn, acc, ctr, ls) {
	if (!ls.b) {
		return acc;
	} else {
		var a = ls.a;
		var r1 = ls.b;
		if (!r1.b) {
			return A2(fn, a, acc);
		} else {
			var b = r1.a;
			var r2 = r1.b;
			if (!r2.b) {
				return A2(
					fn,
					a,
					A2(fn, b, acc));
			} else {
				var c = r2.a;
				var r3 = r2.b;
				if (!r3.b) {
					return A2(
						fn,
						a,
						A2(
							fn,
							b,
							A2(fn, c, acc)));
				} else {
					var d = r3.a;
					var r4 = r3.b;
					var res = (ctr > 500) ? $elm$core$List$foldl$(
						fn,
						acc,
						$elm$core$List$reverse(r4)) : $elm$core$List$foldrHelper$(fn, acc, ctr + 1, r4);
					return A2(
						fn,
						a,
						A2(
							fn,
							b,
							A2(
								fn,
								c,
								A2(fn, d, res))));
				}
			}
		}
	}
};
var $elm$core$List$foldrHelper = F4($elm$core$List$foldrHelper$);
var $elm$core$List$foldr$ = function (fn, acc, ls) {
	return $elm$core$List$foldrHelper$(fn, acc, 0, ls);
};
var $elm$core$List$foldr = F3($elm$core$List$foldr$);
var $elm$core$List$map$ = function (f, xs) {
	return $elm$core$List$foldr$(
		F2(
			function (x, acc) {
				return A2(
					$elm$core$List$cons,
					f(x),
					acc);
			}),
		_List_Nil,
		xs);
};
var $elm$core$List$map = F2($elm$core$List$map$);
var $ianmackenzie$elm_units$Quantity$multiplyBy$ = function (scale, _v0) {
	var value = _v0;
	return scale * value;
};
var $ianmackenzie$elm_units$Quantity$multiplyBy = F2($ianmackenzie$elm_units$Quantity$multiplyBy$);
var $ianmackenzie$elm_units$Quantity$plus$ = function (_v0, _v1) {
	var y = _v0;
	var x = _v1;
	return x + y;
};
var $ianmackenzie$elm_units$Quantity$plus = F2($ianmackenzie$elm_units$Quantity$plus$);
var $ianmackenzie$elm_units$Duration$seconds = function (numSeconds) {
	return numSeconds;
};
var $ianmackenzie$elm_units$Duration$milliseconds = function (numMilliseconds) {
	return $ianmackenzie$elm_units$Duration$seconds(0.001 * numMilliseconds);
};
var $author$project$WordSpellingGame$tileFadeDelay = $ianmackenzie$elm_units$Duration$milliseconds(1000);
var $author$project$WordSpellingGame$tileSlideDuration = $ianmackenzie$elm_units$Duration$milliseconds(250);
var $author$project$WordSpellingGame$tileSlideStagger = $ianmackenzie$elm_units$Duration$milliseconds(80);
var $author$project$WordSpellingGame$audio$ = function (popSound, currentUserId, shared, model) {
	return $author$project$Audio$group(
		_List_fromArray(
			[
				function () {
				var _v0 = $author$project$WordSpellingGame$getPlayer$(currentUserId, shared);
				if (!_v0.$) {
					return $author$project$Audio$group(
						$elm$core$List$map$(
							function (tile) {
								return $author$project$Audio$group(
									_List_fromArray(
										[
											$author$project$Audio$audio$(
											popSound,
											$ianmackenzie$elm_units$Duration$addTo$(tile.createdAt, $author$project$WordSpellingGame$tileFadeDelay)),
											function () {
											var _v1 = tile.position;
											if (!_v1.$) {
												return $author$project$Audio$silence;
											} else {
												var placedAt = _v1.b;
												return $author$project$Audio$audio$(popSound, placedAt);
											}
										}()
										]));
							},
							$elm$core$Array$toList(model.tiles)));
				} else {
					return $author$project$Audio$silence;
				}
			}(),
				function () {
				var _v2 = model.lastWordPlaced;
				if (!_v2.$) {
					var letterCount = _v2.a.letterCount;
					var time = _v2.a.time;
					return $author$project$Audio$group(
						$elm$core$List$map$(
							function (index) {
								return $author$project$Audio$audio$(
									popSound,
									$ianmackenzie$elm_units$Duration$addTo$(
										time,
										$ianmackenzie$elm_units$Quantity$plus$(
											$author$project$WordSpellingGame$tileSlideDuration,
											$ianmackenzie$elm_units$Quantity$multiplyBy$(index, $author$project$WordSpellingGame$tileSlideStagger))));
							},
							$elm$core$List$range$(0, letterCount - 1)));
				} else {
					return $author$project$Audio$silence;
				}
			}()
			]));
};
var $author$project$WordSpellingGame$audio = F4($author$project$WordSpellingGame$audio$);
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $lamdera$containers$SeqDict$shiftStep = 5;
var $lamdera$containers$SeqDict$bitMask = 4294967295 >>> (32 - $lamdera$containers$SeqDict$shiftStep);
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $lamdera$containers$SeqDict$compressedIndex$ = function (index, bitmap) {
	var relevantBits = (bitmap << (31 - index)) << 1;
	var b1 = relevantBits - ((relevantBits >>> 1) & 1431655765);
	var b2 = (b1 & 858993459) + ((b1 >>> 2) & 858993459);
	return (((b2 + (b2 >>> 4)) & 252645135) * 16843009) >>> 24;
};
var $lamdera$containers$SeqDict$compressedIndex = F2($lamdera$containers$SeqDict$compressedIndex$);
var $lamdera$containers$SeqDict$listFind$ = function (predicate, list) {
	listFind:
	while (true) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var first = list.a;
			var rest = list.b;
			if (predicate(first)) {
				return $elm$core$Maybe$Just(first);
			} else {
				var $temp$list = rest;
				list = $temp$list;
				continue listFind;
			}
		}
	}
};
var $lamdera$containers$SeqDict$listFind = F2($lamdera$containers$SeqDict$listFind$);
var $lamdera$containers$JsArray2$unsafeGet = _JsArray2_unsafeGet;
var $lamdera$containers$SeqDict$getHelp$ = function (shift, hash, key, bitmap, nodes) {
	getHelp:
	while (true) {
		var index = $lamdera$containers$SeqDict$bitMask & (hash >>> shift);
		var mask = 1 << index;
		if (_Utils_eq(bitmap & mask, mask)) {
			var _v0 = A2(
				$lamdera$containers$JsArray2$unsafeGet,
				$lamdera$containers$SeqDict$compressedIndex$(index, bitmap),
				nodes);
			switch (_v0.$) {
				case 0:
					var eIdx = _v0.b;
					var eKey = _v0.c;
					var eVal = _v0.d;
					return _Utils_eq(key, eKey) ? $elm$core$Maybe$Just(eVal) : $elm$core$Maybe$Nothing;
				case 1:
					var subBitmap = _v0.a;
					var subNodes = _v0.b;
					var $temp$shift = shift + $lamdera$containers$SeqDict$shiftStep,
						$temp$bitmap = subBitmap,
						$temp$nodes = subNodes;
					shift = $temp$shift;
					bitmap = $temp$bitmap;
					nodes = $temp$nodes;
					continue getHelp;
				default:
					var vals = _v0.b;
					var _v1 = $lamdera$containers$SeqDict$listFind$(
						function (_v2) {
							var k = _v2.b;
							return _Utils_eq(k, key);
						},
						vals);
					if (!_v1.$) {
						var _v3 = _v1.a;
						var val = _v3.c;
						return $elm$core$Maybe$Just(val);
					} else {
						return $elm$core$Maybe$Nothing;
					}
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $lamdera$containers$SeqDict$getHelp = F5($lamdera$containers$SeqDict$getHelp$);
var $lamdera$containers$SeqDict$intDictFoldr$ = function (func, baseCase, dict) {
	return $elm$core$Array$foldr$(
		F2(
			function (maybe, acc) {
				if (!maybe.$) {
					var a = maybe.a;
					return A2(func, a, acc);
				} else {
					return acc;
				}
			}),
		baseCase,
		dict.array);
};
var $lamdera$containers$SeqDict$intDictFoldr = F3($lamdera$containers$SeqDict$intDictFoldr$);
var $lamdera$containers$SeqDict$toList = function (_v0) {
	var triplets = _v0.c;
	var helper = F2(
		function (_v1, acc) {
			var key = _v1.b;
			var value = _v1.c;
			return A2(
				$elm$core$List$cons,
				_Utils_Tuple2(key, value),
				acc);
		});
	return $lamdera$containers$SeqDict$intDictFoldr$(helper, _List_Nil, triplets);
};
var $lamdera$containers$SeqDict$keys = function (_v0) {
	var triplets = _v0.c;
	var helper = F2(
		function (_v1, acc) {
			var key = _v1.b;
			return A2($elm$core$List$cons, key, acc);
		});
	return $lamdera$containers$SeqDict$intDictFoldr$(helper, _List_Nil, triplets);
};
var $lamdera$containers$SeqSet$toList = function (_v0) {
	var dict = _v0;
	return $lamdera$containers$SeqDict$keys(dict);
};
var $lamdera$containers$FNV$hash = _FNV_hash;
var $lamdera$containers$SeqDict$get$ = function (key, _v0) {
	var bitmap = _v0.a;
	var nodes = _v0.b;
	return $lamdera$containers$SeqDict$getHelp$(
		0,
		$lamdera$containers$FNV$hash(key),
		key,
		bitmap,
		nodes);
};
var $lamdera$containers$SeqDict$get = F2($lamdera$containers$SeqDict$get$);
var $author$project$Game$audio$ = function (popSound, currentUserId, matchId, matchData, model) {
	if (!matchData.$) {
		var matchData2 = matchData.a;
		var _v1 = matchData2.data;
		switch (_v1.$) {
			case 0:
				var _v2 = $lamdera$containers$SeqDict$get$(matchId, model.startedGames);
				if ((!_v2.$) && (!_v2.a.$)) {
					var model2 = _v2.a.a;
					return $author$project$Go$audio$(popSound, model2);
				} else {
					return $author$project$Audio$silence;
				}
			case 1:
				var shared = _v1.c;
				var _v3 = $lamdera$containers$SeqDict$get$(matchId, model.startedGames);
				if ((!_v3.$) && (_v3.a.$ === 1)) {
					var model2 = _v3.a.a;
					return $author$project$WordSpellingGame$audio$(popSound, currentUserId, shared, model2);
				} else {
					return $author$project$Audio$silence;
				}
			default:
				return $author$project$Audio$silence;
		}
	} else {
		return $author$project$Audio$silence;
	}
};
var $author$project$Game$audio = F5($author$project$Game$audio$);
var $author$project$Id$GuildOrDmId_Dm = function (a) {
	return {$: 1, a: a};
};
var $author$project$Id$GuildOrDmId_Guild = function (a) {
	return {$: 0, a: a};
};
var $author$project$DmChannel$E2eeDisabled = function (a) {
	return {$: 0, a: a};
};
var $author$project$MessageArray$MessageArray = $elm$core$Basics$identity;
var $author$project$MessageArray$empty = {end: 0, runs: $elm$core$Array$empty, start: 0};
var $lamdera$containers$SeqDict$SeqDict_elm_builtin$ = function (a, b, c) {
	return {$: -11, a: a, b: b, c: c};
};
var $lamdera$containers$SeqDict$SeqDict_elm_builtin = F3($lamdera$containers$SeqDict$SeqDict_elm_builtin$);
var $lamdera$containers$JsArray2$empty = _JsArray2_empty;
var $lamdera$containers$SeqDict$intDictEmpty = {array: $elm$core$Array$empty, size: 0};
var $lamdera$containers$SeqDict$empty = $lamdera$containers$SeqDict$SeqDict_elm_builtin$(0, $lamdera$containers$JsArray2$empty, $lamdera$containers$SeqDict$intDictEmpty);
var $author$project$Id$Id = $elm$core$Basics$identity;
var $author$project$Id$fromInt = $elm$core$Basics$identity;
var $author$project$VisibleMessages$empty = {
	count: 0,
	loadingMessages: false,
	oldest: $author$project$Id$fromInt(0)
};
var $author$project$DmChannel$frontendInit = {
	dateDividerDrawings: $lamdera$containers$SeqDict$empty,
	e2ee: $author$project$DmChannel$E2eeDisabled($elm$core$Maybe$Nothing),
	games: $lamdera$containers$SeqDict$empty,
	lastTypedAt: $lamdera$containers$SeqDict$empty,
	messages: $author$project$MessageArray$empty,
	threads: $lamdera$containers$SeqDict$empty,
	visibleMessages: $author$project$VisibleMessages$empty
};
var $author$project$LocalState$getGuildAndChannel$ = function (_v0, local) {
	var channelId = _v0.channelId;
	var guildId = _v0.guildId;
	var _v1 = $lamdera$containers$SeqDict$get$(guildId, local.guilds);
	if (!_v1.$) {
		var guild = _v1.a;
		var _v2 = $lamdera$containers$SeqDict$get$(channelId, guild.channels);
		if (!_v2.$) {
			var channel = _v2.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(guild, channel));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$LocalState$getGuildAndChannel = F2($author$project$LocalState$getGuildAndChannel$);
var $author$project$Id$increment = function (_v0) {
	var id = _v0;
	return id + 1;
};
var $author$project$MessageArray$length = function (_v0) {
	var array = _v0;
	return array.end - array.start;
};
var $author$project$DmChannel$latestFrontendMessageId = function (channel) {
	return $author$project$Id$fromInt(
		$author$project$MessageArray$length(channel.messages) - 1);
};
var $author$project$DmChannelId$otherUserId$ = function (userId, _v0) {
	var userIdA = _v0.a;
	var userIdB = _v0.b;
	return _Utils_eq(userId, userIdA) ? $elm$core$Maybe$Just(userIdB) : (_Utils_eq(userId, userIdB) ? $elm$core$Maybe$Just(userIdA) : $elm$core$Maybe$Nothing);
};
var $author$project$DmChannelId$otherUserId = F2($author$project$DmChannelId$otherUserId$);
var $elm$core$Maybe$withDefault$ = function (_default, maybe) {
	if (!maybe.$) {
		var value = maybe.a;
		return value;
	} else {
		return _default;
	}
};
var $elm$core$Maybe$withDefault = F2($elm$core$Maybe$withDefault$);
var $author$project$FrontendExtra$currentGamesTab$ = function (local, route) {
	_v0$2:
	while (true) {
		switch (route.$) {
			case 5:
				var dmRoute = route.a;
				var _v1 = _Utils_Tuple2(
					dmRoute.tab,
					$author$project$DmChannelId$otherUserId$(local.localUser.session.userId, dmRoute.channelId));
				if (((!_v1.a.$) && (_v1.a.a.$ === 1)) && (!_v1.b.$)) {
					var _v2 = _v1.a.a;
					var maybeMatchId = _v2.a;
					var otherUserId = _v1.b.a;
					var dmChannel = $elm$core$Maybe$withDefault$(
						$author$project$DmChannel$frontendInit,
						$lamdera$containers$SeqDict$get$(otherUserId, local.dmChannels));
					return $elm$core$Maybe$Just(
						{
							channelGames: dmChannel.games,
							guildOrDmId: $author$project$Id$GuildOrDmId_Dm(
								{otherUserId: otherUserId}),
							maybeMatchId: maybeMatchId,
							newMatchId: $author$project$Id$increment(
								$author$project$DmChannel$latestFrontendMessageId(dmChannel))
						});
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 3:
				if (((!route.b.$) && (!route.b.c.$)) && (route.b.c.a.$ === 1)) {
					var guildId = route.a;
					var _v3 = route.b;
					var channelId = _v3.a;
					var _v4 = _v3.c.a;
					var maybeMatchId = _v4.a;
					var _v5 = $author$project$LocalState$getGuildAndChannel$(
						{channelId: channelId, guildId: guildId},
						local);
					if (!_v5.$) {
						var _v6 = _v5.a;
						var channel = _v6.b;
						return $elm$core$Maybe$Just(
							{
								channelGames: channel.games,
								guildOrDmId: $author$project$Id$GuildOrDmId_Guild(
									{channelId: channelId, guildId: guildId}),
								maybeMatchId: maybeMatchId,
								newMatchId: $author$project$Id$increment(
									$author$project$DmChannel$latestFrontendMessageId(channel))
							});
					} else {
						return $elm$core$Maybe$Nothing;
					}
				} else {
					break _v0$2;
				}
			default:
				break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$FrontendExtra$currentGamesTab = F2($author$project$FrontendExtra$currentGamesTab$);
var $author$project$FrontendExtra$currentGame$ = function (local, model) {
	var _v0 = $author$project$FrontendExtra$currentGamesTab$(local, model.route);
	if (!_v0.$) {
		var gamesTab = _v0.a;
		var _v1 = gamesTab.maybeMatchId;
		if (!_v1.$) {
			var matchId = _v1.a;
			var _v2 = $lamdera$containers$SeqDict$get$(matchId, gamesTab.channelGames);
			if (!_v2.$) {
				var match = _v2.a;
				return $elm$core$Maybe$Just(
					{guildOrDmId: gamesTab.guildOrDmId, match: match, matchId: matchId});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$FrontendExtra$currentGame = F2($author$project$FrontendExtra$currentGame$);
var $author$project$Game$GameSelect = {$: 0};
var $author$project$Game$initModel = {setup: $author$project$Game$GameSelect, sheepGameQuestionsCounter: 0, sheepGameSaveCounters: $lamdera$containers$SeqDict$empty, startedGames: $lamdera$containers$SeqDict$empty};
var $author$project$Local$model = function (_v0) {
	var localModel_ = _v0;
	return localModel_.localModel;
};
var $author$project$FrontendExtra$audio$ = function (_v0, model) {
	if (!model.$) {
		return $author$project$Audio$silence;
	} else {
		var loaded = model.a;
		var _v2 = loaded.loginStatus;
		if (!_v2.$) {
			var loggedIn = _v2.a;
			var local = $author$project$Local$model(loggedIn.localState);
			var _v3 = _Utils_Tuple2(
				$author$project$FrontendExtra$currentGame$(local, loaded),
				loaded.popSound);
			if ((!_v3.a.$) && (!_v3.b.$)) {
				var match = _v3.a.a.match;
				var matchId = _v3.a.a.matchId;
				var guildOrDmId = _v3.a.a.guildOrDmId;
				var popSound = _v3.b.a;
				return $author$project$Game$audio$(
					popSound,
					local.localUser.session.userId,
					matchId,
					match,
					$elm$core$Maybe$withDefault$(
						$author$project$Game$initModel,
						$lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.games)));
			} else {
				return $author$project$Audio$silence;
			}
		} else {
			return $author$project$Audio$silence;
		}
	}
};
var $author$project$FrontendExtra$audio = F2($author$project$FrontendExtra$audio$);
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $author$project$Ports$audioPortFromJS = _Platform_incomingPort('audioPortFromJS', $elm$json$Json$Decode$value);
var $author$project$Ports$audioPortToJS = _Platform_outgoingPort('audioPortToJS', $elm$core$Basics$identity);
var $author$project$Types$CheckLoginRequest = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$GetPublicGoMatchRequest = function (a) {
	return {$: 17, a: a};
};
var $author$project$Types$GotWindowSize$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Types$GotWindowSize = F2($author$project$Types$GotWindowSize$);
var $author$project$Types$LoadedPopSound = function (a) {
	return {$: 166, a: a};
};
var $author$project$Types$Loading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$LoadingData = {$: 0};
var $author$project$Types$LoginWithEmail = 0;
var $author$project$Types$PublicGoMatch_Loading = {$: 1};
var $author$project$Types$PublicGoMatch_NotLoaded = {$: 0};
var $author$project$Audio$UnknownError = 2;
var $lamdera$program_test$Effect$Internal$Batch = function (a) {
	return {$: 0, a: a};
};
var $lamdera$program_test$Effect$Command$batch = $lamdera$program_test$Effect$Internal$Batch;
var $author$project$Route$AdminRoute = function (a) {
	return {$: 1, a: a};
};
var $author$project$Route$AiChatRoute = {$: 9};
var $author$project$Route$ChannelRoute$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $author$project$Route$ChannelRoute = F3($author$project$Route$ChannelRoute$);
var $author$project$Route$ChannelsHiddenOnMobile = 0;
var $author$project$Route$ChannelsVisibleOnMobile = 1;
var $author$project$Route$DiscordChannel_ChannelRoute$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $author$project$Route$DiscordChannel_ChannelRoute = F3($author$project$Route$DiscordChannel_ChannelRoute$);
var $author$project$Route$DiscordChannel_GuildSettingsRoute = {$: 2};
var $author$project$Route$DiscordChannel_NewChannelRoute = {$: 1};
var $author$project$Route$DiscordDmRoute = function (a) {
	return {$: 6, a: a};
};
var $author$project$Route$DiscordGuildRoute = function (a) {
	return {$: 4, a: a};
};
var $author$project$Route$DiscordGuildRouteData$ = function (currentDiscordUserId, guildId, channelRoute, channelsVisible, overlay) {
	return {channelRoute: channelRoute, channelsVisible: channelsVisible, currentDiscordUserId: currentDiscordUserId, guildId: guildId, overlay: overlay};
};
var $author$project$Route$DiscordGuildRouteData = F5($author$project$Route$DiscordGuildRouteData$);
var $author$project$Route$DmRoute = function (a) {
	return {$: 5, a: a};
};
var $author$project$Route$E2eeInfoOverlay = 0;
var $author$project$Route$GuildRoute$ = function (a, b, c, d) {
	return {$: 3, a: a, b: b, c: c, d: d};
};
var $author$project$Route$GuildRoute = F4($author$project$Route$GuildRoute$);
var $author$project$Route$GuildSettingsRoute = {$: 2};
var $author$project$Route$HideChannelSettings = 1;
var $author$project$Route$HomePageRoute = function (a) {
	return {$: 0, a: a};
};
var $author$project$Slack$Id = $elm$core$Basics$identity;
var $author$project$Route$JoinRoute = function (a) {
	return {$: 3, a: a};
};
var $author$project$Route$LinkDiscord = function (a) {
	return {$: 12, a: a};
};
var $author$project$Route$LinkDiscordExpired = 0;
var $author$project$Route$LinkDiscordInvalidData = 2;
var $author$project$Route$LinkDiscordLimitReachedError = 3;
var $author$project$Route$LinkDiscordServerError = 1;
var $author$project$Route$NewChannelRoute = {$: 1};
var $author$project$Route$NewGuildRoute = {$: 2};
var $author$project$Route$NoThreadWithFriends$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Route$NoThreadWithFriends = F2($author$project$Route$NoThreadWithFriends$);
var $author$project$Route$PrivacyRoute = {$: 11};
var $author$project$Route$PublicGoMatchRoute = function (a) {
	return {$: 13, a: a};
};
var $author$project$Route$SearchOverlay = 2;
var $author$project$Route$ShowChannelSettings = 0;
var $author$project$Route$SlackChannel_ChannelRoute$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $author$project$Route$SlackChannel_ChannelRoute = F3($author$project$Route$SlackChannel_ChannelRoute$);
var $author$project$Route$SlackChannel_WorkspaceSettingsRoute = {$: 1};
var $author$project$Route$SlackDmRoute = function (a) {
	return {$: 8, a: a};
};
var $author$project$Route$SlackWorkspaceRoute = function (a) {
	return {$: 7, a: a};
};
var $author$project$Route$TextEditorRoute = {$: 10};
var $author$project$Route$UserOptionsOverlay = 1;
var $author$project$UserSession$ChannelHeaderTab_ChannelDescription = {$: 2};
var $author$project$UserSession$ChannelHeaderTab_Draw = {$: 3};
var $author$project$UserSession$ChannelHeaderTab_Games$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$UserSession$ChannelHeaderTab_Games = F2($author$project$UserSession$ChannelHeaderTab_Games$);
var $author$project$UserSession$ChannelHeaderTab_VoiceChat = {$: 0};
var $author$project$Serialize$DataCorrupted = {$: 1};
var $elm$bytes$Bytes$Encode$getWidth = function (builder) {
	switch (builder.$) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 4;
		case 3:
			return 1;
		case 4:
			return 2;
		case 5:
			return 4;
		case 6:
			return 4;
		case 7:
			return 8;
		case 8:
			var w = builder.a;
			return w;
		case 9:
			var w = builder.a;
			return w;
		default:
			var bs = builder.a;
			return _Bytes_width(bs);
	}
};
var $elm$bytes$Bytes$LE = 0;
var $elm$bytes$Bytes$Encode$write$ = function (builder, mb, offset) {
	switch (builder.$) {
		case 0:
			var n = builder.a;
			return A3(_Bytes_write_i8, mb, offset, n);
		case 1:
			var e = builder.a;
			var n = builder.b;
			return A4(_Bytes_write_i16, mb, offset, n, !e);
		case 2:
			var e = builder.a;
			var n = builder.b;
			return A4(_Bytes_write_i32, mb, offset, n, !e);
		case 3:
			var n = builder.a;
			return A3(_Bytes_write_u8, mb, offset, n);
		case 4:
			var e = builder.a;
			var n = builder.b;
			return A4(_Bytes_write_u16, mb, offset, n, !e);
		case 5:
			var e = builder.a;
			var n = builder.b;
			return A4(_Bytes_write_u32, mb, offset, n, !e);
		case 6:
			var e = builder.a;
			var n = builder.b;
			return A4(_Bytes_write_f32, mb, offset, n, !e);
		case 7:
			var e = builder.a;
			var n = builder.b;
			return A4(_Bytes_write_f64, mb, offset, n, !e);
		case 8:
			var bs = builder.b;
			return $elm$bytes$Bytes$Encode$writeSequence$(bs, mb, offset);
		case 9:
			var s = builder.b;
			return A3(_Bytes_write_string, mb, offset, s);
		default:
			var bs = builder.a;
			return A3(_Bytes_write_bytes, mb, offset, bs);
	}
};
var $elm$bytes$Bytes$Encode$write = F3($elm$bytes$Bytes$Encode$write$);
var $elm$bytes$Bytes$Encode$writeSequence$ = function (builders, mb, offset) {
	writeSequence:
	while (true) {
		if (!builders.b) {
			return offset;
		} else {
			var b = builders.a;
			var bs = builders.b;
			var $temp$builders = bs,
				$temp$offset = $elm$bytes$Bytes$Encode$write$(b, mb, offset);
			builders = $temp$builders;
			offset = $temp$offset;
			continue writeSequence;
		}
	}
};
var $elm$bytes$Bytes$Encode$writeSequence = F3($elm$bytes$Bytes$Encode$writeSequence$);
var $elm$bytes$Bytes$Encode$encode = _Bytes_encode;
var $elm$core$String$length = _String_length;
var $elm$core$Basics$modBy = _Basics_modBy;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp$ = function (n, chunk, result) {
	return (n <= 0) ? result : $elm$core$String$repeatHelp$(
		n >> 1,
		_Utils_ap(chunk, chunk),
		(!(n & 1)) ? result : _Utils_ap(result, chunk));
};
var $elm$core$String$repeatHelp = F3($elm$core$String$repeatHelp$);
var $elm$core$String$repeat$ = function (n, chunk) {
	return $elm$core$String$repeatHelp$(n, chunk, '');
};
var $elm$core$String$repeat = F2($elm$core$String$repeat$);
var $elm$regex$Regex$Match$ = function (match, index, number, submatches) {
	return {index: index, match: match, number: number, submatches: submatches};
};
var $elm$regex$Regex$Match = F4($elm$regex$Regex$Match$);
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{caseInsensitive: false, multiline: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $author$project$Serialize$replaceFromUrl = $elm$core$Maybe$withDefault$(
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('[-_]'));
var $elm$bytes$Bytes$Encode$Seq$ = function (a, b) {
	return {$: 8, a: a, b: b};
};
var $elm$bytes$Bytes$Encode$Seq = F2($elm$bytes$Bytes$Encode$Seq$);
var $elm$bytes$Bytes$Encode$getWidths$ = function (width, builders) {
	getWidths:
	while (true) {
		if (!builders.b) {
			return width;
		} else {
			var b = builders.a;
			var bs = builders.b;
			var $temp$width = width + $elm$bytes$Bytes$Encode$getWidth(b),
				$temp$builders = bs;
			width = $temp$width;
			builders = $temp$builders;
			continue getWidths;
		}
	}
};
var $elm$bytes$Bytes$Encode$getWidths = F2($elm$bytes$Bytes$Encode$getWidths$);
var $elm$bytes$Bytes$Encode$sequence = function (builders) {
	return $elm$bytes$Bytes$Encode$Seq$(
		$elm$bytes$Bytes$Encode$getWidths$(0, builders),
		builders);
};
var $elm$core$Basics$composeR$ = function (f, g, x) {
	return g(
		f(x));
};
var $elm$core$Basics$composeR = F3($elm$core$Basics$composeR$);
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft$ = function (n, string) {
	return (n < 1) ? string : A3(
		$elm$core$String$slice,
		n,
		$elm$core$String$length(string),
		string);
};
var $elm$core$String$dropLeft = F2($elm$core$String$dropLeft$);
var $elm$bytes$Bytes$BE = 1;
var $danfishgold$base64_bytes$Encode$isValidChar = function (c) {
	if ($elm$core$Char$isAlphaNum(c)) {
		return true;
	} else {
		switch (c) {
			case '+':
				return true;
			case '/':
				return true;
			default:
				return false;
		}
	}
};
var $elm$core$Bitwise$or = _Bitwise_or;
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $danfishgold$base64_bytes$Encode$unsafeConvertChar = function (_char) {
	var key = $elm$core$Char$toCode(_char);
	if ((key >= 65) && (key <= 90)) {
		return key - 65;
	} else {
		if ((key >= 97) && (key <= 122)) {
			return (key - 97) + 26;
		} else {
			if ((key >= 48) && (key <= 57)) {
				return ((key - 48) + 26) + 26;
			} else {
				switch (_char) {
					case '+':
						return 62;
					case '/':
						return 63;
					default:
						return -1;
				}
			}
		}
	}
};
var $elm$bytes$Bytes$Encode$U16$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $elm$bytes$Bytes$Encode$U16 = F2($elm$bytes$Bytes$Encode$U16$);
var $elm$bytes$Bytes$Encode$unsignedInt16 = $elm$bytes$Bytes$Encode$U16;
var $elm$bytes$Bytes$Encode$U8 = function (a) {
	return {$: 3, a: a};
};
var $elm$bytes$Bytes$Encode$unsignedInt8 = $elm$bytes$Bytes$Encode$U8;
var $danfishgold$base64_bytes$Encode$encodeCharacters$ = function (a, b, c, d) {
	if ($danfishgold$base64_bytes$Encode$isValidChar(a) && $danfishgold$base64_bytes$Encode$isValidChar(b)) {
		var n2 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(b);
		var n1 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(a);
		if ('=' === d) {
			if ('=' === c) {
				var n = (n1 << 18) | (n2 << 12);
				var b1 = n >> 16;
				return $elm$core$Maybe$Just(
					$elm$bytes$Bytes$Encode$unsignedInt8(b1));
			} else {
				if ($danfishgold$base64_bytes$Encode$isValidChar(c)) {
					var n3 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(c);
					var n = ((n1 << 18) | (n2 << 12)) | (n3 << 6);
					var combined = n >> 8;
					return $elm$core$Maybe$Just(
						A2($elm$bytes$Bytes$Encode$unsignedInt16, 1, combined));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		} else {
			if ($danfishgold$base64_bytes$Encode$isValidChar(c) && $danfishgold$base64_bytes$Encode$isValidChar(d)) {
				var n4 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(d);
				var n3 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(c);
				var n = ((n1 << 18) | (n2 << 12)) | ((n3 << 6) | n4);
				var combined = n >> 8;
				var b3 = n;
				return $elm$core$Maybe$Just(
					$elm$bytes$Bytes$Encode$sequence(
						_List_fromArray(
							[
								A2($elm$bytes$Bytes$Encode$unsignedInt16, 1, combined),
								$elm$bytes$Bytes$Encode$unsignedInt8(b3)
							])));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $danfishgold$base64_bytes$Encode$encodeCharacters = F4($danfishgold$base64_bytes$Encode$encodeCharacters$);
var $elm$core$String$left$ = function (n, string) {
	return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
};
var $elm$core$String$left = F2($elm$core$String$left$);
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $danfishgold$base64_bytes$Encode$encodeChunks$ = function (input, accum) {
	encodeChunks:
	while (true) {
		var _v0 = $elm$core$String$toList(
			$elm$core$String$left$(4, input));
		_v0$4:
		while (true) {
			if (!_v0.b) {
				return $elm$core$Maybe$Just(accum);
			} else {
				if (_v0.b.b) {
					if (_v0.b.b.b) {
						if (_v0.b.b.b.b) {
							if (!_v0.b.b.b.b.b) {
								var a = _v0.a;
								var _v1 = _v0.b;
								var b = _v1.a;
								var _v2 = _v1.b;
								var c = _v2.a;
								var _v3 = _v2.b;
								var d = _v3.a;
								var _v4 = $danfishgold$base64_bytes$Encode$encodeCharacters$(a, b, c, d);
								if (!_v4.$) {
									var enc = _v4.a;
									var $temp$input = $elm$core$String$dropLeft$(4, input),
										$temp$accum = A2($elm$core$List$cons, enc, accum);
									input = $temp$input;
									accum = $temp$accum;
									continue encodeChunks;
								} else {
									return $elm$core$Maybe$Nothing;
								}
							} else {
								break _v0$4;
							}
						} else {
							var a = _v0.a;
							var _v5 = _v0.b;
							var b = _v5.a;
							var _v6 = _v5.b;
							var c = _v6.a;
							var _v7 = $danfishgold$base64_bytes$Encode$encodeCharacters$(a, b, c, '=');
							if (_v7.$ === 1) {
								return $elm$core$Maybe$Nothing;
							} else {
								var enc = _v7.a;
								return $elm$core$Maybe$Just(
									A2($elm$core$List$cons, enc, accum));
							}
						}
					} else {
						var a = _v0.a;
						var _v8 = _v0.b;
						var b = _v8.a;
						var _v9 = $danfishgold$base64_bytes$Encode$encodeCharacters$(a, b, '=', '=');
						if (_v9.$ === 1) {
							return $elm$core$Maybe$Nothing;
						} else {
							var enc = _v9.a;
							return $elm$core$Maybe$Just(
								A2($elm$core$List$cons, enc, accum));
						}
					}
				} else {
					break _v0$4;
				}
			}
		}
		return $elm$core$Maybe$Nothing;
	}
};
var $danfishgold$base64_bytes$Encode$encodeChunks = F2($danfishgold$base64_bytes$Encode$encodeChunks$);
var $elm$core$Maybe$map$ = function (f, maybe) {
	if (!maybe.$) {
		var value = maybe.a;
		return $elm$core$Maybe$Just(
			f(value));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Maybe$map = F2($elm$core$Maybe$map$);
var $danfishgold$base64_bytes$Encode$encoder = function (string) {
	return $elm$core$Maybe$map$(
		A2($elm$core$Basics$composeR, $elm$core$List$reverse, $elm$bytes$Bytes$Encode$sequence),
		$danfishgold$base64_bytes$Encode$encodeChunks$(string, _List_Nil));
};
var $danfishgold$base64_bytes$Encode$toBytes = function (string) {
	return $elm$core$Maybe$map$(
		$elm$bytes$Bytes$Encode$encode,
		$danfishgold$base64_bytes$Encode$encoder(string));
};
var $danfishgold$base64_bytes$Base64$toBytes = $danfishgold$base64_bytes$Encode$toBytes;
var $author$project$Serialize$decode = function (base64text) {
	var strlen = $elm$core$String$length(base64text);
	var replaceChar = function (rematch) {
		var _v0 = rematch.match;
		if (_v0 === '-') {
			return '+';
		} else {
			return '/';
		}
	};
	if (!strlen) {
		return $elm$core$Maybe$Just(
			$elm$bytes$Bytes$Encode$encode(
				$elm$bytes$Bytes$Encode$sequence(_List_Nil)));
	} else {
		var hanging = A2($elm$core$Basics$modBy, 4, strlen);
		var ilen = (!hanging) ? 0 : (4 - hanging);
		return $danfishgold$base64_bytes$Base64$toBytes(
			A3(
				$elm$regex$Regex$replace,
				$author$project$Serialize$replaceFromUrl,
				replaceChar,
				_Utils_ap(
					base64text,
					$elm$core$String$repeat$(ilen, '='))));
	}
};
var $author$project$Serialize$SerializerOutOfDate = {$: 2};
var $elm$bytes$Bytes$Decode$Decoder = $elm$core$Basics$identity;
var $elm$bytes$Bytes$Decode$andThen$ = function (callback, _v0) {
	var decodeA = _v0;
	return F2(
		function (bites, offset) {
			var _v1 = A2(decodeA, bites, offset);
			var newOffset = _v1.a;
			var a = _v1.b;
			var _v2 = callback(a);
			var decodeB = _v2;
			return A2(decodeB, bites, newOffset);
		});
};
var $elm$bytes$Bytes$Decode$andThen = F2($elm$bytes$Bytes$Decode$andThen$);
var $elm$bytes$Bytes$Decode$decode$ = function (_v0, bs) {
	var decoder = _v0;
	return A2(_Bytes_decode, decoder, bs);
};
var $elm$bytes$Bytes$Decode$decode = F2($elm$bytes$Bytes$Decode$decode$);
var $author$project$Serialize$getBytesDecoderHelper = function (_v0) {
	var m = _v0;
	return m.decoder;
};
var $elm$bytes$Bytes$Decode$succeed = function (a) {
	return F2(
		function (_v0, offset) {
			return _Utils_Tuple2(offset, a);
		});
};
var $elm$bytes$Bytes$Decode$unsignedInt8 = _Bytes_read_u8;
var $author$project$Serialize$version = 1;
var $author$project$Serialize$decodeFromBytes$ = function (codec, bytes_) {
	var decoder = $elm$bytes$Bytes$Decode$andThen$(
		function (value) {
			return (value <= 0) ? $elm$bytes$Bytes$Decode$succeed(
				$elm$core$Result$Err($author$project$Serialize$DataCorrupted)) : (_Utils_eq(value, $author$project$Serialize$version) ? $author$project$Serialize$getBytesDecoderHelper(codec) : $elm$bytes$Bytes$Decode$succeed(
				$elm$core$Result$Err($author$project$Serialize$SerializerOutOfDate)));
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
	var _v0 = $elm$bytes$Bytes$Decode$decode$(decoder, bytes_);
	if (!_v0.$) {
		var value = _v0.a;
		return value;
	} else {
		return $elm$core$Result$Err($author$project$Serialize$DataCorrupted);
	}
};
var $author$project$Serialize$decodeFromBytes = F2($author$project$Serialize$decodeFromBytes$);
var $author$project$Serialize$decodeFromString$ = function (codec, base64) {
	var _v0 = $author$project$Serialize$decode(base64);
	if (!_v0.$) {
		var bytes_ = _v0.a;
		return $author$project$Serialize$decodeFromBytes$(codec, bytes_);
	} else {
		return $elm$core$Result$Err($author$project$Serialize$DataCorrupted);
	}
};
var $author$project$Serialize$decodeFromString = F2($author$project$Serialize$decodeFromString$);
var $elm$core$String$toInt = _String_toInt;
var $author$project$Id$fromString = function (string) {
	return $elm$core$Maybe$map$(
		$elm$core$Basics$identity,
		$elm$core$String$toInt(string));
};
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get$ = function (targetKey, dict) {
	get:
	while (true) {
		if (dict.$ === -2) {
			return $elm$core$Maybe$Nothing;
		} else {
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			var _v1 = A2($elm$core$Basics$compare, targetKey, key);
			switch (_v1) {
				case 0:
					var $temp$dict = left;
					dict = $temp$dict;
					continue get;
				case 1:
					return $elm$core$Maybe$Just(value);
				default:
					var $temp$dict = right;
					dict = $temp$dict;
					continue get;
			}
		}
	}
};
var $elm$core$Dict$get = F2($elm$core$Dict$get$);
var $author$project$Route$goMatchParam = 'match';
var $author$project$Message$RepliedTo_SheepGameAnswer$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Message$RepliedTo_SheepGameAnswer = F2($author$project$Message$RepliedTo_SheepGameAnswer$);
var $author$project$Message$RepliedTo_SheepGameNotes = function (a) {
	return {$: 2, a: a};
};
var $author$project$Message$RepliedTo_WordSpellingGameMove = function (a) {
	return {$: 0, a: a};
};
var $author$project$Serialize$Codec = $elm$core$Basics$identity;
var $author$project$Serialize$build$ = function (encoder_, decoder_, jsonEncoder, jsonDecoder) {
	return {decoder: decoder_, encoder: encoder_, jsonDecoder: jsonDecoder, jsonEncoder: jsonEncoder};
};
var $author$project$Serialize$build = F4($author$project$Serialize$build$);
var $author$project$Serialize$endian = 1;
var $elm$bytes$Bytes$Decode$float64 = function (endianness) {
	return _Bytes_read_f64(!endianness);
};
var $elm$bytes$Bytes$Encode$F64$ = function (a, b) {
	return {$: 7, a: a, b: b};
};
var $elm$bytes$Bytes$Encode$F64 = F2($elm$bytes$Bytes$Encode$F64$);
var $elm$bytes$Bytes$Encode$float64 = $elm$bytes$Bytes$Encode$F64;
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$json$Json$Encode$int = _Json_wrap;
var $elm$bytes$Bytes$Decode$map$ = function (func, _v0) {
	var decodeA = _v0;
	return F2(
		function (bites, offset) {
			var _v1 = A2(decodeA, bites, offset);
			var aOffset = _v1.a;
			var a = _v1.b;
			return _Utils_Tuple2(
				aOffset,
				func(a));
		});
};
var $elm$bytes$Bytes$Decode$map = F2($elm$bytes$Bytes$Decode$map$);
var $elm$json$Json$Decode$map = _Json_map1;
var $author$project$Serialize$int = $author$project$Serialize$build$(
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Basics$toFloat,
		$elm$bytes$Bytes$Encode$float64($author$project$Serialize$endian)),
	$elm$bytes$Bytes$Decode$map$(
		A2($elm$core$Basics$composeR, $elm$core$Basics$round, $elm$core$Result$Ok),
		$elm$bytes$Bytes$Decode$float64($author$project$Serialize$endian)),
	$elm$json$Json$Encode$int,
	A2($elm$json$Json$Decode$map, $elm$core$Result$Ok, $elm$json$Json$Decode$int));
var $author$project$Serialize$getBytesEncoderHelper = function (_v0) {
	var m = _v0;
	return m.encoder;
};
var $author$project$Serialize$getJsonDecoderHelper = function (_v0) {
	var m = _v0;
	return m.jsonDecoder;
};
var $author$project$Serialize$getJsonEncoderHelper = function (_v0) {
	var m = _v0;
	return m.jsonEncoder;
};
var $author$project$Serialize$mapHelper$ = function (fromBytes_, toBytes_, codec) {
	return $author$project$Serialize$build$(
		function (v) {
			return A2(
				$author$project$Serialize$getBytesEncoderHelper,
				codec,
				toBytes_(v));
		},
		$elm$bytes$Bytes$Decode$map$(
			fromBytes_,
			$author$project$Serialize$getBytesDecoderHelper(codec)),
		function (v) {
			return A2(
				$author$project$Serialize$getJsonEncoderHelper,
				codec,
				toBytes_(v));
		},
		A2(
			$elm$json$Json$Decode$map,
			fromBytes_,
			$author$project$Serialize$getJsonDecoderHelper(codec)));
};
var $author$project$Serialize$mapHelper = F3($author$project$Serialize$mapHelper$);
var $author$project$Serialize$map$ = function (fromBytes_, toBytes_, codec) {
	return $author$project$Serialize$mapHelper$(
		function (value) {
			if (!value.$) {
				var ok = value.a;
				return $elm$core$Result$Ok(
					fromBytes_(ok));
			} else {
				var err = value.a;
				return $elm$core$Result$Err(err);
			}
		},
		toBytes_,
		codec);
};
var $author$project$Serialize$map = F3($author$project$Serialize$map$);
var $author$project$Id$toInt = function (_v0) {
	var _int = _v0;
	return _int;
};
var $author$project$Id$codec = $author$project$Serialize$map$($elm$core$Basics$identity, $author$project$Id$toInt, $author$project$Serialize$int);
var $author$project$Serialize$CustomTypeCodec = $elm$core$Basics$identity;
var $author$project$Serialize$customType = function (match) {
	return {
		decoder: function (_v0) {
			return $elm$core$Basics$identity;
		},
		idCounter: 0,
		jsonDecoder: function (_v1) {
			return $elm$core$Basics$identity;
		},
		jsonMatch: match,
		match: match
	};
};
var $elm$json$Json$Decode$index = _Json_decodeIndex;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$bytes$Bytes$Decode$unsignedInt16 = function (endianness) {
	return _Bytes_read_u16(!endianness);
};
var $author$project$Serialize$finishCustomType = function (_v0) {
	var am = _v0;
	return $author$project$Serialize$build$(
		A2(
			$elm$core$Basics$composeR,
			am.match,
			function (_v1) {
				var _v2 = _v1;
				var a = _v2.a;
				return a;
			}),
		$elm$bytes$Bytes$Decode$andThen$(
			function (tag) {
				return A2(
					am.decoder,
					tag,
					$elm$bytes$Bytes$Decode$succeed(
						$elm$core$Result$Err($author$project$Serialize$DataCorrupted)));
			},
			$elm$bytes$Bytes$Decode$unsignedInt16($author$project$Serialize$endian)),
		A2(
			$elm$core$Basics$composeR,
			am.jsonMatch,
			function (_v3) {
				var _v4 = _v3;
				var a = _v4.b;
				return a;
			}),
		A2(
			$elm$json$Json$Decode$andThen,
			function (tag) {
				return A2(
					am.jsonDecoder,
					tag,
					$elm$json$Json$Decode$succeed(
						$elm$core$Result$Err($author$project$Serialize$DataCorrupted)));
			},
			A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$int)));
};
var $author$project$Serialize$unsignedInt16 = $author$project$Serialize$build$(
	$elm$bytes$Bytes$Encode$unsignedInt16($author$project$Serialize$endian),
	$elm$bytes$Bytes$Decode$map$(
		$elm$core$Result$Ok,
		$elm$bytes$Bytes$Decode$unsignedInt16($author$project$Serialize$endian)),
	$elm$json$Json$Encode$int,
	A2($elm$json$Json$Decode$map, $elm$core$Result$Ok, $elm$json$Json$Decode$int));
var $author$project$Serialize$result1$ = function (ctor, value) {
	if (!value.$) {
		var ok = value.a;
		return $elm$core$Result$Ok(
			ctor(ok));
	} else {
		var err = value.a;
		return $elm$core$Result$Err(err);
	}
};
var $author$project$Serialize$result1 = F2($author$project$Serialize$result1$);
var $author$project$Serialize$VariantEncoder = $elm$core$Basics$identity;
var $elm$json$Json$Encode$list$ = function (func, entries) {
	return _Json_wrap(
		$elm$core$List$foldl$(
			_Json_addEntry(func),
			_Json_emptyArray(0),
			entries));
};
var $elm$json$Json$Encode$list = F2($elm$json$Json$Encode$list$);
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Serialize$variant$ = function (matchPiece, matchJsonPiece, decoderPiece, jsonDecoderPiece, _v0) {
	var am = _v0;
	var jsonEnc = function (v) {
		return _Utils_Tuple2(
			$elm$bytes$Bytes$Encode$sequence(_List_Nil),
			$elm$json$Json$Encode$list$(
				$elm$core$Basics$identity,
				A2(
					$elm$core$List$cons,
					$elm$json$Json$Encode$int(am.idCounter),
					v)));
	};
	var jsonDecoder_ = F2(
		function (tag, orElse) {
			return _Utils_eq(tag, am.idCounter) ? jsonDecoderPiece : A2(am.jsonDecoder, tag, orElse);
		});
	var enc = function (v) {
		return _Utils_Tuple2(
			$elm$bytes$Bytes$Encode$sequence(
				A2(
					$elm$core$List$cons,
					A2($elm$bytes$Bytes$Encode$unsignedInt16, $author$project$Serialize$endian, am.idCounter),
					v)),
			$elm$json$Json$Encode$null);
	};
	var decoder_ = F2(
		function (tag, orElse) {
			return _Utils_eq(tag, am.idCounter) ? decoderPiece : A2(am.decoder, tag, orElse);
		});
	return {
		decoder: decoder_,
		idCounter: am.idCounter + 1,
		jsonDecoder: jsonDecoder_,
		jsonMatch: am.jsonMatch(
			matchJsonPiece(jsonEnc)),
		match: am.match(
			matchPiece(enc))
	};
};
var $author$project$Serialize$variant = F5($author$project$Serialize$variant$);
var $author$project$Serialize$variant1$ = function (ctor, m1) {
	return A4(
		$author$project$Serialize$variant,
		F2(
			function (c, v) {
				return c(
					_List_fromArray(
						[
							A2($author$project$Serialize$getBytesEncoderHelper, m1, v)
						]));
			}),
		F2(
			function (c, v) {
				return c(
					_List_fromArray(
						[
							A2($author$project$Serialize$getJsonEncoderHelper, m1, v)
						]));
			}),
		$elm$bytes$Bytes$Decode$map$(
			$author$project$Serialize$result1(ctor),
			$author$project$Serialize$getBytesDecoderHelper(m1)),
		A2(
			$elm$json$Json$Decode$map,
			$author$project$Serialize$result1(ctor),
			A2(
				$elm$json$Json$Decode$index,
				1,
				$author$project$Serialize$getJsonDecoderHelper(m1))));
};
var $author$project$Serialize$variant1 = F2($author$project$Serialize$variant1$);
var $elm$bytes$Bytes$Decode$map2$ = function (func, _v0, _v1) {
	var decodeA = _v0;
	var decodeB = _v1;
	return F2(
		function (bites, offset) {
			var _v2 = A2(decodeA, bites, offset);
			var aOffset = _v2.a;
			var a = _v2.b;
			var _v3 = A2(decodeB, bites, aOffset);
			var bOffset = _v3.a;
			var b = _v3.b;
			return _Utils_Tuple2(
				bOffset,
				A2(func, a, b));
		});
};
var $elm$bytes$Bytes$Decode$map2 = F3($elm$bytes$Bytes$Decode$map2$);
var $elm$json$Json$Decode$map2 = _Json_map2;
var $author$project$Serialize$result2$ = function (ctor, v1, v2) {
	var _v0 = _Utils_Tuple2(v1, v2);
	if (!_v0.a.$) {
		if (!_v0.b.$) {
			var ok1 = _v0.a.a;
			var ok2 = _v0.b.a;
			return $elm$core$Result$Ok(
				A2(ctor, ok1, ok2));
		} else {
			var err = _v0.b.a;
			return $elm$core$Result$Err(err);
		}
	} else {
		var err = _v0.a.a;
		return $elm$core$Result$Err(err);
	}
};
var $author$project$Serialize$result2 = F3($author$project$Serialize$result2$);
var $author$project$Serialize$variant2$ = function (ctor, m1, m2) {
	return A4(
		$author$project$Serialize$variant,
		F3(
			function (c, v1, v2) {
				return c(
					_List_fromArray(
						[
							A2($author$project$Serialize$getBytesEncoderHelper, m1, v1),
							A2($author$project$Serialize$getBytesEncoderHelper, m2, v2)
						]));
			}),
		F3(
			function (c, v1, v2) {
				return c(
					_List_fromArray(
						[
							A2($author$project$Serialize$getJsonEncoderHelper, m1, v1),
							A2($author$project$Serialize$getJsonEncoderHelper, m2, v2)
						]));
			}),
		$elm$bytes$Bytes$Decode$map2$(
			$author$project$Serialize$result2(ctor),
			$author$project$Serialize$getBytesDecoderHelper(m1),
			$author$project$Serialize$getBytesDecoderHelper(m2)),
		A3(
			$elm$json$Json$Decode$map2,
			$author$project$Serialize$result2(ctor),
			A2(
				$elm$json$Json$Decode$index,
				1,
				$author$project$Serialize$getJsonDecoderHelper(m1)),
			A2(
				$elm$json$Json$Decode$index,
				2,
				$author$project$Serialize$getJsonDecoderHelper(m2))));
};
var $author$project$Serialize$variant2 = F3($author$project$Serialize$variant2$);
var $author$project$Message$repliedToGameCodec = $author$project$Serialize$finishCustomType(
	A3(
		$author$project$Serialize$variant1,
		$author$project$Message$RepliedTo_SheepGameNotes,
		$author$project$Id$codec,
		A4(
			$author$project$Serialize$variant2,
			$author$project$Message$RepliedTo_SheepGameAnswer,
			$author$project$Id$codec,
			$author$project$Id$codec,
			A3(
				$author$project$Serialize$variant1,
				$author$project$Message$RepliedTo_WordSpellingGameMove,
				$author$project$Serialize$unsignedInt16,
				$author$project$Serialize$customType(
					F4(
						function (a, b, c, value) {
							switch (value.$) {
								case 0:
									var argA = value.a;
									return a(argA);
								case 1:
									var argA = value.a;
									var argB = value.b;
									return A2(b, argA, argB);
								default:
									var argA = value.a;
									return c(argA);
							}
						}))))));
var $author$project$Route$repliedToGameParam = 'replied-to-game';
var $author$project$Route$tabParam = 'tab';
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Route$decodeChannelHeaderTab = function (url2) {
	var repliedTo = function () {
		var _v5 = $elm$core$Dict$get$($author$project$Route$repliedToGameParam, url2.queryParameters);
		if (((!_v5.$) && _v5.a.b) && (!_v5.a.b.b)) {
			var _v6 = _v5.a;
			var repliedTo2 = _v6.a;
			return $elm$core$Result$toMaybe(
				$author$project$Serialize$decodeFromString$($author$project$Message$repliedToGameCodec, repliedTo2));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	var matchId = function () {
		var _v3 = $elm$core$Dict$get$($author$project$Route$goMatchParam, url2.queryParameters);
		if (((!_v3.$) && _v3.a.b) && (!_v3.a.b.b)) {
			var _v4 = _v3.a;
			var matchId2 = _v4.a;
			return $author$project$Id$fromString(matchId2);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	var _v0 = $elm$core$Dict$get$($author$project$Route$tabParam, url2.queryParameters);
	if (((!_v0.$) && _v0.a.b) && (!_v0.a.b.b)) {
		var _v1 = _v0.a;
		var tab2 = _v1.a;
		switch (tab2) {
			case 'description':
				return $elm$core$Maybe$Just($author$project$UserSession$ChannelHeaderTab_ChannelDescription);
			case 'game':
				return $elm$core$Maybe$Just(
					$author$project$UserSession$ChannelHeaderTab_Games$(matchId, repliedTo));
			case 'call':
				return $elm$core$Maybe$Just($author$project$UserSession$ChannelHeaderTab_VoiceChat);
			case 'draw':
				return $elm$core$Maybe$Just($author$project$UserSession$ChannelHeaderTab_Draw);
			default:
				return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $miniBill$elm_codec$Codec$decoder = function (_v0) {
	var m = _v0;
	return m.decoder;
};
var $miniBill$elm_codec$Codec$decodeString = function (codec) {
	return $elm$json$Json$Decode$decodeString(
		$miniBill$elm_codec$Codec$decoder(codec));
};
var $author$project$Route$e2eeInfoOverlayValue = 'end-to-end-encryption';
var $author$project$DmChannelId$DmChannelId$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$DmChannelId$DmChannelId = F2($author$project$DmChannelId$DmChannelId$);
var $elm$core$Basics$min$ = function (x, y) {
	return (_Utils_cmp(x, y) < 0) ? x : y;
};
var $elm$core$Basics$min = F2($elm$core$Basics$min$);
var $author$project$DmChannelId$fromUserIds$ = function (userIdA, userIdB) {
	return $author$project$DmChannelId$DmChannelId$(
		$author$project$Id$fromInt(
			$elm$core$Basics$min$(
				$author$project$Id$toInt(userIdA),
				$author$project$Id$toInt(userIdB))),
		$author$project$Id$fromInt(
			$elm$core$Basics$max$(
				$author$project$Id$toInt(userIdA),
				$author$project$Id$toInt(userIdB))));
};
var $author$project$DmChannelId$fromUserIds = F2($author$project$DmChannelId$fromUserIds$);
var $author$project$DmChannelId$fromString = function (text) {
	var _v0 = $elm$core$String$split$('-', text);
	if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
		var idA = _v0.a;
		var _v1 = _v0.b;
		var idB = _v1.a;
		var _v2 = _Utils_Tuple2(
			$author$project$Id$fromString(idA),
			$author$project$Id$fromString(idB));
		if ((!_v2.a.$) && (!_v2.b.$)) {
			var idA2 = _v2.a.a;
			var idB2 = _v2.b.a;
			return $elm$core$Result$Ok(
				$author$project$DmChannelId$fromUserIds$(idA2, idB2));
		} else {
			return $elm$core$Result$Err(0);
		}
	} else {
		return $elm$core$Result$Err(0);
	}
};
var $author$project$SecretId$SecretId = $elm$core$Basics$identity;
var $author$project$SecretId$fromString = $elm$core$Basics$identity;
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $lydell$elm_app_url$AppUrl$percentDecode = function (string) {
	return $elm$core$Maybe$withDefault$(
		string,
		$elm$url$Url$percentDecode(string));
};
var $elm$core$String$startsWith = _String_startsWith;
var $lydell$elm_app_url$AppUrl$trimLeadingSlash = function (string) {
	return A2($elm$core$String$startsWith, '/', string) ? $elm$core$String$dropLeft$(1, string) : string;
};
var $elm$core$String$dropRight$ = function (n, string) {
	return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
};
var $elm$core$String$dropRight = F2($elm$core$String$dropRight$);
var $elm$core$String$endsWith = _String_endsWith;
var $lydell$elm_app_url$AppUrl$trimTrailingSlash = function (string) {
	return A2($elm$core$String$endsWith, '/', string) ? $elm$core$String$dropRight$(1, string) : string;
};
var $lydell$elm_app_url$AppUrl$parsePath = function (path) {
	var trimmed = $lydell$elm_app_url$AppUrl$trimTrailingSlash(
		$lydell$elm_app_url$AppUrl$trimLeadingSlash(path));
	return $elm$core$String$isEmpty(trimmed) ? _List_Nil : $elm$core$List$map$(
		$lydell$elm_app_url$AppUrl$percentDecode,
		$elm$core$String$split$('/', trimmed));
};
var $lydell$elm_app_url$AppUrl$insert$ = function (value, maybeList) {
	return $elm$core$Maybe$Just(
		A2(
			$elm$core$List$cons,
			value,
			$elm$core$Maybe$withDefault$(_List_Nil, maybeList)));
};
var $lydell$elm_app_url$AppUrl$insert = F2($lydell$elm_app_url$AppUrl$insert$);
var $elm$core$String$replace$ = function (before, after, string) {
	return $elm$core$String$join$(
		after,
		$elm$core$String$split$(before, string));
};
var $elm$core$String$replace = F3($elm$core$String$replace$);
var $lydell$elm_app_url$AppUrl$queryParameterDecode = A2(
	$elm$core$Basics$composeR,
	A2($elm$core$String$replace, '+', ' '),
	$lydell$elm_app_url$AppUrl$percentDecode);
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin$ = function (a, b, c, d, e) {
	return {$: -1, a: a, b: b, c: c, d: d, e: e};
};
var $elm$core$Dict$RBNode_elm_builtin = F5($elm$core$Dict$RBNode_elm_builtin$);
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance$ = function (color, key, value, left, right) {
	if ((right.$ === -1) && (!right.a)) {
		var _v1 = right.a;
		var rK = right.b;
		var rV = right.c;
		var rLeft = right.d;
		var rRight = right.e;
		if ((left.$ === -1) && (!left.a)) {
			var _v3 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return $elm$core$Dict$RBNode_elm_builtin$(
				0,
				key,
				value,
				$elm$core$Dict$RBNode_elm_builtin$(1, lK, lV, lLeft, lRight),
				$elm$core$Dict$RBNode_elm_builtin$(1, rK, rV, rLeft, rRight));
		} else {
			return $elm$core$Dict$RBNode_elm_builtin$(
				color,
				rK,
				rV,
				$elm$core$Dict$RBNode_elm_builtin$(0, key, value, left, rLeft),
				rRight);
		}
	} else {
		if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
			var _v5 = left.a;
			var lK = left.b;
			var lV = left.c;
			var _v6 = left.d;
			var _v7 = _v6.a;
			var llK = _v6.b;
			var llV = _v6.c;
			var llLeft = _v6.d;
			var llRight = _v6.e;
			var lRight = left.e;
			return $elm$core$Dict$RBNode_elm_builtin$(
				0,
				lK,
				lV,
				$elm$core$Dict$RBNode_elm_builtin$(1, llK, llV, llLeft, llRight),
				$elm$core$Dict$RBNode_elm_builtin$(1, key, value, lRight, right));
		} else {
			return $elm$core$Dict$RBNode_elm_builtin$(color, key, value, left, right);
		}
	}
};
var $elm$core$Dict$balance = F5($elm$core$Dict$balance$);
var $elm$core$Dict$insertHelp$ = function (key, value, dict) {
	if (dict.$ === -2) {
		return $elm$core$Dict$RBNode_elm_builtin$(0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
	} else {
		var nColor = dict.a;
		var nKey = dict.b;
		var nValue = dict.c;
		var nLeft = dict.d;
		var nRight = dict.e;
		var _v1 = A2($elm$core$Basics$compare, key, nKey);
		switch (_v1) {
			case 0:
				return $elm$core$Dict$balance$(
					nColor,
					nKey,
					nValue,
					$elm$core$Dict$insertHelp$(key, value, nLeft),
					nRight);
			case 1:
				return $elm$core$Dict$RBNode_elm_builtin$(nColor, nKey, value, nLeft, nRight);
			default:
				return $elm$core$Dict$balance$(
					nColor,
					nKey,
					nValue,
					nLeft,
					$elm$core$Dict$insertHelp$(key, value, nRight));
		}
	}
};
var $elm$core$Dict$insertHelp = F3($elm$core$Dict$insertHelp$);
var $elm$core$Dict$insert$ = function (key, value, dict) {
	var _v0 = $elm$core$Dict$insertHelp$(key, value, dict);
	if ((_v0.$ === -1) && (!_v0.a)) {
		var _v1 = _v0.a;
		var k = _v0.b;
		var v = _v0.c;
		var l = _v0.d;
		var r = _v0.e;
		return $elm$core$Dict$RBNode_elm_builtin$(1, k, v, l, r);
	} else {
		var x = _v0;
		return x;
	}
};
var $elm$core$Dict$insert = F3($elm$core$Dict$insert$);
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return $elm$core$Dict$RBNode_elm_builtin$(
				0,
				rlK,
				rlV,
				$elm$core$Dict$RBNode_elm_builtin$(
					1,
					k,
					v,
					$elm$core$Dict$RBNode_elm_builtin$(0, lK, lV, lLeft, lRight),
					rlL),
				$elm$core$Dict$RBNode_elm_builtin$(1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return $elm$core$Dict$RBNode_elm_builtin$(
					1,
					k,
					v,
					$elm$core$Dict$RBNode_elm_builtin$(0, lK, lV, lLeft, lRight),
					$elm$core$Dict$RBNode_elm_builtin$(0, rK, rV, rLeft, rRight));
			} else {
				return $elm$core$Dict$RBNode_elm_builtin$(
					1,
					k,
					v,
					$elm$core$Dict$RBNode_elm_builtin$(0, lK, lV, lLeft, lRight),
					$elm$core$Dict$RBNode_elm_builtin$(0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return $elm$core$Dict$RBNode_elm_builtin$(
				0,
				lK,
				lV,
				$elm$core$Dict$RBNode_elm_builtin$(1, llK, llV, llLeft, llRight),
				$elm$core$Dict$RBNode_elm_builtin$(
					1,
					k,
					v,
					lRight,
					$elm$core$Dict$RBNode_elm_builtin$(0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return $elm$core$Dict$RBNode_elm_builtin$(
					1,
					k,
					v,
					$elm$core$Dict$RBNode_elm_builtin$(0, lK, lV, lLeft, lRight),
					$elm$core$Dict$RBNode_elm_builtin$(0, rK, rV, rLeft, rRight));
			} else {
				return $elm$core$Dict$RBNode_elm_builtin$(
					1,
					k,
					v,
					$elm$core$Dict$RBNode_elm_builtin$(0, lK, lV, lLeft, lRight),
					$elm$core$Dict$RBNode_elm_builtin$(0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT$ = function (targetKey, dict, color, key, value, left, right) {
	if ((left.$ === -1) && (!left.a)) {
		var _v1 = left.a;
		var lK = left.b;
		var lV = left.c;
		var lLeft = left.d;
		var lRight = left.e;
		return $elm$core$Dict$RBNode_elm_builtin$(
			color,
			lK,
			lV,
			lLeft,
			$elm$core$Dict$RBNode_elm_builtin$(0, key, value, lRight, right));
	} else {
		_v2$2:
		while (true) {
			if ((right.$ === -1) && (right.a === 1)) {
				if (right.d.$ === -1) {
					if (right.d.a === 1) {
						var _v3 = right.a;
						var _v4 = right.d;
						var _v5 = _v4.a;
						return $elm$core$Dict$moveRedRight(dict);
					} else {
						break _v2$2;
					}
				} else {
					var _v6 = right.a;
					var _v7 = right.d;
					return $elm$core$Dict$moveRedRight(dict);
				}
			} else {
				break _v2$2;
			}
		}
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7($elm$core$Dict$removeHelpPrepEQGT$);
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return $elm$core$Dict$RBNode_elm_builtin$(
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return $elm$core$Dict$balance$(
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return $elm$core$Dict$RBNode_elm_builtin$(
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp$ = function (targetKey, dict) {
	if (dict.$ === -2) {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	} else {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var right = dict.e;
		if (_Utils_cmp(targetKey, key) < 0) {
			if ((left.$ === -1) && (left.a === 1)) {
				var _v4 = left.a;
				var lLeft = left.d;
				if ((lLeft.$ === -1) && (!lLeft.a)) {
					var _v6 = lLeft.a;
					return $elm$core$Dict$RBNode_elm_builtin$(
						color,
						key,
						value,
						$elm$core$Dict$removeHelp$(targetKey, left),
						right);
				} else {
					var _v7 = $elm$core$Dict$moveRedLeft(dict);
					if (_v7.$ === -1) {
						var nColor = _v7.a;
						var nKey = _v7.b;
						var nValue = _v7.c;
						var nLeft = _v7.d;
						var nRight = _v7.e;
						return $elm$core$Dict$balance$(
							nColor,
							nKey,
							nValue,
							$elm$core$Dict$removeHelp$(targetKey, nLeft),
							nRight);
					} else {
						return $elm$core$Dict$RBEmpty_elm_builtin;
					}
				}
			} else {
				return $elm$core$Dict$RBNode_elm_builtin$(
					color,
					key,
					value,
					$elm$core$Dict$removeHelp$(targetKey, left),
					right);
			}
		} else {
			return $elm$core$Dict$removeHelpEQGT$(
				targetKey,
				$elm$core$Dict$removeHelpPrepEQGT$(targetKey, dict, color, key, value, left, right));
		}
	}
};
var $elm$core$Dict$removeHelp = F2($elm$core$Dict$removeHelp$);
var $elm$core$Dict$removeHelpEQGT$ = function (targetKey, dict) {
	if (dict.$ === -1) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var right = dict.e;
		if (_Utils_eq(targetKey, key)) {
			var _v1 = $elm$core$Dict$getMin(right);
			if (_v1.$ === -1) {
				var minKey = _v1.b;
				var minValue = _v1.c;
				return $elm$core$Dict$balance$(
					color,
					minKey,
					minValue,
					left,
					$elm$core$Dict$removeMin(right));
			} else {
				return $elm$core$Dict$RBEmpty_elm_builtin;
			}
		} else {
			return $elm$core$Dict$balance$(
				color,
				key,
				value,
				left,
				$elm$core$Dict$removeHelp$(targetKey, right));
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelpEQGT = F2($elm$core$Dict$removeHelpEQGT$);
var $elm$core$Dict$remove$ = function (key, dict) {
	var _v0 = $elm$core$Dict$removeHelp$(key, dict);
	if ((_v0.$ === -1) && (!_v0.a)) {
		var _v1 = _v0.a;
		var k = _v0.b;
		var v = _v0.c;
		var l = _v0.d;
		var r = _v0.e;
		return $elm$core$Dict$RBNode_elm_builtin$(1, k, v, l, r);
	} else {
		var x = _v0;
		return x;
	}
};
var $elm$core$Dict$remove = F2($elm$core$Dict$remove$);
var $elm$core$Dict$update$ = function (targetKey, alter, dictionary) {
	var _v0 = alter(
		$elm$core$Dict$get$(targetKey, dictionary));
	if (!_v0.$) {
		var value = _v0.a;
		return $elm$core$Dict$insert$(targetKey, value, dictionary);
	} else {
		return $elm$core$Dict$remove$(targetKey, dictionary);
	}
};
var $elm$core$Dict$update = F3($elm$core$Dict$update$);
var $lydell$elm_app_url$AppUrl$parseQueryParameter$ = function (segment, queryParameters) {
	var _v0 = $elm$core$String$split$('=', segment);
	if (!_v0.b) {
		return queryParameters;
	} else {
		if ((_v0.a === '') && (!_v0.b.b)) {
			return queryParameters;
		} else {
			var rawKey = _v0.a;
			var rest = _v0.b;
			return $elm$core$Dict$update$(
				$lydell$elm_app_url$AppUrl$queryParameterDecode(rawKey),
				$lydell$elm_app_url$AppUrl$insert(
					$lydell$elm_app_url$AppUrl$queryParameterDecode(
						$elm$core$String$join$('=', rest))),
				queryParameters);
		}
	}
};
var $lydell$elm_app_url$AppUrl$parseQueryParameter = F2($lydell$elm_app_url$AppUrl$parseQueryParameter$);
var $lydell$elm_app_url$AppUrl$parseQueryParameters = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$split('&'),
	A2($elm$core$List$foldr, $lydell$elm_app_url$AppUrl$parseQueryParameter, $elm$core$Dict$empty));
var $lydell$elm_app_url$AppUrl$fromUrl = function (url) {
	return {
		fragment: $elm$core$Maybe$map$($lydell$elm_app_url$AppUrl$percentDecode, url.fragment),
		path: $lydell$elm_app_url$AppUrl$parsePath(url.path),
		queryParameters: $elm$core$Maybe$withDefault$(
			$elm$core$Dict$empty,
			$elm$core$Maybe$map$($lydell$elm_app_url$AppUrl$parseQueryParameters, url.query))
	};
};
var $author$project$Route$guildChannelsVisibleParam = 'show-channels';
var $author$project$Discord$Id = $elm$core$Basics$identity;
var $MartinSStewart$elm_uint64$UInt64$charToBinaryDigit = function (_char) {
	switch (_char) {
		case '0':
			return $elm$core$Maybe$Just(0);
		case '1':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $MartinSStewart$elm_uint64$UInt64$charToHexDigit = function (_char) {
	switch (_char) {
		case '0':
			return $elm$core$Maybe$Just(0);
		case '1':
			return $elm$core$Maybe$Just(1);
		case '2':
			return $elm$core$Maybe$Just(2);
		case '3':
			return $elm$core$Maybe$Just(3);
		case '4':
			return $elm$core$Maybe$Just(4);
		case '5':
			return $elm$core$Maybe$Just(5);
		case '6':
			return $elm$core$Maybe$Just(6);
		case '7':
			return $elm$core$Maybe$Just(7);
		case '8':
			return $elm$core$Maybe$Just(8);
		case '9':
			return $elm$core$Maybe$Just(9);
		case 'A':
			return $elm$core$Maybe$Just(10);
		case 'B':
			return $elm$core$Maybe$Just(11);
		case 'C':
			return $elm$core$Maybe$Just(12);
		case 'D':
			return $elm$core$Maybe$Just(13);
		case 'E':
			return $elm$core$Maybe$Just(14);
		case 'F':
			return $elm$core$Maybe$Just(15);
		case 'a':
			return $elm$core$Maybe$Just(10);
		case 'b':
			return $elm$core$Maybe$Just(11);
		case 'c':
			return $elm$core$Maybe$Just(12);
		case 'd':
			return $elm$core$Maybe$Just(13);
		case 'e':
			return $elm$core$Maybe$Just(14);
		case 'f':
			return $elm$core$Maybe$Just(15);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $MartinSStewart$elm_uint64$UInt64$charToOctalDigit = function (_char) {
	switch (_char) {
		case '0':
			return $elm$core$Maybe$Just(0);
		case '1':
			return $elm$core$Maybe$Just(1);
		case '2':
			return $elm$core$Maybe$Just(2);
		case '3':
			return $elm$core$Maybe$Just(3);
		case '4':
			return $elm$core$Maybe$Just(4);
		case '5':
			return $elm$core$Maybe$Just(5);
		case '6':
			return $elm$core$Maybe$Just(6);
		case '7':
			return $elm$core$Maybe$Just(7);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $MartinSStewart$elm_uint64$UInt64$UInt64 = $elm$core$Basics$identity;
var $MartinSStewart$elm_uint64$UInt64$limit24 = 16777216;
var $MartinSStewart$elm_uint64$UInt64$max16 = 65535;
var $MartinSStewart$elm_uint64$UInt64$max24 = 16777215;
var $MartinSStewart$elm_uint64$UInt64$add$ = function (_v0, _v2) {
	var _v1 = _v0;
	var highA = _v1.a;
	var midA = _v1.b;
	var lowA = _v1.c;
	var _v3 = _v2;
	var highB = _v3.a;
	var midB = _v3.b;
	var lowB = _v3.c;
	var low = lowA + lowB;
	var mid = (_Utils_cmp(low, $MartinSStewart$elm_uint64$UInt64$limit24) < 0) ? (midA + midB) : ((midA + midB) + 1);
	var high = (_Utils_cmp(mid, $MartinSStewart$elm_uint64$UInt64$limit24) < 0) ? (highA + highB) : ((highA + highB) + 1);
	return _Utils_Tuple3($MartinSStewart$elm_uint64$UInt64$max16 & high, $MartinSStewart$elm_uint64$UInt64$max24 & mid, $MartinSStewart$elm_uint64$UInt64$max24 & low);
};
var $MartinSStewart$elm_uint64$UInt64$add = F2($MartinSStewart$elm_uint64$UInt64$add$);
var $MartinSStewart$elm_uint64$UInt64$limit48 = 281474976710656;
var $MartinSStewart$elm_uint64$UInt64$maxSafeHighPart = 31;
var $MartinSStewart$elm_uint64$UInt64$maxSafe = _Utils_Tuple3($MartinSStewart$elm_uint64$UInt64$maxSafeHighPart, $MartinSStewart$elm_uint64$UInt64$max24, $MartinSStewart$elm_uint64$UInt64$max24);
var $MartinSStewart$elm_uint64$UInt64$maxSafeInt = 9007199254740991;
var $MartinSStewart$elm_uint64$UInt64$zero = _Utils_Tuple3(0, 0, 0);
var $MartinSStewart$elm_uint64$UInt64$fromInt = function (x) {
	if (x <= 0) {
		return $MartinSStewart$elm_uint64$UInt64$zero;
	} else {
		if (_Utils_cmp(x, $MartinSStewart$elm_uint64$UInt64$maxSafeInt) < 1) {
			var high = $elm$core$Basics$floor(x / $MartinSStewart$elm_uint64$UInt64$limit48);
			var midLow = x - ($MartinSStewart$elm_uint64$UInt64$limit48 * high);
			var mid = $elm$core$Basics$floor(midLow / $MartinSStewart$elm_uint64$UInt64$limit24);
			var low = midLow - ($MartinSStewart$elm_uint64$UInt64$limit24 * mid);
			return _Utils_Tuple3(high, mid, low);
		} else {
			return $MartinSStewart$elm_uint64$UInt64$maxSafe;
		}
	}
};
var $MartinSStewart$elm_uint64$UInt64$mul$ = function (_v0, _v2) {
	var _v1 = _v0;
	var highA = _v1.a;
	var midA = _v1.b;
	var lowA = _v1.c;
	var _v3 = _v2;
	var highB = _v3.a;
	var midB = _v3.b;
	var lowB = _v3.c;
	var lowFull = lowA * lowB;
	var lowCarry = $elm$core$Basics$floor(lowFull / $MartinSStewart$elm_uint64$UInt64$limit24);
	var midFull = (lowCarry + (lowA * midB)) + (midA * lowB);
	var midCarry = $elm$core$Basics$floor(midFull / $MartinSStewart$elm_uint64$UInt64$limit24);
	var mid = midFull - (midCarry * $MartinSStewart$elm_uint64$UInt64$limit24);
	var low = lowFull - (lowCarry * $MartinSStewart$elm_uint64$UInt64$limit24);
	var high = $MartinSStewart$elm_uint64$UInt64$max16 & (((midCarry + (lowA * highB)) + (midA * midB)) + (highA * lowB));
	return _Utils_Tuple3(high, mid, low);
};
var $MartinSStewart$elm_uint64$UInt64$mul = F2($MartinSStewart$elm_uint64$UInt64$mul$);
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$core$String$right$ = function (n, string) {
	return (n < 1) ? '' : A3(
		$elm$core$String$slice,
		-n,
		$elm$core$String$length(string),
		string);
};
var $elm$core$String$right = F2($elm$core$String$right$);
var $MartinSStewart$elm_uint64$UInt64$fromDecimalString = function (str) {
	var length = $elm$core$String$length(str);
	if (A2($elm$core$String$startsWith, '-', str) || A2($elm$core$String$startsWith, '+', str)) {
		return $elm$core$Maybe$Nothing;
	} else {
		if (length <= 15) {
			var _v0 = $elm$core$String$toInt(str);
			if (!_v0.$) {
				var _int = _v0.a;
				return $elm$core$Maybe$Just(
					$MartinSStewart$elm_uint64$UInt64$fromInt(_int));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			if (length <= 20) {
				var lowStr = $elm$core$String$right$(10, str);
				if (A2($elm$core$String$startsWith, '-', lowStr) || A2($elm$core$String$startsWith, '+', lowStr)) {
					return $elm$core$Maybe$Nothing;
				} else {
					var _v1 = _Utils_Tuple2(
						$elm$core$String$toInt(
							$elm$core$String$dropRight$(10, str)),
						$elm$core$String$toInt(lowStr));
					if ((!_v1.a.$) && (!_v1.b.$)) {
						var highDecimal = _v1.a.a;
						var lowDecimal = _v1.b.a;
						return ((highDecimal > 1844674407) || ((highDecimal === 1844674407) && (lowDecimal > 3709551615))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							$MartinSStewart$elm_uint64$UInt64$add$(
								$MartinSStewart$elm_uint64$UInt64$fromInt(lowDecimal),
								$MartinSStewart$elm_uint64$UInt64$mul$(
									$MartinSStewart$elm_uint64$UInt64$fromInt(highDecimal),
									_Utils_Tuple3(0, 596, 779264))));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}
			} else {
				var prefix = $elm$core$String$dropRight$(20, str);
				return (!_Utils_eq(
					$elm$core$String$toInt(prefix),
					$elm$core$Maybe$Just(0))) ? $elm$core$Maybe$Nothing : $MartinSStewart$elm_uint64$UInt64$fromDecimalString(
					$elm$core$String$right$(20, str));
			}
		}
	}
};
var $MartinSStewart$elm_uint64$UInt64$charListToDigits$ = function (charToDigit, digitCount, digits, chars) {
	charListToDigits:
	while (true) {
		if (chars.b) {
			var x = chars.a;
			var xs = chars.b;
			var _v1 = charToDigit(x);
			if (!_v1.$) {
				var digit = _v1.a;
				var $temp$digitCount = digitCount + 1,
					$temp$digits = A2($elm$core$List$cons, digit, digits),
					$temp$chars = xs;
				digitCount = $temp$digitCount;
				digits = $temp$digits;
				chars = $temp$chars;
				continue charListToDigits;
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					digitCount,
					$elm$core$List$reverse(digits)));
		}
	}
};
var $MartinSStewart$elm_uint64$UInt64$charListToDigits = F4($MartinSStewart$elm_uint64$UInt64$charListToDigits$);
var $MartinSStewart$elm_uint64$UInt64$riskyFromNonDecimalDigitsHelper$ = function (bitsPerDigit, bitCount, high, mid, low, digits) {
	riskyFromNonDecimalDigitsHelper:
	while (true) {
		if (digits.b) {
			var x = digits.a;
			var xs = digits.b;
			if (bitCount <= 24) {
				var $temp$bitCount = bitCount - bitsPerDigit,
					$temp$low = x | (low << bitsPerDigit),
					$temp$digits = xs;
				bitCount = $temp$bitCount;
				low = $temp$low;
				digits = $temp$digits;
				continue riskyFromNonDecimalDigitsHelper;
			} else {
				if (bitCount <= 48) {
					var $temp$bitCount = bitCount - bitsPerDigit,
						$temp$mid = x | (mid << bitsPerDigit),
						$temp$digits = xs;
					bitCount = $temp$bitCount;
					mid = $temp$mid;
					digits = $temp$digits;
					continue riskyFromNonDecimalDigitsHelper;
				} else {
					var $temp$bitCount = bitCount - bitsPerDigit,
						$temp$high = x | (high << bitsPerDigit),
						$temp$digits = xs;
					bitCount = $temp$bitCount;
					high = $temp$high;
					digits = $temp$digits;
					continue riskyFromNonDecimalDigitsHelper;
				}
			}
		} else {
			return (_Utils_cmp(high, $MartinSStewart$elm_uint64$UInt64$max16) > 0) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				_Utils_Tuple3(high, mid, low));
		}
	}
};
var $MartinSStewart$elm_uint64$UInt64$riskyFromNonDecimalDigitsHelper = F6($MartinSStewart$elm_uint64$UInt64$riskyFromNonDecimalDigitsHelper$);
var $MartinSStewart$elm_uint64$UInt64$riskyFromNonDecimalDigits$ = function (bitsPerDigit, digitCount, digits) {
	var bitCount = digitCount * bitsPerDigit;
	return (bitCount <= 66) ? $MartinSStewart$elm_uint64$UInt64$riskyFromNonDecimalDigitsHelper$(bitsPerDigit, bitCount, 0, 0, 0, digits) : $elm$core$Maybe$Nothing;
};
var $MartinSStewart$elm_uint64$UInt64$riskyFromNonDecimalDigits = F3($MartinSStewart$elm_uint64$UInt64$riskyFromNonDecimalDigits$);
var $MartinSStewart$elm_uint64$UInt64$riskyFromNonEmptyNonDecimalChars$ = function (charToDigit, bitsPerDigit, chars) {
	riskyFromNonEmptyNonDecimalChars:
	while (true) {
		if (chars.b && ('0' === chars.a)) {
			var xs = chars.b;
			var $temp$chars = xs;
			chars = $temp$chars;
			continue riskyFromNonEmptyNonDecimalChars;
		} else {
			var noLeadingZeroes = chars;
			var _v1 = $MartinSStewart$elm_uint64$UInt64$charListToDigits$(charToDigit, 0, _List_Nil, noLeadingZeroes);
			if (!_v1.$) {
				var _v2 = _v1.a;
				var digitCount = _v2.a;
				var digits = _v2.b;
				return $MartinSStewart$elm_uint64$UInt64$riskyFromNonDecimalDigits$(bitsPerDigit, digitCount, digits);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	}
};
var $MartinSStewart$elm_uint64$UInt64$riskyFromNonEmptyNonDecimalChars = F3($MartinSStewart$elm_uint64$UInt64$riskyFromNonEmptyNonDecimalChars$);
var $MartinSStewart$elm_uint64$UInt64$fromString = function (str) {
	var fromNonDecimalString = F3(
		function (charToDigit, bitsPerDigit, drop2) {
			var _v6 = $elm$core$String$toList(drop2);
			if (!_v6.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var nonEmptyChars = _v6;
				return $MartinSStewart$elm_uint64$UInt64$riskyFromNonEmptyNonDecimalChars$(charToDigit, bitsPerDigit, nonEmptyChars);
			}
		});
	var _v0 = $elm$core$String$uncons(str);
	if ((!_v0.$) && ('0' === _v0.a.a)) {
		var _v1 = _v0.a;
		var drop1 = _v1.b;
		var _v2 = $elm$core$String$uncons(drop1);
		_v2$3:
		while (true) {
			if (!_v2.$) {
				switch (_v2.a.a) {
					case 'x':
						var _v3 = _v2.a;
						var drop2 = _v3.b;
						return A3(fromNonDecimalString, $MartinSStewart$elm_uint64$UInt64$charToHexDigit, 4, drop2);
					case 'o':
						var _v4 = _v2.a;
						var drop2 = _v4.b;
						return A3(fromNonDecimalString, $MartinSStewart$elm_uint64$UInt64$charToOctalDigit, 3, drop2);
					case 'b':
						var _v5 = _v2.a;
						var drop2 = _v5.b;
						return A3(fromNonDecimalString, $MartinSStewart$elm_uint64$UInt64$charToBinaryDigit, 1, drop2);
					default:
						break _v2$3;
				}
			} else {
				break _v2$3;
			}
		}
		return $MartinSStewart$elm_uint64$UInt64$fromDecimalString(str);
	} else {
		return $MartinSStewart$elm_uint64$UInt64$fromDecimalString(str);
	}
};
var $author$project$Discord$idFromString = function (text) {
	var _v0 = $MartinSStewart$elm_uint64$UInt64$fromString(text);
	if (!_v0.$) {
		var uint = _v0.a;
		return $elm$core$Maybe$Just(uint);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Discord$UserAuth$ = function (token, userAgent, xSuperProperties) {
	return {token: token, userAgent: userAgent, xSuperProperties: xSuperProperties};
};
var $author$project$Discord$UserAuth = F3($author$project$Discord$UserAuth$);
var $miniBill$elm_codec$Codec$Codec = $elm$core$Basics$identity;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		$elm$core$List$foldl$(
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $miniBill$elm_codec$Codec$buildObject = function (_v0) {
	var om = _v0;
	return {
		decoder: om.decoder,
		encoder: function (v) {
			return $elm$json$Json$Encode$object(
				$elm$core$List$reverse(
					om.encoder(v)));
		}
	};
};
var $miniBill$elm_codec$Codec$ObjectCodec = $elm$core$Basics$identity;
var $miniBill$elm_codec$Codec$encoder = function (_v0) {
	var m = _v0;
	return m.encoder;
};
var $elm$json$Json$Decode$field = _Json_decodeField;
var $miniBill$elm_codec$Codec$field$ = function (name, getter, codec, _v0) {
	var ocodec = _v0;
	return {
		decoder: A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (f, x) {
					return f(x);
				}),
			ocodec.decoder,
			A2(
				$elm$json$Json$Decode$field,
				name,
				$miniBill$elm_codec$Codec$decoder(codec))),
		encoder: function (v) {
			return A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					name,
					A2(
						$miniBill$elm_codec$Codec$encoder,
						codec,
						getter(v))),
				ocodec.encoder(v));
		},
		fields: A2($elm$core$List$cons, name, ocodec.fields)
	};
};
var $miniBill$elm_codec$Codec$field = F4($miniBill$elm_codec$Codec$field$);
var $miniBill$elm_codec$Codec$object = function (ctor) {
	return {
		decoder: $elm$json$Json$Decode$succeed(ctor),
		encoder: function (_v0) {
			return _List_Nil;
		},
		fields: _List_Nil
	};
};
var $miniBill$elm_codec$Codec$build$ = function (encoder_, decoder_) {
	return {decoder: decoder_, encoder: encoder_};
};
var $miniBill$elm_codec$Codec$build = F2($miniBill$elm_codec$Codec$build$);
var $elm$json$Json$Decode$string = _Json_decodeString;
var $elm$json$Json$Encode$string = _Json_wrap;
var $miniBill$elm_codec$Codec$string = $miniBill$elm_codec$Codec$build$($elm$json$Json$Encode$string, $elm$json$Json$Decode$string);
var $elm$core$Basics$composeL$ = function (g, f, x) {
	return g(
		f(x));
};
var $elm$core$Basics$composeL = F3($elm$core$Basics$composeL$);
var $miniBill$elm_codec$Codec$andThen$ = function (dec, enc, c) {
	return {
		decoder: A2(
			$elm$json$Json$Decode$andThen,
			A2($elm$core$Basics$composeR, dec, $miniBill$elm_codec$Codec$decoder),
			$miniBill$elm_codec$Codec$decoder(c)),
		encoder: A2(
			$elm$core$Basics$composeL,
			$miniBill$elm_codec$Codec$encoder(c),
			enc)
	};
};
var $miniBill$elm_codec$Codec$andThen = F3($miniBill$elm_codec$Codec$andThen$);
var $author$project$SafeJson$JsonArray = function (a) {
	return {$: 4, a: a};
};
var $author$project$SafeJson$JsonBool = function (a) {
	return {$: 2, a: a};
};
var $author$project$SafeJson$JsonNull = {$: 5};
var $author$project$SafeJson$JsonNumber = function (a) {
	return {$: 1, a: a};
};
var $author$project$SafeJson$JsonObject = function (a) {
	return {$: 3, a: a};
};
var $author$project$SafeJson$JsonString = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$SafeFloat$SafeFloat = $elm$core$Basics$identity;
var $elm$core$String$fromFloat = _String_fromNumber;
var $elm$core$Basics$isInfinite = _Basics_isInfinite;
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $author$project$SafeFloat$fromFloat = function (_float) {
	return ($elm$core$Basics$isNaN(_float) || $elm$core$Basics$isInfinite(_float)) ? $elm$core$Result$Err(
		'Invalid SafeFloat: ' + $elm$core$String$fromFloat(_float)) : $elm$core$Result$Ok(_float);
};
var $author$project$SafeFloat$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		var _v0 = $author$project$SafeFloat$fromFloat(a);
		if (!_v0.$) {
			var safe = _v0.a;
			return $elm$json$Json$Decode$succeed(safe);
		} else {
			var error = _v0.a;
			return $elm$json$Json$Decode$fail(error);
		}
	},
	$elm$json$Json$Decode$float);
var $elm$core$Dict$fromList = function (assocs) {
	return $elm$core$List$foldl$(
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return $elm$core$Dict$insert$(key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(0));
};
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
function $author$project$SafeJson$cyclic$decoder() {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $author$project$SafeJson$JsonString, $elm$json$Json$Decode$string),
				A2($elm$json$Json$Decode$map, $author$project$SafeJson$JsonNumber, $author$project$SafeFloat$decode),
				A2($elm$json$Json$Decode$map, $author$project$SafeJson$JsonBool, $elm$json$Json$Decode$bool),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$SafeJson$JsonObject,
				$elm$json$Json$Decode$dict(
					$elm$json$Json$Decode$lazy(
						function (_v0) {
							return $author$project$SafeJson$cyclic$decoder();
						}))),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$SafeJson$JsonArray,
				$elm$json$Json$Decode$list(
					$elm$json$Json$Decode$lazy(
						function (_v1) {
							return $author$project$SafeJson$cyclic$decoder();
						}))),
				$elm$json$Json$Decode$succeed($author$project$SafeJson$JsonNull)
			]));
}
var $author$project$SafeJson$decoder = $author$project$SafeJson$cyclic$decoder();
$author$project$SafeJson$cyclic$decoder = function () {
	return $author$project$SafeJson$decoder;
};
var $elm$core$Basics$always$ = function (a, _v0) {
	return a;
};
var $elm$core$Basics$always = F2($elm$core$Basics$always$);
var $miniBill$elm_codec$Codec$fail = function (msg) {
	return {
		decoder: $elm$json$Json$Decode$fail(msg),
		encoder: $elm$core$Basics$always($elm$json$Json$Encode$null)
	};
};
var $elm$bytes$Bytes$Decode$loopHelp$ = function (state, callback, bites, offset) {
	loopHelp:
	while (true) {
		var _v0 = callback(state);
		var decoder = _v0;
		var _v1 = A2(decoder, bites, offset);
		var newOffset = _v1.a;
		var step = _v1.b;
		if (!step.$) {
			var newState = step.a;
			var $temp$state = newState,
				$temp$offset = newOffset;
			state = $temp$state;
			offset = $temp$offset;
			continue loopHelp;
		} else {
			var result = step.a;
			return _Utils_Tuple2(newOffset, result);
		}
	}
};
var $elm$bytes$Bytes$Decode$loopHelp = F4($elm$bytes$Bytes$Decode$loopHelp$);
var $elm$bytes$Bytes$Decode$loop$ = function (state, callback) {
	return A2($elm$bytes$Bytes$Decode$loopHelp, state, callback);
};
var $elm$bytes$Bytes$Decode$loop = F2($elm$bytes$Bytes$Decode$loop$);
var $elm$bytes$Bytes$Decode$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$bytes$Bytes$Decode$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $danfishgold$base64_bytes$Decode$lowest6BitsMask = 63;
var $elm$core$Char$fromCode = _Char_fromCode;
var $danfishgold$base64_bytes$Decode$unsafeToChar = function (n) {
	if (n <= 25) {
		return $elm$core$Char$fromCode(65 + n);
	} else {
		if (n <= 51) {
			return $elm$core$Char$fromCode(97 + (n - 26));
		} else {
			if (n <= 61) {
				return $elm$core$Char$fromCode(48 + (n - 52));
			} else {
				switch (n) {
					case 62:
						return '+';
					case 63:
						return '/';
					default:
						return '\u0000';
				}
			}
		}
	}
};
var $danfishgold$base64_bytes$Decode$bitsToChars$ = function (bits, missing) {
	var s = $danfishgold$base64_bytes$Decode$unsafeToChar(bits & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
	var r = $danfishgold$base64_bytes$Decode$unsafeToChar((bits >>> 6) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
	var q = $danfishgold$base64_bytes$Decode$unsafeToChar((bits >>> 12) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
	var p = $danfishgold$base64_bytes$Decode$unsafeToChar(bits >>> 18);
	switch (missing) {
		case 0:
			return A2(
				$elm$core$String$cons,
				p,
				A2(
					$elm$core$String$cons,
					q,
					A2(
						$elm$core$String$cons,
						r,
						$elm$core$String$fromChar(s))));
		case 1:
			return A2(
				$elm$core$String$cons,
				p,
				A2(
					$elm$core$String$cons,
					q,
					A2($elm$core$String$cons, r, '=')));
		case 2:
			return A2(
				$elm$core$String$cons,
				p,
				A2($elm$core$String$cons, q, '=='));
		default:
			return '';
	}
};
var $danfishgold$base64_bytes$Decode$bitsToChars = F2($danfishgold$base64_bytes$Decode$bitsToChars$);
var $danfishgold$base64_bytes$Decode$bitsToCharSpecialized$ = function (bits1, bits2, bits3, accum) {
	var z = $danfishgold$base64_bytes$Decode$unsafeToChar((bits3 >>> 6) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
	var y = $danfishgold$base64_bytes$Decode$unsafeToChar((bits3 >>> 12) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
	var x = $danfishgold$base64_bytes$Decode$unsafeToChar(bits3 >>> 18);
	var w = $danfishgold$base64_bytes$Decode$unsafeToChar(bits3 & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
	var s = $danfishgold$base64_bytes$Decode$unsafeToChar(bits1 & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
	var r = $danfishgold$base64_bytes$Decode$unsafeToChar((bits1 >>> 6) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
	var q = $danfishgold$base64_bytes$Decode$unsafeToChar((bits1 >>> 12) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
	var p = $danfishgold$base64_bytes$Decode$unsafeToChar(bits1 >>> 18);
	var d = $danfishgold$base64_bytes$Decode$unsafeToChar(bits2 & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
	var c = $danfishgold$base64_bytes$Decode$unsafeToChar((bits2 >>> 6) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
	var b = $danfishgold$base64_bytes$Decode$unsafeToChar((bits2 >>> 12) & $danfishgold$base64_bytes$Decode$lowest6BitsMask);
	var a = $danfishgold$base64_bytes$Decode$unsafeToChar(bits2 >>> 18);
	return A2(
		$elm$core$String$cons,
		x,
		A2(
			$elm$core$String$cons,
			y,
			A2(
				$elm$core$String$cons,
				z,
				A2(
					$elm$core$String$cons,
					w,
					A2(
						$elm$core$String$cons,
						a,
						A2(
							$elm$core$String$cons,
							b,
							A2(
								$elm$core$String$cons,
								c,
								A2(
									$elm$core$String$cons,
									d,
									A2(
										$elm$core$String$cons,
										p,
										A2(
											$elm$core$String$cons,
											q,
											A2(
												$elm$core$String$cons,
												r,
												A2($elm$core$String$cons, s, accum))))))))))));
};
var $danfishgold$base64_bytes$Decode$bitsToCharSpecialized = F4($danfishgold$base64_bytes$Decode$bitsToCharSpecialized$);
var $danfishgold$base64_bytes$Decode$decode18Help$ = function (a, b, c, d, e) {
	var combined6 = ((255 & d) << 16) | e;
	var combined5 = d >>> 8;
	var combined4 = 16777215 & c;
	var combined3 = ((65535 & b) << 8) | (c >>> 24);
	var combined2 = ((255 & a) << 16) | (b >>> 16);
	var combined1 = a >>> 8;
	return $danfishgold$base64_bytes$Decode$bitsToCharSpecialized$(
		combined3,
		combined2,
		combined1,
		$danfishgold$base64_bytes$Decode$bitsToCharSpecialized$(combined6, combined5, combined4, ''));
};
var $danfishgold$base64_bytes$Decode$decode18Help = F5($danfishgold$base64_bytes$Decode$decode18Help$);
var $elm$bytes$Bytes$Decode$map5$ = function (func, _v0, _v1, _v2, _v3, _v4) {
	var decodeA = _v0;
	var decodeB = _v1;
	var decodeC = _v2;
	var decodeD = _v3;
	var decodeE = _v4;
	return F2(
		function (bites, offset) {
			var _v5 = A2(decodeA, bites, offset);
			var aOffset = _v5.a;
			var a = _v5.b;
			var _v6 = A2(decodeB, bites, aOffset);
			var bOffset = _v6.a;
			var b = _v6.b;
			var _v7 = A2(decodeC, bites, bOffset);
			var cOffset = _v7.a;
			var c = _v7.b;
			var _v8 = A2(decodeD, bites, cOffset);
			var dOffset = _v8.a;
			var d = _v8.b;
			var _v9 = A2(decodeE, bites, dOffset);
			var eOffset = _v9.a;
			var e = _v9.b;
			return _Utils_Tuple2(
				eOffset,
				A5(func, a, b, c, d, e));
		});
};
var $elm$bytes$Bytes$Decode$map5 = F6($elm$bytes$Bytes$Decode$map5$);
var $danfishgold$base64_bytes$Decode$u16BE = $elm$bytes$Bytes$Decode$unsignedInt16(1);
var $elm$bytes$Bytes$Decode$unsignedInt32 = function (endianness) {
	return _Bytes_read_u32(!endianness);
};
var $danfishgold$base64_bytes$Decode$u32BE = $elm$bytes$Bytes$Decode$unsignedInt32(1);
var $danfishgold$base64_bytes$Decode$decode18Bytes = $elm$bytes$Bytes$Decode$map5$($danfishgold$base64_bytes$Decode$decode18Help, $danfishgold$base64_bytes$Decode$u32BE, $danfishgold$base64_bytes$Decode$u32BE, $danfishgold$base64_bytes$Decode$u32BE, $danfishgold$base64_bytes$Decode$u32BE, $danfishgold$base64_bytes$Decode$u16BE);
var $elm$bytes$Bytes$Decode$map3$ = function (func, _v0, _v1, _v2) {
	var decodeA = _v0;
	var decodeB = _v1;
	var decodeC = _v2;
	return F2(
		function (bites, offset) {
			var _v3 = A2(decodeA, bites, offset);
			var aOffset = _v3.a;
			var a = _v3.b;
			var _v4 = A2(decodeB, bites, aOffset);
			var bOffset = _v4.a;
			var b = _v4.b;
			var _v5 = A2(decodeC, bites, bOffset);
			var cOffset = _v5.a;
			var c = _v5.b;
			return _Utils_Tuple2(
				cOffset,
				A3(func, a, b, c));
		});
};
var $elm$bytes$Bytes$Decode$map3 = F4($elm$bytes$Bytes$Decode$map3$);
var $danfishgold$base64_bytes$Decode$loopHelp = function (_v0) {
	var string = _v0.string;
	var remaining = _v0.remaining;
	if (remaining >= 18) {
		return $elm$bytes$Bytes$Decode$map$(
			function (result) {
				return $elm$bytes$Bytes$Decode$Loop(
					{
						remaining: remaining - 18,
						string: _Utils_ap(string, result)
					});
			},
			$danfishgold$base64_bytes$Decode$decode18Bytes);
	} else {
		if (remaining >= 3) {
			var helper = F3(
				function (a, b, c) {
					var combined = ((a << 16) | (b << 8)) | c;
					return $elm$bytes$Bytes$Decode$Loop(
						{
							remaining: remaining - 3,
							string: _Utils_ap(
								string,
								$danfishgold$base64_bytes$Decode$bitsToChars$(combined, 0))
						});
				});
			return $elm$bytes$Bytes$Decode$map3$(helper, $elm$bytes$Bytes$Decode$unsignedInt8, $elm$bytes$Bytes$Decode$unsignedInt8, $elm$bytes$Bytes$Decode$unsignedInt8);
		} else {
			if (!remaining) {
				return $elm$bytes$Bytes$Decode$succeed(
					$elm$bytes$Bytes$Decode$Done(string));
			} else {
				if (remaining === 2) {
					var helper = F2(
						function (a, b) {
							var combined = (a << 16) | (b << 8);
							return $elm$bytes$Bytes$Decode$Done(
								_Utils_ap(
									string,
									$danfishgold$base64_bytes$Decode$bitsToChars$(combined, 1)));
						});
					return $elm$bytes$Bytes$Decode$map2$(helper, $elm$bytes$Bytes$Decode$unsignedInt8, $elm$bytes$Bytes$Decode$unsignedInt8);
				} else {
					return $elm$bytes$Bytes$Decode$map$(
						function (a) {
							return $elm$bytes$Bytes$Decode$Done(
								_Utils_ap(
									string,
									$danfishgold$base64_bytes$Decode$bitsToChars$(a << 16, 2)));
						},
						$elm$bytes$Bytes$Decode$unsignedInt8);
				}
			}
		}
	}
};
var $danfishgold$base64_bytes$Decode$decoder = function (width) {
	return $elm$bytes$Bytes$Decode$loop$(
		{remaining: width, string: ''},
		$danfishgold$base64_bytes$Decode$loopHelp);
};
var $elm$bytes$Bytes$width = _Bytes_width;
var $danfishgold$base64_bytes$Decode$fromBytes = function (bytes) {
	return $elm$bytes$Bytes$Decode$decode$(
		$danfishgold$base64_bytes$Decode$decoder(
			$elm$bytes$Bytes$width(bytes)),
		bytes);
};
var $danfishgold$base64_bytes$Base64$fromBytes = $danfishgold$base64_bytes$Decode$fromBytes;
var $elm$bytes$Bytes$Encode$Utf8$ = function (a, b) {
	return {$: 9, a: a, b: b};
};
var $elm$bytes$Bytes$Encode$Utf8 = F2($elm$bytes$Bytes$Encode$Utf8$);
var $elm$bytes$Bytes$Encode$string = function (str) {
	return $elm$bytes$Bytes$Encode$Utf8$(
		_Bytes_getStringWidth(str),
		str);
};
var $danfishgold$base64_bytes$Base64$fromString = function (string) {
	return $danfishgold$base64_bytes$Base64$fromBytes(
		$elm$bytes$Bytes$Encode$encode(
			$elm$bytes$Bytes$Encode$string(string)));
};
var $miniBill$elm_codec$Codec$succeed = function (default_) {
	return {
		decoder: $elm$json$Json$Decode$succeed(default_),
		encoder: function (_v0) {
			return $elm$json$Json$Encode$null;
		}
	};
};
var $elm$bytes$Bytes$Decode$string = function (n) {
	return _Bytes_read_string(n);
};
var $danfishgold$base64_bytes$Base64$toString = function (b64String) {
	var _v0 = $danfishgold$base64_bytes$Base64$toBytes(b64String);
	if (_v0.$ === 1) {
		return $elm$core$Maybe$Nothing;
	} else {
		var b64Bytes = _v0.a;
		return $elm$bytes$Bytes$Decode$decode$(
			$elm$bytes$Bytes$Decode$string(
				$elm$bytes$Bytes$width(b64Bytes)),
			b64Bytes);
	}
};
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$SafeFloat$toFloat = function (_v0) {
	var a = _v0;
	return a;
};
var $author$project$SafeFloat$encode = function (value) {
	return $elm$json$Json$Encode$float(
		$author$project$SafeFloat$toFloat(value));
};
var $author$project$SafeJson$encoder = function (safeJson) {
	switch (safeJson.$) {
		case 0:
			var text = safeJson.a;
			return $elm$json$Json$Encode$string(text);
		case 1:
			var _float = safeJson.a;
			return $author$project$SafeFloat$encode(_float);
		case 2:
			var bool = safeJson.a;
			return $elm$json$Json$Encode$bool(bool);
		case 3:
			var dict = safeJson.a;
			return $elm$json$Json$Encode$object(
				$elm$core$List$map$(
					function (_v1) {
						var key = _v1.a;
						var value = _v1.b;
						return _Utils_Tuple2(
							key,
							$author$project$SafeJson$encoder(value));
					},
					$elm$core$Dict$toList(dict)));
		case 4:
			var safeJsons = safeJson.a;
			return $elm$json$Json$Encode$list$($author$project$SafeJson$encoder, safeJsons);
		default:
			return $elm$json$Json$Encode$null;
	}
};
var $author$project$SafeJson$toString$ = function (indentation, json) {
	return A2(
		$elm$json$Json$Encode$encode,
		indentation,
		$author$project$SafeJson$encoder(json));
};
var $author$project$SafeJson$toString = F2($author$project$SafeJson$toString$);
var $author$project$User$superPropertiesCodec = $miniBill$elm_codec$Codec$andThen$(
	function (base64) {
		var _v0 = $danfishgold$base64_bytes$Base64$toString(base64);
		if (!_v0.$) {
			var text = _v0.a;
			var _v1 = A2($elm$json$Json$Decode$decodeString, $author$project$SafeJson$decoder, text);
			if (!_v1.$) {
				var json = _v1.a;
				return $miniBill$elm_codec$Codec$succeed(json);
			} else {
				return $miniBill$elm_codec$Codec$fail('Invalid json');
			}
		} else {
			return $miniBill$elm_codec$Codec$fail('Invalid base64');
		}
	},
	function (a) {
		return $elm$core$Maybe$withDefault$(
			'',
			$danfishgold$base64_bytes$Base64$fromString(
				$author$project$SafeJson$toString$(0, a)));
	},
	$miniBill$elm_codec$Codec$string);
var $author$project$User$linkDiscordDataCodec = $miniBill$elm_codec$Codec$buildObject(
	$miniBill$elm_codec$Codec$field$(
		'xSuperProperties',
		function ($) {
			return $.xSuperProperties;
		},
		$author$project$User$superPropertiesCodec,
		$miniBill$elm_codec$Codec$field$(
			'userAgent',
			function ($) {
				return $.userAgent;
			},
			$miniBill$elm_codec$Codec$string,
			$miniBill$elm_codec$Codec$field$(
				'token',
				function ($) {
					return $.token;
				},
				$miniBill$elm_codec$Codec$string,
				$miniBill$elm_codec$Codec$object($author$project$Discord$UserAuth)))));
var $author$project$Route$linkDiscordErrorParam = 'error';
var $author$project$Route$linkDiscordQueryParam = 'data';
var $elm$core$Result$mapError$ = function (f, result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Result$Ok(v);
	} else {
		var e = result.a;
		return $elm$core$Result$Err(
			f(e));
	}
};
var $elm$core$Result$mapError = F2($elm$core$Result$mapError$);
var $author$project$Route$overlayParam = 'overlay';
var $author$project$Route$searchOverlayValue = 'search';
var $author$project$Route$showMembersParam = 'show-members';
var $author$project$Id$NoThreadWithMaybeMessage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Id$ViewThreadWithMaybeMessage$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Id$ViewThreadWithMaybeMessage = F2($author$project$Id$ViewThreadWithMaybeMessage$);
var $author$project$Route$slackThreadRouteFromPath = function (rest) {
	_v0$3:
	while (true) {
		if (rest.b && rest.b.b) {
			if (rest.b.b.b) {
				if ((((rest.a === 't') && (rest.b.b.a === 'm')) && rest.b.b.b.b) && (!rest.b.b.b.b.b)) {
					var _v2 = rest.b;
					var threadId = _v2.a;
					var _v3 = _v2.b;
					var _v4 = _v3.b;
					var messageIndex = _v4.a;
					var _v5 = $author$project$Id$fromString(threadId);
					if (!_v5.$) {
						var threadId2 = _v5.a;
						return $author$project$Id$ViewThreadWithMaybeMessage$(
							threadId2,
							$author$project$Id$fromString(messageIndex));
					} else {
						return $author$project$Id$NoThreadWithMaybeMessage($elm$core$Maybe$Nothing);
					}
				} else {
					break _v0$3;
				}
			} else {
				switch (rest.a) {
					case 'm':
						var _v1 = rest.b;
						var messageIndex = _v1.a;
						return $author$project$Id$NoThreadWithMaybeMessage(
							$author$project$Id$fromString(messageIndex));
					case 't':
						var _v6 = rest.b;
						var threadId = _v6.a;
						var _v7 = $author$project$Id$fromString(threadId);
						if (!_v7.$) {
							var threadId2 = _v7.a;
							return $author$project$Id$ViewThreadWithMaybeMessage$(threadId2, $elm$core$Maybe$Nothing);
						} else {
							return $author$project$Id$NoThreadWithMaybeMessage($elm$core$Maybe$Nothing);
						}
					default:
						break _v0$3;
				}
			}
		} else {
			break _v0$3;
		}
	}
	return $author$project$Id$NoThreadWithMaybeMessage($elm$core$Maybe$Nothing);
};
var $author$project$Route$ViewThreadWithFriends$ = function (a, b, c) {
	return {$: 1, a: a, b: b, c: c};
};
var $author$project$Route$ViewThreadWithFriends = F3($author$project$Route$ViewThreadWithFriends$);
var $author$project$Route$stringToThread$ = function (showMembers, text, maybeMessageIndex) {
	var _v0 = $author$project$Id$fromString(text);
	if (!_v0.$) {
		var messageIndex = _v0.a;
		return $author$project$Route$ViewThreadWithFriends$(
			messageIndex,
			$author$project$Id$fromString(maybeMessageIndex),
			showMembers);
	} else {
		return $author$project$Route$NoThreadWithFriends$(
			$author$project$Id$fromString(maybeMessageIndex),
			showMembers);
	}
};
var $author$project$Route$stringToThread = F3($author$project$Route$stringToThread$);
var $author$project$Route$userOptionsOverlayValue = 'user-options';
var $author$project$Route$decode = function (url) {
	var url2 = $lydell$elm_app_url$AppUrl$fromUrl(url);
	var showMembers = function () {
		var _v64 = $elm$core$Dict$get$($author$project$Route$showMembersParam, url2.queryParameters);
		if ((((!_v64.$) && _v64.a.b) && (_v64.a.a === 'True')) && (!_v64.a.b.b)) {
			var _v65 = _v64.a;
			return 0;
		} else {
			return 1;
		}
	}();
	var overlay = function () {
		var _v62 = $elm$core$Dict$get$($author$project$Route$overlayParam, url2.queryParameters);
		if (((!_v62.$) && _v62.a.b) && (!_v62.a.b.b)) {
			var _v63 = _v62.a;
			var value = _v63.a;
			return _Utils_eq(value, $author$project$Route$e2eeInfoOverlayValue) ? $elm$core$Maybe$Just(0) : (_Utils_eq(value, $author$project$Route$userOptionsOverlayValue) ? $elm$core$Maybe$Just(1) : (_Utils_eq(value, $author$project$Route$searchOverlayValue) ? $elm$core$Maybe$Just(2) : $elm$core$Maybe$Nothing));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	var channelsVisible = function () {
		var _v60 = $elm$core$Dict$get$($author$project$Route$guildChannelsVisibleParam, url2.queryParameters);
		if ((((!_v60.$) && _v60.a.b) && (_v60.a.a === 'True')) && (!_v60.a.b.b)) {
			var _v61 = _v60.a;
			return 1;
		} else {
			return 0;
		}
	}();
	var _v0 = url2.path;
	_v0$14:
	while (true) {
		if (_v0.b) {
			if (!_v0.b.b) {
				switch (_v0.a) {
					case 'admin':
						return $author$project$Route$AdminRoute(
							{
								highlightLog: function () {
									var _v1 = $elm$core$Dict$get$('highlight-log', url2.queryParameters);
									if (((!_v1.$) && _v1.a.b) && (!_v1.a.b.b)) {
										var _v2 = _v1.a;
										var a = _v2.a;
										return $elm$core$Maybe$map$(
											$author$project$Id$fromInt,
											$elm$core$String$toInt(a));
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}()
							});
					case 'new-guild':
						return $author$project$Route$NewGuildRoute;
					case 'ai-chat':
						return $author$project$Route$AiChatRoute;
					case 'text-editor':
						return $author$project$Route$TextEditorRoute;
					case 'privacy':
						return $author$project$Route$PrivacyRoute;
					case 'link-discord':
						var _v53 = _Utils_Tuple2(
							$elm$core$Dict$get$($author$project$Route$linkDiscordQueryParam, url2.queryParameters),
							$elm$core$Dict$get$($author$project$Route$linkDiscordErrorParam, url2.queryParameters));
						_v53$0:
						while (true) {
							_v53$4:
							while (true) {
								if (((!_v53.b.$) && _v53.b.a.b) && (!_v53.b.a.b.b)) {
									switch (_v53.b.a.a) {
										case 'server-error':
											if (((!_v53.a.$) && _v53.a.a.b) && (!_v53.a.a.b.b)) {
												break _v53$0;
											} else {
												var _v56 = _v53.b.a;
												return $author$project$Route$LinkDiscord(
													$elm$core$Result$Err(1));
											}
										case 'invalid-data':
											if (((!_v53.a.$) && _v53.a.a.b) && (!_v53.a.a.b.b)) {
												break _v53$0;
											} else {
												var _v57 = _v53.b.a;
												return $author$project$Route$LinkDiscord(
													$elm$core$Result$Err(2));
											}
										case 'limit-reached':
											if (((!_v53.a.$) && _v53.a.a.b) && (!_v53.a.a.b.b)) {
												break _v53$0;
											} else {
												var _v58 = _v53.b.a;
												return $author$project$Route$LinkDiscord(
													$elm$core$Result$Err(3));
											}
										default:
											if (((!_v53.a.$) && _v53.a.a.b) && (!_v53.a.a.b.b)) {
												break _v53$0;
											} else {
												break _v53$4;
											}
									}
								} else {
									if (((!_v53.a.$) && _v53.a.a.b) && (!_v53.a.a.b.b)) {
										break _v53$0;
									} else {
										break _v53$4;
									}
								}
							}
							return $author$project$Route$LinkDiscord(
								$elm$core$Result$Err(0));
						}
						var _v54 = _v53.a.a;
						var data = _v54.a;
						return $author$project$Route$LinkDiscord(
							$elm$core$Result$mapError$(
								function (_v55) {
									return 2;
								},
								A2($miniBill$elm_codec$Codec$decodeString, $author$project$User$linkDiscordDataCodec, data)));
					default:
						break _v0$14;
				}
			} else {
				switch (_v0.a) {
					case 'g':
						var _v3 = _v0.b;
						var guildId = _v3.a;
						var rest = _v3.b;
						var _v4 = $author$project$Id$fromString(guildId);
						if (!_v4.$) {
							var guildId2 = _v4.a;
							_v5$4:
							while (true) {
								if (rest.b) {
									if (!rest.b.b) {
										switch (rest.a) {
											case 'new':
												return $author$project$Route$GuildRoute$(guildId2, $author$project$Route$NewChannelRoute, channelsVisible, overlay);
											case 'settings':
												return $author$project$Route$GuildRoute$(guildId2, $author$project$Route$GuildSettingsRoute, channelsVisible, overlay);
											default:
												break _v5$4;
										}
									} else {
										switch (rest.a) {
											case 'c':
												var _v6 = rest.b;
												var channelId = _v6.a;
												var rest2 = _v6.b;
												var _v7 = _Utils_Tuple2(
													$author$project$Id$fromString(channelId),
													rest2);
												_v7$4:
												while (true) {
													if (!_v7.a.$) {
														if (_v7.b.b) {
															if (_v7.b.b.b) {
																if (_v7.b.b.b.b) {
																	if ((((_v7.b.a === 't') && (_v7.b.b.b.a === 'm')) && _v7.b.b.b.b.b) && (!_v7.b.b.b.b.b.b)) {
																		var channelId2 = _v7.a.a;
																		var _v8 = _v7.b;
																		var _v9 = _v8.b;
																		var threadMessageIndex = _v9.a;
																		var _v10 = _v9.b;
																		var _v11 = _v10.b;
																		var messageIndex = _v11.a;
																		return $author$project$Route$GuildRoute$(
																			guildId2,
																			$author$project$Route$ChannelRoute$(
																				channelId2,
																				$author$project$Route$stringToThread$(showMembers, threadMessageIndex, messageIndex),
																				$author$project$Route$decodeChannelHeaderTab(url2)),
																			channelsVisible,
																			overlay);
																	} else {
																		break _v7$4;
																	}
																} else {
																	switch (_v7.b.a) {
																		case 't':
																			var channelId2 = _v7.a.a;
																			var _v12 = _v7.b;
																			var _v13 = _v12.b;
																			var threadMessageIndex = _v13.a;
																			return $author$project$Route$GuildRoute$(
																				guildId2,
																				$author$project$Route$ChannelRoute$(
																					channelId2,
																					$author$project$Route$stringToThread$(showMembers, threadMessageIndex, ''),
																					$author$project$Route$decodeChannelHeaderTab(url2)),
																				channelsVisible,
																				overlay);
																		case 'm':
																			var channelId2 = _v7.a.a;
																			var _v14 = _v7.b;
																			var _v15 = _v14.b;
																			var messageIndex = _v15.a;
																			return $author$project$Route$GuildRoute$(
																				guildId2,
																				$author$project$Route$ChannelRoute$(
																					channelId2,
																					$author$project$Route$NoThreadWithFriends$(
																						$author$project$Id$fromString(messageIndex),
																						showMembers),
																					$author$project$Route$decodeChannelHeaderTab(url2)),
																				channelsVisible,
																				overlay);
																		default:
																			break _v7$4;
																	}
																}
															} else {
																break _v7$4;
															}
														} else {
															var channelId2 = _v7.a.a;
															return $author$project$Route$GuildRoute$(
																guildId2,
																$author$project$Route$ChannelRoute$(
																	channelId2,
																	$author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, showMembers),
																	$author$project$Route$decodeChannelHeaderTab(url2)),
																channelsVisible,
																overlay);
														}
													} else {
														break _v7$4;
													}
												}
												return $author$project$Route$HomePageRoute(overlay);
											case 'join':
												if (!rest.b.b.b) {
													var _v16 = rest.b;
													var inviteLinkId = _v16.a;
													return $author$project$Route$GuildRoute$(
														guildId2,
														$author$project$Route$JoinRoute(
															$author$project$SecretId$fromString(inviteLinkId)),
														channelsVisible,
														overlay);
												} else {
													break _v5$4;
												}
											default:
												break _v5$4;
										}
									}
								} else {
									break _v5$4;
								}
							}
							return $author$project$Route$HomePageRoute(overlay);
						} else {
							return $author$project$Route$HomePageRoute(overlay);
						}
					case 'dg':
						if (_v0.b.b.b) {
							var _v17 = _v0.b;
							var userId = _v17.a;
							var _v18 = _v17.b;
							var guildId = _v18.a;
							var rest = _v18.b;
							var _v19 = _Utils_Tuple2(
								$author$project$Discord$idFromString(userId),
								$author$project$Discord$idFromString(guildId));
							if ((!_v19.a.$) && (!_v19.b.$)) {
								var userId2 = _v19.a.a;
								var guildId2 = _v19.b.a;
								_v20$3:
								while (true) {
									if (rest.b) {
										if (rest.b.b) {
											if (rest.a === 'c') {
												var _v21 = rest.b;
												var channelId = _v21.a;
												var rest2 = _v21.b;
												var _v22 = _Utils_Tuple2(
													$author$project$Discord$idFromString(channelId),
													rest2);
												_v22$4:
												while (true) {
													if (!_v22.a.$) {
														if (_v22.b.b) {
															if (_v22.b.b.b) {
																if (_v22.b.b.b.b) {
																	if ((((_v22.b.a === 't') && (_v22.b.b.b.a === 'm')) && _v22.b.b.b.b.b) && (!_v22.b.b.b.b.b.b)) {
																		var channelId2 = _v22.a.a;
																		var _v23 = _v22.b;
																		var _v24 = _v23.b;
																		var threadMessageIndex = _v24.a;
																		var _v25 = _v24.b;
																		var _v26 = _v25.b;
																		var messageIndex = _v26.a;
																		return $author$project$Route$DiscordGuildRoute(
																			$author$project$Route$DiscordGuildRouteData$(
																				userId2,
																				guildId2,
																				$author$project$Route$DiscordChannel_ChannelRoute$(
																					channelId2,
																					$author$project$Route$stringToThread$(showMembers, threadMessageIndex, messageIndex),
																					$author$project$Route$decodeChannelHeaderTab(url2)),
																				channelsVisible,
																				overlay));
																	} else {
																		break _v22$4;
																	}
																} else {
																	switch (_v22.b.a) {
																		case 't':
																			var channelId2 = _v22.a.a;
																			var _v27 = _v22.b;
																			var _v28 = _v27.b;
																			var threadMessageIndex = _v28.a;
																			return $author$project$Route$DiscordGuildRoute(
																				$author$project$Route$DiscordGuildRouteData$(
																					userId2,
																					guildId2,
																					$author$project$Route$DiscordChannel_ChannelRoute$(
																						channelId2,
																						$author$project$Route$stringToThread$(showMembers, threadMessageIndex, ''),
																						$author$project$Route$decodeChannelHeaderTab(url2)),
																					channelsVisible,
																					overlay));
																		case 'm':
																			var channelId2 = _v22.a.a;
																			var _v29 = _v22.b;
																			var _v30 = _v29.b;
																			var messageIndex = _v30.a;
																			return $author$project$Route$DiscordGuildRoute(
																				$author$project$Route$DiscordGuildRouteData$(
																					userId2,
																					guildId2,
																					$author$project$Route$DiscordChannel_ChannelRoute$(
																						channelId2,
																						$author$project$Route$NoThreadWithFriends$(
																							$author$project$Id$fromString(messageIndex),
																							showMembers),
																						$author$project$Route$decodeChannelHeaderTab(url2)),
																					channelsVisible,
																					overlay));
																		default:
																			break _v22$4;
																	}
																}
															} else {
																break _v22$4;
															}
														} else {
															var channelId2 = _v22.a.a;
															return $author$project$Route$DiscordGuildRoute(
																$author$project$Route$DiscordGuildRouteData$(
																	userId2,
																	guildId2,
																	$author$project$Route$DiscordChannel_ChannelRoute$(
																		channelId2,
																		$author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, showMembers),
																		$author$project$Route$decodeChannelHeaderTab(url2)),
																	channelsVisible,
																	overlay));
														}
													} else {
														break _v22$4;
													}
												}
												return $author$project$Route$HomePageRoute(overlay);
											} else {
												break _v20$3;
											}
										} else {
											switch (rest.a) {
												case 'new':
													return $author$project$Route$DiscordGuildRoute(
														$author$project$Route$DiscordGuildRouteData$(userId2, guildId2, $author$project$Route$DiscordChannel_NewChannelRoute, channelsVisible, overlay));
												case 'settings':
													return $author$project$Route$DiscordGuildRoute(
														$author$project$Route$DiscordGuildRouteData$(userId2, guildId2, $author$project$Route$DiscordChannel_GuildSettingsRoute, channelsVisible, overlay));
												default:
													break _v20$3;
											}
										}
									} else {
										break _v20$3;
									}
								}
								return $author$project$Route$HomePageRoute(overlay);
							} else {
								return $author$project$Route$HomePageRoute(overlay);
							}
						} else {
							break _v0$14;
						}
					case 'd':
						var _v31 = _v0.b;
						var channelId = _v31.a;
						var rest = _v31.b;
						var _v32 = $author$project$DmChannelId$fromString(channelId);
						if (!_v32.$) {
							var channelId2 = _v32.a;
							return $author$project$Route$DmRoute(
								function () {
									_v33$3:
									while (true) {
										if (rest.b && rest.b.b) {
											if (rest.b.b.b) {
												if ((((rest.a === 't') && (rest.b.b.a === 'm')) && rest.b.b.b.b) && (!rest.b.b.b.b.b)) {
													var _v34 = rest.b;
													var threadMessageIndex = _v34.a;
													var _v35 = _v34.b;
													var _v36 = _v35.b;
													var messageIndex = _v36.a;
													return {
														channelId: channelId2,
														channelsVisible: channelsVisible,
														overlay: overlay,
														tab: $author$project$Route$decodeChannelHeaderTab(url2),
														threadRoute: $author$project$Route$stringToThread$(showMembers, threadMessageIndex, messageIndex)
													};
												} else {
													break _v33$3;
												}
											} else {
												switch (rest.a) {
													case 't':
														var _v37 = rest.b;
														var threadMessageIndex = _v37.a;
														return {
															channelId: channelId2,
															channelsVisible: channelsVisible,
															overlay: overlay,
															tab: $author$project$Route$decodeChannelHeaderTab(url2),
															threadRoute: $author$project$Route$stringToThread$(showMembers, threadMessageIndex, '')
														};
													case 'm':
														var _v38 = rest.b;
														var messageIndex = _v38.a;
														return {
															channelId: channelId2,
															channelsVisible: channelsVisible,
															overlay: overlay,
															tab: $author$project$Route$decodeChannelHeaderTab(url2),
															threadRoute: $author$project$Route$NoThreadWithFriends$(
																$author$project$Id$fromString(messageIndex),
																showMembers)
														};
													default:
														break _v33$3;
												}
											}
										} else {
											break _v33$3;
										}
									}
									return {
										channelId: channelId2,
										channelsVisible: channelsVisible,
										overlay: overlay,
										tab: $author$project$Route$decodeChannelHeaderTab(url2),
										threadRoute: $author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, showMembers)
									};
								}());
						} else {
							return $author$project$Route$HomePageRoute(overlay);
						}
					case 'dd':
						if (_v0.b.b.b) {
							var _v39 = _v0.b;
							var userId = _v39.a;
							var _v40 = _v39.b;
							var otherUserId = _v40.a;
							var rest = _v40.b;
							var _v41 = _Utils_Tuple2(
								$author$project$Discord$idFromString(userId),
								$author$project$Discord$idFromString(otherUserId));
							if ((!_v41.a.$) && (!_v41.b.$)) {
								var userId2 = _v41.a.a;
								var otherUserId2 = _v41.b.a;
								return $author$project$Route$DiscordDmRoute(
									{
										channelId: otherUserId2,
										channelsVisible: channelsVisible,
										currentDiscordUserId: userId2,
										overlay: overlay,
										showMembersTab: showMembers,
										tab: $author$project$Route$decodeChannelHeaderTab(url2),
										viewingMessage: function () {
											if (((rest.b && (rest.a === 'm')) && rest.b.b) && (!rest.b.b.b)) {
												var _v43 = rest.b;
												var messageIndex = _v43.a;
												return $author$project$Id$fromString(messageIndex);
											} else {
												return $elm$core$Maybe$Nothing;
											}
										}()
									});
							} else {
								return $author$project$Route$HomePageRoute(overlay);
							}
						} else {
							break _v0$14;
						}
					case 'sw':
						if (_v0.b.b.b && _v0.b.b.b.b) {
							if (_v0.b.b.b.b.b) {
								if (_v0.b.b.b.a === 'c') {
									var _v44 = _v0.b;
									var userId = _v44.a;
									var _v45 = _v44.b;
									var teamId = _v45.a;
									var _v46 = _v45.b;
									var _v47 = _v46.b;
									var channelId = _v47.a;
									var rest = _v47.b;
									return $author$project$Route$SlackWorkspaceRoute(
										{
											channelRoute: $author$project$Route$SlackChannel_ChannelRoute$(
												channelId,
												$author$project$Route$slackThreadRouteFromPath(rest),
												showMembers),
											channelsVisible: channelsVisible,
											currentSlackUserId: userId,
											overlay: overlay,
											teamId: teamId
										});
								} else {
									break _v0$14;
								}
							} else {
								if (_v0.b.b.b.a === 'settings') {
									var _v48 = _v0.b;
									var userId = _v48.a;
									var _v49 = _v48.b;
									var teamId = _v49.a;
									var _v50 = _v49.b;
									return $author$project$Route$SlackWorkspaceRoute(
										{channelRoute: $author$project$Route$SlackChannel_WorkspaceSettingsRoute, channelsVisible: channelsVisible, currentSlackUserId: userId, overlay: overlay, teamId: teamId});
								} else {
									break _v0$14;
								}
							}
						} else {
							break _v0$14;
						}
					case 'sd':
						if (_v0.b.b.b) {
							var _v51 = _v0.b;
							var userId = _v51.a;
							var _v52 = _v51.b;
							var channelId = _v52.a;
							var rest = _v52.b;
							return $author$project$Route$SlackDmRoute(
								{
									channelId: channelId,
									channelsVisible: channelsVisible,
									currentSlackUserId: userId,
									overlay: overlay,
									threadRoute: $author$project$Route$slackThreadRouteFromPath(rest)
								});
						} else {
							break _v0$14;
						}
					case 'go-match':
						if (!_v0.b.b.b) {
							var _v59 = _v0.b;
							var goMatchPublicId = _v59.a;
							return $author$project$Route$PublicGoMatchRoute(
								$author$project$SecretId$fromString(goMatchPublicId));
						} else {
							break _v0$14;
						}
					default:
						break _v0$14;
				}
			}
		} else {
			break _v0$14;
		}
	}
	return $author$project$Route$HomePageRoute(overlay);
};
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + $elm$core$String$join$(
			'&',
			$elm$core$List$map$($elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$absolute$ = function (pathSegments, parameters) {
	return '/' + ($elm$core$String$join$('/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
};
var $elm$url$Url$Builder$absolute = F2($elm$url$Url$Builder$absolute$);
var $author$project$Serialize$encodeToBytes$ = function (codec, value) {
	return $elm$bytes$Bytes$Encode$encode(
		$elm$bytes$Bytes$Encode$sequence(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8($author$project$Serialize$version),
					A2($author$project$Serialize$getBytesEncoderHelper, codec, value)
				])));
};
var $author$project$Serialize$encodeToBytes = F2($author$project$Serialize$encodeToBytes$);
var $author$project$Serialize$replaceForUrl = $elm$core$Maybe$withDefault$(
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('[\u005C+/=]'));
var $author$project$Serialize$replaceBase64Chars = function () {
	var replaceChar = function (rematch) {
		var _v0 = rematch.match;
		switch (_v0) {
			case '+':
				return '-';
			case '/':
				return '_';
			default:
				return '';
		}
	};
	return A2(
		$elm$core$Basics$composeR,
		$danfishgold$base64_bytes$Base64$fromBytes,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$withDefault(''),
			A2($elm$regex$Regex$replace, $author$project$Serialize$replaceForUrl, replaceChar)));
}();
var $author$project$Serialize$encodeToString = function (codec) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Serialize$encodeToBytes(codec),
		$author$project$Serialize$replaceBase64Chars);
};
var $elm$url$Url$Builder$QueryParameter$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $elm$url$Url$Builder$QueryParameter = F2($elm$url$Url$Builder$QueryParameter$);
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$int$ = function (key, value) {
	return $elm$url$Url$Builder$QueryParameter$(
		$elm$url$Url$percentEncode(key),
		$elm$core$String$fromInt(value));
};
var $elm$url$Url$Builder$int = F2($elm$url$Url$Builder$int$);
var $elm$url$Url$Builder$string$ = function (key, value) {
	return $elm$url$Url$Builder$QueryParameter$(
		$elm$url$Url$percentEncode(key),
		$elm$url$Url$percentEncode(value));
};
var $elm$url$Url$Builder$string = F2($elm$url$Url$Builder$string$);
var $author$project$Route$encodeChannelHeaderTab = function (tab) {
	if (!tab.$) {
		switch (tab.a.$) {
			case 0:
				var _v1 = tab.a;
				return _List_fromArray(
					[
						$elm$url$Url$Builder$string$($author$project$Route$tabParam, 'call')
					]);
			case 1:
				var _v2 = tab.a;
				var maybeMatchId = _v2.a;
				var repliedTo = _v2.b;
				return A2(
					$elm$core$List$cons,
					$elm$url$Url$Builder$string$($author$project$Route$tabParam, 'game'),
					function () {
						if (!maybeMatchId.$) {
							var matchId = maybeMatchId.a;
							return A2(
								$elm$core$List$cons,
								$elm$url$Url$Builder$int$(
									$author$project$Route$goMatchParam,
									$author$project$Id$toInt(matchId)),
								function () {
									if (!repliedTo.$) {
										var repliedTo2 = repliedTo.a;
										return _List_fromArray(
											[
												$elm$url$Url$Builder$string$(
												$author$project$Route$repliedToGameParam,
												A2($author$project$Serialize$encodeToString, $author$project$Message$repliedToGameCodec, repliedTo2))
											]);
									} else {
										return _List_Nil;
									}
								}());
						} else {
							return _List_Nil;
						}
					}());
			case 2:
				var _v5 = tab.a;
				return _List_fromArray(
					[
						$elm$url$Url$Builder$string$($author$project$Route$tabParam, 'description')
					]);
			default:
				var _v6 = tab.a;
				return _List_fromArray(
					[
						$elm$url$Url$Builder$string$($author$project$Route$tabParam, 'draw')
					]);
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Route$encodeChannelsVisible = function (channelsVisible) {
	if (channelsVisible === 1) {
		return _List_fromArray(
			[
				$elm$url$Url$Builder$string$($author$project$Route$guildChannelsVisibleParam, 'True')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Route$encodeOverlay = function (overlay) {
	if (!overlay.$) {
		switch (overlay.a) {
			case 0:
				var _v1 = overlay.a;
				return _List_fromArray(
					[
						$elm$url$Url$Builder$string$($author$project$Route$overlayParam, $author$project$Route$e2eeInfoOverlayValue)
					]);
			case 1:
				var _v2 = overlay.a;
				return _List_fromArray(
					[
						$elm$url$Url$Builder$string$($author$project$Route$overlayParam, $author$project$Route$userOptionsOverlayValue)
					]);
			default:
				var _v3 = overlay.a;
				return _List_fromArray(
					[
						$elm$url$Url$Builder$string$($author$project$Route$overlayParam, $author$project$Route$searchOverlayValue)
					]);
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Route$encodeShowMembers = function (showMembers) {
	if (!showMembers) {
		return _List_fromArray(
			[
				$elm$url$Url$Builder$string$($author$project$Route$showMembersParam, 'True')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Discord$idToUInt64 = function (_v0) {
	var id = _v0;
	return id;
};
var $MartinSStewart$elm_uint64$UInt64$compare$ = function (_v0, _v2) {
	var _v1 = _v0;
	var highA = _v1.a;
	var midA = _v1.b;
	var lowA = _v1.c;
	var _v3 = _v2;
	var highB = _v3.a;
	var midB = _v3.b;
	var lowB = _v3.c;
	var _v4 = A2($elm$core$Basics$compare, highA, highB);
	if (_v4 === 1) {
		var _v5 = A2($elm$core$Basics$compare, midA, midB);
		if (_v5 === 1) {
			return A2($elm$core$Basics$compare, lowA, lowB);
		} else {
			var midNotEq = _v5;
			return midNotEq;
		}
	} else {
		var highNotEq = _v4;
		return highNotEq;
	}
};
var $MartinSStewart$elm_uint64$UInt64$compare = F2($MartinSStewart$elm_uint64$UInt64$compare$);
var $MartinSStewart$elm_uint64$UInt64$compare72_64$ = function (_v0, _v2) {
	var _v1 = _v0;
	var highA = _v1.a;
	var midA = _v1.b;
	var lowA = _v1.c;
	var _v3 = _v2;
	var highB = _v3.a;
	var midB = _v3.b;
	var lowB = _v3.c;
	var _v4 = A2($elm$core$Basics$compare, highA, highB);
	if (_v4 === 1) {
		var _v5 = A2($elm$core$Basics$compare, midA, midB);
		if (_v5 === 1) {
			return A2($elm$core$Basics$compare, lowA, lowB);
		} else {
			var midNotEq = _v5;
			return midNotEq;
		}
	} else {
		var highNotEq = _v4;
		return highNotEq;
	}
};
var $MartinSStewart$elm_uint64$UInt64$compare72_64 = F2($MartinSStewart$elm_uint64$UInt64$compare72_64$);
var $MartinSStewart$elm_uint64$UInt64$maxValue = _Utils_Tuple3($MartinSStewart$elm_uint64$UInt64$max16, $MartinSStewart$elm_uint64$UInt64$max24, $MartinSStewart$elm_uint64$UInt64$max24);
var $MartinSStewart$elm_uint64$UInt64$decrement = function (_v0) {
	var _v1 = _v0;
	var high = _v1.a;
	var mid = _v1.b;
	var low = _v1.c;
	return (low > 0) ? _Utils_Tuple3(high, mid, low - 1) : ((mid > 0) ? _Utils_Tuple3(high, mid - 1, $MartinSStewart$elm_uint64$UInt64$max24) : ((high > 0) ? _Utils_Tuple3(high - 1, $MartinSStewart$elm_uint64$UInt64$max24, $MartinSStewart$elm_uint64$UInt64$max24) : $MartinSStewart$elm_uint64$UInt64$maxValue));
};
var $MartinSStewart$elm_uint64$UInt64$divModFloat$ = function (a, b) {
	var div_ = $elm$core$Basics$floor(a / b);
	return _Utils_Tuple2(div_, a - (b * div_));
};
var $MartinSStewart$elm_uint64$UInt64$divModFloat = F2($MartinSStewart$elm_uint64$UInt64$divModFloat$);
var $MartinSStewart$elm_uint64$UInt64$minCertainInteger = 4503599627370496.0;
var $MartinSStewart$elm_uint64$UInt64$floorAnyPositiveFloat = function (x) {
	return (_Utils_cmp(x, $MartinSStewart$elm_uint64$UInt64$minCertainInteger) > -1) ? x : $elm$core$Basics$floor(x);
};
var $MartinSStewart$elm_uint64$UInt64$increment = function (_v0) {
	var _v1 = _v0;
	var high = _v1.a;
	var mid = _v1.b;
	var low = _v1.c;
	return (_Utils_cmp(low, $MartinSStewart$elm_uint64$UInt64$max24) < 0) ? _Utils_Tuple3(high, mid, low + 1) : ((_Utils_cmp(mid, $MartinSStewart$elm_uint64$UInt64$max24) < 0) ? _Utils_Tuple3(high, mid + 1, 0) : ((_Utils_cmp(high, $MartinSStewart$elm_uint64$UInt64$max16) < 0) ? _Utils_Tuple3(high + 1, 0, 0) : $MartinSStewart$elm_uint64$UInt64$zero));
};
var $MartinSStewart$elm_uint64$UInt64$isSafe72 = function (_v0) {
	var _v1 = _v0;
	var high = _v1.a;
	return _Utils_cmp(high, $MartinSStewart$elm_uint64$UInt64$maxSafeHighPart) < 1;
};
var $MartinSStewart$elm_uint64$UInt64$isZero = function (_v0) {
	var _v1 = _v0;
	var high = _v1.a;
	var mid = _v1.b;
	var low = _v1.c;
	return (!low) && ((!mid) && (!high));
};
var $MartinSStewart$elm_uint64$UInt64$UInt72 = $elm$core$Basics$identity;
var $MartinSStewart$elm_uint64$UInt64$mul64_64_72$ = function (_v0, _v2) {
	var _v1 = _v0;
	var highA = _v1.a;
	var midA = _v1.b;
	var lowA = _v1.c;
	var _v3 = _v2;
	var highB = _v3.a;
	var midB = _v3.b;
	var lowB = _v3.c;
	var lowFull = lowA * lowB;
	var lowCarry = $elm$core$Basics$floor(lowFull / $MartinSStewart$elm_uint64$UInt64$limit24);
	var midFull = (lowCarry + (lowA * midB)) + (midA * lowB);
	var midCarry = $elm$core$Basics$floor(midFull / $MartinSStewart$elm_uint64$UInt64$limit24);
	var mid = midFull - (midCarry * $MartinSStewart$elm_uint64$UInt64$limit24);
	var low = lowFull - (lowCarry * $MartinSStewart$elm_uint64$UInt64$limit24);
	var high = $MartinSStewart$elm_uint64$UInt64$max24 & (((midCarry + (lowA * highB)) + (midA * midB)) + (highA * lowB));
	return _Utils_Tuple3(high, mid, low);
};
var $MartinSStewart$elm_uint64$UInt64$mul64_64_72 = F2($MartinSStewart$elm_uint64$UInt64$mul64_64_72$);
var $MartinSStewart$elm_uint64$UInt64$risky72to64 = function (_v0) {
	var tuple = _v0;
	return tuple;
};
var $MartinSStewart$elm_uint64$UInt64$riskyFloatTo64 = function (x) {
	var highMid = $elm$core$Basics$floor(x / $MartinSStewart$elm_uint64$UInt64$limit24);
	var low = $elm$core$Basics$floor(x) - (highMid * $MartinSStewart$elm_uint64$UInt64$limit24);
	var high = $elm$core$Basics$floor(highMid / $MartinSStewart$elm_uint64$UInt64$limit24);
	var mid = highMid - (high * $MartinSStewart$elm_uint64$UInt64$limit24);
	return _Utils_Tuple3(high, mid, low);
};
var $MartinSStewart$elm_uint64$UInt64$sub$ = function (_v0, _v2) {
	var _v1 = _v0;
	var highA = _v1.a;
	var midA = _v1.b;
	var lowA = _v1.c;
	var _v3 = _v2;
	var highB = _v3.a;
	var midB = _v3.b;
	var lowB = _v3.c;
	var low = lowA - lowB;
	var mid = (low >= 0) ? (midA - midB) : ((midA - midB) - 1);
	var high = (mid >= 0) ? (highA - highB) : ((highA - highB) - 1);
	return _Utils_Tuple3($MartinSStewart$elm_uint64$UInt64$max16 & high, $MartinSStewart$elm_uint64$UInt64$max24 & mid, $MartinSStewart$elm_uint64$UInt64$max24 & low);
};
var $MartinSStewart$elm_uint64$UInt64$sub = F2($MartinSStewart$elm_uint64$UInt64$sub$);
var $MartinSStewart$elm_uint64$UInt64$sub72_64_72$ = function (_v0, _v2) {
	var _v1 = _v0;
	var highA = _v1.a;
	var midA = _v1.b;
	var lowA = _v1.c;
	var _v3 = _v2;
	var highB = _v3.a;
	var midB = _v3.b;
	var lowB = _v3.c;
	var low = lowA - lowB;
	var mid = (low >= 0) ? (midA - midB) : ((midA - midB) - 1);
	var high = (mid >= 0) ? (highA - highB) : ((highA - highB) - 1);
	return _Utils_Tuple3($MartinSStewart$elm_uint64$UInt64$max24 & high, $MartinSStewart$elm_uint64$UInt64$max24 & mid, $MartinSStewart$elm_uint64$UInt64$max24 & low);
};
var $MartinSStewart$elm_uint64$UInt64$sub72_64_72 = F2($MartinSStewart$elm_uint64$UInt64$sub72_64_72$);
var $MartinSStewart$elm_uint64$UInt64$toFloat = function (_v0) {
	var _v1 = _v0;
	var high = _v1.a;
	var mid = _v1.b;
	var low = _v1.c;
	return (((high * $MartinSStewart$elm_uint64$UInt64$limit24) + mid) * $MartinSStewart$elm_uint64$UInt64$limit24) + low;
};
var $MartinSStewart$elm_uint64$UInt64$toFloat72 = function (_v0) {
	var _v1 = _v0;
	var high = _v1.a;
	var mid = _v1.b;
	var low = _v1.c;
	return (((high * $MartinSStewart$elm_uint64$UInt64$limit24) + mid) * $MartinSStewart$elm_uint64$UInt64$limit24) + low;
};
var $MartinSStewart$elm_uint64$UInt64$divModFast$ = function (dividend, divisor) {
	if ($MartinSStewart$elm_uint64$UInt64$isZero(divisor)) {
		return $elm$core$Result$Ok(
			_Utils_Tuple2($MartinSStewart$elm_uint64$UInt64$zero, $MartinSStewart$elm_uint64$UInt64$zero));
	} else {
		var approxDivisor = $MartinSStewart$elm_uint64$UInt64$toFloat(divisor);
		var approxDiv = $MartinSStewart$elm_uint64$UInt64$riskyFloatTo64(
			$MartinSStewart$elm_uint64$UInt64$floorAnyPositiveFloat(
				$MartinSStewart$elm_uint64$UInt64$toFloat(dividend) / approxDivisor));
		var approxDivMultiplied72 = $MartinSStewart$elm_uint64$UInt64$mul64_64_72$(approxDiv, divisor);
		var _v0 = $MartinSStewart$elm_uint64$UInt64$compare72_64$(approxDivMultiplied72, dividend);
		switch (_v0) {
			case 1:
				return $elm$core$Result$Ok(
					_Utils_Tuple2(approxDiv, $MartinSStewart$elm_uint64$UInt64$zero));
			case 0:
				var delta = $MartinSStewart$elm_uint64$UInt64$sub$(
					dividend,
					$MartinSStewart$elm_uint64$UInt64$risky72to64(approxDivMultiplied72));
				var _v1 = $MartinSStewart$elm_uint64$UInt64$compare$(delta, divisor);
				switch (_v1) {
					case 0:
						return $elm$core$Result$Ok(
							_Utils_Tuple2(approxDiv, delta));
					case 1:
						return $elm$core$Result$Ok(
							_Utils_Tuple2(
								$MartinSStewart$elm_uint64$UInt64$increment(approxDiv),
								$MartinSStewart$elm_uint64$UInt64$zero));
					default:
						var secondApproxDiv = $MartinSStewart$elm_uint64$UInt64$add$(
							approxDiv,
							$MartinSStewart$elm_uint64$UInt64$riskyFloatTo64(
								$MartinSStewart$elm_uint64$UInt64$floorAnyPositiveFloat(
									$MartinSStewart$elm_uint64$UInt64$toFloat(delta) / approxDivisor)));
						var secondApproxDivMultiplied = $MartinSStewart$elm_uint64$UInt64$mul$(secondApproxDiv, divisor);
						var _v2 = $MartinSStewart$elm_uint64$UInt64$compare$(secondApproxDivMultiplied, dividend);
						switch (_v2) {
							case 1:
								return $elm$core$Result$Ok(
									_Utils_Tuple2(secondApproxDiv, $MartinSStewart$elm_uint64$UInt64$zero));
							case 0:
								var secondDelta = $MartinSStewart$elm_uint64$UInt64$sub$(dividend, secondApproxDivMultiplied);
								var _v3 = $MartinSStewart$elm_uint64$UInt64$compare$(secondDelta, divisor);
								if (!_v3) {
									return $elm$core$Result$Ok(
										_Utils_Tuple2(secondApproxDiv, secondDelta));
								} else {
									return $elm$core$Result$Err('IMPOSSIBLE: secondDelta >= divisor');
								}
							default:
								return $elm$core$Result$Err('IMPOSSIBLE: secondApproxDivMultiplied > dividend');
						}
				}
			default:
				var delta72 = $MartinSStewart$elm_uint64$UInt64$sub72_64_72$(approxDivMultiplied72, dividend);
				var _v4 = $MartinSStewart$elm_uint64$UInt64$compare72_64$(delta72, divisor);
				switch (_v4) {
					case 0:
						return $elm$core$Result$Ok(
							_Utils_Tuple2(
								$MartinSStewart$elm_uint64$UInt64$decrement(approxDiv),
								$MartinSStewart$elm_uint64$UInt64$sub$(
									divisor,
									$MartinSStewart$elm_uint64$UInt64$risky72to64(delta72))));
					case 1:
						return $elm$core$Result$Ok(
							_Utils_Tuple2(
								$MartinSStewart$elm_uint64$UInt64$decrement(approxDiv),
								$MartinSStewart$elm_uint64$UInt64$zero));
					default:
						if ($MartinSStewart$elm_uint64$UInt64$isSafe72(delta72)) {
							var _v5 = $MartinSStewart$elm_uint64$UInt64$divModFloat$(
								$MartinSStewart$elm_uint64$UInt64$toFloat72(delta72),
								approxDivisor);
							var deltaDiv = _v5.a;
							var deltaMod = _v5.b;
							return (!deltaMod) ? $elm$core$Result$Ok(
								_Utils_Tuple2(
									$MartinSStewart$elm_uint64$UInt64$sub$(
										approxDiv,
										$MartinSStewart$elm_uint64$UInt64$riskyFloatTo64(deltaDiv)),
									$MartinSStewart$elm_uint64$UInt64$zero)) : $elm$core$Result$Ok(
								_Utils_Tuple2(
									$MartinSStewart$elm_uint64$UInt64$sub$(
										approxDiv,
										$MartinSStewart$elm_uint64$UInt64$riskyFloatTo64(deltaDiv + 1)),
									$MartinSStewart$elm_uint64$UInt64$riskyFloatTo64(approxDivisor - deltaMod)));
						} else {
							return $elm$core$Result$Err('IMPOSSIBLE: approxDivMultiplied72 > dividend && not (isSafe72 delta72)');
						}
				}
		}
	}
};
var $MartinSStewart$elm_uint64$UInt64$divModFast = F2($MartinSStewart$elm_uint64$UInt64$divModFast$);
var $MartinSStewart$elm_uint64$UInt64$getBit$ = function (givenBitNumber, _v0) {
	var _v1 = _v0;
	var high = _v1.a;
	var mid = _v1.b;
	var low = _v1.c;
	var bitNumber = 63 & givenBitNumber;
	return (bitNumber < 24) ? (1 & (low >>> bitNumber)) : ((bitNumber < 48) ? (1 & (mid >>> (bitNumber - 24))) : (1 & (high >>> (bitNumber - 48))));
};
var $MartinSStewart$elm_uint64$UInt64$getBit = F2($MartinSStewart$elm_uint64$UInt64$getBit$);
var $elm$core$Bitwise$complement = _Bitwise_complement;
var $MartinSStewart$elm_uint64$UInt64$setBit$ = function (givenBitNumber, givenBitValue, _v0) {
	var _v1 = _v0;
	var high = _v1.a;
	var mid = _v1.b;
	var low = _v1.c;
	var bitValue = 1 & givenBitValue;
	var bitNumber = 63 & givenBitNumber;
	return (bitNumber < 24) ? ((!bitValue) ? _Utils_Tuple3(high, mid, low & (~(1 << bitNumber))) : _Utils_Tuple3(high, mid, low | (1 << bitNumber))) : ((bitNumber < 48) ? ((!bitValue) ? _Utils_Tuple3(high, mid & (~(1 << (bitNumber - 24))), low) : _Utils_Tuple3(high, mid | (1 << (bitNumber - 24)), low)) : ((!bitValue) ? _Utils_Tuple3(high & (~(1 << (bitNumber - 48))), mid, low) : _Utils_Tuple3(high | (1 << (bitNumber - 48)), mid, low)));
};
var $MartinSStewart$elm_uint64$UInt64$setBit = F3($MartinSStewart$elm_uint64$UInt64$setBit$);
var $MartinSStewart$elm_uint64$UInt64$shiftLeftBy$ = function (givenShift, _v0) {
	var _v1 = _v0;
	var high = _v1.a;
	var mid = _v1.b;
	var low = _v1.c;
	var n = 63 & givenShift;
	return (n < 24) ? _Utils_Tuple3($MartinSStewart$elm_uint64$UInt64$max16 & ((high << n) | (mid >>> (24 - n))), $MartinSStewart$elm_uint64$UInt64$max24 & ((mid << n) | (low >>> (24 - n))), $MartinSStewart$elm_uint64$UInt64$max24 & (low << n)) : ((n < 48) ? _Utils_Tuple3($MartinSStewart$elm_uint64$UInt64$max16 & ((mid << (n - 24)) | (low >>> (48 - n))), $MartinSStewart$elm_uint64$UInt64$max24 & (low << (n - 24)), 0) : _Utils_Tuple3($MartinSStewart$elm_uint64$UInt64$max16 & (low << (n - 48)), 0, 0));
};
var $MartinSStewart$elm_uint64$UInt64$shiftLeftBy = F2($MartinSStewart$elm_uint64$UInt64$shiftLeftBy$);
var $MartinSStewart$elm_uint64$UInt64$divModSlow$ = function (dividend, divisor) {
	return $MartinSStewart$elm_uint64$UInt64$isZero(divisor) ? _Utils_Tuple2($MartinSStewart$elm_uint64$UInt64$zero, $MartinSStewart$elm_uint64$UInt64$zero) : $elm$core$List$foldl$(
		F2(
			function (n, _v0) {
				var div_ = _v0.a;
				var mod_ = _v0.b;
				var newMod = $MartinSStewart$elm_uint64$UInt64$setBit$(
					0,
					$MartinSStewart$elm_uint64$UInt64$getBit$(n, dividend),
					$MartinSStewart$elm_uint64$UInt64$shiftLeftBy$(1, mod_));
				return (!(!$MartinSStewart$elm_uint64$UInt64$compare$(newMod, divisor))) ? _Utils_Tuple2(
					$MartinSStewart$elm_uint64$UInt64$setBit$(n, 1, div_),
					$MartinSStewart$elm_uint64$UInt64$sub$(newMod, divisor)) : _Utils_Tuple2(div_, newMod);
			}),
		_Utils_Tuple2($MartinSStewart$elm_uint64$UInt64$zero, $MartinSStewart$elm_uint64$UInt64$zero),
		$elm$core$List$reverse(
			$elm$core$List$range$(0, 63)));
};
var $MartinSStewart$elm_uint64$UInt64$divModSlow = F2($MartinSStewart$elm_uint64$UInt64$divModSlow$);
var $MartinSStewart$elm_uint64$UInt64$isSafe = function (_v0) {
	var _v1 = _v0;
	var high = _v1.a;
	return _Utils_cmp(high, $MartinSStewart$elm_uint64$UInt64$maxSafeHighPart) < 1;
};
var $MartinSStewart$elm_uint64$UInt64$divMod$ = function (dividend, divisor) {
	var _v0 = divisor;
	var divisorHigh = _v0.a;
	var divisorMid = _v0.b;
	var divisorLow = _v0.c;
	if ((divisorMid <= 31) && (!divisorHigh)) {
		if ((!divisorLow) && (!divisorMid)) {
			return _Utils_Tuple2($MartinSStewart$elm_uint64$UInt64$zero, $MartinSStewart$elm_uint64$UInt64$zero);
		} else {
			var divisorFloat = $MartinSStewart$elm_uint64$UInt64$toFloat(divisor);
			var _v1 = dividend;
			var _v2 = _v1;
			var dividendHigh = _v2.a;
			var dividendMid = _v2.b;
			var dividendLow = _v2.c;
			var dividendHighMid = (dividendHigh * $MartinSStewart$elm_uint64$UInt64$limit24) + dividendMid;
			var quotHighMid = $elm$core$Basics$floor(dividendHighMid / divisorFloat);
			var highMidCarry = dividendHighMid - (divisorFloat * quotHighMid);
			var highMidCarryWithLow = (highMidCarry * $MartinSStewart$elm_uint64$UInt64$limit24) + dividendLow;
			var quotLow = $elm$core$Basics$floor(highMidCarryWithLow / divisorFloat);
			var modMidLow = highMidCarryWithLow - (divisorFloat * quotLow);
			var modMid = $elm$core$Basics$floor(modMidLow / $MartinSStewart$elm_uint64$UInt64$limit24);
			var modLow = $elm$core$Basics$floor(modMidLow) - (modMid * $MartinSStewart$elm_uint64$UInt64$limit24);
			var quotHigh = $elm$core$Basics$floor(quotHighMid / $MartinSStewart$elm_uint64$UInt64$limit24);
			var quotMid = quotHighMid - (quotHigh * $MartinSStewart$elm_uint64$UInt64$limit24);
			return _Utils_Tuple2(
				_Utils_Tuple3(quotHigh, quotMid, quotLow),
				_Utils_Tuple3(0, modMid, modLow));
		}
	} else {
		if ($MartinSStewart$elm_uint64$UInt64$isSafe(dividend)) {
			var divisorFloat = $MartinSStewart$elm_uint64$UInt64$toFloat(divisor);
			var dividendFloat = $MartinSStewart$elm_uint64$UInt64$toFloat(dividend);
			var quotInt = $elm$core$Basics$floor(dividendFloat / divisorFloat);
			var modFloat = dividendFloat - (divisorFloat * quotInt);
			var modHigh = $elm$core$Basics$floor(modFloat / $MartinSStewart$elm_uint64$UInt64$limit48);
			var modMidLow = modFloat - ($MartinSStewart$elm_uint64$UInt64$limit48 * modHigh);
			var modMid = $elm$core$Basics$floor(modMidLow / $MartinSStewart$elm_uint64$UInt64$limit24);
			var modLow = modMidLow - ($MartinSStewart$elm_uint64$UInt64$limit24 * modMid);
			var quotHigh = $elm$core$Basics$floor(quotInt / $MartinSStewart$elm_uint64$UInt64$limit48);
			var quotMidLow = quotInt - ($MartinSStewart$elm_uint64$UInt64$limit48 * quotHigh);
			var quotMid = $elm$core$Basics$floor(quotMidLow / $MartinSStewart$elm_uint64$UInt64$limit24);
			var quotLow = quotMidLow - ($MartinSStewart$elm_uint64$UInt64$limit24 * quotMid);
			return _Utils_Tuple2(
				_Utils_Tuple3(quotHigh, quotMid, quotLow),
				_Utils_Tuple3(
					modHigh,
					modMid,
					$elm$core$Basics$floor(modLow)));
		} else {
			var _v3 = $MartinSStewart$elm_uint64$UInt64$divModFast$(dividend, divisor);
			if (!_v3.$) {
				var divMod_ = _v3.a;
				return divMod_;
			} else {
				return $MartinSStewart$elm_uint64$UInt64$divModSlow$(dividend, divisor);
			}
		}
	}
};
var $MartinSStewart$elm_uint64$UInt64$divMod = F2($MartinSStewart$elm_uint64$UInt64$divMod$);
var $elm$core$String$padLeft$ = function (n, _char, string) {
	return _Utils_ap(
		$elm$core$String$repeat$(
			n - $elm$core$String$length(string),
			$elm$core$String$fromChar(_char)),
		string);
};
var $elm$core$String$padLeft = F3($elm$core$String$padLeft$);
var $MartinSStewart$elm_uint64$UInt64$toString = function (x) {
	var lowDecimalToDigits = function (_v3) {
		var _v4 = _v3;
		var low = _v4.c;
		return $elm$core$String$fromInt(low);
	};
	var highDecimalToDigits = function (_v1) {
		var _v2 = _v1;
		var mid = _v2.b;
		var low = _v2.c;
		return $elm$core$String$fromInt(low + ($MartinSStewart$elm_uint64$UInt64$limit24 * mid));
	};
	var divisor = _Utils_Tuple3(0, 0, 10000000);
	var _v0 = $MartinSStewart$elm_uint64$UInt64$divMod$(x, divisor);
	var highDecimal = _v0.a;
	var lowDecimal = _v0.b;
	return $MartinSStewart$elm_uint64$UInt64$isZero(highDecimal) ? lowDecimalToDigits(lowDecimal) : _Utils_ap(
		highDecimalToDigits(highDecimal),
		$elm$core$String$padLeft$(
			7,
			'0',
			lowDecimalToDigits(lowDecimal)));
};
var $author$project$Discord$idToString = function (id) {
	return $MartinSStewart$elm_uint64$UInt64$toString(
		$author$project$Discord$idToUInt64(id));
};
var $author$project$Slack$idToString = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$Route$linkDiscordPath = 'link-discord';
var $author$project$Id$toString = function (_v0) {
	var a = _v0;
	return $elm$core$String$fromInt(a);
};
var $author$project$Route$maybeMessageIdToString = function (maybeMessageIndex) {
	if (!maybeMessageIndex.$) {
		var messageIndex = maybeMessageIndex.a;
		return _List_fromArray(
			[
				'm',
				$author$project$Id$toString(messageIndex)
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Route$slackThreadRouteToPath = function (threadRoute) {
	if (!threadRoute.$) {
		var maybeMessageId = threadRoute.a;
		return $author$project$Route$maybeMessageIdToString(maybeMessageId);
	} else {
		var threadId = threadRoute.a;
		var maybeMessageId = threadRoute.b;
		return _Utils_ap(
			_List_fromArray(
				[
					't',
					$author$project$Id$toString(threadId)
				]),
			$author$project$Route$maybeMessageIdToString(maybeMessageId));
	}
};
var $author$project$DmChannelId$toString = function (_v0) {
	var userIdA = _v0.a;
	var userIdB = _v0.b;
	return $author$project$Id$toString(userIdA) + ('-' + $author$project$Id$toString(userIdB));
};
var $author$project$SecretId$toString = function (_v0) {
	var text = _v0;
	return text;
};
var $author$project$Route$encode = function (route) {
	var _v0 = function () {
		_v1$15:
		while (true) {
			switch (route.$) {
				case 0:
					var overlay = route.a;
					return _Utils_Tuple2(
						_List_Nil,
						$author$project$Route$encodeOverlay(overlay));
				case 1:
					var params = route.a;
					return _Utils_Tuple2(
						_List_fromArray(
							['admin']),
						function () {
							var _v2 = params.highlightLog;
							if (!_v2.$) {
								var a = _v2.a;
								return _List_fromArray(
									[
										$elm$url$Url$Builder$int$(
										'highlight-log',
										$author$project$Id$toInt(a))
									]);
							} else {
								return _List_Nil;
							}
						}());
				case 2:
					return _Utils_Tuple2(
						_List_fromArray(
							['new-guild']),
						_List_Nil);
				case 9:
					return _Utils_Tuple2(
						_List_fromArray(
							['ai-chat']),
						_List_Nil);
				case 3:
					var guildId = route.a;
					var maybeChannelId = route.b;
					var channelsVisible = route.c;
					var overlay = route.d;
					switch (maybeChannelId.$) {
						case 0:
							var channelId = maybeChannelId.a;
							var thread = maybeChannelId.b;
							var tab = maybeChannelId.c;
							if (thread.$ === 1) {
								var threadMessageIndex = thread.a;
								var maybeMessageId = thread.b;
								var showMembers = thread.c;
								return _Utils_Tuple2(
									_Utils_ap(
										_List_fromArray(
											[
												'g',
												$author$project$Id$toString(guildId),
												'c',
												$author$project$Id$toString(channelId),
												't',
												$author$project$Id$toString(threadMessageIndex)
											]),
										$author$project$Route$maybeMessageIdToString(maybeMessageId)),
									_Utils_ap(
										$author$project$Route$encodeShowMembers(showMembers),
										_Utils_ap(
											$author$project$Route$encodeChannelHeaderTab(tab),
											_Utils_ap(
												$author$project$Route$encodeChannelsVisible(channelsVisible),
												$author$project$Route$encodeOverlay(overlay)))));
							} else {
								var maybeMessageId = thread.a;
								var showMembers = thread.b;
								return _Utils_Tuple2(
									_Utils_ap(
										_List_fromArray(
											[
												'g',
												$author$project$Id$toString(guildId),
												'c',
												$author$project$Id$toString(channelId)
											]),
										$author$project$Route$maybeMessageIdToString(maybeMessageId)),
									_Utils_ap(
										$author$project$Route$encodeShowMembers(showMembers),
										_Utils_ap(
											$author$project$Route$encodeChannelHeaderTab(tab),
											_Utils_ap(
												$author$project$Route$encodeChannelsVisible(channelsVisible),
												$author$project$Route$encodeOverlay(overlay)))));
							}
						case 1:
							return _Utils_Tuple2(
								_List_fromArray(
									[
										'g',
										$author$project$Id$toString(guildId),
										'new'
									]),
								_Utils_ap(
									$author$project$Route$encodeChannelsVisible(channelsVisible),
									$author$project$Route$encodeOverlay(overlay)));
						case 2:
							return _Utils_Tuple2(
								_List_fromArray(
									[
										'g',
										$author$project$Id$toString(guildId),
										'settings'
									]),
								_Utils_ap(
									$author$project$Route$encodeChannelsVisible(channelsVisible),
									$author$project$Route$encodeOverlay(overlay)));
						default:
							var inviteLinkId = maybeChannelId.a;
							return _Utils_Tuple2(
								_List_fromArray(
									[
										'g',
										$author$project$Id$toString(guildId),
										'join',
										$author$project$SecretId$toString(inviteLinkId)
									]),
								_Utils_ap(
									$author$project$Route$encodeChannelsVisible(channelsVisible),
									$author$project$Route$encodeOverlay(overlay)));
					}
				case 4:
					var overlay = route.a.overlay;
					var channelsVisible = route.a.channelsVisible;
					var channelRoute = route.a.channelRoute;
					var guildId = route.a.guildId;
					var currentDiscordUserId = route.a.currentDiscordUserId;
					switch (channelRoute.$) {
						case 0:
							var channelId = channelRoute.a;
							var thread = channelRoute.b;
							var tab = channelRoute.c;
							if (thread.$ === 1) {
								var threadMessageIndex = thread.a;
								var maybeMessageId = thread.b;
								var showMembers = thread.c;
								return _Utils_Tuple2(
									_Utils_ap(
										_List_fromArray(
											[
												'dg',
												$author$project$Discord$idToString(currentDiscordUserId),
												$author$project$Discord$idToString(guildId),
												'c',
												$author$project$Discord$idToString(channelId),
												't',
												$author$project$Id$toString(threadMessageIndex)
											]),
										$author$project$Route$maybeMessageIdToString(maybeMessageId)),
									_Utils_ap(
										$author$project$Route$encodeShowMembers(showMembers),
										_Utils_ap(
											$author$project$Route$encodeChannelHeaderTab(tab),
											_Utils_ap(
												$author$project$Route$encodeChannelsVisible(channelsVisible),
												$author$project$Route$encodeOverlay(overlay)))));
							} else {
								var maybeMessageId = thread.a;
								var showMembers = thread.b;
								return _Utils_Tuple2(
									_Utils_ap(
										_List_fromArray(
											[
												'dg',
												$author$project$Discord$idToString(currentDiscordUserId),
												$author$project$Discord$idToString(guildId),
												'c',
												$author$project$Discord$idToString(channelId)
											]),
										$author$project$Route$maybeMessageIdToString(maybeMessageId)),
									_Utils_ap(
										$author$project$Route$encodeShowMembers(showMembers),
										_Utils_ap(
											$author$project$Route$encodeChannelHeaderTab(tab),
											_Utils_ap(
												$author$project$Route$encodeChannelsVisible(channelsVisible),
												$author$project$Route$encodeOverlay(overlay)))));
							}
						case 1:
							return _Utils_Tuple2(
								_List_fromArray(
									[
										'dg',
										$author$project$Discord$idToString(currentDiscordUserId),
										$author$project$Discord$idToString(guildId),
										'new'
									]),
								_Utils_ap(
									$author$project$Route$encodeChannelsVisible(channelsVisible),
									$author$project$Route$encodeOverlay(overlay)));
						default:
							return _Utils_Tuple2(
								_List_fromArray(
									[
										'dg',
										$author$project$Discord$idToString(currentDiscordUserId),
										$author$project$Discord$idToString(guildId),
										'settings'
									]),
								_Utils_ap(
									$author$project$Route$encodeChannelsVisible(channelsVisible),
									$author$project$Route$encodeOverlay(overlay)));
					}
				case 5:
					var overlay = route.a.overlay;
					var channelsVisible = route.a.channelsVisible;
					var tab = route.a.tab;
					var threadRoute = route.a.threadRoute;
					var channelId = route.a.channelId;
					if (threadRoute.$ === 1) {
						var threadMessageIndex = threadRoute.a;
						var maybeMessageId = threadRoute.b;
						var showMembers = threadRoute.c;
						return _Utils_Tuple2(
							_Utils_ap(
								_List_fromArray(
									[
										'd',
										$author$project$DmChannelId$toString(channelId),
										't',
										$author$project$Id$toString(threadMessageIndex)
									]),
								$author$project$Route$maybeMessageIdToString(maybeMessageId)),
							_Utils_ap(
								$author$project$Route$encodeShowMembers(showMembers),
								_Utils_ap(
									$author$project$Route$encodeChannelHeaderTab(tab),
									_Utils_ap(
										$author$project$Route$encodeChannelsVisible(channelsVisible),
										$author$project$Route$encodeOverlay(overlay)))));
					} else {
						var maybeMessageId = threadRoute.a;
						var showMembers = threadRoute.b;
						return _Utils_Tuple2(
							_Utils_ap(
								_List_fromArray(
									[
										'd',
										$author$project$DmChannelId$toString(channelId)
									]),
								$author$project$Route$maybeMessageIdToString(maybeMessageId)),
							_Utils_ap(
								$author$project$Route$encodeShowMembers(showMembers),
								_Utils_ap(
									$author$project$Route$encodeChannelHeaderTab(tab),
									_Utils_ap(
										$author$project$Route$encodeChannelsVisible(channelsVisible),
										$author$project$Route$encodeOverlay(overlay)))));
					}
				case 6:
					var overlay = route.a.overlay;
					var channelsVisible = route.a.channelsVisible;
					var tab = route.a.tab;
					var showMembersTab = route.a.showMembersTab;
					var viewingMessage = route.a.viewingMessage;
					var channelId = route.a.channelId;
					var currentDiscordUserId = route.a.currentDiscordUserId;
					return _Utils_Tuple2(
						_Utils_ap(
							_List_fromArray(
								[
									'dd',
									$author$project$Discord$idToString(currentDiscordUserId),
									$author$project$Discord$idToString(channelId)
								]),
							$author$project$Route$maybeMessageIdToString(viewingMessage)),
						_Utils_ap(
							$author$project$Route$encodeShowMembers(showMembersTab),
							_Utils_ap(
								$author$project$Route$encodeChannelHeaderTab(tab),
								_Utils_ap(
									$author$project$Route$encodeChannelsVisible(channelsVisible),
									$author$project$Route$encodeOverlay(overlay)))));
				case 7:
					var overlay = route.a.overlay;
					var channelsVisible = route.a.channelsVisible;
					var channelRoute = route.a.channelRoute;
					var teamId = route.a.teamId;
					var currentSlackUserId = route.a.currentSlackUserId;
					if (!channelRoute.$) {
						var channelId = channelRoute.a;
						var threadRoute = channelRoute.b;
						var showMembers = channelRoute.c;
						return _Utils_Tuple2(
							_Utils_ap(
								_List_fromArray(
									[
										'sw',
										$author$project$Slack$idToString(currentSlackUserId),
										$author$project$Slack$idToString(teamId),
										'c',
										$author$project$Slack$idToString(channelId)
									]),
								$author$project$Route$slackThreadRouteToPath(threadRoute)),
							_Utils_ap(
								$author$project$Route$encodeShowMembers(showMembers),
								_Utils_ap(
									$author$project$Route$encodeChannelsVisible(channelsVisible),
									$author$project$Route$encodeOverlay(overlay))));
					} else {
						return _Utils_Tuple2(
							_List_fromArray(
								[
									'sw',
									$author$project$Slack$idToString(currentSlackUserId),
									$author$project$Slack$idToString(teamId),
									'settings'
								]),
							_Utils_ap(
								$author$project$Route$encodeChannelsVisible(channelsVisible),
								$author$project$Route$encodeOverlay(overlay)));
					}
				case 8:
					var overlay = route.a.overlay;
					var channelsVisible = route.a.channelsVisible;
					var threadRoute = route.a.threadRoute;
					var channelId = route.a.channelId;
					var currentSlackUserId = route.a.currentSlackUserId;
					return _Utils_Tuple2(
						_Utils_ap(
							_List_fromArray(
								[
									'sd',
									$author$project$Slack$idToString(currentSlackUserId),
									$author$project$Slack$idToString(channelId)
								]),
							$author$project$Route$slackThreadRouteToPath(threadRoute)),
						_Utils_ap(
							$author$project$Route$encodeChannelsVisible(channelsVisible),
							$author$project$Route$encodeOverlay(overlay)));
				case 10:
					return _Utils_Tuple2(
						_List_fromArray(
							['text-editor']),
						_List_Nil);
				case 11:
					return _Utils_Tuple2(
						_List_fromArray(
							['privacy']),
						_List_Nil);
				case 12:
					if (route.a.$ === 1) {
						switch (route.a.a) {
							case 1:
								var _v9 = route.a.a;
								return _Utils_Tuple2(
									_List_fromArray(
										[$author$project$Route$linkDiscordPath]),
									_List_fromArray(
										[
											$elm$url$Url$Builder$string$($author$project$Route$linkDiscordErrorParam, 'server-error')
										]));
							case 2:
								var _v10 = route.a.a;
								return _Utils_Tuple2(
									_List_fromArray(
										[$author$project$Route$linkDiscordPath]),
									_List_fromArray(
										[
											$elm$url$Url$Builder$string$($author$project$Route$linkDiscordErrorParam, 'invalid-data')
										]));
							case 3:
								var _v11 = route.a.a;
								return _Utils_Tuple2(
									_List_fromArray(
										[$author$project$Route$linkDiscordPath]),
									_List_fromArray(
										[
											$elm$url$Url$Builder$string$($author$project$Route$linkDiscordErrorParam, 'limit-reached')
										]));
							default:
								break _v1$15;
						}
					} else {
						break _v1$15;
					}
				default:
					var goMatchPublicId = route.a;
					return _Utils_Tuple2(
						_List_fromArray(
							[
								'go-match',
								$author$project$SecretId$toString(goMatchPublicId)
							]),
						_List_Nil);
			}
		}
		return _Utils_Tuple2(
			_List_fromArray(
				[$author$project$Route$linkDiscordPath]),
			_List_Nil);
	}();
	var path = _v0.a;
	var query = _v0.b;
	return $elm$url$Url$Builder$absolute$(path, query);
};
var $lamdera$program_test$Effect$Internal$GetViewport = function (a) {
	return {$: 10, a: a};
};
var $lamdera$program_test$Effect$Internal$Succeed = function (a) {
	return {$: 0, a: a};
};
var $lamdera$program_test$Effect$Browser$Dom$getViewport = $lamdera$program_test$Effect$Internal$GetViewport($lamdera$program_test$Effect$Internal$Succeed);
var $author$project$Audio$AudioLoadRequest = function (a) {
	return {$: 0, a: a};
};
var $author$project$Audio$BufferId = $elm$core$Basics$identity;
var $author$project$Audio$ErrorThatHappensWhenYouLoadMoreThan1000SoundsDueToHackyWorkAroundToMakeThisPackageBehaveMoreLikeAnEffectPackage = 3;
var $author$project$Audio$FailedToDecode = 0;
var $author$project$Audio$File = $elm$core$Basics$identity;
var $author$project$Audio$NetworkError = 1;
var $mgold$elm_nonempty_list$List$Nonempty$Nonempty$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $mgold$elm_nonempty_list$List$Nonempty$Nonempty = F2($mgold$elm_nonempty_list$List$Nonempty$Nonempty$);
var $author$project$Audio$enumeratedResults = $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
	$elm$core$Result$Err(3),
	_Utils_ap(
		_List_fromArray(
			[
				$elm$core$Result$Err(0),
				$elm$core$Result$Err(1),
				$elm$core$Result$Err(2)
			]),
		$elm$core$List$map$(
			function (bufferId) {
				return $elm$core$Result$Ok(
					{bufferId: bufferId});
			},
			$elm$core$List$range$(0, 1000))));
var $mgold$elm_nonempty_list$List$Nonempty$map$ = function (f, _v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
		f(x),
		$elm$core$List$map$(f, xs));
};
var $mgold$elm_nonempty_list$List$Nonempty$map = F2($mgold$elm_nonempty_list$List$Nonempty$map$);
var $author$project$Audio$loadAudio$ = function (userMsg2, url) {
	return $author$project$Audio$AudioLoadRequest(
		{
			audioUrl: url,
			userMsg: $mgold$elm_nonempty_list$List$Nonempty$map$(
				function (results) {
					return _Utils_Tuple2(
						results,
						userMsg2(results));
				},
				$author$project$Audio$enumeratedResults)
		});
};
var $author$project$Audio$loadAudio = F2($author$project$Audio$loadAudio$);
var $author$project$Ports$load_startup_data_to_js = _Platform_outgoingPort('load_startup_data_to_js', $elm$core$Basics$identity);
var $lamdera$program_test$Effect$Internal$Port$ = function (a, b, c) {
	return {$: 11, a: a, b: b, c: c};
};
var $lamdera$program_test$Effect$Internal$Port = F3($lamdera$program_test$Effect$Internal$Port$);
var $lamdera$program_test$Effect$Command$sendToJs = $lamdera$program_test$Effect$Internal$Port;
var $author$project$Ports$loadStartupData = A3($lamdera$program_test$Effect$Command$sendToJs, 'load_startup_data_to_js', $author$project$Ports$load_startup_data_to_js, $elm$json$Json$Encode$null);
var $lamdera$program_test$Effect$Internal$None = {$: 1};
var $lamdera$program_test$Effect$Command$none = $lamdera$program_test$Effect$Internal$None;
var $lamdera$program_test$Effect$Internal$Task = function (a) {
	return {$: 10, a: a};
};
var $lamdera$program_test$Effect$Internal$Blur$ = function (a, b) {
	return {$: 9, a: a, b: b};
};
var $lamdera$program_test$Effect$Internal$Blur = F2($lamdera$program_test$Effect$Internal$Blur$);
var $lamdera$program_test$Effect$Internal$EndXrSession = function (a) {
	return {$: 21, a: a};
};
var $lamdera$program_test$Effect$Internal$Fail = function (a) {
	return {$: 1, a: a};
};
var $lamdera$program_test$Effect$Internal$FileToBytes$ = function (a, b) {
	return {$: 16, a: a, b: b};
};
var $lamdera$program_test$Effect$Internal$FileToBytes = F2($lamdera$program_test$Effect$Internal$FileToBytes$);
var $lamdera$program_test$Effect$Internal$FileToString$ = function (a, b) {
	return {$: 15, a: a, b: b};
};
var $lamdera$program_test$Effect$Internal$FileToString = F2($lamdera$program_test$Effect$Internal$FileToString$);
var $lamdera$program_test$Effect$Internal$FileToUrl$ = function (a, b) {
	return {$: 17, a: a, b: b};
};
var $lamdera$program_test$Effect$Internal$FileToUrl = F2($lamdera$program_test$Effect$Internal$FileToUrl$);
var $lamdera$program_test$Effect$Internal$Focus$ = function (a, b) {
	return {$: 8, a: a, b: b};
};
var $lamdera$program_test$Effect$Internal$Focus = F2($lamdera$program_test$Effect$Internal$Focus$);
var $lamdera$program_test$Effect$Internal$GetElement$ = function (a, b) {
	return {$: 14, a: a, b: b};
};
var $lamdera$program_test$Effect$Internal$GetElement = F2($lamdera$program_test$Effect$Internal$GetElement$);
var $lamdera$program_test$Effect$Internal$GetViewportOf$ = function (a, b) {
	return {$: 12, a: a, b: b};
};
var $lamdera$program_test$Effect$Internal$GetViewportOf = F2($lamdera$program_test$Effect$Internal$GetViewportOf$);
var $lamdera$program_test$Effect$Internal$HttpBytesTask = function (a) {
	return {$: 3, a: a};
};
var $lamdera$program_test$Effect$Internal$HttpStringTask = function (a) {
	return {$: 2, a: a};
};
var $lamdera$program_test$Effect$Internal$LoadTexture$ = function (a, b, c) {
	return {$: 18, a: a, b: b, c: c};
};
var $lamdera$program_test$Effect$Internal$LoadTexture = F3($lamdera$program_test$Effect$Internal$LoadTexture$);
var $lamdera$program_test$Effect$Internal$RenderXrFrame$ = function (a, b) {
	return {$: 20, a: a, b: b};
};
var $lamdera$program_test$Effect$Internal$RenderXrFrame = F2($lamdera$program_test$Effect$Internal$RenderXrFrame$);
var $lamdera$program_test$Effect$Internal$RequestXrStart$ = function (a, b) {
	return {$: 19, a: a, b: b};
};
var $lamdera$program_test$Effect$Internal$RequestXrStart = F2($lamdera$program_test$Effect$Internal$RequestXrStart$);
var $lamdera$program_test$Effect$Internal$SetViewport$ = function (a, b, c) {
	return {$: 11, a: a, b: b, c: c};
};
var $lamdera$program_test$Effect$Internal$SetViewport = F3($lamdera$program_test$Effect$Internal$SetViewport$);
var $lamdera$program_test$Effect$Internal$SetViewportOf$ = function (a, b, c, d) {
	return {$: 13, a: a, b: b, c: c, d: d};
};
var $lamdera$program_test$Effect$Internal$SetViewportOf = F4($lamdera$program_test$Effect$Internal$SetViewportOf$);
var $lamdera$program_test$Effect$Internal$SleepTask$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $lamdera$program_test$Effect$Internal$SleepTask = F2($lamdera$program_test$Effect$Internal$SleepTask$);
var $lamdera$program_test$Effect$Internal$TimeGetZoneName = function (a) {
	return {$: 7, a: a};
};
var $lamdera$program_test$Effect$Internal$TimeHere = function (a) {
	return {$: 6, a: a};
};
var $lamdera$program_test$Effect$Internal$TimeNow = function (a) {
	return {$: 5, a: a};
};
var $lamdera$program_test$Effect$Internal$WebsocketClose$ = function (a, b) {
	return {$: 24, a: a, b: b};
};
var $lamdera$program_test$Effect$Internal$WebsocketClose = F2($lamdera$program_test$Effect$Internal$WebsocketClose$);
var $lamdera$program_test$Effect$Internal$WebsocketCreateHandle$ = function (a, b) {
	return {$: 22, a: a, b: b};
};
var $lamdera$program_test$Effect$Internal$WebsocketCreateHandle = F2($lamdera$program_test$Effect$Internal$WebsocketCreateHandle$);
var $lamdera$program_test$Effect$Internal$WebsocketSendString$ = function (a, b, c) {
	return {$: 23, a: a, b: b, c: c};
};
var $lamdera$program_test$Effect$Internal$WebsocketSendString = F3($lamdera$program_test$Effect$Internal$WebsocketSendString$);
var $lamdera$program_test$Effect$Internal$andThen$ = function (f, task) {
	switch (task.$) {
		case 0:
			var a = task.a;
			return f(a);
		case 1:
			var x = task.a;
			return $lamdera$program_test$Effect$Internal$Fail(x);
		case 2:
			var request = task.a;
			return $lamdera$program_test$Effect$Internal$HttpStringTask(
				{
					body: request.body,
					headers: request.headers,
					isRisky: request.isRisky,
					method: request.method,
					onRequestComplete: A2(
						$elm$core$Basics$composeR,
						request.onRequestComplete,
						$lamdera$program_test$Effect$Internal$andThen(f)),
					timeout: request.timeout,
					tracker: request.tracker,
					url: request.url
				});
		case 3:
			var request = task.a;
			return $lamdera$program_test$Effect$Internal$HttpBytesTask(
				{
					body: request.body,
					headers: request.headers,
					isRisky: request.isRisky,
					method: request.method,
					onRequestComplete: A2(
						$elm$core$Basics$composeR,
						request.onRequestComplete,
						$lamdera$program_test$Effect$Internal$andThen(f)),
					timeout: request.timeout,
					tracker: request.tracker,
					url: request.url
				});
		case 4:
			var delay = task.a;
			var onResult = task.b;
			return $lamdera$program_test$Effect$Internal$SleepTask$(
				delay,
				A2(
					$elm$core$Basics$composeR,
					onResult,
					$lamdera$program_test$Effect$Internal$andThen(f)));
		case 5:
			var gotTime = task.a;
			return $lamdera$program_test$Effect$Internal$TimeNow(
				A2(
					$elm$core$Basics$composeR,
					gotTime,
					$lamdera$program_test$Effect$Internal$andThen(f)));
		case 6:
			var gotTimeZone = task.a;
			return $lamdera$program_test$Effect$Internal$TimeHere(
				A2(
					$elm$core$Basics$composeR,
					gotTimeZone,
					$lamdera$program_test$Effect$Internal$andThen(f)));
		case 7:
			var gotTimeZoneName = task.a;
			return $lamdera$program_test$Effect$Internal$TimeGetZoneName(
				A2(
					$elm$core$Basics$composeR,
					gotTimeZoneName,
					$lamdera$program_test$Effect$Internal$andThen(f)));
		case 11:
			var x = task.a;
			var y = task.b;
			var _function = task.c;
			return $lamdera$program_test$Effect$Internal$SetViewport$(
				x,
				y,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$andThen(f)));
		case 10:
			var _function = task.a;
			return $lamdera$program_test$Effect$Internal$GetViewport(
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$andThen(f)));
		case 14:
			var string = task.a;
			var _function = task.b;
			return $lamdera$program_test$Effect$Internal$GetElement$(
				string,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$andThen(f)));
		case 8:
			var string = task.a;
			var _function = task.b;
			return $lamdera$program_test$Effect$Internal$Focus$(
				string,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$andThen(f)));
		case 9:
			var string = task.a;
			var _function = task.b;
			return $lamdera$program_test$Effect$Internal$Blur$(
				string,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$andThen(f)));
		case 12:
			var string = task.a;
			var _function = task.b;
			return $lamdera$program_test$Effect$Internal$GetViewportOf$(
				string,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$andThen(f)));
		case 13:
			var string = task.a;
			var x = task.b;
			var y = task.c;
			var _function = task.d;
			return $lamdera$program_test$Effect$Internal$SetViewportOf$(
				string,
				x,
				y,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$andThen(f)));
		case 15:
			var file = task.a;
			var _function = task.b;
			return $lamdera$program_test$Effect$Internal$FileToString$(
				file,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$andThen(f)));
		case 16:
			var file = task.a;
			var _function = task.b;
			return $lamdera$program_test$Effect$Internal$FileToBytes$(
				file,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$andThen(f)));
		case 17:
			var file = task.a;
			var _function = task.b;
			return $lamdera$program_test$Effect$Internal$FileToUrl$(
				file,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$andThen(f)));
		case 18:
			var loadTextureOptions = task.a;
			var string = task.b;
			var _function = task.c;
			return $lamdera$program_test$Effect$Internal$LoadTexture$(
				loadTextureOptions,
				string,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$andThen(f)));
		case 19:
			var options = task.a;
			var _function = task.b;
			return $lamdera$program_test$Effect$Internal$RequestXrStart$(
				options,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$andThen(f)));
		case 20:
			var entities = task.a;
			var _function = task.b;
			return $lamdera$program_test$Effect$Internal$RenderXrFrame$(
				entities,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$andThen(f)));
		case 21:
			var _function = task.a;
			return $lamdera$program_test$Effect$Internal$EndXrSession(
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$andThen(f)));
		case 22:
			var url = task.a;
			var _function = task.b;
			return $lamdera$program_test$Effect$Internal$WebsocketCreateHandle$(
				url,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$andThen(f)));
		case 23:
			var connection = task.a;
			var data = task.b;
			var _function = task.c;
			return $lamdera$program_test$Effect$Internal$WebsocketSendString$(
				connection,
				data,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$andThen(f)));
		default:
			var connection = task.a;
			var _function = task.b;
			return $lamdera$program_test$Effect$Internal$WebsocketClose$(
				connection,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$andThen(f)));
	}
};
var $lamdera$program_test$Effect$Internal$andThen = F2($lamdera$program_test$Effect$Internal$andThen$);
var $lamdera$program_test$Effect$Internal$taskMap = function (f) {
	return $lamdera$program_test$Effect$Internal$andThen(
		A2($elm$core$Basics$composeR, f, $lamdera$program_test$Effect$Internal$Succeed));
};
var $lamdera$program_test$Effect$Task$map = $lamdera$program_test$Effect$Internal$taskMap;
var $lamdera$program_test$Effect$Internal$taskMapError$ = function (f, task) {
	switch (task.$) {
		case 0:
			var a = task.a;
			return $lamdera$program_test$Effect$Internal$Succeed(a);
		case 1:
			var x = task.a;
			return $lamdera$program_test$Effect$Internal$Fail(
				f(x));
		case 2:
			var request = task.a;
			return $lamdera$program_test$Effect$Internal$HttpStringTask(
				{
					body: request.body,
					headers: request.headers,
					isRisky: request.isRisky,
					method: request.method,
					onRequestComplete: A2(
						$elm$core$Basics$composeR,
						request.onRequestComplete,
						$lamdera$program_test$Effect$Internal$taskMapError(f)),
					timeout: request.timeout,
					tracker: request.tracker,
					url: request.url
				});
		case 3:
			var request = task.a;
			return $lamdera$program_test$Effect$Internal$HttpBytesTask(
				{
					body: request.body,
					headers: request.headers,
					isRisky: request.isRisky,
					method: request.method,
					onRequestComplete: A2(
						$elm$core$Basics$composeR,
						request.onRequestComplete,
						$lamdera$program_test$Effect$Internal$taskMapError(f)),
					timeout: request.timeout,
					tracker: request.tracker,
					url: request.url
				});
		case 4:
			var delay = task.a;
			var onResult = task.b;
			return $lamdera$program_test$Effect$Internal$SleepTask$(
				delay,
				A2(
					$elm$core$Basics$composeR,
					onResult,
					$lamdera$program_test$Effect$Internal$taskMapError(f)));
		case 5:
			var gotTime = task.a;
			return $lamdera$program_test$Effect$Internal$TimeNow(
				A2(
					$elm$core$Basics$composeR,
					gotTime,
					$lamdera$program_test$Effect$Internal$taskMapError(f)));
		case 6:
			var gotTimeZone = task.a;
			return $lamdera$program_test$Effect$Internal$TimeHere(
				A2(
					$elm$core$Basics$composeR,
					gotTimeZone,
					$lamdera$program_test$Effect$Internal$taskMapError(f)));
		case 7:
			var gotTimeZoneName = task.a;
			return $lamdera$program_test$Effect$Internal$TimeGetZoneName(
				A2(
					$elm$core$Basics$composeR,
					gotTimeZoneName,
					$lamdera$program_test$Effect$Internal$taskMapError(f)));
		case 11:
			var x = task.a;
			var y = task.b;
			var _function = task.c;
			return $lamdera$program_test$Effect$Internal$SetViewport$(
				x,
				y,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$taskMapError(f)));
		case 10:
			var _function = task.a;
			return $lamdera$program_test$Effect$Internal$GetViewport(
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$taskMapError(f)));
		case 14:
			var string = task.a;
			var _function = task.b;
			return $lamdera$program_test$Effect$Internal$GetElement$(
				string,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$taskMapError(f)));
		case 8:
			var string = task.a;
			var _function = task.b;
			return $lamdera$program_test$Effect$Internal$Focus$(
				string,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$taskMapError(f)));
		case 9:
			var string = task.a;
			var _function = task.b;
			return $lamdera$program_test$Effect$Internal$Blur$(
				string,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$taskMapError(f)));
		case 12:
			var string = task.a;
			var _function = task.b;
			return $lamdera$program_test$Effect$Internal$GetViewportOf$(
				string,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$taskMapError(f)));
		case 13:
			var string = task.a;
			var x = task.b;
			var y = task.c;
			var _function = task.d;
			return $lamdera$program_test$Effect$Internal$SetViewportOf$(
				string,
				x,
				y,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$taskMapError(f)));
		case 15:
			var file = task.a;
			var _function = task.b;
			return $lamdera$program_test$Effect$Internal$FileToString$(
				file,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$taskMapError(f)));
		case 16:
			var file = task.a;
			var _function = task.b;
			return $lamdera$program_test$Effect$Internal$FileToBytes$(
				file,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$taskMapError(f)));
		case 17:
			var file = task.a;
			var _function = task.b;
			return $lamdera$program_test$Effect$Internal$FileToUrl$(
				file,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$taskMapError(f)));
		case 18:
			var loadTextureOptions = task.a;
			var string = task.b;
			var _function = task.c;
			return $lamdera$program_test$Effect$Internal$LoadTexture$(
				loadTextureOptions,
				string,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$taskMapError(f)));
		case 19:
			var options = task.a;
			var _function = task.b;
			return $lamdera$program_test$Effect$Internal$RequestXrStart$(
				options,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$taskMapError(f)));
		case 20:
			var entities = task.a;
			var _function = task.b;
			return $lamdera$program_test$Effect$Internal$RenderXrFrame$(
				entities,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$taskMapError(f)));
		case 21:
			var _function = task.a;
			return $lamdera$program_test$Effect$Internal$EndXrSession(
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$taskMapError(f)));
		case 22:
			var url = task.a;
			var _function = task.b;
			return $lamdera$program_test$Effect$Internal$WebsocketCreateHandle$(
				url,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$taskMapError(f)));
		case 23:
			var connection = task.a;
			var data = task.b;
			var _function = task.c;
			return $lamdera$program_test$Effect$Internal$WebsocketSendString$(
				connection,
				data,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$taskMapError(f)));
		default:
			var connection = task.a;
			var _function = task.b;
			return $lamdera$program_test$Effect$Internal$WebsocketClose$(
				connection,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$lamdera$program_test$Effect$Internal$taskMapError(f)));
	}
};
var $lamdera$program_test$Effect$Internal$taskMapError = F2($lamdera$program_test$Effect$Internal$taskMapError$);
var $lamdera$program_test$Effect$Task$mapError = $lamdera$program_test$Effect$Internal$taskMapError;
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $lamdera$program_test$Effect$Task$perform$ = function (f, task) {
	return $lamdera$program_test$Effect$Internal$Task(
		A2(
			$lamdera$program_test$Effect$Task$mapError,
			$elm$core$Basics$never,
			A2($lamdera$program_test$Effect$Task$map, f, task)));
};
var $lamdera$program_test$Effect$Task$perform = F2($lamdera$program_test$Effect$Task$perform$);
var $lamdera$program_test$Effect$Internal$NavigationReplaceUrl$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $lamdera$program_test$Effect$Internal$NavigationReplaceUrl = F2($lamdera$program_test$Effect$Internal$NavigationReplaceUrl$);
var $lamdera$program_test$Effect$Internal$MockNavigationKey = {$: 1};
var $lamdera$program_test$Effect$Internal$RealNavigationKey = function (a) {
	return {$: 0, a: a};
};
var $lamdera$program_test$Effect$Browser$Navigation$toInternalKey = function (key) {
	if (!key.$) {
		var key_ = key.a;
		return $lamdera$program_test$Effect$Internal$RealNavigationKey(key_);
	} else {
		return $lamdera$program_test$Effect$Internal$MockNavigationKey;
	}
};
var $lamdera$program_test$Effect$Browser$Navigation$replaceUrl$ = function (key, url) {
	return $lamdera$program_test$Effect$Internal$NavigationReplaceUrl$(
		$lamdera$program_test$Effect$Browser$Navigation$toInternalKey(key),
		url);
};
var $lamdera$program_test$Effect$Browser$Navigation$replaceUrl = F2($lamdera$program_test$Effect$Browser$Navigation$replaceUrl$);
var $author$project$Types$InitialLoadRequested_Admin = function (a) {
	return {$: 4, a: a};
};
var $author$project$Types$InitialLoadRequested_DiscordDm$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Types$InitialLoadRequested_DiscordDm = F2($author$project$Types$InitialLoadRequested_DiscordDm$);
var $author$project$Types$InitialLoadRequested_DiscordGuild$ = function (a, b, c, d) {
	return {$: 2, a: a, b: b, c: c, d: d};
};
var $author$project$Types$InitialLoadRequested_DiscordGuild = F4($author$project$Types$InitialLoadRequested_DiscordGuild$);
var $author$project$Types$InitialLoadRequested_Dm$ = function (a, b, c) {
	return {$: 1, a: a, b: b, c: c};
};
var $author$project$Types$InitialLoadRequested_Dm = F3($author$project$Types$InitialLoadRequested_Dm$);
var $author$project$Types$InitialLoadRequested_Guild$ = function (a, b, c, d) {
	return {$: 0, a: a, b: b, c: c, d: d};
};
var $author$project$Types$InitialLoadRequested_Guild = F4($author$project$Types$InitialLoadRequested_Guild$);
var $author$project$Types$InitialLoadRequested_None = {$: 5};
var $author$project$Id$NoThread = {$: 0};
var $author$project$Id$ViewThread = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pagination$pageSize = 20;
var $author$project$Pagination$itemToPageId = function (itemId) {
	var itemId2 = $author$project$Id$toInt(itemId);
	return {
		offset: A2($elm$core$Basics$modBy, $author$project$Pagination$pageSize, itemId2),
		pageId: $author$project$Id$fromInt((itemId2 / $author$project$Pagination$pageSize) | 0)
	};
};
var $author$project$Frontend$routeToInitialDataRequest = function (route) {
	_v0$5:
	while (true) {
		switch (route.$) {
			case 3:
				if (!route.b.$) {
					var guildId = route.a;
					var _v1 = route.b;
					var channelId = _v1.a;
					var threadRoute = _v1.b;
					var tab = _v1.c;
					return $author$project$Types$InitialLoadRequested_Guild$(
						guildId,
						channelId,
						function () {
							if (threadRoute.$ === 1) {
								var threadMessageId = threadRoute.a;
								return $author$project$Id$ViewThread(threadMessageId);
							} else {
								return $author$project$Id$NoThread;
							}
						}(),
						tab);
				} else {
					break _v0$5;
				}
			case 5:
				var tab = route.a.tab;
				var threadRoute = route.a.threadRoute;
				var channelId = route.a.channelId;
				return $author$project$Types$InitialLoadRequested_Dm$(
					channelId,
					function () {
						if (threadRoute.$ === 1) {
							var threadMessageId = threadRoute.a;
							return $author$project$Id$ViewThread(threadMessageId);
						} else {
							return $author$project$Id$NoThread;
						}
					}(),
					tab);
			case 4:
				var data = route.a;
				var _v4 = data.channelRoute;
				if (!_v4.$) {
					var channelId = _v4.a;
					var threadRoute = _v4.b;
					return $author$project$Types$InitialLoadRequested_DiscordGuild$(
						data.currentDiscordUserId,
						data.guildId,
						channelId,
						function () {
							if (threadRoute.$ === 1) {
								var threadMessageId = threadRoute.a;
								return $author$project$Id$ViewThread(threadMessageId);
							} else {
								return $author$project$Id$NoThread;
							}
						}());
				} else {
					return $author$project$Types$InitialLoadRequested_None;
				}
			case 6:
				var data = route.a;
				return $author$project$Types$InitialLoadRequested_DiscordDm$(data.currentDiscordUserId, data.channelId);
			case 1:
				var highlightLog = route.a.highlightLog;
				return $author$project$Types$InitialLoadRequested_Admin(
					function () {
						if (!highlightLog.$) {
							var highlightLog2 = highlightLog.a;
							return $elm$core$Maybe$Just(
								$author$project$Pagination$itemToPageId(highlightLog2).pageId);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}());
			default:
				break _v0$5;
		}
	}
	return $author$project$Types$InitialLoadRequested_None;
};
var $lamdera$program_test$Effect$Internal$SendToBackend = function (a) {
	return {$: 2, a: a};
};
var $lamdera$program_test$Effect$Lamdera$sendToBackend = $lamdera$program_test$Effect$Internal$SendToBackend;
var $author$project$Coord$xy$ = function (x_, y_) {
	return _Utils_Tuple2(x_, y_);
};
var $author$project$Coord$xy = F2($author$project$Coord$xy$);
var $author$project$Frontend$init$ = function (url, key) {
	var route = $author$project$Route$decode(url);
	return _Utils_Tuple3(
		$author$project$Types$Loading(
			{
				clientId: $elm$core$Maybe$Nothing,
				loginStatus: $author$project$Types$LoadingData,
				loginType: 0,
				navigationKey: key,
				popSound: $elm$core$Result$Err(2),
				publicGoMatch: function () {
					if (route.$ === 13) {
						return $author$project$Types$PublicGoMatch_Loading;
					} else {
						return $author$project$Types$PublicGoMatch_NotLoaded;
					}
				}(),
				route: route,
				startupData: $elm$core$Maybe$Nothing,
				time: $elm$core$Maybe$Nothing,
				windowSize: $author$project$Coord$xy$(1920, 1080)
			}),
		$lamdera$program_test$Effect$Command$batch(
			_List_fromArray(
				[
					$lamdera$program_test$Effect$Browser$Navigation$replaceUrl$(
					key,
					$author$project$Route$encode(route)),
					$lamdera$program_test$Effect$Task$perform$(
					function (_v1) {
						var viewport = _v1.viewport;
						return $author$project$Types$GotWindowSize$(
							$elm$core$Basics$round(viewport.width),
							$elm$core$Basics$round(viewport.height));
					},
					$lamdera$program_test$Effect$Browser$Dom$getViewport),
					$lamdera$program_test$Effect$Lamdera$sendToBackend(
					$author$project$Types$CheckLoginRequest(
						$author$project$Frontend$routeToInitialDataRequest(route))),
					function () {
					if (route.$ === 13) {
						var goMatchPublicId = route.a;
						return $lamdera$program_test$Effect$Lamdera$sendToBackend(
							$author$project$Types$GetPublicGoMatchRequest(goMatchPublicId));
					} else {
						return $lamdera$program_test$Effect$Command$none;
					}
				}(),
					$author$project$Ports$loadStartupData
				])),
		$author$project$Audio$loadAudio$($author$project$Types$LoadedPopSound, '/cacheable/pop.mp3'));
};
var $author$project$Frontend$init = F2($author$project$Frontend$init$);
var $author$project$Audio$UserMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Audio$AudioData = $elm$core$Basics$identity;
var $author$project$Audio$audioData = function (_v0) {
	var model = _v0;
	return {sourceData: model.sourceData};
};
var $author$project$Audio$flip$ = function (func, a, b) {
	return A2(func, b, a);
};
var $author$project$Audio$flip = F3($author$project$Audio$flip$);
var $author$project$Audio$getUserModel = function (_v0) {
	var model = _v0;
	return model.userModel;
};
var $author$project$Audio$Model = $elm$core$Basics$identity;
var $author$project$Audio$audioPortToJs$ = function (port_, data) {
	return A3($lamdera$program_test$Effect$Command$sendToJs, 'audioPortToJs', port_, data);
};
var $author$project$Audio$audioPortToJs = F2($author$project$Audio$audioPortToJs$);
var $author$project$Audio$audioSourceBufferId = function (_v0) {
	var audioSource = _v0;
	return audioSource.bufferId;
};
var $author$project$Audio$audioStartTime = function (audio_) {
	return $ianmackenzie$elm_units$Duration$addTo$(audio_.startTime, audio_.offset);
};
var $author$project$Audio$encodeBufferId = function (_v0) {
	var bufferId = _v0;
	return $elm$json$Json$Encode$int(bufferId);
};
var $author$project$Audio$encodeDuration = A2($elm$core$Basics$composeR, $ianmackenzie$elm_units$Duration$inMilliseconds, $elm$json$Json$Encode$float);
var $author$project$Audio$encodeLoopConfig = function (maybeLoop) {
	if (!maybeLoop.$) {
		var loop = maybeLoop.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'loopStart',
					$author$project$Audio$encodeDuration(loop.loopStart)),
					_Utils_Tuple2(
					'loopEnd',
					$author$project$Audio$encodeDuration(loop.loopEnd))
				]));
	} else {
		return $elm$json$Json$Encode$null;
	}
};
var $author$project$Audio$encodeTime = A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$json$Json$Encode$int);
var $author$project$Audio$encodeVolumeTimeline = function (volumeTimeline) {
	return $elm$json$Json$Encode$list$(
		function (_v0) {
			var time = _v0.a;
			var volume = _v0.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'time',
						$author$project$Audio$encodeTime(time)),
						_Utils_Tuple2(
						'volume',
						$elm$json$Json$Encode$float(volume))
					]));
		},
		$mgold$elm_nonempty_list$List$Nonempty$toList(volumeTimeline));
};
var $elm$core$Tuple$mapFirst$ = function (func, _v0) {
	var x = _v0.a;
	var y = _v0.b;
	return _Utils_Tuple2(
		func(x),
		y);
};
var $elm$core$Tuple$mapFirst = F2($elm$core$Tuple$mapFirst$);
var $author$project$Audio$volumeTimelines = function (audio_) {
	return $elm$core$List$map$(
		$mgold$elm_nonempty_list$List$Nonempty$map(
			$elm$core$Tuple$mapFirst(
				function (a) {
					return $ianmackenzie$elm_units$Duration$addTo$(a, audio_.offset);
				})),
		audio_.volumeTimelines);
};
var $author$project$Audio$encodeStartSound$ = function (nodeGroupId, audio_) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'action',
				$elm$json$Json$Encode$string('startSound')),
				_Utils_Tuple2(
				'nodeGroupId',
				$elm$json$Json$Encode$int(nodeGroupId)),
				_Utils_Tuple2(
				'bufferId',
				$author$project$Audio$encodeBufferId(
					$author$project$Audio$audioSourceBufferId(audio_.source))),
				_Utils_Tuple2(
				'startTime',
				$author$project$Audio$encodeTime(
					$author$project$Audio$audioStartTime(audio_))),
				_Utils_Tuple2(
				'startAt',
				$author$project$Audio$encodeDuration(audio_.startAt)),
				_Utils_Tuple2(
				'volume',
				$elm$json$Json$Encode$float(audio_.volume)),
				_Utils_Tuple2(
				'volumeTimelines',
				$elm$json$Json$Encode$list$(
					$author$project$Audio$encodeVolumeTimeline,
					$author$project$Audio$volumeTimelines(audio_))),
				_Utils_Tuple2(
				'loop',
				$author$project$Audio$encodeLoopConfig(audio_.loop)),
				_Utils_Tuple2(
				'playbackRate',
				$elm$json$Json$Encode$float(audio_.playbackRate))
			]));
};
var $author$project$Audio$encodeStartSound = F2($author$project$Audio$encodeStartSound$);
var $elm$core$List$append$ = function (xs, ys) {
	if (!ys.b) {
		return xs;
	} else {
		return $elm$core$List$foldr$($elm$core$List$cons, ys, xs);
	}
};
var $elm$core$List$append = F2($elm$core$List$append$);
var $elm$core$List$concat = function (lists) {
	return $elm$core$List$foldr$($elm$core$List$append, _List_Nil, lists);
};
var $author$project$Audio$flattenAudio = function (audio_) {
	switch (audio_.$) {
		case 0:
			var group_ = audio_.a;
			return $elm$core$List$concat(
				$elm$core$List$map$($author$project$Audio$flattenAudio, group_));
		case 1:
			var settings = audio_.a.settings;
			var startTime = audio_.a.startTime;
			var source = audio_.a.source;
			return _List_fromArray(
				[
					{loop: settings.loop, offset: $ianmackenzie$elm_units$Quantity$zero, playbackRate: settings.playbackRate, source: source, startAt: settings.startAt, startTime: startTime, volume: 1, volumeTimelines: _List_Nil}
				]);
		default:
			var effect = audio_.a;
			var _v1 = effect.effectType;
			switch (_v1.$) {
				case 0:
					var scaleVolume_ = _v1.a;
					return $elm$core$List$map$(
						function (a) {
							return _Utils_update(
								a,
								{volume: scaleVolume_.scaleBy * a.volume});
						},
						$author$project$Audio$flattenAudio(effect.audio));
				case 1:
					var volumeAt = _v1.a.volumeAt;
					return $elm$core$List$map$(
						function (a) {
							return _Utils_update(
								a,
								{
									volumeTimelines: A2($elm$core$List$cons, volumeAt, a.volumeTimelines)
								});
						},
						$author$project$Audio$flattenAudio(effect.audio));
				default:
					var duration = _v1.a;
					return $elm$core$List$map$(
						function (a) {
							return _Utils_update(
								a,
								{
									offset: $ianmackenzie$elm_units$Quantity$plus$(duration, a.offset)
								});
						},
						$author$project$Audio$flattenAudio(effect.audio));
			}
	}
};
var $author$project$Audio$encodeSetLoopConfig$ = function (nodeGroupId, loop) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nodeGroupId',
				$elm$json$Json$Encode$int(nodeGroupId)),
				_Utils_Tuple2(
				'action',
				$elm$json$Json$Encode$string('setLoopConfig')),
				_Utils_Tuple2(
				'loop',
				$author$project$Audio$encodeLoopConfig(loop))
			]));
};
var $author$project$Audio$encodeSetLoopConfig = F2($author$project$Audio$encodeSetLoopConfig$);
var $author$project$Audio$encodeSetPlaybackRate$ = function (nodeGroupId, playbackRate) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nodeGroupId',
				$elm$json$Json$Encode$int(nodeGroupId)),
				_Utils_Tuple2(
				'action',
				$elm$json$Json$Encode$string('setPlaybackRate')),
				_Utils_Tuple2(
				'playbackRate',
				$elm$json$Json$Encode$float(playbackRate))
			]));
};
var $author$project$Audio$encodeSetPlaybackRate = F2($author$project$Audio$encodeSetPlaybackRate$);
var $author$project$Audio$encodeSetVolume$ = function (nodeGroupId, volume) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nodeGroupId',
				$elm$json$Json$Encode$int(nodeGroupId)),
				_Utils_Tuple2(
				'action',
				$elm$json$Json$Encode$string('setVolume')),
				_Utils_Tuple2(
				'volume',
				$elm$json$Json$Encode$float(volume))
			]));
};
var $author$project$Audio$encodeSetVolume = F2($author$project$Audio$encodeSetVolume$);
var $author$project$Audio$encodeSetVolumeAt$ = function (nodeGroupId, volumeTimelines_) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'nodeGroupId',
				$elm$json$Json$Encode$int(nodeGroupId)),
				_Utils_Tuple2(
				'action',
				$elm$json$Json$Encode$string('setVolumeAt')),
				_Utils_Tuple2(
				'volumeAt',
				$elm$json$Json$Encode$list$($author$project$Audio$encodeVolumeTimeline, volumeTimelines_))
			]));
};
var $author$project$Audio$encodeSetVolumeAt = F2($author$project$Audio$encodeSetVolumeAt$);
var $author$project$Audio$encodeStopSound = function (nodeGroupId) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'action',
				$elm$json$Json$Encode$string('stopSound')),
				_Utils_Tuple2(
				'nodeGroupId',
				$elm$json$Json$Encode$int(nodeGroupId))
			]));
};
var $elm$core$List$filter$ = function (isGood, list) {
	return $elm$core$List$foldr$(
		F2(
			function (x, xs) {
				return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
			}),
		_List_Nil,
		list);
};
var $elm$core$List$filter = F2($elm$core$List$filter$);
var $elm$core$List$maybeCons$ = function (f, mx, xs) {
	var _v0 = f(mx);
	if (!_v0.$) {
		var x = _v0.a;
		return A2($elm$core$List$cons, x, xs);
	} else {
		return xs;
	}
};
var $elm$core$List$maybeCons = F3($elm$core$List$maybeCons$);
var $elm$core$List$filterMap$ = function (f, xs) {
	return $elm$core$List$foldr$(
		$elm$core$List$maybeCons(f),
		_List_Nil,
		xs);
};
var $elm$core$List$filterMap = F2($elm$core$List$filterMap$);
var $author$project$Audio$find$ = function (predicate, list) {
	find:
	while (true) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var first = list.a;
			var rest = list.b;
			if (predicate(first)) {
				return $elm$core$Maybe$Just(first);
			} else {
				var $temp$list = rest;
				list = $temp$list;
				continue find;
			}
		}
	}
};
var $author$project$Audio$find = F2($author$project$Audio$find$);
var $elm$core$Tuple$pair$ = function (a, b) {
	return _Utils_Tuple2(a, b);
};
var $elm$core$Tuple$pair = F2($elm$core$Tuple$pair$);
var $elm$core$List$drop$ = function (n, list) {
	drop:
	while (true) {
		if (n <= 0) {
			return list;
		} else {
			if (!list.b) {
				return list;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$n = n - 1,
					$temp$list = xs;
				n = $temp$n;
				list = $temp$list;
				continue drop;
			}
		}
	}
};
var $elm$core$List$drop = F2($elm$core$List$drop$);
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$List$takeReverse$ = function (n, list, kept) {
	takeReverse:
	while (true) {
		if (n <= 0) {
			return kept;
		} else {
			if (!list.b) {
				return kept;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$n = n - 1,
					$temp$list = xs,
					$temp$kept = A2($elm$core$List$cons, x, kept);
				n = $temp$n;
				list = $temp$list;
				kept = $temp$kept;
				continue takeReverse;
			}
		}
	}
};
var $elm$core$List$takeReverse = F3($elm$core$List$takeReverse$);
var $elm$core$List$takeTailRec$ = function (n, list) {
	return $elm$core$List$reverse(
		$elm$core$List$takeReverse$(n, list, _List_Nil));
};
var $elm$core$List$takeTailRec = F2($elm$core$List$takeTailRec$);
var $elm$core$List$takeFast$ = function (ctr, n, list) {
	if (n <= 0) {
		return _List_Nil;
	} else {
		var _v0 = _Utils_Tuple2(n, list);
		_v0$1:
		while (true) {
			_v0$5:
			while (true) {
				if (!_v0.b.b) {
					return list;
				} else {
					if (_v0.b.b.b) {
						switch (_v0.a) {
							case 1:
								break _v0$1;
							case 2:
								var _v2 = _v0.b;
								var x = _v2.a;
								var _v3 = _v2.b;
								var y = _v3.a;
								return _List_fromArray(
									[x, y]);
							case 3:
								if (_v0.b.b.b.b) {
									var _v4 = _v0.b;
									var x = _v4.a;
									var _v5 = _v4.b;
									var y = _v5.a;
									var _v6 = _v5.b;
									var z = _v6.a;
									return _List_fromArray(
										[x, y, z]);
								} else {
									break _v0$5;
								}
							default:
								if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
									var _v7 = _v0.b;
									var x = _v7.a;
									var _v8 = _v7.b;
									var y = _v8.a;
									var _v9 = _v8.b;
									var z = _v9.a;
									var _v10 = _v9.b;
									var w = _v10.a;
									var tl = _v10.b;
									return (ctr > 1000) ? A2(
										$elm$core$List$cons,
										x,
										A2(
											$elm$core$List$cons,
											y,
											A2(
												$elm$core$List$cons,
												z,
												A2(
													$elm$core$List$cons,
													w,
													$elm$core$List$takeTailRec$(n - 4, tl))))) : A2(
										$elm$core$List$cons,
										x,
										A2(
											$elm$core$List$cons,
											y,
											A2(
												$elm$core$List$cons,
												z,
												A2(
													$elm$core$List$cons,
													w,
													$elm$core$List$takeFast$(ctr + 1, n - 4, tl)))));
								} else {
									break _v0$5;
								}
						}
					} else {
						if (_v0.a === 1) {
							break _v0$1;
						} else {
							break _v0$5;
						}
					}
				}
			}
			return list;
		}
		var _v1 = _v0.b;
		var x = _v1.a;
		return _List_fromArray(
			[x]);
	}
};
var $elm$core$List$takeFast = F3($elm$core$List$takeFast$);
var $elm$core$List$take$ = function (n, list) {
	return $elm$core$List$takeFast$(0, n, list);
};
var $elm$core$List$take = F2($elm$core$List$take$);
var $author$project$Audio$removeAt$ = function (index, l) {
	if (index < 0) {
		return l;
	} else {
		var tail = $elm$core$List$tail(
			$elm$core$List$drop$(index, l));
		var head = $elm$core$List$take$(index, l);
		if (tail.$ === 1) {
			return l;
		} else {
			var t = tail.a;
			return $elm$core$List$append$(head, t);
		}
	}
};
var $author$project$Audio$removeAt = F2($author$project$Audio$removeAt$);
var $author$project$Audio$updateAudioState$ = function (_v0, _v1) {
	var nodeGroupId = _v0.a;
	var audioGroup = _v0.b;
	var flattenedAudio = _v1.a;
	var audioState = _v1.b;
	var json = _v1.c;
	var validAudio = $elm$core$List$filter$(
		function (_v7) {
			var a = _v7.b;
			return _Utils_eq(a.source, audioGroup.source) && (_Utils_eq(
				$author$project$Audio$audioStartTime(a),
				$author$project$Audio$audioStartTime(audioGroup)) && _Utils_eq(a.startAt, audioGroup.startAt));
		},
		$elm$core$List$indexedMap$($elm$core$Tuple$pair, flattenedAudio));
	var _v2 = $author$project$Audio$find$(
		function (_v3) {
			var a = _v3.b;
			return _Utils_eq(a, audioGroup);
		},
		validAudio);
	if (!_v2.$) {
		var _v4 = _v2.a;
		var index = _v4.a;
		return _Utils_Tuple3(
			$author$project$Audio$removeAt$(index, flattenedAudio),
			audioState,
			json);
	} else {
		if (validAudio.b) {
			var _v6 = validAudio.a;
			var index = _v6.a;
			var a = _v6.b;
			var encodeValue = F2(
				function (getter, encoder) {
					return _Utils_eq(
						getter(audioGroup),
						getter(a)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						A2(
							encoder,
							nodeGroupId,
							getter(a)));
				});
			var effects = $elm$core$List$filterMap$(
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						encodeValue,
						function ($) {
							return $.volume;
						},
						$author$project$Audio$encodeSetVolume),
						A2(
						encodeValue,
						function ($) {
							return $.loop;
						},
						$author$project$Audio$encodeSetLoopConfig),
						A2(
						encodeValue,
						function ($) {
							return $.playbackRate;
						},
						$author$project$Audio$encodeSetPlaybackRate),
						A2(encodeValue, $author$project$Audio$volumeTimelines, $author$project$Audio$encodeSetVolumeAt)
					]));
			return _Utils_Tuple3(
				$author$project$Audio$removeAt$(index, flattenedAudio),
				$elm$core$Dict$insert$(nodeGroupId, a, audioState),
				_Utils_ap(effects, json));
		} else {
			return _Utils_Tuple3(
				flattenedAudio,
				$elm$core$Dict$remove$(nodeGroupId, audioState),
				A2(
					$elm$core$List$cons,
					$author$project$Audio$encodeStopSound(nodeGroupId),
					json));
		}
	}
};
var $author$project$Audio$updateAudioState = F2($author$project$Audio$updateAudioState$);
var $author$project$Audio$diffAudioState$ = function (nodeGroupIdCounter, audioState, newAudio) {
	var _v0 = $elm$core$List$foldl$(
		$author$project$Audio$updateAudioState,
		_Utils_Tuple3(
			$author$project$Audio$flattenAudio(newAudio),
			audioState,
			_List_Nil),
		$elm$core$Dict$toList(audioState));
	var newAudioLeft = _v0.a;
	var newAudioState = _v0.b;
	var json2 = _v0.c;
	var _v1 = $elm$core$List$foldl$(
		F2(
			function (audioLeft, _v2) {
				var counter = _v2.a;
				var audioState_ = _v2.b;
				var json_ = _v2.c;
				return _Utils_Tuple3(
					counter + 1,
					$elm$core$Dict$insert$(counter, audioLeft, audioState_),
					A2(
						$elm$core$List$cons,
						$author$project$Audio$encodeStartSound$(counter, audioLeft),
						json_));
			}),
		_Utils_Tuple3(nodeGroupIdCounter, newAudioState, json2),
		newAudioLeft);
	var newNodeGroupIdCounter = _v1.a;
	var newAudioState2 = _v1.b;
	var json3 = _v1.c;
	return _Utils_Tuple3(newAudioState2, newNodeGroupIdCounter, json3);
};
var $author$project$Audio$diffAudioState = F3($author$project$Audio$diffAudioState$);
var $author$project$Audio$encodeAudioLoadRequest$ = function (index, audioLoad) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'audioUrl',
				$elm$json$Json$Encode$string(audioLoad.audioUrl)),
				_Utils_Tuple2(
				'requestId',
				$elm$json$Json$Encode$int(index))
			]));
};
var $author$project$Audio$encodeAudioLoadRequest = F2($author$project$Audio$encodeAudioLoadRequest$);
var $author$project$Audio$flattenAudioCmd = function (audioCmd) {
	if (!audioCmd.$) {
		var data = audioCmd.a;
		return _List_fromArray(
			[data]);
	} else {
		var list = audioCmd.a;
		return $elm$core$List$concat(
			$elm$core$List$map$($author$project$Audio$flattenAudioCmd, list));
	}
};
var $elm$core$Dict$foldl$ = function (func, acc, dict) {
	foldl:
	while (true) {
		if (dict.$ === -2) {
			return acc;
		} else {
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			var $temp$acc = A3(
				func,
				key,
				value,
				$elm$core$Dict$foldl$(func, acc, left)),
				$temp$dict = right;
			acc = $temp$acc;
			dict = $temp$dict;
			continue foldl;
		}
	}
};
var $elm$core$Dict$foldl = F3($elm$core$Dict$foldl$);
var $elm$core$Dict$union$ = function (t1, t2) {
	return $elm$core$Dict$foldl$($elm$core$Dict$insert, t2, t1);
};
var $elm$core$Dict$union = F2($elm$core$Dict$union$);
var $author$project$Audio$encodeAudioCmd$ = function (_v0, audioCmd) {
	var model = _v0;
	var flattenedAudioCmd = $author$project$Audio$flattenAudioCmd(audioCmd);
	var newPendingRequests = $elm$core$List$indexedMap$(
		F2(
			function (index, request) {
				return _Utils_Tuple2(model.requestCount + index, request);
			}),
		flattenedAudioCmd);
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{
				pendingRequests: $elm$core$Dict$union$(
					model.pendingRequests,
					$elm$core$Dict$fromList(newPendingRequests)),
				requestCount: model.requestCount + $elm$core$List$length(flattenedAudioCmd)
			}),
		$elm$json$Json$Encode$list$(
			$elm$core$Basics$identity,
			$elm$core$List$map$(
				function (_v1) {
					var index = _v1.a;
					var value = _v1.b;
					return $author$project$Audio$encodeAudioLoadRequest$(index, value);
				},
				newPendingRequests)));
};
var $author$project$Audio$encodeAudioCmd = F2($author$project$Audio$encodeAudioCmd$);
var $lamdera$program_test$Effect$Internal$Broadcast = function (a) {
	return {$: 15, a: a};
};
var $lamdera$program_test$Effect$Internal$FileDownloadBytes = function (a) {
	return {$: 18, a: a};
};
var $lamdera$program_test$Effect$Internal$FileDownloadString = function (a) {
	return {$: 17, a: a};
};
var $lamdera$program_test$Effect$Internal$FileDownloadUrl = function (a) {
	return {$: 16, a: a};
};
var $lamdera$program_test$Effect$Internal$FileSelectFile$ = function (a, b) {
	return {$: 19, a: a, b: b};
};
var $lamdera$program_test$Effect$Internal$FileSelectFile = F2($lamdera$program_test$Effect$Internal$FileSelectFile$);
var $lamdera$program_test$Effect$Internal$FileSelectFiles$ = function (a, b) {
	return {$: 20, a: a, b: b};
};
var $lamdera$program_test$Effect$Internal$FileSelectFiles = F2($lamdera$program_test$Effect$Internal$FileSelectFiles$);
var $lamdera$program_test$Effect$Internal$HttpCancel = function (a) {
	return {$: 21, a: a};
};
var $lamdera$program_test$Effect$Internal$HttpTrackedRequest = function (a) {
	return {$: 22, a: a};
};
var $lamdera$program_test$Effect$Internal$NavigationBack$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $lamdera$program_test$Effect$Internal$NavigationBack = F2($lamdera$program_test$Effect$Internal$NavigationBack$);
var $lamdera$program_test$Effect$Internal$NavigationForward$ = function (a, b) {
	return {$: 6, a: a, b: b};
};
var $lamdera$program_test$Effect$Internal$NavigationForward = F2($lamdera$program_test$Effect$Internal$NavigationForward$);
var $lamdera$program_test$Effect$Internal$NavigationLoad = function (a) {
	return {$: 7, a: a};
};
var $lamdera$program_test$Effect$Internal$NavigationPushUrl$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $lamdera$program_test$Effect$Internal$NavigationPushUrl = F2($lamdera$program_test$Effect$Internal$NavigationPushUrl$);
var $lamdera$program_test$Effect$Internal$NavigationReload = {$: 8};
var $lamdera$program_test$Effect$Internal$NavigationReloadAndSkipCache = {$: 9};
var $lamdera$program_test$Effect$Internal$Passthrough = function (a) {
	return {$: 23, a: a};
};
var $lamdera$program_test$Effect$Internal$PortBytes$ = function (a, b, c) {
	return {$: 12, a: a, b: b, c: c};
};
var $lamdera$program_test$Effect$Internal$PortBytes = F3($lamdera$program_test$Effect$Internal$PortBytes$);
var $lamdera$program_test$Effect$Internal$SendToFrontend$ = function (a, b) {
	return {$: 13, a: a, b: b};
};
var $lamdera$program_test$Effect$Internal$SendToFrontend = F2($lamdera$program_test$Effect$Internal$SendToFrontend$);
var $lamdera$program_test$Effect$Internal$SendToFrontends$ = function (a, b) {
	return {$: 14, a: a, b: b};
};
var $lamdera$program_test$Effect$Internal$SendToFrontends = F2($lamdera$program_test$Effect$Internal$SendToFrontends$);
var $elm$core$Platform$Cmd$map = _Platform_map;
var $lamdera$program_test$Effect$Internal$ExpectBytesResponse = function (a) {
	return {$: 1, a: a};
};
var $lamdera$program_test$Effect$Internal$ExpectStringResponse = function (a) {
	return {$: 0, a: a};
};
var $lamdera$program_test$Effect$Internal$mapTrackedHttpRequest$ = function (mapMsg, request) {
	return {
		body: request.body,
		expect: function () {
			var _v0 = request.expect;
			if (!_v0.$) {
				var onRequestComplete = _v0.a;
				return $lamdera$program_test$Effect$Internal$ExpectStringResponse(
					A2($elm$core$Basics$composeR, onRequestComplete, mapMsg));
			} else {
				var onRequestComplete = _v0.a;
				return $lamdera$program_test$Effect$Internal$ExpectBytesResponse(
					A2($elm$core$Basics$composeR, onRequestComplete, mapMsg));
			}
		}(),
		headers: request.headers,
		isRisky: request.isRisky,
		method: request.method,
		timeout: request.timeout,
		tracker: request.tracker,
		url: request.url
	};
};
var $lamdera$program_test$Effect$Internal$mapTrackedHttpRequest = F2($lamdera$program_test$Effect$Internal$mapTrackedHttpRequest$);
var $lamdera$program_test$Effect$Command$map$ = function (mapToMsg, mapMsg, frontendEffect) {
	switch (frontendEffect.$) {
		case 0:
			var frontendEffects = frontendEffect.a;
			return $lamdera$program_test$Effect$Internal$Batch(
				$elm$core$List$map$(
					A2($lamdera$program_test$Effect$Command$map, mapToMsg, mapMsg),
					frontendEffects));
		case 1:
			return $lamdera$program_test$Effect$Internal$None;
		case 2:
			var toMsg = frontendEffect.a;
			return $lamdera$program_test$Effect$Internal$SendToBackend(
				mapToMsg(toMsg));
		case 3:
			var navigationKey = frontendEffect.a;
			var url = frontendEffect.b;
			return $lamdera$program_test$Effect$Internal$NavigationPushUrl$(navigationKey, url);
		case 4:
			var navigationKey = frontendEffect.a;
			var url = frontendEffect.b;
			return $lamdera$program_test$Effect$Internal$NavigationReplaceUrl$(navigationKey, url);
		case 7:
			var url = frontendEffect.a;
			return $lamdera$program_test$Effect$Internal$NavigationLoad(url);
		case 5:
			var navigationKey = frontendEffect.a;
			var _int = frontendEffect.b;
			return $lamdera$program_test$Effect$Internal$NavigationBack$(navigationKey, _int);
		case 6:
			var navigationKey = frontendEffect.a;
			var _int = frontendEffect.b;
			return $lamdera$program_test$Effect$Internal$NavigationForward$(navigationKey, _int);
		case 8:
			return $lamdera$program_test$Effect$Internal$NavigationReload;
		case 9:
			return $lamdera$program_test$Effect$Internal$NavigationReloadAndSkipCache;
		case 10:
			var simulatedTask = frontendEffect.a;
			return $lamdera$program_test$Effect$Internal$Task(
				$lamdera$program_test$Effect$Internal$taskMapError$(
					mapMsg,
					A2($lamdera$program_test$Effect$Internal$taskMap, mapMsg, simulatedTask)));
		case 11:
			var portName = frontendEffect.a;
			var _function = frontendEffect.b;
			var value = frontendEffect.c;
			return $lamdera$program_test$Effect$Internal$Port$(
				portName,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$elm$core$Platform$Cmd$map(mapMsg)),
				value);
		case 12:
			var portName = frontendEffect.a;
			var _function = frontendEffect.b;
			var value = frontendEffect.c;
			return $lamdera$program_test$Effect$Internal$PortBytes$(
				portName,
				A2(
					$elm$core$Basics$composeR,
					_function,
					$elm$core$Platform$Cmd$map(mapMsg)),
				value);
		case 13:
			var clientId = frontendEffect.a;
			var toMsg = frontendEffect.b;
			return $lamdera$program_test$Effect$Internal$SendToFrontend$(
				clientId,
				mapToMsg(toMsg));
		case 14:
			var sessionId = frontendEffect.a;
			var toMsg = frontendEffect.b;
			return $lamdera$program_test$Effect$Internal$SendToFrontends$(
				sessionId,
				mapToMsg(toMsg));
		case 16:
			var record = frontendEffect.a;
			return $lamdera$program_test$Effect$Internal$FileDownloadUrl(record);
		case 17:
			var record = frontendEffect.a;
			return $lamdera$program_test$Effect$Internal$FileDownloadString(record);
		case 18:
			var record = frontendEffect.a;
			return $lamdera$program_test$Effect$Internal$FileDownloadBytes(record);
		case 19:
			var strings = frontendEffect.a;
			var _function = frontendEffect.b;
			return $lamdera$program_test$Effect$Internal$FileSelectFile$(
				strings,
				A2($elm$core$Basics$composeR, _function, mapMsg));
		case 20:
			var strings = frontendEffect.a;
			var _function = frontendEffect.b;
			return $lamdera$program_test$Effect$Internal$FileSelectFiles$(
				strings,
				F2(
					function (file, restOfFiles) {
						return mapMsg(
							A2(_function, file, restOfFiles));
					}));
		case 15:
			var toMsg = frontendEffect.a;
			return $lamdera$program_test$Effect$Internal$Broadcast(
				mapToMsg(toMsg));
		case 21:
			var string = frontendEffect.a;
			return $lamdera$program_test$Effect$Internal$HttpCancel(string);
		case 22:
			var request = frontendEffect.a;
			return $lamdera$program_test$Effect$Internal$HttpTrackedRequest(
				$lamdera$program_test$Effect$Internal$mapTrackedHttpRequest$(mapMsg, request));
		default:
			var cmd = frontendEffect.a;
			return $lamdera$program_test$Effect$Internal$Passthrough(
				A2($elm$core$Platform$Cmd$map, mapMsg, cmd));
	}
};
var $lamdera$program_test$Effect$Command$map = F3($lamdera$program_test$Effect$Command$map$);
var $author$project$Audio$initHelper$ = function (audioPort, audioFunc, _v0) {
	var model = _v0.a;
	var cmds = _v0.b;
	var audioCmds = _v0.c;
	var _v1 = $author$project$Audio$diffAudioState$(
		0,
		$elm$core$Dict$empty,
		A2(
			audioFunc,
			{sourceData: $elm$core$Dict$empty},
			model));
	var audioState = _v1.a;
	var newNodeGroupIdCounter = _v1.b;
	var json = _v1.c;
	var initialModel = {audioState: audioState, nodeGroupIdCounter: newNodeGroupIdCounter, pendingRequests: $elm$core$Dict$empty, requestCount: 0, samplesPerSecond: $elm$core$Maybe$Nothing, sourceData: $elm$core$Dict$empty, userModel: model};
	var _v2 = $author$project$Audio$encodeAudioCmd$(initialModel, audioCmds);
	var initialModel2 = _v2.a;
	var audioRequests = _v2.b;
	var portMessage = $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'audio',
				$elm$json$Json$Encode$list$($elm$core$Basics$identity, json)),
				_Utils_Tuple2('audioCmds', audioRequests)
			]));
	return _Utils_Tuple2(
		initialModel2,
		$lamdera$program_test$Effect$Command$batch(
			_List_fromArray(
				[
					$lamdera$program_test$Effect$Command$map$($elm$core$Basics$identity, $author$project$Audio$UserMsg, cmds),
					$author$project$Audio$audioPortToJs$(audioPort, portMessage)
				])));
};
var $author$project$Audio$initHelper = F3($author$project$Audio$initHelper$);
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $lamdera$program_test$Effect$Internal$SubBatch = function (a) {
	return {$: 0, a: a};
};
var $lamdera$program_test$Effect$Subscription$batch = $lamdera$program_test$Effect$Internal$SubBatch;
var $author$project$Audio$FromJSMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Audio$JsonParseError = function (a) {
	return {$: 3, a: a};
};
var $author$project$Audio$AudioLoadFailed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Audio$AudioLoadSuccess = function (a) {
	return {$: 0, a: a};
};
var $author$project$Audio$InitAudioContext = function (a) {
	return {$: 2, a: a};
};
var $author$project$Audio$decodeBufferId = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$int);
var $author$project$Audio$decodeLoadError = A2(
	$elm$json$Json$Decode$andThen,
	function (value) {
		switch (value) {
			case 'NetworkError':
				return $elm$json$Json$Decode$succeed(1);
			case 'MediaDecodeAudioDataUnknownContentType':
				return $elm$json$Json$Decode$succeed(0);
			case 'DOMException: The buffer passed to decodeAudioData contains an unknown content type.':
				return $elm$json$Json$Decode$succeed(0);
			default:
				return $elm$json$Json$Decode$succeed(2);
		}
	},
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$Audio$decodeFromJSMsg = A2(
	$elm$json$Json$Decode$andThen,
	function (value) {
		switch (value) {
			case 0:
				return A3(
					$elm$json$Json$Decode$map2,
					F2(
						function (requestId, error) {
							return $author$project$Audio$AudioLoadFailed(
								{error: error, requestId: requestId});
						}),
					A2($elm$json$Json$Decode$field, 'requestId', $elm$json$Json$Decode$int),
					A2($elm$json$Json$Decode$field, 'error', $author$project$Audio$decodeLoadError));
			case 1:
				return A4(
					$elm$json$Json$Decode$map3,
					F3(
						function (requestId, bufferId, duration) {
							return $author$project$Audio$AudioLoadSuccess(
								{
									bufferId: bufferId,
									duration: $ianmackenzie$elm_units$Duration$seconds(duration),
									requestId: requestId
								});
						}),
					A2($elm$json$Json$Decode$field, 'requestId', $elm$json$Json$Decode$int),
					A2($elm$json$Json$Decode$field, 'bufferId', $author$project$Audio$decodeBufferId),
					A2($elm$json$Json$Decode$field, 'durationInSeconds', $elm$json$Json$Decode$float));
			case 2:
				return A2(
					$elm$json$Json$Decode$map,
					function (samplesPerSecond) {
						return $author$project$Audio$InitAudioContext(
							{samplesPerSecond: samplesPerSecond});
					},
					A2($elm$json$Json$Decode$field, 'samplesPerSecond', $elm$json$Json$Decode$int));
			default:
				return $elm$json$Json$Decode$succeed(
					$author$project$Audio$JsonParseError(
						{
							error: 'Type ' + ($elm$core$String$fromInt(value) + ' not handled.')
						}));
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$int));
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $author$project$Audio$fromJSPortSub = function (json) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Audio$decodeFromJSMsg, json);
	if (!_v0.$) {
		var value = _v0.a;
		return $author$project$Audio$FromJSMsg(value);
	} else {
		var error = _v0.a;
		return $author$project$Audio$FromJSMsg(
			$author$project$Audio$JsonParseError(
				{
					error: $elm$json$Json$Decode$errorToString(error)
				}));
	}
};
var $lamdera$program_test$Effect$Internal$SubPort$ = function (a, b, c) {
	return {$: 14, a: a, b: b, c: c};
};
var $lamdera$program_test$Effect$Internal$SubPort = F3($lamdera$program_test$Effect$Internal$SubPort$);
var $lamdera$program_test$Effect$Subscription$fromJs$ = function (portName, portFunction, msg) {
	return $lamdera$program_test$Effect$Internal$SubPort$(
		portName,
		portFunction(msg),
		msg);
};
var $lamdera$program_test$Effect$Subscription$fromJs = F3($lamdera$program_test$Effect$Subscription$fromJs$);
var $lamdera$program_test$Effect$Internal$HttpTrack$ = function (a, b) {
	return {$: 18, a: a, b: b};
};
var $lamdera$program_test$Effect$Internal$HttpTrack = F2($lamdera$program_test$Effect$Internal$HttpTrack$);
var $lamdera$program_test$Effect$Internal$OnAnimationFrame = function (a) {
	return {$: 3, a: a};
};
var $lamdera$program_test$Effect$Internal$OnAnimationFrameDelta = function (a) {
	return {$: 4, a: a};
};
var $lamdera$program_test$Effect$Internal$OnClick = function (a) {
	return {$: 8, a: a};
};
var $lamdera$program_test$Effect$Internal$OnConnect = function (a) {
	return {$: 16, a: a};
};
var $lamdera$program_test$Effect$Internal$OnDisconnect = function (a) {
	return {$: 17, a: a};
};
var $lamdera$program_test$Effect$Internal$OnKeyDown = function (a) {
	return {$: 6, a: a};
};
var $lamdera$program_test$Effect$Internal$OnKeyPress = function (a) {
	return {$: 5, a: a};
};
var $lamdera$program_test$Effect$Internal$OnKeyUp = function (a) {
	return {$: 7, a: a};
};
var $lamdera$program_test$Effect$Internal$OnMouseDown = function (a) {
	return {$: 10, a: a};
};
var $lamdera$program_test$Effect$Internal$OnMouseMove = function (a) {
	return {$: 9, a: a};
};
var $lamdera$program_test$Effect$Internal$OnMouseUp = function (a) {
	return {$: 11, a: a};
};
var $lamdera$program_test$Effect$Internal$OnResize = function (a) {
	return {$: 12, a: a};
};
var $lamdera$program_test$Effect$Internal$OnVisibilityChange = function (a) {
	return {$: 13, a: a};
};
var $lamdera$program_test$Effect$Internal$SubNone = {$: 1};
var $lamdera$program_test$Effect$Internal$SubPortBytes$ = function (a, b, c) {
	return {$: 15, a: a, b: b, c: c};
};
var $lamdera$program_test$Effect$Internal$SubPortBytes = F3($lamdera$program_test$Effect$Internal$SubPortBytes$);
var $lamdera$program_test$Effect$Internal$TimeEvery$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $lamdera$program_test$Effect$Internal$TimeEvery = F2($lamdera$program_test$Effect$Internal$TimeEvery$);
var $lamdera$program_test$Effect$Internal$WebsocketListen$ = function (a, b, c) {
	return {$: 19, a: a, b: b, c: c};
};
var $lamdera$program_test$Effect$Internal$WebsocketListen = F3($lamdera$program_test$Effect$Internal$WebsocketListen$);
var $elm$core$Platform$Sub$map = _Platform_map;
var $lamdera$program_test$Effect$Subscription$map$ = function (mapFunc, subscription) {
	switch (subscription.$) {
		case 0:
			var subscriptions = subscription.a;
			return $lamdera$program_test$Effect$Internal$SubBatch(
				$elm$core$List$map$(
					$lamdera$program_test$Effect$Subscription$map(mapFunc),
					subscriptions));
		case 2:
			var duration = subscription.a;
			var msg = subscription.b;
			return $lamdera$program_test$Effect$Internal$TimeEvery$(
				duration,
				A2($elm$core$Basics$composeR, msg, mapFunc));
		case 3:
			var msg = subscription.a;
			return $lamdera$program_test$Effect$Internal$OnAnimationFrame(
				A2($elm$core$Basics$composeR, msg, mapFunc));
		case 4:
			var msg = subscription.a;
			return $lamdera$program_test$Effect$Internal$OnAnimationFrameDelta(
				A2($elm$core$Basics$composeR, msg, mapFunc));
		case 5:
			var decoder = subscription.a;
			return $lamdera$program_test$Effect$Internal$OnKeyPress(
				A2($elm$json$Json$Decode$map, mapFunc, decoder));
		case 6:
			var decoder = subscription.a;
			return $lamdera$program_test$Effect$Internal$OnKeyDown(
				A2($elm$json$Json$Decode$map, mapFunc, decoder));
		case 7:
			var decoder = subscription.a;
			return $lamdera$program_test$Effect$Internal$OnKeyUp(
				A2($elm$json$Json$Decode$map, mapFunc, decoder));
		case 8:
			var decoder = subscription.a;
			return $lamdera$program_test$Effect$Internal$OnClick(
				A2($elm$json$Json$Decode$map, mapFunc, decoder));
		case 9:
			var decoder = subscription.a;
			return $lamdera$program_test$Effect$Internal$OnMouseMove(
				A2($elm$json$Json$Decode$map, mapFunc, decoder));
		case 10:
			var decoder = subscription.a;
			return $lamdera$program_test$Effect$Internal$OnMouseDown(
				A2($elm$json$Json$Decode$map, mapFunc, decoder));
		case 11:
			var decoder = subscription.a;
			return $lamdera$program_test$Effect$Internal$OnMouseUp(
				A2($elm$json$Json$Decode$map, mapFunc, decoder));
		case 13:
			var msg = subscription.a;
			return $lamdera$program_test$Effect$Internal$OnVisibilityChange(
				A2($elm$core$Basics$composeR, msg, mapFunc));
		case 12:
			var msg = subscription.a;
			return $lamdera$program_test$Effect$Internal$OnResize(
				F2(
					function (w, h) {
						return mapFunc(
							A2(msg, w, h));
					}));
		case 14:
			var portName = subscription.a;
			var sub = subscription.b;
			var msg = subscription.c;
			return $lamdera$program_test$Effect$Internal$SubPort$(
				portName,
				A2($elm$core$Platform$Sub$map, mapFunc, sub),
				A2($elm$core$Basics$composeR, msg, mapFunc));
		case 15:
			var portName = subscription.a;
			var sub = subscription.b;
			var msg = subscription.c;
			return $lamdera$program_test$Effect$Internal$SubPortBytes$(
				portName,
				A2($elm$core$Platform$Sub$map, mapFunc, sub),
				A2($elm$core$Basics$composeR, msg, mapFunc));
		case 1:
			return $lamdera$program_test$Effect$Internal$SubNone;
		case 16:
			var msg = subscription.a;
			return $lamdera$program_test$Effect$Internal$OnConnect(
				F2(
					function (sessionId, clientId) {
						return mapFunc(
							A2(msg, sessionId, clientId));
					}));
		case 17:
			var msg = subscription.a;
			return $lamdera$program_test$Effect$Internal$OnDisconnect(
				F2(
					function (sessionId, clientId) {
						return mapFunc(
							A2(msg, sessionId, clientId));
					}));
		case 18:
			var string = subscription.a;
			var msg = subscription.b;
			return $lamdera$program_test$Effect$Internal$HttpTrack$(
				string,
				A2($elm$core$Basics$composeR, msg, mapFunc));
		default:
			var connection = subscription.a;
			var onData = subscription.b;
			var onClose = subscription.c;
			return $lamdera$program_test$Effect$Internal$WebsocketListen$(
				connection,
				A2($elm$core$Basics$composeR, onData, mapFunc),
				A2($elm$core$Basics$composeR, onClose, mapFunc));
	}
};
var $lamdera$program_test$Effect$Subscription$map = F2($lamdera$program_test$Effect$Subscription$map$);
var $author$project$Audio$subscriptions$ = function (app, _v0) {
	var model = _v0;
	return $lamdera$program_test$Effect$Subscription$batch(
		_List_fromArray(
			[
				$lamdera$program_test$Effect$Subscription$map$(
				$author$project$Audio$UserMsg,
				A2(
					app.subscriptions,
					$author$project$Audio$audioData(model),
					model.userModel)),
				$lamdera$program_test$Effect$Subscription$fromJs$('audioPortFromJs', app.audioPort.fromJS, $author$project$Audio$fromJSPortSub)
			]));
};
var $author$project$Audio$subscriptions = F2($author$project$Audio$subscriptions$);
var $mgold$elm_nonempty_list$List$Nonempty$head = function (_v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return x;
};
var $author$project$Audio$rawBufferId = function (_v0) {
	var bufferId = _v0;
	return bufferId;
};
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $author$project$Audio$updateHelper$ = function (audioPort, audioFunc, userUpdate, _v0) {
	var model = _v0;
	var audioData_ = $author$project$Audio$audioData(model);
	var _v1 = A2(userUpdate, audioData_, model.userModel);
	var newUserModel = _v1.a;
	var userCmd = _v1.b;
	var audioCmds = _v1.c;
	var _v2 = $author$project$Audio$diffAudioState$(
		model.nodeGroupIdCounter,
		model.audioState,
		A2(audioFunc, audioData_, newUserModel));
	var audioState = _v2.a;
	var newNodeGroupIdCounter = _v2.b;
	var json = _v2.c;
	var newModel = _Utils_update(
		model,
		{audioState: audioState, nodeGroupIdCounter: newNodeGroupIdCounter, userModel: newUserModel});
	var _v3 = $author$project$Audio$encodeAudioCmd$(newModel, audioCmds);
	var newModel2 = _v3.a;
	var audioRequests = _v3.b;
	var portMessage = $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'audio',
				$elm$json$Json$Encode$list$($elm$core$Basics$identity, json)),
				_Utils_Tuple2('audioCmds', audioRequests)
			]));
	return _Utils_Tuple2(
		newModel2,
		$lamdera$program_test$Effect$Command$batch(
			_List_fromArray(
				[
					$lamdera$program_test$Effect$Command$map$($elm$core$Basics$identity, $author$project$Audio$UserMsg, userCmd),
					$author$project$Audio$audioPortToJs$(audioPort, portMessage)
				])));
};
var $author$project$Audio$updateHelper = F4($author$project$Audio$updateHelper$);
var $author$project$Audio$update$ = function (app, msg, _v0) {
	var model = _v0;
	if (msg.$ === 1) {
		var userMsg2 = msg.a;
		return $author$project$Audio$updateHelper$(
			app.audioPort.toJS,
			app.audio,
			A2($author$project$Audio$flip, app.update, userMsg2),
			model);
	} else {
		var response = msg.a;
		switch (response.$) {
			case 0:
				var duration = response.a.duration;
				var bufferId = response.a.bufferId;
				var requestId = response.a.requestId;
				var _v3 = $elm$core$Dict$get$(requestId, model.pendingRequests);
				if (!_v3.$) {
					var pendingRequest = _v3.a;
					var sourceData = $elm$core$Dict$insert$(
						$author$project$Audio$rawBufferId(bufferId),
						{duration: duration},
						model.sourceData);
					var source = $elm$core$Result$Ok(
						{bufferId: bufferId});
					var maybeUserMsg = $author$project$Audio$find$(
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$eq(source)),
						$mgold$elm_nonempty_list$List$Nonempty$toList(pendingRequest.userMsg));
					if (!maybeUserMsg.$) {
						var _v5 = maybeUserMsg.a;
						var userMsg2 = _v5.b;
						return $author$project$Audio$updateHelper$(
							app.audioPort.toJS,
							app.audio,
							A2($author$project$Audio$flip, app.update, userMsg2),
							_Utils_update(
								model,
								{
									pendingRequests: $elm$core$Dict$remove$(requestId, model.pendingRequests),
									sourceData: sourceData
								}));
					} else {
						return $author$project$Audio$updateHelper$(
							app.audioPort.toJS,
							app.audio,
							A2(
								$author$project$Audio$flip,
								app.update,
								$mgold$elm_nonempty_list$List$Nonempty$head(pendingRequest.userMsg).b),
							_Utils_update(
								model,
								{
									pendingRequests: $elm$core$Dict$remove$(requestId, model.pendingRequests),
									sourceData: sourceData
								}));
					}
				} else {
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				}
			case 1:
				var error = response.a.error;
				var requestId = response.a.requestId;
				var _v6 = $elm$core$Dict$get$(requestId, model.pendingRequests);
				if (!_v6.$) {
					var pendingRequest = _v6.a;
					var a = $elm$core$Result$Err(error);
					var b = $author$project$Audio$find$(
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							$elm$core$Basics$eq(a)),
						$mgold$elm_nonempty_list$List$Nonempty$toList(pendingRequest.userMsg));
					if (!b.$) {
						var _v8 = b.a;
						var userMsg2 = _v8.b;
						return $author$project$Audio$updateHelper$(
							app.audioPort.toJS,
							app.audio,
							A2($author$project$Audio$flip, app.update, userMsg2),
							_Utils_update(
								model,
								{
									pendingRequests: $elm$core$Dict$remove$(requestId, model.pendingRequests)
								}));
					} else {
						return $author$project$Audio$updateHelper$(
							app.audioPort.toJS,
							app.audio,
							A2(
								$author$project$Audio$flip,
								app.update,
								$mgold$elm_nonempty_list$List$Nonempty$head(pendingRequest.userMsg).b),
							_Utils_update(
								model,
								{
									pendingRequests: $elm$core$Dict$remove$(requestId, model.pendingRequests)
								}));
					}
				} else {
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				}
			case 2:
				var samplesPerSecond = response.a.samplesPerSecond;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							samplesPerSecond: $elm$core$Maybe$Just(samplesPerSecond)
						}),
					$lamdera$program_test$Effect$Command$none);
			default:
				var error = response.a.error;
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
		}
	}
};
var $author$project$Audio$update = F3($author$project$Audio$update$);
var $author$project$Audio$Effect = function (a) {
	return {$: 2, a: a};
};
var $author$project$Audio$Offset = function (a) {
	return {$: 2, a: a};
};
var $author$project$Audio$offsetBy$ = function (offset_, audio_) {
	return $author$project$Audio$Effect(
		{
			audio: audio_,
			effectType: $author$project$Audio$Offset(offset_)
		});
};
var $author$project$Audio$offsetBy = F2($author$project$Audio$offsetBy$);
var $author$project$Audio$withAudioOffset = function (app) {
	return _Utils_update(
		app,
		{
			audio: F2(
				function (audioData_, model) {
					return $author$project$Audio$offsetBy$(
						$ianmackenzie$elm_units$Duration$milliseconds(50),
						A2(app.audio, audioData_, model));
				})
		});
};
var $author$project$Audio$lamderaFrontendWithAudio = function (app) {
	var app2 = $author$project$Audio$withAudioOffset(app);
	return {
		init: F2(
			function (url, key) {
				return $author$project$Audio$initHelper$(
					app2.audioPort.toJS,
					app2.audio,
					A2(app2.init, url, key));
			}),
		onUrlChange: A2($elm$core$Basics$composeR, app2.onUrlChange, $author$project$Audio$UserMsg),
		onUrlRequest: A2($elm$core$Basics$composeR, app2.onUrlRequest, $author$project$Audio$UserMsg),
		subscriptions: $author$project$Audio$subscriptions(app2),
		update: $author$project$Audio$update(app2),
		updateFromBackend: F2(
			function (toFrontend, model) {
				return $author$project$Audio$updateHelper$(
					app2.audioPort.toJS,
					app2.audio,
					A2($author$project$Audio$flip, app2.updateFromBackend, toFrontend),
					model);
			}),
		view: function (model) {
			var _v0 = A2(
				app2.view,
				$author$project$Audio$audioData(model),
				$author$project$Audio$getUserModel(model));
			var body = _v0.body;
			var title = _v0.title;
			return {
				body: $elm$core$List$map$(
					$elm$html$Html$map($author$project$Audio$UserMsg),
					body),
				title: title
			};
		}
	};
};
var $author$project$Types$UrlChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Frontend$onUrlChange = $author$project$Types$UrlChanged;
var $author$project$Types$UrlClicked = function (a) {
	return {$: 0, a: a};
};
var $author$project$Frontend$onUrlRequest = $author$project$Types$UrlClicked;
var $author$project$Types$AiChatMsg = function (a) {
	return {$: 76, a: a};
};
var $author$project$Types$ChannelSidebarAnimated = function (a) {
	return {$: 54, a: a};
};
var $author$project$Types$CheckedNotificationPermission = function (a) {
	return {$: 49, a: a};
};
var $author$project$Types$DomFocusChanged = function (a) {
	return {$: 153, a: a};
};
var $author$project$Types$EncryptionFromJs = function (a) {
	return {$: 186, a: a};
};
var $author$project$Types$FileUploadProgress$ = function (a, b, c) {
	return {$: 95, a: a, b: b, c: c};
};
var $author$project$Types$FileUploadProgress = F3($author$project$Types$FileUploadProgress$);
var $author$project$Types$GotDevicePixelRatio = function (a) {
	return {$: 109, a: a};
};
var $author$project$Types$GotRegisterPushSubscription = function (a) {
	return {$: 98, a: a};
};
var $author$project$Types$GotServiceWorkerData = function (a) {
	return {$: 163, a: a};
};
var $author$project$Types$GotServiceWorkerMessage = function (a) {
	return {$: 124, a: a};
};
var $author$project$Types$GotStartupData = function (a) {
	return {$: 108, a: a};
};
var $author$project$Types$GotTime = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$GotVoiceChatSignalFromJs = function (a) {
	return {$: 155, a: a};
};
var $author$project$Types$GuildIconEditorMsg$ = function (a, b) {
	return {$: 83, a: a, b: b};
};
var $author$project$Types$GuildIconEditorMsg = F2($author$project$Types$GuildIconEditorMsg$);
var $author$project$Types$ImageViewerMsg = function (a) {
	return {$: 97, a: a};
};
var $author$project$Types$KeyDown = function (a) {
	return {$: 41, a: a};
};
var $author$project$Types$MessageMenuAnimated = function (a) {
	return {$: 55, a: a};
};
var $author$project$Types$PageHasFocusChanged = function (a) {
	return {$: 122, a: a};
};
var $author$project$Types$PressedNotification = function (a) {
	return {$: 125, a: a};
};
var $author$project$Types$ProfilePictureEditorMsg = function (a) {
	return {$: 82, a: a};
};
var $author$project$Types$SafeAreaInsetsChanged = function (a) {
	return {$: 127, a: a};
};
var $author$project$Types$TextSelectionChanged = function (a) {
	return {$: 152, a: a};
};
var $author$project$Types$VisualViewportChanged = function (a) {
	return {$: 126, a: a};
};
var $author$project$Types$VoiceChatMsg = function (a) {
	return {$: 156, a: a};
};
var $author$project$Route$slackIsThread = function (threadRoute) {
	if (threadRoute.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Route$threadRouteToShowMembersTab = function (threadRoute) {
	if (threadRoute.$ === 1) {
		var showMembers = threadRoute.c;
		return _Utils_Tuple2(showMembers, true);
	} else {
		var showMembers = threadRoute.b;
		return _Utils_Tuple2(showMembers, false);
	}
};
var $author$project$Route$toShowMembersTab = function (route) {
	switch (route.$) {
		case 5:
			var dmRoute = route.a;
			return $author$project$Route$threadRouteToShowMembersTab(dmRoute.threadRoute);
		case 0:
			return _Utils_Tuple2(1, false);
		case 1:
			return _Utils_Tuple2(1, false);
		case 2:
			return _Utils_Tuple2(1, false);
		case 3:
			var channelRoute = route.b;
			switch (channelRoute.$) {
				case 0:
					var threadRoute = channelRoute.b;
					return $author$project$Route$threadRouteToShowMembersTab(threadRoute);
				case 1:
					return _Utils_Tuple2(1, false);
				case 2:
					return _Utils_Tuple2(1, false);
				default:
					return _Utils_Tuple2(1, false);
			}
		case 4:
			var routeData = route.a;
			var _v2 = routeData.channelRoute;
			switch (_v2.$) {
				case 0:
					var threadRoute = _v2.b;
					return $author$project$Route$threadRouteToShowMembersTab(threadRoute);
				case 1:
					return _Utils_Tuple2(1, false);
				default:
					return _Utils_Tuple2(1, false);
			}
		case 6:
			var routeData = route.a;
			return _Utils_Tuple2(routeData.showMembersTab, false);
		case 7:
			var routeData = route.a;
			var _v3 = routeData.channelRoute;
			if (!_v3.$) {
				var threadRoute = _v3.b;
				var showMembers = _v3.c;
				return _Utils_Tuple2(
					showMembers,
					$author$project$Route$slackIsThread(threadRoute));
			} else {
				return _Utils_Tuple2(1, false);
			}
		case 8:
			return _Utils_Tuple2(1, false);
		case 9:
			return _Utils_Tuple2(1, false);
		case 10:
			return _Utils_Tuple2(1, false);
		case 11:
			return _Utils_Tuple2(1, false);
		case 12:
			return _Utils_Tuple2(1, false);
		default:
			return _Utils_Tuple2(1, false);
	}
};
var $author$project$FrontendExtra$channelSidebarTarget = function (route) {
	var _v0 = $author$project$Route$toShowMembersTab(route);
	if (!_v0.a) {
		var _v1 = _v0.a;
		return 0;
	} else {
		var _v2 = _v0.a;
		var helper = function (channelsVisible) {
			if (channelsVisible === 1) {
				return 2;
			} else {
				return 1;
			}
		};
		switch (route.$) {
			case 3:
				var channelsVisible = route.c;
				return helper(channelsVisible);
			case 4:
				var routeData = route.a;
				return helper(routeData.channelsVisible);
			case 0:
				return 2;
			case 1:
				return 2;
			case 2:
				return 2;
			case 5:
				var routeData = route.a;
				return helper(routeData.channelsVisible);
			case 6:
				var routeData = route.a;
				return helper(routeData.channelsVisible);
			case 7:
				var routeData = route.a;
				return helper(routeData.channelsVisible);
			case 8:
				var routeData = route.a;
				return helper(routeData.channelsVisible);
			case 9:
				return 2;
			case 10:
				return 2;
			case 11:
				return 2;
			case 12:
				return 2;
			default:
				return 2;
		}
	}
};
var $author$project$Ports$NotAsked = 0;
var $author$project$Ports$check_notification_permission_from_js = _Platform_incomingPort('check_notification_permission_from_js', $elm$json$Json$Decode$value);
var $author$project$Ports$Denied = 1;
var $author$project$Ports$Granted = 2;
var $author$project$Ports$Unsupported = 3;
var $author$project$Ports$notificationPermissionFromString = function (text) {
	switch (text) {
		case 'granted':
			return 2;
		case 'denied':
			return 1;
		case 'unsupported':
			return 3;
		default:
			return 0;
	}
};
var $elm$core$Result$withDefault$ = function (def, result) {
	if (!result.$) {
		var a = result.a;
		return a;
	} else {
		return def;
	}
};
var $elm$core$Result$withDefault = F2($elm$core$Result$withDefault$);
var $author$project$Ports$checkNotificationPermissionResponse = function (msg) {
	return $lamdera$program_test$Effect$Subscription$fromJs$(
		'check_notification_permission_from_js',
		$author$project$Ports$check_notification_permission_from_js,
		function (json) {
			return msg(
				$elm$core$Result$withDefault$(
					0,
					A2(
						$elm$json$Json$Decode$decodeValue,
						A2($elm$json$Json$Decode$map, $author$project$Ports$notificationPermissionFromString, $elm$json$Json$Decode$string),
						json)));
		});
};
var $author$project$Message$MessageContent$ = function (content, embeds, attachedFiles) {
	return {attachedFiles: attachedFiles, content: content, embeds: embeds};
};
var $author$project$Message$MessageContent = F3($author$project$Message$MessageContent$);
var $elm$core$Array$fromListHelp$ = function (list, nodeList, nodeListSize) {
	fromListHelp:
	while (true) {
		var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
		var jsArray = _v0.a;
		var remainingItems = _v0.b;
		if (_Utils_cmp(
			$elm$core$Elm$JsArray$length(jsArray),
			$elm$core$Array$branchFactor) < 0) {
			return $elm$core$Array$builderToArray$(
				true,
				{nodeList: nodeList, nodeListSize: nodeListSize, tail: jsArray});
		} else {
			var $temp$list = remainingItems,
				$temp$nodeList = A2(
				$elm$core$List$cons,
				$elm$core$Array$Leaf(jsArray),
				nodeList),
				$temp$nodeListSize = nodeListSize + 1;
			list = $temp$list;
			nodeList = $temp$nodeList;
			nodeListSize = $temp$nodeListSize;
			continue fromListHelp;
		}
	}
};
var $elm$core$Array$fromListHelp = F3($elm$core$Array$fromListHelp$);
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return $elm$core$Array$fromListHelp$(list, _List_Nil, 0);
	}
};
var $elm$bytes$Bytes$Encode$U32$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $elm$bytes$Bytes$Encode$U32 = F2($elm$bytes$Bytes$Encode$U32$);
var $elm$bytes$Bytes$Encode$unsignedInt32 = $elm$bytes$Bytes$Encode$U32;
var $author$project$Serialize$encodeList$ = function (encoder_, list_) {
	return $elm$bytes$Bytes$Encode$sequence(
		A2(
			$elm$core$List$cons,
			A2(
				$elm$bytes$Bytes$Encode$unsignedInt32,
				$author$project$Serialize$endian,
				$elm$core$List$length(list_)),
			$elm$core$List$map$(encoder_, list_)));
};
var $author$project$Serialize$encodeList = F2($author$project$Serialize$encodeList$);
var $author$project$Serialize$listStep$ = function (decoder_, _v0) {
	var n = _v0.a;
	var xs = _v0.b;
	return (n <= 0) ? $elm$bytes$Bytes$Decode$succeed(
		$elm$bytes$Bytes$Decode$Done(
			$elm$core$Result$Ok(
				$elm$core$List$reverse(xs)))) : $elm$bytes$Bytes$Decode$map$(
		function (x) {
			if (!x.$) {
				var ok = x.a;
				return $elm$bytes$Bytes$Decode$Loop(
					_Utils_Tuple2(
						n - 1,
						A2($elm$core$List$cons, ok, xs)));
			} else {
				var err = x.a;
				return $elm$bytes$Bytes$Decode$Done(
					$elm$core$Result$Err(err));
			}
		},
		decoder_);
};
var $author$project$Serialize$listStep = F2($author$project$Serialize$listStep$);
var $author$project$Serialize$list = function (codec) {
	return $author$project$Serialize$build$(
		$author$project$Serialize$encodeList(
			$author$project$Serialize$getBytesEncoderHelper(codec)),
		$elm$bytes$Bytes$Decode$andThen$(
			function (length) {
				return $elm$bytes$Bytes$Decode$loop$(
					_Utils_Tuple2(length, _List_Nil),
					$author$project$Serialize$listStep(
						$author$project$Serialize$getBytesDecoderHelper(codec)));
			},
			$elm$bytes$Bytes$Decode$unsignedInt32($author$project$Serialize$endian)),
		$elm$json$Json$Encode$list(
			$author$project$Serialize$getJsonEncoderHelper(codec)),
		A2(
			$elm$json$Json$Decode$map,
			A2(
				$elm$core$List$foldr,
				F2(
					function (value, state) {
						var _v0 = _Utils_Tuple2(value, state);
						if (_v0.b.$ === 1) {
							return state;
						} else {
							if (!_v0.a.$) {
								var ok = _v0.a.a;
								var okState = _v0.b.a;
								return $elm$core$Result$Ok(
									A2($elm$core$List$cons, ok, okState));
							} else {
								var error = _v0.a.a;
								return $elm$core$Result$Err(error);
							}
						}
					}),
				$elm$core$Result$Ok(_List_Nil)),
			$elm$json$Json$Decode$list(
				$author$project$Serialize$getJsonDecoderHelper(codec))));
};
var $elm$core$Result$map$ = function (func, ra) {
	if (!ra.$) {
		var a = ra.a;
		return $elm$core$Result$Ok(
			func(a));
	} else {
		var e = ra.a;
		return $elm$core$Result$Err(e);
	}
};
var $elm$core$Result$map = F2($elm$core$Result$map$);
var $author$project$Serialize$array = function (codec) {
	return $author$project$Serialize$mapHelper$(
		$elm$core$Result$map($elm$core$Array$fromList),
		$elm$core$Array$toList,
		$author$project$Serialize$list(codec));
};
var $author$project$RichText$AttachedFile = function (a) {
	return {$: 14, a: a};
};
var $author$project$RichText$BlockQuote$ = function (a, b) {
	return {$: 8, a: a, b: b};
};
var $author$project$RichText$BlockQuote = F2($author$project$RichText$BlockQuote$);
var $author$project$RichText$Bold = function (a) {
	return {$: 3, a: a};
};
var $author$project$RichText$BulletPoint$ = function (a, b) {
	return {$: 18, a: a, b: b};
};
var $author$project$RichText$BulletPoint = F2($author$project$RichText$BulletPoint$);
var $author$project$RichText$ChannelMention$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$RichText$ChannelMention = F2($author$project$RichText$ChannelMention$);
var $author$project$RichText$CodeBlock$ = function (a, b) {
	return {$: 13, a: a, b: b};
};
var $author$project$RichText$CodeBlock = F2($author$project$RichText$CodeBlock$);
var $author$project$RichText$CustomEmoji = function (a) {
	return {$: 17, a: a};
};
var $author$project$RichText$EscapedChar = function (a) {
	return {$: 15, a: a};
};
var $author$project$RichText$Heading$ = function (a, b, c) {
	return {$: 9, a: a, b: b, c: c};
};
var $author$project$RichText$Heading = F3($author$project$RichText$Heading$);
var $author$project$RichText$Hyperlink = function (a) {
	return {$: 10, a: a};
};
var $author$project$RichText$InlineCode$ = function (a, b) {
	return {$: 12, a: a, b: b};
};
var $author$project$RichText$InlineCode = F2($author$project$RichText$InlineCode$);
var $author$project$RichText$Italic = function (a) {
	return {$: 4, a: a};
};
var $author$project$RichText$MarkdownLink$ = function (a, b) {
	return {$: 11, a: a, b: b};
};
var $author$project$RichText$MarkdownLink = F2($author$project$RichText$MarkdownLink$);
var $author$project$RichText$NormalText$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$RichText$NormalText = F2($author$project$RichText$NormalText$);
var $author$project$RichText$Spoiler = function (a) {
	return {$: 7, a: a};
};
var $author$project$RichText$Sticker = function (a) {
	return {$: 16, a: a};
};
var $author$project$RichText$Strikethrough = function (a) {
	return {$: 6, a: a};
};
var $author$project$RichText$Timestamp = function (a) {
	return {$: 19, a: a};
};
var $author$project$RichText$Underline = function (a) {
	return {$: 5, a: a};
};
var $author$project$RichText$UserMention = function (a) {
	return {$: 0, a: a};
};
var $author$project$Serialize$unsignedInt32 = $author$project$Serialize$build$(
	$elm$bytes$Bytes$Encode$unsignedInt32($author$project$Serialize$endian),
	$elm$bytes$Bytes$Decode$map$(
		$elm$core$Result$Ok,
		$elm$bytes$Bytes$Decode$unsignedInt32($author$project$Serialize$endian)),
	$elm$json$Json$Encode$int,
	A2($elm$json$Json$Decode$map, $elm$core$Result$Ok, $elm$json$Json$Decode$int));
var $author$project$RichText$charCodec = $author$project$Serialize$map$($elm$core$Char$fromCode, $elm$core$Char$toCode, $author$project$Serialize$unsignedInt32);
var $author$project$RichText$EscapedAtSymbol = 3;
var $author$project$RichText$EscapedBackslash = 1;
var $author$project$RichText$EscapedBacktick = 2;
var $author$project$RichText$EscapedBold = 4;
var $author$project$RichText$EscapedItalic = 5;
var $author$project$RichText$EscapedSpoilered = 7;
var $author$project$RichText$EscapedSquareBracket = 0;
var $author$project$RichText$EscapedStrikethrough = 6;
var $author$project$Serialize$variant0 = function (ctor) {
	return A4(
		$author$project$Serialize$variant,
		function (c) {
			return c(_List_Nil);
		},
		function (c) {
			return c(_List_Nil);
		},
		$elm$bytes$Bytes$Decode$succeed(
			$elm$core$Result$Ok(ctor)),
		$elm$json$Json$Decode$succeed(
			$elm$core$Result$Ok(ctor)));
};
var $author$project$RichText$escapedCharCodec = $author$project$Serialize$finishCustomType(
	A2(
		$author$project$Serialize$variant0,
		7,
		A2(
			$author$project$Serialize$variant0,
			6,
			A2(
				$author$project$Serialize$variant0,
				5,
				A2(
					$author$project$Serialize$variant0,
					4,
					A2(
						$author$project$Serialize$variant0,
						3,
						A2(
							$author$project$Serialize$variant0,
							2,
							A2(
								$author$project$Serialize$variant0,
								1,
								A2(
									$author$project$Serialize$variant0,
									0,
									$author$project$Serialize$customType(
										F9(
											function (escapedSquareBracketEncoder, escapedBackslashEncoder, escapedBacktickEncoder, escapedAtSymbolEncoder, escapedBoldEncoder, escapedItalicEncoder, escapedStrikethroughEncoder, escapedSpoileredEncoder, value) {
												switch (value) {
													case 0:
														return escapedSquareBracketEncoder;
													case 1:
														return escapedBackslashEncoder;
													case 2:
														return escapedBacktickEncoder;
													case 3:
														return escapedAtSymbolEncoder;
													case 4:
														return escapedBoldEncoder;
													case 5:
														return escapedItalicEncoder;
													case 6:
														return escapedStrikethroughEncoder;
													default:
														return escapedSpoileredEncoder;
												}
											})))))))))));
var $author$project$RichText$HasLeadingLineBreak = 0;
var $author$project$RichText$NoLeadingLineBreak = 1;
var $author$project$RichText$hasLeadingLineBreakCodec = $author$project$Serialize$finishCustomType(
	A2(
		$author$project$Serialize$variant0,
		1,
		A2(
			$author$project$Serialize$variant0,
			0,
			$author$project$Serialize$customType(
				F3(
					function (hasLeadingLineBreakEncoder, noLeadingLineBreakEncoder, value) {
						if (!value) {
							return hasLeadingLineBreakEncoder;
						} else {
							return noLeadingLineBreakEncoder;
						}
					})))));
var $author$project$RichText$H1 = 0;
var $author$project$RichText$H2 = 1;
var $author$project$RichText$H3 = 2;
var $author$project$RichText$Small = 3;
var $author$project$RichText$headingLevelCodec = $author$project$Serialize$finishCustomType(
	A2(
		$author$project$Serialize$variant0,
		3,
		A2(
			$author$project$Serialize$variant0,
			2,
			A2(
				$author$project$Serialize$variant0,
				1,
				A2(
					$author$project$Serialize$variant0,
					0,
					$author$project$Serialize$customType(
						F5(
							function (h1Encoder, h2Encoder, h3Encoder, smallEncoder, value) {
								switch (value) {
									case 0:
										return h1Encoder;
									case 1:
										return h2Encoder;
									case 2:
										return h3Encoder;
									default:
										return smallEncoder;
								}
							})))))));
var $author$project$RichText$Language = function (a) {
	return {$: 0, a: a};
};
var $author$project$RichText$NoLanguage = {$: 1};
var $MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString = F2($MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$);
var $elm$bytes$Bytes$Encode$getStringWidth = _Bytes_getStringWidth;
var $author$project$Serialize$string = $author$project$Serialize$build$(
	function (text) {
		return $elm$bytes$Bytes$Encode$sequence(
			_List_fromArray(
				[
					A2(
					$elm$bytes$Bytes$Encode$unsignedInt32,
					$author$project$Serialize$endian,
					$elm$bytes$Bytes$Encode$getStringWidth(text)),
					$elm$bytes$Bytes$Encode$string(text)
				]));
	},
	$elm$bytes$Bytes$Decode$andThen$(
		function (charCount) {
			return $elm$bytes$Bytes$Decode$map$(
				$elm$core$Result$Ok,
				$elm$bytes$Bytes$Decode$string(charCount));
		},
		$elm$bytes$Bytes$Decode$unsignedInt32($author$project$Serialize$endian)),
	$elm$json$Json$Encode$string,
	A2($elm$json$Json$Decode$map, $elm$core$Result$Ok, $elm$json$Json$Decode$string));
var $author$project$RichText$nonemptyStringCodec = $author$project$Serialize$finishCustomType(
	A4(
		$author$project$Serialize$variant2,
		$MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString,
		$author$project$RichText$charCodec,
		$author$project$Serialize$string,
		$author$project$Serialize$customType(
			F2(
				function (nonemptyStringEncoder, value) {
					var argA = value.a;
					var argB = value.b;
					return A2(nonemptyStringEncoder, argA, argB);
				}))));
var $author$project$RichText$languageCodec = $author$project$Serialize$finishCustomType(
	A2(
		$author$project$Serialize$variant0,
		$author$project$RichText$NoLanguage,
		A3(
			$author$project$Serialize$variant1,
			$author$project$RichText$Language,
			$author$project$RichText$nonemptyStringCodec,
			$author$project$Serialize$customType(
				F3(
					function (languageEncoder, noLanguageEncoder, value) {
						if (!value.$) {
							var argA = value.a;
							return languageEncoder(argA);
						} else {
							return noLanguageEncoder;
						}
					})))));
var $author$project$Serialize$lazy = function (f) {
	return $author$project$Serialize$build$(
		function (value) {
			return A2(
				$author$project$Serialize$getBytesEncoderHelper,
				f(0),
				value);
		},
		$elm$bytes$Bytes$Decode$andThen$(
			function (_v0) {
				return $author$project$Serialize$getBytesDecoderHelper(
					f(0));
			},
			$elm$bytes$Bytes$Decode$succeed(0)),
		function (value) {
			return A2(
				$author$project$Serialize$getJsonEncoderHelper,
				f(0),
				value);
		},
		A2(
			$elm$json$Json$Decode$andThen,
			function (_v1) {
				return $author$project$Serialize$getJsonDecoderHelper(
					f(0));
			},
			$elm$json$Json$Decode$succeed(0)));
};
var $author$project$Serialize$maybe = function (justCodec) {
	return $author$project$Serialize$finishCustomType(
		A3(
			$author$project$Serialize$variant1,
			$elm$core$Maybe$Just,
			justCodec,
			A2(
				$author$project$Serialize$variant0,
				$elm$core$Maybe$Nothing,
				$author$project$Serialize$customType(
					F3(
						function (nothingEncoder, justEncoder, value) {
							if (value.$ === 1) {
								return nothingEncoder;
							} else {
								var value_ = value.a;
								return justEncoder(value_);
							}
						})))));
};
var $author$project$RichText$nonemptyCodec = function (a) {
	return $author$project$Serialize$finishCustomType(
		A4(
			$author$project$Serialize$variant2,
			$mgold$elm_nonempty_list$List$Nonempty$Nonempty,
			a,
			$author$project$Serialize$list(a),
			$author$project$Serialize$customType(
				F2(
					function (nonemptyEncoder, value) {
						var argA = value.a;
						var argB = value.b;
						return A2(nonemptyEncoder, argA, argB);
					}))));
};
var $author$project$TimeInMinutes$TimeInMinutes = $elm$core$Basics$identity;
var $author$project$TimeInMinutes$codec = $author$project$Serialize$map$(
	$elm$core$Basics$identity,
	function (_v0) {
		var minutes = _v0;
		return minutes;
	},
	$author$project$Serialize$int);
var $author$project$RichText$timeInMinutesCodec = $author$project$TimeInMinutes$codec;
var $elm$url$Url$Url$ = function (protocol, host, port_, path, query, fragment) {
	return {fragment: fragment, host: host, path: path, port_: port_, protocol: protocol, query: query};
};
var $elm$url$Url$Url = F6($elm$url$Url$Url$);
var $author$project$Serialize$RecordCodec = $elm$core$Basics$identity;
var $author$project$Serialize$field$ = function (getter, codec, _v0) {
	var recordCodec = _v0;
	return {
		decoder: $elm$bytes$Bytes$Decode$map2$(
			F2(
				function (f, x) {
					var _v1 = _Utils_Tuple2(f, x);
					if (!_v1.a.$) {
						if (!_v1.b.$) {
							var fOk = _v1.a.a;
							var xOk = _v1.b.a;
							return $elm$core$Result$Ok(
								fOk(xOk));
						} else {
							var err = _v1.b.a;
							return $elm$core$Result$Err(err);
						}
					} else {
						var err = _v1.a.a;
						return $elm$core$Result$Err(err);
					}
				}),
			recordCodec.decoder,
			$author$project$Serialize$getBytesDecoderHelper(codec)),
		encoder: function (v) {
			return A2(
				$elm$core$List$cons,
				A2(
					$author$project$Serialize$getBytesEncoderHelper,
					codec,
					getter(v)),
				recordCodec.encoder(v));
		},
		fieldIndex: recordCodec.fieldIndex + 1,
		jsonDecoder: A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (f, x) {
					var _v2 = _Utils_Tuple2(f, x);
					if (!_v2.a.$) {
						if (!_v2.b.$) {
							var fOk = _v2.a.a;
							var xOk = _v2.b.a;
							return $elm$core$Result$Ok(
								fOk(xOk));
						} else {
							var err = _v2.b.a;
							return $elm$core$Result$Err(err);
						}
					} else {
						var err = _v2.a.a;
						return $elm$core$Result$Err(err);
					}
				}),
			recordCodec.jsonDecoder,
			A2(
				$elm$json$Json$Decode$index,
				recordCodec.fieldIndex,
				$author$project$Serialize$getJsonDecoderHelper(codec))),
		jsonEncoder: function (v) {
			return A2(
				$elm$core$List$cons,
				A2(
					$author$project$Serialize$getJsonEncoderHelper,
					codec,
					getter(v)),
				recordCodec.jsonEncoder(v));
		}
	};
};
var $author$project$Serialize$field = F3($author$project$Serialize$field$);
var $author$project$Serialize$finishRecord = function (_v0) {
	var codec = _v0;
	return {
		decoder: codec.decoder,
		encoder: A2(
			$elm$core$Basics$composeR,
			codec.encoder,
			A2($elm$core$Basics$composeR, $elm$core$List$reverse, $elm$bytes$Bytes$Encode$sequence)),
		jsonDecoder: codec.jsonDecoder,
		jsonEncoder: A2(
			$elm$core$Basics$composeR,
			codec.jsonEncoder,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$reverse,
				$elm$json$Json$Encode$list($elm$core$Basics$identity)))
	};
};
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $author$project$RichText$protocolCodec = $author$project$Serialize$finishCustomType(
	A2(
		$author$project$Serialize$variant0,
		1,
		A2(
			$author$project$Serialize$variant0,
			0,
			$author$project$Serialize$customType(
				F3(
					function (httpEncoder, httpsEncoder, value) {
						if (!value) {
							return httpEncoder;
						} else {
							return httpsEncoder;
						}
					})))));
var $author$project$Serialize$record = function (ctor) {
	return {
		decoder: $elm$bytes$Bytes$Decode$succeed(
			$elm$core$Result$Ok(ctor)),
		encoder: function (_v0) {
			return _List_Nil;
		},
		fieldIndex: 0,
		jsonDecoder: $elm$json$Json$Decode$succeed(
			$elm$core$Result$Ok(ctor)),
		jsonEncoder: function (_v1) {
			return _List_Nil;
		}
	};
};
var $author$project$RichText$urlCodec = $author$project$Serialize$finishRecord(
	$author$project$Serialize$field$(
		function ($) {
			return $.fragment;
		},
		$author$project$Serialize$maybe($author$project$Serialize$string),
		$author$project$Serialize$field$(
			function ($) {
				return $.query;
			},
			$author$project$Serialize$maybe($author$project$Serialize$string),
			$author$project$Serialize$field$(
				function ($) {
					return $.path;
				},
				$author$project$Serialize$string,
				$author$project$Serialize$field$(
					function ($) {
						return $.port_;
					},
					$author$project$Serialize$maybe($author$project$Serialize$unsignedInt16),
					$author$project$Serialize$field$(
						function ($) {
							return $.host;
						},
						$author$project$Serialize$string,
						$author$project$Serialize$field$(
							function ($) {
								return $.protocol;
							},
							$author$project$RichText$protocolCodec,
							$author$project$Serialize$record($elm$url$Url$Url))))))));
var $author$project$Serialize$result3$ = function (ctor, v1, v2, v3) {
	var _v0 = _Utils_Tuple3(v1, v2, v3);
	if (!_v0.a.$) {
		if (!_v0.b.$) {
			if (!_v0.c.$) {
				var ok1 = _v0.a.a;
				var ok2 = _v0.b.a;
				var ok3 = _v0.c.a;
				return $elm$core$Result$Ok(
					A3(ctor, ok1, ok2, ok3));
			} else {
				var err = _v0.c.a;
				return $elm$core$Result$Err(err);
			}
		} else {
			var err = _v0.b.a;
			return $elm$core$Result$Err(err);
		}
	} else {
		var err = _v0.a.a;
		return $elm$core$Result$Err(err);
	}
};
var $author$project$Serialize$result3 = F4($author$project$Serialize$result3$);
var $author$project$Serialize$variant3$ = function (ctor, m1, m2, m3) {
	return A4(
		$author$project$Serialize$variant,
		F4(
			function (c, v1, v2, v3) {
				return c(
					_List_fromArray(
						[
							A2($author$project$Serialize$getBytesEncoderHelper, m1, v1),
							A2($author$project$Serialize$getBytesEncoderHelper, m2, v2),
							A2($author$project$Serialize$getBytesEncoderHelper, m3, v3)
						]));
			}),
		F4(
			function (c, v1, v2, v3) {
				return c(
					_List_fromArray(
						[
							A2($author$project$Serialize$getJsonEncoderHelper, m1, v1),
							A2($author$project$Serialize$getJsonEncoderHelper, m2, v2),
							A2($author$project$Serialize$getJsonEncoderHelper, m3, v3)
						]));
			}),
		$elm$bytes$Bytes$Decode$map3$(
			$author$project$Serialize$result3(ctor),
			$author$project$Serialize$getBytesDecoderHelper(m1),
			$author$project$Serialize$getBytesDecoderHelper(m2),
			$author$project$Serialize$getBytesDecoderHelper(m3)),
		A4(
			$elm$json$Json$Decode$map3,
			$author$project$Serialize$result3(ctor),
			A2(
				$elm$json$Json$Decode$index,
				1,
				$author$project$Serialize$getJsonDecoderHelper(m1)),
			A2(
				$elm$json$Json$Decode$index,
				2,
				$author$project$Serialize$getJsonDecoderHelper(m2)),
			A2(
				$elm$json$Json$Decode$index,
				3,
				$author$project$Serialize$getJsonDecoderHelper(m3))));
};
var $author$project$Serialize$variant3 = F4($author$project$Serialize$variant3$);
var $author$project$RichText$codec$ = function (userIdCodec, channelIdCodec) {
	return $author$project$Serialize$finishCustomType(
		A4(
			$author$project$Serialize$variant2,
			$author$project$RichText$ChannelMention,
			channelIdCodec,
			$author$project$Serialize$maybe($author$project$Id$codec),
			A3(
				$author$project$Serialize$variant1,
				$author$project$RichText$Timestamp,
				$author$project$RichText$timeInMinutesCodec,
				A4(
					$author$project$Serialize$variant2,
					$author$project$RichText$BulletPoint,
					$author$project$RichText$hasLeadingLineBreakCodec,
					$author$project$RichText$nonemptyCodec(
						$author$project$Serialize$list(
							$author$project$Serialize$lazy(
								function (_v8) {
									return $author$project$RichText$codec$(userIdCodec, channelIdCodec);
								}))),
					A3(
						$author$project$Serialize$variant1,
						$author$project$RichText$CustomEmoji,
						$author$project$Id$codec,
						A3(
							$author$project$Serialize$variant1,
							$author$project$RichText$Sticker,
							$author$project$Id$codec,
							A3(
								$author$project$Serialize$variant1,
								$author$project$RichText$EscapedChar,
								$author$project$RichText$escapedCharCodec,
								A3(
									$author$project$Serialize$variant1,
									$author$project$RichText$AttachedFile,
									$author$project$Id$codec,
									A4(
										$author$project$Serialize$variant2,
										$author$project$RichText$CodeBlock,
										$author$project$RichText$languageCodec,
										$author$project$Serialize$string,
										A4(
											$author$project$Serialize$variant2,
											$author$project$RichText$InlineCode,
											$author$project$RichText$charCodec,
											$author$project$Serialize$string,
											A4(
												$author$project$Serialize$variant2,
												$author$project$RichText$MarkdownLink,
												$author$project$RichText$nonemptyStringCodec,
												$author$project$RichText$urlCodec,
												A3(
													$author$project$Serialize$variant1,
													$author$project$RichText$Hyperlink,
													$author$project$RichText$urlCodec,
													A5(
														$author$project$Serialize$variant3,
														$author$project$RichText$Heading,
														$author$project$RichText$headingLevelCodec,
														$author$project$RichText$hasLeadingLineBreakCodec,
														$author$project$RichText$nonemptyCodec(
															$author$project$Serialize$lazy(
																function (_v7) {
																	return $author$project$RichText$codec$(userIdCodec, channelIdCodec);
																})),
														A4(
															$author$project$Serialize$variant2,
															$author$project$RichText$BlockQuote,
															$author$project$RichText$hasLeadingLineBreakCodec,
															$author$project$Serialize$list(
																$author$project$Serialize$lazy(
																	function (_v6) {
																		return $author$project$RichText$codec$(userIdCodec, channelIdCodec);
																	})),
															A3(
																$author$project$Serialize$variant1,
																$author$project$RichText$Spoiler,
																$author$project$RichText$nonemptyCodec(
																	$author$project$Serialize$lazy(
																		function (_v5) {
																			return $author$project$RichText$codec$(userIdCodec, channelIdCodec);
																		})),
																A3(
																	$author$project$Serialize$variant1,
																	$author$project$RichText$Strikethrough,
																	$author$project$RichText$nonemptyCodec(
																		$author$project$Serialize$lazy(
																			function (_v4) {
																				return $author$project$RichText$codec$(userIdCodec, channelIdCodec);
																			})),
																	A3(
																		$author$project$Serialize$variant1,
																		$author$project$RichText$Underline,
																		$author$project$RichText$nonemptyCodec(
																			$author$project$Serialize$lazy(
																				function (_v3) {
																					return $author$project$RichText$codec$(userIdCodec, channelIdCodec);
																				})),
																		A3(
																			$author$project$Serialize$variant1,
																			$author$project$RichText$Italic,
																			$author$project$RichText$nonemptyCodec(
																				$author$project$Serialize$lazy(
																					function (_v2) {
																						return $author$project$RichText$codec$(userIdCodec, channelIdCodec);
																					})),
																			A3(
																				$author$project$Serialize$variant1,
																				$author$project$RichText$Bold,
																				$author$project$RichText$nonemptyCodec(
																					$author$project$Serialize$lazy(
																						function (_v1) {
																							return $author$project$RichText$codec$(userIdCodec, channelIdCodec);
																						})),
																				A4(
																					$author$project$Serialize$variant2,
																					$author$project$RichText$NormalText,
																					$author$project$RichText$charCodec,
																					$author$project$Serialize$string,
																					A3(
																						$author$project$Serialize$variant1,
																						$author$project$RichText$UserMention,
																						userIdCodec,
																						$author$project$Serialize$customType(
																							function (userMentionEncoder) {
																								return function (normalTextEncoder) {
																									return function (boldEncoder) {
																										return function (italicEncoder) {
																											return function (underlineEncoder) {
																												return function (strikethroughEncoder) {
																													return function (spoilerEncoder) {
																														return function (blockQuoteEncoder) {
																															return function (headingEncoder) {
																																return function (hyperlinkEncoder) {
																																	return function (markdownLinkEncoder) {
																																		return function (inlineCodeEncoder) {
																																			return function (codeBlockEncoder) {
																																				return function (attachedFileEncoder) {
																																					return function (escapedCharEncoder) {
																																						return function (stickerEncoder) {
																																							return function (customEmojiEncoder) {
																																								return function (bulletPointEncoder) {
																																									return function (timestampEncoder) {
																																										return function (channelMentionEncoder) {
																																											return function (value) {
																																												switch (value.$) {
																																													case 0:
																																														var argA = value.a;
																																														return userMentionEncoder(argA);
																																													case 2:
																																														var argA = value.a;
																																														var argB = value.b;
																																														return A2(normalTextEncoder, argA, argB);
																																													case 3:
																																														var argA = value.a;
																																														return boldEncoder(argA);
																																													case 4:
																																														var argA = value.a;
																																														return italicEncoder(argA);
																																													case 5:
																																														var argA = value.a;
																																														return underlineEncoder(argA);
																																													case 6:
																																														var argA = value.a;
																																														return strikethroughEncoder(argA);
																																													case 7:
																																														var argA = value.a;
																																														return spoilerEncoder(argA);
																																													case 8:
																																														var argA = value.a;
																																														var argB = value.b;
																																														return A2(blockQuoteEncoder, argA, argB);
																																													case 9:
																																														var argA = value.a;
																																														var argB = value.b;
																																														var argC = value.c;
																																														return A3(headingEncoder, argA, argB, argC);
																																													case 10:
																																														var argA = value.a;
																																														return hyperlinkEncoder(argA);
																																													case 11:
																																														var argA = value.a;
																																														var argB = value.b;
																																														return A2(markdownLinkEncoder, argA, argB);
																																													case 12:
																																														var argA = value.a;
																																														var argB = value.b;
																																														return A2(inlineCodeEncoder, argA, argB);
																																													case 13:
																																														var argA = value.a;
																																														var argB = value.b;
																																														return A2(codeBlockEncoder, argA, argB);
																																													case 14:
																																														var argA = value.a;
																																														return attachedFileEncoder(argA);
																																													case 15:
																																														var argA = value.a;
																																														return escapedCharEncoder(argA);
																																													case 16:
																																														var argA = value.a;
																																														return stickerEncoder(argA);
																																													case 17:
																																														var argA = value.a;
																																														return customEmojiEncoder(argA);
																																													case 18:
																																														var argA = value.a;
																																														var argB = value.b;
																																														return A2(bulletPointEncoder, argA, argB);
																																													case 19:
																																														var argA = value.a;
																																														return timestampEncoder(argA);
																																													default:
																																														var argA = value.a;
																																														var argB = value.b;
																																														return A2(channelMentionEncoder, argA, argB);
																																												}
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							}))))))))))))))))))))));
};
var $author$project$RichText$codec = F2($author$project$RichText$codec$);
var $author$project$Embed$EmbedLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Embed$EmbedLoading = {$: 0};
var $author$project$Embed$EmbedData$ = function (title, image, description, createdAt) {
	return {createdAt: createdAt, description: description, image: image, title: title};
};
var $author$project$Embed$EmbedData = F4($author$project$Embed$EmbedData$);
var $author$project$Embed$EmbedImageData$ = function (url, imageSize, format) {
	return {format: format, imageSize: imageSize, url: url};
};
var $author$project$Embed$EmbedImageData = F3($author$project$Embed$EmbedImageData$);
var $author$project$Embed$Avif = 13;
var $author$project$Embed$Bmp = 8;
var $author$project$Embed$Dds = 7;
var $author$project$Embed$Farbfeld = 12;
var $author$project$Embed$Gif = 2;
var $author$project$Embed$Hdr = 10;
var $author$project$Embed$Ico = 9;
var $author$project$Embed$Jpeg = 1;
var $author$project$Embed$OpenExr = 11;
var $author$project$Embed$Png = 0;
var $author$project$Embed$Pnm = 4;
var $author$project$Embed$Qoi = 14;
var $author$project$Embed$Tga = 6;
var $author$project$Embed$Tiff = 5;
var $author$project$Embed$WebP = 3;
var $author$project$Serialize$findIndexHelp$ = function (index, predicate, list_) {
	findIndexHelp:
	while (true) {
		if (!list_.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var x = list_.a;
			var xs = list_.b;
			if (predicate(x)) {
				return $elm$core$Maybe$Just(index);
			} else {
				var $temp$index = index + 1,
					$temp$list_ = xs;
				index = $temp$index;
				list_ = $temp$list_;
				continue findIndexHelp;
			}
		}
	}
};
var $author$project$Serialize$findIndexHelp = F3($author$project$Serialize$findIndexHelp$);
var $author$project$Serialize$findIndex = $author$project$Serialize$findIndexHelp(0);
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Serialize$getAt$ = function (idx, xs) {
	return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
		$elm$core$List$drop$(idx, xs));
};
var $author$project$Serialize$getAt = F2($author$project$Serialize$getAt$);
var $author$project$Serialize$enum$ = function (defaultItem, items) {
	var getItem = function (index) {
		return (index < 0) ? $elm$core$Result$Err($author$project$Serialize$DataCorrupted) : ((_Utils_cmp(
			index,
			$elm$core$List$length(items)) > 0) ? $elm$core$Result$Err($author$project$Serialize$DataCorrupted) : $elm$core$Result$Ok(
			$elm$core$Maybe$withDefault$(
				defaultItem,
				$author$project$Serialize$getAt$(index - 1, items))));
	};
	var getIndex = function (value) {
		return 1 + $elm$core$Maybe$withDefault$(
			-1,
			A2(
				$author$project$Serialize$findIndex,
				$elm$core$Basics$eq(value),
				items));
	};
	return $author$project$Serialize$build$(
		A2(
			$elm$core$Basics$composeR,
			getIndex,
			$elm$bytes$Bytes$Encode$unsignedInt32($author$project$Serialize$endian)),
		$elm$bytes$Bytes$Decode$map$(
			getItem,
			$elm$bytes$Bytes$Decode$unsignedInt32($author$project$Serialize$endian)),
		A2($elm$core$Basics$composeR, getIndex, $elm$json$Json$Encode$int),
		A2($elm$json$Json$Decode$map, getItem, $elm$json$Json$Decode$int));
};
var $author$project$Serialize$enum = F2($author$project$Serialize$enum$);
var $author$project$Message$embedImageFormatCodec = $author$project$Serialize$enum$(
	0,
	_List_fromArray(
		[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]));
var $ianmackenzie$elm_units$Quantity$unsafe = function (value) {
	return value;
};
var $ianmackenzie$elm_units$Quantity$unwrap = function (_v0) {
	var value = _v0;
	return value;
};
var $author$project$Message$quantityCodec = $author$project$Serialize$map$($ianmackenzie$elm_units$Quantity$unsafe, $ianmackenzie$elm_units$Quantity$unwrap, $author$project$Serialize$unsignedInt32);
var $author$project$Serialize$tuple$ = function (codecFirst, codecSecond) {
	return $author$project$Serialize$finishRecord(
		$author$project$Serialize$field$(
			$elm$core$Tuple$second,
			codecSecond,
			$author$project$Serialize$field$(
				$elm$core$Tuple$first,
				codecFirst,
				$author$project$Serialize$record($elm$core$Tuple$pair))));
};
var $author$project$Serialize$tuple = F2($author$project$Serialize$tuple$);
var $author$project$Message$embedImageDataCodec = $author$project$Serialize$finishRecord(
	$author$project$Serialize$field$(
		function ($) {
			return $.format;
		},
		$author$project$Serialize$maybe($author$project$Message$embedImageFormatCodec),
		$author$project$Serialize$field$(
			function ($) {
				return $.imageSize;
			},
			$author$project$Serialize$tuple$($author$project$Message$quantityCodec, $author$project$Message$quantityCodec),
			$author$project$Serialize$field$(
				function ($) {
					return $.url;
				},
				$author$project$Serialize$string,
				$author$project$Serialize$record($author$project$Embed$EmbedImageData)))));
var $author$project$Message$posixCodec = $author$project$Serialize$map$($elm$time$Time$millisToPosix, $elm$time$Time$posixToMillis, $author$project$Serialize$int);
var $author$project$Message$embedDataCodec = $author$project$Serialize$finishRecord(
	$author$project$Serialize$field$(
		function ($) {
			return $.createdAt;
		},
		$author$project$Serialize$maybe($author$project$Message$posixCodec),
		$author$project$Serialize$field$(
			function ($) {
				return $.description;
			},
			$author$project$Serialize$maybe($author$project$Serialize$string),
			$author$project$Serialize$field$(
				function ($) {
					return $.image;
				},
				$author$project$Serialize$maybe($author$project$Message$embedImageDataCodec),
				$author$project$Serialize$field$(
					function ($) {
						return $.title;
					},
					$author$project$Serialize$maybe($author$project$Serialize$string),
					$author$project$Serialize$record($author$project$Embed$EmbedData))))));
var $author$project$Message$embedCodec = $author$project$Serialize$finishCustomType(
	A3(
		$author$project$Serialize$variant1,
		$author$project$Embed$EmbedLoaded,
		$author$project$Message$embedDataCodec,
		A2(
			$author$project$Serialize$variant0,
			$author$project$Embed$EmbedLoading,
			$author$project$Serialize$customType(
				F3(
					function (embedLoadingEncoder, embedLoadedEncoder, value) {
						if (!value.$) {
							return embedLoadingEncoder;
						} else {
							var argA = value.a;
							return embedLoadedEncoder(argA);
						}
					})))));
var $author$project$FileStatus$FileData$ = function (fileName, fileSize, metadata, contentType, fileHash, isEncrypted) {
	return {contentType: contentType, fileHash: fileHash, fileName: fileName, fileSize: fileSize, isEncrypted: isEncrypted, metadata: metadata};
};
var $author$project$FileStatus$FileData = F6($author$project$FileStatus$FileData$);
var $author$project$FileName$FileName = $elm$core$Basics$identity;
var $elm$core$String$filter = _String_filter;
var $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString = function (text) {
	var _v0 = $elm$core$String$uncons(text);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var head_ = _v1.a;
		var tail_ = _v1.b;
		return $elm$core$Maybe$Just(
			$MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$(head_, tail_));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$String$trim = _String_trim;
var $author$project$FileName$fromString = function (text) {
	var _v0 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(
		A2(
			$elm$core$String$filter,
			function (_char) {
				return (_char !== '\n') && ((_char !== '\r') && ((_char !== '/') && (_char !== '\\')));
			},
			$elm$core$String$left$(
				1024,
				$elm$core$String$trim(text))));
	if (!_v0.$) {
		var nonempty = _v0.a;
		return nonempty;
	} else {
		return $MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('f', 'ile');
	}
};
var $MartinSStewart$elm_nonempty_string$String$Nonempty$toString = function (_v0) {
	var head_ = _v0.a;
	var tail_ = _v0.b;
	return A2($elm$core$String$cons, head_, tail_);
};
var $author$project$FileName$toString = function (_v0) {
	var a = _v0;
	return $MartinSStewart$elm_nonempty_string$String$Nonempty$toString(a);
};
var $author$project$FileName$codec = $author$project$Serialize$map$($author$project$FileName$fromString, $author$project$FileName$toString, $author$project$Serialize$string);
var $author$project$FileStatus$ContentType = $elm$core$Basics$identity;
var $author$project$FileStatus$contentTypeSerializeCodec = $author$project$Serialize$map$(
	$elm$core$Basics$identity,
	function (_v0) {
		var a = _v0;
		return a;
	},
	$author$project$Serialize$unsignedInt16);
var $author$project$FileStatus$FileHash = $elm$core$Basics$identity;
var $author$project$FileStatus$fileHashSerializeCodec = $author$project$Serialize$map$(
	$elm$core$Basics$identity,
	function (_v0) {
		var a = _v0;
		return a;
	},
	$author$project$Serialize$string);
var $author$project$FileStatus$FileMetadata_Image = function (a) {
	return {$: 0, a: a};
};
var $author$project$FileStatus$FileMetadata_Video = function (a) {
	return {$: 1, a: a};
};
var $author$project$FileStatus$ImageMetadata$ = function (imageSize, orientation, gpsLocation, cameraOwner, exposureTime, fNumber, focalLength, isoSpeedRating, make, model, software, userComment) {
	return {cameraOwner: cameraOwner, exposureTime: exposureTime, fNumber: fNumber, focalLength: focalLength, gpsLocation: gpsLocation, imageSize: imageSize, isoSpeedRating: isoSpeedRating, make: make, model: model, orientation: orientation, software: software, userComment: userComment};
};
var $author$project$FileStatus$ImageMetadata = function (imageSize) {
	return function (orientation) {
		return function (gpsLocation) {
			return function (cameraOwner) {
				return function (exposureTime) {
					return function (fNumber) {
						return function (focalLength) {
							return function (isoSpeedRating) {
								return function (make) {
									return function (model) {
										return function (software) {
											return function (userComment) {
												return $author$project$FileStatus$ImageMetadata$(imageSize, orientation, gpsLocation, cameraOwner, exposureTime, fNumber, focalLength, isoSpeedRating, make, model, software, userComment);
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$FileStatus$quantitySerializeCodec = function (number) {
	return $author$project$Serialize$finishCustomType(
		A3(
			$author$project$Serialize$variant1,
			$elm$core$Basics$identity,
			number,
			$author$project$Serialize$customType(
				F2(
					function (quantityEncoder, value) {
						var argA = value;
						return quantityEncoder(argA);
					}))));
};
var $author$project$FileStatus$coordSerializeCodec = $author$project$Serialize$tuple$(
	$author$project$FileStatus$quantitySerializeCodec($author$project$Serialize$int),
	$author$project$FileStatus$quantitySerializeCodec($author$project$Serialize$int));
var $author$project$FileStatus$ExposureTime$ = function (numerator, denominator) {
	return {denominator: denominator, numerator: numerator};
};
var $author$project$FileStatus$ExposureTime = F2($author$project$FileStatus$ExposureTime$);
var $author$project$FileStatus$exposureTimeSerializeCodec = $author$project$Serialize$finishRecord(
	$author$project$Serialize$field$(
		function ($) {
			return $.denominator;
		},
		$author$project$Serialize$int,
		$author$project$Serialize$field$(
			function ($) {
				return $.numerator;
			},
			$author$project$Serialize$int,
			$author$project$Serialize$record($author$project$FileStatus$ExposureTime))));
var $author$project$FileStatus$Location$ = function (lat, lon) {
	return {lat: lat, lon: lon};
};
var $author$project$FileStatus$Location = F2($author$project$FileStatus$Location$);
var $author$project$Serialize$float = $author$project$Serialize$build$(
	$elm$bytes$Bytes$Encode$float64($author$project$Serialize$endian),
	$elm$bytes$Bytes$Decode$map$(
		$elm$core$Result$Ok,
		$elm$bytes$Bytes$Decode$float64($author$project$Serialize$endian)),
	$elm$json$Json$Encode$float,
	A2($elm$json$Json$Decode$map, $elm$core$Result$Ok, $elm$json$Json$Decode$float));
var $author$project$Serialize$CustomError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Serialize$mapValid$ = function (fromBytes_, toBytes_, codec) {
	return $author$project$Serialize$build$(
		function (v) {
			return A2(
				$author$project$Serialize$getBytesEncoderHelper,
				codec,
				toBytes_(v));
		},
		$elm$bytes$Bytes$Decode$map$(
			function (value) {
				if (!value.$) {
					var ok = value.a;
					return $elm$core$Result$mapError$(
						$author$project$Serialize$CustomError,
						fromBytes_(ok));
				} else {
					var err = value.a;
					return $elm$core$Result$Err(err);
				}
			},
			$author$project$Serialize$getBytesDecoderHelper(codec)),
		function (v) {
			return A2(
				$author$project$Serialize$getJsonEncoderHelper,
				codec,
				toBytes_(v));
		},
		A2(
			$elm$json$Json$Decode$map,
			function (value) {
				if (!value.$) {
					var ok = value.a;
					return $elm$core$Result$mapError$(
						$author$project$Serialize$CustomError,
						fromBytes_(ok));
				} else {
					var err = value.a;
					return $elm$core$Result$Err(err);
				}
			},
			$author$project$Serialize$getJsonDecoderHelper(codec)));
};
var $author$project$Serialize$mapValid = F3($author$project$Serialize$mapValid$);
var $author$project$SafeFloat$serializeCodec = $author$project$Serialize$mapValid$($author$project$SafeFloat$fromFloat, $author$project$SafeFloat$toFloat, $author$project$Serialize$float);
var $author$project$FileStatus$locationSerializeCodec = $author$project$Serialize$finishRecord(
	$author$project$Serialize$field$(
		function ($) {
			return $.lon;
		},
		$author$project$SafeFloat$serializeCodec,
		$author$project$Serialize$field$(
			function ($) {
				return $.lat;
			},
			$author$project$SafeFloat$serializeCodec,
			$author$project$Serialize$record($author$project$FileStatus$Location))));
var $author$project$FileStatus$Mirrored = 4;
var $author$project$FileStatus$MirroredRotation180 = 6;
var $author$project$FileStatus$MirroredRotation270 = 7;
var $author$project$FileStatus$MirroredRotation90 = 5;
var $author$project$FileStatus$NoChange = 0;
var $author$project$FileStatus$Rotation180 = 2;
var $author$project$FileStatus$Rotation270 = 3;
var $author$project$FileStatus$Rotation90 = 1;
var $author$project$FileStatus$orientationSerializeCodec = $author$project$Serialize$finishCustomType(
	A2(
		$author$project$Serialize$variant0,
		7,
		A2(
			$author$project$Serialize$variant0,
			6,
			A2(
				$author$project$Serialize$variant0,
				5,
				A2(
					$author$project$Serialize$variant0,
					4,
					A2(
						$author$project$Serialize$variant0,
						3,
						A2(
							$author$project$Serialize$variant0,
							2,
							A2(
								$author$project$Serialize$variant0,
								1,
								A2(
									$author$project$Serialize$variant0,
									0,
									$author$project$Serialize$customType(
										F9(
											function (noChangeEncoder, r90Encoder, r180Encoder, r270Encoder, mirroredEncoder, mr90Encoder, mr180Encoder, mr270Encoder, value) {
												switch (value) {
													case 0:
														return noChangeEncoder;
													case 1:
														return r90Encoder;
													case 2:
														return r180Encoder;
													case 3:
														return r270Encoder;
													case 4:
														return mirroredEncoder;
													case 5:
														return mr90Encoder;
													case 6:
														return mr180Encoder;
													default:
														return mr270Encoder;
												}
											})))))))))));
var $author$project$FileStatus$imageMetadataSerializeCodec = $author$project$Serialize$finishRecord(
	$author$project$Serialize$field$(
		function ($) {
			return $.userComment;
		},
		$author$project$Serialize$maybe($author$project$Serialize$string),
		$author$project$Serialize$field$(
			function ($) {
				return $.software;
			},
			$author$project$Serialize$maybe($author$project$Serialize$string),
			$author$project$Serialize$field$(
				function ($) {
					return $.model;
				},
				$author$project$Serialize$maybe($author$project$Serialize$string),
				$author$project$Serialize$field$(
					function ($) {
						return $.make;
					},
					$author$project$Serialize$maybe($author$project$Serialize$string),
					$author$project$Serialize$field$(
						function ($) {
							return $.isoSpeedRating;
						},
						$author$project$Serialize$maybe($author$project$Serialize$int),
						$author$project$Serialize$field$(
							function ($) {
								return $.focalLength;
							},
							$author$project$Serialize$maybe($author$project$SafeFloat$serializeCodec),
							$author$project$Serialize$field$(
								function ($) {
									return $.fNumber;
								},
								$author$project$Serialize$maybe($author$project$SafeFloat$serializeCodec),
								$author$project$Serialize$field$(
									function ($) {
										return $.exposureTime;
									},
									$author$project$Serialize$maybe($author$project$FileStatus$exposureTimeSerializeCodec),
									$author$project$Serialize$field$(
										function ($) {
											return $.cameraOwner;
										},
										$author$project$Serialize$maybe($author$project$Serialize$string),
										$author$project$Serialize$field$(
											function ($) {
												return $.gpsLocation;
											},
											$author$project$Serialize$maybe($author$project$FileStatus$locationSerializeCodec),
											$author$project$Serialize$field$(
												function ($) {
													return $.orientation;
												},
												$author$project$Serialize$maybe($author$project$FileStatus$orientationSerializeCodec),
												$author$project$Serialize$field$(
													function ($) {
														return $.imageSize;
													},
													$author$project$FileStatus$coordSerializeCodec,
													$author$project$Serialize$record($author$project$FileStatus$ImageMetadata))))))))))))));
var $author$project$FileStatus$VideoMetadata$ = function (videoSize, createdAt, orientation, codec, title, gpsLocation, duration) {
	return {codec: codec, createdAt: createdAt, duration: duration, gpsLocation: gpsLocation, orientation: orientation, title: title, videoSize: videoSize};
};
var $author$project$FileStatus$VideoMetadata = F7($author$project$FileStatus$VideoMetadata$);
var $author$project$FileStatus$durationSerializeCodec = $author$project$Serialize$map$($ianmackenzie$elm_units$Duration$milliseconds, $ianmackenzie$elm_units$Duration$inMilliseconds, $author$project$Serialize$float);
var $lamdera$program_test$Effect$Time$millisToPosix = $elm$time$Time$millisToPosix;
var $lamdera$program_test$Effect$Time$posixToMillis = $elm$time$Time$posixToMillis;
var $author$project$FileStatus$posixSerializeCodec = $author$project$Serialize$map$($lamdera$program_test$Effect$Time$millisToPosix, $lamdera$program_test$Effect$Time$posixToMillis, $author$project$Serialize$int);
var $author$project$FileStatus$videoMetadataSerializeCodec = $author$project$Serialize$finishRecord(
	$author$project$Serialize$field$(
		function ($) {
			return $.duration;
		},
		$author$project$Serialize$maybe($author$project$FileStatus$durationSerializeCodec),
		$author$project$Serialize$field$(
			function ($) {
				return $.gpsLocation;
			},
			$author$project$Serialize$maybe($author$project$FileStatus$locationSerializeCodec),
			$author$project$Serialize$field$(
				function ($) {
					return $.title;
				},
				$author$project$Serialize$maybe($author$project$Serialize$string),
				$author$project$Serialize$field$(
					function ($) {
						return $.codec;
					},
					$author$project$Serialize$maybe($author$project$Serialize$string),
					$author$project$Serialize$field$(
						function ($) {
							return $.orientation;
						},
						$author$project$FileStatus$orientationSerializeCodec,
						$author$project$Serialize$field$(
							function ($) {
								return $.createdAt;
							},
							$author$project$Serialize$maybe($author$project$FileStatus$posixSerializeCodec),
							$author$project$Serialize$field$(
								function ($) {
									return $.videoSize;
								},
								$author$project$FileStatus$coordSerializeCodec,
								$author$project$Serialize$record($author$project$FileStatus$VideoMetadata)))))))));
var $author$project$FileStatus$fileMetadataSerializeCodec = $author$project$Serialize$finishCustomType(
	A3(
		$author$project$Serialize$variant1,
		$author$project$FileStatus$FileMetadata_Video,
		$author$project$FileStatus$videoMetadataSerializeCodec,
		A3(
			$author$project$Serialize$variant1,
			$author$project$FileStatus$FileMetadata_Image,
			$author$project$FileStatus$imageMetadataSerializeCodec,
			$author$project$Serialize$customType(
				F3(
					function (imageEncoder, videoEncoder, value) {
						if (!value.$) {
							var argA = value.a;
							return imageEncoder(argA);
						} else {
							var argA = value.a;
							return videoEncoder(argA);
						}
					})))));
var $author$project$FileStatus$IsEncrypted$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$FileStatus$IsEncrypted = F2($author$project$FileStatus$IsEncrypted$);
var $author$project$FileStatus$IsNotEncrypted = {$: 0};
var $author$project$FileStatus$AesPrivateKey = $elm$core$Basics$identity;
var $elm$bytes$Bytes$Decode$bytes = function (n) {
	return _Bytes_read_bytes(n);
};
var $elm$bytes$Bytes$Encode$Bytes = function (a) {
	return {$: 10, a: a};
};
var $elm$bytes$Bytes$Encode$bytes = $elm$bytes$Bytes$Encode$Bytes;
var $author$project$Serialize$bytes = $author$project$Serialize$build$(
	function (bytes_) {
		return $elm$bytes$Bytes$Encode$sequence(
			_List_fromArray(
				[
					A2(
					$elm$bytes$Bytes$Encode$unsignedInt32,
					$author$project$Serialize$endian,
					$elm$bytes$Bytes$width(bytes_)),
					$elm$bytes$Bytes$Encode$bytes(bytes_)
				]));
	},
	$elm$bytes$Bytes$Decode$andThen$(
		function (length) {
			return $elm$bytes$Bytes$Decode$map$(
				$elm$core$Result$Ok,
				$elm$bytes$Bytes$Decode$bytes(length));
		},
		$elm$bytes$Bytes$Decode$unsignedInt32($author$project$Serialize$endian)),
	A2($elm$core$Basics$composeR, $author$project$Serialize$replaceBase64Chars, $elm$json$Json$Encode$string),
	A2(
		$elm$json$Json$Decode$map,
		function (text) {
			var _v0 = $author$project$Serialize$decode(text);
			if (!_v0.$) {
				var bytes_ = _v0.a;
				return $elm$core$Result$Ok(bytes_);
			} else {
				return $elm$core$Result$Err($author$project$Serialize$DataCorrupted);
			}
		},
		$elm$json$Json$Decode$string));
var $author$project$FileStatus$aesPrivateKeySerializeCodec = $author$project$Serialize$map$(
	$elm$core$Basics$identity,
	function (_v0) {
		var a = _v0;
		return a;
	},
	$author$project$Serialize$bytes);
var $author$project$FileStatus$HasEncryptedThumbnail = 1;
var $author$project$FileStatus$NoEncryptedThumbnail = 0;
var $author$project$FileStatus$encryptedThumbnailSerializeCodec = $author$project$Serialize$finishCustomType(
	A2(
		$author$project$Serialize$variant0,
		1,
		A2(
			$author$project$Serialize$variant0,
			0,
			$author$project$Serialize$customType(
				F3(
					function (noThumbnailEncoder, hasThumbnailEncoder, value) {
						if (!value) {
							return noThumbnailEncoder;
						} else {
							return hasThumbnailEncoder;
						}
					})))));
var $author$project$FileStatus$isEncryptedSerializeCodec = $author$project$Serialize$finishCustomType(
	A4(
		$author$project$Serialize$variant2,
		$author$project$FileStatus$IsEncrypted,
		$author$project$FileStatus$aesPrivateKeySerializeCodec,
		$author$project$FileStatus$encryptedThumbnailSerializeCodec,
		A2(
			$author$project$Serialize$variant0,
			$author$project$FileStatus$IsNotEncrypted,
			$author$project$Serialize$customType(
				F3(
					function (isNotEncryptedEncoder, isEncryptedEncoder, value) {
						if (!value.$) {
							return isNotEncryptedEncoder;
						} else {
							var argA = value.a;
							var argB = value.b;
							return A2(isEncryptedEncoder, argA, argB);
						}
					})))));
var $author$project$FileStatus$fileDataSerializeCodec = $author$project$Serialize$finishRecord(
	$author$project$Serialize$field$(
		function ($) {
			return $.isEncrypted;
		},
		$author$project$FileStatus$isEncryptedSerializeCodec,
		$author$project$Serialize$field$(
			function ($) {
				return $.fileHash;
			},
			$author$project$FileStatus$fileHashSerializeCodec,
			$author$project$Serialize$field$(
				function ($) {
					return $.contentType;
				},
				$author$project$FileStatus$contentTypeSerializeCodec,
				$author$project$Serialize$field$(
					function ($) {
						return $.metadata;
					},
					$author$project$Serialize$maybe($author$project$FileStatus$fileMetadataSerializeCodec),
					$author$project$Serialize$field$(
						function ($) {
							return $.fileSize;
						},
						$author$project$Serialize$unsignedInt32,
						$author$project$Serialize$field$(
							function ($) {
								return $.fileName;
							},
							$author$project$FileName$codec,
							$author$project$Serialize$record($author$project$FileStatus$FileData))))))));
var $author$project$Message$nonemptyCodec = function (a) {
	return $author$project$Serialize$finishCustomType(
		A4(
			$author$project$Serialize$variant2,
			$mgold$elm_nonempty_list$List$Nonempty$Nonempty,
			a,
			$author$project$Serialize$list(a),
			$author$project$Serialize$customType(
				F2(
					function (nonemptyEncoder, value) {
						var argA = value.a;
						var argB = value.b;
						return A2(nonemptyEncoder, argA, argB);
					}))));
};
var $lamdera$containers$SeqDict$Collision$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $lamdera$containers$SeqDict$Collision = F2($lamdera$containers$SeqDict$Collision$);
var $lamdera$containers$SeqDict$Leaf$ = function (a, b, c, d) {
	return {$: 0, a: a, b: b, c: c, d: d};
};
var $lamdera$containers$SeqDict$Leaf = F4($lamdera$containers$SeqDict$Leaf$);
var $lamdera$containers$SeqDict$SubTree$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $lamdera$containers$SeqDict$SubTree = F2($lamdera$containers$SeqDict$SubTree$);
var $elm$core$Elm$JsArray$push = _JsArray_push;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$singleton = _JsArray_singleton;
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$insertTailInTree$ = function (shift, index, tail, tree) {
	var pos = $elm$core$Array$bitMask & (index >>> shift);
	if (_Utils_cmp(
		pos,
		$elm$core$Elm$JsArray$length(tree)) > -1) {
		if (shift === 5) {
			return A2(
				$elm$core$Elm$JsArray$push,
				$elm$core$Array$Leaf(tail),
				tree);
		} else {
			var newSub = $elm$core$Array$SubTree(
				$elm$core$Array$insertTailInTree$(shift - $elm$core$Array$shiftStep, index, tail, $elm$core$Elm$JsArray$empty));
			return A2($elm$core$Elm$JsArray$push, newSub, tree);
		}
	} else {
		var value = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!value.$) {
			var subTree = value.a;
			var newSub = $elm$core$Array$SubTree(
				$elm$core$Array$insertTailInTree$(shift - $elm$core$Array$shiftStep, index, tail, subTree));
			return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
		} else {
			var newSub = $elm$core$Array$SubTree(
				$elm$core$Array$insertTailInTree$(
					shift - $elm$core$Array$shiftStep,
					index,
					tail,
					$elm$core$Elm$JsArray$singleton(value)));
			return A3($elm$core$Elm$JsArray$unsafeSet, pos, newSub, tree);
		}
	}
};
var $elm$core$Array$insertTailInTree = F4($elm$core$Array$insertTailInTree$);
var $elm$core$Array$unsafeReplaceTail$ = function (newTail, _v0) {
	var len = _v0.a;
	var startShift = _v0.b;
	var tree = _v0.c;
	var tail = _v0.d;
	var originalTailLen = $elm$core$Elm$JsArray$length(tail);
	var newTailLen = $elm$core$Elm$JsArray$length(newTail);
	var newArrayLen = len + (newTailLen - originalTailLen);
	if (_Utils_eq(newTailLen, $elm$core$Array$branchFactor)) {
		var overflow = _Utils_cmp(newArrayLen >>> $elm$core$Array$shiftStep, 1 << startShift) > 0;
		if (overflow) {
			var newShift = startShift + $elm$core$Array$shiftStep;
			var newTree = $elm$core$Array$insertTailInTree$(
				newShift,
				len,
				newTail,
				$elm$core$Elm$JsArray$singleton(
					$elm$core$Array$SubTree(tree)));
			return $elm$core$Array$Array_elm_builtin$(newArrayLen, newShift, newTree, $elm$core$Elm$JsArray$empty);
		} else {
			return $elm$core$Array$Array_elm_builtin$(
				newArrayLen,
				startShift,
				$elm$core$Array$insertTailInTree$(startShift, len, newTail, tree),
				$elm$core$Elm$JsArray$empty);
		}
	} else {
		return $elm$core$Array$Array_elm_builtin$(newArrayLen, startShift, tree, newTail);
	}
};
var $elm$core$Array$unsafeReplaceTail = F2($elm$core$Array$unsafeReplaceTail$);
var $elm$core$Array$push$ = function (a, array) {
	var tail = array.d;
	return $elm$core$Array$unsafeReplaceTail$(
		A2($elm$core$Elm$JsArray$push, a, tail),
		array);
};
var $elm$core$Array$push = F2($elm$core$Array$push$);
var $lamdera$containers$SeqDict$intDictPush$ = function (hash, key, value, dict) {
	return {
		array: $elm$core$Array$push$(
			$elm$core$Maybe$Just(
				_Utils_Tuple3(hash, key, value)),
			dict.array),
		size: dict.size + 1
	};
};
var $lamdera$containers$SeqDict$intDictPush = F4($lamdera$containers$SeqDict$intDictPush$);
var $elm$core$Array$setHelp$ = function (shift, index, value, tree) {
	var pos = $elm$core$Array$bitMask & (index >>> shift);
	var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
	if (!_v0.$) {
		var subTree = _v0.a;
		var newSub = $elm$core$Array$setHelp$(shift - $elm$core$Array$shiftStep, index, value, subTree);
		return A3(
			$elm$core$Elm$JsArray$unsafeSet,
			pos,
			$elm$core$Array$SubTree(newSub),
			tree);
	} else {
		var values = _v0.a;
		var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
		return A3(
			$elm$core$Elm$JsArray$unsafeSet,
			pos,
			$elm$core$Array$Leaf(newLeaf),
			tree);
	}
};
var $elm$core$Array$setHelp = F4($elm$core$Array$setHelp$);
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$set$ = function (index, value, array) {
	var len = array.a;
	var startShift = array.b;
	var tree = array.c;
	var tail = array.d;
	return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
		index,
		$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Array$Array_elm_builtin$(
		len,
		startShift,
		tree,
		A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : $elm$core$Array$Array_elm_builtin$(
		len,
		startShift,
		$elm$core$Array$setHelp$(startShift, index, value, tree),
		tail));
};
var $elm$core$Array$set = F3($elm$core$Array$set$);
var $lamdera$containers$SeqDict$intDictSet$ = function (index, hash, key, value, dict) {
	return {
		array: $elm$core$Array$set$(
			index,
			$elm$core$Maybe$Just(
				_Utils_Tuple3(hash, key, value)),
			dict.array),
		size: dict.size
	};
};
var $lamdera$containers$SeqDict$intDictSet = F5($lamdera$containers$SeqDict$intDictSet$);
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $elm$core$Basics$not = _Basics_not;
var $lamdera$containers$JsArray2$singleton = _JsArray2_singleton;
var $lamdera$containers$JsArray2$unsafeInsert = _JsArray2_unsafeInsert;
var $lamdera$containers$JsArray2$unsafeSet = _JsArray2_unsafeSet;
var $lamdera$containers$SeqDict$insertHelp$ = function (shift, hash, key, value, bitmap, nodes, triplets) {
	var uncompressedIdx = $lamdera$containers$SeqDict$bitMask & (hash >>> shift);
	var newShift = shift + $lamdera$containers$SeqDict$shiftStep;
	var mask = 1 << uncompressedIdx;
	var hasValue = _Utils_eq(bitmap & mask, mask);
	var comIdx = $lamdera$containers$SeqDict$compressedIndex$(uncompressedIdx, bitmap);
	if (hasValue) {
		var _v0 = A2($lamdera$containers$JsArray2$unsafeGet, comIdx, nodes);
		switch (_v0.$) {
			case 0:
				var node = _v0;
				var xHash = node.a;
				var xIdx = node.b;
				var xKey = node.c;
				var xVal = node.d;
				if (_Utils_eq(xHash, hash)) {
					if (_Utils_eq(xKey, key)) {
						return $lamdera$containers$SeqDict$SeqDict_elm_builtin$(
							bitmap,
							A3(
								$lamdera$containers$JsArray2$unsafeSet,
								comIdx,
								$lamdera$containers$SeqDict$Leaf$(xHash, xIdx, xKey, value),
								nodes),
							$lamdera$containers$SeqDict$intDictSet$(xIdx, hash, key, value, triplets));
					} else {
						var element = $lamdera$containers$SeqDict$Collision$(
							hash,
							_List_fromArray(
								[
									_Utils_Tuple3(
									$elm$core$Array$length(triplets.array),
									key,
									value),
									_Utils_Tuple3(xIdx, xKey, xVal)
								]));
						return $lamdera$containers$SeqDict$SeqDict_elm_builtin$(
							bitmap,
							A3($lamdera$containers$JsArray2$unsafeSet, comIdx, element, nodes),
							$lamdera$containers$SeqDict$intDictPush$(hash, key, value, triplets));
					}
				} else {
					var subIdx = $lamdera$containers$SeqDict$bitMask & (xHash >>> newShift);
					var _v1 = $lamdera$containers$SeqDict$insertHelp$(
						newShift,
						hash,
						key,
						value,
						1 << subIdx,
						$lamdera$containers$JsArray2$singleton(node),
						triplets);
					var secondBitmap = _v1.a;
					var secondNodes = _v1.b;
					var newTriplets = _v1.c;
					var subTree = $lamdera$containers$SeqDict$SubTree$(secondBitmap, secondNodes);
					return $lamdera$containers$SeqDict$SeqDict_elm_builtin$(
						bitmap,
						A3($lamdera$containers$JsArray2$unsafeSet, comIdx, subTree, nodes),
						newTriplets);
				}
			case 1:
				var subBitmap = _v0.a;
				var subNodes = _v0.b;
				var _v2 = $lamdera$containers$SeqDict$insertHelp$(newShift, hash, key, value, subBitmap, subNodes, triplets);
				var newSubBitmap = _v2.a;
				var newSubNodes = _v2.b;
				var newTriplets = _v2.c;
				var newSub = $lamdera$containers$SeqDict$SubTree$(newSubBitmap, newSubNodes);
				return $lamdera$containers$SeqDict$SeqDict_elm_builtin$(
					bitmap,
					A3($lamdera$containers$JsArray2$unsafeSet, comIdx, newSub, nodes),
					newTriplets);
			default:
				var currValue = _v0;
				var xHash = currValue.a;
				var pairs = currValue.b;
				if (_Utils_eq(xHash, hash)) {
					var keyFinder = function (_v5) {
						var k = _v5.b;
						return _Utils_eq(k, key);
					};
					var _v3 = $lamdera$containers$SeqDict$listFind$(keyFinder, pairs);
					if (!_v3.$) {
						var _v4 = _v3.a;
						var existingIdx = _v4.a;
						var whenRemoved = $elm$core$List$filter$(
							function (pair) {
								return !keyFinder(pair);
							},
							pairs);
						var updated = A2(
							$elm$core$List$cons,
							_Utils_Tuple3(existingIdx, key, value),
							whenRemoved);
						return $lamdera$containers$SeqDict$SeqDict_elm_builtin$(
							bitmap,
							A3(
								$lamdera$containers$JsArray2$unsafeSet,
								comIdx,
								$lamdera$containers$SeqDict$Collision$(xHash, updated),
								nodes),
							$lamdera$containers$SeqDict$intDictSet$(existingIdx, hash, key, value, triplets));
					} else {
						var updated = A2(
							$elm$core$List$cons,
							_Utils_Tuple3(
								$elm$core$Array$length(triplets.array),
								key,
								value),
							pairs);
						return $lamdera$containers$SeqDict$SeqDict_elm_builtin$(
							bitmap,
							A3(
								$lamdera$containers$JsArray2$unsafeSet,
								comIdx,
								$lamdera$containers$SeqDict$Collision$(xHash, updated),
								nodes),
							$lamdera$containers$SeqDict$intDictPush$(hash, key, value, triplets));
					}
				} else {
					var subIdx = $lamdera$containers$SeqDict$bitMask & (xHash >>> newShift);
					var _v6 = $lamdera$containers$SeqDict$insertHelp$(
						newShift,
						hash,
						key,
						value,
						1 << subIdx,
						$lamdera$containers$JsArray2$singleton(currValue),
						triplets);
					var secondBitmap = _v6.a;
					var secondNodes = _v6.b;
					var newTriplets = _v6.c;
					var subTree = $lamdera$containers$SeqDict$SubTree$(secondBitmap, secondNodes);
					return $lamdera$containers$SeqDict$SeqDict_elm_builtin$(
						bitmap,
						A3($lamdera$containers$JsArray2$unsafeSet, comIdx, subTree, nodes),
						newTriplets);
				}
		}
	} else {
		return $lamdera$containers$SeqDict$SeqDict_elm_builtin$(
			bitmap | mask,
			A3(
				$lamdera$containers$JsArray2$unsafeInsert,
				comIdx,
				$lamdera$containers$SeqDict$Leaf$(
					hash,
					$elm$core$Array$length(triplets.array),
					key,
					value),
				nodes),
			$lamdera$containers$SeqDict$intDictPush$(hash, key, value, triplets));
	}
};
var $lamdera$containers$SeqDict$insertHelp = F7($lamdera$containers$SeqDict$insertHelp$);
var $lamdera$containers$SeqDict$insert$ = function (key, value, _v0) {
	var bitmap = _v0.a;
	var nodes = _v0.b;
	var triplets = _v0.c;
	return $lamdera$containers$SeqDict$insertHelp$(
		0,
		$lamdera$containers$FNV$hash(key),
		key,
		value,
		bitmap,
		nodes,
		triplets);
};
var $lamdera$containers$SeqDict$insert = F3($lamdera$containers$SeqDict$insert$);
var $lamdera$containers$SeqDict$fromList = function (list) {
	return $elm$core$List$foldl$(
		F2(
			function (_v0, acc) {
				var key = _v0.a;
				var value = _v0.b;
				return $lamdera$containers$SeqDict$insert$(key, value, acc);
			}),
		$lamdera$containers$SeqDict$empty,
		list);
};
var $author$project$Message$seqDictCodec$ = function (keyCodec, valueCodec) {
	return $author$project$Serialize$map$(
		$lamdera$containers$SeqDict$fromList,
		$lamdera$containers$SeqDict$toList,
		$author$project$Serialize$list(
			$author$project$Serialize$tuple$(keyCodec, valueCodec)));
};
var $author$project$Message$seqDictCodec = F2($author$project$Message$seqDictCodec$);
var $author$project$Message$contentAndEmbedsCodec = $author$project$Serialize$finishRecord(
	$author$project$Serialize$field$(
		function ($) {
			return $.attachedFiles;
		},
		$author$project$Message$seqDictCodec$($author$project$Id$codec, $author$project$FileStatus$fileDataSerializeCodec),
		$author$project$Serialize$field$(
			function ($) {
				return $.embeds;
			},
			$author$project$Serialize$array($author$project$Message$embedCodec),
			$author$project$Serialize$field$(
				function ($) {
					return $.content;
				},
				$author$project$Message$nonemptyCodec(
					$author$project$RichText$codec$($author$project$Id$codec, $author$project$Id$codec)),
				$author$project$Serialize$record($author$project$Message$MessageContent)))));
var $author$project$Call$PolledDebugData = {$: 18};
var $lamdera$program_test$Effect$Time$every = $lamdera$program_test$Effect$Internal$TimeEvery;
var $lamdera$program_test$Effect$Subscription$none = $lamdera$program_test$Effect$Internal$SubNone;
var $author$project$Call$debugDataSubscription = function (model) {
	return model.pollDebugData ? A2(
		$lamdera$program_test$Effect$Time$every,
		$ianmackenzie$elm_units$Duration$milliseconds(500),
		function (_v0) {
			return $author$project$Call$PolledDebugData;
		}) : $lamdera$program_test$Effect$Subscription$none;
};
var $elm$core$Basics$clamp$ = function (low, high, number) {
	return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
};
var $elm$core$Basics$clamp = F3($elm$core$Basics$clamp$);
var $ianmackenzie$elm_units$Duration$from$ = function (startTime, endTime) {
	var numMilliseconds = $elm$time$Time$posixToMillis(endTime) - $elm$time$Time$posixToMillis(startTime);
	return $ianmackenzie$elm_units$Duration$milliseconds(numMilliseconds);
};
var $ianmackenzie$elm_units$Duration$from = F2($ianmackenzie$elm_units$Duration$from$);
var $author$project$FrontendExtra$fileDragOverlayOpacity$ = function (loggedIn, model) {
	var _v0 = loggedIn.fileDragOverCount;
	if (_v0.$ === 1) {
		var dragStart = _v0.a;
		return $elm$core$Basics$clamp$(
			0.01,
			1,
			10 * $ianmackenzie$elm_units$Duration$inSeconds(
				$ianmackenzie$elm_units$Duration$from$(dragStart, model.time)));
	} else {
		if (!_v0.a.$) {
			var lastDrag = _v0.a.a;
			return $elm$core$Basics$clamp$(
				0,
				1,
				1 - ($ianmackenzie$elm_units$Duration$inSeconds(
					$ianmackenzie$elm_units$Duration$from$(lastDrag, model.time)) * 10));
		} else {
			var _v1 = _v0.a;
			return 0;
		}
	}
};
var $author$project$FrontendExtra$fileDragOverlayOpacity = F2($author$project$FrontendExtra$fileDragOverlayOpacity$);
var $author$project$Range$SelectBackward = 1;
var $author$project$Range$SelectForward = 0;
var $lamdera$program_test$Effect$Browser$Dom$HtmlId = $elm$core$Basics$identity;
var $lamdera$program_test$Effect$Browser$Dom$id = $elm$core$Basics$identity;
var $author$project$Ports$decodeDomId = A2($elm$json$Json$Decode$map, $lamdera$program_test$Effect$Browser$Dom$id, $elm$json$Json$Decode$string);
var $elm$json$Json$Decode$map4 = _Json_map4;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $author$project$Ports$decodeHtmlIdAndSelection = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A5(
			$elm$json$Json$Decode$map4,
			F4(
				function (id, start, end, direction) {
					return _Utils_Tuple2(
						id,
						$elm$core$Maybe$Just(
							_Utils_Tuple2(
								{end: end, start: start},
								(direction === 'forward') ? 0 : 1)));
				}),
			A2(
				$elm$json$Json$Decode$field,
				'id',
				$elm$json$Json$Decode$nullable($author$project$Ports$decodeDomId)),
			A2($elm$json$Json$Decode$field, 'selectionStart', $elm$json$Json$Decode$int),
			A2($elm$json$Json$Decode$field, 'selectionEnd', $elm$json$Json$Decode$int),
			A2($elm$json$Json$Decode$field, 'selectionDirection', $elm$json$Json$Decode$string)),
			A2(
			$elm$json$Json$Decode$map,
			function (id) {
				return _Utils_Tuple2(id, $elm$core$Maybe$Nothing);
			},
			A2(
				$elm$json$Json$Decode$field,
				'id',
				$elm$json$Json$Decode$nullable($author$project$Ports$decodeDomId)))
		]));
var $author$project$Ports$focus_changed_from_js = _Platform_incomingPort('focus_changed_from_js', $elm$json$Json$Decode$value);
var $author$project$Ports$focusChanged = function (msg) {
	return $lamdera$program_test$Effect$Subscription$fromJs$(
		'focus_changed_from_js',
		$author$project$Ports$focus_changed_from_js,
		function (json) {
			return msg(
				$elm$core$Result$withDefault$(
					_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
					A2($elm$json$Json$Decode$decodeValue, $author$project$Ports$decodeHtmlIdAndSelection, json)));
		});
};
var $elm$core$Elm$JsArray$foldl = _JsArray_foldl;
var $elm$core$Array$foldl$ = function (func, baseCase, _v0) {
	var tree = _v0.c;
	var tail = _v0.d;
	var helper = F2(
		function (node, acc) {
			if (!node.$) {
				var subTree = node.a;
				return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
			} else {
				var values = node.a;
				return A3($elm$core$Elm$JsArray$foldl, func, acc, values);
			}
		});
	return A3(
		$elm$core$Elm$JsArray$foldl,
		func,
		A3($elm$core$Elm$JsArray$foldl, helper, baseCase, tree),
		tail);
};
var $elm$core$Array$foldl = F3($elm$core$Array$foldl$);
var $lamdera$containers$SeqDict$intDictFoldl$ = function (func, baseCase, dict) {
	return $elm$core$Array$foldl$(
		F2(
			function (maybe, acc) {
				if (!maybe.$) {
					var a = maybe.a;
					return A2(func, a, acc);
				} else {
					return acc;
				}
			}),
		baseCase,
		dict.array);
};
var $lamdera$containers$SeqDict$intDictFoldl = F3($lamdera$containers$SeqDict$intDictFoldl$);
var $lamdera$containers$SeqDict$foldl$ = function (fn, acc, _v0) {
	var triplets = _v0.c;
	var helper = F2(
		function (_v1, acc2) {
			var key = _v1.b;
			var value = _v1.c;
			return A3(fn, key, value, acc2);
		});
	return $lamdera$containers$SeqDict$intDictFoldl$(helper, acc, triplets);
};
var $lamdera$containers$SeqDict$foldl = F3($lamdera$containers$SeqDict$foldl$);
var $author$project$NonemptyDict$foldl$ = function (f, acc, _v0) {
	var k1 = _v0.a;
	var v1 = _v0.b;
	var dict = _v0.c;
	return $lamdera$containers$SeqDict$foldl$(
		f,
		A3(f, k1, v1, acc),
		dict);
};
var $author$project$NonemptyDict$foldl = F3($author$project$NonemptyDict$foldl$);
var $miniBill$elm_codec$Codec$decodeValue = function (codec) {
	return $elm$json$Json$Decode$decodeValue(
		$miniBill$elm_codec$Codec$decoder(codec));
};
var $elm$core$Debug$log = _Debug_log;
var $author$project$Call$FromJs_DebugData = function (a) {
	return {$: 4, a: a};
};
var $author$project$Call$FromJs_GotUserMediaDevices$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Call$FromJs_GotUserMediaDevices = F2($author$project$Call$FromJs_GotUserMediaDevices$);
var $author$project$Call$FromJs_GotUserMediaDevicesError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Call$FromJs_RecordingUploadProgress$ = function (a, b) {
	return {$: 7, a: a, b: b};
};
var $author$project$Call$FromJs_RecordingUploadProgress = F2($author$project$Call$FromJs_RecordingUploadProgress$);
var $author$project$Call$FromJs_RecordingUploadsStopped = {$: 8};
var $author$project$Call$FromJs_ScreenShareStarted = {$: 5};
var $author$project$Call$FromJs_ScreenShareStopped = {$: 6};
var $author$project$Call$FromJs_SpeakingChanged$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Call$FromJs_SpeakingChanged = F2($author$project$Call$FromJs_SpeakingChanged$);
var $author$project$Call$FromJs_StartConnectionError = function (a) {
	return {$: 3, a: a};
};
var $miniBill$elm_codec$Codec$bool = $miniBill$elm_codec$Codec$build$($elm$json$Json$Encode$bool, $elm$json$Json$Decode$bool);
var $miniBill$elm_codec$Codec$buildCustom = function (_v0) {
	var am = _v0;
	return {
		decoder: A2(
			$elm$json$Json$Decode$andThen,
			function (tag) {
				var _v1 = $elm$core$Dict$get$(tag, am.decoder);
				if (_v1.$ === 1) {
					return $elm$json$Json$Decode$fail('tag ' + (tag + ' did not match'));
				} else {
					var dec = _v1.a;
					return A2($elm$json$Json$Decode$field, 'args', dec);
				}
			},
			A2($elm$json$Json$Decode$field, 'tag', $elm$json$Json$Decode$string)),
		encoder: function (v) {
			return am.match(v);
		}
	};
};
var $author$project$IdString$IdString = $elm$core$Basics$identity;
var $author$project$IdString$fromString = $elm$core$Basics$identity;
var $miniBill$elm_codec$Codec$map$ = function (go, back, codec) {
	return {
		decoder: A2(
			$elm$json$Json$Decode$map,
			go,
			$miniBill$elm_codec$Codec$decoder(codec)),
		encoder: function (v) {
			return A2(
				$miniBill$elm_codec$Codec$encoder,
				codec,
				back(v));
		}
	};
};
var $miniBill$elm_codec$Codec$map = F3($miniBill$elm_codec$Codec$map$);
var $author$project$IdString$toString = function (_v0) {
	var a = _v0;
	return a;
};
var $author$project$IdString$codec = $miniBill$elm_codec$Codec$map$($author$project$IdString$fromString, $author$project$IdString$toString, $miniBill$elm_codec$Codec$string);
var $miniBill$elm_codec$Codec$CustomCodec = $elm$core$Basics$identity;
var $miniBill$elm_codec$Codec$custom = function (match) {
	return {decoder: $elm$core$Dict$empty, match: match};
};
var $author$project$Call$DebugSection$ = function (title, rows) {
	return {rows: rows, title: title};
};
var $author$project$Call$DebugSection = F2($author$project$Call$DebugSection$);
var $author$project$Call$DebugRow$ = function (label, value) {
	return {label: label, value: value};
};
var $author$project$Call$DebugRow = F2($author$project$Call$DebugRow$);
var $author$project$Call$debugRowCodec = $miniBill$elm_codec$Codec$buildObject(
	$miniBill$elm_codec$Codec$field$(
		'value',
		function ($) {
			return $.value;
		},
		$miniBill$elm_codec$Codec$string,
		$miniBill$elm_codec$Codec$field$(
			'label',
			function ($) {
				return $.label;
			},
			$miniBill$elm_codec$Codec$string,
			$miniBill$elm_codec$Codec$object($author$project$Call$DebugRow))));
var $miniBill$elm_codec$Codec$composite$ = function (enc, dec, _v0) {
	var codec = _v0;
	return {
		decoder: dec(codec.decoder),
		encoder: enc(codec.encoder)
	};
};
var $miniBill$elm_codec$Codec$composite = F3($miniBill$elm_codec$Codec$composite$);
var $miniBill$elm_codec$Codec$list = A2($miniBill$elm_codec$Codec$composite, $elm$json$Json$Encode$list, $elm$json$Json$Decode$list);
var $author$project$Call$debugSectionCodec = $miniBill$elm_codec$Codec$buildObject(
	$miniBill$elm_codec$Codec$field$(
		'rows',
		function ($) {
			return $.rows;
		},
		$miniBill$elm_codec$Codec$list($author$project$Call$debugRowCodec),
		$miniBill$elm_codec$Codec$field$(
			'title',
			function ($) {
				return $.title;
			},
			$miniBill$elm_codec$Codec$string,
			$miniBill$elm_codec$Codec$object($author$project$Call$DebugSection))));
var $miniBill$elm_codec$Codec$int = $miniBill$elm_codec$Codec$build$($elm$json$Json$Encode$int, $elm$json$Json$Decode$int);
var $author$project$Call$IsConnection = function (a) {
	return {$: 1, a: a};
};
var $author$project$Call$IsLocal = {$: 0};
var $author$project$Call$ConnectionId$ = function (roomId, otherClientId) {
	return {otherClientId: otherClientId, roomId: roomId};
};
var $author$project$Call$ConnectionId = F2($author$project$Call$ConnectionId$);
var $lamdera$program_test$Effect$Lamdera$ClientId = $elm$core$Basics$identity;
var $lamdera$program_test$Effect$Lamdera$clientIdFromString = $elm$core$Basics$identity;
var $author$project$Call$connectionIdFromString = function (text) {
	var _v0 = $elm$core$String$split$(' ', text);
	if (_v0.b && _v0.b.b) {
		var second = _v0.a;
		var _v1 = _v0.b;
		var rest0 = _v1.a;
		var rest = _v1.b;
		var _v2 = $elm$core$String$toInt(second);
		if (!_v2.$) {
			var userId = _v2.a;
			return $elm$core$Result$Ok(
				_Utils_Tuple2(
					$author$project$Id$fromInt(userId),
					$lamdera$program_test$Effect$Lamdera$clientIdFromString(
						$elm$core$String$join$(
							' ',
							A2($elm$core$List$cons, rest0, rest)))));
		} else {
			return $elm$core$Result$Err(0);
		}
	} else {
		return $elm$core$Result$Err(0);
	}
};
var $lamdera$program_test$Effect$Lamdera$clientIdToString = function (_v0) {
	var clientId = _v0;
	return clientId;
};
var $author$project$Call$otherUserIdToString = function (otherClientId) {
	return $author$project$Id$toString(otherClientId.a) + (' ' + $lamdera$program_test$Effect$Lamdera$clientIdToString(otherClientId.b));
};
var $author$project$Call$otherClientIdCodec = $miniBill$elm_codec$Codec$andThen$(
	function (text) {
		var _v0 = $author$project$Call$connectionIdFromString(text);
		if (!_v0.$) {
			var id = _v0.a;
			return $miniBill$elm_codec$Codec$succeed(id);
		} else {
			return $miniBill$elm_codec$Codec$fail('Invalid roomId: ' + text);
		}
	},
	$author$project$Call$otherUserIdToString,
	$miniBill$elm_codec$Codec$string);
var $author$project$Call$DmRoomId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Call$GuildRoomId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Call$roomIdCodec = $miniBill$elm_codec$Codec$andThen$(
	function (text) {
		var _v0 = $elm$core$String$split$('-', text);
		if ((((_v0.b && (_v0.a === 'guild')) && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
			var _v1 = _v0.b;
			var guildId = _v1.a;
			var _v2 = _v1.b;
			var channelId = _v2.a;
			var _v3 = _Utils_Tuple2(
				$author$project$Id$fromString(guildId),
				$author$project$Id$fromString(channelId));
			if ((!_v3.a.$) && (!_v3.b.$)) {
				var guildId2 = _v3.a.a;
				var channelId2 = _v3.b.a;
				return $miniBill$elm_codec$Codec$succeed(
					$author$project$Call$GuildRoomId(
						{channelId: channelId2, guildId: guildId2}));
			} else {
				return $miniBill$elm_codec$Codec$fail('Invalid roomId: ' + text);
			}
		} else {
			var _v4 = $author$project$Id$fromString(text);
			if (!_v4.$) {
				var id = _v4.a;
				return $miniBill$elm_codec$Codec$succeed(
					$author$project$Call$DmRoomId(
						{otherUserId: id}));
			} else {
				return $miniBill$elm_codec$Codec$fail('Invalid roomId: ' + text);
			}
		}
	},
	function (roomId) {
		if (!roomId.$) {
			var otherUserId = roomId.a.otherUserId;
			return $author$project$Id$toString(otherUserId);
		} else {
			var channelId = roomId.a.channelId;
			var guildId = roomId.a.guildId;
			return 'guild-' + ($author$project$Id$toString(guildId) + ('-' + $author$project$Id$toString(channelId)));
		}
	},
	$miniBill$elm_codec$Codec$string);
var $author$project$Call$connectionIdCodec = $miniBill$elm_codec$Codec$buildObject(
	$miniBill$elm_codec$Codec$field$(
		'otherClientId',
		function ($) {
			return $.otherClientId;
		},
		$author$project$Call$otherClientIdCodec,
		$miniBill$elm_codec$Codec$field$(
			'roomId',
			function ($) {
				return $.roomId;
			},
			$author$project$Call$roomIdCodec,
			$miniBill$elm_codec$Codec$object($author$project$Call$ConnectionId))));
var $author$project$Call$localVideoNodeId = 'local-video';
var $miniBill$elm_codec$Codec$variant$ = function (name, matchPiece, decoderPiece, _v0) {
	var am = _v0;
	var enc = function (v) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'tag',
					$elm$json$Json$Encode$string(name)),
					_Utils_Tuple2(
					'args',
					$elm$json$Json$Encode$list$($elm$core$Basics$identity, v))
				]));
	};
	return {
		decoder: $elm$core$Dict$insert$(name, decoderPiece, am.decoder),
		match: am.match(
			matchPiece(enc))
	};
};
var $miniBill$elm_codec$Codec$variant = F4($miniBill$elm_codec$Codec$variant$);
var $miniBill$elm_codec$Codec$variant0$ = function (name, ctor) {
	return A3(
		$miniBill$elm_codec$Codec$variant,
		name,
		function (c) {
			return c(_List_Nil);
		},
		$elm$json$Json$Decode$succeed(ctor));
};
var $miniBill$elm_codec$Codec$variant0 = F2($miniBill$elm_codec$Codec$variant0$);
var $miniBill$elm_codec$Codec$variant1$ = function (name, ctor, m1) {
	return A3(
		$miniBill$elm_codec$Codec$variant,
		name,
		F2(
			function (c, v) {
				return c(
					_List_fromArray(
						[
							A2($miniBill$elm_codec$Codec$encoder, m1, v)
						]));
			}),
		A2(
			$elm$json$Json$Decode$map,
			ctor,
			A2(
				$elm$json$Json$Decode$index,
				0,
				$miniBill$elm_codec$Codec$decoder(m1))));
};
var $miniBill$elm_codec$Codec$variant1 = F3($miniBill$elm_codec$Codec$variant1$);
var $author$project$Call$localOrConnectionCodec = $miniBill$elm_codec$Codec$buildCustom(
	A4(
		$miniBill$elm_codec$Codec$variant1,
		'is-connection',
		$author$project$Call$IsConnection,
		$author$project$Call$connectionIdCodec,
		A3(
			$miniBill$elm_codec$Codec$variant0,
			$author$project$Call$localVideoNodeId,
			$author$project$Call$IsLocal,
			$miniBill$elm_codec$Codec$custom(
				F3(
					function (aEncoder, bEncoder, value) {
						if (!value.$) {
							return aEncoder;
						} else {
							var a = value.a;
							return bEncoder(a);
						}
					})))));
var $author$project$Call$MediaDevice$ = function (deviceId, groupId, kind, label) {
	return {deviceId: deviceId, groupId: groupId, kind: kind, label: label};
};
var $author$project$Call$MediaDevice = F4($author$project$Call$MediaDevice$);
var $author$project$Call$AudioInput = 0;
var $author$project$Call$AudioOutput = 2;
var $author$project$Call$VideoInput = 1;
var $miniBill$elm_codec$Codec$enum$ = function (_v0, options) {
	var codec = _v0;
	var enc = F2(
		function (queue, val) {
			enc:
			while (true) {
				if (!queue.b) {
					return $elm$json$Json$Encode$null;
				} else {
					var _v2 = queue.a;
					var k = _v2.a;
					var v = _v2.b;
					var tail = queue.b;
					if (_Utils_eq(v, val)) {
						return codec.encoder(k);
					} else {
						var $temp$queue = tail;
						queue = $temp$queue;
						continue enc;
					}
				}
			}
		});
	var dec = F2(
		function (queue, key) {
			dec:
			while (true) {
				if (!queue.b) {
					return $elm$json$Json$Decode$fail('Key not found');
				} else {
					var _v4 = queue.a;
					var k = _v4.a;
					var v = _v4.b;
					var tail = queue.b;
					if (_Utils_eq(k, key)) {
						return $elm$json$Json$Decode$succeed(v);
					} else {
						var $temp$queue = tail;
						queue = $temp$queue;
						continue dec;
					}
				}
			}
		});
	return {
		decoder: A2(
			$elm$json$Json$Decode$andThen,
			function (k) {
				return A2(dec, options, k);
			},
			codec.decoder),
		encoder: enc(options)
	};
};
var $miniBill$elm_codec$Codec$enum = F2($miniBill$elm_codec$Codec$enum$);
var $author$project$Call$deviceKindCodec = $miniBill$elm_codec$Codec$enum$(
	$miniBill$elm_codec$Codec$string,
	_List_fromArray(
		[
			_Utils_Tuple2('audioinput', 0),
			_Utils_Tuple2('audiooutput', 2),
			_Utils_Tuple2('videoinput', 1)
		]));
var $author$project$Call$mediaDevicesCodec = $miniBill$elm_codec$Codec$buildObject(
	$miniBill$elm_codec$Codec$field$(
		'label',
		function ($) {
			return $.label;
		},
		$miniBill$elm_codec$Codec$string,
		$miniBill$elm_codec$Codec$field$(
			'kind',
			function ($) {
				return $.kind;
			},
			$author$project$Call$deviceKindCodec,
			$miniBill$elm_codec$Codec$field$(
				'groupId',
				function ($) {
					return $.groupId;
				},
				$miniBill$elm_codec$Codec$string,
				$miniBill$elm_codec$Codec$field$(
					'deviceId',
					function ($) {
						return $.deviceId;
					},
					$author$project$IdString$codec,
					$miniBill$elm_codec$Codec$object($author$project$Call$MediaDevice))))));
var $miniBill$elm_codec$Codec$variant2$ = function (name, ctor, m1, m2) {
	return A3(
		$miniBill$elm_codec$Codec$variant,
		name,
		F3(
			function (c, v1, v2) {
				return c(
					_List_fromArray(
						[
							A2($miniBill$elm_codec$Codec$encoder, m1, v1),
							A2($miniBill$elm_codec$Codec$encoder, m2, v2)
						]));
			}),
		A3(
			$elm$json$Json$Decode$map2,
			ctor,
			A2(
				$elm$json$Json$Decode$index,
				0,
				$miniBill$elm_codec$Codec$decoder(m1)),
			A2(
				$elm$json$Json$Decode$index,
				1,
				$miniBill$elm_codec$Codec$decoder(m2))));
};
var $miniBill$elm_codec$Codec$variant2 = F4($miniBill$elm_codec$Codec$variant2$);
var $author$project$Call$voiceChatFromJsCodec = $miniBill$elm_codec$Codec$buildCustom(
	A3(
		$miniBill$elm_codec$Codec$variant0,
		'recording-uploads-stopped',
		$author$project$Call$FromJs_RecordingUploadsStopped,
		A5(
			$miniBill$elm_codec$Codec$variant2,
			'recording-upload-progress',
			$author$project$Call$FromJs_RecordingUploadProgress,
			$miniBill$elm_codec$Codec$int,
			$miniBill$elm_codec$Codec$int,
			A3(
				$miniBill$elm_codec$Codec$variant0,
				'screen-share-stopped',
				$author$project$Call$FromJs_ScreenShareStopped,
				A3(
					$miniBill$elm_codec$Codec$variant0,
					'screen-share-started',
					$author$project$Call$FromJs_ScreenShareStarted,
					A4(
						$miniBill$elm_codec$Codec$variant1,
						'debug-data',
						$author$project$Call$FromJs_DebugData,
						$miniBill$elm_codec$Codec$list($author$project$Call$debugSectionCodec),
						A4(
							$miniBill$elm_codec$Codec$variant1,
							'start-connection-error',
							$author$project$Call$FromJs_StartConnectionError,
							$miniBill$elm_codec$Codec$string,
							A5(
								$miniBill$elm_codec$Codec$variant2,
								'is-speaking-changed',
								$author$project$Call$FromJs_SpeakingChanged,
								$author$project$Call$localOrConnectionCodec,
								$miniBill$elm_codec$Codec$bool,
								A4(
									$miniBill$elm_codec$Codec$variant1,
									'got-media-devices-error',
									$author$project$Call$FromJs_GotUserMediaDevicesError,
									$miniBill$elm_codec$Codec$string,
									A5(
										$miniBill$elm_codec$Codec$variant2,
										'got-media-devices',
										$author$project$Call$FromJs_GotUserMediaDevices,
										$miniBill$elm_codec$Codec$list($author$project$Call$mediaDevicesCodec),
										$miniBill$elm_codec$Codec$list($author$project$IdString$codec),
										$miniBill$elm_codec$Codec$custom(
											function (cEncoder) {
												return function (dEncoder) {
													return function (eEncoder) {
														return function (fEncoder) {
															return function (gEncoder) {
																return function (hEncoder) {
																	return function (iEncoder) {
																		return function (jEncoder) {
																			return function (kEncoder) {
																				return function (value) {
																					switch (value.$) {
																						case 0:
																							var a = value.a;
																							var b = value.b;
																							return A2(cEncoder, a, b);
																						case 1:
																							var string = value.a;
																							return dEncoder(string);
																						case 2:
																							var a = value.a;
																							var b = value.b;
																							return A2(eEncoder, a, b);
																						case 3:
																							var string = value.a;
																							return fEncoder(string);
																						case 4:
																							var a = value.a;
																							return gEncoder(a);
																						case 5:
																							return hEncoder;
																						case 6:
																							return iEncoder;
																						case 7:
																							var uploaded = value.a;
																							var total = value.b;
																							return A2(jEncoder, uploaded, total);
																						default:
																							return kEncoder;
																					}
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											})))))))))));
var $author$project$Call$voice_chat_from_js = _Platform_incomingPort('voice_chat_from_js', $elm$json$Json$Decode$value);
var $author$project$Call$fromJs = function (msg) {
	return $lamdera$program_test$Effect$Subscription$fromJs$(
		'voice_chat_from_js',
		$author$project$Call$voice_chat_from_js,
		function (json) {
			return msg(
				$elm$core$Result$mapError$(
					function (error) {
						var _v0 = A2(
							$elm$core$Debug$log,
							'voice_chat_from_js error',
							A2($elm$json$Json$Encode$encode, 0, json));
						return $elm$json$Json$Decode$errorToString(error);
					},
					A2($miniBill$elm_codec$Codec$decodeValue, $author$project$Call$voiceChatFromJsCodec, json)));
		});
};
var $lamdera$codecs$Lamdera$Wire3$decodeBytes_ = _LamderaCodecs_decodeBytes;
var $author$project$Encryption$encryption_from_js = _Platform_incomingPort('encryption_from_js', $lamdera$codecs$Lamdera$Wire3$decodeBytes_);
var $lamdera$program_test$Effect$Subscription$fromJsBytes$ = function (portName, portFunction, msg) {
	return $lamdera$program_test$Effect$Internal$SubPortBytes$(
		portName,
		portFunction(msg),
		msg);
};
var $lamdera$program_test$Effect$Subscription$fromJsBytes = F3($lamdera$program_test$Effect$Subscription$fromJsBytes$);
var $author$project$Encryption$FromJs_FileEncryptFailed$ = function (a, b) {
	return {$: 10, a: a, b: b};
};
var $author$project$Encryption$FromJs_FileEncryptFailed = F2($author$project$Encryption$FromJs_FileEncryptFailed$);
var $author$project$Encryption$FromJs_FileEncrypted$ = function (a, b) {
	return {$: 9, a: a, b: b};
};
var $author$project$Encryption$FromJs_FileEncrypted = F2($author$project$Encryption$FromJs_FileEncrypted$);
var $author$project$Encryption$FromJs_ManyMessagesDecrypted$ = function (a, b) {
	return {$: 6, a: a, b: b};
};
var $author$project$Encryption$FromJs_ManyMessagesDecrypted = F2($author$project$Encryption$FromJs_ManyMessagesDecrypted$);
var $author$project$Encryption$FromJs_ManyMessagesEncryptFailed$ = function (a, b) {
	return {$: 8, a: a, b: b};
};
var $author$project$Encryption$FromJs_ManyMessagesEncryptFailed = F2($author$project$Encryption$FromJs_ManyMessagesEncryptFailed$);
var $author$project$Encryption$FromJs_ManyMessagesEncrypted$ = function (a, b) {
	return {$: 7, a: a, b: b};
};
var $author$project$Encryption$FromJs_ManyMessagesEncrypted = F2($author$project$Encryption$FromJs_ManyMessagesEncrypted$);
var $author$project$Encryption$FromJs_NewMessageDecryptFailed = function (a) {
	return {$: 5, a: a};
};
var $author$project$Encryption$FromJs_NewMessageDecrypted$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $author$project$Encryption$FromJs_NewMessageDecrypted = F2($author$project$Encryption$FromJs_NewMessageDecrypted$);
var $author$project$Encryption$FromJs_NewMessageEncryptFailed$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Encryption$FromJs_NewMessageEncryptFailed = F2($author$project$Encryption$FromJs_NewMessageEncryptFailed$);
var $author$project$Encryption$FromJs_NewMessageEncrypted$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Encryption$FromJs_NewMessageEncrypted = F2($author$project$Encryption$FromJs_NewMessageEncrypted$);
var $author$project$Encryption$FromJs_SharedSecretFailed$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Encryption$FromJs_SharedSecretFailed = F2($author$project$Encryption$FromJs_SharedSecretFailed$);
var $author$project$Encryption$FromJs_SharedSecretStored = function (a) {
	return {$: 0, a: a};
};
var $author$project$Encryption$EncryptedData = $elm$core$Basics$identity;
var $author$project$Encryption$encryptedData = $elm$core$Basics$identity;
var $author$project$Encryption$encryptedDataCodec = $author$project$Serialize$map$(
	$author$project$Encryption$encryptedData,
	function (_v0) {
		var bytes = _v0;
		return bytes;
	},
	$author$project$Serialize$bytes);
var $author$project$FileStatus$MeasuredImage = function (a) {
	return {$: 0, a: a};
};
var $author$project$FileStatus$MeasuredVideo$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$FileStatus$MeasuredVideo = F2($author$project$FileStatus$MeasuredVideo$);
var $author$project$FileStatus$measuredFileSerializeCodec = $author$project$Serialize$finishCustomType(
	A4(
		$author$project$Serialize$variant2,
		$author$project$FileStatus$MeasuredVideo,
		$author$project$FileStatus$coordSerializeCodec,
		$author$project$Serialize$maybe($author$project$FileStatus$durationSerializeCodec),
		A3(
			$author$project$Serialize$variant1,
			$author$project$FileStatus$MeasuredImage,
			$author$project$FileStatus$coordSerializeCodec,
			$author$project$Serialize$customType(
				F3(
					function (imageEncoder, videoEncoder, value) {
						if (!value.$) {
							var argA = value.a;
							return imageEncoder(argA);
						} else {
							var argA = value.a;
							var argB = value.b;
							return A2(videoEncoder, argA, argB);
						}
					})))));
var $author$project$Serialize$result$ = function (errorCodec, valueCodec) {
	return $author$project$Serialize$finishCustomType(
		A3(
			$author$project$Serialize$variant1,
			$elm$core$Result$Ok,
			valueCodec,
			A3(
				$author$project$Serialize$variant1,
				$elm$core$Result$Err,
				errorCodec,
				$author$project$Serialize$customType(
					F3(
						function (errEncoder, okEncoder, value) {
							if (value.$ === 1) {
								var err = value.a;
								return errEncoder(err);
							} else {
								var ok = value.a;
								return okEncoder(ok);
							}
						})))));
};
var $author$project$Serialize$result = F2($author$project$Serialize$result$);
var $author$project$Serialize$unit = $author$project$Serialize$build$(
	$elm$core$Basics$always(
		$elm$bytes$Bytes$Encode$sequence(_List_Nil)),
	$elm$bytes$Bytes$Decode$succeed(
		$elm$core$Result$Ok(0)),
	function (_v0) {
		return $elm$json$Json$Encode$int(0);
	},
	$elm$json$Json$Decode$succeed(
		$elm$core$Result$Ok(0)));
var $author$project$Encryption$fromJsCodec = function (aCodec) {
	return $author$project$Serialize$finishCustomType(
		A4(
			$author$project$Serialize$variant2,
			$author$project$Encryption$FromJs_FileEncryptFailed,
			$author$project$Id$codec,
			$author$project$Serialize$string,
			A4(
				$author$project$Serialize$variant2,
				$author$project$Encryption$FromJs_FileEncrypted,
				$author$project$Id$codec,
				$author$project$Serialize$finishRecord(
					$author$project$Serialize$field$(
						function ($) {
							return $.measured;
						},
						$author$project$Serialize$maybe($author$project$FileStatus$measuredFileSerializeCodec),
						$author$project$Serialize$field$(
							function ($) {
								return $.thumbnail;
							},
							$author$project$Serialize$maybe($author$project$Serialize$bytes),
							$author$project$Serialize$field$(
								function ($) {
									return $.data;
								},
								$author$project$Serialize$bytes,
								$author$project$Serialize$field$(
									function ($) {
										return $.key;
									},
									$author$project$Serialize$bytes,
									$author$project$Serialize$record(
										F4(
											function (key, data, thumbnail, measured) {
												return {data: data, key: key, measured: measured, thumbnail: thumbnail};
											}))))))),
				A4(
					$author$project$Serialize$variant2,
					$author$project$Encryption$FromJs_ManyMessagesEncryptFailed,
					$author$project$Id$codec,
					$author$project$Serialize$string,
					A4(
						$author$project$Serialize$variant2,
						$author$project$Encryption$FromJs_ManyMessagesEncrypted,
						$author$project$Id$codec,
						$author$project$Serialize$list($author$project$Encryption$encryptedDataCodec),
						A4(
							$author$project$Serialize$variant2,
							$author$project$Encryption$FromJs_ManyMessagesDecrypted,
							$author$project$Id$codec,
							$author$project$Serialize$list(
								$author$project$Serialize$result$($author$project$Serialize$unit, aCodec)),
							A3(
								$author$project$Serialize$variant1,
								$author$project$Encryption$FromJs_NewMessageDecryptFailed,
								$author$project$Id$codec,
								A4(
									$author$project$Serialize$variant2,
									$author$project$Encryption$FromJs_NewMessageDecrypted,
									$author$project$Id$codec,
									aCodec,
									A4(
										$author$project$Serialize$variant2,
										$author$project$Encryption$FromJs_NewMessageEncryptFailed,
										$author$project$Id$codec,
										$author$project$Serialize$string,
										A4(
											$author$project$Serialize$variant2,
											$author$project$Encryption$FromJs_NewMessageEncrypted,
											$author$project$Id$codec,
											$author$project$Encryption$encryptedDataCodec,
											A4(
												$author$project$Serialize$variant2,
												$author$project$Encryption$FromJs_SharedSecretFailed,
												$author$project$Id$codec,
												$author$project$Serialize$string,
												A3(
													$author$project$Serialize$variant1,
													$author$project$Encryption$FromJs_SharedSecretStored,
													$author$project$Id$codec,
													$author$project$Serialize$customType(
														function (a) {
															return function (b) {
																return function (c) {
																	return function (d) {
																		return function (e) {
																			return function (f) {
																				return function (g) {
																					return function (h) {
																						return function (i) {
																							return function (j) {
																								return function (k) {
																									return function (value) {
																										switch (value.$) {
																											case 0:
																												var argA = value.a;
																												return a(argA);
																											case 1:
																												var argA = value.a;
																												var argB = value.b;
																												return A2(b, argA, argB);
																											case 2:
																												var argA = value.a;
																												var argB = value.b;
																												return A2(c, argA, argB);
																											case 3:
																												var argA = value.a;
																												var argB = value.b;
																												return A2(d, argA, argB);
																											case 4:
																												var argA = value.a;
																												var argB = value.b;
																												return A2(e, argA, argB);
																											case 5:
																												var argA = value.a;
																												return f(argA);
																											case 6:
																												var argA = value.a;
																												var argB = value.b;
																												return A2(g, argA, argB);
																											case 7:
																												var argA = value.a;
																												var argB = value.b;
																												return A2(h, argA, argB);
																											case 8:
																												var argA = value.a;
																												var argB = value.b;
																												return A2(i, argA, argB);
																											case 9:
																												var argA = value.a;
																												var argB = value.b;
																												return A2(j, argA, argB);
																											default:
																												var argA = value.a;
																												var argB = value.b;
																												return A2(k, argA, argB);
																										}
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														})))))))))))));
};
var $author$project$Encryption$fromJs$ = function (aCodec, msg) {
	return $lamdera$program_test$Effect$Subscription$fromJsBytes$(
		'encryption_from_js',
		$author$project$Encryption$encryption_from_js,
		function (bytes) {
			var _v0 = $author$project$Serialize$decodeFromBytes$(
				$author$project$Encryption$fromJsCodec(aCodec),
				bytes);
			if (!_v0.$) {
				var fromJs_ = _v0.a;
				return msg(
					$elm$core$Result$Ok(fromJs_));
			} else {
				return msg(
					$elm$core$Result$Err('The browser sent back something this app can\u0027t read'));
			}
		});
};
var $author$project$Encryption$fromJs = F2($author$project$Encryption$fromJs$);
var $author$project$Ports$device_pixel_ratio_from_js = _Platform_incomingPort('device_pixel_ratio_from_js', $elm$json$Json$Decode$value);
var $author$project$Ports$gotDevicePixelRatio = function (msg) {
	return $lamdera$program_test$Effect$Subscription$fromJs$(
		'device_pixel_ratio_from_js',
		$author$project$Ports$device_pixel_ratio_from_js,
		function (json) {
			return msg(
				$elm$core$Result$withDefault$(
					1,
					A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$float, json)));
		});
};
var $elmcraft$core_extra$Array$Extra$any$ = function (isOkay, array) {
	return $elm$core$Array$foldl$(
		F2(
			function (element, soFar) {
				return soFar || isOkay(element);
			}),
		false,
		array);
};
var $elmcraft$core_extra$Array$Extra$any = F2($elmcraft$core_extra$Array$Extra$any$);
var $author$project$WordSpellingGame$elapsedMs$ = function (currentTime, startTime) {
	return $lamdera$program_test$Effect$Time$posixToMillis(currentTime) - $lamdera$program_test$Effect$Time$posixToMillis(startTime);
};
var $author$project$WordSpellingGame$elapsedMs = F2($author$project$WordSpellingGame$elapsedMs$);
var $author$project$WordSpellingGame$tileFadeDuration = 100;
var $author$project$WordSpellingGame$isTileFading$ = function (currentTime, createdAt) {
	return _Utils_cmp(
		$author$project$WordSpellingGame$elapsedMs$(currentTime, createdAt),
		$ianmackenzie$elm_units$Duration$inMilliseconds($author$project$WordSpellingGame$tileFadeDelay) + $author$project$WordSpellingGame$tileFadeDuration) < 0;
};
var $author$project$WordSpellingGame$isTileFading = F2($author$project$WordSpellingGame$isTileFading$);
var $author$project$WordSpellingGame$trayShiftDuration = 200;
var $author$project$WordSpellingGame$isTileShifting$ = function (currentTime, tile) {
	var _v0 = tile.position;
	if ((!_v0.$) && (!_v0.b.$)) {
		var _v1 = _v0.b.a;
		var startTime = _v1.a;
		return _Utils_cmp(
			$author$project$WordSpellingGame$elapsedMs$(currentTime, startTime),
			$author$project$WordSpellingGame$trayShiftDuration) < 0;
	} else {
		return false;
	}
};
var $author$project$WordSpellingGame$isTileShifting = F2($author$project$WordSpellingGame$isTileShifting$);
var $author$project$WordSpellingGame$anyTileAnimating$ = function (currentTime, model) {
	return $elmcraft$core_extra$Array$Extra$any$(
		function (tile) {
			return $author$project$WordSpellingGame$isTileFading$(currentTime, tile.createdAt) || $author$project$WordSpellingGame$isTileShifting$(currentTime, tile);
		},
		model.tiles);
};
var $author$project$WordSpellingGame$anyTileAnimating = F2($author$project$WordSpellingGame$anyTileAnimating$);
var $author$project$WordSpellingGame$invalidHoldDuration = $ianmackenzie$elm_units$Duration$milliseconds(2000);
var $author$project$WordSpellingGame$slideInEnd = function (tileCount) {
	return $ianmackenzie$elm_units$Quantity$multiplyBy$(
		$elm$core$Basics$max$(0, tileCount - 1),
		$ianmackenzie$elm_units$Quantity$plus$($author$project$WordSpellingGame$tileSlideStagger, $author$project$WordSpellingGame$tileSlideDuration));
};
var $ianmackenzie$elm_units$Quantity$sum = function (quantities) {
	return $elm$core$List$foldl$($ianmackenzie$elm_units$Quantity$plus, $ianmackenzie$elm_units$Quantity$zero, quantities);
};
var $author$project$WordSpellingGame$placementAnimationDuration$ = function (isValid, tileCount) {
	if ((isValid.$ === 1) && (isValid.a.$ === 1)) {
		var _v1 = isValid.a;
		return $ianmackenzie$elm_units$Quantity$sum(
			_List_fromArray(
				[
					$author$project$WordSpellingGame$slideInEnd(tileCount),
					$author$project$WordSpellingGame$invalidHoldDuration,
					$author$project$WordSpellingGame$slideInEnd(tileCount)
				]));
	} else {
		return $author$project$WordSpellingGame$slideInEnd(tileCount);
	}
};
var $author$project$WordSpellingGame$placementAnimationDuration = F2($author$project$WordSpellingGame$placementAnimationDuration$);
var $author$project$WordSpellingGame$isAnimating$ = function (currentTime, shared) {
	var _v0 = shared.lastPlacement;
	if (!_v0.$) {
		var placement = _v0.a;
		return _Utils_cmp(
			$author$project$WordSpellingGame$elapsedMs$(currentTime, placement.startTime),
			$ianmackenzie$elm_units$Duration$inMilliseconds(
				$author$project$WordSpellingGame$placementAnimationDuration$(
					placement.isValid,
					$elm$core$List$length(placement.cells)))) < 0;
	} else {
		return false;
	}
};
var $author$project$WordSpellingGame$isAnimating = F2($author$project$WordSpellingGame$isAnimating$);
var $author$project$Coord$xRaw = function (_v0) {
	var x_ = _v0.a;
	return x_;
};
var $author$project$MyUi$isMobileAlt = function (windowSize) {
	return $author$project$Coord$xRaw(windowSize) < 700;
};
var $author$project$WordSpellingGame$zoomAnimationDuration = 250;
var $author$project$WordSpellingGame$gridSize = 15;
var $elm$core$List$sum = function (numbers) {
	return $elm$core$List$foldl$($elm$core$Basics$add, 0, numbers);
};
var $author$project$WordSpellingGame$zoomedOutState = {amount: 0, focusX: 0.5, focusY: 0.5};
var $author$project$WordSpellingGame$zoomStateForCells = function (placed) {
	if (!placed.b) {
		return $author$project$WordSpellingGame$zoomedOutState;
	} else {
		var count = $elm$core$List$length(placed);
		var focusFraction = function (total) {
			return ((total / count) + 0.5) / $author$project$WordSpellingGame$gridSize;
		};
		return {
			amount: 1,
			focusX: focusFraction(
				$elm$core$List$sum(
					$elm$core$List$map$($elm$core$Tuple$first, placed))),
			focusY: focusFraction(
				$elm$core$List$sum(
					$elm$core$List$map$($elm$core$Tuple$second, placed)))
		};
	}
};
var $author$project$WordSpellingGame$zoomTarget = function (model) {
	return $author$project$WordSpellingGame$zoomStateForCells(
		$elm$core$List$filterMap$(
			function (tile) {
				var _v0 = tile.position;
				if (_v0.$ === 1) {
					var cell = _v0.a;
					return $elm$core$Maybe$Just(cell);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			$elm$core$Array$toList(model.tiles)));
};
var $author$project$WordSpellingGame$isZoomAnimating$ = function (time, windowSize, model) {
	return $author$project$MyUi$isMobileAlt(windowSize) && ((!_Utils_eq(
		$author$project$WordSpellingGame$zoomTarget(model),
		model.zoomAnimation.from)) && (_Utils_cmp(
		$author$project$WordSpellingGame$elapsedMs$(time, model.zoomAnimation.start),
		$author$project$WordSpellingGame$zoomAnimationDuration) < 0));
};
var $author$project$WordSpellingGame$isZoomAnimating = F3($author$project$WordSpellingGame$isZoomAnimating$);
var $author$project$Game$isAnimating$ = function (time, windowSize, matchId, matchData, model) {
	if (!matchData.$) {
		var matchData2 = matchData.a;
		var _v1 = matchData2.data;
		switch (_v1.$) {
			case 0:
				return false;
			case 1:
				var shared = _v1.c;
				return $author$project$WordSpellingGame$isAnimating$(time, shared) || function () {
					var _v2 = $lamdera$containers$SeqDict$get$(matchId, model.startedGames);
					if ((!_v2.$) && (_v2.a.$ === 1)) {
						var game = _v2.a.a;
						return $author$project$WordSpellingGame$anyTileAnimating$(time, game) || $author$project$WordSpellingGame$isZoomAnimating$(time, windowSize, game);
					} else {
						return false;
					}
				}();
			default:
				return false;
		}
	} else {
		return false;
	}
};
var $author$project$Game$isAnimating = F5($author$project$Game$isAnimating$);
var $author$project$Ports$notification_clicked_from_js = _Platform_incomingPort('notification_clicked_from_js', $elm$json$Json$Decode$value);
var $author$project$Ports$notificationClicked = function (msg) {
	return $lamdera$program_test$Effect$Subscription$fromJs$(
		'notification_clicked_from_js',
		$author$project$Ports$notification_clicked_from_js,
		function (json) {
			return msg(
				$elm$core$Result$withDefault$(
					'',
					A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, json)));
		});
};
var $lamdera$program_test$Effect$Browser$Events$onAnimationFrame = $lamdera$program_test$Effect$Internal$OnAnimationFrame;
var $lamdera$program_test$Effect$Browser$Events$onAnimationFrameDelta = $lamdera$program_test$Effect$Internal$OnAnimationFrameDelta;
var $lamdera$program_test$Effect$Browser$Events$onKeyDown = $lamdera$program_test$Effect$Internal$OnKeyDown;
var $lamdera$program_test$Effect$Browser$Events$onResize = $lamdera$program_test$Effect$Internal$OnResize;
var $author$project$Ports$window_has_focus_from_js = _Platform_incomingPort('window_has_focus_from_js', $elm$json$Json$Decode$value);
var $author$project$Ports$pageHasFocus = function (msg) {
	return $lamdera$program_test$Effect$Subscription$fromJs$(
		'window_has_focus_from_js',
		$author$project$Ports$window_has_focus_from_js,
		function (json) {
			return msg(
				$elm$core$Result$withDefault$(
					true,
					A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$bool, json)));
		});
};
var $author$project$Ports$SubscribeJsException = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ports$GotSubscribeData = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ports$SubscribeData$ = function (endpoint, expirationTime, keys) {
	return {endpoint: endpoint, expirationTime: expirationTime, keys: keys};
};
var $author$project$Ports$SubscribeData = F3($author$project$Ports$SubscribeData$);
var $miniBill$elm_codec$Codec$float = $miniBill$elm_codec$Codec$build$($elm$json$Json$Encode$float, $elm$json$Json$Decode$float);
var $author$project$Ports$expirationTimeCodec = $miniBill$elm_codec$Codec$map$(
	function (ms) {
		return $elm$time$Time$millisToPosix(
			$elm$core$Basics$round(ms));
	},
	function (posix) {
		return $elm$time$Time$posixToMillis(posix);
	},
	$miniBill$elm_codec$Codec$float);
var $elm$core$List$any$ = function (isOkay, list) {
	any:
	while (true) {
		if (!list.b) {
			return false;
		} else {
			var x = list.a;
			var xs = list.b;
			if (isOkay(x)) {
				return true;
			} else {
				var $temp$list = xs;
				list = $temp$list;
				continue any;
			}
		}
	}
};
var $elm$core$List$any = F2($elm$core$List$any$);
var $miniBill$elm_codec$Codec$optionalNullableField$ = function (name, getter, codec, _v0) {
	var ocodec = _v0;
	return {
		decoder: A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (f, x) {
					return f(x);
				}),
			ocodec.decoder,
			A2(
				$elm$json$Json$Decode$andThen,
				function (json) {
					return $elm$core$List$any$(
						function (_v1) {
							var k = _v1.a;
							return _Utils_eq(k, name);
						},
						json) ? A2(
						$elm$json$Json$Decode$field,
						name,
						$elm$json$Json$Decode$nullable(
							$miniBill$elm_codec$Codec$decoder(codec))) : $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
				},
				$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value))),
		encoder: function (v) {
			var _v2 = getter(v);
			if (!_v2.$) {
				var present = _v2.a;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						name,
						A2($miniBill$elm_codec$Codec$encoder, codec, present)),
					ocodec.encoder(v));
			} else {
				return ocodec.encoder(v);
			}
		},
		fields: A2($elm$core$List$cons, name, ocodec.fields)
	};
};
var $miniBill$elm_codec$Codec$optionalNullableField = F4($miniBill$elm_codec$Codec$optionalNullableField$);
var $author$project$Ports$SubscribeKeys$ = function (auth, p256dh) {
	return {auth: auth, p256dh: p256dh};
};
var $author$project$Ports$SubscribeKeys = F2($author$project$Ports$SubscribeKeys$);
var $author$project$Ports$subscribeKeysCodec = $miniBill$elm_codec$Codec$buildObject(
	$miniBill$elm_codec$Codec$field$(
		'p256dh',
		function ($) {
			return $.p256dh;
		},
		$miniBill$elm_codec$Codec$string,
		$miniBill$elm_codec$Codec$field$(
			'auth',
			function ($) {
				return $.auth;
			},
			$miniBill$elm_codec$Codec$string,
			$miniBill$elm_codec$Codec$object($author$project$Ports$SubscribeKeys))));
var $elm$core$String$contains = _String_contains;
var $elm$core$String$indexes = _String_indexes;
var $elm$url$Url$chompBeforePath$ = function (protocol, path, params, frag, str) {
	if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
		return $elm$core$Maybe$Nothing;
	} else {
		var _v0 = A2($elm$core$String$indexes, ':', str);
		if (!_v0.b) {
			return $elm$core$Maybe$Just(
				$elm$url$Url$Url$(protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
		} else {
			if (!_v0.b.b) {
				var i = _v0.a;
				var _v1 = $elm$core$String$toInt(
					$elm$core$String$dropLeft$(i + 1, str));
				if (_v1.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var port_ = _v1;
					return $elm$core$Maybe$Just(
						$elm$url$Url$Url$(
							protocol,
							$elm$core$String$left$(i, str),
							port_,
							path,
							params,
							frag));
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	}
};
var $elm$url$Url$chompBeforePath = F5($elm$url$Url$chompBeforePath$);
var $elm$url$Url$chompBeforeQuery$ = function (protocol, params, frag, str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Maybe$Nothing;
	} else {
		var _v0 = A2($elm$core$String$indexes, '/', str);
		if (!_v0.b) {
			return $elm$url$Url$chompBeforePath$(protocol, '/', params, frag, str);
		} else {
			var i = _v0.a;
			return $elm$url$Url$chompBeforePath$(
				protocol,
				$elm$core$String$dropLeft$(i, str),
				params,
				frag,
				$elm$core$String$left$(i, str));
		}
	}
};
var $elm$url$Url$chompBeforeQuery = F4($elm$url$Url$chompBeforeQuery$);
var $elm$url$Url$chompBeforeFragment$ = function (protocol, frag, str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Maybe$Nothing;
	} else {
		var _v0 = A2($elm$core$String$indexes, '?', str);
		if (!_v0.b) {
			return $elm$url$Url$chompBeforeQuery$(protocol, $elm$core$Maybe$Nothing, frag, str);
		} else {
			var i = _v0.a;
			return $elm$url$Url$chompBeforeQuery$(
				protocol,
				$elm$core$Maybe$Just(
					$elm$core$String$dropLeft$(i + 1, str)),
				frag,
				$elm$core$String$left$(i, str));
		}
	}
};
var $elm$url$Url$chompBeforeFragment = F3($elm$url$Url$chompBeforeFragment$);
var $elm$url$Url$chompAfterProtocol$ = function (protocol, str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Maybe$Nothing;
	} else {
		var _v0 = A2($elm$core$String$indexes, '#', str);
		if (!_v0.b) {
			return $elm$url$Url$chompBeforeFragment$(protocol, $elm$core$Maybe$Nothing, str);
		} else {
			var i = _v0.a;
			return $elm$url$Url$chompBeforeFragment$(
				protocol,
				$elm$core$Maybe$Just(
					$elm$core$String$dropLeft$(i + 1, str)),
				$elm$core$String$left$(i, str));
		}
	}
};
var $elm$url$Url$chompAfterProtocol = F2($elm$url$Url$chompAfterProtocol$);
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? $elm$url$Url$chompAfterProtocol$(
		0,
		$elm$core$String$dropLeft$(7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? $elm$url$Url$chompAfterProtocol$(
		1,
		$elm$core$String$dropLeft$(8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$url$Url$addPort$ = function (maybePort, starter) {
	if (maybePort.$ === 1) {
		return starter;
	} else {
		var port_ = maybePort.a;
		return starter + (':' + $elm$core$String$fromInt(port_));
	}
};
var $elm$url$Url$addPort = F2($elm$url$Url$addPort$);
var $elm$url$Url$addPrefixed$ = function (prefix, maybeSegment, starter) {
	if (maybeSegment.$ === 1) {
		return starter;
	} else {
		var segment = maybeSegment.a;
		return _Utils_ap(
			starter,
			_Utils_ap(prefix, segment));
	}
};
var $elm$url$Url$addPrefixed = F3($elm$url$Url$addPrefixed$);
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.protocol;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return $elm$url$Url$addPrefixed$(
		'#',
		url.fragment,
		$elm$url$Url$addPrefixed$(
			'?',
			url.query,
			_Utils_ap(
				$elm$url$Url$addPort$(
					url.port_,
					_Utils_ap(http, url.host)),
				url.path)));
};
var $author$project$CodecExtra$url = $miniBill$elm_codec$Codec$andThen$(
	function (text) {
		var _v0 = $elm$url$Url$fromString(text);
		if (!_v0.$) {
			var url2 = _v0.a;
			return $miniBill$elm_codec$Codec$succeed(url2);
		} else {
			return $miniBill$elm_codec$Codec$fail('Invalid url: ' + text);
		}
	},
	$elm$url$Url$toString,
	$miniBill$elm_codec$Codec$string);
var $author$project$Ports$subscribeDataCodec = $miniBill$elm_codec$Codec$buildObject(
	$miniBill$elm_codec$Codec$field$(
		'keys',
		function ($) {
			return $.keys;
		},
		$author$project$Ports$subscribeKeysCodec,
		$miniBill$elm_codec$Codec$optionalNullableField$(
			'expirationTime',
			function ($) {
				return $.expirationTime;
			},
			$author$project$Ports$expirationTimeCodec,
			$miniBill$elm_codec$Codec$field$(
				'endpoint',
				function ($) {
					return $.endpoint;
				},
				$author$project$CodecExtra$url,
				$miniBill$elm_codec$Codec$object($author$project$Ports$SubscribeData)))));
var $author$project$Ports$registerPushSubscriptionCodec = $miniBill$elm_codec$Codec$buildCustom(
	A4(
		$miniBill$elm_codec$Codec$variant1,
		'SubscribeJsException',
		$author$project$Ports$SubscribeJsException,
		$miniBill$elm_codec$Codec$string,
		A4(
			$miniBill$elm_codec$Codec$variant1,
			'GotSubscribeData',
			$author$project$Ports$GotSubscribeData,
			$author$project$Ports$subscribeDataCodec,
			$miniBill$elm_codec$Codec$custom(
				F3(
					function (a, c, encoder) {
						if (!encoder.$) {
							var a0 = encoder.a;
							return a(a0);
						} else {
							var c0 = encoder.a;
							return c(c0);
						}
					})))));
var $author$project$Ports$register_push_subscription_from_js = _Platform_incomingPort('register_push_subscription_from_js', $elm$json$Json$Decode$value);
var $author$project$Ports$registerPushSubscription = function (msg) {
	return $lamdera$program_test$Effect$Subscription$fromJs$(
		'register_push_subscription_from_js',
		$author$project$Ports$register_push_subscription_from_js,
		function (json) {
			var _v0 = A2($miniBill$elm_codec$Codec$decodeValue, $author$project$Ports$registerPushSubscriptionCodec, json);
			if (!_v0.$) {
				var ok = _v0.a;
				return msg(ok);
			} else {
				var error = _v0.a;
				return msg(
					$author$project$Ports$SubscribeJsException(
						$elm$json$Json$Decode$errorToString(error)));
			}
		});
};
var $author$project$Ports$safe_area_insets_from_js = _Platform_incomingPort('safe_area_insets_from_js', $elm$json$Json$Decode$value);
var $author$project$Ports$safeAreaInsetsChanged = function (msg) {
	return $lamdera$program_test$Effect$Subscription$fromJs$(
		'safe_area_insets_from_js',
		$author$project$Ports$safe_area_insets_from_js,
		function (json) {
			return msg(
				$elm$core$Result$withDefault$(
					{bottom: 0, top: 0},
					A2(
						$elm$json$Json$Decode$decodeValue,
						A3(
							$elm$json$Json$Decode$map2,
							F2(
								function (top, bottom) {
									return {bottom: bottom, top: top};
								}),
							A2(
								$elm$json$Json$Decode$field,
								'top',
								A2($elm$json$Json$Decode$map, $elm$core$Basics$round, $elm$json$Json$Decode$float)),
							A2(
								$elm$json$Json$Decode$field,
								'bottom',
								A2($elm$json$Json$Decode$map, $elm$core$Basics$round, $elm$json$Json$Decode$float))),
						json)));
		});
};
var $ianmackenzie$elm_units$Duration$second = $ianmackenzie$elm_units$Duration$seconds(1);
var $author$project$Ports$selection_changed_from_js = _Platform_incomingPort('selection_changed_from_js', $elm$json$Json$Decode$value);
var $author$project$Ports$selectionChanged = function (msg) {
	return $lamdera$program_test$Effect$Subscription$fromJs$(
		'selection_changed_from_js',
		$author$project$Ports$selection_changed_from_js,
		function (json) {
			return msg(
				$elm$core$Result$withDefault$(
					_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
					A2($elm$json$Json$Decode$decodeValue, $author$project$Ports$decodeHtmlIdAndSelection, json)));
		});
};
var $author$project$Ports$load_service_worker_data_from_js = _Platform_incomingPort('load_service_worker_data_from_js', $elm$json$Json$Decode$value);
var $author$project$Ports$serviceWorkerData = function (msg) {
	return $lamdera$program_test$Effect$Subscription$fromJs$(
		'load_service_worker_data_from_js',
		$author$project$Ports$load_service_worker_data_from_js,
		function (json) {
			return msg(
				$elm$core$Result$withDefault$(
					'',
					A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, json)));
		});
};
var $author$project$Ports$service_worker_message_from_js = _Platform_incomingPort('service_worker_message_from_js', $elm$json$Json$Decode$value);
var $author$project$Ports$serviceWorkerMessage = function (msg) {
	return $lamdera$program_test$Effect$Subscription$fromJs$(
		'service_worker_message_from_js',
		$author$project$Ports$service_worker_message_from_js,
		function (json) {
			return msg(
				$elm$core$Result$withDefault$(
					'',
					A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, json)));
		});
};
var $author$project$Ports$StartupData$ = function (timeOrigin, loadStartupDataTime, userAgent, scrollbarWidth, pwaStatus, notificationPermission, safeAreaInsetTop, safeAreaInsetBottom, devicePixelRatio, timezone, randomSeed, e2eeKeys) {
	return {devicePixelRatio: devicePixelRatio, e2eeKeys: e2eeKeys, loadStartupDataTime: loadStartupDataTime, notificationPermission: notificationPermission, pwaStatus: pwaStatus, randomSeed: randomSeed, safeAreaInsetBottom: safeAreaInsetBottom, safeAreaInsetTop: safeAreaInsetTop, scrollbarWidth: scrollbarWidth, timeOrigin: timeOrigin, timezone: timezone, userAgent: userAgent};
};
var $author$project$Ports$StartupData = function (timeOrigin) {
	return function (loadStartupDataTime) {
		return function (userAgent) {
			return function (scrollbarWidth) {
				return function (pwaStatus) {
					return function (notificationPermission) {
						return function (safeAreaInsetTop) {
							return function (safeAreaInsetBottom) {
								return function (devicePixelRatio) {
									return function (timezone) {
										return function (randomSeed) {
											return function (e2eeKeys) {
												return $author$project$Ports$StartupData$(timeOrigin, loadStartupDataTime, userAgent, scrollbarWidth, pwaStatus, notificationPermission, safeAreaInsetTop, safeAreaInsetBottom, devicePixelRatio, timezone, randomSeed, e2eeKeys);
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm_community$json_extra$Json$Decode$Extra$andMap = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $elm$time$Time$Zone$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $elm$time$Time$Zone = F2($elm$time$Time$Zone$);
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $author$project$Ports$decodeTimezone = A3(
	$elm$json$Json$Decode$map2,
	$elm$time$Time$customZone,
	A2($elm$json$Json$Decode$field, 'defaultOffset', $elm$json$Json$Decode$int),
	A2(
		$elm$json$Json$Decode$field,
		'eras',
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				F2(
					function (start, offset) {
						return {offset: offset, start: start};
					}),
				A2($elm$json$Json$Decode$field, 'start', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'offset', $elm$json$Json$Decode$int)))));
var $author$project$UserAgent$Chrome = 0;
var $author$project$UserAgent$Edge = 3;
var $author$project$UserAgent$Firefox = 1;
var $author$project$UserAgent$Opera = 4;
var $author$project$UserAgent$Safari = 2;
var $author$project$UserAgent$UnknownBrowser = 5;
var $elm$core$String$toLower = _String_toLower;
var $author$project$UserAgent$parseBrowser = function (userAgentString) {
	var lowerUserAgent = $elm$core$String$toLower(userAgentString);
	return (A2($elm$core$String$contains, 'chrome', lowerUserAgent) && (!A2($elm$core$String$contains, 'edge', lowerUserAgent))) ? 0 : (A2($elm$core$String$contains, 'firefox', lowerUserAgent) ? 1 : ((A2($elm$core$String$contains, 'safari', lowerUserAgent) && (!A2($elm$core$String$contains, 'chrome', lowerUserAgent))) ? 2 : (A2($elm$core$String$contains, 'edge', lowerUserAgent) ? 3 : ((A2($elm$core$String$contains, 'opera', lowerUserAgent) || A2($elm$core$String$contains, 'opr', lowerUserAgent)) ? 4 : 5))));
};
var $author$project$UserAgent$AndroidPhone = 2;
var $author$project$UserAgent$AndroidTablet = 3;
var $author$project$UserAgent$ChromeOS = 6;
var $author$project$UserAgent$Desktop = 10;
var $author$project$UserAgent$IPad = 1;
var $author$project$UserAgent$IPhone = 0;
var $author$project$UserAgent$Linux = 7;
var $author$project$UserAgent$MacOS = 5;
var $author$project$UserAgent$Mobile = 8;
var $author$project$UserAgent$Tablet = 9;
var $author$project$UserAgent$Windows = 4;
var $author$project$UserAgent$parseDevice = function (userAgentString) {
	var lowerUserAgent = $elm$core$String$toLower(userAgentString);
	return A2($elm$core$String$contains, 'ipad', lowerUserAgent) ? 1 : ((A2($elm$core$String$contains, 'iphone', lowerUserAgent) || A2($elm$core$String$contains, 'ipod', lowerUserAgent)) ? 0 : (A2($elm$core$String$contains, 'android', lowerUserAgent) ? (A2($elm$core$String$contains, 'mobile', lowerUserAgent) ? 2 : 3) : (A2($elm$core$String$contains, 'mobile', lowerUserAgent) ? 8 : (A2($elm$core$String$contains, 'tablet', lowerUserAgent) ? 9 : (A2($elm$core$String$contains, 'windows', lowerUserAgent) ? 4 : (A2($elm$core$String$contains, 'cros', lowerUserAgent) ? 6 : ((A2($elm$core$String$contains, 'macintosh', lowerUserAgent) || A2($elm$core$String$contains, 'mac os', lowerUserAgent)) ? 5 : ((A2($elm$core$String$contains, 'linux', lowerUserAgent) || A2($elm$core$String$contains, 'x11', lowerUserAgent)) ? 7 : 10))))))));
};
var $author$project$UserAgent$parseUserAgent = function (userAgentString) {
	return {
		browser: $author$project$UserAgent$parseBrowser(userAgentString),
		device: $author$project$UserAgent$parseDevice(userAgentString)
	};
};
var $author$project$Ports$BrowserView = 1;
var $author$project$Ports$InstalledPwa = 0;
var $author$project$Ports$pwaStatusFromBool = function (isPwa) {
	return isPwa ? 0 : 1;
};
var $author$project$Ports$decodeStartupData = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$field,
		'e2eeKeys',
		$elm$json$Json$Decode$list(
			A2($elm$json$Json$Decode$map, $author$project$Id$fromInt, $elm$json$Json$Decode$int))),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2(
			$elm$json$Json$Decode$field,
			'randomSeed',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$int)),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'timezone', $author$project$Ports$decodeTimezone),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				$elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							A2($elm$json$Json$Decode$field, 'devicePixelRatio', $elm$json$Json$Decode$float),
							$elm$json$Json$Decode$succeed(1)
						])),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$json$Json$Decode$field,
								'safeAreaInsetBottom',
								A2($elm$json$Json$Decode$map, $elm$core$Basics$round, $elm$json$Json$Decode$float)),
								$elm$json$Json$Decode$succeed(0)
							])),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						$elm$json$Json$Decode$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$json$Json$Decode$field,
									'safeAreaInsetTop',
									A2($elm$json$Json$Decode$map, $elm$core$Basics$round, $elm$json$Json$Decode$float)),
									$elm$json$Json$Decode$succeed(0)
								])),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2(
								$elm$json$Json$Decode$field,
								'notificationPermission',
								A2($elm$json$Json$Decode$map, $author$project$Ports$notificationPermissionFromString, $elm$json$Json$Decode$string)),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2(
									$elm$json$Json$Decode$field,
									'isPwa',
									A2($elm$json$Json$Decode$map, $author$project$Ports$pwaStatusFromBool, $elm$json$Json$Decode$bool)),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'scrollbarWidth', $elm$json$Json$Decode$int),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2(
											$elm$json$Json$Decode$field,
											'userAgent',
											A2($elm$json$Json$Decode$map, $author$project$UserAgent$parseUserAgent, $elm$json$Json$Decode$string)),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2(
												$elm$json$Json$Decode$field,
												'loadStartupDataTime',
												A2(
													$elm$json$Json$Decode$map,
													function (ms) {
														return $elm$time$Time$millisToPosix(
															$elm$core$Basics$round(ms));
													},
													$elm$json$Json$Decode$float)),
											A2(
												$elm_community$json_extra$Json$Decode$Extra$andMap,
												A2(
													$elm$json$Json$Decode$field,
													'timeOrigin',
													A2(
														$elm$json$Json$Decode$map,
														function (ms) {
															return $elm$time$Time$millisToPosix(
																$elm$core$Basics$round(ms));
														},
														$elm$json$Json$Decode$float)),
												$elm$json$Json$Decode$succeed($author$project$Ports$StartupData)))))))))))));
var $author$project$Ports$load_startup_data_from_js = _Platform_incomingPort('load_startup_data_from_js', $elm$json$Json$Decode$value);
var $author$project$Ports$startupDataSub = function (msg) {
	return $lamdera$program_test$Effect$Subscription$fromJs$(
		'load_startup_data_from_js',
		$author$project$Ports$load_startup_data_from_js,
		function (json) {
			return msg(
				$elm$core$Result$mapError$(
					$elm$json$Json$Decode$errorToString,
					A2($elm$json$Json$Decode$decodeValue, $author$project$Ports$decodeStartupData, json)));
		});
};
var $author$project$AiChat$GotLocalStorage = function (a) {
	return {$: 14, a: a};
};
var $author$project$AiChat$load_user_settings_from_js = _Platform_incomingPort('load_user_settings_from_js', $elm$json$Json$Decode$value);
var $author$project$AiChat$loadUserSettingsFromJs = function (msg) {
	return $lamdera$program_test$Effect$Subscription$fromJs$(
		'load_user_settings_from_js',
		$author$project$AiChat$load_user_settings_from_js,
		function (json) {
			return msg(
				$elm$core$Result$withDefault$(
					'',
					A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, json)));
		});
};
var $author$project$AiChat$subscriptions = $author$project$AiChat$loadUserSettingsFromJs($author$project$AiChat$GotLocalStorage);
var $author$project$ImageEditor$CroppedImage = function (a) {
	return {$: 9, a: a};
};
var $author$project$ImageEditor$MouseUpImageEditor = {$: 4};
var $author$project$Ports$CropImageDataResponse$ = function (requestId, croppedImageUrl) {
	return {croppedImageUrl: croppedImageUrl, requestId: requestId};
};
var $author$project$Ports$CropImageDataResponse = F2($author$project$Ports$CropImageDataResponse$);
var $author$project$Ports$cropImageDataResponseCodec = $miniBill$elm_codec$Codec$buildObject(
	$miniBill$elm_codec$Codec$field$(
		'croppedImageUrl',
		function ($) {
			return $.croppedImageUrl;
		},
		$miniBill$elm_codec$Codec$string,
		$miniBill$elm_codec$Codec$field$(
			'requestId',
			function ($) {
				return $.requestId;
			},
			$miniBill$elm_codec$Codec$int,
			$miniBill$elm_codec$Codec$object($author$project$Ports$CropImageDataResponse))));
var $author$project$Ports$cropImageFromJsName = 'martinsstewart_crop_image_from_js';
var $author$project$Ports$martinsstewart_crop_image_from_js = _Platform_incomingPort('martinsstewart_crop_image_from_js', $elm$json$Json$Decode$value);
var $author$project$Ports$cropImageFromJs = function (msg) {
	return $lamdera$program_test$Effect$Subscription$fromJs$(
		$author$project$Ports$cropImageFromJsName,
		$author$project$Ports$martinsstewart_crop_image_from_js,
		function (a) {
			return msg(
				$elm$core$Result$mapError$(
					$elm$json$Json$Decode$errorToString,
					A2($miniBill$elm_codec$Codec$decodeValue, $author$project$Ports$cropImageDataResponseCodec, a)));
		});
};
var $lamdera$program_test$Effect$Browser$Events$onMouseUp = $lamdera$program_test$Effect$Internal$OnMouseUp;
var $author$project$ImageEditor$subscriptions = $lamdera$program_test$Effect$Subscription$batch(
	_List_fromArray(
		[
			$author$project$Ports$cropImageFromJs(
			function (a) {
				return $author$project$ImageEditor$CroppedImage(a);
			}),
			$lamdera$program_test$Effect$Browser$Events$onMouseUp(
			$elm$json$Json$Decode$succeed($author$project$ImageEditor$MouseUpImageEditor))
		]));
var $author$project$ImageViewer$AnimationFrame = function (a) {
	return {$: 11, a: a};
};
var $author$project$ImageViewer$NoInteraction = {$: 0};
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $author$project$ImageViewer$ViewportBottom = 3;
var $author$project$ImageViewer$ViewportLeft = 0;
var $author$project$ImageViewer$ViewportRight = 1;
var $author$project$ImageViewer$ViewportTop = 2;
var $author$project$Coord$yRaw = function (_v0) {
	var y_ = _v0.b;
	return y_;
};
var $author$project$ImageViewer$fittedSize$ = function (windowSize, model) {
	var w = $elm$core$Basics$max$(
		1,
		$author$project$Coord$xRaw(model.imageSize));
	var vw = $author$project$Coord$xRaw(windowSize);
	var vh = $author$project$Coord$yRaw(windowSize);
	var h = $elm$core$Basics$max$(
		1,
		$author$project$Coord$yRaw(model.imageSize));
	var fit = $elm$core$Basics$min$(
		1,
		$elm$core$Basics$min$((0.9 * vw) / w, (0.9 * vh) / h));
	return _Utils_Tuple2(w * fit, h * fit);
};
var $author$project$ImageViewer$fittedSize = F2($author$project$ImageViewer$fittedSize$);
var $author$project$ImageViewer$displayedSize$ = function (windowSize, model) {
	var _v0 = $author$project$ImageViewer$fittedSize$(windowSize, model);
	var w = _v0.a;
	var h = _v0.b;
	return _Utils_Tuple2(w * model.scale, h * model.scale);
};
var $author$project$ImageViewer$displayedSize = F2($author$project$ImageViewer$displayedSize$);
var $elmcraft$core_extra$List$Extra$minimumBy$ = function (f, ls) {
	var minBy = F2(
		function (x, min) {
			var fy = min.b;
			var fx = f(x);
			return (_Utils_cmp(fx, fy) < 0) ? _Utils_Tuple2(x, fx) : min;
		});
	if (ls.b) {
		if (!ls.b.b) {
			var l_ = ls.a;
			return $elm$core$Maybe$Just(l_);
		} else {
			var l_ = ls.a;
			var ls_ = ls.b;
			return $elm$core$Maybe$Just(
				$elm$core$List$foldl$(
					minBy,
					_Utils_Tuple2(
						l_,
						f(l_)),
					ls_).a);
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elmcraft$core_extra$List$Extra$minimumBy = F2($elmcraft$core_extra$List$Extra$minimumBy$);
var $author$project$NonemptyExtra$minimumBy$ = function (minFunc, _v0) {
	var head = _v0.a;
	var tail = _v0.b;
	var _v1 = $elmcraft$core_extra$List$Extra$minimumBy$(
		minFunc,
		A2($elm$core$List$cons, head, tail));
	if (!_v1.$) {
		var minimum = _v1.a;
		return minimum;
	} else {
		return head;
	}
};
var $author$project$NonemptyExtra$minimumBy = F2($author$project$NonemptyExtra$minimumBy$);
var $author$project$ImageViewer$nearestViewportEdge$ = function (windowSize, model) {
	var viewWidth = $author$project$Coord$xRaw(windowSize);
	var viewHeight = $author$project$Coord$yRaw(windowSize);
	var imageCenterY = (viewHeight / 2) + model.offsetY;
	var imageCenterX = (viewWidth / 2) + model.offsetX;
	var _v0 = $author$project$ImageViewer$displayedSize$(windowSize, model);
	var imageWidth = _v0.a;
	var imageHeight = _v0.b;
	var imageYA = imageCenterY - (imageHeight / 2);
	var imageYB = imageCenterY + (imageHeight / 2);
	var imageXA = imageCenterX - (imageWidth / 2);
	var imageXB = imageCenterX + (imageWidth / 2);
	return $author$project$NonemptyExtra$minimumBy$(
		$elm$core$Tuple$second,
		$mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
			_Utils_Tuple2(
				0,
				$elm$core$Basics$clamp$(0, 1, 4 * ((viewWidth - imageXA) / viewWidth))),
			_List_fromArray(
				[
					_Utils_Tuple2(
					1,
					$elm$core$Basics$clamp$(0, 1, 4 * (imageXB / viewWidth))),
					_Utils_Tuple2(
					2,
					$elm$core$Basics$clamp$(0, 1, 4 * ((viewHeight - imageYA) / viewHeight))),
					_Utils_Tuple2(
					3,
					$elm$core$Basics$clamp$(0, 1, 4 * (imageYB / viewHeight)))
				])));
};
var $author$project$ImageViewer$nearestViewportEdge = F2($author$project$ImageViewer$nearestViewportEdge$);
var $author$project$ImageViewer$panVelocityThreshold = 0.3;
var $author$project$ImageViewer$isAnimating$ = function (windowSize, model) {
	return (!_Utils_eq(model.interaction, $author$project$ImageViewer$NoInteraction)) || ((_Utils_cmp(
		$elm$core$Basics$abs(model.velocityX),
		$author$project$ImageViewer$panVelocityThreshold) > 0) || ((_Utils_cmp(
		$elm$core$Basics$abs(model.velocityY),
		$author$project$ImageViewer$panVelocityThreshold) > 0) || ((!_Utils_eq(model.scale, model.targetScale)) || ($author$project$ImageViewer$nearestViewportEdge$(windowSize, model).b < 1))));
};
var $author$project$ImageViewer$isAnimating = F2($author$project$ImageViewer$isAnimating$);
var $author$project$ImageViewer$subscriptions$ = function (windowSize, model) {
	return $author$project$ImageViewer$isAnimating$(windowSize, model) ? $lamdera$program_test$Effect$Browser$Events$onAnimationFrameDelta($author$project$ImageViewer$AnimationFrame) : $lamdera$program_test$Effect$Subscription$none;
};
var $author$project$ImageViewer$subscriptions = F2($author$project$ImageViewer$subscriptions$);
var $lamdera$program_test$Effect$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $lamdera$program_test$Effect$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $lamdera$program_test$Effect$Http$progressFromInternal = function (progress) {
	if (!progress.$) {
		var a = progress.a;
		return $lamdera$program_test$Effect$Http$Sending(a);
	} else {
		var a = progress.a;
		return $lamdera$program_test$Effect$Http$Receiving(a);
	}
};
var $lamdera$program_test$Effect$Http$track$ = function (tracker, toMsg) {
	return $lamdera$program_test$Effect$Internal$HttpTrack$(
		tracker,
		A2($elm$core$Basics$composeR, $lamdera$program_test$Effect$Http$progressFromInternal, toMsg));
};
var $lamdera$program_test$Effect$Http$track = F2($lamdera$program_test$Effect$Http$track$);
var $author$project$FileStatus$uploadTrackerId$ = function (_v0, fileId) {
	var guildOrDmId = _v0.a;
	var threadRoute = _v0.b;
	return function () {
		switch (guildOrDmId.$) {
			case 0:
				if (!guildOrDmId.a.$) {
					var channelId = guildOrDmId.a.a.channelId;
					var guildId = guildOrDmId.a.a.guildId;
					return $author$project$Id$toString(guildId) + (',' + $author$project$Id$toString(channelId));
				} else {
					var otherUserId = guildOrDmId.a.a.otherUserId;
					return $author$project$Id$toString(otherUserId);
				}
			case 1:
				if (!guildOrDmId.a.$) {
					var id = guildOrDmId.a.a;
					return 'd' + ($author$project$Discord$idToString(id.guildId) + (',' + $author$project$Discord$idToString(id.channelId)));
				} else {
					var channelId = guildOrDmId.a.a.channelId;
					var currentUserId = guildOrDmId.a.a.currentUserId;
					return 'dd' + ($author$project$Discord$idToString(currentUserId) + (',' + $author$project$Discord$idToString(channelId)));
				}
			default:
				if (!guildOrDmId.a.$) {
					var id = guildOrDmId.a.a;
					return 's' + ($author$project$Slack$idToString(id.teamId) + (',' + $author$project$Slack$idToString(id.channelId)));
				} else {
					var channelId = guildOrDmId.a.a.channelId;
					var currentUserId = guildOrDmId.a.a.currentUserId;
					return 'sd' + ($author$project$Slack$idToString(currentUserId) + (',' + $author$project$Slack$idToString(channelId)));
				}
		}
	}() + (function () {
		if (threadRoute.$ === 1) {
			var threadMessageIndex = threadRoute.a;
			return ',t' + $author$project$Id$toString(threadMessageIndex);
		} else {
			return '';
		}
	}() + ('f' + $author$project$Id$toString(fileId)));
};
var $author$project$FileStatus$uploadTrackerId = F2($author$project$FileStatus$uploadTrackerId$);
var $author$project$Ports$visual_viewport_changed_from_js = _Platform_incomingPort('visual_viewport_changed_from_js', $elm$json$Json$Decode$value);
var $author$project$Ports$visualViewportChanged = function (msg) {
	return $lamdera$program_test$Effect$Subscription$fromJs$(
		'visual_viewport_changed_from_js',
		$author$project$Ports$visual_viewport_changed_from_js,
		function (json) {
			return msg(
				$elm$core$Result$withDefault$(
					{height: 0, top: 0},
					A2(
						$elm$json$Json$Decode$decodeValue,
						A3(
							$elm$json$Json$Decode$map2,
							F2(
								function (height, top) {
									return {height: height, top: top};
								}),
							A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$float),
							A2($elm$json$Json$Decode$field, 'top', $elm$json$Json$Decode$float)),
						json)));
		});
};
var $author$project$Frontend$subscriptions$ = function (_v0, model) {
	return $lamdera$program_test$Effect$Subscription$batch(
		_List_fromArray(
			[
				$lamdera$program_test$Effect$Browser$Events$onResize($author$project$Types$GotWindowSize),
				A2($lamdera$program_test$Effect$Time$every, $ianmackenzie$elm_units$Duration$second, $author$project$Types$GotTime),
				$lamdera$program_test$Effect$Browser$Events$onKeyDown(
				A5(
					$elm$json$Json$Decode$map4,
					F4(
						function (ctrlKey, metaKey, shiftKey, key) {
							return $author$project$Types$KeyDown(
								{ctrlKey: ctrlKey, key: key, metaKey: metaKey, shiftKey: shiftKey});
						}),
					A2($elm$json$Json$Decode$field, 'ctrlKey', $elm$json$Json$Decode$bool),
					A2($elm$json$Json$Decode$field, 'metaKey', $elm$json$Json$Decode$bool),
					A2($elm$json$Json$Decode$field, 'shiftKey', $elm$json$Json$Decode$bool),
					A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string))),
				$author$project$Ports$checkNotificationPermissionResponse($author$project$Types$CheckedNotificationPermission),
				$lamdera$program_test$Effect$Subscription$map$($author$project$Types$AiChatMsg, $author$project$AiChat$subscriptions),
				$author$project$Ports$startupDataSub($author$project$Types$GotStartupData),
				$author$project$Ports$gotDevicePixelRatio($author$project$Types$GotDevicePixelRatio),
				$author$project$Ports$pageHasFocus($author$project$Types$PageHasFocusChanged),
				$author$project$Ports$serviceWorkerMessage($author$project$Types$GotServiceWorkerMessage),
				$author$project$Ports$notificationClicked($author$project$Types$PressedNotification),
				$author$project$Ports$serviceWorkerData($author$project$Types$GotServiceWorkerData),
				$author$project$Ports$visualViewportChanged($author$project$Types$VisualViewportChanged),
				$author$project$Ports$safeAreaInsetsChanged($author$project$Types$SafeAreaInsetsChanged),
				$author$project$Ports$selectionChanged($author$project$Types$TextSelectionChanged),
				$author$project$Ports$focusChanged($author$project$Types$DomFocusChanged),
				$author$project$Call$fromJs($author$project$Types$GotVoiceChatSignalFromJs),
				$author$project$Encryption$fromJs$($author$project$Message$contentAndEmbedsCodec, $author$project$Types$EncryptionFromJs),
				function () {
				if (!model.$) {
					return $lamdera$program_test$Effect$Subscription$none;
				} else {
					var loaded = model.a;
					return $lamdera$program_test$Effect$Subscription$batch(
						_List_fromArray(
							[
								function () {
								var _v2 = loaded.imageViewer;
								if (!_v2.$) {
									var imageViewer = _v2.a;
									return $lamdera$program_test$Effect$Subscription$map$(
										$author$project$Types$ImageViewerMsg,
										$author$project$ImageViewer$subscriptions$(loaded.windowSize, imageViewer));
								} else {
									return $lamdera$program_test$Effect$Subscription$none;
								}
							}(),
								function () {
								var _v3 = loaded.loginStatus;
								if (!_v3.$) {
									var loggedIn = _v3.a;
									return $lamdera$program_test$Effect$Subscription$batch(
										_List_fromArray(
											[
												$lamdera$program_test$Effect$Subscription$batch(
												$lamdera$containers$SeqDict$foldl$(
													F3(
														function (guildOrDmId, filesToUpload, list) {
															return $author$project$NonemptyDict$foldl$(
																F3(
																	function (fileId, fileStatus, list2) {
																		switch (fileStatus.$) {
																			case 0:
																				return A2(
																					$elm$core$List$cons,
																					$lamdera$program_test$Effect$Http$track$(
																						$author$project$FileStatus$uploadTrackerId$(guildOrDmId, fileId),
																						A2($author$project$Types$FileUploadProgress, guildOrDmId, fileId)),
																					list2);
																			case 1:
																				return list2;
																			default:
																				return list2;
																		}
																	}),
																list,
																filesToUpload);
														}),
													_List_Nil,
													loggedIn.filesToUpload)),
												($author$project$FrontendExtra$fileDragOverlayOpacity$(loggedIn, loaded) <= 0) ? $lamdera$program_test$Effect$Subscription$none : $lamdera$program_test$Effect$Browser$Events$onAnimationFrame($author$project$Types$GotTime),
												function () {
												var _v5 = $author$project$FrontendExtra$currentGame$(
													$author$project$Local$model(loggedIn.localState),
													loaded);
												if (!_v5.$) {
													var match = _v5.a.match;
													var matchId = _v5.a.matchId;
													var guildOrDmId = _v5.a.guildOrDmId;
													return $author$project$Game$isAnimating$(
														loaded.time,
														loaded.windowSize,
														matchId,
														match,
														$elm$core$Maybe$withDefault$(
															$author$project$Game$initModel,
															$lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.games))) ? $lamdera$program_test$Effect$Browser$Events$onAnimationFrame($author$project$Types$GotTime) : $lamdera$program_test$Effect$Subscription$none;
												} else {
													return $lamdera$program_test$Effect$Subscription$none;
												}
											}(),
												function () {
												var _v6 = loggedIn.sidebarMode;
												if (_v6.$ === 1) {
													return $lamdera$program_test$Effect$Subscription$none;
												} else {
													var offset = _v6.a.offset;
													return _Utils_eq(
														offset,
														$author$project$FrontendExtra$channelSidebarTarget(loaded.route)) ? $lamdera$program_test$Effect$Subscription$none : $lamdera$program_test$Effect$Browser$Events$onAnimationFrameDelta($author$project$Types$ChannelSidebarAnimated);
												}
											}(),
												function () {
												var _v7 = loggedIn.messageHover;
												switch (_v7.$) {
													case 0:
														return $lamdera$program_test$Effect$Subscription$none;
													case 1:
														return $lamdera$program_test$Effect$Subscription$none;
													case 3:
														return $lamdera$program_test$Effect$Subscription$none;
													default:
														var messageMenuExtraOptions = _v7.a;
														var _v8 = messageMenuExtraOptions.mobileMode;
														switch (_v8.$) {
															case 0:
																return $lamdera$program_test$Effect$Browser$Events$onAnimationFrameDelta($author$project$Types$MessageMenuAnimated);
															case 1:
																return $lamdera$program_test$Effect$Browser$Events$onAnimationFrameDelta($author$project$Types$MessageMenuAnimated);
															case 2:
																return $lamdera$program_test$Effect$Subscription$none;
															default:
																return $lamdera$program_test$Effect$Subscription$none;
														}
												}
											}(),
												$lamdera$program_test$Effect$Subscription$map$(
												$author$project$Types$VoiceChatMsg,
												$author$project$Call$debugDataSubscription(loggedIn.voiceChat)),
												$lamdera$program_test$Effect$Subscription$map$($author$project$Types$ProfilePictureEditorMsg, $author$project$ImageEditor$subscriptions),
												function () {
												var _v9 = loggedIn.guildIconEditor;
												if (!_v9.$) {
													var _v10 = _v9.a;
													var guildId = _v10.a;
													return $lamdera$program_test$Effect$Subscription$map$(
														$author$project$Types$GuildIconEditorMsg(guildId),
														$author$project$ImageEditor$subscriptions);
												} else {
													return $lamdera$program_test$Effect$Subscription$none;
												}
											}()
											]));
								} else {
									return $lamdera$program_test$Effect$Subscription$none;
								}
							}()
							]));
				}
			}(),
				$author$project$Ports$registerPushSubscription($author$project$Types$GotRegisterPushSubscription)
			]));
};
var $author$project$Frontend$subscriptions = F2($author$project$Frontend$subscriptions$);
var $author$project$Types$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$LoggedIn = function (a) {
	return {$: 0, a: a};
};
var $author$project$Call$NoVideo = {$: 0};
var $author$project$Call$ShowLocalVideo = function (a) {
	return {$: 1, a: a};
};
var $author$project$Call$ShowLocalVideoAndCall = function (a) {
	return {$: 2, a: a};
};
var $author$project$Call$ShowLocalVideoAndCallThumbnail = function (a) {
	return {$: 3, a: a};
};
var $author$project$Call$displayMode$ = function (isMobile, currentUserId, route, local) {
	var thumbnailOrNoVideo = function () {
		var _v9 = local.currentRoom;
		if (!_v9.$) {
			var currentRoom = _v9.a;
			return $author$project$Call$ShowLocalVideoAndCallThumbnail(currentRoom);
		} else {
			return $author$project$Call$NoVideo;
		}
	}();
	switch (route.$) {
		case 0:
			return thumbnailOrNoVideo;
		case 1:
			return thumbnailOrNoVideo;
		case 2:
			return thumbnailOrNoVideo;
		case 3:
			var guildId = route.a;
			var channelRoute = route.b;
			var channelsVisible = route.c;
			var _v1 = _Utils_Tuple2(isMobile, channelsVisible);
			if (_v1.a && (_v1.b === 1)) {
				var _v2 = _v1.b;
				return thumbnailOrNoVideo;
			} else {
				switch (channelRoute.$) {
					case 0:
						var channelId = channelRoute.a;
						var tab = channelRoute.c;
						var roomId = $author$project$Call$GuildRoomId(
							{channelId: channelId, guildId: guildId});
						var isTabExpanded = _Utils_eq(
							tab,
							$elm$core$Maybe$Just($author$project$UserSession$ChannelHeaderTab_VoiceChat));
						if (_Utils_eq(
							$elm$core$Maybe$Just(roomId),
							local.currentRoom) && isTabExpanded) {
							var _v4 = $lamdera$containers$SeqDict$get$(roomId, local.voiceChats);
							if (!_v4.$) {
								return $author$project$Call$ShowLocalVideoAndCall(roomId);
							} else {
								return $author$project$Call$ShowLocalVideo(roomId);
							}
						} else {
							if (isTabExpanded) {
								return $author$project$Call$ShowLocalVideo(roomId);
							} else {
								return thumbnailOrNoVideo;
							}
						}
					case 1:
						return thumbnailOrNoVideo;
					case 2:
						return thumbnailOrNoVideo;
					default:
						return thumbnailOrNoVideo;
				}
			}
		case 4:
			return thumbnailOrNoVideo;
		case 5:
			var dmRoute = route.a;
			var _v5 = _Utils_Tuple2(isMobile, dmRoute.channelsVisible);
			if (_v5.a && (_v5.b === 1)) {
				var _v6 = _v5.b;
				return thumbnailOrNoVideo;
			} else {
				var _v7 = $author$project$DmChannelId$otherUserId$(currentUserId, dmRoute.channelId);
				if (!_v7.$) {
					var otherUserId = _v7.a;
					var roomId = $author$project$Call$DmRoomId(
						{otherUserId: otherUserId});
					var isTabExpanded = _Utils_eq(
						dmRoute.tab,
						$elm$core$Maybe$Just($author$project$UserSession$ChannelHeaderTab_VoiceChat));
					if (_Utils_eq(
						$elm$core$Maybe$Just(roomId),
						local.currentRoom) && isTabExpanded) {
						var _v8 = $lamdera$containers$SeqDict$get$(roomId, local.voiceChats);
						if (!_v8.$) {
							return $author$project$Call$ShowLocalVideoAndCall(roomId);
						} else {
							return $author$project$Call$ShowLocalVideo(roomId);
						}
					} else {
						if (isTabExpanded) {
							return $author$project$Call$ShowLocalVideo(roomId);
						} else {
							return thumbnailOrNoVideo;
						}
					}
				} else {
					return thumbnailOrNoVideo;
				}
			}
		case 6:
			return thumbnailOrNoVideo;
		case 7:
			return thumbnailOrNoVideo;
		case 8:
			return thumbnailOrNoVideo;
		case 9:
			return thumbnailOrNoVideo;
		case 10:
			return thumbnailOrNoVideo;
		case 11:
			return thumbnailOrNoVideo;
		case 12:
			return thumbnailOrNoVideo;
		default:
			return thumbnailOrNoVideo;
	}
};
var $author$project$Call$displayMode = F4($author$project$Call$displayMode$);
var $author$project$Call$ToJs_StartLocalStream = function (a) {
	return {$: 11, a: a};
};
var $author$project$Call$ToJs_StopLocalStream = {$: 12};
var $author$project$Call$showLocalVideo = function (displayMode2) {
	switch (displayMode2.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return true;
		default:
			return true;
	}
};
var $author$project$Call$ToJs_DebugDataRequest = {$: 14};
var $author$project$Call$ToJs_GetMediaDevices = {$: 10};
var $author$project$Call$ToJs_LeaveCall = {$: 1};
var $author$project$Call$ToJs_PeerJoined = function (a) {
	return {$: 2, a: a};
};
var $author$project$Call$ToJs_PeerLeft = function (a) {
	return {$: 3, a: a};
};
var $author$project$Call$ToJs_SetAudioInputEnabled = function (a) {
	return {$: 4, a: a};
};
var $author$project$Call$ToJs_SetInput$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$Call$ToJs_SetInput = F2($author$project$Call$ToJs_SetInput$);
var $author$project$Call$ToJs_SetPeerVideoInputEnabled$ = function (a, b) {
	return {$: 7, a: a, b: b};
};
var $author$project$Call$ToJs_SetPeerVideoInputEnabled = F2($author$project$Call$ToJs_SetPeerVideoInputEnabled$);
var $author$project$Call$ToJs_SetVideoInputEnabled = function (a) {
	return {$: 6, a: a};
};
var $author$project$Call$ToJs_SetVolume$ = function (a, b) {
	return {$: 13, a: a, b: b};
};
var $author$project$Call$ToJs_SetVolume = F2($author$project$Call$ToJs_SetVolume$);
var $author$project$Call$ToJs_StartCall = function (a) {
	return {$: 0, a: a};
};
var $author$project$Call$ToJs_StartRecording = function (a) {
	return {$: 15, a: a};
};
var $author$project$Call$ToJs_StartScreenShare = {$: 8};
var $author$project$Call$ToJs_StopRecording = {$: 16};
var $author$project$Call$ToJs_StopScreenShare = {$: 9};
var $author$project$Call$peerJoinedArgsCodec = $miniBill$elm_codec$Codec$buildObject(
	$miniBill$elm_codec$Codec$field$(
		'connectionId',
		function ($) {
			return $.connectionId;
		},
		$author$project$Call$connectionIdCodec,
		$miniBill$elm_codec$Codec$object(
			function (c) {
				return {connectionId: c};
			})));
var $author$project$Call$StartCallData$ = function (roomId, websocketUrl, selfId, audioInput, videoInput, audioInputEnabled, videoInputEnabled) {
	return {audioInput: audioInput, audioInputEnabled: audioInputEnabled, roomId: roomId, selfId: selfId, videoInput: videoInput, videoInputEnabled: videoInputEnabled, websocketUrl: websocketUrl};
};
var $author$project$Call$StartCallData = F7($author$project$Call$StartCallData$);
var $miniBill$elm_codec$Codec$nullable = function (codec) {
	return {
		decoder: $elm$json$Json$Decode$nullable(
			$miniBill$elm_codec$Codec$decoder(codec)),
		encoder: function (v) {
			if (v.$ === 1) {
				return $elm$json$Json$Encode$null;
			} else {
				var x = v.a;
				return A2($miniBill$elm_codec$Codec$encoder, codec, x);
			}
		}
	};
};
var $author$project$Call$startCallDataCodec = $miniBill$elm_codec$Codec$buildObject(
	$miniBill$elm_codec$Codec$field$(
		'videoInputEnabled',
		function ($) {
			return $.videoInputEnabled;
		},
		$miniBill$elm_codec$Codec$bool,
		$miniBill$elm_codec$Codec$field$(
			'audioInputEnabled',
			function ($) {
				return $.audioInputEnabled;
			},
			$miniBill$elm_codec$Codec$bool,
			$miniBill$elm_codec$Codec$field$(
				'videoInput',
				function ($) {
					return $.videoInput;
				},
				$miniBill$elm_codec$Codec$nullable($author$project$IdString$codec),
				$miniBill$elm_codec$Codec$field$(
					'audioInput',
					function ($) {
						return $.audioInput;
					},
					$miniBill$elm_codec$Codec$nullable($author$project$IdString$codec),
					$miniBill$elm_codec$Codec$field$(
						'selfId',
						function ($) {
							return $.selfId;
						},
						$author$project$Call$otherClientIdCodec,
						$miniBill$elm_codec$Codec$field$(
							'websocketUrl',
							function ($) {
								return $.websocketUrl;
							},
							$miniBill$elm_codec$Codec$string,
							$miniBill$elm_codec$Codec$field$(
								'roomId',
								function ($) {
									return $.roomId;
								},
								$author$project$Call$roomIdCodec,
								$miniBill$elm_codec$Codec$object($author$project$Call$StartCallData)))))))));
var $author$project$Call$StartLocalStreamData$ = function (audioInput, videoInput, audioInputEnabled, videoInputEnabled) {
	return {audioInput: audioInput, audioInputEnabled: audioInputEnabled, videoInput: videoInput, videoInputEnabled: videoInputEnabled};
};
var $author$project$Call$StartLocalStreamData = F4($author$project$Call$StartLocalStreamData$);
var $author$project$Call$startLocalStreamDataCodec = $miniBill$elm_codec$Codec$buildObject(
	$miniBill$elm_codec$Codec$field$(
		'videoInputEnabled',
		function ($) {
			return $.videoInputEnabled;
		},
		$miniBill$elm_codec$Codec$bool,
		$miniBill$elm_codec$Codec$field$(
			'audioInputEnabled',
			function ($) {
				return $.audioInputEnabled;
			},
			$miniBill$elm_codec$Codec$bool,
			$miniBill$elm_codec$Codec$field$(
				'videoInput',
				function ($) {
					return $.videoInput;
				},
				$miniBill$elm_codec$Codec$nullable($author$project$IdString$codec),
				$miniBill$elm_codec$Codec$field$(
					'audioInput',
					function ($) {
						return $.audioInput;
					},
					$miniBill$elm_codec$Codec$nullable($author$project$IdString$codec),
					$miniBill$elm_codec$Codec$object($author$project$Call$StartLocalStreamData))))));
var $author$project$Call$StartRecordingData$ = function (recordingId, userName) {
	return {recordingId: recordingId, userName: userName};
};
var $author$project$Call$StartRecordingData = F2($author$project$Call$StartRecordingData$);
var $author$project$Call$startRecordingDataCodec = $miniBill$elm_codec$Codec$buildObject(
	$miniBill$elm_codec$Codec$field$(
		'userName',
		function ($) {
			return $.userName;
		},
		$miniBill$elm_codec$Codec$string,
		$miniBill$elm_codec$Codec$field$(
			'recordingId',
			function ($) {
				return $.recordingId;
			},
			$miniBill$elm_codec$Codec$string,
			$miniBill$elm_codec$Codec$object($author$project$Call$StartRecordingData))));
var $author$project$Call$voiceChatToJsCodec = $miniBill$elm_codec$Codec$buildCustom(
	A3(
		$miniBill$elm_codec$Codec$variant0,
		'stop-recording',
		$author$project$Call$ToJs_StopRecording,
		A4(
			$miniBill$elm_codec$Codec$variant1,
			'start-recording',
			$author$project$Call$ToJs_StartRecording,
			$author$project$Call$startRecordingDataCodec,
			A3(
				$miniBill$elm_codec$Codec$variant0,
				'debug-data-request',
				$author$project$Call$ToJs_DebugDataRequest,
				A5(
					$miniBill$elm_codec$Codec$variant2,
					'set-volume',
					$author$project$Call$ToJs_SetVolume,
					$author$project$Call$connectionIdCodec,
					$miniBill$elm_codec$Codec$float,
					A3(
						$miniBill$elm_codec$Codec$variant0,
						'stop-local-stream',
						$author$project$Call$ToJs_StopLocalStream,
						A4(
							$miniBill$elm_codec$Codec$variant1,
							'start-local-stream',
							$author$project$Call$ToJs_StartLocalStream,
							$author$project$Call$startLocalStreamDataCodec,
							A3(
								$miniBill$elm_codec$Codec$variant0,
								'get-media-devices',
								$author$project$Call$ToJs_GetMediaDevices,
								A3(
									$miniBill$elm_codec$Codec$variant0,
									'stop-screen-share',
									$author$project$Call$ToJs_StopScreenShare,
									A3(
										$miniBill$elm_codec$Codec$variant0,
										'start-screen-share',
										$author$project$Call$ToJs_StartScreenShare,
										A5(
											$miniBill$elm_codec$Codec$variant2,
											'set-peer-video-input-enabled',
											$author$project$Call$ToJs_SetPeerVideoInputEnabled,
											$author$project$Call$connectionIdCodec,
											$miniBill$elm_codec$Codec$bool,
											A4(
												$miniBill$elm_codec$Codec$variant1,
												'set-video-input-enabled',
												$author$project$Call$ToJs_SetVideoInputEnabled,
												$miniBill$elm_codec$Codec$bool,
												A5(
													$miniBill$elm_codec$Codec$variant2,
													'set-input',
													$author$project$Call$ToJs_SetInput,
													$miniBill$elm_codec$Codec$bool,
													$author$project$IdString$codec,
													A4(
														$miniBill$elm_codec$Codec$variant1,
														'set-audio-input-enabled',
														$author$project$Call$ToJs_SetAudioInputEnabled,
														$miniBill$elm_codec$Codec$bool,
														A4(
															$miniBill$elm_codec$Codec$variant1,
															'peer-left',
															$author$project$Call$ToJs_PeerLeft,
															$author$project$Call$connectionIdCodec,
															A4(
																$miniBill$elm_codec$Codec$variant1,
																'peer-joined',
																$author$project$Call$ToJs_PeerJoined,
																$author$project$Call$peerJoinedArgsCodec,
																A3(
																	$miniBill$elm_codec$Codec$variant0,
																	'leave-call',
																	$author$project$Call$ToJs_LeaveCall,
																	A4(
																		$miniBill$elm_codec$Codec$variant1,
																		'start-call',
																		$author$project$Call$ToJs_StartCall,
																		$author$project$Call$startCallDataCodec,
																		$miniBill$elm_codec$Codec$custom(
																			function (eA) {
																				return function (eB) {
																					return function (eC) {
																						return function (eD) {
																							return function (eF) {
																								return function (eG) {
																									return function (eH) {
																										return function (eI) {
																											return function (eO) {
																												return function (eP) {
																													return function (eJ) {
																														return function (eK) {
																															return function (eL) {
																																return function (eM) {
																																	return function (eN) {
																																		return function (eQ) {
																																			return function (eR) {
																																				return function (value) {
																																					switch (value.$) {
																																						case 0:
																																							var a = value.a;
																																							return eA(a);
																																						case 1:
																																							return eB;
																																						case 2:
																																							var a = value.a;
																																							return eC(a);
																																						case 3:
																																							var a = value.a;
																																							return eD(a);
																																						case 4:
																																							var a = value.a;
																																							return eF(a);
																																						case 5:
																																							var a = value.a;
																																							var b = value.b;
																																							return A2(eG, a, b);
																																						case 6:
																																							var a = value.a;
																																							return eH(a);
																																						case 7:
																																							var a = value.a;
																																							var b = value.b;
																																							return A2(eI, a, b);
																																						case 8:
																																							return eO;
																																						case 9:
																																							return eP;
																																						case 10:
																																							return eJ;
																																						case 11:
																																							var a = value.a;
																																							return eK(a);
																																						case 12:
																																							return eL;
																																						case 13:
																																							var a = value.a;
																																							var b = value.b;
																																							return A2(eM, a, b);
																																						case 14:
																																							return eN;
																																						case 15:
																																							var a = value.a;
																																							return eQ(a);
																																						default:
																																							return eR;
																																					}
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			})))))))))))))))))));
var $author$project$Call$voice_chat_to_js = _Platform_outgoingPort('voice_chat_to_js', $elm$core$Basics$identity);
var $author$project$Call$toJs = function (msg) {
	return A3(
		$lamdera$program_test$Effect$Command$sendToJs,
		'voice_chat_to_js',
		$author$project$Call$voice_chat_to_js,
		A2($miniBill$elm_codec$Codec$encoder, $author$project$Call$voiceChatToJsCodec, msg));
};
var $author$project$Call$displayModeChangeCmd$ = function (displayModeOld, displayModeNew, model) {
	var _v0 = _Utils_Tuple2(
		$author$project$Call$showLocalVideo(displayModeOld),
		$author$project$Call$showLocalVideo(displayModeNew));
	if (_v0.a) {
		if (_v0.b) {
			return $lamdera$program_test$Effect$Command$none;
		} else {
			return $author$project$Call$toJs($author$project$Call$ToJs_StopLocalStream);
		}
	} else {
		if (!_v0.b) {
			return $lamdera$program_test$Effect$Command$none;
		} else {
			return $author$project$Call$toJs(
				$author$project$Call$ToJs_StartLocalStream(
					{audioInput: model.selectedAudioInputDevice, audioInputEnabled: model.remoteCallData.audioInputEnabled, videoInput: model.selectedVideoInputDevice, videoInputEnabled: model.remoteCallData.videoInputEnabled}));
		}
	}
};
var $author$project$Call$displayModeChangeCmd = F3($author$project$Call$displayModeChangeCmd$);
var $author$project$MyUi$isMobile = function (model) {
	return $author$project$Coord$xRaw(model.windowSize) < 700;
};
var $author$project$Frontend$checkCallDisplayModeChange$ = function (modelOld, modelNew) {
	var _v0 = _Utils_Tuple2(modelOld.loginStatus, modelNew.loginStatus);
	if (_v0.a.$ === 1) {
		if (!_v0.b.$) {
			var loggedInNew = _v0.b.a;
			var localNew = $author$project$Local$model(loggedInNew.localState);
			return $author$project$Call$displayModeChangeCmd$(
				$author$project$Call$NoVideo,
				$author$project$Call$displayMode$(
					$author$project$MyUi$isMobile(modelNew),
					localNew.localUser.session.userId,
					modelNew.route,
					localNew.calls),
				loggedInNew.voiceChat);
		} else {
			return $lamdera$program_test$Effect$Command$none;
		}
	} else {
		if (!_v0.b.$) {
			var loggedInOld = _v0.a.a;
			var loggedInNew = _v0.b.a;
			var localOld = $author$project$Local$model(loggedInOld.localState);
			var localNew = $author$project$Local$model(loggedInNew.localState);
			return $author$project$Call$displayModeChangeCmd$(
				$author$project$Call$displayMode$(
					$author$project$MyUi$isMobile(modelOld),
					localOld.localUser.session.userId,
					modelOld.route,
					localOld.calls),
				$author$project$Call$displayMode$(
					$author$project$MyUi$isMobile(modelNew),
					localNew.localUser.session.userId,
					modelNew.route,
					localNew.calls),
				loggedInNew.voiceChat);
		} else {
			var loggedInOld = _v0.a.a;
			var localOld = $author$project$Local$model(loggedInOld.localState);
			return $author$project$Call$displayModeChangeCmd$(
				$author$project$Call$displayMode$(
					$author$project$MyUi$isMobile(modelOld),
					localOld.localUser.session.userId,
					modelOld.route,
					localOld.calls),
				$author$project$Call$NoVideo,
				loggedInOld.voiceChat);
		}
	}
};
var $author$project$Frontend$checkCallDisplayModeChange = F2($author$project$Frontend$checkCallDisplayModeChange$);
var $author$project$Call$connectionIdToString = function (_v0) {
	var otherClientId = _v0.otherClientId;
	var roomId = _v0.roomId;
	return function () {
		if (!roomId.$) {
			var otherUserId = roomId.a.otherUserId;
			return $author$project$Id$toString(otherUserId);
		} else {
			var channelId = roomId.a.channelId;
			var guildId = roomId.a.guildId;
			return 'guild-' + ($author$project$Id$toString(guildId) + ('-' + $author$project$Id$toString(channelId)));
		}
	}() + (' ' + $author$project$Call$otherUserIdToString(otherClientId));
};
var $author$project$Pages$Home$previewGuildId = $author$project$Id$fromInt(0);
var $author$project$Pages$Home$previewPetPicsChannelId = $author$project$Id$fromInt(1);
var $author$project$Pages$Home$previewCallId = $author$project$Call$GuildRoomId(
	{channelId: $author$project$Pages$Home$previewPetPicsChannelId, guildId: $author$project$Pages$Home$previewGuildId});
var $author$project$Pages$Home$previewCallConnectionId = function (peer) {
	return {otherClientId: peer, roomId: $author$project$Pages$Home$previewCallId};
};
var $author$project$Pages$Home$previewCallMutedPeer = _Utils_Tuple2(
	$author$project$Id$fromInt(2),
	$lamdera$program_test$Effect$Lamdera$clientIdFromString('previewCall2'));
var $author$project$Pages$Home$previewCallPeers = $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
	_Utils_Tuple2(
		$author$project$Id$fromInt(1),
		$lamdera$program_test$Effect$Lamdera$clientIdFromString('previewCall1')),
	_List_fromArray(
		[
			$author$project$Pages$Home$previewCallMutedPeer,
			_Utils_Tuple2(
			$author$project$Id$fromInt(3),
			$lamdera$program_test$Effect$Lamdera$clientIdFromString('previewCall3'))
		]));
var $author$project$Pages$Home$previewContainerId = $lamdera$program_test$Effect$Browser$Dom$id('homePage_preview');
var $author$project$Ports$call_preview_images_to_js = _Platform_outgoingPort('call_preview_images_to_js', $elm$core$Basics$identity);
var $lamdera$program_test$Effect$Browser$Dom$idToString = function (_v0) {
	var htmlId = _v0;
	return htmlId;
};
var $author$project$Ports$setCallPreviewImages$ = function (containerId, images) {
	return A3(
		$lamdera$program_test$Effect$Command$sendToJs,
		'call_preview_images_to_js',
		$author$project$Ports$call_preview_images_to_js,
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'containerId',
					$elm$json$Json$Encode$string(
						$lamdera$program_test$Effect$Browser$Dom$idToString(containerId))),
					_Utils_Tuple2(
					'images',
					$elm$json$Json$Encode$list$(
						function (image) {
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'htmlId',
										$elm$json$Json$Encode$string(image.htmlId)),
										_Utils_Tuple2(
										'url',
										$elm$json$Json$Encode$string(image.url))
									]));
						},
						images))
				])));
};
var $author$project$Ports$setCallPreviewImages = F2($author$project$Ports$setCallPreviewImages$);
var $author$project$Pages$Home$callPreviewImages = $author$project$Ports$setCallPreviewImages$(
	$author$project$Pages$Home$previewContainerId,
	A2(
		$elm$core$List$cons,
		{htmlId: $author$project$Call$localVideoNodeId, url: '/cacheable/call-preview3.webp'},
		$elm$core$List$indexedMap$(
			F2(
				function (index, peer) {
					return {
						htmlId: $author$project$Call$connectionIdToString(
							$author$project$Pages$Home$previewCallConnectionId(peer)),
						url: '/cacheable/call-preview' + ($elm$core$String$fromInt(index) + '.webp')
					};
				}),
			$mgold$elm_nonempty_list$List$Nonempty$toList($author$project$Pages$Home$previewCallPeers))));
var $author$project$Frontend$callPreviewShown = function (model) {
	var _v0 = _Utils_Tuple2(model.route, model.loginStatus);
	if ((!_v0.a.$) && (_v0.b.$ === 1)) {
		var loginForm = _v0.b.a.loginForm;
		return _Utils_eq(loginForm, $elm$core$Maybe$Nothing);
	} else {
		return false;
	}
};
var $author$project$Frontend$checkCallPreviewShown$ = function (modelOld, modelNew) {
	return ((!$author$project$Frontend$callPreviewShown(modelOld)) && $author$project$Frontend$callPreviewShown(modelNew)) ? $author$project$Pages$Home$callPreviewImages : $lamdera$program_test$Effect$Command$none;
};
var $author$project$Frontend$checkCallPreviewShown = F2($author$project$Frontend$checkCallPreviewShown$);
var $author$project$Call$recordingChangeCmd$ = function (userName, recordingIdOld, recordingIdNew) {
	if (_Utils_eq(recordingIdOld, recordingIdNew)) {
		return $lamdera$program_test$Effect$Command$none;
	} else {
		if (!recordingIdNew.$) {
			var recordingId2 = recordingIdNew.a;
			return $author$project$Call$toJs(
				$author$project$Call$ToJs_StartRecording(
					{recordingId: recordingId2, userName: userName}));
		} else {
			return $author$project$Call$toJs($author$project$Call$ToJs_StopRecording);
		}
	}
};
var $author$project$Call$recordingChangeCmd = F3($author$project$Call$recordingChangeCmd$);
var $author$project$Call$recordingIdToString$ = function (sharedCallId, startedAt) {
	return function () {
		if (!sharedCallId.$) {
			var dmChannelId = sharedCallId.a;
			return 'dm-' + $author$project$DmChannelId$toString(dmChannelId);
		} else {
			var id = sharedCallId.a;
			return 'guild-' + ($author$project$Id$toString(id.guildId) + ('-' + $author$project$Id$toString(id.channelId)));
		}
	}() + ('-' + $elm$core$String$fromInt(
		$lamdera$program_test$Effect$Time$posixToMillis(startedAt)));
};
var $author$project$Call$recordingIdToString = F2($author$project$Call$recordingIdToString$);
var $author$project$Call$SharedDmCall = function (a) {
	return {$: 0, a: a};
};
var $author$project$Call$SharedGuildCall = function (a) {
	return {$: 1, a: a};
};
var $author$project$Call$toSharedCallId$ = function (currentUserId, callId) {
	if (!callId.$) {
		var id = callId.a;
		return $author$project$Call$SharedDmCall(
			$author$project$DmChannelId$fromUserIds$(currentUserId, id.otherUserId));
	} else {
		var id = callId.a;
		return $author$project$Call$SharedGuildCall(id);
	}
};
var $author$project$Call$toSharedCallId = F2($author$project$Call$toSharedCallId$);
var $author$project$Call$recordingId$ = function (currentUserId, local) {
	var _v0 = local.currentRoom;
	if (!_v0.$) {
		var callId = _v0.a;
		var _v1 = $lamdera$containers$SeqDict$get$(callId, local.recordings);
		if (!_v1.$) {
			switch (_v1.a.$) {
				case 2:
					var since = _v1.a.a;
					return $elm$core$Maybe$Just(
						$author$project$Call$recordingIdToString$(
							$author$project$Call$toSharedCallId$(currentUserId, callId),
							since));
				case 0:
					return $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Call$recordingId = F2($author$project$Call$recordingId$);
var $author$project$PersonName$toString = function (_v0) {
	var a = _v0;
	return $MartinSStewart$elm_nonempty_string$String$Nonempty$toString(a);
};
var $author$project$Frontend$checkCallRecordingChange$ = function (modelOld, modelNew) {
	var _v0 = _Utils_Tuple2(modelOld.loginStatus, modelNew.loginStatus);
	if (!_v0.a.$) {
		if (!_v0.b.$) {
			var loggedInOld = _v0.a.a;
			var loggedInNew = _v0.b.a;
			var localOld = $author$project$Local$model(loggedInOld.localState);
			var localNew = $author$project$Local$model(loggedInNew.localState);
			return $author$project$Call$recordingChangeCmd$(
				$author$project$PersonName$toString(localNew.localUser.user.name),
				$author$project$Call$recordingId$(localOld.localUser.session.userId, localOld.calls),
				$author$project$Call$recordingId$(localNew.localUser.session.userId, localNew.calls));
		} else {
			var loggedInOld = _v0.a.a;
			var localOld = $author$project$Local$model(loggedInOld.localState);
			return $author$project$Call$recordingChangeCmd$(
				$author$project$PersonName$toString(localOld.localUser.user.name),
				$author$project$Call$recordingId$(localOld.localUser.session.userId, localOld.calls),
				$elm$core$Maybe$Nothing);
		}
	} else {
		if (!_v0.b.$) {
			var loggedInNew = _v0.b.a;
			var localNew = $author$project$Local$model(loggedInNew.localState);
			return $author$project$Call$recordingChangeCmd$(
				$author$project$PersonName$toString(localNew.localUser.user.name),
				$elm$core$Maybe$Nothing,
				$author$project$Call$recordingId$(localNew.localUser.session.userId, localNew.calls));
		} else {
			return $lamdera$program_test$Effect$Command$none;
		}
	}
};
var $author$project$Frontend$checkCallRecordingChange = F2($author$project$Frontend$checkCallRecordingChange$);
var $author$project$Audio$AudioCmdGroup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Audio$cmdNone = $author$project$Audio$AudioCmdGroup(_List_Nil);
var $author$project$MessageInput$isPress = function (msg) {
	switch (msg.$) {
		case 0:
			return true;
		case 1:
			return false;
		case 2:
			return true;
		case 3:
			return false;
		case 4:
			return false;
		case 5:
			return true;
		case 6:
			return true;
		case 7:
			return true;
		case 8:
			return true;
		case 9:
			return false;
		case 10:
			return false;
		case 11:
			return false;
		case 12:
			return false;
		case 13:
			return false;
		default:
			return false;
	}
};
var $author$project$TextEditor$isPress = function (msg) {
	switch (msg.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return false;
		case 3:
			return false;
		default:
			return true;
	}
};
var $author$project$AiChat$isPressMsg = function (msg) {
	switch (msg.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return false;
		case 3:
			return true;
		case 4:
			return true;
		case 5:
			return true;
		case 6:
			return true;
		case 7:
			return true;
		case 8:
			return true;
		case 9:
			return false;
		case 10:
			return true;
		case 11:
			return true;
		case 12:
			return false;
		case 13:
			return false;
		case 14:
			return false;
		case 15:
			return false;
		case 16:
			return false;
		default:
			return false;
	}
};
var $author$project$Call$isPressMsg = function (msg) {
	switch (msg.$) {
		case 0:
			return false;
		case 1:
			return false;
		case 2:
			return true;
		case 3:
			return true;
		case 4:
			return true;
		case 5:
			return true;
		case 6:
			return true;
		case 7:
			return true;
		case 8:
			return true;
		case 9:
			return true;
		case 10:
			return true;
		case 11:
			return false;
		case 12:
			return false;
		case 13:
			return false;
		case 14:
			return false;
		case 15:
			return true;
		case 16:
			return true;
		case 17:
			return true;
		default:
			return false;
	}
};
var $author$project$Editable$isPressMsg = function (msg) {
	if (!msg.$) {
		return false;
	} else {
		return true;
	}
};
var $author$project$ImageEditor$isPressMsg = function (msg) {
	switch (msg.$) {
		case 0:
			return true;
		case 1:
			return false;
		case 2:
			return false;
		case 3:
			return false;
		case 4:
			return false;
		case 5:
			return false;
		case 6:
			return false;
		case 7:
			return false;
		case 8:
			return false;
		case 9:
			return false;
		case 10:
			return true;
		case 11:
			return true;
		default:
			return false;
	}
};
var $author$project$ImageViewer$isPressMsg = function (msg) {
	switch (msg.$) {
		case 0:
			return true;
		case 1:
			return true;
		case 2:
			return true;
		case 3:
			return false;
		case 4:
			return false;
		case 5:
			return false;
		case 6:
			return false;
		case 7:
			return false;
		case 8:
			return false;
		case 9:
			return false;
		case 10:
			return false;
		default:
			return false;
	}
};
var $author$project$LoginForm$isPressMsg = function (msg) {
	switch (msg.$) {
		case 0:
			return true;
		case 1:
			return true;
		case 2:
			return false;
		case 3:
			return false;
		case 4:
			return false;
		case 5:
			return false;
		default:
			return true;
	}
};
var $author$project$MessageView$isPressMsg = function (msg) {
	switch (msg.$) {
		case 0:
			return true;
		case 1:
			return true;
		case 2:
			return true;
		case 3:
			return false;
		case 4:
			return false;
		case 5:
			return false;
		case 6:
			return true;
		case 7:
			return true;
		case 8:
			return true;
		case 9:
			return true;
		case 10:
			return true;
		case 11:
			return true;
		case 12:
			return true;
		case 13:
			return true;
		case 14:
			return true;
		case 15:
			return false;
		case 16:
			return true;
		case 17:
			return true;
		case 18:
			return true;
		case 19:
			return true;
		case 20:
			return true;
		case 21:
			return true;
		case 22:
			return true;
		case 23:
			return true;
		case 24:
			return true;
		case 25:
			return true;
		case 26:
			return true;
		default:
			return true;
	}
};
var $author$project$RecoveryLogin$isPressMsg = function (msg) {
	if (!msg.$) {
		return false;
	} else {
		return true;
	}
};
var $author$project$TwoFactorAuthentication$isPressMsg = function (msg) {
	switch (msg.$) {
		case 0:
			return true;
		case 1:
			return true;
		case 2:
			return false;
		case 3:
			return true;
		case 4:
			return true;
		default:
			return false;
	}
};
var $author$project$Emoji$isPressed = function (msg) {
	switch (msg.$) {
		case 0:
			return true;
		case 3:
			return true;
		case 1:
			return true;
		case 2:
			return false;
		case 4:
			return true;
		case 5:
			return false;
		case 6:
			return false;
		case 7:
			return false;
		case 8:
			return false;
		case 9:
			return true;
		default:
			return false;
	}
};
var $author$project$FrontendExtra$isPressMsg = function (msg) {
	switch (msg.$) {
		case 0:
			return false;
		case 1:
			return false;
		case 2:
			return false;
		case 3:
			return false;
		case 4:
			var loginFormMsg = msg.a;
			return $author$project$LoginForm$isPressMsg(loginFormMsg);
		case 5:
			var recoveryLoginMsg = msg.a;
			return $author$project$RecoveryLogin$isPressMsg(recoveryLoginMsg);
		case 6:
			return true;
		case 7:
			return true;
		case 8:
			return false;
		case 9:
			return true;
		case 10:
			return false;
		case 11:
			return false;
		case 12:
			return true;
		case 14:
			return false;
		case 15:
			return false;
		case 16:
			return false;
		case 17:
			return true;
		case 18:
			return true;
		case 19:
			return true;
		case 20:
			return false;
		case 21:
			return true;
		case 22:
			return true;
		case 23:
			return true;
		case 24:
			return true;
		case 25:
			return false;
		case 26:
			return false;
		case 27:
			return true;
		case 28:
			return true;
		case 30:
			return true;
		case 29:
			return true;
		case 31:
			return true;
		case 32:
			return false;
		case 33:
			return true;
		case 34:
			return true;
		case 35:
			return false;
		case 36:
			return true;
		case 37:
			return false;
		case 78:
			return false;
		case 79:
			return false;
		case 38:
			return false;
		case 39:
			return false;
		case 40:
			return false;
		case 41:
			return false;
		case 42:
			return true;
		case 44:
			return true;
		case 45:
			var emojiMsg = msg.a;
			return $author$project$Emoji$isPressed(emojiMsg);
		case 46:
			return true;
		case 48:
			return true;
		case 49:
			return false;
		case 50:
			return false;
		case 51:
			return false;
		case 52:
			return false;
		case 53:
			return false;
		case 54:
			return false;
		case 55:
			return false;
		case 56:
			return false;
		case 57:
			return true;
		case 60:
			return false;
		case 61:
			return true;
		case 62:
			return true;
		case 63:
			return true;
		case 64:
			return true;
		case 67:
			return false;
		case 68:
			return true;
		case 69:
			return true;
		case 70:
			return true;
		case 71:
			return false;
		case 72:
			return true;
		case 73:
			return true;
		case 75:
			var twoFactorMsg = msg.a;
			return $author$project$TwoFactorAuthentication$isPressMsg(twoFactorMsg);
		case 76:
			var aiChatMsg = msg.a;
			return $author$project$AiChat$isPressMsg(aiChatMsg);
		case 77:
			return true;
		case 81:
			var editableMsg = msg.a;
			return $author$project$Editable$isPressMsg(editableMsg);
		case 82:
			var imageEditorMsg = msg.a;
			return $author$project$ImageEditor$isPressMsg(imageEditorMsg);
		case 83:
			var imageEditorMsg = msg.b;
			return $author$project$ImageEditor$isPressMsg(imageEditorMsg);
		case 84:
			return false;
		case 13:
			return false;
		case 85:
			return false;
		case 86:
			return false;
		case 87:
			return true;
		case 90:
			return true;
		case 93:
			return false;
		case 94:
			return false;
		case 95:
			return false;
		case 47:
			return true;
		case 96:
			var messageViewMsg = msg.c;
			return $author$project$MessageView$isPressMsg(messageViewMsg);
		case 97:
			var imageViewerMsg = msg.a;
			return $author$project$ImageViewer$isPressMsg(imageViewerMsg);
		case 98:
			return false;
		case 99:
			return true;
		case 100:
			return true;
		case 101:
			return true;
		case 102:
			return true;
		case 103:
			return true;
		case 104:
			return true;
		case 105:
			return true;
		case 108:
			return false;
		case 109:
			return false;
		case 88:
			return true;
		case 91:
			return true;
		case 110:
			return true;
		case 58:
			return true;
		case 59:
			return true;
		case 111:
			return true;
		case 112:
			return true;
		case 186:
			return false;
		case 113:
			return true;
		case 114:
			return true;
		case 115:
			return true;
		case 116:
			return true;
		case 117:
			return true;
		case 118:
			return true;
		case 119:
			return true;
		case 120:
			return true;
		case 121:
			return false;
		case 122:
			return false;
		case 123:
			return false;
		case 124:
			return false;
		case 125:
			return false;
		case 126:
			return false;
		case 127:
			return false;
		case 128:
			var textEditorMsg = msg.a;
			return $author$project$TextEditor$isPress(textEditorMsg);
		case 129:
			return true;
		case 130:
			return true;
		case 131:
			return true;
		case 132:
			return true;
		case 133:
			return true;
		case 134:
			return false;
		case 135:
			return false;
		case 106:
			return true;
		case 107:
			return true;
		case 136:
			return true;
		case 137:
			return true;
		case 138:
			return false;
		case 139:
			return true;
		case 140:
			return false;
		case 141:
			return true;
		case 142:
			return true;
		case 143:
			return true;
		case 144:
			return true;
		case 145:
			return true;
		case 146:
			var messageInputMsg = msg.c;
			return $author$project$MessageInput$isPress(messageInputMsg);
		case 147:
			var messageInputMsg = msg.c;
			return $author$project$MessageInput$isPress(messageInputMsg);
		case 148:
			return false;
		case 149:
			return false;
		case 43:
			return true;
		case 151:
			return false;
		case 152:
			return false;
		case 153:
			return false;
		case 89:
			return true;
		case 92:
			return true;
		case 154:
			return false;
		case 155:
			return false;
		case 156:
			var voiceChatMsg = msg.a;
			return $author$project$Call$isPressMsg(voiceChatMsg);
		case 157:
			return true;
		case 158:
			return false;
		case 159:
			return false;
		case 160:
			return false;
		case 80:
			var spectatorMsg = msg.a;
			switch (spectatorMsg.$) {
				case 0:
					return true;
				case 1:
					return true;
				case 2:
					return false;
				default:
					return true;
			}
		case 161:
			return true;
		case 162:
			return true;
		case 163:
			return false;
		case 164:
			var drawingMsg = msg.a;
			switch (drawingMsg.$) {
				case 3:
					return true;
				case 4:
					return true;
				default:
					return false;
			}
		case 165:
			return true;
		case 166:
			return false;
		case 168:
			return false;
		case 169:
			return false;
		case 170:
			return false;
		case 171:
			return true;
		case 74:
			return true;
		case 65:
			return true;
		case 172:
			return true;
		case 66:
			return true;
		case 173:
			return true;
		case 174:
			return true;
		case 175:
			return true;
		case 176:
			return true;
		case 177:
			return true;
		case 178:
			return true;
		case 179:
			return true;
		case 180:
			return true;
		case 181:
			return true;
		case 182:
			return true;
		case 183:
			var messageViewMsg = msg.c;
			return $author$project$MessageView$isPressMsg(messageViewMsg);
		case 184:
			var messageViewMsg = msg.d;
			return $author$project$MessageView$isPressMsg(messageViewMsg);
		case 150:
			return false;
		case 185:
			return false;
		case 187:
			return false;
		case 188:
			return false;
		case 189:
			return true;
		case 190:
			return true;
		case 191:
			return true;
		case 192:
			return true;
		default:
			return true;
	}
};
var $bburdette$toop$Toop$T4$ = function (a, b, c, d) {
	return {$: 0, a: a, b: b, c: c, d: d};
};
var $bburdette$toop$Toop$T4 = F4($bburdette$toop$Toop$T4$);
var $author$project$Types$AiChatToBackend = function (a) {
	return {$: 11, a: a};
};
var $author$project$Types$GotEmojiData = function (a) {
	return {$: 148, a: a};
};
var $author$project$Touch$NoDrag = {$: 0};
var $author$project$Types$NotLoggedIn = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$GotVersionNumber = function (a) {
	return {$: 135, a: a};
};
var $lamdera$program_test$Effect$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $lamdera$program_test$Effect$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $lamdera$program_test$Effect$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $lamdera$program_test$Effect$Http$ExpectString = function (a) {
	return {$: 0, a: a};
};
var $lamdera$program_test$Effect$Http$NetworkError = {$: 2};
var $lamdera$program_test$Effect$Http$Timeout = {$: 1};
var $lamdera$program_test$Effect$Http$expectJson$ = function (onResult, decoder) {
	return $lamdera$program_test$Effect$Http$ExpectString(
		function (response) {
			switch (response.$) {
				case 0:
					var s = response.a;
					return onResult(
						$elm$core$Result$Err(
							$lamdera$program_test$Effect$Http$BadUrl(s)));
				case 1:
					return onResult(
						$elm$core$Result$Err($lamdera$program_test$Effect$Http$Timeout));
				case 2:
					return onResult(
						$elm$core$Result$Err($lamdera$program_test$Effect$Http$NetworkError));
				case 3:
					var metadata = response.a;
					return onResult(
						$elm$core$Result$Err(
							$lamdera$program_test$Effect$Http$BadStatus(metadata.statusCode)));
				default:
					var body = response.b;
					var _v1 = A2($elm$json$Json$Decode$decodeString, decoder, body);
					if (_v1.$ === 1) {
						var jsonError = _v1.a;
						return onResult(
							$elm$core$Result$Err(
								$lamdera$program_test$Effect$Http$BadBody(
									$elm$json$Json$Decode$errorToString(jsonError))));
					} else {
						var value = _v1.a;
						return onResult(
							$elm$core$Result$Ok(value));
					}
			}
		});
};
var $lamdera$program_test$Effect$Http$expectJson = F2($lamdera$program_test$Effect$Http$expectJson$);
var $lamdera$program_test$Effect$Internal$EmptyBody = {$: 0};
var $lamdera$program_test$Effect$Http$emptyBody = $lamdera$program_test$Effect$Internal$EmptyBody;
var $lamdera$program_test$Effect$Http$BadStatus_$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $lamdera$program_test$Effect$Http$BadStatus_ = F2($lamdera$program_test$Effect$Http$BadStatus_$);
var $lamdera$program_test$Effect$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $lamdera$program_test$Effect$Http$GoodStatus_$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $lamdera$program_test$Effect$Http$GoodStatus_ = F2($lamdera$program_test$Effect$Http$GoodStatus_$);
var $lamdera$program_test$Effect$Http$NetworkError_ = {$: 2};
var $lamdera$program_test$Effect$Http$Timeout_ = {$: 1};
var $lamdera$program_test$Effect$Http$mapResponse = function (response) {
	switch (response.$) {
		case 0:
			var url = response.a;
			return $lamdera$program_test$Effect$Http$BadUrl_(url);
		case 1:
			return $lamdera$program_test$Effect$Http$Timeout_;
		case 2:
			return $lamdera$program_test$Effect$Http$NetworkError_;
		case 3:
			var metadata = response.a;
			var body = response.b;
			return $lamdera$program_test$Effect$Http$BadStatus_$(metadata, body);
		default:
			var metadata = response.a;
			var body = response.b;
			return $lamdera$program_test$Effect$Http$GoodStatus_$(metadata, body);
	}
};
var $lamdera$program_test$Effect$Task$succeed = $lamdera$program_test$Effect$Internal$Succeed;
var $lamdera$program_test$Effect$Http$taskHelper$ = function (isRisky, r, onRequestComplete) {
	return {body: r.body, headers: r.headers, isRisky: isRisky, method: r.method, onRequestComplete: onRequestComplete, timeout: r.timeout, tracker: $elm$core$Maybe$Nothing, url: r.url};
};
var $lamdera$program_test$Effect$Http$taskHelper = F3($lamdera$program_test$Effect$Http$taskHelper$);
var $lamdera$program_test$Effect$Http$requestHelper$ = function (isRisky, r) {
	var _v0 = r.tracker;
	if (!_v0.$) {
		var tracker = _v0.a;
		return $lamdera$program_test$Effect$Internal$HttpTrackedRequest(
			{
				body: r.body,
				expect: function () {
					var _v1 = r.expect;
					if (!_v1.$) {
						var onResult = _v1.a;
						return $lamdera$program_test$Effect$Internal$ExpectStringResponse(
							A2($elm$core$Basics$composeR, $lamdera$program_test$Effect$Http$mapResponse, onResult));
					} else {
						var onResult = _v1.a;
						return $lamdera$program_test$Effect$Internal$ExpectBytesResponse(
							A2($elm$core$Basics$composeR, $lamdera$program_test$Effect$Http$mapResponse, onResult));
					}
				}(),
				headers: r.headers,
				isRisky: isRisky,
				method: r.method,
				timeout: r.timeout,
				tracker: tracker,
				url: r.url
			});
	} else {
		return $lamdera$program_test$Effect$Internal$Task(
			function () {
				var _v2 = r.expect;
				if (!_v2.$) {
					var onResult = _v2.a;
					return $lamdera$program_test$Effect$Internal$HttpStringTask(
						$lamdera$program_test$Effect$Http$taskHelper$(
							isRisky,
							r,
							A2(
								$elm$core$Basics$composeR,
								$lamdera$program_test$Effect$Http$mapResponse,
								A2($elm$core$Basics$composeR, onResult, $lamdera$program_test$Effect$Task$succeed))));
				} else {
					var onResult = _v2.a;
					return $lamdera$program_test$Effect$Internal$HttpBytesTask(
						$lamdera$program_test$Effect$Http$taskHelper$(
							isRisky,
							r,
							A2(
								$elm$core$Basics$composeR,
								$lamdera$program_test$Effect$Http$mapResponse,
								A2($elm$core$Basics$composeR, onResult, $lamdera$program_test$Effect$Task$succeed))));
				}
			}());
	}
};
var $lamdera$program_test$Effect$Http$requestHelper = F2($lamdera$program_test$Effect$Http$requestHelper$);
var $lamdera$program_test$Effect$Http$request = function (r) {
	return $lamdera$program_test$Effect$Http$requestHelper$(false, r);
};
var $lamdera$program_test$Effect$Http$get = function (r) {
	return $lamdera$program_test$Effect$Http$request(
		{body: $lamdera$program_test$Effect$Http$emptyBody, expect: r.expect, headers: _List_Nil, method: 'GET', timeout: $elm$core$Maybe$Nothing, tracker: $elm$core$Maybe$Nothing, url: r.url});
};
var $author$project$Frontend$checkAppVersion = $lamdera$program_test$Effect$Http$get(
	{
		expect: $lamdera$program_test$Effect$Http$expectJson$(
			function (result) {
				return $author$project$Types$GotVersionNumber(
					$elm$core$Result$mapError$(
						function (_v0) {
							return 0;
						},
						result));
			},
			A2($elm$json$Json$Decode$field, 'v', $elm$json$Json$Decode$int)),
		url: '/_i'
	});
var $author$project$Ports$clear_browser_storage_to_js = _Platform_outgoingPort('clear_browser_storage_to_js', $elm$core$Basics$identity);
var $author$project$Ports$clearBrowserStorage = A3($lamdera$program_test$Effect$Command$sendToJs, 'clear_browser_storage_to_js', $author$project$Ports$clear_browser_storage_to_js, $elm$json$Json$Encode$null);
var $author$project$AiChat$LoadingAiModels = {$: 0};
var $author$project$AiChat$SendWithShiftEnter = 1;
var $author$project$AiChat$load_user_settings_to_js = _Platform_outgoingPort('load_user_settings_to_js', $elm$core$Basics$identity);
var $author$project$AiChat$loadUserSettingsToJs = A3($lamdera$program_test$Effect$Command$sendToJs, 'load_user_settings_to_js', $author$project$AiChat$load_user_settings_to_js, $elm$json$Json$Encode$null);
var $author$project$AiChat$init = _Utils_Tuple2(
	{aiModels: $author$project$AiChat$LoadingAiModels, chatHistory: '', debounceCounter: 0, message: '', pendingResponses: $lamdera$containers$SeqDict$empty, responseCounter: 0, selectedModels: _List_Nil, sendMessageWith: 1, showOptions: true},
	$author$project$AiChat$loadUserSettingsToJs);
var $author$project$RecoveryLogin$Model = $elm$core$Basics$identity;
var $author$project$RecoveryLogin$NotSubmitted = function (a) {
	return {$: 0, a: a};
};
var $author$project$RecoveryLogin$init = {
	password: '',
	submitStatus: $author$project$RecoveryLogin$NotSubmitted(false)
};
var $author$project$Internal$Model2$State = $elm$core$Basics$identity;
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $author$project$Ui$Anim$init = {added: $elm$core$Set$empty, keyframes: _List_Nil, rules: _List_Nil};
var $author$project$Route$ChannelSidebarNotDragging = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$EmojiSelectorHidden = {$: 0};
var $author$project$Types$NoFileDrag = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$NoMessageHover = {$: 0};
var $author$project$Scroll$ScrolledToBottom = 0;
var $author$project$Types$ScrolledToLogSection = {$: 11};
var $author$project$TwoFactorAuthentication$TwoFactorAlreadyComplete = function (a) {
	return {$: 4, a: a};
};
var $author$project$TwoFactorAuthentication$TwoFactorNotStarted = {$: 0};
var $lamdera$program_test$Effect$Task$andThen = $lamdera$program_test$Effect$Internal$andThen;
var $lamdera$program_test$Effect$Task$attempt$ = function (f, task) {
	return $lamdera$program_test$Effect$Internal$Task(
		A2(
			$lamdera$program_test$Effect$Task$mapError,
			A2($elm$core$Basics$composeR, $elm$core$Result$Err, f),
			A2(
				$lamdera$program_test$Effect$Task$map,
				A2($elm$core$Basics$composeR, $elm$core$Result$Ok, f),
				task)));
};
var $lamdera$program_test$Effect$Task$attempt = F2($lamdera$program_test$Effect$Task$attempt$);
var $author$project$Encryption$ToJs_DecryptManyMessages = function (a) {
	return {$: 3, a: a};
};
var $lamdera$codecs$Lamdera$Wire3$encodeBytes_ = _LamderaCodecs_encodeBytes;
var $author$project$Encryption$encryption_to_js = _Platform_outgoingPort('encryption_to_js', $lamdera$codecs$Lamdera$Wire3$encodeBytes_);
var $lamdera$program_test$Effect$Command$sendToJsBytes = $lamdera$program_test$Effect$Internal$PortBytes;
var $author$project$Encryption$ToJs_DecryptNewMessage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Encryption$ToJs_EncryptFile = function (a) {
	return {$: 5, a: a};
};
var $author$project$Encryption$ToJs_EncryptManyMessages = function (a) {
	return {$: 4, a: a};
};
var $author$project$Encryption$ToJs_EncryptNewMessage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Encryption$ToJs_StoreFileKeys = function (a) {
	return {$: 6, a: a};
};
var $author$project$Encryption$ToJs_StoreSharedSecret = function (a) {
	return {$: 0, a: a};
};
var $author$project$Encryption$toJsCodec = function (dataCodec) {
	return $author$project$Serialize$finishCustomType(
		A3(
			$author$project$Serialize$variant1,
			$author$project$Encryption$ToJs_StoreFileKeys,
			$author$project$Serialize$list(
				$author$project$Serialize$finishRecord(
					$author$project$Serialize$field$(
						function ($) {
							return $.key;
						},
						$author$project$Serialize$bytes,
						$author$project$Serialize$field$(
							function ($) {
								return $.fileHash;
							},
							$author$project$Serialize$string,
							$author$project$Serialize$record(
								F2(
									function (fileHash, key) {
										return {fileHash: fileHash, key: key};
									})))))),
			A3(
				$author$project$Serialize$variant1,
				$author$project$Encryption$ToJs_EncryptFile,
				$author$project$Serialize$finishRecord(
					$author$project$Serialize$field$(
						function ($) {
							return $.data;
						},
						$author$project$Serialize$bytes,
						$author$project$Serialize$field$(
							function ($) {
								return $.contentType;
							},
							$author$project$Serialize$string,
							$author$project$Serialize$field$(
								function ($) {
									return $.requestId;
								},
								$author$project$Id$codec,
								$author$project$Serialize$record(
									F3(
										function (requestId, contentType, data) {
											return {contentType: contentType, data: data, requestId: requestId};
										})))))),
				A3(
					$author$project$Serialize$variant1,
					$author$project$Encryption$ToJs_EncryptManyMessages,
					$author$project$Serialize$finishRecord(
						$author$project$Serialize$field$(
							function ($) {
								return $.data;
							},
							$author$project$Serialize$list($author$project$Serialize$bytes),
							$author$project$Serialize$field$(
								function ($) {
									return $.otherUserId;
								},
								$author$project$Id$codec,
								$author$project$Serialize$field$(
									function ($) {
										return $.requestId;
									},
									$author$project$Id$codec,
									$author$project$Serialize$record(
										F3(
											function (requestId, otherUserId, data) {
												return {data: data, otherUserId: otherUserId, requestId: requestId};
											})))))),
					A3(
						$author$project$Serialize$variant1,
						$author$project$Encryption$ToJs_DecryptManyMessages,
						$author$project$Serialize$finishRecord(
							$author$project$Serialize$field$(
								function ($) {
									return $.data;
								},
								$author$project$Serialize$list($author$project$Serialize$bytes),
								$author$project$Serialize$field$(
									function ($) {
										return $.otherUserId;
									},
									$author$project$Id$codec,
									$author$project$Serialize$field$(
										function ($) {
											return $.requestId;
										},
										$author$project$Id$codec,
										$author$project$Serialize$record(
											F3(
												function (requestId, otherUserId, data) {
													return {data: data, otherUserId: otherUserId, requestId: requestId};
												})))))),
						A3(
							$author$project$Serialize$variant1,
							$author$project$Encryption$ToJs_DecryptNewMessage,
							$author$project$Serialize$finishRecord(
								$author$project$Serialize$field$(
									function ($) {
										return $.data;
									},
									$author$project$Serialize$bytes,
									$author$project$Serialize$field$(
										function ($) {
											return $.otherUserId;
										},
										$author$project$Id$codec,
										$author$project$Serialize$field$(
											function ($) {
												return $.requestId;
											},
											$author$project$Id$codec,
											$author$project$Serialize$record(
												F3(
													function (requestId, otherUserId, data) {
														return {data: data, otherUserId: otherUserId, requestId: requestId};
													})))))),
							A3(
								$author$project$Serialize$variant1,
								$author$project$Encryption$ToJs_EncryptNewMessage,
								$author$project$Serialize$finishRecord(
									$author$project$Serialize$field$(
										function ($) {
											return $.data;
										},
										dataCodec,
										$author$project$Serialize$field$(
											function ($) {
												return $.otherUserId;
											},
											$author$project$Id$codec,
											$author$project$Serialize$field$(
												function ($) {
													return $.requestId;
												},
												$author$project$Id$codec,
												$author$project$Serialize$record(
													F3(
														function (requestId, otherUserId, data) {
															return {data: data, otherUserId: otherUserId, requestId: requestId};
														})))))),
								A3(
									$author$project$Serialize$variant1,
									$author$project$Encryption$ToJs_StoreSharedSecret,
									$author$project$Serialize$finishRecord(
										$author$project$Serialize$field$(
											function ($) {
												return $.sharedSecret;
											},
											$author$project$Serialize$bytes,
											$author$project$Serialize$field$(
												function ($) {
													return $.otherUserId;
												},
												$author$project$Id$codec,
												$author$project$Serialize$record(
													F2(
														function (otherUserId, sharedSecret) {
															return {otherUserId: otherUserId, sharedSecret: sharedSecret};
														}))))),
									$author$project$Serialize$customType(
										F8(
											function (a, b, c, d, e, f, g, value) {
												switch (value.$) {
													case 0:
														var argA = value.a;
														return a(argA);
													case 1:
														var argA = value.a;
														return b(argA);
													case 2:
														var argA = value.a;
														return c(argA);
													case 3:
														var argA = value.a;
														return d(argA);
													case 4:
														var argA = value.a;
														return e(argA);
													case 5:
														var argA = value.a;
														return f(argA);
													default:
														var argA = value.a;
														return g(argA);
												}
											}))))))))));
};
var $author$project$Encryption$decryptManyMessages$ = function (requestId, id, messages) {
	return A3(
		$lamdera$program_test$Effect$Command$sendToJsBytes,
		'encryption_to_js',
		$author$project$Encryption$encryption_to_js,
		$author$project$Serialize$encodeToBytes$(
			$author$project$Encryption$toJsCodec($author$project$Serialize$unit),
			$author$project$Encryption$ToJs_DecryptManyMessages(
				{
					data: $elm$core$List$map$(
						function (_v0) {
							var bytes = _v0;
							return bytes;
						},
						messages),
					otherUserId: id.otherUserId,
					requestId: requestId
				})));
};
var $author$project$Encryption$decryptManyMessages = F3($author$project$Encryption$decryptManyMessages$);
var $author$project$FrontendExtra$MissingKeys = function (a) {
	return {$: 1, a: a};
};
var $author$project$FrontendExtra$PendingEncryption = function (a) {
	return {$: 0, a: a};
};
var $elm$core$List$concatMap$ = function (f, list) {
	return $elm$core$List$concat(
		$elm$core$List$map$(f, list));
};
var $elm$core$List$concatMap = F2($elm$core$List$concatMap$);
var $author$project$FrontendExtra$encryptedMessageData = function (message) {
	if (message.$ === 1) {
		var data = message.a;
		return $elm$core$Maybe$Just(data.content);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$MessageArray$runEnd = function (run) {
	return run.start + $elm$core$Array$length(run.values);
};
var $author$project$MessageArray$toList = function (_v0) {
	var array = _v0;
	return $elm$core$Array$foldr$(
		F2(
			function (run, list) {
				return $elm$core$Array$foldr$(
					F2(
						function (value, _v1) {
							var index = _v1.a;
							var list2 = _v1.b;
							return _Utils_Tuple2(
								index - 1,
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										$author$project$Id$fromInt(index),
										value),
									list2));
						}),
					_Utils_Tuple2(
						$author$project$MessageArray$runEnd(run) - 1,
						list),
					run.values).b;
			}),
		_List_Nil,
		array.runs);
};
var $lamdera$containers$SeqDict$values = function (_v0) {
	var triplets = _v0.c;
	var helper = F2(
		function (_v1, acc) {
			var value = _v1.c;
			return A2($elm$core$List$cons, value, acc);
		});
	return $lamdera$containers$SeqDict$intDictFoldr$(helper, _List_Nil, triplets);
};
var $author$project$FrontendExtra$encryptedMessagesIn = function (dmChannel) {
	return _Utils_ap(
		$elm$core$List$filterMap$(
			function (_v0) {
				var message = _v0.b;
				return $author$project$FrontendExtra$encryptedMessageData(message);
			},
			$author$project$MessageArray$toList(dmChannel.messages)),
		$elm$core$List$concatMap$(
			function (thread) {
				return $elm$core$List$filterMap$(
					function (_v1) {
						var message = _v1.b;
						return $author$project$FrontendExtra$encryptedMessageData(message);
					},
					$author$project$MessageArray$toList(thread.messages));
			},
			$lamdera$containers$SeqDict$values(dmChannel.threads)));
};
var $lamdera$containers$SeqDict$member$ = function (key, _v0) {
	var bitmap = _v0.a;
	var nodes = _v0.b;
	var _v1 = $lamdera$containers$SeqDict$getHelp$(
		0,
		$lamdera$containers$FNV$hash(key),
		key,
		bitmap,
		nodes);
	if (!_v1.$) {
		return true;
	} else {
		return false;
	}
};
var $lamdera$containers$SeqDict$member = F2($lamdera$containers$SeqDict$member$);
var $lamdera$containers$SeqSet$member$ = function (k, _v0) {
	var dict = _v0;
	return $lamdera$containers$SeqDict$member$(k, dict);
};
var $lamdera$containers$SeqSet$member = F2($lamdera$containers$SeqSet$member$);
var $author$project$FrontendExtra$encryptedBacklog$ = function (keysOnThisDevice, dmChannels) {
	return $elm$core$List$filterMap$(
		function (_v0) {
			var otherUserId = _v0.a;
			var dmChannel = _v0.b;
			var _v1 = $author$project$FrontendExtra$encryptedMessagesIn(dmChannel);
			if (!_v1.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var messages = _v1;
				var id = {otherUserId: otherUserId};
				return $elm$core$Maybe$Just(
					$lamdera$containers$SeqSet$member$(otherUserId, keysOnThisDevice) ? $author$project$FrontendExtra$PendingEncryption(
						{id: id, messages: messages}) : $author$project$FrontendExtra$MissingKeys(
						{id: id, messages: messages}));
			}
		},
		$lamdera$containers$SeqDict$toList(dmChannels));
};
var $author$project$FrontendExtra$encryptedBacklog = F2($author$project$FrontendExtra$encryptedBacklog$);
var $lamdera$containers$SeqSet$SeqSet_elm_builtin = $elm$core$Basics$identity;
var $lamdera$containers$SeqSet$empty = $lamdera$containers$SeqDict$empty;
var $lamdera$containers$SeqSet$insert$ = function (k, _v0) {
	var dict = _v0;
	return $lamdera$containers$SeqDict$insert$(k, true, dict);
};
var $lamdera$containers$SeqSet$insert = F2($lamdera$containers$SeqSet$insert$);
var $lamdera$containers$SeqSet$fromList = function (xs) {
	return $elm$core$List$foldl$($lamdera$containers$SeqSet$insert, $lamdera$containers$SeqSet$empty, xs);
};
var $lamdera$program_test$Effect$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $lamdera$program_test$Effect$Browser$Dom$getElement = function (htmlId) {
	return $lamdera$program_test$Effect$Internal$GetElement$(
		$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId),
		function (result) {
			if (!result.$) {
				var ok = result.a;
				return $lamdera$program_test$Effect$Internal$Succeed(ok);
			} else {
				var err = result.a;
				return $lamdera$program_test$Effect$Internal$Fail(
					$lamdera$program_test$Effect$Browser$Dom$id(err));
			}
		});
};
var $author$project$Encryption$BytesHash = $elm$core$Basics$identity;
var $author$project$Encryption$hash = function (_v0) {
	var bytes = _v0;
	return $elm$core$Maybe$withDefault$(
		0,
		$elm$bytes$Bytes$Decode$decode$(
			$elm$bytes$Bytes$Decode$map2$(
				F2(
					function (high, low) {
						return (high * 4294967296) + low;
					}),
				$elm$bytes$Bytes$Decode$unsignedInt16(1),
				$elm$bytes$Bytes$Decode$unsignedInt32(1)),
			bytes));
};
var $author$project$Drawing$NoSelectedAnchor = {$: 0};
var $author$project$Drawing$init = $author$project$Drawing$NoSelectedAnchor;
var $author$project$ImageEditor$NotUploaded = {$: 0};
var $author$project$ImageEditor$init = {dragState: $elm$core$Maybe$Nothing, imageSize: $elm$core$Maybe$Nothing, imageUrl: $elm$core$Maybe$Nothing, size: 0, status: $author$project$ImageEditor$NotUploaded, x: 0, y: 0};
var $author$project$Local$ChangeId = $elm$core$Basics$identity;
var $author$project$Local$Local = $elm$core$Basics$identity;
var $author$project$Local$init = function (model2) {
	return {counter: 0, localModel: model2, localMsgs: $elm$core$Dict$empty, serverModel: model2};
};
var $author$project$TextEditor$init = {};
var $author$project$Pages$Admin$NotImportingBackend = {$: 0};
var $author$project$Editable$NotEditing = {$: 0};
var $author$project$Editable$init = {editing: $author$project$Editable$NotEditing, pressedSubmit: false, showSecret: false};
var $author$project$Table$init = function (columnToSortBy) {
	return {ascendingOrder: false, columnToSortBy: columnToSortBy, showAll: false};
};
var $author$project$Pages$Admin$initForAdmin = function (_v0) {
	var highlightLog = _v0.highlightLog;
	return {
		copiedLogLink: $elm$core$Maybe$Nothing,
		discordLinkLimit: $author$project$Editable$init,
		downloadingBackup: $elm$core$Maybe$Nothing,
		expandedDiscordGuilds: $lamdera$containers$SeqSet$empty,
		expandedGuilds: $lamdera$containers$SeqSet$empty,
		expandedSections: $lamdera$containers$SeqSet$empty,
		expandedSlackWorkspaces: $lamdera$containers$SeqSet$empty,
		exportProgress: $elm$core$Maybe$Nothing,
		exportSubsetSelection: $elm$core$Maybe$Nothing,
		highlightLog: highlightLog,
		importBackendStatus: $author$project$Pages$Admin$NotImportingBackend,
		notifyAdminsBotUserId: $author$project$Editable$init,
		notifyAdminsToken: $author$project$Editable$init,
		openRouterKey: $author$project$Editable$init,
		postmarkKey: $author$project$Editable$init,
		privateVapidKey: $author$project$Editable$init,
		publicVapidKey: $author$project$Editable$init,
		slackLinkLimit: $author$project$Editable$init,
		submitError: $elm$core$Maybe$Nothing,
		userTable: {
			changedUsers: $lamdera$containers$SeqDict$empty,
			deletedUsers: $lamdera$containers$SeqSet$empty,
			editingCell: $elm$core$Maybe$Nothing,
			newUsers: $elm$core$Array$empty,
			table: $author$project$Table$init(1)
		},
		websocketCloseEventsPage: 0
	};
};
var $author$project$Pages$Admin$initForUser = {
	copiedLogLink: $elm$core$Maybe$Nothing,
	discordLinkLimit: $author$project$Editable$init,
	downloadingBackup: $elm$core$Maybe$Nothing,
	expandedDiscordGuilds: $lamdera$containers$SeqSet$empty,
	expandedGuilds: $lamdera$containers$SeqSet$empty,
	expandedSections: $lamdera$containers$SeqSet$empty,
	expandedSlackWorkspaces: $lamdera$containers$SeqSet$empty,
	exportProgress: $elm$core$Maybe$Nothing,
	exportSubsetSelection: $elm$core$Maybe$Nothing,
	highlightLog: $elm$core$Maybe$Nothing,
	importBackendStatus: $author$project$Pages$Admin$NotImportingBackend,
	notifyAdminsBotUserId: $author$project$Editable$init,
	notifyAdminsToken: $author$project$Editable$init,
	openRouterKey: $author$project$Editable$init,
	postmarkKey: $author$project$Editable$init,
	privateVapidKey: $author$project$Editable$init,
	publicVapidKey: $author$project$Editable$init,
	slackLinkLimit: $author$project$Editable$init,
	submitError: $elm$core$Maybe$Nothing,
	userTable: {
		changedUsers: $lamdera$containers$SeqDict$empty,
		deletedUsers: $lamdera$containers$SeqSet$empty,
		editingCell: $elm$core$Maybe$Nothing,
		newUsers: $elm$core$Array$empty,
		table: $author$project$Table$init(1)
	},
	websocketCloseEventsPage: 0
};
var $author$project$Call$MediaDevicesNotLoaded = {$: 0};
var $author$project$Call$defaultRemoteCallData = {audioInputEnabled: true, screenShareEnabled: false, videoInputEnabled: true};
var $author$project$Call$initModel = {
	debugData: _List_Nil,
	focusedTile: $elm$core$Maybe$Nothing,
	isSpeaking: $lamdera$containers$SeqSet$empty,
	localIsSpeaking: false,
	pollDebugData: false,
	recordingUpload: $elm$core$Maybe$Nothing,
	remoteCallData: $author$project$Call$defaultRemoteCallData,
	selectedAudioInputDevice: $elm$core$Maybe$Nothing,
	selectedVideoInputDevice: $elm$core$Maybe$Nothing,
	showDeviceSettings: false,
	startConnectionError: $elm$core$Maybe$Nothing,
	thumbnailPosition: _Utils_Tuple2(1, 0.1),
	userMediaDevices: $author$project$Call$MediaDevicesNotLoaded,
	videoHover: $elm$core$Maybe$Nothing,
	volume: $lamdera$containers$SeqDict$empty
};
var $author$project$Pages$Admin$logSectionId = $lamdera$program_test$Effect$Browser$Dom$id('Pages.Admin_logSection');
var $author$project$LocalState$IsAdmin = function (a) {
	return {$: 0, a: a};
};
var $author$project$LocalState$IsAdminButDataNotLoaded = {$: 1};
var $author$project$LocalState$IsNotAdmin = {$: 2};
var $author$project$Call$init$ = function (voiceChats, recordings) {
	return {currentRoom: $elm$core$Maybe$Nothing, recordings: recordings, voiceChats: voiceChats};
};
var $author$project$Call$init = F2($author$project$Call$init$);
var $author$project$LocalState$AdminDataNotLoaded = {$: 0};
var $author$project$LocalState$NotBeingRegenerated = function (a) {
	return {$: 0, a: a};
};
var $author$project$LocalState$NotDeletingOrphanedFiles = {$: 0};
var $author$project$FrontendExtra$initAdminData = function (adminData) {
	return {
		backendMsgLogs: $author$project$LocalState$AdminDataNotLoaded,
		connections: adminData.connections,
		deleteOrphanedFiles: $author$project$LocalState$NotDeletingOrphanedFiles,
		deletedGuilds: $author$project$LocalState$AdminDataNotLoaded,
		discordDmChannels: $author$project$LocalState$AdminDataNotLoaded,
		discordGuilds: $author$project$LocalState$AdminDataNotLoaded,
		discordLinkLimit: adminData.discordLinkLimit,
		discordLinkingEnabled: adminData.discordLinkingEnabled,
		discordUsers: $author$project$LocalState$AdminDataNotLoaded,
		dmChannels: $author$project$LocalState$AdminDataNotLoaded,
		emailNotificationsEnabled: adminData.emailNotificationsEnabled,
		filesCount: adminData.filesCount,
		guilds: $author$project$LocalState$AdminDataNotLoaded,
		lastBackup: adminData.lastBackup,
		loadingDiscordChannels: adminData.loadingDiscordChannels,
		logs: adminData.logs,
		notifyAdminsBotUserId: adminData.notifyAdminsBotUserId,
		notifyAdminsToken: adminData.notifyAdminsToken,
		openRouterKey: adminData.openRouterKey,
		orphanedFiles: $author$project$LocalState$AdminDataNotLoaded,
		postmarkKey: adminData.postmarkApiKey,
		privateVapidKey: adminData.privateVapidKey,
		seqDictWorks: adminData.seqDictWorks,
		serverSecretRefreshedAt: $author$project$LocalState$NotBeingRegenerated(adminData.serverSecretRegeneratedAt),
		sessions: $author$project$LocalState$AdminDataNotLoaded,
		signupsEnabled: adminData.signupsEnabled,
		slackDmChannels: $author$project$LocalState$AdminDataNotLoaded,
		slackLinkLimit: adminData.slackLinkLimit,
		slackLinkingEnabled: adminData.slackLinkingEnabled,
		slackWorkspaces: $author$project$LocalState$AdminDataNotLoaded,
		toBackendLogs: $author$project$LocalState$AdminDataNotLoaded,
		twoFactorAuthentication: adminData.twoFactorAuthentication,
		users: $author$project$LocalState$AdminDataNotLoaded,
		vulnerabilityChecks: adminData.vulnerabilityChecks,
		websocketCloseEvents: $author$project$LocalState$AdminDataNotLoaded,
		wordSpellingGameEnglish: adminData.wordSpellingGameEnglish,
		wordSpellingGameSwedish: adminData.wordSpellingGameSwedish
	};
};
var $author$project$FrontendExtra$loginDataToLocalState$ = function (startupData, decrypted, encryptionBacklog, emojiData, loginData) {
	return {
		adminData: function () {
			var _v0 = loginData.adminData;
			switch (_v0.$) {
				case 0:
					var adminData = _v0.a;
					return $author$project$LocalState$IsAdmin(
						$author$project$FrontendExtra$initAdminData(adminData));
				case 2:
					return $author$project$LocalState$IsNotAdmin;
				default:
					return $author$project$LocalState$IsAdminButDataNotLoaded;
			}
		}(),
		calls: $author$project$Call$init$(loginData.voiceChatPeers, loginData.callRecordings),
		discordDmChannels: loginData.discordDmChannels,
		discordGuilds: loginData.discordGuilds,
		dmChannels: loginData.dmChannels,
		guilds: loginData.guilds,
		joinGuildError: $elm$core$Maybe$Nothing,
		localUser: {
			currentlyViewing: loginData.currentlyViewing,
			customEmojis: loginData.customEmojis,
			decryptedMessages: $elm$core$List$foldl$(
				F2(
					function (backlog, decrypted2) {
						if (!backlog.$) {
							return decrypted2;
						} else {
							var conversation = backlog.a;
							return $elm$core$List$foldl$(
								F2(
									function (message, decrypted3) {
										return $lamdera$containers$SeqDict$insert$(
											$author$project$Encryption$hash(message),
											$elm$core$Result$Err(0),
											decrypted3);
									}),
								decrypted2,
								conversation.messages);
						}
					}),
				decrypted,
				encryptionBacklog),
			devicePixelRatio: startupData.devicePixelRatio,
			discordUsers: loginData.discordUsers,
			emojiData: emojiData,
			linkedSlackUsers: loginData.linkedSlackUsers,
			otherUsers: loginData.otherUsers,
			safeAreaInsetBottom: startupData.safeAreaInsetBottom,
			safeAreaInsetTop: startupData.safeAreaInsetTop,
			session: loginData.session,
			slackUsers: loginData.slackUsers,
			slackUsersNeedingAuth: loginData.slackUsersNeedingAuth,
			stickers: loginData.stickers,
			timezone: startupData.timezone,
			user: loginData.user,
			userAgent: startupData.userAgent
		},
		otherSessions: loginData.otherSessions,
		publicVapidKey: loginData.publicVapidKey,
		slackDmChannels: loginData.slackDmChannels,
		slackWorkspaces: loginData.slackWorkspaces,
		textEditor: loginData.textEditor
	};
};
var $author$project$FrontendExtra$loginDataToLocalState = F5($author$project$FrontendExtra$loginDataToLocalState$);
var $author$project$Emoji$EmojiCategory = function (a) {
	return {$: 0, a: a};
};
var $author$project$Emoji$SmileysAndEmotion = 7;
var $author$project$Emoji$selectorInit = {
	category: $author$project$Emoji$EmojiCategory(7),
	emojiHovered: $elm$core$Maybe$Nothing,
	searchText: ''
};
var $author$project$Ports$set_app_badge_to_js = _Platform_outgoingPort('set_app_badge_to_js', $elm$core$Basics$identity);
var $author$project$Ports$setAppBadge = function (count) {
	return A3(
		$lamdera$program_test$Effect$Command$sendToJs,
		'set_app_badge_to_js',
		$author$project$Ports$set_app_badge_to_js,
		$elm$json$Json$Encode$int(count));
};
var $lamdera$program_test$Effect$Browser$Dom$setViewport$ = function (x, y) {
	return $lamdera$program_test$Effect$Internal$SetViewport$(x, y, $lamdera$program_test$Effect$Internal$Succeed);
};
var $lamdera$program_test$Effect$Browser$Dom$setViewport = F2($lamdera$program_test$Effect$Browser$Dom$setViewport$);
var $author$project$Id$DiscordGuildOrDmId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Id$DiscordGuildOrDmId_Dm = function (a) {
	return {$: 1, a: a};
};
var $elmcraft$core_extra$List$Extra$findMap$ = function (f, list) {
	findMap:
	while (true) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = list.a;
			var tail = list.b;
			var _v1 = f(a);
			if (!_v1.$) {
				var b = _v1.a;
				return $elm$core$Maybe$Just(b);
			} else {
				var $temp$list = tail;
				list = $temp$list;
				continue findMap;
			}
		}
	}
};
var $elmcraft$core_extra$List$Extra$findMap = F2($elmcraft$core_extra$List$Extra$findMap$);
var $author$project$LinkedAndOtherDiscordUsers$linkedUsers = function (_v0) {
	var a = _v0.b;
	return a;
};
var $author$project$NonemptyDict$member$ = function (key, _v0) {
	var id = _v0.a;
	var dict = _v0.c;
	return _Utils_eq(key, id) || $lamdera$containers$SeqDict$member$(key, dict);
};
var $author$project$NonemptyDict$member = F2($author$project$NonemptyDict$member$);
var $author$project$GuildColumn$discordDmCurrentUserId$ = function (localUser, dmChannel) {
	return $elmcraft$core_extra$List$Extra$findMap$(
		function (_v0) {
			var userId = _v0.a;
			return $author$project$NonemptyDict$member$(userId, dmChannel.members) ? $elm$core$Maybe$Just(userId) : $elm$core$Maybe$Nothing;
		},
		$lamdera$containers$SeqDict$toList(
			$author$project$LinkedAndOtherDiscordUsers$linkedUsers(localUser.discordUsers)));
};
var $author$project$GuildColumn$discordDmCurrentUserId = F2($author$project$GuildColumn$discordDmCurrentUserId$);
var $author$project$OneOrGreater$OneOrGreater = $elm$core$Basics$identity;
var $author$project$OneOrGreater$fromInt = function (_int) {
	return (_int > 0) ? $elm$core$Maybe$Just(_int) : $elm$core$Maybe$Nothing;
};
var $author$project$GuildColumn$newMessageCount$ = function (maybeLastViewed, channel) {
	if (!maybeLastViewed.$) {
		var lastViewed = maybeLastViewed.a;
		return $elm$core$Basics$max$(
			0,
			($author$project$MessageArray$length(channel.messages) - 1) - $author$project$Id$toInt(lastViewed));
	} else {
		return $author$project$MessageArray$length(channel.messages);
	}
};
var $author$project$GuildColumn$newMessageCount = F2($author$project$GuildColumn$newMessageCount$);
var $author$project$GuildColumn$discordDmHasNotifications$ = function (localUser, channelId, dmChannel) {
	var _v0 = $author$project$GuildColumn$discordDmCurrentUserId$(localUser, dmChannel);
	if (!_v0.$) {
		var currentUserId = _v0.a;
		return $elm$core$Maybe$map$(
			$elm$core$Tuple$pair(currentUserId),
			$author$project$OneOrGreater$fromInt(
				$author$project$GuildColumn$newMessageCount$(
					$lamdera$containers$SeqDict$get$(
						$author$project$Id$DiscordGuildOrDmId(
							$author$project$Id$DiscordGuildOrDmId_Dm(
								{channelId: channelId, currentUserId: currentUserId})),
						localUser.user.lastViewedMessage),
					dmChannel)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$GuildColumn$discordDmHasNotifications = F3($author$project$GuildColumn$discordDmHasNotifications$);
var $author$project$MembersAndOwner$IsNotMember = 2;
var $lamdera$containers$SeqDict$filter$ = function (predicate, _v0) {
	var rootTriplets = _v0.c;
	var helper = F2(
		function (_v1, dict) {
			var hash = _v1.a;
			var key = _v1.b;
			var value = _v1.c;
			var bitmap = dict.a;
			var nodes = dict.b;
			var triplets = dict.c;
			return A2(predicate, key, value) ? $lamdera$containers$SeqDict$insertHelp$(0, hash, key, value, bitmap, nodes, triplets) : dict;
		});
	return $lamdera$containers$SeqDict$intDictFoldl$(helper, $lamdera$containers$SeqDict$empty, rootTriplets);
};
var $lamdera$containers$SeqDict$filter = F2($lamdera$containers$SeqDict$filter$);
var $author$project$MembersAndOwner$IsMember = 0;
var $author$project$MembersAndOwner$IsOwner = 1;
var $author$project$MembersAndOwner$isMember$ = function (userId, _v0) {
	var members2 = _v0.a;
	var ownerId = _v0.b;
	return _Utils_eq(userId, ownerId) ? 1 : ($lamdera$containers$SeqDict$member$(userId, members2) ? 0 : 2);
};
var $author$project$MembersAndOwner$isMember = F2($author$project$MembersAndOwner$isMember$);
var $author$project$GuildColumn$discordGuildCurrentUserId$ = function (localUser, guild) {
	return $elm$core$List$head(
		$lamdera$containers$SeqDict$keys(
			$lamdera$containers$SeqDict$filter$(
				F2(
					function (linkedUserId, _v0) {
						return $author$project$MembersAndOwner$isMember$(linkedUserId, guild.membersAndOwner) !== 2;
					}),
				$author$project$LinkedAndOtherDiscordUsers$linkedUsers(localUser.discordUsers))));
};
var $author$project$GuildColumn$discordGuildCurrentUserId = F2($author$project$GuildColumn$discordGuildCurrentUserId$);
var $author$project$GuildIcon$NewMessage = function (a) {
	return {$: 1, a: a};
};
var $author$project$GuildIcon$NewMessageForUser = function (a) {
	return {$: 2, a: a};
};
var $author$project$GuildIcon$NoNotification = {$: 0};
var $author$project$Id$DiscordGuildOrDmId_Guild = function (a) {
	return {$: 0, a: a};
};
var $author$project$MuteSettings$IsNotMuted = 0;
var $author$project$MuteSettings$IsFullyMuted = 2;
var $author$project$MuteSettings$IsPartiallyMuted = 1;
var $author$project$MuteSettings$strongest$ = function (a, b) {
	switch (a) {
		case 0:
			return b;
		case 1:
			switch (b) {
				case 0:
					return 1;
				case 1:
					return 1;
				default:
					return 2;
			}
		default:
			return 2;
	}
};
var $author$project$MuteSettings$strongest = F2($author$project$MuteSettings$strongest$);
var $author$project$MuteSettings$channelOrThreadMuted$ = function (threadRoute, channel) {
	if (!threadRoute.$) {
		return channel.mutedChannel;
	} else {
		var threadId = threadRoute.a;
		return $author$project$MuteSettings$strongest$(
			channel.mutedChannel,
			$elm$core$Maybe$withDefault$(
				0,
				$lamdera$containers$SeqDict$get$(threadId, channel.mutedThreads)));
	}
};
var $author$project$MuteSettings$channelOrThreadMuted = F2($author$project$MuteSettings$channelOrThreadMuted$);
var $author$project$MuteSettings$isDiscordChannelMuted$ = function (model, guildId, channelId, threadRoute) {
	var _v0 = $lamdera$containers$SeqDict$get$(guildId, model.mutedDiscordGuilds);
	if (!_v0.$) {
		var guild = _v0.a;
		var _v1 = $lamdera$containers$SeqDict$get$(channelId, guild.channels);
		if (!_v1.$) {
			var channel = _v1.a;
			return $author$project$MuteSettings$strongest$(
				guild.mutedGuild,
				$author$project$MuteSettings$channelOrThreadMuted$(threadRoute, channel));
		} else {
			return guild.mutedGuild;
		}
	} else {
		return 0;
	}
};
var $author$project$MuteSettings$isDiscordChannelMuted = F4($author$project$MuteSettings$isDiscordChannelMuted$);
var $author$project$GuildColumn$discordGuildNewMessageCount$ = function (currentDiscordUserId, currentUser, guildId, guild) {
	return $lamdera$containers$SeqDict$foldl$(
		F3(
			function (channelId, channel, count) {
				var guildOrDmId = $author$project$Id$DiscordGuildOrDmId(
					$author$project$Id$DiscordGuildOrDmId_Guild(
						{channelId: channelId, currentUserId: currentDiscordUserId, guildId: guildId}));
				return $lamdera$containers$SeqDict$foldl$(
					F3(
						function (threadId, thread, count2) {
							var _v0 = $author$project$MuteSettings$isDiscordChannelMuted$(
								currentUser.muteSettings,
								guildId,
								channelId,
								$author$project$Id$ViewThread(threadId));
							switch (_v0) {
								case 0:
									return count2 + $author$project$GuildColumn$newMessageCount$(
										$lamdera$containers$SeqDict$get$(
											_Utils_Tuple2(guildOrDmId, threadId),
											currentUser.lastViewedThreadMessage),
										thread);
								case 1:
									return count2;
								default:
									return count2;
							}
						}),
					function () {
						var _v1 = $author$project$MuteSettings$isDiscordChannelMuted$(currentUser.muteSettings, guildId, channelId, $author$project$Id$NoThread);
						switch (_v1) {
							case 0:
								return count + $author$project$GuildColumn$newMessageCount$(
									$lamdera$containers$SeqDict$get$(guildOrDmId, currentUser.lastViewedMessage),
									channel);
							case 1:
								return count;
							default:
								return count;
						}
					}(),
					channel.threads);
			}),
		0,
		guild.channels);
};
var $author$project$GuildColumn$discordGuildNewMessageCount = F4($author$project$GuildColumn$discordGuildNewMessageCount$);
var $author$project$MuteSettings$hidesRedDot = function (isMuted) {
	switch (isMuted) {
		case 0:
			return false;
		case 1:
			return false;
		default:
			return true;
	}
};
var $author$project$MuteSettings$isDiscordGuildSpecificallyMute$ = function (model, guildId) {
	var _v0 = $lamdera$containers$SeqDict$get$(guildId, model.mutedDiscordGuilds);
	if (!_v0.$) {
		var guild = _v0.a;
		return guild.mutedGuild;
	} else {
		return 0;
	}
};
var $author$project$MuteSettings$isDiscordGuildSpecificallyMute = F2($author$project$MuteSettings$isDiscordGuildSpecificallyMute$);
var $author$project$OneOrGreater$plus$ = function (_v0, _v1) {
	var a = _v0;
	var b = _v1;
	return a + b;
};
var $author$project$OneOrGreater$plus = F2($author$project$OneOrGreater$plus$);
var $author$project$NonemptyDict$toSeqDict = function (_v0) {
	var id = _v0.a;
	var a = _v0.b;
	var idDict = _v0.c;
	return $lamdera$containers$SeqDict$insert$(id, a, idDict);
};
var $author$project$GuildColumn$unmutedDiscordDirectMentions$ = function (currentUser, guildId, maybeDirectMentions) {
	if (!maybeDirectMentions.$) {
		var directMentions = maybeDirectMentions.a;
		return $lamdera$containers$SeqDict$foldl$(
			F3(
				function (_v1, count, total) {
					var channelId = _v1.a;
					var threadRoute = _v1.b;
					if ($author$project$MuteSettings$hidesRedDot(
						$author$project$MuteSettings$isDiscordChannelMuted$(currentUser.muteSettings, guildId, channelId, threadRoute))) {
						return total;
					} else {
						if (!total.$) {
							var total2 = total.a;
							return $elm$core$Maybe$Just(
								$author$project$OneOrGreater$plus$(count, total2));
						} else {
							return $elm$core$Maybe$Just(count);
						}
					}
				}),
			$elm$core$Maybe$Nothing,
			$author$project$NonemptyDict$toSeqDict(directMentions));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$GuildColumn$unmutedDiscordDirectMentions = F3($author$project$GuildColumn$unmutedDiscordDirectMentions$);
var $author$project$GuildColumn$discordGuildHasNotifications$ = function (currentDiscordUserId, currentUser, guildId, guild) {
	if ($author$project$MuteSettings$hidesRedDot(
		$author$project$MuteSettings$isDiscordGuildSpecificallyMute$(currentUser.muteSettings, guildId))) {
		return $author$project$GuildIcon$NoNotification;
	} else {
		var _v0 = $author$project$GuildColumn$unmutedDiscordDirectMentions$(
			currentUser,
			guildId,
			$lamdera$containers$SeqDict$get$(guildId, currentUser.discordDirectMentions));
		if (!_v0.$) {
			var count = _v0.a;
			return $author$project$GuildIcon$NewMessageForUser(count);
		} else {
			var _v1 = $author$project$OneOrGreater$fromInt(
				$author$project$GuildColumn$discordGuildNewMessageCount$(currentDiscordUserId, currentUser, guildId, guild));
			if (!_v1.$) {
				var count = _v1.a;
				return $author$project$GuildIcon$NewMessage(count);
			} else {
				return $author$project$GuildIcon$NoNotification;
			}
		}
	}
};
var $author$project$GuildColumn$discordGuildHasNotifications = F4($author$project$GuildColumn$discordGuildHasNotifications$);
var $author$project$Id$GuildOrDmId = function (a) {
	return {$: 0, a: a};
};
var $author$project$GuildColumn$channelNewMessageCount$ = function (guildOrDmId, currentUser, channel) {
	return $lamdera$containers$SeqDict$foldl$(
		F3(
			function (threadId, thread, count) {
				return $author$project$GuildColumn$newMessageCount$(
					$lamdera$containers$SeqDict$get$(
						_Utils_Tuple2(guildOrDmId, threadId),
						currentUser.lastViewedThreadMessage),
					thread) + count;
			}),
		$author$project$GuildColumn$newMessageCount$(
			$lamdera$containers$SeqDict$get$(guildOrDmId, currentUser.lastViewedMessage),
			channel),
		channel.threads);
};
var $author$project$GuildColumn$channelNewMessageCount = F3($author$project$GuildColumn$channelNewMessageCount$);
var $author$project$GuildColumn$dmHasNotifications$ = function (currentUser, otherUserId, dmChannel) {
	return $author$project$OneOrGreater$fromInt(
		$author$project$GuildColumn$channelNewMessageCount$(
			$author$project$Id$GuildOrDmId(
				$author$project$Id$GuildOrDmId_Dm(
					{otherUserId: otherUserId})),
			currentUser,
			dmChannel));
};
var $author$project$GuildColumn$dmHasNotifications = F3($author$project$GuildColumn$dmHasNotifications$);
var $author$project$MuteSettings$isChannelMuted$ = function (model, guildId, channelId, threadRoute) {
	var _v0 = $lamdera$containers$SeqDict$get$(guildId, model.mutedGuilds);
	if (!_v0.$) {
		var guild = _v0.a;
		var _v1 = $lamdera$containers$SeqDict$get$(channelId, guild.channels);
		if (!_v1.$) {
			var channel = _v1.a;
			return $author$project$MuteSettings$strongest$(
				guild.mutedGuild,
				$author$project$MuteSettings$channelOrThreadMuted$(threadRoute, channel));
		} else {
			return guild.mutedGuild;
		}
	} else {
		return 0;
	}
};
var $author$project$MuteSettings$isChannelMuted = F4($author$project$MuteSettings$isChannelMuted$);
var $author$project$GuildColumn$guildNewMessageCounts$ = function (currentUser, guildId, guild) {
	return $lamdera$containers$SeqDict$foldl$(
		F3(
			function (channelId, channel, counts) {
				var guildOrDmId = $author$project$Id$GuildOrDmId(
					$author$project$Id$GuildOrDmId_Guild(
						{channelId: channelId, guildId: guildId}));
				return $lamdera$containers$SeqDict$foldl$(
					F3(
						function (threadId, thread, counts2) {
							return A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									$author$project$MuteSettings$isChannelMuted$(
										currentUser.muteSettings,
										guildId,
										channelId,
										$author$project$Id$ViewThread(threadId)),
									$author$project$GuildColumn$newMessageCount$(
										$lamdera$containers$SeqDict$get$(
											_Utils_Tuple2(guildOrDmId, threadId),
											currentUser.lastViewedThreadMessage),
										thread)),
								counts2);
						}),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							$author$project$MuteSettings$isChannelMuted$(currentUser.muteSettings, guildId, channelId, $author$project$Id$NoThread),
							$author$project$GuildColumn$newMessageCount$(
								$lamdera$containers$SeqDict$get$(guildOrDmId, currentUser.lastViewedMessage),
								channel)),
						counts),
					channel.threads);
			}),
		_List_Nil,
		guild.channels);
};
var $author$project$GuildColumn$guildNewMessageCounts = F3($author$project$GuildColumn$guildNewMessageCounts$);
var $author$project$MuteSettings$hidesWhiteDot = function (isMuted) {
	switch (isMuted) {
		case 0:
			return false;
		case 1:
			return true;
		default:
			return true;
	}
};
var $author$project$MuteSettings$isGuildSpecificallyMute$ = function (model, guildId) {
	var _v0 = $lamdera$containers$SeqDict$get$(guildId, model.mutedGuilds);
	if (!_v0.$) {
		var guild = _v0.a;
		return guild.mutedGuild;
	} else {
		return 0;
	}
};
var $author$project$MuteSettings$isGuildSpecificallyMute = F2($author$project$MuteSettings$isGuildSpecificallyMute$);
var $author$project$GuildColumn$unmutedDirectMentions$ = function (currentUser, guildId, maybeDirectMentions) {
	if (!maybeDirectMentions.$) {
		var directMentions = maybeDirectMentions.a;
		return $lamdera$containers$SeqDict$foldl$(
			F3(
				function (_v1, count, total) {
					var channelId = _v1.a;
					var threadRoute = _v1.b;
					if ($author$project$MuteSettings$hidesRedDot(
						$author$project$MuteSettings$isChannelMuted$(currentUser.muteSettings, guildId, channelId, threadRoute))) {
						return total;
					} else {
						if (!total.$) {
							var total2 = total.a;
							return $elm$core$Maybe$Just(
								$author$project$OneOrGreater$plus$(count, total2));
						} else {
							return $elm$core$Maybe$Just(count);
						}
					}
				}),
			$elm$core$Maybe$Nothing,
			$author$project$NonemptyDict$toSeqDict(directMentions));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$GuildColumn$unmutedDirectMentions = F3($author$project$GuildColumn$unmutedDirectMentions$);
var $author$project$GuildColumn$guildHasNotifications$ = function (currentUser, guildId, guild) {
	if ($author$project$MuteSettings$hidesRedDot(
		$author$project$MuteSettings$isGuildSpecificallyMute$(currentUser.muteSettings, guildId))) {
		return $author$project$GuildIcon$NoNotification;
	} else {
		var counts = $author$project$GuildColumn$guildNewMessageCounts$(currentUser, guildId, guild);
		if ($lamdera$containers$SeqSet$member$(guildId, currentUser.notifyOnAllMessages)) {
			var _v0 = $author$project$OneOrGreater$fromInt(
				$elm$core$List$foldl$(
					F2(
						function (_v1, total) {
							var isMuted = _v1.a;
							var count = _v1.b;
							return $author$project$MuteSettings$hidesRedDot(isMuted) ? total : (total + count);
						}),
					0,
					counts));
			if (!_v0.$) {
				var count = _v0.a;
				return $author$project$GuildIcon$NewMessageForUser(count);
			} else {
				return $author$project$GuildIcon$NoNotification;
			}
		} else {
			var _v2 = $author$project$GuildColumn$unmutedDirectMentions$(
				currentUser,
				guildId,
				$lamdera$containers$SeqDict$get$(guildId, currentUser.directMentions));
			if (!_v2.$) {
				var count = _v2.a;
				return $author$project$GuildIcon$NewMessageForUser(count);
			} else {
				var _v3 = $author$project$OneOrGreater$fromInt(
					$elm$core$List$foldl$(
						F2(
							function (_v4, total) {
								var isMuted = _v4.a;
								var count = _v4.b;
								return $author$project$MuteSettings$hidesWhiteDot(isMuted) ? total : (total + count);
							}),
						0,
						counts));
				if (!_v3.$) {
					var count = _v3.a;
					return $author$project$GuildIcon$NewMessage(count);
				} else {
					return $author$project$GuildIcon$NoNotification;
				}
			}
		}
	}
};
var $author$project$GuildColumn$guildHasNotifications = F3($author$project$GuildColumn$guildHasNotifications$);
var $author$project$OneOrGreater$toInt = function (_v0) {
	var a = _v0;
	return a;
};
var $author$project$GuildColumn$redNotificationCount = function (notification) {
	switch (notification.$) {
		case 0:
			return 0;
		case 1:
			return 0;
		default:
			var count = notification.a;
			return $author$project$OneOrGreater$toInt(count);
	}
};
var $author$project$Id$SlackGuildOrDmId = function (a) {
	return {$: 2, a: a};
};
var $author$project$Id$SlackGuildOrDmId_Dm = function (a) {
	return {$: 1, a: a};
};
var $lamdera$containers$SeqDict$foldr$ = function (fn, acc, _v0) {
	var triplets = _v0.c;
	var helper = F2(
		function (_v1, acc2) {
			var key = _v1.b;
			var value = _v1.c;
			return A3(fn, key, value, acc2);
		});
	return $lamdera$containers$SeqDict$intDictFoldr$(helper, acc, triplets);
};
var $lamdera$containers$SeqDict$foldr = F3($lamdera$containers$SeqDict$foldr$);
var $lamdera$containers$SeqSet$foldr$ = function (f, b, _v0) {
	var dict = _v0;
	return $lamdera$containers$SeqDict$foldr$(
		F3(
			function (k, _v1, b2) {
				return A2(f, k, b2);
			}),
		b,
		dict);
};
var $lamdera$containers$SeqSet$foldr = F3($lamdera$containers$SeqSet$foldr$);
var $author$project$NonemptySet$toList = function (_v0) {
	var id = _v0.a;
	var set = _v0.b;
	return $lamdera$containers$SeqSet$foldr$(
		F2(
			function (k, list) {
				return A2($elm$core$List$cons, k, list);
			}),
		_List_fromArray(
			[id]),
		set);
};
var $author$project$GuildColumn$slackDmCurrentUserId$ = function (localUser, dmChannel) {
	return $elmcraft$core_extra$List$Extra$find$(
		function (userId) {
			return $lamdera$containers$SeqDict$member$(userId, localUser.linkedSlackUsers);
		},
		$author$project$NonemptySet$toList(dmChannel.members));
};
var $author$project$GuildColumn$slackDmCurrentUserId = F2($author$project$GuildColumn$slackDmCurrentUserId$);
var $author$project$GuildColumn$slackDmHasNotifications$ = function (localUser, channelId, dmChannel) {
	var _v0 = $author$project$GuildColumn$slackDmCurrentUserId$(localUser, dmChannel);
	if (!_v0.$) {
		var currentUserId = _v0.a;
		return $elm$core$Maybe$map$(
			$elm$core$Tuple$pair(currentUserId),
			$author$project$OneOrGreater$fromInt(
				$author$project$GuildColumn$channelNewMessageCount$(
					$author$project$Id$SlackGuildOrDmId(
						$author$project$Id$SlackGuildOrDmId_Dm(
							{channelId: channelId, currentUserId: currentUserId})),
					localUser.user,
					dmChannel)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$GuildColumn$slackDmHasNotifications = F3($author$project$GuildColumn$slackDmHasNotifications$);
var $author$project$GuildColumn$slackWorkspaceCurrentUserId$ = function (localUser, teamId) {
	return $elm$core$List$head(
		$lamdera$containers$SeqDict$keys(
			$lamdera$containers$SeqDict$filter$(
				F2(
					function (_v0, linkedTeamId) {
						return _Utils_eq(linkedTeamId, teamId);
					}),
				localUser.linkedSlackUsers)));
};
var $author$project$GuildColumn$slackWorkspaceCurrentUserId = F2($author$project$GuildColumn$slackWorkspaceCurrentUserId$);
var $author$project$MuteSettings$isSlackWorkspaceSpecificallyMuted$ = function (model, teamId) {
	var _v0 = $lamdera$containers$SeqDict$get$(teamId, model.mutedSlackWorkspaces);
	if (!_v0.$) {
		var workspace = _v0.a;
		return workspace.mutedWorkspace;
	} else {
		return 0;
	}
};
var $author$project$MuteSettings$isSlackWorkspaceSpecificallyMuted = F2($author$project$MuteSettings$isSlackWorkspaceSpecificallyMuted$);
var $author$project$Id$SlackGuildOrDmId_Workspace = function (a) {
	return {$: 0, a: a};
};
var $author$project$MuteSettings$isSlackChannelMuted$ = function (model, teamId, channelId, threadRoute) {
	var _v0 = $lamdera$containers$SeqDict$get$(teamId, model.mutedSlackWorkspaces);
	if (!_v0.$) {
		var workspace = _v0.a;
		var _v1 = $lamdera$containers$SeqDict$get$(channelId, workspace.channels);
		if (!_v1.$) {
			var channel = _v1.a;
			return $author$project$MuteSettings$strongest$(
				workspace.mutedWorkspace,
				$author$project$MuteSettings$channelOrThreadMuted$(threadRoute, channel));
		} else {
			return workspace.mutedWorkspace;
		}
	} else {
		return 0;
	}
};
var $author$project$MuteSettings$isSlackChannelMuted = F4($author$project$MuteSettings$isSlackChannelMuted$);
var $author$project$GuildColumn$slackWorkspaceNewMessageCount$ = function (currentSlackUserId, currentUser, teamId, workspace) {
	return $lamdera$containers$SeqDict$foldl$(
		F3(
			function (channelId, channel, count) {
				var guildOrDmId = $author$project$Id$SlackGuildOrDmId(
					$author$project$Id$SlackGuildOrDmId_Workspace(
						{channelId: channelId, currentUserId: currentSlackUserId, teamId: teamId}));
				return $lamdera$containers$SeqDict$foldl$(
					F3(
						function (threadId, thread, count2) {
							return $author$project$MuteSettings$hidesWhiteDot(
								$author$project$MuteSettings$isSlackChannelMuted$(
									currentUser.muteSettings,
									teamId,
									channelId,
									$author$project$Id$ViewThread(threadId))) ? count2 : (count2 + $author$project$GuildColumn$newMessageCount$(
								$lamdera$containers$SeqDict$get$(
									_Utils_Tuple2(guildOrDmId, threadId),
									currentUser.lastViewedThreadMessage),
								thread));
						}),
					$author$project$MuteSettings$hidesWhiteDot(
						$author$project$MuteSettings$isSlackChannelMuted$(currentUser.muteSettings, teamId, channelId, $author$project$Id$NoThread)) ? count : (count + $author$project$GuildColumn$newMessageCount$(
						$lamdera$containers$SeqDict$get$(guildOrDmId, currentUser.lastViewedMessage),
						channel)),
					channel.threads);
			}),
		0,
		workspace.channels);
};
var $author$project$GuildColumn$slackWorkspaceNewMessageCount = F4($author$project$GuildColumn$slackWorkspaceNewMessageCount$);
var $author$project$GuildColumn$unmutedSlackDirectMentions$ = function (currentUser, teamId, maybeDirectMentions) {
	if (!maybeDirectMentions.$) {
		var directMentions = maybeDirectMentions.a;
		return $lamdera$containers$SeqDict$foldl$(
			F3(
				function (_v1, count, total) {
					var channelId = _v1.a;
					var threadRoute = _v1.b;
					if ($author$project$MuteSettings$hidesRedDot(
						$author$project$MuteSettings$isSlackChannelMuted$(currentUser.muteSettings, teamId, channelId, threadRoute))) {
						return total;
					} else {
						if (!total.$) {
							var total2 = total.a;
							return $elm$core$Maybe$Just(
								$author$project$OneOrGreater$plus$(count, total2));
						} else {
							return $elm$core$Maybe$Just(count);
						}
					}
				}),
			$elm$core$Maybe$Nothing,
			$author$project$NonemptyDict$toSeqDict(directMentions));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$GuildColumn$unmutedSlackDirectMentions = F3($author$project$GuildColumn$unmutedSlackDirectMentions$);
var $author$project$GuildColumn$slackWorkspaceHasNotifications$ = function (currentSlackUserId, currentUser, teamId, workspace) {
	if ($author$project$MuteSettings$hidesRedDot(
		$author$project$MuteSettings$isSlackWorkspaceSpecificallyMuted$(currentUser.muteSettings, teamId))) {
		return $author$project$GuildIcon$NoNotification;
	} else {
		var _v0 = $author$project$GuildColumn$unmutedSlackDirectMentions$(
			currentUser,
			teamId,
			$lamdera$containers$SeqDict$get$(teamId, currentUser.slackDirectMentions));
		if (!_v0.$) {
			var count = _v0.a;
			return $author$project$GuildIcon$NewMessageForUser(count);
		} else {
			var _v1 = $author$project$OneOrGreater$fromInt(
				$author$project$GuildColumn$slackWorkspaceNewMessageCount$(currentSlackUserId, currentUser, teamId, workspace));
			if (!_v1.$) {
				var count = _v1.a;
				return $author$project$GuildIcon$NewMessage(count);
			} else {
				return $author$project$GuildIcon$NoNotification;
			}
		}
	}
};
var $author$project$GuildColumn$slackWorkspaceHasNotifications = F4($author$project$GuildColumn$slackWorkspaceHasNotifications$);
var $author$project$GuildColumn$unreadNotificationCount = function (local) {
	var slackDmCount = $lamdera$containers$SeqDict$foldl$(
		F3(
			function (channelId, dmChannel, total) {
				var _v5 = $author$project$GuildColumn$slackDmHasNotifications$(local.localUser, channelId, dmChannel);
				if (!_v5.$) {
					var _v6 = _v5.a;
					var count = _v6.b;
					return total + $author$project$OneOrGreater$toInt(count);
				} else {
					return total;
				}
			}),
		0,
		local.slackDmChannels);
	var discordDmCount = $lamdera$containers$SeqDict$foldl$(
		F3(
			function (channelId, dmChannel, total) {
				var _v3 = $author$project$GuildColumn$discordDmHasNotifications$(local.localUser, channelId, dmChannel);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var count = _v4.b;
					return total + $author$project$OneOrGreater$toInt(count);
				} else {
					return total;
				}
			}),
		0,
		local.discordDmChannels);
	var currentUser = local.localUser.user;
	var discordGuildCount = $lamdera$containers$SeqDict$foldl$(
		F3(
			function (guildId, guild, total) {
				var _v2 = $author$project$GuildColumn$discordGuildCurrentUserId$(local.localUser, guild);
				if (!_v2.$) {
					var currentDiscordUserId = _v2.a;
					return total + $author$project$GuildColumn$redNotificationCount(
						$author$project$GuildColumn$discordGuildHasNotifications$(currentDiscordUserId, currentUser, guildId, guild));
				} else {
					return total;
				}
			}),
		0,
		local.discordGuilds);
	var dmCount = $lamdera$containers$SeqDict$foldl$(
		F3(
			function (otherUserId, dmChannel, total) {
				var _v1 = $author$project$GuildColumn$dmHasNotifications$(currentUser, otherUserId, dmChannel);
				if (!_v1.$) {
					var count = _v1.a;
					return total + $author$project$OneOrGreater$toInt(count);
				} else {
					return total;
				}
			}),
		0,
		local.dmChannels);
	var guildCount = $lamdera$containers$SeqDict$foldl$(
		F3(
			function (guildId, guild, total) {
				return total + $author$project$GuildColumn$redNotificationCount(
					$author$project$GuildColumn$guildHasNotifications$(currentUser, guildId, guild));
			}),
		0,
		local.guilds);
	var slackWorkspaceCount = $lamdera$containers$SeqDict$foldl$(
		F3(
			function (teamId, workspace, total) {
				var _v0 = $author$project$GuildColumn$slackWorkspaceCurrentUserId$(local.localUser, teamId);
				if (!_v0.$) {
					var currentSlackUserId = _v0.a;
					return total + $author$project$GuildColumn$redNotificationCount(
						$author$project$GuildColumn$slackWorkspaceHasNotifications$(currentSlackUserId, currentUser, teamId, workspace));
				} else {
					return total;
				}
			}),
		0,
		local.slackWorkspaces);
	return ((((dmCount + discordDmCount) + guildCount) + discordGuildCount) + slackDmCount) + slackWorkspaceCount;
};
var $author$project$FrontendExtra$loadedInitHelper$ = function (startupData, emojiData, loginData, loading) {
	var backlog = $author$project$FrontendExtra$encryptedBacklog$(
		$lamdera$containers$SeqSet$fromList(startupData.e2eeKeys),
		loginData.dmChannels);
	var local = $author$project$FrontendExtra$loginDataToLocalState$(startupData, $lamdera$containers$SeqDict$empty, backlog, emojiData, loginData);
	var loggedIn = {
		accountDeletionBannerClosed: false,
		admin: function () {
			var _v5 = loginData.adminData;
			switch (_v5.$) {
				case 0:
					return $author$project$Pages$Admin$initForAdmin(
						function () {
							var _v6 = loading.route;
							if (_v6.$ === 1) {
								var params = _v6.a;
								return params;
							} else {
								return {highlightLog: $elm$core$Maybe$Nothing};
							}
						}());
				case 1:
					return $author$project$Pages$Admin$initForAdmin(
						function () {
							var _v7 = loading.route;
							if (_v7.$ === 1) {
								var params = _v7.a;
								return params;
							} else {
								return {highlightLog: $elm$core$Maybe$Nothing};
							}
						}());
				default:
					return $author$project$Pages$Admin$initForUser;
			}
		}(),
		channelScrollPosition: 0,
		drafts: $lamdera$containers$SeqDict$empty,
		drawingMode: $author$project$Drawing$init,
		e2eeError: $elm$core$Maybe$Nothing,
		e2eeKeysOnThisDevice: $lamdera$containers$SeqSet$fromList(startupData.e2eeKeys),
		e2eePrivateKeyText: '',
		e2eeSectionsExpanded: $lamdera$containers$SeqDict$empty,
		editChannelForm: $lamdera$containers$SeqDict$empty,
		editGuildForm: $lamdera$containers$SeqDict$empty,
		editMessage: $lamdera$containers$SeqDict$empty,
		emojiSelector: $author$project$Emoji$selectorInit,
		encryptionRequests: {
			nextDecryptManyRequestId: $author$project$Id$fromInt(
				$elm$core$List$length(backlog)),
			nextDecryptionRequestId: $author$project$Id$fromInt(0),
			nextEncryptFileRequestId: $author$project$Id$fromInt(0),
			nextEncryptManyRequestId: $author$project$Id$fromInt(0),
			nextEncryptionRequestId: $author$project$Id$fromInt(0),
			pendingDecryptedManyMessages: $lamdera$containers$SeqDict$fromList(
				$elm$core$List$filterMap$(
					$elm$core$Basics$identity,
					$elm$core$List$indexedMap$(
						F2(
							function (index, backlog2) {
								if (!backlog2.$) {
									var conversation = backlog2.a;
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											$author$project$Id$fromInt(index),
											{
												messageHashes: $elm$core$List$map$($author$project$Encryption$hash, conversation.messages),
												shiftScrollFrom: $elm$core$Maybe$Nothing
											}));
								} else {
									return $elm$core$Maybe$Nothing;
								}
							}),
						backlog))),
			pendingDecryptedMessages: $lamdera$containers$SeqDict$empty,
			pendingDecryptedOldMessages: $lamdera$containers$SeqDict$empty,
			pendingEncryptedEdits: $lamdera$containers$SeqDict$empty,
			pendingEncryptedFiles: $lamdera$containers$SeqDict$empty,
			pendingEncryptedManyMessages: $lamdera$containers$SeqDict$empty,
			pendingEncryptedMessages: $lamdera$containers$SeqDict$empty
		},
		externalLinkWarning: $elm$core$Maybe$Nothing,
		fileDragOverCount: $author$project$Types$NoFileDrag($elm$core$Maybe$Nothing),
		filesToUpload: $lamdera$containers$SeqDict$empty,
		games: $lamdera$containers$SeqDict$empty,
		guildIconEditor: $elm$core$Maybe$Nothing,
		isReloading: false,
		localState: $author$project$Local$init(local),
		messageHover: $author$project$Types$NoMessageHover,
		newChannelForm: $lamdera$containers$SeqDict$empty,
		newGuildForm: $elm$core$Maybe$Nothing,
		newMessagesWhileNotScrolledToBottom: 0,
		previousTextInputFocus: $elm$core$Maybe$Nothing,
		profilePictureEditor: $author$project$ImageEditor$init,
		replyTo: $lamdera$containers$SeqDict$empty,
		revealedSpoilers: $lamdera$containers$SeqDict$empty,
		searchOverlayQuery: '',
		searchOverlaySelection: 0,
		showEmojiSelector: $author$project$Types$EmojiSelectorHidden,
		showFileToUploadInfo: $elm$core$Maybe$Nothing,
		showInviteLinkQrCode: $elm$core$Maybe$Nothing,
		showNewPrivateKey: $elm$core$Maybe$Nothing,
		sidebarMode: $author$project$Route$ChannelSidebarNotDragging(
			{
				offset: $author$project$FrontendExtra$channelSidebarTarget(loading.route)
			}),
		textEditor: $author$project$TextEditor$init,
		textInputFocus: $elm$core$Maybe$Nothing,
		twoFactor: function () {
			var _v9 = loginData.twoFactorAuthenticationEnabled;
			if (!_v9.$) {
				var enabledAt = _v9.a;
				return $author$project$TwoFactorAuthentication$TwoFactorAlreadyComplete(enabledAt);
			} else {
				return $author$project$TwoFactorAuthentication$TwoFactorNotStarted;
			}
		}(),
		typedTextCounter: 0,
		typingDebouncer: true,
		userOptions: $elm$core$Maybe$Nothing,
		voiceChat: $author$project$Call$initModel
	};
	return _Utils_Tuple2(
		loggedIn,
		$lamdera$program_test$Effect$Command$batch(
			_List_fromArray(
				[
					$lamdera$program_test$Effect$Command$batch(
					$elm$core$List$filterMap$(
						$elm$core$Basics$identity,
						$elm$core$List$indexedMap$(
							F2(
								function (index, backlog2) {
									if (!backlog2.$) {
										var conversation = backlog2.a;
										return $elm$core$Maybe$Just(
											$author$project$Encryption$decryptManyMessages$(
												$author$project$Id$fromInt(index),
												conversation.id,
												conversation.messages));
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}),
							backlog))),
					function () {
					var _v1 = loading.route;
					if (_v1.$ === 1) {
						var params = _v1.a;
						var _v2 = params.highlightLog;
						if (!_v2.$) {
							return $lamdera$program_test$Effect$Task$attempt$(
								function (_v4) {
									return $author$project$Types$ScrolledToLogSection;
								},
								A2(
									$lamdera$program_test$Effect$Task$andThen,
									function (_v3) {
										var element = _v3.element;
										return $lamdera$program_test$Effect$Browser$Dom$setViewport$(0, element.y + 40);
									},
									$lamdera$program_test$Effect$Browser$Dom$getElement($author$project$Pages$Admin$logSectionId)));
						} else {
							return $lamdera$program_test$Effect$Command$none;
						}
					} else {
						return $lamdera$program_test$Effect$Command$none;
					}
				}(),
					$author$project$Call$displayModeChangeCmd$(
					$author$project$Call$NoVideo,
					$author$project$Call$displayMode$(
						$author$project$MyUi$isMobile(loading),
						local.localUser.session.userId,
						loading.route,
						local.calls),
					loggedIn.voiceChat),
					$author$project$Ports$setAppBadge(
					$author$project$GuildColumn$unreadNotificationCount(local))
				])));
};
var $author$project$FrontendExtra$loadedInitHelper = F4($author$project$FrontendExtra$loadedInitHelper$);
var $author$project$Ports$register_service_worker_to_js = _Platform_outgoingPort('register_service_worker_to_js', $elm$core$Basics$identity);
var $author$project$Ports$registerServiceWorker = A3($lamdera$program_test$Effect$Command$sendToJs, 'register_service_worker_to_js', $author$project$Ports$register_service_worker_to_js, $elm$json$Json$Encode$null);
var $author$project$Emoji$EmojiResponse$ = function (emoji, shortNames, category, skinVariations) {
	return {category: category, emoji: emoji, shortNames: shortNames, skinVariations: skinVariations};
};
var $author$project$Emoji$EmojiResponse = F4($author$project$Emoji$EmojiResponse$);
var $author$project$Emoji$Activities = 0;
var $author$project$Emoji$AnimalsAndNature = 1;
var $author$project$Emoji$Components = 2;
var $author$project$Emoji$Flags = 3;
var $author$project$Emoji$FoodAndDrink = 4;
var $author$project$Emoji$Objects = 5;
var $author$project$Emoji$PeopleAndBody = 6;
var $author$project$Emoji$Symbols = 8;
var $author$project$Emoji$TravelAndPlaces = 9;
var $author$project$Emoji$allEmojiCategories = _List_fromArray(
	[7, 0, 1, 3, 4, 5, 6, 8, 9, 2]);
var $author$project$Emoji$categoryCodec = $miniBill$elm_codec$Codec$enum$(
	$miniBill$elm_codec$Codec$string,
	$elm$core$List$map$(
		function (category) {
			return _Utils_Tuple2(
				function () {
					switch (category) {
						case 0:
							return 'Activities';
						case 1:
							return 'Animals & Nature';
						case 2:
							return 'Component';
						case 3:
							return 'Flags';
						case 4:
							return 'Food & Drink';
						case 5:
							return 'Objects';
						case 6:
							return 'People & Body';
						case 7:
							return 'Smileys & Emotion';
						case 8:
							return 'Symbols';
						default:
							return 'Travel & Places';
					}
				}(),
				category);
		},
		$author$project$Emoji$allEmojiCategories));
var $elm$core$String$concat = function (strings) {
	return $elm$core$String$join$('', strings);
};
var $elm$core$Basics$pow = _Basics_pow;
var $rtfeldman$elm_hex$Hex$fromStringHelp$ = function (position, chars, accumulated) {
	fromStringHelp:
	while (true) {
		if (!chars.b) {
			return $elm$core$Result$Ok(accumulated);
		} else {
			var _char = chars.a;
			var rest = chars.b;
			switch (_char) {
				case '0':
					var $temp$position = position - 1,
						$temp$chars = rest;
					position = $temp$position;
					chars = $temp$chars;
					continue fromStringHelp;
				case '1':
					var $temp$position = position - 1,
						$temp$chars = rest,
						$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
					position = $temp$position;
					chars = $temp$chars;
					accumulated = $temp$accumulated;
					continue fromStringHelp;
				case '2':
					var $temp$position = position - 1,
						$temp$chars = rest,
						$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
					position = $temp$position;
					chars = $temp$chars;
					accumulated = $temp$accumulated;
					continue fromStringHelp;
				case '3':
					var $temp$position = position - 1,
						$temp$chars = rest,
						$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
					position = $temp$position;
					chars = $temp$chars;
					accumulated = $temp$accumulated;
					continue fromStringHelp;
				case '4':
					var $temp$position = position - 1,
						$temp$chars = rest,
						$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
					position = $temp$position;
					chars = $temp$chars;
					accumulated = $temp$accumulated;
					continue fromStringHelp;
				case '5':
					var $temp$position = position - 1,
						$temp$chars = rest,
						$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
					position = $temp$position;
					chars = $temp$chars;
					accumulated = $temp$accumulated;
					continue fromStringHelp;
				case '6':
					var $temp$position = position - 1,
						$temp$chars = rest,
						$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
					position = $temp$position;
					chars = $temp$chars;
					accumulated = $temp$accumulated;
					continue fromStringHelp;
				case '7':
					var $temp$position = position - 1,
						$temp$chars = rest,
						$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
					position = $temp$position;
					chars = $temp$chars;
					accumulated = $temp$accumulated;
					continue fromStringHelp;
				case '8':
					var $temp$position = position - 1,
						$temp$chars = rest,
						$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
					position = $temp$position;
					chars = $temp$chars;
					accumulated = $temp$accumulated;
					continue fromStringHelp;
				case '9':
					var $temp$position = position - 1,
						$temp$chars = rest,
						$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
					position = $temp$position;
					chars = $temp$chars;
					accumulated = $temp$accumulated;
					continue fromStringHelp;
				case 'a':
					var $temp$position = position - 1,
						$temp$chars = rest,
						$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
					position = $temp$position;
					chars = $temp$chars;
					accumulated = $temp$accumulated;
					continue fromStringHelp;
				case 'b':
					var $temp$position = position - 1,
						$temp$chars = rest,
						$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
					position = $temp$position;
					chars = $temp$chars;
					accumulated = $temp$accumulated;
					continue fromStringHelp;
				case 'c':
					var $temp$position = position - 1,
						$temp$chars = rest,
						$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
					position = $temp$position;
					chars = $temp$chars;
					accumulated = $temp$accumulated;
					continue fromStringHelp;
				case 'd':
					var $temp$position = position - 1,
						$temp$chars = rest,
						$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
					position = $temp$position;
					chars = $temp$chars;
					accumulated = $temp$accumulated;
					continue fromStringHelp;
				case 'e':
					var $temp$position = position - 1,
						$temp$chars = rest,
						$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
					position = $temp$position;
					chars = $temp$chars;
					accumulated = $temp$accumulated;
					continue fromStringHelp;
				case 'f':
					var $temp$position = position - 1,
						$temp$chars = rest,
						$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
					position = $temp$position;
					chars = $temp$chars;
					accumulated = $temp$accumulated;
					continue fromStringHelp;
				default:
					var nonHex = _char;
					return $elm$core$Result$Err(
						$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
			}
		}
	}
};
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3($rtfeldman$elm_hex$Hex$fromStringHelp$);
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = $elm$core$Maybe$withDefault$(
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return $elm$core$Result$map$(
					$elm$core$Basics$negate,
					$rtfeldman$elm_hex$Hex$fromStringHelp$(
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return $rtfeldman$elm_hex$Hex$fromStringHelp$(
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return $elm$core$String$join$(
				' ',
				_List_fromArray(
					['\u0022' + (str + '\u0022'), 'is not a valid hexadecimal string because', err]));
		};
		return $elm$core$Result$mapError$(formatError, result);
	}
};
var $elm$core$String$fromList = _String_fromList;
var $rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
	unsafeToDigit:
	while (true) {
		switch (num) {
			case 0:
				return '0';
			case 1:
				return '1';
			case 2:
				return '2';
			case 3:
				return '3';
			case 4:
				return '4';
			case 5:
				return '5';
			case 6:
				return '6';
			case 7:
				return '7';
			case 8:
				return '8';
			case 9:
				return '9';
			case 10:
				return 'a';
			case 11:
				return 'b';
			case 12:
				return 'c';
			case 13:
				return 'd';
			case 14:
				return 'e';
			case 15:
				return 'f';
			default:
				continue unsafeToDigit;
		}
	}
};
var $rtfeldman$elm_hex$Hex$unsafePositiveToDigits$ = function (digits, num) {
	unsafePositiveToDigits:
	while (true) {
		if (num < 16) {
			return A2(
				$elm$core$List$cons,
				$rtfeldman$elm_hex$Hex$unsafeToDigit(num),
				digits);
		} else {
			var $temp$digits = A2(
				$elm$core$List$cons,
				$rtfeldman$elm_hex$Hex$unsafeToDigit(
					A2($elm$core$Basics$modBy, 16, num)),
				digits),
				$temp$num = (num / 16) | 0;
			digits = $temp$digits;
			num = $temp$num;
			continue unsafePositiveToDigits;
		}
	}
};
var $rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits$);
var $rtfeldman$elm_hex$Hex$toString = function (num) {
	return $elm$core$String$fromList(
		(num < 0) ? A2(
			$elm$core$List$cons,
			'-',
			$rtfeldman$elm_hex$Hex$unsafePositiveToDigits$(_List_Nil, -num)) : $rtfeldman$elm_hex$Hex$unsafePositiveToDigits$(_List_Nil, num));
};
var $author$project$Emoji$charCodeCodec = $miniBill$elm_codec$Codec$map$(
	function (code) {
		return $elm$core$String$concat(
			$elm$core$List$map$(
				function (codePoint) {
					var _v0 = $rtfeldman$elm_hex$Hex$fromString(
						$elm$core$String$toLower(codePoint));
					if (!_v0.$) {
						var code2 = _v0.a;
						return $elm$core$String$fromChar(
							$elm$core$Char$fromCode(code2));
					} else {
						return '?';
					}
				},
				$elm$core$String$split$('-', code)));
	},
	function (text) {
		return $elm$core$String$join$(
			'-',
			$elm$core$List$map$(
				function (_char) {
					return $rtfeldman$elm_hex$Hex$toString(
						$elm$core$Char$toCode(_char));
				},
				$elm$core$String$toList(text)));
	},
	$miniBill$elm_codec$Codec$string);
var $elm$core$Dict$map$ = function (func, dict) {
	if (dict.$ === -2) {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	} else {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var right = dict.e;
		return $elm$core$Dict$RBNode_elm_builtin$(
			color,
			key,
			A2(func, key, value),
			$elm$core$Dict$map$(func, left),
			$elm$core$Dict$map$(func, right));
	}
};
var $elm$core$Dict$map = F2($elm$core$Dict$map$);
var $miniBill$elm_codec$Codec$dict = A2(
	$miniBill$elm_codec$Codec$composite,
	function (e) {
		return A2(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $elm$json$Json$Encode$object, $elm$core$Dict$toList),
			$elm$core$Dict$map(
				function (_v0) {
					return e;
				}));
	},
	$elm$json$Json$Decode$dict);
var $miniBill$elm_codec$Codec$optionalField$ = function (name, getter, codec, _v0) {
	var ocodec = _v0;
	return {
		decoder: A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (f, x) {
					return f(x);
				}),
			ocodec.decoder,
			A2(
				$elm$json$Json$Decode$andThen,
				function (json) {
					return $elm$core$List$any$(
						function (_v1) {
							var k = _v1.a;
							return _Utils_eq(k, name);
						},
						json) ? A2(
						$elm$json$Json$Decode$map,
						$elm$core$Maybe$Just,
						A2(
							$elm$json$Json$Decode$field,
							name,
							$miniBill$elm_codec$Codec$decoder(codec))) : $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
				},
				$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value))),
		encoder: function (v) {
			var _v2 = getter(v);
			if (!_v2.$) {
				var present = _v2.a;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						name,
						A2($miniBill$elm_codec$Codec$encoder, codec, present)),
					ocodec.encoder(v));
			} else {
				return ocodec.encoder(v);
			}
		},
		fields: A2($elm$core$List$cons, name, ocodec.fields)
	};
};
var $miniBill$elm_codec$Codec$optionalField = F4($miniBill$elm_codec$Codec$optionalField$);
var $author$project$Emoji$skinVariationCodec = $miniBill$elm_codec$Codec$buildObject(
	$miniBill$elm_codec$Codec$field$(
		'unified',
		$elm$core$Basics$identity,
		$author$project$Emoji$charCodeCodec,
		$miniBill$elm_codec$Codec$object($elm$core$Basics$identity)));
var $author$project$Emoji$emojiResponseCodec = $miniBill$elm_codec$Codec$buildObject(
	$miniBill$elm_codec$Codec$optionalField$(
		'skin_variations',
		function ($) {
			return $.skinVariations;
		},
		$miniBill$elm_codec$Codec$dict($author$project$Emoji$skinVariationCodec),
		$miniBill$elm_codec$Codec$field$(
			'category',
			function ($) {
				return $.category;
			},
			$author$project$Emoji$categoryCodec,
			$miniBill$elm_codec$Codec$field$(
				'short_names',
				function ($) {
					return $.shortNames;
				},
				$miniBill$elm_codec$Codec$list($miniBill$elm_codec$Codec$string),
				$miniBill$elm_codec$Codec$field$(
					'unified',
					function ($) {
						return $.emoji;
					},
					$author$project$Emoji$charCodeCodec,
					$miniBill$elm_codec$Codec$object($author$project$Emoji$EmojiResponse))))));
var $author$project$Emoji$SkinTone1 = 0;
var $author$project$Emoji$UnicodeEmoji = $elm$core$Basics$identity;
var $author$project$Emoji$SkinTone2 = 1;
var $author$project$Emoji$SkinTone3 = 2;
var $author$project$Emoji$SkinTone4 = 3;
var $author$project$Emoji$SkinTone5 = 4;
var $author$project$Emoji$allSkinTones = _List_fromArray(
	[0, 1, 2, 3, 4]);
var $elm$core$Maybe$andThen$ = function (callback, maybeValue) {
	if (!maybeValue.$) {
		var value = maybeValue.a;
		return callback(value);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Maybe$andThen = F2($elm$core$Maybe$andThen$);
var $author$project$Emoji$animalsNatureSpriteName = 'animals-nature';
var $author$project$Emoji$categorySpriteName = function (emojiCategory) {
	switch (emojiCategory) {
		case 0:
			return 'activities';
		case 1:
			return $author$project$Emoji$animalsNatureSpriteName;
		case 2:
			return 'component';
		case 3:
			return 'flags';
		case 4:
			return 'food-drink';
		case 5:
			return 'objects';
		case 6:
			return 'people-body';
		case 7:
			return 'smileys-emotion';
		case 8:
			return 'symbols';
		default:
			return 'travel-places';
	}
};
var $author$project$Emoji$insertArt$ = function (art, dict) {
	var _v0 = $elm$core$String$uncons(art.sequence);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var firstCharacter = _v1.a;
		return $elm$core$Dict$update$(
			firstCharacter,
			function (maybe) {
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$List$cons,
						art,
						$elm$core$Maybe$withDefault$(_List_Nil, maybe)));
			},
			dict);
	} else {
		return dict;
	}
};
var $author$project$Emoji$insertArt = F2($author$project$Emoji$insertArt$);
var $author$project$Emoji$skinToneSpriteName = function (skinTone) {
	switch (skinTone) {
		case 0:
			return 'tone-1';
		case 1:
			return 'tone-2';
		case 2:
			return 'tone-3';
		case 3:
			return 'tone-4';
		default:
			return 'tone-5';
	}
};
var $author$project$Emoji$skinToneToString = function (skinTone) {
	switch (skinTone) {
		case 0:
			return '🏻';
		case 1:
			return '🏼';
		case 2:
			return '🏽';
		case 3:
			return '🏾';
		default:
			return '🏿';
	}
};
var $elm$core$List$sortBy = _List_sortBy;
var $lamdera$containers$SeqDict$rebuildOnOverflow = function (dict) {
	var rootTriplets = dict.c;
	if ((rootTriplets.size / $elm$core$Array$length(rootTriplets.array)) < 0.8) {
		var helper = F2(
			function (_v0, _v1) {
				var hash = _v0.a;
				var key = _v0.b;
				var value = _v0.c;
				var bitmap = _v1.a;
				var nodes = _v1.b;
				var triplets = _v1.c;
				return $lamdera$containers$SeqDict$insertHelp$(0, hash, key, value, bitmap, nodes, triplets);
			});
		return $lamdera$containers$SeqDict$intDictFoldl$(helper, $lamdera$containers$SeqDict$empty, rootTriplets);
	} else {
		return dict;
	}
};
var $lamdera$containers$SeqDict$intDictRemove$ = function (index, dict) {
	return {
		array: $elm$core$Array$set$(index, $elm$core$Maybe$Nothing, dict.array),
		size: dict.size - 1
	};
};
var $lamdera$containers$SeqDict$intDictRemove = F2($lamdera$containers$SeqDict$intDictRemove$);
var $lamdera$containers$JsArray2$removeIndex = _JsArray2_removeIndex;
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $lamdera$containers$SeqDict$removeHelp$ = function (shift, hash, key, bitmap, nodes, triplets) {
	var uncompIdx = $lamdera$containers$SeqDict$bitMask & (hash >>> shift);
	var mask = 1 << uncompIdx;
	var hasValue = _Utils_eq(bitmap & mask, mask);
	var compIdx = $lamdera$containers$SeqDict$compressedIndex$(uncompIdx, bitmap);
	if (hasValue) {
		var _v0 = A2($lamdera$containers$JsArray2$unsafeGet, compIdx, nodes);
		switch (_v0.$) {
			case 0:
				var eIdx = _v0.b;
				var eKey = _v0.c;
				var eVal = _v0.d;
				return _Utils_eq(eKey, key) ? $lamdera$containers$SeqDict$SeqDict_elm_builtin$(
					bitmap ^ mask,
					A2($lamdera$containers$JsArray2$removeIndex, compIdx, nodes),
					$lamdera$containers$SeqDict$intDictRemove$(eIdx, triplets)) : $lamdera$containers$SeqDict$SeqDict_elm_builtin$(bitmap, nodes, triplets);
			case 1:
				var subBitmap = _v0.a;
				var subNodes = _v0.b;
				var _v1 = $lamdera$containers$SeqDict$removeHelp$(shift + $lamdera$containers$SeqDict$shiftStep, hash, key, subBitmap, subNodes, triplets);
				var newSubBitmap = _v1.a;
				var newSubNodes = _v1.b;
				var newTriplets = _v1.c;
				return (!newSubBitmap) ? $lamdera$containers$SeqDict$SeqDict_elm_builtin$(
					bitmap ^ mask,
					A2($lamdera$containers$JsArray2$removeIndex, compIdx, nodes),
					newTriplets) : $lamdera$containers$SeqDict$SeqDict_elm_builtin$(
					bitmap,
					A3(
						$lamdera$containers$JsArray2$unsafeSet,
						compIdx,
						$lamdera$containers$SeqDict$SubTree$(newSubBitmap, newSubNodes),
						nodes),
					newTriplets);
			default:
				var xHash = _v0.a;
				var vals = _v0.b;
				var maybeIdx = $elm$core$Maybe$map$(
					function (_v8) {
						var idx = _v8.a;
						return idx;
					},
					$lamdera$containers$SeqDict$listFind$(
						function (_v7) {
							var k = _v7.b;
							return _Utils_eq(k, key);
						},
						vals));
				var newCollision = function () {
					if (!maybeIdx.$) {
						var removeIdx = maybeIdx.a;
						return $elm$core$List$filter$(
							function (_v6) {
								var k = _v6.b;
								return !_Utils_eq(k, key);
							},
							vals);
					} else {
						return vals;
					}
				}();
				var newTriplets = function () {
					if (!maybeIdx.$) {
						var removeIdx = maybeIdx.a;
						return $lamdera$containers$SeqDict$intDictRemove$(removeIdx, triplets);
					} else {
						return triplets;
					}
				}();
				if (!newCollision.b) {
					return $lamdera$containers$SeqDict$SeqDict_elm_builtin$(
						bitmap ^ mask,
						A2($lamdera$containers$JsArray2$removeIndex, compIdx, nodes),
						newTriplets);
				} else {
					if (!newCollision.b.b) {
						var _v3 = newCollision.a;
						var eIdx = _v3.a;
						var eKey = _v3.b;
						var eVal = _v3.c;
						return $lamdera$containers$SeqDict$SeqDict_elm_builtin$(
							bitmap,
							A3(
								$lamdera$containers$JsArray2$unsafeSet,
								compIdx,
								$lamdera$containers$SeqDict$Leaf$(xHash, eIdx, eKey, eVal),
								nodes),
							newTriplets);
					} else {
						return $lamdera$containers$SeqDict$SeqDict_elm_builtin$(
							bitmap,
							A3(
								$lamdera$containers$JsArray2$unsafeSet,
								compIdx,
								$lamdera$containers$SeqDict$Collision$(xHash, newCollision),
								nodes),
							newTriplets);
					}
				}
		}
	} else {
		return $lamdera$containers$SeqDict$SeqDict_elm_builtin$(bitmap, nodes, triplets);
	}
};
var $lamdera$containers$SeqDict$removeHelp = F6($lamdera$containers$SeqDict$removeHelp$);
var $lamdera$containers$SeqDict$update$ = function (key, fn, dict) {
	var bitmap = dict.a;
	var nodes = dict.b;
	var triplets = dict.c;
	var hash = $lamdera$containers$FNV$hash(key);
	var _v0 = fn(
		$lamdera$containers$SeqDict$getHelp$(0, hash, key, bitmap, nodes));
	if (_v0.$ === 1) {
		var _v1 = $lamdera$containers$SeqDict$rebuildOnOverflow(dict);
		var bitmap2 = _v1.a;
		var nodes2 = _v1.b;
		var triplets2 = _v1.c;
		return $lamdera$containers$SeqDict$removeHelp$(0, hash, key, bitmap2, nodes2, triplets2);
	} else {
		var value = _v0.a;
		return $lamdera$containers$SeqDict$insertHelp$(0, hash, key, value, bitmap, nodes, triplets);
	}
};
var $lamdera$containers$SeqDict$update = F3($lamdera$containers$SeqDict$update$);
var $author$project$Emoji$fromResponse = function (response) {
	return {
		art: $elm$core$Dict$map$(
			F2(
				function (_v1, list) {
					return $elm$core$Array$fromList(
						A2(
							$elm$core$List$sortBy,
							function (art) {
								return -$elm$core$String$length(art.sequence);
							},
							list));
				}),
			$elm$core$List$foldl$(
				F2(
					function (emoji, dict) {
						return $elm$core$List$foldl$(
							$author$project$Emoji$insertArt,
							dict,
							A2(
								$elm$core$List$cons,
								{
									sequence: emoji.emoji,
									sprite: $author$project$Emoji$categorySpriteName(emoji.category)
								},
								function () {
									var _v0 = $elm$core$Maybe$andThen$(
										$elm$core$Dict$get('1F3FB'),
										emoji.skinVariations);
									if (!_v0.$) {
										var tone1 = _v0.a;
										return $elm$core$List$map$(
											function (skinTone) {
												return {
													sequence: $elm$core$String$replace$(
														$author$project$Emoji$skinToneToString(0),
														$author$project$Emoji$skinToneToString(skinTone),
														tone1),
													sprite: $author$project$Emoji$skinToneSpriteName(skinTone)
												};
											},
											$author$project$Emoji$allSkinTones);
									} else {
										return _List_Nil;
									}
								}()));
					}),
				$elm$core$Dict$empty,
				response)),
		categories: $elm$core$List$foldl$(
			F2(
				function (emoji, dict) {
					return $lamdera$containers$SeqDict$update$(
						emoji.category,
						function (maybe) {
							return $elm$core$Maybe$Just(
								A2(
									$elm$core$List$cons,
									emoji.emoji,
									$elm$core$Maybe$withDefault$(_List_Nil, maybe)));
						},
						dict);
				}),
			$lamdera$containers$SeqDict$fromList(
				$elm$core$List$map$(
					function (category) {
						return _Utils_Tuple2(category, _List_Nil);
					},
					$author$project$Emoji$allEmojiCategories)),
			response),
		emojis: $elm$core$List$foldl$(
			F2(
				function (emoji, dict) {
					return $lamdera$containers$SeqDict$insert$(
						emoji.emoji,
						{
							category: emoji.category,
							shortNames: emoji.shortNames,
							skinVariations: $elm$core$Maybe$andThen$(
								$elm$core$Dict$get('1F3FB'),
								emoji.skinVariations)
						},
						dict);
				}),
			$lamdera$containers$SeqDict$empty,
			response),
		shortNames: $elm$core$Array$fromList(
			$elm$core$List$concatMap$(
				function (emoji) {
					return $elm$core$List$map$(
						function (shortName) {
							return {emoji: emoji.emoji, shortName: shortName};
						},
						emoji.shortNames);
				},
				response))
	};
};
var $author$project$Emoji$requestEmojiData = function (gotEmojiData) {
	return $lamdera$program_test$Effect$Http$get(
		{
			expect: $lamdera$program_test$Effect$Http$expectJson$(
				function (result) {
					return gotEmojiData(
						$elm$core$Result$map$($author$project$Emoji$fromResponse, result));
				},
				$miniBill$elm_codec$Codec$decoder(
					$miniBill$elm_codec$Codec$list($author$project$Emoji$emojiResponseCodec))),
			url: '/cacheable/compact-emoji.json'
		});
};
var $author$project$FrontendExtra$routeReplace$ = function (model, route) {
	return $lamdera$program_test$Effect$Browser$Navigation$replaceUrl$(
		model.navigationKey,
		$author$project$Route$encode(route));
};
var $author$project$FrontendExtra$routeReplace = F2($author$project$FrontendExtra$routeReplace$);
var $author$project$Types$AdminDataRequest = function (a) {
	return {$: 16, a: a};
};
var $author$project$Types$JoinGuildByInviteRequest$ = function (a, b) {
	return {$: 9, a: a, b: b};
};
var $author$project$Types$JoinGuildByInviteRequest = F2($author$project$Types$JoinGuildByInviteRequest$);
var $author$project$Types$LinkDiscordRequest = function (a) {
	return {$: 13, a: a};
};
var $author$project$Types$SetFocus = {$: 39};
var $author$project$Types$SetScrollToBottom = {$: 56};
var $author$project$LocalState$announcementChannel = function (guild) {
	return $elm$core$Maybe$withDefault$(
		$author$project$Id$fromInt(0),
		$elm$core$List$head(
			$lamdera$containers$SeqDict$keys(guild.channels)));
};
var $author$project$FrontendExtra$clearRevealedSpoilers = function (model) {
	return _Utils_update(
		model,
		{
			loginStatus: function () {
				var _v0 = model.loginStatus;
				if (!_v0.$) {
					var loggedIn = _v0.a;
					return $author$project$Types$LoggedIn(
						_Utils_update(
							loggedIn,
							{revealedSpoilers: $lamdera$containers$SeqDict$empty}));
				} else {
					return model.loginStatus;
				}
			}()
		});
};
var $author$project$Pages$Guild$conversationContainerId = $lamdera$program_test$Effect$Browser$Dom$id('conversationContainer');
var $elm$core$Tuple$mapSecond$ = function (func, _v0) {
	var x = _v0.a;
	var y = _v0.b;
	return _Utils_Tuple2(
		x,
		func(y));
};
var $elm$core$Tuple$mapSecond = F2($elm$core$Tuple$mapSecond$);
var $author$project$UserSession$EmptyPlaceholder = {$: 0};
var $author$project$Game$LoadMatch$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Game$LoadMatch = F2($author$project$Game$LoadMatch$);
var $author$project$Types$Local_Game$ = function (a, b) {
	return {$: 57, a: a, b: b};
};
var $author$project$Types$Local_Game = F2($author$project$Types$Local_Game$);
var $author$project$Types$ScrolledToMessage = {$: 67};
var $author$project$FrontendExtra$channelGames$ = function (guildOrDmId, local) {
	if (guildOrDmId.$ === 1) {
		var otherUserId = guildOrDmId.a.otherUserId;
		var _v1 = $lamdera$containers$SeqDict$get$(otherUserId, local.dmChannels);
		if (!_v1.$) {
			var dmChannel = _v1.a;
			return dmChannel.games;
		} else {
			return $lamdera$containers$SeqDict$empty;
		}
	} else {
		var id = guildOrDmId.a;
		var _v2 = $author$project$LocalState$getGuildAndChannel$(id, local);
		if (!_v2.$) {
			var _v3 = _v2.a;
			var channel = _v3.b;
			return channel.games;
		} else {
			return $lamdera$containers$SeqDict$empty;
		}
	}
};
var $author$project$FrontendExtra$channelGames = F2($author$project$FrontendExtra$channelGames$);
var $author$project$Pages$Guild$channelMessageHtmlId = function (messageIndex) {
	return $lamdera$program_test$Effect$Browser$Dom$id(
		'guild_message_' + $author$project$Id$toString(messageIndex));
};
var $author$project$Pages$Guild$channelTextInputId = $lamdera$program_test$Effect$Browser$Dom$id('channel_textinput');
var $author$project$Types$LocalChange$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Types$LocalChange = F2($author$project$Types$LocalChange$);
var $author$project$Types$LocalModelChangeRequest$ = function (a, b) {
	return {$: 7, a: a, b: b};
};
var $author$project$Types$LocalModelChangeRequest = F2($author$project$Types$LocalModelChangeRequest$);
var $author$project$GuildColumn$canChangeUnreadNotificationCount = function (change) {
	switch (change.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return true;
		case 3:
			return true;
		case 4:
			return true;
		case 6:
			return true;
		case 7:
			return true;
		case 8:
			return true;
		case 9:
			return false;
		case 10:
			return true;
		case 11:
			return false;
		case 12:
			return true;
		case 13:
			return true;
		case 14:
			return false;
		case 15:
			return false;
		case 16:
			return true;
		case 17:
			return true;
		case 18:
			return false;
		case 19:
			return false;
		case 20:
			return false;
		case 21:
			return false;
		case 22:
			return false;
		case 23:
			return false;
		case 5:
			return false;
		case 24:
			return false;
		case 25:
			return true;
		case 26:
			return false;
		case 27:
			return true;
		case 28:
			return false;
		case 29:
			return false;
		case 30:
			return false;
		case 33:
			return false;
		case 31:
			return false;
		case 32:
			return false;
		case 34:
			return false;
		case 35:
			return true;
		case 36:
			return true;
		case 38:
			return false;
		case 39:
			return false;
		case 40:
			return false;
		case 41:
			return false;
		case 42:
			return false;
		case 43:
			return false;
		case 44:
			return false;
		case 45:
			return false;
		case 46:
			return false;
		case 47:
			return false;
		case 48:
			return true;
		case 49:
			return true;
		case 50:
			return false;
		case 51:
			return false;
		case 52:
			return false;
		case 53:
			return false;
		case 54:
			return false;
		case 55:
			return false;
		case 56:
			return true;
		case 57:
			return true;
		case 58:
			return false;
		case 59:
			return true;
		case 60:
			return true;
		case 61:
			return true;
		case 62:
			return true;
		case 63:
			return true;
		case 64:
			return true;
		case 37:
			return true;
		case 65:
			return true;
		case 66:
			return true;
		case 67:
			return true;
		case 68:
			return false;
		case 69:
			return false;
		case 70:
			return false;
		case 71:
			return false;
		case 72:
			return false;
		case 73:
			return false;
		case 74:
			return false;
		case 75:
			return false;
		case 76:
			return false;
		case 77:
			return true;
		default:
			return false;
	}
};
var $author$project$Message$ChangeAttachments = function (a) {
	return {$: 0, a: a};
};
var $author$project$DiscordUserData$DiscordUserLoadedSuccessfully = {$: 0};
var $author$project$DiscordUserData$DiscordUserLoadingFailed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Message$DoNotChangeAttachments = {$: 1};
var $author$project$DmChannel$E2eeDeclinedBy = function (a) {
	return {$: 2, a: a};
};
var $author$project$DmChannel$E2eeEnabled = function (a) {
	return {$: 3, a: a};
};
var $author$project$DmChannel$E2eeRequestedBy = function (a) {
	return {$: 1, a: a};
};
var $author$project$Message$NoReply = {$: 0};
var $author$project$Id$NoThreadWithMessage = function (a) {
	return {$: 0, a: a};
};
var $author$project$UserSession$Subscribed$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$UserSession$Subscribed = F2($author$project$UserSession$Subscribed$);
var $author$project$UserSession$SubscriptionError$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$UserSession$SubscriptionError = F2($author$project$UserSession$SubscriptionError$);
var $author$project$UserSession$SubscriptionJsException$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$UserSession$SubscriptionJsException = F2($author$project$UserSession$SubscriptionJsException$);
var $author$project$Message$UserJoinedMessage$ = function (a, b, c, d) {
	return {$: 2, a: a, b: b, c: c, d: d};
};
var $author$project$Message$UserJoinedMessage = F4($author$project$Message$UserJoinedMessage$);
var $author$project$Id$ViewThreadWithMessage$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Id$ViewThreadWithMessage = F2($author$project$Id$ViewThreadWithMessage$);
var $author$project$OneOrGreater$increment = function (_v0) {
	var a = _v0;
	return a + 1;
};
var $author$project$OneOrGreater$one = 1;
var $author$project$NonemptyDict$NonemptyDict$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $author$project$NonemptyDict$NonemptyDict = F3($author$project$NonemptyDict$NonemptyDict$);
var $author$project$NonemptyDict$singleton$ = function (key, value) {
	return $author$project$NonemptyDict$NonemptyDict$(key, value, $lamdera$containers$SeqDict$empty);
};
var $author$project$NonemptyDict$singleton = F2($author$project$NonemptyDict$singleton$);
var $author$project$NonemptyDict$get$ = function (targetKey, _v0) {
	var id = _v0.a;
	var a = _v0.b;
	var dict = _v0.c;
	return _Utils_eq(targetKey, id) ? $elm$core$Maybe$Just(a) : $lamdera$containers$SeqDict$get$(targetKey, dict);
};
var $author$project$NonemptyDict$get = F2($author$project$NonemptyDict$get$);
var $author$project$NonemptyDict$insert$ = function (id, value, _v0) {
	var id2 = _v0.a;
	var a = _v0.b;
	var dict = _v0.c;
	return _Utils_eq(id, id2) ? $author$project$NonemptyDict$NonemptyDict$(id2, value, dict) : ($lamdera$containers$SeqDict$member$(id, dict) ? $author$project$NonemptyDict$NonemptyDict$(
		id2,
		a,
		$lamdera$containers$SeqDict$insert$(id, value, dict)) : $author$project$NonemptyDict$NonemptyDict$(
		id,
		value,
		$lamdera$containers$SeqDict$insert$(id2, a, dict)));
};
var $author$project$NonemptyDict$insert = F3($author$project$NonemptyDict$insert$);
var $lamdera$containers$SeqDict$updateIfExists$ = function (key, fn, dict) {
	var bitmap = dict.a;
	var nodes = dict.b;
	var triplets = dict.c;
	var hash = $lamdera$containers$FNV$hash(key);
	var _v0 = $lamdera$containers$SeqDict$getHelp$(0, hash, key, bitmap, nodes);
	if (_v0.$ === 1) {
		return dict;
	} else {
		var value = _v0.a;
		return $lamdera$containers$SeqDict$insertHelp$(
			0,
			hash,
			key,
			fn(value),
			bitmap,
			nodes,
			triplets);
	}
};
var $lamdera$containers$SeqDict$updateIfExists = F3($lamdera$containers$SeqDict$updateIfExists$);
var $author$project$NonemptyDict$updateIfExists$ = function (targetKey, alter, _v0) {
	var id = _v0.a;
	var a = _v0.b;
	var dict = _v0.c;
	return _Utils_eq(targetKey, id) ? $author$project$NonemptyDict$NonemptyDict$(
		id,
		alter(a),
		dict) : $author$project$NonemptyDict$NonemptyDict$(
		id,
		a,
		$lamdera$containers$SeqDict$updateIfExists$(targetKey, alter, dict));
};
var $author$project$NonemptyDict$updateIfExists = F3($author$project$NonemptyDict$updateIfExists$);
var $author$project$NonemptyDict$updateOrInsert$ = function (targetKey, alter, dict) {
	var _v0 = $author$project$NonemptyDict$get$(targetKey, dict);
	if (!_v0.$) {
		var value = _v0.a;
		return $author$project$NonemptyDict$updateIfExists$(
			targetKey,
			function (_v1) {
				return alter(
					$elm$core$Maybe$Just(value));
			},
			dict);
	} else {
		return $author$project$NonemptyDict$insert$(
			targetKey,
			alter($elm$core$Maybe$Nothing),
			dict);
	}
};
var $author$project$NonemptyDict$updateOrInsert = F3($author$project$NonemptyDict$updateOrInsert$);
var $author$project$User$addDirectMentionHelper$ = function (guildId, channelId, threadRoute) {
	return A2(
		$lamdera$containers$SeqDict$update,
		guildId,
		function (maybeDict) {
			if (!maybeDict.$) {
				var dict = maybeDict.a;
				return $elm$core$Maybe$Just(
					$author$project$NonemptyDict$updateOrInsert$(
						_Utils_Tuple2(channelId, threadRoute),
						function (maybeCount) {
							if (!maybeCount.$) {
								var count = maybeCount.a;
								return $author$project$OneOrGreater$increment(count);
							} else {
								return $author$project$OneOrGreater$one;
							}
						},
						dict));
			} else {
				return $elm$core$Maybe$Just(
					$author$project$NonemptyDict$singleton$(
						_Utils_Tuple2(channelId, threadRoute),
						$author$project$OneOrGreater$one));
			}
		});
};
var $author$project$User$addDirectMentionHelper = F3($author$project$User$addDirectMentionHelper$);
var $author$project$User$addDirectMention$ = function (guildId, channelId, threadRoute, user) {
	return _Utils_update(
		user,
		{
			directMentions: A4($author$project$User$addDirectMentionHelper, guildId, channelId, threadRoute, user.directMentions)
		});
};
var $author$project$User$addDirectMention = F4($author$project$User$addDirectMention$);
var $author$project$User$addDiscordDirectMention$ = function (guildId, channelId, threadRoute, user) {
	return _Utils_update(
		user,
		{
			discordDirectMentions: A4($author$project$User$addDirectMentionHelper, guildId, channelId, threadRoute, user.discordDirectMentions)
		});
};
var $author$project$User$addDiscordDirectMention = F4($author$project$User$addDiscordDirectMention$);
var $author$project$Message$UserTextMessage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Embed$empty = {createdAt: $elm$core$Maybe$Nothing, description: $elm$core$Maybe$Nothing, image: $elm$core$Maybe$Nothing, title: $elm$core$Maybe$Nothing};
var $mgold$elm_nonempty_list$List$Nonempty$fromList = function (ys) {
	if (ys.b) {
		var x = ys.a;
		var xs = ys.b;
		return $elm$core$Maybe$Just(
			$mgold$elm_nonempty_list$List$Nonempty$Nonempty$(x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$RichText$bulletItemConcatMap$ = function (f, item) {
	var _v0 = $mgold$elm_nonempty_list$List$Nonempty$fromList(item);
	if (!_v0.$) {
		var nonempty = _v0.a;
		return f(nonempty);
	} else {
		return _List_Nil;
	}
};
var $author$project$RichText$bulletItemConcatMap = F2($author$project$RichText$bulletItemConcatMap$);
var $author$project$RichText$hyperlinks = function (nonempty) {
	return $elm$core$List$concatMap$(
		function (richText) {
			switch (richText.$) {
				case 10:
					var data = richText.a;
					return _List_fromArray(
						[data]);
				case 11:
					var url = richText.b;
					return _List_fromArray(
						[url]);
				case 0:
					return _List_Nil;
				case 1:
					return _List_Nil;
				case 2:
					return _List_Nil;
				case 3:
					var nonempty2 = richText.a;
					return $author$project$RichText$hyperlinks(nonempty2);
				case 4:
					var nonempty2 = richText.a;
					return $author$project$RichText$hyperlinks(nonempty2);
				case 5:
					var nonempty2 = richText.a;
					return $author$project$RichText$hyperlinks(nonempty2);
				case 6:
					var nonempty2 = richText.a;
					return $author$project$RichText$hyperlinks(nonempty2);
				case 7:
					var nonempty2 = richText.a;
					return $author$project$RichText$hyperlinks(nonempty2);
				case 8:
					var list = richText.b;
					return $elm$core$Maybe$withDefault$(
						_List_Nil,
						$elm$core$Maybe$map$(
							$author$project$RichText$hyperlinks,
							$mgold$elm_nonempty_list$List$Nonempty$fromList(list)));
				case 9:
					var nonempty2 = richText.c;
					return $author$project$RichText$hyperlinks(nonempty2);
				case 12:
					return _List_Nil;
				case 13:
					return _List_Nil;
				case 14:
					return _List_Nil;
				case 15:
					return _List_Nil;
				case 16:
					return _List_Nil;
				case 17:
					return _List_Nil;
				case 18:
					var items = richText.b;
					return $elm$core$List$concatMap$(
						$author$project$RichText$bulletItemConcatMap($author$project$RichText$hyperlinks),
						$mgold$elm_nonempty_list$List$Nonempty$toList(items));
				default:
					return _List_Nil;
			}
		},
		$mgold$elm_nonempty_list$List$Nonempty$toList(nonempty));
};
var $author$project$Message$addEmbed$ = function (_v0, message) {
	var url = _v0.a;
	var result = _v0.b;
	switch (message.$) {
		case 0:
			var message2 = message.a;
			var contentAndEmbeds = message2.content;
			return $author$project$Message$UserTextMessage(
				_Utils_update(
					message2,
					{
						content: _Utils_update(
							contentAndEmbeds,
							{
								embeds: $elm$core$List$foldl$(
									F2(
										function (_v2, array) {
											var index = _v2.a;
											var hyperlink = _v2.b;
											return _Utils_eq(hyperlink, url) ? $elm$core$Array$set$(
												index,
												function () {
													if (!result.$) {
														var embed = result.a;
														return $author$project$Embed$EmbedLoaded(embed);
													} else {
														return $author$project$Embed$EmbedLoaded($author$project$Embed$empty);
													}
												}(),
												array) : array;
										}),
									contentAndEmbeds.embeds,
									$elm$core$List$indexedMap$(
										$elm$core$Tuple$pair,
										$author$project$RichText$hyperlinks(contentAndEmbeds.content)))
							})
					}));
		case 1:
			return message;
		case 2:
			return message;
		case 3:
			return message;
		case 4:
			return message;
		default:
			return message;
	}
};
var $author$project$Message$addEmbed = F2($author$project$Message$addEmbed$);
var $elm$core$Array$getHelp$ = function (shift, index, tree) {
	getHelp:
	while (true) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_v0.$) {
			var subTree = _v0.a;
			var $temp$shift = shift - $elm$core$Array$shiftStep,
				$temp$tree = subTree;
			shift = $temp$shift;
			tree = $temp$tree;
			continue getHelp;
		} else {
			var values = _v0.a;
			return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
		}
	}
};
var $elm$core$Array$getHelp = F3($elm$core$Array$getHelp$);
var $elm$core$Array$get$ = function (index, _v0) {
	var len = _v0.a;
	var startShift = _v0.b;
	var tree = _v0.c;
	var tail = _v0.d;
	return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
		index,
		$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
		A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
		$elm$core$Array$getHelp$(startShift, index, tree)));
};
var $elm$core$Array$get = F2($elm$core$Array$get$);
var $author$project$MessageArray$lowerBoundHelper$ = function (index, low, high, runs) {
	lowerBoundHelper:
	while (true) {
		if (_Utils_cmp(low, high) > -1) {
			return low;
		} else {
			var middle = low + (((high - low) / 2) | 0);
			var _v0 = $elm$core$Array$get$(middle, runs);
			if (!_v0.$) {
				var run = _v0.a;
				if (_Utils_cmp(
					$author$project$MessageArray$runEnd(run),
					index) < 1) {
					var $temp$low = middle + 1;
					low = $temp$low;
					continue lowerBoundHelper;
				} else {
					var $temp$high = middle;
					high = $temp$high;
					continue lowerBoundHelper;
				}
			} else {
				return low;
			}
		}
	}
};
var $author$project$MessageArray$lowerBoundHelper = F4($author$project$MessageArray$lowerBoundHelper$);
var $author$project$MessageArray$lowerBound$ = function (index, runs) {
	return $author$project$MessageArray$lowerBoundHelper$(
		index,
		0,
		$elm$core$Array$length(runs),
		runs);
};
var $author$project$MessageArray$lowerBound = F2($author$project$MessageArray$lowerBound$);
var $author$project$MessageArray$get$ = function (id, _v0) {
	var array = _v0;
	var index = $author$project$Id$toInt(id);
	if ((_Utils_cmp(index, array.start) < 0) || (_Utils_cmp(index, array.end) > -1)) {
		return $elm$core$Maybe$Nothing;
	} else {
		var _v1 = $elm$core$Array$get$(
			$author$project$MessageArray$lowerBound$(index, array.runs),
			array.runs);
		if (!_v1.$) {
			var run = _v1.a;
			return (_Utils_cmp(run.start, index) < 1) ? $elm$core$Array$get$(index - run.start, run.values) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$MessageArray$get = F2($author$project$MessageArray$get$);
var $elm$core$Elm$JsArray$appendN = _JsArray_appendN;
var $elm$core$Elm$JsArray$slice = _JsArray_slice;
var $elm$core$Array$appendHelpBuilder$ = function (tail, builder) {
	var tailLen = $elm$core$Elm$JsArray$length(tail);
	var notAppended = ($elm$core$Array$branchFactor - $elm$core$Elm$JsArray$length(builder.tail)) - tailLen;
	var appended = A3($elm$core$Elm$JsArray$appendN, $elm$core$Array$branchFactor, builder.tail, tail);
	return (notAppended < 0) ? {
		nodeList: A2(
			$elm$core$List$cons,
			$elm$core$Array$Leaf(appended),
			builder.nodeList),
		nodeListSize: builder.nodeListSize + 1,
		tail: A3($elm$core$Elm$JsArray$slice, notAppended, tailLen, tail)
	} : ((!notAppended) ? {
		nodeList: A2(
			$elm$core$List$cons,
			$elm$core$Array$Leaf(appended),
			builder.nodeList),
		nodeListSize: builder.nodeListSize + 1,
		tail: $elm$core$Elm$JsArray$empty
	} : {nodeList: builder.nodeList, nodeListSize: builder.nodeListSize, tail: appended});
};
var $elm$core$Array$appendHelpBuilder = F2($elm$core$Array$appendHelpBuilder$);
var $elm$core$Array$appendHelpTree$ = function (toAppend, array) {
	var len = array.a;
	var tree = array.c;
	var tail = array.d;
	var itemsToAppend = $elm$core$Elm$JsArray$length(toAppend);
	var notAppended = ($elm$core$Array$branchFactor - $elm$core$Elm$JsArray$length(tail)) - itemsToAppend;
	var appended = A3($elm$core$Elm$JsArray$appendN, $elm$core$Array$branchFactor, tail, toAppend);
	var newArray = $elm$core$Array$unsafeReplaceTail$(appended, array);
	if (notAppended < 0) {
		var nextTail = A3($elm$core$Elm$JsArray$slice, notAppended, itemsToAppend, toAppend);
		return $elm$core$Array$unsafeReplaceTail$(nextTail, newArray);
	} else {
		return newArray;
	}
};
var $elm$core$Array$appendHelpTree = F2($elm$core$Array$appendHelpTree$);
var $elm$core$Array$builderFromArray = function (_v0) {
	var len = _v0.a;
	var tree = _v0.c;
	var tail = _v0.d;
	var helper = F2(
		function (node, acc) {
			if (!node.$) {
				var subTree = node.a;
				return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
			} else {
				return A2($elm$core$List$cons, node, acc);
			}
		});
	return {
		nodeList: A3($elm$core$Elm$JsArray$foldl, helper, _List_Nil, tree),
		nodeListSize: (len / $elm$core$Array$branchFactor) | 0,
		tail: tail
	};
};
var $elm$core$Array$append$ = function (a, _v0) {
	var aTail = a.d;
	var bLen = _v0.a;
	var bTree = _v0.c;
	var bTail = _v0.d;
	if (_Utils_cmp(bLen, $elm$core$Array$branchFactor * 4) < 1) {
		var foldHelper = F2(
			function (node, array) {
				if (!node.$) {
					var tree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, foldHelper, array, tree);
				} else {
					var leaf = node.a;
					return $elm$core$Array$appendHelpTree$(leaf, array);
				}
			});
		return $elm$core$Array$appendHelpTree$(
			bTail,
			A3($elm$core$Elm$JsArray$foldl, foldHelper, a, bTree));
	} else {
		var foldHelper = F2(
			function (node, builder) {
				if (!node.$) {
					var tree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, foldHelper, builder, tree);
				} else {
					var leaf = node.a;
					return $elm$core$Array$appendHelpBuilder$(leaf, builder);
				}
			});
		return $elm$core$Array$builderToArray$(
			true,
			$elm$core$Array$appendHelpBuilder$(
				bTail,
				A3(
					$elm$core$Elm$JsArray$foldl,
					foldHelper,
					$elm$core$Array$builderFromArray(a),
					bTree)));
	}
};
var $elm$core$Array$append = F2($elm$core$Array$append$);
var $elm$core$Array$repeat$ = function (n, e) {
	return $elm$core$Array$initialize$(
		n,
		function (_v0) {
			return e;
		});
};
var $elm$core$Array$repeat = F2($elm$core$Array$repeat$);
var $elm$core$Array$sliceLeft$ = function (from, array) {
	var len = array.a;
	var tree = array.c;
	var tail = array.d;
	if (!from) {
		return array;
	} else {
		if (_Utils_cmp(
			from,
			$elm$core$Array$tailIndex(len)) > -1) {
			return $elm$core$Array$Array_elm_builtin$(
				len - from,
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				A3(
					$elm$core$Elm$JsArray$slice,
					from - $elm$core$Array$tailIndex(len),
					$elm$core$Elm$JsArray$length(tail),
					tail));
		} else {
			var skipNodes = (from / $elm$core$Array$branchFactor) | 0;
			var helper = F2(
				function (node, acc) {
					if (!node.$) {
						var subTree = node.a;
						return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
					} else {
						var leaf = node.a;
						return A2($elm$core$List$cons, leaf, acc);
					}
				});
			var leafNodes = A3(
				$elm$core$Elm$JsArray$foldr,
				helper,
				_List_fromArray(
					[tail]),
				tree);
			var nodesToInsert = $elm$core$List$drop$(skipNodes, leafNodes);
			if (!nodesToInsert.b) {
				return $elm$core$Array$empty;
			} else {
				var head = nodesToInsert.a;
				var rest = nodesToInsert.b;
				var firstSlice = from - (skipNodes * $elm$core$Array$branchFactor);
				var initialBuilder = {
					nodeList: _List_Nil,
					nodeListSize: 0,
					tail: A3(
						$elm$core$Elm$JsArray$slice,
						firstSlice,
						$elm$core$Elm$JsArray$length(head),
						head)
				};
				return $elm$core$Array$builderToArray$(
					true,
					$elm$core$List$foldl$($elm$core$Array$appendHelpBuilder, initialBuilder, rest));
			}
		}
	}
};
var $elm$core$Array$sliceLeft = F2($elm$core$Array$sliceLeft$);
var $elm$core$Array$fetchNewTail$ = function (shift, end, treeEnd, tree) {
	fetchNewTail:
	while (true) {
		var pos = $elm$core$Array$bitMask & (treeEnd >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_v0.$) {
			var sub = _v0.a;
			var $temp$shift = shift - $elm$core$Array$shiftStep,
				$temp$tree = sub;
			shift = $temp$shift;
			tree = $temp$tree;
			continue fetchNewTail;
		} else {
			var values = _v0.a;
			return A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, values);
		}
	}
};
var $elm$core$Array$fetchNewTail = F4($elm$core$Array$fetchNewTail$);
var $elm$core$Array$hoistTree$ = function (oldShift, newShift, tree) {
	hoistTree:
	while (true) {
		if ((_Utils_cmp(oldShift, newShift) < 1) || (!$elm$core$Elm$JsArray$length(tree))) {
			return tree;
		} else {
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, 0, tree);
			if (!_v0.$) {
				var sub = _v0.a;
				var $temp$oldShift = oldShift - $elm$core$Array$shiftStep,
					$temp$tree = sub;
				oldShift = $temp$oldShift;
				tree = $temp$tree;
				continue hoistTree;
			} else {
				return tree;
			}
		}
	}
};
var $elm$core$Array$hoistTree = F3($elm$core$Array$hoistTree$);
var $elm$core$Array$sliceTree$ = function (shift, endIdx, tree) {
	var lastPos = $elm$core$Array$bitMask & (endIdx >>> shift);
	var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, lastPos, tree);
	if (!_v0.$) {
		var sub = _v0.a;
		var newSub = $elm$core$Array$sliceTree$(shift - $elm$core$Array$shiftStep, endIdx, sub);
		return (!$elm$core$Elm$JsArray$length(newSub)) ? A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree) : A3(
			$elm$core$Elm$JsArray$unsafeSet,
			lastPos,
			$elm$core$Array$SubTree(newSub),
			A3($elm$core$Elm$JsArray$slice, 0, lastPos + 1, tree));
	} else {
		return A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree);
	}
};
var $elm$core$Array$sliceTree = F3($elm$core$Array$sliceTree$);
var $elm$core$Array$sliceRight$ = function (end, array) {
	var len = array.a;
	var startShift = array.b;
	var tree = array.c;
	var tail = array.d;
	if (_Utils_eq(end, len)) {
		return array;
	} else {
		if (_Utils_cmp(
			end,
			$elm$core$Array$tailIndex(len)) > -1) {
			return $elm$core$Array$Array_elm_builtin$(
				end,
				startShift,
				tree,
				A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, tail));
		} else {
			var endIdx = $elm$core$Array$tailIndex(end);
			var depth = $elm$core$Basics$floor(
				$elm$core$Basics$logBase$(
					$elm$core$Array$branchFactor,
					$elm$core$Basics$max$(1, endIdx - 1)));
			var newShift = $elm$core$Basics$max$(5, depth * $elm$core$Array$shiftStep);
			return $elm$core$Array$Array_elm_builtin$(
				end,
				newShift,
				$elm$core$Array$hoistTree$(
					startShift,
					newShift,
					$elm$core$Array$sliceTree$(startShift, endIdx, tree)),
				$elm$core$Array$fetchNewTail$(startShift, end, endIdx, tree));
		}
	}
};
var $elm$core$Array$sliceRight = F2($elm$core$Array$sliceRight$);
var $elm$core$Array$translateIndex$ = function (index, _v0) {
	var len = _v0.a;
	var posIndex = (index < 0) ? (len + index) : index;
	return (posIndex < 0) ? 0 : ((_Utils_cmp(posIndex, len) > 0) ? len : posIndex);
};
var $elm$core$Array$translateIndex = F2($elm$core$Array$translateIndex$);
var $elm$core$Array$slice$ = function (from, to, array) {
	var correctTo = $elm$core$Array$translateIndex$(to, array);
	var correctFrom = $elm$core$Array$translateIndex$(from, array);
	return (_Utils_cmp(correctFrom, correctTo) > 0) ? $elm$core$Array$empty : $elm$core$Array$sliceLeft$(
		correctFrom,
		$elm$core$Array$sliceRight$(correctTo, array));
};
var $elm$core$Array$slice = F3($elm$core$Array$slice$);
var $author$project$MessageArray$insertAt$ = function (index, value, position, runs) {
	var previous = function () {
		var _v6 = $elm$core$Array$get$(position - 1, runs);
		if (!_v6.$) {
			var run = _v6.a;
			return _Utils_eq(
				$author$project$MessageArray$runEnd(run),
				index) ? $elm$core$Maybe$Just(run) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	var next = function () {
		var _v5 = $elm$core$Array$get$(position, runs);
		if (!_v5.$) {
			var run = _v5.a;
			return _Utils_eq(run.start, index + 1) ? $elm$core$Maybe$Just(run) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	var _v0 = _Utils_Tuple2(previous, next);
	if (!_v0.a.$) {
		if (!_v0.b.$) {
			var previous2 = _v0.a.a;
			var next2 = _v0.b.a;
			return $elm$core$Array$append$(
				$elm$core$Array$set$(
					position - 1,
					_Utils_update(
						previous2,
						{
							values: $elm$core$Array$append$(
								$elm$core$Array$push$(value, previous2.values),
								next2.values)
						}),
					$elm$core$Array$slice$(0, position, runs)),
				$elm$core$Array$slice$(
					position + 1,
					$elm$core$Array$length(runs),
					runs));
		} else {
			var previous2 = _v0.a.a;
			var _v1 = _v0.b;
			return $elm$core$Array$set$(
				position - 1,
				_Utils_update(
					previous2,
					{
						values: $elm$core$Array$push$(value, previous2.values)
					}),
				runs);
		}
	} else {
		if (!_v0.b.$) {
			var _v2 = _v0.a;
			var next2 = _v0.b.a;
			return $elm$core$Array$set$(
				position,
				{
					start: index,
					values: $elm$core$Array$append$(
						$elm$core$Array$repeat$(1, value),
						next2.values)
				},
				runs);
		} else {
			var _v3 = _v0.a;
			var _v4 = _v0.b;
			return $elm$core$Array$append$(
				$elm$core$Array$push$(
					{
						start: index,
						values: $elm$core$Array$repeat$(1, value)
					},
					$elm$core$Array$slice$(0, position, runs)),
				$elm$core$Array$slice$(
					position,
					$elm$core$Array$length(runs),
					runs));
		}
	}
};
var $author$project$MessageArray$insertAt = F4($author$project$MessageArray$insertAt$);
var $author$project$MessageArray$set$ = function (id, value, _v0) {
	var array = _v0;
	var index = $author$project$Id$toInt(id);
	if ((_Utils_cmp(index, array.start) < 0) || (_Utils_cmp(index, array.end) > -1)) {
		return array;
	} else {
		var position = $author$project$MessageArray$lowerBound$(index, array.runs);
		var _v1 = $elm$core$Array$get$(position, array.runs);
		if (!_v1.$) {
			var run = _v1.a;
			return (_Utils_cmp(run.start, index) < 1) ? _Utils_update(
				array,
				{
					runs: $elm$core$Array$set$(
						position,
						_Utils_update(
							run,
							{
								values: $elm$core$Array$set$(index - run.start, value, run.values)
							}),
						array.runs)
				}) : _Utils_update(
				array,
				{
					runs: $author$project$MessageArray$insertAt$(index, value, position, array.runs)
				});
		} else {
			return _Utils_update(
				array,
				{
					runs: $author$project$MessageArray$insertAt$(index, value, position, array.runs)
				});
		}
	}
};
var $author$project$MessageArray$set = F3($author$project$MessageArray$set$);
var $author$project$MessageArray$updateIfExists$ = function (id, updateFunc, array) {
	var _v0 = $author$project$MessageArray$get$(id, array);
	if (!_v0.$) {
		var value = _v0.a;
		return $author$project$MessageArray$set$(
			id,
			updateFunc(value),
			array);
	} else {
		return array;
	}
};
var $author$project$MessageArray$updateIfExists = F3($author$project$MessageArray$updateIfExists$);
var $author$project$LocalState$addEmbedFrontend$ = function (messageId, embed, channel) {
	return _Utils_update(
		channel,
		{
			messages: $author$project$MessageArray$updateIfExists$(
				messageId,
				$author$project$Message$addEmbed(embed),
				channel.messages)
		});
};
var $author$project$LocalState$addEmbedFrontend = F3($author$project$LocalState$addEmbedFrontend$);
var $author$project$VisibleMessages$pageSize = 30;
var $author$project$VisibleMessages$maxCount = $author$project$VisibleMessages$pageSize * 3;
var $author$project$VisibleMessages$reachesEnd$ = function (messageCount, visibleMessages) {
	return _Utils_cmp(
		$author$project$Id$toInt(visibleMessages.oldest) + visibleMessages.count,
		messageCount) > -1;
};
var $author$project$VisibleMessages$reachesEnd = F2($author$project$VisibleMessages$reachesEnd$);
var $author$project$VisibleMessages$increment$ = function (messageCount, visibleMessages) {
	if ($author$project$VisibleMessages$reachesEnd$(messageCount, visibleMessages)) {
		var oldest = $elm$core$Basics$max$(
			$author$project$Id$toInt(visibleMessages.oldest),
			(messageCount + 1) - $author$project$VisibleMessages$maxCount);
		return {
			count: (messageCount + 1) - oldest,
			loadingMessages: visibleMessages.loadingMessages,
			oldest: $author$project$Id$fromInt(oldest)
		};
	} else {
		return visibleMessages;
	}
};
var $author$project$VisibleMessages$increment = F2($author$project$VisibleMessages$increment$);
var $author$project$MessageArray$push$ = function (value, _v0) {
	var array = _v0;
	return $author$project$MessageArray$set$(
		$author$project$Id$fromInt(array.end),
		value,
		_Utils_update(
			array,
			{end: array.end + 1}));
};
var $author$project$MessageArray$push = F2($author$project$MessageArray$push$);
var $author$project$MessageArray$foldrHelper$ = function (foldFunc, runIndex, index, start, runs, state) {
	foldrHelper:
	while (true) {
		if (_Utils_cmp(index, start) < 0) {
			return state;
		} else {
			var _v0 = $elm$core$Array$get$(runIndex, runs);
			if (!_v0.$) {
				var run = _v0.a;
				if (_Utils_cmp(
					index,
					$author$project$MessageArray$runEnd(run)) > -1) {
					var $temp$index = index - 1,
						$temp$state = A3(
						foldFunc,
						$author$project$Id$fromInt(index),
						$elm$core$Maybe$Nothing,
						state);
					index = $temp$index;
					state = $temp$state;
					continue foldrHelper;
				} else {
					if (_Utils_cmp(index, run.start) > -1) {
						var $temp$index = index - 1,
							$temp$state = A3(
							foldFunc,
							$author$project$Id$fromInt(index),
							$elm$core$Array$get$(index - run.start, run.values),
							state);
						index = $temp$index;
						state = $temp$state;
						continue foldrHelper;
					} else {
						var $temp$runIndex = runIndex - 1;
						runIndex = $temp$runIndex;
						continue foldrHelper;
					}
				}
			} else {
				var $temp$index = index - 1,
					$temp$state = A3(
					foldFunc,
					$author$project$Id$fromInt(index),
					$elm$core$Maybe$Nothing,
					state);
				index = $temp$index;
				state = $temp$state;
				continue foldrHelper;
			}
		}
	}
};
var $author$project$MessageArray$foldrHelper = F6($author$project$MessageArray$foldrHelper$);
var $author$project$MessageArray$foldr$ = function (foldFunc, startingValue, _v0) {
	var array = _v0;
	return $author$project$MessageArray$foldrHelper$(
		foldFunc,
		$elm$core$Array$length(array.runs) - 1,
		array.end - 1,
		array.start,
		array.runs,
		startingValue);
};
var $author$project$MessageArray$foldr = F3($author$project$MessageArray$foldr$);
var $author$project$Message$repliedToMessageHelper = function (repliedTo) {
	switch (repliedTo.$) {
		case 1:
			var messageId = repliedTo.a;
			return $elm$core$Maybe$Just(messageId);
		case 2:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Message$repliedToMessage = function (message) {
	switch (message.$) {
		case 0:
			var data = message.a;
			return $author$project$Message$repliedToMessageHelper(data.repliedTo);
		case 1:
			var data = message.a;
			return $author$project$Message$repliedToMessageHelper(data.repliedTo);
		case 2:
			return $elm$core$Maybe$Nothing;
		case 3:
			return $elm$core$Maybe$Nothing;
		case 4:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$MessageArray$dropShadowed$ = function (reversed, entries) {
	dropShadowed:
	while (true) {
		if (entries.b) {
			var entry = entries.a;
			var index = entry.a;
			var rest = entries.b;
			if (rest.b) {
				var _v2 = rest.a;
				var nextIndex = _v2.a;
				if (_Utils_eq(index, nextIndex)) {
					var $temp$entries = rest;
					entries = $temp$entries;
					continue dropShadowed;
				} else {
					var $temp$reversed = A2($elm$core$List$cons, entry, reversed),
						$temp$entries = rest;
					reversed = $temp$reversed;
					entries = $temp$entries;
					continue dropShadowed;
				}
			} else {
				return $elm$core$List$reverse(
					A2($elm$core$List$cons, entry, reversed));
			}
		} else {
			return $elm$core$List$reverse(reversed);
		}
	}
};
var $author$project$MessageArray$dropShadowed = F2($author$project$MessageArray$dropShadowed$);
var $author$project$MessageArray$gapsToRuns = function (gaps) {
	return $elm$core$List$reverse(
		$elm$core$List$foldl$(
			F2(
				function (_v0, runs) {
					var index = _v0.a;
					var value = _v0.b;
					if (runs.b) {
						var run = runs.a;
						var restRuns = runs.b;
						return _Utils_eq(
							$author$project$MessageArray$runEnd(run),
							index) ? A2(
							$elm$core$List$cons,
							_Utils_update(
								run,
								{
									values: $elm$core$Array$push$(value, run.values)
								}),
							restRuns) : A2(
							$elm$core$List$cons,
							{
								start: index,
								values: $elm$core$Array$repeat$(1, value)
							},
							runs);
					} else {
						return _List_fromArray(
							[
								{
								start: index,
								values: $elm$core$Array$repeat$(1, value)
							}
							]);
					}
				}),
			_List_Nil,
			$elm$core$List$reverse(gaps)));
};
var $author$project$MessageArray$appendRun$ = function (run, reversed) {
	if (reversed.b) {
		var previous = reversed.a;
		var rest = reversed.b;
		return _Utils_eq(
			$author$project$MessageArray$runEnd(previous),
			run.start) ? A2(
			$elm$core$List$cons,
			_Utils_update(
				previous,
				{
					values: $elm$core$Array$append$(previous.values, run.values)
				}),
			rest) : A2($elm$core$List$cons, run, reversed);
	} else {
		return _List_fromArray(
			[run]);
	}
};
var $author$project$MessageArray$appendRun = F2($author$project$MessageArray$appendRun$);
var $author$project$MessageArray$mergeRuns$ = function (runsA, runsB, reversed) {
	mergeRuns:
	while (true) {
		var _v0 = _Utils_Tuple2(runsA, runsB);
		if (_v0.a.b) {
			if (_v0.b.b) {
				var _v1 = _v0.a;
				var runA = _v1.a;
				var restA = _v1.b;
				var _v2 = _v0.b;
				var runB = _v2.a;
				var restB = _v2.b;
				if (_Utils_cmp(runA.start, runB.start) < 0) {
					var $temp$runsA = restA,
						$temp$reversed = $author$project$MessageArray$appendRun$(runA, reversed);
					runsA = $temp$runsA;
					reversed = $temp$reversed;
					continue mergeRuns;
				} else {
					var $temp$runsB = restB,
						$temp$reversed = $author$project$MessageArray$appendRun$(runB, reversed);
					runsB = $temp$runsB;
					reversed = $temp$reversed;
					continue mergeRuns;
				}
			} else {
				var _v3 = _v0.a;
				var runA = _v3.a;
				var restA = _v3.b;
				var $temp$runsA = restA,
					$temp$runsB = _List_Nil,
					$temp$reversed = $author$project$MessageArray$appendRun$(runA, reversed);
				runsA = $temp$runsA;
				runsB = $temp$runsB;
				reversed = $temp$reversed;
				continue mergeRuns;
			}
		} else {
			if (_v0.b.b) {
				var _v4 = _v0.b;
				var runB = _v4.a;
				var restB = _v4.b;
				var $temp$runsA = _List_Nil,
					$temp$runsB = restB,
					$temp$reversed = $author$project$MessageArray$appendRun$(runB, reversed);
				runsA = $temp$runsA;
				runsB = $temp$runsB;
				reversed = $temp$reversed;
				continue mergeRuns;
			} else {
				return $elm$core$List$reverse(reversed);
			}
		}
	}
};
var $author$project$MessageArray$mergeRuns = F3($author$project$MessageArray$mergeRuns$);
var $author$project$MessageArray$replaceLoaded$ = function (entries, runs, passedRuns, gaps) {
	replaceLoaded:
	while (true) {
		if (runs.b) {
			var run = runs.a;
			var restRuns = runs.b;
			if (entries.b) {
				var _v2 = entries.a;
				var index = _v2.a;
				var value = _v2.b;
				var restEntries = entries.b;
				if (_Utils_cmp(index, run.start) < 0) {
					var $temp$entries = restEntries,
						$temp$gaps = A2(
						$elm$core$List$cons,
						_Utils_Tuple2(index, value),
						gaps);
					entries = $temp$entries;
					gaps = $temp$gaps;
					continue replaceLoaded;
				} else {
					if (_Utils_cmp(
						index,
						$author$project$MessageArray$runEnd(run)) < 0) {
						var $temp$entries = restEntries,
							$temp$runs = A2(
							$elm$core$List$cons,
							_Utils_update(
								run,
								{
									values: $elm$core$Array$set$(index - run.start, value, run.values)
								}),
							restRuns);
						entries = $temp$entries;
						runs = $temp$runs;
						continue replaceLoaded;
					} else {
						var $temp$runs = restRuns,
							$temp$passedRuns = A2($elm$core$List$cons, run, passedRuns);
						runs = $temp$runs;
						passedRuns = $temp$passedRuns;
						continue replaceLoaded;
					}
				}
			} else {
				return _Utils_Tuple2(
					_Utils_ap(
						$elm$core$List$reverse(passedRuns),
						runs),
					gaps);
			}
		} else {
			return _Utils_Tuple2(
				$elm$core$List$reverse(passedRuns),
				$elm$core$List$foldl$($elm$core$List$cons, gaps, entries));
		}
	}
};
var $author$project$MessageArray$replaceLoaded = F4($author$project$MessageArray$replaceLoaded$);
var $author$project$MessageArray$setMany$ = function (entries, _v0) {
	var array = _v0;
	var _v1 = $author$project$MessageArray$dropShadowed$(
		_List_Nil,
		A2(
			$elm$core$List$sortBy,
			$elm$core$Tuple$first,
			$elm$core$List$filterMap$(
				function (_v2) {
					var id = _v2.a;
					var value = _v2.b;
					var index = $author$project$Id$toInt(id);
					return ((_Utils_cmp(index, array.start) < 0) || (_Utils_cmp(index, array.end) > -1)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						_Utils_Tuple2(index, value));
				},
				entries)));
	if (!_v1.b) {
		return array;
	} else {
		var sorted = _v1;
		var _v3 = $author$project$MessageArray$replaceLoaded$(
			sorted,
			$elm$core$Array$toList(array.runs),
			_List_Nil,
			_List_Nil);
		var loadedRuns = _v3.a;
		var gaps = _v3.b;
		return _Utils_update(
			array,
			{
				runs: $elm$core$Array$fromList(
					$author$project$MessageArray$mergeRuns$(
						loadedRuns,
						$author$project$MessageArray$gapsToRuns(gaps),
						_List_Nil))
			});
	}
};
var $author$project$MessageArray$setMany = F2($author$project$MessageArray$setMany$);
var $author$project$MessageArray$clipRun$ = function (start, end, run) {
	if ((_Utils_cmp(run.start, start) > -1) && (_Utils_cmp(
		$author$project$MessageArray$runEnd(run),
		end) < 1)) {
		return run;
	} else {
		var to = $elm$core$Basics$min$(
			end,
			$author$project$MessageArray$runEnd(run));
		var from = $elm$core$Basics$max$(start, run.start);
		return {
			start: from,
			values: $elm$core$Array$slice$(from - run.start, to - run.start, run.values)
		};
	}
};
var $author$project$MessageArray$clipRun = F3($author$project$MessageArray$clipRun$);
var $elm$core$Elm$JsArray$map = _JsArray_map;
var $elm$core$Array$map$ = function (func, _v0) {
	var len = _v0.a;
	var startShift = _v0.b;
	var tree = _v0.c;
	var tail = _v0.d;
	var helper = function (node) {
		if (!node.$) {
			var subTree = node.a;
			return $elm$core$Array$SubTree(
				A2($elm$core$Elm$JsArray$map, helper, subTree));
		} else {
			var values = node.a;
			return $elm$core$Array$Leaf(
				A2($elm$core$Elm$JsArray$map, func, values));
		}
	};
	return $elm$core$Array$Array_elm_builtin$(
		len,
		startShift,
		A2($elm$core$Elm$JsArray$map, helper, tree),
		A2($elm$core$Elm$JsArray$map, func, tail));
};
var $elm$core$Array$map = F2($elm$core$Array$map$);
var $author$project$MessageArray$upperBoundHelper$ = function (index, low, high, runs) {
	upperBoundHelper:
	while (true) {
		if (_Utils_cmp(low, high) > -1) {
			return low;
		} else {
			var middle = low + (((high - low) / 2) | 0);
			var _v0 = $elm$core$Array$get$(middle, runs);
			if (!_v0.$) {
				var run = _v0.a;
				if (_Utils_cmp(run.start, index) < 0) {
					var $temp$low = middle + 1;
					low = $temp$low;
					continue upperBoundHelper;
				} else {
					var $temp$high = middle;
					high = $temp$high;
					continue upperBoundHelper;
				}
			} else {
				return low;
			}
		}
	}
};
var $author$project$MessageArray$upperBoundHelper = F4($author$project$MessageArray$upperBoundHelper$);
var $author$project$MessageArray$upperBound$ = function (index, runs) {
	return $author$project$MessageArray$upperBoundHelper$(
		index,
		0,
		$elm$core$Array$length(runs),
		runs);
};
var $author$project$MessageArray$upperBound = F2($author$project$MessageArray$upperBound$);
var $author$project$MessageArray$slice$ = function (startId, endId, _v0) {
	var array = _v0;
	var start = $elm$core$Basics$clamp$(
		array.start,
		array.end,
		$author$project$Id$toInt(startId));
	var end = $elm$core$Basics$clamp$(
		start,
		array.end,
		$author$project$Id$toInt(endId));
	return (_Utils_cmp(end, start) < 1) ? {end: start, runs: $elm$core$Array$empty, start: start} : {
		end: end,
		runs: $elm$core$Array$map$(
			A2($author$project$MessageArray$clipRun, start, end),
			$elm$core$Array$slice$(
				$author$project$MessageArray$lowerBound$(start, array.runs),
				$author$project$MessageArray$upperBound$(end, array.runs),
				array.runs)),
		start: start
	};
};
var $author$project$MessageArray$slice = F3($author$project$MessageArray$slice$);
var $author$project$VisibleMessages$slice = function (_v0) {
	var messages = _v0.messages;
	var visibleMessages = _v0.visibleMessages;
	return $author$project$MessageArray$slice$(
		visibleMessages.oldest,
		$author$project$Id$fromInt(
			$author$project$Id$toInt(visibleMessages.oldest) + visibleMessages.count),
		messages);
};
var $author$project$MessageArray$unloadOutside$ = function (startId, endId, _v0) {
	var array = _v0;
	var _v1 = $author$project$MessageArray$slice$(startId, endId, array);
	var sliced = _v1;
	return _Utils_update(
		array,
		{runs: sliced.runs});
};
var $author$project$MessageArray$unloadOutside = F3($author$project$MessageArray$unloadOutside$);
var $author$project$VisibleMessages$unloadHidden$ = function (keep, channel) {
	var visible = $author$project$VisibleMessages$slice(channel);
	var keep2 = A2(
		$elm$core$List$cons,
		$author$project$Id$fromInt(
			$author$project$MessageArray$length(channel.messages) - 1),
		$author$project$MessageArray$foldr$(
			F3(
				function (_v0, maybeMessage, list) {
					var _v1 = $elm$core$Maybe$andThen$($author$project$Message$repliedToMessage, maybeMessage);
					if (!_v1.$) {
						var repliedTo = _v1.a;
						return A2($elm$core$List$cons, repliedTo, list);
					} else {
						return list;
					}
				}),
			keep,
			visible));
	return _Utils_update(
		channel,
		{
			messages: $author$project$MessageArray$setMany$(
				$elm$core$List$filterMap$(
					function (id) {
						return $elm$core$Maybe$map$(
							$elm$core$Tuple$pair(id),
							$author$project$MessageArray$get$(id, channel.messages));
					},
					keep2),
				$author$project$MessageArray$unloadOutside$(
					channel.visibleMessages.oldest,
					$author$project$Id$fromInt(
						$author$project$Id$toInt(channel.visibleMessages.oldest) + channel.visibleMessages.count),
					channel.messages))
		});
};
var $author$project$VisibleMessages$unloadHidden = F2($author$project$VisibleMessages$unloadHidden$);
var $author$project$LocalState$createMessageFrontend$ = function (keep, message, channel) {
	var visibleMessages = $author$project$VisibleMessages$increment$(
		$author$project$MessageArray$length(channel.messages),
		channel.visibleMessages);
	return _Utils_eq(visibleMessages.oldest, channel.visibleMessages.oldest) ? _Utils_update(
		channel,
		{
			messages: $author$project$MessageArray$push$(message, channel.messages),
			visibleMessages: visibleMessages
		}) : $author$project$VisibleMessages$unloadHidden$(
		keep,
		_Utils_update(
			channel,
			{
				messages: $author$project$MessageArray$push$(message, channel.messages),
				visibleMessages: visibleMessages
			}));
};
var $author$project$LocalState$createMessageFrontend = F3($author$project$LocalState$createMessageFrontend$);
var $author$project$LocalState$createChannelMessageFrontend$ = function (message, channel) {
	return $author$project$LocalState$createMessageFrontend$(
		$lamdera$containers$SeqDict$keys(channel.threads),
		message,
		channel);
};
var $author$project$LocalState$createChannelMessageFrontend = F2($author$project$LocalState$createChannelMessageFrontend$);
var $author$project$Thread$frontendInit = {dateDividerDrawings: $lamdera$containers$SeqDict$empty, messages: $author$project$MessageArray$empty, visibleMessages: $author$project$VisibleMessages$empty};
var $author$project$LocalState$createThreadMessageFrontend$ = function (threadId, message, channel) {
	return _Utils_update(
		channel,
		{
			threads: $lamdera$containers$SeqDict$update$(
				threadId,
				function (maybe) {
					return $elm$core$Maybe$Just(
						$author$project$LocalState$createMessageFrontend$(
							_List_Nil,
							message,
							$elm$core$Maybe$withDefault$($author$project$Thread$frontendInit, maybe)));
				},
				channel.threads)
		});
};
var $author$project$LocalState$createThreadMessageFrontend = F3($author$project$LocalState$createThreadMessageFrontend$);
var $author$project$Message$EncryptedUserTextMessage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Message$encryptedUserTextMessageFrontend$ = function (createdAt2, createdBy, fileHashes, contentAndEmbeds, repliedTo2) {
	return $author$project$Message$EncryptedUserTextMessage(
		{content: contentAndEmbeds, createdAt: createdAt2, createdBy: createdBy, drawings: $elm$core$Maybe$Nothing, editedAt: $elm$core$Maybe$Nothing, fileHashes: fileHashes, reactions: $lamdera$containers$SeqDict$empty, repliedTo: repliedTo2});
};
var $author$project$Message$encryptedUserTextMessageFrontend = F5($author$project$Message$encryptedUserTextMessageFrontend$);
var $author$project$Message$RepliedToMessage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Message$maybeToReply = function (maybeRepliedTo) {
	if (maybeRepliedTo.$ === 1) {
		return $author$project$Message$NoReply;
	} else {
		var messageId = maybeRepliedTo.a;
		return $author$project$Message$RepliedToMessage(messageId);
	}
};
var $lamdera$containers$SeqDict$remove$ = function (key, dict) {
	var _v0 = $lamdera$containers$SeqDict$rebuildOnOverflow(dict);
	var bitmap = _v0.a;
	var nodes = _v0.b;
	var triplets = _v0.c;
	return $lamdera$containers$SeqDict$removeHelp$(
		0,
		$lamdera$containers$FNV$hash(key),
		key,
		bitmap,
		nodes,
		triplets);
};
var $lamdera$containers$SeqDict$remove = F2($lamdera$containers$SeqDict$remove$);
var $author$project$FrontendExtra$addEncryptedDmMessage$ = function (createdAt, createdBy, otherUserId, fileHashes, contentAndEmbeds, threadRouteWithRepliedTo, local) {
	var dmChannel = function (a) {
		return _Utils_update(
			a,
			{
				lastTypedAt: $lamdera$containers$SeqDict$remove$(createdBy, a.lastTypedAt)
			});
	}(
		$elm$core$Maybe$withDefault$(
			$author$project$DmChannel$frontendInit,
			$lamdera$containers$SeqDict$get$(otherUserId, local.dmChannels)));
	return _Utils_update(
		local,
		{
			dmChannels: $lamdera$containers$SeqDict$insert$(
				otherUserId,
				function () {
					if (threadRouteWithRepliedTo.$ === 1) {
						var threadId = threadRouteWithRepliedTo.a;
						var maybeReplyTo = threadRouteWithRepliedTo.b;
						return $author$project$LocalState$createThreadMessageFrontend$(
							threadId,
							$author$project$Message$encryptedUserTextMessageFrontend$(
								createdAt,
								createdBy,
								fileHashes,
								contentAndEmbeds,
								$author$project$Message$maybeToReply(maybeReplyTo)),
							dmChannel);
					} else {
						var repliedTo = threadRouteWithRepliedTo.a;
						return $author$project$LocalState$createChannelMessageFrontend$(
							$author$project$Message$encryptedUserTextMessageFrontend$(createdAt, createdBy, fileHashes, contentAndEmbeds, repliedTo),
							dmChannel);
					}
				}(),
				local.dmChannels)
		});
};
var $author$project$FrontendExtra$addEncryptedDmMessage = F7($author$project$FrontendExtra$addEncryptedDmMessage$);
var $author$project$LocalState$addInvite$ = function (inviteId, userId, time, guild) {
	return _Utils_update(
		guild,
		{
			invites: $lamdera$containers$SeqDict$insert$(
				inviteId,
				{createdAt: time, createdBy: userId},
				guild.invites)
		});
};
var $author$project$LocalState$addInvite = F4($author$project$LocalState$addInvite$);
var $author$project$Pagination$PageLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pagination$addItem$ = function (item, model) {
	return _Utils_update(
		model,
		{
			pages: $lamdera$containers$SeqDict$updateIfExists$(
				$author$project$Id$fromInt((($author$project$Pagination$pageSize + model.totalItems) / $author$project$Pagination$pageSize) | 0),
				function (page) {
					if (page.$ === 1) {
						var array = page.a;
						return $author$project$Pagination$PageLoaded(
							$elm$core$Array$push$(item, array));
					} else {
						return page;
					}
				},
				model.pages),
			totalItems: model.totalItems + 1
		});
};
var $author$project$Pagination$addItem = F2($author$project$Pagination$addItem$);
var $author$project$LinkedAndOtherDiscordUsers$LinkedAndOtherDiscordUsers$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$LinkedAndOtherDiscordUsers$LinkedAndOtherDiscordUsers = F2($author$project$LinkedAndOtherDiscordUsers$LinkedAndOtherDiscordUsers$);
var $author$project$LinkedAndOtherDiscordUsers$addLinkedUser$ = function (userId, linkedUser, _v0) {
	var otherUsers2 = _v0.a;
	var linkedUsers2 = _v0.b;
	return $author$project$LinkedAndOtherDiscordUsers$LinkedAndOtherDiscordUsers$(
		$lamdera$containers$SeqDict$remove$(userId, otherUsers2),
		$lamdera$containers$SeqDict$insert$(userId, linkedUser, linkedUsers2));
};
var $author$project$LinkedAndOtherDiscordUsers$addLinkedUser = F3($author$project$LinkedAndOtherDiscordUsers$addLinkedUser$);
var $author$project$MembersAndOwner$MembersAndOwner$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$MembersAndOwner$MembersAndOwner = F2($author$project$MembersAndOwner$MembersAndOwner$);
var $author$project$MembersAndOwner$addMember$ = function (userId, user, _v0) {
	var members2 = _v0.a;
	var ownerId = _v0.b;
	return _Utils_eq(userId, ownerId) ? $elm$core$Result$Err(0) : ($lamdera$containers$SeqDict$member$(userId, members2) ? $elm$core$Result$Err(0) : $elm$core$Result$Ok(
		$author$project$MembersAndOwner$MembersAndOwner$(
			$lamdera$containers$SeqDict$insert$(userId, user, members2),
			ownerId)));
};
var $author$project$MembersAndOwner$addMember = F3($author$project$MembersAndOwner$addMember$);
var $author$project$Drawing$emptyDrawing = {finished: _List_Nil, inProgress: $lamdera$containers$SeqDict$empty, undone: $lamdera$containers$SeqDict$empty};
var $author$project$Message$userJoined$ = function (time, userId) {
	return $author$project$Message$UserJoinedMessage$(time, userId, $lamdera$containers$SeqDict$empty, $author$project$Drawing$emptyDrawing);
};
var $author$project$Message$userJoined = F2($author$project$Message$userJoined$);
var $author$project$LocalState$addMemberFrontend$ = function (time, userId, guild) {
	var _v0 = $author$project$MembersAndOwner$addMember$(
		userId,
		{joinedAt: time, lastPostedAt: $elm$core$Maybe$Nothing},
		guild.membersAndOwner);
	if (!_v0.$) {
		var membersAndOwner = _v0.a;
		return $elm$core$Result$Ok(
			_Utils_update(
				guild,
				{
					channels: $lamdera$containers$SeqDict$updateIfExists$(
						$author$project$LocalState$announcementChannel(guild),
						$author$project$LocalState$createChannelMessageFrontend(
							$author$project$Message$userJoined$(time, userId)),
						guild.channels),
					membersAndOwner: membersAndOwner
				}));
	} else {
		return $elm$core$Result$Err(0);
	}
};
var $author$project$LocalState$addMemberFrontend = F3($author$project$LocalState$addMemberFrontend$);
var $author$project$FrontendExtra$addMessageSender$ = function (userId, user, localUser) {
	return _Utils_eq(userId, localUser.session.userId) ? localUser.otherUsers : $lamdera$containers$SeqDict$insert$(userId, user, localUser.otherUsers);
};
var $author$project$FrontendExtra$addMessageSender = F3($author$project$FrontendExtra$addMessageSender$);
var $lamdera$containers$SeqDict$union$ = function (_v0, t2) {
	var t1Triplets = _v0.c;
	var helper = F2(
		function (_v1, _v2) {
			var hash = _v1.a;
			var key = _v1.b;
			var value = _v1.c;
			var bitmap = _v2.a;
			var nodes = _v2.b;
			var triplets = _v2.c;
			return $lamdera$containers$SeqDict$insertHelp$(0, hash, key, value, bitmap, nodes, triplets);
		});
	return $lamdera$containers$SeqDict$intDictFoldl$(helper, t2, t1Triplets);
};
var $lamdera$containers$SeqDict$union = F2($lamdera$containers$SeqDict$union$);
var $lamdera$containers$SeqSet$union$ = function (_v0, _v1) {
	var d1 = _v0;
	var d2 = _v1;
	return $lamdera$containers$SeqDict$union$(d1, d2);
};
var $lamdera$containers$SeqSet$union = F2($lamdera$containers$SeqSet$union$);
var $author$project$User$addNewCustomEmojis$ = function (customEmojis, user) {
	return _Utils_update(
		user,
		{
			availableCustomEmojis: $lamdera$containers$SeqSet$union$(
				user.availableCustomEmojis,
				$lamdera$containers$SeqSet$fromList(
					$lamdera$containers$SeqDict$keys(customEmojis)))
		});
};
var $author$project$User$addNewCustomEmojis = F2($author$project$User$addNewCustomEmojis$);
var $author$project$User$addNewStickers$ = function (stickers, user) {
	return _Utils_update(
		user,
		{
			availableStickers: $lamdera$containers$SeqSet$union$(
				user.availableStickers,
				$lamdera$containers$SeqSet$fromList(
					$lamdera$containers$SeqDict$keys(stickers)))
		});
};
var $author$project$User$addNewStickers = F2($author$project$User$addNewStickers$);
var $author$project$LinkedAndOtherDiscordUsers$addOtherUser$ = function (userId, otherUser, linkedAndOther) {
	var otherUsers2 = linkedAndOther.a;
	var linkedUsers2 = linkedAndOther.b;
	return $lamdera$containers$SeqDict$member$(userId, linkedUsers2) ? linkedAndOther : $author$project$LinkedAndOtherDiscordUsers$LinkedAndOtherDiscordUsers$(
		$lamdera$containers$SeqDict$insert$(userId, otherUser, otherUsers2),
		linkedUsers2);
};
var $author$project$LinkedAndOtherDiscordUsers$addOtherUser = F3($author$project$LinkedAndOtherDiscordUsers$addOtherUser$);
var $author$project$Message$CallStarted = function (a) {
	return {$: 4, a: a};
};
var $author$project$Message$GameStarted = function (a) {
	return {$: 5, a: a};
};
var $author$project$NonemptySet$NonemptySet$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$NonemptySet$NonemptySet = F2($author$project$NonemptySet$NonemptySet$);
var $author$project$NonemptySet$insert$ = function (id, _v0) {
	var id2 = _v0.a;
	var set = _v0.b;
	return _Utils_eq(id, id2) ? $author$project$NonemptySet$NonemptySet$(id2, set) : ($lamdera$containers$SeqSet$member$(id, set) ? $author$project$NonemptySet$NonemptySet$(
		id2,
		$lamdera$containers$SeqSet$insert$(id, set)) : $author$project$NonemptySet$NonemptySet$(
		id,
		$lamdera$containers$SeqSet$insert$(id2, set)));
};
var $author$project$NonemptySet$insert = F2($author$project$NonemptySet$insert$);
var $author$project$NonemptySet$singleton = function (key) {
	return $author$project$NonemptySet$NonemptySet$(key, $lamdera$containers$SeqSet$empty);
};
var $author$project$SeqDictHelper$addToSet$ = function (key, item, dict) {
	return $lamdera$containers$SeqDict$update$(
		key,
		function (maybe) {
			if (!maybe.$) {
				var nonempty = maybe.a;
				return $elm$core$Maybe$Just(
					$author$project$NonemptySet$insert$(item, nonempty));
			} else {
				return $elm$core$Maybe$Just(
					$author$project$NonemptySet$singleton(item));
			}
		},
		dict);
};
var $author$project$SeqDictHelper$addToSet = F3($author$project$SeqDictHelper$addToSet$);
var $author$project$Message$maxReactionEmojis = 100;
var $lamdera$containers$SeqDict$size = function (_v0) {
	var triplets = _v0.c;
	return triplets.size;
};
var $author$project$Message$addReactionEmojiHelper$ = function (userId, emoji, reactions) {
	return (_Utils_cmp(
		$lamdera$containers$SeqDict$size(reactions),
		$author$project$Message$maxReactionEmojis) > 0) ? reactions : $author$project$SeqDictHelper$addToSet$(emoji, userId, reactions);
};
var $author$project$Message$addReactionEmojiHelper = F3($author$project$Message$addReactionEmojiHelper$);
var $author$project$Message$addReactionEmoji$ = function (userId, emoji, message) {
	switch (message.$) {
		case 0:
			var message2 = message.a;
			return $author$project$Message$UserTextMessage(
				_Utils_update(
					message2,
					{
						reactions: $author$project$Message$addReactionEmojiHelper$(userId, emoji, message2.reactions)
					}));
		case 1:
			var message2 = message.a;
			return $author$project$Message$EncryptedUserTextMessage(
				_Utils_update(
					message2,
					{
						reactions: $author$project$Message$addReactionEmojiHelper$(userId, emoji, message2.reactions)
					}));
		case 2:
			var time = message.a;
			var userJoinedId = message.b;
			var reactions = message.c;
			var drawings = message.d;
			return $author$project$Message$UserJoinedMessage$(
				time,
				userJoinedId,
				$author$project$Message$addReactionEmojiHelper$(userId, emoji, reactions),
				drawings);
		case 3:
			return message;
		case 4:
			var callStarted = message.a;
			return $author$project$Message$CallStarted(
				_Utils_update(
					callStarted,
					{
						reactions: $author$project$Message$addReactionEmojiHelper$(userId, emoji, callStarted.reactions)
					}));
		default:
			var gameStarted = message.a;
			return $author$project$Message$GameStarted(
				_Utils_update(
					gameStarted,
					{
						reactions: $author$project$Message$addReactionEmojiHelper$(userId, emoji, gameStarted.reactions)
					}));
	}
};
var $author$project$Message$addReactionEmoji = F3($author$project$Message$addReactionEmoji$);
var $author$project$LocalState$addReactionEmojiFrontendHelper$ = function (emoji, userId, messageId, channel) {
	return _Utils_update(
		channel,
		{
			messages: $author$project$MessageArray$updateIfExists$(
				messageId,
				A2($author$project$Message$addReactionEmoji, userId, emoji),
				channel.messages)
		});
};
var $author$project$LocalState$addReactionEmojiFrontendHelper = F4($author$project$LocalState$addReactionEmojiFrontendHelper$);
var $author$project$LocalState$addReactionEmojiFrontend$ = function (emoji, userId, threadRoute, channel) {
	if (threadRoute.$ === 1) {
		var threadId = threadRoute.a;
		var messageId = threadRoute.b;
		return _Utils_update(
			channel,
			{
				threads: $lamdera$containers$SeqDict$updateIfExists$(
					threadId,
					A3($author$project$LocalState$addReactionEmojiFrontendHelper, emoji, userId, messageId),
					channel.threads)
			});
	} else {
		var messageId = threadRoute.a;
		return $author$project$LocalState$addReactionEmojiFrontendHelper$(emoji, userId, messageId, channel);
	}
};
var $author$project$LocalState$addReactionEmojiFrontend = F4($author$project$LocalState$addReactionEmojiFrontend$);
var $author$project$User$addRecentlyUsedEmoji$ = function (emoji, user) {
	var emojiConfig = user.emojiConfig;
	var count = $elm$core$Array$length(emojiConfig.lastUsedEmojis);
	return _Utils_update(
		user,
		{
			emojiConfig: _Utils_update(
				emojiConfig,
				{
					lastUsedEmojis: (count > 50) ? $elm$core$Array$push$(
						emoji,
						$elm$core$Array$slice$(count - 20, count, emojiConfig.lastUsedEmojis)) : $elm$core$Array$push$(emoji, emojiConfig.lastUsedEmojis)
				})
		});
};
var $author$project$User$addRecentlyUsedEmoji = F2($author$project$User$addRecentlyUsedEmoji$);
var $author$project$LocalState$updateChannel$ = function (updateFunc, channelId, guild) {
	return _Utils_update(
		guild,
		{
			channels: $lamdera$containers$SeqDict$updateIfExists$(channelId, updateFunc, guild.channels)
		});
};
var $author$project$LocalState$updateChannel = F3($author$project$LocalState$updateChannel$);
var $author$project$FrontendExtra$addReactionEmoji$ = function (userId, guildOrDmId, threadRoute, emoji, local) {
	var localUser = local.localUser;
	var localUser2 = _Utils_eq(userId, localUser.session.userId) ? _Utils_update(
		localUser,
		{
			user: $author$project$User$addRecentlyUsedEmoji$(emoji, localUser.user)
		}) : localUser;
	switch (guildOrDmId.$) {
		case 0:
			if (!guildOrDmId.a.$) {
				var channelId = guildOrDmId.a.a.channelId;
				var guildId = guildOrDmId.a.a.guildId;
				return _Utils_update(
					local,
					{
						guilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							A2(
								$author$project$LocalState$updateChannel,
								A3($author$project$LocalState$addReactionEmojiFrontend, emoji, userId, threadRoute),
								channelId),
							local.guilds),
						localUser: localUser2
					});
			} else {
				var otherUserId = guildOrDmId.a.a.otherUserId;
				return _Utils_update(
					local,
					{
						dmChannels: $lamdera$containers$SeqDict$updateIfExists$(
							otherUserId,
							A3($author$project$LocalState$addReactionEmojiFrontend, emoji, userId, threadRoute),
							local.dmChannels),
						localUser: localUser2
					});
			}
		case 1:
			if (!guildOrDmId.a.$) {
				var channelId = guildOrDmId.a.a.channelId;
				var guildId = guildOrDmId.a.a.guildId;
				var currentUserId = guildOrDmId.a.a.currentUserId;
				return _Utils_update(
					local,
					{
						discordGuilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							A2(
								$author$project$LocalState$updateChannel,
								A3($author$project$LocalState$addReactionEmojiFrontend, emoji, currentUserId, threadRoute),
								channelId),
							local.discordGuilds),
						localUser: localUser2
					});
			} else {
				var channelId = guildOrDmId.a.a.channelId;
				var currentUserId = guildOrDmId.a.a.currentUserId;
				if (threadRoute.$ === 1) {
					return local;
				} else {
					var messageId = threadRoute.a;
					return _Utils_update(
						local,
						{
							discordDmChannels: $lamdera$containers$SeqDict$updateIfExists$(
								channelId,
								A3($author$project$LocalState$addReactionEmojiFrontendHelper, emoji, currentUserId, messageId),
								local.discordDmChannels),
							localUser: localUser2
						});
				}
			}
		default:
			if (!guildOrDmId.a.$) {
				var channelId = guildOrDmId.a.a.channelId;
				var teamId = guildOrDmId.a.a.teamId;
				var currentUserId = guildOrDmId.a.a.currentUserId;
				return _Utils_update(
					local,
					{
						localUser: localUser2,
						slackWorkspaces: $lamdera$containers$SeqDict$updateIfExists$(
							teamId,
							A2(
								$author$project$LocalState$updateChannel,
								A3($author$project$LocalState$addReactionEmojiFrontend, emoji, currentUserId, threadRoute),
								channelId),
							local.slackWorkspaces)
					});
			} else {
				var channelId = guildOrDmId.a.a.channelId;
				var currentUserId = guildOrDmId.a.a.currentUserId;
				return _Utils_update(
					local,
					{
						localUser: localUser2,
						slackDmChannels: $lamdera$containers$SeqDict$updateIfExists$(
							channelId,
							A3($author$project$LocalState$addReactionEmojiFrontend, emoji, currentUserId, threadRoute),
							local.slackDmChannels)
					});
			}
	}
};
var $author$project$FrontendExtra$addReactionEmoji = F5($author$project$FrontendExtra$addReactionEmoji$);
var $author$project$User$addRecentlyUsedEmojis$ = function (emojis, user) {
	return $elm$core$List$foldl$($author$project$User$addRecentlyUsedEmoji, user, emojis);
};
var $author$project$User$addRecentlyUsedEmojis = F2($author$project$User$addRecentlyUsedEmojis$);
var $author$project$Game$FrontendGameData_Go$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $author$project$Game$FrontendGameData_Go = F3($author$project$Game$FrontendGameData_Go$);
var $author$project$Game$FrontendGameData_SheepGame$ = function (a, b, c) {
	return {$: 2, a: a, b: b, c: c};
};
var $author$project$Game$FrontendGameData_SheepGame = F3($author$project$Game$FrontendGameData_SheepGame$);
var $author$project$Game$FrontendGameData_WordSpellingGame$ = function (a, b, c) {
	return {$: 1, a: a, b: b, c: c};
};
var $author$project$Game$FrontendGameData_WordSpellingGame = F3($author$project$Game$FrontendGameData_WordSpellingGame$);
var $author$project$Game$MatchData = function (a) {
	return {$: 0, a: a};
};
var $author$project$Go$Black = 0;
var $author$project$Go$Playing = function (a) {
	return {$: 0, a: a};
};
var $author$project$Go$White = 1;
var $author$project$Go$boardSizeToInt = function (_v0) {
	var a = _v0;
	return a;
};
var $elm$core$Set$insert$ = function (key, _v0) {
	var dict = _v0;
	return $elm$core$Dict$insert$(key, 0, dict);
};
var $elm$core$Set$insert = F2($elm$core$Set$insert$);
var $elm$core$Set$fromList = function (list) {
	return $elm$core$List$foldl$($elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $author$project$Go$handicapPositions = function (setup) {
	var width = $author$project$Go$boardSizeToInt(setup.width);
	var midX = (width / 2) | 0;
	var height = $author$project$Go$boardSizeToInt(setup.height);
	var margin = ($elm$core$Basics$min$(width, height) >= 13) ? 3 : (($elm$core$Basics$min$(width, height) >= 9) ? 2 : 1);
	var leftX = margin;
	var rightX = (width - 1) - margin;
	var topY = margin;
	var midY = (height / 2) | 0;
	var center = _Utils_Tuple2(midX, midY);
	var bottomY = (height - 1) - margin;
	var corners = _List_fromArray(
		[
			_Utils_Tuple2(leftX, bottomY),
			_Utils_Tuple2(rightX, topY),
			_Utils_Tuple2(leftX, topY),
			_Utils_Tuple2(rightX, bottomY)
		]);
	var positions = function () {
		var _v1 = setup.handicap;
		switch (_v1) {
			case 0:
				return _List_Nil;
			case 1:
				return _List_fromArray(
					[
						_Utils_Tuple2(leftX, bottomY)
					]);
			case 2:
				return _List_fromArray(
					[
						_Utils_Tuple2(leftX, bottomY),
						_Utils_Tuple2(rightX, topY)
					]);
			case 3:
				return _List_fromArray(
					[
						_Utils_Tuple2(leftX, bottomY),
						_Utils_Tuple2(rightX, topY),
						_Utils_Tuple2(leftX, topY)
					]);
			case 4:
				return corners;
			case 5:
				return _Utils_ap(
					corners,
					_List_fromArray(
						[center]));
			case 6:
				return _Utils_ap(
					corners,
					_List_fromArray(
						[
							_Utils_Tuple2(leftX, midY),
							_Utils_Tuple2(rightX, midY)
						]));
			case 7:
				return _Utils_ap(
					corners,
					_List_fromArray(
						[
							_Utils_Tuple2(leftX, midY),
							_Utils_Tuple2(rightX, midY),
							center
						]));
			case 8:
				return _Utils_ap(
					corners,
					_List_fromArray(
						[
							_Utils_Tuple2(leftX, midY),
							_Utils_Tuple2(rightX, midY),
							_Utils_Tuple2(midX, topY),
							_Utils_Tuple2(midX, bottomY)
						]));
			default:
				return _Utils_ap(
					corners,
					_List_fromArray(
						[
							_Utils_Tuple2(leftX, midY),
							_Utils_Tuple2(rightX, midY),
							_Utils_Tuple2(midX, topY),
							_Utils_Tuple2(midX, bottomY),
							center
						]));
		}
	}();
	return $elm$core$Set$toList(
		$elm$core$Set$fromList(
			$elm$core$List$filter$(
				function (_v0) {
					var x = _v0.a;
					var y = _v0.b;
					return (x >= 0) && ((_Utils_cmp(x, width) < 0) && ((y >= 0) && (_Utils_cmp(y, height) < 0)));
				},
				positions)));
};
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Go$initShared = function (setup) {
	var positions = $author$project$Go$handicapPositions(setup);
	var startingPlayer = $elm$core$List$isEmpty(positions) ? 0 : 1;
	var board = $elm$core$Dict$fromList(
		$elm$core$List$map$(
			function (p) {
				return _Utils_Tuple2(p, 0);
			},
			positions));
	return {
		blackCaptures: 0,
		board: board,
		currentPlayer: startingPlayer,
		history: _List_Nil,
		joinedUserId: $elm$core$Maybe$Nothing,
		lastAction: $elm$core$Maybe$Nothing,
		lastMove: $elm$core$Maybe$Nothing,
		phase: $author$project$Go$Playing(
			{previousPlayerPassed: false}),
		territoryMarks: $elm$core$Dict$empty,
		timeLeft: function () {
			var _v0 = setup.timeControl;
			if (!_v0.$) {
				var tc = _v0.a;
				return $elm$core$Maybe$Just(
					{black: tc.mainTime, white: tc.mainTime});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}(),
		turnCount: 0,
		whiteCaptures: 0
	};
};
var $author$project$Go$Confirming = {$: 2};
var $author$project$Go$Scored = function (a) {
	return {$: 3, a: a};
};
var $ianmackenzie$elm_units$Quantity$minus$ = function (_v0, _v1) {
	var y = _v0;
	var x = _v1;
	return x - y;
};
var $ianmackenzie$elm_units$Quantity$minus = F2($ianmackenzie$elm_units$Quantity$minus$);
var $author$project$Go$actualTimeLeft$ = function (currentTime, player, currentPlayer, timeLeft, model) {
	var _v0 = model.phase;
	switch (_v0.$) {
		case 0:
			if (_Utils_eq(player, currentPlayer) && (model.turnCount >= 2)) {
				var elapsedTime = $ianmackenzie$elm_units$Duration$from$(
					$elm$core$Maybe$withDefault$(currentTime, model.lastAction),
					currentTime);
				return $ianmackenzie$elm_units$Quantity$minus$(elapsedTime, timeLeft);
			} else {
				return timeLeft;
			}
		case 1:
			return timeLeft;
		case 2:
			return timeLeft;
		default:
			return timeLeft;
	}
};
var $author$project$Go$actualTimeLeft = F5($author$project$Go$actualTimeLeft$);
var $author$project$Go$applyIncrement$ = function (currentTime, setup, mover, model) {
	var _v0 = _Utils_Tuple2(setup.timeControl, model.timeLeft);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var tc = _v0.a.a;
		var black = _v0.b.a.black;
		var white = _v0.b.a.white;
		if (!mover) {
			return _Utils_update(
				model,
				{
					lastAction: $elm$core$Maybe$Just(currentTime),
					timeLeft: $elm$core$Maybe$Just(
						{
							black: $ianmackenzie$elm_units$Quantity$plus$(
								tc.increment,
								$author$project$Go$actualTimeLeft$(currentTime, 0, mover, black, model)),
							white: white
						}),
					turnCount: model.turnCount + 1
				});
		} else {
			return _Utils_update(
				model,
				{
					lastAction: $elm$core$Maybe$Just(currentTime),
					timeLeft: $elm$core$Maybe$Just(
						{
							black: black,
							white: $ianmackenzie$elm_units$Quantity$plus$(
								tc.increment,
								$author$project$Go$actualTimeLeft$(currentTime, 1, mover, white, model))
						}),
					turnCount: model.turnCount + 1
				});
		}
	} else {
		return _Utils_update(
			model,
			{
				lastAction: $elm$core$Maybe$Just(currentTime),
				turnCount: model.turnCount + 1
			});
	}
};
var $author$project$Go$applyIncrement = F4($author$project$Go$applyIncrement$);
var $author$project$Go$gameDeadContext$ = function (setup, model) {
	return {board: model.board, setup: setup, territoryMarks: model.territoryMarks};
};
var $author$project$Go$gameDeadContext = F2($author$project$Go$gameDeadContext$);
var $elm$core$List$all$ = function (isOkay, list) {
	return !$elm$core$List$any$(
		A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
		list);
};
var $elm$core$List$all = F2($elm$core$List$all$);
var $elm$core$Dict$member$ = function (key, dict) {
	var _v0 = $elm$core$Dict$get$(key, dict);
	if (!_v0.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Dict$member = F2($elm$core$Dict$member$);
var $elm$core$Set$member$ = function (key, _v0) {
	var dict = _v0;
	return $elm$core$Dict$member$(key, dict);
};
var $elm$core$Set$member = F2($elm$core$Set$member$);
var $author$project$Go$neighbors$ = function (setup, _v0) {
	var x = _v0.a;
	var y = _v0.b;
	var width = $author$project$Go$boardSizeToInt(setup.width);
	var height = $author$project$Go$boardSizeToInt(setup.height);
	return $elm$core$List$filter$(
		function (_v1) {
			var a = _v1.a;
			var b = _v1.b;
			return (a >= 0) && ((_Utils_cmp(a, width) < 0) && ((b >= 0) && (_Utils_cmp(b, height) < 0)));
		},
		_List_fromArray(
			[
				_Utils_Tuple2(x - 1, y),
				_Utils_Tuple2(x + 1, y),
				_Utils_Tuple2(x, y - 1),
				_Utils_Tuple2(x, y + 1)
			]));
};
var $author$project$Go$neighbors = F2($author$project$Go$neighbors$);
var $author$project$Go$floodFill$ = function (setup, board, stone, queue, stones, liberties) {
	floodFill:
	while (true) {
		if (!queue.b) {
			return {liberties: liberties, stones: stones};
		} else {
			var pos = queue.a;
			var rest = queue.b;
			var _v1 = $elm$core$List$foldl$(
				F2(
					function (n, _v2) {
						var q = _v2.a;
						var s = _v2.b;
						var l = _v2.c;
						if ($elm$core$Set$member$(n, s)) {
							return _Utils_Tuple3(q, s, l);
						} else {
							var _v3 = $elm$core$Dict$get$(n, board);
							if (_v3.$ === 1) {
								return _Utils_Tuple3(
									q,
									s,
									$elm$core$Set$insert$(n, l));
							} else {
								var neighborStone = _v3.a;
								return _Utils_eq(neighborStone, stone) ? _Utils_Tuple3(
									A2($elm$core$List$cons, n, q),
									$elm$core$Set$insert$(n, s),
									l) : _Utils_Tuple3(q, s, l);
							}
						}
					}),
				_Utils_Tuple3(rest, stones, liberties),
				$author$project$Go$neighbors$(setup, pos));
			var newQueue = _v1.a;
			var newStones = _v1.b;
			var newLiberties = _v1.c;
			var $temp$queue = newQueue,
				$temp$stones = newStones,
				$temp$liberties = newLiberties;
			queue = $temp$queue;
			stones = $temp$stones;
			liberties = $temp$liberties;
			continue floodFill;
		}
	}
};
var $author$project$Go$floodFill = F6($author$project$Go$floodFill$);
var $elm$core$Dict$singleton$ = function (key, value) {
	return $elm$core$Dict$RBNode_elm_builtin$(1, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
};
var $elm$core$Dict$singleton = F2($elm$core$Dict$singleton$);
var $elm$core$Set$singleton = function (key) {
	return $elm$core$Dict$singleton$(key, 0);
};
var $author$project$Go$groupAt$ = function (setup, board, start) {
	var _v0 = $elm$core$Dict$get$(start, board);
	if (_v0.$ === 1) {
		return {liberties: $elm$core$Set$empty, stones: $elm$core$Set$empty};
	} else {
		var stone = _v0.a;
		return $author$project$Go$floodFill$(
			setup,
			board,
			stone,
			_List_fromArray(
				[start]),
			$elm$core$Set$singleton(start),
			$elm$core$Set$empty);
	}
};
var $author$project$Go$groupAt = F3($author$project$Go$groupAt$);
var $author$project$Go$otherStone = function (stone) {
	if (!stone) {
		return 1;
	} else {
		return 0;
	}
};
var $author$project$Go$isStoneDead$ = function (ctx, pos, stone) {
	var group = $author$project$Go$groupAt$(ctx.setup, ctx.board, pos);
	var liberties = $elm$core$Set$toList(group.liberties);
	if (!liberties.b) {
		return false;
	} else {
		return $elm$core$List$all$(
			function (lib) {
				return _Utils_eq(
					$elm$core$Dict$get$(lib, ctx.territoryMarks),
					$elm$core$Maybe$Just(
						$author$project$Go$otherStone(stone)));
			},
			liberties);
	}
};
var $author$project$Go$isStoneDead = F3($author$project$Go$isStoneDead$);
var $author$project$Go$komiHalfPointsToFloat = function (_v0) {
	var a = _v0;
	return a / 2;
};
var $author$project$Go$computeScore$ = function (setup, model) {
	var ctx = $author$project$Go$gameDeadContext$(setup, model);
	var _v0 = $elm$core$Dict$foldl$(
		F3(
			function (_v1, s, _v2) {
				var b = _v2.a;
				var w = _v2.b;
				if (!s) {
					return _Utils_Tuple2(b + 1, w);
				} else {
					return _Utils_Tuple2(b, w + 1);
				}
			}),
		_Utils_Tuple2(0, 0),
		model.territoryMarks);
	var blackTerritory = _v0.a;
	var whiteTerritory = _v0.b;
	var _v4 = $elm$core$Dict$foldl$(
		F3(
			function (pos, stone, _v5) {
				var db = _v5.a;
				var dw = _v5.b;
				if ($author$project$Go$isStoneDead$(ctx, pos, stone)) {
					if (!stone) {
						return _Utils_Tuple2(db + 1, dw);
					} else {
						return _Utils_Tuple2(db, dw + 1);
					}
				} else {
					return _Utils_Tuple2(db, dw);
				}
			}),
		_Utils_Tuple2(0, 0),
		model.board);
	var deadBlack = _v4.a;
	var deadWhite = _v4.b;
	return _Utils_Tuple2(
		(blackTerritory + model.blackCaptures) + (2 * deadWhite),
		((whiteTerritory + model.whiteCaptures) + (2 * deadBlack)) + $author$project$Go$komiHalfPointsToFloat(setup.komiHalfPoints));
};
var $author$project$Go$computeScore = F2($author$project$Go$computeScore$);
var $author$project$Go$cycleOwner = function (current) {
	if (current.$ === 1) {
		return $elm$core$Maybe$Just(0);
	} else {
		if (!current.a) {
			var _v1 = current.a;
			return $elm$core$Maybe$Just(1);
		} else {
			var _v2 = current.a;
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$Go$regionFlood$ = function (setup, board, queue, visited) {
	regionFlood:
	while (true) {
		if (!queue.b) {
			return visited;
		} else {
			var pos = queue.a;
			var rest = queue.b;
			var _v1 = $elm$core$List$foldl$(
				F2(
					function (n, _v2) {
						var q = _v2.a;
						var v = _v2.b;
						return ($elm$core$Set$member$(n, v) || $elm$core$Dict$member$(n, board)) ? _Utils_Tuple2(q, v) : _Utils_Tuple2(
							A2($elm$core$List$cons, n, q),
							$elm$core$Set$insert$(n, v));
					}),
				_Utils_Tuple2(rest, visited),
				$author$project$Go$neighbors$(setup, pos));
			var newQueue = _v1.a;
			var newVisited = _v1.b;
			var $temp$queue = newQueue,
				$temp$visited = newVisited;
			queue = $temp$queue;
			visited = $temp$visited;
			continue regionFlood;
		}
	}
};
var $author$project$Go$regionFlood = F4($author$project$Go$regionFlood$);
var $author$project$Go$findRegion$ = function (setup, board, start) {
	return $elm$core$Dict$member$(start, board) ? $elm$core$Set$empty : $author$project$Go$regionFlood$(
		setup,
		board,
		_List_fromArray(
			[start]),
		$elm$core$Set$singleton(start));
};
var $author$project$Go$findRegion = F3($author$project$Go$findRegion$);
var $elm$core$Set$foldl$ = function (func, initialState, _v0) {
	var dict = _v0;
	return $elm$core$Dict$foldl$(
		F3(
			function (key, _v1, state) {
				return A2(func, key, state);
			}),
		initialState,
		dict);
};
var $elm$core$Set$foldl = F3($elm$core$Set$foldl$);
var $author$project$Go$cycleTerritory$ = function (setup, x, y, model) {
	if ($elm$core$Dict$member$(
		_Utils_Tuple2(x, y),
		model.board)) {
		return model;
	} else {
		var region = $author$project$Go$findRegion$(
			setup,
			model.board,
			_Utils_Tuple2(x, y));
		var currentOwner = $elm$core$Maybe$andThen$(
			function (p) {
				return $elm$core$Dict$get$(p, model.territoryMarks);
			},
			$elm$core$List$head(
				$elm$core$Set$toList(region)));
		var newOwner = $author$project$Go$cycleOwner(currentOwner);
		var cleared = $elm$core$Set$foldl$($elm$core$Dict$remove, model.territoryMarks, region);
		var newMarks = function () {
			if (!newOwner.$) {
				var s = newOwner.a;
				return $elm$core$Set$foldl$(
					F2(
						function (p, d) {
							return $elm$core$Dict$insert$(p, s, d);
						}),
					cleared,
					region);
			} else {
				return cleared;
			}
		}();
		return _Utils_update(
			model,
			{territoryMarks: newMarks});
	}
};
var $author$project$Go$cycleTerritory = F4($author$project$Go$cycleTerritory$);
var $ianmackenzie$elm_units$Quantity$greaterThanZero = function (_v0) {
	var x = _v0;
	return x > 0;
};
var $author$project$Go$hasTimeToDoAction$ = function (time, model) {
	var _v0 = model.timeLeft;
	if (!_v0.$) {
		var white = _v0.a.white;
		var black = _v0.a.black;
		return $ianmackenzie$elm_units$Quantity$greaterThanZero(
			$author$project$Go$actualTimeLeft$(
				time,
				model.currentPlayer,
				model.currentPlayer,
				function () {
					var _v1 = model.currentPlayer;
					if (_v1 === 1) {
						return white;
					} else {
						return black;
					}
				}(),
				model));
	} else {
		return true;
	}
};
var $author$project$Go$hasTimeToDoAction = F2($author$project$Go$hasTimeToDoAction$);
var $author$project$Go$Marking = {$: 1};
var $author$project$Go$performPass$ = function (currentTime, setup, model) {
	var _v0 = model.phase;
	if (!_v0.$) {
		var previousPlayerPassed = _v0.a.previousPlayerPassed;
		return previousPlayerPassed ? $author$project$Go$applyIncrement$(
			currentTime,
			setup,
			model.currentPlayer,
			_Utils_update(
				model,
				{
					currentPlayer: $author$project$Go$otherStone(model.currentPlayer),
					phase: $author$project$Go$Marking
				})) : $author$project$Go$applyIncrement$(
			currentTime,
			setup,
			model.currentPlayer,
			_Utils_update(
				model,
				{
					currentPlayer: $author$project$Go$otherStone(model.currentPlayer),
					lastMove: $elm$core$Maybe$Nothing,
					phase: $author$project$Go$Playing(
						{previousPlayerPassed: true})
				}));
	} else {
		return model;
	}
};
var $author$project$Go$performPass = F3($author$project$Go$performPass$);
var $author$project$Go$currentSnapshot = function (model) {
	return {blackCaptures: model.blackCaptures, board: model.board, currentPlayer: model.currentPlayer, whiteCaptures: model.whiteCaptures};
};
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Set$isEmpty = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$isEmpty(dict);
};
var $elm$core$List$member$ = function (x, xs) {
	return $elm$core$List$any$(
		function (a) {
			return _Utils_eq(a, x);
		},
		xs);
};
var $elm$core$List$member = F2($elm$core$List$member$);
var $elm$core$Dict$sizeHelp$ = function (n, dict) {
	sizeHelp:
	while (true) {
		if (dict.$ === -2) {
			return n;
		} else {
			var left = dict.d;
			var right = dict.e;
			var $temp$n = $elm$core$Dict$sizeHelp$(n + 1, right),
				$temp$dict = left;
			n = $temp$n;
			dict = $temp$dict;
			continue sizeHelp;
		}
	}
};
var $elm$core$Dict$sizeHelp = F2($elm$core$Dict$sizeHelp$);
var $elm$core$Dict$size = function (dict) {
	return $elm$core$Dict$sizeHelp$(0, dict);
};
var $elm$core$Set$size = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$size(dict);
};
var $author$project$Go$tryPlace$ = function (setup, x, y, model) {
	if ($elm$core$Dict$member$(
		_Utils_Tuple2(x, y),
		model.board)) {
		return $elm$core$Result$Err('There\u0027s already a stone there');
	} else {
		var stone = model.currentPlayer;
		var recentBoards = $elm$core$List$map$(
			function ($) {
				return $.board;
			},
			$elm$core$List$take$(10, model.history));
		var opponent = $author$project$Go$otherStone(stone);
		var boardWithStone = $elm$core$Dict$insert$(
			_Utils_Tuple2(x, y),
			stone,
			model.board);
		var _v0 = $elm$core$List$foldl$(
			F2(
				function (n, _v1) {
					var b = _v1.a;
					var captures = _v1.b;
					var _v2 = $elm$core$Dict$get$(n, b);
					if (!_v2.$) {
						var neighborStone = _v2.a;
						if (_Utils_eq(neighborStone, opponent)) {
							var group = $author$project$Go$groupAt$(setup, b, n);
							return $elm$core$Set$isEmpty(group.liberties) ? _Utils_Tuple2(
								$elm$core$Set$foldl$($elm$core$Dict$remove, b, group.stones),
								captures + $elm$core$Set$size(group.stones)) : _Utils_Tuple2(b, captures);
						} else {
							return _Utils_Tuple2(b, captures);
						}
					} else {
						return _Utils_Tuple2(b, captures);
					}
				}),
			_Utils_Tuple2(boardWithStone, 0),
			$author$project$Go$neighbors$(
				setup,
				_Utils_Tuple2(x, y)));
		var boardAfterCapture = _v0.a;
		var captured = _v0.b;
		var myGroup = $author$project$Go$groupAt$(
			setup,
			boardAfterCapture,
			_Utils_Tuple2(x, y));
		return $elm$core$Set$isEmpty(myGroup.liberties) ? $elm$core$Result$Err('Suicide move not allowed') : ($elm$core$List$member$(boardAfterCapture, recentBoards) ? $elm$core$Result$Err('Move repeats a board state') : $elm$core$Result$Ok(
			_Utils_update(
				model,
				{
					blackCaptures: (!stone) ? (model.blackCaptures + captured) : model.blackCaptures,
					board: boardAfterCapture,
					currentPlayer: opponent,
					history: A2(
						$elm$core$List$cons,
						$author$project$Go$currentSnapshot(model),
						model.history),
					lastMove: $elm$core$Maybe$Just(
						_Utils_Tuple2(x, y)),
					phase: $author$project$Go$Playing(
						{previousPlayerPassed: false}),
					whiteCaptures: (stone === 1) ? (model.whiteCaptures + captured) : model.whiteCaptures
				})));
	}
};
var $author$project$Go$tryPlace = F4($author$project$Go$tryPlace$);
var $author$project$Go$updateAction$ = function (setup, action, model) {
	var currentPlayer = model.currentPlayer;
	if ($author$project$Go$hasTimeToDoAction$(action.time, model)) {
		var _v0 = action.change;
		switch (_v0.$) {
			case 0:
				var x = _v0.a;
				var y = _v0.b;
				var _v1 = $author$project$Go$tryPlace$(setup, x, y, model);
				if (!_v1.$) {
					var model2 = _v1.a;
					return $author$project$Go$applyIncrement$(action.time, setup, currentPlayer, model2);
				} else {
					return model;
				}
			case 1:
				return $author$project$Go$performPass$(action.time, setup, model);
			case 2:
				var x = _v0.a;
				var y = _v0.b;
				return $author$project$Go$cycleTerritory$(setup, x, y, model);
			case 3:
				var _v2 = model.phase;
				if (_v2.$ === 1) {
					return _Utils_update(
						model,
						{
							currentPlayer: $author$project$Go$otherStone(currentPlayer),
							lastAction: $elm$core$Maybe$Just(action.time),
							phase: $author$project$Go$Confirming
						});
				} else {
					return model;
				}
			case 4:
				var _v3 = model.phase;
				if (_v3.$ === 2) {
					var _v4 = $author$project$Go$computeScore$(setup, model);
					var b = _v4.a;
					var w = _v4.b;
					return _Utils_update(
						model,
						{
							lastAction: $elm$core$Maybe$Just(action.time),
							phase: $author$project$Go$Scored(
								{blackScore: b, whiteScore: w})
						});
				} else {
					return model;
				}
			case 5:
				var _v5 = model.phase;
				if (_v5.$ === 2) {
					return _Utils_update(
						model,
						{
							currentPlayer: $author$project$Go$otherStone(currentPlayer),
							lastAction: $elm$core$Maybe$Just(action.time),
							phase: $author$project$Go$Playing(
								{previousPlayerPassed: false}),
							territoryMarks: $elm$core$Dict$empty
						});
				} else {
					return model;
				}
			default:
				var userId = _v0.a;
				var _v6 = model.joinedUserId;
				if (!_v6.$) {
					return model;
				} else {
					return _Utils_update(
						model,
						{
							joinedUserId: $elm$core$Maybe$Just(userId)
						});
				}
		}
	} else {
		return model;
	}
};
var $author$project$Go$updateAction = F3($author$project$Go$updateAction$);
var $author$project$Go$foldActions$ = function (setup, actions) {
	return $elm$core$Array$foldl$(
		$author$project$Go$updateAction(setup),
		$author$project$Go$initShared(setup),
		actions);
};
var $author$project$Go$foldActions = F2($author$project$Go$foldActions$);
var $author$project$Game$initMatchData$ = function (gameData, publicLink) {
	return $author$project$Game$MatchData(
		{
			data: function () {
				switch (gameData.$) {
					case 0:
						var setup = gameData.a;
						var actions = gameData.b;
						return $author$project$Game$FrontendGameData_Go$(
							setup,
							actions,
							$author$project$Go$foldActions$(setup, actions));
					case 1:
						var setup = gameData.a;
						var actions = gameData.b;
						var shared = gameData.c;
						return $author$project$Game$FrontendGameData_WordSpellingGame$(setup, actions, shared);
					default:
						var setup = gameData.a;
						var actions = gameData.b;
						var shared = gameData.c;
						return $author$project$Game$FrontendGameData_SheepGame$(setup, actions, shared);
				}
			}(),
			publicLink: publicLink
		});
};
var $author$project$Game$initMatchData = F2($author$project$Game$initMatchData$);
var $author$project$DmChannel$addRepliedToMatches$ = function (repliedToMatches, games) {
	return $lamdera$containers$SeqDict$foldl$(
		F3(
			function (matchId, loaded, games2) {
				return $lamdera$containers$SeqDict$updateIfExists$(
					matchId,
					function (_v0) {
						return $author$project$Game$initMatchData$(loaded.gameData, loaded.publicLink);
					},
					games2);
			}),
		games,
		repliedToMatches);
};
var $author$project$DmChannel$addRepliedToMatches = F2($author$project$DmChannel$addRepliedToMatches$);
var $author$project$FrontendExtra$loadIfMissing$ = function (messageId, message, messages) {
	var _v0 = $author$project$MessageArray$get$(messageId, messages);
	if (!_v0.$) {
		return messages;
	} else {
		return $author$project$MessageArray$set$(messageId, message, messages);
	}
};
var $author$project$FrontendExtra$loadIfMissing = F3($author$project$FrontendExtra$loadIfMissing$);
var $author$project$Message$threadRouteRepliedToMatches = function (threadRoute) {
	if (!threadRoute.$) {
		switch (threadRoute.a.$) {
			case 2:
				var _v1 = threadRoute.a;
				var matchId = _v1.a;
				return _List_fromArray(
					[matchId]);
			case 1:
				return _List_Nil;
			default:
				var _v2 = threadRoute.a;
				return _List_Nil;
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$FrontendExtra$addRepliedToData$ = function (threadRoute, repliedToData, channel) {
	switch (repliedToData.$) {
		case 0:
			return channel;
		case 1:
			var message = repliedToData.a;
			if (!threadRoute.$) {
				switch (threadRoute.a.$) {
					case 1:
						var messageId = threadRoute.a.a;
						return _Utils_update(
							channel,
							{
								messages: $author$project$FrontendExtra$loadIfMissing$(messageId, message, channel.messages)
							});
					case 2:
						var _v2 = threadRoute.a;
						return channel;
					default:
						var _v3 = threadRoute.a;
						return channel;
				}
			} else {
				return channel;
			}
		case 2:
			var message = repliedToData.a;
			if (threadRoute.$ === 1) {
				if (!threadRoute.b.$) {
					var threadId = threadRoute.a;
					var messageId = threadRoute.b.a;
					return _Utils_update(
						channel,
						{
							threads: $lamdera$containers$SeqDict$updateIfExists$(
								threadId,
								function (thread) {
									return _Utils_update(
										thread,
										{
											messages: $author$project$FrontendExtra$loadIfMissing$(messageId, message, thread.messages)
										});
								},
								channel.threads)
						});
				} else {
					var _v5 = threadRoute.b;
					return channel;
				}
			} else {
				return channel;
			}
		default:
			var match = repliedToData.a;
			return _Utils_update(
				channel,
				{
					games: $author$project$DmChannel$addRepliedToMatches$(
						$lamdera$containers$SeqDict$fromList(
							$elm$core$List$map$(
								function (matchId) {
									return _Utils_Tuple2(matchId, match);
								},
								$author$project$Message$threadRouteRepliedToMatches(threadRoute))),
						channel.games)
				});
	}
};
var $author$project$FrontendExtra$addRepliedToData = F3($author$project$FrontendExtra$addRepliedToData$);
var $author$project$SeqDictHelper$addToDict$ = function (outerKey, innerKey, value, voiceChats) {
	return $lamdera$containers$SeqDict$update$(
		outerKey,
		function (maybe) {
			if (!maybe.$) {
				var nonempty = maybe.a;
				return $elm$core$Maybe$Just(
					$author$project$NonemptyDict$insert$(innerKey, value, nonempty));
			} else {
				return $elm$core$Maybe$Just(
					$author$project$NonemptyDict$singleton$(innerKey, value));
			}
		},
		voiceChats);
};
var $author$project$SeqDictHelper$addToDict = F4($author$project$SeqDictHelper$addToDict$);
var $author$project$LocalState$addRecordingFileProgress$ = function (file, files) {
	return $elm$core$List$any$(
		function (existing) {
			return _Utils_eq(existing.recordedBy, file.recordedBy) && _Utils_eq(existing.name, file.name);
		},
		files) ? $elm$core$List$map$(
		function (existing) {
			return (_Utils_eq(existing.recordedBy, file.recordedBy) && _Utils_eq(existing.name, file.name)) ? _Utils_update(
				existing,
				{
					uploaded: $elm$core$Basics$max$(file.uploaded, existing.uploaded)
				}) : existing;
		},
		files) : _Utils_ap(
		files,
		_List_fromArray(
			[file]));
};
var $author$project$LocalState$addRecordingFileProgress = F2($author$project$LocalState$addRecordingFileProgress$);
var $author$project$LocalState$callRecordingUploadProgressFrontend$ = function (messageId, file, channel) {
	return _Utils_update(
		channel,
		{
			messages: $author$project$MessageArray$updateIfExists$(
				messageId,
				function (message) {
					if (message.$ === 4) {
						var callStarted = message.a;
						var _v1 = callStarted.recordings;
						if (!_v1.$) {
							var recording = _v1.a;
							return $author$project$Message$CallStarted(
								_Utils_update(
									callStarted,
									{
										recordings: $elm$core$Maybe$Just(
											_Utils_update(
												recording,
												{
													files: $author$project$LocalState$addRecordingFileProgress$(file, recording.files)
												}))
									}));
						} else {
							return message;
						}
					} else {
						return message;
					}
				},
				channel.messages)
		});
};
var $author$project$LocalState$callRecordingUploadProgressFrontend = F3($author$project$LocalState$callRecordingUploadProgressFrontend$);
var $author$project$LocalState$callRecordingZipBuiltFrontend$ = function (messageId, zip, channel) {
	return _Utils_update(
		channel,
		{
			messages: $author$project$MessageArray$updateIfExists$(
				messageId,
				function (message) {
					if (message.$ === 4) {
						var callStarted = message.a;
						var _v1 = callStarted.recordings;
						if (!_v1.$) {
							var recording = _v1.a;
							return $author$project$Message$CallStarted(
								_Utils_update(
									callStarted,
									{
										recordings: $elm$core$Maybe$Just(
											_Utils_update(
												recording,
												{
													zip: $elm$core$Maybe$Just(zip)
												}))
									}));
						} else {
							return message;
						}
					} else {
						return message;
					}
				},
				channel.messages)
		});
};
var $author$project$LocalState$callRecordingZipBuiltFrontend = F3($author$project$LocalState$callRecordingZipBuiltFrontend$);
var $lamdera$containers$SeqDict$intersect$ = function (_v0, _v1) {
	var t1Triplets = _v0.c;
	var t2Bitmap = _v1.a;
	var t2Nodes = _v1.b;
	var helper = F2(
		function (_v3, dict) {
			var hash = _v3.a;
			var key = _v3.b;
			var value = _v3.c;
			var bitmap = dict.a;
			var nodes = dict.b;
			var triplets = dict.c;
			var _v2 = $lamdera$containers$SeqDict$getHelp$(0, hash, key, t2Bitmap, t2Nodes);
			if (_v2.$ === 1) {
				return dict;
			} else {
				return $lamdera$containers$SeqDict$insertHelp$(0, hash, key, value, bitmap, nodes, triplets);
			}
		});
	return $lamdera$containers$SeqDict$intDictFoldl$(helper, $lamdera$containers$SeqDict$empty, t1Triplets);
};
var $lamdera$containers$SeqDict$intersect = F2($lamdera$containers$SeqDict$intersect$);
var $lamdera$containers$SeqDict$isEmpty = function (_v0) {
	var bitmap = _v0.a;
	return !bitmap;
};
var $author$project$MembersAndOwner$members = function (_v0) {
	var members2 = _v0.a;
	return members2;
};
var $author$project$MembersAndOwner$owner = function (_v0) {
	var ownerId = _v0.b;
	return ownerId;
};
var $author$project$LocalState$canViewDiscordGuild$ = function (linkedDiscordUsers, membersAndOwner) {
	return $lamdera$containers$SeqDict$member$(
		$author$project$MembersAndOwner$owner(membersAndOwner),
		linkedDiscordUsers) || (!$lamdera$containers$SeqDict$isEmpty(
		$lamdera$containers$SeqDict$intersect$(
			$author$project$MembersAndOwner$members(membersAndOwner),
			linkedDiscordUsers)));
};
var $author$project$LocalState$canViewDiscordGuild = F2($author$project$LocalState$canViewDiscordGuild$);
var $author$project$Range$rangeSize = function (range) {
	return range.end - range.start;
};
var $author$project$TextEditor$insertTextHelper$ = function (insertCount, removeRange, range) {
	var size = $author$project$Range$rangeSize(removeRange);
	var moveStartBy = (_Utils_cmp(removeRange.start, range.start) < 0) ? insertCount : 0;
	var moveEndBy = (_Utils_cmp(removeRange.start, range.end) < 0) ? insertCount : 0;
	return (_Utils_cmp(removeRange.end, range.start) < 1) ? {end: (range.end - size) + insertCount, start: (range.start - size) + insertCount} : ((_Utils_cmp(removeRange.end, range.end) < 1) ? {
		end: (range.end - size) + moveEndBy,
		start: (range.start - $elm$core$Basics$max$(0, range.start - removeRange.start)) + moveStartBy
	} : {
		end: (range.end - $elm$core$Basics$max$(0, range.end - removeRange.start)) + moveEndBy,
		start: (range.start - $elm$core$Basics$max$(0, range.start - removeRange.start)) + moveStartBy
	});
};
var $author$project$TextEditor$insertTextHelper = F3($author$project$TextEditor$insertTextHelper$);
var $author$project$TextEditor$addEditAdjustRange$ = function (change, range) {
	var insertionRange = change.a;
	var string = change.b;
	var insertCount = $elm$core$String$length(string);
	return $author$project$TextEditor$insertTextHelper$(insertCount, insertionRange, range);
};
var $author$project$TextEditor$addEditAdjustRange = F2($author$project$TextEditor$addEditAdjustRange$);
var $elmcraft$core_extra$List$Extra$count = function (predicate) {
	return A2(
		$elm$core$List$foldl,
		F2(
			function (x, acc) {
				return predicate(x) ? (acc + 1) : acc;
			}),
		0);
};
var $elm$core$Array$filter$ = function (isGood, array) {
	return $elm$core$Array$fromList(
		$elm$core$Array$foldr$(
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			array));
};
var $elm$core$Array$filter = F2($elm$core$Array$filter$);
var $lamdera$containers$JsArray2$map = _JsArray2_map;
var $lamdera$containers$SeqDict$map$ = function (fn, _v0) {
	var rootBitmap = _v0.a;
	var rootNodes = _v0.b;
	var rootTriplets = _v0.c;
	var valueHelper = function (_v2) {
		var i = _v2.a;
		var k = _v2.b;
		var v = _v2.c;
		return _Utils_Tuple3(
			i,
			k,
			A2(fn, k, v));
	};
	var dictHelper = function (node) {
		switch (node.$) {
			case 0:
				var idx = node.a;
				var h = node.b;
				var k = node.c;
				var v = node.d;
				return $lamdera$containers$SeqDict$Leaf$(
					idx,
					h,
					k,
					A2(fn, k, v));
			case 1:
				var bitmap = node.a;
				var nodes = node.b;
				return $lamdera$containers$SeqDict$SubTree$(
					bitmap,
					A2($lamdera$containers$JsArray2$map, dictHelper, nodes));
			default:
				var h = node.a;
				var triplets = node.b;
				return $lamdera$containers$SeqDict$Collision$(
					h,
					$elm$core$List$map$(valueHelper, triplets));
		}
	};
	return $lamdera$containers$SeqDict$SeqDict_elm_builtin$(
		rootBitmap,
		A2($lamdera$containers$JsArray2$map, dictHelper, rootNodes),
		{
			array: $elm$core$Array$map$(
				$elm$core$Maybe$map(valueHelper),
				rootTriplets.array),
			size: rootTriplets.size
		});
};
var $lamdera$containers$SeqDict$map = F2($lamdera$containers$SeqDict$map$);
var $author$project$TextEditor$addEdit$ = function (changeBy, change, local) {
	var undoPoint = $elm$core$Maybe$withDefault$(
		-1,
		$lamdera$containers$SeqDict$get$(changeBy, local.undoPoint));
	var removed = $elm$core$List$filterMap$(
		$elm$core$Basics$identity,
		$elm$core$List$indexedMap$(
			F2(
				function (index, _v3) {
					var a = _v3.a;
					return _Utils_eq(a, changeBy) ? $elm$core$Maybe$Just(index + (undoPoint + 1)) : $elm$core$Maybe$Nothing;
				}),
			$elm$core$Array$toList(
				$elm$core$Array$slice$(
					undoPoint + 1,
					$elm$core$Array$length(local.history),
					local.history))));
	var kept = $elm$core$Array$filter$(
		function (_v2) {
			var a = _v2.a;
			return !_Utils_eq(a, changeBy);
		},
		$elm$core$Array$slice$(
			undoPoint + 1,
			$elm$core$Array$length(local.history),
			local.history));
	var history = $elm$core$Array$push$(
		_Utils_Tuple2(changeBy, change),
		$elm$core$Array$append$(
			$elm$core$Array$slice$(0, undoPoint + 1, local.history),
			kept));
	return _Utils_update(
		local,
		{
			cursorPosition: $lamdera$containers$SeqDict$map$(
				F2(
					function (_v0, range) {
						return $author$project$TextEditor$addEditAdjustRange$(change, range);
					}),
				local.cursorPosition),
			history: history,
			undoPoint: $lamdera$containers$SeqDict$insert$(
				changeBy,
				$elm$core$Array$length(history) - 1,
				$lamdera$containers$SeqDict$map$(
					F2(
						function (_v1, undoPoint2) {
							return undoPoint2 - A2(
								$elmcraft$core_extra$List$Extra$count,
								function (index) {
									return _Utils_cmp(index, undoPoint2) < 0;
								},
								removed);
						}),
					local.undoPoint))
		});
};
var $author$project$TextEditor$addEdit = F3($author$project$TextEditor$addEdit$);
var $author$project$TextEditor$initLocalState = {cursorPosition: $lamdera$containers$SeqDict$empty, history: $elm$core$Array$empty, undoPoint: $lamdera$containers$SeqDict$empty};
var $author$project$TextEditor$getNextRedoPoint$ = function (userId, index, history) {
	getNextRedoPoint:
	while (true) {
		var _v0 = $elm$core$Array$get$(index, history);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var changeBy = _v1.a;
			var edit = _v1.b;
			if (_Utils_eq(changeBy, userId)) {
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(index, edit));
			} else {
				var $temp$index = index + 1;
				index = $temp$index;
				continue getNextRedoPoint;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$TextEditor$getNextRedoPoint = F3($author$project$TextEditor$getNextRedoPoint$);
var $author$project$TextEditor$redoChange$ = function (userId, local) {
	var oldRedoPoint = $elm$core$Maybe$withDefault$(
		-1,
		$lamdera$containers$SeqDict$get$(userId, local.undoPoint));
	var _v0 = $author$project$TextEditor$getNextRedoPoint$(userId, oldRedoPoint + 1, local.history);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var redoPoint = _v1.a;
		var edit = _v1.b;
		return _Utils_update(
			local,
			{
				cursorPosition: $lamdera$containers$SeqDict$map$(
					F2(
						function (_v2, range) {
							return $author$project$TextEditor$addEditAdjustRange$(edit, range);
						}),
					local.cursorPosition),
				undoPoint: $lamdera$containers$SeqDict$insert$(userId, redoPoint, local.undoPoint)
			});
	} else {
		return local;
	}
};
var $author$project$TextEditor$redoChange = F2($author$project$TextEditor$redoChange$);
var $author$project$TextEditor$getNextUndoPoint$ = function (userId, index, history) {
	getNextUndoPoint:
	while (true) {
		var _v0 = $elm$core$Array$get$(index, history);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var changeBy = _v1.a;
			if (_Utils_eq(changeBy, userId)) {
				return $elm$core$Maybe$Just(index);
			} else {
				var $temp$index = index - 1;
				index = $temp$index;
				continue getNextUndoPoint;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$TextEditor$getNextUndoPoint = F3($author$project$TextEditor$getNextUndoPoint$);
var $author$project$TextEditor$undoChange$ = function (userId, local) {
	return _Utils_update(
		local,
		{
			undoPoint: $lamdera$containers$SeqDict$update$(
				userId,
				function (maybe) {
					if (!maybe.$) {
						var index = maybe.a;
						return $author$project$TextEditor$getNextUndoPoint$(userId, index - 1, local.history);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				local.undoPoint)
		});
};
var $author$project$TextEditor$undoChange = F2($author$project$TextEditor$undoChange$);
var $author$project$TextEditor$changeUpdate$ = function (change, local) {
	switch (change.$) {
		case 0:
			var changeBy = change.a;
			var change2 = change.b;
			return $author$project$TextEditor$addEdit$(changeBy, change2, local);
		case 1:
			return $author$project$TextEditor$initLocalState;
		case 2:
			var userId = change.a;
			return $author$project$TextEditor$undoChange$(userId, local);
		default:
			var userId = change.a;
			return $author$project$TextEditor$redoChange$(userId, local);
	}
};
var $author$project$TextEditor$changeUpdate = F2($author$project$TextEditor$changeUpdate$);
var $lamdera$containers$SeqSet$remove$ = function (k, _v0) {
	var dict = _v0;
	return $lamdera$containers$SeqDict$remove$(k, dict);
};
var $lamdera$containers$SeqSet$remove = F2($lamdera$containers$SeqSet$remove$);
var $author$project$UserSession$collapseUserOptionSection$ = function (section, session) {
	return _Utils_update(
		session,
		{
			expandedUserOptions: $lamdera$containers$SeqSet$remove$(section, session.expandedUserOptions)
		});
};
var $author$project$UserSession$collapseUserOptionSection = F2($author$project$UserSession$collapseUserOptionSection$);
var $elmcraft$core_extra$List$Extra$foldl1$ = function (func, list) {
	if (!list.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			$elm$core$List$foldl$(func, x, xs));
	}
};
var $elmcraft$core_extra$List$Extra$foldl1 = F2($elmcraft$core_extra$List$Extra$foldl1$);
var $elmcraft$core_extra$List$Extra$maximumWith$ = function (comparator, list) {
	return $elmcraft$core_extra$List$Extra$foldl1$(
		F2(
			function (x, y) {
				var _v0 = A2(comparator, x, y);
				if (_v0 === 2) {
					return x;
				} else {
					return y;
				}
			}),
		list);
};
var $elmcraft$core_extra$List$Extra$maximumWith = F2($elmcraft$core_extra$List$Extra$maximumWith$);
var $author$project$Id$nextId = function (dict) {
	var _v0 = $elmcraft$core_extra$List$Extra$maximumWith$(
		F2(
			function (_v1, _v2) {
				var a = _v1;
				var b = _v2;
				return A2($elm$core$Basics$compare, a, b);
			}),
		$lamdera$containers$SeqDict$keys(dict));
	if (!_v0.$) {
		var value = _v0.a;
		return value + 1;
	} else {
		return 0;
	}
};
var $author$project$LocalState$createChannelFrontend$ = function (time, userId, channelName, channelDescription, guild) {
	return _Utils_update(
		guild,
		{
			channels: $lamdera$containers$SeqDict$insert$(
				$author$project$Id$nextId(guild.channels),
				{createdAt: time, createdBy: userId, dateDividerDrawings: $lamdera$containers$SeqDict$empty, description: channelDescription, games: $lamdera$containers$SeqDict$empty, isArchived: $elm$core$Maybe$Nothing, messages: $author$project$MessageArray$empty, name: channelName, threads: $lamdera$containers$SeqDict$empty, visibleMessages: $author$project$VisibleMessages$empty},
				guild.channels)
		});
};
var $author$project$LocalState$createChannelFrontend = F5($author$project$LocalState$createChannelFrontend$);
var $author$project$LocalState$createDiscordDmMessageFrontend$ = function (message, channel) {
	return $author$project$LocalState$createMessageFrontend$(_List_Nil, message, channel);
};
var $author$project$LocalState$createDiscordDmMessageFrontend = F2($author$project$LocalState$createDiscordDmMessageFrontend$);
var $author$project$LocalState$ChannelActive = {$: 0};
var $author$project$ChannelName$ChannelName = $elm$core$Basics$identity;
var $elm$core$String$any = _String_any;
var $MartinSStewart$elm_nonempty_string$String$Nonempty$any = function (anyFunc) {
	return A2(
		$elm$core$Basics$composeR,
		$MartinSStewart$elm_nonempty_string$String$Nonempty$toString,
		$elm$core$String$any(anyFunc));
};
var $MartinSStewart$elm_nonempty_string$String$Nonempty$length = A2($elm$core$Basics$composeR, $MartinSStewart$elm_nonempty_string$String$Nonempty$toString, $elm$core$String$length);
var $author$project$ChannelName$maxLength = 50;
var $author$project$ChannelName$fromString = function (text) {
	var _v0 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(
		$elm$core$String$trim(text));
	if (!_v0.$) {
		var nonempty = _v0.a;
		return (_Utils_cmp(
			$MartinSStewart$elm_nonempty_string$String$Nonempty$length(nonempty),
			$author$project$ChannelName$maxLength) > 0) ? $elm$core$Result$Err('Too long') : (A2(
			$MartinSStewart$elm_nonempty_string$String$Nonempty$any,
			function (_char) {
				return (_char === '\n') || (_char === '\r');
			},
			nonempty) ? $elm$core$Result$Err('Name can\u0027t contain line breaks') : $elm$core$Result$Ok(nonempty));
	} else {
		return $elm$core$Result$Err('Can\u0027t be empty');
	}
};
var $author$project$Unsafe$causeStackOverflow = function (value) {
	return $author$project$Unsafe$causeStackOverflow(value) + 1;
};
var $author$project$Unsafe$unreachable = function (v) {
	unreachable:
	while (true) {
		var $temp$v = $author$project$Unsafe$causeStackOverflow(v);
		v = $temp$v;
		continue unreachable;
	}
};
var $author$project$Unsafe$channelName = function (a) {
	var _v0 = $author$project$ChannelName$fromString(a);
	if (!_v0.$) {
		var b = _v0.a;
		return b;
	} else {
		return $author$project$Unsafe$unreachable(0);
	}
};
var $author$project$LocalState$defaultChannelName = $author$project$Unsafe$channelName('general');
var $author$project$ChannelDescription$ChannelDescription = $elm$core$Basics$identity;
var $author$project$ChannelDescription$empty = '';
var $author$project$IdArray$IdArray = $elm$core$Basics$identity;
var $author$project$IdArray$empty = $elm$core$Array$empty;
var $author$project$MembersAndOwner$init$ = function (members2, ownerId) {
	return $author$project$MembersAndOwner$MembersAndOwner$(
		$lamdera$containers$SeqDict$remove$(ownerId, members2),
		ownerId);
};
var $author$project$MembersAndOwner$init = F2($author$project$MembersAndOwner$init$);
var $author$project$LocalState$createGuild$ = function (time, userId, guildName) {
	return {
		bannedUsers: $lamdera$containers$SeqSet$empty,
		channels: $lamdera$containers$SeqDict$fromList(
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Id$fromInt(0),
					{createdAt: time, createdBy: userId, dateDividerDrawings: $lamdera$containers$SeqDict$empty, description: $author$project$ChannelDescription$empty, games: $lamdera$containers$SeqDict$empty, messages: $author$project$IdArray$empty, name: $author$project$LocalState$defaultChannelName, status: $author$project$LocalState$ChannelActive, threads: $lamdera$containers$SeqDict$empty})
				])),
		createdAt: time,
		createdBy: userId,
		icon: $elm$core$Maybe$Nothing,
		invites: $lamdera$containers$SeqDict$empty,
		lastTypedAt: $lamdera$containers$SeqDict$empty,
		membersAndOwner: $author$project$MembersAndOwner$init$($lamdera$containers$SeqDict$empty, userId),
		name: guildName
	};
};
var $author$project$LocalState$createGuild = F3($author$project$LocalState$createGuild$);
var $author$project$Message$toDecrypted$ = function (content, message) {
	switch (message.$) {
		case 1:
			var data = message.a;
			return $author$project$Message$UserTextMessage(
				{content: content, createdAt: data.createdAt, createdBy: data.createdBy, drawings: data.drawings, editedAt: data.editedAt, reactions: data.reactions, repliedTo: data.repliedTo});
		case 0:
			return message;
		case 2:
			return message;
		case 3:
			return message;
		case 4:
			return message;
		default:
			return message;
	}
};
var $author$project$Message$toDecrypted = F2($author$project$Message$toDecrypted$);
var $author$project$FrontendExtra$decryptOldMessages$ = function (messages, dmChannel) {
	return $elm$core$List$foldl$(
		F2(
			function (_v0, channel) {
				var threadRoute = _v0.a;
				var content = _v0.b;
				if (!threadRoute.$) {
					var messageId = threadRoute.a;
					return _Utils_update(
						channel,
						{
							messages: $author$project$MessageArray$updateIfExists$(
								messageId,
								$author$project$Message$toDecrypted(content),
								channel.messages)
						});
				} else {
					var threadId = threadRoute.a;
					var messageId = threadRoute.b;
					return _Utils_update(
						channel,
						{
							threads: $lamdera$containers$SeqDict$updateIfExists$(
								threadId,
								function (thread) {
									return _Utils_update(
										thread,
										{
											messages: $author$project$MessageArray$updateIfExists$(
												messageId,
												$author$project$Message$toDecrypted(content),
												thread.messages)
										});
								},
								channel.threads)
						});
				}
			}),
		dmChannel,
		messages);
};
var $author$project$FrontendExtra$decryptOldMessages = F2($author$project$FrontendExtra$decryptOldMessages$);
var $author$project$LocalState$deleteChannelFrontend$ = function (channelId, guild) {
	return _Utils_update(
		guild,
		{
			channels: $lamdera$containers$SeqDict$remove$(channelId, guild.channels)
		});
};
var $author$project$LocalState$deleteChannelFrontend = F2($author$project$LocalState$deleteChannelFrontend$);
var $author$project$Message$DeletedMessage = function (a) {
	return {$: 3, a: a};
};
var $author$project$LocalState$deleteMessageFrontendNoThread$ = function (messageId, channel) {
	var _v0 = $author$project$MessageArray$get$(messageId, channel.messages);
	if (!_v0.$) {
		var message = _v0.a;
		switch (message.$) {
			case 0:
				var message2 = message.a;
				return _Utils_update(
					channel,
					{
						messages: $author$project$MessageArray$set$(
							messageId,
							$author$project$Message$DeletedMessage(message2.createdAt),
							channel.messages)
					});
			case 1:
				var message2 = message.a;
				return _Utils_update(
					channel,
					{
						messages: $author$project$MessageArray$set$(
							messageId,
							$author$project$Message$DeletedMessage(message2.createdAt),
							channel.messages)
					});
			case 2:
				return channel;
			case 3:
				return channel;
			case 4:
				var callStarted = message.a;
				return _Utils_update(
					channel,
					{
						messages: $author$project$MessageArray$set$(
							messageId,
							$author$project$Message$DeletedMessage(callStarted.startedAt),
							channel.messages)
					});
			default:
				return channel;
		}
	} else {
		return channel;
	}
};
var $author$project$LocalState$deleteMessageFrontendNoThread = F2($author$project$LocalState$deleteMessageFrontendNoThread$);
var $author$project$LocalState$deleteForumPostFrontend$ = function (channelId, messageId, guild) {
	var _v0 = $lamdera$containers$SeqDict$get$(channelId, guild.channels);
	if (!_v0.$) {
		var channel = _v0.a;
		var channel2 = $author$project$LocalState$deleteMessageFrontendNoThread$(messageId, channel);
		return _Utils_update(
			guild,
			{
				channels: $lamdera$containers$SeqDict$insert$(
					channelId,
					_Utils_update(
						channel2,
						{
							threads: $lamdera$containers$SeqDict$remove$(messageId, channel2.threads)
						}),
					guild.channels)
			});
	} else {
		return guild;
	}
};
var $author$project$LocalState$deleteForumPostFrontend = F3($author$project$LocalState$deleteForumPostFrontend$);
var $author$project$LocalState$deleteMessageFrontendHelper$ = function (threadRoute, channel) {
	if (threadRoute.$ === 1) {
		var threadId = threadRoute.a;
		var messageId = threadRoute.b;
		var _v1 = $lamdera$containers$SeqDict$get$(threadId, channel.threads);
		if (!_v1.$) {
			var thread = _v1.a;
			var _v2 = $author$project$MessageArray$get$(messageId, thread.messages);
			if (!_v2.$) {
				var message = _v2.a;
				switch (message.$) {
					case 0:
						var message2 = message.a;
						return _Utils_update(
							channel,
							{
								threads: $lamdera$containers$SeqDict$insert$(
									threadId,
									_Utils_update(
										thread,
										{
											messages: $author$project$MessageArray$set$(
												messageId,
												$author$project$Message$DeletedMessage(message2.createdAt),
												thread.messages)
										}),
									channel.threads)
							});
					case 1:
						var message2 = message.a;
						return _Utils_update(
							channel,
							{
								threads: $lamdera$containers$SeqDict$insert$(
									threadId,
									_Utils_update(
										thread,
										{
											messages: $author$project$MessageArray$set$(
												messageId,
												$author$project$Message$DeletedMessage(message2.createdAt),
												thread.messages)
										}),
									channel.threads)
							});
					case 2:
						return channel;
					case 3:
						return channel;
					case 4:
						return channel;
					default:
						return channel;
				}
			} else {
				return channel;
			}
		} else {
			return channel;
		}
	} else {
		var messageId = threadRoute.a;
		return $author$project$LocalState$deleteMessageFrontendNoThread$(messageId, channel);
	}
};
var $author$project$LocalState$deleteMessageFrontendHelper = F2($author$project$LocalState$deleteMessageFrontendHelper$);
var $author$project$LocalState$deleteMessageFrontend$ = function (channelId, threadRoute, guild) {
	var _v0 = $lamdera$containers$SeqDict$get$(channelId, guild.channels);
	if (!_v0.$) {
		var channel = _v0.a;
		return _Utils_update(
			guild,
			{
				channels: $lamdera$containers$SeqDict$insert$(
					channelId,
					$author$project$LocalState$deleteMessageFrontendHelper$(threadRoute, channel),
					guild.channels)
			});
	} else {
		return guild;
	}
};
var $author$project$LocalState$deleteMessageFrontend = F3($author$project$LocalState$deleteMessageFrontend$);
var $author$project$FrontendExtra$deleteMessage$ = function (guildOrDmId, threadRoute, local) {
	switch (guildOrDmId.$) {
		case 0:
			if (!guildOrDmId.a.$) {
				var channelId = guildOrDmId.a.a.channelId;
				var guildId = guildOrDmId.a.a.guildId;
				return _Utils_update(
					local,
					{
						guilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							A2($author$project$LocalState$deleteMessageFrontend, channelId, threadRoute),
							local.guilds)
					});
			} else {
				var otherUserId = guildOrDmId.a.a.otherUserId;
				return _Utils_update(
					local,
					{
						dmChannels: $lamdera$containers$SeqDict$updateIfExists$(
							otherUserId,
							$author$project$LocalState$deleteMessageFrontendHelper(threadRoute),
							local.dmChannels)
					});
			}
		case 1:
			if (!guildOrDmId.a.$) {
				var channelId = guildOrDmId.a.a.channelId;
				var guildId = guildOrDmId.a.a.guildId;
				return _Utils_update(
					local,
					{
						discordGuilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							A2($author$project$LocalState$deleteMessageFrontend, channelId, threadRoute),
							local.discordGuilds)
					});
			} else {
				var data = guildOrDmId.a.a;
				if (!threadRoute.$) {
					var messageId = threadRoute.a;
					return _Utils_update(
						local,
						{
							discordDmChannels: $lamdera$containers$SeqDict$updateIfExists$(
								data.channelId,
								$author$project$LocalState$deleteMessageFrontendNoThread(messageId),
								local.discordDmChannels)
						});
				} else {
					return local;
				}
			}
		default:
			if (!guildOrDmId.a.$) {
				var channelId = guildOrDmId.a.a.channelId;
				var teamId = guildOrDmId.a.a.teamId;
				return _Utils_update(
					local,
					{
						slackWorkspaces: $lamdera$containers$SeqDict$updateIfExists$(
							teamId,
							A2(
								$author$project$LocalState$updateChannel,
								$author$project$LocalState$deleteMessageFrontendHelper(threadRoute),
								channelId),
							local.slackWorkspaces)
					});
			} else {
				var channelId = guildOrDmId.a.a.channelId;
				return _Utils_update(
					local,
					{
						slackDmChannels: $lamdera$containers$SeqDict$updateIfExists$(
							channelId,
							$author$project$LocalState$deleteMessageFrontendHelper(threadRoute),
							local.slackDmChannels)
					});
			}
	}
};
var $author$project$FrontendExtra$deleteMessage = F3($author$project$FrontendExtra$deleteMessage$);
var $author$project$LocalState$discordDmForgetEditTyping$ = function (editedBy, messageIndex, lastTypedAt) {
	var _v0 = $lamdera$containers$SeqDict$get$(editedBy, lastTypedAt);
	if (!_v0.$) {
		var typing = _v0.a;
		return _Utils_eq(
			typing.messageIndex,
			$elm$core$Maybe$Just(messageIndex)) ? $lamdera$containers$SeqDict$remove$(editedBy, lastTypedAt) : lastTypedAt;
	} else {
		return lastTypedAt;
	}
};
var $author$project$LocalState$discordDmForgetEditTyping = F3($author$project$LocalState$discordDmForgetEditTyping$);
var $author$project$LocalState$discordDmMemberIsTyping$ = function (userId, time, dmChannel) {
	return _Utils_update(
		dmChannel,
		{
			lastTypedAt: $lamdera$containers$SeqDict$insert$(
				userId,
				{messageIndex: $elm$core$Maybe$Nothing, time: time},
				dmChannel.lastTypedAt)
		});
};
var $author$project$LocalState$discordDmMemberIsTyping = F3($author$project$LocalState$discordDmMemberIsTyping$);
var $author$project$FrontendExtra$discordDmMemberTyping$ = function (time, userId, channelId, local) {
	return _Utils_update(
		local,
		{
			discordDmChannels: $lamdera$containers$SeqDict$updateIfExists$(
				channelId,
				A2($author$project$LocalState$discordDmMemberIsTyping, userId, time),
				local.discordDmChannels)
		});
};
var $author$project$FrontendExtra$discordDmMemberTyping = F4($author$project$FrontendExtra$discordDmMemberTyping$);
var $author$project$LinkedAndOtherDiscordUsers$discordCurrentUserToFrontend = function (user) {
	return {color: user.color, icon: user.icon, name: user.name};
};
var $author$project$LinkedAndOtherDiscordUsers$allDiscordUsers = function (_v0) {
	var otherUsers2 = _v0.a;
	var a = _v0.b;
	return $lamdera$containers$SeqDict$union$(
		$lamdera$containers$SeqDict$map$(
			F2(
				function (_v1, user) {
					return $author$project$LinkedAndOtherDiscordUsers$discordCurrentUserToFrontend(user);
				}),
			a),
		otherUsers2);
};
var $author$project$LocalState$callEndedText = 'Call ended';
var $author$project$LocalState$callStartedText = function (endedAt) {
	if (!endedAt.$) {
		return $author$project$LocalState$callEndedText;
	} else {
		return 'Call started';
	}
};
var $author$project$RichText$failedToDecryptMessageText = 'Failed to decrypt message';
var $author$project$LocalState$gameStartedText = function (game) {
	switch (game) {
		case 0:
			return 'Go match started';
		case 1:
			return 'Word Spelling Game started';
		default:
			return 'Sheep Game started';
	}
};
var $author$project$LocalState$messageDeleted = 'Message deleted';
var $author$project$RichText$attachedFilePrefix = '[!';
var $author$project$RichText$attachedFileSuffix = ']';
var $author$project$RichText$blockQuoteToString$ = function (hasLeadingLineBreak, inner) {
	return _Utils_ap(
		function () {
			if (hasLeadingLineBreak === 1) {
				return '';
			} else {
				return '\u000A';
			}
		}(),
		$elm$core$String$join$(
			'\u000A',
			$elm$core$List$map$(
				function (line) {
					return $elm$core$String$isEmpty(line) ? '> ' : ('> ' + line);
				},
				$elm$core$String$split$('\u000A', inner))));
};
var $author$project$RichText$blockQuoteToString = F2($author$project$RichText$blockQuoteToString$);
var $author$project$MyUi$monthToString = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $elm$time$Time$flooredDiv$ = function (numerator, denominator) {
	return $elm$core$Basics$floor(numerator / denominator);
};
var $elm$time$Time$flooredDiv = F2($elm$time$Time$flooredDiv$);
var $elm$time$Time$toAdjustedMinutesHelp$ = function (defaultOffset, posixMinutes, eras) {
	toAdjustedMinutesHelp:
	while (true) {
		if (!eras.b) {
			return posixMinutes + defaultOffset;
		} else {
			var era = eras.a;
			var olderEras = eras.b;
			if (_Utils_cmp(era.start, posixMinutes) < 0) {
				return posixMinutes + era.offset;
			} else {
				var $temp$eras = olderEras;
				eras = $temp$eras;
				continue toAdjustedMinutesHelp;
			}
		}
	}
};
var $elm$time$Time$toAdjustedMinutesHelp = F3($elm$time$Time$toAdjustedMinutesHelp$);
var $elm$time$Time$toAdjustedMinutes$ = function (_v0, time) {
	var defaultOffset = _v0.a;
	var eras = _v0.b;
	return $elm$time$Time$toAdjustedMinutesHelp$(
		defaultOffset,
		$elm$time$Time$flooredDiv$(
			$elm$time$Time$posixToMillis(time),
			60000),
		eras);
};
var $elm$time$Time$toAdjustedMinutes = F2($elm$time$Time$toAdjustedMinutes$);
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = $elm$time$Time$flooredDiv$(minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		day: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		month: month,
		year: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay$ = function (zone, time) {
	return $elm$time$Time$toCivil(
		$elm$time$Time$toAdjustedMinutes$(zone, time)).day;
};
var $elm$time$Time$toDay = F2($elm$time$Time$toDay$);
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $elm$time$Time$toMonth$ = function (zone, time) {
	var _v0 = $elm$time$Time$toCivil(
		$elm$time$Time$toAdjustedMinutes$(zone, time)).month;
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $elm$time$Time$toMonth = F2($elm$time$Time$toMonth$);
var $elm$time$Time$toYear$ = function (zone, time) {
	return $elm$time$Time$toCivil(
		$elm$time$Time$toAdjustedMinutes$(zone, time)).year;
};
var $elm$time$Time$toYear = F2($elm$time$Time$toYear$);
var $author$project$MyUi$datestamp$ = function (timezone, time) {
	return $author$project$MyUi$monthToString(
		$elm$time$Time$toMonth$(timezone, time)) + (' ' + ($elm$core$String$fromInt(
		$elm$time$Time$toDay$(timezone, time)) + (', ' + $elm$core$String$fromInt(
		$elm$time$Time$toYear$(timezone, time)))));
};
var $author$project$MyUi$datestamp = F2($author$project$MyUi$datestamp$);
var $elm$time$Time$toHour$ = function (zone, time) {
	return A2(
		$elm$core$Basics$modBy,
		24,
		$elm$time$Time$flooredDiv$(
			$elm$time$Time$toAdjustedMinutes$(zone, time),
			60));
};
var $elm$time$Time$toHour = F2($elm$time$Time$toHour$);
var $elm$time$Time$toMinute$ = function (zone, time) {
	return A2(
		$elm$core$Basics$modBy,
		60,
		$elm$time$Time$toAdjustedMinutes$(zone, time));
};
var $elm$time$Time$toMinute = F2($elm$time$Time$toMinute$);
var $author$project$MyUi$timestamp$ = function (time, zone) {
	return $elm$core$String$padLeft$(
		2,
		'0',
		$elm$core$String$fromInt(
			$elm$time$Time$toHour$(zone, time))) + (':' + $elm$core$String$padLeft$(
		2,
		'0',
		$elm$core$String$fromInt(
			$elm$time$Time$toMinute$(zone, time))));
};
var $author$project$MyUi$timestamp = F2($author$project$MyUi$timestamp$);
var $author$project$TimeInMinutes$toTime = function (_v0) {
	var _int = _v0;
	return $lamdera$program_test$Effect$Time$millisToPosix((_int * 60) * 1000);
};
var $author$project$RichText$dateAndTimeToString$ = function (timezone, time) {
	var time2 = $author$project$TimeInMinutes$toTime(time);
	return $author$project$MyUi$datestamp$(timezone, time2) + (' at ' + $author$project$MyUi$timestamp$(time2, timezone));
};
var $author$project$RichText$dateAndTimeToString = F2($author$project$RichText$dateAndTimeToString$);
var $author$project$RichText$escapedCharToString = function (escaped) {
	switch (escaped) {
		case 0:
			return '[';
		case 1:
			return '\u005C';
		case 2:
			return '`';
		case 3:
			return '@';
		case 4:
			return '*';
		case 5:
			return '_';
		case 6:
			return '~';
		default:
			return '|';
	}
};
var $author$project$RichText$headingLevelToMarker = function (level) {
	switch (level) {
		case 0:
			return '# ';
		case 1:
			return '## ';
		case 2:
			return '### ';
		default:
			return '-# ';
	}
};
var $author$project$RichText$headingToString$ = function (hasLeadingLineBreak, level, inner) {
	return _Utils_ap(
		function () {
			if (hasLeadingLineBreak === 1) {
				return '';
			} else {
				return '\u000A';
			}
		}(),
		_Utils_ap(
			$author$project$RichText$headingLevelToMarker(level),
			inner));
};
var $author$project$RichText$headingToString = F3($author$project$RichText$headingToString$);
var $author$project$Sticker$toBase4Helper = function (_int) {
	switch (_int) {
		case 0:
			return '\u200B';
		case 1:
			return '\u200C';
		case 2:
			return '\u200D';
		default:
			return '\u2060';
	}
};
var $author$project$Sticker$toBase4 = function (n) {
	return (n < 0) ? ('-' + $author$project$Sticker$toBase4(
		$elm$core$Basics$abs(n))) : ((n < 4) ? $author$project$Sticker$toBase4Helper(n) : _Utils_ap(
		$author$project$Sticker$toBase4((n / 4) | 0),
		$author$project$Sticker$toBase4Helper(n % 4)));
};
var $author$project$CustomEmoji$idToString = function (id) {
	return '❓' + ($author$project$Sticker$toBase4(
		$author$project$Id$toInt(id)) + '\uFEFF');
};
var $author$project$Sticker$idToString = function (id) {
	return '\u000A' + ($author$project$Sticker$toBase4(
		$author$project$Id$toInt(id)) + '\u000A\u000A');
};
var $author$project$RichText$toStringHelper$ = function (timezone, userToString, emojisForStickersAndAttachments, users, channels, list) {
	return $elm$core$String$concat(
		$elm$core$List$map$(
			function (richText) {
				switch (richText.$) {
					case 2:
						var _char = richText.a;
						var rest = richText.b;
						return A2($elm$core$String$cons, _char, rest);
					case 0:
						var userId = richText.a;
						var _v1 = $lamdera$containers$SeqDict$get$(userId, users);
						if (!_v1.$) {
							var user = _v1.a;
							return '@' + userToString(user);
						} else {
							return '@<missing>';
						}
					case 1:
						var channel = richText.a;
						var maybeThread = richText.b;
						var _v2 = $lamdera$containers$SeqDict$get$(
							_Utils_Tuple2(channel, maybeThread),
							channels);
						if (!_v2.$) {
							var name = _v2.a.name;
							return '#' + name;
						} else {
							return '#<missing>';
						}
					case 3:
						var a = richText.a;
						return '*' + ($author$project$RichText$toStringHelper$(
							timezone,
							userToString,
							emojisForStickersAndAttachments,
							users,
							channels,
							$mgold$elm_nonempty_list$List$Nonempty$toList(a)) + '*');
					case 4:
						var a = richText.a;
						return '_' + ($author$project$RichText$toStringHelper$(
							timezone,
							userToString,
							emojisForStickersAndAttachments,
							users,
							channels,
							$mgold$elm_nonempty_list$List$Nonempty$toList(a)) + '_');
					case 5:
						var a = richText.a;
						return '__' + ($author$project$RichText$toStringHelper$(
							timezone,
							userToString,
							emojisForStickersAndAttachments,
							users,
							channels,
							$mgold$elm_nonempty_list$List$Nonempty$toList(a)) + '__');
					case 6:
						var a = richText.a;
						return '~~' + ($author$project$RichText$toStringHelper$(
							timezone,
							userToString,
							emojisForStickersAndAttachments,
							users,
							channels,
							$mgold$elm_nonempty_list$List$Nonempty$toList(a)) + '~~');
					case 7:
						var a = richText.a;
						return '||' + ($author$project$RichText$toStringHelper$(
							timezone,
							userToString,
							emojisForStickersAndAttachments,
							users,
							channels,
							$mgold$elm_nonempty_list$List$Nonempty$toList(a)) + '||');
					case 8:
						var hasLeadingLineBreak = richText.a;
						var a = richText.b;
						return $author$project$RichText$blockQuoteToString$(
							hasLeadingLineBreak,
							$author$project$RichText$toStringHelper$(timezone, userToString, emojisForStickersAndAttachments, users, channels, a));
					case 9:
						var level = richText.a;
						var hasLeadingLineBreak = richText.b;
						var a = richText.c;
						return $author$project$RichText$headingToString$(
							hasLeadingLineBreak,
							level,
							$author$project$RichText$toStringHelper$(
								timezone,
								userToString,
								emojisForStickersAndAttachments,
								users,
								channels,
								$mgold$elm_nonempty_list$List$Nonempty$toList(a)));
					case 10:
						var data = richText.a;
						return $elm$url$Url$toString(data);
					case 11:
						var alias = richText.a;
						var url = richText.b;
						return '[' + ($MartinSStewart$elm_nonempty_string$String$Nonempty$toString(alias) + ('](' + ($elm$url$Url$toString(url) + ')')));
					case 12:
						var _char = richText.a;
						var rest = richText.b;
						return '`' + (A2($elm$core$String$cons, _char, rest) + '`');
					case 13:
						var language = richText.a;
						var string = richText.b;
						return '```' + (function () {
							if (!language.$) {
								var unknown = language.a;
								return $MartinSStewart$elm_nonempty_string$String$Nonempty$toString(unknown) + '\u000A';
							} else {
								return '';
							}
						}() + (string + '```'));
					case 14:
						var fileId = richText.a;
						return emojisForStickersAndAttachments ? '🖼️' : _Utils_ap(
							$author$project$RichText$attachedFilePrefix,
							_Utils_ap(
								$author$project$Id$toString(fileId),
								$author$project$RichText$attachedFileSuffix));
					case 15:
						var _char = richText.a;
						return '\u005C' + $author$project$RichText$escapedCharToString(_char);
					case 16:
						var id = richText.a;
						return emojisForStickersAndAttachments ? '🖼️' : $author$project$Sticker$idToString(id);
					case 17:
						var id = richText.a;
						return $author$project$CustomEmoji$idToString(id);
					case 18:
						var hasLeadingLineBreak = richText.a;
						var items = richText.b;
						return _Utils_ap(
							function () {
								if (hasLeadingLineBreak === 1) {
									return '';
								} else {
									return '\u000A';
								}
							}(),
							$elm$core$String$join$(
								'\u000A',
								$elm$core$List$map$(
									function (item) {
										return '* ' + $author$project$RichText$toStringHelper$(timezone, userToString, emojisForStickersAndAttachments, users, channels, item);
									},
									$mgold$elm_nonempty_list$List$Nonempty$toList(items))));
					default:
						var time = richText.a;
						return $author$project$RichText$dateAndTimeToString$(timezone, time);
				}
			},
			list));
};
var $author$project$RichText$toStringHelper = F6($author$project$RichText$toStringHelper$);
var $author$project$RichText$toString$ = function (timezone, emojisForStickersAndAttachments, users, channels, nonempty) {
	return $author$project$RichText$toStringHelper$(
		timezone,
		function (user) {
			return $author$project$PersonName$toString(user.name);
		},
		emojisForStickersAndAttachments,
		users,
		channels,
		$mgold$elm_nonempty_list$List$Nonempty$toList(nonempty));
};
var $author$project$RichText$toString = F5($author$project$RichText$toString$);
var $author$project$User$missingName = '<missing>';
var $author$project$User$toString$ = function (userId, allUsers2) {
	var _v0 = $lamdera$containers$SeqDict$get$(userId, allUsers2);
	if (!_v0.$) {
		var user = _v0.a;
		return $author$project$PersonName$toString(user.name);
	} else {
		return $author$project$User$missingName;
	}
};
var $author$project$User$toString = F2($author$project$User$toString$);
var $author$project$LocalState$messageToString$ = function (timezone, allUsers3, channels, decrypted, message) {
	switch (message.$) {
		case 0:
			var a = message.a;
			return $author$project$RichText$toString$(timezone, false, allUsers3, channels, a.content.content);
		case 1:
			var a = message.a;
			var _v1 = $lamdera$containers$SeqDict$get$(
				$author$project$Encryption$hash(a.content),
				decrypted);
			if (!_v1.$) {
				var result = _v1.a;
				if (!result.$) {
					var ok = result.a;
					return $author$project$RichText$toString$(timezone, false, allUsers3, channels, ok.content);
				} else {
					return $author$project$RichText$failedToDecryptMessageText;
				}
			} else {
				return '';
			}
		case 2:
			var userId = message.b;
			return $author$project$User$toString$(userId, allUsers3) + ' joined!';
		case 3:
			return $author$project$LocalState$messageDeleted;
		case 4:
			var callStarted = message.a;
			return $author$project$LocalState$callStartedText(callStarted.endedAt);
		default:
			var gameStarted = message.a;
			return $author$project$LocalState$gameStartedText(gameStarted.gameType);
	}
};
var $author$project$LocalState$messageToString = F5($author$project$LocalState$messageToString$);
var $author$project$ChannelName$toString = function (_v0) {
	var a = _v0;
	return $MartinSStewart$elm_nonempty_string$String$Nonempty$toString(a);
};
var $author$project$LocalState$threadName$ = function (channelName, threadMessage) {
	return $author$project$ChannelName$toString(channelName) + ('/' + $elm$core$String$left$(50, threadMessage));
};
var $author$project$LocalState$threadName = F2($author$project$LocalState$threadName$);
var $author$project$LocalState$discordThreadMentionName$ = function (threadId, channel, localUser) {
	return $author$project$LocalState$threadName$(
		channel.name,
		function () {
			var _v0 = $author$project$MessageArray$get$(threadId, channel.messages);
			if (!_v0.$) {
				var message = _v0.a;
				return $author$project$LocalState$messageToString$(
					localUser.timezone,
					$author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(localUser.discordUsers),
					$lamdera$containers$SeqDict$empty,
					$lamdera$containers$SeqDict$empty,
					message);
			} else {
				return '<missing>';
			}
		}());
};
var $author$project$LocalState$discordThreadMentionName = F3($author$project$LocalState$discordThreadMentionName$);
var $author$project$LocalState$discordGuildChannelMentions$ = function (localUser, channels) {
	return $lamdera$containers$SeqDict$foldl$(
		F3(
			function (channelId, channel, dict) {
				return $lamdera$containers$SeqDict$foldl$(
					F3(
						function (threadId, _v0, dict2) {
							return $lamdera$containers$SeqDict$insert$(
								_Utils_Tuple2(
									channelId,
									$elm$core$Maybe$Just(threadId)),
								{
									name: $author$project$LocalState$discordThreadMentionName$(threadId, channel, localUser)
								},
								dict2);
						}),
					$lamdera$containers$SeqDict$insert$(
						_Utils_Tuple2(channelId, $elm$core$Maybe$Nothing),
						{
							name: $author$project$ChannelName$toString(channel.name)
						},
						dict),
					channel.threads);
			}),
		$lamdera$containers$SeqDict$empty,
		channels);
};
var $author$project$LocalState$discordGuildChannelMentions = F2($author$project$LocalState$discordGuildChannelMentions$);
var $author$project$Id$threadRouteWithNoMessage = function (threadRoute) {
	if (threadRoute.$ === 1) {
		var threadId = threadRoute.a;
		return $author$project$Id$ViewThreadWithMaybeMessage$(threadId, $elm$core$Maybe$Nothing);
	} else {
		return $author$project$Id$NoThreadWithMaybeMessage($elm$core$Maybe$Nothing);
	}
};
var $author$project$LocalState$memberIsTyping$ = function (userId, time, channelId, threadRoute, guild) {
	return _Utils_update(
		guild,
		{
			lastTypedAt: $lamdera$containers$SeqDict$insert$(
				userId,
				{
					channelId: channelId,
					threadRoute: $author$project$Id$threadRouteWithNoMessage(threadRoute),
					time: time
				},
				guild.lastTypedAt)
		});
};
var $author$project$LocalState$memberIsTyping = F5($author$project$LocalState$memberIsTyping$);
var $author$project$FrontendExtra$discordGuildMemberTyping$ = function (time, userId, guildId, channelId, threadRoute, local) {
	return _Utils_update(
		local,
		{
			discordGuilds: $lamdera$containers$SeqDict$updateIfExists$(
				guildId,
				A4($author$project$LocalState$memberIsTyping, userId, time, channelId, threadRoute),
				local.discordGuilds)
		});
};
var $author$project$FrontendExtra$discordGuildMemberTyping = F6($author$project$FrontendExtra$discordGuildMemberTyping$);
var $author$project$Message$maxEmbeds = 10;
var $author$project$Message$userTextMessageFrontend$ = function (createdAt2, createdBy, content, repliedTo2, attachedFiles) {
	var hyperlinks = $elm$core$List$take$(
		$author$project$Message$maxEmbeds,
		$author$project$RichText$hyperlinks(content));
	return $author$project$Message$UserTextMessage(
		{
			content: {
				attachedFiles: attachedFiles,
				content: content,
				embeds: $elm$core$Array$initialize$(
					$elm$core$List$length(hyperlinks),
					function (_v0) {
						return $author$project$Embed$EmbedLoading;
					})
			},
			createdAt: createdAt2,
			createdBy: createdBy,
			drawings: $elm$core$Maybe$Nothing,
			editedAt: $elm$core$Maybe$Nothing,
			reactions: $lamdera$containers$SeqDict$empty,
			repliedTo: repliedTo2
		});
};
var $author$project$Message$userTextMessageFrontend = F5($author$project$Message$userTextMessageFrontend$);
var $author$project$FrontendExtra$discordGuildSendMessage$ = function (guildId, guild, channelId, channel, threadRouteWithRepliedTo, createdAt, discordUserId, text, attachedFiles, local) {
	return $lamdera$containers$SeqDict$insert$(
		guildId,
		_Utils_update(
			guild,
			{
				channels: $lamdera$containers$SeqDict$insert$(
					channelId,
					function () {
						if (threadRouteWithRepliedTo.$ === 1) {
							var threadId = threadRouteWithRepliedTo.a;
							var maybeReplyTo = threadRouteWithRepliedTo.b;
							return $author$project$LocalState$createThreadMessageFrontend$(
								threadId,
								$author$project$Message$userTextMessageFrontend$(
									createdAt,
									discordUserId,
									text,
									$author$project$Message$maybeToReply(maybeReplyTo),
									attachedFiles),
								channel);
						} else {
							var maybeReplyTo = threadRouteWithRepliedTo.a;
							return $author$project$LocalState$createChannelMessageFrontend$(
								$author$project$Message$userTextMessageFrontend$(
									createdAt,
									discordUserId,
									text,
									$author$project$Message$maybeToReply(maybeReplyTo),
									attachedFiles),
								channel);
						}
					}(),
					guild.channels),
				lastTypedAt: $lamdera$containers$SeqDict$remove$(discordUserId, guild.lastTypedAt)
			}),
		local.discordGuilds);
};
var $author$project$FrontendExtra$discordGuildSendMessage = function (guildId) {
	return function (guild) {
		return function (channelId) {
			return function (channel) {
				return function (threadRouteWithRepliedTo) {
					return function (createdAt) {
						return function (discordUserId) {
							return function (text) {
								return function (attachedFiles) {
									return function (local) {
										return $author$project$FrontendExtra$discordGuildSendMessage$(guildId, guild, channelId, channel, threadRouteWithRepliedTo, createdAt, discordUserId, text, attachedFiles, local);
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$ChannelDescription$maxLength = 500;
var $author$project$ChannelDescription$fromStringLossy = function (text) {
	return $elm$core$String$left$($author$project$ChannelDescription$maxLength, text);
};
var $author$project$LocalState$discordTopicToDescription$ = function (topic, existingDescription) {
	if (!topic.$) {
		if (!topic.a.$) {
			var topic2 = topic.a.a;
			return $author$project$ChannelDescription$fromStringLossy(topic2);
		} else {
			var _v1 = topic.a;
			return $author$project$ChannelDescription$empty;
		}
	} else {
		return existingDescription;
	}
};
var $author$project$LocalState$discordTopicToDescription = F2($author$project$LocalState$discordTopicToDescription$);
var $author$project$UserSession$FilledInByBackend = function (a) {
	return {$: 1, a: a};
};
var $author$project$FrontendExtra$discordViewMessages = function (backendData) {
	if (backendData.$ === 1) {
		var data = backendData.a;
		return $author$project$UserSession$FilledInByBackend(data.messages);
	} else {
		return $author$project$UserSession$EmptyPlaceholder;
	}
};
var $author$project$Id$threadRouteWithJustMessage = function (threadRoute) {
	if (threadRoute.$ === 1) {
		var threadId = threadRoute.a;
		var messageId = threadRoute.b;
		return $author$project$Id$ViewThreadWithMaybeMessage$(
			threadId,
			$elm$core$Maybe$Just(messageId));
	} else {
		var messageId = threadRoute.a;
		return $author$project$Id$NoThreadWithMaybeMessage(
			$elm$core$Maybe$Just(messageId));
	}
};
var $author$project$LocalState$dmForgetEditTyping$ = function (editedBy, threadRoute, lastTypedAt) {
	var _v0 = $lamdera$containers$SeqDict$get$(editedBy, lastTypedAt);
	if (!_v0.$) {
		var typing = _v0.a;
		return _Utils_eq(
			typing.threadRoute,
			$author$project$Id$threadRouteWithJustMessage(threadRoute)) ? $lamdera$containers$SeqDict$remove$(editedBy, lastTypedAt) : lastTypedAt;
	} else {
		return lastTypedAt;
	}
};
var $author$project$LocalState$dmForgetEditTyping = F3($author$project$LocalState$dmForgetEditTyping$);
var $mgold$elm_nonempty_list$List$Nonempty$append$ = function (_v0, _v1) {
	var x = _v0.a;
	var xs = _v0.b;
	var y = _v1.a;
	var ys = _v1.b;
	return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
		x,
		_Utils_ap(
			xs,
			A2($elm$core$List$cons, y, ys)));
};
var $mgold$elm_nonempty_list$List$Nonempty$append = F2($mgold$elm_nonempty_list$List$Nonempty$append$);
var $author$project$Drawing$maxFinishedStrokes = 200;
var $author$project$Drawing$maxPointsPerStroke = 4000;
var $author$project$Drawing$nonemptyTake$ = function (amount, _v0) {
	var head = _v0.a;
	var rest = _v0.b;
	return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
		head,
		$elm$core$List$take$(amount - 1, rest));
};
var $author$project$Drawing$nonemptyTake = F2($author$project$Drawing$nonemptyTake$);
var $elmcraft$core_extra$List$Extra$findIndexHelp$ = function (index, predicate, list) {
	findIndexHelp:
	while (true) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var x = list.a;
			var xs = list.b;
			if (predicate(x)) {
				return $elm$core$Maybe$Just(index);
			} else {
				var $temp$index = index + 1,
					$temp$list = xs;
				index = $temp$index;
				list = $temp$list;
				continue findIndexHelp;
			}
		}
	}
};
var $elmcraft$core_extra$List$Extra$findIndexHelp = F3($elmcraft$core_extra$List$Extra$findIndexHelp$);
var $elmcraft$core_extra$List$Extra$findIndex = $elmcraft$core_extra$List$Extra$findIndexHelp(0);
var $elmcraft$core_extra$List$Extra$splitAt$ = function (n, xs) {
	return _Utils_Tuple2(
		$elm$core$List$take$(n, xs),
		$elm$core$List$drop$(n, xs));
};
var $elmcraft$core_extra$List$Extra$splitAt = F2($elmcraft$core_extra$List$Extra$splitAt$);
var $elmcraft$core_extra$List$Extra$splitWhen$ = function (predicate, list) {
	return $elm$core$Maybe$map$(
		function (i) {
			return $elmcraft$core_extra$List$Extra$splitAt$(i, list);
		},
		A2($elmcraft$core_extra$List$Extra$findIndex, predicate, list));
};
var $elmcraft$core_extra$List$Extra$splitWhen = F2($elmcraft$core_extra$List$Extra$splitWhen$);
var $author$project$Drawing$handleLocalChange$ = function (userId, change, drawing) {
	switch (change.$) {
		case 0:
			var point = change.a;
			return _Utils_update(
				drawing,
				{
					inProgress: $lamdera$containers$SeqDict$insert$(
						userId,
						{
							points: $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(point, _List_Nil)
						},
						drawing.inProgress),
					undone: $lamdera$containers$SeqDict$remove$(userId, drawing.undone)
				});
		case 1:
			var points = change.a;
			var _v1 = $lamdera$containers$SeqDict$get$(userId, drawing.inProgress);
			if (!_v1.$) {
				var stroke = _v1.a;
				return _Utils_update(
					drawing,
					{
						inProgress: $lamdera$containers$SeqDict$insert$(
							userId,
							_Utils_update(
								stroke,
								{
									points: $author$project$Drawing$nonemptyTake$(
										$author$project$Drawing$maxPointsPerStroke,
										$mgold$elm_nonempty_list$List$Nonempty$append$(stroke.points, points))
								}),
							drawing.inProgress)
					});
			} else {
				return drawing;
			}
		case 2:
			var remainingPoints = change.a;
			var _v2 = $lamdera$containers$SeqDict$get$(userId, drawing.inProgress);
			if (!_v2.$) {
				var stroke = _v2.a;
				return _Utils_update(
					drawing,
					{
						finished: $elm$core$List$take$(
							$author$project$Drawing$maxFinishedStrokes,
							A2(
								$elm$core$List$cons,
								{
									createdBy: userId,
									points: function () {
										var _v3 = $mgold$elm_nonempty_list$List$Nonempty$fromList(remainingPoints);
										if (!_v3.$) {
											var remaining = _v3.a;
											return $author$project$Drawing$nonemptyTake$(
												$author$project$Drawing$maxPointsPerStroke,
												$mgold$elm_nonempty_list$List$Nonempty$append$(stroke.points, remaining));
										} else {
											return stroke.points;
										}
									}()
								},
								drawing.finished)),
						inProgress: $lamdera$containers$SeqDict$remove$(userId, drawing.inProgress)
					});
			} else {
				return drawing;
			}
		case 3:
			var _v4 = $elmcraft$core_extra$List$Extra$splitWhen$(
				function (finished) {
					return _Utils_eq(finished.createdBy, userId);
				},
				drawing.finished);
			if ((!_v4.$) && _v4.a.b.b) {
				var _v5 = _v4.a;
				var before = _v5.a;
				var _v6 = _v5.b;
				var undoneStroke = _v6.a;
				var after = _v6.b;
				return _Utils_update(
					drawing,
					{
						finished: _Utils_ap(before, after),
						undone: $lamdera$containers$SeqDict$update$(
							userId,
							function (maybe) {
								return $elm$core$Maybe$Just(
									A2(
										$elm$core$List$cons,
										{points: undoneStroke.points},
										$elm$core$Maybe$withDefault$(_List_Nil, maybe)));
							},
							drawing.undone)
					});
			} else {
				return drawing;
			}
		default:
			var _v7 = $lamdera$containers$SeqDict$get$(userId, drawing.undone);
			if ((!_v7.$) && _v7.a.b) {
				var _v8 = _v7.a;
				var stroke = _v8.a;
				var rest = _v8.b;
				return _Utils_update(
					drawing,
					{
						finished: A2(
							$elm$core$List$cons,
							{createdBy: userId, points: stroke.points},
							drawing.finished),
						undone: $lamdera$containers$SeqDict$insert$(userId, rest, drawing.undone)
					});
			} else {
				return drawing;
			}
	}
};
var $author$project$Drawing$handleLocalChange = F3($author$project$Drawing$handleLocalChange$);
var $author$project$Message$noDrawings = {embedDrawings: $lamdera$containers$SeqDict$empty, imageAttachmentDrawings: $lamdera$containers$SeqDict$empty, timestampDrawings: $author$project$Drawing$emptyDrawing, userIconDrawings: $author$project$Drawing$emptyDrawing};
var $author$project$Message$handleDrawingChangeHelper$ = function (changeBy, change, anchorType, data) {
	switch (anchorType.$) {
		case 0:
			var data2 = $elm$core$Maybe$withDefault$($author$project$Message$noDrawings, data);
			return $elm$core$Maybe$Just(
				_Utils_update(
					data2,
					{
						userIconDrawings: $author$project$Drawing$handleLocalChange$(changeBy, change, data2.userIconDrawings)
					}));
		case 1:
			var data2 = $elm$core$Maybe$withDefault$($author$project$Message$noDrawings, data);
			return $elm$core$Maybe$Just(
				_Utils_update(
					data2,
					{
						timestampDrawings: $author$project$Drawing$handleLocalChange$(changeBy, change, data2.timestampDrawings)
					}));
		case 2:
			var fileId = anchorType.a;
			var data2 = $elm$core$Maybe$withDefault$($author$project$Message$noDrawings, data);
			return $elm$core$Maybe$Just(
				_Utils_update(
					data2,
					{
						imageAttachmentDrawings: $lamdera$containers$SeqDict$update$(
							fileId,
							function (maybe) {
								return $elm$core$Maybe$Just(
									$author$project$Drawing$handleLocalChange$(
										changeBy,
										change,
										$elm$core$Maybe$withDefault$($author$project$Drawing$emptyDrawing, maybe)));
							},
							data2.imageAttachmentDrawings)
					}));
		case 3:
			var embedIndex = anchorType.a;
			var data2 = $elm$core$Maybe$withDefault$($author$project$Message$noDrawings, data);
			return $elm$core$Maybe$Just(
				_Utils_update(
					data2,
					{
						embedDrawings: $lamdera$containers$SeqDict$update$(
							embedIndex,
							function (maybe) {
								return $elm$core$Maybe$Just(
									$author$project$Drawing$handleLocalChange$(
										changeBy,
										change,
										$elm$core$Maybe$withDefault$($author$project$Drawing$emptyDrawing, maybe)));
							},
							data2.embedDrawings)
					}));
		default:
			return data;
	}
};
var $author$project$Message$handleDrawingChangeHelper = F4($author$project$Message$handleDrawingChangeHelper$);
var $author$project$Message$handleDrawingChange$ = function (changeBy, anchorType, change, message) {
	switch (message.$) {
		case 0:
			var data = message.a;
			return $author$project$Message$UserTextMessage(
				_Utils_update(
					data,
					{
						drawings: $author$project$Message$handleDrawingChangeHelper$(changeBy, change, anchorType, data.drawings)
					}));
		case 1:
			var data = message.a;
			return $author$project$Message$EncryptedUserTextMessage(
				_Utils_update(
					data,
					{
						drawings: $author$project$Message$handleDrawingChangeHelper$(changeBy, change, anchorType, data.drawings)
					}));
		case 2:
			var time = message.a;
			var userId = message.b;
			var reactions = message.c;
			var drawings = message.d;
			return $author$project$Message$UserJoinedMessage$(time, userId, reactions, drawings);
		case 3:
			return message;
		case 4:
			var callStarted = message.a;
			switch (anchorType.$) {
				case 1:
					return $author$project$Message$CallStarted(
						_Utils_update(
							callStarted,
							{
								timestampDrawings: $author$project$Drawing$handleLocalChange$(changeBy, change, callStarted.timestampDrawings)
							}));
				case 0:
					return message;
				case 2:
					return message;
				case 3:
					return message;
				default:
					return $author$project$Message$CallStarted(
						_Utils_update(
							callStarted,
							{
								cardDrawings: $author$project$Drawing$handleLocalChange$(changeBy, change, callStarted.cardDrawings)
							}));
			}
		default:
			var gameStarted = message.a;
			switch (anchorType.$) {
				case 1:
					return $author$project$Message$GameStarted(
						_Utils_update(
							gameStarted,
							{
								timestampDrawings: $author$project$Drawing$handleLocalChange$(changeBy, change, gameStarted.timestampDrawings)
							}));
				case 0:
					return message;
				case 2:
					return message;
				case 3:
					return message;
				default:
					return $author$project$Message$GameStarted(
						_Utils_update(
							gameStarted,
							{
								cardDrawings: $author$project$Drawing$handleLocalChange$(changeBy, change, gameStarted.cardDrawings)
							}));
			}
	}
};
var $author$project$Message$handleDrawingChange = F4($author$project$Message$handleDrawingChange$);
var $author$project$LocalState$drawingHandleChangeNoThreadFrontend$ = function (changedBy, anchor, change, messageId, channel) {
	return _Utils_update(
		channel,
		{
			messages: $author$project$MessageArray$updateIfExists$(
				messageId,
				A3($author$project$Message$handleDrawingChange, changedBy, anchor, change),
				channel.messages)
		});
};
var $author$project$LocalState$drawingHandleChangeNoThreadFrontend = F5($author$project$LocalState$drawingHandleChangeNoThreadFrontend$);
var $author$project$LocalState$drawingHandleChangeHelperFrontend$ = function (changeBy, anchor, change, threadRoute, channel) {
	if (!threadRoute.$) {
		var messageId = threadRoute.a;
		return $author$project$LocalState$drawingHandleChangeNoThreadFrontend$(changeBy, anchor, change, messageId, channel);
	} else {
		var threadId = threadRoute.a;
		var messageId = threadRoute.b;
		return _Utils_update(
			channel,
			{
				threads: $lamdera$containers$SeqDict$updateIfExists$(
					threadId,
					A4($author$project$LocalState$drawingHandleChangeNoThreadFrontend, changeBy, anchor, change, messageId),
					channel.threads)
			});
	}
};
var $author$project$LocalState$drawingHandleChangeHelperFrontend = F5($author$project$LocalState$drawingHandleChangeHelperFrontend$);
var $author$project$SeqDictHelper$updateOrInsert$ = function (a, updateOrInsertFunc, dict) {
	return $lamdera$containers$SeqDict$update$(
		a,
		function (maybe) {
			return $elm$core$Maybe$Just(
				updateOrInsertFunc(maybe));
		},
		dict);
};
var $author$project$SeqDictHelper$updateOrInsert = F3($author$project$SeqDictHelper$updateOrInsert$);
var $author$project$LocalState$drawingHandleDateDivider$ = function (threadRoute, date, changedBy, change, channel) {
	if (!threadRoute.$) {
		return _Utils_update(
			channel,
			{
				dateDividerDrawings: $author$project$SeqDictHelper$updateOrInsert$(
					date,
					function (maybe) {
						return $author$project$Drawing$handleLocalChange$(
							changedBy,
							change,
							$elm$core$Maybe$withDefault$($author$project$Drawing$emptyDrawing, maybe));
					},
					channel.dateDividerDrawings)
			});
	} else {
		var threadId = threadRoute.a;
		return _Utils_update(
			channel,
			{
				threads: $lamdera$containers$SeqDict$updateIfExists$(
					threadId,
					function (thread) {
						return _Utils_update(
							thread,
							{
								dateDividerDrawings: $author$project$SeqDictHelper$updateOrInsert$(
									date,
									function (maybe) {
										return $author$project$Drawing$handleLocalChange$(
											changedBy,
											change,
											$elm$core$Maybe$withDefault$($author$project$Drawing$emptyDrawing, maybe));
									},
									thread.dateDividerDrawings)
							});
					},
					channel.threads)
			});
	}
};
var $author$project$LocalState$drawingHandleDateDivider = F5($author$project$LocalState$drawingHandleDateDivider$);
var $author$project$LocalState$drawingHandleChangeFrontend$ = function (guildOrDmId, anchor, changedBy, change, local) {
	switch (guildOrDmId.$) {
		case 0:
			if (!guildOrDmId.a.$) {
				var channelId = guildOrDmId.a.a.channelId;
				var guildId = guildOrDmId.a.a.guildId;
				return _Utils_update(
					local,
					{
						guilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							A2(
								$author$project$LocalState$updateChannel,
								function (channel) {
									if (!anchor.$) {
										var threadRoute = anchor.a;
										var anchor2 = anchor.b;
										if (!threadRoute.$) {
											var messageId = threadRoute.a;
											return $author$project$LocalState$drawingHandleChangeNoThreadFrontend$(changedBy, anchor2, change, messageId, channel);
										} else {
											var threadId = threadRoute.a;
											var messageId = threadRoute.b;
											return _Utils_update(
												channel,
												{
													threads: $lamdera$containers$SeqDict$updateIfExists$(
														threadId,
														A4($author$project$LocalState$drawingHandleChangeNoThreadFrontend, changedBy, anchor2, change, messageId),
														channel.threads)
												});
										}
									} else {
										var threadRoute = anchor.a;
										var date = anchor.b;
										return $author$project$LocalState$drawingHandleDateDivider$(threadRoute, date, changedBy, change, channel);
									}
								},
								channelId),
							local.guilds)
					});
			} else {
				var otherUserId = guildOrDmId.a.a.otherUserId;
				return _Utils_update(
					local,
					{
						dmChannels: $lamdera$containers$SeqDict$updateIfExists$(
							otherUserId,
							function (dmChannel) {
								if (!anchor.$) {
									var threadRoute = anchor.a;
									var anchor2 = anchor.b;
									return $author$project$LocalState$drawingHandleChangeHelperFrontend$(changedBy, anchor2, change, threadRoute, dmChannel);
								} else {
									var threadRoute = anchor.a;
									var date = anchor.b;
									return $author$project$LocalState$drawingHandleDateDivider$(threadRoute, date, changedBy, change, dmChannel);
								}
							},
							local.dmChannels)
					});
			}
		case 1:
			if (!guildOrDmId.a.$) {
				var channelId = guildOrDmId.a.a.channelId;
				var guildId = guildOrDmId.a.a.guildId;
				var currentUserId = guildOrDmId.a.a.currentUserId;
				return _Utils_update(
					local,
					{
						discordGuilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							A2(
								$author$project$LocalState$updateChannel,
								function (channel) {
									if (!anchor.$) {
										var threadRoute = anchor.a;
										var anchor2 = anchor.b;
										return $author$project$LocalState$drawingHandleChangeHelperFrontend$(currentUserId, anchor2, change, threadRoute, channel);
									} else {
										var threadRoute = anchor.a;
										var date = anchor.b;
										return $author$project$LocalState$drawingHandleDateDivider$(threadRoute, date, currentUserId, change, channel);
									}
								},
								channelId),
							local.discordGuilds)
					});
			} else {
				var data = guildOrDmId.a.a;
				return _Utils_update(
					local,
					{
						discordDmChannels: $lamdera$containers$SeqDict$updateIfExists$(
							data.channelId,
							function (channel) {
								_v5$2:
								while (true) {
									if (!anchor.$) {
										if (!anchor.a.$) {
											var messageId = anchor.a.a;
											var anchor2 = anchor.b;
											return $author$project$LocalState$drawingHandleChangeNoThreadFrontend$(data.currentUserId, anchor2, change, messageId, channel);
										} else {
											break _v5$2;
										}
									} else {
										if (!anchor.a.$) {
											var _v6 = anchor.a;
											var date = anchor.b;
											return _Utils_update(
												channel,
												{
													dateDividerDrawings: $author$project$SeqDictHelper$updateOrInsert$(
														date,
														function (maybe) {
															return $author$project$Drawing$handleLocalChange$(
																data.currentUserId,
																change,
																$elm$core$Maybe$withDefault$($author$project$Drawing$emptyDrawing, maybe));
														},
														channel.dateDividerDrawings)
												});
										} else {
											break _v5$2;
										}
									}
								}
								return channel;
							},
							local.discordDmChannels)
					});
			}
		default:
			return local;
	}
};
var $author$project$LocalState$drawingHandleChangeFrontend = F5($author$project$LocalState$drawingHandleChangeFrontend$);
var $author$project$LocalState$editChannel$ = function (channelName, channelDescription, channelId, guild) {
	return $author$project$LocalState$updateChannel$(
		function (channel) {
			return _Utils_update(
				channel,
				{description: channelDescription, name: channelName});
		},
		channelId,
		guild);
};
var $author$project$LocalState$editChannel = F4($author$project$LocalState$editChannel$);
var $author$project$Message$editAndEncryptUserTextMessage$ = function (time, fileHashes, newContent, data) {
	return {
		content: newContent,
		createdAt: data.createdAt,
		createdBy: data.createdBy,
		drawings: data.drawings,
		editedAt: $elm$core$Maybe$Just(time),
		fileHashes: fileHashes,
		reactions: data.reactions,
		repliedTo: data.repliedTo
	};
};
var $author$project$Message$editAndEncryptUserTextMessage = F4($author$project$Message$editAndEncryptUserTextMessage$);
var $author$project$Message$editEncryptedUserTextMessage$ = function (time, fileHashes, newContent, data) {
	return _Utils_update(
		data,
		{
			content: newContent,
			editedAt: $elm$core$Maybe$Just(time),
			fileHashes: fileHashes
		});
};
var $author$project$Message$editEncryptedUserTextMessage = F4($author$project$Message$editEncryptedUserTextMessage$);
var $author$project$LocalState$editEncryptedMessageFrontendHelperNoThread$ = function (time, editedBy, fileHashes, newContent, messageIndex, channel) {
	var _v0 = $author$project$MessageArray$get$(messageIndex, channel.messages);
	_v0$2:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a.$) {
				case 1:
					var data = _v0.a.a;
					return _Utils_eq(data.createdBy, editedBy) ? $elm$core$Result$Ok(
						_Utils_update(
							channel,
							{
								messages: $author$project$MessageArray$set$(
									messageIndex,
									$author$project$Message$EncryptedUserTextMessage(
										$author$project$Message$editEncryptedUserTextMessage$(time, fileHashes, newContent, data)),
									channel.messages)
							})) : $elm$core$Result$Err(0);
				case 0:
					var data = _v0.a.a;
					return _Utils_eq(data.createdBy, editedBy) ? $elm$core$Result$Ok(
						_Utils_update(
							channel,
							{
								messages: $author$project$MessageArray$set$(
									messageIndex,
									$author$project$Message$EncryptedUserTextMessage(
										$author$project$Message$editAndEncryptUserTextMessage$(time, fileHashes, newContent, data)),
									channel.messages)
							})) : $elm$core$Result$Err(0);
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Result$Err(0);
};
var $author$project$LocalState$editEncryptedMessageFrontendHelperNoThread = F6($author$project$LocalState$editEncryptedMessageFrontendHelperNoThread$);
var $author$project$LocalState$editEncryptedMessageFrontendHelper$ = function (time, editedBy, fileHashes, newContent, threadRoute, channel) {
	if (threadRoute.$ === 1) {
		var threadMessageIndex = threadRoute.a;
		var messageId = threadRoute.b;
		var _v1 = $lamdera$containers$SeqDict$get$(threadMessageIndex, channel.threads);
		if (!_v1.$) {
			var thread = _v1.a;
			var _v2 = $author$project$LocalState$editEncryptedMessageFrontendHelperNoThread$(time, editedBy, fileHashes, newContent, messageId, thread);
			if (!_v2.$) {
				var thread2 = _v2.a;
				return $elm$core$Result$Ok(
					_Utils_update(
						channel,
						{
							threads: $lamdera$containers$SeqDict$insert$(threadMessageIndex, thread2, channel.threads)
						}));
			} else {
				return $elm$core$Result$Err(0);
			}
		} else {
			return $elm$core$Result$Err(0);
		}
	} else {
		var messageId = threadRoute.a;
		return $author$project$LocalState$editEncryptedMessageFrontendHelperNoThread$(time, editedBy, fileHashes, newContent, messageId, channel);
	}
};
var $author$project$LocalState$editEncryptedMessageFrontendHelper = F6($author$project$LocalState$editEncryptedMessageFrontendHelper$);
var $author$project$FrontendExtra$editEncryptedDmMessage$ = function (editedAt, editedBy, otherUserId, threadRoute, fileHashes, content, local) {
	var _v0 = $lamdera$containers$SeqDict$get$(otherUserId, local.dmChannels);
	if (!_v0.$) {
		var dmChannel = _v0.a;
		var _v1 = $author$project$LocalState$editEncryptedMessageFrontendHelper$(editedAt, editedBy, fileHashes, content, threadRoute, dmChannel);
		if (!_v1.$) {
			var dmChannel2 = _v1.a;
			return _Utils_update(
				local,
				{
					dmChannels: $lamdera$containers$SeqDict$insert$(
						otherUserId,
						_Utils_update(
							dmChannel2,
							{
								lastTypedAt: $author$project$LocalState$dmForgetEditTyping$(editedBy, threadRoute, dmChannel2.lastTypedAt)
							}),
						local.dmChannels)
				});
		} else {
			return local;
		}
	} else {
		return local;
	}
};
var $author$project$FrontendExtra$editEncryptedDmMessage = F7($author$project$FrontendExtra$editEncryptedDmMessage$);
var $author$project$LocalState$editGuildName$ = function (guildName, guild) {
	return _Utils_update(
		guild,
		{name: guildName});
};
var $author$project$LocalState$editGuildName = F2($author$project$LocalState$editGuildName$);
var $author$project$Message$editUserTextMessage$ = function (time, newContent, attachedFiles, data) {
	var oldUrls = $lamdera$containers$SeqDict$fromList(
		$elm$core$List$indexedMap$(
			F2(
				function (index, link) {
					var _v1 = $elm$core$Array$get$(index, data.content.embeds);
					if (!_v1.$) {
						if (_v1.a.$ === 1) {
							var embed = _v1.a.a;
							return _Utils_Tuple2(link, embed);
						} else {
							var _v2 = _v1.a;
							return _Utils_Tuple2(link, $author$project$Embed$empty);
						}
					} else {
						return _Utils_Tuple2(link, $author$project$Embed$empty);
					}
				}),
			$author$project$RichText$hyperlinks(data.content.content)));
	return _Utils_update(
		data,
		{
			content: {
				attachedFiles: function () {
					if (!attachedFiles.$) {
						var attachedFiles2 = attachedFiles.a;
						return attachedFiles2;
					} else {
						return data.content.attachedFiles;
					}
				}(),
				content: newContent,
				embeds: $elm$core$Array$fromList(
					$elm$core$List$map$(
						function (url) {
							return $author$project$Embed$EmbedLoaded(
								$elm$core$Maybe$withDefault$(
									$author$project$Embed$empty,
									$lamdera$containers$SeqDict$get$(url, oldUrls)));
						},
						$author$project$RichText$hyperlinks(newContent)))
			},
			editedAt: $elm$core$Maybe$Just(time)
		});
};
var $author$project$Message$editUserTextMessage = F4($author$project$Message$editUserTextMessage$);
var $author$project$LocalState$editMessageFrontendHelperNoThread$ = function (time, editedBy, newContent, attachedFiles, messageIndex, channel) {
	var _v0 = $author$project$MessageArray$get$(messageIndex, channel.messages);
	if ((!_v0.$) && (!_v0.a.$)) {
		var data = _v0.a.a;
		return (_Utils_eq(data.createdBy, editedBy) && (!_Utils_eq(data.content.content, newContent))) ? $elm$core$Result$Ok(
			_Utils_update(
				channel,
				{
					messages: $author$project$MessageArray$set$(
						messageIndex,
						$author$project$Message$UserTextMessage(
							$author$project$Message$editUserTextMessage$(time, newContent, attachedFiles, data)),
						channel.messages)
				})) : $elm$core$Result$Err(0);
	} else {
		return $elm$core$Result$Err(0);
	}
};
var $author$project$LocalState$editMessageFrontendHelperNoThread = F6($author$project$LocalState$editMessageFrontendHelperNoThread$);
var $author$project$LocalState$editMessageFrontendHelper$ = function (time, editedBy, newContent, attachedFiles, threadRoute, channel) {
	if (threadRoute.$ === 1) {
		var threadMessageIndex = threadRoute.a;
		var messageId = threadRoute.b;
		var _v1 = $lamdera$containers$SeqDict$get$(threadMessageIndex, channel.threads);
		if (!_v1.$) {
			var thread = _v1.a;
			var _v2 = $author$project$LocalState$editMessageFrontendHelperNoThread$(time, editedBy, newContent, attachedFiles, messageId, thread);
			if (!_v2.$) {
				var thread2 = _v2.a;
				return $elm$core$Result$Ok(
					_Utils_update(
						channel,
						{
							threads: $lamdera$containers$SeqDict$insert$(threadMessageIndex, thread2, channel.threads)
						}));
			} else {
				return $elm$core$Result$Err(0);
			}
		} else {
			return $elm$core$Result$Err(0);
		}
	} else {
		var messageId = threadRoute.a;
		return $author$project$LocalState$editMessageFrontendHelperNoThread$(time, editedBy, newContent, attachedFiles, messageId, channel);
	}
};
var $author$project$LocalState$editMessageFrontendHelper = F6($author$project$LocalState$editMessageFrontendHelper$);
var $author$project$User$backendToFrontendForUser = function (user) {
	return {color: user.color, icon: user.icon, name: user.name, publicKey: user.publicKey};
};
var $author$project$User$allUsers = function (localUser) {
	return $lamdera$containers$SeqDict$insert$(
		localUser.session.userId,
		$author$project$User$backendToFrontendForUser(localUser.user),
		localUser.otherUsers);
};
var $author$project$LocalState$threadMentionName$ = function (threadId, channel, localUser) {
	return $author$project$LocalState$threadName$(
		channel.name,
		function () {
			var _v0 = $author$project$MessageArray$get$(threadId, channel.messages);
			if (!_v0.$) {
				var message = _v0.a;
				return $author$project$LocalState$messageToString$(
					localUser.timezone,
					$author$project$User$allUsers(localUser),
					$lamdera$containers$SeqDict$empty,
					localUser.decryptedMessages,
					message);
			} else {
				return '<missing>';
			}
		}());
};
var $author$project$LocalState$threadMentionName = F3($author$project$LocalState$threadMentionName$);
var $author$project$LocalState$guildChannelMentions$ = function (localUser, channels) {
	return $lamdera$containers$SeqDict$foldl$(
		F3(
			function (channelId, channel, dict) {
				return $lamdera$containers$SeqDict$foldl$(
					F3(
						function (threadId, _v0, dict2) {
							return $lamdera$containers$SeqDict$insert$(
								_Utils_Tuple2(
									channelId,
									$elm$core$Maybe$Just(threadId)),
								{
									name: $author$project$LocalState$threadMentionName$(threadId, channel, localUser)
								},
								dict2);
						}),
					$lamdera$containers$SeqDict$insert$(
						_Utils_Tuple2(channelId, $elm$core$Maybe$Nothing),
						{
							name: $author$project$ChannelName$toString(channel.name)
						},
						dict),
					channel.threads);
			}),
		$lamdera$containers$SeqDict$empty,
		channels);
};
var $author$project$LocalState$guildChannelMentions = F2($author$project$LocalState$guildChannelMentions$);
var $author$project$MembersAndOwner$membersAndOwner = function (_v0) {
	var members2 = _v0.a;
	var ownerId = _v0.b;
	return A2(
		$elm$core$List$cons,
		ownerId,
		$lamdera$containers$SeqDict$keys(members2));
};
var $MartinSStewart$elm_nonempty_string$String$Nonempty$head = function (_v0) {
	var head_ = _v0.a;
	return head_;
};
var $MartinSStewart$elm_nonempty_string$String$Nonempty$tail = function (_v0) {
	var tail_ = _v0.b;
	return tail_;
};
var $author$project$RichText$bulletRevNodes$ = function (bulletNode, trailing, flushed) {
	var _v0 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(trailing);
	if (!_v0.$) {
		var t = _v0.a;
		return A2(
			$elm$core$List$cons,
			$author$project$RichText$NormalText$(
				$MartinSStewart$elm_nonempty_string$String$Nonempty$head(t),
				$MartinSStewart$elm_nonempty_string$String$Nonempty$tail(t)),
			A2($elm$core$List$cons, bulletNode, flushed));
	} else {
		return A2($elm$core$List$cons, bulletNode, flushed);
	}
};
var $author$project$RichText$bulletRevNodes = F3($author$project$RichText$bulletRevNodes$);
var $author$project$RichText$stringAt$ = function (index, text) {
	return (_Utils_cmp(
		index,
		$elm$core$String$length(text)) < 0) ? $elm$core$Maybe$Just(
		A3($elm$core$String$slice, index, index + 1, text)) : $elm$core$Maybe$Nothing;
};
var $author$project$RichText$stringAt = F2($author$project$RichText$stringAt$);
var $author$project$RichText$findLineEnd$ = function (source, index) {
	findLineEnd:
	while (true) {
		if (_Utils_cmp(
			index,
			$elm$core$String$length(source)) > -1) {
			return index;
		} else {
			if (_Utils_eq(
				$author$project$RichText$stringAt$(index, source),
				$elm$core$Maybe$Just('\u000A'))) {
				return index;
			} else {
				var $temp$index = index + 1;
				index = $temp$index;
				continue findLineEnd;
			}
		}
	}
};
var $author$project$RichText$findLineEnd = F2($author$project$RichText$findLineEnd$);
var $author$project$RichText$stringAtRange$ = function (index, count, text) {
	return ((_Utils_cmp(
		index + count,
		$elm$core$String$length(text)) < 1) && (count >= 0)) ? $elm$core$Maybe$Just(
		A3($elm$core$String$slice, index, index + count, text)) : $elm$core$Maybe$Nothing;
};
var $author$project$RichText$stringAtRange = F3($author$project$RichText$stringAtRange$);
var $author$project$RichText$collectBlockQuoteLines$ = function (source, index) {
	var lineEnd = $author$project$RichText$findLineEnd$(source, index);
	var line = A3($elm$core$String$slice, index, lineEnd, source);
	var _v0 = $author$project$RichText$stringAtRange$(lineEnd, 3, source);
	if ((!_v0.$) && (_v0.a === '\u000A> ')) {
		var afterGt = lineEnd + 3;
		var _v1 = $author$project$RichText$collectBlockQuoteLines$(source, afterGt);
		var nextEnd = _v1.a;
		var nextContent = _v1.b;
		return _Utils_Tuple2(nextEnd, line + ('\u000A' + nextContent));
	} else {
		return _Utils_Tuple2(lineEnd, line);
	}
};
var $author$project$RichText$collectBlockQuoteLines = F2($author$project$RichText$collectBlockQuoteLines$);
var $author$project$RichText$extractBlockQuote$ = function (source, index) {
	var _v0 = $author$project$RichText$stringAtRange$(index, 2, source);
	if ((!_v0.$) && (_v0.a === '> ')) {
		var _v1 = $author$project$RichText$collectBlockQuoteLines$(source, index + 2);
		var endIndex = _v1.a;
		var content = _v1.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(content, endIndex));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$RichText$extractBlockQuote = F2($author$project$RichText$extractBlockQuote$);
var $author$project$RichText$bulletContinuation$ = function (matchMarker, source, lineEnd) {
	if (_Utils_eq(
		$author$project$RichText$stringAt$(lineEnd, source),
		$elm$core$Maybe$Just('\u000A'))) {
		var _v0 = A2(matchMarker, source, lineEnd + 1);
		if (!_v0.$) {
			var markerLen = _v0.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					A3($elm$core$String$slice, lineEnd, (lineEnd + 1) + markerLen, source),
					(lineEnd + 1) + markerLen));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$RichText$bulletContinuation = F3($author$project$RichText$bulletContinuation$);
var $author$project$RichText$collectBulletLines$ = function (matchMarker, parseContent, source, contentStart, markerPrefix) {
	var lineEnd = $author$project$RichText$findLineEnd$(source, contentStart);
	var nodes = parseContent(
		A3($elm$core$String$slice, contentStart, lineEnd, source));
	var _v0 = $author$project$RichText$bulletContinuation$(matchMarker, source, lineEnd);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var nextPrefix = _v1.a;
		var nextContentStart = _v1.b;
		var rest = $author$project$RichText$collectBulletLines$(matchMarker, parseContent, source, nextContentStart, nextPrefix);
		return {
			endIndex: rest.endIndex,
			items: A2($elm$core$List$cons, nodes, rest.items),
			trailing: rest.trailing
		};
	} else {
		return $elm$core$List$isEmpty(nodes) ? {endIndex: lineEnd, items: _List_Nil, trailing: markerPrefix} : {
			endIndex: lineEnd,
			items: _List_fromArray(
				[nodes]),
			trailing: ''
		};
	}
};
var $author$project$RichText$collectBulletLines = F5($author$project$RichText$collectBulletLines$);
var $author$project$RichText$extractBulletPoint$ = function (matchMarker, parseContent, source, index) {
	var _v0 = A2(matchMarker, source, index);
	if (!_v0.$) {
		var markerLen = _v0.a;
		var result = $author$project$RichText$collectBulletLines$(
			matchMarker,
			parseContent,
			source,
			index + markerLen,
			A3($elm$core$String$slice, index, index + markerLen, source));
		var _v1 = $mgold$elm_nonempty_list$List$Nonempty$fromList(result.items);
		if (!_v1.$) {
			var items = _v1.a;
			return $elm$core$Maybe$Just(
				{endIndex: result.endIndex, items: items, trailing: result.trailing});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$RichText$extractBulletPoint = F4($author$project$RichText$extractBulletPoint$);
var $author$project$RichText$collectHeadingLine$ = function (level, source, contentStart) {
	var lineEnd = $author$project$RichText$findLineEnd$(source, contentStart);
	var _v0 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(
		A3($elm$core$String$slice, contentStart, lineEnd, source));
	if (!_v0.$) {
		var nonempty = _v0.a;
		return $elm$core$Maybe$Just(
			_Utils_Tuple3(level, nonempty, lineEnd));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$RichText$collectHeadingLine = F3($author$project$RichText$collectHeadingLine$);
var $author$project$RichText$extractHeading$ = function (source, index) {
	var _v0 = $author$project$RichText$stringAtRange$(index, 4, source);
	if ((!_v0.$) && (_v0.a === '### ')) {
		return $author$project$RichText$collectHeadingLine$(2, source, index + 4);
	} else {
		var _v1 = $author$project$RichText$stringAtRange$(index, 3, source);
		_v1$2:
		while (true) {
			if (!_v1.$) {
				switch (_v1.a) {
					case '## ':
						return $author$project$RichText$collectHeadingLine$(1, source, index + 3);
					case '-# ':
						return $author$project$RichText$collectHeadingLine$(3, source, index + 3);
					default:
						break _v1$2;
				}
			} else {
				break _v1$2;
			}
		}
		var _v2 = $author$project$RichText$stringAtRange$(index, 2, source);
		if ((!_v2.$) && (_v2.a === '# ')) {
			return $author$project$RichText$collectHeadingLine$(0, source, index + 2);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$RichText$extractHeading = F2($author$project$RichText$extractHeading$);
var $author$project$RichText$normalTextFromNonempty = function (text) {
	return $author$project$RichText$NormalText$(
		$MartinSStewart$elm_nonempty_string$String$Nonempty$head(text),
		$MartinSStewart$elm_nonempty_string$String$Nonempty$tail(text));
};
var $mgold$elm_nonempty_list$List$Nonempty$cons$ = function (y, _v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
		y,
		A2($elm$core$List$cons, x, xs));
};
var $mgold$elm_nonempty_list$List$Nonempty$cons = F2($mgold$elm_nonempty_list$List$Nonempty$cons$);
var $author$project$RichText$mapBulletItem$ = function (f, item) {
	var _v0 = $mgold$elm_nonempty_list$List$Nonempty$fromList(item);
	if (!_v0.$) {
		var nonempty = _v0.a;
		return $mgold$elm_nonempty_list$List$Nonempty$toList(
			f(nonempty));
	} else {
		return item;
	}
};
var $author$project$RichText$mapBulletItem = F2($author$project$RichText$mapBulletItem$);
var $mgold$elm_nonempty_list$List$Nonempty$replaceHead$ = function (y, _v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(y, xs);
};
var $mgold$elm_nonempty_list$List$Nonempty$replaceHead = F2($mgold$elm_nonempty_list$List$Nonempty$replaceHead$);
var $mgold$elm_nonempty_list$List$Nonempty$reverse = function (_v0) {
	var x = _v0.a;
	var xs = _v0.b;
	var revapp = function (_v1) {
		revapp:
		while (true) {
			var ls = _v1.a;
			var c = _v1.b;
			var rs = _v1.c;
			if (!rs.b) {
				return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(c, ls);
			} else {
				var r = rs.a;
				var rss = rs.b;
				var $temp$_v1 = _Utils_Tuple3(
					A2($elm$core$List$cons, c, ls),
					r,
					rss);
				_v1 = $temp$_v1;
				continue revapp;
			}
		}
	};
	return revapp(
		_Utils_Tuple3(_List_Nil, x, xs));
};
var $mgold$elm_nonempty_list$List$Nonempty$tail = function (_v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return xs;
};
var $author$project$RichText$normalize = function (nonempty) {
	return $mgold$elm_nonempty_list$List$Nonempty$reverse(
		$elm$core$List$foldl$(
			F2(
				function (richText, nonempty2) {
					switch (richText.$) {
						case 2:
							var _char = richText.a;
							var rest = richText.b;
							var _v1 = $mgold$elm_nonempty_list$List$Nonempty$head(nonempty2);
							if (_v1.$ === 2) {
								var previousChar = _v1.a;
								var previousRest = _v1.b;
								return $mgold$elm_nonempty_list$List$Nonempty$replaceHead$(
									$author$project$RichText$NormalText$(
										previousChar,
										_Utils_ap(
											previousRest,
											A2($elm$core$String$cons, _char, rest))),
									nonempty2);
							} else {
								return $mgold$elm_nonempty_list$List$Nonempty$cons$(richText, nonempty2);
							}
						case 4:
							var a = richText.a;
							return $mgold$elm_nonempty_list$List$Nonempty$cons$(
								$author$project$RichText$Italic(
									$author$project$RichText$normalize(a)),
								nonempty2);
						case 3:
							var a = richText.a;
							return $mgold$elm_nonempty_list$List$Nonempty$cons$(
								$author$project$RichText$Bold(
									$author$project$RichText$normalize(a)),
								nonempty2);
						case 5:
							var a = richText.a;
							return $mgold$elm_nonempty_list$List$Nonempty$cons$(
								$author$project$RichText$Underline(
									$author$project$RichText$normalize(a)),
								nonempty2);
						case 0:
							return $mgold$elm_nonempty_list$List$Nonempty$cons$(richText, nonempty2);
						case 1:
							return $mgold$elm_nonempty_list$List$Nonempty$cons$(richText, nonempty2);
						case 6:
							var a = richText.a;
							return $mgold$elm_nonempty_list$List$Nonempty$cons$(
								$author$project$RichText$Strikethrough(
									$author$project$RichText$normalize(a)),
								nonempty2);
						case 7:
							var a = richText.a;
							return $mgold$elm_nonempty_list$List$Nonempty$cons$(
								$author$project$RichText$Spoiler(
									$author$project$RichText$normalize(a)),
								nonempty2);
						case 8:
							var hasLeadingLineBreak = richText.a;
							var list = richText.b;
							return $mgold$elm_nonempty_list$List$Nonempty$cons$(
								$author$project$RichText$BlockQuote$(
									hasLeadingLineBreak,
									function () {
										var _v2 = $mgold$elm_nonempty_list$List$Nonempty$fromList(list);
										if (!_v2.$) {
											var a = _v2.a;
											return $mgold$elm_nonempty_list$List$Nonempty$toList(
												$author$project$RichText$normalize(a));
										} else {
											return list;
										}
									}()),
								nonempty2);
						case 9:
							var level = richText.a;
							var hasLeadingLineBreak = richText.b;
							var a = richText.c;
							return $mgold$elm_nonempty_list$List$Nonempty$cons$(
								$author$project$RichText$Heading$(
									level,
									hasLeadingLineBreak,
									$author$project$RichText$normalize(a)),
								nonempty2);
						case 10:
							var data = richText.a;
							return $mgold$elm_nonempty_list$List$Nonempty$cons$(
								$author$project$RichText$Hyperlink(data),
								nonempty2);
						case 11:
							var alias = richText.a;
							var url = richText.b;
							return $mgold$elm_nonempty_list$List$Nonempty$cons$(
								$author$project$RichText$MarkdownLink$(alias, url),
								nonempty2);
						case 12:
							var _char = richText.a;
							var string = richText.b;
							return $mgold$elm_nonempty_list$List$Nonempty$cons$(
								$author$project$RichText$InlineCode$(_char, string),
								nonempty2);
						case 13:
							var language = richText.a;
							var string = richText.b;
							return $mgold$elm_nonempty_list$List$Nonempty$cons$(
								$author$project$RichText$CodeBlock$(language, string),
								nonempty2);
						case 14:
							var fileId = richText.a;
							return $mgold$elm_nonempty_list$List$Nonempty$cons$(
								$author$project$RichText$AttachedFile(fileId),
								nonempty2);
						case 15:
							var _char = richText.a;
							return $mgold$elm_nonempty_list$List$Nonempty$cons$(
								$author$project$RichText$EscapedChar(_char),
								nonempty2);
						case 16:
							var id = richText.a;
							return $mgold$elm_nonempty_list$List$Nonempty$cons$(
								$author$project$RichText$Sticker(id),
								nonempty2);
						case 17:
							var id = richText.a;
							return $mgold$elm_nonempty_list$List$Nonempty$cons$(
								$author$project$RichText$CustomEmoji(id),
								nonempty2);
						case 18:
							var hasLeadingLineBreak = richText.a;
							var items = richText.b;
							return $mgold$elm_nonempty_list$List$Nonempty$cons$(
								$author$project$RichText$BulletPoint$(
									hasLeadingLineBreak,
									$mgold$elm_nonempty_list$List$Nonempty$map$(
										$author$project$RichText$mapBulletItem($author$project$RichText$normalize),
										items)),
								nonempty2);
						default:
							var time = richText.a;
							return $mgold$elm_nonempty_list$List$Nonempty$cons$(
								$author$project$RichText$Timestamp(time),
								nonempty2);
					}
				}),
			$mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
				function () {
					var _v3 = $mgold$elm_nonempty_list$List$Nonempty$head(nonempty);
					switch (_v3.$) {
						case 4:
							var a = _v3.a;
							return $author$project$RichText$Italic(
								$author$project$RichText$normalize(a));
						case 0:
							var id = _v3.a;
							return $author$project$RichText$UserMention(id);
						case 1:
							var channel = _v3.a;
							var thread = _v3.b;
							return $author$project$RichText$ChannelMention$(channel, thread);
						case 2:
							var _char = _v3.a;
							var string = _v3.b;
							return $author$project$RichText$NormalText$(_char, string);
						case 3:
							var a = _v3.a;
							return $author$project$RichText$Bold(
								$author$project$RichText$normalize(a));
						case 5:
							var a = _v3.a;
							return $author$project$RichText$Underline(
								$author$project$RichText$normalize(a));
						case 6:
							var a = _v3.a;
							return $author$project$RichText$Strikethrough(
								$author$project$RichText$normalize(a));
						case 7:
							var a = _v3.a;
							return $author$project$RichText$Spoiler(
								$author$project$RichText$normalize(a));
						case 8:
							var hasLeadingLineBreak = _v3.a;
							var list = _v3.b;
							return $author$project$RichText$BlockQuote$(
								hasLeadingLineBreak,
								function () {
									var _v4 = $mgold$elm_nonempty_list$List$Nonempty$fromList(list);
									if (!_v4.$) {
										var a = _v4.a;
										return $mgold$elm_nonempty_list$List$Nonempty$toList(
											$author$project$RichText$normalize(a));
									} else {
										return list;
									}
								}());
						case 9:
							var level = _v3.a;
							var hasLeadingLineBreak = _v3.b;
							var a = _v3.c;
							return $author$project$RichText$Heading$(
								level,
								hasLeadingLineBreak,
								$author$project$RichText$normalize(a));
						case 10:
							var data = _v3.a;
							return $author$project$RichText$Hyperlink(data);
						case 11:
							var alias = _v3.a;
							var url = _v3.b;
							return $author$project$RichText$MarkdownLink$(alias, url);
						case 12:
							var _char = _v3.a;
							var string = _v3.b;
							return $author$project$RichText$InlineCode$(_char, string);
						case 13:
							var language = _v3.a;
							var string = _v3.b;
							return $author$project$RichText$CodeBlock$(language, string);
						case 14:
							var fileId = _v3.a;
							return $author$project$RichText$AttachedFile(fileId);
						case 15:
							var _char = _v3.a;
							return $author$project$RichText$EscapedChar(_char);
						case 16:
							var id = _v3.a;
							return $author$project$RichText$Sticker(id);
						case 17:
							var id = _v3.a;
							return $author$project$RichText$CustomEmoji(id);
						case 18:
							var hasLeadingLineBreak = _v3.a;
							var items = _v3.b;
							return $author$project$RichText$BulletPoint$(
								hasLeadingLineBreak,
								$mgold$elm_nonempty_list$List$Nonempty$map$(
									$author$project$RichText$mapBulletItem($author$project$RichText$normalize),
									items));
						default:
							var time = _v3.a;
							return $author$project$RichText$Timestamp(time);
					}
				}(),
				_List_Nil),
			$mgold$elm_nonempty_list$List$Nonempty$tail(nonempty)));
};
var $author$project$RichText$IsBold = 0;
var $author$project$RichText$IsItalic = 1;
var $author$project$RichText$IsSpoilered = 4;
var $author$project$RichText$IsStrikethrough = 3;
var $author$project$RichText$IsUnderlined = 2;
var $author$project$RichText$allEscapedChars = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7]);
var $author$project$RichText$charToEscaped = $elm$core$Dict$fromList(
	$elm$core$List$map$(
		function (escaped) {
			return _Utils_Tuple2(
				$author$project$RichText$escapedCharToString(escaped),
				escaped);
		},
		$author$project$RichText$allEscapedChars));
var $author$project$RichText$flushText$ = function (text, revNodes) {
	var _v0 = $elm$core$String$uncons(text);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var _char = _v1.a;
		var rest = _v1.b;
		return A2(
			$elm$core$List$cons,
			$author$project$RichText$NormalText$(_char, rest),
			revNodes);
	} else {
		return revNodes;
	}
};
var $author$project$RichText$flushText = F2($author$project$RichText$flushText$);
var $author$project$RichText$closeModifier$ = function (afterSymbol, accText, revNodes, container, symbol) {
	var flushed = $author$project$RichText$flushText$(accText, revNodes);
	var finalNodes = $elm$core$List$reverse(flushed);
	var _v0 = $mgold$elm_nonempty_list$List$Nonempty$fromList(finalNodes);
	if (!_v0.$) {
		var nonempty = _v0.a;
		return {
			nextIndex: afterSymbol,
			nodes: _List_fromArray(
				[
					container(nonempty)
				])
		};
	} else {
		return {
			nextIndex: afterSymbol,
			nodes: _List_fromArray(
				[
					$author$project$RichText$NormalText$(
					$MartinSStewart$elm_nonempty_string$String$Nonempty$head(symbol),
					$MartinSStewart$elm_nonempty_string$String$Nonempty$tail(symbol))
				])
		};
	}
};
var $author$project$RichText$closeModifier = F5($author$project$RichText$closeModifier$);
var $author$project$RichText$finalizeResult$ = function (modifierToString, accText, revNodes, modifiers, index) {
	var flushed = $author$project$RichText$flushText$(accText, revNodes);
	var finalNodes = $elm$core$List$reverse(flushed);
	return {
		nextIndex: index,
		nodes: function () {
			if (modifiers.b) {
				var head = modifiers.a;
				var _v1 = modifierToString(head);
				var _char = _v1.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$author$project$RichText$NormalText$(_char, rest),
					finalNodes);
			} else {
				return finalNodes;
			}
		}()
	};
};
var $author$project$RichText$finalizeResult = F5($author$project$RichText$finalizeResult$);
var $author$project$RichText$findSingleBacktick$ = function (source, index) {
	findSingleBacktick:
	while (true) {
		if (_Utils_cmp(
			index,
			$elm$core$String$length(source)) > -1) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (A3($elm$core$String$slice, index, index + 1, source) === '`') {
				return $elm$core$Maybe$Just(index);
			} else {
				var $temp$index = index + 1;
				index = $temp$index;
				continue findSingleBacktick;
			}
		}
	}
};
var $author$project$RichText$findSingleBacktick = F2($author$project$RichText$findSingleBacktick$);
var $author$project$RichText$findSubstring$ = function (source, index, target) {
	findSubstring:
	while (true) {
		var targetLen = $elm$core$String$length(target);
		if (_Utils_cmp(
			index + targetLen,
			$elm$core$String$length(source)) > 0) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (_Utils_eq(
				A3($elm$core$String$slice, index, index + targetLen, source),
				target)) {
				return $elm$core$Maybe$Just(index);
			} else {
				var $temp$index = index + 1;
				index = $temp$index;
				continue findSubstring;
			}
		}
	}
};
var $author$project$RichText$findSubstring = F3($author$project$RichText$findSubstring$);
var $author$project$RichText$modifierToSymbol = function (modifier) {
	switch (modifier) {
		case 0:
			return $MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('*', '');
		case 1:
			return $MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('_', '');
		case 2:
			return $MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('_', '_');
		case 3:
			return $MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('~', '~');
		default:
			return $MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('|', '|');
	}
};
var $author$project$RichText$parseCodeBlockContent = function (text) {
	var _v0 = $elm$core$String$split$('\u000A', text);
	if (_v0.b) {
		if (!_v0.b.b) {
			var single = _v0.a;
			return _Utils_Tuple2($author$project$RichText$NoLanguage, single);
		} else {
			var head = _v0.a;
			var rest = _v0.b;
			if (A2($elm$core$String$contains, ' ', head)) {
				return _Utils_Tuple2($author$project$RichText$NoLanguage, text);
			} else {
				var _v1 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(head);
				if (!_v1.$) {
					var nonempty = _v1.a;
					var rest2 = $elm$core$String$join$('\u000A', rest);
					return $elm$core$String$isEmpty(
						$elm$core$String$trim(rest2)) ? _Utils_Tuple2($author$project$RichText$NoLanguage, text) : _Utils_Tuple2(
						$author$project$RichText$Language(nonempty),
						rest2);
				} else {
					return _Utils_Tuple2($author$project$RichText$NoLanguage, text);
				}
			}
		}
	} else {
		return _Utils_Tuple2($author$project$RichText$NoLanguage, '');
	}
};
var $author$project$RichText$parseCustomEmojiIdHelper$ = function (id, index, source) {
	parseCustomEmojiIdHelper:
	while (true) {
		var _v0 = $author$project$RichText$stringAt$(index, source);
		if (!_v0.$) {
			var _char = _v0.a;
			switch (_char) {
				case '\u200B':
					var $temp$id = 4 * id,
						$temp$index = index + 1;
					id = $temp$id;
					index = $temp$index;
					continue parseCustomEmojiIdHelper;
				case '\u200C':
					var $temp$id = 1 + (4 * id),
						$temp$index = index + 1;
					id = $temp$id;
					index = $temp$index;
					continue parseCustomEmojiIdHelper;
				case '\u200D':
					var $temp$id = 2 + (4 * id),
						$temp$index = index + 1;
					id = $temp$id;
					index = $temp$index;
					continue parseCustomEmojiIdHelper;
				case '\u2060':
					var $temp$id = 3 + (4 * id),
						$temp$index = index + 1;
					id = $temp$id;
					index = $temp$index;
					continue parseCustomEmojiIdHelper;
				case '\uFEFF':
					return _Utils_Tuple2(
						index + 1,
						$elm$core$Maybe$Just(
							$author$project$Id$fromInt(id)));
				default:
					return _Utils_Tuple2(index, $elm$core$Maybe$Nothing);
			}
		} else {
			return _Utils_Tuple2(index, $elm$core$Maybe$Nothing);
		}
	}
};
var $author$project$RichText$parseCustomEmojiIdHelper = F3($author$project$RichText$parseCustomEmojiIdHelper$);
var $author$project$RichText$parseCustomEmojiId$ = function (index, source) {
	var _v0 = $author$project$RichText$stringAt$(index, source);
	if (!_v0.$) {
		var _char = _v0.a;
		switch (_char) {
			case '\u200B':
				return _Utils_eq(
					$author$project$RichText$stringAt$(index + 1, source),
					$elm$core$Maybe$Just('\uFEFF')) ? _Utils_Tuple2(
					index + 2,
					$elm$core$Maybe$Just(
						$author$project$Id$fromInt(0))) : _Utils_Tuple2(index + 1, $elm$core$Maybe$Nothing);
			case '\u200C':
				return $author$project$RichText$parseCustomEmojiIdHelper$(1, index + 1, source);
			case '\u200D':
				return $author$project$RichText$parseCustomEmojiIdHelper$(2, index + 1, source);
			case '\u2060':
				return $author$project$RichText$parseCustomEmojiIdHelper$(3, index + 1, source);
			default:
				return _Utils_Tuple2(index, $elm$core$Maybe$Nothing);
		}
	} else {
		return _Utils_Tuple2(index, $elm$core$Maybe$Nothing);
	}
};
var $author$project$RichText$parseCustomEmojiId = F2($author$project$RichText$parseCustomEmojiId$);
var $author$project$RichText$skipDigits$ = function (source, index, len) {
	skipDigits:
	while (true) {
		if (_Utils_cmp(index, len) > -1) {
			return index;
		} else {
			var c = A3($elm$core$String$slice, index, index + 1, source);
			if ((c >= '0') && (c <= '9')) {
				var $temp$index = index + 1;
				index = $temp$index;
				continue skipDigits;
			} else {
				return index;
			}
		}
	}
};
var $author$project$RichText$skipDigits = F3($author$project$RichText$skipDigits$);
var $author$project$RichText$parseFileId$ = function (source, index) {
	var len = $elm$core$String$length(source);
	var digitEnd = $author$project$RichText$skipDigits$(source, index, len);
	if ((_Utils_cmp(digitEnd, index) > 0) && ((_Utils_cmp(digitEnd, len) < 0) && (A3($elm$core$String$slice, digitEnd, digitEnd + 1, source) === ']'))) {
		var _v0 = $elm$core$String$toInt(
			A3($elm$core$String$slice, index, digitEnd, source));
		if (!_v0.$) {
			var n = _v0.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(n, digitEnd + 1));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$RichText$parseFileId = F2($author$project$RichText$parseFileId$);
var $author$project$RichText$findChar$ = function (source, index, len, target) {
	findChar:
	while (true) {
		if (_Utils_cmp(index, len) > -1) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (_Utils_eq(
				A3($elm$core$String$slice, index, index + 1, source),
				$elm$core$String$fromChar(target))) {
				return $elm$core$Maybe$Just(index);
			} else {
				var $temp$index = index + 1;
				index = $temp$index;
				continue findChar;
			}
		}
	}
};
var $author$project$RichText$findChar = F4($author$project$RichText$findChar$);
var $author$project$RichText$parseMarkdownLink$ = function (isDiscord, source, index) {
	var len = $elm$core$String$length(source);
	var _v0 = $author$project$RichText$findChar$(source, index, len, ']');
	if (!_v0.$) {
		var closeBracket = _v0.a;
		var alias = A3($elm$core$String$slice, index, closeBracket, source);
		var afterBracket = closeBracket + 1;
		if (A2($elm$core$String$contains, '[', alias)) {
			return $elm$core$Maybe$Nothing;
		} else {
			if ((_Utils_cmp(afterBracket, len) < 0) && (A3($elm$core$String$slice, afterBracket, afterBracket + 1, source) === '(')) {
				var _v1 = $author$project$RichText$findChar$(source, afterBracket + 1, len, ')');
				if (!_v1.$) {
					var closeParen = _v1.a;
					var urlText = (isDiscord ? $elm$core$String$trim : $elm$core$Basics$identity)(
						A3($elm$core$String$slice, afterBracket + 1, closeParen, source));
					var _v2 = _Utils_Tuple2(
						$MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(alias),
						$elm$url$Url$fromString(urlText));
					if ((!_v2.a.$) && (!_v2.b.$)) {
						var nonemptyAlias = _v2.a.a;
						var url = _v2.b.a;
						var urlNoPath = _Utils_update(
							url,
							{path: ''});
						return _Utils_eq(
							$elm$url$Url$toString(urlNoPath),
							urlText) ? $elm$core$Maybe$Just(
							_Utils_Tuple3(nonemptyAlias, urlNoPath, closeParen + 1)) : $elm$core$Maybe$Just(
							_Utils_Tuple3(nonemptyAlias, url, closeParen + 1));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$RichText$parseMarkdownLink = F3($author$project$RichText$parseMarkdownLink$);
var $elmcraft$core_extra$Basics$Extra$maxSafeInteger = A2($elm$core$Basics$pow, 2, 53) - 1;
var $author$project$RichText$parseStickerIdHelper$ = function (id, index, source) {
	parseStickerIdHelper:
	while (true) {
		var _v0 = $author$project$RichText$stringAt$(index, source);
		if (!_v0.$) {
			var _char = _v0.a;
			switch (_char) {
				case '\u200B':
					var $temp$id = 4 * id,
						$temp$index = index + 1;
					id = $temp$id;
					index = $temp$index;
					continue parseStickerIdHelper;
				case '\u200C':
					var $temp$id = 1 + (4 * id),
						$temp$index = index + 1;
					id = $temp$id;
					index = $temp$index;
					continue parseStickerIdHelper;
				case '\u200D':
					var $temp$id = 2 + (4 * id),
						$temp$index = index + 1;
					id = $temp$id;
					index = $temp$index;
					continue parseStickerIdHelper;
				case '\u2060':
					var $temp$id = 3 + (4 * id),
						$temp$index = index + 1;
					id = $temp$id;
					index = $temp$index;
					continue parseStickerIdHelper;
				case '\u000A':
					var _v2 = _Utils_Tuple2(
						$author$project$RichText$stringAt$(index + 1, source),
						_Utils_cmp(id, $elmcraft$core_extra$Basics$Extra$maxSafeInteger) < 1);
					if (((!_v2.a.$) && (_v2.a.a === '\u000A')) && _v2.b) {
						return _Utils_Tuple2(
							index + 2,
							$elm$core$Maybe$Just(
								$author$project$Id$fromInt(id)));
					} else {
						return _Utils_Tuple2(index + 1, $elm$core$Maybe$Nothing);
					}
				default:
					return _Utils_Tuple2(index, $elm$core$Maybe$Nothing);
			}
		} else {
			return _Utils_Tuple2(index, $elm$core$Maybe$Nothing);
		}
	}
};
var $author$project$RichText$parseStickerIdHelper = F3($author$project$RichText$parseStickerIdHelper$);
var $author$project$RichText$parseStickerId$ = function (index, source) {
	var _v0 = $author$project$RichText$stringAt$(index, source);
	if (!_v0.$) {
		var _char = _v0.a;
		switch (_char) {
			case '\u200B':
				return _Utils_eq(
					$author$project$RichText$stringAtRange$(index + 1, 2, source),
					$elm$core$Maybe$Just('\u000A\u000A')) ? _Utils_Tuple2(
					index + 3,
					$elm$core$Maybe$Just(
						$author$project$Id$fromInt(0))) : _Utils_Tuple2(index + 1, $elm$core$Maybe$Nothing);
			case '\u200C':
				return $author$project$RichText$parseStickerIdHelper$(1, index + 1, source);
			case '\u200D':
				return $author$project$RichText$parseStickerIdHelper$(2, index + 1, source);
			case '\u2060':
				return $author$project$RichText$parseStickerIdHelper$(3, index + 1, source);
			default:
				return _Utils_Tuple2(index, $elm$core$Maybe$Nothing);
		}
	} else {
		return _Utils_Tuple2(index, $elm$core$Maybe$Nothing);
	}
};
var $author$project$RichText$parseStickerId = F2($author$project$RichText$parseStickerId$);
var $elm$core$String$foldl = _String_foldl;
var $author$project$RichText$skipUrlChars$ = function (source, index, sourceLength) {
	skipUrlChars:
	while (true) {
		if (_Utils_cmp(index, sourceLength) > -1) {
			return index;
		} else {
			var c = A3($elm$core$String$slice, index, index + 1, source);
			if ((c === ' ') || ((c === '\u000A') || ((c === '\u0009') || ((c === '<') || (c === '|'))))) {
				return index;
			} else {
				var $temp$index = index + 1;
				index = $temp$index;
				continue skipUrlChars;
			}
		}
	}
};
var $author$project$RichText$skipUrlChars = F3($author$project$RichText$skipUrlChars$);
var $author$project$RichText$parseUrlBody$ = function (startedWithAngleBracket, modifierToString, modifiers, index, source) {
	var protocolResult = (A3($elm$core$String$slice, index, index + 8, source) === 'https://') ? $elm$core$Result$Ok(
		_Utils_Tuple2(1, index + 8)) : ((A3($elm$core$String$slice, index, index + 7, source) === 'http://') ? $elm$core$Result$Ok(
		_Utils_Tuple2(0, index + 7)) : $elm$core$Result$Err(0));
	if (!protocolResult.$) {
		var _v1 = protocolResult.a;
		var protocol = _v1.a;
		var protocolEnd = _v1.b;
		var urlEnd = $author$project$RichText$skipUrlChars$(
			source,
			protocolEnd,
			$elm$core$String$length(source));
		var urlBody = A3($elm$core$String$slice, protocolEnd, urlEnd, source);
		var urlBodyLen = $elm$core$String$length(urlBody);
		var protocolStr = function () {
			if (!protocol) {
				return 'http://';
			} else {
				return 'https://';
			}
		}();
		var modifierChars = $elm$core$Set$fromList(
			$elm$core$List$map$(
				function (modifier) {
					return $MartinSStewart$elm_nonempty_string$String$Nonempty$head(
						modifierToString(modifier));
				},
				modifiers));
		var _v2 = A3(
			$elm$core$String$foldl,
			F2(
				function (_char, _v3) {
					var opens = _v3.a;
					var closes = _v3.b;
					return (_char === '(') ? _Utils_Tuple2(opens + 1, closes) : ((_char === ')') ? _Utils_Tuple2(opens, closes + 1) : _Utils_Tuple2(opens, closes));
				}),
			_Utils_Tuple2(0, 0),
			urlBody);
		var openParenCount = _v2.a;
		var closeParenCount = _v2.b;
		var allowedParenTrims = (!openParenCount) ? closeParenCount : ((A3($elm$core$String$slice, index - 1, index, source) === '(') ? $elm$core$Basics$max$(0, closeParenCount - openParenCount) : 0);
		var _v4 = A3(
			$elm$core$String$foldr,
			F2(
				function (_char, _v5) {
					var idx = _v5.a;
					var parenTrims = _v5.b;
					var stop = _v5.c;
					return stop ? _Utils_Tuple3(idx, parenTrims, true) : ((_char === ')') ? ((parenTrims > 0) ? _Utils_Tuple3(idx - 1, parenTrims - 1, false) : _Utils_Tuple3(idx, parenTrims, true)) : (((_char === '.') || ((_char === ']') || ((_char === ',') || ((_char === '"') || ((_char === ':') || $elm$core$Set$member$(_char, modifierChars)))))) ? _Utils_Tuple3(idx - 1, parenTrims, false) : ((startedWithAngleBracket && (_char === '>')) ? _Utils_Tuple3(idx - 1, parenTrims, true) : _Utils_Tuple3(idx, parenTrims, true))));
				}),
			_Utils_Tuple3(urlBodyLen, allowedParenTrims, false),
			urlBody);
		var trimIdx = _v4.a;
		var urlText = _Utils_ap(
			protocolStr,
			A3($elm$core$String$slice, 0, trimIdx, urlBody));
		var _v6 = $elm$url$Url$fromString(urlText);
		if (!_v6.$) {
			var url = _v6.a;
			var url2 = _Utils_update(
				url,
				{protocol: protocol});
			var urlNoPath = _Utils_update(
				url2,
				{path: ''});
			return _Utils_eq(
				$elm$url$Url$toString(urlNoPath),
				urlText) ? $elm$core$Result$Ok(urlNoPath) : $elm$core$Result$Ok(url2);
		} else {
			return $elm$core$Result$Err(urlText);
		}
	} else {
		return $elm$core$Result$Err('h');
	}
};
var $author$project$RichText$parseUrlBody = F5($author$project$RichText$parseUrlBody$);
var $author$project$RichText$shrugEmoticon = '¯\u005C_(ツ)_/¯';
var $author$project$RichText$isMonthStart = function (c) {
	return (c === 'J') || ((c === 'F') || ((c === 'M') || ((c === 'A') || ((c === 'S') || ((c === 'O') || ((c === 'N') || (c === 'D')))))));
};
var $author$project$RichText$skipNormalChars$ = function (source, index) {
	skipNormalChars:
	while (true) {
		if (_Utils_cmp(
			index,
			$elm$core$String$length(source)) > -1) {
			return index;
		} else {
			var c = A3($elm$core$String$slice, index, index + 1, source);
			if ((c === '[') || ((c === '@') || ((c === '#') || ((c === 'h') || ((c === '`') || ((c === '\u005C') || ((c === '*') || ((c === '_') || ((c === '~') || ((c === '|') || ((c === '\u000A') || ((c === '❓') || ((c === '¯') || $author$project$RichText$isMonthStart(c)))))))))))))) {
				return index;
			} else {
				var $temp$index = index + 1;
				index = $temp$index;
				continue skipNormalChars;
			}
		}
	}
};
var $author$project$RichText$skipNormalChars = F2($author$project$RichText$skipNormalChars$);
var $author$project$RichText$starBulletMarker$ = function (source, index) {
	return _Utils_eq(
		$author$project$RichText$stringAtRange$(index, 2, source),
		$elm$core$Maybe$Just('* ')) ? $elm$core$Maybe$Just(2) : $elm$core$Maybe$Nothing;
};
var $author$project$RichText$starBulletMarker = F2($author$project$RichText$starBulletMarker$);
var $author$project$RichText$tryMatchChannel$ = function (channels, remaining) {
	return $elm$core$List$head(
		$elm$core$List$filterMap$(
			function (_v1) {
				var key = _v1.a;
				var channel = _v1.b;
				return A2($elm$core$String$startsWith, channel.name, remaining) ? $elm$core$Maybe$Just(
					_Utils_Tuple2(
						key,
						$elm$core$String$length(channel.name))) : $elm$core$Maybe$Nothing;
			},
			A2(
				$elm$core$List$sortBy,
				function (_v0) {
					var channel = _v0.b;
					return -$elm$core$String$length(channel.name);
				},
				$lamdera$containers$SeqDict$toList(channels))));
};
var $author$project$RichText$tryMatchChannel = F2($author$project$RichText$tryMatchChannel$);
var $author$project$RichText$tryMatchUser$ = function (users, remaining) {
	return $elm$core$List$head(
		$elm$core$List$filterMap$(
			function (_v1) {
				var userId = _v1.a;
				var user = _v1.b;
				var name = $author$project$PersonName$toString(user.name);
				return A2($elm$core$String$startsWith, name, remaining) ? $elm$core$Maybe$Just(
					_Utils_Tuple2(
						userId,
						$elm$core$String$length(name))) : $elm$core$Maybe$Nothing;
			},
			A2(
				$elm$core$List$sortBy,
				function (_v0) {
					var user = _v0.b;
					return -$elm$core$String$length(
						$author$project$PersonName$toString(user.name));
				},
				$lamdera$containers$SeqDict$toList(users))));
};
var $author$project$RichText$tryMatchUser = F2($author$project$RichText$tryMatchUser$);
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysBeforeMonth$ = function (y, m) {
	var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
	switch (m) {
		case 0:
			return 0;
		case 1:
			return 31;
		case 2:
			return 59 + leapDays;
		case 3:
			return 90 + leapDays;
		case 4:
			return 120 + leapDays;
		case 5:
			return 151 + leapDays;
		case 6:
			return 181 + leapDays;
		case 7:
			return 212 + leapDays;
		case 8:
			return 243 + leapDays;
		case 9:
			return 273 + leapDays;
		case 10:
			return 304 + leapDays;
		default:
			return 334 + leapDays;
	}
};
var $justinmimbs$date$Date$daysBeforeMonth = F2($justinmimbs$date$Date$daysBeforeMonth$);
var $justinmimbs$date$Date$floorDiv$ = function (a, b) {
	return $elm$core$Basics$floor(a / b);
};
var $justinmimbs$date$Date$floorDiv = F2($justinmimbs$date$Date$floorDiv$);
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = ($justinmimbs$date$Date$floorDiv$(y, 4) - $justinmimbs$date$Date$floorDiv$(y, 100)) + $justinmimbs$date$Date$floorDiv$(y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$daysInMonth$ = function (y, m) {
	switch (m) {
		case 0:
			return 31;
		case 1:
			return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
		case 2:
			return 31;
		case 3:
			return 30;
		case 4:
			return 31;
		case 5:
			return 30;
		case 6:
			return 31;
		case 7:
			return 31;
		case 8:
			return 30;
		case 9:
			return 31;
		case 10:
			return 30;
		default:
			return 31;
	}
};
var $justinmimbs$date$Date$daysInMonth = F2($justinmimbs$date$Date$daysInMonth$);
var $justinmimbs$date$Date$fromCalendarDate$ = function (y, m, d) {
	return ($justinmimbs$date$Date$daysBeforeYear(y) + $justinmimbs$date$Date$daysBeforeMonth$(y, m)) + $elm$core$Basics$clamp$(
		1,
		$justinmimbs$date$Date$daysInMonth$(y, m),
		d);
};
var $justinmimbs$date$Date$fromCalendarDate = F3($justinmimbs$date$Date$fromCalendarDate$);
var $author$project$TimeInMinutes$minutesPerDay = 1440;
var $author$project$TimeInMinutes$rataDieEpoch = 719163;
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0;
	return rd;
};
var $author$project$TimeInMinutes$minutesFromDateAndTime = function (_v0) {
	var minute = _v0.minute;
	var hour = _v0.hour;
	var day = _v0.day;
	var month = _v0.month;
	var year = _v0.year;
	return ((($justinmimbs$date$Date$toRataDie(
		$justinmimbs$date$Date$fromCalendarDate$(year, month, day)) - $author$project$TimeInMinutes$rataDieEpoch) * $author$project$TimeInMinutes$minutesPerDay) + (hour * 60)) + minute;
};
var $lamdera$program_test$Effect$Time$toDay$ = function (zone, time) {
	return $elm$time$Time$toDay$(zone, time);
};
var $lamdera$program_test$Effect$Time$toDay = F2($lamdera$program_test$Effect$Time$toDay$);
var $lamdera$program_test$Effect$Time$toHour$ = function (zone, time) {
	return $elm$time$Time$toHour$(zone, time);
};
var $lamdera$program_test$Effect$Time$toHour = F2($lamdera$program_test$Effect$Time$toHour$);
var $lamdera$program_test$Effect$Time$toMinute$ = function (zone, time) {
	return $elm$time$Time$toMinute$(zone, time);
};
var $lamdera$program_test$Effect$Time$toMinute = F2($lamdera$program_test$Effect$Time$toMinute$);
var $lamdera$program_test$Effect$Time$toMonth = $elm$time$Time$toMonth;
var $lamdera$program_test$Effect$Time$toYear$ = function (zone, time) {
	return $elm$time$Time$toYear$(zone, time);
};
var $lamdera$program_test$Effect$Time$toYear = F2($lamdera$program_test$Effect$Time$toYear$);
var $author$project$TimeInMinutes$toDateAndTime$ = function (timezone, time) {
	var time2 = $author$project$TimeInMinutes$toTime(time);
	return {
		day: $lamdera$program_test$Effect$Time$toDay$(timezone, time2),
		hour: $lamdera$program_test$Effect$Time$toHour$(timezone, time2),
		minute: $lamdera$program_test$Effect$Time$toMinute$(timezone, time2),
		month: A2($lamdera$program_test$Effect$Time$toMonth, timezone, time2),
		year: $lamdera$program_test$Effect$Time$toYear$(timezone, time2)
	};
};
var $author$project$TimeInMinutes$toDateAndTime = F2($author$project$TimeInMinutes$toDateAndTime$);
var $author$project$TimeInMinutes$offsetMinutes$ = function (timezone, time) {
	var minutes = time;
	return $author$project$TimeInMinutes$minutesFromDateAndTime(
		$author$project$TimeInMinutes$toDateAndTime$(timezone, time)) - minutes;
};
var $author$project$TimeInMinutes$offsetMinutes = F2($author$project$TimeInMinutes$offsetMinutes$);
var $author$project$TimeInMinutes$fromDateAndTime$ = function (timezone, dateAndTime) {
	var readAsUtc = $author$project$TimeInMinutes$minutesFromDateAndTime(dateAndTime);
	var firstGuess = readAsUtc - $author$project$TimeInMinutes$offsetMinutes$(timezone, readAsUtc);
	return readAsUtc - $author$project$TimeInMinutes$offsetMinutes$(timezone, firstGuess);
};
var $author$project$TimeInMinutes$fromDateAndTime = F2($author$project$TimeInMinutes$fromDateAndTime$);
var $author$project$MyUi$allMonths = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
var $author$project$RichText$tryParseMonth$ = function (source, index) {
	return $elm$core$List$head(
		$elm$core$List$filterMap$(
			function (month) {
				var name = $author$project$MyUi$monthToString(month);
				var afterMonth = (index + $elm$core$String$length(name)) + 1;
				return _Utils_eq(
					A3($elm$core$String$slice, index, afterMonth, source),
					name + ' ') ? $elm$core$Maybe$Just(
					_Utils_Tuple2(month, afterMonth)) : $elm$core$Maybe$Nothing;
			},
			$author$project$MyUi$allMonths));
};
var $author$project$RichText$tryParseMonth = F2($author$project$RichText$tryParseMonth$);
var $author$project$RichText$tryParseTimestamp$ = function (timezone, source, index) {
	var len = $elm$core$String$length(source);
	var _v0 = $author$project$RichText$tryParseMonth$(source, index);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var month = _v1.a;
		var afterMonth = _v1.b;
		var dayEnd = $author$project$RichText$skipDigits$(source, afterMonth, len);
		var yearStart = dayEnd + 2;
		var yearEnd = $author$project$RichText$skipDigits$(source, yearStart, len);
		var hourStart = yearEnd + 4;
		if ((_Utils_cmp(dayEnd, afterMonth) > 0) && ((A3($elm$core$String$slice, dayEnd, yearStart, source) === ', ') && ((_Utils_cmp(yearEnd, yearStart) > 0) && ((A3($elm$core$String$slice, yearEnd, hourStart, source) === ' at ') && (_Utils_eq(
			$author$project$RichText$stringAt$(hourStart + 2, source),
			$elm$core$Maybe$Just(':')) && (_Utils_cmp(hourStart + 5, len) < 1)))))) {
			var _v2 = _Utils_Tuple2(
				_Utils_Tuple2(
					$elm$core$String$toInt(
						A3($elm$core$String$slice, afterMonth, dayEnd, source)),
					$elm$core$String$toInt(
						A3($elm$core$String$slice, yearStart, yearEnd, source))),
				_Utils_Tuple2(
					$elm$core$String$toInt(
						A3($elm$core$String$slice, hourStart, hourStart + 2, source)),
					$elm$core$String$toInt(
						A3($elm$core$String$slice, hourStart + 3, hourStart + 5, source))));
			if ((((!_v2.a.a.$) && (!_v2.a.b.$)) && (!_v2.b.a.$)) && (!_v2.b.b.$)) {
				var _v3 = _v2.a;
				var day = _v3.a.a;
				var year = _v3.b.a;
				var _v4 = _v2.b;
				var hour = _v4.a.a;
				var minute = _v4.b.a;
				var time = $author$project$TimeInMinutes$fromDateAndTime$(
					timezone,
					{day: day, hour: hour, minute: minute, month: month, year: year});
				var endIndex = hourStart + 5;
				return _Utils_eq(
					$author$project$RichText$dateAndTimeToString$(timezone, time),
					A3($elm$core$String$slice, index, endIndex, source)) ? $elm$core$Maybe$Just(
					_Utils_Tuple2(time, endIndex)) : $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$RichText$tryParseTimestamp = F3($author$project$RichText$tryParseTimestamp$);
var $author$project$RichText$parseBlockQuoteContent$ = function (timezone, users, channels, content) {
	var _v30 = $mgold$elm_nonempty_list$List$Nonempty$fromList(
		$author$project$RichText$parseLoop$(timezone, content, 0, users, channels, _List_Nil, '', _List_Nil).nodes);
	if (!_v30.$) {
		var nonempty = _v30.a;
		return $mgold$elm_nonempty_list$List$Nonempty$toList(
			$author$project$RichText$normalize(nonempty));
	} else {
		return _List_Nil;
	}
};
var $author$project$RichText$parseBlockQuoteContent = F4($author$project$RichText$parseBlockQuoteContent$);
var $author$project$RichText$parseHeadingContent$ = function (timezone, users, channels, content) {
	var _v29 = $mgold$elm_nonempty_list$List$Nonempty$fromList(
		$author$project$RichText$parseLoop$(
			timezone,
			$MartinSStewart$elm_nonempty_string$String$Nonempty$toString(content),
			0,
			users,
			channels,
			_List_Nil,
			'',
			_List_Nil).nodes);
	if (!_v29.$) {
		var nonempty = _v29.a;
		return $author$project$RichText$normalize(nonempty);
	} else {
		return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
			$author$project$RichText$NormalText$(
				$MartinSStewart$elm_nonempty_string$String$Nonempty$head(content),
				$MartinSStewart$elm_nonempty_string$String$Nonempty$tail(content)),
			_List_Nil);
	}
};
var $author$project$RichText$parseHeadingContent = F4($author$project$RichText$parseHeadingContent$);
var $author$project$RichText$parseInner$ = function (timezone, source, index, users, channels, modifiers) {
	return $author$project$RichText$parseLoop$(timezone, source, index, users, channels, modifiers, '', _List_Nil);
};
var $author$project$RichText$parseInner = F6($author$project$RichText$parseInner$);
var $author$project$RichText$parseLoop$ = function (timezone, source, index, users, channels, modifiers, accText, revNodes) {
	parseLoop:
	while (true) {
		if (_Utils_cmp(
			index,
			$elm$core$String$length(source)) > -1) {
			return $author$project$RichText$finalizeResult$($author$project$RichText$modifierToSymbol, accText, revNodes, modifiers, index);
		} else {
			var _v0 = A3($elm$core$String$slice, index, index + 1, source);
			switch (_v0) {
				case '❓':
					var _v1 = $author$project$RichText$parseCustomEmojiId$(index + 1, source);
					if (!_v1.b.$) {
						var index2 = _v1.a;
						var customEmojiId = _v1.b.a;
						var $temp$index = index2,
							$temp$accText = '',
							$temp$revNodes = A2(
							$elm$core$List$cons,
							$author$project$RichText$CustomEmoji(customEmojiId),
							$author$project$RichText$flushText$(accText, revNodes));
						index = $temp$index;
						accText = $temp$accText;
						revNodes = $temp$revNodes;
						continue parseLoop;
					} else {
						var _v2 = _v1.b;
						var $temp$index = index + 1,
							$temp$accText = accText + '❓';
						index = $temp$index;
						accText = $temp$accText;
						continue parseLoop;
					}
				case '\u000A':
					if ($elm$core$List$isEmpty(modifiers)) {
						var _v3 = $author$project$RichText$extractBlockQuote$(source, index + 1);
						if (!_v3.$) {
							var _v4 = _v3.a;
							var content = _v4.a;
							var endIndex = _v4.b;
							var $temp$index = endIndex,
								$temp$accText = '',
								$temp$revNodes = A2(
								$elm$core$List$cons,
								$author$project$RichText$BlockQuote$(
									0,
									$author$project$RichText$parseBlockQuoteContent$(timezone, users, channels, content)),
								$author$project$RichText$flushText$(accText, revNodes));
							index = $temp$index;
							accText = $temp$accText;
							revNodes = $temp$revNodes;
							continue parseLoop;
						} else {
							var _v5 = $author$project$RichText$extractHeading$(source, index + 1);
							if (!_v5.$) {
								var _v6 = _v5.a;
								var level = _v6.a;
								var content = _v6.b;
								var endIndex = _v6.c;
								var $temp$index = endIndex,
									$temp$accText = '',
									$temp$revNodes = A2(
									$elm$core$List$cons,
									$author$project$RichText$Heading$(
										level,
										0,
										$author$project$RichText$parseHeadingContent$(timezone, users, channels, content)),
									$author$project$RichText$flushText$(accText, revNodes));
								index = $temp$index;
								accText = $temp$accText;
								revNodes = $temp$revNodes;
								continue parseLoop;
							} else {
								var _v7 = $author$project$RichText$extractBulletPoint$(
									$author$project$RichText$starBulletMarker,
									A3($author$project$RichText$parseBlockQuoteContent, timezone, users, channels),
									source,
									index + 1);
								if (!_v7.$) {
									var bullet = _v7.a;
									var $temp$index = bullet.endIndex,
										$temp$accText = '',
										$temp$revNodes = $author$project$RichText$bulletRevNodes$(
										$author$project$RichText$BulletPoint$(0, bullet.items),
										bullet.trailing,
										$author$project$RichText$flushText$(accText, revNodes));
									index = $temp$index;
									accText = $temp$accText;
									revNodes = $temp$revNodes;
									continue parseLoop;
								} else {
									var _v8 = $author$project$RichText$parseStickerId$(index + 1, source);
									if (!_v8.b.$) {
										var index2 = _v8.a;
										var stickerId = _v8.b.a;
										var $temp$index = index2,
											$temp$accText = '',
											$temp$revNodes = A2(
											$elm$core$List$cons,
											$author$project$RichText$Sticker(stickerId),
											$author$project$RichText$flushText$(accText, revNodes));
										index = $temp$index;
										accText = $temp$accText;
										revNodes = $temp$revNodes;
										continue parseLoop;
									} else {
										var _v9 = _v8.b;
										var $temp$index = index + 1,
											$temp$accText = accText + '\u000A';
										index = $temp$index;
										accText = $temp$accText;
										continue parseLoop;
									}
								}
							}
						}
					} else {
						var $temp$index = index + 1,
							$temp$accText = accText + '\u000A';
						index = $temp$index;
						accText = $temp$accText;
						continue parseLoop;
					}
				case '¯':
					if (_Utils_eq(
						A3(
							$elm$core$String$slice,
							index,
							index + $elm$core$String$length($author$project$RichText$shrugEmoticon),
							source),
						$author$project$RichText$shrugEmoticon)) {
						var $temp$index = index + $elm$core$String$length($author$project$RichText$shrugEmoticon),
							$temp$accText = '',
							$temp$revNodes = A2(
							$elm$core$List$cons,
							$author$project$RichText$NormalText$('¯', '\u005C_(ツ)_/¯'),
							$author$project$RichText$flushText$(accText, revNodes));
						index = $temp$index;
						accText = $temp$accText;
						revNodes = $temp$revNodes;
						continue parseLoop;
					} else {
						var $temp$index = index + 1,
							$temp$accText = accText + '¯';
						index = $temp$index;
						accText = $temp$accText;
						continue parseLoop;
					}
				case '\u005C':
					var afterBackslash = index + 1;
					var _v10 = $author$project$RichText$stringAt$(afterBackslash, source);
					if (!_v10.$) {
						var nextChar = _v10.a;
						var _v11 = $elm$core$Dict$get$(nextChar, $author$project$RichText$charToEscaped);
						if (!_v11.$) {
							var escaped = _v11.a;
							var $temp$index = afterBackslash + 1,
								$temp$accText = '',
								$temp$revNodes = A2(
								$elm$core$List$cons,
								$author$project$RichText$EscapedChar(escaped),
								$author$project$RichText$flushText$(accText, revNodes));
							index = $temp$index;
							accText = $temp$accText;
							revNodes = $temp$revNodes;
							continue parseLoop;
						} else {
							var $temp$index = afterBackslash,
								$temp$accText = accText + '\u005C';
							index = $temp$index;
							accText = $temp$accText;
							continue parseLoop;
						}
					} else {
						var $temp$index = afterBackslash,
							$temp$accText = accText + '\u005C';
						index = $temp$index;
						accText = $temp$accText;
						continue parseLoop;
					}
				case '@':
					var afterAt = index + 1;
					var remaining = A3(
						$elm$core$String$slice,
						afterAt,
						$elm$core$String$length(source),
						source);
					var _v12 = $author$project$RichText$tryMatchUser$(users, remaining);
					if (!_v12.$) {
						var _v13 = _v12.a;
						var userId = _v13.a;
						var matchLen = _v13.b;
						var $temp$index = afterAt + matchLen,
							$temp$accText = '',
							$temp$revNodes = A2(
							$elm$core$List$cons,
							$author$project$RichText$UserMention(userId),
							$author$project$RichText$flushText$(accText, revNodes));
						index = $temp$index;
						accText = $temp$accText;
						revNodes = $temp$revNodes;
						continue parseLoop;
					} else {
						var $temp$index = afterAt,
							$temp$accText = accText + '@';
						index = $temp$index;
						accText = $temp$accText;
						continue parseLoop;
					}
				case '#':
					var afterHash = index + 1;
					var _v14 = $author$project$RichText$tryMatchChannel$(
						channels,
						A3(
							$elm$core$String$slice,
							afterHash,
							$elm$core$String$length(source),
							source));
					if (!_v14.$) {
						var _v15 = _v14.a;
						var _v16 = _v15.a;
						var channel = _v16.a;
						var maybeThread = _v16.b;
						var matchLen = _v15.b;
						var $temp$index = afterHash + matchLen,
							$temp$accText = '',
							$temp$revNodes = A2(
							$elm$core$List$cons,
							$author$project$RichText$ChannelMention$(channel, maybeThread),
							$author$project$RichText$flushText$(accText, revNodes));
						index = $temp$index;
						accText = $temp$accText;
						revNodes = $temp$revNodes;
						continue parseLoop;
					} else {
						var $temp$index = afterHash,
							$temp$accText = accText + '#';
						index = $temp$index;
						accText = $temp$accText;
						continue parseLoop;
					}
				case '*':
					var afterSymbol = index + 1;
					if (_Utils_eq(
						$elm$core$List$head(modifiers),
						$elm$core$Maybe$Just(0))) {
						return $author$project$RichText$closeModifier$(
							afterSymbol,
							accText,
							revNodes,
							$author$project$RichText$Bold,
							$author$project$RichText$modifierToSymbol(0));
					} else {
						if ($elm$core$List$member$(0, modifiers)) {
							return $author$project$RichText$finalizeResult$($author$project$RichText$modifierToSymbol, accText, revNodes, modifiers, index);
						} else {
							var nextChar = A3($elm$core$String$slice, afterSymbol, afterSymbol + 1, source);
							if ((nextChar === '*') || (nextChar === ' ')) {
								var $temp$index = afterSymbol,
									$temp$accText = accText + '*';
								index = $temp$index;
								accText = $temp$accText;
								continue parseLoop;
							} else {
								var inner = $author$project$RichText$parseInner$(
									timezone,
									source,
									afterSymbol,
									users,
									channels,
									A2($elm$core$List$cons, 0, modifiers));
								var flushed = $author$project$RichText$flushText$(accText, revNodes);
								var newRevNodes = $elm$core$List$foldl$(
									F2(
										function (node, acc) {
											return A2($elm$core$List$cons, node, acc);
										}),
									flushed,
									inner.nodes);
								var $temp$index = inner.nextIndex,
									$temp$accText = '',
									$temp$revNodes = newRevNodes;
								index = $temp$index;
								accText = $temp$accText;
								revNodes = $temp$revNodes;
								continue parseLoop;
							}
						}
					}
				case '_':
					if (A3($elm$core$String$slice, index, index + 4, source) === '____') {
						var $temp$index = index + 4,
							$temp$accText = accText + '____';
						index = $temp$index;
						accText = $temp$accText;
						continue parseLoop;
					} else {
						if (A3($elm$core$String$slice, index, index + 2, source) === '__') {
							var afterSymbol = index + 2;
							if (_Utils_eq(
								$elm$core$List$head(modifiers),
								$elm$core$Maybe$Just(2))) {
								return $author$project$RichText$closeModifier$(
									afterSymbol,
									accText,
									revNodes,
									$author$project$RichText$Underline,
									$author$project$RichText$modifierToSymbol(2));
							} else {
								if ($elm$core$List$member$(2, modifiers)) {
									return $author$project$RichText$finalizeResult$($author$project$RichText$modifierToSymbol, accText, revNodes, modifiers, index);
								} else {
									var inner = $author$project$RichText$parseInner$(
										timezone,
										source,
										afterSymbol,
										users,
										channels,
										A2($elm$core$List$cons, 2, modifiers));
									var flushed = $author$project$RichText$flushText$(accText, revNodes);
									var newRevNodes = $elm$core$List$foldl$(
										F2(
											function (node, acc) {
												return A2($elm$core$List$cons, node, acc);
											}),
										flushed,
										inner.nodes);
									var $temp$index = inner.nextIndex,
										$temp$accText = '',
										$temp$revNodes = newRevNodes;
									index = $temp$index;
									accText = $temp$accText;
									revNodes = $temp$revNodes;
									continue parseLoop;
								}
							}
						} else {
							var afterSymbol = index + 1;
							if (_Utils_eq(
								$elm$core$List$head(modifiers),
								$elm$core$Maybe$Just(1))) {
								return $author$project$RichText$closeModifier$(
									afterSymbol,
									accText,
									revNodes,
									$author$project$RichText$Italic,
									$author$project$RichText$modifierToSymbol(1));
							} else {
								if ($elm$core$List$member$(1, modifiers)) {
									return $author$project$RichText$finalizeResult$($author$project$RichText$modifierToSymbol, accText, revNodes, modifiers, index);
								} else {
									var inner = $author$project$RichText$parseInner$(
										timezone,
										source,
										afterSymbol,
										users,
										channels,
										A2($elm$core$List$cons, 1, modifiers));
									var flushed = $author$project$RichText$flushText$(accText, revNodes);
									var newRevNodes = $elm$core$List$foldl$(
										F2(
											function (node, acc) {
												return A2($elm$core$List$cons, node, acc);
											}),
										flushed,
										inner.nodes);
									var $temp$index = inner.nextIndex,
										$temp$accText = '',
										$temp$revNodes = newRevNodes;
									index = $temp$index;
									accText = $temp$accText;
									revNodes = $temp$revNodes;
									continue parseLoop;
								}
							}
						}
					}
				case '~':
					if ((!_Utils_eq(
						$elm$core$List$head(modifiers),
						$elm$core$Maybe$Just(3))) && (A3($elm$core$String$slice, index, index + 4, source) === '~~~~')) {
						var $temp$index = index + 4,
							$temp$accText = accText + '~~~~';
						index = $temp$index;
						accText = $temp$accText;
						continue parseLoop;
					} else {
						if (A3($elm$core$String$slice, index, index + 2, source) === '~~') {
							var afterSymbol = index + 2;
							if (_Utils_eq(
								$elm$core$List$head(modifiers),
								$elm$core$Maybe$Just(3))) {
								return $author$project$RichText$closeModifier$(
									afterSymbol,
									accText,
									revNodes,
									$author$project$RichText$Strikethrough,
									$author$project$RichText$modifierToSymbol(3));
							} else {
								if ($elm$core$List$member$(3, modifiers)) {
									return $author$project$RichText$finalizeResult$($author$project$RichText$modifierToSymbol, accText, revNodes, modifiers, index);
								} else {
									var inner = $author$project$RichText$parseInner$(
										timezone,
										source,
										afterSymbol,
										users,
										channels,
										A2($elm$core$List$cons, 3, modifiers));
									var flushed = $author$project$RichText$flushText$(accText, revNodes);
									var newRevNodes = $elm$core$List$foldl$(
										F2(
											function (node, acc) {
												return A2($elm$core$List$cons, node, acc);
											}),
										flushed,
										inner.nodes);
									var $temp$index = inner.nextIndex,
										$temp$accText = '',
										$temp$revNodes = newRevNodes;
									index = $temp$index;
									accText = $temp$accText;
									revNodes = $temp$revNodes;
									continue parseLoop;
								}
							}
						} else {
							var $temp$index = index + 1,
								$temp$accText = accText + '~';
							index = $temp$index;
							accText = $temp$accText;
							continue parseLoop;
						}
					}
				case '|':
					if ((!_Utils_eq(
						$elm$core$List$head(modifiers),
						$elm$core$Maybe$Just(4))) && (A3($elm$core$String$slice, index, index + 4, source) === '||||')) {
						var $temp$index = index + 4,
							$temp$accText = accText + '||||';
						index = $temp$index;
						accText = $temp$accText;
						continue parseLoop;
					} else {
						if (A3($elm$core$String$slice, index, index + 2, source) === '||') {
							var afterSymbol = index + 2;
							if (_Utils_eq(
								$elm$core$List$head(modifiers),
								$elm$core$Maybe$Just(4))) {
								return $author$project$RichText$closeModifier$(
									afterSymbol,
									accText,
									revNodes,
									$author$project$RichText$Spoiler,
									$author$project$RichText$modifierToSymbol(4));
							} else {
								if ($elm$core$List$member$(4, modifiers)) {
									return $author$project$RichText$finalizeResult$($author$project$RichText$modifierToSymbol, accText, revNodes, modifiers, index);
								} else {
									var inner = $author$project$RichText$parseInner$(
										timezone,
										source,
										afterSymbol,
										users,
										channels,
										A2($elm$core$List$cons, 4, modifiers));
									var flushed = $author$project$RichText$flushText$(accText, revNodes);
									var newRevNodes = $elm$core$List$foldl$(
										F2(
											function (node, acc) {
												return A2($elm$core$List$cons, node, acc);
											}),
										flushed,
										inner.nodes);
									var $temp$index = inner.nextIndex,
										$temp$accText = '',
										$temp$revNodes = newRevNodes;
									index = $temp$index;
									accText = $temp$accText;
									revNodes = $temp$revNodes;
									continue parseLoop;
								}
							}
						} else {
							var $temp$index = index + 1,
								$temp$accText = accText + '|';
							index = $temp$index;
							accText = $temp$accText;
							continue parseLoop;
						}
					}
				case '`':
					var _v17 = _Utils_Tuple2(
						$author$project$RichText$stringAtRange$(index, 3, source),
						$author$project$RichText$findSubstring$(source, index + 3, '```'));
					if (((!_v17.a.$) && (_v17.a.a === '```')) && (!_v17.b.$)) {
						var closeIndex = _v17.b.a;
						var content = A3($elm$core$String$slice, index + 3, closeIndex, source);
						var _v18 = $author$project$RichText$parseCodeBlockContent(content);
						var language = _v18.a;
						var codeContent = _v18.b;
						var _v19 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(codeContent);
						if (!_v19.$) {
							var $temp$index = closeIndex + 3,
								$temp$accText = '',
								$temp$revNodes = A2(
								$elm$core$List$cons,
								$author$project$RichText$CodeBlock$(language, codeContent),
								$author$project$RichText$flushText$(accText, revNodes));
							index = $temp$index;
							accText = $temp$accText;
							revNodes = $temp$revNodes;
							continue parseLoop;
						} else {
							var $temp$index = closeIndex + 3,
								$temp$accText = accText + '``````';
							index = $temp$index;
							accText = $temp$accText;
							continue parseLoop;
						}
					} else {
						var _v20 = $author$project$RichText$findSingleBacktick$(source, index + 1);
						if (!_v20.$) {
							var closeIndex = _v20.a;
							var content = A3($elm$core$String$slice, index + 1, closeIndex, source);
							var _v21 = _Utils_Tuple2(
								$MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(content),
								A2($elm$core$String$contains, '\u000A', content));
							if ((!_v21.a.$) && (!_v21.b)) {
								var a = _v21.a.a;
								var $temp$index = closeIndex + 1,
									$temp$accText = '',
									$temp$revNodes = A2(
									$elm$core$List$cons,
									$author$project$RichText$InlineCode$(
										$MartinSStewart$elm_nonempty_string$String$Nonempty$head(a),
										$MartinSStewart$elm_nonempty_string$String$Nonempty$tail(a)),
									$author$project$RichText$flushText$(accText, revNodes));
								index = $temp$index;
								accText = $temp$accText;
								revNodes = $temp$revNodes;
								continue parseLoop;
							} else {
								var $temp$index = index + 1,
									$temp$accText = accText + '`';
								index = $temp$index;
								accText = $temp$accText;
								continue parseLoop;
							}
						} else {
							var $temp$index = index + 1,
								$temp$accText = accText + '`';
							index = $temp$index;
							accText = $temp$accText;
							continue parseLoop;
						}
					}
				case 'h':
					var _v22 = $author$project$RichText$parseUrlBody$(false, $author$project$RichText$modifierToSymbol, modifiers, index, source);
					if (!_v22.$) {
						var url = _v22.a;
						var $temp$index = index + $elm$core$String$length(
							$elm$url$Url$toString(url)),
							$temp$accText = '',
							$temp$revNodes = A2(
							$elm$core$List$cons,
							$author$project$RichText$Hyperlink(url),
							$author$project$RichText$flushText$(accText, revNodes));
						index = $temp$index;
						accText = $temp$accText;
						revNodes = $temp$revNodes;
						continue parseLoop;
					} else {
						var errText = _v22.a;
						var $temp$index = index + $elm$core$String$length(errText),
							$temp$accText = _Utils_ap(accText, errText);
						index = $temp$index;
						accText = $temp$accText;
						continue parseLoop;
					}
				case '[':
					if (A3($elm$core$String$slice, index, index + 2, source) === '[!') {
						var _v23 = $author$project$RichText$parseFileId$(source, index + 2);
						if (!_v23.$) {
							var _v24 = _v23.a;
							var fileId = _v24.a;
							var nextIndex = _v24.b;
							var $temp$index = nextIndex,
								$temp$accText = '',
								$temp$revNodes = A2(
								$elm$core$List$cons,
								$author$project$RichText$AttachedFile(
									$author$project$Id$fromInt(fileId)),
								$author$project$RichText$flushText$(accText, revNodes));
							index = $temp$index;
							accText = $temp$accText;
							revNodes = $temp$revNodes;
							continue parseLoop;
						} else {
							var $temp$index = index + 1,
								$temp$accText = accText + '[';
							index = $temp$index;
							accText = $temp$accText;
							continue parseLoop;
						}
					} else {
						var _v25 = $author$project$RichText$parseMarkdownLink$(false, source, index + 1);
						if (!_v25.$) {
							var _v26 = _v25.a;
							var alias = _v26.a;
							var url = _v26.b;
							var nextIndex = _v26.c;
							var $temp$index = nextIndex,
								$temp$accText = '',
								$temp$revNodes = A2(
								$elm$core$List$cons,
								$author$project$RichText$MarkdownLink$(alias, url),
								$author$project$RichText$flushText$(accText, revNodes));
							index = $temp$index;
							accText = $temp$accText;
							revNodes = $temp$revNodes;
							continue parseLoop;
						} else {
							var $temp$index = index + 1,
								$temp$accText = accText + '[';
							index = $temp$index;
							accText = $temp$accText;
							continue parseLoop;
						}
					}
				default:
					var _v27 = $author$project$RichText$tryParseTimestamp$(timezone, source, index);
					if (!_v27.$) {
						var _v28 = _v27.a;
						var time = _v28.a;
						var timeEndIndex = _v28.b;
						var $temp$index = timeEndIndex,
							$temp$accText = '',
							$temp$revNodes = A2(
							$elm$core$List$cons,
							$author$project$RichText$Timestamp(time),
							$author$project$RichText$flushText$(accText, revNodes));
						index = $temp$index;
						accText = $temp$accText;
						revNodes = $temp$revNodes;
						continue parseLoop;
					} else {
						var nextIndex = $author$project$RichText$skipNormalChars$(source, index + 1);
						var $temp$index = nextIndex,
							$temp$accText = _Utils_ap(
							accText,
							A3($elm$core$String$slice, index, nextIndex, source));
						index = $temp$index;
						accText = $temp$accText;
						continue parseLoop;
					}
			}
		}
	}
};
var $author$project$RichText$parseLoop = F8($author$project$RichText$parseLoop$);
var $author$project$RichText$fromNonemptyString$ = function (timezone, users, channels, string) {
	var source = $MartinSStewart$elm_nonempty_string$String$Nonempty$toString(string);
	var _v0 = function () {
		var _v1 = $author$project$RichText$extractBlockQuote$(source, 0);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var content = _v2.a;
			var endIndex = _v2.b;
			return _Utils_Tuple2(
				endIndex,
				_List_fromArray(
					[
						$author$project$RichText$BlockQuote$(
						1,
						$author$project$RichText$parseBlockQuoteContent$(timezone, users, channels, content))
					]));
		} else {
			var _v3 = $author$project$RichText$extractHeading$(source, 0);
			if (!_v3.$) {
				var _v4 = _v3.a;
				var level = _v4.a;
				var content = _v4.b;
				var endIndex = _v4.c;
				return _Utils_Tuple2(
					endIndex,
					_List_fromArray(
						[
							$author$project$RichText$Heading$(
							level,
							1,
							$author$project$RichText$parseHeadingContent$(timezone, users, channels, content))
						]));
			} else {
				var _v5 = $author$project$RichText$extractBulletPoint$(
					$author$project$RichText$starBulletMarker,
					A3($author$project$RichText$parseBlockQuoteContent, timezone, users, channels),
					source,
					0);
				if (!_v5.$) {
					var bullet = _v5.a;
					return _Utils_Tuple2(
						bullet.endIndex,
						$author$project$RichText$bulletRevNodes$(
							$author$project$RichText$BulletPoint$(1, bullet.items),
							bullet.trailing,
							_List_Nil));
				} else {
					return _Utils_Tuple2(0, _List_Nil);
				}
			}
		}
	}();
	var startIndex = _v0.a;
	var startRevNodes = _v0.b;
	var result = $author$project$RichText$parseLoop$(timezone, source, startIndex, users, channels, _List_Nil, '', startRevNodes);
	var _v6 = $mgold$elm_nonempty_list$List$Nonempty$fromList(result.nodes);
	if (!_v6.$) {
		var nonempty = _v6.a;
		return $author$project$RichText$normalize(nonempty);
	} else {
		return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
			$author$project$RichText$normalTextFromNonempty(string),
			_List_Nil);
	}
};
var $author$project$RichText$fromNonemptyString = F4($author$project$RichText$fromNonemptyString$);
var $author$project$FrontendExtra$textToRichText$ = function (text, memberIds, channels, local) {
	var allUsers = $author$project$User$allUsers(local.localUser);
	return $author$project$RichText$fromNonemptyString$(
		local.localUser.timezone,
		$elm$core$List$foldl$(
			F2(
				function (memberId, dict) {
					var _v0 = $lamdera$containers$SeqDict$get$(memberId, allUsers);
					if (!_v0.$) {
						var member = _v0.a;
						return $lamdera$containers$SeqDict$insert$(memberId, member, dict);
					} else {
						return dict;
					}
				}),
			$lamdera$containers$SeqDict$empty,
			memberIds),
		channels,
		text);
};
var $author$project$FrontendExtra$textToRichText = F4($author$project$FrontendExtra$textToRichText$);
var $author$project$FrontendExtra$editMessage$ = function (time, userId, guildOrDmId, newContent, attachedFiles, threadRoute, local) {
	if (!guildOrDmId.$) {
		var channelId = guildOrDmId.a.channelId;
		var guildId = guildOrDmId.a.guildId;
		return _Utils_update(
			local,
			{
				guilds: $lamdera$containers$SeqDict$updateIfExists$(
					guildId,
					function (guild) {
						return $author$project$LocalState$updateChannel$(
							function (channel) {
								return $elm$core$Result$withDefault$(
									channel,
									$author$project$LocalState$editMessageFrontendHelper$(
										time,
										userId,
										$author$project$FrontendExtra$textToRichText$(
											newContent,
											$author$project$MembersAndOwner$membersAndOwner(guild.membersAndOwner),
											$author$project$LocalState$guildChannelMentions$(local.localUser, guild.channels),
											local),
										$author$project$Message$ChangeAttachments(attachedFiles),
										threadRoute,
										channel));
							},
							channelId,
							guild);
					},
					local.guilds)
			});
	} else {
		var otherUserId = guildOrDmId.a.otherUserId;
		return _Utils_update(
			local,
			{
				dmChannels: $lamdera$containers$SeqDict$updateIfExists$(
					otherUserId,
					function (dmChannel) {
						return $elm$core$Result$withDefault$(
							dmChannel,
							$author$project$LocalState$editMessageFrontendHelper$(
								time,
								userId,
								$author$project$FrontendExtra$textToRichText$(
									newContent,
									_List_fromArray(
										[local.localUser.session.userId, otherUserId]),
									$lamdera$containers$SeqDict$empty,
									local),
								$author$project$Message$ChangeAttachments(attachedFiles),
								threadRoute,
								dmChannel));
					},
					local.dmChannels)
			});
	}
};
var $author$project$FrontendExtra$editMessage = F7($author$project$FrontendExtra$editMessage$);
var $author$project$OneToOne$OneToOne$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$OneToOne$OneToOne = F2($author$project$OneToOne$OneToOne$);
var $author$project$OneToOne$empty = $author$project$OneToOne$OneToOne$($lamdera$containers$SeqDict$empty, $lamdera$containers$SeqDict$empty);
var $author$project$Message$toEncrypted$ = function (fileHashes, encryptedData, message) {
	switch (message.$) {
		case 0:
			var data = message.a;
			return $author$project$Message$EncryptedUserTextMessage(
				{content: encryptedData, createdAt: data.createdAt, createdBy: data.createdBy, drawings: data.drawings, editedAt: data.editedAt, fileHashes: fileHashes, reactions: data.reactions, repliedTo: data.repliedTo});
		case 1:
			return message;
		case 2:
			return message;
		case 3:
			return message;
		case 4:
			return message;
		default:
			return message;
	}
};
var $author$project$Message$toEncrypted = F3($author$project$Message$toEncrypted$);
var $author$project$FrontendExtra$encryptOldMessages$ = function (messages, dmChannel) {
	return $elm$core$List$foldl$(
		F2(
			function (_v0, channel) {
				var threadRoute = _v0.a;
				var fileHashes = _v0.b;
				var encryptedData = _v0.c;
				if (!threadRoute.$) {
					var messageId = threadRoute.a;
					return _Utils_update(
						channel,
						{
							messages: $author$project$MessageArray$updateIfExists$(
								messageId,
								A2($author$project$Message$toEncrypted, fileHashes, encryptedData),
								channel.messages)
						});
				} else {
					var threadId = threadRoute.a;
					var messageId = threadRoute.b;
					return _Utils_update(
						channel,
						{
							threads: $lamdera$containers$SeqDict$updateIfExists$(
								threadId,
								function (thread) {
									return _Utils_update(
										thread,
										{
											messages: $author$project$MessageArray$updateIfExists$(
												messageId,
												A2($author$project$Message$toEncrypted, fileHashes, encryptedData),
												thread.messages)
										});
								},
								channel.threads)
						});
				}
			}),
		dmChannel,
		messages);
};
var $author$project$FrontendExtra$encryptOldMessages = F2($author$project$FrontendExtra$encryptOldMessages$);
var $lamdera$containers$SeqDict$singleton$ = function (key, val) {
	return $lamdera$containers$SeqDict$insert$(key, val, $lamdera$containers$SeqDict$empty);
};
var $lamdera$containers$SeqDict$singleton = F2($lamdera$containers$SeqDict$singleton$);
var $lamdera$containers$SeqSet$singleton = function (k) {
	return $lamdera$containers$SeqDict$singleton$(k, true);
};
var $author$project$UserSession$expandUserOptionSection$ = function (section, _v0, session) {
	var collapseOthers = _v0.collapseOthers;
	return _Utils_update(
		session,
		{
			expandedUserOptions: collapseOthers ? $lamdera$containers$SeqSet$singleton(section) : $lamdera$containers$SeqSet$insert$(section, session.expandedUserOptions)
		});
};
var $author$project$UserSession$expandUserOptionSection = F3($author$project$UserSession$expandUserOptionSection$);
var $author$project$LocalState$finishedUploadingCallRecordingFrontend$ = function (messageId, userId, channel) {
	return _Utils_update(
		channel,
		{
			messages: $author$project$MessageArray$updateIfExists$(
				messageId,
				function (message) {
					if (message.$ === 4) {
						var callStarted = message.a;
						var _v1 = callStarted.recordings;
						if (!_v1.$) {
							var recording = _v1.a;
							return $author$project$Message$CallStarted(
								_Utils_update(
									callStarted,
									{
										recordings: $elm$core$Maybe$Just(
											_Utils_update(
												recording,
												{
													finishedUploading: $lamdera$containers$SeqSet$insert$(userId, recording.finishedUploading)
												}))
									}));
						} else {
							return message;
						}
					} else {
						return message;
					}
				},
				channel.messages)
		});
};
var $author$project$LocalState$finishedUploadingCallRecordingFrontend = F3($author$project$LocalState$finishedUploadingCallRecordingFrontend$);
var $author$project$LocalState$forgetEditTyping$ = function (editedBy, channelId, threadRoute, lastTypedAt) {
	var _v0 = $lamdera$containers$SeqDict$get$(editedBy, lastTypedAt);
	if (!_v0.$) {
		var typing = _v0.a;
		return (_Utils_eq(typing.channelId, channelId) && _Utils_eq(
			typing.threadRoute,
			$author$project$Id$threadRouteWithJustMessage(threadRoute))) ? $lamdera$containers$SeqDict$remove$(editedBy, lastTypedAt) : lastTypedAt;
	} else {
		return lastTypedAt;
	}
};
var $author$project$LocalState$forgetEditTyping = F4($author$project$LocalState$forgetEditTyping$);
var $author$project$NonemptyDict$fromNonemptyList = function (_v0) {
	var _v1 = _v0.a;
	var id = _v1.a;
	var a = _v1.b;
	var rest = _v0.b;
	return $elm$core$List$foldl$(
		F2(
			function (_v2, dict) {
				var k = _v2.a;
				var v = _v2.b;
				return $author$project$NonemptyDict$insert$(k, v, dict);
			}),
		$author$project$NonemptyDict$singleton$(id, a),
		rest);
};
var $author$project$NonemptyDict$fromList = function (list) {
	return $elm$core$Maybe$map$(
		$author$project$NonemptyDict$fromNonemptyList,
		$mgold$elm_nonempty_list$List$Nonempty$fromList(list));
};
var $author$project$NonemptyDict$fromSeqDict = function (dict) {
	return $author$project$NonemptyDict$fromList(
		$lamdera$containers$SeqDict$toList(dict));
};
var $author$project$ChannelName$fromStringLossy = function (text) {
	var _v0 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(
		A2(
			$elm$core$String$filter,
			function (_char) {
				return !((_char === '\n') || (_char === '\r'));
			},
			$elm$core$String$left$(
				$author$project$ChannelName$maxLength,
				$elm$core$String$trim(text))));
	if (!_v0.$) {
		var nonempty = _v0.a;
		return nonempty;
	} else {
		return $MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('e', 'mpty');
	}
};
var $author$project$FrontendExtra$frontendDmChannel$ = function (id, local) {
	return $elm$core$Maybe$withDefault$(
		$author$project$DmChannel$frontendInit,
		$lamdera$containers$SeqDict$get$(id.otherUserId, local.dmChannels));
};
var $author$project$FrontendExtra$frontendDmChannel = F2($author$project$FrontendExtra$frontendDmChannel$);
var $author$project$Game$GameData_Go$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Game$GameData_Go = F2($author$project$Game$GameData_Go$);
var $author$project$Game$GameData_SheepGame$ = function (a, b, c) {
	return {$: 2, a: a, b: b, c: c};
};
var $author$project$Game$GameData_SheepGame = F3($author$project$Game$GameData_SheepGame$);
var $author$project$Game$GameData_WordSpellingGame$ = function (a, b, c) {
	return {$: 1, a: a, b: b, c: c};
};
var $author$project$Game$GameData_WordSpellingGame = F3($author$project$Game$GameData_WordSpellingGame$);
var $author$project$Message$GameType_Go = 0;
var $author$project$Message$GameType_SheepGame = 2;
var $author$project$Message$GameType_WordSpellingGame = 1;
var $author$project$Game$addGoAction$ = function (action, matchData) {
	if (!matchData.$) {
		var matchData2 = matchData.a;
		return $author$project$Game$MatchData(
			_Utils_update(
				matchData2,
				{
					data: function () {
						var _v1 = matchData2.data;
						if (!_v1.$) {
							var setup = _v1.a;
							var actions = _v1.b;
							var cache = _v1.c;
							return $author$project$Game$FrontendGameData_Go$(
								setup,
								$elm$core$Array$push$(action, actions),
								$author$project$Go$updateAction$(setup, action, cache));
						} else {
							return matchData2.data;
						}
					}()
				}));
	} else {
		return matchData;
	}
};
var $author$project$Game$addGoAction = F2($author$project$Game$addGoAction$);
var $author$project$Game$addPublicLink$ = function (publicLink, matchData) {
	if (!matchData.$) {
		var matchData2 = matchData.a;
		return $author$project$Game$MatchData(
			_Utils_update(
				matchData2,
				{
					publicLink: $elm$core$Maybe$Just(publicLink)
				}));
	} else {
		return matchData;
	}
};
var $author$project$Game$addPublicLink = F2($author$project$Game$addPublicLink$);
var $author$project$SheepGame$Answering = 0;
var $author$project$SheepGame$Grouping = 1;
var $author$project$SheepGame$Revealing = 2;
var $elm$time$Time$utc = $elm$time$Time$Zone$(0, _List_Nil);
var $lamdera$program_test$Effect$Time$utc = $elm$time$Time$utc;
var $author$project$SheepGame$answerKey = function (answer) {
	return $elm$core$String$toLower(
		$elm$core$String$trim(
			$author$project$RichText$toString$($lamdera$program_test$Effect$Time$utc, false, $lamdera$containers$SeqDict$empty, $lamdera$containers$SeqDict$empty, answer.text)));
};
var $elm$core$List$partition$ = function (pred, list) {
	var step = F2(
		function (x, _v0) {
			var trues = _v0.a;
			var falses = _v0.b;
			return pred(x) ? _Utils_Tuple2(
				A2($elm$core$List$cons, x, trues),
				falses) : _Utils_Tuple2(
				trues,
				A2($elm$core$List$cons, x, falses));
		});
	return $elm$core$List$foldr$(
		step,
		_Utils_Tuple2(_List_Nil, _List_Nil),
		list);
};
var $elm$core$List$partition = F2($elm$core$List$partition$);
var $elmcraft$core_extra$List$Extra$gatherWith$ = function (testFn, list) {
	var helper = F2(
		function (scattered, gathered) {
			helper:
			while (true) {
				if (!scattered.b) {
					return $elm$core$List$reverse(gathered);
				} else {
					var toGather = scattered.a;
					var population = scattered.b;
					var _v1 = $elm$core$List$partition$(
						testFn(toGather),
						population);
					var gathering = _v1.a;
					var remaining = _v1.b;
					var $temp$scattered = remaining,
						$temp$gathered = A2(
						$elm$core$List$cons,
						_Utils_Tuple2(toGather, gathering),
						gathered);
					scattered = $temp$scattered;
					gathered = $temp$gathered;
					continue helper;
				}
			}
		});
	return A2(helper, list, _List_Nil);
};
var $elmcraft$core_extra$List$Extra$gatherWith = F2($elmcraft$core_extra$List$Extra$gatherWith$);
var $elmcraft$core_extra$List$Extra$gatherEqualsBy$ = function (extract, list) {
	return $elmcraft$core_extra$List$Extra$gatherWith$(
		F2(
			function (a, b) {
				return _Utils_eq(
					extract(a),
					extract(b));
			}),
		list);
};
var $elmcraft$core_extra$List$Extra$gatherEqualsBy = F2($elmcraft$core_extra$List$Extra$gatherEqualsBy$);
var $author$project$IdArray$get$ = function (key, _v0) {
	var array = _v0;
	return $elm$core$Array$get$(
		$author$project$Id$toInt(key),
		array);
};
var $author$project$IdArray$get = F2($author$project$IdArray$get$);
var $author$project$SheepGame$groupLabel = function (index) {
	return $elm$core$String$fromChar(
		$elm$core$Char$fromCode(
			$elm$core$Char$toCode('a') + A2($elm$core$Basics$modBy, 26, index)));
};
var $mgold$elm_nonempty_list$List$Nonempty$length = function (_v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return $elm$core$List$length(xs) + 1;
};
var $author$project$SheepGame$autoGroup$ = function (setup, answers) {
	return $lamdera$containers$SeqDict$fromList(
		$elm$core$List$concatMap$(
			function (questionIndex) {
				var questionId = $author$project$Id$fromInt(questionIndex);
				return $elm$core$List$concat(
					$elm$core$List$indexedMap$(
						F2(
							function (groupIndex, _v2) {
								var first = _v2.a;
								var rest = _v2.b;
								return $elm$core$List$map$(
									function (_v3) {
										var userId = _v3.a;
										return _Utils_Tuple2(
											_Utils_Tuple2(userId, questionId),
											$author$project$SheepGame$groupLabel(groupIndex));
									},
									A2($elm$core$List$cons, first, rest));
							}),
						$elmcraft$core_extra$List$Extra$gatherEqualsBy$(
							$elm$core$Tuple$second,
							$elm$core$List$filterMap$(
								function (_v0) {
									var userId = _v0.a;
									var userAnswers = _v0.b;
									var _v1 = $author$project$IdArray$get$(questionId, userAnswers);
									if ((!_v1.$) && (!_v1.a.$)) {
										var answer = _v1.a.a;
										return $elm$core$Maybe$Just(
											_Utils_Tuple2(
												userId,
												$author$project$SheepGame$answerKey(answer)));
									} else {
										return $elm$core$Maybe$Nothing;
									}
								},
								$lamdera$containers$SeqDict$toList(answers)))));
			},
			$elm$core$List$range$(
				0,
				$mgold$elm_nonempty_list$List$Nonempty$length(setup.questions) - 1)));
};
var $author$project$SheepGame$autoGroup = F2($author$project$SheepGame$autoGroup$);
var $author$project$IdArray$fromArray = $elm$core$Basics$identity;
var $author$project$SheepGame$isHost$ = function (userId, setup) {
	return _Utils_eq(userId, setup.createdBy);
};
var $author$project$SheepGame$isHost = F2($author$project$SheepGame$isHost$);
var $elmcraft$core_extra$Array$Extra$update$ = function (index, alter, array) {
	var _v0 = $elm$core$Array$get$(index, array);
	if (_v0.$ === 1) {
		return array;
	} else {
		var element = _v0.a;
		return $elm$core$Array$set$(
			index,
			alter(element),
			array);
	}
};
var $elmcraft$core_extra$Array$Extra$update = F3($elmcraft$core_extra$Array$Extra$update$);
var $author$project$IdArray$update$ = function (key, updateFunc, _v0) {
	var array = _v0;
	return $elmcraft$core_extra$Array$Extra$update$(
		$author$project$Id$toInt(key),
		updateFunc,
		array);
};
var $author$project$IdArray$update = F3($author$project$IdArray$update$);
var $author$project$SheepGame$mapReactions$ = function (target, mapFunc, shared) {
	if (!target.$) {
		var userId = target.a;
		var questionId = target.b;
		return _Utils_update(
			shared,
			{
				answers: $lamdera$containers$SeqDict$updateIfExists$(
					userId,
					A2(
						$author$project$IdArray$update,
						questionId,
						$elm$core$Maybe$map(
							function (answer) {
								return _Utils_update(
									answer,
									{
										reactions: mapFunc(answer.reactions)
									});
							})),
					shared.answers)
			});
	} else {
		var questionId = target.a;
		return _Utils_update(
			shared,
			{
				notes: $lamdera$containers$SeqDict$updateIfExists$(
					questionId,
					$elm$core$Maybe$map(
						function (notes) {
							return _Utils_update(
								notes,
								{
									reactions: mapFunc(notes.reactions)
								});
						}),
					shared.notes)
			});
	}
};
var $author$project$SheepGame$mapReactions = F3($author$project$SheepGame$mapReactions$);
var $author$project$NonemptySet$fromNonemptyList = function (_v0) {
	var id = _v0.a;
	var rest = _v0.b;
	return $elm$core$List$foldl$(
		F2(
			function (k, set) {
				return $author$project$NonemptySet$insert$(k, set);
			}),
		$author$project$NonemptySet$singleton(id),
		rest);
};
var $author$project$NonemptySet$fromList = function (list) {
	return $elm$core$Maybe$map$(
		$author$project$NonemptySet$fromNonemptyList,
		$mgold$elm_nonempty_list$List$Nonempty$fromList(list));
};
var $author$project$NonemptySet$fromSeqSet = function (set) {
	return $author$project$NonemptySet$fromList(
		$lamdera$containers$SeqSet$toList(set));
};
var $author$project$NonemptySet$toSeqSet = function (_v0) {
	var id = _v0.a;
	var idSet = _v0.b;
	return $lamdera$containers$SeqSet$insert$(id, idSet);
};
var $author$project$SheepGame$removeFromReactions$ = function (emoji, userId, reactions) {
	return $lamdera$containers$SeqDict$update$(
		emoji,
		$elm$core$Maybe$andThen(
			function (users) {
				return $author$project$NonemptySet$fromSeqSet(
					$lamdera$containers$SeqSet$remove$(
						userId,
						$author$project$NonemptySet$toSeqSet(users)));
			}),
		reactions);
};
var $author$project$SheepGame$removeFromReactions = F3($author$project$SheepGame$removeFromReactions$);
var $author$project$SheepGame$revealStepCount = function (setup) {
	return $mgold$elm_nonempty_list$List$Nonempty$length(setup.questions) + 1;
};
var $author$project$IdArray$set$ = function (key, value, _v0) {
	var array = _v0;
	return $elm$core$Array$set$(
		$author$project$Id$toInt(key),
		value,
		array);
};
var $author$project$IdArray$set = F3($author$project$IdArray$set$);
var $author$project$SheepGame$updateAction$ = function (setup, action, shared) {
	var _v0 = action.change;
	switch (_v0.$) {
		case 0:
			var questionId = _v0.a;
			var answer = _v0.b;
			var _v1 = shared.phase;
			if (!_v1) {
				return _Utils_update(
					shared,
					{
						answers: $lamdera$containers$SeqDict$update$(
							action.userId,
							function (answers) {
								return $elm$core$Maybe$Just(
									$author$project$IdArray$set$(
										questionId,
										answer,
										$elm$core$Maybe$withDefault$(
											$author$project$IdArray$fromArray(
												$elm$core$Array$initialize$(
													$mgold$elm_nonempty_list$List$Nonempty$length(setup.questions),
													function (_v2) {
														return $elm$core$Maybe$Nothing;
													})),
											answers)));
							},
							shared.answers)
					});
			} else {
				return shared;
			}
		case 1:
			var _v3 = _Utils_Tuple2(
				shared.phase,
				$author$project$SheepGame$isHost$(action.userId, setup));
			if ((!_v3.a) && _v3.b) {
				var _v4 = _v3.a;
				return _Utils_update(
					shared,
					{
						groups: $author$project$SheepGame$autoGroup$(setup, shared.answers),
						phase: 1
					});
			} else {
				return shared;
			}
		case 2:
			var _v5 = _Utils_Tuple2(
				shared.phase,
				$author$project$SheepGame$isHost$(action.userId, setup));
			if ((_v5.a === 1) && _v5.b) {
				var _v6 = _v5.a;
				return _Utils_update(
					shared,
					{phase: 0});
			} else {
				return shared;
			}
		case 3:
			var userId = _v0.a;
			var questionIndex = _v0.b;
			var group = _v0.c;
			var _v7 = _Utils_Tuple2(
				shared.phase,
				$author$project$SheepGame$isHost$(action.userId, setup));
			if ((_v7.a === 1) && _v7.b) {
				var _v8 = _v7.a;
				return _Utils_update(
					shared,
					{
						groups: $lamdera$containers$SeqDict$insert$(
							_Utils_Tuple2(userId, questionIndex),
							group,
							shared.groups)
					});
			} else {
				return shared;
			}
		case 4:
			var questionId = _v0.a;
			var notes = _v0.b;
			var _v9 = _Utils_Tuple2(
				shared.phase,
				$author$project$SheepGame$isHost$(action.userId, setup));
			_v9$0:
			while (true) {
				if (_v9.b) {
					if (!_v9.a) {
						break _v9$0;
					} else {
						return _Utils_update(
							shared,
							{
								notes: $lamdera$containers$SeqDict$insert$(questionId, notes, shared.notes)
							});
					}
				} else {
					if (!_v9.a) {
						break _v9$0;
					} else {
						return shared;
					}
				}
			}
			var _v10 = _v9.a;
			return shared;
		case 5:
			var _v11 = _Utils_Tuple2(
				shared.phase,
				$author$project$SheepGame$isHost$(action.userId, setup));
			if ((_v11.a === 1) && _v11.b) {
				var _v12 = _v11.a;
				return _Utils_update(
					shared,
					{phase: 2, questionsRevealed: 0});
			} else {
				return shared;
			}
		case 7:
			var target = _v0.a;
			var emoji = _v0.b;
			return $author$project$SheepGame$mapReactions$(
				target,
				A2($author$project$SeqDictHelper$addToSet, emoji, action.userId),
				shared);
		case 8:
			var target = _v0.a;
			var emoji = _v0.b;
			return $author$project$SheepGame$mapReactions$(
				target,
				A2($author$project$SheepGame$removeFromReactions, emoji, action.userId),
				shared);
		default:
			var count = _v0.a;
			var _v13 = _Utils_Tuple2(
				shared.phase,
				$author$project$SheepGame$isHost$(action.userId, setup));
			if ((_v13.a === 2) && _v13.b) {
				var _v14 = _v13.a;
				return _Utils_update(
					shared,
					{
						questionsRevealed: $elm$core$Basics$clamp$(
							0,
							$author$project$SheepGame$revealStepCount(setup),
							$author$project$Id$toInt(count))
					});
			} else {
				return shared;
			}
	}
};
var $author$project$SheepGame$updateAction = F3($author$project$SheepGame$updateAction$);
var $author$project$Game$addSheepGameAction$ = function (action, matchData) {
	if (!matchData.$) {
		var matchData2 = matchData.a;
		return $author$project$Game$MatchData(
			_Utils_update(
				matchData2,
				{
					data: function () {
						var _v1 = matchData2.data;
						if (_v1.$ === 2) {
							var setup = _v1.a;
							var actions = _v1.b;
							var cache = _v1.c;
							return $author$project$Game$FrontendGameData_SheepGame$(
								setup,
								$elm$core$Array$push$(action, actions),
								$author$project$SheepGame$updateAction$(setup, action, cache));
						} else {
							return matchData2.data;
						}
					}()
				}));
	} else {
		return matchData;
	}
};
var $author$project$Game$addSheepGameAction = F2($author$project$Game$addSheepGameAction$);
var $author$project$WordSpellingGame$Description_EndedGame = function (a) {
	return {$: 4, a: a};
};
var $author$project$WordSpellingGame$Description_Joined = function (a) {
	return {$: 5, a: a};
};
var $author$project$WordSpellingGame$Description_Passed = function (a) {
	return {$: 3, a: a};
};
var $author$project$WordSpellingGame$Description_ReplacedTray = function (a) {
	return {$: 2, a: a};
};
var $author$project$WordSpellingGame$IsNotValid = {$: 1};
var $author$project$WordSpellingGame$canJoin = function (shared) {
	return _Utils_cmp(
		shared.turnCount,
		$mgold$elm_nonempty_list$List$Nonempty$length(shared.players)) < 1;
};
var $author$project$IdArray$fromList = function (list) {
	return $elm$core$Array$fromList(list);
};
var $elm$random$Random$Seed$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $elm$random$Random$Seed = F2($elm$random$Random$Seed$);
var $elm$random$Random$next = function (_v0) {
	var state0 = _v0.a;
	var incr = _v0.b;
	return $elm$random$Random$Seed$(((state0 * 1664525) + incr) >>> 0, incr);
};
var $elm$random$Random$initialSeed = function (x) {
	var _v0 = $elm$random$Random$next(
		$elm$random$Random$Seed$(0, 1013904223));
	var state1 = _v0.a;
	var incr = _v0.b;
	var state2 = (state1 + x) >>> 0;
	return $elm$random$Random$next(
		$elm$random$Random$Seed$(state2, incr));
};
var $author$project$OneOrGreater$decrement = function (_v0) {
	var a = _v0;
	return (a > 1) ? $elm$core$Maybe$Just(a - 1) : $elm$core$Maybe$Nothing;
};
var $author$project$SeqDictHelper$decrement$ = function (key, dict) {
	return $lamdera$containers$SeqDict$update$(
		key,
		function (maybe) {
			if (!maybe.$) {
				var value = maybe.a;
				return $author$project$OneOrGreater$decrement(value);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		dict);
};
var $author$project$SeqDictHelper$decrement = F2($author$project$SeqDictHelper$decrement$);
var $author$project$IdArray$foldl$ = function (foldFunc, startingValue, _v0) {
	var array = _v0;
	return $elm$core$Array$foldl$(foldFunc, startingValue, array);
};
var $author$project$IdArray$foldl = F3($author$project$IdArray$foldl$);
var $author$project$WordSpellingGame$remainingLettersInBag$ = function (setup, board, players) {
	var remainingLetters = $lamdera$containers$SeqDict$foldl$(
		F3(
			function (_v0, letter, startingLetters2) {
				return $author$project$SeqDictHelper$decrement$(letter, startingLetters2);
			}),
		$lamdera$containers$SeqDict$map$(
			F2(
				function (_v1, a) {
					return a.count;
				}),
			$author$project$NonemptyDict$toSeqDict(setup.letters)),
		board);
	return $elm$core$List$foldl$(
		F2(
			function (player, remainingLetters2) {
				return $author$project$IdArray$foldl$($author$project$SeqDictHelper$decrement, remainingLetters2, player.tray);
			}),
		remainingLetters,
		players);
};
var $author$project$WordSpellingGame$remainingLettersInBag = F3($author$project$WordSpellingGame$remainingLettersInBag$);
var $elm$core$List$repeatHelp$ = function (result, n, value) {
	repeatHelp:
	while (true) {
		if (n <= 0) {
			return result;
		} else {
			var $temp$result = A2($elm$core$List$cons, value, result),
				$temp$n = n - 1;
			result = $temp$result;
			n = $temp$n;
			continue repeatHelp;
		}
	}
};
var $elm$core$List$repeatHelp = F3($elm$core$List$repeatHelp$);
var $elm$core$List$repeat$ = function (n, value) {
	return $elm$core$List$repeatHelp$(_List_Nil, n, value);
};
var $elm$core$List$repeat = F2($elm$core$List$repeat$);
var $elm$random$Random$Generator = $elm$core$Basics$identity;
var $elm$random$Random$peel = function (_v0) {
	var state = _v0.a;
	var word = (state ^ (state >>> ((state >>> 28) + 4))) * 277803737;
	return ((word >>> 22) ^ word) >>> 0;
};
var $elm$random$Random$int$ = function (a, b) {
	return function (seed0) {
		var _v0 = (_Utils_cmp(a, b) < 0) ? _Utils_Tuple2(a, b) : _Utils_Tuple2(b, a);
		var lo = _v0.a;
		var hi = _v0.b;
		var range = (hi - lo) + 1;
		if (!((range - 1) & range)) {
			return _Utils_Tuple2(
				(((range - 1) & $elm$random$Random$peel(seed0)) >>> 0) + lo,
				$elm$random$Random$next(seed0));
		} else {
			var threshhold = (((-range) >>> 0) % range) >>> 0;
			var accountForBias = function (seed) {
				accountForBias:
				while (true) {
					var x = $elm$random$Random$peel(seed);
					var seedN = $elm$random$Random$next(seed);
					if (_Utils_cmp(x, threshhold) < 0) {
						var $temp$seed = seedN;
						seed = $temp$seed;
						continue accountForBias;
					} else {
						return _Utils_Tuple2((x % range) + lo, seedN);
					}
				}
			};
			return accountForBias(seed0);
		}
	};
};
var $elm$random$Random$int = F2($elm$random$Random$int$);
var $elm$random$Random$map3$ = function (func, _v0, _v1, _v2) {
	var genA = _v0;
	var genB = _v1;
	var genC = _v2;
	return function (seed0) {
		var _v3 = genA(seed0);
		var a = _v3.a;
		var seed1 = _v3.b;
		var _v4 = genB(seed1);
		var b = _v4.a;
		var seed2 = _v4.b;
		var _v5 = genC(seed2);
		var c = _v5.a;
		var seed3 = _v5.b;
		return _Utils_Tuple2(
			A3(func, a, b, c),
			seed3);
	};
};
var $elm$random$Random$map3 = F4($elm$random$Random$map3$);
var $elm$random$Random$step$ = function (_v0, seed) {
	var generator = _v0;
	return generator(seed);
};
var $elm$random$Random$step = F2($elm$random$Random$step$);
var $elm$random$Random$independentSeed = function (seed0) {
	var makeIndependentSeed = F3(
		function (state, b, c) {
			return $elm$random$Random$next(
				$elm$random$Random$Seed$(state, (1 | (b ^ c)) >>> 0));
		});
	var gen = $elm$random$Random$int$(0, 4294967295);
	return $elm$random$Random$step$(
		$elm$random$Random$map3$(makeIndependentSeed, gen, gen, gen),
		seed0);
};
var $elm$random$Random$map$ = function (func, _v0) {
	var genA = _v0;
	return function (seed0) {
		var _v1 = genA(seed0);
		var a = _v1.a;
		var seed1 = _v1.b;
		return _Utils_Tuple2(
			func(a),
			seed1);
	};
};
var $elm$random$Random$map = F2($elm$random$Random$map$);
var $elm$random$Random$maxInt = 2147483647;
var $elm$random$Random$minInt = -2147483648;
var $author$project$WordSpellingGame$shuffle = function (list) {
	return $elm$random$Random$map$(
		function (independentSeed) {
			return $elm$core$List$map$(
				$elm$core$Tuple$first,
				A2(
					$elm$core$List$sortBy,
					$elm$core$Tuple$second,
					$elm$core$List$foldl$(
						F2(
							function (item, _v0) {
								var acc = _v0.a;
								var seed = _v0.b;
								var _v1 = $elm$random$Random$step$(
									$elm$random$Random$int$($elm$random$Random$minInt, $elm$random$Random$maxInt),
									seed);
								var tag = _v1.a;
								var nextSeed = _v1.b;
								return _Utils_Tuple2(
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(item, tag),
										acc),
									nextSeed);
							}),
						_Utils_Tuple2(_List_Nil, independentSeed),
						list).a));
		},
		$elm$random$Random$independentSeed);
};
var $author$project$WordSpellingGame$getLetters$ = function (count, setup, board, players, turnCount) {
	return $elm$core$List$take$(
		$author$project$OneOrGreater$toInt(count),
		$elm$random$Random$step$(
			$author$project$WordSpellingGame$shuffle(
				$lamdera$containers$SeqDict$foldl$(
					F3(
						function (letter, count2, list) {
							return _Utils_ap(
								$elm$core$List$repeat$(
									$author$project$OneOrGreater$toInt(count2),
									letter),
								list);
						}),
					_List_Nil,
					$author$project$WordSpellingGame$remainingLettersInBag$(setup, board, players))),
			$elm$random$Random$initialSeed(setup.seed + turnCount)).a);
};
var $author$project$WordSpellingGame$getLetters = F5($author$project$WordSpellingGame$getLetters$);
var $author$project$WordSpellingGame$EveryonePassed = {$: 0};
var $author$project$WordSpellingGame$OutOfLetters = function (a) {
	return {$: 1, a: a};
};
var $mgold$elm_nonempty_list$List$Nonempty$filter$ = function (p, d, _v0) {
	var x = _v0.a;
	var xs = _v0.b;
	if (p(x)) {
		return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
			x,
			$elm$core$List$filter$(p, xs));
	} else {
		var _v1 = $elm$core$List$filter$(p, xs);
		if (!_v1.b) {
			return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(d, _List_Nil);
		} else {
			var y = _v1.a;
			var ys = _v1.b;
			return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(y, ys);
		}
	}
};
var $mgold$elm_nonempty_list$List$Nonempty$filter = F3($mgold$elm_nonempty_list$List$Nonempty$filter$);
var $elm$core$Array$isEmpty = function (_v0) {
	var len = _v0.a;
	return !len;
};
var $author$project$IdArray$isEmpty = function (_v0) {
	var array = _v0;
	return $elm$core$Array$isEmpty(array);
};
var $elmcraft$core_extra$List$Extra$maximumBy$ = function (f, ls) {
	var maxBy = F2(
		function (x, max) {
			var fy = max.b;
			var fx = f(x);
			return (_Utils_cmp(fx, fy) > 0) ? _Utils_Tuple2(x, fx) : max;
		});
	if (ls.b) {
		if (!ls.b.b) {
			var l_ = ls.a;
			return $elm$core$Maybe$Just(l_);
		} else {
			var l_ = ls.a;
			var ls_ = ls.b;
			return $elm$core$Maybe$Just(
				$elm$core$List$foldl$(
					maxBy,
					_Utils_Tuple2(
						l_,
						f(l_)),
					ls_).a);
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elmcraft$core_extra$List$Extra$maximumBy = F2($elmcraft$core_extra$List$Extra$maximumBy$);
var $author$project$NonemptyExtra$maximumBy$ = function (maxFunc, _v0) {
	var head = _v0.a;
	var tail = _v0.b;
	var _v1 = $elmcraft$core_extra$List$Extra$maximumBy$(
		maxFunc,
		A2($elm$core$List$cons, head, tail));
	if (!_v1.$) {
		var minimum = _v1.a;
		return minimum;
	} else {
		return head;
	}
};
var $author$project$NonemptyExtra$maximumBy = F2($author$project$NonemptyExtra$maximumBy$);
var $author$project$WordSpellingGame$getWinner = function (shared) {
	var someoneOutOfLetters = $elmcraft$core_extra$List$Extra$find$(
		function (player) {
			return $author$project$IdArray$isEmpty(player.tray);
		},
		$mgold$elm_nonempty_list$List$Nonempty$toList(shared.players));
	var getHighestScorers = function (_v2) {
		var player = $author$project$NonemptyExtra$maximumBy$(
			function ($) {
				return $.score;
			},
			shared.players);
		return $mgold$elm_nonempty_list$List$Nonempty$map$(
			function ($) {
				return $.userId;
			},
			$mgold$elm_nonempty_list$List$Nonempty$filter$(
				function (a) {
					return _Utils_eq(a.score, player.score);
				},
				player,
				shared.players));
	};
	var everyonePassed = function () {
		var _v1 = shared.passingStartedAt;
		if (!_v1.$) {
			var passingStartedAt = _v1.a;
			return _Utils_cmp(
				$mgold$elm_nonempty_list$List$Nonempty$length(shared.players),
				shared.turnCount - passingStartedAt) < 1;
		} else {
			return false;
		}
	}();
	if (!someoneOutOfLetters.$) {
		var outOfLetters = someoneOutOfLetters.a;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(
				getHighestScorers(0),
				$author$project$WordSpellingGame$OutOfLetters(outOfLetters.userId)));
	} else {
		return everyonePassed ? $elm$core$Maybe$Just(
			_Utils_Tuple2(
				getHighestScorers(0),
				$author$project$WordSpellingGame$EveryonePassed)) : $elm$core$Maybe$Nothing;
	}
};
var $author$project$WordSpellingGame$Description_InvalidMove$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$WordSpellingGame$Description_InvalidMove = F2($author$project$WordSpellingGame$Description_InvalidMove$);
var $author$project$WordSpellingGame$Description_PremoveBlocked = function (a) {
	return {$: 6, a: a};
};
var $author$project$WordSpellingGame$fullTrayBonusScore$ = function (setup, placedWord) {
	return _Utils_eq(
		$mgold$elm_nonempty_list$List$Nonempty$length(placedWord.letters),
		$author$project$OneOrGreater$toInt(setup.traySize)) ? setup.fullTrayBonus : 0;
};
var $author$project$WordSpellingGame$fullTrayBonusScore = F2($author$project$WordSpellingGame$fullTrayBonusScore$);
var $mgold$elm_nonempty_list$List$Nonempty$get$ = function (i, ne) {
	var x = ne.a;
	var xs = ne.b;
	var j = A2(
		$elm$core$Basics$modBy,
		$mgold$elm_nonempty_list$List$Nonempty$length(ne),
		i);
	var find = F2(
		function (k, ys) {
			find:
			while (true) {
				if (!ys.b) {
					return x;
				} else {
					var z = ys.a;
					var zs = ys.b;
					if (!k) {
						return z;
					} else {
						var $temp$k = k - 1,
							$temp$ys = zs;
						k = $temp$k;
						ys = $temp$ys;
						continue find;
					}
				}
			}
		});
	return (!j) ? x : A2(find, j - 1, xs);
};
var $mgold$elm_nonempty_list$List$Nonempty$get = F2($mgold$elm_nonempty_list$List$Nonempty$get$);
var $author$project$WordSpellingGame$headlineOrder = function (word) {
	return _Utils_Tuple2(
		-word.placedCount,
		-$elm$core$List$length(word.letters));
};
var $author$project$WordSpellingGame$letterOrWildcardsToString = function (letters) {
	return $elm$core$String$concat(
		$elm$core$List$map$(
			function (letterOrWildcard) {
				if (!letterOrWildcard.$) {
					var letter = letterOrWildcard.a;
					return $elm$core$String$fromChar(letter);
				} else {
					return '_';
				}
			},
			letters));
};
var $author$project$WordSpellingGame$headlineWord = function (words) {
	return $elm$core$Maybe$withDefault$(
		'a word',
		$elm$core$Maybe$map$(
			function (a) {
				return $author$project$WordSpellingGame$letterOrWildcardsToString(a.letters);
			},
			$elm$core$List$head(
				A2($elm$core$List$sortBy, $author$project$WordSpellingGame$headlineOrder, words))));
};
var $author$project$WordSpellingGame$lineWord$ = function (board, _v0, cell) {
	var dirX = _v0.a;
	var dirY = _v0.b;
	var walkForward = F2(
		function (_v1, acc) {
			walkForward:
			while (true) {
				var cx = _v1.a;
				var cy = _v1.b;
				if ($lamdera$containers$SeqDict$member$(
					_Utils_Tuple2(cx, cy),
					board)) {
					var $temp$_v1 = _Utils_Tuple2(cx + dirX, cy + dirY),
						$temp$acc = A2(
						$elm$core$List$cons,
						_Utils_Tuple2(cx, cy),
						acc);
					_v1 = $temp$_v1;
					acc = $temp$acc;
					continue walkForward;
				} else {
					return $elm$core$List$reverse(acc);
				}
			}
		});
	var walkBack = function (_v2) {
		walkBack:
		while (true) {
			var cx = _v2.a;
			var cy = _v2.b;
			var prev = _Utils_Tuple2(cx - dirX, cy - dirY);
			if ($lamdera$containers$SeqDict$member$(prev, board)) {
				var $temp$_v2 = prev;
				_v2 = $temp$_v2;
				continue walkBack;
			} else {
				return _Utils_Tuple2(cx, cy);
			}
		}
	};
	return A2(
		walkForward,
		walkBack(cell),
		_List_Nil);
};
var $author$project$WordSpellingGame$lineWord = F3($author$project$WordSpellingGame$lineWord$);
var $author$project$WordSpellingGame$CenterCell = 4;
var $author$project$WordSpellingGame$DoubleLetter = 2;
var $author$project$WordSpellingGame$DoubleWord = 0;
var $author$project$WordSpellingGame$TripleLetter = 3;
var $author$project$WordSpellingGame$TripleWord = 1;
var $author$project$WordSpellingGame$doubleLetterCells = _List_fromArray(
	[
		_Utils_Tuple2(3, 0),
		_Utils_Tuple2(11, 0),
		_Utils_Tuple2(6, 2),
		_Utils_Tuple2(8, 2),
		_Utils_Tuple2(0, 3),
		_Utils_Tuple2(7, 3),
		_Utils_Tuple2(14, 3),
		_Utils_Tuple2(2, 6),
		_Utils_Tuple2(6, 6),
		_Utils_Tuple2(8, 6),
		_Utils_Tuple2(12, 6),
		_Utils_Tuple2(3, 7),
		_Utils_Tuple2(11, 7),
		_Utils_Tuple2(2, 8),
		_Utils_Tuple2(6, 8),
		_Utils_Tuple2(8, 8),
		_Utils_Tuple2(12, 8),
		_Utils_Tuple2(0, 11),
		_Utils_Tuple2(7, 11),
		_Utils_Tuple2(14, 11),
		_Utils_Tuple2(6, 12),
		_Utils_Tuple2(8, 12),
		_Utils_Tuple2(3, 14),
		_Utils_Tuple2(11, 14)
	]);
var $author$project$WordSpellingGame$doubleWordCells = _List_fromArray(
	[
		_Utils_Tuple2(1, 1),
		_Utils_Tuple2(2, 2),
		_Utils_Tuple2(3, 3),
		_Utils_Tuple2(4, 4),
		_Utils_Tuple2(13, 1),
		_Utils_Tuple2(12, 2),
		_Utils_Tuple2(11, 3),
		_Utils_Tuple2(10, 4),
		_Utils_Tuple2(1, 13),
		_Utils_Tuple2(2, 12),
		_Utils_Tuple2(3, 11),
		_Utils_Tuple2(4, 10),
		_Utils_Tuple2(13, 13),
		_Utils_Tuple2(12, 12),
		_Utils_Tuple2(11, 11),
		_Utils_Tuple2(10, 10)
	]);
var $author$project$WordSpellingGame$tripleLetterCells = _List_fromArray(
	[
		_Utils_Tuple2(5, 1),
		_Utils_Tuple2(9, 1),
		_Utils_Tuple2(1, 5),
		_Utils_Tuple2(5, 5),
		_Utils_Tuple2(9, 5),
		_Utils_Tuple2(13, 5),
		_Utils_Tuple2(1, 9),
		_Utils_Tuple2(5, 9),
		_Utils_Tuple2(9, 9),
		_Utils_Tuple2(13, 9),
		_Utils_Tuple2(5, 13),
		_Utils_Tuple2(9, 13)
	]);
var $author$project$WordSpellingGame$tripleWordCells = _List_fromArray(
	[
		_Utils_Tuple2(0, 0),
		_Utils_Tuple2(7, 0),
		_Utils_Tuple2(14, 0),
		_Utils_Tuple2(0, 7),
		_Utils_Tuple2(14, 7),
		_Utils_Tuple2(0, 14),
		_Utils_Tuple2(7, 14),
		_Utils_Tuple2(14, 14)
	]);
var $author$project$WordSpellingGame$bonusCells = $lamdera$containers$SeqDict$fromList(
	A2(
		$elm$core$List$cons,
		_Utils_Tuple2(
			_Utils_Tuple2(7, 7),
			4),
		_Utils_ap(
			$elm$core$List$map$(
				function (position) {
					return _Utils_Tuple2(position, 1);
				},
				$author$project$WordSpellingGame$tripleWordCells),
			_Utils_ap(
				$elm$core$List$map$(
					function (position) {
						return _Utils_Tuple2(position, 0);
					},
					$author$project$WordSpellingGame$doubleWordCells),
				_Utils_ap(
					$elm$core$List$map$(
						function (position) {
							return _Utils_Tuple2(position, 3);
						},
						$author$project$WordSpellingGame$tripleLetterCells),
					$elm$core$List$map$(
						function (position) {
							return _Utils_Tuple2(position, 2);
						},
						$author$project$WordSpellingGame$doubleLetterCells))))));
var $author$project$WordSpellingGame$letterScoreMultiplier = function (position) {
	var _v0 = $lamdera$containers$SeqDict$get$(position, $author$project$WordSpellingGame$bonusCells);
	_v0$2:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 2:
					var _v1 = _v0.a;
					return 2;
				case 3:
					var _v2 = _v0.a;
					return 3;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return 1;
};
var $author$project$WordSpellingGame$Letter = function (a) {
	return {$: 0, a: a};
};
var $author$project$WordSpellingGame$letterValue$ = function (setup, letter) {
	var _v0 = $author$project$NonemptyDict$get$(
		$author$project$WordSpellingGame$Letter(letter),
		setup.letters);
	if (!_v0.$) {
		var data = _v0.a;
		return data.value;
	} else {
		return 0;
	}
};
var $author$project$WordSpellingGame$letterValue = F2($author$project$WordSpellingGame$letterValue$);
var $elm$core$List$product = function (numbers) {
	return $elm$core$List$foldl$($elm$core$Basics$mul, 1, numbers);
};
var $author$project$WordSpellingGame$wordScoreMultiplier = function (position) {
	var _v0 = $lamdera$containers$SeqDict$get$(position, $author$project$WordSpellingGame$bonusCells);
	_v0$3:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 0:
					var _v1 = _v0.a;
					return 2;
				case 1:
					var _v2 = _v0.a;
					return 3;
				case 4:
					var _v3 = _v0.a;
					return 2;
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return 1;
};
var $author$project$WordSpellingGame$wordScore$ = function (setup, board, placedSet, cells) {
	var wordMultiplier = $elm$core$List$product(
		$elm$core$List$map$(
			function (cell) {
				return $elm$core$Set$member$(cell, placedSet) ? $author$project$WordSpellingGame$wordScoreMultiplier(cell) : 1;
			},
			cells));
	var letterSum = $elm$core$List$sum(
		$elm$core$List$map$(
			function (cell) {
				var _v0 = $lamdera$containers$SeqDict$get$(cell, board);
				if (!_v0.$) {
					if (!_v0.a.$) {
						var letter = _v0.a.a;
						return $elm$core$Set$member$(cell, placedSet) ? ($author$project$WordSpellingGame$letterValue$(setup, letter) * $author$project$WordSpellingGame$letterScoreMultiplier(cell)) : $author$project$WordSpellingGame$letterValue$(setup, letter);
					} else {
						var _v1 = _v0.a;
						return 0;
					}
				} else {
					return 0;
				}
			},
			cells));
	return letterSum * wordMultiplier;
};
var $author$project$WordSpellingGame$wordScore = F4($author$project$WordSpellingGame$wordScore$);
var $author$project$WordSpellingGame$wordString$ = function (board, cells) {
	return $elm$core$List$filterMap$(
		function (cell) {
			return $lamdera$containers$SeqDict$get$(cell, board);
		},
		cells);
};
var $author$project$WordSpellingGame$wordString = F2($author$project$WordSpellingGame$wordString$);
var $author$project$WordSpellingGame$placeWord$ = function (setup, board, placedWord) {
	var _v0 = placedWord.isVertical ? _Utils_Tuple2(0, 1) : _Utils_Tuple2(1, 0);
	var dx = _v0.a;
	var dy = _v0.b;
	var layout = F3(
		function (_v1, remaining, acc) {
			layout:
			while (true) {
				var cx = _v1.a;
				var cy = _v1.b;
				if (!remaining.b) {
					return $elm$core$Maybe$Just(
						$elm$core$List$reverse(acc));
				} else {
					var letterOrWildcard = remaining.a;
					var rest = remaining.b;
					if ((cx < 0) || ((cy < 0) || ((_Utils_cmp(cx, $author$project$WordSpellingGame$gridSize) > -1) || (_Utils_cmp(cy, $author$project$WordSpellingGame$gridSize) > -1)))) {
						return $elm$core$Maybe$Nothing;
					} else {
						var _v3 = $lamdera$containers$SeqDict$get$(
							_Utils_Tuple2(cx, cy),
							board);
						if (!_v3.$) {
							var $temp$_v1 = _Utils_Tuple2(cx + dx, cy + dy);
							_v1 = $temp$_v1;
							continue layout;
						} else {
							var $temp$_v1 = _Utils_Tuple2(cx + dx, cy + dy),
								$temp$remaining = rest,
								$temp$acc = A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									_Utils_Tuple2(cx, cy),
									letterOrWildcard),
								acc);
							_v1 = $temp$_v1;
							remaining = $temp$remaining;
							acc = $temp$acc;
							continue layout;
						}
					}
				}
			}
		});
	var _v4 = A3(
		layout,
		placedWord.start,
		$mgold$elm_nonempty_list$List$Nonempty$toList(placedWord.letters),
		_List_Nil);
	if (!_v4.$) {
		var placedCells = _v4.a;
		var placedCoords = $elm$core$List$map$($elm$core$Tuple$first, placedCells);
		var placedSet = $elm$core$Set$fromList(placedCoords);
		var newBoard = $elm$core$List$foldl$(
			F2(
				function (_v7, acc) {
					var cell = _v7.a;
					var letterOrWildcard = _v7.b;
					return $lamdera$containers$SeqDict$insert$(cell, letterOrWildcard, acc);
				}),
			board,
			placedCells);
		var mainWord = function () {
			if (placedCoords.b) {
				var first = placedCoords.a;
				return $author$project$WordSpellingGame$lineWord$(
					newBoard,
					_Utils_Tuple2(dx, dy),
					first);
			} else {
				return _List_Nil;
			}
		}();
		var crossWords = $elm$core$List$filterMap$(
			function (cell) {
				var word = $author$project$WordSpellingGame$lineWord$(
					newBoard,
					_Utils_Tuple2(dy, dx),
					cell);
				return ($elm$core$List$length(word) >= 2) ? $elm$core$Maybe$Just(word) : $elm$core$Maybe$Nothing;
			},
			placedCoords);
		var allWords = function () {
			if (!mainWord.b) {
				return crossWords;
			} else {
				if (!mainWord.b.b) {
					return $elm$core$List$isEmpty(crossWords) ? _List_fromArray(
						[mainWord]) : crossWords;
				} else {
					return A2($elm$core$List$cons, mainWord, crossWords);
				}
			}
		}();
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(
				newBoard,
				{
					placedCells: placedCells,
					score: $elm$core$List$sum(
						$elm$core$List$map$(
							A3($author$project$WordSpellingGame$wordScore, setup, newBoard, placedSet),
							allWords)),
					words: $elm$core$List$map$(
						function (wordCoords) {
							return {
								letters: $author$project$WordSpellingGame$wordString$(newBoard, wordCoords),
								placedCount: A2(
									$elmcraft$core_extra$List$Extra$count,
									function (cell) {
										return $elm$core$Set$member$(cell, placedSet);
									},
									wordCoords)
							};
						},
						allWords)
				}));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$WordSpellingGame$placeWord = F3($author$project$WordSpellingGame$placeWord$);
var $author$project$WordSpellingGame$Description_PlacedWord$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$WordSpellingGame$Description_PlacedWord = F2($author$project$WordSpellingGame$Description_PlacedWord$);
var $author$project$WordSpellingGame$placedWordDescription$ = function (setup, player, placedWord, result, isPremove, wildcardMatches) {
	var bonus = $author$project$WordSpellingGame$fullTrayBonusScore$(setup, placedWord);
	return $author$project$WordSpellingGame$Description_PlacedWord$(
		player.userId,
		{
			isBingo: !(!bonus),
			isPremove: isPremove,
			placedCells: result.placedCells,
			points: result.score + bonus,
			wildcardMatches: wildcardMatches,
			word: $author$project$WordSpellingGame$headlineWord(result.words)
		});
};
var $author$project$WordSpellingGame$placedWordDescription = F6($author$project$WordSpellingGame$placedWordDescription$);
var $author$project$WordSpellingGame$Wildcard = {$: 1};
var $elmcraft$core_extra$List$Extra$reverseAppend$ = function (list1, list2) {
	return $elm$core$List$foldl$($elm$core$List$cons, list2, list1);
};
var $elmcraft$core_extra$List$Extra$reverseAppend = F2($elmcraft$core_extra$List$Extra$reverseAppend$);
var $elmcraft$core_extra$List$Extra$removeHelp$ = function (list, x, xs, previousElements) {
	removeHelp:
	while (true) {
		if (!xs.b) {
			return list;
		} else {
			var y = xs.a;
			var ys = xs.b;
			if (_Utils_eq(x, y)) {
				return $elmcraft$core_extra$List$Extra$reverseAppend$(previousElements, ys);
			} else {
				var $temp$xs = ys,
					$temp$previousElements = A2($elm$core$List$cons, y, previousElements);
				xs = $temp$xs;
				previousElements = $temp$previousElements;
				continue removeHelp;
			}
		}
	}
};
var $elmcraft$core_extra$List$Extra$removeHelp = F4($elmcraft$core_extra$List$Extra$removeHelp$);
var $elmcraft$core_extra$List$Extra$remove$ = function (x, xs) {
	return $elmcraft$core_extra$List$Extra$removeHelp$(xs, x, xs, _List_Nil);
};
var $elmcraft$core_extra$List$Extra$remove = F2($elmcraft$core_extra$List$Extra$remove$);
var $author$project$WordSpellingGame$removeFromTray$ = function (letterOrWildcard, tray) {
	return $elm$core$List$member$(letterOrWildcard, tray) ? $elmcraft$core_extra$List$Extra$remove$(letterOrWildcard, tray) : $elmcraft$core_extra$List$Extra$remove$($author$project$WordSpellingGame$Wildcard, tray);
};
var $author$project$WordSpellingGame$removeFromTray = F2($author$project$WordSpellingGame$removeFromTray$);
var $mgold$elm_nonempty_list$List$Nonempty$indexedMap$ = function (f, _v0) {
	var x = _v0.a;
	var xs = _v0.b;
	var wrapped = F2(
		function (i, d) {
			return A2(f, i + 1, d);
		});
	return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
		A2(f, 0, x),
		$elm$core$List$indexedMap$(wrapped, xs));
};
var $mgold$elm_nonempty_list$List$Nonempty$indexedMap = F2($mgold$elm_nonempty_list$List$Nonempty$indexedMap$);
var $author$project$NonemptyExtra$update$ = function (_int, updateFunc, nonempty) {
	var index = A2(
		$elm$core$Basics$modBy,
		$mgold$elm_nonempty_list$List$Nonempty$length(nonempty),
		_int);
	return $mgold$elm_nonempty_list$List$Nonempty$indexedMap$(
		F2(
			function (i, value) {
				return _Utils_eq(i, index) ? updateFunc(value) : value;
			}),
		nonempty);
};
var $author$project$NonemptyExtra$update = F3($author$project$NonemptyExtra$update$);
var $author$project$NonemptyExtra$set$ = function (_int, value, nonempty) {
	return $author$project$NonemptyExtra$update$(
		_int,
		function (_v0) {
			return value;
		},
		nonempty);
};
var $author$project$NonemptyExtra$set = F3($author$project$NonemptyExtra$set$);
var $author$project$IdArray$toList = function (_v0) {
	var array = _v0;
	return $elm$core$Array$toList(array);
};
var $author$project$WordSpellingGame$handlePlaceWord$ = function (time, setup, placedWord, isPremove, _v4, isValid, player, shared) {
	var board = _v4.a;
	var result = _v4.b;
	var remainingTray = $elm$core$List$foldl$(
		$author$project$WordSpellingGame$removeFromTray,
		$author$project$IdArray$toList(player.tray),
		$mgold$elm_nonempty_list$List$Nonempty$toList(placedWord.letters));
	var tray = function () {
		if ((isValid.$ === 1) && (isValid.a.$ === 1)) {
			var _v15 = isValid.a;
			return $author$project$IdArray$fromList(
				_Utils_ap(
					remainingTray,
					$mgold$elm_nonempty_list$List$Nonempty$toList(placedWord.letters)));
		} else {
			var drawn = function () {
				var _v16 = $author$project$OneOrGreater$fromInt(
					$author$project$OneOrGreater$toInt(setup.traySize) - $elm$core$List$length(remainingTray));
				if (!_v16.$) {
					var drawCount = _v16.a;
					return $author$project$WordSpellingGame$getLetters$(
						drawCount,
						setup,
						board,
						$mgold$elm_nonempty_list$List$Nonempty$toList(
							$author$project$NonemptyExtra$set$(
								shared.turnCount,
								_Utils_update(
									player,
									{
										tray: $author$project$IdArray$fromList(remainingTray)
									}),
								shared.players)),
						shared.turnCount);
				} else {
					return _List_Nil;
				}
			}();
			return $author$project$IdArray$fromList(
				_Utils_ap(remainingTray, drawn));
		}
	}();
	var animatedPlacement = $elm$core$Maybe$Just(
		{cells: result.placedCells, isValid: isValid, startTime: time});
	var shared2 = _Utils_update(
		shared,
		{
			board: function () {
				if ((isValid.$ === 1) && (isValid.a.$ === 1)) {
					var _v10 = isValid.a;
					return shared.board;
				} else {
					return board;
				}
			}(),
			lastPlacement: animatedPlacement,
			passingStartedAt: function () {
				if (_Utils_eq(tray, $author$project$IdArray$empty)) {
					var _v11 = shared.passingStartedAt;
					if (_v11.$ === 1) {
						return $elm$core$Maybe$Just(shared.turnCount);
					} else {
						return shared.passingStartedAt;
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}(),
			players: $author$project$NonemptyExtra$set$(
				shared.turnCount,
				_Utils_update(
					player,
					{
						score: function () {
							if ((isValid.$ === 1) && (isValid.a.$ === 1)) {
								var _v13 = isValid.a;
								return player.score;
							} else {
								return (player.score + result.score) + $author$project$WordSpellingGame$fullTrayBonusScore$(setup, placedWord);
							}
						}(),
						tray: tray
					}),
				shared.players)
		});
	if (isValid.$ === 1) {
		if (isValid.a.$ === 1) {
			var _v6 = isValid.a;
			var _v7 = $author$project$OneOrGreater$decrement(shared2.attemptsLeft);
			if (!_v7.$) {
				var attemptsLeft = _v7.a;
				return _Utils_Tuple2(
					_Utils_update(
						shared2,
						{attemptsLeft: attemptsLeft}),
					_List_fromArray(
						[
							$author$project$WordSpellingGame$Description_InvalidMove$(
							player.userId,
							{
								attemptsLeft: $elm$core$Maybe$Just(attemptsLeft),
								placedCells: result.placedCells,
								word: $author$project$WordSpellingGame$headlineWord(result.words)
							})
						]));
			} else {
				return $author$project$WordSpellingGame$incrementTurnCount$(
					$author$project$WordSpellingGame$Description_InvalidMove$(
						player.userId,
						{
							attemptsLeft: $elm$core$Maybe$Nothing,
							placedCells: result.placedCells,
							word: $author$project$WordSpellingGame$headlineWord(result.words)
						}),
					time,
					setup,
					_Utils_update(
						shared2,
						{
							passingStartedAt: function () {
								var _v8 = shared2.passingStartedAt;
								if (_v8.$ === 1) {
									return $elm$core$Maybe$Just(shared2.turnCount);
								} else {
									return shared2.passingStartedAt;
								}
							}()
						}));
			}
		} else {
			var wildcardMatches = isValid.a.a;
			return $author$project$WordSpellingGame$incrementTurnCount$(
				$author$project$WordSpellingGame$placedWordDescription$(setup, player, placedWord, result, isPremove, wildcardMatches),
				time,
				setup,
				shared2);
		}
	} else {
		return _Utils_Tuple2(
			shared2,
			_List_fromArray(
				[
					$author$project$WordSpellingGame$placedWordDescription$(setup, player, placedWord, result, isPremove, $elm$core$Set$empty)
				]));
	}
};
var $author$project$WordSpellingGame$handlePlaceWord = F8($author$project$WordSpellingGame$handlePlaceWord$);
var $author$project$WordSpellingGame$incrementTurnCount$ = function (description, time, setup, shared) {
	var turnCount = shared.turnCount + 1;
	var nextPlayer = $mgold$elm_nonempty_list$List$Nonempty$get$(turnCount, shared.players);
	var nextPlayerNoPremove = _Utils_update(
		nextPlayer,
		{premove: $elm$core$Maybe$Nothing});
	var shared2 = _Utils_update(
		shared,
		{
			attemptsLeft: setup.placeWordAttempts,
			players: $author$project$NonemptyExtra$set$(turnCount, nextPlayerNoPremove, shared.players),
			turnCount: turnCount
		});
	var _v0 = nextPlayer.premove;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var premove = _v1.a;
		var expected = _v1.b;
		var isValid = _v1.c;
		var _v2 = $author$project$WordSpellingGame$placeWord$(setup, shared2.board, premove);
		if (!_v2.$) {
			var _v3 = _v2.a;
			var board = _v3.a;
			var result = _v3.b;
			return _Utils_eq(result, expected) ? $elm$core$Tuple$mapSecond$(
				function (a) {
					return A2($elm$core$List$cons, description, a);
				},
				$author$project$WordSpellingGame$handlePlaceWord$(
					time,
					setup,
					premove,
					true,
					_Utils_Tuple2(board, result),
					$author$project$UserSession$FilledInByBackend(isValid),
					nextPlayerNoPremove,
					shared2)) : _Utils_Tuple2(
				shared2,
				_List_fromArray(
					[
						description,
						$author$project$WordSpellingGame$Description_PremoveBlocked(nextPlayer.userId)
					]));
		} else {
			return _Utils_Tuple2(
				shared2,
				_List_fromArray(
					[
						description,
						$author$project$WordSpellingGame$Description_PremoveBlocked(nextPlayer.userId)
					]));
		}
	} else {
		return _Utils_Tuple2(
			shared2,
			_List_fromArray(
				[description]));
	}
};
var $author$project$WordSpellingGame$incrementTurnCount = F4($author$project$WordSpellingGame$incrementTurnCount$);
var $author$project$WordSpellingGame$initPlayer$ = function (userId, board, setup, existingPlayers) {
	return {
		premove: $elm$core$Maybe$Nothing,
		score: 0,
		tray: $author$project$IdArray$fromList(
			$author$project$WordSpellingGame$getLetters$(setup.traySize, setup, board, existingPlayers, 0)),
		userId: userId
	};
};
var $author$project$WordSpellingGame$initPlayer = F4($author$project$WordSpellingGame$initPlayer$);
var $author$project$WordSpellingGame$Joined = 1;
var $author$project$WordSpellingGame$JoinedAndItsTheirTurn = 2;
var $author$project$WordSpellingGame$NotJoined = 0;
var $author$project$WordSpellingGame$isPlayerTurn$ = function (userId, shared) {
	var _v0 = A2(
		$elmcraft$core_extra$List$Extra$findIndex,
		function (player) {
			return _Utils_eq(player.userId, userId);
		},
		$mgold$elm_nonempty_list$List$Nonempty$toList(shared.players));
	if (!_v0.$) {
		var index = _v0.a;
		return _Utils_eq(
			index,
			A2(
				$elm$core$Basics$modBy,
				$mgold$elm_nonempty_list$List$Nonempty$length(shared.players),
				shared.turnCount)) ? 2 : 1;
	} else {
		return 0;
	}
};
var $author$project$WordSpellingGame$isPlayerTurn = F2($author$project$WordSpellingGame$isPlayerTurn$);
var $author$project$WordSpellingGame$mapReactions$ = function (target, mapFunc, shared) {
	return _Utils_update(
		shared,
		{
			reactions: $lamdera$containers$SeqDict$update$(
				target,
				function (maybeReactions) {
					var reactions = mapFunc(
						$elm$core$Maybe$withDefault$($lamdera$containers$SeqDict$empty, maybeReactions));
					return $lamdera$containers$SeqDict$isEmpty(reactions) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(reactions);
				},
				shared.reactions)
		});
};
var $author$project$WordSpellingGame$mapReactions = F3($author$project$WordSpellingGame$mapReactions$);
var $author$project$WordSpellingGame$ShouldEndGame = 2;
var $author$project$WordSpellingGame$ShouldPass = 1;
var $author$project$WordSpellingGame$ShouldReplaceTray = 0;
var $author$project$WordSpellingGame$passBehavior$ = function (setup, shared) {
	if (_Utils_eq(
		$author$project$WordSpellingGame$remainingLettersInBag$(
			setup,
			shared.board,
			$mgold$elm_nonempty_list$List$Nonempty$toList(shared.players)),
		$lamdera$containers$SeqDict$empty)) {
		var _v0 = shared.passingStartedAt;
		if (!_v0.$) {
			var passingStartedAt = _v0.a;
			return (_Utils_cmp(
				$mgold$elm_nonempty_list$List$Nonempty$length(shared.players),
				(shared.turnCount + 1) - passingStartedAt) > 0) ? 1 : 2;
		} else {
			return 1;
		}
	} else {
		return 0;
	}
};
var $author$project$WordSpellingGame$passBehavior = F2($author$project$WordSpellingGame$passBehavior$);
var $author$project$WordSpellingGame$removeFromReactions$ = function (emoji, userId, reactions) {
	return $lamdera$containers$SeqDict$update$(
		emoji,
		$elm$core$Maybe$andThen(
			function (users) {
				return $author$project$NonemptySet$fromSeqSet(
					$lamdera$containers$SeqSet$remove$(
						userId,
						$author$project$NonemptySet$toSeqSet(users)));
			}),
		reactions);
};
var $author$project$WordSpellingGame$removeFromReactions = F3($author$project$WordSpellingGame$removeFromReactions$);
var $author$project$WordSpellingGame$updateAction$ = function (setup, action, shared) {
	var _v0 = action.change;
	switch (_v0.$) {
		case 0:
			var placedWord = _v0.a;
			var isValid = _v0.b;
			var _v1 = _Utils_Tuple3(
				$author$project$WordSpellingGame$getWinner(shared),
				$author$project$WordSpellingGame$getPlayer$(action.userId, shared),
				$author$project$WordSpellingGame$isPlayerTurn$(action.userId, shared));
			if (((_v1.a.$ === 1) && (!_v1.b.$)) && (_v1.c === 2)) {
				var _v2 = _v1.a;
				var player = _v1.b.a;
				var _v3 = _v1.c;
				var _v4 = $author$project$WordSpellingGame$placeWord$(setup, shared.board, placedWord);
				if (!_v4.$) {
					var result = _v4.a;
					return $author$project$WordSpellingGame$handlePlaceWord$(action.time, setup, placedWord, false, result, isValid, player, shared);
				} else {
					return _Utils_Tuple2(shared, _List_Nil);
				}
			} else {
				return _Utils_Tuple2(shared, _List_Nil);
			}
		case 1:
			var _v5 = _Utils_Tuple2(
				$author$project$WordSpellingGame$getWinner(shared),
				$author$project$WordSpellingGame$getPlayer$(action.userId, shared));
			if ((_v5.a.$ === 1) && (!_v5.b.$)) {
				var _v6 = _v5.a;
				var player = _v5.b.a;
				var _v7 = $author$project$WordSpellingGame$passBehavior$(setup, shared);
				switch (_v7) {
					case 0:
						return $author$project$WordSpellingGame$incrementTurnCount$(
							$author$project$WordSpellingGame$Description_ReplacedTray(action.userId),
							action.time,
							setup,
							_Utils_update(
								shared,
								{
									passingStartedAt: $elm$core$Maybe$Nothing,
									players: $author$project$NonemptyExtra$set$(
										shared.turnCount,
										_Utils_update(
											player,
											{
												tray: $author$project$IdArray$fromList(
													$author$project$WordSpellingGame$getLetters$(
														setup.traySize,
														setup,
														shared.board,
														$mgold$elm_nonempty_list$List$Nonempty$toList(
															$author$project$NonemptyExtra$set$(
																shared.turnCount,
																_Utils_update(
																	player,
																	{tray: $author$project$IdArray$empty}),
																shared.players)),
														(!shared.turnCount) ? 9999 : shared.turnCount))
											}),
										shared.players)
								}));
					case 1:
						return $author$project$WordSpellingGame$incrementTurnCount$(
							$author$project$WordSpellingGame$Description_Passed(action.userId),
							action.time,
							setup,
							_Utils_update(
								shared,
								{
									passingStartedAt: function () {
										var _v8 = shared.passingStartedAt;
										if (_v8.$ === 1) {
											return $elm$core$Maybe$Just(shared.turnCount);
										} else {
											return shared.passingStartedAt;
										}
									}()
								}));
					default:
						return $author$project$WordSpellingGame$incrementTurnCount$(
							$author$project$WordSpellingGame$Description_EndedGame(action.userId),
							action.time,
							setup,
							shared);
				}
			} else {
				return _Utils_Tuple2(shared, _List_Nil);
			}
		case 2:
			return $author$project$WordSpellingGame$canJoin(shared) ? _Utils_Tuple2(
				_Utils_update(
					shared,
					{
						players: $mgold$elm_nonempty_list$List$Nonempty$append$(
							shared.players,
							$mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
								$author$project$WordSpellingGame$initPlayer$(
									action.userId,
									shared.board,
									setup,
									$mgold$elm_nonempty_list$List$Nonempty$toList(shared.players)),
								_List_Nil))
					}),
				_List_fromArray(
					[
						$author$project$WordSpellingGame$Description_Joined(action.userId)
					])) : _Utils_Tuple2(shared, _List_Nil);
		case 3:
			var placedWord = _v0.a;
			var isValid = _v0.b;
			var _v9 = _Utils_Tuple3(
				$author$project$WordSpellingGame$getWinner(shared),
				$author$project$WordSpellingGame$isPlayerTurn$(action.userId, shared),
				$author$project$WordSpellingGame$placeWord$(setup, shared.board, placedWord));
			if (((_v9.a.$ === 1) && (_v9.b === 1)) && (!_v9.c.$)) {
				var _v10 = _v9.a;
				var _v11 = _v9.b;
				var _v12 = _v9.c.a;
				var result = _v12.b;
				return _Utils_Tuple2(
					_Utils_update(
						shared,
						{
							players: $mgold$elm_nonempty_list$List$Nonempty$map$(
								function (player) {
									return _Utils_eq(player.userId, action.userId) ? _Utils_update(
										player,
										{
											premove: $elm$core$Maybe$Just(
												_Utils_Tuple3(
													placedWord,
													result,
													function () {
														if (isValid.$ === 1) {
															var isValid2 = isValid.a;
															return isValid2;
														} else {
															return $author$project$WordSpellingGame$IsNotValid;
														}
													}()))
										}) : player;
								},
								shared.players)
						}),
					_List_Nil);
			} else {
				return _Utils_Tuple2(shared, _List_Nil);
			}
		case 4:
			return _Utils_Tuple2(
				_Utils_update(
					shared,
					{
						players: $mgold$elm_nonempty_list$List$Nonempty$map$(
							function (player) {
								return _Utils_eq(player.userId, action.userId) ? _Utils_update(
									player,
									{premove: $elm$core$Maybe$Nothing}) : player;
							},
							shared.players)
					}),
				_List_Nil);
		case 5:
			var target = _v0.a;
			var emoji = _v0.b;
			return _Utils_Tuple2(
				$author$project$WordSpellingGame$mapReactions$(
					target,
					A2($author$project$SeqDictHelper$addToSet, emoji, action.userId),
					shared),
				_List_Nil);
		default:
			var target = _v0.a;
			var emoji = _v0.b;
			return _Utils_Tuple2(
				$author$project$WordSpellingGame$mapReactions$(
					target,
					A2($author$project$WordSpellingGame$removeFromReactions, emoji, action.userId),
					shared),
				_List_Nil);
	}
};
var $author$project$WordSpellingGame$updateAction = F3($author$project$WordSpellingGame$updateAction$);
var $author$project$Game$addWordSpellingGameAction$ = function (action, matchData) {
	if (!matchData.$) {
		var matchData2 = matchData.a;
		return $author$project$Game$MatchData(
			_Utils_update(
				matchData2,
				{
					data: function () {
						var _v1 = matchData2.data;
						switch (_v1.$) {
							case 0:
								return matchData2.data;
							case 1:
								var setup = _v1.a;
								var actions = _v1.b;
								var cache = _v1.c;
								return $author$project$Game$FrontendGameData_WordSpellingGame$(
									setup,
									$elm$core$Array$push$(action, actions),
									$author$project$WordSpellingGame$updateAction$(setup, action, cache).a);
							default:
								return matchData2.data;
						}
					}()
				}));
	} else {
		return matchData;
	}
};
var $author$project$Game$addWordSpellingGameAction = F2($author$project$Game$addWordSpellingGameAction$);
var $author$project$SheepGame$initShared = {answers: $lamdera$containers$SeqDict$empty, groups: $lamdera$containers$SeqDict$empty, notes: $lamdera$containers$SeqDict$empty, phase: 0, questionsRevealed: 0};
var $author$project$WordSpellingGame$initShared = function (setup) {
	var initialBoard = $lamdera$containers$SeqDict$empty;
	return {
		attemptsLeft: setup.placeWordAttempts,
		board: initialBoard,
		lastPlacement: $elm$core$Maybe$Nothing,
		passingStartedAt: $elm$core$Maybe$Nothing,
		players: $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
			$author$project$WordSpellingGame$initPlayer$(setup.createdBy, initialBoard, setup, _List_Nil),
			_List_Nil),
		reactions: $lamdera$containers$SeqDict$empty,
		turnCount: 0
	};
};
var $author$project$FrontendExtra$gameChangeUpdateChannel$ = function (changeBy, gameChange, channel) {
	switch (gameChange.$) {
		case 2:
			var matchId = gameChange.a;
			var goChange = gameChange.b;
			if (!goChange.$) {
				var createdAt = goChange.a;
				var setup = goChange.b;
				var channel2 = $author$project$LocalState$createChannelMessageFrontend$(
					$author$project$Message$GameStarted(
						{cardDrawings: $author$project$Drawing$emptyDrawing, gameType: 0, reactions: $lamdera$containers$SeqDict$empty, startedAt: createdAt, startedBy: changeBy, timestampDrawings: $author$project$Drawing$emptyDrawing}),
					channel);
				var newMatchId = $author$project$DmChannel$latestFrontendMessageId(channel2);
				return _Utils_update(
					channel2,
					{
						games: $lamdera$containers$SeqDict$insert$(
							newMatchId,
							$author$project$Game$initMatchData$(
								$author$project$Game$GameData_Go$(setup, $elm$core$Array$empty),
								$elm$core$Maybe$Nothing),
							channel2.games)
					});
			} else {
				var action = goChange.a;
				return _Utils_update(
					channel,
					{
						games: $lamdera$containers$SeqDict$updateIfExists$(
							matchId,
							$author$project$Game$addGoAction(action),
							channel.games)
					});
			}
		case 0:
			var matchId = gameChange.a;
			var data = gameChange.b;
			if (data.$ === 1) {
				var publicId = data.a;
				return _Utils_update(
					channel,
					{
						games: $lamdera$containers$SeqDict$updateIfExists$(
							matchId,
							$author$project$Game$addPublicLink(publicId),
							channel.games)
					});
			} else {
				return channel;
			}
		case 1:
			var matchId = gameChange.a;
			var data = gameChange.b;
			if (data.$ === 1) {
				var loaded = data.a;
				return _Utils_update(
					channel,
					{
						games: $lamdera$containers$SeqDict$updateIfExists$(
							matchId,
							function (_v4) {
								return $author$project$Game$initMatchData$(loaded.gameData, loaded.publicLink);
							},
							channel.games)
					});
			} else {
				return channel;
			}
		case 3:
			var matchId = gameChange.a;
			var wsChange = gameChange.b;
			if (!wsChange.$) {
				var createdAt = wsChange.a;
				var setup = wsChange.b;
				var channel2 = $author$project$LocalState$createChannelMessageFrontend$(
					$author$project$Message$GameStarted(
						{cardDrawings: $author$project$Drawing$emptyDrawing, gameType: 1, reactions: $lamdera$containers$SeqDict$empty, startedAt: createdAt, startedBy: changeBy, timestampDrawings: $author$project$Drawing$emptyDrawing}),
					channel);
				var newMatchId = $author$project$DmChannel$latestFrontendMessageId(channel2);
				return _Utils_update(
					channel2,
					{
						games: $lamdera$containers$SeqDict$insert$(
							newMatchId,
							$author$project$Game$initMatchData$(
								$author$project$Game$GameData_WordSpellingGame$(
									setup,
									$elm$core$Array$empty,
									$author$project$WordSpellingGame$initShared(setup)),
								$elm$core$Maybe$Nothing),
							channel2.games)
					});
			} else {
				var action = wsChange.a;
				return _Utils_update(
					channel,
					{
						games: $lamdera$containers$SeqDict$updateIfExists$(
							matchId,
							$author$project$Game$addWordSpellingGameAction(action),
							channel.games)
					});
			}
		default:
			var matchId = gameChange.a;
			var sheepChange = gameChange.b;
			if (!sheepChange.$) {
				var createdAt = sheepChange.a;
				var setup = sheepChange.b;
				var channel2 = $author$project$LocalState$createChannelMessageFrontend$(
					$author$project$Message$GameStarted(
						{cardDrawings: $author$project$Drawing$emptyDrawing, gameType: 2, reactions: $lamdera$containers$SeqDict$empty, startedAt: createdAt, startedBy: changeBy, timestampDrawings: $author$project$Drawing$emptyDrawing}),
					channel);
				var newMatchId = $author$project$DmChannel$latestFrontendMessageId(channel2);
				return _Utils_update(
					channel2,
					{
						games: $lamdera$containers$SeqDict$insert$(
							newMatchId,
							$author$project$Game$initMatchData$(
								$author$project$Game$GameData_SheepGame$(setup, $elm$core$Array$empty, $author$project$SheepGame$initShared),
								$elm$core$Maybe$Nothing),
							channel2.games)
					});
			} else {
				var action = sheepChange.a;
				return _Utils_update(
					channel,
					{
						games: $lamdera$containers$SeqDict$updateIfExists$(
							matchId,
							$author$project$Game$addSheepGameAction(action),
							channel.games)
					});
			}
	}
};
var $author$project$FrontendExtra$gameChangeUpdateChannel = F3($author$project$FrontendExtra$gameChangeUpdateChannel$);
var $author$project$FrontendExtra$gameStartsMatch = function (gameChange) {
	_v0$2:
	while (true) {
		switch (gameChange.$) {
			case 2:
				if (!gameChange.b.$) {
					var _v1 = gameChange.b;
					return true;
				} else {
					break _v0$2;
				}
			case 3:
				if (!gameChange.b.$) {
					var _v2 = gameChange.b;
					return true;
				} else {
					break _v0$2;
				}
			default:
				break _v0$2;
		}
	}
	return false;
};
var $author$project$LocalState$onlyNewMessageIsUnread$ = function (maybeLastViewed, newMessageId) {
	return _Utils_eq(
		$author$project$Id$toInt(
			$elm$core$Maybe$withDefault$(
				$author$project$Id$fromInt(-1),
				maybeLastViewed)) + 1,
		$author$project$Id$toInt(newMessageId));
};
var $author$project$LocalState$onlyNewMessageIsUnread = F2($author$project$LocalState$onlyNewMessageIsUnread$);
var $author$project$LocalState$hasCaughtUp$ = function (guildOrDmId, threadRoute, user) {
	if (!threadRoute.$) {
		var messageId = threadRoute.a;
		return $author$project$LocalState$onlyNewMessageIsUnread$(
			$lamdera$containers$SeqDict$get$(guildOrDmId, user.lastViewedMessage),
			messageId);
	} else {
		var threadId = threadRoute.a;
		var messageId = threadRoute.b;
		return $author$project$LocalState$onlyNewMessageIsUnread$(
			$lamdera$containers$SeqDict$get$(
				_Utils_Tuple2(guildOrDmId, threadId),
				user.lastViewedThreadMessage),
			messageId);
	}
};
var $author$project$LocalState$hasCaughtUp = F3($author$project$LocalState$hasCaughtUp$);
var $author$project$User$setLastViewedMessage$ = function (guildOrDmId, threadRoute, user) {
	if (threadRoute.$ === 1) {
		var threadMessageId = threadRoute.a;
		var messageId = threadRoute.b;
		return _Utils_update(
			user,
			{
				lastViewedThreadMessage: $lamdera$containers$SeqDict$insert$(
					_Utils_Tuple2(guildOrDmId, threadMessageId),
					messageId,
					user.lastViewedThreadMessage)
			});
	} else {
		var messageId = threadRoute.a;
		return _Utils_update(
			user,
			{
				lastViewedMessage: $lamdera$containers$SeqDict$insert$(guildOrDmId, messageId, user.lastViewedMessage)
			});
	}
};
var $author$project$User$setLastViewedMessage = F3($author$project$User$setLastViewedMessage$);
var $author$project$UserSession$PreviouslyLastViewedMessage = function (a) {
	return {$: 1, a: a};
};
var $author$project$UserSession$Viewing_Channel = function (a) {
	return {$: 3, a: a};
};
var $author$project$UserSession$Viewing_DiscordChannel = function (a) {
	return {$: 5, a: a};
};
var $author$project$UserSession$Viewing_DiscordDm = function (a) {
	return {$: 2, a: a};
};
var $author$project$UserSession$Viewing_Dm = function (a) {
	return {$: 0, a: a};
};
var $author$project$UserSession$Viewing_SlackChannel = function (a) {
	return {$: 7, a: a};
};
var $author$project$UserSession$Viewing_SlackDm = function (a) {
	return {$: 9, a: a};
};
var $author$project$UserSession$setPreviouslyLastViewedChannelMessage$ = function (messageId, viewing) {
	switch (viewing.$) {
		case 0:
			var data = viewing.a;
			return $author$project$UserSession$Viewing_Dm(
				_Utils_update(
					data,
					{
						previouslyLastViewedMessage: $author$project$UserSession$PreviouslyLastViewedMessage(messageId)
					}));
		case 2:
			var data = viewing.a;
			return $author$project$UserSession$Viewing_DiscordDm(
				_Utils_update(
					data,
					{
						previouslyLastViewedMessage: $author$project$UserSession$PreviouslyLastViewedMessage(messageId)
					}));
		case 3:
			var data = viewing.a;
			return $author$project$UserSession$Viewing_Channel(
				_Utils_update(
					data,
					{
						previouslyLastViewedMessage: $author$project$UserSession$PreviouslyLastViewedMessage(messageId)
					}));
		case 5:
			var data = viewing.a;
			return $author$project$UserSession$Viewing_DiscordChannel(
				_Utils_update(
					data,
					{
						previouslyLastViewedMessage: $author$project$UserSession$PreviouslyLastViewedMessage(messageId)
					}));
		case 7:
			var data = viewing.a;
			return $author$project$UserSession$Viewing_SlackChannel(
				_Utils_update(
					data,
					{
						previouslyLastViewedMessage: $author$project$UserSession$PreviouslyLastViewedMessage(messageId)
					}));
		case 9:
			var data = viewing.a;
			return $author$project$UserSession$Viewing_SlackDm(
				_Utils_update(
					data,
					{
						previouslyLastViewedMessage: $author$project$UserSession$PreviouslyLastViewedMessage(messageId)
					}));
		case 8:
			return viewing;
		case 10:
			return viewing;
		case 1:
			return viewing;
		case 4:
			return viewing;
		case 6:
			return viewing;
		case 11:
			return viewing;
		default:
			return viewing;
	}
};
var $author$project$UserSession$setPreviouslyLastViewedChannelMessage = F2($author$project$UserSession$setPreviouslyLastViewedChannelMessage$);
var $author$project$UserSession$Viewing_ChannelThread = function (a) {
	return {$: 4, a: a};
};
var $author$project$UserSession$Viewing_DiscordChannelThread = function (a) {
	return {$: 6, a: a};
};
var $author$project$UserSession$Viewing_DmThread = function (a) {
	return {$: 1, a: a};
};
var $author$project$UserSession$Viewing_SlackChannelThread = function (a) {
	return {$: 8, a: a};
};
var $author$project$UserSession$Viewing_SlackDmThread = function (a) {
	return {$: 10, a: a};
};
var $author$project$UserSession$setPreviouslyLastViewedThreadMessage$ = function (messageId, viewing) {
	switch (viewing.$) {
		case 1:
			var data = viewing.a;
			return $author$project$UserSession$Viewing_DmThread(
				_Utils_update(
					data,
					{
						previouslyLastViewedMessage: $author$project$UserSession$PreviouslyLastViewedMessage(messageId)
					}));
		case 4:
			var data = viewing.a;
			return $author$project$UserSession$Viewing_ChannelThread(
				_Utils_update(
					data,
					{
						previouslyLastViewedMessage: $author$project$UserSession$PreviouslyLastViewedMessage(messageId)
					}));
		case 6:
			var data = viewing.a;
			return $author$project$UserSession$Viewing_DiscordChannelThread(
				_Utils_update(
					data,
					{
						previouslyLastViewedMessage: $author$project$UserSession$PreviouslyLastViewedMessage(messageId)
					}));
		case 8:
			var data = viewing.a;
			return $author$project$UserSession$Viewing_SlackChannelThread(
				_Utils_update(
					data,
					{
						previouslyLastViewedMessage: $author$project$UserSession$PreviouslyLastViewedMessage(messageId)
					}));
		case 10:
			var data = viewing.a;
			return $author$project$UserSession$Viewing_SlackDmThread(
				_Utils_update(
					data,
					{
						previouslyLastViewedMessage: $author$project$UserSession$PreviouslyLastViewedMessage(messageId)
					}));
		case 0:
			return viewing;
		case 2:
			return viewing;
		case 3:
			return viewing;
		case 5:
			return viewing;
		case 7:
			return viewing;
		case 9:
			return viewing;
		case 11:
			return viewing;
		default:
			return viewing;
	}
};
var $author$project$UserSession$setPreviouslyLastViewedThreadMessage = F2($author$project$UserSession$setPreviouslyLastViewedThreadMessage$);
var $author$project$LocalState$ownMessageIsReadFrontend$ = function (guildOrDmId, threadRoute, _v0) {
	var viewing = _v0.a;
	var user = _v0.b;
	return _Utils_Tuple2(
		function () {
			if ($author$project$LocalState$hasCaughtUp$(guildOrDmId, threadRoute, user)) {
				if (!threadRoute.$) {
					var messageId = threadRoute.a;
					return $author$project$UserSession$setPreviouslyLastViewedChannelMessage$(messageId, viewing);
				} else {
					var messageId = threadRoute.b;
					return $author$project$UserSession$setPreviouslyLastViewedThreadMessage$(messageId, viewing);
				}
			} else {
				return viewing;
			}
		}(),
		$author$project$User$setLastViewedMessage$(guildOrDmId, threadRoute, user));
};
var $author$project$LocalState$ownMessageIsReadFrontend = F3($author$project$LocalState$ownMessageIsReadFrontend$);
var $author$project$FrontendExtra$gameChangeUpdate$ = function (changeBy, guildOrDmId, gameChange, local) {
	if (guildOrDmId.$ === 1) {
		var otherUserId = guildOrDmId.a.otherUserId;
		var localUser = local.localUser;
		var dmChannel = $elm$core$Maybe$withDefault$(
			$author$project$DmChannel$frontendInit,
			$lamdera$containers$SeqDict$get$(otherUserId, local.dmChannels));
		var _v1 = ($author$project$FrontendExtra$gameStartsMatch(gameChange) && _Utils_eq(changeBy, localUser.session.userId)) ? $author$project$LocalState$ownMessageIsReadFrontend$(
			$author$project$Id$GuildOrDmId(
				$author$project$Id$GuildOrDmId_Dm(
					{otherUserId: otherUserId})),
			$author$project$Id$NoThreadWithMessage(
				$author$project$Id$fromInt(
					$author$project$MessageArray$length(dmChannel.messages))),
			_Utils_Tuple2(localUser.currentlyViewing, localUser.user)) : _Utils_Tuple2(localUser.currentlyViewing, localUser.user);
		var currentlyViewing2 = _v1.a;
		var user2 = _v1.b;
		return _Utils_update(
			local,
			{
				dmChannels: $lamdera$containers$SeqDict$insert$(
					otherUserId,
					$author$project$FrontendExtra$gameChangeUpdateChannel$(changeBy, gameChange, dmChannel),
					local.dmChannels),
				localUser: _Utils_update(
					localUser,
					{currentlyViewing: currentlyViewing2, user: user2})
			});
	} else {
		var id = guildOrDmId.a;
		var _v2 = $author$project$LocalState$getGuildAndChannel$(id, local);
		if (!_v2.$) {
			var _v3 = _v2.a;
			var guild = _v3.a;
			var channel = _v3.b;
			var localUser = local.localUser;
			var _v4 = ($author$project$FrontendExtra$gameStartsMatch(gameChange) && _Utils_eq(changeBy, localUser.session.userId)) ? $author$project$LocalState$ownMessageIsReadFrontend$(
				$author$project$Id$GuildOrDmId(
					$author$project$Id$GuildOrDmId_Guild(id)),
				$author$project$Id$NoThreadWithMessage(
					$author$project$Id$fromInt(
						$author$project$MessageArray$length(channel.messages))),
				_Utils_Tuple2(localUser.currentlyViewing, localUser.user)) : _Utils_Tuple2(localUser.currentlyViewing, localUser.user);
			var currentlyViewing2 = _v4.a;
			var user2 = _v4.b;
			return _Utils_update(
				local,
				{
					guilds: $lamdera$containers$SeqDict$insert$(
						id.guildId,
						_Utils_update(
							guild,
							{
								channels: $lamdera$containers$SeqDict$insert$(
									id.channelId,
									$author$project$FrontendExtra$gameChangeUpdateChannel$(changeBy, gameChange, channel),
									guild.channels)
							}),
						local.guilds),
					localUser: _Utils_update(
						localUser,
						{currentlyViewing: currentlyViewing2, user: user2})
				});
		} else {
			return local;
		}
	}
};
var $author$project$FrontendExtra$gameChangeUpdate = F4($author$project$FrontendExtra$gameChangeUpdate$);
var $author$project$LocalState$getDiscordGuildAndChannel$ = function (guildId, channelId, local) {
	var _v0 = $lamdera$containers$SeqDict$get$(guildId, local.discordGuilds);
	if (!_v0.$) {
		var guild = _v0.a;
		var _v1 = $lamdera$containers$SeqDict$get$(channelId, guild.channels);
		if (!_v1.$) {
			var channel = _v1.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(guild, channel));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$LocalState$getDiscordGuildAndChannel = F3($author$project$LocalState$getDiscordGuildAndChannel$);
var $author$project$LocalState$getSlackWorkspaceAndChannel$ = function (teamId, channelId, local) {
	var _v0 = $lamdera$containers$SeqDict$get$(teamId, local.slackWorkspaces);
	if (!_v0.$) {
		var workspace = _v0.a;
		var _v1 = $lamdera$containers$SeqDict$get$(channelId, workspace.channels);
		if (!_v1.$) {
			var channel = _v1.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(workspace, channel));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$LocalState$getSlackWorkspaceAndChannel = F3($author$project$LocalState$getSlackWorkspaceAndChannel$);
var $author$project$MembersAndOwner$updateMember$ = function (userId, updateFunc, _v0) {
	var members2 = _v0.a;
	var ownerId = _v0.b;
	return $author$project$MembersAndOwner$MembersAndOwner$(
		$lamdera$containers$SeqDict$updateIfExists$(userId, updateFunc, members2),
		ownerId);
};
var $author$project$MembersAndOwner$updateMember = F3($author$project$MembersAndOwner$updateMember$);
var $author$project$LocalState$memberPosted$ = function (userId, time, guild) {
	return _Utils_update(
		guild,
		{
			lastTypedAt: $lamdera$containers$SeqDict$remove$(userId, guild.lastTypedAt),
			membersAndOwner: $author$project$MembersAndOwner$updateMember$(
				userId,
				function (member) {
					return _Utils_update(
						member,
						{
							lastPostedAt: $elm$core$Maybe$Just(time)
						});
				},
				guild.membersAndOwner)
		});
};
var $author$project$LocalState$memberPosted = F3($author$project$LocalState$memberPosted$);
var $author$project$FrontendExtra$guildSendMessage$ = function (guildId, guild, channelId, channel, threadRouteWithRepliedTo, createdAt, userId, text, attachedFiles, local) {
	return $lamdera$containers$SeqDict$insert$(
		guildId,
		$author$project$LocalState$memberPosted$(
			userId,
			createdAt,
			_Utils_update(
				guild,
				{
					channels: $lamdera$containers$SeqDict$insert$(
						channelId,
						function () {
							if (threadRouteWithRepliedTo.$ === 1) {
								var threadId = threadRouteWithRepliedTo.a;
								var maybeReplyTo = threadRouteWithRepliedTo.b;
								return $author$project$LocalState$createThreadMessageFrontend$(
									threadId,
									$author$project$Message$userTextMessageFrontend$(
										createdAt,
										userId,
										text,
										$author$project$Message$maybeToReply(maybeReplyTo),
										attachedFiles),
									channel);
							} else {
								var repliedTo = threadRouteWithRepliedTo.a;
								return $author$project$LocalState$createChannelMessageFrontend$(
									$author$project$Message$userTextMessageFrontend$(createdAt, userId, text, repliedTo, attachedFiles),
									channel);
							}
						}(),
						guild.channels)
				})),
		local.guilds);
};
var $author$project$FrontendExtra$guildSendMessage = function (guildId) {
	return function (guild) {
		return function (channelId) {
			return function (channel) {
				return function (threadRouteWithRepliedTo) {
					return function (createdAt) {
						return function (userId) {
							return function (text) {
								return function (attachedFiles) {
									return function (local) {
										return $author$project$FrontendExtra$guildSendMessage$(guildId, guild, channelId, channel, threadRouteWithRepliedTo, createdAt, userId, text, attachedFiles, local);
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$DmChannelId$GuildOrFullDmId_Guild$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$DmChannelId$GuildOrFullDmId_Guild = F2($author$project$DmChannelId$GuildOrFullDmId_Guild$);
var $author$project$OneToOne$first$ = function (b, _v0) {
	var secondToFirst = _v0.b;
	return $lamdera$containers$SeqDict$get$(b, secondToFirst);
};
var $author$project$OneToOne$first = F2($author$project$OneToOne$first$);
var $author$project$Game$MatchNotLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Game$matchNotLoaded = function (gameData) {
	return $author$project$Game$MatchNotLoaded(
		function () {
			switch (gameData.$) {
				case 0:
					return 0;
				case 1:
					return 1;
				default:
					return 2;
			}
		}());
};
var $author$project$Message$repliedToMatchHelper = function (repliedTo) {
	switch (repliedTo.$) {
		case 2:
			var matchId = repliedTo.a;
			return $elm$core$Maybe$Just(matchId);
		case 1:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Message$repliedToMatch = function (message) {
	switch (message.$) {
		case 0:
			var data = message.a;
			return $author$project$Message$repliedToMatchHelper(data.repliedTo);
		case 1:
			var data = message.a;
			return $author$project$Message$repliedToMatchHelper(data.repliedTo);
		case 2:
			return $elm$core$Maybe$Nothing;
		case 3:
			return $elm$core$Maybe$Nothing;
		case 4:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$DmChannel$gamesToFrontend$ = function (guildOrDmId, threadRoute, goMatchPublicIds, messages, channel) {
	var repliedToMatches = $lamdera$containers$SeqSet$fromList(
		$elm$core$List$filterMap$(
			function (_v3) {
				var message = _v3.b;
				return $author$project$Message$repliedToMatch(message);
			},
			$author$project$MessageArray$toList(messages)));
	var openMatch = function () {
		if ((((!threadRoute.$) && (!threadRoute.a.b.$)) && (threadRoute.a.b.a.$ === 1)) && (!threadRoute.a.b.a.a.$)) {
			var _v1 = threadRoute.a;
			var _v2 = _v1.b.a;
			var matchId = _v2.a.a;
			return $elm$core$Maybe$Just(matchId);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	return $lamdera$containers$SeqDict$map$(
		F2(
			function (matchId, gameData) {
				return (_Utils_eq(
					$elm$core$Maybe$Just(matchId),
					openMatch) || $lamdera$containers$SeqSet$member$(matchId, repliedToMatches)) ? $author$project$Game$initMatchData$(
					gameData,
					$author$project$OneToOne$first$(
						_Utils_Tuple2(guildOrDmId, matchId),
						goMatchPublicIds)) : $author$project$Game$matchNotLoaded(gameData);
			}),
		channel.games);
};
var $author$project$DmChannel$gamesToFrontend = F5($author$project$DmChannel$gamesToFrontend$);
var $author$project$VisibleMessages$firstLoad = function (messageCount) {
	var oldest = $elm$core$Basics$max$(0, messageCount - $author$project$VisibleMessages$pageSize);
	return {
		count: messageCount - oldest,
		loadingMessages: false,
		oldest: $author$project$Id$fromInt(oldest)
	};
};
var $author$project$VisibleMessages$init$ = function (preloadMessages, messageCount) {
	return preloadMessages ? $author$project$VisibleMessages$firstLoad(messageCount) : $author$project$VisibleMessages$empty;
};
var $author$project$VisibleMessages$init = F2($author$project$VisibleMessages$init$);
var $author$project$IdArray$length = function (_v0) {
	var array = _v0;
	return $elm$core$Array$length(array);
};
var $author$project$MessageArray$fromArray$ = function (count, startId, values) {
	var end = $elm$core$Basics$max$(0, count);
	var start = $elm$core$Basics$clamp$(
		0,
		end,
		$author$project$Id$toInt(startId));
	var clipped = $elm$core$Array$slice$(
		0,
		$elm$core$Basics$min$(
			$elm$core$Array$length(values),
			end - start),
		values);
	return {
		end: end,
		runs: $elm$core$Array$isEmpty(clipped) ? $elm$core$Array$empty : $elm$core$Array$repeat$(
			1,
			{start: start, values: clipped}),
		start: 0
	};
};
var $author$project$MessageArray$fromArray = F3($author$project$MessageArray$fromArray$);
var $author$project$IdArray$toArray = function (_v0) {
	var array = _v0;
	return array;
};
var $author$project$Thread$loadMessages$ = function (preloadMessages, messages) {
	var messageCount = $author$project$IdArray$length(messages);
	var oldestLoaded = preloadMessages ? $elm$core$Basics$max$(0, messageCount - $author$project$VisibleMessages$pageSize) : $elm$core$Basics$max$(0, messageCount - 1);
	var messagesToLoad = $elm$core$Array$slice$(
		oldestLoaded,
		messageCount,
		$author$project$IdArray$toArray(messages));
	var referencedMessages = $elm$core$Array$foldl$(
		F2(
			function (message, list) {
				var _v0 = $author$project$Message$repliedToMessage(message);
				if (!_v0.$) {
					var repliedToId = _v0.a;
					var _v1 = $author$project$IdArray$get$(repliedToId, messages);
					if (!_v1.$) {
						var repliedTo = _v1.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(repliedToId, repliedTo),
							list);
					} else {
						return list;
					}
				} else {
					return list;
				}
			}),
		_List_Nil,
		messagesToLoad);
	return $author$project$MessageArray$setMany$(
		referencedMessages,
		$author$project$MessageArray$fromArray$(
			messageCount,
			$author$project$Id$fromInt(oldestLoaded),
			messagesToLoad));
};
var $author$project$Thread$loadMessages = F2($author$project$Thread$loadMessages$);
var $author$project$Thread$toFrontend$ = function (preloadMessages, thread) {
	return {
		dateDividerDrawings: thread.dateDividerDrawings,
		messages: $author$project$Thread$loadMessages$(preloadMessages, thread.messages),
		visibleMessages: $author$project$VisibleMessages$init$(
			preloadMessages,
			$author$project$IdArray$length(thread.messages))
	};
};
var $author$project$Thread$toFrontend = F2($author$project$Thread$toFrontend$);
var $author$project$DmChannel$loadThreadStarters$ = function (threads, backendMessages, messages) {
	return function (threadStarters) {
		return $author$project$MessageArray$setMany$(threadStarters, messages);
	}(
		$lamdera$containers$SeqDict$foldl$(
			F3(
				function (threadId, _v0, list) {
					var _v1 = $author$project$IdArray$get$(threadId, backendMessages);
					if (!_v1.$) {
						var message = _v1.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(threadId, message),
							list);
					} else {
						return list;
					}
				}),
			_List_Nil,
			threads));
};
var $author$project$DmChannel$loadThreadStarters = F3($author$project$DmChannel$loadThreadStarters$);
var $author$project$DmChannel$toFrontendHelper$ = function (preloadMessages, channel) {
	return $author$project$DmChannel$loadThreadStarters$(
		channel.threads,
		channel.messages,
		$author$project$Thread$loadMessages$(preloadMessages, channel.messages));
};
var $author$project$DmChannel$toFrontendHelper = F2($author$project$DmChannel$toFrontendHelper$);
var $author$project$LocalState$channelToFrontend$ = function (guildId, channelId, threadRoute, goMatchPublicIds, channel) {
	var _v0 = channel.status;
	if (!_v0.$) {
		var preloadMessages = _Utils_eq(
			$elm$core$Maybe$Just($author$project$Id$NoThread),
			$elm$core$Maybe$map$($elm$core$Tuple$first, threadRoute));
		var messages = $author$project$DmChannel$toFrontendHelper$(preloadMessages, channel);
		return $elm$core$Maybe$Just(
			{
				createdAt: channel.createdAt,
				createdBy: channel.createdBy,
				dateDividerDrawings: channel.dateDividerDrawings,
				description: channel.description,
				games: $author$project$DmChannel$gamesToFrontend$(
					$author$project$DmChannelId$GuildOrFullDmId_Guild$(guildId, channelId),
					threadRoute,
					goMatchPublicIds,
					messages,
					channel),
				isArchived: $elm$core$Maybe$Nothing,
				messages: messages,
				name: channel.name,
				threads: $lamdera$containers$SeqDict$map$(
					F2(
						function (threadId, thread) {
							return $author$project$Thread$toFrontend$(
								_Utils_eq(
									$elm$core$Maybe$Just(
										$author$project$Id$ViewThread(threadId)),
									$elm$core$Maybe$map$($elm$core$Tuple$first, threadRoute)),
								thread);
						}),
					channel.threads),
				visibleMessages: $author$project$VisibleMessages$init$(
					preloadMessages,
					$author$project$IdArray$length(channel.messages))
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$LocalState$channelToFrontend = F5($author$project$LocalState$channelToFrontend$);
var $lamdera$containers$SeqDict$filterMap$ = function (mapFunc, _v0) {
	var intDict = _v0.c;
	var helper = F2(
		function (_v2, dict2) {
			var hash = _v2.a;
			var key = _v2.b;
			var value = _v2.c;
			var bitmap = dict2.a;
			var nodes = dict2.b;
			var triplets = dict2.c;
			var _v1 = A2(mapFunc, key, value);
			if (!_v1.$) {
				var value2 = _v1.a;
				return $lamdera$containers$SeqDict$insertHelp$(0, hash, key, value2, bitmap, nodes, triplets);
			} else {
				return dict2;
			}
		});
	return $lamdera$containers$SeqDict$intDictFoldl$(helper, $lamdera$containers$SeqDict$empty, intDict);
};
var $lamdera$containers$SeqDict$filterMap = F2($lamdera$containers$SeqDict$filterMap$);
var $author$project$LocalState$guildToFrontend$ = function (guildId, requestMessagesFor, goMatchPublicIds, guild) {
	return {
		channels: $lamdera$containers$SeqDict$filterMap$(
			F2(
				function (channelId, channel) {
					return $author$project$LocalState$channelToFrontend$(
						guildId,
						channelId,
						function () {
							if (!requestMessagesFor.$) {
								var _v1 = requestMessagesFor.a;
								var channelIdB = _v1.a;
								var threadRoute = _v1.b;
								return _Utils_eq(channelId, channelIdB) ? $elm$core$Maybe$Just(threadRoute) : $elm$core$Maybe$Nothing;
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}(),
						goMatchPublicIds,
						channel);
				}),
			guild.channels),
		createdAt: guild.createdAt,
		createdBy: guild.createdBy,
		icon: guild.icon,
		invites: guild.invites,
		lastTypedAt: guild.lastTypedAt,
		membersAndOwner: guild.membersAndOwner,
		name: guild.name
	};
};
var $author$project$LocalState$guildToFrontend = F4($author$project$LocalState$guildToFrontend$);
var $author$project$LocalState$incrementLastViewedMessageFrontend$ = function (guildOrDmId, threadRoute, _v0) {
	var viewing = _v0.a;
	var user = _v0.b;
	return $author$project$LocalState$hasCaughtUp$(guildOrDmId, threadRoute, user) ? _Utils_Tuple2(
		function () {
			if (!threadRoute.$) {
				var messageId = threadRoute.a;
				return $author$project$UserSession$setPreviouslyLastViewedChannelMessage$(messageId, viewing);
			} else {
				var messageId = threadRoute.b;
				return $author$project$UserSession$setPreviouslyLastViewedThreadMessage$(messageId, viewing);
			}
		}(),
		$author$project$User$setLastViewedMessage$(guildOrDmId, threadRoute, user)) : _Utils_Tuple2(viewing, user);
};
var $author$project$LocalState$incrementLastViewedMessageFrontend = F3($author$project$LocalState$incrementLastViewedMessageFrontend$);
var $author$project$UserSession$isViewing$ = function (guildOrDmId, threadRoute, viewing) {
	var _v0 = _Utils_Tuple2(viewing, threadRoute);
	_v0$11:
	while (true) {
		if (!_v0.b.$) {
			switch (_v0.a.$) {
				case 0:
					var data = _v0.a.a;
					var _v1 = _v0.b;
					return _Utils_eq(
						guildOrDmId,
						$author$project$Id$GuildOrDmId(
							$author$project$Id$GuildOrDmId_Dm(data.id)));
				case 2:
					var data = _v0.a.a;
					var _v2 = _v0.b;
					return _Utils_eq(
						guildOrDmId,
						$author$project$Id$DiscordGuildOrDmId(
							$author$project$Id$DiscordGuildOrDmId_Dm(
								{channelId: data.id.channelId, currentUserId: data.id.currentUserId})));
				case 3:
					var data = _v0.a.a;
					var _v3 = _v0.b;
					return _Utils_eq(
						guildOrDmId,
						$author$project$Id$GuildOrDmId(
							$author$project$Id$GuildOrDmId_Guild(data.id)));
				case 5:
					var data = _v0.a.a;
					var _v4 = _v0.b;
					return _Utils_eq(
						guildOrDmId,
						$author$project$Id$DiscordGuildOrDmId(
							$author$project$Id$DiscordGuildOrDmId_Guild(data.id)));
				case 7:
					var data = _v0.a.a;
					var _v5 = _v0.b;
					return _Utils_eq(
						guildOrDmId,
						$author$project$Id$SlackGuildOrDmId(
							$author$project$Id$SlackGuildOrDmId_Workspace(data.id)));
				case 9:
					var data = _v0.a.a;
					var _v6 = _v0.b;
					return _Utils_eq(
						guildOrDmId,
						$author$project$Id$SlackGuildOrDmId(
							$author$project$Id$SlackGuildOrDmId_Dm(data.id)));
				default:
					break _v0$11;
			}
		} else {
			switch (_v0.a.$) {
				case 1:
					var data = _v0.a.a;
					var threadId = _v0.b.a;
					return _Utils_eq(
						guildOrDmId,
						$author$project$Id$GuildOrDmId(
							$author$project$Id$GuildOrDmId_Dm(
								{otherUserId: data.id.otherUserId}))) && _Utils_eq(data.id.threadId, threadId);
				case 4:
					var data = _v0.a.a;
					var threadId = _v0.b.a;
					return _Utils_eq(
						guildOrDmId,
						$author$project$Id$GuildOrDmId(
							$author$project$Id$GuildOrDmId_Guild(
								{channelId: data.id.channelId, guildId: data.id.guildId}))) && _Utils_eq(data.id.threadId, threadId);
				case 6:
					var data = _v0.a.a;
					var threadId = _v0.b.a;
					return _Utils_eq(
						guildOrDmId,
						$author$project$Id$DiscordGuildOrDmId(
							$author$project$Id$DiscordGuildOrDmId_Guild(
								{channelId: data.id.channelId, currentUserId: data.id.currentUserId, guildId: data.id.guildId}))) && _Utils_eq(data.id.threadId, threadId);
				case 8:
					var data = _v0.a.a;
					var threadId = _v0.b.a;
					return _Utils_eq(
						guildOrDmId,
						$author$project$Id$SlackGuildOrDmId(
							$author$project$Id$SlackGuildOrDmId_Workspace(data.id))) && _Utils_eq(data.threadId, threadId);
				case 10:
					var data = _v0.a.a;
					var threadId = _v0.b.a;
					return _Utils_eq(
						guildOrDmId,
						$author$project$Id$SlackGuildOrDmId(
							$author$project$Id$SlackGuildOrDmId_Dm(data.id))) && _Utils_eq(data.threadId, threadId);
				default:
					break _v0$11;
			}
		}
	}
	return false;
};
var $author$project$UserSession$isViewing = F3($author$project$UserSession$isViewing$);
var $author$project$FrontendExtra$isViewing$ = function (guildOrDmId, threadRoute, local) {
	return $author$project$UserSession$isViewing$(guildOrDmId, threadRoute, local.localUser.currentlyViewing) || $elm$core$List$any$(
		function (otherSession) {
			return $elm$core$List$any$(
				A2($author$project$UserSession$isViewing, guildOrDmId, threadRoute),
				$lamdera$containers$SeqDict$values(otherSession.currentlyViewing));
		},
		$lamdera$containers$SeqDict$values(local.otherSessions));
};
var $author$project$FrontendExtra$isViewing = F3($author$project$FrontendExtra$isViewing$);
var $author$project$DmChannel$latestFrontendThreadMessageId = function (thread) {
	return $author$project$Id$fromInt(
		$author$project$MessageArray$length(thread.messages) - 1);
};
var $author$project$FrontendExtra$latestMessageThreadRoute$ = function (threadRoute, dmChannel) {
	if (threadRoute.$ === 1) {
		var threadId = threadRoute.a;
		return $author$project$Id$ViewThreadWithMessage$(
			threadId,
			$author$project$DmChannel$latestFrontendThreadMessageId(
				$elm$core$Maybe$withDefault$(
					$author$project$Thread$frontendInit,
					$lamdera$containers$SeqDict$get$(threadId, dmChannel.threads))));
	} else {
		return $author$project$Id$NoThreadWithMessage(
			$author$project$DmChannel$latestFrontendMessageId(dmChannel));
	}
};
var $author$project$FrontendExtra$latestMessageThreadRoute = F2($author$project$FrontendExtra$latestMessageThreadRoute$);
var $author$project$Message$threadRouteWithoutRepliedTo = function (threadRoute) {
	if (!threadRoute.$) {
		return $author$project$Id$NoThread;
	} else {
		var threadId = threadRoute.a;
		return $author$project$Id$ViewThread(threadId);
	}
};
var $author$project$FrontendExtra$handleServerSendDmMessage$ = function (id, dmChannelBefore, createdBy, createdByUser, stickers, messageForChannel, messageForThread, threadRouteWithRepliedTo, local) {
	var threadRouteNoReply = $author$project$Message$threadRouteWithoutRepliedTo(threadRouteWithRepliedTo);
	var localUser = local.localUser;
	var user = localUser.user;
	var guildOrDmId = $author$project$Id$GuildOrDmId(
		$author$project$Id$GuildOrDmId_Dm(id));
	var dmChannel = _Utils_update(
		dmChannelBefore,
		{
			lastTypedAt: $lamdera$containers$SeqDict$remove$(createdBy, dmChannelBefore.lastTypedAt)
		});
	var dmChannel2 = function () {
		if (threadRouteWithRepliedTo.$ === 1) {
			var threadId = threadRouteWithRepliedTo.a;
			var maybeReplyTo = threadRouteWithRepliedTo.b;
			return $author$project$LocalState$createThreadMessageFrontend$(
				threadId,
				messageForThread(maybeReplyTo),
				dmChannel);
		} else {
			var repliedTo = threadRouteWithRepliedTo.a;
			return $author$project$LocalState$createChannelMessageFrontend$(
				messageForChannel(repliedTo),
				dmChannel);
		}
	}();
	var _v0 = _Utils_eq(createdBy, localUser.session.userId) ? $author$project$LocalState$ownMessageIsReadFrontend$(
		guildOrDmId,
		$author$project$FrontendExtra$latestMessageThreadRoute$(threadRouteNoReply, dmChannel2),
		_Utils_Tuple2(localUser.currentlyViewing, user)) : ($author$project$FrontendExtra$isViewing$(guildOrDmId, threadRouteNoReply, local) ? $author$project$LocalState$incrementLastViewedMessageFrontend$(
		guildOrDmId,
		$author$project$FrontendExtra$latestMessageThreadRoute$(threadRouteNoReply, dmChannel2),
		_Utils_Tuple2(localUser.currentlyViewing, user)) : _Utils_Tuple2(localUser.currentlyViewing, user));
	var currentlyViewing2 = _v0.a;
	var user2 = _v0.b;
	return _Utils_update(
		local,
		{
			dmChannels: $lamdera$containers$SeqDict$insert$(id.otherUserId, dmChannel2, local.dmChannels),
			localUser: _Utils_update(
				localUser,
				{
					currentlyViewing: currentlyViewing2,
					otherUsers: $author$project$FrontendExtra$addMessageSender$(createdBy, createdByUser, localUser),
					stickers: $lamdera$containers$SeqDict$union$(stickers, localUser.stickers),
					user: user2
				})
		});
};
var $author$project$FrontendExtra$handleServerSendDmMessage = F9($author$project$FrontendExtra$handleServerSendDmMessage$);
var $lamdera$containers$SeqSet$intersect$ = function (_v0, _v1) {
	var d1 = _v0;
	var d2 = _v1;
	return $lamdera$containers$SeqDict$intersect$(d1, d2);
};
var $lamdera$containers$SeqSet$intersect = F2($lamdera$containers$SeqSet$intersect$);
var $lamdera$containers$SeqSet$isEmpty = function (_v0) {
	var dict = _v0;
	return $lamdera$containers$SeqDict$isEmpty(dict);
};
var $author$project$LinkedAndOtherDiscordUsers$isLinkedUser$ = function (userId, _v0) {
	var a = _v0.b;
	return $lamdera$containers$SeqDict$member$(userId, a);
};
var $author$project$LinkedAndOtherDiscordUsers$isLinkedUser = F2($author$project$LinkedAndOtherDiscordUsers$isLinkedUser$);
var $author$project$FrontendExtra$callStartedMessage$ = function (time, startedBy) {
	return $author$project$Message$CallStarted(
		{cardDrawings: $author$project$Drawing$emptyDrawing, endedAt: $elm$core$Maybe$Nothing, joinedBy: $lamdera$containers$SeqSet$empty, reactions: $lamdera$containers$SeqDict$empty, recordings: $elm$core$Maybe$Nothing, startedAt: time, startedBy: startedBy, timestampDrawings: $author$project$Drawing$emptyDrawing});
};
var $author$project$FrontendExtra$callStartedMessage = F2($author$project$FrontendExtra$callStartedMessage$);
var $author$project$MessageArray$findRightInRun$ = function (selectFunc, index, run) {
	findRightInRun:
	while (true) {
		var _v0 = $elm$core$Array$get$(index, run.values);
		if (!_v0.$) {
			var value = _v0.a;
			if (selectFunc(value)) {
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(
						$author$project$Id$fromInt(run.start + index),
						value));
			} else {
				var $temp$index = index - 1;
				index = $temp$index;
				continue findRightInRun;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$MessageArray$findRightInRun = F3($author$project$MessageArray$findRightInRun$);
var $author$project$MessageArray$findRightHelper$ = function (selectFunc, runIndex, runs) {
	findRightHelper:
	while (true) {
		var _v0 = $elm$core$Array$get$(runIndex, runs);
		if (!_v0.$) {
			var run = _v0.a;
			var _v1 = $author$project$MessageArray$findRightInRun$(
				selectFunc,
				$elm$core$Array$length(run.values) - 1,
				run);
			if (!_v1.$) {
				var found = _v1.a;
				return $elm$core$Maybe$Just(found);
			} else {
				var $temp$runIndex = runIndex - 1;
				runIndex = $temp$runIndex;
				continue findRightHelper;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$MessageArray$findRightHelper = F3($author$project$MessageArray$findRightHelper$);
var $author$project$MessageArray$findRight$ = function (selectFunc, _v0) {
	var array = _v0;
	return $author$project$MessageArray$findRightHelper$(
		selectFunc,
		$elm$core$Array$length(array.runs) - 1,
		array.runs);
};
var $author$project$MessageArray$findRight = F2($author$project$MessageArray$findRight$);
var $author$project$LocalState$joinedCallBy$ = function (userId, callStarted) {
	return _Utils_eq(callStarted.startedBy, userId) ? callStarted.joinedBy : $lamdera$containers$SeqSet$insert$(userId, callStarted.joinedBy);
};
var $author$project$LocalState$joinedCallBy = F2($author$project$LocalState$joinedCallBy$);
var $author$project$LocalState$joinedCallRecording$ = function (userId, maybeRecording) {
	if (!maybeRecording.$) {
		var recording = maybeRecording.a;
		return $elm$core$Maybe$Just(
			_Utils_update(
				recording,
				{
					finishedUploading: $lamdera$containers$SeqSet$remove$(userId, recording.finishedUploading),
					participants: $author$project$NonemptySet$insert$(userId, recording.participants)
				}));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$LocalState$joinedCallRecording = F2($author$project$LocalState$joinedCallRecording$);
var $author$project$LocalState$joinedCallMessageFrontend$ = function (userId, channel) {
	var _v0 = $author$project$MessageArray$findRight$(
		function (message) {
			if (message.$ === 4) {
				return true;
			} else {
				return false;
			}
		},
		channel.messages);
	if ((!_v0.$) && (_v0.a.b.$ === 4)) {
		var _v2 = _v0.a;
		var lastCallIndex = _v2.a;
		var callStarted = _v2.b.a;
		var _v3 = callStarted.endedAt;
		if (_v3.$ === 1) {
			return _Utils_update(
				channel,
				{
					messages: $author$project$MessageArray$set$(
						lastCallIndex,
						$author$project$Message$CallStarted(
							_Utils_update(
								callStarted,
								{
									joinedBy: $author$project$LocalState$joinedCallBy$(userId, callStarted),
									recordings: $author$project$LocalState$joinedCallRecording$(userId, callStarted.recordings)
								})),
						channel.messages)
				});
		} else {
			return channel;
		}
	} else {
		return channel;
	}
};
var $author$project$LocalState$joinedCallMessageFrontend = F2($author$project$LocalState$joinedCallMessageFrontend$);
var $author$project$FrontendExtra$joinCallHelper$ = function (userId, time, alreadyInCall, roomId, calls2, local) {
	if (alreadyInCall) {
		if (!roomId.$) {
			var otherUserId = roomId.a.otherUserId;
			return _Utils_update(
				local,
				{
					calls: calls2,
					dmChannels: $lamdera$containers$SeqDict$updateIfExists$(
						otherUserId,
						$author$project$LocalState$joinedCallMessageFrontend(userId),
						local.dmChannels)
				});
		} else {
			var id = roomId.a;
			return _Utils_update(
				local,
				{
					calls: calls2,
					guilds: $lamdera$containers$SeqDict$updateIfExists$(
						id.guildId,
						A2(
							$author$project$LocalState$updateChannel,
							$author$project$LocalState$joinedCallMessageFrontend(userId),
							id.channelId),
						local.guilds)
				});
		}
	} else {
		if (!roomId.$) {
			var otherUserId = roomId.a.otherUserId;
			var localUser = local.localUser;
			var dmChannel = $elm$core$Maybe$withDefault$(
				$author$project$DmChannel$frontendInit,
				$lamdera$containers$SeqDict$get$(otherUserId, local.dmChannels));
			var _v2 = _Utils_eq(userId, localUser.session.userId) ? $author$project$LocalState$ownMessageIsReadFrontend$(
				$author$project$Id$GuildOrDmId(
					$author$project$Id$GuildOrDmId_Dm(
						{otherUserId: otherUserId})),
				$author$project$Id$NoThreadWithMessage(
					$author$project$Id$fromInt(
						$author$project$MessageArray$length(dmChannel.messages))),
				_Utils_Tuple2(localUser.currentlyViewing, localUser.user)) : _Utils_Tuple2(localUser.currentlyViewing, localUser.user);
			var currentlyViewing2 = _v2.a;
			var user2 = _v2.b;
			return _Utils_update(
				local,
				{
					calls: calls2,
					dmChannels: $lamdera$containers$SeqDict$insert$(
						otherUserId,
						$author$project$LocalState$createChannelMessageFrontend$(
							$author$project$FrontendExtra$callStartedMessage$(time, userId),
							dmChannel),
						local.dmChannels),
					localUser: _Utils_update(
						localUser,
						{currentlyViewing: currentlyViewing2, user: user2})
				});
		} else {
			var id = roomId.a;
			var localUser = local.localUser;
			var _v3 = function () {
				var _v4 = _Utils_Tuple2(
					_Utils_eq(userId, localUser.session.userId),
					$author$project$LocalState$getGuildAndChannel$(id, local));
				if (_v4.a && (!_v4.b.$)) {
					var _v5 = _v4.b.a;
					var channel = _v5.b;
					return $author$project$LocalState$ownMessageIsReadFrontend$(
						$author$project$Id$GuildOrDmId(
							$author$project$Id$GuildOrDmId_Guild(id)),
						$author$project$Id$NoThreadWithMessage(
							$author$project$Id$fromInt(
								$author$project$MessageArray$length(channel.messages))),
						_Utils_Tuple2(localUser.currentlyViewing, localUser.user));
				} else {
					return _Utils_Tuple2(localUser.currentlyViewing, localUser.user);
				}
			}();
			var currentlyViewing2 = _v3.a;
			var user2 = _v3.b;
			return _Utils_update(
				local,
				{
					calls: calls2,
					guilds: $lamdera$containers$SeqDict$updateIfExists$(
						id.guildId,
						A2(
							$author$project$LocalState$updateChannel,
							$author$project$LocalState$createChannelMessageFrontend(
								$author$project$FrontendExtra$callStartedMessage$(time, userId)),
							id.channelId),
						local.guilds),
					localUser: _Utils_update(
						localUser,
						{currentlyViewing: currentlyViewing2, user: user2})
				});
		}
	}
};
var $author$project$FrontendExtra$joinCallHelper = F6($author$project$FrontendExtra$joinCallHelper$);
var $author$project$NonemptyDict$keys = function (_v0) {
	var id = _v0.a;
	var dict = _v0.c;
	return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
		id,
		$lamdera$containers$SeqDict$keys(dict));
};
var $author$project$LocalState$markCallMessageAsEndedFrontend$ = function (time, channel) {
	var lastCallIndex = $author$project$MessageArray$findRight$(
		function (message) {
			if (message.$ === 4) {
				return true;
			} else {
				return false;
			}
		},
		channel.messages);
	if (!lastCallIndex.$) {
		var _v1 = lastCallIndex.a;
		var lastCallIndex2 = _v1.a;
		var message = _v1.b;
		if (message.$ === 4) {
			var callStarted = message.a;
			var _v3 = callStarted.endedAt;
			if (_v3.$ === 1) {
				return _Utils_update(
					channel,
					{
						messages: $author$project$MessageArray$set$(
							lastCallIndex2,
							$author$project$Message$CallStarted(
								_Utils_update(
									callStarted,
									{
										endedAt: $elm$core$Maybe$Just(time)
									})),
							channel.messages)
					});
			} else {
				return channel;
			}
		} else {
			return channel;
		}
	} else {
		return channel;
	}
};
var $author$project$LocalState$markCallMessageAsEndedFrontend = F2($author$project$LocalState$markCallMessageAsEndedFrontend$);
var $author$project$FrontendExtra$leaveCall$ = function (time, local) {
	var calls = local.calls;
	var _v0 = calls.currentRoom;
	if (!_v0.$) {
		var roomId = _v0.a;
		if (!roomId.$) {
			var otherUserId = roomId.a.otherUserId;
			return _Utils_update(
				local,
				{
					calls: _Utils_update(
						calls,
						{currentRoom: $elm$core$Maybe$Nothing}),
					dmChannels: $lamdera$containers$SeqDict$member$(roomId, calls.voiceChats) ? local.dmChannels : $lamdera$containers$SeqDict$updateIfExists$(
						otherUserId,
						$author$project$LocalState$markCallMessageAsEndedFrontend(time),
						local.dmChannels)
				});
		} else {
			var channelId = roomId.a.channelId;
			var guildId = roomId.a.guildId;
			return _Utils_update(
				local,
				{
					calls: _Utils_update(
						calls,
						{currentRoom: $elm$core$Maybe$Nothing}),
					guilds: $lamdera$containers$SeqDict$member$(roomId, calls.voiceChats) ? local.guilds : $lamdera$containers$SeqDict$updateIfExists$(
						guildId,
						A2(
							$author$project$LocalState$updateChannel,
							$author$project$LocalState$markCallMessageAsEndedFrontend(time),
							channelId),
						local.guilds)
				});
		}
	} else {
		return local;
	}
};
var $author$project$FrontendExtra$leaveCall = F2($author$project$FrontendExtra$leaveCall$);
var $author$project$VisibleMessages$doneLoading = function (visibleMessages) {
	return _Utils_update(
		visibleMessages,
		{loadingMessages: false});
};
var $author$project$VisibleMessages$isLoading = function (visibleMessages) {
	return _Utils_update(
		visibleMessages,
		{loadingMessages: true});
};
var $author$project$DmChannel$loadMessages$ = function (messagesLoaded, channel) {
	if (messagesLoaded.$ === 1) {
		var messagesLoaded2 = messagesLoaded.a;
		return _Utils_update(
			channel,
			{
				messages: $author$project$MessageArray$setMany$(
					$lamdera$containers$SeqDict$toList(messagesLoaded2),
					channel.messages),
				visibleMessages: (!channel.visibleMessages.count) ? $author$project$VisibleMessages$firstLoad(
					$author$project$MessageArray$length(channel.messages)) : $author$project$VisibleMessages$doneLoading(channel.visibleMessages)
			});
	} else {
		return _Utils_update(
			channel,
			{
				visibleMessages: $author$project$VisibleMessages$isLoading(channel.visibleMessages)
			});
	}
};
var $author$project$DmChannel$loadMessages = F2($author$project$DmChannel$loadMessages$);
var $author$project$DmChannel$loadChannelMessages$ = function (messagesLoaded, channel) {
	if (messagesLoaded.$ === 1) {
		var messagesLoaded2 = messagesLoaded.a;
		return $author$project$DmChannel$loadMessages$(
			$author$project$UserSession$FilledInByBackend(messagesLoaded2.messages),
			_Utils_update(
				channel,
				{
					games: $author$project$DmChannel$addRepliedToMatches$(messagesLoaded2.repliedToMatches, channel.games)
				}));
	} else {
		return $author$project$DmChannel$loadMessages$($author$project$UserSession$EmptyPlaceholder, channel);
	}
};
var $author$project$DmChannel$loadChannelMessages = F2($author$project$DmChannel$loadChannelMessages$);
var $author$project$VisibleMessages$loadNewer$ = function (messageCount, firstNewMessage, visibleMessages) {
	var end = $elm$core$Basics$min$(
		messageCount,
		$author$project$Id$toInt(firstNewMessage) + $author$project$VisibleMessages$pageSize);
	var oldest = _Utils_eq(
		$author$project$Id$toInt(visibleMessages.oldest) + visibleMessages.count,
		$author$project$Id$toInt(firstNewMessage)) ? $elm$core$Basics$max$(
		$author$project$Id$toInt(visibleMessages.oldest),
		end - $author$project$VisibleMessages$maxCount) : $author$project$Id$toInt(firstNewMessage);
	return {
		count: $elm$core$Basics$max$(0, end - oldest),
		loadingMessages: false,
		oldest: $author$project$Id$fromInt(oldest)
	};
};
var $author$project$VisibleMessages$loadNewer = F3($author$project$VisibleMessages$loadNewer$);
var $author$project$VisibleMessages$loadOlder$ = function (previousOldestVisibleMessage, visibleMessages) {
	var oldestNext = $elm$core$Basics$max$(
		0,
		$author$project$Id$toInt(previousOldestVisibleMessage) - $author$project$VisibleMessages$pageSize);
	return {
		count: $elm$core$Basics$min$(
			$author$project$VisibleMessages$maxCount,
			visibleMessages.count + ($author$project$Id$toInt(visibleMessages.oldest) - oldestNext)),
		loadingMessages: false,
		oldest: $author$project$Id$fromInt(oldestNext)
	};
};
var $author$project$VisibleMessages$loadOlder = F2($author$project$VisibleMessages$loadOlder$);
var $author$project$DmChannel$loadPage$ = function (keep, pageRequest, messagesLoaded, channel) {
	if (messagesLoaded.$ === 1) {
		var messagesLoaded2 = messagesLoaded.a;
		var messages = $author$project$MessageArray$setMany$(
			$lamdera$containers$SeqDict$toList(messagesLoaded2),
			channel.messages);
		return $author$project$VisibleMessages$unloadHidden$(
			keep,
			_Utils_update(
				channel,
				{
					messages: messages,
					visibleMessages: function () {
						if (!pageRequest.$) {
							var previousOldestVisibleMessage = pageRequest.a;
							return $author$project$VisibleMessages$loadOlder$(previousOldestVisibleMessage, channel.visibleMessages);
						} else {
							var firstNewMessage = pageRequest.a;
							return $author$project$VisibleMessages$loadNewer$(
								$author$project$MessageArray$length(messages),
								firstNewMessage,
								channel.visibleMessages);
						}
					}()
				}));
	} else {
		return _Utils_update(
			channel,
			{
				visibleMessages: $author$project$VisibleMessages$isLoading(channel.visibleMessages)
			});
	}
};
var $author$project$DmChannel$loadPage = F4($author$project$DmChannel$loadPage$);
var $author$project$DmChannel$loadChannelPage$ = function (pageRequest, messagesLoaded, channel) {
	if (messagesLoaded.$ === 1) {
		var messagesLoaded2 = messagesLoaded.a;
		return $author$project$DmChannel$loadPage$(
			$lamdera$containers$SeqDict$keys(channel.threads),
			pageRequest,
			$author$project$UserSession$FilledInByBackend(messagesLoaded2.messages),
			_Utils_update(
				channel,
				{
					games: $author$project$DmChannel$addRepliedToMatches$(messagesLoaded2.repliedToMatches, channel.games)
				}));
	} else {
		return $author$project$DmChannel$loadPage$(_List_Nil, pageRequest, $author$project$UserSession$EmptyPlaceholder, channel);
	}
};
var $author$project$DmChannel$loadChannelPage = F3($author$project$DmChannel$loadChannelPage$);
var $author$project$DmChannel$loadUnreadMessages$ = function (messages, channel) {
	return _Utils_update(
		channel,
		{
			messages: $author$project$MessageArray$setMany$(
				$lamdera$containers$SeqDict$toList(messages),
				channel.messages)
		});
};
var $author$project$DmChannel$loadUnreadMessages = F2($author$project$DmChannel$loadUnreadMessages$);
var $author$project$TextEditor$localChangeUpdate$ = function (currentUserId, change, local) {
	switch (change.$) {
		case 0:
			var change2 = change.a;
			return $author$project$TextEditor$addEdit$(currentUserId, change2, local);
		case 1:
			return $author$project$TextEditor$initLocalState;
		case 2:
			return $author$project$TextEditor$undoChange$(currentUserId, local);
		default:
			return $author$project$TextEditor$redoChange$(currentUserId, local);
	}
};
var $author$project$TextEditor$localChangeUpdate = F3($author$project$TextEditor$localChangeUpdate$);
var $author$project$LocalState$markAllChannelsAndThreadsAsViewedFrontend$ = function (guildId, guild, user) {
	return _Utils_update(
		user,
		{
			lastViewedMessage: $lamdera$containers$SeqDict$foldl$(
				F3(
					function (channelId, channel, state) {
						return $lamdera$containers$SeqDict$insert$(
							$author$project$Id$GuildOrDmId(
								$author$project$Id$GuildOrDmId_Guild(
									{channelId: channelId, guildId: guildId})),
							$author$project$DmChannel$latestFrontendMessageId(channel),
							state);
					}),
				user.lastViewedMessage,
				guild.channels),
			lastViewedThreadMessage: $lamdera$containers$SeqDict$foldl$(
				F3(
					function (channelId, channel, state) {
						return $lamdera$containers$SeqDict$foldl$(
							F3(
								function (threadId, thread, state2) {
									return $lamdera$containers$SeqDict$insert$(
										_Utils_Tuple2(
											$author$project$Id$GuildOrDmId(
												$author$project$Id$GuildOrDmId_Guild(
													{channelId: channelId, guildId: guildId})),
											threadId),
										$author$project$DmChannel$latestFrontendThreadMessageId(thread),
										state2);
								}),
							state,
							channel.threads);
					}),
				user.lastViewedThreadMessage,
				guild.channels)
		});
};
var $author$project$LocalState$markAllChannelsAndThreadsAsViewedFrontend = F3($author$project$LocalState$markAllChannelsAndThreadsAsViewedFrontend$);
var $author$project$LocalState$markAllDiscordChannelsAndThreadsAsViewedFrontend$ = function (currentUserId, guildId, guild, user) {
	return $lamdera$containers$SeqDict$foldl$(
		F3(
			function (channelId, channel, user2) {
				var guildOrDmId = $author$project$Id$DiscordGuildOrDmId(
					$author$project$Id$DiscordGuildOrDmId_Guild(
						{channelId: channelId, currentUserId: currentUserId, guildId: guildId}));
				return _Utils_update(
					user2,
					{
						lastViewedMessage: $lamdera$containers$SeqDict$insert$(
							guildOrDmId,
							$author$project$DmChannel$latestFrontendMessageId(channel),
							user2.lastViewedMessage),
						lastViewedThreadMessage: $lamdera$containers$SeqDict$foldl$(
							F3(
								function (threadId, thread, state) {
									return $lamdera$containers$SeqDict$insert$(
										_Utils_Tuple2(guildOrDmId, threadId),
										$author$project$DmChannel$latestFrontendThreadMessageId(thread),
										state);
								}),
							user2.lastViewedThreadMessage,
							channel.threads)
					});
			}),
		user,
		guild.channels);
};
var $author$project$LocalState$markAllDiscordChannelsAndThreadsAsViewedFrontend = F4($author$project$LocalState$markAllDiscordChannelsAndThreadsAsViewedFrontend$);
var $author$project$LocalState$markDiscordDmAsViewedFrontend$ = function (currentUserId, channelId, dmChannel, user) {
	return _Utils_update(
		user,
		{
			lastViewedMessage: $lamdera$containers$SeqDict$insert$(
				$author$project$Id$DiscordGuildOrDmId(
					$author$project$Id$DiscordGuildOrDmId_Dm(
						{channelId: channelId, currentUserId: currentUserId})),
				$author$project$DmChannel$latestFrontendMessageId(dmChannel),
				user.lastViewedMessage)
		});
};
var $author$project$LocalState$markDiscordDmAsViewedFrontend = F4($author$project$LocalState$markDiscordDmAsViewedFrontend$);
var $author$project$FrontendExtra$markDiscordDataAsViewed$ = function (discordUserId, local) {
	var localUser = local.localUser;
	var guildsViewed = $lamdera$containers$SeqDict$foldl$(
		F3(
			function (guildId, guild, state) {
				var _v0 = $author$project$MembersAndOwner$isMember$(discordUserId, guild.membersAndOwner);
				if (_v0 === 2) {
					return state;
				} else {
					return $author$project$LocalState$markAllDiscordChannelsAndThreadsAsViewedFrontend$(discordUserId, guildId, guild, state);
				}
			}),
		localUser.user,
		local.discordGuilds);
	return _Utils_update(
		local,
		{
			localUser: _Utils_update(
				localUser,
				{
					user: $lamdera$containers$SeqDict$foldl$(
						F3(
							function (channelId, dmChannel, state) {
								return $author$project$NonemptyDict$member$(discordUserId, dmChannel.members) ? $author$project$LocalState$markDiscordDmAsViewedFrontend$(discordUserId, channelId, dmChannel, state) : state;
							}),
						guildsViewed,
						local.discordDmChannels)
				})
		});
};
var $author$project$FrontendExtra$markDiscordDataAsViewed = F2($author$project$FrontendExtra$markDiscordDataAsViewed$);
var $author$project$FrontendExtra$markNewSlackConversationsAsViewed$ = function (slackUserId, teamId, channelIds, dmChannelIds, local) {
	var markAsViewed = F3(
		function (guildOrDmId, conversation, user) {
			return (($author$project$MessageArray$length(conversation.messages) > 0) && (!$lamdera$containers$SeqDict$member$(
				$author$project$Id$SlackGuildOrDmId(guildOrDmId),
				user.lastViewedMessage))) ? $lamdera$containers$SeqDict$foldl$(
				F3(
					function (threadId, thread, user2) {
						return $author$project$User$setLastViewedMessage$(
							$author$project$Id$SlackGuildOrDmId(guildOrDmId),
							$author$project$Id$ViewThreadWithMessage$(
								threadId,
								$author$project$DmChannel$latestFrontendThreadMessageId(thread)),
							user2);
					}),
				$author$project$User$setLastViewedMessage$(
					$author$project$Id$SlackGuildOrDmId(guildOrDmId),
					$author$project$Id$NoThreadWithMessage(
						$author$project$DmChannel$latestFrontendMessageId(conversation)),
					user),
				conversation.threads) : user;
		});
	var markChannels = function (user) {
		var _v1 = $lamdera$containers$SeqDict$get$(teamId, local.slackWorkspaces);
		if (!_v1.$) {
			var workspace = _v1.a;
			return $elm$core$List$foldl$(
				F2(
					function (channelId, user2) {
						var _v2 = $lamdera$containers$SeqDict$get$(channelId, workspace.channels);
						if (!_v2.$) {
							var channel = _v2.a;
							return A3(
								markAsViewed,
								$author$project$Id$SlackGuildOrDmId_Workspace(
									{channelId: channelId, currentUserId: slackUserId, teamId: teamId}),
								channel,
								user2);
						} else {
							return user2;
						}
					}),
				user,
				channelIds);
		} else {
			return user;
		}
	};
	var markDmChannels = function (user) {
		return $elm$core$List$foldl$(
			F2(
				function (channelId, user2) {
					var _v0 = $lamdera$containers$SeqDict$get$(channelId, local.slackDmChannels);
					if (!_v0.$) {
						var dmChannel = _v0.a;
						return A3(
							markAsViewed,
							$author$project$Id$SlackGuildOrDmId_Dm(
								{channelId: channelId, currentUserId: slackUserId}),
							dmChannel,
							user2);
					} else {
						return user2;
					}
				}),
			user,
			dmChannelIds);
	};
	var localUser = local.localUser;
	return _Utils_update(
		local,
		{
			localUser: _Utils_update(
				localUser,
				{
					user: markDmChannels(
						markChannels(localUser.user))
				})
		});
};
var $author$project$FrontendExtra$markNewSlackConversationsAsViewed = F5($author$project$FrontendExtra$markNewSlackConversationsAsViewed$);
var $author$project$LocalState$isAuthor$ = function (userId, maybeMessage) {
	_v0$2:
	while (true) {
		if (!maybeMessage.$) {
			switch (maybeMessage.a.$) {
				case 0:
					var data = maybeMessage.a.a;
					return _Utils_eq(data.createdBy, userId);
				case 1:
					var data = maybeMessage.a.a;
					return _Utils_eq(data.createdBy, userId);
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return false;
};
var $author$project$LocalState$isAuthor = F2($author$project$LocalState$isAuthor$);
var $author$project$LocalState$discordDmMemberIsEditTypingFrontend$ = function (time, userId, messageId, dmChannel) {
	return $author$project$LocalState$isAuthor$(
		userId,
		$author$project$MessageArray$get$(messageId, dmChannel.messages)) ? $elm$core$Result$Ok(
		_Utils_update(
			dmChannel,
			{
				lastTypedAt: $lamdera$containers$SeqDict$insert$(
					userId,
					{
						messageIndex: $elm$core$Maybe$Just(messageId),
						time: time
					},
					dmChannel.lastTypedAt)
			})) : $elm$core$Result$Err(0);
};
var $author$project$LocalState$discordDmMemberIsEditTypingFrontend = F4($author$project$LocalState$discordDmMemberIsEditTypingFrontend$);
var $author$project$LocalState$isOwnMessageFrontend$ = function (userId, threadRoute, channel) {
	if (threadRoute.$ === 1) {
		var threadId = threadRoute.a;
		var messageId = threadRoute.b;
		var _v1 = $lamdera$containers$SeqDict$get$(threadId, channel.threads);
		if (!_v1.$) {
			var thread = _v1.a;
			return $author$project$LocalState$isAuthor$(
				userId,
				$author$project$MessageArray$get$(messageId, thread.messages));
		} else {
			return false;
		}
	} else {
		var messageId = threadRoute.a;
		return $author$project$LocalState$isAuthor$(
			userId,
			$author$project$MessageArray$get$(messageId, channel.messages));
	}
};
var $author$project$LocalState$isOwnMessageFrontend = F3($author$project$LocalState$isOwnMessageFrontend$);
var $author$project$LocalState$dmMemberIsEditTypingFrontend$ = function (time, userId, threadRoute, dmChannel) {
	return $author$project$LocalState$isOwnMessageFrontend$(userId, threadRoute, dmChannel) ? $elm$core$Result$Ok(
		_Utils_update(
			dmChannel,
			{
				lastTypedAt: $lamdera$containers$SeqDict$insert$(
					userId,
					{
						threadRoute: $author$project$Id$threadRouteWithJustMessage(threadRoute),
						time: time
					},
					dmChannel.lastTypedAt)
			})) : $elm$core$Result$Err(0);
};
var $author$project$LocalState$dmMemberIsEditTypingFrontend = F4($author$project$LocalState$dmMemberIsEditTypingFrontend$);
var $author$project$LocalState$memberIsEditTypingFrontend$ = function (userId, time, channelId, threadRoute, guild) {
	var _v0 = $lamdera$containers$SeqDict$get$(channelId, guild.channels);
	if (!_v0.$) {
		var channel = _v0.a;
		return $author$project$LocalState$isOwnMessageFrontend$(userId, threadRoute, channel) ? $elm$core$Result$Ok(
			_Utils_update(
				guild,
				{
					lastTypedAt: $lamdera$containers$SeqDict$insert$(
						userId,
						{
							channelId: channelId,
							threadRoute: $author$project$Id$threadRouteWithJustMessage(threadRoute),
							time: time
						},
						guild.lastTypedAt)
				})) : $elm$core$Result$Err(0);
	} else {
		return $elm$core$Result$Err(0);
	}
};
var $author$project$LocalState$memberIsEditTypingFrontend = F5($author$project$LocalState$memberIsEditTypingFrontend$);
var $author$project$FrontendExtra$memberEditTyping$ = function (time, userId, guildOrDmId, threadRoute, local) {
	switch (guildOrDmId.$) {
		case 0:
			if (!guildOrDmId.a.$) {
				var channelId = guildOrDmId.a.a.channelId;
				var guildId = guildOrDmId.a.a.guildId;
				return _Utils_update(
					local,
					{
						guilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							function (guild) {
								return $elm$core$Result$withDefault$(
									guild,
									$author$project$LocalState$memberIsEditTypingFrontend$(userId, time, channelId, threadRoute, guild));
							},
							local.guilds)
					});
			} else {
				var otherUserId = guildOrDmId.a.a.otherUserId;
				return _Utils_update(
					local,
					{
						dmChannels: $lamdera$containers$SeqDict$updateIfExists$(
							otherUserId,
							function (dmChannel) {
								return $elm$core$Result$withDefault$(
									dmChannel,
									$author$project$LocalState$dmMemberIsEditTypingFrontend$(time, userId, threadRoute, dmChannel));
							},
							local.dmChannels)
					});
			}
		case 1:
			if (!guildOrDmId.a.$) {
				var channelId = guildOrDmId.a.a.channelId;
				var guildId = guildOrDmId.a.a.guildId;
				var currentUserId = guildOrDmId.a.a.currentUserId;
				return _Utils_update(
					local,
					{
						discordGuilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							function (guild) {
								return $elm$core$Result$withDefault$(
									guild,
									$author$project$LocalState$memberIsEditTypingFrontend$(currentUserId, time, channelId, threadRoute, guild));
							},
							local.discordGuilds)
					});
			} else {
				var channelId = guildOrDmId.a.a.channelId;
				var currentUserId = guildOrDmId.a.a.currentUserId;
				if (threadRoute.$ === 1) {
					return local;
				} else {
					var messageId = threadRoute.a;
					return _Utils_update(
						local,
						{
							discordDmChannels: $lamdera$containers$SeqDict$updateIfExists$(
								channelId,
								function (dmChannel) {
									return $elm$core$Result$withDefault$(
										dmChannel,
										$author$project$LocalState$discordDmMemberIsEditTypingFrontend$(time, currentUserId, messageId, dmChannel));
								},
								local.discordDmChannels)
						});
				}
			}
		default:
			return local;
	}
};
var $author$project$FrontendExtra$memberEditTyping = F5($author$project$FrontendExtra$memberEditTyping$);
var $author$project$LocalState$dmMemberIsTyping$ = function (userId, time, threadRoute, dmChannel) {
	return _Utils_update(
		dmChannel,
		{
			lastTypedAt: $lamdera$containers$SeqDict$insert$(
				userId,
				{
					threadRoute: $author$project$Id$threadRouteWithNoMessage(threadRoute),
					time: time
				},
				dmChannel.lastTypedAt)
		});
};
var $author$project$LocalState$dmMemberIsTyping = F4($author$project$LocalState$dmMemberIsTyping$);
var $author$project$FrontendExtra$memberTyping$ = function (time, userId, guildOrDmId, threadRoute, local) {
	if (!guildOrDmId.$) {
		var channelId = guildOrDmId.a.channelId;
		var guildId = guildOrDmId.a.guildId;
		return _Utils_update(
			local,
			{
				guilds: $lamdera$containers$SeqDict$updateIfExists$(
					guildId,
					A4($author$project$LocalState$memberIsTyping, userId, time, channelId, threadRoute),
					local.guilds)
			});
	} else {
		var otherUserId = guildOrDmId.a.otherUserId;
		return _Utils_update(
			local,
			{
				dmChannels: $lamdera$containers$SeqDict$updateIfExists$(
					otherUserId,
					A3($author$project$LocalState$dmMemberIsTyping, userId, time, threadRoute),
					local.dmChannels)
			});
	}
};
var $author$project$FrontendExtra$memberTyping = F5($author$project$FrontendExtra$memberTyping$);
var $author$project$FrontendExtra$newMessageThreadRoute$ = function (threadRoute, channel) {
	if (threadRoute.$ === 1) {
		var threadId = threadRoute.a;
		return $author$project$Id$ViewThreadWithMessage$(
			threadId,
			$author$project$Id$fromInt(
				$elm$core$Maybe$withDefault$(
					0,
					$elm$core$Maybe$map$(
						function (thread) {
							return $author$project$MessageArray$length(thread.messages);
						},
						$lamdera$containers$SeqDict$get$(threadId, channel.threads)))));
	} else {
		return $author$project$Id$NoThreadWithMessage(
			$author$project$Id$fromInt(
				$author$project$MessageArray$length(channel.messages)));
	}
};
var $author$project$FrontendExtra$newMessageThreadRoute = F2($author$project$FrontendExtra$newMessageThreadRoute$);
var $author$project$NonemptyDict$remove$ = function (k, _v0) {
	var id = _v0.a;
	var v = _v0.b;
	var set = _v0.c;
	return _Utils_eq(k, id) ? set : $lamdera$containers$SeqDict$insert$(
		id,
		v,
		$lamdera$containers$SeqDict$remove$(k, set));
};
var $author$project$NonemptyDict$remove = F2($author$project$NonemptyDict$remove$);
var $author$project$FrontendExtra$otherUserLeaveCall$ = function (time, _v0, local) {
	var otherClientId = _v0.otherClientId;
	var roomId = _v0.roomId;
	var calls = local.calls;
	var _v1 = $lamdera$containers$SeqDict$get$(roomId, calls.voiceChats);
	if (!_v1.$) {
		var dmVoiceChat = _v1.a;
		var voiceChats = $lamdera$containers$SeqDict$update$(
			roomId,
			function (_v5) {
				return $author$project$NonemptyDict$fromSeqDict(
					$author$project$NonemptyDict$remove$(otherClientId, dmVoiceChat));
			},
			calls.voiceChats);
		if (!roomId.$) {
			var otherUserId = roomId.a.otherUserId;
			return _Utils_update(
				local,
				{
					calls: _Utils_update(
						calls,
						{voiceChats: voiceChats}),
					dmChannels: function () {
						var _v3 = _Utils_Tuple2(
							_Utils_eq(
								calls.currentRoom,
								$elm$core$Maybe$Just(roomId)),
							$lamdera$containers$SeqDict$member$(roomId, voiceChats));
						if ((!_v3.a) && (!_v3.b)) {
							return $lamdera$containers$SeqDict$updateIfExists$(
								otherUserId,
								$author$project$LocalState$markCallMessageAsEndedFrontend(time),
								local.dmChannels);
						} else {
							return local.dmChannels;
						}
					}()
				});
		} else {
			var channelId = roomId.a.channelId;
			var guildId = roomId.a.guildId;
			return _Utils_update(
				local,
				{
					calls: _Utils_update(
						calls,
						{voiceChats: voiceChats}),
					guilds: function () {
						var _v4 = _Utils_Tuple2(
							_Utils_eq(
								calls.currentRoom,
								$elm$core$Maybe$Just(roomId)),
							$lamdera$containers$SeqDict$member$(roomId, voiceChats));
						if ((!_v4.a) && (!_v4.b)) {
							return $lamdera$containers$SeqDict$updateIfExists$(
								guildId,
								A2(
									$author$project$LocalState$updateChannel,
									$author$project$LocalState$markCallMessageAsEndedFrontend(time),
									channelId),
								local.guilds);
						} else {
							return local.guilds;
						}
					}()
				});
		}
	} else {
		return local;
	}
};
var $author$project$FrontendExtra$otherUserLeaveCall = F3($author$project$FrontendExtra$otherUserLeaveCall$);
var $author$project$LocalState$removeInvite$ = function (inviteId, guild) {
	return _Utils_update(
		guild,
		{
			invites: $lamdera$containers$SeqDict$remove$(inviteId, guild.invites)
		});
};
var $author$project$LocalState$removeInvite = F2($author$project$LocalState$removeInvite$);
var $author$project$MembersAndOwner$removeMember$ = function (userId, _v0) {
	var members2 = _v0.a;
	var ownerId = _v0.b;
	return $author$project$MembersAndOwner$MembersAndOwner$(
		$lamdera$containers$SeqDict$remove$(userId, members2),
		ownerId);
};
var $author$project$MembersAndOwner$removeMember = F2($author$project$MembersAndOwner$removeMember$);
var $author$project$Message$removeReactionEmojiHelper$ = function (userId, emoji, reactions) {
	return $lamdera$containers$SeqDict$update$(
		emoji,
		function (maybeSet) {
			if (!maybeSet.$) {
				var nonempty = maybeSet.a;
				return $author$project$NonemptySet$fromSeqSet(
					$lamdera$containers$SeqSet$remove$(
						userId,
						$author$project$NonemptySet$toSeqSet(nonempty)));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		reactions);
};
var $author$project$Message$removeReactionEmojiHelper = F3($author$project$Message$removeReactionEmojiHelper$);
var $author$project$Message$removeReactionEmoji$ = function (userId, emoji, message) {
	switch (message.$) {
		case 0:
			var message2 = message.a;
			return $author$project$Message$UserTextMessage(
				_Utils_update(
					message2,
					{
						reactions: $author$project$Message$removeReactionEmojiHelper$(userId, emoji, message2.reactions)
					}));
		case 1:
			var message2 = message.a;
			return $author$project$Message$EncryptedUserTextMessage(
				_Utils_update(
					message2,
					{
						reactions: $author$project$Message$removeReactionEmojiHelper$(userId, emoji, message2.reactions)
					}));
		case 2:
			var time = message.a;
			var userJoinedId = message.b;
			var reactions = message.c;
			var drawings = message.d;
			return $author$project$Message$UserJoinedMessage$(
				time,
				userJoinedId,
				$author$project$Message$removeReactionEmojiHelper$(userId, emoji, reactions),
				drawings);
		case 3:
			return message;
		case 4:
			var callStarted = message.a;
			return $author$project$Message$CallStarted(
				_Utils_update(
					callStarted,
					{
						reactions: $author$project$Message$removeReactionEmojiHelper$(userId, emoji, callStarted.reactions)
					}));
		default:
			var gameStarted = message.a;
			return $author$project$Message$GameStarted(
				_Utils_update(
					gameStarted,
					{
						reactions: $author$project$Message$removeReactionEmojiHelper$(userId, emoji, gameStarted.reactions)
					}));
	}
};
var $author$project$Message$removeReactionEmoji = F3($author$project$Message$removeReactionEmoji$);
var $author$project$LocalState$removeReactionEmojiFrontendHelper$ = function (emoji, userId, messageId, channel) {
	return _Utils_update(
		channel,
		{
			messages: $author$project$MessageArray$updateIfExists$(
				messageId,
				A2($author$project$Message$removeReactionEmoji, userId, emoji),
				channel.messages)
		});
};
var $author$project$LocalState$removeReactionEmojiFrontendHelper = F4($author$project$LocalState$removeReactionEmojiFrontendHelper$);
var $author$project$LocalState$removeReactionEmojiFrontend$ = function (emoji, userId, threadRoute, channel) {
	if (threadRoute.$ === 1) {
		var threadId = threadRoute.a;
		var messageId = threadRoute.b;
		return _Utils_update(
			channel,
			{
				threads: $lamdera$containers$SeqDict$updateIfExists$(
					threadId,
					A3($author$project$LocalState$removeReactionEmojiFrontendHelper, emoji, userId, messageId),
					channel.threads)
			});
	} else {
		var messageId = threadRoute.a;
		return $author$project$LocalState$removeReactionEmojiFrontendHelper$(emoji, userId, messageId, channel);
	}
};
var $author$project$LocalState$removeReactionEmojiFrontend = F4($author$project$LocalState$removeReactionEmojiFrontend$);
var $author$project$FrontendExtra$removeReactionEmoji$ = function (userId, guildOrDmId, threadRoute, emoji, local) {
	switch (guildOrDmId.$) {
		case 0:
			if (!guildOrDmId.a.$) {
				var channelId = guildOrDmId.a.a.channelId;
				var guildId = guildOrDmId.a.a.guildId;
				return _Utils_update(
					local,
					{
						guilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							A2(
								$author$project$LocalState$updateChannel,
								A3($author$project$LocalState$removeReactionEmojiFrontend, emoji, userId, threadRoute),
								channelId),
							local.guilds)
					});
			} else {
				var otherUserId = guildOrDmId.a.a.otherUserId;
				return _Utils_update(
					local,
					{
						dmChannels: $lamdera$containers$SeqDict$updateIfExists$(
							otherUserId,
							A3($author$project$LocalState$removeReactionEmojiFrontend, emoji, userId, threadRoute),
							local.dmChannels)
					});
			}
		case 1:
			if (!guildOrDmId.a.$) {
				var channelId = guildOrDmId.a.a.channelId;
				var guildId = guildOrDmId.a.a.guildId;
				var currentUserId = guildOrDmId.a.a.currentUserId;
				return _Utils_update(
					local,
					{
						discordGuilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							A2(
								$author$project$LocalState$updateChannel,
								A3($author$project$LocalState$removeReactionEmojiFrontend, emoji, currentUserId, threadRoute),
								channelId),
							local.discordGuilds)
					});
			} else {
				var channelId = guildOrDmId.a.a.channelId;
				var currentUserId = guildOrDmId.a.a.currentUserId;
				if (threadRoute.$ === 1) {
					return local;
				} else {
					var messageId = threadRoute.a;
					return _Utils_update(
						local,
						{
							discordDmChannels: $lamdera$containers$SeqDict$updateIfExists$(
								channelId,
								A3($author$project$LocalState$removeReactionEmojiFrontendHelper, emoji, currentUserId, messageId),
								local.discordDmChannels)
						});
				}
			}
		default:
			if (!guildOrDmId.a.$) {
				var channelId = guildOrDmId.a.a.channelId;
				var teamId = guildOrDmId.a.a.teamId;
				var currentUserId = guildOrDmId.a.a.currentUserId;
				return _Utils_update(
					local,
					{
						slackWorkspaces: $lamdera$containers$SeqDict$updateIfExists$(
							teamId,
							A2(
								$author$project$LocalState$updateChannel,
								A3($author$project$LocalState$removeReactionEmojiFrontend, emoji, currentUserId, threadRoute),
								channelId),
							local.slackWorkspaces)
					});
			} else {
				var channelId = guildOrDmId.a.a.channelId;
				var currentUserId = guildOrDmId.a.a.currentUserId;
				return _Utils_update(
					local,
					{
						slackDmChannels: $lamdera$containers$SeqDict$updateIfExists$(
							channelId,
							A3($author$project$LocalState$removeReactionEmojiFrontend, emoji, currentUserId, threadRoute),
							local.slackDmChannels)
					});
			}
	}
};
var $author$project$FrontendExtra$removeReactionEmoji = F5($author$project$FrontendExtra$removeReactionEmoji$);
var $author$project$User$setColor$ = function (color, user) {
	return _Utils_update(
		user,
		{color: color});
};
var $author$project$User$setColor = F2($author$project$User$setColor$);
var $author$project$User$setDiscordGuildNotificationLevel$ = function (guildId, notificationLevel, user) {
	return _Utils_update(
		user,
		{
			discordNotifyOnAllMessages: function () {
				if (!notificationLevel) {
					return $lamdera$containers$SeqSet$insert$(guildId, user.discordNotifyOnAllMessages);
				} else {
					return $lamdera$containers$SeqSet$remove$(guildId, user.discordNotifyOnAllMessages);
				}
			}()
		});
};
var $author$project$User$setDiscordGuildNotificationLevel = F3($author$project$User$setDiscordGuildNotificationLevel$);
var $author$project$LocalState$setDmE2ee$ = function (_v0, e2ee, local) {
	var otherUserId = _v0.otherUserId;
	var emptyDmChannel = $author$project$DmChannel$frontendInit;
	return _Utils_update(
		local,
		{
			dmChannels: $lamdera$containers$SeqDict$update$(
				otherUserId,
				function (maybeDmChannel) {
					return $elm$core$Maybe$Just(
						function () {
							if (!maybeDmChannel.$) {
								var dmChannel = maybeDmChannel.a;
								return _Utils_update(
									dmChannel,
									{e2ee: e2ee});
							} else {
								return _Utils_update(
									emptyDmChannel,
									{e2ee: e2ee});
							}
						}());
				},
				local.dmChannels)
		});
};
var $author$project$LocalState$setDmE2ee = F3($author$project$LocalState$setDmE2ee$);
var $author$project$User$setDomainWhitelist$ = function (enable, domain, user) {
	return _Utils_update(
		user,
		{
			domainWhitelist: enable ? $lamdera$containers$SeqSet$insert$(domain, user.domainWhitelist) : $lamdera$containers$SeqSet$remove$(domain, user.domainWhitelist)
		});
};
var $author$project$User$setDomainWhitelist = F3($author$project$User$setDomainWhitelist$);
var $author$project$User$setEmailNotifications$ = function (emailNotifications, user) {
	return _Utils_update(
		user,
		{emailNotifications: emailNotifications});
};
var $author$project$User$setEmailNotifications = F2($author$project$User$setEmailNotifications$);
var $author$project$User$setEmbedVisibility$ = function (embedVisibility, user) {
	return _Utils_update(
		user,
		{embedVisibility: embedVisibility});
};
var $author$project$User$setEmbedVisibility = F2($author$project$User$setEmbedVisibility$);
var $author$project$User$setEmojiSkinTone$ = function (skinTone, user) {
	var emojiConfig = user.emojiConfig;
	return _Utils_update(
		user,
		{
			emojiConfig: _Utils_update(
				emojiConfig,
				{skinTone: skinTone})
		});
};
var $author$project$User$setEmojiSkinTone = F2($author$project$User$setEmojiSkinTone$);
var $author$project$User$setGuildNotificationLevel$ = function (guildId, notificationLevel, user) {
	return _Utils_update(
		user,
		{
			notifyOnAllMessages: function () {
				if (!notificationLevel) {
					return $lamdera$containers$SeqSet$insert$(guildId, user.notifyOnAllMessages);
				} else {
					return $lamdera$containers$SeqSet$remove$(guildId, user.notifyOnAllMessages);
				}
			}()
		});
};
var $author$project$User$setGuildNotificationLevel = F3($author$project$User$setGuildNotificationLevel$);
var $author$project$User$setIcon$ = function (icon, user) {
	return _Utils_update(
		user,
		{icon: icon});
};
var $author$project$User$setIcon = F2($author$project$User$setIcon$);
var $author$project$User$setLastChannelViewed$ = function (id, threadRoute, user) {
	var threadRouteNoMessage = function () {
		if (threadRoute.$ === 1) {
			var threadId = threadRoute.a;
			return $author$project$Id$ViewThread(threadId);
		} else {
			return $author$project$Id$NoThread;
		}
	}();
	var user2 = _Utils_update(
		user,
		{
			directMentions: $lamdera$containers$SeqDict$update$(
				id.guildId,
				function (maybeDict) {
					if (!maybeDict.$) {
						var dict = maybeDict.a;
						return $author$project$NonemptyDict$fromSeqDict(
							$lamdera$containers$SeqDict$remove$(
								_Utils_Tuple2(id.channelId, threadRouteNoMessage),
								$author$project$NonemptyDict$toSeqDict(dict)));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				user.directMentions),
			lastChannelViewed: $lamdera$containers$SeqDict$insert$(
				id.guildId,
				_Utils_Tuple2(id.channelId, threadRouteNoMessage),
				user.lastChannelViewed)
		});
	if (threadRoute.$ === 1) {
		if (!threadRoute.b.$) {
			var threadId = threadRoute.a;
			var messageId = threadRoute.b.a;
			return _Utils_update(
				user2,
				{
					lastViewedThreadMessage: $lamdera$containers$SeqDict$insert$(
						_Utils_Tuple2(
							$author$project$Id$GuildOrDmId(
								$author$project$Id$GuildOrDmId_Guild(id)),
							threadId),
						messageId,
						user2.lastViewedThreadMessage)
				});
		} else {
			var _v1 = threadRoute.b;
			return user2;
		}
	} else {
		if (!threadRoute.a.$) {
			var messageId = threadRoute.a.a;
			return _Utils_update(
				user2,
				{
					lastViewedMessage: $lamdera$containers$SeqDict$insert$(
						$author$project$Id$GuildOrDmId(
							$author$project$Id$GuildOrDmId_Guild(id)),
						messageId,
						user2.lastViewedMessage)
				});
		} else {
			var _v2 = threadRoute.a;
			return user2;
		}
	}
};
var $author$project$User$setLastChannelViewed = F3($author$project$User$setLastChannelViewed$);
var $author$project$User$setLastDiscordChannelViewed$ = function (id, threadRoute, user) {
	var threadRouteNoMessage = function () {
		if (threadRoute.$ === 1) {
			var threadId = threadRoute.a;
			return $author$project$Id$ViewThread(threadId);
		} else {
			return $author$project$Id$NoThread;
		}
	}();
	var user2 = _Utils_update(
		user,
		{
			discordDirectMentions: $lamdera$containers$SeqDict$update$(
				id.guildId,
				function (maybeDict) {
					if (!maybeDict.$) {
						var dict = maybeDict.a;
						return $author$project$NonemptyDict$fromSeqDict(
							$lamdera$containers$SeqDict$remove$(
								_Utils_Tuple2(id.channelId, threadRouteNoMessage),
								$author$project$NonemptyDict$toSeqDict(dict)));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				user.discordDirectMentions),
			lastDiscordChannelViewed: $lamdera$containers$SeqDict$insert$(
				id.guildId,
				_Utils_Tuple2(id.channelId, threadRouteNoMessage),
				user.lastDiscordChannelViewed)
		});
	if (threadRoute.$ === 1) {
		if (!threadRoute.b.$) {
			var threadId = threadRoute.a;
			var messageId = threadRoute.b.a;
			return _Utils_update(
				user2,
				{
					lastViewedThreadMessage: $lamdera$containers$SeqDict$insert$(
						_Utils_Tuple2(
							$author$project$Id$DiscordGuildOrDmId(
								$author$project$Id$DiscordGuildOrDmId_Guild(id)),
							threadId),
						messageId,
						user2.lastViewedThreadMessage)
				});
		} else {
			var _v1 = threadRoute.b;
			return user2;
		}
	} else {
		if (!threadRoute.a.$) {
			var messageId = threadRoute.a.a;
			return _Utils_update(
				user2,
				{
					lastViewedMessage: $lamdera$containers$SeqDict$insert$(
						$author$project$Id$DiscordGuildOrDmId(
							$author$project$Id$DiscordGuildOrDmId_Guild(id)),
						messageId,
						user2.lastViewedMessage)
				});
		} else {
			var _v2 = threadRoute.a;
			return user2;
		}
	}
};
var $author$project$User$setLastDiscordChannelViewed = F3($author$project$User$setLastDiscordChannelViewed$);
var $author$project$User$DiscordDmChannelLastViewed = function (a) {
	return {$: 1, a: a};
};
var $author$project$User$setLastDiscordDmViewed$ = function (currentUserId, channelId, maybeMessageId, user) {
	if (!maybeMessageId.$) {
		var messageId = maybeMessageId.a;
		return _Utils_update(
			user,
			{
				lastDmViewed: $author$project$User$DiscordDmChannelLastViewed(channelId),
				lastViewedMessage: $lamdera$containers$SeqDict$insert$(
					$author$project$Id$DiscordGuildOrDmId(
						$author$project$Id$DiscordGuildOrDmId_Dm(
							{channelId: channelId, currentUserId: currentUserId})),
					messageId,
					user.lastViewedMessage)
			});
	} else {
		return _Utils_update(
			user,
			{
				lastDmViewed: $author$project$User$DiscordDmChannelLastViewed(channelId)
			});
	}
};
var $author$project$User$setLastDiscordDmViewed = F4($author$project$User$setLastDiscordDmViewed$);
var $author$project$User$DmChannelLastViewed$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$User$DmChannelLastViewed = F2($author$project$User$DmChannelLastViewed$);
var $author$project$User$setLastDmViewed$ = function (id, threadRoute, user) {
	var user2 = _Utils_update(
		user,
		{
			lastDmViewed: $author$project$User$DmChannelLastViewed$(
				id.otherUserId,
				function () {
					if (threadRoute.$ === 1) {
						var threadId = threadRoute.a;
						return $author$project$Id$ViewThread(threadId);
					} else {
						return $author$project$Id$NoThread;
					}
				}())
		});
	if (threadRoute.$ === 1) {
		if (!threadRoute.b.$) {
			var threadId = threadRoute.a;
			var messageId = threadRoute.b.a;
			return _Utils_update(
				user2,
				{
					lastViewedThreadMessage: $lamdera$containers$SeqDict$insert$(
						_Utils_Tuple2(
							$author$project$Id$GuildOrDmId(
								$author$project$Id$GuildOrDmId_Dm(id)),
							threadId),
						messageId,
						user2.lastViewedThreadMessage)
				});
		} else {
			var _v1 = threadRoute.b;
			return user2;
		}
	} else {
		if (!threadRoute.a.$) {
			var messageId = threadRoute.a.a;
			return _Utils_update(
				user2,
				{
					lastViewedMessage: $lamdera$containers$SeqDict$insert$(
						$author$project$Id$GuildOrDmId(
							$author$project$Id$GuildOrDmId_Dm(id)),
						messageId,
						user2.lastViewedMessage)
				});
		} else {
			var _v2 = threadRoute.a;
			return user2;
		}
	}
};
var $author$project$User$setLastDmViewed = F3($author$project$User$setLastDmViewed$);
var $author$project$User$setLastSlackChannelViewed$ = function (id, threadRoute, user) {
	var threadRouteNoMessage = function () {
		if (threadRoute.$ === 1) {
			var threadId = threadRoute.a;
			return $author$project$Id$ViewThread(threadId);
		} else {
			return $author$project$Id$NoThread;
		}
	}();
	var user2 = _Utils_update(
		user,
		{
			lastSlackChannelViewed: $lamdera$containers$SeqDict$insert$(
				id.teamId,
				_Utils_Tuple2(id.channelId, threadRouteNoMessage),
				user.lastSlackChannelViewed),
			slackDirectMentions: $lamdera$containers$SeqDict$update$(
				id.teamId,
				$elm$core$Maybe$andThen(
					function (dict) {
						return $author$project$NonemptyDict$fromSeqDict(
							$lamdera$containers$SeqDict$remove$(
								_Utils_Tuple2(id.channelId, threadRouteNoMessage),
								$author$project$NonemptyDict$toSeqDict(dict)));
					}),
				user.slackDirectMentions)
		});
	if (threadRoute.$ === 1) {
		if (!threadRoute.b.$) {
			var threadId = threadRoute.a;
			var messageId = threadRoute.b.a;
			return _Utils_update(
				user2,
				{
					lastViewedThreadMessage: $lamdera$containers$SeqDict$insert$(
						_Utils_Tuple2(
							$author$project$Id$SlackGuildOrDmId(
								$author$project$Id$SlackGuildOrDmId_Workspace(id)),
							threadId),
						messageId,
						user2.lastViewedThreadMessage)
				});
		} else {
			var _v1 = threadRoute.b;
			return user2;
		}
	} else {
		if (!threadRoute.a.$) {
			var messageId = threadRoute.a.a;
			return _Utils_update(
				user2,
				{
					lastViewedMessage: $lamdera$containers$SeqDict$insert$(
						$author$project$Id$SlackGuildOrDmId(
							$author$project$Id$SlackGuildOrDmId_Workspace(id)),
						messageId,
						user2.lastViewedMessage)
				});
		} else {
			var _v2 = threadRoute.a;
			return user2;
		}
	}
};
var $author$project$User$setLastSlackChannelViewed = F3($author$project$User$setLastSlackChannelViewed$);
var $author$project$UserSession$LastViewedDiscordGuild = function (a) {
	return {$: 1, a: a};
};
var $author$project$UserSession$LastViewedGuild = function (a) {
	return {$: 0, a: a};
};
var $author$project$UserSession$LastViewedSlackWorkspace = function (a) {
	return {$: 2, a: a};
};
var $author$project$UserSession$setLastViewedGuild$ = function (viewing, session) {
	switch (viewing.$) {
		case 3:
			var data = viewing.a;
			return _Utils_update(
				session,
				{
					lastViewedGuild: $elm$core$Maybe$Just(
						$author$project$UserSession$LastViewedGuild(data.id.guildId))
				});
		case 4:
			var data = viewing.a;
			return _Utils_update(
				session,
				{
					lastViewedGuild: $elm$core$Maybe$Just(
						$author$project$UserSession$LastViewedGuild(data.id.guildId))
				});
		case 5:
			var data = viewing.a;
			return _Utils_update(
				session,
				{
					lastViewedGuild: $elm$core$Maybe$Just(
						$author$project$UserSession$LastViewedDiscordGuild(data.id.guildId))
				});
		case 6:
			var data = viewing.a;
			return _Utils_update(
				session,
				{
					lastViewedGuild: $elm$core$Maybe$Just(
						$author$project$UserSession$LastViewedDiscordGuild(data.id.guildId))
				});
		case 0:
			return session;
		case 1:
			return session;
		case 2:
			return session;
		case 7:
			var data = viewing.a;
			return _Utils_update(
				session,
				{
					lastViewedGuild: $elm$core$Maybe$Just(
						$author$project$UserSession$LastViewedSlackWorkspace(data.id.teamId))
				});
		case 9:
			return session;
		case 8:
			var data = viewing.a;
			return _Utils_update(
				session,
				{
					lastViewedGuild: $elm$core$Maybe$Just(
						$author$project$UserSession$LastViewedSlackWorkspace(data.id.teamId))
				});
		case 10:
			return session;
		case 11:
			return session;
		default:
			return session;
	}
};
var $author$project$UserSession$setLastViewedGuild = F2($author$project$UserSession$setLastViewedGuild$);
var $author$project$MuteSettings$updateMutedChannel$ = function (guildId, channelId, updateFunc, model) {
	return _Utils_update(
		model,
		{
			mutedGuilds: $lamdera$containers$SeqDict$update$(
				guildId,
				function (maybeGuild) {
					var guild = $elm$core$Maybe$withDefault$(
						{channels: $lamdera$containers$SeqDict$empty, mutedGuild: 0},
						maybeGuild);
					return $elm$core$Maybe$Just(
						_Utils_update(
							guild,
							{
								channels: $lamdera$containers$SeqDict$update$(
									channelId,
									function (maybeChannel) {
										return $elm$core$Maybe$Just(
											updateFunc(
												$elm$core$Maybe$withDefault$(
													{mutedChannel: 0, mutedThreads: $lamdera$containers$SeqDict$empty},
													maybeChannel)));
									},
									guild.channels)
							}));
				},
				model.mutedGuilds)
		});
};
var $author$project$MuteSettings$updateMutedChannel = F4($author$project$MuteSettings$updateMutedChannel$);
var $author$project$MuteSettings$setMuteChannel$ = function (guildId, channelId, isMuted, model) {
	return $author$project$MuteSettings$updateMutedChannel$(
		guildId,
		channelId,
		function (channel) {
			return _Utils_update(
				channel,
				{mutedChannel: isMuted});
		},
		model);
};
var $author$project$MuteSettings$setMuteChannel = F4($author$project$MuteSettings$setMuteChannel$);
var $author$project$FrontendExtra$setMuteChannel$ = function (guildId, channelId, isMuted, local) {
	var localUser = local.localUser;
	var user = localUser.user;
	return _Utils_update(
		local,
		{
			localUser: _Utils_update(
				localUser,
				{
					user: _Utils_update(
						user,
						{
							muteSettings: $author$project$MuteSettings$setMuteChannel$(guildId, channelId, isMuted, user.muteSettings)
						})
				})
		});
};
var $author$project$FrontendExtra$setMuteChannel = F4($author$project$FrontendExtra$setMuteChannel$);
var $author$project$MuteSettings$updateMutedDiscordChannel$ = function (guildId, channelId, updateFunc, model) {
	return _Utils_update(
		model,
		{
			mutedDiscordGuilds: $lamdera$containers$SeqDict$update$(
				guildId,
				function (maybeGuild) {
					var guild = $elm$core$Maybe$withDefault$(
						{channels: $lamdera$containers$SeqDict$empty, mutedGuild: 0},
						maybeGuild);
					return $elm$core$Maybe$Just(
						_Utils_update(
							guild,
							{
								channels: $lamdera$containers$SeqDict$update$(
									channelId,
									function (maybeChannel) {
										return $elm$core$Maybe$Just(
											updateFunc(
												$elm$core$Maybe$withDefault$(
													{mutedChannel: 0, mutedThreads: $lamdera$containers$SeqDict$empty},
													maybeChannel)));
									},
									guild.channels)
							}));
				},
				model.mutedDiscordGuilds)
		});
};
var $author$project$MuteSettings$updateMutedDiscordChannel = F4($author$project$MuteSettings$updateMutedDiscordChannel$);
var $author$project$MuteSettings$setMuteDiscordChannel$ = function (guildId, channelId, isMuted, model) {
	return $author$project$MuteSettings$updateMutedDiscordChannel$(
		guildId,
		channelId,
		function (channel) {
			return _Utils_update(
				channel,
				{mutedChannel: isMuted});
		},
		model);
};
var $author$project$MuteSettings$setMuteDiscordChannel = F4($author$project$MuteSettings$setMuteDiscordChannel$);
var $author$project$FrontendExtra$setMuteDiscordChannel$ = function (guildId, channelId, isMuted, local) {
	var localUser = local.localUser;
	var user = localUser.user;
	return _Utils_update(
		local,
		{
			localUser: _Utils_update(
				localUser,
				{
					user: _Utils_update(
						user,
						{
							muteSettings: $author$project$MuteSettings$setMuteDiscordChannel$(guildId, channelId, isMuted, user.muteSettings)
						})
				})
		});
};
var $author$project$FrontendExtra$setMuteDiscordChannel = F4($author$project$FrontendExtra$setMuteDiscordChannel$);
var $author$project$MuteSettings$setMuteDiscordGuild$ = function (guildId, isMuted, model) {
	return _Utils_update(
		model,
		{
			mutedDiscordGuilds: $lamdera$containers$SeqDict$update$(
				guildId,
				function (maybeGuild) {
					return $elm$core$Maybe$Just(
						{
							channels: function () {
								if (!maybeGuild.$) {
									var guild = maybeGuild.a;
									return guild.channels;
								} else {
									return $lamdera$containers$SeqDict$empty;
								}
							}(),
							mutedGuild: isMuted
						});
				},
				model.mutedDiscordGuilds)
		});
};
var $author$project$MuteSettings$setMuteDiscordGuild = F3($author$project$MuteSettings$setMuteDiscordGuild$);
var $author$project$FrontendExtra$setMuteDiscordGuild$ = function (guildId, isMuted, local) {
	var localUser = local.localUser;
	var user = localUser.user;
	return _Utils_update(
		local,
		{
			localUser: _Utils_update(
				localUser,
				{
					user: _Utils_update(
						user,
						{
							muteSettings: $author$project$MuteSettings$setMuteDiscordGuild$(guildId, isMuted, user.muteSettings)
						})
				})
		});
};
var $author$project$FrontendExtra$setMuteDiscordGuild = F3($author$project$FrontendExtra$setMuteDiscordGuild$);
var $author$project$MuteSettings$setMuteDiscordThread$ = function (guildId, channelId, threadId, isMuted, model) {
	return $author$project$MuteSettings$updateMutedDiscordChannel$(
		guildId,
		channelId,
		function (channel) {
			return _Utils_update(
				channel,
				{
					mutedThreads: function () {
						switch (isMuted) {
							case 0:
								return $lamdera$containers$SeqDict$remove$(threadId, channel.mutedThreads);
							case 1:
								return $lamdera$containers$SeqDict$insert$(threadId, isMuted, channel.mutedThreads);
							default:
								return $lamdera$containers$SeqDict$insert$(threadId, isMuted, channel.mutedThreads);
						}
					}()
				});
		},
		model);
};
var $author$project$MuteSettings$setMuteDiscordThread = F5($author$project$MuteSettings$setMuteDiscordThread$);
var $author$project$FrontendExtra$setMuteDiscordThread$ = function (guildId, channelId, threadId, isMuted, local) {
	var localUser = local.localUser;
	var user = localUser.user;
	return _Utils_update(
		local,
		{
			localUser: _Utils_update(
				localUser,
				{
					user: _Utils_update(
						user,
						{
							muteSettings: $author$project$MuteSettings$setMuteDiscordThread$(guildId, channelId, threadId, isMuted, user.muteSettings)
						})
				})
		});
};
var $author$project$FrontendExtra$setMuteDiscordThread = F5($author$project$FrontendExtra$setMuteDiscordThread$);
var $author$project$MuteSettings$setMuteGuild$ = function (guildId, isMuted, model) {
	return _Utils_update(
		model,
		{
			mutedGuilds: $lamdera$containers$SeqDict$update$(
				guildId,
				function (maybeGuild) {
					return $elm$core$Maybe$Just(
						{
							channels: function () {
								if (!maybeGuild.$) {
									var guild = maybeGuild.a;
									return guild.channels;
								} else {
									return $lamdera$containers$SeqDict$empty;
								}
							}(),
							mutedGuild: isMuted
						});
				},
				model.mutedGuilds)
		});
};
var $author$project$MuteSettings$setMuteGuild = F3($author$project$MuteSettings$setMuteGuild$);
var $author$project$FrontendExtra$setMuteGuild$ = function (guildId, isMuted, local) {
	var localUser = local.localUser;
	var user = localUser.user;
	return _Utils_update(
		local,
		{
			localUser: _Utils_update(
				localUser,
				{
					user: _Utils_update(
						user,
						{
							muteSettings: $author$project$MuteSettings$setMuteGuild$(guildId, isMuted, user.muteSettings)
						})
				})
		});
};
var $author$project$FrontendExtra$setMuteGuild = F3($author$project$FrontendExtra$setMuteGuild$);
var $author$project$MuteSettings$updateMutedSlackChannel$ = function (teamId, channelId, updateFunc, model) {
	return _Utils_update(
		model,
		{
			mutedSlackWorkspaces: $lamdera$containers$SeqDict$update$(
				teamId,
				function (maybeWorkspace) {
					var workspace = $elm$core$Maybe$withDefault$(
						{channels: $lamdera$containers$SeqDict$empty, mutedWorkspace: 0},
						maybeWorkspace);
					return $elm$core$Maybe$Just(
						_Utils_update(
							workspace,
							{
								channels: $lamdera$containers$SeqDict$update$(
									channelId,
									function (maybeChannel) {
										return $elm$core$Maybe$Just(
											updateFunc(
												$elm$core$Maybe$withDefault$(
													{mutedChannel: 0, mutedThreads: $lamdera$containers$SeqDict$empty},
													maybeChannel)));
									},
									workspace.channels)
							}));
				},
				model.mutedSlackWorkspaces)
		});
};
var $author$project$MuteSettings$updateMutedSlackChannel = F4($author$project$MuteSettings$updateMutedSlackChannel$);
var $author$project$MuteSettings$setMuteSlackChannel$ = function (teamId, channelId, isMuted, model) {
	return $author$project$MuteSettings$updateMutedSlackChannel$(
		teamId,
		channelId,
		function (channel) {
			return _Utils_update(
				channel,
				{mutedChannel: isMuted});
		},
		model);
};
var $author$project$MuteSettings$setMuteSlackChannel = F4($author$project$MuteSettings$setMuteSlackChannel$);
var $author$project$FrontendExtra$setMuteSlackChannel$ = function (teamId, channelId, isMuted, local) {
	var localUser = local.localUser;
	var user = localUser.user;
	return _Utils_update(
		local,
		{
			localUser: _Utils_update(
				localUser,
				{
					user: _Utils_update(
						user,
						{
							muteSettings: $author$project$MuteSettings$setMuteSlackChannel$(teamId, channelId, isMuted, user.muteSettings)
						})
				})
		});
};
var $author$project$FrontendExtra$setMuteSlackChannel = F4($author$project$FrontendExtra$setMuteSlackChannel$);
var $author$project$MuteSettings$setMuteSlackThread$ = function (teamId, channelId, threadId, isMuted, model) {
	return $author$project$MuteSettings$updateMutedSlackChannel$(
		teamId,
		channelId,
		function (channel) {
			return _Utils_update(
				channel,
				{
					mutedThreads: function () {
						switch (isMuted) {
							case 0:
								return $lamdera$containers$SeqDict$remove$(threadId, channel.mutedThreads);
							case 1:
								return $lamdera$containers$SeqDict$insert$(threadId, isMuted, channel.mutedThreads);
							default:
								return $lamdera$containers$SeqDict$insert$(threadId, isMuted, channel.mutedThreads);
						}
					}()
				});
		},
		model);
};
var $author$project$MuteSettings$setMuteSlackThread = F5($author$project$MuteSettings$setMuteSlackThread$);
var $author$project$FrontendExtra$setMuteSlackThread$ = function (teamId, channelId, threadId, isMuted, local) {
	var localUser = local.localUser;
	var user = localUser.user;
	return _Utils_update(
		local,
		{
			localUser: _Utils_update(
				localUser,
				{
					user: _Utils_update(
						user,
						{
							muteSettings: $author$project$MuteSettings$setMuteSlackThread$(teamId, channelId, threadId, isMuted, user.muteSettings)
						})
				})
		});
};
var $author$project$FrontendExtra$setMuteSlackThread = F5($author$project$FrontendExtra$setMuteSlackThread$);
var $author$project$MuteSettings$setMuteSlackWorkspace$ = function (teamId, isMuted, model) {
	return _Utils_update(
		model,
		{
			mutedSlackWorkspaces: $lamdera$containers$SeqDict$update$(
				teamId,
				function (maybeWorkspace) {
					return $elm$core$Maybe$Just(
						{
							channels: function () {
								if (!maybeWorkspace.$) {
									var workspace = maybeWorkspace.a;
									return workspace.channels;
								} else {
									return $lamdera$containers$SeqDict$empty;
								}
							}(),
							mutedWorkspace: isMuted
						});
				},
				model.mutedSlackWorkspaces)
		});
};
var $author$project$MuteSettings$setMuteSlackWorkspace = F3($author$project$MuteSettings$setMuteSlackWorkspace$);
var $author$project$FrontendExtra$setMuteSlackWorkspace$ = function (teamId, isMuted, local) {
	var localUser = local.localUser;
	var user = localUser.user;
	return _Utils_update(
		local,
		{
			localUser: _Utils_update(
				localUser,
				{
					user: _Utils_update(
						user,
						{
							muteSettings: $author$project$MuteSettings$setMuteSlackWorkspace$(teamId, isMuted, user.muteSettings)
						})
				})
		});
};
var $author$project$FrontendExtra$setMuteSlackWorkspace = F3($author$project$FrontendExtra$setMuteSlackWorkspace$);
var $author$project$MuteSettings$setMuteThread$ = function (guildId, channelId, threadId, isMuted, model) {
	return $author$project$MuteSettings$updateMutedChannel$(
		guildId,
		channelId,
		function (channel) {
			return _Utils_update(
				channel,
				{
					mutedThreads: function () {
						switch (isMuted) {
							case 0:
								return $lamdera$containers$SeqDict$remove$(threadId, channel.mutedThreads);
							case 1:
								return $lamdera$containers$SeqDict$insert$(threadId, isMuted, channel.mutedThreads);
							default:
								return $lamdera$containers$SeqDict$insert$(threadId, isMuted, channel.mutedThreads);
						}
					}()
				});
		},
		model);
};
var $author$project$MuteSettings$setMuteThread = F5($author$project$MuteSettings$setMuteThread$);
var $author$project$FrontendExtra$setMuteThread$ = function (guildId, channelId, threadId, isMuted, local) {
	var localUser = local.localUser;
	var user = localUser.user;
	return _Utils_update(
		local,
		{
			localUser: _Utils_update(
				localUser,
				{
					user: _Utils_update(
						user,
						{
							muteSettings: $author$project$MuteSettings$setMuteThread$(guildId, channelId, threadId, isMuted, user.muteSettings)
						})
				})
		});
};
var $author$project$FrontendExtra$setMuteThread = F5($author$project$FrontendExtra$setMuteThread$);
var $author$project$User$setName$ = function (name, user) {
	return _Utils_update(
		user,
		{name: name});
};
var $author$project$User$setName = F2($author$project$User$setName$);
var $author$project$UserSession$setSheepGameQuestions$ = function (questions, session) {
	return _Utils_update(
		session,
		{savedSheepGameQuestions: questions});
};
var $author$project$UserSession$setSheepGameQuestions = F2($author$project$UserSession$setSheepGameQuestions$);
var $author$project$User$setSlackWorkspaceNotificationLevel$ = function (teamId, notificationLevel, user) {
	return _Utils_update(
		user,
		{
			slackNotifyOnAllMessages: function () {
				if (!notificationLevel) {
					return $lamdera$containers$SeqSet$insert$(teamId, user.slackNotifyOnAllMessages);
				} else {
					return $lamdera$containers$SeqSet$remove$(teamId, user.slackNotifyOnAllMessages);
				}
			}()
		});
};
var $author$project$User$setSlackWorkspaceNotificationLevel = F3($author$project$User$setSlackWorkspaceNotificationLevel$);
var $author$project$UserSession$Viewing_None = {$: 11};
var $author$project$UserSession$Viewing_Overview = {$: 12};
var $author$project$SetViewing$setViewingToCurrentlyViewing = function (viewing) {
	switch (viewing.$) {
		case 0:
			var data = viewing.a;
			return $author$project$UserSession$Viewing_Dm(data);
		case 1:
			var data = viewing.a;
			return $author$project$UserSession$Viewing_DmThread(data);
		case 2:
			var data = viewing.a;
			return $author$project$UserSession$Viewing_DiscordDm(data);
		case 3:
			var data = viewing.a;
			return $author$project$UserSession$Viewing_Channel(data);
		case 4:
			var data = viewing.a;
			return $author$project$UserSession$Viewing_ChannelThread(data);
		case 5:
			var data = viewing.a;
			return $author$project$UserSession$Viewing_DiscordChannel(data);
		case 6:
			var data = viewing.a;
			return $author$project$UserSession$Viewing_DiscordChannelThread(data);
		case 7:
			var data = viewing.a;
			return $author$project$UserSession$Viewing_SlackChannel(data);
		case 8:
			var data = viewing.a;
			return $author$project$UserSession$Viewing_SlackDm(data);
		case 9:
			var data = viewing.a;
			return $author$project$UserSession$Viewing_SlackChannelThread(data);
		case 10:
			var data = viewing.a;
			return $author$project$UserSession$Viewing_SlackDmThread(data);
		case 11:
			return $author$project$UserSession$Viewing_None;
		default:
			return $author$project$UserSession$Viewing_Overview;
	}
};
var $author$project$LocalState$slackChannelMentions$ = function (guildOrDmId, local) {
	if (!guildOrDmId.$) {
		var teamId = guildOrDmId.a.teamId;
		var _v1 = $lamdera$containers$SeqDict$get$(teamId, local.slackWorkspaces);
		if (!_v1.$) {
			var workspace = _v1.a;
			return $lamdera$containers$SeqDict$foldl$(
				F3(
					function (channelId, channel, dict) {
						return $lamdera$containers$SeqDict$insert$(
							_Utils_Tuple2(channelId, $elm$core$Maybe$Nothing),
							{
								name: $author$project$ChannelName$toString(channel.name)
							},
							dict);
					}),
				$lamdera$containers$SeqDict$empty,
				workspace.channels);
		} else {
			return $lamdera$containers$SeqDict$empty;
		}
	} else {
		return $lamdera$containers$SeqDict$empty;
	}
};
var $author$project$LocalState$slackChannelMentions = F2($author$project$LocalState$slackChannelMentions$);
var $author$project$FrontendExtra$slackEditMessage$ = function (editedAt, editedBy, guildOrDmId, threadRoute, content, local) {
	var edit = function (channel) {
		return $elm$core$Result$withDefault$(
			channel,
			$author$project$LocalState$editMessageFrontendHelper$(editedAt, editedBy, content, $author$project$Message$DoNotChangeAttachments, threadRoute, channel));
	};
	if (!guildOrDmId.$) {
		var channelId = guildOrDmId.a.channelId;
		var teamId = guildOrDmId.a.teamId;
		return _Utils_update(
			local,
			{
				slackWorkspaces: $lamdera$containers$SeqDict$updateIfExists$(
					teamId,
					A2($author$project$LocalState$updateChannel, edit, channelId),
					local.slackWorkspaces)
			});
	} else {
		var channelId = guildOrDmId.a.channelId;
		return _Utils_update(
			local,
			{
				slackDmChannels: $lamdera$containers$SeqDict$updateIfExists$(channelId, edit, local.slackDmChannels)
			});
	}
};
var $author$project$FrontendExtra$slackEditMessage = F6($author$project$FrontendExtra$slackEditMessage$);
var $author$project$FrontendExtra$slackAddMessage$ = function (createdAt, author, threadRoute, content, attachedFiles, channel) {
	if (!threadRoute.$) {
		return $author$project$LocalState$createChannelMessageFrontend$(
			$author$project$Message$userTextMessageFrontend$(createdAt, author, content, $author$project$Message$NoReply, attachedFiles),
			channel);
	} else {
		var threadId = threadRoute.a;
		return $author$project$LocalState$createThreadMessageFrontend$(
			threadId,
			$author$project$Message$userTextMessageFrontend$(createdAt, author, content, $author$project$Message$NoReply, attachedFiles),
			channel);
	}
};
var $author$project$FrontendExtra$slackAddMessage = F6($author$project$FrontendExtra$slackAddMessage$);
var $author$project$FrontendExtra$slackLoadThreadStarter$ = function (threadRoute, maybeThreadStarter, channel) {
	var _v0 = _Utils_Tuple2(threadRoute, maybeThreadStarter);
	if (_v0.a.$ === 1) {
		if (!_v0.b.$) {
			var threadId = _v0.a.a;
			var threadStarter = _v0.b.a;
			return _Utils_update(
				channel,
				{
					messages: $author$project$MessageArray$setMany$(
						_List_fromArray(
							[
								_Utils_Tuple2(threadId, threadStarter)
							]),
						channel.messages)
				});
		} else {
			var _v1 = _v0.b;
			return channel;
		}
	} else {
		if (!_v0.b.$) {
			var _v2 = _v0.a;
			return channel;
		} else {
			var _v3 = _v0.a;
			var _v4 = _v0.b;
			return channel;
		}
	}
};
var $author$project$FrontendExtra$slackLoadThreadStarter = F3($author$project$FrontendExtra$slackLoadThreadStarter$);
var $author$project$User$addSlackDirectMention$ = function (teamId, channelId, threadRoute, user) {
	return _Utils_update(
		user,
		{
			slackDirectMentions: A4($author$project$User$addDirectMentionHelper, teamId, channelId, threadRoute, user.slackDirectMentions)
		});
};
var $author$project$User$addSlackDirectMention = F4($author$project$User$addSlackDirectMention$);
var $mgold$elm_nonempty_list$List$Nonempty$foldl$ = function (f, b, _v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return $elm$core$List$foldl$(
		f,
		b,
		A2($elm$core$List$cons, x, xs));
};
var $mgold$elm_nonempty_list$List$Nonempty$foldl = F3($mgold$elm_nonempty_list$List$Nonempty$foldl$);
var $author$project$RichText$mentionsUserHelper$ = function (set, nonempty) {
	return $mgold$elm_nonempty_list$List$Nonempty$foldl$(
		F2(
			function (richText, set2) {
				switch (richText.$) {
					case 2:
						return set2;
					case 0:
						var mentionedUser = richText.a;
						return $lamdera$containers$SeqSet$insert$(mentionedUser, set2);
					case 1:
						return set2;
					case 3:
						var nonempty2 = richText.a;
						return $author$project$RichText$mentionsUserHelper$(set2, nonempty2);
					case 4:
						var nonempty2 = richText.a;
						return $author$project$RichText$mentionsUserHelper$(set2, nonempty2);
					case 5:
						var nonempty2 = richText.a;
						return $author$project$RichText$mentionsUserHelper$(set2, nonempty2);
					case 6:
						var nonempty2 = richText.a;
						return $author$project$RichText$mentionsUserHelper$(set2, nonempty2);
					case 7:
						var nonempty2 = richText.a;
						return $author$project$RichText$mentionsUserHelper$(set2, nonempty2);
					case 8:
						var list = richText.b;
						return $elm$core$Maybe$withDefault$(
							set2,
							$elm$core$Maybe$map$(
								$author$project$RichText$mentionsUserHelper(set2),
								$mgold$elm_nonempty_list$List$Nonempty$fromList(list)));
					case 9:
						var nonempty2 = richText.c;
						return $author$project$RichText$mentionsUserHelper$(set2, nonempty2);
					case 10:
						return set2;
					case 11:
						return set2;
					case 12:
						return set2;
					case 13:
						return set2;
					case 14:
						return set2;
					case 15:
						return set2;
					case 16:
						return set2;
					case 17:
						return set2;
					case 18:
						var items = richText.b;
						return $elm$core$List$foldl$(
							F2(
								function (item, set3) {
									var _v1 = $mgold$elm_nonempty_list$List$Nonempty$fromList(item);
									if (!_v1.$) {
										var nonempty3 = _v1.a;
										return $author$project$RichText$mentionsUserHelper$(set3, nonempty3);
									} else {
										return set3;
									}
								}),
							set2,
							$mgold$elm_nonempty_list$List$Nonempty$toList(items));
					default:
						return set2;
				}
			}),
		set,
		nonempty);
};
var $author$project$RichText$mentionsUserHelper = F2($author$project$RichText$mentionsUserHelper$);
var $author$project$RichText$mentionsUser = function (nonempty) {
	return $author$project$RichText$mentionsUserHelper$($lamdera$containers$SeqSet$empty, nonempty);
};
var $author$project$Id$threadRouteWithoutMessage = function (threadRoute) {
	if (threadRoute.$ === 1) {
		var threadId = threadRoute.a;
		return $author$project$Id$ViewThread(threadId);
	} else {
		return $author$project$Id$NoThread;
	}
};
var $author$project$FrontendExtra$slackMessageAddedFrontend$ = function (guildOrDmId, threadRouteWithMessage, content, localUser) {
	var viewingId = function () {
		var _v3 = _Utils_Tuple3(localUser.currentlyViewing, guildOrDmId, threadRouteWithMessage);
		_v3$4:
		while (true) {
			if (!_v3.b.$) {
				if (!_v3.c.$) {
					if (_v3.a.$ === 7) {
						var data = _v3.a.a;
						var channelId = _v3.b.a.channelId;
						var teamId = _v3.b.a.teamId;
						return (_Utils_eq(data.id.teamId, teamId) && _Utils_eq(data.id.channelId, channelId)) ? $elm$core$Maybe$Just(
							$author$project$Id$SlackGuildOrDmId_Workspace(data.id)) : $elm$core$Maybe$Nothing;
					} else {
						break _v3$4;
					}
				} else {
					if (_v3.a.$ === 8) {
						var data = _v3.a.a;
						var channelId = _v3.b.a.channelId;
						var teamId = _v3.b.a.teamId;
						var _v4 = _v3.c;
						var threadId = _v4.a;
						return (_Utils_eq(data.id.teamId, teamId) && (_Utils_eq(data.id.channelId, channelId) && _Utils_eq(data.threadId, threadId))) ? $elm$core$Maybe$Just(
							$author$project$Id$SlackGuildOrDmId_Workspace(data.id)) : $elm$core$Maybe$Nothing;
					} else {
						break _v3$4;
					}
				}
			} else {
				if (!_v3.c.$) {
					if (_v3.a.$ === 9) {
						var data = _v3.a.a;
						var channelId = _v3.b.a.channelId;
						return _Utils_eq(data.id.channelId, channelId) ? $elm$core$Maybe$Just(
							$author$project$Id$SlackGuildOrDmId_Dm(data.id)) : $elm$core$Maybe$Nothing;
					} else {
						break _v3$4;
					}
				} else {
					if (_v3.a.$ === 10) {
						var data = _v3.a.a;
						var channelId = _v3.b.a.channelId;
						var _v5 = _v3.c;
						var threadId = _v5.a;
						return (_Utils_eq(data.id.channelId, channelId) && _Utils_eq(data.threadId, threadId)) ? $elm$core$Maybe$Just(
							$author$project$Id$SlackGuildOrDmId_Dm(data.id)) : $elm$core$Maybe$Nothing;
					} else {
						break _v3$4;
					}
				}
			}
		}
		return $elm$core$Maybe$Nothing;
	}();
	var author = function () {
		if (!guildOrDmId.$) {
			var data = guildOrDmId.a;
			return data.currentUserId;
		} else {
			var data = guildOrDmId.a;
			return data.currentUserId;
		}
	}();
	if ($lamdera$containers$SeqDict$member$(author, localUser.linkedSlackUsers)) {
		return $author$project$LocalState$ownMessageIsReadFrontend$(
			$author$project$Id$SlackGuildOrDmId(guildOrDmId),
			threadRouteWithMessage,
			_Utils_Tuple2(localUser.currentlyViewing, localUser.user));
	} else {
		if (!viewingId.$) {
			var viewingId2 = viewingId.a;
			return $author$project$LocalState$incrementLastViewedMessageFrontend$(
				$author$project$Id$SlackGuildOrDmId(viewingId2),
				threadRouteWithMessage,
				_Utils_Tuple2(localUser.currentlyViewing, localUser.user));
		} else {
			return _Utils_Tuple2(
				localUser.currentlyViewing,
				function () {
					if (!guildOrDmId.$) {
						var channelId = guildOrDmId.a.channelId;
						var teamId = guildOrDmId.a.teamId;
						return $elm$core$List$any$(
							function (userId) {
								return $lamdera$containers$SeqDict$member$(userId, localUser.linkedSlackUsers);
							},
							$lamdera$containers$SeqSet$toList(
								$author$project$RichText$mentionsUser(content))) ? $author$project$User$addSlackDirectMention$(
							teamId,
							channelId,
							$author$project$Id$threadRouteWithoutMessage(threadRouteWithMessage),
							localUser.user) : localUser.user;
					} else {
						return localUser.user;
					}
				}());
		}
	}
};
var $author$project$FrontendExtra$slackMessageAddedFrontend = F4($author$project$FrontendExtra$slackMessageAddedFrontend$);
var $author$project$FrontendExtra$slackNextMessageId$ = function (threadRoute, channel) {
	if (!threadRoute.$) {
		return $author$project$Id$NoThreadWithMessage(
			$author$project$Id$fromInt(
				$author$project$MessageArray$length(channel.messages)));
	} else {
		var threadId = threadRoute.a;
		var _v1 = $lamdera$containers$SeqDict$get$(threadId, channel.threads);
		if (!_v1.$) {
			var thread = _v1.a;
			return $author$project$Id$ViewThreadWithMessage$(
				threadId,
				$author$project$Id$fromInt(
					$author$project$MessageArray$length(thread.messages)));
		} else {
			return $author$project$Id$ViewThreadWithMessage$(
				threadId,
				$author$project$Id$fromInt(0));
		}
	}
};
var $author$project$FrontendExtra$slackNextMessageId = F2($author$project$FrontendExtra$slackNextMessageId$);
var $author$project$FrontendExtra$slackSendMessage$ = function (createdAt, guildOrDmId, threadRoute, content, attachedFiles, maybeThreadStarter, local) {
	if (!guildOrDmId.$) {
		var channelId = guildOrDmId.a.channelId;
		var teamId = guildOrDmId.a.teamId;
		var currentUserId = guildOrDmId.a.currentUserId;
		var _v1 = $author$project$LocalState$getSlackWorkspaceAndChannel$(teamId, channelId, local);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var workspace = _v2.a;
			var channel = _v2.b;
			var localUser = local.localUser;
			var _v3 = $author$project$FrontendExtra$slackMessageAddedFrontend$(
				guildOrDmId,
				$author$project$FrontendExtra$slackNextMessageId$(threadRoute, channel),
				content,
				localUser);
			var currentlyViewing2 = _v3.a;
			var user2 = _v3.b;
			return _Utils_update(
				local,
				{
					localUser: _Utils_update(
						localUser,
						{currentlyViewing: currentlyViewing2, user: user2}),
					slackWorkspaces: $lamdera$containers$SeqDict$insert$(
						teamId,
						_Utils_update(
							workspace,
							{
								channels: $lamdera$containers$SeqDict$insert$(
									channelId,
									$author$project$FrontendExtra$slackAddMessage$(
										createdAt,
										currentUserId,
										threadRoute,
										content,
										attachedFiles,
										$author$project$FrontendExtra$slackLoadThreadStarter$(threadRoute, maybeThreadStarter, channel)),
									workspace.channels)
							}),
						local.slackWorkspaces)
				});
		} else {
			return local;
		}
	} else {
		var channelId = guildOrDmId.a.channelId;
		var currentUserId = guildOrDmId.a.currentUserId;
		var _v4 = $lamdera$containers$SeqDict$get$(channelId, local.slackDmChannels);
		if (!_v4.$) {
			var dmChannel = _v4.a;
			var localUser = local.localUser;
			var _v5 = $author$project$FrontendExtra$slackMessageAddedFrontend$(
				guildOrDmId,
				$author$project$FrontendExtra$slackNextMessageId$(threadRoute, dmChannel),
				content,
				localUser);
			var currentlyViewing2 = _v5.a;
			var user2 = _v5.b;
			return _Utils_update(
				local,
				{
					localUser: _Utils_update(
						localUser,
						{currentlyViewing: currentlyViewing2, user: user2}),
					slackDmChannels: $lamdera$containers$SeqDict$insert$(
						channelId,
						$author$project$FrontendExtra$slackAddMessage$(
							createdAt,
							currentUserId,
							threadRoute,
							content,
							attachedFiles,
							$author$project$FrontendExtra$slackLoadThreadStarter$(threadRoute, maybeThreadStarter, dmChannel)),
						local.slackDmChannels)
				});
		} else {
			return local;
		}
	}
};
var $author$project$FrontendExtra$slackSendMessage = F7($author$project$FrontendExtra$slackSendMessage$);
var $author$project$LocalState$startCallRecordingFrontend$ = function (messageId, startedAt, participants, channel) {
	return _Utils_update(
		channel,
		{
			messages: $author$project$MessageArray$updateIfExists$(
				messageId,
				function (message) {
					if (message.$ === 4) {
						var callStarted = message.a;
						return $author$project$Message$CallStarted(
							_Utils_update(
								callStarted,
								{
									recordings: $elm$core$Maybe$Just(
										{files: _List_Nil, finishedUploading: $lamdera$containers$SeqSet$empty, participants: participants, startedAt: startedAt, zip: $elm$core$Maybe$Nothing})
								}));
					} else {
						return message;
					}
				},
				channel.messages)
		});
};
var $author$project$LocalState$startCallRecordingFrontend = F4($author$project$LocalState$startCallRecordingFrontend$);
var $author$project$DiscordUserData$DiscordUserLoadingData = function (a) {
	return {$: 1, a: a};
};
var $author$project$LinkedAndOtherDiscordUsers$updateLinkedUser$ = function (userId, updateFunc, _v0) {
	var otherUsers2 = _v0.a;
	var linkedUsers2 = _v0.b;
	return $author$project$LinkedAndOtherDiscordUsers$LinkedAndOtherDiscordUsers$(
		otherUsers2,
		$lamdera$containers$SeqDict$updateIfExists$(userId, updateFunc, linkedUsers2));
};
var $author$project$LinkedAndOtherDiscordUsers$updateLinkedUser = F3($author$project$LinkedAndOtherDiscordUsers$updateLinkedUser$);
var $author$project$FrontendExtra$startReloadingDiscordUser$ = function (time, discordUserId, local) {
	var localUser = local.localUser;
	return _Utils_update(
		local,
		{
			localUser: _Utils_update(
				localUser,
				{
					discordUsers: $author$project$LinkedAndOtherDiscordUsers$updateLinkedUser$(
						discordUserId,
						function (user) {
							return _Utils_update(
								user,
								{
									isLoadingData: $author$project$DiscordUserData$DiscordUserLoadingData(time)
								});
						},
						localUser.discordUsers)
				})
		});
};
var $author$project$FrontendExtra$startReloadingDiscordUser = F3($author$project$FrontendExtra$startReloadingDiscordUser$);
var $author$project$FrontendExtra$textToDiscordRichText$ = function (text, memberIds, channels, local) {
	var allUsers = $author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(local.localUser.discordUsers);
	return $author$project$RichText$fromNonemptyString$(
		local.localUser.timezone,
		$elm$core$List$foldl$(
			F2(
				function (memberId, dict) {
					var _v0 = $lamdera$containers$SeqDict$get$(memberId, allUsers);
					if (!_v0.$) {
						var member = _v0.a;
						return $lamdera$containers$SeqDict$insert$(memberId, member, dict);
					} else {
						return dict;
					}
				}),
			$lamdera$containers$SeqDict$empty,
			memberIds),
		channels,
		text);
};
var $author$project$FrontendExtra$textToDiscordRichText = F4($author$project$FrontendExtra$textToDiscordRichText$);
var $author$project$Id$threadRouteWithoutMaybeMessage = function (threadRoute) {
	if (threadRoute.$ === 1) {
		var threadId = threadRoute.a;
		return $author$project$Id$ViewThread(threadId);
	} else {
		return $author$project$Id$NoThread;
	}
};
var $author$project$Message$replyToMaybe = function (repliedTo2) {
	switch (repliedTo2.$) {
		case 1:
			var messageId2 = repliedTo2.a;
			return $elm$core$Maybe$Just(messageId2);
		case 0:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Message$toThreadRouteWithMaybeMessage = function (threadRoute) {
	if (!threadRoute.$) {
		var repliedTo2 = threadRoute.a;
		return $author$project$Id$NoThreadWithMaybeMessage(
			$author$project$Message$replyToMaybe(repliedTo2));
	} else {
		var threadId = threadRoute.a;
		var maybeRepliedTo = threadRoute.b;
		return $author$project$Id$ViewThreadWithMaybeMessage$(threadId, maybeRepliedTo);
	}
};
var $author$project$NonemptySet$member$ = function (key, _v0) {
	var id = _v0.a;
	var set = _v0.b;
	return _Utils_eq(key, id) || $lamdera$containers$SeqSet$member$(key, set);
};
var $author$project$NonemptySet$member = F2($author$project$NonemptySet$member$);
var $author$project$FrontendExtra$unlinkSlackUser$ = function (slackUserId, local) {
	var localUser = local.localUser;
	var linkedSlackUsers = $lamdera$containers$SeqDict$remove$(slackUserId, localUser.linkedSlackUsers);
	var linkedTeams = $lamdera$containers$SeqDict$values(linkedSlackUsers);
	return _Utils_update(
		local,
		{
			localUser: _Utils_update(
				localUser,
				{linkedSlackUsers: linkedSlackUsers}),
			slackDmChannels: $lamdera$containers$SeqDict$filter$(
				F2(
					function (_v0, dmChannel) {
						return $elm$core$List$any$(
							function (linkedId) {
								return $author$project$NonemptySet$member$(linkedId, dmChannel.members);
							},
							$lamdera$containers$SeqDict$keys(linkedSlackUsers));
					}),
				local.slackDmChannels),
			slackWorkspaces: $lamdera$containers$SeqDict$filter$(
				F2(
					function (teamId, _v1) {
						return $elm$core$List$member$(teamId, linkedTeams);
					}),
				local.slackWorkspaces)
		});
};
var $author$project$FrontendExtra$unlinkSlackUser = F2($author$project$FrontendExtra$unlinkSlackUser$);
var $author$project$LinkedAndOtherDiscordUsers$unlinkUser$ = function (userId, linkedAndOther) {
	var otherUsers2 = linkedAndOther.a;
	var linkedUsers2 = linkedAndOther.b;
	var _v0 = $lamdera$containers$SeqDict$get$(userId, linkedUsers2);
	if (!_v0.$) {
		var discordUser = _v0.a;
		return $author$project$LinkedAndOtherDiscordUsers$LinkedAndOtherDiscordUsers$(
			$lamdera$containers$SeqDict$insert$(
				userId,
				$author$project$LinkedAndOtherDiscordUsers$discordCurrentUserToFrontend(discordUser),
				otherUsers2),
			$lamdera$containers$SeqDict$remove$(userId, linkedUsers2));
	} else {
		return linkedAndOther;
	}
};
var $author$project$LinkedAndOtherDiscordUsers$unlinkUser = F2($author$project$LinkedAndOtherDiscordUsers$unlinkUser$);
var $author$project$LocalState$AdminDataLoaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$LocalState$BeingRegenerated = {$: 1};
var $author$project$LocalState$DeletingOrphanedFiles = {$: 1};
var $author$project$LocalState$DeletingOrphanedFilesFailed = function (a) {
	return {$: 2, a: a};
};
var $author$project$LocalState$LoadingDiscordChannelMessages = {$: 0};
var $author$project$LocalState$LoadingDiscordDmChannel$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $author$project$LocalState$LoadingDiscordDmChannel = F3($author$project$LocalState$LoadingDiscordDmChannel$);
var $author$project$LocalState$LoadingDiscordGuildChannel$ = function (a, b, c, d) {
	return {$: 1, a: a, b: b, c: c, d: d};
};
var $author$project$LocalState$LoadingDiscordGuildChannel = F4($author$project$LocalState$LoadingDiscordGuildChannel$);
var $author$project$LocalState$RegenerationFailed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$CantDeleteYourself = {$: 4};
var $author$project$Pages$Admin$CantRemoveAdminRoleFromYourself = {$: 3};
var $author$project$Pages$Admin$ChangesAppliedToNonExistentUser = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$EmailAddressesAreNotUnique = {$: 0};
var $author$project$Pages$Admin$InvalidChangesToUser = {$: 1};
var $author$project$Pages$Admin$InvalidNewUser = {$: 5};
var $bburdette$toop$Toop$T3$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $bburdette$toop$Toop$T3 = F3($bburdette$toop$Toop$T3$);
var $author$project$User$UserHasEmail = function (a) {
	return {$: 1, a: a};
};
var $bburdette$toop$Toop$T2$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $bburdette$toop$Toop$T2 = F2($bburdette$toop$Toop$T2$);
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $author$project$EmailAddress$EmailAddress = $elm$core$Basics$identity;
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$Bad$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $elm$parser$Parser$Advanced$Bad = F2($elm$parser$Parser$Advanced$Bad$);
var $elm$parser$Parser$Advanced$Good$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $elm$parser$Parser$Advanced$Good = F3($elm$parser$Parser$Advanced$Good$);
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$AddRight$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $elm$parser$Parser$Advanced$AddRight = F2($elm$parser$Parser$Advanced$AddRight$);
var $elm$parser$Parser$Advanced$DeadEnd$ = function (row, col, problem, contextStack) {
	return {col: col, contextStack: contextStack, problem: problem, row: row};
};
var $elm$parser$Parser$Advanced$DeadEnd = F4($elm$parser$Parser$Advanced$DeadEnd$);
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState$ = function (s, x) {
	return $elm$parser$Parser$Advanced$AddRight$(
		$elm$parser$Parser$Advanced$Empty,
		$elm$parser$Parser$Advanced$DeadEnd$(s.row, s.col, x, s.context));
};
var $elm$parser$Parser$Advanced$fromState = F2($elm$parser$Parser$Advanced$fromState$);
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.src),
			s.offset) ? $elm$parser$Parser$Advanced$Good$(false, 0, s) : $elm$parser$Parser$Advanced$Bad$(
			false,
			$elm$parser$Parser$Advanced$fromState$(s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$parser$Parser$Advanced$map2$ = function (func, _v0, _v1) {
	var parseA = _v0;
	var parseB = _v1;
	return function (s0) {
		var _v2 = parseA(s0);
		if (_v2.$ === 1) {
			var p = _v2.a;
			var x = _v2.b;
			return $elm$parser$Parser$Advanced$Bad$(p, x);
		} else {
			var p1 = _v2.a;
			var a = _v2.b;
			var s1 = _v2.c;
			var _v3 = parseB(s1);
			if (_v3.$ === 1) {
				var p2 = _v3.a;
				var x = _v3.b;
				return $elm$parser$Parser$Advanced$Bad$(p1 || p2, x);
			} else {
				var p2 = _v3.a;
				var b = _v3.b;
				var s2 = _v3.c;
				return $elm$parser$Parser$Advanced$Good$(
					p1 || p2,
					A2(func, a, b),
					s2);
			}
		}
	};
};
var $elm$parser$Parser$Advanced$map2 = F3($elm$parser$Parser$Advanced$map2$);
var $elm$parser$Parser$Advanced$ignorer$ = function (keepParser, ignoreParser) {
	return $elm$parser$Parser$Advanced$map2$($elm$core$Basics$always, keepParser, ignoreParser);
};
var $elm$parser$Parser$Advanced$ignorer = F2($elm$parser$Parser$Advanced$ignorer$);
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$keeper$ = function (parseFunc, parseArg) {
	return $elm$parser$Parser$Advanced$map2$($elm$core$Basics$apL, parseFunc, parseArg);
};
var $elm$parser$Parser$Advanced$keeper = F2($elm$parser$Parser$Advanced$keeper$);
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$loopHelp$ = function (p, state, callback, s0) {
	loopHelp:
	while (true) {
		var _v0 = callback(state);
		var parse = _v0;
		var _v1 = parse(s0);
		if (!_v1.$) {
			var p1 = _v1.a;
			var step = _v1.b;
			var s1 = _v1.c;
			if (!step.$) {
				var newState = step.a;
				var $temp$p = p || p1,
					$temp$state = newState,
					$temp$s0 = s1;
				p = $temp$p;
				state = $temp$state;
				s0 = $temp$s0;
				continue loopHelp;
			} else {
				var result = step.a;
				return $elm$parser$Parser$Advanced$Good$(p || p1, result, s1);
			}
		} else {
			var p1 = _v1.a;
			var x = _v1.b;
			return $elm$parser$Parser$Advanced$Bad$(p || p1, x);
		}
	}
};
var $elm$parser$Parser$Advanced$loopHelp = F4($elm$parser$Parser$Advanced$loopHelp$);
var $elm$parser$Parser$Advanced$loop$ = function (state, callback) {
	return function (s) {
		return $elm$parser$Parser$Advanced$loopHelp$(false, state, callback, s);
	};
};
var $elm$parser$Parser$Advanced$loop = F2($elm$parser$Parser$Advanced$loop$);
var $elm$parser$Parser$Advanced$map$ = function (func, _v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (!_v1.$) {
			var p = _v1.a;
			var a = _v1.b;
			var s1 = _v1.c;
			return $elm$parser$Parser$Advanced$Good$(
				p,
				func(a),
				s1);
		} else {
			var p = _v1.a;
			var x = _v1.b;
			return $elm$parser$Parser$Advanced$Bad$(p, x);
		}
	};
};
var $elm$parser$Parser$Advanced$map = F2($elm$parser$Parser$Advanced$map$);
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop$ = function (state, callback) {
	return $elm$parser$Parser$Advanced$loop$(
		state,
		function (s) {
			return A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$toAdvancedStep,
				callback(s));
		});
};
var $elm$parser$Parser$loop = F2($elm$parser$Parser$loop$);
var $elm$parser$Parser$Advanced$Append$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $elm$parser$Parser$Advanced$Append = F2($elm$parser$Parser$Advanced$Append$);
var $elm$parser$Parser$Advanced$oneOfHelp$ = function (s0, bag, parsers) {
	oneOfHelp:
	while (true) {
		if (!parsers.b) {
			return $elm$parser$Parser$Advanced$Bad$(false, bag);
		} else {
			var parse = parsers.a;
			var remainingParsers = parsers.b;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var step = _v1;
				return step;
			} else {
				var step = _v1;
				var p = step.a;
				var x = step.b;
				if (p) {
					return step;
				} else {
					var $temp$bag = $elm$parser$Parser$Advanced$Append$(bag, x),
						$temp$parsers = remainingParsers;
					bag = $temp$bag;
					parsers = $temp$parsers;
					continue oneOfHelp;
				}
			}
		}
	}
};
var $elm$parser$Parser$Advanced$oneOfHelp = F3($elm$parser$Parser$Advanced$oneOfHelp$);
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return $elm$parser$Parser$Advanced$oneOfHelp$(s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $elm$parser$Parser$Advanced$andThen$ = function (callback, _v0) {
	var parseA = _v0;
	return function (s0) {
		var _v1 = parseA(s0);
		if (_v1.$ === 1) {
			var p = _v1.a;
			var x = _v1.b;
			return $elm$parser$Parser$Advanced$Bad$(p, x);
		} else {
			var p1 = _v1.a;
			var a = _v1.b;
			var s1 = _v1.c;
			var _v2 = callback(a);
			var parseB = _v2;
			var _v3 = parseB(s1);
			if (_v3.$ === 1) {
				var p2 = _v3.a;
				var x = _v3.b;
				return $elm$parser$Parser$Advanced$Bad$(p1 || p2, x);
			} else {
				var p2 = _v3.a;
				var b = _v3.b;
				var s2 = _v3.c;
				return $elm$parser$Parser$Advanced$Good$(p1 || p2, b, s2);
			}
		}
	};
};
var $elm$parser$Parser$Advanced$andThen = F2($elm$parser$Parser$Advanced$andThen$);
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompWhileHelp$ = function (isGood, offset, row, col, s0) {
	chompWhileHelp:
	while (true) {
		var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.src);
		if (_Utils_eq(newOffset, -1)) {
			return $elm$parser$Parser$Advanced$Good$(
				_Utils_cmp(s0.offset, offset) < 0,
				0,
				{col: col, context: s0.context, indent: s0.indent, offset: offset, row: row, src: s0.src});
		} else {
			if (_Utils_eq(newOffset, -2)) {
				var $temp$offset = offset + 1,
					$temp$row = row + 1,
					$temp$col = 1;
				offset = $temp$offset;
				row = $temp$row;
				col = $temp$col;
				continue chompWhileHelp;
			} else {
				var $temp$offset = newOffset,
					$temp$col = col + 1;
				offset = $temp$offset;
				col = $temp$col;
				continue chompWhileHelp;
			}
		}
	}
};
var $elm$parser$Parser$Advanced$chompWhileHelp = F5($elm$parser$Parser$Advanced$chompWhileHelp$);
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return $elm$parser$Parser$Advanced$chompWhileHelp$(isGood, s.offset, s.row, s.col, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$mapChompedString$ = function (func, _v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var p = _v1.a;
			var x = _v1.b;
			return $elm$parser$Parser$Advanced$Bad$(p, x);
		} else {
			var p = _v1.a;
			var a = _v1.b;
			var s1 = _v1.c;
			return $elm$parser$Parser$Advanced$Good$(
				p,
				A2(
					func,
					A3($elm$core$String$slice, s0.offset, s1.offset, s0.src),
					a),
				s1);
		}
	};
};
var $elm$parser$Parser$Advanced$mapChompedString = F2($elm$parser$Parser$Advanced$mapChompedString$);
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return $elm$parser$Parser$Advanced$mapChompedString$($elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return $elm$parser$Parser$Advanced$Bad$(
			false,
			$elm$parser$Parser$Advanced$fromState$(s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return $elm$parser$Parser$Advanced$Good$(false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $author$project$EmailAddress$parseDomain = A2(
	$elm$parser$Parser$andThen,
	function (a) {
		return ($elm$core$String$length(a) < 1) ? $elm$parser$Parser$problem('Domain has to be atleast 1 character long.') : $elm$parser$Parser$succeed(a);
	},
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompWhile(
				function (a) {
					return ($elm$core$Char$isAlphaNum(a) || (a === '-')) && ((a !== '@') && (a !== '.'));
				}))));
var $author$project$EmailAddress$parseLocalPart = A2(
	$elm$parser$Parser$andThen,
	function (localPart) {
		return (A2($elm$core$String$startsWith, '.', localPart) || (A2($elm$core$String$endsWith, '.', localPart) || (!_Utils_eq(
			A2($elm$core$String$indexes, '..', localPart),
			_List_Nil)))) ? $elm$parser$Parser$problem('localPart can\u0027t start or end with a dot, nor can there be double dots') : ((!_Utils_eq(
			$elm$core$String$trim(localPart),
			localPart)) ? $elm$parser$Parser$problem('localPart can\u0027t be wrapped with whitespace') : $elm$parser$Parser$succeed(localPart));
	},
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompWhile(
				function (a) {
					return (a !== '+') && ((a !== '@') && ((a !== '\\') && (a !== '"')));
				}))));
var $author$project$EmailAddress$parseTld = A2(
	$elm$parser$Parser$andThen,
	function (a) {
		return ($elm$core$String$length(a) >= 2) ? $elm$parser$Parser$succeed(a) : $elm$parser$Parser$problem('Tld needs to be at least 2 character long.');
	},
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompWhile(
				function (a) {
					return $elm$core$Char$isUpper(a) || ($elm$core$Char$isLower(a) || (a === '-'));
				}))));
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$Token$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $elm$parser$Parser$Advanced$Token = F2($elm$parser$Parser$Advanced$Token$);
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.offset, s.row, s.col, s.src);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? $elm$parser$Parser$Advanced$Bad$(
			false,
			$elm$parser$Parser$Advanced$fromState$(s, expecting)) : $elm$parser$Parser$Advanced$Good$(
			progress,
			0,
			{col: newCol, context: s.context, indent: s.indent, offset: newOffset, row: newRow, src: s.src});
	};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		$elm$parser$Parser$Advanced$Token$(
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $author$project$EmailAddress$parseEmail = function () {
	var split = F2(
		function (_char, parser) {
			return $elm$parser$Parser$loop$(
				_List_Nil,
				function (r) {
					return $elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed(
										function (tld) {
											return $elm$parser$Parser$Loop(
												A2($elm$core$List$cons, tld, r));
										}),
									$elm$parser$Parser$symbol(
										$elm$core$String$fromChar(_char))),
								parser),
								A2(
								$elm$parser$Parser$map,
								function (_v1) {
									return $elm$parser$Parser$Done(
										$elm$core$List$reverse(r));
								},
								$elm$parser$Parser$succeed(0))
							]));
				});
		});
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$keeper,
					$elm$parser$Parser$succeed(
						F4(
							function (localPart, tags, domain, tlds) {
								var fullLocalPart = $elm$core$String$join$(
									'',
									_List_fromArray(
										[
											localPart,
											function () {
											if (!tags.b) {
												return '';
											} else {
												return '+' + $elm$core$String$join$('+', tags);
											}
										}()
										]));
								return ($elm$core$String$length(fullLocalPart) > 64) ? $elm$core$Maybe$Nothing : (($elm$core$List$length(tlds) < 1) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
									{
										domain: $elm$core$String$toLower(domain),
										localPart: $elm$core$String$toLower(localPart),
										tags: $elm$core$List$map$($elm$core$String$toLower, tags),
										tld: $elm$core$List$map$($elm$core$String$toLower, tlds)
									}));
							})),
					$author$project$EmailAddress$parseLocalPart),
				A2(
					$elm$parser$Parser$ignorer,
					A2(split, '+', $author$project$EmailAddress$parseLocalPart),
					$elm$parser$Parser$symbol('@'))),
			$author$project$EmailAddress$parseDomain),
		A2(
			$elm$parser$Parser$ignorer,
			A2(split, '.', $author$project$EmailAddress$parseTld),
			$elm$parser$Parser$end));
}();
var $elm$parser$Parser$DeadEnd$ = function (row, col, problem) {
	return {col: col, problem: problem, row: row};
};
var $elm$parser$Parser$DeadEnd = F3($elm$parser$Parser$DeadEnd$);
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return $elm$parser$Parser$DeadEnd$(p.row, p.col, p.problem);
};
var $elm$parser$Parser$Advanced$bagToList$ = function (bag, list) {
	bagToList:
	while (true) {
		switch (bag.$) {
			case 0:
				return list;
			case 1:
				var bag1 = bag.a;
				var x = bag.b;
				var $temp$bag = bag1,
					$temp$list = A2($elm$core$List$cons, x, list);
				bag = $temp$bag;
				list = $temp$list;
				continue bagToList;
			default:
				var bag1 = bag.a;
				var bag2 = bag.b;
				var $temp$bag = bag1,
					$temp$list = $elm$parser$Parser$Advanced$bagToList$(bag2, list);
				bag = $temp$bag;
				list = $temp$list;
				continue bagToList;
		}
	}
};
var $elm$parser$Parser$Advanced$bagToList = F2($elm$parser$Parser$Advanced$bagToList$);
var $elm$parser$Parser$Advanced$run$ = function (_v0, src) {
	var parse = _v0;
	var _v1 = parse(
		{col: 1, context: _List_Nil, indent: 1, offset: 0, row: 1, src: src});
	if (!_v1.$) {
		var value = _v1.b;
		return $elm$core$Result$Ok(value);
	} else {
		var bag = _v1.b;
		return $elm$core$Result$Err(
			$elm$parser$Parser$Advanced$bagToList$(bag, _List_Nil));
	}
};
var $elm$parser$Parser$Advanced$run = F2($elm$parser$Parser$Advanced$run$);
var $elm$parser$Parser$run$ = function (parser, source) {
	var _v0 = $elm$parser$Parser$Advanced$run$(parser, source);
	if (!_v0.$) {
		var a = _v0.a;
		return $elm$core$Result$Ok(a);
	} else {
		var problems = _v0.a;
		return $elm$core$Result$Err(
			$elm$core$List$map$($elm$parser$Parser$problemToDeadEnd, problems));
	}
};
var $elm$parser$Parser$run = F2($elm$parser$Parser$run$);
var $author$project$EmailAddress$fromString = function (string) {
	var _v0 = $elm$parser$Parser$run$($author$project$EmailAddress$parseEmail, string);
	if (!_v0.$) {
		var result = _v0.a;
		return result;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$PersonName$PersonName = $elm$core$Basics$identity;
var $author$project$PersonName$maxLength = 32;
var $author$project$PersonName$fromString = function (text) {
	var _v0 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(
		$elm$core$String$trim(text));
	if (!_v0.$) {
		var nonempty = _v0.a;
		return (_Utils_cmp(
			$MartinSStewart$elm_nonempty_string$String$Nonempty$length(nonempty),
			$author$project$PersonName$maxLength) > 0) ? $elm$core$Result$Err('Too long') : (A2(
			$MartinSStewart$elm_nonempty_string$String$Nonempty$any,
			function (_char) {
				return (_char === '\n') || ((_char === '\r') || (_char === '@'));
			},
			nonempty) ? $elm$core$Result$Err('Name can\u0027t contain line breaks or @ symbol') : (A2(
			$MartinSStewart$elm_nonempty_string$String$Nonempty$any,
			function (_char) {
				return ($elm$core$Char$toCode(_char) < 32) || ((_char === ' ') || ((_char === '​') || ((_char === '‌') || ((_char === '‍') || (_char === '⁠')))));
			},
			nonempty) ? $elm$core$Result$Err('Name can\u0027t contain special characters') : $elm$core$Result$Ok(nonempty)));
	} else {
		return $elm$core$Result$Err('Can\u0027t be empty');
	}
};
var $author$project$Pages$Admin$applyChangeToBackendUser$ = function (change, user) {
	var _v0 = $bburdette$toop$Toop$T2$(
		$author$project$PersonName$fromString(change.name),
		$author$project$EmailAddress$fromString(change.email));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var name = _v0.a.a;
		var email = _v0.b.a;
		var _v1 = user.email;
		if (_v1.$ === 1) {
			return $elm$core$Result$Ok(
				_Utils_update(
					user,
					{
						email: $author$project$User$UserHasEmail(email),
						isAdmin: change.isAdmin,
						name: name
					}));
		} else {
			return $elm$core$Result$Err(0);
		}
	} else {
		return $elm$core$Result$Err(0);
	}
};
var $author$project$Pages$Admin$applyChangeToBackendUser = F2($author$project$Pages$Admin$applyChangeToBackendUser$);
var $lamdera$containers$SeqDict$diff$ = function (t1, _v0) {
	var t2Triplets = _v0.c;
	var helper = F2(
		function (_v2, dict) {
			var hash = _v2.a;
			var key = _v2.b;
			var _v1 = $lamdera$containers$SeqDict$rebuildOnOverflow(dict);
			var bitmap2 = _v1.a;
			var nodes2 = _v1.b;
			var triplets2 = _v1.c;
			return $lamdera$containers$SeqDict$removeHelp$(0, hash, key, bitmap2, nodes2, triplets2);
		});
	return $lamdera$containers$SeqDict$intDictFoldl$(helper, t1, t2Triplets);
};
var $lamdera$containers$SeqDict$diff = F2($lamdera$containers$SeqDict$diff$);
var $author$project$User$NeverNotifyMe = 0;
var $author$project$User$NoLastDmViewed = {$: 2};
var $author$project$User$ShowEmbeds = 0;
var $author$project$UserColor$UserColor = $elm$core$Basics$identity;
var $author$project$UserColor$hueCount = 32;
var $avh4$elm_color$Color$RgbaSpace$ = function (a, b, c, d) {
	return {$: 0, a: a, b: b, c: c, d: d};
};
var $avh4$elm_color$Color$RgbaSpace = F4($avh4$elm_color$Color$RgbaSpace$);
var $avh4$elm_color$Color$scaleFrom255 = function (c) {
	return c / 255;
};
var $avh4$elm_color$Color$rgb255$ = function (r, g, b) {
	return $avh4$elm_color$Color$RgbaSpace$(
		$avh4$elm_color$Color$scaleFrom255(r),
		$avh4$elm_color$Color$scaleFrom255(g),
		$avh4$elm_color$Color$scaleFrom255(b),
		1.0);
};
var $avh4$elm_color$Color$rgb255 = F3($avh4$elm_color$Color$rgb255$);
var $author$project$Ui$rgb$ = function (r, g, b) {
	return $avh4$elm_color$Color$rgb255$(r, g, b);
};
var $author$project$Ui$rgb = F3($author$project$Ui$rgb$);
var $author$project$MyUi$background3 = $author$project$Ui$rgb$(39, 50, 76);
var $avh4$elm_color$Color$toRgba = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	return {alpha: a, blue: b, green: g, red: r};
};
var $author$project$UserColor$screenLuminance = function (color) {
	var _v0 = $avh4$elm_color$Color$toRgba(color);
	var blue = _v0.blue;
	var green = _v0.green;
	var red = _v0.red;
	var y = ((0.2126729 * A2($elm$core$Basics$pow, red, 2.4)) + (0.7151522 * A2($elm$core$Basics$pow, green, 2.4))) + (0.072175 * A2($elm$core$Basics$pow, blue, 2.4));
	return (y < 0.022) ? (y + A2($elm$core$Basics$pow, 0.022 - y, 1.414)) : y;
};
var $author$project$UserColor$apcaContrast$ = function (fontColor, backgroundColor) {
	var yText = $author$project$UserColor$screenLuminance(fontColor);
	var yBg = $author$project$UserColor$screenLuminance(backgroundColor);
	if ($elm$core$Basics$abs(yBg - yText) < 0.0005) {
		return 0;
	} else {
		if (_Utils_cmp(yBg, yText) > 0) {
			var sapc = (A2($elm$core$Basics$pow, yBg, 0.56) - A2($elm$core$Basics$pow, yText, 0.57)) * 1.14;
			return (sapc < 0.1) ? 0 : ((sapc - 0.027) * 100);
		} else {
			var sapc = (A2($elm$core$Basics$pow, yBg, 0.65) - A2($elm$core$Basics$pow, yText, 0.62)) * 1.14;
			return (_Utils_cmp(sapc, -0.1) > 0) ? 0 : ((sapc + 0.027) * 100);
		}
	}
};
var $author$project$UserColor$apcaContrast = F2($author$project$UserColor$apcaContrast$);
var $author$project$UserColor$isFontColorReadable$ = function (fontColor, backgroundColor) {
	return $elm$core$Basics$abs(
		$author$project$UserColor$apcaContrast$(fontColor, backgroundColor)) >= 30;
};
var $author$project$UserColor$isFontColorReadable = F2($author$project$UserColor$isFontColorReadable$);
var $author$project$UserColor$isReadable = function (color) {
	return $author$project$UserColor$isFontColorReadable$(color, $author$project$MyUi$background3);
};
var $author$project$UserColor$lightnessCount = 16;
var $author$project$UserColor$maxLightness = ($author$project$UserColor$lightnessCount - 1) - 2;
var $author$project$UserColor$minLightness = 5;
var $author$project$UserColor$saturationCount = 12;
var $avh4$elm_color$Color$hsla$ = function (hue, sat, light, alpha) {
	var _v0 = _Utils_Tuple3(hue, sat, light);
	var h = _v0.a;
	var s = _v0.b;
	var l = _v0.c;
	var m2 = (l <= 0.5) ? (l * (s + 1)) : ((l + s) - (l * s));
	var m1 = (l * 2) - m2;
	var hueToRgb = function (h__) {
		var h_ = (h__ < 0) ? (h__ + 1) : ((h__ > 1) ? (h__ - 1) : h__);
		return ((h_ * 6) < 1) ? (m1 + (((m2 - m1) * h_) * 6)) : (((h_ * 2) < 1) ? m2 : (((h_ * 3) < 2) ? (m1 + (((m2 - m1) * ((2 / 3) - h_)) * 6)) : m1));
	};
	var b = hueToRgb(h - (1 / 3));
	var g = hueToRgb(h);
	var r = hueToRgb(h + (1 / 3));
	return $avh4$elm_color$Color$RgbaSpace$(r, g, b, alpha);
};
var $avh4$elm_color$Color$hsla = F4($avh4$elm_color$Color$hsla$);
var $avh4$elm_color$Color$hsl$ = function (h, s, l) {
	return $avh4$elm_color$Color$hsla$(h, s, l, 1.0);
};
var $avh4$elm_color$Color$hsl = F3($avh4$elm_color$Color$hsl$);
var $author$project$UserColor$toParts = function (_v0) {
	var index = _v0;
	var wrapped = A2($elm$core$Basics$modBy, ($author$project$UserColor$hueCount * $author$project$UserColor$saturationCount) * $author$project$UserColor$lightnessCount, index);
	return {
		hue: A2($elm$core$Basics$modBy, $author$project$UserColor$hueCount, wrapped),
		lightness: (wrapped / ($author$project$UserColor$hueCount * $author$project$UserColor$saturationCount)) | 0,
		saturation: A2($elm$core$Basics$modBy, $author$project$UserColor$saturationCount, (wrapped / $author$project$UserColor$hueCount) | 0)
	};
};
var $author$project$UserColor$toColor = function (userColor) {
	var parts = $author$project$UserColor$toParts(userColor);
	return $avh4$elm_color$Color$hsl$(parts.hue / $author$project$UserColor$hueCount, parts.saturation / ($author$project$UserColor$saturationCount - 1), parts.lightness / ($author$project$UserColor$lightnessCount - 1));
};
var $author$project$UserColor$fromParts = function (parts) {
	var color = (A2($elm$core$Basics$modBy, $author$project$UserColor$hueCount, parts.hue) + (A2($elm$core$Basics$modBy, $author$project$UserColor$saturationCount, parts.saturation) * $author$project$UserColor$hueCount)) + ((A2($elm$core$Basics$modBy, $author$project$UserColor$lightnessCount, parts.lightness) * $author$project$UserColor$hueCount) * $author$project$UserColor$saturationCount);
	return ((_Utils_cmp(parts.lightness, $author$project$UserColor$minLightness) < 0) || (_Utils_cmp(parts.lightness, $author$project$UserColor$maxLightness) > 0)) ? $elm$core$Result$Err('Invalid lightness') : ($author$project$UserColor$isReadable(
		$author$project$UserColor$toColor(color)) ? $elm$core$Result$Ok(color) : $elm$core$Result$Err('Contrast is too low'));
};
var $author$project$Unsafe$userColor = function (record) {
	var _v0 = $author$project$UserColor$fromParts(record);
	if (!_v0.$) {
		var ok = _v0.a;
		return ok;
	} else {
		return $author$project$Unsafe$unreachable(0);
	}
};
var $author$project$RichText$defaultColor = $author$project$Unsafe$userColor(
	{hue: 0, lightness: 11, saturation: 0});
var $author$project$MuteSettings$init = {mutedDiscordDms: $lamdera$containers$SeqDict$empty, mutedDiscordGuilds: $lamdera$containers$SeqDict$empty, mutedDms: $lamdera$containers$SeqDict$empty, mutedGuilds: $lamdera$containers$SeqDict$empty, mutedSlackWorkspaces: $lamdera$containers$SeqDict$empty};
var $author$project$User$init$ = function (createdAt, name, email, userIsAdmin) {
	return {
		availableCustomEmojis: $lamdera$containers$SeqSet$empty,
		availableStickers: $lamdera$containers$SeqSet$empty,
		color: $author$project$RichText$defaultColor,
		createdAt: createdAt,
		deleteAccountAt: $elm$core$Maybe$Nothing,
		directMentions: $lamdera$containers$SeqDict$empty,
		discordDirectMentions: $lamdera$containers$SeqDict$empty,
		discordNotifyOnAllMessages: $lamdera$containers$SeqSet$empty,
		domainWhitelist: $lamdera$containers$SeqSet$empty,
		e2eeRisksAccepted: false,
		email: email,
		emailNotifications: 0,
		embedVisibility: 0,
		emojiConfig: {lastUsedEmojis: $elm$core$Array$empty, skinTone: $elm$core$Maybe$Nothing},
		icon: $elm$core$Maybe$Nothing,
		isAdmin: userIsAdmin,
		lastChannelViewed: $lamdera$containers$SeqDict$empty,
		lastDiscordChannelViewed: $lamdera$containers$SeqDict$empty,
		lastDmViewed: $author$project$User$NoLastDmViewed,
		lastEmailNotification: createdAt,
		lastLogPageViewed: $author$project$Id$fromInt(0),
		lastPushNotification: $elm$core$Maybe$Nothing,
		lastSlackChannelViewed: $lamdera$containers$SeqDict$empty,
		lastViewedMessage: $lamdera$containers$SeqDict$empty,
		lastViewedThreadMessage: $lamdera$containers$SeqDict$empty,
		linkDiscordAcknowledgementIsChecked: false,
		linkSlackAcknowledgementIsChecked: false,
		muteSettings: $author$project$MuteSettings$init,
		name: name,
		notifyOnAllMessages: $lamdera$containers$SeqSet$empty,
		publicKey: $elm$core$Maybe$Nothing,
		recentLoginEmails: _List_Nil,
		slackDirectMentions: $lamdera$containers$SeqDict$empty,
		slackNotifyOnAllMessages: $lamdera$containers$SeqSet$empty
	};
};
var $author$project$User$init = F4($author$project$User$init$);
var $author$project$NonemptyDict$size = function (_v0) {
	var dict = _v0.c;
	return $lamdera$containers$SeqDict$size(dict) + 1;
};
var $author$project$EmailAddress$toString = function (_v0) {
	var tld = _v0.tld;
	var domain = _v0.domain;
	var tags = _v0.tags;
	var localPart = _v0.localPart;
	return $elm$core$String$join$(
		'',
		_List_fromArray(
			[
				localPart,
				function () {
				if (!tags.b) {
					return '';
				} else {
					return '+' + $elm$core$String$join$('+', tags);
				}
			}(),
				'@',
				domain,
				'.',
				$elm$core$String$join$('.', tld)
			]));
};
var $author$project$Pages$Admin$applyChangesToBackendUsers$ = function (changedBy, _v0, users) {
	var deletedUsers = _v0.deletedUsers;
	var newUsers = _v0.newUsers;
	var changedUsers = _v0.changedUsers;
	var time = _v0.time;
	var resultB = $elm$core$Array$foldl$(
		F2(
			function (a, state) {
				var _v10 = $bburdette$toop$Toop$T3$(
					state,
					$author$project$PersonName$fromString(a.name),
					$author$project$EmailAddress$fromString(a.email));
				if (((!_v10.a.$) && (!_v10.b.$)) && (!_v10.c.$)) {
					var dict = _v10.a.a;
					var name = _v10.b.a;
					var email = _v10.c.a;
					var getId = function (id) {
						getId:
						while (true) {
							if ($author$project$NonemptyDict$member$(
								$author$project$Id$fromInt(id),
								users) || $lamdera$containers$SeqDict$member$(
								$author$project$Id$fromInt(id),
								dict)) {
								var $temp$id = id + 1;
								id = $temp$id;
								continue getId;
							} else {
								return $author$project$Id$fromInt(id);
							}
						}
					};
					return $elm$core$Result$Ok(
						$lamdera$containers$SeqDict$insert$(
							getId(
								$lamdera$containers$SeqDict$size(dict) + $author$project$NonemptyDict$size(users)),
							$author$project$User$init$(
								time,
								name,
								$author$project$User$UserHasEmail(email),
								a.isAdmin),
							dict));
				} else {
					return $elm$core$Result$Err($author$project$Pages$Admin$InvalidNewUser);
				}
			}),
		$elm$core$Result$Ok($lamdera$containers$SeqDict$empty),
		newUsers);
	var resultA = $lamdera$containers$SeqDict$foldl$(
		F3(
			function (userId, change, state) {
				if (!state.$) {
					var users2 = state.a;
					var _v8 = $author$project$NonemptyDict$get$(userId, users2);
					if (!_v8.$) {
						var user = _v8.a;
						var _v9 = $author$project$Pages$Admin$applyChangeToBackendUser$(change, user);
						if (!_v9.$) {
							var newUser = _v9.a;
							return $elm$core$Result$Ok(
								$author$project$NonemptyDict$insert$(userId, newUser, users2));
						} else {
							return $elm$core$Result$Err($author$project$Pages$Admin$InvalidChangesToUser);
						}
					} else {
						return $elm$core$Result$Err(
							$author$project$Pages$Admin$ChangesAppliedToNonExistentUser(userId));
					}
				} else {
					return state;
				}
			}),
		$elm$core$Result$Ok(users),
		changedUsers);
	var _v1 = _Utils_Tuple2(resultB, resultA);
	_v1$1:
	while (true) {
		if (!_v1.a.$) {
			if (!_v1.b.$) {
				var newUsersOk = _v1.a.a;
				var ok = _v1.b.a;
				var deletedUsers2 = $lamdera$containers$SeqDict$fromList(
					$elm$core$List$map$(
						function (id) {
							return _Utils_Tuple2(id, 0);
						},
						$lamdera$containers$SeqSet$toList(deletedUsers)));
				var allUsers = $lamdera$containers$SeqDict$union$(
					$lamdera$containers$SeqDict$diff$(
						$author$project$NonemptyDict$toSeqDict(ok),
						deletedUsers2),
					newUsersOk);
				var _v2 = $lamdera$containers$SeqDict$get$(changedBy, allUsers);
				if (!_v2.$) {
					var currentUser = _v2.a;
					if (currentUser.isAdmin) {
						var emailAddresses = $elm$core$Set$fromList(
							$elm$core$List$map$(
								function (_v5) {
									var userId = _v5.a;
									var user = _v5.b;
									var _v6 = user.email;
									if (_v6.$ === 1) {
										var email = _v6.a;
										return $author$project$EmailAddress$toString(email);
									} else {
										return $author$project$Id$toString(userId);
									}
								},
								$lamdera$containers$SeqDict$toList(allUsers)));
						var _v3 = _Utils_Tuple2(
							$author$project$NonemptyDict$fromSeqDict(allUsers),
							_Utils_eq(
								$elm$core$Set$size(emailAddresses),
								$lamdera$containers$SeqDict$size(allUsers)));
						_v3$1:
						while (true) {
							if (!_v3.a.$) {
								if (_v3.b) {
									var nonempty = _v3.a.a;
									return $elm$core$Result$Ok(nonempty);
								} else {
									break _v3$1;
								}
							} else {
								if (!_v3.b) {
									break _v3$1;
								} else {
									var _v4 = _v3.a;
									return $elm$core$Result$Err($author$project$Pages$Admin$CantDeleteYourself);
								}
							}
						}
						return $elm$core$Result$Err($author$project$Pages$Admin$EmailAddressesAreNotUnique);
					} else {
						return $elm$core$Result$Err($author$project$Pages$Admin$CantRemoveAdminRoleFromYourself);
					}
				} else {
					return $elm$core$Result$Err($author$project$Pages$Admin$CantDeleteYourself);
				}
			} else {
				break _v1$1;
			}
		} else {
			if (_v1.b.$ === 1) {
				break _v1$1;
			} else {
				var error = _v1.a.a;
				return $elm$core$Result$Err(error);
			}
		}
	}
	var error = _v1.b.a;
	return $elm$core$Result$Err(error);
};
var $author$project$Pages$Admin$applyChangesToBackendUsers = F3($author$project$Pages$Admin$applyChangesToBackendUsers$);
var $author$project$Pages$Admin$disconnectClient$ = function (sessionId, clientId, connections) {
	var _v0 = $lamdera$containers$SeqDict$get$(sessionId, connections);
	if (!_v0.$) {
		var clientIds = _v0.a;
		var _v1 = $author$project$NonemptyDict$get$(clientId, clientIds);
		if (!_v1.$) {
			var connection = _v1.a;
			return $elm$core$Result$Ok(
				_Utils_Tuple2(
					connection,
					$lamdera$containers$SeqDict$update$(
						sessionId,
						function (_v2) {
							return $author$project$NonemptyDict$fromSeqDict(
								$lamdera$containers$SeqDict$remove$(
									clientId,
									$author$project$NonemptyDict$toSeqDict(clientIds)));
						},
						connections)));
		} else {
			return $elm$core$Result$Err(0);
		}
	} else {
		return $elm$core$Result$Err(0);
	}
};
var $author$project$Pages$Admin$disconnectClient = F3($author$project$Pages$Admin$disconnectClient$);
var $author$project$LocalState$AdminDataLoading = {$: 1};
var $author$project$Pages$Admin$loadedAdminData = function (filledInByBackend) {
	if (filledInByBackend.$ === 1) {
		var data = filledInByBackend.a;
		return $author$project$LocalState$AdminDataLoaded(data);
	} else {
		return $author$project$LocalState$AdminDataLoading;
	}
};
var $author$project$Pages$Admin$rolesToDict = function (roles) {
	return $lamdera$containers$SeqDict$fromList(
		$elm$core$List$map$(
			function (role) {
				return _Utils_Tuple2(
					role.id,
					{description: role.description, name: role.name, permissions: role.permissions});
			},
			roles));
};
var $author$project$Pagination$PageLoading = {$: 0};
var $author$project$Pagination$setPage$ = function (pageId, filledInByBackend, model) {
	if (filledInByBackend.$ === 1) {
		var data = filledInByBackend.a;
		return _Utils_update(
			model,
			{
				currentPage: pageId,
				pages: $lamdera$containers$SeqDict$insert$(
					pageId,
					$author$project$Pagination$PageLoaded(data),
					model.pages),
				previousPage: model.currentPage
			});
	} else {
		var _v1 = $lamdera$containers$SeqDict$get$(pageId, model.pages);
		if (!_v1.$) {
			if (!_v1.a.$) {
				var _v2 = _v1.a;
				return _Utils_update(
					model,
					{currentPage: pageId, previousPage: model.currentPage});
			} else {
				return _Utils_update(
					model,
					{currentPage: pageId, previousPage: model.currentPage});
			}
		} else {
			return _Utils_update(
				model,
				{
					currentPage: pageId,
					pages: $lamdera$containers$SeqDict$insert$(pageId, $author$project$Pagination$PageLoading, model.pages),
					previousPage: model.currentPage
				});
		}
	}
};
var $author$project$Pagination$setPage = F3($author$project$Pagination$setPage$);
var $author$project$LocalState$updateAdminData$ = function (updateFunc, adminDataStatus) {
	switch (adminDataStatus.$) {
		case 2:
			var data = adminDataStatus.a;
			return $author$project$LocalState$AdminDataLoaded(
				updateFunc(data));
		case 1:
			return $author$project$LocalState$AdminDataLoading;
		default:
			return $author$project$LocalState$AdminDataNotLoaded;
	}
};
var $author$project$LocalState$updateAdminData = F2($author$project$LocalState$updateAdminData$);
var $author$project$LocalState$userIsLoadingDiscordChannel$ = function (userId, loadingDiscordChannels) {
	var _v0 = $lamdera$containers$SeqDict$get$(userId, loadingDiscordChannels);
	if (!_v0.$) {
		if (_v0.a.$ === 1) {
			var _v1 = _v0.a;
			var step = _v1.d;
			switch (step.$) {
				case 0:
					return true;
				case 1:
					return false;
				default:
					return true;
			}
		} else {
			var _v3 = _v0.a;
			var step = _v3.c;
			switch (step.$) {
				case 0:
					return true;
				case 1:
					return false;
				default:
					return true;
			}
		}
	} else {
		return false;
	}
};
var $author$project$LocalState$userIsLoadingDiscordChannel = F2($author$project$LocalState$userIsLoadingDiscordChannel$);
var $author$project$Pages$Admin$updateAdmin$ = function (changedBy, change, adminData, local) {
	switch (change.$) {
		case 0:
			var changes = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{
								users: $author$project$LocalState$updateAdminData$(
									function (users) {
										var _v1 = $author$project$Pages$Admin$applyChangesToBackendUsers$(changedBy, changes, users);
										if (!_v1.$) {
											var newUsers = _v1.a;
											return newUsers;
										} else {
											return users;
										}
									},
									adminData.users)
							}))
				});
		case 1:
			var pageIndex = change.a;
			var filledInByBackend = change.b;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{
								logs: $author$project$Pagination$setPage$(pageIndex, filledInByBackend, adminData.logs),
								users: $author$project$LocalState$updateAdminData$(
									A2(
										$author$project$NonemptyDict$updateIfExists,
										changedBy,
										function (user) {
											return _Utils_update(
												user,
												{lastLogPageViewed: pageIndex});
										}),
									adminData.users)
							}))
				});
		case 2:
			var filledInByBackend = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{
								users: $author$project$Pages$Admin$loadedAdminData(filledInByBackend)
							}))
				});
		case 3:
			var filledInByBackend = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{
								guilds: $author$project$Pages$Admin$loadedAdminData(filledInByBackend)
							}))
				});
		case 4:
			var filledInByBackend = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{
								deletedGuilds: $author$project$Pages$Admin$loadedAdminData(filledInByBackend)
							}))
				});
		case 5:
			var filledInByBackend = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{
								dmChannels: $author$project$Pages$Admin$loadedAdminData(filledInByBackend)
							}))
				});
		case 6:
			var filledInByBackend = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{
								discordGuilds: $author$project$Pages$Admin$loadedAdminData(filledInByBackend)
							}))
				});
		case 7:
			var filledInByBackend = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{
								discordDmChannels: $author$project$Pages$Admin$loadedAdminData(filledInByBackend)
							}))
				});
		case 8:
			var filledInByBackend = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{
								discordUsers: $author$project$Pages$Admin$loadedAdminData(filledInByBackend)
							}))
				});
		case 9:
			var filledInByBackend = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{
								slackWorkspaces: $author$project$Pages$Admin$loadedAdminData(filledInByBackend)
							}))
				});
		case 10:
			var filledInByBackend = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{
								slackDmChannels: $author$project$Pages$Admin$loadedAdminData(filledInByBackend)
							}))
				});
		case 11:
			var filledInByBackend = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{
								sessions: $author$project$Pages$Admin$loadedAdminData(filledInByBackend)
							}))
				});
		case 12:
			var filledInByBackend = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{
								websocketCloseEvents: $author$project$Pages$Admin$loadedAdminData(filledInByBackend)
							}))
				});
		case 13:
			var filledInByBackend = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{
								orphanedFiles: $author$project$Pages$Admin$loadedAdminData(filledInByBackend)
							}))
				});
		case 14:
			var filledInByBackend = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{
								toBackendLogs: $author$project$Pages$Admin$loadedAdminData(filledInByBackend)
							}))
				});
		case 15:
			var filledInByBackend = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{
								backendMsgLogs: $author$project$Pages$Admin$loadedAdminData(filledInByBackend)
							}))
				});
		case 16:
			var isEnabled = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{emailNotificationsEnabled: isEnabled}))
				});
		case 17:
			var isEnabled = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{signupsEnabled: isEnabled}))
				});
		case 18:
			var isEnabled = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{discordLinkingEnabled: isEnabled}))
				});
		case 19:
			var limit = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{discordLinkLimit: limit}))
				});
		case 20:
			var isEnabled = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{slackLinkingEnabled: isEnabled}))
				});
		case 21:
			var limit = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{slackLinkLimit: limit}))
				});
		case 22:
			var privateVapidKey = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{privateVapidKey: privateVapidKey}))
				});
		case 23:
			var publicVapidKey = change.a;
			return _Utils_update(
				local,
				{publicVapidKey: publicVapidKey});
		case 24:
			var openRouterKey = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{openRouterKey: openRouterKey}))
				});
		case 25:
			var notifyAdminsToken = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{notifyAdminsToken: notifyAdminsToken}))
				});
		case 26:
			var notifyAdminsBotUserId = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{notifyAdminsBotUserId: notifyAdminsBotUserId}))
				});
		case 27:
			var postmarkKey = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{postmarkKey: postmarkKey}))
				});
		case 28:
			var channelId = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{
								discordDmChannels: $author$project$LocalState$updateAdminData$(
									$lamdera$containers$SeqDict$remove(channelId),
									adminData.discordDmChannels)
							}))
				});
		case 29:
			var guildId = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{
								discordGuilds: $author$project$LocalState$updateAdminData$(
									$lamdera$containers$SeqDict$remove(guildId),
									adminData.discordGuilds)
							}))
				});
		case 30:
			var teamId = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{
								slackWorkspaces: $author$project$LocalState$updateAdminData$(
									$lamdera$containers$SeqDict$remove(teamId),
									adminData.slackWorkspaces)
							}))
				});
		case 31:
			var channelId = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{
								slackDmChannels: $author$project$LocalState$updateAdminData$(
									$lamdera$containers$SeqDict$remove(channelId),
									adminData.slackDmChannels)
							}))
				});
		case 32:
			var guildId = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{
								guilds: $author$project$LocalState$updateAdminData$(
									$lamdera$containers$SeqDict$remove(guildId),
									adminData.guilds)
							}))
				});
		case 33:
			var guildId = change.a;
			var _v2 = adminData.deletedGuilds;
			switch (_v2.$) {
				case 2:
					var deletedGuilds = _v2.a;
					var _v3 = $lamdera$containers$SeqDict$get$(guildId, deletedGuilds);
					if (!_v3.$) {
						var deletedGuild = _v3.a;
						return _Utils_update(
							local,
							{
								adminData: $author$project$LocalState$IsAdmin(
									_Utils_update(
										adminData,
										{
											deletedGuilds: $author$project$LocalState$AdminDataLoaded(
												$lamdera$containers$SeqDict$remove$(guildId, deletedGuilds)),
											guilds: $author$project$LocalState$updateAdminData$(
												A2(
													$lamdera$containers$SeqDict$insert,
													guildId,
													{channels: $lamdera$containers$SeqDict$empty, memberCount: deletedGuild.memberCount, name: deletedGuild.name, owner: deletedGuild.owner}),
												adminData.guilds)
										}))
							});
					} else {
						return local;
					}
				case 1:
					return local;
				default:
					return local;
			}
		case 34:
			var time = change.a;
			var userId = change.b;
			var guildId = change.c;
			var channelId = change.d;
			return $author$project$LocalState$userIsLoadingDiscordChannel$(userId, adminData.loadingDiscordChannels) ? local : _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{
								loadingDiscordChannels: $lamdera$containers$SeqDict$insert$(
									userId,
									$author$project$LocalState$LoadingDiscordGuildChannel$(time, guildId, channelId, $author$project$LocalState$LoadingDiscordChannelMessages),
									adminData.loadingDiscordChannels)
							}))
				});
		case 35:
			var time = change.a;
			var userId = change.b;
			var channelId = change.c;
			return $author$project$LocalState$userIsLoadingDiscordChannel$(userId, adminData.loadingDiscordChannels) ? local : _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{
								loadingDiscordChannels: $lamdera$containers$SeqDict$insert$(
									userId,
									$author$project$LocalState$LoadingDiscordDmChannel$(time, channelId, $author$project$LocalState$LoadingDiscordChannelMessages),
									adminData.loadingDiscordChannels)
							}))
				});
		case 36:
			var guildId = change.b;
			var toBeFilledInByBackend = change.c;
			if ((toBeFilledInByBackend.$ === 1) && (!toBeFilledInByBackend.a.$)) {
				var roles = toBeFilledInByBackend.a.a;
				return _Utils_update(
					local,
					{
						adminData: $author$project$LocalState$IsAdmin(
							_Utils_update(
								adminData,
								{
									discordGuilds: $author$project$LocalState$updateAdminData$(
										A2(
											$lamdera$containers$SeqDict$updateIfExists,
											guildId,
											function (guild) {
												return _Utils_update(
													guild,
													{
														roles: $author$project$Pages$Admin$rolesToDict(roles)
													});
											}),
										adminData.discordGuilds)
								}))
					});
			} else {
				return local;
			}
		case 37:
			var sessionIdHash = change.a;
			var clientId = change.b;
			return _Utils_update(
				local,
				{
					adminData: function () {
						var _v5 = $author$project$Pages$Admin$disconnectClient$(
							sessionIdHash,
							clientId,
							$lamdera$containers$SeqDict$fromList(adminData.connections));
						if (!_v5.$) {
							var _v6 = _v5.a;
							var connections = _v6.b;
							return $author$project$LocalState$IsAdmin(
								_Utils_update(
									adminData,
									{
										connections: $lamdera$containers$SeqDict$toList(connections)
									}));
						} else {
							return $author$project$LocalState$IsAdmin(adminData);
						}
					}()
				});
		case 38:
			var sessionIdHash = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{
								sessions: $author$project$LocalState$updateAdminData$(
									$lamdera$containers$SeqDict$remove(sessionIdHash),
									adminData.sessions)
							}))
				});
		case 39:
			var time = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						_Utils_update(
							adminData,
							{
								serverSecretRefreshedAt: function () {
									if (!time.$) {
										return $author$project$LocalState$BeingRegenerated;
									} else {
										var result = time.a;
										if (!result.$) {
											var time2 = result.a;
											return $author$project$LocalState$NotBeingRegenerated(
												$elm$core$Maybe$Just(time2));
										} else {
											var error = result.a;
											return $author$project$LocalState$RegenerationFailed(error);
										}
									}
								}()
							}))
				});
		default:
			var result = change.a;
			return _Utils_update(
				local,
				{
					adminData: $author$project$LocalState$IsAdmin(
						function () {
							if (!result.$) {
								return _Utils_update(
									adminData,
									{deleteOrphanedFiles: $author$project$LocalState$DeletingOrphanedFiles});
							} else {
								if (!result.a.$) {
									var deleted = result.a.a;
									return _Utils_update(
										adminData,
										{
											deleteOrphanedFiles: $author$project$LocalState$NotDeletingOrphanedFiles,
											filesCount: adminData.filesCount - $elm$core$List$length(deleted),
											orphanedFiles: $author$project$LocalState$updateAdminData$(
												function (orphanedFiles) {
													return $elm$core$List$foldl$($lamdera$containers$SeqDict$remove, orphanedFiles, deleted);
												},
												adminData.orphanedFiles)
										});
								} else {
									var error = result.a.a;
									return _Utils_update(
										adminData,
										{
											deleteOrphanedFiles: $author$project$LocalState$DeletingOrphanedFilesFailed(error)
										});
								}
							}
						}())
				});
	}
};
var $author$project$Pages$Admin$updateAdmin = F4($author$project$Pages$Admin$updateAdmin$);
var $author$project$LinkedAndOtherDiscordUsers$updateOtherUser$ = function (userId, updateFunc, _v0) {
	var otherUsers2 = _v0.a;
	var linkedUsers2 = _v0.b;
	return $author$project$LinkedAndOtherDiscordUsers$LinkedAndOtherDiscordUsers$(
		$lamdera$containers$SeqDict$update$(
			userId,
			function (a) {
				return $elm$core$Maybe$Just(
					updateFunc(a));
			},
			otherUsers2),
		linkedUsers2);
};
var $author$project$LinkedAndOtherDiscordUsers$updateOtherUser = F3($author$project$LinkedAndOtherDiscordUsers$updateOtherUser$);
var $author$project$LocalState$repliedToUserIdFrontend$ = function (maybeRepliedTo, channel) {
	if (!maybeRepliedTo.$) {
		var repliedTo = maybeRepliedTo.a;
		var _v1 = $author$project$MessageArray$get$(repliedTo, channel.messages);
		if (!_v1.$) {
			var message = _v1.a;
			switch (message.$) {
				case 0:
					var repliedToData = message.a;
					return $elm$core$Maybe$Just(repliedToData.createdBy);
				case 1:
					var repliedToData = message.a;
					return $elm$core$Maybe$Just(repliedToData.createdBy);
				case 2:
					var joinedUser = message.b;
					return $elm$core$Maybe$Just(joinedUser);
				case 3:
					return $elm$core$Maybe$Nothing;
				case 4:
					var startedBy = message.a.startedBy;
					return $elm$core$Maybe$Just(startedBy);
				default:
					var startedBy = message.a.startedBy;
					return $elm$core$Maybe$Just(startedBy);
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$LocalState$repliedToUserIdFrontend = F2($author$project$LocalState$repliedToUserIdFrontend$);
var $elmcraft$core_extra$Maybe$Extra$toList = function (m) {
	if (m.$ === 1) {
		return _List_Nil;
	} else {
		var x = m.a;
		return _List_fromArray(
			[x]);
	}
};
var $author$project$LocalState$usersMentionedOrRepliedToFrontend$ = function (threadRouteWithRepliedTo, content, channel) {
	return $elm$core$List$foldl$(
		$lamdera$containers$SeqSet$insert,
		$author$project$RichText$mentionsUser(content),
		function () {
			if (threadRouteWithRepliedTo.$ === 1) {
				var threadId = threadRouteWithRepliedTo.a;
				var maybeRepliedTo = threadRouteWithRepliedTo.b;
				return _Utils_ap(
					function () {
						var _v1 = $lamdera$containers$SeqDict$get$(threadId, channel.threads);
						if (!_v1.$) {
							var thread = _v1.a;
							return $elmcraft$core_extra$Maybe$Extra$toList(
								$author$project$LocalState$repliedToUserIdFrontend$(maybeRepliedTo, thread));
						} else {
							return _List_Nil;
						}
					}(),
					function () {
						var _v2 = $author$project$MessageArray$get$(threadId, channel.messages);
						if (!_v2.$) {
							var message = _v2.a;
							switch (message.$) {
								case 0:
									var data = message.a;
									return _List_fromArray(
										[data.createdBy]);
								case 1:
									var data = message.a;
									return _List_fromArray(
										[data.createdBy]);
								case 2:
									var userJoined = message.b;
									return _List_fromArray(
										[userJoined]);
								case 3:
									return _List_Nil;
								case 4:
									var startedBy = message.a.startedBy;
									return _List_fromArray(
										[startedBy]);
								default:
									var startedBy = message.a.startedBy;
									return _List_fromArray(
										[startedBy]);
							}
						} else {
							return _List_Nil;
						}
					}());
			} else {
				var maybeRepliedTo = threadRouteWithRepliedTo.a;
				return $elmcraft$core_extra$Maybe$Extra$toList(
					$author$project$LocalState$repliedToUserIdFrontend$(maybeRepliedTo, channel));
			}
		}());
};
var $author$project$LocalState$usersMentionedOrRepliedToFrontend = F3($author$project$LocalState$usersMentionedOrRepliedToFrontend$);
var $author$project$FrontendExtra$changeUpdate$ = function (localMsg, local) {
	if (!localMsg.$) {
		var changedBy = localMsg.a;
		var localChange = localMsg.b;
		switch (localChange.$) {
			case 0:
				return local;
			case 1:
				var adminChange = localChange.a;
				var _v2 = local.adminData;
				switch (_v2.$) {
					case 0:
						var adminData = _v2.a;
						return $author$project$Pages$Admin$updateAdmin$(changedBy, adminChange, adminData, local);
					case 1:
						return local;
					default:
						return local;
				}
			case 2:
				var createdAt = localChange.a;
				var guildOrDmId = localChange.c;
				var text = localChange.d;
				var threadRouteWithRepliedTo = localChange.e;
				var attachedFiles = localChange.f;
				var emojis = localChange.g;
				if (!guildOrDmId.$) {
					var id = guildOrDmId.a;
					var _v4 = $author$project$LocalState$getGuildAndChannel$(id, local);
					if (!_v4.$) {
						var _v5 = _v4.a;
						var guild = _v5.a;
						var channel = _v5.b;
						var user = local.localUser.user;
						var localUser = local.localUser;
						var _v6 = $author$project$LocalState$ownMessageIsReadFrontend$(
							$author$project$Id$GuildOrDmId(guildOrDmId),
							$author$project$FrontendExtra$newMessageThreadRoute$(
								$author$project$Message$threadRouteWithoutRepliedTo(threadRouteWithRepliedTo),
								channel),
							_Utils_Tuple2(localUser.currentlyViewing, user));
						var currentlyViewing2 = _v6.a;
						var user2 = _v6.b;
						return _Utils_update(
							local,
							{
								guilds: $author$project$FrontendExtra$guildSendMessage$(
									id.guildId,
									guild,
									id.channelId,
									channel,
									threadRouteWithRepliedTo,
									createdAt,
									localUser.session.userId,
									$author$project$FrontendExtra$textToRichText$(
										text,
										$author$project$MembersAndOwner$membersAndOwner(guild.membersAndOwner),
										$author$project$LocalState$guildChannelMentions$(local.localUser, guild.channels),
										local),
									attachedFiles,
									local),
								localUser: _Utils_update(
									localUser,
									{
										currentlyViewing: currentlyViewing2,
										user: $author$project$User$addRecentlyUsedEmojis$(emojis, user2)
									})
							});
					} else {
						return local;
					}
				} else {
					var otherUserId = guildOrDmId.a.otherUserId;
					var user = local.localUser.user;
					var localUser = local.localUser;
					var dmChannel = $elm$core$Maybe$withDefault$(
						$author$project$DmChannel$frontendInit,
						$lamdera$containers$SeqDict$get$(otherUserId, local.dmChannels));
					var dmChannel2 = function () {
						if (threadRouteWithRepliedTo.$ === 1) {
							var threadId = threadRouteWithRepliedTo.a;
							var maybeReplyTo = threadRouteWithRepliedTo.b;
							return $author$project$LocalState$createThreadMessageFrontend$(
								threadId,
								$author$project$Message$userTextMessageFrontend$(
									createdAt,
									localUser.session.userId,
									$author$project$FrontendExtra$textToRichText$(
										text,
										_List_fromArray(
											[localUser.session.userId, otherUserId]),
										$lamdera$containers$SeqDict$empty,
										local),
									$author$project$Message$maybeToReply(maybeReplyTo),
									attachedFiles),
								dmChannel);
						} else {
							var repliedTo = threadRouteWithRepliedTo.a;
							return $author$project$LocalState$createChannelMessageFrontend$(
								$author$project$Message$userTextMessageFrontend$(
									createdAt,
									localUser.session.userId,
									$author$project$FrontendExtra$textToRichText$(
										text,
										_List_fromArray(
											[localUser.session.userId, otherUserId]),
										$lamdera$containers$SeqDict$empty,
										local),
									repliedTo,
									attachedFiles),
								dmChannel);
						}
					}();
					var _v7 = $author$project$LocalState$ownMessageIsReadFrontend$(
						$author$project$Id$GuildOrDmId(guildOrDmId),
						$author$project$FrontendExtra$latestMessageThreadRoute$(
							$author$project$Message$threadRouteWithoutRepliedTo(threadRouteWithRepliedTo),
							dmChannel2),
						_Utils_Tuple2(localUser.currentlyViewing, user));
					var currentlyViewing2 = _v7.a;
					var user2 = _v7.b;
					return _Utils_update(
						local,
						{
							dmChannels: $lamdera$containers$SeqDict$insert$(otherUserId, dmChannel2, local.dmChannels),
							localUser: _Utils_update(
								localUser,
								{
									currentlyViewing: currentlyViewing2,
									user: $author$project$User$addRecentlyUsedEmojis$(emojis, user2)
								})
						});
				}
			case 3:
				var createdAt = localChange.a;
				var guildOrDmId = localChange.c;
				var text = localChange.d;
				var threadRouteWithRepliedTo = localChange.e;
				var attachedFiles = localChange.f;
				if (!guildOrDmId.$) {
					var channelId = guildOrDmId.a.channelId;
					var guildId = guildOrDmId.a.guildId;
					var currentUserId = guildOrDmId.a.currentUserId;
					var _v10 = $author$project$LocalState$getDiscordGuildAndChannel$(guildId, channelId, local);
					if (!_v10.$) {
						var _v11 = _v10.a;
						var guild = _v11.a;
						var channel = _v11.b;
						var user = local.localUser.user;
						var localUser = local.localUser;
						var _v12 = $author$project$LocalState$ownMessageIsReadFrontend$(
							$author$project$Id$DiscordGuildOrDmId(guildOrDmId),
							$author$project$FrontendExtra$newMessageThreadRoute$(
								$author$project$Id$threadRouteWithoutMaybeMessage(threadRouteWithRepliedTo),
								channel),
							_Utils_Tuple2(localUser.currentlyViewing, user));
						var currentlyViewing2 = _v12.a;
						var user2 = _v12.b;
						return _Utils_update(
							local,
							{
								discordGuilds: $author$project$FrontendExtra$discordGuildSendMessage$(
									guildId,
									guild,
									channelId,
									channel,
									threadRouteWithRepliedTo,
									createdAt,
									currentUserId,
									$author$project$FrontendExtra$textToDiscordRichText$(
										text,
										$author$project$MembersAndOwner$membersAndOwner(guild.membersAndOwner),
										$author$project$LocalState$discordGuildChannelMentions$(localUser, guild.channels),
										local),
									attachedFiles,
									local),
								localUser: _Utils_update(
									localUser,
									{currentlyViewing: currentlyViewing2, user: user2})
							});
					} else {
						return local;
					}
				} else {
					var channelId = guildOrDmId.a.channelId;
					var currentUserId = guildOrDmId.a.currentUserId;
					var _v13 = $lamdera$containers$SeqDict$get$(channelId, local.discordDmChannels);
					if (!_v13.$) {
						var dmChannel = _v13.a;
						var user = local.localUser.user;
						var localUser = local.localUser;
						var _v14 = $author$project$LocalState$ownMessageIsReadFrontend$(
							$author$project$Id$DiscordGuildOrDmId(guildOrDmId),
							$author$project$Id$NoThreadWithMessage(
								$author$project$Id$fromInt(
									$author$project$MessageArray$length(dmChannel.messages))),
							_Utils_Tuple2(localUser.currentlyViewing, user));
						var currentlyViewing2 = _v14.a;
						var user2 = _v14.b;
						return _Utils_update(
							local,
							{
								discordDmChannels: $lamdera$containers$SeqDict$insert$(
									channelId,
									function () {
										if (threadRouteWithRepliedTo.$ === 1) {
											return dmChannel;
										} else {
											var maybeReplyTo = threadRouteWithRepliedTo.a;
											return $author$project$LocalState$createDiscordDmMessageFrontend$(
												$author$project$Message$userTextMessageFrontend$(
													createdAt,
													currentUserId,
													$author$project$FrontendExtra$textToDiscordRichText$(
														text,
														$mgold$elm_nonempty_list$List$Nonempty$toList(
															$author$project$NonemptyDict$keys(dmChannel.members)),
														$lamdera$containers$SeqDict$empty,
														local),
													$author$project$Message$maybeToReply(maybeReplyTo),
													attachedFiles),
												dmChannel);
										}
									}(),
									local.discordDmChannels),
								localUser: _Utils_update(
									localUser,
									{currentlyViewing: currentlyViewing2, user: user2})
							});
					} else {
						return local;
					}
				}
			case 8:
				var time = localChange.a;
				var guildId = localChange.b;
				var channelName = localChange.c;
				var channelDescription = localChange.d;
				return _Utils_update(
					local,
					{
						guilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							A4($author$project$LocalState$createChannelFrontend, time, local.localUser.session.userId, channelName, channelDescription),
							local.guilds)
					});
			case 9:
				var guildId = localChange.a;
				var channelId = localChange.b;
				var channelName = localChange.c;
				var channelDescription = localChange.d;
				return _Utils_update(
					local,
					{
						guilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							A3($author$project$LocalState$editChannel, channelName, channelDescription, channelId),
							local.guilds)
					});
			case 10:
				var guildId = localChange.a;
				var channelId = localChange.b;
				return _Utils_update(
					local,
					{
						guilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							$author$project$LocalState$deleteChannelFrontend(channelId),
							local.guilds)
					});
			case 11:
				var guildId = localChange.a;
				var guildName = localChange.b;
				return _Utils_update(
					local,
					{
						guilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							$author$project$LocalState$editGuildName(guildName),
							local.guilds)
					});
			case 12:
				var guildId = localChange.a;
				return _Utils_update(
					local,
					{
						guilds: $lamdera$containers$SeqDict$remove$(guildId, local.guilds)
					});
			case 13:
				var guildId = localChange.a;
				return _Utils_update(
					local,
					{
						guilds: $lamdera$containers$SeqDict$remove$(guildId, local.guilds)
					});
			case 14:
				var time = localChange.a;
				var guildId = localChange.b;
				var inviteLinkId = localChange.c;
				if (!inviteLinkId.$) {
					return local;
				} else {
					var inviteLinkId2 = inviteLinkId.a;
					return _Utils_update(
						local,
						{
							guilds: $lamdera$containers$SeqDict$updateIfExists$(
								guildId,
								A3($author$project$LocalState$addInvite, inviteLinkId2, local.localUser.session.userId, time),
								local.guilds)
						});
				}
			case 15:
				var guildId = localChange.a;
				var inviteLinkId = localChange.b;
				return _Utils_update(
					local,
					{
						guilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							$author$project$LocalState$removeInvite(inviteLinkId),
							local.guilds)
					});
			case 16:
				var guildId = localChange.a;
				var userId = localChange.b;
				return _Utils_update(
					local,
					{
						guilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							function (guild) {
								return _Utils_update(
									guild,
									{
										membersAndOwner: $author$project$MembersAndOwner$removeMember$(userId, guild.membersAndOwner)
									});
							},
							local.guilds)
					});
			case 17:
				var time = localChange.a;
				var guildName = localChange.b;
				var guildIdPlaceholder = localChange.c;
				if (!guildIdPlaceholder.$) {
					return local;
				} else {
					var guildId = guildIdPlaceholder.a;
					var guild = $author$project$LocalState$createGuild$(time, local.localUser.session.userId, guildName);
					return _Utils_update(
						local,
						{
							guilds: $lamdera$containers$SeqDict$insert$(
								guildId,
								$author$project$LocalState$guildToFrontend$(
									guildId,
									$elm$core$Maybe$Just(
										_Utils_Tuple2(
											$author$project$LocalState$announcementChannel(guild),
											_Utils_Tuple2($author$project$Id$NoThread, $elm$core$Maybe$Nothing))),
									$author$project$OneToOne$empty,
									guild),
								local.guilds)
						});
				}
			case 18:
				var time = localChange.a;
				var _v18 = localChange.b;
				var guildOrDmId = _v18.a;
				var threadRoute = _v18.b;
				switch (guildOrDmId.$) {
					case 0:
						var guildOrDmId2 = guildOrDmId.a;
						return $author$project$FrontendExtra$memberTyping$(time, local.localUser.session.userId, guildOrDmId2, threadRoute, local);
					case 1:
						var guildOrDmId2 = guildOrDmId.a;
						if (!guildOrDmId2.$) {
							var channelId = guildOrDmId2.a.channelId;
							var guildId = guildOrDmId2.a.guildId;
							var currentUserId = guildOrDmId2.a.currentUserId;
							return $author$project$FrontendExtra$discordGuildMemberTyping$(time, currentUserId, guildId, channelId, threadRoute, local);
						} else {
							var data = guildOrDmId2.a;
							return $author$project$FrontendExtra$discordDmMemberTyping$(time, data.currentUserId, data.channelId, local);
						}
					default:
						return local;
				}
			case 19:
				var guildOrDmId = localChange.a;
				var threadRoute = localChange.b;
				var emoji = localChange.c;
				return $author$project$FrontendExtra$addReactionEmoji$(local.localUser.session.userId, guildOrDmId, threadRoute, emoji, local);
			case 20:
				var guildOrDmId = localChange.a;
				var threadRoute = localChange.b;
				var emoji = localChange.c;
				return $author$project$FrontendExtra$removeReactionEmoji$(local.localUser.session.userId, guildOrDmId, threadRoute, emoji, local);
			case 21:
				var time = localChange.a;
				var guildOrDmId = localChange.c;
				var threadRoute = localChange.d;
				var newContent = localChange.e;
				var attachedFiles = localChange.f;
				return $author$project$FrontendExtra$editMessage$(time, local.localUser.session.userId, guildOrDmId, newContent, attachedFiles, threadRoute, local);
			case 22:
				var time = localChange.a;
				var currentUserId = localChange.c;
				var guildId = localChange.d;
				var channelId = localChange.e;
				var threadRoute = localChange.f;
				var newContent = localChange.g;
				return _Utils_update(
					local,
					{
						discordGuilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							function (guild) {
								return $author$project$LocalState$updateChannel$(
									function (channel) {
										return $elm$core$Result$withDefault$(
											channel,
											$author$project$LocalState$editMessageFrontendHelper$(
												time,
												currentUserId,
												$author$project$FrontendExtra$textToDiscordRichText$(
													newContent,
													$author$project$MembersAndOwner$membersAndOwner(guild.membersAndOwner),
													$author$project$LocalState$discordGuildChannelMentions$(local.localUser, guild.channels),
													local),
												$author$project$Message$DoNotChangeAttachments,
												threadRoute,
												channel));
									},
									channelId,
									guild);
							},
							local.discordGuilds)
					});
			case 23:
				var time = localChange.a;
				var dmData = localChange.c;
				var messageId = localChange.d;
				var newContent = localChange.e;
				return _Utils_update(
					local,
					{
						discordDmChannels: $lamdera$containers$SeqDict$updateIfExists$(
							dmData.channelId,
							function (dmChannel) {
								return $elm$core$Result$withDefault$(
									dmChannel,
									$author$project$LocalState$editMessageFrontendHelperNoThread$(
										time,
										dmData.currentUserId,
										$author$project$FrontendExtra$textToDiscordRichText$(
											newContent,
											$mgold$elm_nonempty_list$List$Nonempty$toList(
												$author$project$NonemptyDict$keys(dmChannel.members)),
											$lamdera$containers$SeqDict$empty,
											local),
										$author$project$Message$DoNotChangeAttachments,
										messageId,
										dmChannel));
							},
							local.discordDmChannels)
					});
			case 24:
				var time = localChange.a;
				var guildOrDmId = localChange.b;
				var threadRoute = localChange.c;
				return $author$project$FrontendExtra$memberEditTyping$(time, local.localUser.session.userId, guildOrDmId, threadRoute, local);
			case 25:
				var guildOrDmId = localChange.a;
				var threadRoute = localChange.b;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								currentlyViewing: function () {
									if ($author$project$UserSession$isViewing$(
										guildOrDmId,
										$author$project$Id$threadRouteWithoutMessage(threadRoute),
										localUser.currentlyViewing)) {
										if (!threadRoute.$) {
											var messageId = threadRoute.a;
											return $author$project$UserSession$setPreviouslyLastViewedChannelMessage$(messageId, localUser.currentlyViewing);
										} else {
											var messageId = threadRoute.b;
											return $author$project$UserSession$setPreviouslyLastViewedThreadMessage$(messageId, localUser.currentlyViewing);
										}
									} else {
										return localUser.currentlyViewing;
									}
								}(),
								user: $author$project$User$setLastViewedMessage$(guildOrDmId, threadRoute, local.localUser.user)
							})
					});
			case 26:
				var guildOrDmId = localChange.a;
				var threadRoute = localChange.b;
				return $author$project$FrontendExtra$deleteMessage$(guildOrDmId, threadRoute, local);
			case 27:
				var markMessagesAsViewed = localChange.a.markMessagesAsViewed;
				var viewing = localChange.b;
				var previousLocalUser = local.localUser;
				var localUser = _Utils_update(
					previousLocalUser,
					{
						session: $author$project$UserSession$setLastViewedGuild$(
							$author$project$SetViewing$setViewingToCurrentlyViewing(viewing),
							previousLocalUser.session)
					});
				switch (viewing.$) {
					case 0:
						var data = viewing.a;
						var messagesLoaded = viewing.b;
						return _Utils_update(
							local,
							{
								dmChannels: $lamdera$containers$SeqDict$updateIfExists$(
									data.id.otherUserId,
									$author$project$DmChannel$loadChannelMessages(messagesLoaded),
									local.dmChannels),
								localUser: _Utils_update(
									localUser,
									{
										currentlyViewing: $author$project$SetViewing$setViewingToCurrentlyViewing(viewing),
										user: $author$project$User$setLastDmViewed$(
											data.id,
											$author$project$Id$NoThreadWithMaybeMessage(
												markMessagesAsViewed ? $elm$core$Maybe$map$(
													$author$project$DmChannel$latestFrontendMessageId,
													$lamdera$containers$SeqDict$get$(data.id.otherUserId, local.dmChannels)) : $elm$core$Maybe$Nothing),
											localUser.user)
									})
							});
					case 1:
						var data = viewing.a;
						var messagesLoaded = viewing.b;
						return _Utils_update(
							local,
							{
								dmChannels: $lamdera$containers$SeqDict$updateIfExists$(
									data.id.otherUserId,
									function (dmChannel) {
										return _Utils_update(
											dmChannel,
											{
												threads: $lamdera$containers$SeqDict$updateIfExists$(
													data.id.threadId,
													$author$project$DmChannel$loadMessages(messagesLoaded),
													dmChannel.threads)
											});
									},
									local.dmChannels),
								localUser: _Utils_update(
									localUser,
									{
										currentlyViewing: $author$project$SetViewing$setViewingToCurrentlyViewing(viewing),
										user: $author$project$User$setLastDmViewed$(
											{otherUserId: data.id.otherUserId},
											$author$project$Id$ViewThreadWithMaybeMessage$(
												data.id.threadId,
												markMessagesAsViewed ? $elm$core$Maybe$map$(
													$author$project$DmChannel$latestFrontendThreadMessageId,
													$elm$core$Maybe$andThen$(
														function (dmChannel) {
															return $lamdera$containers$SeqDict$get$(data.id.threadId, dmChannel.threads);
														},
														$lamdera$containers$SeqDict$get$(data.id.otherUserId, local.dmChannels))) : $elm$core$Maybe$Nothing),
											localUser.user)
									})
							});
					case 7:
						var data = viewing.a;
						var messagesLoaded = viewing.b;
						return _Utils_update(
							local,
							{
								localUser: _Utils_update(
									localUser,
									{
										currentlyViewing: $author$project$SetViewing$setViewingToCurrentlyViewing(viewing),
										user: $author$project$User$setLastSlackChannelViewed$(
											data.id,
											$author$project$Id$NoThreadWithMaybeMessage(
												markMessagesAsViewed ? $elm$core$Maybe$map$(
													function (_v23) {
														var channel = _v23.b;
														return $author$project$DmChannel$latestFrontendMessageId(channel);
													},
													$author$project$LocalState$getSlackWorkspaceAndChannel$(data.id.teamId, data.id.channelId, local)) : $elm$core$Maybe$Nothing),
											localUser.user)
									}),
								slackWorkspaces: $lamdera$containers$SeqDict$updateIfExists$(
									data.id.teamId,
									A2(
										$author$project$LocalState$updateChannel,
										$author$project$DmChannel$loadMessages(messagesLoaded),
										data.id.channelId),
									local.slackWorkspaces)
							});
					case 8:
						var data = viewing.a;
						var messagesLoaded = viewing.b;
						return _Utils_update(
							local,
							{
								localUser: _Utils_update(
									localUser,
									{
										currentlyViewing: $author$project$SetViewing$setViewingToCurrentlyViewing(viewing),
										user: function () {
											var _v24 = $lamdera$containers$SeqDict$get$(data.id.channelId, local.slackDmChannels);
											if (!_v24.$) {
												var dmChannel = _v24.a;
												return markMessagesAsViewed ? $author$project$User$setLastViewedMessage$(
													$author$project$Id$SlackGuildOrDmId(
														$author$project$Id$SlackGuildOrDmId_Dm(data.id)),
													$author$project$Id$NoThreadWithMessage(
														$author$project$DmChannel$latestFrontendMessageId(dmChannel)),
													localUser.user) : localUser.user;
											} else {
												return localUser.user;
											}
										}()
									}),
								slackDmChannels: $lamdera$containers$SeqDict$updateIfExists$(
									data.id.channelId,
									$author$project$DmChannel$loadMessages(messagesLoaded),
									local.slackDmChannels)
							});
					case 9:
						var data = viewing.a;
						var messagesLoaded = viewing.b;
						return _Utils_update(
							local,
							{
								localUser: _Utils_update(
									localUser,
									{
										currentlyViewing: $author$project$SetViewing$setViewingToCurrentlyViewing(viewing),
										user: $author$project$User$setLastSlackChannelViewed$(
											data.id,
											$author$project$Id$ViewThreadWithMaybeMessage$(
												data.threadId,
												markMessagesAsViewed ? $elm$core$Maybe$map$(
													$author$project$DmChannel$latestFrontendThreadMessageId,
													$elm$core$Maybe$andThen$(
														function (_v25) {
															var channel = _v25.b;
															return $lamdera$containers$SeqDict$get$(data.threadId, channel.threads);
														},
														$author$project$LocalState$getSlackWorkspaceAndChannel$(data.id.teamId, data.id.channelId, local))) : $elm$core$Maybe$Nothing),
											localUser.user)
									}),
								slackWorkspaces: $lamdera$containers$SeqDict$updateIfExists$(
									data.id.teamId,
									A2(
										$author$project$LocalState$updateChannel,
										function (channel) {
											return _Utils_update(
												channel,
												{
													threads: $lamdera$containers$SeqDict$updateIfExists$(
														data.threadId,
														$author$project$DmChannel$loadMessages(messagesLoaded),
														channel.threads)
												});
										},
										data.id.channelId),
									local.slackWorkspaces)
							});
					case 10:
						var data = viewing.a;
						var messagesLoaded = viewing.b;
						return _Utils_update(
							local,
							{
								localUser: _Utils_update(
									localUser,
									{
										currentlyViewing: $author$project$SetViewing$setViewingToCurrentlyViewing(viewing),
										user: function () {
											var _v26 = $elm$core$Maybe$andThen$(
												function (dmChannel) {
													return $lamdera$containers$SeqDict$get$(data.threadId, dmChannel.threads);
												},
												$lamdera$containers$SeqDict$get$(data.id.channelId, local.slackDmChannels));
											if (!_v26.$) {
												var thread = _v26.a;
												return markMessagesAsViewed ? $author$project$User$setLastViewedMessage$(
													$author$project$Id$SlackGuildOrDmId(
														$author$project$Id$SlackGuildOrDmId_Dm(data.id)),
													$author$project$Id$ViewThreadWithMessage$(
														data.threadId,
														$author$project$DmChannel$latestFrontendThreadMessageId(thread)),
													localUser.user) : localUser.user;
											} else {
												return localUser.user;
											}
										}()
									}),
								slackDmChannels: $lamdera$containers$SeqDict$updateIfExists$(
									data.id.channelId,
									function (dmChannel) {
										return _Utils_update(
											dmChannel,
											{
												threads: $lamdera$containers$SeqDict$updateIfExists$(
													data.threadId,
													$author$project$DmChannel$loadMessages(messagesLoaded),
													dmChannel.threads)
											});
									},
									local.slackDmChannels)
							});
					case 2:
						var data = viewing.a;
						var messagesLoaded = viewing.b;
						return _Utils_update(
							local,
							{
								discordDmChannels: $lamdera$containers$SeqDict$updateIfExists$(
									data.id.channelId,
									$author$project$DmChannel$loadMessages(messagesLoaded),
									local.discordDmChannels),
								localUser: _Utils_update(
									localUser,
									{
										currentlyViewing: $author$project$SetViewing$setViewingToCurrentlyViewing(viewing),
										user: $author$project$User$setLastDiscordDmViewed$(
											data.id.currentUserId,
											data.id.channelId,
											markMessagesAsViewed ? $elm$core$Maybe$map$(
												$author$project$DmChannel$latestFrontendMessageId,
												$lamdera$containers$SeqDict$get$(data.id.channelId, local.discordDmChannels)) : $elm$core$Maybe$Nothing,
											localUser.user)
									})
							});
					case 3:
						var data = viewing.a;
						var messagesLoaded = viewing.b;
						return _Utils_update(
							local,
							{
								guilds: $lamdera$containers$SeqDict$updateIfExists$(
									data.id.guildId,
									A2(
										$author$project$LocalState$updateChannel,
										$author$project$DmChannel$loadChannelMessages(messagesLoaded),
										data.id.channelId),
									local.guilds),
								localUser: _Utils_update(
									localUser,
									{
										currentlyViewing: $author$project$SetViewing$setViewingToCurrentlyViewing(viewing),
										user: $author$project$User$setLastChannelViewed$(
											data.id,
											$author$project$Id$NoThreadWithMaybeMessage(
												markMessagesAsViewed ? $elm$core$Maybe$map$(
													function (_v27) {
														var channel = _v27.b;
														return $author$project$DmChannel$latestFrontendMessageId(channel);
													},
													$author$project$LocalState$getGuildAndChannel$(data.id, local)) : $elm$core$Maybe$Nothing),
											localUser.user)
									})
							});
					case 4:
						var data = viewing.a;
						var messagesLoaded = viewing.b;
						return _Utils_update(
							local,
							{
								guilds: $lamdera$containers$SeqDict$updateIfExists$(
									data.id.guildId,
									A2(
										$author$project$LocalState$updateChannel,
										function (channel) {
											return _Utils_update(
												channel,
												{
													threads: $lamdera$containers$SeqDict$updateIfExists$(
														data.id.threadId,
														$author$project$DmChannel$loadMessages(messagesLoaded),
														channel.threads)
												});
										},
										data.id.channelId),
									local.guilds),
								localUser: _Utils_update(
									localUser,
									{
										currentlyViewing: $author$project$SetViewing$setViewingToCurrentlyViewing(viewing),
										user: $author$project$User$setLastChannelViewed$(
											{channelId: data.id.channelId, guildId: data.id.guildId},
											$author$project$Id$ViewThreadWithMaybeMessage$(
												data.id.threadId,
												markMessagesAsViewed ? $elm$core$Maybe$map$(
													$author$project$DmChannel$latestFrontendThreadMessageId,
													$elm$core$Maybe$andThen$(
														function (_v28) {
															var channel = _v28.b;
															return $lamdera$containers$SeqDict$get$(data.id.threadId, channel.threads);
														},
														$author$project$LocalState$getGuildAndChannel$(
															{channelId: data.id.channelId, guildId: data.id.guildId},
															local))) : $elm$core$Maybe$Nothing),
											localUser.user)
									})
							});
					case 11:
						return _Utils_update(
							local,
							{
								localUser: _Utils_update(
									localUser,
									{
										currentlyViewing: $author$project$SetViewing$setViewingToCurrentlyViewing(viewing)
									})
							});
					case 5:
						var data = viewing.a;
						var backendData = viewing.b;
						return _Utils_update(
							local,
							{
								discordGuilds: $lamdera$containers$SeqDict$updateIfExists$(
									data.id.guildId,
									A2(
										$author$project$LocalState$updateChannel,
										$author$project$DmChannel$loadMessages(
											$author$project$FrontendExtra$discordViewMessages(backendData)),
										data.id.channelId),
									local.discordGuilds),
								localUser: _Utils_update(
									localUser,
									{
										currentlyViewing: $author$project$SetViewing$setViewingToCurrentlyViewing(viewing),
										discordUsers: function () {
											if (backendData.$ === 1) {
												var backendData2 = backendData.a;
												return $lamdera$containers$SeqDict$foldl$($author$project$LinkedAndOtherDiscordUsers$addOtherUser, localUser.discordUsers, backendData2.newUsers);
											} else {
												return localUser.discordUsers;
											}
										}(),
										user: $author$project$User$setLastDiscordChannelViewed$(
											data.id,
											$author$project$Id$NoThreadWithMaybeMessage(
												markMessagesAsViewed ? $elm$core$Maybe$map$(
													function (_v30) {
														var channel = _v30.b;
														return $author$project$DmChannel$latestFrontendMessageId(channel);
													},
													$author$project$LocalState$getDiscordGuildAndChannel$(data.id.guildId, data.id.channelId, local)) : $elm$core$Maybe$Nothing),
											localUser.user)
									})
							});
					case 6:
						var data = viewing.a;
						var backendData = viewing.b;
						return _Utils_update(
							local,
							{
								discordGuilds: $lamdera$containers$SeqDict$updateIfExists$(
									data.id.guildId,
									A2(
										$author$project$LocalState$updateChannel,
										function (channel) {
											return _Utils_update(
												channel,
												{
													threads: $lamdera$containers$SeqDict$updateIfExists$(
														data.id.threadId,
														$author$project$DmChannel$loadMessages(
															$author$project$FrontendExtra$discordViewMessages(backendData)),
														channel.threads)
												});
										},
										data.id.channelId),
									local.discordGuilds),
								localUser: _Utils_update(
									localUser,
									{
										currentlyViewing: $author$project$SetViewing$setViewingToCurrentlyViewing(viewing),
										discordUsers: function () {
											if (backendData.$ === 1) {
												var backendData2 = backendData.a;
												return $lamdera$containers$SeqDict$foldl$($author$project$LinkedAndOtherDiscordUsers$addOtherUser, localUser.discordUsers, backendData2.newUsers);
											} else {
												return localUser.discordUsers;
											}
										}(),
										user: $author$project$User$setLastDiscordChannelViewed$(
											{channelId: data.id.channelId, currentUserId: data.id.currentUserId, guildId: data.id.guildId},
											$author$project$Id$ViewThreadWithMaybeMessage$(
												data.id.threadId,
												markMessagesAsViewed ? $elm$core$Maybe$map$(
													$author$project$DmChannel$latestFrontendThreadMessageId,
													$elm$core$Maybe$andThen$(
														function (_v32) {
															var channel = _v32.b;
															return $lamdera$containers$SeqDict$get$(data.id.threadId, channel.threads);
														},
														$author$project$LocalState$getDiscordGuildAndChannel$(data.id.guildId, data.id.channelId, local))) : $elm$core$Maybe$Nothing),
											localUser.user)
									})
							});
					default:
						var overviewData = viewing.a;
						var localUser2 = _Utils_update(
							localUser,
							{
								currentlyViewing: $author$project$SetViewing$setViewingToCurrentlyViewing(viewing)
							});
						if (overviewData.$ === 1) {
							var overviewData2 = overviewData.a;
							var slackWorkspaces = $lamdera$containers$SeqDict$foldl$(
								F3(
									function (_v41, messages, slackWorkspaces2) {
										var teamId = _v41.a;
										var channelId = _v41.b;
										return $lamdera$containers$SeqDict$updateIfExists$(
											teamId,
											A2(
												$author$project$LocalState$updateChannel,
												$author$project$DmChannel$loadUnreadMessages(messages),
												channelId),
											slackWorkspaces2);
									}),
								local.slackWorkspaces,
								overviewData2.slackChannels);
							var slackDmChannels = $lamdera$containers$SeqDict$foldl$(
								F3(
									function (channelId, messages, slackDmChannels2) {
										return $lamdera$containers$SeqDict$updateIfExists$(
											channelId,
											$author$project$DmChannel$loadUnreadMessages(messages),
											slackDmChannels2);
									}),
								local.slackDmChannels,
								overviewData2.slackDmChannels);
							var guilds = $lamdera$containers$SeqDict$foldl$(
								F3(
									function (_v40, messages, guilds2) {
										var guildId = _v40.a;
										var channelId = _v40.b;
										return $lamdera$containers$SeqDict$updateIfExists$(
											guildId,
											A2(
												$author$project$LocalState$updateChannel,
												$author$project$DmChannel$loadUnreadMessages(messages),
												channelId),
											guilds2);
									}),
								local.guilds,
								overviewData2.guildChannels);
							var dmChannels = $lamdera$containers$SeqDict$foldl$(
								F3(
									function (otherUserId, messages, dmChannels2) {
										return $lamdera$containers$SeqDict$updateIfExists$(
											otherUserId,
											$author$project$DmChannel$loadUnreadMessages(messages),
											dmChannels2);
									}),
								local.dmChannels,
								overviewData2.dmChannels);
							var discordGuilds = $lamdera$containers$SeqDict$foldl$(
								F3(
									function (_v39, messages, discordGuilds2) {
										var guildId = _v39.a;
										var channelId = _v39.b;
										return $lamdera$containers$SeqDict$updateIfExists$(
											guildId,
											A2(
												$author$project$LocalState$updateChannel,
												$author$project$DmChannel$loadUnreadMessages(messages),
												channelId),
											discordGuilds2);
									}),
								local.discordGuilds,
								overviewData2.discordGuildChannels);
							return _Utils_update(
								local,
								{
									discordDmChannels: $lamdera$containers$SeqDict$foldl$(
										F3(
											function (channelId, messages, discordDmChannels) {
												return $lamdera$containers$SeqDict$updateIfExists$(
													channelId,
													$author$project$DmChannel$loadUnreadMessages(messages),
													discordDmChannels);
											}),
										local.discordDmChannels,
										overviewData2.discordDmChannels),
									discordGuilds: $lamdera$containers$SeqDict$foldl$(
										F3(
											function (_v34, messages, discordGuilds2) {
												var guildId = _v34.a;
												var channelId = _v34.b;
												var threadId = _v34.c;
												return $lamdera$containers$SeqDict$updateIfExists$(
													guildId,
													A2(
														$author$project$LocalState$updateChannel,
														function (channel) {
															return _Utils_update(
																channel,
																{
																	threads: $lamdera$containers$SeqDict$updateIfExists$(
																		threadId,
																		$author$project$DmChannel$loadUnreadMessages(messages),
																		channel.threads)
																});
														},
														channelId),
													discordGuilds2);
											}),
										discordGuilds,
										overviewData2.discordGuildThreads),
									dmChannels: $lamdera$containers$SeqDict$foldl$(
										F3(
											function (_v35, messages, dmChannels2) {
												var otherUserId = _v35.a;
												var threadId = _v35.b;
												return $lamdera$containers$SeqDict$updateIfExists$(
													otherUserId,
													function (dmChannel) {
														return _Utils_update(
															dmChannel,
															{
																threads: $lamdera$containers$SeqDict$updateIfExists$(
																	threadId,
																	$author$project$DmChannel$loadUnreadMessages(messages),
																	dmChannel.threads)
															});
													},
													dmChannels2);
											}),
										dmChannels,
										overviewData2.dmThreads),
									guilds: $lamdera$containers$SeqDict$foldl$(
										F3(
											function (_v36, messages, guilds2) {
												var guildId = _v36.a;
												var channelId = _v36.b;
												var threadId = _v36.c;
												return $lamdera$containers$SeqDict$updateIfExists$(
													guildId,
													A2(
														$author$project$LocalState$updateChannel,
														function (channel) {
															return _Utils_update(
																channel,
																{
																	threads: $lamdera$containers$SeqDict$updateIfExists$(
																		threadId,
																		$author$project$DmChannel$loadUnreadMessages(messages),
																		channel.threads)
																});
														},
														channelId),
													guilds2);
											}),
										guilds,
										overviewData2.guildThreads),
									localUser: _Utils_update(
										localUser2,
										{
											discordUsers: $lamdera$containers$SeqDict$foldl$($author$project$LinkedAndOtherDiscordUsers$addOtherUser, localUser2.discordUsers, overviewData2.discordUsers)
										}),
									slackDmChannels: $lamdera$containers$SeqDict$foldl$(
										F3(
											function (_v37, messages, slackDmChannels2) {
												var channelId = _v37.a;
												var threadId = _v37.b;
												return $lamdera$containers$SeqDict$updateIfExists$(
													channelId,
													function (dmChannel) {
														return _Utils_update(
															dmChannel,
															{
																threads: $lamdera$containers$SeqDict$updateIfExists$(
																	threadId,
																	$author$project$DmChannel$loadUnreadMessages(messages),
																	dmChannel.threads)
															});
													},
													slackDmChannels2);
											}),
										slackDmChannels,
										overviewData2.slackDmThreads),
									slackWorkspaces: $lamdera$containers$SeqDict$foldl$(
										F3(
											function (_v38, messages, slackWorkspaces2) {
												var teamId = _v38.a;
												var channelId = _v38.b;
												var threadId = _v38.c;
												return $lamdera$containers$SeqDict$updateIfExists$(
													teamId,
													A2(
														$author$project$LocalState$updateChannel,
														function (channel) {
															return _Utils_update(
																channel,
																{
																	threads: $lamdera$containers$SeqDict$updateIfExists$(
																		threadId,
																		$author$project$DmChannel$loadUnreadMessages(messages),
																		channel.threads)
																});
														},
														channelId),
													slackWorkspaces2);
											}),
										slackWorkspaces,
										overviewData2.slackThreads)
								});
						} else {
							return _Utils_update(
								local,
								{localUser: localUser2});
						}
				}
			case 28:
				var name = localChange.a;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								user: $author$project$User$setName$(name, localUser.user)
							})
					});
			case 29:
				var guildOrDmId = localChange.a;
				var pageRequest = localChange.b;
				var messagesLoaded = localChange.c;
				if (!guildOrDmId.$) {
					var channelId = guildOrDmId.a.channelId;
					var guildId = guildOrDmId.a.guildId;
					return _Utils_update(
						local,
						{
							guilds: $lamdera$containers$SeqDict$updateIfExists$(
								guildId,
								A2(
									$author$project$LocalState$updateChannel,
									A2($author$project$DmChannel$loadChannelPage, pageRequest, messagesLoaded),
									channelId),
								local.guilds)
						});
				} else {
					var otherUserId = guildOrDmId.a.otherUserId;
					return _Utils_update(
						local,
						{
							dmChannels: $lamdera$containers$SeqDict$updateIfExists$(
								otherUserId,
								A2($author$project$DmChannel$loadChannelPage, pageRequest, messagesLoaded),
								local.dmChannels)
						});
				}
			case 30:
				var guildOrDmId = localChange.a;
				var threadId = localChange.b;
				var pageRequest = localChange.c;
				var messagesLoaded = localChange.d;
				if (!guildOrDmId.$) {
					var channelId = guildOrDmId.a.channelId;
					var guildId = guildOrDmId.a.guildId;
					return _Utils_update(
						local,
						{
							guilds: $lamdera$containers$SeqDict$updateIfExists$(
								guildId,
								A2(
									$author$project$LocalState$updateChannel,
									function (channel) {
										return _Utils_update(
											channel,
											{
												threads: $lamdera$containers$SeqDict$updateIfExists$(
													threadId,
													A3($author$project$DmChannel$loadPage, _List_Nil, pageRequest, messagesLoaded),
													channel.threads)
											});
									},
									channelId),
								local.guilds)
						});
				} else {
					var otherUserId = guildOrDmId.a.otherUserId;
					return _Utils_update(
						local,
						{
							dmChannels: $lamdera$containers$SeqDict$updateIfExists$(
								otherUserId,
								function (dmChannel) {
									return _Utils_update(
										dmChannel,
										{
											threads: $lamdera$containers$SeqDict$updateIfExists$(
												threadId,
												A3($author$project$DmChannel$loadPage, _List_Nil, pageRequest, messagesLoaded),
												dmChannel.threads)
										});
								},
								local.dmChannels)
						});
				}
			case 33:
				var guildOrDmId = localChange.a;
				var pageRequest = localChange.b;
				var messagesLoaded = localChange.c;
				if (!guildOrDmId.$) {
					var channelId = guildOrDmId.a.channelId;
					var guildId = guildOrDmId.a.guildId;
					return _Utils_update(
						local,
						{
							discordGuilds: $lamdera$containers$SeqDict$updateIfExists$(
								guildId,
								A2(
									$author$project$LocalState$updateChannel,
									function (channel) {
										return $author$project$DmChannel$loadPage$(
											$lamdera$containers$SeqDict$keys(channel.threads),
											pageRequest,
											messagesLoaded,
											channel);
									},
									channelId),
								local.discordGuilds)
						});
				} else {
					var data = guildOrDmId.a;
					return _Utils_update(
						local,
						{
							discordDmChannels: $lamdera$containers$SeqDict$updateIfExists$(
								data.channelId,
								A3($author$project$DmChannel$loadPage, _List_Nil, pageRequest, messagesLoaded),
								local.discordDmChannels)
						});
				}
			case 31:
				var guildOrDmId = localChange.a;
				var pageRequest = localChange.b;
				var messagesLoaded = localChange.c;
				if (!guildOrDmId.$) {
					var channelId = guildOrDmId.a.channelId;
					var teamId = guildOrDmId.a.teamId;
					return _Utils_update(
						local,
						{
							slackWorkspaces: $lamdera$containers$SeqDict$updateIfExists$(
								teamId,
								A2(
									$author$project$LocalState$updateChannel,
									A3($author$project$DmChannel$loadPage, _List_Nil, pageRequest, messagesLoaded),
									channelId),
								local.slackWorkspaces)
						});
				} else {
					var data = guildOrDmId.a;
					return _Utils_update(
						local,
						{
							slackDmChannels: $lamdera$containers$SeqDict$updateIfExists$(
								data.channelId,
								A3($author$project$DmChannel$loadPage, _List_Nil, pageRequest, messagesLoaded),
								local.slackDmChannels)
						});
				}
			case 32:
				var guildOrDmId = localChange.a;
				var threadId = localChange.b;
				var pageRequest = localChange.c;
				var messagesLoaded = localChange.d;
				var loadThreadPage = function (channel) {
					return _Utils_update(
						channel,
						{
							threads: $lamdera$containers$SeqDict$updateIfExists$(
								threadId,
								A3($author$project$DmChannel$loadPage, _List_Nil, pageRequest, messagesLoaded),
								channel.threads)
						});
				};
				if (!guildOrDmId.$) {
					var channelId = guildOrDmId.a.channelId;
					var teamId = guildOrDmId.a.teamId;
					return _Utils_update(
						local,
						{
							slackWorkspaces: $lamdera$containers$SeqDict$updateIfExists$(
								teamId,
								A2($author$project$LocalState$updateChannel, loadThreadPage, channelId),
								local.slackWorkspaces)
						});
				} else {
					var data = guildOrDmId.a;
					return _Utils_update(
						local,
						{
							slackDmChannels: $lamdera$containers$SeqDict$updateIfExists$(data.channelId, loadThreadPage, local.slackDmChannels)
						});
				}
			case 5:
				var editedAt = localChange.a;
				var guildOrDmId = localChange.c;
				var threadRoute = localChange.d;
				var text = localChange.e;
				return $author$project$FrontendExtra$slackEditMessage$(
					editedAt,
					function () {
						if (!guildOrDmId.$) {
							var currentUserId = guildOrDmId.a.currentUserId;
							return currentUserId;
						} else {
							var currentUserId = guildOrDmId.a.currentUserId;
							return currentUserId;
						}
					}(),
					guildOrDmId,
					threadRoute,
					$author$project$RichText$fromNonemptyString$(
						local.localUser.timezone,
						local.localUser.slackUsers,
						$author$project$LocalState$slackChannelMentions$(guildOrDmId, local),
						text),
					local);
			case 4:
				var createdAt = localChange.a;
				var guildOrDmId = localChange.c;
				var threadRoute = localChange.d;
				var text = localChange.e;
				var attachedFiles = localChange.f;
				return $author$project$FrontendExtra$slackSendMessage$(
					createdAt,
					guildOrDmId,
					threadRoute,
					$author$project$RichText$fromNonemptyString$(
						local.localUser.timezone,
						local.localUser.slackUsers,
						$author$project$LocalState$slackChannelMentions$(guildOrDmId, local),
						text),
					attachedFiles,
					$elm$core$Maybe$Nothing,
					local);
			case 34:
				var guildOrDmId = localChange.a;
				var threadId = localChange.b;
				var pageRequest = localChange.c;
				var messagesLoaded = localChange.d;
				if (!guildOrDmId.$) {
					var channelId = guildOrDmId.a.channelId;
					var guildId = guildOrDmId.a.guildId;
					return _Utils_update(
						local,
						{
							discordGuilds: $lamdera$containers$SeqDict$updateIfExists$(
								guildId,
								A2(
									$author$project$LocalState$updateChannel,
									function (channel) {
										return _Utils_update(
											channel,
											{
												threads: $lamdera$containers$SeqDict$updateIfExists$(
													threadId,
													A3($author$project$DmChannel$loadPage, _List_Nil, pageRequest, messagesLoaded),
													channel.threads)
											});
									},
									channelId),
								local.discordGuilds)
						});
				} else {
					return local;
				}
			case 35:
				var guildId = localChange.a;
				var notificationLevel = localChange.b;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								user: $author$project$User$setGuildNotificationLevel$(guildId, notificationLevel, localUser.user)
							})
					});
			case 36:
				var guildId = localChange.b;
				var notificationLevel = localChange.c;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								user: $author$project$User$setDiscordGuildNotificationLevel$(guildId, notificationLevel, localUser.user)
							})
					});
			case 37:
				var teamId = localChange.b;
				var notificationLevel = localChange.c;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								user: $author$project$User$setSlackWorkspaceNotificationLevel$(teamId, notificationLevel, localUser.user)
							})
					});
			case 38:
				var notificationMode = localChange.a;
				var localUser = local.localUser;
				var session = localUser.session;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								session: _Utils_update(
									session,
									{notificationMode: notificationMode})
							})
					});
			case 39:
				var section = localChange.a;
				var collapseOthers = localChange.b;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								session: $author$project$UserSession$expandUserOptionSection$(section, collapseOthers, localUser.session)
							})
					});
			case 40:
				var section = localChange.a;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								session: $author$project$UserSession$collapseUserOptionSection$(section, localUser.session)
							})
					});
			case 41:
				var questions = localChange.a;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								session: $author$project$UserSession$setSheepGameQuestions$(questions, localUser.session)
							})
					});
			case 42:
				var emailNotifications = localChange.a;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								user: $author$project$User$setEmailNotifications$(emailNotifications, localUser.user)
							})
					});
			case 43:
				var embedVisibility = localChange.a;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								user: $author$project$User$setEmbedVisibility$(embedVisibility, localUser.user)
							})
					});
			case 44:
				var deleteAt = localChange.a;
				var localUser = local.localUser;
				var user = localUser.user;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								user: _Utils_update(
									user,
									{
										deleteAccountAt: $elm$core$Maybe$Just(deleteAt)
									})
							})
					});
			case 45:
				var localUser = local.localUser;
				var user = localUser.user;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								user: _Utils_update(
									user,
									{deleteAccountAt: $elm$core$Maybe$Nothing})
							})
					});
			case 46:
				var time = localChange.a;
				var pushSubscription = localChange.b;
				var localUser = local.localUser;
				var session = localUser.session;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								session: _Utils_update(
									session,
									{
										pushSubscription: function () {
											if (!pushSubscription.$) {
												var subscribeData = pushSubscription.a;
												return $author$project$UserSession$Subscribed$(subscribeData, time);
											} else {
												var jsError = pushSubscription.a;
												return $author$project$UserSession$SubscriptionJsException$(jsError, time);
											}
										}()
									})
							})
					});
			case 47:
				var localChange2 = localChange.a;
				return _Utils_update(
					local,
					{
						textEditor: $author$project$TextEditor$localChangeUpdate$(local.localUser.session.userId, localChange2, local.textEditor)
					});
			case 6:
				var slackUserId = localChange.a;
				return $author$project$FrontendExtra$unlinkSlackUser$(slackUserId, local);
			case 7:
				return local;
			case 48:
				var userId = localChange.a;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								discordUsers: $author$project$LinkedAndOtherDiscordUsers$unlinkUser$(userId, localUser.discordUsers)
							})
					});
			case 49:
				var time = localChange.a;
				var discordUserId = localChange.b;
				return $author$project$FrontendExtra$startReloadingDiscordUser$(time, discordUserId, local);
			case 51:
				var isChecked = localChange.a;
				var localUser = local.localUser;
				var user = localUser.user;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								user: _Utils_update(
									user,
									{linkSlackAcknowledgementIsChecked: isChecked})
							})
					});
			case 50:
				var isChecked = localChange.a;
				var localUser = local.localUser;
				var user = localUser.user;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								user: _Utils_update(
									user,
									{linkDiscordAcknowledgementIsChecked: isChecked})
							})
					});
			case 52:
				var enable = localChange.a;
				var domain = localChange.b;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								user: $author$project$User$setDomainWhitelist$(enable, domain, localUser.user)
							})
					});
			case 53:
				var maybeSkinTone = localChange.a;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								user: $author$project$User$setEmojiSkinTone$(maybeSkinTone, localUser.user)
							})
					});
			case 54:
				var color = localChange.a;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								user: $author$project$User$setColor$(color, localUser.user)
							})
					});
			case 55:
				var customEmojiIds = localChange.a;
				var localUser = local.localUser;
				var user = localUser.user;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								user: _Utils_update(
									user,
									{
										availableCustomEmojis: $lamdera$containers$SeqSet$union$(
											$author$project$NonemptySet$toSeqSet(customEmojiIds),
											user.availableCustomEmojis)
									})
							})
					});
			case 56:
				var voiceChatChange = localChange.a;
				switch (voiceChatChange.$) {
					case 0:
						var time = voiceChatChange.a;
						return $author$project$FrontendExtra$leaveCall$(time, local);
					case 1:
						return local;
					case 2:
						return local;
					case 3:
						return local;
					default:
						return local;
				}
			case 57:
				var guildOrDmId = localChange.a;
				var gameChange = localChange.b;
				return $author$project$FrontendExtra$gameChangeUpdate$(local.localUser.session.userId, guildOrDmId, gameChange, local);
			case 58:
				var guildOrDmId = localChange.a;
				var threadRoute = localChange.b;
				var drawingChange = localChange.c;
				return $author$project$LocalState$drawingHandleChangeFrontend$(guildOrDmId, threadRoute, changedBy, drawingChange, local);
			case 59:
				var guildId = localChange.a;
				var channelId = localChange.b;
				var isMuted = localChange.c;
				return $author$project$FrontendExtra$setMuteChannel$(guildId, channelId, isMuted, local);
			case 60:
				var guildId = localChange.a;
				var channelId = localChange.b;
				var threadId = localChange.c;
				var isMuted = localChange.d;
				return $author$project$FrontendExtra$setMuteThread$(guildId, channelId, threadId, isMuted, local);
			case 61:
				var guildId = localChange.b;
				var channelId = localChange.c;
				var isMuted = localChange.d;
				return $author$project$FrontendExtra$setMuteDiscordChannel$(guildId, channelId, isMuted, local);
			case 62:
				var guildId = localChange.b;
				var channelId = localChange.c;
				var threadId = localChange.d;
				var isMuted = localChange.e;
				return $author$project$FrontendExtra$setMuteDiscordThread$(guildId, channelId, threadId, isMuted, local);
			case 63:
				var guildId = localChange.a;
				var isMuted = localChange.b;
				return $author$project$FrontendExtra$setMuteGuild$(guildId, isMuted, local);
			case 64:
				var guildId = localChange.b;
				var isMuted = localChange.c;
				return $author$project$FrontendExtra$setMuteDiscordGuild$(guildId, isMuted, local);
			case 65:
				var teamId = localChange.b;
				var isMuted = localChange.c;
				return $author$project$FrontendExtra$setMuteSlackWorkspace$(teamId, isMuted, local);
			case 66:
				var teamId = localChange.b;
				var channelId = localChange.c;
				var isMuted = localChange.d;
				return $author$project$FrontendExtra$setMuteSlackChannel$(teamId, channelId, isMuted, local);
			case 67:
				var teamId = localChange.b;
				var channelId = localChange.c;
				var threadId = localChange.d;
				var isMuted = localChange.e;
				return $author$project$FrontendExtra$setMuteSlackThread$(teamId, channelId, threadId, isMuted, local);
			case 68:
				var id = localChange.a;
				return $author$project$LocalState$setDmE2ee$(
					id,
					$author$project$DmChannel$E2eeRequestedBy(
						_Utils_Tuple2(local.localUser.session.userId, local.localUser.session.sessionIdHash)),
					local);
			case 69:
				var id = localChange.a;
				return $author$project$LocalState$setDmE2ee$(
					id,
					$author$project$DmChannel$E2eeDisabled($elm$core$Maybe$Nothing),
					local);
			case 70:
				var id = localChange.a;
				return $author$project$LocalState$setDmE2ee$(
					id,
					$author$project$DmChannel$E2eeDeclinedBy(local.localUser.session.userId),
					local);
			case 78:
				var createdAt = localChange.a;
				var otherUserId = localChange.b.otherUserId;
				var threadRoute = localChange.c;
				var fileHashes = localChange.d;
				var content = localChange.e;
				return $author$project$FrontendExtra$editEncryptedDmMessage$(createdAt, local.localUser.session.userId, otherUserId, threadRoute, fileHashes, content, local);
			case 77:
				var createdAt = localChange.a;
				var otherUserId = localChange.b.otherUserId;
				var fileHashes = localChange.c;
				var content = localChange.d;
				var threadRouteWithRepliedTo = localChange.f;
				var localUser = local.localUser;
				var local2 = $author$project$FrontendExtra$addEncryptedDmMessage$(createdAt, localUser.session.userId, otherUserId, fileHashes, content, threadRouteWithRepliedTo, local);
				var _v51 = $author$project$LocalState$ownMessageIsReadFrontend$(
					$author$project$Id$GuildOrDmId(
						$author$project$Id$GuildOrDmId_Dm(
							{otherUserId: otherUserId})),
					$author$project$FrontendExtra$latestMessageThreadRoute$(
						$author$project$Message$threadRouteWithoutRepliedTo(threadRouteWithRepliedTo),
						$elm$core$Maybe$withDefault$(
							$author$project$DmChannel$frontendInit,
							$lamdera$containers$SeqDict$get$(otherUserId, local2.dmChannels))),
					_Utils_Tuple2(localUser.currentlyViewing, localUser.user));
				var currentlyViewing2 = _v51.a;
				var user2 = _v51.b;
				return _Utils_update(
					local2,
					{
						localUser: _Utils_update(
							localUser,
							{currentlyViewing: currentlyViewing2, user: user2})
					});
			case 76:
				var id = localChange.a;
				var time = localChange.b;
				var _v52 = $lamdera$containers$SeqDict$get$(id.otherUserId, local.dmChannels);
				if (!_v52.$) {
					var dmChannel = _v52.a;
					var _v53 = dmChannel.e2ee;
					switch (_v53.$) {
						case 1:
							var requestedBy = _v53.a;
							return $author$project$LocalState$setDmE2ee$(
								id,
								$author$project$DmChannel$E2eeEnabled(
									{enabledAt: time, requestedBy: requestedBy}),
								local);
						case 0:
							return local;
						case 2:
							return local;
						default:
							return local;
					}
				} else {
					return local;
				}
			case 75:
				var isAccepted = localChange.a;
				var localUser = local.localUser;
				var user = localUser.user;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								user: _Utils_update(
									user,
									{e2eeRisksAccepted: isAccepted})
							})
					});
			case 72:
				var otherUserId = localChange.a.otherUserId;
				var messages = localChange.b;
				return _Utils_update(
					local,
					{
						dmChannels: $lamdera$containers$SeqDict$updateIfExists$(
							otherUserId,
							$author$project$FrontendExtra$encryptOldMessages(messages),
							local.dmChannels)
					});
			case 73:
				return local;
			case 74:
				var id = localChange.a;
				var time = localChange.b;
				var messages = localChange.c;
				return $author$project$LocalState$setDmE2ee$(
					id,
					$author$project$DmChannel$E2eeDisabled(
						$elm$core$Maybe$Just(
							_Utils_Tuple2(local.localUser.session.userId, time))),
					_Utils_update(
						local,
						{
							dmChannels: $lamdera$containers$SeqDict$updateIfExists$(
								id.otherUserId,
								$author$project$FrontendExtra$decryptOldMessages(messages),
								local.dmChannels)
						}));
			default:
				var publicKey = localChange.a;
				var localUser = local.localUser;
				var user = localUser.user;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								user: _Utils_update(
									user,
									{
										publicKey: $elm$core$Maybe$Just(publicKey)
									})
							})
					});
		}
	} else {
		var serverChange = localMsg.a;
		switch (serverChange.$) {
			case 0:
				var repliedToData = serverChange.a.repliedToData;
				var stickers = serverChange.a.stickers;
				var attachedFiles = serverChange.a.attachedFiles;
				var threadRoute = serverChange.a.threadRoute;
				var content = serverChange.a.content;
				var guildOrDmId = serverChange.a.guildOrDmId;
				var sentAt = serverChange.a.sentAt;
				var sender = serverChange.a.sender;
				var senderId = serverChange.a.senderId;
				if (!guildOrDmId.$) {
					var id = guildOrDmId.a;
					var _v56 = $author$project$LocalState$getGuildAndChannel$(id, local);
					if (!_v56.$) {
						var _v57 = _v56.a;
						var guild = _v57.a;
						var channel = _v57.b;
						var threadRouteNoReply = $author$project$Message$threadRouteWithoutRepliedTo(threadRoute);
						var localUser = local.localUser;
						var user = localUser.user;
						var isViewing2 = $author$project$FrontendExtra$isViewing$(
							$author$project$Id$GuildOrDmId(guildOrDmId),
							threadRouteNoReply,
							local);
						var _v58 = function () {
							var _v59 = _Utils_Tuple2(
								isViewing2,
								_Utils_eq(senderId, localUser.session.userId));
							_v59$0:
							while (true) {
								if (_v59.a) {
									if (_v59.b) {
										break _v59$0;
									} else {
										return $author$project$LocalState$incrementLastViewedMessageFrontend$(
											$author$project$Id$GuildOrDmId(guildOrDmId),
											$author$project$FrontendExtra$newMessageThreadRoute$(
												$author$project$Message$threadRouteWithoutRepliedTo(threadRoute),
												channel),
											_Utils_Tuple2(localUser.currentlyViewing, user));
									}
								} else {
									if (_v59.b) {
										break _v59$0;
									} else {
										return _Utils_Tuple2(
											localUser.currentlyViewing,
											$lamdera$containers$SeqSet$member$(
												localUser.session.userId,
												$author$project$LocalState$usersMentionedOrRepliedToFrontend$(
													$author$project$Message$toThreadRouteWithMaybeMessage(threadRoute),
													content,
													channel)) ? $author$project$User$addDirectMention$(id.guildId, id.channelId, threadRouteNoReply, user) : user);
									}
								}
							}
							return $author$project$LocalState$ownMessageIsReadFrontend$(
								$author$project$Id$GuildOrDmId(guildOrDmId),
								$author$project$FrontendExtra$newMessageThreadRoute$(
									$author$project$Message$threadRouteWithoutRepliedTo(threadRoute),
									channel),
								_Utils_Tuple2(localUser.currentlyViewing, user));
						}();
						var currentlyViewing2 = _v58.a;
						var user2 = _v58.b;
						return _Utils_update(
							local,
							{
								guilds: $author$project$FrontendExtra$guildSendMessage$(
									id.guildId,
									guild,
									id.channelId,
									$author$project$FrontendExtra$addRepliedToData$(threadRoute, repliedToData, channel),
									threadRoute,
									sentAt,
									senderId,
									content,
									attachedFiles,
									local),
								localUser: _Utils_update(
									localUser,
									{
										currentlyViewing: currentlyViewing2,
										otherUsers: $author$project$FrontendExtra$addMessageSender$(senderId, sender, localUser),
										stickers: $lamdera$containers$SeqDict$union$(stickers, localUser.stickers),
										user: user2
									})
							});
					} else {
						return local;
					}
				} else {
					var id = guildOrDmId.a;
					return $author$project$FrontendExtra$handleServerSendDmMessage$(
						id,
						$author$project$FrontendExtra$addRepliedToData$(
							threadRoute,
							repliedToData,
							$author$project$FrontendExtra$frontendDmChannel$(id, local)),
						senderId,
						sender,
						stickers,
						function (repliedTo) {
							return $author$project$Message$userTextMessageFrontend$(sentAt, senderId, content, repliedTo, attachedFiles);
						},
						function (maybeReplyTo) {
							return $author$project$Message$userTextMessageFrontend$(
								sentAt,
								senderId,
								content,
								$author$project$Message$maybeToReply(maybeReplyTo),
								attachedFiles);
						},
						threadRoute,
						local);
				}
			case 1:
				var createdAt = serverChange.a;
				var guildOrDmId = serverChange.b;
				var threadRoute = serverChange.c;
				var content = serverChange.d;
				var attachedFiles = serverChange.e;
				var maybeThreadStarter = serverChange.f;
				return $author$project$FrontendExtra$slackSendMessage$(createdAt, guildOrDmId, threadRoute, content, attachedFiles, maybeThreadStarter, local);
			case 2:
				var editedAt = serverChange.a;
				var editedBy = serverChange.b;
				var guildOrDmId = serverChange.c;
				var threadRoute = serverChange.d;
				var content = serverChange.e;
				return $author$project$FrontendExtra$slackEditMessage$(editedAt, editedBy, guildOrDmId, threadRoute, content, local);
			case 13:
				var slackUserId = serverChange.a;
				var guildOrDmId = serverChange.b;
				var threadRoute = serverChange.c;
				var emoji = serverChange.d;
				if (!guildOrDmId.$) {
					var channelId = guildOrDmId.a.channelId;
					var teamId = guildOrDmId.a.teamId;
					return _Utils_update(
						local,
						{
							slackWorkspaces: $lamdera$containers$SeqDict$updateIfExists$(
								teamId,
								A2(
									$author$project$LocalState$updateChannel,
									A3($author$project$LocalState$addReactionEmojiFrontend, emoji, slackUserId, threadRoute),
									channelId),
								local.slackWorkspaces)
						});
				} else {
					var channelId = guildOrDmId.a.channelId;
					return _Utils_update(
						local,
						{
							slackDmChannels: $lamdera$containers$SeqDict$updateIfExists$(
								channelId,
								A3($author$project$LocalState$addReactionEmojiFrontend, emoji, slackUserId, threadRoute),
								local.slackDmChannels)
						});
				}
			case 14:
				var slackUserId = serverChange.a;
				var guildOrDmId = serverChange.b;
				var threadRoute = serverChange.c;
				var emoji = serverChange.d;
				if (!guildOrDmId.$) {
					var channelId = guildOrDmId.a.channelId;
					var teamId = guildOrDmId.a.teamId;
					return _Utils_update(
						local,
						{
							slackWorkspaces: $lamdera$containers$SeqDict$updateIfExists$(
								teamId,
								A2(
									$author$project$LocalState$updateChannel,
									A3($author$project$LocalState$removeReactionEmojiFrontend, emoji, slackUserId, threadRoute),
									channelId),
								local.slackWorkspaces)
						});
				} else {
					var channelId = guildOrDmId.a.channelId;
					return _Utils_update(
						local,
						{
							slackDmChannels: $lamdera$containers$SeqDict$updateIfExists$(
								channelId,
								A3($author$project$LocalState$removeReactionEmojiFrontend, emoji, slackUserId, threadRoute),
								local.slackDmChannels)
						});
				}
			case 3:
				var guildOrDmId = serverChange.a;
				var threadRoute = serverChange.b;
				if (!guildOrDmId.$) {
					var channelId = guildOrDmId.a.channelId;
					var teamId = guildOrDmId.a.teamId;
					return _Utils_update(
						local,
						{
							slackWorkspaces: $lamdera$containers$SeqDict$updateIfExists$(
								teamId,
								A2(
									$author$project$LocalState$updateChannel,
									$author$project$LocalState$deleteMessageFrontendHelper(threadRoute),
									channelId),
								local.slackWorkspaces)
						});
				} else {
					var channelId = guildOrDmId.a.channelId;
					return _Utils_update(
						local,
						{
							slackDmChannels: $lamdera$containers$SeqDict$updateIfExists$(
								channelId,
								$author$project$LocalState$deleteMessageFrontendHelper(threadRoute),
								local.slackDmChannels)
						});
				}
			case 15:
				var createdAt = serverChange.a;
				var guildOrDmId = serverChange.b;
				var createdByUser = serverChange.c;
				var text = serverChange.d;
				var threadRouteWithRepliedTo = serverChange.e;
				var attachedFiles = serverChange.f;
				var stickers = serverChange.g;
				if (!guildOrDmId.$) {
					var channelId = guildOrDmId.a.channelId;
					var guildId = guildOrDmId.a.guildId;
					var currentUserId = guildOrDmId.a.currentUserId;
					var _v64 = $author$project$LocalState$getDiscordGuildAndChannel$(guildId, channelId, local);
					if (!_v64.$) {
						var _v65 = _v64.a;
						var guild = _v65.a;
						var channel = _v65.b;
						var threadRouteNoReply = function () {
							if (threadRouteWithRepliedTo.$ === 1) {
								var threadId = threadRouteWithRepliedTo.a;
								return $author$project$Id$ViewThread(threadId);
							} else {
								return $author$project$Id$NoThread;
							}
						}();
						var localUser = local.localUser;
						var readingItNow = function () {
							var _v68 = _Utils_Tuple2(localUser.currentlyViewing, threadRouteNoReply);
							_v68$2:
							while (true) {
								if (!_v68.b.$) {
									if (_v68.a.$ === 5) {
										var data = _v68.a.a;
										var _v69 = _v68.b;
										return (_Utils_eq(data.id.guildId, guildId) && _Utils_eq(data.id.channelId, channelId)) ? $elm$core$Maybe$Just(
											$author$project$Id$DiscordGuildOrDmId(
												$author$project$Id$DiscordGuildOrDmId_Guild(data.id))) : $elm$core$Maybe$Nothing;
									} else {
										break _v68$2;
									}
								} else {
									if (_v68.a.$ === 6) {
										var data = _v68.a.a;
										var threadId = _v68.b.a;
										return (_Utils_eq(data.id.guildId, guildId) && (_Utils_eq(data.id.channelId, channelId) && _Utils_eq(data.id.threadId, threadId))) ? $elm$core$Maybe$Just(
											$author$project$Id$DiscordGuildOrDmId(
												$author$project$Id$DiscordGuildOrDmId_Guild(
													{channelId: data.id.channelId, currentUserId: data.id.currentUserId, guildId: data.id.guildId}))) : $elm$core$Maybe$Nothing;
									} else {
										break _v68$2;
									}
								}
							}
							return $elm$core$Maybe$Nothing;
						}();
						var user = localUser.user;
						var _v66 = function () {
							if ($author$project$LinkedAndOtherDiscordUsers$isLinkedUser$(currentUserId, localUser.discordUsers)) {
								return $author$project$LocalState$ownMessageIsReadFrontend$(
									$author$project$Id$DiscordGuildOrDmId(guildOrDmId),
									$author$project$FrontendExtra$newMessageThreadRoute$(
										$author$project$Id$threadRouteWithoutMaybeMessage(threadRouteWithRepliedTo),
										channel),
									_Utils_Tuple2(localUser.currentlyViewing, user));
							} else {
								if (!readingItNow.$) {
									var guildOrDmId2 = readingItNow.a;
									return $author$project$LocalState$incrementLastViewedMessageFrontend$(
										guildOrDmId2,
										$author$project$FrontendExtra$newMessageThreadRoute$(
											$author$project$Id$threadRouteWithoutMaybeMessage(threadRouteWithRepliedTo),
											channel),
										_Utils_Tuple2(localUser.currentlyViewing, user));
								} else {
									return _Utils_Tuple2(
										localUser.currentlyViewing,
										(!$lamdera$containers$SeqSet$isEmpty(
											$lamdera$containers$SeqSet$intersect$(
												$lamdera$containers$SeqSet$fromList(
													$lamdera$containers$SeqDict$keys(
														$author$project$LinkedAndOtherDiscordUsers$linkedUsers(localUser.discordUsers))),
												$author$project$LocalState$usersMentionedOrRepliedToFrontend$(threadRouteWithRepliedTo, text, channel)))) ? $author$project$User$addDiscordDirectMention$(guildId, channelId, threadRouteNoReply, user) : user);
								}
							}
						}();
						var currentlyViewing2 = _v66.a;
						var user2 = _v66.b;
						return _Utils_update(
							local,
							{
								discordGuilds: $author$project$FrontendExtra$discordGuildSendMessage$(guildId, guild, channelId, channel, threadRouteWithRepliedTo, createdAt, currentUserId, text, attachedFiles, local),
								localUser: _Utils_update(
									localUser,
									{
										currentlyViewing: currentlyViewing2,
										discordUsers: $author$project$LinkedAndOtherDiscordUsers$addOtherUser$(currentUserId, createdByUser, localUser.discordUsers),
										stickers: $lamdera$containers$SeqDict$union$(stickers, localUser.stickers),
										user: user2
									})
							});
					} else {
						return local;
					}
				} else {
					var data = guildOrDmId.a;
					var _v71 = $lamdera$containers$SeqDict$get$(data.channelId, local.discordDmChannels);
					if (!_v71.$) {
						var dmChannel = _v71.a;
						var localUser = local.localUser;
						var readingItNow = function () {
							var _v75 = localUser.currentlyViewing;
							if (_v75.$ === 2) {
								var viewingData = _v75.a;
								return _Utils_eq(viewingData.id.channelId, data.channelId) ? $elm$core$Maybe$Just(
									$author$project$Id$DiscordGuildOrDmId(
										$author$project$Id$DiscordGuildOrDmId_Dm(viewingData.id))) : $elm$core$Maybe$Nothing;
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}();
						var user = localUser.user;
						var dmChannel2 = $author$project$LocalState$createDiscordDmMessageFrontend$(
							$author$project$Message$userTextMessageFrontend$(
								createdAt,
								data.currentUserId,
								text,
								function () {
									if (!threadRouteWithRepliedTo.$) {
										var maybeReplyTo = threadRouteWithRepliedTo.a;
										return $author$project$Message$maybeToReply(maybeReplyTo);
									} else {
										return $author$project$Message$NoReply;
									}
								}(),
								attachedFiles),
							_Utils_update(
								dmChannel,
								{
									lastTypedAt: $lamdera$containers$SeqDict$remove$(data.currentUserId, dmChannel.lastTypedAt)
								}));
						var _v72 = function () {
							if ($author$project$LinkedAndOtherDiscordUsers$isLinkedUser$(data.currentUserId, localUser.discordUsers)) {
								return $author$project$LocalState$ownMessageIsReadFrontend$(
									$author$project$Id$DiscordGuildOrDmId(guildOrDmId),
									$author$project$Id$NoThreadWithMessage(
										$author$project$DmChannel$latestFrontendMessageId(dmChannel2)),
									_Utils_Tuple2(localUser.currentlyViewing, user));
							} else {
								if (!readingItNow.$) {
									var guildOrDmId2 = readingItNow.a;
									return $author$project$LocalState$incrementLastViewedMessageFrontend$(
										guildOrDmId2,
										$author$project$Id$NoThreadWithMessage(
											$author$project$DmChannel$latestFrontendMessageId(dmChannel2)),
										_Utils_Tuple2(localUser.currentlyViewing, user));
								} else {
									return _Utils_Tuple2(localUser.currentlyViewing, user);
								}
							}
						}();
						var currentlyViewing2 = _v72.a;
						var user2 = _v72.b;
						return _Utils_update(
							local,
							{
								discordDmChannels: $lamdera$containers$SeqDict$insert$(data.channelId, dmChannel2, local.discordDmChannels),
								localUser: _Utils_update(
									localUser,
									{
										currentlyViewing: currentlyViewing2,
										discordUsers: $author$project$LinkedAndOtherDiscordUsers$addOtherUser$(data.currentUserId, createdByUser, localUser.discordUsers),
										stickers: $lamdera$containers$SeqDict$union$(stickers, localUser.stickers),
										user: user2
									})
							});
					} else {
						return local;
					}
				}
			case 16:
				var time = serverChange.a;
				var guildId = serverChange.b;
				var channelName = serverChange.c;
				var channelDescription = serverChange.d;
				return _Utils_update(
					local,
					{
						guilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							A4($author$project$LocalState$createChannelFrontend, time, local.localUser.session.userId, channelName, channelDescription),
							local.guilds)
					});
			case 17:
				var guildId = serverChange.a;
				var channelId = serverChange.b;
				var channel = serverChange.c;
				return _Utils_update(
					local,
					{
						guilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							function (guild) {
								return _Utils_update(
									guild,
									{
										channels: $lamdera$containers$SeqDict$insert$(channelId, channel, guild.channels)
									});
							},
							local.guilds)
					});
			case 18:
				var guildId = serverChange.a;
				var channelId = serverChange.b;
				var channelName = serverChange.c;
				var channelDescription = serverChange.d;
				return _Utils_update(
					local,
					{
						guilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							A3($author$project$LocalState$editChannel, channelName, channelDescription, channelId),
							local.guilds)
					});
			case 19:
				var guildId = serverChange.a;
				var channelId = serverChange.b;
				return _Utils_update(
					local,
					{
						guilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							$author$project$LocalState$deleteChannelFrontend(channelId),
							local.guilds)
					});
			case 20:
				var guildId = serverChange.a;
				var guildName = serverChange.b;
				return _Utils_update(
					local,
					{
						guilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							$author$project$LocalState$editGuildName(guildName),
							local.guilds)
					});
			case 21:
				var guildId = serverChange.a;
				return _Utils_update(
					local,
					{
						guilds: $lamdera$containers$SeqDict$remove$(guildId, local.guilds)
					});
			case 22:
				var time = serverChange.a;
				var userId = serverChange.b;
				var guildId = serverChange.c;
				var inviteLinkId = serverChange.d;
				return _Utils_update(
					local,
					{
						guilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							A3($author$project$LocalState$addInvite, inviteLinkId, userId, time),
							local.guilds)
					});
			case 23:
				var guildId = serverChange.a;
				var inviteLinkId = serverChange.b;
				return _Utils_update(
					local,
					{
						guilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							$author$project$LocalState$removeInvite(inviteLinkId),
							local.guilds)
					});
			case 24:
				var time = serverChange.a;
				var userId = serverChange.b;
				var guildId = serverChange.c;
				var user = serverChange.d;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						guilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							function (guild) {
								return $elm$core$Result$withDefault$(
									guild,
									$author$project$LocalState$addMemberFrontend$(time, userId, guild));
							},
							local.guilds),
						localUser: _Utils_update(
							localUser,
							{
								otherUsers: $lamdera$containers$SeqDict$insert$(userId, user, localUser.otherUsers)
							})
					});
			case 25:
				var userId = serverChange.a;
				var guildId = serverChange.b;
				return _Utils_eq(userId, local.localUser.session.userId) ? _Utils_update(
					local,
					{
						guilds: $lamdera$containers$SeqDict$remove$(guildId, local.guilds)
					}) : _Utils_update(
					local,
					{
						guilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							function (guild) {
								return _Utils_update(
									guild,
									{
										membersAndOwner: $author$project$MembersAndOwner$removeMember$(userId, guild.membersAndOwner)
									});
							},
							local.guilds)
					});
			case 26:
				var result = serverChange.a;
				if (!result.$) {
					var ok = result.a;
					var localUser = local.localUser;
					return _Utils_update(
						local,
						{
							guilds: $lamdera$containers$SeqDict$insert$(ok.guildId, ok.guild, local.guilds),
							localUser: _Utils_update(
								localUser,
								{
									otherUsers: $lamdera$containers$SeqDict$union$(
										ok.members,
										$lamdera$containers$SeqDict$insert$(
											$author$project$MembersAndOwner$owner(ok.guild.membersAndOwner),
											ok.owner,
											localUser.otherUsers)),
									user: $author$project$LocalState$markAllChannelsAndThreadsAsViewedFrontend$(ok.guildId, ok.guild, localUser.user)
								})
						});
				} else {
					var error = result.a;
					return _Utils_update(
						local,
						{
							joinGuildError: $elm$core$Maybe$Just(error)
						});
				}
			case 27:
				var time = serverChange.a;
				var userId = serverChange.b;
				var guildOrDmId = serverChange.c;
				var threadRoute = serverChange.d;
				return $author$project$FrontendExtra$memberTyping$(time, userId, guildOrDmId, threadRoute, local);
			case 28:
				var time = serverChange.a;
				var userId = serverChange.b;
				var guildId = serverChange.c;
				var channelId = serverChange.d;
				var threadRoute = serverChange.e;
				return $author$project$FrontendExtra$discordGuildMemberTyping$(time, userId, guildId, channelId, threadRoute, local);
			case 29:
				var time = serverChange.a;
				var userId = serverChange.b;
				var channelId = serverChange.c;
				return $author$project$FrontendExtra$discordDmMemberTyping$(time, userId, channelId, local);
			case 30:
				var userId = serverChange.a;
				var guildOrDmId = serverChange.b;
				var messageIndex = serverChange.c;
				var emoji = serverChange.d;
				return $author$project$FrontendExtra$addReactionEmoji$(
					userId,
					$author$project$Id$GuildOrDmId(guildOrDmId),
					messageIndex,
					emoji,
					local);
			case 31:
				var guildOrDmId = serverChange.a;
				var messageId = serverChange.b;
				var startedAt = serverChange.c;
				var participants = serverChange.d;
				if (!guildOrDmId.$) {
					var channelId = guildOrDmId.a.channelId;
					var guildId = guildOrDmId.a.guildId;
					return _Utils_update(
						local,
						{
							guilds: $lamdera$containers$SeqDict$updateIfExists$(
								guildId,
								A2(
									$author$project$LocalState$updateChannel,
									A3($author$project$LocalState$startCallRecordingFrontend, messageId, startedAt, participants),
									channelId),
								local.guilds)
						});
				} else {
					var otherUserId = guildOrDmId.a.otherUserId;
					return _Utils_update(
						local,
						{
							dmChannels: $lamdera$containers$SeqDict$updateIfExists$(
								otherUserId,
								A3($author$project$LocalState$startCallRecordingFrontend, messageId, startedAt, participants),
								local.dmChannels)
						});
				}
			case 32:
				var guildOrDmId = serverChange.a;
				var messageId = serverChange.b;
				var file = serverChange.c;
				if (!guildOrDmId.$) {
					var channelId = guildOrDmId.a.channelId;
					var guildId = guildOrDmId.a.guildId;
					return _Utils_update(
						local,
						{
							guilds: $lamdera$containers$SeqDict$updateIfExists$(
								guildId,
								A2(
									$author$project$LocalState$updateChannel,
									A2($author$project$LocalState$callRecordingUploadProgressFrontend, messageId, file),
									channelId),
								local.guilds)
						});
				} else {
					var otherUserId = guildOrDmId.a.otherUserId;
					return _Utils_update(
						local,
						{
							dmChannels: $lamdera$containers$SeqDict$updateIfExists$(
								otherUserId,
								A2($author$project$LocalState$callRecordingUploadProgressFrontend, messageId, file),
								local.dmChannels)
						});
				}
			case 33:
				var guildOrDmId = serverChange.a;
				var messageId = serverChange.b;
				var userId = serverChange.c;
				if (!guildOrDmId.$) {
					var channelId = guildOrDmId.a.channelId;
					var guildId = guildOrDmId.a.guildId;
					return _Utils_update(
						local,
						{
							guilds: $lamdera$containers$SeqDict$updateIfExists$(
								guildId,
								A2(
									$author$project$LocalState$updateChannel,
									A2($author$project$LocalState$finishedUploadingCallRecordingFrontend, messageId, userId),
									channelId),
								local.guilds)
						});
				} else {
					var otherUserId = guildOrDmId.a.otherUserId;
					return _Utils_update(
						local,
						{
							dmChannels: $lamdera$containers$SeqDict$updateIfExists$(
								otherUserId,
								A2($author$project$LocalState$finishedUploadingCallRecordingFrontend, messageId, userId),
								local.dmChannels)
						});
				}
			case 34:
				var guildOrDmId = serverChange.a;
				var messageId = serverChange.b;
				var zip = serverChange.c;
				if (!guildOrDmId.$) {
					var channelId = guildOrDmId.a.channelId;
					var guildId = guildOrDmId.a.guildId;
					return _Utils_update(
						local,
						{
							guilds: $lamdera$containers$SeqDict$updateIfExists$(
								guildId,
								A2(
									$author$project$LocalState$updateChannel,
									A2($author$project$LocalState$callRecordingZipBuiltFrontend, messageId, zip),
									channelId),
								local.guilds)
						});
				} else {
					var otherUserId = guildOrDmId.a.otherUserId;
					return _Utils_update(
						local,
						{
							dmChannels: $lamdera$containers$SeqDict$updateIfExists$(
								otherUserId,
								A2($author$project$LocalState$callRecordingZipBuiltFrontend, messageId, zip),
								local.dmChannels)
						});
				}
			case 35:
				var userId = serverChange.a;
				var guildOrDmId = serverChange.b;
				var messageIndex = serverChange.c;
				var emoji = serverChange.d;
				return $author$project$FrontendExtra$removeReactionEmoji$(
					userId,
					$author$project$Id$GuildOrDmId(guildOrDmId),
					messageIndex,
					emoji,
					local);
			case 36:
				var userId = serverChange.a;
				var guildId = serverChange.b;
				var channelId = serverChange.c;
				var threadRoute = serverChange.d;
				var emoji = serverChange.e;
				return _Utils_update(
					local,
					{
						discordGuilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							A2(
								$author$project$LocalState$updateChannel,
								A3($author$project$LocalState$addReactionEmojiFrontend, emoji, userId, threadRoute),
								channelId),
							local.discordGuilds)
					});
			case 37:
				var userId = serverChange.a;
				var channelId = serverChange.b;
				var messageId = serverChange.c;
				var emoji = serverChange.d;
				return _Utils_update(
					local,
					{
						discordDmChannels: $lamdera$containers$SeqDict$updateIfExists$(
							channelId,
							A3($author$project$LocalState$addReactionEmojiFrontendHelper, emoji, userId, messageId),
							local.discordDmChannels)
					});
			case 38:
				var userId = serverChange.a;
				var guildId = serverChange.b;
				var channelId = serverChange.c;
				var threadRoute = serverChange.d;
				var emoji = serverChange.e;
				return _Utils_update(
					local,
					{
						discordGuilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							A2(
								$author$project$LocalState$updateChannel,
								A3($author$project$LocalState$removeReactionEmojiFrontend, emoji, userId, threadRoute),
								channelId),
							local.discordGuilds)
					});
			case 39:
				var userId = serverChange.a;
				var channelId = serverChange.b;
				var messageId = serverChange.c;
				var emoji = serverChange.d;
				return _Utils_update(
					local,
					{
						discordDmChannels: $lamdera$containers$SeqDict$updateIfExists$(
							channelId,
							A3($author$project$LocalState$removeReactionEmojiFrontendHelper, emoji, userId, messageId),
							local.discordDmChannels)
					});
			case 40:
				var time = serverChange.a;
				var userId = serverChange.b;
				var guildOrDmId = serverChange.c;
				var threadRoute = serverChange.d;
				var newContent = serverChange.e;
				var attachedFiles = serverChange.f;
				if (!guildOrDmId.$) {
					var channelId = guildOrDmId.a.channelId;
					var guildId = guildOrDmId.a.guildId;
					return _Utils_update(
						local,
						{
							guilds: $lamdera$containers$SeqDict$updateIfExists$(
								guildId,
								function (guild) {
									return $author$project$LocalState$updateChannel$(
										function (channel) {
											return $elm$core$Result$withDefault$(
												channel,
												$author$project$LocalState$editMessageFrontendHelper$(
													time,
													userId,
													newContent,
													$author$project$Message$ChangeAttachments(attachedFiles),
													threadRoute,
													channel));
										},
										channelId,
										_Utils_update(
											guild,
											{
												lastTypedAt: $author$project$LocalState$forgetEditTyping$(userId, channelId, threadRoute, guild.lastTypedAt)
											}));
								},
								local.guilds)
						});
				} else {
					var otherUserId = guildOrDmId.a.otherUserId;
					return _Utils_update(
						local,
						{
							dmChannels: $lamdera$containers$SeqDict$updateIfExists$(
								otherUserId,
								function (dmChannel) {
									return $elm$core$Result$withDefault$(
										dmChannel,
										$author$project$LocalState$editMessageFrontendHelper$(
											time,
											userId,
											newContent,
											$author$project$Message$ChangeAttachments(attachedFiles),
											threadRoute,
											_Utils_update(
												dmChannel,
												{
													lastTypedAt: $author$project$LocalState$dmForgetEditTyping$(userId, threadRoute, dmChannel.lastTypedAt)
												})));
								},
								local.dmChannels)
						});
				}
			case 41:
				var time = serverChange.a;
				var editedBy = serverChange.b;
				var guildId = serverChange.c;
				var channelId = serverChange.d;
				var threadRoute = serverChange.e;
				var newContent = serverChange.f;
				return _Utils_update(
					local,
					{
						discordGuilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							function (guild) {
								return $author$project$LocalState$updateChannel$(
									function (channel) {
										return $elm$core$Result$withDefault$(
											channel,
											$author$project$LocalState$editMessageFrontendHelper$(time, editedBy, newContent, $author$project$Message$DoNotChangeAttachments, threadRoute, channel));
									},
									channelId,
									_Utils_update(
										guild,
										{
											lastTypedAt: $author$project$LocalState$forgetEditTyping$(editedBy, channelId, threadRoute, guild.lastTypedAt)
										}));
							},
							local.discordGuilds)
					});
			case 42:
				var time = serverChange.a;
				var data = serverChange.b;
				var messageId = serverChange.c;
				var newContent = serverChange.d;
				return _Utils_update(
					local,
					{
						discordDmChannels: $lamdera$containers$SeqDict$updateIfExists$(
							data.channelId,
							function (dmChannel) {
								return $elm$core$Result$withDefault$(
									dmChannel,
									$author$project$LocalState$editMessageFrontendHelperNoThread$(
										time,
										data.currentUserId,
										newContent,
										$author$project$Message$DoNotChangeAttachments,
										messageId,
										_Utils_update(
											dmChannel,
											{
												lastTypedAt: $author$project$LocalState$discordDmForgetEditTyping$(data.currentUserId, messageId, dmChannel.lastTypedAt)
											})));
							},
							local.discordDmChannels)
					});
			case 43:
				var time = serverChange.a;
				var userId = serverChange.b;
				var guildOrDmId = serverChange.c;
				var messageIndex = serverChange.d;
				return $author$project$FrontendExtra$memberEditTyping$(time, userId, guildOrDmId, messageIndex, local);
			case 44:
				var guildOrDmId = serverChange.a;
				var messageIndex = serverChange.b;
				return $author$project$FrontendExtra$deleteMessage$(guildOrDmId, messageIndex, local);
			case 45:
				var guildId = serverChange.a;
				var channelId = serverChange.b;
				var threadRoute = serverChange.c;
				return _Utils_update(
					local,
					{
						discordGuilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							A2($author$project$LocalState$deleteMessageFrontend, channelId, threadRoute),
							local.discordGuilds)
					});
			case 46:
				var guildId = serverChange.a;
				var forumId = serverChange.b;
				var messageId = serverChange.c;
				return _Utils_update(
					local,
					{
						discordGuilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							A2($author$project$LocalState$deleteForumPostFrontend, forumId, messageId),
							local.discordGuilds)
					});
			case 47:
				var channelId = serverChange.a;
				var messageId = serverChange.b;
				return _Utils_update(
					local,
					{
						discordDmChannels: $lamdera$containers$SeqDict$updateIfExists$(
							channelId,
							$author$project$LocalState$deleteMessageFrontendNoThread(messageId),
							local.discordDmChannels)
					});
			case 48:
				var userId = serverChange.a;
				var name = serverChange.b;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								otherUsers: $lamdera$containers$SeqDict$updateIfExists$(
									userId,
									$author$project$User$setName(name),
									localUser.otherUsers)
							})
					});
			case 49:
				var userId = serverChange.a;
				var color = serverChange.b;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								otherUsers: $lamdera$containers$SeqDict$updateIfExists$(
									userId,
									$author$project$User$setColor(color),
									localUser.otherUsers)
							})
					});
			case 50:
				var userId = serverChange.a;
				var icon = serverChange.b;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								otherUsers: $lamdera$containers$SeqDict$updateIfExists$(
									userId,
									$author$project$User$setIcon(icon),
									localUser.otherUsers),
								user: _Utils_eq(localUser.session.userId, userId) ? $author$project$User$setIcon$(icon, localUser.user) : localUser.user
							})
					});
			case 51:
				var guildId = serverChange.a;
				var icon = serverChange.b;
				return _Utils_update(
					local,
					{
						guilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							function (guild) {
								return _Utils_update(
									guild,
									{icon: icon});
							},
							local.guilds)
					});
			case 52:
				var publicVapidKey = serverChange.a;
				return _Utils_update(
					local,
					{publicVapidKey: publicVapidKey});
			case 53:
				var guildId = serverChange.a;
				var notificationLevel = serverChange.b;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								user: $author$project$User$setGuildNotificationLevel$(guildId, notificationLevel, localUser.user)
							})
					});
			case 54:
				var guildId = serverChange.a;
				var notificationLevel = serverChange.b;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								user: $author$project$User$setDiscordGuildNotificationLevel$(guildId, notificationLevel, localUser.user)
							})
					});
			case 55:
				var teamId = serverChange.a;
				var notificationLevel = serverChange.b;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								user: $author$project$User$setSlackWorkspaceNotificationLevel$(teamId, notificationLevel, localUser.user)
							})
					});
			case 56:
				var subscribeData = serverChange.a;
				var error = serverChange.b;
				var localUser = local.localUser;
				var session = localUser.session;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								session: _Utils_update(
									session,
									{
										pushSubscription: $author$project$UserSession$SubscriptionError$(subscribeData, error)
									})
							})
					});
			case 57:
				var sessionId = serverChange.a;
				var session = serverChange.b;
				return _Utils_update(
					local,
					{
						otherSessions: $lamdera$containers$SeqDict$insert$(sessionId, session, local.otherSessions)
					});
			case 58:
				var sessionId = serverChange.a;
				return _Utils_update(
					local,
					{
						otherSessions: $lamdera$containers$SeqDict$remove$(sessionId, local.otherSessions)
					});
			case 59:
				var sessionIdHash = serverChange.a;
				var clientId = serverChange.b;
				var currentlyViewing = serverChange.c;
				var localUser = local.localUser;
				return _Utils_eq(sessionIdHash, localUser.session.sessionIdHash) ? _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{currentlyViewing: currentlyViewing})
					}) : _Utils_update(
					local,
					{
						otherSessions: $lamdera$containers$SeqDict$updateIfExists$(
							sessionIdHash,
							function (session) {
								return _Utils_update(
									session,
									{
										currentlyViewing: $lamdera$containers$SeqDict$insert$(clientId, currentlyViewing, session.currentlyViewing)
									});
							},
							local.otherSessions)
					});
			case 60:
				var sessionId = serverChange.a;
				var clientId = serverChange.b;
				var disconnectedAt = serverChange.c;
				return _Utils_update(
					local,
					{
						otherSessions: $lamdera$containers$SeqDict$updateIfExists$(
							sessionId,
							function (session) {
								return _Utils_update(
									session,
									{
										currentlyViewing: $lamdera$containers$SeqDict$remove$(clientId, session.currentlyViewing),
										lastActiveAt: disconnectedAt
									});
							},
							local.otherSessions)
					});
			case 61:
				var serverChange2 = serverChange.a;
				return _Utils_update(
					local,
					{
						textEditor: $author$project$TextEditor$changeUpdate$(serverChange2, local.textEditor)
					});
			case 62:
				var userId = serverChange.a;
				var user = serverChange.b;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								discordUsers: $author$project$LinkedAndOtherDiscordUsers$addLinkedUser$(userId, user, localUser.discordUsers)
							})
					});
			case 4:
				var slackUserId = serverChange.a;
				return $author$project$FrontendExtra$unlinkSlackUser$(slackUserId, local);
			case 5:
				var slackUserId = serverChange.a;
				var user = serverChange.b;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								slackUsers: $lamdera$containers$SeqDict$insert$(slackUserId, user, localUser.slackUsers)
							})
					});
			case 6:
				var teamId = serverChange.a;
				var name = serverChange.b;
				return _Utils_update(
					local,
					{
						slackWorkspaces: $lamdera$containers$SeqDict$updateIfExists$(
							teamId,
							function (workspace) {
								return _Utils_update(
									workspace,
									{name: name});
							},
							local.slackWorkspaces)
					});
			case 9:
				var guildOrDmId = serverChange.a;
				var threadRouteWithMessage = serverChange.b;
				var result = serverChange.c;
				var addEmbed = function (channel) {
					if (!threadRouteWithMessage.$) {
						var messageId = threadRouteWithMessage.a;
						return $author$project$LocalState$addEmbedFrontend$(messageId, result, channel);
					} else {
						var threadId = threadRouteWithMessage.a;
						var messageId = threadRouteWithMessage.b;
						return _Utils_update(
							channel,
							{
								threads: $lamdera$containers$SeqDict$updateIfExists$(
									threadId,
									A2($author$project$LocalState$addEmbedFrontend, messageId, result),
									channel.threads)
							});
					}
				};
				if (!guildOrDmId.$) {
					var channelId = guildOrDmId.a.channelId;
					var teamId = guildOrDmId.a.teamId;
					return _Utils_update(
						local,
						{
							slackWorkspaces: $lamdera$containers$SeqDict$updateIfExists$(
								teamId,
								A2($author$project$LocalState$updateChannel, addEmbed, channelId),
								local.slackWorkspaces)
						});
				} else {
					var channelId = guildOrDmId.a.channelId;
					return _Utils_update(
						local,
						{
							slackDmChannels: $lamdera$containers$SeqDict$updateIfExists$(channelId, addEmbed, local.slackDmChannels)
						});
				}
			case 8:
				var slackUserId = serverChange.a;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								slackUsersNeedingAuth: $lamdera$containers$SeqSet$insert$(slackUserId, localUser.slackUsersNeedingAuth)
							})
					});
			case 7:
				var teamId = serverChange.a;
				var channelId = serverChange.b;
				var name = serverChange.c;
				return _Utils_update(
					local,
					{
						slackWorkspaces: $lamdera$containers$SeqDict$updateIfExists$(
							teamId,
							function (workspace) {
								return _Utils_update(
									workspace,
									{
										channels: $lamdera$containers$SeqDict$updateIfExists$(
											channelId,
											function (channel) {
												return _Utils_update(
													channel,
													{name: name});
											},
											workspace.channels)
									});
							},
							local.slackWorkspaces)
					});
			case 10:
				var slackUserId = serverChange.a;
				var teamId = serverChange.b;
				var data = serverChange.c;
				var newDmChannels = data.markNewDmsAsViewed ? $elm$core$List$filterMap$(
					function (_v86) {
						var channelId = _v86.a;
						var dmChannel = _v86.b;
						return (_Utils_eq(dmChannel.teamId, teamId) && (!$lamdera$containers$SeqDict$member$(channelId, local.slackDmChannels))) ? $elm$core$Maybe$Just(channelId) : $elm$core$Maybe$Nothing;
					},
					$lamdera$containers$SeqDict$toList(data.dmChannels)) : _List_Nil;
				var localUser = local.localUser;
				var existingChannels = function () {
					var _v85 = $lamdera$containers$SeqDict$get$(teamId, local.slackWorkspaces);
					if (!_v85.$) {
						var workspace = _v85.a;
						return workspace.channels;
					} else {
						return $lamdera$containers$SeqDict$empty;
					}
				}();
				var newChannels = function () {
					var _v84 = $lamdera$containers$SeqDict$get$(teamId, data.workspaces);
					if (!_v84.$) {
						var workspace = _v84.a;
						return $elm$core$List$filter$(
							function (channelId) {
								return !$lamdera$containers$SeqDict$member$(channelId, existingChannels);
							},
							$lamdera$containers$SeqDict$keys(workspace.channels));
					} else {
						return _List_Nil;
					}
				}();
				return $author$project$FrontendExtra$markNewSlackConversationsAsViewed$(
					slackUserId,
					teamId,
					newChannels,
					newDmChannels,
					_Utils_update(
						local,
						{
							localUser: _Utils_update(
								localUser,
								{
									customEmojis: $lamdera$containers$SeqDict$union$(data.customEmojis, localUser.customEmojis),
									linkedSlackUsers: $lamdera$containers$SeqDict$insert$(slackUserId, teamId, localUser.linkedSlackUsers),
									slackUsers: $lamdera$containers$SeqDict$union$(data.users, localUser.slackUsers),
									slackUsersNeedingAuth: $lamdera$containers$SeqSet$remove$(slackUserId, localUser.slackUsersNeedingAuth),
									user: $author$project$User$addNewCustomEmojis$(data.customEmojis, localUser.user)
								}),
							slackDmChannels: $lamdera$containers$SeqDict$union$(data.dmChannels, local.slackDmChannels),
							slackWorkspaces: $lamdera$containers$SeqDict$union$(data.workspaces, local.slackWorkspaces)
						}));
			case 11:
				var customEmojis = serverChange.a;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								customEmojis: $lamdera$containers$SeqDict$union$(customEmojis, localUser.customEmojis)
							})
					});
			case 12:
				var teamId = serverChange.a;
				var customEmojiId = serverChange.b;
				var customEmoji = serverChange.c;
				var localUser = local.localUser;
				var user = localUser.user;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								customEmojis: $lamdera$containers$SeqDict$insert$(customEmojiId, customEmoji, localUser.customEmojis),
								user: _Utils_update(
									user,
									{
										availableCustomEmojis: $lamdera$containers$SeqSet$insert$(customEmojiId, user.availableCustomEmojis)
									})
							}),
						slackWorkspaces: $lamdera$containers$SeqDict$updateIfExists$(
							teamId,
							function (workspace) {
								return _Utils_update(
									workspace,
									{
										customEmojis: $lamdera$containers$SeqSet$insert$(customEmojiId, workspace.customEmojis)
									});
							},
							local.slackWorkspaces)
					});
			case 63:
				var userId = serverChange.a;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								discordUsers: $author$project$LinkedAndOtherDiscordUsers$unlinkUser$(userId, localUser.discordUsers)
							})
					});
			case 64:
				var guildId = serverChange.a;
				var channelId = serverChange.b;
				var isForum = serverChange.c;
				var channelName = serverChange.d;
				var topic = serverChange.e;
				var permissionOverwrites = serverChange.f;
				return _Utils_update(
					local,
					{
						discordGuilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							function (guild) {
								return _Utils_update(
									guild,
									{
										channels: $lamdera$containers$SeqDict$update$(
											channelId,
											function (maybeChannel) {
												if (!maybeChannel.$) {
													var channel = maybeChannel.a;
													return $elm$core$Maybe$Just(
														_Utils_update(
															channel,
															{
																description: $author$project$LocalState$discordTopicToDescription$(topic, $author$project$ChannelDescription$empty),
																isForum: isForum,
																name: channelName,
																permissionOverwrites: permissionOverwrites
															}));
												} else {
													return $elm$core$Maybe$Just(
														{
															dateDividerDrawings: $lamdera$containers$SeqDict$empty,
															description: $author$project$LocalState$discordTopicToDescription$(topic, $author$project$ChannelDescription$empty),
															isForum: isForum,
															messages: $author$project$MessageArray$empty,
															name: channelName,
															permissionOverwrites: permissionOverwrites,
															threads: $lamdera$containers$SeqDict$empty,
															visibleMessages: $author$project$VisibleMessages$empty
														});
												}
											},
											guild.channels)
									});
							},
							local.discordGuilds)
					});
			case 65:
				var channelId = serverChange.a;
				var members = serverChange.b;
				return _Utils_update(
					local,
					{
						discordDmChannels: $lamdera$containers$SeqDict$update$(
							channelId,
							function (maybeChannel) {
								if (!maybeChannel.$) {
									return maybeChannel;
								} else {
									return $elm$core$Maybe$Just(
										{dateDividerDrawings: $lamdera$containers$SeqDict$empty, lastTypedAt: $lamdera$containers$SeqDict$empty, members: members, messages: $author$project$MessageArray$empty, visibleMessages: $author$project$VisibleMessages$empty});
								}
							},
							local.discordDmChannels)
					});
			case 66:
				var channelId = serverChange.a;
				var removedUserId = serverChange.b;
				return _Utils_update(
					local,
					{
						discordDmChannels: $lamdera$containers$SeqDict$update$(
							channelId,
							function (maybe) {
								if (!maybe.$) {
									var channel = maybe.a;
									var _v90 = $author$project$NonemptyDict$fromSeqDict(
										$author$project$NonemptyDict$remove$(removedUserId, channel.members));
									if (!_v90.$) {
										var members = _v90.a;
										return $elm$core$Maybe$Just(
											_Utils_update(
												channel,
												{members: members}));
									} else {
										return $elm$core$Maybe$Just(channel);
									}
								} else {
									return $elm$core$Maybe$Nothing;
								}
							},
							local.discordDmChannels)
					});
			case 67:
				var userId = serverChange.a;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								discordUsers: $author$project$LinkedAndOtherDiscordUsers$updateLinkedUser$(
									userId,
									function (user) {
										return _Utils_update(
											user,
											{needsAuthAgain: true});
									},
									localUser.discordUsers)
							})
					});
			case 68:
				var discordUserId = serverChange.a;
				var result = serverChange.b;
				var localUser = local.localUser;
				if (!result.$) {
					var data = result.a;
					var local2 = _Utils_update(
						local,
						{
							discordDmChannels: $lamdera$containers$SeqDict$foldl$($lamdera$containers$SeqDict$insert, local.discordDmChannels, data.discordDms),
							discordGuilds: $lamdera$containers$SeqDict$foldl$($lamdera$containers$SeqDict$insert, local.discordGuilds, data.discordGuilds),
							localUser: _Utils_update(
								localUser,
								{
									discordUsers: $author$project$LinkedAndOtherDiscordUsers$updateLinkedUser$(
										discordUserId,
										function (user) {
											return _Utils_update(
												user,
												{isLoadingData: $author$project$DiscordUserData$DiscordUserLoadedSuccessfully});
										},
										$lamdera$containers$SeqDict$foldl$($author$project$LinkedAndOtherDiscordUsers$addOtherUser, localUser.discordUsers, data.discordUsers))
								})
						});
					return data.markEverythingAsViewed ? $author$project$FrontendExtra$markDiscordDataAsViewed$(discordUserId, local2) : local2;
				} else {
					var time = result.a;
					return _Utils_update(
						local,
						{
							localUser: _Utils_update(
								localUser,
								{
									discordUsers: $author$project$LinkedAndOtherDiscordUsers$updateLinkedUser$(
										discordUserId,
										function (user) {
											return _Utils_update(
												user,
												{
													isLoadingData: $author$project$DiscordUserData$DiscordUserLoadingFailed(time)
												});
										},
										localUser.discordUsers)
								})
						});
				}
			case 69:
				var time = serverChange.a;
				var discordUserId = serverChange.b;
				return $author$project$FrontendExtra$startReloadingDiscordUser$(time, discordUserId, local);
			case 70:
				var userIdToLoadWith = serverChange.a;
				var maybeLoading = serverChange.b;
				var _v92 = local.adminData;
				switch (_v92.$) {
					case 0:
						var adminData = _v92.a;
						return _Utils_update(
							local,
							{
								adminData: $author$project$LocalState$IsAdmin(
									_Utils_update(
										adminData,
										{
											loadingDiscordChannels: function () {
												if (!maybeLoading.$) {
													var loading = maybeLoading.a;
													return $lamdera$containers$SeqDict$insert$(userIdToLoadWith, loading, adminData.loadingDiscordChannels);
												} else {
													return $lamdera$containers$SeqDict$remove$(userIdToLoadWith, adminData.loadingDiscordChannels);
												}
											}()
										}))
							});
					case 1:
						return local;
					default:
						return local;
				}
			case 71:
				var adminData = serverChange.a;
				return _Utils_update(
					local,
					{
						adminData: $author$project$LocalState$IsAdmin(
							$author$project$FrontendExtra$initAdminData(adminData))
					});
			case 73:
				var backup = serverChange.a;
				return _Utils_update(
					local,
					{
						adminData: function () {
							var _v94 = local.adminData;
							switch (_v94.$) {
								case 0:
									var adminData = _v94.a;
									return $author$project$LocalState$IsAdmin(
										_Utils_update(
											adminData,
											{
												lastBackup: $elm$core$Maybe$Just(backup)
											}));
								case 1:
									return local.adminData;
								default:
									return local.adminData;
							}
						}()
					});
			case 72:
				var time = serverChange.a;
				var log = serverChange.b;
				return _Utils_update(
					local,
					{
						adminData: function () {
							var _v95 = local.adminData;
							switch (_v95.$) {
								case 0:
									var adminData = _v95.a;
									return $author$project$LocalState$IsAdmin(
										_Utils_update(
											adminData,
											{
												logs: $author$project$Pagination$addItem$(
													{log: log, time: time},
													adminData.logs)
											}));
								case 1:
									return local.adminData;
								default:
									return local.adminData;
							}
						}()
					});
			case 74:
				var guildId = serverChange.a;
				var channelId = serverChange.b;
				var threadRouteWithMessage = serverChange.c;
				var result = serverChange.d;
				var _v96 = $author$project$LocalState$getGuildAndChannel$(
					{channelId: channelId, guildId: guildId},
					local);
				if (!_v96.$) {
					var _v97 = _v96.a;
					var guild = _v97.a;
					var channel = _v97.b;
					return _Utils_update(
						local,
						{
							guilds: $lamdera$containers$SeqDict$insert$(
								guildId,
								_Utils_update(
									guild,
									{
										channels: $lamdera$containers$SeqDict$insert$(
											channelId,
											function () {
												if (!threadRouteWithMessage.$) {
													var messageId = threadRouteWithMessage.a;
													return $author$project$LocalState$addEmbedFrontend$(messageId, result, channel);
												} else {
													var threadId = threadRouteWithMessage.a;
													var messageId = threadRouteWithMessage.b;
													return _Utils_update(
														channel,
														{
															threads: $lamdera$containers$SeqDict$updateIfExists$(
																threadId,
																A2($author$project$LocalState$addEmbedFrontend, messageId, result),
																channel.threads)
														});
												}
											}(),
											guild.channels)
									}),
								local.guilds)
						});
				} else {
					return local;
				}
			case 75:
				var channelId = serverChange.a;
				var threadRouteWithMessage = serverChange.b;
				var result = serverChange.c;
				var _v99 = $lamdera$containers$SeqDict$get$(channelId, local.dmChannels);
				if (!_v99.$) {
					var channel = _v99.a;
					return _Utils_update(
						local,
						{
							dmChannels: $lamdera$containers$SeqDict$insert$(
								channelId,
								function () {
									if (!threadRouteWithMessage.$) {
										var messageId = threadRouteWithMessage.a;
										return $author$project$LocalState$addEmbedFrontend$(messageId, result, channel);
									} else {
										var threadId = threadRouteWithMessage.a;
										var messageId = threadRouteWithMessage.b;
										return _Utils_update(
											channel,
											{
												threads: $lamdera$containers$SeqDict$updateIfExists$(
													threadId,
													A2($author$project$LocalState$addEmbedFrontend, messageId, result),
													channel.threads)
											});
									}
								}(),
								local.dmChannels)
						});
				} else {
					return local;
				}
			case 76:
				var guildId = serverChange.a;
				var channelId = serverChange.b;
				var threadRouteWithMessage = serverChange.c;
				var result = serverChange.d;
				var _v101 = $author$project$LocalState$getDiscordGuildAndChannel$(guildId, channelId, local);
				if (!_v101.$) {
					var _v102 = _v101.a;
					var guild = _v102.a;
					var channel = _v102.b;
					return _Utils_update(
						local,
						{
							discordGuilds: $lamdera$containers$SeqDict$insert$(
								guildId,
								_Utils_update(
									guild,
									{
										channels: $lamdera$containers$SeqDict$insert$(
											channelId,
											function () {
												if (!threadRouteWithMessage.$) {
													var messageId = threadRouteWithMessage.a;
													return $author$project$LocalState$addEmbedFrontend$(messageId, result, channel);
												} else {
													var threadId = threadRouteWithMessage.a;
													var messageId = threadRouteWithMessage.b;
													return _Utils_update(
														channel,
														{
															threads: $lamdera$containers$SeqDict$updateIfExists$(
																threadId,
																A2($author$project$LocalState$addEmbedFrontend, messageId, result),
																channel.threads)
														});
												}
											}(),
											guild.channels)
									}),
								local.discordGuilds)
						});
				} else {
					return local;
				}
			case 77:
				var channelId = serverChange.a;
				var messageId = serverChange.b;
				var result = serverChange.c;
				var _v104 = $lamdera$containers$SeqDict$get$(channelId, local.discordDmChannels);
				if (!_v104.$) {
					var channel = _v104.a;
					return _Utils_update(
						local,
						{
							discordDmChannels: $lamdera$containers$SeqDict$insert$(
								channelId,
								$author$project$LocalState$addEmbedFrontend$(messageId, result, channel),
								local.discordDmChannels)
						});
				} else {
					return local;
				}
			case 78:
				var discordUserId = serverChange.a;
				var guildId = serverChange.b;
				var guild = serverChange.c;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						discordGuilds: $lamdera$containers$SeqDict$update$(
							guildId,
							function (maybe) {
								if (!maybe.$) {
									return maybe;
								} else {
									return $elm$core$Maybe$Just(guild);
								}
							},
							local.discordGuilds),
						localUser: _Utils_update(
							localUser,
							{
								user: $author$project$LocalState$markAllDiscordChannelsAndThreadsAsViewedFrontend$(discordUserId, guildId, guild, localUser.user)
							})
					});
			case 79:
				var discordUserId = serverChange.a;
				var guildId = serverChange.b;
				return _Utils_update(
					local,
					{
						discordGuilds: $lamdera$containers$SeqDict$update$(
							guildId,
							function (maybe) {
								if (!maybe.$) {
									var guild = maybe.a;
									var _v107 = $author$project$MembersAndOwner$isMember$(discordUserId, guild.membersAndOwner);
									if (_v107 === 1) {
										return $elm$core$Maybe$Nothing;
									} else {
										var guild2 = _Utils_update(
											guild,
											{
												membersAndOwner: $author$project$MembersAndOwner$removeMember$(discordUserId, guild.membersAndOwner)
											});
										return $author$project$LocalState$canViewDiscordGuild$(
											$author$project$LinkedAndOtherDiscordUsers$linkedUsers(local.localUser.discordUsers),
											guild2.membersAndOwner) ? $elm$core$Maybe$Just(guild2) : $elm$core$Maybe$Nothing;
									}
								} else {
									return $elm$core$Maybe$Nothing;
								}
							},
							local.discordGuilds)
					});
			case 80:
				var guildId = serverChange.a;
				var channelId = serverChange.b;
				var name = serverChange.c;
				var topic = serverChange.d;
				var permissionOverwrites = serverChange.e;
				return _Utils_update(
					local,
					{
						discordGuilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							A2(
								$author$project$LocalState$updateChannel,
								function (channel) {
									return _Utils_update(
										channel,
										{
											description: $author$project$LocalState$discordTopicToDescription$(topic, channel.description),
											name: function () {
												if ((!name.$) && (!name.a.$)) {
													var name2 = name.a.a;
													return $author$project$ChannelName$fromStringLossy(name2);
												} else {
													return channel.name;
												}
											}(),
											permissionOverwrites: permissionOverwrites
										});
								},
								channelId),
							local.discordGuilds)
					});
			case 81:
				var guildId = serverChange.a;
				var channelId = serverChange.b;
				return _Utils_update(
					local,
					{
						discordGuilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							function (guild) {
								return _Utils_update(
									guild,
									{
										channels: $lamdera$containers$SeqDict$remove$(channelId, guild.channels)
									});
							},
							local.discordGuilds)
					});
			case 82:
				var guildId = serverChange.a;
				var name = serverChange.b;
				var icon = serverChange.c;
				var roles = serverChange.d;
				return _Utils_update(
					local,
					{
						discordGuilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							function (guild) {
								return _Utils_update(
									guild,
									{icon: icon, name: name, roles: roles});
							},
							local.discordGuilds)
					});
			case 83:
				var guildId = serverChange.a;
				var roleId = serverChange.b;
				var role = serverChange.c;
				return _Utils_update(
					local,
					{
						discordGuilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							function (guild) {
								return _Utils_update(
									guild,
									{
										roles: $lamdera$containers$SeqDict$insert$(roleId, role, guild.roles)
									});
							},
							local.discordGuilds)
					});
			case 84:
				var guildId = serverChange.a;
				var customEmojis = serverChange.b;
				return _Utils_update(
					local,
					{
						discordGuilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							function (guild) {
								return _Utils_update(
									guild,
									{customEmojis: customEmojis});
							},
							local.discordGuilds)
					});
			case 85:
				var guildId = serverChange.a;
				var members = serverChange.b;
				return _Utils_update(
					local,
					{
						discordGuilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							function (guild) {
								return _Utils_update(
									guild,
									{membersAndOwner: members});
							},
							local.discordGuilds)
					});
			case 86:
				var time = serverChange.a;
				var guildId = serverChange.b;
				var channelId = serverChange.c;
				var userJoinedId = serverChange.d;
				var name = serverChange.e;
				var color = serverChange.f;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						discordGuilds: $lamdera$containers$SeqDict$updateIfExists$(
							guildId,
							function (guild) {
								return _Utils_update(
									guild,
									{
										channels: $lamdera$containers$SeqDict$updateIfExists$(
											channelId,
											$author$project$LocalState$createChannelMessageFrontend(
												$author$project$Message$UserJoinedMessage$(time, userJoinedId, $lamdera$containers$SeqDict$empty, $author$project$Drawing$emptyDrawing)),
											guild.channels),
										membersAndOwner: $elm$core$Result$withDefault$(
											guild.membersAndOwner,
											$author$project$MembersAndOwner$addMember$(
												userJoinedId,
												{
													joinedAt: $elm$core$Maybe$Just(time),
													roles: $lamdera$containers$SeqSet$empty
												},
												guild.membersAndOwner))
									});
							},
							local.discordGuilds),
						localUser: _Utils_update(
							localUser,
							{
								discordUsers: $author$project$LinkedAndOtherDiscordUsers$updateOtherUser$(
									userJoinedId,
									function (maybe) {
										if (!maybe.$) {
											var user = maybe.a;
											return _Utils_update(
												user,
												{name: name});
										} else {
											return {color: color, icon: $elm$core$Maybe$Nothing, name: name};
										}
									},
									localUser.discordUsers)
							})
					});
			case 87:
				var newStickers = serverChange.a;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								stickers: $lamdera$containers$SeqDict$union$(newStickers, localUser.stickers),
								user: $author$project$User$addNewStickers$(newStickers, localUser.user)
							})
					});
			case 88:
				var newCustomEmojis = serverChange.a;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								customEmojis: $lamdera$containers$SeqDict$union$(newCustomEmojis, localUser.customEmojis),
								user: $author$project$User$addNewCustomEmojis$(newCustomEmojis, localUser.user)
							})
					});
			case 89:
				var voiceChatChange = serverChange.a;
				var calls = local.calls;
				switch (voiceChatChange.$) {
					case 0:
						var time = voiceChatChange.a;
						var roomId = voiceChatChange.b;
						return $author$project$FrontendExtra$joinCallHelper$(
							local.localUser.session.userId,
							time,
							_Utils_eq(
								calls.currentRoom,
								$elm$core$Maybe$Just(roomId)) || $lamdera$containers$SeqDict$member$(roomId, calls.voiceChats),
							roomId,
							_Utils_update(
								calls,
								{
									currentRoom: $elm$core$Maybe$Just(roomId)
								}),
							local);
					case 1:
						var time = voiceChatChange.a;
						var otherClientId = voiceChatChange.b.otherClientId;
						var roomId = voiceChatChange.b.roomId;
						var remoteCallData = voiceChatChange.c;
						return $author$project$FrontendExtra$joinCallHelper$(
							otherClientId.a,
							time,
							_Utils_eq(
								calls.currentRoom,
								$elm$core$Maybe$Just(roomId)) || $lamdera$containers$SeqDict$member$(roomId, calls.voiceChats),
							roomId,
							_Utils_update(
								calls,
								{
									voiceChats: $author$project$SeqDictHelper$addToDict$(roomId, otherClientId, remoteCallData, calls.voiceChats)
								}),
							local);
					case 2:
						var time = voiceChatChange.a;
						var connectionId = voiceChatChange.b;
						return $author$project$FrontendExtra$otherUserLeaveCall$(time, connectionId, local);
					case 3:
						var connectionId = voiceChatChange.a;
						var remoteCallData = voiceChatChange.b;
						return _Utils_update(
							local,
							{
								calls: _Utils_update(
									calls,
									{
										voiceChats: $lamdera$containers$SeqDict$updateIfExists$(
											connectionId.roomId,
											A2($author$project$NonemptyDict$insert, connectionId.otherClientId, remoteCallData),
											calls.voiceChats)
									})
							});
					default:
						var callId = voiceChatChange.a;
						var maybeStatus = voiceChatChange.b;
						return _Utils_update(
							local,
							{
								calls: _Utils_update(
									calls,
									{
										recordings: function () {
											if (!maybeStatus.$) {
												var status = maybeStatus.a;
												return $lamdera$containers$SeqDict$insert$(callId, status, calls.recordings);
											} else {
												return $lamdera$containers$SeqDict$remove$(callId, calls.recordings);
											}
										}()
									})
							});
				}
			case 90:
				var changeBy = serverChange.a;
				var guildOrDmId = serverChange.b;
				var gameChange = serverChange.c;
				return $author$project$FrontendExtra$gameChangeUpdate$(changeBy, guildOrDmId, gameChange, local);
			case 91:
				var changeBy = serverChange.a;
				var guildOrDmId = serverChange.b;
				var threadRoute = serverChange.c;
				var drawingChange = serverChange.d;
				return $author$project$LocalState$drawingHandleChangeFrontend$(guildOrDmId, threadRoute, changeBy, drawingChange, local);
			case 92:
				var guildId = serverChange.a;
				var channelId = serverChange.b;
				var isMuted = serverChange.c;
				return $author$project$FrontendExtra$setMuteChannel$(guildId, channelId, isMuted, local);
			case 93:
				var guildId = serverChange.a;
				var channelId = serverChange.b;
				var threadId = serverChange.c;
				var isMuted = serverChange.d;
				return $author$project$FrontendExtra$setMuteThread$(guildId, channelId, threadId, isMuted, local);
			case 94:
				var guildId = serverChange.a;
				var channelId = serverChange.b;
				var isMuted = serverChange.c;
				return $author$project$FrontendExtra$setMuteDiscordChannel$(guildId, channelId, isMuted, local);
			case 95:
				var guildId = serverChange.a;
				var channelId = serverChange.b;
				var threadId = serverChange.c;
				var isMuted = serverChange.d;
				return $author$project$FrontendExtra$setMuteDiscordThread$(guildId, channelId, threadId, isMuted, local);
			case 96:
				var guildId = serverChange.a;
				var isMuted = serverChange.b;
				return $author$project$FrontendExtra$setMuteGuild$(guildId, isMuted, local);
			case 97:
				var guildId = serverChange.a;
				var isMuted = serverChange.b;
				return $author$project$FrontendExtra$setMuteDiscordGuild$(guildId, isMuted, local);
			case 98:
				var teamId = serverChange.a;
				var isMuted = serverChange.b;
				return $author$project$FrontendExtra$setMuteSlackWorkspace$(teamId, isMuted, local);
			case 99:
				var teamId = serverChange.a;
				var channelId = serverChange.b;
				var isMuted = serverChange.c;
				return $author$project$FrontendExtra$setMuteSlackChannel$(teamId, channelId, isMuted, local);
			case 100:
				var teamId = serverChange.a;
				var channelId = serverChange.b;
				var threadId = serverChange.c;
				var isMuted = serverChange.d;
				return $author$project$FrontendExtra$setMuteSlackThread$(teamId, channelId, threadId, isMuted, local);
			case 102:
				var id = serverChange.a;
				var requestedBy = serverChange.b;
				return $author$project$LocalState$setDmE2ee$(
					id,
					$author$project$DmChannel$E2eeRequestedBy(requestedBy),
					local);
			case 103:
				var id = serverChange.a;
				return $author$project$LocalState$setDmE2ee$(
					id,
					$author$project$DmChannel$E2eeDisabled($elm$core$Maybe$Nothing),
					local);
			case 104:
				var id = serverChange.a;
				var declinedBy = serverChange.b;
				return $author$project$LocalState$setDmE2ee$(
					id,
					$author$project$DmChannel$E2eeDeclinedBy(declinedBy),
					local);
			case 109:
				var disabledAt = serverChange.a;
				var disabledBy = serverChange.b;
				var id = serverChange.c;
				return $author$project$LocalState$setDmE2ee$(
					id,
					$author$project$DmChannel$E2eeDisabled(
						$elm$core$Maybe$Just(
							_Utils_Tuple2(disabledBy, disabledAt))),
					local);
			case 106:
				var userId = serverChange.a;
				var publicKey = serverChange.b;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								otherUsers: $lamdera$containers$SeqDict$updateIfExists$(
									userId,
									function (otherUser) {
										return _Utils_update(
											otherUser,
											{
												publicKey: $elm$core$Maybe$Just(publicKey)
											});
									},
									localUser.otherUsers)
							})
					});
			case 105:
				var id = serverChange.a;
				var time = serverChange.b;
				return $author$project$LocalState$setDmE2ee$(
					id,
					$author$project$DmChannel$E2eeEnabled(
						{
							enabledAt: time,
							requestedBy: _Utils_Tuple2(local.localUser.session.userId, local.localUser.session.sessionIdHash)
						}),
					local);
			case 107:
				var repliedToData = serverChange.a.repliedToData;
				var threadRoute = serverChange.a.threadRoute;
				var content = serverChange.a.content;
				var fileHashes = serverChange.a.fileHashes;
				var id = serverChange.a.id;
				var sentAt = serverChange.a.sentAt;
				var sender = serverChange.a.sender;
				var senderId = serverChange.a.senderId;
				return $author$project$FrontendExtra$handleServerSendDmMessage$(
					id,
					$author$project$FrontendExtra$addRepliedToData$(
						threadRoute,
						repliedToData,
						$author$project$FrontendExtra$frontendDmChannel$(id, local)),
					senderId,
					sender,
					$lamdera$containers$SeqDict$empty,
					function (repliedTo) {
						return $author$project$Message$encryptedUserTextMessageFrontend$(sentAt, senderId, fileHashes, content, repliedTo);
					},
					function (maybeReplyTo) {
						return $author$project$Message$encryptedUserTextMessageFrontend$(
							sentAt,
							senderId,
							fileHashes,
							content,
							$author$project$Message$maybeToReply(maybeReplyTo));
					},
					threadRoute,
					local);
			case 108:
				var editedAt = serverChange.a;
				var editedBy = serverChange.b;
				var id = serverChange.c;
				var threadRoute = serverChange.d;
				var fileHashes = serverChange.e;
				var content = serverChange.f;
				return $author$project$FrontendExtra$editEncryptedDmMessage$(editedAt, editedBy, id.otherUserId, threadRoute, fileHashes, content, local);
			default:
				var discordUserId = serverChange.a;
				var discordUser = serverChange.b;
				var localUser = local.localUser;
				return _Utils_update(
					local,
					{
						localUser: _Utils_update(
							localUser,
							{
								discordUsers: $author$project$LinkedAndOtherDiscordUsers$updateLinkedUser$(
									discordUserId,
									function (linkedUser) {
										return _Utils_update(
											linkedUser,
											{icon: discordUser.icon, name: discordUser.name});
									},
									$author$project$LinkedAndOtherDiscordUsers$addOtherUser$(discordUserId, discordUser, localUser.discordUsers))
							})
					});
		}
	}
};
var $author$project$FrontendExtra$changeUpdate = F2($author$project$FrontendExtra$changeUpdate$);
var $author$project$Local$increment = function (_v0) {
	var a = _v0;
	return a + 1;
};
var $author$project$Local$toInt = function (_v0) {
	var a = _v0;
	return a;
};
var $author$project$Local$update$ = function (userUpdate, time, msg, _v0) {
	var localModel_ = _v0;
	return _Utils_Tuple2(
		localModel_.counter,
		{
			counter: $author$project$Local$increment(localModel_.counter),
			localModel: A2(userUpdate, msg, localModel_.localModel),
			localMsgs: $elm$core$Dict$insert$(
				$author$project$Local$toInt(localModel_.counter),
				{createdAt: time, msg: msg},
				localModel_.localMsgs),
			serverModel: localModel_.serverModel
		});
};
var $author$project$Local$update = F4($author$project$Local$update$);
var $author$project$FrontendExtra$handleLocalChange$ = function (time, maybeLocalChange, loggedIn, cmds) {
	if (!maybeLocalChange.$) {
		var localChange = maybeLocalChange.a;
		var _v1 = $author$project$Local$update$(
			$author$project$FrontendExtra$changeUpdate,
			time,
			$author$project$Types$LocalChange$(
				$author$project$Local$model(loggedIn.localState).localUser.session.userId,
				localChange),
			loggedIn.localState);
		var changeId = _v1.a;
		var localState2 = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				loggedIn,
				{localState: localState2}),
			$lamdera$program_test$Effect$Command$batch(
				_List_fromArray(
					[
						cmds,
						$lamdera$program_test$Effect$Lamdera$sendToBackend(
						$author$project$Types$LocalModelChangeRequest$(changeId, localChange)),
						$author$project$GuildColumn$canChangeUnreadNotificationCount(localChange) ? $author$project$Ports$setAppBadge(
						$author$project$GuildColumn$unreadNotificationCount(
							$author$project$Local$model(localState2))) : $lamdera$program_test$Effect$Command$none
					])));
	} else {
		return _Utils_Tuple2(loggedIn, cmds);
	}
};
var $author$project$FrontendExtra$handleLocalChange = F4($author$project$FrontendExtra$handleLocalChange$);
var $author$project$Game$isNotLoaded = function (matchData) {
	if (!matchData.$) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Types$Local_Discord_LoadChannelMessages$ = function (a, b, c) {
	return {$: 33, a: a, b: b, c: c};
};
var $author$project$Types$Local_Discord_LoadChannelMessages = F3($author$project$Types$Local_Discord_LoadChannelMessages$);
var $author$project$Types$Local_Discord_LoadThreadMessages$ = function (a, b, c, d) {
	return {$: 34, a: a, b: b, c: c, d: d};
};
var $author$project$Types$Local_Discord_LoadThreadMessages = F4($author$project$Types$Local_Discord_LoadThreadMessages$);
var $author$project$Types$Local_LoadChannelMessages$ = function (a, b, c) {
	return {$: 29, a: a, b: b, c: c};
};
var $author$project$Types$Local_LoadChannelMessages = F3($author$project$Types$Local_LoadChannelMessages$);
var $author$project$Types$Local_LoadThreadMessages$ = function (a, b, c, d) {
	return {$: 30, a: a, b: b, c: c, d: d};
};
var $author$project$Types$Local_LoadThreadMessages = F4($author$project$Types$Local_LoadThreadMessages$);
var $author$project$Types$Local_Slack_LoadChannelMessages$ = function (a, b, c) {
	return {$: 31, a: a, b: b, c: c};
};
var $author$project$Types$Local_Slack_LoadChannelMessages = F3($author$project$Types$Local_Slack_LoadChannelMessages$);
var $author$project$Types$Local_Slack_LoadThreadMessages$ = function (a, b, c, d) {
	return {$: 32, a: a, b: b, c: c, d: d};
};
var $author$project$Types$Local_Slack_LoadThreadMessages = F4($author$project$Types$Local_Slack_LoadThreadMessages$);
var $author$project$VisibleMessages$PageFrom = function (a) {
	return {$: 1, a: a};
};
var $author$project$FrontendExtra$ChannelWindow$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $author$project$FrontendExtra$ChannelWindow = F3($author$project$FrontendExtra$ChannelWindow$);
var $author$project$FrontendExtra$DiscordChannelWindow$ = function (a, b, c) {
	return {$: 2, a: a, b: b, c: c};
};
var $author$project$FrontendExtra$DiscordChannelWindow = F3($author$project$FrontendExtra$DiscordChannelWindow$);
var $author$project$FrontendExtra$DiscordThreadWindow$ = function (a, b, c, d) {
	return {$: 3, a: a, b: b, c: c, d: d};
};
var $author$project$FrontendExtra$DiscordThreadWindow = F4($author$project$FrontendExtra$DiscordThreadWindow$);
var $author$project$FrontendExtra$SlackChannelWindow$ = function (a, b, c) {
	return {$: 4, a: a, b: b, c: c};
};
var $author$project$FrontendExtra$SlackChannelWindow = F3($author$project$FrontendExtra$SlackChannelWindow$);
var $author$project$FrontendExtra$SlackThreadWindow$ = function (a, b, c, d) {
	return {$: 5, a: a, b: b, c: c, d: d};
};
var $author$project$FrontendExtra$SlackThreadWindow = F4($author$project$FrontendExtra$SlackThreadWindow$);
var $author$project$FrontendExtra$ThreadWindow$ = function (a, b, c, d) {
	return {$: 1, a: a, b: b, c: c, d: d};
};
var $author$project$FrontendExtra$ThreadWindow = F4($author$project$FrontendExtra$ThreadWindow$);
var $author$project$Thread$discordFrontendInit = {dateDividerDrawings: $lamdera$containers$SeqDict$empty, messages: $author$project$MessageArray$empty, visibleMessages: $author$project$VisibleMessages$empty};
var $author$project$FrontendExtra$conversationWindow$ = function (guildOrDmId, threadRoute, local) {
	switch (guildOrDmId.$) {
		case 0:
			if (!guildOrDmId.a.$) {
				var guildOrDmId2 = guildOrDmId.a;
				var channelId = guildOrDmId2.a.channelId;
				var guildId = guildOrDmId2.a.guildId;
				var _v1 = $author$project$LocalState$getGuildAndChannel$(
					{channelId: channelId, guildId: guildId},
					local);
				if (!_v1.$) {
					var _v2 = _v1.a;
					var channel = _v2.b;
					if (!threadRoute.$) {
						return $elm$core$Maybe$Just(
							$author$project$FrontendExtra$ChannelWindow$(
								guildOrDmId2,
								channel.visibleMessages,
								$author$project$MessageArray$length(channel.messages)));
					} else {
						var threadId = threadRoute.a;
						var thread = $elm$core$Maybe$withDefault$(
							$author$project$Thread$frontendInit,
							$lamdera$containers$SeqDict$get$(threadId, channel.threads));
						return $elm$core$Maybe$Just(
							$author$project$FrontendExtra$ThreadWindow$(
								guildOrDmId2,
								threadId,
								thread.visibleMessages,
								$author$project$MessageArray$length(thread.messages)));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				var guildOrDmId2 = guildOrDmId.a;
				var otherUserId = guildOrDmId2.a.otherUserId;
				var dmChannel = $elm$core$Maybe$withDefault$(
					$author$project$DmChannel$frontendInit,
					$lamdera$containers$SeqDict$get$(otherUserId, local.dmChannels));
				if (!threadRoute.$) {
					return $elm$core$Maybe$Just(
						$author$project$FrontendExtra$ChannelWindow$(
							guildOrDmId2,
							dmChannel.visibleMessages,
							$author$project$MessageArray$length(dmChannel.messages)));
				} else {
					var threadId = threadRoute.a;
					var thread = $elm$core$Maybe$withDefault$(
						$author$project$Thread$frontendInit,
						$lamdera$containers$SeqDict$get$(threadId, dmChannel.threads));
					return $elm$core$Maybe$Just(
						$author$project$FrontendExtra$ThreadWindow$(
							guildOrDmId2,
							threadId,
							thread.visibleMessages,
							$author$project$MessageArray$length(thread.messages)));
				}
			}
		case 1:
			if (!guildOrDmId.a.$) {
				var guildOrDmId2 = guildOrDmId.a;
				var channelId = guildOrDmId2.a.channelId;
				var guildId = guildOrDmId2.a.guildId;
				var _v5 = $author$project$LocalState$getDiscordGuildAndChannel$(guildId, channelId, local);
				if (!_v5.$) {
					var _v6 = _v5.a;
					var channel = _v6.b;
					if (!threadRoute.$) {
						return $elm$core$Maybe$Just(
							$author$project$FrontendExtra$DiscordChannelWindow$(
								guildOrDmId2,
								channel.visibleMessages,
								$author$project$MessageArray$length(channel.messages)));
					} else {
						var threadId = threadRoute.a;
						var thread = $elm$core$Maybe$withDefault$(
							$author$project$Thread$discordFrontendInit,
							$lamdera$containers$SeqDict$get$(threadId, channel.threads));
						return $elm$core$Maybe$Just(
							$author$project$FrontendExtra$DiscordThreadWindow$(
								guildOrDmId2,
								threadId,
								thread.visibleMessages,
								$author$project$MessageArray$length(thread.messages)));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				var guildOrDmId2 = guildOrDmId.a;
				var data = guildOrDmId2.a;
				var _v8 = $lamdera$containers$SeqDict$get$(data.channelId, local.discordDmChannels);
				if (!_v8.$) {
					var dmChannel = _v8.a;
					return $elm$core$Maybe$Just(
						$author$project$FrontendExtra$DiscordChannelWindow$(
							guildOrDmId2,
							dmChannel.visibleMessages,
							$author$project$MessageArray$length(dmChannel.messages)));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		default:
			if (!guildOrDmId.a.$) {
				var guildOrDmId2 = guildOrDmId.a;
				var channelId = guildOrDmId2.a.channelId;
				var teamId = guildOrDmId2.a.teamId;
				var _v9 = $author$project$LocalState$getSlackWorkspaceAndChannel$(teamId, channelId, local);
				if (!_v9.$) {
					var _v10 = _v9.a;
					var channel = _v10.b;
					if (!threadRoute.$) {
						return $elm$core$Maybe$Just(
							$author$project$FrontendExtra$SlackChannelWindow$(
								guildOrDmId2,
								channel.visibleMessages,
								$author$project$MessageArray$length(channel.messages)));
					} else {
						var threadId = threadRoute.a;
						var thread = $elm$core$Maybe$withDefault$(
							$author$project$Thread$frontendInit,
							$lamdera$containers$SeqDict$get$(threadId, channel.threads));
						return $elm$core$Maybe$Just(
							$author$project$FrontendExtra$SlackThreadWindow$(
								guildOrDmId2,
								threadId,
								thread.visibleMessages,
								$author$project$MessageArray$length(thread.messages)));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				var guildOrDmId2 = guildOrDmId.a;
				var data = guildOrDmId2.a;
				var _v12 = $lamdera$containers$SeqDict$get$(data.channelId, local.slackDmChannels);
				if (!_v12.$) {
					var dmChannel = _v12.a;
					if (!threadRoute.$) {
						return $elm$core$Maybe$Just(
							$author$project$FrontendExtra$SlackChannelWindow$(
								guildOrDmId2,
								dmChannel.visibleMessages,
								$author$project$MessageArray$length(dmChannel.messages)));
					} else {
						var threadId = threadRoute.a;
						var thread = $elm$core$Maybe$withDefault$(
							$author$project$Thread$frontendInit,
							$lamdera$containers$SeqDict$get$(threadId, dmChannel.threads));
						return $elm$core$Maybe$Just(
							$author$project$FrontendExtra$SlackThreadWindow$(
								guildOrDmId2,
								threadId,
								thread.visibleMessages,
								$author$project$MessageArray$length(thread.messages)));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
	}
};
var $author$project$FrontendExtra$conversationWindow = F3($author$project$FrontendExtra$conversationWindow$);
var $author$project$FrontendExtra$jumpToNewestMessages$ = function (guildOrDmId, threadRoute, local) {
	var newestPage = function (messageCount) {
		return $author$project$VisibleMessages$PageFrom(
			$author$project$Id$fromInt(
				$elm$core$Basics$max$(0, messageCount - $author$project$VisibleMessages$pageSize)));
	};
	var ifNotAtEnd = F3(
		function (visibleMessages, messageCount, localChange) {
			return ($author$project$VisibleMessages$reachesEnd$(messageCount, visibleMessages) || (!visibleMessages.count)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(localChange);
		});
	var _v0 = $author$project$FrontendExtra$conversationWindow$(guildOrDmId, threadRoute, local);
	if (!_v0.$) {
		switch (_v0.a.$) {
			case 0:
				var _v1 = _v0.a;
				var guildOrDmId2 = _v1.a;
				var visibleMessages = _v1.b;
				var messageCount = _v1.c;
				return A3(
					ifNotAtEnd,
					visibleMessages,
					messageCount,
					$author$project$Types$Local_LoadChannelMessages$(
						guildOrDmId2,
						newestPage(messageCount),
						$author$project$UserSession$EmptyPlaceholder));
			case 1:
				var _v2 = _v0.a;
				var guildOrDmId2 = _v2.a;
				var threadId = _v2.b;
				var visibleMessages = _v2.c;
				var messageCount = _v2.d;
				return A3(
					ifNotAtEnd,
					visibleMessages,
					messageCount,
					$author$project$Types$Local_LoadThreadMessages$(
						guildOrDmId2,
						threadId,
						newestPage(messageCount),
						$author$project$UserSession$EmptyPlaceholder));
			case 2:
				var _v3 = _v0.a;
				var guildOrDmId2 = _v3.a;
				var visibleMessages = _v3.b;
				var messageCount = _v3.c;
				return A3(
					ifNotAtEnd,
					visibleMessages,
					messageCount,
					$author$project$Types$Local_Discord_LoadChannelMessages$(
						guildOrDmId2,
						newestPage(messageCount),
						$author$project$UserSession$EmptyPlaceholder));
			case 3:
				var _v4 = _v0.a;
				var guildOrDmId2 = _v4.a;
				var threadId = _v4.b;
				var visibleMessages = _v4.c;
				var messageCount = _v4.d;
				return A3(
					ifNotAtEnd,
					visibleMessages,
					messageCount,
					$author$project$Types$Local_Discord_LoadThreadMessages$(
						guildOrDmId2,
						threadId,
						newestPage(messageCount),
						$author$project$UserSession$EmptyPlaceholder));
			case 4:
				var _v5 = _v0.a;
				var guildOrDmId2 = _v5.a;
				var visibleMessages = _v5.b;
				var messageCount = _v5.c;
				return A3(
					ifNotAtEnd,
					visibleMessages,
					messageCount,
					$author$project$Types$Local_Slack_LoadChannelMessages$(
						guildOrDmId2,
						newestPage(messageCount),
						$author$project$UserSession$EmptyPlaceholder));
			default:
				var _v6 = _v0.a;
				var guildOrDmId2 = _v6.a;
				var threadId = _v6.b;
				var visibleMessages = _v6.c;
				var messageCount = _v6.d;
				return A3(
					ifNotAtEnd,
					visibleMessages,
					messageCount,
					$author$project$Types$Local_Slack_LoadThreadMessages$(
						guildOrDmId2,
						threadId,
						newestPage(messageCount),
						$author$project$UserSession$EmptyPlaceholder));
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$FrontendExtra$jumpToNewestMessages = F3($author$project$FrontendExtra$jumpToNewestMessages$);
var $author$project$FrontendExtra$jumpToNewest$ = function (time, guildOrDmId, threadRoute, loggedIn) {
	var _v0 = $author$project$FrontendExtra$jumpToNewestMessages$(
		guildOrDmId,
		threadRoute,
		$author$project$Local$model(loggedIn.localState));
	if (!_v0.$) {
		var localChange = _v0.a;
		return $author$project$FrontendExtra$handleLocalChange$(
			time,
			$elm$core$Maybe$Just(localChange),
			_Utils_update(
				loggedIn,
				{channelScrollPosition: 0}),
			$lamdera$program_test$Effect$Command$none);
	} else {
		return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
	}
};
var $author$project$FrontendExtra$jumpToNewest = F4($author$project$FrontendExtra$jumpToNewest$);
var $ianmackenzie$elm_units$Duration$millisecond = $ianmackenzie$elm_units$Duration$milliseconds(1);
var $author$project$WordSpellingGame$pastWordsContainerId = $lamdera$program_test$Effect$Browser$Dom$id('wsg_pastWords');
var $author$project$SheepGame$AnswerReaction$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$SheepGame$AnswerReaction = F2($author$project$SheepGame$AnswerReaction$);
var $author$project$WordSpellingGame$MoveReaction = $elm$core$Basics$identity;
var $author$project$SheepGame$NotesReaction = function (a) {
	return {$: 1, a: a};
};
var $author$project$SheepGame$gameViewId = $lamdera$program_test$Effect$Browser$Dom$id('sheepGame_tabBody');
var $author$project$SheepGame$reactionTargetId = function (target) {
	if (!target.$) {
		var userId = target.a;
		var questionId = target.b;
		return $lamdera$program_test$Effect$Browser$Dom$id(
			'sheepGame_revealedAnswer_' + ($author$project$Id$toString(questionId) + ('_' + $author$project$Id$toString(userId))));
	} else {
		var questionId = target.a;
		return $lamdera$program_test$Effect$Browser$Dom$id(
			'sheepGame_revealedNotes_' + $author$project$Id$toString(questionId));
	}
};
var $author$project$WordSpellingGame$reactionTargetId = function (target) {
	var moveNumber = target;
	return $lamdera$program_test$Effect$Browser$Dom$id(
		'wordSpellingGame_move_' + $elm$core$String$fromInt(moveNumber));
};
var $author$project$Game$replyScrollTo = function (repliedTo) {
	switch (repliedTo.$) {
		case 0:
			var moveNumber = repliedTo.a;
			return {
				container: $author$project$WordSpellingGame$pastWordsContainerId,
				target: $author$project$WordSpellingGame$reactionTargetId(moveNumber)
			};
		case 1:
			var userId = repliedTo.a;
			var questionId = repliedTo.b;
			return {
				container: $author$project$SheepGame$gameViewId,
				target: $author$project$SheepGame$reactionTargetId(
					$author$project$SheepGame$AnswerReaction$(userId, questionId))
			};
		default:
			var questionId = repliedTo.a;
			return {
				container: $author$project$SheepGame$gameViewId,
				target: $author$project$SheepGame$reactionTargetId(
					$author$project$SheepGame$NotesReaction(questionId))
			};
	}
};
var $author$project$Game$GoModel_Game = function (a) {
	return {$: 0, a: a};
};
var $author$project$Game$SheepGame_Game = function (a) {
	return {$: 2, a: a};
};
var $author$project$Game$WordSpellingGame_Game = function (a) {
	return {$: 1, a: a};
};
var $author$project$Go$initGame = {lastError: $elm$core$Maybe$Nothing, lastPlacedStone: $elm$core$Maybe$Nothing, viewingMovesBack: 0};
var $author$project$SheepGame$emptyInput = {attachedFiles: $lamdera$containers$SeqDict$empty, text: ''};
var $author$project$FileStatus$FileUploaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$SheepGame$toSourceText$ = function (localUser, content) {
	return $author$project$RichText$toString$(
		localUser.timezone,
		false,
		$author$project$User$allUsers(localUser),
		$lamdera$containers$SeqDict$empty,
		content);
};
var $author$project$SheepGame$toSourceText = F2($author$project$SheepGame$toSourceText$);
var $author$project$SheepGame$toDraft$ = function (localUser, saved) {
	if (!saved.$) {
		var saved2 = saved.a;
		return {
			attachedFiles: $lamdera$containers$SeqDict$map$(
				F2(
					function (_v1, fileData) {
						return $author$project$FileStatus$FileUploaded(fileData);
					}),
				saved2.attachedFiles),
			text: $author$project$SheepGame$toSourceText$(localUser, saved2.text)
		};
	} else {
		return $author$project$SheepGame$emptyInput;
	}
};
var $author$project$SheepGame$toDraft = F2($author$project$SheepGame$toDraft$);
var $author$project$SheepGame$initGame$ = function (localUser, setup, shared) {
	return {
		answerDrafts: $author$project$IdArray$fromList(
			function () {
				var _v0 = $lamdera$containers$SeqDict$get$(localUser.session.userId, shared.answers);
				if (!_v0.$) {
					var answers = _v0.a;
					return $elm$core$List$map$(
						$author$project$SheepGame$toDraft(localUser),
						$author$project$IdArray$toList(answers));
				} else {
					return $elm$core$List$repeat$(
						$mgold$elm_nonempty_list$List$Nonempty$length(setup.questions),
						$author$project$SheepGame$emptyInput);
				}
			}()),
		gridHovered: $elm$core$Maybe$Nothing,
		hoveredQuestion: $elm$core$Maybe$Nothing,
		hoveredResult: $elm$core$Maybe$Nothing,
		newQuestionRevealed: false,
		noteDrafts: $author$project$IdArray$fromList(
			$elm$core$List$map$(
				function (index) {
					return $author$project$SheepGame$toDraft$(
						localUser,
						$elm$core$Maybe$withDefault$(
							$elm$core$Maybe$Nothing,
							$lamdera$containers$SeqDict$get$(
								$author$project$Id$fromInt(index),
								shared.notes)));
				},
				$elm$core$List$range$(
					0,
					$mgold$elm_nonempty_list$List$Nonempty$length(setup.questions) - 1))),
		questionsRevealedSeen: shared.questionsRevealed,
		scrollPosition: 0
	};
};
var $author$project$SheepGame$initGame = F3($author$project$SheepGame$initGame$);
var $author$project$WordSpellingGame$NotDragging = {$: 1};
var $author$project$WordSpellingGame$TileInTray$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$WordSpellingGame$TileInTray = F2($author$project$WordSpellingGame$TileInTray$);
var $author$project$WordSpellingGame$TileOnBoard$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$WordSpellingGame$TileOnBoard = F2($author$project$WordSpellingGame$TileOnBoard$);
var $author$project$WordSpellingGame$TrayIndex = $elm$core$Basics$identity;
var $author$project$WordSpellingGame$WordDefinition_None = {$: 0};
var $elmcraft$core_extra$List$Extra$getAt$ = function (idx, xs) {
	return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
		$elm$core$List$drop$(idx, xs));
};
var $elmcraft$core_extra$List$Extra$getAt = F2($elmcraft$core_extra$List$Extra$getAt$);
var $elmcraft$core_extra$List$Extra$removeAt$ = function (index, l) {
	if (index < 0) {
		return l;
	} else {
		var _v0 = $elm$core$List$drop$(index, l);
		if (!_v0.b) {
			return l;
		} else {
			var rest = _v0.b;
			return _Utils_ap(
				$elm$core$List$take$(index, l),
				rest);
		}
	}
};
var $elmcraft$core_extra$List$Extra$removeAt = F2($elmcraft$core_extra$List$Extra$removeAt$);
var $author$project$WordSpellingGame$initGame$ = function (time, currentUserId, setup, shared) {
	var maybePlayer = $author$project$WordSpellingGame$getPlayer$(currentUserId, shared);
	var list = $elm$core$List$range$(
		0,
		$author$project$OneOrGreater$toInt(setup.traySize) - 1);
	var letters = function () {
		if (!maybePlayer.$) {
			var player = maybePlayer.a;
			return player.tray;
		} else {
			return $author$project$IdArray$empty;
		}
	}();
	return {
		dragging: $author$project$WordSpellingGame$NotDragging,
		highlightedPlayer: $elm$core$Maybe$Nothing,
		hoveredMove: $elm$core$Maybe$Nothing,
		lastWordPlaced: $elm$core$Maybe$Nothing,
		scrollPosition: 0,
		selectedCell: $elm$core$Maybe$Nothing,
		showSettings: false,
		tiles: $elm$core$Array$fromList(
			$elm$core$List$reverse(
				$elm$core$List$foldl$(
					F2(
						function (index, _v0) {
							var list2 = _v0.a;
							var premoveTiles = _v0.b;
							var createdAt = $ianmackenzie$elm_units$Duration$addTo$(
								time,
								$ianmackenzie$elm_units$Duration$seconds(0.2 * index));
							var trayTile = _Utils_Tuple2(
								A2(
									$elm$core$List$cons,
									{
										createdAt: createdAt,
										position: $author$project$WordSpellingGame$TileInTray$(index, $elm$core$Maybe$Nothing)
									},
									list2),
								premoveTiles);
							var _v1 = $author$project$IdArray$get$(
								$author$project$Id$fromInt(index),
								letters);
							if (!_v1.$) {
								var letter = _v1.a;
								var _v2 = A2(
									$elmcraft$core_extra$List$Extra$findIndex,
									function (_v3) {
										var tile = _v3.b;
										return _Utils_eq(tile, letter);
									},
									premoveTiles);
								if (!_v2.$) {
									var tileIndex = _v2.a;
									var _v4 = $elmcraft$core_extra$List$Extra$getAt$(tileIndex, premoveTiles);
									if (!_v4.$) {
										var _v5 = _v4.a;
										var position = _v5.a;
										return _Utils_Tuple2(
											A2(
												$elm$core$List$cons,
												{
													createdAt: createdAt,
													position: $author$project$WordSpellingGame$TileOnBoard$(position, createdAt)
												},
												list2),
											$elmcraft$core_extra$List$Extra$removeAt$(tileIndex, premoveTiles));
									} else {
										return trayTile;
									}
								} else {
									return trayTile;
								}
							} else {
								return trayTile;
							}
						}),
					_Utils_Tuple2(
						_List_Nil,
						function () {
							if (!maybePlayer.$) {
								var player = maybePlayer.a;
								var _v7 = player.premove;
								if (!_v7.$) {
									var _v8 = _v7.a;
									var result = _v8.b;
									return result.placedCells;
								} else {
									return _List_Nil;
								}
							} else {
								return _List_Nil;
							}
						}()),
					list).a)),
		wordDefinition: $author$project$WordSpellingGame$WordDefinition_None,
		zoomAnimation: {from: $author$project$WordSpellingGame$zoomedOutState, start: time}
	};
};
var $author$project$WordSpellingGame$initGame = F4($author$project$WordSpellingGame$initGame$);
var $author$project$Game$routeRequest$ = function (time, localUser, guildOrDmId, matchId, matchData, models) {
	var currentUserId = localUser.session.userId;
	var _v0 = $lamdera$containers$SeqDict$get$(matchId, matchData);
	if (!_v0.$) {
		if (!_v0.a.$) {
			var matchData2 = _v0.a.a;
			return $lamdera$containers$SeqDict$update$(
				guildOrDmId,
				function (maybeModel) {
					var model = $elm$core$Maybe$withDefault$($author$project$Game$initModel, maybeModel);
					return $elm$core$Maybe$Just(
						function () {
							var _v1 = matchData2.data;
							switch (_v1.$) {
								case 0:
									return _Utils_update(
										model,
										{
											startedGames: $lamdera$containers$SeqDict$update$(
												matchId,
												function (maybeGame) {
													if (!maybeGame.$) {
														return maybeGame;
													} else {
														return $elm$core$Maybe$Just(
															$author$project$Game$GoModel_Game($author$project$Go$initGame));
													}
												},
												model.startedGames)
										});
								case 1:
									var setup = _v1.a;
									var shared = _v1.c;
									return _Utils_update(
										model,
										{
											startedGames: $lamdera$containers$SeqDict$update$(
												matchId,
												function (maybeGame) {
													if (!maybeGame.$) {
														return maybeGame;
													} else {
														return $elm$core$Maybe$Just(
															$author$project$Game$WordSpellingGame_Game(
																$author$project$WordSpellingGame$initGame$(time, currentUserId, setup, shared)));
													}
												},
												model.startedGames)
										});
								default:
									var setup = _v1.a;
									var shared = _v1.c;
									return _Utils_update(
										model,
										{
											startedGames: $lamdera$containers$SeqDict$update$(
												matchId,
												function (maybeGame) {
													if (!maybeGame.$) {
														return maybeGame;
													} else {
														return $elm$core$Maybe$Just(
															$author$project$Game$SheepGame_Game(
																$author$project$SheepGame$initGame$(localUser, setup, shared)));
													}
												},
												model.startedGames)
										});
							}
						}());
				},
				models);
		} else {
			return models;
		}
	} else {
		return models;
	}
};
var $author$project$Game$routeRequest = F6($author$project$Game$routeRequest$);
var $lamdera$program_test$Effect$Browser$Dom$focus = function (htmlId) {
	return $lamdera$program_test$Effect$Internal$Focus$(
		$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId),
		function (result) {
			if (!result.$) {
				var ok = result.a;
				return $lamdera$program_test$Effect$Internal$Succeed(ok);
			} else {
				var err = result.a;
				return $lamdera$program_test$Effect$Internal$Fail(
					$lamdera$program_test$Effect$Browser$Dom$id(err));
			}
		});
};
var $author$project$FrontendExtra$setFocus$ = function (model, htmlId) {
	return $author$project$MyUi$isMobile(model) ? $lamdera$program_test$Effect$Command$none : $lamdera$program_test$Effect$Task$attempt$(
		function (_v0) {
			return $author$project$Types$SetFocus;
		},
		$lamdera$program_test$Effect$Browser$Dom$focus(htmlId));
};
var $author$project$FrontendExtra$setFocus = F2($author$project$FrontendExtra$setFocus$);
var $lamdera$program_test$Effect$Browser$Dom$setViewportOf$ = function (htmlId, x, y) {
	return $lamdera$program_test$Effect$Internal$SetViewportOf$(
		$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId),
		x,
		y,
		function (result) {
			if (!result.$) {
				var ok = result.a;
				return $lamdera$program_test$Effect$Internal$Succeed(ok);
			} else {
				var err = result.a;
				return $lamdera$program_test$Effect$Internal$Fail(
					$lamdera$program_test$Effect$Browser$Dom$id(err));
			}
		});
};
var $lamdera$program_test$Effect$Browser$Dom$setViewportOf = F3($lamdera$program_test$Effect$Browser$Dom$setViewportOf$);
var $lamdera$program_test$Effect$Process$sleep = function (duration) {
	return $lamdera$program_test$Effect$Internal$SleepTask$(duration, $lamdera$program_test$Effect$Internal$Succeed);
};
var $author$project$MyUi$channelHeaderHeight = 38;
var $lamdera$program_test$Effect$Browser$Dom$getViewportOf = function (htmlId) {
	return $lamdera$program_test$Effect$Internal$GetViewportOf$(
		$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId),
		function (result) {
			if (!result.$) {
				var ok = result.a;
				return $lamdera$program_test$Effect$Internal$Succeed(ok);
			} else {
				var err = result.a;
				return $lamdera$program_test$Effect$Internal$Fail(
					$lamdera$program_test$Effect$Browser$Dom$id(err));
			}
		});
};
var $lamdera$program_test$Effect$Task$map2$ = function (func, taskA, taskB) {
	return A2(
		$lamdera$program_test$Effect$Task$andThen,
		function (a) {
			return A2(
				$lamdera$program_test$Effect$Task$andThen,
				function (b) {
					return $lamdera$program_test$Effect$Task$succeed(
						A2(func, a, b));
				},
				taskB);
		},
		taskA);
};
var $lamdera$program_test$Effect$Task$map2 = F3($lamdera$program_test$Effect$Task$map2$);
var $elm_community$easing_functions$Ease$inOut$ = function (e1, e2, time) {
	return (time < 0.5) ? (e1(time * 2) / 2) : (0.5 + (e2((time - 0.5) * 2) / 2));
};
var $elm_community$easing_functions$Ease$inOut = F3($elm_community$easing_functions$Ease$inOut$);
var $elm_community$easing_functions$Ease$inQuart = function (time) {
	return A2($elm$core$Basics$pow, time, 4);
};
var $elm_community$easing_functions$Ease$flip$ = function (easing, time) {
	return 1 - easing(1 - time);
};
var $elm_community$easing_functions$Ease$flip = F2($elm_community$easing_functions$Ease$flip$);
var $elm_community$easing_functions$Ease$outQuart = $elm_community$easing_functions$Ease$flip($elm_community$easing_functions$Ease$inQuart);
var $elm_community$easing_functions$Ease$inOutQuart = A2($elm_community$easing_functions$Ease$inOut, $elm_community$easing_functions$Ease$inQuart, $elm_community$easing_functions$Ease$outQuart);
var $author$project$Scroll$smoothScrollSteps = 30;
var $author$project$Scroll$smoothScrollY$ = function (conversationContainerId, stepCount, x, startY, endY) {
	var t = $elm_community$easing_functions$Ease$inOutQuart(stepCount / $author$project$Scroll$smoothScrollSteps);
	var y = startY + ((endY - startY) * t);
	return (_Utils_cmp(stepCount, $author$project$Scroll$smoothScrollSteps) > 0) ? $lamdera$program_test$Effect$Task$succeed(0) : A2(
		$lamdera$program_test$Effect$Task$andThen,
		function (_v0) {
			return $author$project$Scroll$smoothScrollY$(conversationContainerId, stepCount + 1, x, startY, endY);
		},
		$lamdera$program_test$Effect$Browser$Dom$setViewportOf$(conversationContainerId, x, y));
};
var $author$project$Scroll$smoothScrollY = F5($author$project$Scroll$smoothScrollY$);
var $author$project$Scroll$smoothScroll$ = function (conversationContainerId, targetId) {
	return A2(
		$lamdera$program_test$Effect$Task$andThen,
		function (_v0) {
			var element = _v0.a.element;
			var viewport = _v0.b.viewport;
			return (element.y > 0) ? $lamdera$program_test$Effect$Browser$Dom$setViewportOf$(conversationContainerId, 0, (viewport.y + element.y) - $author$project$MyUi$channelHeaderHeight) : $author$project$Scroll$smoothScrollY$(conversationContainerId, 0, viewport.x, viewport.y, (viewport.y + element.y) - $author$project$MyUi$channelHeaderHeight);
		},
		$lamdera$program_test$Effect$Task$map2$(
			$elm$core$Tuple$pair,
			$lamdera$program_test$Effect$Browser$Dom$getElement(targetId),
			$lamdera$program_test$Effect$Browser$Dom$getViewportOf(conversationContainerId)));
};
var $author$project$Scroll$smoothScroll = F2($author$project$Scroll$smoothScroll$);
var $author$project$Scroll$smoothScrollTo$ = function (conversationContainerId, targetId) {
	return A2(
		$lamdera$program_test$Effect$Task$andThen,
		function (_v0) {
			var element = _v0.a.element;
			var viewport = _v0.b.viewport;
			return $author$project$Scroll$smoothScrollY$(conversationContainerId, 0, viewport.x, viewport.y, (viewport.y + element.y) - $author$project$MyUi$channelHeaderHeight);
		},
		$lamdera$program_test$Effect$Task$map2$(
			$elm$core$Tuple$pair,
			$lamdera$program_test$Effect$Browser$Dom$getElement(targetId),
			$lamdera$program_test$Effect$Browser$Dom$getViewportOf(conversationContainerId)));
};
var $author$project$Scroll$smoothScrollTo = F2($author$project$Scroll$smoothScrollTo$);
var $lamdera$program_test$Effect$Task$map3$ = function (func, taskA, taskB, taskC) {
	return A2(
		$lamdera$program_test$Effect$Task$andThen,
		function (a) {
			return A2(
				$lamdera$program_test$Effect$Task$andThen,
				function (b) {
					return A2(
						$lamdera$program_test$Effect$Task$andThen,
						function (c) {
							return $lamdera$program_test$Effect$Task$succeed(
								A3(func, a, b, c));
						},
						taskC);
				},
				taskB);
		},
		taskA);
};
var $lamdera$program_test$Effect$Task$map3 = F4($lamdera$program_test$Effect$Task$map3$);
var $author$project$Scroll$smoothScrollToCenterOf$ = function (containerId, targetId) {
	return A2(
		$lamdera$program_test$Effect$Task$andThen,
		$elm$core$Basics$identity,
		$lamdera$program_test$Effect$Task$map3$(
			F3(
				function (target, container, _v0) {
					var scene = _v0.scene;
					var viewport = _v0.viewport;
					var topOfTarget = (viewport.y + target.element.y) - container.element.y;
					var spaceToSpare = (viewport.height - target.element.height) / 2;
					return $author$project$Scroll$smoothScrollY$(
						containerId,
						0,
						viewport.x,
						viewport.y,
						$elm$core$Basics$clamp$(
							0,
							$elm$core$Basics$max$(0, scene.height - viewport.height),
							topOfTarget - spaceToSpare));
				}),
			$lamdera$program_test$Effect$Browser$Dom$getElement(targetId),
			$lamdera$program_test$Effect$Browser$Dom$getElement(containerId),
			$lamdera$program_test$Effect$Browser$Dom$getViewportOf(containerId)));
};
var $author$project$Scroll$smoothScrollToCenterOf = F2($author$project$Scroll$smoothScrollToCenterOf$);
var $author$project$Pages$Guild$threadMessageHtmlId = function (messageIndex) {
	return $lamdera$program_test$Effect$Browser$Dom$id(
		'thread_message_' + $author$project$Id$toString(messageIndex));
};
var $author$project$Scroll$toBottomOfChannel$ = function (conversationContainerId, setScrollToBottom) {
	return $lamdera$program_test$Effect$Task$attempt$(
		function (_v0) {
			return setScrollToBottom;
		},
		$lamdera$program_test$Effect$Browser$Dom$setViewportOf$(conversationContainerId, 0, 9999999));
};
var $author$project$Scroll$toBottomOfChannel = F2($author$project$Scroll$toBottomOfChannel$);
var $author$project$Scroll$toBottomOfChannelIfAtBottom$ = function (conversationContainerId, setScrollToBottom, position) {
	switch (position) {
		case 0:
			return $author$project$Scroll$toBottomOfChannel$(conversationContainerId, setScrollToBottom);
		case 1:
			return $lamdera$program_test$Effect$Command$none;
		case 2:
			return $lamdera$program_test$Effect$Command$none;
		default:
			return $lamdera$program_test$Effect$Command$none;
	}
};
var $author$project$Scroll$toBottomOfChannelIfAtBottom = F3($author$project$Scroll$toBottomOfChannelIfAtBottom$);
var $author$project$FrontendExtra$routeRequestChannelHelper$ = function (sameChannel, guildOrDmId, tab, threadRoute, local, loggedIn, model3) {
	var startsAtBottom = function () {
		if (sameChannel) {
			return false;
		} else {
			if (threadRoute.$ === 1) {
				var maybeMessageIndex = threadRoute.b;
				return _Utils_eq(maybeMessageIndex, $elm$core$Maybe$Nothing);
			} else {
				var maybeMessageIndex = threadRoute.a;
				return _Utils_eq(maybeMessageIndex, $elm$core$Maybe$Nothing);
			}
		}
	}();
	var _v0 = startsAtBottom ? $author$project$FrontendExtra$jumpToNewest$(
		model3.time,
		guildOrDmId,
		function () {
			if (threadRoute.$ === 1) {
				var threadId = threadRoute.a;
				return $author$project$Id$ViewThread(threadId);
			} else {
				return $author$project$Id$NoThread;
			}
		}(),
		_Utils_update(
			loggedIn,
			{channelScrollPosition: 0})) : _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
	var loggedIn2 = _v0.a;
	var jumpCmd = _v0.b;
	return $elm$core$Tuple$mapSecond$(
		function (loadCmd) {
			return $lamdera$program_test$Effect$Command$batch(
				_List_fromArray(
					[
						loadCmd,
						jumpCmd,
						$lamdera$program_test$Effect$Command$batch(
						_List_fromArray(
							[
								function () {
								if (sameChannel) {
									if (threadRoute.$ === 1) {
										if (!threadRoute.b.$) {
											var messageIndex = threadRoute.b.a;
											return $lamdera$program_test$Effect$Task$attempt$(
												function (_v6) {
													return $author$project$Types$ScrolledToMessage;
												},
												$author$project$Scroll$smoothScrollTo$(
													$author$project$Pages$Guild$conversationContainerId,
													$author$project$Pages$Guild$threadMessageHtmlId(messageIndex)));
										} else {
											var _v7 = threadRoute.b;
											return $author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn2.channelScrollPosition);
										}
									} else {
										if (!threadRoute.a.$) {
											var messageIndex = threadRoute.a.a;
											return $lamdera$program_test$Effect$Task$attempt$(
												function (_v8) {
													return $author$project$Types$ScrolledToMessage;
												},
												$author$project$Scroll$smoothScrollTo$(
													$author$project$Pages$Guild$conversationContainerId,
													$author$project$Pages$Guild$channelMessageHtmlId(messageIndex)));
										} else {
											var _v9 = threadRoute.a;
											return $author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn2.channelScrollPosition);
										}
									}
								} else {
									var scrollToBottom = $lamdera$program_test$Effect$Task$attempt$(
										function (_v16) {
											return $author$project$Types$SetScrollToBottom;
										},
										A2(
											$lamdera$program_test$Effect$Task$andThen,
											function (_v15) {
												return $lamdera$program_test$Effect$Browser$Dom$setViewportOf$($author$project$Pages$Guild$conversationContainerId, 0, 9999999);
											},
											$lamdera$program_test$Effect$Process$sleep($ianmackenzie$elm_units$Duration$millisecond)));
									return $lamdera$program_test$Effect$Command$batch(
										_List_fromArray(
											[
												$author$project$FrontendExtra$setFocus$(model3, $author$project$Pages$Guild$channelTextInputId),
												function () {
												if (threadRoute.$ === 1) {
													var maybeMessageIndex = threadRoute.b;
													if (!maybeMessageIndex.$) {
														var messageIndex = maybeMessageIndex.a;
														return $lamdera$program_test$Effect$Task$attempt$(
															function (_v12) {
																return $author$project$Types$ScrolledToMessage;
															},
															$author$project$Scroll$smoothScroll$(
																$author$project$Pages$Guild$conversationContainerId,
																$author$project$Pages$Guild$threadMessageHtmlId(messageIndex)));
													} else {
														return scrollToBottom;
													}
												} else {
													var maybeMessageIndex = threadRoute.a;
													if (!maybeMessageIndex.$) {
														var messageIndex = maybeMessageIndex.a;
														return $lamdera$program_test$Effect$Task$attempt$(
															function (_v14) {
																return $author$project$Types$ScrolledToMessage;
															},
															$author$project$Scroll$smoothScroll$(
																$author$project$Pages$Guild$conversationContainerId,
																$author$project$Pages$Guild$channelMessageHtmlId(messageIndex)));
													} else {
														return scrollToBottom;
													}
												}
											}()
											]));
								}
							}(),
								function () {
								if ((!tab.$) && (tab.a.$ === 1)) {
									if (!tab.a.b.$) {
										var _v18 = tab.a;
										var repliedTo = _v18.b.a;
										var scrollTo = $author$project$Game$replyScrollTo(repliedTo);
										return $lamdera$program_test$Effect$Task$attempt$(
											function (_v19) {
												return $author$project$Types$SetScrollToBottom;
											},
											$author$project$Scroll$smoothScrollToCenterOf$(scrollTo.container, scrollTo.target));
									} else {
										var _v20 = tab.a;
										var _v21 = _v20.b;
										return $lamdera$program_test$Effect$Task$attempt$(
											function (_v22) {
												return $author$project$Types$SetScrollToBottom;
											},
											$lamdera$program_test$Effect$Browser$Dom$setViewportOf$($author$project$WordSpellingGame$pastWordsContainerId, 0, 9999999));
									}
								} else {
									return $lamdera$program_test$Effect$Command$none;
								}
							}()
							]))
					]));
		},
		function () {
			var _v2 = _Utils_Tuple2(guildOrDmId, tab);
			if ((((!_v2.a.$) && (!_v2.b.$)) && (_v2.b.a.$ === 1)) && (!_v2.b.a.a.$)) {
				var guildOrDmId2 = _v2.a.a;
				var _v3 = _v2.b.a;
				var messageId = _v3.a.a;
				var games = $author$project$FrontendExtra$channelGames$(guildOrDmId2, local);
				return $author$project$FrontendExtra$handleLocalChange$(
					model3.time,
					function () {
						var _v4 = $lamdera$containers$SeqDict$get$(messageId, games);
						if (!_v4.$) {
							var match = _v4.a;
							return $author$project$Game$isNotLoaded(match) ? $elm$core$Maybe$Just(
								$author$project$Types$Local_Game$(
									guildOrDmId2,
									$author$project$Game$LoadMatch$(messageId, $author$project$UserSession$EmptyPlaceholder))) : $elm$core$Maybe$Nothing;
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}(),
					_Utils_update(
						loggedIn2,
						{
							games: $author$project$Game$routeRequest$(model3.time, local.localUser, guildOrDmId2, messageId, games, loggedIn2.games)
						}),
					$lamdera$program_test$Effect$Command$none);
			} else {
				return _Utils_Tuple2(loggedIn2, $lamdera$program_test$Effect$Command$none);
			}
		}());
};
var $author$project$FrontendExtra$routeRequestChannelHelper = F7($author$project$FrontendExtra$routeRequestChannelHelper$);
var $author$project$FrontendExtra$updateLoggedIn$ = function (updateFunc, model) {
	var _v0 = model.loginStatus;
	if (!_v0.$) {
		var loggedIn = _v0.a;
		return $elm$core$Tuple$mapFirst$(
			function (a) {
				return _Utils_update(
					model,
					{
						loginStatus: $author$project$Types$LoggedIn(a)
					});
			},
			updateFunc(loggedIn));
	} else {
		return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
	}
};
var $author$project$FrontendExtra$updateLoggedIn = F2($author$project$FrontendExtra$updateLoggedIn$);
var $author$project$FrontendExtra$enterChannelRoute$ = function (guildOrDmId, tab, threadRoute, sameChannel, viewCmd, model) {
	return $author$project$FrontendExtra$updateLoggedIn$(
		function (loggedIn) {
			return $elm$core$Tuple$mapSecond$(
				function (cmd) {
					return $lamdera$program_test$Effect$Command$batch(
						_List_fromArray(
							[viewCmd, cmd]));
				},
				$author$project$FrontendExtra$routeRequestChannelHelper$(
					sameChannel,
					guildOrDmId,
					tab,
					threadRoute,
					$author$project$Local$model(loggedIn.localState),
					loggedIn,
					model));
		},
		model);
};
var $author$project$FrontendExtra$enterChannelRoute = F6($author$project$FrontendExtra$enterChannelRoute$);
var $author$project$AiChat$GotAiModels = function (a) {
	return {$: 17, a: a};
};
var $author$project$AiChat$AiModel$ = function (id, inputs) {
	return {id: id, inputs: inputs};
};
var $author$project$AiChat$AiModel = F2($author$project$AiChat$AiModel$);
var $author$project$AiChat$AiModelName = $elm$core$Basics$identity;
var $elm$json$Json$Decode$at$ = function (fields, decoder) {
	return $elm$core$List$foldr$($elm$json$Json$Decode$field, decoder, fields);
};
var $elm$json$Json$Decode$at = F2($elm$json$Json$Decode$at$);
var $author$project$AiChat$decodeModels = A2(
	$elm$json$Json$Decode$field,
	'data',
	$elm$json$Json$Decode$list(
		A3(
			$elm$json$Json$Decode$map2,
			$author$project$AiChat$AiModel,
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Basics$identity,
				A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)),
			$elm$json$Json$Decode$at$(
				_List_fromArray(
					['architecture', 'input_modalities']),
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string)))));
var $author$project$AiChat$getModels = $lamdera$program_test$Effect$Http$get(
	{
		expect: $lamdera$program_test$Effect$Http$expectJson$($author$project$AiChat$GotAiModels, $author$project$AiChat$decodeModels),
		url: 'https://openrouter.ai/api/v1/models'
	});
var $author$project$Types$E2eeKeys_NotChecked = {$: 0};
var $author$project$RichText$domainToString = function (_v0) {
	var domain = _v0;
	return domain;
};
var $elm$core$List$sort = function (xs) {
	return A2($elm$core$List$sortBy, $elm$core$Basics$identity, xs);
};
var $author$project$UserOptions$domainWhitelistToString = function (domains) {
	return $elm$core$String$join$(
		', ',
		$elm$core$List$sort(
			$elm$core$List$map$(
				$author$project$RichText$domainToString,
				$lamdera$containers$SeqSet$toList(domains))));
};
var $author$project$UserOptions$init = function (domainWhitelist) {
	return {
		color: $elm$core$Maybe$Nothing,
		debugData: $elm$core$Maybe$Nothing,
		domainWhitelistInput: $author$project$UserOptions$domainWhitelistToString(domainWhitelist),
		e2eeKeysValid: $author$project$Types$E2eeKeys_NotChecked,
		linkSlackResult: $elm$core$Maybe$Nothing,
		name: $author$project$Editable$init,
		pressedSubmitSlackData: false,
		privateKeyText: '',
		removedSlackTeams: $lamdera$containers$SeqSet$empty,
		slackCookie: '',
		slackTeamsJson: ''
	};
};
var $author$project$SearchOverlay$inputId = $lamdera$program_test$Effect$Browser$Dom$id('searchOverlay_input');
var $author$project$Route$sameThread$ = function (threadRoute, previousThreadRoute) {
	var _v0 = _Utils_Tuple2(threadRoute, previousThreadRoute);
	_v0$2:
	while (true) {
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var _v2 = _v0.b;
				return true;
			} else {
				break _v0$2;
			}
		} else {
			if (_v0.b.$ === 1) {
				var _v3 = _v0.a;
				var threadId = _v3.a;
				var _v4 = _v0.b;
				var previousThreadId = _v4.a;
				return _Utils_eq(threadId, previousThreadId);
			} else {
				break _v0$2;
			}
		}
	}
	return false;
};
var $author$project$Route$sameThread = F2($author$project$Route$sameThread$);
var $author$project$Route$sameConversation$ = function (old, _new) {
	var _v0 = _Utils_Tuple2(old, _new);
	_v0$6:
	while (true) {
		switch (_v0.a.$) {
			case 3:
				if (((!_v0.a.b.$) && (_v0.b.$ === 3)) && (!_v0.b.b.$)) {
					var _v1 = _v0.a;
					var oldGuildId = _v1.a;
					var _v2 = _v1.b;
					var oldChannelId = _v2.a;
					var oldThreadRoute = _v2.b;
					var oldChannelsVisible = _v1.c;
					var _v3 = _v0.b;
					var newGuildId = _v3.a;
					var _v4 = _v3.b;
					var newChannelId = _v4.a;
					var newThreadRoute = _v4.b;
					var newChannelsVisible = _v3.c;
					return _Utils_eq(oldGuildId, newGuildId) && (_Utils_eq(oldChannelId, newChannelId) && ($author$project$Route$sameThread$(oldThreadRoute, newThreadRoute) && _Utils_eq(oldChannelsVisible, newChannelsVisible)));
				} else {
					break _v0$6;
				}
			case 4:
				if (_v0.b.$ === 4) {
					var oldData = _v0.a.a;
					var newData = _v0.b.a;
					var _v5 = _Utils_Tuple2(oldData.channelRoute, newData.channelRoute);
					if ((!_v5.a.$) && (!_v5.b.$)) {
						var _v6 = _v5.a;
						var oldChannelId = _v6.a;
						var oldThreadRoute = _v6.b;
						var _v7 = _v5.b;
						var newChannelId = _v7.a;
						var newThreadRoute = _v7.b;
						return _Utils_eq(oldData.currentDiscordUserId, newData.currentDiscordUserId) && (_Utils_eq(oldData.guildId, newData.guildId) && (_Utils_eq(oldChannelId, newChannelId) && ($author$project$Route$sameThread$(oldThreadRoute, newThreadRoute) && _Utils_eq(oldData.channelsVisible, newData.channelsVisible))));
					} else {
						return false;
					}
				} else {
					break _v0$6;
				}
			case 5:
				if (_v0.b.$ === 5) {
					var oldData = _v0.a.a;
					var newData = _v0.b.a;
					return _Utils_eq(oldData.channelId, newData.channelId) && ($author$project$Route$sameThread$(oldData.threadRoute, newData.threadRoute) && _Utils_eq(oldData.channelsVisible, newData.channelsVisible));
				} else {
					break _v0$6;
				}
			case 6:
				if (_v0.b.$ === 6) {
					var oldData = _v0.a.a;
					var newData = _v0.b.a;
					return _Utils_eq(oldData.currentDiscordUserId, newData.currentDiscordUserId) && (_Utils_eq(oldData.channelId, newData.channelId) && _Utils_eq(oldData.channelsVisible, newData.channelsVisible));
				} else {
					break _v0$6;
				}
			case 7:
				if (_v0.b.$ === 7) {
					var oldData = _v0.a.a;
					var newData = _v0.b.a;
					return _Utils_eq(oldData.currentSlackUserId, newData.currentSlackUserId) && (_Utils_eq(oldData.teamId, newData.teamId) && (function () {
						var _v8 = _Utils_Tuple2(oldData.channelRoute, newData.channelRoute);
						if ((!_v8.a.$) && (!_v8.b.$)) {
							var _v9 = _v8.a;
							var oldChannelId = _v9.a;
							var oldThreadRoute = _v9.b;
							var _v10 = _v8.b;
							var newChannelId = _v10.a;
							var newThreadRoute = _v10.b;
							return _Utils_eq(oldChannelId, newChannelId) && _Utils_eq(
								$author$project$Id$threadRouteWithoutMaybeMessage(oldThreadRoute),
								$author$project$Id$threadRouteWithoutMaybeMessage(newThreadRoute));
						} else {
							return false;
						}
					}() && _Utils_eq(oldData.channelsVisible, newData.channelsVisible)));
				} else {
					break _v0$6;
				}
			case 8:
				if (_v0.b.$ === 8) {
					var oldData = _v0.a.a;
					var newData = _v0.b.a;
					return _Utils_eq(oldData.currentSlackUserId, newData.currentSlackUserId) && (_Utils_eq(oldData.channelId, newData.channelId) && (_Utils_eq(
						$author$project$Id$threadRouteWithoutMaybeMessage(oldData.threadRoute),
						$author$project$Id$threadRouteWithoutMaybeMessage(newData.threadRoute)) && _Utils_eq(oldData.channelsVisible, newData.channelsVisible)));
				} else {
					break _v0$6;
				}
			default:
				break _v0$6;
		}
	}
	return false;
};
var $author$project$Route$sameConversation = F2($author$project$Route$sameConversation$);
var $author$project$Route$routeChangeCountsAsMessageView$ = function (old, _new) {
	return !$author$project$Route$sameConversation$(old, _new);
};
var $author$project$Route$routeChangeCountsAsMessageView = F2($author$project$Route$routeChangeCountsAsMessageView$);
var $author$project$Types$Local_CurrentlyViewing$ = function (a, b) {
	return {$: 27, a: a, b: b};
};
var $author$project$Types$Local_CurrentlyViewing = F2($author$project$Types$Local_CurrentlyViewing$);
var $author$project$SetViewing$StopViewingChannel = {$: 11};
var $author$project$SetViewing$ViewChannel$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$SetViewing$ViewChannel = F2($author$project$SetViewing$ViewChannel$);
var $author$project$SetViewing$ViewChannelThread$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $author$project$SetViewing$ViewChannelThread = F2($author$project$SetViewing$ViewChannelThread$);
var $author$project$SetViewing$ViewDiscordChannel$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$SetViewing$ViewDiscordChannel = F2($author$project$SetViewing$ViewDiscordChannel$);
var $author$project$SetViewing$ViewDiscordChannelThread$ = function (a, b) {
	return {$: 6, a: a, b: b};
};
var $author$project$SetViewing$ViewDiscordChannelThread = F2($author$project$SetViewing$ViewDiscordChannelThread$);
var $author$project$SetViewing$ViewDiscordDm$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$SetViewing$ViewDiscordDm = F2($author$project$SetViewing$ViewDiscordDm$);
var $author$project$SetViewing$ViewDm$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$SetViewing$ViewDm = F2($author$project$SetViewing$ViewDm$);
var $author$project$SetViewing$ViewDmThread$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$SetViewing$ViewDmThread = F2($author$project$SetViewing$ViewDmThread$);
var $author$project$SetViewing$ViewOverview = function (a) {
	return {$: 12, a: a};
};
var $author$project$SetViewing$ViewSlackChannel$ = function (a, b) {
	return {$: 7, a: a, b: b};
};
var $author$project$SetViewing$ViewSlackChannel = F2($author$project$SetViewing$ViewSlackChannel$);
var $author$project$SetViewing$ViewSlackChannelThread$ = function (a, b) {
	return {$: 9, a: a, b: b};
};
var $author$project$SetViewing$ViewSlackChannelThread = F2($author$project$SetViewing$ViewSlackChannelThread$);
var $author$project$SetViewing$ViewSlackDm$ = function (a, b) {
	return {$: 8, a: a, b: b};
};
var $author$project$SetViewing$ViewSlackDm = F2($author$project$SetViewing$ViewSlackDm$);
var $author$project$SetViewing$ViewSlackDmThread$ = function (a, b) {
	return {$: 10, a: a, b: b};
};
var $author$project$SetViewing$ViewSlackDmThread = F2($author$project$SetViewing$ViewSlackDmThread$);
var $author$project$LocalState$previouslyLastViewedMessage$ = function (guildOrDmId, local) {
	return $author$project$UserSession$PreviouslyLastViewedMessage(
		$elm$core$Maybe$withDefault$(
			$author$project$Id$fromInt(-1),
			$lamdera$containers$SeqDict$get$(guildOrDmId, local.localUser.user.lastViewedMessage)));
};
var $author$project$LocalState$previouslyLastViewedMessage = F2($author$project$LocalState$previouslyLastViewedMessage$);
var $author$project$LocalState$previouslyLastViewedThreadMessage$ = function (guildOrDmId, threadId, local) {
	return $author$project$UserSession$PreviouslyLastViewedMessage(
		$elm$core$Maybe$withDefault$(
			$author$project$Id$fromInt(-1),
			$lamdera$containers$SeqDict$get$(
				_Utils_Tuple2(guildOrDmId, threadId),
				local.localUser.user.lastViewedThreadMessage)));
};
var $author$project$LocalState$previouslyLastViewedThreadMessage = F3($author$project$LocalState$previouslyLastViewedThreadMessage$);
var $author$project$LocalState$routeToViewing$ = function (isMobile, route, local) {
	switch (route.$) {
		case 0:
			return $author$project$SetViewing$ViewOverview($author$project$UserSession$EmptyPlaceholder);
		case 1:
			return $author$project$SetViewing$StopViewingChannel;
		case 2:
			return $author$project$SetViewing$StopViewingChannel;
		case 3:
			var guildId = route.a;
			var channelRoute = route.b;
			var channelsVisible = route.c;
			if ($lamdera$containers$SeqDict$member$(guildId, local.guilds) && (!(isMobile && (channelsVisible === 1)))) {
				switch (channelRoute.$) {
					case 0:
						var channelId = channelRoute.a;
						var threadRoute = channelRoute.b;
						var tab = channelRoute.c;
						var id = {channelId: channelId, guildId: guildId};
						if (!threadRoute.$) {
							return $author$project$SetViewing$ViewChannel$(
								{
									channelHeaderTab: tab,
									id: id,
									previouslyLastViewedMessage: $author$project$LocalState$previouslyLastViewedMessage$(
										$author$project$Id$GuildOrDmId(
											$author$project$Id$GuildOrDmId_Guild(id)),
										local)
								},
								$author$project$UserSession$EmptyPlaceholder);
						} else {
							var threadId = threadRoute.a;
							return $author$project$SetViewing$ViewChannelThread$(
								{
									id: {channelId: channelId, guildId: guildId, threadId: threadId},
									previouslyLastViewedMessage: $author$project$LocalState$previouslyLastViewedThreadMessage$(
										$author$project$Id$GuildOrDmId(
											$author$project$Id$GuildOrDmId_Guild(id)),
										threadId,
										local)
								},
								$author$project$UserSession$EmptyPlaceholder);
						}
					case 1:
						return $author$project$SetViewing$StopViewingChannel;
					case 2:
						return $author$project$SetViewing$StopViewingChannel;
					default:
						return $author$project$SetViewing$StopViewingChannel;
				}
			} else {
				return $author$project$SetViewing$StopViewingChannel;
			}
		case 4:
			var channelsVisible = route.a.channelsVisible;
			var channelRoute = route.a.channelRoute;
			var guildId = route.a.guildId;
			var currentDiscordUserId = route.a.currentDiscordUserId;
			if ($lamdera$containers$SeqDict$member$(guildId, local.discordGuilds) && (!(isMobile && (channelsVisible === 1)))) {
				switch (channelRoute.$) {
					case 0:
						var channelId = channelRoute.a;
						var threadRoute = channelRoute.b;
						var id = {channelId: channelId, currentUserId: currentDiscordUserId, guildId: guildId};
						if (!threadRoute.$) {
							return $author$project$SetViewing$ViewDiscordChannel$(
								{
									id: id,
									previouslyLastViewedMessage: $author$project$LocalState$previouslyLastViewedMessage$(
										$author$project$Id$DiscordGuildOrDmId(
											$author$project$Id$DiscordGuildOrDmId_Guild(id)),
										local)
								},
								$author$project$UserSession$EmptyPlaceholder);
						} else {
							var threadId = threadRoute.a;
							return $author$project$SetViewing$ViewDiscordChannelThread$(
								{
									id: {channelId: channelId, currentUserId: currentDiscordUserId, guildId: guildId, threadId: threadId},
									previouslyLastViewedMessage: $author$project$LocalState$previouslyLastViewedThreadMessage$(
										$author$project$Id$DiscordGuildOrDmId(
											$author$project$Id$DiscordGuildOrDmId_Guild(id)),
										threadId,
										local)
								},
								$author$project$UserSession$EmptyPlaceholder);
						}
					case 1:
						return $author$project$SetViewing$StopViewingChannel;
					default:
						return $author$project$SetViewing$StopViewingChannel;
				}
			} else {
				return $author$project$SetViewing$StopViewingChannel;
			}
		case 5:
			var channelsVisible = route.a.channelsVisible;
			var tab = route.a.tab;
			var threadRoute = route.a.threadRoute;
			var channelId = route.a.channelId;
			var _v5 = $author$project$DmChannelId$otherUserId$(local.localUser.session.userId, channelId);
			if (!_v5.$) {
				var otherUserId = _v5.a;
				if (isMobile && (channelsVisible === 1)) {
					return $author$project$SetViewing$StopViewingChannel;
				} else {
					var id = {otherUserId: otherUserId};
					if (!threadRoute.$) {
						return $author$project$SetViewing$ViewDm$(
							{
								channelHeaderTab: tab,
								id: id,
								previouslyLastViewedMessage: $author$project$LocalState$previouslyLastViewedMessage$(
									$author$project$Id$GuildOrDmId(
										$author$project$Id$GuildOrDmId_Dm(id)),
									local)
							},
							$author$project$UserSession$EmptyPlaceholder);
					} else {
						var threadId = threadRoute.a;
						return $author$project$SetViewing$ViewDmThread$(
							{
								id: {otherUserId: otherUserId, threadId: threadId},
								previouslyLastViewedMessage: $author$project$LocalState$previouslyLastViewedThreadMessage$(
									$author$project$Id$GuildOrDmId(
										$author$project$Id$GuildOrDmId_Dm(id)),
									threadId,
									local)
							},
							$author$project$UserSession$EmptyPlaceholder);
					}
				}
			} else {
				return $author$project$SetViewing$StopViewingChannel;
			}
		case 6:
			var data = route.a;
			return ($lamdera$containers$SeqDict$member$(data.channelId, local.discordDmChannels) && (!(isMobile && (data.channelsVisible === 1)))) ? $author$project$SetViewing$ViewDiscordDm$(
				{
					id: {channelId: data.channelId, currentUserId: data.currentDiscordUserId},
					previouslyLastViewedMessage: $author$project$LocalState$previouslyLastViewedMessage$(
						$author$project$Id$DiscordGuildOrDmId(
							$author$project$Id$DiscordGuildOrDmId_Dm(
								{channelId: data.channelId, currentUserId: data.currentDiscordUserId})),
						local)
				},
				$author$project$UserSession$EmptyPlaceholder) : $author$project$SetViewing$StopViewingChannel;
		case 9:
			return $author$project$SetViewing$StopViewingChannel;
		case 10:
			return $author$project$SetViewing$StopViewingChannel;
		case 11:
			return $author$project$SetViewing$StopViewingChannel;
		case 12:
			return $author$project$SetViewing$StopViewingChannel;
		case 13:
			return $author$project$SetViewing$StopViewingChannel;
		case 7:
			var data = route.a;
			var _v7 = data.channelRoute;
			if (!_v7.$) {
				var channelId = _v7.a;
				var threadRoute = _v7.b;
				var id = {channelId: channelId, currentUserId: data.currentSlackUserId, teamId: data.teamId};
				var _v8 = $author$project$LocalState$getSlackWorkspaceAndChannel$(data.teamId, channelId, local);
				if (!_v8.$) {
					if (isMobile && (data.channelsVisible === 1)) {
						return $author$project$SetViewing$StopViewingChannel;
					} else {
						if (!threadRoute.$) {
							return $author$project$SetViewing$ViewSlackChannel$(
								{
									id: id,
									previouslyLastViewedMessage: $author$project$LocalState$previouslyLastViewedMessage$(
										$author$project$Id$SlackGuildOrDmId(
											$author$project$Id$SlackGuildOrDmId_Workspace(id)),
										local)
								},
								$author$project$UserSession$EmptyPlaceholder);
						} else {
							var threadId = threadRoute.a;
							return $author$project$SetViewing$ViewSlackChannelThread$(
								{
									id: id,
									previouslyLastViewedMessage: $author$project$LocalState$previouslyLastViewedThreadMessage$(
										$author$project$Id$SlackGuildOrDmId(
											$author$project$Id$SlackGuildOrDmId_Workspace(id)),
										threadId,
										local),
									threadId: threadId
								},
								$author$project$UserSession$EmptyPlaceholder);
						}
					}
				} else {
					return $author$project$SetViewing$StopViewingChannel;
				}
			} else {
				return $author$project$SetViewing$StopViewingChannel;
			}
		default:
			var data = route.a;
			var id = {channelId: data.channelId, currentUserId: data.currentSlackUserId};
			if ($lamdera$containers$SeqDict$member$(data.channelId, local.slackDmChannels) && (!(isMobile && (data.channelsVisible === 1)))) {
				var _v10 = data.threadRoute;
				if (!_v10.$) {
					return $author$project$SetViewing$ViewSlackDm$(
						{
							id: id,
							previouslyLastViewedMessage: $author$project$LocalState$previouslyLastViewedMessage$(
								$author$project$Id$SlackGuildOrDmId(
									$author$project$Id$SlackGuildOrDmId_Dm(id)),
								local)
						},
						$author$project$UserSession$EmptyPlaceholder);
				} else {
					var threadId = _v10.a;
					return $author$project$SetViewing$ViewSlackDmThread$(
						{
							id: id,
							previouslyLastViewedMessage: $author$project$LocalState$previouslyLastViewedThreadMessage$(
								$author$project$Id$SlackGuildOrDmId(
									$author$project$Id$SlackGuildOrDmId_Dm(id)),
								threadId,
								local),
							threadId: threadId
						},
						$author$project$UserSession$EmptyPlaceholder);
				}
			} else {
				return $author$project$SetViewing$StopViewingChannel;
			}
	}
};
var $author$project$LocalState$routeToViewing = F3($author$project$LocalState$routeToViewing$);
var $author$project$FrontendExtra$routeViewingLocalChange$ = function (isMobile, markMessagesAsViewed, local, route) {
	var localChange = $author$project$LocalState$routeToViewing$(isMobile, route, local);
	return _Utils_eq(
		$author$project$SetViewing$setViewingToCurrentlyViewing(localChange),
		local.localUser.currentlyViewing) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		$author$project$Types$Local_CurrentlyViewing$(
			{markMessagesAsViewed: markMessagesAsViewed},
			localChange));
};
var $author$project$FrontendExtra$routeViewingLocalChange = F4($author$project$FrontendExtra$routeViewingLocalChange$);
var $author$project$FrontendExtra$slackThreadRouteWithFriends$ = function (threadRoute, showMembers) {
	if (!threadRoute.$) {
		var maybeMessageId = threadRoute.a;
		return $author$project$Route$NoThreadWithFriends$(maybeMessageId, showMembers);
	} else {
		var threadId = threadRoute.a;
		var maybeMessageId = threadRoute.b;
		return $author$project$Route$ViewThreadWithFriends$(threadId, maybeMessageId, showMembers);
	}
};
var $author$project$FrontendExtra$slackThreadRouteWithFriends = F2($author$project$FrontendExtra$slackThreadRouteWithFriends$);
var $author$project$Route$toChannelHeaderTab = function (route) {
	switch (route.$) {
		case 5:
			var dmRoute = route.a;
			return dmRoute.tab;
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 2:
			return $elm$core$Maybe$Nothing;
		case 3:
			var channelRoute = route.b;
			switch (channelRoute.$) {
				case 0:
					var maybeTab = channelRoute.c;
					return maybeTab;
				case 1:
					return $elm$core$Maybe$Nothing;
				case 2:
					return $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		case 4:
			var routeData = route.a;
			var _v2 = routeData.channelRoute;
			switch (_v2.$) {
				case 0:
					var maybeTab = _v2.c;
					return maybeTab;
				case 1:
					return $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		case 6:
			var routeData = route.a;
			return routeData.tab;
		case 7:
			return $elm$core$Maybe$Nothing;
		case 8:
			return $elm$core$Maybe$Nothing;
		case 9:
			return $elm$core$Maybe$Nothing;
		case 10:
			return $elm$core$Maybe$Nothing;
		case 11:
			return $elm$core$Maybe$Nothing;
		case 12:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Route$toOverlay = function (route) {
	switch (route.$) {
		case 0:
			var overlay = route.a;
			return overlay;
		case 3:
			var overlay = route.d;
			return overlay;
		case 4:
			var routeData = route.a;
			return routeData.overlay;
		case 5:
			var routeData = route.a;
			return routeData.overlay;
		case 6:
			var routeData = route.a;
			return routeData.overlay;
		case 7:
			var routeData = route.a;
			return routeData.overlay;
		case 8:
			var routeData = route.a;
			return routeData.overlay;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 2:
			return $elm$core$Maybe$Nothing;
		case 9:
			return $elm$core$Maybe$Nothing;
		case 10:
			return $elm$core$Maybe$Nothing;
		case 11:
			return $elm$core$Maybe$Nothing;
		case 12:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$FrontendExtra$routeRequest$ = function (previousRoute, newRoute, model) {
	var openedSearchOverlay = _Utils_eq(
		$author$project$Route$toOverlay(newRoute),
		$elm$core$Maybe$Just(2)) && (!_Utils_eq(
		$elm$core$Maybe$andThen$($author$project$Route$toOverlay, previousRoute),
		$elm$core$Maybe$Just(2)));
	var markMessagesAsViewed = function () {
		if (!previousRoute.$) {
			var oldRoute = previousRoute.a;
			return $author$project$Route$routeChangeCountsAsMessageView$(oldRoute, newRoute);
		} else {
			return false;
		}
	}();
	var _v0 = $author$project$FrontendExtra$updateLoggedIn$(
		function (loggedIn) {
			return $author$project$FrontendExtra$handleLocalChange$(
				model.time,
				$author$project$FrontendExtra$routeViewingLocalChange$(
					$author$project$MyUi$isMobile(model),
					markMessagesAsViewed,
					$author$project$Local$model(loggedIn.localState),
					newRoute),
				_Utils_update(
					loggedIn,
					{
						drawingMode: _Utils_eq(
							$author$project$Route$toChannelHeaderTab(newRoute),
							$elm$core$Maybe$Just($author$project$UserSession$ChannelHeaderTab_Draw)) ? loggedIn.drawingMode : $author$project$Drawing$init,
						newMessagesWhileNotScrolledToBottom: 0,
						searchOverlaySelection: openedSearchOverlay ? 0 : loggedIn.searchOverlaySelection,
						userOptions: function () {
							var _v1 = $author$project$Route$toOverlay(newRoute);
							if (!_v1.$) {
								switch (_v1.a) {
									case 1:
										var _v2 = _v1.a;
										var _v3 = loggedIn.userOptions;
										if (!_v3.$) {
											var userOptions = _v3.a;
											return $elm$core$Maybe$Just(userOptions);
										} else {
											return $elm$core$Maybe$Just(
												$author$project$UserOptions$init(
													$author$project$Local$model(loggedIn.localState).localUser.user.domainWhitelist));
										}
									case 0:
										var _v4 = _v1.a;
										return $elm$core$Maybe$Nothing;
									default:
										var _v5 = _v1.a;
										return $elm$core$Maybe$Nothing;
								}
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}()
					}),
				openedSearchOverlay ? $lamdera$program_test$Effect$Task$attempt$(
					function (_v6) {
						return $author$project$Types$SetFocus;
					},
					$lamdera$program_test$Effect$Browser$Dom$focus($author$project$SearchOverlay$inputId)) : $lamdera$program_test$Effect$Command$none);
		},
		_Utils_update(
			model,
			{route: newRoute}));
	var model2 = _v0.a;
	var viewCmd = _v0.b;
	return $elm$core$Tuple$mapSecond$(
		function (a) {
			return $lamdera$program_test$Effect$Command$batch(
				_List_fromArray(
					[viewCmd, a]));
		},
		function () {
			switch (newRoute.$) {
				case 0:
					return _Utils_Tuple2(
						_Utils_update(
							model2,
							{
								loginStatus: function () {
									var _v8 = model2.loginStatus;
									if (_v8.$ === 1) {
										var notLoggedIn = _v8.a;
										return $author$project$Types$NotLoggedIn(
											_Utils_update(
												notLoggedIn,
												{loginForm: $elm$core$Maybe$Nothing}));
									} else {
										return model2.loginStatus;
									}
								}()
							}),
						$author$project$Scroll$toBottomOfChannel$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom));
				case 1:
					var highlightLog = newRoute.a.highlightLog;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							var admin = loggedIn.admin;
							return _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{
										admin: _Utils_update(
											admin,
											{highlightLog: highlightLog})
									}),
								function () {
									var _v9 = $author$project$Local$model(loggedIn.localState).adminData;
									switch (_v9.$) {
										case 1:
											return $lamdera$program_test$Effect$Lamdera$sendToBackend(
												function () {
													if (!highlightLog.$) {
														var highlightLog2 = highlightLog.a;
														return $author$project$Types$AdminDataRequest(
															$elm$core$Maybe$Just(
																$author$project$Pagination$itemToPageId(highlightLog2).pageId));
													} else {
														return $author$project$Types$AdminDataRequest($elm$core$Maybe$Nothing);
													}
												}());
										case 0:
											return $lamdera$program_test$Effect$Command$none;
										default:
											return $lamdera$program_test$Effect$Command$none;
									}
								}());
						},
						model2);
				case 2:
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							return _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{newGuildForm: $elm$core$Maybe$Nothing}),
								$lamdera$program_test$Effect$Command$none);
						},
						model2);
				case 3:
					var guildId = newRoute.a;
					var channelRoute = newRoute.b;
					var model3 = $author$project$FrontendExtra$clearRevealedSpoilers(model2);
					switch (channelRoute.$) {
						case 0:
							var channelId = channelRoute.a;
							var threadRoute = channelRoute.b;
							var tab = channelRoute.c;
							return $author$project$FrontendExtra$enterChannelRoute$(
								$author$project$Id$GuildOrDmId(
									$author$project$Id$GuildOrDmId_Guild(
										{channelId: channelId, guildId: guildId})),
								tab,
								threadRoute,
								function () {
									if (((!previousRoute.$) && (previousRoute.a.$ === 3)) && (!previousRoute.a.b.$)) {
										var _v13 = previousRoute.a;
										var previousGuildId = _v13.a;
										var _v14 = _v13.b;
										var previousChannelId = _v14.a;
										var previousThreadRoute = _v14.b;
										return _Utils_eq(guildId, previousGuildId) && (_Utils_eq(channelId, previousChannelId) && $author$project$Route$sameThread$(threadRoute, previousThreadRoute));
									} else {
										return false;
									}
								}(),
								$lamdera$program_test$Effect$Command$none,
								model3);
						case 1:
							return _Utils_Tuple2(model3, $lamdera$program_test$Effect$Command$none);
						case 2:
							return _Utils_Tuple2(model3, $lamdera$program_test$Effect$Command$none);
						default:
							var inviteLinkId = channelRoute.a;
							var _v15 = model3.loginStatus;
							if (_v15.$ === 1) {
								var notLoggedIn = _v15.a;
								return _Utils_Tuple2(
									_Utils_update(
										model3,
										{
											loginStatus: $author$project$Types$NotLoggedIn(
												_Utils_update(
													notLoggedIn,
													{
														useInviteAfterLoggedIn: $elm$core$Maybe$Just(inviteLinkId)
													}))
										}),
									$lamdera$program_test$Effect$Command$none);
							} else {
								var loggedIn = _v15.a;
								var local = $author$project$Local$model(loggedIn.localState);
								return _Utils_Tuple2(
									model3,
									$lamdera$program_test$Effect$Command$batch(
										_List_fromArray(
											[
												$lamdera$program_test$Effect$Lamdera$sendToBackend(
												$author$project$Types$JoinGuildByInviteRequest$(guildId, inviteLinkId)),
												function () {
												var _v16 = $lamdera$containers$SeqDict$get$(guildId, local.guilds);
												if (!_v16.$) {
													var guild = _v16.a;
													return $author$project$FrontendExtra$routeReplace$(
														model3,
														$author$project$Route$GuildRoute$(
															guildId,
															$author$project$Route$ChannelRoute$(
																$author$project$LocalState$announcementChannel(guild),
																$author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1),
																$elm$core$Maybe$Nothing),
															1,
															$elm$core$Maybe$Nothing));
												} else {
													return $lamdera$program_test$Effect$Command$none;
												}
											}()
											])));
							}
					}
				case 4:
					var channelRoute = newRoute.a.channelRoute;
					var guildId = newRoute.a.guildId;
					var currentDiscordUserId = newRoute.a.currentDiscordUserId;
					var model3 = $author$project$FrontendExtra$clearRevealedSpoilers(model2);
					switch (channelRoute.$) {
						case 0:
							var channelId = channelRoute.a;
							var threadRoute = channelRoute.b;
							return $author$project$FrontendExtra$enterChannelRoute$(
								$author$project$Id$DiscordGuildOrDmId(
									$author$project$Id$DiscordGuildOrDmId_Guild(
										{channelId: channelId, currentUserId: currentDiscordUserId, guildId: guildId})),
								$elm$core$Maybe$Nothing,
								threadRoute,
								function () {
									if ((!previousRoute.$) && (previousRoute.a.$ === 4)) {
										var guildData = previousRoute.a.a;
										var _v19 = guildData.channelRoute;
										if (!_v19.$) {
											var previousChannelId = _v19.a;
											var previousThreadRoute = _v19.b;
											return _Utils_eq(currentDiscordUserId, guildData.currentDiscordUserId) && (_Utils_eq(guildId, guildData.guildId) && (_Utils_eq(channelId, previousChannelId) && $author$project$Route$sameThread$(threadRoute, previousThreadRoute)));
										} else {
											return false;
										}
									} else {
										return false;
									}
								}(),
								$lamdera$program_test$Effect$Command$none,
								model3);
						case 1:
							return _Utils_Tuple2(model3, $lamdera$program_test$Effect$Command$none);
						default:
							return _Utils_Tuple2(model3, $lamdera$program_test$Effect$Command$none);
					}
				case 9:
					return _Utils_Tuple2(
						model2,
						$lamdera$program_test$Effect$Command$map$($author$project$Types$AiChatToBackend, $author$project$Types$AiChatMsg, $author$project$AiChat$getModels));
				case 5:
					var dmRoute = newRoute.a;
					var sameDmRoute = function () {
						if ((!previousRoute.$) && (previousRoute.a.$ === 5)) {
							var previousDmRoute = previousRoute.a.a;
							return _Utils_eq(dmRoute.channelId, previousDmRoute.channelId);
						} else {
							return false;
						}
					}();
					var model3 = sameDmRoute ? model2 : $author$project$FrontendExtra$clearRevealedSpoilers(model2);
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							var local = $author$project$Local$model(loggedIn.localState);
							var _v20 = $author$project$DmChannelId$otherUserId$(local.localUser.session.userId, dmRoute.channelId);
							if (!_v20.$) {
								var otherUserId = _v20.a;
								return $author$project$FrontendExtra$routeRequestChannelHelper$(
									sameDmRoute,
									$author$project$Id$GuildOrDmId(
										$author$project$Id$GuildOrDmId_Dm(
											{otherUserId: otherUserId})),
									dmRoute.tab,
									dmRoute.threadRoute,
									local,
									loggedIn,
									model3);
							} else {
								return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
							}
						},
						model3);
				case 6:
					var routeData = newRoute.a;
					var sameDmRoute = function () {
						if ((!previousRoute.$) && (previousRoute.a.$ === 6)) {
							var previousDmRoute = previousRoute.a.a;
							return _Utils_eq(routeData.channelId, previousDmRoute.channelId);
						} else {
							return false;
						}
					}();
					var model3 = sameDmRoute ? model2 : $author$project$FrontendExtra$clearRevealedSpoilers(model2);
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							return $author$project$FrontendExtra$routeRequestChannelHelper$(
								sameDmRoute,
								$author$project$Id$DiscordGuildOrDmId(
									$author$project$Id$DiscordGuildOrDmId_Dm(
										{channelId: routeData.channelId, currentUserId: routeData.currentDiscordUserId})),
								$elm$core$Maybe$Nothing,
								$author$project$Route$NoThreadWithFriends$(routeData.viewingMessage, routeData.showMembersTab),
								$author$project$Local$model(loggedIn.localState),
								loggedIn,
								model3);
						},
						model3);
				case 10:
					return _Utils_Tuple2(model2, $lamdera$program_test$Effect$Command$none);
				case 11:
					return _Utils_Tuple2(
						_Utils_update(
							model2,
							{
								loginStatus: function () {
									var _v23 = model2.loginStatus;
									if (_v23.$ === 1) {
										var notLoggedIn = _v23.a;
										return $author$project$Types$NotLoggedIn(
											_Utils_update(
												notLoggedIn,
												{loginForm: $elm$core$Maybe$Nothing}));
									} else {
										return model2.loginStatus;
									}
								}()
							}),
						$lamdera$program_test$Effect$Command$none);
				case 12:
					var result = newRoute.a;
					return _Utils_Tuple2(
						model2,
						function () {
							var _v24 = _Utils_Tuple2(model2.loginStatus, result);
							if ((!_v24.a.$) && (!_v24.b.$)) {
								var userData = _v24.b.a;
								return $lamdera$program_test$Effect$Lamdera$sendToBackend(
									$author$project$Types$LinkDiscordRequest(userData));
							} else {
								return $lamdera$program_test$Effect$Command$none;
							}
						}());
				case 13:
					var publicGoMatchId = newRoute.a;
					return _Utils_Tuple2(
						_Utils_update(
							model2,
							{publicGoMatch: $author$project$Types$PublicGoMatch_Loading}),
						$lamdera$program_test$Effect$Lamdera$sendToBackend(
							$author$project$Types$GetPublicGoMatchRequest(publicGoMatchId)));
				case 7:
					var routeData = newRoute.a;
					var _v25 = routeData.channelRoute;
					if (!_v25.$) {
						var channelId = _v25.a;
						var threadRoute = _v25.b;
						var showMembers = _v25.c;
						var sameChannelRoute = function () {
							if ((!previousRoute.$) && (previousRoute.a.$ === 7)) {
								var previousRouteData = previousRoute.a.a;
								var _v27 = previousRouteData.channelRoute;
								if (!_v27.$) {
									var previousChannelId = _v27.a;
									return _Utils_eq(routeData.teamId, previousRouteData.teamId) && _Utils_eq(channelId, previousChannelId);
								} else {
									return false;
								}
							} else {
								return false;
							}
						}();
						var model3 = sameChannelRoute ? model2 : $author$project$FrontendExtra$clearRevealedSpoilers(model2);
						var guildOrDmId = $author$project$Id$SlackGuildOrDmId_Workspace(
							{channelId: channelId, currentUserId: routeData.currentSlackUserId, teamId: routeData.teamId});
						return $author$project$FrontendExtra$updateLoggedIn$(
							function (loggedIn) {
								return $author$project$FrontendExtra$routeRequestChannelHelper$(
									sameChannelRoute,
									$author$project$Id$SlackGuildOrDmId(guildOrDmId),
									$elm$core$Maybe$Nothing,
									$author$project$FrontendExtra$slackThreadRouteWithFriends$(threadRoute, showMembers),
									$author$project$Local$model(loggedIn.localState),
									loggedIn,
									model3);
							},
							model3);
					} else {
						return _Utils_Tuple2(
							$author$project$FrontendExtra$clearRevealedSpoilers(model2),
							$lamdera$program_test$Effect$Command$none);
					}
				default:
					var routeData = newRoute.a;
					var sameDmRoute = function () {
						if ((!previousRoute.$) && (previousRoute.a.$ === 8)) {
							var previousDmRoute = previousRoute.a.a;
							return _Utils_eq(routeData.channelId, previousDmRoute.channelId);
						} else {
							return false;
						}
					}();
					var model3 = sameDmRoute ? model2 : $author$project$FrontendExtra$clearRevealedSpoilers(model2);
					var guildOrDmId = $author$project$Id$SlackGuildOrDmId_Dm(
						{channelId: routeData.channelId, currentUserId: routeData.currentSlackUserId});
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							return $author$project$FrontendExtra$routeRequestChannelHelper$(
								sameDmRoute,
								$author$project$Id$SlackGuildOrDmId(guildOrDmId),
								$elm$core$Maybe$Nothing,
								$author$project$FrontendExtra$slackThreadRouteWithFriends$(routeData.threadRoute, 1),
								$author$project$Local$model(loggedIn.localState),
								loggedIn,
								model3);
						},
						model3);
			}
		}());
};
var $author$project$FrontendExtra$routeRequest = F3($author$project$FrontendExtra$routeRequest$);
var $author$project$Discord$idFromUInt64 = $elm$core$Basics$identity;
var $author$project$LocalState$discordAnnouncementChannel = function (guild) {
	return $elm$core$Maybe$withDefault$(
		$author$project$Discord$idFromUInt64(
			$MartinSStewart$elm_uint64$UInt64$fromInt(0)),
		$elm$core$List$head(
			$lamdera$containers$SeqDict$keys(guild.channels)));
};
var $author$project$GuildColumn$discordGuildRoute$ = function (localUser, discordUserId, guildId, guild) {
	return $author$project$Route$DiscordGuildRoute(
		{
			channelRoute: function () {
				var _v0 = $lamdera$containers$SeqDict$get$(guildId, localUser.user.lastDiscordChannelViewed);
				if (!_v0.$) {
					var _v1 = _v0.a;
					var channelId = _v1.a;
					var threadRoute = _v1.b;
					return $author$project$Route$DiscordChannel_ChannelRoute$(
						channelId,
						function () {
							if (threadRoute.$ === 1) {
								var threadId = threadRoute.a;
								return $author$project$Route$ViewThreadWithFriends$(threadId, $elm$core$Maybe$Nothing, 1);
							} else {
								return $author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1);
							}
						}(),
						$elm$core$Maybe$Nothing);
				} else {
					return $author$project$Route$DiscordChannel_ChannelRoute$(
						$author$project$LocalState$discordAnnouncementChannel(guild),
						$author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1),
						$elm$core$Maybe$Nothing);
				}
			}(),
			channelsVisible: 1,
			currentDiscordUserId: discordUserId,
			guildId: guildId,
			overlay: $elm$core$Maybe$Nothing
		});
};
var $author$project$GuildColumn$discordGuildRoute = F4($author$project$GuildColumn$discordGuildRoute$);
var $author$project$GuildColumn$guildRoute$ = function (localUser, guildId, guild) {
	return $author$project$Route$GuildRoute$(
		guildId,
		function () {
			var _v0 = $lamdera$containers$SeqDict$get$(guildId, localUser.user.lastChannelViewed);
			if (!_v0.$) {
				var _v1 = _v0.a;
				var channelId = _v1.a;
				var threadRoute = _v1.b;
				return $author$project$Route$ChannelRoute$(
					channelId,
					function () {
						if (threadRoute.$ === 1) {
							var threadId = threadRoute.a;
							return $author$project$Route$ViewThreadWithFriends$(threadId, $elm$core$Maybe$Nothing, 1);
						} else {
							return $author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1);
						}
					}(),
					$elm$core$Maybe$Nothing);
			} else {
				return $author$project$Route$ChannelRoute$(
					$author$project$LocalState$announcementChannel(guild),
					$author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1),
					$elm$core$Maybe$Nothing);
			}
		}(),
		1,
		$elm$core$Maybe$Nothing);
};
var $author$project$GuildColumn$guildRoute = F3($author$project$GuildColumn$guildRoute$);
var $author$project$Route$setOverlay$ = function (overlay, route) {
	switch (route.$) {
		case 0:
			return $author$project$Route$HomePageRoute(overlay);
		case 3:
			var guildId = route.a;
			var channelRoute = route.b;
			var channelsVisible = route.c;
			return $author$project$Route$GuildRoute$(guildId, channelRoute, channelsVisible, overlay);
		case 4:
			var routeData = route.a;
			return $author$project$Route$DiscordGuildRoute(
				_Utils_update(
					routeData,
					{overlay: overlay}));
		case 5:
			var routeData = route.a;
			return $author$project$Route$DmRoute(
				_Utils_update(
					routeData,
					{overlay: overlay}));
		case 6:
			var routeData = route.a;
			return $author$project$Route$DiscordDmRoute(
				_Utils_update(
					routeData,
					{overlay: overlay}));
		case 7:
			var routeData = route.a;
			return $author$project$Route$SlackWorkspaceRoute(
				_Utils_update(
					routeData,
					{overlay: overlay}));
		case 8:
			var routeData = route.a;
			return $author$project$Route$SlackDmRoute(
				_Utils_update(
					routeData,
					{overlay: overlay}));
		case 1:
			return route;
		case 2:
			return route;
		case 9:
			return route;
		case 10:
			return route;
		case 11:
			return route;
		case 12:
			return $author$project$Route$HomePageRoute(overlay);
		default:
			return route;
	}
};
var $author$project$Route$setOverlay = F2($author$project$Route$setOverlay$);
var $author$project$LocalState$slackAnnouncementChannel = function (guild) {
	return $elm$core$List$head(
		$lamdera$containers$SeqDict$keys(guild.channels));
};
var $author$project$GuildColumn$slackWorkspaceRoute$ = function (localUser, slackUserId, teamId, workspace) {
	var lastViewed = function () {
		var _v3 = $lamdera$containers$SeqDict$get$(teamId, localUser.user.lastSlackChannelViewed);
		if (!_v3.$) {
			var _v4 = _v3.a;
			var channelId = _v4.a;
			var threadRoute = _v4.b;
			return $lamdera$containers$SeqDict$member$(channelId, workspace.channels) ? $elm$core$Maybe$Just(
				_Utils_Tuple2(
					channelId,
					function () {
						if (threadRoute.$ === 1) {
							var threadId = threadRoute.a;
							return $author$project$Id$ViewThreadWithMaybeMessage$(threadId, $elm$core$Maybe$Nothing);
						} else {
							return $author$project$Id$NoThreadWithMaybeMessage($elm$core$Maybe$Nothing);
						}
					}())) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	var targetChannel = function () {
		if (!lastViewed.$) {
			return lastViewed;
		} else {
			return $elm$core$Maybe$map$(
				function (channelId) {
					return _Utils_Tuple2(
						channelId,
						$author$project$Id$NoThreadWithMaybeMessage($elm$core$Maybe$Nothing));
				},
				$author$project$LocalState$slackAnnouncementChannel(workspace));
		}
	}();
	if (!targetChannel.$) {
		var _v1 = targetChannel.a;
		var channelId = _v1.a;
		var threadRoute = _v1.b;
		return $elm$core$Maybe$Just(
			$author$project$Route$SlackWorkspaceRoute(
				{
					channelRoute: $author$project$Route$SlackChannel_ChannelRoute$(channelId, threadRoute, 1),
					channelsVisible: 1,
					currentSlackUserId: slackUserId,
					overlay: $elm$core$Maybe$Nothing,
					teamId: teamId
				}));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$GuildColumn$slackWorkspaceRoute = F4($author$project$GuildColumn$slackWorkspaceRoute$);
var $author$project$Frontend$startupRoute$ = function (loading, loggedIn) {
	var _v0 = loading.route;
	if (!_v0.$) {
		var overlay = _v0.a;
		if ($author$project$MyUi$isMobile(loading)) {
			return loading.route;
		} else {
			var local = $author$project$Local$model(loggedIn.localState);
			var _v1 = local.localUser.session.lastViewedGuild;
			if (!_v1.$) {
				switch (_v1.a.$) {
					case 0:
						var guildId = _v1.a.a;
						var _v2 = $lamdera$containers$SeqDict$get$(guildId, local.guilds);
						if (!_v2.$) {
							var guild = _v2.a;
							return $author$project$Route$setOverlay$(
								overlay,
								$author$project$GuildColumn$guildRoute$(local.localUser, guildId, guild));
						} else {
							return loading.route;
						}
					case 1:
						var guildId = _v1.a.a;
						var _v3 = $lamdera$containers$SeqDict$get$(guildId, local.discordGuilds);
						if (!_v3.$) {
							var guild = _v3.a;
							var _v4 = $author$project$GuildColumn$discordGuildCurrentUserId$(local.localUser, guild);
							if (!_v4.$) {
								var discordUserId = _v4.a;
								return $author$project$Route$setOverlay$(
									overlay,
									$author$project$GuildColumn$discordGuildRoute$(local.localUser, discordUserId, guildId, guild));
							} else {
								return loading.route;
							}
						} else {
							return loading.route;
						}
					default:
						var teamId = _v1.a.a;
						var _v5 = $lamdera$containers$SeqDict$get$(teamId, local.slackWorkspaces);
						if (!_v5.$) {
							var workspace = _v5.a;
							var _v6 = $author$project$GuildColumn$slackWorkspaceCurrentUserId$(local.localUser, teamId);
							if (!_v6.$) {
								var slackUserId = _v6.a;
								var _v7 = $author$project$GuildColumn$slackWorkspaceRoute$(local.localUser, slackUserId, teamId, workspace);
								if (!_v7.$) {
									var workspaceRoute = _v7.a;
									return $author$project$Route$setOverlay$(overlay, workspaceRoute);
								} else {
									return loading.route;
								}
							} else {
								return loading.route;
							}
						} else {
							return loading.route;
						}
				}
			} else {
				return loading.route;
			}
		}
	} else {
		return loading.route;
	}
};
var $author$project$Frontend$startupRoute = F2($author$project$Frontend$startupRoute$);
var $author$project$Frontend$initLoadedFrontend$ = function (loading, clientId, time, startupData, loginResult) {
	var _v0 = function () {
		if (!loginResult.$) {
			var loginData = loginResult.a;
			return $elm$core$Tuple$mapFirst$(
				$author$project$Types$LoggedIn,
				$author$project$FrontendExtra$loadedInitHelper$(startupData, $elm$core$Maybe$Nothing, loginData, loading));
		} else {
			return _Utils_Tuple2(
				$author$project$Types$NotLoggedIn(
					{loginForm: $elm$core$Maybe$Nothing, recoveryLogin: $author$project$RecoveryLogin$init, textInputFocus: $elm$core$Maybe$Nothing, useInviteAfterLoggedIn: $elm$core$Maybe$Nothing}),
				$lamdera$program_test$Effect$Command$batch(
					_List_fromArray(
						[
							$author$project$Ports$clearBrowserStorage,
							$author$project$Ports$setAppBadge(0)
						])));
		}
	}();
	var loginStatus = _v0.a;
	var cmdB = _v0.b;
	var route = function () {
		if (!loginStatus.$) {
			var loggedIn = loginStatus.a;
			return $author$project$Frontend$startupRoute$(loading, loggedIn);
		} else {
			return loading.route;
		}
	}();
	var _v2 = $author$project$AiChat$init;
	var aiChatModel = _v2.a;
	var aiChatCmd = _v2.b;
	var model = {
		aiChatModel: aiChatModel,
		clientId: clientId,
		drag: $author$project$Touch$NoDrag,
		dragPrevious: $author$project$Touch$NoDrag,
		elmUiState: $author$project$Ui$Anim$init,
		emojiData: $elm$core$Maybe$Nothing,
		homePagePreview: {changedAt: time, index: 0, rotate: true},
		imageViewer: $elm$core$Maybe$Nothing,
		lastCopied: $elm$core$Maybe$Nothing,
		loginStatus: loginStatus,
		loginType: loading.loginType,
		navigationKey: loading.navigationKey,
		pageHasFocus: true,
		popSound: loading.popSound,
		publicGoMatch: loading.publicGoMatch,
		route: route,
		startupData: startupData,
		time: time,
		timezone: startupData.timezone,
		toFrontendLogs: $elm$core$Maybe$Nothing,
		versionNumber: $elm$core$Maybe$Nothing,
		visualViewportHeight: $author$project$Coord$yRaw(loading.windowSize),
		visualViewportTop: 0,
		windowSize: loading.windowSize
	};
	var _v3 = $author$project$FrontendExtra$routeRequest$($elm$core$Maybe$Nothing, model.route, model);
	var model2 = _v3.a;
	var cmdA = _v3.b;
	return _Utils_Tuple3(
		model2,
		$lamdera$program_test$Effect$Command$batch(
			_List_fromArray(
				[
					cmdB,
					cmdA,
					_Utils_eq(route, loading.route) ? $lamdera$program_test$Effect$Command$none : $author$project$FrontendExtra$routeReplace$(model2, route),
					$lamdera$program_test$Effect$Command$map$($author$project$Types$AiChatToBackend, $author$project$Types$AiChatMsg, aiChatCmd),
					$author$project$Frontend$checkAppVersion,
					$author$project$Frontend$callPreviewShown(model2) ? $author$project$Pages$Home$callPreviewImages : $lamdera$program_test$Effect$Command$none,
					function () {
					if (!loginResult.$) {
						return $author$project$Ports$registerServiceWorker;
					} else {
						return $lamdera$program_test$Effect$Command$none;
					}
				}(),
					$author$project$Emoji$requestEmojiData($author$project$Types$GotEmojiData)
				])),
		$author$project$Audio$cmdNone);
};
var $author$project$Frontend$initLoadedFrontend = F5($author$project$Frontend$initLoadedFrontend$);
var $author$project$Frontend$tryInitLoadedFrontend = function (loading) {
	var maybeLoginStatus = function () {
		var _v2 = loading.loginStatus;
		switch (_v2.$) {
			case 0:
				return $elm$core$Maybe$Nothing;
			case 1:
				var loginData = _v2.a;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(loginData));
			default:
				return $elm$core$Maybe$Just(
					$elm$core$Result$Err(0));
		}
	}();
	var _v0 = $bburdette$toop$Toop$T4$(loading.clientId, loading.time, maybeLoginStatus, loading.startupData);
	if ((((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) && (!_v0.d.$)) {
		var clientId = _v0.a.a;
		var time = _v0.b.a;
		var loginStatus = _v0.c.a;
		var startupData = _v0.d.a;
		var _v1 = $author$project$Frontend$initLoadedFrontend$(loading, clientId, time, startupData, loginStatus);
		var loaded = _v1.a;
		var audioCmd = _v1.b;
		var cmd = _v1.c;
		return _Utils_Tuple3(
			$author$project$Types$Loaded(loaded),
			audioCmd,
			cmd);
	} else {
		return _Utils_Tuple3(
			$author$project$Types$Loading(loading),
			$lamdera$program_test$Effect$Command$none,
			$author$project$Audio$cmdNone);
	}
};
var $author$project$Types$AdminPageMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Types$AdminToBackend = function (a) {
	return {$: 5, a: a};
};
var $author$project$Drawing$CardAnchor = {$: 4};
var $author$project$ImageEditor$ChangeGuildIconRequest$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$ImageEditor$ChangeGuildIconRequest = F2($author$project$ImageEditor$ChangeGuildIconRequest$);
var $author$project$ImageEditor$ChangeUserAvatarRequest = function (a) {
	return {$: 0, a: a};
};
var $author$project$MyUi$CopiedImage = function (a) {
	return {$: 1, a: a};
};
var $author$project$MyUi$CopiedText = function (a) {
	return {$: 0, a: a};
};
var $author$project$Drawing$DateDividerAnchor$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Drawing$DateDividerAnchor = F2($author$project$Drawing$DateDividerAnchor$);
var $author$project$Types$DebouncedTyping = {$: 37};
var $author$project$Touch$Dragging = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$EditMessage_SelectedFilesToAttach$ = function (a, b, c) {
	return {$: 93, a: a, b: b, c: c};
};
var $author$project$Types$EditMessage_SelectedFilesToAttach = F3($author$project$Types$EditMessage_SelectedFilesToAttach$);
var $author$project$Types$ElmUiMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Drawing$EmbedImageAnchor = function (a) {
	return {$: 3, a: a};
};
var $author$project$Emoji$EmojiOrCustomEmoji_CustomEmoji = function (a) {
	return {$: 1, a: a};
};
var $author$project$Emoji$EmojiOrCustomEmoji_Emoji = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$EmojiSelectorForEditMessage$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Types$EmojiSelectorForEditMessage = F2($author$project$Types$EmojiSelectorForEditMessage$);
var $author$project$Types$EmojiSelectorForMessage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$EmojiSelectorForSheepGameInput$ = function (a, b, c) {
	return {$: 4, a: a, b: b, c: c};
};
var $author$project$Types$EmojiSelectorForSheepGameInput = F3($author$project$Types$EmojiSelectorForSheepGameInput$);
var $author$project$Types$ExportChannelRequest = function (a) {
	return {$: 18, a: a};
};
var $author$project$Call$FailedToGetMediaDevices = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$FileDragging$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Types$FileDragging = F2($author$project$Types$FileDragging$);
var $author$project$FileStatus$FileUploading$ = function (a, b, c, d) {
	return {$: 0, a: a, b: b, c: c, d: d};
};
var $author$project$FileStatus$FileUploading = F4($author$project$FileStatus$FileUploading$);
var $author$project$Types$FinishUserCreationRequest$ = function (a, b, c) {
	return {$: 10, a: a, b: b, c: c};
};
var $author$project$Types$FinishUserCreationRequest = F3($author$project$Types$FinishUserCreationRequest$);
var $author$project$Types$FrontendNoOp = {$: 32};
var $author$project$Types$GetLoginTokenRequest = function (a) {
	return {$: 3, a: a};
};
var $author$project$Types$GotFileHashName$ = function (a, b, c, d) {
	return {$: 86, a: a, b: b, c: c, d: d};
};
var $author$project$Types$GotFileHashName = F4($author$project$Types$GotFileHashName$);
var $author$project$Types$GotImportChannelFile$ = function (a, b) {
	return {$: 26, a: a, b: b};
};
var $author$project$Types$GotImportChannelFile = F2($author$project$Types$GotImportChannelFile$);
var $author$project$Types$GotPositionForEmojiSelector_EditMessage = function (a) {
	return {$: 149, a: a};
};
var $author$project$Drawing$ImageAttachmentAnchor = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$ImportChannelRequest$ = function (a, b) {
	return {$: 19, a: a, b: b};
};
var $author$project$Types$ImportChannelRequest = F2($author$project$Types$ImportChannelRequest$);
var $author$project$Types$ImportingChannel = {$: 1};
var $author$project$Ports$InsertText$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Ports$InsertText = F2($author$project$Ports$InsertText$);
var $author$project$Types$LinkSlackRequest = function (a) {
	return {$: 14, a: a};
};
var $author$project$Types$Local_AcceptE2ee$ = function (a, b, c) {
	return {$: 76, a: a, b: b, c: c};
};
var $author$project$Types$Local_AcceptE2ee = F3($author$project$Types$Local_AcceptE2ee$);
var $author$project$Types$Local_AddCustomEmojisToUser = function (a) {
	return {$: 55, a: a};
};
var $author$project$Types$Local_AddReactionEmoji$ = function (a, b, c) {
	return {$: 19, a: a, b: b, c: c};
};
var $author$project$Types$Local_AddReactionEmoji = F3($author$project$Types$Local_AddReactionEmoji$);
var $author$project$Types$Local_Admin = function (a) {
	return {$: 1, a: a};
};
var $author$project$Call$Local_AnswerRecording = function (a) {
	return {$: 3, a: a};
};
var $author$project$Types$Local_BanMember$ = function (a, b) {
	return {$: 16, a: a, b: b};
};
var $author$project$Types$Local_BanMember = F2($author$project$Types$Local_BanMember$);
var $author$project$Types$Local_CancelAccountDeletion = {$: 45};
var $author$project$Call$Local_CancelRecording = {$: 4};
var $author$project$Types$Local_CollapseUserOptionSection = function (a) {
	return {$: 40, a: a};
};
var $author$project$Types$Local_DeclineE2eeRequest = function (a) {
	return {$: 70, a: a};
};
var $author$project$Types$Local_DeclineE2eeRequestAsInitiator = function (a) {
	return {$: 69, a: a};
};
var $author$project$Types$Local_DecryptOldMessages$ = function (a, b, c) {
	return {$: 74, a: a, b: b, c: c};
};
var $author$project$Types$Local_DecryptOldMessages = F3($author$project$Types$Local_DecryptOldMessages$);
var $author$project$Types$Local_DeleteChannel$ = function (a, b) {
	return {$: 10, a: a, b: b};
};
var $author$project$Types$Local_DeleteChannel = F2($author$project$Types$Local_DeleteChannel$);
var $author$project$Types$Local_DeleteGuild = function (a) {
	return {$: 12, a: a};
};
var $author$project$Types$Local_DeleteInviteLink$ = function (a, b) {
	return {$: 15, a: a, b: b};
};
var $author$project$Types$Local_DeleteInviteLink = F2($author$project$Types$Local_DeleteInviteLink$);
var $author$project$Types$Local_DeleteMessage$ = function (a, b) {
	return {$: 26, a: a, b: b};
};
var $author$project$Types$Local_DeleteMessage = F2($author$project$Types$Local_DeleteMessage$);
var $author$project$Types$Local_DisableE2ee$ = function (a, b) {
	return {$: 73, a: a, b: b};
};
var $author$project$Types$Local_DisableE2ee = F2($author$project$Types$Local_DisableE2ee$);
var $author$project$Types$Local_Discord_SendEditDmMessage$ = function (a, b, c, d, e) {
	return {$: 23, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Types$Local_Discord_SendEditDmMessage = F5($author$project$Types$Local_Discord_SendEditDmMessage$);
var $author$project$Types$Local_Discord_SendEditGuildMessage$ = function (a, b, c, d, e, f, g) {
	return {$: 22, a: a, b: b, c: c, d: d, e: e, f: f, g: g};
};
var $author$project$Types$Local_Discord_SendEditGuildMessage = F7($author$project$Types$Local_Discord_SendEditGuildMessage$);
var $author$project$Types$Local_Discord_SendMessage$ = function (a, b, c, d, e, f) {
	return {$: 3, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Types$Local_Discord_SendMessage = F6($author$project$Types$Local_Discord_SendMessage$);
var $author$project$Types$Local_EditChannel$ = function (a, b, c, d) {
	return {$: 9, a: a, b: b, c: c, d: d};
};
var $author$project$Types$Local_EditChannel = F4($author$project$Types$Local_EditChannel$);
var $author$project$Types$Local_EditGuildName$ = function (a, b) {
	return {$: 11, a: a, b: b};
};
var $author$project$Types$Local_EditGuildName = F2($author$project$Types$Local_EditGuildName$);
var $author$project$Types$Local_ExpandUserOptionSection$ = function (a, b) {
	return {$: 39, a: a, b: b};
};
var $author$project$Types$Local_ExpandUserOptionSection = F2($author$project$Types$Local_ExpandUserOptionSection$);
var $author$project$Call$Local_Leave = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$Local_LeaveGuild = function (a) {
	return {$: 13, a: a};
};
var $author$project$Types$Local_LinkDiscordAcknowledgementIsChecked = function (a) {
	return {$: 50, a: a};
};
var $author$project$Types$Local_LinkSlackAcknowledgementIsChecked = function (a) {
	return {$: 51, a: a};
};
var $author$project$Types$Local_MemberEditTyping$ = function (a, b, c) {
	return {$: 24, a: a, b: b, c: c};
};
var $author$project$Types$Local_MemberEditTyping = F3($author$project$Types$Local_MemberEditTyping$);
var $author$project$Types$Local_MemberTyping$ = function (a, b) {
	return {$: 18, a: a, b: b};
};
var $author$project$Types$Local_MemberTyping = F2($author$project$Types$Local_MemberTyping$);
var $author$project$Types$Local_NewChannel$ = function (a, b, c, d) {
	return {$: 8, a: a, b: b, c: c, d: d};
};
var $author$project$Types$Local_NewChannel = F4($author$project$Types$Local_NewChannel$);
var $author$project$Types$Local_NewGuild$ = function (a, b, c) {
	return {$: 17, a: a, b: b, c: c};
};
var $author$project$Types$Local_NewGuild = F3($author$project$Types$Local_NewGuild$);
var $author$project$Types$Local_NewInviteLink$ = function (a, b, c) {
	return {$: 14, a: a, b: b, c: c};
};
var $author$project$Types$Local_NewInviteLink = F3($author$project$Types$Local_NewInviteLink$);
var $author$project$Types$Local_RegisterPushSubscription$ = function (a, b) {
	return {$: 46, a: a, b: b};
};
var $author$project$Types$Local_RegisterPushSubscription = F2($author$project$Types$Local_RegisterPushSubscription$);
var $author$project$Types$Local_RemoveReactionEmoji$ = function (a, b, c) {
	return {$: 20, a: a, b: b, c: c};
};
var $author$project$Types$Local_RemoveReactionEmoji = F3($author$project$Types$Local_RemoveReactionEmoji$);
var $author$project$Types$Local_RequestE2ee = function (a) {
	return {$: 68, a: a};
};
var $author$project$Call$Local_RequestRecording = {$: 2};
var $author$project$Types$Local_ScheduleAccountDeletion = function (a) {
	return {$: 44, a: a};
};
var $author$project$Types$Local_SendEditMessage$ = function (a, b, c, d, e, f) {
	return {$: 21, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Types$Local_SendEditMessage = F6($author$project$Types$Local_SendEditMessage$);
var $author$project$Types$Local_SendEncryptedEditMessage$ = function (a, b, c, d, e) {
	return {$: 78, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Types$Local_SendEncryptedEditMessage = F5($author$project$Types$Local_SendEncryptedEditMessage$);
var $author$project$Types$Local_SendEncryptedMessage$ = function (a, b, c, d, e, f) {
	return {$: 77, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Types$Local_SendEncryptedMessage = F6($author$project$Types$Local_SendEncryptedMessage$);
var $author$project$Types$Local_SendMessage$ = function (a, b, c, d, e, f, g) {
	return {$: 2, a: a, b: b, c: c, d: d, e: e, f: f, g: g};
};
var $author$project$Types$Local_SendMessage = F7($author$project$Types$Local_SendMessage$);
var $author$project$Types$Local_SetDiscordGuildNotificationLevel$ = function (a, b, c) {
	return {$: 36, a: a, b: b, c: c};
};
var $author$project$Types$Local_SetDiscordGuildNotificationLevel = F3($author$project$Types$Local_SetDiscordGuildNotificationLevel$);
var $author$project$Types$Local_SetDomainWhitelist$ = function (a, b) {
	return {$: 52, a: a, b: b};
};
var $author$project$Types$Local_SetDomainWhitelist = F2($author$project$Types$Local_SetDomainWhitelist$);
var $author$project$Types$Local_SetE2eeRisksAccepted = function (a) {
	return {$: 75, a: a};
};
var $author$project$Types$Local_SetEmailNotifications = function (a) {
	return {$: 42, a: a};
};
var $author$project$Types$Local_SetEmbedVisibility = function (a) {
	return {$: 43, a: a};
};
var $author$project$Types$Local_SetEmojiSkinTone = function (a) {
	return {$: 53, a: a};
};
var $author$project$Types$Local_SetGuildNotificationLevel$ = function (a, b) {
	return {$: 35, a: a, b: b};
};
var $author$project$Types$Local_SetGuildNotificationLevel = F2($author$project$Types$Local_SetGuildNotificationLevel$);
var $author$project$Types$Local_SetLastViewed$ = function (a, b) {
	return {$: 25, a: a, b: b};
};
var $author$project$Types$Local_SetLastViewed = F2($author$project$Types$Local_SetLastViewed$);
var $author$project$Types$Local_SetMuteChannel$ = function (a, b, c) {
	return {$: 59, a: a, b: b, c: c};
};
var $author$project$Types$Local_SetMuteChannel = F3($author$project$Types$Local_SetMuteChannel$);
var $author$project$Types$Local_SetMuteDiscordChannel$ = function (a, b, c, d) {
	return {$: 61, a: a, b: b, c: c, d: d};
};
var $author$project$Types$Local_SetMuteDiscordChannel = F4($author$project$Types$Local_SetMuteDiscordChannel$);
var $author$project$Types$Local_SetMuteDiscordGuild$ = function (a, b, c) {
	return {$: 64, a: a, b: b, c: c};
};
var $author$project$Types$Local_SetMuteDiscordGuild = F3($author$project$Types$Local_SetMuteDiscordGuild$);
var $author$project$Types$Local_SetMuteDiscordThread$ = function (a, b, c, d, e) {
	return {$: 62, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Types$Local_SetMuteDiscordThread = F5($author$project$Types$Local_SetMuteDiscordThread$);
var $author$project$Types$Local_SetMuteGuild$ = function (a, b) {
	return {$: 63, a: a, b: b};
};
var $author$project$Types$Local_SetMuteGuild = F2($author$project$Types$Local_SetMuteGuild$);
var $author$project$Types$Local_SetMuteSlackChannel$ = function (a, b, c, d) {
	return {$: 66, a: a, b: b, c: c, d: d};
};
var $author$project$Types$Local_SetMuteSlackChannel = F4($author$project$Types$Local_SetMuteSlackChannel$);
var $author$project$Types$Local_SetMuteSlackThread$ = function (a, b, c, d, e) {
	return {$: 67, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Types$Local_SetMuteSlackThread = F5($author$project$Types$Local_SetMuteSlackThread$);
var $author$project$Types$Local_SetMuteSlackWorkspace$ = function (a, b, c) {
	return {$: 65, a: a, b: b, c: c};
};
var $author$project$Types$Local_SetMuteSlackWorkspace = F3($author$project$Types$Local_SetMuteSlackWorkspace$);
var $author$project$Types$Local_SetMuteThread$ = function (a, b, c, d) {
	return {$: 60, a: a, b: b, c: c, d: d};
};
var $author$project$Types$Local_SetMuteThread = F4($author$project$Types$Local_SetMuteThread$);
var $author$project$Types$Local_SetName = function (a) {
	return {$: 28, a: a};
};
var $author$project$Types$Local_SetNotificationMode = function (a) {
	return {$: 38, a: a};
};
var $author$project$Types$Local_SetPublicKey$ = function (a, b) {
	return {$: 71, a: a, b: b};
};
var $author$project$Types$Local_SetPublicKey = F2($author$project$Types$Local_SetPublicKey$);
var $author$project$Call$Local_SetRemoteCallData = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$Local_SetSheepGameQuestions = function (a) {
	return {$: 41, a: a};
};
var $author$project$Types$Local_SetSlackWorkspaceNotificationLevel$ = function (a, b, c) {
	return {$: 37, a: a, b: b, c: c};
};
var $author$project$Types$Local_SetSlackWorkspaceNotificationLevel = F3($author$project$Types$Local_SetSlackWorkspaceNotificationLevel$);
var $author$project$Types$Local_SetUserColor = function (a) {
	return {$: 54, a: a};
};
var $author$project$Types$Local_Slack_ReloadUser = function (a) {
	return {$: 7, a: a};
};
var $author$project$Types$Local_Slack_SendEditMessage$ = function (a, b, c, d, e) {
	return {$: 5, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Types$Local_Slack_SendEditMessage = F5($author$project$Types$Local_Slack_SendEditMessage$);
var $author$project$Types$Local_Slack_SendMessage$ = function (a, b, c, d, e, f) {
	return {$: 4, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Types$Local_Slack_SendMessage = F6($author$project$Types$Local_Slack_SendMessage$);
var $author$project$Types$Local_Slack_UnlinkUser = function (a) {
	return {$: 6, a: a};
};
var $author$project$Types$Local_StartReloadingDiscordUser$ = function (a, b) {
	return {$: 49, a: a, b: b};
};
var $author$project$Types$Local_StartReloadingDiscordUser = F2($author$project$Types$Local_StartReloadingDiscordUser$);
var $author$project$Types$Local_TextEditor = function (a) {
	return {$: 47, a: a};
};
var $author$project$Types$Local_UnlinkDiscordUser = function (a) {
	return {$: 48, a: a};
};
var $author$project$Types$Local_VoiceChatChange = function (a) {
	return {$: 56, a: a};
};
var $author$project$Types$LogOutRequest = function (a) {
	return {$: 6, a: a};
};
var $author$project$Types$LoginFormMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Types$LoginWithRecoveryPasswordRequest$ = function (a, b, c) {
	return {$: 4, a: a, b: b, c: c};
};
var $author$project$Types$LoginWithRecoveryPasswordRequest = F3($author$project$Types$LoginWithRecoveryPasswordRequest$);
var $author$project$Types$LoginWithTokenRequest$ = function (a, b, c) {
	return {$: 1, a: a, b: b, c: c};
};
var $author$project$Types$LoginWithTokenRequest = F3($author$project$Types$LoginWithTokenRequest$);
var $author$project$Types$LoginWithTwoFactorRequest$ = function (a, b, c) {
	return {$: 2, a: a, b: b, c: c};
};
var $author$project$Types$LoginWithTwoFactorRequest = F3($author$project$Types$LoginWithTwoFactorRequest$);
var $author$project$Drawing$MessageAnchor$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Drawing$MessageAnchor = F2($author$project$Drawing$MessageAnchor$);
var $author$project$Types$MessageMenu = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$MessageMenuClosing$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Types$MessageMenuClosing = F2($author$project$Types$MessageMenuClosing$);
var $author$project$Types$MessageMenuDragging = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$MessageMenuFixed = function (a) {
	return {$: 3, a: a};
};
var $author$project$Types$MessageMenuOpening = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$PageFocusSettled = {$: 123};
var $author$project$Types$ProfilePictureEditorToBackend = function (a) {
	return {$: 15, a: a};
};
var $author$project$Types$PublicGoMatch_Loaded$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Types$PublicGoMatch_Loaded = F2($author$project$Types$PublicGoMatch_Loaded$);
var $author$project$Types$ReactionPopup$ = function (a, b, c) {
	return {$: 3, a: a, b: b, c: c};
};
var $author$project$Types$ReactionPopup = F3($author$project$Types$ReactionPopup$);
var $author$project$Types$RecoveryLoginMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Types$RemoveFocus = {$: 40};
var $author$project$Scroll$ScrolledCloseToBottom = 1;
var $author$project$Types$SelectedFilesToAttach$ = function (a, b, c) {
	return {$: 13, a: a, b: b, c: c};
};
var $author$project$Types$SelectedFilesToAttach = F3($author$project$Types$SelectedFilesToAttach$);
var $author$project$Types$SelectedImportChannelFile$ = function (a, b) {
	return {$: 25, a: a, b: b};
};
var $author$project$Types$SelectedImportChannelFile = F2($author$project$Types$SelectedImportChannelFile$);
var $author$project$Drawing$TimestampAnchor = {$: 1};
var $author$project$Types$TwoFactorMsg = function (a) {
	return {$: 75, a: a};
};
var $author$project$Types$TwoFactorToBackend = function (a) {
	return {$: 8, a: a};
};
var $author$project$Drawing$UserIconAnchor = {$: 0};
var $author$project$UserSession$UserOption_Settings = 1;
var $author$project$User$accountDeletionDelayInWeeks = 2;
var $author$project$FileStatus$FileError$ = function (a, b, c, d, e) {
	return {$: 2, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$FileStatus$FileError = F5($author$project$FileStatus$FileError$);
var $author$project$FileStatus$uploadResponseMetadata = function (data) {
	var _v0 = _Utils_Tuple2(data.imageMetadata, data.videoMetadata);
	if (!_v0.b.$) {
		var videoMetadata = _v0.b.a;
		return $elm$core$Maybe$Just(
			$author$project$FileStatus$FileMetadata_Video(videoMetadata));
	} else {
		if (!_v0.a.$) {
			var imageMetadata = _v0.a.a;
			var _v1 = _v0.b;
			return $elm$core$Maybe$Just(
				$author$project$FileStatus$FileMetadata_Image(imageMetadata));
		} else {
			var _v2 = _v0.a;
			var _v3 = _v0.b;
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$FileStatus$addFileHash$ = function (clientMetadata, result, fileStatus) {
	switch (fileStatus.$) {
		case 0:
			var fileName = fileStatus.a;
			var fileSize = fileStatus.b;
			var contentType2 = fileStatus.c;
			var isEncrypted = fileStatus.d;
			if (!result.$) {
				var data = result.a;
				return $author$project$FileStatus$FileUploaded(
					{
						contentType: contentType2,
						fileHash: data.fileHash,
						fileName: fileName,
						fileSize: fileSize.size,
						isEncrypted: isEncrypted,
						metadata: function () {
							var _v2 = $author$project$FileStatus$uploadResponseMetadata(data);
							if (!_v2.$) {
								var serverMetadata = _v2.a;
								return $elm$core$Maybe$Just(serverMetadata);
							} else {
								return clientMetadata;
							}
						}()
					});
			} else {
				var error = result.a;
				return $author$project$FileStatus$FileError$(fileName, fileSize.size, contentType2, error, isEncrypted);
			}
		case 1:
			return fileStatus;
		default:
			return fileStatus;
	}
};
var $author$project$FileStatus$addFileHash = F3($author$project$FileStatus$addFileHash$);
var $author$project$SheepGame$Action = function (a) {
	return {$: 1, a: a};
};
var $author$project$SheepGame$AddedReaction$ = function (a, b) {
	return {$: 7, a: a, b: b};
};
var $author$project$SheepGame$AddedReaction = F2($author$project$SheepGame$AddedReaction$);
var $author$project$Game$LocalChange_SheepGame$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $author$project$Game$LocalChange_SheepGame = F2($author$project$Game$LocalChange_SheepGame$);
var $author$project$Frontend$addSheepGameReaction$ = function (guildOrDmId, matchId, target, emoji, model, loggedIn) {
	return $author$project$FrontendExtra$handleLocalChange$(
		model.time,
		$elm$core$Maybe$Just(
			$author$project$Types$Local_Game$(
				guildOrDmId,
				$author$project$Game$LocalChange_SheepGame$(
					matchId,
					$author$project$SheepGame$Action(
						{
							change: $author$project$SheepGame$AddedReaction$(target, emoji),
							time: model.time,
							userId: $author$project$Local$model(loggedIn.localState).localUser.session.userId
						})))),
		_Utils_update(
			loggedIn,
			{showEmojiSelector: $author$project$Types$EmojiSelectorHidden}),
		$lamdera$program_test$Effect$Command$none);
};
var $author$project$Frontend$addSheepGameReaction = F6($author$project$Frontend$addSheepGameReaction$);
var $author$project$WordSpellingGame$Action = function (a) {
	return {$: 1, a: a};
};
var $author$project$WordSpellingGame$AddedReaction$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$WordSpellingGame$AddedReaction = F2($author$project$WordSpellingGame$AddedReaction$);
var $author$project$Game$LocalChange_WordSpellingGame$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Game$LocalChange_WordSpellingGame = F2($author$project$Game$LocalChange_WordSpellingGame$);
var $author$project$Frontend$addWordSpellingGameReaction$ = function (guildOrDmId, matchId, target, emoji, model, loggedIn) {
	return $author$project$FrontendExtra$handleLocalChange$(
		model.time,
		$elm$core$Maybe$Just(
			$author$project$Types$Local_Game$(
				guildOrDmId,
				$author$project$Game$LocalChange_WordSpellingGame$(
					matchId,
					$author$project$WordSpellingGame$Action(
						{
							change: $author$project$WordSpellingGame$AddedReaction$(target, emoji),
							time: model.time,
							userId: $author$project$Local$model(loggedIn.localState).localUser.session.userId
						})))),
		_Utils_update(
			loggedIn,
			{showEmojiSelector: $author$project$Types$EmojiSelectorHidden}),
		$lamdera$program_test$Effect$Command$none);
};
var $author$project$Frontend$addWordSpellingGameReaction = F6($author$project$Frontend$addWordSpellingGameReaction$);
var $author$project$Geometry$Types$Vector2d = $elm$core$Basics$identity;
var $author$project$Vector2d$scaleBy$ = function (k, _v0) {
	var v = _v0;
	return {x: k * v.x, y: k * v.y};
};
var $author$project$Vector2d$scaleBy = F2($author$project$Vector2d$scaleBy$);
var $author$project$Vector2d$divideBy$ = function (scale, vector) {
	return $author$project$Vector2d$scaleBy$(1 / scale, vector);
};
var $author$project$Vector2d$divideBy = F2($author$project$Vector2d$divideBy$);
var $author$project$Vector2d$from$ = function (_v0, _v1) {
	var p1 = _v0;
	var p2 = _v1;
	return {x: p2.x - p1.x, y: p2.y - p1.y};
};
var $author$project$Vector2d$from = F2($author$project$Vector2d$from$);
var $lamdera$containers$SeqDict$merge$ = function (leftStep, bothStep, rightStep, _v0, rightDict, initialResult) {
	var leftIntDict = _v0.c;
	var helper2 = F2(
		function (_v6, acc) {
			var key = _v6.b;
			var value = _v6.c;
			return A3(rightStep, key, value, acc);
		});
	var helper = F2(
		function (_v4, _v5) {
			var hash = _v4.a;
			var key = _v4.b;
			var value = _v4.c;
			var acc = _v5.a;
			var rightDict2 = _v5.b;
			var rightBitmap = rightDict2.a;
			var rightNodeArray = rightDict2.b;
			var rightIntDict = rightDict2.c;
			var _v3 = $lamdera$containers$SeqDict$getHelp$(0, hash, key, rightBitmap, rightNodeArray);
			if (!_v3.$) {
				var value2 = _v3.a;
				return _Utils_Tuple2(
					A4(bothStep, key, value, value2, acc),
					$lamdera$containers$SeqDict$removeHelp$(0, hash, key, rightBitmap, rightNodeArray, rightIntDict));
			} else {
				return _Utils_Tuple2(
					A3(leftStep, key, value, acc),
					rightDict2);
			}
		});
	var _v1 = $lamdera$containers$SeqDict$intDictFoldl$(
		helper,
		_Utils_Tuple2(initialResult, rightDict),
		leftIntDict);
	var acc2 = _v1.a;
	var _v2 = _v1.b;
	var rightIntDict2 = _v2.c;
	return $lamdera$containers$SeqDict$intDictFoldl$(helper2, acc2, rightIntDict2);
};
var $lamdera$containers$SeqDict$merge = F6($lamdera$containers$SeqDict$merge$);
var $author$project$NonemptyDict$merge$ = function (left, both, right, dict1, dict2, result) {
	return $lamdera$containers$SeqDict$merge$(
		left,
		both,
		right,
		$author$project$NonemptyDict$toSeqDict(dict1),
		$author$project$NonemptyDict$toSeqDict(dict2),
		result);
};
var $author$project$NonemptyDict$merge = F6($author$project$NonemptyDict$merge$);
var $author$project$Vector2d$plus$ = function (_v0, _v1) {
	var v2 = _v0;
	var v1 = _v1;
	return {x: v1.x + v2.x, y: v1.y + v2.y};
};
var $author$project$Vector2d$plus = F2($author$project$Vector2d$plus$);
var $author$project$Vector2d$zero = {x: 0, y: 0};
var $author$project$Touch$averageTouchMove$ = function (oldTouches, newTouches) {
	return function (a) {
		return (a.count > 0) ? $author$project$Vector2d$divideBy$(a.count, a.total) : $author$project$Vector2d$zero;
	}(
		$author$project$NonemptyDict$merge$(
			F3(
				function (_v0, _v1, state) {
					return state;
				}),
			F4(
				function (_v2, _new, old, state) {
					return {
						count: state.count + 1,
						total: $author$project$Vector2d$plus$(
							state.total,
							$author$project$Vector2d$from$(old.client, _new.client))
					};
				}),
			F3(
				function (_v3, _v4, state) {
					return state;
				}),
			newTouches,
			oldTouches,
			{count: 0, total: $author$project$Vector2d$zero}));
};
var $author$project$Touch$averageTouchMove = F2($author$project$Touch$averageTouchMove$);
var $lamdera$program_test$Effect$Browser$Dom$blur = function (htmlId) {
	return $lamdera$program_test$Effect$Internal$Blur$(
		$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId),
		function (result) {
			if (!result.$) {
				var ok = result.a;
				return $lamdera$program_test$Effect$Internal$Succeed(ok);
			} else {
				var err = result.a;
				return $lamdera$program_test$Effect$Internal$Fail(
					$lamdera$program_test$Effect$Browser$Dom$id(err));
			}
		});
};
var $author$project$Types$EditMessage_GotFileHashName$ = function (a, b, c, d) {
	return {$: 94, a: a, b: b, c: c, d: d};
};
var $author$project$Types$EditMessage_GotFileHashName = F4($author$project$Types$EditMessage_GotFileHashName$);
var $author$project$OneToOne$removeFirst$ = function (a, _v0) {
	var firstToSecond = _v0.a;
	var secondToFirst = _v0.b;
	return $author$project$OneToOne$OneToOne$(
		$lamdera$containers$SeqDict$remove$(a, firstToSecond),
		$elm$core$Maybe$withDefault$(
			secondToFirst,
			$elm$core$Maybe$map$(
				function (b) {
					return $lamdera$containers$SeqDict$remove$(b, secondToFirst);
				},
				$lamdera$containers$SeqDict$get$(a, firstToSecond))));
};
var $author$project$OneToOne$removeFirst = F2($author$project$OneToOne$removeFirst$);
var $author$project$OneToOne$removeSecond$ = function (b, _v0) {
	var firstToSecond = _v0.a;
	var secondToFirst = _v0.b;
	return $author$project$OneToOne$OneToOne$(
		$elm$core$Maybe$withDefault$(
			firstToSecond,
			$elm$core$Maybe$map$(
				function (a) {
					return $lamdera$containers$SeqDict$remove$(a, firstToSecond);
				},
				$lamdera$containers$SeqDict$get$(b, secondToFirst))),
		$lamdera$containers$SeqDict$remove$(b, secondToFirst));
};
var $author$project$OneToOne$removeSecond = F2($author$project$OneToOne$removeSecond$);
var $author$project$OneToOne$insert$ = function (a, b, oneToOne) {
	return function (_v0) {
		var firstToSecond = _v0.a;
		var secondToFirst = _v0.b;
		return $author$project$OneToOne$OneToOne$(
			$lamdera$containers$SeqDict$insert$(a, b, firstToSecond),
			$lamdera$containers$SeqDict$insert$(b, a, secondToFirst));
	}(
		$author$project$OneToOne$removeSecond$(
			b,
			$author$project$OneToOne$removeFirst$(a, oneToOne)));
};
var $author$project$OneToOne$insert = F3($author$project$OneToOne$insert$);
var $author$project$OneToOne$fromList = function (associations) {
	return $elm$core$List$foldl$(
		F2(
			function (_v0, oneToOne) {
				var a = _v0.a;
				var b = _v0.b;
				return $author$project$OneToOne$insert$(a, b, oneToOne);
			}),
		$author$project$OneToOne$empty,
		associations);
};
var $author$project$FileStatus$contentTypes = $author$project$OneToOne$fromList(
	$elm$core$List$indexedMap$(
		F2(
			function (index, contentType2) {
				return _Utils_Tuple2(index, contentType2);
			}),
		_List_fromArray(
			['image/gif', 'image/jpeg', 'image/png', 'image/webp', 'text/plain', 'text/calendar', 'text/css', 'text/csv', 'text/html', 'text/javascript', 'text/markdown', 'text/mathml', 'text/prs.lines.tag', 'text/richtext', 'text/sgml', 'text/tab-separated-values', 'text/troff', 'text/uri-list', 'text/vnd.curl', 'text/vnd.curl.dcurl', 'text/vnd.curl.mcurl', 'text/vnd.curl.scurl', 'text/vnd.fly', 'text/vnd.fmi.flexstor', 'text/vnd.graphviz', 'text/vnd.in3d.3dml', 'text/vnd.in3d.spot', 'text/vnd.sun.j2me.app-descriptor', 'text/vnd.wap.si', 'text/vnd.wap.sl', 'text/vnd.wap.wml', 'text/vnd.wap.wmlscript', 'text/x-asm', 'text/x-c', 'text/x-fortran', 'text/x-java-source', 'text/x-pascal', 'text/x-python', 'text/x-setext', 'text/x-uuencode', 'text/x-vcalendar', 'text/x-vcard', 'video/3gpp', 'video/3gpp2', 'video/h261', 'video/h263', 'video/h264', 'video/jpeg', 'video/jpm', 'video/mj2', 'video/mp2t', 'video/mp4', 'video/mpeg', 'video/ogg', 'video/quicktime', 'video/vnd.fvt', 'video/vnd.mpegurl', 'video/vnd.ms-playready.media.pyv', 'video/vnd.vivo', 'video/webm', 'video/x-f4v', 'video/x-fli', 'video/x-flv', 'video/x-m4v', 'video/x-matroska', 'video/x-ms-asf', 'video/x-ms-wm', 'video/x-ms-wmv', 'video/x-ms-wmx', 'video/x-ms-wvx', 'video/x-msvideo', 'video/x-sgi-movie', 'audio/3gpp2', 'audio/aac', 'audio/aacp', 'audio/adpcm', 'audio/aiff', 'audio/x-aiff', 'audio/basic', 'audio/flac', 'audio/midi', 'audio/mp4', 'audio/mp4a-latm', 'audio/mpeg', 'audio/ogg', 'audio/opus', 'audio/vnd.digital-winds', 'audio/vnd.dts', 'audio/vnd.dts.hd', 'audio/vnd.lucent.voice', 'audio/vnd.ms-playready.media.pya', 'audio/vnd.nuera.ecelp4800', 'audio/vnd.nuera.ecelp7470', 'audio/vnd.nuera.ecelp9600', 'audio/vnd.wav', 'audio/wav', 'audio/x-wav', 'audio/vnd.wave', 'audio/wave', 'audio/webm', 'audio/x-pn-wav', 'audio/x-matroska', 'audio/x-mpegurl', 'audio/x-ms-wax', 'audio/x-ms-wma', 'audio/x-pn-realaudio', 'audio/x-pn-realaudio-plugin', 'application/andrew-inset', 'application/applixware', 'application/atom+xml', 'application/atomcat+xml', 'application/atomsvc+xml', 'application/ccxml+xml', 'application/cu-seeme', 'application/davmount+xml', 'application/ecmascript', 'application/emma+xml', 'application/epub+zip', 'application/font-tdpfr', 'application/gzip', 'application/hyperstudio', 'application/java-archive', 'application/java-serialized-object', 'application/java-vm', 'application/json', 'application/lost+xml', 'application/mac-binhex40', 'application/mac-compactpro', 'application/marc', 'application/mathematica', 'application/mathml+xml', 'application/mbox', 'application/mediaservercontrol+xml', 'application/mp4', 'application/msword', 'application/mxf', 'application/octet-stream', 'application/oda', 'application/oebps-package+xml', 'application/ogg', 'application/onenote', 'application/patch-ops-error+xml', 'application/pdf', 'application/pgp-encrypted', 'application/pgp-signature', 'application/pics-rules', 'application/pkcs10', 'application/pkcs7-mime', 'application/pkcs7-signature', 'application/pkix-cert', 'application/pkix-crl', 'application/pkix-pkipath', 'application/pkixcmp', 'application/pls+xml', 'application/postscript', 'application/prql', 'application/prs.cww', 'application/rdf+xml', 'application/reginfo+xml', 'application/relax-ng-compact-syntax', 'application/resource-lists+xml', 'application/resource-lists-diff+xml', 'application/rls-services+xml', 'application/rsd+xml', 'application/rss+xml', 'application/rtf', 'application/sbml+xml', 'application/scvp-cv-request', 'application/scvp-cv-response', 'application/scvp-vp-request', 'application/scvp-vp-response', 'application/sdp', 'application/set-payment-initiation', 'application/set-registration-initiation', 'application/shf+xml', 'application/smil+xml', 'application/sparql-query', 'application/sparql-results+xml', 'application/srgs', 'application/srgs+xml', 'application/ssml+xml', 'application/vnd.3gpp.pic-bw-large', 'application/vnd.3gpp.pic-bw-small', 'application/vnd.3gpp.pic-bw-var', 'application/vnd.3gpp2.tcap', 'application/vnd.3m.post-it-notes', 'application/vnd.accpac.simply.aso', 'application/vnd.accpac.simply.imp', 'application/vnd.acucobol', 'application/vnd.acucorp', 'application/vnd.adobe.air-application-installer-package+zip', 'application/vnd.adobe.xdp+xml', 'application/vnd.adobe.xfdf', 'application/vnd.airzip.filesecure.azf', 'application/vnd.airzip.filesecure.azs', 'application/vnd.amazon.ebook', 'application/vnd.americandynamics.acc', 'application/vnd.amiga.ami', 'application/vnd.android.package-archive', 'application/vnd.anser-web-certificate-issue-initiation', 'application/vnd.anser-web-funds-transfer-initiation', 'application/vnd.antix.game-component', 'application/vnd.apple.installer+xml', 'application/vnd.arastra.swi', 'application/vnd.audiograph', 'application/vnd.blueice.multipass', 'application/vnd.bmi', 'application/vnd.businessobjects', 'application/vnd.chemdraw+xml', 'application/vnd.chipnuts.karaoke-mmd', 'application/vnd.cinderella', 'application/vnd.claymore', 'application/vnd.clonk.c4group', 'application/vnd.commonspace', 'application/vnd.contact.cmsg', 'application/vnd.cosmocaller', 'application/vnd.crick.clicker', 'application/vnd.crick.clicker.keyboard', 'application/vnd.crick.clicker.palette', 'application/vnd.crick.clicker.template', 'application/vnd.crick.clicker.wordbank', 'application/vnd.criticaltools.wbs+xml', 'application/vnd.ctc-posml', 'application/vnd.cups-ppd', 'application/vnd.curl.car', 'application/vnd.curl.pcurl', 'application/vnd.data-vision.rdz', 'application/vnd.debian.binary-package', 'application/vnd.denovo.fcselayout-link', 'application/vnd.dna', 'application/vnd.dolby.mlp', 'application/vnd.dpgraph', 'application/vnd.dreamfactory', 'application/vnd.dynageo', 'application/vnd.ecowin.chart', 'application/vnd.enliven', 'application/vnd.epson.esf', 'application/vnd.epson.msf', 'application/vnd.epson.quickanime', 'application/vnd.epson.salt', 'application/vnd.epson.ssf', 'application/vnd.eszigno3+xml', 'application/vnd.ezpix-album', 'application/vnd.ezpix-package', 'application/vnd.fdf', 'application/vnd.fdsn.mseed', 'application/vnd.fdsn.seed', 'application/vnd.flographit', 'application/vnd.fluxtime.clip', 'application/vnd.framemaker', 'application/vnd.frogans.fnc', 'application/vnd.frogans.ltf', 'application/vnd.fsc.weblaunch', 'application/vnd.fujitsu.oasys', 'application/vnd.fujitsu.oasys2', 'application/vnd.fujitsu.oasys3', 'application/vnd.fujitsu.oasysgp', 'application/vnd.fujitsu.oasysprs', 'application/vnd.fujixerox.ddd', 'application/vnd.fujixerox.docuworks', 'application/vnd.fujixerox.docuworks.binder', 'application/vnd.fuzzysheet', 'application/vnd.genomatix.tuxedo', 'application/vnd.geogebra.file', 'application/vnd.geogebra.tool', 'application/vnd.geometry-explorer', 'application/vnd.gerber', 'application/vnd.gmx', 'application/vnd.google-earth.kml+xml', 'application/vnd.google-earth.kmz', 'application/vnd.grafeq', 'application/vnd.groove-account', 'application/vnd.groove-help', 'application/vnd.groove-identity-message', 'application/vnd.groove-injector', 'application/vnd.groove-tool-message', 'application/vnd.groove-tool-template', 'application/vnd.groove-vcard', 'application/vnd.handheld-entertainment+xml', 'application/vnd.hbci', 'application/vnd.hhe.lesson-player', 'application/vnd.hp-hpgl', 'application/vnd.hp-hpid', 'application/vnd.hp-hps', 'application/vnd.hp-jlyt', 'application/vnd.hp-pcl', 'application/vnd.hp-pclxl', 'application/vnd.hydrostatix.sof-data\u0009.sf', 'application/vnd.hzn-3d-crossword', 'application/vnd.ibm.minipay', 'application/vnd.ibm.modcap', 'application/vnd.ibm.rights-management', 'application/vnd.ibm.secure-container', 'application/vnd.iccprofile', 'application/vnd.igloader', 'application/vnd.immervision-ivp', 'application/vnd.immervision-ivu', 'application/vnd.intercon.formnet', 'application/vnd.intu.qbo', 'application/vnd.intu.qfx', 'application/vnd.ipunplugged.rcprofile', 'application/vnd.irepository.package+xml', 'application/vnd.is-xpr', 'application/vnd.jam', 'application/vnd.jcp.javame.midlet-rms', 'application/vnd.jisp', 'application/vnd.joost.joda-archive', 'application/vnd.kahootz', 'application/vnd.kde.karbon', 'application/vnd.kde.kchart', 'application/vnd.kde.kformula', 'application/vnd.kde.kivio', 'application/vnd.kde.kontour', 'application/vnd.kde.kpresenter', 'application/vnd.kde.kspread', 'application/vnd.kde.kword', 'application/vnd.kenameaapp', 'application/vnd.kidspiration', 'application/vnd.kinar', 'application/vnd.koan', 'application/vnd.kodak-descriptor', 'application/vnd.llamagraphics.life-balance.desktop', 'application/vnd.llamagraphics.life-balance.exchange+xml', 'application/vnd.lotus-1-2-3', 'application/vnd.lotus-approach', 'application/vnd.lotus-freelance', 'application/vnd.lotus-notes', 'application/vnd.lotus-organizer', 'application/vnd.lotus-screencam', 'application/vnd.lotus-wordpro', 'application/vnd.macports.portpkg', 'application/vnd.mcd', 'application/vnd.medcalcdata', 'application/vnd.mediastation.cdkey', 'application/vnd.mfer', 'application/vnd.mfmp', 'application/vnd.micrografx.flo', 'application/vnd.micrografx.igx', 'application/vnd.mif', 'application/vnd.mobius.daf', 'application/vnd.mobius.dis', 'application/vnd.mobius.mbk', 'application/vnd.mobius.mqy', 'application/vnd.mobius.msl', 'application/vnd.mobius.plc', 'application/vnd.mobius.txf', 'application/vnd.mophun.application', 'application/vnd.mophun.certificate', 'application/vnd.mozilla.xul+xml', 'application/vnd.ms-artgalry', 'application/vnd.ms-cab-compressed', 'application/vnd.ms-excel', 'application/vnd.ms-excel.addin.macroenabled.12', 'application/vnd.ms-excel.sheet.binary.macroenabled.12', 'application/vnd.ms-excel.sheet.macroenabled.12', 'application/vnd.ms-excel.template.macroenabled.12', 'application/vnd.ms-fontobject', 'application/vnd.ms-htmlhelp', 'application/vnd.ms-ims', 'application/vnd.ms-lrm', 'application/vnd.ms-pki.seccat', 'application/vnd.ms-pki.stl', 'application/vnd.ms-powerpoint', 'application/vnd.ms-powerpoint.addin.macroenabled.12', 'application/vnd.ms-powerpoint.presentation.macroenabled.12', 'application/vnd.ms-powerpoint.slide.macroenabled.12', 'application/vnd.ms-powerpoint.slideshow.macroenabled.12', 'application/vnd.ms-powerpoint.template.macroenabled.12', 'application/vnd.ms-project', 'application/vnd.ms-word.document.macroenabled.12', 'application/vnd.ms-word.template.macroenabled.12', 'application/vnd.ms-works', 'application/vnd.ms-wpl', 'application/vnd.ms-xpsdocument', 'application/vnd.mseq', 'application/vnd.musician', 'application/vnd.muvee.style', 'application/vnd.neurolanguage.nlu', 'application/vnd.noblenet-directory', 'application/vnd.noblenet-sealer', 'application/vnd.noblenet-web', 'application/vnd.nokia.n-gage.data', 'application/vnd.nokia.n-gage.symbian.install\u0009.', 'application/vnd.nokia.radio-preset', 'application/vnd.nokia.radio-presets', 'application/vnd.novadigm.edm', 'application/vnd.novadigm.edx', 'application/vnd.novadigm.ext', 'application/vnd.oasis.opendocument.chart', 'application/vnd.oasis.opendocument.chart-template', 'application/vnd.oasis.opendocument.database', 'application/vnd.oasis.opendocument.formula', 'application/vnd.oasis.opendocument.formula-template', 'application/vnd.oasis.opendocument.graphics', 'application/vnd.oasis.opendocument.graphics-template', 'application/vnd.oasis.opendocument.image', 'application/vnd.oasis.opendocument.image-template', 'application/vnd.oasis.opendocument.presentation', 'application/vnd.oasis.opendocument.presentation-template', 'application/vnd.oasis.opendocument.spreadsheet', 'application/vnd.oasis.opendocument.spreadsheet-template', 'application/vnd.oasis.opendocument.text', 'application/vnd.oasis.opendocument.text-master', 'application/vnd.oasis.opendocument.text-template', 'application/vnd.oasis.opendocument.text-web', 'application/vnd.olpc-sugar', 'application/vnd.oma.dd2+xml', 'application/vnd.openofficeorg.extension', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/vnd.openxmlformats-officedocument.presentationml.slide', 'application/vnd.openxmlformats-officedocument.presentationml.slideshow', 'application/vnd.openxmlformats-officedocument.presentationml.template', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.openxmlformats-officedocument.spreadsheetml.template', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.openxmlformats-officedocument.wordprocessingml.template', 'application/vnd.osgi.dp', 'application/vnd.palm', 'application/vnd.pg.format', 'application/vnd.pg.osasli', 'application/vnd.picsel', 'application/vnd.pocketlearn', 'application/vnd.powerbuilder6', 'application/vnd.previewsystems.box', 'application/vnd.proteus.magazine', 'application/vnd.publishare-delta-tree', 'application/vnd.pvi.ptid1', 'application/vnd.quark.quarkxpress', 'application/vnd.rar', 'application/vnd.recordare.musicxml', 'application/vnd.recordare.musicxml+xml', 'application/vnd.rim.cod', 'application/vnd.rn-realmedia', 'application/vnd.route66.link66+xml', 'application/vnd.seemail', 'application/vnd.sema', 'application/vnd.semd', 'application/vnd.semf', 'application/vnd.shana.informed.formdata', 'application/vnd.shana.informed.formtemplate', 'application/vnd.shana.informed.interchange', 'application/vnd.shana.informed.package', 'application/vnd.simtech-mindmapper', 'application/vnd.smaf', 'application/vnd.smart.teacher', 'application/vnd.solent.sdkm+xml', 'application/vnd.spotfire.dxp', 'application/vnd.spotfire.sfs', 'application/vnd.sqlite3', 'application/vnd.stardivision.calc', 'application/vnd.stardivision.draw', 'application/vnd.stardivision.impress', 'application/vnd.stardivision.math', 'application/vnd.stardivision.writer', 'application/vnd.stardivision.writer-global', 'application/vnd.sun.xml.calc', 'application/vnd.sun.xml.calc.template', 'application/vnd.sun.xml.draw', 'application/vnd.sun.xml.draw.template', 'application/vnd.sun.xml.impress', 'application/vnd.sun.xml.impress.template', 'application/vnd.sun.xml.math', 'application/vnd.sun.xml.writer', 'application/vnd.sun.xml.writer.global', 'application/vnd.sun.xml.writer.template', 'application/vnd.sus-calendar', 'application/vnd.svd', 'application/vnd.symbian.install', 'application/vnd.syncml+xml', 'application/vnd.syncml.dm+wbxml', 'application/vnd.syncml.dm+xml', 'application/vnd.tao.intent-module-archive', 'application/vnd.tmobile-livetv', 'application/vnd.trid.tpt', 'application/vnd.triscape.mxs', 'application/vnd.trueapp', 'application/vnd.ufdl', 'application/vnd.uiq.theme', 'application/vnd.umajin', 'application/vnd.unity', 'application/vnd.uoml+xml', 'application/vnd.vcx', 'application/vnd.visio', 'application/vnd.visionary', 'application/vnd.vsf', 'application/vnd.wap.sic', 'application/vnd.wap.slc', 'application/vnd.wap.wbxml', 'application/vnd.wap.wmlc', 'application/vnd.wap.wmlscriptc', 'application/vnd.webturbo', 'application/vnd.wordperfect', 'application/vnd.wqd', 'application/vnd.wt.stf', 'application/vnd.xara', 'application/vnd.xfdl', 'application/vnd.yamaha.hv-dic', 'application/vnd.yamaha.hv-script', 'application/vnd.yamaha.hv-voice', 'application/vnd.yamaha.openscoreformat', 'application/vnd.yamaha.openscoreformat.osfpvg+xml', 'application/vnd.yamaha.smaf-audio', 'application/vnd.yamaha.smaf-phrase', 'application/vnd.yellowriver-custom-menu', 'application/vnd.zul', 'application/vnd.zzazz.deck+xml', 'application/voicexml+xml', 'application/wasm', 'application/winhlp', 'application/wsdl+xml', 'application/wspolicy+xml', 'application/x-7z-compressed', 'application/x-abiword', 'application/x-ace-compressed', 'application/x-authorware-bin', 'application/x-authorware-map', 'application/x-authorware-seg', 'application/x-bcpio', 'application/x-bittorrent', 'application/x-bzip', 'application/x-bzip2', 'application/x-cdlink', 'application/x-chat', 'application/x-chess-pgn', 'application/x-cpio', 'application/x-csh', 'application/x-debian-package', 'application/x-director', 'application/x-doom', 'application/x-dtbncx+xml', 'application/x-dtbook+xml', 'application/x-dtbresource+xml', 'application/x-dvi', 'application/x-font-bdf', 'application/x-font-ghostscript', 'application/x-font-linux-psf', 'application/x-font-otf', 'application/x-font-pcf', 'application/x-font-snf', 'application/x-font-ttf', 'application/x-font-type1', 'application/x-futuresplash', 'application/x-gnumeric', 'application/x-gtar', 'application/x-gzip', 'application/x-hdf', 'application/x-iso9660-image', 'application/x-java-jnlp-file', 'application/x-killustrator', 'application/x-krita', 'application/x-latex', 'application/x-mobipocket-ebook', 'application/x-ms-application', 'application/x-ms-wmd', 'application/x-ms-wmz', 'application/x-ms-xbap', 'application/x-msaccess', 'application/x-msbinder', 'application/x-mscardfile', 'application/x-msclip', 'application/x-msdownload', 'application/x-msmediaview', 'application/x-msmetafile', 'application/x-msmoney', 'application/x-mspublisher', 'application/x-msschedule', 'application/x-msterminal', 'application/x-mswrite', 'application/x-netcdf', 'application/x-perl', 'application/x-pkcs12', 'application/x-pkcs7-certificates', 'application/x-pkcs7-certreqresp', 'application/x-rar-compressed', 'application/x-redhat-package-manager', 'application/x-rpm', 'application/x-sh', 'application/x-shar', 'application/x-shellscript', 'application/x-shockwave-flash', 'application/x-silverlight-app', 'application/x-stuffit', 'application/x-stuffitx', 'application/x-sv4cpio', 'application/x-sv4crc', 'application/x-tar', 'application/x-tcl', 'application/x-tex', 'application/x-tex-tfm', 'application/x-texinfo', 'application/', 'application/x-ustar', 'application/x-wais-source', 'application/x-x509-ca-cert', 'application/x-xfig', 'application/x-xpinstall', 'application/x-zip-compressed', 'application/xenc+xml', 'application/xhtml+xml', 'application/xml', 'application/xml-dtd', 'application/xop+xml', 'application/xslt+xml', 'application/xspf+xml', 'application/xv+xml', 'application/yaml', 'application/zip', 'application/zip-compressed', 'chemical/x-cdx', 'chemical/x-cif', 'chemical/x-cmdf', 'chemical/x-cml', 'chemical/x-csml', 'chemical/x-xyz', 'font/otf', 'font/woff', 'font/woff2', 'gcode', 'image/avif', 'image/avif-sequence', 'image/bmp', 'image/cgm', 'image/g3fax', 'image/heic', 'image/ief', 'image/pjpeg', 'image/prs.btif', 'image/svg+xml', 'image/tiff', 'image/vnd.adobe.photoshop', 'image/vnd.djvu', 'image/vnd.dwg', 'image/vnd.dxf', 'image/vnd.fastbidsheet', 'image/vnd.fpx', 'image/vnd.fst', 'image/vnd.fujixerox.edmics-mmr', 'image/vnd.fujixerox.edmics-rlc', 'image/vnd.ms-modi', 'image/vnd.net-fpx', 'image/vnd.wap.wbmp', 'image/vnd.xiff', 'image/x-adobe-dng', 'image/x-canon-cr2', 'image/x-canon-crw', 'image/x-cmu-raster', 'image/x-cmx', 'image/x-epson-erf', 'image/x-freehand', 'image/x-fuji-raf', 'image/x-icns', 'image/x-icon', 'image/x-kodak-dcr', 'image/x-kodak-k25', 'image/x-kodak-kdc', 'image/x-minolta-mrw', 'image/x-nikon-nef', 'image/x-olympus-orf', 'image/x-panasonic-raw', 'image/x-pcx', 'image/x-pentax-pef', 'image/x-pict', 'image/x-portable-anymap', 'image/x-portable-bitmap', 'image/x-portable-graymap', 'image/x-portable-pixmap', 'image/x-rgb', 'image/x-sigma-x3f', 'image/x-sony-arw', 'image/x-sony-sr2', 'image/x-sony-srf', 'image/x-xbitmap', 'image/x-xpixmap', 'image/x-xwindowdump', 'message/rfc822', 'model/iges', 'model/mesh', 'model/vnd.dwf', 'model/vnd.gdl', 'model/vnd.gtw', 'model/vnd.mts', 'model/vnd.vtu', 'model/vrml', 'test/mimetype', 'test/mimetyp', 'x-conference/x-cooltalk', 'image/apng'])));
var $author$project$FileStatus$unknownContentType = 9999;
var $author$project$FileStatus$contentType = function (a) {
	var _v0 = $elm$core$String$split$(';', a);
	if (_v0.b) {
		var head = _v0.a;
		return $elm$core$Maybe$withDefault$(
			$author$project$FileStatus$unknownContentType,
			$author$project$OneToOne$first$(
				$elm$core$String$trim(head),
				$author$project$FileStatus$contentTypes));
	} else {
		return $author$project$FileStatus$unknownContentType;
	}
};
var $elm$file$File$mime = _File_mime;
var $lamdera$program_test$Effect$File$mime = function (file) {
	if (!file.$) {
		var file_ = file.a;
		return $elm$file$File$mime(file_);
	} else {
		var file_ = file.a;
		return file_.mimeType;
	}
};
var $elm$file$File$name = _File_name;
var $lamdera$program_test$Effect$File$name = function (file) {
	if (!file.$) {
		var file_ = file.a;
		return $elm$file$File$name(file_);
	} else {
		var file_ = file.a;
		return file_.name;
	}
};
var $elm$file$File$size = _File_size;
var $lamdera$program_test$Effect$File$size = function (file) {
	if (!file.$) {
		var file_ = file.a;
		return $elm$file$File$size(file_);
	} else {
		var file_ = file.a;
		var _v1 = file_.content;
		if (!_v1.$) {
			var bytes = _v1.a;
			return $elm$bytes$Bytes$width(bytes);
		} else {
			var text = _v1.a;
			return $elm$bytes$Bytes$width(
				$elm$bytes$Bytes$Encode$encode(
					$elm$bytes$Bytes$Encode$string(text)));
		}
	}
};
var $author$project$Env$isProduction_ = 'True';
var $author$project$Env$isProduction = $author$project$Env$isProduction_ === 'True';
var $author$project$Env$domain = $author$project$Env$isProduction ? 'https://at-chat.app' : 'http://localhost:8000';
var $author$project$FileStatus$domain = $author$project$Env$isProduction ? $author$project$Env$domain : 'http://localhost:3000';
var $lamdera$program_test$Effect$Internal$FileBody = function (a) {
	return {$: 5, a: a};
};
var $lamdera$program_test$Effect$Internal$BytesFile = function (a) {
	return {$: 0, a: a};
};
var $lamdera$program_test$Effect$Internal$MockFile = function (a) {
	return {$: 1, a: a};
};
var $lamdera$program_test$Effect$Internal$RealFile = function (a) {
	return {$: 0, a: a};
};
var $lamdera$program_test$Effect$Internal$StringFile = function (a) {
	return {$: 1, a: a};
};
var $lamdera$program_test$Effect$File$toInternalFile = function (file) {
	if (!file.$) {
		var realFile = file.a;
		return $lamdera$program_test$Effect$Internal$RealFile(realFile);
	} else {
		var mockFile = file.a;
		return $lamdera$program_test$Effect$Internal$MockFile(
			{
				content: function () {
					var _v1 = mockFile.content;
					if (!_v1.$) {
						var a = _v1.a;
						return $lamdera$program_test$Effect$Internal$BytesFile(a);
					} else {
						var a = _v1.a;
						return $lamdera$program_test$Effect$Internal$StringFile(a);
					}
				}(),
				lastModified: mockFile.lastModified,
				mimeType: mockFile.mimeType,
				name: mockFile.name
			});
	}
};
var $lamdera$program_test$Effect$Http$fileBody = function (file) {
	return $lamdera$program_test$Effect$Internal$FileBody(
		$lamdera$program_test$Effect$File$toInternalFile(file));
};
var $ianmackenzie$elm_units$Duration$minutes = function (numMinutes) {
	return $ianmackenzie$elm_units$Duration$seconds(60 * numMinutes);
};
var $ianmackenzie$elm_units$Duration$minute = $ianmackenzie$elm_units$Duration$minutes(1);
var $lamdera$program_test$Effect$Http$riskyRequest = function (r) {
	return $lamdera$program_test$Effect$Http$requestHelper$(true, r);
};
var $author$project$FileStatus$UploadResponse$ = function (fileHash, imageMetadata, videoMetadata) {
	return {fileHash: fileHash, imageMetadata: imageMetadata, videoMetadata: videoMetadata};
};
var $author$project$FileStatus$UploadResponse = F3($author$project$FileStatus$UploadResponse$);
var $author$project$FileStatus$fileHash = $elm$core$Basics$identity;
var $author$project$FileStatus$fileHashCodec = $miniBill$elm_codec$Codec$map$(
	$author$project$FileStatus$fileHash,
	function (_v0) {
		var a = _v0;
		return a;
	},
	$miniBill$elm_codec$Codec$string);
var $author$project$SafeFloat$codec = $miniBill$elm_codec$Codec$build$($author$project$SafeFloat$encode, $author$project$SafeFloat$decode);
var $author$project$FileStatus$exposureTimeCodec = $miniBill$elm_codec$Codec$buildObject(
	$miniBill$elm_codec$Codec$field$(
		'denominator',
		function ($) {
			return $.denominator;
		},
		$miniBill$elm_codec$Codec$int,
		$miniBill$elm_codec$Codec$field$(
			'numerator',
			function ($) {
				return $.numerator;
			},
			$miniBill$elm_codec$Codec$int,
			$miniBill$elm_codec$Codec$object($author$project$FileStatus$ExposureTime))));
var $author$project$FileStatus$locationCodec = $miniBill$elm_codec$Codec$buildObject(
	$miniBill$elm_codec$Codec$field$(
		'lon',
		function ($) {
			return $.lon;
		},
		$author$project$SafeFloat$codec,
		$miniBill$elm_codec$Codec$field$(
			'lat',
			function ($) {
				return $.lat;
			},
			$author$project$SafeFloat$codec,
			$miniBill$elm_codec$Codec$object($author$project$FileStatus$Location))));
var $author$project$FileStatus$orientationCodec = $miniBill$elm_codec$Codec$andThen$(
	function (a) {
		switch (a) {
			case 1:
				return $miniBill$elm_codec$Codec$succeed(0);
			case 8:
				return $miniBill$elm_codec$Codec$succeed(1);
			case 3:
				return $miniBill$elm_codec$Codec$succeed(2);
			case 6:
				return $miniBill$elm_codec$Codec$succeed(3);
			case 2:
				return $miniBill$elm_codec$Codec$succeed(4);
			case 5:
				return $miniBill$elm_codec$Codec$succeed(5);
			case 4:
				return $miniBill$elm_codec$Codec$succeed(6);
			case 7:
				return $miniBill$elm_codec$Codec$succeed(7);
			default:
				return $miniBill$elm_codec$Codec$fail('Invalid orientation');
		}
	},
	function (a) {
		switch (a) {
			case 0:
				return 1;
			case 1:
				return 8;
			case 2:
				return 3;
			case 3:
				return 6;
			case 4:
				return 2;
			case 5:
				return 5;
			case 6:
				return 4;
			default:
				return 7;
		}
	},
	$miniBill$elm_codec$Codec$int);
var $author$project$CodecExtra$quantityInt = $miniBill$elm_codec$Codec$map$($ianmackenzie$elm_units$Quantity$unsafe, $ianmackenzie$elm_units$Quantity$unwrap, $miniBill$elm_codec$Codec$int);
var $miniBill$elm_codec$Codec$tuple$ = function (m1, m2) {
	return {
		decoder: A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (a, b) {
					return _Utils_Tuple2(a, b);
				}),
			A2(
				$elm$json$Json$Decode$index,
				0,
				$miniBill$elm_codec$Codec$decoder(m1)),
			A2(
				$elm$json$Json$Decode$index,
				1,
				$miniBill$elm_codec$Codec$decoder(m2))),
		encoder: function (_v0) {
			var v1 = _v0.a;
			var v2 = _v0.b;
			return $elm$json$Json$Encode$list$(
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2($miniBill$elm_codec$Codec$encoder, m1, v1),
						A2($miniBill$elm_codec$Codec$encoder, m2, v2)
					]));
		}
	};
};
var $miniBill$elm_codec$Codec$tuple = F2($miniBill$elm_codec$Codec$tuple$);
var $author$project$FileStatus$imageMetadataCodec = $miniBill$elm_codec$Codec$buildObject(
	$miniBill$elm_codec$Codec$field$(
		'user_comment',
		function ($) {
			return $.userComment;
		},
		$miniBill$elm_codec$Codec$nullable($miniBill$elm_codec$Codec$string),
		$miniBill$elm_codec$Codec$field$(
			'software',
			function ($) {
				return $.software;
			},
			$miniBill$elm_codec$Codec$nullable($miniBill$elm_codec$Codec$string),
			$miniBill$elm_codec$Codec$field$(
				'model',
				function ($) {
					return $.model;
				},
				$miniBill$elm_codec$Codec$nullable($miniBill$elm_codec$Codec$string),
				$miniBill$elm_codec$Codec$field$(
					'make',
					function ($) {
						return $.make;
					},
					$miniBill$elm_codec$Codec$nullable($miniBill$elm_codec$Codec$string),
					$miniBill$elm_codec$Codec$field$(
						'iso_speed_rating',
						function ($) {
							return $.isoSpeedRating;
						},
						$miniBill$elm_codec$Codec$nullable($miniBill$elm_codec$Codec$int),
						$miniBill$elm_codec$Codec$field$(
							'focal_length',
							function ($) {
								return $.focalLength;
							},
							$miniBill$elm_codec$Codec$nullable($author$project$SafeFloat$codec),
							$miniBill$elm_codec$Codec$field$(
								'f_number',
								function ($) {
									return $.fNumber;
								},
								$miniBill$elm_codec$Codec$nullable($author$project$SafeFloat$codec),
								$miniBill$elm_codec$Codec$field$(
									'exposure_time',
									function ($) {
										return $.exposureTime;
									},
									$miniBill$elm_codec$Codec$nullable($author$project$FileStatus$exposureTimeCodec),
									$miniBill$elm_codec$Codec$field$(
										'camera_owner',
										function ($) {
											return $.cameraOwner;
										},
										$miniBill$elm_codec$Codec$nullable($miniBill$elm_codec$Codec$string),
										$miniBill$elm_codec$Codec$field$(
											'gps_location',
											function ($) {
												return $.gpsLocation;
											},
											$miniBill$elm_codec$Codec$nullable($author$project$FileStatus$locationCodec),
											$miniBill$elm_codec$Codec$field$(
												'orientation',
												function ($) {
													return $.orientation;
												},
												$miniBill$elm_codec$Codec$nullable($author$project$FileStatus$orientationCodec),
												$miniBill$elm_codec$Codec$field$(
													'image_size',
													function ($) {
														return $.imageSize;
													},
													$miniBill$elm_codec$Codec$tuple$($author$project$CodecExtra$quantityInt, $author$project$CodecExtra$quantityInt),
													$miniBill$elm_codec$Codec$object($author$project$FileStatus$ImageMetadata))))))))))))));
var $author$project$FileStatus$durationCodec = $miniBill$elm_codec$Codec$map$(
	function (milliseconds) {
		return $ianmackenzie$elm_units$Duration$milliseconds(milliseconds);
	},
	function (duration) {
		return $elm$core$Basics$round(
			$ianmackenzie$elm_units$Duration$inMilliseconds(duration));
	},
	$miniBill$elm_codec$Codec$int);
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $miniBill$elm_codec$Codec$maybeField$ = function (name, getter, codec, _v0) {
	var ocodec = _v0;
	return {
		decoder: A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (f, x) {
					return f(x);
				}),
			ocodec.decoder,
			$elm$json$Json$Decode$maybe(
				A2(
					$elm$json$Json$Decode$field,
					name,
					$miniBill$elm_codec$Codec$decoder(codec)))),
		encoder: function (v) {
			var _v1 = getter(v);
			if (!_v1.$) {
				var present = _v1.a;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						name,
						A2($miniBill$elm_codec$Codec$encoder, codec, present)),
					ocodec.encoder(v));
			} else {
				return ocodec.encoder(v);
			}
		},
		fields: A2($elm$core$List$cons, name, ocodec.fields)
	};
};
var $miniBill$elm_codec$Codec$maybeField = F4($miniBill$elm_codec$Codec$maybeField$);
var $author$project$CodecExtra$time = $miniBill$elm_codec$Codec$map$($lamdera$program_test$Effect$Time$millisToPosix, $lamdera$program_test$Effect$Time$posixToMillis, $miniBill$elm_codec$Codec$int);
var $author$project$FileStatus$videoMetadataCodec = $miniBill$elm_codec$Codec$buildObject(
	$miniBill$elm_codec$Codec$maybeField$(
		'duration_ms',
		function ($) {
			return $.duration;
		},
		$author$project$FileStatus$durationCodec,
		$miniBill$elm_codec$Codec$field$(
			'gps_location',
			function ($) {
				return $.gpsLocation;
			},
			$miniBill$elm_codec$Codec$nullable($author$project$FileStatus$locationCodec),
			$miniBill$elm_codec$Codec$field$(
				'title',
				function ($) {
					return $.title;
				},
				$miniBill$elm_codec$Codec$nullable($miniBill$elm_codec$Codec$string),
				$miniBill$elm_codec$Codec$field$(
					'codec',
					function ($) {
						return $.codec;
					},
					$miniBill$elm_codec$Codec$nullable($miniBill$elm_codec$Codec$string),
					$miniBill$elm_codec$Codec$field$(
						'orientation',
						function ($) {
							return $.orientation;
						},
						$author$project$FileStatus$orientationCodec,
						$miniBill$elm_codec$Codec$field$(
							'created_at_ms',
							function ($) {
								return $.createdAt;
							},
							$miniBill$elm_codec$Codec$nullable($author$project$CodecExtra$time),
							$miniBill$elm_codec$Codec$field$(
								'video_size',
								function ($) {
									return $.videoSize;
								},
								$miniBill$elm_codec$Codec$tuple$($author$project$CodecExtra$quantityInt, $author$project$CodecExtra$quantityInt),
								$miniBill$elm_codec$Codec$object($author$project$FileStatus$VideoMetadata)))))))));
var $author$project$FileStatus$uploadResponseCodec = $miniBill$elm_codec$Codec$buildObject(
	$miniBill$elm_codec$Codec$field$(
		'video_metadata',
		function ($) {
			return $.videoMetadata;
		},
		$miniBill$elm_codec$Codec$nullable($author$project$FileStatus$videoMetadataCodec),
		$miniBill$elm_codec$Codec$field$(
			'image_metadata',
			function ($) {
				return $.imageMetadata;
			},
			$miniBill$elm_codec$Codec$nullable($author$project$FileStatus$imageMetadataCodec),
			$miniBill$elm_codec$Codec$field$(
				'hash',
				function ($) {
					return $.fileHash;
				},
				$author$project$FileStatus$fileHashCodec,
				$miniBill$elm_codec$Codec$object($author$project$FileStatus$UploadResponse)))));
var $author$project$FileStatus$uploadFile$ = function (onResult, guildOrDmId, fileId, file2) {
	return $lamdera$program_test$Effect$Http$riskyRequest(
		{
			body: $lamdera$program_test$Effect$Http$fileBody(file2),
			expect: $lamdera$program_test$Effect$Http$expectJson$(
				onResult,
				$miniBill$elm_codec$Codec$decoder($author$project$FileStatus$uploadResponseCodec)),
			headers: _List_Nil,
			method: 'POST',
			timeout: $elm$core$Maybe$Just($ianmackenzie$elm_units$Duration$minute),
			tracker: $elm$core$Maybe$Just(
				$author$project$FileStatus$uploadTrackerId$(guildOrDmId, fileId)),
			url: $author$project$FileStatus$domain + '/file/upload'
		});
};
var $author$project$FileStatus$uploadFile = F4($author$project$FileStatus$uploadFile$);
var $author$project$FrontendExtra$editMessage_gotFiles$ = function (guildOrDmId, files, model) {
	return $author$project$FrontendExtra$updateLoggedIn$(
		function (loggedIn) {
			var _v0 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.editMessage);
			if (!_v0.$) {
				var edit = _v0.a;
				var _v1 = $mgold$elm_nonempty_list$List$Nonempty$foldl$(
					F2(
						function (file2, _v2) {
							var fileText2 = _v2.a;
							var cmds2 = _v2.b;
							var dict3 = _v2.c;
							var fileId = $author$project$Id$nextId(dict3);
							return _Utils_Tuple3(
								_Utils_ap(
									fileText2,
									_List_fromArray(
										[
											' ' + ($author$project$RichText$attachedFilePrefix + ($author$project$Id$toString(fileId) + $author$project$RichText$attachedFileSuffix))
										])),
								A2(
									$elm$core$List$cons,
									$author$project$FileStatus$uploadFile$(
										A3($author$project$Types$EditMessage_GotFileHashName, guildOrDmId, edit.messageIndex, fileId),
										guildOrDmId,
										fileId,
										file2),
									cmds2),
								$lamdera$containers$SeqDict$insert$(
									fileId,
									$author$project$FileStatus$FileUploading$(
										$author$project$FileName$fromString(
											$lamdera$program_test$Effect$File$name(file2)),
										{
											sent: 0,
											size: $lamdera$program_test$Effect$File$size(file2)
										},
										$author$project$FileStatus$contentType(
											$lamdera$program_test$Effect$File$mime(file2)),
										$author$project$FileStatus$IsNotEncrypted),
									dict3));
						}),
					_Utils_Tuple3(_List_Nil, _List_Nil, edit.attachedFiles),
					files);
				var fileText = _v1.a;
				var cmds = _v1.b;
				var dict = _v1.c;
				return _Utils_Tuple2(
					_Utils_update(
						loggedIn,
						{
							editMessage: $lamdera$containers$SeqDict$insert$(
								guildOrDmId,
								_Utils_update(
									edit,
									{
										attachedFiles: dict,
										text: _Utils_ap(
											edit.text,
											$elm$core$String$concat(fileText))
									}),
								loggedIn.editMessage)
						}),
					$lamdera$program_test$Effect$Command$batch(cmds));
			} else {
				return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
			}
		},
		model);
};
var $author$project$FrontendExtra$editMessage_gotFiles = F3($author$project$FrontendExtra$editMessage_gotFiles$);
var $author$project$Types$GotFileToEncrypt$ = function (a, b, c, d) {
	return {$: 85, a: a, b: b, c: c, d: d};
};
var $author$project$Types$GotFileToEncrypt = F4($author$project$Types$GotFileToEncrypt$);
var $MartinSStewart$elm_nonempty_string$String$Nonempty$append_$ = function (_v0, second) {
	var head_ = _v0.a;
	var tail_ = _v0.b;
	return $MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$(
		head_,
		_Utils_ap(tail_, second));
};
var $MartinSStewart$elm_nonempty_string$String$Nonempty$append_ = F2($MartinSStewart$elm_nonempty_string$String$Nonempty$append_$);
var $author$project$FrontendExtra$encryptedDmOtherUser$ = function (guildOrDmId, local, loggedIn) {
	if ((!guildOrDmId.$) && (guildOrDmId.a.$ === 1)) {
		var otherUserId = guildOrDmId.a.a.otherUserId;
		var _v1 = _Utils_Tuple2(
			$elm$core$Maybe$map$(
				function ($) {
					return $.e2ee;
				},
				$lamdera$containers$SeqDict$get$(otherUserId, local.dmChannels)),
			$lamdera$containers$SeqSet$member$(otherUserId, loggedIn.e2eeKeysOnThisDevice));
		if (((!_v1.a.$) && (_v1.a.a.$ === 3)) && _v1.b) {
			return $elm$core$Maybe$Just(
				{otherUserId: otherUserId});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$FrontendExtra$encryptedDmOtherUser = F3($author$project$FrontendExtra$encryptedDmOtherUser$);
var $lamdera$program_test$Effect$File$toBytes = function (file) {
	return $lamdera$program_test$Effect$Internal$FileToBytes$(
		$lamdera$program_test$Effect$File$toInternalFile(file),
		$lamdera$program_test$Effect$Internal$Succeed);
};
var $author$project$FrontendExtra$gotFiles$ = function (guildOrDmId, threadRoute, files, model) {
	return $author$project$FrontendExtra$updateLoggedIn$(
		function (loggedIn) {
			var startUpload = F2(
				function (fileId, file2) {
					var _v6 = $author$project$FrontendExtra$encryptedDmOtherUser$(
						guildOrDmId,
						$author$project$Local$model(loggedIn.localState),
						loggedIn);
					if (!_v6.$) {
						return $lamdera$program_test$Effect$Task$perform$(
							A3(
								$author$project$Types$GotFileToEncrypt,
								_Utils_Tuple2(guildOrDmId, threadRoute),
								fileId,
								$lamdera$program_test$Effect$File$mime(file2)),
							$lamdera$program_test$Effect$File$toBytes(file2));
					} else {
						return $author$project$FileStatus$uploadFile$(
							A3(
								$author$project$Types$GotFileHashName,
								_Utils_Tuple2(guildOrDmId, threadRoute),
								fileId,
								$elm$core$Maybe$Nothing),
							_Utils_Tuple2(guildOrDmId, threadRoute),
							fileId,
							file2);
					}
				});
			var _v0 = function () {
				var _v1 = $lamdera$containers$SeqDict$get$(
					_Utils_Tuple2(guildOrDmId, threadRoute),
					loggedIn.filesToUpload);
				if (!_v1.$) {
					var dict2 = _v1.a;
					return $mgold$elm_nonempty_list$List$Nonempty$foldl$(
						F2(
							function (file2, _v2) {
								var fileText2 = _v2.a;
								var cmds2 = _v2.b;
								var dict3 = _v2.c;
								var id = $author$project$Id$nextId(
									$author$project$NonemptyDict$toSeqDict(dict3));
								return _Utils_Tuple3(
									_Utils_ap(
										fileText2,
										_List_fromArray(
											[
												_Utils_ap(
												$author$project$RichText$attachedFilePrefix,
												_Utils_ap(
													$author$project$Id$toString(id),
													$author$project$RichText$attachedFileSuffix))
											])),
									A2(
										$elm$core$List$cons,
										A2(startUpload, id, file2),
										cmds2),
									$author$project$NonemptyDict$insert$(
										id,
										$author$project$FileStatus$FileUploading$(
											$author$project$FileName$fromString(
												$lamdera$program_test$Effect$File$name(file2)),
											{
												sent: 0,
												size: $lamdera$program_test$Effect$File$size(file2)
											},
											$author$project$FileStatus$contentType(
												$lamdera$program_test$Effect$File$mime(file2)),
											$author$project$FileStatus$IsNotEncrypted),
										dict3));
							}),
						_Utils_Tuple3(_List_Nil, _List_Nil, dict2),
						files);
				} else {
					return _Utils_Tuple3(
						$elm$core$List$indexedMap$(
							F2(
								function (index, _v3) {
									return _Utils_ap(
										$author$project$RichText$attachedFilePrefix,
										_Utils_ap(
											$author$project$Id$toString(
												$author$project$Id$fromInt(index + 1)),
											$author$project$RichText$attachedFileSuffix));
								}),
							$mgold$elm_nonempty_list$List$Nonempty$toList(files)),
						$elm$core$List$indexedMap$(
							F2(
								function (index, file2) {
									return A2(
										startUpload,
										$author$project$Id$fromInt(index + 1),
										file2);
								}),
							$mgold$elm_nonempty_list$List$Nonempty$toList(files)),
						$author$project$NonemptyDict$fromNonemptyList(
							$mgold$elm_nonempty_list$List$Nonempty$indexedMap$(
								F2(
									function (index, file2) {
										return _Utils_Tuple2(
											$author$project$Id$fromInt(index + 1),
											$author$project$FileStatus$FileUploading$(
												$author$project$FileName$fromString(
													$lamdera$program_test$Effect$File$name(file2)),
												{
													sent: 0,
													size: $lamdera$program_test$Effect$File$size(file2)
												},
												$author$project$FileStatus$contentType(
													$lamdera$program_test$Effect$File$mime(file2)),
												$author$project$FileStatus$IsNotEncrypted));
									}),
								files)));
				}
			}();
			var fileText = _v0.a;
			var cmds = _v0.b;
			var dict = _v0.c;
			return _Utils_Tuple2(
				_Utils_update(
					loggedIn,
					{
						drafts: function () {
							var _v4 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(
								$elm$core$String$join$(' ', fileText));
							if (!_v4.$) {
								var fileText2 = _v4.a;
								return $lamdera$containers$SeqDict$update$(
									_Utils_Tuple2(guildOrDmId, threadRoute),
									function (maybe) {
										if (!maybe.$) {
											var draft = maybe.a;
											return $elm$core$Maybe$Just(
												$MartinSStewart$elm_nonempty_string$String$Nonempty$append_$(
													draft,
													' ' + $MartinSStewart$elm_nonempty_string$String$Nonempty$toString(fileText2)));
										} else {
											return $elm$core$Maybe$Just(fileText2);
										}
									},
									loggedIn.drafts);
							} else {
								return loggedIn.drafts;
							}
						}(),
						filesToUpload: $lamdera$containers$SeqDict$insert$(
							_Utils_Tuple2(guildOrDmId, threadRoute),
							dict,
							loggedIn.filesToUpload)
					}),
				$lamdera$program_test$Effect$Command$batch(cmds));
		},
		model);
};
var $author$project$FrontendExtra$gotFiles = F4($author$project$FrontendExtra$gotFiles$);
var $author$project$FrontendExtra$canDropFileHelper$ = function (guildOrDmId, threadRoute2, files, model) {
	var _v0 = model.loginStatus;
	if (!_v0.$) {
		var loggedIn = _v0.a;
		return $lamdera$containers$SeqDict$member$(
			_Utils_Tuple2(guildOrDmId, threadRoute2),
			loggedIn.editMessage) ? $author$project$FrontendExtra$editMessage_gotFiles$(
			_Utils_Tuple2(guildOrDmId, threadRoute2),
			files,
			model) : $author$project$FrontendExtra$gotFiles$(guildOrDmId, threadRoute2, files, model);
	} else {
		return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
	}
};
var $author$project$FrontendExtra$canDropFileHelper = F4($author$project$FrontendExtra$canDropFileHelper$);
var $author$project$FrontendExtra$canDropFiles$ = function (isMobile, currentUserId, route) {
	switch (route.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 2:
			return $elm$core$Maybe$Nothing;
		case 3:
			var guildId = route.a;
			var channelRoute = route.b;
			var channelsVisible = route.c;
			if ((channelsVisible === 1) && isMobile) {
				return $elm$core$Maybe$Nothing;
			} else {
				switch (channelRoute.$) {
					case 0:
						var channelId = channelRoute.a;
						var threadRoute = channelRoute.b;
						var threadRoute2 = function () {
							if (!threadRoute.$) {
								return $author$project$Id$NoThread;
							} else {
								var threadId = threadRoute.a;
								return $author$project$Id$ViewThread(threadId);
							}
						}();
						return $elm$core$Maybe$Just(
							A2(
								$author$project$FrontendExtra$canDropFileHelper,
								$author$project$Id$GuildOrDmId(
									$author$project$Id$GuildOrDmId_Guild(
										{channelId: channelId, guildId: guildId})),
								threadRoute2));
					case 1:
						return $elm$core$Maybe$Nothing;
					case 2:
						return $elm$core$Maybe$Nothing;
					default:
						return $elm$core$Maybe$Nothing;
				}
			}
		case 4:
			var routeData = route.a;
			if ((routeData.channelsVisible === 1) && isMobile) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v3 = routeData.channelRoute;
				switch (_v3.$) {
					case 0:
						var channelId = _v3.a;
						var threadRoute = _v3.b;
						var threadRoute2 = function () {
							if (!threadRoute.$) {
								return $author$project$Id$NoThread;
							} else {
								var threadId = threadRoute.a;
								return $author$project$Id$ViewThread(threadId);
							}
						}();
						return $elm$core$Maybe$Just(
							A2(
								$author$project$FrontendExtra$canDropFileHelper,
								$author$project$Id$DiscordGuildOrDmId(
									$author$project$Id$DiscordGuildOrDmId_Guild(
										{channelId: channelId, currentUserId: routeData.currentDiscordUserId, guildId: routeData.guildId})),
								threadRoute2));
					case 1:
						return $elm$core$Maybe$Nothing;
					default:
						return $elm$core$Maybe$Nothing;
				}
			}
		case 5:
			var routeData = route.a;
			if ((routeData.channelsVisible === 1) && isMobile) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v5 = $author$project$DmChannelId$otherUserId$(currentUserId, routeData.channelId);
				if (!_v5.$) {
					var otherUserId = _v5.a;
					var threadRoute2 = function () {
						var _v6 = routeData.threadRoute;
						if (!_v6.$) {
							return $author$project$Id$NoThread;
						} else {
							var threadId = _v6.a;
							return $author$project$Id$ViewThread(threadId);
						}
					}();
					return $elm$core$Maybe$Just(
						A2(
							$author$project$FrontendExtra$canDropFileHelper,
							$author$project$Id$GuildOrDmId(
								$author$project$Id$GuildOrDmId_Dm(
									{otherUserId: otherUserId})),
							threadRoute2));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		case 6:
			var routeData = route.a;
			return ((routeData.channelsVisible === 1) && isMobile) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				A2(
					$author$project$FrontendExtra$canDropFileHelper,
					$author$project$Id$DiscordGuildOrDmId(
						$author$project$Id$DiscordGuildOrDmId_Dm(
							{channelId: routeData.channelId, currentUserId: routeData.currentDiscordUserId})),
					$author$project$Id$NoThread));
		case 9:
			return $elm$core$Maybe$Nothing;
		case 10:
			return $elm$core$Maybe$Nothing;
		case 11:
			return $elm$core$Maybe$Nothing;
		case 12:
			return $elm$core$Maybe$Nothing;
		case 13:
			return $elm$core$Maybe$Nothing;
		case 7:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$FrontendExtra$canDropFiles = F3($author$project$FrontendExtra$canDropFiles$);
var $author$project$LinkedAndOtherDiscordUsers$getLinkedUser$ = function (userId, _v0) {
	var a = _v0.b;
	return $lamdera$containers$SeqDict$get$(userId, a);
};
var $author$project$LinkedAndOtherDiscordUsers$getLinkedUser = F2($author$project$LinkedAndOtherDiscordUsers$getLinkedUser$);
var $author$project$LocalState$notEnoughDiscordMessagesError = 'Send at least 4 messages using Discord first';
var $author$project$LocalState$sentEnoughDiscordDmMessages$ = function (currentUserId, channel) {
	var _v0 = $author$project$NonemptyDict$get$(currentUserId, channel.members);
	if (!_v0.$) {
		var member = _v0.a;
		return member.messagesSent >= 4;
	} else {
		return false;
	}
};
var $author$project$LocalState$sentEnoughDiscordDmMessages = F2($author$project$LocalState$sentEnoughDiscordDmMessages$);
var $author$project$LocalState$canSendDiscordMessage$ = function (local, guildOrDmId) {
	if (!guildOrDmId.$) {
		return $elm$core$Result$Ok(0);
	} else {
		var data = guildOrDmId.a;
		var _v1 = $author$project$LinkedAndOtherDiscordUsers$getLinkedUser$(data.currentUserId, local.localUser.discordUsers);
		if (!_v1.$) {
			var linkedUser = _v1.a;
			if (linkedUser.needsAuthAgain) {
				return $elm$core$Result$Err('Please link your Discord account again');
			} else {
				var _v2 = $lamdera$containers$SeqDict$get$(data.channelId, local.discordDmChannels);
				if (!_v2.$) {
					var channel = _v2.a;
					return $author$project$LocalState$sentEnoughDiscordDmMessages$(data.currentUserId, channel) ? $elm$core$Result$Ok(0) : $elm$core$Result$Err($author$project$LocalState$notEnoughDiscordMessagesError);
				} else {
					return $elm$core$Result$Err('Channel not found');
				}
			}
		} else {
			return $elm$core$Result$Err('This Discord user isn\u0027t linked to your account');
		}
	}
};
var $author$project$LocalState$canSendDiscordMessage = F2($author$project$LocalState$canSendDiscordMessage$);
var $lamdera$program_test$Effect$Http$cancel = $lamdera$program_test$Effect$Internal$HttpCancel;
var $author$project$Id$changeType = function (_v0) {
	var a = _v0;
	return a;
};
var $author$project$LocalState$guildChannels$ = function (guildOrDmId, local) {
	if (!guildOrDmId.$) {
		var guildId = guildOrDmId.a.guildId;
		var _v1 = $lamdera$containers$SeqDict$get$(guildId, local.guilds);
		if (!_v1.$) {
			var guild = _v1.a;
			return guild.channels;
		} else {
			return $lamdera$containers$SeqDict$empty;
		}
	} else {
		return $lamdera$containers$SeqDict$empty;
	}
};
var $author$project$LocalState$guildChannels = F2($author$project$LocalState$guildChannels$);
var $author$project$LocalState$channelMentions$ = function (guildOrDmId, local) {
	return $author$project$LocalState$guildChannelMentions$(
		local.localUser,
		$author$project$LocalState$guildChannels$(guildOrDmId, local));
};
var $author$project$LocalState$channelMentions = F2($author$project$LocalState$channelMentions$);
var $author$project$Frontend$channelSidebarDragRange = function (route) {
	var _v0 = $author$project$Route$toShowMembersTab(route);
	if (!_v0.a) {
		var _v1 = _v0.a;
		return {max: 1, min: 0};
	} else {
		var _v2 = _v0.a;
		return {max: 2, min: 1};
	}
};
var $author$project$MessageMenu$showEdit$ = function (extraOptions, loggedIn) {
	var _v0 = $lamdera$containers$SeqDict$get$(
		_Utils_Tuple2(
			extraOptions.guildOrDmId,
			$author$project$Id$threadRouteWithoutMessage(extraOptions.threadRoute)),
		loggedIn.editMessage);
	if (!_v0.$) {
		var edit = _v0.a;
		var _v1 = extraOptions.threadRoute;
		if (_v1.$ === 1) {
			var messageId = _v1.b;
			return _Utils_eq(
				edit.messageIndex,
				$author$project$Id$changeType(messageId)) ? $elm$core$Maybe$Just(edit) : $elm$core$Maybe$Nothing;
		} else {
			var messageId = _v1.a;
			return _Utils_eq(edit.messageIndex, messageId) ? $elm$core$Maybe$Just(edit) : $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$MessageMenu$showEdit = F2($author$project$MessageMenu$showEdit$);
var $author$project$MessageMenu$close$ = function (model, loggedIn) {
	var _v0 = loggedIn.messageHover;
	switch (_v0.$) {
		case 0:
			return loggedIn;
		case 1:
			return loggedIn;
		case 3:
			return loggedIn;
		default:
			var extraOptions = _v0.a;
			var isMobile = $author$project$MyUi$isMobile(model);
			return _Utils_update(
				loggedIn,
				{
					editMessage: isMobile ? $lamdera$containers$SeqDict$remove$(
						_Utils_Tuple2(
							extraOptions.guildOrDmId,
							$author$project$Id$threadRouteWithoutMessage(extraOptions.threadRoute)),
						loggedIn.editMessage) : loggedIn.editMessage,
					messageHover: isMobile ? $author$project$Types$MessageMenu(
						_Utils_update(
							extraOptions,
							{
								mobileMode: function () {
									var _v1 = extraOptions.mobileMode;
									switch (_v1.$) {
										case 0:
											var offset = _v1.a;
											var maybeEdit = _v1.b;
											return $author$project$Types$MessageMenuClosing$(offset, maybeEdit);
										case 1:
											var offset = _v1.a.offset;
											return $author$project$Types$MessageMenuClosing$(
												offset,
												$author$project$MessageMenu$showEdit$(extraOptions, loggedIn));
										case 2:
											var offset = _v1.a.offset;
											return $author$project$Types$MessageMenuClosing$(
												offset,
												$author$project$MessageMenu$showEdit$(extraOptions, loggedIn));
										default:
											var offset = _v1.a;
											return $author$project$Types$MessageMenuClosing$(
												offset,
												$author$project$MessageMenu$showEdit$(extraOptions, loggedIn));
									}
								}()
							})) : $author$project$Types$NoMessageHover
				});
	}
};
var $author$project$MessageMenu$close = F2($author$project$MessageMenu$close$);
var $author$project$Ports$close_notifications_to_js = _Platform_outgoingPort('close_notifications_to_js', $elm$core$Basics$identity);
var $author$project$Ports$closeNotifications = A3($lamdera$program_test$Effect$Command$sendToJs, 'close_notifications_to_js', $author$project$Ports$close_notifications_to_js, $elm$json$Json$Encode$null);
var $author$project$Scroll$closeToTop = 300;
var $author$project$Frontend$conversationsToEncrypt$ = function (nextRequestId, conversations) {
	return $elm$core$List$indexedMap$(
		F2(
			function (index, _v0) {
				var id = _v0.a;
				var conversation = _v0.b;
				return _Utils_Tuple2(
					$author$project$Id$fromInt(
						$author$project$Id$toInt(nextRequestId) + index),
					{
						id: id,
						messages: _Utils_ap(
							$elm$core$List$map$(
								function (_v1) {
									var messageId = _v1.a;
									var content = _v1.b;
									return _Utils_Tuple2(
										$author$project$Id$NoThreadWithMessage(messageId),
										content);
								},
								$lamdera$containers$SeqDict$toList(conversation.channel)),
							$elm$core$List$concatMap$(
								function (_v2) {
									var threadId = _v2.a;
									var thread = _v2.b;
									return $elm$core$List$map$(
										function (_v3) {
											var messageId = _v3.a;
											var content = _v3.b;
											return _Utils_Tuple2(
												$author$project$Id$ViewThreadWithMessage$(threadId, messageId),
												content);
										},
										$lamdera$containers$SeqDict$toList(thread));
								},
								$lamdera$containers$SeqDict$toList(conversation.threads)))
					});
			}),
		$lamdera$containers$SeqDict$toList(conversations));
};
var $author$project$Frontend$conversationsToEncrypt = F2($author$project$Frontend$conversationsToEncrypt$);
var $author$project$Ports$copy_image_to_clipboard_to_js = _Platform_outgoingPort('copy_image_to_clipboard_to_js', $elm$core$Basics$identity);
var $author$project$Ports$copyImageToClipboard = function (imageUrl) {
	return A3(
		$lamdera$program_test$Effect$Command$sendToJs,
		'copy_image_to_clipboard_to_js',
		$author$project$Ports$copy_image_to_clipboard_to_js,
		$elm$json$Json$Encode$string(imageUrl));
};
var $author$project$Ports$copy_to_clipboard_to_js = _Platform_outgoingPort('copy_to_clipboard_to_js', $elm$core$Basics$identity);
var $author$project$Ports$copyToClipboard = function (text) {
	return A3(
		$lamdera$program_test$Effect$Command$sendToJs,
		'copy_to_clipboard_to_js',
		$author$project$Ports$copy_to_clipboard_to_js,
		$elm$json$Json$Encode$string(text));
};
var $author$project$Frontend$copyText$ = function (text, model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{
				lastCopied: $elm$core$Maybe$Just(
					{
						copied: $author$project$MyUi$CopiedText(text),
						copiedAt: model.time
					})
			}),
		$author$project$Ports$copyToClipboard(text));
};
var $author$project$Frontend$copyText = F2($author$project$Frontend$copyText$);
var $author$project$CssPixels$cssPixels = $ianmackenzie$elm_units$Quantity$unsafe;
var $lamdera$containers$SeqSet$diff$ = function (_v0, _v1) {
	var d1 = _v0;
	var d2 = _v1;
	return $lamdera$containers$SeqDict$diff$(d1, d2);
};
var $lamdera$containers$SeqSet$diff = F2($lamdera$containers$SeqSet$diff$);
var $author$project$LocalState$discordChannelMentions$ = function (guildOrDmId, local) {
	if (!guildOrDmId.$) {
		var guildId = guildOrDmId.a.guildId;
		var _v1 = $lamdera$containers$SeqDict$get$(guildId, local.discordGuilds);
		if (!_v1.$) {
			var guild = _v1.a;
			return $author$project$LocalState$discordGuildChannelMentions$(local.localUser, guild.channels);
		} else {
			return $lamdera$containers$SeqDict$empty;
		}
	} else {
		return $lamdera$containers$SeqDict$empty;
	}
};
var $author$project$LocalState$discordChannelMentions = F2($author$project$LocalState$discordChannelMentions$);
var $author$project$LocalState$discordGuildOrDmIdToMessage$ = function (guildOrDmId, threadRoute, local) {
	var helper = F2(
		function (messageId, channel) {
			var _v7 = $author$project$MessageArray$get$(messageId, channel.messages);
			if (!_v7.$) {
				var message = _v7.a;
				switch (message.$) {
					case 0:
						var data = message.a;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(
								{content: data.content, createdAt: data.createdAt, createdBy: data.createdBy, editedAt: data.editedAt, reactions: data.reactions},
								$author$project$Id$NoThreadWithMaybeMessage(
									$author$project$Message$replyToMaybe(data.repliedTo))));
					case 1:
						return $elm$core$Maybe$Nothing;
					case 2:
						return $elm$core$Maybe$Nothing;
					case 3:
						return $elm$core$Maybe$Nothing;
					case 4:
						return $elm$core$Maybe$Nothing;
					default:
						return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
	if (!guildOrDmId.$) {
		var id = guildOrDmId.a;
		var _v1 = $author$project$LocalState$getDiscordGuildAndChannel$(id.guildId, id.channelId, local);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var channel = _v2.b;
			if (threadRoute.$ === 1) {
				var threadId = threadRoute.a;
				var messageId = threadRoute.b;
				var _v4 = $author$project$MessageArray$get$(
					messageId,
					$elm$core$Maybe$withDefault$(
						$author$project$Thread$discordFrontendInit,
						$lamdera$containers$SeqDict$get$(threadId, channel.threads)).messages);
				if (!_v4.$) {
					var message = _v4.a;
					switch (message.$) {
						case 0:
							var data = message.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(
									{content: data.content, createdAt: data.createdAt, createdBy: data.createdBy, editedAt: data.editedAt, reactions: data.reactions},
									$author$project$Id$ViewThreadWithMaybeMessage$(
										threadId,
										$author$project$Message$replyToMaybe(data.repliedTo))));
						case 1:
							return $elm$core$Maybe$Nothing;
						case 2:
							return $elm$core$Maybe$Nothing;
						case 3:
							return $elm$core$Maybe$Nothing;
						case 4:
							return $elm$core$Maybe$Nothing;
						default:
							return $elm$core$Maybe$Nothing;
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				var messageId = threadRoute.a;
				return A2(helper, messageId, channel);
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		var data = guildOrDmId.a;
		var _v6 = _Utils_Tuple2(
			$lamdera$containers$SeqDict$get$(data.channelId, local.discordDmChannels),
			threadRoute);
		if ((!_v6.a.$) && (!_v6.b.$)) {
			var channel = _v6.a.a;
			var messageId = _v6.b.a;
			return A2(helper, messageId, channel);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$LocalState$discordGuildOrDmIdToMessage = F3($author$project$LocalState$discordGuildOrDmIdToMessage$);
var $author$project$Route$ChannelSidebarDragging = function (a) {
	return {$: 1, a: a};
};
var $author$project$Frontend$dragChannelSidebar$ = function (range, time, delta, sidebar) {
	if (!sidebar.$) {
		var offset = sidebar.a.offset;
		return $author$project$Route$ChannelSidebarDragging(
			{
				offset: $elm$core$Basics$clamp$(range.min, range.max, offset + delta),
				previousOffset: offset,
				time: time
			});
	} else {
		var record = sidebar.a;
		return $author$project$Route$ChannelSidebarDragging(
			_Utils_update(
				record,
				{
					offset: $elm$core$Basics$clamp$(range.min, range.max, record.offset + delta),
					time: time
				}));
	}
};
var $author$project$Frontend$dragChannelSidebar = F4($author$project$Frontend$dragChannelSidebar$);
var $author$project$Go$dragStart = function (model) {
	return model;
};
var $author$project$WordSpellingGame$Dragging = function (a) {
	return {$: 0, a: a};
};
var $author$project$WordSpellingGame$statusHeight = 70;
var $author$project$WordSpellingGame$trayTileSpacing = 4;
var $author$project$WordSpellingGame$trayTileSize$ = function (traySize, windowSize) {
	var slots = $author$project$OneOrGreater$toInt(traySize) + 1;
	return $elm$core$Basics$min$(
		50,
		($author$project$Coord$xRaw(windowSize) - ($author$project$WordSpellingGame$trayTileSpacing * (slots - 1))) / slots);
};
var $author$project$WordSpellingGame$trayTileSize = F2($author$project$WordSpellingGame$trayTileSize$);
var $author$project$WordSpellingGame$trayHeight$ = function (traySize, windowSize) {
	return $elm$core$Basics$round(
		$author$project$WordSpellingGame$trayTileSize$(traySize, windowSize));
};
var $author$project$WordSpellingGame$trayHeight = F2($author$project$WordSpellingGame$trayHeight$);
var $author$project$WordSpellingGame$cellSize$ = function (traySize, windowSize) {
	var availableSize = $elm$core$Basics$min$(
		($elm$core$Basics$round(
			$author$project$Coord$yRaw(windowSize) * 0.7) - $author$project$WordSpellingGame$trayHeight$(traySize, windowSize)) - ($author$project$MyUi$isMobileAlt(windowSize) ? $author$project$WordSpellingGame$statusHeight : 0),
		$author$project$Coord$xRaw(windowSize));
	return $elm$core$Basics$min$(30, (availableSize / $author$project$WordSpellingGame$gridSize) | 0);
};
var $author$project$WordSpellingGame$cellSize = F2($author$project$WordSpellingGame$cellSize$);
var $author$project$WordSpellingGame$boardWidth$ = function (traySize, windowSize) {
	return $author$project$WordSpellingGame$cellSize$(traySize, windowSize) * $author$project$WordSpellingGame$gridSize;
};
var $author$project$WordSpellingGame$boardWidth = F2($author$project$WordSpellingGame$boardWidth$);
var $author$project$MyUi$channelColumnWidth = function (windowSize) {
	return $elm$core$Basics$clamp$(
		200,
		300,
		$elm$core$Basics$round(
			$author$project$Coord$xRaw(windowSize) * 0.2));
};
var $author$project$MyUi$guildIconFullWidth = 56;
var $author$project$MyUi$channelAndGuildColumnWidth = function (windowSize) {
	return $author$project$MyUi$channelColumnWidth(windowSize) + $author$project$MyUi$guildIconFullWidth;
};
var $author$project$WordSpellingGame$boardX = function (windowSize) {
	return $author$project$MyUi$isMobileAlt(windowSize) ? 0 : $author$project$MyUi$channelAndGuildColumnWidth(windowSize);
};
var $author$project$WordSpellingGame$boardY = $author$project$MyUi$channelHeaderHeight;
var $author$project$WordSpellingGame$cellAtPosition$ = function (setup, windowSize, coord) {
	var size = $author$project$WordSpellingGame$cellSize$(setup.traySize, windowSize);
	var relY = $author$project$Coord$yRaw(coord) - $author$project$WordSpellingGame$boardY;
	var relX = $author$project$Coord$xRaw(coord) - $author$project$WordSpellingGame$boardX(windowSize);
	return ((relX >= 0) && ((relY >= 0) && ((_Utils_cmp((relX / size) | 0, $author$project$WordSpellingGame$gridSize) < 0) && (_Utils_cmp((relY / size) | 0, $author$project$WordSpellingGame$gridSize) < 0)))) ? $elm$core$Maybe$Just(
		_Utils_Tuple2((relX / size) | 0, (relY / size) | 0)) : $elm$core$Maybe$Nothing;
};
var $author$project$WordSpellingGame$cellAtPosition = F3($author$project$WordSpellingGame$cellAtPosition$);
var $author$project$WordSpellingGame$easeOutCubic = function (t) {
	var clamped = $elm$core$Basics$clamp$(0, 1, t);
	return 1 - A2($elm$core$Basics$pow, 1 - clamped, 3);
};
var $author$project$WordSpellingGame$animatedZoomState$ = function (time, model) {
	var target = $author$project$WordSpellingGame$zoomTarget(model);
	var from = model.zoomAnimation.from;
	var eased = $author$project$WordSpellingGame$easeOutCubic(
		$elm$core$Basics$clamp$(
			0,
			1,
			$author$project$WordSpellingGame$elapsedMs$(time, model.zoomAnimation.start) / $author$project$WordSpellingGame$zoomAnimationDuration));
	var lerp = F2(
		function (a, b) {
			return a + (eased * (b - a));
		});
	return {
		amount: A2(lerp, from.amount, target.amount),
		focusX: A2(lerp, from.focusX, target.focusX),
		focusY: A2(lerp, from.focusY, target.focusY)
	};
};
var $author$project$WordSpellingGame$animatedZoomState = F2($author$project$WordSpellingGame$animatedZoomState$);
var $author$project$WordSpellingGame$boardZoomScale = 1.75;
var $author$project$WordSpellingGame$resolveZoom$ = function (traySize, windowSize, zoomState) {
	if (zoomState.amount < 0.02) {
		return $elm$core$Maybe$Nothing;
	} else {
		var size = $author$project$WordSpellingGame$cellSize$(traySize, windowSize);
		var zc = $elm$core$Basics$round((1 + (zoomState.amount * ($author$project$WordSpellingGame$boardZoomScale - 1))) * size);
		var effScale = zc / size;
		var boardPx = $author$project$WordSpellingGame$gridSize * size;
		var window = boardPx / effScale;
		var axisTranslate = function (focusFraction) {
			var focusLocal = focusFraction * boardPx;
			var left = $elm$core$Basics$clamp$(0, boardPx - window, focusLocal - (window / 2));
			return $elm$core$Basics$round((-effScale) * left);
		};
		return _Utils_eq(zc, size) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			{
				translate: $author$project$Coord$xy$(
					axisTranslate(zoomState.focusX),
					axisTranslate(zoomState.focusY)),
				zoomedCellSize: zc
			});
	}
};
var $author$project$WordSpellingGame$resolveZoom = F3($author$project$WordSpellingGame$resolveZoom$);
var $author$project$WordSpellingGame$boardZoom$ = function (time, traySize, windowSize, model) {
	return $author$project$MyUi$isMobileAlt(windowSize) ? $author$project$WordSpellingGame$resolveZoom$(
		traySize,
		windowSize,
		$author$project$WordSpellingGame$animatedZoomState$(time, model)) : $elm$core$Maybe$Nothing;
};
var $author$project$WordSpellingGame$boardZoom = F4($author$project$WordSpellingGame$boardZoom$);
var $author$project$WordSpellingGame$unprojectTouch$ = function (time, windowSize, setup, model, coord) {
	var _v0 = $author$project$WordSpellingGame$boardZoom$(time, setup.traySize, windowSize, model);
	if (!_v0.$) {
		var translate = _v0.a.translate;
		var zoomedCellSize = _v0.a.zoomedCellSize;
		var effScale = zoomedCellSize / $author$project$WordSpellingGame$cellSize$(setup.traySize, windowSize);
		var unproject = F3(
			function (axis, boardOrigin, axisTranslate) {
				return boardOrigin + $elm$core$Basics$round(((axis - boardOrigin) - axisTranslate) / effScale);
			});
		return $author$project$Coord$xy$(
			A3(
				unproject,
				$author$project$Coord$xRaw(coord),
				$author$project$WordSpellingGame$boardX(windowSize),
				$author$project$Coord$xRaw(translate)),
			A3(
				unproject,
				$author$project$Coord$yRaw(coord),
				$author$project$WordSpellingGame$boardY,
				$author$project$Coord$yRaw(translate)));
	} else {
		return coord;
	}
};
var $author$project$WordSpellingGame$unprojectTouch = F5($author$project$WordSpellingGame$unprojectTouch$);
var $author$project$WordSpellingGame$boardCellAtPosition$ = function (time, windowSize, setup, model, coord) {
	var width = $author$project$WordSpellingGame$boardWidth$(setup.traySize, windowSize);
	var relY = $author$project$Coord$yRaw(coord) - $author$project$WordSpellingGame$boardY;
	var relX = $author$project$Coord$xRaw(coord) - $author$project$WordSpellingGame$boardX(windowSize);
	return ((relX >= 0) && ((_Utils_cmp(relX, width) < 0) && ((relY >= 0) && (_Utils_cmp(relY, width) < 0)))) ? $author$project$WordSpellingGame$cellAtPosition$(
		setup,
		windowSize,
		$author$project$WordSpellingGame$unprojectTouch$(time, windowSize, setup, model, coord)) : $elm$core$Maybe$Nothing;
};
var $author$project$WordSpellingGame$boardCellAtPosition = F5($author$project$WordSpellingGame$boardCellAtPosition$);
var $elm$core$Elm$JsArray$indexedMap = _JsArray_indexedMap;
var $elm$core$Array$indexedMap$ = function (func, _v0) {
	var len = _v0.a;
	var tree = _v0.c;
	var tail = _v0.d;
	var initialBuilder = {
		nodeList: _List_Nil,
		nodeListSize: 0,
		tail: A3(
			$elm$core$Elm$JsArray$indexedMap,
			func,
			$elm$core$Array$tailIndex(len),
			tail)
	};
	var helper = F2(
		function (node, builder) {
			if (!node.$) {
				var subTree = node.a;
				return A3($elm$core$Elm$JsArray$foldl, helper, builder, subTree);
			} else {
				var leaf = node.a;
				var offset = builder.nodeListSize * $elm$core$Array$branchFactor;
				var mappedLeaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$indexedMap, func, offset, leaf));
				return {
					nodeList: A2($elm$core$List$cons, mappedLeaf, builder.nodeList),
					nodeListSize: builder.nodeListSize + 1,
					tail: builder.tail
				};
			}
		});
	return $elm$core$Array$builderToArray$(
		true,
		A3($elm$core$Elm$JsArray$foldl, helper, initialBuilder, tree));
};
var $elm$core$Array$indexedMap = F2($elm$core$Array$indexedMap$);
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			$elm$core$List$foldl$($elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Array$toIndexedList = function (array) {
	var len = array.a;
	var helper = F2(
		function (entry, _v0) {
			var index = _v0.a;
			var list = _v0.b;
			return _Utils_Tuple2(
				index - 1,
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(index, entry),
					list));
		});
	return $elm$core$Array$foldr$(
		helper,
		_Utils_Tuple2(len - 1, _List_Nil),
		array).b;
};
var $author$project$WordSpellingGame$trayDropSlot$ = function (tileSize, trayLeft, centerX, slotCount) {
	return $elm$core$Basics$clamp$(
		0,
		slotCount - 1,
		$elm$core$Basics$round(((centerX - trayLeft) - (tileSize / 2)) / (tileSize + $author$project$WordSpellingGame$trayTileSpacing)));
};
var $author$project$WordSpellingGame$trayDropSlot = F4($author$project$WordSpellingGame$trayDropSlot$);
var $author$project$WordSpellingGame$trayX = $author$project$WordSpellingGame$boardX;
var $author$project$WordSpellingGame$insertIntoTray$ = function (currentTime, windowSize, tileIndex, position, setup, tiles) {
	var slotCount = $elm$core$Array$length(tiles);
	var target = $author$project$WordSpellingGame$trayDropSlot$(
		$author$project$WordSpellingGame$trayTileSize$(setup.traySize, windowSize),
		$author$project$WordSpellingGame$trayX(windowSize),
		$author$project$Coord$xRaw(position),
		slotCount);
	var shiftRight = F2(
		function (free, slot) {
			return ((_Utils_cmp(slot, target) > -1) && (_Utils_cmp(slot, free) < 0)) ? (slot + 1) : slot;
		});
	var shiftLeft = F2(
		function (free, slot) {
			return ((_Utils_cmp(slot, free) > 0) && (_Utils_cmp(slot, target) < 1)) ? (slot - 1) : slot;
		});
	var occupied = $elm$core$Set$fromList(
		$elm$core$List$filterMap$(
			function (_v6) {
				var index = _v6.a;
				var tile = _v6.b;
				if (_Utils_eq(index, tileIndex)) {
					return $elm$core$Maybe$Nothing;
				} else {
					var _v7 = tile.position;
					if (!_v7.$) {
						var slot = _v7.a;
						return $elm$core$Maybe$Just(slot);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}
			},
			$elm$core$Array$toIndexedList(tiles)));
	var rightFree = $elm$core$List$head(
		$elm$core$List$filter$(
			function (slot) {
				return !$elm$core$Set$member$(slot, occupied);
			},
			$elm$core$List$range$(target + 1, slotCount - 1)));
	var leftFree = $elm$core$List$maximum(
		$elm$core$List$filter$(
			function (slot) {
				return !$elm$core$Set$member$(slot, occupied);
			},
			$elm$core$List$range$(0, target - 1)));
	var slotMapping = function () {
		if (!$elm$core$Set$member$(target, occupied)) {
			return $elm$core$Basics$identity;
		} else {
			var _v1 = _Utils_Tuple2(leftFree, rightFree);
			if (!_v1.a.$) {
				if (!_v1.b.$) {
					var l = _v1.a.a;
					var r = _v1.b.a;
					return (_Utils_cmp(target - l, r - target) < 1) ? shiftLeft(l) : shiftRight(r);
				} else {
					var l = _v1.a.a;
					var _v2 = _v1.b;
					return shiftLeft(l);
				}
			} else {
				if (!_v1.b.$) {
					var _v3 = _v1.a;
					var r = _v1.b.a;
					return shiftRight(r);
				} else {
					var _v4 = _v1.a;
					var _v5 = _v1.b;
					return $elm$core$Basics$identity;
				}
			}
		}
	}();
	return $elm$core$Array$indexedMap$(
		F2(
			function (index, tile) {
				if (_Utils_eq(index, tileIndex)) {
					return _Utils_update(
						tile,
						{
							position: $author$project$WordSpellingGame$TileInTray$(target, $elm$core$Maybe$Nothing)
						});
				} else {
					var _v0 = tile.position;
					if (!_v0.$) {
						var slot = _v0.a;
						var newSlot = slotMapping(slot);
						return _Utils_eq(newSlot, slot) ? tile : _Utils_update(
							tile,
							{
								position: $author$project$WordSpellingGame$TileInTray$(
									newSlot,
									$elm$core$Maybe$Just(
										_Utils_Tuple2(currentTime, slot)))
							});
					} else {
						return tile;
					}
				}
			}),
		tiles);
};
var $author$project$WordSpellingGame$insertIntoTray = F6($author$project$WordSpellingGame$insertIntoTray$);
var $author$project$Coord$tuple = function (_v0) {
	var x_ = _v0.a;
	var y_ = _v0.b;
	return _Utils_Tuple2(x_, y_);
};
var $author$project$Coord$origin = $author$project$Coord$tuple(
	_Utils_Tuple2(0, 0));
var $author$project$WordSpellingGame$getTiles$ = function (windowSize, currentUserId, setup, shared, tiles) {
	var trayCount = function () {
		var _v5 = $author$project$WordSpellingGame$getPlayer$(currentUserId, shared);
		if (!_v5.$) {
			var player = _v5.a;
			return $author$project$IdArray$length(player.tray);
		} else {
			return $elm$core$Array$length(tiles);
		}
	}();
	var isCovered = function (tile) {
		var _v4 = tile.position;
		if (!_v4.$) {
			return false;
		} else {
			var gridPos = _v4.a;
			return $lamdera$containers$SeqDict$member$(gridPos, shared.board);
		}
	};
	var tiles2 = $elm$core$Array$foldl$(
		F2(
			function (tile, _v3) {
				var toDrop = _v3.a;
				var acc = _v3.b;
				return ((toDrop > 0) && isCovered(tile)) ? _Utils_Tuple2(toDrop - 1, acc) : _Utils_Tuple2(
					toDrop,
					$elm$core$Array$push$(tile, acc));
			}),
		_Utils_Tuple2(
			$elm$core$Array$length(tiles) - trayCount,
			$elm$core$Array$empty),
		tiles).b;
	return $elm$core$List$foldl$(
		F2(
			function (_v0, tiles3) {
				var index = _v0.a;
				var tile = _v0.b;
				var _v1 = tile.position;
				if (!_v1.$) {
					return tiles3;
				} else {
					var gridPos = _v1.a;
					var time = _v1.b;
					var _v2 = $lamdera$containers$SeqDict$get$(gridPos, shared.board);
					if (!_v2.$) {
						return $author$project$WordSpellingGame$insertIntoTray$(time, windowSize, index, $author$project$Coord$origin, setup, tiles3);
					} else {
						return tiles3;
					}
				}
			}),
		tiles2,
		$elm$core$Array$toIndexedList(tiles2));
};
var $author$project$WordSpellingGame$getTiles = F5($author$project$WordSpellingGame$getTiles$);
var $author$project$Geometry$Types$Point2d = $elm$core$Basics$identity;
var $author$project$Point2d$centroidHelp$ = function (x0, y0, count, dx, dy, points) {
	centroidHelp:
	while (true) {
		if (points.b) {
			var p = points.a;
			var remaining = points.b;
			var $temp$count = count + 1,
				$temp$dx = dx + (p.x - x0),
				$temp$dy = dy + (p.y - y0),
				$temp$points = remaining;
			count = $temp$count;
			dx = $temp$dx;
			dy = $temp$dy;
			points = $temp$points;
			continue centroidHelp;
		} else {
			return {x: x0 + (dx / count), y: y0 + (dy / count)};
		}
	}
};
var $author$project$Point2d$centroidHelp = F6($author$project$Point2d$centroidHelp$);
var $author$project$Point2d$centroid$ = function (_v0, rest) {
	var p0 = _v0;
	return $author$project$Point2d$centroidHelp$(p0.x, p0.y, 1, 0, 0, rest);
};
var $author$project$Point2d$centroid = F2($author$project$Point2d$centroid$);
var $author$project$Point2d$unwrap = function (_v0) {
	var pointCoordinates = _v0;
	return pointCoordinates;
};
var $author$project$Coord$roundPoint = function (point2d) {
	var point = $author$project$Point2d$unwrap(point2d);
	return $author$project$Coord$tuple(
		_Utils_Tuple2(
			$elm$core$Basics$round(point.x),
			$elm$core$Basics$round(point.y)));
};
var $author$project$NonemptyDict$values = function (_v0) {
	var v = _v0.b;
	var dict = _v0.c;
	return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
		v,
		$lamdera$containers$SeqDict$values(dict));
};
var $author$project$Touch$touchCentroid = function (touches) {
	return $author$project$Coord$roundPoint(
		function (_v0) {
			var head = _v0.a;
			var rest = _v0.b;
			return $author$project$Point2d$centroid$(head, rest);
		}(
			$mgold$elm_nonempty_list$List$Nonempty$map$(
				function ($) {
					return $.client;
				},
				$author$project$NonemptyDict$values(touches))));
};
var $author$project$WordSpellingGame$trayY$ = function (traySize, windowSize) {
	return $author$project$WordSpellingGame$boardY + $author$project$WordSpellingGame$boardWidth$(traySize, windowSize);
};
var $author$project$WordSpellingGame$trayY = F2($author$project$WordSpellingGame$trayY$);
var $author$project$WordSpellingGame$trayIndexAtPosition$ = function (setup, windowSize, coord, trayLength) {
	var relY = $author$project$Coord$yRaw(coord) - $author$project$WordSpellingGame$trayY$(setup.traySize, windowSize);
	var relX = $author$project$Coord$xRaw(coord) - $author$project$WordSpellingGame$trayX(windowSize);
	var index = $elm$core$Basics$floor(
		relX / ($author$project$WordSpellingGame$trayTileSize$(setup.traySize, windowSize) + $author$project$WordSpellingGame$trayTileSpacing));
	return ((relX >= 0) && ((relY >= 0) && ((_Utils_cmp(
		relY,
		$author$project$WordSpellingGame$trayHeight$(setup.traySize, windowSize)) < 0) && (_Utils_cmp(index, trayLength) < 0)))) ? $elm$core$Maybe$Just(index) : $elm$core$Maybe$Nothing;
};
var $author$project$WordSpellingGame$trayIndexAtPosition = F4($author$project$WordSpellingGame$trayIndexAtPosition$);
var $author$project$WordSpellingGame$dragStartHelper$ = function (time, windowSize, currentUserId, touches, setup, shared, oldModel) {
	var touchPosition = $author$project$Touch$touchCentroid(touches);
	var gameModel = _Utils_update(
		oldModel,
		{
			tiles: $author$project$WordSpellingGame$getTiles$(windowSize, currentUserId, setup, shared, oldModel.tiles)
		});
	var trayList = $elm$core$Array$toList(gameModel.tiles);
	var _v0 = $author$project$WordSpellingGame$boardCellAtPosition$(time, windowSize, setup, gameModel, touchPosition);
	if (!_v0.$) {
		var cell = _v0.a;
		var _v1 = A2(
			$elmcraft$core_extra$List$Extra$findIndex,
			function (tile) {
				var _v2 = tile.position;
				if (_v2.$ === 1) {
					var boardPosition = _v2.a;
					return _Utils_eq(boardPosition, cell);
				} else {
					return false;
				}
			},
			trayList);
		if (!_v1.$) {
			var tileIndex = _v1.a;
			return _Utils_update(
				gameModel,
				{
					dragging: $author$project$WordSpellingGame$Dragging(tileIndex)
				});
		} else {
			return gameModel;
		}
	} else {
		var _v3 = $author$project$WordSpellingGame$trayIndexAtPosition$(
			setup,
			windowSize,
			touchPosition,
			$author$project$OneOrGreater$toInt(setup.traySize));
		if (!_v3.$) {
			var index = _v3.a;
			var _v4 = A2(
				$elmcraft$core_extra$List$Extra$findIndex,
				function (tile) {
					var _v5 = tile.position;
					if (_v5.$ === 1) {
						return false;
					} else {
						var trayIndex = _v5.a;
						return _Utils_eq(trayIndex, index);
					}
				},
				trayList);
			if (!_v4.$) {
				var tileIndex = _v4.a;
				return _Utils_update(
					gameModel,
					{
						dragging: $author$project$WordSpellingGame$Dragging(tileIndex),
						highlightedPlayer: $elm$core$Maybe$Nothing,
						wordDefinition: $author$project$WordSpellingGame$WordDefinition_None
					});
			} else {
				return gameModel;
			}
		} else {
			return gameModel;
		}
	}
};
var $author$project$WordSpellingGame$dragStartHelper = F7($author$project$WordSpellingGame$dragStartHelper$);
var $author$project$WordSpellingGame$dragStart$ = function (time, windowSize, currentUserId, touches, setup, shared, gameModel) {
	return gameModel.showSettings ? gameModel : $author$project$WordSpellingGame$dragStartHelper$(time, windowSize, currentUserId, touches, setup, shared, gameModel);
};
var $author$project$WordSpellingGame$dragStart = F7($author$project$WordSpellingGame$dragStart$);
var $author$project$Game$dragStart$ = function (time, windowSize, currentUserId, touches, matchId, matchData, model) {
	if (!matchData.$) {
		var matchData2 = matchData.a;
		return _Utils_update(
			model,
			{
				startedGames: $lamdera$containers$SeqDict$updateIfExists$(
					matchId,
					function (game) {
						var _v1 = matchData2.data;
						switch (_v1.$) {
							case 0:
								if (!game.$) {
									var game2 = game.a;
									return $author$project$Game$GoModel_Game(
										$author$project$Go$dragStart(game2));
								} else {
									return game;
								}
							case 1:
								var setup = _v1.a;
								var shared = _v1.c;
								if (game.$ === 1) {
									var game2 = game.a;
									return $author$project$Game$WordSpellingGame_Game(
										$author$project$WordSpellingGame$dragStart$(time, windowSize, currentUserId, touches, setup, shared, game2));
								} else {
									return game;
								}
							default:
								return game;
						}
					},
					model.startedGames)
			});
	} else {
		return model;
	}
};
var $author$project$Game$dragStart = F7($author$project$Game$dragStart$);
var $author$project$Touch$Drag_CallThumbnail = 1;
var $author$project$Touch$Drag_Channel = 0;
var $author$project$Touch$Drag_Game = 2;
var $author$project$WordSpellingGame$boardHeight$ = function (traySize, windowSize) {
	return $author$project$WordSpellingGame$boardWidth$(traySize, windowSize) + $author$project$WordSpellingGame$trayHeight$(traySize, windowSize);
};
var $author$project$WordSpellingGame$boardHeight = F2($author$project$WordSpellingGame$boardHeight$);
var $author$project$WordSpellingGame$insideBoard$ = function (setup, model, windowSize, coord) {
	if (model.showSettings) {
		return false;
	} else {
		var x = $author$project$WordSpellingGame$boardX(windowSize);
		return (_Utils_cmp(
			$author$project$Coord$xRaw(coord),
			x) > 0) && ((_Utils_cmp(
			$author$project$Coord$xRaw(coord),
			x + $author$project$WordSpellingGame$boardWidth$(setup.traySize, windowSize)) < 0) && ((_Utils_cmp(
			$author$project$Coord$yRaw(coord),
			$author$project$WordSpellingGame$boardY) > 0) && (_Utils_cmp(
			$author$project$Coord$yRaw(coord),
			$author$project$WordSpellingGame$boardY + $author$project$WordSpellingGame$boardHeight$(setup.traySize, windowSize)) < 0)));
	}
};
var $author$project$WordSpellingGame$insideBoard = F4($author$project$WordSpellingGame$insideBoard$);
var $author$project$Game$insideBoard$ = function (windowSize, coord, guildOrDmId, matchId, matchData, games) {
	if (!matchData.$) {
		var matchData2 = matchData.a;
		var _v1 = matchData2.data;
		switch (_v1.$) {
			case 0:
				return false;
			case 1:
				var setup = _v1.a;
				var _v2 = $lamdera$containers$SeqDict$get$(
					matchId,
					$elm$core$Maybe$withDefault$(
						$author$project$Game$initModel,
						$lamdera$containers$SeqDict$get$(guildOrDmId, games)).startedGames);
				if ((!_v2.$) && (_v2.a.$ === 1)) {
					var game = _v2.a.a;
					return $author$project$WordSpellingGame$insideBoard$(setup, game, windowSize, coord);
				} else {
					return false;
				}
			default:
				return false;
		}
	} else {
		return false;
	}
};
var $author$project$Game$insideBoard = F6($author$project$Game$insideBoard$);
var $author$project$Coord$addTuple_$ = function (_v0, _v1) {
	var x0 = _v0.a;
	var y0 = _v0.b;
	var x1 = _v1.a;
	var y1 = _v1.b;
	return _Utils_Tuple2(
		$ianmackenzie$elm_units$Quantity$plus$(x0, x1),
		$ianmackenzie$elm_units$Quantity$plus$(y0, y1));
};
var $author$project$Coord$addTuple_ = F2($author$project$Coord$addTuple_$);
var $author$project$Call$aspectRatio = 16 / 9;
var $ianmackenzie$elm_units$Quantity$max$ = function (_v0, _v1) {
	var x = _v0;
	var y = _v1;
	return $elm$core$Basics$max$(x, y);
};
var $ianmackenzie$elm_units$Quantity$max = F2($ianmackenzie$elm_units$Quantity$max$);
var $author$project$Coord$maximum$ = function (_v0, _v1) {
	var x0 = _v0.a;
	var y0 = _v0.b;
	var x1 = _v1.a;
	var y1 = _v1.b;
	return _Utils_Tuple2(
		$ianmackenzie$elm_units$Quantity$max$(x0, x1),
		$ianmackenzie$elm_units$Quantity$max$(y0, y1));
};
var $author$project$Coord$maximum = F2($author$project$Coord$maximum$);
var $ianmackenzie$elm_units$Quantity$min$ = function (_v0, _v1) {
	var x = _v0;
	var y = _v1;
	return $elm$core$Basics$min$(x, y);
};
var $ianmackenzie$elm_units$Quantity$min = F2($ianmackenzie$elm_units$Quantity$min$);
var $author$project$Coord$minimum$ = function (_v0, _v1) {
	var x0 = _v0.a;
	var y0 = _v0.b;
	var x1 = _v1.a;
	var y1 = _v1.b;
	return _Utils_Tuple2(
		$ianmackenzie$elm_units$Quantity$min$(x0, x1),
		$ianmackenzie$elm_units$Quantity$min$(y0, y1));
};
var $author$project$Coord$minimum = F2($author$project$Coord$minimum$);
var $author$project$Call$thumbnailWindowWidth = function (isMobile) {
	return isMobile ? 200 : 300;
};
var $author$project$Call$thumbnailPosition$ = function (isMobile, windowSize, model) {
	var _v0 = model.thumbnailPosition;
	var x = _v0.a;
	var y = _v0.b;
	return $author$project$Coord$xy$(
		$elm$core$Basics$round(
			($author$project$Coord$xRaw(windowSize) - $author$project$Call$thumbnailWindowWidth(isMobile)) * x),
		$elm$core$Basics$round(
			($author$project$Coord$yRaw(windowSize) - ($author$project$Call$thumbnailWindowWidth(isMobile) / $author$project$Call$aspectRatio)) * y));
};
var $author$project$Call$thumbnailPosition = F3($author$project$Call$thumbnailPosition$);
var $author$project$Call$insideThumbnail$ = function (coord, config, model) {
	var isMobile = $author$project$MyUi$isMobile(config);
	var pA = $author$project$Call$thumbnailPosition$(isMobile, config.windowSize, model);
	var pB = $author$project$Coord$addTuple_$(
		_Utils_Tuple2(
			$author$project$Call$thumbnailWindowWidth(isMobile),
			$elm$core$Basics$round(
				$author$project$Call$thumbnailWindowWidth(isMobile) / $author$project$Call$aspectRatio)),
		pA);
	return _Utils_eq(
		$author$project$Coord$maximum$(pA, coord),
		coord) && _Utils_eq(
		$author$project$Coord$minimum$(pB, coord),
		coord);
};
var $author$project$Call$insideThumbnail = F3($author$project$Call$insideThumbnail$);
var $author$project$NonemptyDict$map$ = function (func, _v0) {
	var id = _v0.a;
	var a = _v0.b;
	var dict = _v0.c;
	return $author$project$NonemptyDict$NonemptyDict$(
		id,
		A2(func, id, a),
		$lamdera$containers$SeqDict$map$(func, dict));
};
var $author$project$NonemptyDict$map = F2($author$project$NonemptyDict$map$);
var $author$project$Point2d$translateBy$ = function (_v0, _v1) {
	var v = _v0;
	var p = _v1;
	return {x: p.x + v.x, y: p.y + v.y};
};
var $author$project$Point2d$translateBy = F2($author$project$Point2d$translateBy$);
var $author$project$Vector2d$xy$ = function (_v0, _v1) {
	var x = _v0;
	var y = _v1;
	return {x: x, y: y};
};
var $author$project$Vector2d$xy = F2($author$project$Vector2d$xy$);
var $author$project$Touch$removeSafeAreaTopInset$ = function (insetTop, touches) {
	return (!insetTop) ? touches : $author$project$NonemptyDict$map$(
		F2(
			function (_v0, touch) {
				return _Utils_update(
					touch,
					{
						client: $author$project$Point2d$translateBy$(
							$author$project$Vector2d$xy$(
								$ianmackenzie$elm_units$Quantity$zero,
								$author$project$CssPixels$cssPixels(-insetTop)),
							touch.client)
					});
			}),
		touches);
};
var $author$project$Touch$removeSafeAreaTopInset = F2($author$project$Touch$removeSafeAreaTopInset$);
var $author$project$Frontend$dragTargetHelper$ = function (startTouches, loggedIn, model) {
	var local = $author$project$Local$model(loggedIn.localState);
	var isMobile = $author$project$MyUi$isMobile(model);
	var insideBoard = function () {
		var _v1 = $author$project$FrontendExtra$currentGame$(local, model);
		if (!_v1.$) {
			var matchId = _v1.a.matchId;
			var match = _v1.a.match;
			var guildOrDmId = _v1.a.guildOrDmId;
			return $author$project$Game$insideBoard$(
				model.windowSize,
				$author$project$Touch$touchCentroid(
					$author$project$Touch$removeSafeAreaTopInset$(model.startupData.safeAreaInsetTop, startTouches)),
				guildOrDmId,
				matchId,
				match,
				loggedIn.games);
		} else {
			return false;
		}
	}();
	var centroid = $author$project$Touch$touchCentroid(startTouches);
	var _v0 = $author$project$Call$displayMode$(
		$author$project$MyUi$isMobile(model),
		local.localUser.session.userId,
		model.route,
		local.calls);
	if (_v0.$ === 3) {
		return $author$project$Call$insideThumbnail$(centroid, model, loggedIn.voiceChat) ? $elm$core$Maybe$Just(1) : (insideBoard ? $elm$core$Maybe$Just(2) : (isMobile ? $elm$core$Maybe$Just(0) : $elm$core$Maybe$Nothing));
	} else {
		return insideBoard ? $elm$core$Maybe$Just(2) : (isMobile ? $elm$core$Maybe$Just(0) : $elm$core$Maybe$Nothing);
	}
};
var $author$project$Frontend$dragTargetHelper = F3($author$project$Frontend$dragTargetHelper$);
var $author$project$Frontend$dragTarget$ = function (startTouches, model) {
	var _v0 = model.loginStatus;
	if (!_v0.$) {
		var loggedIn = _v0.a;
		var _v1 = loggedIn.drawingMode;
		if (_v1.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			return $author$project$Frontend$dragTargetHelper$(startTouches, loggedIn, model);
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Frontend$dragTarget = F2($author$project$Frontend$dragTarget$);
var $author$project$Call$dragThumbnail$ = function (isMobile, delta, windowSize, model) {
	var availableWidth = $author$project$Coord$xRaw(windowSize) - $author$project$Call$thumbnailWindowWidth(isMobile);
	var availableHeight = $author$project$Coord$yRaw(windowSize) - ($author$project$Call$thumbnailWindowWidth(isMobile) / $author$project$Call$aspectRatio);
	var _v0 = model.thumbnailPosition;
	var x = _v0.a;
	var y = _v0.b;
	return _Utils_update(
		model,
		{
			thumbnailPosition: _Utils_Tuple2(
				(availableWidth > 0) ? $elm$core$Basics$clamp$(0, 1, x + (delta.x / availableWidth)) : x,
				(availableHeight > 0) ? $elm$core$Basics$clamp$(0, 1, y + (delta.y / availableHeight)) : y)
		});
};
var $author$project$Call$dragThumbnail = F4($author$project$Call$dragThumbnail$);
var $author$project$ChannelHeader$showDmSettingsRedDot$ = function (otherUserId, local, loggedIn) {
	var _v0 = $lamdera$containers$SeqDict$get$(otherUserId, local.dmChannels);
	if (!_v0.$) {
		var dmChannel = _v0.a;
		var _v1 = dmChannel.e2ee;
		switch (_v1.$) {
			case 1:
				var _v2 = _v1.a;
				var requestedBy = _v2.a;
				return !_Utils_eq(requestedBy, local.localUser.session.userId);
			case 2:
				var declinedBy = _v1.a;
				return !_Utils_eq(declinedBy, local.localUser.session.userId);
			case 0:
				return false;
			default:
				return !$lamdera$containers$SeqSet$member$(otherUserId, loggedIn.e2eeKeysOnThisDevice);
		}
	} else {
		return false;
	}
};
var $author$project$ChannelHeader$showDmSettingsRedDot = F3($author$project$ChannelHeader$showDmSettingsRedDot$);
var $author$project$Pages$Guild$e2eeSectionIsExpanded$ = function (otherUserId, local, loggedIn) {
	return $elm$core$Maybe$withDefault$(
		$author$project$ChannelHeader$showDmSettingsRedDot$(otherUserId, local, loggedIn),
		$lamdera$containers$SeqDict$get$(otherUserId, loggedIn.e2eeSectionsExpanded));
};
var $author$project$Pages$Guild$e2eeSectionIsExpanded = F3($author$project$Pages$Guild$e2eeSectionIsExpanded$);
var $author$project$MessageMenu$editMessageTextInputId = $lamdera$program_test$Effect$Browser$Dom$id('editMessageTextInput');
var $author$project$FrontendExtra$pastedMessageFileName = 'message.txt';
var $author$project$FrontendExtra$pastedTextFileStatus = function (pastedText) {
	return $author$project$FileStatus$FileUploading$(
		$author$project$FileName$fromString($author$project$FrontendExtra$pastedMessageFileName),
		{
			sent: 0,
			size: $elm$bytes$Bytes$Encode$getStringWidth(pastedText)
		},
		$author$project$FileStatus$contentType('text/plain'),
		$author$project$FileStatus$IsNotEncrypted);
};
var $lamdera$program_test$Effect$Internal$StringBody = function (a) {
	return {$: 1, a: a};
};
var $lamdera$program_test$Effect$Http$stringBody$ = function (contentType, content) {
	return $lamdera$program_test$Effect$Internal$StringBody(
		{content: content, contentType: contentType});
};
var $lamdera$program_test$Effect$Http$stringBody = F2($lamdera$program_test$Effect$Http$stringBody$);
var $author$project$FileStatus$uploadString$ = function (onResult, guildOrDmId, fileId, text) {
	return $lamdera$program_test$Effect$Http$riskyRequest(
		{
			body: $lamdera$program_test$Effect$Http$stringBody$('text/plain', text),
			expect: $lamdera$program_test$Effect$Http$expectJson$(
				onResult,
				$miniBill$elm_codec$Codec$decoder($author$project$FileStatus$uploadResponseCodec)),
			headers: _List_Nil,
			method: 'POST',
			timeout: $elm$core$Maybe$Just($ianmackenzie$elm_units$Duration$minute),
			tracker: $elm$core$Maybe$Just(
				$author$project$FileStatus$uploadTrackerId$(guildOrDmId, fileId)),
			url: $author$project$FileStatus$domain + '/file/upload'
		});
};
var $author$project$FileStatus$uploadString = F4($author$project$FileStatus$uploadString$);
var $author$project$FrontendExtra$editMessage_gotPastedText$ = function (guildOrDmId, _v0, loggedIn) {
	var textAfterPaste = _v0.textAfterPaste;
	var pastedText = _v0.pastedText;
	var textBeforePaste = _v0.textBeforePaste;
	var _v1 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.editMessage);
	if (!_v1.$) {
		var edit = _v1.a;
		var fileId = $author$project$Id$nextId(edit.attachedFiles);
		return _Utils_Tuple2(
			_Utils_update(
				loggedIn,
				{
					editMessage: $lamdera$containers$SeqDict$insert$(
						guildOrDmId,
						_Utils_update(
							edit,
							{
								attachedFiles: $lamdera$containers$SeqDict$insert$(
									fileId,
									$author$project$FrontendExtra$pastedTextFileStatus(pastedText),
									edit.attachedFiles),
								text: _Utils_ap(
									textBeforePaste,
									_Utils_ap(
										$author$project$RichText$attachedFilePrefix,
										_Utils_ap(
											$author$project$Id$toString(fileId),
											_Utils_ap($author$project$RichText$attachedFileSuffix, textAfterPaste))))
							}),
						loggedIn.editMessage),
					typedTextCounter: loggedIn.typedTextCounter + 1
				}),
			$author$project$FileStatus$uploadString$(
				A3($author$project$Types$EditMessage_GotFileHashName, guildOrDmId, edit.messageIndex, fileId),
				guildOrDmId,
				fileId,
				pastedText));
	} else {
		return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
	}
};
var $author$project$FrontendExtra$editMessage_gotPastedText = F3($author$project$FrontendExtra$editMessage_gotPastedText$);
var $author$project$Emoji$maxEmojiLength = 8;
var $author$project$Emoji$emojiStartingWith$ = function (emojis, chars) {
	return $elm$core$List$foldl$(
		F2(
			function (length, result) {
				if (!result.$) {
					return result;
				} else {
					var emoji = $elm$core$String$fromList(
						$elm$core$List$take$(length, chars));
					return $lamdera$containers$SeqDict$member$(emoji, emojis) ? $elm$core$Maybe$Just(
						_Utils_Tuple2(emoji, length)) : $elm$core$Maybe$Nothing;
				}
			}),
		$elm$core$Maybe$Nothing,
		$elm$core$List$reverse(
			$elm$core$List$range$(1, $author$project$Emoji$maxEmojiLength)));
};
var $author$project$Emoji$emojiStartingWith = F2($author$project$Emoji$emojiStartingWith$);
var $author$project$Emoji$emojisInTextHelper$ = function (emojis, found, chars) {
	emojisInTextHelper:
	while (true) {
		if (!chars.b) {
			return found;
		} else {
			var rest = chars.b;
			var _v1 = $author$project$Emoji$emojiStartingWith$(emojis, chars);
			if (!_v1.$) {
				var _v2 = _v1.a;
				var emoji = _v2.a;
				var length = _v2.b;
				var $temp$found = $elm$core$List$member$(emoji, found) ? found : A2($elm$core$List$cons, emoji, found),
					$temp$chars = $elm$core$List$drop$(length, chars);
				found = $temp$found;
				chars = $temp$chars;
				continue emojisInTextHelper;
			} else {
				var $temp$chars = rest;
				chars = $temp$chars;
				continue emojisInTextHelper;
			}
		}
	}
};
var $author$project$Emoji$emojisInTextHelper = F3($author$project$Emoji$emojisInTextHelper$);
var $author$project$Emoji$emojisInText$ = function (emojiData, text) {
	return $elm$core$List$reverse(
		$author$project$Emoji$emojisInTextHelper$(
			emojiData.emojis,
			_List_Nil,
			$elm$core$String$toList(
				$elm$core$List$foldl$(
					F2(
						function (skinTone, text2) {
							return $elm$core$String$replace$(
								$author$project$Emoji$skinToneToString(skinTone),
								'',
								text2);
						}),
					text,
					$author$project$Emoji$allSkinTones))));
};
var $author$project$Emoji$emojisInText = F2($author$project$Emoji$emojisInText$);
var $author$project$RichText$emojisAndCustomEmojis$ = function (emojiData, nonempty) {
	return $elm$core$List$concatMap$(
		function (richText) {
			switch (richText.$) {
				case 10:
					return _List_Nil;
				case 11:
					var text = richText.a;
					return $elm$core$List$map$(
						$author$project$Emoji$EmojiOrCustomEmoji_Emoji,
						$author$project$Emoji$emojisInText$(
							emojiData,
							$MartinSStewart$elm_nonempty_string$String$Nonempty$toString(text)));
				case 0:
					return _List_Nil;
				case 1:
					return _List_Nil;
				case 2:
					var _char = richText.a;
					var rest = richText.b;
					return $elm$core$List$map$(
						$author$project$Emoji$EmojiOrCustomEmoji_Emoji,
						$author$project$Emoji$emojisInText$(
							emojiData,
							_Utils_ap(
								$elm$core$String$fromChar(_char),
								rest)));
				case 3:
					var nonempty2 = richText.a;
					return $author$project$RichText$emojisAndCustomEmojis$(emojiData, nonempty2);
				case 4:
					var nonempty2 = richText.a;
					return $author$project$RichText$emojisAndCustomEmojis$(emojiData, nonempty2);
				case 5:
					var nonempty2 = richText.a;
					return $author$project$RichText$emojisAndCustomEmojis$(emojiData, nonempty2);
				case 6:
					var nonempty2 = richText.a;
					return $author$project$RichText$emojisAndCustomEmojis$(emojiData, nonempty2);
				case 7:
					var nonempty2 = richText.a;
					return $author$project$RichText$emojisAndCustomEmojis$(emojiData, nonempty2);
				case 8:
					var list = richText.b;
					return $elm$core$Maybe$withDefault$(
						_List_Nil,
						$elm$core$Maybe$map$(
							$author$project$RichText$emojisAndCustomEmojis(emojiData),
							$mgold$elm_nonempty_list$List$Nonempty$fromList(list)));
				case 9:
					var nonempty2 = richText.c;
					return $author$project$RichText$emojisAndCustomEmojis$(emojiData, nonempty2);
				case 12:
					var _char = richText.a;
					var rest = richText.b;
					return $elm$core$List$map$(
						$author$project$Emoji$EmojiOrCustomEmoji_Emoji,
						$author$project$Emoji$emojisInText$(
							emojiData,
							_Utils_ap(
								$elm$core$String$fromChar(_char),
								rest)));
				case 13:
					var code = richText.b;
					return $elm$core$List$map$(
						$author$project$Emoji$EmojiOrCustomEmoji_Emoji,
						$author$project$Emoji$emojisInText$(emojiData, code));
				case 14:
					return _List_Nil;
				case 15:
					return _List_Nil;
				case 16:
					return _List_Nil;
				case 17:
					var customEmojiId = richText.a;
					return _List_fromArray(
						[
							$author$project$Emoji$EmojiOrCustomEmoji_CustomEmoji(customEmojiId)
						]);
				case 18:
					var items = richText.b;
					return $elm$core$List$concatMap$(
						$author$project$RichText$bulletItemConcatMap(
							$author$project$RichText$emojisAndCustomEmojis(emojiData)),
						$mgold$elm_nonempty_list$List$Nonempty$toList(items));
				default:
					return _List_Nil;
			}
		},
		$mgold$elm_nonempty_list$List$Nonempty$toList(nonempty));
};
var $author$project$RichText$emojisAndCustomEmojis = F2($author$project$RichText$emojisAndCustomEmojis$);
var $author$project$Serialize$encodeToBytesWithoutVersion$ = function (codec, value) {
	return $elm$bytes$Bytes$Encode$encode(
		A2($author$project$Serialize$getBytesEncoderHelper, codec, value));
};
var $author$project$Serialize$encodeToBytesWithoutVersion = F2($author$project$Serialize$encodeToBytesWithoutVersion$);
var $author$project$Encryption$encryptManyMessages$ = function (requestId, id, dataCodec, messages) {
	return A3(
		$lamdera$program_test$Effect$Command$sendToJsBytes,
		'encryption_to_js',
		$author$project$Encryption$encryption_to_js,
		$author$project$Serialize$encodeToBytes$(
			$author$project$Encryption$toJsCodec($author$project$Serialize$unit),
			$author$project$Encryption$ToJs_EncryptManyMessages(
				{
					data: $elm$core$List$map$(
						$author$project$Serialize$encodeToBytesWithoutVersion(dataCodec),
						messages),
					otherUserId: id.otherUserId,
					requestId: requestId
				})));
};
var $author$project$Encryption$encryptManyMessages = F4($author$project$Encryption$encryptManyMessages$);
var $author$project$Frontend$encryptConversation = function (_v0) {
	var requestId = _v0.a;
	var conversation = _v0.b;
	return $author$project$Encryption$encryptManyMessages$(
		requestId,
		conversation.id,
		$author$project$Message$contentAndEmbedsCodec,
		$elm$core$List$map$($elm$core$Tuple$second, conversation.messages));
};
var $miniBill$elm_codec$Codec$encodeToValue = function (codec) {
	return $miniBill$elm_codec$Codec$encoder(codec);
};
var $author$project$Ports$ExecCommandPort$ = function (htmlId, commands) {
	return {commands: commands, htmlId: htmlId};
};
var $author$project$Ports$ExecCommandPort = F2($author$project$Ports$ExecCommandPort$);
var $author$project$Ports$SelectRange$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Ports$SelectRange = F2($author$project$Ports$SelectRange$);
var $author$project$Ports$Undo = {$: 1};
var $author$project$Range$Range$ = function (start, end) {
	return {end: end, start: start};
};
var $author$project$Range$Range = F2($author$project$Range$Range$);
var $author$project$Range$codec = $miniBill$elm_codec$Codec$buildObject(
	$miniBill$elm_codec$Codec$field$(
		'end',
		function ($) {
			return $.end;
		},
		$miniBill$elm_codec$Codec$int,
		$miniBill$elm_codec$Codec$field$(
			'start',
			function ($) {
				return $.start;
			},
			$miniBill$elm_codec$Codec$int,
			$miniBill$elm_codec$Codec$object($author$project$Range$Range))));
var $author$project$Range$selectionDirectionCodec = $miniBill$elm_codec$Codec$enum$(
	$miniBill$elm_codec$Codec$string,
	_List_fromArray(
		[
			_Utils_Tuple2('forward', 0),
			_Utils_Tuple2('backward', 1)
		]));
var $author$project$Ports$execCommandCodec = $miniBill$elm_codec$Codec$buildCustom(
	A5(
		$miniBill$elm_codec$Codec$variant2,
		'selectRange',
		$author$project$Ports$SelectRange,
		$author$project$Range$codec,
		$author$project$Range$selectionDirectionCodec,
		A3(
			$miniBill$elm_codec$Codec$variant0,
			'undo',
			$author$project$Ports$Undo,
			A5(
				$miniBill$elm_codec$Codec$variant2,
				'insertText',
				$author$project$Ports$InsertText,
				$miniBill$elm_codec$Codec$string,
				$author$project$Range$codec,
				$miniBill$elm_codec$Codec$custom(
					F4(
						function (insertTextEncoder, undoEncoder, selectRangeEncoder, value) {
							switch (value.$) {
								case 0:
									var argA = value.a;
									var argB = value.b;
									return A2(insertTextEncoder, argA, argB);
								case 1:
									return undoEncoder;
								default:
									var argA = value.a;
									var argB = value.b;
									return A2(selectRangeEncoder, argA, argB);
							}
						}))))));
var $author$project$CodecExtra$htmlId = $miniBill$elm_codec$Codec$map$($lamdera$program_test$Effect$Browser$Dom$id, $lamdera$program_test$Effect$Browser$Dom$idToString, $miniBill$elm_codec$Codec$string);
var $author$project$Ports$execCommandPortCodec = $miniBill$elm_codec$Codec$buildObject(
	$miniBill$elm_codec$Codec$field$(
		'commands',
		function ($) {
			return $.commands;
		},
		$miniBill$elm_codec$Codec$list($author$project$Ports$execCommandCodec),
		$miniBill$elm_codec$Codec$field$(
			'htmlId',
			function ($) {
				return $.htmlId;
			},
			$author$project$CodecExtra$htmlId,
			$miniBill$elm_codec$Codec$object($author$project$Ports$ExecCommandPort))));
var $author$project$Ports$exec_command_to_js = _Platform_outgoingPort('exec_command_to_js', $elm$core$Basics$identity);
var $author$project$Ports$execCommand = function (data) {
	return A3(
		$lamdera$program_test$Effect$Command$sendToJs,
		'exec_command_to_js',
		$author$project$Ports$exec_command_to_js,
		A2($miniBill$elm_codec$Codec$encodeToValue, $author$project$Ports$execCommandPortCodec, data));
};
var $lamdera$program_test$Effect$File$BytesFile = function (a) {
	return {$: 0, a: a};
};
var $lamdera$program_test$Effect$File$MockFile = function (a) {
	return {$: 1, a: a};
};
var $lamdera$program_test$Effect$File$RealFile = function (a) {
	return {$: 0, a: a};
};
var $lamdera$program_test$Effect$File$StringFile = function (a) {
	return {$: 1, a: a};
};
var $lamdera$program_test$Effect$File$fromInternalFile = function (file) {
	if (!file.$) {
		var realFile = file.a;
		return $lamdera$program_test$Effect$File$RealFile(realFile);
	} else {
		var mockFile = file.a;
		return $lamdera$program_test$Effect$File$MockFile(
			{
				content: function () {
					var _v1 = mockFile.content;
					if (!_v1.$) {
						var a = _v1.a;
						return $lamdera$program_test$Effect$File$BytesFile(a);
					} else {
						var a = _v1.a;
						return $lamdera$program_test$Effect$File$StringFile(a);
					}
				}(),
				lastModified: mockFile.lastModified,
				mimeType: mockFile.mimeType,
				name: mockFile.name
			});
	}
};
var $lamdera$program_test$Effect$File$Select$file$ = function (mimeTypes, onSelect) {
	return $lamdera$program_test$Effect$Internal$FileSelectFile$(
		mimeTypes,
		A2($elm$core$Basics$composeR, $lamdera$program_test$Effect$File$fromInternalFile, onSelect));
};
var $lamdera$program_test$Effect$File$Select$file = F2($lamdera$program_test$Effect$File$Select$file$);
var $author$project$Local$mapModel$ = function (func, _v0) {
	var localModel_ = _v0;
	return _Utils_update(
		localModel_,
		{
			localModel: func(localModel_.localModel),
			serverModel: func(localModel_.serverModel)
		});
};
var $author$project$Local$mapModel = F2($author$project$Local$mapModel$);
var $author$project$FrontendExtra$fileDecryptedMessages$ = function (decrypted, loggedIn) {
	return _Utils_update(
		loggedIn,
		{
			localState: $author$project$Local$mapModel$(
				function (local) {
					var localUser = local.localUser;
					return _Utils_update(
						local,
						{
							localUser: _Utils_update(
								localUser,
								{
									decryptedMessages: $elm$core$List$foldl$(
										F2(
											function (_v0, dict) {
												var bytesHash = _v0.a;
												var result = _v0.b;
												return $lamdera$containers$SeqDict$insert$(bytesHash, result, dict);
											}),
										localUser.decryptedMessages,
										decrypted)
								})
						});
				},
				loggedIn.localState)
		});
};
var $author$project$FrontendExtra$fileDecryptedMessages = F2($author$project$FrontendExtra$fileDecryptedMessages$);
var $author$project$FileStatus$aesPrivateKey = $elm$core$Basics$identity;
var $author$project$Frontend$fileEncrypted$ = function (encrypted, fileStatus) {
	switch (fileStatus.$) {
		case 0:
			var fileName = fileStatus.a;
			var fileSize = fileStatus.b;
			var contentType = fileStatus.c;
			return $author$project$FileStatus$FileUploading$(
				fileName,
				_Utils_update(
					fileSize,
					{
						size: $elm$bytes$Bytes$width(encrypted.data)
					}),
				contentType,
				$author$project$FileStatus$IsEncrypted$(
					$author$project$FileStatus$aesPrivateKey(encrypted.key),
					function () {
						var _v1 = encrypted.thumbnail;
						if (!_v1.$) {
							return 1;
						} else {
							return 0;
						}
					}()));
		case 1:
			return fileStatus;
		default:
			return fileStatus;
	}
};
var $author$project$Frontend$fileEncrypted = F2($author$project$Frontend$fileEncrypted$);
var $author$project$FileStatus$fileKey = function (fileData) {
	var _v0 = _Utils_Tuple2(fileData.isEncrypted, fileData.fileHash);
	if (_v0.a.$ === 1) {
		var _v1 = _v0.a;
		var key = _v1.a;
		var hash = _v0.b;
		return $elm$core$Maybe$Just(
			{fileHash: hash, key: key});
	} else {
		var _v2 = _v0.a;
		return $elm$core$Maybe$Nothing;
	}
};
var $lamdera$program_test$Effect$File$Select$files$ = function (mimeTypes, onSelect) {
	return $lamdera$program_test$Effect$Internal$FileSelectFiles$(
		mimeTypes,
		F2(
			function (file_, files_) {
				return A2(
					onSelect,
					$lamdera$program_test$Effect$File$fromInternalFile(file_),
					$elm$core$List$map$($lamdera$program_test$Effect$File$fromInternalFile, files_));
			}));
};
var $lamdera$program_test$Effect$File$Select$files = F2($lamdera$program_test$Effect$File$Select$files$);
var $ianmackenzie$elm_units$Quantity$for$ = function (_v0, _v1) {
	var independentValue = _v0;
	var rateOfChange = _v1;
	return rateOfChange * independentValue;
};
var $ianmackenzie$elm_units$Quantity$for = F2($ianmackenzie$elm_units$Quantity$for$);
var $author$project$Frontend$forgetDecryptOldMessagesRequest$ = function (requestId, requests) {
	return _Utils_update(
		requests,
		{
			pendingDecryptedOldMessages: $lamdera$containers$SeqDict$remove$(requestId, requests.pendingDecryptedOldMessages)
		});
};
var $author$project$Frontend$forgetDecryptOldMessagesRequest = F2($author$project$Frontend$forgetDecryptOldMessagesRequest$);
var $author$project$Frontend$forgetEncryptFileRequest$ = function (requestId, requests) {
	return _Utils_update(
		requests,
		{
			pendingEncryptedFiles: $lamdera$containers$SeqDict$remove$(requestId, requests.pendingEncryptedFiles)
		});
};
var $author$project$Frontend$forgetEncryptFileRequest = F2($author$project$Frontend$forgetEncryptFileRequest$);
var $author$project$Frontend$forgetEncryptManyRequest$ = function (requestId, requests) {
	return _Utils_update(
		requests,
		{
			pendingEncryptedManyMessages: $lamdera$containers$SeqDict$remove$(requestId, requests.pendingEncryptedManyMessages),
			pendingEncryptedMessages: $lamdera$containers$SeqDict$remove$(requestId, requests.pendingEncryptedMessages)
		});
};
var $author$project$Frontend$forgetEncryptManyRequest = F2($author$project$Frontend$forgetEncryptManyRequest$);
var $author$project$Frontend$forgetEncryptRequest$ = function (requestId, requests) {
	return _Utils_update(
		requests,
		{
			pendingEncryptedEdits: $lamdera$containers$SeqDict$remove$(requestId, requests.pendingEncryptedEdits)
		});
};
var $author$project$Frontend$forgetEncryptRequest = F2($author$project$Frontend$forgetEncryptRequest$);
var $author$project$ChannelDescription$fromString = function (text) {
	return (_Utils_cmp(
		$elm$core$String$length(text),
		$author$project$ChannelDescription$maxLength) > 0) ? $elm$core$Result$Err(
		'Description can\u0027t be longer than ' + ($elm$core$String$fromInt($author$project$ChannelDescription$maxLength) + ' characters')) : $elm$core$Result$Ok(text);
};
var $author$project$GuildName$GuildName = $elm$core$Basics$identity;
var $author$project$GuildName$maxLength = 100;
var $author$project$GuildName$fromString = function (text) {
	var _v0 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(
		$elm$core$String$trim(text));
	if (!_v0.$) {
		var nonempty = _v0.a;
		return (_Utils_cmp(
			$MartinSStewart$elm_nonempty_string$String$Nonempty$length(nonempty),
			$author$project$GuildName$maxLength) > 0) ? $elm$core$Result$Err('Too long') : (A2(
			$MartinSStewart$elm_nonempty_string$String$Nonempty$any,
			function (_char) {
				return _char === '\n';
			},
			nonempty) ? $elm$core$Result$Err('Name can\u0027t contain line breaks') : $elm$core$Result$Ok(nonempty));
	} else {
		return $elm$core$Result$Err('Can\u0027t be empty');
	}
};
var $author$project$Encryption$encryptFile$ = function (requestId, contentType, data) {
	return A3(
		$lamdera$program_test$Effect$Command$sendToJsBytes,
		'encryption_to_js',
		$author$project$Encryption$encryption_to_js,
		$author$project$Serialize$encodeToBytes$(
			$author$project$Encryption$toJsCodec($author$project$Serialize$unit),
			$author$project$Encryption$ToJs_EncryptFile(
				{contentType: contentType, data: data, requestId: requestId})));
};
var $author$project$Encryption$encryptFile = F3($author$project$Encryption$encryptFile$);
var $author$project$FrontendExtra$mapEncryptionRequests$ = function (func, loggedIn) {
	return _Utils_update(
		loggedIn,
		{
			encryptionRequests: func(loggedIn.encryptionRequests)
		});
};
var $author$project$FrontendExtra$mapEncryptionRequests = F2($author$project$FrontendExtra$mapEncryptionRequests$);
var $author$project$FrontendExtra$startEncryptingFile$ = function (guildOrDmId, fileId, contentType, bytes, loggedIn) {
	return _Utils_Tuple2(
		$author$project$FrontendExtra$mapEncryptionRequests$(
			function (requests) {
				return _Utils_update(
					requests,
					{
						nextEncryptFileRequestId: $author$project$Id$increment(requests.nextEncryptFileRequestId),
						pendingEncryptedFiles: $lamdera$containers$SeqDict$insert$(
							requests.nextEncryptFileRequestId,
							{fileId: fileId, guildOrDmId: guildOrDmId},
							requests.pendingEncryptedFiles)
					});
			},
			loggedIn),
		$author$project$Encryption$encryptFile$(loggedIn.encryptionRequests.nextEncryptFileRequestId, contentType, bytes));
};
var $author$project$FrontendExtra$startEncryptingFile = F5($author$project$FrontendExtra$startEncryptingFile$);
var $author$project$FrontendExtra$gotPastedText$ = function (guildOrDmId, threadRoute, _v0, loggedIn) {
	var textAfterPaste = _v0.textAfterPaste;
	var pastedText = _v0.pastedText;
	var textBeforePaste = _v0.textBeforePaste;
	var fileId = function () {
		var _v4 = $lamdera$containers$SeqDict$get$(
			_Utils_Tuple2(guildOrDmId, threadRoute),
			loggedIn.filesToUpload);
		if (!_v4.$) {
			var dict = _v4.a;
			return $author$project$Id$nextId(
				$author$project$NonemptyDict$toSeqDict(dict));
		} else {
			return $author$project$Id$fromInt(1);
		}
	}();
	var draft = _Utils_ap(
		textBeforePaste,
		_Utils_ap(
			$author$project$RichText$attachedFilePrefix,
			_Utils_ap(
				$author$project$Id$toString(fileId),
				_Utils_ap($author$project$RichText$attachedFileSuffix, textAfterPaste))));
	var loggedIn2 = _Utils_update(
		loggedIn,
		{
			drafts: function () {
				var _v2 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(draft);
				if (!_v2.$) {
					var nonempty = _v2.a;
					return $lamdera$containers$SeqDict$insert$(
						_Utils_Tuple2(guildOrDmId, threadRoute),
						nonempty,
						loggedIn.drafts);
				} else {
					return loggedIn.drafts;
				}
			}(),
			filesToUpload: $lamdera$containers$SeqDict$update$(
				_Utils_Tuple2(guildOrDmId, threadRoute),
				function (maybe) {
					if (!maybe.$) {
						var dict = maybe.a;
						return $elm$core$Maybe$Just(
							$author$project$NonemptyDict$insert$(
								fileId,
								$author$project$FrontendExtra$pastedTextFileStatus(pastedText),
								dict));
					} else {
						return $elm$core$Maybe$Just(
							$author$project$NonemptyDict$singleton$(
								fileId,
								$author$project$FrontendExtra$pastedTextFileStatus(pastedText)));
					}
				},
				loggedIn.filesToUpload)
		});
	var _v1 = $author$project$FrontendExtra$encryptedDmOtherUser$(
		guildOrDmId,
		$author$project$Local$model(loggedIn2.localState),
		loggedIn2);
	if (!_v1.$) {
		return $author$project$FrontendExtra$startEncryptingFile$(
			_Utils_Tuple2(guildOrDmId, threadRoute),
			fileId,
			'text/plain',
			$elm$bytes$Bytes$Encode$encode(
				$elm$bytes$Bytes$Encode$string(pastedText)),
			loggedIn2);
	} else {
		return _Utils_Tuple2(
			loggedIn2,
			$author$project$FileStatus$uploadString$(
				A3(
					$author$project$Types$GotFileHashName,
					_Utils_Tuple2(guildOrDmId, threadRoute),
					fileId,
					$elm$core$Maybe$Nothing),
				_Utils_Tuple2(guildOrDmId, threadRoute),
				fileId,
				pastedText));
	}
};
var $author$project$FrontendExtra$gotPastedText = F4($author$project$FrontendExtra$gotPastedText$);
var $author$project$Call$HasMediaDevices = function (a) {
	return {$: 1, a: a};
};
var $author$project$Call$gotUserMediaDevices$ = function (devices, selectedDevices, model) {
	return _Utils_update(
		model,
		{
			selectedAudioInputDevice: $elmcraft$core_extra$List$Extra$findMap$(
				function (device) {
					return ((!device.kind) && $elm$core$List$member$(device.deviceId, selectedDevices)) ? $elm$core$Maybe$Just(device.deviceId) : $elm$core$Maybe$Nothing;
				},
				devices),
			selectedVideoInputDevice: $elmcraft$core_extra$List$Extra$findMap$(
				function (device) {
					return ((device.kind === 1) && $elm$core$List$member$(device.deviceId, selectedDevices)) ? $elm$core$Maybe$Just(device.deviceId) : $elm$core$Maybe$Nothing;
				},
				devices),
			userMediaDevices: $author$project$Call$HasMediaDevices(devices)
		});
};
var $author$project$Call$gotUserMediaDevices = F3($author$project$Call$gotUserMediaDevices$);
var $ianmackenzie$elm_units$Quantity$greaterThan$ = function (_v0, _v1) {
	var y = _v0;
	var x = _v1;
	return _Utils_cmp(x, y) > 0;
};
var $ianmackenzie$elm_units$Quantity$greaterThan = F2($ianmackenzie$elm_units$Quantity$greaterThan$);
var $author$project$Message$NoThreadWithRepliedTo = function (a) {
	return {$: 0, a: a};
};
var $author$project$Message$ViewThreadWithRepliedTo$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Message$ViewThreadWithRepliedTo = F2($author$project$Message$ViewThreadWithRepliedTo$);
var $author$project$LocalState$guildOrDmIdToMessage$ = function (guildOrDmId, threadRoute, local) {
	var helper = function (channel) {
		if (threadRoute.$ === 1) {
			var threadId = threadRoute.a;
			var messageId = threadRoute.b;
			var _v5 = $author$project$MessageArray$get$(
				messageId,
				$elm$core$Maybe$withDefault$(
					$author$project$Thread$frontendInit,
					$lamdera$containers$SeqDict$get$(threadId, channel.threads)).messages);
			if (!_v5.$) {
				var message = _v5.a;
				switch (message.$) {
					case 0:
						var data = message.a;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(
								{content: data.content, createdAt: data.createdAt, createdBy: data.createdBy, editedAt: data.editedAt, reactions: data.reactions},
								$author$project$Message$ViewThreadWithRepliedTo$(
									threadId,
									$author$project$Message$replyToMaybe(data.repliedTo))));
					case 1:
						var data = message.a;
						var _v7 = $lamdera$containers$SeqDict$get$(
							$author$project$Encryption$hash(data.content),
							local.localUser.decryptedMessages);
						if ((!_v7.$) && (!_v7.a.$)) {
							var content = _v7.a.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(
									{content: content, createdAt: data.createdAt, createdBy: data.createdBy, editedAt: data.editedAt, reactions: data.reactions},
									$author$project$Message$ViewThreadWithRepliedTo$(
										threadId,
										$author$project$Message$replyToMaybe(data.repliedTo))));
						} else {
							return $elm$core$Maybe$Nothing;
						}
					case 2:
						return $elm$core$Maybe$Nothing;
					case 3:
						return $elm$core$Maybe$Nothing;
					case 4:
						return $elm$core$Maybe$Nothing;
					default:
						return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			var messageId = threadRoute.a;
			var _v8 = $author$project$MessageArray$get$(messageId, channel.messages);
			if (!_v8.$) {
				var message = _v8.a;
				switch (message.$) {
					case 0:
						var data = message.a;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(
								{content: data.content, createdAt: data.createdAt, createdBy: data.createdBy, editedAt: data.editedAt, reactions: data.reactions},
								$author$project$Message$NoThreadWithRepliedTo(data.repliedTo)));
					case 1:
						var data = message.a;
						var _v10 = $lamdera$containers$SeqDict$get$(
							$author$project$Encryption$hash(data.content),
							local.localUser.decryptedMessages);
						if ((!_v10.$) && (!_v10.a.$)) {
							var content = _v10.a.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(
									{content: content, createdAt: data.createdAt, createdBy: data.createdBy, editedAt: data.editedAt, reactions: data.reactions},
									$author$project$Message$NoThreadWithRepliedTo(data.repliedTo)));
						} else {
							return $elm$core$Maybe$Nothing;
						}
					case 2:
						return $elm$core$Maybe$Nothing;
					case 3:
						return $elm$core$Maybe$Nothing;
					case 4:
						return $elm$core$Maybe$Nothing;
					default:
						return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	};
	if (!guildOrDmId.$) {
		var id = guildOrDmId.a;
		var _v1 = $author$project$LocalState$getGuildAndChannel$(id, local);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var channel = _v2.b;
			return helper(channel);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		var otherUserId = guildOrDmId.a.otherUserId;
		var _v3 = $lamdera$containers$SeqDict$get$(otherUserId, local.dmChannels);
		if (!_v3.$) {
			var dmChannel = _v3.a;
			return helper(dmChannel);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$LocalState$guildOrDmIdToMessage = F3($author$project$LocalState$guildOrDmIdToMessage$);
var $author$project$MessageMenu$buttonHeight = function (isMobile) {
	return isMobile ? (22 + 34) : (6 + 30);
};
var $author$project$MessageMenu$ButtonItem = function (a) {
	return {$: 1, a: a};
};
var $author$project$MessageMenu$GroupItem = function (a) {
	return {$: 3, a: a};
};
var $author$project$MessageMenu$HorizontalLineItem = {$: 2};
var $author$project$Types$MessageMenu_PressedAddCustomEmojisToUser = function (a) {
	return {$: 64, a: a};
};
var $author$project$Types$MessageMenu_PressedDeleteMessage$ = function (a, b) {
	return {$: 62, a: a, b: b};
};
var $author$project$Types$MessageMenu_PressedDeleteMessage = F2($author$project$Types$MessageMenu_PressedDeleteMessage$);
var $author$project$Types$MessageMenu_PressedEditMessage$ = function (a, b) {
	return {$: 44, a: a, b: b};
};
var $author$project$Types$MessageMenu_PressedEditMessage = F2($author$project$Types$MessageMenu_PressedEditMessage$);
var $author$project$Types$MessageMenu_PressedMarkAsUnread$ = function (a, b) {
	return {$: 63, a: a, b: b};
};
var $author$project$Types$MessageMenu_PressedMarkAsUnread = F2($author$project$Types$MessageMenu_PressedMarkAsUnread$);
var $author$project$Types$MessageMenu_PressedOpenDiscordDm$ = function (a, b) {
	return {$: 66, a: a, b: b};
};
var $author$project$Types$MessageMenu_PressedOpenDiscordDm = F2($author$project$Types$MessageMenu_PressedOpenDiscordDm$);
var $author$project$Types$MessageMenu_PressedOpenDm = function (a) {
	return {$: 65, a: a};
};
var $author$project$Types$MessageMenu_PressedOpenThread = function (a) {
	return {$: 47, a: a};
};
var $author$project$Types$MessageMenu_PressedReactionEmoji = function (a) {
	return {$: 43, a: a};
};
var $author$project$Types$MessageMenu_PressedReply = function (a) {
	return {$: 46, a: a};
};
var $author$project$Types$MessageMenu_PressedShowReactionEmojiSelector$ = function (a, b, c) {
	return {$: 42, a: a, b: b, c: c};
};
var $author$project$Types$MessageMenu_PressedShowReactionEmojiSelector = F3($author$project$Types$MessageMenu_PressedShowReactionEmojiSelector$);
var $author$project$MessageMenu$NoItem = {$: 0};
var $author$project$Types$PressedCopyText = function (a) {
	return {$: 33, a: a};
};
var $author$project$LocalState$discordGuildAvailableStickersAndCustomEmojis$ = function (localUser, guild) {
	return _Utils_Tuple2(
		$lamdera$containers$SeqSet$intersect$(localUser.user.availableCustomEmojis, guild.customEmojis),
		$lamdera$containers$SeqSet$intersect$(localUser.user.availableStickers, guild.stickers));
};
var $author$project$LocalState$discordGuildAvailableStickersAndCustomEmojis = F2($author$project$LocalState$discordGuildAvailableStickersAndCustomEmojis$);
var $author$project$MessageMenu$slackWorkspaceCustomEmojis$ = function (teamId, local) {
	var _v0 = $lamdera$containers$SeqDict$get$(teamId, local.slackWorkspaces);
	if (!_v0.$) {
		var workspace = _v0.a;
		return $lamdera$containers$SeqSet$intersect$(local.localUser.user.availableCustomEmojis, workspace.customEmojis);
	} else {
		return $lamdera$containers$SeqSet$empty;
	}
};
var $author$project$MessageMenu$slackWorkspaceCustomEmojis = F2($author$project$MessageMenu$slackWorkspaceCustomEmojis$);
var $author$project$MessageMenu$availableCustomEmojisAndStickers$ = function (guildOrDmId, local) {
	switch (guildOrDmId.$) {
		case 0:
			return _Utils_Tuple2(local.localUser.user.availableCustomEmojis, local.localUser.user.availableStickers);
		case 1:
			if (!guildOrDmId.a.$) {
				var guildId = guildOrDmId.a.a.guildId;
				var _v1 = $lamdera$containers$SeqDict$get$(guildId, local.discordGuilds);
				if (!_v1.$) {
					var guild = _v1.a;
					return $author$project$LocalState$discordGuildAvailableStickersAndCustomEmojis$(local.localUser, guild);
				} else {
					return _Utils_Tuple2($lamdera$containers$SeqSet$empty, $lamdera$containers$SeqSet$empty);
				}
			} else {
				return _Utils_Tuple2($lamdera$containers$SeqSet$empty, $lamdera$containers$SeqSet$empty);
			}
		default:
			if (!guildOrDmId.a.$) {
				var teamId = guildOrDmId.a.a.teamId;
				return _Utils_Tuple2(
					$author$project$MessageMenu$slackWorkspaceCustomEmojis$(teamId, local),
					$lamdera$containers$SeqSet$empty);
			} else {
				var channelId = guildOrDmId.a.a.channelId;
				var _v2 = $lamdera$containers$SeqDict$get$(channelId, local.slackDmChannels);
				if (!_v2.$) {
					var dmChannel = _v2.a;
					return _Utils_Tuple2(
						$author$project$MessageMenu$slackWorkspaceCustomEmojis$(dmChannel.teamId, local),
						$lamdera$containers$SeqSet$empty);
				} else {
					return _Utils_Tuple2($lamdera$containers$SeqSet$empty, $lamdera$containers$SeqSet$empty);
				}
			}
	}
};
var $author$project$MessageMenu$availableCustomEmojisAndStickers = F2($author$project$MessageMenu$availableCustomEmojisAndStickers$);
var $author$project$Internal$BitField$BitField = $elm$core$Basics$identity;
var $author$project$Internal$BitField$ones = ~0;
var $author$project$Internal$BitField$custom = function (details) {
	if ((!details.offset) && (!details.length)) {
		return {inverseMask: $author$project$Internal$BitField$ones, length: 0, mask: 0, offset: 0};
	} else {
		var offset = $elm$core$Basics$min$(
			$elm$core$Basics$max$(0, details.offset),
			31);
		var length = ((details.length + offset) > 32) ? (32 - offset) : details.length;
		var mask = ($author$project$Internal$BitField$ones >>> (32 - length)) << offset;
		return {inverseMask: ~mask, length: length, mask: mask, offset: offset};
	}
};
var $author$project$Internal$BitField$next$ = function (nextLength, _v0) {
	var existing = _v0;
	return $author$project$Internal$BitField$custom(
		{length: nextLength, offset: existing.offset + existing.length});
};
var $author$project$Internal$BitField$next = F2($author$project$Internal$BitField$next$);
var $author$project$Internal$BitField$first = function (len) {
	return $author$project$Internal$BitField$custom(
		{length: len, offset: 0});
};
var $author$project$Internal$Flag$skip = $author$project$Internal$BitField$first(0);
var $author$project$Internal$Flag$padding = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$skip);
var $author$project$Internal$Flag$spacing = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$padding);
var $author$project$Internal$Flag$fontSize = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$spacing);
var $author$project$Internal$Flag$fontFamily = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$fontSize);
var $author$project$Internal$Flag$width = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$fontFamily);
var $author$project$Internal$Flag$height = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$width);
var $author$project$Internal$Flag$fontAlignment = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$height);
var $author$project$Internal$Flag$fontWeight = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$fontAlignment);
var $author$project$Internal$Flag$fontColor = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$fontWeight);
var $author$project$Internal$Flag$fontGradient = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$fontColor);
var $author$project$Internal$Flag$fontAdjustment = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$fontGradient);
var $author$project$Internal$Flag$fontEllipsis = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$fontAdjustment);
var $author$project$Internal$Flag$id = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$fontEllipsis);
var $author$project$Internal$Flag$txtShadows = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$id);
var $author$project$Internal$Flag$shadows = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$txtShadows);
var $author$project$Internal$Flag$overflow = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$shadows);
var $author$project$Internal$Flag$cursor = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$overflow);
var $author$project$Internal$Flag$transform = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$cursor);
var $author$project$Internal$Flag$borderWidth = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$transform);
var $author$project$Internal$Flag$yAlign = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$borderWidth);
var $author$project$Internal$Flag$xAlign = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$yAlign);
var $author$project$Internal$Flag$xContentAlign = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$xAlign);
var $author$project$Internal$Flag$yContentAlign = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$xContentAlign);
var $author$project$Internal$Flag$focus = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$yContentAlign);
var $author$project$Internal$Flag$active = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$focus);
var $author$project$Internal$Flag$hover = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$active);
var $author$project$Internal$Flag$gridTemplate = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$hover);
var $author$project$Internal$Flag$gridPosition = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$gridTemplate);
var $author$project$Internal$Flag$widthBetween = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$gridPosition);
var $author$project$Internal$Flag$heightBetween = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$widthBetween);
var $author$project$Internal$Flag$background = $author$project$Internal$BitField$next$(1, $author$project$Internal$Flag$heightBetween);
var $avh4$elm_color$Color$toCssString = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	var roundTo = function (x) {
		return $elm$core$Basics$round(x * 1000) / 1000;
	};
	var pct = function (x) {
		return $elm$core$Basics$round(x * 10000) / 100;
	};
	return $elm$core$String$concat(
		_List_fromArray(
			[
				'rgba(',
				$elm$core$String$fromFloat(
				pct(r)),
				'%,',
				$elm$core$String$fromFloat(
				pct(g)),
				'%,',
				$elm$core$String$fromFloat(
				pct(b)),
				'%,',
				$elm$core$String$fromFloat(
				roundTo(a)),
				')'
			]));
};
var $author$project$Internal$Style2$color = function (colorDetails) {
	return $avh4$elm_color$Color$toCssString(colorDetails);
};
var $author$project$Internal$Model2$Attr = $elm$core$Basics$identity;
var $author$project$Internal$Model2$Attribute = $elm$core$Basics$identity;
var $author$project$Internal$Model2$NodeAsDiv = {$: 0};
var $author$project$Internal$BitField$none = 0;
var $author$project$Internal$Model2$styleWith$ = function (flag, name, val) {
	return {
		attr: {
			additionalInheritance: $author$project$Internal$BitField$none,
			attrs: _List_Nil,
			_class: $elm$core$Maybe$Nothing,
			nearby: $elm$core$Maybe$Nothing,
			node: $author$project$Internal$Model2$NodeAsDiv,
			styles: F2(
				function (_v0, _v1) {
					return _List_fromArray(
						[
							_Utils_Tuple2(name, val)
						]);
				})
		},
		flag: flag
	};
};
var $author$project$Internal$Model2$styleWith = F3($author$project$Internal$Model2$styleWith$);
var $author$project$Ui$background = function (color) {
	return $author$project$Internal$Model2$styleWith$(
		$author$project$Internal$Flag$background,
		'background-color',
		$author$project$Internal$Style2$color(color));
};
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $elm$svg$Svg$Attributes$strokeLinecap = _VirtualDom_attribute('stroke-linecap');
var $elm$svg$Svg$Attributes$strokeLinejoin = _VirtualDom_attribute('stroke-linejoin');
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $author$project$Icons$backward = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor'),
			$elm$svg$Svg$Attributes$width('24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M21 16.811c0 .864-.933 1.406-1.683.977l-7.108-4.061a1.125 1.125 0 0 1 0-1.954l7.108-4.061A1.125 1.125 0 0 1 21 8.689v8.122ZM11.25 16.811c0 .864-.933 1.406-1.683.977l-7.108-4.061a1.125 1.125 0 0 1 0-1.954l7.108-4.061a1.125 1.125 0 0 1 1.683.977v8.122Z')
				]),
			_List_Nil)
		]));
var $author$project$MyUi$border1 = $author$project$Ui$rgb$(34, 39, 56);
var $author$project$Internal$Model2$noStyles$ = function (inheritance, encoded) {
	return _List_Nil;
};
var $author$project$Internal$Model2$noStyles = F2($author$project$Internal$Model2$noStyles$);
var $author$project$Internal$Model2$noAttr = {
	attr: {additionalInheritance: $author$project$Internal$BitField$none, attrs: _List_Nil, _class: $elm$core$Maybe$Nothing, nearby: $elm$core$Maybe$Nothing, node: $author$project$Internal$Model2$NodeAsDiv, styles: $author$project$Internal$Model2$noStyles},
	flag: $author$project$Internal$Flag$skip
};
var $author$project$Ui$noAttr = $author$project$Internal$Model2$noAttr;
var $author$project$Ui$attrIf$ = function (bool, attr) {
	return bool ? attr : $author$project$Ui$noAttr;
};
var $author$project$Ui$attrIf = F2($author$project$Ui$attrIf$);
var $author$project$InternalAnim$Css$ColorProp$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$InternalAnim$Css$ColorProp = F2($author$project$InternalAnim$Css$ColorProp$);
var $author$project$InternalAnim$Move$Pos$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $author$project$InternalAnim$Move$Pos = F3($author$project$InternalAnim$Move$Pos$);
var $author$project$InternalAnim$Transition$Transition = function (a) {
	return {$: 0, a: a};
};
var $mdgriffith$elm_bezier$Bezier$Spline$ = function (a, b, c, d) {
	return {$: 0, a: a, b: b, c: c, d: d};
};
var $mdgriffith$elm_bezier$Bezier$Spline = F4($mdgriffith$elm_bezier$Bezier$Spline$);
var $mdgriffith$elm_bezier$Bezier$fromPoints = $mdgriffith$elm_bezier$Bezier$Spline;
var $mdgriffith$elm_bezier$Bezier$standard = A4(
	$mdgriffith$elm_bezier$Bezier$fromPoints,
	{x: 0, y: 0},
	{x: 0.4, y: 0},
	{x: 0.2, y: 1},
	{x: 1, y: 1});
var $author$project$InternalAnim$Transition$standard = $author$project$InternalAnim$Transition$Transition($mdgriffith$elm_bezier$Bezier$standard);
var $author$project$InternalAnim$Move$to = function (v) {
	return $author$project$InternalAnim$Move$Pos$($author$project$InternalAnim$Transition$standard, v, _List_Nil);
};
var $author$project$Animator$color$ = function (name, colorValue) {
	return $author$project$InternalAnim$Css$ColorProp$(
		name,
		$author$project$InternalAnim$Move$to(colorValue));
};
var $author$project$Animator$color = F2($author$project$Animator$color$);
var $author$project$Ui$Anim$backgroundColor = function (clr) {
	return $author$project$Animator$color$('background-color', clr);
};
var $author$project$Internal$Model2$classWith$ = function (flag, cls) {
	return {
		attr: {
			additionalInheritance: $author$project$Internal$BitField$none,
			attrs: _List_Nil,
			_class: $elm$core$Maybe$Just(cls),
			nearby: $elm$core$Maybe$Nothing,
			node: $author$project$Internal$Model2$NodeAsDiv,
			styles: $author$project$Internal$Model2$noStyles
		},
		flag: flag
	};
};
var $author$project$Internal$Model2$classWith = F2($author$project$Internal$Model2$classWith$);
var $author$project$Internal$Style$Generated$classes = {above: 'a', active: 'atv', alignBottom: 'ab', alignCenterX: 'cx', alignCenterY: 'cy', alignLeft: 'al', alignRight: 'ar', alignTop: 'at', alignedHorizontally: 'ah', any: 's', behind: 'bh', below: 'b', capturePointerEvents: 'cpe', clip: 'cp', clipX: 'cpx', clipY: 'cpy', column: 'c', contentBottom: 'cb', contentCenterX: 'ccx', contentCenterY: 'ccy', contentLeft: 'cl', contentRight: 'cr', contentTop: 'ct', cursorGrab: 'grab', cursorGrabbing: 'grabbing', cursorPointer: 'cptr', cursorText: 'ctxt', el: 'e', ellipses: 'ellip', focus: 'fcs', focusedWithin: 'focus-within', fontAdjusted: 'f-adj', fullSize: 'fs', grid: 'g', hasBehind: 'hbh', hasNearby: 'hnb', heightBounded: 'hb', heightContent: 'hc', heightExact: 'he', heightFill: 'hf', hover: 'hv', imageContainer: 'ic', inFront: 'fr', inputLabel: 'lbl', inputMultiline: 'iml', inputMultilineFiller: 'imlf', inputMultilineParent: 'imlp', inputMultilineWrapper: 'implw', inputReset: 'irs', inputText: 'it', inputTextInputWrapper: 'itw', inputTextParent: 'itp', italic: 'i', lineHeightPrefix: 'lh', link: 'lnk', nearby: 'nb', noTextSelection: 'notxt', nowrap: 'nowrp', onDismout: 'on-dismount', onFocused: 'on-focused', onFocusedWithin: 'on-focused-within', onHovered: 'on-hovered', onLeft: 'ol', onPressed: 'on-activated', onRendered: 'on-rendered', onRight: 'or', opaque: 'oq', overflowHidden: 'oh', padding: 'pad', page: 'pg', paragraph: 'p', passPointerEvents: 'ppe', root: 'elm-ui-root', row: 'r', scrollbars: 'sb', scrollbarsX: 'sbx', scrollbarsY: 'sby', sizeByCapital: 'cap', slider: 'sldr', spaceEvenly: 'sev', spacing: 'spc', stickyBottom: 'stick-bottom', stickyLeft: 'stick-left', stickyTop: 'stick-top', strike: 'sk', text: 't', textCenter: 'tc', textGradient: 'tgrd', textJustify: 'tj', textJustifyAll: 'tja', textLeft: 'tl', textRight: 'tr', textUnitalicized: 'tun', transform: 'move', transition: 'ts', transparent: 'clr', trigger: 'ui-trigger', underline: 'u', widthBounded: 'wb', widthContent: 'wc', widthExact: 'we', widthFill: 'wf'};
var $author$project$Internal$Style2$classes = $author$project$Internal$Style$Generated$classes;
var $author$project$Ui$contentCenterY = $author$project$Internal$Model2$classWith$($author$project$Internal$Flag$yContentAlign, $author$project$Internal$Style2$classes.contentCenterY);
var $author$project$Internal$Model2$AsEl = 2;
var $author$project$Internal$Model2$Element = $elm$core$Basics$identity;
var $author$project$Internal$Model2$NodeAsImage = {$: 30};
var $elm$html$Html$a = _VirtualDom_node('a');
var $author$project$Internal$Model2$NodeAsButton = {$: 4};
var $author$project$Internal$Model2$NodeAsLink = {$: 2};
var $author$project$Internal$BitField$flipIf$ = function (_v0, bool, bits) {
	var mask = _v0.mask;
	return bool ? (bits | mask) : bits;
};
var $author$project$Internal$BitField$flipIf = F3($author$project$Internal$BitField$flipIf$);
var $author$project$Internal$Flag$add$ = function (myFlag, myField) {
	return $author$project$Internal$BitField$flipIf$(myFlag, true, myField);
};
var $author$project$Internal$Flag$add = F2($author$project$Internal$Flag$add$);
var $author$project$Internal$Bits$Analyze$cssVars = $author$project$Internal$BitField$first(1);
var $author$project$Internal$BitField$fieldEqual$ = function (_v0, _v1) {
	var one = _v0;
	var two = _v1;
	return _Utils_eq(one.offset, two.offset) && _Utils_eq(one.length, two.length);
};
var $author$project$Internal$BitField$fieldEqual = F2($author$project$Internal$BitField$fieldEqual$);
var $author$project$Internal$BitField$has$ = function (_v0, base) {
	var mask = _v0.mask;
	return !(!(mask & base));
};
var $author$project$Internal$BitField$has = F2($author$project$Internal$BitField$has$);
var $author$project$Internal$Bits$Inheritance$isRow = $author$project$Internal$BitField$first(1);
var $author$project$Internal$Bits$Inheritance$isColumn = $author$project$Internal$BitField$next$(1, $author$project$Internal$Bits$Inheritance$isRow);
var $author$project$Internal$Bits$Inheritance$isTextLayout = $author$project$Internal$BitField$next$(1, $author$project$Internal$Bits$Inheritance$isColumn);
var $author$project$Internal$Bits$Inheritance$hasTextModification = $author$project$Internal$BitField$next$(1, $author$project$Internal$Bits$Inheritance$isTextLayout);
var $author$project$Internal$Bits$Analyze$transforms = $author$project$Internal$BitField$next$(1, $author$project$Internal$Bits$Analyze$cssVars);
var $author$project$Internal$Bits$Analyze$nearbys = $author$project$Internal$BitField$next$(1, $author$project$Internal$Bits$Analyze$transforms);
var $author$project$Internal$Bits$Analyze$isLink = $author$project$Internal$BitField$next$(1, $author$project$Internal$Bits$Analyze$nearbys);
var $author$project$Internal$Bits$Analyze$isButton = $author$project$Internal$BitField$next$(1, $author$project$Internal$Bits$Analyze$isLink);
var $author$project$Internal$BitField$merge$ = function (one, two) {
	return one | two;
};
var $author$project$Internal$BitField$merge = F2($author$project$Internal$BitField$merge$);
var $author$project$Internal$Model2$analyze$ = function (has, encoded, inheritance, attrs) {
	analyze:
	while (true) {
		if (!attrs.b) {
			return _Utils_Tuple3(
				$author$project$Internal$BitField$flipIf$(
					$author$project$Internal$Bits$Analyze$cssVars,
					$author$project$Internal$BitField$has$($author$project$Internal$Flag$fontGradient, has),
					encoded),
				$author$project$Internal$BitField$flipIf$(
					$author$project$Internal$Bits$Inheritance$hasTextModification,
					$author$project$Internal$BitField$has$($author$project$Internal$Flag$fontGradient, has) || $author$project$Internal$BitField$has$($author$project$Internal$Flag$fontEllipsis, has),
					inheritance),
				has);
		} else {
			var attr = attrs.a.attr;
			var flag = attrs.a.flag;
			var remain = attrs.b;
			var previouslyRendered = $author$project$Internal$BitField$fieldEqual$(flag, $author$project$Internal$Flag$skip) ? false : $author$project$Internal$BitField$has$(flag, has);
			if (previouslyRendered) {
				var $temp$attrs = remain;
				attrs = $temp$attrs;
				continue analyze;
			} else {
				var details = attr;
				var newInheritance = $author$project$Internal$BitField$merge$(details.additionalInheritance, inheritance);
				var newEncoded = $author$project$Internal$BitField$flipIf$(
					$author$project$Internal$Bits$Analyze$isButton,
					_Utils_eq($author$project$Internal$Model2$NodeAsButton, details.node),
					$author$project$Internal$BitField$flipIf$(
						$author$project$Internal$Bits$Analyze$isLink,
						_Utils_eq($author$project$Internal$Model2$NodeAsLink, details.node),
						$author$project$Internal$BitField$flipIf$(
							$author$project$Internal$Bits$Analyze$nearbys,
							!_Utils_eq(details.nearby, $elm$core$Maybe$Nothing),
							encoded)));
				var $temp$has = $author$project$Internal$Flag$add$(flag, has),
					$temp$encoded = newEncoded,
					$temp$inheritance = newInheritance,
					$temp$attrs = remain;
				has = $temp$has;
				encoded = $temp$encoded;
				inheritance = $temp$inheritance;
				attrs = $temp$attrs;
				continue analyze;
			}
		}
	}
};
var $author$project$Internal$Model2$analyze = F4($author$project$Internal$Model2$analyze$);
var $elm$html$Html$article = _VirtualDom_node('article');
var $elm$html$Html$aside = _VirtualDom_node('aside');
var $elm$html$Html$button = _VirtualDom_node('button');
var $author$project$Internal$BitField$clear$ = function (_v0, bits) {
	var inverseMask = _v0.inverseMask;
	return inverseMask & bits;
};
var $author$project$Internal$BitField$clear = F2($author$project$Internal$BitField$clear$);
var $author$project$Internal$Bits$Inheritance$fontHeight = $author$project$Internal$BitField$next$(7, $author$project$Internal$Bits$Inheritance$hasTextModification);
var $author$project$Internal$Bits$Inheritance$spacingX = $author$project$Internal$BitField$next$(9, $author$project$Internal$Bits$Inheritance$fontHeight);
var $author$project$Internal$Bits$Inheritance$spacingY = $author$project$Internal$BitField$next$(9, $author$project$Internal$Bits$Inheritance$spacingX);
var $author$project$Internal$Bits$Inheritance$clearParentValues = function (bits) {
	return $author$project$Internal$BitField$clear$(
		$author$project$Internal$Bits$Inheritance$isTextLayout,
		$author$project$Internal$BitField$clear$(
			$author$project$Internal$Bits$Inheritance$isColumn,
			$author$project$Internal$BitField$clear$(
				$author$project$Internal$Bits$Inheritance$isRow,
				$author$project$Internal$BitField$clear$(
					$author$project$Internal$Bits$Inheritance$spacingY,
					$author$project$Internal$BitField$clear$($author$project$Internal$Bits$Inheritance$spacingX, bits)))));
};
var $author$project$Internal$Model2$columnClass = $author$project$Internal$Style2$classes.any + (' ' + $author$project$Internal$Style2$classes.column);
var $author$project$Internal$Model2$gridClass = $author$project$Internal$Style2$classes.any + (' ' + $author$project$Internal$Style2$classes.grid);
var $author$project$Internal$Model2$paragraphClass = $author$project$Internal$Style2$classes.any + (' ' + $author$project$Internal$Style2$classes.paragraph);
var $author$project$Internal$Model2$rootClass = $author$project$Internal$Style2$classes.root + (' ' + ($author$project$Internal$Style2$classes.any + (' ' + $author$project$Internal$Style2$classes.el)));
var $author$project$Internal$Model2$rowClass = $author$project$Internal$Style2$classes.any + (' ' + ($author$project$Internal$Style2$classes.row + (' ' + $author$project$Internal$Style2$classes.nowrap)));
var $author$project$Internal$Model2$singleClass = $author$project$Internal$Style2$classes.any + (' ' + $author$project$Internal$Style2$classes.el);
var $author$project$Internal$Model2$textColumnClass = $author$project$Internal$Style2$classes.any + (' ' + $author$project$Internal$Style2$classes.page);
var $author$project$Internal$Model2$contextClasses = function (context) {
	switch (context) {
		case 0:
			return $author$project$Internal$Model2$rowClass;
		case 1:
			return $author$project$Internal$Model2$columnClass;
		case 6:
			return $author$project$Internal$Model2$rootClass;
		case 2:
			return $author$project$Internal$Model2$singleClass;
		case 3:
			return $author$project$Internal$Model2$gridClass;
		case 4:
			return $author$project$Internal$Model2$paragraphClass;
		default:
			return $author$project$Internal$Model2$textColumnClass;
	}
};
var $elm$html$Html$div = _VirtualDom_node('div');
var $author$project$Internal$BitField$flip$ = function (_v0, bool, innerBits) {
	var inverseMask = _v0.inverseMask;
	var mask = _v0.mask;
	return bool ? (innerBits | mask) : (innerBits & inverseMask);
};
var $author$project$Internal$BitField$flip = F3($author$project$Internal$BitField$flip$);
var $elm$html$Html$footer = _VirtualDom_node('footer');
var $author$project$Internal$BitField$get$ = function (_v0, bits) {
	var offset = _v0.offset;
	var length = _v0.length;
	var top = $author$project$Internal$BitField$ones >>> (32 - length);
	return top & (bits >>> offset);
};
var $author$project$Internal$BitField$get = F2($author$project$Internal$BitField$get$);
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $elm$html$Html$h5 = _VirtualDom_node('h5');
var $elm$html$Html$h6 = _VirtualDom_node('h6');
var $elm$html$Html$img = _VirtualDom_node('img');
var $author$project$Internal$BitField$init = 0;
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm$html$Html$main_ = _VirtualDom_node('main');
var $elm$html$Html$nav = _VirtualDom_node('nav');
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $author$project$Internal$Flag$none = $author$project$Internal$BitField$init;
var $elm$html$Html$ol = _VirtualDom_node('ol');
var $elm$html$Html$p = _VirtualDom_node('p');
var $elm$html$Html$section = _VirtualDom_node('section');
var $elm$html$Html$span = _VirtualDom_node('span');
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $elm$html$Html$tfoot = _VirtualDom_node('tfoot');
var $elm$html$Html$th = _VirtualDom_node('th');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $author$project$Internal$Model2$toAttrs$ = function (parentBits, myBits, has, htmlAttrs, attrs) {
	toAttrs:
	while (true) {
		if (!attrs.b) {
			return htmlAttrs;
		} else {
			var attr = attrs.a.attr;
			var flag = attrs.a.flag;
			var remain = attrs.b;
			var previouslyRendered = $author$project$Internal$BitField$fieldEqual$(flag, $author$project$Internal$Flag$skip) ? false : $author$project$Internal$BitField$has$(flag, has);
			if (previouslyRendered) {
				var $temp$attrs = remain;
				attrs = $temp$attrs;
				continue toAttrs;
			} else {
				var details = attr;
				var _v2 = details.attrs;
				if (!_v2.b) {
					var $temp$attrs = remain;
					attrs = $temp$attrs;
					continue toAttrs;
				} else {
					var newAttrs = function () {
						var _v3 = details.attrs;
						if (!_v3.b) {
							return htmlAttrs;
						} else {
							if (!_v3.b.b) {
								var single = _v3.a;
								return A2($elm$core$List$cons, single, htmlAttrs);
							} else {
								if (!_v3.b.b.b) {
									var first = _v3.a;
									var _v4 = _v3.b;
									var second = _v4.a;
									return A2(
										$elm$core$List$cons,
										first,
										A2($elm$core$List$cons, second, htmlAttrs));
								} else {
									var list = _v3;
									return _Utils_ap(list, htmlAttrs);
								}
							}
						}
					}();
					var $temp$has = $author$project$Internal$Flag$add$(flag, has),
						$temp$htmlAttrs = newAttrs,
						$temp$attrs = remain;
					has = $temp$has;
					htmlAttrs = $temp$htmlAttrs;
					attrs = $temp$attrs;
					continue toAttrs;
				}
			}
		}
	}
};
var $author$project$Internal$Model2$toAttrs = F5($author$project$Internal$Model2$toAttrs$);
var $author$project$Internal$Model2$Behind = 5;
var $author$project$Internal$Model2$Trigger = 6;
var $elm$html$Html$Attributes$class = _VirtualDom_attribute('class');
var $author$project$Internal$Model2$nearbyToHtml$ = function (inheritance, location, _v0) {
	var elem = _v0;
	return (location === 6) ? elem(inheritance) : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(
				_Utils_ap(
					$author$project$Internal$Style2$classes.nearby,
					_Utils_ap(
						' ' + ($author$project$Internal$Style2$classes.el + ' '),
						function () {
							switch (location) {
								case 0:
									return $author$project$Internal$Style2$classes.above;
								case 1:
									return $author$project$Internal$Style2$classes.below;
								case 2:
									return $author$project$Internal$Style2$classes.onRight;
								case 3:
									return $author$project$Internal$Style2$classes.onLeft;
								case 4:
									return $author$project$Internal$Style2$classes.inFront;
								case 5:
									return $author$project$Internal$Style2$classes.behind;
								default:
									return $author$project$Internal$Style2$classes.trigger;
							}
						}())))
			]),
		_List_fromArray(
			[
				elem(inheritance)
			]));
};
var $author$project$Internal$Model2$nearbyToHtml = F3($author$project$Internal$Model2$nearbyToHtml$);
var $author$project$Internal$Model2$toBehindElements$ = function (inheritance, foundElems, attrs) {
	toBehindElements:
	while (true) {
		if (!attrs.b) {
			return foundElems;
		} else {
			var attr = attrs.a.attr;
			var remain = attrs.b;
			var details = attr;
			var _v2 = details.nearby;
			_v2$2:
			while (true) {
				if (!_v2.$) {
					switch (_v2.a.a) {
						case 5:
							var _v3 = _v2.a;
							var _v4 = _v3.a;
							var behindElem = _v3.b;
							var $temp$foundElems = A2(
								$elm$core$List$cons,
								$author$project$Internal$Model2$nearbyToHtml$(inheritance, 5, behindElem),
								foundElems),
								$temp$attrs = remain;
							foundElems = $temp$foundElems;
							attrs = $temp$attrs;
							continue toBehindElements;
						case 6:
							var _v5 = _v2.a;
							var _v6 = _v5.a;
							var triggerElem = _v5.b;
							var $temp$foundElems = A2(
								$elm$core$List$cons,
								$author$project$Internal$Model2$nearbyToHtml$(inheritance, 6, triggerElem),
								foundElems),
								$temp$attrs = remain;
							foundElems = $temp$foundElems;
							attrs = $temp$attrs;
							continue toBehindElements;
						default:
							break _v2$2;
					}
				} else {
					break _v2$2;
				}
			}
			var $temp$attrs = remain;
			attrs = $temp$attrs;
			continue toBehindElements;
		}
	}
};
var $author$project$Internal$Model2$toBehindElements = F3($author$project$Internal$Model2$toBehindElements$);
var $author$project$Internal$Model2$toNearbyElements$ = function (inheritance, foundElems, attrs) {
	toNearbyElements:
	while (true) {
		if (!attrs.b) {
			return foundElems;
		} else {
			var attr = attrs.a.attr;
			var remain = attrs.b;
			var details = attr;
			var _v2 = details.nearby;
			if (_v2.$ === 1) {
				var $temp$attrs = remain;
				attrs = $temp$attrs;
				continue toNearbyElements;
			} else {
				switch (_v2.a.a) {
					case 5:
						var _v3 = _v2.a;
						var _v4 = _v3.a;
						var $temp$attrs = remain;
						attrs = $temp$attrs;
						continue toNearbyElements;
					case 6:
						var _v5 = _v2.a;
						var _v6 = _v5.a;
						var $temp$attrs = remain;
						attrs = $temp$attrs;
						continue toNearbyElements;
					default:
						var _v7 = _v2.a;
						var location = _v7.a;
						var nearbyElem = _v7.b;
						var $temp$foundElems = A2(
							$elm$core$List$cons,
							$author$project$Internal$Model2$nearbyToHtml$(inheritance, location, nearbyElem),
							foundElems),
							$temp$attrs = remain;
						foundElems = $temp$foundElems;
						attrs = $temp$attrs;
						continue toNearbyElements;
				}
			}
		}
	}
};
var $author$project$Internal$Model2$toNearbyElements = F3($author$project$Internal$Model2$toNearbyElements$);
var $author$project$Internal$Model2$prependReversed$ = function (rest, reversed) {
	prependReversed:
	while (true) {
		if (!reversed.b) {
			return rest;
		} else {
			var first = reversed.a;
			var remain = reversed.b;
			var $temp$rest = A2($elm$core$List$cons, first, rest),
				$temp$reversed = remain;
			rest = $temp$rest;
			reversed = $temp$reversed;
			continue prependReversed;
		}
	}
};
var $author$project$Internal$Model2$prependReversed = F2($author$project$Internal$Model2$prependReversed$);
var $author$project$Internal$Model2$unwrapChildrenHelp$ = function (inheritance, rendered, children) {
	unwrapChildrenHelp:
	while (true) {
		if (!children.b) {
			return rendered;
		} else {
			var toChild = children.a;
			var remain = children.b;
			var $temp$rendered = A2(
				$elm$core$List$cons,
				toChild(inheritance),
				rendered),
				$temp$children = remain;
			rendered = $temp$rendered;
			children = $temp$children;
			continue unwrapChildrenHelp;
		}
	}
};
var $author$project$Internal$Model2$unwrapChildrenHelp = F3($author$project$Internal$Model2$unwrapChildrenHelp$);
var $author$project$Internal$Model2$unwrapChildren$ = function (inheritance, rest, children) {
	return $author$project$Internal$Model2$prependReversed$(
		rest,
		$author$project$Internal$Model2$unwrapChildrenHelp$(inheritance, _List_Nil, children));
};
var $author$project$Internal$Model2$unwrapChildren = F3($author$project$Internal$Model2$unwrapChildren$);
var $author$project$Internal$Model2$toChildren$ = function (myBits, analyzedBits, attrs, children) {
	return $author$project$Internal$BitField$has$($author$project$Internal$Bits$Analyze$nearbys, analyzedBits) ? $author$project$Internal$Model2$toBehindElements$(
		myBits,
		$author$project$Internal$Model2$unwrapChildren$(
			myBits,
			$author$project$Internal$Model2$toNearbyElements$(myBits, _List_Nil, attrs),
			children),
		attrs) : $author$project$Internal$Model2$unwrapChildren$(myBits, _List_Nil, children);
};
var $author$project$Internal$Model2$toChildren = F4($author$project$Internal$Model2$toChildren$);
var $author$project$Internal$Model2$addStyles$ = function (styles, attrs) {
	addStyles:
	while (true) {
		if (!styles.b) {
			return attrs;
		} else {
			var _v1 = styles.a;
			var name = _v1.a;
			var val = _v1.b;
			var remain = styles.b;
			var $temp$styles = remain,
				$temp$attrs = A2(
				$elm$core$List$cons,
				A2($elm$html$Html$Attributes$style, name, val),
				attrs);
			styles = $temp$styles;
			attrs = $temp$attrs;
			continue addStyles;
		}
	}
};
var $author$project$Internal$Model2$addStyles = F2($author$project$Internal$Model2$addStyles$);
var $author$project$Internal$Model2$toStyle$ = function (parentBits, myBits, analyzedBits, has, htmlAttrs, classes, attrs) {
	toStyle:
	while (true) {
		if (!attrs.b) {
			return $author$project$Internal$BitField$has$($author$project$Internal$Bits$Analyze$nearbys, analyzedBits) ? A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class(classes + (' ' + $author$project$Internal$Style2$classes.hasNearby)),
				htmlAttrs) : A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class(classes),
				htmlAttrs);
		} else {
			var attr = attrs.a.attr;
			var flag = attrs.a.flag;
			var remain = attrs.b;
			var previouslyRendered = $author$project$Internal$BitField$fieldEqual$(flag, $author$project$Internal$Flag$skip) ? false : $author$project$Internal$BitField$has$(flag, has);
			if (previouslyRendered) {
				var $temp$attrs = remain;
				attrs = $temp$attrs;
				continue toStyle;
			} else {
				var details = attr;
				var newClasses = function () {
					var _v7 = details._class;
					if (_v7.$ === 1) {
						return classes;
					} else {
						var classStr = _v7.a;
						return classes + (' ' + classStr);
					}
				}();
				var _v2 = A2(details.styles, parentBits, analyzedBits);
				if (!_v2.b) {
					var $temp$has = $author$project$Internal$Flag$add$(flag, has),
						$temp$classes = newClasses,
						$temp$attrs = remain;
					has = $temp$has;
					classes = $temp$classes;
					attrs = $temp$attrs;
					continue toStyle;
				} else {
					if (!_v2.b.b) {
						var _v3 = _v2.a;
						var name = _v3.a;
						var val = _v3.b;
						var $temp$has = $author$project$Internal$Flag$add$(flag, has),
							$temp$htmlAttrs = A2(
							$elm$core$List$cons,
							A2($elm$html$Html$Attributes$style, name, val),
							htmlAttrs),
							$temp$classes = newClasses,
							$temp$attrs = remain;
						has = $temp$has;
						htmlAttrs = $temp$htmlAttrs;
						classes = $temp$classes;
						attrs = $temp$attrs;
						continue toStyle;
					} else {
						if (!_v2.b.b.b) {
							var _v4 = _v2.a;
							var name = _v4.a;
							var val = _v4.b;
							var _v5 = _v2.b;
							var _v6 = _v5.a;
							var twoName = _v6.a;
							var twoVal = _v6.b;
							var $temp$has = $author$project$Internal$Flag$add$(flag, has),
								$temp$htmlAttrs = A2(
								$elm$core$List$cons,
								A2($elm$html$Html$Attributes$style, name, val),
								A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$style, twoName, twoVal),
									htmlAttrs)),
								$temp$classes = newClasses,
								$temp$attrs = remain;
							has = $temp$has;
							htmlAttrs = $temp$htmlAttrs;
							classes = $temp$classes;
							attrs = $temp$attrs;
							continue toStyle;
						} else {
							var list = _v2;
							var $temp$has = $author$project$Internal$Flag$add$(flag, has),
								$temp$htmlAttrs = $author$project$Internal$Model2$addStyles$(list, htmlAttrs),
								$temp$classes = newClasses,
								$temp$attrs = remain;
							has = $temp$has;
							htmlAttrs = $temp$htmlAttrs;
							classes = $temp$classes;
							attrs = $temp$attrs;
							continue toStyle;
						}
					}
				}
			}
		}
	}
};
var $author$project$Internal$Model2$toStyle = F7($author$project$Internal$Model2$toStyle$);
var $author$project$Internal$Model2$addStylesToString$ = function (styles, attrs) {
	addStylesToString:
	while (true) {
		if (!styles.b) {
			return attrs;
		} else {
			var _v1 = styles.a;
			var name = _v1.a;
			var val = _v1.b;
			var remain = styles.b;
			var $temp$styles = remain,
				$temp$attrs = name + (':' + (val + (';' + attrs)));
			styles = $temp$styles;
			attrs = $temp$attrs;
			continue addStylesToString;
		}
	}
};
var $author$project$Internal$Model2$addStylesToString = F2($author$project$Internal$Model2$addStylesToString$);
var $elm$virtual_dom$VirtualDom$property$ = function (key, value) {
	return A2(
		_VirtualDom_property,
		_VirtualDom_noInnerHtmlOrFormAction(key),
		_VirtualDom_noJavaScriptOrHtmlJson(value));
};
var $elm$virtual_dom$VirtualDom$property = F2($elm$virtual_dom$VirtualDom$property$);
var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
var $author$project$Internal$Model2$toStyleAsEncodedProperty$ = function (parentBits, myBits, analyzed, has, classesString, htmlAttrs, str, attrs) {
	toStyleAsEncodedProperty:
	while (true) {
		if (!attrs.b) {
			return A2(
				$elm$core$List$cons,
				$author$project$Internal$BitField$has$($author$project$Internal$Bits$Analyze$nearbys, analyzed) ? $elm$html$Html$Attributes$class(classesString + (' ' + $author$project$Internal$Style2$classes.hasNearby)) : $elm$html$Html$Attributes$class(classesString),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$Attributes$property,
						'style',
						$elm$json$Json$Encode$string(str)),
					htmlAttrs));
		} else {
			var attr = attrs.a.attr;
			var flag = attrs.a.flag;
			var remain = attrs.b;
			var previouslyRendered = $author$project$Internal$BitField$fieldEqual$(flag, $author$project$Internal$Flag$skip) ? false : $author$project$Internal$BitField$has$(flag, has);
			if (previouslyRendered) {
				var $temp$attrs = remain;
				attrs = $temp$attrs;
				continue toStyleAsEncodedProperty;
			} else {
				var details = attr;
				var newClasses = function () {
					var _v7 = details._class;
					if (_v7.$ === 1) {
						return classesString;
					} else {
						var moreClasses = _v7.a;
						return classesString + (' ' + moreClasses);
					}
				}();
				var _v2 = A2(details.styles, parentBits, analyzed);
				if (!_v2.b) {
					var $temp$has = $author$project$Internal$Flag$add$(flag, has),
						$temp$classesString = newClasses,
						$temp$attrs = remain;
					has = $temp$has;
					classesString = $temp$classesString;
					attrs = $temp$attrs;
					continue toStyleAsEncodedProperty;
				} else {
					if (!_v2.b.b) {
						var _v3 = _v2.a;
						var name = _v3.a;
						var val = _v3.b;
						var $temp$has = $author$project$Internal$Flag$add$(flag, has),
							$temp$classesString = newClasses,
							$temp$str = name + (':' + (val + (';' + str))),
							$temp$attrs = remain;
						has = $temp$has;
						classesString = $temp$classesString;
						str = $temp$str;
						attrs = $temp$attrs;
						continue toStyleAsEncodedProperty;
					} else {
						if (!_v2.b.b.b) {
							var _v4 = _v2.a;
							var name = _v4.a;
							var val = _v4.b;
							var _v5 = _v2.b;
							var _v6 = _v5.a;
							var twoName = _v6.a;
							var twoVal = _v6.b;
							var $temp$has = $author$project$Internal$Flag$add$(flag, has),
								$temp$classesString = newClasses,
								$temp$str = name + (':' + (val + (';' + (twoName + (':' + (twoVal + (';' + str))))))),
								$temp$attrs = remain;
							has = $temp$has;
							classesString = $temp$classesString;
							str = $temp$str;
							attrs = $temp$attrs;
							continue toStyleAsEncodedProperty;
						} else {
							var list = _v2;
							var $temp$has = $author$project$Internal$Flag$add$(flag, has),
								$temp$classesString = newClasses,
								$temp$str = $author$project$Internal$Model2$addStylesToString$(list, str),
								$temp$attrs = remain;
							has = $temp$has;
							classesString = $temp$classesString;
							str = $temp$str;
							attrs = $temp$attrs;
							continue toStyleAsEncodedProperty;
						}
					}
				}
			}
		}
	}
};
var $author$project$Internal$Model2$toStyleAsEncodedProperty = F8($author$project$Internal$Model2$toStyleAsEncodedProperty$);
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Internal$Model2$element$ = function (node, layout, attrs, children) {
	return function (parentBits) {
		var myBaseBits = function () {
			switch (layout) {
				case 0:
					return A2($author$project$Internal$BitField$flip, $author$project$Internal$Bits$Inheritance$isRow, true);
				case 1:
					return A2($author$project$Internal$BitField$flip, $author$project$Internal$Bits$Inheritance$isColumn, true);
				case 4:
					return A2($author$project$Internal$BitField$flip, $author$project$Internal$Bits$Inheritance$isTextLayout, true);
				case 5:
					return A2($author$project$Internal$BitField$flip, $author$project$Internal$Bits$Inheritance$isTextLayout, true);
				default:
					return $elm$core$Basics$identity;
			}
		}()(
			$author$project$Internal$Bits$Inheritance$clearParentValues(parentBits));
		var _v0 = $author$project$Internal$Model2$analyze$($author$project$Internal$Flag$none, $author$project$Internal$BitField$init, myBaseBits, attrs);
		var analyzedBits = _v0.a;
		var myBits = _v0.b;
		var iHave = _v0.c;
		var finalChildren = $author$project$Internal$Model2$toChildren$(myBits, analyzedBits, attrs, children);
		var htmlAttrs = function () {
			if ($author$project$Internal$BitField$has$($author$project$Internal$Bits$Inheritance$isTextLayout, parentBits) && $author$project$Internal$BitField$has$($author$project$Internal$Flag$xAlign, iHave)) {
				var spacingY = $author$project$Internal$BitField$get$($author$project$Internal$Bits$Inheritance$spacingY, parentBits);
				var spacingX = $author$project$Internal$BitField$get$($author$project$Internal$Bits$Inheritance$spacingX, parentBits);
				var margin = A2(
					$elm$html$Html$Attributes$style,
					'margin',
					$elm$core$String$fromInt(spacingY) + ('px' + (' ' + ($elm$core$String$fromInt(spacingX) + 'px'))));
				return $author$project$Internal$Model2$toAttrs$(
					parentBits,
					myBits,
					$author$project$Internal$Flag$none,
					_List_fromArray(
						[margin]),
					attrs);
			} else {
				return $author$project$Internal$Model2$toAttrs$(parentBits, myBits, $author$project$Internal$Flag$none, _List_Nil, attrs);
			}
		}();
		var styleAttrs = $author$project$Internal$BitField$has$($author$project$Internal$Bits$Analyze$cssVars, analyzedBits) ? $author$project$Internal$Model2$toStyleAsEncodedProperty$(
			parentBits,
			myBits,
			analyzedBits,
			$author$project$Internal$Flag$none,
			$author$project$Internal$Model2$contextClasses(layout),
			htmlAttrs,
			'',
			$elm$core$List$reverse(attrs)) : $author$project$Internal$Model2$toStyle$(
			parentBits,
			myBits,
			analyzedBits,
			$author$project$Internal$Flag$none,
			htmlAttrs,
			$author$project$Internal$Model2$contextClasses(layout),
			$elm$core$List$reverse(attrs));
		if (_Utils_eq(node, $author$project$Internal$Model2$NodeAsImage)) {
			return A2($elm$html$Html$img, styleAttrs, finalChildren);
		} else {
			if ($author$project$Internal$BitField$has$($author$project$Internal$Bits$Analyze$isLink, analyzedBits)) {
				return A2($elm$html$Html$a, styleAttrs, finalChildren);
			} else {
				if ($author$project$Internal$BitField$has$($author$project$Internal$Bits$Analyze$isButton, analyzedBits)) {
					return A2($elm$html$Html$button, styleAttrs, finalChildren);
				} else {
					switch (node.$) {
						case 0:
							return A2($elm$html$Html$div, styleAttrs, finalChildren);
						case 1:
							return A2($elm$html$Html$span, styleAttrs, finalChildren);
						case 2:
							return A2($elm$html$Html$a, styleAttrs, finalChildren);
						case 3:
							return A2($elm$html$Html$p, styleAttrs, finalChildren);
						case 4:
							return A2($elm$html$Html$button, styleAttrs, finalChildren);
						case 5:
							return A2($elm$html$Html$table, styleAttrs, finalChildren);
						case 6:
							return A2($elm$html$Html$thead, styleAttrs, finalChildren);
						case 7:
							return A2($elm$html$Html$th, styleAttrs, finalChildren);
						case 8:
							return A2($elm$html$Html$tr, styleAttrs, finalChildren);
						case 11:
							return A2($elm$html$Html$tbody, styleAttrs, finalChildren);
						case 9:
							return A2($elm$html$Html$td, styleAttrs, finalChildren);
						case 10:
							return A2($elm$html$Html$tfoot, styleAttrs, finalChildren);
						case 12:
							return A2($elm$html$Html$label, styleAttrs, finalChildren);
						case 13:
							return A2($elm$html$Html$input, styleAttrs, finalChildren);
						case 14:
							return A2($elm$html$Html$textarea, styleAttrs, finalChildren);
						case 30:
							return A2($elm$html$Html$img, styleAttrs, finalChildren);
						case 15:
							return A2($elm$html$Html$h1, styleAttrs, finalChildren);
						case 16:
							return A2($elm$html$Html$h2, styleAttrs, finalChildren);
						case 17:
							return A2($elm$html$Html$h3, styleAttrs, finalChildren);
						case 18:
							return A2($elm$html$Html$h4, styleAttrs, finalChildren);
						case 19:
							return A2($elm$html$Html$h5, styleAttrs, finalChildren);
						case 20:
							return A2($elm$html$Html$h6, styleAttrs, finalChildren);
						case 21:
							return A2($elm$html$Html$nav, styleAttrs, finalChildren);
						case 22:
							return A2($elm$html$Html$main_, styleAttrs, finalChildren);
						case 23:
							return A2($elm$html$Html$aside, styleAttrs, finalChildren);
						case 24:
							return A2($elm$html$Html$section, styleAttrs, finalChildren);
						case 25:
							return A2($elm$html$Html$article, styleAttrs, finalChildren);
						case 26:
							return A2($elm$html$Html$footer, styleAttrs, finalChildren);
						case 27:
							return A2($elm$html$Html$ol, styleAttrs, finalChildren);
						case 28:
							return A2($elm$html$Html$ul, styleAttrs, finalChildren);
						case 29:
							return A2($elm$html$Html$li, styleAttrs, finalChildren);
						default:
							var nodeName = node.a;
							return A3($elm$html$Html$node, nodeName, styleAttrs, finalChildren);
					}
				}
			}
		}
	};
};
var $author$project$Internal$Model2$element = F4($author$project$Internal$Model2$element$);
var $author$project$Ui$Fill = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$fill = $author$project$Ui$Fill(1);
var $author$project$Internal$Style2$px = function (x) {
	return $elm$core$String$fromInt(x) + 'px';
};
var $author$project$Internal$Model2$styleAndClass$ = function (flag, v) {
	return {
		attr: {
			additionalInheritance: $author$project$Internal$BitField$none,
			attrs: _List_Nil,
			_class: $elm$core$Maybe$Just(v._class),
			nearby: $elm$core$Maybe$Nothing,
			node: $author$project$Internal$Model2$NodeAsDiv,
			styles: F2(
				function (_v0, _v1) {
					return _List_fromArray(
						[
							_Utils_Tuple2(v.styleName, v.styleVal)
						]);
				})
		},
		flag: flag
	};
};
var $author$project$Internal$Model2$styleAndClass = F2($author$project$Internal$Model2$styleAndClass$);
var $author$project$Ui$width = function (len) {
	switch (len.$) {
		case 2:
			return $author$project$Internal$Model2$classWith$($author$project$Internal$Flag$width, $author$project$Internal$Style2$classes.widthContent);
		case 0:
			var x = len.a;
			return $author$project$Internal$Model2$styleAndClass$(
				$author$project$Internal$Flag$width,
				{
					_class: $author$project$Internal$Style2$classes.widthExact,
					styleName: 'width',
					styleVal: $author$project$Internal$Style2$px(x)
				});
		default:
			if (len.a === 1) {
				return $author$project$Internal$Model2$classWith$($author$project$Internal$Flag$width, $author$project$Internal$Style2$classes.widthFill);
			} else {
				var portionSize = len.a;
				return {
					attr: {
						additionalInheritance: $author$project$Internal$BitField$none,
						attrs: _List_Nil,
						_class: $elm$core$Maybe$Just($author$project$Internal$Style2$classes.widthFill),
						nearby: $elm$core$Maybe$Nothing,
						node: $author$project$Internal$Model2$NodeAsDiv,
						styles: F2(
							function (inheritance, _v1) {
								return $author$project$Internal$BitField$has$($author$project$Internal$Bits$Inheritance$isRow, inheritance) ? _List_fromArray(
									[
										$elm$core$Tuple$pair$(
										'flex-grow',
										$elm$core$String$fromInt(portionSize))
									]) : _List_Nil;
							})
					},
					flag: $author$project$Internal$Flag$width
				};
			}
	}
};
var $author$project$Ui$el$ = function (attrs, child) {
	return $author$project$Internal$Model2$element$(
		$author$project$Internal$Model2$NodeAsDiv,
		2,
		A2(
			$elm$core$List$cons,
			$author$project$Ui$width($author$project$Ui$fill),
			attrs),
		_List_fromArray(
			[child]));
};
var $author$project$Ui$el = F2($author$project$Ui$el$);
var $author$project$Ui$height = function (len) {
	switch (len.$) {
		case 2:
			return $author$project$Internal$Model2$classWith$($author$project$Internal$Flag$height, $author$project$Internal$Style2$classes.heightContent);
		case 0:
			var x = len.a;
			return $author$project$Internal$Model2$styleAndClass$(
				$author$project$Internal$Flag$height,
				{
					_class: $author$project$Internal$Style2$classes.heightExact,
					styleName: 'height',
					styleVal: $author$project$Internal$Style2$px(x)
				});
		default:
			if (len.a === 1) {
				return $author$project$Internal$Model2$classWith$($author$project$Internal$Flag$height, $author$project$Internal$Style2$classes.heightFill);
			} else {
				var portionSize = len.a;
				return {
					attr: {
						additionalInheritance: $author$project$Internal$BitField$none,
						attrs: _List_Nil,
						_class: $elm$core$Maybe$Just($author$project$Internal$Style2$classes.heightFill),
						nearby: $elm$core$Maybe$Nothing,
						node: $author$project$Internal$Model2$NodeAsDiv,
						styles: F2(
							function (inheritance, _v1) {
								return $author$project$Internal$BitField$has$($author$project$Internal$Bits$Inheritance$isColumn, inheritance) ? _List_fromArray(
									[
										$elm$core$Tuple$pair$(
										'flex-grow',
										$elm$core$String$fromInt(portionSize))
									]) : _List_Nil;
							})
					},
					flag: $author$project$Internal$Flag$width
				};
			}
	}
};
var $author$project$Ui$Anim$Hover = 0;
var $author$project$InternalAnim$Move$DisallowTransitions = 1;
var $author$project$InternalAnim$Css$Prop$ = function (a, b, c, d) {
	return {$: 0, a: a, b: b, c: c, d: d};
};
var $author$project$InternalAnim$Css$Prop = F4($author$project$InternalAnim$Css$Prop$);
var $author$project$InternalAnim$Move$Sequence$ = function (a, b, c, d) {
	return {$: 0, a: a, b: b, c: c, d: d};
};
var $author$project$InternalAnim$Move$Sequence = F4($author$project$InternalAnim$Move$Sequence$);
var $author$project$InternalAnim$Quantity$Quantity = $elm$core$Basics$identity;
var $author$project$InternalAnim$Time$zeroDuration = 0;
var $author$project$InternalAnim$Move$addSequence$ = function (n, dur, steps, _v0) {
	var transition = _v0.a;
	var value = _v0.b;
	var seq = _v0.c;
	return $author$project$InternalAnim$Move$Pos$(
		transition,
		value,
		_Utils_ap(
			seq,
			_List_fromArray(
				[
					$author$project$InternalAnim$Move$Sequence$(n, $author$project$InternalAnim$Time$zeroDuration, dur, steps)
				])));
};
var $author$project$InternalAnim$Move$addSequence = F4($author$project$InternalAnim$Move$addSequence$);
var $author$project$InternalAnim$Css$Props$noId = 100000;
var $author$project$InternalAnim$Css$match$ = function (one, two) {
	if (!one.$) {
		var id = one.a;
		var name = one.b;
		if (!two.$) {
			var twoId = two.a;
			var twoName = two.b;
			return ((!($author$project$InternalAnim$Css$Props$noId - id)) && (!($author$project$InternalAnim$Css$Props$noId - twoId))) ? _Utils_eq(name, twoName) : (!(id - twoId));
		} else {
			return false;
		}
	} else {
		var name = one.a;
		if (two.$ === 1) {
			var twoName = two.a;
			return _Utils_eq(name, twoName);
		} else {
			return false;
		}
	}
};
var $author$project$InternalAnim$Css$match = F2($author$project$InternalAnim$Css$match$);
var $author$project$Animator$firstMatch$ = function (prop, props) {
	firstMatch:
	while (true) {
		if (!props.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var next = props.a;
			var remain = props.b;
			if ($author$project$InternalAnim$Css$match$(prop, next)) {
				return $elm$core$Maybe$Just(next);
			} else {
				var $temp$props = remain;
				props = $temp$props;
				continue firstMatch;
			}
		}
	}
};
var $author$project$Animator$firstMatch = F2($author$project$Animator$firstMatch$);
var $author$project$InternalAnim$Move$Step$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $author$project$InternalAnim$Move$Step = F3($author$project$InternalAnim$Move$Step$);
var $author$project$InternalAnim$Move$stepWith = $author$project$InternalAnim$Move$Step;
var $author$project$Animator$formatColorSteps$ = function (steps, prop, pastSteps) {
	formatColorSteps:
	while (true) {
		if (!steps.b) {
			return $elm$core$List$reverse(pastSteps);
		} else {
			var _v1 = steps.a;
			var dur = _v1.a;
			var props = _v1.b;
			var next = steps.b;
			var _v2 = $author$project$Animator$firstMatch$(prop, props);
			if (_v2.$ === 1) {
				return $elm$core$List$reverse(pastSteps);
			} else {
				if (!_v2.a.$) {
					var _v3 = _v2.a;
					var $temp$steps = next;
					steps = $temp$steps;
					continue formatColorSteps;
				} else {
					var _v4 = _v2.a;
					var _v5 = _v4.b;
					var trans = _v5.a;
					var value = _v5.b;
					var $temp$steps = next,
						$temp$pastSteps = A2(
						$elm$core$List$cons,
						A3($author$project$InternalAnim$Move$stepWith, dur, trans, value),
						pastSteps);
					steps = $temp$steps;
					pastSteps = $temp$pastSteps;
					continue formatColorSteps;
				}
			}
		}
	}
};
var $author$project$Animator$formatColorSteps = F3($author$project$Animator$formatColorSteps$);
var $author$project$Animator$formatSteps$ = function (steps, prop, pastSteps) {
	formatSteps:
	while (true) {
		if (!steps.b) {
			return $elm$core$List$reverse(pastSteps);
		} else {
			var _v1 = steps.a;
			var dur = _v1.a;
			var props = _v1.b;
			var next = steps.b;
			var _v2 = $author$project$Animator$firstMatch$(prop, props);
			if (_v2.$ === 1) {
				return $elm$core$List$reverse(pastSteps);
			} else {
				if (!_v2.a.$) {
					var _v3 = _v2.a;
					var _v4 = _v3.c;
					var trans = _v4.a;
					var value = _v4.b;
					var $temp$steps = next,
						$temp$pastSteps = A2(
						$elm$core$List$cons,
						A3($author$project$InternalAnim$Move$stepWith, dur, trans, value),
						pastSteps);
					steps = $temp$steps;
					pastSteps = $temp$pastSteps;
					continue formatSteps;
				} else {
					var _v5 = _v2.a;
					var $temp$steps = next;
					steps = $temp$steps;
					continue formatSteps;
				}
			}
		}
	}
};
var $author$project$Animator$formatSteps = F3($author$project$Animator$formatSteps$);
var $author$project$Animator$addSequenceSteps$ = function (n, fullDuration, steps, prop) {
	if (!prop.$) {
		var id = prop.a;
		var name = prop.b;
		var movement = prop.c;
		var format = prop.d;
		var formattedSteps = $author$project$Animator$formatSteps$(steps, prop, _List_Nil);
		return $author$project$InternalAnim$Css$Prop$(
			id,
			name,
			$author$project$InternalAnim$Move$addSequence$(n, fullDuration, formattedSteps, movement),
			format);
	} else {
		var name = prop.a;
		var movement = prop.b;
		var formattedSteps = $author$project$Animator$formatColorSteps$(steps, prop, _List_Nil);
		return $author$project$InternalAnim$Css$ColorProp$(
			name,
			$author$project$InternalAnim$Move$addSequence$(n, fullDuration, formattedSteps, movement));
	}
};
var $author$project$Animator$addSequenceSteps = F4($author$project$Animator$addSequenceSteps$);
var $author$project$Animator$addIfNew$ = function (durationTillThisStep, stepProps, props) {
	addIfNew:
	while (true) {
		if (!props.b) {
			return stepProps;
		} else {
			if (!stepProps.b) {
				return props;
			} else {
				var topStep = stepProps.a;
				var remainingSteps = stepProps.b;
				if ($elm$core$List$any$(
					$author$project$InternalAnim$Css$match(topStep),
					props)) {
					var $temp$stepProps = remainingSteps;
					stepProps = $temp$stepProps;
					continue addIfNew;
				} else {
					var $temp$stepProps = remainingSteps,
						$temp$props = A2($elm$core$List$cons, topStep, props);
					stepProps = $temp$stepProps;
					props = $temp$props;
					continue addIfNew;
				}
			}
		}
	}
};
var $author$project$Animator$addIfNew = F3($author$project$Animator$addIfNew$);
var $author$project$InternalAnim$Quantity$plus$ = function (_v0, _v1) {
	var y = _v0;
	var x = _v1;
	return x + y;
};
var $author$project$InternalAnim$Quantity$plus = F2($author$project$InternalAnim$Quantity$plus$);
var $author$project$InternalAnim$Time$expand$ = function (one, two) {
	return $author$project$InternalAnim$Quantity$plus$(one, two);
};
var $author$project$InternalAnim$Time$expand = F2($author$project$InternalAnim$Time$expand$);
var $author$project$Animator$getInitialProps$ = function (durationTillThisStep, steps, props) {
	getInitialProps:
	while (true) {
		if (!steps.b) {
			return props;
		} else {
			var _v1 = steps.a;
			var dur = _v1.a;
			var stepProps = _v1.b;
			var remaining = steps.b;
			var newProps = $author$project$Animator$addIfNew$(durationTillThisStep, stepProps, props);
			var $temp$durationTillThisStep = $author$project$InternalAnim$Time$expand$(durationTillThisStep, dur),
				$temp$steps = remaining,
				$temp$props = newProps;
			durationTillThisStep = $temp$durationTillThisStep;
			steps = $temp$steps;
			props = $temp$props;
			continue getInitialProps;
		}
	}
};
var $author$project$Animator$getInitialProps = F3($author$project$Animator$getInitialProps$);
var $author$project$InternalAnim$Timeline$getUpdatedAt = function (_v0) {
	var details = _v0;
	return details.updatedAt;
};
var $author$project$InternalAnim$Timeline$Occurring$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $author$project$InternalAnim$Timeline$Occurring = F3($author$project$InternalAnim$Timeline$Occurring$);
var $author$project$InternalAnim$Timeline$endTime = function (_v0) {
	var end = _v0.c;
	return end;
};
var $author$project$InternalAnim$Timeline$startTime = function (_v0) {
	var time = _v0.b;
	return time;
};
var $author$project$InternalAnim$Time$thisBeforeThat$ = function (_v0, _v1) {
	var _this = _v0;
	var that = _v1;
	return (_this - that) < 0;
};
var $author$project$InternalAnim$Time$thisBeforeThat = F2($author$project$InternalAnim$Time$thisBeforeThat$);
var $author$project$InternalAnim$Timeline$visitAll$ = function (now, toAnchor, transitionTo, details, prev, queue, future, state) {
	visitAll:
	while (true) {
		if (!queue.b) {
			if (!future.b) {
				return state;
			} else {
				if (!future.b.b) {
					var _v2 = future.a;
					var futureStart = _v2.a;
					var futureEvent = _v2.b;
					var futureRemain = _v2.c;
					var _new = A8(
						transitionTo,
						toAnchor,
						prev,
						futureEvent,
						now,
						futureStart,
						$author$project$InternalAnim$Timeline$startTime(futureEvent),
						futureRemain,
						state);
					var $temp$prev = futureEvent,
						$temp$queue = futureRemain,
						$temp$future = _List_Nil,
						$temp$state = _new;
					prev = $temp$prev;
					queue = $temp$queue;
					future = $temp$future;
					state = $temp$state;
					continue visitAll;
				} else {
					var _v3 = future.a;
					var futureStart = _v3.a;
					var futureEvent = _v3.b;
					var futureRemain = _v3.c;
					var allFuture = future.b;
					var _v4 = allFuture.a;
					var nextStart = _v4.a;
					var nextEvent = _v4.b;
					var nextRemain = _v4.c;
					var restOfFuture = allFuture.b;
					if ($author$project$InternalAnim$Time$thisBeforeThat$(
						nextStart,
						$author$project$InternalAnim$Timeline$endTime(futureEvent))) {
						var _new = A8(
							transitionTo,
							toAnchor,
							prev,
							nextEvent,
							now,
							nextStart,
							$author$project$InternalAnim$Timeline$endTime(nextEvent),
							nextRemain,
							A8(transitionTo, toAnchor, prev, futureEvent, now, futureStart, nextStart, futureRemain, state));
						var $temp$prev = nextEvent,
							$temp$queue = nextRemain,
							$temp$future = restOfFuture,
							$temp$state = _new;
						prev = $temp$prev;
						queue = $temp$queue;
						future = $temp$future;
						state = $temp$state;
						continue visitAll;
					} else {
						var _new = A8(
							transitionTo,
							toAnchor,
							prev,
							futureEvent,
							now,
							$author$project$InternalAnim$Timeline$endTime(prev),
							$author$project$InternalAnim$Timeline$endTime(futureEvent),
							futureRemain,
							state);
						var $temp$prev = futureEvent,
							$temp$queue = futureRemain,
							$temp$future = allFuture,
							$temp$state = _new;
						prev = $temp$prev;
						queue = $temp$queue;
						future = $temp$future;
						state = $temp$state;
						continue visitAll;
					}
				}
			}
		} else {
			var top = queue.a;
			var remain = queue.b;
			if (!future.b) {
				var _new = A8(
					transitionTo,
					toAnchor,
					prev,
					top,
					now,
					$author$project$InternalAnim$Timeline$endTime(prev),
					$author$project$InternalAnim$Timeline$startTime(top),
					remain,
					state);
				var $temp$prev = top,
					$temp$queue = remain,
					$temp$state = _new;
				prev = $temp$prev;
				queue = $temp$queue;
				state = $temp$state;
				continue visitAll;
			} else {
				var _v6 = future.a;
				var futureStart = _v6.a;
				var futureEvent = _v6.b;
				var futureRemain = _v6.c;
				var restOfFuture = future.b;
				if ($author$project$InternalAnim$Time$thisBeforeThat$(
					futureStart,
					$author$project$InternalAnim$Timeline$endTime(top))) {
					var _new = A8(
						transitionTo,
						toAnchor,
						prev,
						futureEvent,
						now,
						futureStart,
						$author$project$InternalAnim$Timeline$endTime(futureEvent),
						futureRemain,
						A8(
							transitionTo,
							toAnchor,
							prev,
							top,
							now,
							$author$project$InternalAnim$Timeline$endTime(prev),
							futureStart,
							remain,
							state));
					var $temp$prev = futureEvent,
						$temp$queue = futureRemain,
						$temp$future = restOfFuture,
						$temp$state = _new;
					prev = $temp$prev;
					queue = $temp$queue;
					future = $temp$future;
					state = $temp$state;
					continue visitAll;
				} else {
					var _new = A8(
						transitionTo,
						toAnchor,
						prev,
						top,
						now,
						$author$project$InternalAnim$Timeline$endTime(prev),
						$author$project$InternalAnim$Timeline$endTime(top),
						remain,
						state);
					var $temp$prev = top,
						$temp$queue = remain,
						$temp$state = _new;
					prev = $temp$prev;
					queue = $temp$queue;
					state = $temp$state;
					continue visitAll;
				}
			}
		}
	}
};
var $author$project$InternalAnim$Timeline$visitAll = F8($author$project$InternalAnim$Timeline$visitAll$);
var $author$project$InternalAnim$Timeline$foldpAll$ = function (now, lookup, toStart, transitionTo, _v0) {
	var timelineDetails = _v0;
	var _v1 = timelineDetails.events;
	var timetable = _v1;
	var start = toStart(
		lookup(timelineDetails.initial));
	if (!timetable.b) {
		return start;
	} else {
		var _v3 = timetable.a;
		var lineStart = _v3.a;
		return $author$project$InternalAnim$Timeline$visitAll$(
			now,
			lookup,
			transitionTo,
			timelineDetails,
			$author$project$InternalAnim$Timeline$Occurring$(timelineDetails.initial, lineStart, lineStart),
			_List_Nil,
			timetable,
			start);
	}
};
var $author$project$InternalAnim$Timeline$foldpAll = F5($author$project$InternalAnim$Timeline$foldpAll$);
var $author$project$InternalAnim$Css$RenderedColorProp = function (a) {
	return {$: 1, a: a};
};
var $author$project$InternalAnim$Css$RenderedProp = function (a) {
	return {$: 0, a: a};
};
var $author$project$InternalAnim$Css$Props$zero = $author$project$InternalAnim$Move$to(0);
var $author$project$InternalAnim$Css$Props$default = function (id) {
	switch (id) {
		case 13:
			return $author$project$InternalAnim$Move$to(1);
		case 4:
			return $author$project$InternalAnim$Move$to(1);
		case 5:
			return $author$project$InternalAnim$Move$to(1);
		case 6:
			return $author$project$InternalAnim$Move$to(1);
		default:
			return $author$project$InternalAnim$Css$Props$zero;
	}
};
var $author$project$InternalAnim$Css$Props$groups = {scaling: 20, translation: 10};
var $author$project$InternalAnim$Units$pixels = function (ps) {
	return ps;
};
var $author$project$InternalAnim$Units$pixelsPerSecond = function (ps) {
	return ps;
};
var $author$project$InternalAnim$Move$init = function (movement) {
	return {
		position: function () {
			var x = movement.b;
			return $author$project$InternalAnim$Units$pixels(x);
		}(),
		velocity: $author$project$InternalAnim$Units$pixelsPerSecond(0)
	};
};
var $author$project$InternalAnim$Css$initState = function (x) {
	return {
		position: $author$project$InternalAnim$Units$pixels(x),
		velocity: $author$project$InternalAnim$Units$pixelsPerSecond(0)
	};
};
var $author$project$InternalAnim$Css$initVector = function (i) {
	return {
		x: $author$project$InternalAnim$Css$initState(i),
		y: $author$project$InternalAnim$Css$initState(i),
		z: $author$project$InternalAnim$Css$initState(i)
	};
};
var $author$project$InternalAnim$Css$Props$isScaleId = function (id) {
	return (id === 4) || ((id === 5) || ((id === 6) || (id === 7)));
};
var $author$project$InternalAnim$Css$Props$isTranslateId = function (id) {
	return id < 3;
};
var $author$project$InternalAnim$Css$matchColor$ = function (name, renderedProp) {
	switch (renderedProp.$) {
		case 0:
			return false;
		case 1:
			var details = renderedProp.a;
			return _Utils_eq(details.name, name);
		default:
			return false;
	}
};
var $author$project$InternalAnim$Css$matchColor = F2($author$project$InternalAnim$Css$matchColor$);
var $author$project$InternalAnim$Css$matchProp$ = function (id, renderedProp) {
	switch (renderedProp.$) {
		case 0:
			var details = renderedProp.a;
			return !(details.id - id);
		case 1:
			return false;
		default:
			return false;
	}
};
var $author$project$InternalAnim$Css$matchProp = F2($author$project$InternalAnim$Css$matchProp$);
var $author$project$InternalAnim$Css$addInitialProps$ = function (props, rendered) {
	addInitialProps:
	while (true) {
		if (!props.b) {
			return rendered;
		} else {
			if (!props.a.$) {
				var _v1 = props.a;
				var id = _v1.a;
				var name = _v1.b;
				var format = _v1.d;
				var remaining = props.b;
				var _new = function () {
					if ($author$project$InternalAnim$Css$Props$isTranslateId(id)) {
						var _v2 = rendered.translation;
						if (_v2.$ === 1) {
							return {
								props: rendered.props,
								scale: rendered.scale,
								translation: $elm$core$Maybe$Just(
									{
										format: format,
										group: $author$project$InternalAnim$Css$Props$groups.translation,
										name: name,
										sections: _List_Nil,
										state: $author$project$InternalAnim$Css$initVector(0)
									})
							};
						} else {
							return rendered;
						}
					} else {
						if ($author$project$InternalAnim$Css$Props$isScaleId(id)) {
							var _v3 = rendered.scale;
							if (_v3.$ === 1) {
								return {
									props: rendered.props,
									scale: $elm$core$Maybe$Just(
										{
											format: format,
											group: $author$project$InternalAnim$Css$Props$groups.scaling,
											name: name,
											sections: _List_Nil,
											state: $author$project$InternalAnim$Css$initVector(1)
										}),
									translation: rendered.scale
								};
							} else {
								return rendered;
							}
						} else {
							if ($elm$core$List$any$(
								function (renderedProp) {
									return $author$project$InternalAnim$Css$matchProp$(id, renderedProp);
								},
								rendered.props)) {
								return rendered;
							} else {
								return {
									props: A2(
										$elm$core$List$cons,
										$author$project$InternalAnim$Css$RenderedProp(
											{
												format: format,
												id: id,
												name: name,
												sections: _List_Nil,
												state: $author$project$InternalAnim$Move$init(
													$author$project$InternalAnim$Css$Props$default(id))
											}),
										rendered.props),
									scale: rendered.scale,
									translation: rendered.translation
								};
							}
						}
					}
				}();
				var $temp$props = remaining,
					$temp$rendered = _new;
				props = $temp$props;
				rendered = $temp$rendered;
				continue addInitialProps;
			} else {
				var _v4 = props.a;
				var name = _v4.a;
				var _v5 = _v4.b;
				var color = _v5.b;
				var remaining = props.b;
				var _new = $elm$core$List$any$(
					function (renderedProp) {
						return $author$project$InternalAnim$Css$matchColor$(name, renderedProp);
					},
					rendered.props) ? rendered : {
					props: A2(
						$elm$core$List$cons,
						$author$project$InternalAnim$Css$RenderedColorProp(
							{color: color, name: name, sections: _List_Nil}),
						rendered.props),
					scale: rendered.scale,
					translation: rendered.translation
				};
				var $temp$props = remaining,
					$temp$rendered = _new;
				props = $temp$props;
				rendered = $temp$rendered;
				continue addInitialProps;
			}
		}
	}
};
var $author$project$InternalAnim$Css$addInitialProps = F2($author$project$InternalAnim$Css$addInitialProps$);
var $author$project$InternalAnim$Css$VectorProp = function (a) {
	return {$: 2, a: a};
};
var $author$project$InternalAnim$Css$addMaybeVector$ = function (maybeVector, renderedProps) {
	if (maybeVector.$ === 1) {
		return renderedProps;
	} else {
		var vector = maybeVector.a;
		return A2(
			$elm$core$List$cons,
			$author$project$InternalAnim$Css$VectorProp(vector),
			renderedProps);
	}
};
var $author$project$InternalAnim$Css$addMaybeVector = F2($author$project$InternalAnim$Css$addMaybeVector$);
var $author$project$InternalAnim$Timeline$getEvent = function (_v0) {
	var ev = _v0.a;
	return ev;
};
var $author$project$InternalAnim$Move$toState = function (x) {
	return {
		position: $author$project$InternalAnim$Units$pixels(x),
		velocity: $author$project$InternalAnim$Units$pixelsPerSecond(0)
	};
};
var $author$project$InternalAnim$Css$Props$initVectorState$ = function (id, state) {
	switch (id) {
		case 0:
			return {
				x: state,
				y: $author$project$InternalAnim$Move$toState(0),
				z: $author$project$InternalAnim$Move$toState(0)
			};
		case 1:
			return {
				x: $author$project$InternalAnim$Move$toState(0),
				y: state,
				z: $author$project$InternalAnim$Move$toState(0)
			};
		case 2:
			return {
				x: $author$project$InternalAnim$Move$toState(0),
				y: $author$project$InternalAnim$Move$toState(0),
				z: state
			};
		case 4:
			return {x: state, y: state, z: state};
		case 5:
			return {
				x: state,
				y: $author$project$InternalAnim$Move$toState(1),
				z: $author$project$InternalAnim$Move$toState(1)
			};
		case 6:
			return {
				x: $author$project$InternalAnim$Move$toState(1),
				y: state,
				z: $author$project$InternalAnim$Move$toState(1)
			};
		case 7:
			return {
				x: $author$project$InternalAnim$Move$toState(1),
				y: $author$project$InternalAnim$Move$toState(1),
				z: state
			};
		default:
			return {
				x: $author$project$InternalAnim$Move$toState(0),
				y: $author$project$InternalAnim$Move$toState(0),
				z: $author$project$InternalAnim$Move$toState(0)
			};
	}
};
var $author$project$InternalAnim$Css$Props$initVectorState = F2($author$project$InternalAnim$Css$Props$initVectorState$);
var $author$project$InternalAnim$Css$Props$updateVectorById$ = function (id, val, vec) {
	switch (id) {
		case 0:
			return _Utils_update(
				vec,
				{x: val});
		case 1:
			return _Utils_update(
				vec,
				{y: val});
		case 2:
			return _Utils_update(
				vec,
				{z: val});
		case 4:
			return {x: val, y: val, z: val};
		case 5:
			return _Utils_update(
				vec,
				{x: val});
		case 6:
			return _Utils_update(
				vec,
				{y: val});
		case 7:
			return _Utils_update(
				vec,
				{z: val});
		default:
			return vec;
	}
};
var $author$project$InternalAnim$Css$Props$updateVectorById = F3($author$project$InternalAnim$Css$Props$updateVectorById$);
var $author$project$InternalAnim$Css$toInitialProps$ = function (props, rendered) {
	toInitialProps:
	while (true) {
		if (!props.b) {
			return rendered;
		} else {
			if (!props.a.$) {
				var _v1 = props.a;
				var id = _v1.a;
				var name = _v1.b;
				var movement = _v1.c;
				var format = _v1.d;
				var remaining = props.b;
				var $temp$props = remaining,
					$temp$rendered = function () {
					if ($author$project$InternalAnim$Css$Props$isTranslateId(id)) {
						var _v2 = rendered.translation;
						if (_v2.$ === 1) {
							return {
								props: rendered.props,
								scale: rendered.scale,
								translation: $elm$core$Maybe$Just(
									{
										format: format,
										group: $author$project$InternalAnim$Css$Props$groups.translation,
										name: name,
										sections: _List_Nil,
										state: $author$project$InternalAnim$Css$Props$initVectorState$(
											id,
											$author$project$InternalAnim$Move$init(movement))
									})
							};
						} else {
							var translation = _v2.a;
							return {
								props: rendered.props,
								scale: rendered.scale,
								translation: $elm$core$Maybe$Just(
									_Utils_update(
										translation,
										{
											state: $author$project$InternalAnim$Css$Props$updateVectorById$(
												id,
												$author$project$InternalAnim$Move$init(movement),
												translation.state)
										}))
							};
						}
					} else {
						if ($author$project$InternalAnim$Css$Props$isScaleId(id)) {
							var _v3 = rendered.scale;
							if (_v3.$ === 1) {
								return {
									props: rendered.props,
									scale: $elm$core$Maybe$Just(
										{
											format: format,
											group: $author$project$InternalAnim$Css$Props$groups.scaling,
											name: name,
											sections: _List_Nil,
											state: $author$project$InternalAnim$Css$Props$initVectorState$(
												id,
												$author$project$InternalAnim$Move$init(movement))
										}),
									translation: rendered.scale
								};
							} else {
								var scale = _v3.a;
								return {
									props: rendered.props,
									scale: $elm$core$Maybe$Just(
										_Utils_update(
											scale,
											{
												state: $author$project$InternalAnim$Css$Props$updateVectorById$(
													id,
													$author$project$InternalAnim$Move$init(movement),
													scale.state)
											})),
									translation: rendered.translation
								};
							}
						} else {
							var state = $author$project$InternalAnim$Move$init(
								$author$project$InternalAnim$Css$Props$default(id));
							return {
								props: A2(
									$elm$core$List$cons,
									$author$project$InternalAnim$Css$RenderedProp(
										{format: format, id: id, name: name, sections: _List_Nil, state: state}),
									rendered.props),
								scale: rendered.scale,
								translation: rendered.translation
							};
						}
					}
				}();
				props = $temp$props;
				rendered = $temp$rendered;
				continue toInitialProps;
			} else {
				var _v4 = props.a;
				var name = _v4.a;
				var _v5 = _v4.b;
				var color = _v5.b;
				var remaining = props.b;
				var $temp$props = remaining,
					$temp$rendered = {
					props: A2(
						$elm$core$List$cons,
						$author$project$InternalAnim$Css$RenderedColorProp(
							{color: color, name: name, sections: _List_Nil}),
						rendered.props),
					scale: rendered.scale,
					translation: rendered.translation
				};
				props = $temp$props;
				rendered = $temp$rendered;
				continue toInitialProps;
			}
		}
	}
};
var $author$project$InternalAnim$Css$toInitialProps = F2($author$project$InternalAnim$Css$toInitialProps$);
var $author$project$InternalAnim$Css$getInitial$ = function (timeline, lookup) {
	var rendered = $author$project$InternalAnim$Timeline$foldpAll$(
		$author$project$InternalAnim$Timeline$getUpdatedAt(timeline),
		lookup,
		function (props) {
			return $author$project$InternalAnim$Css$toInitialProps$(
				props,
				{props: _List_Nil, scale: $elm$core$Maybe$Nothing, translation: $elm$core$Maybe$Nothing});
		},
		F8(
			function (get, _v0, target, _v1, _v2, _v3, _v4, cursor) {
				return $author$project$InternalAnim$Css$addInitialProps$(
					get(
						$author$project$InternalAnim$Timeline$getEvent(target)),
					cursor);
			}),
		timeline);
	return $author$project$InternalAnim$Css$addMaybeVector$(
		rendered.scale,
		$author$project$InternalAnim$Css$addMaybeVector$(rendered.translation, rendered.props));
};
var $author$project$InternalAnim$Css$getInitial = F2($author$project$InternalAnim$Css$getInitial$);
var $author$project$InternalAnim$Css$Props$X = 0;
var $author$project$InternalAnim$Css$Props$Y = 1;
var $author$project$InternalAnim$Css$Props$Z = 2;
var $elm$core$Basics$cos = _Basics_cos;
var $elm$core$Basics$e = _Basics_e;
var $elm$core$Basics$sin = _Basics_sin;
var $elm$core$Basics$sqrt = _Basics_sqrt;
var $mdgriffith$elm_bezier$Bezier$Spring$at$ = function (_v0, duration) {
	var initial = _v0.initial;
	var target = _v0.target;
	var spring = _v0.spring;
	var magicNumber = $elm$core$Basics$sqrt(spring.stiffness / spring.mass);
	var t = (duration * magicNumber) / 1000;
	var dampingRatio = spring.damping / (2 * $elm$core$Basics$sqrt(spring.mass * spring.stiffness));
	var inner = $elm$core$Basics$sqrt(
		1 - A2($elm$core$Basics$pow, dampingRatio, 2));
	var c1 = target - initial.position;
	var c2 = dampingRatio * (c1 / inner);
	var sinElement = c2 * $elm$core$Basics$sin(inner * t);
	var cosinElement = c1 * $elm$core$Basics$cos(inner * t);
	var newPosition = A2($elm$core$Basics$pow, $elm$core$Basics$e, ((-1) * dampingRatio) * t) * (cosinElement + sinElement);
	var firstFactor = ((dampingRatio * c1) - (c2 * inner)) * $elm$core$Basics$cos(inner * t);
	var secondFactor = ((dampingRatio * c2) + (c1 * inner)) * $elm$core$Basics$sin(inner * t);
	var attentuationFactor = A2($elm$core$Basics$pow, $elm$core$Basics$e, ((-1) * dampingRatio) * t);
	var newVelocity = attentuationFactor * (firstFactor + secondFactor);
	return {position: target - newPosition, velocity: newVelocity * magicNumber};
};
var $mdgriffith$elm_bezier$Bezier$Spring$at = F2($mdgriffith$elm_bezier$Bezier$Spring$at$);
var $mdgriffith$elm_bezier$Bezier$atXTolerance = 0.0005;
var $mdgriffith$elm_bezier$Bezier$atXHelper$ = function (spline, desiredX, jumpSize, t, depth) {
	atXHelper:
	while (true) {
		var p1 = spline.a;
		var p2 = spline.b;
		var p3 = spline.c;
		var p4 = spline.d;
		var point = function () {
			if (t <= 0.5) {
				var q3 = {x: p3.x + (t * (p4.x - p3.x)), y: p3.y + (t * (p4.y - p3.y))};
				var q2 = {x: p2.x + (t * (p3.x - p2.x)), y: p2.y + (t * (p3.y - p2.y))};
				var r2 = {x: q2.x + (t * (q3.x - q2.x)), y: q2.y + (t * (q3.y - q2.y))};
				var q1 = {x: p1.x + (t * (p2.x - p1.x)), y: p1.y + (t * (p2.y - p1.y))};
				var r1 = {x: q1.x + (t * (q2.x - q1.x)), y: q1.y + (t * (q2.y - q1.y))};
				return {x: r1.x + (t * (r2.x - r1.x)), y: r1.y + (t * (r2.y - r1.y))};
			} else {
				var q3 = {x: p4.x + ((1 - t) * (p3.x - p4.x)), y: p4.y + ((1 - t) * (p3.y - p4.y))};
				var q2 = {x: p3.x + ((1 - t) * (p2.x - p3.x)), y: p3.y + ((1 - t) * (p2.y - p3.y))};
				var r2 = {x: q3.x + ((1 - t) * (q2.x - q3.x)), y: q3.y + ((1 - t) * (q2.y - q3.y))};
				var q1 = {x: p2.x + ((1 - t) * (p1.x - p2.x)), y: p2.y + ((1 - t) * (p1.y - p2.y))};
				var r1 = {x: q2.x + ((1 - t) * (q1.x - q2.x)), y: q2.y + ((1 - t) * (q1.y - q2.y))};
				return {x: r2.x + ((1 - t) * (r1.x - r2.x)), y: r2.y + ((1 - t) * (r1.y - r2.y))};
			}
		}();
		if (depth === 10) {
			return {point: point, t: t};
		} else {
			if ((_Utils_cmp(
				$elm$core$Basics$abs(point.x - desiredX),
				$mdgriffith$elm_bezier$Bezier$atXTolerance) < 0) && ($elm$core$Basics$abs(point.x - desiredX) >= 0)) {
				return {point: point, t: t};
			} else {
				if ((point.x - desiredX) > 0) {
					var $temp$jumpSize = jumpSize / 2,
						$temp$t = t - jumpSize,
						$temp$depth = depth + 1;
					jumpSize = $temp$jumpSize;
					t = $temp$t;
					depth = $temp$depth;
					continue atXHelper;
				} else {
					var $temp$jumpSize = jumpSize / 2,
						$temp$t = t + jumpSize,
						$temp$depth = depth + 1;
					jumpSize = $temp$jumpSize;
					t = $temp$t;
					depth = $temp$depth;
					continue atXHelper;
				}
			}
		}
	}
};
var $mdgriffith$elm_bezier$Bezier$atXHelper = F5($mdgriffith$elm_bezier$Bezier$atXHelper$);
var $mdgriffith$elm_bezier$Bezier$guessTime$ = function (now, _v0) {
	var one = _v0.a;
	var two = _v0.b;
	var three = _v0.c;
	var four = _v0.d;
	return (!(four.x - one.x)) ? 0.5 : ((now - one.x) / (four.x - one.x));
};
var $mdgriffith$elm_bezier$Bezier$guessTime = F2($mdgriffith$elm_bezier$Bezier$guessTime$);
var $mdgriffith$elm_bezier$Bezier$atX$ = function (x, spline) {
	return $mdgriffith$elm_bezier$Bezier$atXHelper$(
		spline,
		x,
		0.25,
		$mdgriffith$elm_bezier$Bezier$guessTime$(x, spline),
		0);
};
var $mdgriffith$elm_bezier$Bezier$atX = F2($mdgriffith$elm_bezier$Bezier$atX$);
var $mdgriffith$elm_bezier$Bezier$interpolateValue$ = function (start, end, t) {
	return (t <= 0.5) ? (start + (t * (end - start))) : (end + ((1 - t) * (start - end)));
};
var $mdgriffith$elm_bezier$Bezier$interpolateValue = F3($mdgriffith$elm_bezier$Bezier$interpolateValue$);
var $mdgriffith$elm_bezier$Bezier$firstDerivative$ = function (_v0, proportion) {
	var p1 = _v0.a;
	var p2 = _v0.b;
	var p3 = _v0.c;
	var p4 = _v0.d;
	var vy3 = p4.y - p3.y;
	var vy2 = p3.y - p2.y;
	var wy2 = $mdgriffith$elm_bezier$Bezier$interpolateValue$(vy2, vy3, proportion);
	var vy1 = p2.y - p1.y;
	var wy1 = $mdgriffith$elm_bezier$Bezier$interpolateValue$(vy1, vy2, proportion);
	var vx3 = p4.x - p3.x;
	var vx2 = p3.x - p2.x;
	var wx2 = $mdgriffith$elm_bezier$Bezier$interpolateValue$(vx2, vx3, proportion);
	var vx1 = p2.x - p1.x;
	var wx1 = $mdgriffith$elm_bezier$Bezier$interpolateValue$(vx1, vx2, proportion);
	return {
		x: 3 * $mdgriffith$elm_bezier$Bezier$interpolateValue$(wx1, wx2, proportion),
		y: 3 * $mdgriffith$elm_bezier$Bezier$interpolateValue$(wy1, wy2, proportion)
	};
};
var $mdgriffith$elm_bezier$Bezier$firstDerivative = F2($mdgriffith$elm_bezier$Bezier$firstDerivative$);
var $mdgriffith$elm_bezier$Bezier$Spring$clampToPortion = function (x) {
	return $elm$core$Basics$max$(
		0,
		$elm$core$Basics$min$(1, x));
};
var $mdgriffith$elm_bezier$Bezier$Spring$mapToRange$ = function (minimum, maximum, x) {
	var total = maximum - minimum;
	return minimum + (x * total);
};
var $mdgriffith$elm_bezier$Bezier$Spring$mapToRange = F3($mdgriffith$elm_bezier$Bezier$Spring$mapToRange$);
var $mdgriffith$elm_bezier$Bezier$Spring$criticalDamping$ = function (k, m) {
	return 2 * $elm$core$Basics$sqrt(k * m);
};
var $mdgriffith$elm_bezier$Bezier$Spring$criticalDamping = F2($mdgriffith$elm_bezier$Bezier$Spring$criticalDamping$);
var $mdgriffith$elm_bezier$Bezier$Spring$toleranceForSpringSettleTimeCalculation = (-1) * $elm$core$Basics$logBase$($elm$core$Basics$e, 0.005);
var $mdgriffith$elm_bezier$Bezier$Spring$settlesAt = function (_v0) {
	var mass = _v0.mass;
	var damping = _v0.damping;
	var stiffness = _v0.stiffness;
	var m = mass;
	var k = stiffness;
	var springAspect = $elm$core$Basics$sqrt(k / m);
	var cCritical = $mdgriffith$elm_bezier$Bezier$Spring$criticalDamping$(k, m);
	var c = damping;
	if (_Utils_eq(
		$elm$core$Basics$round(c),
		$elm$core$Basics$round(cCritical))) {
		return 1000 * (8.5 / springAspect);
	} else {
		if ((c - cCritical) > 0) {
			var dampingAspect = c / cCritical;
			return 1000 * ($mdgriffith$elm_bezier$Bezier$Spring$toleranceForSpringSettleTimeCalculation / (dampingAspect * springAspect));
		} else {
			var dampingAspect = c / cCritical;
			return 1000 * ($mdgriffith$elm_bezier$Bezier$Spring$toleranceForSpringSettleTimeCalculation / (dampingAspect * springAspect));
		}
	}
};
var $mdgriffith$elm_bezier$Bezier$Spring$wobble2Ratio$ = function (wobble, msDuration) {
	var scalingBelowDur = msDuration / 350;
	var top = $elm$core$Basics$max$(
		0.43,
		0.9 * $elm$core$Basics$min$(1, scalingBelowDur));
	var bounded = $mdgriffith$elm_bezier$Bezier$Spring$clampToPortion(wobble);
	return $mdgriffith$elm_bezier$Bezier$Spring$mapToRange$(0.43, top, 1 - bounded);
};
var $mdgriffith$elm_bezier$Bezier$Spring$wobble2Ratio = F2($mdgriffith$elm_bezier$Bezier$Spring$wobble2Ratio$);
var $mdgriffith$elm_bezier$Bezier$Spring$wobble2Damping$ = function (wobble, k, m, duration) {
	return $mdgriffith$elm_bezier$Bezier$Spring$wobble2Ratio$(wobble, duration) * $mdgriffith$elm_bezier$Bezier$Spring$criticalDamping$(k, m);
};
var $mdgriffith$elm_bezier$Bezier$Spring$wobble2Damping = F4($mdgriffith$elm_bezier$Bezier$Spring$wobble2Damping$);
var $mdgriffith$elm_bezier$Bezier$Spring$new = function (options) {
	var k = $mdgriffith$elm_bezier$Bezier$Spring$mapToRange$(
		120,
		210,
		$mdgriffith$elm_bezier$Bezier$Spring$clampToPortion(options.quickness));
	var damping = $mdgriffith$elm_bezier$Bezier$Spring$wobble2Damping$(options.wobble, k, 1, options.settleMax);
	var initiallySettlesAt = $mdgriffith$elm_bezier$Bezier$Spring$settlesAt(
		{damping: damping, mass: 1, stiffness: k});
	return (_Utils_cmp(initiallySettlesAt, options.settleMax) > 0) ? {damping: damping, mass: options.settleMax / initiallySettlesAt, stiffness: k} : {damping: damping, mass: 1, stiffness: k};
};
var $author$project$InternalAnim$Transition$atX$ = function (progress, transition) {
	if (!transition.$) {
		var spline = transition.a;
		var pos = $mdgriffith$elm_bezier$Bezier$atX$(progress, spline);
		return {
			position: pos.point,
			velocity: $mdgriffith$elm_bezier$Bezier$firstDerivative$(spline, pos.t)
		};
	} else {
		var wob = transition.a;
		var totalX = 1;
		var params = $mdgriffith$elm_bezier$Bezier$Spring$new(
			{quickness: wob.quickness, settleMax: totalX, wobble: wob.wobble});
		var sprung = $mdgriffith$elm_bezier$Bezier$Spring$at$(
			{
				initial: {position: 0, velocity: wob.introVelocity},
				spring: params,
				target: totalX * progress
			},
			1);
		return {
			position: {x: progress, y: sprung.position},
			velocity: {x: progress, y: sprung.velocity}
		};
	}
};
var $author$project$InternalAnim$Transition$atX = F2($author$project$InternalAnim$Transition$atX$);
var $author$project$InternalAnim$Quantity$greaterThan$ = function (_v0, _v1) {
	var y = _v0;
	var x = _v1;
	return _Utils_cmp(x, y) > 0;
};
var $author$project$InternalAnim$Quantity$greaterThan = F2($author$project$InternalAnim$Quantity$greaterThan$);
var $author$project$InternalAnim$Time$inMilliseconds = function (_v0) {
	var ms = _v0;
	return ms;
};
var $author$project$InternalAnim$Duration$milliseconds = function (numMilliseconds) {
	return 0.001 * numMilliseconds;
};
var $author$project$InternalAnim$Time$duration$ = function (one, two) {
	return $author$project$InternalAnim$Quantity$greaterThan$(two, one) ? $author$project$InternalAnim$Duration$milliseconds(
		$elm$core$Basics$max$(
			0,
			$author$project$InternalAnim$Time$inMilliseconds(one) - $author$project$InternalAnim$Time$inMilliseconds(two))) : $author$project$InternalAnim$Duration$milliseconds(
		$elm$core$Basics$max$(
			0,
			$author$project$InternalAnim$Time$inMilliseconds(two) - $author$project$InternalAnim$Time$inMilliseconds(one)));
};
var $author$project$InternalAnim$Time$duration = F2($author$project$InternalAnim$Time$duration$);
var $author$project$InternalAnim$Duration$inSeconds = function (_v0) {
	var seconds = _v0;
	return seconds;
};
var $author$project$InternalAnim$Move$scaleXYBy$ = function (_v0, point) {
	var y = _v0.y;
	var x = _v0.x;
	return {x: point.x * x, y: point.y * y};
};
var $author$project$InternalAnim$Move$scaleXYBy = F2($author$project$InternalAnim$Move$scaleXYBy$);
var $author$project$InternalAnim$Move$toReal$ = function (start, end, t) {
	return start + (t * (end - start));
};
var $author$project$InternalAnim$Move$toReal = F3($author$project$InternalAnim$Move$toReal$);
var $author$project$InternalAnim$Move$denormalize$ = function (startTime, targetTime, startPosition, targetPosition, state) {
	return {
		position: $author$project$InternalAnim$Units$pixels(
			$author$project$InternalAnim$Move$toReal$(startPosition, targetPosition, state.position.y)),
		velocity: function () {
			var scaled = $author$project$InternalAnim$Move$scaleXYBy$(
				{
					x: $author$project$InternalAnim$Duration$inSeconds(
						$author$project$InternalAnim$Time$duration$(startTime, targetTime)),
					y: targetPosition - startPosition
				},
				state.velocity);
			return (!scaled.x) ? $author$project$InternalAnim$Units$pixelsPerSecond(0) : $author$project$InternalAnim$Units$pixelsPerSecond(scaled.y / scaled.x);
		}()
	};
};
var $author$project$InternalAnim$Move$denormalize = F5($author$project$InternalAnim$Move$denormalize$);
var $author$project$InternalAnim$Units$inPixels = function (_v0) {
	var pixs = _v0;
	return pixs;
};
var $author$project$InternalAnim$Move$at$ = function (progress, startTime, targetTime, _v0, startingState) {
	var transition = _v0.a;
	var targetPosition = _v0.b;
	var dwell = _v0.c;
	var startPosition = $author$project$InternalAnim$Units$inPixels(startingState.position);
	return $author$project$InternalAnim$Move$denormalize$(
		startTime,
		targetTime,
		startPosition,
		targetPosition,
		$author$project$InternalAnim$Transition$atX$(progress, transition));
};
var $author$project$InternalAnim$Move$at = F5($author$project$InternalAnim$Move$at$);
var $author$project$InternalAnim$Css$colorOrDefault$ = function (targetName, _default, props) {
	colorOrDefault:
	while (true) {
		if (!props.b) {
			return _default;
		} else {
			if (!props.a.$) {
				var _v1 = props.a;
				var remain = props.b;
				var $temp$props = remain;
				props = $temp$props;
				continue colorOrDefault;
			} else {
				var _v2 = props.a;
				var name = _v2.a;
				var _v3 = _v2.b;
				var clr = _v3.b;
				var remain = props.b;
				if (_Utils_eq(targetName, name)) {
					return clr;
				} else {
					var $temp$props = remain;
					props = $temp$props;
					continue colorOrDefault;
				}
			}
		}
	}
};
var $author$project$InternalAnim$Css$colorOrDefault = F3($author$project$InternalAnim$Css$colorOrDefault$);
var $author$project$InternalAnim$Time$equal$ = function (_v0, _v1) {
	var _this = _v0;
	var that = _v1;
	return !(_this - that);
};
var $author$project$InternalAnim$Time$equal = F2($author$project$InternalAnim$Time$equal$);
var $author$project$InternalAnim$Css$firstNonZero = function (list) {
	firstNonZero:
	while (true) {
		if (!list.b) {
			return 0;
		} else {
			var top = list.a;
			var remain = list.b;
			if (!(!top)) {
				return top;
			} else {
				var $temp$list = remain;
				list = $temp$list;
				continue firstNonZero;
			}
		}
	}
};
var $mdgriffith$elm_bezier$Bezier$controlOne = function (_v0) {
	var c = _v0.b;
	return c;
};
var $mdgriffith$elm_bezier$Bezier$controlTwo = function (_v0) {
	var c = _v0.c;
	return c;
};
var $mdgriffith$elm_bezier$Bezier$first = function (_v0) {
	var f = _v0.a;
	return f;
};
var $mdgriffith$elm_bezier$Bezier$last = function (_v0) {
	var l = _v0.d;
	return l;
};
var $author$project$InternalAnim$Transition$toBezierPoints = function (spline) {
	return {
		four: $mdgriffith$elm_bezier$Bezier$last(spline),
		one: $mdgriffith$elm_bezier$Bezier$first(spline),
		three: $mdgriffith$elm_bezier$Bezier$controlTwo(spline),
		two: $mdgriffith$elm_bezier$Bezier$controlOne(spline)
	};
};
var $author$project$InternalAnim$Transition$isStandard = function (trans) {
	if (!trans.$) {
		var spline = trans.a;
		var _v1 = $author$project$InternalAnim$Transition$toBezierPoints(spline);
		var four = _v1.four;
		var three = _v1.three;
		var two = _v1.two;
		var one = _v1.one;
		return _Utils_eq(
			one,
			{x: 0, y: 0}) && (_Utils_eq(
			two,
			{x: 0.4, y: 0}) && (_Utils_eq(
			three,
			{x: 0.2, y: 1}) && _Utils_eq(
			four,
			{x: 1, y: 1})));
	} else {
		return false;
	}
};
var $author$project$InternalAnim$Css$getCommonTransformTransition$ = function (props, currentTrans) {
	getCommonTransformTransition:
	while (true) {
		if (!props.b) {
			return currentTrans;
		} else {
			if (!props.a.$) {
				var _v1 = props.a;
				var _v2 = _v1.c;
				var trans = _v2.a;
				var remain = props.b;
				if ($author$project$InternalAnim$Transition$isStandard(trans)) {
					var $temp$props = remain;
					props = $temp$props;
					continue getCommonTransformTransition;
				} else {
					var $temp$props = remain,
						$temp$currentTrans = trans;
					props = $temp$props;
					currentTrans = $temp$currentTrans;
					continue getCommonTransformTransition;
				}
			} else {
				var _v3 = props.a;
				var _v4 = _v3.b;
				var trans = _v4.a;
				var remain = props.b;
				var $temp$props = remain,
					$temp$currentTrans = trans;
				props = $temp$props;
				currentTrans = $temp$currentTrans;
				continue getCommonTransformTransition;
			}
		}
	}
};
var $author$project$InternalAnim$Css$getCommonTransformTransition = F2($author$project$InternalAnim$Css$getCommonTransformTransition$);
var $author$project$InternalAnim$Css$Props$defaultPosition = function (id) {
	switch (id) {
		case 13:
			return 1;
		case 3:
			return 0;
		case 4:
			return 1;
		case 5:
			return 1;
		case 6:
			return 1;
		case 7:
			return 1;
		default:
			return 0;
	}
};
var $author$project$InternalAnim$Css$getAt$ = function (i, list) {
	getAt:
	while (true) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var top = list.a;
			var remain = list.b;
			if (!i) {
				return $elm$core$Maybe$Just(top);
			} else {
				var $temp$i = i - 1,
					$temp$list = remain;
				i = $temp$i;
				list = $temp$list;
				continue getAt;
			}
		}
	}
};
var $author$project$InternalAnim$Css$getAt = F2($author$project$InternalAnim$Css$getAt$);
var $author$project$InternalAnim$Css$getTransformSequenceValueAt$ = function (seqLevel, stepLevel, maybeDefaultId, targetId, props, defaultValue) {
	getTransformSequenceValueAt:
	while (true) {
		if (!props.b) {
			if (defaultValue.$ === 1) {
				return $author$project$InternalAnim$Css$Props$defaultPosition(targetId);
			} else {
				var _default = defaultValue.a;
				return _default;
			}
		} else {
			if (!props.a.$) {
				var _v2 = props.a;
				var id = _v2.a;
				var move = _v2.c;
				var remain = props.b;
				if (!(id - targetId)) {
					var v = move.b;
					var seq = move.c;
					var _v4 = $author$project$InternalAnim$Css$getAt$(seqLevel, seq);
					if (_v4.$ === 1) {
						return v;
					} else {
						var _v5 = _v4.a;
						var seqSteps = _v5.d;
						var _v6 = $author$project$InternalAnim$Css$getAt$(stepLevel, seqSteps);
						if (_v6.$ === 1) {
							return v;
						} else {
							var _v7 = _v6.a;
							var stepValue = _v7.c;
							return stepValue;
						}
					}
				} else {
					if (maybeDefaultId.$ === 1) {
						var $temp$props = remain;
						props = $temp$props;
						continue getTransformSequenceValueAt;
					} else {
						var defaultId = maybeDefaultId.a;
						if (!(id - defaultId)) {
							var newDefaultValue = function () {
								var v = move.b;
								var seq = move.c;
								var _v10 = $author$project$InternalAnim$Css$getAt$(seqLevel, seq);
								if (_v10.$ === 1) {
									return v;
								} else {
									var _v11 = _v10.a;
									var seqSteps = _v11.d;
									var _v12 = $author$project$InternalAnim$Css$getAt$(stepLevel, seqSteps);
									if (_v12.$ === 1) {
										return v;
									} else {
										var _v13 = _v12.a;
										var stepValue = _v13.c;
										return stepValue;
									}
								}
							}();
							var $temp$maybeDefaultId = $elm$core$Maybe$Nothing,
								$temp$props = remain,
								$temp$defaultValue = $elm$core$Maybe$Just(newDefaultValue);
							maybeDefaultId = $temp$maybeDefaultId;
							props = $temp$props;
							defaultValue = $temp$defaultValue;
							continue getTransformSequenceValueAt;
						} else {
							var $temp$props = remain;
							props = $temp$props;
							continue getTransformSequenceValueAt;
						}
					}
				}
			} else {
				var _v14 = props.a;
				var remain = props.b;
				var $temp$props = remain;
				props = $temp$props;
				continue getTransformSequenceValueAt;
			}
		}
	}
};
var $author$project$InternalAnim$Css$getTransformSequenceValueAt = F6($author$project$InternalAnim$Css$getTransformSequenceValueAt$);
var $author$project$InternalAnim$Css$Props$groupToCompoundId = function (groupId) {
	switch (groupId) {
		case 10:
			return $elm$core$Maybe$Nothing;
		case 20:
			return $elm$core$Maybe$Just(4);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$InternalAnim$Css$Props$vectorSlotToId$ = function (id, slot) {
	switch (id) {
		case 10:
			switch (slot) {
				case 0:
					return 0;
				case 1:
					return 1;
				default:
					return 2;
			}
		case 20:
			switch (slot) {
				case 0:
					return 5;
				case 1:
					return 6;
				default:
					return 7;
			}
		default:
			return 0;
	}
};
var $author$project$InternalAnim$Css$Props$vectorSlotToId = F2($author$project$InternalAnim$Css$Props$vectorSlotToId$);
var $author$project$InternalAnim$Css$getVectorStepAt$ = function (groupId, dur, trans, seqLevel, stepLevel, props) {
	var z = $author$project$InternalAnim$Css$Props$vectorSlotToId$(groupId, 2);
	var y = $author$project$InternalAnim$Css$Props$vectorSlotToId$(groupId, 1);
	var x = $author$project$InternalAnim$Css$Props$vectorSlotToId$(groupId, 0);
	return $author$project$InternalAnim$Move$Step$(
		dur,
		trans,
		{
			x: $author$project$InternalAnim$Css$getTransformSequenceValueAt$(
				seqLevel,
				stepLevel,
				$author$project$InternalAnim$Css$Props$groupToCompoundId(groupId),
				x,
				props,
				$elm$core$Maybe$Nothing),
			y: $author$project$InternalAnim$Css$getTransformSequenceValueAt$(
				seqLevel,
				stepLevel,
				$author$project$InternalAnim$Css$Props$groupToCompoundId(groupId),
				y,
				props,
				$elm$core$Maybe$Nothing),
			z: $author$project$InternalAnim$Css$getTransformSequenceValueAt$(
				seqLevel,
				stepLevel,
				$author$project$InternalAnim$Css$Props$groupToCompoundId(groupId),
				z,
				props,
				$elm$core$Maybe$Nothing)
		});
};
var $author$project$InternalAnim$Css$getVectorStepAt = F6($author$project$InternalAnim$Css$getVectorStepAt$);
var $author$project$InternalAnim$Css$gatherVectorSteps$ = function (groupId, seqLevel, stepLevel, steps, props, transforms) {
	gatherVectorSteps:
	while (true) {
		if (!steps.b) {
			return transforms;
		} else {
			var _v1 = steps.a;
			var dur = _v1.a;
			var trans = _v1.b;
			var remainingSteps = steps.b;
			var $temp$stepLevel = stepLevel + 1,
				$temp$steps = remainingSteps,
				$temp$transforms = A2(
				$elm$core$List$cons,
				$author$project$InternalAnim$Css$getVectorStepAt$(groupId, dur, trans, seqLevel, stepLevel, props),
				transforms);
			stepLevel = $temp$stepLevel;
			steps = $temp$steps;
			transforms = $temp$transforms;
			continue gatherVectorSteps;
		}
	}
};
var $author$project$InternalAnim$Css$gatherVectorSteps = F6($author$project$InternalAnim$Css$gatherVectorSteps$);
var $author$project$InternalAnim$Css$vectorSeq$ = function (groupId, props, pilotSequence, seqLevel, renderedSeq) {
	vectorSeq:
	while (true) {
		if (!pilotSequence.b) {
			return renderedSeq;
		} else {
			var _v1 = pilotSequence.a;
			var n = _v1.a;
			var delay = _v1.b;
			var dur = _v1.c;
			var steps = _v1.d;
			var remain = pilotSequence.b;
			var $temp$pilotSequence = remain,
				$temp$seqLevel = seqLevel + 1,
				$temp$renderedSeq = A2(
				$elm$core$List$cons,
				$author$project$InternalAnim$Move$Sequence$(
					n,
					delay,
					dur,
					$author$project$InternalAnim$Css$gatherVectorSteps$(groupId, seqLevel, 0, steps, props, _List_Nil)),
				renderedSeq);
			pilotSequence = $temp$pilotSequence;
			seqLevel = $temp$seqLevel;
			renderedSeq = $temp$renderedSeq;
			continue vectorSeq;
		}
	}
};
var $author$project$InternalAnim$Css$vectorSeq = F5($author$project$InternalAnim$Css$vectorSeq$);
var $author$project$InternalAnim$Css$getCommonVectorSequence$ = function (groupId, props, sequences) {
	if (props.b && (!props.a.$)) {
		var _v1 = props.a;
		var _v2 = _v1.c;
		var propSeq = _v2.c;
		return $author$project$InternalAnim$Css$vectorSeq$(groupId, props, propSeq, 0, _List_Nil);
	} else {
		return sequences;
	}
};
var $author$project$InternalAnim$Css$getCommonVectorSequence = F3($author$project$InternalAnim$Css$getCommonVectorSequence$);
var $author$project$InternalAnim$Css$valueOrDefault$ = function (maybeDefaultid, targetId, props, defaultVal) {
	valueOrDefault:
	while (true) {
		if (!props.b) {
			if (defaultVal.$ === 1) {
				return $author$project$InternalAnim$Css$Props$defaultPosition(targetId);
			} else {
				var val = defaultVal.a;
				return val;
			}
		} else {
			if (!props.a.$) {
				var _v2 = props.a;
				var id = _v2.a;
				var move = _v2.c;
				var remain = props.b;
				if (!(id - targetId)) {
					var v = move.b;
					return v;
				} else {
					if (maybeDefaultid.$ === 1) {
						var $temp$props = remain;
						props = $temp$props;
						continue valueOrDefault;
					} else {
						var defaultId = maybeDefaultid.a;
						if (!(id - defaultId)) {
							var v = move.b;
							var $temp$maybeDefaultid = $elm$core$Maybe$Nothing,
								$temp$props = remain,
								$temp$defaultVal = $elm$core$Maybe$Just(v);
							maybeDefaultid = $temp$maybeDefaultid;
							props = $temp$props;
							defaultVal = $temp$defaultVal;
							continue valueOrDefault;
						} else {
							var $temp$props = remain;
							props = $temp$props;
							continue valueOrDefault;
						}
					}
				}
			} else {
				var _v6 = props.a;
				var remain = props.b;
				var $temp$props = remain;
				props = $temp$props;
				continue valueOrDefault;
			}
		}
	}
};
var $author$project$InternalAnim$Css$valueOrDefault = F4($author$project$InternalAnim$Css$valueOrDefault$);
var $author$project$InternalAnim$Css$getVectorSlot$ = function (groupId, slot, props) {
	return $author$project$InternalAnim$Css$valueOrDefault$(
		$author$project$InternalAnim$Css$Props$groupToCompoundId(groupId),
		$author$project$InternalAnim$Css$Props$vectorSlotToId$(groupId, slot),
		props,
		$elm$core$Maybe$Nothing);
};
var $author$project$InternalAnim$Css$getVectorSlot = F3($author$project$InternalAnim$Css$getVectorSlot$);
var $author$project$InternalAnim$Css$Props$isGroup$ = function (groupId, id) {
	switch (groupId) {
		case 10:
			switch (id) {
				case 0:
					return true;
				case 1:
					return true;
				case 3:
					return true;
				default:
					return false;
			}
		case 20:
			switch (id) {
				case 4:
					return true;
				case 5:
					return true;
				case 6:
					return true;
				case 7:
					return true;
				default:
					return false;
			}
		default:
			return false;
	}
};
var $author$project$InternalAnim$Css$Props$isGroup = F2($author$project$InternalAnim$Css$Props$isGroup$);
var $author$project$InternalAnim$Css$isGroupProp$ = function (groupId, prop) {
	if (!prop.$) {
		var id = prop.a;
		return $author$project$InternalAnim$Css$Props$isGroup$(groupId, id);
	} else {
		return false;
	}
};
var $author$project$InternalAnim$Css$isGroupProp = F2($author$project$InternalAnim$Css$isGroupProp$);
var $author$project$InternalAnim$Move$average$ = function (x, y, progress) {
	return $elm$core$Basics$sqrt(((x * x) * (1 - progress)) + ((y * y) * progress));
};
var $author$project$InternalAnim$Move$average = F3($author$project$InternalAnim$Move$average$);
var $avh4$elm_color$Color$rgba$ = function (r, g, b, a) {
	return $avh4$elm_color$Color$RgbaSpace$(r, g, b, a);
};
var $avh4$elm_color$Color$rgba = F4($avh4$elm_color$Color$rgba$);
var $author$project$InternalAnim$Move$lerpColor$ = function (progress, from, target) {
	var two = $avh4$elm_color$Color$toRgba(target);
	var one = $avh4$elm_color$Color$toRgba(from);
	return $avh4$elm_color$Color$rgba$(
		$author$project$InternalAnim$Move$average$(one.red, two.red, progress),
		$author$project$InternalAnim$Move$average$(one.green, two.green, progress),
		$author$project$InternalAnim$Move$average$(one.blue, two.blue, progress),
		$author$project$InternalAnim$Move$average$(one.alpha, two.alpha, progress));
};
var $author$project$InternalAnim$Move$lerpColor = F3($author$project$InternalAnim$Move$lerpColor$);
var $author$project$InternalAnim$Transition$linear = $author$project$InternalAnim$Transition$Transition(
	A4(
		$mdgriffith$elm_bezier$Bezier$fromPoints,
		{x: 0, y: 0},
		{x: 0.2, y: 0.2},
		{x: 0.8, y: 0.8},
		{x: 1, y: 1}));
var $author$project$InternalAnim$Move$move = $author$project$InternalAnim$Move$Pos;
var $author$project$InternalAnim$Units$inPixelsPerSecond = function (_v0) {
	var pps = _v0;
	return pps;
};
var $author$project$InternalAnim$Css$normalizeVelocity$ = function (startTime, targetTime, startPosition, targetPosition, velocity) {
	var pixelsPerSecond = $author$project$InternalAnim$Units$inPixelsPerSecond(velocity);
	return (!pixelsPerSecond) ? 0 : ((pixelsPerSecond * $author$project$InternalAnim$Duration$inSeconds(
		$author$project$InternalAnim$Time$duration$(startTime, targetTime))) / (targetPosition - startPosition));
};
var $author$project$InternalAnim$Css$normalizeVelocity = F5($author$project$InternalAnim$Css$normalizeVelocity$);
var $author$project$InternalAnim$Time$progress$ = function (_v0, _v1, _v2) {
	var start = _v0;
	var end = _v1;
	var current = _v2;
	var total = $elm$core$Basics$abs(end - start);
	return (!total) ? 0 : $elm$core$Basics$min$(
		1,
		$elm$core$Basics$max$(0, (current - start) / total));
};
var $author$project$InternalAnim$Time$progress = F3($author$project$InternalAnim$Time$progress$);
var $author$project$InternalAnim$Move$getSequenceDuration = function (_v0) {
	var i = _v0.a;
	var delay = _v0.b;
	var dur = _v0.c;
	var steps = _v0.d;
	return dur;
};
var $author$project$InternalAnim$Quantity$equalWithin$ = function (_v0, _v1, _v2) {
	var tolerance = _v0;
	var x = _v1;
	var y = _v2;
	return _Utils_cmp(
		$elm$core$Basics$abs(x - y),
		tolerance) < 1;
};
var $author$project$InternalAnim$Quantity$equalWithin = F3($author$project$InternalAnim$Quantity$equalWithin$);
var $author$project$InternalAnim$Move$push$ = function (top, stack) {
	var topI = top.a;
	var topDelay = top.b;
	var topDuration = top.c;
	var topSteps = top.d;
	if (!stack.b) {
		return A2($elm$core$List$cons, top, stack);
	} else {
		var _v1 = stack.a;
		var seqI = _v1.a;
		var seqDelay = _v1.b;
		var seqDuration = _v1.c;
		var steps = _v1.d;
		var others = stack.b;
		if ((!(topI - seqI)) && $author$project$InternalAnim$Quantity$equalWithin$(0.1, topDelay, seqDuration)) {
			var transitionDuration = $author$project$InternalAnim$Time$expand$(seqDuration, topDuration);
			return A2(
				$elm$core$List$cons,
				$author$project$InternalAnim$Move$Sequence$(
					seqI,
					seqDelay,
					transitionDuration,
					_Utils_ap(steps, topSteps)),
				others);
		} else {
			return A2($elm$core$List$cons, top, stack);
		}
	}
};
var $author$project$InternalAnim$Move$push = F2($author$project$InternalAnim$Move$push$);
var $author$project$InternalAnim$Move$withSequenceDelay$ = function (delay, _v0) {
	var i = _v0.a;
	var dur = _v0.c;
	var steps = _v0.d;
	return $author$project$InternalAnim$Move$Sequence$(i, delay, dur, steps);
};
var $author$project$InternalAnim$Move$withSequenceDelay = F2($author$project$InternalAnim$Move$withSequenceDelay$);
var $author$project$InternalAnim$Move$addDelayToSequence$ = function (delay, seqs, captured) {
	addDelayToSequence:
	while (true) {
		if (!seqs.b) {
			return $elm$core$List$reverse(captured);
		} else {
			var seq = seqs.a;
			var remain = seqs.b;
			var $temp$delay = $author$project$InternalAnim$Time$expand$(
				delay,
				$author$project$InternalAnim$Move$getSequenceDuration(seq)),
				$temp$seqs = remain,
				$temp$captured = $author$project$InternalAnim$Move$push$(
				$author$project$InternalAnim$Move$withSequenceDelay$(delay, seq),
				captured);
			delay = $temp$delay;
			seqs = $temp$seqs;
			captured = $temp$captured;
			continue addDelayToSequence;
		}
	}
};
var $author$project$InternalAnim$Move$addDelayToSequence = F3($author$project$InternalAnim$Move$addDelayToSequence$);
var $author$project$InternalAnim$Quantity$greaterThanOrEqualTo$ = function (_v0, _v1) {
	var y = _v0;
	var x = _v1;
	return _Utils_cmp(x, y) > -1;
};
var $author$project$InternalAnim$Quantity$greaterThanOrEqualTo = F2($author$project$InternalAnim$Quantity$greaterThanOrEqualTo$);
var $author$project$InternalAnim$Quantity$multiplyBy$ = function (scale, _v0) {
	var value = _v0;
	return scale * value;
};
var $author$project$InternalAnim$Quantity$multiplyBy = F2($author$project$InternalAnim$Quantity$multiplyBy$);
var $author$project$InternalAnim$Move$afterSequence$ = function (durationTillNow, _v0) {
	var n = _v0.a;
	var delay = _v0.b;
	var duration = _v0.c;
	var steps = _v0.d;
	var floatN = n;
	if ($elm$core$Basics$isInfinite(floatN)) {
		return false;
	} else {
		var fullDuration = $author$project$InternalAnim$Quantity$multiplyBy$(floatN, duration);
		return $author$project$InternalAnim$Quantity$greaterThanOrEqualTo$(fullDuration, durationTillNow);
	}
};
var $author$project$InternalAnim$Move$afterSequence = F2($author$project$InternalAnim$Move$afterSequence$);
var $author$project$InternalAnim$Quantity$minus$ = function (_v0, _v1) {
	var y = _v0;
	var x = _v1;
	return x - y;
};
var $author$project$InternalAnim$Quantity$minus = F2($author$project$InternalAnim$Quantity$minus$);
var $author$project$InternalAnim$Move$afterSequenceList$ = function (durationTillNow, seq, remaining) {
	afterSequenceList:
	while (true) {
		if ($author$project$InternalAnim$Move$afterSequence$(durationTillNow, seq)) {
			if (!remaining.b) {
				return true;
			} else {
				var top = remaining.a;
				var n = top.a;
				var duration = top.c;
				var rest = remaining.b;
				var durationOfUnrolledSeq = $author$project$InternalAnim$Quantity$multiplyBy$(n, duration);
				var $temp$durationTillNow = $author$project$InternalAnim$Quantity$minus$(durationOfUnrolledSeq, durationTillNow),
					$temp$seq = top,
					$temp$remaining = rest;
				durationTillNow = $temp$durationTillNow;
				seq = $temp$seq;
				remaining = $temp$remaining;
				continue afterSequenceList;
			}
		} else {
			return false;
		}
	}
};
var $author$project$InternalAnim$Move$afterSequenceList = F3($author$project$InternalAnim$Move$afterSequenceList$);
var $author$project$InternalAnim$Time$thisAfterThat$ = function (_v0, _v1) {
	var _this = _v0;
	var that = _v1;
	return (_this - that) > 0;
};
var $author$project$InternalAnim$Time$thisAfterThat = F2($author$project$InternalAnim$Time$thisAfterThat$);
var $author$project$InternalAnim$Move$after$ = function (startTime, stopTime, now, movement) {
	if (!movement.c.b) {
		return $author$project$InternalAnim$Time$thisAfterThat$(now, stopTime);
	} else {
		var _v1 = movement.c;
		var seq = _v1.a;
		var remaining = _v1.b;
		return $author$project$InternalAnim$Move$afterSequenceList$(
			$author$project$InternalAnim$Time$duration$(startTime, now),
			seq,
			remaining);
	}
};
var $author$project$InternalAnim$Move$after = F4($author$project$InternalAnim$Move$after$);
var $author$project$InternalAnim$Move$append$ = function (first, stack) {
	if (!first.b) {
		return stack;
	} else {
		if (!first.b.b) {
			var top = first.a;
			return $author$project$InternalAnim$Move$push$(top, stack);
		} else {
			return _Utils_ap(first, stack);
		}
	}
};
var $author$project$InternalAnim$Move$append = F2($author$project$InternalAnim$Move$append$);
var $author$project$InternalAnim$Time$isZeroDuration = function (_v0) {
	var dur = _v0;
	return !dur;
};
var $author$project$InternalAnim$Duration$inMilliseconds = function (_v0) {
	var seconds = _v0;
	return seconds * 1000;
};
var $author$project$InternalAnim$Quantity$lessThanOrEqualTo$ = function (_v0, _v1) {
	var y = _v0;
	var x = _v1;
	return _Utils_cmp(x, y) < 1;
};
var $author$project$InternalAnim$Quantity$lessThanOrEqualTo = F2($author$project$InternalAnim$Quantity$lessThanOrEqualTo$);
var $author$project$InternalAnim$Time$progressWithin$ = function (_v0, _v1) {
	var current = _v0;
	var total = _v1;
	return (!total) ? 0 : $elm$core$Basics$min$(
		1,
		$elm$core$Basics$max$(0, current / total));
};
var $author$project$InternalAnim$Time$progressWithin = F2($author$project$InternalAnim$Time$progressWithin$);
var $author$project$InternalAnim$Transition$Wobble = function (a) {
	return {$: 1, a: a};
};
var $mdgriffith$elm_bezier$Bezier$normalize = function (untouched) {
	var c0 = untouched.a;
	var c1 = untouched.b;
	var c2 = untouched.c;
	var c3 = untouched.d;
	if ((!c0.x) && ((!c0.y) && ((c3.x === 1) && (c3.y === 1)))) {
		return untouched;
	} else {
		var factorY = c3.y - c0.y;
		var factorX = c3.x - c0.x;
		return $mdgriffith$elm_bezier$Bezier$Spline$(
			{x: 0, y: 0},
			{x: (c1.x - c0.x) / factorX, y: (c1.y - c0.y) / factorY},
			{x: (c2.x - c0.x) / factorX, y: (c2.y - c0.y) / factorY},
			{x: 1, y: 1});
	}
};
var $mdgriffith$elm_bezier$Bezier$interpolatePoints$ = function (p1, p2, t) {
	return (t <= 0.5) ? {x: p1.x + (t * (p2.x - p1.x)), y: p1.y + (t * (p2.y - p1.y))} : {x: p2.x + ((1 - t) * (p1.x - p2.x)), y: p2.y + ((1 - t) * (p1.y - p2.y))};
};
var $mdgriffith$elm_bezier$Bezier$interpolatePoints = F3($mdgriffith$elm_bezier$Bezier$interpolatePoints$);
var $mdgriffith$elm_bezier$Bezier$splitAt$ = function (parameterValue, _v0) {
	var p1 = _v0.a;
	var p2 = _v0.b;
	var p3 = _v0.c;
	var p4 = _v0.d;
	var q3 = $mdgriffith$elm_bezier$Bezier$interpolatePoints$(p3, p4, parameterValue);
	var q2 = $mdgriffith$elm_bezier$Bezier$interpolatePoints$(p2, p3, parameterValue);
	var r2 = $mdgriffith$elm_bezier$Bezier$interpolatePoints$(q2, q3, parameterValue);
	var q1 = $mdgriffith$elm_bezier$Bezier$interpolatePoints$(p1, p2, parameterValue);
	var r1 = $mdgriffith$elm_bezier$Bezier$interpolatePoints$(q1, q2, parameterValue);
	var s = $mdgriffith$elm_bezier$Bezier$interpolatePoints$(r1, r2, parameterValue);
	return _Utils_Tuple2(
		$mdgriffith$elm_bezier$Bezier$Spline$(p1, q1, r1, s),
		$mdgriffith$elm_bezier$Bezier$Spline$(s, r2, q3, p4));
};
var $mdgriffith$elm_bezier$Bezier$splitAt = F2($mdgriffith$elm_bezier$Bezier$splitAt$);
var $mdgriffith$elm_bezier$Bezier$splitAtX$ = function (x, spline) {
	var _v0 = $mdgriffith$elm_bezier$Bezier$atX$(x, spline);
	var t = _v0.t;
	return $mdgriffith$elm_bezier$Bezier$splitAt$(t, spline);
};
var $mdgriffith$elm_bezier$Bezier$splitAtX = F2($mdgriffith$elm_bezier$Bezier$splitAtX$);
var $author$project$InternalAnim$Transition$takeAfter$ = function (t, transition) {
	if (!transition.$) {
		var spline = transition.a;
		var _v1 = $mdgriffith$elm_bezier$Bezier$splitAtX$(t, spline);
		var afterT = _v1.b;
		return $author$project$InternalAnim$Transition$Transition(
			$mdgriffith$elm_bezier$Bezier$normalize(afterT));
	} else {
		var wob = transition.a;
		return $author$project$InternalAnim$Transition$Wobble(wob);
	}
};
var $author$project$InternalAnim$Transition$takeAfter = F2($author$project$InternalAnim$Transition$takeAfter$);
var $author$project$InternalAnim$Move$takeStepsAfter$ = function (durationToNow, steps) {
	takeStepsAfter:
	while (true) {
		if (!steps.b) {
			return _List_Nil;
		} else {
			var _v1 = steps.a;
			var duration = _v1.a;
			var transition = _v1.b;
			var value = _v1.c;
			var remain = steps.b;
			if ($author$project$InternalAnim$Quantity$greaterThan$(durationToNow, duration)) {
				var progress = $author$project$InternalAnim$Time$progressWithin$(durationToNow, duration);
				return A2(
					$elm$core$List$cons,
					$author$project$InternalAnim$Move$Step$(
						$author$project$InternalAnim$Quantity$minus$(durationToNow, duration),
						$author$project$InternalAnim$Transition$takeAfter$(progress, transition),
						value),
					remain);
			} else {
				var $temp$durationToNow = $author$project$InternalAnim$Quantity$minus$(duration, durationToNow),
					$temp$steps = remain;
				durationToNow = $temp$durationToNow;
				steps = $temp$steps;
				continue takeStepsAfter;
			}
		}
	}
};
var $author$project$InternalAnim$Move$takeStepsAfter = F2($author$project$InternalAnim$Move$takeStepsAfter$);
var $author$project$InternalAnim$Quantity$zero = 0;
var $author$project$InternalAnim$Move$zeroDuration = $author$project$InternalAnim$Duration$milliseconds(0);
var $author$project$InternalAnim$Move$takeAfter$ = function (durationToNow, seq) {
	var n = seq.a;
	var delay = seq.b;
	var duration = seq.c;
	var steps = seq.d;
	if ($author$project$InternalAnim$Quantity$lessThanOrEqualTo$($author$project$InternalAnim$Move$zeroDuration, durationToNow)) {
		return {base: seq, following: $elm$core$Maybe$Nothing};
	} else {
		if ($author$project$InternalAnim$Quantity$lessThanOrEqualTo$(delay, durationToNow)) {
			return {
				base: $author$project$InternalAnim$Move$Sequence$(
					n,
					$author$project$InternalAnim$Quantity$minus$(durationToNow, delay),
					duration,
					steps),
				following: $elm$core$Maybe$Nothing
			};
		} else {
			var seqDurInMs = $elm$core$Basics$round(
				$author$project$InternalAnim$Duration$inMilliseconds(duration));
			var durationToNowMs = $elm$core$Basics$round(
				$author$project$InternalAnim$Duration$inMilliseconds(durationToNow));
			var newN = (durationToNowMs / seqDurInMs) | 0;
			var durationOfUnrolledSeq = $author$project$InternalAnim$Duration$milliseconds(
				A2($elm$core$Basics$modBy, seqDurInMs, durationToNowMs));
			var remainingDuration = $author$project$InternalAnim$Quantity$minus$(durationOfUnrolledSeq, duration);
			return {
				base: $author$project$InternalAnim$Move$Sequence$(
					1,
					$author$project$InternalAnim$Quantity$zero,
					remainingDuration,
					$author$project$InternalAnim$Move$takeStepsAfter$(durationOfUnrolledSeq, steps)),
				following: ((newN - 1) <= 0) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$InternalAnim$Move$Sequence$(newN - 1, remainingDuration, duration, steps))
			};
		}
	}
};
var $author$project$InternalAnim$Move$takeAfter = F2($author$project$InternalAnim$Move$takeAfter$);
var $author$project$InternalAnim$Move$takeAfterSequenceList$ = function (durationToNow, seqs) {
	takeAfterSequenceList:
	while (true) {
		if (!seqs.b) {
			return _List_Nil;
		} else {
			var top = seqs.a;
			var n = top.a;
			var duration = top.c;
			var remain = seqs.b;
			var floatN = n;
			if ($elm$core$Basics$isInfinite(floatN)) {
				if ($author$project$InternalAnim$Quantity$greaterThan$(durationToNow, duration)) {
					var _new = $author$project$InternalAnim$Move$takeAfter$(durationToNow, top);
					var _v1 = _new.following;
					if (_v1.$ === 1) {
						return A2(
							$elm$core$List$cons,
							_new.base,
							$author$project$InternalAnim$Move$addDelayToSequence$(
								$author$project$InternalAnim$Move$getSequenceDuration(_new.base),
								remain,
								_List_Nil));
					} else {
						var following = _v1.a;
						var delayToFollowing = $author$project$InternalAnim$Move$getSequenceDuration(_new.base);
						return A2(
							$elm$core$List$cons,
							_new.base,
							A2(
								$elm$core$List$cons,
								$author$project$InternalAnim$Move$withSequenceDelay$(delayToFollowing, following),
								$author$project$InternalAnim$Move$addDelayToSequence$(
									$author$project$InternalAnim$Time$expand$(
										$author$project$InternalAnim$Move$getSequenceDuration(following),
										delayToFollowing),
									remain,
									_List_Nil)));
					}
				} else {
					var $temp$durationToNow = $author$project$InternalAnim$Quantity$minus$(duration, durationToNow),
						$temp$seqs = remain;
					durationToNow = $temp$durationToNow;
					seqs = $temp$seqs;
					continue takeAfterSequenceList;
				}
			} else {
				var fullSeqDuration = $author$project$InternalAnim$Quantity$multiplyBy$(floatN, duration);
				if ($author$project$InternalAnim$Quantity$greaterThan$(durationToNow, fullSeqDuration)) {
					var _new = $author$project$InternalAnim$Move$takeAfter$(durationToNow, top);
					var _v2 = _new.following;
					if (_v2.$ === 1) {
						return A2(
							$elm$core$List$cons,
							_new.base,
							$author$project$InternalAnim$Move$addDelayToSequence$(
								$author$project$InternalAnim$Move$getSequenceDuration(_new.base),
								remain,
								_List_Nil));
					} else {
						var following = _v2.a;
						var delayToFollowing = $author$project$InternalAnim$Move$getSequenceDuration(_new.base);
						return A2(
							$elm$core$List$cons,
							_new.base,
							A2(
								$elm$core$List$cons,
								$author$project$InternalAnim$Move$withSequenceDelay$(delayToFollowing, following),
								$author$project$InternalAnim$Move$addDelayToSequence$(
									$author$project$InternalAnim$Time$expand$(
										$author$project$InternalAnim$Move$getSequenceDuration(following),
										delayToFollowing),
									remain,
									_List_Nil)));
					}
				} else {
					var $temp$durationToNow = $author$project$InternalAnim$Quantity$minus$(fullSeqDuration, durationToNow),
						$temp$seqs = remain;
					durationToNow = $temp$durationToNow;
					seqs = $temp$seqs;
					continue takeAfterSequenceList;
				}
			}
		}
	}
};
var $author$project$InternalAnim$Move$takeAfterSequenceList = F2($author$project$InternalAnim$Move$takeAfterSequenceList$);
var $author$project$InternalAnim$Time$thisAfterOrEqualThat$ = function (_v0, _v1) {
	var _this = _v0;
	var that = _v1;
	return (_this - that) >= 0;
};
var $author$project$InternalAnim$Time$thisAfterOrEqualThat = F2($author$project$InternalAnim$Time$thisAfterOrEqualThat$);
var $author$project$InternalAnim$Move$sequences$ = function (startTime, targetTime, now, stopTime, movement, existingSequence) {
	if ($author$project$InternalAnim$Time$equal$(now, stopTime) && (!$author$project$InternalAnim$Time$equal$(targetTime, stopTime))) {
		return _List_Nil;
	} else {
		var durationToNow = $author$project$InternalAnim$Time$duration$(startTime, now);
		if ($author$project$InternalAnim$Time$thisAfterOrEqualThat$(startTime, now)) {
			if (!movement.c.b) {
				var trans = movement.a;
				var value = movement.b;
				var transitionDuration = $author$project$InternalAnim$Time$duration$(startTime, targetTime);
				var seq = $author$project$InternalAnim$Move$Sequence$(
					1,
					durationToNow,
					transitionDuration,
					_List_fromArray(
						[
							$author$project$InternalAnim$Move$Step$(transitionDuration, trans, value)
						]));
				return $author$project$InternalAnim$Move$push$(seq, existingSequence);
			} else {
				if ((movement.c.a.a === 1) && (!movement.c.b.b)) {
					var trans = movement.a;
					var value = movement.b;
					var _v1 = movement.c;
					var _v2 = _v1.a;
					var delay = _v2.b;
					var dur = _v2.c;
					var steps = _v2.d;
					var stepDuration = $author$project$InternalAnim$Time$duration$(startTime, targetTime);
					var transitionDuration = $author$project$InternalAnim$Time$expand$(dur, stepDuration);
					var transitionSequence = $author$project$InternalAnim$Move$Sequence$(
						1,
						$author$project$InternalAnim$Time$expand$(durationToNow, delay),
						transitionDuration,
						A2(
							$elm$core$List$cons,
							$author$project$InternalAnim$Move$Step$(stepDuration, trans, value),
							steps));
					return $author$project$InternalAnim$Move$push$(transitionSequence, existingSequence);
				} else {
					var trans = movement.a;
					var value = movement.b;
					var dwell = movement.c;
					var transitionDuration = $author$project$InternalAnim$Time$duration$(startTime, targetTime);
					if ($author$project$InternalAnim$Time$isZeroDuration(transitionDuration) && (!$elm$core$List$isEmpty(dwell))) {
						return $author$project$InternalAnim$Move$append$(
							$author$project$InternalAnim$Move$addDelayToSequence$(durationToNow, dwell, _List_Nil),
							existingSequence);
					} else {
						var transitionSequence = $author$project$InternalAnim$Move$Sequence$(
							1,
							durationToNow,
							transitionDuration,
							_List_fromArray(
								[
									$author$project$InternalAnim$Move$Step$(transitionDuration, trans, value)
								]));
						return $author$project$InternalAnim$Move$append$(
							$author$project$InternalAnim$Move$addDelayToSequence$(
								$author$project$InternalAnim$Time$expand$(durationToNow, transitionDuration),
								dwell,
								_List_Nil),
							$author$project$InternalAnim$Move$push$(transitionSequence, existingSequence));
					}
				}
			}
		} else {
			if ($author$project$InternalAnim$Move$after$(startTime, stopTime, now, movement)) {
				return _List_Nil;
			} else {
				if (!movement.c.b) {
					var trans = movement.a;
					var value = movement.b;
					var transitionDuration = $author$project$InternalAnim$Time$duration$(startTime, targetTime);
					var newSequence = $author$project$InternalAnim$Move$takeAfter$(
						durationToNow,
						$author$project$InternalAnim$Move$Sequence$(
							1,
							$author$project$InternalAnim$Quantity$zero,
							transitionDuration,
							_List_fromArray(
								[
									$author$project$InternalAnim$Move$Step$(transitionDuration, trans, value)
								])));
					var _v4 = newSequence.following;
					if (_v4.$ === 1) {
						return _List_fromArray(
							[newSequence.base]);
					} else {
						var following = _v4.a;
						return $author$project$InternalAnim$Move$push$(
							$author$project$InternalAnim$Move$withSequenceDelay$(
								$author$project$InternalAnim$Move$getSequenceDuration(newSequence.base),
								following),
							_List_fromArray(
								[newSequence.base]));
					}
				} else {
					if ((movement.c.a.a === 1) && (!movement.c.b.b)) {
						var trans = movement.a;
						var value = movement.b;
						var _v5 = movement.c;
						var _v6 = _v5.a;
						var dur = _v6.c;
						var steps = _v6.d;
						var stepDuration = $author$project$InternalAnim$Time$duration$(startTime, targetTime);
						var transitionDuration = $author$project$InternalAnim$Time$expand$(dur, stepDuration);
						var _new = $author$project$InternalAnim$Move$takeAfter$(
							durationToNow,
							$author$project$InternalAnim$Move$Sequence$(
								1,
								$author$project$InternalAnim$Quantity$zero,
								transitionDuration,
								A2(
									$elm$core$List$cons,
									$author$project$InternalAnim$Move$Step$(stepDuration, trans, value),
									steps)));
						var _v7 = _new.following;
						if (_v7.$ === 1) {
							return _List_fromArray(
								[_new.base]);
						} else {
							var following = _v7.a;
							return $author$project$InternalAnim$Move$push$(
								$author$project$InternalAnim$Move$withSequenceDelay$(
									$author$project$InternalAnim$Move$getSequenceDuration(_new.base),
									following),
								_List_fromArray(
									[_new.base]));
						}
					} else {
						var trans = movement.a;
						var value = movement.b;
						var dwell = movement.c;
						if ($author$project$InternalAnim$Time$thisAfterThat$(now, targetTime)) {
							return $author$project$InternalAnim$Move$takeAfterSequenceList$(durationToNow, dwell);
						} else {
							var transitionDuration = $author$project$InternalAnim$Time$duration$(startTime, targetTime);
							var _new = $author$project$InternalAnim$Move$takeAfter$(
								durationToNow,
								$author$project$InternalAnim$Move$Sequence$(
									1,
									$author$project$InternalAnim$Quantity$zero,
									transitionDuration,
									_List_fromArray(
										[
											$author$project$InternalAnim$Move$Step$(transitionDuration, trans, value)
										])));
							var _v8 = _new.following;
							if (_v8.$ === 1) {
								return A2(
									$elm$core$List$cons,
									_new.base,
									$author$project$InternalAnim$Move$addDelayToSequence$(
										$author$project$InternalAnim$Move$getSequenceDuration(_new.base),
										dwell,
										_List_Nil));
							} else {
								var following = _v8.a;
								var delayToFollowing = $author$project$InternalAnim$Move$getSequenceDuration(_new.base);
								return $author$project$InternalAnim$Move$append$(
									$author$project$InternalAnim$Move$addDelayToSequence$(
										$author$project$InternalAnim$Time$expand$(
											$author$project$InternalAnim$Move$getSequenceDuration(following),
											delayToFollowing),
										dwell,
										_List_Nil),
									$author$project$InternalAnim$Move$push$(
										$author$project$InternalAnim$Move$withSequenceDelay$(delayToFollowing, following),
										_List_fromArray(
											[_new.base])));
							}
						}
					}
				}
			}
		}
	}
};
var $author$project$InternalAnim$Move$sequences = F6($author$project$InternalAnim$Move$sequences$);
var $author$project$InternalAnim$Css$stateOrDefault$ = function (targetId, targetName, props) {
	stateOrDefault:
	while (true) {
		if (!props.b) {
			return $author$project$InternalAnim$Css$Props$default(targetId);
		} else {
			if (!props.a.$) {
				var _v1 = props.a;
				var id = _v1.a;
				var name = _v1.b;
				var move = _v1.c;
				var remain = props.b;
				if (!(targetId - $author$project$InternalAnim$Css$Props$noId)) {
					if (_Utils_eq(name, targetName)) {
						return move;
					} else {
						var $temp$props = remain;
						props = $temp$props;
						continue stateOrDefault;
					}
				} else {
					if (_Utils_eq(id, targetId)) {
						return move;
					} else {
						var $temp$props = remain;
						props = $temp$props;
						continue stateOrDefault;
					}
				}
			} else {
				var _v2 = props.a;
				var remain = props.b;
				var $temp$props = remain;
				props = $temp$props;
				continue stateOrDefault;
			}
		}
	}
};
var $author$project$InternalAnim$Css$stateOrDefault = F3($author$project$InternalAnim$Css$stateOrDefault$);
var $author$project$InternalAnim$Move$toWith$ = function (t, v) {
	return $author$project$InternalAnim$Move$Pos$(t, v, _List_Nil);
};
var $author$project$InternalAnim$Move$toWith = F2($author$project$InternalAnim$Move$toWith$);
var $author$project$InternalAnim$Css$Props$transparent = $avh4$elm_color$Color$rgba$(0, 0, 0, 0);
var $mdgriffith$elm_bezier$Bezier$withVelocities$ = function (intro, exit, full) {
	var one = full.a;
	var two = full.b;
	var three = full.c;
	var four = full.d;
	if ((!intro) && (!exit)) {
		return full;
	} else {
		var ctrl2 = (!exit) ? three : {x: four.x + ((-1) / 3), y: four.y + (((-1) / 3) * exit)};
		var ctrl1 = (!intro) ? two : {x: one.x + (1 / 3), y: one.y + ((1 / 3) * intro)};
		return $mdgriffith$elm_bezier$Bezier$Spline$(one, ctrl1, ctrl2, four);
	}
};
var $mdgriffith$elm_bezier$Bezier$withVelocities = F3($mdgriffith$elm_bezier$Bezier$withVelocities$);
var $author$project$InternalAnim$Transition$withVelocities$ = function (intro, exit, transition) {
	if (!transition.$) {
		var spline = transition.a;
		return $author$project$InternalAnim$Transition$Transition(
			$mdgriffith$elm_bezier$Bezier$withVelocities$(intro, exit, spline));
	} else {
		var wob = transition.a;
		return $author$project$InternalAnim$Transition$Wobble(
			{introVelocity: intro, quickness: wob.quickness, wobble: wob.wobble});
	}
};
var $author$project$InternalAnim$Transition$withVelocities = F3($author$project$InternalAnim$Transition$withVelocities$);
var $author$project$InternalAnim$Move$withVelocities$ = function (intro, exit, untouched) {
	var trans = untouched.a;
	var val = untouched.b;
	var dwell = untouched.c;
	return ((!intro) && (!exit)) ? untouched : $author$project$InternalAnim$Move$Pos$(
		$author$project$InternalAnim$Transition$withVelocities$(intro, exit, trans),
		val,
		dwell);
};
var $author$project$InternalAnim$Move$withVelocities = F3($author$project$InternalAnim$Move$withVelocities$);
var $author$project$InternalAnim$Css$toPropCurves2$ = function (lookup, prev, target, now, startTime, endTime, future, cursor) {
	var targetTime = $author$project$InternalAnim$Timeline$startTime(target);
	var progress = $author$project$InternalAnim$Time$progress$(startTime, targetTime, now);
	var finished = $author$project$InternalAnim$Time$thisAfterThat$(
		now,
		$author$project$InternalAnim$Timeline$endTime(target));
	return $elm$core$List$map$(
		function (prop) {
			switch (prop.$) {
				case 1:
					var details = prop.a;
					var targetColor = $author$project$InternalAnim$Css$colorOrDefault$(
						details.name,
						$author$project$InternalAnim$Css$Props$transparent,
						lookup(
							$author$project$InternalAnim$Timeline$getEvent(target)));
					return $author$project$InternalAnim$Css$RenderedColorProp(
						{
							color: $author$project$InternalAnim$Move$lerpColor$(progress, details.color, targetColor),
							name: details.name,
							sections: finished ? details.sections : $author$project$InternalAnim$Move$sequences$(
								startTime,
								targetTime,
								now,
								endTime,
								$author$project$InternalAnim$Move$toWith$($author$project$InternalAnim$Transition$linear, targetColor),
								details.sections)
						});
				case 0:
					var rendered = prop.a;
					var targetProp = $author$project$InternalAnim$Css$stateOrDefault$(
						rendered.id,
						rendered.name,
						lookup(
							$author$project$InternalAnim$Timeline$getEvent(target)));
					return $author$project$InternalAnim$Css$RenderedProp(
						{
							format: rendered.format,
							id: rendered.id,
							name: rendered.name,
							sections: function () {
								if (finished) {
									return rendered.sections;
								} else {
									var finalProp = function () {
										if (!$author$project$InternalAnim$Time$equal$(
											$author$project$InternalAnim$Timeline$endTime(prev),
											startTime)) {
											var targetPosition = function () {
												var x = targetProp.b;
												return x;
											}();
											var startPosition = $author$project$InternalAnim$Units$inPixels(rendered.state.position);
											return $author$project$InternalAnim$Move$withVelocities$(
												$author$project$InternalAnim$Css$normalizeVelocity$(startTime, targetTime, startPosition, targetPosition, rendered.state.velocity),
												0,
												targetProp);
										} else {
											return targetProp;
										}
									}();
									return $author$project$InternalAnim$Move$sequences$(startTime, targetTime, now, endTime, finalProp, rendered.sections);
								}
							}(),
							state: $author$project$InternalAnim$Move$at$(progress, startTime, targetTime, targetProp, rendered.state)
						});
				default:
					var details = prop.a;
					var targetProps = $elm$core$List$filter$(
						$author$project$InternalAnim$Css$isGroupProp(details.group),
						lookup(
							$author$project$InternalAnim$Timeline$getEvent(target)));
					var targets = {
						x: $author$project$InternalAnim$Css$getVectorSlot$(details.group, 0, targetProps),
						y: $author$project$InternalAnim$Css$getVectorSlot$(details.group, 1, targetProps),
						z: $author$project$InternalAnim$Css$getVectorSlot$(details.group, 2, targetProps)
					};
					var commonTransition = function () {
						if (!$author$project$InternalAnim$Time$equal$(
							$author$project$InternalAnim$Timeline$endTime(prev),
							startTime)) {
							var fastestVelocity = $author$project$InternalAnim$Css$firstNonZero(
								_List_fromArray(
									[
										$author$project$InternalAnim$Css$normalizeVelocity$(
										startTime,
										targetTime,
										$author$project$InternalAnim$Units$inPixels(details.state.x.position),
										targets.x,
										details.state.x.velocity),
										$author$project$InternalAnim$Css$normalizeVelocity$(
										startTime,
										targetTime,
										$author$project$InternalAnim$Units$inPixels(details.state.y.position),
										targets.y,
										details.state.y.velocity),
										$author$project$InternalAnim$Css$normalizeVelocity$(
										startTime,
										targetTime,
										$author$project$InternalAnim$Units$inPixels(details.state.z.position),
										targets.z,
										details.state.z.velocity)
									]));
							return $author$project$InternalAnim$Css$getCommonTransformTransition$(targetProps, $author$project$InternalAnim$Transition$standard);
						} else {
							return $author$project$InternalAnim$Css$getCommonTransformTransition$(targetProps, $author$project$InternalAnim$Transition$standard);
						}
					}();
					return $author$project$InternalAnim$Css$VectorProp(
						{
							format: details.format,
							group: details.group,
							name: details.name,
							sections: function () {
								if (finished) {
									return details.sections;
								} else {
									var commonSequence = $author$project$InternalAnim$Css$getCommonVectorSequence$(details.group, targetProps, _List_Nil);
									var commonMovement = A3($author$project$InternalAnim$Move$move, commonTransition, targets, commonSequence);
									return $author$project$InternalAnim$Move$sequences$(startTime, targetTime, now, endTime, commonMovement, details.sections);
								}
							}(),
							state: {
								x: $author$project$InternalAnim$Move$at$(
									progress,
									startTime,
									targetTime,
									$author$project$InternalAnim$Move$toWith$(commonTransition, targets.x),
									details.state.x),
								y: $author$project$InternalAnim$Move$at$(
									progress,
									startTime,
									targetTime,
									$author$project$InternalAnim$Move$toWith$(commonTransition, targets.y),
									details.state.y),
								z: $author$project$InternalAnim$Move$at$(
									progress,
									startTime,
									targetTime,
									$author$project$InternalAnim$Move$toWith$(commonTransition, targets.z),
									details.state.z)
							}
						});
			}
		},
		cursor);
};
var $author$project$InternalAnim$Css$toPropCurves2 = F8($author$project$InternalAnim$Css$toPropCurves2$);
var $author$project$InternalAnim$Css$propsToRenderedProps$ = function (timeline, lookup) {
	var present = $author$project$InternalAnim$Css$getInitial$(timeline, lookup);
	return $author$project$InternalAnim$Timeline$foldpAll$(
		$author$project$InternalAnim$Timeline$getUpdatedAt(timeline),
		lookup,
		function (_v0) {
			return present;
		},
		$author$project$InternalAnim$Css$toPropCurves2,
		timeline);
};
var $author$project$InternalAnim$Css$propsToRenderedProps = F2($author$project$InternalAnim$Css$propsToRenderedProps$);
var $author$project$Animator$sumStepDuration$ = function (dur, steps) {
	sumStepDuration:
	while (true) {
		if (!steps.b) {
			return dur;
		} else {
			var _v1 = steps.a;
			var stepDur = _v1.a;
			var remain = steps.b;
			var $temp$dur = $author$project$InternalAnim$Time$expand$(stepDur, dur),
				$temp$steps = remain;
			dur = $temp$dur;
			steps = $temp$steps;
			continue sumStepDuration;
		}
	}
};
var $author$project$Animator$sumStepDuration = F2($author$project$Animator$sumStepDuration$);
var $author$project$InternalAnim$Css$emptyAnim = {animation: '', hash: '', keyframes: '', props: _List_Nil, transition: ''};
var $author$project$InternalAnim$Css$Props$ones = ~0;
var $author$project$InternalAnim$Css$Props$top8 = $author$project$InternalAnim$Css$Props$ones >>> (32 - 8);
var $author$project$InternalAnim$Css$Props$encode4$ = function (one, two, three, four) {
	return (($author$project$InternalAnim$Css$Props$top8 & $elm$core$Basics$round(four * 255)) << 24) | ((($author$project$InternalAnim$Css$Props$top8 & $elm$core$Basics$round(three * 255)) << 16) | ((($author$project$InternalAnim$Css$Props$top8 & $elm$core$Basics$round(two * 255)) << 8) | ($author$project$InternalAnim$Css$Props$top8 & $elm$core$Basics$round(one * 255))));
};
var $author$project$InternalAnim$Css$Props$encode4 = F4($author$project$InternalAnim$Css$Props$encode4$);
var $author$project$InternalAnim$Css$Props$colorHash = function (color) {
	var rgba = $avh4$elm_color$Color$toRgba(color);
	return $elm$core$String$fromInt(
		$author$project$InternalAnim$Css$Props$encode4$(rgba.red, rgba.green, rgba.blue, rgba.alpha));
};
var $author$project$InternalAnim$Css$combine$ = function (one, two) {
	return ($elm$core$String$isEmpty(one.hash) && $elm$core$List$isEmpty(one.props)) ? two : (($elm$core$String$isEmpty(two.hash) && $elm$core$List$isEmpty(two.props)) ? one : {
		animation: function () {
			var _v0 = one.animation;
			if (_v0 === '') {
				return two.animation;
			} else {
				var _v1 = two.animation;
				if (_v1 === '') {
					return two.animation;
				} else {
					return two.animation + (', ' + one.animation);
				}
			}
		}(),
		hash: _Utils_ap(one.hash, two.hash),
		keyframes: function () {
			var _v2 = one.keyframes;
			if (_v2 === '') {
				return two.keyframes;
			} else {
				var _v3 = two.keyframes;
				if (_v3 === '') {
					return two.keyframes;
				} else {
					return two.keyframes + ('\u000A' + one.keyframes);
				}
			}
		}(),
		props: _Utils_ap(one.props, two.props),
		transition: function () {
			var _v4 = one.transition;
			if (_v4 === '') {
				return two.transition;
			} else {
				var _v5 = two.transition;
				if (_v5 === '') {
					return two.transition;
				} else {
					return two.transition + (', ' + one.transition);
				}
			}
		}()
	});
};
var $author$project$InternalAnim$Css$combine = F2($author$project$InternalAnim$Css$combine$);
var $author$project$InternalAnim$Move$hashDuration$ = function (prefix, dur) {
	var seconds = $author$project$InternalAnim$Duration$inSeconds(dur);
	return (!seconds) ? '' : _Utils_ap(
		prefix,
		$elm$core$String$fromInt(
			$elm$core$Basics$round(
				$author$project$InternalAnim$Duration$inSeconds(dur))));
};
var $author$project$InternalAnim$Move$hashDuration = F2($author$project$InternalAnim$Move$hashDuration$);
var $author$project$InternalAnim$Bits$Bits = $elm$core$Basics$identity;
var $author$project$InternalAnim$Bits$zeroes = 0 | 0;
var $author$project$InternalAnim$Bits$ones = ~$author$project$InternalAnim$Bits$zeroes;
var $author$project$InternalAnim$Bits$top8 = $author$project$InternalAnim$Bits$ones >>> (32 - 8);
var $author$project$InternalAnim$Bits$store4Float$ = function (one, two, three, four) {
	return (($author$project$InternalAnim$Bits$top8 & $elm$core$Basics$round(four)) << 24) | ((($author$project$InternalAnim$Bits$top8 & $elm$core$Basics$round(three)) << 16) | ((($author$project$InternalAnim$Bits$top8 & $elm$core$Basics$round(two)) << 8) | ($author$project$InternalAnim$Bits$top8 & $elm$core$Basics$round(one))));
};
var $author$project$InternalAnim$Bits$store4Float = F4($author$project$InternalAnim$Bits$store4Float$);
var $author$project$InternalAnim$Bits$value = function (_v0) {
	var val = _v0;
	return val;
};
var $author$project$InternalAnim$Hash$bezierNormalized = function (spline) {
	var two = $mdgriffith$elm_bezier$Bezier$controlOne(spline);
	var three = $mdgriffith$elm_bezier$Bezier$controlTwo(spline);
	return 'b' + $elm$core$String$fromInt(
		$author$project$InternalAnim$Bits$value(
			$author$project$InternalAnim$Bits$store4Float$(two.x, two.y, three.x, three.y)));
};
var $author$project$InternalAnim$Hash$float = function (f) {
	return $elm$core$String$fromInt(
		$elm$core$Basics$round(f * 100));
};
var $author$project$InternalAnim$Transition$hash = function (transition) {
	if (!transition.$) {
		var spline = transition.a;
		return $author$project$InternalAnim$Hash$bezierNormalized(spline);
	} else {
		var f = transition.a;
		return 'wob' + $author$project$InternalAnim$Hash$float(f.wobble);
	}
};
var $author$project$InternalAnim$Move$stepHash$ = function (steps, toString, hashed) {
	stepHash:
	while (true) {
		if (!steps.b) {
			return hashed;
		} else {
			var _v1 = steps.a;
			var dur = _v1.a;
			var trans = _v1.b;
			var v = _v1.c;
			var remain = steps.b;
			var $temp$steps = remain,
				$temp$hashed = hashed + ($author$project$InternalAnim$Move$hashDuration$('d', dur) + ($author$project$InternalAnim$Transition$hash(trans) + ('-' + toString(v))));
			steps = $temp$steps;
			hashed = $temp$hashed;
			continue stepHash;
		}
	}
};
var $author$project$InternalAnim$Move$stepHash = F3($author$project$InternalAnim$Move$stepHash$);
var $author$project$InternalAnim$Move$hash$ = function (now, name, _v0, toString) {
	var n = _v0.a;
	var delay = _v0.b;
	var dur = _v0.c;
	var steps = _v0.d;
	return _Utils_ap(
		name,
		_Utils_ap(
			$elm$core$String$fromInt(
				$elm$core$Basics$round(
					$author$project$InternalAnim$Time$inMilliseconds(now))),
			_Utils_ap(
				(n === 1) ? '' : ('n' + $elm$core$String$fromInt(n)),
				_Utils_ap(
					$author$project$InternalAnim$Move$hashDuration$('dl', delay),
					_Utils_ap(
						$author$project$InternalAnim$Move$hashDuration$('d', dur),
						$author$project$InternalAnim$Move$stepHash$(steps, toString, ''))))));
};
var $author$project$InternalAnim$Move$hash = F4($author$project$InternalAnim$Move$hash$);
var $author$project$InternalAnim$Time$durationToString = function (dur) {
	return function (s) {
		return s + 'ms';
	}(
		$elm$core$String$fromInt(
			$elm$core$Basics$round(
				$author$project$InternalAnim$Duration$inMilliseconds(dur))));
};
var $mdgriffith$elm_bezier$Bezier$comma = ',';
var $mdgriffith$elm_bezier$Bezier$roundFloat = function (f) {
	return $elm$core$Basics$round(f * 100) / 100;
};
var $mdgriffith$elm_bezier$Bezier$toCss = function (spline) {
	var _v0 = $mdgriffith$elm_bezier$Bezier$normalize(spline);
	var c0 = _v0.a;
	var c1 = _v0.b;
	var c2 = _v0.c;
	var c3 = _v0.d;
	return 'cubic-bezier(' + (_Utils_ap(
		$elm$core$String$fromFloat(
			$mdgriffith$elm_bezier$Bezier$roundFloat(c1.x)),
		$mdgriffith$elm_bezier$Bezier$comma) + (_Utils_ap(
		$elm$core$String$fromFloat(
			$mdgriffith$elm_bezier$Bezier$roundFloat(c1.y)),
		$mdgriffith$elm_bezier$Bezier$comma) + (_Utils_ap(
		$elm$core$String$fromFloat(
			$mdgriffith$elm_bezier$Bezier$roundFloat(c2.x)),
		$mdgriffith$elm_bezier$Bezier$comma) + ($elm$core$String$fromFloat(
		$mdgriffith$elm_bezier$Bezier$roundFloat(c2.y)) + ')'))));
};
var $author$project$InternalAnim$Move$renderTransition$ = function (prop, delay, duration, spline) {
	return prop + (' ' + ($author$project$InternalAnim$Time$durationToString(duration) + (' ' + ($mdgriffith$elm_bezier$Bezier$toCss(spline) + (' ' + $author$project$InternalAnim$Time$durationToString(delay))))));
};
var $author$project$InternalAnim$Move$renderTransition = F4($author$project$InternalAnim$Move$renderTransition$);
var $author$project$InternalAnim$Move$combine$ = function (one, two) {
	return ($elm$core$String$isEmpty(one.hash) && $elm$core$List$isEmpty(one.props)) ? two : (($elm$core$String$isEmpty(two.hash) && $elm$core$List$isEmpty(two.props)) ? one : {
		animation: function () {
			var _v0 = one.animation;
			if (_v0 === '') {
				return two.animation;
			} else {
				var _v1 = two.animation;
				if (_v1 === '') {
					return two.animation;
				} else {
					return two.animation + (', ' + one.animation);
				}
			}
		}(),
		hash: _Utils_ap(one.hash, two.hash),
		keyframes: function () {
			var _v2 = one.keyframes;
			if (_v2 === '') {
				return two.keyframes;
			} else {
				var _v3 = two.keyframes;
				if (_v3 === '') {
					return two.keyframes;
				} else {
					return two.keyframes + ('\u000A' + one.keyframes);
				}
			}
		}(),
		props: _Utils_ap(one.props, two.props),
		transition: function () {
			var _v4 = one.transition;
			if (_v4 === '') {
				return two.transition;
			} else {
				var _v5 = two.transition;
				if (_v5 === '') {
					return two.transition;
				} else {
					return two.transition + (', ' + one.transition);
				}
			}
		}()
	});
};
var $author$project$InternalAnim$Move$combine = F2($author$project$InternalAnim$Move$combine$);
var $author$project$InternalAnim$Duration$isZero = function (_v0) {
	var seconds = _v0;
	return !seconds;
};
var $author$project$InternalAnim$Move$initialProps$ = function (name, toString, startPos, _v0) {
	var steps = _v0.d;
	if (!steps.b) {
		return _List_Nil;
	} else {
		var _v2 = steps.a;
		var dur = _v2.a;
		var val = _v2.c;
		return $author$project$InternalAnim$Duration$isZero(dur) ? _List_fromArray(
			[
				_Utils_Tuple2(
				name,
				toString(val))
			]) : _List_Nil;
	}
};
var $author$project$InternalAnim$Move$initialProps = F4($author$project$InternalAnim$Move$initialProps$);
var $author$project$InternalAnim$Transition$keyframeFromSpline$ = function (percent, start, toString, spline) {
	return (percent === 100) ? ($elm$core$String$fromInt(
		$elm$core$Basics$floor(percent)) + ('% {' + (toString(start) + ';}'))) : ($elm$core$String$fromInt(
		$elm$core$Basics$floor(percent)) + ('% {' + (toString(start) + (';animation-timing-function:' + ($mdgriffith$elm_bezier$Bezier$toCss(spline) + ';}')))));
};
var $author$project$InternalAnim$Transition$keyframeFromSpline = F4($author$project$InternalAnim$Transition$keyframeFromSpline$);
var $author$project$InternalAnim$Transition$keyframeListFromNonNormalizedBezier$ = function (steps, toString, str) {
	keyframeListFromNonNormalizedBezier:
	while (true) {
		if (!steps.b) {
			return str;
		} else {
			if (!steps.b.b) {
				var top = steps.a;
				var value = toString(
					$mdgriffith$elm_bezier$Bezier$first(top).y / 1000);
				var percent = $mdgriffith$elm_bezier$Bezier$first(top).x / 1000;
				var normalizedSpline = $mdgriffith$elm_bezier$Bezier$normalize(top);
				var finalValue = toString(
					$mdgriffith$elm_bezier$Bezier$last(top).y);
				var finalPercent = $mdgriffith$elm_bezier$Bezier$last(top).x / 1000;
				return _Utils_ap(
					str,
					_Utils_ap(
						$author$project$InternalAnim$Transition$keyframeFromSpline$(percent * 100, value, $elm$core$Basics$identity, normalizedSpline),
						$author$project$InternalAnim$Transition$keyframeFromSpline$(finalPercent * 100, finalValue, $elm$core$Basics$identity, normalizedSpline)));
			} else {
				var top = steps.a;
				var remain = steps.b;
				var value = toString(
					$mdgriffith$elm_bezier$Bezier$first(top).y / 1000);
				var percent = $mdgriffith$elm_bezier$Bezier$first(top).x / 1000;
				var normalizedSpline = $mdgriffith$elm_bezier$Bezier$normalize(top);
				var $temp$steps = remain,
					$temp$str = _Utils_ap(
					str,
					$author$project$InternalAnim$Transition$keyframeFromSpline$(percent * 100, value, $elm$core$Basics$identity, normalizedSpline));
				steps = $temp$steps;
				str = $temp$str;
				continue keyframeListFromNonNormalizedBezier;
			}
		}
	}
};
var $author$project$InternalAnim$Transition$keyframeListFromNonNormalizedBezier = F3($author$project$InternalAnim$Transition$keyframeListFromNonNormalizedBezier$);
var $author$project$InternalAnim$Transition$kf$ = function (percent, prop, spline) {
	return (percent === 100) ? ($elm$core$String$fromInt(
		$elm$core$Basics$floor(percent)) + ('% {' + (prop + ';}'))) : ($elm$core$String$fromInt(
		$elm$core$Basics$floor(percent)) + ('% {' + (prop + (';animation-timing-function:' + ($mdgriffith$elm_bezier$Bezier$toCss(spline) + ';}')))));
};
var $author$project$InternalAnim$Transition$kf = F3($author$project$InternalAnim$Transition$kf$);
var $mdgriffith$elm_bezier$Bezier$Point$ = function (x, y) {
	return {x: x, y: y};
};
var $mdgriffith$elm_bezier$Bezier$Point = F2($mdgriffith$elm_bezier$Bezier$Point$);
var $elm$core$Basics$atan = _Basics_atan;
var $mdgriffith$elm_bezier$Bezier$Spring$isCriticallyDamped = function (_v0) {
	var mass = _v0.mass;
	var damping = _v0.damping;
	var stiffness = _v0.stiffness;
	var cCritical = $mdgriffith$elm_bezier$Bezier$Spring$criticalDamping$(stiffness, mass);
	return _Utils_eq(
		$elm$core$Basics$round(damping),
		$elm$core$Basics$round(cCritical));
};
var $mdgriffith$elm_bezier$Bezier$Spring$magicNumberHelper$ = function (options, i, captured) {
	magicNumberHelper:
	while (true) {
		var newNum = (options.t(i) * 1000) / options.magicNumber;
		if ((_Utils_cmp(newNum, options.target) > -1) || (i > 8)) {
			return $elm$core$List$reverse(
				A2($elm$core$List$cons, newNum, captured));
		} else {
			var $temp$i = i + 1,
				$temp$captured = A2($elm$core$List$cons, newNum, captured);
			i = $temp$i;
			captured = $temp$captured;
			continue magicNumberHelper;
		}
	}
};
var $mdgriffith$elm_bezier$Bezier$Spring$magicNumberHelper = F3($mdgriffith$elm_bezier$Bezier$Spring$magicNumberHelper$);
var $elm$core$Basics$pi = _Basics_pi;
var $mdgriffith$elm_bezier$Bezier$Spring$peaks$ = function (spring, ms, target, initial) {
	if ($mdgriffith$elm_bezier$Bezier$Spring$isCriticallyDamped(spring)) {
		return _List_fromArray(
			[0, target]);
	} else {
		var magicNumber = $elm$core$Basics$sqrt(spring.stiffness / spring.mass);
		var dampingRatio = spring.damping / (2 * $elm$core$Basics$sqrt(spring.mass * spring.stiffness));
		var inner = $elm$core$Basics$sqrt(
			1 - A2($elm$core$Basics$pow, dampingRatio, 2));
		var c1 = target - initial.position;
		var c2 = dampingRatio * (c1 / inner);
		var top = (dampingRatio * c1) - (c2 * inner);
		var bottom = (dampingRatio * c2) + (c1 * inner);
		var t = function (k) {
			return ((-1) / inner) * ($elm$core$Basics$atan(top / bottom) - (k * $elm$core$Basics$pi));
		};
		return $mdgriffith$elm_bezier$Bezier$Spring$magicNumberHelper$(
			{magicNumber: magicNumber, t: t, target: target},
			0,
			_List_Nil);
	}
};
var $mdgriffith$elm_bezier$Bezier$Spring$peaks = F4($mdgriffith$elm_bezier$Bezier$Spring$peaks$);
var $mdgriffith$elm_bezier$Bezier$fromCatmullRom$ = function (p0, p1, p2, p3) {
	var b3 = p2;
	var b2 = {x: p2.x - ((p3.x - p1.x) / 6), y: p2.y - ((p3.y - p1.y) / 6)};
	var b1 = {x: p1.x + ((p2.x - p0.x) / 6), y: p1.y + ((p2.y - p0.y) / 6)};
	var b0 = p1;
	return $mdgriffith$elm_bezier$Bezier$Spline$(b0, b1, b2, b3);
};
var $mdgriffith$elm_bezier$Bezier$fromCatmullRom = F4($mdgriffith$elm_bezier$Bezier$fromCatmullRom$);
var $mdgriffith$elm_bezier$Bezier$traceHelper$ = function (toPoint, t, stepSize, captured) {
	traceHelper:
	while (true) {
		var smallStepSize = stepSize * 0.8;
		var pastT = (!t) ? 0 : (t - smallStepSize);
		var nextT = t + stepSize;
		var futureT = (t + stepSize) + smallStepSize;
		if (t >= 1) {
			return $elm$core$List$reverse(captured);
		} else {
			var $temp$t = nextT,
				$temp$captured = A2(
				$elm$core$List$cons,
				$mdgriffith$elm_bezier$Bezier$fromCatmullRom$(
					toPoint(pastT),
					toPoint(t),
					toPoint(nextT),
					toPoint(futureT)),
				captured);
			t = $temp$t;
			captured = $temp$captured;
			continue traceHelper;
		}
	}
};
var $mdgriffith$elm_bezier$Bezier$traceHelper = F4($mdgriffith$elm_bezier$Bezier$traceHelper$);
var $mdgriffith$elm_bezier$Bezier$trace = function (options) {
	var stepSize = 1 / options.steps;
	return $mdgriffith$elm_bezier$Bezier$traceHelper$(options.toPoint, 0, stepSize, _List_Nil);
};
var $mdgriffith$elm_bezier$Bezier$Spring$segments$ = function (spring, initialState, targetPos) {
	var pks = $mdgriffith$elm_bezier$Bezier$Spring$peaks$(spring, 0, targetPos, initialState);
	var needsDirectPathing = ($mdgriffith$elm_bezier$Bezier$Spring$criticalDamping$(spring.stiffness, spring.mass) - spring.damping) < 12;
	var crit = $mdgriffith$elm_bezier$Bezier$Spring$criticalDamping$(spring.stiffness, spring.mass);
	if (needsDirectPathing) {
		var onSpring = $mdgriffith$elm_bezier$Bezier$Spring$at(
			{initial: initialState, spring: spring, target: targetPos});
		var toPoint = function (factor) {
			var x = factor * targetPos;
			return {
				x: x,
				y: onSpring(x).position
			};
		};
		return $mdgriffith$elm_bezier$Bezier$trace(
			{steps: 8, toPoint: toPoint});
	} else {
		var toPos = $mdgriffith$elm_bezier$Bezier$Spring$at(
			{initial: initialState, spring: spring, target: targetPos});
		return A3(
			$elm$core$List$map2,
			F2(
				function (one, two) {
					var spread = 0;
					var posTwo = toPos(two);
					var posOne = toPos(one);
					var factor = 0;
					var offsetOne = (two - one) * ((0.33 - factor) - spread);
					var offsetTwo = (two - one) * ((0.55 + factor) - spread);
					var ctrlTwo = $mdgriffith$elm_bezier$Bezier$Point$(two - offsetTwo, posTwo.position);
					var ctrlOne = $mdgriffith$elm_bezier$Bezier$Point$(one + offsetOne, posOne.position);
					var result = A4(
						$mdgriffith$elm_bezier$Bezier$fromPoints,
						$mdgriffith$elm_bezier$Bezier$Point$(one, posOne.position),
						ctrlOne,
						ctrlTwo,
						$mdgriffith$elm_bezier$Bezier$Point$(two, posTwo.position));
					return (_Utils_cmp(two, targetPos) > 0) ? $mdgriffith$elm_bezier$Bezier$splitAtX$(targetPos, result).a : result;
				}),
			pks,
			$elm$core$List$drop$(1, pks));
	}
};
var $mdgriffith$elm_bezier$Bezier$Spring$segments = F3($mdgriffith$elm_bezier$Bezier$Spring$segments$);
var $author$project$InternalAnim$Transition$keyframes$ = function (interpolate, startPercent, endPercent, transition) {
	if (_Utils_eq(startPercent, endPercent)) {
		return '';
	} else {
		if (!transition.$) {
			var spline = transition.a;
			return _Utils_ap(
				$author$project$InternalAnim$Transition$kf$(
					startPercent,
					interpolate(0),
					spline),
				(endPercent === 100) ? $author$project$InternalAnim$Transition$kf$(
					endPercent,
					interpolate(1),
					spline) : '');
		} else {
			var wob = transition.a;
			var splines = $mdgriffith$elm_bezier$Bezier$Spring$segments$(
				$mdgriffith$elm_bezier$Bezier$Spring$new(
					{quickness: wob.quickness, settleMax: 1000, wobble: wob.wobble}),
				{position: 0, velocity: wob.introVelocity},
				1000);
			return $author$project$InternalAnim$Transition$keyframeListFromNonNormalizedBezier$(splines, interpolate, '');
		}
	}
};
var $author$project$InternalAnim$Transition$keyframes = F4($author$project$InternalAnim$Transition$keyframes$);
var $author$project$InternalAnim$Move$keyframeHelper$ = function (name, lerp, startPos, sequenceDuration, currentDur, steps, rendered) {
	keyframeHelper:
	while (true) {
		if (!steps.b) {
			return rendered;
		} else {
			var _v1 = steps.a;
			var dur = _v1.a;
			var transition = _v1.b;
			var val = _v1.c;
			var remaining = steps.b;
			var startPercent = $author$project$InternalAnim$Time$progressWithin$(currentDur, sequenceDuration) * 100;
			var nextCurrent = $author$project$InternalAnim$Time$expand$(currentDur, dur);
			var endPercent = $author$project$InternalAnim$Time$progressWithin$(nextCurrent, sequenceDuration) * 100;
			var frames = $author$project$InternalAnim$Transition$keyframes$(
				function (t) {
					return A3(lerp, t, startPos, val);
				},
				startPercent,
				endPercent,
				transition);
			var $temp$startPos = val,
				$temp$currentDur = nextCurrent,
				$temp$steps = remaining,
				$temp$rendered = _Utils_ap(rendered, frames);
			startPos = $temp$startPos;
			currentDur = $temp$currentDur;
			steps = $temp$steps;
			rendered = $temp$rendered;
			continue keyframeHelper;
		}
	}
};
var $author$project$InternalAnim$Move$keyframeHelper = F7($author$project$InternalAnim$Move$keyframeHelper$);
var $author$project$InternalAnim$Move$keyframes$ = function (name, lerp, startPos, _v0, rendered) {
	var dur = _v0.c;
	var steps = _v0.d;
	return $author$project$InternalAnim$Move$keyframeHelper$(name, lerp, startPos, dur, $author$project$InternalAnim$Move$zeroDuration, steps, rendered);
};
var $author$project$InternalAnim$Move$keyframes = F5($author$project$InternalAnim$Move$keyframes$);
var $author$project$InternalAnim$Move$css$ = function (now, startPos, name, lerp, toString, toHashString, seq) {
	var n = function () {
		var i = seq.a;
		return _Utils_eq(i, -1) ? 'infinite' : ((i <= 0) ? '1' : $elm$core$String$fromInt(i));
	}();
	var durationStr = function () {
		var dur = seq.c;
		return $author$project$InternalAnim$Time$durationToString(dur);
	}();
	var delayStr = function () {
		var delay = seq.b;
		return $author$project$InternalAnim$Time$durationToString(delay);
	}();
	var animationName = $author$project$InternalAnim$Move$hash$(now, name, seq, toHashString);
	return {
		animation: durationStr + (' linear ' + (delayStr + (' ' + (n + (' normal forwards running ' + animationName))))),
		hash: animationName,
		keyframes: ('@keyframes ' + (animationName + ' {\u000A')) + ($author$project$InternalAnim$Move$keyframes$(name, lerp, startPos, seq, '') + '\u000A}'),
		props: $author$project$InternalAnim$Move$initialProps$(name, toString, startPos, seq),
		transition: ''
	};
};
var $author$project$InternalAnim$Move$css = F7($author$project$InternalAnim$Move$css$);
var $author$project$InternalAnim$Move$toCssKeyframes$ = function (now, startPos, name, lerp, toString, toHashString, sections, anim) {
	toCssKeyframes:
	while (true) {
		if (!sections.b) {
			return anim;
		} else {
			var seq = sections.a;
			var remain = sections.b;
			var $temp$sections = remain,
				$temp$anim = $author$project$InternalAnim$Move$combine$(
				$author$project$InternalAnim$Move$css$(now, startPos, name, lerp, toString, toHashString, seq),
				anim);
			sections = $temp$sections;
			anim = $temp$anim;
			continue toCssKeyframes;
		}
	}
};
var $author$project$InternalAnim$Move$toCssKeyframes = F8($author$project$InternalAnim$Move$toCssKeyframes$);
var $author$project$InternalAnim$Move$cssForSections$ = function (now, allowTransitions, startPos, name, lerp, toString, toHashString, sections, anim) {
	if (!sections.b) {
		return anim;
	} else {
		if (((((sections.a.a === 1) && sections.a.d.b) && (!sections.a.d.a.b.$)) && (!sections.a.d.b.b)) && (!sections.b.b)) {
			var seq = sections.a;
			var delay = seq.b;
			var _v1 = seq.d;
			var _v2 = _v1.a;
			var stepDur = _v2.a;
			var spline = _v2.b.a;
			var v = _v2.c;
			if (!allowTransitions) {
				return _Utils_update(
					anim,
					{
						hash: function () {
							var _v4 = anim.hash;
							if (_v4 === '') {
								return $author$project$InternalAnim$Move$hash$(now, name, seq, toHashString);
							} else {
								return _Utils_ap(
									anim.hash,
									$author$project$InternalAnim$Move$hash$(now, name, seq, toHashString));
							}
						}(),
						props: A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								name,
								toString(v)),
							anim.props),
						transition: function () {
							var _v5 = anim.transition;
							if (_v5 === '') {
								return $author$project$InternalAnim$Move$renderTransition$(name, delay, stepDur, spline);
							} else {
								return $author$project$InternalAnim$Move$renderTransition$(name, delay, stepDur, spline) + (', ' + anim.transition);
							}
						}()
					});
			} else {
				return $author$project$InternalAnim$Move$toCssKeyframes$(now, startPos, name, lerp, toString, toHashString, sections, anim);
			}
		} else {
			return $author$project$InternalAnim$Move$toCssKeyframes$(now, startPos, name, lerp, toString, toHashString, sections, anim);
		}
	}
};
var $author$project$InternalAnim$Move$cssForSections = F9($author$project$InternalAnim$Move$cssForSections$);
var $author$project$InternalAnim$Css$Props$roundFloat = function (f) {
	return $elm$core$Basics$round(f * 100) / 100;
};
var $author$project$InternalAnim$Css$Props$floatToString = function (f) {
	return $elm$core$String$fromFloat(
		$author$project$InternalAnim$Css$Props$roundFloat(f));
};
var $author$project$InternalAnim$Css$Props$vectorToCssString = function (_v0) {
	var z = _v0.z;
	var y = _v0.y;
	var x = _v0.x;
	return $author$project$InternalAnim$Css$Props$floatToString(x) + (' ' + ($author$project$InternalAnim$Css$Props$floatToString(y) + (' ' + $author$project$InternalAnim$Css$Props$floatToString(z))));
};
var $author$project$InternalAnim$Css$Props$format$ = function (form, num) {
	switch (form.$) {
		case 0:
			return $elm$core$String$fromFloat(
				$author$project$InternalAnim$Css$Props$roundFloat(num));
		case 1:
			return $elm$core$String$fromInt(
				$elm$core$Basics$round(num));
		case 2:
			return $elm$core$String$fromInt(
				$elm$core$Basics$round(num)) + 'px';
		default:
			var vec = form.a;
			return $author$project$InternalAnim$Css$Props$vectorToCssString(vec) + (' ' + ($elm$core$String$fromFloat(num / 1000) + 'turn'));
	}
};
var $author$project$InternalAnim$Css$Props$format = F2($author$project$InternalAnim$Css$Props$format$);
var $author$project$InternalAnim$Css$Props$hashFormat$ = function (form, num) {
	switch (form.$) {
		case 0:
			return $author$project$InternalAnim$Hash$float(num);
		case 1:
			return $elm$core$String$fromInt(
				$elm$core$Basics$round(num));
		case 2:
			return $elm$core$String$fromInt(
				$elm$core$Basics$round(num)) + 'px';
		default:
			return $elm$core$String$fromInt(
				$elm$core$Basics$round(num));
	}
};
var $author$project$InternalAnim$Css$Props$hashFormat = F2($author$project$InternalAnim$Css$Props$hashFormat$);
var $author$project$InternalAnim$Css$Props$hashId = function (id) {
	switch (id) {
		case 0:
			return 'x';
		case 1:
			return 'y';
		case 2:
			return 'z';
		case 3:
			return 'r';
		case 4:
			return 's';
		case 5:
			return 'sx';
		case 6:
			return 'sy';
		case 13:
			return 'o';
		case 14:
			return 'bgc';
		default:
			return 'unknown';
	}
};
var $author$project$InternalAnim$Css$Props$known = function (id) {
	switch (id) {
		case 0:
			return true;
		case 1:
			return true;
		case 2:
			return true;
		case 3:
			return true;
		case 4:
			return true;
		case 5:
			return true;
		case 6:
			return true;
		case 13:
			return true;
		case 14:
			return true;
		default:
			return false;
	}
};
var $author$project$InternalAnim$Css$Props$hash$ = function (p, val) {
	return $author$project$InternalAnim$Css$Props$known(p.id) ? _Utils_ap(
		$author$project$InternalAnim$Css$Props$hashId(p.id),
		$author$project$InternalAnim$Css$Props$hashFormat$(p.format, val)) : _Utils_ap(
		p.name,
		$author$project$InternalAnim$Css$Props$hashFormat$(p.format, val));
};
var $author$project$InternalAnim$Css$Props$hash = F2($author$project$InternalAnim$Css$Props$hash$);
var $author$project$InternalAnim$Move$lerpFloat$ = function (t, one, two) {
	return one + ((two - one) * t);
};
var $author$project$InternalAnim$Move$lerpFloat = F3($author$project$InternalAnim$Move$lerpFloat$);
var $author$project$InternalAnim$Move$lerpVector$ = function (t, one, two) {
	return {
		x: $author$project$InternalAnim$Move$lerpFloat$(t, one.x, two.x),
		y: $author$project$InternalAnim$Move$lerpFloat$(t, one.y, two.y),
		z: $author$project$InternalAnim$Move$lerpFloat$(t, one.z, two.z)
	};
};
var $author$project$InternalAnim$Move$lerpVector = F3($author$project$InternalAnim$Move$lerpVector$);
var $author$project$InternalAnim$Css$vectorStateToVector = function (state) {
	return {
		x: $author$project$InternalAnim$Units$inPixels(state.x.position),
		y: $author$project$InternalAnim$Units$inPixels(state.y.position),
		z: $author$project$InternalAnim$Units$inPixels(state.z.position)
	};
};
var $author$project$InternalAnim$Css$vectorToHash$ = function (group, vec) {
	if ((!vec.x) && ((!vec.y) && (!vec.z))) {
		return '';
	} else {
		var tag = function () {
			switch (group) {
				case 10:
					return 't';
				case 20:
					return 's';
				default:
					return 'v';
			}
		}();
		return tag + ($author$project$InternalAnim$Hash$float(vec.x) + ('-' + ($author$project$InternalAnim$Hash$float(vec.y) + ('-' + $author$project$InternalAnim$Hash$float(vec.z)))));
	}
};
var $author$project$InternalAnim$Css$vectorToHash = F2($author$project$InternalAnim$Css$vectorToHash$);
var $author$project$InternalAnim$Css$Props$scaleToString = function (vec) {
	return $author$project$InternalAnim$Css$Props$vectorToCssString(vec);
};
var $author$project$InternalAnim$Css$Props$translateToString = function (_v0) {
	var z = _v0.z;
	var y = _v0.y;
	var x = _v0.x;
	return $author$project$InternalAnim$Css$Props$floatToString(x) + ('px ' + ($author$project$InternalAnim$Css$Props$floatToString(y) + ('px ' + ($author$project$InternalAnim$Css$Props$floatToString(z) + 'px'))));
};
var $author$project$InternalAnim$Css$Props$vectorToString$ = function (id, vec) {
	switch (id) {
		case 10:
			return $author$project$InternalAnim$Css$Props$translateToString(vec);
		case 20:
			return $author$project$InternalAnim$Css$Props$scaleToString(vec);
		default:
			return $author$project$InternalAnim$Css$Props$vectorToCssString(vec);
	}
};
var $author$project$InternalAnim$Css$Props$vectorToString = F2($author$project$InternalAnim$Css$Props$vectorToString$);
var $author$project$InternalAnim$Css$props2Css$ = function (allowTransitions, now, renderedProps, anim) {
	props2Css:
	while (true) {
		if (!renderedProps.b) {
			return anim;
		} else {
			switch (renderedProps.a.$) {
				case 0:
					var details = renderedProps.a.a;
					var remain = renderedProps.b;
					var $temp$renderedProps = remain,
						$temp$anim = function () {
						var _v1 = details.sections;
						if (!_v1.b) {
							var val = $author$project$InternalAnim$Units$inPixels(details.state.position);
							var value = $author$project$InternalAnim$Css$Props$format$(details.format, val);
							return _Utils_update(
								anim,
								{
									hash: _Utils_ap(
										$author$project$InternalAnim$Css$Props$hash$(details, val),
										anim.hash),
									props: A2(
										$elm$core$List$cons,
										_Utils_Tuple2(details.name, value),
										anim.props)
								});
						} else {
							return $author$project$InternalAnim$Css$combine$(
								anim,
								$author$project$InternalAnim$Move$cssForSections$(
									now,
									allowTransitions,
									$author$project$InternalAnim$Units$inPixels(details.state.position),
									details.name,
									F3(
										function (t, one, two) {
											return details.name + (': ' + $author$project$InternalAnim$Css$Props$format$(
												details.format,
												$author$project$InternalAnim$Move$lerpFloat$(t, one, two)));
										}),
									$author$project$InternalAnim$Css$Props$format(details.format),
									$author$project$InternalAnim$Css$Props$hash(details),
									$elm$core$List$reverse(details.sections),
									$author$project$InternalAnim$Css$emptyAnim));
						}
					}();
					renderedProps = $temp$renderedProps;
					anim = $temp$anim;
					continue props2Css;
				case 1:
					var details = renderedProps.a.a;
					var remain = renderedProps.b;
					var $temp$renderedProps = remain,
						$temp$anim = function () {
						var _v2 = details.sections;
						if (!_v2.b) {
							return _Utils_update(
								anim,
								{
									hash: details.name + ('-' + ($author$project$InternalAnim$Css$Props$colorHash(details.color) + anim.hash)),
									props: A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											details.name,
											$avh4$elm_color$Color$toCssString(details.color)),
										anim.props)
								});
						} else {
							return $author$project$InternalAnim$Css$combine$(
								anim,
								$author$project$InternalAnim$Move$cssForSections$(
									now,
									allowTransitions,
									details.color,
									details.name,
									F3(
										function (t, one, two) {
											return details.name + (': ' + $avh4$elm_color$Color$toCssString(
												$author$project$InternalAnim$Move$lerpColor$(t, one, two)));
										}),
									$avh4$elm_color$Color$toCssString,
									$author$project$InternalAnim$Css$Props$colorHash,
									$elm$core$List$reverse(details.sections),
									$author$project$InternalAnim$Css$emptyAnim));
						}
					}();
					renderedProps = $temp$renderedProps;
					anim = $temp$anim;
					continue props2Css;
				default:
					var details = renderedProps.a.a;
					var remain = renderedProps.b;
					var $temp$renderedProps = remain,
						$temp$anim = function () {
						var _v3 = details.sections;
						if (!_v3.b) {
							return _Utils_update(
								anim,
								{
									hash: _Utils_ap(
										$author$project$InternalAnim$Css$vectorToHash$(
											details.group,
											$author$project$InternalAnim$Css$vectorStateToVector(details.state)),
										anim.hash),
									props: A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											details.name,
											$author$project$InternalAnim$Css$Props$vectorToString$(
												details.group,
												$author$project$InternalAnim$Css$vectorStateToVector(details.state))),
										anim.props)
								});
						} else {
							return $author$project$InternalAnim$Css$combine$(
								anim,
								$author$project$InternalAnim$Move$cssForSections$(
									now,
									allowTransitions,
									$author$project$InternalAnim$Css$vectorStateToVector(details.state),
									details.name,
									F3(
										function (t, one, two) {
											return details.name + (': ' + $author$project$InternalAnim$Css$Props$vectorToString$(
												details.group,
												$author$project$InternalAnim$Move$lerpVector$(t, one, two)));
										}),
									$author$project$InternalAnim$Css$Props$vectorToString(details.group),
									$author$project$InternalAnim$Css$vectorToHash(details.group),
									$elm$core$List$reverse(details.sections),
									$author$project$InternalAnim$Css$emptyAnim));
						}
					}();
					renderedProps = $temp$renderedProps;
					anim = $temp$anim;
					continue props2Css;
			}
		}
	}
};
var $author$project$InternalAnim$Css$props2Css = F4($author$project$InternalAnim$Css$props2Css$);
var $author$project$InternalAnim$Css$toCss = function (_v0) {
	var attrs = _v0.attrs;
	var now = _v0.now;
	var allowTransitions = _v0.allowTransitions;
	var cssDetails = $author$project$InternalAnim$Css$props2Css$(allowTransitions, now, attrs, $author$project$InternalAnim$Css$emptyAnim);
	return {
		hash: cssDetails.hash,
		keyframes: cssDetails.keyframes,
		props: function () {
			var _v1 = cssDetails.animation;
			if (_v1 === '') {
				var _v2 = cssDetails.transition;
				if (_v2 === '') {
					return cssDetails.props;
				} else {
					var trans = _v2;
					return A2(
						$elm$core$List$cons,
						_Utils_Tuple2('transition', trans),
						cssDetails.props);
				}
			} else {
				var anim = _v1;
				var _v3 = cssDetails.transition;
				if (_v3 === '') {
					return A2(
						$elm$core$List$cons,
						_Utils_Tuple2('animation', anim),
						cssDetails.props);
				} else {
					var trans = _v3;
					return A2(
						$elm$core$List$cons,
						_Utils_Tuple2('animation', anim),
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2('transition', trans),
							cssDetails.props));
				}
			}
		}(),
		transition: cssDetails.transition
	};
};
var $author$project$Animator$css$ = function (timeline, toPropsAndSteps) {
	var toProps = function (event) {
		var _v0 = toPropsAndSteps(event);
		var props = _v0.a;
		var steps = _v0.b;
		var fullDuration = $author$project$Animator$sumStepDuration$($author$project$InternalAnim$Time$zeroDuration, steps);
		return $elm$core$List$map$(
			A3($author$project$Animator$addSequenceSteps, 1, fullDuration, steps),
			$author$project$Animator$getInitialProps$($author$project$InternalAnim$Time$zeroDuration, steps, props));
	};
	return $author$project$InternalAnim$Css$toCss(
		{
			allowTransitions: 1,
			attrs: $author$project$InternalAnim$Css$propsToRenderedProps$(timeline, toProps),
			now: $author$project$InternalAnim$Timeline$getUpdatedAt(timeline)
		});
};
var $author$project$Animator$css = F2($author$project$Animator$css$);
var $author$project$InternalAnim$Timeline$Timeline = $elm$core$Basics$identity;
var $author$project$InternalAnim$Timeline$Timetable = $elm$core$Basics$identity;
var $author$project$InternalAnim$Time$absolute = function (posix) {
	return $elm$time$Time$posixToMillis(posix);
};
var $author$project$Animator$Timeline$init = function (first) {
	var epoch = $author$project$InternalAnim$Time$absolute(
		$elm$time$Time$millisToPosix(0));
	return {
		delay: $author$project$InternalAnim$Duration$milliseconds(0),
		events: _List_Nil,
		initial: first,
		interruption: _List_Nil,
		now: epoch,
		queued: $elm$core$Maybe$Nothing,
		running: true,
		scale: 1,
		updatedAt: epoch
	};
};
var $author$project$InternalAnim$Timeline$Event$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $author$project$InternalAnim$Timeline$Event = F3($author$project$InternalAnim$Timeline$Event$);
var $author$project$InternalAnim$Timeline$Schedule$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $author$project$InternalAnim$Timeline$Schedule = F3($author$project$InternalAnim$Timeline$Schedule$);
var $author$project$Animator$Timeline$initializeSchedule$ = function (waiting, steps) {
	initializeSchedule:
	while (true) {
		if (!steps.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!steps.a.$) {
				var additionalWait = steps.a.a;
				var moreSteps = steps.b;
				var $temp$waiting = $author$project$InternalAnim$Quantity$plus$(waiting, additionalWait),
					$temp$steps = moreSteps;
				waiting = $temp$waiting;
				steps = $temp$steps;
				continue initializeSchedule;
			} else {
				var _v1 = steps.a;
				var dur = _v1.a;
				var checkpoint = _v1.b;
				var moreSteps = steps.b;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(
						$author$project$InternalAnim$Timeline$Schedule$(
							waiting,
							$author$project$InternalAnim$Timeline$Event$(dur, checkpoint, $elm$core$Maybe$Nothing),
							_List_Nil),
						moreSteps));
			}
		}
	}
};
var $author$project$Animator$Timeline$initializeSchedule = F2($author$project$Animator$Timeline$initializeSchedule$);
var $author$project$InternalAnim$Timeline$addToDwell$ = function (duration, maybeDwell) {
	if (!$author$project$InternalAnim$Duration$inMilliseconds(duration)) {
		return maybeDwell;
	} else {
		if (maybeDwell.$ === 1) {
			return $elm$core$Maybe$Just(duration);
		} else {
			var existing = maybeDwell.a;
			return $elm$core$Maybe$Just(
				$author$project$InternalAnim$Quantity$plus$(duration, existing));
		}
	}
};
var $author$project$InternalAnim$Timeline$addToDwell = F2($author$project$InternalAnim$Timeline$addToDwell$);
var $author$project$InternalAnim$Timeline$extendEventDwell$ = function (extendBy, thisEvent) {
	var at = thisEvent.a;
	var ev = thisEvent.b;
	var maybeDwell = thisEvent.c;
	return (!$author$project$InternalAnim$Duration$inMilliseconds(extendBy)) ? thisEvent : $author$project$InternalAnim$Timeline$Event$(
		at,
		ev,
		$author$project$InternalAnim$Timeline$addToDwell$(extendBy, maybeDwell));
};
var $author$project$InternalAnim$Timeline$extendEventDwell = F2($author$project$InternalAnim$Timeline$extendEventDwell$);
var $author$project$Animator$Timeline$stepsToEvents$ = function (currentStep, _v0) {
	var delayTime = _v0.a;
	var startEvent = _v0.b;
	var events = _v0.c;
	if (!events.b) {
		if (!currentStep.$) {
			var waiting = currentStep.a;
			return $author$project$InternalAnim$Timeline$Schedule$(
				delayTime,
				$author$project$InternalAnim$Timeline$extendEventDwell$(waiting, startEvent),
				events);
		} else {
			var dur = currentStep.a;
			var checkpoint = currentStep.b;
			return $author$project$InternalAnim$Timeline$Schedule$(
				delayTime,
				startEvent,
				_List_fromArray(
					[
						$author$project$InternalAnim$Timeline$Event$(dur, checkpoint, $elm$core$Maybe$Nothing)
					]));
		}
	} else {
		var _v3 = events.a;
		var durationTo = _v3.a;
		var recentEvent = _v3.b;
		var maybeDwell = _v3.c;
		var remaining = events.b;
		if (!currentStep.$) {
			var dur = currentStep.a;
			return $author$project$InternalAnim$Timeline$Schedule$(
				delayTime,
				startEvent,
				A2(
					$elm$core$List$cons,
					$author$project$InternalAnim$Timeline$Event$(
						durationTo,
						recentEvent,
						$author$project$InternalAnim$Timeline$addToDwell$(dur, maybeDwell)),
					remaining));
		} else {
			var dur = currentStep.a;
			var checkpoint = currentStep.b;
			return _Utils_eq(checkpoint, recentEvent) ? $author$project$InternalAnim$Timeline$Schedule$(
				delayTime,
				startEvent,
				A2(
					$elm$core$List$cons,
					$author$project$InternalAnim$Timeline$Event$(
						durationTo,
						recentEvent,
						$author$project$InternalAnim$Timeline$addToDwell$(dur, maybeDwell)),
					remaining)) : $author$project$InternalAnim$Timeline$Schedule$(
				delayTime,
				startEvent,
				A2(
					$elm$core$List$cons,
					$author$project$InternalAnim$Timeline$Event$(dur, checkpoint, $elm$core$Maybe$Nothing),
					events));
		}
	}
};
var $author$project$Animator$Timeline$stepsToEvents = F2($author$project$Animator$Timeline$stepsToEvents$);
var $author$project$Animator$Timeline$interrupt$ = function (steps, fullTimeline) {
	var tl = fullTimeline;
	return _Utils_update(
		tl,
		{
			interruption: function () {
				var _v0 = $author$project$Animator$Timeline$initializeSchedule$(
					$author$project$InternalAnim$Duration$milliseconds(0),
					steps);
				if (_v0.$ === 1) {
					return tl.interruption;
				} else {
					var _v1 = _v0.a;
					var schedule = _v1.a;
					var otherSteps = _v1.b;
					return _List_fromArray(
						[
							$elm$core$List$foldl$($author$project$Animator$Timeline$stepsToEvents, schedule, otherSteps)
						]);
				}
			}(),
			running: true
		});
};
var $author$project$Animator$Timeline$interrupt = F2($author$project$Animator$Timeline$interrupt$);
var $author$project$Animator$Timeline$TransitionTo$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Animator$Timeline$TransitionTo = F2($author$project$Animator$Timeline$TransitionTo$);
var $author$project$Animator$Timeline$transitionTo = $author$project$Animator$Timeline$TransitionTo;
var $author$project$Animator$Timeline$to$ = function (duration, ev, timeline) {
	return $author$project$Animator$Timeline$interrupt$(
		_List_fromArray(
			[
				A2($author$project$Animator$Timeline$transitionTo, duration, ev)
			]),
		timeline);
};
var $author$project$Animator$Timeline$to = F3($author$project$Animator$Timeline$to$);
var $author$project$Ui$Anim$onActiveTrigger = 'on-activated';
var $author$project$Ui$Anim$onFocusTrigger = 'on-focused';
var $author$project$Ui$Anim$onHoverTrigger = 'on-hovered';
var $author$project$Ui$Anim$onRenderTrigger = 'on-rendered';
var $author$project$Ui$Anim$triggerClass = function (trigger) {
	switch (trigger) {
		case 0:
			return $author$project$Ui$Anim$onHoverTrigger;
		case 1:
			return $author$project$Ui$Anim$onFocusTrigger;
		case 2:
			return $author$project$Ui$Anim$onActiveTrigger;
		default:
			return $author$project$Ui$Anim$onRenderTrigger;
	}
};
var $author$project$Ui$Anim$addTriggerToCssClass$ = function (trigger, css) {
	return _Utils_update(
		css,
		{
			hash: _Utils_ap(
				$author$project$Ui$Anim$triggerClass(trigger),
				css.hash)
		});
};
var $author$project$Ui$Anim$addTriggerToCssClass = F2($author$project$Ui$Anim$addTriggerToCssClass$);
var $author$project$Internal$Teleport$encodeProp$ = function (asImportant, _v0) {
	var key = _v0.a;
	var value = _v0.b;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'key',
				$elm$json$Json$Encode$string(key)),
				_Utils_Tuple2(
				'value',
				asImportant ? $elm$json$Json$Encode$string(value + ' !important') : $elm$json$Json$Encode$string(value))
			]));
};
var $author$project$Internal$Teleport$encodeProp = F2($author$project$Internal$Teleport$encodeProp$);
var $author$project$Internal$Teleport$encodeCss$ = function (trigger, keyframesHash, css) {
	var noKeyframes = $elm$core$String$isEmpty(css.keyframes);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string('css')),
				_Utils_Tuple2(
				'trigger',
				$elm$json$Json$Encode$string(trigger)),
				_Utils_Tuple2(
				'hash',
				$elm$json$Json$Encode$string(css.hash)),
				_Utils_Tuple2(
				'keyframesHash',
				$elm$json$Json$Encode$string(keyframesHash)),
				_Utils_Tuple2(
				'keyframes',
				$elm$json$Json$Encode$string(css.keyframes)),
				_Utils_Tuple2(
				'transition',
				$elm$json$Json$Encode$string(css.transition)),
				_Utils_Tuple2(
				'props',
				$elm$json$Json$Encode$list$(
					$author$project$Internal$Teleport$encodeProp(noKeyframes),
					css.props))
			]));
};
var $author$project$Internal$Teleport$encodeCss = F3($author$project$Internal$Teleport$encodeCss$);
var $author$project$Internal$Model2$teleport = function (options) {
	return {
		attr: {
			additionalInheritance: $author$project$Internal$BitField$none,
			attrs: _List_Nil,
			_class: $elm$core$Maybe$Just(options._class + (' ' + options.trigger)),
			nearby: $elm$core$Maybe$Just(
				_Utils_Tuple2(
					6,
					function (_v0) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(options._class + (' ' + $author$project$Internal$Style2$classes.trigger)),
									A2(
									$elm$html$Html$Attributes$property,
									'data-elm-ui',
									$elm$json$Json$Encode$list$(
										$elm$core$Basics$identity,
										_List_fromArray(
											[options.data]))),
									A2($elm$html$Html$Attributes$style, 'pointer-events', 'none')
								]),
							_List_Nil);
					})),
			node: $author$project$Internal$Model2$NodeAsDiv,
			styles: F2(
				function (_v1, _v2) {
					return options.style;
				})
		},
		flag: $author$project$Internal$Flag$skip
	};
};
var $author$project$Ui$Anim$triggerPsuedo = function (trigger) {
	switch (trigger) {
		case 0:
			return ':hover';
		case 1:
			return ':focus';
		case 2:
			return ':active';
		default:
			return '';
	}
};
var $author$project$Ui$Anim$toAttr$ = function (trigger, incomingCss) {
	var css = $author$project$Ui$Anim$addTriggerToCssClass$(trigger, incomingCss);
	var props = (css.transition === '') ? _List_Nil : _List_fromArray(
		[
			_Utils_Tuple2('transition', css.transition)
		]);
	return $author$project$Internal$Model2$teleport(
		{
			_class: css.hash,
			data: $author$project$Internal$Teleport$encodeCss$(
				$author$project$Ui$Anim$triggerPsuedo(trigger),
				incomingCss.hash,
				css),
			style: function () {
				if (trigger === 3) {
					return _Utils_ap(incomingCss.props, props);
				} else {
					return props;
				}
			}(),
			trigger: $author$project$Ui$Anim$triggerClass(trigger)
		});
};
var $author$project$Ui$Anim$toAttr = F2($author$project$Ui$Anim$toAttr$);
var $author$project$InternalAnim$Timeline$Line$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $author$project$InternalAnim$Timeline$Line = F3($author$project$InternalAnim$Timeline$Line$);
var $author$project$InternalAnim$Time$advanceBy$ = function (dur, time) {
	return $author$project$InternalAnim$Quantity$plus$(
		time,
		$author$project$InternalAnim$Duration$inMilliseconds(dur));
};
var $author$project$InternalAnim$Time$advanceBy = F2($author$project$InternalAnim$Time$advanceBy$);
var $author$project$InternalAnim$Timeline$toOccurring$ = function (_v0, _v1) {
	var duration = _v0.a;
	var event = _v0.b;
	var maybeDwell = _v0.c;
	var now = _v1.a;
	var events = _v1.b;
	var occursAt = $author$project$InternalAnim$Time$advanceBy$(duration, now);
	var endsAt = function () {
		if (maybeDwell.$ === 1) {
			return occursAt;
		} else {
			var dwell = maybeDwell.a;
			return $author$project$InternalAnim$Time$advanceBy$(dwell, occursAt);
		}
	}();
	return _Utils_Tuple2(
		endsAt,
		A2(
			$elm$core$List$cons,
			$author$project$InternalAnim$Timeline$Occurring$(event, occursAt, endsAt),
			events));
};
var $author$project$InternalAnim$Timeline$toOccurring = F2($author$project$InternalAnim$Timeline$toOccurring$);
var $author$project$InternalAnim$Timeline$createLine$ = function (now, _v0) {
	var delay = _v0.a;
	var _v1 = _v0.b;
	var dur = _v1.a;
	var startEvent = _v1.b;
	var maybeDwell = _v1.c;
	var reverseQueued = _v0.c;
	var start = $author$project$InternalAnim$Time$advanceBy$(
		delay,
		$author$project$InternalAnim$Time$advanceBy$(dur, now));
	var startNextEvent = function () {
		if (maybeDwell.$ === 1) {
			return start;
		} else {
			var dwell = maybeDwell.a;
			return $author$project$InternalAnim$Time$advanceBy$(dwell, start);
		}
	}();
	var events = $elm$core$List$reverse(
		$elm$core$List$foldl$(
			$author$project$InternalAnim$Timeline$toOccurring,
			_Utils_Tuple2(startNextEvent, _List_Nil),
			$elm$core$List$reverse(reverseQueued)).b);
	return $author$project$InternalAnim$Timeline$Line$(
		$author$project$InternalAnim$Time$advanceBy$(delay, now),
		$author$project$InternalAnim$Timeline$Occurring$(startEvent, start, startNextEvent),
		events);
};
var $author$project$InternalAnim$Timeline$createLine = F2($author$project$InternalAnim$Timeline$createLine$);
var $author$project$InternalAnim$Time$latest$ = function (oneQty, twoQty) {
	var one = oneQty;
	var two = twoQty;
	return ((one - two) <= 0) ? twoQty : oneQty;
};
var $author$project$InternalAnim$Time$latest = F2($author$project$InternalAnim$Time$latest$);
var $author$project$InternalAnim$Timeline$scheduleDelay = function (_v0) {
	var d = _v0.a;
	return d;
};
var $author$project$InternalAnim$Timeline$addEventsToLine$ = function (now, scheduled, _v0, lines) {
	var startLineAt = _v0.a;
	var startingEvent = _v0.b;
	var events = _v0.c;
	var _v1 = $elm$core$List$reverse(events);
	if (!_v1.b) {
		var startNewEventsAt = $author$project$InternalAnim$Time$latest$(
			$author$project$InternalAnim$Timeline$endTime(startingEvent),
			now);
		var startingEventWithDwell = function () {
			var ev = startingEvent.a;
			var eventStart = startingEvent.b;
			return $author$project$InternalAnim$Timeline$Occurring$(
				ev,
				eventStart,
				$author$project$InternalAnim$Time$advanceBy$(
					$author$project$InternalAnim$Timeline$scheduleDelay(scheduled),
					startNewEventsAt));
		}();
		var newLine = $author$project$InternalAnim$Timeline$createLine$(startNewEventsAt, scheduled);
		return A2(
			$elm$core$List$cons,
			$author$project$InternalAnim$Timeline$Line$(startLineAt, startingEventWithDwell, _List_Nil),
			A2($elm$core$List$cons, newLine, lines));
	} else {
		var _v3 = _v1.a;
		var lastEvent = _v3.a;
		var lastEventTime = _v3.b;
		var lastEventFinish = _v3.c;
		var eventTail = _v1.b;
		var startNewEventsAt = $author$project$InternalAnim$Time$latest$(lastEventFinish, now);
		var newLine = $author$project$InternalAnim$Timeline$createLine$(startNewEventsAt, scheduled);
		var newLastEvent = $author$project$InternalAnim$Timeline$Occurring$(
			lastEvent,
			lastEventTime,
			$author$project$InternalAnim$Time$advanceBy$(
				$author$project$InternalAnim$Timeline$scheduleDelay(scheduled),
				startNewEventsAt));
		return A2(
			$elm$core$List$cons,
			$author$project$InternalAnim$Timeline$Line$(
				startLineAt,
				startingEvent,
				$elm$core$List$reverse(
					A2($elm$core$List$cons, newLastEvent, eventTail))),
			A2($elm$core$List$cons, newLine, lines));
	}
};
var $author$project$InternalAnim$Timeline$addEventsToLine = F4($author$project$InternalAnim$Timeline$addEventsToLine$);
var $author$project$InternalAnim$Timeline$addToCurrentLine$ = function (now, scheduled, lines) {
	if (!lines.b) {
		return _List_fromArray(
			[
				$author$project$InternalAnim$Timeline$createLine$(now, scheduled)
			]);
	} else {
		if (!lines.b.b) {
			var line = lines.a;
			return $author$project$InternalAnim$Timeline$addEventsToLine$(now, scheduled, line, _List_Nil);
		} else {
			var _v1 = lines.a;
			var startOne = _v1.a;
			var startEventOne = _v1.b;
			var one = _v1.c;
			var _v2 = lines.b;
			var _v3 = _v2.a;
			var startTwo = _v3.a;
			var startEventTwo = _v3.b;
			var two = _v3.c;
			var remaining = _v2.b;
			return ($author$project$InternalAnim$Time$thisAfterOrEqualThat$(now, startOne) && $author$project$InternalAnim$Time$thisBeforeThat$(now, startTwo)) ? $author$project$InternalAnim$Timeline$addEventsToLine$(
				now,
				scheduled,
				$author$project$InternalAnim$Timeline$Line$(startOne, startEventOne, one),
				A2(
					$elm$core$List$cons,
					$author$project$InternalAnim$Timeline$Line$(startTwo, startEventTwo, two),
					remaining)) : A2(
				$elm$core$List$cons,
				$author$project$InternalAnim$Timeline$Line$(startOne, startEventOne, one),
				$author$project$InternalAnim$Timeline$addToCurrentLine$(
					now,
					scheduled,
					A2(
						$elm$core$List$cons,
						$author$project$InternalAnim$Timeline$Line$(startTwo, startEventTwo, two),
						remaining)));
		}
	}
};
var $author$project$InternalAnim$Timeline$addToCurrentLine = F3($author$project$InternalAnim$Timeline$addToCurrentLine$);
var $author$project$InternalAnim$Timeline$enqueue$ = function (timeline, now, scheduled) {
	var _v0 = timeline.events;
	var lines = _v0;
	return $author$project$InternalAnim$Timeline$addToCurrentLine$(now, scheduled, lines);
};
var $author$project$InternalAnim$Timeline$enqueue = F3($author$project$InternalAnim$Timeline$enqueue$);
var $author$project$InternalAnim$Timeline$beforeEventEnd$ = function (time, events) {
	beforeEventEnd:
	while (true) {
		if (!events.b) {
			return false;
		} else {
			var top = events.a;
			var remain = events.b;
			if ($author$project$InternalAnim$Time$thisBeforeThat$(
				time,
				$author$project$InternalAnim$Timeline$endTime(top))) {
				return true;
			} else {
				var $temp$events = remain;
				events = $temp$events;
				continue beforeEventEnd;
			}
		}
	}
};
var $author$project$InternalAnim$Timeline$beforeEventEnd = F2($author$project$InternalAnim$Timeline$beforeEventEnd$);
var $author$project$InternalAnim$Time$thisBeforeOrEqualThat$ = function (_v0, _v1) {
	var _this = _v0;
	var that = _v1;
	return (_this - that) <= 0;
};
var $author$project$InternalAnim$Time$thisBeforeOrEqualThat = F2($author$project$InternalAnim$Time$thisBeforeOrEqualThat$);
var $author$project$InternalAnim$Timeline$beforeLineEnd$ = function (time, _v0) {
	var lineStartAt = _v0.a;
	var startingEvent = _v0.b;
	var trailing = _v0.c;
	if ($author$project$InternalAnim$Time$thisBeforeOrEqualThat$(time, lineStartAt)) {
		return true;
	} else {
		if (!trailing.b) {
			return $author$project$InternalAnim$Time$thisBeforeThat$(
				time,
				$author$project$InternalAnim$Timeline$endTime(startingEvent));
		} else {
			return $author$project$InternalAnim$Timeline$beforeEventEnd$(time, trailing);
		}
	}
};
var $author$project$InternalAnim$Timeline$beforeLineEnd = F2($author$project$InternalAnim$Timeline$beforeLineEnd$);
var $author$project$InternalAnim$Timeline$interruptLine$ = function (now, scheduled, line, future) {
	var start = line.a;
	var startEvent = line.b;
	var trailing = line.c;
	var startInterruption = $author$project$InternalAnim$Time$advanceBy$(
		$author$project$InternalAnim$Timeline$scheduleDelay(scheduled),
		now);
	if ($author$project$InternalAnim$Time$thisAfterOrEqualThat$(startInterruption, start)) {
		if (!future.b) {
			return $author$project$InternalAnim$Timeline$beforeLineEnd$(startInterruption, line) ? $elm$core$Maybe$Just(
				_List_fromArray(
					[
						$author$project$InternalAnim$Timeline$createLine$(now, scheduled)
					])) : $elm$core$Maybe$Nothing;
		} else {
			var _v2 = future.a;
			var nextStart = _v2.a;
			var next = _v2.b;
			var nextEvents = _v2.c;
			var futureRemaining = future.b;
			return ($author$project$InternalAnim$Time$thisAfterOrEqualThat$(startInterruption, nextStart) && $author$project$InternalAnim$Time$thisBeforeOrEqualThat$(
				startInterruption,
				$author$project$InternalAnim$Timeline$startTime(next))) ? $elm$core$Maybe$Just(
				A2(
					$elm$core$List$cons,
					$author$project$InternalAnim$Timeline$Line$(nextStart, next, nextEvents),
					A2(
						$elm$core$List$cons,
						$author$project$InternalAnim$Timeline$createLine$(now, scheduled),
						futureRemaining))) : $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$InternalAnim$Timeline$interruptLine = F4($author$project$InternalAnim$Timeline$interruptLine$);
var $author$project$InternalAnim$Timeline$lineStartTime = function (_v0) {
	var start = _v0.a;
	return start;
};
var $author$project$InternalAnim$Timeline$interruptionHappensLater$ = function (startInterruption, remaining) {
	if (!remaining.b) {
		return false;
	} else {
		var top = remaining.a;
		return $author$project$InternalAnim$Time$thisAfterOrEqualThat$(
			startInterruption,
			$author$project$InternalAnim$Timeline$lineStartTime(top));
	}
};
var $author$project$InternalAnim$Timeline$interruptionHappensLater = F2($author$project$InternalAnim$Timeline$interruptionHappensLater$);
var $author$project$InternalAnim$Timeline$scheduledEventEqual$ = function (_v0, _v1) {
	var schedEvent = _v0.b;
	var occurEvent = _v1.a;
	return _Utils_eq(schedEvent, occurEvent);
};
var $author$project$InternalAnim$Timeline$scheduledEventEqual = F2($author$project$InternalAnim$Timeline$scheduledEventEqual$);
var $author$project$InternalAnim$Timeline$scheduleMatchesExisting$ = function (_v0, _v1) {
	var event = _v0.b;
	var schedulUpcoming = _v0.c;
	var lineStartEvent = _v1.b;
	var lineUpcoming = _v1.c;
	var equalUpcoming = function () {
		if (!schedulUpcoming.b) {
			if (!lineUpcoming.b) {
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	}();
	var equalStartEvent = $author$project$InternalAnim$Timeline$scheduledEventEqual$(event, lineStartEvent);
	return equalStartEvent && equalUpcoming;
};
var $author$project$InternalAnim$Timeline$scheduleMatchesExisting = F2($author$project$InternalAnim$Timeline$scheduleMatchesExisting$);
var $author$project$InternalAnim$Timeline$interruptLines$ = function (now, scheduled, pastLines, lines) {
	interruptLines:
	while (true) {
		if (!lines.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var startLine = lines.a;
			var remaining = lines.b;
			var startInterruption = $author$project$InternalAnim$Time$advanceBy$(
				$author$project$InternalAnim$Timeline$scheduleDelay(scheduled),
				now);
			if ($author$project$InternalAnim$Timeline$interruptionHappensLater$(startInterruption, remaining)) {
				var $temp$pastLines = A2($elm$core$List$cons, startLine, pastLines),
					$temp$lines = remaining;
				pastLines = $temp$pastLines;
				lines = $temp$lines;
				continue interruptLines;
			} else {
				var _v1 = $author$project$InternalAnim$Timeline$interruptLine$(now, scheduled, startLine, remaining);
				if (_v1.$ === 1) {
					var $temp$pastLines = A2($elm$core$List$cons, startLine, pastLines),
						$temp$lines = remaining;
					pastLines = $temp$pastLines;
					lines = $temp$lines;
					continue interruptLines;
				} else {
					var interruption = _v1.a;
					return $author$project$InternalAnim$Timeline$scheduleMatchesExisting$(scheduled, startLine) ? $elm$core$Maybe$Just(
						_Utils_ap(
							$elm$core$List$reverse(pastLines),
							lines)) : ((_Utils_eq(
						startInterruption,
						$author$project$InternalAnim$Timeline$lineStartTime(startLine)) && $author$project$InternalAnim$Time$thisAfterThat$(startInterruption, now)) ? $elm$core$Maybe$Just(
						_Utils_ap(
							$elm$core$List$reverse(pastLines),
							interruption)) : $elm$core$Maybe$Just(
						_Utils_ap(
							$elm$core$List$reverse(pastLines),
							A2($elm$core$List$cons, startLine, interruption))));
				}
			}
		}
	}
};
var $author$project$InternalAnim$Timeline$interruptLines = F4($author$project$InternalAnim$Timeline$interruptLines$);
var $author$project$InternalAnim$Timeline$interrupt$ = function (timeline, scheduled) {
	var _v0 = timeline.events;
	var lines = _v0;
	var _v1 = $author$project$InternalAnim$Timeline$interruptLines$(timeline.now, scheduled, _List_Nil, lines);
	if (_v1.$ === 1) {
		return $author$project$InternalAnim$Timeline$enqueue$(timeline, timeline.now, scheduled);
	} else {
		var interrupted = _v1.a;
		return interrupted;
	}
};
var $author$project$InternalAnim$Timeline$interrupt = F2($author$project$InternalAnim$Timeline$interrupt$);
var $author$project$InternalAnim$Time$scaleDuration$ = function (x, untouched) {
	var d = untouched;
	return (x === 1) ? untouched : (x * d);
};
var $author$project$InternalAnim$Time$scaleDuration = F2($author$project$InternalAnim$Time$scaleDuration$);
var $author$project$InternalAnim$Timeline$scaleEvent$ = function (scale, _v0) {
	var dur = _v0.a;
	var event = _v0.b;
	var maybeDur = _v0.c;
	return $author$project$InternalAnim$Timeline$Event$(
		$author$project$InternalAnim$Time$scaleDuration$(scale, dur),
		event,
		$elm$core$Maybe$map$(
			$author$project$InternalAnim$Time$scaleDuration(scale),
			maybeDur));
};
var $author$project$InternalAnim$Timeline$scaleEvent = F2($author$project$InternalAnim$Timeline$scaleEvent$);
var $author$project$InternalAnim$Timeline$scaleSchedule$ = function (scale, _v0) {
	var dur = _v0.a;
	var event = _v0.b;
	var events = _v0.c;
	return $author$project$InternalAnim$Timeline$Schedule$(
		$author$project$InternalAnim$Time$scaleDuration$(scale, dur),
		$author$project$InternalAnim$Timeline$scaleEvent$(scale, event),
		$elm$core$List$map$(
			$author$project$InternalAnim$Timeline$scaleEvent(scale),
			events));
};
var $author$project$InternalAnim$Timeline$scaleSchedule = F2($author$project$InternalAnim$Timeline$scaleSchedule$);
var $author$project$InternalAnim$Timeline$applyInterruptionHelper$ = function (interrupts, timeline) {
	applyInterruptionHelper:
	while (true) {
		if (!interrupts.b) {
			return timeline;
		} else {
			var inter = interrupts.a;
			var remaining = interrupts.b;
			var $temp$interrupts = remaining,
				$temp$timeline = _Utils_update(
				timeline,
				{
					events: (timeline.scale === 1) ? $author$project$InternalAnim$Timeline$interrupt$(timeline, inter) : $author$project$InternalAnim$Timeline$interrupt$(
						timeline,
						$author$project$InternalAnim$Timeline$scaleSchedule$(timeline.scale, inter))
				});
			interrupts = $temp$interrupts;
			timeline = $temp$timeline;
			continue applyInterruptionHelper;
		}
	}
};
var $author$project$InternalAnim$Timeline$applyInterruptionHelper = F2($author$project$InternalAnim$Timeline$applyInterruptionHelper$);
var $author$project$InternalAnim$Timeline$currentScheduleTarget = function (_v0) {
	var _v1 = _v0.b;
	var target = _v1.b;
	return target;
};
var $author$project$InternalAnim$Time$rollbackBy$ = function (dur, time) {
	return $author$project$InternalAnim$Quantity$minus$(
		$author$project$InternalAnim$Duration$inMilliseconds(dur),
		time);
};
var $author$project$InternalAnim$Time$rollbackBy = F2($author$project$InternalAnim$Time$rollbackBy$);
var $author$project$InternalAnim$Timeline$getCurrentTime = function (_v0) {
	var timeline = _v0;
	return $author$project$InternalAnim$Time$rollbackBy$(timeline.delay, timeline.now);
};
var $author$project$InternalAnim$Timeline$previous = function (timeline) {
	var details = timeline;
	return $author$project$InternalAnim$Timeline$foldpAll$(
		$author$project$InternalAnim$Timeline$getCurrentTime(timeline),
		$elm$core$Basics$identity,
		function (_v0) {
			return details.initial;
		},
		F8(
			function (_v1, _v2, target, now, _v3, _v4, future, state) {
				if ($author$project$InternalAnim$Time$thisAfterThat$(
					now,
					$author$project$InternalAnim$Timeline$endTime(target))) {
					if (!future.b) {
						return state;
					} else {
						return $author$project$InternalAnim$Timeline$getEvent(target);
					}
				} else {
					return state;
				}
			}),
		timeline);
};
var $author$project$InternalAnim$Duration$scale$ = function (factor, _v0) {
	var seconds = _v0;
	return factor * seconds;
};
var $author$project$InternalAnim$Duration$scale = F2($author$project$InternalAnim$Duration$scale$);
var $author$project$InternalAnim$Timeline$scaleScheduleDurationBy$ = function (factor, _v0) {
	var currentScheduleDelay = _v0.a;
	var _v1 = _v0.b;
	var dur = _v1.a;
	var checkpoint = _v1.b;
	var dwell = _v1.c;
	var events = _v0.c;
	return $author$project$InternalAnim$Timeline$Schedule$(
		currentScheduleDelay,
		$author$project$InternalAnim$Timeline$Event$(
			$author$project$InternalAnim$Duration$scale$(factor, dur),
			checkpoint,
			dwell),
		events);
};
var $author$project$InternalAnim$Timeline$scaleScheduleDurationBy = F2($author$project$InternalAnim$Timeline$scaleScheduleDurationBy$);
var $author$project$InternalAnim$Timeline$Dwelling = function (a) {
	return {$: 0, a: a};
};
var $author$project$InternalAnim$Timeline$Transitioning = function (a) {
	return {$: 1, a: a};
};
var $author$project$InternalAnim$Timeline$status = function (timeline) {
	return $author$project$InternalAnim$Timeline$foldpAll$(
		$author$project$InternalAnim$Timeline$getCurrentTime(timeline),
		$elm$core$Basics$identity,
		function (_v0) {
			return $author$project$InternalAnim$Timeline$Dwelling($author$project$InternalAnim$Time$zeroDuration);
		},
		F8(
			function (_v1, prev, target, now, start, end, theFuture, found) {
				var startTimeTarget = $author$project$InternalAnim$Timeline$startTime(target);
				if ($author$project$InternalAnim$Time$thisAfterThat$(now, startTimeTarget)) {
					return $author$project$InternalAnim$Timeline$Dwelling(
						$author$project$InternalAnim$Time$duration$(now, startTimeTarget));
				} else {
					if (found.$ === 1) {
						var trans = found.a;
						return $author$project$InternalAnim$Timeline$Transitioning(
							{
								progress: $author$project$InternalAnim$Time$progress$(start, startTimeTarget, now),
								transitionProgress: A2($elm$core$List$cons, trans.progress, trans.transitionProgress)
							});
					} else {
						return $author$project$InternalAnim$Timeline$Transitioning(
							{
								progress: $author$project$InternalAnim$Time$progress$(start, startTimeTarget, now),
								transitionProgress: _List_Nil
							});
					}
				}
			}),
		timeline);
};
var $author$project$InternalAnim$Timeline$transitionProgress = function (timeline) {
	var _v0 = $author$project$InternalAnim$Timeline$status(timeline);
	if (!_v0.$) {
		return _List_Nil;
	} else {
		var t = _v0.a;
		return A2($elm$core$List$cons, t.progress, t.transitionProgress);
	}
};
var $author$project$InternalAnim$Timeline$applyInterruptions = function (timeline) {
	var discountInterruption = F2(
		function (schedule, discounted) {
			if ($author$project$InternalAnim$Duration$isZero(
				$author$project$InternalAnim$Timeline$scheduleDelay(schedule)) && _Utils_eq(
				$author$project$InternalAnim$Timeline$previous(timeline),
				$author$project$InternalAnim$Timeline$currentScheduleTarget(schedule))) {
				var maxProgress = $elm$core$Maybe$withDefault$(
					1,
					$elm$core$List$maximum(
						$author$project$InternalAnim$Timeline$transitionProgress(timeline)));
				return A2(
					$elm$core$List$cons,
					$author$project$InternalAnim$Timeline$scaleScheduleDurationBy$(maxProgress, schedule),
					discounted);
			} else {
				return A2($elm$core$List$cons, schedule, discounted);
			}
		});
	var _v0 = $elm$core$List$foldl$(discountInterruption, _List_Nil, timeline.interruption);
	if (!_v0.b) {
		return timeline;
	} else {
		var interruptions = _v0;
		return $author$project$InternalAnim$Timeline$applyInterruptionHelper$(
			interruptions,
			_Utils_update(
				timeline,
				{interruption: _List_Nil, updatedAt: timeline.now}));
	}
};
var $author$project$InternalAnim$Timeline$applyQueued = function (timeline) {
	var _v0 = timeline.queued;
	if (_v0.$ === 1) {
		return timeline;
	} else {
		var queued = _v0.a;
		return _Utils_update(
			timeline,
			{
				events: (timeline.scale === 1) ? $author$project$InternalAnim$Timeline$enqueue$(timeline, timeline.now, queued) : $author$project$InternalAnim$Timeline$enqueue$(
					timeline,
					timeline.now,
					$author$project$InternalAnim$Timeline$scaleSchedule$(timeline.scale, queued)),
				queued: $elm$core$Maybe$Nothing,
				updatedAt: timeline.now
			});
	}
};
var $author$project$InternalAnim$Timeline$dwellingAt$ = function (now, event) {
	var eventStartTime = $author$project$InternalAnim$Timeline$startTime(event);
	var eventEndTime = $author$project$InternalAnim$Timeline$endTime(event);
	return $author$project$InternalAnim$Time$thisAfterOrEqualThat$(now, eventStartTime) && $author$project$InternalAnim$Time$thisBeforeOrEqualThat$(now, eventEndTime);
};
var $author$project$InternalAnim$Timeline$dwellingAt = F2($author$project$InternalAnim$Timeline$dwellingAt$);
var $author$project$InternalAnim$Timeline$Captured = function (a) {
	return {$: 0, a: a};
};
var $author$project$InternalAnim$Timeline$NothingCaptured = {$: 1};
var $author$project$InternalAnim$Timeline$hewLine$ = function (lineOriginalStartingTime, now, maybePrevious, events) {
	hewLine:
	while (true) {
		if (!events.b) {
			return $author$project$InternalAnim$Timeline$NothingCaptured;
		} else {
			var top = events.a;
			var remaining = events.b;
			if ($author$project$InternalAnim$Timeline$dwellingAt$(now, top)) {
				if (maybePrevious.$ === 1) {
					return $author$project$InternalAnim$Timeline$NothingCaptured;
				} else {
					var prev = maybePrevious.a;
					return $author$project$InternalAnim$Timeline$Captured(
						$author$project$InternalAnim$Timeline$Line$(
							lineOriginalStartingTime,
							prev,
							A2($elm$core$List$cons, top, remaining)));
				}
			} else {
				if ($author$project$InternalAnim$Time$thisAfterThat$(
					now,
					$author$project$InternalAnim$Timeline$endTime(top))) {
					var $temp$maybePrevious = $elm$core$Maybe$Just(top),
						$temp$events = remaining;
					maybePrevious = $temp$maybePrevious;
					events = $temp$events;
					continue hewLine;
				} else {
					return $author$project$InternalAnim$Timeline$NothingCaptured;
				}
			}
		}
	}
};
var $author$project$InternalAnim$Timeline$hewLine = F4($author$project$InternalAnim$Timeline$hewLine$);
var $author$project$InternalAnim$Timeline$garbageCollectOldEvents$ = function (now, droppable, lines) {
	garbageCollectOldEvents:
	while (true) {
		if (!lines.b) {
			return $elm$core$List$reverse(droppable);
		} else {
			var topLine = lines.a;
			var startAt = topLine.a;
			var startingEvent = topLine.b;
			var events = topLine.c;
			var remaining = lines.b;
			if ($author$project$InternalAnim$Time$thisAfterThat$(startAt, now)) {
				return _Utils_ap(
					$elm$core$List$reverse(droppable),
					lines);
			} else {
				if ($author$project$InternalAnim$Timeline$dwellingAt$(now, startingEvent)) {
					return lines;
				} else {
					var maybeInterruptionTime = $elm$core$Maybe$map$(
						$author$project$InternalAnim$Timeline$lineStartTime,
						$elm$core$List$head(remaining));
					var interrupted = function () {
						if (maybeInterruptionTime.$ === 1) {
							return false;
						} else {
							var interruptionTime = maybeInterruptionTime.a;
							return $author$project$InternalAnim$Time$thisAfterThat$(now, interruptionTime);
						}
					}();
					if (interrupted) {
						var $temp$droppable = A2($elm$core$List$cons, topLine, droppable),
							$temp$lines = remaining;
						droppable = $temp$droppable;
						lines = $temp$lines;
						continue garbageCollectOldEvents;
					} else {
						var _v1 = $author$project$InternalAnim$Timeline$hewLine$(
							startAt,
							now,
							$elm$core$Maybe$Nothing,
							A2($elm$core$List$cons, startingEvent, events));
						if (_v1.$ === 1) {
							return _Utils_ap(
								$elm$core$List$reverse(droppable),
								lines);
						} else {
							var capturedLine = _v1.a;
							return A2($elm$core$List$cons, capturedLine, remaining);
						}
					}
				}
			}
		}
	}
};
var $author$project$InternalAnim$Timeline$garbageCollectOldEvents = F3($author$project$InternalAnim$Timeline$garbageCollectOldEvents$);
var $author$project$InternalAnim$Timeline$linesAreActive$ = function (now, lines) {
	linesAreActive:
	while (true) {
		if (!lines.b) {
			return false;
		} else {
			var _v1 = lines.a;
			var startAt = _v1.a;
			var startingEvent = _v1.b;
			var events = _v1.c;
			var remaining = lines.b;
			if ($author$project$InternalAnim$Time$thisAfterOrEqualThat$(startAt, now)) {
				return true;
			} else {
				var maybeInterruption = function () {
					var _v5 = $elm$core$List$head(remaining);
					if (_v5.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var _v6 = _v5.a;
						var interruptionTime = _v6.a;
						return $elm$core$Maybe$Just(interruptionTime);
					}
				}();
				var last = $elm$core$Maybe$withDefault$(
					startingEvent,
					$elm$core$List$head(
						$elm$core$List$reverse(events)));
				if (!maybeInterruption.$) {
					var interruptTime = maybeInterruption.a;
					if ($author$project$InternalAnim$Time$thisAfterOrEqualThat$(interruptTime, now)) {
						return true;
					} else {
						var time = last.b;
						if ($author$project$InternalAnim$Time$thisAfterOrEqualThat$(time, now)) {
							return true;
						} else {
							var $temp$lines = remaining;
							lines = $temp$lines;
							continue linesAreActive;
						}
					}
				} else {
					var time = last.b;
					if ($author$project$InternalAnim$Time$thisAfterOrEqualThat$(time, now)) {
						return true;
					} else {
						var $temp$lines = remaining;
						lines = $temp$lines;
						continue linesAreActive;
					}
				}
			}
		}
	}
};
var $author$project$InternalAnim$Timeline$linesAreActive = F2($author$project$InternalAnim$Timeline$linesAreActive$);
var $author$project$InternalAnim$Timeline$clean$ = function (runGC, details) {
	var running = function () {
		var _v1 = details.events;
		var lines = _v1;
		return $author$project$InternalAnim$Timeline$linesAreActive$(details.now, lines);
	}();
	return _Utils_update(
		details,
		{
			events: function () {
				if (runGC) {
					var events = function () {
						var _v0 = details.events;
						var evs = _v0;
						return evs;
					}();
					return $author$project$InternalAnim$Timeline$garbageCollectOldEvents$(details.now, _List_Nil, events);
				} else {
					return details.events;
				}
			}(),
			running: running
		});
};
var $author$project$InternalAnim$Timeline$clean = F2($author$project$InternalAnim$Timeline$clean$);
var $author$project$InternalAnim$Quantity$max$ = function (_v0, _v1) {
	var x = _v0;
	var y = _v1;
	return $elm$core$Basics$max$(x, y);
};
var $author$project$InternalAnim$Quantity$max = F2($author$project$InternalAnim$Quantity$max$);
var $author$project$InternalAnim$Timeline$updateWith$ = function (withGC, possiblyNow, _v0) {
	var timeline = _v0;
	var now = $author$project$InternalAnim$Quantity$max$(
		$author$project$InternalAnim$Time$absolute(possiblyNow),
		timeline.now);
	return $author$project$InternalAnim$Timeline$clean$(
		withGC,
		$author$project$InternalAnim$Timeline$applyInterruptions(
			$author$project$InternalAnim$Timeline$applyQueued(
				_Utils_update(
					timeline,
					{now: now}))));
};
var $author$project$InternalAnim$Timeline$updateWith = F3($author$project$InternalAnim$Timeline$updateWith$);
var $author$project$InternalAnim$Timeline$update$ = function (time, tl) {
	return $author$project$InternalAnim$Timeline$updateWith$(true, time, tl);
};
var $author$project$InternalAnim$Timeline$update = F2($author$project$InternalAnim$Timeline$update$);
var $author$project$Animator$Timeline$update = $author$project$InternalAnim$Timeline$update;
var $author$project$Ui$Anim$transitionWithTrigger$ = function (trigger, dur, attrs) {
	return $author$project$Ui$Anim$toAttr$(
		trigger,
		$author$project$Animator$css$(
			A2(
				$author$project$Animator$Timeline$update,
				$elm$time$Time$millisToPosix(1),
				$author$project$Animator$Timeline$to$(
					dur,
					attrs,
					$author$project$Animator$Timeline$init(_List_Nil))),
			function (animated) {
				return _Utils_Tuple2(animated, _List_Nil);
			}));
};
var $author$project$Ui$Anim$transitionWithTrigger = F3($author$project$Ui$Anim$transitionWithTrigger$);
var $author$project$Ui$Anim$hovered$ = function (dur, attrs) {
	return $author$project$Ui$Anim$transitionWithTrigger$(0, dur, attrs);
};
var $author$project$Ui$Anim$hovered = F2($author$project$Ui$Anim$hovered$);
var $author$project$Animator$ms = $author$project$InternalAnim$Duration$milliseconds;
var $author$project$Ui$Anim$ms = $author$project$Animator$ms;
var $author$project$MyUi$hover$ = function (isMobile2, animated) {
	return isMobile2 ? $author$project$Ui$noAttr : $author$project$Ui$Anim$hovered$(
		$author$project$Ui$Anim$ms(10),
		animated);
};
var $author$project$MyUi$hover = F2($author$project$MyUi$hover$);
var $author$project$Ui$rgba$ = function (r, g, b, a) {
	return $avh4$elm_color$Color$rgba$(r / 255, g / 255, b / 255, a);
};
var $author$project$Ui$rgba = F4($author$project$Ui$rgba$);
var $author$project$MyUi$hoverHighlight = $author$project$Ui$rgba$(255, 255, 255, 0.17);
var $author$project$Ui$html = function (x) {
	return function (_v0) {
		return x;
	};
};
var $author$project$Internal$Model2$style$ = function (name, val) {
	return {
		attr: {
			additionalInheritance: $author$project$Internal$BitField$none,
			attrs: _List_Nil,
			_class: $elm$core$Maybe$Nothing,
			nearby: $elm$core$Maybe$Nothing,
			node: $author$project$Internal$Model2$NodeAsDiv,
			styles: F2(
				function (_v0, _v1) {
					return _List_fromArray(
						[
							_Utils_Tuple2(name, val)
						]);
				})
		},
		flag: $author$project$Internal$Flag$skip
	};
};
var $author$project$Internal$Model2$style = F2($author$project$Internal$Model2$style$);
var $author$project$Ui$paddingXY$ = function (x, y) {
	return $author$project$Internal$Model2$style$(
		'padding',
		($elm$core$String$fromInt(y) + 'px ') + ($elm$core$String$fromInt(x) + 'px'));
};
var $author$project$Ui$paddingXY = F2($author$project$Ui$paddingXY$);
var $author$project$Ui$Px = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$px = $author$project$Ui$Px;
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on$ = function (event, decoder) {
	return A2(
		$elm$virtual_dom$VirtualDom$on,
		event,
		$elm$virtual_dom$VirtualDom$Normal(decoder));
};
var $elm$html$Html$Events$on = F2($elm$html$Html$Events$on$);
var $elm$html$Html$Events$onClick = function (msg) {
	return $elm$html$Html$Events$on$(
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Internal$Model2$onPress = function (msg) {
	return {
		attr: {
			additionalInheritance: $author$project$Internal$BitField$none,
			attrs: _List_fromArray(
				[
					$elm$html$Html$Events$onClick(msg)
				]),
			_class: $elm$core$Maybe$Just($author$project$Internal$Style2$classes.cursorPointer),
			nearby: $elm$core$Maybe$Nothing,
			node: $author$project$Internal$Model2$NodeAsButton,
			styles: $author$project$Internal$Model2$noStyles
		},
		flag: $author$project$Internal$Flag$skip
	};
};
var $author$project$Ui$Input$button = $author$project$Internal$Model2$onPress;
var $author$project$Internal$Model2$attribute = function (a) {
	return {
		attr: {
			additionalInheritance: $author$project$Internal$BitField$none,
			attrs: _List_fromArray(
				[a]),
			_class: $elm$core$Maybe$Nothing,
			nearby: $elm$core$Maybe$Nothing,
			node: $author$project$Internal$Model2$NodeAsDiv,
			styles: $author$project$Internal$Model2$noStyles
		},
		flag: $author$project$Internal$Flag$skip
	};
};
var $elm$html$Html$Attributes$id = _VirtualDom_attribute('id');
var $author$project$Ui$id = function (strId) {
	return $author$project$Internal$Model2$attribute(
		$elm$html$Html$Attributes$id(strId));
};
var $author$project$Internal$Model2$AsRow = 0;
var $author$project$Ui$row$ = function (attrs, children) {
	return $author$project$Internal$Model2$element$(
		$author$project$Internal$Model2$NodeAsDiv,
		0,
		A2(
			$elm$core$List$cons,
			$author$project$Ui$width($author$project$Ui$fill),
			attrs),
		children);
};
var $author$project$Ui$row = F2($author$project$Ui$row$);
var $author$project$MyUi$rowButton$ = function (htmlId, onPress, attributes, content) {
	return $author$project$Ui$row$(
		A2(
			$elm$core$List$cons,
			$author$project$Ui$id(
				$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId)),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Input$button(onPress),
				attributes)),
		content);
};
var $author$project$MyUi$rowButton = F4($author$project$MyUi$rowButton$);
var $author$project$Internal$Model2$styleDynamic$ = function (name, toVal) {
	return {
		attr: {
			additionalInheritance: $author$project$Internal$BitField$none,
			attrs: _List_Nil,
			_class: $elm$core$Maybe$Nothing,
			nearby: $elm$core$Maybe$Nothing,
			node: $author$project$Internal$Model2$NodeAsDiv,
			styles: F2(
				function (inheritance, _v0) {
					return _List_fromArray(
						[
							_Utils_Tuple2(
							name,
							toVal(inheritance))
						]);
				})
		},
		flag: $author$project$Internal$Flag$skip
	};
};
var $author$project$Internal$Model2$styleDynamic = F2($author$project$Internal$Model2$styleDynamic$);
var $author$project$Ui$Font$toFontPixels = function (f) {
	var rem = f / 16;
	return $elm$core$String$fromFloat(rem) + 'rem';
};
var $author$project$Ui$Font$size = function (i) {
	return $author$project$Internal$Model2$styleDynamic$(
		'font-size',
		function (inheritance) {
			var modificationInt = $author$project$Internal$BitField$get$($author$project$Internal$Bits$Inheritance$fontHeight, inheritance);
			var baseSize = i;
			var modification = (modificationInt / 100) * baseSize;
			return $author$project$Ui$Font$toFontPixels(baseSize - modification);
		});
};
var $author$project$Internal$BitField$set$ = function (_v0, unboundedVal, bits) {
	var length = _v0.length;
	var offset = _v0.offset;
	var inverseMask = _v0.inverseMask;
	var val = $elm$core$Basics$min$(
		A2($elm$core$Basics$pow, 2, length) - 1,
		$elm$core$Basics$max$(0, unboundedVal));
	var top = $author$project$Internal$BitField$ones >>> (32 - length);
	return ((top & val) << offset) | (inverseMask & bits);
};
var $author$project$Internal$BitField$set = F3($author$project$Internal$BitField$set$);
var $author$project$Ui$spacing = function (x) {
	return {
		attr: {
			additionalInheritance: $author$project$Internal$BitField$set$(
				$author$project$Internal$Bits$Inheritance$spacingY,
				x,
				$author$project$Internal$BitField$set$($author$project$Internal$Bits$Inheritance$spacingX, x, $author$project$Internal$BitField$none)),
			attrs: _List_Nil,
			_class: $elm$core$Maybe$Nothing,
			nearby: $elm$core$Maybe$Nothing,
			node: $author$project$Internal$Model2$NodeAsDiv,
			styles: F2(
				function (inheritance, _v0) {
					return $author$project$Internal$BitField$has$($author$project$Internal$Bits$Inheritance$isTextLayout, inheritance) ? _List_Nil : _List_fromArray(
						[
							$elm$core$Tuple$pair$(
							'gap',
							$elm$core$String$fromInt(x) + 'px')
						]);
				})
		},
		flag: $author$project$Internal$Flag$spacing
	};
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $author$project$Internal$Model2$textElementClasses = $author$project$Internal$Style2$classes.any + (' ' + $author$project$Internal$Style2$classes.text);
var $author$project$Internal$Model2$text = function (str) {
	return function (encoded) {
		return ((!$author$project$Internal$BitField$has$($author$project$Internal$Bits$Inheritance$isTextLayout, encoded)) || $author$project$Internal$BitField$has$($author$project$Internal$Bits$Inheritance$hasTextModification, encoded)) ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class($author$project$Internal$Model2$textElementClasses)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(str)
				])) : $elm$html$Html$text(str);
	};
};
var $author$project$Ui$text = $author$project$Internal$Model2$text;
var $author$project$MessageMenu$button$ = function (isMobile, htmlId, icon, text, msg) {
	return $author$project$MyUi$rowButton$(
		htmlId,
		msg,
		_List_fromArray(
			[
				$author$project$Ui$spacing(8),
				$author$project$Ui$contentCenterY,
				$author$project$Ui$paddingXY$(8, 0),
				$author$project$Ui$height(
				$author$project$Ui$px(
					$author$project$MessageMenu$buttonHeight(isMobile))),
				$author$project$Ui$attrIf$(
				isMobile,
				$author$project$Ui$Font$size(14)),
				$author$project$MyUi$hover$(
				isMobile,
				_List_fromArray(
					[
						$author$project$Ui$Anim$backgroundColor($author$project$MyUi$hoverHighlight)
					]))
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$width(
						$author$project$Ui$px(24))
					]),
				$author$project$Ui$html(icon)),
				$author$project$Ui$text(text)
			]));
};
var $author$project$MessageMenu$button = F5($author$project$MessageMenu$button$);
var $author$project$LocalState$canDeleteCallMessage$ = function (userId, callStarted) {
	return (!_Utils_eq(callStarted.endedAt, $elm$core$Maybe$Nothing)) && (_Utils_eq(callStarted.startedBy, userId) || $lamdera$containers$SeqSet$member$(userId, callStarted.joinedBy));
};
var $author$project$LocalState$canDeleteCallMessage = F2($author$project$LocalState$canDeleteCallMessage$);
var $author$project$Ui$Font$color = function (fontColor) {
	return $author$project$Internal$Model2$style$(
		'color',
		$author$project$Internal$Style2$color(fontColor));
};
var $author$project$User$canUseEmoji$ = function (availableCustomEmojis, emoji) {
	if (!emoji.$) {
		return true;
	} else {
		var customEmojiId = emoji.a;
		return $lamdera$containers$SeqSet$member$(customEmojiId, availableCustomEmojis);
	}
};
var $author$project$User$canUseEmoji = F2($author$project$User$canUseEmoji$);
var $author$project$Emoji$heart = '❤️';
var $author$project$Emoji$smiley = '😃';
var $author$project$Emoji$thumbsUp = '👍';
var $author$project$User$commonlyUsedEmojis$ = function (availableCustomEmojis, user) {
	return A2(
		$elm$core$List$sortBy,
		function (_v0) {
			var count = _v0.b;
			return -count;
		},
		$lamdera$containers$SeqDict$toList(
			$elm$core$Array$foldl$(
				F2(
					function (emoji, dict) {
						return $author$project$User$canUseEmoji$(availableCustomEmojis, emoji) ? $lamdera$containers$SeqDict$update$(
							emoji,
							function (maybe) {
								return $elm$core$Maybe$Just(
									1 + $elm$core$Maybe$withDefault$(0, maybe));
							},
							dict) : dict;
					}),
				$lamdera$containers$SeqDict$fromList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Emoji$EmojiOrCustomEmoji_Emoji($author$project$Emoji$heart),
							0),
							_Utils_Tuple2(
							$author$project$Emoji$EmojiOrCustomEmoji_Emoji($author$project$Emoji$thumbsUp),
							0),
							_Utils_Tuple2(
							$author$project$Emoji$EmojiOrCustomEmoji_Emoji($author$project$Emoji$smiley),
							0)
						])),
				user.emojiConfig.lastUsedEmojis)));
};
var $author$project$User$commonlyUsedEmojis = F2($author$project$User$commonlyUsedEmojis$);
var $author$project$Ui$contentCenterX = $author$project$Internal$Model2$classWith$($author$project$Internal$Flag$xContentAlign, $author$project$Internal$Style2$classes.contentCenterX);
var $author$project$Icons$copyIcon = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$fill('currentColor')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M7.5 3.375c0-1.036.84-1.875 1.875-1.875h.375a3.75 3.75 0 0 1 3.75 3.75v1.875C13.5 8.161 14.34 9 15.375 9h1.875A3.75 3.75 0 0 1 21 12.75v3.375C21 17.16 20.16 18 19.125 18h-9.75A1.875 1.875 0 0 1 7.5 16.125V3.375Z')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M15 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 17.25 7.5h-1.875A.375.375 0 0 1 15 7.125V5.25ZM4.875 6H6v10.125A3.375 3.375 0 0 0 9.375 19.5H16.5v1.125c0 1.035-.84 1.875-1.875 1.875h-9.75A1.875 1.875 0 0 1 3 20.625V7.875C3 6.839 3.84 6 4.875 6Z')
				]),
			_List_Nil)
		]));
var $author$project$Types$PressedCopyImage = function (a) {
	return {$: 34, a: a};
};
var $author$project$Icons$image = function (width) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$viewBox('0 4 24 16'),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromInt(width)),
				$elm$svg$Svg$Attributes$strokeWidth('1.5'),
				$elm$svg$Svg$Attributes$stroke('currentColor')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$d('m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z')
					]),
				_List_Nil)
			]));
};
var $author$project$MessageMenu$copyImageButton$ = function (isMobile, imageUrl, lastCopied) {
	return A2($elm$core$String$startsWith, $author$project$Env$domain, imageUrl) ? $author$project$MessageMenu$ButtonItem(
		$author$project$MessageMenu$button$(
			isMobile,
			$lamdera$program_test$Effect$Browser$Dom$id('messageMenu_copyImage'),
			$author$project$Icons$image(22),
			function () {
				if (!lastCopied.$) {
					var lastCopied2 = lastCopied.a;
					return _Utils_eq(
						lastCopied2.copied,
						$author$project$MyUi$CopiedImage(imageUrl)) ? 'Copied!' : 'Copy image';
				} else {
					return 'Copy image';
				}
			}(),
			$author$project$Types$PressedCopyImage(imageUrl))) : $author$project$MessageMenu$NoItem;
};
var $author$project$MessageMenu$copyImageButton = F3($author$project$MessageMenu$copyImageButton$);
var $author$project$Icons$link = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor'),
			$elm$svg$Svg$Attributes$width('20')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244')
				]),
			_List_Nil)
		]));
var $author$project$MessageMenu$copyImageLinkButton$ = function (isMobile, imageUrl, lastCopied) {
	return $author$project$MessageMenu$button$(
		isMobile,
		$lamdera$program_test$Effect$Browser$Dom$id('messageMenu_copyImageLink'),
		$author$project$Icons$link,
		function () {
			if (!lastCopied.$) {
				var lastCopied2 = lastCopied.a;
				return _Utils_eq(
					lastCopied2.copied,
					$author$project$MyUi$CopiedText(imageUrl)) ? 'Copied!' : 'Copy image link';
			} else {
				return 'Copy image link';
			}
		}(),
		$author$project$Types$PressedCopyText(imageUrl));
};
var $author$project$MessageMenu$copyImageLinkButton = F3($author$project$MessageMenu$copyImageLinkButton$);
var $author$project$MessageMenu$copyLinkButton$ = function (isMobile, linkUrl, lastCopied) {
	return $author$project$MessageMenu$button$(
		isMobile,
		$lamdera$program_test$Effect$Browser$Dom$id('messageMenu_copyLink'),
		$author$project$Icons$link,
		function () {
			if (!lastCopied.$) {
				var lastCopied2 = lastCopied.a;
				return _Utils_eq(
					lastCopied2.copied,
					$author$project$MyUi$CopiedText(linkUrl)) ? 'Copied!' : 'Copy link';
			} else {
				return 'Copy link';
			}
		}(),
		$author$project$Types$PressedCopyText(linkUrl));
};
var $author$project$MessageMenu$copyLinkButton = F3($author$project$MessageMenu$copyLinkButton$);
var $author$project$Icons$delete = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor'),
			$elm$svg$Svg$Attributes$width('24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0')
				]),
			_List_Nil)
		]));
var $author$project$LocalState$discordDmChannelWithUser$ = function (otherUserId, local) {
	return $elmcraft$core_extra$List$Extra$findMap$(
		function (_v0) {
			var channelId = _v0.a;
			var channel = _v0.b;
			return (($author$project$NonemptyDict$size(channel.members) === 2) && $author$project$NonemptyDict$member$(otherUserId, channel.members)) ? $elmcraft$core_extra$List$Extra$findMap$(
				function (currentUserId) {
					return ((!_Utils_eq(currentUserId, otherUserId)) && $author$project$NonemptyDict$member$(currentUserId, channel.members)) ? $elm$core$Maybe$Just(
						_Utils_Tuple2(currentUserId, channelId)) : $elm$core$Maybe$Nothing;
				},
				$lamdera$containers$SeqDict$keys(
					$author$project$LinkedAndOtherDiscordUsers$linkedUsers(local.localUser.discordUsers))) : $elm$core$Maybe$Nothing;
		},
		$lamdera$containers$SeqDict$toList(local.discordDmChannels));
};
var $author$project$LocalState$discordDmChannelWithUser = F2($author$project$LocalState$discordDmChannelWithUser$);
var $author$project$MessageMenu$editMessageText = 'Edit message';
var $author$project$MyUi$elButton$ = function (htmlId, onPress, attributes, content) {
	return $author$project$Ui$el$(
		A2(
			$elm$core$List$cons,
			$author$project$Ui$id(
				$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId)),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Input$button(onPress),
				attributes)),
		content);
};
var $author$project$MyUi$elButton = F4($author$project$MyUi$elButton$);
var $author$project$MyUi$errorColor = $author$project$Ui$rgb$(240, 170, 180);
var $elm$svg$Svg$Attributes$clipRule = _VirtualDom_attribute('clip-rule');
var $elm$svg$Svg$Attributes$fillRule = _VirtualDom_attribute('fill-rule');
var $author$project$Icons$hashtag = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$width('20'),
			$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
			$elm$svg$Svg$Attributes$fill('currentColor')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$d('M7.487 2.89a.75.75 0 1 0-1.474-.28l-.455 2.388H3.61a.75.75 0 0 0 0 1.5h1.663l-.571 2.998H2.75a.75.75 0 0 0 0 1.5h1.666l-.403 2.114a.75.75 0 0 0 1.474.28l.456-2.394h2.973l-.403 2.114a.75.75 0 0 0 1.474.28l.456-2.394h1.947a.75.75 0 0 0 0-1.5h-1.661l.57-2.998h1.95a.75.75 0 0 0 0-1.5h-1.664l.402-2.108a.75.75 0 0 0-1.474-.28l-.455 2.388H7.085l.402-2.108ZM6.8 6.498l-.571 2.998h2.973l.57-2.998H6.8Z'),
					$elm$svg$Svg$Attributes$clipRule('evenodd')
				]),
			_List_Nil)
		]));
var $author$project$MessageMenu$horizontalLineHeight = 16;
var $author$project$Internal$Model2$none = function (_v0) {
	return $elm$html$Html$text('');
};
var $author$project$Ui$none = $author$project$Internal$Model2$none;
var $author$project$MessageMenu$horizontalLine = $author$project$Ui$el$(
	_List_fromArray(
		[
			$author$project$Ui$height(
			$author$project$Ui$px($author$project$MessageMenu$horizontalLineHeight)),
			$author$project$Ui$contentCenterY,
			$author$project$Ui$paddingXY$(8, 0)
		]),
	$author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$height(
				$author$project$Ui$px(1)),
				$author$project$Ui$background($author$project$MyUi$border1)
			]),
		$author$project$Ui$none));
var $author$project$MessageMenu$menuItemsHelper$ = function (isMobile, a) {
	return function (_v2) {
		var height = _v2.height;
		var items = _v2.items;
		return {
			height: height,
			items: $elm$core$List$reverse(items)
		};
	}(
		$elm$core$List$foldl$(
			F2(
				function (item, _v0) {
					var height = _v0.height;
					var items = _v0.items;
					switch (item.$) {
						case 0:
							return {height: height, items: items};
						case 2:
							return isMobile ? {height: height, items: items} : {
								height: height + $author$project$MessageMenu$horizontalLineHeight,
								items: A2($elm$core$List$cons, $author$project$MessageMenu$horizontalLine, items)
							};
						case 1:
							var element = item.a;
							return {
								height: height + $author$project$MessageMenu$buttonHeight(isMobile),
								items: A2($elm$core$List$cons, element, items)
							};
						default:
							var groupItems = item.a;
							var b = $author$project$MessageMenu$menuItemsHelper$(isMobile, groupItems);
							return {
								height: height + b.height,
								items: _Utils_ap(
									$elm$core$List$reverse(b.items),
									items)
							};
					}
				}),
			{height: 0, items: _List_Nil},
			a));
};
var $author$project$MessageMenu$menuItemsHelper = F2($author$project$MessageMenu$menuItemsHelper$);
var $author$project$RichText$customEmojis = function (nonempty) {
	return $elm$core$List$concatMap$(
		function (richText) {
			switch (richText.$) {
				case 10:
					return _List_Nil;
				case 11:
					return _List_Nil;
				case 0:
					return _List_Nil;
				case 1:
					return _List_Nil;
				case 2:
					return _List_Nil;
				case 3:
					var nonempty2 = richText.a;
					return $author$project$RichText$customEmojis(nonempty2);
				case 4:
					var nonempty2 = richText.a;
					return $author$project$RichText$customEmojis(nonempty2);
				case 5:
					var nonempty2 = richText.a;
					return $author$project$RichText$customEmojis(nonempty2);
				case 6:
					var nonempty2 = richText.a;
					return $author$project$RichText$customEmojis(nonempty2);
				case 7:
					var nonempty2 = richText.a;
					return $author$project$RichText$customEmojis(nonempty2);
				case 8:
					var list = richText.b;
					return $elm$core$Maybe$withDefault$(
						_List_Nil,
						$elm$core$Maybe$map$(
							$author$project$RichText$customEmojis,
							$mgold$elm_nonempty_list$List$Nonempty$fromList(list)));
				case 9:
					var nonempty2 = richText.c;
					return $author$project$RichText$customEmojis(nonempty2);
				case 12:
					return _List_Nil;
				case 13:
					return _List_Nil;
				case 14:
					return _List_Nil;
				case 15:
					return _List_Nil;
				case 16:
					return _List_Nil;
				case 17:
					var customEmojiId = richText.a;
					return _List_fromArray(
						[customEmojiId]);
				case 18:
					var items = richText.b;
					return $elm$core$List$concatMap$(
						$author$project$RichText$bulletItemConcatMap($author$project$RichText$customEmojis),
						$mgold$elm_nonempty_list$List$Nonempty$toList(items));
				default:
					return _List_Nil;
			}
		},
		$mgold$elm_nonempty_list$List$Nonempty$toList(nonempty));
};
var $author$project$MessageMenu$messageCustomEmojiIds = function (message) {
	var reactionIds = function (reactions) {
		return $elm$core$List$filterMap$(
			function (emoji) {
				if (emoji.$ === 1) {
					var id = emoji.a;
					return $elm$core$Maybe$Just(id);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			$lamdera$containers$SeqDict$keys(reactions));
	};
	switch (message.$) {
		case 0:
			var data = message.a;
			return _Utils_ap(
				$author$project$RichText$customEmojis(data.content.content),
				reactionIds(data.reactions));
		case 1:
			var data = message.a;
			return reactionIds(data.reactions);
		case 2:
			var reactions = message.c;
			return reactionIds(reactions);
		case 3:
			return _List_Nil;
		case 4:
			var reactions = message.a.reactions;
			return reactionIds(reactions);
		default:
			var reactions = message.a.reactions;
			return reactionIds(reactions);
	}
};
var $author$project$Ui$htmlAttribute = function (a) {
	return $author$project$Internal$Model2$attribute(a);
};
var $author$project$MyUi$htmlStyle$ = function (name, value) {
	return $author$project$Ui$htmlAttribute(
		A2($elm$html$Html$Attributes$style, name, value));
};
var $author$project$MyUi$htmlStyle = F2($author$project$MyUi$htmlStyle$);
var $author$project$MyUi$noShrinking = $author$project$MyUi$htmlStyle$('flex-shrink', '0');
var $author$project$Icons$pencil = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$fill('currentColor'),
			$elm$svg$Svg$Attributes$width('24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-12.15 12.15a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32L19.513 8.2Z')
				]),
			_List_Nil)
		]));
var $author$project$Icons$person = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$fill('currentColor')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$d('M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z'),
					$elm$svg$Svg$Attributes$clipRule('evenodd')
				]),
			_List_Nil)
		]));
var $author$project$Icons$plusIcon = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$fill('currentColor')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$d('M12 5.25a.75.75 0 0 1 .75.75v5.25H18a.75.75 0 0 1 0 1.5h-5.25V18a.75.75 0 0 1-1.5 0v-5.25H6a.75.75 0 0 1 0-1.5h5.25V6a.75.75 0 0 1 .75-.75Z'),
					$elm$svg$Svg$Attributes$clipRule('evenodd')
				]),
			_List_Nil)
		]));
var $author$project$Sticker$LoopAFewTimesOnLoad = 0;
var $author$project$Emoji$artStartingWith$ = function (emojiData, text) {
	var _v0 = $elm$core$String$uncons(text);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var firstCharacter = _v1.a;
		var _v2 = $elm$core$Dict$get$(firstCharacter, emojiData.art);
		if (!_v2.$) {
			var candidates = _v2.a;
			return $elm$core$Array$foldl$(
				F2(
					function (art, value) {
						if (!value.$) {
							return value;
						} else {
							return A2($elm$core$String$startsWith, art.sequence, text) ? $elm$core$Maybe$Just(art) : $elm$core$Maybe$Nothing;
						}
					}),
				$elm$core$Maybe$Nothing,
				candidates);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Emoji$artStartingWith = F2($author$project$Emoji$artStartingWith$);
var $author$project$Twemoji$variationSelector = 65039;
var $author$project$Twemoji$zeroWidthJoiner = 8205;
var $author$project$Twemoji$fileName = function (emoji) {
	var codePoints = $elm$core$List$map$(
		$elm$core$Char$toCode,
		$elm$core$String$toList(emoji));
	return $elm$core$String$join$(
		'-',
		$elm$core$List$map$(
			$rtfeldman$elm_hex$Hex$toString,
			$elm$core$List$member$($author$project$Twemoji$zeroWidthJoiner, codePoints) ? codePoints : $elm$core$List$filter$(
				function (codePoint) {
					return !_Utils_eq(codePoint, $author$project$Twemoji$variationSelector);
				},
				codePoints)));
};
var $author$project$Twemoji$spriteReference$ = function (sprite, emoji) {
	return '/cacheable/emoji/' + (sprite + ('.svg#e' + $author$project$Twemoji$fileName(emoji)));
};
var $author$project$Twemoji$spriteReference = F2($author$project$Twemoji$spriteReference$);
var $elm$svg$Svg$use = $elm$svg$Svg$trustedNode('use');
var $elm$svg$Svg$Attributes$xlinkHref = function (value) {
	return A3(
		_VirtualDom_attributeNS,
		'http://www.w3.org/1999/xlink',
		'xlink:href',
		_VirtualDom_noJavaScriptUri(value));
};
var $author$project$Twemoji$spriteView$ = function (size, sprite, emoji) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'inline-block')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('emoji-characters'),
						A2($elm$html$Html$Attributes$style, 'position', 'relative'),
						A2($elm$html$Html$Attributes$style, 'display', 'inline-block'),
						A2($elm$html$Html$Attributes$style, 'width', size),
						A2($elm$html$Html$Attributes$style, 'height', size),
						A2($elm$html$Html$Attributes$style, 'line-height', size),
						A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
						A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
						A2($elm$html$Html$Attributes$style, 'vertical-align', 'calc(0.375em - ' + (size + ' / 2)'))
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$svg,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$viewBox('0 0 36 36'),
								A2($elm$html$Html$Attributes$style, 'position', 'relative'),
								A2($elm$html$Html$Attributes$style, 'vertical-align', 'top'),
								A2($elm$html$Html$Attributes$style, 'margin-right', '-' + size),
								A2($elm$html$Html$Attributes$style, 'width', size),
								A2($elm$html$Html$Attributes$style, 'height', size),
								A2($elm$html$Html$Attributes$style, 'pointer-events', 'none')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$use,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$xlinkHref(
										$author$project$Twemoji$spriteReference$(sprite, emoji))
									]),
								_List_Nil)
							])),
						$elm$html$Html$text(emoji)
					]))
			]));
};
var $author$project$Twemoji$spriteView = F3($author$project$Twemoji$spriteView$);
var $author$project$Emoji$sequenceView$ = function (size, emojiData, sequence) {
	var _v0 = $author$project$Emoji$artStartingWith$(emojiData, sequence);
	if (!_v0.$) {
		var art = _v0.a;
		return $author$project$Twemoji$spriteView$(size, art.sprite, art.sequence);
	} else {
		return $elm$html$Html$text(sequence);
	}
};
var $author$project$Emoji$sequenceView = F3($author$project$Emoji$sequenceView$);
var $author$project$Emoji$unicodeView$ = function (size, maybeEmojiData, _v0) {
	var emoji = _v0;
	if (!maybeEmojiData.$) {
		var emojiData = maybeEmojiData.a;
		return $author$project$Emoji$sequenceView$(size, emojiData, emoji);
	} else {
		return $elm$html$Html$text(emoji);
	}
};
var $author$project$Emoji$unicodeView = F3($author$project$Emoji$unicodeView$);
var $author$project$CustomEmoji$placeholder$ = function (emojiSize, yOffset) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'width', emojiSize),
				A2($elm$html$Html$Attributes$style, 'height', emojiSize),
				A2($elm$html$Html$Attributes$style, 'display', 'inline-block'),
				A2($elm$html$Html$Attributes$style, 'background-color', 'gray'),
				A2($elm$html$Html$Attributes$style, 'transform', 'translateY(' + (yOffset + ')'))
			]),
		_List_Nil);
};
var $author$project$CustomEmoji$placeholder = F2($author$project$CustomEmoji$placeholder$);
var $author$project$Sticker$animationModeToInt = function (animationMode) {
	switch (animationMode) {
		case 0:
			return '0';
		case 1:
			return '1';
		default:
			return '2';
	}
};
var $elm$virtual_dom$VirtualDom$attribute$ = function (key, value) {
	return A2(
		_VirtualDom_attribute,
		_VirtualDom_noOnOrFormAction(key),
		_VirtualDom_noJavaScriptOrHtmlUri(value));
};
var $elm$virtual_dom$VirtualDom$attribute = F2($elm$virtual_dom$VirtualDom$attribute$);
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $author$project$Sticker$animatedImageView$ = function (isInline, width, height, yOffset, url, animationMode) {
	return A3(
		$elm$html$Html$node,
		'animated-image-player',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', width),
					A2($elm$html$Html$Attributes$style, 'height', height),
					A2($elm$html$Html$Attributes$attribute, 'src', url),
					A2($elm$html$Html$Attributes$attribute, 'data-image-url', url),
					A2($elm$html$Html$Attributes$style, 'display', 'block'),
					A2(
					$elm$html$Html$Attributes$attribute,
					'start-playing',
					$author$project$Sticker$animationModeToInt(animationMode)),
					A2(
					$elm$html$Html$Attributes$style,
					'background-color',
					$author$project$Env$isProduction ? 'transparent' : 'rgba(0,0,0,0.1)')
				]),
			_Utils_ap(
				function () {
					if (!yOffset.$) {
						var yOffset2 = yOffset.a;
						return _List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'transform', 'translateY(' + (yOffset2 + ')'))
							]);
					} else {
						return _List_Nil;
					}
				}(),
				isInline ? _List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'display', 'inline-block')
					]) : _List_Nil)),
		_List_Nil);
};
var $author$project$Sticker$animatedImageView = F6($author$project$Sticker$animatedImageView$);
var $author$project$FileStatus$fileUrl$ = function (_v0, _v1) {
	var contentType2 = _v0;
	var fileHash2 = _v1;
	return $author$project$FileStatus$domain + ('/file/' + ($elm$core$String$fromInt(contentType2) + ('/' + fileHash2)));
};
var $author$project$FileStatus$fileUrl = F2($author$project$FileStatus$fileUrl$);
var $author$project$FileStatus$gifContent = $author$project$FileStatus$contentType('image/gif');
var $author$project$MyUi$lazyLoading = A2($elm$html$Html$Attributes$attribute, 'loading', 'lazy');
var $author$project$FileStatus$pngContent = $author$project$FileStatus$contentType('image/png');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		_VirtualDom_attribute,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$CustomEmoji$viewHelper$ = function (emojiSize, yOffset, customEmoji, animationMode) {
	var _v0 = customEmoji.url;
	if (_v0.$ === 1) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', emojiSize),
					A2($elm$html$Html$Attributes$style, 'height', emojiSize),
					A2($elm$html$Html$Attributes$style, 'background-color', 'gray'),
					A2($elm$html$Html$Attributes$style, 'display', 'inline-block'),
					A2($elm$html$Html$Attributes$style, 'transform', 'translateY(' + (yOffset + ')'))
				]),
			_List_Nil);
	} else {
		var fileHash = _v0.a;
		return customEmoji.isAnimated ? $author$project$Sticker$animatedImageView$(
			true,
			emojiSize,
			emojiSize,
			$elm$core$Maybe$Just(yOffset),
			$author$project$FileStatus$fileUrl$($author$project$FileStatus$gifContent, fileHash),
			animationMode) : A2(
			$elm$html$Html$img,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', emojiSize),
					A2($elm$html$Html$Attributes$style, 'height', emojiSize),
					$elm$html$Html$Attributes$src(
					$author$project$FileStatus$fileUrl$($author$project$FileStatus$pngContent, fileHash)),
					$author$project$MyUi$lazyLoading,
					A2($elm$html$Html$Attributes$style, 'display', 'inline-block'),
					A2($elm$html$Html$Attributes$style, 'transform', 'translateY(' + (yOffset + ')'))
				]),
			_List_Nil);
	}
};
var $author$project$CustomEmoji$viewHelper = F4($author$project$CustomEmoji$viewHelper$);
var $author$project$CustomEmoji$view$ = function (emojiSize, yOffset, customEmojiId, customEmojis2, animationMode) {
	var _v0 = $lamdera$containers$SeqDict$get$(customEmojiId, customEmojis2);
	if (!_v0.$) {
		var customEmoji = _v0.a;
		return $author$project$CustomEmoji$viewHelper$(emojiSize, yOffset, customEmoji, animationMode);
	} else {
		return $author$project$CustomEmoji$placeholder$(emojiSize, yOffset);
	}
};
var $author$project$CustomEmoji$view = F5($author$project$CustomEmoji$view$);
var $author$project$MessageView$reactionEmojiButtonContent$ = function (emojiData, customEmojis, emoji) {
	if (!emoji.$) {
		var emoji2 = emoji.a;
		return $author$project$Emoji$unicodeView$('20px', emojiData, emoji2);
	} else {
		var customEmojiId = emoji.a;
		return $author$project$CustomEmoji$view$('1.1em', '0.2em', customEmojiId, customEmojis, 0);
	}
};
var $author$project$MessageView$reactionEmojiButtonContent = F3($author$project$MessageView$reactionEmojiButtonContent$);
var $author$project$Icons$reply = function (width2) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$strokeWidth('1.5'),
				$elm$svg$Svg$Attributes$stroke('currentColor'),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromInt(width2))
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$d('m16.49 12 3.75-3.751m0 0-3.75-3.75m3.75 3.75H3.74V19.5')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$smile = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$fill('currentColor'),
			$elm$svg$Svg$Attributes$width('24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$d('M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-2.625 6c-.54 0-.828.419-.936.634a1.96 1.96 0 0 0-.189.866c0 .298.059.605.189.866.108.215.395.634.936.634.54 0 .828-.419.936-.634.13-.26.189-.568.189-.866 0-.298-.059-.605-.189-.866-.108-.215-.395-.634-.936-.634Zm4.314.634c.108-.215.395-.634.936-.634.54 0 .828.419.936.634.13.26.189.568.189.866 0 .298-.059.605-.189.866-.108.215-.395.634-.936.634-.54 0-.828-.419-.936-.634a1.96 1.96 0 0 1-.189-.866c0-.298.059-.605.189-.866Zm2.023 6.828a.75.75 0 1 0-1.06-1.06 3.75 3.75 0 0 1-5.304 0 .75.75 0 0 0-1.06 1.06 5.25 5.25 0 0 0 7.424 0Z'),
					$elm$svg$Svg$Attributes$clipRule('evenodd')
				]),
			_List_Nil)
		]));
var $author$project$MessageMenu$menuItems$ = function (isMobile, guildOrDmId, threadRoute, isThreadStarter, maybeImageUrl, maybeLinkUrl, position, local, model) {
	var slackHelper = F4(
		function (guildOrDmId2, currentUserId, messageId, thread) {
			var _v40 = $author$project$MessageArray$get$(messageId, thread.messages);
			if (!_v40.$) {
				var message = _v40.a;
				return $elm$core$Maybe$Just(
					{
						canDelete: function () {
							switch (message.$) {
								case 0:
									var data = message.a;
									return _Utils_eq(data.createdBy, currentUserId);
								case 1:
									return false;
								case 2:
									return false;
								case 3:
									return false;
								case 4:
									return false;
								default:
									return false;
							}
						}(),
						canEdit: function () {
							switch (message.$) {
								case 0:
									var data = message.a;
									return _Utils_eq(data.createdBy, currentUserId);
								case 1:
									return false;
								case 2:
									return false;
								case 3:
									return false;
								case 4:
									return false;
								default:
									return false;
							}
						}(),
						canReply: false,
						messageCustomEmojiIdsList: _List_Nil,
						openDm: $elm$core$Maybe$Nothing,
						text: $author$project$LocalState$messageToString$(
							local.localUser.timezone,
							local.localUser.slackUsers,
							$author$project$LocalState$slackChannelMentions$(guildOrDmId2, local),
							$lamdera$containers$SeqDict$empty,
							message)
					});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
	var helper = F4(
		function (guildOrDmId2, isPrivateDm, messageId, thread) {
			var _v36 = $author$project$MessageArray$get$(messageId, thread.messages);
			if (!_v36.$) {
				var message = _v36.a;
				return $elm$core$Maybe$Just(
					{
						canDelete: function () {
							switch (message.$) {
								case 0:
									var data = message.a;
									return _Utils_eq(data.createdBy, local.localUser.session.userId);
								case 1:
									var data = message.a;
									return _Utils_eq(data.createdBy, local.localUser.session.userId);
								case 2:
									return false;
								case 3:
									return false;
								case 4:
									var callStarted = message.a;
									return $author$project$LocalState$canDeleteCallMessage$(local.localUser.session.userId, callStarted);
								default:
									return false;
							}
						}(),
						canEdit: function () {
							switch (message.$) {
								case 0:
									var data = message.a;
									return _Utils_eq(data.createdBy, local.localUser.session.userId);
								case 1:
									var data = message.a;
									return _Utils_eq(data.createdBy, local.localUser.session.userId);
								case 2:
									return false;
								case 3:
									return false;
								case 4:
									return false;
								default:
									return false;
							}
						}(),
						canReply: true,
						messageCustomEmojiIdsList: $author$project$MessageMenu$messageCustomEmojiIds(message),
						openDm: function () {
							if (isPrivateDm) {
								return $elm$core$Maybe$Nothing;
							} else {
								switch (message.$) {
									case 0:
										var data = message.a;
										return $elm$core$Maybe$Just(
											$author$project$Types$MessageMenu_PressedOpenDm(data.createdBy));
									case 1:
										var data = message.a;
										return $elm$core$Maybe$Just(
											$author$project$Types$MessageMenu_PressedOpenDm(data.createdBy));
									case 2:
										var createdBy = message.b;
										return $elm$core$Maybe$Just(
											$author$project$Types$MessageMenu_PressedOpenDm(createdBy));
									case 3:
										return $elm$core$Maybe$Nothing;
									case 4:
										var data = message.a;
										return $elm$core$Maybe$Just(
											$author$project$Types$MessageMenu_PressedOpenDm(data.startedBy));
									default:
										var data = message.a;
										return $elm$core$Maybe$Just(
											$author$project$Types$MessageMenu_PressedOpenDm(data.startedBy));
								}
							}
						}(),
						text: $author$project$LocalState$messageToString$(
							local.localUser.timezone,
							$author$project$User$allUsers(local.localUser),
							$author$project$LocalState$channelMentions$(guildOrDmId2, local),
							local.localUser.decryptedMessages,
							message)
					});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
	var discordHelper = F4(
		function (guildOrDmId2, isPrivateDm, messageId, thread) {
			var _v29 = $author$project$MessageArray$get$(messageId, thread.messages);
			if (!_v29.$) {
				var message = _v29.a;
				var messageUserId = function () {
					switch (message.$) {
						case 0:
							var data = message.a;
							return $elm$core$Maybe$Just(data.createdBy);
						case 1:
							var data = message.a;
							return $elm$core$Maybe$Just(data.createdBy);
						case 2:
							var createdBy = message.b;
							return $elm$core$Maybe$Just(createdBy);
						case 3:
							return $elm$core$Maybe$Nothing;
						case 4:
							var data = message.a;
							return $elm$core$Maybe$Just(data.startedBy);
						default:
							var data = message.a;
							return $elm$core$Maybe$Just(data.startedBy);
					}
				}();
				return $elm$core$Maybe$Just(
					{
						canDelete: function () {
							if (!message.$) {
								var data = message.a;
								return $author$project$LinkedAndOtherDiscordUsers$isLinkedUser$(data.createdBy, local.localUser.discordUsers);
							} else {
								return false;
							}
						}(),
						canEdit: function () {
							if (!message.$) {
								var data = message.a;
								return $author$project$LinkedAndOtherDiscordUsers$isLinkedUser$(data.createdBy, local.localUser.discordUsers);
							} else {
								return false;
							}
						}(),
						canReply: true,
						messageCustomEmojiIdsList: $author$project$MessageMenu$messageCustomEmojiIds(message),
						openDm: function () {
							var _v32 = _Utils_Tuple2(isPrivateDm, messageUserId);
							if ((!_v32.a) && (!_v32.b.$)) {
								var otherUserId = _v32.b.a;
								var _v33 = $author$project$LocalState$discordDmChannelWithUser$(otherUserId, local);
								if (!_v33.$) {
									var _v34 = _v33.a;
									var linkedUserId = _v34.a;
									var channelId = _v34.b;
									return $elm$core$Maybe$Just(
										$author$project$Types$MessageMenu_PressedOpenDiscordDm$(linkedUserId, channelId));
								} else {
									return $elm$core$Maybe$Nothing;
								}
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}(),
						text: $author$project$LocalState$messageToString$(
							local.localUser.timezone,
							$author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(local.localUser.discordUsers),
							$author$project$LocalState$discordChannelMentions$(guildOrDmId2, local),
							$lamdera$containers$SeqDict$empty,
							message)
					});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
	var maybeData = function () {
		switch (guildOrDmId.$) {
			case 0:
				if (!guildOrDmId.a.$) {
					var guildOrDmId2 = guildOrDmId.a;
					var id = guildOrDmId2.a;
					var _v10 = $author$project$LocalState$getGuildAndChannel$(id, local);
					if (!_v10.$) {
						var _v11 = _v10.a;
						var channel = _v11.b;
						if (threadRoute.$ === 1) {
							var threadMessageIndex = threadRoute.a;
							var messageId = threadRoute.b;
							var _v13 = $lamdera$containers$SeqDict$get$(threadMessageIndex, channel.threads);
							if (!_v13.$) {
								var thread = _v13.a;
								return A4(helper, guildOrDmId2, false, messageId, thread);
							} else {
								return $elm$core$Maybe$Nothing;
							}
						} else {
							var messageId = threadRoute.a;
							return A4(helper, guildOrDmId2, false, messageId, channel);
						}
					} else {
						return $elm$core$Maybe$Nothing;
					}
				} else {
					var guildOrDmId2 = guildOrDmId.a;
					var otherUserId = guildOrDmId2.a.otherUserId;
					var _v14 = $lamdera$containers$SeqDict$get$(otherUserId, local.dmChannels);
					if (!_v14.$) {
						var dmChannel = _v14.a;
						if (threadRoute.$ === 1) {
							var threadMessageIndex = threadRoute.a;
							var messageId = threadRoute.b;
							var _v16 = $lamdera$containers$SeqDict$get$(threadMessageIndex, dmChannel.threads);
							if (!_v16.$) {
								var thread = _v16.a;
								return A4(helper, guildOrDmId2, true, messageId, thread);
							} else {
								return $elm$core$Maybe$Nothing;
							}
						} else {
							var messageId = threadRoute.a;
							return A4(helper, guildOrDmId2, true, messageId, dmChannel);
						}
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}
			case 1:
				if (!guildOrDmId.a.$) {
					var guildOrDmId2 = guildOrDmId.a;
					var id = guildOrDmId2.a;
					var _v17 = $author$project$LocalState$getDiscordGuildAndChannel$(id.guildId, id.channelId, local);
					if (!_v17.$) {
						var _v18 = _v17.a;
						var channel = _v18.b;
						if (threadRoute.$ === 1) {
							var threadMessageIndex = threadRoute.a;
							var messageId = threadRoute.b;
							var _v20 = $lamdera$containers$SeqDict$get$(threadMessageIndex, channel.threads);
							if (!_v20.$) {
								var thread = _v20.a;
								return A4(discordHelper, guildOrDmId2, false, messageId, thread);
							} else {
								return $elm$core$Maybe$Nothing;
							}
						} else {
							var messageId = threadRoute.a;
							return A4(discordHelper, guildOrDmId2, false, messageId, channel);
						}
					} else {
						return $elm$core$Maybe$Nothing;
					}
				} else {
					var guildOrDmId2 = guildOrDmId.a;
					var id = guildOrDmId2.a;
					var _v21 = $lamdera$containers$SeqDict$get$(id.channelId, local.discordDmChannels);
					if (!_v21.$) {
						var channel = _v21.a;
						if (threadRoute.$ === 1) {
							return $elm$core$Maybe$Nothing;
						} else {
							var messageId = threadRoute.a;
							return A4(
								discordHelper,
								guildOrDmId2,
								$author$project$NonemptyDict$size(channel.members) < 3,
								messageId,
								channel);
						}
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}
			default:
				if (!guildOrDmId.a.$) {
					var guildOrDmId2 = guildOrDmId.a;
					var id = guildOrDmId2.a;
					var _v23 = $elm$core$Maybe$andThen$(
						function (workspace) {
							return $lamdera$containers$SeqDict$get$(id.channelId, workspace.channels);
						},
						$lamdera$containers$SeqDict$get$(id.teamId, local.slackWorkspaces));
					if (!_v23.$) {
						var channel = _v23.a;
						if (threadRoute.$ === 1) {
							var threadMessageIndex = threadRoute.a;
							var messageId = threadRoute.b;
							var _v25 = $lamdera$containers$SeqDict$get$(threadMessageIndex, channel.threads);
							if (!_v25.$) {
								var thread = _v25.a;
								return A4(slackHelper, guildOrDmId2, id.currentUserId, messageId, thread);
							} else {
								return $elm$core$Maybe$Nothing;
							}
						} else {
							var messageId = threadRoute.a;
							return A4(slackHelper, guildOrDmId2, id.currentUserId, messageId, channel);
						}
					} else {
						return $elm$core$Maybe$Nothing;
					}
				} else {
					var guildOrDmId2 = guildOrDmId.a;
					var id = guildOrDmId2.a;
					var _v26 = $lamdera$containers$SeqDict$get$(id.channelId, local.slackDmChannels);
					if (!_v26.$) {
						var channel = _v26.a;
						if (threadRoute.$ === 1) {
							var threadMessageIndex = threadRoute.a;
							var messageId = threadRoute.b;
							var _v28 = $lamdera$containers$SeqDict$get$(threadMessageIndex, channel.threads);
							if (!_v28.$) {
								var thread = _v28.a;
								return A4(slackHelper, guildOrDmId2, id.currentUserId, messageId, thread);
							} else {
								return $elm$core$Maybe$Nothing;
							}
						} else {
							var messageId = threadRoute.a;
							return A4(slackHelper, guildOrDmId2, id.currentUserId, messageId, channel);
						}
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}
		}
	}();
	if (!maybeData.$) {
		var openDm = maybeData.a.openDm;
		var messageCustomEmojiIdsList = maybeData.a.messageCustomEmojiIdsList;
		var text = maybeData.a.text;
		var canReply = maybeData.a.canReply;
		var canDelete = maybeData.a.canDelete;
		var canEdit = maybeData.a.canEdit;
		var newCustomEmojiIds = $author$project$NonemptySet$fromList(
			$elm$core$List$filter$(
				function (id) {
					return $lamdera$containers$SeqDict$member$(id, local.localUser.customEmojis) && (!$lamdera$containers$SeqSet$member$(id, local.localUser.user.availableCustomEmojis));
				},
				messageCustomEmojiIdsList));
		return $author$project$MessageMenu$menuItemsHelper$(
			isMobile,
			_List_fromArray(
				[
					$author$project$MessageMenu$ButtonItem(
					$author$project$Ui$row$(
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$el$(
								_List_Nil,
								$author$project$MessageMenu$button$(
									isMobile,
									$lamdera$program_test$Effect$Browser$Dom$id('messageMenu_addReaction'),
									$author$project$Icons$smile,
									'Add reaction emoji',
									$author$project$Types$MessageMenu_PressedShowReactionEmojiSelector$(guildOrDmId, threadRoute, position))),
								function () {
								if (isMobile) {
									var commonEmojis = $elm$core$List$indexedMap$(
										F2(
											function (index, _v1) {
												var emoji = _v1.a;
												return $author$project$MyUi$elButton$(
													$lamdera$program_test$Effect$Browser$Dom$id(
														'messageMenu_mobileReactionEmoji_' + $elm$core$String$fromInt(index)),
													$author$project$Types$MessageMenu_PressedReactionEmoji(emoji),
													_List_fromArray(
														[
															$author$project$Ui$contentCenterX,
															$author$project$Ui$contentCenterY,
															$author$project$Ui$height(
															$author$project$Ui$px(
																$author$project$MessageMenu$buttonHeight(isMobile))),
															$author$project$Ui$Font$size(24)
														]),
													$author$project$Ui$html(
														$author$project$MessageView$reactionEmojiButtonContent$(local.localUser.emojiData, local.localUser.customEmojis, emoji)));
											}),
										$elm$core$List$take$(
											3,
											$author$project$User$commonlyUsedEmojis$(
												$author$project$MessageMenu$availableCustomEmojisAndStickers$(guildOrDmId, local).a,
												local.localUser.user)));
									return $author$project$Ui$row$(
										_List_fromArray(
											[
												$author$project$Ui$height(
												$author$project$Ui$px(
													$author$project$MessageMenu$buttonHeight(true))),
												$author$project$MyUi$noShrinking
											]),
										A2(
											$elm$core$List$cons,
											$author$project$Ui$el$(
												_List_fromArray(
													[
														$author$project$Ui$paddingXY$(0, 4),
														$author$project$Ui$width(
														$author$project$Ui$px(1)),
														$author$project$Ui$height($author$project$Ui$fill)
													]),
												$author$project$Ui$el$(
													_List_fromArray(
														[
															$author$project$Ui$height($author$project$Ui$fill),
															$author$project$Ui$background($author$project$MyUi$border1)
														]),
													$author$project$Ui$none)),
											commonEmojis));
								} else {
									return $author$project$Ui$none;
								}
							}()
							]))),
					canEdit ? $author$project$MessageMenu$ButtonItem(
					$author$project$MessageMenu$button$(
						isMobile,
						$lamdera$program_test$Effect$Browser$Dom$id('messageMenu_editMessage'),
						$author$project$Icons$pencil,
						$author$project$MessageMenu$editMessageText,
						$author$project$Types$MessageMenu_PressedEditMessage$(guildOrDmId, threadRoute))) : $author$project$MessageMenu$NoItem,
					(isThreadStarter || (!canReply)) ? $author$project$MessageMenu$NoItem : $author$project$MessageMenu$ButtonItem(
					$author$project$MessageMenu$button$(
						isMobile,
						$lamdera$program_test$Effect$Browser$Dom$id('messageMenu_replyTo'),
						$author$project$Icons$reply(24),
						'Reply to',
						$author$project$Types$MessageMenu_PressedReply(threadRoute))),
					function () {
					var _v2 = _Utils_Tuple2(threadRoute, guildOrDmId);
					_v2$0:
					while (true) {
						if (!_v2.a.$) {
							if ((_v2.b.$ === 1) && (_v2.b.a.$ === 1)) {
								break _v2$0;
							} else {
								var messageId = _v2.a.a;
								return $author$project$MessageMenu$ButtonItem(
									$author$project$MessageMenu$button$(
										isMobile,
										$lamdera$program_test$Effect$Browser$Dom$id('messageMenu_openThread'),
										$author$project$Icons$hashtag,
										'Start thread',
										$author$project$Types$MessageMenu_PressedOpenThread(messageId)));
							}
						} else {
							if ((_v2.b.$ === 1) && (_v2.b.a.$ === 1)) {
								break _v2$0;
							} else {
								var _v3 = _v2.a;
								return $author$project$MessageMenu$NoItem;
							}
						}
					}
					return $author$project$MessageMenu$NoItem;
				}(),
					$author$project$MessageMenu$ButtonItem(
					$author$project$MessageMenu$button$(
						isMobile,
						$lamdera$program_test$Effect$Browser$Dom$id('messageMenu_copy'),
						$author$project$Icons$copyIcon,
						function () {
							var _v4 = model.lastCopied;
							if (!_v4.$) {
								var lastCopied = _v4.a;
								return _Utils_eq(
									lastCopied.copied,
									$author$project$MyUi$CopiedText(text)) ? 'Copied!' : 'Copy message';
							} else {
								return 'Copy message';
							}
						}(),
						$author$project$Types$PressedCopyText(text))),
					$author$project$MessageMenu$ButtonItem(
					$author$project$MessageMenu$button$(
						isMobile,
						$lamdera$program_test$Effect$Browser$Dom$id('messageMenu_markAsUnread'),
						$author$project$Icons$backward,
						'Mark as unread',
						$author$project$Types$MessageMenu_PressedMarkAsUnread$(guildOrDmId, threadRoute))),
					function () {
					if (!maybeImageUrl.$) {
						var imageUrl = maybeImageUrl.a;
						return $author$project$MessageMenu$GroupItem(
							_List_fromArray(
								[
									$author$project$MessageMenu$HorizontalLineItem,
									$author$project$MessageMenu$copyImageButton$(isMobile, imageUrl, model.lastCopied),
									$author$project$MessageMenu$ButtonItem(
									$author$project$MessageMenu$copyImageLinkButton$(isMobile, imageUrl, model.lastCopied))
								]));
					} else {
						return $author$project$MessageMenu$NoItem;
					}
				}(),
					function () {
					if (!maybeLinkUrl.$) {
						var linkUrl = maybeLinkUrl.a;
						return $author$project$MessageMenu$ButtonItem(
							$author$project$MessageMenu$copyLinkButton$(isMobile, linkUrl, model.lastCopied));
					} else {
						return $author$project$MessageMenu$NoItem;
					}
				}(),
					function () {
					if (!newCustomEmojiIds.$) {
						var newCustomEmojiIds2 = newCustomEmojiIds.a;
						return $author$project$MessageMenu$ButtonItem(
							$author$project$MessageMenu$button$(
								isMobile,
								$lamdera$program_test$Effect$Browser$Dom$id('messageMenu_addCustomEmojis'),
								$author$project$Icons$plusIcon,
								'Get stickers & emojis',
								$author$project$Types$MessageMenu_PressedAddCustomEmojisToUser(newCustomEmojiIds2)));
					} else {
						return $author$project$MessageMenu$NoItem;
					}
				}(),
					function () {
					if (!openDm.$) {
						var openDm2 = openDm.a;
						return $author$project$MessageMenu$ButtonItem(
							$author$project$MessageMenu$button$(
								isMobile,
								$lamdera$program_test$Effect$Browser$Dom$id('messageMenu_openDm'),
								$author$project$Icons$person,
								'DM this user',
								openDm2));
					} else {
						return $author$project$MessageMenu$NoItem;
					}
				}(),
					canDelete ? $author$project$MessageMenu$GroupItem(
					_List_fromArray(
						[
							$author$project$MessageMenu$HorizontalLineItem,
							$author$project$MessageMenu$ButtonItem(
							$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$Font$color($author$project$MyUi$errorColor)
									]),
								$author$project$MessageMenu$button$(
									isMobile,
									$lamdera$program_test$Effect$Browser$Dom$id('messageMenu_deleteMessage'),
									$author$project$Icons$delete,
									'Delete message',
									$author$project$Types$MessageMenu_PressedDeleteMessage$(guildOrDmId, threadRoute))))
						])) : $author$project$MessageMenu$NoItem
				]));
	} else {
		return {height: 0, items: _List_Nil};
	}
};
var $author$project$MessageMenu$menuItems = F9($author$project$MessageMenu$menuItems$);
var $author$project$MessageMenu$mobileCloseButton = 12;
var $author$project$MessageMenu$bottomPadding = 8;
var $author$project$MessageMenu$topPadding = 4;
var $author$project$MessageMenu$mobileMenuMaxHeightHelper = function (_v0) {
	var height = _v0.height;
	var items = _v0.items;
	return ((((height + $elm$core$List$length(items)) - 1) + $author$project$MessageMenu$mobileCloseButton) + $author$project$MessageMenu$topPadding) + $author$project$MessageMenu$bottomPadding;
};
var $author$project$MessageMenu$mobileMenuOpeningOffset$ = function (guildOrDmId, threadRoute, isThreadStarter, maybeImageUrl, maybeLinkUrl, local, model) {
	var menuItemsData = $author$project$MessageMenu$menuItems$(true, guildOrDmId, threadRoute, isThreadStarter, maybeImageUrl, maybeLinkUrl, $author$project$Coord$origin, local, model);
	return ($elm$core$List$length(menuItemsData.items) <= 4) ? $author$project$CssPixels$cssPixels(
		$author$project$MessageMenu$mobileMenuMaxHeightHelper(menuItemsData)) : $author$project$CssPixels$cssPixels(
		(((3 * ($author$project$MessageMenu$buttonHeight(true) + 1)) + ($author$project$MessageMenu$buttonHeight(true) / 2)) + $author$project$MessageMenu$mobileCloseButton) + $author$project$MessageMenu$topPadding);
};
var $author$project$MessageMenu$mobileMenuOpeningOffset = F7($author$project$MessageMenu$mobileMenuOpeningOffset$);
var $author$project$Frontend$handleAltPressedMessage$ = function (guildOrDmId, threadRoute, isThreadStarter, maybeImageUrl, maybeLinkUrl, clickedAt, loggedIn, local, model) {
	return _Utils_update(
		loggedIn,
		{
			messageHover: $author$project$Types$MessageMenu(
				{
					guildOrDmId: guildOrDmId,
					imageUrl: maybeImageUrl,
					isThreadStarter: isThreadStarter,
					linkUrl: maybeLinkUrl,
					mobileMode: $author$project$Types$MessageMenuOpening(
						{
							offset: $ianmackenzie$elm_units$Quantity$zero,
							targetOffset: $author$project$MessageMenu$mobileMenuOpeningOffset$(guildOrDmId, threadRoute, isThreadStarter, maybeImageUrl, maybeLinkUrl, local, model)
						}),
					position: clickedAt,
					threadRoute: threadRoute
				})
		});
};
var $author$project$Frontend$handleAltPressedMessage = F9($author$project$Frontend$handleAltPressedMessage$);
var $author$project$RichText$failedToDecryptMessage = $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
	$author$project$RichText$Italic(
		$mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
			$author$project$RichText$NormalText$('F', 'ailed to decrypt message'),
			_List_Nil)),
	_List_Nil);
var $author$project$Scroll$ScrolledToMiddle = 3;
var $author$project$Ports$shift_scroll_by_element_delta_to_js = _Platform_outgoingPort('shift_scroll_by_element_delta_to_js', $elm$core$Basics$identity);
var $author$project$Ports$shiftScrollByElementDelta$ = function (containerId, elementId) {
	return A3(
		$lamdera$program_test$Effect$Command$sendToJs,
		'shift_scroll_by_element_delta_to_js',
		$author$project$Ports$shift_scroll_by_element_delta_to_js,
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'containerId',
					$elm$json$Json$Encode$string(
						$lamdera$program_test$Effect$Browser$Dom$idToString(containerId))),
					_Utils_Tuple2(
					'elementId',
					$elm$json$Json$Encode$string(
						$lamdera$program_test$Effect$Browser$Dom$idToString(elementId)))
				])));
};
var $author$project$Ports$shiftScrollByElementDelta = F2($author$project$Ports$shiftScrollByElementDelta$);
var $author$project$FrontendExtra$holdScrollOnNewMessage$ = function (guildOrDmId, threadRoute, local) {
	var _v0 = $author$project$FrontendExtra$conversationWindow$(guildOrDmId, threadRoute, local);
	if (!_v0.$) {
		switch (_v0.a.$) {
			case 0:
				var _v1 = _v0.a;
				var messageCount = _v1.c;
				return $author$project$Ports$shiftScrollByElementDelta$(
					$author$project$Pages$Guild$conversationContainerId,
					$author$project$Pages$Guild$channelMessageHtmlId(
						$author$project$Id$fromInt(messageCount - 2)));
			case 1:
				var _v2 = _v0.a;
				var messageCount = _v2.d;
				return $author$project$Ports$shiftScrollByElementDelta$(
					$author$project$Pages$Guild$conversationContainerId,
					$author$project$Pages$Guild$threadMessageHtmlId(
						$author$project$Id$fromInt(messageCount - 2)));
			case 2:
				var _v3 = _v0.a;
				var messageCount = _v3.c;
				return $author$project$Ports$shiftScrollByElementDelta$(
					$author$project$Pages$Guild$conversationContainerId,
					$author$project$Pages$Guild$channelMessageHtmlId(
						$author$project$Id$fromInt(messageCount - 2)));
			case 3:
				var _v4 = _v0.a;
				var messageCount = _v4.d;
				return $author$project$Ports$shiftScrollByElementDelta$(
					$author$project$Pages$Guild$conversationContainerId,
					$author$project$Pages$Guild$threadMessageHtmlId(
						$author$project$Id$fromInt(messageCount - 2)));
			case 4:
				var _v5 = _v0.a;
				var messageCount = _v5.c;
				return $author$project$Ports$shiftScrollByElementDelta$(
					$author$project$Pages$Guild$conversationContainerId,
					$author$project$Pages$Guild$channelMessageHtmlId(
						$author$project$Id$fromInt(messageCount - 2)));
			default:
				var _v6 = _v0.a;
				var messageCount = _v6.d;
				return $author$project$Ports$shiftScrollByElementDelta$(
					$author$project$Pages$Guild$conversationContainerId,
					$author$project$Pages$Guild$threadMessageHtmlId(
						$author$project$Id$fromInt(messageCount - 2)));
		}
	} else {
		return $lamdera$program_test$Effect$Command$none;
	}
};
var $author$project$FrontendExtra$holdScrollOnNewMessage = F3($author$project$FrontendExtra$holdScrollOnNewMessage$);
var $author$project$Ports$martinsstewart_set_favicon_to_js = _Platform_outgoingPort('martinsstewart_set_favicon_to_js', $elm$core$Basics$identity);
var $author$project$Ports$setFavicon = function (faviconPath) {
	return A3(
		$lamdera$program_test$Effect$Command$sendToJs,
		'martinsstewart_set_favicon_to_js',
		$author$project$Ports$martinsstewart_set_favicon_to_js,
		$elm$json$Json$Encode$string(faviconPath));
};
var $author$project$Ports$show_notification = _Platform_outgoingPort('show_notification', $elm$core$Basics$identity);
var $author$project$Ports$showNotification$ = function (title, body, url) {
	return A3(
		$lamdera$program_test$Effect$Command$sendToJs,
		'show_notification',
		$author$project$Ports$show_notification,
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'title',
					$elm$json$Json$Encode$string(title)),
					_Utils_Tuple2(
					'body',
					$elm$json$Json$Encode$string(body)),
					_Utils_Tuple2(
					'url',
					$elm$json$Json$Encode$string(url))
				])));
};
var $author$project$Ports$showNotification = F3($author$project$Ports$showNotification$);
var $author$project$Route$threadRouteWithFriends = function (threadRoute) {
	if (!threadRoute.$) {
		return $author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1);
	} else {
		var threadId = threadRoute.a;
		return $author$project$Route$ViewThreadWithFriends$(threadId, $elm$core$Maybe$Nothing, 1);
	}
};
var $author$project$FrontendExtra$playNotificationSound$ = function (senderId, guildOrDmId, threadRouteWithRepliedTo, channel, local, content, model) {
	var _v0 = local.localUser.session.notificationMode;
	switch (_v0) {
		case 0:
			return $lamdera$program_test$Effect$Command$none;
		case 1:
			var threadRouteWithFriends = $author$project$Route$threadRouteWithFriends(
				$author$project$Id$threadRouteWithoutMaybeMessage(threadRouteWithRepliedTo));
			var isMentionedOrRepliedTo = $lamdera$containers$SeqSet$member$(
				local.localUser.session.userId,
				$author$project$LocalState$usersMentionedOrRepliedToFrontend$(threadRouteWithRepliedTo, content, channel));
			var alwaysNotify = function () {
				if (!guildOrDmId.$) {
					var guildId = guildOrDmId.a.guildId;
					return $lamdera$containers$SeqSet$member$(guildId, local.localUser.user.notifyOnAllMessages);
				} else {
					return true;
				}
			}();
			return ((!model.pageHasFocus) && (alwaysNotify || isMentionedOrRepliedTo)) ? $lamdera$program_test$Effect$Command$batch(
				_List_fromArray(
					[
						$author$project$Ports$setFavicon('/favicon-red.ico'),
						function () {
						var _v1 = model.startupData.notificationPermission;
						if (_v1 === 2) {
							var users = $author$project$User$allUsers(local.localUser);
							return $author$project$Ports$showNotification$(
								$author$project$User$toString$(senderId, users),
								$author$project$RichText$toString$(
									local.localUser.timezone,
									true,
									users,
									$author$project$LocalState$channelMentions$(guildOrDmId, local),
									content),
								_Utils_ap(
									$author$project$Env$domain,
									$author$project$Route$encode(
										function () {
											if (!guildOrDmId.$) {
												var channelId = guildOrDmId.a.channelId;
												var guildId = guildOrDmId.a.guildId;
												return $author$project$Route$GuildRoute$(
													guildId,
													$author$project$Route$ChannelRoute$(channelId, threadRouteWithFriends, $elm$core$Maybe$Nothing),
													0,
													$elm$core$Maybe$Nothing);
											} else {
												var otherUserId = guildOrDmId.a.otherUserId;
												return $author$project$Route$DmRoute(
													{
														channelId: $author$project$DmChannelId$fromUserIds$(local.localUser.session.userId, otherUserId),
														channelsVisible: 0,
														overlay: $elm$core$Maybe$Nothing,
														tab: $elm$core$Maybe$Nothing,
														threadRoute: threadRouteWithFriends
													});
											}
										}())));
						} else {
							return $lamdera$program_test$Effect$Command$none;
						}
					}()
					])) : $lamdera$program_test$Effect$Command$none;
		default:
			return $lamdera$program_test$Effect$Command$none;
	}
};
var $author$project$FrontendExtra$playNotificationSound = F7($author$project$FrontendExtra$playNotificationSound$);
var $author$project$Scroll$toBottomOfChannelSmoothHelper$ = function (conversationContainerId, startY, endY, count) {
	if (_Utils_cmp(count, $author$project$Scroll$smoothScrollSteps) < 1) {
		var t = count / $author$project$Scroll$smoothScrollSteps;
		var y = (t * (endY - startY)) + startY;
		return A2(
			$lamdera$program_test$Effect$Task$andThen,
			function (_v0) {
				return $author$project$Scroll$toBottomOfChannelSmoothHelper$(conversationContainerId, startY, endY, count + 1);
			},
			$lamdera$program_test$Effect$Browser$Dom$setViewportOf$(conversationContainerId, 0, y));
	} else {
		return $lamdera$program_test$Effect$Task$succeed(0);
	}
};
var $author$project$Scroll$toBottomOfChannelSmoothHelper = F4($author$project$Scroll$toBottomOfChannelSmoothHelper$);
var $author$project$Scroll$toBottomOfChannelSmooth$ = function (conversationContainerId, setScrollToBottom) {
	return $lamdera$program_test$Effect$Task$attempt$(
		function (_v1) {
			return setScrollToBottom;
		},
		A2(
			$lamdera$program_test$Effect$Task$andThen,
			function (_v0) {
				var viewport = _v0.viewport;
				var scene = _v0.scene;
				return $author$project$Scroll$toBottomOfChannelSmoothHelper$(conversationContainerId, viewport.y, scene.height - viewport.height, 0);
			},
			$lamdera$program_test$Effect$Browser$Dom$getViewportOf(conversationContainerId)));
};
var $author$project$Scroll$toBottomOfChannelSmooth = F2($author$project$Scroll$toBottomOfChannelSmooth$);
var $author$project$Route$toGuildOrDmId$ = function (userId, route) {
	_v0$6:
	while (true) {
		switch (route.$) {
			case 3:
				if (!route.b.$) {
					var guildId = route.a;
					var _v1 = route.b;
					var channelId = _v1.a;
					var threadRoute = _v1.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							$author$project$Id$GuildOrDmId(
								$author$project$Id$GuildOrDmId_Guild(
									{channelId: channelId, guildId: guildId})),
							function () {
								if (threadRoute.$ === 1) {
									var threadMessageId = threadRoute.a;
									return $author$project$Id$ViewThread(threadMessageId);
								} else {
									return $author$project$Id$NoThread;
								}
							}()));
				} else {
					break _v0$6;
				}
			case 5:
				var threadRoute = route.a.threadRoute;
				var channelId = route.a.channelId;
				var _v3 = $author$project$DmChannelId$otherUserId$(userId, channelId);
				if (!_v3.$) {
					var otherUserId = _v3.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							$author$project$Id$GuildOrDmId(
								$author$project$Id$GuildOrDmId_Dm(
									{otherUserId: otherUserId})),
							function () {
								if (threadRoute.$ === 1) {
									var threadMessageId = threadRoute.a;
									return $author$project$Id$ViewThread(threadMessageId);
								} else {
									return $author$project$Id$NoThread;
								}
							}()));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 4:
				var data = route.a;
				var _v5 = data.channelRoute;
				if (!_v5.$) {
					var channelId = _v5.a;
					var threadRoute = _v5.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							$author$project$Id$DiscordGuildOrDmId(
								$author$project$Id$DiscordGuildOrDmId_Guild(
									{channelId: channelId, currentUserId: data.currentDiscordUserId, guildId: data.guildId})),
							function () {
								if (threadRoute.$ === 1) {
									var threadMessageId = threadRoute.a;
									return $author$project$Id$ViewThread(threadMessageId);
								} else {
									return $author$project$Id$NoThread;
								}
							}()));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 6:
				var data = route.a;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(
						$author$project$Id$DiscordGuildOrDmId(
							$author$project$Id$DiscordGuildOrDmId_Dm(
								{channelId: data.channelId, currentUserId: data.currentDiscordUserId})),
						$author$project$Id$NoThread));
			case 7:
				var data = route.a;
				var _v7 = data.channelRoute;
				if (!_v7.$) {
					var channelId = _v7.a;
					var threadRoute = _v7.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							$author$project$Id$SlackGuildOrDmId(
								$author$project$Id$SlackGuildOrDmId_Workspace(
									{channelId: channelId, currentUserId: data.currentSlackUserId, teamId: data.teamId})),
							$author$project$Id$threadRouteWithoutMaybeMessage(threadRoute)));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 8:
				var data = route.a;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(
						$author$project$Id$SlackGuildOrDmId(
							$author$project$Id$SlackGuildOrDmId_Dm(
								{channelId: data.channelId, currentUserId: data.currentSlackUserId})),
						$author$project$Id$threadRouteWithoutMaybeMessage(data.threadRoute)));
			default:
				break _v0$6;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Route$toGuildOrDmId = F2($author$project$Route$toGuildOrDmId$);
var $author$project$FrontendExtra$handleServerSendMessage$ = function (senderId, guildOrDmId, content, maybeRepliedTo, local, loggedIn2, model) {
	var scrolledToBottom = (!_Utils_eq(
		$author$project$Route$toChannelHeaderTab(model.route),
		$elm$core$Maybe$Just($author$project$UserSession$ChannelHeaderTab_Draw))) && (!loggedIn2.channelScrollPosition);
	var isViewingConversation = _Utils_eq(
		$author$project$Route$toGuildOrDmId$(local.localUser.session.userId, model.route),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(
				$author$project$Id$GuildOrDmId(guildOrDmId),
				$author$project$Message$threadRouteWithoutRepliedTo(maybeRepliedTo))));
	var helper = function (channel) {
		return $lamdera$program_test$Effect$Command$batch(
			_List_fromArray(
				[
					$author$project$FrontendExtra$playNotificationSound$(
					senderId,
					guildOrDmId,
					$author$project$Message$toThreadRouteWithMaybeMessage(maybeRepliedTo),
					channel,
					local,
					content,
					model),
					scrolledToBottom ? ($author$project$MyUi$isMobile(model) ? $author$project$Scroll$toBottomOfChannelSmooth$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom) : $author$project$Scroll$toBottomOfChannel$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom)) : (isViewingConversation ? $author$project$FrontendExtra$holdScrollOnNewMessage$(
					$author$project$Id$GuildOrDmId(guildOrDmId),
					$author$project$Message$threadRouteWithoutRepliedTo(maybeRepliedTo),
					local) : $lamdera$program_test$Effect$Command$none)
				]));
	};
	return _Utils_Tuple2(
		(isViewingConversation && (!scrolledToBottom)) ? _Utils_update(
			loggedIn2,
			{
				channelScrollPosition: function () {
					var _v0 = loggedIn2.channelScrollPosition;
					switch (_v0) {
						case 0:
							return 3;
						case 1:
							return loggedIn2.channelScrollPosition;
						case 2:
							return loggedIn2.channelScrollPosition;
						default:
							return loggedIn2.channelScrollPosition;
					}
				}(),
				newMessagesWhileNotScrolledToBottom: loggedIn2.newMessagesWhileNotScrolledToBottom + 1
			}) : loggedIn2,
		function () {
			if (!guildOrDmId.$) {
				var channelId = guildOrDmId.a.channelId;
				var guildId = guildOrDmId.a.guildId;
				var _v2 = $author$project$LocalState$getGuildAndChannel$(
					{channelId: channelId, guildId: guildId},
					local);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var channel = _v3.b;
					return helper(channel);
				} else {
					return $lamdera$program_test$Effect$Command$none;
				}
			} else {
				var otherUserId = guildOrDmId.a.otherUserId;
				var _v4 = $lamdera$containers$SeqDict$get$(otherUserId, local.dmChannels);
				if (!_v4.$) {
					var channel = _v4.a;
					return helper(channel);
				} else {
					return $lamdera$program_test$Effect$Command$none;
				}
			}
		}());
};
var $author$project$FrontendExtra$handleServerSendMessage = F7($author$project$FrontendExtra$handleServerSendMessage$);
var $author$project$Encryption$storeFileKeys = function (keys) {
	return A3(
		$lamdera$program_test$Effect$Command$sendToJsBytes,
		'encryption_to_js',
		$author$project$Encryption$encryption_to_js,
		$author$project$Serialize$encodeToBytes$(
			$author$project$Encryption$toJsCodec($author$project$Serialize$unit),
			$author$project$Encryption$ToJs_StoreFileKeys(keys)));
};
var $author$project$FrontendExtra$storeDecryptedFileKeys = function (decrypted) {
	var _v0 = $elm$core$List$concatMap$(
		function (result) {
			if (!result.$) {
				var messageContent = result.a;
				return $elm$core$List$filterMap$(
					$author$project$FileStatus$fileKey,
					$lamdera$containers$SeqDict$values(messageContent.attachedFiles));
			} else {
				return _List_Nil;
			}
		},
		decrypted);
	if (!_v0.b) {
		return $lamdera$program_test$Effect$Command$none;
	} else {
		var keys = _v0;
		return $author$project$Encryption$storeFileKeys(keys);
	}
};
var $author$project$FrontendExtra$handleDecryptedMessage$ = function (requestId, result, model, loggedIn) {
	var _v0 = $lamdera$containers$SeqDict$get$(requestId, loggedIn.encryptionRequests.pendingDecryptedMessages);
	if (!_v0.$) {
		var request = _v0.a;
		var loggedIn2 = $author$project$FrontendExtra$fileDecryptedMessages$(
			_List_fromArray(
				[
					_Utils_Tuple2(request.hash, result)
				]),
			loggedIn);
		return $elm$core$Tuple$mapSecond$(
			function (cmd) {
				return $lamdera$program_test$Effect$Command$batch(
					_List_fromArray(
						[
							cmd,
							$author$project$FrontendExtra$storeDecryptedFileKeys(
							_List_fromArray(
								[result]))
						]));
			},
			$author$project$FrontendExtra$handleServerSendMessage$(
				request.senderId,
				$author$project$Id$GuildOrDmId_Dm(request.id),
				function () {
					if (!result.$) {
						var contentAndEmbeds = result.a;
						return contentAndEmbeds.content;
					} else {
						return $author$project$RichText$failedToDecryptMessage;
					}
				}(),
				request.threadRoute,
				$author$project$Local$model(loggedIn2.localState),
				loggedIn2,
				model));
	} else {
		return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
	}
};
var $author$project$FrontendExtra$handleDecryptedMessage = F4($author$project$FrontendExtra$handleDecryptedMessage$);
var $author$project$Frontend$handleEditable$ = function (editableMsg, setter, acceptEdit, model) {
	return $author$project$FrontendExtra$updateLoggedIn$(
		function (loggedIn) {
			var _v0 = loggedIn.userOptions;
			if (!_v0.$) {
				var userOptions = _v0.a;
				if (!editableMsg.$) {
					var editable = editableMsg.a;
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{
								userOptions: $elm$core$Maybe$Just(
									A2(setter, userOptions, editable))
							}),
						$lamdera$program_test$Effect$Command$none);
				} else {
					var value = editableMsg.a;
					return A2(
						acceptEdit,
						value,
						_Utils_update(
							loggedIn,
							{
								userOptions: $elm$core$Maybe$Just(
									A2(setter, userOptions, $author$project$Editable$init))
							}));
				}
			} else {
				return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
			}
		},
		model);
};
var $author$project$Frontend$handleEditable = F4($author$project$Frontend$handleEditable$);
var $author$project$LocalState$guildOrDmIdToMessagesCount$ = function (guildOrDmId, threadRoute, local) {
	switch (guildOrDmId.$) {
		case 0:
			if (!guildOrDmId.a.$) {
				var id = guildOrDmId.a.a;
				var _v1 = $author$project$LocalState$getGuildAndChannel$(id, local);
				if (!_v1.$) {
					var _v2 = _v1.a;
					var channel = _v2.b;
					if (threadRoute.$ === 1) {
						var threadMessageIndex = threadRoute.a;
						return $elm$core$Maybe$Just(
							$author$project$MessageArray$length(
								$elm$core$Maybe$withDefault$(
									$author$project$Thread$frontendInit,
									$lamdera$containers$SeqDict$get$(threadMessageIndex, channel.threads)).messages));
					} else {
						return $elm$core$Maybe$Just(
							$author$project$MessageArray$length(channel.messages));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				var otherUserId = guildOrDmId.a.a.otherUserId;
				var _v4 = $lamdera$containers$SeqDict$get$(otherUserId, local.dmChannels);
				if (!_v4.$) {
					var dmChannel = _v4.a;
					if (threadRoute.$ === 1) {
						var threadMessageIndex = threadRoute.a;
						return $elm$core$Maybe$Just(
							$author$project$MessageArray$length(
								$elm$core$Maybe$withDefault$(
									$author$project$Thread$frontendInit,
									$lamdera$containers$SeqDict$get$(threadMessageIndex, dmChannel.threads)).messages));
					} else {
						return $elm$core$Maybe$Just(
							$author$project$MessageArray$length(dmChannel.messages));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		case 1:
			if (!guildOrDmId.a.$) {
				var id = guildOrDmId.a.a;
				var _v6 = $author$project$LocalState$getDiscordGuildAndChannel$(id.guildId, id.channelId, local);
				if (!_v6.$) {
					var _v7 = _v6.a;
					var channel = _v7.b;
					if (threadRoute.$ === 1) {
						var threadMessageIndex = threadRoute.a;
						return $elm$core$Maybe$Just(
							$author$project$MessageArray$length(
								$elm$core$Maybe$withDefault$(
									$author$project$Thread$discordFrontendInit,
									$lamdera$containers$SeqDict$get$(threadMessageIndex, channel.threads)).messages));
					} else {
						return $elm$core$Maybe$Just(
							$author$project$MessageArray$length(channel.messages));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				var data = guildOrDmId.a.a;
				var _v9 = $lamdera$containers$SeqDict$get$(data.channelId, local.discordDmChannels);
				if (!_v9.$) {
					var dmChannel = _v9.a;
					return $elm$core$Maybe$Just(
						$author$project$MessageArray$length(dmChannel.messages));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		default:
			if (!guildOrDmId.a.$) {
				var id = guildOrDmId.a.a;
				var _v10 = $author$project$LocalState$getSlackWorkspaceAndChannel$(id.teamId, id.channelId, local);
				if (!_v10.$) {
					var _v11 = _v10.a;
					var channel = _v11.b;
					return $elm$core$Maybe$Just(
						$author$project$MessageArray$length(channel.messages));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				var data = guildOrDmId.a.a;
				var _v12 = $lamdera$containers$SeqDict$get$(data.channelId, local.slackDmChannels);
				if (!_v12.$) {
					var dmChannel = _v12.a;
					return $elm$core$Maybe$Just(
						$author$project$MessageArray$length(dmChannel.messages));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
	}
};
var $author$project$LocalState$guildOrDmIdToMessagesCount = F3($author$project$LocalState$guildOrDmIdToMessagesCount$);
var $author$project$FrontendExtra$markConversationAsRead$ = function (guildOrDmId, threadRoute, local) {
	var _v0 = $author$project$LocalState$guildOrDmIdToMessagesCount$(guildOrDmId, threadRoute, local);
	if (!_v0.$) {
		var messages = _v0.a;
		return $elm$core$Maybe$Just(
			$author$project$Types$Local_SetLastViewed$(
				guildOrDmId,
				function () {
					if (threadRoute.$ === 1) {
						var threadMessageId = threadRoute.a;
						return $author$project$Id$ViewThreadWithMessage$(
							threadMessageId,
							$author$project$Id$fromInt(messages - 1));
					} else {
						return $author$project$Id$NoThreadWithMessage(
							$author$project$Id$fromInt(messages - 1));
					}
				}()));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$FrontendExtra$markConversationAsRead = F3($author$project$FrontendExtra$markConversationAsRead$);
var $author$project$Emoji$searchInputId = $lamdera$program_test$Effect$Browser$Dom$id('emoji_search_input');
var $author$project$Emoji$setSearch$ = function (text, model) {
	return _Utils_update(
		model,
		{emojiHovered: $elm$core$Maybe$Nothing, searchText: text});
};
var $author$project$Emoji$setSearch = F2($author$project$Emoji$setSearch$);
var $author$project$FrontendExtra$handleEscapeKeyHelper$ = function (model, loggedIn) {
	var loggedIn2 = $author$project$MessageMenu$close$(model, loggedIn);
	var isPingUserDropdownOpen = function () {
		var _v4 = loggedIn2.textInputFocus;
		if (!_v4.$) {
			var textInputFocus = _v4.a;
			if (_Utils_eq(textInputFocus.htmlId, $author$project$Emoji$searchInputId)) {
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(
						_Utils_update(
							loggedIn2,
							{
								emojiSelector: $author$project$Emoji$setSearch$('', loggedIn2.emojiSelector)
							}),
						$lamdera$program_test$Effect$Task$attempt$(
							function (result) {
								var _v5 = A2($elm$core$Debug$log, 'result', result);
								return $author$project$Types$RemoveFocus;
							},
							$lamdera$program_test$Effect$Browser$Dom$blur($author$project$Emoji$searchInputId))));
			} else {
				var _v6 = textInputFocus.dropdown;
				if (!_v6.$) {
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							_Utils_update(
								loggedIn2,
								{
									previousTextInputFocus: loggedIn2.textInputFocus,
									showEmojiSelector: $author$project$Types$EmojiSelectorHidden,
									textInputFocus: $elm$core$Maybe$Just(
										_Utils_update(
											textInputFocus,
											{dropdown: $elm$core$Maybe$Nothing}))
								}),
							$lamdera$program_test$Effect$Command$none));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	if (!isPingUserDropdownOpen.$) {
		var a = isPingUserDropdownOpen.a;
		return a;
	} else {
		var _v1 = loggedIn2.showEmojiSelector;
		if (!_v1.$) {
			var local = $author$project$Local$model(loggedIn2.localState);
			var _v2 = $author$project$Route$toGuildOrDmId$(local.localUser.session.userId, model.route);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var guildOrDmId = _v3.a;
				var threadRoute = _v3.b;
				var localChange = $author$project$FrontendExtra$markConversationAsRead$(guildOrDmId, threadRoute, local);
				return $author$project$FrontendExtra$handleLocalChange$(
					model.time,
					localChange,
					($lamdera$containers$SeqDict$member$(
						_Utils_Tuple2(guildOrDmId, threadRoute),
						loggedIn2.editMessage) || $lamdera$containers$SeqDict$member$(
						_Utils_Tuple2(guildOrDmId, $author$project$Id$NoThread),
						loggedIn2.editMessage)) ? _Utils_update(
						loggedIn2,
						{
							editMessage: $lamdera$containers$SeqDict$remove$(
								_Utils_Tuple2(guildOrDmId, $author$project$Id$NoThread),
								$lamdera$containers$SeqDict$remove$(
									_Utils_Tuple2(guildOrDmId, threadRoute),
									loggedIn2.editMessage))
						}) : _Utils_update(
						loggedIn2,
						{
							replyTo: $lamdera$containers$SeqDict$remove$(
								_Utils_Tuple2(guildOrDmId, threadRoute),
								loggedIn2.replyTo)
						}),
					$author$project$FrontendExtra$setFocus$(model, $author$project$Pages$Guild$channelTextInputId));
			} else {
				return _Utils_Tuple2(loggedIn2, $lamdera$program_test$Effect$Command$none);
			}
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					loggedIn2,
					{showEmojiSelector: $author$project$Types$EmojiSelectorHidden}),
				$lamdera$program_test$Effect$Command$none);
		}
	}
};
var $author$project$FrontendExtra$handleEscapeKeyHelper = F2($author$project$FrontendExtra$handleEscapeKeyHelper$);
var $author$project$UserAgent$isAndroid = function (device) {
	switch (device) {
		case 0:
			return false;
		case 1:
			return false;
		case 2:
			return true;
		case 3:
			return true;
		case 4:
			return false;
		case 5:
			return false;
		case 6:
			return false;
		case 7:
			return false;
		case 8:
			return false;
		case 9:
			return false;
		default:
			return false;
	}
};
var $lamdera$program_test$Effect$Browser$Navigation$pushUrl$ = function (key, url) {
	return $lamdera$program_test$Effect$Internal$NavigationPushUrl$(
		$lamdera$program_test$Effect$Browser$Navigation$toInternalKey(key),
		url);
};
var $lamdera$program_test$Effect$Browser$Navigation$pushUrl = F2($lamdera$program_test$Effect$Browser$Navigation$pushUrl$);
var $author$project$FrontendExtra$routePush$ = function (model, route) {
	return ($author$project$MyUi$isMobile(model) && (!$author$project$UserAgent$isAndroid(model.startupData.userAgent.device))) ? $author$project$FrontendExtra$routeRequest$(
		$elm$core$Maybe$Just(model.route),
		route,
		model) : _Utils_Tuple2(
		model,
		$lamdera$program_test$Effect$Browser$Navigation$pushUrl$(
			model.navigationKey,
			$author$project$Route$encode(route)));
};
var $author$project$FrontendExtra$routePush = F2($author$project$FrontendExtra$routePush$);
var $author$project$Route$setChannelHeaderTab$ = function (tab, route) {
	_v0$4:
	while (true) {
		switch (route.$) {
			case 5:
				var dmRoute = route.a;
				return $author$project$Route$DmRoute(
					_Utils_update(
						dmRoute,
						{tab: tab}));
			case 3:
				if (!route.b.$) {
					var guildId = route.a;
					var _v1 = route.b;
					var channelId = _v1.a;
					var threadRoute = _v1.b;
					var channelsVisible = route.c;
					var overlay = route.d;
					return $author$project$Route$GuildRoute$(
						guildId,
						$author$project$Route$ChannelRoute$(channelId, threadRoute, tab),
						channelsVisible,
						overlay);
				} else {
					break _v0$4;
				}
			case 4:
				var routeData = route.a;
				var _v2 = routeData.channelRoute;
				if (!_v2.$) {
					var channelId = _v2.a;
					var threadRoute = _v2.b;
					return $author$project$Route$DiscordGuildRoute(
						_Utils_update(
							routeData,
							{
								channelRoute: $author$project$Route$DiscordChannel_ChannelRoute$(channelId, threadRoute, tab)
							}));
				} else {
					return route;
				}
			case 6:
				var routeData = route.a;
				return $author$project$Route$DiscordDmRoute(
					_Utils_update(
						routeData,
						{tab: tab}));
			default:
				break _v0$4;
		}
	}
	return route;
};
var $author$project$Route$setChannelHeaderTab = F2($author$project$Route$setChannelHeaderTab$);
var $author$project$FrontendExtra$handleEscapeKey = function (model) {
	var _v0 = model.imageViewer;
	if (!_v0.$) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{imageViewer: $elm$core$Maybe$Nothing}),
			$lamdera$program_test$Effect$Command$none);
	} else {
		return (_Utils_eq(
			$author$project$Route$toOverlay(model.route),
			$elm$core$Maybe$Just(1)) || _Utils_eq(
			$author$project$Route$toOverlay(model.route),
			$elm$core$Maybe$Just(2))) ? $author$project$FrontendExtra$routePush$(
			model,
			$author$project$Route$setOverlay$($elm$core$Maybe$Nothing, model.route)) : (_Utils_eq(
			$author$project$Route$toChannelHeaderTab(model.route),
			$elm$core$Maybe$Just($author$project$UserSession$ChannelHeaderTab_Draw)) ? $author$project$FrontendExtra$routePush$(
			model,
			$author$project$Route$setChannelHeaderTab$($elm$core$Maybe$Nothing, model.route)) : $author$project$FrontendExtra$updateLoggedIn$(
			$author$project$FrontendExtra$handleEscapeKeyHelper(model),
			model));
	}
};
var $author$project$Types$CheckedSheepGameQuestionsDebounce$ = function (a, b) {
	return {$: 79, a: a, b: b};
};
var $author$project$Types$CheckedSheepGameQuestionsDebounce = F2($author$project$Types$CheckedSheepGameQuestionsDebounce$);
var $author$project$Types$CheckedSheepGameSaveDebounce$ = function (a, b, c, d) {
	return {$: 78, a: a, b: b, c: c, d: d};
};
var $author$project$Types$CheckedSheepGameSaveDebounce = F4($author$project$Types$CheckedSheepGameSaveDebounce$);
var $author$project$Types$EmojiSelectorForSheepGameReaction$ = function (a, b, c) {
	return {$: 5, a: a, b: b, c: c};
};
var $author$project$Types$EmojiSelectorForSheepGameReaction = F3($author$project$Types$EmojiSelectorForSheepGameReaction$);
var $author$project$Types$EmojiSelectorForWordSpellingGameReaction$ = function (a, b, c) {
	return {$: 6, a: a, b: b, c: c};
};
var $author$project$Types$EmojiSelectorForWordSpellingGameReaction = F3($author$project$Types$EmojiSelectorForWordSpellingGameReaction$);
var $author$project$Types$GameMsg = function (a) {
	return {$: 77, a: a};
};
var $author$project$Types$GotPositionForEmojiSelector_SheepGameInput$ = function (a, b) {
	return {$: 150, a: a, b: b};
};
var $author$project$Types$GotPositionForEmojiSelector_SheepGameInput = F2($author$project$Types$GotPositionForEmojiSelector_SheepGameInput$);
var $author$project$WordSpellingGame$GotWordDefinition$ = function (a, b) {
	return {$: 16, a: a, b: b};
};
var $author$project$WordSpellingGame$GotWordDefinition = F2($author$project$WordSpellingGame$GotWordDefinition$);
var $author$project$Message$RepliedToGame$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Message$RepliedToGame = F2($author$project$Message$RepliedToGame$);
var $author$project$Game$WordSpellingGameMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$SheepGame$inputId = function (input) {
	switch (input.$) {
		case 0:
			var questionId = input.a;
			return $lamdera$program_test$Effect$Browser$Dom$id(
				'sheepGame_question_' + $author$project$Id$toString(questionId));
		case 1:
			var questionId = input.a;
			return $lamdera$program_test$Effect$Browser$Dom$id(
				'sheepGame_answer_' + $author$project$Id$toString(questionId));
		default:
			var questionId = input.a;
			return $lamdera$program_test$Effect$Browser$Dom$id(
				'sheepGame_notes_' + $author$project$Id$toString(questionId));
	}
};
var $author$project$SheepGame$attachedFileTrackerId$ = function (input, fileId) {
	return 'sheepGameAttachedFile-' + ($lamdera$program_test$Effect$Browser$Dom$idToString(
		$author$project$SheepGame$inputId(input)) + ('-' + $author$project$Id$toString(fileId)));
};
var $author$project$SheepGame$attachedFileTrackerId = F2($author$project$SheepGame$attachedFileTrackerId$);
var $author$project$WordSpellingGame$partOfSpeechName = function (abbreviation) {
	switch (abbreviation) {
		case 'n':
			return 'noun';
		case 'v':
			return 'verb';
		case 'adj':
			return 'adjective';
		case 'adv':
			return 'adverb';
		case 'u':
			return 'other';
		default:
			return abbreviation;
	}
};
var $author$project$WordSpellingGame$groupDefinitions = function (definitions) {
	return $elm$core$List$foldl$(
		F2(
			function (definition, entries) {
				var _v0 = function () {
					var _v1 = $elm$core$String$split$('\u0009', definition);
					if ((_v1.b && _v1.b.b) && (!_v1.b.b.b)) {
						var abbreviation = _v1.a;
						var _v2 = _v1.b;
						var rest = _v2.a;
						return _Utils_Tuple2(
							$author$project$WordSpellingGame$partOfSpeechName(abbreviation),
							$elm$core$String$trim(rest));
					} else {
						return _Utils_Tuple2(
							'other',
							$elm$core$String$trim(definition));
					}
				}();
				var partOfSpeech = _v0.a;
				var text = _v0.b;
				return (text === '') ? entries : ($elm$core$List$any$(
					function (entry) {
						return _Utils_eq(entry.partOfSpeech, partOfSpeech);
					},
					entries) ? $elm$core$List$map$(
					function (entry) {
						return _Utils_eq(entry.partOfSpeech, partOfSpeech) ? _Utils_update(
							entry,
							{
								definitions: _Utils_ap(
									entry.definitions,
									_List_fromArray(
										[text]))
							}) : entry;
					},
					entries) : _Utils_ap(
					entries,
					_List_fromArray(
						[
							{
							definitions: _List_fromArray(
								[text]),
							partOfSpeech: partOfSpeech
						}
						])));
			}),
		_List_Nil,
		definitions);
};
var $author$project$WordSpellingGame$decodeDefinition = A2(
	$elm$json$Json$Decode$map,
	function (entries) {
		return $author$project$WordSpellingGame$groupDefinitions(
			$elm$core$List$concat(entries));
	},
	$elm$json$Json$Decode$list(
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$withDefault(_List_Nil),
			$elm$json$Json$Decode$maybe(
				A2(
					$elm$json$Json$Decode$field,
					'defs',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string))))));
var $author$project$WordSpellingGame$definitionApiUrl = function (word) {
	return 'https://api.datamuse.com/words?md=d&max=1&sp=' + $elm$url$Url$percentEncode(
		$elm$core$String$toLower(word));
};
var $author$project$ImageViewer$init = function (_v0) {
	var imageSize = _v0.imageSize;
	var url = _v0.url;
	return {imageSize: imageSize, imageUrl: url, interaction: $author$project$ImageViewer$NoInteraction, offsetX: 0, offsetY: 0, prevOffsetX: 0, prevOffsetY: 0, scale: 1, targetScale: 1, velocityX: 0, velocityY: 0, zoomFocusX: 0, zoomFocusY: 0};
};
var $author$project$SheepGame$inputContainerId = function (input) {
	switch (input.$) {
		case 0:
			var questionId = input.a;
			return $lamdera$program_test$Effect$Browser$Dom$id(
				'sheepGame_questionContainer_' + $author$project$Id$toString(questionId));
		case 1:
			var questionId = input.a;
			return $lamdera$program_test$Effect$Browser$Dom$id(
				'sheepGame_answerContainer_' + $author$project$Id$toString(questionId));
		default:
			var questionId = input.a;
			return $lamdera$program_test$Effect$Browser$Dom$id(
				'sheepGame_notesContainer_' + $author$project$Id$toString(questionId));
	}
};
var $author$project$Scroll$smoothScrollToTopOf$ = function (containerId, targetId) {
	return A2(
		$lamdera$program_test$Effect$Task$andThen,
		$elm$core$Basics$identity,
		$lamdera$program_test$Effect$Task$map3$(
			F3(
				function (target, container, _v0) {
					var viewport = _v0.viewport;
					return $author$project$Scroll$smoothScrollY$(containerId, 0, viewport.x, viewport.y, (viewport.y + target.element.y) - container.element.y);
				}),
			$lamdera$program_test$Effect$Browser$Dom$getElement(targetId),
			$lamdera$program_test$Effect$Browser$Dom$getElement(containerId),
			$lamdera$program_test$Effect$Browser$Dom$getViewportOf(containerId)));
};
var $author$project$Scroll$smoothScrollToTopOf = F2($author$project$Scroll$smoothScrollToTopOf$);
var $author$project$Frontend$scrollElementToTop = function (_v0) {
	var target = _v0.target;
	var container = _v0.container;
	return $lamdera$program_test$Effect$Task$attempt$(
		function (_v1) {
			return $author$project$Types$SetScrollToBottom;
		},
		$author$project$Scroll$smoothScrollToTopOf$(container, target));
};
var $author$project$SheepGame$GotAnswerFileUpload$ = function (a, b, c) {
	return {$: 2, a: a, b: b, c: c};
};
var $author$project$SheepGame$GotAnswerFileUpload = F3($author$project$SheepGame$GotAnswerFileUpload$);
var $author$project$SheepGame$GotAttachedFileUpload$ = function (a, b, c) {
	return {$: 6, a: a, b: b, c: c};
};
var $author$project$SheepGame$GotAttachedFileUpload = F3($author$project$SheepGame$GotAttachedFileUpload$);
var $author$project$SheepGame$GotNotesFileUpload$ = function (a, b, c) {
	return {$: 11, a: a, b: b, c: c};
};
var $author$project$SheepGame$GotNotesFileUpload = F3($author$project$SheepGame$GotNotesFileUpload$);
var $author$project$Game$SheepGameMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Game$SheepSetupMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Game$sheepGameFileUploaded$ = function (input, fileId, result) {
	switch (input.$) {
		case 0:
			var questionId = input.a;
			return $author$project$Game$SheepSetupMsg(
				$author$project$SheepGame$GotAttachedFileUpload$(questionId, fileId, result));
		case 1:
			var questionId = input.a;
			return $author$project$Game$SheepGameMsg(
				$author$project$SheepGame$GotAnswerFileUpload$(questionId, fileId, result));
		default:
			var questionId = input.a;
			return $author$project$Game$SheepGameMsg(
				$author$project$SheepGame$GotNotesFileUpload$(questionId, fileId, result));
	}
};
var $author$project$Game$sheepGameFileUploaded = F3($author$project$Game$sheepGameFileUploaded$);
var $author$project$SheepGame$GotAnswerFiles$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$SheepGame$GotAnswerFiles = F2($author$project$SheepGame$GotAnswerFiles$);
var $author$project$SheepGame$GotFilesToAttach$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$SheepGame$GotFilesToAttach = F2($author$project$SheepGame$GotFilesToAttach$);
var $author$project$SheepGame$GotNotesFiles$ = function (a, b) {
	return {$: 10, a: a, b: b};
};
var $author$project$SheepGame$GotNotesFiles = F2($author$project$SheepGame$GotNotesFiles$);
var $author$project$Game$sheepGameFilesToAttach$ = function (input, files) {
	switch (input.$) {
		case 0:
			var questionId = input.a;
			return $author$project$Game$SheepSetupMsg(
				$author$project$SheepGame$GotFilesToAttach$(questionId, files));
		case 1:
			var questionId = input.a;
			return $author$project$Game$SheepGameMsg(
				$author$project$SheepGame$GotAnswerFiles$(questionId, files));
		default:
			var questionId = input.a;
			return $author$project$Game$SheepGameMsg(
				$author$project$SheepGame$GotNotesFiles$(questionId, files));
	}
};
var $author$project$Game$sheepGameFilesToAttach = F2($author$project$Game$sheepGameFilesToAttach$);
var $author$project$Game$sheepGameInputSaveDelay = $ianmackenzie$elm_units$Duration$seconds(1);
var $author$project$Game$sheepGameQuestionsSaveDelay = $ianmackenzie$elm_units$Duration$seconds(1);
var $author$project$FileStatus$uploadGameFile$ = function (onResult, trackerId, file2) {
	return $lamdera$program_test$Effect$Http$riskyRequest(
		{
			body: $lamdera$program_test$Effect$Http$fileBody(file2),
			expect: $lamdera$program_test$Effect$Http$expectJson$(
				onResult,
				$miniBill$elm_codec$Codec$decoder($author$project$FileStatus$uploadResponseCodec)),
			headers: _List_Nil,
			method: 'POST',
			timeout: $elm$core$Maybe$Just($ianmackenzie$elm_units$Duration$minute),
			tracker: $elm$core$Maybe$Just(trackerId),
			url: $author$project$FileStatus$domain + '/file/upload'
		});
};
var $author$project$FileStatus$uploadGameFile = F3($author$project$FileStatus$uploadGameFile$);
var $author$project$Frontend$handleGameOutMsgs$ = function (outMsgs, model) {
	return $elm$core$List$foldl$(
		F2(
			function (outMsg, _v0) {
				var model2 = _v0.a;
				var cmds = _v0.b;
				switch (outMsg.$) {
					case 1:
						var text = outMsg.a;
						var _v2 = $author$project$Frontend$copyText$(text, model2);
						var copyModel = _v2.a;
						var copyCmd = _v2.b;
						return _Utils_Tuple2(
							copyModel,
							A2($elm$core$List$cons, copyCmd, cmds));
					case 2:
						var newSelected = outMsg.a;
						var _v3 = $author$project$FrontendExtra$routePush$(
							model2,
							$author$project$Route$setChannelHeaderTab$(
								$elm$core$Maybe$Just(
									$author$project$UserSession$ChannelHeaderTab_Games$(newSelected, $elm$core$Maybe$Nothing)),
								model2.route));
						var pushModel = _v3.a;
						var pushCmd = _v3.b;
						return _Utils_Tuple2(
							pushModel,
							A2($elm$core$List$cons, pushCmd, cmds));
					case 6:
						var matchId = outMsg.a;
						var repliedToGame = outMsg.b;
						var _v4 = $author$project$FrontendExtra$updateLoggedIn$(
							function (loggedIn) {
								var _v5 = $author$project$Route$toGuildOrDmId$(
									$author$project$Local$model(loggedIn.localState).localUser.session.userId,
									model2.route);
								if (!_v5.$) {
									var _v6 = _v5.a;
									var guildOrDmId = _v6.a;
									return _Utils_Tuple2(
										_Utils_update(
											loggedIn,
											{
												replyTo: $lamdera$containers$SeqDict$insert$(
													_Utils_Tuple2(guildOrDmId, $author$project$Id$NoThread),
													$author$project$Message$RepliedToGame$(matchId, repliedToGame),
													loggedIn.replyTo)
											}),
										$author$project$FrontendExtra$setFocus$(model2, $author$project$Pages$Guild$channelTextInputId));
								} else {
									return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
								}
							},
							model2);
						var replyModel = _v4.a;
						var replyCmd = _v4.b;
						return _Utils_Tuple2(
							replyModel,
							A2($elm$core$List$cons, replyCmd, cmds));
					case 0:
						return _Utils_Tuple2(model2, cmds);
					case 3:
						var htmlId = outMsg.a;
						return _Utils_Tuple2(
							model2,
							A2(
								$elm$core$List$cons,
								$author$project$Scroll$toBottomOfChannel$(htmlId, $author$project$Types$SetScrollToBottom),
								cmds));
					case 4:
						var scrollTo = outMsg.a;
						return _Utils_Tuple2(
							model2,
							A2(
								$elm$core$List$cons,
								$author$project$Frontend$scrollElementToTop(scrollTo),
								cmds));
					case 7:
						return _Utils_Tuple2(model2, cmds);
					case 8:
						var guildOrDmId = outMsg.a;
						var counter = outMsg.b;
						return _Utils_Tuple2(
							model2,
							A2(
								$elm$core$List$cons,
								$lamdera$program_test$Effect$Task$perform$(
									function (_v7) {
										return $author$project$Types$CheckedSheepGameQuestionsDebounce$(guildOrDmId, counter);
									},
									$lamdera$program_test$Effect$Process$sleep($author$project$Game$sheepGameQuestionsSaveDelay)),
								cmds));
					case 9:
						var guildOrDmId = outMsg.a;
						var matchId = outMsg.b;
						var input = outMsg.c;
						var counter = outMsg.d;
						return _Utils_Tuple2(
							model2,
							A2(
								$elm$core$List$cons,
								$lamdera$program_test$Effect$Task$perform$(
									function (_v8) {
										return $author$project$Types$CheckedSheepGameSaveDebounce$(guildOrDmId, matchId, input, counter);
									},
									$lamdera$program_test$Effect$Process$sleep($author$project$Game$sheepGameInputSaveDelay)),
								cmds));
					case 13:
						var input = outMsg.a;
						return _Utils_Tuple2(
							model2,
							A2(
								$elm$core$List$cons,
								$lamdera$program_test$Effect$File$Select$files$(
									_List_Nil,
									F2(
										function (file, files) {
											return $author$project$Types$GameMsg(
												$author$project$Game$sheepGameFilesToAttach$(
													input,
													$mgold$elm_nonempty_list$List$Nonempty$Nonempty$(file, files)));
										})),
								cmds));
					case 14:
						var input = outMsg.a;
						var files = outMsg.b;
						return _Utils_Tuple2(
							model2,
							A2(
								$elm$core$List$cons,
								$lamdera$program_test$Effect$Command$batch(
									$elm$core$List$map$(
										function (_v9) {
											var fileId = _v9.a;
											var file = _v9.b;
											return $author$project$FileStatus$uploadGameFile$(
												function (result) {
													return $author$project$Types$GameMsg(
														$author$project$Game$sheepGameFileUploaded$(input, fileId, result));
												},
												$author$project$SheepGame$attachedFileTrackerId$(input, fileId),
												file);
										},
										$mgold$elm_nonempty_list$List$Nonempty$toList(files))),
								cmds));
					case 15:
						var input = outMsg.a;
						var fileId = outMsg.b;
						return _Utils_Tuple2(
							model2,
							A2(
								$elm$core$List$cons,
								$lamdera$program_test$Effect$Http$cancel(
									$author$project$SheepGame$attachedFileTrackerId$(input, fileId)),
								cmds));
					case 16:
						var fileData = outMsg.a;
						var _v10 = $author$project$FrontendExtra$updateLoggedIn$(
							function (loggedIn) {
								return _Utils_Tuple2(
									_Utils_update(
										loggedIn,
										{
											showFileToUploadInfo: $elm$core$Maybe$Just(fileData)
										}),
									$lamdera$program_test$Effect$Command$none);
							},
							model2);
						var infoModel = _v10.a;
						var infoCmd = _v10.b;
						return _Utils_Tuple2(
							infoModel,
							A2($elm$core$List$cons, infoCmd, cmds));
					case 5:
						var word = outMsg.a;
						return _Utils_Tuple2(
							model2,
							A2(
								$elm$core$List$cons,
								$lamdera$program_test$Effect$Http$get(
									{
										expect: $lamdera$program_test$Effect$Http$expectJson$(
											function (result) {
												return $author$project$Types$GameMsg(
													$author$project$Game$WordSpellingGameMsg(
														$author$project$WordSpellingGame$GotWordDefinition$(word, result)));
											},
											$author$project$WordSpellingGame$decodeDefinition),
										url: $author$project$WordSpellingGame$definitionApiUrl(word)
									}),
								cmds));
					case 11:
						var guildOrDmId = outMsg.a;
						var matchId = outMsg.b;
						var target = outMsg.c;
						var _v11 = $author$project$FrontendExtra$updateLoggedIn$(
							function (loggedIn) {
								var emojiSelectorModel = loggedIn.emojiSelector;
								return _Utils_Tuple2(
									_Utils_update(
										loggedIn,
										{
											emojiSelector: _Utils_update(
												emojiSelectorModel,
												{category: $author$project$Emoji$selectorInit.category, searchText: ''}),
											showEmojiSelector: $author$project$Types$EmojiSelectorForSheepGameReaction$(guildOrDmId, matchId, target)
										}),
									$author$project$MyUi$isMobile(model2) ? $lamdera$program_test$Effect$Command$none : $lamdera$program_test$Effect$Task$attempt$(
										function (_v12) {
											return $author$project$Types$SetFocus;
										},
										$lamdera$program_test$Effect$Browser$Dom$focus($author$project$Emoji$searchInputId)));
							},
							model2);
						var selectorModel = _v11.a;
						var selectorCmd = _v11.b;
						return _Utils_Tuple2(
							selectorModel,
							A2($elm$core$List$cons, selectorCmd, cmds));
					case 12:
						var guildOrDmId = outMsg.a;
						var matchId = outMsg.b;
						var target = outMsg.c;
						var _v13 = $author$project$FrontendExtra$updateLoggedIn$(
							function (loggedIn) {
								var emojiSelectorModel = loggedIn.emojiSelector;
								return _Utils_Tuple2(
									_Utils_update(
										loggedIn,
										{
											emojiSelector: _Utils_update(
												emojiSelectorModel,
												{category: $author$project$Emoji$selectorInit.category, searchText: ''}),
											showEmojiSelector: $author$project$Types$EmojiSelectorForWordSpellingGameReaction$(guildOrDmId, matchId, target)
										}),
									$author$project$MyUi$isMobile(model2) ? $lamdera$program_test$Effect$Command$none : $lamdera$program_test$Effect$Task$attempt$(
										function (_v14) {
											return $author$project$Types$SetFocus;
										},
										$lamdera$program_test$Effect$Browser$Dom$focus($author$project$Emoji$searchInputId)));
							},
							model2);
						var selectorModel = _v13.a;
						var selectorCmd = _v13.b;
						return _Utils_Tuple2(
							selectorModel,
							A2($elm$core$List$cons, selectorCmd, cmds));
					case 17:
						var imageSize = outMsg.a.imageSize;
						var fileUrl = outMsg.a.fileUrl;
						return _Utils_Tuple2(
							_Utils_update(
								model2,
								{
									imageViewer: $elm$core$Maybe$Just(
										$author$project$ImageViewer$init(
											{imageSize: imageSize, url: fileUrl}))
								}),
							cmds);
					case 10:
						var input = outMsg.a;
						return _Utils_Tuple2(
							model2,
							A2(
								$elm$core$List$cons,
								$lamdera$program_test$Effect$Task$attempt$(
									$author$project$Types$GotPositionForEmojiSelector_SheepGameInput(input),
									$lamdera$program_test$Effect$Browser$Dom$getElement(
										$author$project$SheepGame$inputContainerId(input))),
								cmds));
					default:
						var htmlId = outMsg.a;
						return _Utils_Tuple2(
							model2,
							A2(
								$elm$core$List$cons,
								$author$project$FrontendExtra$setFocus$(model2, htmlId),
								cmds));
				}
			}),
		_Utils_Tuple2(model, _List_Nil),
		outMsgs);
};
var $author$project$Frontend$handleGameOutMsgs = F2($author$project$Frontend$handleGameOutMsgs$);
var $author$project$Frontend$handleManyMessagesDecrypted$ = function (requestId, results, loggedIn) {
	var decrypted = function () {
		var _v1 = $lamdera$containers$SeqDict$get$(requestId, loggedIn.encryptionRequests.pendingDecryptedManyMessages);
		if (!_v1.$) {
			var pending = _v1.a;
			return A3($elm$core$List$map2, $elm$core$Tuple$pair, pending.messageHashes, results);
		} else {
			return _List_Nil;
		}
	}();
	return _Utils_Tuple2(
		$author$project$FrontendExtra$fileDecryptedMessages$(
			decrypted,
			$author$project$FrontendExtra$mapEncryptionRequests$(
				function (requests) {
					return _Utils_update(
						requests,
						{
							pendingDecryptedManyMessages: $lamdera$containers$SeqDict$remove$(requestId, requests.pendingDecryptedManyMessages)
						});
				},
				loggedIn)),
		$lamdera$program_test$Effect$Command$batch(
			_List_fromArray(
				[
					function () {
					var _v0 = $elm$core$Maybe$andThen$(
						function ($) {
							return $.shiftScrollFrom;
						},
						$lamdera$containers$SeqDict$get$(requestId, loggedIn.encryptionRequests.pendingDecryptedManyMessages));
					if (!_v0.$) {
						var anchor = _v0.a;
						return $author$project$Ports$shiftScrollByElementDelta$($author$project$Pages$Guild$conversationContainerId, anchor);
					} else {
						return $author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn.channelScrollPosition);
					}
				}(),
					$author$project$FrontendExtra$storeDecryptedFileKeys(
					$elm$core$List$map$($elm$core$Tuple$second, decrypted))
				])));
};
var $author$project$Frontend$handleManyMessagesDecrypted = F3($author$project$Frontend$handleManyMessagesDecrypted$);
var $author$project$Types$MessageHover$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Types$MessageHover = F2($author$project$Types$MessageHover$);
var $author$project$Frontend$handleMouseEnteredMessage$ = function (guildOrDmId, threadRoute, model) {
	return $author$project$MyUi$isMobile(model) ? _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none) : $author$project$FrontendExtra$updateLoggedIn$(
		function (loggedIn) {
			return _Utils_Tuple2(
				function () {
					var _v0 = loggedIn.messageHover;
					if (_v0.$ === 2) {
						return loggedIn;
					} else {
						return _Utils_update(
							loggedIn,
							{
								messageHover: $author$project$Types$MessageHover$(guildOrDmId, threadRoute)
							});
					}
				}(),
				$lamdera$program_test$Effect$Command$none);
		},
		model);
};
var $author$project$Frontend$handleMouseEnteredMessage = F3($author$project$Frontend$handleMouseEnteredMessage$);
var $author$project$Frontend$handleMouseExitedMessage$ = function (guildOrDmId, threadRoute, model) {
	return $author$project$FrontendExtra$updateLoggedIn$(
		function (loggedIn) {
			return _Utils_Tuple2(
				_Utils_update(
					loggedIn,
					{
						messageHover: _Utils_eq(
							$author$project$Types$MessageHover$(guildOrDmId, threadRoute),
							loggedIn.messageHover) ? $author$project$Types$NoMessageHover : loggedIn.messageHover
					}),
				$lamdera$program_test$Effect$Command$none);
		},
		model);
};
var $author$project$Frontend$handleMouseExitedMessage = F3($author$project$Frontend$handleMouseExitedMessage$);
var $author$project$Message$CallStarted_NoReply$ = function (a, b, c) {
	return {$: 4, a: a, b: b, c: c};
};
var $author$project$Message$CallStarted_NoReply = F3($author$project$Message$CallStarted_NoReply$);
var $author$project$Message$DeletedMessage_NoReply = function (a) {
	return {$: 3, a: a};
};
var $author$project$Message$EncryptedUserTextMessage_NoReply = function (a) {
	return {$: 1, a: a};
};
var $author$project$Message$GoMatchStarted_NoReply$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$Message$GoMatchStarted_NoReply = F2($author$project$Message$GoMatchStarted_NoReply$);
var $author$project$Message$UserJoinedMessage_NoReply$ = function (a, b, c) {
	return {$: 2, a: a, b: b, c: c};
};
var $author$project$Message$UserJoinedMessage_NoReply = F3($author$project$Message$UserJoinedMessage_NoReply$);
var $author$project$Message$UserTextMessage_NoReply = function (a) {
	return {$: 0, a: a};
};
var $author$project$LocalState$toMessageNoReply = function (message) {
	switch (message.$) {
		case 0:
			var data = message.a;
			return $author$project$Message$UserTextMessage_NoReply(
				{content: data.content, createdAt: data.createdAt, createdBy: data.createdBy, editedAt: data.editedAt, reactions: data.reactions});
		case 1:
			var data = message.a;
			return $author$project$Message$EncryptedUserTextMessage_NoReply(
				{content: data.content, createdAt: data.createdAt, createdBy: data.createdBy, editedAt: data.editedAt, reactions: data.reactions});
		case 2:
			var time = message.a;
			var userId = message.b;
			var reactions = message.c;
			return $author$project$Message$UserJoinedMessage_NoReply$(time, userId, reactions);
		case 3:
			var time = message.a;
			return $author$project$Message$DeletedMessage_NoReply(time);
		case 4:
			var reactions = message.a.reactions;
			var startedBy = message.a.startedBy;
			var startedAt = message.a.startedAt;
			return $author$project$Message$CallStarted_NoReply$(startedAt, startedBy, reactions);
		default:
			var reactions = message.a.reactions;
			var startedAt = message.a.startedAt;
			return $author$project$Message$GoMatchStarted_NoReply$(startedAt, reactions);
	}
};
var $author$project$LocalState$latestMessagesHelper$ = function (count, channel) {
	var messageCount = $author$project$MessageArray$length(channel.messages);
	return $elm$core$List$map$(
		function (_v0) {
			var messageId = _v0.a;
			var message = _v0.b;
			return _Utils_Tuple2(
				$author$project$Id$toInt(messageId),
				$author$project$LocalState$toMessageNoReply(message));
		},
		$author$project$MessageArray$toList(
			$author$project$MessageArray$slice$(
				$author$project$Id$fromInt(
					$elm$core$Basics$max$(0, messageCount - count)),
				$author$project$Id$fromInt(messageCount),
				channel.messages)));
};
var $author$project$LocalState$latestMessagesHelper = F2($author$project$LocalState$latestMessagesHelper$);
var $author$project$LocalState$discordGuildOrDmIdToLatestMessages$ = function (count, guildOrDmId, threadRoute, local) {
	var helper2 = function (channel) {
		return $elm$core$Maybe$Just(
			$author$project$LocalState$latestMessagesHelper$(count, channel));
	};
	if (!guildOrDmId.$) {
		var id = guildOrDmId.a;
		var _v1 = $author$project$LocalState$getDiscordGuildAndChannel$(id.guildId, id.channelId, local);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var channel = _v2.b;
			if (threadRoute.$ === 1) {
				var threadMessageIndex = threadRoute.a;
				var _v4 = $lamdera$containers$SeqDict$get$(threadMessageIndex, channel.threads);
				if (!_v4.$) {
					var thread = _v4.a;
					return helper2(thread);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return helper2(channel);
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		var id = guildOrDmId.a;
		var _v5 = $lamdera$containers$SeqDict$get$(id.channelId, local.discordDmChannels);
		if (!_v5.$) {
			var dmChannel = _v5.a;
			return helper2(dmChannel);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$LocalState$discordGuildOrDmIdToLatestMessages = F4($author$project$LocalState$discordGuildOrDmIdToLatestMessages$);
var $author$project$FrontendExtra$editPreviousMessageLookback = 5;
var $author$project$LocalState$guildOrDmIdToLatestMessages$ = function (count, _v0, local) {
	var guildOrDmId = _v0.a;
	var threadRoute = _v0.b;
	var helper = function (channel) {
		if (threadRoute.$ === 1) {
			var threadMessageIndex = threadRoute.a;
			return $elm$core$Maybe$Just(
				$author$project$LocalState$latestMessagesHelper$(
					count,
					$elm$core$Maybe$withDefault$(
						$author$project$Thread$frontendInit,
						$lamdera$containers$SeqDict$get$(threadMessageIndex, channel.threads))));
		} else {
			return $elm$core$Maybe$Just(
				$author$project$LocalState$latestMessagesHelper$(count, channel));
		}
	};
	if (!guildOrDmId.$) {
		var id = guildOrDmId.a;
		var _v2 = $author$project$LocalState$getGuildAndChannel$(id, local);
		if (!_v2.$) {
			var _v3 = _v2.a;
			var channel = _v3.b;
			return helper(channel);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		var otherUserId = guildOrDmId.a.otherUserId;
		var _v4 = $lamdera$containers$SeqDict$get$(otherUserId, local.dmChannels);
		if (!_v4.$) {
			var dmChannel = _v4.a;
			return helper(dmChannel);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$LocalState$guildOrDmIdToLatestMessages = F3($author$project$LocalState$guildOrDmIdToLatestMessages$);
var $author$project$LocalState$slackGuildOrDmIdToLatestMessages$ = function (count, guildOrDmId, threadRoute, local) {
	var helper = function (conversation) {
		if (threadRoute.$ === 1) {
			var threadMessageIndex = threadRoute.a;
			return $elm$core$Maybe$map$(
				$author$project$LocalState$latestMessagesHelper(count),
				$lamdera$containers$SeqDict$get$(threadMessageIndex, conversation.threads));
		} else {
			return $elm$core$Maybe$Just(
				$author$project$LocalState$latestMessagesHelper$(count, conversation));
		}
	};
	if (!guildOrDmId.$) {
		var channelId = guildOrDmId.a.channelId;
		var teamId = guildOrDmId.a.teamId;
		return $elm$core$Maybe$andThen$(
			function (_v1) {
				var channel = _v1.b;
				return helper(channel);
			},
			$author$project$LocalState$getSlackWorkspaceAndChannel$(teamId, channelId, local));
	} else {
		var channelId = guildOrDmId.a.channelId;
		return $elm$core$Maybe$andThen$(
			helper,
			$lamdera$containers$SeqDict$get$(channelId, local.slackDmChannels));
	}
};
var $author$project$LocalState$slackGuildOrDmIdToLatestMessages = F4($author$project$LocalState$slackGuildOrDmIdToLatestMessages$);
var $author$project$FrontendExtra$handlePressedArrowUpInEmptyInput$ = function (model, guildOrDmId, threadRoute) {
	return $author$project$FrontendExtra$updateLoggedIn$(
		function (loggedIn) {
			var local = $author$project$Local$model(loggedIn.localState);
			switch (guildOrDmId.$) {
				case 0:
					var guildOrDmId2 = guildOrDmId.a;
					var maybeMessages = $author$project$LocalState$guildOrDmIdToLatestMessages$(
						$author$project$FrontendExtra$editPreviousMessageLookback,
						_Utils_Tuple2(guildOrDmId2, threadRoute),
						local);
					if (!maybeMessages.$) {
						var messages = maybeMessages.a;
						var mostRecentMessage = $elmcraft$core_extra$List$Extra$findMap$(
							function (_v5) {
								var index = _v5.a;
								var message = _v5.b;
								switch (message.$) {
									case 0:
										var data = message.a;
										return _Utils_eq(local.localUser.session.userId, data.createdBy) ? $elm$core$Maybe$Just(
											_Utils_Tuple2(
												$author$project$Id$fromInt(index),
												data)) : $elm$core$Maybe$Nothing;
									case 1:
										var data = message.a;
										var _v7 = _Utils_Tuple2(
											$lamdera$containers$SeqDict$get$(
												$author$project$Encryption$hash(data.content),
												local.localUser.decryptedMessages),
											_Utils_eq(local.localUser.session.userId, data.createdBy));
										if (((!_v7.a.$) && (!_v7.a.a.$)) && _v7.b) {
											var contentAndEmbeds = _v7.a.a.a;
											return $elm$core$Maybe$Just(
												_Utils_Tuple2(
													$author$project$Id$fromInt(index),
													{content: contentAndEmbeds, createdAt: data.createdAt, createdBy: data.createdBy, editedAt: data.editedAt, reactions: data.reactions}));
										} else {
											return $elm$core$Maybe$Nothing;
										}
									case 2:
										return $elm$core$Maybe$Nothing;
									case 3:
										return $elm$core$Maybe$Nothing;
									case 4:
										return $elm$core$Maybe$Nothing;
									default:
										return $elm$core$Maybe$Nothing;
								}
							},
							$elm$core$List$reverse(messages));
						if (!mostRecentMessage.$) {
							var _v3 = mostRecentMessage.a;
							var index = _v3.a;
							var message = _v3.b;
							return _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{
										editMessage: $lamdera$containers$SeqDict$insert$(
											_Utils_Tuple2(
												$author$project$Id$GuildOrDmId(guildOrDmId2),
												threadRoute),
											{
												attachedFiles: $lamdera$containers$SeqDict$map$(
													F2(
														function (_v4, a) {
															return $author$project$FileStatus$FileUploaded(a);
														}),
													message.content.attachedFiles),
												messageIndex: index,
												text: $author$project$RichText$toString$(
													local.localUser.timezone,
													false,
													$author$project$User$allUsers(local.localUser),
													$author$project$LocalState$channelMentions$(guildOrDmId2, local),
													message.content.content)
											},
											loggedIn.editMessage)
									}),
								$author$project$FrontendExtra$setFocus$(model, $author$project$MessageMenu$editMessageTextInputId));
						} else {
							return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
						}
					} else {
						return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
					}
				case 1:
					var guildOrDmId2 = guildOrDmId.a;
					var maybeMessages = $author$project$LocalState$discordGuildOrDmIdToLatestMessages$($author$project$FrontendExtra$editPreviousMessageLookback, guildOrDmId2, threadRoute, local);
					if (!maybeMessages.$) {
						var messages = maybeMessages.a;
						var currentUserId = function () {
							if (!guildOrDmId2.$) {
								var id = guildOrDmId2.a;
								return id.currentUserId;
							} else {
								var data = guildOrDmId2.a;
								return data.currentUserId;
							}
						}();
						var mostRecentMessage = $elmcraft$core_extra$List$Extra$findMap$(
							function (_v12) {
								var index = _v12.a;
								var message = _v12.b;
								switch (message.$) {
									case 0:
										var data = message.a;
										return _Utils_eq(currentUserId, data.createdBy) ? $elm$core$Maybe$Just(
											_Utils_Tuple2(
												$author$project$Id$fromInt(index),
												data)) : $elm$core$Maybe$Nothing;
									case 1:
										return $elm$core$Maybe$Nothing;
									case 2:
										return $elm$core$Maybe$Nothing;
									case 3:
										return $elm$core$Maybe$Nothing;
									case 4:
										return $elm$core$Maybe$Nothing;
									default:
										return $elm$core$Maybe$Nothing;
								}
							},
							$elm$core$List$reverse(messages));
						if (!mostRecentMessage.$) {
							var _v10 = mostRecentMessage.a;
							var index = _v10.a;
							var message = _v10.b;
							return _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{
										editMessage: $lamdera$containers$SeqDict$insert$(
											_Utils_Tuple2(
												$author$project$Id$DiscordGuildOrDmId(guildOrDmId2),
												threadRoute),
											{
												attachedFiles: $lamdera$containers$SeqDict$map$(
													F2(
														function (_v11, a) {
															return $author$project$FileStatus$FileUploaded(a);
														}),
													message.content.attachedFiles),
												messageIndex: index,
												text: $author$project$RichText$toString$(
													local.localUser.timezone,
													false,
													$author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(local.localUser.discordUsers),
													$author$project$LocalState$discordChannelMentions$(guildOrDmId2, local),
													message.content.content)
											},
											loggedIn.editMessage)
									}),
								$author$project$FrontendExtra$setFocus$(model, $author$project$MessageMenu$editMessageTextInputId));
						} else {
							return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
						}
					} else {
						return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
					}
				default:
					var guildOrDmId2 = guildOrDmId.a;
					var maybeMessages = $author$project$LocalState$slackGuildOrDmIdToLatestMessages$($author$project$FrontendExtra$editPreviousMessageLookback, guildOrDmId2, threadRoute, local);
					if (!maybeMessages.$) {
						var messages = maybeMessages.a;
						var currentUserId = function () {
							if (!guildOrDmId2.$) {
								var id = guildOrDmId2.a;
								return id.currentUserId;
							} else {
								var data = guildOrDmId2.a;
								return data.currentUserId;
							}
						}();
						var mostRecentMessage = $elmcraft$core_extra$List$Extra$findMap$(
							function (_v19) {
								var index = _v19.a;
								var message = _v19.b;
								switch (message.$) {
									case 0:
										var data = message.a;
										return _Utils_eq(currentUserId, data.createdBy) ? $elm$core$Maybe$Just(
											_Utils_Tuple2(
												$author$project$Id$fromInt(index),
												data)) : $elm$core$Maybe$Nothing;
									case 1:
										return $elm$core$Maybe$Nothing;
									case 2:
										return $elm$core$Maybe$Nothing;
									case 3:
										return $elm$core$Maybe$Nothing;
									case 4:
										return $elm$core$Maybe$Nothing;
									default:
										return $elm$core$Maybe$Nothing;
								}
							},
							$elm$core$List$reverse(messages));
						if (!mostRecentMessage.$) {
							var _v17 = mostRecentMessage.a;
							var index = _v17.a;
							var message = _v17.b;
							return _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{
										editMessage: $lamdera$containers$SeqDict$insert$(
											_Utils_Tuple2(
												$author$project$Id$SlackGuildOrDmId(guildOrDmId2),
												threadRoute),
											{
												attachedFiles: $lamdera$containers$SeqDict$map$(
													F2(
														function (_v18, a) {
															return $author$project$FileStatus$FileUploaded(a);
														}),
													message.content.attachedFiles),
												messageIndex: index,
												text: $author$project$RichText$toString$(
													local.localUser.timezone,
													false,
													local.localUser.slackUsers,
													$author$project$LocalState$slackChannelMentions$(guildOrDmId2, local),
													message.content.content)
											},
											loggedIn.editMessage)
									}),
								$author$project$FrontendExtra$setFocus$(model, $author$project$MessageMenu$editMessageTextInputId));
						} else {
							return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
						}
					} else {
						return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
					}
			}
		},
		model);
};
var $author$project$FrontendExtra$handlePressedArrowUpInEmptyInput = F3($author$project$FrontendExtra$handlePressedArrowUpInEmptyInput$);
var $author$project$Frontend$handlePressedChannelMention$ = function (guildOrDmId, channelId, threadRoute, model) {
	if ((!guildOrDmId.$) && (!guildOrDmId.a.$)) {
		var guildId = guildOrDmId.a.a.guildId;
		return $author$project$FrontendExtra$routePush$(
			model,
			$author$project$Route$GuildRoute$(
				guildId,
				$author$project$Route$ChannelRoute$(
					channelId,
					$author$project$Route$threadRouteWithFriends(threadRoute),
					$elm$core$Maybe$Nothing),
				0,
				$elm$core$Maybe$Nothing));
	} else {
		return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
	}
};
var $author$project$Frontend$handlePressedChannelMention = F4($author$project$Frontend$handlePressedChannelMention$);
var $author$project$Frontend$handlePressedDiscordChannelMention$ = function (guildOrDmId, channelId, threadRoute, model) {
	if ((guildOrDmId.$ === 1) && (!guildOrDmId.a.$)) {
		var currentUserId = guildOrDmId.a.a.currentUserId;
		var guildId = guildOrDmId.a.a.guildId;
		return $author$project$FrontendExtra$routePush$(
			model,
			$author$project$Route$DiscordGuildRoute(
				{
					channelRoute: $author$project$Route$DiscordChannel_ChannelRoute$(
						channelId,
						$author$project$Route$threadRouteWithFriends(threadRoute),
						$elm$core$Maybe$Nothing),
					channelsVisible: 0,
					currentDiscordUserId: currentUserId,
					guildId: guildId,
					overlay: $elm$core$Maybe$Nothing
				}));
	} else {
		return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
	}
};
var $author$project$Frontend$handlePressedDiscordChannelMention = F4($author$project$Frontend$handlePressedDiscordChannelMention$);
var $author$project$Frontend$handlePressedDiscordUserIconButton$ = function (otherUserId, model) {
	var _v0 = model.loginStatus;
	if (!_v0.$) {
		var loggedIn = _v0.a;
		var _v1 = $author$project$LocalState$discordDmChannelWithUser$(
			otherUserId,
			$author$project$Local$model(loggedIn.localState));
		if (!_v1.$) {
			var _v2 = _v1.a;
			var currentDiscordUserId = _v2.a;
			var channelId = _v2.b;
			return $author$project$FrontendExtra$routePush$(
				model,
				$author$project$Route$DiscordDmRoute(
					{channelId: channelId, channelsVisible: 0, currentDiscordUserId: currentDiscordUserId, overlay: $elm$core$Maybe$Nothing, showMembersTab: 1, tab: $elm$core$Maybe$Nothing, viewingMessage: $elm$core$Maybe$Nothing}));
		} else {
			return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
		}
	} else {
		return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
	}
};
var $author$project$Frontend$handlePressedDiscordUserIconButton = F2($author$project$Frontend$handlePressedDiscordUserIconButton$);
var $author$project$Frontend$handlePressedNonWhitelistLink$ = function (url, model) {
	return $author$project$FrontendExtra$updateLoggedIn$(
		function (loggedIn) {
			return _Utils_Tuple2(
				_Utils_update(
					loggedIn,
					{
						externalLinkWarning: $elm$core$Maybe$Just(url)
					}),
				$lamdera$program_test$Effect$Command$none);
		},
		model);
};
var $author$project$Frontend$handlePressedNonWhitelistLink = F2($author$project$Frontend$handlePressedNonWhitelistLink$);
var $author$project$FrontendExtra$handlePressedTextInput = function (model) {
	return $author$project$FrontendExtra$updateLoggedIn$(
		function (loggedIn) {
			return _Utils_Tuple2(
				_Utils_update(
					loggedIn,
					{drawingMode: $author$project$Drawing$NoSelectedAnchor}),
				$lamdera$program_test$Effect$Command$none);
		},
		model);
};
var $author$project$Frontend$handlePressedUserIconButton$ = function (otherUserId, model) {
	var _v0 = model.loginStatus;
	if (!_v0.$) {
		var loggedIn = _v0.a;
		return $author$project$FrontendExtra$routePush$(
			model,
			$author$project$Route$DmRoute(
				{
					channelId: $author$project$DmChannelId$fromUserIds$(
						$author$project$Local$model(loggedIn.localState).localUser.session.userId,
						otherUserId),
					channelsVisible: 0,
					overlay: $elm$core$Maybe$Nothing,
					tab: $elm$core$Maybe$Nothing,
					threadRoute: $author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1)
				}));
	} else {
		return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
	}
};
var $author$project$Frontend$handlePressedUserIconButton = F2($author$project$Frontend$handlePressedUserIconButton$);
var $author$project$Types$Local_Drawing$ = function (a, b, c) {
	return {$: 58, a: a, b: b, c: c};
};
var $author$project$Types$Local_Drawing = F3($author$project$Types$Local_Drawing$);
var $author$project$Drawing$RedoStroke = {$: 4};
var $author$project$Drawing$canRedo$ = function (userId, drawing) {
	var _v0 = $lamdera$containers$SeqDict$get$(userId, drawing.undone);
	if ((!_v0.$) && _v0.a.b) {
		var _v1 = _v0.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$Drawing$canRedo = F2($author$project$Drawing$canRedo$);
var $author$project$Drawing$canUndo$ = function (userId, drawing) {
	return $elm$core$List$any$(
		function (finished) {
			return _Utils_eq(finished.createdBy, userId);
		},
		drawing.finished);
};
var $author$project$Drawing$canUndo = F2($author$project$Drawing$canUndo$);
var $author$project$Message$userTextMessageDrawing$ = function (anchor, data) {
	var data2 = $elm$core$Maybe$withDefault$($author$project$Message$noDrawings, data);
	switch (anchor.$) {
		case 0:
			return data2.userIconDrawings;
		case 1:
			return data2.timestampDrawings;
		case 2:
			var fileId = anchor.a;
			return $elm$core$Maybe$withDefault$(
				$author$project$Drawing$emptyDrawing,
				$lamdera$containers$SeqDict$get$(fileId, data2.imageAttachmentDrawings));
		case 3:
			var embedIndex = anchor.a;
			return $elm$core$Maybe$withDefault$(
				$author$project$Drawing$emptyDrawing,
				$lamdera$containers$SeqDict$get$(embedIndex, data2.embedDrawings));
		default:
			return $author$project$Drawing$emptyDrawing;
	}
};
var $author$project$Message$userTextMessageDrawing = F2($author$project$Message$userTextMessageDrawing$);
var $author$project$Message$drawing$ = function (anchor, message) {
	switch (message.$) {
		case 0:
			var data = message.a;
			return $author$project$Message$userTextMessageDrawing$(anchor, data.drawings);
		case 1:
			var data = message.a;
			return $author$project$Message$userTextMessageDrawing$(anchor, data.drawings);
		case 2:
			var drawings = message.d;
			return drawings;
		case 3:
			return $author$project$Drawing$emptyDrawing;
		case 4:
			var callStarted = message.a;
			switch (anchor.$) {
				case 0:
					return $author$project$Drawing$emptyDrawing;
				case 1:
					return callStarted.timestampDrawings;
				case 2:
					return $author$project$Drawing$emptyDrawing;
				case 3:
					return $author$project$Drawing$emptyDrawing;
				default:
					return callStarted.cardDrawings;
			}
		default:
			var gameStarted = message.a;
			switch (anchor.$) {
				case 0:
					return $author$project$Drawing$emptyDrawing;
				case 1:
					return gameStarted.timestampDrawings;
				case 2:
					return $author$project$Drawing$emptyDrawing;
				case 3:
					return $author$project$Drawing$emptyDrawing;
				default:
					return gameStarted.cardDrawings;
			}
	}
};
var $author$project$Message$drawing = F2($author$project$Message$drawing$);
var $author$project$ChannelHeader$drawingCanUndoOrRedo$ = function (guildOrDmId, anchor, local) {
	var noThreadHelper = F4(
		function (userId, anchor2, messageId, channel2) {
			var _v15 = $author$project$MessageArray$get$(messageId, channel2.messages);
			if (!_v15.$) {
				var message = _v15.a;
				var drawing = $author$project$Message$drawing$(anchor2, message);
				return _Utils_Tuple2(
					$author$project$Drawing$canUndo$(userId, drawing),
					$author$project$Drawing$canRedo$(userId, drawing));
			} else {
				return _Utils_Tuple2(false, false);
			}
		});
	var helper = F2(
		function (userId, channel2) {
			if (!anchor.$) {
				var threadRoute = anchor.a;
				var anchor2 = anchor.b;
				if (!threadRoute.$) {
					var messageId = threadRoute.a;
					return A4(noThreadHelper, userId, anchor2, messageId, channel2);
				} else {
					var threadId = threadRoute.a;
					var messageId = threadRoute.b;
					return A4(
						noThreadHelper,
						userId,
						anchor2,
						messageId,
						$elm$core$Maybe$withDefault$(
							$author$project$Thread$frontendInit,
							$lamdera$containers$SeqDict$get$(threadId, channel2.threads)));
				}
			} else {
				var threadRoute = anchor.a;
				var date = anchor.b;
				if (!threadRoute.$) {
					var _v13 = $lamdera$containers$SeqDict$get$(date, channel2.dateDividerDrawings);
					if (!_v13.$) {
						var drawing = _v13.a;
						return _Utils_Tuple2(
							$author$project$Drawing$canUndo$(userId, drawing),
							$author$project$Drawing$canRedo$(userId, drawing));
					} else {
						return _Utils_Tuple2(false, false);
					}
				} else {
					var threadId = threadRoute.a;
					var _v14 = $lamdera$containers$SeqDict$get$(
						date,
						$elm$core$Maybe$withDefault$(
							$author$project$Thread$frontendInit,
							$lamdera$containers$SeqDict$get$(threadId, channel2.threads)).dateDividerDrawings);
					if (!_v14.$) {
						var drawing = _v14.a;
						return _Utils_Tuple2(
							$author$project$Drawing$canUndo$(userId, drawing),
							$author$project$Drawing$canRedo$(userId, drawing));
					} else {
						return _Utils_Tuple2(false, false);
					}
				}
			}
		});
	switch (guildOrDmId.$) {
		case 0:
			if (!guildOrDmId.a.$) {
				var channelId = guildOrDmId.a.a.channelId;
				var guildId = guildOrDmId.a.a.guildId;
				var _v1 = $author$project$LocalState$getGuildAndChannel$(
					{channelId: channelId, guildId: guildId},
					local);
				if (!_v1.$) {
					var _v2 = _v1.a;
					var channel2 = _v2.b;
					return A2(helper, local.localUser.session.userId, channel2);
				} else {
					return _Utils_Tuple2(false, false);
				}
			} else {
				var otherUserId = guildOrDmId.a.a.otherUserId;
				var _v3 = $lamdera$containers$SeqDict$get$(otherUserId, local.dmChannels);
				if (!_v3.$) {
					var channel2 = _v3.a;
					return A2(helper, local.localUser.session.userId, channel2);
				} else {
					return _Utils_Tuple2(false, false);
				}
			}
		case 1:
			if (!guildOrDmId.a.$) {
				var channelId = guildOrDmId.a.a.channelId;
				var guildId = guildOrDmId.a.a.guildId;
				var currentUserId = guildOrDmId.a.a.currentUserId;
				var _v4 = $author$project$LocalState$getDiscordGuildAndChannel$(guildId, channelId, local);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var channel2 = _v5.b;
					return A2(helper, currentUserId, channel2);
				} else {
					return _Utils_Tuple2(false, false);
				}
			} else {
				var data = guildOrDmId.a.a;
				var _v6 = $lamdera$containers$SeqDict$get$(data.channelId, local.discordDmChannels);
				if (!_v6.$) {
					var channel2 = _v6.a;
					_v7$2:
					while (true) {
						if (!anchor.$) {
							if (!anchor.a.$) {
								var messageId = anchor.a.a;
								var anchor2 = anchor.b;
								return A4(noThreadHelper, data.currentUserId, anchor2, messageId, channel2);
							} else {
								break _v7$2;
							}
						} else {
							if (!anchor.a.$) {
								var _v8 = anchor.a;
								var date = anchor.b;
								var _v9 = $lamdera$containers$SeqDict$get$(date, channel2.dateDividerDrawings);
								if (!_v9.$) {
									var drawing = _v9.a;
									return _Utils_Tuple2(
										$author$project$Drawing$canUndo$(data.currentUserId, drawing),
										$author$project$Drawing$canRedo$(data.currentUserId, drawing));
								} else {
									return _Utils_Tuple2(false, false);
								}
							} else {
								break _v7$2;
							}
						}
					}
					return _Utils_Tuple2(false, false);
				} else {
					return _Utils_Tuple2(false, false);
				}
			}
		default:
			return _Utils_Tuple2(false, false);
	}
};
var $author$project$ChannelHeader$drawingCanUndoOrRedo = F3($author$project$ChannelHeader$drawingCanUndoOrRedo$);
var $author$project$FrontendExtra$drawingRedo$ = function (selected, loggedIn, model) {
	var _v0 = $author$project$ChannelHeader$drawingCanUndoOrRedo$(
		selected.guildOrDmId,
		selected.anchorType,
		$author$project$Local$model(loggedIn.localState));
	var canRedo = _v0.b;
	return canRedo ? $author$project$FrontendExtra$handleLocalChange$(
		model.time,
		$elm$core$Maybe$Just(
			$author$project$Types$Local_Drawing$(selected.guildOrDmId, selected.anchorType, $author$project$Drawing$RedoStroke)),
		loggedIn,
		$lamdera$program_test$Effect$Command$none) : _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
};
var $author$project$FrontendExtra$drawingRedo = F3($author$project$FrontendExtra$drawingRedo$);
var $author$project$FrontendExtra$handleRedo = function (model) {
	return $author$project$FrontendExtra$updateLoggedIn$(
		function (loggedIn) {
			var _v0 = loggedIn.drawingMode;
			if (!_v0.$) {
				return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
			} else {
				var selected = _v0.a;
				return $author$project$FrontendExtra$drawingRedo$(selected, loggedIn, model);
			}
		},
		model);
};
var $author$project$Frontend$handleRevealSpoilers$ = function (guildOrDmId, threadRoute, spoilerIndex, model) {
	return $author$project$FrontendExtra$updateLoggedIn$(
		function (loggedIn) {
			return _Utils_Tuple2(
				_Utils_update(
					loggedIn,
					{
						revealedSpoilers: $lamdera$containers$SeqDict$update$(
							guildOrDmId,
							function (maybe) {
								var _v0 = function () {
									if (!maybe.$) {
										var a = maybe.a;
										return a;
									} else {
										return {messages: $lamdera$containers$SeqDict$empty, threadMessages: $lamdera$containers$SeqDict$empty};
									}
								}();
								var threadMessages = _v0.threadMessages;
								var messages = _v0.messages;
								return $elm$core$Maybe$Just(
									function () {
										if (threadRoute.$ === 1) {
											var threadMessageIndex = threadRoute.a;
											var messageId = threadRoute.b;
											return {
												messages: messages,
												threadMessages: $lamdera$containers$SeqDict$update$(
													threadMessageIndex,
													function (maybe2) {
														return $elm$core$Maybe$Just(
															$author$project$SeqDictHelper$addToSet$(
																messageId,
																spoilerIndex,
																$elm$core$Maybe$withDefault$($lamdera$containers$SeqDict$empty, maybe2)));
													},
													threadMessages)
											};
										} else {
											var messageId = threadRoute.a;
											return {
												messages: $author$project$SeqDictHelper$addToSet$(messageId, spoilerIndex, messages),
												threadMessages: threadMessages
											};
										}
									}());
							},
							loggedIn.revealedSpoilers)
					}),
				$lamdera$program_test$Effect$Command$none);
		},
		model);
};
var $author$project$Frontend$handleRevealSpoilers = F4($author$project$Frontend$handleRevealSpoilers$);
var $author$project$Types$OneFrameAfterDragEnd = {$: 84};
var $ianmackenzie$elm_units$Quantity$divideBy$ = function (divisor, _v0) {
	var value = _v0;
	return value / divisor;
};
var $ianmackenzie$elm_units$Quantity$divideBy = F2($ianmackenzie$elm_units$Quantity$divideBy$);
var $author$project$WordSpellingGame$CancelPremove = {$: 4};
var $author$project$Go$dragEnd = function (model) {
	return model;
};
var $author$project$WordSpellingGame$cellOccupiedByOtherTile$ = function (draggedIndex, cell, tiles) {
	return $elm$core$List$any$(
		function (_v0) {
			var index = _v0.a;
			var tile = _v0.b;
			var _v1 = tile.position;
			if (_v1.$ === 1) {
				var pos = _v1.a;
				return (!_Utils_eq(index, draggedIndex)) && _Utils_eq(pos, cell);
			} else {
				return false;
			}
		},
		$elm$core$Array$toIndexedList(tiles));
};
var $author$project$WordSpellingGame$cellOccupiedByOtherTile = F3($author$project$WordSpellingGame$cellOccupiedByOtherTile$);
var $author$project$WordSpellingGame$distanceToTray$ = function (setup, windowSize, coord, slotCount) {
	var top = $author$project$WordSpellingGame$trayY$(setup.traySize, windowSize);
	var left = $author$project$WordSpellingGame$trayX(windowSize);
	var right = (left + $elm$core$Basics$round(
		slotCount * $author$project$WordSpellingGame$trayTileSize$(setup.traySize, windowSize))) + ((slotCount - 1) * $author$project$WordSpellingGame$trayTileSpacing);
	var dx = $elm$core$Basics$max$(
		0,
		$elm$core$Basics$max$(
			left - $author$project$Coord$xRaw(coord),
			$author$project$Coord$xRaw(coord) - right));
	var bottom = top + $author$project$WordSpellingGame$trayHeight$(setup.traySize, windowSize);
	var dy = $elm$core$Basics$max$(
		0,
		$elm$core$Basics$max$(
			top - $author$project$Coord$yRaw(coord),
			$author$project$Coord$yRaw(coord) - bottom));
	return $elm$core$Basics$sqrt((dx * dx) + (dy * dy));
};
var $author$project$WordSpellingGame$distanceToTray = F4($author$project$WordSpellingGame$distanceToTray$);
var $author$project$WordSpellingGame$firstOpenTrayIndex$ = function (draggedIndex, tiles) {
	var occupied = $elm$core$List$filterMap$(
		function (_v0) {
			var index = _v0.a;
			var tile = _v0.b;
			if (_Utils_eq(
				$elm$core$Maybe$Just(index),
				draggedIndex)) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v1 = tile.position;
				if (!_v1.$) {
					var trayIndex = _v1.a;
					return $elm$core$Maybe$Just(trayIndex);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		},
		$elm$core$Array$toIndexedList(tiles));
	var find = function (n) {
		find:
		while (true) {
			if ($elm$core$List$member$(n, occupied)) {
				var $temp$n = n + 1;
				n = $temp$n;
				continue find;
			} else {
				return n;
			}
		}
	};
	return find(0);
};
var $author$project$WordSpellingGame$firstOpenTrayIndex = F2($author$project$WordSpellingGame$firstOpenTrayIndex$);
var $author$project$WordSpellingGame$maxTraySnapDistance = 100;
var $author$project$WordSpellingGame$withZoomAnimation$ = function (time, before, after) {
	return _Utils_eq(
		$author$project$WordSpellingGame$zoomTarget(before),
		$author$project$WordSpellingGame$zoomTarget(after)) ? after : _Utils_update(
		after,
		{
			zoomAnimation: {
				from: $author$project$WordSpellingGame$animatedZoomState$(time, before),
				start: time
			}
		});
};
var $author$project$WordSpellingGame$withZoomAnimation = F3($author$project$WordSpellingGame$withZoomAnimation$);
var $author$project$WordSpellingGame$dragEnd$ = function (currentTime, windowSize, currentUserId, newTouches, setup, shared, oldModel) {
	var model = _Utils_update(
		oldModel,
		{
			tiles: $author$project$WordSpellingGame$getTiles$(windowSize, currentUserId, setup, shared, oldModel.tiles)
		});
	var _v0 = model.dragging;
	if (!_v0.$) {
		var tileIndex = _v0.a;
		var shouldEndPremove = function (newPosition) {
			var _v2 = _Utils_Tuple2(
				$author$project$WordSpellingGame$getPlayer$(currentUserId, shared),
				$elm$core$Array$get$(tileIndex, model.tiles));
			if ((!_v2.a.$) && (!_v2.b.$)) {
				var player = _v2.a.a;
				var tile = _v2.b.a;
				var _v3 = _Utils_Tuple2(player.premove, tile.position);
				if ((!_v3.a.$) && (_v3.b.$ === 1)) {
					var _v4 = _v3.a.a;
					var result = _v4.b;
					var _v5 = _v3.b;
					var _v6 = _v5.a;
					var x = _v6.a;
					var y = _v6.b;
					return $elm$core$List$any$(
						function (_v7) {
							var _v8 = _v7.a;
							var xA = _v8.a;
							var yA = _v8.b;
							return _Utils_eq(xA, x) && _Utils_eq(yA, y);
						},
						result.placedCells) ? (!_Utils_eq(
						newPosition,
						$elm$core$Maybe$Just(
							_Utils_Tuple2(x, y)))) : false;
				} else {
					return false;
				}
			} else {
				return false;
			}
		};
		var position = $author$project$Touch$touchCentroid(newTouches);
		var returnToTray = _Utils_Tuple2(
			$author$project$WordSpellingGame$withZoomAnimation$(
				currentTime,
				model,
				(_Utils_cmp(
					$author$project$WordSpellingGame$distanceToTray$(
						setup,
						windowSize,
						position,
						$elm$core$Array$length(model.tiles)),
					$author$project$WordSpellingGame$maxTraySnapDistance) < 1) ? _Utils_update(
					model,
					{
						dragging: $author$project$WordSpellingGame$NotDragging,
						tiles: $author$project$WordSpellingGame$insertIntoTray$(currentTime, windowSize, tileIndex, position, setup, model.tiles)
					}) : _Utils_update(
					model,
					{
						dragging: $author$project$WordSpellingGame$NotDragging,
						tiles: $elmcraft$core_extra$Array$Extra$update$(
							tileIndex,
							function (tile) {
								return _Utils_update(
									tile,
									{
										position: $author$project$WordSpellingGame$TileInTray$(
											$author$project$WordSpellingGame$firstOpenTrayIndex$(
												$elm$core$Maybe$Just(tileIndex),
												model.tiles),
											$elm$core$Maybe$Nothing)
									});
							},
							model.tiles)
					})),
			shouldEndPremove($elm$core$Maybe$Nothing));
		var _v1 = $author$project$WordSpellingGame$boardCellAtPosition$(currentTime, windowSize, setup, model, position);
		if (!_v1.$) {
			var cell = _v1.a;
			return ($lamdera$containers$SeqDict$member$(cell, shared.board) || $author$project$WordSpellingGame$cellOccupiedByOtherTile$(tileIndex, cell, model.tiles)) ? returnToTray : _Utils_Tuple2(
				$author$project$WordSpellingGame$withZoomAnimation$(
					currentTime,
					model,
					_Utils_update(
						model,
						{
							dragging: $author$project$WordSpellingGame$NotDragging,
							tiles: $elmcraft$core_extra$Array$Extra$update$(
								tileIndex,
								function (tile) {
									return _Utils_update(
										tile,
										{
											position: $author$project$WordSpellingGame$TileOnBoard$(cell, currentTime)
										});
								},
								model.tiles)
						})),
				shouldEndPremove(
					$elm$core$Maybe$Just(cell)));
		} else {
			return returnToTray;
		}
	} else {
		return _Utils_Tuple2(model, false);
	}
};
var $author$project$WordSpellingGame$dragEnd = F7($author$project$WordSpellingGame$dragEnd$);
var $author$project$Game$dragEnd$ = function (time, windowSize, currentUserId, touches, matchId, matchData, model) {
	var _v0 = _Utils_Tuple2(
		matchData,
		$lamdera$containers$SeqDict$get$(matchId, model.startedGames));
	if (!_v0.b.$) {
		if (!_v0.a.$) {
			var matchData2 = _v0.a.a;
			var game = _v0.b.a;
			var _v1 = function () {
				var _v2 = matchData2.data;
				switch (_v2.$) {
					case 0:
						return _Utils_Tuple2(
							function () {
								if (!game.$) {
									var game2 = game.a;
									return $author$project$Game$GoModel_Game(
										$author$project$Go$dragEnd(game2));
								} else {
									return game;
								}
							}(),
							$elm$core$Maybe$Nothing);
					case 1:
						var setup = _v2.a;
						var shared = _v2.c;
						if (game.$ === 1) {
							var game2 = game.a;
							var _v5 = $author$project$WordSpellingGame$dragEnd$(time, windowSize, currentUserId, touches, setup, shared, game2);
							var game3 = _v5.a;
							var shouldEndPremove = _v5.b;
							return _Utils_Tuple2(
								$author$project$Game$WordSpellingGame_Game(game3),
								shouldEndPremove ? $elm$core$Maybe$Just(
									$author$project$Game$LocalChange_WordSpellingGame$(
										matchId,
										$author$project$WordSpellingGame$Action(
											{change: $author$project$WordSpellingGame$CancelPremove, time: time, userId: currentUserId}))) : $elm$core$Maybe$Nothing);
						} else {
							return _Utils_Tuple2(game, $elm$core$Maybe$Nothing);
						}
					default:
						return _Utils_Tuple2(game, $elm$core$Maybe$Nothing);
				}
			}();
			var game4 = _v1.a;
			var outMsg = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						startedGames: $lamdera$containers$SeqDict$insert$(matchId, game4, model.startedGames)
					}),
				outMsg);
		} else {
			return _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
		}
	} else {
		var _v6 = _v0.b;
		return _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
	}
};
var $author$project$Game$dragEnd = F7($author$project$Game$dragEnd$);
var $author$project$Frontend$finalizeWordSpellingDrag$ = function (time, model, loggedIn) {
	var _v0 = model.drag;
	if (_v0.$ === 2) {
		var dragging = _v0.a;
		var _v1 = dragging.target;
		if (_v1 === 2) {
			var _v2 = $author$project$FrontendExtra$currentGame$(
				$author$project$Local$model(loggedIn.localState),
				model);
			if (!_v2.$) {
				var match = _v2.a.match;
				var matchId = _v2.a.matchId;
				var guildOrDmId = _v2.a.guildOrDmId;
				var _v3 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.games);
				if (!_v3.$) {
					var game = _v3.a;
					var _v4 = $author$project$Game$dragEnd$(
						time,
						model.windowSize,
						$author$project$Local$model(loggedIn.localState).localUser.session.userId,
						$author$project$Touch$removeSafeAreaTopInset$(model.startupData.safeAreaInsetTop, dragging.touches),
						matchId,
						match,
						game);
					var game2 = _v4.a;
					var outMsg = _v4.b;
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$map$(
							$author$project$Types$Local_Game(guildOrDmId),
							outMsg),
						_Utils_update(
							loggedIn,
							{
								games: $lamdera$containers$SeqDict$insert$(guildOrDmId, game2, loggedIn.games)
							}),
						$lamdera$program_test$Effect$Command$none);
				} else {
					return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
				}
			} else {
				return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
			}
		} else {
			return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
		}
	} else {
		return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
	}
};
var $author$project$Frontend$finalizeWordSpellingDrag = F3($author$project$Frontend$finalizeWordSpellingDrag$);
var $ianmackenzie$elm_units$Quantity$lessThan$ = function (_v0, _v1) {
	var y = _v0;
	var x = _v1;
	return _Utils_cmp(x, y) < 0;
};
var $ianmackenzie$elm_units$Quantity$lessThan = F2($ianmackenzie$elm_units$Quantity$lessThan$);
var $author$project$MessageMenu$mobileMenuMaxHeight$ = function (extraOptions, local, model) {
	return $author$project$CssPixels$cssPixels(
		$author$project$MessageMenu$mobileMenuMaxHeightHelper(
			$author$project$MessageMenu$menuItems$(true, extraOptions.guildOrDmId, extraOptions.threadRoute, false, extraOptions.imageUrl, extraOptions.linkUrl, $author$project$Coord$origin, local, model)));
};
var $author$project$MessageMenu$mobileMenuMaxHeight = F3($author$project$MessageMenu$mobileMenuMaxHeight$);
var $ianmackenzie$elm_units$Quantity$per$ = function (_v0, _v1) {
	var independentValue = _v0;
	var dependentValue = _v1;
	return dependentValue / independentValue;
};
var $ianmackenzie$elm_units$Quantity$per = F2($ianmackenzie$elm_units$Quantity$per$);
var $ianmackenzie$elm_units$Quantity$rate$ = function (_v0, _v1) {
	var dependentValue = _v0;
	var independentValue = _v1;
	return dependentValue / independentValue;
};
var $ianmackenzie$elm_units$Quantity$rate = F2($ianmackenzie$elm_units$Quantity$rate$);
var $author$project$Route$setChannelsVisible$ = function (channelsVisible, route) {
	switch (route.$) {
		case 3:
			var guildId = route.a;
			var channelRoute = route.b;
			var overlay = route.d;
			return $author$project$Route$GuildRoute$(guildId, channelRoute, channelsVisible, overlay);
		case 4:
			var routeData = route.a;
			return $author$project$Route$DiscordGuildRoute(
				_Utils_update(
					routeData,
					{channelsVisible: channelsVisible}));
		case 0:
			return route;
		case 1:
			return route;
		case 2:
			return route;
		case 5:
			var dmRouteData = route.a;
			return $author$project$Route$DmRoute(
				_Utils_update(
					dmRouteData,
					{channelsVisible: channelsVisible}));
		case 6:
			var routeData = route.a;
			return $author$project$Route$DiscordDmRoute(
				_Utils_update(
					routeData,
					{channelsVisible: channelsVisible}));
		case 7:
			var routeData = route.a;
			return $author$project$Route$SlackWorkspaceRoute(
				_Utils_update(
					routeData,
					{channelsVisible: channelsVisible}));
		case 8:
			var routeData = route.a;
			return $author$project$Route$SlackDmRoute(
				_Utils_update(
					routeData,
					{channelsVisible: channelsVisible}));
		case 9:
			return route;
		case 10:
			return route;
		case 11:
			return route;
		case 12:
			return route;
		default:
			return route;
	}
};
var $author$project$Route$setChannelsVisible = F2($author$project$Route$setChannelsVisible$);
var $author$project$Route$threadRouteWithShowMembers$ = function (showMembers, threadRoute) {
	if (!threadRoute.$) {
		var a = threadRoute.a;
		return $author$project$Route$NoThreadWithFriends$(a, showMembers);
	} else {
		var threadId = threadRoute.a;
		var a = threadRoute.b;
		return $author$project$Route$ViewThreadWithFriends$(threadId, a, showMembers);
	}
};
var $author$project$Route$threadRouteWithShowMembers = F2($author$project$Route$threadRouteWithShowMembers$);
var $author$project$Route$setShowMembers$ = function (showMembers, route) {
	_v0$5:
	while (true) {
		switch (route.$) {
			case 3:
				if (!route.b.$) {
					var guildId = route.a;
					var _v1 = route.b;
					var channelId = _v1.a;
					var threadRoute = _v1.b;
					var tab = _v1.c;
					var channelsVisible = route.c;
					var overlay = route.d;
					return $author$project$Route$GuildRoute$(
						guildId,
						$author$project$Route$ChannelRoute$(
							channelId,
							$author$project$Route$threadRouteWithShowMembers$(showMembers, threadRoute),
							tab),
						channelsVisible,
						overlay);
				} else {
					break _v0$5;
				}
			case 4:
				var routeData = route.a;
				var channelRoute = routeData.channelRoute;
				if (!channelRoute.$) {
					var channelId = channelRoute.a;
					var threadRoute = channelRoute.b;
					var tab = channelRoute.c;
					return $author$project$Route$DiscordGuildRoute(
						_Utils_update(
							routeData,
							{
								channelRoute: $author$project$Route$DiscordChannel_ChannelRoute$(
									channelId,
									$author$project$Route$threadRouteWithShowMembers$(showMembers, threadRoute),
									tab)
							}));
				} else {
					return route;
				}
			case 5:
				var routeData = route.a;
				return $author$project$Route$DmRoute(
					_Utils_update(
						routeData,
						{
							threadRoute: $author$project$Route$threadRouteWithShowMembers$(showMembers, routeData.threadRoute)
						}));
			case 6:
				var routeData = route.a;
				return $author$project$Route$DiscordDmRoute(
					_Utils_update(
						routeData,
						{showMembersTab: showMembers}));
			case 7:
				var routeData = route.a;
				var _v3 = routeData.channelRoute;
				if (!_v3.$) {
					var channelId = _v3.a;
					var threadRoute = _v3.b;
					return $author$project$Route$SlackWorkspaceRoute(
						_Utils_update(
							routeData,
							{
								channelRoute: $author$project$Route$SlackChannel_ChannelRoute$(channelId, threadRoute, showMembers)
							}));
				} else {
					return route;
				}
			default:
				break _v0$5;
		}
	}
	return route;
};
var $author$project$Route$setShowMembers = F2($author$project$Route$setShowMembers$);
var $author$project$Frontend$releasedSidebarDrag$ = function (time, model) {
	var _v0 = model.loginStatus;
	if (!_v0.$) {
		var loggedIn = _v0.a;
		var _v1 = loggedIn.sidebarMode;
		if (_v1.$ === 1) {
			var a = _v1.a;
			var sidebarDelta = $ianmackenzie$elm_units$Quantity$per$(
				$ianmackenzie$elm_units$Duration$from$(a.time, time),
				$author$project$CssPixels$cssPixels(
					$author$project$Coord$xRaw(model.windowSize) * (a.offset - a.previousOffset)));
			var range = $author$project$Frontend$channelSidebarDragRange(model.route);
			var landsOnTheNearSide = $ianmackenzie$elm_units$Quantity$lessThan$(
				$ianmackenzie$elm_units$Quantity$unsafe(-100),
				sidebarDelta) || ((_Utils_cmp(a.offset, range.min + 0.5) < 0) && $ianmackenzie$elm_units$Quantity$lessThan$(
				$ianmackenzie$elm_units$Quantity$unsafe(100),
				sidebarDelta));
			return $elm$core$Maybe$Just(
				function () {
					var _v2 = $author$project$Route$toShowMembersTab(model.route);
					if (!_v2.a) {
						var _v3 = _v2.a;
						return landsOnTheNearSide ? model.route : $author$project$Route$setShowMembers$(1, model.route);
					} else {
						var _v4 = _v2.a;
						return $author$project$Route$setChannelsVisible$(
							landsOnTheNearSide ? 0 : 1,
							model.route);
					}
				}());
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Frontend$releasedSidebarDrag = F2($author$project$Frontend$releasedSidebarDrag$);
var $author$project$Frontend$handleTouchEnd$ = function (time, model) {
	return function (_v5) {
		var newModel = _v5.a;
		var cmd = _v5.b;
		var _v6 = $author$project$Frontend$releasedSidebarDrag$(time, model);
		if (!_v6.$) {
			var route = _v6.a;
			return _Utils_eq(route, newModel.route) ? _Utils_Tuple2(newModel, cmd) : $elm$core$Tuple$mapSecond$(
				function (routeCmd) {
					return $lamdera$program_test$Effect$Command$batch(
						_List_fromArray(
							[cmd, routeCmd]));
				},
				$author$project$FrontendExtra$routePush$(newModel, route));
		} else {
			return _Utils_Tuple2(newModel, cmd);
		}
	}(
		$author$project$FrontendExtra$updateLoggedIn$(
			function (loggedIn) {
				var loggedIn2 = function () {
					var _v4 = loggedIn.sidebarMode;
					if (_v4.$ === 1) {
						var a = _v4.a;
						return _Utils_update(
							loggedIn,
							{
								sidebarMode: $author$project$Route$ChannelSidebarNotDragging(
									{offset: a.offset})
							});
					} else {
						return loggedIn;
					}
				}();
				var _v0 = $author$project$Frontend$finalizeWordSpellingDrag$(
					time,
					model,
					function () {
						var _v1 = loggedIn2.messageHover;
						switch (_v1.$) {
							case 2:
								var extraOptions = _v1.a;
								var _v2 = extraOptions.mobileMode;
								if (_v2.$ === 2) {
									var dragging = _v2.a;
									var speedThreshold = $ianmackenzie$elm_units$Quantity$rate$(
										$author$project$CssPixels$cssPixels(-100),
										$ianmackenzie$elm_units$Duration$second);
									var menuHeight = $author$project$MessageMenu$mobileMenuMaxHeight$(
										extraOptions,
										$author$project$Local$model(loggedIn2.localState),
										model);
									var halfwayPoint = $ianmackenzie$elm_units$Quantity$divideBy$(2, menuHeight);
									var delta = $ianmackenzie$elm_units$Duration$from$(dragging.time, time);
									var menuDelta = $ianmackenzie$elm_units$Quantity$per$(
										delta,
										$ianmackenzie$elm_units$Quantity$minus$(dragging.previousOffset, dragging.offset));
									return ($ianmackenzie$elm_units$Quantity$lessThan$(halfwayPoint, dragging.offset) || $ianmackenzie$elm_units$Quantity$lessThan$(speedThreshold, menuDelta)) ? $author$project$MessageMenu$close$(model, loggedIn2) : _Utils_update(
										loggedIn2,
										{
											messageHover: $author$project$Types$MessageMenu(
												_Utils_update(
													extraOptions,
													{
														mobileMode: $author$project$Types$MessageMenuFixed(
															$ianmackenzie$elm_units$Quantity$min$(menuHeight, dragging.offset))
													}))
										});
								} else {
									return loggedIn2;
								}
							case 0:
								return loggedIn2;
							case 1:
								return loggedIn2;
							default:
								return loggedIn2;
						}
					}());
				var loggedIn3 = _v0.a;
				var cmds = _v0.b;
				return _Utils_Tuple2(
					loggedIn3,
					$lamdera$program_test$Effect$Command$batch(
						_List_fromArray(
							[
								$lamdera$program_test$Effect$Task$perform$(
								function (_v3) {
									return $author$project$Types$OneFrameAfterDragEnd;
								},
								$lamdera$program_test$Effect$Process$sleep(
									$ianmackenzie$elm_units$Duration$milliseconds(30))),
								cmds
							])));
			},
			_Utils_update(
				model,
				{drag: $author$project$Touch$NoDrag, dragPrevious: model.drag})));
};
var $author$project$Frontend$handleTouchEnd = F2($author$project$Frontend$handleTouchEnd$);
var $author$project$Drawing$UndoStroke = {$: 3};
var $author$project$FrontendExtra$drawingUndo$ = function (selected, loggedIn, model) {
	var _v0 = $author$project$ChannelHeader$drawingCanUndoOrRedo$(
		selected.guildOrDmId,
		selected.anchorType,
		$author$project$Local$model(loggedIn.localState));
	var canUndo = _v0.a;
	return canUndo ? $author$project$FrontendExtra$handleLocalChange$(
		model.time,
		$elm$core$Maybe$Just(
			$author$project$Types$Local_Drawing$(selected.guildOrDmId, selected.anchorType, $author$project$Drawing$UndoStroke)),
		loggedIn,
		$lamdera$program_test$Effect$Command$none) : _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
};
var $author$project$FrontendExtra$drawingUndo = F3($author$project$FrontendExtra$drawingUndo$);
var $author$project$FrontendExtra$handleUndo = function (model) {
	return $author$project$FrontendExtra$updateLoggedIn$(
		function (loggedIn) {
			var _v0 = loggedIn.drawingMode;
			if (!_v0.$) {
				return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
			} else {
				var selected = _v0.a;
				return $author$project$FrontendExtra$drawingUndo$(selected, loggedIn, model);
			}
		},
		model);
};
var $author$project$Ports$haptic_feedback = _Platform_outgoingPort('haptic_feedback', $elm$core$Basics$identity);
var $author$project$Ports$hapticFeedback = A3($lamdera$program_test$Effect$Command$sendToJs, 'haptic_feedback', $author$project$Ports$haptic_feedback, $elm$json$Json$Encode$null);
var $author$project$FileStatus$hasUploadingFile = function (dict) {
	return $elm$core$List$any$(
		function (_v0) {
			var status = _v0.b;
			switch (status.$) {
				case 0:
					return true;
				case 1:
					return false;
				default:
					return false;
			}
		},
		$lamdera$containers$SeqDict$toList(dict));
};
var $author$project$LoginForm$EnterEmail = function (a) {
	return {$: 0, a: a};
};
var $author$project$LoginForm$init = $author$project$LoginForm$EnterEmail(
	{email: '', pressedSubmitEmail: false, rateLimited: false, showSignupsDisabled: false, showUserIsDeleted: false});
var $author$project$Emoji$toString = function (emoji) {
	var text = emoji;
	return text;
};
var $author$project$Emoji$emojiWithSkinTone$ = function (maybeSkinTone, emoji, emojiData2) {
	if (!maybeSkinTone.$) {
		var skinTone = maybeSkinTone.a;
		var _v1 = $lamdera$containers$SeqDict$get$(emoji, emojiData2.emojis);
		if (!_v1.$) {
			var emojiData3 = _v1.a;
			var _v2 = emojiData3.skinVariations;
			if (!_v2.$) {
				var skinVariation = _v2.a;
				return $elm$core$String$replace$(
					$author$project$Emoji$skinToneToString(0),
					$author$project$Emoji$skinToneToString(skinTone),
					skinVariation);
			} else {
				return $author$project$Emoji$toString(emoji);
			}
		} else {
			return $author$project$Emoji$toString(emoji);
		}
	} else {
		return $author$project$Emoji$toString(emoji);
	}
};
var $author$project$Emoji$emojiWithSkinTone = F3($author$project$Emoji$emojiWithSkinTone$);
var $author$project$Frontend$insertEmojiOrSticker$ = function (inputId, maybeSelection, emojiOrSticker, model, loggedIn) {
	var text = function () {
		switch (emojiOrSticker.$) {
			case 0:
				var emoji = emojiOrSticker.a;
				var _v2 = model.emojiData;
				if (!_v2.$) {
					var emojiData = _v2.a;
					return $author$project$Emoji$emojiWithSkinTone$(
						$author$project$Local$model(loggedIn.localState).localUser.user.emojiConfig.skinTone,
						emoji,
						emojiData) + ' ';
				} else {
					return '';
				}
			case 1:
				var stickerId = emojiOrSticker.a;
				return $author$project$Sticker$idToString(stickerId);
			default:
				var customEmojiId = emojiOrSticker.a;
				return $author$project$CustomEmoji$idToString(customEmojiId);
		}
	}();
	return _Utils_Tuple2(
		_Utils_update(
			loggedIn,
			{showEmojiSelector: $author$project$Types$EmojiSelectorHidden}),
		function () {
			if (!maybeSelection.$) {
				var range = maybeSelection.a;
				return $author$project$Ports$execCommand(
					{
						commands: _List_fromArray(
							[
								$author$project$Ports$InsertText$(text, range)
							]),
						htmlId: inputId
					});
			} else {
				return $author$project$Ports$execCommand(
					{
						commands: _List_fromArray(
							[
								$author$project$Ports$InsertText$(
								text,
								{end: 99999, start: 99999})
							]),
						htmlId: inputId
					});
			}
		}());
};
var $author$project$Frontend$insertEmojiOrSticker = F5($author$project$Frontend$insertEmojiOrSticker$);
var $author$project$MessageInput$tabText = '  ';
var $author$project$MessageInput$insertTab$ = function (range, text) {
	return _Utils_ap(
		$elm$core$String$left$(range.start, text),
		_Utils_ap(
			$author$project$MessageInput$tabText,
			$elm$core$String$dropLeft$(range.end, text)));
};
var $author$project$MessageInput$insertTab = F2($author$project$MessageInput$insertTab$);
var $author$project$Frontend$isReleasingReactionLongPress$ = function (guildOrDmId, threadRoute, loggedIn) {
	var _v0 = loggedIn.messageHover;
	switch (_v0.$) {
		case 3:
			var guildOrDmIdA = _v0.a;
			var threadRouteA = _v0.b;
			return _Utils_eq(guildOrDmId, guildOrDmIdA) && _Utils_eq(threadRoute, threadRouteA);
		case 0:
			return false;
		case 1:
			return false;
		default:
			return false;
	}
};
var $author$project$Frontend$isReleasingReactionLongPress = F3($author$project$Frontend$isReleasingReactionLongPress$);
var $author$project$FrontendExtra$isShowingNewestMessages$ = function (guildOrDmId, threadRoute, local) {
	var _v0 = $author$project$FrontendExtra$conversationWindow$(guildOrDmId, threadRoute, local);
	if (!_v0.$) {
		switch (_v0.a.$) {
			case 0:
				var _v1 = _v0.a;
				var visibleMessages = _v1.b;
				var messageCount = _v1.c;
				return $author$project$VisibleMessages$reachesEnd$(messageCount, visibleMessages);
			case 1:
				var _v2 = _v0.a;
				var visibleMessages = _v2.c;
				var messageCount = _v2.d;
				return $author$project$VisibleMessages$reachesEnd$(messageCount, visibleMessages);
			case 2:
				var _v3 = _v0.a;
				var visibleMessages = _v3.b;
				var messageCount = _v3.c;
				return $author$project$VisibleMessages$reachesEnd$(messageCount, visibleMessages);
			case 3:
				var _v4 = _v0.a;
				var visibleMessages = _v4.c;
				var messageCount = _v4.d;
				return $author$project$VisibleMessages$reachesEnd$(messageCount, visibleMessages);
			case 4:
				var _v5 = _v0.a;
				var visibleMessages = _v5.b;
				var messageCount = _v5.c;
				return $author$project$VisibleMessages$reachesEnd$(messageCount, visibleMessages);
			default:
				var _v6 = _v0.a;
				var visibleMessages = _v6.c;
				var messageCount = _v6.d;
				return $author$project$VisibleMessages$reachesEnd$(messageCount, visibleMessages);
		}
	} else {
		return true;
	}
};
var $author$project$FrontendExtra$isShowingNewestMessages = F3($author$project$FrontendExtra$isShowingNewestMessages$);
var $author$project$NonemptyDict$any$ = function (f, _v0) {
	var k1 = _v0.a;
	var v1 = _v0.b;
	var dict = _v0.c;
	return A2(f, k1, v1) || $lamdera$containers$SeqDict$foldl$(
		F3(
			function (k, v, acc) {
				return acc || A2(f, k, v);
			}),
		false,
		dict);
};
var $author$project$NonemptyDict$any = F2($author$project$NonemptyDict$any$);
var $author$project$Frontend$isTouchingTextInput = function (touches) {
	return $author$project$NonemptyDict$any$(
		F2(
			function (_v0, touch) {
				return touch.targetIsTextInput;
			}),
		touches);
};
var $author$project$MessageInput$commonPrefixLength$ = function (count, listA, listB) {
	commonPrefixLength:
	while (true) {
		var _v0 = _Utils_Tuple2(listA, listB);
		if (_v0.a.b && _v0.b.b) {
			var _v1 = _v0.a;
			var headA = _v1.a;
			var restA = _v1.b;
			var _v2 = _v0.b;
			var headB = _v2.a;
			var restB = _v2.b;
			if (_Utils_eq(headA, headB)) {
				var $temp$count = count + 1,
					$temp$listA = restA,
					$temp$listB = restB;
				count = $temp$count;
				listA = $temp$listA;
				listB = $temp$listB;
				continue commonPrefixLength;
			} else {
				return count;
			}
		} else {
			return count;
		}
	}
};
var $author$project$MessageInput$commonPrefixLength = F3($author$project$MessageInput$commonPrefixLength$);
var $author$project$MessageInput$largePasteThreshold = 1000;
var $author$project$RichText$maxLength = 2000;
var $author$project$MessageInput$largePastedText$ = function (previousText, text) {
	if (_Utils_cmp(
		$elm$core$String$length(text),
		$author$project$RichText$maxLength) > 0) {
		var previousChars = $elm$core$String$toList(previousText);
		var chars = $elm$core$String$toList(text);
		var prefixLength = $author$project$MessageInput$commonPrefixLength$(0, previousChars, chars);
		var suffixLength = $author$project$MessageInput$commonPrefixLength$(
			0,
			$elm$core$List$reverse(
				$elm$core$List$drop$(prefixLength, previousChars)),
			$elm$core$List$reverse(
				$elm$core$List$drop$(prefixLength, chars)));
		var pastedText = $elm$core$String$fromList(
			$elm$core$List$take$(
				($elm$core$List$length(chars) - prefixLength) - suffixLength,
				$elm$core$List$drop$(prefixLength, chars)));
		return (_Utils_cmp(
			$elm$core$String$length(pastedText),
			$author$project$MessageInput$largePasteThreshold) > 0) ? $elm$core$Maybe$Just(
			{
				pastedText: pastedText,
				textAfterPaste: $elm$core$String$fromList(
					$elm$core$List$drop$(
						$elm$core$List$length(chars) - suffixLength,
						chars)),
				textBeforePaste: $elm$core$String$fromList(
					$elm$core$List$take$(prefixLength, chars))
			}) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$MessageInput$largePastedText = F2($author$project$MessageInput$largePastedText$);
var $author$project$Call$leaveVoiceChatCmds = function (model) {
	var _v0 = model.currentRoom;
	if (!_v0.$) {
		return $author$project$Call$toJs($author$project$Call$ToJs_LeaveCall);
	} else {
		return $lamdera$program_test$Effect$Command$none;
	}
};
var $ianmackenzie$elm_units$Quantity$lessThanOrEqualToZero = function (_v0) {
	var x = _v0;
	return x <= 0;
};
var $lamdera$program_test$Effect$Browser$Navigation$load = $lamdera$program_test$Effect$Internal$NavigationLoad;
var $author$project$Frontend$loadNewerMessages$ = function (guildOrDmId, threadRoute, local) {
	var messagesLeft = F3(
		function (visibleMessages, messageCount, localChange) {
			return ($author$project$VisibleMessages$reachesEnd$(messageCount, visibleMessages) || visibleMessages.loadingMessages) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(localChange);
		});
	var firstNewMessage = function (visibleMessages) {
		return $author$project$VisibleMessages$PageFrom(
			$author$project$Id$fromInt(
				$author$project$Id$toInt(visibleMessages.oldest) + visibleMessages.count));
	};
	var _v0 = $author$project$FrontendExtra$conversationWindow$(guildOrDmId, threadRoute, local);
	if (!_v0.$) {
		switch (_v0.a.$) {
			case 0:
				var _v1 = _v0.a;
				var guildOrDmId2 = _v1.a;
				var visibleMessages = _v1.b;
				var messageCount = _v1.c;
				return A3(
					messagesLeft,
					visibleMessages,
					messageCount,
					$author$project$Types$Local_LoadChannelMessages$(
						guildOrDmId2,
						firstNewMessage(visibleMessages),
						$author$project$UserSession$EmptyPlaceholder));
			case 1:
				var _v2 = _v0.a;
				var guildOrDmId2 = _v2.a;
				var threadId = _v2.b;
				var visibleMessages = _v2.c;
				var messageCount = _v2.d;
				return A3(
					messagesLeft,
					visibleMessages,
					messageCount,
					$author$project$Types$Local_LoadThreadMessages$(
						guildOrDmId2,
						threadId,
						firstNewMessage(visibleMessages),
						$author$project$UserSession$EmptyPlaceholder));
			case 2:
				var _v3 = _v0.a;
				var guildOrDmId2 = _v3.a;
				var visibleMessages = _v3.b;
				var messageCount = _v3.c;
				return A3(
					messagesLeft,
					visibleMessages,
					messageCount,
					$author$project$Types$Local_Discord_LoadChannelMessages$(
						guildOrDmId2,
						firstNewMessage(visibleMessages),
						$author$project$UserSession$EmptyPlaceholder));
			case 3:
				var _v4 = _v0.a;
				var guildOrDmId2 = _v4.a;
				var threadId = _v4.b;
				var visibleMessages = _v4.c;
				var messageCount = _v4.d;
				return A3(
					messagesLeft,
					visibleMessages,
					messageCount,
					$author$project$Types$Local_Discord_LoadThreadMessages$(
						guildOrDmId2,
						threadId,
						firstNewMessage(visibleMessages),
						$author$project$UserSession$EmptyPlaceholder));
			case 4:
				var _v5 = _v0.a;
				var guildOrDmId2 = _v5.a;
				var visibleMessages = _v5.b;
				var messageCount = _v5.c;
				return A3(
					messagesLeft,
					visibleMessages,
					messageCount,
					$author$project$Types$Local_Slack_LoadChannelMessages$(
						guildOrDmId2,
						firstNewMessage(visibleMessages),
						$author$project$UserSession$EmptyPlaceholder));
			default:
				var _v6 = _v0.a;
				var guildOrDmId2 = _v6.a;
				var threadId = _v6.b;
				var visibleMessages = _v6.c;
				var messageCount = _v6.d;
				return A3(
					messagesLeft,
					visibleMessages,
					messageCount,
					$author$project$Types$Local_Slack_LoadThreadMessages$(
						guildOrDmId2,
						threadId,
						firstNewMessage(visibleMessages),
						$author$project$UserSession$EmptyPlaceholder));
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Frontend$loadNewerMessages = F3($author$project$Frontend$loadNewerMessages$);
var $author$project$VisibleMessages$PageBefore = function (a) {
	return {$: 0, a: a};
};
var $author$project$Frontend$loadOlderMessages$ = function (guildOrDmId, threadRoute, local) {
	var messagesLeft = F2(
		function (visibleMessages, localChange) {
			return ($author$project$Id$toInt(visibleMessages.oldest) > 0) ? $elm$core$Maybe$Just(localChange) : $elm$core$Maybe$Nothing;
		});
	var _v0 = $author$project$FrontendExtra$conversationWindow$(guildOrDmId, threadRoute, local);
	if (!_v0.$) {
		switch (_v0.a.$) {
			case 0:
				var _v1 = _v0.a;
				var guildOrDmId2 = _v1.a;
				var visibleMessages = _v1.b;
				return A2(
					messagesLeft,
					visibleMessages,
					$author$project$Types$Local_LoadChannelMessages$(
						guildOrDmId2,
						$author$project$VisibleMessages$PageBefore(visibleMessages.oldest),
						$author$project$UserSession$EmptyPlaceholder));
			case 1:
				var _v2 = _v0.a;
				var guildOrDmId2 = _v2.a;
				var threadId = _v2.b;
				var visibleMessages = _v2.c;
				return A2(
					messagesLeft,
					visibleMessages,
					$author$project$Types$Local_LoadThreadMessages$(
						guildOrDmId2,
						threadId,
						$author$project$VisibleMessages$PageBefore(visibleMessages.oldest),
						$author$project$UserSession$EmptyPlaceholder));
			case 2:
				var _v3 = _v0.a;
				var guildOrDmId2 = _v3.a;
				var visibleMessages = _v3.b;
				return A2(
					messagesLeft,
					visibleMessages,
					$author$project$Types$Local_Discord_LoadChannelMessages$(
						guildOrDmId2,
						$author$project$VisibleMessages$PageBefore(visibleMessages.oldest),
						$author$project$UserSession$EmptyPlaceholder));
			case 3:
				var _v4 = _v0.a;
				var guildOrDmId2 = _v4.a;
				var threadId = _v4.b;
				var visibleMessages = _v4.c;
				return A2(
					messagesLeft,
					visibleMessages,
					$author$project$Types$Local_Discord_LoadThreadMessages$(
						guildOrDmId2,
						threadId,
						$author$project$VisibleMessages$PageBefore(visibleMessages.oldest),
						$author$project$UserSession$EmptyPlaceholder));
			case 4:
				var _v5 = _v0.a;
				var guildOrDmId2 = _v5.a;
				var visibleMessages = _v5.b;
				return A2(
					messagesLeft,
					visibleMessages,
					$author$project$Types$Local_Slack_LoadChannelMessages$(
						guildOrDmId2,
						$author$project$VisibleMessages$PageBefore(visibleMessages.oldest),
						$author$project$UserSession$EmptyPlaceholder));
			default:
				var _v6 = _v0.a;
				var guildOrDmId2 = _v6.a;
				var threadId = _v6.b;
				var visibleMessages = _v6.c;
				return A2(
					messagesLeft,
					visibleMessages,
					$author$project$Types$Local_Slack_LoadThreadMessages$(
						guildOrDmId2,
						threadId,
						$author$project$VisibleMessages$PageBefore(visibleMessages.oldest),
						$author$project$UserSession$EmptyPlaceholder));
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Frontend$loadOlderMessages = F3($author$project$Frontend$loadOlderMessages$);
var $author$project$Ports$load_service_worker_data_to_js = _Platform_outgoingPort('load_service_worker_data_to_js', $elm$core$Basics$identity);
var $author$project$Ports$loadServiceWorkerData = A3($lamdera$program_test$Effect$Command$sendToJs, 'load_service_worker_data_to_js', $author$project$Ports$load_service_worker_data_to_js, $elm$json$Json$Encode$null);
var $author$project$Frontend$plainTextLoaded = function (messages) {
	return $lamdera$containers$SeqDict$fromList(
		$elm$core$List$filterMap$(
			function (_v0) {
				var messageId = _v0.a;
				var message = _v0.b;
				if (!message.$) {
					var data = message.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(messageId, data.content));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			$author$project$MessageArray$toList(messages)));
};
var $author$project$Frontend$locallyLoadedMessagesToEncrypt = function (local) {
	return $lamdera$containers$SeqDict$foldl$(
		F3(
			function (otherUserId, dmChannel, dict) {
				var _v0 = dmChannel.e2ee;
				if (_v0.$ === 3) {
					var conversation = {
						channel: $author$project$Frontend$plainTextLoaded(dmChannel.messages),
						threads: $lamdera$containers$SeqDict$foldl$(
							F3(
								function (threadId, thread, threads) {
									var plainText = $author$project$Frontend$plainTextLoaded(thread.messages);
									return $lamdera$containers$SeqDict$isEmpty(plainText) ? threads : $lamdera$containers$SeqDict$insert$(threadId, plainText, threads);
								}),
							$lamdera$containers$SeqDict$empty,
							dmChannel.threads)
					};
					return ($lamdera$containers$SeqDict$isEmpty(conversation.channel) && $lamdera$containers$SeqDict$isEmpty(conversation.threads)) ? dict : $lamdera$containers$SeqDict$insert$(
						{otherUserId: otherUserId},
						conversation,
						dict);
				} else {
					return dict;
				}
			}),
		$lamdera$containers$SeqDict$empty,
		local.dmChannels);
};
var $author$project$Types$Local_EncryptOldMessages$ = function (a, b) {
	return {$: 72, a: a, b: b};
};
var $author$project$Types$Local_EncryptOldMessages = F2($author$project$Types$Local_EncryptOldMessages$);
var $author$project$Frontend$manyMessagesEncrypted$ = function (requestId, encrypted, model, loggedIn) {
	var _v0 = $lamdera$containers$SeqDict$get$(requestId, loggedIn.encryptionRequests.pendingEncryptedManyMessages);
	if (!_v0.$) {
		var pending = _v0.a;
		var pairs = A3($elm$core$List$map2, $elm$core$Tuple$pair, pending.messages, encrypted);
		return $author$project$FrontendExtra$handleLocalChange$(
			model.time,
			$elm$core$Maybe$Just(
				$author$project$Types$Local_EncryptOldMessages$(
					pending.id,
					$elm$core$List$map$(
						function (_v1) {
							var _v2 = _v1.a;
							var threadRoute = _v2.a;
							var content = _v2.b;
							var encryptedData = _v1.b;
							return _Utils_Tuple3(
								threadRoute,
								$lamdera$containers$SeqSet$fromList(
									$elm$core$List$map$(
										function ($) {
											return $.fileHash;
										},
										$lamdera$containers$SeqDict$values(content.attachedFiles))),
								encryptedData);
						},
						pairs))),
			$author$project$FrontendExtra$fileDecryptedMessages$(
				$elm$core$List$map$(
					function (_v3) {
						var _v4 = _v3.a;
						var contentAndEmbeds = _v4.b;
						var encryptedData = _v3.b;
						return _Utils_Tuple2(
							$author$project$Encryption$hash(encryptedData),
							$elm$core$Result$Ok(contentAndEmbeds));
					},
					pairs),
				$author$project$FrontendExtra$mapEncryptionRequests$(
					$author$project$Frontend$forgetEncryptManyRequest(requestId),
					loggedIn)),
			$author$project$FrontendExtra$storeDecryptedFileKeys(
				$elm$core$List$map$(
					function (_v5) {
						var _v6 = _v5.a;
						var contentAndEmbeds = _v6.b;
						return $elm$core$Result$Ok(contentAndEmbeds);
					},
					pairs)));
	} else {
		return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
	}
};
var $author$project$Frontend$manyMessagesEncrypted = F4($author$project$Frontend$manyMessagesEncrypted$);
var $elm$core$Result$map2$ = function (func, ra, rb) {
	if (ra.$ === 1) {
		var x = ra.a;
		return $elm$core$Result$Err(x);
	} else {
		var a = ra.a;
		if (rb.$ === 1) {
			var x = rb.a;
			return $elm$core$Result$Err(x);
		} else {
			var b = rb.a;
			return $elm$core$Result$Ok(
				A2(func, a, b));
		}
	}
};
var $elm$core$Result$map2 = F3($elm$core$Result$map2$);
var $author$project$FileStatus$measuredFileMetadata = function (measured) {
	if (!measured.$) {
		var imageSize = measured.a;
		return $author$project$FileStatus$FileMetadata_Image(
			{cameraOwner: $elm$core$Maybe$Nothing, exposureTime: $elm$core$Maybe$Nothing, fNumber: $elm$core$Maybe$Nothing, focalLength: $elm$core$Maybe$Nothing, gpsLocation: $elm$core$Maybe$Nothing, imageSize: imageSize, isoSpeedRating: $elm$core$Maybe$Nothing, make: $elm$core$Maybe$Nothing, model: $elm$core$Maybe$Nothing, orientation: $elm$core$Maybe$Nothing, software: $elm$core$Maybe$Nothing, userComment: $elm$core$Maybe$Nothing});
	} else {
		var videoSize = measured.a;
		var duration = measured.b;
		return $author$project$FileStatus$FileMetadata_Video(
			{codec: $elm$core$Maybe$Nothing, createdAt: $elm$core$Maybe$Nothing, duration: duration, gpsLocation: $elm$core$Maybe$Nothing, orientation: 0, title: $elm$core$Maybe$Nothing, videoSize: videoSize});
	}
};
var $author$project$Frontend$messageBefore = function (messageId) {
	return $author$project$Id$fromInt(
		$author$project$Id$toInt(messageId) - 1);
};
var $author$project$Types$messageMenuMobileOffset = function (mobileMode) {
	switch (mobileMode.$) {
		case 0:
			var offset = mobileMode.a;
			return offset;
		case 1:
			var offset = mobileMode.a.offset;
			return offset;
		case 2:
			var offset = mobileMode.a.offset;
			return offset;
		default:
			var offset = mobileMode.a;
			return offset;
	}
};
var $author$project$MessageMenu$messageMenuSpeed = $ianmackenzie$elm_units$Quantity$rate$(
	$author$project$CssPixels$cssPixels(800),
	$ianmackenzie$elm_units$Duration$second);
var $author$project$Encryption$notificationText = function (_v0) {
	var bytes = _v0;
	return bytes;
};
var $author$project$FileStatus$onlyUploadedFiles = function (dict) {
	return $lamdera$containers$SeqDict$filterMap$(
		F2(
			function (_v0, status) {
				switch (status.$) {
					case 0:
						return $elm$core$Maybe$Nothing;
					case 1:
						var fileData = status.a;
						return $elm$core$Maybe$Just(fileData);
					default:
						return $elm$core$Maybe$Nothing;
				}
			}),
		dict);
};
var $author$project$FrontendExtra$openUserOptionsAndExpandContainer$ = function (section, model) {
	var _v0 = $author$project$FrontendExtra$updateLoggedIn$(
		function (loggedIn) {
			return $author$project$FrontendExtra$handleLocalChange$(
				model.time,
				$elm$core$Maybe$Just(
					$author$project$Types$Local_ExpandUserOptionSection$(
						section,
						{collapseOthers: true})),
				loggedIn,
				$lamdera$program_test$Effect$Command$none);
		},
		model);
	var model2 = _v0.a;
	var expandCmd = _v0.b;
	var _v1 = $author$project$FrontendExtra$routePush$(
		model2,
		$author$project$Route$setOverlay$(
			$elm$core$Maybe$Just(1),
			model2.route));
	var model3 = _v1.a;
	var routeCmd = _v1.b;
	return _Utils_Tuple2(
		model3,
		$lamdera$program_test$Effect$Command$batch(
			_List_fromArray(
				[expandCmd, routeCmd])));
};
var $author$project$FrontendExtra$openUserOptionsAndExpandContainer = F2($author$project$FrontendExtra$openUserOptionsAndExpandContainer$);
var $author$project$Types$PageUpGotViewport = function (a) {
	return {$: 154, a: a};
};
var $author$project$Ports$smooth_scroll_by_to_js = _Platform_outgoingPort('smooth_scroll_by_to_js', $elm$core$Basics$identity);
var $author$project$Ports$smoothScrollBy$ = function (containerId, scrollY) {
	return A3(
		$lamdera$program_test$Effect$Command$sendToJs,
		'smooth_scroll_by_to_js',
		$author$project$Ports$smooth_scroll_by_to_js,
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'containerId',
					$elm$json$Json$Encode$string(
						$lamdera$program_test$Effect$Browser$Dom$idToString(containerId))),
					_Utils_Tuple2(
					'scrollY',
					$elm$json$Json$Encode$float(scrollY))
				])));
};
var $author$project$Ports$smoothScrollBy = F2($author$project$Ports$smoothScrollBy$);
var $author$project$Scroll$smoothScrollBy$ = function (conversationContainerId, scrollYAmount) {
	return $author$project$Ports$smoothScrollBy$(conversationContainerId, scrollYAmount);
};
var $author$project$Scroll$smoothScrollBy = F2($author$project$Scroll$smoothScrollBy$);
var $author$project$Frontend$pageUpOrDownScroll$ = function (isUp, model) {
	return _Utils_Tuple2(
		model,
		$lamdera$program_test$Effect$Command$batch(
			_List_fromArray(
				[
					$author$project$Scroll$smoothScrollBy$(
					$author$project$Pages$Guild$conversationContainerId,
					(isUp ? (-0.9) : 0.9) * ($author$project$Coord$yRaw(model.windowSize) - $author$project$MyUi$channelHeaderHeight)),
					$lamdera$program_test$Effect$Task$attempt$(
					$author$project$Types$PageUpGotViewport,
					$lamdera$program_test$Effect$Browser$Dom$getViewportOf($author$project$Pages$Guild$conversationContainerId))
				])));
};
var $author$project$Frontend$pageUpOrDownScroll = F2($author$project$Frontend$pageUpOrDownScroll$);
var $author$project$RichText$Domain = $elm$core$Basics$identity;
var $author$project$RichText$urlToDomain = function (data) {
	return data.host;
};
var $author$project$Frontend$parseDomainWhitelistInput = function (text) {
	return $lamdera$containers$SeqSet$fromList(
		$elm$core$List$filterMap$(
			function (text2) {
				var _v0 = $elm$url$Url$fromString(
					'https://' + $elm$core$String$trim(text2));
				if (!_v0.$) {
					var url = _v0.a;
					return $elm$core$Maybe$Just(
						$author$project$RichText$urlToDomain(url));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			$elm$core$String$split$(',', text)));
};
var $author$project$UserColor$picked = function (selection) {
	return selection.lastValid;
};
var $author$project$MessageInput$ChannelSoFar = function (a) {
	return {$: 2, a: a};
};
var $author$project$MessageInput$DayOffset = function (a) {
	return {$: 1, a: a};
};
var $author$project$MessageInput$EmojiSoFar = function (a) {
	return {$: 1, a: a};
};
var $author$project$MessageInput$HourOffset = function (a) {
	return {$: 2, a: a};
};
var $author$project$MessageInput$MinuteOffset = function (a) {
	return {$: 3, a: a};
};
var $author$project$MessageInput$NameSoFar = function (a) {
	return {$: 0, a: a};
};
var $author$project$MessageInput$TimeOfDay = function (a) {
	return {$: 4, a: a};
};
var $author$project$MessageInput$TimestampSoFar$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$MessageInput$TimestampSoFar = F2($author$project$MessageInput$TimestampSoFar$);
var $author$project$MessageInput$WeekOffset = function (a) {
	return {$: 0, a: a};
};
var $author$project$MessageInput$isInsideCodeBlock$ = function (cursor, text) {
	return A2(
		$elm$core$Basics$modBy,
		2,
		$elm$core$List$length(
			A2(
				$elm$core$String$indexes,
				'```',
				$elm$core$String$left$(cursor, text)))) === 1;
};
var $author$project$MessageInput$isInsideCodeBlock = F2($author$project$MessageInput$isInsideCodeBlock$);
var $author$project$MessageInput$isInsideInlineCode$ = function (cursor, text) {
	var _v0 = $elm$core$List$reverse(
		$elm$core$String$split$(
			'\u000A',
			$elm$core$String$left$(cursor, text)));
	if (_v0.b) {
		var currentLine = _v0.a;
		return A2(
			$elm$core$Basics$modBy,
			2,
			$elm$core$List$length(
				A2(
					$elm$core$String$indexes,
					'`',
					$elm$core$String$replace$('```', '', currentLine)))) === 1;
	} else {
		return false;
	}
};
var $author$project$MessageInput$isInsideInlineCode = F2($author$project$MessageInput$isInsideInlineCode$);
var $author$project$FrontendExtra$wordStart$ = function (text, end) {
	wordStart:
	while (true) {
		if (end <= 0) {
			return 0;
		} else {
			var _v0 = A3($elm$core$String$slice, end - 1, end, text);
			switch (_v0) {
				case ' ':
					return end;
				case '\u000A':
					return end;
				case '\u000D':
					return end;
				default:
					var $temp$end = end - 1;
					end = $temp$end;
					continue wordStart;
			}
		}
	}
};
var $author$project$FrontendExtra$wordStart = F2($author$project$FrontendExtra$wordStart$);
var $author$project$FrontendExtra$lastWord$ = function (index, text) {
	var start = $author$project$FrontendExtra$wordStart$(text, index);
	return (_Utils_cmp(start, index) < 0) ? $elm$core$Maybe$Just(
		A3($elm$core$String$slice, start, index, text)) : $elm$core$Maybe$Nothing;
};
var $author$project$FrontendExtra$lastWord = F2($author$project$FrontendExtra$lastWord$);
var $author$project$FrontendExtra$lastWordsHelper$ = function (count, startIndex, index, text) {
	lastWordsHelper:
	while (true) {
		if (count <= 0) {
			return $elm$core$Maybe$Just(
				A3($elm$core$String$slice, index + 1, startIndex, text));
		} else {
			var _v0 = $author$project$FrontendExtra$lastWord$(index, text);
			if (!_v0.$) {
				var word = _v0.a;
				var $temp$count = count - 1,
					$temp$index = (index - $elm$core$String$length(word)) - 1;
				count = $temp$count;
				index = $temp$index;
				continue lastWordsHelper;
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	}
};
var $author$project$FrontendExtra$lastWordsHelper = F4($author$project$FrontendExtra$lastWordsHelper$);
var $author$project$FrontendExtra$lastFiveWords$ = function (index, text) {
	return $author$project$FrontendExtra$lastWordsHelper$(5, index, index, text);
};
var $author$project$FrontendExtra$lastFiveWords = F2($author$project$FrontendExtra$lastFiveWords$);
var $author$project$FrontendExtra$lastTwoWords$ = function (index, text) {
	var secondStart = $author$project$FrontendExtra$wordStart$(text, index);
	var firstStart = $author$project$FrontendExtra$wordStart$(text, secondStart - 1);
	return ((_Utils_cmp(secondStart, index) < 0) && ((A3($elm$core$String$slice, secondStart - 1, secondStart, text) === ' ') && (_Utils_cmp(firstStart, secondStart - 1) < 0))) ? _List_fromArray(
		[
			A3($elm$core$String$slice, firstStart, secondStart - 1, text),
			A3($elm$core$String$slice, secondStart, index, text)
		]) : _List_Nil;
};
var $author$project$FrontendExtra$lastTwoWords = F2($author$project$FrontendExtra$lastTwoWords$);
var $author$project$FrontendExtra$parseTimeOfDayHelper$ = function (hours, minutes) {
	if (($elm$core$String$length(hours) <= 2) && ($elm$core$String$length(minutes) === 2)) {
		var _v0 = _Utils_Tuple2(
			$elm$core$String$toInt(hours),
			$elm$core$String$toInt(minutes));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var hours2 = _v0.a.a;
			var minutes2 = _v0.b.a;
			return ((hours2 < 24) && (minutes2 < 60)) ? $elm$core$Maybe$Just(
				{hours: hours2, minutes: minutes2}) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$FrontendExtra$parseTimeOfDayHelper = F2($author$project$FrontendExtra$parseTimeOfDayHelper$);
var $author$project$FrontendExtra$parseTimeOfDay = function (text) {
	var _v0 = $elm$core$String$split$(':', text);
	if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
		var hours = _v0.a;
		var _v1 = _v0.b;
		var minutes = _v1.a;
		return $author$project$FrontendExtra$parseTimeOfDayHelper$(hours, minutes);
	} else {
		var _v2 = $elm$core$String$split$('.', text);
		if ((_v2.b && _v2.b.b) && (!_v2.b.b.b)) {
			var hours = _v2.a;
			var _v3 = _v2.b;
			var minutes = _v3.a;
			return $author$project$FrontendExtra$parseTimeOfDayHelper$(hours, minutes);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $elm$core$String$toFloat = _String_toFloat;
var $author$project$FrontendExtra$pingUserNameSoFar$ = function (htmlId, selection, guildOrDmId, threadRoute, loggedIn) {
	var timeOffsetSoFar = F2(
		function (caret, text) {
			var timeOffsetHelper = F3(
				function (valueText, unit, offsetType) {
					var _v17 = $elm$core$String$toFloat(valueText);
					if (!_v17.$) {
						var value = _v17.a;
						return $elm$core$Maybe$Just(
							$author$project$MessageInput$TimestampSoFar$(
								{
									end: caret,
									start: ((caret - $elm$core$String$length(valueText)) - 1) - $elm$core$String$length(unit)
								},
								offsetType(value)));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				});
			var _v5 = $elm$core$List$map$(
				$elm$core$String$toLower,
				$author$project$FrontendExtra$lastTwoWords$(caret, text));
			_v5$8:
			while (true) {
				if ((_v5.b && _v5.b.b) && (!_v5.b.b.b)) {
					switch (_v5.b.a) {
						case 'weeks':
							var value = _v5.a;
							var _v6 = _v5.b;
							return A3(timeOffsetHelper, value, 'weeks', $author$project$MessageInput$WeekOffset);
						case 'week':
							var value = _v5.a;
							var _v7 = _v5.b;
							return A3(timeOffsetHelper, value, 'week', $author$project$MessageInput$WeekOffset);
						case 'days':
							var value = _v5.a;
							var _v8 = _v5.b;
							return A3(timeOffsetHelper, value, 'days', $author$project$MessageInput$DayOffset);
						case 'day':
							var value = _v5.a;
							var _v9 = _v5.b;
							return A3(timeOffsetHelper, value, 'day', $author$project$MessageInput$DayOffset);
						case 'hours':
							var value = _v5.a;
							var _v10 = _v5.b;
							return A3(timeOffsetHelper, value, 'hours', $author$project$MessageInput$HourOffset);
						case 'hour':
							var value = _v5.a;
							var _v11 = _v5.b;
							return A3(timeOffsetHelper, value, 'hour', $author$project$MessageInput$HourOffset);
						case 'minutes':
							var value = _v5.a;
							var _v12 = _v5.b;
							return A3(timeOffsetHelper, value, 'minutes', $author$project$MessageInput$MinuteOffset);
						case 'minute':
							var value = _v5.a;
							var _v13 = _v5.b;
							return A3(timeOffsetHelper, value, 'minute', $author$project$MessageInput$MinuteOffset);
						default:
							break _v5$8;
					}
				} else {
					break _v5$8;
				}
			}
			var _v14 = $elm$core$Maybe$map$(
				$elm$core$String$toLower,
				$author$project$FrontendExtra$lastWord$(caret, text));
			if (!_v14.$) {
				var valueText = _v14.a;
				var _v15 = $author$project$FrontendExtra$parseTimeOfDay(valueText);
				if (!_v15.$) {
					var value2 = _v15.a;
					var _v16 = $author$project$RichText$tryParseTimestamp$(
						$lamdera$program_test$Effect$Time$utc,
						$elm$core$Maybe$withDefault$(
							'',
							$author$project$FrontendExtra$lastFiveWords$(caret, text)),
						0);
					if (!_v16.$) {
						return $elm$core$Maybe$Nothing;
					} else {
						return $elm$core$Maybe$Just(
							$author$project$MessageInput$TimestampSoFar$(
								{
									end: caret,
									start: caret - $elm$core$String$length(valueText)
								},
								$author$project$MessageInput$TimeOfDay(value2)));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
	var isValidStart = F2(
		function (index, text) {
			if (index <= 0) {
				return true;
			} else {
				var _v4 = A3($elm$core$String$slice, index - 1, index, text);
				switch (_v4) {
					case ' ':
						return true;
					case '\u000A':
						return true;
					case '\u000D':
						return true;
					default:
						return false;
				}
			}
		});
	var helper = F2(
		function (index, text) {
			helper:
			while (true) {
				if ((_Utils_cmp($author$project$PersonName$maxLength, selection.start - index) < 0) || (index <= 0)) {
					return $elm$core$Maybe$Nothing;
				} else {
					var _v0 = A3($elm$core$String$slice, index - 1, index, text);
					switch (_v0) {
						case '@':
							return A2(isValidStart, index - 1, text) ? $elm$core$Maybe$Just(
								$author$project$MessageInput$NameSoFar(
									{
										index: index,
										nameSoFar: A3($elm$core$String$slice, index, selection.start, text)
									})) : $elm$core$Maybe$Nothing;
						case ':':
							return A2(isValidStart, index - 1, text) ? $elm$core$Maybe$Just(
								$author$project$MessageInput$EmojiSoFar(
									{
										index: index,
										nameSoFar: A3($elm$core$String$slice, index, selection.start, text)
									})) : $elm$core$Maybe$Nothing;
						case '#':
							return A2(isValidStart, index - 1, text) ? $elm$core$Maybe$Just(
								$author$project$MessageInput$ChannelSoFar(
									{
										index: index,
										nameSoFar: A3($elm$core$String$slice, index, selection.start, text)
									})) : $elm$core$Maybe$Nothing;
						default:
							var $temp$index = index - 1;
							index = $temp$index;
							continue helper;
					}
				}
			}
		});
	var nameSoFar = F2(
		function (caret, text) {
			if ($author$project$MessageInput$isInsideCodeBlock$(caret, text) || $author$project$MessageInput$isInsideInlineCode$(caret, text)) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v3 = A2(timeOffsetSoFar, caret, text);
				if (!_v3.$) {
					var timeOffset = _v3.a;
					return $elm$core$Maybe$Just(timeOffset);
				} else {
					return A2(helper, caret, text);
				}
			}
		});
	if (_Utils_eq(selection.start, selection.end)) {
		if (_Utils_eq(htmlId, $author$project$Pages$Guild$channelTextInputId)) {
			var _v1 = $lamdera$containers$SeqDict$get$(
				_Utils_Tuple2(guildOrDmId, threadRoute),
				loggedIn.drafts);
			if (!_v1.$) {
				var draft = _v1.a;
				return A2(
					nameSoFar,
					selection.start,
					$MartinSStewart$elm_nonempty_string$String$Nonempty$toString(draft));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			if (_Utils_eq(htmlId, $author$project$MessageMenu$editMessageTextInputId)) {
				var _v2 = $lamdera$containers$SeqDict$get$(
					_Utils_Tuple2(guildOrDmId, threadRoute),
					loggedIn.editMessage);
				if (!_v2.$) {
					var edit = _v2.a;
					return A2(nameSoFar, selection.start, edit.text);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$FrontendExtra$pingUserNameSoFar = F5($author$project$FrontendExtra$pingUserNameSoFar$);
var $author$project$MessageDropdown$maxDropdownUsers = function (isMobile) {
	return isMobile ? 5 : 10;
};
var $author$project$MessageDropdown$namesSortBy$ = function (text, name) {
	return A2($elm$core$String$startsWith, text, name) ? $elm$core$Maybe$Just('   ' + name) : (A2(
		$elm$core$String$startsWith,
		$elm$core$String$toLower(text),
		$elm$core$String$toLower(name)) ? $elm$core$Maybe$Just('  ' + name) : (A2(
		$elm$core$String$contains,
		$elm$core$String$toLower(text),
		$elm$core$String$toLower(name)) ? $elm$core$Maybe$Just(' ' + name) : $elm$core$Maybe$Nothing));
};
var $author$project$MessageDropdown$namesSortBy = F2($author$project$MessageDropdown$namesSortBy$);
var $author$project$MessageDropdown$channelDropdownList$ = function (isMobile, nameSoFar, guildOrDmId, local) {
	return $elm$core$List$map$(
		$elm$core$Tuple$first,
		$elm$core$List$take$(
			$author$project$MessageDropdown$maxDropdownUsers(isMobile),
			A2(
				$elm$core$List$sortBy,
				$elm$core$Tuple$second,
				$elm$core$List$filterMap$(
					function (mention) {
						var _v4 = $author$project$MessageDropdown$namesSortBy$(nameSoFar.nameSoFar, mention.name);
						if (!_v4.$) {
							var a = _v4.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(mention, a));
						} else {
							return $elm$core$Maybe$Nothing;
						}
					},
					function () {
						switch (guildOrDmId.$) {
							case 0:
								var guildOrDmId2 = guildOrDmId.a;
								return $elm$core$List$map$(
									function (_v1) {
										var mention = _v1.b;
										return {name: mention.name};
									},
									$lamdera$containers$SeqDict$toList(
										$author$project$LocalState$channelMentions$(guildOrDmId2, local)));
							case 1:
								var guildOrDmId2 = guildOrDmId.a;
								return $elm$core$List$map$(
									function (_v2) {
										var mention = _v2.b;
										return {name: mention.name};
									},
									$lamdera$containers$SeqDict$toList(
										$author$project$LocalState$discordChannelMentions$(guildOrDmId2, local)));
							default:
								var guildOrDmId2 = guildOrDmId.a;
								return $elm$core$List$map$(
									function (_v3) {
										var mention = _v3.b;
										return {name: mention.name};
									},
									$lamdera$containers$SeqDict$toList(
										$author$project$LocalState$slackChannelMentions$(guildOrDmId2, local)));
						}
					}()))));
};
var $author$project$MessageDropdown$channelDropdownList = F4($author$project$MessageDropdown$channelDropdownList$);
var $author$project$MessageDropdown$discordUserDropdownList$ = function (isMobile, nameSoFar, guildOrDmId, local) {
	var allUsers = $author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(local.localUser.discordUsers);
	return $elm$core$List$take$(
		$author$project$MessageDropdown$maxDropdownUsers(isMobile),
		A2(
			$elm$core$List$sortBy,
			function (_v4) {
				var user = _v4.b;
				return $author$project$PersonName$toString(user.name);
			},
			$elm$core$List$filterMap$(
				function (userId) {
					var _v3 = $lamdera$containers$SeqDict$get$(userId, allUsers);
					if (!_v3.$) {
						var user = _v3.a;
						return A2(
							$elm$core$String$startsWith,
							nameSoFar.nameSoFar,
							$author$project$PersonName$toString(user.name)) ? $elm$core$Maybe$Just(
							_Utils_Tuple2(userId, user)) : $elm$core$Maybe$Nothing;
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				function () {
					if (!guildOrDmId.$) {
						var guildId = guildOrDmId.a.guildId;
						var _v1 = $lamdera$containers$SeqDict$get$(guildId, local.discordGuilds);
						if (!_v1.$) {
							var guild = _v1.a;
							return $author$project$MembersAndOwner$membersAndOwner(guild.membersAndOwner);
						} else {
							return _List_Nil;
						}
					} else {
						var data = guildOrDmId.a;
						var _v2 = $lamdera$containers$SeqDict$get$(data.channelId, local.discordDmChannels);
						if (!_v2.$) {
							var channel = _v2.a;
							return $mgold$elm_nonempty_list$List$Nonempty$toList(
								$author$project$NonemptyDict$keys(channel.members));
						} else {
							return _List_Nil;
						}
					}
				}())));
};
var $author$project$MessageDropdown$discordUserDropdownList = F4($author$project$MessageDropdown$discordUserDropdownList$);
var $author$project$Emoji$EmojiOrSticker_CustomEmoji = function (a) {
	return {$: 2, a: a};
};
var $author$project$Emoji$EmojiOrSticker_Sticker = function (a) {
	return {$: 1, a: a};
};
var $author$project$Emoji$EmojiOrSticker_UnicodeEmoji = function (a) {
	return {$: 0, a: a};
};
var $author$project$CustomEmoji$emojiNameToString = function (_v0) {
	var a = _v0;
	return a;
};
var $author$project$MessageDropdown$emojiDropdownList$ = function (isMobile, nameSoFar, availableCustomEmojis, availableStickers, localUser, emojiData) {
	var substring = $elm$core$String$toLower(nameSoFar.nameSoFar);
	if ($elm$core$String$length(substring) > 1) {
		var unicodeEmojis = $elm$core$List$map$(
			function (a) {
				return _Utils_Tuple2(
					$elm$core$String$length(a.shortName),
					$author$project$Emoji$EmojiOrSticker_UnicodeEmoji(a.emoji));
			},
			$elm$core$Array$toList(
				$elm$core$Array$filter$(
					function (item) {
						return A2($elm$core$String$contains, substring, item.shortName);
					},
					emojiData.shortNames)));
		var stickers = $elm$core$List$filterMap$(
			function (stickerId) {
				var _v1 = $lamdera$containers$SeqDict$get$(stickerId, localUser.stickers);
				if (!_v1.$) {
					var sticker = _v1.a;
					return A2(
						$elm$core$String$contains,
						substring,
						$elm$core$String$toLower(sticker.name)) ? $elm$core$Maybe$Just(
						_Utils_Tuple2(
							$elm$core$String$length(sticker.name),
							$author$project$Emoji$EmojiOrSticker_Sticker(stickerId))) : $elm$core$Maybe$Nothing;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			$lamdera$containers$SeqSet$toList(availableStickers));
		var customEmojis = $elm$core$List$filterMap$(
			function (customEmojiId) {
				var _v0 = $lamdera$containers$SeqDict$get$(customEmojiId, localUser.customEmojis);
				if (!_v0.$) {
					var customEmoji = _v0.a;
					var name = $author$project$CustomEmoji$emojiNameToString(customEmoji.name);
					return A2(
						$elm$core$String$contains,
						substring,
						$elm$core$String$toLower(name)) ? $elm$core$Maybe$Just(
						_Utils_Tuple2(
							$elm$core$String$length(name),
							$author$project$Emoji$EmojiOrSticker_CustomEmoji(customEmojiId))) : $elm$core$Maybe$Nothing;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			$lamdera$containers$SeqSet$toList(availableCustomEmojis));
		return $elm$core$List$map$(
			$elm$core$Tuple$second,
			$elm$core$List$take$(
				$author$project$MessageDropdown$maxDropdownUsers(isMobile),
				A2(
					$elm$core$List$sortBy,
					$elm$core$Tuple$first,
					_Utils_ap(
						unicodeEmojis,
						_Utils_ap(customEmojis, stickers)))));
	} else {
		return _List_Nil;
	}
};
var $author$project$MessageDropdown$emojiDropdownList = F6($author$project$MessageDropdown$emojiDropdownList$);
var $author$project$MessageDropdown$slackUserDropdownList$ = function (isMobile, nameSoFar, guildOrDmId, local) {
	return $elm$core$List$map$(
		$elm$core$Tuple$first,
		$elm$core$List$take$(
			$author$project$MessageDropdown$maxDropdownUsers(isMobile),
			A2(
				$elm$core$List$sortBy,
				$elm$core$Tuple$second,
				$elm$core$List$filterMap$(
					function (_v3) {
						var userId = _v3.a;
						var user = _v3.b;
						var _v4 = $author$project$MessageDropdown$namesSortBy$(
							nameSoFar.nameSoFar,
							$author$project$PersonName$toString(user.name));
						if (!_v4.$) {
							var a = _v4.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(
									_Utils_Tuple2(userId, user),
									a));
						} else {
							return $elm$core$Maybe$Nothing;
						}
					},
					function () {
						if (!guildOrDmId.$) {
							var teamId = guildOrDmId.a.teamId;
							return $lamdera$containers$SeqDict$toList(
								$lamdera$containers$SeqDict$filter$(
									F2(
										function (_v1, user) {
											return _Utils_eq(user.teamId, teamId);
										}),
									local.localUser.slackUsers));
						} else {
							var data = guildOrDmId.a;
							var _v2 = $lamdera$containers$SeqDict$get$(data.channelId, local.slackDmChannels);
							if (!_v2.$) {
								var channel = _v2.a;
								return $elm$core$List$filterMap$(
									function (userId) {
										return $elm$core$Maybe$map$(
											$elm$core$Tuple$pair(userId),
											$lamdera$containers$SeqDict$get$(userId, local.localUser.slackUsers));
									},
									$author$project$NonemptySet$toList(channel.members));
							} else {
								return _List_Nil;
							}
						}
					}()))));
};
var $author$project$MessageDropdown$slackUserDropdownList = F4($author$project$MessageDropdown$slackUserDropdownList$);
var $author$project$TimeInMinutes$fromMinutes = $elm$core$Basics$identity;
var $elm$time$Time$toMillis$ = function (_v0, time) {
	return A2(
		$elm$core$Basics$modBy,
		1000,
		$elm$time$Time$posixToMillis(time));
};
var $elm$time$Time$toMillis = F2($elm$time$Time$toMillis$);
var $lamdera$program_test$Effect$Time$toMillis = $elm$time$Time$toMillis;
var $elm$time$Time$toSecond$ = function (_v0, time) {
	return A2(
		$elm$core$Basics$modBy,
		60,
		$elm$time$Time$flooredDiv$(
			$elm$time$Time$posixToMillis(time),
			1000));
};
var $elm$time$Time$toSecond = F2($elm$time$Time$toSecond$);
var $lamdera$program_test$Effect$Time$toSecond = $elm$time$Time$toSecond;
var $author$project$MessageDropdown$timestampDropdownList$ = function (timezone, time, timestamp) {
	var helper = F2(
		function (scale, value) {
			return _List_fromArray(
				[
					$author$project$TimeInMinutes$fromMinutes(
					$elm$core$Basics$round(
						(($lamdera$program_test$Effect$Time$posixToMillis(time) / (60 * 1000)) | 0) + (scale * value))),
					$author$project$TimeInMinutes$fromMinutes(
					$elm$core$Basics$round(
						(($lamdera$program_test$Effect$Time$posixToMillis(time) / (60 * 1000)) | 0) - (scale * value)))
				]);
		});
	switch (timestamp.$) {
		case 0:
			var value = timestamp.a;
			return A2(helper, (60 * 24) * 7, value);
		case 1:
			var value = timestamp.a;
			return A2(helper, 60 * 24, value);
		case 2:
			var value = timestamp.a;
			return A2(helper, 60, value);
		case 3:
			var value = timestamp.a;
			return A2(helper, 1, value);
		default:
			var minutes = timestamp.a.minutes;
			var hours = timestamp.a.hours;
			var sinceStartOfDayMs = ((((($lamdera$program_test$Effect$Time$toHour$(timezone, time) * 60) * 60) * 1000) + (($lamdera$program_test$Effect$Time$toMinute$(timezone, time) * 60) * 1000)) + (A2($lamdera$program_test$Effect$Time$toSecond, timezone, time) * 1000)) + A2($lamdera$program_test$Effect$Time$toMillis, timezone, time);
			var startOfDay = (($lamdera$program_test$Effect$Time$posixToMillis(time) - sinceStartOfDayMs) / (60 * 1000)) | 0;
			return _List_fromArray(
				[
					$author$project$TimeInMinutes$fromMinutes((startOfDay + (hours * 60)) + minutes),
					$author$project$TimeInMinutes$fromMinutes((startOfDay + ((hours + 12) * 60)) + minutes),
					$author$project$TimeInMinutes$fromMinutes((startOfDay + ((hours + 24) * 60)) + minutes),
					$author$project$TimeInMinutes$fromMinutes((startOfDay + ((hours + 36) * 60)) + minutes)
				]);
	}
};
var $author$project$MessageDropdown$timestampDropdownList = F3($author$project$MessageDropdown$timestampDropdownList$);
var $author$project$MessageDropdown$userDropdownList$ = function (isMobile, nameSoFar, guildOrDmId, local) {
	var allUsers = $author$project$User$allUsers(local.localUser);
	return $elm$core$List$map$(
		$elm$core$Tuple$first,
		$elm$core$List$take$(
			$author$project$MessageDropdown$maxDropdownUsers(isMobile),
			A2(
				$elm$core$List$sortBy,
				$elm$core$Tuple$second,
				$elm$core$List$filterMap$(
					function (userId) {
						var _v2 = $lamdera$containers$SeqDict$get$(userId, allUsers);
						if (!_v2.$) {
							var user = _v2.a;
							var _v3 = $author$project$MessageDropdown$namesSortBy$(
								nameSoFar.nameSoFar,
								$author$project$PersonName$toString(user.name));
							if (!_v3.$) {
								var a = _v3.a;
								return $elm$core$Maybe$Just(
									_Utils_Tuple2(
										_Utils_Tuple2(userId, user),
										a));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						} else {
							return $elm$core$Maybe$Nothing;
						}
					},
					function () {
						if (!guildOrDmId.$) {
							var guildId = guildOrDmId.a.guildId;
							var _v1 = $lamdera$containers$SeqDict$get$(guildId, local.guilds);
							if (!_v1.$) {
								var guild = _v1.a;
								return $author$project$MembersAndOwner$membersAndOwner(guild.membersAndOwner);
							} else {
								return _List_Nil;
							}
						} else {
							var otherUserId = guildOrDmId.a.otherUserId;
							return _Utils_eq(local.localUser.session.userId, otherUserId) ? _List_fromArray(
								[otherUserId]) : _List_fromArray(
								[local.localUser.session.userId, otherUserId]);
						}
					}()))));
};
var $author$project$MessageDropdown$userDropdownList = F4($author$project$MessageDropdown$userDropdownList$);
var $author$project$MessageDropdown$pressedArrowInDropdown$ = function (isMobile, timezone, time, nameSoFar, guildOrDmId, index, maybePingUser, emojiData, local) {
	if (!maybePingUser.$) {
		var pingUser = maybePingUser.a;
		var helper = function (dropdownListLength) {
			return $elm$core$Maybe$Just(
				_Utils_update(
					pingUser,
					{
						dropdownIndex: (index < 0) ? (dropdownListLength - 1) : ((_Utils_cmp(index, dropdownListLength) > -1) ? 0 : index)
					}));
		};
		switch (nameSoFar.$) {
			case 0:
				var nameSoFarData = nameSoFar.a;
				switch (guildOrDmId.$) {
					case 0:
						var guildOrDmId2 = guildOrDmId.a;
						return helper(
							$elm$core$List$length(
								$author$project$MessageDropdown$userDropdownList$(isMobile, nameSoFarData, guildOrDmId2, local)));
					case 1:
						var guildOrDmId2 = guildOrDmId.a;
						return helper(
							$elm$core$List$length(
								$author$project$MessageDropdown$discordUserDropdownList$(isMobile, nameSoFarData, guildOrDmId2, local)));
					default:
						var guildOrDmId2 = guildOrDmId.a;
						return helper(
							$elm$core$List$length(
								$author$project$MessageDropdown$slackUserDropdownList$(isMobile, nameSoFarData, guildOrDmId2, local)));
				}
			case 1:
				var emojiSoFar = nameSoFar.a;
				if (!emojiData.$) {
					var emojiData2 = emojiData.a;
					var _v4 = $author$project$MessageMenu$availableCustomEmojisAndStickers$(guildOrDmId, local);
					var availableCustomEmojis = _v4.a;
					var availableStickers = _v4.b;
					return helper(
						$elm$core$List$length(
							$author$project$MessageDropdown$emojiDropdownList$(isMobile, emojiSoFar, availableCustomEmojis, availableStickers, local.localUser, emojiData2)));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 2:
				var nameSoFarData = nameSoFar.a;
				return helper(
					$elm$core$List$length(
						$author$project$MessageDropdown$channelDropdownList$(isMobile, nameSoFarData, guildOrDmId, local)));
			default:
				var timestampData = nameSoFar.b;
				return helper(
					$elm$core$List$length(
						$author$project$MessageDropdown$timestampDropdownList$(timezone, time, timestampData)));
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$MessageDropdown$pressedArrowInDropdown = F9($author$project$MessageDropdown$pressedArrowInDropdown$);
var $author$project$MessageDropdown$pressedDropdownItem$ = function (setFocusMsg, isMobile, time, nameSoFar, guildOrDmId, channelTextInputId, dropdownIndex, pingUser, emojiData, local, inputText) {
	var maybeTextToInsert = function () {
		switch (nameSoFar.$) {
			case 0:
				var nameSoFarData = nameSoFar.a;
				switch (guildOrDmId.$) {
					case 0:
						var guildOrDmId2 = guildOrDmId.a;
						var _v5 = $elmcraft$core_extra$List$Extra$getAt$(
							dropdownIndex,
							$author$project$MessageDropdown$userDropdownList$(isMobile, nameSoFarData, guildOrDmId2, local));
						if (!_v5.$) {
							var _v6 = _v5.a;
							var user = _v6.b;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(
									{
										end: nameSoFarData.index + $elm$core$String$length(nameSoFarData.nameSoFar),
										start: nameSoFarData.index
									},
									$author$project$PersonName$toString(user.name)));
						} else {
							return $elm$core$Maybe$Nothing;
						}
					case 1:
						var guildOrDmId2 = guildOrDmId.a;
						var _v7 = $elmcraft$core_extra$List$Extra$getAt$(
							dropdownIndex,
							$author$project$MessageDropdown$discordUserDropdownList$(isMobile, nameSoFarData, guildOrDmId2, local));
						if (!_v7.$) {
							var _v8 = _v7.a;
							var user = _v8.b;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(
									{
										end: nameSoFarData.index + $elm$core$String$length(nameSoFarData.nameSoFar),
										start: nameSoFarData.index
									},
									$author$project$PersonName$toString(user.name)));
						} else {
							return $elm$core$Maybe$Nothing;
						}
					default:
						var guildOrDmId2 = guildOrDmId.a;
						var _v9 = $elmcraft$core_extra$List$Extra$getAt$(
							dropdownIndex,
							$author$project$MessageDropdown$slackUserDropdownList$(isMobile, nameSoFarData, guildOrDmId2, local));
						if (!_v9.$) {
							var _v10 = _v9.a;
							var user = _v10.b;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(
									{
										end: nameSoFarData.index + $elm$core$String$length(nameSoFarData.nameSoFar),
										start: nameSoFarData.index
									},
									$author$project$PersonName$toString(user.name)));
						} else {
							return $elm$core$Maybe$Nothing;
						}
				}
			case 1:
				var emojiSoFar = nameSoFar.a;
				if (!emojiData.$) {
					var emojiData2 = emojiData.a;
					var _v12 = $author$project$MessageMenu$availableCustomEmojisAndStickers$(guildOrDmId, local);
					var availableCustomEmojis = _v12.a;
					var availableStickers = _v12.b;
					var _v13 = $elmcraft$core_extra$List$Extra$getAt$(
						dropdownIndex,
						$author$project$MessageDropdown$emojiDropdownList$(isMobile, emojiSoFar, availableCustomEmojis, availableStickers, local.localUser, emojiData2));
					if (!_v13.$) {
						var emojiOrSticker = _v13.a;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(
								{
									end: emojiSoFar.index + $elm$core$String$length(emojiSoFar.nameSoFar),
									start: emojiSoFar.index - 1
								},
								function () {
									switch (emojiOrSticker.$) {
										case 0:
											var emoji = emojiOrSticker.a;
											return $author$project$Emoji$emojiWithSkinTone$(local.localUser.user.emojiConfig.skinTone, emoji, emojiData2);
										case 1:
											var stickerId = emojiOrSticker.a;
											return $author$project$Sticker$idToString(stickerId);
										default:
											var customEmojiId = emojiOrSticker.a;
											return $author$project$CustomEmoji$idToString(customEmojiId);
									}
								}()));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 2:
				var nameSoFarData = nameSoFar.a;
				var _v15 = $elmcraft$core_extra$List$Extra$getAt$(
					dropdownIndex,
					$author$project$MessageDropdown$channelDropdownList$(isMobile, nameSoFarData, guildOrDmId, local));
				if (!_v15.$) {
					var name = _v15.a.name;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							{
								end: nameSoFarData.index + $elm$core$String$length(nameSoFarData.nameSoFar),
								start: nameSoFarData.index
							},
							name));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			default:
				var range = nameSoFar.a;
				var timestampData = nameSoFar.b;
				var _v16 = $elmcraft$core_extra$List$Extra$getAt$(
					dropdownIndex,
					$author$project$MessageDropdown$timestampDropdownList$(local.localUser.timezone, time, timestampData));
				if (!_v16.$) {
					var timestamp = _v16.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							range,
							$author$project$RichText$dateAndTimeToString$(local.localUser.timezone, timestamp)));
				} else {
					return $elm$core$Maybe$Nothing;
				}
		}
	}();
	var _v0 = _Utils_Tuple2(pingUser, maybeTextToInsert);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var _v1 = _v0.b.a;
		var range = _v1.a;
		var textToInsert = _v1.b;
		return _Utils_Tuple3(
			$elm$core$Maybe$Nothing,
			inputText,
			$lamdera$program_test$Effect$Command$batch(
				_List_fromArray(
					[
						$lamdera$program_test$Effect$Task$attempt$(
						function (_v2) {
							return setFocusMsg;
						},
						$lamdera$program_test$Effect$Browser$Dom$focus(channelTextInputId)),
						$author$project$Ports$execCommand(
						{
							commands: _List_fromArray(
								[
									$author$project$Ports$InsertText$(textToInsert + ' ', range)
								]),
							htmlId: channelTextInputId
						})
					])));
	} else {
		return _Utils_Tuple3($elm$core$Maybe$Nothing, inputText, $lamdera$program_test$Effect$Command$none);
	}
};
var $author$project$MessageDropdown$pressedDropdownItem = function (setFocusMsg) {
	return function (isMobile) {
		return function (time) {
			return function (nameSoFar) {
				return function (guildOrDmId) {
					return function (channelTextInputId) {
						return function (dropdownIndex) {
							return function (pingUser) {
								return function (emojiData) {
									return function (local) {
										return function (inputText) {
											return $author$project$MessageDropdown$pressedDropdownItem$(setFocusMsg, isMobile, time, nameSoFar, guildOrDmId, channelTextInputId, dropdownIndex, pingUser, emojiData, local, inputText);
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$LocalState$slackGuildOrDmIdToMessage$ = function (guildOrDmId, threadRoute, local) {
	var helper = F2(
		function (thread, messageId) {
			var _v3 = $author$project$MessageArray$get$(messageId, thread.messages);
			if (!_v3.$) {
				switch (_v3.a.$) {
					case 0:
						var data = _v3.a.a;
						return $elm$core$Maybe$Just(
							{content: data.content, createdAt: data.createdAt, createdBy: data.createdBy, editedAt: data.editedAt, reactions: data.reactions});
					case 1:
						return $elm$core$Maybe$Nothing;
					case 2:
						var _v4 = _v3.a;
						return $elm$core$Maybe$Nothing;
					case 3:
						return $elm$core$Maybe$Nothing;
					case 4:
						return $elm$core$Maybe$Nothing;
					default:
						return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
	var conversationHelper = function (conversation) {
		if (threadRoute.$ === 1) {
			var threadId = threadRoute.a;
			var messageId = threadRoute.b;
			return $elm$core$Maybe$andThen$(
				function (thread) {
					return A2(helper, thread, messageId);
				},
				$lamdera$containers$SeqDict$get$(threadId, conversation.threads));
		} else {
			var messageId = threadRoute.a;
			return A2(helper, conversation, messageId);
		}
	};
	if (!guildOrDmId.$) {
		var channelId = guildOrDmId.a.channelId;
		var teamId = guildOrDmId.a.teamId;
		return $elm$core$Maybe$andThen$(
			function (_v1) {
				var channel = _v1.b;
				return conversationHelper(channel);
			},
			$author$project$LocalState$getSlackWorkspaceAndChannel$(teamId, channelId, local));
	} else {
		var channelId = guildOrDmId.a.channelId;
		return $elm$core$Maybe$andThen$(
			conversationHelper,
			$lamdera$containers$SeqDict$get$(channelId, local.slackDmChannels));
	}
};
var $author$project$LocalState$slackGuildOrDmIdToMessage = F3($author$project$LocalState$slackGuildOrDmIdToMessage$);
var $author$project$Id$threadRouteToMessageId = function (threadRoute) {
	if (threadRoute.$ === 1) {
		var messageId = threadRoute.b;
		return $author$project$Id$changeType(messageId);
	} else {
		var messageId = threadRoute.a;
		return messageId;
	}
};
var $author$project$Frontend$pressedEditMessage$ = function (guildOrDmId, threadRoute, model) {
	return $author$project$FrontendExtra$updateLoggedIn$(
		function (loggedIn) {
			var local = $author$project$Local$model(loggedIn.localState);
			var maybeContentAndFiles = function () {
				switch (guildOrDmId.$) {
					case 0:
						var guildOrDmId2 = guildOrDmId.a;
						var _v5 = $author$project$LocalState$guildOrDmIdToMessage$(guildOrDmId2, threadRoute, local);
						if (!_v5.$) {
							var _v6 = _v5.a;
							var message = _v6.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$author$project$RichText$toString$(
										local.localUser.timezone,
										false,
										$author$project$User$allUsers(local.localUser),
										$author$project$LocalState$channelMentions$(guildOrDmId2, local),
										message.content.content),
									message.content.attachedFiles));
						} else {
							return $elm$core$Maybe$Nothing;
						}
					case 1:
						var guildOrDmId2 = guildOrDmId.a;
						var _v7 = $author$project$LocalState$discordGuildOrDmIdToMessage$(guildOrDmId2, threadRoute, local);
						if (!_v7.$) {
							var _v8 = _v7.a;
							var message = _v8.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$author$project$RichText$toString$(
										local.localUser.timezone,
										false,
										$author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(local.localUser.discordUsers),
										$author$project$LocalState$discordChannelMentions$(guildOrDmId2, local),
										message.content.content),
									message.content.attachedFiles));
						} else {
							return $elm$core$Maybe$Nothing;
						}
					default:
						var guildOrDmId2 = guildOrDmId.a;
						var _v9 = $author$project$LocalState$slackGuildOrDmIdToMessage$(guildOrDmId2, threadRoute, local);
						if (!_v9.$) {
							var message = _v9.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$author$project$RichText$toString$(
										local.localUser.timezone,
										false,
										local.localUser.slackUsers,
										$author$project$LocalState$slackChannelMentions$(guildOrDmId2, local),
										message.content.content),
									message.content.attachedFiles));
						} else {
							return $elm$core$Maybe$Nothing;
						}
				}
			}();
			return _Utils_Tuple2(
				function () {
					if (!maybeContentAndFiles.$) {
						var _v1 = maybeContentAndFiles.a;
						var content = _v1.a;
						var attachedFiles = _v1.b;
						var loggedIn2 = _Utils_update(
							loggedIn,
							{
								editMessage: $lamdera$containers$SeqDict$insert$(
									_Utils_Tuple2(
										guildOrDmId,
										$author$project$Id$threadRouteWithoutMessage(threadRoute)),
									{
										attachedFiles: $lamdera$containers$SeqDict$map$(
											F2(
												function (_v3, a) {
													return $author$project$FileStatus$FileUploaded(a);
												}),
											attachedFiles),
										messageIndex: $author$project$Id$threadRouteToMessageId(threadRoute),
										text: content
									},
									loggedIn.editMessage)
							});
						return _Utils_update(
							loggedIn2,
							{
								messageHover: function () {
									if ($author$project$MyUi$isMobile(model)) {
										var _v2 = loggedIn2.messageHover;
										switch (_v2.$) {
											case 0:
												return loggedIn2.messageHover;
											case 1:
												return loggedIn2.messageHover;
											case 3:
												return loggedIn2.messageHover;
											default:
												var extraOptions = _v2.a;
												return $author$project$Types$MessageMenu(
													_Utils_update(
														extraOptions,
														{
															mobileMode: $author$project$Types$MessageMenuOpening(
																{
																	offset: $author$project$Types$messageMenuMobileOffset(extraOptions.mobileMode),
																	targetOffset: $author$project$MessageMenu$mobileMenuMaxHeight$(extraOptions, local, model)
																})
														}));
										}
									} else {
										return $author$project$Types$NoMessageHover;
									}
								}()
							});
					} else {
						return loggedIn;
					}
				}(),
				$lamdera$program_test$Effect$Command$batch(
					_List_fromArray(
						[
							$author$project$FrontendExtra$setFocus$(model, $author$project$MessageMenu$editMessageTextInputId),
							$author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn.channelScrollPosition)
						])));
		},
		model);
};
var $author$project$Frontend$pressedEditMessage = F3($author$project$Frontend$pressedEditMessage$);
var $author$project$Go$stepBack$ = function (shared, model) {
	return _Utils_update(
		model,
		{
			lastError: $elm$core$Maybe$Nothing,
			viewingMovesBack: $elm$core$Basics$min$(
				$elm$core$List$length(shared.history),
				model.viewingMovesBack + 1)
		});
};
var $author$project$Go$stepBack = F2($author$project$Go$stepBack$);
var $author$project$Go$stepForward = function (model) {
	return _Utils_update(
		model,
		{
			lastError: $elm$core$Maybe$Nothing,
			viewingMovesBack: $elm$core$Basics$max$(0, model.viewingMovesBack - 1)
		});
};
var $author$project$Go$pressedKey$ = function (key, shared, model) {
	switch (key) {
		case 'ArrowLeft':
			return $author$project$Go$stepBack$(shared, model);
		case 'ArrowRight':
			return $author$project$Go$stepForward(model);
		default:
			return model;
	}
};
var $author$project$Go$pressedKey = F3($author$project$Go$pressedKey$);
var $author$project$WordSpellingGame$pressedKey = function (model) {
	return model;
};
var $author$project$Game$pressedKey$ = function (matchId, key, matchData, maybeGameModel) {
	if (!matchData.$) {
		var matchData2 = matchData.a;
		var model = $elm$core$Maybe$withDefault$($author$project$Game$initModel, maybeGameModel);
		return $elm$core$Maybe$Just(
			_Utils_update(
				model,
				{
					startedGames: $lamdera$containers$SeqDict$updateIfExists$(
						matchId,
						function (game) {
							var _v1 = matchData2.data;
							switch (_v1.$) {
								case 0:
									var shared = _v1.c;
									if (!game.$) {
										var game2 = game.a;
										return $author$project$Game$GoModel_Game(
											$author$project$Go$pressedKey$(key, shared, game2));
									} else {
										return game;
									}
								case 1:
									if (game.$ === 1) {
										var game2 = game.a;
										return $author$project$Game$WordSpellingGame_Game(
											$author$project$WordSpellingGame$pressedKey(game2));
									} else {
										return game;
									}
								default:
									return game;
							}
						},
						model.startedGames)
				}));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Game$pressedKey = F4($author$project$Game$pressedKey$);
var $author$project$Frontend$pressedOpenEmojiSelector$ = function (textInputId, emojiSelector, model) {
	return $author$project$FrontendExtra$updateLoggedIn$(
		function (loggedIn) {
			var emojiSelectorModel = loggedIn.emojiSelector;
			return _Utils_Tuple2(
				_Utils_update(
					loggedIn,
					{
						emojiSelector: _Utils_update(
							emojiSelectorModel,
							{category: $author$project$Emoji$selectorInit.category, searchText: ''}),
						showEmojiSelector: function () {
							var _v0 = loggedIn.showEmojiSelector;
							if (!_v0.$) {
								var _v1 = loggedIn.previousTextInputFocus;
								if (!_v1.$) {
									var textInputFocus = _v1.a;
									return _Utils_eq(textInputFocus.htmlId, textInputId) ? emojiSelector(
										$elm$core$Maybe$Just(textInputFocus.selection)) : emojiSelector($elm$core$Maybe$Nothing);
								} else {
									return emojiSelector($elm$core$Maybe$Nothing);
								}
							} else {
								return $author$project$Types$EmojiSelectorHidden;
							}
						}()
					}),
				$author$project$MyUi$isMobile(model) ? $lamdera$program_test$Effect$Command$none : $lamdera$program_test$Effect$Task$attempt$(
					function (_v2) {
						return $author$project$Types$SetFocus;
					},
					$lamdera$program_test$Effect$Browser$Dom$focus($author$project$Emoji$searchInputId)));
		},
		model);
};
var $author$project$Frontend$pressedOpenEmojiSelector = F3($author$project$Frontend$pressedOpenEmojiSelector$);
var $author$project$Frontend$pressedReply$ = function (guildOrDmId, threadRoute, loggedIn, model) {
	return _Utils_Tuple2(
		$author$project$MessageMenu$close$(
			model,
			_Utils_update(
				loggedIn,
				{
					replyTo: $lamdera$containers$SeqDict$insert$(
						_Utils_Tuple2(
							guildOrDmId,
							$author$project$Id$threadRouteWithoutMessage(threadRoute)),
						$author$project$Message$RepliedToMessage(
							$author$project$Id$threadRouteToMessageId(threadRoute)),
						loggedIn.replyTo)
				})),
		$lamdera$program_test$Effect$Command$batch(
			_List_fromArray(
				[
					$author$project$FrontendExtra$setFocus$(model, $author$project$Pages$Guild$channelTextInputId),
					$author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn.channelScrollPosition)
				])));
};
var $author$project$Frontend$pressedReply = F4($author$project$Frontend$pressedReply$);
var $author$project$X25519$PrivateKey = $elm$core$Basics$identity;
var $author$project$X25519$keyFromWords = function (words) {
	if ((((((((words.b && words.b.b) && words.b.b.b) && words.b.b.b.b) && words.b.b.b.b.b) && words.b.b.b.b.b.b) && words.b.b.b.b.b.b.b) && words.b.b.b.b.b.b.b.b) && (!words.b.b.b.b.b.b.b.b.b)) {
		var w0 = words.a;
		var _v1 = words.b;
		var w1 = _v1.a;
		var _v2 = _v1.b;
		var w2 = _v2.a;
		var _v3 = _v2.b;
		var w3 = _v3.a;
		var _v4 = _v3.b;
		var w4 = _v4.a;
		var _v5 = _v4.b;
		var w5 = _v5.a;
		var _v6 = _v5.b;
		var w6 = _v6.a;
		var _v7 = _v6.b;
		var w7 = _v7.a;
		return $elm$core$Maybe$Just(
			{w0: w0, w1: w1, w2: w2, w3: w3, w4: w4, w5: w5, w6: w6, w7: w7});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$X25519$keyLength = 32;
var $author$project$X25519$wordListStep = function (_v0) {
	var remaining = _v0.a;
	var acc = _v0.b;
	return (remaining <= 0) ? $elm$bytes$Bytes$Decode$succeed(
		$elm$bytes$Bytes$Decode$Done(
			$elm$core$List$reverse(acc))) : $elm$bytes$Bytes$Decode$map$(
		function (word) {
			return $elm$bytes$Bytes$Decode$Loop(
				_Utils_Tuple2(
					remaining - 1,
					A2($elm$core$List$cons, word, acc)));
		},
		$elm$bytes$Bytes$Decode$unsignedInt32(0));
};
var $author$project$X25519$keyFromBytes = function (bytes) {
	return _Utils_eq(
		$elm$bytes$Bytes$width(bytes),
		$author$project$X25519$keyLength) ? $elm$core$Maybe$andThen$(
		$author$project$X25519$keyFromWords,
		$elm$bytes$Bytes$Decode$decode$(
			$elm$bytes$Bytes$Decode$loop$(
				_Utils_Tuple2(8, _List_Nil),
				$author$project$X25519$wordListStep),
			bytes)) : $elm$core$Maybe$Nothing;
};
var $author$project$X25519$privateKeyFromBytes = function (bytes) {
	return $elm$core$Maybe$map$(
		$elm$core$Basics$identity,
		$author$project$X25519$keyFromBytes(bytes));
};
var $author$project$X25519$privateKeyFromString = function (text) {
	var _v0 = $danfishgold$base64_bytes$Base64$toBytes(text);
	if (!_v0.$) {
		var bytes = _v0.a;
		var _v1 = $author$project$X25519$privateKeyFromBytes(bytes);
		if (!_v1.$) {
			var key = _v1.a;
			return $elm$core$Result$Ok(key);
		} else {
			return $elm$core$Result$Err('Invalid private key');
		}
	} else {
		return $elm$core$Result$Err('Invalid base64 string');
	}
};
var $author$project$X25519$PublicKey = $elm$core$Basics$identity;
var $author$project$X25519$keyZero = {w0: 0, w1: 0, w2: 0, w3: 0, w4: 0, w5: 0, w6: 0, w7: 0};
var $author$project$X25519$basePoint = _Utils_update(
	$author$project$X25519$keyZero,
	{w0: 9});
var $author$project$X25519$carryLimb$ = function (limb, carry) {
	var value = (limb + carry) + 65535;
	var nextCarry = $elm$core$Basics$floor(value / 65536);
	return _Utils_Tuple2(nextCarry, value - (nextCarry * 65536));
};
var $author$project$X25519$carryLimb = F2($author$project$X25519$carryLimb$);
var $author$project$X25519$feCarry = function (fe) {
	var _v0 = $author$project$X25519$carryLimb$(fe.l0, 1);
	var c0 = _v0.a;
	var v0 = _v0.b;
	var _v1 = $author$project$X25519$carryLimb$(fe.l1, c0);
	var c1 = _v1.a;
	var v1 = _v1.b;
	var _v2 = $author$project$X25519$carryLimb$(fe.l2, c1);
	var c2 = _v2.a;
	var v2 = _v2.b;
	var _v3 = $author$project$X25519$carryLimb$(fe.l3, c2);
	var c3 = _v3.a;
	var v3 = _v3.b;
	var _v4 = $author$project$X25519$carryLimb$(fe.l4, c3);
	var c4 = _v4.a;
	var v4 = _v4.b;
	var _v5 = $author$project$X25519$carryLimb$(fe.l5, c4);
	var c5 = _v5.a;
	var v5 = _v5.b;
	var _v6 = $author$project$X25519$carryLimb$(fe.l6, c5);
	var c6 = _v6.a;
	var v6 = _v6.b;
	var _v7 = $author$project$X25519$carryLimb$(fe.l7, c6);
	var c7 = _v7.a;
	var v7 = _v7.b;
	var _v8 = $author$project$X25519$carryLimb$(fe.l8, c7);
	var c8 = _v8.a;
	var v8 = _v8.b;
	var _v9 = $author$project$X25519$carryLimb$(fe.l9, c8);
	var c9 = _v9.a;
	var v9 = _v9.b;
	var _v10 = $author$project$X25519$carryLimb$(fe.l10, c9);
	var c10 = _v10.a;
	var v10 = _v10.b;
	var _v11 = $author$project$X25519$carryLimb$(fe.l11, c10);
	var c11 = _v11.a;
	var v11 = _v11.b;
	var _v12 = $author$project$X25519$carryLimb$(fe.l12, c11);
	var c12 = _v12.a;
	var v12 = _v12.b;
	var _v13 = $author$project$X25519$carryLimb$(fe.l13, c12);
	var c13 = _v13.a;
	var v13 = _v13.b;
	var _v14 = $author$project$X25519$carryLimb$(fe.l14, c13);
	var c14 = _v14.a;
	var v14 = _v14.b;
	var _v15 = $author$project$X25519$carryLimb$(fe.l15, c14);
	var c15 = _v15.a;
	var v15 = _v15.b;
	return {l0: v0 + (38 * (c15 - 1)), l1: v1, l10: v10, l11: v11, l12: v12, l13: v13, l14: v14, l15: v15, l2: v2, l3: v3, l4: v4, l5: v5, l6: v6, l7: v7, l8: v8, l9: v9};
};
var $author$project$X25519$feMul$ = function (a, b) {
	return $author$project$X25519$feCarry(
		$author$project$X25519$feCarry(
			{l0: (a.l0 * b.l0) + (38 * (((((((((((((((a.l1 * b.l15) + (a.l2 * b.l14)) + (a.l3 * b.l13)) + (a.l4 * b.l12)) + (a.l5 * b.l11)) + (a.l6 * b.l10)) + (a.l7 * b.l9)) + (a.l8 * b.l8)) + (a.l9 * b.l7)) + (a.l10 * b.l6)) + (a.l11 * b.l5)) + (a.l12 * b.l4)) + (a.l13 * b.l3)) + (a.l14 * b.l2)) + (a.l15 * b.l1))), l1: ((a.l0 * b.l1) + (a.l1 * b.l0)) + (38 * ((((((((((((((a.l2 * b.l15) + (a.l3 * b.l14)) + (a.l4 * b.l13)) + (a.l5 * b.l12)) + (a.l6 * b.l11)) + (a.l7 * b.l10)) + (a.l8 * b.l9)) + (a.l9 * b.l8)) + (a.l10 * b.l7)) + (a.l11 * b.l6)) + (a.l12 * b.l5)) + (a.l13 * b.l4)) + (a.l14 * b.l3)) + (a.l15 * b.l2))), l10: (((((((((((a.l0 * b.l10) + (a.l1 * b.l9)) + (a.l2 * b.l8)) + (a.l3 * b.l7)) + (a.l4 * b.l6)) + (a.l5 * b.l5)) + (a.l6 * b.l4)) + (a.l7 * b.l3)) + (a.l8 * b.l2)) + (a.l9 * b.l1)) + (a.l10 * b.l0)) + (38 * (((((a.l11 * b.l15) + (a.l12 * b.l14)) + (a.l13 * b.l13)) + (a.l14 * b.l12)) + (a.l15 * b.l11))), l11: ((((((((((((a.l0 * b.l11) + (a.l1 * b.l10)) + (a.l2 * b.l9)) + (a.l3 * b.l8)) + (a.l4 * b.l7)) + (a.l5 * b.l6)) + (a.l6 * b.l5)) + (a.l7 * b.l4)) + (a.l8 * b.l3)) + (a.l9 * b.l2)) + (a.l10 * b.l1)) + (a.l11 * b.l0)) + (38 * ((((a.l12 * b.l15) + (a.l13 * b.l14)) + (a.l14 * b.l13)) + (a.l15 * b.l12))), l12: (((((((((((((a.l0 * b.l12) + (a.l1 * b.l11)) + (a.l2 * b.l10)) + (a.l3 * b.l9)) + (a.l4 * b.l8)) + (a.l5 * b.l7)) + (a.l6 * b.l6)) + (a.l7 * b.l5)) + (a.l8 * b.l4)) + (a.l9 * b.l3)) + (a.l10 * b.l2)) + (a.l11 * b.l1)) + (a.l12 * b.l0)) + (38 * (((a.l13 * b.l15) + (a.l14 * b.l14)) + (a.l15 * b.l13))), l13: ((((((((((((((a.l0 * b.l13) + (a.l1 * b.l12)) + (a.l2 * b.l11)) + (a.l3 * b.l10)) + (a.l4 * b.l9)) + (a.l5 * b.l8)) + (a.l6 * b.l7)) + (a.l7 * b.l6)) + (a.l8 * b.l5)) + (a.l9 * b.l4)) + (a.l10 * b.l3)) + (a.l11 * b.l2)) + (a.l12 * b.l1)) + (a.l13 * b.l0)) + (38 * ((a.l14 * b.l15) + (a.l15 * b.l14))), l14: (((((((((((((((a.l0 * b.l14) + (a.l1 * b.l13)) + (a.l2 * b.l12)) + (a.l3 * b.l11)) + (a.l4 * b.l10)) + (a.l5 * b.l9)) + (a.l6 * b.l8)) + (a.l7 * b.l7)) + (a.l8 * b.l6)) + (a.l9 * b.l5)) + (a.l10 * b.l4)) + (a.l11 * b.l3)) + (a.l12 * b.l2)) + (a.l13 * b.l1)) + (a.l14 * b.l0)) + (38 * (a.l15 * b.l15)), l15: (((((((((((((((a.l0 * b.l15) + (a.l1 * b.l14)) + (a.l2 * b.l13)) + (a.l3 * b.l12)) + (a.l4 * b.l11)) + (a.l5 * b.l10)) + (a.l6 * b.l9)) + (a.l7 * b.l8)) + (a.l8 * b.l7)) + (a.l9 * b.l6)) + (a.l10 * b.l5)) + (a.l11 * b.l4)) + (a.l12 * b.l3)) + (a.l13 * b.l2)) + (a.l14 * b.l1)) + (a.l15 * b.l0), l2: (((a.l0 * b.l2) + (a.l1 * b.l1)) + (a.l2 * b.l0)) + (38 * (((((((((((((a.l3 * b.l15) + (a.l4 * b.l14)) + (a.l5 * b.l13)) + (a.l6 * b.l12)) + (a.l7 * b.l11)) + (a.l8 * b.l10)) + (a.l9 * b.l9)) + (a.l10 * b.l8)) + (a.l11 * b.l7)) + (a.l12 * b.l6)) + (a.l13 * b.l5)) + (a.l14 * b.l4)) + (a.l15 * b.l3))), l3: ((((a.l0 * b.l3) + (a.l1 * b.l2)) + (a.l2 * b.l1)) + (a.l3 * b.l0)) + (38 * ((((((((((((a.l4 * b.l15) + (a.l5 * b.l14)) + (a.l6 * b.l13)) + (a.l7 * b.l12)) + (a.l8 * b.l11)) + (a.l9 * b.l10)) + (a.l10 * b.l9)) + (a.l11 * b.l8)) + (a.l12 * b.l7)) + (a.l13 * b.l6)) + (a.l14 * b.l5)) + (a.l15 * b.l4))), l4: (((((a.l0 * b.l4) + (a.l1 * b.l3)) + (a.l2 * b.l2)) + (a.l3 * b.l1)) + (a.l4 * b.l0)) + (38 * (((((((((((a.l5 * b.l15) + (a.l6 * b.l14)) + (a.l7 * b.l13)) + (a.l8 * b.l12)) + (a.l9 * b.l11)) + (a.l10 * b.l10)) + (a.l11 * b.l9)) + (a.l12 * b.l8)) + (a.l13 * b.l7)) + (a.l14 * b.l6)) + (a.l15 * b.l5))), l5: ((((((a.l0 * b.l5) + (a.l1 * b.l4)) + (a.l2 * b.l3)) + (a.l3 * b.l2)) + (a.l4 * b.l1)) + (a.l5 * b.l0)) + (38 * ((((((((((a.l6 * b.l15) + (a.l7 * b.l14)) + (a.l8 * b.l13)) + (a.l9 * b.l12)) + (a.l10 * b.l11)) + (a.l11 * b.l10)) + (a.l12 * b.l9)) + (a.l13 * b.l8)) + (a.l14 * b.l7)) + (a.l15 * b.l6))), l6: (((((((a.l0 * b.l6) + (a.l1 * b.l5)) + (a.l2 * b.l4)) + (a.l3 * b.l3)) + (a.l4 * b.l2)) + (a.l5 * b.l1)) + (a.l6 * b.l0)) + (38 * (((((((((a.l7 * b.l15) + (a.l8 * b.l14)) + (a.l9 * b.l13)) + (a.l10 * b.l12)) + (a.l11 * b.l11)) + (a.l12 * b.l10)) + (a.l13 * b.l9)) + (a.l14 * b.l8)) + (a.l15 * b.l7))), l7: ((((((((a.l0 * b.l7) + (a.l1 * b.l6)) + (a.l2 * b.l5)) + (a.l3 * b.l4)) + (a.l4 * b.l3)) + (a.l5 * b.l2)) + (a.l6 * b.l1)) + (a.l7 * b.l0)) + (38 * ((((((((a.l8 * b.l15) + (a.l9 * b.l14)) + (a.l10 * b.l13)) + (a.l11 * b.l12)) + (a.l12 * b.l11)) + (a.l13 * b.l10)) + (a.l14 * b.l9)) + (a.l15 * b.l8))), l8: (((((((((a.l0 * b.l8) + (a.l1 * b.l7)) + (a.l2 * b.l6)) + (a.l3 * b.l5)) + (a.l4 * b.l4)) + (a.l5 * b.l3)) + (a.l6 * b.l2)) + (a.l7 * b.l1)) + (a.l8 * b.l0)) + (38 * (((((((a.l9 * b.l15) + (a.l10 * b.l14)) + (a.l11 * b.l13)) + (a.l12 * b.l12)) + (a.l13 * b.l11)) + (a.l14 * b.l10)) + (a.l15 * b.l9))), l9: ((((((((((a.l0 * b.l9) + (a.l1 * b.l8)) + (a.l2 * b.l7)) + (a.l3 * b.l6)) + (a.l4 * b.l5)) + (a.l5 * b.l4)) + (a.l6 * b.l3)) + (a.l7 * b.l2)) + (a.l8 * b.l1)) + (a.l9 * b.l0)) + (38 * ((((((a.l10 * b.l15) + (a.l11 * b.l14)) + (a.l12 * b.l13)) + (a.l13 * b.l12)) + (a.l14 * b.l11)) + (a.l15 * b.l10)))}));
};
var $author$project$X25519$feMul = F2($author$project$X25519$feMul$);
var $author$project$X25519$feSquare = function (a) {
	return $author$project$X25519$feMul$(a, a);
};
var $author$project$X25519$invertStep$ = function (base, bitIndex, acc) {
	invertStep:
	while (true) {
		if (bitIndex < 0) {
			return acc;
		} else {
			var squared = $author$project$X25519$feSquare(acc);
			var $temp$bitIndex = bitIndex - 1,
				$temp$acc = ((bitIndex === 2) || (bitIndex === 4)) ? squared : $author$project$X25519$feMul$(squared, base);
			bitIndex = $temp$bitIndex;
			acc = $temp$acc;
			continue invertStep;
		}
	}
};
var $author$project$X25519$invertStep = F3($author$project$X25519$invertStep$);
var $author$project$X25519$feInvert = function (fe) {
	return $author$project$X25519$invertStep$(fe, 253, fe);
};
var $author$project$X25519$feZero = {l0: 0, l1: 0, l10: 0, l11: 0, l12: 0, l13: 0, l14: 0, l15: 0, l2: 0, l3: 0, l4: 0, l5: 0, l6: 0, l7: 0, l8: 0, l9: 0};
var $author$project$X25519$feOne = _Utils_update(
	$author$project$X25519$feZero,
	{l0: 1});
var $author$project$X25519$borrowLimb$ = function (limb, subtrahend, borrow) {
	var value = (limb - subtrahend) - borrow;
	return _Utils_Tuple2(1 & (value >> 16), value);
};
var $author$project$X25519$borrowLimb = F3($author$project$X25519$borrowLimb$);
var $author$project$X25519$feMap2$ = function (combine, a, b) {
	return {
		l0: A2(combine, a.l0, b.l0),
		l1: A2(combine, a.l1, b.l1),
		l10: A2(combine, a.l10, b.l10),
		l11: A2(combine, a.l11, b.l11),
		l12: A2(combine, a.l12, b.l12),
		l13: A2(combine, a.l13, b.l13),
		l14: A2(combine, a.l14, b.l14),
		l15: A2(combine, a.l15, b.l15),
		l2: A2(combine, a.l2, b.l2),
		l3: A2(combine, a.l3, b.l3),
		l4: A2(combine, a.l4, b.l4),
		l5: A2(combine, a.l5, b.l5),
		l6: A2(combine, a.l6, b.l6),
		l7: A2(combine, a.l7, b.l7),
		l8: A2(combine, a.l8, b.l8),
		l9: A2(combine, a.l9, b.l9)
	};
};
var $author$project$X25519$feMap2 = F3($author$project$X25519$feMap2$);
var $author$project$X25519$feSwap$ = function (swap, p, q) {
	var mask = ~(swap - 1);
	var difference = $author$project$X25519$feMap2$(
		F2(
			function (left, right) {
				return mask & (left ^ right);
			}),
		p,
		q);
	return _Utils_Tuple2(
		$author$project$X25519$feMap2$($elm$core$Bitwise$xor, p, difference),
		$author$project$X25519$feMap2$($elm$core$Bitwise$xor, q, difference));
};
var $author$project$X25519$feSwap = F3($author$project$X25519$feSwap$);
var $author$project$X25519$subtractPrime = function (fe) {
	var _v0 = $author$project$X25519$borrowLimb$(fe.l0, 65517, 0);
	var b0 = _v0.a;
	var m0 = _v0.b;
	var _v1 = $author$project$X25519$borrowLimb$(fe.l1, 65535, b0);
	var b1 = _v1.a;
	var m1 = _v1.b;
	var _v2 = $author$project$X25519$borrowLimb$(fe.l2, 65535, b1);
	var b2 = _v2.a;
	var m2 = _v2.b;
	var _v3 = $author$project$X25519$borrowLimb$(fe.l3, 65535, b2);
	var b3 = _v3.a;
	var m3 = _v3.b;
	var _v4 = $author$project$X25519$borrowLimb$(fe.l4, 65535, b3);
	var b4 = _v4.a;
	var m4 = _v4.b;
	var _v5 = $author$project$X25519$borrowLimb$(fe.l5, 65535, b4);
	var b5 = _v5.a;
	var m5 = _v5.b;
	var _v6 = $author$project$X25519$borrowLimb$(fe.l6, 65535, b5);
	var b6 = _v6.a;
	var m6 = _v6.b;
	var _v7 = $author$project$X25519$borrowLimb$(fe.l7, 65535, b6);
	var b7 = _v7.a;
	var m7 = _v7.b;
	var _v8 = $author$project$X25519$borrowLimb$(fe.l8, 65535, b7);
	var b8 = _v8.a;
	var m8 = _v8.b;
	var _v9 = $author$project$X25519$borrowLimb$(fe.l9, 65535, b8);
	var b9 = _v9.a;
	var m9 = _v9.b;
	var _v10 = $author$project$X25519$borrowLimb$(fe.l10, 65535, b9);
	var b10 = _v10.a;
	var m10 = _v10.b;
	var _v11 = $author$project$X25519$borrowLimb$(fe.l11, 65535, b10);
	var b11 = _v11.a;
	var m11 = _v11.b;
	var _v12 = $author$project$X25519$borrowLimb$(fe.l12, 65535, b11);
	var b12 = _v12.a;
	var m12 = _v12.b;
	var _v13 = $author$project$X25519$borrowLimb$(fe.l13, 65535, b12);
	var b13 = _v13.a;
	var m13 = _v13.b;
	var _v14 = $author$project$X25519$borrowLimb$(fe.l14, 65535, b13);
	var b14 = _v14.a;
	var m14 = _v14.b;
	var _v15 = $author$project$X25519$borrowLimb$(fe.l15, 32767, b14);
	var b15 = _v15.a;
	var m15 = _v15.b;
	var subtracted = {l0: 65535 & m0, l1: 65535 & m1, l10: 65535 & m10, l11: 65535 & m11, l12: 65535 & m12, l13: 65535 & m13, l14: 65535 & m14, l15: m15, l2: 65535 & m2, l3: 65535 & m3, l4: 65535 & m4, l5: 65535 & m5, l6: 65535 & m6, l7: 65535 & m7, l8: 65535 & m8, l9: 65535 & m9};
	return $author$project$X25519$feSwap$(1 - b15, fe, subtracted).a;
};
var $author$project$X25519$fePack = function (fe) {
	var reduced = $author$project$X25519$subtractPrime(
		$author$project$X25519$subtractPrime(
			$author$project$X25519$feCarry(
				$author$project$X25519$feCarry(
					$author$project$X25519$feCarry(fe)))));
	return {w0: reduced.l0 + (reduced.l1 * 65536), w1: reduced.l2 + (reduced.l3 * 65536), w2: reduced.l4 + (reduced.l5 * 65536), w3: reduced.l6 + (reduced.l7 * 65536), w4: reduced.l8 + (reduced.l9 * 65536), w5: reduced.l10 + (reduced.l11 * 65536), w6: reduced.l12 + (reduced.l13 * 65536), w7: reduced.l14 + (reduced.l15 * 65536)};
};
var $author$project$X25519$feUnpack = function (key) {
	return {
		l0: A2($elm$core$Basics$modBy, 65536, key.w0),
		l1: (key.w0 / 65536) | 0,
		l10: A2($elm$core$Basics$modBy, 65536, key.w5),
		l11: (key.w5 / 65536) | 0,
		l12: A2($elm$core$Basics$modBy, 65536, key.w6),
		l13: (key.w6 / 65536) | 0,
		l14: A2($elm$core$Basics$modBy, 65536, key.w7),
		l15: A2($elm$core$Basics$modBy, 32768, (key.w7 / 65536) | 0),
		l2: A2($elm$core$Basics$modBy, 65536, key.w1),
		l3: (key.w1 / 65536) | 0,
		l4: A2($elm$core$Basics$modBy, 65536, key.w2),
		l5: (key.w2 / 65536) | 0,
		l6: A2($elm$core$Basics$modBy, 65536, key.w3),
		l7: (key.w3 / 65536) | 0,
		l8: A2($elm$core$Basics$modBy, 65536, key.w4),
		l9: (key.w4 / 65536) | 0
	};
};
var $author$project$X25519$fe121665 = _Utils_update(
	$author$project$X25519$feZero,
	{l0: 56129, l1: 1});
var $author$project$X25519$feAdd$ = function (a, b) {
	return $author$project$X25519$feMap2$($elm$core$Basics$add, a, b);
};
var $author$project$X25519$feAdd = F2($author$project$X25519$feAdd$);
var $author$project$X25519$feSub$ = function (a, b) {
	return $author$project$X25519$feMap2$($elm$core$Basics$sub, a, b);
};
var $author$project$X25519$feSub = F2($author$project$X25519$feSub$);
var $author$project$X25519$ladderStep$ = function (x1, bit, state) {
	var _v0 = $author$project$X25519$feSwap$(bit, state.z2, state.z3);
	var c0 = _v0.a;
	var d0 = _v0.b;
	var _v1 = $author$project$X25519$feSwap$(bit, state.x2, state.x3);
	var a0 = _v1.a;
	var b0 = _v1.b;
	var a1 = $author$project$X25519$feSub$(a0, c0);
	var f0 = $author$project$X25519$feSquare(a1);
	var e0 = $author$project$X25519$feAdd$(a0, c0);
	var d1 = $author$project$X25519$feSquare(e0);
	var a5 = $author$project$X25519$feMul$(d1, f0);
	var c3 = $author$project$X25519$feSub$(d1, f0);
	var a4 = $author$project$X25519$feAdd$(
		$author$project$X25519$feMul$(c3, $author$project$X25519$fe121665),
		d1);
	var c4 = $author$project$X25519$feMul$(c3, a4);
	var b1 = $author$project$X25519$feSub$(b0, d0);
	var c2 = $author$project$X25519$feMul$(b1, e0);
	var c1 = $author$project$X25519$feAdd$(b0, d0);
	var a2 = $author$project$X25519$feMul$(c1, a1);
	var a3 = $author$project$X25519$feSub$(a2, c2);
	var b2 = $author$project$X25519$feSquare(a3);
	var d2 = $author$project$X25519$feMul$(b2, x1);
	var _v2 = $author$project$X25519$feSwap$(bit, c4, d2);
	var z2 = _v2.a;
	var z3 = _v2.b;
	var e1 = $author$project$X25519$feAdd$(a2, c2);
	var b3 = $author$project$X25519$feSquare(e1);
	var _v3 = $author$project$X25519$feSwap$(bit, a5, b3);
	var x2 = _v3.a;
	var x3 = _v3.b;
	return {x2: x2, x3: x3, z2: z2, z3: z3};
};
var $author$project$X25519$ladderStep = F3($author$project$X25519$ladderStep$);
var $author$project$X25519$wordBits = function (word) {
	return $elm$core$List$map$(
		function (bit) {
			return A2(
				$elm$core$Basics$modBy,
				2,
				(word / A2($elm$core$Basics$pow, 2, bit)) | 0);
		},
		$elm$core$List$reverse(
			$elm$core$List$range$(0, 31)));
};
var $author$project$X25519$scalarBits = function (key) {
	return $elm$core$List$drop$(
		1,
		$elm$core$List$concatMap$(
			$author$project$X25519$wordBits,
			_List_fromArray(
				[
					1073741824 | (2147483647 & key.w7),
					key.w6,
					key.w5,
					key.w4,
					key.w3,
					key.w2,
					key.w1,
					key.w0 - A2($elm$core$Basics$modBy, 8, key.w0)
				])));
};
var $author$project$X25519$scalarMult$ = function (scalar, point) {
	var x1 = $author$project$X25519$feUnpack(point);
	var _final = $elm$core$List$foldl$(
		$author$project$X25519$ladderStep(x1),
		{x2: $author$project$X25519$feOne, x3: x1, z2: $author$project$X25519$feZero, z3: $author$project$X25519$feOne},
		$author$project$X25519$scalarBits(scalar));
	return $author$project$X25519$fePack(
		$author$project$X25519$feMul$(
			_final.x2,
			$author$project$X25519$feInvert(_final.z2)));
};
var $author$project$X25519$scalarMult = F2($author$project$X25519$scalarMult$);
var $author$project$X25519$toPublicKey = function (_v0) {
	var scalar = _v0;
	return $author$project$X25519$scalarMult$(scalar, $author$project$X25519$basePoint);
};
var $author$project$User$privateKeyForAccount$ = function (text, user) {
	var _v0 = user.publicKey;
	if (_v0.$ === 1) {
		return $elm$core$Result$Err('This account doesn\u0027t have a key pair yet');
	} else {
		var publicKey = _v0.a;
		var _v1 = $author$project$X25519$privateKeyFromString(
			$elm$core$String$trim(text));
		if (!_v1.$) {
			var privateKey = _v1.a;
			return _Utils_eq(
				$author$project$X25519$toPublicKey(privateKey),
				publicKey) ? $elm$core$Result$Ok(privateKey) : $elm$core$Result$Err('That isn\u0027t the private key for this account');
		} else {
			var error = _v1.a;
			return $elm$core$Result$Err(error);
		}
	}
};
var $author$project$User$privateKeyForAccount = F2($author$project$User$privateKeyForAccount$);
var $author$project$X25519$privateKeyFromListInt = function (ints) {
	return $elm$core$Maybe$map$(
		$elm$core$Basics$identity,
		$author$project$X25519$keyFromWords(
			$elm$core$List$map$(
				$elm$core$Basics$modBy(4294967296),
				$elm$core$List$take$(8, ints))));
};
var $author$project$User$redactedPrivateKey = '*don\u0027t reveal your private key!*';
var $elm$core$String$words = _String_words;
var $author$project$User$redactPrivateKeys$ = function (user, text) {
	var _v0 = user.publicKey;
	if (_v0.$ === 1) {
		return text;
	} else {
		var original = $MartinSStewart$elm_nonempty_string$String$Nonempty$toString(text);
		return $elm$core$Maybe$withDefault$(
			text,
			$MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(
				$elm$core$List$foldl$(
					F2(
						function (word, acc) {
							return $elm$core$String$replace$(word, $author$project$User$redactedPrivateKey, acc);
						}),
					original,
					$elm$core$List$filter$(
						function (word) {
							return A2($elm$core$String$endsWith, '=', word) && function () {
								var _v1 = $author$project$User$privateKeyForAccount$(word, user);
								if (!_v1.$) {
									return true;
								} else {
									return false;
								}
							}();
						},
						$elm$core$String$words(original)))));
	}
};
var $author$project$User$redactPrivateKeys = F2($author$project$User$redactPrivateKeys$);
var $author$project$Ports$register_push_subscription_to_js = _Platform_outgoingPort('register_push_subscription_to_js', $elm$core$Basics$identity);
var $author$project$Ports$registerPushSubscriptionToJs = function (publicKey) {
	return A3(
		$lamdera$program_test$Effect$Command$sendToJs,
		'register_push_subscription_to_js',
		$author$project$Ports$register_push_subscription_to_js,
		$elm$json$Json$Encode$string(publicKey));
};
var $lamdera$program_test$Effect$Browser$Navigation$reload = $lamdera$program_test$Effect$Internal$NavigationReload;
var $author$project$Frontend$rememberDecryptManyRequest$ = function (pending, requests) {
	return _Utils_update(
		requests,
		{
			nextDecryptManyRequestId: $author$project$Id$increment(requests.nextDecryptManyRequestId),
			pendingDecryptedManyMessages: $lamdera$containers$SeqDict$insert$(requests.nextDecryptManyRequestId, pending, requests.pendingDecryptedManyMessages)
		});
};
var $author$project$Frontend$rememberDecryptManyRequest = F2($author$project$Frontend$rememberDecryptManyRequest$);
var $author$project$Frontend$rememberEncryptManyRequests$ = function (conversations, requests) {
	return _Utils_update(
		requests,
		{
			nextEncryptManyRequestId: $author$project$Id$fromInt(
				$author$project$Id$toInt(requests.nextEncryptManyRequestId) + $elm$core$List$length(conversations)),
			pendingEncryptedManyMessages: $elm$core$List$foldl$(
				F2(
					function (_v0, dict) {
						var requestId = _v0.a;
						var conversation = _v0.b;
						return $lamdera$containers$SeqDict$insert$(requestId, conversation, dict);
					}),
				requests.pendingEncryptedManyMessages,
				conversations)
		});
};
var $author$project$Frontend$rememberEncryptManyRequests = F2($author$project$Frontend$rememberEncryptManyRequests$);
var $author$project$RichText$removeAttachedFile$ = function (shouldRemove, list) {
	return $mgold$elm_nonempty_list$List$Nonempty$fromList(
		$elm$core$List$filterMap$(
			function (richText) {
				switch (richText.$) {
					case 2:
						return $elm$core$Maybe$Just(richText);
					case 0:
						return $elm$core$Maybe$Just(richText);
					case 1:
						return $elm$core$Maybe$Just(richText);
					case 3:
						var nonempty = richText.a;
						return $elm$core$Maybe$map$(
							$author$project$RichText$Bold,
							$author$project$RichText$removeAttachedFile$(shouldRemove, nonempty));
					case 4:
						var nonempty = richText.a;
						return $elm$core$Maybe$map$(
							$author$project$RichText$Italic,
							$author$project$RichText$removeAttachedFile$(shouldRemove, nonempty));
					case 5:
						var nonempty = richText.a;
						return $elm$core$Maybe$map$(
							$author$project$RichText$Underline,
							$author$project$RichText$removeAttachedFile$(shouldRemove, nonempty));
					case 6:
						var nonempty = richText.a;
						return $elm$core$Maybe$map$(
							$author$project$RichText$Strikethrough,
							$author$project$RichText$removeAttachedFile$(shouldRemove, nonempty));
					case 7:
						var nonempty = richText.a;
						return $elm$core$Maybe$map$(
							$author$project$RichText$Spoiler,
							$author$project$RichText$removeAttachedFile$(shouldRemove, nonempty));
					case 8:
						var a = richText.a;
						var list2 = richText.b;
						var _v1 = $mgold$elm_nonempty_list$List$Nonempty$fromList(list2);
						if (!_v1.$) {
							var nonempty = _v1.a;
							var _v2 = $author$project$RichText$removeAttachedFile$(shouldRemove, nonempty);
							if (!_v2.$) {
								var nonempty2 = _v2.a;
								return $elm$core$Maybe$Just(
									$author$project$RichText$BlockQuote$(
										a,
										$mgold$elm_nonempty_list$List$Nonempty$toList(nonempty2)));
							} else {
								return $elm$core$Maybe$Just(
									$author$project$RichText$BlockQuote$(a, _List_Nil));
							}
						} else {
							return $elm$core$Maybe$Just(richText);
						}
					case 9:
						var level = richText.a;
						var a = richText.b;
						var nonempty = richText.c;
						return $elm$core$Maybe$map$(
							A2($author$project$RichText$Heading, level, a),
							$author$project$RichText$removeAttachedFile$(shouldRemove, nonempty));
					case 10:
						return $elm$core$Maybe$Just(richText);
					case 11:
						return $elm$core$Maybe$Just(richText);
					case 12:
						return $elm$core$Maybe$Just(richText);
					case 13:
						return $elm$core$Maybe$Just(richText);
					case 14:
						var fileId = richText.a;
						return shouldRemove(fileId) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(richText);
					case 15:
						return $elm$core$Maybe$Just(richText);
					case 16:
						return $elm$core$Maybe$Just(richText);
					case 17:
						return $elm$core$Maybe$Just(richText);
					case 18:
						var a = richText.a;
						var items = richText.b;
						return $elm$core$Maybe$Just(
							$author$project$RichText$BulletPoint$(
								a,
								$mgold$elm_nonempty_list$List$Nonempty$map$(
									function (item) {
										var _v3 = $mgold$elm_nonempty_list$List$Nonempty$fromList(item);
										if (!_v3.$) {
											var nonempty = _v3.a;
											return $elm$core$Maybe$withDefault$(
												_List_Nil,
												$elm$core$Maybe$map$(
													$mgold$elm_nonempty_list$List$Nonempty$toList,
													$author$project$RichText$removeAttachedFile$(shouldRemove, nonempty)));
										} else {
											return _List_Nil;
										}
									},
									items)));
					default:
						return $elm$core$Maybe$Just(richText);
				}
			},
			$mgold$elm_nonempty_list$List$Nonempty$toList(list)));
};
var $author$project$RichText$removeAttachedFile = F2($author$project$RichText$removeAttachedFile$);
var $elmcraft$core_extra$String$Extra$replaceSlice$ = function (substitution, start, end, string) {
	return _Utils_ap(
		A3($elm$core$String$slice, 0, start, string),
		_Utils_ap(
			substitution,
			A3(
				$elm$core$String$slice,
				end,
				$elm$core$String$length(string),
				string)));
};
var $elmcraft$core_extra$String$Extra$replaceSlice = F4($elmcraft$core_extra$String$Extra$replaceSlice$);
var $author$project$RichText$stringToStickersAndCustomEmojis = function (text) {
	var stickers2 = $elm$core$List$foldl$(
		F2(
			function (index, shouldRemove) {
				var _v3 = $author$project$RichText$parseStickerId$(index + 1, text);
				var endIndex = _v3.a;
				var stickerId = _v3.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						{end: endIndex, start: index},
						$elm$core$Maybe$map$(
							function (_v4) {
								return 0;
							},
							stickerId)),
					shouldRemove);
			}),
		_List_Nil,
		_Utils_ap(
			A2($elm$core$String$indexes, '\u000A\u200B', text),
			_Utils_ap(
				A2($elm$core$String$indexes, '\u000A\u200C', text),
				_Utils_ap(
					A2($elm$core$String$indexes, '\u000A\u200D', text),
					A2($elm$core$String$indexes, '\u000A\u2060', text)))));
	var customEmojis2 = $elm$core$List$foldl$(
		F2(
			function (index, shouldRemove) {
				var _v1 = $author$project$RichText$parseCustomEmojiId$(index + 1, text);
				var endIndex = _v1.a;
				var customEmojiId = _v1.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						{end: endIndex, start: index},
						$elm$core$Maybe$map$(
							function (_v2) {
								return 0;
							},
							customEmojiId)),
					shouldRemove);
			}),
		_List_Nil,
		_Utils_ap(
			A2($elm$core$String$indexes, '❓\u200B', text),
			_Utils_ap(
				A2($elm$core$String$indexes, '❓\u200C', text),
				_Utils_ap(
					A2($elm$core$String$indexes, '❓\u200D', text),
					A2($elm$core$String$indexes, '❓\u2060', text)))));
	return A2(
		$elm$core$List$sortBy,
		function (_v0) {
			var range = _v0.a;
			return -range.start;
		},
		_Utils_ap(stickers2, customEmojis2));
};
var $author$project$Frontend$removePartialStickers$ = function (textInputFocus, htmlId, text) {
	var _v0 = $elm$core$List$filterMap$(
		function (_v1) {
			var range = _v1.a;
			var maybeStickerId = _v1.b;
			if (!maybeStickerId.$) {
				return $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Just(range);
			}
		},
		$author$project$RichText$stringToStickersAndCustomEmojis(text));
	if (!_v0.b) {
		return $lamdera$program_test$Effect$Command$none;
	} else {
		var list = _v0;
		var text2 = $elm$core$List$foldl$(
			F2(
				function (range, text3) {
					return $elmcraft$core_extra$String$Extra$replaceSlice$('', range.start, range.end, text3);
				}),
			text,
			list);
		return $author$project$Ports$execCommand(
			{
				commands: _Utils_ap(
					_List_fromArray(
						[
							$author$project$Ports$Undo,
							$author$project$Ports$InsertText$(
							text2,
							{end: 999999, start: 0})
						]),
					function () {
						if (!textInputFocus.$) {
							var textInputFocus2 = textInputFocus.a;
							if (_Utils_eq(textInputFocus2.htmlId, htmlId)) {
								var selection2 = $elm$core$List$foldl$(
									F2(
										function (range, selection) {
											return (_Utils_cmp(range.end, selection.start) < 0) ? {
												end: (selection.end - $author$project$Range$rangeSize(range)) - 1,
												start: (selection.start - $author$project$Range$rangeSize(range)) - 1
											} : ((_Utils_cmp(range.start, selection.start) < 0) ? {end: (selection.end - (range.start - selection.start)) - 1, start: (selection.start - (range.start - selection.start)) - 1} : selection);
										}),
									textInputFocus2.selection,
									list);
								return _List_fromArray(
									[
										$author$project$Ports$SelectRange$(selection2, textInputFocus2.direction)
									]);
							} else {
								return _List_Nil;
							}
						} else {
							return _List_Nil;
						}
					}()),
				htmlId: htmlId
			});
	}
};
var $author$project$Frontend$removePartialStickers = F3($author$project$Frontend$removePartialStickers$);
var $author$project$Frontend$repliedToMessage$ = function (guildOrDmIdWithThread, loggedIn) {
	return $elm$core$Maybe$andThen$(
		$author$project$Message$replyToMaybe,
		$lamdera$containers$SeqDict$get$(guildOrDmIdWithThread, loggedIn.replyTo));
};
var $author$project$Frontend$repliedToMessage = F2($author$project$Frontend$repliedToMessage$);
var $author$project$Ports$request_device_pixel_ratio_to_js = _Platform_outgoingPort('request_device_pixel_ratio_to_js', $elm$core$Basics$identity);
var $author$project$Ports$requestDevicePixelRatio = A3($lamdera$program_test$Effect$Command$sendToJs, 'request_device_pixel_ratio_to_js', $author$project$Ports$request_device_pixel_ratio_to_js, $elm$json$Json$Encode$null);
var $author$project$Ports$request_notification_permission = _Platform_outgoingPort('request_notification_permission', $elm$core$Basics$identity);
var $author$project$Ports$requestNotificationPermission = A3($lamdera$program_test$Effect$Command$sendToJs, 'request_notification_permission', $author$project$Ports$request_notification_permission, $elm$json$Json$Encode$null);
var $author$project$Route$requiresLogin = function (route) {
	switch (route.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return true;
		case 9:
			return false;
		case 3:
			return true;
		case 4:
			return true;
		case 5:
			return true;
		case 10:
			return false;
		case 11:
			return false;
		case 6:
			return true;
		case 7:
			return true;
		case 8:
			return true;
		case 12:
			return false;
		default:
			return false;
	}
};
var $author$project$Drawing$resetAnchor = function (_v0) {
	return $author$project$Drawing$NoSelectedAnchor;
};
var $author$project$SearchOverlay$resultsContainerId = $lamdera$program_test$Effect$Browser$Dom$id('searchOverlay_results');
var $author$project$SearchOverlay$rowHeight = function (isMobile) {
	return isMobile ? 50 : 30;
};
var $author$project$Route$sameChannelHeaderTab$ = function (tabA, tabB) {
	switch (tabA.$) {
		case 0:
			return _Utils_eq(tabB, $author$project$UserSession$ChannelHeaderTab_VoiceChat);
		case 1:
			if (tabB.$ === 1) {
				return true;
			} else {
				return false;
			}
		case 2:
			return _Utils_eq(tabB, $author$project$UserSession$ChannelHeaderTab_ChannelDescription);
		default:
			return _Utils_eq(tabB, $author$project$UserSession$ChannelHeaderTab_Draw);
	}
};
var $author$project$Route$sameChannelHeaderTab = F2($author$project$Route$sameChannelHeaderTab$);
var $author$project$Emoji$scrollContainerId = $lamdera$program_test$Effect$Browser$Dom$id('emoji_scroll_container');
var $author$project$Emoji$emojiButtonId = function (index) {
	return $lamdera$program_test$Effect$Browser$Dom$id(
		'guild_emojiSelector_' + $elm$core$String$fromInt(index));
};
var $author$project$Frontend$scrollEmojiIntoView = function (index) {
	return $lamdera$program_test$Effect$Task$attempt$(
		function (_v1) {
			return $author$project$Types$FrontendNoOp;
		},
		A2(
			$lamdera$program_test$Effect$Task$andThen,
			function (_v0) {
				var button = _v0.a;
				var container = _v0.b;
				var viewport = _v0.c.viewport;
				var buttonTop = (button.element.y - container.element.y) + viewport.y;
				var buttonBottom = buttonTop + button.element.height;
				return (_Utils_cmp(buttonTop, viewport.y) < 0) ? $lamdera$program_test$Effect$Browser$Dom$setViewportOf$($author$project$Emoji$scrollContainerId, viewport.x, buttonTop) : ((_Utils_cmp(buttonBottom, viewport.y + viewport.height) > 0) ? $lamdera$program_test$Effect$Browser$Dom$setViewportOf$($author$project$Emoji$scrollContainerId, viewport.x, buttonBottom - viewport.height) : $lamdera$program_test$Effect$Task$succeed(0));
			},
			$lamdera$program_test$Effect$Task$map3$(
				F3(
					function (button, container, viewport) {
						return _Utils_Tuple3(button, container, viewport);
					}),
				$lamdera$program_test$Effect$Browser$Dom$getElement(
					$author$project$Emoji$emojiButtonId(index)),
				$lamdera$program_test$Effect$Browser$Dom$getElement($author$project$Emoji$scrollContainerId),
				$lamdera$program_test$Effect$Browser$Dom$getViewportOf($author$project$Emoji$scrollContainerId))));
};
var $author$project$SearchOverlay$DiscordUserIcon$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$SearchOverlay$DiscordUserIcon = F2($author$project$SearchOverlay$DiscordUserIcon$);
var $author$project$SearchOverlay$FromDiscord = 1;
var $author$project$LinkedAndOtherDiscordUsers$getOtherUser$ = function (userId, _v0) {
	var otherUsers2 = _v0.a;
	return $lamdera$containers$SeqDict$get$(userId, otherUsers2);
};
var $author$project$LinkedAndOtherDiscordUsers$getOtherUser = F2($author$project$LinkedAndOtherDiscordUsers$getOtherUser$);
var $author$project$User$getDiscordUser$ = function (userId, localUser) {
	var _v0 = $author$project$LinkedAndOtherDiscordUsers$getLinkedUser$(userId, localUser.discordUsers);
	if (!_v0.$) {
		var user = _v0.a;
		return $elm$core$Maybe$Just(
			$author$project$LinkedAndOtherDiscordUsers$discordCurrentUserToFrontend(user));
	} else {
		return $author$project$LinkedAndOtherDiscordUsers$getOtherUser$(userId, localUser.discordUsers);
	}
};
var $author$project$User$getDiscordUser = F2($author$project$User$getDiscordUser$);
var $author$project$Message$createdAt = function (message) {
	switch (message.$) {
		case 0:
			var data = message.a;
			return data.createdAt;
		case 1:
			var data = message.a;
			return data.createdAt;
		case 2:
			var time = message.a;
			return time;
		case 3:
			var time = message.a;
			return time;
		case 4:
			var callStarted = message.a;
			return callStarted.startedAt;
		default:
			var gameStarted = message.a;
			return gameStarted.startedAt;
	}
};
var $author$project$MessageArray$last = function (_v0) {
	var array = _v0;
	return $author$project$MessageArray$get$(
		$author$project$Id$fromInt(array.end - 1),
		array);
};
var $author$project$SearchOverlay$lastActivity = function (channel) {
	var _v0 = $author$project$MessageArray$last(channel.messages);
	if (!_v0.$) {
		var message = _v0.a;
		return $elm$time$Time$posixToMillis(
			$author$project$Message$createdAt(message));
	} else {
		return 0;
	}
};
var $author$project$SearchOverlay$discordDmResult$ = function (local, channelId, dmChannel) {
	var _v0 = $author$project$GuildColumn$discordDmCurrentUserId$(local.localUser, dmChannel);
	if (!_v0.$) {
		var currentUserId = _v0.a;
		var otherMembers = $lamdera$containers$SeqDict$keys(
			$author$project$NonemptyDict$remove$(currentUserId, dmChannel.members));
		var members = $elm$core$List$filterMap$(
			function (userId) {
				return $elm$core$Maybe$map$(
					$elm$core$Tuple$pair(userId),
					$author$project$User$getDiscordUser$(userId, local.localUser));
			},
			function () {
				if (!otherMembers.b) {
					return _List_fromArray(
						[currentUserId]);
				} else {
					return otherMembers;
				}
			}());
		return $elm$core$Maybe$Just(
			{
				icon: function () {
					if (members.b) {
						var _v2 = members.a;
						var userId = _v2.a;
						var user = _v2.b;
						return $author$project$SearchOverlay$DiscordUserIcon$(userId, user.icon);
					} else {
						return $author$project$SearchOverlay$DiscordUserIcon$(currentUserId, $elm$core$Maybe$Nothing);
					}
				}(),
				lastActivity: $author$project$SearchOverlay$lastActivity(dmChannel),
				location: $elm$core$Maybe$Nothing,
				name: $elm$core$String$join$(
					', ',
					$elm$core$List$map$(
						function (_v3) {
							var user = _v3.b;
							return $author$project$PersonName$toString(user.name);
						},
						members)),
				route: $author$project$Route$DiscordDmRoute(
					{channelId: channelId, channelsVisible: 0, currentDiscordUserId: currentUserId, overlay: $elm$core$Maybe$Nothing, showMembersTab: 1, tab: $elm$core$Maybe$Nothing, viewingMessage: $elm$core$Maybe$Nothing}),
				source: 1
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$SearchOverlay$discordDmResult = F3($author$project$SearchOverlay$discordDmResult$);
var $author$project$SearchOverlay$ChannelIcon = {$: 0};
var $author$project$SearchOverlay$mentionName$ = function (channelId, threadId, channelMentions) {
	var _v0 = $lamdera$containers$SeqDict$get$(
		_Utils_Tuple2(
			channelId,
			$elm$core$Maybe$Just(threadId)),
		channelMentions);
	if (!_v0.$) {
		var mention = _v0.a;
		return mention.name;
	} else {
		return '<missing>';
	}
};
var $author$project$SearchOverlay$mentionName = F3($author$project$SearchOverlay$mentionName$);
var $author$project$GuildName$toString = function (_v0) {
	var a = _v0;
	return $MartinSStewart$elm_nonempty_string$String$Nonempty$toString(a);
};
var $author$project$SearchOverlay$discordGuildResults$ = function (local, guildId, guild) {
	var _v0 = $author$project$GuildColumn$discordGuildCurrentUserId$(local.localUser, guild);
	if (!_v0.$) {
		var currentUserId = _v0.a;
		var guildName = $author$project$GuildName$toString(guild.name);
		var channelMentions = $author$project$LocalState$discordGuildChannelMentions$(local.localUser, guild.channels);
		return $lamdera$containers$SeqDict$foldl$(
			F3(
				function (channelId, channel, list) {
					var route = function (threadRoute) {
						return $author$project$Route$DiscordGuildRoute(
							{
								channelRoute: $author$project$Route$DiscordChannel_ChannelRoute$(channelId, threadRoute, $elm$core$Maybe$Nothing),
								channelsVisible: 0,
								currentDiscordUserId: currentUserId,
								guildId: guildId,
								overlay: $elm$core$Maybe$Nothing
							});
					};
					return A2(
						$elm$core$List$cons,
						{
							icon: $author$project$SearchOverlay$ChannelIcon,
							lastActivity: $author$project$SearchOverlay$lastActivity(channel),
							location: $elm$core$Maybe$Just(guildName),
							name: $author$project$ChannelName$toString(channel.name),
							route: route(
								$author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1)),
							source: 1
						},
						$lamdera$containers$SeqDict$foldl$(
							F3(
								function (threadId, thread, list2) {
									return A2(
										$elm$core$List$cons,
										{
											icon: $author$project$SearchOverlay$ChannelIcon,
											lastActivity: $author$project$SearchOverlay$lastActivity(thread),
											location: $elm$core$Maybe$Just(guildName),
											name: $author$project$SearchOverlay$mentionName$(channelId, threadId, channelMentions),
											route: route(
												$author$project$Route$ViewThreadWithFriends$(threadId, $elm$core$Maybe$Nothing, 1)),
											source: 1
										},
										list2);
								}),
							list,
							channel.threads));
				}),
			_List_Nil,
			guild.channels);
	} else {
		return _List_Nil;
	}
};
var $author$project$SearchOverlay$discordGuildResults = F3($author$project$SearchOverlay$discordGuildResults$);
var $author$project$SearchOverlay$FromAtChat = 0;
var $author$project$SearchOverlay$UserIcon = function (a) {
	return {$: 1, a: a};
};
var $author$project$User$backendToFrontend = function (user) {
	return {color: user.color, icon: user.icon, name: user.name, publicKey: user.publicKey};
};
var $author$project$User$getUser$ = function (userId, localUser) {
	return _Utils_eq(localUser.session.userId, userId) ? $elm$core$Maybe$Just(
		$author$project$User$backendToFrontend(localUser.user)) : $lamdera$containers$SeqDict$get$(userId, localUser.otherUsers);
};
var $author$project$User$getUser = F2($author$project$User$getUser$);
var $author$project$User$toStringAlt$ = function (userId, local) {
	if (_Utils_eq(local.session.userId, userId)) {
		return $author$project$PersonName$toString(local.user.name);
	} else {
		var _v0 = $lamdera$containers$SeqDict$get$(userId, local.otherUsers);
		if (!_v0.$) {
			var user = _v0.a;
			return $author$project$PersonName$toString(user.name);
		} else {
			return $author$project$User$missingName;
		}
	}
};
var $author$project$User$toStringAlt = F2($author$project$User$toStringAlt$);
var $author$project$SearchOverlay$dmResults$ = function (local, otherUserId, dmChannel) {
	var route = function (threadRoute) {
		return $author$project$Route$DmRoute(
			{
				channelId: $author$project$DmChannelId$fromUserIds$(local.localUser.session.userId, otherUserId),
				channelsVisible: 0,
				overlay: $elm$core$Maybe$Nothing,
				tab: $elm$core$Maybe$Nothing,
				threadRoute: threadRoute
			});
	};
	var otherUserName = $author$project$User$toStringAlt$(otherUserId, local.localUser);
	return A2(
		$elm$core$List$cons,
		{
			icon: $author$project$SearchOverlay$UserIcon(
				$author$project$User$getUser$(otherUserId, local.localUser)),
			lastActivity: $author$project$SearchOverlay$lastActivity(dmChannel),
			location: $elm$core$Maybe$Nothing,
			name: otherUserName,
			route: route(
				$author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1)),
			source: 0
		},
		$lamdera$containers$SeqDict$foldl$(
			F3(
				function (threadId, thread, list) {
					return A2(
						$elm$core$List$cons,
						{
							icon: $author$project$SearchOverlay$UserIcon(
								$author$project$User$getUser$(otherUserId, local.localUser)),
							lastActivity: $author$project$SearchOverlay$lastActivity(thread),
							location: $elm$core$Maybe$Nothing,
							name: otherUserName + ('/' + function () {
								var _v0 = $author$project$MessageArray$get$(threadId, dmChannel.messages);
								if (!_v0.$) {
									var message = _v0.a;
									return $elm$core$String$left$(
										50,
										$author$project$LocalState$messageToString$(
											local.localUser.timezone,
											$author$project$User$allUsers(local.localUser),
											$lamdera$containers$SeqDict$empty,
											local.localUser.decryptedMessages,
											message));
								} else {
									return '<missing>';
								}
							}()),
							route: route(
								$author$project$Route$ViewThreadWithFriends$(threadId, $elm$core$Maybe$Nothing, 1)),
							source: 0
						},
						list);
				}),
			_List_Nil,
			dmChannel.threads));
};
var $author$project$SearchOverlay$dmResults = F3($author$project$SearchOverlay$dmResults$);
var $author$project$SearchOverlay$guildResults$ = function (local, guildId, guild) {
	var guildName = $author$project$GuildName$toString(guild.name);
	var channelMentions = $author$project$LocalState$guildChannelMentions$(local.localUser, guild.channels);
	return $lamdera$containers$SeqDict$foldl$(
		F3(
			function (channelId, channel, list) {
				var route = function (threadRoute) {
					return $author$project$Route$GuildRoute$(
						guildId,
						$author$project$Route$ChannelRoute$(channelId, threadRoute, $elm$core$Maybe$Nothing),
						0,
						$elm$core$Maybe$Nothing);
				};
				return A2(
					$elm$core$List$cons,
					{
						icon: $author$project$SearchOverlay$ChannelIcon,
						lastActivity: $author$project$SearchOverlay$lastActivity(channel),
						location: $elm$core$Maybe$Just(guildName),
						name: $author$project$ChannelName$toString(channel.name),
						route: route(
							$author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1)),
						source: 0
					},
					$lamdera$containers$SeqDict$foldl$(
						F3(
							function (threadId, thread, list2) {
								return A2(
									$elm$core$List$cons,
									{
										icon: $author$project$SearchOverlay$ChannelIcon,
										lastActivity: $author$project$SearchOverlay$lastActivity(thread),
										location: $elm$core$Maybe$Just(guildName),
										name: $author$project$SearchOverlay$mentionName$(channelId, threadId, channelMentions),
										route: route(
											$author$project$Route$ViewThreadWithFriends$(threadId, $elm$core$Maybe$Nothing, 1)),
										source: 0
									},
									list2);
							}),
						list,
						channel.threads));
			}),
		_List_Nil,
		guild.channels);
};
var $author$project$SearchOverlay$guildResults = F3($author$project$SearchOverlay$guildResults$);
var $author$project$SearchOverlay$FromSlack = 2;
var $author$project$SearchOverlay$SlackUserIcon = function (a) {
	return {$: 3, a: a};
};
var $author$project$SearchOverlay$slackDmResults$ = function (local, channelId, dmChannel) {
	var _v0 = $author$project$GuildColumn$slackDmCurrentUserId$(local.localUser, dmChannel);
	if (!_v0.$) {
		var currentUserId = _v0.a;
		var route = function (threadRoute) {
			return $author$project$Route$SlackDmRoute(
				{channelId: channelId, channelsVisible: 0, currentSlackUserId: currentUserId, overlay: $elm$core$Maybe$Nothing, threadRoute: threadRoute});
		};
		var otherMembers = function () {
			var _v3 = $elm$core$List$filter$(
				function (userId) {
					return !_Utils_eq(userId, currentUserId);
				},
				$author$project$NonemptySet$toList(dmChannel.members));
			if (!_v3.b) {
				return _List_fromArray(
					[currentUserId]);
			} else {
				var otherMembers2 = _v3;
				return otherMembers2;
			}
		}();
		var icon = function () {
			if (otherMembers.b) {
				var userId = otherMembers.a;
				return $author$project$SearchOverlay$SlackUserIcon(
					$lamdera$containers$SeqDict$get$(userId, local.localUser.slackUsers));
			} else {
				return $author$project$SearchOverlay$SlackUserIcon($elm$core$Maybe$Nothing);
			}
		}();
		var dmName = $elm$core$String$join$(
			', ',
			$elm$core$List$map$(
				function (userId) {
					return $author$project$User$toString$(userId, local.localUser.slackUsers);
				},
				otherMembers));
		return A2(
			$elm$core$List$cons,
			{
				icon: icon,
				lastActivity: $author$project$SearchOverlay$lastActivity(dmChannel),
				location: $elm$core$Maybe$Nothing,
				name: dmName,
				route: route(
					$author$project$Id$NoThreadWithMaybeMessage($elm$core$Maybe$Nothing)),
				source: 2
			},
			$lamdera$containers$SeqDict$foldl$(
				F3(
					function (threadId, thread, list) {
						return A2(
							$elm$core$List$cons,
							{
								icon: icon,
								lastActivity: $author$project$SearchOverlay$lastActivity(thread),
								location: $elm$core$Maybe$Nothing,
								name: dmName + ('/' + function () {
									var _v1 = $author$project$MessageArray$get$(threadId, dmChannel.messages);
									if (!_v1.$) {
										var message = _v1.a;
										return $elm$core$String$left$(
											50,
											$author$project$LocalState$messageToString$(local.localUser.timezone, local.localUser.slackUsers, $lamdera$containers$SeqDict$empty, $lamdera$containers$SeqDict$empty, message));
									} else {
										return '<missing>';
									}
								}()),
								route: route(
									$author$project$Id$ViewThreadWithMaybeMessage$(threadId, $elm$core$Maybe$Nothing)),
								source: 2
							},
							list);
					}),
				_List_Nil,
				dmChannel.threads));
	} else {
		return _List_Nil;
	}
};
var $author$project$SearchOverlay$slackDmResults = F3($author$project$SearchOverlay$slackDmResults$);
var $author$project$LocalState$slackThreadMentionName$ = function (threadId, channel, localUser) {
	return $author$project$LocalState$threadName$(
		channel.name,
		function () {
			var _v0 = $author$project$MessageArray$get$(threadId, channel.messages);
			if (!_v0.$) {
				var message = _v0.a;
				return $author$project$LocalState$messageToString$(localUser.timezone, localUser.slackUsers, $lamdera$containers$SeqDict$empty, $lamdera$containers$SeqDict$empty, message);
			} else {
				return '<missing>';
			}
		}());
};
var $author$project$LocalState$slackThreadMentionName = F3($author$project$LocalState$slackThreadMentionName$);
var $author$project$SearchOverlay$slackWorkspaceResults$ = function (local, teamId, workspace) {
	var _v0 = $author$project$GuildColumn$slackWorkspaceCurrentUserId$(local.localUser, teamId);
	if (!_v0.$) {
		var currentUserId = _v0.a;
		return $lamdera$containers$SeqDict$foldl$(
			F3(
				function (channelId, channel, list) {
					var route = function (threadRoute) {
						return $author$project$Route$SlackWorkspaceRoute(
							{
								channelRoute: $author$project$Route$SlackChannel_ChannelRoute$(channelId, threadRoute, 1),
								channelsVisible: 0,
								currentSlackUserId: currentUserId,
								overlay: $elm$core$Maybe$Nothing,
								teamId: teamId
							});
					};
					return A2(
						$elm$core$List$cons,
						{
							icon: $author$project$SearchOverlay$ChannelIcon,
							lastActivity: $author$project$SearchOverlay$lastActivity(channel),
							location: $elm$core$Maybe$Just(workspace.name),
							name: $author$project$ChannelName$toString(channel.name),
							route: route(
								$author$project$Id$NoThreadWithMaybeMessage($elm$core$Maybe$Nothing)),
							source: 2
						},
						$lamdera$containers$SeqDict$foldl$(
							F3(
								function (threadId, thread, list2) {
									return A2(
										$elm$core$List$cons,
										{
											icon: $author$project$SearchOverlay$ChannelIcon,
											lastActivity: $author$project$SearchOverlay$lastActivity(thread),
											location: $elm$core$Maybe$Just(workspace.name),
											name: $author$project$LocalState$slackThreadMentionName$(threadId, channel, local.localUser),
											route: route(
												$author$project$Id$ViewThreadWithMaybeMessage$(threadId, $elm$core$Maybe$Nothing)),
											source: 2
										},
										list2);
								}),
							list,
							channel.threads));
				}),
			_List_Nil,
			workspace.channels);
	} else {
		return _List_Nil;
	}
};
var $author$project$SearchOverlay$slackWorkspaceResults = F3($author$project$SearchOverlay$slackWorkspaceResults$);
var $author$project$SearchOverlay$allResults = function (local) {
	return _Utils_ap(
		$lamdera$containers$SeqDict$foldl$(
			F3(
				function (guildId, guild, list) {
					return _Utils_ap(
						$author$project$SearchOverlay$guildResults$(local, guildId, guild),
						list);
				}),
			_List_Nil,
			local.guilds),
		_Utils_ap(
			$lamdera$containers$SeqDict$foldl$(
				F3(
					function (guildId, guild, list) {
						return _Utils_ap(
							$author$project$SearchOverlay$discordGuildResults$(local, guildId, guild),
							list);
					}),
				_List_Nil,
				local.discordGuilds),
			_Utils_ap(
				$lamdera$containers$SeqDict$foldl$(
					F3(
						function (otherUserId, dmChannel, list) {
							return _Utils_ap(
								$author$project$SearchOverlay$dmResults$(local, otherUserId, dmChannel),
								list);
						}),
					_List_Nil,
					local.dmChannels),
				_Utils_ap(
					$lamdera$containers$SeqDict$foldl$(
						F3(
							function (channelId, dmChannel, list) {
								var _v0 = $author$project$SearchOverlay$discordDmResult$(local, channelId, dmChannel);
								if (!_v0.$) {
									var result = _v0.a;
									return A2($elm$core$List$cons, result, list);
								} else {
									return list;
								}
							}),
						_List_Nil,
						local.discordDmChannels),
					_Utils_ap(
						$lamdera$containers$SeqDict$foldl$(
							F3(
								function (teamId, workspace, list) {
									return _Utils_ap(
										$author$project$SearchOverlay$slackWorkspaceResults$(local, teamId, workspace),
										list);
								}),
							_List_Nil,
							local.slackWorkspaces),
						$lamdera$containers$SeqDict$foldl$(
							F3(
								function (channelId, dmChannel, list) {
									return _Utils_ap(
										$author$project$SearchOverlay$slackDmResults$(local, channelId, dmChannel),
										list);
								}),
							_List_Nil,
							local.slackDmChannels))))));
};
var $elm$core$String$map = _String_map;
var $author$project$SearchOverlay$maxResults = 50;
var $author$project$SearchOverlay$search$ = function (query, local) {
	var queryWords = $elm$core$String$words(
		$elm$core$String$toLower(
			$elm$core$String$replace$('#', ' ', query)));
	return $elm$core$List$map$(
		$elm$core$Tuple$second,
		$elm$core$List$take$(
			$author$project$SearchOverlay$maxResults,
			A2(
				$elm$core$List$sortBy,
				$elm$core$Tuple$first,
				$elm$core$List$filterMap$(
					function (result) {
						var searchText = $elm$core$String$toLower(
							function () {
								var _v1 = result.location;
								if (!_v1.$) {
									var location = _v1.a;
									return result.name + (' ' + location);
								} else {
									return result.name;
								}
							}());
						var searchTextWords = $elm$core$String$words(
							A2(
								$elm$core$String$map,
								function (_char) {
									return $elm$core$Char$isAlphaNum(_char) ? _char : ' ';
								},
								searchText));
						var nameLength = function () {
							if (!queryWords.b) {
								return 0;
							} else {
								return $elm$core$String$length(result.name);
							}
						}();
						return $elm$core$List$all$(
							function (word) {
								return A2($elm$core$String$contains, word, searchText);
							},
							queryWords) ? $elm$core$Maybe$Just(
							_Utils_Tuple2(
								_Utils_Tuple3(
									A2(
										$elmcraft$core_extra$List$Extra$count,
										function (word) {
											return !$elm$core$List$any$(
												$elm$core$String$startsWith(word),
												searchTextWords);
										},
										queryWords),
									nameLength,
									-result.lastActivity),
								result)) : $elm$core$Maybe$Nothing;
					},
					$author$project$SearchOverlay$allResults(local)))));
};
var $author$project$SearchOverlay$search = F2($author$project$SearchOverlay$search$);
var $author$project$Drawing$SelectedAnchor = function (a) {
	return {$: 1, a: a};
};
var $author$project$Drawing$initialAnchorSelection$ = function (guildOrDmId, anchorType, position, anchorHalfSize, pointScale) {
	return {anchorHalfSize: anchorHalfSize, anchorType: anchorType, guildOrDmId: guildOrDmId, pointScale: pointScale, position: position, stroke: $elm$core$Maybe$Nothing, zoom: 1, zoomContainer: $elm$core$Maybe$Nothing};
};
var $author$project$Drawing$initialAnchorSelection = F5($author$project$Drawing$initialAnchorSelection$);
var $author$project$Frontend$selectDrawingAnchor$ = function (guildOrDmId, anchorType, elementPosition, anchorHalfSize, pointScale, model) {
	return $author$project$FrontendExtra$updateLoggedIn$(
		function (loggedIn) {
			return _Utils_Tuple2(
				_Utils_update(
					loggedIn,
					{
						drawingMode: $author$project$Drawing$SelectedAnchor(
							$author$project$Drawing$initialAnchorSelection$(guildOrDmId, anchorType, elementPosition, anchorHalfSize, pointScale))
					}),
				$lamdera$program_test$Effect$Command$none);
		},
		model);
};
var $author$project$Frontend$selectDrawingAnchor = F6($author$project$Frontend$selectDrawingAnchor$);
var $author$project$Types$GotPingUserPosition$ = function (a, b) {
	return {$: 38, a: a, b: b};
};
var $author$project$Types$GotPingUserPosition = F2($author$project$Types$GotPingUserPosition$);
var $author$project$Range$inside$ = function (index, range) {
	return (_Utils_cmp(index, range.start) > 0) && (_Utils_cmp(index, range.end) < 0);
};
var $author$project$Range$inside = F2($author$project$Range$inside$);
var $author$project$Frontend$adjustSelection$ = function (selectionOld, selection, text) {
	var selectionOld2 = $elm$core$Maybe$withDefault$(
		{end: 0, start: 0},
		selectionOld);
	return $elmcraft$core_extra$List$Extra$findMap$(
		function (_v0) {
			var stickerRange = _v0.a;
			var maybeStickerId = _v0.b;
			if (!maybeStickerId.$) {
				return _Utils_eq(selection.start, selection.end) ? ($author$project$Range$inside$(selection.start, stickerRange) ? ((_Utils_cmp(selection.start, selectionOld2.start) < 0) ? $elm$core$Maybe$Just(
					{end: stickerRange.start, start: stickerRange.start}) : $elm$core$Maybe$Just(
					{end: stickerRange.end, start: stickerRange.end})) : $elm$core$Maybe$Nothing) : ($author$project$Range$inside$(selection.start, stickerRange) ? $elm$core$Maybe$Just(
					{end: selection.end, start: stickerRange.start}) : ($author$project$Range$inside$(selection.end, stickerRange) ? $elm$core$Maybe$Just(
					{end: stickerRange.end, start: selection.start}) : $elm$core$Maybe$Nothing));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		$author$project$RichText$stringToStickersAndCustomEmojis(text));
};
var $author$project$Frontend$adjustSelection = F3($author$project$Frontend$adjustSelection$);
var $author$project$Frontend$selectionChanged$ = function (maybeHtmlId, maybeRange, model) {
	var _v0 = _Utils_Tuple2(maybeHtmlId, maybeRange);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var htmlId = _v0.a.a;
		var _v1 = _v0.b.a;
		var range = _v1.a;
		var direction = _v1.b;
		var _v2 = model.loginStatus;
		if (!_v2.$) {
			var loggedIn = _v2.a;
			var local = $author$project$Local$model(loggedIn.localState);
			var showDropdown = (_Utils_eq(htmlId, $author$project$Pages$Guild$channelTextInputId) || _Utils_eq(htmlId, $author$project$MessageMenu$editMessageTextInputId)) && function () {
				var _v10 = $author$project$Route$toGuildOrDmId$(local.localUser.session.userId, model.route);
				if (!_v10.$) {
					var _v11 = _v10.a;
					var guildOrDmId = _v11.a;
					var threadRoute = _v11.b;
					var _v12 = $author$project$FrontendExtra$pingUserNameSoFar$(htmlId, range, guildOrDmId, threadRoute, loggedIn);
					if (!_v12.$) {
						switch (_v12.a.$) {
							case 0:
								var nameSoFar = _v12.a.a;
								switch (guildOrDmId.$) {
									case 0:
										var guildOrDmId2 = guildOrDmId.a;
										return !$elm$core$List$isEmpty(
											$author$project$MessageDropdown$userDropdownList$(
												$author$project$MyUi$isMobile(model),
												nameSoFar,
												guildOrDmId2,
												local));
									case 1:
										var guildOrDmId2 = guildOrDmId.a;
										return !$elm$core$List$isEmpty(
											$author$project$MessageDropdown$discordUserDropdownList$(
												$author$project$MyUi$isMobile(model),
												nameSoFar,
												guildOrDmId2,
												local));
									default:
										var guildOrDmId2 = guildOrDmId.a;
										return !$elm$core$List$isEmpty(
											$author$project$MessageDropdown$slackUserDropdownList$(
												$author$project$MyUi$isMobile(model),
												nameSoFar,
												guildOrDmId2,
												local));
								}
							case 1:
								var emojiSoFar = _v12.a.a;
								var _v14 = model.emojiData;
								if (!_v14.$) {
									var emojiData2 = _v14.a;
									var _v15 = $author$project$MessageMenu$availableCustomEmojisAndStickers$(guildOrDmId, local);
									var availableCustomEmojis = _v15.a;
									var availableStickers = _v15.b;
									return !$elm$core$List$isEmpty(
										$author$project$MessageDropdown$emojiDropdownList$(
											$author$project$MyUi$isMobile(model),
											emojiSoFar,
											availableCustomEmojis,
											availableStickers,
											local.localUser,
											emojiData2));
								} else {
									return false;
								}
							case 2:
								var channelSoFar = _v12.a.a;
								return !$elm$core$List$isEmpty(
									$author$project$MessageDropdown$channelDropdownList$(
										$author$project$MyUi$isMobile(model),
										channelSoFar,
										guildOrDmId,
										local));
							default:
								var _v16 = _v12.a;
								return true;
						}
					} else {
						return false;
					}
				} else {
					return false;
				}
			}();
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						loginStatus: $author$project$Types$LoggedIn(
							_Utils_update(
								loggedIn,
								{
									drawingMode: $author$project$Drawing$NoSelectedAnchor,
									previousTextInputFocus: loggedIn.textInputFocus,
									textInputFocus: function () {
										var _v3 = loggedIn.textInputFocus;
										if (!_v3.$) {
											var textInputFocus = _v3.a;
											return _Utils_eq(htmlId, textInputFocus.htmlId) ? $elm$core$Maybe$Just(
												_Utils_update(
													textInputFocus,
													{
														dropdown: showDropdown ? textInputFocus.dropdown : $elm$core$Maybe$Nothing,
														selection: range
													})) : $elm$core$Maybe$Just(
												{direction: direction, dropdown: $elm$core$Maybe$Nothing, htmlId: htmlId, selection: range});
										} else {
											return $elm$core$Maybe$Just(
												{direction: direction, dropdown: $elm$core$Maybe$Nothing, htmlId: htmlId, selection: range});
										}
									}()
								}))
					}),
				$lamdera$program_test$Effect$Command$batch(
					_List_fromArray(
						[
							showDropdown ? $lamdera$program_test$Effect$Task$attempt$(
							$author$project$Types$GotPingUserPosition(htmlId),
							A2(
								$lamdera$program_test$Effect$Task$map,
								function (_v4) {
									var element = _v4.element;
									return {
										dropdownIndex: 0,
										inputElement: _Utils_update(
											element,
											{y: element.y - model.startupData.safeAreaInsetTop})
									};
								},
								$lamdera$program_test$Effect$Browser$Dom$getElement(htmlId))) : $lamdera$program_test$Effect$Command$none,
							function () {
							var _v5 = $author$project$Route$toGuildOrDmId$(local.localUser.session.userId, model.route);
							if (!_v5.$) {
								var guildOrDmId = _v5.a;
								if (_Utils_eq(htmlId, $author$project$Pages$Guild$channelTextInputId)) {
									var _v6 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.drafts);
									if (!_v6.$) {
										var draft = _v6.a;
										var _v7 = $author$project$Frontend$adjustSelection$(
											$elm$core$Maybe$map$(
												function ($) {
													return $.selection;
												},
												loggedIn.textInputFocus),
											range,
											$MartinSStewart$elm_nonempty_string$String$Nonempty$toString(draft));
										if (!_v7.$) {
											var range2 = _v7.a;
											return $author$project$Ports$execCommand(
												{
													commands: _List_fromArray(
														[
															$author$project$Ports$SelectRange$(range2, direction)
														]),
													htmlId: htmlId
												});
										} else {
											return $lamdera$program_test$Effect$Command$none;
										}
									} else {
										return $lamdera$program_test$Effect$Command$none;
									}
								} else {
									if (_Utils_eq(htmlId, $author$project$MessageMenu$editMessageTextInputId)) {
										var _v8 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.editMessage);
										if (!_v8.$) {
											var edit = _v8.a;
											var _v9 = $author$project$Frontend$adjustSelection$(
												$elm$core$Maybe$map$(
													function ($) {
														return $.selection;
													},
													loggedIn.textInputFocus),
												range,
												edit.text);
											if (!_v9.$) {
												var range2 = _v9.a;
												return $author$project$Ports$execCommand(
													{
														commands: _List_fromArray(
															[
																$author$project$Ports$SelectRange$(range2, direction)
															]),
														htmlId: htmlId
													});
											} else {
												return $lamdera$program_test$Effect$Command$none;
											}
										} else {
											return $lamdera$program_test$Effect$Command$none;
										}
									} else {
										return $lamdera$program_test$Effect$Command$none;
									}
								}
							} else {
								return $lamdera$program_test$Effect$Command$none;
							}
						}()
						])));
		} else {
			var notLoggedIn = _v2.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						loginStatus: $author$project$Types$NotLoggedIn(
							_Utils_update(
								notLoggedIn,
								{
									textInputFocus: $elm$core$Maybe$Just(
										{direction: direction, htmlId: htmlId, selection: range})
								}))
					}),
				$lamdera$program_test$Effect$Command$none);
		}
	} else {
		return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
	}
};
var $author$project$Frontend$selectionChanged = F3($author$project$Frontend$selectionChanged$);
var $author$project$Frontend$sendMessageThreadRoute$ = function (guildOrDmIdWithThread, threadRoute, loggedIn) {
	if (threadRoute.$ === 1) {
		var threadId = threadRoute.a;
		return $author$project$Message$ViewThreadWithRepliedTo$(
			threadId,
			$elm$core$Maybe$map$(
				$author$project$Id$changeType,
				$author$project$Frontend$repliedToMessage$(guildOrDmIdWithThread, loggedIn)));
	} else {
		return $author$project$Message$NoThreadWithRepliedTo(
			$elm$core$Maybe$withDefault$(
				$author$project$Message$NoReply,
				$lamdera$containers$SeqDict$get$(guildOrDmIdWithThread, loggedIn.replyTo)));
	}
};
var $author$project$Frontend$sendMessageThreadRoute = F3($author$project$Frontend$sendMessageThreadRoute$);
var $author$project$Frontend$setDevicePixelRatio$ = function (devicePixelRatio, model) {
	var startupData = model.startupData;
	return _Utils_update(
		model,
		{
			loginStatus: function () {
				var _v0 = model.loginStatus;
				if (!_v0.$) {
					var loggedIn = _v0.a;
					return $author$project$Types$LoggedIn(
						_Utils_update(
							loggedIn,
							{
								localState: $author$project$Local$mapModel$(
									function (local) {
										var localUser = local.localUser;
										return _Utils_update(
											local,
											{
												localUser: _Utils_update(
													localUser,
													{devicePixelRatio: devicePixelRatio})
											});
									},
									loggedIn.localState)
							}));
				} else {
					return model.loginStatus;
				}
			}(),
			startupData: _Utils_update(
				startupData,
				{devicePixelRatio: devicePixelRatio})
		});
};
var $author$project$Frontend$setDevicePixelRatio = F2($author$project$Frontend$setDevicePixelRatio$);
var $author$project$Frontend$setEmojiData$ = function (emojiData, model) {
	return _Utils_update(
		model,
		{
			emojiData: $elm$core$Maybe$Just(emojiData),
			loginStatus: function () {
				var _v0 = model.loginStatus;
				if (!_v0.$) {
					var loggedIn = _v0.a;
					return $author$project$Types$LoggedIn(
						_Utils_update(
							loggedIn,
							{
								localState: $author$project$Local$mapModel$(
									function (local) {
										var localUser = local.localUser;
										return _Utils_update(
											local,
											{
												localUser: _Utils_update(
													localUser,
													{
														emojiData: $elm$core$Maybe$Just(emojiData)
													})
											});
									},
									loggedIn.localState)
							}));
				} else {
					return model.loginStatus;
				}
			}()
		});
};
var $author$project$Frontend$setEmojiData = F2($author$project$Frontend$setEmojiData$);
var $author$project$Pages$Guild$setImportChannelStatus$ = function (guildId, status, local, loggedIn) {
	return _Utils_update(
		loggedIn,
		{
			editGuildForm: $lamdera$containers$SeqDict$update$(
				guildId,
				function (maybeForm) {
					var _v0 = _Utils_Tuple2(
						maybeForm,
						$lamdera$containers$SeqDict$get$(guildId, local.guilds));
					if (!_v0.a.$) {
						var form = _v0.a.a;
						return $elm$core$Maybe$Just(
							_Utils_update(
								form,
								{importChannel: status}));
					} else {
						if (!_v0.b.$) {
							var _v1 = _v0.a;
							var guild = _v0.b.a;
							return $elm$core$Maybe$Just(
								{
									deleteConfirmation: '',
									importChannel: status,
									name: $author$project$GuildName$toString(guild.name),
									pressedSubmit: false,
									showDeleteConfirmation: false,
									showLeaveConfirmation: false
								});
						} else {
							var _v2 = _v0.a;
							var _v3 = _v0.b;
							return $elm$core$Maybe$Nothing;
						}
					}
				},
				loggedIn.editGuildForm)
		});
};
var $author$project$Pages$Guild$setImportChannelStatus = F4($author$project$Pages$Guild$setImportChannelStatus$);
var $author$project$Frontend$setSafeAreaInsets$ = function (insets, model) {
	var startupData = model.startupData;
	return _Utils_update(
		model,
		{
			loginStatus: function () {
				var _v0 = model.loginStatus;
				if (!_v0.$) {
					var loggedIn = _v0.a;
					return $author$project$Types$LoggedIn(
						_Utils_update(
							loggedIn,
							{
								localState: $author$project$Local$mapModel$(
									function (local) {
										var localUser = local.localUser;
										return _Utils_update(
											local,
											{
												localUser: _Utils_update(
													localUser,
													{safeAreaInsetBottom: insets.bottom, safeAreaInsetTop: insets.top})
											});
									},
									loggedIn.localState)
							}));
				} else {
					return model.loginStatus;
				}
			}(),
			startupData: _Utils_update(
				startupData,
				{safeAreaInsetBottom: insets.bottom, safeAreaInsetTop: insets.top})
		});
};
var $author$project$Frontend$setSafeAreaInsets = F2($author$project$Frontend$setSafeAreaInsets$);
var $author$project$Frontend$setScreenShareEnabled$ = function (time, screenShareEnabled, loggedIn) {
	var voiceChat = loggedIn.voiceChat;
	var remoteCallData = voiceChat.remoteCallData;
	return _Utils_eq(remoteCallData.screenShareEnabled, screenShareEnabled) ? _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none) : $author$project$FrontendExtra$handleLocalChange$(
		time,
		$elm$core$Maybe$Just(
			$author$project$Types$Local_VoiceChatChange(
				$author$project$Call$Local_SetRemoteCallData(
					_Utils_update(
						remoteCallData,
						{screenShareEnabled: screenShareEnabled})))),
		_Utils_update(
			loggedIn,
			{
				voiceChat: _Utils_update(
					voiceChat,
					{
						remoteCallData: _Utils_update(
							remoteCallData,
							{screenShareEnabled: screenShareEnabled})
					})
			}),
		$lamdera$program_test$Effect$Command$none);
};
var $author$project$Frontend$setScreenShareEnabled = F3($author$project$Frontend$setScreenShareEnabled$);
var $author$project$Frontend$setShowMembers$ = function (showMembers, model) {
	var _v0 = model.route;
	switch (_v0.$) {
		case 3:
			if (!_v0.b.$) {
				var guildId = _v0.a;
				var _v1 = _v0.b;
				var channelId = _v1.a;
				var threadRoute = _v1.b;
				var tab = _v1.c;
				var channelsVisible = _v0.c;
				var overlay = _v0.d;
				if (!threadRoute.$) {
					var a = threadRoute.a;
					return $author$project$FrontendExtra$routePush$(
						model,
						$author$project$Route$GuildRoute$(
							guildId,
							$author$project$Route$ChannelRoute$(
								channelId,
								$author$project$Route$NoThreadWithFriends$(a, showMembers),
								tab),
							channelsVisible,
							overlay));
				} else {
					var threadId = threadRoute.a;
					var a = threadRoute.b;
					return $author$project$FrontendExtra$routePush$(
						model,
						$author$project$Route$GuildRoute$(
							guildId,
							$author$project$Route$ChannelRoute$(
								channelId,
								$author$project$Route$ViewThreadWithFriends$(threadId, a, showMembers),
								tab),
							channelsVisible,
							overlay));
				}
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 5:
			var dmRoute = _v0.a;
			var _v3 = dmRoute.threadRoute;
			if (!_v3.$) {
				var a = _v3.a;
				return $author$project$FrontendExtra$routePush$(
					model,
					$author$project$Route$DmRoute(
						_Utils_update(
							dmRoute,
							{
								threadRoute: $author$project$Route$NoThreadWithFriends$(a, showMembers)
							})));
			} else {
				var threadId = _v3.a;
				var a = _v3.b;
				return $author$project$FrontendExtra$routePush$(
					model,
					$author$project$Route$DmRoute(
						_Utils_update(
							dmRoute,
							{
								threadRoute: $author$project$Route$ViewThreadWithFriends$(threadId, a, showMembers)
							})));
			}
		case 4:
			var guildRoute = _v0.a;
			var _v4 = guildRoute.channelRoute;
			if (!_v4.$) {
				var channelId = _v4.a;
				var threadRoute = _v4.b;
				var tab = _v4.c;
				return $author$project$FrontendExtra$routePush$(
					model,
					$author$project$Route$DiscordGuildRoute(
						function () {
							if (!threadRoute.$) {
								var a = threadRoute.a;
								return _Utils_update(
									guildRoute,
									{
										channelRoute: $author$project$Route$DiscordChannel_ChannelRoute$(
											channelId,
											$author$project$Route$NoThreadWithFriends$(a, showMembers),
											tab)
									});
							} else {
								var threadId = threadRoute.a;
								var a = threadRoute.b;
								return _Utils_update(
									guildRoute,
									{
										channelRoute: $author$project$Route$DiscordChannel_ChannelRoute$(
											channelId,
											$author$project$Route$ViewThreadWithFriends$(threadId, a, showMembers),
											tab)
									});
							}
						}()));
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 6:
			var dmRoute = _v0.a;
			return $author$project$FrontendExtra$routePush$(
				model,
				$author$project$Route$DiscordDmRoute(
					_Utils_update(
						dmRoute,
						{showMembersTab: showMembers})));
		case 0:
			return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
		case 1:
			return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
		case 2:
			return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
		case 9:
			return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
		case 10:
			return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
		case 11:
			return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
		case 12:
			return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
		case 13:
			return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
		case 7:
			return $author$project$FrontendExtra$routePush$(
				model,
				$author$project$Route$setShowMembers$(showMembers, model.route));
		default:
			return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
	}
};
var $author$project$Frontend$setShowMembers = F2($author$project$Frontend$setShowMembers$);
var $author$project$SheepGame$ChangedNotes$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $author$project$SheepGame$ChangedNotes = F2($author$project$SheepGame$ChangedNotes$);
var $author$project$SheepGame$SubmittedAnswer$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$SheepGame$SubmittedAnswer = F2($author$project$SheepGame$SubmittedAnswer$);
var $author$project$SheepGame$emptyQuestionError = 'Can\u0027t be empty';
var $author$project$SheepGame$validateInput$ = function (timezone, users, question) {
	var _v0 = _Utils_Tuple3(
		$MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(
			$elm$core$String$trim(question.text)),
		$MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(question.text),
		$author$project$FileStatus$hasUploadingFile(question.attachedFiles));
	if (!_v0.a.$) {
		if (!_v0.b.$) {
			if (!_v0.c) {
				var content = _v0.b.a;
				return $elm$core$Result$Ok(
					function (_v1) {
						return {
							attachedFiles: $author$project$FileStatus$onlyUploadedFiles(question.attachedFiles),
							reactions: $lamdera$containers$SeqDict$empty,
							text: $author$project$RichText$fromNonemptyString$(timezone, users, $lamdera$containers$SeqDict$empty, content)
						};
					});
			} else {
				return $elm$core$Result$Err('Attached files not finished uploading');
			}
		} else {
			var _v3 = _v0.b;
			return $elm$core$Result$Err($author$project$SheepGame$emptyQuestionError);
		}
	} else {
		var _v2 = _v0.a;
		return $elm$core$Result$Err($author$project$SheepGame$emptyQuestionError);
	}
};
var $author$project$SheepGame$validateInput = F3($author$project$SheepGame$validateInput$);
var $author$project$SheepGame$validatedDraft$ = function (localUser, questionId, drafts) {
	var _v0 = $author$project$IdArray$get$(questionId, drafts);
	if (!_v0.$) {
		var draft = _v0.a;
		return $elm$core$Maybe$map$(
			function (validated) {
				return validated(0);
			},
			$elm$core$Result$toMaybe(
				$author$project$SheepGame$validateInput$(
					localUser.timezone,
					$author$project$User$allUsers(localUser),
					draft)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$SheepGame$validatedDraft = F3($author$project$SheepGame$validatedDraft$);
var $author$project$SheepGame$saveInputAction$ = function (localUser, input, model) {
	switch (input.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var questionId = input.a;
			return $elm$core$Maybe$Just(
				$author$project$SheepGame$SubmittedAnswer$(
					questionId,
					$author$project$SheepGame$validatedDraft$(localUser, questionId, model.answerDrafts)));
		default:
			var questionId = input.a;
			return $elm$core$Maybe$Just(
				$author$project$SheepGame$ChangedNotes$(
					questionId,
					$author$project$SheepGame$validatedDraft$(localUser, questionId, model.noteDrafts)));
	}
};
var $author$project$SheepGame$saveInputAction = F3($author$project$SheepGame$saveInputAction$);
var $author$project$Game$sheepGameInputToSave$ = function (time, localUser, matchId, input, counter, model) {
	var _v0 = _Utils_Tuple2(
		_Utils_eq(
			$lamdera$containers$SeqDict$get$(
				_Utils_Tuple2(matchId, input),
				model.sheepGameSaveCounters),
			$elm$core$Maybe$Just(counter)),
		$lamdera$containers$SeqDict$get$(matchId, model.startedGames));
	if ((_v0.a && (!_v0.b.$)) && (_v0.b.a.$ === 2)) {
		var game = _v0.b.a.a;
		return $elm$core$Maybe$map$(
			function (action) {
				return $author$project$Game$LocalChange_SheepGame$(
					matchId,
					$author$project$SheepGame$Action(
						{change: action, time: time, userId: localUser.session.userId}));
			},
			$author$project$SheepGame$saveInputAction$(localUser, input, game));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Game$sheepGameInputToSave = F6($author$project$Game$sheepGameInputToSave$);
var $author$project$IdArray$map$ = function (mapFunc, _v0) {
	var array = _v0;
	return $elm$core$Array$indexedMap$(
		F2(
			function (index, value) {
				return A2(
					mapFunc,
					$author$project$Id$fromInt(index),
					value);
			}),
		array);
};
var $author$project$IdArray$map = F2($author$project$IdArray$map$);
var $author$project$SheepGame$maxQuestionLength = 200;
var $author$project$SheepGame$maxQuestions = 50;
var $author$project$IdArray$slice$ = function (start, end, _v0) {
	var array = _v0;
	return $elm$core$Array$slice$(
		$author$project$Id$toInt(start),
		$author$project$Id$toInt(end),
		array);
};
var $author$project$IdArray$slice = F3($author$project$IdArray$slice$);
var $author$project$SheepGame$clampSavedQuestions = function (questions) {
	return $author$project$IdArray$map$(
		F2(
			function (_v0, question) {
				return _Utils_update(
					question,
					{
						text: $elm$core$String$left$($author$project$SheepGame$maxQuestionLength, question.text)
					});
			}),
		$author$project$IdArray$slice$(
			$author$project$Id$fromInt(0),
			$author$project$Id$fromInt($author$project$SheepGame$maxQuestions),
			questions));
};
var $author$project$Game$sheepGameQuestionsToSave$ = function (counter, model) {
	var _v0 = _Utils_Tuple2(
		_Utils_eq(counter, model.sheepGameQuestionsCounter),
		model.setup);
	if (_v0.a && (_v0.b.$ === 3)) {
		var setup = _v0.b.a;
		return $elm$core$Maybe$Just(
			$author$project$SheepGame$clampSavedQuestions(setup.questions));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Game$sheepGameQuestionsToSave = F2($author$project$Game$sheepGameQuestionsToSave$);
var $author$project$Types$EmojiSelectorForReaction$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Types$EmojiSelectorForReaction = F2($author$project$Types$EmojiSelectorForReaction$);
var $author$project$Frontend$showReactionEmojiSelector$ = function (guildOrDmId, messageIndex, model) {
	return $author$project$FrontendExtra$updateLoggedIn$(
		function (loggedIn) {
			var emojiSelectorModel = loggedIn.emojiSelector;
			return _Utils_Tuple2(
				$author$project$MessageMenu$close$(
					model,
					_Utils_update(
						loggedIn,
						{
							emojiSelector: _Utils_update(
								emojiSelectorModel,
								{category: $author$project$Emoji$selectorInit.category, searchText: ''}),
							showEmojiSelector: function () {
								var _v0 = loggedIn.showEmojiSelector;
								switch (_v0.$) {
									case 0:
										return $author$project$Types$EmojiSelectorForReaction$(guildOrDmId, messageIndex);
									case 1:
										return $author$project$Types$EmojiSelectorHidden;
									case 2:
										return $author$project$Types$EmojiSelectorHidden;
									case 3:
										return $author$project$Types$EmojiSelectorHidden;
									case 5:
										return $author$project$Types$EmojiSelectorHidden;
									case 6:
										return $author$project$Types$EmojiSelectorHidden;
									default:
										return $author$project$Types$EmojiSelectorHidden;
								}
							}()
						})),
				$author$project$MyUi$isMobile(model) ? $lamdera$program_test$Effect$Command$none : $lamdera$program_test$Effect$Task$attempt$(
					function (_v1) {
						return $author$project$Types$SetFocus;
					},
					$lamdera$program_test$Effect$Browser$Dom$focus($author$project$Emoji$searchInputId)));
		},
		model);
};
var $author$project$Frontend$showReactionEmojiSelector = F3($author$project$Frontend$showReactionEmojiSelector$);
var $ianmackenzie$elm_units$Quantity$float = function (value) {
	return value;
};
var $author$project$Frontend$sidebarSpeed = $ianmackenzie$elm_units$Quantity$per$(
	$ianmackenzie$elm_units$Duration$second,
	$ianmackenzie$elm_units$Quantity$float(7));
var $author$project$RichText$spoilerAttachedFile$ = function (fileId, nonempty) {
	return $mgold$elm_nonempty_list$List$Nonempty$map$(
		function (richText) {
			switch (richText.$) {
				case 2:
					return richText;
				case 0:
					return richText;
				case 1:
					return richText;
				case 3:
					var nonempty2 = richText.a;
					return $author$project$RichText$Bold(
						$author$project$RichText$spoilerAttachedFile$(fileId, nonempty2));
				case 4:
					var nonempty2 = richText.a;
					return $author$project$RichText$Italic(
						$author$project$RichText$spoilerAttachedFile$(fileId, nonempty2));
				case 5:
					var nonempty2 = richText.a;
					return $author$project$RichText$Underline(
						$author$project$RichText$spoilerAttachedFile$(fileId, nonempty2));
				case 6:
					var nonempty2 = richText.a;
					return $author$project$RichText$Strikethrough(
						$author$project$RichText$spoilerAttachedFile$(fileId, nonempty2));
				case 7:
					var nonempty2 = richText.a;
					return $author$project$RichText$Spoiler(
						$author$project$RichText$spoilerAttachedFile$(fileId, nonempty2));
				case 8:
					var a = richText.a;
					var list = richText.b;
					var _v1 = $mgold$elm_nonempty_list$List$Nonempty$fromList(list);
					if (!_v1.$) {
						var nonempty2 = _v1.a;
						return $author$project$RichText$BlockQuote$(
							a,
							$mgold$elm_nonempty_list$List$Nonempty$toList(
								$author$project$RichText$spoilerAttachedFile$(fileId, nonempty2)));
					} else {
						return richText;
					}
				case 9:
					var level = richText.a;
					var a = richText.b;
					var nonempty2 = richText.c;
					return $author$project$RichText$Heading$(
						level,
						a,
						$author$project$RichText$spoilerAttachedFile$(fileId, nonempty2));
				case 10:
					return richText;
				case 11:
					return richText;
				case 12:
					return richText;
				case 13:
					return richText;
				case 14:
					var id = richText.a;
					return _Utils_eq(id, fileId) ? $author$project$RichText$Spoiler(
						$mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
							$author$project$RichText$AttachedFile(fileId),
							_List_Nil)) : richText;
				case 15:
					return richText;
				case 16:
					return richText;
				case 17:
					return richText;
				case 18:
					var a = richText.a;
					var items = richText.b;
					return $author$project$RichText$BulletPoint$(
						a,
						$mgold$elm_nonempty_list$List$Nonempty$map$(
							$author$project$RichText$mapBulletItem(
								$author$project$RichText$spoilerAttachedFile(fileId)),
							items));
				default:
					return richText;
			}
		},
		nonempty);
};
var $author$project$RichText$spoilerAttachedFile = F2($author$project$RichText$spoilerAttachedFile$);
var $author$project$FileStatus$websocketDomain = $elm$core$String$replace$('http', 'ws', $author$project$FileStatus$domain);
var $author$project$Call$startCallCmd$ = function (roomId, userId, clientId, model) {
	return $author$project$Call$toJs(
		$author$project$Call$ToJs_StartCall(
			{
				audioInput: model.selectedAudioInputDevice,
				audioInputEnabled: model.remoteCallData.audioInputEnabled,
				roomId: roomId,
				selfId: _Utils_Tuple2(userId, clientId),
				videoInput: model.selectedVideoInputDevice,
				videoInputEnabled: model.remoteCallData.videoInputEnabled,
				websocketUrl: $author$project$FileStatus$websocketDomain + ('/file/websocket/' + ($elm$url$Url$percentEncode(
					function () {
						if (!roomId.$) {
							var otherUserId = roomId.a.otherUserId;
							return $author$project$DmChannelId$toString(
								$author$project$DmChannelId$fromUserIds$(userId, otherUserId));
						} else {
							var id = roomId.a;
							return 'guild-' + ($author$project$Id$toString(id.guildId) + ('-' + $author$project$Id$toString(id.channelId)));
						}
					}()) + ('?clientId=' + $elm$url$Url$percentEncode(
					$lamdera$program_test$Effect$Lamdera$clientIdToString(clientId)))))
			}));
};
var $author$project$Call$startCallCmd = F4($author$project$Call$startCallCmd$);
var $author$project$Frontend$startClosingChannelSidebar = function (model) {
	var _v0 = $author$project$Route$toShowMembersTab(model.route);
	if (!_v0.a) {
		var _v1 = _v0.a;
		return $author$project$Frontend$setShowMembers$(1, model);
	} else {
		var _v2 = _v0.a;
		return $author$project$FrontendExtra$routePush$(
			model,
			$author$project$Route$setChannelsVisible$(1, model.route));
	}
};
var $author$project$Encryption$encryptMessage$ = function (requestId, id, dataCodec, data) {
	return A3(
		$lamdera$program_test$Effect$Command$sendToJsBytes,
		'encryption_to_js',
		$author$project$Encryption$encryption_to_js,
		$author$project$Serialize$encodeToBytes$(
			$author$project$Encryption$toJsCodec(dataCodec),
			$author$project$Encryption$ToJs_EncryptNewMessage(
				{data: data, otherUserId: id.otherUserId, requestId: requestId})));
};
var $author$project$Encryption$encryptMessage = F4($author$project$Encryption$encryptMessage$);
var $author$project$Frontend$startEncryptingEdit$ = function (id, threadRoute, contentAndEmbeds, loggedIn) {
	return _Utils_Tuple2(
		$author$project$FrontendExtra$mapEncryptionRequests$(
			function (requests) {
				return _Utils_update(
					requests,
					{
						nextEncryptionRequestId: $author$project$Id$increment(requests.nextEncryptionRequestId),
						pendingEncryptedEdits: $lamdera$containers$SeqDict$insert$(
							requests.nextEncryptionRequestId,
							{contentAndEmbeds: contentAndEmbeds, id: id, threadRoute: threadRoute},
							requests.pendingEncryptedEdits)
					});
			},
			_Utils_update(
				loggedIn,
				{e2eeError: $elm$core$Maybe$Nothing})),
		$author$project$Encryption$encryptMessage$(loggedIn.encryptionRequests.nextEncryptionRequestId, id, $author$project$Message$contentAndEmbedsCodec, contentAndEmbeds));
};
var $author$project$Frontend$startEncryptingEdit = F4($author$project$Frontend$startEncryptingEdit$);
var $author$project$Encryption$encryptMessageAndNotification$ = function (requestId, id, dataCodec, message, notification) {
	return A3(
		$lamdera$program_test$Effect$Command$sendToJsBytes,
		'encryption_to_js',
		$author$project$Encryption$encryption_to_js,
		$author$project$Serialize$encodeToBytes$(
			$author$project$Encryption$toJsCodec($author$project$Serialize$unit),
			$author$project$Encryption$ToJs_EncryptManyMessages(
				{
					data: _List_fromArray(
						[
							$author$project$Serialize$encodeToBytesWithoutVersion$(dataCodec, message),
							$elm$bytes$Bytes$Encode$encode(
							$elm$bytes$Bytes$Encode$string(notification))
						]),
					otherUserId: id.otherUserId,
					requestId: requestId
				})));
};
var $author$project$Encryption$encryptMessageAndNotification = F5($author$project$Encryption$encryptMessageAndNotification$);
var $author$project$UserSession$truncatePushNotificationText = function (text) {
	var chars = $elm$core$String$toList(text);
	return ($elm$core$List$length(chars) > 400) ? ($elm$core$String$fromList(
		$elm$core$List$take$(399, chars)) + '…') : text;
};
var $author$project$Frontend$startEncryptingMessage$ = function (id, threadRoute, contentAndEmbeds, loggedIn) {
	var localUser = $author$project$Local$model(loggedIn.localState).localUser;
	var guildOrDmId = _Utils_Tuple2(
		$author$project$Id$GuildOrDmId(
			$author$project$Id$GuildOrDmId_Dm(id)),
		threadRoute);
	return _Utils_Tuple2(
		$author$project$FrontendExtra$mapEncryptionRequests$(
			function (requests) {
				return _Utils_update(
					requests,
					{
						nextEncryptManyRequestId: $author$project$Id$increment(requests.nextEncryptManyRequestId),
						pendingEncryptedMessages: $lamdera$containers$SeqDict$insert$(
							requests.nextEncryptManyRequestId,
							{
								contentAndEmbeds: contentAndEmbeds,
								otherUserId: id.otherUserId,
								threadRoute: $author$project$Frontend$sendMessageThreadRoute$(guildOrDmId, threadRoute, loggedIn)
							},
							requests.pendingEncryptedMessages)
					});
			},
			_Utils_update(
				loggedIn,
				{e2eeError: $elm$core$Maybe$Nothing})),
		$author$project$Encryption$encryptMessageAndNotification$(
			loggedIn.encryptionRequests.nextEncryptManyRequestId,
			id,
			$author$project$Message$contentAndEmbedsCodec,
			contentAndEmbeds,
			$author$project$UserSession$truncatePushNotificationText(
				$author$project$RichText$toString$(
					localUser.timezone,
					true,
					$author$project$User$allUsers(localUser),
					$lamdera$containers$SeqDict$empty,
					contentAndEmbeds.content))));
};
var $author$project$Frontend$startEncryptingMessage = F4($author$project$Frontend$startEncryptingMessage$);
var $author$project$Call$startLocalStream = function (model) {
	return $author$project$Call$toJs(
		$author$project$Call$ToJs_StartLocalStream(
			{audioInput: model.selectedAudioInputDevice, audioInputEnabled: model.remoteCallData.audioInputEnabled, videoInput: model.selectedVideoInputDevice, videoInputEnabled: model.remoteCallData.videoInputEnabled}));
};
var $author$project$UserColor$startPicking = function (color) {
	return {
		lastValid: color,
		selected: $author$project$UserColor$toParts(color)
	};
};
var $author$project$Frontend$stayAtBottomOfConversation = function (model) {
	var _v0 = model.loginStatus;
	if (!_v0.$) {
		var loggedIn = _v0.a;
		return $author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn.channelScrollPosition);
	} else {
		return $lamdera$program_test$Effect$Command$none;
	}
};
var $author$project$Frontend$stillAttached$ = function (loggedIn, pending) {
	var _v0 = $elm$core$Maybe$andThen$(
		$author$project$NonemptyDict$get(pending.fileId),
		$lamdera$containers$SeqDict$get$(pending.guildOrDmId, loggedIn.filesToUpload));
	if (!_v0.$) {
		return $elm$core$Maybe$Just(pending);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Frontend$stillAttached = F2($author$project$Frontend$stillAttached$);
var $author$project$X25519$SharedSecret = $elm$core$Basics$identity;
var $author$project$X25519$sharedSecret$ = function (_v0, _v1) {
	var scalar = _v0;
	var point = _v1;
	var secret = $author$project$X25519$scalarMult$(scalar, point);
	return _Utils_eq(secret, $author$project$X25519$keyZero) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(secret);
};
var $author$project$X25519$sharedSecret = F2($author$project$X25519$sharedSecret$);
var $author$project$X25519$keyToBytes = function (key) {
	return $elm$bytes$Bytes$Encode$encode(
		$elm$bytes$Bytes$Encode$sequence(
			$elm$core$List$map$(
				$elm$bytes$Bytes$Encode$unsignedInt32(0),
				_List_fromArray(
					[key.w0, key.w1, key.w2, key.w3, key.w4, key.w5, key.w6, key.w7]))));
};
var $author$project$X25519$sharedSecretToBytes = function (_v0) {
	var key = _v0;
	return $author$project$X25519$keyToBytes(key);
};
var $author$project$Encryption$storeSharedSecret$ = function (otherUserId, sharedSecret) {
	return A3(
		$lamdera$program_test$Effect$Command$sendToJsBytes,
		'encryption_to_js',
		$author$project$Encryption$encryption_to_js,
		$author$project$Serialize$encodeToBytes$(
			$author$project$Encryption$toJsCodec($author$project$Serialize$unit),
			$author$project$Encryption$ToJs_StoreSharedSecret(
				{otherUserId: otherUserId, sharedSecret: sharedSecret})));
};
var $author$project$Encryption$storeSharedSecret = F2($author$project$Encryption$storeSharedSecret$);
var $author$project$Frontend$storeSharedSecret$ = function (otherUserId, privateKey, loggedIn) {
	var local = $author$project$Local$model(loggedIn.localState);
	var _v0 = $elm$core$Maybe$andThen$(
		function ($) {
			return $.publicKey;
		},
		$author$project$User$getUser$(otherUserId, local.localUser));
	if (_v0.$ === 1) {
		return $elm$core$Result$Err('The other person hasn\u0027t created a private key yet');
	} else {
		var otherPublicKey = _v0.a;
		var _v1 = $author$project$X25519$sharedSecret$(privateKey, otherPublicKey);
		if (_v1.$ === 1) {
			return $elm$core$Result$Err('The other person\u0027s public key is not usable');
		} else {
			var secret = _v1.a;
			return $elm$core$Result$Ok(
				$author$project$Encryption$storeSharedSecret$(
					otherUserId,
					$author$project$X25519$sharedSecretToBytes(secret)));
		}
	}
};
var $author$project$Frontend$storeSharedSecret = F3($author$project$Frontend$storeSharedSecret$);
var $author$project$Frontend$storeRemainingSharedSecrets$ = function (alreadyHandled, privateKey, loggedIn) {
	return $elm$core$List$filterMap$(
		function (_v0) {
			var otherUserId = _v0.a;
			var dmChannel = _v0.b;
			var _v1 = dmChannel.e2ee;
			switch (_v1.$) {
				case 3:
					return (_Utils_eq(otherUserId, alreadyHandled) || $lamdera$containers$SeqSet$member$(otherUserId, loggedIn.e2eeKeysOnThisDevice)) ? $elm$core$Maybe$Nothing : $elm$core$Result$toMaybe(
						$author$project$Frontend$storeSharedSecret$(otherUserId, privateKey, loggedIn));
				case 1:
					return $elm$core$Maybe$Nothing;
				case 2:
					return $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		},
		$lamdera$containers$SeqDict$toList(
			$author$project$Local$model(loggedIn.localState).dmChannels));
};
var $author$project$Frontend$storeRemainingSharedSecrets = F3($author$project$Frontend$storeRemainingSharedSecrets$);
var $author$project$UserOptions$discordBookmarkletId = $lamdera$program_test$Effect$Browser$Dom$id('userOptions_discordLinkBookmarklet');
var $author$project$Ports$fix_cursor_position_to_js = _Platform_outgoingPort('fix_cursor_position_to_js', $elm$core$Basics$identity);
var $author$project$Ports$fixCursorPosition = function (htmlId) {
	return A3(
		$lamdera$program_test$Effect$Command$sendToJs,
		'fix_cursor_position_to_js',
		$author$project$Ports$fix_cursor_position_to_js,
		$elm$json$Json$Encode$string(
			$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId)));
};
var $author$project$UserAgent$isDesktop = function (device) {
	switch (device) {
		case 0:
			return false;
		case 1:
			return false;
		case 2:
			return false;
		case 3:
			return false;
		case 4:
			return true;
		case 5:
			return true;
		case 6:
			return true;
		case 7:
			return true;
		case 8:
			return false;
		case 9:
			return false;
		default:
			return true;
	}
};
var $author$project$Ports$text_input_select_all_to_js = _Platform_outgoingPort('text_input_select_all_to_js', $elm$core$Basics$identity);
var $author$project$Ports$textInputSelectAll = function (htmlId) {
	return A3(
		$lamdera$program_test$Effect$Command$sendToJs,
		'text_input_select_all_to_js',
		$author$project$Ports$text_input_select_all_to_js,
		$elm$json$Json$Encode$string(
			$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId)));
};
var $author$project$Frontend$textInputFocusChanged$ = function (maybeHtmlId, maybeSelection, model) {
	var _v0 = model.loginStatus;
	if (!_v0.$) {
		var loggedIn = _v0.a;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					loginStatus: $author$project$Types$LoggedIn(
						_Utils_update(
							loggedIn,
							{
								previousTextInputFocus: loggedIn.textInputFocus,
								textInputFocus: function () {
									if (!maybeHtmlId.$) {
										var htmlId = maybeHtmlId.a;
										if (!maybeSelection.$) {
											var _v3 = maybeSelection.a;
											var range = _v3.a;
											var direction = _v3.b;
											return $elm$core$Maybe$Just(
												{direction: direction, dropdown: $elm$core$Maybe$Nothing, htmlId: htmlId, selection: range});
										} else {
											return $elm$core$Maybe$Nothing;
										}
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}()
							}))
				}),
			$lamdera$program_test$Effect$Command$batch(
				_List_fromArray(
					[
						function () {
						if (!maybeHtmlId.$) {
							var htmlId = maybeHtmlId.a;
							return $lamdera$program_test$Effect$Command$batch(
								_List_fromArray(
									[
										($author$project$UserAgent$isDesktop(model.startupData.userAgent.device) || _Utils_eq(
										$elm$core$Maybe$map$(
											function ($) {
												return $.htmlId;
											},
											loggedIn.textInputFocus),
										$elm$core$Maybe$Just(htmlId))) ? $lamdera$program_test$Effect$Command$none : $author$project$Ports$fixCursorPosition(htmlId),
										_Utils_eq(htmlId, $author$project$UserOptions$discordBookmarkletId) ? $author$project$Ports$textInputSelectAll(htmlId) : $lamdera$program_test$Effect$Command$none
									]));
						} else {
							return $lamdera$program_test$Effect$Command$none;
						}
					}(),
						$author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn.channelScrollPosition)
					])));
	} else {
		var notLoggedIn = _v0.a;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					loginStatus: $author$project$Types$NotLoggedIn(
						_Utils_update(
							notLoggedIn,
							{
								textInputFocus: function () {
									if (!maybeHtmlId.$) {
										var htmlId = maybeHtmlId.a;
										if (!maybeSelection.$) {
											var _v7 = maybeSelection.a;
											var range = _v7.a;
											var direction = _v7.b;
											return $elm$core$Maybe$Just(
												{direction: direction, htmlId: htmlId, selection: range});
										} else {
											return $elm$core$Maybe$Nothing;
										}
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}()
							}))
				}),
			$lamdera$program_test$Effect$Command$none);
	}
};
var $author$project$Frontend$textInputFocusChanged = F3($author$project$Frontend$textInputFocusChanged$);
var $author$project$Id$threadRouteWithMessage$ = function (messageId, threadRoute) {
	if (threadRoute.$ === 1) {
		var threadId = threadRoute.a;
		return $author$project$Id$ViewThreadWithMessage$(
			threadId,
			$author$project$Id$changeType(messageId));
	} else {
		return $author$project$Id$NoThreadWithMessage(messageId);
	}
};
var $author$project$Id$threadRouteWithMessage = F2($author$project$Id$threadRouteWithMessage$);
var $lamdera$program_test$Effect$File$toString = function (file) {
	return $lamdera$program_test$Effect$Internal$FileToString$(
		$lamdera$program_test$Effect$File$toInternalFile(file),
		$lamdera$program_test$Effect$Internal$Succeed);
};
var $author$project$Message$reactionEmojis = function (message) {
	switch (message.$) {
		case 0:
			var data = message.a;
			return data.reactions;
		case 1:
			var data = message.a;
			return data.reactions;
		case 2:
			var reactions = message.c;
			return reactions;
		case 3:
			return $lamdera$containers$SeqDict$empty;
		case 4:
			var callStarted = message.a;
			return callStarted.reactions;
		default:
			var gameStarted = message.a;
			return gameStarted.reactions;
	}
};
var $author$project$LocalState$messageReactionsNoThread$ = function (messageId, channel) {
	var _v0 = $author$project$MessageArray$get$(messageId, channel.messages);
	if (!_v0.$) {
		var message = _v0.a;
		return $author$project$Message$reactionEmojis(message);
	} else {
		return $lamdera$containers$SeqDict$empty;
	}
};
var $author$project$LocalState$messageReactionsNoThread = F2($author$project$LocalState$messageReactionsNoThread$);
var $author$project$LocalState$messageReactionsHelper$ = function (channel, threadRoute2) {
	if (!threadRoute2.$) {
		var messageId = threadRoute2.a;
		return $author$project$LocalState$messageReactionsNoThread$(messageId, channel);
	} else {
		var threadId = threadRoute2.a;
		var messageId = threadRoute2.b;
		var _v1 = $lamdera$containers$SeqDict$get$(threadId, channel.threads);
		if (!_v1.$) {
			var thread = _v1.a;
			return $author$project$LocalState$messageReactionsNoThread$(messageId, thread);
		} else {
			return $lamdera$containers$SeqDict$empty;
		}
	}
};
var $author$project$LocalState$messageReactionsHelper = F2($author$project$LocalState$messageReactionsHelper$);
var $author$project$LocalState$messageReactions$ = function (guildOrDmId, threadRoute, local) {
	if (!guildOrDmId.$) {
		var id = guildOrDmId.a;
		var _v1 = $author$project$LocalState$getGuildAndChannel$(id, local);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var channel = _v2.b;
			return $author$project$LocalState$messageReactionsHelper$(channel, threadRoute);
		} else {
			return $lamdera$containers$SeqDict$empty;
		}
	} else {
		var otherUserId = guildOrDmId.a.otherUserId;
		var _v3 = $lamdera$containers$SeqDict$get$(otherUserId, local.dmChannels);
		if (!_v3.$) {
			var channel = _v3.a;
			return $author$project$LocalState$messageReactionsHelper$(channel, threadRoute);
		} else {
			return $lamdera$containers$SeqDict$empty;
		}
	}
};
var $author$project$LocalState$messageReactions = F3($author$project$LocalState$messageReactions$);
var $author$project$Frontend$messageHasReaction$ = function (emoji, guildOrDmId, threadRoute, local) {
	switch (guildOrDmId.$) {
		case 0:
			var guildOrDmId3 = guildOrDmId.a;
			var _v1 = $lamdera$containers$SeqDict$get$(
				emoji,
				$author$project$LocalState$messageReactions$(guildOrDmId3, threadRoute, local));
			if (!_v1.$) {
				var reactions = _v1.a;
				return $author$project$NonemptySet$member$(local.localUser.session.userId, reactions);
			} else {
				return false;
			}
		case 1:
			if (!guildOrDmId.a.$) {
				var channelId = guildOrDmId.a.a.channelId;
				var guildId = guildOrDmId.a.a.guildId;
				var currentUserId = guildOrDmId.a.a.currentUserId;
				var _v2 = $author$project$LocalState$getDiscordGuildAndChannel$(guildId, channelId, local);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var channel = _v3.b;
					var _v4 = $lamdera$containers$SeqDict$get$(
						emoji,
						$author$project$LocalState$messageReactionsHelper$(channel, threadRoute));
					if (!_v4.$) {
						var reactions = _v4.a;
						return $author$project$NonemptySet$member$(currentUserId, reactions);
					} else {
						return false;
					}
				} else {
					return false;
				}
			} else {
				var data = guildOrDmId.a.a;
				var _v5 = $lamdera$containers$SeqDict$get$(data.channelId, local.discordDmChannels);
				if (!_v5.$) {
					var channel = _v5.a;
					if (!threadRoute.$) {
						var messageId = threadRoute.a;
						var _v7 = $lamdera$containers$SeqDict$get$(
							emoji,
							$author$project$LocalState$messageReactionsNoThread$(messageId, channel));
						if (!_v7.$) {
							var reactions = _v7.a;
							return $author$project$NonemptySet$member$(data.currentUserId, reactions);
						} else {
							return false;
						}
					} else {
						return false;
					}
				} else {
					return false;
				}
			}
		default:
			if (!guildOrDmId.a.$) {
				var channelId = guildOrDmId.a.a.channelId;
				var teamId = guildOrDmId.a.a.teamId;
				var currentUserId = guildOrDmId.a.a.currentUserId;
				var _v8 = $elm$core$Maybe$andThen$(
					function (workspace) {
						return $lamdera$containers$SeqDict$get$(channelId, workspace.channels);
					},
					$lamdera$containers$SeqDict$get$(teamId, local.slackWorkspaces));
				if (!_v8.$) {
					var channel = _v8.a;
					var _v9 = $lamdera$containers$SeqDict$get$(
						emoji,
						$author$project$LocalState$messageReactionsHelper$(channel, threadRoute));
					if (!_v9.$) {
						var reactions = _v9.a;
						return $author$project$NonemptySet$member$(currentUserId, reactions);
					} else {
						return false;
					}
				} else {
					return false;
				}
			} else {
				var channelId = guildOrDmId.a.a.channelId;
				var currentUserId = guildOrDmId.a.a.currentUserId;
				var _v10 = $lamdera$containers$SeqDict$get$(channelId, local.slackDmChannels);
				if (!_v10.$) {
					var channel = _v10.a;
					var _v11 = $lamdera$containers$SeqDict$get$(
						emoji,
						$author$project$LocalState$messageReactionsHelper$(channel, threadRoute));
					if (!_v11.$) {
						var reactions = _v11.a;
						return $author$project$NonemptySet$member$(currentUserId, reactions);
					} else {
						return false;
					}
				} else {
					return false;
				}
			}
	}
};
var $author$project$Frontend$messageHasReaction = F4($author$project$Frontend$messageHasReaction$);
var $author$project$Frontend$toggleReactionEmoji$ = function (emoji, guildOrDmId, threadRoute, model, loggedIn) {
	var local = $author$project$Local$model(loggedIn.localState);
	var hasReaction = $author$project$Frontend$messageHasReaction$(emoji, guildOrDmId, threadRoute, local);
	return $author$project$FrontendExtra$handleLocalChange$(
		model.time,
		$elm$core$Maybe$Just(
			A3(
				hasReaction ? $author$project$Types$Local_RemoveReactionEmoji : $author$project$Types$Local_AddReactionEmoji,
				guildOrDmId,
				threadRoute,
				emoji)),
		loggedIn,
		hasReaction ? $lamdera$program_test$Effect$Command$none : $author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn.channelScrollPosition));
};
var $author$project$Frontend$toggleReactionEmoji = F5($author$project$Frontend$toggleReactionEmoji$);
var $author$project$Frontend$toggleSearchOverlay = function (model) {
	var _v0 = model.loginStatus;
	if (!_v0.$) {
		var loggedIn = _v0.a;
		if (_Utils_eq(
			$author$project$Route$toOverlay(model.route),
			$elm$core$Maybe$Just(2))) {
			return $author$project$FrontendExtra$routePush$(
				model,
				$author$project$Route$setOverlay$($elm$core$Maybe$Nothing, model.route));
		} else {
			var route = $author$project$Route$setOverlay$(
				$elm$core$Maybe$Just(2),
				model.route);
			return _Utils_eq(route, model.route) ? _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none) : $author$project$FrontendExtra$routePush$(
				_Utils_update(
					model,
					{
						loginStatus: $author$project$Types$LoggedIn(
							_Utils_update(
								loggedIn,
								{searchOverlayQuery: ''}))
					}),
				route);
		}
	} else {
		return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
	}
};
var $author$project$Types$CheckMessageAltPress$ = function (a, b, c, d, e, f, g) {
	return {$: 71, a: a, b: b, c: c, d: d, e: e, f: f, g: g};
};
var $author$project$Types$CheckMessageAltPress = F7($author$project$Types$CheckMessageAltPress$);
var $author$project$Touch$DragStart$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Touch$DragStart = F2($author$project$Touch$DragStart$);
var $author$project$Frontend$hideReactionPopup = function (model) {
	var _v0 = model.loginStatus;
	if (!_v0.$) {
		var loggedIn = _v0.a;
		var _v1 = loggedIn.messageHover;
		switch (_v1.$) {
			case 3:
				return _Utils_update(
					model,
					{
						loginStatus: $author$project$Types$LoggedIn(
							_Utils_update(
								loggedIn,
								{messageHover: $author$project$Types$NoMessageHover}))
					});
			case 0:
				return model;
			case 1:
				return model;
			default:
				return model;
		}
	} else {
		return model;
	}
};
var $author$project$NonemptyDict$toList = function (_v0) {
	var id = _v0.a;
	var a = _v0.b;
	var dict = _v0.c;
	return $lamdera$containers$SeqDict$foldr$(
		F3(
			function (k, v, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(k, v),
					list);
			}),
		_List_fromArray(
			[
				_Utils_Tuple2(id, a)
			]),
		dict);
};
var $author$project$Frontend$touchStart$ = function (maybeGuildOrDmIdAndMessageIndex, maybeImageUrl, maybeLinkUrl, maybeReactionIndex, time, touches, model) {
	var model2 = $author$project$Frontend$hideReactionPopup(model);
	var _v0 = model2.drag;
	switch (_v0.$) {
		case 0:
			return $author$project$Frontend$isTouchingTextInput(touches) ? _Utils_Tuple2(model2, $lamdera$program_test$Effect$Command$none) : _Utils_Tuple2(
				_Utils_update(
					model2,
					{
						drag: $author$project$Touch$DragStart$(time, touches),
						dragPrevious: model2.drag
					}),
				$lamdera$program_test$Effect$Command$batch(
					_List_fromArray(
						[
							function () {
							var _v1 = $author$project$NonemptyDict$toList(touches);
							if (_v1.b && (!_v1.b.b)) {
								if (!maybeGuildOrDmIdAndMessageIndex.$) {
									var _v3 = maybeGuildOrDmIdAndMessageIndex.a;
									var guildOrMessageId = _v3.a;
									var messageIndex = _v3.b;
									var isThreadStarter = _v3.c;
									return $lamdera$program_test$Effect$Task$perform$(
										function (_v4) {
											return $author$project$Types$CheckMessageAltPress$(time, guildOrMessageId, messageIndex, isThreadStarter, maybeImageUrl, maybeLinkUrl, maybeReactionIndex);
										},
										$lamdera$program_test$Effect$Process$sleep(
											$ianmackenzie$elm_units$Duration$seconds(0.5)));
								} else {
									return $lamdera$program_test$Effect$Command$none;
								}
							} else {
								return $lamdera$program_test$Effect$Command$none;
							}
						}(),
							function () {
							var _v5 = _Utils_Tuple2(
								model2.loginStatus,
								$author$project$MyUi$isMobile(model2));
							if ((!_v5.a.$) && _v5.b) {
								var loggedIn = _v5.a.a;
								var _v6 = loggedIn.textInputFocus;
								if (!_v6.$) {
									var textInputFocus = _v6.a;
									return $lamdera$program_test$Effect$Task$attempt$(
										function (_v7) {
											return $author$project$Types$RemoveFocus;
										},
										$lamdera$program_test$Effect$Browser$Dom$blur(textInputFocus.htmlId));
								} else {
									return $lamdera$program_test$Effect$Command$none;
								}
							} else {
								return $lamdera$program_test$Effect$Command$none;
							}
						}()
						])));
		case 1:
			return _Utils_Tuple2(model2, $lamdera$program_test$Effect$Command$none);
		default:
			return _Utils_Tuple2(model2, $lamdera$program_test$Effect$Command$none);
	}
};
var $author$project$Frontend$touchStart = F7($author$project$Frontend$touchStart$);
var $author$project$Pages$Guild$typingDebouncerDelay = $ianmackenzie$elm_units$Duration$seconds(7);
var $lamdera$containers$SeqDict$array2AllHelper$ = function (index, func, array) {
	array2AllHelper:
	while (true) {
		var _v0 = $elm$core$Array$get$(index, array);
		if (!_v0.$) {
			var item = _v0.a;
			if (func(item)) {
				var $temp$index = index - 1;
				index = $temp$index;
				continue array2AllHelper;
			} else {
				return false;
			}
		} else {
			return true;
		}
	}
};
var $lamdera$containers$SeqDict$array2AllHelper = F3($lamdera$containers$SeqDict$array2AllHelper$);
var $lamdera$containers$SeqDict$array2All$ = function (func, array) {
	return $lamdera$containers$SeqDict$array2AllHelper$(
		$elm$core$Array$length(array) - 1,
		func,
		array);
};
var $lamdera$containers$SeqDict$array2All = F2($lamdera$containers$SeqDict$array2All$);
var $lamdera$containers$SeqDict$unorderedEqualsHelper$ = function (_v0, dict) {
	var bitmap = _v0.a;
	var nodes = _v0.b;
	var func = function (_v3) {
		var hash = _v3.a;
		var key = _v3.b;
		var value = _v3.c;
		var _v2 = $lamdera$containers$SeqDict$getHelp$(0, hash, key, bitmap, nodes);
		if (!_v2.$) {
			var value2 = _v2.a;
			return _Utils_eq(value, value2);
		} else {
			return false;
		}
	};
	var helper = function (node) {
		if (!node.$) {
			var a = node.a;
			return func(a);
		} else {
			return true;
		}
	};
	return $lamdera$containers$SeqDict$array2All$(helper, dict.array);
};
var $lamdera$containers$SeqDict$unorderedEqualsHelper = F2($lamdera$containers$SeqDict$unorderedEqualsHelper$);
var $lamdera$containers$SeqDict$unorderedEquals$ = function (dict1, dict2) {
	var triplets2 = dict2.c;
	return _Utils_eq(
		$lamdera$containers$SeqDict$size(dict1),
		$lamdera$containers$SeqDict$size(dict2)) ? $lamdera$containers$SeqDict$unorderedEqualsHelper$(dict1, triplets2) : false;
};
var $lamdera$containers$SeqDict$unorderedEquals = F2($lamdera$containers$SeqDict$unorderedEquals$);
var $lamdera$containers$SeqSet$unorderedEquals$ = function (_v0, _v1) {
	var dict1 = _v0;
	var dict2 = _v1;
	return $lamdera$containers$SeqDict$unorderedEquals$(dict1, dict2);
};
var $lamdera$containers$SeqSet$unorderedEquals = F2($lamdera$containers$SeqSet$unorderedEquals$);
var $author$project$NonemptySet$unorderedEquals$ = function (_v0, _v1) {
	var a = _v0.a;
	var setA = _v0.b;
	var b = _v1.a;
	var setB = _v1.b;
	return $lamdera$containers$SeqSet$unorderedEquals$(
		$lamdera$containers$SeqSet$insert$(a, setA),
		$lamdera$containers$SeqSet$insert$(b, setB));
};
var $author$project$NonemptySet$unorderedEquals = F2($author$project$NonemptySet$unorderedEquals$);
var $author$project$Ports$unregister_service_worker_to_js = _Platform_outgoingPort('unregister_service_worker_to_js', $elm$core$Basics$identity);
var $author$project$Ports$unregisterServiceWorker = A3($lamdera$program_test$Effect$Command$sendToJs, 'unregister_service_worker_to_js', $author$project$Ports$unregister_service_worker_to_js, $elm$json$Json$Encode$null);
var $mgold$elm_nonempty_list$List$Nonempty$any$ = function (f, _v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return f(x) || $elm$core$List$any$(f, xs);
};
var $mgold$elm_nonempty_list$List$Nonempty$any = F2($mgold$elm_nonempty_list$List$Nonempty$any$);
var $mgold$elm_nonempty_list$List$Nonempty$concat = function (_v0) {
	var xs = _v0.a;
	var xss = _v0.b;
	var tl = _Utils_ap(
		$mgold$elm_nonempty_list$List$Nonempty$tail(xs),
		$elm$core$List$concat(
			$elm$core$List$map$($mgold$elm_nonempty_list$List$Nonempty$toList, xss)));
	var hd = $mgold$elm_nonempty_list$List$Nonempty$head(xs);
	return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(hd, tl);
};
var $mgold$elm_nonempty_list$List$Nonempty$concatMap$ = function (f, xs) {
	return $mgold$elm_nonempty_list$List$Nonempty$concat(
		$mgold$elm_nonempty_list$List$Nonempty$map$(f, xs));
};
var $mgold$elm_nonempty_list$List$Nonempty$concatMap = F2($mgold$elm_nonempty_list$List$Nonempty$concatMap$);
var $elmcraft$core_extra$List$Extra$groupWhile$ = function (isSameGroup, items) {
	return $elm$core$List$foldr$(
		F2(
			function (x, acc) {
				if (!acc.b) {
					return _List_fromArray(
						[
							_Utils_Tuple2(x, _List_Nil)
						]);
				} else {
					var _v1 = acc.a;
					var y = _v1.a;
					var restOfGroup = _v1.b;
					var groups = acc.b;
					return A2(isSameGroup, x, y) ? A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							x,
							A2($elm$core$List$cons, y, restOfGroup)),
						groups) : A2(
						$elm$core$List$cons,
						_Utils_Tuple2(x, _List_Nil),
						acc);
				}
			}),
		_List_Nil,
		items);
};
var $elmcraft$core_extra$List$Extra$groupWhile = F2($elmcraft$core_extra$List$Extra$groupWhile$);
var $author$project$RichText$unspoilerAttachedFile$ = function (fileId, nonempty) {
	var helper = function (nonempty2) {
		var unspoilered = unspoilerAttachedFileHelper(nonempty2);
		return _Utils_Tuple2(
			$mgold$elm_nonempty_list$List$Nonempty$any$(
				function (_v5) {
					var removeSpoiler = _v5.a;
					return removeSpoiler;
				},
				unspoilered),
			$elm$core$Maybe$withDefault$(
				nonempty2,
				$mgold$elm_nonempty_list$List$Nonempty$fromList(
					$elm$core$List$concatMap$(
						function (_v8) {
							var _v9 = _v8.a;
							var removeSpoiler = _v9.a;
							var head = _v9.b;
							var rest = _v8.b;
							return removeSpoiler ? A2(
								$elm$core$List$cons,
								head,
								$elm$core$List$map$($elm$core$Tuple$second, rest)) : _List_fromArray(
								[
									$author$project$RichText$Spoiler(
									$mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
										head,
										$elm$core$List$map$($elm$core$Tuple$second, rest)))
								]);
						},
						$elmcraft$core_extra$List$Extra$groupWhile$(
							F2(
								function (_v6, _v7) {
									var removeSpoilerA = _v6.a;
									var removeSpoilerB = _v7.a;
									return _Utils_eq(removeSpoilerA, removeSpoilerB);
								}),
							$mgold$elm_nonempty_list$List$Nonempty$toList(unspoilered))))));
	};
	var unspoilerAttachedFileHelper = function (nonempty2) {
		return $mgold$elm_nonempty_list$List$Nonempty$concatMap$(
			function (richText) {
				switch (richText.$) {
					case 2:
						return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
							_Utils_Tuple2(false, richText),
							_List_Nil);
					case 0:
						return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
							_Utils_Tuple2(false, richText),
							_List_Nil);
					case 1:
						return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
							_Utils_Tuple2(false, richText),
							_List_Nil);
					case 3:
						var nonempty3 = richText.a;
						return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
							$elm$core$Tuple$mapSecond$(
								$author$project$RichText$Bold,
								helper(nonempty3)),
							_List_Nil);
					case 4:
						var nonempty3 = richText.a;
						return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
							$elm$core$Tuple$mapSecond$(
								$author$project$RichText$Italic,
								helper(nonempty3)),
							_List_Nil);
					case 5:
						var nonempty3 = richText.a;
						return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
							$elm$core$Tuple$mapSecond$(
								$author$project$RichText$Underline,
								helper(nonempty3)),
							_List_Nil);
					case 6:
						var nonempty3 = richText.a;
						return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
							$elm$core$Tuple$mapSecond$(
								$author$project$RichText$Strikethrough,
								helper(nonempty3)),
							_List_Nil);
					case 7:
						return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
							_Utils_Tuple2(false, richText),
							_List_Nil);
					case 8:
						var hasLeadingLineBreak = richText.a;
						var list = richText.b;
						var _v4 = $mgold$elm_nonempty_list$List$Nonempty$fromList(list);
						if (!_v4.$) {
							var nonempty3 = _v4.a;
							return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
								$elm$core$Tuple$mapSecond$(
									function (a) {
										return $author$project$RichText$BlockQuote$(
											hasLeadingLineBreak,
											$mgold$elm_nonempty_list$List$Nonempty$toList(a));
									},
									helper(nonempty3)),
								_List_Nil);
						} else {
							return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
								_Utils_Tuple2(false, richText),
								_List_Nil);
						}
					case 9:
						var level = richText.a;
						var hasLeadingLineBreak = richText.b;
						var nonempty3 = richText.c;
						return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
							$elm$core$Tuple$mapSecond$(
								function (a) {
									return $author$project$RichText$Heading$(level, hasLeadingLineBreak, a);
								},
								helper(nonempty3)),
							_List_Nil);
					case 10:
						return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
							_Utils_Tuple2(false, richText),
							_List_Nil);
					case 11:
						return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
							_Utils_Tuple2(false, richText),
							_List_Nil);
					case 12:
						return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
							_Utils_Tuple2(false, richText),
							_List_Nil);
					case 13:
						return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
							_Utils_Tuple2(false, richText),
							_List_Nil);
					case 14:
						var id = richText.a;
						return _Utils_eq(id, fileId) ? $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
							_Utils_Tuple2(true, richText),
							_List_Nil) : $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
							_Utils_Tuple2(false, richText),
							_List_Nil);
					case 15:
						return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
							_Utils_Tuple2(false, richText),
							_List_Nil);
					case 16:
						return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
							_Utils_Tuple2(false, richText),
							_List_Nil);
					case 17:
						return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
							_Utils_Tuple2(false, richText),
							_List_Nil);
					case 18:
						var hasLeadingLineBreak = richText.a;
						var items = richText.b;
						return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
							_Utils_Tuple2(
								false,
								$author$project$RichText$BulletPoint$(
									hasLeadingLineBreak,
									$mgold$elm_nonempty_list$List$Nonempty$map$(
										$author$project$RichText$mapBulletItem(
											$author$project$RichText$unspoilerAttachedFile(fileId)),
										items))),
							_List_Nil);
					default:
						return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
							_Utils_Tuple2(false, richText),
							_List_Nil);
				}
			},
			nonempty2);
	};
	return $mgold$elm_nonempty_list$List$Nonempty$concatMap$(
		function (richText) {
			switch (richText.$) {
				case 2:
					return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(richText, _List_Nil);
				case 0:
					return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(richText, _List_Nil);
				case 1:
					return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(richText, _List_Nil);
				case 3:
					var nonempty2 = richText.a;
					return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
						$author$project$RichText$Bold(
							$author$project$RichText$unspoilerAttachedFile$(fileId, nonempty2)),
						_List_Nil);
				case 4:
					var nonempty2 = richText.a;
					return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
						$author$project$RichText$Italic(
							$author$project$RichText$unspoilerAttachedFile$(fileId, nonempty2)),
						_List_Nil);
				case 5:
					var nonempty2 = richText.a;
					return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
						$author$project$RichText$Underline(
							$author$project$RichText$unspoilerAttachedFile$(fileId, nonempty2)),
						_List_Nil);
				case 6:
					var nonempty2 = richText.a;
					return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
						$author$project$RichText$Strikethrough(
							$author$project$RichText$unspoilerAttachedFile$(fileId, nonempty2)),
						_List_Nil);
				case 7:
					var nonempty2 = richText.a;
					var _v1 = helper(nonempty2);
					var removeSpoiler = _v1.a;
					var nonempty4 = _v1.b;
					return removeSpoiler ? nonempty4 : $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(richText, _List_Nil);
				case 8:
					var a = richText.a;
					var list = richText.b;
					var _v2 = $mgold$elm_nonempty_list$List$Nonempty$fromList(list);
					if (!_v2.$) {
						var nonempty2 = _v2.a;
						return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
							$author$project$RichText$BlockQuote$(
								a,
								$mgold$elm_nonempty_list$List$Nonempty$toList(
									$author$project$RichText$unspoilerAttachedFile$(fileId, nonempty2))),
							_List_Nil);
					} else {
						return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(richText, _List_Nil);
					}
				case 9:
					var level = richText.a;
					var a = richText.b;
					var nonempty2 = richText.c;
					return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
						$author$project$RichText$Heading$(
							level,
							a,
							$author$project$RichText$unspoilerAttachedFile$(fileId, nonempty2)),
						_List_Nil);
				case 10:
					return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(richText, _List_Nil);
				case 11:
					return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(richText, _List_Nil);
				case 12:
					return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(richText, _List_Nil);
				case 13:
					return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(richText, _List_Nil);
				case 14:
					return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(richText, _List_Nil);
				case 15:
					return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(richText, _List_Nil);
				case 16:
					return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(richText, _List_Nil);
				case 17:
					return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(richText, _List_Nil);
				case 18:
					var hasLeadingLineBreak = richText.a;
					var items = richText.b;
					return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
						$author$project$RichText$BulletPoint$(
							hasLeadingLineBreak,
							$mgold$elm_nonempty_list$List$Nonempty$map$(
								$author$project$RichText$mapBulletItem(
									$author$project$RichText$unspoilerAttachedFile(fileId)),
								items)),
						_List_Nil);
				default:
					return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(richText, _List_Nil);
			}
		},
		nonempty);
};
var $author$project$RichText$unspoilerAttachedFile = F2($author$project$RichText$unspoilerAttachedFile$);
var $author$project$Vector2d$unwrap = function (_v0) {
	var vectorComponents = _v0;
	return vectorComponents;
};
var $author$project$AiChat$AiMessageRequest$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $author$project$AiChat$AiMessageRequest = F3($author$project$AiChat$AiMessageRequest$);
var $author$project$AiChat$AiMessageRequestSimple$ = function (a, b, c) {
	return {$: 1, a: a, b: b, c: c};
};
var $author$project$AiChat$AiMessageRequestSimple = F3($author$project$AiChat$AiMessageRequestSimple$);
var $author$project$AiChat$GotResponse$ = function (a, b, c, d) {
	return {$: 1, a: a, b: b, c: c, d: d};
};
var $author$project$AiChat$GotResponse = F4($author$project$AiChat$GotResponse$);
var $author$project$AiChat$LoadedAiModels = function (a) {
	return {$: 1, a: a};
};
var $author$project$AiChat$LoadingFailed = function (a) {
	return {$: 2, a: a};
};
var $author$project$AiChat$NoOp = {$: 16};
var $author$project$AiChat$Pending = function (a) {
	return {$: 0, a: a};
};
var $author$project$AiChat$RespondId = $elm$core$Basics$identity;
var $author$project$AiChat$aiModelNameToString = function (_v0) {
	var a = _v0;
	return a;
};
var $author$project$AiChat$botPrefix = '[bot]';
var $author$project$AiChat$chatHistoryInputId = $lamdera$program_test$Effect$Browser$Dom$id('chat-history-input');
var $author$project$AiChat$TextMessage = function (a) {
	return {$: 0, a: a};
};
var $author$project$AiChat$ImageUrlMessage = function (a) {
	return {$: 1, a: a};
};
var $author$project$TimeInMinutes$toSeconds = function (_v0) {
	var _int = _v0;
	return _int * 60;
};
var $author$project$RichText$timestampToDiscordString = function (time) {
	return '<t:' + ($elm$core$String$fromInt(
		$author$project$TimeInMinutes$toSeconds(time)) + ':f>');
};
var $author$project$AiChat$richTextToMessage$ = function (previousText, previousList, nonempty) {
	return $elm$core$List$foldl$(
		F2(
			function (a, _v0) {
				var currentText = _v0.a;
				var list = _v0.b;
				switch (a.$) {
					case 2:
						var _char = a.a;
						var rest = a.b;
						return _Utils_Tuple2(
							_Utils_ap(
								currentText,
								_Utils_ap(
									$elm$core$String$fromChar(_char),
									rest)),
							list);
					case 0:
						return _Utils_Tuple2(currentText, list);
					case 1:
						return _Utils_Tuple2(currentText, list);
					case 3:
						var nonempty2 = a.a;
						return $elm$core$Tuple$mapFirst$(
							function (b) {
								return b + '*';
							},
							$author$project$AiChat$richTextToMessage$(currentText + '*', list, nonempty2));
					case 4:
						var nonempty2 = a.a;
						return $elm$core$Tuple$mapFirst$(
							function (b) {
								return b + '_';
							},
							$author$project$AiChat$richTextToMessage$(currentText + '_', list, nonempty2));
					case 5:
						var nonempty2 = a.a;
						return $elm$core$Tuple$mapFirst$(
							function (b) {
								return b + '__';
							},
							$author$project$AiChat$richTextToMessage$(currentText + '__', list, nonempty2));
					case 6:
						var nonempty2 = a.a;
						return $elm$core$Tuple$mapFirst$(
							function (b) {
								return b + '~~';
							},
							$author$project$AiChat$richTextToMessage$(currentText + '~~', list, nonempty2));
					case 7:
						var nonempty2 = a.a;
						return $elm$core$Tuple$mapFirst$(
							function (b) {
								return b + '||';
							},
							$author$project$AiChat$richTextToMessage$(currentText + '||', list, nonempty2));
					case 8:
						var b = a.b;
						var _v2 = $mgold$elm_nonempty_list$List$Nonempty$fromList(b);
						if (!_v2.$) {
							var nonempty2 = _v2.a;
							return $author$project$AiChat$richTextToMessage$(currentText + '\u000A> ', list, nonempty2);
						} else {
							return _Utils_Tuple2(currentText, list);
						}
					case 9:
						var level = a.a;
						var nonempty2 = a.c;
						return $author$project$AiChat$richTextToMessage$(
							_Utils_ap(
								currentText,
								function () {
									switch (level) {
										case 0:
											return '\u000A# ';
										case 1:
											return '\u000A## ';
										case 2:
											return '\u000A### ';
										default:
											return '\u000A-# ';
									}
								}()),
							list,
							nonempty2);
					case 10:
						var url = a.a;
						return _Utils_Tuple2(
							'',
							A2(
								$elm$core$List$cons,
								$author$project$AiChat$ImageUrlMessage(
									$elm$url$Url$toString(url)),
								A2(
									$elm$core$List$cons,
									$author$project$AiChat$TextMessage(currentText),
									list)));
					case 11:
						var url = a.b;
						return _Utils_Tuple2(
							'',
							A2(
								$elm$core$List$cons,
								$author$project$AiChat$ImageUrlMessage(
									$elm$url$Url$toString(url)),
								A2(
									$elm$core$List$cons,
									$author$project$AiChat$TextMessage(currentText),
									list)));
					case 12:
						var _char = a.a;
						var rest = a.b;
						return _Utils_Tuple2(
							currentText + ('`' + ($elm$core$String$fromChar(_char) + (rest + '`'))),
							list);
					case 13:
						var string = a.b;
						return _Utils_Tuple2(currentText + ('```' + (string + '```')), list);
					case 14:
						return _Utils_Tuple2(currentText, list);
					case 15:
						var _char = a.a;
						return _Utils_Tuple2(
							currentText + ('\u005C' + $author$project$RichText$escapedCharToString(_char)),
							list);
					case 16:
						return _Utils_Tuple2(currentText, list);
					case 17:
						return _Utils_Tuple2(currentText, list);
					case 18:
						var items = a.b;
						return $elm$core$List$foldl$(
							F2(
								function (bulletItem, _v4) {
									var currentText2 = _v4.a;
									var list2 = _v4.b;
									var _v5 = $mgold$elm_nonempty_list$List$Nonempty$fromList(bulletItem);
									if (!_v5.$) {
										var nonempty2 = _v5.a;
										return $author$project$AiChat$richTextToMessage$(currentText2 + '\u000A* ', list2, nonempty2);
									} else {
										return _Utils_Tuple2(currentText2 + '\u000A* ', list2);
									}
								}),
							_Utils_Tuple2(currentText, list),
							$mgold$elm_nonempty_list$List$Nonempty$toList(items));
					default:
						var time = a.a;
						return _Utils_Tuple2(
							_Utils_ap(
								currentText,
								$author$project$RichText$timestampToDiscordString(time)),
							list);
				}
			}),
		_Utils_Tuple2(previousText, previousList),
		$mgold$elm_nonempty_list$List$Nonempty$toList(nonempty));
};
var $author$project$AiChat$richTextToMessage = F3($author$project$AiChat$richTextToMessage$);
var $author$project$AiChat$chatToMessage = function (text) {
	var _v0 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(text);
	if (!_v0.$) {
		var text2 = _v0.a;
		return function (_v1) {
			var currentText = _v1.a;
			var list = _v1.b;
			return $elm$core$List$reverse(
				A2(
					$elm$core$List$cons,
					$author$project$AiChat$TextMessage(currentText),
					list));
		}(
			$author$project$AiChat$richTextToMessage$(
				'',
				_List_Nil,
				$author$project$RichText$fromNonemptyString$($lamdera$program_test$Effect$Time$utc, $lamdera$containers$SeqDict$empty, $lamdera$containers$SeqDict$empty, text2)));
	} else {
		return _List_Nil;
	}
};
var $author$project$AiChat$getAiModelById$ = function (modelId, model) {
	var _v0 = model.aiModels;
	if (_v0.$ === 1) {
		var aiModels = _v0.a;
		return $elmcraft$core_extra$List$Extra$find$(
			function (aiModel) {
				return _Utils_eq(aiModel.id, modelId);
			},
			aiModels);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$AiChat$getAiModelById = F2($author$project$AiChat$getAiModelById$);
var $author$project$AiChat$getSelectedAiModels = function (model) {
	var _v0 = model.aiModels;
	if (_v0.$ === 1) {
		var aiModels = _v0.a;
		return $elm$core$List$filterMap$(
			function (selected) {
				return $elmcraft$core_extra$List$Extra$find$(
					function (aiModel) {
						return _Utils_eq(aiModel.id, selected);
					},
					aiModels);
			},
			model.selectedModels);
	} else {
		return _List_Nil;
	}
};
var $author$project$AiChat$LocalStorage$ = function (message, chatHistory, pendingResponses, showOptions, selectedModels, sendMessageWith, responseCounter) {
	return {chatHistory: chatHistory, message: message, pendingResponses: pendingResponses, responseCounter: responseCounter, selectedModels: selectedModels, sendMessageWith: sendMessageWith, showOptions: showOptions};
};
var $author$project$AiChat$LocalStorage = F7($author$project$AiChat$LocalStorage$);
var $author$project$AiChat$aiModelCodec = $author$project$Serialize$map$(
	$elm$core$Basics$identity,
	function (_v0) {
		var a = _v0;
		return a;
	},
	$author$project$Serialize$string);
var $author$project$Serialize$bool = $author$project$Serialize$build$(
	function (value) {
		if (value) {
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		} else {
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		}
	},
	$elm$bytes$Bytes$Decode$map$(
		function (value) {
			switch (value) {
				case 0:
					return $elm$core$Result$Ok(false);
				case 1:
					return $elm$core$Result$Ok(true);
				default:
					return $elm$core$Result$Err($author$project$Serialize$DataCorrupted);
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8),
	$elm$json$Json$Encode$bool,
	A2($elm$json$Json$Decode$map, $elm$core$Result$Ok, $elm$json$Json$Decode$bool));
var $author$project$AiChat$GotError$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$AiChat$GotError = F2($author$project$AiChat$GotError$);
var $author$project$AiChat$errorCodec = $author$project$Serialize$finishCustomType(
	A3(
		$author$project$Serialize$variant1,
		$lamdera$program_test$Effect$Http$BadBody,
		$author$project$Serialize$string,
		A3(
			$author$project$Serialize$variant1,
			$lamdera$program_test$Effect$Http$BadStatus,
			$author$project$Serialize$int,
			A2(
				$author$project$Serialize$variant0,
				$lamdera$program_test$Effect$Http$NetworkError,
				A2(
					$author$project$Serialize$variant0,
					$lamdera$program_test$Effect$Http$Timeout,
					A3(
						$author$project$Serialize$variant1,
						$lamdera$program_test$Effect$Http$BadUrl,
						$author$project$Serialize$string,
						$author$project$Serialize$customType(
							F6(
								function (badUrlEncoder, timeoutEncoder, networkErrorEncoder, badStatusEncoder, badBodyEncoder, value) {
									switch (value.$) {
										case 0:
											var arg0 = value.a;
											return badUrlEncoder(arg0);
										case 1:
											return timeoutEncoder;
										case 2:
											return networkErrorEncoder;
										case 3:
											var arg0 = value.a;
											return badStatusEncoder(arg0);
										default:
											var arg0 = value.a;
											return badBodyEncoder(arg0);
									}
								}))))))));
var $elm$bytes$Bytes$Decode$map4$ = function (func, _v0, _v1, _v2, _v3) {
	var decodeA = _v0;
	var decodeB = _v1;
	var decodeC = _v2;
	var decodeD = _v3;
	return F2(
		function (bites, offset) {
			var _v4 = A2(decodeA, bites, offset);
			var aOffset = _v4.a;
			var a = _v4.b;
			var _v5 = A2(decodeB, bites, aOffset);
			var bOffset = _v5.a;
			var b = _v5.b;
			var _v6 = A2(decodeC, bites, bOffset);
			var cOffset = _v6.a;
			var c = _v6.b;
			var _v7 = A2(decodeD, bites, cOffset);
			var dOffset = _v7.a;
			var d = _v7.b;
			return _Utils_Tuple2(
				dOffset,
				A4(func, a, b, c, d));
		});
};
var $elm$bytes$Bytes$Decode$map4 = F5($elm$bytes$Bytes$Decode$map4$);
var $author$project$Serialize$result4$ = function (ctor, v1, v2, v3, v4) {
	var _v0 = $bburdette$toop$Toop$T4$(v1, v2, v3, v4);
	if (!_v0.a.$) {
		if (!_v0.b.$) {
			if (!_v0.c.$) {
				if (!_v0.d.$) {
					var ok1 = _v0.a.a;
					var ok2 = _v0.b.a;
					var ok3 = _v0.c.a;
					var ok4 = _v0.d.a;
					return $elm$core$Result$Ok(
						A4(ctor, ok1, ok2, ok3, ok4));
				} else {
					var err = _v0.d.a;
					return $elm$core$Result$Err(err);
				}
			} else {
				var err = _v0.c.a;
				return $elm$core$Result$Err(err);
			}
		} else {
			var err = _v0.b.a;
			return $elm$core$Result$Err(err);
		}
	} else {
		var err = _v0.a.a;
		return $elm$core$Result$Err(err);
	}
};
var $author$project$Serialize$result4 = F5($author$project$Serialize$result4$);
var $author$project$Serialize$variant4$ = function (ctor, m1, m2, m3, m4) {
	return A4(
		$author$project$Serialize$variant,
		F5(
			function (c, v1, v2, v3, v4) {
				return c(
					_List_fromArray(
						[
							A2($author$project$Serialize$getBytesEncoderHelper, m1, v1),
							A2($author$project$Serialize$getBytesEncoderHelper, m2, v2),
							A2($author$project$Serialize$getBytesEncoderHelper, m3, v3),
							A2($author$project$Serialize$getBytesEncoderHelper, m4, v4)
						]));
			}),
		F5(
			function (c, v1, v2, v3, v4) {
				return c(
					_List_fromArray(
						[
							A2($author$project$Serialize$getJsonEncoderHelper, m1, v1),
							A2($author$project$Serialize$getJsonEncoderHelper, m2, v2),
							A2($author$project$Serialize$getJsonEncoderHelper, m3, v3),
							A2($author$project$Serialize$getJsonEncoderHelper, m4, v4)
						]));
			}),
		$elm$bytes$Bytes$Decode$map4$(
			$author$project$Serialize$result4(ctor),
			$author$project$Serialize$getBytesDecoderHelper(m1),
			$author$project$Serialize$getBytesDecoderHelper(m2),
			$author$project$Serialize$getBytesDecoderHelper(m3),
			$author$project$Serialize$getBytesDecoderHelper(m4)),
		A5(
			$elm$json$Json$Decode$map4,
			$author$project$Serialize$result4(ctor),
			A2(
				$elm$json$Json$Decode$index,
				1,
				$author$project$Serialize$getJsonDecoderHelper(m1)),
			A2(
				$elm$json$Json$Decode$index,
				2,
				$author$project$Serialize$getJsonDecoderHelper(m2)),
			A2(
				$elm$json$Json$Decode$index,
				3,
				$author$project$Serialize$getJsonDecoderHelper(m3)),
			A2(
				$elm$json$Json$Decode$index,
				4,
				$author$project$Serialize$getJsonDecoderHelper(m4))));
};
var $author$project$Serialize$variant4 = F5($author$project$Serialize$variant4$);
var $author$project$AiChat$pendingResponseCodec = $author$project$Serialize$finishCustomType(
	A4(
		$author$project$Serialize$variant2,
		$author$project$AiChat$GotError,
		$author$project$AiChat$aiModelCodec,
		$author$project$AiChat$errorCodec,
		A6(
			$author$project$Serialize$variant4,
			$author$project$AiChat$GotResponse,
			$author$project$AiChat$aiModelCodec,
			$author$project$Serialize$string,
			$author$project$Serialize$maybe($author$project$Serialize$string),
			$author$project$Serialize$maybe($author$project$Serialize$float),
			A3(
				$author$project$Serialize$variant1,
				$author$project$AiChat$Pending,
				$author$project$AiChat$aiModelCodec,
				$author$project$Serialize$customType(
					F4(
						function (pendingEncoder, gotResponseEncoder, gotErrorEncoder, value) {
							switch (value.$) {
								case 0:
									var arg0 = value.a;
									return pendingEncoder(arg0);
								case 1:
									var argA = value.a;
									var argB = value.b;
									var argC = value.c;
									var argD = value.d;
									return A4(gotResponseEncoder, argA, argB, argC, argD);
								default:
									var argA = value.a;
									var argB = value.b;
									return A2(gotErrorEncoder, argA, argB);
							}
						}))))));
var $author$project$AiChat$responseIdCodec = $author$project$Serialize$finishCustomType(
	A3(
		$author$project$Serialize$variant1,
		$elm$core$Basics$identity,
		$author$project$Serialize$int,
		$author$project$Serialize$customType(
			F2(
				function (respondIdEncoder, value) {
					var arg0 = value;
					return respondIdEncoder(arg0);
				}))));
var $author$project$AiChat$SendWithEnter = 0;
var $author$project$AiChat$sendMessageWithCodec = $author$project$Serialize$enum$(
	0,
	_List_fromArray(
		[1]));
var $author$project$AiChat$seqDictCodec$ = function (keyCodec, valueCodec) {
	return $author$project$Serialize$map$(
		$lamdera$containers$SeqDict$fromList,
		$lamdera$containers$SeqDict$toList,
		$author$project$Serialize$list(
			$author$project$Serialize$tuple$(keyCodec, valueCodec)));
};
var $author$project$AiChat$seqDictCodec = F2($author$project$AiChat$seqDictCodec$);
var $author$project$AiChat$localStorageCodec = $author$project$Serialize$finishRecord(
	$author$project$Serialize$field$(
		function ($) {
			return $.responseCounter;
		},
		$author$project$Serialize$int,
		$author$project$Serialize$field$(
			function ($) {
				return $.sendMessageWith;
			},
			$author$project$AiChat$sendMessageWithCodec,
			$author$project$Serialize$field$(
				function ($) {
					return $.selectedModels;
				},
				$author$project$Serialize$list($author$project$AiChat$aiModelCodec),
				$author$project$Serialize$field$(
					function ($) {
						return $.showOptions;
					},
					$author$project$Serialize$bool,
					$author$project$Serialize$field$(
						function ($) {
							return $.pendingResponses;
						},
						$author$project$AiChat$seqDictCodec$($author$project$AiChat$responseIdCodec, $author$project$AiChat$pendingResponseCodec),
						$author$project$Serialize$field$(
							function ($) {
								return $.chatHistory;
							},
							$author$project$Serialize$string,
							$author$project$Serialize$field$(
								function ($) {
									return $.message;
								},
								$author$project$Serialize$string,
								$author$project$Serialize$record($author$project$AiChat$LocalStorage)))))))));
var $author$project$AiChat$maxModels = 3;
var $author$project$AiChat$pendingResponseModelId = function (response) {
	switch (response.$) {
		case 0:
			var modelId = response.a;
			return modelId;
		case 1:
			var modelId = response.a;
			return modelId;
		default:
			var modelId = response.a;
			return modelId;
	}
};
var $author$project$AiChat$prefixWrapper = function (prefix) {
	return '\u000A\u000A' + (prefix + '\u000A');
};
var $author$project$AiChat$responseContainerId = function (_v0) {
	var responseId = _v0;
	return $lamdera$program_test$Effect$Browser$Dom$id(
		'responseContainer_' + $elm$core$String$fromInt(responseId));
};
var $author$project$AiChat$modelToLocalStorage = function (model) {
	return {chatHistory: model.chatHistory, message: model.message, pendingResponses: model.pendingResponses, responseCounter: model.responseCounter, selectedModels: model.selectedModels, sendMessageWith: model.sendMessageWith, showOptions: model.showOptions};
};
var $author$project$AiChat$save_user_settings_to_js = _Platform_outgoingPort('save_user_settings_to_js', $elm$core$Basics$identity);
var $author$project$AiChat$saveUserSettingsToJs = function (text) {
	return A3(
		$lamdera$program_test$Effect$Command$sendToJs,
		'save_user_settings_to_js',
		$author$project$AiChat$save_user_settings_to_js,
		$elm$json$Json$Encode$string(text));
};
var $author$project$AiChat$saveToLocalStorage = function (model) {
	return _Utils_Tuple2(
		model,
		$author$project$AiChat$saveUserSettingsToJs(
			A2(
				$author$project$Serialize$encodeToString,
				$author$project$AiChat$localStorageCodec,
				$author$project$AiChat$modelToLocalStorage(model))));
};
var $author$project$AiChat$chatHistoryId = $lamdera$program_test$Effect$Browser$Dom$id('chat-history');
var $author$project$AiChat$scrollToBottom = $lamdera$program_test$Effect$Task$attempt$(
	function (_v0) {
		return $author$project$AiChat$NoOp;
	},
	$lamdera$program_test$Effect$Browser$Dom$setViewportOf$($author$project$AiChat$chatHistoryId, 0, 999999));
var $author$project$AiChat$scrollToTop = function (id) {
	return $lamdera$program_test$Effect$Task$attempt$(
		function (_v0) {
			return $author$project$AiChat$NoOp;
		},
		$lamdera$program_test$Effect$Browser$Dom$setViewportOf$(id, 0, 0));
};
var $author$project$AiChat$CheckDebounce = function (a) {
	return {$: 13, a: a};
};
var $author$project$AiChat$startDebounceSave = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{debounceCounter: model.debounceCounter + 1}),
		$lamdera$program_test$Effect$Task$perform$(
			function (_v0) {
				return $author$project$AiChat$CheckDebounce(model.debounceCounter + 1);
			},
			$lamdera$program_test$Effect$Process$sleep(
				$ianmackenzie$elm_units$Duration$seconds(0.5))));
};
var $elm$core$String$trimLeft = _String_trimLeft;
var $elm$core$String$trimRight = _String_trimRight;
var $author$project$AiChat$userPrefix = '[user]';
var $author$project$AiChat$update$ = function (msg, model) {
	switch (msg.$) {
		case 0:
			var message = msg.a;
			return $author$project$AiChat$startDebounceSave(
				_Utils_update(
					model,
					{message: message}));
		case 1:
			var aiModelsToSend = $author$project$AiChat$getSelectedAiModels(model);
			if ((!$elm$core$List$isEmpty(aiModelsToSend)) && (_Utils_cmp(
				$lamdera$containers$SeqDict$size(model.pendingResponses) + $elm$core$List$length(aiModelsToSend),
				$author$project$AiChat$maxModels) < 1)) {
				var newChatHistory = ($elm$core$String$trim(model.message) === '') ? model.chatHistory : $elm$core$String$trimLeft(
					_Utils_ap(
						$elm$core$String$trimRight(model.chatHistory),
						_Utils_ap(
							$author$project$AiChat$prefixWrapper($author$project$AiChat$userPrefix),
							_Utils_ap(
								$elm$core$String$trim(model.message),
								$author$project$AiChat$prefixWrapper($author$project$AiChat$botPrefix)))));
				var indexedModels = $elm$core$List$indexedMap$($elm$core$Tuple$pair, aiModelsToSend);
				var newPendings = $elm$core$List$foldl$(
					F2(
						function (_v2, acc) {
							var i = _v2.a;
							var aiModel = _v2.b;
							return $lamdera$containers$SeqDict$insert$(
								model.responseCounter + i,
								$author$project$AiChat$Pending(aiModel.id),
								acc);
						}),
					model.pendingResponses,
					indexedModels);
				var requestCmds = $elm$core$List$map$(
					function (_v1) {
						var i = _v1.a;
						var aiModel = _v1.b;
						var responseId = model.responseCounter + i;
						return $lamdera$program_test$Effect$Lamdera$sendToBackend(
							$elm$core$List$member$('image', aiModel.inputs) ? $author$project$AiChat$AiMessageRequest$(
								aiModel.id,
								responseId,
								$author$project$AiChat$chatToMessage(newChatHistory)) : $author$project$AiChat$AiMessageRequestSimple$(aiModel.id, responseId, newChatHistory));
					},
					indexedModels);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							chatHistory: newChatHistory,
							message: '',
							pendingResponses: newPendings,
							responseCounter: model.responseCounter + $elm$core$List$length(aiModelsToSend)
						}),
					$lamdera$program_test$Effect$Command$batch(
						A2($elm$core$List$cons, $author$project$AiChat$scrollToBottom, requestCmds)));
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 2:
			var text = msg.a;
			return $author$project$AiChat$startDebounceSave(
				_Utils_update(
					model,
					{chatHistory: text}));
		case 3:
			var responseId = msg.a;
			var _v3 = $lamdera$containers$SeqDict$get$(responseId, model.pendingResponses);
			if ((!_v3.$) && (_v3.a.$ === 1)) {
				var _v4 = _v3.a;
				var text = _v4.b;
				return $elm$core$Tuple$mapSecond$(
					function (cmd) {
						return $lamdera$program_test$Effect$Command$batch(
							_List_fromArray(
								[$author$project$AiChat$scrollToBottom, cmd]));
					},
					$author$project$AiChat$saveToLocalStorage(
						_Utils_update(
							model,
							{
								chatHistory: $elm$core$String$trim(model.chatHistory) + ('\u000A' + text),
								pendingResponses: $lamdera$containers$SeqDict$empty
							})));
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 4:
			var responseId = msg.a;
			return $author$project$AiChat$saveToLocalStorage(
				_Utils_update(
					model,
					{
						pendingResponses: $lamdera$containers$SeqDict$remove$(responseId, model.pendingResponses)
					}));
		case 5:
			var responseId = msg.a;
			var _v5 = $lamdera$containers$SeqDict$get$(responseId, model.pendingResponses);
			if (!_v5.$) {
				var pendingResponse = _v5.a;
				var modelId = $author$project$AiChat$pendingResponseModelId(pendingResponse);
				var _v6 = $author$project$AiChat$getAiModelById$(modelId, model);
				if (!_v6.$) {
					var aiModel = _v6.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								pendingResponses: $lamdera$containers$SeqDict$insert$(
									responseId,
									$author$project$AiChat$Pending(modelId),
									model.pendingResponses)
							}),
						$lamdera$program_test$Effect$Command$batch(
							_List_fromArray(
								[
									$lamdera$program_test$Effect$Lamdera$sendToBackend(
									$elm$core$List$member$('image', aiModel.inputs) ? $author$project$AiChat$AiMessageRequest$(
										aiModel.id,
										responseId,
										$author$project$AiChat$chatToMessage(model.chatHistory)) : $author$project$AiChat$AiMessageRequestSimple$(aiModel.id, responseId, model.chatHistory)),
									$author$project$AiChat$scrollToTop(
									$author$project$AiChat$responseContainerId(responseId))
								])));
				} else {
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				}
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 6:
			return _Utils_Tuple2(
				model,
				$lamdera$program_test$Effect$Task$attempt$(
					function (_v7) {
						return $author$project$AiChat$NoOp;
					},
					$lamdera$program_test$Effect$Browser$Dom$focus($author$project$AiChat$chatHistoryInputId)));
		case 7:
			return $author$project$AiChat$saveToLocalStorage(
				_Utils_update(
					model,
					{chatHistory: ''}));
		case 8:
			return $author$project$AiChat$saveToLocalStorage(
				_Utils_update(
					model,
					{showOptions: !model.showOptions}));
		case 9:
			var index = msg.a;
			var aiModel = msg.b;
			return $author$project$AiChat$saveToLocalStorage(
				_Utils_update(
					model,
					{
						selectedModels: (_Utils_cmp(
							index,
							$elm$core$List$length(model.selectedModels)) > -1) ? _Utils_ap(
							model.selectedModels,
							_List_fromArray(
								[aiModel])) : $elm$core$List$indexedMap$(
							F2(
								function (i, existing) {
									return _Utils_eq(i, index) ? aiModel : existing;
								}),
							model.selectedModels)
					}));
		case 10:
			if (_Utils_cmp(
				$elm$core$List$length(model.selectedModels),
				$author$project$AiChat$maxModels) < 0) {
				var defaultModel = function () {
					var _v9 = $elm$core$List$reverse(model.selectedModels);
					if (_v9.b) {
						var last = _v9.a;
						return $elm$core$Maybe$Just(last);
					} else {
						var _v10 = model.aiModels;
						if ((_v10.$ === 1) && _v10.a.b) {
							var _v11 = _v10.a;
							var first = _v11.a;
							return $elm$core$Maybe$Just(first.id);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}
				}();
				if (!defaultModel.$) {
					var newModel = defaultModel.a;
					return $author$project$AiChat$saveToLocalStorage(
						_Utils_update(
							model,
							{
								selectedModels: _Utils_ap(
									model.selectedModels,
									_List_fromArray(
										[newModel]))
							}));
				} else {
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				}
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 11:
			var index = msg.a;
			return $author$project$AiChat$saveToLocalStorage(
				_Utils_update(
					model,
					{
						selectedModels: $elm$core$List$filterMap$(
							function (_v12) {
								var i = _v12.a;
								var existing = _v12.b;
								return _Utils_eq(i, index) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(existing);
							},
							$elm$core$List$indexedMap$($elm$core$Tuple$pair, model.selectedModels))
					}));
		case 12:
			var sendMessageWith = msg.a;
			return $author$project$AiChat$saveToLocalStorage(
				_Utils_update(
					model,
					{sendMessageWith: sendMessageWith}));
		case 13:
			var counter = msg.a;
			return _Utils_eq(counter, model.debounceCounter) ? $author$project$AiChat$saveToLocalStorage(model) : _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
		case 14:
			var text = msg.a;
			var _v13 = $author$project$Serialize$decodeFromString$($author$project$AiChat$localStorageCodec, text);
			if (!_v13.$) {
				var ok = _v13.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{chatHistory: ok.chatHistory, message: ok.message, pendingResponses: ok.pendingResponses, responseCounter: ok.responseCounter, selectedModels: ok.selectedModels, sendMessageWith: ok.sendMessageWith, showOptions: ok.showOptions}),
					$author$project$AiChat$scrollToBottom);
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 15:
			var responseId = msg.a;
			var text = msg.b;
			return $author$project$AiChat$startDebounceSave(
				_Utils_update(
					model,
					{
						pendingResponses: $lamdera$containers$SeqDict$updateIfExists$(
							responseId,
							function (response) {
								switch (response.$) {
									case 1:
										var modelId = response.a;
										var reasoning = response.c;
										var cost = response.d;
										return $author$project$AiChat$GotResponse$(modelId, text, reasoning, cost);
									case 0:
										return response;
									default:
										return response;
								}
							},
							model.pendingResponses)
					}));
		case 16:
			return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
		default:
			var result = msg.a;
			return _Utils_Tuple2(
				function () {
					if (!result.$) {
						var ok = result.a;
						return _Utils_update(
							model,
							{
								aiModels: $author$project$AiChat$LoadedAiModels(
									A2(
										$elm$core$List$sortBy,
										function (a) {
											return $author$project$AiChat$aiModelNameToString(a.id);
										},
										ok)),
								selectedModels: ($elm$core$List$any$(
									function (a) {
										return a.id === 'anthropic/claude-sonnet-4';
									},
									ok) && $elm$core$List$isEmpty(model.selectedModels)) ? _List_fromArray(
									['anthropic/claude-sonnet-4']) : model.selectedModels
							});
					} else {
						var err = result.a;
						return _Utils_update(
							model,
							{
								aiModels: $author$project$AiChat$LoadingFailed(err)
							});
					}
				}(),
				$lamdera$program_test$Effect$Command$none);
	}
};
var $author$project$AiChat$update = F2($author$project$AiChat$update$);
var $author$project$Go$Action = function (a) {
	return {$: 1, a: a};
};
var $author$project$Game$CopyText = function (a) {
	return {$: 1, a: a};
};
var $author$project$Game$CreatePublicLink$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Game$CreatePublicLink = F2($author$project$Game$CreatePublicLink$);
var $author$project$Game$FetchWordDefinition = function (a) {
	return {$: 5, a: a};
};
var $author$project$Game$GoModel_Setup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Go$Joined = function (a) {
	return {$: 6, a: a};
};
var $author$project$Game$LocalChange_Go$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Game$LocalChange_Go = F2($author$project$Game$LocalChange_Go$);
var $author$project$Game$OpenSheepGameReactionEmojiSelector$ = function (a, b, c) {
	return {$: 11, a: a, b: b, c: c};
};
var $author$project$Game$OpenSheepGameReactionEmojiSelector = F3($author$project$Game$OpenSheepGameReactionEmojiSelector$);
var $author$project$Game$OpenWordSpellingGameReactionEmojiSelector$ = function (a, b, c) {
	return {$: 12, a: a, b: b, c: c};
};
var $author$project$Game$OpenWordSpellingGameReactionEmojiSelector = F3($author$project$Game$OpenWordSpellingGameReactionEmojiSelector$);
var $author$project$Game$OutLocalChange = function (a) {
	return {$: 0, a: a};
};
var $author$project$Game$OutReplyToGame$ = function (a, b) {
	return {$: 6, a: a, b: b};
};
var $author$project$Game$OutReplyToGame = F2($author$project$Game$OutReplyToGame$);
var $author$project$Game$OutSelectMatch = function (a) {
	return {$: 2, a: a};
};
var $author$project$Game$SaveSheepGameInputAfterDelay$ = function (a, b, c, d) {
	return {$: 9, a: a, b: b, c: c, d: d};
};
var $author$project$Game$SaveSheepGameInputAfterDelay = F4($author$project$Game$SaveSheepGameInputAfterDelay$);
var $author$project$Game$SaveSheepGameQuestions = function (a) {
	return {$: 7, a: a};
};
var $author$project$Game$SaveSheepGameQuestionsAfterDelay$ = function (a, b) {
	return {$: 8, a: a, b: b};
};
var $author$project$Game$SaveSheepGameQuestionsAfterDelay = F2($author$project$Game$SaveSheepGameQuestionsAfterDelay$);
var $author$project$Game$ScrollToBottom = function (a) {
	return {$: 3, a: a};
};
var $author$project$Game$SheepGame_Setup = function (a) {
	return {$: 3, a: a};
};
var $author$project$Game$SmoothScrollTo = function (a) {
	return {$: 4, a: a};
};
var $author$project$Go$StartMatch$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Go$StartMatch = F2($author$project$Go$StartMatch$);
var $author$project$WordSpellingGame$StartMatch$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$WordSpellingGame$StartMatch = F2($author$project$WordSpellingGame$StartMatch$);
var $author$project$Game$WordSpellingGame_Setup = function (a) {
	return {$: 2, a: a};
};
var $author$project$SheepGame$AnswerInput = function (a) {
	return {$: 1, a: a};
};
var $author$project$SheepGame$NotesInput = function (a) {
	return {$: 2, a: a};
};
var $author$project$SheepGame$changedDrafts$ = function (toInput, before, after) {
	return $elm$core$List$filterMap$(
		$elm$core$Basics$identity,
		$author$project$IdArray$toList(
			$author$project$IdArray$map$(
				F2(
					function (questionId, draft) {
						return _Utils_eq(
							$author$project$IdArray$get$(questionId, before),
							$elm$core$Maybe$Just(draft)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							toInput(questionId));
					}),
				after)));
};
var $author$project$SheepGame$changedDrafts = F3($author$project$SheepGame$changedDrafts$);
var $author$project$SheepGame$changedInputs$ = function (before, after) {
	return _Utils_ap(
		$author$project$SheepGame$changedDrafts$($author$project$SheepGame$AnswerInput, before.answerDrafts, after.answerDrafts),
		$author$project$SheepGame$changedDrafts$($author$project$SheepGame$NotesInput, before.noteDrafts, after.noteDrafts));
};
var $author$project$SheepGame$changedInputs = F2($author$project$SheepGame$changedInputs$);
var $author$project$Go$Standard9 = 0;
var $author$project$Go$initSetup = {error: $elm$core$Maybe$Nothing, gameCreatorPlayingAs: 0, handicapInput: '0', heightInput: '9', incrementInput: '5', komiInput: '6.5', mainTimeInput: '10', sizeSelection: 0, widthInput: '9'};
var $author$project$SheepGame$initSetup = {
	error: $elm$core$Maybe$Nothing,
	pressedSubmit: false,
	questions: $author$project$IdArray$fromList(
		_List_fromArray(
			[
				{attachedFiles: $lamdera$containers$SeqDict$empty, text: 'Pick a random number between 1 and 10'},
				{attachedFiles: $lamdera$containers$SeqDict$empty, text: 'What\u0027s your favorite color?'}
			]))
};
var $author$project$WordSpellingGame$English = 0;
var $author$project$WordSpellingGame$defaultFullTrayBonus = 50;
var $author$project$WordSpellingGame$defaultLetters = function (language) {
	if (!language) {
		return '  AAAAAAAAABBCCDDDDEEEEEEEEEEEEFFGGGHHIIIIIIIIIJKLLLLMMNNNNNNOOOOOOOOPPQRRRRRRSSSSTTTTTTUUUUVVWWXYYZ';
	} else {
		return '  AAAAAAAAABBCCDDDDDDDEEEEEEEEFFGGGGHHHIIIIIIJKKKLLLLLLLMMMNNNNNNNOOOOOPPPQRRRRRRRRRSSSSSSSSTTTTTTTUUUVVXYYZÅÅÄÄÖÖ';
	}
};
var $author$project$OneOrGreater$three = 3;
var $author$project$WordSpellingGame$initSetup = {
	advancedSettingsExpanded: false,
	error: $elm$core$Maybe$Nothing,
	fullTrayBonus: $author$project$WordSpellingGame$defaultFullTrayBonus,
	incrementInput: '5',
	language: 0,
	letterValues: $lamdera$containers$SeqDict$empty,
	letters: $author$project$WordSpellingGame$defaultLetters(0),
	mainTimeInput: '10',
	placeWordAttempts: $author$project$OneOrGreater$three,
	traySize: 7
};
var $author$project$SheepGame$initSetupFromSavedQuestions = function (questions) {
	return $author$project$IdArray$isEmpty(questions) ? $author$project$SheepGame$initSetup : {error: $elm$core$Maybe$Nothing, pressedSubmit: false, questions: questions};
};
var $author$project$Game$CancelSheepGameAttachedFileUpload$ = function (a, b) {
	return {$: 15, a: a, b: b};
};
var $author$project$Game$CancelSheepGameAttachedFileUpload = F2($author$project$Game$CancelSheepGameAttachedFileUpload$);
var $author$project$Game$OpenSheepGameEmojiSelector = function (a) {
	return {$: 10, a: a};
};
var $author$project$SheepGame$QuestionInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Game$SelectSheepGameFilesToAttach = function (a) {
	return {$: 13, a: a};
};
var $author$project$Game$SetFocus = function (a) {
	return {$: 18, a: a};
};
var $author$project$Game$ShowSheepGameAttachedFileInfo = function (a) {
	return {$: 16, a: a};
};
var $author$project$Game$ShowSheepGameImage = function (a) {
	return {$: 17, a: a};
};
var $author$project$SheepGame$StartMatch$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$SheepGame$StartMatch = F2($author$project$SheepGame$StartMatch$);
var $author$project$Game$UploadSheepGameAttachedFiles$ = function (a, b) {
	return {$: 14, a: a, b: b};
};
var $author$project$Game$UploadSheepGameAttachedFiles = F2($author$project$Game$UploadSheepGameAttachedFiles$);
var $author$project$Game$sheepGameOutMsgs$ = function (time, newMatchId, outMsg) {
	switch (outMsg.$) {
		case 1:
			var setup = outMsg.a;
			return _List_fromArray(
				[
					$author$project$Game$OutLocalChange(
					$author$project$Game$LocalChange_SheepGame$(
						newMatchId,
						$author$project$SheepGame$StartMatch$(time, setup))),
					$author$project$Game$OutSelectMatch(
					$elm$core$Maybe$Just(newMatchId))
				]);
		case 0:
			return _List_Nil;
		case 2:
			var input = outMsg.a;
			return _List_fromArray(
				[
					$author$project$Game$OpenSheepGameEmojiSelector(input)
				]);
		case 3:
			var input = outMsg.a;
			return _List_fromArray(
				[
					$author$project$Game$SelectSheepGameFilesToAttach(input)
				]);
		case 4:
			var input = outMsg.a;
			var files = outMsg.b;
			return _List_fromArray(
				[
					$author$project$Game$UploadSheepGameAttachedFiles$(input, files)
				]);
		case 5:
			var input = outMsg.a;
			var fileId = outMsg.b;
			return _List_fromArray(
				[
					$author$project$Game$CancelSheepGameAttachedFileUpload$(input, fileId)
				]);
		case 6:
			var fileData = outMsg.a;
			return _List_fromArray(
				[
					$author$project$Game$ShowSheepGameAttachedFileInfo(fileData)
				]);
		case 7:
			var htmlId = outMsg.a;
			return _List_fromArray(
				[
					$author$project$Game$SmoothScrollTo(
					{container: $author$project$SheepGame$gameViewId, target: htmlId})
				]);
		case 8:
			return _List_Nil;
		case 9:
			return _List_Nil;
		case 10:
			var pressedImageData = outMsg.a;
			return _List_fromArray(
				[
					$author$project$Game$ShowSheepGameImage(pressedImageData)
				]);
		case 11:
			var text = outMsg.a;
			return _List_fromArray(
				[
					$author$project$Game$CopyText(text)
				]);
		default:
			var questionId = outMsg.a;
			return _List_fromArray(
				[
					$author$project$Game$SetFocus(
					$author$project$SheepGame$inputId(
						$author$project$SheepGame$QuestionInput(questionId)))
				]);
	}
};
var $author$project$Game$sheepGameOutMsgs = F3($author$project$Game$sheepGameOutMsgs$);
var $author$project$SheepGame$revealedQuestionId = function (index) {
	return $lamdera$program_test$Effect$Browser$Dom$id(
		'sheepGame_revealedQuestion_' + $elm$core$String$fromInt(index));
};
var $author$project$SheepGame$scoringId = $lamdera$program_test$Effect$Browser$Dom$id('sheepGame_scoring');
var $author$project$SheepGame$revealedSectionId = function (questionsRevealed) {
	return (questionsRevealed <= 1) ? $author$project$SheepGame$scoringId : $author$project$SheepGame$revealedQuestionId(questionsRevealed - 2);
};
var $author$project$SheepGame$questionRevealed$ = function (questionsRevealed, model) {
	return (_Utils_cmp(questionsRevealed, model.questionsRevealedSeen) > 0) ? _Utils_Tuple2(
		_Utils_update(
			model,
			{newQuestionRevealed: !(!model.scrollPosition), questionsRevealedSeen: questionsRevealed}),
		function () {
			var _v0 = model.scrollPosition;
			switch (_v0) {
				case 0:
					return $elm$core$Maybe$Just(
						$author$project$SheepGame$revealedSectionId(questionsRevealed));
				case 1:
					return $elm$core$Maybe$Nothing;
				case 2:
					return $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		}()) : _Utils_Tuple2(
		_Utils_update(
			model,
			{questionsRevealedSeen: questionsRevealed}),
		$elm$core$Maybe$Nothing);
};
var $author$project$SheepGame$questionRevealed = F2($author$project$SheepGame$questionRevealed$);
var $author$project$Game$sheepGameQuestionRevealed$ = function (matchId, questionsRevealed, model) {
	var _v0 = $lamdera$containers$SeqDict$get$(matchId, model.startedGames);
	if ((!_v0.$) && (_v0.a.$ === 2)) {
		var gameData = _v0.a.a;
		var _v1 = $author$project$SheepGame$questionRevealed$(questionsRevealed, gameData);
		var gameData2 = _v1.a;
		var maybeTarget = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					startedGames: $lamdera$containers$SeqDict$insert$(
						matchId,
						$author$project$Game$SheepGame_Game(gameData2),
						model.startedGames)
				}),
			$elm$core$Maybe$map$(
				function (target) {
					return {container: $author$project$SheepGame$gameViewId, target: target};
				},
				maybeTarget));
	} else {
		return _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
	}
};
var $author$project$Game$sheepGameQuestionRevealed = F3($author$project$Game$sheepGameQuestionRevealed$);
var $author$project$Game$sheepGameReplyTarget = function (target) {
	if (!target.$) {
		var userId = target.a;
		var questionId = target.b;
		return $author$project$Message$RepliedTo_SheepGameAnswer$(userId, questionId);
	} else {
		var questionId = target.a;
		return $author$project$Message$RepliedTo_SheepGameNotes(questionId);
	}
};
var $author$project$Go$AcceptTerritory = {$: 4};
var $author$project$Go$FinishedMarking = {$: 3};
var $author$project$Go$MarkTerritory$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Go$MarkTerritory = F2($author$project$Go$MarkTerritory$);
var $author$project$Go$PassTurn = {$: 1};
var $author$project$Go$PlaceStone$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Go$PlaceStone = F2($author$project$Go$PlaceStone$);
var $author$project$Go$RejectTerritory = {$: 5};
var $author$project$Go$getPlayers$ = function (setup, shared) {
	var _v0 = setup.gameCreatorPlayingAs;
	if (_v0 === 1) {
		return {
			black: shared.joinedUserId,
			white: $elm$core$Maybe$Just(setup.createdBy)
		};
	} else {
		return {
			black: $elm$core$Maybe$Just(setup.createdBy),
			white: shared.joinedUserId
		};
	}
};
var $author$project$Go$getPlayers = F2($author$project$Go$getPlayers$);
var $author$project$Go$isLocalUsersTurn$ = function (currentUserId, setup, shared) {
	var _v0 = shared.phase;
	if (_v0.$ === 3) {
		return false;
	} else {
		var players = $author$project$Go$getPlayers$(setup, shared);
		var _v1 = shared.currentPlayer;
		if (!_v1) {
			return _Utils_eq(
				players.black,
				$elm$core$Maybe$Just(currentUserId));
		} else {
			return _Utils_eq(
				players.white,
				$elm$core$Maybe$Just(currentUserId));
		}
	}
};
var $author$project$Go$isLocalUsersTurn = F3($author$project$Go$isLocalUsersTurn$);
var $author$project$Go$isViewingPast = function (model) {
	return model.viewingMovesBack > 0;
};
var $author$project$Go$jumpToLatest = function (model) {
	return _Utils_update(
		model,
		{lastError: $elm$core$Maybe$Nothing, viewingMovesBack: 0});
};
var $author$project$Go$updateSpectator$ = function (msg, state, model) {
	switch (msg.$) {
		case 2:
			var moveNumber = msg.a;
			var total = $elm$core$List$length(state.history);
			var clamped = $elm$core$Basics$clamp$(0, total, moveNumber);
			return _Utils_update(
				model,
				{lastError: $elm$core$Maybe$Nothing, viewingMovesBack: total - clamped});
		case 0:
			return $author$project$Go$stepBack$(state, model);
		case 1:
			return $author$project$Go$stepForward(model);
		default:
			return model;
	}
};
var $author$project$Go$updateSpectator = F3($author$project$Go$updateSpectator$);
var $author$project$Go$updateGame$ = function (currentTime, currentUserId, msg, setup, state, model) {
	switch (msg.$) {
		case 0:
			var _v1 = msg.a;
			var x = _v1.a;
			var y = _v1.b;
			if ($author$project$Go$isViewingPast(model)) {
				return _Utils_Tuple2(
					$author$project$Go$jumpToLatest(model),
					$elm$core$Maybe$Nothing);
			} else {
				var _v2 = state.phase;
				switch (_v2.$) {
					case 0:
						if ($author$project$Go$isLocalUsersTurn$(currentUserId, setup, state) && $author$project$Go$hasTimeToDoAction$(currentTime, state)) {
							var _v3 = $author$project$Go$tryPlace$(setup, x, y, state);
							if (!_v3.$) {
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											lastPlacedStone: $elm$core$Maybe$Just(currentTime)
										}),
									$elm$core$Maybe$Just(
										{
											change: $author$project$Go$PlaceStone$(x, y),
											time: currentTime
										}));
							} else {
								var error = _v3.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											lastError: $elm$core$Maybe$Just(error)
										}),
									$elm$core$Maybe$Nothing);
							}
						} else {
							return _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
						}
					case 1:
						return $author$project$Go$isLocalUsersTurn$(currentUserId, setup, state) ? _Utils_Tuple2(
							model,
							$elm$core$Maybe$Just(
								{
									change: $author$project$Go$MarkTerritory$(x, y),
									time: currentTime
								})) : _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
					case 2:
						return _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
					default:
						return _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
				}
			}
		case 1:
			if ($author$project$Go$isViewingPast(model)) {
				return _Utils_Tuple2(
					$author$project$Go$jumpToLatest(model),
					$elm$core$Maybe$Nothing);
			} else {
				var _v4 = _Utils_Tuple2(
					state.phase,
					$author$project$Go$hasTimeToDoAction$(currentTime, state));
				if ((!_v4.a.$) && _v4.b) {
					return $author$project$Go$isLocalUsersTurn$(currentUserId, setup, state) ? _Utils_Tuple2(
						model,
						$elm$core$Maybe$Just(
							{change: $author$project$Go$PassTurn, time: currentTime})) : _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
				} else {
					return _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
				}
			}
		case 2:
			var _v5 = state.phase;
			if (_v5.$ === 1) {
				return _Utils_Tuple2(
					model,
					$elm$core$Maybe$Just(
						{change: $author$project$Go$FinishedMarking, time: currentTime}));
			} else {
				return _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
			}
		case 3:
			var _v6 = state.phase;
			if (_v6.$ === 2) {
				return _Utils_Tuple2(
					model,
					$elm$core$Maybe$Just(
						{change: $author$project$Go$AcceptTerritory, time: currentTime}));
			} else {
				return _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
			}
		case 4:
			var _v7 = state.phase;
			if (_v7.$ === 2) {
				return _Utils_Tuple2(
					model,
					$elm$core$Maybe$Just(
						{change: $author$project$Go$RejectTerritory, time: currentTime}));
			} else {
				return _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
			}
		case 5:
			return _Utils_eq(state.joinedUserId, $elm$core$Maybe$Nothing) ? _Utils_Tuple2(
				model,
				$elm$core$Maybe$Just(
					{
						change: $author$project$Go$Joined(currentUserId),
						time: currentTime
					})) : _Utils_Tuple2(model, $elm$core$Maybe$Nothing);
		default:
			var spectatorMsg = msg.a;
			return _Utils_Tuple2(
				$author$project$Go$updateSpectator$(spectatorMsg, state, model),
				$elm$core$Maybe$Nothing);
	}
};
var $author$project$Go$updateGame = F6($author$project$Go$updateGame$);
var $author$project$SheepGame$CancelAttachedFileUpload$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$SheepGame$CancelAttachedFileUpload = F2($author$project$SheepGame$CancelAttachedFileUpload$);
var $author$project$SheepGame$ChangedGroup$ = function (a, b, c) {
	return {$: 3, a: a, b: b, c: c};
};
var $author$project$SheepGame$ChangedGroup = F3($author$project$SheepGame$ChangedGroup$);
var $author$project$SheepGame$ChangedQuestionsRevealed = function (a) {
	return {$: 6, a: a};
};
var $author$project$SheepGame$CopyText = function (a) {
	return {$: 11, a: a};
};
var $author$project$SheepGame$FinishedGrouping = {$: 5};
var $author$project$SheepGame$LockedAnswers = {$: 1};
var $author$project$SheepGame$NoOutMsg = {$: 0};
var $author$project$SheepGame$OpenEmojiSelector = function (a) {
	return {$: 2, a: a};
};
var $author$project$SheepGame$OpenReactionEmojiSelector = function (a) {
	return {$: 8, a: a};
};
var $author$project$SheepGame$RemovedReaction$ = function (a, b) {
	return {$: 8, a: a, b: b};
};
var $author$project$SheepGame$RemovedReaction = F2($author$project$SheepGame$RemovedReaction$);
var $author$project$SheepGame$ReplyToResult = function (a) {
	return {$: 9, a: a};
};
var $author$project$SheepGame$ScrollResultsTo = function (a) {
	return {$: 7, a: a};
};
var $author$project$SheepGame$SelectFilesToAttach = function (a) {
	return {$: 3, a: a};
};
var $author$project$SheepGame$ShowAttachedFileInfo = function (a) {
	return {$: 6, a: a};
};
var $author$project$SheepGame$ShowImage = function (a) {
	return {$: 10, a: a};
};
var $author$project$SheepGame$UnlockedAnswers = {$: 2};
var $author$project$SheepGame$UploadAttachedFiles$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $author$project$SheepGame$UploadAttachedFiles = F2($author$project$SheepGame$UploadAttachedFiles$);
var $author$project$SheepGame$appendAttachedFiles$ = function (fileIds, question) {
	return $elm$core$List$foldl$(
		F2(
			function (fileId, text) {
				return _Utils_ap(
					text,
					_Utils_ap(
						$author$project$RichText$attachedFilePrefix,
						_Utils_ap(
							$author$project$Id$toString(fileId),
							$author$project$RichText$attachedFileSuffix)));
			}),
		((question === '') || A2($elm$core$String$endsWith, ' ', question)) ? question : (question + ' '),
		fileIds);
};
var $author$project$SheepGame$appendAttachedFiles = F2($author$project$SheepGame$appendAttachedFiles$);
var $author$project$SheepGame$inputQuestionId = function (input) {
	switch (input.$) {
		case 0:
			var questionId = input.a;
			return questionId;
		case 1:
			var questionId = input.a;
			return questionId;
		default:
			var questionId = input.a;
			return questionId;
	}
};
var $author$project$SheepGame$nextAttachedFileId = function (attachedFiles) {
	return $author$project$Id$fromInt(
		$elm$core$Basics$max$(
			1,
			$author$project$Id$toInt(
				$author$project$Id$nextId(attachedFiles))));
};
var $author$project$SheepGame$attachFiles$ = function (input, files, inputs) {
	var questionId = $author$project$SheepGame$inputQuestionId(input);
	var _v0 = $mgold$elm_nonempty_list$List$Nonempty$foldl$(
		F2(
			function (file, _v1) {
				var attachedFiles2 = _v1.a;
				var toUpload2 = _v1.b;
				var fileId = $author$project$SheepGame$nextAttachedFileId(attachedFiles2);
				return _Utils_Tuple2(
					$lamdera$containers$SeqDict$insert$(
						fileId,
						$author$project$FileStatus$FileUploading$(
							$author$project$FileName$fromString(
								$lamdera$program_test$Effect$File$name(file)),
							{
								sent: 0,
								size: $lamdera$program_test$Effect$File$size(file)
							},
							$author$project$FileStatus$contentType(
								$lamdera$program_test$Effect$File$mime(file)),
							$author$project$FileStatus$IsNotEncrypted),
						attachedFiles2),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(fileId, file),
						toUpload2));
			}),
		function () {
			var _v2 = $author$project$IdArray$get$(questionId, inputs);
			if (!_v2.$) {
				var input2 = _v2.a;
				return _Utils_Tuple2(input2.attachedFiles, _List_Nil);
			} else {
				return _Utils_Tuple2($lamdera$containers$SeqDict$empty, _List_Nil);
			}
		}(),
		files);
	var attachedFiles = _v0.a;
	var toUpload = _v0.b;
	var added = $elm$core$List$reverse(toUpload);
	return _Utils_Tuple2(
		$author$project$IdArray$update$(
			questionId,
			function (input2) {
				return _Utils_update(
					input2,
					{
						attachedFiles: attachedFiles,
						text: $author$project$SheepGame$appendAttachedFiles$(
							$elm$core$List$map$($elm$core$Tuple$first, added),
							input2.text)
					});
			},
			inputs),
		function () {
			var _v3 = $mgold$elm_nonempty_list$List$Nonempty$fromList(added);
			if (!_v3.$) {
				var nonempty = _v3.a;
				return $author$project$SheepGame$UploadAttachedFiles$(input, nonempty);
			} else {
				return $author$project$SheepGame$NoOutMsg;
			}
		}());
};
var $author$project$SheepGame$attachFiles = F3($author$project$SheepGame$attachFiles$);
var $author$project$SheepGame$attachAnswerFiles$ = function (questionId, files, model) {
	var _v0 = $author$project$SheepGame$attachFiles$(
		$author$project$SheepGame$AnswerInput(questionId),
		files,
		model.answerDrafts);
	var answerDrafts = _v0.a;
	var outMsg = _v0.b;
	return _Utils_Tuple3(
		_Utils_update(
			model,
			{answerDrafts: answerDrafts}),
		$elm$core$Maybe$Nothing,
		outMsg);
};
var $author$project$SheepGame$attachAnswerFiles = F3($author$project$SheepGame$attachAnswerFiles$);
var $author$project$SheepGame$attachNotesFiles$ = function (questionId, files, model) {
	var _v0 = $author$project$SheepGame$attachFiles$(
		$author$project$SheepGame$NotesInput(questionId),
		files,
		model.noteDrafts);
	var noteDrafts = _v0.a;
	var outMsg = _v0.b;
	return _Utils_Tuple3(
		_Utils_update(
			model,
			{noteDrafts: noteDrafts}),
		$elm$core$Maybe$Nothing,
		outMsg);
};
var $author$project$SheepGame$attachNotesFiles = F3($author$project$SheepGame$attachNotesFiles$);
var $author$project$SheepGame$mapQuestionRichText$ = function (timezone, users, change, text) {
	var _v0 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(text);
	if (!_v0.$) {
		var nonempty = _v0.a;
		return $author$project$RichText$toString$(
			timezone,
			false,
			users,
			$lamdera$containers$SeqDict$empty,
			change(
				$author$project$RichText$fromNonemptyString$(timezone, users, $lamdera$containers$SeqDict$empty, nonempty)));
	} else {
		return text;
	}
};
var $author$project$SheepGame$mapQuestionRichText = F4($author$project$SheepGame$mapQuestionRichText$);
var $author$project$SheepGame$maxAnswerLength = 200;
var $author$project$SheepGame$removeAttachedFileFromText$ = function (timezone, users, fileId, text) {
	var _v0 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(text);
	if (!_v0.$) {
		var nonempty = _v0.a;
		var _v1 = $author$project$RichText$removeAttachedFile$(
			function (a) {
				return _Utils_eq(a, fileId);
			},
			$author$project$RichText$fromNonemptyString$(timezone, users, $lamdera$containers$SeqDict$empty, nonempty));
		if (!_v1.$) {
			var richText = _v1.a;
			return $author$project$RichText$toString$(timezone, false, users, $lamdera$containers$SeqDict$empty, richText);
		} else {
			return '';
		}
	} else {
		return text;
	}
};
var $author$project$SheepGame$removeAttachedFileFromText = F4($author$project$SheepGame$removeAttachedFileFromText$);
var $author$project$SheepGame$toggleReaction$ = function (userId, shared, target, emoji) {
	var reactions = function () {
		if (!target.$) {
			var answeredBy = target.a;
			var questionId = target.b;
			return $elm$core$Maybe$withDefault$(
				$lamdera$containers$SeqDict$empty,
				$elm$core$Maybe$map$(
					function ($) {
						return $.reactions;
					},
					$elm$core$Maybe$andThen$(
						$elm$core$Basics$identity,
						$elm$core$Maybe$andThen$(
							$author$project$IdArray$get(questionId),
							$lamdera$containers$SeqDict$get$(answeredBy, shared.answers)))));
		} else {
			var questionId = target.a;
			return $elm$core$Maybe$withDefault$(
				$lamdera$containers$SeqDict$empty,
				$elm$core$Maybe$map$(
					function ($) {
						return $.reactions;
					},
					$elm$core$Maybe$andThen$(
						$elm$core$Basics$identity,
						$lamdera$containers$SeqDict$get$(questionId, shared.notes))));
		}
	}();
	var _v0 = $lamdera$containers$SeqDict$get$(emoji, reactions);
	if (!_v0.$) {
		var users = _v0.a;
		return $author$project$NonemptySet$member$(userId, users) ? $author$project$SheepGame$RemovedReaction$(target, emoji) : $author$project$SheepGame$AddedReaction$(target, emoji);
	} else {
		return $author$project$SheepGame$AddedReaction$(target, emoji);
	}
};
var $author$project$SheepGame$toggleReaction = F4($author$project$SheepGame$toggleReaction$);
var $author$project$SheepGame$updateGame$ = function (localUser, setup, shared, msg, model) {
	switch (msg.$) {
		case 0:
			var questionId = msg.a;
			var messageInputMsg = msg.b;
			switch (messageInputMsg.$) {
				case 1:
					var text = messageInputMsg.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								answerDrafts: $author$project$IdArray$update$(
									questionId,
									function (draft) {
										return _Utils_update(
											draft,
											{
												text: $elm$core$String$left$($author$project$SheepGame$maxAnswerLength, text)
											});
									},
									model.answerDrafts)
							}),
						$elm$core$Maybe$Nothing,
						$author$project$SheepGame$NoOutMsg);
				case 7:
					return _Utils_Tuple3(
						model,
						$elm$core$Maybe$Nothing,
						$author$project$SheepGame$SelectFilesToAttach(
							$author$project$SheepGame$AnswerInput(questionId)));
				case 8:
					return _Utils_Tuple3(
						model,
						$elm$core$Maybe$Nothing,
						$author$project$SheepGame$OpenEmojiSelector(
							$author$project$SheepGame$AnswerInput(questionId)));
				case 9:
					var files = messageInputMsg.a;
					return $author$project$SheepGame$attachAnswerFiles$(questionId, files, model);
				default:
					return _Utils_Tuple3(model, $elm$core$Maybe$Nothing, $author$project$SheepGame$NoOutMsg);
			}
		case 1:
			var questionId = msg.a;
			var files = msg.b;
			return $author$project$SheepGame$attachAnswerFiles$(questionId, files, model);
		case 2:
			var questionId = msg.a;
			var fileId = msg.b;
			var result = msg.c;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						answerDrafts: $author$project$IdArray$update$(
							questionId,
							function (draft) {
								return _Utils_update(
									draft,
									{
										attachedFiles: $lamdera$containers$SeqDict$updateIfExists$(
											fileId,
											A2($author$project$FileStatus$addFileHash, $elm$core$Maybe$Nothing, result),
											draft.attachedFiles)
									});
							},
							model.answerDrafts)
					}),
				$elm$core$Maybe$Nothing,
				$author$project$SheepGame$NoOutMsg);
		case 3:
			var questionId = msg.a;
			var fileId = msg.b;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						answerDrafts: $author$project$IdArray$update$(
							questionId,
							function (draft) {
								return _Utils_update(
									draft,
									{
										attachedFiles: $lamdera$containers$SeqDict$remove$(fileId, draft.attachedFiles),
										text: $author$project$SheepGame$removeAttachedFileFromText$(
											localUser.timezone,
											$author$project$User$allUsers(localUser),
											fileId,
											draft.text)
									});
							},
							model.answerDrafts)
					}),
				$elm$core$Maybe$Nothing,
				$author$project$SheepGame$CancelAttachedFileUpload$(
					$author$project$SheepGame$AnswerInput(questionId),
					fileId));
		case 4:
			var questionId = msg.a;
			var fileId = msg.b;
			return _Utils_Tuple3(
				model,
				$elm$core$Maybe$Nothing,
				function () {
					var _v2 = $elm$core$Maybe$andThen$(
						function (draft) {
							return $lamdera$containers$SeqDict$get$(fileId, draft.attachedFiles);
						},
						$author$project$IdArray$get$(questionId, model.answerDrafts));
					if ((!_v2.$) && (_v2.a.$ === 1)) {
						var fileData = _v2.a.a;
						var _v3 = fileData.metadata;
						if (!_v3.$) {
							var metadata = _v3.a;
							return $author$project$SheepGame$ShowAttachedFileInfo(
								{contentType: fileData.contentType, fileHash: fileData.fileHash, fileName: fileData.fileName, fileSize: fileData.fileSize, isEncrypted: fileData.isEncrypted, metadata: metadata});
						} else {
							return $author$project$SheepGame$NoOutMsg;
						}
					} else {
						return $author$project$SheepGame$NoOutMsg;
					}
				}());
		case 5:
			var questionId = msg.a;
			var removeSpoiler = msg.b.removeSpoiler;
			var fileId = msg.b.fileId;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						answerDrafts: $author$project$IdArray$update$(
							questionId,
							function (draft) {
								return _Utils_update(
									draft,
									{
										text: $author$project$SheepGame$mapQuestionRichText$(
											localUser.timezone,
											$author$project$User$allUsers(localUser),
											removeSpoiler ? $author$project$RichText$unspoilerAttachedFile(fileId) : $author$project$RichText$spoilerAttachedFile(fileId),
											draft.text)
									});
							},
							model.answerDrafts)
					}),
				$elm$core$Maybe$Nothing,
				$author$project$SheepGame$NoOutMsg);
		case 6:
			return _Utils_Tuple3(
				model,
				$elm$core$Maybe$Just($author$project$SheepGame$LockedAnswers),
				$author$project$SheepGame$NoOutMsg);
		case 7:
			return _Utils_Tuple3(
				model,
				$elm$core$Maybe$Just($author$project$SheepGame$UnlockedAnswers),
				$author$project$SheepGame$NoOutMsg);
		case 8:
			var userId = msg.a;
			var questionIndex = msg.b;
			var group = msg.c;
			return _Utils_Tuple3(
				model,
				$elm$core$Maybe$Just(
					$author$project$SheepGame$ChangedGroup$(
						userId,
						questionIndex,
						$elm$core$String$left$(1, group))),
				$author$project$SheepGame$NoOutMsg);
		case 9:
			var questionId = msg.a;
			var messageInputMsg = msg.b;
			switch (messageInputMsg.$) {
				case 1:
					var text = messageInputMsg.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								noteDrafts: $author$project$IdArray$update$(
									questionId,
									function (draft) {
										return _Utils_update(
											draft,
											{
												text: $elm$core$String$left$($author$project$SheepGame$maxAnswerLength, text)
											});
									},
									model.noteDrafts)
							}),
						$elm$core$Maybe$Nothing,
						$author$project$SheepGame$NoOutMsg);
				case 7:
					return _Utils_Tuple3(
						model,
						$elm$core$Maybe$Nothing,
						$author$project$SheepGame$SelectFilesToAttach(
							$author$project$SheepGame$NotesInput(questionId)));
				case 8:
					return _Utils_Tuple3(
						model,
						$elm$core$Maybe$Nothing,
						$author$project$SheepGame$OpenEmojiSelector(
							$author$project$SheepGame$NotesInput(questionId)));
				case 9:
					var files = messageInputMsg.a;
					return $author$project$SheepGame$attachNotesFiles$(questionId, files, model);
				default:
					return _Utils_Tuple3(model, $elm$core$Maybe$Nothing, $author$project$SheepGame$NoOutMsg);
			}
		case 10:
			var questionId = msg.a;
			var files = msg.b;
			return $author$project$SheepGame$attachNotesFiles$(questionId, files, model);
		case 11:
			var questionId = msg.a;
			var fileId = msg.b;
			var result = msg.c;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						noteDrafts: $author$project$IdArray$update$(
							questionId,
							function (draft) {
								return _Utils_update(
									draft,
									{
										attachedFiles: $lamdera$containers$SeqDict$updateIfExists$(
											fileId,
											A2($author$project$FileStatus$addFileHash, $elm$core$Maybe$Nothing, result),
											draft.attachedFiles)
									});
							},
							model.noteDrafts)
					}),
				$elm$core$Maybe$Nothing,
				$author$project$SheepGame$NoOutMsg);
		case 12:
			var questionId = msg.a;
			var fileId = msg.b;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						noteDrafts: $author$project$IdArray$update$(
							questionId,
							function (draft) {
								return _Utils_update(
									draft,
									{
										attachedFiles: $lamdera$containers$SeqDict$remove$(fileId, draft.attachedFiles),
										text: $author$project$SheepGame$removeAttachedFileFromText$(
											localUser.timezone,
											$author$project$User$allUsers(localUser),
											fileId,
											draft.text)
									});
							},
							model.noteDrafts)
					}),
				$elm$core$Maybe$Nothing,
				$author$project$SheepGame$CancelAttachedFileUpload$(
					$author$project$SheepGame$NotesInput(questionId),
					fileId));
		case 13:
			var questionId = msg.a;
			var fileId = msg.b;
			return _Utils_Tuple3(
				model,
				$elm$core$Maybe$Nothing,
				function () {
					var _v5 = $elm$core$Maybe$andThen$(
						function (draft) {
							return $lamdera$containers$SeqDict$get$(fileId, draft.attachedFiles);
						},
						$author$project$IdArray$get$(questionId, model.noteDrafts));
					if ((!_v5.$) && (_v5.a.$ === 1)) {
						var fileData = _v5.a.a;
						var _v6 = fileData.metadata;
						if (!_v6.$) {
							var metadata = _v6.a;
							return $author$project$SheepGame$ShowAttachedFileInfo(
								{contentType: fileData.contentType, fileHash: fileData.fileHash, fileName: fileData.fileName, fileSize: fileData.fileSize, isEncrypted: fileData.isEncrypted, metadata: metadata});
						} else {
							return $author$project$SheepGame$NoOutMsg;
						}
					} else {
						return $author$project$SheepGame$NoOutMsg;
					}
				}());
		case 14:
			var questionId = msg.a;
			var removeSpoiler = msg.b.removeSpoiler;
			var fileId = msg.b.fileId;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						noteDrafts: $author$project$IdArray$update$(
							questionId,
							function (draft) {
								return _Utils_update(
									draft,
									{
										text: $author$project$SheepGame$mapQuestionRichText$(
											localUser.timezone,
											$author$project$User$allUsers(localUser),
											removeSpoiler ? $author$project$RichText$unspoilerAttachedFile(fileId) : $author$project$RichText$spoilerAttachedFile(fileId),
											draft.text)
									});
							},
							model.noteDrafts)
					}),
				$elm$core$Maybe$Nothing,
				$author$project$SheepGame$NoOutMsg);
		case 15:
			return _Utils_Tuple3(
				model,
				$elm$core$Maybe$Just($author$project$SheepGame$FinishedGrouping),
				$author$project$SheepGame$NoOutMsg);
		case 16:
			return _Utils_Tuple3(
				model,
				$elm$core$Maybe$Just(
					$author$project$SheepGame$ChangedQuestionsRevealed(
						$author$project$Id$fromInt(
							$elm$core$Basics$min$(
								$author$project$SheepGame$revealStepCount(setup),
								shared.questionsRevealed + 1)))),
				$author$project$SheepGame$NoOutMsg);
		case 17:
			return _Utils_Tuple3(
				model,
				$elm$core$Maybe$Just(
					$author$project$SheepGame$ChangedQuestionsRevealed(
						$author$project$Id$fromInt(
							$elm$core$Basics$max$(0, shared.questionsRevealed - 1)))),
				$author$project$SheepGame$NoOutMsg);
		case 18:
			var questionId = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						hoveredQuestion: $elm$core$Maybe$Just(questionId)
					}),
				$elm$core$Maybe$Nothing,
				$author$project$SheepGame$NoOutMsg);
		case 19:
			var questionId = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						hoveredQuestion: _Utils_eq(
							model.hoveredQuestion,
							$elm$core$Maybe$Just(questionId)) ? $elm$core$Maybe$Nothing : model.hoveredQuestion
					}),
				$elm$core$Maybe$Nothing,
				$author$project$SheepGame$NoOutMsg);
		case 20:
			var userPair = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						gridHovered: $elm$core$Maybe$Just(userPair)
					}),
				$elm$core$Maybe$Nothing,
				$author$project$SheepGame$NoOutMsg);
		case 21:
			var userPair = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						gridHovered: _Utils_eq(
							model.gridHovered,
							$elm$core$Maybe$Just(userPair)) ? $elm$core$Maybe$Nothing : model.gridHovered
					}),
				$elm$core$Maybe$Nothing,
				$author$project$SheepGame$NoOutMsg);
		case 22:
			var scrollPosition = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{newQuestionRevealed: model.newQuestionRevealed && (!(!scrollPosition)), scrollPosition: scrollPosition}),
				$elm$core$Maybe$Nothing,
				$author$project$SheepGame$NoOutMsg);
		case 26:
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{newQuestionRevealed: false}),
				$elm$core$Maybe$Nothing,
				$author$project$SheepGame$ScrollResultsTo(
					$author$project$SheepGame$revealedSectionId(shared.questionsRevealed)));
		case 23:
			var target = msg.a;
			var messageViewMsg = msg.b;
			switch (messageViewMsg.$) {
				case 3:
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								hoveredResult: $elm$core$Maybe$Just(target)
							}),
						$elm$core$Maybe$Nothing,
						$author$project$SheepGame$NoOutMsg);
				case 4:
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								hoveredResult: _Utils_eq(
									model.hoveredResult,
									$elm$core$Maybe$Just(target)) ? $elm$core$Maybe$Nothing : model.hoveredResult
							}),
						$elm$core$Maybe$Nothing,
						$author$project$SheepGame$NoOutMsg);
				case 16:
					var emoji = messageViewMsg.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Maybe$Just(
							$author$project$SheepGame$toggleReaction$(localUser.session.userId, shared, target, emoji)),
						$author$project$SheepGame$NoOutMsg);
				case 8:
					var emoji = messageViewMsg.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Maybe$Just(
							$author$project$SheepGame$AddedReaction$(target, emoji)),
						$author$project$SheepGame$NoOutMsg);
				case 7:
					var emoji = messageViewMsg.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Maybe$Just(
							$author$project$SheepGame$RemovedReaction$(target, emoji)),
						$author$project$SheepGame$NoOutMsg);
				case 10:
					return _Utils_Tuple3(
						model,
						$elm$core$Maybe$Nothing,
						$author$project$SheepGame$OpenReactionEmojiSelector(target));
				case 12:
					return _Utils_Tuple3(
						model,
						$elm$core$Maybe$Nothing,
						$author$project$SheepGame$ReplyToResult(target));
				default:
					return _Utils_Tuple3(model, $elm$core$Maybe$Nothing, $author$project$SheepGame$NoOutMsg);
			}
		case 24:
			var pressedImageData = msg.a;
			return _Utils_Tuple3(
				model,
				$elm$core$Maybe$Nothing,
				$author$project$SheepGame$ShowImage(pressedImageData));
		case 25:
			var text = msg.a;
			return _Utils_Tuple3(
				model,
				$elm$core$Maybe$Nothing,
				$author$project$SheepGame$CopyText(text));
		default:
			return _Utils_Tuple3(model, $elm$core$Maybe$Nothing, $author$project$SheepGame$NoOutMsg);
	}
};
var $author$project$SheepGame$updateGame = F5($author$project$SheepGame$updateGame$);
var $author$project$WordSpellingGame$JoinGame = {$: 2};
var $author$project$WordSpellingGame$OpenReactionEmojiSelector = function (a) {
	return {$: 2, a: a};
};
var $author$project$WordSpellingGame$PlaceWord$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$WordSpellingGame$PlaceWord = F2($author$project$WordSpellingGame$PlaceWord$);
var $author$project$WordSpellingGame$Premove$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$WordSpellingGame$Premove = F2($author$project$WordSpellingGame$Premove$);
var $author$project$WordSpellingGame$RemovedReaction$ = function (a, b) {
	return {$: 6, a: a, b: b};
};
var $author$project$WordSpellingGame$RemovedReaction = F2($author$project$WordSpellingGame$RemovedReaction$);
var $author$project$WordSpellingGame$ReplaceTrayOrPass = {$: 1};
var $author$project$WordSpellingGame$ReplyToResult = function (a) {
	return {$: 1, a: a};
};
var $author$project$WordSpellingGame$WordDefinition_Open$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$WordSpellingGame$WordDefinition_Open = F2($author$project$WordSpellingGame$WordDefinition_Open$);
var $author$project$WordSpellingGame$currentDefinitionWord = function (open) {
	return $mgold$elm_nonempty_list$List$Nonempty$get$(open.index, open.words);
};
var $author$project$WordSpellingGame$FetchDefinition = function (a) {
	return {$: 0, a: a};
};
var $author$project$WordSpellingGame$WordDefinition_Loading = {$: 0};
var $author$project$WordSpellingGame$WordDefinition_SwedishUnsupported = {$: 1};
var $author$project$WordSpellingGame$openWordDefinition$ = function (open, setup, model) {
	var _v0 = setup.language;
	if (!_v0) {
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{
					wordDefinition: $author$project$WordSpellingGame$WordDefinition_Open$(open, $author$project$WordSpellingGame$WordDefinition_Loading)
				}),
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Just(
				$author$project$WordSpellingGame$FetchDefinition(
					$author$project$WordSpellingGame$currentDefinitionWord(open))));
	} else {
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{
					wordDefinition: $author$project$WordSpellingGame$WordDefinition_Open$(open, $author$project$WordSpellingGame$WordDefinition_SwedishUnsupported)
				}),
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing);
	}
};
var $author$project$WordSpellingGame$openWordDefinition = F3($author$project$WordSpellingGame$openWordDefinition$);
var $author$project$WordSpellingGame$cycleWordDefinition$ = function (offset, setup, model) {
	var _v0 = model.wordDefinition;
	if (_v0.$ === 1) {
		var open = _v0.a;
		return $author$project$WordSpellingGame$openWordDefinition$(
			_Utils_update(
				open,
				{
					index: A2(
						$elm$core$Basics$modBy,
						$mgold$elm_nonempty_list$List$Nonempty$length(open.words),
						open.index + offset)
				}),
			setup,
			model);
	} else {
		return _Utils_Tuple3(model, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
	}
};
var $author$project$WordSpellingGame$cycleWordDefinition = F3($author$project$WordSpellingGame$cycleWordDefinition$);
var $author$project$WordSpellingGame$WordDefinition_Failed = {$: 3};
var $author$project$WordSpellingGame$WordDefinition_Loaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$WordSpellingGame$WordDefinition_NotFound = {$: 2};
var $author$project$WordSpellingGame$definitionResultToData = function (result) {
	if (!result.$) {
		if (result.a.b) {
			var _v1 = result.a;
			var entry = _v1.a;
			var rest = _v1.b;
			return $author$project$WordSpellingGame$WordDefinition_Loaded(
				A2($elm$core$List$cons, entry, rest));
		} else {
			return $author$project$WordSpellingGame$WordDefinition_NotFound;
		}
	} else {
		return $author$project$WordSpellingGame$WordDefinition_Failed;
	}
};
var $author$project$WordSpellingGame$lowestFreeTrayIndex$ = function (n, taken) {
	lowestFreeTrayIndex:
	while (true) {
		if ($elm$core$Set$member$(n, taken)) {
			var $temp$n = n + 1;
			n = $temp$n;
			continue lowestFreeTrayIndex;
		} else {
			return n;
		}
	}
};
var $author$project$WordSpellingGame$lowestFreeTrayIndex = F2($author$project$WordSpellingGame$lowestFreeTrayIndex$);
var $author$project$WordSpellingGame$remainingLettersInBagCount$ = function (setup, board, players) {
	return $lamdera$containers$SeqDict$foldl$(
		F3(
			function (_v0, a, total) {
				return $author$project$OneOrGreater$toInt(a) + total;
			}),
		0,
		$author$project$WordSpellingGame$remainingLettersInBag$(setup, board, players));
};
var $author$project$WordSpellingGame$remainingLettersInBagCount = F3($author$project$WordSpellingGame$remainingLettersInBagCount$);
var $author$project$WordSpellingGame$toggleReaction$ = function (userId, shared, target, emoji) {
	var _v0 = $elm$core$Maybe$andThen$(
		$lamdera$containers$SeqDict$get(emoji),
		$lamdera$containers$SeqDict$get$(target, shared.reactions));
	if (!_v0.$) {
		var users = _v0.a;
		return $author$project$NonemptySet$member$(userId, users) ? $author$project$WordSpellingGame$RemovedReaction$(target, emoji) : $author$project$WordSpellingGame$AddedReaction$(target, emoji);
	} else {
		return $author$project$WordSpellingGame$AddedReaction$(target, emoji);
	}
};
var $author$project$WordSpellingGame$toggleReaction = F4($author$project$WordSpellingGame$toggleReaction$);
var $author$project$WordSpellingGame$trayIndicesInUse = function (tiles) {
	return $elm$core$Array$foldl$(
		F2(
			function (tile, set) {
				var _v0 = tile.position;
				if (!_v0.$) {
					var index = _v0.a;
					return $elm$core$Set$insert$(index, set);
				} else {
					return set;
				}
			}),
		$elm$core$Set$empty,
		tiles);
};
var $author$project$WordSpellingGame$updateGame$ = function (time, windowSize, currentUserId, setup, shared, msg, oldModel) {
	var model = _Utils_update(
		oldModel,
		{
			tiles: $author$project$WordSpellingGame$getTiles$(windowSize, currentUserId, setup, shared, oldModel.tiles)
		});
	switch (msg.$) {
		case 0:
			var placement = msg.a;
			var _v1 = $author$project$WordSpellingGame$placeWord$(setup, shared.board, placement);
			if (!_v1.$) {
				var _v2 = _v1.a;
				var result = _v2.b;
				var lineCells = $elm$core$Set$fromList(
					$elm$core$List$map$($elm$core$Tuple$first, result.placedCells));
				var kept = $elm$core$Array$foldl$(
					F2(
						function (tile, acc) {
							var _v3 = tile.position;
							if (!_v3.$) {
								return $elm$core$Array$push$(tile, acc);
							} else {
								var cell = _v3.a;
								return $elm$core$Set$member$(cell, lineCells) ? acc : $elm$core$Array$push$(
									_Utils_update(
										tile,
										{
											position: $author$project$WordSpellingGame$TileInTray$(
												$author$project$WordSpellingGame$firstOpenTrayIndex$($elm$core$Maybe$Nothing, acc),
												$elm$core$Maybe$Nothing)
										}),
									acc);
							}
						}),
					$elm$core$Array$empty,
					model.tiles);
				var newTileCount = $author$project$OneOrGreater$toInt(setup.traySize) - $elm$core$Array$length(kept);
				return _Utils_Tuple3(
					$author$project$WordSpellingGame$withZoomAnimation$(
						time,
						model,
						_Utils_update(
							model,
							{
								dragging: $author$project$WordSpellingGame$NotDragging,
								tiles: $elm$core$List$foldl$(
									F2(
										function (index, tray) {
											return $elm$core$Array$push$(
												{
													createdAt: $ianmackenzie$elm_units$Duration$addTo$(
														time,
														$ianmackenzie$elm_units$Quantity$sum(
															_List_fromArray(
																[
																	$ianmackenzie$elm_units$Duration$seconds(0.1 * index),
																	$author$project$WordSpellingGame$placementAnimationDuration$(
																	$author$project$UserSession$FilledInByBackend($author$project$WordSpellingGame$IsNotValid),
																	newTileCount)
																]))),
													position: $author$project$WordSpellingGame$TileInTray$(
														$author$project$WordSpellingGame$firstOpenTrayIndex$($elm$core$Maybe$Nothing, tray),
														$elm$core$Maybe$Nothing)
												},
												tray);
										}),
									kept,
									$elm$core$List$range$(0, newTileCount - 1))
							})),
					$elm$core$Maybe$Just(
						$author$project$WordSpellingGame$PlaceWord$(placement, $author$project$UserSession$EmptyPlaceholder)),
					$elm$core$Maybe$Nothing);
			} else {
				return _Utils_Tuple3(model, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
			}
		case 1:
			return _Utils_Tuple3(
				model,
				$elm$core$Maybe$Just($author$project$WordSpellingGame$JoinGame),
				$elm$core$Maybe$Nothing);
		case 2:
			var lettersLeftIncludingTray = $elm$core$Basics$min$(
				$author$project$OneOrGreater$toInt(setup.traySize),
				$author$project$WordSpellingGame$remainingLettersInBagCount$(
					setup,
					shared.board,
					$elm$core$List$filter$(
						function (player) {
							return _Utils_eq(player.userId, currentUserId);
						},
						$mgold$elm_nonempty_list$List$Nonempty$toList(shared.players))));
			var list = $elm$core$List$range$(0, lettersLeftIncludingTray - 1);
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						tiles: $elm$core$Array$fromList(
							$elm$core$List$map$(
								function (index) {
									return {
										createdAt: $ianmackenzie$elm_units$Duration$addTo$(
											time,
											$ianmackenzie$elm_units$Duration$seconds(0.2 * index)),
										position: $author$project$WordSpellingGame$TileInTray$(index, $elm$core$Maybe$Nothing)
									};
								},
								list))
					}),
				$elm$core$Maybe$Just($author$project$WordSpellingGame$ReplaceTrayOrPass),
				$elm$core$Maybe$Nothing);
		case 3:
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						dragging: $author$project$WordSpellingGame$NotDragging,
						tiles: $elm$core$Array$foldl$(
							F2(
								function (tile, _v4) {
									var acc = _v4.a;
									var taken = _v4.b;
									var _v5 = tile.position;
									if (!_v5.$) {
										return _Utils_Tuple2(
											$elm$core$Array$push$(tile, acc),
											taken);
									} else {
										var index = $author$project$WordSpellingGame$lowestFreeTrayIndex$(0, taken);
										return _Utils_Tuple2(
											$elm$core$Array$push$(
												_Utils_update(
													tile,
													{
														position: $author$project$WordSpellingGame$TileInTray$(index, $elm$core$Maybe$Nothing)
													}),
												acc),
											$elm$core$Set$insert$(index, taken));
									}
								}),
							_Utils_Tuple2(
								$elm$core$Array$empty,
								$author$project$WordSpellingGame$trayIndicesInUse(model.tiles)),
							model.tiles).a
					}),
				function () {
					var _v6 = $author$project$WordSpellingGame$getPlayer$(currentUserId, shared);
					if (!_v6.$) {
						var player = _v6.a;
						var _v7 = player.premove;
						if (!_v7.$) {
							return $elm$core$Maybe$Just($author$project$WordSpellingGame$CancelPremove);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}(),
				$elm$core$Maybe$Nothing);
		case 4:
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{showSettings: !model.showSettings}),
				$elm$core$Maybe$Nothing,
				$elm$core$Maybe$Nothing);
		case 5:
			var userId = msg.a;
			return _Utils_Tuple3(
				$author$project$MyUi$isMobileAlt(windowSize) ? _Utils_update(
					model,
					{
						highlightedPlayer: _Utils_eq(
							model.highlightedPlayer,
							$elm$core$Maybe$Just(userId)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(userId)
					}) : model,
				$elm$core$Maybe$Nothing,
				$elm$core$Maybe$Nothing);
		case 6:
			var userId = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						highlightedPlayer: $elm$core$Maybe$Just(userId)
					}),
				$elm$core$Maybe$Nothing,
				$elm$core$Maybe$Nothing);
		case 7:
			var userId = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						highlightedPlayer: _Utils_eq(
							model.highlightedPlayer,
							$elm$core$Maybe$Just(userId)) ? $elm$core$Maybe$Nothing : model.highlightedPlayer
					}),
				$elm$core$Maybe$Nothing,
				$elm$core$Maybe$Nothing);
		case 8:
			var index = msg.a;
			var cells = msg.b;
			var sharedAtMove = msg.c;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						hoveredMove: $elm$core$Maybe$Just(
							{
								cells: $elm$core$Dict$fromList(cells),
								index: index,
								shared: sharedAtMove
							})
					}),
				$elm$core$Maybe$Nothing,
				$elm$core$Maybe$Nothing);
		case 9:
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{hoveredMove: $elm$core$Maybe$Nothing}),
				$elm$core$Maybe$Nothing,
				$elm$core$Maybe$Nothing);
		case 10:
			var position = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{scrollPosition: position}),
				$elm$core$Maybe$Nothing,
				$elm$core$Maybe$Nothing);
		case 11:
			var placement = msg.a;
			var _v8 = $author$project$WordSpellingGame$placeWord$(setup, shared.board, placement);
			if (!_v8.$) {
				return _Utils_Tuple3(
					model,
					$elm$core$Maybe$Just(
						$author$project$WordSpellingGame$Premove$(placement, $author$project$UserSession$EmptyPlaceholder)),
					$elm$core$Maybe$Nothing);
			} else {
				return _Utils_Tuple3(model, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
			}
		case 12:
			var words = msg.a;
			return $author$project$WordSpellingGame$openWordDefinition$(
				{index: 0, words: words},
				setup,
				model);
		case 13:
			return $author$project$WordSpellingGame$cycleWordDefinition$(-1, setup, model);
		case 14:
			return $author$project$WordSpellingGame$cycleWordDefinition$(1, setup, model);
		case 15:
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{wordDefinition: $author$project$WordSpellingGame$WordDefinition_None}),
				$elm$core$Maybe$Nothing,
				$elm$core$Maybe$Nothing);
		case 16:
			var word = msg.a;
			var result = msg.b;
			return _Utils_Tuple3(
				function () {
					var _v9 = model.wordDefinition;
					if ((_v9.$ === 1) && (!_v9.b.$)) {
						var open = _v9.a;
						var _v10 = _v9.b;
						return _Utils_eq(
							$author$project$WordSpellingGame$currentDefinitionWord(open),
							word) ? _Utils_update(
							model,
							{
								wordDefinition: $author$project$WordSpellingGame$WordDefinition_Open$(
									open,
									$author$project$WordSpellingGame$definitionResultToData(result))
							}) : model;
					} else {
						return model;
					}
				}(),
				$elm$core$Maybe$Nothing,
				$elm$core$Maybe$Nothing);
		default:
			var target = msg.a;
			var messageViewMsg = msg.b;
			switch (messageViewMsg.$) {
				case 16:
					var emoji = messageViewMsg.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Maybe$Just(
							$author$project$WordSpellingGame$toggleReaction$(currentUserId, shared, target, emoji)),
						$elm$core$Maybe$Nothing);
				case 8:
					var emoji = messageViewMsg.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Maybe$Just(
							$author$project$WordSpellingGame$AddedReaction$(target, emoji)),
						$elm$core$Maybe$Nothing);
				case 7:
					var emoji = messageViewMsg.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Maybe$Just(
							$author$project$WordSpellingGame$RemovedReaction$(target, emoji)),
						$elm$core$Maybe$Nothing);
				case 10:
					return _Utils_Tuple3(
						model,
						$elm$core$Maybe$Nothing,
						$elm$core$Maybe$Just(
							$author$project$WordSpellingGame$OpenReactionEmojiSelector(target)));
				case 12:
					return _Utils_Tuple3(
						model,
						$elm$core$Maybe$Nothing,
						$elm$core$Maybe$Just(
							$author$project$WordSpellingGame$ReplyToResult(target)));
				default:
					return _Utils_Tuple3(model, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
			}
	}
};
var $author$project$WordSpellingGame$updateGame = F7($author$project$WordSpellingGame$updateGame$);
var $author$project$Go$CancelSetup = {$: 2};
var $author$project$Go$Game = function (a) {
	return {$: 1, a: a};
};
var $author$project$Go$Setup = function (a) {
	return {$: 0, a: a};
};
var $author$project$Go$KomiHalfPoints = $elm$core$Basics$identity;
var $author$project$Go$komiHalfPointsFromString = function (input) {
	var trimmed = $elm$core$String$trim(input);
	if (trimmed === '') {
		return $elm$core$Result$Ok(0);
	} else {
		var _v0 = $elm$core$String$toFloat(trimmed);
		if (!_v0.$) {
			var n = _v0.a;
			var halfStones = $elm$core$Basics$round(n * 2);
			return ($elm$core$Basics$abs(halfStones - (n * 2)) < 0.0001) ? $elm$core$Result$Ok(halfStones) : $elm$core$Result$Err('Value must be a value such as 0.5, 1, 2.5');
		} else {
			return $elm$core$Result$Err('Enter a number');
		}
	}
};
var $author$project$Go$maxHandicap = 9;
var $author$project$Go$parseHandicap = function (input) {
	var trimmed = $elm$core$String$trim(input);
	if (trimmed === '') {
		return $elm$core$Result$Ok(0);
	} else {
		var _v0 = $elm$core$String$toInt(trimmed);
		if (!_v0.$) {
			var n = _v0.a;
			return (n < 0) ? $elm$core$Result$Err('Cannot be negative') : ((_Utils_cmp(n, $author$project$Go$maxHandicap) > 0) ? $elm$core$Result$Err(
				'Maximum is ' + $elm$core$String$fromInt($author$project$Go$maxHandicap)) : $elm$core$Result$Ok(n));
		} else {
			return $elm$core$Result$Err('Enter a number');
		}
	}
};
var $author$project$Go$parseTimeControl = function (model) {
	var trimmedMain = $elm$core$String$trim(model.mainTimeInput);
	if (trimmedMain === '') {
		return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
	} else {
		var _v0 = $elm$core$String$toFloat(trimmedMain);
		if (_v0.$ === 1) {
			return $elm$core$Result$Err('Main time: enter a number of minutes');
		} else {
			var minutes = _v0.a;
			if (minutes <= 0) {
				return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
			} else {
				var _v1 = $elm$core$String$toFloat(
					$elm$core$String$trim(model.incrementInput));
				if (_v1.$ === 1) {
					return $elm$core$Result$Err('Increment: enter a number of seconds');
				} else {
					var inc = _v1.a;
					return (inc < 0) ? $elm$core$Result$Err('Increment cannot be negative') : $elm$core$Result$Ok(
						$elm$core$Maybe$Just(
							{
								increment: $ianmackenzie$elm_units$Duration$seconds(inc),
								mainTime: $ianmackenzie$elm_units$Duration$minutes(minutes)
							}));
				}
			}
		}
	}
};
var $author$project$Go$BoardSize = $elm$core$Basics$identity;
var $author$project$Go$boardSize13 = 13;
var $author$project$Go$boardSize19 = 19;
var $author$project$Go$boardSize9 = 9;
var $author$project$Go$maxDimension = 25;
var $author$project$Go$minDimension = 2;
var $author$project$Go$boardSizeFromInt = function (n) {
	return (_Utils_cmp(n, $author$project$Go$minDimension) < 0) ? $elm$core$Result$Err(
		'Minimum dimension is ' + $elm$core$String$fromInt($author$project$Go$minDimension)) : ((_Utils_cmp(n, $author$project$Go$maxDimension) > 0) ? $elm$core$Result$Err(
		'Maximum dimension is ' + $elm$core$String$fromInt($author$project$Go$maxDimension)) : $elm$core$Result$Ok(n));
};
var $author$project$Go$boardSizeFromString = function (text) {
	var _v0 = $elm$core$String$toInt(
		$elm$core$String$trim(text));
	if (!_v0.$) {
		var n = _v0.a;
		return $author$project$Go$boardSizeFromInt(n);
	} else {
		return $elm$core$Result$Err('Enter a number');
	}
};
var $author$project$Go$selectedDimensions = function (model) {
	var _v0 = model.sizeSelection;
	switch (_v0) {
		case 0:
			return $elm$core$Result$Ok(
				_Utils_Tuple2($author$project$Go$boardSize9, $author$project$Go$boardSize9));
		case 1:
			return $elm$core$Result$Ok(
				_Utils_Tuple2($author$project$Go$boardSize13, $author$project$Go$boardSize13));
		case 2:
			return $elm$core$Result$Ok(
				_Utils_Tuple2($author$project$Go$boardSize19, $author$project$Go$boardSize19));
		default:
			var _v1 = _Utils_Tuple2(
				$author$project$Go$boardSizeFromString(model.widthInput),
				$author$project$Go$boardSizeFromString(model.heightInput));
			if (!_v1.a.$) {
				if (!_v1.b.$) {
					var w = _v1.a.a;
					var h = _v1.b.a;
					return $elm$core$Result$Ok(
						_Utils_Tuple2(w, h));
				} else {
					var err = _v1.b.a;
					return $elm$core$Result$Err('Height: ' + err);
				}
			} else {
				var err = _v1.a.a;
				return $elm$core$Result$Err('Width: ' + err);
			}
	}
};
var $author$project$Go$validateSetup$ = function (creatorId, model) {
	var _v0 = $author$project$Go$selectedDimensions(model);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var width = _v1.a;
		var height = _v1.b;
		var _v2 = $author$project$Go$parseHandicap(model.handicapInput);
		if (_v2.$ === 1) {
			var err = _v2.a;
			return $elm$core$Result$Err('Handicap: ' + err);
		} else {
			var handicap = _v2.a;
			var _v3 = $author$project$Go$komiHalfPointsFromString(model.komiInput);
			if (_v3.$ === 1) {
				var err = _v3.a;
				return $elm$core$Result$Err('Komi: ' + err);
			} else {
				var komiHalfPoints = _v3.a;
				var _v4 = $author$project$Go$parseTimeControl(model);
				if (_v4.$ === 1) {
					var err = _v4.a;
					return $elm$core$Result$Err(err);
				} else {
					var timeControl = _v4.a;
					return $elm$core$Result$Ok(
						{createdBy: creatorId, gameCreatorPlayingAs: model.gameCreatorPlayingAs, handicap: handicap, height: height, komiHalfPoints: komiHalfPoints, timeControl: timeControl, width: width});
				}
			}
		}
	} else {
		var err = _v0.a;
		return $elm$core$Result$Err(err);
	}
};
var $author$project$Go$validateSetup = F2($author$project$Go$validateSetup$);
var $author$project$Go$updateSetup$ = function (creatorId, msg, model) {
	switch (msg.$) {
		case 0:
			var input = msg.a;
			return _Utils_Tuple2(
				$author$project$Go$Setup(
					_Utils_update(
						model,
						{error: $elm$core$Maybe$Nothing, widthInput: input})),
				$elm$core$Maybe$Nothing);
		case 1:
			var input = msg.a;
			return _Utils_Tuple2(
				$author$project$Go$Setup(
					_Utils_update(
						model,
						{error: $elm$core$Maybe$Nothing, heightInput: input})),
				$elm$core$Maybe$Nothing);
		case 2:
			var input = msg.a;
			return _Utils_Tuple2(
				$author$project$Go$Setup(
					_Utils_update(
						model,
						{error: $elm$core$Maybe$Nothing, handicapInput: input})),
				$elm$core$Maybe$Nothing);
		case 3:
			var input = msg.a;
			return _Utils_Tuple2(
				$author$project$Go$Setup(
					_Utils_update(
						model,
						{error: $elm$core$Maybe$Nothing, komiInput: input})),
				$elm$core$Maybe$Nothing);
		case 4:
			var input = msg.a;
			return _Utils_Tuple2(
				$author$project$Go$Setup(
					_Utils_update(
						model,
						{error: $elm$core$Maybe$Nothing, mainTimeInput: input})),
				$elm$core$Maybe$Nothing);
		case 5:
			var input = msg.a;
			return _Utils_Tuple2(
				$author$project$Go$Setup(
					_Utils_update(
						model,
						{error: $elm$core$Maybe$Nothing, incrementInput: input})),
				$elm$core$Maybe$Nothing);
		case 6:
			var selection = msg.a;
			return _Utils_Tuple2(
				$author$project$Go$Setup(
					_Utils_update(
						model,
						{error: $elm$core$Maybe$Nothing, sizeSelection: selection})),
				$elm$core$Maybe$Nothing);
		case 7:
			var stone = msg.a;
			return _Utils_Tuple2(
				$author$project$Go$Setup(
					_Utils_update(
						model,
						{error: $elm$core$Maybe$Nothing, gameCreatorPlayingAs: stone})),
				$elm$core$Maybe$Nothing);
		case 8:
			var _v1 = $author$project$Go$validateSetup$(creatorId, model);
			if (!_v1.$) {
				var setup = _v1.a;
				return _Utils_Tuple2(
					$author$project$Go$Game($author$project$Go$initGame),
					$elm$core$Maybe$Just(setup));
			} else {
				var error = _v1.a;
				return _Utils_Tuple2(
					$author$project$Go$Setup(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(error)
							})),
					$elm$core$Maybe$Nothing);
			}
		default:
			return _Utils_Tuple2($author$project$Go$CancelSetup, $elm$core$Maybe$Nothing);
	}
};
var $author$project$Go$updateSetup = F3($author$project$Go$updateSetup$);
var $author$project$SheepGame$CancelSetup = {$: 2};
var $author$project$SheepGame$FinishedSetup = function (a) {
	return {$: 1, a: a};
};
var $author$project$SheepGame$Game = function (a) {
	return {$: 1, a: a};
};
var $author$project$SheepGame$SetFocusOnQuestion = function (a) {
	return {$: 12, a: a};
};
var $author$project$SheepGame$Setup = function (a) {
	return {$: 0, a: a};
};
var $author$project$IdArray$append$ = function (_v0, _v1) {
	var arrayA = _v0;
	var arrayB = _v1;
	return $elm$core$Array$append$(arrayA, arrayB);
};
var $author$project$IdArray$append = F2($author$project$IdArray$append$);
var $author$project$SheepGame$attachQuestionFiles$ = function (questionId, files, model) {
	var _v0 = $author$project$SheepGame$attachFiles$(
		$author$project$SheepGame$QuestionInput(questionId),
		files,
		model.questions);
	var questions = _v0.a;
	var outMsg = _v0.b;
	return _Utils_Tuple2(
		$author$project$SheepGame$Setup(
			_Utils_update(
				model,
				{error: $elm$core$Maybe$Nothing, questions: questions})),
		outMsg);
};
var $author$project$SheepGame$attachQuestionFiles = F3($author$project$SheepGame$attachQuestionFiles$);
var $author$project$SheepGame$attachedFile$ = function (questionId, fileId, model) {
	return $elm$core$Maybe$andThen$(
		function (question) {
			return $lamdera$containers$SeqDict$get$(fileId, question.attachedFiles);
		},
		$author$project$IdArray$get$(questionId, model.questions));
};
var $author$project$SheepGame$attachedFile = F3($author$project$SheepGame$attachedFile$);
var $author$project$IdArray$nextId = function (idArray) {
	return $author$project$Id$fromInt(
		$author$project$IdArray$length(idArray));
};
var $author$project$IdArray$push$ = function (value, _v0) {
	var array = _v0;
	return $elm$core$Array$push$(value, array);
};
var $author$project$IdArray$push = F2($author$project$IdArray$push$);
var $author$project$SheepGame$noQuestionsError = 'Write at least one question before starting';
var $author$project$SheepGame$validateSetup$ = function (timezone, users, createdBy, model) {
	var _v0 = $mgold$elm_nonempty_list$List$Nonempty$fromList(
		$elm$core$List$filterMap$(
			function (question) {
				return $elm$core$Result$toMaybe(
					$author$project$SheepGame$validateInput$(timezone, users, question));
			},
			$author$project$IdArray$toList(model.questions)));
	if (!_v0.$) {
		var questions = _v0.a;
		return _Utils_eq(
			$author$project$IdArray$length(model.questions),
			$mgold$elm_nonempty_list$List$Nonempty$length(questions)) ? $elm$core$Result$Ok(
			{
				createdBy: createdBy,
				questions: $mgold$elm_nonempty_list$List$Nonempty$map$(
					function (a) {
						return a(0);
					},
					questions)
			}) : $elm$core$Result$Err('');
	} else {
		return $elm$core$Result$Err($author$project$SheepGame$noQuestionsError);
	}
};
var $author$project$SheepGame$validateSetup = F4($author$project$SheepGame$validateSetup$);
var $author$project$SheepGame$updateSetup$ = function (localUser, msg, model) {
	switch (msg.$) {
		case 0:
			var questionId = msg.a;
			var messageInputMsg = msg.b;
			switch (messageInputMsg.$) {
				case 0:
					return _Utils_Tuple2(
						$author$project$SheepGame$Setup(model),
						$author$project$SheepGame$NoOutMsg);
				case 1:
					var text = messageInputMsg.a;
					return _Utils_Tuple2(
						$author$project$SheepGame$Setup(
							_Utils_update(
								model,
								{
									error: $elm$core$Maybe$Nothing,
									questions: $author$project$IdArray$update$(
										questionId,
										function (question) {
											return _Utils_update(
												question,
												{text: text});
										},
										model.questions)
								})),
						$author$project$SheepGame$NoOutMsg);
				case 2:
					var charsLeft = messageInputMsg.a.charsLeft;
					return _Utils_eq(charsLeft, $author$project$SheepGame$maxQuestionLength) ? _Utils_Tuple2(
						$author$project$SheepGame$Setup(model),
						$author$project$SheepGame$NoOutMsg) : _Utils_Tuple2(
						$author$project$SheepGame$Setup(
							_Utils_update(
								model,
								{
									questions: $author$project$IdArray$append$(
										$author$project$IdArray$push$(
											{attachedFiles: $lamdera$containers$SeqDict$empty, text: ''},
											$author$project$IdArray$slice$(
												$author$project$Id$fromInt(0),
												$author$project$Id$increment(questionId),
												model.questions)),
										$author$project$IdArray$slice$(
											$author$project$Id$increment(questionId),
											$author$project$IdArray$nextId(model.questions),
											model.questions))
								})),
						$author$project$SheepGame$SetFocusOnQuestion(
							$author$project$Id$increment(questionId)));
				case 3:
					return _Utils_Tuple2(
						$author$project$SheepGame$Setup(model),
						$author$project$SheepGame$NoOutMsg);
				case 4:
					return _Utils_Tuple2(
						$author$project$SheepGame$Setup(model),
						$author$project$SheepGame$NoOutMsg);
				case 5:
					return _Utils_Tuple2(
						$author$project$SheepGame$Setup(model),
						$author$project$SheepGame$NoOutMsg);
				case 6:
					return _Utils_Tuple2(
						$author$project$SheepGame$Setup(model),
						$author$project$SheepGame$NoOutMsg);
				case 7:
					return _Utils_Tuple2(
						$author$project$SheepGame$Setup(model),
						$author$project$SheepGame$SelectFilesToAttach(
							$author$project$SheepGame$QuestionInput(questionId)));
				case 8:
					return _Utils_Tuple2(
						$author$project$SheepGame$Setup(model),
						$author$project$SheepGame$OpenEmojiSelector(
							$author$project$SheepGame$QuestionInput(questionId)));
				case 9:
					var files = messageInputMsg.a;
					return $author$project$SheepGame$attachQuestionFiles$(questionId, files, model);
				case 10:
					return _Utils_Tuple2(
						$author$project$SheepGame$Setup(model),
						$author$project$SheepGame$NoOutMsg);
				case 11:
					return _Utils_Tuple2(
						$author$project$SheepGame$Setup(model),
						$author$project$SheepGame$NoOutMsg);
				case 12:
					return _Utils_Tuple2(
						$author$project$SheepGame$Setup(model),
						$author$project$SheepGame$NoOutMsg);
				case 13:
					return _Utils_Tuple2(
						$author$project$SheepGame$Setup(model),
						$author$project$SheepGame$NoOutMsg);
				default:
					return _Utils_Tuple2(
						$author$project$SheepGame$Setup(model),
						$author$project$SheepGame$NoOutMsg);
			}
		case 1:
			return _Utils_Tuple2(
				$author$project$SheepGame$Setup(
					_Utils_update(
						model,
						{
							error: $elm$core$Maybe$Nothing,
							questions: (_Utils_cmp(
								$author$project$IdArray$length(model.questions),
								$author$project$SheepGame$maxQuestions) > -1) ? model.questions : $author$project$IdArray$push$(
								{attachedFiles: $lamdera$containers$SeqDict$empty, text: ''},
								model.questions)
						})),
				$author$project$SheepGame$SetFocusOnQuestion(
					$author$project$IdArray$nextId(model.questions)));
		case 2:
			var index = msg.a;
			return _Utils_Tuple2(
				$author$project$SheepGame$Setup(
					_Utils_update(
						model,
						{
							error: $elm$core$Maybe$Nothing,
							questions: $author$project$IdArray$fromList(
								$elmcraft$core_extra$List$Extra$removeAt$(
									$author$project$Id$toInt(index),
									$author$project$IdArray$toList(model.questions)))
						})),
				$author$project$SheepGame$NoOutMsg);
		case 3:
			var _v2 = $author$project$SheepGame$validateSetup$(
				localUser.timezone,
				$author$project$User$allUsers(localUser),
				localUser.session.userId,
				model);
			if (!_v2.$) {
				var setup = _v2.a;
				return _Utils_Tuple2(
					$author$project$SheepGame$Game(
						$author$project$SheepGame$initGame$(localUser, setup, $author$project$SheepGame$initShared)),
					$author$project$SheepGame$FinishedSetup(setup));
			} else {
				var error = _v2.a;
				return _Utils_Tuple2(
					$author$project$SheepGame$Setup(
						_Utils_update(
							model,
							{
								error: $elm$core$Maybe$Just(error),
								pressedSubmit: true
							})),
					$author$project$SheepGame$NoOutMsg);
			}
		case 5:
			var questionId = msg.a;
			var files = msg.b;
			return $author$project$SheepGame$attachQuestionFiles$(questionId, files, model);
		case 6:
			var questionId = msg.a;
			var fileId = msg.b;
			var result = msg.c;
			return _Utils_Tuple2(
				$author$project$SheepGame$Setup(
					_Utils_update(
						model,
						{
							questions: $author$project$IdArray$update$(
								questionId,
								function (question) {
									return _Utils_update(
										question,
										{
											attachedFiles: $lamdera$containers$SeqDict$updateIfExists$(
												fileId,
												A2($author$project$FileStatus$addFileHash, $elm$core$Maybe$Nothing, result),
												question.attachedFiles)
										});
								},
								model.questions)
						})),
				$author$project$SheepGame$NoOutMsg);
		case 4:
			return _Utils_Tuple2($author$project$SheepGame$CancelSetup, $author$project$SheepGame$NoOutMsg);
		case 7:
			var questionId = msg.a;
			var fileId = msg.b;
			return _Utils_Tuple2(
				$author$project$SheepGame$Setup(
					_Utils_update(
						model,
						{
							error: $elm$core$Maybe$Nothing,
							questions: $author$project$IdArray$update$(
								questionId,
								function (question) {
									return _Utils_update(
										question,
										{
											attachedFiles: $lamdera$containers$SeqDict$remove$(fileId, question.attachedFiles),
											text: $author$project$SheepGame$removeAttachedFileFromText$(
												localUser.timezone,
												$author$project$User$allUsers(localUser),
												fileId,
												question.text)
										});
								},
								model.questions)
						})),
				$author$project$SheepGame$CancelAttachedFileUpload$(
					$author$project$SheepGame$QuestionInput(questionId),
					fileId));
		case 8:
			var questionId = msg.a;
			var fileId = msg.b;
			return _Utils_Tuple2(
				$author$project$SheepGame$Setup(model),
				function () {
					var _v3 = $author$project$SheepGame$attachedFile$(questionId, fileId, model);
					if ((!_v3.$) && (_v3.a.$ === 1)) {
						var fileData = _v3.a.a;
						var _v4 = fileData.metadata;
						if (!_v4.$) {
							var metadata = _v4.a;
							return $author$project$SheepGame$ShowAttachedFileInfo(
								{contentType: fileData.contentType, fileHash: fileData.fileHash, fileName: fileData.fileName, fileSize: fileData.fileSize, isEncrypted: fileData.isEncrypted, metadata: metadata});
						} else {
							return $author$project$SheepGame$NoOutMsg;
						}
					} else {
						return $author$project$SheepGame$NoOutMsg;
					}
				}());
		default:
			var questionId = msg.a;
			var removeSpoiler = msg.b.removeSpoiler;
			var fileId = msg.b.fileId;
			return _Utils_Tuple2(
				$author$project$SheepGame$Setup(
					_Utils_update(
						model,
						{
							error: $elm$core$Maybe$Nothing,
							questions: $author$project$IdArray$update$(
								questionId,
								function (question) {
									return _Utils_update(
										question,
										{
											text: $author$project$SheepGame$mapQuestionRichText$(
												localUser.timezone,
												$author$project$User$allUsers(localUser),
												removeSpoiler ? $author$project$RichText$unspoilerAttachedFile(fileId) : $author$project$RichText$spoilerAttachedFile(fileId),
												question.text)
										});
								},
								model.questions)
						})),
				$author$project$SheepGame$NoOutMsg);
	}
};
var $author$project$SheepGame$updateSetup = F3($author$project$SheepGame$updateSetup$);
var $author$project$WordSpellingGame$CancelSetup = {$: 2};
var $author$project$WordSpellingGame$Game = function (a) {
	return {$: 1, a: a};
};
var $author$project$WordSpellingGame$Setup = function (a) {
	return {$: 0, a: a};
};
var $author$project$WordSpellingGame$LetterChar = $elm$core$Basics$identity;
var $author$project$SeqDictHelper$increment$ = function (key, dict) {
	return $lamdera$containers$SeqDict$update$(
		key,
		function (maybe) {
			if (!maybe.$) {
				var value = maybe.a;
				return $elm$core$Maybe$Just(
					$author$project$OneOrGreater$increment(value));
			} else {
				return $elm$core$Maybe$Just($author$project$OneOrGreater$one);
			}
		},
		dict);
};
var $author$project$SeqDictHelper$increment = F2($author$project$SeqDictHelper$increment$);
var $author$project$WordSpellingGame$defaultEnglishLetterValue = function (_char) {
	switch (_char) {
		case 'A':
			return 1;
		case 'B':
			return 3;
		case 'C':
			return 3;
		case 'D':
			return 2;
		case 'E':
			return 1;
		case 'F':
			return 4;
		case 'G':
			return 2;
		case 'H':
			return 4;
		case 'I':
			return 1;
		case 'J':
			return 8;
		case 'K':
			return 5;
		case 'L':
			return 1;
		case 'M':
			return 3;
		case 'N':
			return 1;
		case 'O':
			return 1;
		case 'P':
			return 3;
		case 'Q':
			return 10;
		case 'R':
			return 1;
		case 'S':
			return 1;
		case 'T':
			return 1;
		case 'U':
			return 1;
		case 'V':
			return 4;
		case 'W':
			return 4;
		case 'X':
			return 8;
		case 'Y':
			return 4;
		case 'Z':
			return 10;
		default:
			return 1;
	}
};
var $author$project$WordSpellingGame$defaultSwedishLetterValue = function (_char) {
	switch (_char) {
		case 'A':
			return 1;
		case 'B':
			return 4;
		case 'C':
			return 8;
		case 'D':
			return 1;
		case 'E':
			return 1;
		case 'F':
			return 4;
		case 'G':
			return 2;
		case 'H':
			return 3;
		case 'I':
			return 1;
		case 'J':
			return 8;
		case 'K':
			return 3;
		case 'L':
			return 1;
		case 'M':
			return 3;
		case 'N':
			return 1;
		case 'O':
			return 2;
		case 'P':
			return 3;
		case 'Q':
			return 10;
		case 'R':
			return 1;
		case 'S':
			return 1;
		case 'T':
			return 1;
		case 'U':
			return 3;
		case 'V':
			return 4;
		case 'W':
			return 10;
		case 'X':
			return 10;
		case 'Y':
			return 8;
		case 'Z':
			return 10;
		case 'Å':
			return 4;
		case 'Ä':
			return 4;
		case 'Ö':
			return 4;
		default:
			return 1;
	}
};
var $author$project$WordSpellingGame$letterValueInputFor$ = function (_char, setup) {
	var _v0 = $lamdera$containers$SeqDict$get$(_char, setup.letterValues);
	if (!_v0.$) {
		var input = _v0.a;
		return input;
	} else {
		return $elm$core$String$fromInt(
			function () {
				var _v1 = setup.language;
				if (!_v1) {
					return $author$project$WordSpellingGame$defaultEnglishLetterValue(_char);
				} else {
					return $author$project$WordSpellingGame$defaultSwedishLetterValue(_char);
				}
			}());
	}
};
var $author$project$WordSpellingGame$letterValueInputFor = F2($author$project$WordSpellingGame$letterValueInputFor$);
var $author$project$NonemptyDict$toNonemptyList = function (_v0) {
	var id = _v0.a;
	var a = _v0.b;
	var dict = _v0.c;
	return $lamdera$containers$SeqDict$foldr$(
		F3(
			function (k, v, list) {
				return $mgold$elm_nonempty_list$List$Nonempty$cons$(
					_Utils_Tuple2(k, v),
					list);
			}),
		$mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
			_Utils_Tuple2(id, a),
			_List_Nil),
		dict);
};
var $elm$core$String$toUpper = _String_toUpper;
var $author$project$WordSpellingGame$wildcardMax = 2;
var $author$project$WordSpellingGame$parseLettersAndValues = function (setup) {
	var parsedLetters = function () {
		var distributionChars = $elm$core$List$filter$(
			function (_char) {
				return !$elm$core$List$member$(
					_char,
					_List_fromArray(
						['\n', '\r', '\t']));
			},
			$elm$core$String$toList(
				$elm$core$String$toUpper(setup.letters)));
		var counts = $elm$core$List$foldl$(
			F2(
				function (_char, acc) {
					return (_char === ' ') ? $author$project$SeqDictHelper$increment$($author$project$WordSpellingGame$Wildcard, acc) : $author$project$SeqDictHelper$increment$(
						$author$project$WordSpellingGame$Letter(_char),
						acc);
				}),
			$lamdera$containers$SeqDict$empty,
			distributionChars);
		var _v7 = $author$project$NonemptyDict$fromSeqDict(counts);
		if (!_v7.$) {
			var nonempty = _v7.a;
			var _v8 = $author$project$NonemptyDict$get$($author$project$WordSpellingGame$Wildcard, nonempty);
			if (!_v8.$) {
				var value = _v8.a;
				return (_Utils_cmp(
					$author$project$OneOrGreater$toInt(value),
					$author$project$WordSpellingGame$wildcardMax) > 0) ? $elm$core$Result$Err('No more than 2 wildcards (spaces) are allowed') : $elm$core$Result$Ok(nonempty);
			} else {
				return $elm$core$Result$Ok(nonempty);
			}
		} else {
			return $elm$core$Result$Err('Letters: enter at least one letter');
		}
	}();
	if (!parsedLetters.$) {
		var counts = parsedLetters.a;
		var result = $mgold$elm_nonempty_list$List$Nonempty$foldl$(
			F2(
				function (_v3, result2) {
					var letterOrWildcard = _v3.a;
					var count = _v3.b;
					if (!result2.$) {
						var list = result2.a;
						if (!letterOrWildcard.$) {
							var _char = letterOrWildcard.a;
							var _v6 = $elm$core$String$toInt(
								$elm$core$String$trim(
									$author$project$WordSpellingGame$letterValueInputFor$(_char, setup)));
							if (!_v6.$) {
								var value = _v6.a;
								return $elm$core$Result$Ok(
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											letterOrWildcard,
											{count: count, value: value}),
										list));
							} else {
								return $elm$core$Result$Err(
									'Letter values: enter a whole number for ' + $elm$core$String$fromChar(_char));
							}
						} else {
							return $elm$core$Result$Ok(
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										letterOrWildcard,
										{count: count, value: 0}),
									list));
						}
					} else {
						var error = result2.a;
						return $elm$core$Result$Err(error);
					}
				}),
			$elm$core$Result$Ok(_List_Nil),
			$author$project$NonemptyDict$toNonemptyList(counts));
		if (!result.$) {
			var list = result.a;
			var _v2 = $author$project$NonemptyDict$fromList(
				$elm$core$List$reverse(list));
			if (!_v2.$) {
				var nonempty = _v2.a;
				return $elm$core$Result$Ok(nonempty);
			} else {
				return $elm$core$Result$Err('Letters: enter at least one letter');
			}
		} else {
			var error = result.a;
			return $elm$core$Result$Err(error);
		}
	} else {
		var error = parsedLetters.a;
		return $elm$core$Result$Err(error);
	}
};
var $author$project$WordSpellingGame$parseTimeControl = function (setup) {
	var _v0 = $elm$core$String$toFloat(
		$elm$core$String$trim(setup.mainTimeInput));
	if (_v0.$ === 1) {
		return $elm$core$Result$Err('Main time: enter a number of minutes');
	} else {
		var minutes = _v0.a;
		if (minutes <= 0) {
			return $elm$core$Result$Err('Main time must be greater than 0');
		} else {
			var _v1 = $elm$core$String$toFloat(
				$elm$core$String$trim(setup.incrementInput));
			if (_v1.$ === 1) {
				return $elm$core$Result$Err('Increment: enter a number of seconds');
			} else {
				var increment = _v1.a;
				return (increment < 0) ? $elm$core$Result$Err('Increment cannot be negative') : $elm$core$Result$Ok(
					{
						increment: $ianmackenzie$elm_units$Duration$seconds(increment),
						mainTime: $ianmackenzie$elm_units$Duration$minutes(minutes)
					});
			}
		}
	}
};
var $author$project$WordSpellingGame$validateSetup$ = function (createdBy, time, setup) {
	var _v0 = $author$project$WordSpellingGame$parseTimeControl(setup);
	if (_v0.$ === 1) {
		var error = _v0.a;
		return $elm$core$Result$Err(error);
	} else {
		var timeControls = _v0.a;
		var _v1 = $author$project$OneOrGreater$fromInt(setup.traySize);
		if (!_v1.$) {
			var traySize = _v1.a;
			var _v2 = $author$project$WordSpellingGame$parseLettersAndValues(setup);
			if (!_v2.$) {
				var letters = _v2.a;
				return $elm$core$Result$Ok(
					{
						createdBy: createdBy,
						fullTrayBonus: setup.fullTrayBonus,
						language: setup.language,
						letters: letters,
						placeWordAttempts: setup.placeWordAttempts,
						seed: $author$project$Id$toInt(createdBy) + (10000 * (($lamdera$program_test$Effect$Time$posixToMillis(time) / 10000) | 0)),
						timeControls: timeControls,
						traySize: traySize
					});
			} else {
				var error = _v2.a;
				return $elm$core$Result$Err(error);
			}
		} else {
			return $elm$core$Result$Err('Tray size must be at least 1');
		}
	}
};
var $author$project$WordSpellingGame$validateSetup = F3($author$project$WordSpellingGame$validateSetup$);
var $author$project$WordSpellingGame$updateSetup$ = function (time, currentUserId, msg, setup) {
	switch (msg.$) {
		case 0:
			var input = msg.a;
			return _Utils_Tuple2(
				$author$project$WordSpellingGame$Setup(
					_Utils_update(
						setup,
						{
							error: $elm$core$Maybe$Nothing,
							traySize: $elm$core$Maybe$withDefault$(
								setup.traySize,
								$elm$core$String$toInt(
									$elm$core$String$trim(input)))
						})),
				$elm$core$Maybe$Nothing);
		case 1:
			var input = msg.a;
			return _Utils_Tuple2(
				$author$project$WordSpellingGame$Setup(
					_Utils_update(
						setup,
						{
							error: $elm$core$Maybe$Nothing,
							fullTrayBonus: $elm$core$Maybe$withDefault$(
								setup.fullTrayBonus,
								$elm$core$String$toInt(
									$elm$core$String$trim(input)))
						})),
				$elm$core$Maybe$Nothing);
		case 2:
			var input = msg.a;
			return _Utils_Tuple2(
				$author$project$WordSpellingGame$Setup(
					_Utils_update(
						setup,
						{error: $elm$core$Maybe$Nothing, letters: input})),
				$elm$core$Maybe$Nothing);
		case 3:
			var _char = msg.a;
			var input = msg.b;
			return _Utils_Tuple2(
				$author$project$WordSpellingGame$Setup(
					_Utils_update(
						setup,
						{
							error: $elm$core$Maybe$Nothing,
							letterValues: $lamdera$containers$SeqDict$insert$(_char, input, setup.letterValues)
						})),
				$elm$core$Maybe$Nothing);
		case 4:
			var attempts = msg.a;
			return _Utils_Tuple2(
				$author$project$WordSpellingGame$Setup(
					_Utils_update(
						setup,
						{placeWordAttempts: attempts})),
				$elm$core$Maybe$Nothing);
		case 5:
			return _Utils_Tuple2(
				$author$project$WordSpellingGame$Setup(
					_Utils_update(
						setup,
						{
							error: $elm$core$Maybe$Nothing,
							letterValues: $lamdera$containers$SeqDict$empty,
							letters: $author$project$WordSpellingGame$defaultLetters(setup.language)
						})),
				$elm$core$Maybe$Nothing);
		case 6:
			var _v1 = $author$project$WordSpellingGame$validateSetup$(currentUserId, time, setup);
			if (!_v1.$) {
				var validated = _v1.a;
				return _Utils_Tuple2(
					$author$project$WordSpellingGame$Game(
						$author$project$WordSpellingGame$initGame$(
							time,
							currentUserId,
							validated,
							$author$project$WordSpellingGame$initShared(validated))),
					$elm$core$Maybe$Just(validated));
			} else {
				var error = _v1.a;
				return _Utils_Tuple2(
					$author$project$WordSpellingGame$Setup(
						_Utils_update(
							setup,
							{
								error: $elm$core$Maybe$Just(error)
							})),
					$elm$core$Maybe$Nothing);
			}
		case 7:
			return _Utils_Tuple2($author$project$WordSpellingGame$CancelSetup, $elm$core$Maybe$Nothing);
		case 8:
			var language = msg.a;
			return _Utils_Tuple2(
				$author$project$WordSpellingGame$Setup(
					_Utils_update(
						setup,
						{
							language: language,
							letters: $author$project$WordSpellingGame$defaultLetters(language)
						})),
				$elm$core$Maybe$Nothing);
		default:
			return _Utils_Tuple2(
				$author$project$WordSpellingGame$Setup(
					_Utils_update(
						setup,
						{advancedSettingsExpanded: !setup.advancedSettingsExpanded})),
				$elm$core$Maybe$Nothing);
	}
};
var $author$project$WordSpellingGame$updateSetup = F4($author$project$WordSpellingGame$updateSetup$);
var $author$project$Game$update$ = function (time, windowSize, localUser, guildOrDmId, msg, newMatchId, maybeMatch, model) {
	var currentUserId = localUser.session.userId;
	switch (msg.$) {
		case 6:
			var matchId = msg.a;
			return _Utils_Tuple2(
				model,
				_List_fromArray(
					[
						$author$project$Game$OutLocalChange(
						$author$project$Game$CreatePublicLink$(matchId, $author$project$UserSession$EmptyPlaceholder))
					]));
		case 7:
			var text = msg.a;
			return _Utils_Tuple2(
				model,
				_List_fromArray(
					[
						$author$project$Game$CopyText(text)
					]));
		case 0:
			var goMsg = msg.a;
			if (!maybeMatch.$) {
				if (!maybeMatch.a.b.$) {
					var _v2 = maybeMatch.a;
					var matchId = _v2.a;
					var matchData = _v2.b.a;
					var _v3 = matchData.data;
					if (!_v3.$) {
						var setup = _v3.a;
						var cache = _v3.c;
						var _v4 = $author$project$Go$updateGame$(
							time,
							currentUserId,
							goMsg,
							setup,
							cache,
							function () {
								var _v5 = $lamdera$containers$SeqDict$get$(matchId, model.startedGames);
								if ((!_v5.$) && (!_v5.a.$)) {
									var goModel2 = _v5.a.a;
									return goModel2;
								} else {
									return $author$project$Go$initGame;
								}
							}());
						var goModel = _v4.a;
						var maybeLocalChange = _v4.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									startedGames: $lamdera$containers$SeqDict$insert$(
										matchId,
										$author$project$Game$GoModel_Game(goModel),
										model.startedGames)
								}),
							function () {
								if (!maybeLocalChange.$) {
									var localChange = maybeLocalChange.a;
									return _List_fromArray(
										[
											$author$project$Game$OutLocalChange(
											$author$project$Game$LocalChange_Go$(
												matchId,
												$author$project$Go$Action(localChange)))
										]);
								} else {
									return _List_Nil;
								}
							}());
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				} else {
					var _v7 = maybeMatch.a;
					return _Utils_Tuple2(model, _List_Nil);
				}
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		case 1:
			var goMsg = msg.a;
			var _v8 = $author$project$Go$updateSetup$(
				currentUserId,
				goMsg,
				function () {
					var _v9 = model.setup;
					if (_v9.$ === 1) {
						var setup = _v9.a;
						return setup;
					} else {
						return $author$project$Go$initSetup;
					}
				}());
			var goModel = _v8.a;
			var maybeStartMatch = _v8.b;
			return _Utils_Tuple2(
				function () {
					switch (goModel.$) {
						case 0:
							var setup = goModel.a;
							return _Utils_update(
								model,
								{
									setup: $author$project$Game$GoModel_Setup(setup)
								});
						case 1:
							var gameModel = goModel.a;
							return _Utils_update(
								model,
								{
									startedGames: $lamdera$containers$SeqDict$insert$(
										newMatchId,
										$author$project$Game$GoModel_Game(gameModel),
										model.startedGames)
								});
						default:
							return _Utils_update(
								model,
								{setup: $author$project$Game$GameSelect});
					}
				}(),
				function () {
					if (!maybeStartMatch.$) {
						var setup = maybeStartMatch.a;
						return _Utils_ap(
							_Utils_eq(
								$author$project$Id$GuildOrDmId_Dm(
									{otherUserId: currentUserId}),
								guildOrDmId) ? _List_fromArray(
								[
									$author$project$Game$OutLocalChange(
									$author$project$Game$LocalChange_Go$(
										newMatchId,
										$author$project$Go$Action(
											{
												change: $author$project$Go$Joined(currentUserId),
												time: time
											})))
								]) : _List_Nil,
							_List_fromArray(
								[
									$author$project$Game$OutLocalChange(
									$author$project$Game$LocalChange_Go$(
										newMatchId,
										$author$project$Go$StartMatch$(time, setup))),
									$author$project$Game$OutSelectMatch(
									$elm$core$Maybe$Just(newMatchId))
								]));
					} else {
						return _List_Nil;
					}
				}());
		case 2:
			var wordSpellingGameMsg = msg.a;
			if (!maybeMatch.$) {
				if (!maybeMatch.a.b.$) {
					var _v13 = maybeMatch.a;
					var matchId = _v13.a;
					var matchData = _v13.b.a;
					var _v14 = _Utils_Tuple2(
						matchData.data,
						$lamdera$containers$SeqDict$get$(matchId, model.startedGames));
					if (((_v14.a.$ === 1) && (!_v14.b.$)) && (_v14.b.a.$ === 1)) {
						var _v15 = _v14.a;
						var setup = _v15.a;
						var cache = _v15.c;
						var game = _v14.b.a.a;
						var _v16 = $author$project$WordSpellingGame$updateGame$(time, windowSize, currentUserId, setup, cache, wordSpellingGameMsg, game);
						var game2 = _v16.a;
						var maybeAction = _v16.b;
						var maybeOutMsg = _v16.c;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									startedGames: $lamdera$containers$SeqDict$insert$(
										matchId,
										$author$project$Game$WordSpellingGame_Game(game2),
										model.startedGames)
								}),
							_Utils_ap(
								function () {
									if (!maybeAction.$) {
										var action = maybeAction.a;
										return _List_fromArray(
											[
												$author$project$Game$OutLocalChange(
												$author$project$Game$LocalChange_WordSpellingGame$(
													matchId,
													$author$project$WordSpellingGame$Action(
														{change: action, time: time, userId: currentUserId}))),
												$author$project$Game$ScrollToBottom($author$project$WordSpellingGame$pastWordsContainerId)
											]);
									} else {
										return _List_Nil;
									}
								}(),
								function () {
									if (!maybeOutMsg.$) {
										switch (maybeOutMsg.a.$) {
											case 0:
												var word = maybeOutMsg.a.a;
												return _List_fromArray(
													[
														$author$project$Game$FetchWordDefinition(word)
													]);
											case 1:
												var moveNumber = maybeOutMsg.a.a;
												return _List_fromArray(
													[
														$author$project$Game$OutReplyToGame$(
														matchId,
														$author$project$Message$RepliedTo_WordSpellingGameMove(moveNumber))
													]);
											default:
												var target = maybeOutMsg.a.a;
												return _List_fromArray(
													[
														$author$project$Game$OpenWordSpellingGameReactionEmojiSelector$(guildOrDmId, matchId, target)
													]);
										}
									} else {
										return _List_Nil;
									}
								}()));
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				} else {
					var _v19 = maybeMatch.a;
					return _Utils_Tuple2(model, _List_Nil);
				}
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		case 3:
			var wordSpellingGameMsg = msg.a;
			var _v20 = $author$project$WordSpellingGame$updateSetup$(
				time,
				currentUserId,
				wordSpellingGameMsg,
				function () {
					var _v21 = model.setup;
					if (_v21.$ === 2) {
						var setup = _v21.a;
						return setup;
					} else {
						return $author$project$WordSpellingGame$initSetup;
					}
				}());
			var gameOrSetup = _v20.a;
			var maybeSetup = _v20.b;
			return _Utils_Tuple2(
				function () {
					switch (gameOrSetup.$) {
						case 0:
							var setup = gameOrSetup.a;
							return _Utils_update(
								model,
								{
									setup: $author$project$Game$WordSpellingGame_Setup(setup)
								});
						case 1:
							var game = gameOrSetup.a;
							return _Utils_update(
								model,
								{
									startedGames: $lamdera$containers$SeqDict$insert$(
										newMatchId,
										$author$project$Game$WordSpellingGame_Game(game),
										model.startedGames)
								});
						default:
							return _Utils_update(
								model,
								{setup: $author$project$Game$GameSelect});
					}
				}(),
				function () {
					if (!maybeSetup.$) {
						var setup = maybeSetup.a;
						return _List_fromArray(
							[
								$author$project$Game$OutLocalChange(
								$author$project$Game$LocalChange_WordSpellingGame$(
									newMatchId,
									$author$project$WordSpellingGame$StartMatch$(time, setup))),
								$author$project$Game$OutSelectMatch(
								$elm$core$Maybe$Just(newMatchId))
							]);
					} else {
						return _List_Nil;
					}
				}());
		case 4:
			var sheepMsg = msg.a;
			if (!maybeMatch.$) {
				if (!maybeMatch.a.b.$) {
					var _v25 = maybeMatch.a;
					var matchId = _v25.a;
					var matchData = _v25.b.a;
					var _v26 = _Utils_Tuple2(
						matchData.data,
						$lamdera$containers$SeqDict$get$(matchId, model.startedGames));
					if (((_v26.a.$ === 2) && (!_v26.b.$)) && (_v26.b.a.$ === 2)) {
						var _v27 = _v26.a;
						var setup = _v27.a;
						var cache = _v27.c;
						var oldGame = _v26.b.a.a;
						var _v28 = $author$project$SheepGame$updateGame$(localUser, setup, cache, sheepMsg, oldGame);
						var game = _v28.a;
						var maybeAction = _v28.b;
						var outMsg = _v28.c;
						var changed = $author$project$SheepGame$changedInputs$(oldGame, game);
						var counters = $elm$core$List$foldl$(
							F2(
								function (input, dict) {
									return $lamdera$containers$SeqDict$update$(
										_Utils_Tuple2(matchId, input),
										function (count) {
											return $elm$core$Maybe$Just(
												$elm$core$Maybe$withDefault$(0, count) + 1);
										},
										dict);
								}),
							model.sheepGameSaveCounters,
							changed);
						var model2 = _Utils_update(
							model,
							{
								sheepGameSaveCounters: counters,
								startedGames: $lamdera$containers$SeqDict$insert$(
									matchId,
									$author$project$Game$SheepGame_Game(game),
									model.startedGames)
							});
						var _v29 = function () {
							if ((!maybeAction.$) && (maybeAction.a.$ === 6)) {
								var count = maybeAction.a.a;
								return $author$project$Game$sheepGameQuestionRevealed$(
									matchId,
									$author$project$Id$toInt(count),
									model2);
							} else {
								return _Utils_Tuple2(model2, $elm$core$Maybe$Nothing);
							}
						}();
						var model3 = _v29.a;
						var maybeScrollTo = _v29.b;
						return _Utils_Tuple2(
							model3,
							_Utils_ap(
								function () {
									if (!maybeAction.$) {
										var action = maybeAction.a;
										return _List_fromArray(
											[
												$author$project$Game$OutLocalChange(
												$author$project$Game$LocalChange_SheepGame$(
													matchId,
													$author$project$SheepGame$Action(
														{change: action, time: time, userId: currentUserId})))
											]);
									} else {
										return _List_Nil;
									}
								}(),
								_Utils_ap(
									function () {
										if (!maybeScrollTo.$) {
											var scrollTo = maybeScrollTo.a;
											return _List_fromArray(
												[
													$author$project$Game$SmoothScrollTo(scrollTo)
												]);
										} else {
											return _List_Nil;
										}
									}(),
									_Utils_ap(
										$elm$core$List$map$(
											function (input) {
												return $author$project$Game$SaveSheepGameInputAfterDelay$(
													guildOrDmId,
													matchId,
													input,
													$elm$core$Maybe$withDefault$(
														0,
														$lamdera$containers$SeqDict$get$(
															_Utils_Tuple2(matchId, input),
															counters)));
											},
											changed),
										function () {
											switch (outMsg.$) {
												case 8:
													var target = outMsg.a;
													return _List_fromArray(
														[
															$author$project$Game$OpenSheepGameReactionEmojiSelector$(guildOrDmId, matchId, target)
														]);
												case 9:
													var target = outMsg.a;
													return _List_fromArray(
														[
															$author$project$Game$OutReplyToGame$(
															matchId,
															$author$project$Game$sheepGameReplyTarget(target))
														]);
												default:
													return $author$project$Game$sheepGameOutMsgs$(time, newMatchId, outMsg);
											}
										}()))));
					} else {
						return _Utils_Tuple2(model, _List_Nil);
					}
				} else {
					var _v34 = maybeMatch.a;
					return _Utils_Tuple2(model, _List_Nil);
				}
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		case 5:
			var sheepMsg = msg.a;
			var oldSetup = function () {
				var _v37 = model.setup;
				if (_v37.$ === 3) {
					var setup = _v37.a;
					return setup;
				} else {
					return $author$project$SheepGame$initSetup;
				}
			}();
			var _v35 = $author$project$SheepGame$updateSetup$(localUser, sheepMsg, oldSetup);
			var gameOrSetup = _v35.a;
			var outMsg = _v35.b;
			var outMsg2 = $author$project$Game$sheepGameOutMsgs$(time, newMatchId, outMsg);
			switch (gameOrSetup.$) {
				case 0:
					var setup = gameOrSetup.a;
					return _Utils_eq(setup.questions, oldSetup.questions) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{
								setup: $author$project$Game$SheepGame_Setup(setup)
							}),
						outMsg2) : _Utils_Tuple2(
						_Utils_update(
							model,
							{
								setup: $author$project$Game$SheepGame_Setup(setup),
								sheepGameQuestionsCounter: model.sheepGameQuestionsCounter + 1
							}),
						A2(
							$elm$core$List$cons,
							$author$project$Game$SaveSheepGameQuestionsAfterDelay$(guildOrDmId, model.sheepGameQuestionsCounter + 1),
							outMsg2));
				case 1:
					var game = gameOrSetup.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								sheepGameQuestionsCounter: model.sheepGameQuestionsCounter + 1,
								startedGames: $lamdera$containers$SeqDict$insert$(
									newMatchId,
									$author$project$Game$SheepGame_Game(game),
									model.startedGames)
							}),
						A2(
							$elm$core$List$cons,
							$author$project$Game$SaveSheepGameQuestions($author$project$IdArray$empty),
							outMsg2));
				default:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{setup: $author$project$Game$GameSelect, sheepGameQuestionsCounter: model.sheepGameQuestionsCounter + 1}),
						A2(
							$elm$core$List$cons,
							$author$project$Game$SaveSheepGameQuestions($author$project$IdArray$empty),
							outMsg2));
			}
		case 10:
			var game = msg.a;
			switch (game) {
				case 0:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								setup: $author$project$Game$GoModel_Setup($author$project$Go$initSetup)
							}),
						_List_Nil);
				case 1:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								setup: $author$project$Game$WordSpellingGame_Setup($author$project$WordSpellingGame$initSetup)
							}),
						_List_Nil);
				default:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								setup: $author$project$Game$SheepGame_Setup(
									$author$project$SheepGame$initSetupFromSavedQuestions(localUser.session.savedSheepGameQuestions))
							}),
						_List_Nil);
			}
		case 9:
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{setup: $author$project$Game$GameSelect}),
				_List_fromArray(
					[
						$author$project$Game$OutSelectMatch($elm$core$Maybe$Nothing)
					]));
		case 8:
			var selectedMatchId = msg.a;
			return _Utils_Tuple2(
				model,
				_List_fromArray(
					[
						$author$project$Game$OutSelectMatch(
						$elm$core$Maybe$Just(selectedMatchId))
					]));
		default:
			return _Utils_Tuple2(model, _List_Nil);
	}
};
var $author$project$Game$update = F8($author$project$Game$update$);
var $author$project$ImageEditor$BottomLeft = 2;
var $author$project$ImageEditor$BottomRight = 3;
var $author$project$ImageEditor$Center = 4;
var $author$project$ImageEditor$Cropping = {$: 1};
var $author$project$ImageEditor$GotImageSize = function (a) {
	return {$: 8, a: a};
};
var $author$project$ImageEditor$GotImageUrl = function (a) {
	return {$: 2, a: a};
};
var $author$project$ImageEditor$SelectedImage = function (a) {
	return {$: 1, a: a};
};
var $author$project$ImageEditor$TopLeft = 0;
var $author$project$ImageEditor$TopRight = 1;
var $author$project$ImageEditor$UploadedImage = function (a) {
	return {$: 12, a: a};
};
var $author$project$ImageEditor$Uploading = function (a) {
	return {$: 2, a: a};
};
var $author$project$ImageEditor$UploadingError = {$: 3};
var $author$project$Ports$CropImageData$ = function (requestId, imageUrl, cropX, cropY, cropWidth, cropHeight, width, height) {
	return {cropHeight: cropHeight, cropWidth: cropWidth, cropX: cropX, cropY: cropY, height: height, imageUrl: imageUrl, requestId: requestId, width: width};
};
var $author$project$Ports$CropImageData = F8($author$project$Ports$CropImageData$);
var $author$project$Ports$cropImageDataCodec = $miniBill$elm_codec$Codec$buildObject(
	$miniBill$elm_codec$Codec$field$(
		'height',
		function ($) {
			return $.height;
		},
		$author$project$CodecExtra$quantityInt,
		$miniBill$elm_codec$Codec$field$(
			'width',
			function ($) {
				return $.width;
			},
			$author$project$CodecExtra$quantityInt,
			$miniBill$elm_codec$Codec$field$(
				'cropHeight',
				function ($) {
					return $.cropHeight;
				},
				$author$project$CodecExtra$quantityInt,
				$miniBill$elm_codec$Codec$field$(
					'cropWidth',
					function ($) {
						return $.cropWidth;
					},
					$author$project$CodecExtra$quantityInt,
					$miniBill$elm_codec$Codec$field$(
						'cropY',
						function ($) {
							return $.cropY;
						},
						$author$project$CodecExtra$quantityInt,
						$miniBill$elm_codec$Codec$field$(
							'cropX',
							function ($) {
								return $.cropX;
							},
							$author$project$CodecExtra$quantityInt,
							$miniBill$elm_codec$Codec$field$(
								'imageUrl',
								function ($) {
									return $.imageUrl;
								},
								$miniBill$elm_codec$Codec$string,
								$miniBill$elm_codec$Codec$field$(
									'requestId',
									function ($) {
										return $.requestId;
									},
									$miniBill$elm_codec$Codec$int,
									$miniBill$elm_codec$Codec$object($author$project$Ports$CropImageData))))))))));
var $author$project$Ports$cropImageToJsName = 'martinsstewart_crop_image_to_js';
var $author$project$Ports$martinsstewart_crop_image_to_js = _Platform_outgoingPort('martinsstewart_crop_image_to_js', $elm$core$Basics$identity);
var $author$project$Ports$cropImageToJs = function (data) {
	return A3(
		$lamdera$program_test$Effect$Command$sendToJs,
		$author$project$Ports$cropImageToJsName,
		$author$project$Ports$martinsstewart_crop_image_to_js,
		A2($miniBill$elm_codec$Codec$encodeToValue, $author$project$Ports$cropImageDataCodec, data));
};
var $ianmackenzie$elm_units$Pixels$pixels = function (numPixels) {
	return numPixels;
};
var $author$project$ImageEditor$defaultSize = $ianmackenzie$elm_units$Pixels$pixels(80);
var $author$project$ImageEditor$getActualImageState = function (imageData) {
	var minY = 0;
	var minX = 0;
	var maxX = 1;
	var aspectRatio = function () {
		var _v2 = imageData.imageSize;
		if (!_v2.$) {
			var _v3 = _v2.a;
			var w = _v3.a;
			var h = _v3.b;
			return h / w;
		} else {
			return 1;
		}
	}();
	var maxY = aspectRatio;
	var _v0 = imageData.dragState;
	if (!_v0.$) {
		var dragState = _v0.a;
		var _v1 = dragState.dragPart;
		switch (_v1) {
			case 4:
				return _Utils_update(
					imageData,
					{
						x: $elm$core$Basics$clamp$(minX, maxX - imageData.size, (imageData.x + dragState.currentX) - dragState.startX),
						y: $elm$core$Basics$clamp$(minY, maxY - imageData.size, (imageData.y + dragState.currentY) - dragState.startY)
					});
			case 0:
				var yDelta = dragState.currentY - dragState.startY;
				var xDelta = dragState.currentX - dragState.startX;
				var maxDelta = $elm$core$Basics$max$(
					-$elm$core$Basics$min$(imageData.x, imageData.y),
					$elm$core$Basics$min$(
						imageData.size - 0.05,
						$elm$core$Basics$min$(xDelta, yDelta)));
				return _Utils_update(
					imageData,
					{size: imageData.size - maxDelta, x: imageData.x + maxDelta, y: imageData.y + maxDelta});
			case 1:
				var yDelta = dragState.currentY - dragState.startY;
				var xDelta = dragState.currentX - dragState.startX;
				var maxDelta = $elm$core$Basics$max$(
					-$elm$core$Basics$min$((maxX - imageData.x) - imageData.size, imageData.y),
					$elm$core$Basics$min$(
						imageData.size - 0.05,
						$elm$core$Basics$min$(-xDelta, yDelta)));
				return _Utils_update(
					imageData,
					{size: imageData.size - maxDelta, y: imageData.y + maxDelta});
			case 2:
				var yDelta = dragState.currentY - dragState.startY;
				var xDelta = dragState.currentX - dragState.startX;
				var maxDelta = $elm$core$Basics$max$(
					-$elm$core$Basics$min$(imageData.x, (maxY - imageData.y) - imageData.size),
					$elm$core$Basics$min$(
						imageData.size - 0.05,
						$elm$core$Basics$min$(xDelta, -yDelta)));
				return _Utils_update(
					imageData,
					{size: imageData.size - maxDelta, x: imageData.x + maxDelta});
			default:
				var yDelta = dragState.currentY - dragState.startY;
				var xDelta = dragState.currentX - dragState.startX;
				var maxDelta = $elm$core$Basics$max$(
					-$elm$core$Basics$min$((maxX - imageData.x) - imageData.size, (maxY - imageData.y) - imageData.size),
					$elm$core$Basics$min$(
						imageData.size - 0.05,
						$elm$core$Basics$min$(-xDelta, -yDelta)));
				return _Utils_update(
					imageData,
					{size: imageData.size - maxDelta});
		}
	} else {
		return imageData;
	}
};
var $author$project$ImageEditor$imageEditorWidth = function (windowSize) {
	return $elm$core$Basics$min$(
		400,
		$author$project$Coord$xRaw(windowSize));
};
var $author$project$ImageEditor$pixelToT$ = function (windowSize, value) {
	return value / $author$project$ImageEditor$imageEditorWidth(windowSize);
};
var $author$project$ImageEditor$pixelToT = F2($author$project$ImageEditor$pixelToT$);
var $author$project$ImageEditor$profileImagePlaceholderId = $lamdera$program_test$Effect$Browser$Dom$id('profile-image-placeholder-id');
var $lamdera$program_test$Effect$File$toUrl = function (file) {
	return $lamdera$program_test$Effect$Internal$FileToUrl$(
		$lamdera$program_test$Effect$File$toInternalFile(file),
		$lamdera$program_test$Effect$Internal$Succeed);
};
var $author$project$ImageEditor$updateDragState$ = function (tx, ty, imageData) {
	return _Utils_update(
		imageData,
		{
			dragState: function () {
				var _v0 = imageData.dragState;
				if (!_v0.$) {
					var dragState_ = _v0.a;
					return $elm$core$Maybe$Just(
						_Utils_update(
							dragState_,
							{currentX: tx, currentY: ty}));
				} else {
					return imageData.dragState;
				}
			}()
		});
};
var $author$project$ImageEditor$updateDragState = F3($author$project$ImageEditor$updateDragState$);
var $lamdera$program_test$Effect$Internal$BytesBody$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $lamdera$program_test$Effect$Internal$BytesBody = F2($lamdera$program_test$Effect$Internal$BytesBody$);
var $lamdera$program_test$Effect$Http$bytesBody = $lamdera$program_test$Effect$Internal$BytesBody;
var $author$project$FileStatus$uploadAvatar$ = function (onResult, file2) {
	return $lamdera$program_test$Effect$Http$riskyRequest(
		{
			body: A2($lamdera$program_test$Effect$Http$bytesBody, 'application/octet-stream', file2),
			expect: $lamdera$program_test$Effect$Http$expectJson$(
				onResult,
				$miniBill$elm_codec$Codec$decoder($author$project$FileStatus$uploadResponseCodec)),
			headers: _List_Nil,
			method: 'POST',
			timeout: $elm$core$Maybe$Just($ianmackenzie$elm_units$Duration$minute),
			tracker: $elm$core$Maybe$Just('avatar-file-upload'),
			url: $author$project$FileStatus$domain + '/file/upload'
		});
};
var $author$project$FileStatus$uploadAvatar = F2($author$project$FileStatus$uploadAvatar$);
var $author$project$ImageEditor$update$ = function (toBackendMsg, windowSize, msg, model) {
	switch (msg.$) {
		case 0:
			return _Utils_Tuple2(
				model,
				$lamdera$program_test$Effect$File$Select$file$(
					_List_fromArray(
						['image/png', 'image/jpg', 'image/jpeg']),
					$author$project$ImageEditor$SelectedImage));
		case 1:
			var file = msg.a;
			return _Utils_Tuple2(
				model,
				$lamdera$program_test$Effect$Task$perform$(
					$author$project$ImageEditor$GotImageUrl,
					$lamdera$program_test$Effect$File$toUrl(file)));
		case 2:
			var imageUrl = msg.a;
			return _Utils_Tuple2(
				{
					dragState: $elm$core$Maybe$Nothing,
					imageSize: $elm$core$Maybe$Nothing,
					imageUrl: $elm$core$Maybe$Just(imageUrl),
					size: 1,
					status: $author$project$ImageEditor$NotUploaded,
					x: 0,
					y: 0
				},
				$lamdera$program_test$Effect$Task$attempt$(
					$author$project$ImageEditor$GotImageSize,
					$lamdera$program_test$Effect$Browser$Dom$getElement($author$project$ImageEditor$profileImagePlaceholderId)));
		case 3:
			var x = msg.a;
			var y = msg.b;
			var _v1 = _Utils_Tuple2(
				$author$project$ImageEditor$pixelToT$(windowSize, x),
				$author$project$ImageEditor$pixelToT$(windowSize, y));
			var tx = _v1.a;
			var ty = _v1.b;
			var dragPart = $elmcraft$core_extra$List$Extra$minimumBy$(
				$elm$core$Tuple$second,
				$elm$core$List$map$(
					function (_v4) {
						var part = _v4.a;
						var partX = _v4.b;
						var partY = _v4.c;
						return _Utils_Tuple2(
							part,
							$elm$core$Basics$sqrt(
								A2($elm$core$Basics$pow, partX - tx, 2) + A2($elm$core$Basics$pow, partY - ty, 2)));
					},
					_List_fromArray(
						[
							_Utils_Tuple3(0, model.x, model.y),
							_Utils_Tuple3(1, model.x + model.size, model.y),
							_Utils_Tuple3(2, model.x, model.y + model.size),
							_Utils_Tuple3(3, model.x + model.size, model.y + model.size)
						])));
			var newDragState = {
				currentX: tx,
				currentY: ty,
				dragPart: function () {
					if (!dragPart.$) {
						var _v3 = dragPart.a;
						var part = _v3.a;
						var distance = _v3.b;
						return (distance > 0.07) ? 4 : part;
					} else {
						return 4;
					}
				}(),
				startX: tx,
				startY: ty
			};
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						dragState: $elm$core$Maybe$Just(newDragState)
					}),
				$lamdera$program_test$Effect$Command$none);
		case 5:
			var x = msg.a;
			var y = msg.b;
			return _Utils_Tuple2(
				$author$project$ImageEditor$updateDragState$(
					$author$project$ImageEditor$pixelToT$(windowSize, x),
					$author$project$ImageEditor$pixelToT$(windowSize, y),
					model),
				$lamdera$program_test$Effect$Command$none);
		case 4:
			return _Utils_Tuple2(
				function (a) {
					return _Utils_update(
						a,
						{dragState: $elm$core$Maybe$Nothing});
				}(
					$author$project$ImageEditor$getActualImageState(model)),
				$lamdera$program_test$Effect$Command$none);
		case 6:
			return _Utils_Tuple2(
				function (a) {
					return _Utils_update(
						a,
						{dragState: $elm$core$Maybe$Nothing});
				}(
					$author$project$ImageEditor$getActualImageState(model)),
				$lamdera$program_test$Effect$Command$none);
		case 7:
			var _v5 = _Utils_Tuple2(model.imageSize, model.imageUrl);
			if ((!_v5.a.$) && (!_v5.b.$)) {
				var _v6 = _v5.a.a;
				var w = _v6.a;
				var imageUrl = _v5.b.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{status: $author$project$ImageEditor$Cropping}),
					$author$project$Ports$cropImageToJs(
						{
							cropHeight: $author$project$ImageEditor$defaultSize,
							cropWidth: $author$project$ImageEditor$defaultSize,
							cropX: $ianmackenzie$elm_units$Pixels$pixels(
								$elm$core$Basics$round(model.x * w)),
							cropY: $ianmackenzie$elm_units$Pixels$pixels(
								$elm$core$Basics$round(model.y * w)),
							height: $ianmackenzie$elm_units$Pixels$pixels(
								$elm$core$Basics$round(w * model.size)),
							imageUrl: imageUrl,
							requestId: 0,
							width: $ianmackenzie$elm_units$Pixels$pixels(
								$elm$core$Basics$round(w * model.size))
						}));
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 8:
			var result = msg.a;
			if (!result.$) {
				var element = result.a.element;
				return (element.height <= 0) ? _Utils_Tuple2(
					model,
					$lamdera$program_test$Effect$Task$attempt$(
						$author$project$ImageEditor$GotImageSize,
						$lamdera$program_test$Effect$Browser$Dom$getElement($author$project$ImageEditor$profileImagePlaceholderId))) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							imageSize: $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$elm$core$Basics$round(element.width),
									$elm$core$Basics$round(element.height))),
							size: $elm$core$Basics$min$(1, element.height / element.width),
							x: 0,
							y: 0
						}),
					$lamdera$program_test$Effect$Command$none);
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 9:
			var result = msg.a;
			var _v8 = model.status;
			if (_v8.$ === 1) {
				if (!result.$) {
					var imageData = result.a;
					var _v10 = $elm$core$String$split$(';base64,', imageData.croppedImageUrl);
					if ((_v10.b && _v10.b.b) && (!_v10.b.b.b)) {
						var _v11 = _v10.b;
						var base64 = _v11.a;
						var _v12 = $danfishgold$base64_bytes$Base64$toBytes(base64);
						if (!_v12.$) {
							var bytes = _v12.a;
							return _Utils_Tuple2(
								model,
								$author$project$FileStatus$uploadAvatar$($author$project$ImageEditor$UploadedImage, bytes));
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{status: $author$project$ImageEditor$UploadingError}),
								$lamdera$program_test$Effect$Command$none);
						}
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{status: $author$project$ImageEditor$UploadingError}),
							$lamdera$program_test$Effect$Command$none);
					}
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{status: $author$project$ImageEditor$UploadingError}),
						$lamdera$program_test$Effect$Command$none);
				}
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 10:
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{imageSize: $elm$core$Maybe$Nothing, imageUrl: $elm$core$Maybe$Nothing}),
				$lamdera$program_test$Effect$Command$none);
		case 11:
			return _Utils_Tuple2(
				model,
				$lamdera$program_test$Effect$Lamdera$sendToBackend(
					toBackendMsg($elm$core$Maybe$Nothing)));
		default:
			var result = msg.a;
			if (!result.$) {
				var uploaded = result.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							status: $author$project$ImageEditor$Uploading(uploaded.fileHash)
						}),
					$lamdera$program_test$Effect$Lamdera$sendToBackend(
						toBackendMsg(
							$elm$core$Maybe$Just(uploaded.fileHash))));
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{status: $author$project$ImageEditor$UploadingError}),
					$lamdera$program_test$Effect$Command$none);
			}
	}
};
var $author$project$ImageEditor$update = F4($author$project$ImageEditor$update$);
var $author$project$ImageViewer$Pinching = function (a) {
	return {$: 2, a: a};
};
var $author$project$ImageViewer$scaleEpsilon = 0.0005;
var $author$project$ImageViewer$clampScale = function (scale) {
	return $elm$core$Basics$clamp$(0.2, 8, scale);
};
var $author$project$ImageViewer$zoomAround$ = function (windowSize, focusX, focusY, newScaleRaw, model) {
	var py = focusY - ($author$project$Coord$yRaw(windowSize) / 2);
	var px = focusX - ($author$project$Coord$xRaw(windowSize) / 2);
	var newScale = $author$project$ImageViewer$clampScale(newScaleRaw);
	var ratio = newScale / model.scale;
	return _Utils_update(
		model,
		{offsetX: (px * (1 - ratio)) + (ratio * model.offsetX), offsetY: (py * (1 - ratio)) + (ratio * model.offsetY), scale: newScale});
};
var $author$project$ImageViewer$zoomAround = F5($author$project$ImageViewer$zoomAround$);
var $author$project$ImageViewer$zoomEaseRate = 0.22;
var $author$project$ImageViewer$applyZoomEasing$ = function (windowSize, frames, model) {
	var diff = model.targetScale - model.scale;
	if (_Utils_cmp(
		$elm$core$Basics$abs(diff),
		$author$project$ImageViewer$scaleEpsilon) < 0) {
		return _Utils_eq(model.scale, model.targetScale) ? model : $author$project$ImageViewer$zoomAround$(windowSize, model.zoomFocusX, model.zoomFocusY, model.targetScale, model);
	} else {
		var t = 1 - A2($elm$core$Basics$pow, 1 - $author$project$ImageViewer$zoomEaseRate, frames);
		return $author$project$ImageViewer$zoomAround$(windowSize, model.zoomFocusX, model.zoomFocusY, model.scale + (diff * t), model);
	}
};
var $author$project$ImageViewer$applyZoomEasing = F3($author$project$ImageViewer$applyZoomEasing$);
var $author$project$ImageViewer$Dragging = function (a) {
	return {$: 1, a: a};
};
var $author$project$ImageViewer$beginDrag$ = function (x, y, model) {
	return _Utils_update(
		model,
		{
			interaction: $author$project$ImageViewer$Dragging(
				{offsetStartX: model.offsetX, offsetStartY: model.offsetY, startX: x, startY: y}),
			prevOffsetX: model.offsetX,
			prevOffsetY: model.offsetY,
			velocityX: 0,
			velocityY: 0
		});
};
var $author$project$ImageViewer$beginDrag = F3($author$project$ImageViewer$beginDrag$);
var $author$project$ImageViewer$centerX = function (windowSize) {
	return $author$project$Coord$xRaw(windowSize) / 2;
};
var $author$project$ImageViewer$centerY = function (windowSize) {
	return $author$project$Coord$yRaw(windowSize) / 2;
};
var $author$project$ImageViewer$continueDrag$ = function (x, y, model) {
	var _v0 = model.interaction;
	if (_v0.$ === 1) {
		var drag = _v0.a;
		var newOffsetY = drag.offsetStartY + (y - drag.startY);
		var newOffsetX = drag.offsetStartX + (x - drag.startX);
		return _Utils_update(
			model,
			{offsetX: newOffsetX, offsetY: newOffsetY, velocityX: newOffsetX - model.offsetX, velocityY: newOffsetY - model.offsetY});
	} else {
		return model;
	}
};
var $author$project$ImageViewer$continueDrag = F3($author$project$ImageViewer$continueDrag$);
var $author$project$ImageViewer$distance$ = function (_v0, _v1) {
	var xA = _v0.a;
	var yA = _v0.b;
	var xB = _v1.a;
	var yB = _v1.b;
	return $elm$core$Basics$sqrt(
		A2($elm$core$Basics$pow, xB - xA, 2) + A2($elm$core$Basics$pow, yB - yA, 2));
};
var $author$project$ImageViewer$distance = F2($author$project$ImageViewer$distance$);
var $author$project$ImageViewer$isOffScreen$ = function (windowSize, model) {
	var vw = $author$project$Coord$xRaw(windowSize);
	var vh = $author$project$Coord$yRaw(windowSize);
	var imageCenterY = (vh / 2) + model.offsetY;
	var imageCenterX = (vw / 2) + model.offsetX;
	var _v0 = $author$project$ImageViewer$displayedSize$(windowSize, model);
	var dw = _v0.a;
	var dh = _v0.b;
	return ((imageCenterX + (dw / 2)) < 0) || ((_Utils_cmp(imageCenterX - (dw / 2), vw) > 0) || (((imageCenterY + (dh / 2)) < 0) || (_Utils_cmp(imageCenterY - (dh / 2), vh) > 0)));
};
var $author$project$ImageViewer$isOffScreen = F2($author$project$ImageViewer$isOffScreen$);
var $author$project$ImageViewer$isOverImage$ = function (windowSize, x, y, model) {
	var imageCenterY = ($author$project$Coord$yRaw(windowSize) / 2) + model.offsetY;
	var imageCenterX = ($author$project$Coord$xRaw(windowSize) / 2) + model.offsetX;
	var _v0 = $author$project$ImageViewer$displayedSize$(windowSize, model);
	var imageWidth = _v0.a;
	var imageHeight = _v0.b;
	return (_Utils_cmp(
		$elm$core$Basics$abs(x - imageCenterX),
		imageWidth / 2) < 1) && (_Utils_cmp(
		$elm$core$Basics$abs(y - imageCenterY),
		imageHeight / 2) < 1);
};
var $author$project$ImageViewer$isOverImage = F4($author$project$ImageViewer$isOverImage$);
var $author$project$ImageViewer$pressMaxMovement = 10;
var $author$project$ImageViewer$pressedBackdrop$ = function (windowSize, model) {
	var _v0 = model.interaction;
	switch (_v0.$) {
		case 1:
			var drag = _v0.a;
			return (_Utils_cmp(
				$elm$core$Basics$abs(model.offsetX - drag.offsetStartX),
				$author$project$ImageViewer$pressMaxMovement) < 0) && ((_Utils_cmp(
				$elm$core$Basics$abs(model.offsetY - drag.offsetStartY),
				$author$project$ImageViewer$pressMaxMovement) < 0) && (!$author$project$ImageViewer$isOverImage$(windowSize, drag.startX, drag.startY, model)));
		case 2:
			return false;
		default:
			return false;
	}
};
var $author$project$ImageViewer$pressedBackdrop = F2($author$project$ImageViewer$pressedBackdrop$);
var $author$project$ImageViewer$endInteraction$ = function (windowSize, model) {
	return ($author$project$ImageViewer$isOffScreen$(windowSize, model) || $author$project$ImageViewer$pressedBackdrop$(windowSize, model)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		_Utils_update(
			model,
			{interaction: $author$project$ImageViewer$NoInteraction}));
};
var $author$project$ImageViewer$endInteraction = F2($author$project$ImageViewer$endInteraction$);
var $author$project$ImageViewer$frameMs = 1000 / 60;
var $author$project$ImageViewer$midpoint$ = function (_v0, _v1) {
	var xA = _v0.a;
	var yA = _v0.b;
	var xB = _v1.a;
	var yB = _v1.b;
	return _Utils_Tuple2((xA + xB) / 2, (yA + yB) / 2);
};
var $author$project$ImageViewer$midpoint = F2($author$project$ImageViewer$midpoint$);
var $author$project$ImageViewer$panDecay = 0.9;
var $author$project$ImageViewer$sampleDragVelocity$ = function (frames, model) {
	return _Utils_update(
		model,
		{prevOffsetX: model.offsetX, prevOffsetY: model.offsetY, velocityX: (model.offsetX - model.prevOffsetX) / frames, velocityY: (model.offsetY - model.prevOffsetY) / frames});
};
var $author$project$ImageViewer$sampleDragVelocity = F2($author$project$ImageViewer$sampleDragVelocity$);
var $author$project$ImageViewer$zoomTowards$ = function (focusX, focusY, newTargetScale, model) {
	return _Utils_update(
		model,
		{
			targetScale: $author$project$ImageViewer$clampScale(newTargetScale),
			zoomFocusX: focusX,
			zoomFocusY: focusY
		});
};
var $author$project$ImageViewer$zoomTowards = F4($author$project$ImageViewer$zoomTowards$);
var $author$project$ImageViewer$update$ = function (windowSize, msg, model) {
	switch (msg.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Just(
				$author$project$ImageViewer$zoomTowards$(
					$author$project$ImageViewer$centerX(windowSize),
					$author$project$ImageViewer$centerY(windowSize),
					model.targetScale * 1.25,
					model));
		case 2:
			return $elm$core$Maybe$Just(
				$author$project$ImageViewer$zoomTowards$(
					$author$project$ImageViewer$centerX(windowSize),
					$author$project$ImageViewer$centerY(windowSize),
					model.targetScale / 1.25,
					model));
		case 3:
			return $elm$core$Maybe$Just(model);
		case 4:
			var x = msg.a;
			var y = msg.b;
			return $elm$core$Maybe$Just(
				$author$project$ImageViewer$beginDrag$(x, y, model));
		case 5:
			var x = msg.a;
			var y = msg.b;
			return $elm$core$Maybe$Just(
				$author$project$ImageViewer$continueDrag$(x, y, model));
		case 6:
			return $author$project$ImageViewer$endInteraction$(windowSize, model);
		case 7:
			var deltaY = msg.a;
			var x = msg.b;
			var y = msg.c;
			return $elm$core$Maybe$Just(
				$author$project$ImageViewer$zoomTowards$(
					x,
					y,
					model.targetScale * ((deltaY > 0) ? 0.9 : 1.1),
					model));
		case 8:
			var positions = msg.a;
			if (positions.b) {
				if (positions.b.b) {
					var first = positions.a;
					var _v2 = positions.b;
					var second = _v2.a;
					var _v3 = $author$project$ImageViewer$midpoint$(first, second);
					var midX = _v3.a;
					var midY = _v3.b;
					return $elm$core$Maybe$Just(
						_Utils_update(
							model,
							{
								interaction: $author$project$ImageViewer$Pinching(
									{
										prevMidX: midX,
										prevMidY: midY,
										startDistance: $elm$core$Basics$max$(
											1,
											$author$project$ImageViewer$distance$(first, second)),
										startScale: model.scale
									}),
								velocityX: 0,
								velocityY: 0
							}));
				} else {
					var _v4 = positions.a;
					var x = _v4.a;
					var y = _v4.b;
					return $elm$core$Maybe$Just(
						$author$project$ImageViewer$beginDrag$(x, y, model));
				}
			} else {
				return $elm$core$Maybe$Just(model);
			}
		case 9:
			var positions = msg.a;
			var _v5 = _Utils_Tuple2(model.interaction, positions);
			_v5$2:
			while (true) {
				if (_v5.b.b) {
					switch (_v5.a.$) {
						case 2:
							if (_v5.b.b.b) {
								var pinch = _v5.a.a;
								var _v6 = _v5.b;
								var first = _v6.a;
								var _v7 = _v6.b;
								var second = _v7.a;
								var _v8 = $author$project$ImageViewer$midpoint$(first, second);
								var midX = _v8.a;
								var midY = _v8.b;
								var panned = _Utils_update(
									model,
									{offsetX: model.offsetX + (midX - pinch.prevMidX), offsetY: model.offsetY + (midY - pinch.prevMidY)});
								var zoomed = $author$project$ImageViewer$zoomAround$(
									windowSize,
									midX,
									midY,
									(pinch.startScale * $author$project$ImageViewer$distance$(first, second)) / pinch.startDistance,
									panned);
								return $elm$core$Maybe$Just(
									_Utils_update(
										zoomed,
										{
											interaction: $author$project$ImageViewer$Pinching(
												_Utils_update(
													pinch,
													{prevMidX: midX, prevMidY: midY})),
											targetScale: zoomed.scale,
											zoomFocusX: midX,
											zoomFocusY: midY
										}));
							} else {
								break _v5$2;
							}
						case 1:
							var _v9 = _v5.b;
							var _v10 = _v9.a;
							var x = _v10.a;
							var y = _v10.b;
							return $elm$core$Maybe$Just(
								$author$project$ImageViewer$continueDrag$(x, y, model));
						default:
							break _v5$2;
					}
				} else {
					break _v5$2;
				}
			}
			return $elm$core$Maybe$Just(model);
		case 10:
			return $author$project$ImageViewer$endInteraction$(windowSize, model);
		default:
			var duration = msg.a;
			var frames = $ianmackenzie$elm_units$Duration$inMilliseconds(duration) / $author$project$ImageViewer$frameMs;
			var model2 = $author$project$ImageViewer$applyZoomEasing$(windowSize, frames, model);
			var _v11 = model2.interaction;
			switch (_v11.$) {
				case 1:
					return $elm$core$Maybe$Just(
						$author$project$ImageViewer$sampleDragVelocity$(frames, model2));
				case 2:
					return $elm$core$Maybe$Just(model2);
				default:
					var _v12 = $author$project$ImageViewer$nearestViewportEdge$(windowSize, model2);
					var nearestEdge = _v12.a;
					var t = _v12.b;
					if (t <= 0) {
						return $elm$core$Maybe$Nothing;
					} else {
						if (t < 1) {
							return $elm$core$Maybe$Just(
								_Utils_update(
									model2,
									{
										offsetX: model2.offsetX + (model2.velocityX * frames),
										offsetY: model2.offsetY + (model2.velocityY * frames),
										velocityX: model2.velocityX + function () {
											switch (nearestEdge) {
												case 0:
													return frames * 3;
												case 1:
													return (-frames) * 3;
												case 2:
													return 0;
												default:
													return 0;
											}
										}(),
										velocityY: model2.velocityY + function () {
											switch (nearestEdge) {
												case 0:
													return 0;
												case 1:
													return 0;
												case 2:
													return frames * 3;
												default:
													return (-frames) * 3;
											}
										}()
									}));
						} else {
							var decay = A2($elm$core$Basics$pow, $author$project$ImageViewer$panDecay, frames);
							var newVelocityX = model2.velocityX * decay;
							var newVelocityY = model2.velocityY * decay;
							var stopped = _Utils_cmp((newVelocityX * newVelocityX) + (newVelocityY * newVelocityY), $author$project$ImageViewer$panVelocityThreshold * $author$project$ImageViewer$panVelocityThreshold) < 0;
							return $elm$core$Maybe$Just(
								_Utils_update(
									model2,
									{
										offsetX: model2.offsetX + (model2.velocityX * frames),
										offsetY: model2.offsetY + (model2.velocityY * frames),
										velocityX: stopped ? 0 : newVelocityX,
										velocityY: stopped ? 0 : newVelocityY
									}));
						}
					}
			}
	}
};
var $author$project$ImageViewer$update = F3($author$project$ImageViewer$update$);
var $author$project$LoginForm$EnterLoginCode = function (a) {
	return {$: 1, a: a};
};
var $author$project$LoginForm$EnterTwoFactorCode = function (a) {
	return {$: 2, a: a};
};
var $author$project$LoginForm$EnterUserData = function (a) {
	return {$: 3, a: a};
};
var $author$project$LoginForm$NotSubmitted = function (a) {
	return {$: 0, a: a};
};
var $author$project$LoginForm$Submitting = {$: 1};
var $author$project$LoginForm$Checking = 0;
var $author$project$LoginForm$validateCode$ = function (digitCount, text) {
	if (A2(
		$elm$core$String$any,
		function (_char) {
			return !$elm$core$Char$isDigit(_char);
		},
		text)) {
		return $elm$core$Result$Err('Must only contain digits 0-9');
	} else {
		if (_Utils_eq(
			$elm$core$String$length(text),
			digitCount)) {
			var _v0 = $elm$core$String$toInt(text);
			if (!_v0.$) {
				var _int = _v0.a;
				return $elm$core$Result$Ok(_int);
			} else {
				return $elm$core$Result$Err('Invalid code');
			}
		} else {
			return $elm$core$Result$Err('\u00A0');
		}
	}
};
var $author$project$LoginForm$validateCode = F2($author$project$LoginForm$validateCode$);
var $author$project$LoginForm$isCheckingCode$ = function (digitCount, model) {
	var _v0 = $author$project$LoginForm$validateCode$(digitCount, model.code);
	if (!_v0.$) {
		var code = _v0.a;
		return _Utils_eq(
			$lamdera$containers$SeqDict$get$(code, model.attempts),
			$elm$core$Maybe$Just(0));
	} else {
		return false;
	}
};
var $author$project$LoginForm$isCheckingCode = F2($author$project$LoginForm$isCheckingCode$);
var $author$project$LoginForm$loginCodeLength = 8;
var $author$project$LoginForm$twoFactorCodeLength = 6;
var $author$project$LoginForm$typedCode$ = function (digitCount, onSubmitLoginCode, text, model) {
	var text2 = A2($elm$core$String$filter, $elm$core$Char$isDigit, text);
	var _v0 = $author$project$LoginForm$validateCode$(digitCount, text2);
	if (!_v0.$) {
		var loginCode = _v0.a;
		return $lamdera$containers$SeqDict$member$(loginCode, model.attempts) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{
					code: $elm$core$String$left$(digitCount, text2)
				}),
			$lamdera$program_test$Effect$Command$none) : _Utils_Tuple2(
			_Utils_update(
				model,
				{
					attempts: $lamdera$containers$SeqDict$insert$(loginCode, 0, model.attempts),
					code: $elm$core$String$left$(digitCount, text2)
				}),
			onSubmitLoginCode(loginCode));
	} else {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					code: $elm$core$String$left$(digitCount, text2)
				}),
			$lamdera$program_test$Effect$Command$none);
	}
};
var $author$project$LoginForm$typedCode = F4($author$project$LoginForm$typedCode$);
var $author$project$LoginForm$update$ = function (onSubmitEmail, onSubmitLoginCode, onSubmitTwoFactorCode, onSubmitUserData, msg, model) {
	switch (msg.$) {
		case 0:
			return $elm$core$Maybe$Just(
				function () {
					if (!model.$) {
						var loginForm = model.a;
						var _v2 = $author$project$EmailAddress$fromString(loginForm.email);
						if (!_v2.$) {
							var email = _v2.a;
							return _Utils_Tuple2(
								$author$project$LoginForm$EnterLoginCode(
									{attempts: $lamdera$containers$SeqDict$empty, code: '', sentTo: email}),
								onSubmitEmail(email));
						} else {
							return _Utils_Tuple2(
								$author$project$LoginForm$EnterEmail(
									_Utils_update(
										loginForm,
										{pressedSubmitEmail: true})),
								$lamdera$program_test$Effect$Command$none);
						}
					} else {
						return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
					}
				}());
		case 2:
			var text = msg.a;
			return $elm$core$Maybe$Just(
				function () {
					if (!model.$) {
						var loginForm = model.a;
						return _Utils_Tuple2(
							$author$project$LoginForm$EnterEmail(
								_Utils_update(
									loginForm,
									{email: text})),
							$lamdera$program_test$Effect$Command$none);
					} else {
						return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
					}
				}());
		case 1:
			switch (model.$) {
				case 1:
					var enterLoginCode = model.a;
					return $author$project$LoginForm$isCheckingCode$($author$project$LoginForm$loginCodeLength, enterLoginCode) ? $elm$core$Maybe$Just(
						_Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none)) : $elm$core$Maybe$Nothing;
				case 2:
					var enterTwoFactorCode = model.a;
					return $author$project$LoginForm$isCheckingCode$($author$project$LoginForm$twoFactorCodeLength, enterTwoFactorCode) ? $elm$core$Maybe$Just(
						_Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none)) : $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		case 3:
			var loginCodeText = msg.a;
			return $elm$core$Maybe$Just(
				function () {
					if (model.$ === 1) {
						var enterLoginCode = model.a;
						return $elm$core$Tuple$mapFirst$(
							$author$project$LoginForm$EnterLoginCode,
							$author$project$LoginForm$typedCode$($author$project$LoginForm$loginCodeLength, onSubmitLoginCode, loginCodeText, enterLoginCode));
					} else {
						return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
					}
				}());
		case 4:
			var twoFactorCodeText = msg.a;
			return $elm$core$Maybe$Just(
				function () {
					if (model.$ === 2) {
						var twoFactorCode = model.a;
						return $elm$core$Tuple$mapFirst$(
							$author$project$LoginForm$EnterTwoFactorCode,
							$author$project$LoginForm$typedCode$(
								$author$project$LoginForm$twoFactorCodeLength,
								onSubmitTwoFactorCode,
								twoFactorCodeText,
								_Utils_update(
									twoFactorCode,
									{attempts: $lamdera$containers$SeqDict$empty})));
					} else {
						return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
					}
				}());
		case 5:
			var text = msg.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					function () {
						if (model.$ === 3) {
							var enterUserData = model.a;
							var _v8 = enterUserData.pressedSubmit;
							if (!_v8.$) {
								return $author$project$LoginForm$EnterUserData(
									_Utils_update(
										enterUserData,
										{name: text}));
							} else {
								return model;
							}
						} else {
							return model;
						}
					}(),
					$lamdera$program_test$Effect$Command$none));
		default:
			if (model.$ === 3) {
				var enterUserData = model.a;
				var _v10 = $author$project$PersonName$fromString(enterUserData.name);
				if (!_v10.$) {
					var name = _v10.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							$author$project$LoginForm$EnterUserData(
								_Utils_update(
									enterUserData,
									{pressedSubmit: $author$project$LoginForm$Submitting})),
							onSubmitUserData(name)));
				} else {
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							$author$project$LoginForm$EnterUserData(
								_Utils_update(
									enterUserData,
									{
										pressedSubmit: $author$project$LoginForm$NotSubmitted(true)
									})),
							$lamdera$program_test$Effect$Command$none));
				}
			} else {
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none));
			}
	}
};
var $author$project$LoginForm$update = F6($author$project$LoginForm$update$);
var $author$project$Pages$Admin$AdminChange = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$AdminChanges = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$ChangeUsers = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$CopyToClipboard = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$DeleteDiscordDmChannel = function (a) {
	return {$: 28, a: a};
};
var $author$project$Pages$Admin$DeleteDiscordGuild = function (a) {
	return {$: 29, a: a};
};
var $author$project$Pages$Admin$DeleteGuild = function (a) {
	return {$: 32, a: a};
};
var $author$project$Pages$Admin$DeleteOrphanedFiles = function (a) {
	return {$: 40, a: a};
};
var $author$project$Pages$Admin$DeleteSession = function (a) {
	return {$: 38, a: a};
};
var $author$project$Pages$Admin$DeleteSlackDmChannel = function (a) {
	return {$: 31, a: a};
};
var $author$project$Pages$Admin$DeleteSlackWorkspace = function (a) {
	return {$: 30, a: a};
};
var $author$project$Pages$Admin$DisconnectClient$ = function (a, b) {
	return {$: 37, a: a, b: b};
};
var $author$project$Pages$Admin$DisconnectClient = F2($author$project$Pages$Admin$DisconnectClient$);
var $author$project$Pages$Admin$DownloadLastBackupRequest = {$: 1};
var $author$project$Pages$Admin$ExportAll = {$: 1};
var $author$project$Pages$Admin$ExportBackendRequest = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$ExportStarting = {$: 0};
var $author$project$Pages$Admin$ExportSubset = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$FocusedOnEditCell = {$: 6};
var $author$project$Pages$Admin$GoToHomepage = {$: 2};
var $author$project$Pages$Admin$GotImportBackendFileContent = function (a) {
	return {$: 55, a: a};
};
var $author$project$Pages$Admin$ImportBackendChunkRequest$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Pages$Admin$ImportBackendChunkRequest = F2($author$project$Pages$Admin$ImportBackendChunkRequest$);
var $author$project$Pages$Admin$ImportBackendFileSelected = function (a) {
	return {$: 54, a: a};
};
var $author$project$Pages$Admin$ImportingBackend = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$LoadDiscordDmChannels = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$LoadDiscordGuilds = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$LoadDiscordUsers = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Admin$LoadDmChannels = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$LoadGuilds = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$LoadUsers = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$LogPageChanged$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Pages$Admin$LogPageChanged = F2($author$project$Pages$Admin$LogPageChanged$);
var $author$project$Pages$Admin$NoOutMsg = {$: 3};
var $author$project$Pages$Admin$RegenerateServerSecret = function (a) {
	return {$: 39, a: a};
};
var $author$project$Pages$Admin$ReloadDiscordGuild$ = function (a, b, c) {
	return {$: 36, a: a, b: b, c: c};
};
var $author$project$Pages$Admin$ReloadDiscordGuild = F3($author$project$Pages$Admin$ReloadDiscordGuild$);
var $author$project$Pages$Admin$RestoreGuild = function (a) {
	return {$: 33, a: a};
};
var $author$project$Pages$Admin$SetDiscordLinkLimit = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Admin$SetDiscordLinkingEnabled = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Admin$SetEmailNotificationsEnabled = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Admin$SetNotifyAdminsBotUserId = function (a) {
	return {$: 26, a: a};
};
var $author$project$Pages$Admin$SetNotifyAdminsToken = function (a) {
	return {$: 25, a: a};
};
var $author$project$Pages$Admin$SetOpenRouterKey = function (a) {
	return {$: 24, a: a};
};
var $author$project$Pages$Admin$SetPostmarkKey = function (a) {
	return {$: 27, a: a};
};
var $author$project$Pages$Admin$SetPrivateVapidKey = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$Admin$SetPublicVapidKey = function (a) {
	return {$: 23, a: a};
};
var $author$project$Pages$Admin$SetSignupsEnabled = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Admin$SetSlackLinkLimit = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$Admin$SetSlackLinkingEnabled = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$Admin$StartReloadingDiscordDmChannel$ = function (a, b, c) {
	return {$: 35, a: a, b: b, c: c};
};
var $author$project$Pages$Admin$StartReloadingDiscordDmChannel = F3($author$project$Pages$Admin$StartReloadingDiscordDmChannel$);
var $author$project$Pages$Admin$StartReloadingDiscordGuildChannel$ = function (a, b, c, d) {
	return {$: 34, a: a, b: b, c: c, d: d};
};
var $author$project$Pages$Admin$StartReloadingDiscordGuildChannel = F4($author$project$Pages$Admin$StartReloadingDiscordGuildChannel$);
var $author$project$Pages$Admin$TypeThatIsAlwaysInvalid = 0;
var $author$project$Pages$Admin$TypeThatIsAlwaysInvalidRequest = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$adminUser$ = function (userId, adminData) {
	var _v0 = adminData.users;
	switch (_v0.$) {
		case 2:
			var users = _v0.a;
			return $author$project$NonemptyDict$get$(userId, users);
		case 1:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Admin$adminUser = F2($author$project$Pages$Admin$adminUser$);
var $author$project$Pages$Admin$updateEditUserField$ = function (userColumn, text, change) {
	if (!userColumn) {
		return _Utils_update(
			change,
			{name: text});
	} else {
		return _Utils_update(
			change,
			{email: text});
	}
};
var $author$project$Pages$Admin$updateEditUserField = F3($author$project$Pages$Admin$updateEditUserField$);
var $author$project$Pages$Admin$userToEditUser = function (user) {
	return {
		createdAt: user.createdAt,
		deleteAccountAt: user.deleteAccountAt,
		email: function () {
			var _v0 = user.email;
			if (_v0.$ === 1) {
				var email = _v0.a;
				return $author$project$EmailAddress$toString(email);
			} else {
				return '';
			}
		}(),
		isAdmin: user.isAdmin,
		name: $author$project$PersonName$toString(user.name)
	};
};
var $author$project$Pages$Admin$applyEditCell$ = function (userTable, editingCell, adminData) {
	var _v0 = editingCell.userId;
	if (!_v0.$) {
		var userId = _v0.a;
		var _v1 = $author$project$Pages$Admin$adminUser$(userId, adminData);
		if (!_v1.$) {
			var user = _v1.a;
			return _Utils_update(
				userTable,
				{
					changedUsers: $lamdera$containers$SeqDict$update$(
						userId,
						function (maybeChange) {
							var changeA = $elm$core$Maybe$withDefault$(
								$author$project$Pages$Admin$userToEditUser(user),
								maybeChange);
							var changeB = $author$project$Pages$Admin$updateEditUserField$(editingCell.column, editingCell.text, changeA);
							return (_Utils_eq(maybeChange, $elm$core$Maybe$Nothing) && _Utils_eq(changeB, changeA)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(changeB);
						},
						userTable.changedUsers),
					deletedUsers: $lamdera$containers$SeqSet$remove$(userId, userTable.deletedUsers),
					editingCell: $elm$core$Maybe$Nothing
				});
		} else {
			return userTable;
		}
	} else {
		var index = _v0.a;
		return _Utils_update(
			userTable,
			{
				editingCell: $elm$core$Maybe$Nothing,
				newUsers: $elmcraft$core_extra$Array$Extra$update$(
					index,
					A2($author$project$Pages$Admin$updateEditUserField, editingCell.column, editingCell.text),
					userTable.newUsers)
			});
	}
};
var $author$project$Pages$Admin$applyEditCell = F3($author$project$Pages$Admin$applyEditCell$);
var $author$project$Pages$Admin$editCellTextInputId = $lamdera$program_test$Effect$Browser$Dom$id('admin_editCellTextInput');
var $author$project$Pages$Admin$handleTogglingAdmin$ = function (userTableId, userTableState, isAdmin, adminData) {
	if (!userTableId.$) {
		var userId = userTableId.a;
		return _Utils_update(
			userTableState,
			{
				changedUsers: $lamdera$containers$SeqDict$update$(
					userId,
					function (maybe) {
						if (!maybe.$) {
							var change = maybe.a;
							return $elm$core$Maybe$Just(
								_Utils_update(
									change,
									{isAdmin: isAdmin}));
						} else {
							var _v2 = $author$project$Pages$Admin$adminUser$(userId, adminData);
							if (!_v2.$) {
								var user = _v2.a;
								var change = $author$project$Pages$Admin$userToEditUser(user);
								return $elm$core$Maybe$Just(
									_Utils_update(
										change,
										{isAdmin: isAdmin}));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}
					},
					userTableState.changedUsers)
			});
	} else {
		var index = userTableId.a;
		return _Utils_update(
			userTableState,
			{
				newUsers: $elmcraft$core_extra$Array$Extra$update$(
					index,
					function (newUser) {
						return _Utils_update(
							newUser,
							{isAdmin: isAdmin});
					},
					userTableState.newUsers)
			});
	}
};
var $author$project$Pages$Admin$handleTogglingAdmin = F4($author$project$Pages$Admin$handleTogglingAdmin$);
var $author$project$Pages$Admin$importBackendChunkSize = (3 * 1024) * 1024;
var $author$project$Pages$Admin$loadIfNeeded$ = function (adminDataStatus, change) {
	switch (adminDataStatus.$) {
		case 0:
			return _List_fromArray(
				[change]);
		case 1:
			return _List_Nil;
		default:
			return _List_Nil;
	}
};
var $author$project$Pages$Admin$loadIfNeeded = F2($author$project$Pages$Admin$loadIfNeeded$);
var $author$project$Pages$Admin$localChangeToText$ = function (column, localChange) {
	if (!column) {
		return localChange.name;
	} else {
		return localChange.email;
	}
};
var $author$project$Pages$Admin$localChangeToText = F2($author$project$Pages$Admin$localChangeToText$);
var $author$project$Pages$Admin$EmailAddressColumn = 1;
var $author$project$Pages$Admin$NameColumn = 0;
var $author$project$Pages$Admin$nextUserColumn = function (column) {
	if (!column) {
		return 1;
	} else {
		return 0;
	}
};
var $author$project$Pages$Admin$previousUserColumn = function (column) {
	if (!column) {
		return 1;
	} else {
		return 0;
	}
};
var $elmcraft$core_extra$Array$Extra$sliceFrom$ = function (lengthDropped, array) {
	return $elm$core$Array$slice$(
		lengthDropped,
		$elm$core$Array$length(array),
		array);
};
var $elmcraft$core_extra$Array$Extra$sliceFrom = F2($elmcraft$core_extra$Array$Extra$sliceFrom$);
var $elmcraft$core_extra$Array$Extra$sliceUntil$ = function (exclusiveEndIndex, array) {
	return $elm$core$Array$slice$(0, exclusiveEndIndex, array);
};
var $elmcraft$core_extra$Array$Extra$sliceUntil = F2($elmcraft$core_extra$Array$Extra$sliceUntil$);
var $elmcraft$core_extra$Array$Extra$splitAt$ = function (index, array) {
	return (index <= 0) ? _Utils_Tuple2($elm$core$Array$empty, array) : _Utils_Tuple2(
		$elmcraft$core_extra$Array$Extra$sliceUntil$(index, array),
		$elmcraft$core_extra$Array$Extra$sliceFrom$(index, array));
};
var $elmcraft$core_extra$Array$Extra$splitAt = F2($elmcraft$core_extra$Array$Extra$splitAt$);
var $elmcraft$core_extra$Array$Extra$removeAt$ = function (index, array) {
	if (_Utils_cmp(index, -1) < 1) {
		return array;
	} else {
		var _v0 = $elmcraft$core_extra$Array$Extra$splitAt$(index, array);
		var beforeIndex = _v0.a;
		var startingAtIndex = _v0.b;
		var lengthStartingAtIndex = $elm$core$Array$length(startingAtIndex);
		return (!lengthStartingAtIndex) ? beforeIndex : $elm$core$Array$append$(
			beforeIndex,
			$elm$core$Array$slice$(1, lengthStartingAtIndex, startingAtIndex));
	}
};
var $elmcraft$core_extra$Array$Extra$removeAt = F2($elmcraft$core_extra$Array$Extra$removeAt$);
var $author$project$Pages$Admin$LoadBackendMsgLogs = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Admin$LoadDeletedGuilds = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$LoadOrphanedFiles = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Admin$LoadSessions = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Admin$LoadSlackDmChannels = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Admin$LoadSlackWorkspaces = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$LoadToBackendLogs = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Admin$LoadWebsocketCloseEvents = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Admin$sectionDataToLoad$ = function (section2, adminData) {
	switch (section2) {
		case 0:
			return _Utils_ap(
				$author$project$Pages$Admin$loadIfNeeded$(
					adminData.users,
					$author$project$Pages$Admin$LoadUsers($author$project$UserSession$EmptyPlaceholder)),
				$author$project$Pages$Admin$loadIfNeeded$(
					adminData.discordUsers,
					$author$project$Pages$Admin$LoadDiscordUsers($author$project$UserSession$EmptyPlaceholder)));
		case 1:
			return _List_Nil;
		case 2:
			return _Utils_ap(
				$author$project$Pages$Admin$loadIfNeeded$(
					adminData.dmChannels,
					$author$project$Pages$Admin$LoadDmChannels($author$project$UserSession$EmptyPlaceholder)),
				$author$project$Pages$Admin$loadIfNeeded$(
					adminData.users,
					$author$project$Pages$Admin$LoadUsers($author$project$UserSession$EmptyPlaceholder)));
		case 3:
			return _Utils_ap(
				$author$project$Pages$Admin$loadIfNeeded$(
					adminData.discordDmChannels,
					$author$project$Pages$Admin$LoadDiscordDmChannels($author$project$UserSession$EmptyPlaceholder)),
				$author$project$Pages$Admin$loadIfNeeded$(
					adminData.discordUsers,
					$author$project$Pages$Admin$LoadDiscordUsers($author$project$UserSession$EmptyPlaceholder)));
		case 4:
			return _Utils_ap(
				$author$project$Pages$Admin$loadIfNeeded$(
					adminData.discordUsers,
					$author$project$Pages$Admin$LoadDiscordUsers($author$project$UserSession$EmptyPlaceholder)),
				$author$project$Pages$Admin$loadIfNeeded$(
					adminData.users,
					$author$project$Pages$Admin$LoadUsers($author$project$UserSession$EmptyPlaceholder)));
		case 5:
			return _Utils_ap(
				$author$project$Pages$Admin$loadIfNeeded$(
					adminData.discordGuilds,
					$author$project$Pages$Admin$LoadDiscordGuilds($author$project$UserSession$EmptyPlaceholder)),
				$author$project$Pages$Admin$loadIfNeeded$(
					adminData.discordUsers,
					$author$project$Pages$Admin$LoadDiscordUsers($author$project$UserSession$EmptyPlaceholder)));
		case 7:
			return _Utils_ap(
				$author$project$Pages$Admin$loadIfNeeded$(
					adminData.slackDmChannels,
					$author$project$Pages$Admin$LoadSlackDmChannels($author$project$UserSession$EmptyPlaceholder)),
				$author$project$Pages$Admin$loadIfNeeded$(
					adminData.slackWorkspaces,
					$author$project$Pages$Admin$LoadSlackWorkspaces($author$project$UserSession$EmptyPlaceholder)));
		case 6:
			return _Utils_ap(
				$author$project$Pages$Admin$loadIfNeeded$(
					adminData.slackWorkspaces,
					$author$project$Pages$Admin$LoadSlackWorkspaces($author$project$UserSession$EmptyPlaceholder)),
				$author$project$Pages$Admin$loadIfNeeded$(
					adminData.users,
					$author$project$Pages$Admin$LoadUsers($author$project$UserSession$EmptyPlaceholder)));
		case 8:
			return _Utils_ap(
				$author$project$Pages$Admin$loadIfNeeded$(
					adminData.guilds,
					$author$project$Pages$Admin$LoadGuilds($author$project$UserSession$EmptyPlaceholder)),
				$author$project$Pages$Admin$loadIfNeeded$(
					adminData.users,
					$author$project$Pages$Admin$LoadUsers($author$project$UserSession$EmptyPlaceholder)));
		case 9:
			return _Utils_ap(
				$author$project$Pages$Admin$loadIfNeeded$(
					adminData.deletedGuilds,
					$author$project$Pages$Admin$LoadDeletedGuilds($author$project$UserSession$EmptyPlaceholder)),
				$author$project$Pages$Admin$loadIfNeeded$(
					adminData.users,
					$author$project$Pages$Admin$LoadUsers($author$project$UserSession$EmptyPlaceholder)));
		case 10:
			return _List_Nil;
		case 11:
			return _List_Nil;
		case 12:
			return _Utils_ap(
				$author$project$Pages$Admin$loadIfNeeded$(
					adminData.users,
					$author$project$Pages$Admin$LoadUsers($author$project$UserSession$EmptyPlaceholder)),
				_Utils_ap(
					$author$project$Pages$Admin$loadIfNeeded$(
						adminData.guilds,
						$author$project$Pages$Admin$LoadGuilds($author$project$UserSession$EmptyPlaceholder)),
					_Utils_ap(
						$author$project$Pages$Admin$loadIfNeeded$(
							adminData.discordGuilds,
							$author$project$Pages$Admin$LoadDiscordGuilds($author$project$UserSession$EmptyPlaceholder)),
						_Utils_ap(
							$author$project$Pages$Admin$loadIfNeeded$(
								adminData.discordDmChannels,
								$author$project$Pages$Admin$LoadDiscordDmChannels($author$project$UserSession$EmptyPlaceholder)),
							$author$project$Pages$Admin$loadIfNeeded$(
								adminData.discordUsers,
								$author$project$Pages$Admin$LoadDiscordUsers($author$project$UserSession$EmptyPlaceholder))))));
		case 13:
			return $author$project$Pages$Admin$loadIfNeeded$(
				adminData.orphanedFiles,
				$author$project$Pages$Admin$LoadOrphanedFiles($author$project$UserSession$EmptyPlaceholder));
		case 14:
			return _Utils_ap(
				$author$project$Pages$Admin$loadIfNeeded$(
					adminData.toBackendLogs,
					$author$project$Pages$Admin$LoadToBackendLogs($author$project$UserSession$EmptyPlaceholder)),
				$author$project$Pages$Admin$loadIfNeeded$(
					adminData.backendMsgLogs,
					$author$project$Pages$Admin$LoadBackendMsgLogs($author$project$UserSession$EmptyPlaceholder)));
		case 15:
			return _List_Nil;
		case 16:
			return $author$project$Pages$Admin$loadIfNeeded$(
				adminData.websocketCloseEvents,
				$author$project$Pages$Admin$LoadWebsocketCloseEvents($author$project$UserSession$EmptyPlaceholder));
		case 17:
			return $author$project$Pages$Admin$loadIfNeeded$(
				adminData.sessions,
				$author$project$Pages$Admin$LoadSessions($author$project$UserSession$EmptyPlaceholder));
		default:
			return _List_Nil;
	}
};
var $author$project$Pages$Admin$sectionDataToLoad = F2($author$project$Pages$Admin$sectionDataToLoad$);
var $author$project$Pages$Admin$setMember$ = function (isChecked, item, set) {
	return isChecked ? $lamdera$containers$SeqSet$insert$(item, set) : $lamdera$containers$SeqSet$remove$(item, set);
};
var $author$project$Pages$Admin$setMember = F3($author$project$Pages$Admin$setMember$);
var $author$project$Pages$Admin$splitOffChunk$ = function (chunkWidth, bytes) {
	var width = $elm$core$Basics$min$(
		chunkWidth,
		$elm$bytes$Bytes$width(bytes));
	return $elm$core$Maybe$withDefault$(
		_Utils_Tuple2(
			bytes,
			$elm$bytes$Bytes$Encode$encode(
				$elm$bytes$Bytes$Encode$sequence(_List_Nil))),
		$elm$bytes$Bytes$Decode$decode$(
			$elm$bytes$Bytes$Decode$map2$(
				$elm$core$Tuple$pair,
				$elm$bytes$Bytes$Decode$bytes(width),
				$elm$bytes$Bytes$Decode$bytes(
					$elm$bytes$Bytes$width(bytes) - width)),
			bytes));
};
var $author$project$Pages$Admin$splitOffChunk = F2($author$project$Pages$Admin$splitOffChunk$);
var $author$project$Table$update$ = function (msg, model) {
	if (!msg.$) {
		var sortBy = msg.a;
		return _Utils_update(
			model,
			{
				ascendingOrder: _Utils_eq(sortBy, model.columnToSortBy) ? (!model.ascendingOrder) : model.ascendingOrder,
				columnToSortBy: sortBy,
				showAll: false
			});
	} else {
		return _Utils_update(
			model,
			{showAll: true});
	}
};
var $author$project$Table$update = F2($author$project$Table$update$);
var $author$project$Pages$Admin$updateUserTable$ = function (updateFunc, model) {
	var _v0 = updateFunc(model.userTable);
	var userTable = _v0.a;
	var cmd = _v0.b;
	var localChange = _v0.c;
	return _Utils_Tuple3(
		_Utils_update(
			model,
			{userTable: userTable}),
		cmd,
		localChange);
};
var $author$project$Pages$Admin$updateUserTable = F2($author$project$Pages$Admin$updateUserTable$);
var $author$project$Pages$Admin$update$ = function (navigationKey, time, adminData, localState, msg, model) {
	switch (msg.$) {
		case 0:
			var index = msg.a;
			return _Utils_Tuple3(
				model,
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$AdminChange(
					$author$project$Pages$Admin$LogPageChanged$(index, $author$project$UserSession$EmptyPlaceholder)));
		case 1:
			var logIndex = msg.a;
			var route = _Utils_ap(
				$author$project$Env$domain,
				$author$project$Route$encode(
					$author$project$Route$AdminRoute(
						{
							highlightLog: $elm$core$Maybe$Just(logIndex)
						})));
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						copiedLogLink: $elm$core$Maybe$Just(logIndex)
					}),
				$lamdera$program_test$Effect$Command$batch(
					_List_fromArray(
						[
							$author$project$Ports$copyToClipboard(route),
							$lamdera$program_test$Effect$Browser$Navigation$replaceUrl$(navigationKey, route)
						])),
				$author$project$Pages$Admin$NoOutMsg);
		case 56:
			var sessionIdHash = msg.a;
			var clientId = msg.b;
			return _Utils_Tuple3(
				model,
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$AdminChange(
					$author$project$Pages$Admin$DisconnectClient$(sessionIdHash, clientId)));
		case 57:
			var sessionIdHash = msg.a;
			return _Utils_Tuple3(
				model,
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$AdminChange(
					$author$project$Pages$Admin$DeleteSession(sessionIdHash)));
		case 2:
			var section2 = msg.a;
			return $lamdera$containers$SeqSet$member$(section2, model.expandedSections) ? _Utils_Tuple3(
				_Utils_update(
					model,
					{
						expandedSections: $lamdera$containers$SeqSet$remove$(section2, model.expandedSections)
					}),
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$NoOutMsg) : _Utils_Tuple3(
				_Utils_update(
					model,
					{
						expandedSections: $lamdera$containers$SeqSet$insert$(section2, model.expandedSections)
					}),
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$AdminChanges(
					$author$project$Pages$Admin$sectionDataToLoad$(section2, adminData)));
		case 3:
			var userTableId = msg.a;
			var column = msg.b;
			return $author$project$Pages$Admin$updateUserTable$(
				function (userTable) {
					var userTable2 = function () {
						var _v6 = userTable.editingCell;
						if (!_v6.$) {
							var editingCell = _v6.a;
							return $author$project$Pages$Admin$applyEditCell$(userTable, editingCell, adminData);
						} else {
							return userTable;
						}
					}();
					var helper = function (change) {
						return _Utils_Tuple3(
							_Utils_update(
								userTable2,
								{
									editingCell: $elm$core$Maybe$Just(
										{
											column: column,
											text: $author$project$Pages$Admin$localChangeToText$(column, change),
											userId: userTableId
										})
								}),
							$lamdera$program_test$Effect$Task$attempt$(
								function (_v5) {
									return $author$project$Pages$Admin$FocusedOnEditCell;
								},
								$lamdera$program_test$Effect$Browser$Dom$focus($author$project$Pages$Admin$editCellTextInputId)),
							$author$project$Pages$Admin$NoOutMsg);
					};
					if (!userTableId.$) {
						var userId = userTableId.a;
						var _v2 = $lamdera$containers$SeqDict$get$(userId, userTable2.changedUsers);
						if (!_v2.$) {
							var change = _v2.a;
							return helper(change);
						} else {
							var _v3 = $author$project$Pages$Admin$adminUser$(userId, adminData);
							if (!_v3.$) {
								var user = _v3.a;
								return helper(
									$author$project$Pages$Admin$userToEditUser(user));
							} else {
								return _Utils_Tuple3(userTable2, $lamdera$program_test$Effect$Command$none, $author$project$Pages$Admin$NoOutMsg);
							}
						}
					} else {
						var index = userTableId.a;
						var _v4 = $elm$core$Array$get$(index, userTable2.newUsers);
						if (!_v4.$) {
							var change = _v4.a;
							return helper(change);
						} else {
							return _Utils_Tuple3(userTable2, $lamdera$program_test$Effect$Command$none, $author$project$Pages$Admin$NoOutMsg);
						}
					}
				},
				model);
		case 4:
			var text = msg.a;
			return $author$project$Pages$Admin$updateUserTable$(
				function (userTableState) {
					return _Utils_Tuple3(
						function () {
							var _v7 = userTableState.editingCell;
							if (!_v7.$) {
								var editingCell = _v7.a;
								return _Utils_update(
									userTableState,
									{
										editingCell: $elm$core$Maybe$Just(
											_Utils_update(
												editingCell,
												{text: text}))
									});
							} else {
								return userTableState;
							}
						}(),
						$lamdera$program_test$Effect$Command$none,
						$author$project$Pages$Admin$NoOutMsg);
				},
				model);
		case 5:
			var userId = msg.a;
			var column = msg.b;
			return $author$project$Pages$Admin$updateUserTable$(
				function (userTable) {
					return _Utils_Tuple3(
						function () {
							var _v8 = userTable.editingCell;
							if (!_v8.$) {
								var editingCell = _v8.a;
								return (_Utils_eq(editingCell.userId, userId) && _Utils_eq(editingCell.column, column)) ? $author$project$Pages$Admin$applyEditCell$(userTable, editingCell, adminData) : userTable;
							} else {
								return userTable;
							}
						}(),
						$lamdera$program_test$Effect$Command$none,
						$author$project$Pages$Admin$NoOutMsg);
				},
				model);
		case 6:
			return _Utils_Tuple3(
				model,
				$author$project$Ports$textInputSelectAll($author$project$Pages$Admin$editCellTextInputId),
				$author$project$Pages$Admin$NoOutMsg);
		case 7:
			var userId = msg.a;
			var column = msg.b;
			return $author$project$Pages$Admin$updateUserTable$(
				function (userTable) {
					return _Utils_Tuple3(
						function () {
							var _v9 = userTable.editingCell;
							if (!_v9.$) {
								var editingCell = _v9.a;
								return (_Utils_eq(editingCell.userId, userId) && _Utils_eq(editingCell.column, column)) ? $author$project$Pages$Admin$applyEditCell$(userTable, editingCell, adminData) : userTable;
							} else {
								return userTable;
							}
						}(),
						$lamdera$program_test$Effect$Command$none,
						$author$project$Pages$Admin$NoOutMsg);
				},
				model);
		case 8:
			var userTable2 = function () {
				var _v12 = model.userTable.editingCell;
				if (!_v12.$) {
					var editingCell = _v12.a;
					return $author$project$Pages$Admin$applyEditCell$(model.userTable, editingCell, adminData);
				} else {
					return model.userTable;
				}
			}();
			var result = function () {
				var _v11 = adminData.users;
				switch (_v11.$) {
					case 2:
						var users = _v11.a;
						return $author$project$Pages$Admin$applyChangesToBackendUsers$(
							localState.localUser.session.userId,
							{changedUsers: userTable2.changedUsers, deletedUsers: userTable2.deletedUsers, newUsers: userTable2.newUsers, time: time},
							users);
					case 1:
						return $elm$core$Result$Err($author$project$Pages$Admin$InvalidChangesToUser);
					default:
						return $elm$core$Result$Err($author$project$Pages$Admin$InvalidChangesToUser);
				}
			}();
			if (!result.$) {
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							submitError: $elm$core$Maybe$Nothing,
							userTable: _Utils_update(
								userTable2,
								{changedUsers: $lamdera$containers$SeqDict$empty, deletedUsers: $lamdera$containers$SeqSet$empty, editingCell: $elm$core$Maybe$Nothing, newUsers: $elm$core$Array$empty})
						}),
					$lamdera$program_test$Effect$Command$none,
					$author$project$Pages$Admin$AdminChange(
						$author$project$Pages$Admin$ChangeUsers(
							{changedUsers: userTable2.changedUsers, deletedUsers: userTable2.deletedUsers, newUsers: userTable2.newUsers, time: time})));
			} else {
				var error = result.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							submitError: $elm$core$Maybe$Just(error)
						}),
					$lamdera$program_test$Effect$Command$none,
					$author$project$Pages$Admin$NoOutMsg);
			}
		case 9:
			var shiftKeyHeld = msg.a;
			return $author$project$Pages$Admin$updateUserTable$(
				function (userTable) {
					var _v13 = userTable.editingCell;
					if (!_v13.$) {
						var editingCell = _v13.a;
						var userTable2 = $author$project$Pages$Admin$applyEditCell$(userTable, editingCell, adminData);
						var oldUserTable = userTable;
						var column = shiftKeyHeld ? $author$project$Pages$Admin$previousUserColumn(editingCell.column) : $author$project$Pages$Admin$nextUserColumn(editingCell.column);
						return _Utils_Tuple3(
							_Utils_update(
								userTable2,
								{
									editingCell: $elm$core$Maybe$Just(
										{
											column: column,
											text: function () {
												var _v14 = editingCell.userId;
												if (!_v14.$) {
													var userId = _v14.a;
													var _v15 = $author$project$Pages$Admin$adminUser$(userId, adminData);
													if (!_v15.$) {
														var user = _v15.a;
														return $author$project$Pages$Admin$localChangeToText$(
															column,
															$author$project$Pages$Admin$userToEditUser(user));
													} else {
														return '';
													}
												} else {
													var index = _v14.a;
													var _v16 = $elm$core$Array$get$(index, oldUserTable.newUsers);
													if (!_v16.$) {
														var user = _v16.a;
														return $author$project$Pages$Admin$localChangeToText$(column, user);
													} else {
														return '';
													}
												}
											}(),
											userId: editingCell.userId
										})
								}),
							$lamdera$program_test$Effect$Task$attempt$(
								function (_v17) {
									return $author$project$Pages$Admin$FocusedOnEditCell;
								},
								$lamdera$program_test$Effect$Browser$Dom$focus($author$project$Pages$Admin$editCellTextInputId)),
							$author$project$Pages$Admin$NoOutMsg);
					} else {
						return _Utils_Tuple3(userTable, $lamdera$program_test$Effect$Command$none, $author$project$Pages$Admin$NoOutMsg);
					}
				},
				model);
		case 10:
			return $author$project$Pages$Admin$updateUserTable$(
				function (userTable) {
					return _Utils_Tuple3(
						_Utils_update(
							userTable,
							{changedUsers: $lamdera$containers$SeqDict$empty, deletedUsers: $lamdera$containers$SeqSet$empty, newUsers: $elm$core$Array$empty}),
						$lamdera$program_test$Effect$Command$none,
						$author$project$Pages$Admin$NoOutMsg);
				},
				model);
		case 11:
			return $author$project$Pages$Admin$updateUserTable$(
				function (userTable) {
					return _Utils_Tuple3(
						_Utils_update(
							userTable,
							{editingCell: $elm$core$Maybe$Nothing}),
						$lamdera$program_test$Effect$Command$none,
						$author$project$Pages$Admin$NoOutMsg);
				},
				model);
		case 12:
			return $author$project$Pages$Admin$updateUserTable$(
				function (userTable) {
					return _Utils_Tuple3(
						_Utils_update(
							userTable,
							{
								newUsers: $elm$core$Array$push$(
									{createdAt: time, deleteAccountAt: $elm$core$Maybe$Nothing, email: '', isAdmin: false, name: ''},
									userTable.newUsers)
							}),
						$lamdera$program_test$Effect$Command$none,
						$author$project$Pages$Admin$NoOutMsg);
				},
				model);
		case 13:
			var userTableId = msg.a;
			return $author$project$Pages$Admin$updateUserTable$(
				function (userTable) {
					if (!userTableId.$) {
						var userId = userTableId.a;
						return _Utils_Tuple3(
							_Utils_update(
								userTable,
								{
									changedUsers: $lamdera$containers$SeqDict$remove$(userId, userTable.changedUsers),
									deletedUsers: $lamdera$containers$SeqSet$insert$(userId, userTable.deletedUsers)
								}),
							$lamdera$program_test$Effect$Command$none,
							$author$project$Pages$Admin$NoOutMsg);
					} else {
						var index = userTableId.a;
						return _Utils_Tuple3(
							_Utils_update(
								userTable,
								{
									newUsers: $elmcraft$core_extra$Array$Extra$removeAt$(index, userTable.newUsers)
								}),
							$lamdera$program_test$Effect$Command$none,
							$author$project$Pages$Admin$NoOutMsg);
					}
				},
				model);
		case 14:
			var userId = msg.a;
			return $author$project$Pages$Admin$updateUserTable$(
				function (userTable) {
					return _Utils_Tuple3(
						_Utils_update(
							userTable,
							{
								changedUsers: $lamdera$containers$SeqDict$remove$(userId, userTable.changedUsers),
								deletedUsers: $lamdera$containers$SeqSet$remove$(userId, userTable.deletedUsers)
							}),
						$lamdera$program_test$Effect$Command$none,
						$author$project$Pages$Admin$NoOutMsg);
				},
				model);
		case 15:
			var tableMsg = msg.a;
			return $author$project$Pages$Admin$updateUserTable$(
				function (userTable) {
					return _Utils_Tuple3(
						_Utils_update(
							userTable,
							{
								table: $author$project$Table$update$(tableMsg, userTable.table)
							}),
						$lamdera$program_test$Effect$Command$none,
						$author$project$Pages$Admin$NoOutMsg);
				},
				model);
		case 16:
			var isChecked = msg.a;
			return _Utils_Tuple3(
				model,
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$AdminChange(
					$author$project$Pages$Admin$SetEmailNotificationsEnabled(isChecked)));
		case 17:
			var isChecked = msg.a;
			return _Utils_Tuple3(
				model,
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$AdminChange(
					$author$project$Pages$Admin$SetSignupsEnabled(isChecked)));
		case 18:
			var isChecked = msg.a;
			return _Utils_Tuple3(
				model,
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$AdminChange(
					$author$project$Pages$Admin$SetDiscordLinkingEnabled(isChecked)));
		case 20:
			var isChecked = msg.a;
			return _Utils_Tuple3(
				model,
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$AdminChange(
					$author$project$Pages$Admin$SetSlackLinkingEnabled(isChecked)));
		case 22:
			var userTableId = msg.a;
			var isAdmin = msg.b;
			return $author$project$Pages$Admin$updateUserTable$(
				function (userTableState) {
					return _Utils_Tuple3(
						$author$project$Pages$Admin$handleTogglingAdmin$(userTableId, userTableState, isAdmin, adminData),
						$lamdera$program_test$Effect$Command$none,
						$author$project$Pages$Admin$NoOutMsg);
				},
				model);
		case 23:
			var channelId = msg.a;
			return _Utils_Tuple3(
				model,
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$AdminChange(
					$author$project$Pages$Admin$DeleteDiscordDmChannel(channelId)));
		case 24:
			var guildId = msg.a;
			return _Utils_Tuple3(
				model,
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$AdminChange(
					$author$project$Pages$Admin$DeleteDiscordGuild(guildId)));
		case 26:
			var teamId = msg.a;
			return _Utils_Tuple3(
				model,
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$AdminChange(
					$author$project$Pages$Admin$DeleteSlackWorkspace(teamId)));
		case 28:
			var channelId = msg.a;
			return _Utils_Tuple3(
				model,
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$AdminChange(
					$author$project$Pages$Admin$DeleteSlackDmChannel(channelId)));
		case 27:
			var teamId = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						expandedSlackWorkspaces: $lamdera$containers$SeqSet$member$(teamId, model.expandedSlackWorkspaces) ? $lamdera$containers$SeqSet$remove$(teamId, model.expandedSlackWorkspaces) : $lamdera$containers$SeqSet$insert$(teamId, model.expandedSlackWorkspaces)
					}),
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$NoOutMsg);
		case 25:
			var guildId = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						expandedDiscordGuilds: $lamdera$containers$SeqSet$member$(guildId, model.expandedDiscordGuilds) ? $lamdera$containers$SeqSet$remove$(guildId, model.expandedDiscordGuilds) : $lamdera$containers$SeqSet$insert$(guildId, model.expandedDiscordGuilds)
					}),
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$NoOutMsg);
		case 29:
			var guildId = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						expandedGuilds: $lamdera$containers$SeqSet$member$(guildId, model.expandedGuilds) ? $lamdera$containers$SeqSet$remove$(guildId, model.expandedGuilds) : $lamdera$containers$SeqSet$insert$(guildId, model.expandedGuilds)
					}),
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$NoOutMsg);
		case 30:
			var guildId = msg.a;
			return _Utils_Tuple3(
				model,
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$AdminChange(
					$author$project$Pages$Admin$DeleteGuild(guildId)));
		case 31:
			var guildId = msg.a;
			return _Utils_Tuple3(
				model,
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$AdminChange(
					$author$project$Pages$Admin$RestoreGuild(guildId)));
		case 32:
			var editableMsg = msg.a;
			if (!editableMsg.$) {
				var editable = editableMsg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{publicVapidKey: editable}),
					$lamdera$program_test$Effect$Command$none,
					$author$project$Pages$Admin$NoOutMsg);
			} else {
				var value = editableMsg.a;
				return _Utils_Tuple3(
					model,
					$lamdera$program_test$Effect$Command$none,
					$author$project$Pages$Admin$AdminChange(
						$author$project$Pages$Admin$SetPublicVapidKey(value)));
			}
		case 33:
			var editableMsg = msg.a;
			if (!editableMsg.$) {
				var editable = editableMsg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{privateVapidKey: editable}),
					$lamdera$program_test$Effect$Command$none,
					$author$project$Pages$Admin$NoOutMsg);
			} else {
				var value = editableMsg.a;
				return _Utils_Tuple3(
					model,
					$lamdera$program_test$Effect$Command$none,
					$author$project$Pages$Admin$AdminChange(
						$author$project$Pages$Admin$SetPrivateVapidKey(value)));
			}
		case 34:
			var editableMsg = msg.a;
			if (!editableMsg.$) {
				var editable = editableMsg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{openRouterKey: editable}),
					$lamdera$program_test$Effect$Command$none,
					$author$project$Pages$Admin$NoOutMsg);
			} else {
				var value = editableMsg.a;
				return _Utils_Tuple3(
					model,
					$lamdera$program_test$Effect$Command$none,
					$author$project$Pages$Admin$AdminChange(
						$author$project$Pages$Admin$SetOpenRouterKey(value)));
			}
		case 35:
			var editableMsg = msg.a;
			if (!editableMsg.$) {
				var editable = editableMsg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{notifyAdminsToken: editable}),
					$lamdera$program_test$Effect$Command$none,
					$author$project$Pages$Admin$NoOutMsg);
			} else {
				var value = editableMsg.a;
				return _Utils_Tuple3(
					model,
					$lamdera$program_test$Effect$Command$none,
					$author$project$Pages$Admin$AdminChange(
						$author$project$Pages$Admin$SetNotifyAdminsToken(value)));
			}
		case 36:
			var editableMsg = msg.a;
			if (!editableMsg.$) {
				var editable = editableMsg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{notifyAdminsBotUserId: editable}),
					$lamdera$program_test$Effect$Command$none,
					$author$project$Pages$Admin$NoOutMsg);
			} else {
				var value = editableMsg.a;
				return _Utils_Tuple3(
					model,
					$lamdera$program_test$Effect$Command$none,
					$author$project$Pages$Admin$AdminChange(
						$author$project$Pages$Admin$SetNotifyAdminsBotUserId(value)));
			}
		case 37:
			var editableMsg = msg.a;
			if (!editableMsg.$) {
				var editable = editableMsg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{postmarkKey: editable}),
					$lamdera$program_test$Effect$Command$none,
					$author$project$Pages$Admin$NoOutMsg);
			} else {
				var value = editableMsg.a;
				return _Utils_Tuple3(
					model,
					$lamdera$program_test$Effect$Command$none,
					$author$project$Pages$Admin$AdminChange(
						$author$project$Pages$Admin$SetPostmarkKey(value)));
			}
		case 19:
			var editableMsg = msg.a;
			if (!editableMsg.$) {
				var editable = editableMsg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{discordLinkLimit: editable}),
					$lamdera$program_test$Effect$Command$none,
					$author$project$Pages$Admin$NoOutMsg);
			} else {
				var value = editableMsg.a;
				return _Utils_Tuple3(
					model,
					$lamdera$program_test$Effect$Command$none,
					$author$project$Pages$Admin$AdminChange(
						$author$project$Pages$Admin$SetDiscordLinkLimit(value)));
			}
		case 21:
			var editableMsg = msg.a;
			if (!editableMsg.$) {
				var editable = editableMsg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{slackLinkLimit: editable}),
					$lamdera$program_test$Effect$Command$none,
					$author$project$Pages$Admin$NoOutMsg);
			} else {
				var value = editableMsg.a;
				return _Utils_Tuple3(
					model,
					$lamdera$program_test$Effect$Command$none,
					$author$project$Pages$Admin$AdminChange(
						$author$project$Pages$Admin$SetSlackLinkLimit(value)));
			}
		case 38:
			return _Utils_Tuple3(model, $lamdera$program_test$Effect$Command$none, $author$project$Pages$Admin$GoToHomepage);
		case 39:
			var currentUserId = msg.a;
			var guildId = msg.b;
			var channelId = msg.c;
			return _Utils_Tuple3(
				model,
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$AdminChange(
					$author$project$Pages$Admin$StartReloadingDiscordGuildChannel$(time, currentUserId, guildId, channelId)));
		case 40:
			var currentUserId = msg.a;
			var channelId = msg.b;
			return _Utils_Tuple3(
				model,
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$AdminChange(
					$author$project$Pages$Admin$StartReloadingDiscordDmChannel$(time, currentUserId, channelId)));
		case 41:
			var currentUserId = msg.a;
			var guildId = msg.b;
			return _Utils_Tuple3(
				model,
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$AdminChange(
					$author$project$Pages$Admin$ReloadDiscordGuild$(currentUserId, guildId, $author$project$UserSession$EmptyPlaceholder)));
		case 42:
			var string = msg.a;
			return _Utils_Tuple3(
				model,
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$CopyToClipboard(string));
		case 43:
			return _Utils_Tuple3(model, $lamdera$program_test$Effect$Command$none, $author$project$Pages$Admin$NoOutMsg);
		case 44:
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						exportProgress: $elm$core$Maybe$Just($author$project$Pages$Admin$ExportStarting)
					}),
				$lamdera$program_test$Effect$Lamdera$sendToBackend(
					$author$project$Pages$Admin$ExportBackendRequest($author$project$Pages$Admin$ExportAll)),
				$author$project$Pages$Admin$NoOutMsg);
		case 61:
			return _Utils_Tuple3(
				model,
				$lamdera$program_test$Effect$Lamdera$sendToBackend(
					$author$project$Pages$Admin$TypeThatIsAlwaysInvalidRequest(0)),
				$author$project$Pages$Admin$NoOutMsg);
		case 46:
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{downloadingBackup: $elm$core$Maybe$Nothing}),
				$lamdera$program_test$Effect$Lamdera$sendToBackend($author$project$Pages$Admin$DownloadLastBackupRequest),
				$author$project$Pages$Admin$NoOutMsg);
		case 45:
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						exportSubsetSelection: $elm$core$Maybe$Just(
							{discordDmChannels: $lamdera$containers$SeqSet$empty, discordGuilds: $lamdera$containers$SeqSet$empty, dmChannels: $lamdera$containers$SeqSet$empty, guilds: $lamdera$containers$SeqSet$empty})
					}),
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$AdminChanges(
					_Utils_ap(
						$author$project$Pages$Admin$loadIfNeeded$(
							adminData.users,
							$author$project$Pages$Admin$LoadUsers($author$project$UserSession$EmptyPlaceholder)),
						_Utils_ap(
							$author$project$Pages$Admin$loadIfNeeded$(
								adminData.guilds,
								$author$project$Pages$Admin$LoadGuilds($author$project$UserSession$EmptyPlaceholder)),
							_Utils_ap(
								$author$project$Pages$Admin$loadIfNeeded$(
									adminData.dmChannels,
									$author$project$Pages$Admin$LoadDmChannels($author$project$UserSession$EmptyPlaceholder)),
								_Utils_ap(
									$author$project$Pages$Admin$loadIfNeeded$(
										adminData.discordGuilds,
										$author$project$Pages$Admin$LoadDiscordGuilds($author$project$UserSession$EmptyPlaceholder)),
									_Utils_ap(
										$author$project$Pages$Admin$loadIfNeeded$(
											adminData.discordDmChannels,
											$author$project$Pages$Admin$LoadDiscordDmChannels($author$project$UserSession$EmptyPlaceholder)),
										$author$project$Pages$Admin$loadIfNeeded$(
											adminData.discordUsers,
											$author$project$Pages$Admin$LoadDiscordUsers($author$project$UserSession$EmptyPlaceholder)))))))));
		case 47:
			var guildId = msg.a;
			var isChecked = msg.b;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						exportSubsetSelection: $elm$core$Maybe$map$(
							function (selection) {
								return _Utils_update(
									selection,
									{
										guilds: $author$project$Pages$Admin$setMember$(isChecked, guildId, selection.guilds)
									});
							},
							model.exportSubsetSelection)
					}),
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$NoOutMsg);
		case 48:
			var channelId = msg.a;
			var isChecked = msg.b;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						exportSubsetSelection: $elm$core$Maybe$map$(
							function (selection) {
								return _Utils_update(
									selection,
									{
										dmChannels: $author$project$Pages$Admin$setMember$(isChecked, channelId, selection.dmChannels)
									});
							},
							model.exportSubsetSelection)
					}),
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$NoOutMsg);
		case 49:
			var guildId = msg.a;
			var isChecked = msg.b;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						exportSubsetSelection: $elm$core$Maybe$map$(
							function (selection) {
								return _Utils_update(
									selection,
									{
										discordGuilds: $author$project$Pages$Admin$setMember$(isChecked, guildId, selection.discordGuilds)
									});
							},
							model.exportSubsetSelection)
					}),
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$NoOutMsg);
		case 50:
			var channelId = msg.a;
			var isChecked = msg.b;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						exportSubsetSelection: $elm$core$Maybe$map$(
							function (selection) {
								return _Utils_update(
									selection,
									{
										discordDmChannels: $author$project$Pages$Admin$setMember$(isChecked, channelId, selection.discordDmChannels)
									});
							},
							model.exportSubsetSelection)
					}),
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$NoOutMsg);
		case 51:
			var _v27 = model.exportSubsetSelection;
			if (!_v27.$) {
				var selection = _v27.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							exportProgress: $elm$core$Maybe$Just($author$project$Pages$Admin$ExportStarting),
							exportSubsetSelection: $elm$core$Maybe$Nothing
						}),
					$lamdera$program_test$Effect$Lamdera$sendToBackend(
						$author$project$Pages$Admin$ExportBackendRequest(
							$author$project$Pages$Admin$ExportSubset(selection))),
					$author$project$Pages$Admin$NoOutMsg);
			} else {
				return _Utils_Tuple3(model, $lamdera$program_test$Effect$Command$none, $author$project$Pages$Admin$NoOutMsg);
			}
		case 52:
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{exportSubsetSelection: $elm$core$Maybe$Nothing}),
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$NoOutMsg);
		case 53:
			var _v28 = model.importBackendStatus;
			if (_v28.$ === 2) {
				return _Utils_Tuple3(model, $lamdera$program_test$Effect$Command$none, $author$project$Pages$Admin$NoOutMsg);
			} else {
				return _Utils_Tuple3(
					model,
					$lamdera$program_test$Effect$File$Select$file$(_List_Nil, $author$project$Pages$Admin$ImportBackendFileSelected),
					$author$project$Pages$Admin$NoOutMsg);
			}
		case 54:
			var file = msg.a;
			return _Utils_Tuple3(
				model,
				$lamdera$program_test$Effect$Task$perform$(
					$author$project$Pages$Admin$GotImportBackendFileContent,
					$lamdera$program_test$Effect$File$toBytes(file)),
				$author$project$Pages$Admin$NoOutMsg);
		case 55:
			var content = msg.a;
			var _v29 = $author$project$Pages$Admin$splitOffChunk$($author$project$Pages$Admin$importBackendChunkSize, content);
			var chunk = _v29.a;
			var remainingBytes = _v29.b;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						importBackendStatus: $author$project$Pages$Admin$ImportingBackend(
							{
								remainingBytes: remainingBytes,
								sentBytes: $elm$bytes$Bytes$width(chunk),
								totalBytes: $elm$bytes$Bytes$width(content)
							})
					}),
				$lamdera$program_test$Effect$Lamdera$sendToBackend(
					$author$project$Pages$Admin$ImportBackendChunkRequest$(
						{
							offset: 0,
							totalBytes: $elm$bytes$Bytes$width(content)
						},
						chunk)),
				$author$project$Pages$Admin$NoOutMsg);
		case 58:
			return _Utils_Tuple3(
				model,
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$AdminChange(
					$author$project$Pages$Admin$RegenerateServerSecret($author$project$UserSession$EmptyPlaceholder)));
		case 59:
			return _Utils_Tuple3(
				model,
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$AdminChange(
					$author$project$Pages$Admin$DeleteOrphanedFiles($author$project$UserSession$EmptyPlaceholder)));
		default:
			var page = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{websocketCloseEventsPage: page}),
				$lamdera$program_test$Effect$Command$none,
				$author$project$Pages$Admin$NoOutMsg);
	}
};
var $author$project$Pages$Admin$update = F6($author$project$Pages$Admin$update$);
var $author$project$RecoveryLogin$Submitting = {$: 1};
var $author$project$RecoveryLogin$update$ = function (onSubmitPassword, msg, _v0) {
	var model = _v0;
	if (!msg.$) {
		var text = msg.a;
		var _v2 = model.submitStatus;
		if (_v2.$ === 1) {
			return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{password: text}),
				$lamdera$program_test$Effect$Command$none);
		}
	} else {
		return $elm$core$String$isEmpty(model.password) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{
					submitStatus: $author$project$RecoveryLogin$NotSubmitted(true)
				}),
			$lamdera$program_test$Effect$Command$none) : _Utils_Tuple2(
			_Utils_update(
				model,
				{submitStatus: $author$project$RecoveryLogin$Submitting}),
			onSubmitPassword(model.password));
	}
};
var $author$project$RecoveryLogin$update = F3($author$project$RecoveryLogin$update$);
var $author$project$TextEditor$Edit_TypedText$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$TextEditor$Edit_TypedText = F2($author$project$TextEditor$Edit_TypedText$);
var $author$project$TextEditor$Local_EditChange = function (a) {
	return {$: 0, a: a};
};
var $author$project$TextEditor$Local_Redo = {$: 3};
var $author$project$TextEditor$Local_Reset = {$: 1};
var $author$project$TextEditor$Local_Undo = {$: 2};
var $author$project$TextEditor$NoOutMsg = {$: 2};
var $author$project$TextEditor$OutMsg_Back = {$: 1};
var $author$project$TextEditor$OutMsg_LocalChange = function (a) {
	return {$: 0, a: a};
};
var $author$project$TextEditor$initEditorState = {text: ''};
var $author$project$TextEditor$insertText$ = function (insertionRange, text, local) {
	return _Utils_update(
		local,
		{
			text: $elmcraft$core_extra$String$Extra$replaceSlice$(
				text,
				$elm$core$Basics$max$(0, insertionRange.start),
				insertionRange.end,
				local.text)
		});
};
var $author$project$TextEditor$insertText = F3($author$project$TextEditor$insertText$);
var $author$project$TextEditor$getEditorState = function (local) {
	return function (_v4) {
		var a = _v4.c;
		return a;
	}(
		$elm$core$Array$foldl$(
			F2(
				function (_v0, _v1) {
					var changeBy = _v0.a;
					var change = _v0.b;
					var index = _v1.a;
					var skipped = _v1.b;
					var state = _v1.c;
					var isSkipped = function () {
						var _v3 = $lamdera$containers$SeqDict$get$(changeBy, local.undoPoint);
						if (!_v3.$) {
							var undoPoint = _v3.a;
							return _Utils_cmp(undoPoint, index) < 0;
						} else {
							return true;
						}
					}();
					return isSkipped ? _Utils_Tuple3(
						index + 1,
						A2($elm$core$List$cons, change, skipped),
						state) : _Utils_Tuple3(
						index + 1,
						skipped,
						function () {
							var range = change.a;
							var text = change.b;
							return $author$project$TextEditor$insertText$(
								$elm$core$List$foldl$($author$project$TextEditor$addEditAdjustRange, range, skipped),
								text,
								state);
						}());
				}),
			_Utils_Tuple3(0, _List_Nil, $author$project$TextEditor$initEditorState),
			local.history));
};
var $author$project$TextEditor$update$ = function (currentUserId, msg, model, local) {
	switch (msg.$) {
		case 0:
			var text = msg.a;
			var editorState = $author$project$TextEditor$getEditorState(local);
			var _v1 = $lamdera$containers$SeqDict$get$(currentUserId, local.cursorPosition);
			if (!_v1.$) {
				var range = _v1.a;
				var lengthDiff = $elm$core$String$length(text) - $elm$core$String$length(editorState.text);
				return _Utils_Tuple2(
					model,
					((!$author$project$Range$rangeSize(range)) && (lengthDiff < 0)) ? $author$project$TextEditor$OutMsg_LocalChange(
						$author$project$TextEditor$Local_EditChange(
							$author$project$TextEditor$Edit_TypedText$(
								_Utils_update(
									range,
									{start: range.start + lengthDiff}),
								''))) : $author$project$TextEditor$OutMsg_LocalChange(
						$author$project$TextEditor$Local_EditChange(
							$author$project$TextEditor$Edit_TypedText$(
								range,
								A3(
									$elm$core$String$slice,
									range.start,
									(range.start + lengthDiff) + $author$project$Range$rangeSize(range),
									text)))));
			} else {
				return _Utils_Tuple2(model, $author$project$TextEditor$NoOutMsg);
			}
		case 1:
			return _Utils_Tuple2(
				model,
				$author$project$TextEditor$OutMsg_LocalChange($author$project$TextEditor$Local_Reset));
		case 2:
			return _Utils_Tuple2(
				model,
				$author$project$TextEditor$OutMsg_LocalChange($author$project$TextEditor$Local_Undo));
		case 3:
			return _Utils_Tuple2(
				model,
				$author$project$TextEditor$OutMsg_LocalChange($author$project$TextEditor$Local_Redo));
		default:
			return _Utils_Tuple2(model, $author$project$TextEditor$OutMsg_Back);
	}
};
var $author$project$TextEditor$update = F4($author$project$TextEditor$update$);
var $author$project$TwoFactorAuthentication$ConfirmTwoFactorAuthenticationRequest = function (a) {
	return {$: 1, a: a};
};
var $author$project$TwoFactorAuthentication$DisableTwoFactorAuthenticationRequest = function (a) {
	return {$: 2, a: a};
};
var $author$project$TwoFactorAuthentication$EnableTwoFactorAuthenticationRequest = {$: 0};
var $author$project$TwoFactorAuthentication$TwoFactorDisable$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$TwoFactorAuthentication$TwoFactorDisable = F2($author$project$TwoFactorAuthentication$TwoFactorDisable$);
var $author$project$TwoFactorAuthentication$TwoFactorLoading = {$: 1};
var $author$project$TwoFactorAuthentication$TwoFactorSetup = function (a) {
	return {$: 2, a: a};
};
var $author$project$TwoFactorAuthentication$update$ = function (msg, twoFactorStatus) {
	switch (msg.$) {
		case 0:
			if (!twoFactorStatus.$) {
				return _Utils_Tuple2(
					$author$project$TwoFactorAuthentication$TwoFactorLoading,
					$lamdera$program_test$Effect$Lamdera$sendToBackend($author$project$TwoFactorAuthentication$EnableTwoFactorAuthenticationRequest));
			} else {
				return _Utils_Tuple2(twoFactorStatus, $lamdera$program_test$Effect$Command$none);
			}
		case 1:
			var text = msg.a;
			return _Utils_Tuple2(
				twoFactorStatus,
				$author$project$Ports$copyToClipboard(text));
		case 2:
			var code = msg.a;
			if (twoFactorStatus.$ === 2) {
				var state = twoFactorStatus.a;
				var _v3 = $author$project$LoginForm$typedCode$(
					$author$project$LoginForm$twoFactorCodeLength,
					function (a) {
						return $lamdera$program_test$Effect$Lamdera$sendToBackend(
							$author$project$TwoFactorAuthentication$ConfirmTwoFactorAuthenticationRequest(a));
					},
					code,
					_Utils_update(
						state,
						{attempts: $lamdera$containers$SeqDict$empty}));
				var state2 = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple2(
					$author$project$TwoFactorAuthentication$TwoFactorSetup(state2),
					cmd);
			} else {
				return _Utils_Tuple2(twoFactorStatus, $lamdera$program_test$Effect$Command$none);
			}
		case 3:
			if (twoFactorStatus.$ === 4) {
				var enabledAt = twoFactorStatus.a;
				return _Utils_Tuple2(
					$author$project$TwoFactorAuthentication$TwoFactorDisable$(
						enabledAt,
						{attempts: $lamdera$containers$SeqDict$empty, code: ''}),
					$lamdera$program_test$Effect$Command$none);
			} else {
				return _Utils_Tuple2(twoFactorStatus, $lamdera$program_test$Effect$Command$none);
			}
		case 4:
			if (twoFactorStatus.$ === 5) {
				var enabledAt = twoFactorStatus.a;
				return _Utils_Tuple2(
					$author$project$TwoFactorAuthentication$TwoFactorAlreadyComplete(enabledAt),
					$lamdera$program_test$Effect$Command$none);
			} else {
				return _Utils_Tuple2(twoFactorStatus, $lamdera$program_test$Effect$Command$none);
			}
		default:
			var code = msg.a;
			if (twoFactorStatus.$ === 5) {
				var enabledAt = twoFactorStatus.a;
				var state = twoFactorStatus.b;
				var _v7 = $author$project$LoginForm$typedCode$(
					$author$project$LoginForm$twoFactorCodeLength,
					function (a) {
						return $lamdera$program_test$Effect$Lamdera$sendToBackend(
							$author$project$TwoFactorAuthentication$DisableTwoFactorAuthenticationRequest(a));
					},
					code,
					_Utils_update(
						state,
						{attempts: $lamdera$containers$SeqDict$empty}));
				var state2 = _v7.a;
				var cmd = _v7.b;
				return _Utils_Tuple2(
					$author$project$TwoFactorAuthentication$TwoFactorDisable$(enabledAt, state2),
					cmd);
			} else {
				return _Utils_Tuple2(twoFactorStatus, $lamdera$program_test$Effect$Command$none);
			}
	}
};
var $author$project$TwoFactorAuthentication$update = F2($author$project$TwoFactorAuthentication$update$);
var $author$project$Internal$Model2$addRule$ = function (rule, existingRules) {
	return (rule === '') ? existingRules : A2($elm$core$List$cons, rule, existingRules);
};
var $author$project$Internal$Model2$addRule = F2($author$project$Internal$Model2$addRule$);
var $author$project$Internal$Model2$addChildReactions$ = function (parent, anims, untouched) {
	addChildReactions:
	while (true) {
		var state = untouched;
		if (!anims.b) {
			return _Utils_Tuple2(untouched, _List_Nil);
		} else {
			var css = anims.a;
			var remaining = anims.b;
			if ($elm$core$Set$member$(css.hash, state.added)) {
				var $temp$anims = remaining;
				anims = $temp$anims;
				continue addChildReactions;
			} else {
				var keyframes = $elm$core$Set$member$(css.keyframesHash, state.added) ? state.keyframes : $author$project$Internal$Model2$addRule$(css.keyframes, state.keyframes);
				var cssClass = ('.' + (parent.identifierClass + (css.trigger + (' .' + css.hash)))) + ('{' + ($author$project$Internal$Model2$addStylesToString$(css.props, '') + '}'));
				var $temp$anims = remaining,
					$temp$untouched = _Utils_update(
					state,
					{
						added: $elm$core$Set$insert$(
							css.keyframesHash,
							$elm$core$Set$insert$(css.hash, state.added)),
						keyframes: keyframes,
						rules: $author$project$Internal$Model2$addRule$(cssClass, state.rules)
					});
				anims = $temp$anims;
				untouched = $temp$untouched;
				continue addChildReactions;
			}
		}
	}
};
var $author$project$Internal$Model2$addChildReactions = F3($author$project$Internal$Model2$addChildReactions$);
var $author$project$Internal$Model2$applyTeleported$ = function (event, data, _v0) {
	var untouched = _v0.a;
	var state = untouched;
	var cmds = _v0.b;
	if (data.$ === 1) {
		var parentTrigger = data.a;
		return $author$project$Internal$Model2$addChildReactions$(parentTrigger, parentTrigger.children, untouched);
	} else {
		var css = data.a;
		if ($elm$core$Set$member$(css.hash, state.added)) {
			return _Utils_Tuple2(untouched, cmds);
		} else {
			var keyframes = $elm$core$Set$member$(css.keyframesHash, state.added) ? state.keyframes : $author$project$Internal$Model2$addRule$(css.keyframes, state.keyframes);
			var disableTrigger = '.' + (css.hash + ('.' + ($author$project$Internal$Style2$classes.trigger + '{ display: none; }')));
			var cssClass = '.' + (css.hash + (css.trigger + ('{' + ($author$project$Internal$Model2$addStylesToString$(css.props, '') + '}'))));
			return _Utils_Tuple2(
				_Utils_update(
					state,
					{
						added: $elm$core$Set$insert$(
							css.keyframesHash,
							$elm$core$Set$insert$(css.hash, state.added)),
						keyframes: keyframes,
						rules: $author$project$Internal$Model2$addRule$(
							disableTrigger,
							$author$project$Internal$Model2$addRule$(cssClass, state.rules))
					}),
				cmds);
		}
	}
};
var $author$project$Internal$Model2$applyTeleported = F3($author$project$Internal$Model2$applyTeleported$);
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Internal$Model2$update$ = function (toAppMsg, msg, unchanged) {
	var details = unchanged;
	if (!msg.$) {
		return _Utils_Tuple2(unchanged, $elm$core$Platform$Cmd$none);
	} else {
		var trigger = msg.a;
		var teleported = msg.b;
		var _v1 = $elm$core$List$foldl$(
			$author$project$Internal$Model2$applyTeleported(teleported),
			_Utils_Tuple2(unchanged, _List_Nil),
			teleported.data);
		var updated = _v1.a;
		var cmds = _v1.b;
		return _Utils_Tuple2(
			updated,
			A2(
				$elm$core$Platform$Cmd$map,
				toAppMsg,
				$elm$core$Platform$Cmd$batch(cmds)));
	}
};
var $author$project$Internal$Model2$update = F3($author$project$Internal$Model2$update$);
var $author$project$Ui$Anim$update$ = function (a, b, c) {
	return $author$project$Internal$Model2$update$(a, b, c).a;
};
var $author$project$Ui$Anim$update = F3($author$project$Ui$Anim$update$);
var $author$project$Drawing$ContinueStroke = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$DrawingMsg = function (a) {
	return {$: 164, a: a};
};
var $author$project$Drawing$EndStroke = function (a) {
	return {$: 2, a: a};
};
var $author$project$Drawing$GotZoomContainer = function (a) {
	return {$: 6, a: a};
};
var $author$project$Drawing$StartStroke = function (a) {
	return {$: 0, a: a};
};
var $author$project$SafeFloat$zero = 0;
var $author$project$Drawing$zoomCssOrigin = function (selected) {
	var _v0 = selected.zoomContainer;
	if (!_v0.$) {
		var container = _v0.a;
		if (selected.zoom <= 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var z = selected.zoom;
			var anchor = $author$project$Point2d$unwrap(selected.position);
			var _v1 = selected.anchorHalfSize;
			var halfWidth = _v1.a;
			var halfHeight = _v1.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					$elm$core$Basics$clamp$(0, container.width, ((z * ((anchor.x - container.x) + halfWidth)) - (container.width / 2)) / (z - 1)),
					$elm$core$Basics$clamp$(0, container.height, ((z * ((anchor.y - container.y) + halfHeight)) - (container.height / 2)) / (z - 1))));
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Drawing$zoomPointOffset = function (selected) {
	var _v0 = _Utils_Tuple2(
		selected.zoomContainer,
		$author$project$Drawing$zoomCssOrigin(selected));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var container = _v0.a.a;
		var _v1 = _v0.b.a;
		var originX = _v1.a;
		var originY = _v1.b;
		var anchor = $author$project$Point2d$unwrap(selected.position);
		return _Utils_Tuple2(originX - (anchor.x - container.x), originY - (anchor.y - container.y));
	} else {
		return _Utils_Tuple2(0, 0);
	}
};
var $author$project$Frontend$anchorRelativePoint$ = function (selected, x, y) {
	var anchorPosition = $author$project$Point2d$unwrap(selected.position);
	var _v0 = $author$project$Drawing$zoomPointOffset(selected);
	var offsetX = _v0.a;
	var offsetY = _v0.b;
	return _Utils_Tuple2(
		$elm$core$Result$withDefault$(
			$author$project$SafeFloat$zero,
			$author$project$SafeFloat$fromFloat((offsetX + (((x - anchorPosition.x) - offsetX) / selected.zoom)) * selected.pointScale)),
		$elm$core$Result$withDefault$(
			$author$project$SafeFloat$zero,
			$author$project$SafeFloat$fromFloat((offsetY + (((y - anchorPosition.y) - offsetY) / selected.zoom)) * selected.pointScale)));
};
var $author$project$Frontend$anchorRelativePoint = F3($author$project$Frontend$anchorRelativePoint$);
var $author$project$Drawing$zoomLevel = 2.5;
var $author$project$Frontend$updateDrawing$ = function (drawingMsg, model) {
	return $author$project$FrontendExtra$updateLoggedIn$(
		function (loggedIn) {
			var _v0 = loggedIn.drawingMode;
			if (_v0.$ === 1) {
				var selected = _v0.a;
				switch (drawingMsg.$) {
					case 0:
						var x = drawingMsg.a;
						var y = drawingMsg.b;
						var _v2 = selected.stroke;
						if (_v2.$ === 1) {
							return $author$project$FrontendExtra$handleLocalChange$(
								model.time,
								$elm$core$Maybe$Just(
									$author$project$Types$Local_Drawing$(
										selected.guildOrDmId,
										selected.anchorType,
										$author$project$Drawing$StartStroke(
											$author$project$Frontend$anchorRelativePoint$(selected, x, y)))),
								_Utils_update(
									loggedIn,
									{
										drawingMode: $author$project$Drawing$SelectedAnchor(
											_Utils_update(
												selected,
												{
													stroke: $elm$core$Maybe$Just(
														{unsent: _List_Nil})
												}))
									}),
								$lamdera$program_test$Effect$Command$none);
						} else {
							return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
						}
					case 1:
						var x = drawingMsg.a;
						var y = drawingMsg.b;
						var _v3 = selected.stroke;
						if (!_v3.$) {
							var stroke = _v3.a;
							var unsent = A2(
								$elm$core$List$cons,
								$author$project$Frontend$anchorRelativePoint$(selected, x, y),
								stroke.unsent);
							var setStroke = function (newStroke) {
								return _Utils_update(
									loggedIn,
									{
										drawingMode: $author$project$Drawing$SelectedAnchor(
											_Utils_update(
												selected,
												{stroke: newStroke}))
									});
							};
							return ($elm$core$List$length(unsent) >= 4) ? $author$project$FrontendExtra$handleLocalChange$(
								model.time,
								function () {
									var _v4 = $mgold$elm_nonempty_list$List$Nonempty$fromList(
										$elm$core$List$reverse(unsent));
									if (!_v4.$) {
										var points = _v4.a;
										return $elm$core$Maybe$Just(
											$author$project$Types$Local_Drawing$(
												selected.guildOrDmId,
												selected.anchorType,
												$author$project$Drawing$ContinueStroke(points)));
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}(),
								setStroke(
									$elm$core$Maybe$Just(
										{unsent: _List_Nil})),
								$lamdera$program_test$Effect$Command$none) : _Utils_Tuple2(
								setStroke(
									$elm$core$Maybe$Just(
										{unsent: unsent})),
								$lamdera$program_test$Effect$Command$none);
						} else {
							return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
						}
					case 2:
						var _v5 = selected.stroke;
						if (!_v5.$) {
							var stroke = _v5.a;
							return $author$project$FrontendExtra$handleLocalChange$(
								model.time,
								$elm$core$Maybe$Just(
									$author$project$Types$Local_Drawing$(
										selected.guildOrDmId,
										selected.anchorType,
										$author$project$Drawing$EndStroke(
											$elm$core$List$reverse(stroke.unsent)))),
								_Utils_update(
									loggedIn,
									{
										drawingMode: $author$project$Drawing$SelectedAnchor(
											_Utils_update(
												selected,
												{stroke: $elm$core$Maybe$Nothing}))
									}),
								$lamdera$program_test$Effect$Command$none);
						} else {
							return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
						}
					case 3:
						return $author$project$FrontendExtra$drawingUndo$(selected, loggedIn, model);
					case 4:
						return $author$project$FrontendExtra$drawingRedo$(selected, loggedIn, model);
					case 5:
						return (selected.zoom === 1) ? _Utils_Tuple2(
							_Utils_update(
								loggedIn,
								{
									drawingMode: $author$project$Drawing$SelectedAnchor(
										_Utils_update(
											selected,
											{zoom: $author$project$Drawing$zoomLevel, zoomContainer: $elm$core$Maybe$Nothing}))
								}),
							$lamdera$program_test$Effect$Task$attempt$(
								function (result) {
									return $author$project$Types$DrawingMsg(
										$author$project$Drawing$GotZoomContainer(
											function () {
												if (!result.$) {
													var element = result.a.element;
													return $elm$core$Maybe$Just(
														{height: element.height, width: element.width, x: element.x, y: element.y});
												} else {
													return $elm$core$Maybe$Nothing;
												}
											}()));
								},
								$lamdera$program_test$Effect$Browser$Dom$getElement($author$project$Pages$Guild$conversationContainerId))) : _Utils_Tuple2(
							_Utils_update(
								loggedIn,
								{
									drawingMode: $author$project$Drawing$SelectedAnchor(
										_Utils_update(
											selected,
											{zoom: 1, zoomContainer: $elm$core$Maybe$Nothing}))
								}),
							$lamdera$program_test$Effect$Command$none);
					case 6:
						var maybeContainer = drawingMsg.a;
						return _Utils_Tuple2(
							_Utils_update(
								loggedIn,
								{
									drawingMode: $author$project$Drawing$SelectedAnchor(
										_Utils_update(
											selected,
											{zoomContainer: maybeContainer}))
								}),
							$lamdera$program_test$Effect$Command$none);
					default:
						return _Utils_Tuple2(
							_Utils_update(
								loggedIn,
								{drawingMode: $author$project$Drawing$NoSelectedAnchor}),
							$lamdera$program_test$Effect$Command$none);
				}
			} else {
				return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
			}
		},
		model);
};
var $author$project$Frontend$updateDrawing = F2($author$project$Frontend$updateDrawing$);
var $author$project$FileStatus$emptyBytes = $elm$bytes$Bytes$Encode$encode(
	$elm$bytes$Bytes$Encode$sequence(_List_Nil));
var $author$project$FileStatus$uploadEncryptedFile$ = function (onResult, guildOrDmId, fileId, encrypted) {
	var thumbnail = $elm$core$Maybe$withDefault$($author$project$FileStatus$emptyBytes, encrypted.thumbnail);
	return $lamdera$program_test$Effect$Http$riskyRequest(
		{
			body: A2(
				$lamdera$program_test$Effect$Http$bytesBody,
				'application/octet-stream',
				$elm$bytes$Bytes$Encode$encode(
					$elm$bytes$Bytes$Encode$sequence(
						_List_fromArray(
							[
								A2(
								$elm$bytes$Bytes$Encode$unsignedInt32,
								1,
								$elm$bytes$Bytes$width(thumbnail)),
								$elm$bytes$Bytes$Encode$bytes(thumbnail),
								$elm$bytes$Bytes$Encode$bytes(encrypted.cipherText)
							])))),
			expect: $lamdera$program_test$Effect$Http$expectJson$(
				onResult,
				$miniBill$elm_codec$Codec$decoder($author$project$FileStatus$uploadResponseCodec)),
			headers: _List_Nil,
			method: 'POST',
			timeout: $elm$core$Maybe$Just($ianmackenzie$elm_units$Duration$minute),
			tracker: $elm$core$Maybe$Just(
				$author$project$FileStatus$uploadTrackerId$(guildOrDmId, fileId)),
			url: $author$project$FileStatus$domain + '/file/upload-encrypted'
		});
};
var $author$project$FileStatus$uploadEncryptedFile = F4($author$project$FileStatus$uploadEncryptedFile$);
var $author$project$Slack$SlackCookie = $elm$core$Basics$identity;
var $author$project$Slack$stringToSlackCookie = function (text) {
	return A2($elm$core$String$startsWith, 'xoxd-', text) ? (($elm$core$String$length(text) < 10) ? $elm$core$Result$Err('Cookie is too short') : $elm$core$Result$Ok(text)) : $elm$core$Result$Err('Cookie must start with \u0022xoxd-\u0022');
};
var $author$project$Slack$decodePastedWorkspace = A4(
	$elm$json$Json$Decode$map3,
	F3(
		function (name, url, token) {
			return {name: name, token: token, url: url};
		}),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'token', $elm$json$Json$Decode$string));
var $author$project$Slack$resultCombine = A2(
	$elm$core$List$foldr,
	$elm$core$Result$map2($elm$core$List$cons),
	$elm$core$Result$Ok(_List_Nil));
var $author$project$Slack$SlackToken = $elm$core$Basics$identity;
var $author$project$Slack$stringToSlackToken = function (text) {
	return A2($elm$core$String$startsWith, 'xoxc-', text) ? (($elm$core$String$length(text) < 10) ? $elm$core$Result$Err('Token is too short') : $elm$core$Result$Ok(text)) : $elm$core$Result$Err('Token must start with \u0022xoxc-\u0022');
};
var $author$project$Slack$teamsJsonToWorkspaces = function (text) {
	var _v0 = A2(
		$elm$json$Json$Decode$decodeString,
		$elm$json$Json$Decode$keyValuePairs($author$project$Slack$decodePastedWorkspace),
		text);
	if (!_v0.$) {
		var teams = _v0.a;
		var _v1 = $author$project$Slack$resultCombine(
			$elm$core$List$map$(
				function (_v2) {
					var teamId = _v2.a;
					var workspace = _v2.b;
					return $elm$core$Result$map$(
						function (token) {
							return {name: workspace.name, teamId: teamId, token: token, url: workspace.url};
						},
						$author$project$Slack$stringToSlackToken(workspace.token));
				},
				teams));
		if (!_v1.$) {
			var workspaces = _v1.a;
			var _v3 = $mgold$elm_nonempty_list$List$Nonempty$fromList(workspaces);
			if (!_v3.$) {
				var nonempty = _v3.a;
				return $elm$core$Result$Ok(nonempty);
			} else {
				return $elm$core$Result$Err('No workspaces found');
			}
		} else {
			var error = _v1.a;
			return $elm$core$Result$Err(error);
		}
	} else {
		return $elm$core$Result$Err('This isn\u0027t the teams JSON');
	}
};
var $author$project$Slack$teamsJsonToSlackTokens$ = function (removedTeams, text) {
	var _v0 = $author$project$Slack$teamsJsonToWorkspaces(text);
	if (!_v0.$) {
		var workspaces = _v0.a;
		var _v1 = $mgold$elm_nonempty_list$List$Nonempty$fromList(
			$elm$core$List$filterMap$(
				function (workspace) {
					return $lamdera$containers$SeqSet$member$(workspace.teamId, removedTeams) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(workspace.token);
				},
				$mgold$elm_nonempty_list$List$Nonempty$toList(workspaces)));
		if (!_v1.$) {
			var tokens = _v1.a;
			return $elm$core$Result$Ok(tokens);
		} else {
			return $elm$core$Result$Err('You must include at least one workspace');
		}
	} else {
		var error = _v0.a;
		return $elm$core$Result$Err(error);
	}
};
var $author$project$Slack$teamsJsonToSlackTokens = F2($author$project$Slack$teamsJsonToSlackTokens$);
var $author$project$Slack$validateSlackData = function (_v0) {
	var removedSlackTeams = _v0.removedSlackTeams;
	var slackTeamsJson = _v0.slackTeamsJson;
	var slackCookie = _v0.slackCookie;
	var _v1 = _Utils_Tuple2(
		$author$project$Slack$stringToSlackCookie(slackCookie),
		$author$project$Slack$teamsJsonToSlackTokens$(removedSlackTeams, slackTeamsJson));
	if ((!_v1.a.$) && (!_v1.b.$)) {
		var cookie = _v1.a.a;
		var tokens = _v1.b.a;
		return $elm$core$Result$Ok(
			{cookie: cookie, tokens: tokens});
	} else {
		return $elm$core$Result$Err(0);
	}
};
var $author$project$Frontend$viewImageInfo$ = function (guildOrDmId, fileId, model) {
	return $author$project$FrontendExtra$updateLoggedIn$(
		function (loggedIn) {
			return _Utils_Tuple2(
				_Utils_update(
					loggedIn,
					{
						showFileToUploadInfo: function () {
							var _v0 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.filesToUpload);
							if (!_v0.$) {
								var nonemptyDict = _v0.a;
								var _v1 = $author$project$NonemptyDict$get$(fileId, nonemptyDict);
								if ((!_v1.$) && (_v1.a.$ === 1)) {
									var fileData = _v1.a.a;
									var _v2 = fileData.metadata;
									if (!_v2.$) {
										var metadata = _v2.a;
										return $elm$core$Maybe$Just(
											{contentType: fileData.contentType, fileHash: fileData.fileHash, fileName: fileData.fileName, fileSize: fileData.fileSize, isEncrypted: fileData.isEncrypted, metadata: metadata});
									} else {
										return $elm$core$Maybe$Nothing;
									}
								} else {
									return $elm$core$Maybe$Nothing;
								}
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}()
					}),
				$lamdera$program_test$Effect$Command$none);
		},
		model);
};
var $author$project$Frontend$viewImageInfo = F3($author$project$Frontend$viewImageInfo$);
var $ianmackenzie$elm_units$Constants$second = 1;
var $ianmackenzie$elm_units$Constants$minute = 60 * $ianmackenzie$elm_units$Constants$second;
var $ianmackenzie$elm_units$Constants$hour = 60 * $ianmackenzie$elm_units$Constants$minute;
var $ianmackenzie$elm_units$Constants$day = 24 * $ianmackenzie$elm_units$Constants$hour;
var $ianmackenzie$elm_units$Constants$week = 7 * $ianmackenzie$elm_units$Constants$day;
var $ianmackenzie$elm_units$Duration$weeks = function (numWeeks) {
	return $ianmackenzie$elm_units$Duration$seconds($ianmackenzie$elm_units$Constants$week * numWeeks);
};
var $author$project$Frontend$updateLoaded$ = function (msg, model) {
	switch (msg.$) {
		case 0:
			var urlRequest = msg.a;
			if (!urlRequest.$) {
				var url = urlRequest.a;
				var route = $author$project$Route$decode(url);
				var isSameRoute = _Utils_eq(model.route, route);
				return _Utils_Tuple2(
					model,
					$lamdera$program_test$Effect$Command$batch(
						_List_fromArray(
							[
								isSameRoute ? $lamdera$program_test$Effect$Browser$Navigation$replaceUrl$(
								model.navigationKey,
								$author$project$Route$encode(route)) : $lamdera$program_test$Effect$Browser$Navigation$pushUrl$(
								model.navigationKey,
								$author$project$Route$encode(route))
							])));
			} else {
				var url = urlRequest.a;
				return _Utils_Tuple2(
					model,
					$lamdera$program_test$Effect$Browser$Navigation$load(url));
			}
		case 1:
			var url = msg.a;
			return $author$project$FrontendExtra$routeRequest$(
				$elm$core$Maybe$Just(model.route),
				$author$project$Route$decode(url),
				model);
		case 2:
			var time = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{time: time}),
				(model.pageHasFocus && $ianmackenzie$elm_units$Quantity$greaterThan$(
					$ianmackenzie$elm_units$Duration$seconds(10),
					$ianmackenzie$elm_units$Duration$from$(model.time, time))) ? $author$project$Frontend$checkAppVersion : $lamdera$program_test$Effect$Command$none);
		case 3:
			var width = msg.a;
			var height = msg.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						loginStatus: function () {
							var _v2 = model.loginStatus;
							if (!_v2.$) {
								var loggedIn = _v2.a;
								return $author$project$Types$LoggedIn(
									_Utils_update(
										loggedIn,
										{
											drawingMode: $author$project$Drawing$resetAnchor(loggedIn.drawingMode)
										}));
							} else {
								return model.loginStatus;
							}
						}(),
						windowSize: $author$project$Coord$xy$(width, height)
					}),
				$lamdera$program_test$Effect$Command$batch(
					_List_fromArray(
						[
							$author$project$Ports$requestDevicePixelRatio,
							$author$project$Frontend$stayAtBottomOfConversation(model)
						])));
		case 6:
			var _v3 = model.loginStatus;
			if (!_v3.$) {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			} else {
				var notLoggedIn = _v3.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							loginStatus: $author$project$Types$NotLoggedIn(
								_Utils_update(
									notLoggedIn,
									{
										loginForm: function () {
											var _v4 = notLoggedIn.loginForm;
											if (!_v4.$) {
												return notLoggedIn.loginForm;
											} else {
												return $elm$core$Maybe$Just($author$project$LoginForm$init);
											}
										}()
									}))
						}),
					$lamdera$program_test$Effect$Command$none);
			}
		case 7:
			var index = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						homePagePreview: {changedAt: model.time, index: index, rotate: false}
					}),
				$lamdera$program_test$Effect$Command$none);
		case 8:
			var adminPageMsg = msg.a;
			var _v5 = model.loginStatus;
			if (!_v5.$) {
				var loggedIn = _v5.a;
				var _v6 = $author$project$Local$model(loggedIn.localState).adminData;
				if (!_v6.$) {
					var adminData = _v6.a;
					var _v7 = $author$project$Pages$Admin$update$(
						model.navigationKey,
						model.time,
						adminData,
						$author$project$Local$model(loggedIn.localState),
						adminPageMsg,
						loggedIn.admin);
					var newAdmin = _v7.a;
					var cmd = _v7.b;
					var outMsg = _v7.c;
					var loggedIn2 = _Utils_update(
						loggedIn,
						{admin: newAdmin});
					switch (outMsg.$) {
						case 0:
							var adminChange = outMsg.a;
							var _v9 = $author$project$FrontendExtra$handleLocalChange$(
								model.time,
								$elm$core$Maybe$Just(
									$author$project$Types$Local_Admin(adminChange)),
								loggedIn2,
								$lamdera$program_test$Effect$Command$map$($author$project$Types$AdminToBackend, $author$project$Types$AdminPageMsg, cmd));
							var loggedIn3 = _v9.a;
							var cmd2 = _v9.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										loginStatus: $author$project$Types$LoggedIn(loggedIn3)
									}),
								cmd2);
						case 1:
							var adminChanges = outMsg.a;
							var _v10 = $elm$core$List$foldl$(
								F2(
									function (adminChange, _v11) {
										var loggedIn4 = _v11.a;
										var cmd3 = _v11.b;
										return $author$project$FrontendExtra$handleLocalChange$(
											model.time,
											$elm$core$Maybe$Just(
												$author$project$Types$Local_Admin(adminChange)),
											loggedIn4,
											cmd3);
									}),
								_Utils_Tuple2(
									loggedIn2,
									$lamdera$program_test$Effect$Command$map$($author$project$Types$AdminToBackend, $author$project$Types$AdminPageMsg, cmd)),
								adminChanges);
							var loggedIn3 = _v10.a;
							var cmd2 = _v10.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										loginStatus: $author$project$Types$LoggedIn(loggedIn3)
									}),
								cmd2);
						case 3:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										loginStatus: $author$project$Types$LoggedIn(loggedIn2)
									}),
								$lamdera$program_test$Effect$Command$map$($author$project$Types$AdminToBackend, $author$project$Types$AdminPageMsg, cmd));
						case 2:
							return $author$project$FrontendExtra$routePush$(
								_Utils_update(
									model,
									{
										loginStatus: $author$project$Types$LoggedIn(loggedIn2)
									}),
								$author$project$Route$HomePageRoute($elm$core$Maybe$Nothing));
						default:
							var text = outMsg.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										lastCopied: $elm$core$Maybe$Just(
											{
												copied: $author$project$MyUi$CopiedText(text),
												copiedAt: model.time
											})
									}),
								$author$project$Ports$copyToClipboard(text));
					}
				} else {
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				}
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 4:
			var loginFormMsg = msg.a;
			var _v12 = model.loginStatus;
			if (!_v12.$) {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			} else {
				var notLoggedIn = _v12.a;
				var requestMessagesFor = $author$project$Frontend$routeToInitialDataRequest(model.route);
				var _v13 = $author$project$LoginForm$update$(
					function (email) {
						return $lamdera$program_test$Effect$Lamdera$sendToBackend(
							$author$project$Types$GetLoginTokenRequest(email));
					},
					function (loginToken) {
						return $lamdera$program_test$Effect$Lamdera$sendToBackend(
							$author$project$Types$LoginWithTokenRequest$(requestMessagesFor, loginToken, model.startupData.userAgent));
					},
					function (loginToken) {
						return $lamdera$program_test$Effect$Lamdera$sendToBackend(
							$author$project$Types$LoginWithTwoFactorRequest$(requestMessagesFor, loginToken, model.startupData.userAgent));
					},
					function (name) {
						return $lamdera$program_test$Effect$Lamdera$sendToBackend(
							$author$project$Types$FinishUserCreationRequest$(requestMessagesFor, name, model.startupData.userAgent));
					},
					loginFormMsg,
					$elm$core$Maybe$withDefault$($author$project$LoginForm$init, notLoggedIn.loginForm));
				if (!_v13.$) {
					var _v14 = _v13.a;
					var newLoginForm = _v14.a;
					var cmd = _v14.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								loginStatus: $author$project$Types$NotLoggedIn(
									_Utils_update(
										notLoggedIn,
										{
											loginForm: $elm$core$Maybe$Just(newLoginForm)
										}))
							}),
						$lamdera$program_test$Effect$Command$map$($elm$core$Basics$identity, $author$project$Types$LoginFormMsg, cmd));
				} else {
					var model2 = _Utils_update(
						model,
						{
							loginStatus: $author$project$Types$NotLoggedIn(
								_Utils_update(
									notLoggedIn,
									{loginForm: $elm$core$Maybe$Nothing}))
						});
					return $author$project$Route$requiresLogin(model2.route) ? $author$project$FrontendExtra$routePush$(
						model2,
						$author$project$Route$HomePageRoute($elm$core$Maybe$Nothing)) : _Utils_Tuple2(
						model2,
						$author$project$FrontendExtra$routeReplace$(
							model2,
							$author$project$Route$HomePageRoute($elm$core$Maybe$Nothing)));
				}
			}
		case 5:
			var recoveryLoginMsg = msg.a;
			var _v15 = model.loginStatus;
			if (!_v15.$) {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			} else {
				var notLoggedIn = _v15.a;
				var _v16 = $author$project$RecoveryLogin$update$(
					function (password) {
						return $lamdera$program_test$Effect$Lamdera$sendToBackend(
							$author$project$Types$LoginWithRecoveryPasswordRequest$(
								$author$project$Frontend$routeToInitialDataRequest(model.route),
								password,
								model.startupData.userAgent));
					},
					recoveryLoginMsg,
					notLoggedIn.recoveryLogin);
				var recoveryLogin = _v16.a;
				var cmd = _v16.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							loginStatus: $author$project$Types$NotLoggedIn(
								_Utils_update(
									notLoggedIn,
									{recoveryLogin: recoveryLogin}))
						}),
					$lamdera$program_test$Effect$Command$map$($elm$core$Basics$identity, $author$project$Types$RecoveryLoginMsg, cmd));
			}
		case 9:
			var sessionId = msg.a;
			return _Utils_Tuple2(
				model,
				$lamdera$program_test$Effect$Lamdera$sendToBackend(
					$author$project$Types$LogOutRequest(sessionId)));
		case 11:
			return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
		case 10:
			var elmUiMsg = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						elmUiState: $author$project$Ui$Anim$update$($author$project$Types$ElmUiMsg, elmUiMsg, model.elmUiState)
					}),
				$lamdera$program_test$Effect$Command$none);
		case 12:
			var route = msg.a;
			return $author$project$FrontendExtra$routePush$(model, route);
		case 37:
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{typingDebouncer: true}),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 13:
			var _v17 = msg.a;
			var guildOrDmId = _v17.a;
			var threadRoute = _v17.b;
			var file = msg.b;
			var files = msg.c;
			return $author$project$FrontendExtra$gotFiles$(
				guildOrDmId,
				threadRoute,
				$mgold$elm_nonempty_list$List$Nonempty$Nonempty$(file, files),
				model);
		case 14:
			var guildId = msg.a;
			var newChannelForm = msg.b;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{
								newChannelForm: $lamdera$containers$SeqDict$insert$(guildId, newChannelForm, loggedIn.newChannelForm)
							}),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 15:
			var guildId = msg.a;
			var newChannelForm = msg.b;
			var _v18 = model.loginStatus;
			if (!_v18.$) {
				var loggedIn = _v18.a;
				var _v19 = $elm$core$Result$map2$(
					$elm$core$Tuple$pair,
					$author$project$ChannelName$fromString(newChannelForm.name),
					$author$project$ChannelDescription$fromString(newChannelForm.description));
				if (!_v19.$) {
					var _v20 = _v19.a;
					var channelName = _v20.a;
					var channelDescription = _v20.b;
					var oldLoggedIn = loggedIn;
					var nextChannelId = function () {
						var _v23 = $lamdera$containers$SeqDict$get$(
							guildId,
							$author$project$Local$model(oldLoggedIn.localState).guilds);
						if (!_v23.$) {
							var guild = _v23.a;
							return $author$project$Id$nextId(guild.channels);
						} else {
							return $author$project$Id$fromInt(0);
						}
					}();
					var _v21 = $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_NewChannel$(model.time, guildId, channelName, channelDescription)),
						_Utils_update(
							loggedIn,
							{
								newChannelForm: $lamdera$containers$SeqDict$remove$(guildId, loggedIn.newChannelForm)
							}),
						$lamdera$program_test$Effect$Command$none);
					var loggedIn2 = _v21.a;
					var cmd = _v21.b;
					var _v22 = $author$project$FrontendExtra$routePush$(
						_Utils_update(
							model,
							{
								loginStatus: $author$project$Types$LoggedIn(loggedIn2)
							}),
						$author$project$Route$GuildRoute$(
							guildId,
							$author$project$Route$ChannelRoute$(
								nextChannelId,
								$author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1),
								$elm$core$Maybe$Nothing),
							0,
							$elm$core$Maybe$Nothing));
					var model2 = _v22.a;
					var routeCmd = _v22.b;
					return _Utils_Tuple2(
						model2,
						$lamdera$program_test$Effect$Command$batch(
							_List_fromArray(
								[routeCmd, cmd])));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								loginStatus: $author$project$Types$LoggedIn(
									_Utils_update(
										loggedIn,
										{
											newChannelForm: $lamdera$containers$SeqDict$insert$(
												guildId,
												_Utils_update(
													newChannelForm,
													{pressedSubmit: true}),
												loggedIn.newChannelForm)
										}))
							}),
						$lamdera$program_test$Effect$Command$none);
				}
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 16:
			var guildId = msg.a;
			var channelId = msg.b;
			var form = msg.c;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{
								editChannelForm: $lamdera$containers$SeqDict$insert$(
									_Utils_Tuple2(guildId, channelId),
									form,
									loggedIn.editChannelForm)
							}),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 17:
			var guildId = msg.a;
			var channelId = msg.b;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{
								editChannelForm: $lamdera$containers$SeqDict$remove$(
									_Utils_Tuple2(guildId, channelId),
									loggedIn.editChannelForm)
							}),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 18:
			var guildId = msg.a;
			var channelId = msg.b;
			var form = msg.c;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					var _v24 = _Utils_Tuple2(
						$author$project$ChannelName$fromString(form.name),
						$author$project$ChannelDescription$fromString(form.description));
					if ((!_v24.a.$) && (!_v24.b.$)) {
						var channelName = _v24.a.a;
						var channelDescription = _v24.b.a;
						return $author$project$FrontendExtra$handleLocalChange$(
							model.time,
							$elm$core$Maybe$Just(
								$author$project$Types$Local_EditChannel$(guildId, channelId, channelName, channelDescription)),
							_Utils_update(
								loggedIn,
								{
									editChannelForm: $lamdera$containers$SeqDict$remove$(
										_Utils_Tuple2(guildId, channelId),
										loggedIn.editChannelForm)
								}),
							$lamdera$program_test$Effect$Command$none);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								loggedIn,
								{
									editChannelForm: $lamdera$containers$SeqDict$insert$(
										_Utils_Tuple2(guildId, channelId),
										_Utils_update(
											form,
											{pressedSubmit: true}),
										loggedIn.editChannelForm)
								}),
							$lamdera$program_test$Effect$Command$none);
					}
				},
				model);
		case 19:
			var guildId = msg.a;
			var channelId = msg.b;
			var _v25 = model.loginStatus;
			if (!_v25.$) {
				var loggedIn = _v25.a;
				var local = $author$project$Local$model(loggedIn.localState);
				var _v26 = function () {
					var _v27 = $lamdera$containers$SeqDict$get$(guildId, local.guilds);
					if (!_v27.$) {
						var guild = _v27.a;
						return $author$project$FrontendExtra$routePush$(
							model,
							$author$project$Route$GuildRoute$(
								guildId,
								$author$project$Route$ChannelRoute$(
									$author$project$LocalState$announcementChannel(guild),
									$author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1),
									$elm$core$Maybe$Nothing),
								1,
								$elm$core$Maybe$Nothing));
					} else {
						return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
					}
				}();
				var model2 = _v26.a;
				var cmd = _v26.b;
				var _v28 = $author$project$FrontendExtra$handleLocalChange$(
					model2.time,
					$elm$core$Maybe$Just(
						$author$project$Types$Local_DeleteChannel$(guildId, channelId)),
					_Utils_update(
						loggedIn,
						{
							drafts: $lamdera$containers$SeqDict$remove$(
								_Utils_Tuple2(
									$author$project$Id$GuildOrDmId(
										$author$project$Id$GuildOrDmId_Guild(
											{channelId: channelId, guildId: guildId})),
									$author$project$Id$NoThread),
								loggedIn.drafts),
							editChannelForm: $lamdera$containers$SeqDict$remove$(
								_Utils_Tuple2(guildId, channelId),
								loggedIn.editChannelForm)
						}),
					cmd);
				var loggedIn2 = _v28.a;
				var cmd2 = _v28.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							loginStatus: $author$project$Types$LoggedIn(loggedIn2)
						}),
					cmd2);
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 20:
			var guildId = msg.a;
			var form = msg.b;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{
								editGuildForm: $lamdera$containers$SeqDict$insert$(guildId, form, loggedIn.editGuildForm)
							}),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 21:
			var guildId = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{
								editGuildForm: $lamdera$containers$SeqDict$remove$(guildId, loggedIn.editGuildForm)
							}),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 22:
			var guildId = msg.a;
			var form = msg.b;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					var _v29 = $author$project$GuildName$fromString(form.name);
					if (!_v29.$) {
						var guildName = _v29.a;
						return $author$project$FrontendExtra$handleLocalChange$(
							model.time,
							$elm$core$Maybe$Just(
								$author$project$Types$Local_EditGuildName$(guildId, guildName)),
							_Utils_update(
								loggedIn,
								{
									editGuildForm: $lamdera$containers$SeqDict$remove$(guildId, loggedIn.editGuildForm)
								}),
							$lamdera$program_test$Effect$Command$none);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								loggedIn,
								{
									editGuildForm: $lamdera$containers$SeqDict$insert$(
										guildId,
										_Utils_update(
											form,
											{pressedSubmit: true}),
										loggedIn.editGuildForm)
								}),
							$lamdera$program_test$Effect$Command$none);
					}
				},
				model);
		case 23:
			var guildId = msg.a;
			var _v30 = model.loginStatus;
			if (!_v30.$) {
				var loggedIn = _v30.a;
				var _v31 = $author$project$FrontendExtra$routePush$(
					model,
					$author$project$Route$HomePageRoute($elm$core$Maybe$Nothing));
				var model2 = _v31.a;
				var cmd = _v31.b;
				var _v32 = $author$project$FrontendExtra$handleLocalChange$(
					model2.time,
					$elm$core$Maybe$Just(
						$author$project$Types$Local_DeleteGuild(guildId)),
					_Utils_update(
						loggedIn,
						{
							editGuildForm: $lamdera$containers$SeqDict$remove$(guildId, loggedIn.editGuildForm)
						}),
					cmd);
				var loggedIn2 = _v32.a;
				var cmd2 = _v32.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							loginStatus: $author$project$Types$LoggedIn(loggedIn2)
						}),
					cmd2);
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 27:
			var guildId = msg.a;
			var _v33 = model.loginStatus;
			if (!_v33.$) {
				var loggedIn = _v33.a;
				var _v34 = $author$project$FrontendExtra$routePush$(
					model,
					$author$project$Route$HomePageRoute($elm$core$Maybe$Nothing));
				var model2 = _v34.a;
				var cmd = _v34.b;
				var _v35 = $author$project$FrontendExtra$handleLocalChange$(
					model2.time,
					$elm$core$Maybe$Just(
						$author$project$Types$Local_LeaveGuild(guildId)),
					_Utils_update(
						loggedIn,
						{
							editGuildForm: $lamdera$containers$SeqDict$remove$(guildId, loggedIn.editGuildForm)
						}),
					cmd);
				var loggedIn2 = _v35.a;
				var cmd2 = _v35.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							loginStatus: $author$project$Types$LoggedIn(loggedIn2)
						}),
					cmd2);
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 28:
			var guildId = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_NewInviteLink$(model.time, guildId, $author$project$UserSession$EmptyPlaceholder)),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 29:
			var guildId = msg.a;
			var inviteLinkId = msg.b;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_DeleteInviteLink$(guildId, inviteLinkId)),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 30:
			var guildId = msg.a;
			var userId = msg.b;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_BanMember$(guildId, userId)),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 31:
			var inviteLinkId = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{
								showInviteLinkQrCode: _Utils_eq(
									$elm$core$Maybe$Just(inviteLinkId),
									loggedIn.showInviteLinkQrCode) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(inviteLinkId)
							}),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 32:
			return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
		case 33:
			var text = msg.a;
			return $author$project$Frontend$copyText$(text, model);
		case 34:
			var imageUrl = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						lastCopied: $elm$core$Maybe$Just(
							{
								copied: $author$project$MyUi$CopiedImage(imageUrl),
								copiedAt: model.time
							})
					}),
				$author$project$Ports$copyImageToClipboard(imageUrl));
		case 35:
			var newGuildForm = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{
								newGuildForm: $elm$core$Maybe$Just(newGuildForm)
							}),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 36:
			var newGuildForm = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					var _v36 = $author$project$GuildName$fromString(newGuildForm.name);
					if (!_v36.$) {
						var guildName = _v36.a;
						return $author$project$FrontendExtra$handleLocalChange$(
							model.time,
							$elm$core$Maybe$Just(
								$author$project$Types$Local_NewGuild$(model.time, guildName, $author$project$UserSession$EmptyPlaceholder)),
							loggedIn,
							$lamdera$program_test$Effect$Command$none);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								loggedIn,
								{
									newGuildForm: $elm$core$Maybe$Just(
										_Utils_update(
											newGuildForm,
											{pressedSubmit: true}))
								}),
							$lamdera$program_test$Effect$Command$none);
					}
				},
				model);
		case 38:
			var htmlId = msg.a;
			var result = msg.b;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						function () {
							if (!result.$) {
								var ok = result.a;
								var _v38 = loggedIn.textInputFocus;
								if (!_v38.$) {
									var textInputFocus = _v38.a;
									return _Utils_eq(textInputFocus.htmlId, htmlId) ? _Utils_update(
										loggedIn,
										{
											previousTextInputFocus: loggedIn.textInputFocus,
											textInputFocus: $elm$core$Maybe$Just(
												_Utils_update(
													textInputFocus,
													{
														dropdown: $elm$core$Maybe$Just(ok)
													}))
										}) : loggedIn;
								} else {
									return loggedIn;
								}
							} else {
								return loggedIn;
							}
						}(),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 39:
			return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
		case 40:
			return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
		case 41:
			var key = msg.a.key;
			var shiftKey = msg.a.shiftKey;
			var metaKey = msg.a.metaKey;
			var ctrlKey = msg.a.ctrlKey;
			var ctrlOrMeta = ctrlKey || metaKey;
			var _v39 = _Utils_Tuple3(ctrlOrMeta, shiftKey, key);
			_v39$6:
			while (true) {
				switch (_v39.c) {
					case 'Escape':
						return $author$project$FrontendExtra$handleEscapeKey(model);
					case 'z':
						if (_v39.a) {
							if (!_v39.b) {
								return $author$project$FrontendExtra$handleUndo(model);
							} else {
								return $author$project$FrontendExtra$handleRedo(model);
							}
						} else {
							break _v39$6;
						}
					case 'y':
						if (_v39.a) {
							return $author$project$FrontendExtra$handleRedo(model);
						} else {
							break _v39$6;
						}
					case 'k':
						if (_v39.a && (!_v39.b)) {
							return $author$project$Frontend$toggleSearchOverlay(model);
						} else {
							break _v39$6;
						}
					case 'K':
						if (_v39.a && (!_v39.b)) {
							return $author$project$Frontend$toggleSearchOverlay(model);
						} else {
							break _v39$6;
						}
					default:
						break _v39$6;
				}
			}
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					if ((!_Utils_eq(loggedIn.textInputFocus, $elm$core$Maybe$Nothing)) || _Utils_eq(
						$author$project$Route$toOverlay(model.route),
						$elm$core$Maybe$Just(2))) {
						return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
					} else {
						var _v40 = $author$project$FrontendExtra$currentGame$(
							$author$project$Local$model(loggedIn.localState),
							model);
						if (!_v40.$) {
							var match = _v40.a.match;
							var matchId = _v40.a.matchId;
							var guildOrDmId = _v40.a.guildOrDmId;
							return _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{
										games: $lamdera$containers$SeqDict$update$(
											guildOrDmId,
											A3($author$project$Game$pressedKey, matchId, key, match),
											loggedIn.games)
									}),
								$lamdera$program_test$Effect$Command$none);
						} else {
							return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
						}
					}
				},
				model);
		case 42:
			var guildOrDmId = msg.a;
			var threadRoute = msg.b;
			return $author$project$Frontend$showReactionEmojiSelector$(guildOrDmId, threadRoute, model);
		case 43:
			var emoji = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					var _v41 = loggedIn.messageHover;
					switch (_v41.$) {
						case 0:
							return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
						case 2:
							var data = _v41.a;
							return $author$project$Frontend$toggleReactionEmoji$(
								emoji,
								data.guildOrDmId,
								data.threadRoute,
								model,
								$author$project$MessageMenu$close$(model, loggedIn));
						case 1:
							var guildOrDmId = _v41.a;
							var threadRoute = _v41.b;
							return $author$project$Frontend$toggleReactionEmoji$(
								emoji,
								guildOrDmId,
								threadRoute,
								model,
								$author$project$MessageMenu$close$(model, loggedIn));
						default:
							return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
					}
				},
				model);
		case 44:
			var guildOrDmId = msg.a;
			var threadRoute = msg.b;
			return $author$project$Frontend$pressedEditMessage$(guildOrDmId, threadRoute, model);
		case 45:
			var emojiMsg = msg.a;
			switch (emojiMsg.$) {
				case 3:
					var emojiOrSticker = emojiMsg.a;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							var loggedIn2 = _Utils_update(
								loggedIn,
								{emojiSelector: $author$project$Emoji$selectorInit});
							var _v43 = loggedIn2.showEmojiSelector;
							switch (_v43.$) {
								case 0:
									return _Utils_Tuple2(loggedIn2, $lamdera$program_test$Effect$Command$none);
								case 1:
									var guildOrDmId = _v43.a;
									var threadRoute = _v43.b;
									switch (emojiOrSticker.$) {
										case 0:
											var emoji = emojiOrSticker.a;
											return $author$project$FrontendExtra$handleLocalChange$(
												model.time,
												$elm$core$Maybe$Just(
													$author$project$Types$Local_AddReactionEmoji$(
														guildOrDmId,
														threadRoute,
														$author$project$Emoji$EmojiOrCustomEmoji_Emoji(emoji))),
												_Utils_update(
													loggedIn2,
													{showEmojiSelector: $author$project$Types$EmojiSelectorHidden}),
												$author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn2.channelScrollPosition));
										case 1:
											return _Utils_Tuple2(loggedIn2, $lamdera$program_test$Effect$Command$none);
										default:
											var customEmojiId = emojiOrSticker.a;
											return $author$project$FrontendExtra$handleLocalChange$(
												model.time,
												$elm$core$Maybe$Just(
													$author$project$Types$Local_AddReactionEmoji$(
														guildOrDmId,
														threadRoute,
														$author$project$Emoji$EmojiOrCustomEmoji_CustomEmoji(customEmojiId))),
												_Utils_update(
													loggedIn2,
													{showEmojiSelector: $author$project$Types$EmojiSelectorHidden}),
												$author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn2.channelScrollPosition));
									}
								case 2:
									var maybeSelection = _v43.a;
									return $author$project$Frontend$insertEmojiOrSticker$($author$project$Pages$Guild$channelTextInputId, maybeSelection, emojiOrSticker, model, loggedIn2);
								case 3:
									var maybeSelection = _v43.b;
									return $author$project$Frontend$insertEmojiOrSticker$($author$project$MessageMenu$editMessageTextInputId, maybeSelection, emojiOrSticker, model, loggedIn2);
								case 4:
									var input = _v43.a;
									var maybeSelection = _v43.c;
									return $author$project$Frontend$insertEmojiOrSticker$(
										$author$project$SheepGame$inputId(input),
										maybeSelection,
										emojiOrSticker,
										model,
										loggedIn2);
								case 5:
									var guildOrDmId = _v43.a;
									var matchId = _v43.b;
									var target = _v43.c;
									switch (emojiOrSticker.$) {
										case 0:
											var emoji = emojiOrSticker.a;
											return $author$project$Frontend$addSheepGameReaction$(
												guildOrDmId,
												matchId,
												target,
												$author$project$Emoji$EmojiOrCustomEmoji_Emoji(emoji),
												model,
												loggedIn2);
										case 2:
											var customEmojiId = emojiOrSticker.a;
											return $author$project$Frontend$addSheepGameReaction$(
												guildOrDmId,
												matchId,
												target,
												$author$project$Emoji$EmojiOrCustomEmoji_CustomEmoji(customEmojiId),
												model,
												loggedIn2);
										default:
											return _Utils_Tuple2(loggedIn2, $lamdera$program_test$Effect$Command$none);
									}
								default:
									var guildOrDmId = _v43.a;
									var matchId = _v43.b;
									var target = _v43.c;
									switch (emojiOrSticker.$) {
										case 0:
											var emoji = emojiOrSticker.a;
											return $author$project$Frontend$addWordSpellingGameReaction$(
												guildOrDmId,
												matchId,
												target,
												$author$project$Emoji$EmojiOrCustomEmoji_Emoji(emoji),
												model,
												loggedIn2);
										case 2:
											var customEmojiId = emojiOrSticker.a;
											return $author$project$Frontend$addWordSpellingGameReaction$(
												guildOrDmId,
												matchId,
												target,
												$author$project$Emoji$EmojiOrCustomEmoji_CustomEmoji(customEmojiId),
												model,
												loggedIn2);
										default:
											return _Utils_Tuple2(loggedIn2, $lamdera$program_test$Effect$Command$none);
									}
							}
						},
						model);
				case 0:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 1:
					var category = emojiMsg.a;
					var offset = emojiMsg.b;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							var emojiSelector = loggedIn.emojiSelector;
							return _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{
										emojiSelector: _Utils_update(
											emojiSelector,
											{category: category})
									}),
								$lamdera$program_test$Effect$Task$attempt$(
									function (_v47) {
										return $author$project$Types$FrontendNoOp;
									},
									$lamdera$program_test$Effect$Browser$Dom$setViewportOf$($author$project$Emoji$scrollContainerId, 0, offset)));
						},
						model);
				case 2:
					var category = emojiMsg.a;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							var emojiSelector = loggedIn.emojiSelector;
							return _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{
										emojiSelector: _Utils_update(
											emojiSelector,
											{category: category})
									}),
								$lamdera$program_test$Effect$Command$none);
						},
						model);
				case 4:
					var skinTone = emojiMsg.a;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							return $author$project$FrontendExtra$handleLocalChange$(
								model.time,
								$elm$core$Maybe$Just(
									$author$project$Types$Local_SetEmojiSkinTone(skinTone)),
								loggedIn,
								$lamdera$program_test$Effect$Command$none);
						},
						model);
				case 5:
					var index = emojiMsg.a;
					var emoji = emojiMsg.b;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							var emojiSelector = loggedIn.emojiSelector;
							return _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{
										emojiSelector: _Utils_update(
											emojiSelector,
											{
												emojiHovered: $elm$core$Maybe$Just(
													{emoji: emoji, index: index})
											})
									}),
								$lamdera$program_test$Effect$Command$none);
						},
						model);
				case 6:
					var index = emojiMsg.a;
					var emoji = emojiMsg.b;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							var emojiSelector = loggedIn.emojiSelector;
							return _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{
										emojiSelector: _Utils_update(
											emojiSelector,
											{
												emojiHovered: $elm$core$Maybe$Just(
													{emoji: emoji, index: index})
											})
									}),
								$author$project$Frontend$scrollEmojiIntoView(index));
						},
						model);
				case 7:
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							var emojiSelector = loggedIn.emojiSelector;
							return _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{
										emojiSelector: _Utils_update(
											emojiSelector,
											{emojiHovered: $elm$core$Maybe$Nothing})
									}),
								$lamdera$program_test$Effect$Command$none);
						},
						model);
				case 8:
					var text = emojiMsg.a;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							return _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{
										emojiSelector: $author$project$Emoji$setSearch$(text, loggedIn.emojiSelector)
									}),
								$lamdera$program_test$Effect$Command$none);
						},
						model);
				case 9:
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							return _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{
										emojiSelector: $author$project$Emoji$setSearch$('', loggedIn.emojiSelector)
									}),
								$lamdera$program_test$Effect$Command$none);
						},
						model);
				default:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 46:
			var threadRoute = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					var _v48 = $author$project$Route$toGuildOrDmId$(
						$author$project$Local$model(loggedIn.localState).localUser.session.userId,
						model.route);
					if (!_v48.$) {
						var _v49 = _v48.a;
						var guildOrDmId = _v49.a;
						return $author$project$Frontend$pressedReply$(guildOrDmId, threadRoute, loggedIn, model);
					} else {
						return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
					}
				},
				model);
		case 47:
			var messageIndex = msg.a;
			var _v50 = _Utils_Tuple2(model.route, model.loginStatus);
			_v50$6:
			while (true) {
				if (!_v50.b.$) {
					switch (_v50.a.$) {
						case 3:
							if ((!_v50.a.b.$) && (!_v50.a.b.b.$)) {
								var _v51 = _v50.a;
								var guildId = _v51.a;
								var _v52 = _v51.b;
								var channelId = _v52.a;
								var _v53 = _v52.b;
								var loggedIn = _v50.b.a;
								return $author$project$FrontendExtra$routePush$(
									_Utils_update(
										model,
										{
											loginStatus: $author$project$Types$LoggedIn(
												$author$project$MessageMenu$close$(model, loggedIn))
										}),
									$author$project$Route$GuildRoute$(
										guildId,
										$author$project$Route$ChannelRoute$(
											channelId,
											$author$project$Route$ViewThreadWithFriends$(messageIndex, $elm$core$Maybe$Nothing, 1),
											$elm$core$Maybe$Nothing),
										0,
										$elm$core$Maybe$Nothing));
							} else {
								break _v50$6;
							}
						case 5:
							var dmRoute = _v50.a.a;
							var loggedIn = _v50.b.a;
							var _v54 = dmRoute.threadRoute;
							if (!_v54.$) {
								return $author$project$FrontendExtra$routePush$(
									_Utils_update(
										model,
										{
											loginStatus: $author$project$Types$LoggedIn(
												$author$project$MessageMenu$close$(model, loggedIn))
										}),
									$author$project$Route$DmRoute(
										_Utils_update(
											dmRoute,
											{
												threadRoute: $author$project$Route$ViewThreadWithFriends$(messageIndex, $elm$core$Maybe$Nothing, 1)
											})));
							} else {
								return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
							}
						case 4:
							var guildRoute = _v50.a.a;
							var loggedIn = _v50.b.a;
							var _v55 = guildRoute.channelRoute;
							if ((!_v55.$) && (!_v55.b.$)) {
								var channelId = _v55.a;
								var _v56 = _v55.b;
								return $author$project$FrontendExtra$routePush$(
									_Utils_update(
										model,
										{
											loginStatus: $author$project$Types$LoggedIn(
												$author$project$MessageMenu$close$(model, loggedIn))
										}),
									$author$project$Route$DiscordGuildRoute(
										_Utils_update(
											guildRoute,
											{
												channelRoute: $author$project$Route$DiscordChannel_ChannelRoute$(
													channelId,
													$author$project$Route$ViewThreadWithFriends$(messageIndex, $elm$core$Maybe$Nothing, 1),
													$elm$core$Maybe$Nothing)
											})));
							} else {
								return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
							}
						case 6:
							return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
						case 7:
							var routeData = _v50.a.a;
							var loggedIn = _v50.b.a;
							var _v57 = routeData.channelRoute;
							if (!_v57.$) {
								if (!_v57.b.$) {
									var channelId = _v57.a;
									return $author$project$FrontendExtra$routePush$(
										_Utils_update(
											model,
											{
												loginStatus: $author$project$Types$LoggedIn(
													$author$project$MessageMenu$close$(model, loggedIn))
											}),
										$author$project$Route$SlackWorkspaceRoute(
											_Utils_update(
												routeData,
												{
													channelRoute: $author$project$Route$SlackChannel_ChannelRoute$(
														channelId,
														$author$project$Id$ViewThreadWithMaybeMessage$(messageIndex, $elm$core$Maybe$Nothing),
														1)
												})));
								} else {
									var _v58 = _v57.b;
									return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
								}
							} else {
								return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
							}
						case 8:
							var routeData = _v50.a.a;
							var loggedIn = _v50.b.a;
							var _v59 = routeData.threadRoute;
							if (!_v59.$) {
								return $author$project$FrontendExtra$routePush$(
									_Utils_update(
										model,
										{
											loginStatus: $author$project$Types$LoggedIn(
												$author$project$MessageMenu$close$(model, loggedIn))
										}),
									$author$project$Route$SlackDmRoute(
										_Utils_update(
											routeData,
											{
												threadRoute: $author$project$Id$ViewThreadWithMaybeMessage$(messageIndex, $elm$core$Maybe$Nothing)
											})));
							} else {
								return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
							}
						default:
							break _v50$6;
					}
				} else {
					break _v50$6;
				}
			}
			return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
		case 48:
			var guildOrDmId = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{
								replyTo: $lamdera$containers$SeqDict$remove$(guildOrDmId, loggedIn.replyTo)
							}),
						$author$project$FrontendExtra$setFocus$(model, $author$project$Pages$Guild$channelTextInputId));
				},
				model);
		case 49:
			var notificationPermission = msg.a;
			var startupData = model.startupData;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						startupData: _Utils_update(
							startupData,
							{notificationPermission: notificationPermission})
					}),
				$lamdera$program_test$Effect$Command$none);
		case 50:
			var timeStamp = msg.a;
			var touches = msg.b;
			return $author$project$Frontend$touchStart$(
				$elm$core$Maybe$Nothing,
				$elm$core$Maybe$Nothing,
				$elm$core$Maybe$Nothing,
				$elm$core$Maybe$Nothing,
				$ianmackenzie$elm_units$Duration$addTo$(model.startupData.timeOrigin, timeStamp),
				touches,
				model);
		case 51:
			var timeStamp = msg.a;
			var newTouches = msg.b;
			var time = $ianmackenzie$elm_units$Duration$addTo$(model.startupData.timeOrigin, timeStamp);
			var _v60 = model.drag;
			switch (_v60.$) {
				case 2:
					var dragging = _v60.a;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							var averageMove = $author$project$Vector2d$unwrap(
								$author$project$Touch$averageTouchMove$(dragging.touches, newTouches));
							return _Utils_Tuple2(
								function () {
									var _v61 = dragging.target;
									switch (_v61) {
										case 1:
											return _Utils_update(
												loggedIn,
												{
													voiceChat: $author$project$Call$dragThumbnail$(
														$author$project$MyUi$isMobile(model),
														averageMove,
														model.windowSize,
														loggedIn.voiceChat)
												});
										case 2:
											return loggedIn;
										default:
											var _v62 = _Utils_Tuple2(loggedIn.showFileToUploadInfo, loggedIn.messageHover);
											if (!_v62.a.$) {
												return loggedIn;
											} else {
												if (_v62.b.$ === 2) {
													var _v63 = _v62.a;
													var messageMenu = _v62.b.a;
													if (dragging.horizontalStart) {
														return loggedIn;
													} else {
														var previousOffset = $author$project$Types$messageMenuMobileOffset(messageMenu.mobileMode);
														var offset = $ianmackenzie$elm_units$Quantity$min$(
															$author$project$MessageMenu$mobileMenuMaxHeight$(
																messageMenu,
																$author$project$Local$model(loggedIn.localState),
																model),
															$ianmackenzie$elm_units$Quantity$plus$(
																$author$project$CssPixels$cssPixels(-averageMove.y),
																previousOffset));
														return _Utils_update(
															loggedIn,
															{
																messageHover: $author$project$Types$MessageMenu(
																	_Utils_update(
																		messageMenu,
																		{
																			mobileMode: $author$project$Types$MessageMenuDragging(
																				{offset: offset, previousOffset: previousOffset, time: time})
																		}))
															});
													}
												} else {
													if (dragging.horizontalStart) {
														var tHorizontal = averageMove.x / $author$project$Coord$xRaw(model.windowSize);
														return _Utils_update(
															loggedIn,
															{
																sidebarMode: function () {
																	var _v64 = _Utils_Tuple2(
																		loggedIn.textInputFocus,
																		$author$project$Frontend$isTouchingTextInput(dragging.touches));
																	if ((!_v64.a.$) && _v64.b) {
																		return loggedIn.sidebarMode;
																	} else {
																		return $author$project$Frontend$dragChannelSidebar$(
																			$author$project$Frontend$channelSidebarDragRange(model.route),
																			time,
																			tHorizontal,
																			loggedIn.sidebarMode);
																	}
																}()
															});
													} else {
														return loggedIn;
													}
												}
											}
									}
								}(),
								$lamdera$program_test$Effect$Command$none);
						},
						_Utils_update(
							model,
							{
								drag: $author$project$Touch$Dragging(
									_Utils_update(
										dragging,
										{touches: newTouches})),
								dragPrevious: model.drag
							}));
				case 0:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				default:
					var startTouches = _v60.b;
					var averageMove = $author$project$Vector2d$unwrap(
						$author$project$Touch$averageTouchMove$(startTouches, newTouches));
					var horizontalStart = _Utils_cmp(
						$elm$core$Basics$abs(averageMove.x),
						$elm$core$Basics$abs(averageMove.y)) > 0;
					var _v65 = $author$project$Frontend$dragTarget$(startTouches, model);
					if (!_v65.$) {
						var target = _v65.a;
						return $author$project$FrontendExtra$updateLoggedIn$(
							function (loggedIn) {
								return _Utils_Tuple2(
									function () {
										switch (target) {
											case 1:
												return _Utils_update(
													loggedIn,
													{
														voiceChat: $author$project$Call$dragThumbnail$(
															$author$project$MyUi$isMobile(model),
															averageMove,
															model.windowSize,
															loggedIn.voiceChat)
													});
											case 0:
												if (horizontalStart) {
													var tHorizontal = averageMove.x / $author$project$Coord$xRaw(model.windowSize);
													return _Utils_update(
														loggedIn,
														{
															sidebarMode: function () {
																var _v67 = _Utils_Tuple2(
																	loggedIn.textInputFocus,
																	$author$project$Frontend$isTouchingTextInput(startTouches));
																if ((!_v67.a.$) && _v67.b) {
																	return loggedIn.sidebarMode;
																} else {
																	return $author$project$Frontend$dragChannelSidebar$(
																		$author$project$Frontend$channelSidebarDragRange(model.route),
																		time,
																		tHorizontal,
																		loggedIn.sidebarMode);
																}
															}()
														});
												} else {
													return loggedIn;
												}
											default:
												var _v68 = $author$project$FrontendExtra$currentGame$(
													$author$project$Local$model(loggedIn.localState),
													model);
												if (!_v68.$) {
													var match = _v68.a.match;
													var matchId = _v68.a.matchId;
													var guildOrDmId = _v68.a.guildOrDmId;
													return _Utils_update(
														loggedIn,
														{
															games: $lamdera$containers$SeqDict$updateIfExists$(
																guildOrDmId,
																A6(
																	$author$project$Game$dragStart,
																	time,
																	model.windowSize,
																	$author$project$Local$model(loggedIn.localState).localUser.session.userId,
																	$author$project$Touch$removeSafeAreaTopInset$(model.startupData.safeAreaInsetTop, startTouches),
																	matchId,
																	match),
																loggedIn.games)
														});
												} else {
													return loggedIn;
												}
										}
									}(),
									$lamdera$program_test$Effect$Command$none);
							},
							_Utils_update(
								model,
								{
									drag: $author$project$Touch$Dragging(
										{horizontalStart: horizontalStart, target: target, touches: startTouches}),
									dragPrevious: model.drag
								}));
					} else {
						return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
					}
			}
		case 52:
			var timeStamp = msg.a;
			return $author$project$Frontend$handleTouchEnd$(
				$ianmackenzie$elm_units$Duration$addTo$(model.startupData.timeOrigin, timeStamp),
				model);
		case 53:
			var timeStamp = msg.a;
			return $author$project$Frontend$handleTouchEnd$(
				$ianmackenzie$elm_units$Duration$addTo$(model.startupData.timeOrigin, timeStamp),
				model);
		case 54:
			var elapsedTime = msg.a;
			var _v69 = model.loginStatus;
			if (!_v69.$) {
				var loggedIn = _v69.a;
				var _v70 = loggedIn.sidebarMode;
				if (_v70.$ === 1) {
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				} else {
					var offset = _v70.a.offset;
					var target = $author$project$FrontendExtra$channelSidebarTarget(model.route);
					var step = $ianmackenzie$elm_units$Quantity$unwrap(
						$ianmackenzie$elm_units$Quantity$for$(elapsedTime, $author$project$Frontend$sidebarSpeed));
					var offset2 = (_Utils_cmp(offset, target) < 0) ? $elm$core$Basics$min$(target, offset + step) : $elm$core$Basics$max$(target, offset - step);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								loginStatus: $author$project$Types$LoggedIn(
									_Utils_update(
										loggedIn,
										{
											sidebarMode: $author$project$Route$ChannelSidebarNotDragging(
												{offset: offset2})
										}))
							}),
						(target > 1) ? $lamdera$program_test$Effect$Task$attempt$(
							function (_v71) {
								return $author$project$Types$RemoveFocus;
							},
							$lamdera$program_test$Effect$Browser$Dom$blur($author$project$Pages$Guild$channelTextInputId)) : $lamdera$program_test$Effect$Command$none);
				}
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 56:
			return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
		case 57:
			return $author$project$Frontend$startClosingChannelSidebar(model);
		case 58:
			return $author$project$Frontend$setShowMembers$(0, model);
		case 59:
			return $author$project$Frontend$setShowMembers$(1, model);
		case 60:
			var guildOrDmId = msg.a;
			var threadRoute = msg.b;
			var scrollPosition = msg.c;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					var local = $author$project$Local$model(loggedIn.localState);
					var loadNewer = function () {
						var _v73 = $author$project$Frontend$loadNewerMessages$(guildOrDmId, threadRoute, local);
						if (!_v73.$) {
							var localChange = _v73.a;
							return $author$project$FrontendExtra$handleLocalChange$(
								model.time,
								$elm$core$Maybe$Just(localChange),
								_Utils_update(
									loggedIn,
									{channelScrollPosition: 1}),
								$lamdera$program_test$Effect$Command$none);
						} else {
							return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
						}
					}();
					switch (scrollPosition) {
						case 2:
							return $author$project$FrontendExtra$handleLocalChange$(
								model.time,
								$author$project$Frontend$loadOlderMessages$(guildOrDmId, threadRoute, local),
								_Utils_update(
									loggedIn,
									{channelScrollPosition: scrollPosition}),
								$lamdera$program_test$Effect$Command$none);
						case 0:
							return $author$project$FrontendExtra$isShowingNewestMessages$(guildOrDmId, threadRoute, local) ? _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{channelScrollPosition: scrollPosition, newMessagesWhileNotScrolledToBottom: 0}),
								$lamdera$program_test$Effect$Command$none) : loadNewer;
						case 1:
							return $author$project$FrontendExtra$isShowingNewestMessages$(guildOrDmId, threadRoute, local) ? _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{channelScrollPosition: scrollPosition}),
								$lamdera$program_test$Effect$Command$none) : loadNewer;
						default:
							return _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{channelScrollPosition: scrollPosition}),
								$lamdera$program_test$Effect$Command$none);
					}
				},
				model);
		case 61:
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						$author$project$MessageMenu$close$(
							model,
							_Utils_update(
								loggedIn,
								{showEmojiSelector: $author$project$Types$EmojiSelectorHidden})),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 62:
			var guildOrDmId = msg.a;
			var messageIndex = msg.b;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_DeleteMessage$(guildOrDmId, messageIndex)),
						$author$project$MessageMenu$close$(model, loggedIn),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 63:
			var guildOrDmId = msg.a;
			var threadRoute = msg.b;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_SetLastViewed$(
								guildOrDmId,
								function () {
									if (threadRoute.$ === 1) {
										var threadMessageId = threadRoute.a;
										var messageId = threadRoute.b;
										return $author$project$Id$ViewThreadWithMessage$(
											threadMessageId,
											$author$project$Frontend$messageBefore(messageId));
									} else {
										var messageId = threadRoute.a;
										return $author$project$Id$NoThreadWithMessage(
											$author$project$Frontend$messageBefore(messageId));
									}
								}())),
						$author$project$MessageMenu$close$(model, loggedIn),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 64:
			var customEmojiIds = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_AddCustomEmojisToUser(customEmojiIds)),
						$author$project$MessageMenu$close$(model, loggedIn),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 65:
			var otherUserId = msg.a;
			var _v75 = model.loginStatus;
			if (!_v75.$) {
				var loggedIn = _v75.a;
				return $author$project$FrontendExtra$routePush$(
					model,
					$author$project$Route$DmRoute(
						{
							channelId: $author$project$DmChannelId$fromUserIds$(
								otherUserId,
								$author$project$Local$model(loggedIn.localState).localUser.session.userId),
							channelsVisible: 0,
							overlay: $elm$core$Maybe$Nothing,
							tab: $elm$core$Maybe$Nothing,
							threadRoute: $author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1)
						}));
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 66:
			var currentUserId = msg.a;
			var channelId = msg.b;
			var _v76 = model.loginStatus;
			if (!_v76.$) {
				return $author$project$FrontendExtra$routePush$(
					model,
					$author$project$Route$DiscordDmRoute(
						{channelId: channelId, channelsVisible: 0, currentDiscordUserId: currentUserId, overlay: $elm$core$Maybe$Nothing, showMembersTab: 1, tab: $elm$core$Maybe$Nothing, viewingMessage: $elm$core$Maybe$Nothing}));
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 67:
			return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
		case 68:
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						$author$project$MessageMenu$close$(model, loggedIn),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 69:
			return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
		case 70:
			var guildOrDmId = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{
								editMessage: $lamdera$containers$SeqDict$remove$(guildOrDmId, loggedIn.editMessage)
							}),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 71:
			var startTime = msg.a;
			var guildOrDmId = msg.b;
			var threadRoute = msg.c;
			var isThreadStarter = msg.d;
			var maybeImageUrl = msg.e;
			var maybeLinkUrl = msg.f;
			var maybeReactionIndex = msg.g;
			var _v77 = model.drag;
			switch (_v77.$) {
				case 1:
					var dragStart = _v77.a;
					return _Utils_eq(startTime, dragStart) ? $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							return _Utils_Tuple2(
								function () {
									if (!maybeReactionIndex.$) {
										var reactionIndex = maybeReactionIndex.a;
										return _Utils_update(
											loggedIn,
											{
												messageHover: $author$project$Types$ReactionPopup$(guildOrDmId, threadRoute, reactionIndex)
											});
									} else {
										return $author$project$Frontend$handleAltPressedMessage$(
											guildOrDmId,
											threadRoute,
											isThreadStarter,
											maybeImageUrl,
											maybeLinkUrl,
											$author$project$Coord$origin,
											loggedIn,
											$author$project$Local$model(loggedIn.localState),
											model);
									}
								}(),
								$author$project$Ports$hapticFeedback);
						},
						model) : _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 0:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				default:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 55:
			var elapsedTime = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{
								messageHover: function () {
									var _v79 = loggedIn.messageHover;
									switch (_v79.$) {
										case 0:
											return loggedIn.messageHover;
										case 1:
											return loggedIn.messageHover;
										case 3:
											return loggedIn.messageHover;
										default:
											var messageMenu = _v79.a;
											var _v80 = messageMenu.mobileMode;
											switch (_v80.$) {
												case 1:
													var targetOffset = _v80.a.targetOffset;
													var offset = _v80.a.offset;
													var delta = $ianmackenzie$elm_units$Quantity$for$(elapsedTime, $author$project$MessageMenu$messageMenuSpeed);
													var offsetNext = $ianmackenzie$elm_units$Quantity$lessThan$(targetOffset, offset) ? $ianmackenzie$elm_units$Quantity$plus$(delta, offset) : $ianmackenzie$elm_units$Quantity$minus$(delta, offset);
													return $author$project$Types$MessageMenu(
														_Utils_update(
															messageMenu,
															{
																mobileMode: _Utils_eq(
																	$ianmackenzie$elm_units$Quantity$lessThan$(targetOffset, offsetNext),
																	$ianmackenzie$elm_units$Quantity$lessThan$(targetOffset, offset)) ? $author$project$Types$MessageMenuOpening(
																	{offset: offsetNext, targetOffset: targetOffset}) : $author$project$Types$MessageMenuFixed(targetOffset)
															}));
												case 0:
													var offset = _v80.a;
													var maybeEdit = _v80.b;
													var offsetNext = $ianmackenzie$elm_units$Quantity$minus$(
														$ianmackenzie$elm_units$Quantity$for$(elapsedTime, $author$project$MessageMenu$messageMenuSpeed),
														offset);
													return $ianmackenzie$elm_units$Quantity$lessThanOrEqualToZero(offsetNext) ? $author$project$Types$NoMessageHover : $author$project$Types$MessageMenu(
														_Utils_update(
															messageMenu,
															{
																mobileMode: $author$project$Types$MessageMenuClosing$(offsetNext, maybeEdit)
															}));
												case 2:
													return $author$project$Types$MessageMenu(messageMenu);
												default:
													return $author$project$Types$MessageMenu(messageMenu);
											}
									}
								}()
							}),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 72:
			return $author$project$FrontendExtra$routePush$(
				model,
				$author$project$Route$setOverlay$(
					$elm$core$Maybe$Just(1),
					model.route));
		case 73:
			return $author$project$FrontendExtra$routePush$(
				model,
				$author$project$Route$setOverlay$($elm$core$Maybe$Nothing, model.route));
		case 74:
			var section = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$lamdera$containers$SeqSet$member$(
							section,
							$author$project$Local$model(loggedIn.localState).localUser.session.expandedUserOptions) ? $elm$core$Maybe$Just(
							$author$project$Types$Local_CollapseUserOptionSection(section)) : $elm$core$Maybe$Just(
							$author$project$Types$Local_ExpandUserOptionSection$(
								section,
								{collapseOthers: false})),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 75:
			var twoFactorMsg = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					var _v81 = $author$project$TwoFactorAuthentication$update$(twoFactorMsg, loggedIn.twoFactor);
					var twoFactor2 = _v81.a;
					var cmd = _v81.b;
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{twoFactor: twoFactor2}),
						$lamdera$program_test$Effect$Command$map$($author$project$Types$TwoFactorToBackend, $author$project$Types$TwoFactorMsg, cmd));
				},
				model);
		case 76:
			var aiChatMsg = msg.a;
			var _v82 = $author$project$AiChat$update$(aiChatMsg, model.aiChatModel);
			var aiChatModel2 = _v82.a;
			var aiChatCmd = _v82.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{aiChatModel: aiChatModel2}),
				$lamdera$program_test$Effect$Command$map$($author$project$Types$AiChatToBackend, $author$project$Types$AiChatMsg, aiChatCmd));
		case 77:
			var gameMsg = msg.a;
			var _v83 = model.loginStatus;
			if (!_v83.$) {
				var loggedIn = _v83.a;
				var local = $author$project$Local$model(loggedIn.localState);
				var _v84 = $author$project$FrontendExtra$currentGamesTab$(local, model.route);
				if (!_v84.$) {
					var gamesTab = _v84.a;
					var _v85 = $author$project$Game$update$(
						model.time,
						model.windowSize,
						local.localUser,
						gamesTab.guildOrDmId,
						gameMsg,
						gamesTab.newMatchId,
						function () {
							var _v86 = gamesTab.maybeMatchId;
							if (!_v86.$) {
								var matchId = _v86.a;
								var _v87 = $lamdera$containers$SeqDict$get$(matchId, gamesTab.channelGames);
								if (!_v87.$) {
									var matchData = _v87.a;
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(matchId, matchData));
								} else {
									return $elm$core$Maybe$Nothing;
								}
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}(),
						$elm$core$Maybe$withDefault$(
							$author$project$Game$initModel,
							$lamdera$containers$SeqDict$get$(gamesTab.guildOrDmId, loggedIn.games)));
					var gameModel2 = _v85.a;
					var outMsgs = _v85.b;
					var _v88 = $elm$core$List$foldl$(
						F2(
							function (outMsg, _v89) {
								var accLoggedIn = _v89.a;
								var accCmd = _v89.b;
								switch (outMsg.$) {
									case 0:
										var change = outMsg.a;
										return $author$project$FrontendExtra$handleLocalChange$(
											model.time,
											$elm$core$Maybe$Just(
												$author$project$Types$Local_Game$(gamesTab.guildOrDmId, change)),
											accLoggedIn,
											accCmd);
									case 7:
										var questions = outMsg.a;
										return $author$project$FrontendExtra$handleLocalChange$(
											model.time,
											$elm$core$Maybe$Just(
												$author$project$Types$Local_SetSheepGameQuestions(questions)),
											accLoggedIn,
											accCmd);
									default:
										return _Utils_Tuple2(accLoggedIn, accCmd);
								}
							}),
						_Utils_Tuple2(
							_Utils_update(
								loggedIn,
								{
									games: $lamdera$containers$SeqDict$update$(
										gamesTab.guildOrDmId,
										function (_v91) {
											return $elm$core$Maybe$Just(gameModel2);
										},
										loggedIn.games)
								}),
							$lamdera$program_test$Effect$Command$none),
						outMsgs);
					var loggedIn2 = _v88.a;
					var localChangeCmd = _v88.b;
					var _v92 = $author$project$Frontend$handleGameOutMsgs$(
						outMsgs,
						_Utils_update(
							model,
							{
								loginStatus: $author$project$Types$LoggedIn(loggedIn2)
							}));
					var model2 = _v92.a;
					var effectCmd = _v92.b;
					return _Utils_Tuple2(
						model2,
						$lamdera$program_test$Effect$Command$batch(
							_List_fromArray(
								[
									localChangeCmd,
									$lamdera$program_test$Effect$Command$batch(
									$elm$core$List$reverse(effectCmd))
								])));
				} else {
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				}
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 78:
			var guildOrDmId = msg.a;
			var matchId = msg.b;
			var input = msg.c;
			var counter = msg.d;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$map$(
							$author$project$Types$Local_Game(guildOrDmId),
							$elm$core$Maybe$andThen$(
								A5(
									$author$project$Game$sheepGameInputToSave,
									model.time,
									$author$project$Local$model(loggedIn.localState).localUser,
									matchId,
									input,
									counter),
								$lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.games))),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 79:
			var guildOrDmId = msg.a;
			var counter = msg.b;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$map$(
							$author$project$Types$Local_SetSheepGameQuestions,
							$elm$core$Maybe$andThen$(
								$author$project$Game$sheepGameQuestionsToSave(counter),
								$lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.games))),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 81:
			var editableMsg = msg.a;
			return $author$project$Frontend$handleEditable$(
				editableMsg,
				F2(
					function (userOptions, value) {
						return _Utils_update(
							userOptions,
							{name: value});
					}),
				F2(
					function (value, loggedIn) {
						return $author$project$FrontendExtra$handleLocalChange$(
							model.time,
							$elm$core$Maybe$Just(
								$author$project$Types$Local_SetName(value)),
							loggedIn,
							$lamdera$program_test$Effect$Command$none);
					}),
				model);
		case 84:
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{dragPrevious: model.drag}),
				$lamdera$program_test$Effect$Command$none);
		case 85:
			var guildOrDmId = msg.a;
			var fileId = msg.b;
			var contentType = msg.c;
			var bytes = msg.d;
			return $author$project$FrontendExtra$updateLoggedIn$(
				A4($author$project$FrontendExtra$startEncryptingFile, guildOrDmId, fileId, contentType, bytes),
				model);
		case 86:
			var guildOrDmId = msg.a;
			var fileStatusId = msg.b;
			var clientMetadata = msg.c;
			var result = msg.d;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					var filesToUpload = $lamdera$containers$SeqDict$updateIfExists$(
						guildOrDmId,
						A2(
							$author$project$NonemptyDict$updateIfExists,
							fileStatusId,
							A2($author$project$FileStatus$addFileHash, clientMetadata, result)),
						loggedIn.filesToUpload);
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{filesToUpload: filesToUpload}),
						function () {
							var _v93 = $elm$core$Maybe$andThen$(
								$author$project$NonemptyDict$get(fileStatusId),
								$lamdera$containers$SeqDict$get$(guildOrDmId, filesToUpload));
							if (!_v93.$) {
								switch (_v93.a.$) {
									case 1:
										var fileData = _v93.a.a;
										var _v94 = $author$project$FileStatus$fileKey(fileData);
										if (!_v94.$) {
											var key = _v94.a;
											return $author$project$Encryption$storeFileKeys(
												_List_fromArray(
													[key]));
										} else {
											return $lamdera$program_test$Effect$Command$none;
										}
									case 0:
										var _v95 = _v93.a;
										return $lamdera$program_test$Effect$Command$none;
									default:
										var _v96 = _v93.a;
										return $lamdera$program_test$Effect$Command$none;
								}
							} else {
								return $lamdera$program_test$Effect$Command$none;
							}
						}());
				},
				model);
		case 87:
			var guildOrDmId = msg.a;
			var fileId = msg.b;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					var local = $author$project$Local$model(loggedIn.localState);
					var allUsers = $author$project$User$allUsers(local.localUser);
					var removeFile = F2(
						function (channels, draft) {
							var _v100 = $author$project$RichText$removeAttachedFile$(
								function (a) {
									return _Utils_eq(a, fileId);
								},
								$author$project$RichText$fromNonemptyString$(local.localUser.timezone, allUsers, channels, draft));
							if (!_v100.$) {
								var richText = _v100.a;
								return $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(
									$author$project$RichText$toString$(local.localUser.timezone, false, allUsers, channels, richText));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						});
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{
								drafts: $lamdera$containers$SeqDict$update$(
									guildOrDmId,
									function (maybe) {
										if (!maybe.$) {
											var draft = maybe.a;
											var _v98 = guildOrDmId.a;
											switch (_v98.$) {
												case 0:
													var guildOrDmId2 = _v98.a;
													return A2(
														removeFile,
														$author$project$LocalState$channelMentions$(guildOrDmId2, local),
														draft);
												case 1:
													var guildOrDmId2 = _v98.a;
													return A2(
														removeFile,
														$author$project$LocalState$discordChannelMentions$(guildOrDmId2, local),
														draft);
												default:
													var guildOrDmId2 = _v98.a;
													return A2(
														removeFile,
														$author$project$LocalState$slackChannelMentions$(guildOrDmId2, local),
														draft);
											}
										} else {
											return $elm$core$Maybe$Nothing;
										}
									},
									loggedIn.drafts),
								filesToUpload: $lamdera$containers$SeqDict$update$(
									guildOrDmId,
									function (maybe) {
										if (!maybe.$) {
											var dict = maybe.a;
											return $author$project$NonemptyDict$fromSeqDict(
												$lamdera$containers$SeqDict$remove$(
													fileId,
													$author$project$NonemptyDict$toSeqDict(dict)));
										} else {
											return $elm$core$Maybe$Nothing;
										}
									},
									loggedIn.filesToUpload)
							}),
						$lamdera$program_test$Effect$Http$cancel(
							$author$project$FileStatus$uploadTrackerId$(guildOrDmId, fileId)));
				},
				model);
		case 90:
			var guildOrDmId = msg.a;
			var fileId = msg.b;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					var local = $author$project$Local$model(loggedIn.localState);
					var allUsers = $author$project$User$allUsers(local.localUser);
					var removeFile = F3(
						function (channels, nonempty, text) {
							var _v104 = $author$project$RichText$removeAttachedFile$(
								function (a) {
									return _Utils_eq(a, fileId);
								},
								$author$project$RichText$fromNonemptyString$(local.localUser.timezone, allUsers, channels, nonempty));
							if (!_v104.$) {
								var richText = _v104.a;
								return $author$project$RichText$toString$(local.localUser.timezone, false, allUsers, channels, richText);
							} else {
								return text;
							}
						});
					return _Utils_Tuple2(
						function () {
							var _v101 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.editMessage);
							if (!_v101.$) {
								var edit = _v101.a;
								return _Utils_update(
									loggedIn,
									{
										editMessage: $lamdera$containers$SeqDict$insert$(
											guildOrDmId,
											_Utils_update(
												edit,
												{
													attachedFiles: $lamdera$containers$SeqDict$remove$(fileId, edit.attachedFiles),
													text: function () {
														var _v102 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(edit.text);
														if (!_v102.$) {
															var nonempty = _v102.a;
															var _v103 = guildOrDmId.a;
															switch (_v103.$) {
																case 0:
																	var guildOrDmId2 = _v103.a;
																	return A3(
																		removeFile,
																		$author$project$LocalState$channelMentions$(guildOrDmId2, local),
																		nonempty,
																		edit.text);
																case 1:
																	var guildOrDmId2 = _v103.a;
																	return A3(
																		removeFile,
																		$author$project$LocalState$discordChannelMentions$(guildOrDmId2, local),
																		nonempty,
																		edit.text);
																default:
																	var guildOrDmId2 = _v103.a;
																	return A3(
																		removeFile,
																		$author$project$LocalState$slackChannelMentions$(guildOrDmId2, local),
																		nonempty,
																		edit.text);
															}
														} else {
															return edit.text;
														}
													}()
												}),
											loggedIn.editMessage)
									});
							} else {
								return loggedIn;
							}
						}(),
						$lamdera$program_test$Effect$Http$cancel(
							$author$project$FileStatus$uploadTrackerId$(guildOrDmId, fileId)));
				},
				model);
		case 93:
			var guildOrDmId = msg.a;
			var file = msg.b;
			var files = msg.c;
			return $author$project$FrontendExtra$editMessage_gotFiles$(
				guildOrDmId,
				$mgold$elm_nonempty_list$List$Nonempty$Nonempty$(file, files),
				model);
		case 94:
			var guildOrDmId = msg.a;
			var messageIndex = msg.b;
			var fileId = msg.c;
			var result = msg.d;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{
								editMessage: $lamdera$containers$SeqDict$updateIfExists$(
									guildOrDmId,
									function (edit) {
										return _Utils_eq(edit.messageIndex, messageIndex) ? _Utils_update(
											edit,
											{
												attachedFiles: $lamdera$containers$SeqDict$updateIfExists$(
													fileId,
													A2($author$project$FileStatus$addFileHash, $elm$core$Maybe$Nothing, result),
													edit.attachedFiles)
											}) : edit;
									},
									loggedIn.editMessage)
							}),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 95:
			var guildOrDmId = msg.a;
			var fileId = msg.b;
			var progress = msg.c;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{
								filesToUpload: $lamdera$containers$SeqDict$updateIfExists$(
									guildOrDmId,
									A2(
										$author$project$NonemptyDict$updateIfExists,
										fileId,
										function (fileStatus) {
											switch (fileStatus.$) {
												case 0:
													var fileName = fileStatus.a;
													var fileSize = fileStatus.b;
													var contentType = fileStatus.c;
													var isEncrypted = fileStatus.d;
													return $author$project$FileStatus$FileUploading$(
														fileName,
														function () {
															if (!progress.$) {
																var progress2 = progress.a;
																return progress2;
															} else {
																var received = progress.a.received;
																return {sent: received, size: fileSize.size};
															}
														}(),
														contentType,
														isEncrypted);
												case 1:
													return fileStatus;
												default:
													return fileStatus;
											}
										}),
									loggedIn.filesToUpload)
							}),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 97:
			var imageViewerMsg = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						imageViewer: $elm$core$Maybe$andThen$(
							A2($author$project$ImageViewer$update, model.windowSize, imageViewerMsg),
							model.imageViewer)
					}),
				$lamdera$program_test$Effect$Command$none);
		case 96:
			var guildOrDmId = msg.a;
			var threadRoute = msg.b;
			var messageViewMsg = msg.c;
			switch (messageViewMsg.$) {
				case 0:
					var spoilerIndex = messageViewMsg.a;
					return $author$project$Frontend$handleRevealSpoilers$(guildOrDmId, threadRoute, spoilerIndex, model);
				case 3:
					return $author$project$Frontend$handleMouseEnteredMessage$(guildOrDmId, threadRoute, model);
				case 4:
					return $author$project$Frontend$handleMouseExitedMessage$(guildOrDmId, threadRoute, model);
				case 5:
					var timeStamp = messageViewMsg.a;
					var isThreadStarter = messageViewMsg.b;
					var maybeImageUrl = messageViewMsg.c;
					var maybeLinkUrl = messageViewMsg.d;
					var maybeReactionIndex = messageViewMsg.e;
					var touches = messageViewMsg.f;
					return $author$project$Frontend$touchStart$(
						$elm$core$Maybe$Just(
							_Utils_Tuple3(guildOrDmId, threadRoute, isThreadStarter)),
						maybeImageUrl,
						maybeLinkUrl,
						maybeReactionIndex,
						$ianmackenzie$elm_units$Duration$addTo$(model.startupData.timeOrigin, timeStamp),
						touches,
						model);
				case 6:
					var isThreadStarter = messageViewMsg.a;
					var maybeImageUrl = messageViewMsg.b;
					var maybeLinkUrl = messageViewMsg.c;
					var maybeReactionIndex = messageViewMsg.d;
					var clickedAt = messageViewMsg.e;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							return _Utils_Tuple2(
								function () {
									var _v108 = _Utils_Tuple3(
										maybeReactionIndex,
										$author$project$MyUi$isMobile(model),
										model.drag);
									if (((!_v108.a.$) && _v108.b) && (_v108.c.$ === 1)) {
										var reactionIndex = _v108.a.a;
										var _v109 = _v108.c;
										return _Utils_update(
											loggedIn,
											{
												messageHover: $author$project$Types$ReactionPopup$(guildOrDmId, threadRoute, reactionIndex)
											});
									} else {
										return $author$project$Frontend$handleAltPressedMessage$(
											guildOrDmId,
											threadRoute,
											isThreadStarter,
											maybeImageUrl,
											maybeLinkUrl,
											clickedAt,
											loggedIn,
											$author$project$Local$model(loggedIn.localState),
											model);
									}
								}(),
								$lamdera$program_test$Effect$Command$none);
						},
						model);
				case 7:
					var emoji = messageViewMsg.a;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							return $author$project$Frontend$isReleasingReactionLongPress$(guildOrDmId, threadRoute, loggedIn) ? _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none) : $author$project$FrontendExtra$handleLocalChange$(
								model.time,
								$elm$core$Maybe$Just(
									$author$project$Types$Local_RemoveReactionEmoji$(guildOrDmId, threadRoute, emoji)),
								loggedIn,
								$lamdera$program_test$Effect$Command$none);
						},
						model);
				case 8:
					var emoji = messageViewMsg.a;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							return $author$project$Frontend$isReleasingReactionLongPress$(guildOrDmId, threadRoute, loggedIn) ? _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none) : $author$project$FrontendExtra$handleLocalChange$(
								model.time,
								$elm$core$Maybe$Just(
									$author$project$Types$Local_AddReactionEmoji$(guildOrDmId, threadRoute, emoji)),
								loggedIn,
								$author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn.channelScrollPosition));
						},
						model);
				case 9:
					var _v110 = model.loginStatus;
					if (!_v110.$) {
						var loggedIn = _v110.a;
						switch (guildOrDmId.$) {
							case 0:
								var guildOrDmId2 = guildOrDmId.a;
								var _v112 = $author$project$LocalState$guildOrDmIdToMessage$(
									guildOrDmId2,
									threadRoute,
									$author$project$Local$model(loggedIn.localState));
								if (!_v112.$) {
									var _v113 = _v112.a;
									var maybeRepliedTo = _v113.b;
									var _v114 = _Utils_Tuple2(guildOrDmId2, maybeRepliedTo);
									_v114$5:
									while (true) {
										if (_v114.b.$ === 1) {
											if (!_v114.a.$) {
												if (!_v114.b.b.$) {
													var channelId = _v114.a.a.channelId;
													var guildId = _v114.a.a.guildId;
													var _v115 = _v114.b;
													var threadId = _v115.a;
													var repliedTo = _v115.b.a;
													return $author$project$FrontendExtra$routePush$(
														model,
														$author$project$Route$GuildRoute$(
															guildId,
															$author$project$Route$ChannelRoute$(
																channelId,
																$author$project$Route$ViewThreadWithFriends$(
																	threadId,
																	$elm$core$Maybe$Just(repliedTo),
																	1),
																$elm$core$Maybe$Nothing),
															0,
															$elm$core$Maybe$Nothing));
												} else {
													break _v114$5;
												}
											} else {
												if (!_v114.b.b.$) {
													var otherUserId = _v114.a.a.otherUserId;
													var _v116 = _v114.b;
													var threadId = _v116.a;
													var repliedTo = _v116.b.a;
													return $author$project$FrontendExtra$routePush$(
														model,
														$author$project$Route$DmRoute(
															{
																channelId: $author$project$DmChannelId$fromUserIds$(
																	$author$project$Local$model(loggedIn.localState).localUser.session.userId,
																	otherUserId),
																channelsVisible: 0,
																overlay: $elm$core$Maybe$Nothing,
																tab: $elm$core$Maybe$Nothing,
																threadRoute: $author$project$Route$ViewThreadWithFriends$(
																	threadId,
																	$elm$core$Maybe$Just(repliedTo),
																	1)
															}));
												} else {
													break _v114$5;
												}
											}
										} else {
											switch (_v114.b.a.$) {
												case 1:
													if (!_v114.a.$) {
														var channelId = _v114.a.a.channelId;
														var guildId = _v114.a.a.guildId;
														var repliedTo = _v114.b.a.a;
														return $author$project$FrontendExtra$routePush$(
															model,
															$author$project$Route$GuildRoute$(
																guildId,
																$author$project$Route$ChannelRoute$(
																	channelId,
																	$author$project$Route$NoThreadWithFriends$(
																		$elm$core$Maybe$Just(repliedTo),
																		1),
																	$elm$core$Maybe$Nothing),
																0,
																$elm$core$Maybe$Nothing));
													} else {
														var otherUserId = _v114.a.a.otherUserId;
														var repliedTo = _v114.b.a.a;
														return $author$project$FrontendExtra$routePush$(
															model,
															$author$project$Route$DmRoute(
																{
																	channelId: $author$project$DmChannelId$fromUserIds$(
																		$author$project$Local$model(loggedIn.localState).localUser.session.userId,
																		otherUserId),
																	channelsVisible: 0,
																	overlay: $elm$core$Maybe$Nothing,
																	tab: $elm$core$Maybe$Nothing,
																	threadRoute: $author$project$Route$NoThreadWithFriends$(
																		$elm$core$Maybe$Just(repliedTo),
																		1)
																}));
													}
												case 2:
													var _v117 = _v114.b.a;
													var matchId = _v117.a;
													var repliedToGame = _v117.b;
													return $author$project$FrontendExtra$routePush$(
														model,
														$author$project$Route$setChannelHeaderTab$(
															$elm$core$Maybe$Just(
																$author$project$UserSession$ChannelHeaderTab_Games$(
																	$elm$core$Maybe$Just(matchId),
																	$elm$core$Maybe$Just(repliedToGame))),
															model.route));
												default:
													break _v114$5;
											}
										}
									}
									return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
								} else {
									return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
								}
							case 1:
								var guildOrDmId2 = guildOrDmId.a;
								var _v118 = $author$project$LocalState$discordGuildOrDmIdToMessage$(
									guildOrDmId2,
									threadRoute,
									$author$project$Local$model(loggedIn.localState));
								if (!_v118.$) {
									var _v119 = _v118.a;
									var maybeRepliedTo = _v119.b;
									var _v120 = _Utils_Tuple2(guildOrDmId2, maybeRepliedTo);
									_v120$3:
									while (true) {
										if (!_v120.a.$) {
											if (_v120.b.$ === 1) {
												if (!_v120.b.b.$) {
													var channelId = _v120.a.a.channelId;
													var guildId = _v120.a.a.guildId;
													var currentUserId = _v120.a.a.currentUserId;
													var _v121 = _v120.b;
													var threadId = _v121.a;
													var repliedTo = _v121.b.a;
													return $author$project$FrontendExtra$routePush$(
														model,
														$author$project$Route$DiscordGuildRoute(
															{
																channelRoute: $author$project$Route$DiscordChannel_ChannelRoute$(
																	channelId,
																	$author$project$Route$ViewThreadWithFriends$(
																		threadId,
																		$elm$core$Maybe$Just(repliedTo),
																		1),
																	$elm$core$Maybe$Nothing),
																channelsVisible: 0,
																currentDiscordUserId: currentUserId,
																guildId: guildId,
																overlay: $elm$core$Maybe$Nothing
															}));
												} else {
													break _v120$3;
												}
											} else {
												if (!_v120.b.a.$) {
													var channelId = _v120.a.a.channelId;
													var guildId = _v120.a.a.guildId;
													var currentUserId = _v120.a.a.currentUserId;
													var repliedTo = _v120.b.a.a;
													return $author$project$FrontendExtra$routePush$(
														model,
														$author$project$Route$DiscordGuildRoute(
															{
																channelRoute: $author$project$Route$DiscordChannel_ChannelRoute$(
																	channelId,
																	$author$project$Route$NoThreadWithFriends$(
																		$elm$core$Maybe$Just(repliedTo),
																		1),
																	$elm$core$Maybe$Nothing),
																channelsVisible: 0,
																currentDiscordUserId: currentUserId,
																guildId: guildId,
																overlay: $elm$core$Maybe$Nothing
															}));
												} else {
													break _v120$3;
												}
											}
										} else {
											if ((!_v120.b.$) && (!_v120.b.a.$)) {
												var channelId = _v120.a.a.channelId;
												var currentUserId = _v120.a.a.currentUserId;
												var repliedTo = _v120.b.a.a;
												return $author$project$FrontendExtra$routePush$(
													model,
													$author$project$Route$DiscordDmRoute(
														{
															channelId: channelId,
															channelsVisible: 0,
															currentDiscordUserId: currentUserId,
															overlay: $elm$core$Maybe$Nothing,
															showMembersTab: 1,
															tab: $elm$core$Maybe$Nothing,
															viewingMessage: $elm$core$Maybe$Just(repliedTo)
														}));
											} else {
												break _v120$3;
											}
										}
									}
									return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
								} else {
									return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
								}
							default:
								return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
						}
					} else {
						return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
					}
				case 10:
					return $author$project$Frontend$showReactionEmojiSelector$(guildOrDmId, threadRoute, model);
				case 11:
					return $author$project$Frontend$pressedEditMessage$(guildOrDmId, threadRoute, model);
				case 12:
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							return $author$project$Frontend$pressedReply$(guildOrDmId, threadRoute, loggedIn, model);
						},
						model);
				case 13:
					var isThreadStarter = messageViewMsg.a;
					var clickedAt = messageViewMsg.b;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							var local = $author$project$Local$model(loggedIn.localState);
							return _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{
										messageHover: $author$project$Types$MessageMenu(
											{
												guildOrDmId: guildOrDmId,
												imageUrl: $elm$core$Maybe$Nothing,
												isThreadStarter: isThreadStarter,
												linkUrl: $elm$core$Maybe$Nothing,
												mobileMode: $author$project$Types$MessageMenuOpening(
													{
														offset: $ianmackenzie$elm_units$Quantity$zero,
														targetOffset: $author$project$MessageMenu$mobileMenuOpeningOffset$(guildOrDmId, threadRoute, isThreadStarter, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, local, model)
													}),
												position: clickedAt,
												threadRoute: threadRoute
											})
									}),
								$lamdera$program_test$Effect$Command$none);
						},
						model);
				case 14:
					var _v122 = _Utils_Tuple2(guildOrDmId, threadRoute);
					if (!_v122.b.$) {
						switch (_v122.a.$) {
							case 0:
								if (!_v122.a.a.$) {
									var channelId = _v122.a.a.a.channelId;
									var guildId = _v122.a.a.a.guildId;
									var messageId = _v122.b.a;
									return $author$project$FrontendExtra$routePush$(
										model,
										$author$project$Route$GuildRoute$(
											guildId,
											$author$project$Route$ChannelRoute$(
												channelId,
												$author$project$Route$ViewThreadWithFriends$(messageId, $elm$core$Maybe$Nothing, 1),
												$elm$core$Maybe$Nothing),
											0,
											$elm$core$Maybe$Nothing));
								} else {
									var otherUserId = _v122.a.a.a.otherUserId;
									var messageId = _v122.b.a;
									var _v123 = model.loginStatus;
									if (!_v123.$) {
										var loggedIn = _v123.a;
										return $author$project$FrontendExtra$routePush$(
											model,
											$author$project$Route$DmRoute(
												{
													channelId: $author$project$DmChannelId$fromUserIds$(
														$author$project$Local$model(loggedIn.localState).localUser.session.userId,
														otherUserId),
													channelsVisible: 0,
													overlay: $elm$core$Maybe$Nothing,
													tab: $elm$core$Maybe$Nothing,
													threadRoute: $author$project$Route$ViewThreadWithFriends$(messageId, $elm$core$Maybe$Nothing, 1)
												}));
									} else {
										return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
									}
								}
							case 1:
								if (!_v122.a.a.$) {
									var channelId = _v122.a.a.a.channelId;
									var guildId = _v122.a.a.a.guildId;
									var currentUserId = _v122.a.a.a.currentUserId;
									var messageId = _v122.b.a;
									return $author$project$FrontendExtra$routePush$(
										model,
										$author$project$Route$DiscordGuildRoute(
											{
												channelRoute: $author$project$Route$DiscordChannel_ChannelRoute$(
													channelId,
													$author$project$Route$ViewThreadWithFriends$(messageId, $elm$core$Maybe$Nothing, 1),
													$elm$core$Maybe$Nothing),
												channelsVisible: 0,
												currentDiscordUserId: currentUserId,
												guildId: guildId,
												overlay: $elm$core$Maybe$Nothing
											}));
								} else {
									var channelId = _v122.a.a.a.channelId;
									var currentUserId = _v122.a.a.a.currentUserId;
									return $author$project$FrontendExtra$routePush$(
										model,
										$author$project$Route$DiscordDmRoute(
											{channelId: channelId, channelsVisible: 0, currentDiscordUserId: currentUserId, overlay: $elm$core$Maybe$Nothing, showMembersTab: 1, tab: $elm$core$Maybe$Nothing, viewingMessage: $elm$core$Maybe$Nothing}));
								}
							default:
								if (!_v122.a.a.$) {
									var channelId = _v122.a.a.a.channelId;
									var teamId = _v122.a.a.a.teamId;
									var currentUserId = _v122.a.a.a.currentUserId;
									var messageId = _v122.b.a;
									return $author$project$FrontendExtra$routePush$(
										model,
										$author$project$Route$SlackWorkspaceRoute(
											{
												channelRoute: $author$project$Route$SlackChannel_ChannelRoute$(
													channelId,
													$author$project$Id$ViewThreadWithMaybeMessage$(messageId, $elm$core$Maybe$Nothing),
													1),
												channelsVisible: 0,
												currentSlackUserId: currentUserId,
												overlay: $elm$core$Maybe$Nothing,
												teamId: teamId
											}));
								} else {
									var channelId = _v122.a.a.a.channelId;
									var currentUserId = _v122.a.a.a.currentUserId;
									var messageId = _v122.b.a;
									return $author$project$FrontendExtra$routePush$(
										model,
										$author$project$Route$SlackDmRoute(
											{
												channelId: channelId,
												channelsVisible: 0,
												currentSlackUserId: currentUserId,
												overlay: $elm$core$Maybe$Nothing,
												threadRoute: $author$project$Id$ViewThreadWithMaybeMessage$(messageId, $elm$core$Maybe$Nothing)
											}));
								}
						}
					} else {
						return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
					}
				case 1:
					var url = messageViewMsg.a;
					return $author$project$Frontend$handlePressedNonWhitelistLink$(url, model);
				case 2:
					var displayWidth = messageViewMsg.a.displayWidth;
					var position = messageViewMsg.a.position;
					var imageSize = messageViewMsg.a.imageSize;
					var fileUrl = messageViewMsg.a.fileUrl;
					var imageId = messageViewMsg.a.imageId;
					var _v124 = $author$project$Route$toChannelHeaderTab(model.route);
					if ((!_v124.$) && (_v124.a.$ === 3)) {
						var _v125 = _v124.a;
						var displayHeight = ($author$project$Coord$xRaw(imageSize) > 0) ? ((displayWidth * $author$project$Coord$yRaw(imageSize)) / $author$project$Coord$xRaw(imageSize)) : displayWidth;
						return $author$project$Frontend$selectDrawingAnchor$(
							guildOrDmId,
							$author$project$Drawing$MessageAnchor$(
								threadRoute,
								function () {
									if (!imageId.$) {
										var fileId = imageId.a;
										return $author$project$Drawing$ImageAttachmentAnchor(fileId);
									} else {
										var embedIndex = imageId.a;
										return $author$project$Drawing$EmbedImageAnchor(embedIndex);
									}
								}()),
							position,
							_Utils_Tuple2(displayWidth / 2, displayHeight / 2),
							(displayWidth > 0) ? ($author$project$Coord$xRaw(imageSize) / displayWidth) : 1,
							model);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									imageViewer: $elm$core$Maybe$Just(
										$author$project$ImageViewer$init(
											{imageSize: imageSize, url: fileUrl}))
								}),
							$lamdera$program_test$Effect$Command$none);
					}
				case 15:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 16:
					var emoji = messageViewMsg.a;
					return $author$project$FrontendExtra$updateLoggedIn$(
						A4($author$project$Frontend$toggleReactionEmoji, emoji, guildOrDmId, threadRoute, model),
						model);
				case 17:
					var _v127 = model.route;
					switch (_v127.$) {
						case 5:
							var dmRoute = _v127.a;
							return $author$project$FrontendExtra$routePush$(
								model,
								$author$project$Route$DmRoute(
									_Utils_update(
										dmRoute,
										{
											tab: $elm$core$Maybe$Just($author$project$UserSession$ChannelHeaderTab_VoiceChat)
										})));
						case 0:
							return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
						case 1:
							return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
						case 2:
							return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
						case 3:
							var guildId = _v127.a;
							var channelRoute = _v127.b;
							var channelsVisible = _v127.c;
							var overlay = _v127.d;
							switch (channelRoute.$) {
								case 0:
									if (!channelRoute.b.$) {
										var channelId = channelRoute.a;
										var _v129 = channelRoute.b;
										var a = _v129.a;
										var b = _v129.b;
										return $author$project$FrontendExtra$routePush$(
											model,
											$author$project$Route$GuildRoute$(
												guildId,
												$author$project$Route$ChannelRoute$(
													channelId,
													$author$project$Route$NoThreadWithFriends$(a, b),
													$elm$core$Maybe$Just($author$project$UserSession$ChannelHeaderTab_VoiceChat)),
												channelsVisible,
												overlay));
									} else {
										var _v130 = channelRoute.b;
										return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
									}
								case 1:
									return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
								case 2:
									return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
								default:
									return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
							}
						case 4:
							return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
						case 6:
							return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
						case 9:
							return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
						case 10:
							return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
						case 11:
							return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
						case 12:
							return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
						case 13:
							return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
						case 7:
							return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
						default:
							return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
					}
				case 18:
					if (!threadRoute.$) {
						var messageId = threadRoute.a;
						var newRoute = $author$project$Route$setChannelHeaderTab$(
							$elm$core$Maybe$Just(
								$author$project$UserSession$ChannelHeaderTab_Games$(
									$elm$core$Maybe$Just(messageId),
									$elm$core$Maybe$Nothing)),
							model.route);
						return _Utils_eq(newRoute, model.route) ? _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none) : $author$project$FrontendExtra$routePush$(model, newRoute);
					} else {
						return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
					}
				case 19:
					var elementPosition = messageViewMsg.a;
					var anchorHalfSize = messageViewMsg.b;
					var _v132 = $author$project$Route$toChannelHeaderTab(model.route);
					if ((!_v132.$) && (_v132.a.$ === 3)) {
						var _v133 = _v132.a;
						return $author$project$Frontend$selectDrawingAnchor$(
							guildOrDmId,
							$author$project$Drawing$MessageAnchor$(threadRoute, $author$project$Drawing$UserIconAnchor),
							elementPosition,
							anchorHalfSize,
							1,
							model);
					} else {
						return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
					}
				case 20:
					var elementPosition = messageViewMsg.a;
					var anchorHalfSize = messageViewMsg.b;
					var _v134 = $author$project$Route$toChannelHeaderTab(model.route);
					if ((!_v134.$) && (_v134.a.$ === 3)) {
						var _v135 = _v134.a;
						return $author$project$Frontend$selectDrawingAnchor$(
							guildOrDmId,
							$author$project$Drawing$MessageAnchor$(threadRoute, $author$project$Drawing$TimestampAnchor),
							elementPosition,
							anchorHalfSize,
							1,
							model);
					} else {
						return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
					}
				case 21:
					var date = messageViewMsg.a;
					var elementPosition = messageViewMsg.b;
					var anchorHalfSize = messageViewMsg.c;
					var _v136 = $author$project$Route$toChannelHeaderTab(model.route);
					if ((!_v136.$) && (_v136.a.$ === 3)) {
						var _v137 = _v136.a;
						return $author$project$Frontend$selectDrawingAnchor$(
							guildOrDmId,
							$author$project$Drawing$DateDividerAnchor$(
								$author$project$Id$threadRouteWithoutMessage(threadRoute),
								date),
							elementPosition,
							anchorHalfSize,
							1,
							model);
					} else {
						return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
					}
				case 22:
					var elementPosition = messageViewMsg.a;
					var anchorHalfSize = messageViewMsg.b;
					var _v138 = $author$project$Route$toChannelHeaderTab(model.route);
					if ((!_v138.$) && (_v138.a.$ === 3)) {
						var _v139 = _v138.a;
						return $author$project$Frontend$selectDrawingAnchor$(
							guildOrDmId,
							$author$project$Drawing$MessageAnchor$(threadRoute, $author$project$Drawing$CardAnchor),
							elementPosition,
							anchorHalfSize,
							1,
							model);
					} else {
						return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
					}
				case 23:
					var otherUserId = messageViewMsg.a;
					return $author$project$Frontend$handlePressedUserIconButton$(otherUserId, model);
				case 24:
					var otherUserId = messageViewMsg.a;
					return $author$project$Frontend$handlePressedDiscordUserIconButton$(otherUserId, model);
				case 25:
					var channelId = messageViewMsg.a;
					var threadRoute2 = messageViewMsg.b;
					return $author$project$Frontend$handlePressedChannelMention$(guildOrDmId, channelId, threadRoute2, model);
				case 26:
					var channelId = messageViewMsg.a;
					var threadRoute2 = messageViewMsg.b;
					return $author$project$Frontend$handlePressedDiscordChannelMention$(guildOrDmId, channelId, threadRoute2, model);
				default:
					var text = messageViewMsg.a;
					return $author$project$Frontend$copyText$(text, model);
			}
		case 98:
			var result = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_RegisterPushSubscription$(model.time, result)),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 99:
			var notificationMode = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_SetNotificationMode(notificationMode)),
						loggedIn,
						function () {
							switch (notificationMode) {
								case 0:
									return $lamdera$program_test$Effect$Command$none;
								case 1:
									return $author$project$Ports$requestNotificationPermission;
								default:
									return $author$project$Ports$registerPushSubscriptionToJs(
										$author$project$Local$model(loggedIn.localState).publicVapidKey);
							}
						}());
				},
				model);
		case 100:
			var emailNotifications = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_SetEmailNotifications(emailNotifications)),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 101:
			var embedVisibility = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_SetEmbedVisibility(embedVisibility)),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 102:
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					var _v141 = $author$project$Local$model(loggedIn.localState).localUser.user.deleteAccountAt;
					if (!_v141.$) {
						return $author$project$FrontendExtra$handleLocalChange$(
							model.time,
							$elm$core$Maybe$Just($author$project$Types$Local_CancelAccountDeletion),
							loggedIn,
							$lamdera$program_test$Effect$Command$none);
					} else {
						return $author$project$FrontendExtra$handleLocalChange$(
							model.time,
							$elm$core$Maybe$Just(
								$author$project$Types$Local_ScheduleAccountDeletion(
									$ianmackenzie$elm_units$Duration$addTo$(
										model.time,
										$ianmackenzie$elm_units$Duration$weeks($author$project$User$accountDeletionDelayInWeeks)))),
							_Utils_update(
								loggedIn,
								{accountDeletionBannerClosed: false}),
							$lamdera$program_test$Effect$Command$none);
					}
				},
				model);
		case 103:
			return $author$project$FrontendExtra$openUserOptionsAndExpandContainer$(1, model);
		case 104:
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{accountDeletionBannerClosed: true}),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 82:
			var imageEditorMsg = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					var _v142 = $author$project$ImageEditor$update$($author$project$ImageEditor$ChangeUserAvatarRequest, model.windowSize, imageEditorMsg, loggedIn.profilePictureEditor);
					var newImageEditor = _v142.a;
					var cmd = _v142.b;
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{profilePictureEditor: newImageEditor}),
						$lamdera$program_test$Effect$Command$map$($author$project$Types$ProfilePictureEditorToBackend, $author$project$Types$ProfilePictureEditorMsg, cmd));
				},
				model);
		case 83:
			var guildId = msg.a;
			var imageEditorMsg = msg.b;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					var currentEditor = function () {
						var _v144 = loggedIn.guildIconEditor;
						if (!_v144.$) {
							var _v145 = _v144.a;
							var existingGuildId = _v145.a;
							var editor = _v145.b;
							return _Utils_eq(existingGuildId, guildId) ? editor : $author$project$ImageEditor$init;
						} else {
							return $author$project$ImageEditor$init;
						}
					}();
					var _v143 = $author$project$ImageEditor$update$(
						$author$project$ImageEditor$ChangeGuildIconRequest(guildId),
						model.windowSize,
						imageEditorMsg,
						currentEditor);
					var newImageEditor = _v143.a;
					var cmd = _v143.b;
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{
								guildIconEditor: $elm$core$Maybe$Just(
									_Utils_Tuple2(guildId, newImageEditor))
							}),
						$lamdera$program_test$Effect$Command$map$(
							$author$project$Types$ProfilePictureEditorToBackend,
							$author$project$Types$GuildIconEditorMsg(guildId),
							cmd));
				},
				model);
		case 105:
			var guildId = msg.a;
			var notificationLevel = msg.b;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_SetGuildNotificationLevel$(guildId, notificationLevel)),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 106:
			var userId = msg.a;
			var guildId = msg.b;
			var notificationLevel = msg.c;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_SetDiscordGuildNotificationLevel$(userId, guildId, notificationLevel)),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 107:
			var slackUserId = msg.a;
			var teamId = msg.b;
			var notificationLevel = msg.c;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_SetSlackWorkspaceNotificationLevel$(slackUserId, teamId, notificationLevel)),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 108:
			var startupData = msg.a;
			if (!startupData.$) {
				var startupData2 = startupData.a;
				return _Utils_Tuple2(
					$author$project$Frontend$setSafeAreaInsets$(
						{bottom: startupData2.safeAreaInsetBottom, top: startupData2.safeAreaInsetTop},
						$author$project$Frontend$setDevicePixelRatio$(
							startupData2.devicePixelRatio,
							_Utils_update(
								model,
								{startupData: startupData2}))),
					$lamdera$program_test$Effect$Command$none);
			} else {
				var error = startupData.a;
				var _v147 = A2($elm$core$Debug$log, 'GotStartupData failed! (after loading)', error);
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 109:
			var devicePixelRatio = msg.a;
			return _Utils_Tuple2(
				$author$project$Frontend$setDevicePixelRatio$(devicePixelRatio, model),
				$lamdera$program_test$Effect$Command$none);
		case 88:
			var guildOrDmId = msg.a;
			var fileId = msg.b;
			return $author$project$Frontend$viewImageInfo$(guildOrDmId, fileId, model);
		case 91:
			var guildOrDmId = msg.a;
			var fileId = msg.b;
			return $author$project$Frontend$viewImageInfo$(guildOrDmId, fileId, model);
		case 110:
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{showFileToUploadInfo: $elm$core$Maybe$Nothing}),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 111:
			return $author$project$Frontend$startClosingChannelSidebar(model);
		case 112:
			var exportChannelId = msg.a;
			return _Utils_Tuple2(
				model,
				$lamdera$program_test$Effect$Lamdera$sendToBackend(
					$author$project$Types$ExportChannelRequest(exportChannelId)));
		case 24:
			var guildId = msg.a;
			return _Utils_Tuple2(
				model,
				$lamdera$program_test$Effect$File$Select$file$(
					_List_fromArray(
						['application/json']),
					$author$project$Types$SelectedImportChannelFile(guildId)));
		case 25:
			var guildId = msg.a;
			var file = msg.b;
			return _Utils_Tuple2(
				model,
				$lamdera$program_test$Effect$Task$perform$(
					function (json) {
						return $author$project$Types$GotImportChannelFile$(
							guildId,
							{
								fileName: $lamdera$program_test$Effect$File$name(file),
								json: json
							});
					},
					$lamdera$program_test$Effect$File$toString(file)));
		case 26:
			var guildId = msg.a;
			var file = msg.b;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						$author$project$Pages$Guild$setImportChannelStatus$(
							guildId,
							$author$project$Types$ImportingChannel,
							$author$project$Local$model(loggedIn.localState),
							loggedIn),
						$lamdera$program_test$Effect$Lamdera$sendToBackend(
							$author$project$Types$ImportChannelRequest$(guildId, file)));
				},
				model);
		case 113:
			var _v148 = $author$project$X25519$privateKeyFromListInt(
				$elm$core$List$indexedMap$(
					F2(
						function (index, value) {
							return ((index + 1) * $lamdera$program_test$Effect$Time$posixToMillis(model.time)) + value;
						}),
					model.startupData.randomSeed));
			if (!_v148.$) {
				var privateKey = _v148.a;
				var startupData = model.startupData;
				return $author$project$FrontendExtra$updateLoggedIn$(
					function (loggedIn) {
						return $author$project$FrontendExtra$handleLocalChange$(
							model.time,
							$elm$core$Maybe$Just(
								$author$project$Types$Local_SetPublicKey$(
									$author$project$X25519$toPublicKey(privateKey),
									$author$project$UserSession$EmptyPlaceholder)),
							_Utils_update(
								loggedIn,
								{
									showNewPrivateKey: $elm$core$Maybe$Just(privateKey)
								}),
							$lamdera$program_test$Effect$Command$none);
					},
					_Utils_update(
						model,
						{
							startupData: _Utils_update(
								startupData,
								{
									randomSeed: $elm$core$List$drop$(8, startupData.randomSeed)
								})
						}));
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 114:
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{showNewPrivateKey: $elm$core$Maybe$Nothing}),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 115:
			var otherUserId = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					var isExpanded = $author$project$Pages$Guild$e2eeSectionIsExpanded$(
						otherUserId,
						$author$project$Local$model(loggedIn.localState),
						loggedIn);
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{
								e2eeSectionsExpanded: $lamdera$containers$SeqDict$insert$(otherUserId, !isExpanded, loggedIn.e2eeSectionsExpanded)
							}),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 116:
			var isChecked = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_SetE2eeRisksAccepted(isChecked)),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 117:
			var otherUserId = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_RequestE2ee(
								{otherUserId: otherUserId})),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 118:
			var otherUserId = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_DeclineE2eeRequestAsInitiator(
								{otherUserId: otherUserId})),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 119:
			var otherUserId = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_DisableE2ee$(
								{otherUserId: otherUserId},
								$author$project$UserSession$EmptyPlaceholder)),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 120:
			var otherUserId = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_DeclineE2eeRequest(
								{otherUserId: otherUserId})),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 121:
			var otherUserId = msg.a;
			var text = msg.b;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					var trimmed = $elm$core$String$trim(text);
					if (A2($elm$core$String$endsWith, '=', trimmed)) {
						var result = function () {
							var _v151 = $author$project$User$privateKeyForAccount$(
								trimmed,
								$author$project$Local$model(loggedIn.localState).localUser.user);
							if (!_v151.$) {
								var privateKey = _v151.a;
								var _v152 = $author$project$Frontend$storeSharedSecret$(otherUserId, privateKey, loggedIn);
								if (!_v152.$) {
									var command = _v152.a;
									return $elm$core$Result$Ok(
										_Utils_Tuple2(
											$author$project$X25519$toPublicKey(privateKey),
											$lamdera$program_test$Effect$Command$batch(
												A2(
													$elm$core$List$cons,
													command,
													$author$project$Frontend$storeRemainingSharedSecrets$(otherUserId, privateKey, loggedIn)))));
								} else {
									var error = _v152.a;
									return $elm$core$Result$Err(error);
								}
							} else {
								var error = _v151.a;
								return $elm$core$Result$Err(error);
							}
						}();
						if (!result.$) {
							var _v150 = result.a;
							var publicKey = _v150.a;
							var command = _v150.b;
							var toEncrypt = $author$project$Frontend$conversationsToEncrypt$(
								loggedIn.encryptionRequests.nextEncryptManyRequestId,
								$author$project$Frontend$locallyLoadedMessagesToEncrypt(
									$author$project$Local$model(loggedIn.localState)));
							return $author$project$FrontendExtra$handleLocalChange$(
								model.time,
								$elm$core$Maybe$Just(
									$author$project$Types$Local_SetPublicKey$(publicKey, $author$project$UserSession$EmptyPlaceholder)),
								$author$project$FrontendExtra$mapEncryptionRequests$(
									$author$project$Frontend$rememberEncryptManyRequests(toEncrypt),
									_Utils_update(
										loggedIn,
										{e2eeError: $elm$core$Maybe$Nothing, e2eePrivateKeyText: ''})),
								$lamdera$program_test$Effect$Command$batch(
									A2(
										$elm$core$List$cons,
										command,
										$elm$core$List$map$($author$project$Frontend$encryptConversation, toEncrypt))));
						} else {
							var error = result.a;
							return _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{
										e2eeError: $elm$core$Maybe$Just(error),
										e2eePrivateKeyText: text
									}),
								$lamdera$program_test$Effect$Command$none);
						}
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								loggedIn,
								{e2eeError: $elm$core$Maybe$Nothing, e2eePrivateKeyText: text}),
							$lamdera$program_test$Effect$Command$none);
					}
				},
				model);
		case 186:
			var result = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					if (!result.$) {
						switch (result.a.$) {
							case 0:
								var otherUserId = result.a.a;
								var loggedIn2 = _Utils_update(
									loggedIn,
									{
										e2eeKeysOnThisDevice: $lamdera$containers$SeqSet$insert$(otherUserId, loggedIn.e2eeKeysOnThisDevice)
									});
								var local = $author$project$Local$model(loggedIn2.localState);
								var stillEncrypted = function () {
									var _v159 = $lamdera$containers$SeqDict$get$(otherUserId, local.dmChannels);
									if (!_v159.$) {
										var dmChannel = _v159.a;
										return $author$project$FrontendExtra$encryptedMessagesIn(dmChannel);
									} else {
										return _List_Nil;
									}
								}();
								var acceptE2ee = function () {
									var _v156 = $lamdera$containers$SeqDict$get$(otherUserId, local.dmChannels);
									if (!_v156.$) {
										var dmChannel = _v156.a;
										var _v157 = dmChannel.e2ee;
										switch (_v157.$) {
											case 1:
												var _v158 = _v157.a;
												var requestedBy = _v158.a;
												return (!_Utils_eq(requestedBy, local.localUser.session.userId)) || _Utils_eq(otherUserId, local.localUser.session.userId);
											case 2:
												return false;
											case 0:
												return false;
											default:
												return false;
										}
									} else {
										return false;
									}
								}();
								var _v154 = function () {
									if (!stillEncrypted.b) {
										return _Utils_Tuple2(loggedIn2, $lamdera$program_test$Effect$Command$none);
									} else {
										return _Utils_Tuple2(
											$author$project$FrontendExtra$mapEncryptionRequests$(
												$author$project$Frontend$rememberDecryptManyRequest(
													{
														messageHashes: $elm$core$List$map$($author$project$Encryption$hash, stillEncrypted),
														shiftScrollFrom: $elm$core$Maybe$Nothing
													}),
												loggedIn2),
											$author$project$Encryption$decryptManyMessages$(
												loggedIn2.encryptionRequests.nextDecryptManyRequestId,
												{otherUserId: otherUserId},
												stillEncrypted));
									}
								}();
								var loggedIn3 = _v154.a;
								var decryptCmd = _v154.b;
								return acceptE2ee ? $author$project$FrontendExtra$handleLocalChange$(
									model.time,
									$elm$core$Maybe$Just(
										$author$project$Types$Local_AcceptE2ee$(
											{otherUserId: otherUserId},
											model.time,
											$author$project$UserSession$EmptyPlaceholder)),
									loggedIn3,
									decryptCmd) : _Utils_Tuple2(loggedIn3, decryptCmd);
							case 1:
								var _v160 = result.a;
								var error = _v160.b;
								return _Utils_Tuple2(
									_Utils_update(
										loggedIn,
										{
											e2eeError: $elm$core$Maybe$Just(error)
										}),
									$lamdera$program_test$Effect$Command$none);
							case 2:
								var _v161 = result.a;
								var requestId = _v161.a;
								var cipherText = _v161.b;
								var _v162 = $lamdera$containers$SeqDict$get$(requestId, loggedIn.encryptionRequests.pendingEncryptedEdits);
								if (!_v162.$) {
									var pending = _v162.a;
									return $author$project$FrontendExtra$handleLocalChange$(
										model.time,
										$elm$core$Maybe$Just(
											$author$project$Types$Local_SendEncryptedEditMessage$(
												model.time,
												pending.id,
												pending.threadRoute,
												$lamdera$containers$SeqSet$fromList(
													$elm$core$List$map$(
														function ($) {
															return $.fileHash;
														},
														$lamdera$containers$SeqDict$values(pending.contentAndEmbeds.attachedFiles))),
												cipherText)),
										$author$project$FrontendExtra$fileDecryptedMessages$(
											_List_fromArray(
												[
													_Utils_Tuple2(
													$author$project$Encryption$hash(cipherText),
													$elm$core$Result$Ok(pending.contentAndEmbeds))
												]),
											$author$project$FrontendExtra$mapEncryptionRequests$(
												$author$project$Frontend$forgetEncryptRequest(requestId),
												loggedIn)),
										$author$project$FrontendExtra$storeDecryptedFileKeys(
											_List_fromArray(
												[
													$elm$core$Result$Ok(pending.contentAndEmbeds)
												])));
								} else {
									return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
								}
							case 3:
								var _v163 = result.a;
								var requestId = _v163.a;
								var error = _v163.b;
								return _Utils_Tuple2(
									$author$project$FrontendExtra$mapEncryptionRequests$(
										$author$project$Frontend$forgetEncryptRequest(requestId),
										_Utils_update(
											loggedIn,
											{
												e2eeError: $elm$core$Maybe$Just(error)
											})),
									$lamdera$program_test$Effect$Command$none);
							case 4:
								var _v164 = result.a;
								var requestId = _v164.a;
								var contentAndEmbeds = _v164.b;
								return $author$project$FrontendExtra$handleDecryptedMessage$(
									requestId,
									$elm$core$Result$Ok(contentAndEmbeds),
									model,
									loggedIn);
							case 5:
								var requestId = result.a.a;
								return $author$project$FrontendExtra$handleDecryptedMessage$(
									requestId,
									$elm$core$Result$Err(0),
									model,
									loggedIn);
							case 6:
								var _v165 = result.a;
								var requestId = _v165.a;
								var results = _v165.b;
								var _v166 = $lamdera$containers$SeqDict$get$(requestId, loggedIn.encryptionRequests.pendingDecryptedOldMessages);
								if (!_v166.$) {
									var pending = _v166.a;
									var decrypted = $elm$core$List$filterMap$(
										function (_v168) {
											var threadRoute = _v168.a;
											var decryptResult = _v168.b;
											if (!decryptResult.$) {
												var content = decryptResult.a;
												return $elm$core$Maybe$Just(
													_Utils_Tuple2(threadRoute, content));
											} else {
												return $elm$core$Maybe$Nothing;
											}
										},
										A3($elm$core$List$map2, $elm$core$Tuple$pair, pending.messages, results));
									return $author$project$FrontendExtra$handleLocalChange$(
										model.time,
										$elm$core$Maybe$Just(
											$author$project$Types$Local_DecryptOldMessages$(pending.id, model.time, decrypted)),
										$author$project$FrontendExtra$mapEncryptionRequests$(
											$author$project$Frontend$forgetDecryptOldMessagesRequest(requestId),
											loggedIn),
										$author$project$FrontendExtra$storeDecryptedFileKeys(
											$elm$core$List$map$(
												function (_v167) {
													var content = _v167.b;
													return $elm$core$Result$Ok(content);
												},
												decrypted)));
								} else {
									return $author$project$Frontend$handleManyMessagesDecrypted$(requestId, results, loggedIn);
								}
							case 7:
								var _v170 = result.a;
								var requestId = _v170.a;
								var encrypted = _v170.b;
								var _v171 = _Utils_Tuple2(
									$lamdera$containers$SeqDict$get$(requestId, loggedIn.encryptionRequests.pendingEncryptedMessages),
									encrypted);
								if ((((!_v171.a.$) && _v171.b.b) && _v171.b.b.b) && (!_v171.b.b.b.b)) {
									var pending = _v171.a.a;
									var _v172 = _v171.b;
									var cipherText = _v172.a;
									var _v173 = _v172.b;
									var notification = _v173.a;
									var draft = _Utils_Tuple2(
										$author$project$Id$GuildOrDmId(
											$author$project$Id$GuildOrDmId_Dm(
												{otherUserId: pending.otherUserId})),
										$author$project$Message$threadRouteWithoutRepliedTo(pending.threadRoute));
									return $author$project$FrontendExtra$handleLocalChange$(
										model.time,
										$elm$core$Maybe$Just(
											$author$project$Types$Local_SendEncryptedMessage$(
												model.time,
												{otherUserId: pending.otherUserId},
												$lamdera$containers$SeqSet$fromList(
													$elm$core$List$map$(
														function ($) {
															return $.fileHash;
														},
														$lamdera$containers$SeqDict$values(pending.contentAndEmbeds.attachedFiles))),
												cipherText,
												$author$project$Encryption$notificationText(notification),
												pending.threadRoute)),
										$author$project$FrontendExtra$fileDecryptedMessages$(
											_List_fromArray(
												[
													_Utils_Tuple2(
													$author$project$Encryption$hash(cipherText),
													$elm$core$Result$Ok(pending.contentAndEmbeds))
												]),
											$author$project$FrontendExtra$mapEncryptionRequests$(
												$author$project$Frontend$forgetEncryptManyRequest(requestId),
												_Utils_update(
													loggedIn,
													{
														drafts: $lamdera$containers$SeqDict$remove$(draft, loggedIn.drafts),
														filesToUpload: $lamdera$containers$SeqDict$remove$(draft, loggedIn.filesToUpload),
														replyTo: $lamdera$containers$SeqDict$remove$(draft, loggedIn.replyTo)
													}))),
										$lamdera$program_test$Effect$Command$batch(
											_List_fromArray(
												[
													$author$project$Scroll$toBottomOfChannel$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom),
													$author$project$FrontendExtra$storeDecryptedFileKeys(
													_List_fromArray(
														[
															$elm$core$Result$Ok(pending.contentAndEmbeds)
														]))
												])));
								} else {
									return $author$project$Frontend$manyMessagesEncrypted$(requestId, encrypted, model, loggedIn);
								}
							case 8:
								var _v174 = result.a;
								var requestId = _v174.a;
								var error = _v174.b;
								return _Utils_Tuple2(
									$author$project$FrontendExtra$mapEncryptionRequests$(
										$author$project$Frontend$forgetEncryptManyRequest(requestId),
										_Utils_update(
											loggedIn,
											{
												e2eeError: $elm$core$Maybe$Just(error)
											})),
									$lamdera$program_test$Effect$Command$none);
							case 9:
								var _v175 = result.a;
								var requestId = _v175.a;
								var encrypted = _v175.b;
								var _v176 = $elm$core$Maybe$andThen$(
									$author$project$Frontend$stillAttached(loggedIn),
									$lamdera$containers$SeqDict$get$(requestId, loggedIn.encryptionRequests.pendingEncryptedFiles));
								if (!_v176.$) {
									var fileId = _v176.a.fileId;
									var guildOrDmId = _v176.a.guildOrDmId;
									return _Utils_Tuple2(
										$author$project$FrontendExtra$mapEncryptionRequests$(
											$author$project$Frontend$forgetEncryptFileRequest(requestId),
											_Utils_update(
												loggedIn,
												{
													filesToUpload: $lamdera$containers$SeqDict$updateIfExists$(
														guildOrDmId,
														A2(
															$author$project$NonemptyDict$updateIfExists,
															fileId,
															$author$project$Frontend$fileEncrypted(encrypted)),
														loggedIn.filesToUpload)
												})),
										$author$project$FileStatus$uploadEncryptedFile$(
											A3(
												$author$project$Types$GotFileHashName,
												guildOrDmId,
												fileId,
												$elm$core$Maybe$map$($author$project$FileStatus$measuredFileMetadata, encrypted.measured)),
											guildOrDmId,
											fileId,
											{cipherText: encrypted.data, thumbnail: encrypted.thumbnail}));
								} else {
									return _Utils_Tuple2(
										$author$project$FrontendExtra$mapEncryptionRequests$(
											$author$project$Frontend$forgetEncryptFileRequest(requestId),
											loggedIn),
										$lamdera$program_test$Effect$Command$none);
								}
							default:
								var _v177 = result.a;
								var requestId = _v177.a;
								var error = _v177.b;
								return _Utils_Tuple2(
									$author$project$FrontendExtra$mapEncryptionRequests$(
										$author$project$Frontend$forgetEncryptFileRequest(requestId),
										_Utils_update(
											loggedIn,
											{
												e2eeError: $elm$core$Maybe$Just(error),
												filesToUpload: function () {
													var _v178 = $lamdera$containers$SeqDict$get$(requestId, loggedIn.encryptionRequests.pendingEncryptedFiles);
													if (!_v178.$) {
														var fileId = _v178.a.fileId;
														var guildOrDmId = _v178.a.guildOrDmId;
														return $lamdera$containers$SeqDict$updateIfExists$(
															guildOrDmId,
															A2(
																$author$project$NonemptyDict$updateIfExists,
																fileId,
																A2(
																	$author$project$FileStatus$addFileHash,
																	$elm$core$Maybe$Nothing,
																	$elm$core$Result$Err(
																		$lamdera$program_test$Effect$Http$BadBody(error)))),
															loggedIn.filesToUpload);
													} else {
														return loggedIn.filesToUpload;
													}
												}()
											})),
									$lamdera$program_test$Effect$Command$none);
						}
					} else {
						var error = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								loggedIn,
								{
									e2eeError: $elm$core$Maybe$Just(error)
								}),
							$lamdera$program_test$Effect$Command$none);
					}
				},
				model);
		case 122:
			var hasFocus = msg.a;
			var _v179 = $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						hasFocus ? $elm$core$Maybe$Just(
							$author$project$Types$Local_CurrentlyViewing$(
								{markMessagesAsViewed: true},
								$author$project$LocalState$routeToViewing$(
									$author$project$MyUi$isMobile(model),
									model.route,
									$author$project$Local$model(loggedIn.localState)))) : $elm$core$Maybe$Just(
							$author$project$Types$Local_CurrentlyViewing$(
								{markMessagesAsViewed: false},
								$author$project$SetViewing$StopViewingChannel)),
						_Utils_update(
							loggedIn,
							{messageHover: $author$project$Types$NoMessageHover}),
						$lamdera$program_test$Effect$Command$none);
				},
				_Utils_update(
					model,
					{pageHasFocus: hasFocus}));
			var model2 = _v179.a;
			var cmd = _v179.b;
			return _Utils_Tuple2(
				model2,
				$lamdera$program_test$Effect$Command$batch(
					_List_fromArray(
						[
							cmd,
							hasFocus ? $lamdera$program_test$Effect$Command$batch(
							_List_fromArray(
								[
									$lamdera$program_test$Effect$Task$perform$(
									function (_v180) {
										return $author$project$Types$PageFocusSettled;
									},
									$lamdera$program_test$Effect$Process$sleep(
										$ianmackenzie$elm_units$Duration$milliseconds(100))),
									$author$project$Ports$setFavicon('/favicon.ico'),
									$author$project$Ports$closeNotifications,
									$author$project$Ports$registerServiceWorker,
									$author$project$Frontend$checkAppVersion,
									$author$project$Ports$loadStartupData
								])) : $lamdera$program_test$Effect$Command$none
						])));
		case 123:
			return _Utils_Tuple2(
				model,
				function () {
					var _v181 = model.loginStatus;
					if (!_v181.$) {
						var loggedIn = _v181.a;
						return _Utils_eq(loggedIn.textInputFocus, $elm$core$Maybe$Nothing) ? $author$project$FrontendExtra$setFocus$(model, $author$project$Pages$Guild$channelTextInputId) : $lamdera$program_test$Effect$Command$none;
					} else {
						return $lamdera$program_test$Effect$Command$none;
					}
				}());
		case 124:
			var url = msg.a;
			var _v182 = $elm$url$Url$fromString(url);
			if (!_v182.$) {
				var url2 = _v182.a;
				return $author$project$FrontendExtra$routePush$(
					model,
					$author$project$Route$decode(url2));
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 125:
			var url = msg.a;
			var _v183 = $elm$url$Url$fromString(url);
			if (!_v183.$) {
				var url2 = _v183.a;
				return $author$project$FrontendExtra$routePush$(
					model,
					$author$project$Route$decode(url2));
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 126:
			var visualViewport = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						visualViewportHeight: $elm$core$Basics$round(visualViewport.height),
						visualViewportTop: $elm$core$Basics$round(visualViewport.top)
					}),
				_Utils_eq(
					$elm$core$Basics$round(visualViewport.height),
					model.visualViewportHeight) ? $lamdera$program_test$Effect$Command$none : $author$project$Frontend$stayAtBottomOfConversation(model));
		case 127:
			var insets = msg.a;
			return _Utils_Tuple2(
				$author$project$Frontend$setSafeAreaInsets$(insets, model),
				$lamdera$program_test$Effect$Command$none);
		case 128:
			var textEditorMsg = msg.a;
			var _v184 = model.loginStatus;
			if (!_v184.$) {
				var loggedIn = _v184.a;
				var local = $author$project$Local$model(loggedIn.localState);
				var _v185 = $author$project$TextEditor$update$(local.localUser.session.userId, textEditorMsg, loggedIn.textEditor, local.textEditor);
				var textEditor = _v185.a;
				var outMsg = _v185.b;
				switch (outMsg.$) {
					case 0:
						var localChange = outMsg.a;
						var _v187 = $author$project$FrontendExtra$handleLocalChange$(
							model.time,
							$elm$core$Maybe$Just(
								$author$project$Types$Local_TextEditor(localChange)),
							_Utils_update(
								loggedIn,
								{textEditor: textEditor}),
							$lamdera$program_test$Effect$Command$none);
						var loggedIn2 = _v187.a;
						var cmds = _v187.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									loginStatus: $author$project$Types$LoggedIn(loggedIn2)
								}),
							cmds);
					case 1:
						return $author$project$FrontendExtra$routePush$(
							model,
							$author$project$Route$HomePageRoute($elm$core$Maybe$Nothing));
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									loginStatus: $author$project$Types$LoggedIn(
										_Utils_update(
											loggedIn,
											{textEditor: textEditor}))
								}),
							$lamdera$program_test$Effect$Command$none);
				}
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 130:
			var checked = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_LinkSlackAcknowledgementIsChecked(checked)),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 129:
			var checked = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_LinkDiscordAcknowledgementIsChecked(checked)),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 131:
			var discordUserId = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_StartReloadingDiscordUser$(model.time, discordUserId)),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 192:
			var slackUserId = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_Slack_ReloadUser(slackUserId)),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 191:
			var slackUserId = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_Slack_UnlinkUser(slackUserId)),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 132:
			var discordUserId = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_UnlinkDiscordUser(discordUserId)),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 133:
			var data = msg.a;
			var _v188 = model.loginStatus;
			if (!_v188.$) {
				var loggedIn = _v188.a;
				var local = $author$project$Local$model(loggedIn.localState);
				var _v189 = $elmcraft$core_extra$List$Extra$find$(
					function (_v190) {
						var channel = _v190.b;
						return $author$project$NonemptySet$unorderedEquals$(
							$author$project$NonemptySet$fromNonemptyList(
								$mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
									data.currentUserId,
									_List_fromArray(
										[data.otherUserId]))),
							$author$project$NonemptySet$fromNonemptyList(
								$author$project$NonemptyDict$keys(channel.members)));
					},
					$lamdera$containers$SeqDict$toList(local.discordDmChannels));
				if (!_v189.$) {
					var _v191 = _v189.a;
					var channelId = _v191.a;
					return $author$project$FrontendExtra$routePush$(
						model,
						$author$project$Route$DiscordDmRoute(
							{channelId: channelId, channelsVisible: 0, currentDiscordUserId: data.currentUserId, overlay: $elm$core$Maybe$Nothing, showMembersTab: 1, tab: $elm$core$Maybe$Nothing, viewingMessage: $elm$core$Maybe$Nothing}));
				} else {
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				}
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 134:
			return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
		case 135:
			var result = msg.a;
			var _v192 = _Utils_Tuple2(result, model.versionNumber);
			if (!_v192.a.$) {
				if (!_v192.b.$) {
					var version = _v192.a.a;
					var previousVersion = _v192.b.a;
					return _Utils_eq(version, previousVersion) ? _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none) : _Utils_Tuple2(model, $lamdera$program_test$Effect$Browser$Navigation$reload);
				} else {
					var version = _v192.a.a;
					var _v193 = _v192.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								versionNumber: $elm$core$Maybe$Just(version)
							}),
						$lamdera$program_test$Effect$Command$none);
				}
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 136:
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{externalLinkWarning: $elm$core$Maybe$Nothing}),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 137:
			var isChecked = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					var _v194 = loggedIn.externalLinkWarning;
					if (!_v194.$) {
						var url = _v194.a;
						return $author$project$FrontendExtra$handleLocalChange$(
							model.time,
							$elm$core$Maybe$Just(
								$author$project$Types$Local_SetDomainWhitelist$(
									isChecked,
									$author$project$RichText$urlToDomain(url))),
							loggedIn,
							$lamdera$program_test$Effect$Command$none);
					} else {
						return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
					}
				},
				model);
		case 138:
			var newText = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					var _v195 = loggedIn.userOptions;
					if (!_v195.$) {
						var userOptions = _v195.a;
						return _Utils_Tuple2(
							_Utils_update(
								loggedIn,
								{
									userOptions: $elm$core$Maybe$Just(
										_Utils_update(
											userOptions,
											{domainWhitelistInput: newText}))
								}),
							$lamdera$program_test$Effect$Command$none);
					} else {
						return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
					}
				},
				model);
		case 139:
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					var _v196 = loggedIn.userOptions;
					if (!_v196.$) {
						var userOptions = _v196.a;
						return _Utils_Tuple2(
							_Utils_update(
								loggedIn,
								{
									userOptions: $elm$core$Maybe$Just(
										_Utils_update(
											userOptions,
											{
												color: $elm$core$Maybe$Just(
													$author$project$UserColor$startPicking(
														$author$project$Local$model(loggedIn.localState).localUser.user.color))
											}))
								}),
							$lamdera$program_test$Effect$Command$none);
					} else {
						return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
					}
				},
				model);
		case 140:
			var selection = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					var _v197 = loggedIn.userOptions;
					if (!_v197.$) {
						var userOptions = _v197.a;
						return _Utils_Tuple2(
							_Utils_update(
								loggedIn,
								{
									userOptions: $elm$core$Maybe$Just(
										_Utils_update(
											userOptions,
											{
												color: $elm$core$Maybe$Just(selection)
											}))
								}),
							$lamdera$program_test$Effect$Command$none);
					} else {
						return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
					}
				},
				model);
		case 141:
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					var _v198 = loggedIn.userOptions;
					if (!_v198.$) {
						var userOptions = _v198.a;
						return $author$project$FrontendExtra$handleLocalChange$(
							model.time,
							$elm$core$Maybe$map$(
								function (selection) {
									return $author$project$Types$Local_SetUserColor(
										$author$project$UserColor$picked(selection));
								},
								userOptions.color),
							_Utils_update(
								loggedIn,
								{
									userOptions: $elm$core$Maybe$Just(
										_Utils_update(
											userOptions,
											{color: $elm$core$Maybe$Nothing}))
								}),
							$lamdera$program_test$Effect$Command$none);
					} else {
						return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
					}
				},
				model);
		case 142:
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					var _v199 = loggedIn.userOptions;
					if (!_v199.$) {
						var userOptions = _v199.a;
						return _Utils_Tuple2(
							_Utils_update(
								loggedIn,
								{
									userOptions: $elm$core$Maybe$Just(
										_Utils_update(
											userOptions,
											{color: $elm$core$Maybe$Nothing}))
								}),
							$lamdera$program_test$Effect$Command$none);
					} else {
						return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
					}
				},
				model);
		case 143:
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					var _v200 = loggedIn.userOptions;
					if (!_v200.$) {
						var userOptions = _v200.a;
						var oldDomains = $author$project$Local$model(loggedIn.localState).localUser.user.domainWhitelist;
						var newDomains = $author$project$Frontend$parseDomainWhitelistInput(userOptions.domainWhitelistInput);
						return $elm$core$Tuple$mapFirst$(
							function (l) {
								return _Utils_update(
									l,
									{
										userOptions: $elm$core$Maybe$map$(
											function (uo) {
												return _Utils_update(
													uo,
													{
														domainWhitelistInput: $author$project$UserOptions$domainWhitelistToString(
															$author$project$Local$model(l.localState).localUser.user.domainWhitelist)
													});
											},
											l.userOptions)
									});
							},
							function (acc) {
								return $elm$core$List$foldl$(
									F2(
										function (domain, _v202) {
											var l = _v202.a;
											var cmds = _v202.b;
											return $author$project$FrontendExtra$handleLocalChange$(
												model.time,
												$elm$core$Maybe$Just(
													$author$project$Types$Local_SetDomainWhitelist$(false, domain)),
												l,
												cmds);
										}),
									acc,
									$lamdera$containers$SeqSet$toList(
										$lamdera$containers$SeqSet$diff$(oldDomains, newDomains)));
							}(
								$elm$core$List$foldl$(
									F2(
										function (domain, _v201) {
											var l = _v201.a;
											var cmds = _v201.b;
											return $author$project$FrontendExtra$handleLocalChange$(
												model.time,
												$elm$core$Maybe$Just(
													$author$project$Types$Local_SetDomainWhitelist$(true, domain)),
												l,
												cmds);
										}),
									_Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none),
									$lamdera$containers$SeqSet$toList(
										$lamdera$containers$SeqSet$diff$(newDomains, oldDomains)))));
					} else {
						return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
					}
				},
				model);
		case 144:
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					var _v203 = loggedIn.userOptions;
					if (!_v203.$) {
						var userOptions = _v203.a;
						return _Utils_Tuple2(
							_Utils_update(
								loggedIn,
								{
									userOptions: $elm$core$Maybe$Just(
										_Utils_update(
											userOptions,
											{
												domainWhitelistInput: $author$project$UserOptions$domainWhitelistToString(
													$author$project$Local$model(loggedIn.localState).localUser.user.domainWhitelist)
											}))
								}),
							$lamdera$program_test$Effect$Command$none);
					} else {
						return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
					}
				},
				model);
		case 145:
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{externalLinkWarning: $elm$core$Maybe$Nothing}),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 146:
			var guildOrDmId = msg.a;
			var threadRoute = msg.b;
			var messageInputMsg = msg.c;
			switch (messageInputMsg.$) {
				case 0:
					return $author$project$FrontendExtra$handlePressedTextInput(model);
				case 1:
					var text = messageInputMsg.a;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							var _v205 = $lamdera$containers$SeqDict$get$(
								_Utils_Tuple2(guildOrDmId, threadRoute),
								loggedIn.editMessage);
							if (!_v205.$) {
								var edit = _v205.a;
								var _v206 = $author$project$MessageInput$largePastedText$(edit.text, text);
								if (!_v206.$) {
									var largePaste = _v206.a;
									return $author$project$FrontendExtra$editMessage_gotPastedText$(
										_Utils_Tuple2(guildOrDmId, threadRoute),
										largePaste,
										loggedIn);
								} else {
									var oldTypingDebouncer = loggedIn.typingDebouncer;
									var loggedIn2 = _Utils_update(
										loggedIn,
										{
											editMessage: $lamdera$containers$SeqDict$insert$(
												_Utils_Tuple2(guildOrDmId, threadRoute),
												_Utils_update(
													edit,
													{text: text}),
												loggedIn.editMessage),
											typedTextCounter: loggedIn.typedTextCounter + 1,
											typingDebouncer: false
										});
									return $author$project$FrontendExtra$handleLocalChange$(
										model.time,
										oldTypingDebouncer ? $elm$core$Maybe$Just(
											$author$project$Types$Local_MemberEditTyping$(
												model.time,
												guildOrDmId,
												function () {
													if (threadRoute.$ === 1) {
														var threadId = threadRoute.a;
														return $author$project$Id$ViewThreadWithMessage$(
															threadId,
															$author$project$Id$changeType(edit.messageIndex));
													} else {
														return $author$project$Id$NoThreadWithMessage(edit.messageIndex);
													}
												}())) : $elm$core$Maybe$Nothing,
										_Utils_update(
											loggedIn2,
											{
												messageHover: function () {
													var _v208 = loggedIn2.messageHover;
													switch (_v208.$) {
														case 0:
															return loggedIn2.messageHover;
														case 1:
															return loggedIn2.messageHover;
														case 3:
															return loggedIn2.messageHover;
														default:
															var extraOptions = _v208.a;
															return $author$project$Types$MessageMenu(
																_Utils_update(
																	extraOptions,
																	{
																		mobileMode: $author$project$Types$MessageMenuFixed(
																			$author$project$MessageMenu$mobileMenuMaxHeight$(
																				extraOptions,
																				$author$project$Local$model(loggedIn2.localState),
																				model))
																	}));
													}
												}()
											}),
										$lamdera$program_test$Effect$Command$batch(
											_List_fromArray(
												[
													$lamdera$program_test$Effect$Task$perform$(
													function (_v209) {
														return $author$project$Types$DebouncedTyping;
													},
													$lamdera$program_test$Effect$Process$sleep(
														$ianmackenzie$elm_units$Duration$seconds(1))),
													$author$project$Frontend$removePartialStickers$(loggedIn2.textInputFocus, $author$project$MessageMenu$editMessageTextInputId, text)
												])));
								}
							} else {
								return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
							}
						},
						model);
				case 2:
					var charsLeft = messageInputMsg.a.charsLeft;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							var _v210 = $lamdera$containers$SeqDict$get$(
								_Utils_Tuple2(guildOrDmId, threadRoute),
								loggedIn.editMessage);
							if (!_v210.$) {
								var edit = _v210.a;
								if ((charsLeft < 0) || $author$project$FileStatus$hasUploadingFile(edit.attachedFiles)) {
									return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
								} else {
									var local = $author$project$Local$model(loggedIn.localState);
									var editedRichText = function () {
										var _v224 = _Utils_Tuple2(
											$MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(edit.text),
											$author$project$LocalState$guildOrDmIdToMessage$(
												function () {
													switch (guildOrDmId.$) {
														case 0:
															var guildOrDmId2 = guildOrDmId.a;
															return guildOrDmId2;
														case 1:
															return $author$project$Id$GuildOrDmId_Dm(
																{otherUserId: local.localUser.session.userId});
														default:
															return $author$project$Id$GuildOrDmId_Dm(
																{otherUserId: local.localUser.session.userId});
													}
												}(),
												$author$project$Id$threadRouteWithMessage$(edit.messageIndex, threadRoute),
												local));
										if ((!_v224.a.$) && (!_v224.b.$)) {
											var nonempty = _v224.a.a;
											var _v226 = _v224.b.a;
											var message = _v226.a;
											var richText = $author$project$RichText$fromNonemptyString$(
												local.localUser.timezone,
												$author$project$User$allUsers(local.localUser),
												$lamdera$containers$SeqDict$empty,
												nonempty);
											return _Utils_eq(message.content.content, richText) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(richText);
										} else {
											return $elm$core$Maybe$Nothing;
										}
									}();
									var editWasSent = function (loggedIn2) {
										return $author$project$MyUi$isMobile(model) ? $author$project$MessageMenu$close$(model, loggedIn2) : _Utils_update(
											loggedIn2,
											{
												editMessage: $lamdera$containers$SeqDict$remove$(
													_Utils_Tuple2(guildOrDmId, threadRoute),
													loggedIn2.editMessage)
											});
									};
									var _v211 = _Utils_Tuple2(
										$author$project$FrontendExtra$encryptedDmOtherUser$(guildOrDmId, local, loggedIn),
										editedRichText);
									if (!_v211.a.$) {
										if (!_v211.b.$) {
											var dmId = _v211.a.a;
											var richText = _v211.b.a;
											return $elm$core$Tuple$mapSecond$(
												function (cmd) {
													return $lamdera$program_test$Effect$Command$batch(
														_List_fromArray(
															[
																cmd,
																$author$project$FrontendExtra$setFocus$(model, $author$project$Pages$Guild$channelTextInputId)
															]));
												},
												$author$project$Frontend$startEncryptingEdit$(
													dmId,
													function () {
														if (threadRoute.$ === 1) {
															var threadId = threadRoute.a;
															return $author$project$Id$ViewThreadWithMessage$(
																threadId,
																$author$project$Id$changeType(edit.messageIndex));
														} else {
															return $author$project$Id$NoThreadWithMessage(edit.messageIndex);
														}
													}(),
													{
														attachedFiles: $author$project$FileStatus$onlyUploadedFiles(edit.attachedFiles),
														content: richText,
														embeds: $elm$core$Array$empty
													},
													editWasSent(loggedIn)));
										} else {
											var _v213 = _v211.b;
											return _Utils_Tuple2(
												editWasSent(loggedIn),
												$author$project$FrontendExtra$setFocus$(model, $author$project$Pages$Guild$channelTextInputId));
										}
									} else {
										var _v214 = _v211.a;
										return $author$project$FrontendExtra$handleLocalChange$(
											model.time,
											function () {
												switch (guildOrDmId.$) {
													case 0:
														var guildOrDmId2 = guildOrDmId.a;
														var _v216 = _Utils_Tuple2(
															$MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(edit.text),
															$author$project$LocalState$guildOrDmIdToMessage$(
																guildOrDmId2,
																$author$project$Id$threadRouteWithMessage$(edit.messageIndex, threadRoute),
																local));
														if ((!_v216.a.$) && (!_v216.b.$)) {
															var nonempty = _v216.a.a;
															var _v217 = _v216.b.a;
															var message = _v217.a;
															var richText = $author$project$RichText$fromNonemptyString$(
																local.localUser.timezone,
																$author$project$User$allUsers(local.localUser),
																$author$project$LocalState$channelMentions$(guildOrDmId2, local),
																nonempty);
															return _Utils_eq(message.content.content, richText) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
																$author$project$Types$Local_SendEditMessage$(
																	model.time,
																	model.timezone,
																	guildOrDmId2,
																	function () {
																		if (threadRoute.$ === 1) {
																			var threadId = threadRoute.a;
																			return $author$project$Id$ViewThreadWithMessage$(
																				threadId,
																				$author$project$Id$changeType(edit.messageIndex));
																		} else {
																			return $author$project$Id$NoThreadWithMessage(edit.messageIndex);
																		}
																	}(),
																	nonempty,
																	$author$project$FileStatus$onlyUploadedFiles(edit.attachedFiles)));
														} else {
															return $elm$core$Maybe$Nothing;
														}
													case 1:
														var guildOrDmId2 = guildOrDmId.a;
														var _v219 = _Utils_Tuple2(
															$MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(edit.text),
															$author$project$LocalState$discordGuildOrDmIdToMessage$(
																guildOrDmId2,
																$author$project$Id$threadRouteWithMessage$(edit.messageIndex, threadRoute),
																local));
														if ((!_v219.a.$) && (!_v219.b.$)) {
															var nonempty = _v219.a.a;
															var _v220 = _v219.b.a;
															var message = _v220.a;
															var richText = $author$project$RichText$fromNonemptyString$(
																local.localUser.timezone,
																$author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(local.localUser.discordUsers),
																$author$project$LocalState$discordChannelMentions$(guildOrDmId2, local),
																nonempty);
															if (_Utils_eq(message.content.content, richText)) {
																return $elm$core$Maybe$Nothing;
															} else {
																if (!guildOrDmId2.$) {
																	var channelId = guildOrDmId2.a.channelId;
																	var guildId = guildOrDmId2.a.guildId;
																	var currentUserId = guildOrDmId2.a.currentUserId;
																	return $elm$core$Maybe$Just(
																		$author$project$Types$Local_Discord_SendEditGuildMessage$(
																			model.time,
																			model.timezone,
																			currentUserId,
																			guildId,
																			channelId,
																			function () {
																				if (threadRoute.$ === 1) {
																					var threadId = threadRoute.a;
																					return $author$project$Id$ViewThreadWithMessage$(
																						threadId,
																						$author$project$Id$changeType(edit.messageIndex));
																				} else {
																					return $author$project$Id$NoThreadWithMessage(edit.messageIndex);
																				}
																			}(),
																			nonempty));
																} else {
																	var data = guildOrDmId2.a;
																	return $elm$core$Maybe$Just(
																		$author$project$Types$Local_Discord_SendEditDmMessage$(model.time, model.timezone, data, edit.messageIndex, nonempty));
																}
															}
														} else {
															return $elm$core$Maybe$Nothing;
														}
													default:
														var guildOrDmId2 = guildOrDmId.a;
														var _v223 = _Utils_Tuple2(
															$MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(edit.text),
															$author$project$LocalState$slackGuildOrDmIdToMessage$(
																guildOrDmId2,
																$author$project$Id$threadRouteWithMessage$(edit.messageIndex, threadRoute),
																local));
														if ((!_v223.a.$) && (!_v223.b.$)) {
															var nonempty = _v223.a.a;
															var message = _v223.b.a;
															var richText = $author$project$RichText$fromNonemptyString$(
																local.localUser.timezone,
																local.localUser.slackUsers,
																$author$project$LocalState$slackChannelMentions$(guildOrDmId2, local),
																nonempty);
															return _Utils_eq(message.content.content, richText) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
																$author$project$Types$Local_Slack_SendEditMessage$(
																	model.time,
																	model.timezone,
																	guildOrDmId2,
																	$author$project$Id$threadRouteWithMessage$(edit.messageIndex, threadRoute),
																	nonempty));
														} else {
															return $elm$core$Maybe$Nothing;
														}
												}
											}(),
											$author$project$MyUi$isMobile(model) ? $author$project$MessageMenu$close$(model, loggedIn) : _Utils_update(
												loggedIn,
												{
													editMessage: $lamdera$containers$SeqDict$remove$(
														_Utils_Tuple2(guildOrDmId, threadRoute),
														loggedIn.editMessage)
												}),
											$author$project$FrontendExtra$setFocus$(model, $author$project$Pages$Guild$channelTextInputId));
									}
								}
							} else {
								return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
							}
						},
						model);
				case 3:
					var index = messageInputMsg.a;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							return _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{
										previousTextInputFocus: loggedIn.textInputFocus,
										textInputFocus: function () {
											var _v227 = loggedIn.textInputFocus;
											if (!_v227.$) {
												var textInputFocus = _v227.a;
												var _v228 = $author$project$FrontendExtra$pingUserNameSoFar$($author$project$MessageMenu$editMessageTextInputId, textInputFocus.selection, guildOrDmId, threadRoute, loggedIn);
												if (!_v228.$) {
													var nameSoFar = _v228.a;
													return $elm$core$Maybe$Just(
														_Utils_update(
															textInputFocus,
															{
																dropdown: $author$project$MessageDropdown$pressedArrowInDropdown$(
																	$author$project$MyUi$isMobile(model),
																	model.timezone,
																	model.time,
																	nameSoFar,
																	guildOrDmId,
																	index,
																	textInputFocus.dropdown,
																	model.emojiData,
																	$author$project$Local$model(loggedIn.localState))
															}));
												} else {
													return loggedIn.textInputFocus;
												}
											} else {
												return loggedIn.textInputFocus;
											}
										}()
									}),
								$lamdera$program_test$Effect$Command$none);
						},
						model);
				case 4:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 5:
					var dropdownIndex = messageInputMsg.a;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							var _v229 = _Utils_Tuple2(
								$lamdera$containers$SeqDict$get$(
									_Utils_Tuple2(guildOrDmId, threadRoute),
									loggedIn.editMessage),
								loggedIn.textInputFocus);
							if ((!_v229.a.$) && (!_v229.b.$)) {
								var edit = _v229.a.a;
								var textInputFocus = _v229.b.a;
								var _v230 = _Utils_Tuple2(
									$MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(edit.text),
									$author$project$FrontendExtra$pingUserNameSoFar$($author$project$MessageMenu$editMessageTextInputId, textInputFocus.selection, guildOrDmId, threadRoute, loggedIn));
								if ((!_v230.a.$) && (!_v230.b.$)) {
									var nonempty = _v230.a.a;
									var nameSoFar = _v230.b.a;
									var _v231 = $author$project$MessageDropdown$pressedDropdownItem$(
										$author$project$Types$SetFocus,
										$author$project$MyUi$isMobile(model),
										model.time,
										nameSoFar,
										guildOrDmId,
										$author$project$MessageMenu$editMessageTextInputId,
										dropdownIndex,
										textInputFocus.dropdown,
										model.emojiData,
										$author$project$Local$model(loggedIn.localState),
										nonempty);
									var pingUser = _v231.a;
									var text2 = _v231.b;
									var cmd = _v231.c;
									return _Utils_Tuple2(
										_Utils_update(
											loggedIn,
											{
												editMessage: $lamdera$containers$SeqDict$insert$(
													_Utils_Tuple2(guildOrDmId, threadRoute),
													_Utils_update(
														edit,
														{
															text: $MartinSStewart$elm_nonempty_string$String$Nonempty$toString(text2)
														}),
													loggedIn.editMessage),
												previousTextInputFocus: loggedIn.textInputFocus,
												textInputFocus: $elm$core$Maybe$Just(
													_Utils_update(
														textInputFocus,
														{dropdown: pingUser}))
											}),
										cmd);
								} else {
									return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
								}
							} else {
								return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
							}
						},
						model);
				case 6:
					return _Utils_Tuple2(
						model,
						$author$project$FrontendExtra$setFocus$(model, $author$project$MessageMenu$editMessageTextInputId));
				case 7:
					return _Utils_Tuple2(
						model,
						$lamdera$program_test$Effect$File$Select$files$(
							_List_Nil,
							$author$project$Types$EditMessage_SelectedFilesToAttach(
								_Utils_Tuple2(guildOrDmId, threadRoute))));
				case 9:
					var files = messageInputMsg.a;
					return $author$project$FrontendExtra$editMessage_gotFiles$(
						_Utils_Tuple2(guildOrDmId, threadRoute),
						files,
						model);
				case 8:
					return _Utils_Tuple2(
						model,
						$lamdera$program_test$Effect$Task$attempt$(
							$author$project$Types$GotPositionForEmojiSelector_EditMessage,
							$lamdera$program_test$Effect$Browser$Dom$getElement($author$project$MessageMenu$editMessageTextInputId)));
				case 10:
					return $author$project$Frontend$pageUpOrDownScroll$(true, model);
				case 11:
					return $author$project$Frontend$pageUpOrDownScroll$(false, model);
				case 12:
					var range = messageInputMsg.a;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							return _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{
										editMessage: $lamdera$containers$SeqDict$update$(
											_Utils_Tuple2(guildOrDmId, threadRoute),
											$elm$core$Maybe$map(
												function (edit) {
													return _Utils_update(
														edit,
														{
															text: $author$project$MessageInput$insertTab$(range, edit.text)
														});
												}),
											loggedIn.editMessage),
										typedTextCounter: loggedIn.typedTextCounter + 1
									}),
								$author$project$Ports$execCommand(
									{
										commands: _List_fromArray(
											[
												$author$project$Ports$InsertText$($author$project$MessageInput$tabText, range)
											]),
										htmlId: $author$project$MessageMenu$editMessageTextInputId
									}));
						},
						model);
				case 13:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				default:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 154:
			var result = msg.a;
			if (!result.$) {
				var viewport = result.a;
				return $author$project$FrontendExtra$updateLoggedIn$(
					function (loggedIn) {
						var local = $author$project$Local$model(loggedIn.localState);
						var _v233 = _Utils_Tuple2(
							$author$project$Route$toGuildOrDmId$(local.localUser.session.userId, model.route),
							_Utils_cmp(
								viewport.viewport.y - (0.9 * ($author$project$Coord$yRaw(model.windowSize) - $author$project$MyUi$channelHeaderHeight)),
								$author$project$Scroll$closeToTop) < 0);
						if ((!_v233.a.$) && _v233.b) {
							var _v234 = _v233.a.a;
							var guildOrDmId = _v234.a;
							var threadRoute = _v234.b;
							return $author$project$FrontendExtra$handleLocalChange$(
								model.time,
								$author$project$Frontend$loadOlderMessages$(guildOrDmId, threadRoute, local),
								loggedIn,
								$lamdera$program_test$Effect$Command$none);
						} else {
							return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
						}
					},
					model);
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 149:
			var result = msg.a;
			if (!result.$) {
				var ok = result.a;
				return $author$project$Frontend$pressedOpenEmojiSelector$(
					$author$project$MessageMenu$editMessageTextInputId,
					$author$project$Types$EmojiSelectorForEditMessage(
						$author$project$Coord$xy$(
							$elm$core$Basics$round(ok.element.x),
							$elm$core$Basics$round(ok.element.y))),
					model);
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 150:
			var input = msg.a;
			var result = msg.b;
			if (!result.$) {
				var ok = result.a;
				return $author$project$Frontend$pressedOpenEmojiSelector$(
					$author$project$SheepGame$inputId(input),
					A2(
						$author$project$Types$EmojiSelectorForSheepGameInput,
						input,
						$author$project$Coord$xy$(
							$elm$core$Basics$round(ok.element.x),
							$elm$core$Basics$round(ok.element.y + ok.element.height))),
					model);
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 147:
			var guildOrDmId = msg.a;
			var threadRoute = msg.b;
			var messageInputMsg = msg.c;
			switch (messageInputMsg.$) {
				case 0:
					return $author$project$FrontendExtra$handlePressedTextInput(model);
				case 1:
					var text = messageInputMsg.a;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							var _v238 = $author$project$MessageInput$largePastedText$(
								$elm$core$Maybe$withDefault$(
									'',
									$elm$core$Maybe$map$(
										$MartinSStewart$elm_nonempty_string$String$Nonempty$toString,
										$lamdera$containers$SeqDict$get$(
											_Utils_Tuple2(guildOrDmId, threadRoute),
											loggedIn.drafts))),
								text);
							if (!_v238.$) {
								var largePaste = _v238.a;
								return $author$project$FrontendExtra$gotPastedText$(guildOrDmId, threadRoute, largePaste, loggedIn);
							} else {
								return $author$project$FrontendExtra$handleLocalChange$(
									model.time,
									loggedIn.typingDebouncer ? $elm$core$Maybe$Just(
										$author$project$Types$Local_MemberTyping$(
											model.time,
											_Utils_Tuple2(guildOrDmId, threadRoute))) : $elm$core$Maybe$Nothing,
									_Utils_update(
										loggedIn,
										{
											drafts: function () {
												var _v239 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(text);
												if (!_v239.$) {
													var nonempty = _v239.a;
													return $lamdera$containers$SeqDict$insert$(
														_Utils_Tuple2(guildOrDmId, threadRoute),
														nonempty,
														loggedIn.drafts);
												} else {
													return $lamdera$containers$SeqDict$remove$(
														_Utils_Tuple2(guildOrDmId, threadRoute),
														loggedIn.drafts);
												}
											}(),
											typedTextCounter: loggedIn.typedTextCounter + 1,
											typingDebouncer: false
										}),
									$lamdera$program_test$Effect$Command$batch(
										_List_fromArray(
											[
												$lamdera$program_test$Effect$Task$perform$(
												function (_v240) {
													return $author$project$Types$DebouncedTyping;
												},
												$lamdera$program_test$Effect$Process$sleep($author$project$Pages$Guild$typingDebouncerDelay)),
												$author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn.channelScrollPosition),
												$author$project$Frontend$removePartialStickers$(loggedIn.textInputFocus, $author$project$Pages$Guild$channelTextInputId, text)
											])));
							}
						},
						model);
				case 2:
					var charsLeft = messageInputMsg.a.charsLeft;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							var guildOrDmIdWithThread = _Utils_Tuple2(guildOrDmId, threadRoute);
							var _v241 = $lamdera$containers$SeqDict$get$(guildOrDmIdWithThread, loggedIn.drafts);
							if (!_v241.$) {
								var draft = _v241.a;
								var local = $author$project$Local$model(loggedIn.localState);
								var nonempty = $author$project$User$redactPrivateKeys$(local.localUser.user, draft);
								var safeToSend = (charsLeft >= 0) && (function () {
									var _v252 = $lamdera$containers$SeqDict$get$(guildOrDmIdWithThread, loggedIn.filesToUpload);
									if (!_v252.$) {
										var dict = _v252.a;
										return !$author$project$FileStatus$hasUploadingFile(
											$author$project$NonemptyDict$toSeqDict(dict));
									} else {
										return true;
									}
								}() && function () {
									switch (guildOrDmId.$) {
										case 0:
											return true;
										case 1:
											var guildOrDmId2 = guildOrDmId.a;
											return _Utils_eq(
												$author$project$LocalState$canSendDiscordMessage$(local, guildOrDmId2),
												$elm$core$Result$Ok(0));
										default:
											return true;
									}
								}());
								return (!safeToSend) ? _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none) : function (_v250) {
									var loggedIn2 = _v250.a;
									var cmd = _v250.b;
									var _v251 = $author$project$FrontendExtra$jumpToNewest$(model.time, guildOrDmId, threadRoute, loggedIn2);
									var loggedIn3 = _v251.a;
									var jumpCmd = _v251.b;
									return _Utils_Tuple2(
										loggedIn3,
										$lamdera$program_test$Effect$Command$batch(
											_List_fromArray(
												[cmd, jumpCmd])));
								}(
									function () {
										var _v242 = $author$project$FrontendExtra$encryptedDmOtherUser$(guildOrDmId, local, loggedIn);
										if (!_v242.$) {
											var dmId = _v242.a;
											return $author$project$Frontend$startEncryptingMessage$(
												dmId,
												threadRoute,
												{
													attachedFiles: function () {
														var _v243 = $lamdera$containers$SeqDict$get$(guildOrDmIdWithThread, loggedIn.filesToUpload);
														if (!_v243.$) {
															var dict = _v243.a;
															return $author$project$FileStatus$onlyUploadedFiles(
																$author$project$NonemptyDict$toSeqDict(dict));
														} else {
															return $lamdera$containers$SeqDict$empty;
														}
													}(),
													content: $author$project$RichText$fromNonemptyString$(
														local.localUser.timezone,
														$author$project$User$allUsers(local.localUser),
														$lamdera$containers$SeqDict$empty,
														nonempty),
													embeds: $elm$core$Array$empty
												},
												loggedIn);
										} else {
											return $author$project$FrontendExtra$handleLocalChange$(
												model.time,
												$elm$core$Maybe$Just(
													function () {
														switch (guildOrDmId.$) {
															case 0:
																var guildOrDmId2 = guildOrDmId.a;
																return $author$project$Types$Local_SendMessage$(
																	model.time,
																	model.timezone,
																	guildOrDmId2,
																	nonempty,
																	$author$project$Frontend$sendMessageThreadRoute$(guildOrDmIdWithThread, threadRoute, loggedIn),
																	function () {
																		var _v245 = $lamdera$containers$SeqDict$get$(guildOrDmIdWithThread, loggedIn.filesToUpload);
																		if (!_v245.$) {
																			var dict = _v245.a;
																			return $author$project$FileStatus$onlyUploadedFiles(
																				$author$project$NonemptyDict$toSeqDict(dict));
																		} else {
																			return $lamdera$containers$SeqDict$empty;
																		}
																	}(),
																	function () {
																		var _v246 = model.emojiData;
																		if (!_v246.$) {
																			var emojiData2 = _v246.a;
																			return $lamdera$containers$SeqSet$toList(
																				$lamdera$containers$SeqSet$fromList(
																					$author$project$RichText$emojisAndCustomEmojis$(
																						emojiData2,
																						$author$project$RichText$fromNonemptyString$($lamdera$program_test$Effect$Time$utc, $lamdera$containers$SeqDict$empty, $lamdera$containers$SeqDict$empty, nonempty))));
																		} else {
																			return _List_Nil;
																		}
																	}());
															case 1:
																var guildOrDmId2 = guildOrDmId.a;
																return $author$project$Types$Local_Discord_SendMessage$(
																	model.time,
																	model.timezone,
																	guildOrDmId2,
																	nonempty,
																	function () {
																		if (threadRoute.$ === 1) {
																			var threadId = threadRoute.a;
																			return $author$project$Id$ViewThreadWithMaybeMessage$(
																				threadId,
																				$elm$core$Maybe$map$(
																					$author$project$Id$changeType,
																					$author$project$Frontend$repliedToMessage$(guildOrDmIdWithThread, loggedIn)));
																		} else {
																			return $author$project$Id$NoThreadWithMaybeMessage(
																				$author$project$Frontend$repliedToMessage$(guildOrDmIdWithThread, loggedIn));
																		}
																	}(),
																	function () {
																		var _v248 = $lamdera$containers$SeqDict$get$(guildOrDmIdWithThread, loggedIn.filesToUpload);
																		if (!_v248.$) {
																			var dict = _v248.a;
																			return $author$project$FileStatus$onlyUploadedFiles(
																				$author$project$NonemptyDict$toSeqDict(dict));
																		} else {
																			return $lamdera$containers$SeqDict$empty;
																		}
																	}());
															default:
																var guildOrDmId2 = guildOrDmId.a;
																return $author$project$Types$Local_Slack_SendMessage$(
																	model.time,
																	model.timezone,
																	guildOrDmId2,
																	threadRoute,
																	nonempty,
																	function () {
																		var _v249 = $lamdera$containers$SeqDict$get$(guildOrDmIdWithThread, loggedIn.filesToUpload);
																		if (!_v249.$) {
																			var dict = _v249.a;
																			return $author$project$FileStatus$onlyUploadedFiles(
																				$author$project$NonemptyDict$toSeqDict(dict));
																		} else {
																			return $lamdera$containers$SeqDict$empty;
																		}
																	}());
														}
													}()),
												_Utils_update(
													loggedIn,
													{
														drafts: $lamdera$containers$SeqDict$remove$(guildOrDmIdWithThread, loggedIn.drafts),
														filesToUpload: $lamdera$containers$SeqDict$remove$(guildOrDmIdWithThread, loggedIn.filesToUpload),
														replyTo: $lamdera$containers$SeqDict$remove$(guildOrDmIdWithThread, loggedIn.replyTo)
													}),
												$author$project$MyUi$isMobile(model) ? $author$project$Scroll$toBottomOfChannelSmooth$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom) : $author$project$Scroll$toBottomOfChannel$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom));
										}
									}());
							} else {
								return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
							}
						},
						model);
				case 3:
					var index = messageInputMsg.a;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							return _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{
										previousTextInputFocus: loggedIn.textInputFocus,
										textInputFocus: function () {
											var _v254 = loggedIn.textInputFocus;
											if (!_v254.$) {
												var textInputFocus = _v254.a;
												var _v255 = $author$project$FrontendExtra$pingUserNameSoFar$($author$project$Pages$Guild$channelTextInputId, textInputFocus.selection, guildOrDmId, threadRoute, loggedIn);
												if (!_v255.$) {
													var nameSoFar = _v255.a;
													return $elm$core$Maybe$Just(
														_Utils_update(
															textInputFocus,
															{
																dropdown: $author$project$MessageDropdown$pressedArrowInDropdown$(
																	$author$project$MyUi$isMobile(model),
																	model.timezone,
																	model.time,
																	nameSoFar,
																	guildOrDmId,
																	index,
																	textInputFocus.dropdown,
																	model.emojiData,
																	$author$project$Local$model(loggedIn.localState))
															}));
												} else {
													return loggedIn.textInputFocus;
												}
											} else {
												return loggedIn.textInputFocus;
											}
										}()
									}),
								$lamdera$program_test$Effect$Command$none);
						},
						model);
				case 4:
					return $author$project$FrontendExtra$handlePressedArrowUpInEmptyInput$(model, guildOrDmId, threadRoute);
				case 5:
					var index = messageInputMsg.a;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							var _v256 = _Utils_Tuple2(
								$lamdera$containers$SeqDict$get$(
									_Utils_Tuple2(guildOrDmId, threadRoute),
									loggedIn.drafts),
								loggedIn.textInputFocus);
							if ((!_v256.a.$) && (!_v256.b.$)) {
								var text = _v256.a.a;
								var textInputFocus = _v256.b.a;
								var _v257 = $author$project$FrontendExtra$pingUserNameSoFar$($author$project$Pages$Guild$channelTextInputId, textInputFocus.selection, guildOrDmId, threadRoute, loggedIn);
								if (!_v257.$) {
									var nameSoFar = _v257.a;
									var _v258 = $author$project$MessageDropdown$pressedDropdownItem$(
										$author$project$Types$SetFocus,
										$author$project$MyUi$isMobile(model),
										model.time,
										nameSoFar,
										guildOrDmId,
										$author$project$Pages$Guild$channelTextInputId,
										index,
										textInputFocus.dropdown,
										model.emojiData,
										$author$project$Local$model(loggedIn.localState),
										text);
									var pingUser = _v258.a;
									var text2 = _v258.b;
									var cmd = _v258.c;
									return _Utils_Tuple2(
										_Utils_update(
											loggedIn,
											{
												drafts: $lamdera$containers$SeqDict$insert$(
													_Utils_Tuple2(guildOrDmId, threadRoute),
													text2,
													loggedIn.drafts),
												previousTextInputFocus: loggedIn.textInputFocus,
												textInputFocus: $elm$core$Maybe$Just(
													_Utils_update(
														textInputFocus,
														{dropdown: pingUser}))
											}),
										cmd);
								} else {
									return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
								}
							} else {
								return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
							}
						},
						model);
				case 6:
					return _Utils_Tuple2(
						model,
						$author$project$FrontendExtra$setFocus$(model, $author$project$Pages$Guild$channelTextInputId));
				case 7:
					return _Utils_Tuple2(
						model,
						$lamdera$program_test$Effect$File$Select$files$(
							_List_Nil,
							$author$project$Types$SelectedFilesToAttach(
								_Utils_Tuple2(guildOrDmId, threadRoute))));
				case 9:
					var files = messageInputMsg.a;
					return $author$project$FrontendExtra$gotFiles$(guildOrDmId, threadRoute, files, model);
				case 8:
					return $author$project$Frontend$pressedOpenEmojiSelector$($author$project$Pages$Guild$channelTextInputId, $author$project$Types$EmojiSelectorForMessage, model);
				case 10:
					return $author$project$Frontend$pageUpOrDownScroll$(true, model);
				case 11:
					return $author$project$Frontend$pageUpOrDownScroll$(false, model);
				case 12:
					var range = messageInputMsg.a;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							return _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{
										drafts: $lamdera$containers$SeqDict$update$(
											_Utils_Tuple2(guildOrDmId, threadRoute),
											$elm$core$Maybe$map(
												function (draft) {
													return $elm$core$Maybe$withDefault$(
														draft,
														$MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(
															$author$project$MessageInput$insertTab$(
																range,
																$MartinSStewart$elm_nonempty_string$String$Nonempty$toString(draft))));
												}),
											loggedIn.drafts),
										typedTextCounter: loggedIn.typedTextCounter + 1
									}),
								$author$project$Ports$execCommand(
									{
										commands: _List_fromArray(
											[
												$author$project$Ports$InsertText$($author$project$MessageInput$tabText, range)
											]),
										htmlId: $author$project$Pages$Guild$channelTextInputId
									}));
						},
						model);
				case 13:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				default:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 148:
			var result = msg.a;
			if (!result.$) {
				var emojiData = result.a;
				return _Utils_Tuple2(
					$author$project$Frontend$setEmojiData$(emojiData, model),
					$lamdera$program_test$Effect$Command$none);
			} else {
				var error = result.a;
				var _v260 = A2($elm$core$Debug$log, 'emoji error', error);
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 151:
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						toFrontendLogs: $elm$core$Maybe$Just($elm$core$Array$empty)
					}),
				$lamdera$program_test$Effect$Command$none);
		case 152:
			var _v261 = msg.a;
			var maybeHtmlId = _v261.a;
			var maybeRange = _v261.b;
			return $author$project$Frontend$selectionChanged$(maybeHtmlId, maybeRange, model);
		case 153:
			var _v262 = msg.a;
			var maybeHtmlId = _v262.a;
			var maybeRange = _v262.b;
			return $author$project$Frontend$textInputFocusChanged$(maybeHtmlId, maybeRange, model);
		case 155:
			var result = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					if (!result.$) {
						var event = result.a;
						switch (event.$) {
							case 0:
								var mediaDevices = event.a;
								var defaultDevices = event.b;
								var voiceChat = $author$project$Call$gotUserMediaDevices$(mediaDevices, defaultDevices, loggedIn.voiceChat);
								var remoteCallData = voiceChat.remoteCallData;
								var _v265 = _Utils_Tuple2(voiceChat.selectedVideoInputDevice, remoteCallData.videoInputEnabled);
								if ((_v265.a.$ === 1) && _v265.b) {
									var _v266 = _v265.a;
									return $author$project$FrontendExtra$handleLocalChange$(
										model.time,
										$elm$core$Maybe$Just(
											$author$project$Types$Local_VoiceChatChange(
												$author$project$Call$Local_SetRemoteCallData(
													_Utils_update(
														remoteCallData,
														{videoInputEnabled: false})))),
										_Utils_update(
											loggedIn,
											{
												voiceChat: _Utils_update(
													voiceChat,
													{
														remoteCallData: _Utils_update(
															remoteCallData,
															{videoInputEnabled: false})
													})
											}),
										$author$project$Call$toJs(
											$author$project$Call$ToJs_SetVideoInputEnabled(false)));
								} else {
									return _Utils_Tuple2(
										_Utils_update(
											loggedIn,
											{voiceChat: voiceChat}),
										$lamdera$program_test$Effect$Command$none);
								}
							case 1:
								var error = event.a;
								var voiceChat = loggedIn.voiceChat;
								return _Utils_Tuple2(
									_Utils_update(
										loggedIn,
										{
											voiceChat: _Utils_update(
												voiceChat,
												{
													userMediaDevices: $author$project$Call$FailedToGetMediaDevices(error)
												})
										}),
									$lamdera$program_test$Effect$Command$none);
							case 2:
								var connectionId = event.a;
								var isSpeaking = event.b;
								var voiceChat = loggedIn.voiceChat;
								return _Utils_Tuple2(
									_Utils_update(
										loggedIn,
										{
											voiceChat: function () {
												if (connectionId.$ === 1) {
													var connection2 = connectionId.a;
													return _Utils_update(
														voiceChat,
														{
															isSpeaking: isSpeaking ? $lamdera$containers$SeqSet$insert$(connection2, voiceChat.isSpeaking) : $lamdera$containers$SeqSet$remove$(connection2, voiceChat.isSpeaking)
														});
												} else {
													return _Utils_update(
														voiceChat,
														{localIsSpeaking: isSpeaking});
												}
											}()
										}),
									$lamdera$program_test$Effect$Command$none);
							case 3:
								var string = event.a;
								var voiceChat = loggedIn.voiceChat;
								return _Utils_Tuple2(
									_Utils_update(
										loggedIn,
										{
											voiceChat: _Utils_update(
												voiceChat,
												{
													startConnectionError: $elm$core$Maybe$Just(string)
												})
										}),
									$lamdera$program_test$Effect$Command$none);
							case 5:
								return $author$project$Frontend$setScreenShareEnabled$(model.time, true, loggedIn);
							case 6:
								return $author$project$Frontend$setScreenShareEnabled$(model.time, false, loggedIn);
							case 7:
								var uploaded = event.a;
								var total = event.b;
								var voiceChat = loggedIn.voiceChat;
								return _Utils_Tuple2(
									_Utils_update(
										loggedIn,
										{
											voiceChat: _Utils_update(
												voiceChat,
												{
													recordingUpload: $elm$core$Maybe$Just(
														{total: total, uploaded: uploaded})
												})
										}),
									$lamdera$program_test$Effect$Command$none);
							case 8:
								var voiceChat = loggedIn.voiceChat;
								return _Utils_Tuple2(
									_Utils_update(
										loggedIn,
										{
											voiceChat: _Utils_update(
												voiceChat,
												{recordingUpload: $elm$core$Maybe$Nothing})
										}),
									$lamdera$program_test$Effect$Command$none);
							default:
								var sections = event.a;
								var voiceChat = loggedIn.voiceChat;
								return _Utils_Tuple2(
									_Utils_update(
										loggedIn,
										{
											voiceChat: _Utils_update(
												voiceChat,
												{debugData: sections})
										}),
									$lamdera$program_test$Effect$Command$none);
						}
					} else {
						var error = result.a;
						var _v268 = A2($elm$core$Debug$log, 'voice chat port didn\u0027t decode', error);
						return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
					}
				},
				model);
		case 89:
			var guildOrDmId = msg.a;
			var fileId = msg.b.fileId;
			var removeSpoiler = msg.b.removeSpoiler;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{
								drafts: $lamdera$containers$SeqDict$updateIfExists$(
									guildOrDmId,
									function (text) {
										var timezone = $author$project$Local$model(loggedIn.localState).localUser.timezone;
										var allUsers = $author$project$User$allUsers(
											$author$project$Local$model(loggedIn.localState).localUser);
										var toggleSpoiler = function (channels) {
											return $author$project$RichText$toString$(
												timezone,
												false,
												allUsers,
												channels,
												removeSpoiler ? $author$project$RichText$unspoilerAttachedFile$(
													fileId,
													$author$project$RichText$fromNonemptyString$(timezone, allUsers, channels, text)) : $author$project$RichText$spoilerAttachedFile$(
													fileId,
													$author$project$RichText$fromNonemptyString$(timezone, allUsers, channels, text)));
										};
										return $elm$core$Maybe$withDefault$(
											text,
											$MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(
												function () {
													var _v269 = guildOrDmId.a;
													switch (_v269.$) {
														case 0:
															var guildOrDmId2 = _v269.a;
															return toggleSpoiler(
																$author$project$LocalState$channelMentions$(
																	guildOrDmId2,
																	$author$project$Local$model(loggedIn.localState)));
														case 1:
															var guildOrDmId2 = _v269.a;
															return toggleSpoiler(
																$author$project$LocalState$discordChannelMentions$(
																	guildOrDmId2,
																	$author$project$Local$model(loggedIn.localState)));
														default:
															var guildOrDmId2 = _v269.a;
															return toggleSpoiler(
																$author$project$LocalState$slackChannelMentions$(
																	guildOrDmId2,
																	$author$project$Local$model(loggedIn.localState)));
													}
												}()));
									},
									loggedIn.drafts)
							}),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 92:
			var guildOrDmId = msg.a;
			var fileId = msg.b.fileId;
			var removeSpoiler = msg.b.removeSpoiler;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{
								editMessage: $lamdera$containers$SeqDict$updateIfExists$(
									guildOrDmId,
									function (edit) {
										var _v270 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(edit.text);
										if (!_v270.$) {
											var nonempty = _v270.a;
											var timezone2 = $author$project$Local$model(loggedIn.localState).localUser.timezone;
											var allUsers = $author$project$User$allUsers(
												$author$project$Local$model(loggedIn.localState).localUser);
											var toggleSpoiler = function (channels) {
												return $author$project$RichText$toString$(
													timezone2,
													false,
													allUsers,
													channels,
													removeSpoiler ? $author$project$RichText$unspoilerAttachedFile$(
														fileId,
														$author$project$RichText$fromNonemptyString$(timezone2, allUsers, channels, nonempty)) : $author$project$RichText$spoilerAttachedFile$(
														fileId,
														$author$project$RichText$fromNonemptyString$(timezone2, allUsers, channels, nonempty)));
											};
											return _Utils_update(
												edit,
												{
													text: function () {
														var _v271 = guildOrDmId.a;
														switch (_v271.$) {
															case 0:
																var guildOrDmId2 = _v271.a;
																return toggleSpoiler(
																	$author$project$LocalState$channelMentions$(
																		guildOrDmId2,
																		$author$project$Local$model(loggedIn.localState)));
															case 1:
																var guildOrDmId2 = _v271.a;
																return toggleSpoiler(
																	$author$project$LocalState$discordChannelMentions$(
																		guildOrDmId2,
																		$author$project$Local$model(loggedIn.localState)));
															default:
																var guildOrDmId2 = _v271.a;
																return toggleSpoiler(
																	$author$project$LocalState$slackChannelMentions$(
																		guildOrDmId2,
																		$author$project$Local$model(loggedIn.localState)));
														}
													}()
												});
										} else {
											return edit;
										}
									},
									loggedIn.editMessage)
							}),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 156:
			var voiceChatMsg = msg.a;
			switch (voiceChatMsg.$) {
				case 0:
					var deviceId = voiceChatMsg.a;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							var voiceChat = loggedIn.voiceChat;
							var voiceChat2 = _Utils_update(
								voiceChat,
								{
									selectedAudioInputDevice: $elm$core$Maybe$Just(deviceId)
								});
							return _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{voiceChat: voiceChat2}),
								$lamdera$program_test$Effect$Command$batch(
									_List_fromArray(
										[
											$author$project$Call$toJs(
											$author$project$Call$ToJs_SetInput$(true, deviceId)),
											$author$project$Call$startLocalStream(voiceChat2)
										])));
						},
						model);
				case 1:
					var deviceId = voiceChatMsg.a;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							var voiceChat = loggedIn.voiceChat;
							var voiceChat2 = _Utils_update(
								voiceChat,
								{
									selectedVideoInputDevice: $elm$core$Maybe$Just(deviceId)
								});
							return _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{voiceChat: voiceChat2}),
								$lamdera$program_test$Effect$Command$batch(
									_List_fromArray(
										[
											$author$project$Call$toJs(
											$author$project$Call$ToJs_SetInput$(false, deviceId)),
											$author$project$Call$startLocalStream(voiceChat2)
										])));
						},
						model);
				case 2:
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							var voiceChat = loggedIn.voiceChat;
							var remoteCallData = voiceChat.remoteCallData;
							var audioInputEnabled = !remoteCallData.audioInputEnabled;
							return $author$project$FrontendExtra$handleLocalChange$(
								model.time,
								$elm$core$Maybe$Just(
									$author$project$Types$Local_VoiceChatChange(
										$author$project$Call$Local_SetRemoteCallData(
											_Utils_update(
												remoteCallData,
												{audioInputEnabled: audioInputEnabled})))),
								_Utils_update(
									loggedIn,
									{
										voiceChat: _Utils_update(
											voiceChat,
											{
												remoteCallData: _Utils_update(
													remoteCallData,
													{audioInputEnabled: audioInputEnabled})
											})
									}),
								$author$project$Call$toJs(
									$author$project$Call$ToJs_SetAudioInputEnabled(audioInputEnabled)));
						},
						model);
				case 3:
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							var voiceChat = loggedIn.voiceChat;
							var remoteCallData = voiceChat.remoteCallData;
							var videoInputEnabled = !remoteCallData.videoInputEnabled;
							return $author$project$FrontendExtra$handleLocalChange$(
								model.time,
								$elm$core$Maybe$Just(
									$author$project$Types$Local_VoiceChatChange(
										$author$project$Call$Local_SetRemoteCallData(
											_Utils_update(
												remoteCallData,
												{videoInputEnabled: videoInputEnabled})))),
								_Utils_update(
									loggedIn,
									{
										voiceChat: _Utils_update(
											voiceChat,
											{
												remoteCallData: _Utils_update(
													remoteCallData,
													{videoInputEnabled: videoInputEnabled})
											})
									}),
								$author$project$Call$toJs(
									$author$project$Call$ToJs_SetVideoInputEnabled(videoInputEnabled)));
						},
						model);
				case 4:
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							return loggedIn.voiceChat.remoteCallData.screenShareEnabled ? $elm$core$Tuple$mapSecond$(
								function (cmd) {
									return $lamdera$program_test$Effect$Command$batch(
										_List_fromArray(
											[
												cmd,
												$author$project$Call$toJs($author$project$Call$ToJs_StopScreenShare)
											]));
								},
								$author$project$Frontend$setScreenShareEnabled$(model.time, false, loggedIn)) : _Utils_Tuple2(
								loggedIn,
								$author$project$Call$toJs($author$project$Call$ToJs_StartScreenShare));
						},
						model);
				case 5:
					var roomId = voiceChatMsg.a;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							return _Utils_Tuple2(
								loggedIn,
								$author$project$Call$startCallCmd$(
									roomId,
									$author$project$Local$model(loggedIn.localState).localUser.session.userId,
									model.clientId,
									loggedIn.voiceChat));
						},
						model);
				case 6:
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							var local = $author$project$Local$model(loggedIn.localState);
							return $author$project$FrontendExtra$handleLocalChange$(
								model.time,
								$elm$core$Maybe$Just(
									$author$project$Types$Local_VoiceChatChange(
										$author$project$Call$Local_Leave(model.time))),
								loggedIn,
								$author$project$Call$leaveVoiceChatCmds(local.calls));
						},
						model);
				case 7:
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							return $author$project$FrontendExtra$handleLocalChange$(
								model.time,
								$elm$core$Maybe$Just(
									$author$project$Types$Local_VoiceChatChange($author$project$Call$Local_RequestRecording)),
								loggedIn,
								$lamdera$program_test$Effect$Command$none);
						},
						model);
				case 8:
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							return $author$project$FrontendExtra$handleLocalChange$(
								model.time,
								$elm$core$Maybe$Just(
									$author$project$Types$Local_VoiceChatChange($author$project$Call$Local_CancelRecording)),
								loggedIn,
								$lamdera$program_test$Effect$Command$none);
						},
						model);
				case 9:
					var allow = voiceChatMsg.a;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							return $author$project$FrontendExtra$handleLocalChange$(
								model.time,
								$elm$core$Maybe$Just(
									$author$project$Types$Local_VoiceChatChange(
										$author$project$Call$Local_AnswerRecording(allow))),
								loggedIn,
								$lamdera$program_test$Effect$Command$none);
						},
						model);
				case 10:
					var text = voiceChatMsg.a;
					return $author$project$Frontend$copyText$(text, model);
				case 11:
					var connectionId = voiceChatMsg.a;
					var volume = voiceChatMsg.b;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							var voiceChat = loggedIn.voiceChat;
							return _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{
										voiceChat: _Utils_update(
											voiceChat,
											{
												volume: $lamdera$containers$SeqDict$insert$(connectionId.otherClientId, volume, voiceChat.volume)
											})
									}),
								$author$project$Call$toJs(
									$author$project$Call$ToJs_SetVolume$(connectionId, volume)));
						},
						model);
				case 12:
					var connectionId = voiceChatMsg.a;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							var voiceChat = loggedIn.voiceChat;
							return _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{
										voiceChat: _Utils_update(
											voiceChat,
											{
												videoHover: $elm$core$Maybe$Just(connectionId)
											})
									}),
								$lamdera$program_test$Effect$Command$none);
						},
						model);
				case 13:
					var connectionId = voiceChatMsg.a;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							var voiceChat = loggedIn.voiceChat;
							return _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{
										voiceChat: _Utils_update(
											voiceChat,
											{
												videoHover: _Utils_eq(
													voiceChat.videoHover,
													$elm$core$Maybe$Just(connectionId)) ? $elm$core$Maybe$Nothing : voiceChat.videoHover
											})
									}),
								$lamdera$program_test$Effect$Command$none);
						},
						model);
				case 17:
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							var voiceChat = loggedIn.voiceChat;
							var pollDebugData = !voiceChat.pollDebugData;
							return _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{
										voiceChat: _Utils_update(
											voiceChat,
											{debugData: _List_Nil, pollDebugData: pollDebugData})
									}),
								pollDebugData ? $author$project$Call$toJs($author$project$Call$ToJs_DebugDataRequest) : $lamdera$program_test$Effect$Command$none);
						},
						model);
				case 18:
					return _Utils_Tuple2(
						model,
						$author$project$Call$toJs($author$project$Call$ToJs_DebugDataRequest));
				case 16:
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							var voiceChat = loggedIn.voiceChat;
							return _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{
										voiceChat: _Utils_update(
											voiceChat,
											{showDeviceSettings: !voiceChat.showDeviceSettings})
									}),
								$lamdera$program_test$Effect$Command$none);
						},
						model);
				case 15:
					var tile = voiceChatMsg.a;
					return $author$project$MyUi$isMobile(model) ? _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none) : $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							var voiceChat = loggedIn.voiceChat;
							return _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{
										voiceChat: _Utils_update(
											voiceChat,
											{
												focusedTile: _Utils_eq(
													voiceChat.focusedTile,
													$elm$core$Maybe$Just(tile)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(tile)
											})
									}),
								$lamdera$program_test$Effect$Command$none);
						},
						model);
				default:
					var _v273 = model.loginStatus;
					if (!_v273.$) {
						var loggedIn = _v273.a;
						var local = $author$project$Local$model(loggedIn.localState);
						var _v274 = $author$project$Call$displayMode$(
							$author$project$MyUi$isMobile(model),
							local.localUser.session.userId,
							model.route,
							local.calls);
						switch (_v274.$) {
							case 0:
								return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
							case 1:
								return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
							case 2:
								return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
							default:
								if (!_v274.a.$) {
									var otherUserId = _v274.a.a.otherUserId;
									return $author$project$FrontendExtra$routePush$(
										model,
										$author$project$Route$DmRoute(
											{
												channelId: $author$project$DmChannelId$fromUserIds$(local.localUser.session.userId, otherUserId),
												channelsVisible: 0,
												overlay: $elm$core$Maybe$Nothing,
												tab: $elm$core$Maybe$Just($author$project$UserSession$ChannelHeaderTab_VoiceChat),
												threadRoute: $author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1)
											}));
								} else {
									var channelId = _v274.a.a.channelId;
									var guildId = _v274.a.a.guildId;
									return $author$project$FrontendExtra$routePush$(
										model,
										$author$project$Route$GuildRoute$(
											guildId,
											$author$project$Route$ChannelRoute$(
												channelId,
												$author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1),
												$elm$core$Maybe$Just($author$project$UserSession$ChannelHeaderTab_VoiceChat)),
											0,
											$elm$core$Maybe$Nothing));
								}
						}
					} else {
						return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
					}
			}
		case 158:
			var timeStamp = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{
								fileDragOverCount: function () {
									var _v275 = loggedIn.fileDragOverCount;
									if (_v275.$ === 1) {
										var dragStart = _v275.a;
										var count = _v275.b;
										return $author$project$Types$FileDragging$(
											dragStart,
											$author$project$OneOrGreater$increment(count));
									} else {
										return $author$project$Types$FileDragging$(
											$ianmackenzie$elm_units$Duration$addTo$(model.startupData.timeOrigin, timeStamp),
											$author$project$OneOrGreater$one);
									}
								}()
							}),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 159:
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{
								fileDragOverCount: function () {
									var _v276 = loggedIn.fileDragOverCount;
									if (_v276.$ === 1) {
										var dragStart = _v276.a;
										var count = _v276.b;
										var _v277 = $author$project$OneOrGreater$fromInt(
											$author$project$OneOrGreater$toInt(count) - 1);
										if (!_v277.$) {
											var count2 = _v277.a;
											return $author$project$Types$FileDragging$(dragStart, count2);
										} else {
											return $author$project$Types$NoFileDrag(
												$elm$core$Maybe$Just(model.time));
										}
									} else {
										return loggedIn.fileDragOverCount;
									}
								}()
							}),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 160:
			var files = msg.a;
			var modelReset = $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{
								fileDragOverCount: $author$project$Types$NoFileDrag(
									$elm$core$Maybe$Just(model.time))
							}),
						$lamdera$program_test$Effect$Command$none);
				},
				model).a;
			var _v278 = _Utils_Tuple2(
				$mgold$elm_nonempty_list$List$Nonempty$fromList(files),
				modelReset.loginStatus);
			if ((!_v278.a.$) && (!_v278.b.$)) {
				var nonemptyFiles = _v278.a.a;
				var loggedIn = _v278.b.a;
				var _v279 = $author$project$FrontendExtra$canDropFiles$(
					$author$project$MyUi$isMobile(model),
					$author$project$Local$model(loggedIn.localState).localUser.session.userId,
					modelReset.route);
				if (!_v279.$) {
					var func = _v279.a;
					return A2(func, nonemptyFiles, modelReset);
				} else {
					return _Utils_Tuple2(modelReset, $lamdera$program_test$Effect$Command$none);
				}
			} else {
				return _Utils_Tuple2(modelReset, $lamdera$program_test$Effect$Command$none);
			}
		case 157:
			var tab = msg.a;
			var sameTab = F2(
				function (tabA, tabB) {
					if (!tabB.$) {
						var tabB2 = tabB.a;
						return $author$project$Route$sameChannelHeaderTab$(tabA, tabB2) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(tabA);
					} else {
						return $elm$core$Maybe$Just(tabA);
					}
				});
			var _v280 = model.route;
			switch (_v280.$) {
				case 5:
					var dmRoute = _v280.a;
					return $author$project$FrontendExtra$routePush$(
						model,
						$author$project$Route$DmRoute(
							_Utils_update(
								dmRoute,
								{
									tab: A2(sameTab, tab, dmRoute.tab)
								})));
				case 0:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 1:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 2:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 3:
					var guildId = _v280.a;
					var channelRoute = _v280.b;
					var channelsVisible = _v280.c;
					var overlay = _v280.d;
					if (!channelRoute.$) {
						var channelId = channelRoute.a;
						var threadRoute = channelRoute.b;
						var currentTab = channelRoute.c;
						return $author$project$FrontendExtra$routePush$(
							model,
							$author$project$Route$GuildRoute$(
								guildId,
								$author$project$Route$ChannelRoute$(
									channelId,
									threadRoute,
									A2(sameTab, tab, currentTab)),
								channelsVisible,
								overlay));
					} else {
						return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
					}
				case 4:
					var routeData = _v280.a;
					var _v282 = routeData.channelRoute;
					if (!_v282.$) {
						var channelId = _v282.a;
						var threadRoute = _v282.b;
						var currentTab = _v282.c;
						return $author$project$FrontendExtra$routePush$(
							model,
							$author$project$Route$DiscordGuildRoute(
								_Utils_update(
									routeData,
									{
										channelRoute: $author$project$Route$DiscordChannel_ChannelRoute$(
											channelId,
											threadRoute,
											A2(sameTab, tab, currentTab))
									})));
					} else {
						return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
					}
				case 6:
					var routeData = _v280.a;
					return $author$project$FrontendExtra$routePush$(
						model,
						$author$project$Route$DiscordDmRoute(
							_Utils_update(
								routeData,
								{
									tab: A2(sameTab, tab, routeData.tab)
								})));
				case 9:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 10:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 11:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 12:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 13:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 7:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				default:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 80:
			var spectatorMsg = msg.a;
			var _v284 = model.publicGoMatch;
			switch (_v284.$) {
				case 2:
					var data = _v284.a;
					var gameModel = _v284.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								publicGoMatch: $author$project$Types$PublicGoMatch_Loaded$(
									data,
									$author$project$Go$updateSpectator$(spectatorMsg, data.cache, gameModel))
							}),
						$lamdera$program_test$Effect$Command$none);
				case 0:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 1:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				default:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 161:
			return _Utils_Tuple2(model, $author$project$Ports$unregisterServiceWorker);
		case 162:
			return _Utils_Tuple2(model, $author$project$Ports$loadServiceWorkerData);
		case 163:
			var serviceWorkerData = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{
								userOptions: $elm$core$Maybe$map$(
									function (userOptions) {
										return _Utils_update(
											userOptions,
											{
												debugData: $elm$core$Maybe$Just(
													{data: serviceWorkerData, loadedAt: model.time})
											});
									},
									loggedIn.userOptions)
							}),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 164:
			var drawingMsg = msg.a;
			return $author$project$Frontend$updateDrawing$(drawingMsg, model);
		case 165:
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					var loggedIn2 = _Utils_update(
						loggedIn,
						{channelScrollPosition: 0, drawingMode: $author$project$Drawing$NoSelectedAnchor, newMessagesWhileNotScrolledToBottom: 0});
					var _v285 = function () {
						var _v286 = $author$project$Route$toGuildOrDmId$(
							$author$project$Local$model(loggedIn2.localState).localUser.session.userId,
							model.route);
						if (!_v286.$) {
							var _v287 = _v286.a;
							var guildOrDmId = _v287.a;
							var threadRoute = _v287.b;
							return $author$project$FrontendExtra$jumpToNewest$(model.time, guildOrDmId, threadRoute, loggedIn2);
						} else {
							return _Utils_Tuple2(loggedIn2, $lamdera$program_test$Effect$Command$none);
						}
					}();
					var loggedIn3 = _v285.a;
					var jumpCmd = _v285.b;
					return _Utils_Tuple2(
						loggedIn3,
						$lamdera$program_test$Effect$Command$batch(
							_List_fromArray(
								[
									$author$project$Scroll$toBottomOfChannel$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom),
									jumpCmd
								])));
				},
				model);
		case 166:
			var result = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{popSound: result}),
				$lamdera$program_test$Effect$Command$none);
		case 167:
			var _v288 = model.loginStatus;
			if (!_v288.$) {
				var loggedIn = _v288.a;
				var route = $author$project$Route$setOverlay$(
					$elm$core$Maybe$Just(2),
					model.route);
				var local = $author$project$Local$model(loggedIn.localState);
				var query = function () {
					var _v289 = model.route;
					switch (_v289.$) {
						case 3:
							var guildId = _v289.a;
							var _v290 = $lamdera$containers$SeqDict$get$(guildId, local.guilds);
							if (!_v290.$) {
								var guild = _v290.a;
								return $author$project$GuildName$toString(guild.name) + ' ';
							} else {
								return '';
							}
						case 4:
							var data = _v289.a;
							var _v291 = $lamdera$containers$SeqDict$get$(data.guildId, local.discordGuilds);
							if (!_v291.$) {
								var guild = _v291.a;
								return $author$project$GuildName$toString(guild.name) + ' ';
							} else {
								return '';
							}
						case 7:
							var data = _v289.a;
							var _v292 = $lamdera$containers$SeqDict$get$(data.teamId, local.slackWorkspaces);
							if (!_v292.$) {
								var workspace = _v292.a;
								return workspace.name + ' ';
							} else {
								return '';
							}
						case 0:
							return '';
						case 5:
							return '';
						case 6:
							return '';
						case 8:
							return '';
						case 1:
							return '';
						case 2:
							return '';
						case 9:
							return '';
						case 10:
							return '';
						case 11:
							return '';
						case 12:
							return '';
						default:
							return '';
					}
				}();
				return _Utils_eq(route, model.route) ? _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none) : $author$project$FrontendExtra$routePush$(
					_Utils_update(
						model,
						{
							loginStatus: $author$project$Types$LoggedIn(
								_Utils_update(
									loggedIn,
									{searchOverlayQuery: query}))
						}),
					route);
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 168:
			var text = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{searchOverlayQuery: text, searchOverlaySelection: 0}),
						$lamdera$program_test$Effect$Task$attempt$(
							function (_v293) {
								return $author$project$Types$FrontendNoOp;
							},
							$lamdera$program_test$Effect$Browser$Dom$setViewportOf$($author$project$SearchOverlay$resultsContainerId, 0, 0)));
				},
				model);
		case 169:
			var delta = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					var rowHeight = $author$project$SearchOverlay$rowHeight(
						$author$project$MyUi$isMobile(model));
					var resultCount = $elm$core$List$length(
						$author$project$SearchOverlay$search$(
							loggedIn.searchOverlayQuery,
							$author$project$Local$model(loggedIn.localState)));
					var selection = $elm$core$Basics$clamp$(0, resultCount - 1, loggedIn.searchOverlaySelection + delta);
					var rowTop = selection * rowHeight;
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{searchOverlaySelection: selection}),
						$lamdera$program_test$Effect$Task$attempt$(
							function (_v295) {
								return $author$project$Types$FrontendNoOp;
							},
							A2(
								$lamdera$program_test$Effect$Task$andThen,
								function (_v294) {
									var viewport = _v294.viewport;
									return (_Utils_cmp(rowTop, viewport.y) < 0) ? $lamdera$program_test$Effect$Browser$Dom$setViewportOf$($author$project$SearchOverlay$resultsContainerId, 0, rowTop) : ((_Utils_cmp(rowTop + rowHeight, viewport.y + viewport.height) > 0) ? $lamdera$program_test$Effect$Browser$Dom$setViewportOf$($author$project$SearchOverlay$resultsContainerId, 0, (rowTop + rowHeight) - viewport.height) : $lamdera$program_test$Effect$Task$succeed(0));
								},
								$lamdera$program_test$Effect$Browser$Dom$getViewportOf($author$project$SearchOverlay$resultsContainerId))));
				},
				model);
		case 170:
			var _v296 = model.loginStatus;
			if (!_v296.$) {
				var loggedIn = _v296.a;
				var _v297 = $elm$core$List$head(
					$elm$core$List$drop$(
						loggedIn.searchOverlaySelection,
						$author$project$SearchOverlay$search$(
							loggedIn.searchOverlayQuery,
							$author$project$Local$model(loggedIn.localState))));
				if (!_v297.$) {
					var result = _v297.a;
					return _Utils_Tuple2(
						model,
						$author$project$FrontendExtra$routeReplace$(model, result.route));
				} else {
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				}
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 171:
			var route = msg.a;
			return _Utils_Tuple2(
				model,
				$author$project$FrontendExtra$routeReplace$(model, route));
		case 172:
			var guildId = msg.a;
			var channelId = msg.b;
			var isMuted = msg.c;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_SetMuteChannel$(guildId, channelId, isMuted)),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 173:
			var guildId = msg.a;
			var channelId = msg.b;
			var threadId = msg.c;
			var isMuted = msg.d;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_SetMuteThread$(guildId, channelId, threadId, isMuted)),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 174:
			var discordUserId = msg.a;
			var guildId = msg.b;
			var channelId = msg.c;
			var isMuted = msg.d;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_SetMuteDiscordChannel$(discordUserId, guildId, channelId, isMuted)),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 175:
			var discordUserId = msg.a;
			var guildId = msg.b;
			var channelId = msg.c;
			var threadId = msg.d;
			var isMuted = msg.e;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_SetMuteDiscordThread$(discordUserId, guildId, channelId, threadId, isMuted)),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 178:
			var guildId = msg.a;
			var isMuted = msg.b;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_SetMuteGuild$(guildId, isMuted)),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 179:
			var discordUserId = msg.a;
			var guildId = msg.b;
			var isMuted = msg.c;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_SetMuteDiscordGuild$(discordUserId, guildId, isMuted)),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 180:
			var slackUserId = msg.a;
			var teamId = msg.b;
			var isMuted = msg.c;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_SetMuteSlackWorkspace$(slackUserId, teamId, isMuted)),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 181:
			var slackUserId = msg.a;
			var teamId = msg.b;
			var channelId = msg.c;
			var isMuted = msg.d;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_SetMuteSlackChannel$(slackUserId, teamId, channelId, isMuted)),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 182:
			var slackUserId = msg.a;
			var teamId = msg.b;
			var channelId = msg.c;
			var threadId = msg.d;
			var isMuted = msg.e;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_SetMuteSlackThread$(slackUserId, teamId, channelId, threadId, isMuted)),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 176:
			var guildOrDmId = msg.a;
			var threadRoute = msg.b;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $author$project$FrontendExtra$handleLocalChange$(
						model.time,
						$elm$core$Maybe$Just(
							$author$project$Types$Local_SetLastViewed$(guildOrDmId, threadRoute)),
						loggedIn,
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 177:
			var unreads = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return $elm$core$List$foldl$(
						F2(
							function (_v298, _v299) {
								var guildOrDmId = _v298.a;
								var threadRoute = _v298.b;
								var loggedIn2 = _v299.a;
								var cmds = _v299.b;
								return $author$project$FrontendExtra$handleLocalChange$(
									model.time,
									$elm$core$Maybe$Just(
										$author$project$Types$Local_SetLastViewed$(guildOrDmId, threadRoute)),
									loggedIn2,
									cmds);
							}),
						_Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none),
						unreads);
				},
				model);
		case 183:
			var guildOrDmId = msg.a;
			var messageId = msg.b;
			var messageViewMsg = msg.c;
			switch (messageViewMsg.$) {
				case 0:
					var spoilerIndex = messageViewMsg.a;
					return $author$project$Frontend$handleRevealSpoilers$(
						guildOrDmId,
						$author$project$Id$NoThreadWithMessage(messageId),
						spoilerIndex,
						model);
				case 1:
					var url = messageViewMsg.a;
					return $author$project$Frontend$handlePressedNonWhitelistLink$(url, model);
				case 2:
					var imageSize = messageViewMsg.a.imageSize;
					var fileUrl = messageViewMsg.a.fileUrl;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								imageViewer: $elm$core$Maybe$Just(
									$author$project$ImageViewer$init(
										{imageSize: imageSize, url: fileUrl}))
							}),
						$lamdera$program_test$Effect$Command$none);
				case 3:
					return $author$project$Frontend$handleMouseEnteredMessage$(
						guildOrDmId,
						$author$project$Id$NoThreadWithMessage(messageId),
						model);
				case 4:
					return $author$project$Frontend$handleMouseExitedMessage$(
						guildOrDmId,
						$author$project$Id$NoThreadWithMessage(messageId),
						model);
				case 5:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 6:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 7:
					var emoji = messageViewMsg.a;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							return $author$project$FrontendExtra$handleLocalChange$(
								model.time,
								$elm$core$Maybe$Just(
									$author$project$Types$Local_RemoveReactionEmoji$(
										guildOrDmId,
										$author$project$Id$NoThreadWithMessage(messageId),
										emoji)),
								loggedIn,
								$lamdera$program_test$Effect$Command$none);
						},
						model);
				case 8:
					var emoji = messageViewMsg.a;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							return $author$project$FrontendExtra$handleLocalChange$(
								model.time,
								$elm$core$Maybe$Just(
									$author$project$Types$Local_AddReactionEmoji$(
										guildOrDmId,
										$author$project$Id$NoThreadWithMessage(messageId),
										emoji)),
								loggedIn,
								$lamdera$program_test$Effect$Command$none);
						},
						model);
				case 9:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 10:
					return $author$project$Frontend$showReactionEmojiSelector$(
						guildOrDmId,
						$author$project$Id$NoThreadWithMessage(messageId),
						model);
				case 11:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 12:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 13:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 14:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 15:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 16:
					var emoji = messageViewMsg.a;
					return $author$project$FrontendExtra$updateLoggedIn$(
						A4(
							$author$project$Frontend$toggleReactionEmoji,
							emoji,
							guildOrDmId,
							$author$project$Id$NoThreadWithMessage(messageId),
							model),
						model);
				case 17:
					switch (guildOrDmId.$) {
						case 0:
							if (!guildOrDmId.a.$) {
								var channelId = guildOrDmId.a.a.channelId;
								var guildId = guildOrDmId.a.a.guildId;
								return $author$project$FrontendExtra$routePush$(
									model,
									$author$project$Route$GuildRoute$(
										guildId,
										$author$project$Route$ChannelRoute$(
											channelId,
											$author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1),
											$elm$core$Maybe$Just($author$project$UserSession$ChannelHeaderTab_VoiceChat)),
										0,
										$elm$core$Maybe$Nothing));
							} else {
								var otherUserId = guildOrDmId.a.a.otherUserId;
								var _v302 = model.loginStatus;
								if (!_v302.$) {
									var loggedIn = _v302.a;
									return $author$project$FrontendExtra$routePush$(
										model,
										$author$project$Route$DmRoute(
											{
												channelId: $author$project$DmChannelId$fromUserIds$(
													$author$project$Local$model(loggedIn.localState).localUser.session.userId,
													otherUserId),
												channelsVisible: 0,
												overlay: $elm$core$Maybe$Nothing,
												tab: $elm$core$Maybe$Just($author$project$UserSession$ChannelHeaderTab_VoiceChat),
												threadRoute: $author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1)
											}));
								} else {
									return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
								}
							}
						case 1:
							return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
						default:
							return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
					}
				case 18:
					switch (guildOrDmId.$) {
						case 0:
							if (!guildOrDmId.a.$) {
								var channelId = guildOrDmId.a.a.channelId;
								var guildId = guildOrDmId.a.a.guildId;
								return $author$project$FrontendExtra$routePush$(
									model,
									$author$project$Route$GuildRoute$(
										guildId,
										$author$project$Route$ChannelRoute$(
											channelId,
											$author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1),
											$elm$core$Maybe$Just(
												$author$project$UserSession$ChannelHeaderTab_Games$(
													$elm$core$Maybe$Just(messageId),
													$elm$core$Maybe$Nothing))),
										0,
										$elm$core$Maybe$Nothing));
							} else {
								var otherUserId = guildOrDmId.a.a.otherUserId;
								var _v304 = model.loginStatus;
								if (!_v304.$) {
									var loggedIn = _v304.a;
									return $author$project$FrontendExtra$routePush$(
										model,
										$author$project$Route$DmRoute(
											{
												channelId: $author$project$DmChannelId$fromUserIds$(
													$author$project$Local$model(loggedIn.localState).localUser.session.userId,
													otherUserId),
												channelsVisible: 0,
												overlay: $elm$core$Maybe$Nothing,
												tab: $elm$core$Maybe$Just(
													$author$project$UserSession$ChannelHeaderTab_Games$(
														$elm$core$Maybe$Just(messageId),
														$elm$core$Maybe$Nothing)),
												threadRoute: $author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1)
											}));
								} else {
									return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
								}
							}
						case 1:
							return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
						default:
							return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
					}
				case 19:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 20:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 21:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 22:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 23:
					var otherUserId = messageViewMsg.a;
					return $author$project$Frontend$handlePressedUserIconButton$(otherUserId, model);
				case 24:
					var otherUserId = messageViewMsg.a;
					return $author$project$Frontend$handlePressedDiscordUserIconButton$(otherUserId, model);
				case 25:
					var channelId = messageViewMsg.a;
					var threadRoute2 = messageViewMsg.b;
					return $author$project$Frontend$handlePressedChannelMention$(guildOrDmId, channelId, threadRoute2, model);
				case 26:
					var channelId = messageViewMsg.a;
					var threadRoute2 = messageViewMsg.b;
					return $author$project$Frontend$handlePressedDiscordChannelMention$(guildOrDmId, channelId, threadRoute2, model);
				default:
					var text = messageViewMsg.a;
					return $author$project$Frontend$copyText$(text, model);
			}
		case 184:
			var guildOrDmId = msg.a;
			var threadId = msg.b;
			var messageId = msg.c;
			var messageViewMsg = msg.d;
			switch (messageViewMsg.$) {
				case 0:
					var spoilerIndex = messageViewMsg.a;
					return $author$project$Frontend$handleRevealSpoilers$(
						guildOrDmId,
						$author$project$Id$ViewThreadWithMessage$(threadId, messageId),
						spoilerIndex,
						model);
				case 1:
					var url = messageViewMsg.a;
					return $author$project$Frontend$handlePressedNonWhitelistLink$(url, model);
				case 2:
					var imageSize = messageViewMsg.a.imageSize;
					var fileUrl = messageViewMsg.a.fileUrl;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								imageViewer: $elm$core$Maybe$Just(
									$author$project$ImageViewer$init(
										{imageSize: imageSize, url: fileUrl}))
							}),
						$lamdera$program_test$Effect$Command$none);
				case 3:
					return $author$project$Frontend$handleMouseEnteredMessage$(
						guildOrDmId,
						$author$project$Id$ViewThreadWithMessage$(threadId, messageId),
						model);
				case 4:
					return $author$project$Frontend$handleMouseExitedMessage$(
						guildOrDmId,
						$author$project$Id$ViewThreadWithMessage$(threadId, messageId),
						model);
				case 5:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 6:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 7:
					var emoji = messageViewMsg.a;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							return $author$project$FrontendExtra$handleLocalChange$(
								model.time,
								$elm$core$Maybe$Just(
									$author$project$Types$Local_RemoveReactionEmoji$(
										guildOrDmId,
										$author$project$Id$ViewThreadWithMessage$(threadId, messageId),
										emoji)),
								loggedIn,
								$lamdera$program_test$Effect$Command$none);
						},
						model);
				case 8:
					var emoji = messageViewMsg.a;
					return $author$project$FrontendExtra$updateLoggedIn$(
						function (loggedIn) {
							return $author$project$FrontendExtra$handleLocalChange$(
								model.time,
								$elm$core$Maybe$Just(
									$author$project$Types$Local_AddReactionEmoji$(
										guildOrDmId,
										$author$project$Id$ViewThreadWithMessage$(threadId, messageId),
										emoji)),
								loggedIn,
								$lamdera$program_test$Effect$Command$none);
						},
						model);
				case 9:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 10:
					return $author$project$Frontend$showReactionEmojiSelector$(
						guildOrDmId,
						$author$project$Id$ViewThreadWithMessage$(threadId, messageId),
						model);
				case 11:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 12:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 13:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 14:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 15:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 16:
					var emoji = messageViewMsg.a;
					return $author$project$FrontendExtra$updateLoggedIn$(
						A4(
							$author$project$Frontend$toggleReactionEmoji,
							emoji,
							guildOrDmId,
							$author$project$Id$ViewThreadWithMessage$(threadId, messageId),
							model),
						model);
				case 17:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 18:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 19:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 20:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 21:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 22:
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				case 23:
					var otherUserId = messageViewMsg.a;
					return $author$project$Frontend$handlePressedUserIconButton$(otherUserId, model);
				case 24:
					var otherUserId = messageViewMsg.a;
					return $author$project$Frontend$handlePressedDiscordUserIconButton$(otherUserId, model);
				case 25:
					var channelId = messageViewMsg.a;
					var threadRoute2 = messageViewMsg.b;
					return $author$project$Frontend$handlePressedChannelMention$(guildOrDmId, channelId, threadRoute2, model);
				case 26:
					var channelId = messageViewMsg.a;
					var threadRoute2 = messageViewMsg.b;
					return $author$project$Frontend$handlePressedDiscordChannelMention$(guildOrDmId, channelId, threadRoute2, model);
				default:
					var text = messageViewMsg.a;
					return $author$project$Frontend$copyText$(text, model);
			}
		case 185:
			var text = msg.a;
			var keysValid = msg.b;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{
								userOptions: $elm$core$Maybe$map$(
									function (userOptions) {
										return _Utils_update(
											userOptions,
											{e2eeKeysValid: keysValid, privateKeyText: text});
									},
									loggedIn.userOptions)
							}),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 187:
			var text = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{
								userOptions: $elm$core$Maybe$map$(
									function (userOptions) {
										return _Utils_update(
											userOptions,
											{slackCookie: text});
									},
									loggedIn.userOptions)
							}),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 188:
			var text = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{
								userOptions: $elm$core$Maybe$map$(
									function (userOptions) {
										return _Utils_update(
											userOptions,
											{removedSlackTeams: $lamdera$containers$SeqSet$empty, slackTeamsJson: text});
									},
									loggedIn.userOptions)
							}),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 189:
			var teamId = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{
								userOptions: $elm$core$Maybe$map$(
									function (userOptions) {
										return _Utils_update(
											userOptions,
											{
												removedSlackTeams: $lamdera$containers$SeqSet$insert$(teamId, userOptions.removedSlackTeams)
											});
									},
									loggedIn.userOptions)
							}),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		default:
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					var _v306 = loggedIn.userOptions;
					if (!_v306.$) {
						var userOptions = _v306.a;
						var _v307 = $author$project$Slack$validateSlackData(userOptions);
						if (!_v307.$) {
							var slackData = _v307.a;
							return _Utils_Tuple2(
								loggedIn,
								$lamdera$program_test$Effect$Lamdera$sendToBackend(
									$author$project$Types$LinkSlackRequest(slackData)));
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									loggedIn,
									{
										userOptions: $elm$core$Maybe$Just(
											_Utils_update(
												userOptions,
												{pressedSubmitSlackData: true}))
									}),
								$lamdera$program_test$Effect$Command$none);
						}
					} else {
						return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
					}
				},
				model);
	}
};
var $author$project$Frontend$updateLoaded = F2($author$project$Frontend$updateLoaded$);
var $author$project$Frontend$update$ = function (_v0, msg, model) {
	if (!model.$) {
		var loading = model.a;
		switch (msg.$) {
			case 3:
				var width = msg.a;
				var height = msg.b;
				return _Utils_Tuple3(
					$author$project$Types$Loading(
						_Utils_update(
							loading,
							{
								windowSize: $author$project$Coord$xy$(width, height)
							})),
					$lamdera$program_test$Effect$Command$none,
					$author$project$Audio$cmdNone);
			case 108:
				if (!msg.a.$) {
					var startupData = msg.a.a;
					return $author$project$Frontend$tryInitLoadedFrontend(
						_Utils_update(
							loading,
							{
								startupData: $elm$core$Maybe$Just(startupData),
								time: $elm$core$Maybe$Just(startupData.loadStartupDataTime)
							}));
				} else {
					var error = msg.a.a;
					var _v3 = A2($elm$core$Debug$log, 'GotStartupData failed!', error);
					return _Utils_Tuple3(model, $lamdera$program_test$Effect$Command$none, $author$project$Audio$cmdNone);
				}
			case 166:
				var result = msg.a;
				return _Utils_Tuple3(
					$author$project$Types$Loading(
						_Utils_update(
							loading,
							{popSound: result})),
					$lamdera$program_test$Effect$Command$none,
					$author$project$Audio$cmdNone);
			default:
				return _Utils_Tuple3(model, $lamdera$program_test$Effect$Command$none, $author$project$Audio$cmdNone);
		}
	} else {
		var loaded = model.a;
		var _v4 = _Utils_Tuple2(
			$author$project$MyUi$isMobile(loaded) && $author$project$FrontendExtra$isPressMsg(msg),
			loaded.dragPrevious);
		if (_v4.a) {
			if (_v4.b.$ === 2) {
				return _Utils_Tuple3(model, $lamdera$program_test$Effect$Command$none, $author$project$Audio$cmdNone);
			} else {
				var _v5 = $author$project$Frontend$updateLoaded$(msg, loaded);
				var loadedNew = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple3(
					function () {
						var _v6 = loadedNew.loginStatus;
						if (!_v6.$) {
							var loggedIn = _v6.a;
							return $author$project$Types$Loaded(
								_Utils_update(
									loadedNew,
									{
										loginStatus: $author$project$Types$LoggedIn(
											_Utils_update(
												loggedIn,
												{previousTextInputFocus: $elm$core$Maybe$Nothing}))
									}));
						} else {
							return $author$project$Types$Loaded(loadedNew);
						}
					}(),
					$lamdera$program_test$Effect$Command$batch(
						_List_fromArray(
							[
								cmd,
								$author$project$Frontend$checkCallDisplayModeChange$(loaded, loadedNew),
								$author$project$Frontend$checkCallPreviewShown$(loaded, loadedNew),
								$author$project$Frontend$checkCallRecordingChange$(loaded, loadedNew)
							])),
					$author$project$Audio$cmdNone);
			}
		} else {
			var _v7 = $author$project$Frontend$updateLoaded$(msg, loaded);
			var loadedNew = _v7.a;
			var cmd = _v7.b;
			return _Utils_Tuple3(
				$author$project$Types$Loaded(loadedNew),
				$lamdera$program_test$Effect$Command$batch(
					_List_fromArray(
						[
							cmd,
							$author$project$Frontend$checkCallDisplayModeChange$(loaded, loadedNew),
							$author$project$Frontend$checkCallPreviewShown$(loaded, loadedNew),
							$author$project$Frontend$checkCallRecordingChange$(loaded, loadedNew)
						])),
				$author$project$Audio$cmdNone);
		}
	}
};
var $author$project$Frontend$update = F3($author$project$Frontend$update$);
var $author$project$Types$LoadError = {$: 2};
var $author$project$Types$LoadSuccess = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$PublicGoMatch_Missing = {$: 3};
var $author$project$Types$ImportChannelFailed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$ImportedChannel = function (a) {
	return {$: 3, a: a};
};
var $author$project$Types$ReloadDataRequest = function (a) {
	return {$: 12, a: a};
};
var $author$project$UserSession$UserOption_Discord = 4;
var $author$project$Frontend$decryptConversation$ = function (requestId, conversation) {
	return $author$project$Encryption$decryptManyMessages$(
		requestId,
		conversation.id,
		$elm$core$List$map$($elm$core$Tuple$second, conversation.messages));
};
var $author$project$Frontend$decryptConversation = F2($author$project$Frontend$decryptConversation$);
var $author$project$Encryption$decryptMessage$ = function (requestId, id, _v0) {
	var data = _v0;
	return A3(
		$lamdera$program_test$Effect$Command$sendToJsBytes,
		'encryption_to_js',
		$author$project$Encryption$encryption_to_js,
		$author$project$Serialize$encodeToBytes$(
			$author$project$Encryption$toJsCodec($author$project$Serialize$unit),
			$author$project$Encryption$ToJs_DecryptNewMessage(
				{data: data, otherUserId: id.otherUserId, requestId: requestId})));
};
var $author$project$Encryption$decryptMessage = F3($author$project$Encryption$decryptMessage$);
var $author$project$Frontend$encryptedContent = function (message) {
	switch (message.$) {
		case 1:
			var data = message.a;
			return $elm$core$Maybe$Just(data.content);
		case 0:
			return $elm$core$Maybe$Nothing;
		case 2:
			return $elm$core$Maybe$Nothing;
		case 3:
			return $elm$core$Maybe$Nothing;
		case 4:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Frontend$decryptRepliedTo$ = function (id, repliedToData, local, loggedIn) {
	var maybeContent = function () {
		switch (repliedToData.$) {
			case 0:
				return $elm$core$Maybe$Nothing;
			case 1:
				var message = repliedToData.a;
				return $author$project$Frontend$encryptedContent(message);
			case 2:
				var message = repliedToData.a;
				return $author$project$Frontend$encryptedContent(message);
			default:
				return $elm$core$Maybe$Nothing;
		}
	}();
	if (!maybeContent.$) {
		var content = maybeContent.a;
		return $lamdera$containers$SeqDict$member$(
			$author$project$Encryption$hash(content),
			local.localUser.decryptedMessages) ? _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none) : _Utils_Tuple2(
			$author$project$FrontendExtra$mapEncryptionRequests$(
				$author$project$Frontend$rememberDecryptManyRequest(
					{
						messageHashes: _List_fromArray(
							[
								$author$project$Encryption$hash(content)
							]),
						shiftScrollFrom: $elm$core$Maybe$Nothing
					}),
				loggedIn),
			$author$project$Encryption$decryptManyMessages$(
				loggedIn.encryptionRequests.nextDecryptManyRequestId,
				id,
				_List_fromArray(
					[content])));
	} else {
		return _Utils_Tuple2(loggedIn, $lamdera$program_test$Effect$Command$none);
	}
};
var $author$project$Frontend$decryptRepliedTo = F4($author$project$Frontend$decryptRepliedTo$);
var $author$project$Frontend$encryptedMessagesInConversation$ = function (id, shiftScrollFrom, messagesLoaded) {
	var _v0 = $elm$core$List$filterMap$($author$project$FrontendExtra$encryptedMessageData, messagesLoaded);
	if (!_v0.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var messages = _v0;
		return $elm$core$Maybe$Just(
			{id: id, messages: messages, shiftScrollFrom: shiftScrollFrom});
	}
};
var $author$project$Frontend$encryptedMessagesInConversation = F3($author$project$Frontend$encryptedMessagesInConversation$);
var $author$project$Frontend$encryptedMessagesLoadedInto$ = function (guildOrDmId, shiftScrollFrom, messagesLoaded) {
	if (guildOrDmId.$ === 1) {
		var id = guildOrDmId.a;
		return $author$project$Frontend$encryptedMessagesInConversation$(id, shiftScrollFrom, messagesLoaded);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Frontend$encryptedMessagesLoadedInto = F3($author$project$Frontend$encryptedMessagesLoadedInto$);
var $author$project$Frontend$shiftScrollAfterDecrypting$ = function (toHtmlId, pageRequest) {
	if (!pageRequest.$) {
		var previousOldestVisibleMessage = pageRequest.a;
		return $elm$core$Maybe$Just(
			toHtmlId(previousOldestVisibleMessage));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Frontend$shiftScrollAfterDecrypting = F2($author$project$Frontend$shiftScrollAfterDecrypting$);
var $author$project$Frontend$encryptedMessagesJustLoaded = function (localChange) {
	_v0$4:
	while (true) {
		switch (localChange.$) {
			case 29:
				if (localChange.c.$ === 1) {
					var guildOrDmId = localChange.a;
					var pageRequest = localChange.b;
					var messagesLoaded = localChange.c.a;
					return $author$project$Frontend$encryptedMessagesLoadedInto$(
						guildOrDmId,
						$author$project$Frontend$shiftScrollAfterDecrypting$($author$project$Pages$Guild$channelMessageHtmlId, pageRequest),
						$lamdera$containers$SeqDict$values(messagesLoaded.messages));
				} else {
					break _v0$4;
				}
			case 30:
				if (localChange.d.$ === 1) {
					var guildOrDmId = localChange.a;
					var pageRequest = localChange.c;
					var messagesLoaded = localChange.d.a;
					return $author$project$Frontend$encryptedMessagesLoadedInto$(
						guildOrDmId,
						$author$project$Frontend$shiftScrollAfterDecrypting$($author$project$Pages$Guild$threadMessageHtmlId, pageRequest),
						$lamdera$containers$SeqDict$values(messagesLoaded));
				} else {
					break _v0$4;
				}
			case 27:
				switch (localChange.b.$) {
					case 0:
						if (localChange.b.b.$ === 1) {
							var _v1 = localChange.b;
							var data = _v1.a;
							var messagesLoaded = _v1.b.a;
							return $author$project$Frontend$encryptedMessagesInConversation$(
								data.id,
								$elm$core$Maybe$Nothing,
								$lamdera$containers$SeqDict$values(messagesLoaded.messages));
						} else {
							break _v0$4;
						}
					case 1:
						if (localChange.b.b.$ === 1) {
							var _v2 = localChange.b;
							var data = _v2.a;
							var messagesLoaded = _v2.b.a;
							return $author$project$Frontend$encryptedMessagesInConversation$(
								{otherUserId: data.id.otherUserId},
								$elm$core$Maybe$Nothing,
								$lamdera$containers$SeqDict$values(messagesLoaded));
						} else {
							break _v0$4;
						}
					default:
						break _v0$4;
				}
			default:
				break _v0$4;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Game$gameChangeFromServer$ = function (time, localUser, gameChange, maybeModel) {
	var model = $elm$core$Maybe$withDefault$($author$project$Game$initModel, maybeModel);
	var currentUserId = localUser.session.userId;
	var updated = function () {
		switch (gameChange.$) {
			case 2:
				var matchId = gameChange.a;
				var goChange = gameChange.b;
				if (!goChange.$) {
					return _Utils_update(
						model,
						{
							startedGames: $lamdera$containers$SeqDict$insert$(
								matchId,
								$author$project$Game$GoModel_Game($author$project$Go$initGame),
								model.startedGames)
						});
				} else {
					var actionWithTime = goChange.a;
					var playPop = function () {
						var _v5 = actionWithTime.change;
						switch (_v5.$) {
							case 0:
								return true;
							case 1:
								return true;
							case 2:
								return false;
							case 3:
								return true;
							case 4:
								return true;
							case 5:
								return true;
							default:
								return true;
						}
					}();
					return playPop ? _Utils_update(
						model,
						{
							startedGames: $lamdera$containers$SeqDict$updateIfExists$(
								matchId,
								function (game) {
									if (!game.$) {
										var goModel = game.a;
										return $author$project$Game$GoModel_Game(
											_Utils_update(
												goModel,
												{
													lastPlacedStone: $elm$core$Maybe$Just(time)
												}));
									} else {
										return game;
									}
								},
								model.startedGames)
						}) : model;
				}
			case 0:
				return model;
			case 1:
				return model;
			case 3:
				var matchId = gameChange.a;
				var wordSpellinGameChange = gameChange.b;
				if (!wordSpellinGameChange.$) {
					var serverTime = wordSpellinGameChange.a;
					var setup = wordSpellinGameChange.b;
					return _Utils_update(
						model,
						{
							startedGames: $lamdera$containers$SeqDict$insert$(
								matchId,
								$author$project$Game$WordSpellingGame_Game(
									$author$project$WordSpellingGame$initGame$(
										serverTime,
										currentUserId,
										setup,
										$author$project$WordSpellingGame$initShared(setup))),
								model.startedGames)
						});
				} else {
					var action = wordSpellinGameChange.a;
					var _v7 = action.change;
					if (!_v7.$) {
						var placedWord = _v7.a;
						return _Utils_update(
							model,
							{
								startedGames: $lamdera$containers$SeqDict$updateIfExists$(
									matchId,
									function (game) {
										if (game.$ === 1) {
											var gameData = game.a;
											return $author$project$Game$WordSpellingGame_Game(
												_Utils_update(
													gameData,
													{
														lastWordPlaced: $elm$core$Maybe$Just(
															{
																letterCount: $mgold$elm_nonempty_list$List$Nonempty$length(placedWord.letters),
																time: time
															})
													}));
										} else {
											return game;
										}
									},
									model.startedGames)
							});
					} else {
						return model;
					}
				}
			default:
				var matchId = gameChange.a;
				var sheepChange = gameChange.b;
				if (!sheepChange.$) {
					var setup = sheepChange.b;
					return _Utils_update(
						model,
						{
							startedGames: $lamdera$containers$SeqDict$insert$(
								matchId,
								$author$project$Game$SheepGame_Game(
									$author$project$SheepGame$initGame$(localUser, setup, $author$project$SheepGame$initShared)),
								model.startedGames)
						});
				} else {
					return model;
				}
		}
	}();
	if ((gameChange.$ === 4) && (gameChange.b.$ === 1)) {
		var matchId = gameChange.a;
		var action = gameChange.b.a;
		var _v1 = action.change;
		if (_v1.$ === 6) {
			var count = _v1.a;
			return $elm$core$Tuple$mapFirst$(
				$elm$core$Maybe$Just,
				$author$project$Game$sheepGameQuestionRevealed$(
					matchId,
					$author$project$Id$toInt(count),
					updated));
		} else {
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(updated),
				$elm$core$Maybe$Nothing);
		}
	} else {
		return _Utils_Tuple2(
			$elm$core$Maybe$Just(updated),
			$elm$core$Maybe$Nothing);
	}
};
var $author$project$Game$gameChangeFromServer = F4($author$project$Game$gameChangeFromServer$);
var $author$project$RecoveryLogin$IncorrectPassword = {$: 2};
var $author$project$RecoveryLogin$incorrectPassword = function (_v0) {
	var model = _v0;
	return _Utils_update(
		model,
		{submitStatus: $author$project$RecoveryLogin$IncorrectPassword});
};
var $author$project$TextEditor$inputId = $lamdera$program_test$Effect$Browser$Dom$id('textEditor_input');
var $author$project$LoginForm$NotValid = 1;
var $author$project$LoginForm$invalidCode$ = function (loginCode, loginForm) {
	switch (loginForm.$) {
		case 0:
			return loginForm;
		case 1:
			var enterLoginCode = loginForm.a;
			return $author$project$LoginForm$EnterLoginCode(
				_Utils_update(
					enterLoginCode,
					{
						attempts: $lamdera$containers$SeqDict$insert$(loginCode, 1, enterLoginCode.attempts)
					}));
		case 2:
			var enterTwoFactorCode = loginForm.a;
			return $author$project$LoginForm$EnterTwoFactorCode(
				_Utils_update(
					enterTwoFactorCode,
					{
						attemptCount: enterTwoFactorCode.attemptCount + 1,
						attempts: $lamdera$containers$SeqDict$insert$(loginCode, 1, enterTwoFactorCode.attempts)
					}));
		default:
			return loginForm;
	}
};
var $author$project$LoginForm$invalidCode = F2($author$project$LoginForm$invalidCode$);
var $author$project$FrontendExtra$isSameSlackConversation$ = function (a, b) {
	var _v0 = _Utils_Tuple2(a, b);
	if (!_v0.a.$) {
		if (!_v0.b.$) {
			var a2 = _v0.a.a;
			var b2 = _v0.b.a;
			return _Utils_eq(a2.teamId, b2.teamId) && _Utils_eq(a2.channelId, b2.channelId);
		} else {
			return false;
		}
	} else {
		if (_v0.b.$ === 1) {
			var a2 = _v0.a.a;
			var b2 = _v0.b.a;
			return _Utils_eq(a2.channelId, b2.channelId);
		} else {
			return false;
		}
	}
};
var $author$project$FrontendExtra$isSameSlackConversation = F2($author$project$FrontendExtra$isSameSlackConversation$);
var $author$project$FrontendExtra$logout = function (model) {
	var _v0 = model.loginStatus;
	if (!_v0.$) {
		var model2 = _Utils_update(
			model,
			{
				loginStatus: $author$project$Types$NotLoggedIn(
					{loginForm: $elm$core$Maybe$Nothing, recoveryLogin: $author$project$RecoveryLogin$init, textInputFocus: $elm$core$Maybe$Nothing, useInviteAfterLoggedIn: $elm$core$Maybe$Nothing})
			});
		var _v1 = $author$project$Route$requiresLogin(model2.route) ? $author$project$FrontendExtra$routePush$(
			model2,
			$author$project$Route$HomePageRoute($elm$core$Maybe$Nothing)) : _Utils_Tuple2(model2, $lamdera$program_test$Effect$Command$none);
		var model3 = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			model3,
			$lamdera$program_test$Effect$Command$batch(
				_List_fromArray(
					[
						cmd,
						$author$project$Ports$clearBrowserStorage,
						$author$project$Ports$setAppBadge(0)
					])));
	} else {
		return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
	}
};
var $author$project$Frontend$messagesNeedingDecryption = function (localChange) {
	if ((localChange.$ === 73) && (localChange.b.$ === 1)) {
		var id = localChange.a;
		var conversation = localChange.b.a;
		var _v1 = _Utils_ap(
			$elm$core$List$map$(
				function (_v2) {
					var messageId = _v2.a;
					var content = _v2.b;
					return _Utils_Tuple2(
						$author$project$Id$NoThreadWithMessage(messageId),
						content);
				},
				$lamdera$containers$SeqDict$toList(conversation.channel)),
			$elm$core$List$concatMap$(
				function (_v3) {
					var threadId = _v3.a;
					var thread = _v3.b;
					return $elm$core$List$map$(
						function (_v4) {
							var messageId = _v4.a;
							var content = _v4.b;
							return _Utils_Tuple2(
								$author$project$Id$ViewThreadWithMessage$(threadId, messageId),
								content);
						},
						$author$project$NonemptyDict$toList(thread));
				},
				$lamdera$containers$SeqDict$toList(conversation.threads)));
		if (!_v1.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var messages = _v1;
			return $elm$core$Maybe$Just(
				{id: id, messages: messages});
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Frontend$messagesNeedingEncryption$ = function (nextRequestId, localChange) {
	_v0$2:
	while (true) {
		switch (localChange.$) {
			case 71:
				if (localChange.b.$ === 1) {
					var conversations = localChange.b.a;
					return $author$project$Frontend$conversationsToEncrypt$(nextRequestId, conversations);
				} else {
					break _v0$2;
				}
			case 76:
				if (localChange.c.$ === 1) {
					var conversations = localChange.c.a;
					return $author$project$Frontend$conversationsToEncrypt$(nextRequestId, conversations);
				} else {
					break _v0$2;
				}
			default:
				break _v0$2;
		}
	}
	return _List_Nil;
};
var $author$project$Frontend$messagesNeedingEncryption = F2($author$project$Frontend$messagesNeedingEncryption$);
var $author$project$LoginForm$needsTwoFactor = function (loginForm) {
	if (loginForm.$ === 1) {
		return $author$project$LoginForm$EnterTwoFactorCode(
			{attemptCount: 0, attempts: $lamdera$containers$SeqDict$empty, code: ''});
	} else {
		return loginForm;
	}
};
var $author$project$LoginForm$needsUserData = $author$project$LoginForm$EnterUserData(
	{
		name: '',
		pressedSubmit: $author$project$LoginForm$NotSubmitted(false)
	});
var $author$project$Frontend$pageLoadedScroll$ = function (toHtmlId, pageRequest, scrollPosition) {
	if (!pageRequest.$) {
		var previousOldestVisibleMessage = pageRequest.a;
		return $author$project$Ports$shiftScrollByElementDelta$(
			$author$project$Pages$Guild$conversationContainerId,
			toHtmlId(previousOldestVisibleMessage));
	} else {
		var firstNewMessage = pageRequest.a;
		var holdInPlace = $author$project$Ports$shiftScrollByElementDelta$(
			$author$project$Pages$Guild$conversationContainerId,
			toHtmlId(
				$author$project$Id$fromInt(
					$author$project$Id$toInt(firstNewMessage) - 1)));
		switch (scrollPosition) {
			case 0:
				return $author$project$Scroll$toBottomOfChannel$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom);
			case 1:
				return holdInPlace;
			case 2:
				return holdInPlace;
			default:
				return holdInPlace;
		}
	}
};
var $author$project$Frontend$pageLoadedScroll = F3($author$project$Frontend$pageLoadedScroll$);
var $author$project$FrontendExtra$playNotificationSoundForDiscordMessage$ = function (senderId, guildOrDmId, threadRouteWithRepliedTo, channel, local, content, model) {
	var _v0 = local.localUser.session.notificationMode;
	switch (_v0) {
		case 0:
			return $lamdera$program_test$Effect$Command$none;
		case 1:
			var threadRouteWithFriends = $author$project$Route$threadRouteWithFriends(
				$author$project$Id$threadRouteWithoutMaybeMessage(threadRouteWithRepliedTo));
			var isMentionedOrRepliedTo = !$lamdera$containers$SeqSet$isEmpty(
				$lamdera$containers$SeqSet$intersect$(
					$lamdera$containers$SeqSet$fromList(
						$lamdera$containers$SeqDict$keys(
							$author$project$LinkedAndOtherDiscordUsers$linkedUsers(local.localUser.discordUsers))),
					$author$project$LocalState$usersMentionedOrRepliedToFrontend$(threadRouteWithRepliedTo, content, channel)));
			var alwaysNotify = function () {
				if (!guildOrDmId.$) {
					var guildId = guildOrDmId.a.guildId;
					return $lamdera$containers$SeqSet$member$(guildId, local.localUser.user.discordNotifyOnAllMessages);
				} else {
					return false;
				}
			}();
			var allUsers = $author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(local.localUser.discordUsers);
			return ((!model.pageHasFocus) && (alwaysNotify || isMentionedOrRepliedTo)) ? $lamdera$program_test$Effect$Command$batch(
				_List_fromArray(
					[
						$author$project$Ports$setFavicon('/favicon-red.ico'),
						function () {
						var _v1 = model.startupData.notificationPermission;
						if (_v1 === 2) {
							return $author$project$Ports$showNotification$(
								$author$project$User$toString$(senderId, allUsers),
								$author$project$RichText$toString$(
									local.localUser.timezone,
									true,
									allUsers,
									$author$project$LocalState$discordChannelMentions$(guildOrDmId, local),
									content),
								_Utils_ap(
									$author$project$Env$domain,
									$author$project$Route$encode(
										function () {
											if (!guildOrDmId.$) {
												var channelId = guildOrDmId.a.channelId;
												var guildId = guildOrDmId.a.guildId;
												var currentUserId = guildOrDmId.a.currentUserId;
												return $author$project$Route$DiscordGuildRoute(
													{
														channelRoute: $author$project$Route$DiscordChannel_ChannelRoute$(channelId, threadRouteWithFriends, $elm$core$Maybe$Nothing),
														channelsVisible: 0,
														currentDiscordUserId: currentUserId,
														guildId: guildId,
														overlay: $elm$core$Maybe$Nothing
													});
											} else {
												var channelId = guildOrDmId.a.channelId;
												var currentUserId = guildOrDmId.a.currentUserId;
												return $author$project$Route$DiscordDmRoute(
													{channelId: channelId, channelsVisible: 0, currentDiscordUserId: currentUserId, overlay: $elm$core$Maybe$Nothing, showMembersTab: 1, tab: $elm$core$Maybe$Nothing, viewingMessage: $elm$core$Maybe$Nothing});
											}
										}())));
						} else {
							return $lamdera$program_test$Effect$Command$none;
						}
					}()
					])) : $lamdera$program_test$Effect$Command$none;
		default:
			return $lamdera$program_test$Effect$Command$none;
	}
};
var $author$project$FrontendExtra$playNotificationSoundForDiscordMessage = F7($author$project$FrontendExtra$playNotificationSoundForDiscordMessage$);
var $author$project$FrontendExtra$playNotificationSoundForSlackMessage$ = function (guildOrDmId, threadRoute, local, content, model) {
	var _v0 = local.localUser.session.notificationMode;
	switch (_v0) {
		case 0:
			return $lamdera$program_test$Effect$Command$none;
		case 1:
			var author = function () {
				if (!guildOrDmId.$) {
					var data = guildOrDmId.a;
					return data.currentUserId;
				} else {
					var data = guildOrDmId.a;
					return data.currentUserId;
				}
			}();
			var recipient = function () {
				if ($lamdera$containers$SeqDict$member$(author, local.localUser.linkedSlackUsers)) {
					return $elm$core$Maybe$Nothing;
				} else {
					if (!guildOrDmId.$) {
						var teamId = guildOrDmId.a.teamId;
						var _v5 = $elmcraft$core_extra$List$Extra$find$(
							function (userId) {
								return $lamdera$containers$SeqDict$member$(userId, local.localUser.linkedSlackUsers);
							},
							$lamdera$containers$SeqSet$toList(
								$author$project$RichText$mentionsUser(content)));
						if (!_v5.$) {
							var mentioned = _v5.a;
							return $elm$core$Maybe$Just(mentioned);
						} else {
							return $lamdera$containers$SeqSet$member$(teamId, local.localUser.user.slackNotifyOnAllMessages) ? $elm$core$List$head(
								$lamdera$containers$SeqDict$keys(
									$lamdera$containers$SeqDict$filter$(
										F2(
											function (_v6, linkedTeamId) {
												return _Utils_eq(linkedTeamId, teamId);
											}),
										local.localUser.linkedSlackUsers))) : $elm$core$Maybe$Nothing;
						}
					} else {
						var channelId = guildOrDmId.a.channelId;
						return $elm$core$Maybe$andThen$(
							function (dmChannel) {
								return $elmcraft$core_extra$List$Extra$find$(
									function (userId) {
										return $lamdera$containers$SeqDict$member$(userId, local.localUser.linkedSlackUsers);
									},
									$author$project$NonemptySet$toList(dmChannel.members));
							},
							$lamdera$containers$SeqDict$get$(channelId, local.slackDmChannels));
					}
				}
			}();
			if (!recipient.$) {
				var currentUserId = recipient.a;
				return model.pageHasFocus ? $lamdera$program_test$Effect$Command$none : $lamdera$program_test$Effect$Command$batch(
					_List_fromArray(
						[
							$author$project$Ports$setFavicon('/favicon-red.ico'),
							function () {
							var _v2 = model.startupData.notificationPermission;
							if (_v2 === 2) {
								return $author$project$Ports$showNotification$(
									$author$project$User$toString$(author, local.localUser.slackUsers),
									$author$project$RichText$toString$(
										local.localUser.timezone,
										true,
										local.localUser.slackUsers,
										$author$project$LocalState$slackChannelMentions$(guildOrDmId, local),
										content),
									_Utils_ap(
										$author$project$Env$domain,
										$author$project$Route$encode(
											function () {
												if (!guildOrDmId.$) {
													var channelId = guildOrDmId.a.channelId;
													var teamId = guildOrDmId.a.teamId;
													return $author$project$Route$SlackWorkspaceRoute(
														{
															channelRoute: $author$project$Route$SlackChannel_ChannelRoute$(
																channelId,
																$author$project$Id$threadRouteWithNoMessage(threadRoute),
																1),
															channelsVisible: 0,
															currentSlackUserId: currentUserId,
															overlay: $elm$core$Maybe$Nothing,
															teamId: teamId
														});
												} else {
													var channelId = guildOrDmId.a.channelId;
													return $author$project$Route$SlackDmRoute(
														{
															channelId: channelId,
															channelsVisible: 0,
															currentSlackUserId: currentUserId,
															overlay: $elm$core$Maybe$Nothing,
															threadRoute: $author$project$Id$threadRouteWithNoMessage(threadRoute)
														});
												}
											}())));
							} else {
								return $lamdera$program_test$Effect$Command$none;
							}
						}()
						]));
			} else {
				return $lamdera$program_test$Effect$Command$none;
			}
		default:
			return $lamdera$program_test$Effect$Command$none;
	}
};
var $author$project$FrontendExtra$playNotificationSoundForSlackMessage = F5($author$project$FrontendExtra$playNotificationSoundForSlackMessage$);
var $author$project$LoginForm$rateLimited = function (loginForm) {
	switch (loginForm.$) {
		case 0:
			var enterEmail = loginForm.a;
			return $author$project$LoginForm$EnterEmail(
				_Utils_update(
					enterEmail,
					{rateLimited: true}));
		case 1:
			var enterLoginCode = loginForm.a;
			return $author$project$LoginForm$EnterEmail(
				{
					email: $author$project$EmailAddress$toString(enterLoginCode.sentTo),
					pressedSubmitEmail: false,
					rateLimited: true,
					showSignupsDisabled: false,
					showUserIsDeleted: false
				});
		case 2:
			return $author$project$LoginForm$EnterEmail(
				{email: '', pressedSubmitEmail: false, rateLimited: true, showSignupsDisabled: false, showUserIsDeleted: false});
		default:
			return loginForm;
	}
};
var $author$project$Frontend$rememberDecryptOldMessagesRequest$ = function (conversation, requests) {
	return _Utils_update(
		requests,
		{
			nextDecryptManyRequestId: $author$project$Id$increment(requests.nextDecryptManyRequestId),
			pendingDecryptedOldMessages: $lamdera$containers$SeqDict$insert$(
				requests.nextDecryptManyRequestId,
				{
					id: conversation.id,
					messages: $elm$core$List$map$($elm$core$Tuple$first, conversation.messages)
				},
				requests.pendingDecryptedOldMessages)
		});
};
var $author$project$Frontend$rememberDecryptOldMessagesRequest = F2($author$project$Frontend$rememberDecryptOldMessagesRequest$);
var $author$project$Call$serverChangeCmd$ = function (change, _v0, local, _v1) {
	switch (change.$) {
		case 0:
			return $lamdera$program_test$Effect$Command$none;
		case 1:
			var connectionId = change.b;
			var _v3 = local.currentRoom;
			if (!_v3.$) {
				var roomId = _v3.a;
				return _Utils_eq(roomId, connectionId.roomId) ? $author$project$Call$toJs(
					$author$project$Call$ToJs_PeerJoined(
						{connectionId: connectionId})) : $lamdera$program_test$Effect$Command$none;
			} else {
				return $lamdera$program_test$Effect$Command$none;
			}
		case 2:
			var connectionId = change.b;
			return $author$project$Call$toJs(
				$author$project$Call$ToJs_PeerLeft(connectionId));
		case 3:
			var connectionId = change.a;
			var remoteCallData = change.b;
			return $author$project$Call$toJs(
				$author$project$Call$ToJs_SetPeerVideoInputEnabled$(connectionId, remoteCallData.videoInputEnabled));
		default:
			return $lamdera$program_test$Effect$Command$none;
	}
};
var $author$project$Call$serverChangeCmd = F4($author$project$Call$serverChangeCmd$);
var $author$project$Ports$set_cursor_position_to_js = _Platform_outgoingPort('set_cursor_position_to_js', $elm$core$Basics$identity);
var $author$project$Ports$setCursorPosition$ = function (htmlId, range) {
	return A3(
		$lamdera$program_test$Effect$Command$sendToJs,
		'set_cursor_position_to_js',
		$author$project$Ports$set_cursor_position_to_js,
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'htmlId',
					$elm$json$Json$Encode$string(
						$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId))),
					_Utils_Tuple2(
					'start',
					$elm$json$Json$Encode$int(range.start)),
					_Utils_Tuple2(
					'end',
					$elm$json$Json$Encode$int(range.end))
				])));
};
var $author$project$Ports$setCursorPosition = F2($author$project$Ports$setCursorPosition$);
var $author$project$LoginForm$signupsDisabled = function (loginForm) {
	switch (loginForm.$) {
		case 0:
			var enterEmail = loginForm.a;
			return $author$project$LoginForm$EnterEmail(
				_Utils_update(
					enterEmail,
					{showSignupsDisabled: true}));
		case 1:
			var enterLoginCode = loginForm.a;
			return $author$project$LoginForm$EnterEmail(
				{
					email: $author$project$EmailAddress$toString(enterLoginCode.sentTo),
					pressedSubmitEmail: false,
					rateLimited: false,
					showSignupsDisabled: true,
					showUserIsDeleted: false
				});
		case 2:
			return $author$project$LoginForm$EnterEmail(
				{email: '', pressedSubmitEmail: false, rateLimited: false, showSignupsDisabled: true, showUserIsDeleted: false});
		default:
			return loginForm;
	}
};
var $lamdera$program_test$Effect$File$Download$string$ = function (name, mime, content) {
	return $lamdera$program_test$Effect$Internal$FileDownloadString(
		{content: content, mimeType: mime, name: name});
};
var $lamdera$program_test$Effect$File$Download$string = F3($lamdera$program_test$Effect$File$Download$string$);
var $author$project$AiChat$updateFromBackend$ = function (msg, model) {
	var responseId = msg.a;
	var result = msg.b;
	var _v1 = $lamdera$containers$SeqDict$get$(responseId, model.pendingResponses);
	if ((!_v1.$) && (!_v1.a.$)) {
		var modelId = _v1.a.a;
		return $author$project$AiChat$saveToLocalStorage(
			_Utils_update(
				model,
				{
					pendingResponses: $lamdera$containers$SeqDict$insert$(
						responseId,
						function () {
							if (!result.$) {
								var aiMessage = result.a;
								var text = function () {
									var _v3 = $elm$core$String$split$(
										$author$project$AiChat$prefixWrapper($author$project$AiChat$botPrefix),
										aiMessage.content);
									if (_v3.b) {
										var aiMessage3 = _v3.a;
										var _v4 = $elm$core$String$split$(
											$author$project$AiChat$prefixWrapper($author$project$AiChat$userPrefix),
											aiMessage3);
										if (_v4.b) {
											var aiMessage4 = _v4.a;
											return aiMessage4;
										} else {
											return aiMessage3;
										}
									} else {
										return aiMessage.content;
									}
								}();
								return $author$project$AiChat$GotResponse$(
									modelId,
									$elm$core$String$replace$('\u005C\u0022', '\u0022', text),
									aiMessage.reasoning,
									aiMessage.cost);
							} else {
								var error = result.a;
								return $author$project$AiChat$GotError$(modelId, error);
							}
						}(),
						model.pendingResponses)
				}));
	} else {
		return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
	}
};
var $author$project$AiChat$updateFromBackend = F2($author$project$AiChat$updateFromBackend$);
var $author$project$Local$updateFromBackend$ = function (userUpdate, maybeChangeId, msg, _v0) {
	var localModel_ = _v0;
	var newModel = A2(userUpdate, msg, localModel_.serverModel);
	var newLocalMsgs = function () {
		if (!maybeChangeId.$) {
			var changeId = maybeChangeId.a;
			return $elm$core$Dict$remove$(
				$author$project$Local$toInt(changeId),
				localModel_.localMsgs);
		} else {
			return localModel_.localMsgs;
		}
	}();
	return {
		counter: localModel_.counter,
		localModel: $elm$core$Dict$foldl$(
			F3(
				function (_v1, localMsg, state) {
					return A2(userUpdate, localMsg.msg, state);
				}),
			newModel,
			newLocalMsgs),
		localMsgs: newLocalMsgs,
		serverModel: newModel
	};
};
var $author$project$Local$updateFromBackend = F4($author$project$Local$updateFromBackend$);
var $author$project$Pages$Admin$ImportBackendFailed = {$: 1};
var $author$project$Pages$Admin$ImportedBackendSuccessfully = {$: 3};
var $lamdera$program_test$Effect$File$Download$bytes$ = function (name, mime, content) {
	return $lamdera$program_test$Effect$Internal$FileDownloadBytes(
		{content: content, mimeType: mime, name: name});
};
var $lamdera$program_test$Effect$File$Download$bytes = F3($lamdera$program_test$Effect$File$Download$bytes$);
var $author$project$Pages$Admin$updateFromBackend$ = function (toFrontend, model) {
	switch (toFrontend.$) {
		case 2:
			var progress = toFrontend.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						exportProgress: $elm$core$Maybe$Just(progress)
					}),
				$lamdera$program_test$Effect$Command$none);
		case 3:
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{exportProgress: $elm$core$Maybe$Nothing}),
				$lamdera$program_test$Effect$Command$none);
		case 4:
			var contents = toFrontend.a;
			var totalBytes = toFrontend.b;
			var chunk = toFrontend.c;
			var chunks = A2(
				$elm$core$List$cons,
				chunk,
				function () {
					var _v2 = model.downloadingBackup;
					if (!_v2.$) {
						var downloading = _v2.a;
						return downloading.chunks;
					} else {
						return _List_Nil;
					}
				}());
			var receivedBytes = $elm$core$List$foldl$(
				F2(
					function (bytes, total) {
						return $elm$bytes$Bytes$width(bytes) + total;
					}),
				0,
				chunks);
			return (_Utils_cmp(receivedBytes, totalBytes) > -1) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{downloadingBackup: $elm$core$Maybe$Nothing}),
				$lamdera$program_test$Effect$File$Download$bytes$(
					function () {
						if (!contents) {
							return 'backend-export.bin';
						} else {
							return 'backend-export-subset.bin';
						}
					}(),
					'application/octet-stream',
					$elm$bytes$Bytes$Encode$encode(
						$elm$bytes$Bytes$Encode$sequence(
							$elm$core$List$map$(
								$elm$bytes$Bytes$Encode$bytes,
								$elm$core$List$reverse(chunks)))))) : _Utils_Tuple2(
				_Utils_update(
					model,
					{
						downloadingBackup: $elm$core$Maybe$Just(
							{chunks: chunks, receivedBytes: receivedBytes, totalBytes: totalBytes})
					}),
				$lamdera$program_test$Effect$Command$none);
		case 1:
			var receivedBytes = toFrontend.a;
			var _v3 = model.importBackendStatus;
			if (_v3.$ === 2) {
				var importing = _v3.a;
				if (_Utils_eq(receivedBytes, importing.sentBytes)) {
					var _v4 = $author$project$Pages$Admin$splitOffChunk$($author$project$Pages$Admin$importBackendChunkSize, importing.remainingBytes);
					var chunk = _v4.a;
					var remainingBytes = _v4.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								importBackendStatus: $author$project$Pages$Admin$ImportingBackend(
									_Utils_update(
										importing,
										{
											remainingBytes: remainingBytes,
											sentBytes: importing.sentBytes + $elm$bytes$Bytes$width(chunk)
										}))
							}),
						$lamdera$program_test$Effect$Lamdera$sendToBackend(
							$author$project$Pages$Admin$ImportBackendChunkRequest$(
								{offset: importing.sentBytes, totalBytes: importing.totalBytes},
								chunk)));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{importBackendStatus: $author$project$Pages$Admin$ImportBackendFailed}),
						$lamdera$program_test$Effect$Command$none);
				}
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		default:
			var result = toFrontend.a;
			if (!result.$) {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{importBackendStatus: $author$project$Pages$Admin$ImportedBackendSuccessfully}),
					$lamdera$program_test$Effect$Command$none);
			} else {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{importBackendStatus: $author$project$Pages$Admin$ImportBackendFailed}),
					$lamdera$program_test$Effect$Command$none);
			}
	}
};
var $author$project$Pages$Admin$updateFromBackend = F2($author$project$Pages$Admin$updateFromBackend$);
var $author$project$TwoFactorAuthentication$TwoFactorComplete = {$: 3};
var $author$project$TwoFactorAuthentication$updateFromBackend$ = function (toFrontend, model) {
	switch (toFrontend.$) {
		case 0:
			var qrCodeUrl = toFrontend.a.qrCodeUrl;
			if (model.$ === 1) {
				return $author$project$TwoFactorAuthentication$TwoFactorSetup(
					{attempts: $lamdera$containers$SeqDict$empty, code: '', qrCodeUrl: qrCodeUrl});
			} else {
				return model;
			}
		case 1:
			var code = toFrontend.a;
			var isSuccessful = toFrontend.b;
			if (model.$ === 2) {
				var data = model.a;
				return isSuccessful ? $author$project$TwoFactorAuthentication$TwoFactorComplete : $author$project$TwoFactorAuthentication$TwoFactorSetup(
					_Utils_update(
						data,
						{
							attempts: $lamdera$containers$SeqDict$insert$(code, 1, data.attempts)
						}));
			} else {
				return model;
			}
		default:
			var code = toFrontend.a;
			var isSuccessful = toFrontend.b;
			if (model.$ === 5) {
				var enabledAt = model.a;
				var data = model.b;
				return isSuccessful ? $author$project$TwoFactorAuthentication$TwoFactorNotStarted : $author$project$TwoFactorAuthentication$TwoFactorDisable$(
					enabledAt,
					_Utils_update(
						data,
						{
							attempts: $lamdera$containers$SeqDict$insert$(code, 1, data.attempts)
						}));
			} else {
				return model;
			}
	}
};
var $author$project$TwoFactorAuthentication$updateFromBackend = F2($author$project$TwoFactorAuthentication$updateFromBackend$);
var $author$project$LoginForm$userIsDeleted = function (loginForm) {
	switch (loginForm.$) {
		case 0:
			var enterEmail = loginForm.a;
			return $author$project$LoginForm$EnterEmail(
				_Utils_update(
					enterEmail,
					{showUserIsDeleted: true}));
		case 1:
			var enterLoginCode = loginForm.a;
			return $author$project$LoginForm$EnterEmail(
				{
					email: $author$project$EmailAddress$toString(enterLoginCode.sentTo),
					pressedSubmitEmail: false,
					rateLimited: false,
					showSignupsDisabled: false,
					showUserIsDeleted: true
				});
		case 2:
			return $author$project$LoginForm$EnterEmail(
				{email: '', pressedSubmitEmail: false, rateLimited: false, showSignupsDisabled: false, showUserIsDeleted: true});
		default:
			return loginForm;
	}
};
var $author$project$Game$wordSpellingScrollPosition$ = function (matchId, model) {
	var _v0 = $lamdera$containers$SeqDict$get$(matchId, model.startedGames);
	if ((!_v0.$) && (_v0.a.$ === 1)) {
		var gameData = _v0.a.a;
		return gameData.scrollPosition;
	} else {
		return 0;
	}
};
var $author$project$Game$wordSpellingScrollPosition = F2($author$project$Game$wordSpellingScrollPosition$);
var $author$project$Frontend$updateLoadedFromBackend$ = function (msg, model) {
	switch (msg.$) {
		case 0:
			var loginType = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{loginType: loginType}),
				$lamdera$program_test$Effect$Command$none);
		case 1:
			var result = msg.a;
			var _v1 = model.loginStatus;
			if (_v1.$ === 1) {
				var notLoggedIn = _v1.a;
				switch (result.$) {
					case 0:
						var loginData = result.a;
						var _v3 = $author$project$FrontendExtra$loadedInitHelper$(model.startupData, model.emojiData, loginData, model);
						var loggedIn = _v3.a;
						var cmdA = _v3.b;
						var _v4 = $author$project$FrontendExtra$routeRequest$(
							$elm$core$Maybe$Just(model.route),
							model.route,
							_Utils_update(
								model,
								{
									loginStatus: $author$project$Types$LoggedIn(loggedIn)
								}));
						var model2 = _v4.a;
						var cmdB = _v4.b;
						return _Utils_Tuple2(
							model2,
							$lamdera$program_test$Effect$Command$batch(
								_List_fromArray(
									[
										cmdA,
										cmdB,
										function () {
										var _v5 = _Utils_Tuple2(model2.route, notLoggedIn.useInviteAfterLoggedIn);
										if ((_v5.a.$ === 3) && (!_v5.b.$)) {
											var _v6 = _v5.a;
											var guildId = _v6.a;
											var inviteLinkId = _v5.b.a;
											return $lamdera$program_test$Effect$Lamdera$sendToBackend(
												$author$project$Types$JoinGuildByInviteRequest$(guildId, inviteLinkId));
										} else {
											return $lamdera$program_test$Effect$Command$none;
										}
									}()
									])));
					case 1:
						var loginCode = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									loginStatus: $author$project$Types$NotLoggedIn(
										_Utils_update(
											notLoggedIn,
											{
												loginForm: function () {
													var _v7 = notLoggedIn.loginForm;
													if (!_v7.$) {
														var loginForm = _v7.a;
														return $elm$core$Maybe$Just(
															$author$project$LoginForm$invalidCode$(loginCode, loginForm));
													} else {
														return $elm$core$Maybe$Nothing;
													}
												}()
											}))
								}),
							$lamdera$program_test$Effect$Command$none);
					case 2:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									loginStatus: $author$project$Types$NotLoggedIn(
										_Utils_update(
											notLoggedIn,
											{
												loginForm: function () {
													var _v8 = notLoggedIn.loginForm;
													if (!_v8.$) {
														var loginForm = _v8.a;
														return $elm$core$Maybe$Just(
															$author$project$LoginForm$needsTwoFactor(loginForm));
													} else {
														return $elm$core$Maybe$Nothing;
													}
												}()
											}))
								}),
							$lamdera$program_test$Effect$Command$none);
					case 3:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									loginStatus: $author$project$Types$NotLoggedIn(
										_Utils_update(
											notLoggedIn,
											{
												loginForm: $elm$core$Maybe$Just($author$project$LoginForm$needsUserData)
											}))
								}),
							$lamdera$program_test$Effect$Command$none);
					case 4:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									loginStatus: $author$project$Types$NotLoggedIn(
										_Utils_update(
											notLoggedIn,
											{
												recoveryLogin: $author$project$RecoveryLogin$incorrectPassword(notLoggedIn.recoveryLogin)
											}))
								}),
							$lamdera$program_test$Effect$Command$none);
					default:
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									loginStatus: $author$project$Types$NotLoggedIn(
										_Utils_update(
											notLoggedIn,
											{
												loginForm: $elm$core$Maybe$map$($author$project$LoginForm$userIsDeleted, notLoggedIn.loginForm)
											}))
								}),
							$lamdera$program_test$Effect$Command$none);
				}
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 4:
			return $author$project$FrontendExtra$logout(model);
		case 5:
			var adminToFrontend = msg.a;
			var _v9 = model.loginStatus;
			if (!_v9.$) {
				var loggedIn = _v9.a;
				var _v10 = $author$project$Pages$Admin$updateFromBackend$(adminToFrontend, loggedIn.admin);
				var newAdmin = _v10.a;
				var cmd = _v10.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							loginStatus: $author$project$Types$LoggedIn(
								_Utils_update(
									loggedIn,
									{admin: newAdmin}))
						}),
					$lamdera$program_test$Effect$Command$map$($author$project$Types$AdminToBackend, $author$project$Types$AdminPageMsg, cmd));
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 2:
			var _v11 = model.loginStatus;
			if (!_v11.$) {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			} else {
				var notLoggedIn = _v11.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							loginStatus: $author$project$Types$NotLoggedIn(
								_Utils_update(
									notLoggedIn,
									{
										loginForm: function () {
											var _v12 = notLoggedIn.loginForm;
											if (!_v12.$) {
												var loginForm = _v12.a;
												return $elm$core$Maybe$Just(
													$author$project$LoginForm$rateLimited(loginForm));
											} else {
												return $elm$core$Maybe$Nothing;
											}
										}()
									}))
						}),
					$lamdera$program_test$Effect$Command$none);
			}
		case 3:
			var _v13 = model.loginStatus;
			if (!_v13.$) {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			} else {
				var notLoggedIn = _v13.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							loginStatus: $author$project$Types$NotLoggedIn(
								_Utils_update(
									notLoggedIn,
									{
										loginForm: function () {
											var _v14 = notLoggedIn.loginForm;
											if (!_v14.$) {
												var loginForm = _v14.a;
												return $elm$core$Maybe$Just(
													$author$project$LoginForm$signupsDisabled(loginForm));
											} else {
												return $elm$core$Maybe$Nothing;
											}
										}()
									}))
						}),
					$lamdera$program_test$Effect$Command$none);
			}
		case 6:
			var changeId = msg.a;
			var localChange = msg.b;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					var userId = $author$project$Local$model(loggedIn.localState).localUser.session.userId;
					var oldMessagesToEncrypt = $author$project$Frontend$messagesNeedingEncryption$(loggedIn.encryptionRequests.nextEncryptManyRequestId, localChange);
					var oldMessagesToDecrypt = $author$project$Frontend$messagesNeedingDecryption(localChange);
					var loadedEncryptedMessages = $author$project$Frontend$encryptedMessagesJustLoaded(localChange);
					var change = $author$project$Types$LocalChange$(userId, localChange);
					var localState = $author$project$Local$updateFromBackend$(
						$author$project$FrontendExtra$changeUpdate,
						$elm$core$Maybe$Just(changeId),
						change,
						loggedIn.localState);
					var local = $author$project$Local$model(localState);
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{
								encryptionRequests: $author$project$Frontend$rememberEncryptManyRequests$(
									oldMessagesToEncrypt,
									function () {
										var _v15 = _Utils_Tuple2(loadedEncryptedMessages, oldMessagesToDecrypt);
										if (!_v15.a.$) {
											var loaded = _v15.a.a;
											return $author$project$Frontend$rememberDecryptManyRequest$(
												{
													messageHashes: $elm$core$List$map$($author$project$Encryption$hash, loaded.messages),
													shiftScrollFrom: loaded.shiftScrollFrom
												},
												loggedIn.encryptionRequests);
										} else {
											if (!_v15.b.$) {
												var _v16 = _v15.a;
												var conversation = _v15.b.a;
												return $author$project$Frontend$rememberDecryptOldMessagesRequest$(conversation, loggedIn.encryptionRequests);
											} else {
												var _v17 = _v15.a;
												var _v18 = _v15.b;
												return loggedIn.encryptionRequests;
											}
										}
									}()),
								games: function () {
									if (((localChange.$ === 57) && (localChange.b.$ === 1)) && (localChange.b.b.$ === 1)) {
										var guildOrDmId = localChange.a;
										var _v20 = localChange.b;
										var matchId = _v20.a;
										return $author$project$Game$routeRequest$(
											model.time,
											local.localUser,
											guildOrDmId,
											matchId,
											$author$project$FrontendExtra$channelGames$(guildOrDmId, local),
											loggedIn.games);
									} else {
										return loggedIn.games;
									}
								}(),
								localState: localState
							}),
						$lamdera$program_test$Effect$Command$batch(
							_List_fromArray(
								[
									$lamdera$program_test$Effect$Command$batch(
									$elm$core$List$map$($author$project$Frontend$encryptConversation, oldMessagesToEncrypt)),
									function () {
									if (!loadedEncryptedMessages.$) {
										var loaded = loadedEncryptedMessages.a;
										return $author$project$Encryption$decryptManyMessages$(loggedIn.encryptionRequests.nextDecryptManyRequestId, loaded.id, loaded.messages);
									} else {
										return $lamdera$program_test$Effect$Command$none;
									}
								}(),
									function () {
									if (!oldMessagesToDecrypt.$) {
										var conversation = oldMessagesToDecrypt.a;
										return $author$project$Frontend$decryptConversation$(loggedIn.encryptionRequests.nextDecryptManyRequestId, conversation);
									} else {
										return $lamdera$program_test$Effect$Command$none;
									}
								}(),
									function () {
									_v23$11:
									while (true) {
										switch (localChange.$) {
											case 57:
												var guildOrDmId = localChange.a;
												var game = localChange.b;
												switch (game.$) {
													case 0:
														return $lamdera$program_test$Effect$Command$none;
													case 1:
														if (game.b.$ === 1) {
															var matchId = game.a;
															var _v25 = $author$project$FrontendExtra$currentGamesTab$(local, model.route);
															if (!_v25.$) {
																var gamesTab = _v25.a;
																return (_Utils_eq(gamesTab.guildOrDmId, guildOrDmId) && _Utils_eq(
																	gamesTab.maybeMatchId,
																	$elm$core$Maybe$Just(matchId))) ? $author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$WordSpellingGame$pastWordsContainerId, $author$project$Types$SetScrollToBottom, 0) : $lamdera$program_test$Effect$Command$none;
															} else {
																return $lamdera$program_test$Effect$Command$none;
															}
														} else {
															var _v26 = game.b;
															return $lamdera$program_test$Effect$Command$none;
														}
													case 2:
														return $lamdera$program_test$Effect$Command$none;
													case 3:
														return $lamdera$program_test$Effect$Command$none;
													default:
														return $lamdera$program_test$Effect$Command$none;
												}
											case 56:
												var callChange = localChange.a;
												switch (callChange.$) {
													case 0:
														return $lamdera$program_test$Effect$Command$none;
													case 1:
														return $lamdera$program_test$Effect$Command$none;
													case 2:
														return $lamdera$program_test$Effect$Command$none;
													case 3:
														return $lamdera$program_test$Effect$Command$none;
													default:
														return $lamdera$program_test$Effect$Command$none;
												}
											case 47:
												if (localChange.a.$ === 2) {
													var _v28 = localChange.a;
													var _v29 = $lamdera$containers$SeqDict$get$(local.localUser.session.userId, local.textEditor.cursorPosition);
													if (!_v29.$) {
														var range = _v29.a;
														return $author$project$Ports$setCursorPosition$($author$project$TextEditor$inputId, range);
													} else {
														return $lamdera$program_test$Effect$Command$none;
													}
												} else {
													break _v23$11;
												}
											case 17:
												if (localChange.c.$ === 1) {
													var guildId = localChange.c.a;
													var _v30 = $lamdera$containers$SeqDict$get$(guildId, local.guilds);
													if (!_v30.$) {
														var guild = _v30.a;
														return $author$project$FrontendExtra$routeReplace$(
															model,
															$author$project$Route$GuildRoute$(
																guildId,
																$author$project$Route$ChannelRoute$(
																	$author$project$LocalState$announcementChannel(guild),
																	$author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1),
																	$elm$core$Maybe$Nothing),
																0,
																$elm$core$Maybe$Nothing));
													} else {
														return $lamdera$program_test$Effect$Command$none;
													}
												} else {
													break _v23$11;
												}
											case 27:
												var viewing = localChange.b;
												switch (viewing.$) {
													case 3:
														var data = viewing.a;
														var _v32 = $author$project$Route$toGuildOrDmId$(userId, model.route);
														if ((((!_v32.$) && (!_v32.a.a.$)) && (!_v32.a.a.a.$)) && (!_v32.a.b.$)) {
															var _v33 = _v32.a;
															var channelId = _v33.a.a.a.channelId;
															var guildId = _v33.a.a.a.guildId;
															var _v34 = _v33.b;
															return (_Utils_eq(data.id.guildId, guildId) && _Utils_eq(data.id.channelId, channelId)) ? $author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn.channelScrollPosition) : $lamdera$program_test$Effect$Command$none;
														} else {
															return $lamdera$program_test$Effect$Command$none;
														}
													case 0:
														var data = viewing.a;
														var _v35 = $author$project$Route$toGuildOrDmId$(userId, model.route);
														if ((((!_v35.$) && (!_v35.a.a.$)) && (_v35.a.a.a.$ === 1)) && (!_v35.a.b.$)) {
															var _v36 = _v35.a;
															var otherUserId = _v36.a.a.a.otherUserId;
															var _v37 = _v36.b;
															return _Utils_eq(data.id.otherUserId, otherUserId) ? $author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn.channelScrollPosition) : $lamdera$program_test$Effect$Command$none;
														} else {
															return $lamdera$program_test$Effect$Command$none;
														}
													case 4:
														var data = viewing.a;
														var _v38 = $author$project$Route$toGuildOrDmId$(userId, model.route);
														if ((((!_v38.$) && (!_v38.a.a.$)) && (!_v38.a.a.a.$)) && (_v38.a.b.$ === 1)) {
															var _v39 = _v38.a;
															var channelId = _v39.a.a.a.channelId;
															var guildId = _v39.a.a.a.guildId;
															var threadIdRoute = _v39.b.a;
															return (_Utils_eq(data.id.guildId, guildId) && (_Utils_eq(data.id.channelId, channelId) && _Utils_eq(data.id.threadId, threadIdRoute))) ? $author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn.channelScrollPosition) : $lamdera$program_test$Effect$Command$none;
														} else {
															return $lamdera$program_test$Effect$Command$none;
														}
													case 1:
														var data = viewing.a;
														var _v40 = $author$project$Route$toGuildOrDmId$(userId, model.route);
														if ((((!_v40.$) && (!_v40.a.a.$)) && (_v40.a.a.a.$ === 1)) && (_v40.a.b.$ === 1)) {
															var _v41 = _v40.a;
															var otherUserId = _v41.a.a.a.otherUserId;
															var threadIdRoute = _v41.b.a;
															return (_Utils_eq(data.id.otherUserId, otherUserId) && _Utils_eq(data.id.threadId, threadIdRoute)) ? $author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn.channelScrollPosition) : $lamdera$program_test$Effect$Command$none;
														} else {
															return $lamdera$program_test$Effect$Command$none;
														}
													case 11:
														return $lamdera$program_test$Effect$Command$none;
													case 5:
														var data = viewing.a;
														var _v42 = $author$project$Route$toGuildOrDmId$(userId, model.route);
														if ((((!_v42.$) && (_v42.a.a.$ === 1)) && (!_v42.a.a.a.$)) && (!_v42.a.b.$)) {
															var _v43 = _v42.a;
															var channelId = _v43.a.a.a.channelId;
															var guildId = _v43.a.a.a.guildId;
															var currentUserId = _v43.a.a.a.currentUserId;
															var _v44 = _v43.b;
															return (_Utils_eq(data.id.currentUserId, currentUserId) && (_Utils_eq(data.id.guildId, guildId) && _Utils_eq(data.id.channelId, channelId))) ? $author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn.channelScrollPosition) : $lamdera$program_test$Effect$Command$none;
														} else {
															return $lamdera$program_test$Effect$Command$none;
														}
													case 6:
														var data = viewing.a;
														var _v45 = $author$project$Route$toGuildOrDmId$(userId, model.route);
														if ((((!_v45.$) && (_v45.a.a.$ === 1)) && (!_v45.a.a.a.$)) && (_v45.a.b.$ === 1)) {
															var _v46 = _v45.a;
															var channelId = _v46.a.a.a.channelId;
															var guildId = _v46.a.a.a.guildId;
															var currentUserId = _v46.a.a.a.currentUserId;
															var threadIdRoute = _v46.b.a;
															return (_Utils_eq(data.id.currentUserId, currentUserId) && (_Utils_eq(data.id.guildId, guildId) && (_Utils_eq(data.id.channelId, channelId) && _Utils_eq(data.id.threadId, threadIdRoute)))) ? $author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn.channelScrollPosition) : $lamdera$program_test$Effect$Command$none;
														} else {
															return $lamdera$program_test$Effect$Command$none;
														}
													case 2:
														var data = viewing.a;
														var _v47 = $author$project$Route$toGuildOrDmId$(userId, model.route);
														if ((((!_v47.$) && (_v47.a.a.$ === 1)) && (_v47.a.a.a.$ === 1)) && (!_v47.a.b.$)) {
															var _v48 = _v47.a;
															var dmRoute = _v48.a.a.a;
															var _v49 = _v48.b;
															return _Utils_eq(data.id.channelId, dmRoute.channelId) ? $author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn.channelScrollPosition) : $lamdera$program_test$Effect$Command$none;
														} else {
															return $lamdera$program_test$Effect$Command$none;
														}
													case 7:
														var data = viewing.a;
														var _v50 = $author$project$Route$toGuildOrDmId$(userId, model.route);
														if ((((!_v50.$) && (_v50.a.a.$ === 2)) && (!_v50.a.a.a.$)) && (!_v50.a.b.$)) {
															var _v51 = _v50.a;
															var routeId = _v51.a.a.a;
															var _v52 = _v51.b;
															return _Utils_eq(data.id, routeId) ? $author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn.channelScrollPosition) : $lamdera$program_test$Effect$Command$none;
														} else {
															return $lamdera$program_test$Effect$Command$none;
														}
													case 8:
														var data = viewing.a;
														var _v53 = $author$project$Route$toGuildOrDmId$(userId, model.route);
														if ((((!_v53.$) && (_v53.a.a.$ === 2)) && (_v53.a.a.a.$ === 1)) && (!_v53.a.b.$)) {
															var _v54 = _v53.a;
															var routeId = _v54.a.a.a;
															var _v55 = _v54.b;
															return _Utils_eq(data.id, routeId) ? $author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn.channelScrollPosition) : $lamdera$program_test$Effect$Command$none;
														} else {
															return $lamdera$program_test$Effect$Command$none;
														}
													case 9:
														var data = viewing.a;
														var _v56 = $author$project$Route$toGuildOrDmId$(userId, model.route);
														if ((((!_v56.$) && (_v56.a.a.$ === 2)) && (!_v56.a.a.a.$)) && (_v56.a.b.$ === 1)) {
															var _v57 = _v56.a;
															var routeId = _v57.a.a.a;
															var threadIdRoute = _v57.b.a;
															return (_Utils_eq(data.id, routeId) && _Utils_eq(data.threadId, threadIdRoute)) ? $author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn.channelScrollPosition) : $lamdera$program_test$Effect$Command$none;
														} else {
															return $lamdera$program_test$Effect$Command$none;
														}
													case 10:
														var data = viewing.a;
														var _v58 = $author$project$Route$toGuildOrDmId$(userId, model.route);
														if ((((!_v58.$) && (_v58.a.a.$ === 2)) && (_v58.a.a.a.$ === 1)) && (_v58.a.b.$ === 1)) {
															var _v59 = _v58.a;
															var routeId = _v59.a.a.a;
															var threadIdRoute = _v59.b.a;
															return (_Utils_eq(data.id, routeId) && _Utils_eq(data.threadId, threadIdRoute)) ? $author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn.channelScrollPosition) : $lamdera$program_test$Effect$Command$none;
														} else {
															return $lamdera$program_test$Effect$Command$none;
														}
													default:
														return $lamdera$program_test$Effect$Command$none;
												}
											case 29:
												if (localChange.c.$ === 1) {
													var pageRequest = localChange.b;
													var messagesLoaded = localChange.c.a;
													return $lamdera$containers$SeqDict$isEmpty(messagesLoaded.messages) ? $lamdera$program_test$Effect$Command$none : $author$project$Frontend$pageLoadedScroll$($author$project$Pages$Guild$channelMessageHtmlId, pageRequest, loggedIn.channelScrollPosition);
												} else {
													break _v23$11;
												}
											case 30:
												if (localChange.d.$ === 1) {
													var pageRequest = localChange.c;
													var messagesLoaded = localChange.d.a;
													return $lamdera$containers$SeqDict$isEmpty(messagesLoaded) ? $lamdera$program_test$Effect$Command$none : $author$project$Frontend$pageLoadedScroll$($author$project$Pages$Guild$threadMessageHtmlId, pageRequest, loggedIn.channelScrollPosition);
												} else {
													break _v23$11;
												}
											case 33:
												if (localChange.c.$ === 1) {
													var pageRequest = localChange.b;
													var messagesLoaded = localChange.c.a;
													return $lamdera$containers$SeqDict$isEmpty(messagesLoaded) ? $lamdera$program_test$Effect$Command$none : $author$project$Frontend$pageLoadedScroll$($author$project$Pages$Guild$channelMessageHtmlId, pageRequest, loggedIn.channelScrollPosition);
												} else {
													break _v23$11;
												}
											case 34:
												if (localChange.d.$ === 1) {
													var pageRequest = localChange.c;
													var messagesLoaded = localChange.d.a;
													return $lamdera$containers$SeqDict$isEmpty(messagesLoaded) ? $lamdera$program_test$Effect$Command$none : $author$project$Frontend$pageLoadedScroll$($author$project$Pages$Guild$threadMessageHtmlId, pageRequest, loggedIn.channelScrollPosition);
												} else {
													break _v23$11;
												}
											case 31:
												if (localChange.c.$ === 1) {
													var pageRequest = localChange.b;
													var messagesLoaded = localChange.c.a;
													return $lamdera$containers$SeqDict$isEmpty(messagesLoaded) ? $lamdera$program_test$Effect$Command$none : $author$project$Frontend$pageLoadedScroll$($author$project$Pages$Guild$channelMessageHtmlId, pageRequest, loggedIn.channelScrollPosition);
												} else {
													break _v23$11;
												}
											case 32:
												if (localChange.d.$ === 1) {
													var pageRequest = localChange.c;
													var messagesLoaded = localChange.d.a;
													return $lamdera$containers$SeqDict$isEmpty(messagesLoaded) ? $lamdera$program_test$Effect$Command$none : $author$project$Frontend$pageLoadedScroll$($author$project$Pages$Guild$threadMessageHtmlId, pageRequest, loggedIn.channelScrollPosition);
												} else {
													break _v23$11;
												}
											default:
												break _v23$11;
										}
									}
									return $lamdera$program_test$Effect$Command$none;
								}(),
									$author$project$Ports$setAppBadge(
									$author$project$GuildColumn$unreadNotificationCount(local))
								])));
				},
				model);
		case 7:
			var change = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					var localState = $author$project$Local$updateFromBackend$($author$project$FrontendExtra$changeUpdate, $elm$core$Maybe$Nothing, change, loggedIn.localState);
					var loggedIn2 = _Utils_update(
						loggedIn,
						{localState: localState});
					var local = $author$project$Local$model(localState);
					var _v60 = function () {
						if (change.$ === 1) {
							var serverChange = change.a;
							_v62$16:
							while (true) {
								switch (serverChange.$) {
									case 61:
										return _Utils_Tuple2(
											loggedIn2,
											function () {
												var _v63 = $lamdera$containers$SeqDict$get$(local.localUser.session.userId, local.textEditor.cursorPosition);
												if (!_v63.$) {
													var range = _v63.a;
													return $author$project$Ports$setCursorPosition$($author$project$TextEditor$inputId, range);
												} else {
													return $lamdera$program_test$Effect$Command$none;
												}
											}());
									case 26:
										if (!serverChange.a.$) {
											var guild = serverChange.a.a.guild;
											var guildId = serverChange.a.a.guildId;
											return _Utils_Tuple2(
												loggedIn2,
												function () {
													var _v64 = model.route;
													if (_v64.$ === 3) {
														var inviteGuildId = _v64.a;
														return _Utils_eq(inviteGuildId, guildId) ? $author$project$FrontendExtra$routeReplace$(
															model,
															$author$project$Route$GuildRoute$(
																guildId,
																$author$project$Route$ChannelRoute$(
																	$author$project$LocalState$announcementChannel(guild),
																	$author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1),
																	$elm$core$Maybe$Nothing),
																0,
																$elm$core$Maybe$Nothing)) : $lamdera$program_test$Effect$Command$none;
													} else {
														return $lamdera$program_test$Effect$Command$none;
													}
												}());
										} else {
											break _v62$16;
										}
									case 0:
										var data = serverChange.a;
										return $author$project$FrontendExtra$handleServerSendMessage$(data.senderId, data.guildOrDmId, data.content, data.threadRoute, local, loggedIn2, model);
									case 107:
										var data = serverChange.a;
										var _v65 = $author$project$Frontend$decryptRepliedTo$(data.id, data.repliedToData, local, loggedIn2);
										var loggedIn3 = _v65.a;
										var decryptRepliedToCmd = _v65.b;
										return _Utils_Tuple2(
											$author$project$FrontendExtra$mapEncryptionRequests$(
												function (requests) {
													return _Utils_update(
														requests,
														{
															nextDecryptionRequestId: $author$project$Id$increment(requests.nextDecryptionRequestId),
															pendingDecryptedMessages: $lamdera$containers$SeqDict$insert$(
																requests.nextDecryptionRequestId,
																{
																	hash: $author$project$Encryption$hash(data.content),
																	id: data.id,
																	senderId: data.senderId,
																	threadRoute: data.threadRoute
																},
																requests.pendingDecryptedMessages)
														});
												},
												loggedIn3),
											$lamdera$program_test$Effect$Command$batch(
												_List_fromArray(
													[
														$author$project$Encryption$decryptMessage$(loggedIn3.encryptionRequests.nextDecryptionRequestId, data.id, data.content),
														decryptRepliedToCmd
													])));
									case 108:
										var id = serverChange.c;
										var content = serverChange.f;
										return _Utils_Tuple2(
											$author$project$FrontendExtra$mapEncryptionRequests$(
												function (requests) {
													return _Utils_update(
														requests,
														{
															nextDecryptManyRequestId: $author$project$Id$increment(requests.nextDecryptManyRequestId),
															pendingDecryptedManyMessages: $lamdera$containers$SeqDict$insert$(
																requests.nextDecryptManyRequestId,
																{
																	messageHashes: _List_fromArray(
																		[
																			$author$project$Encryption$hash(content)
																		]),
																	shiftScrollFrom: $elm$core$Maybe$Nothing
																},
																requests.pendingDecryptedManyMessages)
														});
												},
												loggedIn2),
											$author$project$Encryption$decryptManyMessages$(
												loggedIn2.encryptionRequests.nextDecryptManyRequestId,
												id,
												_List_fromArray(
													[content])));
									case 15:
										var guildOrDmId = serverChange.b;
										var content = serverChange.d;
										var maybeRepliedTo = serverChange.e;
										var scrollsToBottom = (!_Utils_eq(
											$author$project$Route$toChannelHeaderTab(model.route),
											$elm$core$Maybe$Just($author$project$UserSession$ChannelHeaderTab_Draw))) && (!loggedIn2.channelScrollPosition);
										var isViewingConversation = _Utils_eq(
											$author$project$Route$toGuildOrDmId$(local.localUser.session.userId, model.route),
											$elm$core$Maybe$Just(
												_Utils_Tuple2(
													$author$project$Id$DiscordGuildOrDmId(guildOrDmId),
													$author$project$Id$threadRouteWithoutMaybeMessage(maybeRepliedTo))));
										var helper = F2(
											function (senderId, channel) {
												return $lamdera$program_test$Effect$Command$batch(
													_List_fromArray(
														[
															$author$project$FrontendExtra$playNotificationSoundForDiscordMessage$(senderId, guildOrDmId, maybeRepliedTo, channel, local, content, model),
															scrollsToBottom ? ($author$project$MyUi$isMobile(model) ? $author$project$Scroll$toBottomOfChannelSmooth$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom) : $author$project$Scroll$toBottomOfChannel$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom)) : (isViewingConversation ? $author$project$FrontendExtra$holdScrollOnNewMessage$(
															$author$project$Id$DiscordGuildOrDmId(guildOrDmId),
															$author$project$Id$threadRouteWithoutMaybeMessage(maybeRepliedTo),
															local) : $lamdera$program_test$Effect$Command$none)
														]));
											});
										return _Utils_Tuple2(
											(isViewingConversation && (!scrollsToBottom)) ? _Utils_update(
												loggedIn2,
												{
													channelScrollPosition: function () {
														var _v66 = loggedIn2.channelScrollPosition;
														switch (_v66) {
															case 0:
																return 3;
															case 1:
																return loggedIn2.channelScrollPosition;
															case 2:
																return loggedIn2.channelScrollPosition;
															default:
																return loggedIn2.channelScrollPosition;
														}
													}(),
													newMessagesWhileNotScrolledToBottom: loggedIn2.newMessagesWhileNotScrolledToBottom + 1
												}) : loggedIn2,
											function () {
												if (!guildOrDmId.$) {
													var channelId = guildOrDmId.a.channelId;
													var guildId = guildOrDmId.a.guildId;
													var currentUserId = guildOrDmId.a.currentUserId;
													var _v68 = $author$project$LocalState$getDiscordGuildAndChannel$(guildId, channelId, local);
													if (!_v68.$) {
														var _v69 = _v68.a;
														var channel = _v69.b;
														return A2(helper, currentUserId, channel);
													} else {
														return $lamdera$program_test$Effect$Command$none;
													}
												} else {
													var data = guildOrDmId.a;
													var _v70 = $lamdera$containers$SeqDict$get$(data.channelId, local.discordDmChannels);
													if (!_v70.$) {
														var channel = _v70.a;
														return A2(
															helper,
															data.currentUserId,
															{messages: channel.messages, threads: $lamdera$containers$SeqDict$empty});
													} else {
														return $lamdera$program_test$Effect$Command$none;
													}
												}
											}());
									case 1:
										var guildOrDmId = serverChange.b;
										var threadRoute = serverChange.c;
										var content = serverChange.d;
										var viewedConversation = function () {
											var _v73 = $author$project$Route$toGuildOrDmId$(local.localUser.session.userId, model.route);
											if ((!_v73.$) && (_v73.a.a.$ === 2)) {
												var _v74 = _v73.a;
												var routeId = _v74.a.a;
												var routeThreadRoute = _v74.b;
												return ($author$project$FrontendExtra$isSameSlackConversation$(routeId, guildOrDmId) && _Utils_eq(routeThreadRoute, threadRoute)) ? $elm$core$Maybe$Just(routeId) : $elm$core$Maybe$Nothing;
											} else {
												return $elm$core$Maybe$Nothing;
											}
										}();
										var scrollsToBottom = !loggedIn2.channelScrollPosition;
										if (!viewedConversation.$) {
											var routeId = viewedConversation.a;
											return scrollsToBottom ? _Utils_Tuple2(
												loggedIn2,
												$lamdera$program_test$Effect$Command$batch(
													_List_fromArray(
														[
															$author$project$FrontendExtra$playNotificationSoundForSlackMessage$(guildOrDmId, threadRoute, local, content, model),
															$author$project$MyUi$isMobile(model) ? $author$project$Scroll$toBottomOfChannelSmooth$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom) : $author$project$Scroll$toBottomOfChannel$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom)
														]))) : _Utils_Tuple2(
												_Utils_update(
													loggedIn2,
													{
														channelScrollPosition: function () {
															var _v72 = loggedIn2.channelScrollPosition;
															switch (_v72) {
																case 0:
																	return 3;
																case 1:
																	return loggedIn2.channelScrollPosition;
																case 2:
																	return loggedIn2.channelScrollPosition;
																default:
																	return loggedIn2.channelScrollPosition;
															}
														}(),
														newMessagesWhileNotScrolledToBottom: loggedIn2.newMessagesWhileNotScrolledToBottom + 1
													}),
												$lamdera$program_test$Effect$Command$batch(
													_List_fromArray(
														[
															$author$project$FrontendExtra$playNotificationSoundForSlackMessage$(guildOrDmId, threadRoute, local, content, model),
															$author$project$FrontendExtra$holdScrollOnNewMessage$(
															$author$project$Id$SlackGuildOrDmId(routeId),
															threadRoute,
															local)
														])));
										} else {
											return _Utils_Tuple2(
												loggedIn2,
												$author$project$FrontendExtra$playNotificationSoundForSlackMessage$(guildOrDmId, threadRoute, local, content, model));
										}
									case 75:
										var userId = serverChange.a;
										var threadRoute = serverChange.b;
										var id = _Utils_Tuple2(
											$author$project$Id$GuildOrDmId(
												$author$project$Id$GuildOrDmId_Dm(
													{otherUserId: userId})),
											$author$project$Id$threadRouteWithoutMessage(threadRoute));
										return _Utils_Tuple2(
											loggedIn2,
											_Utils_eq(
												$author$project$Route$toGuildOrDmId$(local.localUser.session.userId, model.route),
												$elm$core$Maybe$Just(id)) ? $author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn2.channelScrollPosition) : $lamdera$program_test$Effect$Command$none);
									case 74:
										var guildId = serverChange.a;
										var channelId = serverChange.b;
										var threadRoute = serverChange.c;
										var id = _Utils_Tuple2(
											$author$project$Id$GuildOrDmId(
												$author$project$Id$GuildOrDmId_Guild(
													{channelId: channelId, guildId: guildId})),
											$author$project$Id$threadRouteWithoutMessage(threadRoute));
										return _Utils_Tuple2(
											loggedIn2,
											_Utils_eq(
												$author$project$Route$toGuildOrDmId$(local.localUser.session.userId, model.route),
												$elm$core$Maybe$Just(id)) ? $author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn2.channelScrollPosition) : $lamdera$program_test$Effect$Command$none);
									case 77:
										var channelId = serverChange.a;
										return _Utils_Tuple2(
											loggedIn2,
											function () {
												var _v75 = $author$project$Route$toGuildOrDmId$(local.localUser.session.userId, model.route);
												if (((!_v75.$) && (_v75.a.a.$ === 1)) && (_v75.a.a.a.$ === 1)) {
													var _v76 = _v75.a;
													var data = _v76.a.a.a;
													return _Utils_eq(channelId, data.channelId) ? $author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn2.channelScrollPosition) : $lamdera$program_test$Effect$Command$none;
												} else {
													return $lamdera$program_test$Effect$Command$none;
												}
											}());
									case 76:
										var guildIdA = serverChange.a;
										var channelIdA = serverChange.b;
										var threadRouteA = serverChange.c;
										return _Utils_Tuple2(
											loggedIn2,
											function () {
												var _v77 = $author$project$Route$toGuildOrDmId$(local.localUser.session.userId, model.route);
												if (((!_v77.$) && (_v77.a.a.$ === 1)) && (!_v77.a.a.a.$)) {
													var _v78 = _v77.a;
													var channelId = _v78.a.a.a.channelId;
													var guildId = _v78.a.a.a.guildId;
													var threadRouteB = _v78.b;
													return (_Utils_eq(guildIdA, guildId) && (_Utils_eq(channelIdA, channelId) && _Utils_eq(
														$author$project$Id$threadRouteWithoutMessage(threadRouteA),
														threadRouteB))) ? $author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn2.channelScrollPosition) : $lamdera$program_test$Effect$Command$none;
												} else {
													return $lamdera$program_test$Effect$Command$none;
												}
											}());
									case 30:
										return _Utils_Tuple2(
											loggedIn2,
											$author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn2.channelScrollPosition));
									case 36:
										return _Utils_Tuple2(
											loggedIn2,
											$author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn2.channelScrollPosition));
									case 37:
										return _Utils_Tuple2(
											loggedIn2,
											$author$project$Scroll$toBottomOfChannelIfAtBottom$($author$project$Pages$Guild$conversationContainerId, $author$project$Types$SetScrollToBottom, loggedIn2.channelScrollPosition));
									case 89:
										var voiceChatChange = serverChange.a;
										return _Utils_Tuple2(
											loggedIn2,
											$author$project$Call$serverChangeCmd$(voiceChatChange, local.localUser.session.userId, local.calls, loggedIn2.voiceChat));
									case 90:
										var guildOrDmId = serverChange.b;
										var gameChange = serverChange.c;
										var _v79 = $author$project$Game$gameChangeFromServer$(
											model.time,
											local.localUser,
											gameChange,
											$lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn2.games));
										var updatedGameModel = _v79.a;
										var maybeScrollTo = _v79.b;
										return _Utils_Tuple2(
											_Utils_update(
												loggedIn2,
												{
													games: $lamdera$containers$SeqDict$update$(
														guildOrDmId,
														function (_v80) {
															return updatedGameModel;
														},
														loggedIn2.games)
												}),
											$lamdera$program_test$Effect$Command$batch(
												_List_fromArray(
													[
														function () {
														if (!maybeScrollTo.$) {
															var scrollTo = maybeScrollTo.a;
															return $author$project$Frontend$scrollElementToTop(scrollTo);
														} else {
															return $lamdera$program_test$Effect$Command$none;
														}
													}(),
														function () {
														if ((gameChange.$ === 3) && (gameChange.b.$ === 1)) {
															var matchId = gameChange.a;
															var _v83 = $author$project$FrontendExtra$currentGamesTab$(local, model.route);
															if (!_v83.$) {
																var gamesTab = _v83.a;
																return (_Utils_eq(gamesTab.guildOrDmId, guildOrDmId) && _Utils_eq(
																	gamesTab.maybeMatchId,
																	$elm$core$Maybe$Just(matchId))) ? $author$project$Scroll$toBottomOfChannelIfAtBottom$(
																	$author$project$WordSpellingGame$pastWordsContainerId,
																	$author$project$Types$SetScrollToBottom,
																	function () {
																		if (!updatedGameModel.$) {
																			var gameModel3 = updatedGameModel.a;
																			return $author$project$Game$wordSpellingScrollPosition$(matchId, gameModel3);
																		} else {
																			return 0;
																		}
																	}()) : $lamdera$program_test$Effect$Command$none;
															} else {
																return $lamdera$program_test$Effect$Command$none;
															}
														} else {
															return $lamdera$program_test$Effect$Command$none;
														}
													}()
													])));
									default:
										break _v62$16;
								}
							}
							return _Utils_Tuple2(loggedIn2, $lamdera$program_test$Effect$Command$none);
						} else {
							return _Utils_Tuple2(loggedIn2, $lamdera$program_test$Effect$Command$none);
						}
					}();
					var loggedIn4 = _v60.a;
					var cmd = _v60.b;
					return _Utils_Tuple2(
						loggedIn4,
						$lamdera$program_test$Effect$Command$batch(
							_List_fromArray(
								[
									cmd,
									$author$project$Ports$setAppBadge(
									$author$project$GuildColumn$unreadNotificationCount(local))
								])));
				},
				model);
		case 8:
			var toFrontend2 = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{
								twoFactor: $author$project$TwoFactorAuthentication$updateFromBackend$(toFrontend2, loggedIn.twoFactor)
							}),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 9:
			var aiChatToFrontend = msg.a;
			var _v85 = $author$project$AiChat$updateFromBackend$(aiChatToFrontend, model.aiChatModel);
			var newAiChatModel = _v85.a;
			var cmd = _v85.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{aiChatModel: newAiChatModel}),
				$lamdera$program_test$Effect$Command$map$($author$project$Types$AiChatToBackend, $author$project$Types$AiChatMsg, cmd));
		case 10:
			var clientId = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{isReloading: true}),
						$lamdera$program_test$Effect$Lamdera$sendToBackend(
							$author$project$Types$ReloadDataRequest(
								$author$project$Frontend$routeToInitialDataRequest(model.route))));
				},
				_Utils_update(
					model,
					{clientId: clientId}));
		case 11:
			var reloadData = msg.a;
			if (!reloadData.$) {
				var loginData = reloadData.a;
				return $author$project$FrontendExtra$updateLoggedIn$(
					function (loggedIn) {
						var local = $author$project$Local$model(loggedIn.localState);
						var localState = $author$project$Local$init(
							$author$project$FrontendExtra$loginDataToLocalState$(
								model.startupData,
								local.localUser.decryptedMessages,
								$author$project$FrontendExtra$encryptedBacklog$(
									$lamdera$containers$SeqSet$fromList(model.startupData.e2eeKeys),
									loginData.dmChannels),
								model.emojiData,
								loginData));
						return _Utils_Tuple2(
							_Utils_update(
								loggedIn,
								{isReloading: false, localState: localState}),
							$author$project$Ports$setAppBadge(
								$author$project$GuildColumn$unreadNotificationCount(
									$author$project$Local$model(localState))));
					},
					model);
			} else {
				return $author$project$FrontendExtra$logout(model);
			}
		case 12:
			var result = msg.a;
			var _v87 = model.loginStatus;
			if (!_v87.$) {
				var loggedIn = _v87.a;
				var _v88 = _Utils_Tuple2(model.route, loggedIn.userOptions);
				if ((_v88.a.$ === 12) && (_v88.b.$ === 1)) {
					var _v89 = _v88.b;
					if (!result.$) {
						return $author$project$FrontendExtra$openUserOptionsAndExpandContainer$(4, model);
					} else {
						if (result.a.$ === 1) {
							var _v91 = result.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										loginStatus: $author$project$Types$LoggedIn(loggedIn)
									}),
								$author$project$FrontendExtra$routeReplace$(
									model,
									$author$project$Route$LinkDiscord(
										$elm$core$Result$Err(3))));
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										loginStatus: $author$project$Types$LoggedIn(loggedIn)
									}),
								$author$project$FrontendExtra$routeReplace$(
									model,
									$author$project$Route$LinkDiscord(
										$elm$core$Result$Err(1))));
						}
					}
				} else {
					return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
				}
			} else {
				return _Utils_Tuple2(model, $lamdera$program_test$Effect$Command$none);
			}
		case 13:
			var result = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						_Utils_update(
							loggedIn,
							{
								userOptions: $elm$core$Maybe$map$(
									function (userOptions) {
										return _Utils_update(
											userOptions,
											{
												linkSlackResult: $elm$core$Maybe$Just(result)
											});
									},
									loggedIn.userOptions)
							}),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
		case 14:
			var imageEditorToFrontend = msg.a;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					if (!imageEditorToFrontend.$) {
						return _Utils_Tuple2(
							_Utils_update(
								loggedIn,
								{profilePictureEditor: $author$project$ImageEditor$init}),
							$lamdera$program_test$Effect$Command$none);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								loggedIn,
								{guildIconEditor: $elm$core$Maybe$Nothing}),
							$lamdera$program_test$Effect$Command$none);
					}
				},
				model);
		case 15:
			var result = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						publicGoMatch: function () {
							if (!result.$) {
								var ok = result.a;
								return $author$project$Types$PublicGoMatch_Loaded$(
									{
										actions: ok.actions,
										cache: $author$project$Go$foldActions$(ok.setup, ok.actions),
										creatorUser: ok.creatorUser,
										joinedUser: ok.joinedUser,
										setup: ok.setup
									},
									$author$project$Go$initGame);
							} else {
								return $author$project$Types$PublicGoMatch_Missing;
							}
						}()
					}),
				$lamdera$program_test$Effect$Command$none);
		case 16:
			var json = msg.a.json;
			var fileName = msg.a.fileName;
			return _Utils_Tuple2(
				model,
				$lamdera$program_test$Effect$File$Download$string$(fileName, 'application/json', json));
		default:
			var guildId = msg.a;
			var result = msg.b;
			return $author$project$FrontendExtra$updateLoggedIn$(
				function (loggedIn) {
					return _Utils_Tuple2(
						$author$project$Pages$Guild$setImportChannelStatus$(
							guildId,
							function () {
								if (!result.$) {
									var encryptedMessages = result.a.encryptedMessages;
									return $author$project$Types$ImportedChannel(
										{encryptedMessages: encryptedMessages});
								} else {
									var error = result.a;
									return $author$project$Types$ImportChannelFailed(error);
								}
							}(),
							$author$project$Local$model(loggedIn.localState),
							loggedIn),
						$lamdera$program_test$Effect$Command$none);
				},
				model);
	}
};
var $author$project$Frontend$updateLoadedFromBackend = F2($author$project$Frontend$updateLoadedFromBackend$);
var $author$project$Frontend$updateFromBackend$ = function (_v0, msg, model) {
	if (!model.$) {
		var loading = model.a;
		switch (msg.$) {
			case 0:
				var loginType = msg.a;
				var result = msg.b;
				if (!result.$) {
					var loginData = result.a;
					return $author$project$Frontend$tryInitLoadedFrontend(
						_Utils_update(
							loading,
							{
								loginStatus: $author$project$Types$LoadSuccess(loginData),
								loginType: loginType
							}));
				} else {
					return $author$project$Frontend$tryInitLoadedFrontend(
						_Utils_update(
							loading,
							{loginStatus: $author$project$Types$LoadError, loginType: loginType}));
				}
			case 10:
				var clientId = msg.a;
				return $author$project$Frontend$tryInitLoadedFrontend(
					_Utils_update(
						loading,
						{
							clientId: $elm$core$Maybe$Just(clientId)
						}));
			case 15:
				var result = msg.a;
				return $author$project$Frontend$tryInitLoadedFrontend(
					_Utils_update(
						loading,
						{
							publicGoMatch: function () {
								if (!result.$) {
									var ok = result.a;
									return $author$project$Types$PublicGoMatch_Loaded$(
										{
											actions: ok.actions,
											cache: $author$project$Go$foldActions$(ok.setup, ok.actions),
											creatorUser: ok.creatorUser,
											joinedUser: ok.joinedUser,
											setup: ok.setup
										},
										$author$project$Go$initGame);
								} else {
									return $author$project$Types$PublicGoMatch_Missing;
								}
							}()
						}));
			default:
				return _Utils_Tuple3(model, $lamdera$program_test$Effect$Command$none, $author$project$Audio$cmdNone);
		}
	} else {
		var loaded = model.a;
		var _v5 = $author$project$Frontend$updateLoadedFromBackend$(
			msg,
			function () {
				var _v6 = loaded.toFrontendLogs;
				if (!_v6.$) {
					var logs = _v6.a;
					return _Utils_update(
						loaded,
						{
							toFrontendLogs: $elm$core$Maybe$Just(
								$elm$core$Array$push$(msg, logs))
						});
				} else {
					return loaded;
				}
			}());
		var loadedNew = _v5.a;
		var cmds = _v5.b;
		return _Utils_Tuple3(
			$author$project$Types$Loaded(loadedNew),
			$lamdera$program_test$Effect$Command$batch(
				_List_fromArray(
					[
						cmds,
						$author$project$Frontend$checkCallPreviewShown$(loaded, loadedNew),
						$author$project$Frontend$checkCallRecordingChange$(loaded, loadedNew)
					])),
			$author$project$Audio$cmdNone);
	}
};
var $author$project$Frontend$updateFromBackend = F3($author$project$Frontend$updateFromBackend$);
var $author$project$Types$GoSpectatorMsg = function (a) {
	return {$: 80, a: a};
};
var $author$project$Pages$Guild$NoDmChannelSelected = {$: 3};
var $author$project$Pages$Guild$SelectedDiscordDmChannel = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Guild$SelectedDmChannel = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Guild$SelectedSlackDmChannel = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$TextEditorMsg = function (a) {
	return {$: 128, a: a};
};
var $author$project$Types$PressedAccountDeletionBanner = {$: 103};
var $author$project$Types$PressedCloseAccountDeletionBanner = {$: 104};
var $author$project$FrontendExtra$accountDeletionBannerId = $lamdera$program_test$Effect$Browser$Dom$id('accountDeletionBanner');
var $author$project$Ui$alignRight = $author$project$Internal$Model2$classWith$($author$project$Internal$Flag$xAlign, $author$project$Internal$Style2$classes.alignRight);
var $author$project$Ui$alignTop = $author$project$Internal$Model2$classWith$($author$project$Internal$Flag$yAlign, $author$project$Internal$Style2$classes.alignTop);
var $author$project$Ui$borderColor = function (color) {
	return $author$project$Internal$Model2$styleWith$(
		$author$project$Internal$Flag$skip,
		'border-color',
		$author$project$Internal$Style2$color(color));
};
var $author$project$Ui$borderWith = function (options) {
	return $author$project$Internal$Model2$style$(
		'border-width',
		($elm$core$String$fromInt(options.top) + 'px ') + (($elm$core$String$fromInt(options.right) + 'px ') + (($elm$core$String$fromInt(options.bottom) + 'px ') + ($elm$core$String$fromInt(options.left) + 'px'))));
};
var $author$project$MyUi$deleteButtonBackground = $author$project$Ui$rgb$(180, 50, 40);
var $author$project$MyUi$deleteButtonBorder = $author$project$Ui$rgb$(179, 67, 59);
var $author$project$MyUi$deleteButtonFont = $author$project$Ui$rgb$(255, 240, 250);
var $elm$html$Html$Attributes$title = _VirtualDom_attribute('title');
var $author$project$MyUi$hoverText = function (text) {
	return $author$project$Ui$htmlAttribute(
		$elm$html$Html$Attributes$title(text));
};
var $author$project$Ui$paddingWith = function (pad) {
	return $author$project$Internal$Model2$style$(
		'padding',
		($elm$core$String$fromInt(pad.top) + 'px ') + (($elm$core$String$fromInt(pad.right) + 'px ') + (($elm$core$String$fromInt(pad.bottom) + 'px ') + ($elm$core$String$fromInt(pad.left) + 'px'))));
};
var $author$project$Ui$Shrink = {$: 2};
var $author$project$Ui$shrink = $author$project$Ui$Shrink;
var $ianmackenzie$elm_units$Quantity$abs = function (_v0) {
	var value = _v0;
	return $elm$core$Basics$abs(value);
};
var $ianmackenzie$elm_units$Duration$inDays = function (duration) {
	return $ianmackenzie$elm_units$Duration$inSeconds(duration) / $ianmackenzie$elm_units$Constants$day;
};
var $ianmackenzie$elm_units$Duration$inHours = function (duration) {
	return $ianmackenzie$elm_units$Duration$inSeconds(duration) / $ianmackenzie$elm_units$Constants$hour;
};
var $ianmackenzie$elm_units$Duration$inMinutes = function (duration) {
	return $ianmackenzie$elm_units$Duration$inSeconds(duration) / 60;
};
var $ianmackenzie$elm_units$Duration$inWeeks = function (duration) {
	return $ianmackenzie$elm_units$Duration$inSeconds(duration) / $ianmackenzie$elm_units$Constants$week;
};
var $author$project$MyUi$dropSuffix$ = function (suffix, string) {
	return A2($elm$core$String$endsWith, suffix, string) ? $elm$core$String$dropRight$(
		$elm$core$String$length(suffix),
		string) : string;
};
var $author$project$MyUi$dropSuffix = F2($author$project$MyUi$dropSuffix$);
var $myrho$elm_round$Round$addSign$ = function (signed, str) {
	var isNotZero = $elm$core$List$any$(
		function (c) {
			return (c !== '0') && (c !== '.');
		},
		$elm$core$String$toList(str));
	return _Utils_ap(
		(signed && isNotZero) ? '-' : '',
		str);
};
var $myrho$elm_round$Round$addSign = F2($myrho$elm_round$Round$addSign$);
var $myrho$elm_round$Round$increaseNum = function (_v0) {
	var head = _v0.a;
	var tail = _v0.b;
	if (head === '9') {
		var _v1 = $elm$core$String$uncons(tail);
		if (_v1.$ === 1) {
			return '01';
		} else {
			var headtail = _v1.a;
			return A2(
				$elm$core$String$cons,
				'0',
				$myrho$elm_round$Round$increaseNum(headtail));
		}
	} else {
		var c = $elm$core$Char$toCode(head);
		return ((c >= 48) && (c < 57)) ? A2(
			$elm$core$String$cons,
			$elm$core$Char$fromCode(c + 1),
			tail) : '0';
	}
};
var $elm$core$String$padRight$ = function (n, _char, string) {
	return _Utils_ap(
		string,
		$elm$core$String$repeat$(
			n - $elm$core$String$length(string),
			$elm$core$String$fromChar(_char)));
};
var $elm$core$String$padRight = F3($elm$core$String$padRight$);
var $elm$core$String$reverse = _String_reverse;
var $myrho$elm_round$Round$splitComma = function (str) {
	var _v0 = $elm$core$String$split$('.', str);
	if (_v0.b) {
		if (_v0.b.b) {
			var before = _v0.a;
			var _v1 = _v0.b;
			var after = _v1.a;
			return _Utils_Tuple2(before, after);
		} else {
			var before = _v0.a;
			return _Utils_Tuple2(before, '0');
		}
	} else {
		return _Utils_Tuple2('0', '0');
	}
};
var $myrho$elm_round$Round$toDecimal = function (fl) {
	var _v0 = $elm$core$String$split$(
		'e',
		$elm$core$String$fromFloat(
			$elm$core$Basics$abs(fl)));
	if (_v0.b) {
		if (_v0.b.b) {
			var num = _v0.a;
			var _v1 = _v0.b;
			var exp = _v1.a;
			var e = $elm$core$Maybe$withDefault$(
				0,
				$elm$core$String$toInt(
					A2($elm$core$String$startsWith, '+', exp) ? $elm$core$String$dropLeft$(1, exp) : exp));
			var _v2 = $myrho$elm_round$Round$splitComma(num);
			var before = _v2.a;
			var after = _v2.b;
			var total = _Utils_ap(before, after);
			var zeroed = (e < 0) ? $elm$core$Maybe$withDefault$(
				'0',
				$elm$core$Maybe$map$(
					function (_v3) {
						var a = _v3.a;
						var b = _v3.b;
						return a + ('.' + b);
					},
					$elm$core$Maybe$map$(
						$elm$core$Tuple$mapFirst($elm$core$String$fromChar),
						$elm$core$String$uncons(
							_Utils_ap(
								$elm$core$String$repeat$(
									$elm$core$Basics$abs(e),
									'0'),
								total))))) : $elm$core$String$padRight$(e + 1, '0', total);
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				zeroed);
		} else {
			var num = _v0.a;
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				num);
		}
	} else {
		return '';
	}
};
var $myrho$elm_round$Round$roundFun$ = function (functor, s, fl) {
	if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
		return $elm$core$String$fromFloat(fl);
	} else {
		var signed = fl < 0;
		var _v0 = $myrho$elm_round$Round$splitComma(
			$myrho$elm_round$Round$toDecimal(
				$elm$core$Basics$abs(fl)));
		var before = _v0.a;
		var after = _v0.b;
		var r = $elm$core$String$length(before) + s;
		var normalized = _Utils_ap(
			$elm$core$String$repeat$((-r) + 1, '0'),
			$elm$core$String$padRight$(
				r,
				'0',
				_Utils_ap(before, after)));
		var totalLen = $elm$core$String$length(normalized);
		var roundDigitIndex = $elm$core$Basics$max$(1, r);
		var increase = A2(
			functor,
			signed,
			A3($elm$core$String$slice, roundDigitIndex, totalLen, normalized));
		var remains = A3($elm$core$String$slice, 0, roundDigitIndex, normalized);
		var num = increase ? $elm$core$String$reverse(
			$elm$core$Maybe$withDefault$(
				'1',
				$elm$core$Maybe$map$(
					$myrho$elm_round$Round$increaseNum,
					$elm$core$String$uncons(
						$elm$core$String$reverse(remains))))) : remains;
		var numLen = $elm$core$String$length(num);
		var numZeroed = (num === '0') ? num : ((s <= 0) ? _Utils_ap(
			num,
			$elm$core$String$repeat$(
				$elm$core$Basics$abs(s),
				'0')) : ((_Utils_cmp(
			s,
			$elm$core$String$length(after)) < 0) ? (A3($elm$core$String$slice, 0, numLen - s, num) + ('.' + A3($elm$core$String$slice, numLen - s, numLen, num))) : _Utils_ap(
			before + '.',
			$elm$core$String$padRight$(s, '0', after))));
		return $myrho$elm_round$Round$addSign$(signed, numZeroed);
	}
};
var $myrho$elm_round$Round$roundFun = F3($myrho$elm_round$Round$roundFun$);
var $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _v0 = $elm$core$String$uncons(str);
			if (_v0.$ === 1) {
				return false;
			} else {
				if ('5' === _v0.a.a) {
					if (_v0.a.b === '') {
						var _v1 = _v0.a;
						return !signed;
					} else {
						var _v2 = _v0.a;
						return true;
					}
				} else {
					var _v3 = _v0.a;
					var _int = _v3.a;
					return function (i) {
						return ((i > 53) && signed) || ((i >= 53) && (!signed));
					}(
						$elm$core$Char$toCode(_int));
				}
			}
		}));
var $author$project$MyUi$removeTrailing0s$ = function (decimalPoints, value) {
	var _v0 = $elm$core$String$split$(
		'.',
		A2($myrho$elm_round$Round$round, decimalPoints, value));
	_v0$2:
	while (true) {
		if (_v0.b) {
			if (_v0.b.b) {
				if (!_v0.b.b.b) {
					var nonDecimal = _v0.a;
					var _v1 = _v0.b;
					var decimal = _v1.a;
					return (decimalPoints > 0) ? $author$project$MyUi$dropSuffix$(
						'.',
						nonDecimal + ('.' + A3(
							$elm$core$String$foldr,
							F2(
								function (_char, _v2) {
									var text = _v2.a;
									var reachedNonZero = _v2.b;
									return (reachedNonZero || (_char !== '0')) ? _Utils_Tuple2(text, true) : _Utils_Tuple2(
										$elm$core$String$dropRight$(1, text),
										false);
								}),
							_Utils_Tuple2(decimal, false),
							decimal).a)) : nonDecimal;
				} else {
					break _v0$2;
				}
			} else {
				var nonDecimal = _v0.a;
				return nonDecimal;
			}
		} else {
			break _v0$2;
		}
	}
	return '0';
};
var $author$project$MyUi$removeTrailing0s = F2($author$project$MyUi$removeTrailing0s$);
var $author$project$MyUi$timeElapsed$ = function (now, event) {
	var suffix = (_Utils_cmp(
		$elm$time$Time$posixToMillis(now),
		$elm$time$Time$posixToMillis(event)) < 1) ? '' : ' ago';
	var difference = $ianmackenzie$elm_units$Quantity$abs(
		$ianmackenzie$elm_units$Duration$from$(event, now));
	var months = $elm$core$Basics$floor(
		$ianmackenzie$elm_units$Duration$inDays(difference) / 30);
	if (months >= 2) {
		return $elm$core$String$fromInt(months) + ('\u00A0months' + suffix);
	} else {
		var weeks = $elm$core$Basics$floor(
			$ianmackenzie$elm_units$Duration$inWeeks(difference));
		if (weeks >= 2) {
			return $elm$core$String$fromInt(weeks) + ('\u00A0weeks' + suffix);
		} else {
			var days = $elm$core$Basics$round(
				$ianmackenzie$elm_units$Duration$inDays(difference));
			if (days > 1) {
				return $elm$core$String$fromInt(days) + ('\u00A0days' + suffix);
			} else {
				var hours = $elm$core$Basics$floor(
					$ianmackenzie$elm_units$Duration$inHours(difference));
				if (hours > 22) {
					return '1\u00A0day' + suffix;
				} else {
					if (hours > 6) {
						return $elm$core$String$fromInt(hours) + ('\u00A0hours' + suffix);
					} else {
						if ($ianmackenzie$elm_units$Duration$inHours(difference) >= 1.2) {
							return $author$project$MyUi$removeTrailing0s$(
								1,
								$ianmackenzie$elm_units$Duration$inHours(difference)) + ('\u00A0hours' + suffix);
						} else {
							var minutes = $elm$core$Basics$round(
								$ianmackenzie$elm_units$Duration$inMinutes(difference));
							return (minutes > 1) ? ($elm$core$String$fromInt(minutes) + ('\u00A0minutes' + suffix)) : ('1\u00A0minute' + suffix);
						}
					}
				}
			}
		}
	}
};
var $author$project$MyUi$timeElapsed = F2($author$project$MyUi$timeElapsed$);
var $author$project$Icons$x = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$width('24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M6 18 18 6M6 6l12 12')
				]),
			_List_Nil)
		]));
var $author$project$FrontendExtra$accountDeletionBanner$ = function (safeAreaInsetTop, time, deleteAt) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$alignTop,
				$author$project$Ui$background($author$project$MyUi$deleteButtonBackground),
				$author$project$Ui$Font$color($author$project$MyUi$deleteButtonFont),
				$author$project$Ui$borderColor($author$project$MyUi$deleteButtonBorder),
				$author$project$Ui$borderWith(
				{bottom: 1, left: 0, right: 0, top: 1}),
				$author$project$Ui$paddingWith(
				{bottom: 0, left: 0, right: 0, top: safeAreaInsetTop})
			]),
		_List_fromArray(
			[
				$author$project$MyUi$elButton$(
				$author$project$FrontendExtra$accountDeletionBannerId,
				$author$project$Types$PressedAccountDeletionBanner,
				_List_fromArray(
					[
						$author$project$Ui$paddingXY$(16, 10),
						$author$project$Ui$width($author$project$Ui$shrink)
					]),
				$author$project$Ui$text(
					'Your account will be permanently deleted in ' + ($author$project$MyUi$timeElapsed$(time, deleteAt) + '. Press here to cancel.'))),
				$author$project$MyUi$elButton$(
				$lamdera$program_test$Effect$Browser$Dom$id('accountDeletionBanner_close'),
				$author$project$Types$PressedCloseAccountDeletionBanner,
				_List_fromArray(
					[
						$author$project$Ui$width($author$project$Ui$shrink),
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$paddingXY$(16, 0),
						$author$project$MyUi$hoverText('Close'),
						$author$project$Ui$contentCenterY,
						$author$project$Ui$alignRight
					]),
				$author$project$Ui$html($author$project$Icons$x))
			]));
};
var $author$project$FrontendExtra$accountDeletionBanner = F3($author$project$FrontendExtra$accountDeletionBanner$);
var $author$project$Ui$alignBottom = $author$project$Internal$Model2$classWith$($author$project$Internal$Flag$yAlign, $author$project$Internal$Style2$classes.alignBottom);
var $author$project$MyUi$background1 = $author$project$Ui$rgb$(4, 6, 20);
var $author$project$Ui$border = function (options) {
	return $author$project$Internal$Model2$styleWith$(
		$author$project$Internal$Flag$skip,
		'border-width',
		$elm$core$String$fromInt(options) + 'px');
};
var $author$project$Ui$Font$center = $author$project$Internal$Model2$classWith$($author$project$Internal$Flag$fontAlignment, $author$project$Internal$Style2$classes.textCenter);
var $author$project$Ui$centerX = $author$project$Internal$Model2$classWith$($author$project$Internal$Flag$xAlign, $author$project$Internal$Style2$classes.alignCenterX);
var $author$project$Ui$centerY = $author$project$Internal$Model2$classWith$($author$project$Internal$Flag$yAlign, $author$project$Internal$Style2$classes.alignCenterY);
var $author$project$Internal$Model2$AsColumn = 1;
var $author$project$Ui$column$ = function (attrs, children) {
	return $author$project$Internal$Model2$element$(
		$author$project$Internal$Model2$NodeAsDiv,
		1,
		A2(
			$elm$core$List$cons,
			$author$project$Ui$width($author$project$Ui$fill),
			attrs),
		children);
};
var $author$project$Ui$column = F2($author$project$Ui$column$);
var $author$project$MyUi$colorToStyle = function (color) {
	var floatToInt = function (value) {
		return $elm$core$String$fromInt(
			$elm$core$Basics$round(value * 255));
	};
	var _v0 = $avh4$elm_color$Color$toRgba(color);
	var alpha = _v0.alpha;
	var blue = _v0.blue;
	var green = _v0.green;
	var red = _v0.red;
	return 'rgba(' + (floatToInt(red) + (',' + (floatToInt(green) + (',' + (floatToInt(blue) + (',' + ($elm$core$String$fromFloat(alpha) + ')')))))));
};
var $author$project$MyUi$monoFontFace$ = function (weight, fileName) {
	return '\u000A@font-face {\u000A  font-family: \u0027DejaVu Sans Mono\u0027;\u000A  font-style: normal;\u000A  font-weight: ' + ($elm$core$String$fromInt(weight) + (';\u000A  font-stretch: normal;\u000A  font-display: swap;\u000A  src: url(/cacheable/fonts/' + (fileName + ') format(\u0027woff2\u0027);\u000A}')));
};
var $author$project$MyUi$monoFontFace = F2($author$project$MyUi$monoFontFace$);
var $author$project$MyUi$dejavuSansMonoFontFaces = _Utils_ap(
	$author$project$MyUi$monoFontFace$(400, 'DejaVuSansMono.woff2'),
	$author$project$MyUi$monoFontFace$(700, 'DejaVuSansMono-Bold.woff2'));
var $author$project$MyUi$font3 = $author$project$Ui$rgb$(160, 180, 200);
var $author$project$MyUi$guildIconSelectedBorder = $author$project$Ui$rgb$(90, 190, 255);
var $author$project$MyUi$elmSyntaxHighlight = '.elmsh {color: inherit; font: inherit; background: transparent;}\u000A' + ('.elmsh-comm {color: rgb(128,136,150); font-style: italic;}\u000A' + ('.elmsh1 {color: rgb(209,154,102);}\u000A' + ('.elmsh2 {color: rgb(152,195,121);}\u000A' + ('.elmsh3 {color: rgb(198,120,221);}\u000A' + (('.elmsh4 {color: ' + ($author$project$MyUi$colorToStyle($author$project$MyUi$font3) + ';}\u000A')) + (('.elmsh5 {color: ' + ($author$project$MyUi$colorToStyle($author$project$MyUi$guildIconSelectedBorder) + ';}\u000A')) + ('.elmsh6 {color: rgb(229,192,123);}\u000A' + '.elmsh7 {color: rgb(224,108,117);}\u000A')))))));
var $author$project$MyUi$font1 = $author$project$Ui$rgb$(255, 255, 255);
var $author$project$MyUi$fontFace$ = function (format, family, weight, fileName, unicodeRange) {
	return '\u000A@font-face {\u000A  font-family: \u0027' + (family + ('\u0027;\u000A  font-style: normal;\u000A  font-weight: ' + ($elm$core$String$fromInt(weight) + (';\u000A  font-stretch: normal;\u000A  font-display: swap;\u000A  src: url(/cacheable/fonts/' + (fileName + (') format(\u0027' + (format + ('\u0027);\u000A  unicode-range: ' + (unicodeRange + ';\u000A}')))))))));
};
var $author$project$MyUi$fontFace = F5($author$project$MyUi$fontFace$);
var $author$project$MyUi$notoSansFontFaces = function () {
	var latinRange = 'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD';
	var latinExtRange = 'U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF';
	return $elm$core$String$concat(
		A2(
			$elm$core$List$cons,
			$author$project$MyUi$fontFace$('TrueType', 'ascii', 400, 'ascii.ttf', 'U+0000-FFFF'),
			$elm$core$List$map$(
				function (weight) {
					return _Utils_ap(
						$author$project$MyUi$fontFace$(
							'woff2',
							'Noto Sans',
							weight,
							'noto-sans-latin-' + ($elm$core$String$fromInt(weight) + '-normal.woff2'),
							latinRange),
						$author$project$MyUi$fontFace$(
							'woff2',
							'Noto Sans',
							weight,
							'noto-sans-latin-ext-' + ($elm$core$String$fromInt(weight) + '-normal.woff2'),
							latinExtRange));
				},
				_List_fromArray(
					[400, 500, 600, 700]))));
}();
var $author$project$MyUi$selectedTextBackground = $author$project$Ui$rgb$(0, 120, 215);
var $author$project$MyUi$css = A3(
	$elm$html$Html$node,
	'style',
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$MyUi$notoSansFontFaces + ($author$project$MyUi$dejavuSansMonoFontFaces + ('\u000A@font-face {\u000A    font-family: \u0022myemoji\u0022;\u000A    src: local(\u0027Apple Color Emoji\u0027), local(\u0027Android Emoji\u0027), local(\u0027Segoe UI Emoji\u0027), local(\u0027Noto Color Emoji\u0027), local(EmojiSymbols), local(Symbola);\u000A    unicode-range: U+200D, U+20E3, U+2194-2195, U+231A-231B, U+23E9-23EC, U+23F0, U+23F3, U+25FD-25FE, U+2614-2615, U+261D, U+2620, U+2640, U+2642, U+2648-2653, U+267F, U+2693, U+2695-2696, U+26A1, U+26A7, U+26AA-26AB, U+26BD-26BE, U+26C4-26C5, U+26CE, U+26D3-26D4, U+26EA, U+26F2-26F3, U+26F5, U+26F9-26FA, U+26FD, U+2705, U+2708, U+270A-270D, U+2728, U+2744, U+274C, U+274E, U+2753-2755, U+2757, U+2764, U+2795-2797, U+27A1, U+27B0, U+27BF, U+2B1B-2B1C, U+2B50, U+2B55, U+FE0F, U+1F004, U+1F0CF, U+1F18E, U+1F191-1F19A, U+1F1E6-1F1FF, U+1F201, U+1F21A, U+1F22F, U+1F232-1F236, U+1F238-1F23A, U+1F250-1F251, U+1F300-1F320, U+1F32B, U+1F32D-1F335, U+1F337-1F393, U+1F3A0-1F3CC, U+1F3CF-1F3D3, U+1F3E0-1F3F0, U+1F3F3-1F3F4, U+1F3F8-1F43E, U+1F440-1F4FC, U+1F4FF-1F53D, U+1F54B-1F567, U+1F574-1F575, U+1F57A, U+1F590, U+1F595-1F596, U+1F5A4, U+1F5E8, U+1F5FB-1F64F, U+1F680-1F6CC, U+1F6D0-1F6D2, U+1F6D5-1F6D7, U+1F6DC-1F6DF, U+1F6EB-1F6EC, U+1F6F4-1F6FC, U+1F7E0-1F7EB, U+1F7F0, U+1F90C-1F93A, U+1F93C-1F945, U+1F947-1FA7C, U+1FA80-1FAC5, U+1FACE-1FADB, U+1FAE0-1FAE8, U+1FAF0-1FAF8, U+E0062-E0063, U+E0065, U+E0067, U+E006C, U+E006E, U+E0073-E0074, U+E0077, U+E007F;\u000A    size-adjust: 130%;\u000A}\u000Atextarea::selection {\u000A    background-color: ' + ($author$project$MyUi$colorToStyle($author$project$MyUi$selectedTextBackground) + (';\u000A    color: rgba(0,0,0,0);\u000A}\u000Atextarea::-moz-selection {\u000A    background-color: ' + ($author$project$MyUi$colorToStyle($author$project$MyUi$selectedTextBackground) + (';\u000A    color: rgba(0,0,0,0);\u000A}\u000A/* Emoji drawn as pictures keep their characters underneath, for copying. Color emoji\u000A   ignore `color` once selected unless `::selection` sets it too, and setting anything\u000A   there drops the browser\u0027s own highlight, so that is put back with `Highlight`. */\u000A.emoji-characters {\u000A    color: transparent;\u000A}\u000A.emoji-characters::selection {\u000A    background-color: Highlight;\u000A    color: transparent;\u000A}\u000A.emoji-characters::-moz-selection {\u000A    background-color: Highlight;\u000A    color: transparent;\u000A}\u000A.rich-text-input::selection {\u000A    background-color: transparent;\u000A    color: transparent;\u000A}\u000A.rich-text-input::-moz-selection {\u000A    background-color: transparent;\u000A    color: transparent;\u000A}\u000A\u000A/* The homepage previews can\u0027t be scrolled, so their conversations are laid out from the\u000A   bottom rather than scrolled there. Each preview is a whole copy of the app, so several of\u000A   them carry the one conversation container id and only the first could be found to scroll. */\u000A#homePage_preview #conversationContainer {\u000A    justify-content: flex-end;\u000A}\u000A\u000A//https://stackoverflow.com/a/54410301\u000A.disable-scrollbars::-webkit-scrollbar {\u000A  background: transparent;\u000A  width: 0px;\u000A}\u000A.disable-scrollbars {\u000A  scrollbar-width: none;\u000A  -ms-overflow-style: none;\u000A}\u000A\u000Aa:link {\u000A  color: rgb(176,193,255);\u000A  text-decoration: none;\u000A}\u000Aa:hover {\u000A  color: rgb(176,193,255);\u000A  text-decoration: underline;\u000A}\u000Aa:visited {\u000A  color: rgb(206,193,225);\u000A}\u000Ahtml, body {\u000A  overscroll-behavior: none;\u000A}\u000Abody {\u000A  overflow: hidden;\u000A  scrollbar-color: ' + ($author$project$MyUi$colorToStyle($author$project$MyUi$font1) + (' transparent\u000A}\u000A/* elm-ui hides the native focus ring with `.s:focus { outline: none; }` for\u000A   every element it renders. This puts it back for keyboard navigation */\u000A.elm-ui-root .s:focus-visible {\u000A  outline: rgb(96,165,250) solid 2px;\u000A  outline-offset: -2px;\u000A}\u000A.drawing-anchor-select {\u000A  cursor: pointer;\u000A  outline: rgba(0,0,0,0) solid 2px;\u000A}\u000A.drawing-anchor-select:hover {\u000A  outline-color: rgb(96,165,250);\u000A  background-color: rgba(96,165,250,0.3);\u000A}\u000A.emoji-popup,\u000A.custom-emoji-popup-arrow {\u000A  display: none;\u000A  opacity: 0;\u000A}\u000A.emoji-popup-container:hover .emoji-popup {\u000A  display: flex;\u000A  animation: emoji-popup-fade-in 0.2s ease 0.5s forwards;\u000A}\u000A.emoji-popup-container:hover .custom-emoji-popup-arrow {\u000A  display: block;\u000A  animation: emoji-popup-fade-in 0.2s ease 0.5s forwards;\u000A}\u000A/* A long press has already waited, so the popup comes straight in */\u000A.reaction-long-pressed .emoji-popup {\u000A  display: flex;\u000A  animation: emoji-popup-fade-in 0.2s ease forwards;\u000A}\u000A@keyframes emoji-popup-fade-in {\u000A  from { opacity: 0; }\u000A  to { opacity: 1; }\u000A}\u000A/* A section of a sheep game\u0027s results turning up. It waits a moment before sliding into\u000A   place, so that the room has a chance to look up before the answer appears. */\u000A.fade-in {\u000A  animation: fade-in 2s;\u000A}\u000A@keyframes fade-in {\u000A  0% { opacity: 0; transform: translate(0px, -20px); }\u000A  50% { opacity: 0; transform: translate(0px, -20px); }\u000A  100% { opacity: 1; }\u000A}\u000A/* The custom emoji tooltip hangs above its emoji, centred on it. The arrow is a\u000A   sibling of the tooltip rather than a child of it so that it keeps pointing at\u000A   the emoji when the tooltip below slides sideways. */\u000A.custom-emoji-popup {\u000A  position: absolute;\u000A  bottom: calc(100% + 8px);\u000A  left: 50%;\u000A  transform: translateX(-50%);\u000A}\u000A.custom-emoji-popup-arrow {\u000A  position: absolute;\u000A  bottom: calc(100% + 1px);\u000A  left: calc(50% - 8px);\u000A  width: 0;\u000A  height: 0;\u000A}\u000A/* Centred is fine until the emoji is near the edge of the window, where half a\u000A   tooltip hangs off the side of the conversation and gives it a horizontal\u000A   scrollbar. Browsers with anchor positioning slide the tooltip back on screen\u000A   instead of overflowing: position-area centres it on the emoji, and the\u000A   fallbacks line its right edge up with the emoji at the right of the screen, or\u000A   its left edge at the left. position: fixed is what takes it out of the\u000A   conversation\u0027s scrollable area, so nothing it does can scroll the conversation.\u000A   Browsers without anchor positioning keep the centred rules above. */\u000A@supports (anchor-scope: --a) and (position-area: top span-all) {\u000A  .emoji-popup-container {\u000A    anchor-name: --custom-emoji;\u000A    /* Without a scope, every tooltip on the page anchors itself to the last emoji\u000A       in the document rather than to the emoji it belongs to */\u000A    anchor-scope: --custom-emoji;\u000A  }\u000A  .custom-emoji-popup {\u000A    position: fixed;\u000A    position-anchor: --custom-emoji;\u000A    position-area: top span-all;\u000A    justify-self: anchor-center;\u000A    position-try-fallbacks: top span-left, top span-right;\u000A    /* A fixed tooltip is no longer clipped by the conversation, so it has to hide\u000A       itself when its emoji scrolls out of view */\u000A    position-visibility: anchors-visible;\u000A    inset: auto;\u000A    transform: none;\u000A    margin-bottom: 8px;\u000A  }\u000A}\u000A' + $author$project$MyUi$elmSyntaxHighlight)))))))))
		]));
var $author$project$Types$PressedCloseImageInfo = {$: 110};
var $author$project$MyUi$canScroll$ = function (isMobile2, drag) {
	if (isMobile2) {
		if (drag.$ === 2) {
			var dragging = drag.a;
			return !dragging.horizontalStart;
		} else {
			return true;
		}
	} else {
		return true;
	}
};
var $author$project$MyUi$canScroll = F2($author$project$MyUi$canScroll$);
var $author$project$Call$sidebarOffset = function (sidebarMode) {
	if (!sidebarMode.$) {
		var a = sidebarMode.a;
		return a.offset;
	} else {
		var a = sidebarMode.a;
		return a.offset;
	}
};
var $author$project$Call$conversationOffset$ = function (sidebarMode, model) {
	return $elm$core$Basics$round(
		$elm$core$Basics$clamp$(
			0,
			1,
			$author$project$Call$sidebarOffset(sidebarMode) - 1) * $author$project$Coord$xRaw(model.windowSize));
};
var $author$project$Call$conversationOffset = F2($author$project$Call$conversationOffset$);
var $author$project$Internal$Model2$InFront = 4;
var $author$project$Internal$Model2$nearby$ = function (loc, el) {
	return {
		attr: {
			additionalInheritance: $author$project$Internal$BitField$none,
			attrs: _List_Nil,
			_class: $elm$core$Maybe$Nothing,
			nearby: $elm$core$Maybe$Just(
				_Utils_Tuple2(loc, el)),
			node: $author$project$Internal$Model2$NodeAsDiv,
			styles: $author$project$Internal$Model2$noStyles
		},
		flag: $author$project$Internal$Flag$skip
	};
};
var $author$project$Internal$Model2$nearby = F2($author$project$Internal$Model2$nearby$);
var $author$project$Ui$inFront = function (element) {
	return $author$project$Internal$Model2$nearby$(4, element);
};
var $author$project$Ui$move = function (pos) {
	return $author$project$Internal$Model2$style$(
		'translate',
		($elm$core$String$fromInt(pos.x) + 'px ') + (($elm$core$String$fromInt(pos.y) + 'px ') + ($elm$core$String$fromInt(pos.z) + 'px')));
};
var $author$project$MyUi$bounceScroll = function (isMobile2) {
	return $author$project$Ui$attrIf$(
		isMobile2,
		$author$project$Ui$inFront(
			$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$height(
						$author$project$Ui$px(1)),
						$author$project$Ui$alignBottom,
						$author$project$Ui$move(
						{x: 0, y: 1, z: 0})
					]),
				$author$project$Ui$none)));
};
var $author$project$MyUi$background2 = $author$project$Ui$rgb$(28, 35, 60);
var $author$project$Ui$behindContent = function (element) {
	return $author$project$Internal$Model2$nearby$(5, element);
};
var $author$project$Ui$Font$bold = $author$project$Internal$Model2$style$('font-weight', '700');
var $author$project$Ui$clipWithEllipsis = $author$project$Internal$Model2$classWith$($author$project$Internal$Flag$fontEllipsis, $author$project$Internal$Style2$classes.ellipses);
var $author$project$Ui$alignLeft = $author$project$Internal$Model2$classWith$($author$project$Internal$Flag$xAlign, $author$project$Internal$Style2$classes.alignLeft);
var $author$project$MyUi$guildColumnBorder = $author$project$Ui$rgb$(59, 89, 120);
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$line = $elm$svg$Svg$trustedNode('line');
var $author$project$MyUi$noPointerEvents = $author$project$MyUi$htmlStyle$('pointer-events', 'none');
var $author$project$GuildIcon$size = 50;
var $elm$svg$Svg$Attributes$style = _VirtualDom_attribute('style');
var $elm$svg$Svg$Attributes$x1 = _VirtualDom_attribute('x1');
var $elm$svg$Svg$Attributes$x2 = _VirtualDom_attribute('x2');
var $elm$svg$Svg$Attributes$y1 = _VirtualDom_attribute('y1');
var $elm$svg$Svg$Attributes$y2 = _VirtualDom_attribute('y2');
var $author$project$GuildIcon$columnBorderView = function (safeAreaInsetTop) {
	var x = $elm$core$String$fromFloat($author$project$GuildIcon$size - 0.5);
	var topLeftRadius = (safeAreaInsetTop / 2) | 0;
	var radius = $elm$core$String$fromFloat(topLeftRadius - 0.5);
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$MyUi$noPointerEvents,
				(safeAreaInsetTop > 0) ? $author$project$Ui$inFront(
				$author$project$Ui$html(
					A2(
						$elm$svg$Svg$svg,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$width('100%'),
								$elm$svg$Svg$Attributes$height('1'),
								$elm$svg$Svg$Attributes$style('display:block;position:absolute;left:0;top:0')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$line,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$x1(
										$elm$core$String$fromFloat(
											$elm$core$Basics$max$(0.5, topLeftRadius))),
										$elm$svg$Svg$Attributes$x2('100%'),
										$elm$svg$Svg$Attributes$y1('0.5'),
										$elm$svg$Svg$Attributes$y2('0.5'),
										$elm$svg$Svg$Attributes$stroke(
										$author$project$MyUi$colorToStyle($author$project$MyUi$guildColumnBorder)),
										$elm$svg$Svg$Attributes$strokeWidth('var(--guild-outline-width, 1px)')
									]),
								_List_Nil)
							])))) : $author$project$Ui$noAttr
			]),
		$author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$width(
					$author$project$Ui$px(1)),
					$author$project$Ui$height($author$project$Ui$fill),
					$author$project$Ui$alignLeft,
					$author$project$MyUi$htmlStyle$('position', 'relative'),
					$author$project$MyUi$noPointerEvents
				]),
			$author$project$Ui$html(
				A2(
					$elm$svg$Svg$svg,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$width(
							$elm$core$String$fromInt($author$project$GuildIcon$size)),
							$elm$svg$Svg$Attributes$height('100%'),
							$elm$svg$Svg$Attributes$style('display:block;overflow:visible;position:absolute;right:0;top:0')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$svg$Svg$line,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$x1(x),
									$elm$svg$Svg$Attributes$x2(x),
									$elm$svg$Svg$Attributes$y1(
									$elm$core$String$fromInt(topLeftRadius)),
									$elm$svg$Svg$Attributes$y2('100%'),
									$elm$svg$Svg$Attributes$stroke(
									$author$project$MyUi$colorToStyle($author$project$MyUi$guildColumnBorder)),
									$elm$svg$Svg$Attributes$strokeWidth('var(--guild-outline-width, 1px)')
								]),
							_List_Nil),
						(topLeftRadius > 0) ? _List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d(
										'M ' + (x + (',' + ($elm$core$String$fromInt(topLeftRadius) + (' A ' + (radius + (' ' + (radius + (' 0 0 1 ' + ($elm$core$String$fromInt(($author$project$GuildIcon$size + topLeftRadius) - 1) + ',0.5')))))))))),
										$elm$svg$Svg$Attributes$fill('none'),
										$elm$svg$Svg$Attributes$strokeLinecap('square'),
										$elm$svg$Svg$Attributes$stroke(
										$author$project$MyUi$colorToStyle($author$project$MyUi$guildColumnBorder)),
										$elm$svg$Svg$Attributes$strokeWidth('var(--guild-outline-width, 1px)')
									]),
								_List_Nil)
							]) : _List_Nil)))));
};
var $author$project$Pages$Guild$channelColumnContainer$ = function (safeAreaInsetTop, header, content) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$Ui$paddingWith(
				{bottom: 0, left: 0, right: 0, top: safeAreaInsetTop})
			]),
		$author$project$Ui$column$(
			_List_fromArray(
				[
					$author$project$Ui$height($author$project$Ui$fill),
					$author$project$Ui$background($author$project$MyUi$background2),
					$author$project$MyUi$htmlStyle$(
					'border-radius',
					$elm$core$String$fromInt((safeAreaInsetTop / 2) | 0) + 'px 0 0 0'),
					$author$project$Ui$paddingWith(
					{
						bottom: 0,
						left: 1,
						right: 0,
						top: $elm$core$Basics$min$(safeAreaInsetTop, 1)
					}),
					$author$project$Ui$behindContent(
					$author$project$GuildIcon$columnBorderView(safeAreaInsetTop))
				]),
			_List_fromArray(
				[
					$author$project$Ui$row$(
					_List_fromArray(
						[
							$author$project$Ui$Font$bold,
							$author$project$Ui$paddingWith(
							{
								bottom: 0,
								left: $elm$core$Basics$max$((safeAreaInsetTop / 4) | 0, 8),
								right: 4,
								top: 0
							}),
							$author$project$Ui$spacing(8),
							$author$project$Ui$Font$color($author$project$MyUi$font1),
							$author$project$Ui$borderWith(
							{bottom: 1, left: 0, right: 0, top: 0}),
							$author$project$Ui$borderColor($author$project$MyUi$border1),
							$author$project$Ui$height(
							$author$project$Ui$px($author$project$MyUi$channelHeaderHeight)),
							$author$project$MyUi$noShrinking,
							$author$project$Ui$clipWithEllipsis
						]),
					header),
					content
				])));
};
var $author$project$Pages$Guild$channelColumnContainer = F3($author$project$Pages$Guild$channelColumnContainer$);
var $author$project$GuildColumn$channelOrThreadHasNotificationsHelper$ = function (maybeDirectMentions, notifyOnAllMessages, channelId, threadRoute, maybeLastViewed, channel) {
	if (notifyOnAllMessages) {
		var _v0 = $author$project$OneOrGreater$fromInt(
			$author$project$GuildColumn$newMessageCount$(maybeLastViewed, channel));
		if (!_v0.$) {
			var count = _v0.a;
			return $author$project$GuildIcon$NewMessageForUser(count);
		} else {
			return $author$project$GuildIcon$NoNotification;
		}
	} else {
		var _v1 = $elm$core$Maybe$andThen$(
			$author$project$NonemptyDict$get(
				_Utils_Tuple2(channelId, threadRoute)),
			maybeDirectMentions);
		if (!_v1.$) {
			var count = _v1.a;
			return $author$project$GuildIcon$NewMessageForUser(count);
		} else {
			var _v2 = $author$project$OneOrGreater$fromInt(
				$author$project$GuildColumn$newMessageCount$(maybeLastViewed, channel));
			if (!_v2.$) {
				var count = _v2.a;
				return $author$project$GuildIcon$NewMessage(count);
			} else {
				return $author$project$GuildIcon$NoNotification;
			}
		}
	}
};
var $author$project$GuildColumn$channelOrThreadHasNotificationsHelper = F6($author$project$GuildColumn$channelOrThreadHasNotificationsHelper$);
var $author$project$GuildColumn$hideNewMessage = function (notification) {
	switch (notification.$) {
		case 0:
			return $author$project$GuildIcon$NoNotification;
		case 1:
			return $author$project$GuildIcon$NoNotification;
		default:
			return notification;
	}
};
var $author$project$GuildColumn$channelOrThreadHasNotifications$ = function (isMuted, maybeDirectMentions, notifyOnAllMessages, channelId, threadRoute, maybeLastViewed, channel) {
	switch (isMuted) {
		case 2:
			return $author$project$GuildIcon$NoNotification;
		case 1:
			return $author$project$GuildColumn$hideNewMessage(
				$author$project$GuildColumn$channelOrThreadHasNotificationsHelper$(maybeDirectMentions, notifyOnAllMessages, channelId, threadRoute, maybeLastViewed, channel));
		default:
			return $author$project$GuildColumn$channelOrThreadHasNotificationsHelper$(maybeDirectMentions, notifyOnAllMessages, channelId, threadRoute, maybeLastViewed, channel);
	}
};
var $author$project$GuildColumn$channelOrThreadHasNotifications = F7($author$project$GuildColumn$channelOrThreadHasNotifications$);
var $elm$core$List$minimum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			$elm$core$List$foldl$($elm$core$Basics$min, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Guild$channelSortName$ = function (notifications, channel) {
	return _Utils_ap(
		$elm$core$Maybe$withDefault$(
			'c',
			$elm$core$List$minimum(
				$elm$core$List$map$(
					function (notification) {
						switch (notification.$) {
							case 0:
								return 'c';
							case 1:
								return 'b';
							default:
								return 'a';
						}
					},
					notifications))),
		$author$project$ChannelName$toString(channel.name));
};
var $author$project$Pages$Guild$channelSortName = F2($author$project$Pages$Guild$channelSortName$);
var $author$project$Icons$bellDoubleSlash = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor'),
			$elm$svg$Svg$Attributes$width('20')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M9.143 17.082a24.248 24.248 0 0 0 3.844.148m-3.844-.148a23.856 23.856 0 0 1-5.455-1.31 8.964 8.964 0 0 0 2.3-5.542m3.155 6.852a3 3 0 0 0 5.667 1.97m1.965-2.277L21 21m-4.225-4.225a23.81 23.81 0 0 0 3.536-1.003A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6.53 6.53m10.245 10.245L6.53 6.53M3 3l3.53 3.53')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$d('M21 3 3 21')
				]),
			_List_Nil)
		]));
var $author$project$Icons$bellSlash = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor'),
			$elm$svg$Svg$Attributes$width('20')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M9.143 17.082a24.248 24.248 0 0 0 3.844.148m-3.844-.148a23.856 23.856 0 0 1-5.455-1.31 8.964 8.964 0 0 0 2.3-5.542m3.155 6.852a3 3 0 0 0 5.667 1.97m1.965-2.277L21 21m-4.225-4.225a23.81 23.81 0 0 0 3.536-1.003A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6.53 6.53m10.245 10.245L6.53 6.53M3 3l3.53 3.53')
				]),
			_List_Nil)
		]));
var $author$project$Pages$Guild$channelIsMuted = function (isMuted) {
	switch (isMuted) {
		case 1:
			return $author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$MyUi$noShrinking,
						$author$project$Ui$paddingWith(
						{bottom: 0, left: 0, right: 0, top: 0}),
						$author$project$Ui$alignRight
					]),
				$author$project$Ui$html($author$project$Icons$bellSlash));
		case 2:
			return $author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$MyUi$noShrinking,
						$author$project$Ui$paddingWith(
						{bottom: 0, left: 0, right: 0, top: 0}),
						$author$project$Ui$alignRight
					]),
				$author$project$Ui$html($author$project$Icons$bellDoubleSlash));
		default:
			return $author$project$Ui$none;
	}
};
var $author$project$Ui$Anim$fontColor = function (clr) {
	return $author$project$Animator$color$('color', clr);
};
var $author$project$MyUi$alertColor = $author$project$Ui$rgb$(255, 10, 40);
var $author$project$MyUi$black = $author$project$Ui$rgb$(0, 0, 0);
var $author$project$Ui$Accessibility$description = function (label) {
	return $author$project$Internal$Model2$attribute(
		A2($elm$html$Html$Attributes$attribute, 'aria-label', label));
};
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute('transform');
var $author$project$Icons$infinity = function (width) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromInt(width)),
				$elm$svg$Svg$Attributes$fill('currentColor')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$transform('translate(6.025 -1038.1)')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('M-2.025 1042.1a4 4 0 0 0 0 8c2 0 4-1 5-4-1-3-3-4-5-4zm0 2s2 0 3 2c-1 2-3 2-3 2a2 2 0 1 1 0-4z')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('M5.975 1042.1a4 4 0 0 1 0 8c-2 0-4-1-5-4 1-3 3-4 5-4zm0 2s-2 0-3 2c1 2 3 2 3 2a2 2 0 1 0 0-4z')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$GuildIcon$maxNotifications = 99;
var $author$project$GuildIcon$notificationHeight = 17;
var $author$project$Icons$eight = function (width) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('2 0 12 16'),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromInt(width))
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M11.4539 7.38469C12.107 6.60363 12.5 5.59772 12.5 4.5C12.5 2.01472 10.4853 0 8 0C5.51472 0 3.5 2.01472 3.5 4.5C3.5 5.59771 3.89304 6.60363 4.54608 7.38469C3.59342 8.29508 3 9.57824 3 11C3 13.7614 5.23858 16 8 16C10.7614 16 13 13.7614 13 11C13 9.57824 12.4066 8.29508 11.4539 7.38469ZM9.5 4.5C9.5 5.32843 8.82843 6 8 6C7.17157 6 6.5 5.32843 6.5 4.5C6.5 3.67157 7.17157 3 8 3C8.82843 3 9.5 3.67157 9.5 4.5ZM8 9C6.89543 9 6 9.89543 6 11C6 12.1046 6.89543 13 8 13C9.10457 13 10 12.1046 10 11C10 9.89543 9.10457 9 8 9Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$five = function (width) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('2 0 12 16'),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromInt(width))
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M4.11984 0H13V3H6.88024L6.70068 5.15468C7.11748 5.05361 7.55269 5 8.00004 5C11.0376 5 13.5 7.46243 13.5 10.5C13.5 13.5376 11.0376 16 8.00004 16C5.68948 16 3.71518 14.5757 2.90039 12.5628L5.6812 11.4372C6.05319 12.3561 6.95322 13 8.00004 13C9.38075 13 10.5 11.8807 10.5 10.5C10.5 9.11929 9.38075 8 8.00004 8C7.36498 8 6.78843 8.23483 6.34681 8.62461L5.9215 9H3.36984L4.11984 0Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$four = function (width) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('2 0 12 16'),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromInt(width))
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M13 0H10V7H6.03769L7.46324 0.680058L4.53676 0.0199507L3 6.83293V10H10V16H13V0Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$nine = function (width) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('2 0 12 16'),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromInt(width))
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M7.85144 10.998C4.88255 10.9193 2.5 8.48789 2.5 5.5C2.5 2.46243 4.96243 0 8 0C11.0376 0 13.5 2.46243 13.5 5.5C13.5 6.55815 13.2012 7.54651 12.6833 8.38529L8.56828 15.9656L5.93172 14.5344L7.85144 10.998ZM10.0965 6.86244C9.65053 7.54725 8.87814 8 8 8C6.61929 8 5.5 6.88071 5.5 5.5C5.5 4.11929 6.61929 3 8 3C9.38071 3 10.5 4.11929 10.5 5.5C10.5 5.90629 10.3985 6.30614 10.2046 6.66322L10.0965 6.86244Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$one = function (width) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('2 0 12 16'),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromInt(width))
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M6.64594 0L2.32922 2.15836L3.67086 4.84164L7.00004 3.17705V13H3.00004V16H13V13H10V0H6.64594Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$seven = function (width) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('2 0 12 16'),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromInt(width))
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M9.875 3H3V0H13V3.3L7.88462 15.5769L5.11538 14.4231L9.875 3Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$six = function (width) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('2 0 12 16'),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromInt(width))
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M8.14856 5.00197C11.1174 5.0807 13.5 7.51211 13.5 10.5C13.5 13.5376 11.0376 16 8 16C4.96243 16 2.5 13.5376 2.5 10.5C2.5 9.44185 2.79882 8.45349 3.31667 7.61471L7.43172 0.0343628L10.0683 1.46564L8.14856 5.00197ZM5.90352 9.13756C6.34947 8.45275 7.12186 8 8 8C9.38071 8 10.5 9.11929 10.5 10.5C10.5 11.8807 9.38071 13 8 13C6.61929 13 5.5 11.8807 5.5 10.5C5.5 10.0937 5.60153 9.69386 5.79537 9.33679L5.90352 9.13756Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$three = function (width) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('2 0 12 16'),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromInt(width))
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M6.5 4.5C6.5 3.67157 7.17157 3 8 3C8.82843 3 9.5 3.67157 9.5 4.5C9.5 5.32843 8.82843 6 8 6H7V9H8C9.10457 9 10 9.89543 10 11C10 12.1046 9.10457 13 8 13C6.89543 13 6 12.1046 6 11H3C3 13.7614 5.23858 16 8 16C10.7614 16 13 13.7614 13 11C13 9.57824 12.4066 8.29508 11.4539 7.38469C12.107 6.60363 12.5 5.59771 12.5 4.5C12.5 2.01472 10.4853 0 8 0C5.51472 0 3.5 2.01472 3.5 4.5H6.5Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$two = function (width) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('2 0 12 16'),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromInt(width))
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M3 5C3 2.23858 5.23858 0 8 0H8.07519C10.7951 0 13 2.20491 13 4.92481C13 6.36248 12.3718 7.72838 11.2802 8.66401L6.22155 13H13V16H3V11.8101L9.32784 6.38624C9.75447 6.02056 10 5.48671 10 4.92481C10 3.86177 9.13823 3 8.07519 3H8C6.89543 3 6 3.89543 6 5H3Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$zero = function (width) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('2 0 12 16'),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromInt(width))
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M3 5C3 2.23858 5.23858 0 8 0C10.7614 0 13 2.23858 13 5V11C13 13.7614 10.7614 16 8 16C5.23858 16 3 13.7614 3 11V5ZM8 3C6.89543 3 6 3.89543 6 5V11C6 12.1046 6.89543 13 8 13C9.10457 13 10 12.1046 10 11V5C10 3.89543 9.10457 3 8 3Z'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$number$ = function (width, _char) {
	switch (_char) {
		case '0':
			return $author$project$Icons$zero(width);
		case '1':
			return $author$project$Icons$one(width);
		case '2':
			return $author$project$Icons$two(width);
		case '3':
			return $author$project$Icons$three(width);
		case '4':
			return $author$project$Icons$four(width);
		case '5':
			return $author$project$Icons$five(width);
		case '6':
			return $author$project$Icons$six(width);
		case '7':
			return $author$project$Icons$seven(width);
		case '8':
			return $author$project$Icons$eight(width);
		case '9':
			return $author$project$Icons$nine(width);
		default:
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$Attributes$style,
						'width',
						$elm$core$String$fromInt(width) + 'px')
					]),
				_List_Nil);
	}
};
var $author$project$Icons$number = F2($author$project$Icons$number$);
var $author$project$Icons$numberHelper$ = function (width, html, _int) {
	numberHelper:
	while (true) {
		if (_int.b) {
			var _char = _int.a;
			var rest = _int.b;
			var $temp$html = A2(
				$elm$core$List$cons,
				$author$project$Icons$number$(width, _char),
				html),
				$temp$int = rest;
			html = $temp$html;
			_int = $temp$int;
			continue numberHelper;
		} else {
			return html;
		}
	}
};
var $author$project$Icons$numberHelper = F3($author$project$Icons$numberHelper$);
var $author$project$Icons$numbers$ = function (width, value) {
	return $elm$core$List$reverse(
		$author$project$Icons$numberHelper$(
			width,
			_List_Nil,
			$elm$core$String$toList(value)));
};
var $author$project$Icons$numbers = F2($author$project$Icons$numbers$);
var $author$project$Ui$rounded = function (radius) {
	return $author$project$Internal$Model2$style$(
		'border-radius',
		$elm$core$String$fromInt(radius) + 'px');
};
var $author$project$GuildIcon$notificationHelper$ = function (color, fontColor, borderColor, xOffset, yOffset, count) {
	var count2 = $author$project$OneOrGreater$toInt(count);
	return $author$project$Ui$inFront(
		$author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$rounded(99),
					$author$project$Ui$background(color),
					$author$project$Ui$width(
					$author$project$Ui$px(
						(count2 < 10) ? $author$project$GuildIcon$notificationHeight : 22)),
					$author$project$Ui$height(
					$author$project$Ui$px($author$project$GuildIcon$notificationHeight)),
					$author$project$Ui$border(2),
					$author$project$Ui$borderColor(borderColor),
					$author$project$Ui$move(
					{x: xOffset, y: yOffset, z: 0}),
					$author$project$Ui$alignRight,
					$author$project$Ui$Font$color(fontColor),
					$author$project$Ui$contentCenterX,
					$author$project$Ui$contentCenterY,
					$author$project$Ui$Accessibility$description(
					$elm$core$String$fromInt(count2))
				]),
			$author$project$Ui$html(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'flex')
						]),
					(_Utils_cmp(count2, $author$project$GuildIcon$maxNotifications) > 0) ? _List_fromArray(
						[
							$author$project$Icons$infinity(14)
						]) : $author$project$Icons$numbers$(
						7,
						$elm$core$String$fromInt(count2))))));
};
var $author$project$GuildIcon$notificationHelper = F6($author$project$GuildIcon$notificationHelper$);
var $author$project$MyUi$white = $author$project$Ui$rgb$(255, 255, 255);
var $author$project$GuildIcon$notificationView$ = function (xOffset, yOffset, borderColor, notification) {
	switch (notification.$) {
		case 0:
			return $author$project$Ui$noAttr;
		case 1:
			var count = notification.a;
			return $author$project$GuildIcon$notificationHelper$($author$project$MyUi$white, $author$project$MyUi$black, borderColor, xOffset, yOffset, count);
		default:
			var count = notification.a;
			return $author$project$GuildIcon$notificationHelper$($author$project$MyUi$alertColor, $author$project$MyUi$white, borderColor, xOffset, yOffset, count);
	}
};
var $author$project$GuildIcon$notificationView = F4($author$project$GuildIcon$notificationView$);
var $author$project$Types$PressedLink = function (a) {
	return {$: 12, a: a};
};
var $author$project$GuildColumn$rowLinkButton$ = function (htmlId, route, attributes, content) {
	return $author$project$MyUi$rowButton$(
		htmlId,
		$author$project$Types$PressedLink(route),
		attributes,
		content);
};
var $author$project$GuildColumn$rowLinkButton = F4($author$project$GuildColumn$rowLinkButton$);
var $author$project$MyUi$selectedHighlight = $author$project$Ui$rgba$(255, 255, 255, 0.13);
var $author$project$Pages$Guild$discordChannelColumnRow$ = function (isMobile, isMuted, hasNotifications, routeData, channelId, channel) {
	var isSelected = function () {
		var _v0 = routeData.channelRoute;
		if ((!_v0.$) && (!_v0.b.$)) {
			var a = _v0.a;
			var _v1 = _v0.b;
			return _Utils_eq(a, channelId);
		} else {
			return false;
		}
	}();
	return $author$project$GuildColumn$rowLinkButton$(
		$lamdera$program_test$Effect$Browser$Dom$id(
			'guild_openChannel_' + $author$project$Discord$idToString(channelId)),
		$author$project$Route$DiscordGuildRoute(
			{
				channelRoute: $author$project$Route$DiscordChannel_ChannelRoute$(
					channelId,
					$author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1),
					$elm$core$Maybe$Nothing),
				channelsVisible: 0,
				currentDiscordUserId: routeData.currentDiscordUserId,
				guildId: routeData.guildId,
				overlay: $elm$core$Maybe$Nothing
			}),
		_List_fromArray(
			[
				$author$project$Ui$paddingWith(
				{bottom: 0, left: 26, right: 8, top: 0}),
				$author$project$Ui$inFront(
				$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$GuildIcon$notificationView$(
							0,
							-3,
							$author$project$MyUi$background2,
							(isSelected && (!isMobile)) ? $author$project$GuildIcon$NoNotification : hasNotifications),
							$author$project$Ui$width(
							$author$project$Ui$px(20)),
							$author$project$Ui$move(
							{x: 4, y: 0, z: 0}),
							$author$project$Ui$centerY
						]),
					$author$project$Ui$html($author$project$Icons$hashtag))),
				isSelected ? $author$project$Ui$Font$color($author$project$MyUi$font1) : $author$project$Ui$Font$color($author$project$MyUi$font3),
				$author$project$MyUi$hover$(
				isMobile,
				_List_fromArray(
					[
						$author$project$Ui$Anim$fontColor($author$project$MyUi$font1)
					])),
				$author$project$Ui$attrIf$(
				isSelected,
				$author$project$Ui$background($author$project$MyUi$selectedHighlight)),
				$author$project$Ui$clipWithEllipsis,
				$author$project$Ui$height(
				$author$project$Ui$px($author$project$MyUi$channelHeaderHeight)),
				$author$project$MyUi$hoverText(
				$author$project$ChannelName$toString(channel.name)),
				$author$project$Ui$contentCenterY,
				$author$project$MyUi$noShrinking
			]),
		_List_fromArray(
			[
				$author$project$Ui$text(
				$author$project$ChannelName$toString(channel.name)),
				$author$project$Pages$Guild$channelIsMuted(isMuted)
			]));
};
var $author$project$Pages$Guild$discordChannelColumnRow = F6($author$project$Pages$Guild$discordChannelColumnRow$);
var $author$project$Icons$threadBottomSegment = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 20 38'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor'),
			$elm$svg$Svg$Attributes$width('20')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$line,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$y2('20.75'),
							$elm$svg$Svg$Attributes$x2('10'),
							$elm$svg$Svg$Attributes$y1('0'),
							$elm$svg$Svg$Attributes$x1('10')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$line,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$y2('20'),
							$elm$svg$Svg$Attributes$x2('10'),
							$elm$svg$Svg$Attributes$y1('20'),
							$elm$svg$Svg$Attributes$x1('20')
						]),
					_List_Nil)
				]))
		]));
var $author$project$Icons$threadMiddleSegment = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 20 38'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor'),
			$elm$svg$Svg$Attributes$width('20')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$line,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$y2('38'),
							$elm$svg$Svg$Attributes$x2('10'),
							$elm$svg$Svg$Attributes$y1('0'),
							$elm$svg$Svg$Attributes$x1('10')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$line,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$y2('19'),
							$elm$svg$Svg$Attributes$x2('10'),
							$elm$svg$Svg$Attributes$y1('19'),
							$elm$svg$Svg$Attributes$x1('20')
						]),
					_List_Nil)
				]))
		]));
var $author$project$Icons$threadSingleSegment = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 20 38'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor'),
			$elm$svg$Svg$Attributes$width('20')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$line,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$y2('20.75'),
							$elm$svg$Svg$Attributes$x2('10'),
							$elm$svg$Svg$Attributes$y1('4'),
							$elm$svg$Svg$Attributes$x1('10')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$line,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$y2('20'),
							$elm$svg$Svg$Attributes$x2('10'),
							$elm$svg$Svg$Attributes$y1('20'),
							$elm$svg$Svg$Attributes$x1('20')
						]),
					_List_Nil)
				]))
		]));
var $author$project$Icons$threadTopSegment = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 20 38'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor'),
			$elm$svg$Svg$Attributes$width('20')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$line,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$y2('38'),
							$elm$svg$Svg$Attributes$x2('10'),
							$elm$svg$Svg$Attributes$y1('4'),
							$elm$svg$Svg$Attributes$x1('10')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$line,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$y2('19'),
							$elm$svg$Svg$Attributes$x2('10'),
							$elm$svg$Svg$Attributes$y1('19'),
							$elm$svg$Svg$Attributes$x1('20')
						]),
					_List_Nil)
				]))
		]));
var $author$project$Pages$Guild$channelColumnThreadsHelper$ = function (isMobile, isSelected, isMuted, hasNotifications, index, visibleThreadCount, htmlId, route, name) {
	return $author$project$GuildColumn$rowLinkButton$(
		htmlId,
		route,
		_List_fromArray(
			[
				$author$project$Ui$paddingWith(
				{bottom: 0, left: 28, right: 8, top: 0}),
				$author$project$Ui$inFront(
				$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$GuildIcon$notificationView$(
							4,
							5,
							$author$project$MyUi$background2,
							(isSelected && (!isMobile)) ? $author$project$GuildIcon$NoNotification : hasNotifications),
							$author$project$Ui$move(
							{x: 0, y: 0, z: 0}),
							$author$project$Ui$Font$color($author$project$MyUi$font3),
							$author$project$Ui$width($author$project$Ui$shrink)
						]),
					$author$project$Ui$html(
						(visibleThreadCount === 1) ? $author$project$Icons$threadSingleSegment : (_Utils_eq(visibleThreadCount - 1, index) ? $author$project$Icons$threadBottomSegment : ((!index) ? $author$project$Icons$threadTopSegment : $author$project$Icons$threadMiddleSegment))))),
				isSelected ? $author$project$Ui$Font$color($author$project$MyUi$font1) : $author$project$Ui$Font$color($author$project$MyUi$font3),
				$author$project$MyUi$hover$(
				isMobile,
				_List_fromArray(
					[
						$author$project$Ui$Anim$fontColor($author$project$MyUi$font1)
					])),
				$author$project$Ui$attrIf$(
				isSelected,
				$author$project$Ui$background($author$project$MyUi$selectedHighlight)),
				$author$project$Ui$clipWithEllipsis,
				$author$project$Ui$height(
				$author$project$Ui$px($author$project$MyUi$channelHeaderHeight)),
				$author$project$MyUi$hoverText(name),
				$author$project$Ui$contentCenterY,
				$author$project$MyUi$noShrinking
			]),
		_List_fromArray(
			[
				$author$project$Ui$text(name),
				$author$project$Pages$Guild$channelIsMuted(isMuted)
			]));
};
var $author$project$Pages$Guild$channelColumnThreadsHelper = F9($author$project$Pages$Guild$channelColumnThreadsHelper$);
var $author$project$Pages$Guild$threadPreviewText$ = function (timezone, allUsers, channels, threadMessageIndex, decrypted, channel) {
	var _v0 = $author$project$MessageArray$get$(threadMessageIndex, channel.messages);
	if (!_v0.$) {
		var message = _v0.a;
		return $author$project$LocalState$messageToString$(timezone, allUsers, channels, decrypted, message);
	} else {
		return 'Thread not found';
	}
};
var $author$project$Pages$Guild$threadPreviewText = F6($author$project$Pages$Guild$threadPreviewText$);
var $ianmackenzie$elm_units$Duration$week = $ianmackenzie$elm_units$Duration$weeks(1);
var $author$project$Pages$Guild$discordChannelColumnThreads$ = function (isMobile, now, routeData, directMentions, localUser, channels, channelId, channel, threads) {
	var threads2 = $elm$core$List$filterMap$(
		function (_v2) {
			var threadMessageIndex = _v2.a;
			var thread = _v2.b;
			var isSelected = function () {
				var _v5 = routeData.channelRoute;
				if ((!_v5.$) && (_v5.b.$ === 1)) {
					var a = _v5.a;
					var _v6 = _v5.b;
					var b = _v6.a;
					return _Utils_eq(a, channelId) && _Utils_eq(b, threadMessageIndex);
				} else {
					return false;
				}
			}();
			var isMuted = $author$project$MuteSettings$isDiscordChannelMuted$(
				localUser.user.muteSettings,
				routeData.guildId,
				channelId,
				$author$project$Id$ViewThread(threadMessageIndex));
			var hasNotifications = $author$project$GuildColumn$channelOrThreadHasNotifications$(
				isMuted,
				directMentions,
				$lamdera$containers$SeqSet$member$(routeData.guildId, localUser.user.discordNotifyOnAllMessages),
				channelId,
				$author$project$Id$ViewThread(threadMessageIndex),
				$lamdera$containers$SeqDict$get$(
					_Utils_Tuple2(
						$author$project$Id$DiscordGuildOrDmId(
							$author$project$Id$DiscordGuildOrDmId_Guild(
								{channelId: channelId, currentUserId: routeData.currentDiscordUserId, guildId: routeData.guildId})),
						threadMessageIndex),
					localUser.user.lastViewedThreadMessage),
				thread);
			var _v3 = _Utils_Tuple3(
				hasNotifications,
				isSelected,
				$author$project$MessageArray$last(thread.messages));
			if (((!_v3.a.$) && (!_v3.b)) && (!_v3.c.$)) {
				var _v4 = _v3.a;
				var message = _v3.c.a;
				return $ianmackenzie$elm_units$Quantity$lessThan$(
					$ianmackenzie$elm_units$Duration$week,
					$ianmackenzie$elm_units$Duration$from$(
						$author$project$Message$createdAt(message),
						now)) ? $elm$core$Maybe$Just(
					_Utils_Tuple3(
						threadMessageIndex,
						_Utils_Tuple2(isMuted, hasNotifications),
						isSelected)) : $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Just(
					_Utils_Tuple3(
						threadMessageIndex,
						_Utils_Tuple2(isMuted, hasNotifications),
						isSelected));
			}
		},
		$lamdera$containers$SeqDict$toList(threads));
	var count = $elm$core$List$length(threads2);
	return $author$project$Ui$column$(
		_List_Nil,
		$elm$core$List$indexedMap$(
			F2(
				function (index, _v0) {
					var threadMessageIndex = _v0.a;
					var _v1 = _v0.b;
					var isMuted = _v1.a;
					var hasNotifications = _v1.b;
					var isSelected = _v0.c;
					return $author$project$Pages$Guild$channelColumnThreadsHelper$(
						isMobile,
						isSelected,
						isMuted,
						hasNotifications,
						index,
						count,
						$lamdera$program_test$Effect$Browser$Dom$id(
							'guild_viewThread_' + ($author$project$Discord$idToString(channelId) + ('_' + $author$project$Id$toString(threadMessageIndex)))),
						$author$project$Route$DiscordGuildRoute(
							{
								channelRoute: $author$project$Route$DiscordChannel_ChannelRoute$(
									channelId,
									$author$project$Route$ViewThreadWithFriends$(threadMessageIndex, $elm$core$Maybe$Nothing, 1),
									$elm$core$Maybe$Nothing),
								channelsVisible: 0,
								currentDiscordUserId: routeData.currentDiscordUserId,
								guildId: routeData.guildId,
								overlay: $elm$core$Maybe$Nothing
							}),
						$author$project$Pages$Guild$threadPreviewText$(
							localUser.timezone,
							$author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(localUser.discordUsers),
							channels,
							threadMessageIndex,
							$lamdera$containers$SeqDict$empty,
							channel));
				}),
			threads2));
};
var $author$project$Pages$Guild$discordChannelColumnThreads = F9($author$project$Pages$Guild$discordChannelColumnThreads$);
var $author$project$Icons$discord = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$fill('currentColor'),
			$elm$svg$Svg$Attributes$width('11')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z')
				]),
			_List_Nil)
		]));
var $author$project$GuildIcon$discordBlurple = $author$project$Ui$rgb$(88, 101, 242);
var $author$project$GuildIcon$discordLabel = 'Discord';
var $author$project$Ui$padding = function (x) {
	return $author$project$Internal$Model2$style$(
		'padding',
		$elm$core$String$fromInt(x) + 'px');
};
var $author$project$GuildIcon$discordLogo = $author$project$Ui$el$(
	_List_fromArray(
		[
			$author$project$Ui$background($author$project$GuildIcon$discordBlurple),
			$author$project$Ui$rounded(99),
			$author$project$Ui$padding(3),
			$author$project$Ui$border(1),
			$author$project$Ui$borderColor($author$project$MyUi$background1),
			$author$project$Ui$width($author$project$Ui$shrink),
			$author$project$MyUi$noShrinking,
			$author$project$Ui$Accessibility$description($author$project$GuildIcon$discordLabel)
		]),
	$author$project$Ui$html($author$project$Icons$discord));
var $author$project$MyUi$font2 = $author$project$Ui$rgb$(220, 220, 220);
var $author$project$Ui$heightMin = function (x) {
	return $author$project$Internal$Model2$styleAndClass$(
		$author$project$Internal$Flag$skip,
		{
			_class: $author$project$Internal$Style2$classes.heightBounded,
			styleName: 'min-height',
			styleVal: $author$project$Internal$Style2$px(x)
		});
};
var $author$project$Ui$clip = $author$project$Internal$Model2$classWith$($author$project$Internal$Flag$overflow, $author$project$Internal$Style2$classes.clip);
var $author$project$Ui$scrollable = $author$project$Internal$Model2$classWith$($author$project$Internal$Flag$overflow, $author$project$Internal$Style2$classes.scrollbarsY + (' ' + $author$project$Internal$Style2$classes.heightFill));
var $author$project$MyUi$scrollable = function (canScroll2) {
	return canScroll2 ? $author$project$Ui$scrollable : $author$project$Ui$clip;
};
var $author$project$Types$PressedShowSearchOverlay = {$: 167};
var $author$project$Icons$magnifyingGlass = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$fill('currentColor'),
			$elm$svg$Svg$Attributes$width('20')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$d('M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z'),
					$elm$svg$Svg$Attributes$clipRule('evenodd')
				]),
			_List_Nil)
		]));
var $author$project$Pages$Guild$searchButtonId = $lamdera$program_test$Effect$Browser$Dom$id('guild_showSearchOverlay');
var $author$project$Pages$Guild$searchIcon = function (isMobile) {
	return $author$project$MyUi$elButton$(
		$author$project$Pages$Guild$searchButtonId,
		$author$project$Types$PressedShowSearchOverlay,
		_List_fromArray(
			[
				$author$project$Ui$Font$color($author$project$MyUi$font3),
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$Ui$contentCenterY,
				$author$project$Ui$paddingXY$(4, 0),
				$author$project$Ui$alignRight,
				$author$project$Ui$width($author$project$Ui$shrink),
				$author$project$MyUi$hover$(
				isMobile,
				_List_fromArray(
					[
						$author$project$Ui$Anim$fontColor($author$project$MyUi$font1)
					]))
			]),
		$author$project$Ui$html($author$project$Icons$magnifyingGlass));
};
var $author$project$Pages$Guild$discordChannelColumn$ = function (isMobile, time, localUser, routeData, guild, canScroll2) {
	var guildName = $author$project$GuildName$toString(guild.name);
	var directMentions = $lamdera$containers$SeqDict$get$(routeData.guildId, localUser.user.discordDirectMentions);
	var channels = $author$project$LocalState$discordGuildChannelMentions$(localUser, guild.channels);
	return $author$project$Pages$Guild$channelColumnContainer$(
		localUser.safeAreaInsetTop,
		_List_fromArray(
			[
				$author$project$GuildColumn$rowLinkButton$(
				$lamdera$program_test$Effect$Browser$Dom$id('guild_inviteLinkCreatorRoute'),
				$author$project$Route$DiscordGuildRoute(
					{channelRoute: $author$project$Route$DiscordChannel_GuildSettingsRoute, channelsVisible: 0, currentDiscordUserId: routeData.currentDiscordUserId, guildId: routeData.guildId, overlay: $elm$core$Maybe$Nothing}),
				_List_fromArray(
					[
						$author$project$Ui$Font$color($author$project$MyUi$font2),
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$contentCenterY,
						$author$project$Ui$spacing(4),
						$author$project$MyUi$hoverText(guildName)
					]),
				_List_fromArray(
					[
						$author$project$GuildIcon$discordLogo,
						$author$project$Ui$text(guildName)
					])),
				$author$project$Pages$Guild$searchIcon(isMobile)
			]),
		$author$project$Ui$column$(
			_List_fromArray(
				[
					$author$project$MyUi$scrollable(canScroll2),
					$author$project$Ui$heightMin(0),
					$author$project$Ui$paddingXY$(0, 8),
					$author$project$Ui$attrIf$(
					isMobile,
					$author$project$Ui$height($author$project$Ui$fill)),
					$author$project$MyUi$bounceScroll(isMobile)
				]),
			$elm$core$List$map$(
				$elm$core$Tuple$second,
				A2(
					$elm$core$List$sortBy,
					$elm$core$Tuple$first,
					$elm$core$List$map$(
						function (_v0) {
							var channelId = _v0.a;
							var channel = _v0.b;
							var threadNotifications = $elm$core$List$map$(
								function (_v3) {
									var threadId = _v3.a;
									var thread = _v3.b;
									return $author$project$GuildColumn$channelOrThreadHasNotifications$(
										$author$project$MuteSettings$isDiscordChannelMuted$(
											localUser.user.muteSettings,
											routeData.guildId,
											channelId,
											$author$project$Id$ViewThread(threadId)),
										directMentions,
										$lamdera$containers$SeqSet$member$(routeData.guildId, localUser.user.discordNotifyOnAllMessages),
										channelId,
										$author$project$Id$ViewThread(threadId),
										$lamdera$containers$SeqDict$get$(
											_Utils_Tuple2(
												$author$project$Id$DiscordGuildOrDmId(
													$author$project$Id$DiscordGuildOrDmId_Guild(
														{channelId: channelId, currentUserId: routeData.currentDiscordUserId, guildId: routeData.guildId})),
												threadId),
											localUser.user.lastViewedThreadMessage),
										thread);
								},
								$lamdera$containers$SeqDict$toList(channel.threads));
							var channelMuted = $author$project$MuteSettings$isDiscordChannelMuted$(localUser.user.muteSettings, routeData.guildId, channelId, $author$project$Id$NoThread);
							var hasNotifications = $author$project$GuildColumn$channelOrThreadHasNotifications$(
								channelMuted,
								directMentions,
								$lamdera$containers$SeqSet$member$(routeData.guildId, localUser.user.discordNotifyOnAllMessages),
								channelId,
								$author$project$Id$NoThread,
								$lamdera$containers$SeqDict$get$(
									$author$project$Id$DiscordGuildOrDmId(
										$author$project$Id$DiscordGuildOrDmId_Guild(
											{channelId: channelId, currentUserId: routeData.currentDiscordUserId, guildId: routeData.guildId})),
									localUser.user.lastViewedMessage),
								channel);
							return _Utils_Tuple2(
								$author$project$Pages$Guild$channelSortName$(
									A2($elm$core$List$cons, hasNotifications, threadNotifications),
									channel),
								$author$project$Ui$column$(
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Pages$Guild$discordChannelColumnRow$(isMobile, channelMuted, hasNotifications, routeData, channelId, channel),
											$author$project$Pages$Guild$discordChannelColumnThreads$(
											isMobile,
											time,
											routeData,
											directMentions,
											localUser,
											channels,
											channelId,
											channel,
											function () {
												var _v1 = routeData.channelRoute;
												if ((!_v1.$) && (_v1.b.$ === 1)) {
													var channelIdB = _v1.a;
													var _v2 = _v1.b;
													var threadMessageIndex = _v2.a;
													return _Utils_eq(channelIdB, channelId) ? $lamdera$containers$SeqDict$insert$(threadMessageIndex, $author$project$Thread$discordFrontendInit, channel.threads) : channel.threads;
												} else {
													return channel.threads;
												}
											}())
										])));
						},
						$lamdera$containers$SeqDict$toList(guild.channels))))));
};
var $author$project$Pages$Guild$discordChannelColumn = F6($author$project$Pages$Guild$discordChannelColumn$);
var $author$project$Pages$Guild$discordChannelColumnCanScrollMobile$ = function (time, localUser, guildId, guild) {
	return $author$project$Pages$Guild$discordChannelColumn$(
		true,
		$elm$time$Time$millisToPosix(time),
		localUser,
		guildId,
		guild,
		true);
};
var $author$project$Pages$Guild$discordChannelColumnCanScrollMobile = F4($author$project$Pages$Guild$discordChannelColumnCanScrollMobile$);
var $author$project$Pages$Guild$discordChannelColumnCannotScrollMobile$ = function (time, localUser, guildId, guild) {
	return $author$project$Pages$Guild$discordChannelColumn$(
		true,
		$elm$time$Time$millisToPosix(time),
		localUser,
		guildId,
		guild,
		false);
};
var $author$project$Pages$Guild$discordChannelColumnCannotScrollMobile = F4($author$project$Pages$Guild$discordChannelColumnCannotScrollMobile$);
var $author$project$Pages$Guild$discordChannelColumnNotMobile$ = function (time, localUser, routeData, guild) {
	return $author$project$Pages$Guild$discordChannelColumn$(
		false,
		$elm$time$Time$millisToPosix(time),
		localUser,
		routeData,
		guild,
		true);
};
var $author$project$Pages$Guild$discordChannelColumnNotMobile = F4($author$project$Pages$Guild$discordChannelColumnNotMobile$);
var $author$project$Internal$Model2$unwrap$ = function (inheritance, _v0) {
	var fn = _v0;
	return fn(inheritance);
};
var $author$project$Internal$Model2$unwrap = F2($author$project$Internal$Model2$unwrap$);
var $author$project$Ui$Lazy$apply4$ = function (fn, a, b, c, d, s) {
	return $author$project$Internal$Model2$unwrap$(
		s,
		A4(fn, a, b, c, d));
};
var $author$project$Ui$Lazy$apply4 = F6($author$project$Ui$Lazy$apply4$);
var $elm$virtual_dom$VirtualDom$lazy6 = _VirtualDom_lazy6;
var $elm$html$Html$Lazy$lazy6 = $elm$virtual_dom$VirtualDom$lazy6;
var $author$project$Ui$Lazy$lazy4$ = function (fn, a, b, c, d) {
	return function (s) {
		return A7($elm$html$Html$Lazy$lazy6, $author$project$Ui$Lazy$apply4, fn, a, b, c, d, s);
	};
};
var $author$project$Ui$Lazy$lazy4 = F5($author$project$Ui$Lazy$lazy4$);
var $author$project$Pages$Guild$nearestHour = function (time) {
	return ((60 * 60) * 1000) * (($elm$time$Time$posixToMillis(time) / ((60 * 60) * 1000)) | 0);
};
var $author$project$Pages$Guild$discordChannelColumnLazy$ = function (isMobile, canScroll2, model, localUser, routeData, guild) {
	return $author$project$Ui$Lazy$lazy4$(
		isMobile ? (canScroll2 ? $author$project$Pages$Guild$discordChannelColumnCanScrollMobile : $author$project$Pages$Guild$discordChannelColumnCannotScrollMobile) : $author$project$Pages$Guild$discordChannelColumnNotMobile,
		$author$project$Pages$Guild$nearestHour(model.time),
		localUser,
		routeData,
		guild);
};
var $author$project$Pages$Guild$discordChannelColumnLazy = F6($author$project$Pages$Guild$discordChannelColumnLazy$);
var $author$project$Types$PressedMemberListBack = {$: 111};
var $author$project$MyUi$border2 = $author$project$Ui$rgb$(17, 20, 28);
var $author$project$Id$ExportChannel_Discord$ = function (a, b, c) {
	return {$: 1, a: a, b: b, c: c};
};
var $author$project$Id$ExportChannel_Discord = F3($author$project$Id$ExportChannel_Discord$);
var $author$project$Types$PressedMuteDiscordChannel$ = function (a, b, c, d) {
	return {$: 174, a: a, b: b, c: c, d: d};
};
var $author$project$Types$PressedMuteDiscordChannel = F4($author$project$Types$PressedMuteDiscordChannel$);
var $author$project$Types$PressedMuteDiscordThread$ = function (a, b, c, d, e) {
	return {$: 175, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Types$PressedMuteDiscordThread = F5($author$project$Types$PressedMuteDiscordThread$);
var $author$project$Types$PressedExportChannel = function (a) {
	return {$: 112, a: a};
};
var $author$project$MyUi$buttonBackground = $author$project$Ui$rgb$(64, 122, 178);
var $author$project$MyUi$buttonBorder = $author$project$Ui$rgb$(101, 141, 181);
var $author$project$Ui$Font$weight = function (i) {
	return $author$project$Internal$Model2$style$(
		'font-weight',
		$elm$core$String$fromInt(i));
};
var $author$project$Pages$Guild$exportChannelButton = function (exportChannelId) {
	return $author$project$MyUi$elButton$(
		$lamdera$program_test$Effect$Browser$Dom$id('guild_exportChannel'),
		$author$project$Types$PressedExportChannel(exportChannelId),
		_List_fromArray(
			[
				$author$project$Ui$paddingXY$(8, 4),
				$author$project$Ui$rounded(4),
				$author$project$Ui$border(1),
				$author$project$Ui$borderColor($author$project$MyUi$buttonBorder),
				$author$project$Ui$background($author$project$MyUi$buttonBackground),
				$author$project$Ui$Font$color($author$project$MyUi$font1),
				$author$project$Ui$Font$center,
				$author$project$Ui$Font$weight(500),
				$author$project$MyUi$noShrinking
			]),
		$author$project$Ui$text('Export channel'));
};
var $author$project$MuteSettings$isDiscordChannelSpecificallyMuted$ = function (model, guildId, channelId) {
	var _v0 = $lamdera$containers$SeqDict$get$(guildId, model.mutedDiscordGuilds);
	if (!_v0.$) {
		var guild = _v0.a;
		var _v1 = $lamdera$containers$SeqDict$get$(channelId, guild.channels);
		if (!_v1.$) {
			var channel = _v1.a;
			return channel.mutedChannel;
		} else {
			return 0;
		}
	} else {
		return 0;
	}
};
var $author$project$MuteSettings$isDiscordChannelSpecificallyMuted = F3($author$project$MuteSettings$isDiscordChannelSpecificallyMuted$);
var $author$project$MuteSettings$isDiscordThreadSpecificallyMuted$ = function (model, guildId, channelId, threadId) {
	var _v0 = $lamdera$containers$SeqDict$get$(guildId, model.mutedDiscordGuilds);
	if (!_v0.$) {
		var guild = _v0.a;
		var _v1 = $lamdera$containers$SeqDict$get$(channelId, guild.channels);
		if (!_v1.$) {
			var channel = _v1.a;
			return $elm$core$Maybe$withDefault$(
				0,
				$lamdera$containers$SeqDict$get$(threadId, channel.mutedThreads));
		} else {
			return 0;
		}
	} else {
		return 0;
	}
};
var $author$project$MuteSettings$isDiscordThreadSpecificallyMuted = F4($author$project$MuteSettings$isDiscordThreadSpecificallyMuted$);
var $author$project$Icons$bell = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor'),
			$elm$svg$Svg$Attributes$width('20')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0')
				]),
			_List_Nil)
		]));
var $author$project$Ui$Input$AfterFound = 2;
var $author$project$Ui$Input$BeforeFound = 1;
var $author$project$Ui$Input$NotFound = 0;
var $author$project$Ui$Accessibility$announce = $author$project$Internal$Model2$attribute(
	A2($elm$html$Html$Attributes$attribute, 'aria-live', 'polite'));
var $author$project$Internal$Model2$class = function (cls) {
	return {
		attr: {
			additionalInheritance: $author$project$Internal$BitField$none,
			attrs: _List_Nil,
			_class: $elm$core$Maybe$Just(cls),
			nearby: $elm$core$Maybe$Nothing,
			node: $author$project$Internal$Model2$NodeAsDiv,
			styles: $author$project$Internal$Model2$noStyles
		},
		flag: $author$project$Internal$Flag$skip
	};
};
var $author$project$Ui$Input$downArrow = 'ArrowDown';
var $author$project$Ui$Input$labelAttribute = function (lbl) {
	if (!lbl.$) {
		var textLabel = lbl.a;
		return $author$project$Ui$Accessibility$description(textLabel);
	} else {
		var id = lbl.a;
		return $author$project$Ui$id(id);
	}
};
var $author$project$Ui$Input$leftArrow = 'ArrowLeft';
var $author$project$Ui$Input$onKeyLookup2 = function (lookup) {
	var decode = function (code) {
		var _v0 = lookup(code);
		if (_v0.$ === 1) {
			return $elm$json$Json$Decode$fail('No key matched');
		} else {
			var msg = _v0.a;
			return $elm$json$Json$Decode$succeed(msg);
		}
	};
	var isKey = A2(
		$elm$json$Json$Decode$andThen,
		decode,
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
	return $author$project$Internal$Model2$attribute(
		$elm$html$Html$Events$on$('keyup', isKey));
};
var $author$project$Ui$Input$Idle = 0;
var $author$project$Ui$Input$Selected = 2;
var $author$project$Ui$Events$onClick = function (msg) {
	return $author$project$Internal$Model2$attribute(
		$elm$html$Html$Events$onClick(msg));
};
var $author$project$Ui$pointer = $author$project$Internal$Model2$class($author$project$Internal$Style2$classes.cursorPointer);
var $author$project$Ui$Input$renderOption$ = function (input, _v0) {
	var val = _v0.a;
	var view = _v0.b;
	var status = _Utils_eq(
		$elm$core$Maybe$Just(val),
		input.selected) ? 2 : 0;
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$pointer,
				$author$project$Ui$Events$onClick(
				input.onChange(val)),
				$author$project$Internal$Model2$attribute(
				A2(
					$elm$html$Html$Attributes$attribute,
					'aria-checked',
					function () {
						if (status === 2) {
							return 'true';
						} else {
							return 'false';
						}
					}())),
				$author$project$Internal$Model2$attribute(
				A2($elm$html$Html$Attributes$attribute, 'role', 'radio'))
			]),
		view(status));
};
var $author$project$Ui$Input$renderOption = F2($author$project$Ui$Input$renderOption$);
var $author$project$Ui$Input$rightArrow = 'ArrowRight';
var $author$project$Ui$Input$space = ' ';
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $author$project$Ui$Input$upArrow = 'ArrowUp';
var $author$project$Ui$Input$chooseOne$ = function (layoutFn, attrs, input) {
	var track = F2(
		function (opt, _v9) {
			var found = _v9.a;
			var prev = _v9.b;
			var nxt = _v9.c;
			var val = opt.a;
			switch (found) {
				case 0:
					return _Utils_eq(
						$elm$core$Maybe$Just(val),
						input.selected) ? _Utils_Tuple3(1, prev, nxt) : _Utils_Tuple3(found, val, nxt);
				case 1:
					return _Utils_Tuple3(2, prev, val);
				default:
					return _Utils_Tuple3(found, prev, nxt);
			}
		});
	var prevNext = function () {
		var _v3 = input.options;
		if (!_v3.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v4 = _v3.a;
			var val = _v4.a;
			return function (_v5) {
				var found = _v5.a;
				var b = _v5.b;
				var a = _v5.c;
				switch (found) {
					case 0:
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(b, val));
					case 1:
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(b, val));
					default:
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(b, a));
				}
			}(
				$elm$core$List$foldl$(
					track,
					_Utils_Tuple3(0, val, val),
					input.options));
		}
	}();
	var events = _List_Nil;
	var finalAttrs = _Utils_ap(
		_List_fromArray(
			[
				$author$project$Ui$Input$labelAttribute(input.label),
				$author$project$Ui$alignLeft,
				$author$project$Internal$Model2$attribute(
				$elm$html$Html$Attributes$tabindex(0)),
				$author$project$Internal$Model2$class('focus'),
				$author$project$Ui$Accessibility$announce,
				$author$project$Internal$Model2$attribute(
				A2($elm$html$Html$Attributes$attribute, 'role', 'radiogroup')),
				function () {
				if (prevNext.$ === 1) {
					return $author$project$Internal$Model2$class('');
				} else {
					var _v1 = prevNext.a;
					var prev = _v1.a;
					var next = _v1.b;
					return $author$project$Ui$Input$onKeyLookup2(
						function (code) {
							if (_Utils_eq(code, $author$project$Ui$Input$leftArrow)) {
								return $elm$core$Maybe$Just(
									input.onChange(prev));
							} else {
								if (_Utils_eq(code, $author$project$Ui$Input$upArrow)) {
									return $elm$core$Maybe$Just(
										input.onChange(prev));
								} else {
									if (_Utils_eq(code, $author$project$Ui$Input$rightArrow)) {
										return $elm$core$Maybe$Just(
											input.onChange(next));
									} else {
										if (_Utils_eq(code, $author$project$Ui$Input$downArrow)) {
											return $elm$core$Maybe$Just(
												input.onChange(next));
										} else {
											if (_Utils_eq(code, $author$project$Ui$Input$space)) {
												var _v2 = input.selected;
												if (_v2.$ === 1) {
													return $elm$core$Maybe$Just(
														input.onChange(prev));
												} else {
													return $elm$core$Maybe$Nothing;
												}
											} else {
												return $elm$core$Maybe$Nothing;
											}
										}
									}
								}
							}
						});
				}
			}()
			]),
		_Utils_ap(events, attrs));
	return A2(
		layoutFn,
		finalAttrs,
		$elm$core$List$map$(
			$author$project$Ui$Input$renderOption(input),
			input.options));
};
var $author$project$Ui$Input$chooseOne = F3($author$project$Ui$Input$chooseOne$);
var $author$project$Ui$Input$LabelFromId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Internal$Model2$NodeAsLabel = {$: 12};
var $elm$html$Html$Attributes$for = _VirtualDom_attribute('for');
var $author$project$Ui$Input$label$ = function (id, attrs, labelElement) {
	return {
		element: $author$project$Internal$Model2$element$(
			$author$project$Internal$Model2$NodeAsLabel,
			1,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$htmlAttribute(
					$elm$html$Html$Attributes$for(id)),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$width($author$project$Ui$fill),
					attrs)),
			_List_fromArray(
				[labelElement])),
		id: $author$project$Ui$Input$LabelFromId(id)
	};
};
var $author$project$Ui$Input$label = F3($author$project$Ui$Input$label$);
var $author$project$Ui$Input$Option$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Ui$Input$Option = F2($author$project$Ui$Input$Option$);
var $author$project$Ui$Input$optionWith$ = function (val, view) {
	return $author$project$Ui$Input$Option$(val, view);
};
var $author$project$Ui$Input$optionWith = F2($author$project$Ui$Input$optionWith$);
var $author$project$MyUi$radioFillColor = $author$project$MyUi$white;
var $author$project$MyUi$radioCircle = function (option) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$width(
				$author$project$Ui$px(23)),
				$author$project$Ui$height(
				$author$project$Ui$px(23)),
				$author$project$Ui$rounded(99),
				$author$project$Ui$border(2),
				$author$project$Ui$borderColor(
				function () {
					switch (option) {
						case 2:
							return $author$project$MyUi$radioFillColor;
						case 0:
							return $author$project$MyUi$radioFillColor;
						default:
							return $author$project$MyUi$white;
					}
				}())
			]),
		function () {
			switch (option) {
				case 2:
					return $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$width(
								$author$project$Ui$px(15)),
								$author$project$Ui$height(
								$author$project$Ui$px(15)),
								$author$project$Ui$centerX,
								$author$project$Ui$centerY,
								$author$project$Ui$background($author$project$MyUi$radioFillColor),
								$author$project$Ui$rounded(99),
								$author$project$Ui$inFront(
								$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$width(
											$author$project$Ui$px(3)),
											$author$project$Ui$height(
											$author$project$Ui$px(3)),
											$author$project$Ui$background($author$project$MyUi$background1),
											$author$project$Ui$rounded(99),
											$author$project$Ui$centerX,
											$author$project$Ui$centerY
										]),
									$author$project$Ui$none))
							]),
						$author$project$Ui$none);
				case 0:
					return $author$project$Ui$none;
				default:
					return $author$project$Ui$none;
			}
		}());
};
var $author$project$MyUi$radioOption$ = function (htmlId, value, text) {
	return $author$project$Ui$Input$optionWith$(
		value,
		function (option) {
			return $author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(6),
						$author$project$Ui$id(
						$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId) + ('_' + text))
					]),
				_List_fromArray(
					[
						$author$project$MyUi$radioCircle(option),
						$author$project$Ui$text(text)
					]));
		});
};
var $author$project$MyUi$radioOption = F3($author$project$MyUi$radioOption$);
var $author$project$MyUi$radioColumn$ = function (htmlId, onPress, maybeValue, title, options) {
	var label2 = $author$project$Ui$Input$label$(
		$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId),
		_List_fromArray(
			[$author$project$Ui$Font$bold]),
		title);
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(4)
			]),
		_List_fromArray(
			[
				label2.element,
				$author$project$Ui$Input$chooseOne$(
				$author$project$Ui$column,
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				{
					label: label2.id,
					onChange: onPress,
					options: $elm$core$List$map$(
						function (_v0) {
							var value = _v0.a;
							var text = _v0.b;
							return $author$project$MyUi$radioOption$(htmlId, value, text);
						},
						options),
					selected: maybeValue
				})
			]));
};
var $author$project$MyUi$radioColumn = F5($author$project$MyUi$radioColumn$);
var $author$project$MuteSettings$view$ = function (onPress, isMuted) {
	return $author$project$MyUi$radioColumn$(
		$lamdera$program_test$Effect$Browser$Dom$id('guild_muteChannel'),
		onPress,
		$elm$core$Maybe$Just(isMuted),
		$author$project$Ui$row$(
			_List_fromArray(
				[
					$author$project$Ui$spacing(8)
				]),
			_List_fromArray(
				[
					$author$project$Ui$text('Mute notifications'),
					function () {
					switch (isMuted) {
						case 0:
							return $author$project$Ui$html($author$project$Icons$bell);
						case 1:
							return $author$project$Ui$html($author$project$Icons$bellSlash);
						default:
							return $author$project$Ui$html($author$project$Icons$bellDoubleSlash);
					}
				}()
				])),
		_List_fromArray(
			[
				_Utils_Tuple2(0, 'Not muted'),
				_Utils_Tuple2(1, 'Partial mute (hide white dot)'),
				_Utils_Tuple2(2, 'Fully muted (hide red/white dot)')
			]));
};
var $author$project$MuteSettings$view = F2($author$project$MuteSettings$view$);
var $author$project$Pages$Guild$discordChannelSettingsForm$ = function (localUser, currentDiscordUserId, guildId, channelId, threadRoute) {
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$Font$color($author$project$MyUi$font1),
				$author$project$Ui$padding(8),
				$author$project$Ui$spacing(16)
			]),
		function () {
			if (!threadRoute.$) {
				return _List_fromArray(
					[
						$author$project$MuteSettings$view$(
						A3($author$project$Types$PressedMuteDiscordChannel, currentDiscordUserId, guildId, channelId),
						$author$project$MuteSettings$isDiscordChannelSpecificallyMuted$(localUser.user.muteSettings, guildId, channelId)),
						$author$project$Pages$Guild$exportChannelButton(
						$author$project$Id$ExportChannel_Discord$(currentDiscordUserId, guildId, channelId))
					]);
			} else {
				var threadId = threadRoute.a;
				return _List_fromArray(
					[
						$author$project$MuteSettings$view$(
						A4($author$project$Types$PressedMuteDiscordThread, currentDiscordUserId, guildId, channelId, threadId),
						$author$project$MuteSettings$isDiscordThreadSpecificallyMuted$(localUser.user.muteSettings, guildId, channelId, threadId))
					]);
			}
		}());
};
var $author$project$Pages$Guild$discordChannelSettingsForm = F5($author$project$Pages$Guild$discordChannelSettingsForm$);
var $author$project$Discord$RoleOrUserId_RoleId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Discord$RoleOrUserId_UserId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Discord$memberHasChannelPermission$ = function (permission, guildId, ownerId, roles, member, overwrites) {
	var everyoneRoleId = $author$project$Discord$idFromUInt64(
		$author$project$Discord$idToUInt64(guildId));
	var memberRoleIds = A2($elm$core$List$cons, everyoneRoleId, member.roles);
	var memberRoles = $elm$core$List$filter$(
		function (role) {
			return $elm$core$List$member$(role.id, memberRoleIds);
		},
		roles);
	if (_Utils_eq(member.userId, ownerId) || $elm$core$List$any$(
		function (role) {
			return role.permissions.administrator;
		},
		memberRoles)) {
		return true;
	} else {
		var applyOverwrites = F2(
			function (relevantOverwrites, value) {
				return $elm$core$List$any$(
					function (overwrite) {
						return permission(overwrite.allow);
					},
					relevantOverwrites) ? true : ($elm$core$List$any$(
					function (overwrite) {
						return permission(overwrite.deny);
					},
					relevantOverwrites) ? false : value);
			});
		return A2(
			applyOverwrites,
			$elm$core$List$filter$(
				function (overwrite) {
					return _Utils_eq(
						overwrite.id,
						$author$project$Discord$RoleOrUserId_UserId(member.userId));
				},
				overwrites),
			A2(
				applyOverwrites,
				$elm$core$List$filter$(
					function (overwrite) {
						var _v0 = overwrite.id;
						if (!_v0.$) {
							var roleId = _v0.a;
							return (!_Utils_eq(roleId, everyoneRoleId)) && $elm$core$List$member$(roleId, member.roles);
						} else {
							return false;
						}
					},
					overwrites),
				A2(
					applyOverwrites,
					$elm$core$List$filter$(
						function (overwrite) {
							return _Utils_eq(
								overwrite.id,
								$author$project$Discord$RoleOrUserId_RoleId(everyoneRoleId));
						},
						overwrites),
					$elm$core$List$any$(
						function (role) {
							return permission(role.permissions);
						},
						memberRoles))));
	}
};
var $author$project$Discord$memberHasChannelPermission = F6($author$project$Discord$memberHasChannelPermission$);
var $author$project$LocalState$canViewDiscordChannel$ = function (guildId, channel, guild, userId) {
	return $author$project$Discord$memberHasChannelPermission$(
		function ($) {
			return $.viewChannel;
		},
		guildId,
		$author$project$MembersAndOwner$owner(guild.membersAndOwner),
		$elm$core$List$map$(
			function (_v0) {
				var roleId = _v0.a;
				var role = _v0.b;
				return {id: roleId, permissions: role.permissions};
			},
			$lamdera$containers$SeqDict$toList(guild.roles)),
		{
			roles: function () {
				var _v1 = $lamdera$containers$SeqDict$get$(
					userId,
					$author$project$MembersAndOwner$members(guild.membersAndOwner));
				if (!_v1.$) {
					var memberData = _v1.a;
					return $lamdera$containers$SeqSet$toList(memberData.roles);
				} else {
					return _List_Nil;
				}
			}(),
			userId: userId
		},
		channel.permissionOverwrites);
};
var $author$project$LocalState$canViewDiscordChannel = F4($author$project$LocalState$canViewDiscordChannel$);
var $author$project$Pages$Guild$discordChannelViewers$ = function (guildId, guild, channelId) {
	var _v0 = $lamdera$containers$SeqDict$get$(channelId, guild.channels);
	if (!_v0.$) {
		var channel = _v0.a;
		return $elm$core$Maybe$Just(
			$lamdera$containers$SeqDict$filter$(
				F2(
					function (userId, _v1) {
						return $author$project$LocalState$canViewDiscordChannel$(guildId, channel, guild, userId);
					}),
				$author$project$MembersAndOwner$members(guild.membersAndOwner)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Guild$discordChannelViewers = F3($author$project$Pages$Guild$discordChannelViewers$);
var $author$project$Types$PressedDiscordGuildMemberLabel = function (a) {
	return {$: 133, a: a};
};
var $author$project$Discord$TwoToNthPower = function (a) {
	return {$: 1, a: a};
};
var $elm$url$Url$Builder$crossOrigin$ = function (prePath, pathSegments, parameters) {
	return prePath + ('/' + ($elm$core$String$join$('/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters)));
};
var $elm$url$Url$Builder$crossOrigin = F3($elm$url$Url$Builder$crossOrigin$);
var $author$project$Discord$discordCdnUrl = 'https://cdn.discordapp.com';
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$Discord$imageSizeQuery = function (size) {
	if (size.$ === 1) {
		var size_ = size.a;
		return $elm$core$List$singleton(
			$elm$url$Url$Builder$int$(
				'size',
				$elm$core$Basics$clamp$(
					16,
					4096,
					A2($elm$core$Basics$pow, 2, size_))));
	} else {
		return _List_Nil;
	}
};
var $MartinSStewart$elm_uint64$UInt64$mod$ = function (dividend, divisor) {
	var _v0 = divisor;
	var divisorHigh = _v0.a;
	var divisorMid = _v0.b;
	var divisorLow = _v0.c;
	if ((divisorMid <= 31) && (!divisorHigh)) {
		if ((!divisorLow) && (!divisorMid)) {
			return $MartinSStewart$elm_uint64$UInt64$zero;
		} else {
			var divisorFloat = $MartinSStewart$elm_uint64$UInt64$toFloat(divisor);
			var _v1 = dividend;
			var _v2 = _v1;
			var dividendHigh = _v2.a;
			var dividendMid = _v2.b;
			var dividendLow = _v2.c;
			var dividendHighMid = (dividendHigh * $MartinSStewart$elm_uint64$UInt64$limit24) + dividendMid;
			var quotHighMid = $elm$core$Basics$floor(dividendHighMid / divisorFloat);
			var highMidCarry = dividendHighMid - (divisorFloat * quotHighMid);
			var highMidCarryWithLow = (highMidCarry * $MartinSStewart$elm_uint64$UInt64$limit24) + dividendLow;
			var quotLow = $elm$core$Basics$floor(highMidCarryWithLow / divisorFloat);
			var modMidLow = highMidCarryWithLow - (divisorFloat * quotLow);
			var modMid = $elm$core$Basics$floor(modMidLow / $MartinSStewart$elm_uint64$UInt64$limit24);
			var modLow = $elm$core$Basics$floor(modMidLow) - (modMid * $MartinSStewart$elm_uint64$UInt64$limit24);
			return _Utils_Tuple3(0, modMid, modLow);
		}
	} else {
		if ($MartinSStewart$elm_uint64$UInt64$isSafe(dividend)) {
			var divisorFloat = $MartinSStewart$elm_uint64$UInt64$toFloat(divisor);
			var dividendFloat = $MartinSStewart$elm_uint64$UInt64$toFloat(dividend);
			var quotInt = $elm$core$Basics$floor(dividendFloat / divisorFloat);
			var modFloat = dividendFloat - (divisorFloat * quotInt);
			var modHigh = $elm$core$Basics$floor(modFloat / $MartinSStewart$elm_uint64$UInt64$limit48);
			var modMidLow = modFloat - ($MartinSStewart$elm_uint64$UInt64$limit48 * modHigh);
			var modMid = $elm$core$Basics$floor(modMidLow / $MartinSStewart$elm_uint64$UInt64$limit24);
			var modLow = modMidLow - ($MartinSStewart$elm_uint64$UInt64$limit24 * modMid);
			return _Utils_Tuple3(
				modHigh,
				modMid,
				$elm$core$Basics$floor(modLow));
		} else {
			var _v3 = $MartinSStewart$elm_uint64$UInt64$divModFast$(dividend, divisor);
			if (!_v3.$) {
				var _v4 = _v3.a;
				var mod_ = _v4.b;
				return mod_;
			} else {
				return $MartinSStewart$elm_uint64$UInt64$divModSlow$(dividend, divisor).b;
			}
		}
	}
};
var $MartinSStewart$elm_uint64$UInt64$mod = F2($MartinSStewart$elm_uint64$UInt64$mod$);
var $MartinSStewart$elm_uint64$UInt64$shiftRightZfBy$ = function (givenShift, _v0) {
	var _v1 = _v0;
	var high = _v1.a;
	var mid = _v1.b;
	var low = _v1.c;
	var n = 63 & givenShift;
	return (n < 24) ? _Utils_Tuple3(high >>> n, $MartinSStewart$elm_uint64$UInt64$max24 & ((mid >>> n) | (high << (24 - n))), $MartinSStewart$elm_uint64$UInt64$max24 & ((low >>> n) | (mid << (24 - n)))) : ((n < 48) ? _Utils_Tuple3(0, high >>> (n - 24), $MartinSStewart$elm_uint64$UInt64$max24 & ((mid >>> (n - 24)) | (high << (48 - n)))) : _Utils_Tuple3(0, 0, high >>> (n - 48)));
};
var $MartinSStewart$elm_uint64$UInt64$shiftRightZfBy = F2($MartinSStewart$elm_uint64$UInt64$shiftRightZfBy$);
var $author$project$Discord$defaultUserAvatarUrl$ = function (size, userId) {
	var discriminator = $MartinSStewart$elm_uint64$UInt64$toString(
		$MartinSStewart$elm_uint64$UInt64$mod$(
			$MartinSStewart$elm_uint64$UInt64$shiftRightZfBy$(
				22,
				$author$project$Discord$idToUInt64(userId)),
			$MartinSStewart$elm_uint64$UInt64$fromInt(6)));
	return $elm$url$Url$Builder$crossOrigin$(
		$author$project$Discord$discordCdnUrl,
		_List_fromArray(
			['embed', 'avatars', discriminator + '.png']),
		$author$project$Discord$imageSizeQuery(size));
};
var $author$project$Discord$defaultUserAvatarUrl = F2($author$project$Discord$defaultUserAvatarUrl$);
var $elm$html$Html$Attributes$alt = _VirtualDom_attribute('alt');
var $author$project$Ui$imageLazy$ = function (attrs, img) {
	return $author$project$Internal$Model2$element$(
		$author$project$Internal$Model2$NodeAsDiv,
		2,
		A2(
			$elm$core$List$cons,
			$author$project$Ui$width($author$project$Ui$fill),
			attrs),
		_List_fromArray(
			[
				$author$project$Internal$Model2$element$(
				$author$project$Internal$Model2$NodeAsImage,
				2,
				_List_fromArray(
					[
						$author$project$Ui$width($author$project$Ui$fill),
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$clip,
						$author$project$Internal$Model2$class($author$project$Internal$Style2$classes.imageContainer),
						$author$project$Ui$htmlAttribute(
						$elm$html$Html$Attributes$src(img.source)),
						$author$project$Ui$htmlAttribute(
						$elm$html$Html$Attributes$alt(img.description)),
						$author$project$Ui$htmlAttribute(
						A2($elm$html$Html$Attributes$attribute, 'loading', 'lazy')),
						function () {
						var _v0 = img.onLoad;
						if (!_v0.$) {
							var msg = _v0.a;
							return $author$project$Ui$htmlAttribute(
								$elm$html$Html$Events$on$(
									'load',
									$elm$json$Json$Decode$succeed(msg)));
						} else {
							return $author$project$Ui$noAttr;
						}
					}()
					]),
				_List_Nil)
			]));
};
var $author$project$Ui$imageLazy = F2($author$project$Ui$imageLazy$);
var $author$project$User$profileImageRounding = 8;
var $author$project$User$profileImageSize = 40;
var $author$project$User$discordProfileImage$ = function (userId, maybeFileHash) {
	return $author$project$Ui$imageLazy$(
		_List_fromArray(
			[
				$author$project$Ui$rounded($author$project$User$profileImageRounding),
				$author$project$Ui$width(
				$author$project$Ui$px($author$project$User$profileImageSize)),
				$author$project$Ui$height(
				$author$project$Ui$px($author$project$User$profileImageSize)),
				$author$project$Ui$clip
			]),
		{
			description: '',
			onLoad: $elm$core$Maybe$Nothing,
			source: function () {
				if (!maybeFileHash.$) {
					var fileHash = maybeFileHash.a;
					return $author$project$FileStatus$fileUrl$($author$project$FileStatus$pngContent, fileHash);
				} else {
					return $author$project$Discord$defaultUserAvatarUrl$(
						$author$project$Discord$TwoToNthPower(7),
						userId);
				}
			}()
		});
};
var $author$project$User$discordProfileImage = F2($author$project$User$discordProfileImage$);
var $author$project$MyUi$weakHoverHighlight = $author$project$Ui$rgba$(255, 255, 255, 0.08);
var $author$project$Pages$Guild$discordMemberLabel$ = function (isMobile, localUser, currentUserId, userId) {
	return $author$project$MyUi$rowButton$(
		$lamdera$program_test$Effect$Browser$Dom$id(
			'guild_openDiscordDm_' + $author$project$Discord$idToString(userId)),
		$author$project$Types$PressedDiscordGuildMemberLabel(
			{currentUserId: currentUserId, otherUserId: userId}),
		_List_fromArray(
			[
				$author$project$Ui$spacing(8),
				$author$project$Ui$paddingXY$(8, 4),
				$author$project$MyUi$hover$(
				isMobile,
				_List_fromArray(
					[
						$author$project$Ui$Anim$backgroundColor($author$project$MyUi$weakHoverHighlight),
						$author$project$Ui$Anim$fontColor($author$project$MyUi$font1)
					])),
				$author$project$Ui$Font$color($author$project$MyUi$font3),
				$author$project$Ui$clipWithEllipsis
			]),
		function () {
			var _v0 = $author$project$User$getDiscordUser$(userId, localUser);
			if (!_v0.$) {
				var user = _v0.a;
				return _List_fromArray(
					[
						$author$project$User$discordProfileImage$(userId, user.icon),
						$author$project$Ui$text(
						$author$project$PersonName$toString(user.name))
					]);
			} else {
				return _List_Nil;
			}
		}());
};
var $author$project$Pages$Guild$discordMemberLabel = F4($author$project$Pages$Guild$discordMemberLabel$);
var $author$project$Pages$Guild$discordMemberListView$ = function (isMobile, currentUserId, localUser, guildId, guild, channelId) {
	var _v0 = $author$project$Pages$Guild$discordChannelViewers$(guildId, guild, channelId);
	if (_v0.$ === 1) {
		return $author$project$Ui$none;
	} else {
		var members = _v0.a;
		return $author$project$Ui$column$(
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$paddingXY$(8, 4)
						]),
					$author$project$Ui$text(
						'Members (' + ($elm$core$String$fromInt(
							$lamdera$containers$SeqDict$size(members)) + ')'))),
					$author$project$Ui$column$(
					_List_fromArray(
						[
							$author$project$Ui$height($author$project$Ui$fill)
						]),
					$lamdera$containers$SeqDict$foldr$(
						F3(
							function (userId, _v1, list) {
								return A2(
									$elm$core$List$cons,
									$author$project$Pages$Guild$discordMemberLabel$(isMobile, localUser, currentUserId, userId),
									list);
							}),
						_List_Nil,
						members))
				]));
	}
};
var $author$project$Pages$Guild$discordMemberListView = F6($author$project$Pages$Guild$discordMemberListView$);
var $author$project$Icons$arrowLeft = function (width) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromInt(width))
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M14 8a.75.75 0 0 1-.75.75H4.56l3.22 3.22a.75.75 0 1 1-1.06 1.06l-4.5-4.5a.75.75 0 0 1 0-1.06l4.5-4.5a.75.75 0 0 1 1.06 1.06L4.56 7.25h8.69A.75.75 0 0 1 14 8Z'),
						$elm$svg$Svg$Attributes$clipRule('evenodd')
					]),
				_List_Nil)
			]));
};
var $author$project$ChannelHeader$headerBackButton$ = function (htmlId, onPress) {
	return $author$project$MyUi$elButton$(
		htmlId,
		onPress,
		_List_fromArray(
			[
				$author$project$Ui$width($author$project$Ui$shrink),
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$Ui$Font$color($author$project$MyUi$font3),
				$author$project$Ui$contentCenterY,
				$author$project$Ui$contentCenterX,
				$author$project$Ui$paddingWith(
				{bottom: 8, left: 12, right: 8, top: 8}),
				$author$project$MyUi$hoverText('Back')
			]),
		$author$project$Ui$html(
			$author$project$Icons$arrowLeft(16)));
};
var $author$project$ChannelHeader$headerBackButton = F2($author$project$ChannelHeader$headerBackButton$);
var $author$project$Pages$Guild$discordChannelSettingsMobile$ = function (canScroll2, localUser, routeData, guild, channelId, threadRoute) {
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$height($author$project$Ui$fill)
			]),
		_List_fromArray(
			[
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$contentCenterY,
						$author$project$Ui$borderWith(
						{bottom: 1, left: 0, right: 0, top: 0}),
						$author$project$Ui$borderColor($author$project$MyUi$border2),
						$author$project$Ui$background($author$project$MyUi$background3),
						$author$project$Ui$height(
						$author$project$Ui$px($author$project$MyUi$channelHeaderHeight)),
						$author$project$MyUi$noShrinking
					]),
				_List_fromArray(
					[
						$author$project$ChannelHeader$headerBackButton$(
						$lamdera$program_test$Effect$Browser$Dom$id('guild_memberColumnBack'),
						$author$project$Types$PressedMemberListBack),
						function () {
						if (threadRoute.$ === 1) {
							return $author$project$Ui$text('Thread members');
						} else {
							return $author$project$Ui$text('Channel members');
						}
					}()
					])),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$background($author$project$MyUi$background2),
						$author$project$Ui$Font$color($author$project$MyUi$font1),
						$author$project$Ui$paddingWith(
						{bottom: localUser.safeAreaInsetBottom + 16, left: 0, right: 0, top: 16}),
						$author$project$MyUi$scrollable(canScroll2),
						$author$project$Ui$heightMin(0)
					]),
				_List_fromArray(
					[
						$author$project$Pages$Guild$discordChannelSettingsForm$(localUser, routeData.currentDiscordUserId, routeData.guildId, channelId, threadRoute),
						$author$project$Pages$Guild$discordMemberListView$(true, routeData.currentDiscordUserId, localUser, routeData.guildId, guild, channelId)
					]))
			]));
};
var $author$project$Pages$Guild$discordChannelSettingsMobile = F6($author$project$Pages$Guild$discordChannelSettingsMobile$);
var $author$project$Ui$Lazy$apply6$ = function (fn, a, b, c, d, e, f, s) {
	return $author$project$Internal$Model2$unwrap$(
		s,
		A6(fn, a, b, c, d, e, f));
};
var $author$project$Ui$Lazy$apply6 = F8($author$project$Ui$Lazy$apply6$);
var $elm$virtual_dom$VirtualDom$lazy8 = _VirtualDom_lazy8;
var $elm$html$Html$Lazy$lazy8 = $elm$virtual_dom$VirtualDom$lazy8;
var $author$project$Ui$Lazy$lazy6$ = function (fn, a, b, c, d, e, f) {
	return function (s) {
		return A9($elm$html$Html$Lazy$lazy8, $author$project$Ui$Lazy$apply6, fn, a, b, c, d, e, f, s);
	};
};
var $author$project$Ui$Lazy$lazy6 = F7($author$project$Ui$Lazy$lazy6$);
var $author$project$Types$PressedHideMembers = {$: 59};
var $author$project$MyUi$memberColumnWidth = 300;
var $author$project$Pages$Guild$memberColumnContainerNotMobile$ = function (isThread, contents) {
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$Ui$alignRight,
				$author$project$Ui$background($author$project$MyUi$background2),
				$author$project$Ui$Font$color($author$project$MyUi$font1),
				$author$project$Ui$width(
				$author$project$Ui$px($author$project$MyUi$memberColumnWidth)),
				$author$project$Ui$heightMin(0),
				$author$project$Ui$borderWith(
				{bottom: 0, left: 1, right: 0, top: 0}),
				$author$project$Ui$borderColor($author$project$MyUi$border2)
			]),
		_List_fromArray(
			[
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$height(
						$author$project$Ui$px($author$project$MyUi$channelHeaderHeight + 1)),
						$author$project$MyUi$noShrinking,
						$author$project$Ui$borderWith(
						{bottom: 1, left: 0, right: 0, top: 0}),
						$author$project$Ui$borderColor($author$project$MyUi$border1)
					]),
				_List_fromArray(
					[
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$Font$color($author$project$MyUi$font3),
								$author$project$Ui$paddingXY$(8, 0)
							]),
						isThread ? $author$project$Ui$text('Thread settings') : $author$project$Ui$text('Channel settings')),
						$author$project$MyUi$elButton$(
						$lamdera$program_test$Effect$Browser$Dom$id('guild_hideMembers'),
						$author$project$Types$PressedHideMembers,
						_List_fromArray(
							[
								$author$project$Ui$alignRight,
								$author$project$Ui$width(
								$author$project$Ui$px(24 + 24)),
								$author$project$Ui$height($author$project$Ui$fill),
								$author$project$Ui$paddingXY$(12, 0),
								$author$project$Ui$contentCenterY,
								$author$project$Ui$Font$color($author$project$MyUi$font3),
								$author$project$MyUi$hover$(
								false,
								_List_fromArray(
									[
										$author$project$Ui$Anim$fontColor($author$project$MyUi$font1)
									])),
								$author$project$MyUi$hoverText('Hide members')
							]),
						$author$project$Ui$html($author$project$Icons$x))
					])),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$scrollable,
						$author$project$Ui$heightMin(0)
					]),
				contents)
			]));
};
var $author$project$Pages$Guild$memberColumnContainerNotMobile = F2($author$project$Pages$Guild$memberColumnContainerNotMobile$);
var $author$project$Pages$Guild$discordChannelSettingsNotMobile$ = function (localUser, guildId, currentDiscordUserId, guild, channelId, threadRoute) {
	return $author$project$Pages$Guild$memberColumnContainerNotMobile$(
		function () {
			if (!threadRoute.$) {
				return false;
			} else {
				return true;
			}
		}(),
		_List_fromArray(
			[
				$author$project$Pages$Guild$discordChannelSettingsForm$(localUser, currentDiscordUserId, guildId, channelId, threadRoute),
				$author$project$Ui$Lazy$lazy6$($author$project$Pages$Guild$discordMemberListView, false, currentDiscordUserId, localUser, guildId, guild, channelId)
			]));
};
var $author$project$Pages$Guild$discordChannelSettingsNotMobile = F6($author$project$Pages$Guild$discordChannelSettingsNotMobile$);
var $author$project$Pages$Guild$channelDoesNotExistText = 'Channel does not exist';
var $author$project$Types$MessageInputMsg$ = function (a, b, c) {
	return {$: 147, a: a, b: b, c: c};
};
var $author$project$Types$MessageInputMsg = F3($author$project$Types$MessageInputMsg$);
var $author$project$Types$PressedDeleteAttachedFile$ = function (a, b) {
	return {$: 87, a: a, b: b};
};
var $author$project$Types$PressedDeleteAttachedFile = F2($author$project$Types$PressedDeleteAttachedFile$);
var $author$project$Types$PressedToggleAttachedFileSpoiler$ = function (a, b) {
	return {$: 89, a: a, b: b};
};
var $author$project$Types$PressedToggleAttachedFileSpoiler = F2($author$project$Types$PressedToggleAttachedFileSpoiler$);
var $author$project$Types$PressedViewAttachedFileInfo$ = function (a, b) {
	return {$: 88, a: a, b: b};
};
var $author$project$Types$PressedViewAttachedFileInfo = F2($author$project$Types$PressedViewAttachedFileInfo$);
var $author$project$Types$UserScrolled$ = function (a, b, c) {
	return {$: 60, a: a, b: b, c: c};
};
var $author$project$Types$UserScrolled = F3($author$project$Types$UserScrolled$);
var $author$project$NonemptyDict$all$ = function (predicate, _v0) {
	var id = _v0.a;
	var a = _v0.b;
	var set = _v0.c;
	return A2(predicate, id, a) && $lamdera$containers$SeqDict$foldl$(
		F3(
			function (key, value, state) {
				return state && A2(predicate, key, value);
			}),
		true,
		set);
};
var $author$project$NonemptyDict$all = F2($author$project$NonemptyDict$all$);
var $author$project$ChannelHeader$chattingWithYourself$ = function (data, local) {
	var _v0 = $lamdera$containers$SeqDict$get$(data.channelId, local.discordDmChannels);
	if (!_v0.$) {
		var channel2 = _v0.a;
		return $author$project$NonemptyDict$all$(
			F2(
				function (userId, _v1) {
					return $author$project$LinkedAndOtherDiscordUsers$isLinkedUser$(userId, local.localUser.discordUsers);
				}),
			channel2.members);
	} else {
		return false;
	}
};
var $author$project$ChannelHeader$chattingWithYourself = F2($author$project$ChannelHeader$chattingWithYourself$);
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $author$project$Internal$Model2$unwrapKeyedChildrenHelp$ = function (inheritance, rendered, children) {
	unwrapKeyedChildrenHelp:
	while (true) {
		if (!children.b) {
			return rendered;
		} else {
			var _v1 = children.a;
			var key = _v1.a;
			var toChild = _v1.b;
			var remain = children.b;
			var $temp$rendered = A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					key,
					toChild(inheritance)),
				rendered),
				$temp$children = remain;
			rendered = $temp$rendered;
			children = $temp$children;
			continue unwrapKeyedChildrenHelp;
		}
	}
};
var $author$project$Internal$Model2$unwrapKeyedChildrenHelp = F3($author$project$Internal$Model2$unwrapKeyedChildrenHelp$);
var $author$project$Internal$Model2$unwrapKeyedChildren$ = function (inheritance, rest, children) {
	return $author$project$Internal$Model2$prependReversed$(
		rest,
		$author$project$Internal$Model2$unwrapKeyedChildrenHelp$(inheritance, _List_Nil, children));
};
var $author$project$Internal$Model2$unwrapKeyedChildren = F3($author$project$Internal$Model2$unwrapKeyedChildren$);
var $author$project$Internal$Model2$toChildrenKeyed$ = function (myBits, analyzedBits, attrs, children) {
	if ($author$project$Internal$BitField$has$($author$project$Internal$Bits$Analyze$nearbys, analyzedBits)) {
		var behind = $elm$core$List$map$(
			$elm$core$Tuple$pair('behind'),
			$author$project$Internal$Model2$toBehindElements$(myBits, _List_Nil, attrs));
		var after = $elm$core$List$map$(
			$elm$core$Tuple$pair('after'),
			$author$project$Internal$Model2$toNearbyElements$(myBits, _List_Nil, attrs));
		return _Utils_ap(
			behind,
			$author$project$Internal$Model2$unwrapKeyedChildren$(myBits, after, children));
	} else {
		return $author$project$Internal$Model2$unwrapKeyedChildren$(myBits, _List_Nil, children);
	}
};
var $author$project$Internal$Model2$toChildrenKeyed = F4($author$project$Internal$Model2$toChildrenKeyed$);
var $author$project$Internal$Model2$elementKeyed$ = function (node, layout, attrs, children) {
	return function (parentBits) {
		var myBaseBits = function () {
			switch (layout) {
				case 0:
					return A2($author$project$Internal$BitField$flip, $author$project$Internal$Bits$Inheritance$isRow, true);
				case 1:
					return A2($author$project$Internal$BitField$flip, $author$project$Internal$Bits$Inheritance$isColumn, true);
				case 4:
					return A2($author$project$Internal$BitField$flip, $author$project$Internal$Bits$Inheritance$isTextLayout, true);
				case 5:
					return A2($author$project$Internal$BitField$flip, $author$project$Internal$Bits$Inheritance$isTextLayout, true);
				default:
					return $elm$core$Basics$identity;
			}
		}()(
			$author$project$Internal$Bits$Inheritance$clearParentValues(parentBits));
		var _v0 = $author$project$Internal$Model2$analyze$($author$project$Internal$Flag$none, $author$project$Internal$BitField$init, myBaseBits, attrs);
		var analyzedBits = _v0.a;
		var myBits = _v0.b;
		var iHave = _v0.c;
		var finalChildren = $author$project$Internal$Model2$toChildrenKeyed$(myBits, analyzedBits, attrs, children);
		var htmlAttrs = function () {
			if ($author$project$Internal$BitField$has$($author$project$Internal$Bits$Inheritance$isTextLayout, parentBits) && $author$project$Internal$BitField$has$($author$project$Internal$Flag$xAlign, iHave)) {
				var spacingY = $author$project$Internal$BitField$get$($author$project$Internal$Bits$Inheritance$spacingY, parentBits);
				var spacingX = $author$project$Internal$BitField$get$($author$project$Internal$Bits$Inheritance$spacingX, parentBits);
				var margin = A2(
					$elm$html$Html$Attributes$style,
					'margin',
					$elm$core$String$fromInt(spacingY) + ('px' + (' ' + ($elm$core$String$fromInt(spacingX) + 'px'))));
				return $author$project$Internal$Model2$toAttrs$(
					parentBits,
					myBits,
					$author$project$Internal$Flag$none,
					_List_fromArray(
						[margin]),
					attrs);
			} else {
				return $author$project$Internal$Model2$toAttrs$(parentBits, myBits, $author$project$Internal$Flag$none, _List_Nil, attrs);
			}
		}();
		var styleAttrs = $author$project$Internal$BitField$has$($author$project$Internal$Bits$Analyze$cssVars, analyzedBits) ? $author$project$Internal$Model2$toStyleAsEncodedProperty$(
			parentBits,
			myBits,
			analyzedBits,
			$author$project$Internal$Flag$none,
			$author$project$Internal$Model2$contextClasses(layout),
			htmlAttrs,
			'',
			$elm$core$List$reverse(attrs)) : $author$project$Internal$Model2$toStyle$(
			parentBits,
			myBits,
			analyzedBits,
			$author$project$Internal$Flag$none,
			htmlAttrs,
			$author$project$Internal$Model2$contextClasses(layout),
			$elm$core$List$reverse(attrs));
		if ($author$project$Internal$BitField$has$($author$project$Internal$Bits$Analyze$isLink, analyzedBits)) {
			return A3($elm$html$Html$Keyed$node, 'a', styleAttrs, finalChildren);
		} else {
			if ($author$project$Internal$BitField$has$($author$project$Internal$Bits$Analyze$isButton, analyzedBits)) {
				return A3($elm$html$Html$Keyed$node, 'button', styleAttrs, finalChildren);
			} else {
				switch (node.$) {
					case 0:
						return A3($elm$html$Html$Keyed$node, 'div', styleAttrs, finalChildren);
					case 1:
						return A3($elm$html$Html$Keyed$node, 'span', styleAttrs, finalChildren);
					case 2:
						return A3($elm$html$Html$Keyed$node, 'a', styleAttrs, finalChildren);
					case 3:
						return A3($elm$html$Html$Keyed$node, 'p', styleAttrs, finalChildren);
					case 4:
						return A3($elm$html$Html$Keyed$node, 'button', styleAttrs, finalChildren);
					case 5:
						return A3($elm$html$Html$Keyed$node, 'table', styleAttrs, finalChildren);
					case 6:
						return A3($elm$html$Html$Keyed$node, 'thead', styleAttrs, finalChildren);
					case 7:
						return A3($elm$html$Html$Keyed$node, 'th', styleAttrs, finalChildren);
					case 8:
						return A3($elm$html$Html$Keyed$node, 'tr', styleAttrs, finalChildren);
					case 11:
						return A3($elm$html$Html$Keyed$node, 'tbody', styleAttrs, finalChildren);
					case 9:
						return A3($elm$html$Html$Keyed$node, 'td', styleAttrs, finalChildren);
					case 10:
						return A3($elm$html$Html$Keyed$node, 'tfoot', styleAttrs, finalChildren);
					case 12:
						return A3($elm$html$Html$Keyed$node, 'label', styleAttrs, finalChildren);
					case 13:
						return A3($elm$html$Html$Keyed$node, 'input', styleAttrs, finalChildren);
					case 14:
						return A3($elm$html$Html$Keyed$node, 'textarea', styleAttrs, finalChildren);
					case 30:
						return A3($elm$html$Html$Keyed$node, 'img', styleAttrs, finalChildren);
					case 15:
						return A3($elm$html$Html$Keyed$node, 'h1', styleAttrs, finalChildren);
					case 16:
						return A3($elm$html$Html$Keyed$node, 'h2', styleAttrs, finalChildren);
					case 17:
						return A3($elm$html$Html$Keyed$node, 'h3', styleAttrs, finalChildren);
					case 18:
						return A3($elm$html$Html$Keyed$node, 'h4', styleAttrs, finalChildren);
					case 19:
						return A3($elm$html$Html$Keyed$node, 'h5', styleAttrs, finalChildren);
					case 20:
						return A3($elm$html$Html$Keyed$node, 'h6', styleAttrs, finalChildren);
					case 21:
						return A3($elm$html$Html$Keyed$node, 'nav', styleAttrs, finalChildren);
					case 22:
						return A3($elm$html$Html$Keyed$node, 'main', styleAttrs, finalChildren);
					case 23:
						return A3($elm$html$Html$Keyed$node, 'aside', styleAttrs, finalChildren);
					case 24:
						return A3($elm$html$Html$Keyed$node, 'section', styleAttrs, finalChildren);
					case 25:
						return A3($elm$html$Html$Keyed$node, 'article', styleAttrs, finalChildren);
					case 26:
						return A3($elm$html$Html$Keyed$node, 'footer', styleAttrs, finalChildren);
					case 27:
						return A3($elm$html$Html$Keyed$node, 'ol', styleAttrs, finalChildren);
					case 28:
						return A3($elm$html$Html$Keyed$node, 'ul', styleAttrs, finalChildren);
					case 29:
						return A3($elm$html$Html$Keyed$node, 'li', styleAttrs, finalChildren);
					default:
						var nodeName = node.a;
						return A3($elm$html$Html$Keyed$node, nodeName, styleAttrs, finalChildren);
				}
			}
		}
	};
};
var $author$project$Internal$Model2$elementKeyed = F4($author$project$Internal$Model2$elementKeyed$);
var $author$project$Ui$Keyed$column$ = function (attrs, children) {
	return $author$project$Internal$Model2$elementKeyed$($author$project$Internal$Model2$NodeAsDiv, 1, attrs, children);
};
var $author$project$Ui$Keyed$column = F2($author$project$Ui$Keyed$column$);
var $author$project$Scroll$ScrolledToTop = 2;
var $author$project$Scroll$closeToBottom = 300;
var $author$project$Scroll$decodeScrollToBottom$ = function (onScroll, currentScrollPosition) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (scrollPosition) {
			return _Utils_eq(scrollPosition, currentScrollPosition) ? $elm$json$Json$Decode$fail('') : $elm$json$Json$Decode$succeed(
				onScroll(scrollPosition));
		},
		A4(
			$elm$json$Json$Decode$map3,
			F3(
				function (scrollTop, scrollHeight, clientHeight) {
					return (_Utils_cmp(scrollTop + clientHeight, scrollHeight - 5) > -1) ? 0 : ((_Utils_cmp(scrollTop, $author$project$Scroll$closeToTop) < 1) ? 2 : ((_Utils_cmp(scrollTop + clientHeight, scrollHeight - $author$project$Scroll$closeToBottom) > -1) ? 1 : 3));
				}),
			$elm$json$Json$Decode$at$(
				_List_fromArray(
					['target', 'scrollTop']),
				$elm$json$Json$Decode$float),
			$elm$json$Json$Decode$at$(
				_List_fromArray(
					['target', 'scrollHeight']),
				$elm$json$Json$Decode$float),
			$elm$json$Json$Decode$at$(
				_List_fromArray(
					['target', 'clientHeight']),
				$elm$json$Json$Decode$float)));
};
var $author$project$Scroll$decodeScrollToBottom = F2($author$project$Scroll$decodeScrollToBottom$);
var $author$project$Icons$attachment = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor'),
			$elm$svg$Svg$Attributes$width('24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13')
				]),
			_List_Nil)
		]));
var $author$project$MyUi$disabledButtonBackground = $author$project$Ui$rgb$(112, 113, 113);
var $elm$html$Html$Attributes$boolProperty$ = function (key, bool) {
	return A2(
		_VirtualDom_property,
		key,
		$elm$json$Json$Encode$bool(bool));
};
var $elm$html$Html$Attributes$boolProperty = F2($elm$html$Html$Attributes$boolProperty$);
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $author$project$MyUi$dimFont = $author$project$Ui$rgb$(180, 180, 180);
var $author$project$MessageInput$textPlaceholder = function (text) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$style,
				'color',
				$author$project$MyUi$colorToStyle($author$project$MyUi$dimFont))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(text)
			]));
};
var $author$project$MessageInput$emptyPlaceholder = $author$project$MessageInput$textPlaceholder('\u00A0');
var $author$project$Sticker$LoopForever = 2;
var $avh4$elm_color$Color$fromRgba = function (components) {
	return $avh4$elm_color$Color$RgbaSpace$(components.red, components.green, components.blue, components.alpha);
};
var $author$project$MyUi$colorWithAlpha$ = function (alpha, color) {
	var color2 = $avh4$elm_color$Color$toRgba(color);
	return $avh4$elm_color$Color$fromRgba(
		_Utils_update(
			color2,
			{alpha: alpha}));
};
var $author$project$MyUi$colorWithAlpha = F2($author$project$MyUi$colorWithAlpha$);
var $author$project$RichText$codeBackground = $author$project$MyUi$colorToStyle(
	$author$project$MyUi$colorWithAlpha$(0.5, $author$project$MyUi$background1));
var $author$project$RichText$emojiSizeInInput = '1.4em';
var $elm$svg$Svg$Attributes$preserveAspectRatio = _VirtualDom_attribute('preserveAspectRatio');
var $author$project$Twemoji$overlaySpriteView$ = function (size, sprite, emoji) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'position', 'relative'),
				A2($elm$html$Html$Attributes$style, 'visibility', 'hidden')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(emoji),
				A2(
				$elm$svg$Svg$svg,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$viewBox('0 0 36 36'),
						$elm$svg$Svg$Attributes$preserveAspectRatio('xMidYMid meet'),
						A2($elm$html$Html$Attributes$style, 'visibility', 'visible'),
						A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
						A2($elm$html$Html$Attributes$style, 'left', '50%'),
						A2($elm$html$Html$Attributes$style, 'top', '50%'),
						A2($elm$html$Html$Attributes$style, 'width', size),
						A2($elm$html$Html$Attributes$style, 'height', size),
						A2($elm$html$Html$Attributes$style, 'transform', 'translate(-50%, -50%)')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$use,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$xlinkHref(
								$author$project$Twemoji$spriteReference$(sprite, emoji))
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Twemoji$overlaySpriteView = F3($author$project$Twemoji$overlaySpriteView$);
var $author$project$Emoji$EmojiArtwork = function (a) {
	return {$: 1, a: a};
};
var $author$project$Emoji$PlainText = function (a) {
	return {$: 0, a: a};
};
var $author$project$Emoji$flushPlainText$ = function (text, start, end, output) {
	return (_Utils_cmp(start, end) < 0) ? A2(
		$elm$core$List$cons,
		$author$project$Emoji$PlainText(
			A3($elm$core$String$slice, start, end, text)),
		output) : output;
};
var $author$project$Emoji$flushPlainText = F4($author$project$Emoji$flushPlainText$);
var $author$project$Emoji$splitOnEmojiHelper$ = function (emojiData, text, length, textStart, index, output) {
	splitOnEmojiHelper:
	while (true) {
		if (_Utils_cmp(index, length) > -1) {
			return $author$project$Emoji$flushPlainText$(text, textStart, index, output);
		} else {
			var _v0 = $author$project$Emoji$artStartingWith$(
				emojiData,
				A3($elm$core$String$slice, index, index + (2 * $author$project$Emoji$maxEmojiLength), text));
			if (!_v0.$) {
				var art = _v0.a;
				var next = index + $elm$core$String$length(art.sequence);
				var $temp$textStart = next,
					$temp$index = next,
					$temp$output = A2(
					$elm$core$List$cons,
					$author$project$Emoji$EmojiArtwork(art),
					$author$project$Emoji$flushPlainText$(text, textStart, index, output));
				textStart = $temp$textStart;
				index = $temp$index;
				output = $temp$output;
				continue splitOnEmojiHelper;
			} else {
				var $temp$index = index + 1;
				index = $temp$index;
				continue splitOnEmojiHelper;
			}
		}
	}
};
var $author$project$Emoji$splitOnEmojiHelper = F6($author$project$Emoji$splitOnEmojiHelper$);
var $author$project$Emoji$splitOnEmoji$ = function (emojiData, text) {
	return $elm$core$List$reverse(
		$author$project$Emoji$splitOnEmojiHelper$(
			emojiData,
			text,
			$elm$core$String$length(text),
			0,
			0,
			_List_Nil));
};
var $author$project$Emoji$splitOnEmoji = F2($author$project$Emoji$splitOnEmoji$);
var $author$project$Emoji$inputTextView$ = function (size, maybeEmojiData, text) {
	if (!maybeEmojiData.$) {
		var emojiData = maybeEmojiData.a;
		return $elm$core$List$map$(
			function (piece) {
				if (!piece.$) {
					var text2 = piece.a;
					return $elm$html$Html$text(text2);
				} else {
					var art = piece.a;
					return $author$project$Twemoji$overlaySpriteView$(size, art.sprite, art.sequence);
				}
			},
			$author$project$Emoji$splitOnEmoji$(emojiData, text));
	} else {
		return _List_fromArray(
			[
				$elm$html$Html$text(text)
			]);
	}
};
var $author$project$Emoji$inputTextView = F3($author$project$Emoji$inputTextView$);
var $author$project$RichText$emojiTextWithSelection$ = function (emojiData, selection, startIndex, text) {
	if (!selection.$) {
		var end = selection.a.end;
		var start = selection.a.start;
		var selectionStart = $elm$core$Basics$clamp$(
			0,
			$elm$core$String$length(text),
			start - startIndex);
		var selectionEnd = $elm$core$Basics$clamp$(
			0,
			$elm$core$String$length(text),
			end - startIndex);
		return (_Utils_cmp(selectionEnd, selectionStart) < 1) ? $author$project$Emoji$inputTextView$($author$project$RichText$emojiSizeInInput, emojiData, text) : _Utils_ap(
			$author$project$Emoji$inputTextView$(
				$author$project$RichText$emojiSizeInInput,
				emojiData,
				$elm$core$String$left$(selectionStart, text)),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$Attributes$style,
								'background-color',
								$author$project$MyUi$colorToStyle($author$project$MyUi$selectedTextBackground))
							]),
						$author$project$Emoji$inputTextView$(
							$author$project$RichText$emojiSizeInInput,
							emojiData,
							A3($elm$core$String$slice, selectionStart, selectionEnd, text)))
					]),
				$author$project$Emoji$inputTextView$(
					$author$project$RichText$emojiSizeInInput,
					emojiData,
					$elm$core$String$dropLeft$(selectionEnd, text))));
	} else {
		return $author$project$Emoji$inputTextView$($author$project$RichText$emojiSizeInInput, emojiData, text);
	}
};
var $author$project$RichText$emojiTextWithSelection = F4($author$project$RichText$emojiTextWithSelection$);
var $author$project$RichText$textWithSelection$ = function (selection, startIndex, text) {
	if (!selection.$) {
		var end = selection.a.end;
		var start = selection.a.start;
		var selectionStart = $elm$core$Basics$clamp$(
			0,
			$elm$core$String$length(text),
			start - startIndex);
		var selectionEnd = $elm$core$Basics$clamp$(
			0,
			$elm$core$String$length(text),
			end - startIndex);
		return (_Utils_cmp(selectionEnd, selectionStart) < 1) ? _List_fromArray(
			[
				$elm$html$Html$text(text)
			]) : _List_fromArray(
			[
				$elm$html$Html$text(
				$elm$core$String$left$(selectionStart, text)),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$Attributes$style,
						'background-color',
						$author$project$MyUi$colorToStyle($author$project$MyUi$selectedTextBackground))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A3($elm$core$String$slice, selectionStart, selectionEnd, text))
					])),
				$elm$html$Html$text(
				$elm$core$String$dropLeft$(selectionEnd, text))
			]);
	} else {
		return _List_fromArray(
			[
				$elm$html$Html$text(text)
			]);
	}
};
var $author$project$RichText$textWithSelection = F3($author$project$RichText$textWithSelection$);
var $author$project$RichText$formatText$ = function (selection, startIndex, text) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'color', 'rgb(140,140,140)')
			]),
		$author$project$RichText$textWithSelection$(selection, startIndex, text));
};
var $author$project$RichText$formatText = F3($author$project$RichText$formatText$);
var $author$project$RichText$htmlAttrIf$ = function (condition, attribute) {
	return condition ? attribute : A2($elm$html$Html$Attributes$style, '', '');
};
var $author$project$RichText$htmlAttrIf = F2($author$project$RichText$htmlAttrIf$);
var $author$project$MyUi$userLabelFontColor = $author$project$Ui$rgb$(215, 235, 255);
var $author$project$RichText$mentionInputView$ = function (selection, index, text) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$style,
				'color',
				$author$project$MyUi$colorToStyle($author$project$MyUi$userLabelFontColor)),
				A2($elm$html$Html$Attributes$style, 'background-color', 'rgba(57,77,255,0.5)'),
				A2($elm$html$Html$Attributes$style, 'border-radius', '2px')
			]),
		$author$project$RichText$textWithSelection$(selection, index, text));
};
var $author$project$RichText$mentionInputView = F3($author$project$RichText$mentionInputView$);
var $author$project$RichText$spoilerBackground = $author$project$MyUi$colorToStyle($author$project$MyUi$black);
var $author$project$MyUi$textLinkColor = $author$project$Ui$rgb$(66, 93, 203);
var $author$project$Sticker$stickerFailedToLoadText = 'Sticker failed to load';
var $author$project$FileStatus$discordStickerUrl$ = function (stickerId, format) {
	return $author$project$FileStatus$domain + ('/file/discord-sticker/' + ($author$project$Discord$idToString(stickerId) + function () {
		switch (format) {
			case 0:
				return '.png';
			case 1:
				return '.png';
			case 2:
				return '.json';
			default:
				return '.gif';
		}
	}()));
};
var $author$project$FileStatus$discordStickerUrl = F2($author$project$FileStatus$discordStickerUrl$);
var $author$project$FileStatus$jsonContent = $author$project$FileStatus$contentType('application/json');
var $author$project$Sticker$lottieView$ = function (stickerSize2, url, animationMode) {
	return A3(
		$elm$html$Html$node,
		'lottie-player',
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'width', stickerSize2),
				A2($elm$html$Html$Attributes$style, 'height', stickerSize2),
				A2($elm$html$Html$Attributes$style, 'display', 'inline-block'),
				A2($elm$html$Html$Attributes$attribute, 'src', url),
				A2(
				$elm$html$Html$Attributes$attribute,
				'start-playing',
				$author$project$Sticker$animationModeToInt(animationMode)),
				A2(
				$elm$html$Html$Attributes$style,
				'background-color',
				$author$project$Env$isProduction ? 'transparent' : 'rgba(0,0,0,0.1)')
			]),
		_List_Nil);
};
var $author$project$Sticker$lottieView = F3($author$project$Sticker$lottieView$);
var $author$project$Sticker$viewHelper$ = function (stickerSize2, sticker, animationMode) {
	var _v0 = sticker.url;
	switch (_v0.$) {
		case 2:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'width', stickerSize2),
						A2($elm$html$Html$Attributes$style, 'height', stickerSize2),
						A2($elm$html$Html$Attributes$style, 'background-color', 'gray'),
						A2($elm$html$Html$Attributes$style, 'display', 'block')
					]),
				_List_Nil);
		case 0:
			var fileHash = _v0.a;
			var _v1 = sticker.format;
			switch (_v1) {
				case 0:
					return A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'width', stickerSize2),
								A2($elm$html$Html$Attributes$style, 'height', stickerSize2),
								$elm$html$Html$Attributes$src(
								$author$project$FileStatus$fileUrl$($author$project$FileStatus$pngContent, fileHash)),
								$author$project$MyUi$lazyLoading,
								A2($elm$html$Html$Attributes$style, 'display', 'block')
							]),
						_List_Nil);
				case 1:
					return $author$project$Sticker$animatedImageView$(
						false,
						stickerSize2,
						stickerSize2,
						$elm$core$Maybe$Nothing,
						$author$project$FileStatus$fileUrl$($author$project$FileStatus$pngContent, fileHash),
						animationMode);
				case 2:
					return $author$project$Sticker$lottieView$(
						stickerSize2,
						$author$project$FileStatus$fileUrl$($author$project$FileStatus$jsonContent, fileHash),
						animationMode);
				default:
					return $author$project$Sticker$animatedImageView$(
						false,
						stickerSize2,
						stickerSize2,
						$elm$core$Maybe$Nothing,
						$author$project$FileStatus$fileUrl$($author$project$FileStatus$gifContent, fileHash),
						animationMode);
			}
		default:
			var discordStickerId = _v0.a;
			var _v2 = sticker.format;
			if (_v2 === 2) {
				return $author$project$Sticker$lottieView$(
					stickerSize2,
					$author$project$FileStatus$discordStickerUrl$(discordStickerId, sticker.format),
					animationMode);
			} else {
				return $author$project$Sticker$animatedImageView$(
					false,
					stickerSize2,
					stickerSize2,
					$elm$core$Maybe$Nothing,
					$author$project$FileStatus$discordStickerUrl$(discordStickerId, sticker.format),
					animationMode);
			}
	}
};
var $author$project$Sticker$viewHelper = F3($author$project$Sticker$viewHelper$);
var $author$project$Sticker$view$ = function (stickerSize2, stickerId, stickers2, animationMode) {
	var _v0 = $lamdera$containers$SeqDict$get$(stickerId, stickers2);
	if (!_v0.$) {
		var sticker = _v0.a;
		return $author$project$Sticker$viewHelper$(stickerSize2, sticker, animationMode);
	} else {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', stickerSize2),
					A2($elm$html$Html$Attributes$style, 'height', stickerSize2),
					A2($elm$html$Html$Attributes$style, 'background-color', 'gray')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text($author$project$Sticker$stickerFailedToLoadText)
				]));
	}
};
var $author$project$Sticker$view = F4($author$project$Sticker$view$);
var $author$project$RichText$textInputViewHelper$ = function (timezone, emojiData, state, allUsers, channels, attachedFiles, customEmojis2, stickers2, index, selection, list, inBlockQuote, output) {
	return $elm$core$List$foldl$(
		F2(
			function (item, _v0) {
				var index2 = _v0.a;
				var output2 = _v0.b;
				switch (item.$) {
					case 0:
						var userId = item.a;
						var _v2 = $lamdera$containers$SeqDict$get$(userId, allUsers);
						if (!_v2.$) {
							var user = _v2.a;
							var text = '@' + $author$project$PersonName$toString(user.name);
							return _Utils_Tuple2(
								index2 + $elm$core$String$length(text),
								$elm$core$Array$push$(
									$author$project$RichText$mentionInputView$(selection, index2, text),
									output2));
						} else {
							return _Utils_Tuple2(index2 + 1, output2);
						}
					case 1:
						var channel = item.a;
						var maybeThread = item.b;
						var _v3 = $lamdera$containers$SeqDict$get$(
							_Utils_Tuple2(channel, maybeThread),
							channels);
						if (!_v3.$) {
							var name = _v3.a.name;
							var text = '#' + name;
							return _Utils_Tuple2(
								index2 + $elm$core$String$length(text),
								$elm$core$Array$push$(
									$author$project$RichText$mentionInputView$(selection, index2, text),
									output2));
						} else {
							return _Utils_Tuple2(index2 + 1, output2);
						}
					case 2:
						var _char = item.a;
						var text = item.b;
						var text2 = A2($elm$core$String$cons, _char, text);
						var helper = F2(
							function (startIndex, text4) {
								return A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$author$project$RichText$htmlAttrIf$(
											state.underline,
											A2($elm$html$Html$Attributes$style, 'text-decoration', 'underline')),
											$author$project$RichText$htmlAttrIf$(
											state.bold,
											A2($elm$html$Html$Attributes$style, 'text-shadow', '0.7px 0px 0px white')),
											$author$project$RichText$htmlAttrIf$(
											state.strikethrough,
											A2($elm$html$Html$Attributes$style, 'text-decoration', 'line-through')),
											$author$project$RichText$htmlAttrIf$(
											state.spoiler,
											A2($elm$html$Html$Attributes$style, 'background-color', $author$project$RichText$spoilerBackground))
										]),
									$author$project$RichText$emojiTextWithSelection$(emojiData, selection, startIndex, text4));
							});
						if (inBlockQuote) {
							var _v4 = $elm$core$String$split$('\u000A', text2);
							if (_v4.b) {
								var first = _v4.a;
								var rest = _v4.b;
								return $elm$core$List$foldl$(
									F2(
										function (line, _v5) {
											var index3 = _v5.a;
											var output3 = _v5.b;
											return _Utils_Tuple2(
												(index3 + 3) + $elm$core$String$length(line),
												$elm$core$Array$push$(
													A2(helper, index3 + 3, line),
													$elm$core$Array$push$(
														$author$project$RichText$formatText$(selection, index3, '\u000A> '),
														output3)));
										}),
									_Utils_Tuple2(
										index2 + $elm$core$String$length(first),
										$elm$core$Array$push$(
											A2(helper, index2, first),
											output2)),
									rest);
							} else {
								return _Utils_Tuple2(index2, output2);
							}
						} else {
							return _Utils_Tuple2(
								index2 + $elm$core$String$length(text2),
								$elm$core$Array$push$(
									A2(helper, index2, text2),
									output2));
						}
					case 4:
						var nonempty2 = item.a;
						var _v6 = $author$project$RichText$textInputViewHelper$(
							timezone,
							emojiData,
							_Utils_update(
								state,
								{italic: true}),
							allUsers,
							channels,
							attachedFiles,
							customEmojis2,
							stickers2,
							index2 + 1,
							selection,
							$mgold$elm_nonempty_list$List$Nonempty$toList(nonempty2),
							inBlockQuote,
							$elm$core$Array$push$(
								$author$project$RichText$formatText$(selection, index2, '_'),
								output2));
						var index3 = _v6.a;
						var output3 = _v6.b;
						return _Utils_Tuple2(
							index3 + 1,
							$elm$core$Array$push$(
								$author$project$RichText$formatText$(selection, index3, '_'),
								output3));
					case 5:
						var nonempty2 = item.a;
						var _v7 = $author$project$RichText$textInputViewHelper$(
							timezone,
							emojiData,
							_Utils_update(
								state,
								{underline: true}),
							allUsers,
							channels,
							attachedFiles,
							customEmojis2,
							stickers2,
							index2 + 2,
							selection,
							$mgold$elm_nonempty_list$List$Nonempty$toList(nonempty2),
							inBlockQuote,
							$elm$core$Array$push$(
								$author$project$RichText$formatText$(selection, index2, '__'),
								output2));
						var index3 = _v7.a;
						var output3 = _v7.b;
						return _Utils_Tuple2(
							index3 + 2,
							$elm$core$Array$push$(
								$author$project$RichText$formatText$(selection, index3, '__'),
								output3));
					case 3:
						var nonempty2 = item.a;
						var _v8 = $author$project$RichText$textInputViewHelper$(
							timezone,
							emojiData,
							_Utils_update(
								state,
								{bold: true}),
							allUsers,
							channels,
							attachedFiles,
							customEmojis2,
							stickers2,
							index2 + 1,
							selection,
							$mgold$elm_nonempty_list$List$Nonempty$toList(nonempty2),
							inBlockQuote,
							$elm$core$Array$push$(
								$author$project$RichText$formatText$(selection, index2, '*'),
								output2));
						var index3 = _v8.a;
						var output3 = _v8.b;
						return _Utils_Tuple2(
							index3 + 1,
							$elm$core$Array$push$(
								$author$project$RichText$formatText$(selection, index3, '*'),
								output3));
					case 6:
						var nonempty2 = item.a;
						var _v9 = $author$project$RichText$textInputViewHelper$(
							timezone,
							emojiData,
							_Utils_update(
								state,
								{strikethrough: true}),
							allUsers,
							channels,
							attachedFiles,
							customEmojis2,
							stickers2,
							index2 + 2,
							selection,
							$mgold$elm_nonempty_list$List$Nonempty$toList(nonempty2),
							inBlockQuote,
							$elm$core$Array$push$(
								$author$project$RichText$formatText$(selection, index2, '~~'),
								output2));
						var index3 = _v9.a;
						var output3 = _v9.b;
						return _Utils_Tuple2(
							index3 + 2,
							$elm$core$Array$push$(
								$author$project$RichText$formatText$(selection, index3, '~~'),
								output3));
					case 7:
						var nonempty2 = item.a;
						var _v10 = $author$project$RichText$textInputViewHelper$(
							timezone,
							emojiData,
							_Utils_update(
								state,
								{spoiler: true}),
							allUsers,
							channels,
							attachedFiles,
							customEmojis2,
							stickers2,
							index2 + 2,
							selection,
							$mgold$elm_nonempty_list$List$Nonempty$toList(nonempty2),
							inBlockQuote,
							$elm$core$Array$push$(
								$author$project$RichText$formatText$(selection, index2, '||'),
								output2));
						var index3 = _v10.a;
						var output3 = _v10.b;
						return _Utils_Tuple2(
							index3 + 2,
							$elm$core$Array$push$(
								$author$project$RichText$formatText$(selection, index3, '||'),
								output3));
					case 8:
						var hasLeadingLineBreak = item.a;
						var nonempty2 = item.b;
						var marker = function () {
							if (!hasLeadingLineBreak) {
								return '\u000A> ';
							} else {
								return '> ';
							}
						}();
						return $author$project$RichText$textInputViewHelper$(
							timezone,
							emojiData,
							state,
							allUsers,
							channels,
							attachedFiles,
							customEmojis2,
							stickers2,
							index2 + $elm$core$String$length(marker),
							selection,
							nonempty2,
							true,
							$elm$core$Array$push$(
								$author$project$RichText$formatText$(selection, index2, marker),
								output2));
					case 9:
						var level = item.a;
						var hasLeadingLineBreak = item.b;
						var nonempty2 = item.c;
						var marker = _Utils_ap(
							function () {
								if (!hasLeadingLineBreak) {
									return '\u000A';
								} else {
									return '';
								}
							}(),
							$author$project$RichText$headingLevelToMarker(level));
						return $author$project$RichText$textInputViewHelper$(
							timezone,
							emojiData,
							state,
							allUsers,
							channels,
							attachedFiles,
							customEmojis2,
							stickers2,
							index2 + $elm$core$String$length(marker),
							selection,
							$mgold$elm_nonempty_list$List$Nonempty$toList(nonempty2),
							inBlockQuote,
							$elm$core$Array$push$(
								$author$project$RichText$formatText$(selection, index2, marker),
								output2));
					case 10:
						var data = item.a;
						var text = $elm$url$Url$toString(data);
						return _Utils_Tuple2(
							index2 + $elm$core$String$length(text),
							$elm$core$Array$push$(
								A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$author$project$RichText$htmlAttrIf$(
											state.underline,
											A2($elm$html$Html$Attributes$style, 'text-decoration', 'underline')),
											$author$project$RichText$htmlAttrIf$(
											state.bold,
											A2($elm$html$Html$Attributes$style, 'text-shadow', '0.7px 0px 0px white')),
											$author$project$RichText$htmlAttrIf$(
											state.strikethrough,
											A2($elm$html$Html$Attributes$style, 'text-decoration', 'line-through')),
											$author$project$RichText$htmlAttrIf$(
											state.spoiler,
											A2($elm$html$Html$Attributes$style, 'background-color', $author$project$RichText$spoilerBackground)),
											A2(
											$elm$html$Html$Attributes$style,
											'color',
											$author$project$MyUi$colorToStyle($author$project$MyUi$textLinkColor))
										]),
									$author$project$RichText$textWithSelection$(selection, index2, text)),
								output2));
					case 11:
						var alias = item.a;
						var url = item.b;
						var text = '[' + ($MartinSStewart$elm_nonempty_string$String$Nonempty$toString(alias) + ('](' + ($elm$url$Url$toString(url) + ')')));
						return _Utils_Tuple2(
							index2 + $elm$core$String$length(text),
							$elm$core$Array$push$(
								A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$author$project$RichText$htmlAttrIf$(
											state.underline,
											A2($elm$html$Html$Attributes$style, 'text-decoration', 'underline')),
											$author$project$RichText$htmlAttrIf$(
											state.bold,
											A2($elm$html$Html$Attributes$style, 'text-shadow', '0.7px 0px 0px white')),
											$author$project$RichText$htmlAttrIf$(
											state.strikethrough,
											A2($elm$html$Html$Attributes$style, 'text-decoration', 'line-through')),
											$author$project$RichText$htmlAttrIf$(
											state.spoiler,
											A2($elm$html$Html$Attributes$style, 'background-color', $author$project$RichText$spoilerBackground)),
											A2(
											$elm$html$Html$Attributes$style,
											'color',
											$author$project$MyUi$colorToStyle($author$project$MyUi$textLinkColor))
										]),
									$author$project$RichText$textWithSelection$(selection, index2, text)),
								output2));
					case 12:
						var _char = item.a;
						var rest = item.b;
						return _Utils_Tuple2(
							(index2 + $elm$core$String$length(rest)) + 3,
							$elm$core$Array$append$(
								output2,
								$elm$core$Array$fromList(
									_List_fromArray(
										[
											$author$project$RichText$formatText$(selection, index2, '`'),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$RichText$htmlAttrIf$(
													state.underline,
													A2($elm$html$Html$Attributes$style, 'text-decoration', 'underline')),
													$author$project$RichText$htmlAttrIf$(
													state.bold,
													A2($elm$html$Html$Attributes$style, 'text-shadow', '0.7px 0px 0px white')),
													$author$project$RichText$htmlAttrIf$(
													state.strikethrough,
													A2($elm$html$Html$Attributes$style, 'text-decoration', 'line-through')),
													state.spoiler ? A2($elm$html$Html$Attributes$style, 'background-color', $author$project$RichText$spoilerBackground) : A2($elm$html$Html$Attributes$style, 'background-color', $author$project$RichText$codeBackground)
												]),
											$author$project$RichText$textWithSelection$(
												selection,
												index2 + 1,
												A2($elm$core$String$cons, _char, rest))),
											$author$project$RichText$formatText$(
											selection,
											(index2 + 2) + $elm$core$String$length(rest),
											'`')
										]))));
					case 13:
						var language = item.a;
						var string = item.b;
						var language2 = function () {
							if (!language.$) {
								var a = language.a;
								return $MartinSStewart$elm_nonempty_string$String$Nonempty$toString(a) + '\u000A';
							} else {
								return '';
							}
						}();
						return _Utils_Tuple2(
							((index2 + $elm$core$String$length(string)) + $elm$core$String$length(language2)) + 6,
							$elm$core$Array$append$(
								output2,
								$elm$core$Array$fromList(
									_List_fromArray(
										[
											$author$project$RichText$formatText$(selection, index2, '```' + language2),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											$author$project$RichText$textWithSelection$(
												selection,
												(index2 + 3) + $elm$core$String$length(language2),
												string)),
											$author$project$RichText$formatText$(
											selection,
											((index2 + 3) + $elm$core$String$length(language2)) + $elm$core$String$length(string),
											'```')
										]))));
					case 14:
						var fileId = item.a;
						var text = _Utils_ap(
							$author$project$RichText$attachedFilePrefix,
							_Utils_ap(
								$author$project$Id$toString(fileId),
								$author$project$RichText$attachedFileSuffix));
						return _Utils_Tuple2(
							index2 + $elm$core$String$length(text),
							$elm$core$Array$push$(
								$lamdera$containers$SeqDict$member$(fileId, attachedFiles) ? $author$project$RichText$formatText$(selection, index2, text) : A2(
									$elm$html$Html$span,
									_List_Nil,
									$author$project$RichText$textWithSelection$(selection, index2, text)),
								output2));
					case 15:
						var _char = item.a;
						return _Utils_Tuple2(
							index2 + 2,
							$elm$core$Array$append$(
								output2,
								$elm$core$Array$fromList(
									_List_fromArray(
										[
											$author$project$RichText$formatText$(selection, index2, '\u005C'),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											$author$project$RichText$textWithSelection$(
												selection,
												index2 + 1,
												$author$project$RichText$escapedCharToString(_char)))
										]))));
					case 16:
						var stickerId = item.a;
						var isSelected = function () {
							if (!selection.$) {
								var selection2 = selection.a;
								return (_Utils_cmp(index2, selection2.start) > -1) && (_Utils_cmp(index2, selection2.end) < 0);
							} else {
								return false;
							}
						}();
						return _Utils_Tuple2(
							index2 + $elm$core$String$length(
								$author$project$Sticker$idToString(stickerId)),
							$elm$core$Array$append$(
								output2,
								$elm$core$Array$fromList(
									_List_fromArray(
										[
											$elm$html$Html$text('\u000A'),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'position', 'relative')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
															isSelected ? A2(
															$elm$html$Html$Attributes$style,
															'background-color',
															$author$project$MyUi$colorToStyle($author$project$MyUi$selectedTextBackground)) : A2($elm$html$Html$Attributes$style, 'opacity', 'transparent'),
															A2($elm$html$Html$Attributes$style, 'top', '0'),
															A2($elm$html$Html$Attributes$style, 'left', '0')
														]),
													_List_fromArray(
														[
															$author$project$Sticker$view$('2lh', stickerId, stickers2, 2)
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
															A2($elm$html$Html$Attributes$style, 'width', '2lh'),
															A2($elm$html$Html$Attributes$style, 'height', '2lh'),
															isSelected ? A2(
															$elm$html$Html$Attributes$style,
															'background-color',
															$author$project$MyUi$colorToStyle(
																$author$project$MyUi$colorWithAlpha$(0.5, $author$project$MyUi$selectedTextBackground))) : A2($elm$html$Html$Attributes$style, 'opacity', 'transparent'),
															A2($elm$html$Html$Attributes$style, 'top', '0'),
															A2($elm$html$Html$Attributes$style, 'left', '0')
														]),
													_List_Nil)
												])),
											$elm$html$Html$text('\u000A\u000A')
										]))));
					case 17:
						var customEmojiId = item.a;
						var text = $author$project$CustomEmoji$idToString(customEmojiId);
						var isSelected = function () {
							if (!selection.$) {
								var selection2 = selection.a;
								return (_Utils_cmp(index2, selection2.start) > -1) && (_Utils_cmp(index2, selection2.end) < 0);
							} else {
								return false;
							}
						}();
						return _Utils_Tuple2(
							index2 + $elm$core$String$length(text),
							$elm$core$Array$append$(
								output2,
								$elm$core$Array$fromList(
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'position', 'relative')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
															isSelected ? A2(
															$elm$html$Html$Attributes$style,
															'background-color',
															$author$project$MyUi$colorToStyle($author$project$MyUi$selectedTextBackground)) : A2(
															$elm$html$Html$Attributes$style,
															'background-color',
															$author$project$MyUi$colorToStyle($author$project$MyUi$background2)),
															A2($elm$html$Html$Attributes$style, 'top', '-0.1em'),
															A2($elm$html$Html$Attributes$style, 'left', '0.1em'),
															A2($elm$html$Html$Attributes$style, 'width', '1.4em'),
															A2($elm$html$Html$Attributes$style, 'height', '1.6em')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
															A2($elm$html$Html$Attributes$style, 'top', '0'),
															A2($elm$html$Html$Attributes$style, 'left', '0.1em')
														]),
													_List_fromArray(
														[
															$author$project$CustomEmoji$view$('1.4em', '0', customEmojiId, customEmojis2, 2)
														]))
												])),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(text)
												]))
										]))));
					case 18:
						var hasLeadingLineBreak = item.a;
						var items = item.b;
						var leading = function () {
							if (!hasLeadingLineBreak) {
								return '\u000A';
							} else {
								return '';
							}
						}();
						return $elm$core$List$foldl$(
							F2(
								function (_v16, _v17) {
									var itemIndex = _v16.a;
									var bulletItem = _v16.b;
									var index3 = _v17.a;
									var output3 = _v17.b;
									var marker = (!itemIndex) ? (leading + '* ') : '\u000A* ';
									return $author$project$RichText$textInputViewHelper$(
										timezone,
										emojiData,
										state,
										allUsers,
										channels,
										attachedFiles,
										customEmojis2,
										stickers2,
										index3 + $elm$core$String$length(marker),
										selection,
										bulletItem,
										inBlockQuote,
										$elm$core$Array$push$(
											$author$project$RichText$formatText$(selection, index3, marker),
											output3));
								}),
							_Utils_Tuple2(index2, output2),
							$elm$core$List$indexedMap$(
								$elm$core$Tuple$pair,
								$mgold$elm_nonempty_list$List$Nonempty$toList(items)));
					default:
						var time = item.a;
						var text = $author$project$RichText$dateAndTimeToString$(timezone, time);
						return _Utils_Tuple2(
							index2 + $elm$core$String$length(text),
							$elm$core$Array$push$(
								$author$project$RichText$formatText$(selection, index2, text),
								output2));
				}
			}),
		_Utils_Tuple2(index, output),
		list);
};
var $author$project$RichText$textInputViewHelper = function (timezone) {
	return function (emojiData) {
		return function (state) {
			return function (allUsers) {
				return function (channels) {
					return function (attachedFiles) {
						return function (customEmojis2) {
							return function (stickers2) {
								return function (index) {
									return function (selection) {
										return function (list) {
											return function (inBlockQuote) {
												return function (output) {
													return $author$project$RichText$textInputViewHelper$(timezone, emojiData, state, allUsers, channels, attachedFiles, customEmojis2, stickers2, index, selection, list, inBlockQuote, output);
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$RichText$textInputView$ = function (timezone, emojiData, users, channels, attachedFiles, customEmojis2, stickers2, selection, nonempty) {
	return $elm$core$Array$toList(
		$author$project$RichText$textInputViewHelper$(
			timezone,
			emojiData,
			{bold: false, italic: false, spoiler: false, strikethrough: false, underline: false},
			users,
			channels,
			attachedFiles,
			customEmojis2,
			stickers2,
			0,
			selection,
			$mgold$elm_nonempty_list$List$Nonempty$toList(nonempty),
			false,
			$elm$core$Array$empty).b);
};
var $author$project$RichText$textInputView = F9($author$project$RichText$textInputView$);
var $author$project$MessageInput$textareaOverlayAttributes = function (text) {
	return _Utils_ap(
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
				A2($elm$html$Html$Attributes$style, 'padding', '0 9px 0 9px'),
				A2($elm$html$Html$Attributes$style, 'transform', 'translateX(-1px) translateY(8px)'),
				A2($elm$html$Html$Attributes$style, 'overflow-wrap', 'anywhere'),
				A2($elm$html$Html$Attributes$style, 'height', 'fit-content'),
				A2($elm$html$Html$Attributes$style, 'min-height', '100%'),
				A2($elm$html$Html$Attributes$style, 'flex-grow', '1')
			]),
		(text === '') ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
				A2($elm$html$Html$Attributes$style, 'text-overflow', 'ellipsis'),
				A2($elm$html$Html$Attributes$style, 'overflow', 'hidden')
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$style,
				'color',
				$author$project$MyUi$colorToStyle($author$project$MyUi$white)),
				A2($elm$html$Html$Attributes$style, 'white-space', 'pre-wrap')
			]));
};
var $elm$html$Html$Attributes$value = function (string) {
	return A2(
		_VirtualDom_property,
		'value',
		$elm$json$Json$Encode$string(string));
};
var $author$project$MessageInput$disabledTextarea$ = function (placeholderText, text, attachedFiles, localUser) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'position', 'relative'),
				A2($elm$html$Html$Attributes$style, 'min-height', 'min-content'),
				A2($elm$html$Html$Attributes$style, 'width', '100%'),
				A2($elm$html$Html$Attributes$style, 'height', 'fit-content')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$textarea,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'color', 'rgba(255,0,0,1)'),
						A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
						A2($elm$html$Html$Attributes$style, 'font-size', 'inherit'),
						A2($elm$html$Html$Attributes$style, 'font-family', 'inherit'),
						A2($elm$html$Html$Attributes$style, 'line-height', 'inherit'),
						A2($elm$html$Html$Attributes$style, 'width', 'calc(100% - 18px)'),
						A2($elm$html$Html$Attributes$style, 'height', '100%'),
						A2($elm$html$Html$Attributes$style, 'background-color', 'transparent'),
						A2($elm$html$Html$Attributes$style, 'border', '0'),
						A2($elm$html$Html$Attributes$style, 'resize', 'none'),
						A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
						A2($elm$html$Html$Attributes$style, 'caret-color', 'white'),
						A2($elm$html$Html$Attributes$style, 'padding', '8px'),
						A2($elm$html$Html$Attributes$style, 'outline', 'none'),
						$elm$html$Html$Attributes$value(text),
						$elm$html$Html$Attributes$disabled(true)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				$author$project$MessageInput$textareaOverlayAttributes(text),
				function () {
					var _v0 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(text);
					if (!_v0.$) {
						var nonempty = _v0.a;
						var users = $lamdera$containers$SeqDict$insert$(
							localUser.session.userId,
							$author$project$User$backendToFrontendForUser(localUser.user),
							localUser.otherUsers);
						return _Utils_ap(
							$author$project$RichText$textInputView$(
								localUser.timezone,
								localUser.emojiData,
								users,
								$lamdera$containers$SeqDict$empty,
								attachedFiles,
								localUser.customEmojis,
								localUser.stickers,
								$elm$core$Maybe$Nothing,
								$author$project$RichText$fromNonemptyString$(localUser.timezone, users, $lamdera$containers$SeqDict$empty, nonempty)),
							_List_fromArray(
								[
									$elm$html$Html$text('\u000A')
								]));
					} else {
						return _List_fromArray(
							[
								(placeholderText === '') ? $author$project$MessageInput$emptyPlaceholder : $author$project$MessageInput$textPlaceholder(placeholderText)
							]);
					}
				}())
			]));
};
var $author$project$MessageInput$disabledTextarea = F4($author$project$MessageInput$disabledTextarea$);
var $author$project$Ui$heightMax = function (x) {
	return $author$project$Internal$Model2$styleAndClass$(
		$author$project$Internal$Flag$skip,
		{
			_class: $author$project$Internal$Style2$classes.heightBounded,
			styleName: 'max-height',
			styleVal: $author$project$Internal$Style2$px(x)
		});
};
var $author$project$Ui$roundedWith = function (options) {
	return $author$project$Internal$Model2$style$(
		'border-radius',
		($elm$core$String$fromInt(options.topLeft) + 'px ') + (($elm$core$String$fromInt(options.topRight) + 'px ') + (($elm$core$String$fromInt(options.bottomRight) + 'px ') + ($elm$core$String$fromInt(options.bottomLeft) + 'px'))));
};
var $author$project$Icons$sendMessage = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor'),
			$elm$svg$Svg$Attributes$width('24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5')
				]),
			_List_Nil)
		]));
var $author$project$MessageInput$disabledView$ = function (roundTopCorners, placeholderText, text, attachedFiles, localUser) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$paddingWith(
				{bottom: 0, left: 40, right: 36, top: 0}),
				$author$project$Ui$inFront(
				$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$alignLeft,
							$author$project$Ui$width($author$project$Ui$shrink),
							$author$project$Ui$rounded(4),
							$author$project$Ui$paddingXY$(6, 0),
							$author$project$Ui$height(
							$author$project$Ui$px(38)),
							$author$project$Ui$background($author$project$MyUi$disabledButtonBackground),
							$author$project$Ui$move(
							{x: 2, y: 0, z: 0}),
							$author$project$Ui$contentCenterY,
							$author$project$Ui$centerY
						]),
					$author$project$Ui$html($author$project$Icons$attachment))),
				$author$project$Ui$inFront(
				$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$alignRight,
							$author$project$Ui$width($author$project$Ui$shrink),
							$author$project$Ui$rounded(4),
							$author$project$Ui$paddingXY$(4, 0),
							$author$project$Ui$height(
							$author$project$Ui$px(38)),
							$author$project$Ui$background($author$project$MyUi$disabledButtonBackground),
							$author$project$Ui$move(
							{x: -2, y: 0, z: 0}),
							$author$project$Ui$contentCenterY,
							$author$project$Ui$centerY
						]),
					$author$project$Ui$html($author$project$Icons$sendMessage)))
			]),
		$author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$paddingWith(
					{bottom: 19, left: 0, right: 0, top: 0}),
					$author$project$Ui$scrollable,
					$author$project$Ui$border(1),
					$author$project$Ui$borderColor($author$project$MyUi$border1),
					roundTopCorners ? $author$project$Ui$rounded(8) : $author$project$Ui$roundedWith(
					{bottomLeft: 8, bottomRight: 8, topLeft: 0, topRight: 0}),
					$author$project$Ui$heightMin(0),
					$author$project$Ui$heightMax(400),
					$author$project$MyUi$htmlStyle$('scrollbar-color', 'black'),
					$author$project$Ui$background($author$project$MyUi$background2)
				]),
			$author$project$Ui$html(
				$author$project$MessageInput$disabledTextarea$(placeholderText, text, attachedFiles, localUser))));
};
var $author$project$MessageInput$disabledView = F5($author$project$MessageInput$disabledView$);
var $author$project$Types$PressedChannelHeaderBackButton = {$: 57};
var $author$project$ChannelHeader$tabBodyZIndex = $author$project$MyUi$htmlStyle$('z-index', '20');
var $author$project$ChannelHeader$channelHeader$ = function (isMobile, content, tabContent) {
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$borderWith(
				{bottom: 1, left: 0, right: 0, top: 0}),
				$author$project$Ui$borderColor($author$project$MyUi$border2),
				$author$project$Ui$background($author$project$MyUi$background3),
				function () {
				if (!tabContent.$) {
					var tabContent2 = tabContent.a;
					return $author$project$Ui$inFront(
						$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$move(
									{x: 0, y: $author$project$MyUi$channelHeaderHeight + 1, z: 0}),
									$author$project$ChannelHeader$tabBodyZIndex,
									$author$project$Ui$borderWith(
									{bottom: 4, left: 0, right: 0, top: 0}),
									$author$project$Ui$borderColor($author$project$MyUi$background1)
								]),
							tabContent2));
				} else {
					return $author$project$Ui$noAttr;
				}
			}()
			]),
		_List_fromArray(
			[
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$contentCenterY,
						$author$project$Ui$height(
						$author$project$Ui$px($author$project$MyUi$channelHeaderHeight)),
						$author$project$MyUi$noShrinking
					]),
				isMobile ? _List_fromArray(
					[
						$author$project$ChannelHeader$headerBackButton$(
						$lamdera$program_test$Effect$Browser$Dom$id('guild_headerBackButton'),
						$author$project$Types$PressedChannelHeaderBackButton),
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$height($author$project$Ui$fill),
								$author$project$Ui$contentCenterY
							]),
						content)
					]) : _List_fromArray(
					[
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$paddingWith(
								{bottom: 0, left: 16, right: 0, top: 0}),
								$author$project$Ui$contentCenterY,
								$author$project$Ui$height($author$project$Ui$fill)
							]),
						content)
					]))
			]));
};
var $author$project$ChannelHeader$channelHeader = F3($author$project$ChannelHeader$channelHeader$);
var $author$project$Types$PressedChannelHeaderTab = function (a) {
	return {$: 157, a: a};
};
var $author$project$MyUi$tabBackground = $author$project$MyUi$background1;
var $author$project$MyUi$tabSideEdge$ = function (radius, tabHeight, isLeft, color) {
	var translate = (isLeft ? ('translate(-' + ($elm$core$String$fromFloat(radius * 1.5) + 'px, ')) : ('translate(' + ($elm$core$String$fromFloat(radius * 1.5) + 'px, '))) + '0)';
	var r = $elm$core$String$fromInt(radius);
	var edgeWidth = radius * 2;
	var w = $elm$core$String$fromInt(edgeWidth);
	var edgeHeight = tabHeight;
	var h = $elm$core$String$fromInt(edgeHeight);
	var arc = 'A ' + (r + (' ' + (r + ' 0 0 ')));
	var path = isLeft ? $elm$core$String$join$(
		' ',
		_List_fromArray(
			[
				'M ' + (w + ',0'),
				'L ' + ($elm$core$String$fromInt(radius * 2) + ',0'),
				arc + ('0 ' + (r + (',' + r))),
				'L ' + (r + (',' + $elm$core$String$fromInt(edgeHeight - radius))),
				arc + ('1 0,' + h),
				'L ' + (w + (',' + h)),
				'Z'
			])) : $elm$core$String$join$(
		' ',
		_List_fromArray(
			[
				'M 0,0',
				arc + ('1 ' + ($elm$core$String$fromInt(radius) + (',' + r))),
				'L ' + ($elm$core$String$fromInt(radius) + (',' + $elm$core$String$fromInt(edgeHeight - radius))),
				arc + ('0 ' + (w + (',' + h))),
				'L 0,' + h,
				'Z'
			]));
	return $author$project$Ui$inFront(
		$author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$alignBottom,
					isLeft ? $author$project$Ui$alignLeft : $author$project$Ui$alignRight,
					$author$project$Ui$width(
					$author$project$Ui$px(edgeWidth)),
					$author$project$Ui$height(
					$author$project$Ui$px(edgeHeight)),
					$author$project$Ui$Font$color(color),
					$author$project$MyUi$htmlStyle$('transform', translate),
					$author$project$MyUi$htmlStyle$('pointer-events', 'none')
				]),
			$author$project$Ui$html(
				A2(
					$elm$svg$Svg$svg,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$width(w),
							$elm$svg$Svg$Attributes$height(h),
							$elm$svg$Svg$Attributes$viewBox('0 0 ' + (w + (' ' + h))),
							$elm$svg$Svg$Attributes$style('display:block')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d(path),
									$elm$svg$Svg$Attributes$fill('currentColor')
								]),
							_List_Nil)
						])))));
};
var $author$project$MyUi$tabSideEdge = F4($author$project$MyUi$tabSideEdge$);
var $author$project$ChannelHeader$channelHeaderTabAttributes$ = function (paddingLeft, paddingRight, isMobile, tab, currentTab, rightMostTab) {
	var isSelected = function () {
		if (!currentTab.$) {
			var currentTab2 = currentTab.a;
			return $author$project$Route$sameChannelHeaderTab$(tab, currentTab2);
		} else {
			return false;
		}
	}();
	var borderHalfRadius = 4;
	return _List_fromArray(
		[
			$author$project$Ui$width($author$project$Ui$shrink),
			$author$project$Ui$height($author$project$Ui$fill),
			$author$project$Ui$paddingWith(
			{bottom: borderHalfRadius, left: paddingLeft, right: paddingRight, top: borderHalfRadius}),
			$author$project$Ui$attrIf$(
			isSelected,
			$author$project$Ui$behindContent(
				$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$height($author$project$Ui$fill),
							$author$project$Ui$paddingXY$(4, 0)
						]),
					$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$background($author$project$MyUi$tabBackground),
								$author$project$Ui$height($author$project$Ui$fill)
							]),
						$author$project$Ui$none)))),
			$author$project$Ui$attrIf$(
			isSelected,
			$author$project$MyUi$tabSideEdge$(borderHalfRadius * 2, $author$project$MyUi$channelHeaderHeight, true, $author$project$MyUi$tabBackground)),
			$author$project$Ui$attrIf$(
			isSelected,
			rightMostTab ? $author$project$Ui$inFront(
				$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$width(
							$author$project$Ui$px(4)),
							$author$project$Ui$background($author$project$MyUi$background1),
							$author$project$Ui$alignRight,
							$author$project$Ui$height($author$project$Ui$fill)
						]),
					$author$project$Ui$none)) : $author$project$MyUi$tabSideEdge$(borderHalfRadius * 2, $author$project$MyUi$channelHeaderHeight, false, $author$project$MyUi$tabBackground)),
			$author$project$Ui$contentCenterY,
			$author$project$Ui$Font$color(
			isSelected ? $author$project$MyUi$font1 : $author$project$MyUi$font3),
			$author$project$MyUi$hover$(
			isMobile,
			_List_fromArray(
				[
					$author$project$Ui$Anim$fontColor($author$project$MyUi$font1)
				]))
		]);
};
var $author$project$ChannelHeader$channelHeaderTabAttributes = F6($author$project$ChannelHeader$channelHeaderTabAttributes$);
var $author$project$MyUi$prewrap = $author$project$MyUi$htmlStyle$('white-space', 'pre-wrap');
var $author$project$ChannelHeader$channelHeaderTabRow$ = function (isMobile, htmlId, tab, currentTab, rightMostTab, content) {
	return $author$project$MyUi$rowButton$(
		htmlId,
		$author$project$Types$PressedChannelHeaderTab(tab),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$spacing(2),
			A2(
				$elm$core$List$cons,
				$author$project$MyUi$prewrap,
				$author$project$ChannelHeader$channelHeaderTabAttributes$(4, 8, isMobile, tab, currentTab, rightMostTab))),
		content);
};
var $author$project$ChannelHeader$channelHeaderTabRow = F6($author$project$ChannelHeader$channelHeaderTabRow$);
var $author$project$Types$PressedShowMembers = {$: 58};
var $author$project$Icons$gear = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor'),
			$elm$svg$Svg$Attributes$width('24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z')
				]),
			_List_Nil)
		]));
var $author$project$ChannelHeader$channelSettingsTab$ = function (isMobile, route) {
	var _v0 = $author$project$Route$toShowMembersTab(route);
	if (_v0.a === 1) {
		var _v1 = _v0.a;
		var isThread = _v0.b;
		return $elm$core$Maybe$Just(
			$author$project$MyUi$elButton$(
				$lamdera$program_test$Effect$Browser$Dom$id('guild_showMembers'),
				$author$project$Types$PressedShowMembers,
				_List_fromArray(
					[
						$author$project$Ui$width(
						$author$project$Ui$px(24 + 24)),
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$paddingXY$(12, 0),
						$author$project$Ui$contentCenterY,
						$author$project$Ui$Font$color($author$project$MyUi$font3),
						$author$project$MyUi$hover$(
						isMobile,
						_List_fromArray(
							[
								$author$project$Ui$Anim$fontColor($author$project$MyUi$font1)
							])),
						$author$project$MyUi$hoverText(
						isThread ? 'Thread settings' : 'Channel settings')
					]),
				$author$project$Ui$html($author$project$Icons$gear)));
	} else {
		var _v2 = _v0.a;
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ChannelHeader$channelSettingsTab = F2($author$project$ChannelHeader$channelSettingsTab$);
var $author$project$ChannelHeader$channelHeaderTab$ = function (isMobile, htmlId, tab, currentTab, content) {
	return $author$project$MyUi$elButton$(
		htmlId,
		$author$project$Types$PressedChannelHeaderTab(tab),
		$author$project$ChannelHeader$channelHeaderTabAttributes$(16, 16, isMobile, tab, currentTab, false),
		content);
};
var $author$project$ChannelHeader$channelHeaderTab = F5($author$project$ChannelHeader$channelHeaderTab$);
var $author$project$ChannelHeader$channelHeaderIconTab$ = function (isMobile, htmlId, tab, currentTab, rightMostTab, content) {
	return $author$project$MyUi$elButton$(
		htmlId,
		$author$project$Types$PressedChannelHeaderTab(tab),
		$author$project$ChannelHeader$channelHeaderTabAttributes$(12, 12, isMobile, tab, currentTab, rightMostTab),
		content);
};
var $author$project$ChannelHeader$channelHeaderIconTab = F6($author$project$ChannelHeader$channelHeaderIconTab$);
var $author$project$Icons$paintbrush = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M9.53 16.122a3 3 0 0 0-5.78 1.128 2.25 2.25 0 0 1-2.4 2.245 4.5 4.5 0 0 0 8.4-2.245c0-.399-.078-.78-.22-1.128Zm0 0a15.998 15.998 0 0 0 3.388-1.62m-5.043-.025a15.994 15.994 0 0 1 1.622-3.395m3.42 3.42a15.995 15.995 0 0 0 4.764-4.648l3.876-5.814a1.151 1.151 0 0 0-1.597-1.597L14.146 6.32a15.996 15.996 0 0 0-4.649 4.763m3.42 3.42a6.776 6.776 0 0 0-3.42-3.42')
				]),
			_List_Nil)
		]));
var $author$project$ChannelHeader$drawingTab$ = function (isMobile, currentTab, rightMostTab) {
	return $author$project$ChannelHeader$channelHeaderIconTab$(
		isMobile,
		$lamdera$program_test$Effect$Browser$Dom$id('channelHeader_drawOnMessages'),
		$author$project$UserSession$ChannelHeaderTab_Draw,
		currentTab,
		rightMostTab,
		$author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$width(
					$author$project$Ui$px(24)),
					$author$project$MyUi$hoverText('Draw on top of messages')
				]),
			$author$project$Ui$html($author$project$Icons$paintbrush)));
};
var $author$project$ChannelHeader$drawingTab = F3($author$project$ChannelHeader$drawingTab$);
var $author$project$ChannelHeader$discordPrivateChatWith$ = function (isMobile, route, currentTab, name) {
	var channelSettingsTab2 = $author$project$ChannelHeader$channelSettingsTab$(isMobile, route);
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$Font$color($author$project$MyUi$font1),
				$author$project$Ui$spacing(6),
				$author$project$Ui$height($author$project$Ui$fill)
			]),
		_List_fromArray(
			[
				$author$project$ChannelHeader$channelHeaderTab$(
				isMobile,
				$lamdera$program_test$Effect$Browser$Dom$id('guild_openDescription'),
				$author$project$UserSession$ChannelHeaderTab_ChannelDescription,
				currentTab,
				isMobile ? $author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$Font$color($author$project$MyUi$font1)
						]),
					$author$project$Ui$text(name)) : $author$project$Ui$row$(
					_List_fromArray(
						[
							$author$project$Ui$spacing(5)
						]),
					_List_fromArray(
						[
							$author$project$Ui$text('Chat with '),
							$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$Font$color($author$project$MyUi$font1)
								]),
							$author$project$Ui$text(name))
						]))),
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$alignRight,
						$author$project$Ui$height($author$project$Ui$fill)
					]),
				_List_fromArray(
					[
						$author$project$ChannelHeader$drawingTab$(
						isMobile,
						currentTab,
						_Utils_eq(channelSettingsTab2, $elm$core$Maybe$Nothing)),
						$elm$core$Maybe$withDefault$($author$project$Ui$none, channelSettingsTab2)
					]))
			]));
};
var $author$project$ChannelHeader$discordPrivateChatWith = F4($author$project$ChannelHeader$discordPrivateChatWith$);
var $author$project$Call$joinedUsers$ = function (currentUserId, roomId, calls) {
	var others = function () {
		var _v0 = $lamdera$containers$SeqDict$get$(roomId, calls.voiceChats);
		if (!_v0.$) {
			var voiceChat = _v0.a;
			return $author$project$NonemptyDict$foldl$(
				F3(
					function (_v1, _v2, dict) {
						var userId = _v1.a;
						return $author$project$SeqDictHelper$increment$(userId, dict);
					}),
				$lamdera$containers$SeqDict$empty,
				voiceChat);
		} else {
			return $lamdera$containers$SeqDict$empty;
		}
	}();
	return _Utils_eq(
		calls.currentRoom,
		$elm$core$Maybe$Just(roomId)) ? $author$project$SeqDictHelper$increment$(currentUserId, others) : others;
};
var $author$project$Call$joinedUsers = F3($author$project$Call$joinedUsers$);
var $author$project$User$multipleProfileImagesY = 12;
var $author$project$GuildIcon$iconFontColor = $author$project$Ui$rgba$(0, 0, 0, 0.8);
var $author$project$GuildIcon$defaultUser$ = function (size2, rounding, color) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$contentCenterY,
				rounding,
				$author$project$Ui$background(
				$author$project$UserColor$toColor(color)),
				$author$project$Ui$width(
				$author$project$Ui$px(size2)),
				$author$project$Ui$height(
				$author$project$Ui$px(size2)),
				$author$project$Ui$paddingXY$(4, 0),
				$author$project$Ui$Font$color($author$project$GuildIcon$iconFontColor),
				$author$project$MyUi$noPointerEvents
			]),
		$author$project$Ui$html($author$project$Icons$person));
};
var $author$project$GuildIcon$defaultUser = F3($author$project$GuildIcon$defaultUser$);
var $author$project$User$profileOutlineColor = function (userColor2) {
	return $author$project$MyUi$colorToStyle(
		$author$project$MyUi$colorWithAlpha$(
			0.5,
			$author$project$UserColor$toColor(userColor2)));
};
var $author$project$User$smallProfileImageRounding = 4;
var $author$project$User$smallProfileImageSize = 25;
var $author$project$User$smallProfileImage$ = function (roundLeftOnly, user) {
	var rounding = $author$project$Ui$roundedWith(
		{
			bottomLeft: $author$project$User$smallProfileImageRounding,
			bottomRight: roundLeftOnly ? 0 : $author$project$User$smallProfileImageRounding,
			topLeft: $author$project$User$smallProfileImageRounding,
			topRight: roundLeftOnly ? 0 : $author$project$User$smallProfileImageRounding
		});
	if (!user.$) {
		var user2 = user.a;
		var _v1 = user2.icon;
		if (!_v1.$) {
			var fileHash = _v1.a;
			return $author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$width(
						$author$project$Ui$px($author$project$User$smallProfileImageSize)),
						$author$project$Ui$height(
						$author$project$Ui$px($author$project$User$smallProfileImageSize)),
						$author$project$Ui$clip,
						rounding,
						$author$project$MyUi$htmlStyle$(
						'outline',
						'solid 1px ' + $author$project$User$profileOutlineColor(user2.color)),
						$author$project$MyUi$htmlStyle$('outline-offset', '-1px'),
						$author$project$MyUi$noPointerEvents
					]),
				$author$project$Ui$imageLazy$(
					_List_fromArray(
						[
							$author$project$Ui$width(
							$author$project$Ui$px($author$project$User$smallProfileImageSize + 4)),
							$author$project$Ui$height(
							$author$project$Ui$px($author$project$User$smallProfileImageSize + 4)),
							$author$project$Ui$move(
							{x: -2, y: -2, z: 0})
						]),
					{
						description: '',
						onLoad: $elm$core$Maybe$Nothing,
						source: $author$project$FileStatus$fileUrl$($author$project$FileStatus$pngContent, fileHash)
					}));
		} else {
			return $author$project$GuildIcon$defaultUser$($author$project$User$smallProfileImageSize, rounding, user2.color);
		}
	} else {
		return $author$project$GuildIcon$defaultUser$($author$project$User$smallProfileImageSize, rounding, $author$project$RichText$defaultColor);
	}
};
var $author$project$User$smallProfileImage = F2($author$project$User$smallProfileImage$);
var $author$project$User$multipleProfileImages = function (profileImages) {
	if (!profileImages.b) {
		return $author$project$Ui$none;
	} else {
		if (!profileImages.b.b) {
			var one = profileImages.a;
			return $author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$width(
						$author$project$Ui$px($author$project$User$smallProfileImageSize)),
						$author$project$Ui$height(
						$author$project$Ui$px($author$project$MyUi$channelHeaderHeight)),
						$author$project$Ui$inFront(
						$author$project$Ui$el$(
							_List_fromArray(
								[$author$project$Ui$centerY]),
							$author$project$User$smallProfileImage$(
								false,
								$elm$core$Maybe$Just(one)))),
						$author$project$Ui$alignRight
					]),
				$author$project$Ui$none);
		} else {
			if (!profileImages.b.b.b) {
				var one = profileImages.a;
				var _v1 = profileImages.b;
				var two = _v1.a;
				return $author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$width(
							$author$project$Ui$px(40)),
							$author$project$Ui$height(
							$author$project$Ui$px($author$project$MyUi$channelHeaderHeight)),
							$author$project$Ui$inFront(
							$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$move(
										{x: 15, y: $author$project$User$multipleProfileImagesY, z: 0})
									]),
								$author$project$User$smallProfileImage$(
									false,
									$elm$core$Maybe$Just(two)))),
							$author$project$Ui$inFront(
							$author$project$User$smallProfileImage$(
								false,
								$elm$core$Maybe$Just(one))),
							$author$project$Ui$alignRight
						]),
					$author$project$Ui$none);
			} else {
				if (!profileImages.b.b.b.b) {
					var one = profileImages.a;
					var _v2 = profileImages.b;
					var two = _v2.a;
					var _v3 = _v2.b;
					var three = _v3.a;
					return $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$width(
								$author$project$Ui$px(55)),
								$author$project$Ui$height(
								$author$project$Ui$px($author$project$MyUi$channelHeaderHeight)),
								$author$project$Ui$inFront(
								$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$move(
											{x: 30, y: 0, z: 0})
										]),
									$author$project$User$smallProfileImage$(
										false,
										$elm$core$Maybe$Just(three)))),
								$author$project$Ui$inFront(
								$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$move(
											{x: 15, y: $author$project$User$multipleProfileImagesY, z: 0})
										]),
									$author$project$User$smallProfileImage$(
										false,
										$elm$core$Maybe$Just(two)))),
								$author$project$Ui$inFront(
								$author$project$User$smallProfileImage$(
									false,
									$elm$core$Maybe$Just(one))),
								$author$project$Ui$alignRight
							]),
						$author$project$Ui$none);
				} else {
					if (!profileImages.b.b.b.b.b) {
						var one = profileImages.a;
						var _v4 = profileImages.b;
						var two = _v4.a;
						var _v5 = _v4.b;
						var three = _v5.a;
						var _v6 = _v5.b;
						var four = _v6.a;
						return $author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$width(
									$author$project$Ui$px(70)),
									$author$project$Ui$height(
									$author$project$Ui$px($author$project$MyUi$channelHeaderHeight)),
									$author$project$Ui$inFront(
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$move(
												{x: 45, y: $author$project$User$multipleProfileImagesY, z: 0})
											]),
										$author$project$User$smallProfileImage$(
											false,
											$elm$core$Maybe$Just(four)))),
									$author$project$Ui$inFront(
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$move(
												{x: 30, y: 0, z: 0})
											]),
										$author$project$User$smallProfileImage$(
											false,
											$elm$core$Maybe$Just(three)))),
									$author$project$Ui$inFront(
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$move(
												{x: 15, y: $author$project$User$multipleProfileImagesY, z: 0})
											]),
										$author$project$User$smallProfileImage$(
											false,
											$elm$core$Maybe$Just(two)))),
									$author$project$Ui$inFront(
									$author$project$User$smallProfileImage$(
										false,
										$elm$core$Maybe$Just(one))),
									$author$project$Ui$alignRight
								]),
							$author$project$Ui$none);
					} else {
						var one = profileImages.a;
						var _v7 = profileImages.b;
						var two = _v7.a;
						var _v8 = _v7.b;
						var three = _v8.a;
						var rest = _v8.b;
						return $author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$width(
									$author$project$Ui$px(70)),
									$author$project$Ui$height(
									$author$project$Ui$px($author$project$MyUi$channelHeaderHeight)),
									$author$project$Ui$inFront(
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$move(
												{x: 30, y: 0, z: 0})
											]),
										$author$project$User$smallProfileImage$(
											false,
											$elm$core$Maybe$Just(three)))),
									$author$project$Ui$inFront(
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$move(
												{x: 15, y: $author$project$User$multipleProfileImagesY, z: 0})
											]),
										$author$project$User$smallProfileImage$(
											false,
											$elm$core$Maybe$Just(two)))),
									$author$project$Ui$inFront(
									$author$project$User$smallProfileImage$(
										false,
										$elm$core$Maybe$Just(one))),
									$author$project$Ui$inFront(
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$move(
												{x: 45, y: $author$project$User$multipleProfileImagesY, z: 0}),
												$author$project$Ui$background($author$project$MyUi$background1),
												$author$project$Ui$width(
												$author$project$Ui$px($author$project$User$smallProfileImageSize)),
												$author$project$Ui$height(
												$author$project$Ui$px($author$project$User$smallProfileImageSize)),
												$author$project$Ui$Font$center,
												$author$project$Ui$Font$bold,
												$author$project$Ui$rounded(8),
												$author$project$Ui$Font$color($author$project$MyUi$font3),
												$author$project$Ui$Font$size(14),
												$author$project$Ui$contentCenterY,
												$author$project$MyUi$htmlStyle$('white-space', 'pre')
											]),
										$author$project$Ui$text(
											'+' + $elm$core$String$fromInt(
												$elm$core$List$length(rest))))),
									$author$project$Ui$alignRight
								]),
							$author$project$Ui$none);
					}
				}
			}
		}
	}
};
var $author$project$Icons$phone = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor'),
			$elm$svg$Svg$Attributes$width('24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z')
				]),
			_List_Nil)
		]));
var $author$project$ChannelHeader$callTab$ = function (isMobile, currentTab, roomId, localUser, calls) {
	var joined = $author$project$User$multipleProfileImages(
		$elm$core$List$filterMap$(
			function (_v0) {
				var userId = _v0.a;
				return $author$project$User$getUser$(userId, localUser);
			},
			$lamdera$containers$SeqDict$toList(
				$author$project$Call$joinedUsers$(localUser.session.userId, roomId, calls))));
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$width($author$project$Ui$shrink),
				$author$project$Ui$spacing(8),
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$Ui$contentCenterY
			]),
		_List_fromArray(
			[
				joined,
				$author$project$ChannelHeader$channelHeaderIconTab$(
				isMobile,
				$lamdera$program_test$Effect$Browser$Dom$id('guild_voiceChat'),
				$author$project$UserSession$ChannelHeaderTab_VoiceChat,
				currentTab,
				false,
				$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$MyUi$hoverText('Voice chat')
						]),
					$author$project$Ui$html($author$project$Icons$phone)))
			]));
};
var $author$project$ChannelHeader$callTab = F5($author$project$ChannelHeader$callTab$);
var $author$project$ChannelHeader$e2eeRequestDot = $author$project$Ui$inFront(
	$author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$rounded(99),
				$author$project$Ui$background($author$project$MyUi$alertColor),
				$author$project$Ui$border(2),
				$author$project$Ui$borderColor($author$project$MyUi$background1),
				$author$project$Ui$width(
				$author$project$Ui$px(12)),
				$author$project$Ui$height(
				$author$project$Ui$px(12)),
				$author$project$Ui$move(
				{x: 6, y: -6, z: 0}),
				$author$project$Ui$alignRight,
				$author$project$Ui$alignTop,
				$author$project$Ui$htmlAttribute(
				A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Waiting for an answer about end-to-end encryption'))
			]),
		$author$project$Ui$none));
var $author$project$ChannelHeader$dmChannelSettingsTab$ = function (isMobile, route, showSettingsRedDot) {
	var _v0 = $author$project$Route$toShowMembersTab(route);
	if (_v0.a === 1) {
		var _v1 = _v0.a;
		var isThread = _v0.b;
		return $elm$core$Maybe$Just(
			$author$project$MyUi$elButton$(
				$lamdera$program_test$Effect$Browser$Dom$id('guild_showMembers'),
				$author$project$Types$PressedShowMembers,
				_List_fromArray(
					[
						$author$project$Ui$width(
						$author$project$Ui$px(24 + 24)),
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$paddingXY$(12, 0),
						$author$project$Ui$contentCenterY,
						$author$project$Ui$Font$color($author$project$MyUi$font3),
						$author$project$MyUi$hover$(
						isMobile,
						_List_fromArray(
							[
								$author$project$Ui$Anim$fontColor($author$project$MyUi$font1)
							])),
						$author$project$MyUi$hoverText(
						isThread ? 'Thread settings' : 'Channel settings')
					]),
				$author$project$Ui$el$(
					_List_fromArray(
						[
							showSettingsRedDot ? $author$project$ChannelHeader$e2eeRequestDot : $author$project$Ui$noAttr
						]),
					$author$project$Ui$html($author$project$Icons$gear))));
	} else {
		var _v2 = _v0.a;
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ChannelHeader$dmChannelSettingsTab = F3($author$project$ChannelHeader$dmChannelSettingsTab$);
var $elm$svg$Svg$circle = $elm$svg$Svg$trustedNode('circle');
var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');
var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');
var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');
var $author$project$Icons$go = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
			$elm$svg$Svg$Attributes$width('24'),
			$elm$svg$Svg$Attributes$fill('none')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$stroke('currentColor'),
					$elm$svg$Svg$Attributes$strokeWidth('1'),
					$elm$svg$Svg$Attributes$strokeLinecap('round')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$line,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$x1('5.5'),
							$elm$svg$Svg$Attributes$y1('1'),
							$elm$svg$Svg$Attributes$x2('5.5'),
							$elm$svg$Svg$Attributes$y2('15')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$line,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$x1('10.5'),
							$elm$svg$Svg$Attributes$y1('1'),
							$elm$svg$Svg$Attributes$x2('10.5'),
							$elm$svg$Svg$Attributes$y2('15')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$line,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$x1('1'),
							$elm$svg$Svg$Attributes$y1('5.5'),
							$elm$svg$Svg$Attributes$x2('15'),
							$elm$svg$Svg$Attributes$y2('5.5')
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$line,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$x1('1'),
							$elm$svg$Svg$Attributes$y1('10.5'),
							$elm$svg$Svg$Attributes$x2('15'),
							$elm$svg$Svg$Attributes$y2('10.5')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('10.5'),
					$elm$svg$Svg$Attributes$cy('5.5'),
					$elm$svg$Svg$Attributes$r('2.6'),
					$elm$svg$Svg$Attributes$fill('#fff'),
					$elm$svg$Svg$Attributes$stroke('#000'),
					$elm$svg$Svg$Attributes$strokeWidth('0.6')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('5.5'),
					$elm$svg$Svg$Attributes$cy('10.5'),
					$elm$svg$Svg$Attributes$r('2.6'),
					$elm$svg$Svg$Attributes$fill('#fff'),
					$elm$svg$Svg$Attributes$stroke('#000'),
					$elm$svg$Svg$Attributes$strokeWidth('0.6')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('10.5'),
					$elm$svg$Svg$Attributes$cy('10.5'),
					$elm$svg$Svg$Attributes$r('2.6'),
					$elm$svg$Svg$Attributes$fill('#000')
				]),
			_List_Nil)
		]));
var $author$project$ChannelHeader$gameButton$ = function (isMobile, currentTab) {
	return $author$project$ChannelHeader$channelHeaderIconTab$(
		isMobile,
		$lamdera$program_test$Effect$Browser$Dom$id('guild_openGamesTab'),
		$author$project$UserSession$ChannelHeaderTab_Games$($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
		currentTab,
		false,
		$author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$MyUi$hoverText('Games')
				]),
			$author$project$Ui$html($author$project$Icons$go)));
};
var $author$project$ChannelHeader$gameButton = F2($author$project$ChannelHeader$gameButton$);
var $author$project$Ui$Lazy$apply2$ = function (fn, a, b, s) {
	return $author$project$Internal$Model2$unwrap$(
		s,
		A2(fn, a, b));
};
var $author$project$Ui$Lazy$apply2 = F4($author$project$Ui$Lazy$apply2$);
var $elm$virtual_dom$VirtualDom$lazy4 = _VirtualDom_lazy4;
var $elm$html$Html$Lazy$lazy4 = $elm$virtual_dom$VirtualDom$lazy4;
var $author$project$Ui$Lazy$lazy2$ = function (fn, a, b) {
	return function (s) {
		return A5($elm$html$Html$Lazy$lazy4, $author$project$Ui$Lazy$apply2, fn, a, b, s);
	};
};
var $author$project$Ui$Lazy$lazy2 = F3($author$project$Ui$Lazy$lazy2$);
var $author$project$ChannelHeader$dmHeaderButtons$ = function (isMobile, route, showSettingsRedDot, currentTab, otherUserId, local) {
	var dmChannelSettingsTab2 = $author$project$ChannelHeader$dmChannelSettingsTab$(isMobile, route, showSettingsRedDot);
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$MyUi$noShrinking,
				$author$project$Ui$width($author$project$Ui$shrink),
				$author$project$Ui$alignRight,
				$author$project$Ui$height($author$project$Ui$fill)
			]),
		_List_fromArray(
			[
				$author$project$ChannelHeader$callTab$(
				isMobile,
				currentTab,
				$author$project$Call$DmRoomId(
					{otherUserId: otherUserId}),
				local.localUser,
				local.calls),
				$author$project$Ui$Lazy$lazy2$($author$project$ChannelHeader$gameButton, isMobile, currentTab),
				$author$project$ChannelHeader$drawingTab$(
				isMobile,
				currentTab,
				_Utils_eq(dmChannelSettingsTab2, $elm$core$Maybe$Nothing)),
				$elm$core$Maybe$withDefault$($author$project$Ui$none, dmChannelSettingsTab2)
			]));
};
var $author$project$ChannelHeader$dmHeaderButtons = F6($author$project$ChannelHeader$dmHeaderButtons$);
var $author$project$ChannelHeader$privateChatWithYourself$ = function (isMobile, route, showSettingsRedDot, currentTab, local) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$Font$color($author$project$MyUi$font1),
				$author$project$Ui$spacing(6),
				$author$project$Ui$height($author$project$Ui$fill)
			]),
		_List_fromArray(
			[
				$author$project$ChannelHeader$channelHeaderTab$(
				isMobile,
				$lamdera$program_test$Effect$Browser$Dom$id('guild_openDescription'),
				$author$project$UserSession$ChannelHeaderTab_ChannelDescription,
				currentTab,
				$author$project$Ui$text('Solo chat')),
				$author$project$ChannelHeader$dmHeaderButtons$(isMobile, route, showSettingsRedDot, currentTab, local.localUser.session.userId, local)
			]));
};
var $author$project$ChannelHeader$privateChatWithYourself = F5($author$project$ChannelHeader$privateChatWithYourself$);
var $author$project$Call$canShareScreen = function (userAgent) {
	var _v0 = userAgent.device;
	switch (_v0) {
		case 0:
			return false;
		case 1:
			return false;
		case 2:
			return false;
		case 3:
			return false;
		case 8:
			return false;
		case 9:
			return false;
		case 4:
			return true;
		case 5:
			return true;
		case 6:
			return true;
		case 7:
			return true;
		default:
			return true;
	}
};
var $author$project$Ui$Font$italic = $author$project$Internal$Model2$class($author$project$Internal$Style2$classes.italic);
var $author$project$ChannelHeader$channelDescriptionView$ = function (channelName, description) {
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$paddingXY$(16, 12),
				$author$project$Ui$background($author$project$MyUi$tabBackground),
				$author$project$Ui$Font$color($author$project$MyUi$font2),
				$author$project$Ui$spacing(8),
				$author$project$Ui$borderWith(
				{bottom: 1, left: 0, right: 0, top: 0}),
				$author$project$Ui$borderColor($author$project$MyUi$border2)
			]),
		_List_fromArray(
			[
				function () {
				if (!channelName.$) {
					var channelName2 = channelName.a;
					return $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$Font$bold,
								$author$project$MyUi$htmlStyle$('overflow-wrap', 'break-word')
							]),
						$author$project$Ui$text(
							$author$project$ChannelName$toString(channelName2)));
				} else {
					return $author$project$Ui$none;
				}
			}(),
				$elm$core$String$isEmpty(description) ? $author$project$Ui$el$(
				_List_fromArray(
					[$author$project$Ui$Font$italic]),
				$author$project$Ui$text('No channel description')) : $author$project$Ui$text(description)
			]));
};
var $author$project$ChannelHeader$channelDescriptionView = F2($author$project$ChannelHeader$channelDescriptionView$);
var $author$project$Drawing$PressedDone = {$: 7};
var $author$project$Drawing$PressedRedo = {$: 4};
var $author$project$Drawing$PressedUndo = {$: 3};
var $author$project$Drawing$PressedZoom = {$: 5};
var $author$project$Drawing$button$ = function (htmlId, onPress, label, isEnabled) {
	return $author$project$MyUi$elButton$(
		htmlId,
		onPress,
		_List_fromArray(
			[
				$author$project$Ui$width($author$project$Ui$shrink),
				$author$project$Ui$paddingXY$(12, 4),
				$author$project$Ui$rounded(4),
				$author$project$Ui$border(1),
				$author$project$Ui$borderColor($author$project$MyUi$border1),
				$author$project$Ui$background(
				isEnabled ? $author$project$MyUi$background2 : $author$project$MyUi$background1),
				$author$project$Ui$Font$color(
				isEnabled ? $author$project$MyUi$font1 : $author$project$MyUi$font3)
			]),
		$author$project$Ui$text(label));
};
var $author$project$Drawing$button = F4($author$project$Drawing$button$);
var $author$project$Internal$Model2$map$ = function (fn, el) {
	var elem = el;
	return function (s) {
		return A2(
			$elm$html$Html$map,
			fn,
			elem(s));
	};
};
var $author$project$Internal$Model2$map = F2($author$project$Internal$Model2$map$);
var $author$project$Ui$map = $author$project$Internal$Model2$map;
var $author$project$Drawing$redoButtonId = $lamdera$program_test$Effect$Browser$Dom$id('drawing_redo');
var $author$project$ChannelHeader$startDrawingText = 'Start drawing!';
var $author$project$Drawing$undoButtonId = $lamdera$program_test$Effect$Browser$Dom$id('drawing_undo');
var $author$project$Drawing$zoomButtonId = $lamdera$program_test$Effect$Browser$Dom$id('drawing_zoom');
var $author$project$ChannelHeader$zoomInText = 'Zoom in';
var $author$project$ChannelHeader$zoomOutText = 'Zoom out';
var $author$project$ChannelHeader$drawingTabView$ = function (isMobile, model, local) {
	return A2(
		$author$project$Ui$map,
		$author$project$Types$DrawingMsg,
		$author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$paddingXY$(16, 0),
					$author$project$Ui$background($author$project$MyUi$tabBackground),
					$author$project$Ui$contentCenterY,
					$author$project$Ui$height(
					$author$project$Ui$px(80)),
					$author$project$Ui$borderWith(
					{bottom: 1, left: 0, right: 0, top: 0}),
					$author$project$Ui$borderColor($author$project$MyUi$border2)
				]),
			function () {
				if (!model.$) {
					return $author$project$Ui$text('Click on a profile image, timestamp, or attachment to anchor your drawing to it.');
				} else {
					var selected = model.a;
					var _v1 = $author$project$ChannelHeader$drawingCanUndoOrRedo$(selected.guildOrDmId, selected.anchorType, local);
					var canUndo = _v1.a;
					var canRedo = _v1.b;
					return $author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$spacing(8)
							]),
						_List_fromArray(
							[
								$author$project$Ui$text($author$project$ChannelHeader$startDrawingText),
								$author$project$Ui$row$(
								_List_fromArray(
									[
										isMobile ? $author$project$Ui$spacing(8) : $author$project$Ui$spacing(16)
									]),
								_List_fromArray(
									[
										$author$project$Drawing$button$(
										$lamdera$program_test$Effect$Browser$Dom$id('drawing_done'),
										$author$project$Drawing$PressedDone,
										'Done',
										true),
										$author$project$Drawing$button$($author$project$Drawing$undoButtonId, $author$project$Drawing$PressedUndo, 'Undo', canUndo),
										$author$project$Drawing$button$($author$project$Drawing$redoButtonId, $author$project$Drawing$PressedRedo, 'Redo', canRedo),
										$author$project$Drawing$button$(
										$author$project$Drawing$zoomButtonId,
										$author$project$Drawing$PressedZoom,
										(selected.zoom === 1) ? $author$project$ChannelHeader$zoomInText : $author$project$ChannelHeader$zoomOutText,
										true)
									]))
							]));
				}
			}()));
};
var $author$project$ChannelHeader$drawingTabView = F3($author$project$ChannelHeader$drawingTabView$);
var $author$project$Game$GoGameMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Game$GoSetupMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Game$WordSpellingSetupMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Game$allGames = _List_fromArray(
	[0, 1, 2]);
var $author$project$Game$PressedSelectGame = function (a) {
	return {$: 10, a: a};
};
var $author$project$Game$gameToPreviewUrl = function (game) {
	switch (game) {
		case 0:
			return '/cacheable/go-preview.webp';
		case 1:
			return '/cacheable/word-spelling-game-preview.webp';
		default:
			return '/cacheable/sheep-game-preview.webp';
	}
};
var $author$project$Game$goName = 'Go (Baduk)';
var $author$project$Game$sheepGameName = 'Sheep Game (WIP)';
var $author$project$Game$wordSpellingGameName = 'Word Spelling Game';
var $author$project$Game$gameToString = function (game) {
	switch (game) {
		case 0:
			return $author$project$Game$goName;
		case 1:
			return $author$project$Game$wordSpellingGameName;
		default:
			return $author$project$Game$sheepGameName;
	}
};
var $author$project$Internal$Style2$floatPx = function (x) {
	return $elm$core$String$fromFloat(x) + 'px';
};
var $author$project$Internal$Style2$pent$ = function (one, two, three, four, five) {
	return one + (' ' + (two + (' ' + (three + (' ' + (four + (' ' + five)))))));
};
var $author$project$Internal$Style2$pent = F5($author$project$Internal$Style2$pent$);
var $author$project$Internal$Style2$singleShadow = function (shadow) {
	return $author$project$Internal$Style2$pent$(
		$author$project$Internal$Style2$floatPx(shadow.x),
		$author$project$Internal$Style2$floatPx(shadow.y),
		$author$project$Internal$Style2$floatPx(shadow.blur),
		$author$project$Internal$Style2$floatPx(shadow.size),
		$author$project$Internal$Style2$color(shadow.color));
};
var $author$project$Ui$Shadow$shadows = function (shades) {
	return $author$project$Internal$Model2$style$(
		'box-shadow',
		$elm$core$String$join$(
			', ',
			$elm$core$List$map$($author$project$Internal$Style2$singleShadow, shades)));
};
var $author$project$Game$gameSelectButton$ = function (isMobile, game) {
	return $author$project$MyUi$elButton$(
		$lamdera$program_test$Effect$Browser$Dom$id(
			'game_select_' + $author$project$Game$gameToString(game)),
		$author$project$Game$PressedSelectGame(game),
		_List_fromArray(
			[
				$author$project$Ui$width(
				$author$project$Ui$px(
					isMobile ? 170 : 240)),
				$author$project$Ui$height(
				$author$project$Ui$px(
					isMobile ? 170 : 240)),
				$author$project$Ui$rounded(16),
				$author$project$Ui$clip,
				$author$project$Ui$contentCenterY,
				$author$project$Ui$Font$size(
				isMobile ? 16 : 18),
				$author$project$Ui$Font$center,
				$author$project$Ui$Font$bold,
				$author$project$Ui$inFront(
				$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$contentCenterX,
							$author$project$Ui$contentCenterY,
							$author$project$Ui$alignBottom,
							$author$project$Ui$background(
							$author$project$Ui$rgba$(0, 0, 0, 0.7)),
							$author$project$Ui$Shadow$shadows(
							_List_fromArray(
								[
									{
									blur: 100,
									color: $author$project$Ui$rgba$(0, 0, 0, 1),
									size: 0,
									x: 0,
									y: 0
								}
								])),
							$author$project$Ui$heightMin(
							isMobile ? 32 : 40)
						]),
					$author$project$Ui$text(
						$author$project$Game$gameToString(game))))
			]),
		$author$project$Ui$imageLazy$(
			_List_Nil,
			{
				description: '',
				onLoad: $elm$core$Maybe$Nothing,
				source: $author$project$Game$gameToPreviewUrl(game)
			}));
};
var $author$project$Game$gameSelectButton = F2($author$project$Game$gameSelectButton$);
var $author$project$Go$PressedAgree = {$: 3};
var $author$project$Go$PressedCell = function (a) {
	return {$: 0, a: a};
};
var $author$project$Go$PressedDisagree = {$: 4};
var $author$project$Go$PressedDoneMarking = {$: 2};
var $author$project$Go$PressedJoinGame = {$: 5};
var $author$project$Go$PressedPass = {$: 1};
var $author$project$Go$SpectatorMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Go$boardColor = $author$project$Ui$rgb$(220, 179, 92);
var $author$project$Go$boardChromeHeight = 260;
var $author$project$Go$cellPx = 40;
var $elm$svg$Svg$Attributes$id = _VirtualDom_attribute('id');
var $elm$svg$Svg$Events$onClick = function (msg) {
	return $elm$html$Html$Events$on$(
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$svg$Svg$rect = $elm$svg$Svg$trustedNode('rect');
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $author$project$Go$clickTargets$ = function (width, height) {
	return $elm$core$List$concatMap$(
		function (x) {
			return $elm$core$List$map$(
				function (y) {
					return A2(
						$elm$svg$Svg$rect,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id(
								'go_cell_' + ($elm$core$String$fromInt(x) + ('_' + $elm$core$String$fromInt(y)))),
								$elm$svg$Svg$Attributes$x(
								$elm$core$String$fromInt(x * $author$project$Go$cellPx)),
								$elm$svg$Svg$Attributes$y(
								$elm$core$String$fromInt(y * $author$project$Go$cellPx)),
								$elm$svg$Svg$Attributes$width(
								$elm$core$String$fromInt($author$project$Go$cellPx)),
								$elm$svg$Svg$Attributes$height(
								$elm$core$String$fromInt($author$project$Go$cellPx)),
								$elm$svg$Svg$Attributes$fill('transparent'),
								$elm$svg$Svg$Attributes$style('cursor:pointer'),
								$elm$svg$Svg$Events$onClick(
								_Utils_Tuple2(x, y))
							]),
						_List_Nil);
				},
				$elm$core$List$range$(0, height - 1));
		},
		$elm$core$List$range$(0, width - 1));
};
var $author$project$Go$clickTargets = F2($author$project$Go$clickTargets$);
var $author$project$Go$deadStones = function (ctx) {
	return $elm$core$Dict$foldl$(
		F3(
			function (pos, stone, acc) {
				return $author$project$Go$isStoneDead$(ctx, pos, stone) ? $elm$core$Set$insert$(pos, acc) : acc;
			}),
		$elm$core$Set$empty,
		ctx.board);
};
var $author$project$Go$deadStonePositions$ = function (setup, model) {
	return $author$project$Go$deadStones(
		$author$project$Go$gameDeadContext$(setup, model));
};
var $author$project$Go$deadStonePositions = F2($author$project$Go$deadStonePositions$);
var $author$project$Go$gridLines$ = function (width, height) {
	var offset = ($author$project$Go$cellPx / 2) | 0;
	var endY = ((height - 1) * $author$project$Go$cellPx) + offset;
	var vertical = $elm$core$List$map$(
		function (i) {
			var p = (i * $author$project$Go$cellPx) + offset;
			return A2(
				$elm$svg$Svg$line,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$x1(
						$elm$core$String$fromInt(p)),
						$elm$svg$Svg$Attributes$y1(
						$elm$core$String$fromInt(offset)),
						$elm$svg$Svg$Attributes$x2(
						$elm$core$String$fromInt(p)),
						$elm$svg$Svg$Attributes$y2(
						$elm$core$String$fromInt(endY)),
						$elm$svg$Svg$Attributes$stroke('black'),
						$elm$svg$Svg$Attributes$strokeWidth('1')
					]),
				_List_Nil);
		},
		$elm$core$List$range$(0, width - 1));
	var endX = ((width - 1) * $author$project$Go$cellPx) + offset;
	var horizontal = $elm$core$List$map$(
		function (j) {
			var p = (j * $author$project$Go$cellPx) + offset;
			return A2(
				$elm$svg$Svg$line,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$x1(
						$elm$core$String$fromInt(offset)),
						$elm$svg$Svg$Attributes$y1(
						$elm$core$String$fromInt(p)),
						$elm$svg$Svg$Attributes$x2(
						$elm$core$String$fromInt(endX)),
						$elm$svg$Svg$Attributes$y2(
						$elm$core$String$fromInt(p)),
						$elm$svg$Svg$Attributes$stroke('black'),
						$elm$svg$Svg$Attributes$strokeWidth('1')
					]),
				_List_Nil);
		},
		$elm$core$List$range$(0, height - 1));
	return _Utils_ap(horizontal, vertical);
};
var $author$project$Go$gridLines = F2($author$project$Go$gridLines$);
var $author$project$Go$lastMoveMarker$ = function (viewingPast, state) {
	var _v0 = _Utils_Tuple2(viewingPast, state.lastMove);
	if ((!_v0.a) && (!_v0.b.$)) {
		var _v1 = _v0.b.a;
		var x = _v1.a;
		var y = _v1.b;
		return _List_fromArray(
			[
				A2(
				$elm$svg$Svg$circle,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$cx(
						$elm$core$String$fromInt((x * $author$project$Go$cellPx) + (($author$project$Go$cellPx / 2) | 0))),
						$elm$svg$Svg$Attributes$cy(
						$elm$core$String$fromInt((y * $author$project$Go$cellPx) + (($author$project$Go$cellPx / 2) | 0))),
						$elm$svg$Svg$Attributes$r(
						$elm$core$String$fromInt(($author$project$Go$cellPx / 8) | 0)),
						$elm$svg$Svg$Attributes$fill('rebeccapurple')
					]),
				_List_Nil)
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Go$lastMoveMarker = F2($author$project$Go$lastMoveMarker$);
var $author$project$Go$starPoints$ = function (width, height) {
	var _v0 = _Utils_Tuple2(width, height);
	_v0$3:
	while (true) {
		switch (_v0.a) {
			case 9:
				if (_v0.b === 9) {
					return _List_fromArray(
						[
							_Utils_Tuple2(2, 2),
							_Utils_Tuple2(6, 2),
							_Utils_Tuple2(4, 4),
							_Utils_Tuple2(2, 6),
							_Utils_Tuple2(6, 6)
						]);
				} else {
					break _v0$3;
				}
			case 13:
				if (_v0.b === 13) {
					return _List_fromArray(
						[
							_Utils_Tuple2(3, 3),
							_Utils_Tuple2(9, 3),
							_Utils_Tuple2(6, 6),
							_Utils_Tuple2(3, 9),
							_Utils_Tuple2(9, 9)
						]);
				} else {
					break _v0$3;
				}
			case 19:
				if (_v0.b === 19) {
					return _List_fromArray(
						[
							_Utils_Tuple2(3, 3),
							_Utils_Tuple2(9, 3),
							_Utils_Tuple2(15, 3),
							_Utils_Tuple2(3, 9),
							_Utils_Tuple2(9, 9),
							_Utils_Tuple2(15, 9),
							_Utils_Tuple2(3, 15),
							_Utils_Tuple2(9, 15),
							_Utils_Tuple2(15, 15)
						]);
				} else {
					break _v0$3;
				}
			default:
				break _v0$3;
		}
	}
	return _List_Nil;
};
var $author$project$Go$starPoints = F2($author$project$Go$starPoints$);
var $author$project$Go$starPointShapes$ = function (width, height) {
	return $elm$core$List$map$(
		function (_v0) {
			var x = _v0.a;
			var y = _v0.b;
			return A2(
				$elm$svg$Svg$circle,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$cx(
						$elm$core$String$fromInt((x * $author$project$Go$cellPx) + (($author$project$Go$cellPx / 2) | 0))),
						$elm$svg$Svg$Attributes$cy(
						$elm$core$String$fromInt((y * $author$project$Go$cellPx) + (($author$project$Go$cellPx / 2) | 0))),
						$elm$svg$Svg$Attributes$r('3'),
						$elm$svg$Svg$Attributes$fill('black')
					]),
				_List_Nil);
		},
		$author$project$Go$starPoints$(width, height));
};
var $author$project$Go$starPointShapes = F2($author$project$Go$starPointShapes$);
var $elm$svg$Svg$Attributes$opacity = _VirtualDom_attribute('opacity');
var $author$project$Go$stoneShapes$ = function (dead, board) {
	return $elm$core$List$map$(
		function (_v0) {
			var _v1 = _v0.a;
			var x = _v1.a;
			var y = _v1.b;
			var stone = _v0.b;
			var isDead = $elm$core$Set$member$(
				_Utils_Tuple2(x, y),
				dead);
			var cy = (y * $author$project$Go$cellPx) + (($author$project$Go$cellPx / 2) | 0);
			var cx = (x * $author$project$Go$cellPx) + (($author$project$Go$cellPx / 2) | 0);
			var color = function () {
				if (!stone) {
					return 'black';
				} else {
					return 'white';
				}
			}();
			return A2(
				$elm$svg$Svg$circle,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$cx(
						$elm$core$String$fromInt(cx)),
						$elm$svg$Svg$Attributes$cy(
						$elm$core$String$fromInt(cy)),
						$elm$svg$Svg$Attributes$r(
						$elm$core$String$fromInt((($author$project$Go$cellPx / 2) | 0) - 2)),
						$elm$svg$Svg$Attributes$fill(color),
						$elm$svg$Svg$Attributes$stroke('black'),
						$elm$svg$Svg$Attributes$strokeWidth('1'),
						$elm$svg$Svg$Attributes$opacity(
						isDead ? '0.35' : '1')
					]),
				_List_Nil);
		},
		$elm$core$Dict$toList(board));
};
var $author$project$Go$stoneShapes = F2($author$project$Go$stoneShapes$);
var $author$project$Go$territoryShapes = function (marks) {
	return $elm$core$List$map$(
		function (_v0) {
			var _v1 = _v0.a;
			var x = _v1.a;
			var y = _v1.b;
			var stone = _v0.b;
			var side = ($author$project$Go$cellPx / 4) | 0;
			var cy = (y * $author$project$Go$cellPx) + (($author$project$Go$cellPx / 2) | 0);
			var cx = (x * $author$project$Go$cellPx) + (($author$project$Go$cellPx / 2) | 0);
			var color = function () {
				if (!stone) {
					return 'black';
				} else {
					return 'white';
				}
			}();
			return A2(
				$elm$svg$Svg$rect,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$x(
						$elm$core$String$fromInt(cx - ((side / 2) | 0))),
						$elm$svg$Svg$Attributes$y(
						$elm$core$String$fromInt(cy - ((side / 2) | 0))),
						$elm$svg$Svg$Attributes$width(
						$elm$core$String$fromInt(side)),
						$elm$svg$Svg$Attributes$height(
						$elm$core$String$fromInt(side)),
						$elm$svg$Svg$Attributes$fill(color),
						$elm$svg$Svg$Attributes$stroke('black'),
						$elm$svg$Svg$Attributes$strokeWidth('1')
					]),
				_List_Nil);
		},
		$elm$core$Dict$toList(marks));
};
var $author$project$Go$viewHeight = function (windowSize) {
	return $elm$core$Basics$round(
		($author$project$Coord$yRaw(windowSize) * 2) / 3);
};
var $author$project$Go$viewingSnapshot$ = function (state, model) {
	if (model.viewingMovesBack <= 0) {
		return $author$project$Go$currentSnapshot(state);
	} else {
		var _v0 = $elm$core$List$head(
			$elm$core$List$drop$(model.viewingMovesBack - 1, state.history));
		if (!_v0.$) {
			var snapshot = _v0.a;
			return snapshot;
		} else {
			return $author$project$Go$currentSnapshot(state);
		}
	}
};
var $author$project$Go$viewingSnapshot = F2($author$project$Go$viewingSnapshot$);
var $author$project$Go$boardView$ = function (windowSize, setup, state, model) {
	var width = $author$project$Go$boardSizeToInt(setup.width);
	var widthPx = width * $author$project$Go$cellPx;
	var viewing = $author$project$Go$isViewingPast(model);
	var snapshot = $author$project$Go$viewingSnapshot$(state, model);
	var marks = viewing ? $elm$core$Dict$empty : state.territoryMarks;
	var isMobile = $author$project$MyUi$isMobileAlt(windowSize);
	var height = $author$project$Go$boardSizeToInt(setup.height);
	var heightPx = height * $author$project$Go$cellPx;
	var deadSet = viewing ? $elm$core$Set$empty : $author$project$Go$deadStonePositions$(setup, state);
	var availWidthPx = isMobile ? $elm$core$Basics$max$(
		200,
		$author$project$Coord$xRaw(windowSize)) : $elm$core$Basics$clamp$(
		280,
		600,
		($author$project$Coord$xRaw(windowSize) - $author$project$MyUi$channelAndGuildColumnWidth(windowSize)) - 64);
	var availHeightPx = $elm$core$Basics$max$(
		180,
		$author$project$Go$viewHeight(windowSize) - $author$project$Go$boardChromeHeight);
	var scale = $elm$core$Basics$clamp$(
		0.35,
		1.5,
		$elm$core$Basics$min$(availWidthPx / widthPx, availHeightPx / heightPx));
	var displayHeight = $elm$core$Basics$round(heightPx * scale);
	var displayWidth = $elm$core$Basics$round(widthPx * scale);
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$width($author$project$Ui$shrink),
				$author$project$Ui$centerX
			]),
		$author$project$Ui$html(
			A2(
				$elm$svg$Svg$svg,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$width(
						$elm$core$String$fromInt(displayWidth)),
						$elm$svg$Svg$Attributes$height(
						$elm$core$String$fromInt(displayHeight)),
						$elm$svg$Svg$Attributes$viewBox(
						'0 0 ' + ($elm$core$String$fromInt(widthPx) + (' ' + $elm$core$String$fromInt(heightPx)))),
						$elm$svg$Svg$Attributes$preserveAspectRatio('xMidYMid meet'),
						$elm$svg$Svg$Attributes$style('display:block')
					]),
				_Utils_ap(
					$author$project$Go$gridLines$(width, height),
					_Utils_ap(
						$author$project$Go$starPointShapes$(width, height),
						_Utils_ap(
							$author$project$Go$territoryShapes(marks),
							_Utils_ap(
								$author$project$Go$stoneShapes$(deadSet, snapshot.board),
								_Utils_ap(
									$author$project$Go$lastMoveMarker$(viewing, state),
									$author$project$Go$clickTargets$(
										$author$project$Go$boardSizeToInt(setup.width),
										$author$project$Go$boardSizeToInt(setup.height))))))))));
};
var $author$project$Go$boardView = F4($author$project$Go$boardView$);
var $author$project$Go$formatClock = function (seconds) {
	var twoDigit = function (n) {
		return (n < 10) ? ('0' + $elm$core$String$fromInt(n)) : $elm$core$String$fromInt(n);
	};
	var clamped = $elm$core$Basics$max$(
		0,
		$elm$core$Basics$floor(
			$ianmackenzie$elm_units$Duration$inSeconds(seconds)));
	var minutes = (clamped / 60) | 0;
	var secs = A2($elm$core$Basics$modBy, 60, clamped);
	return $elm$core$String$fromInt(minutes) + (':' + twoDigit(secs));
};
var $ianmackenzie$elm_units$Quantity$lessThanZero = function (_v0) {
	var x = _v0;
	return x < 0;
};
var $author$project$Ui$paddingRight = function (x) {
	return $author$project$Internal$Model2$style$(
		'padding-right',
		$elm$core$String$fromInt(x) + 'px');
};
var $author$project$Ui$image$ = function (attrs, img) {
	return $author$project$Internal$Model2$element$(
		$author$project$Internal$Model2$NodeAsDiv,
		2,
		A2(
			$elm$core$List$cons,
			$author$project$Ui$width($author$project$Ui$fill),
			attrs),
		_List_fromArray(
			[
				$author$project$Internal$Model2$element$(
				$author$project$Internal$Model2$NodeAsImage,
				2,
				_List_fromArray(
					[
						$author$project$Ui$width($author$project$Ui$fill),
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$clip,
						$author$project$Internal$Model2$class($author$project$Internal$Style2$classes.imageContainer),
						$author$project$Ui$htmlAttribute(
						$elm$html$Html$Attributes$src(img.source)),
						$author$project$Ui$htmlAttribute(
						$elm$html$Html$Attributes$alt(img.description)),
						function () {
						var _v0 = img.onLoad;
						if (!_v0.$) {
							var msg = _v0.a;
							return $author$project$Ui$htmlAttribute(
								$elm$html$Html$Events$on$(
									'load',
									$elm$json$Json$Decode$succeed(msg)));
						} else {
							return $author$project$Ui$noAttr;
						}
					}()
					]),
				_List_Nil)
			]));
};
var $author$project$Ui$image = F2($author$project$Ui$image$);
var $author$project$User$profileImageNoRounding = function (user) {
	if (!user.$) {
		var user2 = user.a;
		var _v1 = user2.icon;
		if (!_v1.$) {
			var fileHash = _v1.a;
			return $author$project$Ui$image$(
				_List_fromArray(
					[
						$author$project$Ui$width(
						$author$project$Ui$px($author$project$User$profileImageSize)),
						$author$project$Ui$height(
						$author$project$Ui$px($author$project$User$profileImageSize))
					]),
				{
					description: '',
					onLoad: $elm$core$Maybe$Nothing,
					source: $author$project$FileStatus$fileUrl$($author$project$FileStatus$pngContent, fileHash)
				});
		} else {
			return $author$project$GuildIcon$defaultUser$($author$project$User$profileImageSize, $author$project$Ui$noAttr, user2.color);
		}
	} else {
		return $author$project$GuildIcon$defaultUser$($author$project$User$profileImageSize, $author$project$Ui$noAttr, $author$project$RichText$defaultColor);
	}
};
var $author$project$StringExtra$dropSuffix$ = function (suffix, string) {
	return A2($elm$core$String$endsWith, suffix, string) ? $elm$core$String$dropRight$(
		$elm$core$String$length(suffix),
		string) : string;
};
var $author$project$StringExtra$dropSuffix = F2($author$project$StringExtra$dropSuffix$);
var $author$project$StringExtra$removeTrailing0s$ = function (decimalPoints, value) {
	var _v0 = $elm$core$String$split$(
		'.',
		A2($myrho$elm_round$Round$round, decimalPoints, value));
	_v0$2:
	while (true) {
		if (_v0.b) {
			if (_v0.b.b) {
				if (!_v0.b.b.b) {
					var nonDecimal = _v0.a;
					var _v1 = _v0.b;
					var decimal = _v1.a;
					return (decimalPoints > 0) ? $author$project$StringExtra$dropSuffix$(
						'.',
						nonDecimal + ('.' + A3(
							$elm$core$String$foldr,
							F2(
								function (_char, _v2) {
									var text = _v2.a;
									var reachedNonZero = _v2.b;
									return (reachedNonZero || (_char !== '0')) ? _Utils_Tuple2(text, true) : _Utils_Tuple2(
										$elm$core$String$dropRight$(1, text),
										false);
								}),
							_Utils_Tuple2(decimal, false),
							decimal).a)) : nonDecimal;
				} else {
					break _v0$2;
				}
			} else {
				var nonDecimal = _v0.a;
				return nonDecimal;
			}
		} else {
			break _v0$2;
		}
	}
	return '0';
};
var $author$project$StringExtra$removeTrailing0s = F2($author$project$StringExtra$removeTrailing0s$);
var $author$project$Go$clockChip$ = function (maybeUser, maybeTimeLeft, isActive, stone, score) {
	var _v0 = function () {
		if (stone === 1) {
			return _Utils_Tuple2(
				$author$project$Ui$rgb$(230, 230, 230),
				$author$project$Ui$rgb$(20, 20, 20));
		} else {
			return _Utils_Tuple2(
				$author$project$Ui$rgb$(20, 20, 20),
				$author$project$MyUi$white);
		}
	}();
	var colorA = _v0.a;
	var colorB = _v0.b;
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$rounded($author$project$User$profileImageRounding),
				$author$project$Ui$width(
				$author$project$Ui$px(170)),
				$author$project$Ui$border(2),
				$author$project$Ui$spacing(8),
				$author$project$Ui$paddingRight(8),
				$author$project$Ui$contentCenterY,
				$author$project$Ui$clip,
				$author$project$Ui$borderColor(
				function () {
					var _v2 = _Utils_Tuple2(isActive, stone);
					if (_v2.a) {
						if (!_v2.b) {
							var _v3 = _v2.b;
							return $author$project$Ui$rgb$(59, 153, 252);
						} else {
							var _v5 = _v2.b;
							return $author$project$Ui$rgb$(59, 153, 252);
						}
					} else {
						if (!_v2.b) {
							var _v4 = _v2.b;
							return colorA;
						} else {
							var _v6 = _v2.b;
							return colorA;
						}
					}
				}()),
				$author$project$Ui$background(colorA),
				isActive ? $author$project$Ui$Shadow$shadows(
				_List_fromArray(
					[
						{
						blur: 6,
						color: $author$project$Ui$rgba$(59, 153, 252, 1),
						size: 0,
						x: 0,
						y: 0
					}
					])) : $author$project$Ui$noAttr
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$move(
						{x: -1, y: 0, z: 0}),
						$author$project$Ui$width($author$project$Ui$shrink)
					]),
				$author$project$User$profileImageNoRounding(
					$elm$core$Maybe$map$($elm$core$Tuple$second, maybeUser))),
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(20),
						$author$project$Ui$alignRight,
						$author$project$Ui$Font$size(20),
						$author$project$Ui$Font$color(colorB)
					]),
				_List_fromArray(
					[
						function () {
						if (!maybeTimeLeft.$) {
							var timeLeft = maybeTimeLeft.a;
							return $author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$Font$bold,
										$author$project$Ui$width($author$project$Ui$shrink),
										$ianmackenzie$elm_units$Quantity$lessThanZero(timeLeft) ? $author$project$Ui$Font$color(
										function () {
											if (stone === 1) {
												return $author$project$Ui$rgb$(175, 0, 21);
											} else {
												return $author$project$MyUi$errorColor;
											}
										}()) : $author$project$Ui$noAttr
									]),
								$author$project$Ui$text(
									$author$project$Go$formatClock(timeLeft)));
						} else {
							return $author$project$Ui$none;
						}
					}(),
						$author$project$Ui$text(
						$author$project$StringExtra$removeTrailing0s$(1, score))
					]))
			]));
};
var $author$project$Go$clockChip = F5($author$project$Go$clockChip$);
var $author$project$Go$currentScore$ = function (setup, state, stone) {
	var _v0 = state.phase;
	if (_v0.$ === 3) {
		var s = _v0.a;
		if (!stone) {
			return s.blackScore;
		} else {
			return s.whiteScore;
		}
	} else {
		if (!stone) {
			return state.blackCaptures;
		} else {
			return state.whiteCaptures + $author$project$Go$komiHalfPointsToFloat(setup.komiHalfPoints);
		}
	}
};
var $author$project$Go$currentScore = F3($author$project$Go$currentScore$);
var $author$project$Go$clockView$ = function (currentTime, blackUser, whiteUser, state, setup) {
	var gameActive = function () {
		var _v2 = state.phase;
		switch (_v2.$) {
			case 0:
				return true;
			case 1:
				return true;
			case 2:
				return true;
			default:
				return false;
		}
	}();
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8),
				$author$project$Ui$paddingXY$(16, 16),
				$author$project$Ui$contentCenterX
			]),
		_List_fromArray(
			[
				$author$project$Go$clockChip$(
				blackUser,
				function () {
					var _v0 = state.timeLeft;
					if (!_v0.$) {
						var timeLeft = _v0.a;
						return $elm$core$Maybe$Just(
							$author$project$Go$actualTimeLeft$(currentTime, 0, state.currentPlayer, timeLeft.black, state));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}(),
				gameActive && (!state.currentPlayer),
				0,
				$author$project$Go$currentScore$(setup, state, 0)),
				$author$project$Go$clockChip$(
				whiteUser,
				function () {
					var _v1 = state.timeLeft;
					if (!_v1.$) {
						var timeLeft = _v1.a;
						return $elm$core$Maybe$Just(
							$author$project$Go$actualTimeLeft$(currentTime, 1, state.currentPlayer, timeLeft.white, state));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}(),
				gameActive && (state.currentPlayer === 1),
				1,
				$author$project$Go$currentScore$(setup, state, 1))
			]));
};
var $author$project$Go$clockView = F5($author$project$Go$clockView$);
var $author$project$MyUi$dangerRed = $author$project$Ui$rgb$(200, 60, 60);
var $author$project$Go$ChangedViewingMove = function (a) {
	return {$: 2, a: a};
};
var $author$project$Go$PressedArrowLeft = {$: 0};
var $author$project$Go$PressedArrowRight = {$: 1};
var $author$project$Icons$arrowRight = function (width) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromInt(width))
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M2 8a.75.75 0 0 1 .75-.75h8.69L8.22 4.03a.75.75 0 0 1 1.06-1.06l4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 0 1-1.06-1.06l3.22-3.22H2.75A.75.75 0 0 1 2 8Z'),
						$elm$svg$Svg$Attributes$clipRule('evenodd')
					]),
				_List_Nil)
			]));
};
var $elm$html$Html$Attributes$max = _VirtualDom_attribute('max');
var $elm$html$Html$Attributes$min = _VirtualDom_attribute('min');
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn$ = function (event, decoder) {
	return A2(
		$elm$virtual_dom$VirtualDom$on,
		event,
		$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
};
var $elm$html$Html$Events$stopPropagationOn = F2($elm$html$Html$Events$stopPropagationOn$);
var $elm$html$Html$Events$targetValue = $elm$json$Json$Decode$at$(
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return $elm$html$Html$Events$stopPropagationOn$(
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $author$project$MyUi$id = function (htmlId) {
	return $author$project$Ui$id(
		$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId));
};
var $author$project$MyUi$simpleButton$ = function (htmlId, onPress, content) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$Input$button(onPress),
				$author$project$Ui$borderColor($author$project$MyUi$buttonBorder),
				$author$project$Ui$border(1),
				$author$project$Ui$background($author$project$MyUi$buttonBackground),
				$author$project$Ui$rounded(4),
				$author$project$MyUi$id(htmlId),
				$author$project$Ui$width($author$project$Ui$shrink),
				$author$project$Ui$paddingXY$(16, 8),
				$author$project$Ui$Font$weight(500)
			]),
		content);
};
var $author$project$MyUi$simpleButton = F3($author$project$MyUi$simpleButton$);
var $elm$html$Html$Attributes$type_ = _VirtualDom_attribute('type');
var $author$project$Go$historyView$ = function (state, model) {
	var total = $elm$core$List$length(state.history);
	var currentMove = total - model.viewingMovesBack;
	return (!total) ? $author$project$Ui$none : $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8),
				$author$project$Ui$width($author$project$Ui$shrink),
				$author$project$Ui$paddingXY$(16, 0)
			]),
		_List_fromArray(
			[
				$author$project$MyUi$simpleButton$(
				$lamdera$program_test$Effect$Browser$Dom$id('go_arrowLeft'),
				$author$project$Go$PressedArrowLeft,
				$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$MyUi$hoverText('Previous move')
						]),
					$author$project$Ui$html(
						$author$project$Icons$arrowLeft(20)))),
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$width(
						$author$project$Ui$px(220))
					]),
				$author$project$Ui$html(
					A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('range'),
								$elm$html$Html$Attributes$min('0'),
								$elm$html$Html$Attributes$max(
								$elm$core$String$fromInt(total)),
								$elm$html$Html$Attributes$value(
								$elm$core$String$fromInt(currentMove)),
								A2($elm$html$Html$Attributes$style, 'width', '200px'),
								$elm$html$Html$Events$onInput(
								function (s) {
									return $author$project$Go$ChangedViewingMove(
										$elm$core$Maybe$withDefault$(
											currentMove,
											$elm$core$String$toInt(s)));
								})
							]),
						_List_Nil))),
				$author$project$MyUi$simpleButton$(
				$lamdera$program_test$Effect$Browser$Dom$id('go_arrowRight'),
				$author$project$Go$PressedArrowRight,
				$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$MyUi$hoverText('Next move')
						]),
					$author$project$Ui$html(
						$author$project$Icons$arrowRight(20)))),
				$author$project$Ui$el$(
				_List_fromArray(
					[$author$project$Ui$Font$bold]),
				$author$project$Ui$text(
					$elm$core$String$fromInt(currentMove) + (' / ' + $elm$core$String$fromInt(total))))
			]));
};
var $author$project$Go$historyView = F2($author$project$Go$historyView$);
var $author$project$Go$lossOnTimeText = function (ranOutOfTime) {
	if (ranOutOfTime === 1) {
		return 'Black wins! White loses on time.';
	} else {
		return 'White wins! Black loses on time.';
	}
};
var $author$project$Go$stoneName = function (stone) {
	if (!stone) {
		return 'Black';
	} else {
		return 'White';
	}
};
var $author$project$Go$winnerSuffix$ = function (b, w) {
	return (_Utils_cmp(b, w) > 0) ? ' (Black wins)' : ((_Utils_cmp(w, b) > 0) ? ' (White wins)' : ' (tie)');
};
var $author$project$Go$winnerSuffix = F2($author$project$Go$winnerSuffix$);
var $author$project$Go$statusView$ = function (currentTime, state) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$Font$weight(600),
				$author$project$Ui$paddingXY$(16, 0)
			]),
		$author$project$Ui$text(
			function () {
				var _v0 = state.phase;
				switch (_v0.$) {
					case 0:
						var previousPlayerPassed = _v0.a.previousPlayerPassed;
						return $author$project$Go$hasTimeToDoAction$(currentTime, state) ? ((previousPlayerPassed ? ($author$project$Go$stoneName(
							$author$project$Go$otherStone(state.currentPlayer)) + ' passed. ') : '') + ($author$project$Go$stoneName(state.currentPlayer) + ' to move')) : $author$project$Go$lossOnTimeText(state.currentPlayer);
					case 1:
						return $author$project$Go$stoneName(state.currentPlayer) + ' marks territory: tap an empty region to cycle owner (none → Black → White).';
					case 2:
						return $author$project$Go$stoneName(
							$author$project$Go$otherStone(state.currentPlayer)) + ': agree with the marking, or disagree to resume play.';
					default:
						var s = _v0.a;
						return 'Final score - Black: ' + ($author$project$StringExtra$removeTrailing0s$(1, s.blackScore) + (', White: ' + ($author$project$StringExtra$removeTrailing0s$(1, s.whiteScore) + $author$project$Go$winnerSuffix$(s.blackScore, s.whiteScore))));
				}
			}()));
};
var $author$project$Go$statusView = F2($author$project$Go$statusView$);
var $author$project$Go$gameView$ = function (currentTime, windowSize, localUser, setup, shared, model) {
	var players = $author$project$Go$getPlayers$(setup, shared);
	var isMobile = $author$project$MyUi$isMobileAlt(windowSize);
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(
				isMobile ? 8 : 16),
				$author$project$Ui$paddingXY$(
				0,
				isMobile ? 8 : 16),
				$author$project$Ui$background($author$project$MyUi$background1)
			]),
		_List_fromArray(
			[
				$author$project$Ui$column$(
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Go$statusView$(currentTime, shared),
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$height(
								$author$project$Ui$px(44)),
								$author$project$Ui$contentCenterY
							]),
						function () {
							if (_Utils_eq(shared.joinedUserId, $elm$core$Maybe$Nothing) && (!_Utils_eq(setup.createdBy, localUser.session.userId))) {
								return $author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$paddingXY$(16, 0)
										]),
									$author$project$MyUi$simpleButton$(
										$lamdera$program_test$Effect$Browser$Dom$id('go_joinGame'),
										$author$project$Go$PressedJoinGame,
										$author$project$Ui$text('Join game')));
							} else {
								if ($author$project$Go$isLocalUsersTurn$(localUser.session.userId, setup, shared) && $author$project$Go$hasTimeToDoAction$(currentTime, shared)) {
									var _v0 = shared.phase;
									switch (_v0.$) {
										case 0:
											var previousPlayerPassed = _v0.a.previousPlayerPassed;
											return $author$project$Ui$el$(
												_List_fromArray(
													[
														$author$project$Ui$paddingXY$(16, 0)
													]),
												$author$project$MyUi$simpleButton$(
													$lamdera$program_test$Effect$Browser$Dom$id('go_pass'),
													$author$project$Go$PressedPass,
													$author$project$Ui$text(
														previousPlayerPassed ? 'Pass and mark territory' : 'Pass')));
										case 1:
											return $author$project$Ui$el$(
												_List_fromArray(
													[
														$author$project$Ui$paddingXY$(16, 0)
													]),
												$author$project$MyUi$simpleButton$(
													$lamdera$program_test$Effect$Browser$Dom$id('go_doneMarking'),
													$author$project$Go$PressedDoneMarking,
													$author$project$Ui$text('Done marking')));
										case 2:
											return $author$project$Ui$row$(
												_List_fromArray(
													[
														$author$project$Ui$spacing(8),
														$author$project$Ui$paddingXY$(16, 0)
													]),
												_List_fromArray(
													[
														$author$project$MyUi$simpleButton$(
														$lamdera$program_test$Effect$Browser$Dom$id('go_agree'),
														$author$project$Go$PressedAgree,
														$author$project$Ui$text('Agree')),
														$author$project$MyUi$simpleButton$(
														$lamdera$program_test$Effect$Browser$Dom$id('go_disagree'),
														$author$project$Go$PressedDisagree,
														$author$project$Ui$text('Disagree'))
													]));
										default:
											return $author$project$Ui$none;
									}
								} else {
									return $author$project$Ui$none;
								}
							}
						}())
					])),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$width($author$project$Ui$shrink),
						$author$project$Ui$background($author$project$Go$boardColor),
						$author$project$Ui$rounded(4)
					]),
				_List_fromArray(
					[
						$author$project$Go$clockView$(
						currentTime,
						function () {
							var _v1 = players.black;
							if (!_v1.$) {
								var userId = _v1.a;
								return $elm$core$Maybe$map$(
									$elm$core$Tuple$pair(userId),
									$author$project$User$getUser$(userId, localUser));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}(),
						function () {
							var _v2 = players.white;
							if (!_v2.$) {
								var userId = _v2.a;
								return $elm$core$Maybe$map$(
									$elm$core$Tuple$pair(userId),
									$author$project$User$getUser$(userId, localUser));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}(),
						shared,
						setup),
						A2(
						$author$project$Ui$map,
						$author$project$Go$PressedCell,
						$author$project$Ui$Lazy$lazy4$($author$project$Go$boardView, windowSize, setup, shared, model))
					])),
				isMobile ? $author$project$Ui$none : A2(
				$author$project$Ui$map,
				$author$project$Go$SpectatorMsg,
				$author$project$Ui$Lazy$lazy2$($author$project$Go$historyView, shared, model)),
				function () {
				var _v3 = model.lastError;
				if (!_v3.$) {
					var err = _v3.a;
					return $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$Font$color($author$project$MyUi$dangerRed)
							]),
						$author$project$Ui$text(err));
				} else {
					return $author$project$Ui$none;
				}
			}()
			]));
};
var $author$project$Go$gameView = F6($author$project$Go$gameView$);
var $author$project$SheepGame$PressedHidePreviousQuestion = {$: 17};
var $author$project$SheepGame$PressedShowNextQuestion = {$: 16};
var $author$project$SheepGame$UserScrolledResults = function (a) {
	return {$: 22, a: a};
};
var $author$project$SheepGame$PressedLockAnswers = {$: 6};
var $author$project$SheepGame$PressedDeleteAnswerFile$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$SheepGame$PressedDeleteAnswerFile = F2($author$project$SheepGame$PressedDeleteAnswerFile$);
var $author$project$SheepGame$PressedToggleAnswerFileSpoiler$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$SheepGame$PressedToggleAnswerFileSpoiler = F2($author$project$SheepGame$PressedToggleAnswerFileSpoiler$);
var $author$project$SheepGame$PressedViewAnswerFileInfo$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $author$project$SheepGame$PressedViewAnswerFileInfo = F2($author$project$SheepGame$PressedViewAnswerFileInfo$);
var $author$project$SheepGame$TypedAnswer$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$SheepGame$TypedAnswer = F2($author$project$SheepGame$TypedAnswer$);
var $author$project$MessageInput$IgnoreTouchStart = {$: 14};
var $author$project$MessageInput$PressedUploadFile = {$: 7};
var $author$project$Ui$Events$stopPropagationOn$ = function (name, decoder) {
	return $author$project$Internal$Model2$attribute(
		$elm$html$Html$Events$stopPropagationOn$(name, decoder));
};
var $author$project$Ui$Events$stopPropagationOn = F2($author$project$Ui$Events$stopPropagationOn$);
var $author$project$MyUi$blockTouchStartPropagation = function (msg) {
	return $author$project$Ui$Events$stopPropagationOn$(
		'touchstart',
		$elm$json$Json$Decode$succeed(
			_Utils_Tuple2(msg, true)));
};
var $author$project$MessageInput$attachmentButton = function (htmlIdPrefix) {
	return $author$project$MyUi$elButton$(
		$lamdera$program_test$Effect$Browser$Dom$id(htmlIdPrefix + '_uploadFile'),
		$author$project$MessageInput$PressedUploadFile,
		_List_fromArray(
			[
				$author$project$Ui$rounded(4),
				$author$project$Ui$width($author$project$Ui$shrink),
				$author$project$Ui$paddingXY$(6, 0),
				$author$project$Ui$height(
				$author$project$Ui$px(40)),
				$author$project$Ui$background($author$project$MyUi$buttonBackground),
				$author$project$Ui$contentCenterY,
				$author$project$Ui$centerY,
				$author$project$MyUi$hoverText('Attach file'),
				$author$project$MyUi$blockTouchStartPropagation($author$project$MessageInput$IgnoreTouchStart)
			]),
		$author$project$Ui$html($author$project$Icons$attachment));
};
var $author$project$MessageInput$containerAttributes = function (roundTopCorners) {
	return _List_fromArray(
		[
			$author$project$Ui$paddingWith(
			{bottom: 19, left: 0, right: 0, top: 0}),
			$author$project$Ui$scrollable,
			$author$project$Ui$border(1),
			$author$project$Ui$borderColor($author$project$MyUi$border1),
			roundTopCorners ? $author$project$Ui$rounded(8) : $author$project$Ui$roundedWith(
			{bottomLeft: 8, bottomRight: 8, topLeft: 0, topRight: 0}),
			$author$project$Ui$heightMin(0),
			$author$project$MyUi$htmlStyle$('scrollbar-color', 'black'),
			$author$project$Ui$background($author$project$MyUi$background2)
		]);
};
var $author$project$RichText$attachmentsHelper$ = function (isSpoilered, nonempty) {
	return $elm$core$List$concatMap$(
		function (richText) {
			switch (richText.$) {
				case 10:
					return _List_Nil;
				case 11:
					return _List_Nil;
				case 0:
					return _List_Nil;
				case 1:
					return _List_Nil;
				case 2:
					return _List_Nil;
				case 3:
					var nonempty2 = richText.a;
					return $author$project$RichText$attachmentsHelper$(isSpoilered, nonempty2);
				case 4:
					var nonempty2 = richText.a;
					return $author$project$RichText$attachmentsHelper$(isSpoilered, nonempty2);
				case 5:
					var nonempty2 = richText.a;
					return $author$project$RichText$attachmentsHelper$(isSpoilered, nonempty2);
				case 6:
					var nonempty2 = richText.a;
					return $author$project$RichText$attachmentsHelper$(isSpoilered, nonempty2);
				case 7:
					var nonempty2 = richText.a;
					return $author$project$RichText$attachmentsHelper$(true, nonempty2);
				case 8:
					var list = richText.b;
					return $elm$core$Maybe$withDefault$(
						_List_Nil,
						$elm$core$Maybe$map$(
							$author$project$RichText$attachmentsHelper(isSpoilered),
							$mgold$elm_nonempty_list$List$Nonempty$fromList(list)));
				case 9:
					var nonempty2 = richText.c;
					return $author$project$RichText$attachmentsHelper$(isSpoilered, nonempty2);
				case 12:
					return _List_Nil;
				case 13:
					return _List_Nil;
				case 14:
					var fileId = richText.a;
					return _List_fromArray(
						[
							{attachmentId: fileId, isSpoilered: isSpoilered}
						]);
				case 15:
					return _List_Nil;
				case 16:
					return _List_Nil;
				case 17:
					return _List_Nil;
				case 18:
					var items = richText.b;
					return $elm$core$List$concatMap$(
						$author$project$RichText$bulletItemConcatMap(
							$author$project$RichText$attachmentsHelper(isSpoilered)),
						$mgold$elm_nonempty_list$List$Nonempty$toList(items));
				default:
					return _List_Nil;
			}
		},
		$mgold$elm_nonempty_list$List$Nonempty$toList(nonempty));
};
var $author$project$RichText$attachmentsHelper = F2($author$project$RichText$attachmentsHelper$);
var $author$project$RichText$attachments = function (nonempty) {
	return $author$project$RichText$attachmentsHelper$(false, nonempty);
};
var $author$project$Icons$camera = function (width) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$strokeWidth('1.5'),
				$elm$svg$Svg$Attributes$stroke('currentColor'),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromInt(width))
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$d('m15.75 10.5 4.72-4.72a.75.75 0 0 1 1.28.53v11.38a.75.75 0 0 1-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25h-9A2.25 2.25 0 0 0 2.25 7.5v9a2.25 2.25 0 0 0 2.25 2.25Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Icons$closedEye = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor'),
			$elm$svg$Svg$Attributes$width('24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88')
				]),
			_List_Nil)
		]));
var $author$project$FileStatus$Application = 4;
var $author$project$FileStatus$Audio = 3;
var $author$project$FileStatus$Image = 1;
var $author$project$FileStatus$Other = 5;
var $author$project$FileStatus$Text = 0;
var $author$project$FileStatus$Video = 2;
var $author$project$OneToOne$second$ = function (a, _v0) {
	var firstToSecond = _v0.a;
	return $lamdera$containers$SeqDict$get$(a, firstToSecond);
};
var $author$project$OneToOne$second = F2($author$project$OneToOne$second$);
var $author$project$FileStatus$contentTypeType = function (contentType2) {
	var _v0 = $author$project$OneToOne$second$(contentType2, $author$project$FileStatus$contentTypes);
	if (!_v0.$) {
		var text = _v0.a;
		return A2($elm$core$String$startsWith, 'image/', text) ? 1 : (A2($elm$core$String$startsWith, 'text/', text) ? 0 : (A2($elm$core$String$startsWith, 'video/', text) ? 2 : (A2($elm$core$String$startsWith, 'audio/', text) ? 3 : (A2($elm$core$String$startsWith, 'application/', text) ? 4 : 5))));
	} else {
		return 5;
	}
};
var $author$project$Icons$document = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z')
				]),
			_List_Nil)
		]));
var $author$project$FileStatus$contentTypeHeader = function (contentType2) {
	var _v0 = $author$project$OneToOne$second$(contentType2, $author$project$FileStatus$contentTypes);
	if (!_v0.$) {
		var text = _v0.a;
		return A2($elm$core$String$startsWith, 'text/', text) ? (text + '; charset=UTF-8') : text;
	} else {
		return 'application/octet-stream';
	}
};
var $author$project$FileStatus$encryptedFileUrl$ = function (contentType2, _v0) {
	var fileHash2 = _v0;
	return $author$project$FileStatus$domain + ('/file/e/' + ($elm$url$Url$percentEncode(
		$author$project$FileStatus$contentTypeHeader(contentType2)) + ('/' + fileHash2)));
};
var $author$project$FileStatus$encryptedFileUrl = F2($author$project$FileStatus$encryptedFileUrl$);
var $author$project$FileStatus$encryptedThumbnailUrl = function (_v0) {
	var fileHash2 = _v0;
	return $author$project$FileStatus$domain + ('/file/e/t/' + fileHash2);
};
var $author$project$FileStatus$imageMaxHeight = 600;
var $author$project$FileStatus$hasThumbnailImage = function (imageSize) {
	return (_Utils_cmp(
		$author$project$Coord$yRaw(imageSize),
		$author$project$FileStatus$imageMaxHeight) > 0) || (_Utils_cmp(
		$author$project$Coord$xRaw(imageSize),
		$author$project$FileStatus$imageMaxHeight * 3) > 0);
};
var $author$project$FileStatus$thumbnailUrl$ = function (imageSize, contentType2, _v0) {
	var fileHash2 = _v0;
	return $author$project$FileStatus$hasThumbnailImage(imageSize) ? ($author$project$FileStatus$domain + ('/file/t/' + fileHash2)) : $author$project$FileStatus$fileUrl$(contentType2, fileHash2);
};
var $author$project$FileStatus$thumbnailUrl = F3($author$project$FileStatus$thumbnailUrl$);
var $author$project$FileStatus$fileDataThumbnailUrl$ = function (imageSize, fileData) {
	var _v0 = fileData.isEncrypted;
	if (_v0.$ === 1) {
		if (_v0.b === 1) {
			var _v1 = _v0.b;
			return $author$project$FileStatus$encryptedThumbnailUrl(fileData.fileHash);
		} else {
			var _v2 = _v0.b;
			return $author$project$FileStatus$encryptedFileUrl$(fileData.contentType, fileData.fileHash);
		}
	} else {
		return $author$project$FileStatus$thumbnailUrl$(imageSize, fileData.contentType, fileData.fileHash);
	}
};
var $author$project$FileStatus$fileDataThumbnailUrl = F2($author$project$FileStatus$fileDataThumbnailUrl$);
var $author$project$FileStatus$fileDataUrl = function (fileData) {
	var _v0 = fileData.isEncrypted;
	if (_v0.$ === 1) {
		return $author$project$FileStatus$encryptedFileUrl$(fileData.contentType, fileData.fileHash);
	} else {
		return $author$project$FileStatus$fileUrl$(fileData.contentType, fileData.fileHash);
	}
};
var $author$project$Icons$info = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z')
				]),
			_List_Nil)
		]));
var $author$project$Icons$map = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor'),
			$elm$svg$Svg$Attributes$width('24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M9 6.75V15m6-6v8.25m.503 3.498 4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 0 0-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0Z')
				]),
			_List_Nil)
		]));
var $author$project$SheepGame$fileUploadInfoButton$ = function (onPressInfo, fileStatusId, metadata) {
	return $author$project$Ui$inFront(
		$author$project$MyUi$elButton$(
			$lamdera$program_test$Effect$Browser$Dom$id(
				'fileStatus_info_' + $author$project$Id$toString(fileStatusId)),
			onPressInfo(fileStatusId),
			_List_fromArray(
				[
					$author$project$Ui$width(
					$author$project$Ui$px(42)),
					$author$project$Ui$height(
					$author$project$Ui$px(42)),
					$author$project$Ui$rounded(16),
					$author$project$Ui$move(
					{x: -3, y: 77, z: 0}),
					$author$project$MyUi$hoverText('Image info')
				]),
			$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$width(
						$author$project$Ui$px(34)),
						$author$project$Ui$height(
						$author$project$Ui$px(34)),
						$author$project$Ui$rounded(16),
						$author$project$Ui$contentCenterX,
						$author$project$Ui$contentCenterY,
						$author$project$Ui$background($author$project$MyUi$buttonBackground)
					]),
				function () {
					var _v0 = metadata.gpsLocation;
					if (!_v0.$) {
						return $author$project$Ui$html($author$project$Icons$map);
					} else {
						return $author$project$Ui$html($author$project$Icons$info);
					}
				}())));
};
var $author$project$SheepGame$fileUploadInfoButton = F3($author$project$SheepGame$fileUploadInfoButton$);
var $author$project$SheepGame$fileUploadPreviewSize = 150;
var $author$project$Ui$Shadow$font = function (shade) {
	return $author$project$Internal$Model2$style$(
		'text-shadow',
		_Utils_ap(
			$elm$core$String$fromFloat(shade.offset.a) + 'px ',
			_Utils_ap(
				$elm$core$String$fromFloat(shade.offset.b) + 'px ',
				_Utils_ap(
					$elm$core$String$fromFloat(shade.blur) + 'px ',
					$author$project$Internal$Style2$color(shade.color)))));
};
var $elm$html$Html$Attributes$height = function (n) {
	return A2(
		_VirtualDom_attribute,
		'height',
		$elm$core$String$fromInt(n));
};
var $author$project$FileStatus$imageHasMetadata = function (metadata) {
	return (!_Utils_eq(metadata.orientation, $elm$core$Maybe$Nothing)) || ((!_Utils_eq(metadata.gpsLocation, $elm$core$Maybe$Nothing)) || ((!_Utils_eq(metadata.cameraOwner, $elm$core$Maybe$Nothing)) || ((!_Utils_eq(metadata.exposureTime, $elm$core$Maybe$Nothing)) || ((!_Utils_eq(metadata.fNumber, $elm$core$Maybe$Nothing)) || ((!_Utils_eq(metadata.focalLength, $elm$core$Maybe$Nothing)) || ((!_Utils_eq(metadata.isoSpeedRating, $elm$core$Maybe$Nothing)) || ((!_Utils_eq(metadata.make, $elm$core$Maybe$Nothing)) || ((!_Utils_eq(metadata.model, $elm$core$Maybe$Nothing)) || ((!_Utils_eq(metadata.software, $elm$core$Maybe$Nothing)) || (!_Utils_eq(metadata.userComment, $elm$core$Maybe$Nothing)))))))))));
};
var $author$project$Ui$Font$letterSpacing = function (offset) {
	return $author$project$Internal$Model2$style$(
		'letter-spacing',
		$elm$core$String$fromFloat(offset) + 'px');
};
var $author$project$Ui$Font$lineHeight = function (height) {
	return $author$project$Internal$Model2$style$(
		'line-height',
		$elm$core$String$fromFloat(height));
};
var $author$project$Icons$openEye = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor'),
			$elm$svg$Svg$Attributes$width('24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z')
				]),
			_List_Nil)
		]));
var $author$project$FileStatus$progressToString = function (_v0) {
	var size = _v0.size;
	var sent = _v0.sent;
	return (size < 200) ? ($elm$core$String$fromInt(sent) + ('/' + ($elm$core$String$fromInt(size) + ' bytes'))) : ((_Utils_cmp(size, 1024 * 1024) < 0) ? ($author$project$StringExtra$removeTrailing0s$(1, sent / 1024) + ('/' + ($author$project$StringExtra$removeTrailing0s$(1, size / 1024) + 'kb'))) : ($author$project$StringExtra$removeTrailing0s$(1, sent / (1024 * 1024)) + ('/' + ($author$project$StringExtra$removeTrailing0s$(1, size / (1024 * 1024)) + 'mb'))));
};
var $author$project$FileStatus$videoHasMetadata = function (metadata) {
	return (!_Utils_eq(metadata.duration, $elm$core$Maybe$Nothing)) || ((!_Utils_eq(metadata.createdAt, $elm$core$Maybe$Nothing)) || ((!(!metadata.orientation)) || ((!_Utils_eq(metadata.codec, $elm$core$Maybe$Nothing)) || (!_Utils_eq(metadata.title, $elm$core$Maybe$Nothing)))));
};
var $author$project$Icons$volume = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M19.114 5.636a9 9 0 0 1 0 12.728M16.463 8.288a5.25 5.25 0 0 1 0 7.424M6.75 8.25l4.72-4.72a.75.75 0 0 1 1.28.53v15.88a.75.75 0 0 1-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.009 9.009 0 0 1 2.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z')
				]),
			_List_Nil)
		]));
var $elm$html$Html$Attributes$width = function (n) {
	return A2(
		_VirtualDom_attribute,
		'width',
		$elm$core$String$fromInt(n));
};
var $author$project$SheepGame$fileUploadPreview$ = function (onPressDelete, onPressInfo, onPressSpoiler, richText, filesToUpload2) {
	var isSpoilered = function () {
		if (!richText.$) {
			var richText2 = richText.a;
			return $lamdera$containers$SeqDict$fromList(
				$elm$core$List$map$(
					function (a) {
						return _Utils_Tuple2(a.attachmentId, a.isSpoilered);
					},
					$author$project$RichText$attachments(richText2)));
		} else {
			return $lamdera$containers$SeqDict$empty;
		}
	}();
	return $elm$core$List$map$(
		function (_v0) {
			var fileStatusId = _v0.a;
			var fileStatus = _v0.b;
			var isSpoilered2 = $elm$core$Maybe$withDefault$(
				false,
				$lamdera$containers$SeqDict$get$(fileStatusId, isSpoilered));
			return $author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$width(
						$author$project$Ui$px($author$project$SheepGame$fileUploadPreviewSize)),
						$author$project$Ui$height(
						$author$project$Ui$px($author$project$SheepGame$fileUploadPreviewSize)),
						$author$project$Ui$background($author$project$MyUi$background1),
						$author$project$Ui$borderColor(
						$author$project$Ui$rgb$(150, 150, 160)),
						$author$project$Ui$border(1),
						$author$project$Ui$rounded(8),
						$author$project$Ui$inFront(
						$author$project$MyUi$elButton$(
							$lamdera$program_test$Effect$Browser$Dom$id(
								'fileStatus_delete_' + $author$project$Id$toString(fileStatusId)),
							onPressDelete(fileStatusId),
							_List_fromArray(
								[
									$author$project$Ui$width(
									$author$project$Ui$px(42)),
									$author$project$Ui$height(
									$author$project$Ui$px(42)),
									$author$project$Ui$rounded(16),
									$author$project$Ui$move(
									{x: -3, y: -3, z: 0}),
									$author$project$MyUi$hoverText('Remove file')
								]),
							$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$width(
										$author$project$Ui$px(34)),
										$author$project$Ui$height(
										$author$project$Ui$px(34)),
										$author$project$Ui$rounded(16),
										$author$project$Ui$contentCenterX,
										$author$project$Ui$contentCenterY,
										$author$project$Ui$background($author$project$MyUi$deleteButtonBackground),
										$author$project$Ui$border(1),
										$author$project$Ui$borderColor($author$project$MyUi$deleteButtonBorder)
									]),
								$author$project$Ui$html($author$project$Icons$delete)))),
						function () {
						if (!onPressSpoiler.$) {
							var onPressSpoiler2 = onPressSpoiler.a;
							return $author$project$Ui$inFront(
								$author$project$MyUi$elButton$(
									$lamdera$program_test$Effect$Browser$Dom$id(
										'fileStatus_spoiler_' + $author$project$Id$toString(fileStatusId)),
									onPressSpoiler2(
										{fileId: fileStatusId, removeSpoiler: isSpoilered2}),
									_List_fromArray(
										[
											$author$project$Ui$width(
											$author$project$Ui$px(42)),
											$author$project$Ui$height(
											$author$project$Ui$px(42)),
											$author$project$Ui$rounded(16),
											$author$project$Ui$move(
											{x: -3, y: 40, z: 0}),
											$author$project$MyUi$hoverText(
											isSpoilered2 ? 'Remove spoiler' : 'Mark as spoiler')
										]),
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$width(
												$author$project$Ui$px(34)),
												$author$project$Ui$height(
												$author$project$Ui$px(34)),
												$author$project$Ui$rounded(16),
												$author$project$Ui$contentCenterX,
												$author$project$Ui$contentCenterY,
												$author$project$Ui$background($author$project$MyUi$buttonBackground)
											]),
										$author$project$Ui$html(
											isSpoilered2 ? $author$project$Icons$closedEye : $author$project$Icons$openEye))));
						} else {
							return $author$project$Ui$noAttr;
						}
					}(),
						function () {
						switch (fileStatus.$) {
							case 1:
								var fileData = fileStatus.a;
								var _v3 = fileData.metadata;
								if (!_v3.$) {
									if (!_v3.a.$) {
										var imageMetadata = _v3.a.a;
										return $author$project$FileStatus$imageHasMetadata(imageMetadata) ? $author$project$SheepGame$fileUploadInfoButton$(onPressInfo, fileStatusId, imageMetadata) : $author$project$Ui$noAttr;
									} else {
										var videoMetadata = _v3.a.a;
										return $author$project$FileStatus$videoHasMetadata(videoMetadata) ? $author$project$SheepGame$fileUploadInfoButton$(onPressInfo, fileStatusId, videoMetadata) : $author$project$Ui$noAttr;
									}
								} else {
									return $author$project$Ui$noAttr;
								}
							case 0:
								return $author$project$Ui$noAttr;
							default:
								return $author$project$Ui$noAttr;
						}
					}(),
						$author$project$Ui$inFront(
						$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$alignBottom,
									$author$project$Ui$padding(4),
									$author$project$Ui$Font$bold,
									$author$project$Ui$Shadow$font(
									{
										blur: 3,
										color: $author$project$MyUi$black,
										offset: _Utils_Tuple2(0, 0)
									})
								]),
							$author$project$Ui$text(
								'[!' + ($author$project$Id$toString(fileStatusId) + ']')))),
						function () {
						switch (fileStatus.$) {
							case 0:
								var fileSize = fileStatus.b;
								return $author$project$Ui$inFront(
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$alignRight,
												$author$project$Ui$Font$size(14),
												$author$project$Ui$paddingRight(8),
												$author$project$Ui$Shadow$font(
												{
													blur: 3,
													color: $author$project$MyUi$black,
													offset: _Utils_Tuple2(0, 0)
												})
											]),
										$author$project$Ui$text(
											$author$project$FileStatus$progressToString(fileSize))));
							case 1:
								return $author$project$Ui$noAttr;
							default:
								return $author$project$Ui$noAttr;
						}
					}()
					]),
				function () {
					switch (fileStatus.$) {
						case 0:
							return $author$project$Ui$none;
						case 1:
							var fileData = fileStatus.a;
							var _v6 = $author$project$FileStatus$contentTypeType(fileData.contentType);
							switch (_v6) {
								case 1:
									return $author$project$Ui$html(
										A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src(
													function () {
														var _v7 = fileData.metadata;
														if (!_v7.$) {
															if (!_v7.a.$) {
																var metadata = _v7.a.a;
																return $author$project$FileStatus$fileDataThumbnailUrl$(metadata.imageSize, fileData);
															} else {
																return $author$project$FileStatus$fileDataUrl(fileData);
															}
														} else {
															return $author$project$FileStatus$fileDataUrl(fileData);
														}
													}()),
													A2($elm$html$Html$Attributes$style, 'object-fit', 'cover'),
													$elm$html$Html$Attributes$width($author$project$SheepGame$fileUploadPreviewSize - 2),
													$elm$html$Html$Attributes$height($author$project$SheepGame$fileUploadPreviewSize - 2),
													A2($elm$html$Html$Attributes$style, 'display', 'flex'),
													A2($elm$html$Html$Attributes$style, 'align-self', 'center'),
													A2($elm$html$Html$Attributes$style, 'border-radius', '8px')
												]),
											_List_Nil));
								case 0:
									return $author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$width(
												$author$project$Ui$px(42)),
												$author$project$Ui$centerX,
												$author$project$Ui$centerY,
												$author$project$Ui$Font$color($author$project$MyUi$font3)
											]),
										$author$project$Ui$html($author$project$Icons$document));
								case 2:
									return $author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$centerX,
												$author$project$Ui$centerY,
												$author$project$Ui$Font$color($author$project$MyUi$font3),
												$author$project$Ui$move(
												{x: 6, y: 0, z: 0})
											]),
										$author$project$Ui$html(
											$author$project$Icons$camera(42)));
								case 3:
									return $author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$width(
												$author$project$Ui$px(42)),
												$author$project$Ui$centerX,
												$author$project$Ui$centerY,
												$author$project$Ui$Font$color($author$project$MyUi$font3)
											]),
										$author$project$Ui$html($author$project$Icons$volume));
								default:
									return $author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$Font$bold,
												$author$project$Ui$Font$letterSpacing(-1),
												$author$project$Ui$Font$lineHeight(1.1),
												$author$project$Ui$centerX,
												$author$project$Ui$centerY,
												$author$project$MyUi$prewrap,
												$author$project$Ui$Font$color($author$project$MyUi$font3)
											]),
										$author$project$Ui$text('0110\u000A0001'));
							}
						default:
							return $author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$centerX,
										$author$project$Ui$centerY,
										$author$project$Ui$width($author$project$Ui$shrink)
									]),
								$author$project$Ui$html($author$project$Icons$x));
					}
				}());
		},
		$author$project$NonemptyDict$toList(filesToUpload2));
};
var $author$project$SheepGame$fileUploadPreview = F5($author$project$SheepGame$fileUploadPreview$);
var $author$project$MessageInput$PressedOpenEmojiSelector = {$: 8};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn$ = function (event, decoder) {
	return A2(
		$elm$virtual_dom$VirtualDom$on,
		event,
		$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
};
var $elm$html$Html$Events$preventDefaultOn = F2($elm$html$Html$Events$preventDefaultOn$);
var $author$project$MessageInput$showEmojiSelectorButton = function (htmlIdPrefix) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$rounded(4),
				$author$project$Ui$width($author$project$Ui$shrink),
				$author$project$Ui$id(htmlIdPrefix + '_openEmojiSelector'),
				$author$project$Ui$pointer,
				$author$project$Ui$paddingXY$(6, 0),
				$author$project$Ui$height(
				$author$project$Ui$px(40)),
				$author$project$Ui$background($author$project$MyUi$buttonBackground),
				$author$project$Ui$contentCenterY,
				$author$project$Ui$centerY,
				$author$project$MyUi$hoverText('Add emoji'),
				$author$project$Ui$Events$stopPropagationOn$(
				'click',
				$elm$json$Json$Decode$succeed(
					_Utils_Tuple2($author$project$MessageInput$PressedOpenEmojiSelector, true))),
				$author$project$Ui$htmlAttribute(
				$elm$html$Html$Events$preventDefaultOn$(
					'touchend',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($author$project$MessageInput$PressedOpenEmojiSelector, true)))),
				$author$project$MyUi$blockTouchStartPropagation($author$project$MessageInput$IgnoreTouchStart)
			]),
		$author$project$Ui$html($author$project$Icons$smile));
};
var $author$project$MessageInput$IgnoredKeyPress = {$: 13};
var $author$project$MessageInput$OnPasteFiles = function (a) {
	return {$: 9, a: a};
};
var $author$project$MessageInput$PressedDropdownItem = function (a) {
	return {$: 5, a: a};
};
var $author$project$MessageInput$PressedSendMessage = function (a) {
	return {$: 2, a: a};
};
var $author$project$MessageInput$PressedTextInput = {$: 0};
var $author$project$MessageInput$TypedArrowInDropdown = function (a) {
	return {$: 3, a: a};
};
var $author$project$MessageInput$TypedArrowUpInEmptyInput = {$: 4};
var $author$project$MessageInput$TypedMessage = function (a) {
	return {$: 1, a: a};
};
var $author$project$MessageInput$TypedPageDown = {$: 11};
var $author$project$MessageInput$TypedPageUp = {$: 10};
var $author$project$MessageInput$TypedTabInCodeBlock = function (a) {
	return {$: 12, a: a};
};
var $author$project$RichText$bigEmojiFont = A2($elm$html$Html$Attributes$style, 'font-family', '\u0022myemoji\u0022, sans-serif');
var $elm_community$json_extra$Json$Decode$Extra$combine = A2(
	$elm$core$List$foldr,
	$elm$json$Json$Decode$map2($elm$core$List$cons),
	$elm$json$Json$Decode$succeed(_List_Nil));
var $elm_community$json_extra$Json$Decode$Extra$collection = function (decoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (length) {
			return $elm_community$json_extra$Json$Decode$Extra$combine(
				$elm$core$List$map$(
					function (index) {
						return A2(
							$elm$json$Json$Decode$field,
							$elm$core$String$fromInt(index),
							decoder);
					},
					$elm$core$List$range$(0, length - 1)));
		},
		A2($elm$json$Json$Decode$field, 'length', $elm$json$Json$Decode$int));
};
var $elm$file$File$decoder = _File_decoder;
var $lamdera$program_test$Effect$File$decoder = A2($elm$json$Json$Decode$map, $lamdera$program_test$Effect$File$RealFile, $elm$file$File$decoder);
var $lamdera$program_test$Effect$Browser$Dom$idToAttribute = A2($elm$core$Basics$composeR, $lamdera$program_test$Effect$Browser$Dom$idToString, $elm$html$Html$Attributes$id);
var $author$project$MessageInput$selectionInsideCodeBlock$ = function (text, maybeSelection) {
	if (!maybeSelection.$) {
		var selection = maybeSelection.a;
		return $author$project$MessageInput$isInsideCodeBlock$(selection.start, text) ? $elm$core$Maybe$Just(selection) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$MessageInput$selectionInsideCodeBlock = F2($author$project$MessageInput$selectionInsideCodeBlock$);
var $author$project$MessageInput$textarea$ = function (allowEnterKeyLinebreak, channelTextInputId, placeholder, charsLeft, text, richText, attachedFiles, localUser, loggedIn, users, channels) {
	var selection = function () {
		var _v8 = loggedIn.textInputFocus;
		if (!_v8.$) {
			var textInputFocus = _v8.a;
			return _Utils_eq(textInputFocus.htmlId, channelTextInputId) ? $elm$core$Maybe$Just(textInputFocus.selection) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	var codeBlockSelection = $author$project$MessageInput$selectionInsideCodeBlock$(text, selection);
	var keyDownNoDropdown = $elm$html$Html$Events$preventDefaultOn$(
		'keydown',
		A2(
			$elm$json$Json$Decode$andThen,
			function (_v5) {
				var shiftHeld = _v5.a;
				var key = _v5.b;
				if ((key === 'ArrowUp') && (text === '')) {
					return $elm$json$Json$Decode$succeed(
						_Utils_Tuple2($author$project$MessageInput$TypedArrowUpInEmptyInput, true));
				} else {
					if ((key === 'Enter') && ((!shiftHeld) && (!allowEnterKeyLinebreak))) {
						if (!codeBlockSelection.$) {
							return $elm$json$Json$Decode$succeed(
								_Utils_Tuple2($author$project$MessageInput$IgnoredKeyPress, false));
						} else {
							return $elm$json$Json$Decode$succeed(
								_Utils_Tuple2(
									$author$project$MessageInput$PressedSendMessage(
										{charsLeft: charsLeft}),
									true));
						}
					} else {
						if ((key === 'Tab') && (!shiftHeld)) {
							if (!codeBlockSelection.$) {
								var range = codeBlockSelection.a;
								return $elm$json$Json$Decode$succeed(
									_Utils_Tuple2(
										$author$project$MessageInput$TypedTabInCodeBlock(range),
										true));
							} else {
								return $elm$json$Json$Decode$succeed(
									_Utils_Tuple2($author$project$MessageInput$IgnoredKeyPress, false));
							}
						} else {
							if (key === 'PageUp') {
								return $elm$json$Json$Decode$succeed(
									_Utils_Tuple2($author$project$MessageInput$TypedPageUp, true));
							} else {
								if (key === 'PageDown') {
									return $elm$json$Json$Decode$succeed(
										_Utils_Tuple2($author$project$MessageInput$TypedPageDown, true));
								} else {
									return $elm$json$Json$Decode$fail('');
								}
							}
						}
					}
				}
			},
			A3(
				$elm$json$Json$Decode$map2,
				$elm$core$Tuple$pair,
				A2($elm$json$Json$Decode$field, 'shiftKey', $elm$json$Json$Decode$bool),
				A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string))));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'position', 'relative'),
				A2($elm$html$Html$Attributes$style, 'min-height', 'min-content'),
				A2($elm$html$Html$Attributes$style, 'width', '100%'),
				A2($elm$html$Html$Attributes$style, 'height', 'fit-content'),
				A2(
				$elm$html$Html$Attributes$style,
				'letter-spacing',
				((localUser.userAgent.browser === 2) && (!A2($elm$core$Basics$modBy, 2, loggedIn.typedTextCounter))) ? '-0.001px' : '0'),
				$author$project$RichText$bigEmojiFont,
				A2($elm$html$Html$Attributes$style, 'isolation', 'isolate')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$textarea,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('rich-text-input'),
						A2($elm$html$Html$Attributes$style, 'z-index', '1'),
						A2($elm$html$Html$Attributes$style, 'color', 'transparent'),
						A2($elm$html$Html$Attributes$style, '-webkit-text-fill-color', 'transparent'),
						A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
						A2($elm$html$Html$Attributes$style, 'font-size', 'inherit'),
						A2($elm$html$Html$Attributes$style, 'font-family', 'inherit'),
						A2($elm$html$Html$Attributes$style, 'line-height', 'inherit'),
						A2($elm$html$Html$Attributes$style, 'letter-spacing', 'inherit'),
						A2($elm$html$Html$Attributes$style, 'width', 'calc(100% - 18px)'),
						A2($elm$html$Html$Attributes$style, 'height', '100%'),
						$lamdera$program_test$Effect$Browser$Dom$idToAttribute(channelTextInputId),
						A2($elm$html$Html$Attributes$style, 'background-color', 'transparent'),
						A2($elm$html$Html$Attributes$style, 'border', '0'),
						A2($elm$html$Html$Attributes$style, 'resize', 'none'),
						A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
						A2($elm$html$Html$Attributes$style, 'caret-color', 'white'),
						A2($elm$html$Html$Attributes$style, 'padding', '8px'),
						A2($elm$html$Html$Attributes$style, 'outline', 'none'),
						$elm$html$Html$Events$onClick($author$project$MessageInput$PressedTextInput),
						$elm$html$Html$Events$preventDefaultOn$(
						'paste',
						A2(
							$elm$json$Json$Decode$andThen,
							function (list) {
								var _v0 = $mgold$elm_nonempty_list$List$Nonempty$fromList(list);
								if (!_v0.$) {
									var nonempty = _v0.a;
									return $elm$json$Json$Decode$succeed(
										_Utils_Tuple2(
											$author$project$MessageInput$OnPasteFiles(nonempty),
											true));
								} else {
									return $elm$json$Json$Decode$fail('');
								}
							},
							$elm$json$Json$Decode$at$(
								_List_fromArray(
									['clipboardData', 'files']),
								$elm_community$json_extra$Json$Decode$Extra$collection($lamdera$program_test$Effect$File$decoder)))),
						function () {
						var _v1 = loggedIn.textInputFocus;
						if (!_v1.$) {
							var textInputFocus2 = _v1.a;
							var _v2 = textInputFocus2.dropdown;
							if (!_v2.$) {
								var dropdownIndex = _v2.a.dropdownIndex;
								return $elm$html$Html$Events$preventDefaultOn$(
									'keydown',
									A2(
										$elm$json$Json$Decode$andThen,
										function (key) {
											switch (key) {
												case 'ArrowDown':
													return $elm$json$Json$Decode$succeed(
														_Utils_Tuple2(
															$author$project$MessageInput$TypedArrowInDropdown(dropdownIndex + 1),
															true));
												case 'ArrowUp':
													return $elm$json$Json$Decode$succeed(
														_Utils_Tuple2(
															$author$project$MessageInput$TypedArrowInDropdown(dropdownIndex - 1),
															true));
												case 'Enter':
													return $elm$json$Json$Decode$succeed(
														_Utils_Tuple2(
															$author$project$MessageInput$PressedDropdownItem(dropdownIndex),
															true));
												case 'PageUp':
													return $elm$json$Json$Decode$succeed(
														_Utils_Tuple2($author$project$MessageInput$TypedPageUp, true));
												case 'PageDown':
													return $elm$json$Json$Decode$succeed(
														_Utils_Tuple2($author$project$MessageInput$TypedPageDown, true));
												default:
													return $elm$json$Json$Decode$fail('');
											}
										},
										A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)));
							} else {
								return keyDownNoDropdown;
							}
						} else {
							return keyDownNoDropdown;
						}
					}(),
						$elm$html$Html$Events$onInput($author$project$MessageInput$TypedMessage),
						$elm$html$Html$Attributes$value(text)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				$author$project$MessageInput$textareaOverlayAttributes(text),
				function () {
					if (!richText.$) {
						var richText2 = richText.a;
						return _Utils_ap(
							$author$project$RichText$textInputView$(localUser.timezone, localUser.emojiData, users, channels, attachedFiles, localUser.customEmojis, localUser.stickers, selection, richText2),
							_List_fromArray(
								[
									$elm$html$Html$text('\u000A')
								]));
					} else {
						return _List_fromArray(
							[placeholder]);
					}
				}())
			]));
};
var $author$project$MessageInput$textarea = function (allowEnterKeyLinebreak) {
	return function (channelTextInputId) {
		return function (placeholder) {
			return function (charsLeft) {
				return function (text) {
					return function (richText) {
						return function (attachedFiles) {
							return function (localUser) {
								return function (loggedIn) {
									return function (users) {
										return function (channels) {
											return $author$project$MessageInput$textarea$(allowEnterKeyLinebreak, channelTextInputId, placeholder, charsLeft, text, richText, attachedFiles, localUser, loggedIn, users, channels);
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$SheepGame$answerInput$ = function (localUser, loggedIn, questionId, answer) {
	var users = $author$project$User$allUsers(localUser);
	var richText = $elm$core$Maybe$map$(
		A3($author$project$RichText$fromNonemptyString, localUser.timezone, users, $lamdera$containers$SeqDict$empty),
		$MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(answer.text));
	var htmlId = $author$project$SheepGame$inputId(
		$author$project$SheepGame$AnswerInput(questionId));
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(4)
			]),
		_List_fromArray(
			[
				function () {
				var _v0 = $author$project$NonemptyDict$fromSeqDict(answer.attachedFiles);
				if (!_v0.$) {
					var attachedFiles = _v0.a;
					return $author$project$Ui$row$(
						_List_fromArray(
							[
								$author$project$Ui$spacing(2),
								$author$project$Ui$width($author$project$Ui$shrink)
							]),
						$author$project$SheepGame$fileUploadPreview$(
							$author$project$SheepGame$PressedDeleteAnswerFile(questionId),
							$author$project$SheepGame$PressedViewAnswerFileInfo(questionId),
							$elm$core$Maybe$Just(
								$author$project$SheepGame$PressedToggleAnswerFileSpoiler(questionId)),
							richText,
							attachedFiles));
				} else {
					return $author$project$Ui$none;
				}
			}(),
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Ui$row$(
						_List_fromArray(
							[
								$author$project$Ui$width($author$project$Ui$shrink),
								$author$project$Ui$alignTop,
								$author$project$Ui$spacing(4)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$map,
								$author$project$SheepGame$TypedAnswer(questionId),
								$author$project$MessageInput$attachmentButton(
									$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId))),
								A2(
								$author$project$Ui$map,
								$author$project$SheepGame$TypedAnswer(questionId),
								$author$project$MessageInput$showEmojiSelectorButton(
									$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId)))
							])),
						$author$project$Ui$el$(
						_List_Nil,
						$author$project$Ui$el$(
							A2(
								$elm$core$List$cons,
								$author$project$Ui$heightMax(200),
								A2(
									$elm$core$List$cons,
									$author$project$Ui$id(
										$lamdera$program_test$Effect$Browser$Dom$idToString(
											$author$project$SheepGame$inputContainerId(
												$author$project$SheepGame$AnswerInput(questionId)))),
									$author$project$MessageInput$containerAttributes(true))),
							A2(
								$author$project$Ui$map,
								$author$project$SheepGame$TypedAnswer(questionId),
								$author$project$Ui$html(
									$author$project$MessageInput$textarea$(
										true,
										htmlId,
										$author$project$MessageInput$textPlaceholder('Answer here'),
										$author$project$SheepGame$maxAnswerLength - $elm$core$String$length(answer.text),
										answer.text,
										richText,
										answer.attachedFiles,
										localUser,
										loggedIn,
										users,
										$lamdera$containers$SeqDict$empty)))))
					]))
			]));
};
var $author$project$SheepGame$answerInput = F4($author$project$SheepGame$answerInput$);
var $author$project$SheepGame$answeredCountText = function (count) {
	return (count === 1) ? '1 player has answered so far' : ($elm$core$String$fromInt(count) + ' players have answered so far');
};
var $author$project$SheepGame$NoOp = {$: 27};
var $author$project$SheepGame$PressedCopyCode = function (a) {
	return {$: 25, a: a};
};
var $author$project$SheepGame$PressedImage = function (a) {
	return {$: 24, a: a};
};
var $author$project$Sticker$ResetAndLoopAFewTimes = 1;
var $author$project$RichText$ShowLargeContent = function (a) {
	return {$: 0, a: a};
};
var $author$project$RichText$NoLargeContent = {$: 1};
var $author$project$RichText$OtherContent = function (a) {
	return {$: 0, a: a};
};
var $author$project$RichText$accentBarColor = 'rgb(80,120,200)';
var $author$project$RichText$codeBorderWidth = 1;
var $author$project$RichText$codePaddingX = 4;
var $author$project$RichText$asciiFontSize$ = function (containerWidth, dpi, text) {
	var rows = $elm$core$Basics$max$(
		1,
		$elm$core$List$length(
			A2($elm$core$String$indexes, '\u000A', text)));
	var roomInDevicePixels = $elm$core$Basics$floor(dpi * (containerWidth - (2 * ($author$project$RichText$codeBorderWidth + $author$project$RichText$codePaddingX))));
	var columns = $elm$core$Basics$max$(
		1,
		$elm$core$Maybe$withDefault$(
			1,
			$elm$core$List$maximum(
				$elm$core$List$map$(
					$elm$core$String$length,
					$elm$core$String$split$('\u000A', text)))));
	var scale = $elm$core$Basics$clamp$(
		1,
		$elm$core$Basics$round(2 * dpi),
		$elm$core$Basics$min$((400 / (18 * rows)) | 0, (roomInDevicePixels / (10 * columns)) | 0));
	return $elm$core$String$fromFloat((18 * scale) / dpi) + 'px';
};
var $author$project$RichText$asciiFontSize = F3($author$project$RichText$asciiFontSize$);
var $elm$html$Html$audio = _VirtualDom_node('audio');
var $elm$html$Html$Attributes$controls = $elm$html$Html$Attributes$boolProperty('controls');
var $author$project$RichText$audioView$ = function (maybeHtmlId, isSpoilered, containerWidth, fileData) {
	var width = $elm$core$Basics$min$(containerWidth, 600);
	var idAttribute = function () {
		if (!maybeHtmlId.$) {
			var htmlId = maybeHtmlId.a;
			return $elm$html$Html$Attributes$id(htmlId);
		} else {
			return $elm$html$Html$Attributes$class('');
		}
	}();
	return A2(
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$Attributes$style,
				'width',
				$elm$core$String$fromInt(width) + 'px'),
			isSpoilered ? _List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'background-color', $author$project$RichText$spoilerBackground)
				]) : _List_Nil),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$audio,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(
							$author$project$FileStatus$fileDataUrl(fileData)),
							$elm$html$Html$Attributes$controls(true),
							A2($elm$html$Html$Attributes$style, 'display', 'block'),
							A2(
							$elm$html$Html$Attributes$style,
							'width',
							$elm$core$String$fromInt(width) + 'px'),
							idAttribute
						]),
					isSpoilered ? _List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
							A2($elm$html$Html$Attributes$style, 'opacity', '0')
						]) : _List_Nil),
				_List_Nil)
			]));
};
var $author$project$RichText$audioView = F4($author$project$RichText$audioView$);
var $elm$html$Html$br = _VirtualDom_node('br');
var $author$project$RichText$bulletPointLeftPadding = 24;
var $author$project$MyUi$userLabelBackground = $author$project$Ui$rgb$(32, 50, 218);
var $author$project$MyUi$userLabelHtmlAttributes = _List_fromArray(
	[
		A2(
		$elm$html$Html$Attributes$style,
		'background-color',
		$author$project$MyUi$colorToStyle($author$project$MyUi$userLabelBackground)),
		A2($elm$html$Html$Attributes$style, 'padding', '1px 1px 0 1px'),
		A2(
		$elm$html$Html$Attributes$style,
		'color',
		$author$project$MyUi$colorToStyle($author$project$MyUi$userLabelFontColor)),
		A2($elm$html$Html$Attributes$style, 'border-radius', '2px'),
		A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
		A2($elm$html$Html$Attributes$style, 'display', 'inline-flex'),
		A2($elm$html$Html$Attributes$style, 'box-sizing', 'border-box'),
		A2($elm$html$Html$Attributes$style, 'max-width', '100%'),
		A2($elm$html$Html$Attributes$style, 'line-height', 'normal'),
		A2($elm$html$Html$Attributes$style, 'margin-top', '-1px')
	]);
var $author$project$MyUi$userLabelText = function (text) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'min-width', '0'),
				A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
				A2($elm$html$Html$Attributes$style, 'text-overflow', 'ellipsis')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(text)
			]));
};
var $author$project$RichText$channelMentionView$ = function (onPress, channel, maybeThread, channels) {
	var _v0 = $lamdera$containers$SeqDict$get$(
		_Utils_Tuple2(channel, maybeThread),
		channels);
	if (!_v0.$) {
		var name = _v0.a.name;
		return A2(
			$elm$html$Html$a,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Events$onClick(
					A2(
						onPress,
						channel,
						function () {
							if (!maybeThread.$) {
								var threadId = maybeThread.a;
								return $author$project$Id$ViewThread(threadId);
							} else {
								return $author$project$Id$NoThread;
							}
						}())),
				A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
					$author$project$MyUi$userLabelHtmlAttributes)),
			_List_fromArray(
				[
					$author$project$MyUi$userLabelText('#' + name)
				]));
	} else {
		return A2(
			$elm$html$Html$span,
			$author$project$MyUi$userLabelHtmlAttributes,
			_List_fromArray(
				[
					$author$project$MyUi$userLabelText('#<missing>')
				]));
	}
};
var $author$project$RichText$channelMentionView = F4($author$project$RichText$channelMentionView$);
var $author$project$RichText$codeBorder = 'rgb(49, 54, 67)';
var $author$project$Icons$copy = function (size) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$strokeWidth('1.5'),
				$elm$svg$Svg$Attributes$stroke('currentColor'),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromInt(size))
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$d('M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75')
					]),
				_List_Nil)
			]));
};
var $author$project$RichText$copyCodeButton$ = function (maybeHtmlId, onPress) {
	return A2(
		$elm$html$Html$button,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(onPress),
					$elm$html$Html$Attributes$title('Copy'),
					A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
					A2($elm$html$Html$Attributes$style, 'top', '2px'),
					A2($elm$html$Html$Attributes$style, 'right', '2px'),
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'padding', '2px'),
					A2($elm$html$Html$Attributes$style, 'border', 'none'),
					A2($elm$html$Html$Attributes$style, 'border-radius', '4px'),
					A2($elm$html$Html$Attributes$style, 'background-color', $author$project$RichText$codeBorder),
					A2(
					$elm$html$Html$Attributes$style,
					'color',
					$author$project$MyUi$colorToStyle($author$project$MyUi$font3)),
					A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
					A2($elm$html$Html$Attributes$style, 'user-select', 'none')
				]),
			function () {
				if (!maybeHtmlId.$) {
					var htmlId = maybeHtmlId.a;
					return _List_fromArray(
						[
							$lamdera$program_test$Effect$Browser$Dom$idToAttribute(htmlId)
						]);
				} else {
					return _List_Nil;
				}
			}()),
		_List_fromArray(
			[
				$author$project$Icons$copy(16)
			]));
};
var $author$project$RichText$copyCodeButton = F2($author$project$RichText$copyCodeButton$);
var $author$project$RichText$copyCodeButtonId$ = function (htmlIdPrefix, index) {
	return $lamdera$program_test$Effect$Browser$Dom$id(
		$lamdera$program_test$Effect$Browser$Dom$idToString(htmlIdPrefix) + ('_copyCode_' + $elm$core$String$fromInt(index)));
};
var $author$project$RichText$copyCodeButtonId = F2($author$project$RichText$copyCodeButtonId$);
var $author$project$CustomEmoji$copyableCharacters$ = function (emojiSize, customEmojiId) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('emoji-characters'),
				A2($elm$html$Html$Attributes$style, 'display', 'inline-block'),
				A2($elm$html$Html$Attributes$style, 'width', emojiSize),
				A2($elm$html$Html$Attributes$style, 'height', emojiSize),
				A2($elm$html$Html$Attributes$style, 'line-height', emojiSize),
				A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
				A2($elm$html$Html$Attributes$style, 'overflow', 'hidden')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$CustomEmoji$idToString(customEmojiId))
			]));
};
var $author$project$CustomEmoji$copyableCharacters = F2($author$project$CustomEmoji$copyableCharacters$);
var $author$project$CustomEmoji$imageOverCharacters$ = function (emojiSize, image) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'position', 'relative'),
				A2($elm$html$Html$Attributes$style, 'display', 'inline-block'),
				A2($elm$html$Html$Attributes$style, 'margin-right', '-' + emojiSize),
				A2($elm$html$Html$Attributes$style, 'pointer-events', 'none')
			]),
		_List_fromArray(
			[image]));
};
var $author$project$CustomEmoji$imageOverCharacters = F2($author$project$CustomEmoji$imageOverCharacters$);
var $author$project$CustomEmoji$copyableView$ = function (emojiSize, yOffset, customEmojiId, customEmojis2, animationMode) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'position', 'relative'),
				A2($elm$html$Html$Attributes$style, 'display', 'inline-block')
			]),
		_List_fromArray(
			[
				$author$project$CustomEmoji$imageOverCharacters$(
				emojiSize,
				$author$project$CustomEmoji$view$(emojiSize, yOffset, customEmojiId, customEmojis2, animationMode)),
				$author$project$CustomEmoji$copyableCharacters$(emojiSize, customEmojiId)
			]));
};
var $author$project$CustomEmoji$copyableView = F5($author$project$CustomEmoji$copyableView$);
var $author$project$CustomEmoji$tooltipArrow = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('custom-emoji-popup-arrow'),
			A2($elm$html$Html$Attributes$style, 'border-left', '8px solid transparent'),
			A2($elm$html$Html$Attributes$style, 'border-right', '8px solid transparent'),
			A2(
			$elm$html$Html$Attributes$style,
			'border-top',
			'8px solid ' + $author$project$MyUi$colorToStyle($author$project$MyUi$background1)),
			A2($elm$html$Html$Attributes$style, 'z-index', '21')
		]),
	_List_Nil);
var $author$project$CustomEmoji$tooltipView = function (customEmoji) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('emoji-popup custom-emoji-popup'),
				A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
				A2($elm$html$Html$Attributes$style, 'gap', '8px'),
				A2($elm$html$Html$Attributes$style, 'padding', '8px'),
				A2($elm$html$Html$Attributes$style, 'border-radius', '8px'),
				A2(
				$elm$html$Html$Attributes$style,
				'border',
				'1px solid ' + $author$project$MyUi$colorToStyle($author$project$MyUi$border1)),
				A2(
				$elm$html$Html$Attributes$style,
				'background-color',
				$author$project$MyUi$colorToStyle($author$project$MyUi$background1)),
				A2($elm$html$Html$Attributes$style, 'box-shadow', '0 2px 8px rgba(0,0,0,0.3)'),
				A2(
				$elm$html$Html$Attributes$style,
				'color',
				$author$project$MyUi$colorToStyle($author$project$MyUi$font1)),
				A2($elm$html$Html$Attributes$style, 'font-size', '14px'),
				A2($elm$html$Html$Attributes$style, 'font-weight', '700'),
				A2($elm$html$Html$Attributes$style, 'line-height', 'normal'),
				A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
				A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
				A2($elm$html$Html$Attributes$style, 'z-index', '20')
			]),
		_List_fromArray(
			[
				$author$project$CustomEmoji$viewHelper$('40px', '0', customEmoji, 2),
				$elm$html$Html$text(
				':' + ($author$project$CustomEmoji$emojiNameToString(customEmoji.name) + ':'))
			]));
};
var $author$project$CustomEmoji$copyableViewWithTooltip$ = function (emojiSize, yOffset, customEmojiId, customEmojis2, animationMode) {
	var _v0 = $lamdera$containers$SeqDict$get$(customEmojiId, customEmojis2);
	if (!_v0.$) {
		var customEmoji = _v0.a;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('emoji-popup-container'),
					A2($elm$html$Html$Attributes$style, 'position', 'relative'),
					A2($elm$html$Html$Attributes$style, 'display', 'inline-block')
				]),
			_List_fromArray(
				[
					$author$project$CustomEmoji$imageOverCharacters$(
					emojiSize,
					$author$project$CustomEmoji$viewHelper$(emojiSize, yOffset, customEmoji, animationMode)),
					$author$project$CustomEmoji$copyableCharacters$(emojiSize, customEmojiId),
					$author$project$CustomEmoji$tooltipView(customEmoji),
					$author$project$CustomEmoji$tooltipArrow
				]));
	} else {
		return $author$project$CustomEmoji$copyableView$(emojiSize, yOffset, customEmojiId, customEmojis2, animationMode);
	}
};
var $author$project$CustomEmoji$copyableViewWithTooltip = F5($author$project$CustomEmoji$copyableViewWithTooltip$);
var $author$project$RichText$embedContainerLeftBorderWidth = 4;
var $author$project$RichText$embedContainerMaxWidth = 432;
var $author$project$RichText$embedContainerPaddingX = 12;
var $author$project$RichText$embedContainer = function (contents) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2(
				$elm$html$Html$Attributes$style,
				'max-width',
				$elm$core$String$fromInt($author$project$RichText$embedContainerMaxWidth) + 'px'),
				A2($elm$html$Html$Attributes$style, 'margin-top', '4px')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$Attributes$style,
						'width',
						$elm$core$String$fromInt($author$project$RichText$embedContainerLeftBorderWidth) + 'px'),
						A2($elm$html$Html$Attributes$style, 'flex-shrink', '0'),
						A2($elm$html$Html$Attributes$style, 'background-color', $author$project$RichText$accentBarColor),
						A2($elm$html$Html$Attributes$style, 'border-radius', '4px 0 0 4px')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$Attributes$style,
						'background-color',
						$author$project$MyUi$colorToStyle($author$project$MyUi$background2)),
						A2(
						$elm$html$Html$Attributes$style,
						'padding',
						'8px ' + ($elm$core$String$fromInt($author$project$RichText$embedContainerPaddingX) + 'px')),
						A2($elm$html$Html$Attributes$style, 'min-width', '0'),
						A2($elm$html$Html$Attributes$style, 'flex', '1'),
						A2($elm$html$Html$Attributes$style, 'border-radius', '0 4px 4px 0')
					]),
				contents)
			]));
};
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		_VirtualDom_attribute,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$html$Html$Attributes$rel = _VirtualDom_attribute('rel');
var $elm$html$Html$Attributes$target = _VirtualDom_attribute('target');
var $author$project$MyUi$textLinkColorOnDarkBackground = $author$project$Ui$rgb$(176, 193, 255);
var $author$project$RichText$buttonOrA$ = function (onLinkPress, domainWhitelist, url, attributes, content) {
	return $lamdera$containers$SeqSet$member$(
		$author$project$RichText$urlToDomain(url),
		domainWhitelist) ? A2(
		$elm$html$Html$a,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$href(
				$elm$url$Url$toString(url)),
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$target('_blank'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$rel('noreferrer'),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$Attributes$attribute,
							'data-link-url',
							$elm$url$Url$toString(url)),
						attributes)))),
		content) : A2(
		$elm$html$Html$span,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Events$onClick(
				onLinkPress(url)),
			A2(
				$elm$core$List$cons,
				A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$Attributes$style,
						'color',
						$author$project$MyUi$colorToStyle($author$project$MyUi$textLinkColorOnDarkBackground)),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$Attributes$attribute,
							'data-link-url',
							$elm$url$Url$toString(url)),
						attributes)))),
		content);
};
var $author$project$RichText$buttonOrA = F5($author$project$RichText$buttonOrA$);
var $author$project$RichText$favicon = function (url) {
	return $author$project$FileStatus$domain + ('/file/favicon/' + url.host);
};
var $author$project$RichText$urlAddPrefixed$ = function (prefix, maybeSegment, starter) {
	if (maybeSegment.$ === 1) {
		return starter;
	} else {
		var segment = maybeSegment.a;
		return _Utils_ap(
			starter,
			_Utils_ap(prefix, segment));
	}
};
var $author$project$RichText$urlAddPrefixed = F3($author$project$RichText$urlAddPrefixed$);
var $author$project$RichText$smallHyperlink$ = function (onPressUrl, domainWhitelist, url) {
	var path = $author$project$RichText$urlAddPrefixed$(
		'#',
		url.fragment,
		$author$project$RichText$urlAddPrefixed$('?', url.query, url.path));
	return $author$project$RichText$buttonOrA$(
		onPressUrl,
		domainWhitelist,
		url,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
				A2($elm$html$Html$Attributes$style, 'gap', '6px'),
				A2($elm$html$Html$Attributes$style, 'margin-top', '4px'),
				A2($elm$html$Html$Attributes$style, 'text-decoration', 'none')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'width', '16px'),
						A2($elm$html$Html$Attributes$style, 'height', '16px'),
						A2($elm$html$Html$Attributes$style, 'border-radius', '2px'),
						$elm$html$Html$Attributes$src(
						$author$project$RichText$favicon(url)),
						$author$project$MyUi$lazyLoading
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'font-size', '14px'),
						A2(
						$elm$html$Html$Attributes$style,
						'color',
						$author$project$MyUi$colorToStyle($author$project$MyUi$font2)),
						A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
						A2($elm$html$Html$Attributes$style, 'text-overflow', 'ellipsis'),
						A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
						A2($elm$html$Html$Attributes$style, 'min-width', '0')
					]),
				_List_fromArray(
					[
						(!url.protocol) ? A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$Attributes$style,
								'color',
								$author$project$MyUi$colorToStyle($author$project$MyUi$font3))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('http://')
							])) : $elm$html$Html$text(''),
						$elm$html$Html$text(url.host),
						(path === '/') ? $elm$html$Html$text('') : A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$Attributes$style,
								'color',
								$author$project$MyUi$colorToStyle($author$project$MyUi$font3))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(path)
							]))
					]))
			]));
};
var $author$project$RichText$smallHyperlink = F3($author$project$RichText$smallHyperlink$);
var $author$project$RichText$embedLoadingView$ = function (onPressLink, domainWhitelist, url) {
	return $author$project$RichText$embedContainer(
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'width', '60%'),
						A2($elm$html$Html$Attributes$style, 'height', '14px'),
						A2(
						$elm$html$Html$Attributes$style,
						'background-color',
						$author$project$MyUi$colorToStyle($author$project$MyUi$background3)),
						A2($elm$html$Html$Attributes$style, 'border-radius', '4px'),
						A2($elm$html$Html$Attributes$style, 'margin-bottom', '8px')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'width', '90%'),
						A2($elm$html$Html$Attributes$style, 'height', '12px'),
						A2(
						$elm$html$Html$Attributes$style,
						'background-color',
						$author$project$MyUi$colorToStyle($author$project$MyUi$background3)),
						A2($elm$html$Html$Attributes$style, 'border-radius', '4px'),
						A2($elm$html$Html$Attributes$style, 'margin-bottom', '6px')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'width', '75%'),
						A2($elm$html$Html$Attributes$style, 'height', '12px'),
						A2(
						$elm$html$Html$Attributes$style,
						'background-color',
						$author$project$MyUi$colorToStyle($author$project$MyUi$background3)),
						A2($elm$html$Html$Attributes$style, 'border-radius', '4px')
					]),
				_List_Nil),
				$author$project$RichText$smallHyperlink$(onPressLink, domainWhitelist, url)
			]));
};
var $author$project$RichText$embedLoadingView = F3($author$project$RichText$embedLoadingView$);
var $author$project$RichText$PressedEmbedImage = function (a) {
	return {$: 1, a: a};
};
var $author$project$RichText$actualImageSize$ = function (maxImageHeight, containerWidth2, imageSize) {
	var w = $author$project$Coord$xRaw(imageSize);
	var w2 = $elm$core$Basics$min$(w, containerWidth2);
	var h = $author$project$Coord$yRaw(imageSize);
	var aspect = h / w;
	var h2 = $elm$core$Basics$min$(maxImageHeight / 2, w2 * aspect);
	return _Utils_Tuple2(h2 / aspect, h2);
};
var $author$project$RichText$actualImageSize = F3($author$project$RichText$actualImageSize$);
var $author$project$Drawing$anchorHighlightHtmlClass = $elm$html$Html$Attributes$class('drawing-anchor-select');
var $author$project$Drawing$floatFieldWithDefault = function (fieldName) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, fieldName, $elm$json$Json$Decode$float),
				$elm$json$Json$Decode$succeed(0)
			]));
};
var $author$project$Point2d$xy$ = function (_v0, _v1) {
	var x = _v0;
	var y = _v1;
	return {x: x, y: y};
};
var $author$project$Point2d$xy = F2($author$project$Point2d$xy$);
var $author$project$Drawing$decodeWithTargetScreenPosition = A5(
	$elm$json$Json$Decode$map4,
	F4(
		function (clientX, clientY, offsetX, offsetY) {
			return $author$project$Point2d$xy$(
				$author$project$CssPixels$cssPixels(clientX - offsetX),
				$author$project$CssPixels$cssPixels(clientY - offsetY));
		}),
	$author$project$Drawing$floatFieldWithDefault('clientX'),
	$author$project$Drawing$floatFieldWithDefault('clientY'),
	$author$project$Drawing$floatFieldWithDefault('offsetX'),
	$author$project$Drawing$floatFieldWithDefault('offsetY'));
var $author$project$RichText$embedImageMaxHeight = 500;
var $author$project$RichText$formatPosix$ = function (timezone, time) {
	return $author$project$MyUi$datestamp$(timezone, time);
};
var $author$project$RichText$formatPosix = F2($author$project$RichText$formatPosix$);
var $author$project$MyUi$imagePlaceholderStyle = A2(
	$elm$html$Html$Attributes$style,
	'background-color',
	$author$project$MyUi$colorToStyle($author$project$MyUi$background3));
var $author$project$RichText$embedView$ = function (timezone, onPressLink, maybeOnPressImage, containerWidth, domainWhitelist, playAnimation, isSelectingAnchor, embedIndex, htmlId, drawingOverlays, url, embed) {
	return $author$project$RichText$embedContainer(
		$elm$core$List$filterMap$(
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					function () {
					var _v0 = embed.title;
					if (!_v0.$) {
						var title = _v0.a;
						return $elm$core$Maybe$Just(
							$author$project$RichText$buttonOrA$(
								onPressLink,
								domainWhitelist,
								url,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'font-size', '14px'),
										A2($elm$html$Html$Attributes$style, 'font-weight', '600'),
										A2($elm$html$Html$Attributes$style, 'color', 'rgb(100,160,255)'),
										A2($elm$html$Html$Attributes$style, 'display', 'block'),
										A2($elm$html$Html$Attributes$style, 'margin-bottom', '4px'),
										A2($elm$html$Html$Attributes$style, 'text-decoration', 'none'),
										A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
										A2($elm$html$Html$Attributes$style, 'text-overflow', 'ellipsis'),
										A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(title)
									])));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}(),
					function () {
					var _v1 = embed.description;
					if (!_v1.$) {
						var content = _v1.a;
						return $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'font-size', '13px'),
										A2(
										$elm$html$Html$Attributes$style,
										'color',
										$author$project$MyUi$colorToStyle($author$project$MyUi$font2)),
										A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
										A2($elm$html$Html$Attributes$style, 'display', '-webkit-box'),
										A2($elm$html$Html$Attributes$style, '-webkit-line-clamp', '3'),
										A2($elm$html$Html$Attributes$style, '-webkit-box-orient', 'vertical'),
										A2($elm$html$Html$Attributes$style, 'white-space', 'pre-wrap')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$left$(300, content))
									])));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}(),
					function () {
					var _v2 = embed.image;
					if (!_v2.$) {
						var imageData = _v2.a;
						var isAnimatedImage = function () {
							var _v5 = imageData.format;
							if (!_v5.$) {
								var format = _v5.a;
								if (format === 2) {
									return true;
								} else {
									return false;
								}
							} else {
								return false;
							}
						}();
						var insideWidth = ($elm$core$Basics$min$($author$project$RichText$embedContainerMaxWidth, containerWidth) - $author$project$RichText$embedContainerLeftBorderWidth) - ($author$project$RichText$embedContainerPaddingX * 2);
						var _v3 = $author$project$RichText$actualImageSize$($author$project$RichText$embedImageMaxHeight, insideWidth, imageData.imageSize);
						var width = _v3.a;
						var height = _v3.b;
						var heightText = $elm$core$String$fromFloat(height) + 'px';
						var widthText = $elm$core$String$fromFloat(width) + 'px';
						var image = isAnimatedImage ? $author$project$Sticker$animatedImageView$(false, widthText, heightText, $elm$core$Maybe$Nothing, imageData.url, playAnimation) : A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(imageData.url),
									A2($elm$html$Html$Attributes$style, 'width', widthText),
									A2($elm$html$Html$Attributes$style, 'height', heightText),
									A2($elm$html$Html$Attributes$style, 'border-radius', '4px'),
									$author$project$MyUi$lazyLoading,
									A2($elm$html$Html$Attributes$style, 'display', 'block'),
									$author$project$MyUi$imagePlaceholderStyle,
									A2($elm$html$Html$Attributes$attribute, 'data-image-url', imageData.url)
								]),
							_List_Nil);
						return $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$div,
								_Utils_ap(
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'position', 'relative'),
											A2($elm$html$Html$Attributes$style, 'width', widthText),
											$author$project$RichText$htmlAttrIf$(
											!isAnimatedImage,
											A2($elm$html$Html$Attributes$style, 'margin-top', '8px'))
										]),
									function () {
										if (!maybeOnPressImage.$) {
											var onPressImage = maybeOnPressImage.a;
											return _List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
													$elm$html$Html$Attributes$id(htmlId),
													$elm$html$Html$Events$on$(
													'click',
													A2(
														$elm$json$Json$Decode$map,
														function (position) {
															return onPressImage(
																{
																	displayWidth: width,
																	fileUrl: imageData.url,
																	imageId: $author$project$RichText$PressedEmbedImage(embedIndex),
																	imageSize: imageData.imageSize,
																	position: position
																});
														},
														$author$project$Drawing$decodeWithTargetScreenPosition)),
													$author$project$RichText$htmlAttrIf$(isSelectingAnchor, $author$project$Drawing$anchorHighlightHtmlClass)
												]);
										} else {
											return _List_Nil;
										}
									}()),
								_Utils_ap(
									drawingOverlays(
										width / $elm$core$Basics$max$(
											1,
											$author$project$Coord$xRaw(imageData.imageSize))),
									_List_fromArray(
										[image]))));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}(),
					function () {
					var _v7 = embed.createdAt;
					if (!_v7.$) {
						var createdAt = _v7.a;
						return $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$style, 'font-size', '11px'),
										A2(
										$elm$html$Html$Attributes$style,
										'color',
										$author$project$MyUi$colorToStyle($author$project$MyUi$font3)),
										A2($elm$html$Html$Attributes$style, 'margin-top', '6px')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$RichText$formatPosix$(timezone, createdAt))
									])));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}(),
					$elm$core$Maybe$Just(
					$author$project$RichText$smallHyperlink$(onPressLink, domainWhitelist, url))
				])));
};
var $author$project$RichText$embedView = function (timezone) {
	return function (onPressLink) {
		return function (maybeOnPressImage) {
			return function (containerWidth) {
				return function (domainWhitelist) {
					return function (playAnimation) {
						return function (isSelectingAnchor) {
							return function (embedIndex) {
								return function (htmlId) {
									return function (drawingOverlays) {
										return function (url) {
											return function (embed) {
												return $author$project$RichText$embedView$(timezone, onPressLink, maybeOnPressImage, containerWidth, domainWhitelist, playAnimation, isSelectingAnchor, embedIndex, htmlId, drawingOverlays, url, embed);
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$html$Html$Attributes$download = function (fileName) {
	return A2(_VirtualDom_attribute, 'download', fileName);
};
var $author$project$Icons$download = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor'),
			$elm$svg$Svg$Attributes$width('18')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3')
				]),
			_List_Nil)
		]));
var $author$project$FileStatus$sizeToString = function (_int) {
	return (_int < 200) ? ($elm$core$String$fromInt(_int) + ' bytes') : ((_Utils_cmp(_int, 1024 * 1024) < 0) ? ($author$project$StringExtra$removeTrailing0s$(1, _int / 1024) + 'kb') : ((_Utils_cmp(_int, (1024 * 1024) * 1024) < 0) ? ($author$project$StringExtra$removeTrailing0s$(1, _int / (1024 * 1024)) + 'mb') : ($author$project$StringExtra$removeTrailing0s$(1, _int / ((1024 * 1024) * 1024)) + 'gb')));
};
var $author$project$RichText$fileDownloadView$ = function (maybeHtmlId, isSpoilered, fileData) {
	var fileUrl = $author$project$FileStatus$fileDataUrl(fileData);
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				function () {
				if (!maybeHtmlId.$) {
					var htmlId = maybeHtmlId.a;
					return $elm$html$Html$Attributes$id(htmlId);
				} else {
					return $elm$html$Html$Attributes$class('');
				}
			}(),
				A2($elm$html$Html$Attributes$style, 'max-width', '284px'),
				A2(
				$elm$html$Html$Attributes$style,
				'background-color',
				isSpoilered ? $author$project$RichText$spoilerBackground : $author$project$MyUi$colorToStyle($author$project$MyUi$background1)),
				A2($elm$html$Html$Attributes$style, 'border-radius', '4px'),
				A2(
				$elm$html$Html$Attributes$style,
				'border',
				'solid 1px ' + $author$project$MyUi$colorToStyle($author$project$MyUi$border1)),
				A2($elm$html$Html$Attributes$style, 'display', 'block'),
				isSpoilered ? A2($elm$html$Html$Attributes$style, 'color', 'transparent') : $elm$html$Html$Attributes$href(fileUrl),
				$elm$html$Html$Attributes$download(
				$author$project$FileName$toString(fileData.fileName)),
				$elm$html$Html$Attributes$target('_blank'),
				$elm$html$Html$Attributes$rel('noreferrer'),
				A2($elm$html$Html$Attributes$style, 'font-size', '14px'),
				A2($elm$html$Html$Attributes$style, 'padding', '4px 8px 4px 8px')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$FileName$toString(fileData.fileName)),
				$elm$html$Html$text(
				'\u000A' + ($author$project$FileStatus$sizeToString(fileData.fileSize) + ' ')),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'display', 'inline-block'),
						A2($elm$html$Html$Attributes$style, 'transform', 'translateY(4px)'),
						$author$project$RichText$htmlAttrIf$(
						isSpoilered,
						A2($elm$html$Html$Attributes$style, 'opacity', '0'))
					]),
				_List_fromArray(
					[$author$project$Icons$download]))
			]));
};
var $author$project$RichText$fileDownloadView = F3($author$project$RichText$fileDownloadView$);
var $author$project$RichText$MediaRow = function (a) {
	return {$: 1, a: a};
};
var $author$project$RichText$addOtherContent$ = function (otherContent, groups) {
	var _v0 = $mgold$elm_nonempty_list$List$Nonempty$fromList(
		$elm$core$List$reverse(otherContent));
	if (!_v0.$) {
		var nonempty = _v0.a;
		return A2(
			$elm$core$List$cons,
			$author$project$RichText$OtherContent(nonempty),
			groups);
	} else {
		return groups;
	}
};
var $author$project$RichText$addOtherContent = F2($author$project$RichText$addOtherContent$);
var $mgold$elm_nonempty_list$List$Nonempty$all$ = function (f, _v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return f(x) && $elm$core$List$all$(f, xs);
};
var $mgold$elm_nonempty_list$List$Nonempty$all = F2($mgold$elm_nonempty_list$List$Nonempty$all$);
var $author$project$RichText$isMedia$ = function (attachedFiles, richText) {
	switch (richText.$) {
		case 14:
			var fileId = richText.a;
			var _v1 = $lamdera$containers$SeqDict$get$(fileId, attachedFiles);
			if (!_v1.$) {
				var fileData = _v1.a;
				var _v2 = fileData.metadata;
				if (!_v2.$) {
					if (!_v2.a.$) {
						return true;
					} else {
						return true;
					}
				} else {
					var _v3 = $author$project$FileStatus$contentTypeType(fileData.contentType);
					switch (_v3) {
						case 2:
							return true;
						case 0:
							return false;
						case 1:
							return false;
						case 3:
							return false;
						case 4:
							return false;
						default:
							return false;
					}
				}
			} else {
				return false;
			}
		case 7:
			var nonempty = richText.a;
			return $mgold$elm_nonempty_list$List$Nonempty$all$(
				$author$project$RichText$isMedia(attachedFiles),
				nonempty);
		case 0:
			return false;
		case 1:
			return false;
		case 2:
			return false;
		case 3:
			return false;
		case 4:
			return false;
		case 5:
			return false;
		case 6:
			return false;
		case 8:
			return false;
		case 9:
			return false;
		case 10:
			return false;
		case 11:
			return false;
		case 12:
			return false;
		case 13:
			return false;
		case 15:
			return false;
		case 16:
			return false;
		case 17:
			return false;
		case 18:
			return false;
		default:
			return false;
	}
};
var $author$project$RichText$isMedia = F2($author$project$RichText$isMedia$);
var $author$project$RichText$takeMediaRow$ = function (attachedFiles, media, nodes) {
	takeMediaRow:
	while (true) {
		if (nodes.b) {
			if ((nodes.a.$ === 2) && nodes.b.b) {
				var _v1 = nodes.a;
				var _char = _v1.a;
				var text = _v1.b;
				var _v2 = nodes.b;
				var next = _v2.a;
				var rest = _v2.b;
				if (A2(
					$elm$core$String$all,
					function (a) {
						return a === ' ';
					},
					A2($elm$core$String$cons, _char, text)) && $author$project$RichText$isMedia$(attachedFiles, next)) {
					var $temp$media = A2($elm$core$List$cons, next, media),
						$temp$nodes = rest;
					media = $temp$media;
					nodes = $temp$nodes;
					continue takeMediaRow;
				} else {
					return _Utils_Tuple2(media, nodes);
				}
			} else {
				var next = nodes.a;
				var rest = nodes.b;
				if ($author$project$RichText$isMedia$(attachedFiles, next)) {
					var $temp$media = A2($elm$core$List$cons, next, media),
						$temp$nodes = rest;
					media = $temp$media;
					nodes = $temp$nodes;
					continue takeMediaRow;
				} else {
					return _Utils_Tuple2(media, nodes);
				}
			}
		} else {
			return _Utils_Tuple2(media, nodes);
		}
	}
};
var $author$project$RichText$takeMediaRow = F3($author$project$RichText$takeMediaRow$);
var $author$project$RichText$groupMediaRows$ = function (attachedFiles, otherContent, groups, nodes) {
	groupMediaRows:
	while (true) {
		if (nodes.b) {
			var node = nodes.a;
			var rest = nodes.b;
			if ($author$project$RichText$isMedia$(attachedFiles, node)) {
				var _v1 = $author$project$RichText$takeMediaRow$(
					attachedFiles,
					_List_fromArray(
						[node]),
					rest);
				if (_v1.a.b && (!_v1.a.b.b)) {
					var _v2 = _v1.a;
					var $temp$otherContent = A2($elm$core$List$cons, node, otherContent),
						$temp$nodes = rest;
					otherContent = $temp$otherContent;
					nodes = $temp$nodes;
					continue groupMediaRows;
				} else {
					var media = _v1.a;
					var rest2 = _v1.b;
					var $temp$otherContent = _List_Nil,
						$temp$groups = function () {
						var _v3 = $mgold$elm_nonempty_list$List$Nonempty$fromList(
							$elm$core$List$reverse(media));
						if (!_v3.$) {
							var mediaNonempty = _v3.a;
							return A2(
								$elm$core$List$cons,
								$author$project$RichText$MediaRow(mediaNonempty),
								$author$project$RichText$addOtherContent$(otherContent, groups));
						} else {
							return $author$project$RichText$addOtherContent$(otherContent, groups);
						}
					}(),
						$temp$nodes = rest2;
					otherContent = $temp$otherContent;
					groups = $temp$groups;
					nodes = $temp$nodes;
					continue groupMediaRows;
				}
			} else {
				var $temp$otherContent = A2($elm$core$List$cons, node, otherContent),
					$temp$nodes = rest;
				otherContent = $temp$otherContent;
				nodes = $temp$nodes;
				continue groupMediaRows;
			}
		} else {
			return $elm$core$List$reverse(
				$author$project$RichText$addOtherContent$(otherContent, groups));
		}
	}
};
var $author$project$RichText$groupMediaRows = F4($author$project$RichText$groupMediaRows$);
var $author$project$RichText$hyperlinkColor = 'rgb(66,133,244)';
var $elm$svg$Svg$Attributes$points = _VirtualDom_attribute('points');
var $elm$svg$Svg$polyline = $elm$svg$Svg$trustedNode('polyline');
var $author$project$SafeFloat$toString = function (_v0) {
	var a = _v0;
	return $elm$core$String$fromFloat(a);
};
var $author$project$Drawing$strokeSvg$ = function (scale, color, points) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$width('1'),
				$elm$svg$Svg$Attributes$height('1'),
				$elm$svg$Svg$Attributes$style('position:absolute;left:0;top:0;overflow:visible;pointer-events:none;display:block')
			]),
		_List_fromArray(
			[
				function () {
				var _v0 = $mgold$elm_nonempty_list$List$Nonempty$toList(points);
				if (_v0.b && (!_v0.b.b)) {
					var _v1 = _v0.a;
					var x = _v1.a;
					var y = _v1.b;
					return A2(
						$elm$svg$Svg$circle,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$r('1.5'),
								$elm$svg$Svg$Attributes$cx(
								$author$project$SafeFloat$toString(x)),
								$elm$svg$Svg$Attributes$cy(
								$author$project$SafeFloat$toString(y)),
								$elm$svg$Svg$Attributes$transform(
								'scale(' + ($elm$core$String$fromFloat(scale) + ')')),
								A2($elm$html$Html$Attributes$attribute, 'vector-effect', 'non-scaling-stroke'),
								$elm$svg$Svg$Attributes$fill(color),
								$elm$svg$Svg$Attributes$stroke(color)
							]),
						_List_Nil);
				} else {
					var points2 = _v0;
					return A2(
						$elm$svg$Svg$polyline,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$points(
								$elm$core$String$join$(
									' ',
									$elm$core$List$map$(
										function (_v2) {
											var x = _v2.a;
											var y = _v2.b;
											return $author$project$SafeFloat$toString(x) + (',' + $author$project$SafeFloat$toString(y));
										},
										points2))),
								$elm$svg$Svg$Attributes$transform(
								'scale(' + ($elm$core$String$fromFloat(scale) + ')')),
								A2($elm$html$Html$Attributes$attribute, 'vector-effect', 'non-scaling-stroke'),
								$elm$svg$Svg$Attributes$fill('none'),
								$elm$svg$Svg$Attributes$stroke(color),
								$elm$svg$Svg$Attributes$strokeWidth('3'),
								$elm$svg$Svg$Attributes$strokeLinecap('round'),
								$elm$svg$Svg$Attributes$strokeLinejoin('round')
							]),
						_List_Nil);
				}
			}()
			]));
};
var $author$project$Drawing$strokeSvg = F3($author$project$Drawing$strokeSvg$);
var $author$project$Drawing$strokesFor = function (drawing) {
	return _Utils_ap(
		$elm$core$List$map$(
			function (finished) {
				return _Utils_Tuple2(finished.createdBy, finished.points);
			},
			drawing.finished),
		$elm$core$List$map$(
			function (_v0) {
				var createdBy = _v0.a;
				var stroke = _v0.b;
				return _Utils_Tuple2(createdBy, stroke.points);
			},
			$lamdera$containers$SeqDict$toList(drawing.inProgress)));
};
var $author$project$UserColor$toStyle = function (userColor) {
	var parts = $author$project$UserColor$toParts(userColor);
	return 'hsl(' + ($elm$core$String$fromFloat((360 * parts.hue) / $author$project$UserColor$hueCount) + (' ' + ($elm$core$String$fromFloat((100 * parts.saturation) / ($author$project$UserColor$saturationCount - 1)) + (' ' + ($elm$core$String$fromFloat((100 * parts.lightness) / ($author$project$UserColor$lightnessCount - 1)) + ')')))));
};
var $author$project$Drawing$imageAttachmentOverlays$ = function (scale, getColor, drawing) {
	return $elm$core$List$map$(
		function (_v0) {
			var createdBy = _v0.a;
			var points = _v0.b;
			return $author$project$Drawing$strokeSvg$(
				scale,
				$author$project$UserColor$toStyle(
					getColor(createdBy)),
				points);
		},
		$author$project$Drawing$strokesFor(drawing));
};
var $author$project$Drawing$imageAttachmentOverlays = F3($author$project$Drawing$imageAttachmentOverlays$);
var $author$project$RichText$PressedAttachedFileImage = function (a) {
	return {$: 0, a: a};
};
var $author$project$RichText$imageView$ = function (maybePressedSpoiler, maybeOnPressImage, containerWidth2, config, imageSize, fileId, fileData, state) {
	var _v0 = $author$project$RichText$actualImageSize$($author$project$FileStatus$imageMaxHeight, containerWidth2, imageSize);
	var width = _v0.a;
	var height = _v0.b;
	if (state.spoiler) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$Attributes$style,
					'width',
					$elm$core$String$fromInt(
						$elm$core$Basics$round(width)) + 'px'),
					A2(
					$elm$html$Html$Attributes$style,
					'height',
					$elm$core$String$fromInt(
						$elm$core$Basics$round(height)) + 'px'),
					A2($elm$html$Html$Attributes$style, 'display', 'block'),
					A2($elm$html$Html$Attributes$style, 'background-color', $author$project$RichText$spoilerBackground)
				]),
			_List_Nil);
	} else {
		var thumbnailUrl = $author$project$FileStatus$fileDataThumbnailUrl$(imageSize, fileData);
		var fileUrl = $author$project$FileStatus$fileDataUrl(fileData);
		var imageElement = function (extraAttributes) {
			return A2(
				$elm$html$Html$img,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$src(thumbnailUrl),
					A2(
						$elm$core$List$cons,
						A2($elm$html$Html$Attributes$style, 'display', 'block'),
						A2(
							$elm$core$List$cons,
							$author$project$MyUi$lazyLoading,
							A2(
								$elm$core$List$cons,
								$author$project$MyUi$imagePlaceholderStyle,
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$width(
										$elm$core$Basics$round(width)),
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$height(
											$elm$core$Basics$round(height)),
										A2(
											$elm$core$List$cons,
											A2($elm$html$Html$Attributes$attribute, 'data-image-url', fileUrl),
											extraAttributes))))))),
				_List_Nil);
		};
		if (!maybeOnPressImage.$) {
			var onPressImage = maybeOnPressImage.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'position', 'relative')
							]),
						function () {
							var _v2 = $lamdera$containers$SeqDict$get$(fileId, config.drawings);
							if (!_v2.$) {
								var drawing = _v2.a;
								return $author$project$Drawing$imageAttachmentOverlays$(
									width / $elm$core$Basics$max$(
										1,
										$author$project$Coord$xRaw(imageSize)),
									config.drawingUserColor,
									drawing);
							} else {
								return _List_Nil;
							}
						}()),
						imageElement(
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
								$elm$html$Html$Attributes$id(
								function () {
									if (!maybePressedSpoiler.$) {
										var _v4 = maybePressedSpoiler.a;
										var htmlIdPrefix = _v4.a;
										return $lamdera$program_test$Effect$Browser$Dom$idToString(htmlIdPrefix) + ('_image_' + $author$project$Id$toString(fileId));
									} else {
										return 'image_' + $author$project$Id$toString(fileId);
									}
								}()),
								$elm$html$Html$Events$on$(
								'click',
								A2(
									$elm$json$Json$Decode$map,
									function (position) {
										return onPressImage(
											{
												displayWidth: width,
												fileUrl: fileUrl,
												imageId: $author$project$RichText$PressedAttachedFileImage(fileId),
												imageSize: imageSize,
												position: position
											});
									},
									$author$project$Drawing$decodeWithTargetScreenPosition)),
								$author$project$RichText$htmlAttrIf$(config.isSelectingAnchor, $author$project$Drawing$anchorHighlightHtmlClass)
							]))
					]));
		} else {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href(fileUrl),
						$elm$html$Html$Attributes$target('_blank'),
						$elm$html$Html$Attributes$rel('noreferrer'),
						A2(
						$elm$html$Html$Attributes$style,
						'width',
						$elm$core$String$fromInt(
							$elm$core$Basics$round(width)) + 'px'),
						A2($elm$html$Html$Attributes$style, 'display', 'block')
					]),
				_List_fromArray(
					[
						imageElement(_List_Nil)
					]));
		}
	}
};
var $author$project$RichText$imageView = F8($author$project$RichText$imageView$);
var $author$project$RichText$inlineEmbedView$ = function (showLargeContent, onPressUrl, domainWhitelist, url) {
	var width = function () {
		if (!showLargeContent.$) {
			var containerWidth = showLargeContent.a;
			return containerWidth;
		} else {
			return 600;
		}
	}();
	var path = $author$project$RichText$urlAddPrefixed$(
		'#',
		url.fragment,
		$author$project$RichText$urlAddPrefixed$('?', url.query, url.path));
	return $author$project$RichText$buttonOrA$(
		onPressUrl,
		domainWhitelist,
		url,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'inline-block'),
				A2(
				$elm$html$Html$Attributes$style,
				'max-width',
				$elm$core$String$fromInt(
					$elm$core$Basics$min$(600, width - 4)) + 'px'),
				A2($elm$html$Html$Attributes$style, 'border-radius', '4px'),
				A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
				A2($elm$html$Html$Attributes$style, 'text-overflow', 'ellipsis'),
				A2(
				$elm$html$Html$Attributes$style,
				'color',
				$author$project$MyUi$colorToStyle($author$project$MyUi$font2)),
				A2(
				$elm$html$Html$Attributes$style,
				'background-color',
				$author$project$MyUi$colorToStyle($author$project$MyUi$background2)),
				A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
				A2($elm$html$Html$Attributes$style, 'transform', 'translateY(0.3em)'),
				A2($elm$html$Html$Attributes$style, 'border-left', 'solid 5px ' + $author$project$RichText$accentBarColor),
				A2($elm$html$Html$Attributes$style, 'padding-right', '4px')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'width', '1em'),
						A2($elm$html$Html$Attributes$style, 'height', '1em'),
						A2($elm$html$Html$Attributes$style, 'border-radius', '2px'),
						A2($elm$html$Html$Attributes$style, 'transform', 'translateY(0.125em)'),
						A2($elm$html$Html$Attributes$style, 'padding', '0 4px 0 4px'),
						$elm$html$Html$Attributes$src(
						$author$project$RichText$favicon(url)),
						$author$project$MyUi$lazyLoading
					]),
				_List_Nil),
				(!url.protocol) ? A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$Attributes$style,
						'color',
						$author$project$MyUi$colorToStyle($author$project$MyUi$font3))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('http://')
					])) : $elm$html$Html$text(''),
				$elm$html$Html$text(url.host),
				(path === '/') ? $elm$html$Html$text('') : A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$Attributes$style,
						'color',
						$author$project$MyUi$colorToStyle($author$project$MyUi$font3))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(path)
					]))
			]));
};
var $author$project$RichText$inlineEmbedView = F4($author$project$RichText$inlineEmbedView$);
var $author$project$RichText$isAsciiArt = function (language) {
	if (!language.$) {
		var name = language.a;
		return $elm$core$String$toLower(
			$MartinSStewart$elm_nonempty_string$String$Nonempty$toString(name)) === 'ascii';
	} else {
		return false;
	}
};
var $author$project$Emoji$textView$ = function (size, maybeEmojiData, text) {
	if (!maybeEmojiData.$) {
		var emojiData = maybeEmojiData.a;
		return $elm$core$List$map$(
			function (piece) {
				if (!piece.$) {
					var text2 = piece.a;
					return $elm$html$Html$text(text2);
				} else {
					var art = piece.a;
					return $author$project$Twemoji$spriteView$(size, art.sprite, art.sequence);
				}
			},
			$author$project$Emoji$splitOnEmoji$(emojiData, text));
	} else {
		return _List_fromArray(
			[
				$elm$html$Html$text(text)
			]);
	}
};
var $author$project$Emoji$textView = F3($author$project$Emoji$textView$);
var $author$project$RichText$normalTextView$ = function (emojiData, text, state) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$author$project$RichText$htmlAttrIf$(
					state.italic,
					A2($elm$html$Html$Attributes$style, 'font-style', 'italic')),
					$author$project$RichText$htmlAttrIf$(
					state.underline,
					A2($elm$html$Html$Attributes$style, 'text-decoration', 'underline')),
					$author$project$RichText$htmlAttrIf$(
					state.bold,
					A2($elm$html$Html$Attributes$style, 'font-weight', '700')),
					$author$project$RichText$htmlAttrIf$(
					state.strikethrough,
					A2($elm$html$Html$Attributes$style, 'text-decoration', 'line-through')),
					$author$project$RichText$htmlAttrIf$(
					state.spoiler,
					A2($elm$html$Html$Attributes$style, 'opacity', '0')),
					$author$project$RichText$bigEmojiFont
				]),
			$author$project$Emoji$textView$('1.4em', emojiData, text))
		]);
};
var $author$project$RichText$normalTextView = F3($author$project$RichText$normalTextView$);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$HCode = $elm$core$Basics$identity;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style1 = 2;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style2 = 3;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style3 = 4;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style4 = 5;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style5 = 6;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$atRuleToFragment = function (a) {
	switch (a) {
		case 0:
			return _Utils_Tuple2(4, 'css-ar-i');
		case 1:
			return _Utils_Tuple2(6, 'css-ar-p');
		case 2:
			return _Utils_Tuple2(4, 'css-ar-k');
		default:
			return _Utils_Tuple2(5, 'css-ar-v');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Default = 0;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style7 = 8;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$attributeSelectorToFragment = function (att) {
	switch (att) {
		case 0:
			return _Utils_Tuple2(6, 'css-s-a-an');
		case 1:
			return _Utils_Tuple2(3, 'css-s-a-av');
		default:
			return _Utils_Tuple2(4, 'css-s-a-o');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$selectorToFragment = function (s) {
	switch (s.$) {
		case 0:
			return _Utils_Tuple2(4, 'css-s-e');
		case 1:
			return _Utils_Tuple2(6, 'css-s-i');
		case 2:
			return _Utils_Tuple2(6, 'css-s-cl');
		case 3:
			return _Utils_Tuple2(8, 'css-s-c');
		case 4:
			return _Utils_Tuple2(4, 'css-s-u');
		case 5:
			var att = s.a;
			return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$attributeSelectorToFragment(att);
		case 6:
			return _Utils_Tuple2(0, 'css-s-pe');
		default:
			return _Utils_Tuple2(0, 'css-s-pc');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$syntaxToStyle = function (syntax) {
	switch (syntax.$) {
		case 0:
			return _Utils_Tuple2(3, 'css-s');
		case 1:
			var a = syntax.a;
			return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$atRuleToFragment(a);
		case 2:
			var s = syntax.a;
			return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$selectorToFragment(s);
		case 3:
			return _Utils_Tuple2(5, 'css-p');
		case 4:
			return _Utils_Tuple2(5, 'css-pv');
		case 5:
			return _Utils_Tuple2(2, 'css-n');
		default:
			return _Utils_Tuple2(4, 'css-u');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$newLine = function (fragments) {
	return {fragments: fragments, highlight: $elm$core$Maybe$Nothing};
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak = {$: 2};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Comment = 1;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toFragment$ = function (toStyle, _v0) {
	var syntax = _v0.a;
	var text = _v0.b;
	switch (syntax.$) {
		case 0:
			return {additionalClass: '', requiredStyle: 0, text: text};
		case 1:
			return {additionalClass: '', requiredStyle: 1, text: text};
		case 2:
			return {additionalClass: '', requiredStyle: 0, text: text};
		default:
			var c = syntax.a;
			var _v2 = toStyle(c);
			var requiredStyle = _v2.a;
			var additionalClass = _v2.b;
			return {additionalClass: additionalClass, requiredStyle: requiredStyle, text: text};
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toFragment = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toFragment$);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLinesHelp$ = function (toStyle, _v0, _v1) {
	var syntax = _v0.a;
	var text = _v0.b;
	var lines = _v1.a;
	var fragments = _v1.b;
	var maybeLastSyntax = _v1.c;
	if (_Utils_eq(syntax, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak)) {
		return _Utils_Tuple3(
			A2(
				$elm$core$List$cons,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$newLine(fragments),
				lines),
			_List_fromArray(
				[
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toFragment$(
					toStyle,
					_Utils_Tuple2(syntax, text))
				]),
			$elm$core$Maybe$Nothing);
	} else {
		if (_Utils_eq(
			$elm$core$Maybe$Just(syntax),
			maybeLastSyntax)) {
			if (fragments.b) {
				var headFrag = fragments.a;
				var tailFrags = fragments.b;
				return _Utils_Tuple3(
					lines,
					A2(
						$elm$core$List$cons,
						_Utils_update(
							headFrag,
							{
								text: _Utils_ap(text, headFrag.text)
							}),
						tailFrags),
					maybeLastSyntax);
			} else {
				return _Utils_Tuple3(
					lines,
					A2(
						$elm$core$List$cons,
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toFragment$(
							toStyle,
							_Utils_Tuple2(syntax, text)),
						fragments),
					maybeLastSyntax);
			}
		} else {
			return _Utils_Tuple3(
				lines,
				A2(
					$elm$core$List$cons,
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toFragment$(
						toStyle,
						_Utils_Tuple2(syntax, text)),
					fragments),
				$elm$core$Maybe$Just(syntax));
		}
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLinesHelp = F3($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLinesHelp$);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLines$ = function (toStyle, revTokens) {
	return function (_v0) {
		var lines = _v0.a;
		var frags = _v0.b;
		return A2(
			$elm$core$List$cons,
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$newLine(frags),
			lines);
	}(
		$elm$core$List$foldl$(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLinesHelp(toStyle),
			_Utils_Tuple3(_List_Nil, _List_Nil, $elm$core$Maybe$Nothing),
			revTokens));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLines = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLines$);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal = {$: 0};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$AtRule = function (a) {
	return {$: 1, a: a};
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C = function (a) {
	return {$: 3, a: a};
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Identifier = 0;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Prefix = 1;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$String = {$: 0};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$AtRuleValue = 3;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Keyword = 2;
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$chompIf$ = function (isGood, expecting) {
	return function (s) {
		var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.offset, s.src);
		return _Utils_eq(newOffset, -1) ? $elm$parser$Parser$Advanced$Bad$(
			false,
			$elm$parser$Parser$Advanced$fromState$(s, expecting)) : (_Utils_eq(newOffset, -2) ? $elm$parser$Parser$Advanced$Good$(
			true,
			0,
			{col: 1, context: s.context, indent: s.indent, offset: s.offset + 1, row: s.row + 1, src: s.src}) : $elm$parser$Parser$Advanced$Good$(
			true,
			0,
			{col: s.col + 1, context: s.context, indent: s.indent, offset: newOffset, row: s.row, src: s.src}));
	};
};
var $elm$parser$Parser$Advanced$chompIf = F2($elm$parser$Parser$Advanced$chompIf$);
var $elm$parser$Parser$chompIf = function (isGood) {
	return $elm$parser$Parser$Advanced$chompIf$(isGood, $elm$parser$Parser$UnexpectedChar);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile = function (isNotRelevant) {
	return A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf(isNotRelevant)),
		$elm$parser$Parser$chompWhile(isNotRelevant));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$atRuleKeywordSet = $elm$core$Set$fromList(
	_List_fromArray(
		['and', 'or', 'not', 'only']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isAtRuleKeyword = function (n) {
	return $elm$core$Set$member$(n, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$atRuleKeywordSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isCommentChar = function (c) {
	return c === '/';
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak = function (c) {
	return c === '\n';
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isSpace = function (c) {
	return (c === ' ') || (c === '\t');
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace = function (c) {
	return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isSpace(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$selectorNameInvalidCharSet = $elm$core$Set$fromList(
	_List_fromArray(
		[':', '{', '}', ',', '.', '#', '>', '+', '~', '*', '[', ']', '|', ';', '(', ')']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isSelectorNameChar = function (c) {
	return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isCommentChar(c) || $elm$core$Set$member$(c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$selectorNameInvalidCharSet)));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$atRuleKeywordOrValue = function (revTokens) {
	return A2(
		$elm$parser$Parser$map,
		function (n) {
			return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isAtRuleKeyword(n) ? A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$AtRule(2)),
					n),
				revTokens) : A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$AtRule(3)),
					n),
				revTokens);
		},
		$elm$parser$Parser$getChompedString(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isSelectorNameChar)));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$atRuleSet = $elm$core$Set$fromList(
	_List_fromArray(
		['@page', '@font-face', '@swash', '@annotation', '@ornaments', '@stylistic', '@styleset', '@character-variant']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment = {$: 1};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$addThen$ = function (f, list, plist) {
	return A2(
		$elm$parser$Parser$andThen,
		function (n) {
			return f(
				_Utils_ap(n, list));
		},
		plist);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$addThen = F3($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$addThen$);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$consThen$ = function (f, list, pn) {
	return A2(
		$elm$parser$Parser$andThen,
		function (n) {
			return f(
				A2($elm$core$List$cons, n, list));
		},
		pn);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$consThen = F3($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$consThen$);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile$ = function (isNotRelevant, previousParser) {
	return A2(
		$elm$parser$Parser$ignorer,
		previousParser,
		$elm$parser$Parser$chompWhile(isNotRelevant));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile$);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedUnnestable$ = function (options, revAList) {
	var innerParsers = options.innerParsers;
	var end = options.end;
	var isNotRelevant = options.isNotRelevant;
	var defaultMap = options.defaultMap;
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				$elm$core$Basics$always(
					A2(
						$elm$core$List$cons,
						defaultMap(end),
						revAList)),
				$elm$parser$Parser$symbol(end)),
				A2(
				$elm$parser$Parser$map,
				$elm$core$Basics$always(revAList),
				$elm$parser$Parser$end),
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$addThen$(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedUnnestable(options),
				revAList,
				$elm$parser$Parser$oneOf(innerParsers)),
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$consThen$(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedUnnestable(options),
				revAList,
				A2(
					$elm$parser$Parser$map,
					defaultMap,
					$elm$parser$Parser$getChompedString(
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile$(
							isNotRelevant,
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$always(true))))))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedUnnestable = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedUnnestable$);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedNestable$ = function (nestLevel, options, revAList) {
	var innerParsers = options.innerParsers;
	var end = options.end;
	var start = options.start;
	var isNotRelevant = options.isNotRelevant;
	var defaultMap = options.defaultMap;
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (n) {
					return (nestLevel === 1) ? $elm$parser$Parser$succeed(n) : $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedNestable$(nestLevel - 1, options, n);
				},
				A2(
					$elm$parser$Parser$map,
					$elm$core$Basics$always(
						A2(
							$elm$core$List$cons,
							defaultMap(end),
							revAList)),
					$elm$parser$Parser$symbol(end))),
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$consThen$(
				A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedNestable, nestLevel + 1, options),
				revAList,
				A2(
					$elm$parser$Parser$map,
					defaultMap,
					$elm$parser$Parser$getChompedString(
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile$(
							isNotRelevant,
							$elm$parser$Parser$symbol(start))))),
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$addThen$(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedUnnestable(options),
				revAList,
				$elm$parser$Parser$oneOf(innerParsers)),
				A2(
				$elm$parser$Parser$map,
				$elm$core$Basics$always(revAList),
				$elm$parser$Parser$end),
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$consThen$(
				A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedNestable, nestLevel, options),
				revAList,
				A2(
					$elm$parser$Parser$map,
					defaultMap,
					$elm$parser$Parser$getChompedString(
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile$(
							isNotRelevant,
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$always(true))))))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedNestable = F3($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedNestable$);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedHelp$ = function (options, revAList) {
	var isNotRelevant = options.isNotRelevant;
	var end = options.end;
	var start = options.start;
	var _v0 = _Utils_Tuple2(
		$elm$core$String$uncons(options.start),
		$elm$core$String$uncons(options.end));
	if (_v0.a.$ === 1) {
		var _v1 = _v0.a;
		return $elm$parser$Parser$problem('Trying to parse a delimited helper, but the start token cannot be an empty string!');
	} else {
		if (_v0.b.$ === 1) {
			var _v2 = _v0.b;
			return $elm$parser$Parser$problem('Trying to parse a delimited helper, but the end token cannot be an empty string!');
		} else {
			var _v3 = _v0.a.a;
			var startChar = _v3.a;
			var _v4 = _v0.b.a;
			var endChar = _v4.a;
			return options.isNestable ? $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedNestable$(
				1,
				_Utils_update(
					options,
					{
						isNotRelevant: function (c) {
							return isNotRelevant(c) && ((!_Utils_eq(c, startChar)) && (!_Utils_eq(c, endChar)));
						}
					}),
				revAList) : $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedUnnestable$(
				_Utils_update(
					options,
					{
						isNotRelevant: function (c) {
							return isNotRelevant(c) && (!_Utils_eq(c, endChar));
						}
					}),
				revAList);
		}
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedHelp = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedHelp$);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited = function (options) {
	var defaultMap = options.defaultMap;
	var isNotRelevant = options.isNotRelevant;
	var start = options.start;
	return A2(
		$elm$parser$Parser$andThen,
		function (n) {
			return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedHelp$(
				options,
				_List_fromArray(
					[n]));
		},
		A2(
			$elm$parser$Parser$map,
			$elm$core$Basics$always(
				defaultMap(start)),
			$elm$parser$Parser$symbol(start)));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$lineBreak = A2(
	$elm$parser$Parser$map,
	function (_v0) {
		return _List_fromArray(
			[
				_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak, '\u000A')
			]);
	},
	$elm$parser$Parser$symbol('\u000A'));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$comment = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(
	{
		defaultMap: function (b) {
			return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment, b);
		},
		end: '*/',
		innerParsers: _List_fromArray(
			[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$lineBreak]),
		isNestable: false,
		isNotRelevant: function (c) {
			return !$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c);
		},
		start: '/*'
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$whitespaceOrCommentStep = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isSpace))),
				A2(
				$elm$parser$Parser$map,
				function (ns) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(ns, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$lineBreak),
				A2(
				$elm$parser$Parser$map,
				function (ns) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(ns, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$comment)
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$keyframesOrCounterStyle = function (a) {
	return $elm$parser$Parser$loop$(
		_List_fromArray(
			[
				_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$AtRule(0)),
				a)
			]),
		function (ns) {
			return $elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$whitespaceOrCommentStep(ns),
						A2(
						$elm$parser$Parser$map,
						function (b) {
							return $elm$parser$Parser$Loop(
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(
											$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$AtRule(1)),
										b),
									ns));
						},
						$elm$parser$Parser$getChompedString(
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isSelectorNameChar))),
						A2(
						$elm$parser$Parser$map,
						function (b) {
							return $elm$parser$Parser$Loop(
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b),
									ns));
						},
						$elm$parser$Parser$getChompedString(
							$elm$parser$Parser$chompIf(
								function (c) {
									return c !== '{';
								}))),
						$elm$parser$Parser$succeed(
						$elm$parser$Parser$Done(ns))
					]));
		});
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$nestableAtRuleOpener = function (ns) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				$elm$core$Basics$always(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, '{'),
						ns)),
				$elm$parser$Parser$symbol('{')),
				$elm$parser$Parser$succeed(ns)
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Number = {$: 5};
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return $elm$parser$Parser$Advanced$Bad$(false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return $elm$parser$Parser$Advanced$Good$(false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$escapableSet = $elm$core$Set$fromList(
	_List_fromArray(
		['\'', '"', '\\', 'n', 'r', 't', 'b', 'f', 'v']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapableChar = function (c) {
	return $elm$core$Set$member$(c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$escapableSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$escapable = A2(
	$elm$parser$Parser$ignorer,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed(0),
		$elm$parser$Parser$backtrackable(
			$elm$parser$Parser$symbol('\u005C'))),
	$elm$parser$Parser$chompIf($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapableChar));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$cssEscapable = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Number),
				b)
			]);
	},
	$elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$escapable));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapable = function (c) {
	return c === '\\';
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$quoteDelimiter = {
	defaultMap: function (b) {
		return _Utils_Tuple2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$String),
			b);
	},
	end: '\u0027',
	innerParsers: _List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$lineBreak, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$cssEscapable]),
	isNestable: false,
	isNotRelevant: function (c) {
		return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapable(c));
	},
	start: '\u0027'
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$doubleQuote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(
	_Utils_update(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$quoteDelimiter,
		{end: '\u0022', start: '\u0022'}));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$quote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$quoteDelimiter);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$stringLiteral = function (revTokens) {
	return A2(
		$elm$parser$Parser$map,
		function (n) {
			return _Utils_ap(n, revTokens);
		},
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$quote, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$doubleQuote])));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$mediaOrSupports = function (a) {
	return A2(
		$elm$parser$Parser$andThen,
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$nestableAtRuleOpener,
		$elm$parser$Parser$loop$(
			_List_fromArray(
				[
					_Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$AtRule(0)),
					a)
				]),
			function (ns) {
				return $elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$whitespaceOrCommentStep(ns),
							A2(
							$elm$parser$Parser$map,
							$elm$parser$Parser$Loop,
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$stringLiteral(ns)),
							A2(
							$elm$parser$Parser$map,
							$elm$parser$Parser$Loop,
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$atRuleKeywordOrValue(ns)),
							A2(
							$elm$parser$Parser$map,
							function (b) {
								return $elm$parser$Parser$Loop(
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b),
										ns));
							},
							$elm$parser$Parser$getChompedString(
								$elm$parser$Parser$chompIf(
									function (c) {
										return c !== '{';
									}))),
							$elm$parser$Parser$succeed(
							$elm$parser$Parser$Done(ns))
						]));
			}));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$PropertyValue = {$: 4};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$stringArg$ = function (fnStr, revTokens) {
	return A2(
		$elm$parser$Parser$andThen,
		function (revT_) {
			return $elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$stringLiteral(revT_),
						A2(
						$elm$parser$Parser$map,
						function (n) {
							return A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$String),
									n),
								revT_);
						},
						$elm$parser$Parser$getChompedString(
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
								function (c) {
									return c !== ')';
								}))),
						$elm$parser$Parser$succeed(revT_)
					]));
		},
		A2(
			$elm$parser$Parser$map,
			$elm$core$Basics$always(
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, '('),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$PropertyValue),
							fnStr),
						revTokens))),
			$elm$parser$Parser$symbol(fnStr + '(')));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$stringArg = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$stringArg$);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$atRuleHelper = function (a) {
	switch (a) {
		case '@import':
			return $elm$parser$Parser$loop$(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$AtRule(0)),
						a)
					]),
				function (ns) {
					return $elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$whitespaceOrCommentStep(ns),
								A2(
								$elm$parser$Parser$map,
								$elm$parser$Parser$Loop,
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$stringArg$('url', ns)),
								A2(
								$elm$parser$Parser$map,
								$elm$parser$Parser$Loop,
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$stringLiteral(ns)),
								A2(
								$elm$parser$Parser$map,
								$elm$parser$Parser$Loop,
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$atRuleKeywordOrValue(ns)),
								A2(
								$elm$parser$Parser$map,
								function (b) {
									return $elm$parser$Parser$Loop(
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b),
											ns));
								},
								$elm$parser$Parser$getChompedString(
									$elm$parser$Parser$chompIf(
										function (c) {
											return c !== ';';
										}))),
								$elm$parser$Parser$succeed(
								$elm$parser$Parser$Done(ns))
							]));
				});
		case '@namespace':
			return $elm$parser$Parser$loop$(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$AtRule(0)),
						a)
					]),
				function (ns) {
					return $elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$whitespaceOrCommentStep(ns),
								A2(
								$elm$parser$Parser$map,
								$elm$parser$Parser$Loop,
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$stringArg$('url', ns)),
								A2(
								$elm$parser$Parser$map,
								$elm$parser$Parser$Loop,
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$stringLiteral(ns)),
								A2(
								$elm$parser$Parser$map,
								function (b) {
									return $elm$parser$Parser$Loop(
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2(
												$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(
													$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$AtRule(1)),
												b),
											ns));
								},
								$elm$parser$Parser$getChompedString(
									$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isSelectorNameChar))),
								A2(
								$elm$parser$Parser$map,
								function (b) {
									return $elm$parser$Parser$Loop(
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b),
											ns));
								},
								$elm$parser$Parser$getChompedString(
									$elm$parser$Parser$chompIf(
										function (c) {
											return c !== ';';
										}))),
								$elm$parser$Parser$succeed(
								$elm$parser$Parser$Done(ns))
							]));
				});
		case '@charset':
			return $elm$parser$Parser$loop$(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$AtRule(0)),
						a)
					]),
				function (ns) {
					return $elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$whitespaceOrCommentStep(ns),
								A2(
								$elm$parser$Parser$map,
								$elm$parser$Parser$Loop,
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$stringLiteral(ns)),
								A2(
								$elm$parser$Parser$map,
								function (b) {
									return $elm$parser$Parser$Loop(
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2(
												$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$String),
												b),
											ns));
								},
								$elm$parser$Parser$getChompedString(
									$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isSelectorNameChar))),
								A2(
								$elm$parser$Parser$map,
								function (b) {
									return $elm$parser$Parser$Loop(
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b),
											ns));
								},
								$elm$parser$Parser$getChompedString(
									$elm$parser$Parser$chompIf(
										function (c) {
											return c !== ';';
										}))),
								$elm$parser$Parser$succeed(
								$elm$parser$Parser$Done(ns))
							]));
				});
		case '@media':
			return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$mediaOrSupports(a);
		case '@supports':
			return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$mediaOrSupports(a);
		case '@keyframes':
			return A2(
				$elm$parser$Parser$andThen,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$nestableAtRuleOpener,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$keyframesOrCounterStyle(a));
		case '@counter-style':
			return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$keyframesOrCounterStyle(a);
		case '@font-feature-values':
			return A2(
				$elm$parser$Parser$andThen,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$nestableAtRuleOpener,
				$elm$parser$Parser$loop$(
					_List_fromArray(
						[
							_Utils_Tuple2(
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$AtRule(0)),
							a)
						]),
					function (ns) {
						return $elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$whitespaceOrCommentStep(ns),
									A2(
									$elm$parser$Parser$map,
									function (b) {
										return $elm$parser$Parser$Loop(
											A2(
												$elm$core$List$cons,
												_Utils_Tuple2(
													$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(
														$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$AtRule(1)),
													b),
												ns));
									},
									$elm$parser$Parser$getChompedString(
										$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isSelectorNameChar))),
									A2(
									$elm$parser$Parser$map,
									function (b) {
										return $elm$parser$Parser$Loop(
											A2(
												$elm$core$List$cons,
												_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b),
												ns));
									},
									$elm$parser$Parser$getChompedString(
										$elm$parser$Parser$chompIf(
											function (c) {
												return c !== '{';
											}))),
									$elm$parser$Parser$succeed(
									$elm$parser$Parser$Done(ns))
								]));
					}));
		default:
			return $elm$core$Set$member$(a, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$atRuleSet) ? $elm$parser$Parser$succeed(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$AtRule(0)),
						a)
					])) : $elm$parser$Parser$succeed(
				_List_fromArray(
					[
						_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, a)
					]));
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$atRule = A2(
	$elm$parser$Parser$andThen,
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$atRuleHelper,
	$elm$parser$Parser$getChompedString(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile$(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isSelectorNameChar,
			$elm$parser$Parser$symbol('@'))));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Property = {$: 3};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isPropertyChar = function (c) {
	return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isCommentChar(c) || ((c === ':') || ((c === ';') || (c === '}')))));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Unit = {$: 6};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$operatorCharSet = $elm$core$Set$fromList(
	_List_fromArray(
		['+', '-', '%', '*', '/']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isOperatorChar = function (c) {
	return $elm$core$Set$member$(c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$operatorCharSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isPropertyValueChar = function (c) {
	return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isPropertyChar(c) && (!((c === '(') || ((c === ')') || ((c === ',') || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isOperatorChar(c)))));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$hexColor = function (revTokens) {
	return A2(
		$elm$parser$Parser$map,
		function (n) {
			return A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Number),
					n),
				revTokens);
		},
		$elm$parser$Parser$getChompedString(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile$(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isPropertyValueChar,
				$elm$parser$Parser$symbol('#'))));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isNotPropertyValueChar = function (c) {
	return (c === '(') || ((c === ')') || ((c === ':') || ((c === ',') || (c === '/'))));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$unitSet = $elm$core$Set$fromList(
	_List_fromArray(
		['em', 'ex', 'ch', 'rem', 'vw', 'vh', 'vmin', 'vmax', 'cm', 'mm', 'q', 'in', 'pt', 'pc', 'px', 'deg', 'grad', 'rad', 'turn', 's', 'ms', 'Hz', 'kHz', 'dpi', 'dpcm', 'dppx']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isUnit = function (n) {
	return $elm$core$Set$member$(n, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$unitSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isNumber = function (c) {
	return $elm$core$Char$isDigit(c) || (c === '.');
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$positiveNumber = A2(
	$elm$parser$Parser$ignorer,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed(0),
		$elm$parser$Parser$chompIf($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isNumber)),
	$elm$parser$Parser$chompWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isNumber));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$negativeNumber = A2(
	$elm$parser$Parser$ignorer,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed(0),
		$elm$parser$Parser$backtrackable(
			$elm$parser$Parser$symbol('-'))),
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$positiveNumber);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$number = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$positiveNumber, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$negativeNumber]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$number = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Number),
			b);
	},
	$elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$number));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$valueLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$stringLiteral(revTokens)),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$number),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$hexColor(revTokens)),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$stringArg$('url', revTokens)),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$stringArg$('format', revTokens)),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$stringArg$('local', revTokens)),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isUnit(n) ? $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Unit),
								n),
							revTokens)) : $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$PropertyValue),
								n),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isPropertyValueChar))),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isNotPropertyValueChar))),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Unit),
								b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isOperatorChar))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$valueHelper = function (opener) {
	return $elm$parser$Parser$loop$(
		_List_fromArray(
			[opener]),
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$valueLoop);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$value = A2(
	$elm$parser$Parser$andThen,
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$valueHelper,
	A2(
		$elm$parser$Parser$map,
		function (b) {
			return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
		},
		$elm$parser$Parser$getChompedString(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
				$elm$core$Basics$eq(':')))));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$declarationLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Property),
								b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isPropertyChar))),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
						function (c) {
							return (c === ';') || (c === '/');
						}))),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$value),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$declarationBlockHelper = function (opener) {
	return $elm$parser$Parser$loop$(
		_List_fromArray(
			[opener]),
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$declarationLoop);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$declarationBlock = A2(
	$elm$parser$Parser$andThen,
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$declarationBlockHelper,
	A2(
		$elm$parser$Parser$map,
		function (b) {
			return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
		},
		$elm$parser$Parser$getChompedString(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
				function (c) {
					return c === '{';
				}))));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Selector = function (a) {
	return {$: 2, a: a};
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$AttributeName = 0;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$AttributeSelector = function (a) {
	return {$: 5, a: a};
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$attSelOperatorCharSet = $elm$core$Set$fromList(
	_List_fromArray(
		['=', '~', '|', '^', '$', '*']));
var $elm$core$Set$union$ = function (_v0, _v1) {
	var dict1 = _v0;
	var dict2 = _v1;
	return $elm$core$Dict$union$(dict1, dict2);
};
var $elm$core$Set$union = F2($elm$core$Set$union$);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$whitespaceCharSet = $elm$core$Set$fromList(
	_List_fromArray(
		[' ', '\t', '\n']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$attSelNameInvalidCharSet = $elm$core$Set$insert$(
	']',
	$elm$core$Set$union$($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$attSelOperatorCharSet, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$whitespaceCharSet));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$attributeName = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Selector(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$AttributeSelector(0))),
			b);
	},
	$elm$parser$Parser$getChompedString(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
			function (c) {
				return !$elm$core$Set$member$(c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$attSelNameInvalidCharSet);
			})));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$AttributeOperator = 2;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$attributeOperator = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Selector(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$AttributeSelector(2))),
			b);
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$symbol('~='),
					$elm$parser$Parser$symbol('|='),
					$elm$parser$Parser$symbol('^='),
					$elm$parser$Parser$symbol('$='),
					$elm$parser$Parser$symbol('*='),
					$elm$parser$Parser$symbol('=')
				]))));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$AttributeValue = 1;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$attributeValue = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Done,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$stringLiteral(revTokens)),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Done,
				A2(
					$elm$parser$Parser$map,
					function (b) {
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(
									$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Selector(
										$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$AttributeSelector(1))),
								b),
							revTokens);
					},
					$elm$parser$Parser$getChompedString(
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
							function (c) {
								return (c !== ']') && (!$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c));
							})))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$attributeSelectorLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$attributeName),
				A2(
				$elm$parser$Parser$andThen,
				function (operator) {
					return A2(
						$elm$parser$Parser$map,
						function (n) {
							return $elm$parser$Parser$Loop(
								_Utils_ap(n, revTokens));
						},
						$elm$parser$Parser$loop$(
							_List_fromArray(
								[operator]),
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$attributeValue));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$attributeOperator),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$attributeSelector = A2(
	$elm$parser$Parser$andThen,
	function (opener) {
		return $elm$parser$Parser$loop$(
			_List_fromArray(
				[opener]),
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$attributeSelectorLoop);
	},
	A2(
		$elm$parser$Parser$map,
		$elm$core$Basics$always(
			_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, '[')),
		$elm$parser$Parser$symbol('[')));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Class = {$: 2};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$class = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Class, b);
	},
	$elm$parser$Parser$getChompedString(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile$(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isSelectorNameChar,
			$elm$parser$Parser$symbol('.'))));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Combinator = {$: 3};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$combinator = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Combinator, b);
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$symbol('+'),
					$elm$parser$Parser$symbol('~'),
					$elm$parser$Parser$symbol('>')
				]))));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Element = {$: 0};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$element = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Element, b);
	},
	$elm$parser$Parser$getChompedString(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isSelectorNameChar)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Id = {$: 1};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$id = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Id, b);
	},
	$elm$parser$Parser$getChompedString(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile$(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isSelectorNameChar,
			$elm$parser$Parser$symbol('#'))));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$PseudoClass = {$: 7};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$pseudoClass = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$PseudoClass, b);
	},
	$elm$parser$Parser$getChompedString(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile$(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isSelectorNameChar,
			$elm$parser$Parser$symbol(':'))));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$PseudoElement = {$: 6};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$pseudoElement = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$PseudoElement, b);
	},
	$elm$parser$Parser$getChompedString(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile$(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$isSelectorNameChar,
			$elm$parser$Parser$symbol('::'))));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Universal = {$: 4};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$universal = A2(
	$elm$parser$Parser$map,
	$elm$core$Basics$always(
		_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Universal, '*')),
	$elm$parser$Parser$symbol('*'));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$selector = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$map,
			function (_v0) {
				var n = _v0.a;
				var s = _v0.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Selector(n)),
						s)
					]);
			},
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$id, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$class, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$element, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$universal, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$combinator, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$pseudoElement, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$pseudoClass]))),
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$attributeSelector
		]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$mainLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$atRule),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$selector),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$declarationBlock),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$always(true)))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$toRevTokens = $elm$parser$Parser$loop$(_List_Nil, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$mainLoop);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$toLines = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$toRevTokens),
	$elm$core$Result$map(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLines($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$syntaxToStyle)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$css = A2(
	$elm$core$Basics$composeR,
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$toLines,
	$elm$core$Result$map($elm$core$Basics$identity));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style6 = 7;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$syntaxToStyle = function (syntax) {
	switch (syntax) {
		case 0:
			return _Utils_Tuple2(3, 'elm-s');
		case 1:
			return _Utils_Tuple2(4, 'elm-bs');
		case 2:
			return _Utils_Tuple2(5, 'elm-gs');
		case 3:
			return _Utils_Tuple2(7, 'elm-c');
		case 4:
			return _Utils_Tuple2(4, 'elm-k');
		case 5:
			return _Utils_Tuple2(6, 'elm-f');
		case 6:
			return _Utils_Tuple2(5, 'elm-ts');
		default:
			return _Utils_Tuple2(2, 'elm-n');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$inlineComment = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _List_fromArray(
			[
				_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment, b)
			]);
	},
	$elm$parser$Parser$getChompedString(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile$(
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak),
			$elm$parser$Parser$symbol('--'))));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineBreakList = A2(
	$elm$parser$Parser$map,
	function (_v0) {
		return _List_fromArray(
			[
				_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak, '\u000A')
			]);
	},
	$elm$parser$Parser$symbol('\u000A'));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$multilineComment = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(
	{
		defaultMap: function (b) {
			return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment, b);
		},
		end: '-}',
		innerParsers: _List_fromArray(
			[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineBreakList]),
		isNestable: true,
		isNotRelevant: function (c) {
			return !$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c);
		},
		start: '{-'
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$comment = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$inlineComment, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$multilineComment]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$BasicSymbol = 1;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$Capitalized = 3;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$GroupSymbol = 2;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$Keyword = 4;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$Number = 7;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$basicSymbols = $elm$core$Set$fromList(
	_List_fromArray(
		['|', '.', '=', '\\', '/', '(', ')', '-', '>', '<', ':', '+', '!', '$', '%', '&', '*']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isBasicSymbol = function (c) {
	return $elm$core$Set$member$(c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$basicSymbols);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$basicSymbol = $elm$parser$Parser$getChompedString(
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isBasicSymbol));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$groupSymbols = $elm$core$Set$fromList(
	_List_fromArray(
		[',', '[', ']', '{', '}']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isGroupSymbol = function (c) {
	return $elm$core$Set$member$(c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$groupSymbols);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isStringLiteralChar = function (c) {
	return (c === '"') || (c === '\'');
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isVariableChar = function (c) {
	return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isBasicSymbol(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isGroupSymbol(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isStringLiteralChar(c))));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$capitalized = $elm$parser$Parser$getChompedString(
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile$(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isVariableChar,
		$elm$parser$Parser$chompIf($elm$core$Char$isUpper)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$groupSymbol = $elm$parser$Parser$getChompedString(
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isGroupSymbol));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$Function = 5;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$infixSet = $elm$core$Set$fromList(
	_List_fromArray(
		['+', '-', '/', '*', '=', '.', '$', '<', '>', ':', '&', '|', '^', '?', '%', '#', '@', '~', '!', ',']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isInfixChar = function (c) {
	return $elm$core$Set$member$(c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$infixSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$infixParser = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5),
			b);
	},
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$backtrackable(
						$elm$parser$Parser$symbol('('))),
				$elm$parser$Parser$backtrackable(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isInfixChar))),
			$elm$parser$Parser$backtrackable(
				$elm$parser$Parser$symbol(')')))));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$keywordSet = $elm$core$Set$fromList(
	_List_fromArray(
		['as', 'where', 'let', 'in', 'if', 'else', 'then', 'case', 'of', 'type', 'alias']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isKeyword = function (str) {
	return $elm$core$Set$member$(str, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$keywordSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$variable = $elm$parser$Parser$getChompedString(
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile$(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isVariableChar,
		$elm$parser$Parser$chompIf($elm$core$Char$isLower)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$weirdText = $elm$parser$Parser$getChompedString(
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isVariableChar));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBodyContent = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$map,
			function (b) {
				return _Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(7),
					b);
			},
			$elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$number)),
			A2(
			$elm$parser$Parser$map,
			$elm$core$Basics$always(
				_Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3),
					'()')),
			$elm$parser$Parser$symbol('()')),
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$infixParser,
			A2(
			$elm$parser$Parser$map,
			function (b) {
				return _Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(1),
					b);
			},
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$basicSymbol),
			A2(
			$elm$parser$Parser$map,
			function (b) {
				return _Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(2),
					b);
			},
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$groupSymbol),
			A2(
			$elm$parser$Parser$map,
			function (b) {
				return _Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3),
					b);
			},
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$capitalized),
			A2(
			$elm$parser$Parser$map,
			function (n) {
				return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isKeyword(n) ? _Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
					n) : _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, n);
			},
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$variable),
			A2(
			$elm$parser$Parser$map,
			function (b) {
				return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
			},
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$weirdText)
		]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$String = 0;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$elmEscapable = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3),
				b)
			]);
	},
	$elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$escapable));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$stringDelimiter = {
	defaultMap: function (b) {
		return _Utils_Tuple2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(0),
			b);
	},
	end: '\u0022',
	innerParsers: _List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineBreakList, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$elmEscapable]),
	isNestable: false,
	isNotRelevant: function (c) {
		return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapable(c));
	},
	start: '\u0022'
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$doubleQuote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$stringDelimiter);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$quote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(
	_Utils_update(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$stringDelimiter,
		{end: '\u0027', start: '\u0027'}));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$tripleDoubleQuote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(
	_Utils_update(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$stringDelimiter,
		{end: '\u0022\u0022\u0022', start: '\u0022\u0022\u0022'}));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$stringLiteral = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$tripleDoubleQuote, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$doubleQuote, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$quote]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineBreak = A2(
	$elm$parser$Parser$map,
	function (_v0) {
		return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak, '\u000A');
	},
	$elm$parser$Parser$symbol('\u000A'));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$space = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
	},
	$elm$parser$Parser$getChompedString(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isSpace)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$checkContext = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep(revTokens),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$space),
				A2(
				$elm$parser$Parser$andThen,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$checkContext,
				A2(
					$elm$parser$Parser$map,
					function (n) {
						return A2($elm$core$List$cons, n, revTokens);
					},
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineBreak)),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$comment)
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBody = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (ns) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(ns, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$stringLiteral),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBodyContent),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$TypeSignature = 6;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$fnSigIsNotRelevant = function (c) {
	return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c) || ((c === '(') || ((c === ')') || ((c === '-') || (c === ',')))));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$fnSigContentHelp = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$map,
			$elm$core$Basics$always(
				_Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6),
					'()')),
			$elm$parser$Parser$symbol('()')),
			A2(
			$elm$parser$Parser$map,
			$elm$core$Basics$always(
				_Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(1),
					'->')),
			$elm$parser$Parser$symbol('->')),
			A2(
			$elm$parser$Parser$map,
			function (b) {
				return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
			},
			$elm$parser$Parser$getChompedString(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
					function (c) {
						return (c === '(') || ((c === ')') || ((c === '-') || (c === ',')));
					}))),
			A2(
			$elm$parser$Parser$map,
			function (b) {
				return _Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6),
					b);
			},
			$elm$parser$Parser$getChompedString(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile$(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$fnSigIsNotRelevant,
					$elm$parser$Parser$chompIf($elm$core$Char$isUpper)))),
			A2(
			$elm$parser$Parser$map,
			function (b) {
				return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
			},
			$elm$parser$Parser$getChompedString(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$fnSigIsNotRelevant)))
		]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$fnSigContent = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$fnSigContentHelp),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionSignature = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Done,
				A2(
					$elm$parser$Parser$andThen,
					function (ns) {
						return $elm$parser$Parser$loop$(ns, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$fnSigContent);
					},
					A2(
						$elm$parser$Parser$map,
						$elm$core$Basics$always(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(1),
									':'),
								revTokens)),
						$elm$parser$Parser$symbol(':')))),
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Done,
				$elm$parser$Parser$loop$(revTokens, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBody)),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isCommentChar = function (c) {
	return (c === '-') || (c === '{');
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$commentChar = $elm$parser$Parser$getChompedString(
	$elm$parser$Parser$chompIf($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isCommentChar));
var $elm$parser$Parser$ExpectingKeyword = function (a) {
	return {$: 9, a: a};
};
var $elm$parser$Parser$Advanced$keyword = function (_v0) {
	var kwd = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(kwd);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, kwd, s.offset, s.row, s.col, s.src);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return (_Utils_eq(newOffset, -1) || (0 <= A3(
			$elm$parser$Parser$Advanced$isSubChar,
			function (c) {
				return $elm$core$Char$isAlphaNum(c) || (c === '_');
			},
			newOffset,
			s.src))) ? $elm$parser$Parser$Advanced$Bad$(
			false,
			$elm$parser$Parser$Advanced$fromState$(s, expecting)) : $elm$parser$Parser$Advanced$Good$(
			progress,
			0,
			{col: newCol, context: s.context, indent: s.indent, offset: newOffset, row: newRow, src: s.src});
	};
};
var $elm$parser$Parser$keyword = function (kwd) {
	return $elm$parser$Parser$Advanced$keyword(
		$elm$parser$Parser$Advanced$Token$(
			kwd,
			$elm$parser$Parser$ExpectingKeyword(kwd)));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$modDecIsNotRelevant = function (c) {
	return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isCommentChar(c) || (c === '(')));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$mdpIsNotRelevant = function (c) {
	return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isCommentChar(c) || ((c === '(') || ((c === ')') || ((c === ',') || (c === '.'))))));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$mdpnIsSpecialChar = function (c) {
	return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isCommentChar(c) || ((c === '(') || (c === ')')));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$checkContextNested = function (_v1) {
	var nestLevel = _v1.a;
	var revTokens = _v1.b;
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStepNested(
				_Utils_Tuple2(nestLevel, revTokens)),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStepNested = function (_v0) {
	var nestLevel = _v0.a;
	var revTokens = _v0.b;
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						_Utils_Tuple2(
							nestLevel,
							A2($elm$core$List$cons, n, revTokens)));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$space),
				A2(
				$elm$parser$Parser$andThen,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$checkContextNested,
				A2(
					$elm$parser$Parser$map,
					function (n) {
						return _Utils_Tuple2(
							nestLevel,
							A2($elm$core$List$cons, n, revTokens));
					},
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineBreak)),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						_Utils_Tuple2(
							nestLevel,
							_Utils_ap(n, revTokens)));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$comment)
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$modDecParNest = function (_v0) {
	var nestLevel = _v0.a;
	var revTokens = _v0.b;
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStepNested(
				_Utils_Tuple2(nestLevel, revTokens)),
				A2(
				$elm$parser$Parser$map,
				function (ns) {
					return $elm$parser$Parser$Loop(
						_Utils_Tuple2(nestLevel + 1, ns));
				},
				A2(
					$elm$parser$Parser$map,
					$elm$core$Basics$always(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, '('),
							revTokens)),
					$elm$parser$Parser$symbol('('))),
				A2(
				$elm$parser$Parser$map,
				function (ns) {
					return (!nestLevel) ? $elm$parser$Parser$Done(ns) : $elm$parser$Parser$Loop(
						_Utils_Tuple2(nestLevel - 1, ns));
				},
				A2(
					$elm$parser$Parser$map,
					$elm$core$Basics$always(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, ')'),
							revTokens)),
					$elm$parser$Parser$symbol(')'))),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						_Utils_Tuple2(
							nestLevel,
							A2($elm$core$List$cons, n, revTokens)));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$map,
							function (b) {
								return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
							},
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$commentChar),
							A2(
							$elm$parser$Parser$map,
							function (s) {
								return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, s);
							},
							$elm$parser$Parser$getChompedString(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
									A2($elm$core$Basics$composeL, $elm$core$Basics$not, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$mdpnIsSpecialChar))))
						]))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$modDecParentheses = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Done,
				A2(
					$elm$parser$Parser$map,
					$elm$core$Basics$always(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, ')'),
							revTokens)),
					$elm$parser$Parser$symbol(')'))),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$infixParser,
							A2(
							$elm$parser$Parser$map,
							function (b) {
								return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
							},
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$commentChar),
							A2(
							$elm$parser$Parser$map,
							function (b) {
								return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
							},
							$elm$parser$Parser$getChompedString(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
									function (c) {
										return (c === ',') || (c === '.');
									}))),
							A2(
							$elm$parser$Parser$map,
							function (b) {
								return _Utils_Tuple2(
									$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6),
									b);
							},
							$elm$parser$Parser$getChompedString(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile$(
									$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$mdpIsNotRelevant,
									$elm$parser$Parser$chompIf($elm$core$Char$isUpper)))),
							A2(
							$elm$parser$Parser$map,
							function (b) {
								return _Utils_Tuple2(
									$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5),
									b);
							},
							$elm$parser$Parser$getChompedString(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$mdpIsNotRelevant)))
						]))),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					function (n) {
						return $elm$parser$Parser$loop$(
							_Utils_Tuple2(0, n),
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$modDecParNest);
					},
					A2(
						$elm$parser$Parser$map,
						$elm$core$Basics$always(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, '('),
								revTokens)),
						$elm$parser$Parser$symbol('(')))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$moduleDeclaration = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					function (n) {
						return $elm$parser$Parser$loop$(n, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$modDecParentheses);
					},
					A2(
						$elm$parser$Parser$map,
						$elm$core$Basics$always(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, '('),
								revTokens)),
						$elm$parser$Parser$symbol('(')))),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$map,
							function (b) {
								return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
							},
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$commentChar),
							A2(
							$elm$parser$Parser$map,
							$elm$core$Basics$always(
								_Utils_Tuple2(
									$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
									'exposing')),
							$elm$parser$Parser$keyword('exposing')),
							A2(
							$elm$parser$Parser$map,
							$elm$core$Basics$always(
								_Utils_Tuple2(
									$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
									'as')),
							$elm$parser$Parser$keyword('as')),
							A2(
							$elm$parser$Parser$map,
							function (b) {
								return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
							},
							$elm$parser$Parser$getChompedString(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$modDecIsNotRelevant)))
						]))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$portDeclarationHelp$ = function (revTokens, str) {
	return (str === 'module') ? $elm$parser$Parser$loop$(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
				str),
			revTokens),
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$moduleDeclaration) : $elm$parser$Parser$loop$(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5),
				str),
			revTokens),
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionSignature);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$portDeclarationHelp = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$portDeclarationHelp$);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$portDeclaration = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Done,
				A2(
					$elm$parser$Parser$andThen,
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$portDeclarationHelp(revTokens),
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$variable)),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Done,
				$elm$parser$Parser$loop$(revTokens, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBody)),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineStartVariable$ = function (revTokens, n) {
	return ((n === 'module') || (n === 'import')) ? $elm$parser$Parser$loop$(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
				n),
			revTokens),
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$moduleDeclaration) : ((n === 'port') ? $elm$parser$Parser$loop$(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
				n),
			revTokens),
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$portDeclaration) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isKeyword(n) ? $elm$parser$Parser$loop$(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
				n),
			revTokens),
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBody) : $elm$parser$Parser$loop$(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5),
				n),
			revTokens),
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionSignature)));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineStartVariable = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineStartVariable$);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$mainLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$space),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineBreak),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$comment),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineStartVariable(revTokens),
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$variable)),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					function (s) {
						return $elm$parser$Parser$loop$(
							_Utils_ap(s, revTokens),
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBody);
					},
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$stringLiteral)),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					function (s) {
						return $elm$parser$Parser$loop$(
							A2($elm$core$List$cons, s, revTokens),
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBody);
					},
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBodyContent)),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$toRevTokens = $elm$parser$Parser$loop$(_List_Nil, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$mainLoop);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$toLines = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$toRevTokens),
	$elm$core$Result$map(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLines($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$syntaxToStyle)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$elm = A2(
	$elm$core$Basics$composeR,
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$toLines,
	$elm$core$Result$map($elm$core$Basics$identity));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$syntaxToStyle = function (syntax) {
	switch (syntax) {
		case 0:
			return _Utils_Tuple2(2, 'go-n');
		case 1:
			return _Utils_Tuple2(3, 'go-s');
		case 2:
			return _Utils_Tuple2(4, 'go-k');
		case 3:
			return _Utils_Tuple2(4, 'go-dk');
		case 4:
			return _Utils_Tuple2(5, 'go-t');
		case 5:
			return _Utils_Tuple2(6, 'go-f');
		case 6:
			return _Utils_Tuple2(7, 'go-lk');
		case 7:
			return _Utils_Tuple2(4, 'go-p');
		case 8:
			return _Utils_Tuple2(4, 'go-o');
		default:
			return _Utils_Tuple2(8, 'go-param');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$groupCharSet = $elm$core$Set$fromList(
	_List_fromArray(
		['(', ')', '[', ']', '{', '}', ',', ';']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$isGroupChar = function (c) {
	return $elm$core$Set$member$(c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$groupCharSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$groupChar = A2(
	$elm$parser$Parser$map,
	function (s) {
		return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, s);
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$isGroupChar)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$isIdentifierNameChar = function (c) {
	return $elm$core$Char$isAlphaNum(c) || ((c === '_') || ($elm$core$Char$toCode(c) > 127));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$DeclarationKeyword = 3;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$Keyword = 2;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$LiteralKeyword = 6;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$Package = 7;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$Type = 4;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$Function = 5;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$Param = 9;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$types = $elm$core$Set$fromList(
	_List_fromArray(
		['bool', 'byte', 'complex64', 'complex128', 'error', 'float32', 'float64', 'int', 'int8', 'int16', 'int32', 'int64', 'rune', 'string', 'uint', 'uint8', 'uint16', 'uint32', 'uint64', 'uintptr']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$isType = function (str) {
	return $elm$core$Set$member$(str, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$types);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$argParser$ = function (revTokens, n) {
	return ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$isType(n) || A2($elm$core$String$startsWith, '[]', n)) ? $elm$parser$Parser$succeed(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
				n),
			revTokens)) : $elm$parser$Parser$succeed(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(9),
				n),
			revTokens));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$argParser = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$argParser$);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$isCommentChar = function (c) {
	return c === '/';
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$inlineComment = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _List_fromArray(
			[
				_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment, b)
			]);
	},
	$elm$parser$Parser$getChompedString(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile$(
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak),
			$elm$parser$Parser$symbol('//'))));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$lineBreakList = A2(
	$elm$parser$Parser$map,
	function (_v0) {
		return _List_fromArray(
			[
				_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak, '\u000A')
			]);
	},
	$elm$parser$Parser$symbol('\u000A'));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$multilineComment = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(
	{
		defaultMap: function (b) {
			return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment, b);
		},
		end: '*/',
		innerParsers: _List_fromArray(
			[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$lineBreakList]),
		isNestable: false,
		isNotRelevant: function (c) {
			return !$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c);
		},
		start: '/*'
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$comment = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$inlineComment, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$multilineComment]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$whitespaceOrCommentStep = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isSpace))),
				A2(
				$elm$parser$Parser$map,
				function (ns) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(ns, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$lineBreakList),
				A2(
				$elm$parser$Parser$map,
				function (ns) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(ns, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$comment)
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$argLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$argParser(revTokens),
					$elm$parser$Parser$getChompedString(
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
							function (c) {
								return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$isCommentChar(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c) || ((c === ',') || (c === ')'))));
							})))),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
						function (c) {
							return (c === '/') || (c === ',');
						}))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$functionDeclarationLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5),
								b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$isIdentifierNameChar))),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					function (_v0) {
						return $elm$parser$Parser$loop$(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, '('),
								revTokens),
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$argLoop);
					},
					$elm$parser$Parser$symbol('('))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$declarationKeywords = $elm$core$Set$fromList(
	_List_fromArray(
		['func', 'type', 'var', 'const', 'import']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$isDeclarationKeyword = function (str) {
	return $elm$core$Set$member$(str, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$declarationKeywords);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$keywords = $elm$core$Set$fromList(
	_List_fromArray(
		['break', 'case', 'chan', 'continue', 'default', 'defer', 'else', 'fallthrough', 'for', 'go', 'goto', 'if', 'interface', 'map', 'range', 'return', 'select', 'struct', 'switch']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$isKeyword = function (str) {
	return $elm$core$Set$member$(str, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$keywords);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$literalKeywordSet = $elm$core$Set$fromList(
	_List_fromArray(
		['true', 'false', 'nil']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$isLiteralKeyword = function (str) {
	return $elm$core$Set$member$(str, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$literalKeywordSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$isPackage = function (str) {
	return str === 'package';
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$keywordParser$ = function (revTokens, n) {
	return (n === 'func') ? $elm$parser$Parser$loop$(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3),
				n),
			revTokens),
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$functionDeclarationLoop) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$isType(n) ? $elm$parser$Parser$succeed(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
				n),
			revTokens)) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$isPackage(n) ? $elm$parser$Parser$succeed(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(7),
				n),
			revTokens)) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$isKeyword(n) ? $elm$parser$Parser$succeed(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(2),
				n),
			revTokens)) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$isDeclarationKeyword(n) ? $elm$parser$Parser$succeed(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3),
				n),
			revTokens)) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$isLiteralKeyword(n) ? $elm$parser$Parser$succeed(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6),
				n),
			revTokens)) : $elm$parser$Parser$succeed(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, n),
			revTokens)))))));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$keywordParser = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$keywordParser$);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$Number = 0;
var $elm$core$Char$isHexDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return ((48 <= code) && (code <= 57)) || (((65 <= code) && (code <= 70)) || ((97 <= code) && (code <= 102)));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$hexNumber = A2(
	$elm$parser$Parser$ignorer,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed(0),
		$elm$parser$Parser$backtrackable(
			$elm$parser$Parser$symbol('0x'))),
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($elm$core$Char$isHexDigit));
var $elm$parser$Parser$ExpectingFloat = {$: 5};
var $elm$parser$Parser$Advanced$consumeBase = _Parser_consumeBase;
var $elm$parser$Parser$Advanced$consumeBase16 = _Parser_consumeBase16;
var $elm$parser$Parser$Advanced$bumpOffset$ = function (newOffset, s) {
	return {col: s.col + (newOffset - s.offset), context: s.context, indent: s.indent, offset: newOffset, row: s.row, src: s.src};
};
var $elm$parser$Parser$Advanced$bumpOffset = F2($elm$parser$Parser$Advanced$bumpOffset$);
var $elm$parser$Parser$Advanced$chompBase10 = _Parser_chompBase10;
var $elm$parser$Parser$Advanced$isAsciiCode = _Parser_isAsciiCode;
var $elm$parser$Parser$Advanced$consumeExp$ = function (offset, src) {
	if (A3($elm$parser$Parser$Advanced$isAsciiCode, 101, offset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 69, offset, src)) {
		var eOffset = offset + 1;
		var expOffset = (A3($elm$parser$Parser$Advanced$isAsciiCode, 43, eOffset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 45, eOffset, src)) ? (eOffset + 1) : eOffset;
		var newOffset = A2($elm$parser$Parser$Advanced$chompBase10, expOffset, src);
		return _Utils_eq(expOffset, newOffset) ? (-newOffset) : newOffset;
	} else {
		return offset;
	}
};
var $elm$parser$Parser$Advanced$consumeExp = F2($elm$parser$Parser$Advanced$consumeExp$);
var $elm$parser$Parser$Advanced$consumeDotAndExp$ = function (offset, src) {
	return A3($elm$parser$Parser$Advanced$isAsciiCode, 46, offset, src) ? $elm$parser$Parser$Advanced$consumeExp$(
		A2($elm$parser$Parser$Advanced$chompBase10, offset + 1, src),
		src) : $elm$parser$Parser$Advanced$consumeExp$(offset, src);
};
var $elm$parser$Parser$Advanced$consumeDotAndExp = F2($elm$parser$Parser$Advanced$consumeDotAndExp$);
var $elm$parser$Parser$Advanced$finalizeInt$ = function (invalid, handler, startOffset, _v0, s) {
	var endOffset = _v0.a;
	var n = _v0.b;
	if (handler.$ === 1) {
		var x = handler.a;
		return $elm$parser$Parser$Advanced$Bad$(
			true,
			$elm$parser$Parser$Advanced$fromState$(s, x));
	} else {
		var toValue = handler.a;
		return _Utils_eq(startOffset, endOffset) ? $elm$parser$Parser$Advanced$Bad$(
			_Utils_cmp(s.offset, startOffset) < 0,
			$elm$parser$Parser$Advanced$fromState$(s, invalid)) : $elm$parser$Parser$Advanced$Good$(
			true,
			toValue(n),
			$elm$parser$Parser$Advanced$bumpOffset$(endOffset, s));
	}
};
var $elm$parser$Parser$Advanced$finalizeInt = F5($elm$parser$Parser$Advanced$finalizeInt$);
var $elm$parser$Parser$Advanced$fromInfo$ = function (row, col, x, context) {
	return $elm$parser$Parser$Advanced$AddRight$(
		$elm$parser$Parser$Advanced$Empty,
		$elm$parser$Parser$Advanced$DeadEnd$(row, col, x, context));
};
var $elm$parser$Parser$Advanced$fromInfo = F4($elm$parser$Parser$Advanced$fromInfo$);
var $elm$parser$Parser$Advanced$finalizeFloat$ = function (invalid, expecting, intSettings, floatSettings, intPair, s) {
	var intOffset = intPair.a;
	var floatOffset = $elm$parser$Parser$Advanced$consumeDotAndExp$(intOffset, s.src);
	if (floatOffset < 0) {
		return $elm$parser$Parser$Advanced$Bad$(
			true,
			$elm$parser$Parser$Advanced$fromInfo$(s.row, s.col - (floatOffset + s.offset), invalid, s.context));
	} else {
		if (_Utils_eq(s.offset, floatOffset)) {
			return $elm$parser$Parser$Advanced$Bad$(
				false,
				$elm$parser$Parser$Advanced$fromState$(s, expecting));
		} else {
			if (_Utils_eq(intOffset, floatOffset)) {
				return $elm$parser$Parser$Advanced$finalizeInt$(invalid, intSettings, s.offset, intPair, s);
			} else {
				if (floatSettings.$ === 1) {
					var x = floatSettings.a;
					return $elm$parser$Parser$Advanced$Bad$(
						true,
						$elm$parser$Parser$Advanced$fromState$(s, invalid));
				} else {
					var toValue = floatSettings.a;
					var _v1 = $elm$core$String$toFloat(
						A3($elm$core$String$slice, s.offset, floatOffset, s.src));
					if (_v1.$ === 1) {
						return $elm$parser$Parser$Advanced$Bad$(
							true,
							$elm$parser$Parser$Advanced$fromState$(s, invalid));
					} else {
						var n = _v1.a;
						return $elm$parser$Parser$Advanced$Good$(
							true,
							toValue(n),
							$elm$parser$Parser$Advanced$bumpOffset$(floatOffset, s));
					}
				}
			}
		}
	}
};
var $elm$parser$Parser$Advanced$finalizeFloat = F6($elm$parser$Parser$Advanced$finalizeFloat$);
var $elm$parser$Parser$Advanced$number = function (c) {
	return function (s) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 48, s.offset, s.src)) {
			var zeroOffset = s.offset + 1;
			var baseOffset = zeroOffset + 1;
			return A3($elm$parser$Parser$Advanced$isAsciiCode, 120, zeroOffset, s.src) ? $elm$parser$Parser$Advanced$finalizeInt$(
				c.invalid,
				c.hex,
				baseOffset,
				A2($elm$parser$Parser$Advanced$consumeBase16, baseOffset, s.src),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 111, zeroOffset, s.src) ? $elm$parser$Parser$Advanced$finalizeInt$(
				c.invalid,
				c.octal,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 8, baseOffset, s.src),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 98, zeroOffset, s.src) ? $elm$parser$Parser$Advanced$finalizeInt$(
				c.invalid,
				c.binary,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 2, baseOffset, s.src),
				s) : $elm$parser$Parser$Advanced$finalizeFloat$(
				c.invalid,
				c.expecting,
				c._int,
				c._float,
				_Utils_Tuple2(zeroOffset, 0),
				s)));
		} else {
			return $elm$parser$Parser$Advanced$finalizeFloat$(
				c.invalid,
				c.expecting,
				c._int,
				c._float,
				A3($elm$parser$Parser$Advanced$consumeBase, 10, s.offset, s.src),
				s);
		}
	};
};
var $elm$parser$Parser$Advanced$float$ = function (expecting, invalid) {
	return $elm$parser$Parser$Advanced$number(
		{
			binary: $elm$core$Result$Err(invalid),
			expecting: expecting,
			_float: $elm$core$Result$Ok($elm$core$Basics$identity),
			hex: $elm$core$Result$Err(invalid),
			_int: $elm$core$Result$Ok($elm$core$Basics$toFloat),
			invalid: invalid,
			octal: $elm$core$Result$Err(invalid)
		});
};
var $elm$parser$Parser$Advanced$float = F2($elm$parser$Parser$Advanced$float$);
var $elm$parser$Parser$float = $elm$parser$Parser$Advanced$float$($elm$parser$Parser$ExpectingFloat, $elm$parser$Parser$ExpectingFloat);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$positiveNumberExponentialNotation = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(0),
	$elm$parser$Parser$backtrackable($elm$parser$Parser$float));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$negativeNumberExponentialNotation = A2(
	$elm$parser$Parser$ignorer,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed(0),
		$elm$parser$Parser$backtrackable(
			$elm$parser$Parser$symbol('-'))),
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$positiveNumberExponentialNotation);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$numberExponentialNotation = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$positiveNumberExponentialNotation, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$negativeNumberExponentialNotation, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$number]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$number = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(0),
			b);
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$hexNumber, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$number, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$numberExponentialNotation]))));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$Operator = 8;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$operatorSet = $elm$core$Set$fromList(
	_List_fromArray(
		['+', '-', '*', '/', '%', '&', '|', '^', '<', '>', '=', '!', ':', '.']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$isOperator = function (c) {
	return $elm$core$Set$member$(c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$operatorSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$operatorChar = A2(
	$elm$parser$Parser$map,
	function (s) {
		return _Utils_Tuple2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(8),
			s);
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$isOperator)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$String = 1;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$doubleQuoteString = function () {
	var delimiter = {
		defaultMap: function (b) {
			return _Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(1),
				b);
		},
		end: '\u0022',
		innerParsers: _List_Nil,
		isNestable: false,
		isNotRelevant: function (c) {
			return !(c === '"');
		},
		start: '\u0022'
	};
	return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(delimiter);
}();
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$rawString = function () {
	var delimiter = {
		defaultMap: function (b) {
			return _Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(1),
				b);
		},
		end: '`',
		innerParsers: _List_Nil,
		isNestable: false,
		isNotRelevant: function (_v0) {
			return true;
		},
		start: '`'
	};
	return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(delimiter);
}();
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$singleQuoteString = function () {
	var delimiter = {
		defaultMap: function (b) {
			return _Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(1),
				b);
		},
		end: '\u0027',
		innerParsers: _List_Nil,
		isNestable: false,
		isNotRelevant: function (c) {
			return !(c === '"');
		},
		start: '\u0027'
	};
	return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(delimiter);
}();
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$stringLiteral = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$rawString, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$doubleQuoteString, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$singleQuoteString]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$mainLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (s) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(s, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$stringLiteral),
				A2(
				$elm$parser$Parser$map,
				function (s) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, s, revTokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$operatorChar, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$groupChar, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$number]))),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$keywordParser(revTokens),
					$elm$parser$Parser$getChompedString(
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$isIdentifierNameChar)))),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					function (str) {
						return $elm$parser$Parser$succeed(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, str),
								revTokens));
					},
					$elm$parser$Parser$getChompedString(
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
							A2($elm$core$Basics$composeR, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak, $elm$core$Basics$not))))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$toRevTokens = $elm$parser$Parser$loop$(_List_Nil, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$mainLoop);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$toLines = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$toRevTokens),
	$elm$core$Result$map(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLines($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$syntaxToStyle)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$go = A2(
	$elm$core$Basics$composeR,
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Go$toLines,
	$elm$core$Result$map($elm$core$Basics$identity));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$syntaxToStyle = function (syntax) {
	switch (syntax) {
		case 0:
			return _Utils_Tuple2(2, 'js-n');
		case 1:
			return _Utils_Tuple2(3, 'js-s');
		case 2:
			return _Utils_Tuple2(4, 'js-k');
		case 3:
			return _Utils_Tuple2(5, 'js-dk');
		case 4:
			return _Utils_Tuple2(5, 'js-fe');
		case 5:
			return _Utils_Tuple2(6, 'js-f');
		case 6:
			return _Utils_Tuple2(7, 'js-lk');
		case 7:
			return _Utils_Tuple2(8, 'js-p');
		default:
			return _Utils_Tuple2(6, 'js-ce');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$groupSet = $elm$core$Set$fromList(
	_List_fromArray(
		['{', '}', '(', ')', '[', ']', ',', ';']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isGroupChar = function (c) {
	return $elm$core$Set$member$(c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$groupSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$groupChar = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
	},
	$elm$parser$Parser$getChompedString(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isGroupChar)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isCommentChar = function (c) {
	return c === '/';
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$operatorSet = $elm$core$Set$fromList(
	_List_fromArray(
		['+', '-', '*', '/', '=', '!', '<', '>', '&', '|', '?', '^', ':', '~', '%', '.']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$punctuactorSet = $elm$core$Set$union$($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$operatorSet, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$groupSet);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isPunctuaction = function (c) {
	return $elm$core$Set$member$(c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$punctuactorSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isStringLiteralChar = function (c) {
	return (c === '"') || ((c === '\'') || (c === '`'));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isIdentifierNameChar = function (c) {
	return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isPunctuaction(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isStringLiteralChar(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isCommentChar(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c))));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$DeclarationKeyword = 3;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$Function = 5;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$Keyword = 2;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$LiteralKeyword = 6;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$Param = 7;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$ClassExtends = 8;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$inlineComment = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _List_fromArray(
			[
				_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment, b)
			]);
	},
	$elm$parser$Parser$getChompedString(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile$(
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak),
			$elm$parser$Parser$symbol('//'))));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$lineBreakList = A2(
	$elm$parser$Parser$map,
	function (_v0) {
		return _List_fromArray(
			[
				_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak, '\u000A')
			]);
	},
	$elm$parser$Parser$symbol('\u000A'));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$multilineComment = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(
	{
		defaultMap: function (b) {
			return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment, b);
		},
		end: '*/',
		innerParsers: _List_fromArray(
			[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$lineBreakList]),
		isNestable: false,
		isNotRelevant: function (c) {
			return !$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c);
		},
		start: '/*'
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$comment = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$inlineComment, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$multilineComment]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isSpace))),
				A2(
				$elm$parser$Parser$map,
				function (ns) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(ns, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$lineBreakList),
				A2(
				$elm$parser$Parser$map,
				function (ns) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(ns, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$comment)
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$classExtendsLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(8),
								b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isIdentifierNameChar))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$classDeclarationLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$andThen,
				function (n) {
					return (n === 'extends') ? A2(
						$elm$parser$Parser$map,
						$elm$parser$Parser$Loop,
						$elm$parser$Parser$loop$(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(2),
									n),
								revTokens),
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$classExtendsLoop)) : $elm$parser$Parser$succeed(
						$elm$parser$Parser$Loop(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5),
									n),
								revTokens)));
				},
				$elm$parser$Parser$getChompedString(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isIdentifierNameChar))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$argLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(7),
								b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
						function (c) {
							return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isCommentChar(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c) || ((c === ',') || (c === ')'))));
						}))),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
						function (c) {
							return (c === '/') || (c === ',');
						}))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$functionDeclarationLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5),
								b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isIdentifierNameChar))),
				A2(
				$elm$parser$Parser$map,
				function (_v0) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(2),
								'*'),
							revTokens));
				},
				$elm$parser$Parser$symbol('*')),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					function (_v1) {
						return $elm$parser$Parser$loop$(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, '('),
								revTokens),
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$argLoop);
					},
					$elm$parser$Parser$symbol('('))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$FunctionEval = 4;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$functionEvalLoop$ = function (identifier, revTokens, thisRevToken) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(thisRevToken),
				A2(
				$elm$parser$Parser$map,
				function (_v0) {
					return $elm$parser$Parser$Done(
						_Utils_ap(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, '('),
								thisRevToken),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
									identifier),
								revTokens)));
				},
				$elm$parser$Parser$symbol('(')),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(
					_Utils_ap(
						thisRevToken,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, identifier),
							revTokens))))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$functionEvalLoop = F3($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$functionEvalLoop$);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$declarationKeywordSet = $elm$core$Set$fromList(
	_List_fromArray(
		['var', 'const', 'let']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isDeclarationKeyword = function (str) {
	return $elm$core$Set$member$(str, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$declarationKeywordSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$keywordSet = $elm$core$Set$fromList(
	_List_fromArray(
		['break', 'do', 'instanceof', 'typeof', 'case', 'else', 'new', 'catch', 'finally', 'return', 'void', 'continue', 'for', 'switch', 'while', 'debugger', 'this', 'with', 'default', 'if', 'throw', 'delete', 'in', 'try', 'enum', 'extends', 'export', 'import', 'implements', 'private', 'public', 'yield', 'interface', 'package', 'protected']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isKeyword = function (str) {
	return $elm$core$Set$member$(str, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$keywordSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$literalKeywordSet = $elm$core$Set$fromList(
	_List_fromArray(
		['true', 'false', 'null', 'undefined', 'NaN', 'Infinity']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isLiteralKeyword = function (str) {
	return $elm$core$Set$member$(str, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$literalKeywordSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$keywordParser$ = function (revTokens, n) {
	return ((n === 'function') || (n === 'static')) ? $elm$parser$Parser$loop$(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3),
				n),
			revTokens),
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$functionDeclarationLoop) : ((n === 'class') ? $elm$parser$Parser$loop$(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3),
				n),
			revTokens),
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$classDeclarationLoop) : (((n === 'this') || (n === 'super')) ? $elm$parser$Parser$succeed(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(7),
				n),
			revTokens)) : ((n === 'constructor') ? $elm$parser$Parser$loop$(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5),
				n),
			revTokens),
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$functionDeclarationLoop) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isKeyword(n) ? $elm$parser$Parser$succeed(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(2),
				n),
			revTokens)) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isDeclarationKeyword(n) ? $elm$parser$Parser$succeed(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3),
				n),
			revTokens)) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isLiteralKeyword(n) ? $elm$parser$Parser$succeed(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6),
				n),
			revTokens)) : $elm$parser$Parser$loop$(
		_List_Nil,
		A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$functionEvalLoop, n, revTokens))))))));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$keywordParser = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$keywordParser$);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$Number = 0;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$number = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(0),
			b);
	},
	$elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$number));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isOperatorChar = function (c) {
	return $elm$core$Set$member$(c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$operatorSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$operatorChar = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(2),
			b);
	},
	$elm$parser$Parser$getChompedString(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isOperatorChar)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$String = 1;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$jsEscapable = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6),
				b)
			]);
	},
	$elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$escapable));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$quoteDelimiter = {
	defaultMap: function (b) {
		return _Utils_Tuple2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(1),
			b);
	},
	end: '\u0027',
	innerParsers: _List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$lineBreakList, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$jsEscapable]),
	isNestable: false,
	isNotRelevant: function (c) {
		return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapable(c));
	},
	start: '\u0027'
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$doubleQuote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(
	_Utils_update(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$quoteDelimiter,
		{end: '\u0022', start: '\u0022'}));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$quote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$quoteDelimiter);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$templateString = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(
	_Utils_update(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$quoteDelimiter,
		{
			end: '`',
			innerParsers: _List_fromArray(
				[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$lineBreakList, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$jsEscapable]),
			isNotRelevant: function (c) {
				return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapable(c));
			},
			start: '`'
		}));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$stringLiteral = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$quote, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$doubleQuote, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$templateString]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$mainLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (s) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(s, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$stringLiteral),
				A2(
				$elm$parser$Parser$map,
				function (s) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, s, revTokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$operatorChar, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$groupChar, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$number]))),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$keywordParser(revTokens),
					$elm$parser$Parser$getChompedString(
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$isIdentifierNameChar)))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$toRevTokens = $elm$parser$Parser$loop$(_List_Nil, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$mainLoop);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$toLines = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$toRevTokens),
	$elm$core$Result$map(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLines($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$syntaxToStyle)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$javascript = A2(
	$elm$core$Basics$composeR,
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$toLines,
	$elm$core$Result$map($elm$core$Basics$identity));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$syntaxToStyle = function (syntax) {
	switch (syntax) {
		case 0:
			return _Utils_Tuple2(3, 'json-s');
		case 1:
			return _Utils_Tuple2(2, 'json-e');
		case 2:
			return _Utils_Tuple2(2, 'json-n');
		case 3:
			return _Utils_Tuple2(4, 'json-b');
		case 4:
			return _Utils_Tuple2(4, 'json-null');
		case 5:
			return _Utils_Tuple2(5, 'json-k');
		case 6:
			return _Utils_Tuple2(0, 'json-o');
		default:
			return _Utils_Tuple2(0, 'json-a');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$Array = 7;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$Boolean = 3;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$Null = 4;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$Object = 6;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$ObjectKey = 5;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$String = 0;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$Number = 2;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$number = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(2),
			b);
	},
	$elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$numberExponentialNotation));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$lineBreak = A2(
	$elm$parser$Parser$map,
	function (_v0) {
		return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak, '\u000A');
	},
	$elm$parser$Parser$symbol('\u000A'));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$Escapable = 1;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$escapableSet = $elm$core$Set$fromList(
	_List_fromArray(
		['"', '\\', '/', 'b', 'f', 'n', 'r', 't', 'u']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$isEscapableChar = function (c) {
	return $elm$core$Set$member$(c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$escapableSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$escapable = A2(
	$elm$parser$Parser$ignorer,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed(0),
		$elm$parser$Parser$backtrackable(
			$elm$parser$Parser$symbol('\u005C'))),
	$elm$parser$Parser$chompIf($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$isEscapableChar));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$stringEscapable = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(1),
				b)
			]);
	},
	$elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$escapable));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$doubleQuoteDelimiter = function (syntax_) {
	return {
		defaultMap: function (b) {
			return _Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(syntax_),
				b);
		},
		end: '\u0022',
		innerParsers: _List_fromArray(
			[
				A2($elm$parser$Parser$map, $elm$core$List$singleton, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$lineBreak),
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$stringEscapable
			]),
		isNestable: false,
		isNotRelevant: function (c) {
			return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapable(c));
		},
		start: '\u0022'
	};
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$stringLiteral$ = function (syntax_, revTokens) {
	return A2(
		$elm$parser$Parser$map,
		function (n) {
			return _Utils_ap(n, revTokens);
		},
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$doubleQuoteDelimiter(syntax_)));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$stringLiteral = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$stringLiteral$);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$space = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
	},
	$elm$parser$Parser$getChompedString(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isSpace)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$whitespace = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$space, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$lineBreak]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$arrayLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$whitespace),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				A2(
					$elm$parser$Parser$map,
					function (_v4) {
						return _Utils_Tuple2(
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(7),
							',');
					},
					$elm$parser$Parser$symbol(','))),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Done(
						A2($elm$core$List$cons, n, revTokens));
				},
				A2(
					$elm$parser$Parser$map,
					function (_v5) {
						return _Utils_Tuple2(
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(7),
							']');
					},
					$elm$parser$Parser$symbol(']'))),
				A2(
				$elm$parser$Parser$map,
				function (ns) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(ns, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$cyclic$value()),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$objectLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$whitespace),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$stringLiteral$(5, revTokens)),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					function (_v0) {
						var revTokens_ = A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6),
								':'),
							revTokens);
						return A2(
							$elm$parser$Parser$map,
							function (ns) {
								return _Utils_ap(ns, revTokens_);
							},
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$andThen,
										function (ws) {
											return $elm$parser$Parser$oneOf(
												_List_fromArray(
													[
														A2(
														$elm$parser$Parser$map,
														function (v) {
															return _Utils_ap(
																v,
																_List_fromArray(
																	[ws]));
														},
														$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$cyclic$value()),
														$elm$parser$Parser$succeed(
														_List_fromArray(
															[ws]))
													]));
										},
										$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$whitespace),
										$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$cyclic$value(),
										$elm$parser$Parser$succeed(_List_Nil)
									])));
					},
					$elm$parser$Parser$symbol(':'))),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				A2(
					$elm$parser$Parser$map,
					function (_v1) {
						return _Utils_Tuple2(
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6),
							',');
					},
					$elm$parser$Parser$symbol(','))),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Done(
						A2($elm$core$List$cons, n, revTokens));
				},
				A2(
					$elm$parser$Parser$map,
					function (_v2) {
						return _Utils_Tuple2(
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6),
							'}');
					},
					$elm$parser$Parser$symbol('}'))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
function $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$cyclic$value() {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$stringLiteral$(0, _List_Nil),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return _List_fromArray(
						[n]);
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$number),
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$cyclic$object(),
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$cyclic$array(),
				A2(
				$elm$parser$Parser$map,
				function (s) {
					return _List_fromArray(
						[
							_Utils_Tuple2(
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
							s)
						]);
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$keyword('null'))),
				A2(
				$elm$parser$Parser$map,
				function (s) {
					return _List_fromArray(
						[
							_Utils_Tuple2(
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3),
							s)
						]);
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$keyword('true'),
								$elm$parser$Parser$keyword('false')
							]))))
			]));
}
function $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$cyclic$array() {
	return A2(
		$elm$parser$Parser$andThen,
		function (_v6) {
			return $elm$parser$Parser$loop$(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(7),
						'[')
					]),
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$arrayLoop);
		},
		$elm$parser$Parser$symbol('['));
}
function $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$cyclic$object() {
	return A2(
		$elm$parser$Parser$andThen,
		function (_v3) {
			return $elm$parser$Parser$loop$(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6),
						'{')
					]),
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$objectLoop);
		},
		$elm$parser$Parser$symbol('{'));
}
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$value = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$cyclic$value();
$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$cyclic$value = function () {
	return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$value;
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$array = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$cyclic$array();
$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$cyclic$array = function () {
	return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$array;
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$object = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$cyclic$object();
$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$cyclic$object = function () {
	return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$object;
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$mainLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$whitespace),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$object),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$always(true)))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$toRevTokens = $elm$parser$Parser$loop$(_List_Nil, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$mainLoop);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$toLines = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$toRevTokens),
	$elm$core$Result$map(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLines($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$syntaxToStyle)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$json = A2(
	$elm$core$Basics$composeR,
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Json$toLines,
	$elm$core$Result$map($elm$core$Basics$identity));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$syntaxToStyle = function (syntax) {
	switch (syntax) {
		case 0:
			return _Utils_Tuple2(2, 'kt-n');
		case 1:
			return _Utils_Tuple2(3, 'kt-s');
		case 5:
			return _Utils_Tuple2(4, 'kt-dk');
		case 2:
			return _Utils_Tuple2(4, 'kt-k');
		case 3:
			return _Utils_Tuple2(5, 'kt-o');
		case 4:
			return _Utils_Tuple2(6, 'kt-f');
		case 7:
			return _Utils_Tuple2(7, 'kt-pu');
		case 8:
			return _Utils_Tuple2(8, 'kt-l');
		default:
			return _Utils_Tuple2(8, 'kt-pa');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$inlineComment = $elm$parser$Parser$oneOf(
	$elm$core$List$map$(
		A2(
			$elm$core$Basics$composeR,
			$elm$parser$Parser$symbol,
			A2(
				$elm$core$Basics$composeR,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile(
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak)),
				A2(
					$elm$core$Basics$composeR,
					$elm$parser$Parser$getChompedString,
					$elm$parser$Parser$map(
						function (b) {
							return _List_fromArray(
								[
									_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment, b)
								]);
						})))),
		_List_fromArray(
			['//'])));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$lineBreakList = A2(
	$elm$parser$Parser$map,
	function (_v0) {
		return _List_fromArray(
			[
				_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak, '\u000A')
			]);
	},
	$elm$parser$Parser$symbol('\u000A'));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$multilineComment = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(
	{
		defaultMap: function (b) {
			return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment, b);
		},
		end: '*/',
		innerParsers: _List_fromArray(
			[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$lineBreakList]),
		isNestable: false,
		isNotRelevant: A2($elm$core$Basics$composeL, $elm$core$Basics$not, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak),
		start: '/*'
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$comment = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$inlineComment, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$multilineComment]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$punctuatorSet = $elm$core$Set$fromList(
	_List_fromArray(
		['{', '}', '(', ')', '[', ']', '.', ',', ':', ';']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$isPunctuationChar = function (c) {
	return $elm$core$Set$member$(c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$punctuatorSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$isIdentifierChar = function (c) {
	return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$isPunctuationChar(c));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$DeclarationKeyword = 5;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$Keyword = 2;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$Literal = 8;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$Operator = 3;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$Function = 4;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$isCommentChar = function (c) {
	return c === '/';
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$isStringLiteralChar = function (c) {
	return (c === '\'') || (c === '"');
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$isIdentifierNameChar = function (c) {
	return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$isPunctuationChar(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$isStringLiteralChar(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$isCommentChar(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c))));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$lineBreak = A2(
	$elm$parser$Parser$map,
	function (_v0) {
		return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak, '\u000A');
	},
	$elm$parser$Parser$symbol('\u000A'));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$space = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
	},
	$elm$parser$Parser$getChompedString(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isSpace)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$checkContext = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$whitespaceOrCommentStep(revTokens),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$whitespaceOrCommentStep = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				function (s) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, s, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$space),
				A2(
				$elm$parser$Parser$andThen,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$checkContext,
				A2(
					$elm$parser$Parser$map,
					function (s) {
						return A2($elm$core$List$cons, s, revTokens);
					},
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$lineBreak)),
				A2(
				$elm$parser$Parser$map,
				function (s) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(s, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$comment)
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$functionDeclarationLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
								b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$isIdentifierNameChar))),
				A2(
				$elm$parser$Parser$map,
				function (_v0) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(2),
								'*'),
							revTokens));
				},
				$elm$parser$Parser$symbol('*')),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$declarationKeywordSet = $elm$core$Set$fromList(
	_List_fromArray(
		['var', 'val', 'vararg']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$isDeclarationKeyword = function (str) {
	return $elm$core$Set$member$(str, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$declarationKeywordSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$isFunction = $elm$core$Basics$eq('fun');
var $elm$regex$Regex$contains = _Regex_contains;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$keywordPattern = $elm$core$Maybe$withDefault$(
	$elm$regex$Regex$never,
	A2(
		$elm$regex$Regex$fromStringWith,
		{caseInsensitive: false, multiline: false},
		'^(actual|abstract|annotation|break|by|catch|class|companion|const|constructor|continue|coroutine|crossinline|data|delegate|dynamic|do|else|enum|expect|external|final|finally|for|fun|get|if|import|infix|inline|interface|internal|lazy|lateinit|native|object|open|operator|out|override|package|private|protected|public|reified|return|sealed|set|super|suspend|tailrec|this|throw|try|typealias|typeof|when|while|yield)$'));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$isKeyword = $elm$regex$Regex$contains($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$keywordPattern);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$literalSet = $elm$core$Set$fromList(
	_List_fromArray(
		['false', 'true', 'null']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$isLiteral = function (str) {
	return $elm$core$Set$member$(str, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$literalSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$operatorPattern = $elm$core$Maybe$withDefault$(
	$elm$regex$Regex$never,
	A2(
		$elm$regex$Regex$fromStringWith,
		{caseInsensitive: false, multiline: false},
		'^([=!<>\u005C+]=?|\u005C+|\u005C|\u005C||&&|as\u005C??|!?in|!?is)$'));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$isOperator = $elm$regex$Regex$contains($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$operatorPattern);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$keywordParser$ = function (revTokens, s) {
	return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$isOperator(s) ? $elm$parser$Parser$succeed(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3),
				s),
			revTokens)) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$isFunction(s) ? $elm$parser$Parser$loop$(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5),
				s),
			revTokens),
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$functionDeclarationLoop) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$isKeyword(s) ? $elm$parser$Parser$succeed(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(2),
				s),
			revTokens)) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$isLiteral(s) ? $elm$parser$Parser$succeed(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(8),
				s),
			revTokens)) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$isDeclarationKeyword(s) ? $elm$parser$Parser$succeed(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5),
				s),
			revTokens)) : $elm$parser$Parser$succeed(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, s),
			revTokens))))));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$keywordParser = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$keywordParser$);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$Number = 0;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$hexNumber = A2(
	$elm$parser$Parser$ignorer,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed(0),
		$elm$parser$Parser$backtrackable(
			$elm$parser$Parser$symbol('0x'))),
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($elm$core$Char$isHexDigit));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$number = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(0),
			b);
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$hexNumber, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$number]))));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$Punctuation = 7;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$punctuationChar = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(7),
			b);
	},
	$elm$parser$Parser$getChompedString(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$isPunctuationChar)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$String = 1;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$ktEscapable = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
				b)
			]);
	},
	$elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$escapable));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$quoteDelimiter = {
	defaultMap: function (b) {
		return _Utils_Tuple2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(1),
			b);
	},
	end: '\u0027',
	innerParsers: _List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$lineBreakList, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$ktEscapable]),
	isNestable: false,
	isNotRelevant: function (c) {
		return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapable(c));
	},
	start: '\u0027'
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$doubleQuote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(
	_Utils_update(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$quoteDelimiter,
		{end: '\u0022', start: '\u0022'}));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$multilineString = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(
	_Utils_update(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$quoteDelimiter,
		{end: '\u0022\u0022\u0022', start: '\u0022\u0022\u0022'}));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$quote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$quoteDelimiter);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$stringLiteral = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$multilineString, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$quote, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$doubleQuote]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$stringBody = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (s) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(s, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$stringLiteral),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$mainLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$space),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$lineBreak),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$punctuationChar),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$number),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$comment),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					function (n) {
						return $elm$parser$Parser$loop$(
							_Utils_ap(n, revTokens),
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$stringBody);
					},
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$stringLiteral)),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$keywordParser(revTokens),
					$elm$parser$Parser$getChompedString(
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$isIdentifierChar)))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$toRevTokens = $elm$parser$Parser$loop$(_List_Nil, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$mainLoop);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$toLines = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$toRevTokens),
	$elm$core$Result$map(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLines($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$syntaxToStyle)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$kotlin = A2(
	$elm$core$Basics$composeR,
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Kotlin$toLines,
	$elm$core$Result$map($elm$core$Basics$identity));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$syntaxToStyle = function (syntax) {
	switch (syntax) {
		case 0:
			return _Utils_Tuple2(2, 'nix-n');
		case 1:
			return _Utils_Tuple2(3, 'nix-s');
		case 2:
			return _Utils_Tuple2(4, 'nix-k');
		case 3:
			return _Utils_Tuple2(5, 'nix-o');
		case 4:
			return _Utils_Tuple2(6, 'nix-f');
		case 5:
			return _Utils_Tuple2(7, 'nix-p');
		default:
			return _Utils_Tuple2(8, 'nix-l');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$inlineComment = $elm$parser$Parser$oneOf(
	$elm$core$List$map$(
		A2(
			$elm$core$Basics$composeR,
			$elm$parser$Parser$symbol,
			A2(
				$elm$core$Basics$composeR,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile(
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak)),
				A2(
					$elm$core$Basics$composeR,
					$elm$parser$Parser$getChompedString,
					$elm$parser$Parser$map(
						function (b) {
							return _List_fromArray(
								[
									_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment, b)
								]);
						})))),
		_List_fromArray(
			['#'])));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$lineBreakList = A2(
	$elm$parser$Parser$map,
	function (_v0) {
		return _List_fromArray(
			[
				_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak, '\u000A')
			]);
	},
	$elm$parser$Parser$symbol('\u000A'));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$multilineComment = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(
	{
		defaultMap: function (b) {
			return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment, b);
		},
		end: '*/',
		innerParsers: _List_fromArray(
			[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$lineBreakList]),
		isNestable: false,
		isNotRelevant: A2($elm$core$Basics$composeL, $elm$core$Basics$not, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak),
		start: '/*'
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$comment = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$inlineComment, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$multilineComment]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$punctuatorSet = $elm$core$Set$fromList(
	_List_fromArray(
		['{', '}', '(', ')', '[', ']', '.', ',', ':', ';']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$isPunctuationChar = function (c) {
	return $elm$core$Set$member$(c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$punctuatorSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$isIdentifierChar = function (c) {
	return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$isPunctuationChar(c));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$Function = 4;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$Keyword = 2;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$Literal = 6;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$Operator = 3;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$functionPattern = $elm$core$Maybe$withDefault$(
	$elm$regex$Regex$never,
	A2(
		$elm$regex$Regex$fromStringWith,
		{caseInsensitive: false, multiline: false},
		'^(?:abort|add|all|any|attrNames|attrValues|baseNameOf|compareVersions|concatLists|currentSystem|deepSeq|derivation|dirOf|div|elem(?:At)?|fetch(?:Tarball|url)|filter(?:Source)?|fromJSON|genList|getAttr|getEnv|hasAttr|hashString|head|import|intersectAttrs|is(?:Attrs|Bool|Function|Int|List|Null|String)|length|lessThan|listToAttrs|map|mul|parseDrvName|pathExists|read(?:Dir|File)|removeAttrs|replaceStrings|seq|sort|stringLength|sub(?:string)?|tail|throw|to(?:File|JSON|Path|String|XML)|trace|typeOf)|foldl\u0027$'));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$isFunction = $elm$regex$Regex$contains($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$functionPattern);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$keywordPattern = $elm$core$Maybe$withDefault$(
	$elm$regex$Regex$never,
	A2(
		$elm$regex$Regex$fromStringWith,
		{caseInsensitive: false, multiline: false},
		'^(assert|builtins|else|if|in|inherit|let|null|or|then|with)$'));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$isKeyword = $elm$regex$Regex$contains($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$keywordPattern);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$literalSet = $elm$core$Set$fromList(
	_List_fromArray(
		['false', 'true']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$isLiteral = function (str) {
	return $elm$core$Set$member$(
		$elm$core$String$toUpper(str),
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$literalSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$operatorPattern = $elm$core$Maybe$withDefault$(
	$elm$regex$Regex$never,
	A2(
		$elm$regex$Regex$fromStringWith,
		{caseInsensitive: false, multiline: false},
		'^([=!<>]=?|\u005C+\u005C+?|\u005C|\u005C||&&|\u005C/\u005C/|->?|[?@])$'));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$isOperator = $elm$regex$Regex$contains($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$operatorPattern);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$keywordParser$ = function (revTokens, s) {
	return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$isOperator(s) ? $elm$parser$Parser$succeed(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3),
				s),
			revTokens)) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$isFunction(s) ? $elm$parser$Parser$succeed(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
				s),
			revTokens)) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$isKeyword(s) ? $elm$parser$Parser$succeed(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(2),
				s),
			revTokens)) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$isLiteral(s) ? $elm$parser$Parser$succeed(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6),
				s),
			revTokens)) : $elm$parser$Parser$succeed(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, s),
			revTokens)))));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$keywordParser = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$keywordParser$);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$lineBreak = A2(
	$elm$parser$Parser$map,
	function (_v0) {
		return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak, '\u000A');
	},
	$elm$parser$Parser$symbol('\u000A'));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$Number = 0;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$hexNumber = A2(
	$elm$parser$Parser$ignorer,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed(0),
		$elm$parser$Parser$backtrackable(
			$elm$parser$Parser$symbol('0x'))),
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($elm$core$Char$isHexDigit));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$number = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(0),
			b);
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$hexNumber, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$number]))));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$Punctuation = 5;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$punctuationChar = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5),
			b);
	},
	$elm$parser$Parser$getChompedString(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$isPunctuationChar)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$space = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
	},
	$elm$parser$Parser$getChompedString(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isSpace)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$String = 1;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$nixEscapable = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
				b)
			]);
	},
	$elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$escapable));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$quoteDelimiter = {
	defaultMap: function (b) {
		return _Utils_Tuple2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(1),
			b);
	},
	end: '\u0027',
	innerParsers: _List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$lineBreakList, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$nixEscapable]),
	isNestable: false,
	isNotRelevant: function (c) {
		return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapable(c));
	},
	start: '\u0027'
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$doubleQuote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(
	_Utils_update(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$quoteDelimiter,
		{end: '\u0022', start: '\u0022'}));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$multilineString = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(
	_Utils_update(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$quoteDelimiter,
		{end: '\u0027\u0027', start: '\u0027\u0027'}));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$quote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$quoteDelimiter);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$stringLiteral = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$multilineString, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$quote, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$doubleQuote]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$checkContext = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$whitespaceOrCommentStep(revTokens),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$whitespaceOrCommentStep = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				function (s) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, s, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$space),
				A2(
				$elm$parser$Parser$andThen,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$checkContext,
				A2(
					$elm$parser$Parser$map,
					function (s) {
						return A2($elm$core$List$cons, s, revTokens);
					},
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$lineBreak)),
				A2(
				$elm$parser$Parser$map,
				function (s) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(s, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$comment)
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$stringBody = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (s) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(s, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$stringLiteral),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$mainLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$space),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$lineBreak),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$punctuationChar),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$number),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$comment),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					function (n) {
						return $elm$parser$Parser$loop$(
							_Utils_ap(n, revTokens),
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$stringBody);
					},
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$stringLiteral)),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$keywordParser(revTokens),
					$elm$parser$Parser$getChompedString(
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$isIdentifierChar)))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$toRevTokens = $elm$parser$Parser$loop$(_List_Nil, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$mainLoop);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$toLines = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$toRevTokens),
	$elm$core$Result$map(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLines($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$syntaxToStyle)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$nix = A2(
	$elm$core$Basics$composeR,
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Nix$toLines,
	$elm$core$Result$map($elm$core$Basics$identity));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$syntaxToStyle = function (syntax) {
	switch (syntax) {
		case 0:
			return _Utils_Tuple2(2, 'py-n');
		case 1:
			return _Utils_Tuple2(3, 'py-s');
		case 2:
			return _Utils_Tuple2(4, 'py-k');
		case 3:
			return _Utils_Tuple2(5, 'py-dk');
		case 5:
			return _Utils_Tuple2(6, 'py-f');
		case 6:
			return _Utils_Tuple2(7, 'py-lk');
		case 7:
			return _Utils_Tuple2(8, 'py-p');
		default:
			return _Utils_Tuple2(0, 'py-fe');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$groupSet = $elm$core$Set$fromList(
	_List_fromArray(
		['{', '}', '(', ')', '[', ']', ',', ';']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isGroupChar = function (c) {
	return $elm$core$Set$member$(c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$groupSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$groupChar = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
	},
	$elm$parser$Parser$getChompedString(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isGroupChar)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isCommentChar = function (c) {
	return c === '#';
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$operatorSet = $elm$core$Set$fromList(
	_List_fromArray(
		['+', '-', '*', '/', '=', '!', '<', '>', '&', '|', '?', '^', ':', '~', '%', '.']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$punctuationSet = $elm$core$Set$union$($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$operatorSet, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$groupSet);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isPunctuation = function (c) {
	return $elm$core$Set$member$(c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$punctuationSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isStringLiteralChar = function (c) {
	return (c === '"') || (c === '\'');
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isIdentifierNameChar = function (c) {
	return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isPunctuation(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isStringLiteralChar(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isCommentChar(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c))));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$DeclarationKeyword = 3;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$FunctionEval = 4;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$Keyword = 2;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$LiteralKeyword = 6;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$Function = 5;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$inlineComment = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _List_fromArray(
			[
				_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment, b)
			]);
	},
	$elm$parser$Parser$getChompedString(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile$(
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak),
			$elm$parser$Parser$symbol('#'))));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$lineBreak = A2(
	$elm$parser$Parser$map,
	function (_v0) {
		return _List_fromArray(
			[
				_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak, '\u000A')
			]);
	},
	$elm$parser$Parser$symbol('\u000A'));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$multilineComment = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(
	{
		defaultMap: function (b) {
			return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment, b);
		},
		end: '\u0027\u0027\u0027',
		innerParsers: _List_fromArray(
			[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$lineBreak]),
		isNestable: false,
		isNotRelevant: function (c) {
			return !$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c);
		},
		start: '\u0027\u0027\u0027'
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$comment = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$inlineComment, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$multilineComment]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$whitespaceOrCommentStep = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				function (s) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, s),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isSpace))),
				A2(
				$elm$parser$Parser$map,
				function (ns) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(ns, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$lineBreak),
				A2(
				$elm$parser$Parser$map,
				function (ns) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(ns, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$comment)
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$classDeclarationLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5),
								b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isIdentifierNameChar))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$Param = 7;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$argLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(7),
								b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
						function (c) {
							return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isCommentChar(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c) || ((c === ',') || (c === ')'))));
						}))),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
						function (c) {
							return (c === '/') || (c === ',');
						}))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$functionDeclarationLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5),
								b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isIdentifierNameChar))),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					function (_v0) {
						return $elm$parser$Parser$loop$(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, '('),
								revTokens),
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$argLoop);
					},
					$elm$parser$Parser$symbol('('))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$functionEvalLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (_v0) {
					return $elm$parser$Parser$Done(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, '('),
							revTokens));
				},
				$elm$parser$Parser$symbol('(')),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$keywordSet = $elm$core$Set$fromList(
	_List_fromArray(
		['finally', 'is', 'return', 'continue', 'for', 'lambda', 'try', 'from', 'nonlocal', 'while', 'and', 'del', 'global', 'not', 'with', 'as', 'elif', 'if', 'or', 'yield', 'assert', 'else', 'import', 'pass', 'break', 'except', 'in', 'raise']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isKeyword = function (str) {
	return $elm$core$Set$member$(str, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$keywordSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$literalKeywordSet = $elm$core$Set$fromList(
	_List_fromArray(
		['True', 'False', 'None']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isLiteralKeyword = function (str) {
	return $elm$core$Set$member$(str, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$literalKeywordSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$keywordParser$ = function (revTokens, n) {
	return (n === 'def') ? $elm$parser$Parser$loop$(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3),
				n),
			revTokens),
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$functionDeclarationLoop) : ((n === 'class') ? $elm$parser$Parser$loop$(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3),
				n),
			revTokens),
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$classDeclarationLoop) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isKeyword(n) ? $elm$parser$Parser$succeed(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(2),
				n),
			revTokens)) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isLiteralKeyword(n) ? $elm$parser$Parser$succeed(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6),
				n),
			revTokens)) : $elm$parser$Parser$loop$(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
				n),
			revTokens),
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$functionEvalLoop))));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$keywordParser = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$keywordParser$);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$Number = 0;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$number = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(0),
			b);
	},
	$elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$number));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isOperatorChar = function (c) {
	return $elm$core$Set$member$(c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$operatorSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$operatorChar = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(2),
			b);
	},
	$elm$parser$Parser$getChompedString(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isOperatorChar)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$String = 1;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$quoteDelimiter = {
	defaultMap: function (b) {
		return _Utils_Tuple2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(1),
			b);
	},
	end: '\u0027',
	innerParsers: _List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$lineBreak]),
	isNestable: false,
	isNotRelevant: function (c) {
		return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapable(c));
	},
	start: '\u0027'
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$doubleQuote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(
	_Utils_update(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$quoteDelimiter,
		{end: '\u0022', start: '\u0022'}));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$quote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$quoteDelimiter);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$stringLiteral = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$quote, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$doubleQuote]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$mainLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (s) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(s, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$stringLiteral),
				A2(
				$elm$parser$Parser$map,
				function (s) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, s, revTokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$operatorChar, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$groupChar, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$number]))),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$keywordParser(revTokens),
					$elm$parser$Parser$getChompedString(
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$isIdentifierNameChar)))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$toRevTokens = $elm$parser$Parser$loop$(_List_Nil, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$mainLoop);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$toLines = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$toRevTokens),
	$elm$core$Result$map(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLines($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$syntaxToStyle)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$python = A2(
	$elm$core$Basics$composeR,
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$toLines,
	$elm$core$Result$map($elm$core$Basics$identity));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$syntaxToStyle = function (syntax) {
	switch (syntax) {
		case 0:
			return _Utils_Tuple2(2, 'sql-n');
		case 1:
			return _Utils_Tuple2(3, 'sql-s');
		case 2:
			return _Utils_Tuple2(4, 'sql-k');
		case 3:
			return _Utils_Tuple2(5, 'sql-o');
		case 4:
			return _Utils_Tuple2(6, 'sql-f');
		case 5:
			return _Utils_Tuple2(7, 'sql-p');
		default:
			return _Utils_Tuple2(8, 'sql-l');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$inlineComment = $elm$parser$Parser$oneOf(
	$elm$core$List$map$(
		A2(
			$elm$core$Basics$composeR,
			$elm$parser$Parser$symbol,
			A2(
				$elm$core$Basics$composeR,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile(
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak)),
				A2(
					$elm$core$Basics$composeR,
					$elm$parser$Parser$getChompedString,
					$elm$parser$Parser$map(
						function (b) {
							return _List_fromArray(
								[
									_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment, b)
								]);
						})))),
		_List_fromArray(
			['--', '$', '#'])));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$lineBreakList = A2(
	$elm$parser$Parser$map,
	function (_v0) {
		return _List_fromArray(
			[
				_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak, '\u000A')
			]);
	},
	$elm$parser$Parser$symbol('\u000A'));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$multilineComment = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(
	{
		defaultMap: function (b) {
			return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment, b);
		},
		end: '*/',
		innerParsers: _List_fromArray(
			[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$lineBreakList]),
		isNestable: false,
		isNotRelevant: A2($elm$core$Basics$composeL, $elm$core$Basics$not, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak),
		start: '/*'
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$comment = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$inlineComment, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$multilineComment]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$punctuatorSet = $elm$core$Set$fromList(
	_List_fromArray(
		[';', '[', ']', '(', ')', '`', ',', '.']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isPunctuationChar = function (c) {
	return $elm$core$Set$member$(c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$punctuatorSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isIdentifierChar = function (c) {
	return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isPunctuationChar(c));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$Function = 4;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$Keyword = 2;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$Literal = 6;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$Operator = 3;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$functionSet = $elm$core$Set$fromList(
	_List_fromArray(
		['AVG', 'COUNT', 'FIRST', 'FORMAT', 'LAST', 'LCASE', 'LEN', 'MAX', 'MID', 'MIN', 'MOD', 'NOW', 'ROUND', 'SUM', 'UCASE']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isFunction = function (str) {
	return $elm$core$Set$member$(
		$elm$core$String$toUpper(str),
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$functionSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$keywordPattern = $elm$core$Maybe$withDefault$(
	$elm$regex$Regex$never,
	A2(
		$elm$regex$Regex$fromStringWith,
		{caseInsensitive: true, multiline: false},
		'^(ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:_INSERT|COL)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURNS?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)$'));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isKeyword = $elm$regex$Regex$contains($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$keywordPattern);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$literalSet = $elm$core$Set$fromList(
	_List_fromArray(
		['TRUE', 'FALSE', 'NULL']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isLiteral = function (str) {
	return $elm$core$Set$member$(
		$elm$core$String$toUpper(str),
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$literalSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$operatorPattern = $elm$core$Maybe$withDefault$(
	$elm$regex$Regex$never,
	A2(
		$elm$regex$Regex$fromStringWith,
		{caseInsensitive: true, multiline: false},
		'^([-+*\u005C/=%^~]|&&?|\u005C|\u005C|?|!=?|<(?:=>?|<|>)?|>[>=]?|AND|BETWEEN|IN|LIKE|NOT|OR|IS|DIV|REGEXP|RLIKE|SOUNDS LIKE|XOR)$'));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isOperator = $elm$regex$Regex$contains($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$operatorPattern);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$keywordParser$ = function (revTokens, s) {
	return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isOperator(s) ? $elm$parser$Parser$succeed(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3),
				s),
			revTokens)) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isFunction(s) ? $elm$parser$Parser$succeed(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
				s),
			revTokens)) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isKeyword(s) ? $elm$parser$Parser$succeed(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(2),
				s),
			revTokens)) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isLiteral(s) ? $elm$parser$Parser$succeed(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6),
				s),
			revTokens)) : $elm$parser$Parser$succeed(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, s),
			revTokens)))));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$keywordParser = F2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$keywordParser$);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$lineBreak = A2(
	$elm$parser$Parser$map,
	function (_v0) {
		return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak, '\u000A');
	},
	$elm$parser$Parser$symbol('\u000A'));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$Number = 0;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$hexNumber = A2(
	$elm$parser$Parser$ignorer,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed(0),
		$elm$parser$Parser$backtrackable(
			$elm$parser$Parser$symbol('0x'))),
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($elm$core$Char$isHexDigit));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$number = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(0),
			b);
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$hexNumber, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$number]))));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$Punctuation = 5;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$punctuationChar = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5),
			b);
	},
	$elm$parser$Parser$getChompedString(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isPunctuationChar)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$space = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
	},
	$elm$parser$Parser$getChompedString(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isSpace)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$String = 1;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$sqlEscapable = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
				b)
			]);
	},
	$elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$escapable));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$quoteDelimiter = {
	defaultMap: function (b) {
		return _Utils_Tuple2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(1),
			b);
	},
	end: '\u0027',
	innerParsers: _List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$lineBreakList, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$sqlEscapable]),
	isNestable: false,
	isNotRelevant: function (c) {
		return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapable(c));
	},
	start: '\u0027'
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$doubleQuote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(
	_Utils_update(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$quoteDelimiter,
		{end: '\u0022', start: '\u0022'}));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$quote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$quoteDelimiter);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$stringLiteral = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$quote, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$doubleQuote]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$checkContext = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$whitespaceOrCommentStep(revTokens),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$whitespaceOrCommentStep = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				function (s) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, s, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$space),
				A2(
				$elm$parser$Parser$andThen,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$checkContext,
				A2(
					$elm$parser$Parser$map,
					function (s) {
						return A2($elm$core$List$cons, s, revTokens);
					},
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$lineBreak)),
				A2(
				$elm$parser$Parser$map,
				function (s) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(s, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$comment)
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$stringBody = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (s) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(s, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$stringLiteral),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$mainLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$space),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$lineBreak),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$punctuationChar),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$number),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$comment),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					function (n) {
						return $elm$parser$Parser$loop$(
							_Utils_ap(n, revTokens),
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$stringBody);
					},
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$stringLiteral)),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$keywordParser(revTokens),
					$elm$parser$Parser$getChompedString(
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$isIdentifierChar)))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$toRevTokens = $elm$parser$Parser$loop$(_List_Nil, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$mainLoop);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$toLines = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$toRevTokens),
	$elm$core$Result$map(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLines($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$syntaxToStyle)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$sql = A2(
	$elm$core$Basics$composeR,
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$toLines,
	$elm$core$Result$map($elm$core$Basics$identity));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$syntaxToStyle = function (syntax) {
	switch (syntax) {
		case 0:
			return _Utils_Tuple2(4, 'xml-t');
		case 1:
			return _Utils_Tuple2(6, 'xml-a');
		default:
			return _Utils_Tuple2(3, 'xlm-av');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$AttributeValue = 2;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$lineBreak = A2(
	$elm$parser$Parser$map,
	function (_v0) {
		return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak, '\u000A');
	},
	$elm$parser$Parser$symbol('\u000A'));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$lineBreakList = A2($elm$parser$Parser$map, $elm$core$List$singleton, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$lineBreak);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$doubleQuoteDelimiter = {
	defaultMap: function (b) {
		return _Utils_Tuple2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(2),
			b);
	},
	end: '\u0022',
	innerParsers: _List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$lineBreakList]),
	isNestable: false,
	isNotRelevant: A2($elm$core$Basics$composeL, $elm$core$Basics$not, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak),
	start: '\u0022'
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$comment = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(
	_Utils_update(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$doubleQuoteDelimiter,
		{
			defaultMap: function (b) {
				return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment, b);
			},
			end: '-->',
			start: '<!--'
		}));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$openTagParser = A2(
	$elm$parser$Parser$ignorer,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed(0),
		$elm$parser$Parser$chompIf(
			function (c) {
				return c === '<';
			})),
	$elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$elm$parser$Parser$chompIf(
				function (c) {
					return (c === '/') || ((c === '!') || (c === '?'));
				}),
				$elm$parser$Parser$succeed(0)
			])));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$Tag = 0;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$Attribute = 1;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$doubleQuote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$doubleQuoteDelimiter);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$quote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(
	_Utils_update(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$doubleQuoteDelimiter,
		{end: '\u0027', start: '\u0027'}));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$attributeValue = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$doubleQuote,
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$quote,
			A2(
			$elm$parser$Parser$map,
			function (b) {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(2),
						b)
					]);
			},
			$elm$parser$Parser$getChompedString(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
					function (c) {
						return (!$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c)) && (c !== '>');
					})))
		]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$whitespace = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$map,
			function (s) {
				return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, s);
			},
			$elm$parser$Parser$getChompedString(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isSpace))),
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$lineBreak
		]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$attributeValueLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$consThen$($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$attributeValueLoop, revTokens, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$whitespace),
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$addThen$($elm$parser$Parser$succeed, revTokens, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$attributeValue),
				$elm$parser$Parser$succeed(revTokens)
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$attributeConfirm = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$consThen$($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$attributeConfirm, revTokens, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$whitespace),
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$consThen$(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$attributeValueLoop,
				revTokens,
				A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, '=');
					},
					$elm$parser$Parser$symbol('='))),
				$elm$parser$Parser$succeed(revTokens)
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$isStartTagChar = function (c) {
	return $elm$core$Char$isUpper(c) || ($elm$core$Char$isLower(c) || $elm$core$Char$isDigit(c));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$isTagChar = function (c) {
	return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$isStartTagChar(c) || (c === '-');
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$isAttributeChar = function (c) {
	return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$isTagChar(c) || (c === '_');
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$attributeLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$consThen$(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$attributeConfirm,
					revTokens,
					A2(
						$elm$parser$Parser$map,
						function (b) {
							return _Utils_Tuple2(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(1),
								b);
						},
						$elm$parser$Parser$getChompedString(
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$isAttributeChar))))),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$whitespace),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
						function (c) {
							return (!$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c)) && (c !== '>');
						}))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$tag = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (n) {
					return $elm$parser$Parser$loop$(
						A2($elm$core$List$cons, n, revTokens),
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$attributeLoop);
				},
				A2(
					$elm$parser$Parser$map,
					function (b) {
						return _Utils_Tuple2(
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(0),
							b);
					},
					$elm$parser$Parser$getChompedString(
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile$(
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$isTagChar,
							$elm$parser$Parser$chompIf($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$isStartTagChar))))),
				$elm$parser$Parser$succeed(revTokens)
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$openTag = function (revTokens) {
	return A2(
		$elm$parser$Parser$andThen,
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$tag,
		A2(
			$elm$parser$Parser$map,
			function (b) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b),
					revTokens);
			},
			$elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$openTagParser)));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$mainLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$whitespace),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$comment),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, n),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
						function (c) {
							return (c !== '<') && (!$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c));
						}))),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$openTag(revTokens)),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$toRevTokens = $elm$parser$Parser$loop$(_List_Nil, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$mainLoop);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$toLines = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$toRevTokens),
	$elm$core$Result$map(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLines($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$syntaxToStyle)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$xml = A2(
	$elm$core$Basics$composeR,
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$toLines,
	$elm$core$Result$map($elm$core$Basics$identity));
var $author$project$RichText$syntaxHighlight$ = function (language, text) {
	var highlighter = function () {
		if (!language.$) {
			var name = language.a;
			var _v1 = $elm$core$String$toLower(
				$MartinSStewart$elm_nonempty_string$String$Nonempty$toString(name));
			switch (_v1) {
				case 'elm':
					return $elm$core$Maybe$Just($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$elm);
				case 'js':
					return $elm$core$Maybe$Just($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$javascript);
				case 'jsx':
					return $elm$core$Maybe$Just($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$javascript);
				case 'javascript':
					return $elm$core$Maybe$Just($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$javascript);
				case 'css':
					return $elm$core$Maybe$Just($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$css);
				case 'py':
					return $elm$core$Maybe$Just($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$python);
				case 'python':
					return $elm$core$Maybe$Just($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$python);
				case 'sql':
					return $elm$core$Maybe$Just($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$sql);
				case 'xml':
					return $elm$core$Maybe$Just($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$xml);
				case 'html':
					return $elm$core$Maybe$Just($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$xml);
				case 'svg':
					return $elm$core$Maybe$Just($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$xml);
				case 'json':
					return $elm$core$Maybe$Just($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$json);
				case 'nix':
					return $elm$core$Maybe$Just($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$nix);
				case 'kt':
					return $elm$core$Maybe$Just($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$kotlin);
				case 'kotlin':
					return $elm$core$Maybe$Just($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$kotlin);
				case 'go':
					return $elm$core$Maybe$Just($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$go);
				case 'golang':
					return $elm$core$Maybe$Just($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$go);
				default:
					return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	return $elm$core$Maybe$andThen$(
		function (highlight) {
			return $elm$core$Result$toMaybe(
				highlight(text));
		},
		highlighter);
};
var $author$project$RichText$syntaxHighlight = F2($author$project$RichText$syntaxHighlight$);
var $author$project$RichText$isSameDay$ = function (timezone, a, b) {
	return _Utils_eq(
		$lamdera$program_test$Effect$Time$toYear$(timezone, a),
		$lamdera$program_test$Effect$Time$toYear$(timezone, b)) && (_Utils_eq(
		A2($lamdera$program_test$Effect$Time$toMonth, timezone, a),
		A2($lamdera$program_test$Effect$Time$toMonth, timezone, b)) && _Utils_eq(
		$lamdera$program_test$Effect$Time$toDay$(timezone, a),
		$lamdera$program_test$Effect$Time$toDay$(timezone, b)));
};
var $author$project$RichText$isSameDay = F3($author$project$RichText$isSameDay$);
var $author$project$RichText$pluralize$ = function (amount, unit) {
	return $elm$core$String$fromInt(amount) + ('\u00A0' + (unit + ((amount === 1) ? '' : 's')));
};
var $author$project$RichText$pluralize = F2($author$project$RichText$pluralize$);
var $author$project$RichText$timeUntilToString$ = function (now, time) {
	var minutesLeft = (($lamdera$program_test$Effect$Time$posixToMillis(time) - $lamdera$program_test$Effect$Time$posixToMillis(now)) / 60000) | 0;
	var minutes = A2(
		$elm$core$Basics$modBy,
		60,
		$elm$core$Basics$abs(minutesLeft));
	var hours = ($elm$core$Basics$abs(minutesLeft) / 60) | 0;
	var amount = (!hours) ? $author$project$RichText$pluralize$(minutes, 'minute') : ((!minutes) ? $author$project$RichText$pluralize$(hours, 'hour') : ($author$project$RichText$pluralize$(hours, 'hour') + (' ' + $author$project$RichText$pluralize$(minutes, 'minute'))));
	return (!minutesLeft) ? 'now' : ((minutesLeft > 0) ? ('in ' + amount) : (amount + ' ago'));
};
var $author$project$RichText$timeUntilToString = F2($author$project$RichText$timeUntilToString$);
var $author$project$RichText$timestampToString$ = function (now, timezone, time) {
	var timeB = $author$project$TimeInMinutes$toTime(time);
	return $author$project$RichText$isSameDay$(timezone, now, timeB) ? ($author$project$MyUi$timestamp$(timeB, timezone) + (' (' + ($author$project$RichText$timeUntilToString$(now, timeB) + ')'))) : $author$project$RichText$dateAndTimeToString$(timezone, time);
};
var $author$project$RichText$timestampToString = F3($author$project$RichText$timestampToString$);
var $author$project$RichText$timestampView$ = function (now, timezone, state, time) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$author$project$RichText$htmlAttrIf$(
				state.italic,
				A2($elm$html$Html$Attributes$style, 'font-style', 'italic')),
				$author$project$RichText$htmlAttrIf$(
				state.underline,
				A2($elm$html$Html$Attributes$style, 'text-decoration', 'underline')),
				$author$project$RichText$htmlAttrIf$(
				state.bold,
				A2($elm$html$Html$Attributes$style, 'font-weight', '700')),
				$author$project$RichText$htmlAttrIf$(
				state.strikethrough,
				A2($elm$html$Html$Attributes$style, 'text-decoration', 'line-through')),
				$author$project$RichText$htmlAttrIf$(
				state.spoiler,
				A2($elm$html$Html$Attributes$style, 'opacity', '0')),
				A2($elm$html$Html$Attributes$style, 'background-color', $author$project$RichText$codeBackground),
				A2($elm$html$Html$Attributes$style, 'padding', '1px 3px'),
				A2($elm$html$Html$Attributes$style, 'border-radius', '3px'),
				A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
				$elm$html$Html$Attributes$title(
				$author$project$RichText$dateAndTimeToString$(timezone, time))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$RichText$timestampToString$(now, timezone, time))
			]));
};
var $author$project$RichText$timestampView = F4($author$project$RichText$timestampView$);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Add = 1;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Del = 2;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Normal = 0;
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		$elm$core$String$join$(
			' ',
			$elm$core$List$map$(
				$elm$core$Tuple$first,
				$elm$core$List$filter$($elm$core$Tuple$second, classes))));
};
var $elm$html$Html$code = _VirtualDom_node('code');
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$requiredStyleToString = function (required) {
	return 'elmsh' + function () {
		switch (required) {
			case 0:
				return '0';
			case 1:
				return '-comm';
			case 2:
				return '1';
			case 3:
				return '2';
			case 4:
				return '3';
			case 5:
				return '4';
			case 6:
				return '5';
			case 7:
				return '6';
			default:
				return '7';
		}
	}();
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$fragmentView = function (_v0) {
	var additionalClass = _v0.additionalClass;
	var requiredStyle = _v0.requiredStyle;
	var text = _v0.text;
	return ((!requiredStyle) && $elm$core$String$isEmpty(additionalClass)) ? $elm$html$Html$text(text) : A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$requiredStyleToString(requiredStyle),
						!(!requiredStyle)),
						_Utils_Tuple2('elmsh-' + additionalClass, additionalClass !== '')
					]))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(text)
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$toInlineHtml = function (lines) {
	return A2(
		$elm$html$Html$code,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('elmsh')
			]),
		$elm$core$List$concat(
			$elm$core$List$map$(
				function (_v0) {
					var fragments = _v0.fragments;
					var highlight = _v0.highlight;
					return _Utils_eq(highlight, $elm$core$Maybe$Nothing) ? $elm$core$List$map$($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$fragmentView, fragments) : _List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'elmsh-hl',
											_Utils_eq(
												highlight,
												$elm$core$Maybe$Just(0))),
											_Utils_Tuple2(
											'elmsh-add',
											_Utils_eq(
												highlight,
												$elm$core$Maybe$Just(1))),
											_Utils_Tuple2(
											'elmsh-del',
											_Utils_eq(
												highlight,
												$elm$core$Maybe$Just(2)))
										]))
								]),
							$elm$core$List$map$($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$fragmentView, fragments))
						]);
				},
				lines)));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$toInlineHtml = function (_v0) {
	var lines = _v0;
	return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$toInlineHtml(lines);
};
var $author$project$MyUi$userLabel2Html = function (user) {
	return A2(
		$elm$html$Html$span,
		$author$project$MyUi$userLabelHtmlAttributes,
		_List_fromArray(
			[
				$author$project$MyUi$userLabelText(
				'@' + $author$project$PersonName$toString(user.name))
			]));
};
var $author$project$MyUi$userLabelHtml$ = function (userId, allUsers) {
	var _v0 = $lamdera$containers$SeqDict$get$(userId, allUsers);
	if (!_v0.$) {
		var user = _v0.a;
		return $author$project$MyUi$userLabel2Html(user);
	} else {
		return A2(
			$elm$html$Html$span,
			$author$project$MyUi$userLabelHtmlAttributes,
			_List_fromArray(
				[
					$author$project$MyUi$userLabelText('@<name missing>')
				]));
	}
};
var $author$project$MyUi$userLabelHtml = F2($author$project$MyUi$userLabelHtml$);
var $elm$html$Html$video = _VirtualDom_node('video');
var $author$project$RichText$videoView$ = function (maybeHtmlId, maybeMetadata, isSpoilered, containerWidth, fileData) {
	var sizeAttrs = function () {
		if (!maybeMetadata.$) {
			var metadata = maybeMetadata.a;
			var _v2 = $author$project$RichText$actualImageSize$($author$project$FileStatus$imageMaxHeight, containerWidth, metadata.videoSize);
			var width = _v2.a;
			var height = _v2.b;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$Attributes$style,
					'width',
					$elm$core$String$fromFloat(width) + 'px'),
					A2(
					$elm$html$Html$Attributes$style,
					'height',
					$elm$core$String$fromFloat(height) + 'px')
				]);
		} else {
			return _List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'height', '300px')
				]);
		}
	}();
	var idAttribute = function () {
		if (!maybeHtmlId.$) {
			var htmlId = maybeHtmlId.a;
			return $elm$html$Html$Attributes$id(htmlId);
		} else {
			return $elm$html$Html$Attributes$class('');
		}
	}();
	return isSpoilered ? A2(
		$elm$html$Html$div,
		_Utils_ap(
			sizeAttrs,
			_List_fromArray(
				[
					idAttribute,
					A2($elm$html$Html$Attributes$style, 'display', 'block'),
					A2($elm$html$Html$Attributes$style, 'border-radius', '4px'),
					A2($elm$html$Html$Attributes$style, 'background-color', $author$project$RichText$spoilerBackground)
				])),
		_List_Nil) : A2(
		$elm$html$Html$video,
		_Utils_ap(
			sizeAttrs,
			_List_fromArray(
				[
					idAttribute,
					$elm$html$Html$Attributes$src(
					$author$project$FileStatus$fileDataUrl(fileData)),
					$elm$html$Html$Attributes$controls(true),
					A2($elm$html$Html$Attributes$style, 'display', 'block'),
					A2($elm$html$Html$Attributes$style, 'border-radius', '4px')
				])),
		_List_Nil);
};
var $author$project$RichText$videoView = F5($author$project$RichText$videoView$);
var $author$project$RichText$viewHelper$ = function (dropNextLineBreak, showLargeContent, maybePressedSpoiler, maybeOnPressImage, onPressLink, spoilerIndex, state, config, embeds, embedIndex, nonempty) {
	return $elm$core$List$foldl$(
		F2(
			function (group, _v57) {
				var _v58 = _v57.a;
				var dropNextLineBreak2 = _v58.a;
				var spoilerIndex2 = _v58.b;
				var embedIndex2 = _v57.b;
				var currentList = _v57.c;
				if (!group.$) {
					var nodes = group.a;
					return $author$project$RichText$viewNodes$(dropNextLineBreak2, showLargeContent, maybePressedSpoiler, maybeOnPressImage, onPressLink, spoilerIndex2, state, config, embeds, embedIndex2, currentList, nodes);
				} else {
					var nodes = group.a;
					var _v60 = $author$project$RichText$viewNodes$(dropNextLineBreak2, showLargeContent, maybePressedSpoiler, maybeOnPressImage, onPressLink, spoilerIndex2, state, config, embeds, embedIndex2, _List_Nil, nodes);
					var _v61 = _v60.a;
					var dropNextLineBreak3 = _v61.a;
					var spoilerIndex3 = _v61.b;
					var embedIndex3 = _v60.b;
					var row = _v60.c;
					return _Utils_Tuple3(
						_Utils_Tuple2(dropNextLineBreak3, spoilerIndex3),
						embedIndex3,
						_Utils_ap(
							currentList,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'display', 'flex'),
											A2($elm$html$Html$Attributes$style, 'flex-wrap', 'wrap'),
											A2($elm$html$Html$Attributes$style, 'align-items', 'flex-start'),
											A2($elm$html$Html$Attributes$style, 'gap', '4px')
										]),
									row)
								])));
				}
			}),
		_Utils_Tuple3(
			_Utils_Tuple2(dropNextLineBreak, spoilerIndex),
			embedIndex,
			_List_Nil),
		function () {
			if (!showLargeContent.$) {
				return $author$project$RichText$groupMediaRows$(
					config.attachedFiles,
					_List_Nil,
					_List_Nil,
					$mgold$elm_nonempty_list$List$Nonempty$toList(nonempty));
			} else {
				return _List_fromArray(
					[
						$author$project$RichText$OtherContent(nonempty)
					]);
			}
		}());
};
var $author$project$RichText$viewHelper = function (dropNextLineBreak) {
	return function (showLargeContent) {
		return function (maybePressedSpoiler) {
			return function (maybeOnPressImage) {
				return function (onPressLink) {
					return function (spoilerIndex) {
						return function (state) {
							return function (config) {
								return function (embeds) {
									return function (embedIndex) {
										return function (nonempty) {
											return $author$project$RichText$viewHelper$(dropNextLineBreak, showLargeContent, maybePressedSpoiler, maybeOnPressImage, onPressLink, spoilerIndex, state, config, embeds, embedIndex, nonempty);
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$RichText$viewNodes$ = function (dropNextLineBreak, showLargeContent, maybePressedSpoiler, maybeOnPressImage, onPressLink, spoilerIndex, state, config, embeds, embedIndex, previousHtml, nonempty) {
	var nodes = $mgold$elm_nonempty_list$List$Nonempty$toList(nonempty);
	return $elm$core$List$foldl$(
		F2(
			function (_v0, _v1) {
				var previousItem = _v0.a;
				var item = _v0.b;
				var _v2 = _v1.a;
				var dropNextLineBreak2 = _v2.a;
				var spoilerIndex2 = _v2.b;
				var embedIndex2 = _v1.b;
				var currentList = _v1.c;
				switch (item.$) {
					case 0:
						var userId = item.a;
						return _Utils_Tuple3(
							_Utils_Tuple2(false, spoilerIndex2),
							embedIndex2,
							_Utils_ap(
								currentList,
								_List_fromArray(
									[
										$author$project$MyUi$userLabelHtml$(userId, config.users)
									])));
					case 1:
						var channel = item.a;
						var thread = item.b;
						return _Utils_Tuple3(
							_Utils_Tuple2(false, spoilerIndex2),
							embedIndex2,
							_Utils_ap(
								currentList,
								_List_fromArray(
									[
										$author$project$RichText$channelMentionView$(config.onPressChannelMention, channel, thread, config.channels)
									])));
					case 2:
						var _char = item.a;
						var text = item.b;
						return _Utils_Tuple3(
							_Utils_Tuple2(false, spoilerIndex2),
							embedIndex2,
							_Utils_ap(
								currentList,
								$author$project$RichText$normalTextView$(
									config.emojiData,
									(dropNextLineBreak2 && (_char === '\n')) ? text : A2($elm$core$String$cons, _char, text),
									state)));
					case 4:
						var nonempty2 = item.a;
						var _v4 = $author$project$RichText$viewHelper$(
							dropNextLineBreak2,
							showLargeContent,
							maybePressedSpoiler,
							maybeOnPressImage,
							onPressLink,
							spoilerIndex2,
							_Utils_update(
								state,
								{italic: true}),
							config,
							embeds,
							embedIndex2,
							nonempty2);
						var _v5 = _v4.a;
						var dropNextLineBreak3 = _v5.a;
						var spoilerIndex3 = _v5.b;
						var embedIndex3 = _v4.b;
						var list = _v4.c;
						return _Utils_Tuple3(
							_Utils_Tuple2(dropNextLineBreak3, spoilerIndex3),
							embedIndex3,
							_Utils_ap(currentList, list));
					case 5:
						var nonempty2 = item.a;
						var _v6 = $author$project$RichText$viewHelper$(
							dropNextLineBreak2,
							showLargeContent,
							maybePressedSpoiler,
							maybeOnPressImage,
							onPressLink,
							spoilerIndex2,
							_Utils_update(
								state,
								{underline: true}),
							config,
							embeds,
							embedIndex2,
							nonempty2);
						var _v7 = _v6.a;
						var dropNextLineBreak3 = _v7.a;
						var spoilerIndex3 = _v7.b;
						var embedIndex3 = _v6.b;
						var list = _v6.c;
						return _Utils_Tuple3(
							_Utils_Tuple2(dropNextLineBreak3, spoilerIndex3),
							embedIndex3,
							_Utils_ap(currentList, list));
					case 3:
						var nonempty2 = item.a;
						var _v8 = $author$project$RichText$viewHelper$(
							dropNextLineBreak2,
							showLargeContent,
							maybePressedSpoiler,
							maybeOnPressImage,
							onPressLink,
							spoilerIndex2,
							_Utils_update(
								state,
								{bold: true}),
							config,
							embeds,
							embedIndex2,
							nonempty2);
						var _v9 = _v8.a;
						var dropNextLineBreak3 = _v9.a;
						var spoilerIndex3 = _v9.b;
						var embedIndex3 = _v8.b;
						var list = _v8.c;
						return _Utils_Tuple3(
							_Utils_Tuple2(dropNextLineBreak3, spoilerIndex3),
							embedIndex3,
							_Utils_ap(currentList, list));
					case 6:
						var nonempty2 = item.a;
						var _v10 = $author$project$RichText$viewHelper$(
							dropNextLineBreak2,
							showLargeContent,
							maybePressedSpoiler,
							maybeOnPressImage,
							onPressLink,
							spoilerIndex2,
							_Utils_update(
								state,
								{strikethrough: true}),
							config,
							embeds,
							embedIndex2,
							nonempty2);
						var _v11 = _v10.a;
						var dropNextLineBreak3 = _v11.a;
						var spoilerIndex3 = _v11.b;
						var embedIndex3 = _v10.b;
						var list = _v10.c;
						return _Utils_Tuple3(
							_Utils_Tuple2(dropNextLineBreak3, spoilerIndex3),
							embedIndex3,
							_Utils_ap(currentList, list));
					case 7:
						var nonempty2 = item.a;
						var revealed = $lamdera$containers$SeqSet$member$(spoilerIndex2, config.revealedSpoilers);
						var _v12 = $author$project$RichText$viewHelper$(
							dropNextLineBreak2,
							showLargeContent,
							maybePressedSpoiler,
							maybeOnPressImage,
							onPressLink,
							spoilerIndex2,
							revealed ? state : _Utils_update(
								state,
								{spoiler: true}),
							config,
							embeds,
							embedIndex2,
							nonempty2);
						var _v13 = _v12.a;
						var dropNextLineBreak3 = _v13.a;
						var embedIndex3 = _v12.b;
						var list = _v12.c;
						return _Utils_Tuple3(
							_Utils_Tuple2(dropNextLineBreak3, spoilerIndex2 + 1),
							embedIndex3,
							_Utils_ap(
								currentList,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										A2(
											$elm$core$List$cons,
											A2($elm$html$Html$Attributes$style, 'border-radius', '2px'),
											revealed ? _List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'background', 'rgb(14,14,16)')
												]) : _Utils_ap(
												_List_fromArray(
													[
														A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
														A2($elm$html$Html$Attributes$style, 'background', $author$project$RichText$spoilerBackground)
													]),
												function () {
													if (!maybePressedSpoiler.$) {
														var _v15 = maybePressedSpoiler.a;
														var htmlIdPrefix = _v15.a;
														var pressedSpoiler = _v15.b;
														return _List_fromArray(
															[
																$elm$html$Html$Events$onClick(
																pressedSpoiler(spoilerIndex2)),
																$elm$html$Html$Attributes$id(
																$lamdera$program_test$Effect$Browser$Dom$idToString(htmlIdPrefix) + ('_' + $elm$core$String$fromInt(spoilerIndex2)))
															]);
													} else {
														return _List_Nil;
													}
												}())),
										list)
									])));
					case 8:
						var list = item.b;
						var sidePadding = 8;
						var borderLeft = 4;
						var _v16 = function () {
							var _v18 = $mgold$elm_nonempty_list$List$Nonempty$fromList(list);
							if (!_v18.$) {
								var nonempty2 = _v18.a;
								return $author$project$RichText$viewHelper$(
									true,
									function () {
										if (!showLargeContent.$) {
											var a = showLargeContent.a;
											return $author$project$RichText$ShowLargeContent((a - sidePadding) - borderLeft);
										} else {
											return $author$project$RichText$NoLargeContent;
										}
									}(),
									maybePressedSpoiler,
									maybeOnPressImage,
									onPressLink,
									spoilerIndex2,
									state,
									config,
									embeds,
									embedIndex2,
									nonempty2);
							} else {
								return _Utils_Tuple3(
									_Utils_Tuple2(true, spoilerIndex2),
									embedIndex2,
									_List_fromArray(
										[
											$elm$html$Html$text(' ')
										]));
							}
						}();
						var _v17 = _v16.a;
						var spoilerIndex3 = _v17.b;
						var embedIndex3 = _v16.b;
						var list2 = _v16.c;
						return _Utils_Tuple3(
							_Utils_Tuple2(true, spoilerIndex3),
							embedIndex3,
							_Utils_ap(
								currentList,
								_List_fromArray(
									[
										function () {
										if (!showLargeContent.$) {
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$Attributes$style,
														'border-left',
														$elm$core$String$fromInt(borderLeft) + ('px solid ' + $author$project$RichText$accentBarColor)),
														A2(
														$elm$html$Html$Attributes$style,
														'padding',
														'2px ' + ($elm$core$String$fromInt(sidePadding) + 'px'))
													]),
												list2);
										} else {
											return A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$Attributes$style,
														'border-left',
														$elm$core$String$fromInt(borderLeft) + ('px solid ' + $author$project$RichText$accentBarColor)),
														A2(
														$elm$html$Html$Attributes$style,
														'padding',
														'0px ' + ($elm$core$String$fromInt(sidePadding) + 'px'))
													]),
												list2);
										}
									}()
									])));
					case 9:
						var level = item.a;
						var nonempty2 = item.c;
						var _v21 = $author$project$RichText$viewHelper$(true, showLargeContent, maybePressedSpoiler, maybeOnPressImage, onPressLink, spoilerIndex2, state, config, embeds, embedIndex2, nonempty2);
						var _v22 = _v21.a;
						var spoilerIndex3 = _v22.b;
						var embedIndex3 = _v21.b;
						var list2 = _v21.c;
						var headingElement = function () {
							if (!showLargeContent.$) {
								switch (level) {
									case 0:
										return A2(
											$elm$html$Html$h1,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'font-size', '2em'),
													A2($elm$html$Html$Attributes$style, 'font-weight', '700'),
													A2($elm$html$Html$Attributes$style, 'margin', '0')
												]),
											list2);
									case 1:
										return A2(
											$elm$html$Html$h2,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'font-size', '1.5em'),
													A2($elm$html$Html$Attributes$style, 'font-weight', '700'),
													A2($elm$html$Html$Attributes$style, 'margin', '0')
												]),
											list2);
									case 2:
										return A2(
											$elm$html$Html$h3,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'font-size', '1.25em'),
													A2($elm$html$Html$Attributes$style, 'font-weight', '700'),
													A2($elm$html$Html$Attributes$style, 'margin', '0')
												]),
											list2);
									default:
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'font-size', '0.8em'),
													A2(
													$elm$html$Html$Attributes$style,
													'color',
													$author$project$MyUi$colorToStyle($author$project$MyUi$font2))
												]),
											list2);
								}
							} else {
								return A2(
									$elm$html$Html$span,
									function () {
										switch (level) {
											case 3:
												return _List_fromArray(
													[
														A2($elm$html$Html$Attributes$style, 'font-size', '0.8em'),
														A2(
														$elm$html$Html$Attributes$style,
														'color',
														$author$project$MyUi$colorToStyle($author$project$MyUi$font3))
													]);
											case 0:
												return _List_fromArray(
													[
														A2($elm$html$Html$Attributes$style, 'font-weight', '700')
													]);
											case 1:
												return _List_fromArray(
													[
														A2($elm$html$Html$Attributes$style, 'font-weight', '700')
													]);
											default:
												return _List_fromArray(
													[
														A2($elm$html$Html$Attributes$style, 'font-weight', '700')
													]);
										}
									}(),
									list2);
							}
						}();
						return _Utils_Tuple3(
							_Utils_Tuple2(true, spoilerIndex3),
							embedIndex3,
							function () {
								var _v23 = _Utils_Tuple2(showLargeContent, previousItem);
								if (((!_v23.a.$) && (!_v23.b.$)) && (_v23.b.a.$ === 2)) {
									var _v24 = _v23.b.a;
									var _char = _v24.a;
									var text = _v24.b;
									return A2(
										$elm$core$String$endsWith,
										'\u000A',
										A2($elm$core$String$cons, _char, text)) ? _Utils_ap(
										currentList,
										_List_fromArray(
											[
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												headingElement
											])) : _Utils_ap(
										currentList,
										_List_fromArray(
											[headingElement]));
								} else {
									return _Utils_ap(
										currentList,
										_List_fromArray(
											[headingElement]));
								}
							}());
					case 10:
						var data = item.a;
						var text = $elm$url$Url$toString(data);
						return _Utils_Tuple3(
							_Utils_Tuple2(false, spoilerIndex2),
							embedIndex2 + 1,
							_Utils_ap(
								currentList,
								_List_fromArray(
									[
										function () {
										if (state.spoiler) {
											return A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$RichText$htmlAttrIf$(
														state.italic,
														A2($elm$html$Html$Attributes$style, 'font-style', 'italic')),
														$author$project$RichText$htmlAttrIf$(
														state.underline,
														A2($elm$html$Html$Attributes$style, 'text-decoration', 'underline')),
														$author$project$RichText$htmlAttrIf$(
														state.bold,
														A2($elm$html$Html$Attributes$style, 'font-weight', '700')),
														$author$project$RichText$htmlAttrIf$(
														state.strikethrough,
														A2($elm$html$Html$Attributes$style, 'text-decoration', 'line-through')),
														A2($elm$html$Html$Attributes$style, 'opacity', '0')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(text)
													]));
										} else {
											var _v28 = $elm$core$Array$get$(embedIndex2, embeds);
											if (!_v28.$) {
												if (!_v28.a.$) {
													var _v29 = _v28.a;
													return $author$project$RichText$embedLoadingView$(onPressLink, config.domainWhitelist, data);
												} else {
													var embed = _v28.a.a;
													var _v30 = _Utils_Tuple2(
														_Utils_eq(embed, $author$project$Embed$empty),
														showLargeContent);
													if ((!_v30.a) && (!_v30.b.$)) {
														var containerWidth = _v30.b.a;
														return $author$project$RichText$embedView$(
															config.timezone,
															onPressLink,
															maybeOnPressImage,
															containerWidth,
															config.domainWhitelist,
															config.animationMode,
															config.isSelectingAnchor,
															embedIndex2,
															function () {
																if (!maybePressedSpoiler.$) {
																	var _v32 = maybePressedSpoiler.a;
																	var htmlIdPrefix = _v32.a;
																	return $lamdera$program_test$Effect$Browser$Dom$idToString(htmlIdPrefix) + ('_embedImage_' + $elm$core$String$fromInt(embedIndex2));
																} else {
																	return 'embedImage_' + $elm$core$String$fromInt(embedIndex2);
																}
															}(),
															function () {
																var _v33 = $lamdera$containers$SeqDict$get$(embedIndex2, config.embedDrawings);
																if (!_v33.$) {
																	var embedDrawing = _v33.a;
																	return function (scale) {
																		return $author$project$Drawing$imageAttachmentOverlays$(scale, config.drawingUserColor, embedDrawing);
																	};
																} else {
																	return function (_v34) {
																		return _List_Nil;
																	};
																}
															}(),
															data,
															embed);
													} else {
														return $author$project$RichText$inlineEmbedView$(showLargeContent, onPressLink, config.domainWhitelist, data);
													}
												}
											} else {
												return $author$project$RichText$inlineEmbedView$(showLargeContent, onPressLink, config.domainWhitelist, data);
											}
										}
									}()
									])));
					case 11:
						var alias = item.a;
						var url = item.b;
						var aliasText = $MartinSStewart$elm_nonempty_string$String$Nonempty$toString(alias);
						return _Utils_Tuple3(
							_Utils_Tuple2(false, spoilerIndex2),
							embedIndex2,
							_Utils_ap(
								currentList,
								_List_fromArray(
									[
										state.spoiler ? A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$author$project$RichText$htmlAttrIf$(
												state.italic,
												A2($elm$html$Html$Attributes$style, 'font-style', 'italic')),
												$author$project$RichText$htmlAttrIf$(
												state.underline,
												A2($elm$html$Html$Attributes$style, 'text-decoration', 'underline')),
												$author$project$RichText$htmlAttrIf$(
												state.bold,
												A2($elm$html$Html$Attributes$style, 'font-weight', '700')),
												$author$project$RichText$htmlAttrIf$(
												state.strikethrough,
												A2($elm$html$Html$Attributes$style, 'text-decoration', 'line-through')),
												A2($elm$html$Html$Attributes$style, 'opacity', '0')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(aliasText)
											])) : A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(
												$elm$url$Url$toString(url)),
												$elm$html$Html$Attributes$target('_blank'),
												$elm$html$Html$Attributes$rel('noreferrer'),
												A2(
												$elm$html$Html$Attributes$attribute,
												'data-link-url',
												$elm$url$Url$toString(url)),
												A2($elm$html$Html$Attributes$style, 'color', $author$project$RichText$hyperlinkColor),
												$author$project$RichText$htmlAttrIf$(
												state.italic,
												A2($elm$html$Html$Attributes$style, 'font-style', 'italic')),
												$author$project$RichText$htmlAttrIf$(
												state.underline,
												A2($elm$html$Html$Attributes$style, 'text-decoration', 'underline')),
												$author$project$RichText$htmlAttrIf$(
												state.bold,
												A2($elm$html$Html$Attributes$style, 'font-weight', '700')),
												$author$project$RichText$htmlAttrIf$(
												state.strikethrough,
												A2($elm$html$Html$Attributes$style, 'text-decoration', 'line-through'))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(aliasText)
											]))
									])));
					case 12:
						var _char = item.a;
						var rest = item.b;
						return _Utils_Tuple3(
							_Utils_Tuple2(false, spoilerIndex2),
							embedIndex2,
							_Utils_ap(
								currentList,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$author$project$RichText$htmlAttrIf$(
												state.italic,
												A2($elm$html$Html$Attributes$style, 'font-style', 'italic')),
												$author$project$RichText$htmlAttrIf$(
												state.underline,
												A2($elm$html$Html$Attributes$style, 'text-decoration', 'underline')),
												$author$project$RichText$htmlAttrIf$(
												state.bold,
												A2($elm$html$Html$Attributes$style, 'text-shadow', '0.7px 0px 0px white')),
												$author$project$RichText$htmlAttrIf$(
												state.strikethrough,
												A2($elm$html$Html$Attributes$style, 'text-decoration', 'line-through')),
												$author$project$RichText$htmlAttrIf$(
												state.spoiler,
												A2($elm$html$Html$Attributes$style, 'opacity', '0')),
												A2($elm$html$Html$Attributes$style, 'background-color', $author$project$RichText$codeBackground),
												A2($elm$html$Html$Attributes$style, 'border', $author$project$RichText$codeBorder + ' solid 1px'),
												A2($elm$html$Html$Attributes$style, 'padding', '0 4px 0 4px'),
												A2($elm$html$Html$Attributes$style, 'border-radius', '4px'),
												A2($elm$html$Html$Attributes$style, 'font-family', '\u0027DejaVu Sans Mono\u0027, monospace')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($elm$core$String$cons, _char, rest))
											]))
									])));
					case 13:
						var language = item.a;
						var text = item.b;
						if (!showLargeContent.$) {
							var containerWidth2 = showLargeContent.a;
							return _Utils_Tuple3(
								_Utils_Tuple2(true, spoilerIndex2),
								embedIndex2,
								_Utils_ap(
									currentList,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'position', 'relative')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_Utils_ap(
														_List_fromArray(
															[
																A2(
																$elm$html$Html$Attributes$style,
																'background-color',
																state.spoiler ? $author$project$RichText$spoilerBackground : $author$project$RichText$codeBackground),
																A2(
																$elm$html$Html$Attributes$style,
																'border',
																$author$project$RichText$codeBorder + (' solid ' + ($elm$core$String$fromInt($author$project$RichText$codeBorderWidth) + 'px'))),
																A2(
																$elm$html$Html$Attributes$style,
																'padding',
																'0 ' + ($elm$core$String$fromInt($author$project$RichText$codePaddingX) + 'px')),
																A2($elm$html$Html$Attributes$style, 'border-radius', '4px'),
																A2($elm$html$Html$Attributes$style, 'white-space', 'pre'),
																A2($elm$html$Html$Attributes$style, 'overflow-x', 'auto'),
																$elm$html$Html$Events$stopPropagationOn$(
																'touchstart',
																A2(
																	$elm$json$Json$Decode$andThen,
																	$elm$core$Basics$identity,
																	A3(
																		$elm$json$Json$Decode$map2,
																		F2(
																			function (scrollWidth, clientWidth) {
																				return (_Utils_cmp(scrollWidth, clientWidth) > 0) ? $elm$json$Json$Decode$succeed(
																					_Utils_Tuple2(config.noOp, true)) : $elm$json$Json$Decode$fail('');
																			}),
																		$elm$json$Json$Decode$at$(
																			_List_fromArray(
																				['currentTarget', 'scrollWidth']),
																			$elm$json$Json$Decode$int),
																		$elm$json$Json$Decode$at$(
																			_List_fromArray(
																				['currentTarget', 'clientWidth']),
																			$elm$json$Json$Decode$int))))
															]),
														$author$project$RichText$isAsciiArt(language) ? _List_fromArray(
															[
																A2($elm$html$Html$Attributes$style, 'font-family', '\u0027ascii\u0027, monospace'),
																A2($elm$html$Html$Attributes$style, 'line-height', '1'),
																A2(
																$elm$html$Html$Attributes$style,
																'font-size',
																$author$project$RichText$asciiFontSize$(containerWidth2, config.devicePixelRatio, text)),
																A2($elm$html$Html$Attributes$style, 'transform', 'translateZ(0)')
															]) : _List_fromArray(
															[
																A2($elm$html$Html$Attributes$style, 'font-family', '\u0027DejaVu Sans Mono\u0027, monospace')
															])),
													_List_fromArray(
														[
															function () {
															if (state.spoiler) {
																return A2(
																	$elm$html$Html$span,
																	_List_fromArray(
																		[
																			A2($elm$html$Html$Attributes$style, 'opacity', '0')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(text)
																		]));
															} else {
																var _v36 = $author$project$RichText$syntaxHighlight$(language, text);
																if (!_v36.$) {
																	var highlighted = _v36.a;
																	return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$toInlineHtml(highlighted);
																} else {
																	return $elm$html$Html$text(text);
																}
															}
														}()
														])),
													state.spoiler ? $elm$html$Html$text('') : $author$project$RichText$copyCodeButton$(
													function () {
														if (!maybePressedSpoiler.$) {
															var _v38 = maybePressedSpoiler.a;
															var htmlIdPrefix = _v38.a;
															return $elm$core$Maybe$Just(
																$author$project$RichText$copyCodeButtonId$(
																	htmlIdPrefix,
																	$elm$core$List$length(currentList)));
														} else {
															return $elm$core$Maybe$Nothing;
														}
													}(),
													config.onPressCopyCode(text))
												]))
										])));
						} else {
							return _Utils_Tuple3(
								_Utils_Tuple2(false, spoilerIndex2),
								embedIndex2,
								_Utils_ap(
									currentList,
									_List_fromArray(
										[
											$elm$html$Html$text('<...>')
										])));
						}
					case 14:
						var fileId = item.a;
						if (!showLargeContent.$) {
							var containerWidth2 = showLargeContent.a;
							return _Utils_Tuple3(
								_Utils_Tuple2(true, spoilerIndex2),
								embedIndex2,
								function () {
									var _v40 = $lamdera$containers$SeqDict$get$(fileId, config.attachedFiles);
									if (!_v40.$) {
										var fileData = _v40.a;
										var maybeHtmlId = function () {
											if (!maybePressedSpoiler.$) {
												var _v44 = maybePressedSpoiler.a;
												var htmlIdPrefix = _v44.a;
												return $elm$core$Maybe$Just(
													$lamdera$program_test$Effect$Browser$Dom$idToString(htmlIdPrefix) + ('_file_' + $author$project$Id$toString(fileId)));
											} else {
												return $elm$core$Maybe$Nothing;
											}
										}();
										return _Utils_ap(
											currentList,
											_List_fromArray(
												[
													function () {
													var _v41 = fileData.metadata;
													if (!_v41.$) {
														if (!_v41.a.$) {
															var imageSize = _v41.a.a.imageSize;
															return $author$project$RichText$imageView$(maybePressedSpoiler, maybeOnPressImage, containerWidth2, config, imageSize, fileId, fileData, state);
														} else {
															var videoMetadata = _v41.a.a;
															return $author$project$RichText$videoView$(
																maybeHtmlId,
																$elm$core$Maybe$Just(videoMetadata),
																state.spoiler,
																containerWidth2,
																fileData);
														}
													} else {
														var _v42 = $author$project$FileStatus$contentTypeType(fileData.contentType);
														switch (_v42) {
															case 2:
																return $author$project$RichText$videoView$(maybeHtmlId, $elm$core$Maybe$Nothing, state.spoiler, containerWidth2, fileData);
															case 3:
																return $author$project$RichText$audioView$(maybeHtmlId, state.spoiler, containerWidth2, fileData);
															default:
																return $author$project$RichText$fileDownloadView$(maybeHtmlId, state.spoiler, fileData);
														}
													}
												}()
												]));
									} else {
										return _Utils_ap(
											currentList,
											_List_fromArray(
												[
													$author$project$Icons$image(18)
												]));
									}
								}());
						} else {
							return _Utils_Tuple3(
								_Utils_Tuple2(false, spoilerIndex2),
								embedIndex2,
								_Utils_ap(
									currentList,
									_List_fromArray(
										[
											$author$project$Icons$image(18)
										])));
						}
					case 15:
						var _char = item.a;
						return _Utils_Tuple3(
							_Utils_Tuple2(false, spoilerIndex2),
							embedIndex2,
							_Utils_ap(
								currentList,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$RichText$escapedCharToString(_char))
									])));
					case 16:
						var stickerId = item.a;
						if (!showLargeContent.$) {
							return _Utils_Tuple3(
								_Utils_Tuple2(true, spoilerIndex2),
								embedIndex2,
								_Utils_ap(
									currentList,
									_List_fromArray(
										[
											$author$project$Sticker$view$('160px', stickerId, config.stickers, config.animationMode)
										])));
						} else {
							return _Utils_Tuple3(
								_Utils_Tuple2(false, spoilerIndex2),
								embedIndex2,
								_Utils_ap(
									currentList,
									_List_fromArray(
										[
											$author$project$Icons$image(18)
										])));
						}
					case 17:
						var id = item.a;
						return _Utils_Tuple3(
							_Utils_Tuple2(false, spoilerIndex2),
							embedIndex2,
							_Utils_ap(
								currentList,
								_List_fromArray(
									[
										function () {
										var _v46 = _Utils_Tuple2(showLargeContent, config.isHovered);
										if ((!_v46.a.$) && _v46.b) {
											return $author$project$CustomEmoji$copyableViewWithTooltip$('1.4em', '0.2em', id, config.customEmojis, config.animationMode);
										} else {
											return $author$project$CustomEmoji$copyableView$('1.4em', '0.2em', id, config.customEmojis, config.animationMode);
										}
									}()
									])));
					case 18:
						var items = item.b;
						var _v47 = function (_v55) {
							var a = _v55.a;
							var b = _v55.b;
							var acc = _v55.c;
							return _Utils_Tuple3(
								a,
								b,
								$elm$core$List$reverse(acc));
						}(
							$elm$core$List$foldl$(
								F2(
									function (bulletItem, _v49) {
										var _v50 = _v49.a;
										var spoilerIndex3 = _v50.b;
										var embedIndex3 = _v49.b;
										var acc = _v49.c;
										var _v51 = $mgold$elm_nonempty_list$List$Nonempty$fromList(bulletItem);
										if (!_v51.$) {
											var nonempty2 = _v51.a;
											var _v52 = $author$project$RichText$viewHelper$(
												true,
												function () {
													if (!showLargeContent.$) {
														var containerWidth = showLargeContent.a;
														return $author$project$RichText$ShowLargeContent(containerWidth - $author$project$RichText$bulletPointLeftPadding);
													} else {
														return $author$project$RichText$NoLargeContent;
													}
												}(),
												maybePressedSpoiler,
												maybeOnPressImage,
												onPressLink,
												spoilerIndex3,
												state,
												config,
												embeds,
												embedIndex3,
												nonempty2);
											var _v53 = _v52.a;
											var d4 = _v53.a;
											var spoilerIndex4 = _v53.b;
											var embedIndex4 = _v52.b;
											var html = _v52.c;
											return _Utils_Tuple3(
												_Utils_Tuple2(d4, spoilerIndex4),
												embedIndex4,
												A2($elm$core$List$cons, html, acc));
										} else {
											return _Utils_Tuple3(
												_Utils_Tuple2(true, spoilerIndex3),
												embedIndex3,
												acc);
										}
									}),
								_Utils_Tuple3(
									_Utils_Tuple2(dropNextLineBreak2, spoilerIndex2),
									embedIndex2,
									_List_Nil),
								$mgold$elm_nonempty_list$List$Nonempty$toList(items)));
						var _v48 = _v47.a;
						var spoilerIndex5 = _v48.b;
						var embedIndex5 = _v47.b;
						var listItems = _v47.c;
						return _Utils_Tuple3(
							_Utils_Tuple2(true, spoilerIndex5),
							embedIndex5,
							_Utils_ap(
								currentList,
								function () {
									if (!showLargeContent.$) {
										return _List_fromArray(
											[
												A2(
												$elm$html$Html$ul,
												_List_fromArray(
													[
														A2($elm$html$Html$Attributes$style, 'margin', '0'),
														A2(
														$elm$html$Html$Attributes$style,
														'padding-left',
														$elm$core$String$fromInt($author$project$RichText$bulletPointLeftPadding) + 'px')
													]),
												$elm$core$List$map$(
													$elm$html$Html$li(_List_Nil),
													listItems))
											]);
									} else {
										return $elm$core$List$concatMap$(
											function (a) {
												return A2(
													$elm$core$List$cons,
													$elm$html$Html$text(' • '),
													a);
											},
											listItems);
									}
								}()));
					default:
						var time = item.a;
						return _Utils_Tuple3(
							_Utils_Tuple2(false, spoilerIndex2),
							embedIndex2,
							_Utils_ap(
								currentList,
								_List_fromArray(
									[
										$author$project$RichText$timestampView$(config.time, config.timezone, state, time)
									])));
				}
			}),
		_Utils_Tuple3(
			_Utils_Tuple2(dropNextLineBreak, spoilerIndex),
			embedIndex,
			previousHtml),
		A3(
			$elm$core$List$map2,
			$elm$core$Tuple$pair,
			A2(
				$elm$core$List$cons,
				$elm$core$Maybe$Nothing,
				$elm$core$List$map$($elm$core$Maybe$Just, nodes)),
			nodes));
};
var $author$project$RichText$viewNodes = function (dropNextLineBreak) {
	return function (showLargeContent) {
		return function (maybePressedSpoiler) {
			return function (maybeOnPressImage) {
				return function (onPressLink) {
					return function (spoilerIndex) {
						return function (state) {
							return function (config) {
								return function (embeds) {
									return function (embedIndex) {
										return function (previousHtml) {
											return function (nonempty) {
												return $author$project$RichText$viewNodes$(dropNextLineBreak, showLargeContent, maybePressedSpoiler, maybeOnPressImage, onPressLink, spoilerIndex, state, config, embeds, embedIndex, previousHtml, nonempty);
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$RichText$view$ = function (htmlIdPrefix, containerWidth, onPressLink, onPressSpoiler, onPressImage, config, embeds, nonempty) {
	return function (_v0) {
		var a = _v0.c;
		return a;
	}(
		$author$project$RichText$viewHelper$(
			false,
			$author$project$RichText$ShowLargeContent(containerWidth),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(htmlIdPrefix, onPressSpoiler)),
			$elm$core$Maybe$Just(onPressImage),
			onPressLink,
			0,
			{bold: false, italic: false, spoiler: false, strikethrough: false, underline: false},
			config,
			embeds,
			0,
			nonempty));
};
var $author$project$RichText$view = F8($author$project$RichText$view$);
var $author$project$SheepGame$contentView$ = function (time, contentWidth, localUser, isHovered, htmlId, attachedFiles, content) {
	return $author$project$Ui$html(
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'white-space', 'pre-wrap'),
					$elm$html$Html$Attributes$id(
					$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId))
				]),
			$author$project$RichText$view$(
				htmlId,
				contentWidth,
				function (_v0) {
					return $author$project$SheepGame$NoOp;
				},
				function (_v1) {
					return $author$project$SheepGame$NoOp;
				},
				$author$project$SheepGame$PressedImage,
				{
					animationMode: isHovered ? 1 : 0,
					attachedFiles: attachedFiles,
					channels: $lamdera$containers$SeqDict$empty,
					customEmojis: localUser.customEmojis,
					devicePixelRatio: localUser.devicePixelRatio,
					domainWhitelist: localUser.user.domainWhitelist,
					drawingUserColor: function (_v2) {
						return $author$project$RichText$defaultColor;
					},
					drawings: $lamdera$containers$SeqDict$empty,
					embedDrawings: $lamdera$containers$SeqDict$empty,
					emojiData: localUser.emojiData,
					isHovered: isHovered,
					isSelectingAnchor: false,
					noOp: $author$project$SheepGame$NoOp,
					onPressChannelMention: F2(
						function (_v3, _v4) {
							return $author$project$SheepGame$NoOp;
						}),
					onPressCopyCode: $author$project$SheepGame$PressedCopyCode,
					revealedSpoilers: $lamdera$containers$SeqSet$empty,
					stickers: localUser.stickers,
					time: time,
					timezone: localUser.timezone,
					users: $author$project$User$allUsers(localUser)
				},
				$elm$core$Array$empty,
				content)));
};
var $author$project$SheepGame$contentView = F7($author$project$SheepGame$contentView$);
var $author$project$GuildIcon$defaultUserHtml$ = function (size2, rounded, color) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$style,
				'border-radius',
				$elm$core$String$fromInt(rounded) + 'px'),
				A2(
				$elm$html$Html$Attributes$style,
				'background-color',
				$author$project$MyUi$colorToStyle(
					$author$project$UserColor$toColor(color))),
				A2(
				$elm$html$Html$Attributes$style,
				'width',
				$elm$core$String$fromInt(size2 - 8) + 'px'),
				A2(
				$elm$html$Html$Attributes$style,
				'height',
				$elm$core$String$fromInt(size2 - 8) + 'px'),
				A2($elm$html$Html$Attributes$style, 'padding', '4px'),
				A2(
				$elm$html$Html$Attributes$style,
				'color',
				$author$project$MyUi$colorToStyle($author$project$GuildIcon$iconFontColor)),
				A2($elm$html$Html$Attributes$style, 'flex-shrink', '0')
			]),
		_List_fromArray(
			[$author$project$Icons$person]));
};
var $author$project$GuildIcon$defaultUserHtml = F3($author$project$GuildIcon$defaultUserHtml$);
var $author$project$User$profileImgHtml$ = function (fileHash, color) {
	return A2(
		$elm$html$Html$img,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$style,
				'border-radius',
				$elm$core$String$fromInt($author$project$User$profileImageRounding) + 'px'),
				A2(
				$elm$html$Html$Attributes$style,
				'width',
				$elm$core$String$fromInt($author$project$User$profileImageSize) + 'px'),
				A2(
				$elm$html$Html$Attributes$style,
				'height',
				$elm$core$String$fromInt($author$project$User$profileImageSize) + 'px'),
				A2(
				$elm$html$Html$Attributes$style,
				'outline',
				'solid 1px ' + $author$project$User$profileOutlineColor(color)),
				A2($elm$html$Html$Attributes$style, 'outline-offset', '-1px'),
				A2($elm$html$Html$Attributes$style, 'flex-shrink', '0'),
				$elm$html$Html$Attributes$src(
				$author$project$FileStatus$fileUrl$($author$project$FileStatus$pngContent, fileHash)),
				$author$project$MyUi$lazyLoading
			]),
		_List_Nil);
};
var $author$project$User$profileImgHtml = F2($author$project$User$profileImgHtml$);
var $author$project$User$profileImageHtml = function (user) {
	if (!user.$) {
		var user2 = user.a;
		var _v1 = user2.icon;
		if (!_v1.$) {
			var fileHash = _v1.a;
			return $author$project$User$profileImgHtml$(fileHash, user2.color);
		} else {
			return $author$project$GuildIcon$defaultUserHtml$($author$project$User$profileImageSize, 8, user2.color);
		}
	} else {
		return $author$project$GuildIcon$defaultUserHtml$($author$project$User$profileImageSize, 8, $author$project$RichText$defaultColor);
	}
};
var $author$project$User$profileImage = function (user) {
	return $author$project$Ui$html(
		$author$project$User$profileImageHtml(user));
};
var $author$project$MessageView$profileImagePaddingRight = 8;
var $author$project$User$toColoredString$ = function (userId, allUsers2) {
	var _v0 = $lamdera$containers$SeqDict$get$(userId, allUsers2);
	if (!_v0.$) {
		var user = _v0.a;
		return $author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$Font$bold,
					$author$project$Ui$Font$color(
					$author$project$UserColor$toColor(user.color)),
					$author$project$Ui$clipWithEllipsis
				]),
			$author$project$Ui$text(
				$author$project$PersonName$toString(user.name)));
	} else {
		return $author$project$Ui$el$(
			_List_fromArray(
				[$author$project$Ui$clipWithEllipsis]),
			$author$project$Ui$text($author$project$User$missingName));
	}
};
var $author$project$User$toColoredString = F2($author$project$User$toColoredString$);
var $author$project$SheepGame$messageWithProfile$ = function (userId, localUser, content) {
	return $author$project$Ui$row$(
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$alignTop,
						$author$project$Ui$width($author$project$Ui$shrink),
						$author$project$Ui$paddingWith(
						{bottom: 0, left: 0, right: $author$project$MessageView$profileImagePaddingRight, top: 2})
					]),
				$author$project$User$profileImage(
					$author$project$User$getUser$(userId, localUser))),
				$author$project$Ui$column$(
				_List_Nil,
				_List_fromArray(
					[
						$author$project$User$toColoredString$(
						userId,
						$author$project$User$allUsers(localUser)),
						content
					]))
			]));
};
var $author$project$SheepGame$messageWithProfile = F3($author$project$SheepGame$messageWithProfile$);
var $author$project$SheepGame$players = function (shared) {
	return $elm$core$List$filterMap$(
		function (_v0) {
			var userId = _v0.a;
			var answers = _v0.b;
			return $elm$core$List$any$(
				function (answer) {
					return !_Utils_eq(answer, $elm$core$Maybe$Nothing);
				},
				$author$project$IdArray$toList(answers)) ? $elm$core$Maybe$Just(userId) : $elm$core$Maybe$Nothing;
		},
		$lamdera$containers$SeqDict$toList(shared.answers));
};
var $author$project$SheepGame$ExitedQuestion = function (a) {
	return {$: 19, a: a};
};
var $author$project$SheepGame$HoveredQuestion = function (a) {
	return {$: 18, a: a};
};
var $elm$html$Html$Events$onMouseEnter = function (msg) {
	return $elm$html$Html$Events$on$(
		'mouseenter',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Ui$Events$onMouseEnter = function (msg) {
	return $author$project$Internal$Model2$attribute(
		$elm$html$Html$Events$onMouseEnter(msg));
};
var $elm$html$Html$Events$onMouseLeave = function (msg) {
	return $elm$html$Html$Events$on$(
		'mouseleave',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Ui$Events$onMouseLeave = function (msg) {
	return $author$project$Internal$Model2$attribute(
		$elm$html$Html$Events$onMouseLeave(msg));
};
var $author$project$SheepGame$questionView$ = function (time, contentWidth, localUser, hoveredQuestion, questionId, htmlId, question) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$Events$onMouseEnter(
				$author$project$SheepGame$HoveredQuestion(questionId)),
				$author$project$Ui$Events$onMouseLeave(
				$author$project$SheepGame$ExitedQuestion(questionId))
			]),
		$author$project$SheepGame$contentView$(
			time,
			contentWidth,
			localUser,
			_Utils_eq(
				hoveredQuestion,
				$elm$core$Maybe$Just(questionId)),
			htmlId,
			question.attachedFiles,
			question.text));
};
var $author$project$SheepGame$questionView = F7($author$project$SheepGame$questionView$);
var $author$project$MyUi$secondaryGray = $author$project$Ui$rgb$(240, 240, 240);
var $author$project$MyUi$secondaryButton$ = function (htmlId, onPress, label2) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$Input$button(onPress),
				$author$project$MyUi$id(htmlId),
				$author$project$Ui$background($author$project$MyUi$secondaryGray),
				$author$project$Ui$border(1),
				$author$project$Ui$Font$color($author$project$MyUi$black),
				$author$project$Ui$rounded(4),
				$author$project$Ui$width($author$project$Ui$shrink),
				$author$project$Ui$paddingXY$(16, 4),
				$author$project$Ui$Font$weight(500)
			]),
		$author$project$Ui$text(label2));
};
var $author$project$MyUi$secondaryButton = F3($author$project$MyUi$secondaryButton$);
var $author$project$SheepGame$answeringView$ = function (time, contentWidth, localUser, loggedIn, setup, shared, model) {
	var currentUserId = localUser.session.userId;
	var answerContentWidth = contentWidth - ($author$project$User$profileImageSize + 8);
	return _List_fromArray(
		[
			$author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$Font$bold,
					$author$project$Ui$Font$size(20)
				]),
			$author$project$SheepGame$isHost$(localUser.session.userId, setup) ? $author$project$Ui$text('Waiting on people\u0027s answers') : $author$project$Ui$text('Answer like everyone else')),
			$author$project$Ui$column$(
			_List_fromArray(
				[
					$author$project$Ui$spacing(8)
				]),
			_List_fromArray(
				[
					$author$project$Ui$text('You score a point for every player who writes a sufficiently* similar answer to you.'),
					$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$Font$color($author$project$MyUi$font3)
						]),
					$author$project$Ui$text('*The game host decides what counts as sufficiently similar.'))
				])),
			$author$project$Ui$column$(
			_List_fromArray(
				[
					$author$project$Ui$spacing(16)
				]),
			$elm$core$List$indexedMap$(
				F2(
					function (index, question) {
						var questionId = $author$project$Id$fromInt(index);
						return $author$project$Ui$column$(
							_List_fromArray(
								[
									$author$project$Ui$spacing(4)
								]),
							_List_fromArray(
								[
									$author$project$SheepGame$questionView$(
									time,
									contentWidth,
									localUser,
									model.hoveredQuestion,
									questionId,
									$lamdera$program_test$Effect$Browser$Dom$id(
										'sheepGame_answeringQuestion_' + $author$project$Id$toString(questionId)),
									question),
									function () {
									if ($author$project$SheepGame$isHost$(localUser.session.userId, setup)) {
										var answers = $elm$core$List$filterMap$(
											function (_v1) {
												var answeredBy = _v1.a;
												var answers2 = _v1.b;
												var _v2 = $author$project$IdArray$get$(questionId, answers2);
												if ((!_v2.$) && (!_v2.a.$)) {
													var answer = _v2.a.a;
													return $elm$core$Maybe$Just(
														$author$project$SheepGame$messageWithProfile$(
															answeredBy,
															localUser,
															$author$project$SheepGame$contentView$(
																time,
																answerContentWidth,
																localUser,
																false,
																$lamdera$program_test$Effect$Browser$Dom$id(
																	'sheepGame_answerPreview_' + ($author$project$Id$toString(questionId) + ('_' + $author$project$Id$toString(answeredBy)))),
																answer.attachedFiles,
																answer.text)));
												} else {
													return $elm$core$Maybe$Nothing;
												}
											},
											$lamdera$containers$SeqDict$toList(shared.answers));
										if (!answers.b) {
											return $author$project$Ui$el$(
												_List_fromArray(
													[
														$author$project$Ui$Font$italic,
														$author$project$Ui$Font$color($author$project$MyUi$font3)
													]),
												$author$project$Ui$text('No answers yet'));
										} else {
											return $author$project$Ui$column$(_List_Nil, answers);
										}
									} else {
										return $author$project$SheepGame$answerInput$(
											localUser,
											loggedIn,
											questionId,
											$elm$core$Maybe$withDefault$(
												{attachedFiles: $lamdera$containers$SeqDict$empty, text: ''},
												$author$project$IdArray$get$(questionId, model.answerDrafts)));
									}
								}()
								]));
					}),
				$mgold$elm_nonempty_list$List$Nonempty$toList(setup.questions))),
			$author$project$SheepGame$isHost$(currentUserId, setup) ? $author$project$MyUi$secondaryButton$(
			$lamdera$program_test$Effect$Browser$Dom$id('sheepGame_lockAnswers'),
			$author$project$SheepGame$PressedLockAnswers,
			'Lock answers and tally score') : $author$project$Ui$text('Your answers are saved automatically!'),
			$author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$Font$color($author$project$MyUi$font3)
				]),
			$author$project$Ui$text(
				$author$project$SheepGame$answeredCountText(
					$elm$core$List$length(
						$author$project$SheepGame$players(shared)))))
		]);
};
var $author$project$SheepGame$answeringView = F7($author$project$SheepGame$answeringView$);
var $author$project$MyUi$conversationWidthIgnoreScrollbar$ = function (windowSize, showMembersTab) {
	return $author$project$MyUi$isMobileAlt(windowSize) ? $author$project$Coord$xRaw(windowSize) : ($author$project$Coord$xRaw(windowSize) - ((($author$project$MyUi$guildIconFullWidth + 1) + $author$project$MyUi$channelColumnWidth(windowSize)) + (showMembersTab ? $author$project$MyUi$memberColumnWidth : 0)));
};
var $author$project$MyUi$conversationWidthIgnoreScrollbar = F2($author$project$MyUi$conversationWidthIgnoreScrollbar$);
var $author$project$SheepGame$encodeContentWidthAndTime$ = function (isMobile, time, contentWidth) {
	return ((contentWidth << 1) + (((($lamdera$program_test$Effect$Time$posixToMillis(time) / (1000 * 60)) | 0) * 8192) * 2)) + (isMobile ? 1 : 0);
};
var $author$project$SheepGame$encodeContentWidthAndTime = F3($author$project$SheepGame$encodeContentWidthAndTime$);
var $author$project$SheepGame$encodeUserIdAndQuestionId$ = function (userId, questionId) {
	return $author$project$Id$toInt(questionId) + ($author$project$Id$toInt(userId) << 6);
};
var $author$project$SheepGame$encodeUserIdAndQuestionId = F2($author$project$SheepGame$encodeUserIdAndQuestionId$);
var $author$project$SheepGame$PressedRevealScores = {$: 15};
var $author$project$SheepGame$PressedUnlockAnswers = {$: 7};
var $author$project$SheepGame$answerFor$ = function (userId, questionId, shared) {
	var _v0 = $lamdera$containers$SeqDict$get$(userId, shared.answers);
	if (!_v0.$) {
		var answers = _v0.a;
		var _v1 = $author$project$IdArray$get$(questionId, answers);
		if (!_v1.$) {
			var answer = _v1.a;
			return answer;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$SheepGame$answerFor = F3($author$project$SheepGame$answerFor$);
var $author$project$SheepGame$answerGroups = function (answers) {
	return $elm$core$List$map$(
		function (_v2) {
			var first = _v2.a;
			var rest = _v2.b;
			return $elm$core$List$map$(
				function (_v3) {
					var userId = _v3.a;
					var answer = _v3.c;
					return _Utils_Tuple2(userId, answer);
				},
				A2($elm$core$List$cons, first, rest));
		},
		A2(
			$elm$core$List$sortBy,
			function (_v1) {
				var rest = _v1.b;
				return $elm$core$List$length(rest);
			},
			$elmcraft$core_extra$List$Extra$gatherEqualsBy$(
				function (_v0) {
					var group = _v0.b;
					return group;
				},
				answers)));
};
var $author$project$SheepGame$answerGroupOutlineColor = $author$project$Ui$rgb$(76, 80, 100);
var $author$project$SheepGame$answerGroupOutlineOffset = -1;
var $author$project$SheepGame$answerGroupOutlineWidth = 2;
var $author$project$SheepGame$paddingX = function (isMobile) {
	return isMobile ? 8 : 16;
};
var $author$project$SheepGame$answerGroupsColumn$ = function (isMobile, groups) {
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$paddingWith(
				{
					bottom: 0,
					left: ($author$project$SheepGame$paddingX(isMobile) + $author$project$SheepGame$answerGroupOutlineWidth) + $author$project$SheepGame$answerGroupOutlineOffset,
					right: $author$project$SheepGame$paddingX(isMobile),
					top: 0
				})
			]),
		$elm$core$List$map$(
			$author$project$Ui$column(
				_List_fromArray(
					[
						$author$project$MyUi$htmlStyle$(
						'outline',
						'solid ' + ($elm$core$String$fromInt($author$project$SheepGame$answerGroupOutlineWidth) + ('px ' + $author$project$MyUi$colorToStyle($author$project$SheepGame$answerGroupOutlineColor)))),
						$author$project$MyUi$htmlStyle$(
						'outline-offset',
						$elm$core$String$fromInt($author$project$SheepGame$answerGroupOutlineOffset) + 'px'),
						$author$project$Ui$rounded(3),
						$author$project$Ui$width($author$project$Ui$shrink),
						$author$project$Ui$background($author$project$MyUi$background2)
					])),
			groups));
};
var $author$project$SheepGame$answerGroupsColumn = F2($author$project$SheepGame$answerGroupsColumn$);
var $author$project$SheepGame$TypedGroup$ = function (a, b, c) {
	return {$: 8, a: a, b: b, c: c};
};
var $author$project$SheepGame$TypedGroup = F3($author$project$SheepGame$TypedGroup$);
var $author$project$SheepGame$fromMinutes = function (minutes) {
	return $lamdera$program_test$Effect$Time$millisToPosix(minutes * 60000);
};
var $author$project$SheepGame$groupingAnswerContent$ = function (minutes, contentWidth, localUser, questionIndex, userIdInt, answer) {
	return $author$project$SheepGame$contentView$(
		$author$project$SheepGame$fromMinutes(minutes),
		contentWidth,
		localUser,
		false,
		$lamdera$program_test$Effect$Browser$Dom$id(
			'sheepGame_groupingAnswer_' + ($elm$core$String$fromInt(questionIndex) + ('_' + $elm$core$String$fromInt(userIdInt)))),
		answer.attachedFiles,
		answer.text);
};
var $author$project$SheepGame$groupingAnswerContent = F6($author$project$SheepGame$groupingAnswerContent$);
var $author$project$MyUi$inputBackground = $author$project$Ui$rgba$(0, 0, 0, 0.3);
var $author$project$MyUi$inputBorder = $author$project$Ui$rgb$(79, 84, 102);
var $author$project$MyUi$label$ = function (htmlId, attributes, element) {
	return $author$project$Ui$Input$label$(
		$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId),
		attributes,
		element);
};
var $author$project$MyUi$label = F3($author$project$MyUi$label$);
var $author$project$Ui$Input$TextInputNode = function (a) {
	return {$: 0, a: a};
};
var $author$project$Internal$Model2$NodeAsInput = {$: 13};
var $author$project$Internal$Model2$NodeAsTextArea = {$: 14};
var $author$project$Ui$Input$darkGrey2 = $author$project$Ui$rgb$(186, 189, 182);
var $author$project$Ui$Input$white = $author$project$Ui$rgb$(255, 255, 255);
var $author$project$Ui$Input$defaultTextBoxStyle2 = _List_fromArray(
	[
		$author$project$Ui$padding(12),
		$author$project$Ui$rounded(3),
		$author$project$Ui$borderColor($author$project$Ui$Input$darkGrey2),
		$author$project$Ui$border(1),
		$author$project$Ui$background($author$project$Ui$Input$white),
		$author$project$Ui$spacing(5),
		$author$project$Ui$width($author$project$Ui$fill)
	]);
var $author$project$Internal$Model2$ifFlag$ = function (isPassing, _v0) {
	var flag = _v0.flag;
	return isPassing(flag);
};
var $author$project$Internal$Model2$ifFlag = F2($author$project$Internal$Model2$ifFlag$);
var $author$project$Ui$Input$isWidthOrHeight = function (flag) {
	return $author$project$Internal$BitField$fieldEqual$($author$project$Internal$Flag$width, flag) || $author$project$Internal$BitField$fieldEqual$($author$project$Internal$Flag$height, flag);
};
var $elm$html$Html$Attributes$placeholder = _VirtualDom_attribute('placeholder');
var $elm$html$Html$Attributes$spellcheck = function (bool) {
	return A2(
		_VirtualDom_attribute,
		'spellcheck',
		bool ? 'true' : 'false');
};
var $author$project$Internal$Model2$toOnlyStyle = function (_v0) {
	var attr = _v0.attr;
	var flag = _v0.flag;
	return {
		attr: function () {
			var details = attr;
			return _Utils_update(
				details,
				{attrs: _List_Nil});
		}(),
		flag: flag
	};
};
var $author$project$Ui$Input$textHelper$ = function (textInput, attrs, textOptions) {
	var withDefaults = _Utils_ap($author$project$Ui$Input$defaultTextBoxStyle2, attrs);
	var inputElement = $author$project$Internal$Model2$element$(
		function () {
			var _v1 = textInput.type_;
			if (!_v1.$) {
				return $author$project$Internal$Model2$NodeAsInput;
			} else {
				return $author$project$Internal$Model2$NodeAsTextArea;
			}
		}(),
		2,
		_Utils_ap(
			function () {
				var _v2 = textInput.type_;
				if (!_v2.$) {
					var inputType = _v2.a;
					return _List_fromArray(
						[
							$author$project$Internal$Model2$attribute(
							$elm$html$Html$Attributes$type_(inputType)),
							$author$project$Internal$Model2$class($author$project$Internal$Style$Generated$classes.inputText)
						]);
				} else {
					return _List_fromArray(
						[
							$author$project$Internal$Model2$classWith$($author$project$Internal$Flag$overflow, $author$project$Internal$Style2$classes.clip),
							$author$project$Ui$height($author$project$Ui$fill),
							$author$project$Internal$Model2$class($author$project$Internal$Style$Generated$classes.inputMultiline),
							$author$project$Internal$Model2$style$('line-height', 'inherit')
						]);
				}
			}(),
			_Utils_ap(
				_List_fromArray(
					[
						$author$project$Internal$Model2$attribute(
						$elm$html$Html$Attributes$value(textOptions.text)),
						$author$project$Internal$Model2$attribute(
						$elm$html$Html$Events$onInput(textOptions.onChange)),
						$author$project$Ui$Input$labelAttribute(textOptions.label),
						$author$project$Internal$Model2$attribute(
						$elm$html$Html$Attributes$spellcheck(textInput.spellchecked)),
						function () {
						var _v3 = textInput.autofill;
						if (_v3.$ === 1) {
							return $author$project$Internal$Model2$noAttr;
						} else {
							var fill = _v3.a;
							return $author$project$Internal$Model2$attribute(
								A2($elm$html$Html$Attributes$attribute, 'autocomplete', fill));
						}
					}(),
						function () {
						var _v4 = textOptions.placeholder;
						if (_v4.$ === 1) {
							return $author$project$Internal$Model2$noAttr;
						} else {
							var placeholder = _v4.a;
							return $author$project$Internal$Model2$attribute(
								$elm$html$Html$Attributes$placeholder(placeholder));
						}
					}()
					]),
				withDefaults)),
		_List_Nil);
	var _v0 = textInput.type_;
	if (_v0.$ === 1) {
		var onlyStyleAttrs = $elm$core$List$map$($author$project$Internal$Model2$toOnlyStyle, withDefaults);
		return $author$project$Internal$Model2$element$(
			$author$project$Internal$Model2$NodeAsDiv,
			2,
			_Utils_ap(
				_List_fromArray(
					[
						$author$project$Ui$width($author$project$Ui$fill),
						$author$project$Internal$Model2$class($author$project$Internal$Style$Generated$classes.focusedWithin),
						$author$project$Internal$Model2$class($author$project$Internal$Style$Generated$classes.inputMultilineWrapper),
						$author$project$Internal$Model2$style$('white-space', 'pre-wrap'),
						$author$project$Internal$Model2$style$('overflow-wrap', 'anywhere'),
						$author$project$Ui$inFront(inputElement)
					]),
				$elm$core$List$filter$(
					$author$project$Internal$Model2$ifFlag($author$project$Ui$Input$isWidthOrHeight),
					withDefaults)),
			_List_fromArray(
				[
					$author$project$Ui$el$(
					A2(
						$elm$core$List$cons,
						$author$project$Ui$height($author$project$Ui$fill),
						A2(
							$elm$core$List$cons,
							$author$project$Ui$width($author$project$Ui$fill),
							$elm$core$List$filter$(
								A2(
									$elm$core$Basics$composeR,
									$author$project$Internal$Model2$ifFlag($author$project$Ui$Input$isWidthOrHeight),
									$elm$core$Basics$not),
								onlyStyleAttrs))),
					(textOptions.text === '') ? $author$project$Ui$text(
						$elm$core$Maybe$withDefault$('', textOptions.placeholder) + '\u00A0') : $author$project$Ui$text(textOptions.text + '\u00A0'))
				]));
	} else {
		return inputElement;
	}
};
var $author$project$Ui$Input$textHelper = F3($author$project$Ui$Input$textHelper$);
var $author$project$Ui$Input$text = $author$project$Ui$Input$textHelper(
	{
		autofill: $elm$core$Maybe$Nothing,
		spellchecked: false,
		type_: $author$project$Ui$Input$TextInputNode('text')
	});
var $author$project$SheepGame$groupingAnswerView$ = function (minutes, contentWidth, localUser, questionId, userId, shared, answer) {
	var groupLabel2 = $author$project$MyUi$label$(
		$lamdera$program_test$Effect$Browser$Dom$id(
			'sheepGame_group_' + ($author$project$Id$toString(questionId) + ('_' + $author$project$Id$toString(userId)))),
		_List_Nil,
		$author$project$Ui$text('Group'));
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$width(
						$author$project$Ui$px(40))
					]),
				groupLabel2.element),
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$alignTop,
						$author$project$Ui$spacing(8),
						$author$project$Ui$width($author$project$Ui$shrink),
						$author$project$MyUi$noShrinking
					]),
				_List_fromArray(
					[
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$width(
								$author$project$Ui$px(48))
							]),
						A2(
							$author$project$Ui$Input$text,
							_List_fromArray(
								[
									$author$project$Ui$border(1),
									$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
									$author$project$Ui$background($author$project$MyUi$inputBackground),
									$author$project$Ui$rounded(4),
									$author$project$Ui$paddingXY$(8, 4)
								]),
							{
								label: groupLabel2.id,
								onChange: A2($author$project$SheepGame$TypedGroup, userId, questionId),
								placeholder: $elm$core$Maybe$Nothing,
								text: $elm$core$Maybe$withDefault$(
									'',
									$lamdera$containers$SeqDict$get$(
										_Utils_Tuple2(userId, questionId),
										shared.groups))
							})),
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$Font$weight(600),
								$author$project$Ui$width($author$project$Ui$shrink),
								$author$project$MyUi$noShrinking
							]),
						$author$project$Ui$text(
							$author$project$User$toStringAlt$(userId, localUser)))
					])),
				$author$project$Ui$Lazy$lazy6$(
				$author$project$SheepGame$groupingAnswerContent,
				minutes,
				contentWidth,
				localUser,
				$author$project$Id$toInt(questionId),
				$author$project$Id$toInt(userId),
				answer)
			]));
};
var $author$project$SheepGame$groupingAnswerView = F7($author$project$SheepGame$groupingAnswerView$);
var $author$project$MessageView$MessageView_MouseEnteredMessage = {$: 3};
var $author$project$MessageView$MessageView_MouseExitedMessage = {$: 4};
var $author$project$SheepGame$ReactionMsg$ = function (a, b) {
	return {$: 23, a: a, b: b};
};
var $author$project$SheepGame$ReactionMsg = F2($author$project$SheepGame$ReactionMsg$);
var $author$project$MessageView$ReactionsHovered = {$: 0};
var $author$project$MessageView$ReactionsNotHovered = {$: 1};
var $author$project$MessageView$MessageViewMsg_PressedReply = {$: 12};
var $author$project$MessageView$MessageViewMsg_PressedShowReactionEmojiSelector = {$: 10};
var $author$project$MessageView$miniButtonSize = 36;
var $author$project$MessageView$miniButton$ = function (htmlId, onPress, hoverText, svg) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$width(
				$author$project$Ui$px($author$project$MessageView$miniButtonSize)),
				$author$project$Ui$height(
				$author$project$Ui$px($author$project$MessageView$miniButtonSize)),
				$author$project$Ui$contentCenterX,
				$author$project$Ui$contentCenterY,
				$author$project$Ui$id(
				$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId)),
				$author$project$Ui$Events$stopPropagationOn$(
				'click',
				$elm$json$Json$Decode$succeed(
					_Utils_Tuple2(onPress, true))),
				$author$project$Ui$pointer,
				$author$project$MyUi$hoverText(hoverText),
				$author$project$MyUi$hover$(
				false,
				_List_fromArray(
					[
						$author$project$Ui$Anim$backgroundColor($author$project$MyUi$hoverHighlight)
					])),
				$author$project$MyUi$htmlStyle$('user-select', 'none'),
				$author$project$MyUi$htmlStyle$('-webkit-user-select', 'none')
			]),
		$author$project$Ui$html(svg));
};
var $author$project$MessageView$miniButton = F4($author$project$MessageView$miniButton$);
var $author$project$MessageView$MessageViewMsg_PressedReactionEmoji = function (a) {
	return {$: 16, a: a};
};
var $author$project$MessageView$recentEmojiButtons$ = function (user, availableCustomEmojis, emojiData, customEmojis) {
	return $elm$core$List$indexedMap$(
		F2(
			function (index, _v0) {
				var emoji = _v0.a;
				return $author$project$MessageView$miniButton$(
					$lamdera$program_test$Effect$Browser$Dom$id(
						'miniView_emojiReact_' + $elm$core$String$fromInt(index)),
					$author$project$MessageView$MessageViewMsg_PressedReactionEmoji(emoji),
					'',
					$author$project$MessageView$reactionEmojiButtonContent$(emojiData, customEmojis, emoji));
			}),
		$elm$core$List$take$(
			3,
			$author$project$User$commonlyUsedEmojis$(availableCustomEmojis, user)));
};
var $author$project$MessageView$recentEmojiButtons = F4($author$project$MessageView$recentEmojiButtons$);
var $author$project$MessageView$gameMiniViewNearEdge$ = function (user, availableCustomEmojis, emojiData, customEmojis) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$alignRight,
				$author$project$Ui$background($author$project$MyUi$background1),
				$author$project$Ui$rounded(4),
				$author$project$Ui$borderColor($author$project$MyUi$border1),
				$author$project$Ui$border(1),
				$author$project$Ui$move(
				{x: -8, y: -16, z: 0}),
				$author$project$Ui$height(
				$author$project$Ui$px($author$project$MessageView$miniButtonSize)),
				$author$project$Ui$clip,
				$author$project$MyUi$htmlStyle$('z-index', '1')
			]),
		_Utils_ap(
			$author$project$MessageView$recentEmojiButtons$(user, availableCustomEmojis, emojiData, customEmojis),
			_List_fromArray(
				[
					$author$project$MessageView$miniButton$(
					$lamdera$program_test$Effect$Browser$Dom$id('miniView_showReactionEmojiSelector'),
					$author$project$MessageView$MessageViewMsg_PressedShowReactionEmojiSelector,
					'Add reaction',
					$author$project$Icons$smile),
					$author$project$MessageView$miniButton$(
					$lamdera$program_test$Effect$Browser$Dom$id('miniView_reply'),
					$author$project$MessageView$MessageViewMsg_PressedReply,
					'Reply',
					$author$project$Icons$reply(24))
				])));
};
var $author$project$MessageView$gameMiniViewNearEdge = F4($author$project$MessageView$gameMiniViewNearEdge$);
var $author$project$MyUi$highlightSettledOpacity = 0.5;
var $author$project$Ui$Anim$OnRender = 3;
var $author$project$Animator$Animation = $elm$core$Basics$identity;
var $author$project$Animator$toOccurring$ = function (currentTime, _v0) {
	var dur = _v0.a;
	var props = _v0.b;
	var time = $author$project$InternalAnim$Time$advanceBy$(dur, currentTime);
	return _Utils_Tuple2(
		time,
		$author$project$InternalAnim$Timeline$Occurring$(props, time, time));
};
var $author$project$Animator$toOccurring = F2($author$project$Animator$toOccurring$);
var $author$project$Animator$keyframes = function (steps) {
	var imminent = $author$project$InternalAnim$Time$absolute(
		$elm$time$Time$millisToPosix(1));
	var firstEventTime = imminent;
	var _v0 = function () {
		if (!steps.b) {
			return _Utils_Tuple2(
				$author$project$InternalAnim$Timeline$Occurring$(_List_Nil, imminent, imminent),
				_List_Nil);
		} else {
			var _v2 = steps.a;
			var dur = _v2.a;
			var props = _v2.b;
			var r = steps.b;
			var eventEnd = $author$project$InternalAnim$Time$advanceBy$(dur, firstEventTime);
			return _Utils_Tuple2(
				$author$project$InternalAnim$Timeline$Occurring$(props, firstEventTime, eventEnd),
				r);
		}
	}();
	var firstOccurring = _v0.a;
	var remaining = _v0.b;
	var timeline = {
		delay: $author$project$InternalAnim$Time$zeroDuration,
		events: _List_fromArray(
			[
				$author$project$InternalAnim$Timeline$Line$(
				imminent,
				firstOccurring,
				$elm$core$List$foldl$(
					F2(
						function (currentStep, _v3) {
							var time = _v3.a;
							var occurs = _v3.b;
							var _v4 = $author$project$Animator$toOccurring$(time, currentStep);
							var newTime = _v4.a;
							var occur = _v4.b;
							return _Utils_Tuple2(
								newTime,
								A2($elm$core$List$cons, occur, occurs));
						}),
					_Utils_Tuple2(firstEventTime, _List_Nil),
					remaining).b)
			]),
		initial: function () {
			if (!steps.b) {
				return _List_Nil;
			} else {
				var _v6 = steps.a;
				var props = _v6.b;
				return props;
			}
		}(),
		interruption: _List_Nil,
		now: imminent,
		queued: $elm$core$Maybe$Nothing,
		running: true,
		scale: 1,
		updatedAt: imminent
	};
	return {
		allowTransitions: 1,
		attrs: $author$project$InternalAnim$Css$propsToRenderedProps$(timeline, $elm$core$Basics$identity),
		now: $author$project$InternalAnim$Timeline$getUpdatedAt(timeline)
	};
};
var $author$project$Animator$toCss = function (_v0) {
	var anim = _v0;
	return $author$project$InternalAnim$Css$toCss(anim);
};
var $author$project$Ui$Anim$keyframes = function (steps) {
	return $author$project$Ui$Anim$toAttr$(
		3,
		$author$project$Animator$toCss(
			$author$project$Animator$keyframes(steps)));
};
var $author$project$Animator$Step$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Animator$Step = F2($author$project$Animator$Step$);
var $author$project$Animator$addSequence$ = function (n, steps, prop) {
	var fullDuration = $author$project$Animator$sumStepDuration$($author$project$InternalAnim$Time$zeroDuration, steps);
	return $author$project$Animator$Step$(
		fullDuration,
		$elm$core$List$map$(
			A3($author$project$Animator$addSequenceSteps, n, fullDuration, steps),
			prop));
};
var $author$project$Animator$addSequence = F3($author$project$Animator$addSequence$);
var $author$project$Animator$loopFor$ = function (n, steps) {
	var initialProps = $author$project$Animator$getInitialProps$($author$project$InternalAnim$Time$zeroDuration, steps, _List_Nil);
	return $author$project$Animator$addSequence$(n, steps, initialProps);
};
var $author$project$Animator$loopFor = F2($author$project$Animator$loopFor$);
var $author$project$Ui$Anim$loopFor = $author$project$Animator$loopFor;
var $author$project$InternalAnim$Css$Props$AsFloat = {$: 0};
var $author$project$InternalAnim$Css$Props$float = $author$project$InternalAnim$Css$Props$AsFloat;
var $author$project$InternalAnim$Css$Props$ids = {opacity: 13, rotation: 3, scale: 4, scaleX: 5, scaleY: 6, scaleZ: 7, x: 0, y: 1, z: 2};
var $author$project$Animator$opacity = function (o) {
	return $author$project$InternalAnim$Css$Prop$(
		$author$project$InternalAnim$Css$Props$ids.opacity,
		'opacity',
		$author$project$InternalAnim$Move$to(o),
		$author$project$InternalAnim$Css$Props$float);
};
var $author$project$Ui$Anim$opacity = $author$project$Animator$opacity;
var $author$project$Animator$step = $author$project$Animator$Step;
var $author$project$Ui$Anim$step = $author$project$Animator$step;
var $author$project$MyUi$highlightFadeOut = function (color) {
	return $author$project$Ui$behindContent(
		$author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$height($author$project$Ui$fill),
					$author$project$Ui$background(color),
					$author$project$Ui$Anim$keyframes(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Anim$loopFor,
							1,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Anim$step,
									$author$project$Ui$Anim$ms(2800),
									_List_fromArray(
										[
											$author$project$Ui$Anim$opacity(1)
										])),
									A2(
									$author$project$Ui$Anim$step,
									$author$project$Ui$Anim$ms(1200),
									_List_fromArray(
										[
											$author$project$Ui$Anim$opacity($author$project$MyUi$highlightSettledOpacity)
										]))
								]))
						]))
				]),
			$author$project$Ui$none));
};
var $author$project$MyUi$hoverHighlightLayer = $author$project$Ui$behindContent(
	$author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$Ui$background($author$project$MyUi$hoverHighlight)
			]),
		$author$project$Ui$none));
var $author$project$MessageView$MessageView_PressedReactionEmoji_Add = function (a) {
	return {$: 8, a: a};
};
var $author$project$MessageView$MessageView_PressedReactionEmoji_Remove = function (a) {
	return {$: 7, a: a};
};
var $author$project$Internal$Model2$Above = 0;
var $author$project$Ui$above = function (element) {
	return $author$project$Internal$Model2$nearby$(0, element);
};
var $author$project$MyUi$highlightedBorder = $author$project$Ui$rgb$(12, 140, 200);
var $author$project$MessageView$reactionSpacing = 4;
var $author$project$MessageView$reactionButtonOffsets$ = function (rowWidth, widths) {
	return $elm$core$List$reverse(
		$elm$core$List$foldl$(
			F2(
				function (width, _v0) {
					var nextOffset = _v0.a;
					var offsets = _v0.b;
					return ((nextOffset > 0) && (_Utils_cmp(nextOffset + width, rowWidth) > 0)) ? _Utils_Tuple2(
						width + $author$project$MessageView$reactionSpacing,
						A2($elm$core$List$cons, 0, offsets)) : _Utils_Tuple2(
						(nextOffset + width) + $author$project$MessageView$reactionSpacing,
						A2($elm$core$List$cons, nextOffset, offsets));
				}),
			_Utils_Tuple2(0, _List_Nil),
			widths).b);
};
var $author$project$MessageView$reactionButtonOffsets = F2($author$project$MessageView$reactionButtonOffsets$);
var $lamdera$containers$SeqSet$size = function (_v0) {
	var dict = _v0;
	return $lamdera$containers$SeqDict$size(dict);
};
var $author$project$NonemptySet$size = function (_v0) {
	var set = _v0.b;
	return $lamdera$containers$SeqSet$size(set) + 1;
};
var $author$project$MessageView$reactionButtonWidth = function (users) {
	return ($author$project$NonemptySet$size(users) < 10) ? 52 : 60;
};
var $author$project$MessageView$reactionCountView = function (users) {
	return ($author$project$NonemptySet$size(users) > 99) ? $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$width($author$project$Ui$shrink),
				$author$project$MyUi$noShrinking,
				$author$project$Ui$centerY
			]),
		$author$project$Ui$html(
			$author$project$Icons$infinity(16))) : $author$project$Ui$text(
		$elm$core$String$fromInt(
			$author$project$NonemptySet$size(users)));
};
var $author$project$Emoji$firstShortName$ = function (emojiData, emoji) {
	return $elm$core$Maybe$andThen$(
		function (data) {
			return $elm$core$List$head(data.shortNames);
		},
		$lamdera$containers$SeqDict$get$(emoji, emojiData.emojis));
};
var $author$project$Emoji$firstShortName = F2($author$project$Emoji$firstShortName$);
var $elm$core$List$intersperse$ = function (sep, xs) {
	if (!xs.b) {
		return _List_Nil;
	} else {
		var hd = xs.a;
		var tl = xs.b;
		var step = F2(
			function (x, rest) {
				return A2(
					$elm$core$List$cons,
					sep,
					A2($elm$core$List$cons, x, rest));
			});
		var spersed = $elm$core$List$foldr$(step, _List_Nil, tl);
		return A2($elm$core$List$cons, hd, spersed);
	}
};
var $elm$core$List$intersperse = F2($elm$core$List$intersperse$);
var $author$project$Internal$Model2$AsParagraph = 4;
var $author$project$Internal$Model2$NodeAsParagraph = {$: 3};
var $author$project$Ui$Prose$paragraph$ = function (attrs, children) {
	return $author$project$Internal$Model2$element$(
		$author$project$Internal$Model2$NodeAsParagraph,
		4,
		A2(
			$elm$core$List$cons,
			$author$project$Ui$width($author$project$Ui$fill),
			attrs),
		children);
};
var $author$project$Ui$Prose$paragraph = F2($author$project$Ui$Prose$paragraph$);
var $author$project$MessageView$reactionPopupArrowOffset = 11;
var $author$project$MessageView$reactionPopupArrowFromLeft = $author$project$Ui$html(
	A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
				A2($elm$html$Html$Attributes$style, 'top', 'calc(100% - 1px)'),
				A2(
				$elm$html$Html$Attributes$style,
				'left',
				$elm$core$String$fromInt($author$project$MessageView$reactionPopupArrowOffset) + 'px'),
				A2($elm$html$Html$Attributes$style, 'width', '0'),
				A2($elm$html$Html$Attributes$style, 'height', '0'),
				A2($elm$html$Html$Attributes$style, 'border-left', '8px solid transparent'),
				A2($elm$html$Html$Attributes$style, 'border-right', '8px solid transparent'),
				A2(
				$elm$html$Html$Attributes$style,
				'border-top',
				'8px solid ' + $author$project$MyUi$colorToStyle($author$project$MyUi$background1)),
				A2($elm$html$Html$Attributes$style, 'pointer-events', 'none')
			]),
		_List_Nil));
var $author$project$MessageView$reactionPopupArrowFromRight = function (arrowFromRight) {
	return $author$project$Ui$html(
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
					A2($elm$html$Html$Attributes$style, 'top', 'calc(100% - 1px)'),
					A2(
					$elm$html$Html$Attributes$style,
					'right',
					$elm$core$String$fromInt(arrowFromRight) + 'px'),
					A2($elm$html$Html$Attributes$style, 'width', '0'),
					A2($elm$html$Html$Attributes$style, 'height', '0'),
					A2($elm$html$Html$Attributes$style, 'border-left', '8px solid transparent'),
					A2($elm$html$Html$Attributes$style, 'border-right', '8px solid transparent'),
					A2(
					$elm$html$Html$Attributes$style,
					'border-top',
					'8px solid ' + $author$project$MyUi$colorToStyle($author$project$MyUi$background1)),
					A2($elm$html$Html$Attributes$style, 'pointer-events', 'none')
				]),
			_List_Nil));
};
var $mgold$elm_nonempty_list$List$Nonempty$take$ = function (n, _v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
		x,
		$elm$core$List$take$(n - 1, xs));
};
var $mgold$elm_nonempty_list$List$Nonempty$take = F2($mgold$elm_nonempty_list$List$Nonempty$take$);
var $author$project$NonemptySet$toNonemptyList = function (_v0) {
	var id = _v0.a;
	var set = _v0.b;
	return $lamdera$containers$SeqSet$foldr$(
		F2(
			function (k, list) {
				return $mgold$elm_nonempty_list$List$Nonempty$cons$(k, list);
			}),
		$mgold$elm_nonempty_list$List$Nonempty$Nonempty$(id, _List_Nil),
		set);
};
var $author$project$MessageView$reactionPopup$ = function (emojiData, customEmojis, allUsers, placement, emoji, users) {
	var names = $mgold$elm_nonempty_list$List$Nonempty$map$(
		function (userId) {
			var _v5 = $lamdera$containers$SeqDict$get$(userId, allUsers);
			if (!_v5.$) {
				var user = _v5.a;
				return $author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$Font$color($author$project$MyUi$font1),
							$author$project$Ui$width($author$project$Ui$shrink)
						]),
					$author$project$Ui$text(
						$author$project$PersonName$toString(user.name)));
			} else {
				return $author$project$Ui$text('<Missing>');
			}
		},
		$author$project$NonemptySet$toNonemptyList(users));
	var nameCount = $mgold$elm_nonempty_list$List$Nonempty$length(names);
	var namesParagraph = $author$project$Ui$Prose$paragraph$(
		_List_fromArray(
			[
				$author$project$Ui$Font$size(14),
				$author$project$Ui$width($author$project$Ui$fill)
			]),
		function () {
			if (nameCount > 10) {
				var visible = $elm$core$List$intersperse$(
					$author$project$Ui$text(', '),
					$mgold$elm_nonempty_list$List$Nonempty$toList(
						$mgold$elm_nonempty_list$List$Nonempty$take$(8, names)));
				return _Utils_ap(
					visible,
					_List_fromArray(
						[
							$author$project$Ui$text(', and '),
							$author$project$Ui$text(
							$elm$core$String$fromInt(nameCount - 8)),
							$author$project$Ui$text(' more')
						]));
			} else {
				var _v4 = $mgold$elm_nonempty_list$List$Nonempty$tail(names);
				if (!_v4.b) {
					return _List_fromArray(
						[
							$mgold$elm_nonempty_list$List$Nonempty$head(names)
						]);
				} else {
					if (!_v4.b.b) {
						var two = _v4.a;
						return _List_fromArray(
							[
								$mgold$elm_nonempty_list$List$Nonempty$head(names),
								$author$project$Ui$text(' and '),
								two
							]);
					} else {
						var rest = _v4;
						return _Utils_ap(
							$elm$core$List$intersperse$(
								$author$project$Ui$text(', '),
								rest),
							_List_fromArray(
								[
									$author$project$Ui$text(', and '),
									$mgold$elm_nonempty_list$List$Nonempty$head(names)
								]));
					}
				}
			}
		}());
	var maybeEmojiName = function () {
		if (!emoji.$) {
			var emoji2 = emoji.a;
			return $elm$core$Maybe$map$(
				function (name) {
					return ':' + (name + ':');
				},
				$elm$core$Maybe$andThen$(
					function (cached) {
						return $author$project$Emoji$firstShortName$(cached, emoji2);
					},
					emojiData));
		} else {
			var customEmojiId = emoji.a;
			return $elm$core$Maybe$map$(
				function (customEmoji) {
					return ':' + ($author$project$CustomEmoji$emojiNameToString(customEmoji.name) + ':');
				},
				$lamdera$containers$SeqDict$get$(customEmojiId, customEmojis));
		}
	}();
	return $author$project$Ui$row$(
		_Utils_ap(
			_List_fromArray(
				[
					$author$project$Ui$htmlAttribute(
					$elm$html$Html$Attributes$class('emoji-popup')),
					$author$project$Ui$width($author$project$Ui$shrink),
					$author$project$MyUi$htmlStyle$('width', 'max-content'),
					$author$project$MyUi$htmlStyle$('position', 'absolute'),
					$author$project$MyUi$htmlStyle$('bottom', '8px'),
					$author$project$Ui$background($author$project$MyUi$background1),
					$author$project$Ui$borderColor($author$project$MyUi$border1),
					$author$project$Ui$border(1),
					$author$project$Ui$rounded(8),
					$author$project$Ui$padding(8),
					$author$project$Ui$spacing(8),
					$author$project$Ui$Font$color($author$project$MyUi$font3),
					$author$project$MyUi$noPointerEvents,
					$author$project$Ui$Shadow$shadows(
					_List_fromArray(
						[
							{
							blur: 8,
							color: $author$project$Ui$rgba$(0, 0, 0, 0.3),
							size: 0,
							x: 0,
							y: 2
						}
						])),
					$author$project$Ui$contentCenterY
				]),
			function () {
				if (!placement.$) {
					var maxWidth = placement.a.maxWidth;
					return _List_fromArray(
						[
							$author$project$MyUi$htmlStyle$('left', '0'),
							$author$project$MyUi$htmlStyle$(
							'max-width',
							$elm$core$String$fromInt(maxWidth) + 'px'),
							$author$project$Ui$inFront($author$project$MessageView$reactionPopupArrowFromLeft)
						]);
				} else {
					var arrowFromRight = placement.a.arrowFromRight;
					var maxWidth = placement.a.maxWidth;
					return _List_fromArray(
						[
							$author$project$MyUi$htmlStyle$('right', '0'),
							$author$project$MyUi$htmlStyle$(
							'max-width',
							$elm$core$String$fromInt(maxWidth) + 'px'),
							$author$project$Ui$inFront(
							$author$project$MessageView$reactionPopupArrowFromRight(arrowFromRight))
						]);
				}
			}()),
		_List_fromArray(
			[
				function () {
				if (!emoji.$) {
					var emoji2 = emoji.a;
					return $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$Font$size(40),
								$author$project$Ui$width($author$project$Ui$shrink),
								$author$project$MyUi$noShrinking
							]),
						$author$project$Ui$html(
							$author$project$Emoji$unicodeView$('1em', emojiData, emoji2)));
				} else {
					var customEmojiId = emoji.a;
					return $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$width($author$project$Ui$shrink),
								$author$project$MyUi$noShrinking
							]),
						$author$project$Ui$html(
							$author$project$CustomEmoji$view$('40px', '0em', customEmojiId, customEmojis, 2)));
				}
			}(),
				function () {
				if (!maybeEmojiName.$) {
					var emojiName = maybeEmojiName.a;
					return $author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$spacing(2)
							]),
						_List_fromArray(
							[
								$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$Font$size(14),
										$author$project$Ui$Font$bold,
										$author$project$Ui$Font$color($author$project$MyUi$font1)
									]),
								$author$project$Ui$text(emojiName)),
								namesParagraph
							]));
				} else {
					return namesParagraph;
				}
			}()
			]));
};
var $author$project$MessageView$reactionPopup = F6($author$project$MessageView$reactionPopup$);
var $author$project$MessageView$PopupOpensLeft = function (a) {
	return {$: 1, a: a};
};
var $author$project$MessageView$PopupOpensRight = function (a) {
	return {$: 0, a: a};
};
var $author$project$MessageView$reactionPopupArrowWidth = 16;
var $author$project$MessageView$reactionPopupMaxWidth = 400;
var $author$project$MessageView$reactionPopupPlacement$ = function (rowWidth, buttonWidth, buttonOffset) {
	var roomOnRight = rowWidth - buttonOffset;
	var roomOnLeft = buttonOffset + buttonWidth;
	return (_Utils_cmp(roomOnRight, roomOnLeft) > -1) ? $author$project$MessageView$PopupOpensRight(
		{
			maxWidth: $elm$core$Basics$min$($author$project$MessageView$reactionPopupMaxWidth, roomOnRight)
		}) : $author$project$MessageView$PopupOpensLeft(
		{
			arrowFromRight: ((buttonWidth - 4) - $author$project$MessageView$reactionPopupArrowOffset) - $author$project$MessageView$reactionPopupArrowWidth,
			maxWidth: $elm$core$Basics$min$($author$project$MessageView$reactionPopupMaxWidth, roomOnLeft)
		});
};
var $author$project$MessageView$reactionPopupPlacement = F3($author$project$MessageView$reactionPopupPlacement$);
var $author$project$MessageView$reactionRowWidth = function (containerWidth) {
	return (containerWidth + $author$project$User$profileImageSize) + $author$project$MessageView$profileImagePaddingRight;
};
var $author$project$Emoji$view$ = function (maybeEmojiData, emoji) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$Font$size(20),
				$author$project$Ui$width($author$project$Ui$shrink)
			]),
		$author$project$Ui$html(
			$author$project$Emoji$unicodeView$('1em', maybeEmojiData, emoji)));
};
var $author$project$Emoji$view = F2($author$project$Emoji$view$);
var $author$project$Ui$wrap = $author$project$Internal$Model2$style$('flex-wrap', 'wrap');
var $author$project$MessageView$reactionEmojiView$ = function (emojiData, isHovered, currentUserId, customEmojis, allUsers, animationMode, containerWidth, reactions) {
	if ($lamdera$containers$SeqDict$isEmpty(reactions)) {
		return $elm$core$Maybe$Nothing;
	} else {
		var rowWidth = $author$project$MessageView$reactionRowWidth(containerWidth);
		var entries = $lamdera$containers$SeqDict$toList(reactions);
		var widths = $elm$core$List$map$(
			function (_v4) {
				var users = _v4.b;
				return $author$project$MessageView$reactionButtonWidth(users);
			},
			entries);
		var placements = A3(
			$elm$core$List$map2,
			$author$project$MessageView$reactionPopupPlacement(rowWidth),
			widths,
			$author$project$MessageView$reactionButtonOffsets$(rowWidth, widths));
		return $elm$core$Maybe$Just(
			$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$wrap,
						$author$project$Ui$spacing($author$project$MessageView$reactionSpacing)
					]),
				$elm$core$List$indexedMap$(
					F2(
						function (index, _v0) {
							var _v1 = _v0.a;
							var emoji = _v1.a;
							var users = _v1.b;
							var placement = _v0.b;
							var hasReactedTo = $author$project$NonemptySet$member$(currentUserId, users);
							return A2(
								hasReactedTo ? A2(
									$author$project$MyUi$rowButton,
									$lamdera$program_test$Effect$Browser$Dom$id(
										'guild_removeReactionEmoji_' + $elm$core$String$fromInt(index)),
									$author$project$MessageView$MessageView_PressedReactionEmoji_Remove(emoji)) : A2(
									$author$project$MyUi$rowButton,
									$lamdera$program_test$Effect$Browser$Dom$id('guild_addReactionEmoji'),
									$author$project$MessageView$MessageView_PressedReactionEmoji_Add(emoji)),
								_Utils_ap(
									_List_fromArray(
										[
											$author$project$Ui$rounded(8),
											$author$project$Ui$spacing(2),
											$author$project$Ui$background($author$project$MyUi$background1),
											$author$project$Ui$paddingXY$(4, 0),
											$author$project$Ui$htmlAttribute(
											$elm$html$Html$Attributes$class('emoji-popup-container')),
											$author$project$Ui$htmlAttribute(
											A2(
												$elm$html$Html$Attributes$attribute,
												'data-reaction-index',
												$elm$core$String$fromInt(index))),
											$author$project$Ui$borderColor(
											hasReactedTo ? $author$project$MyUi$highlightedBorder : $author$project$MyUi$border1),
											$author$project$Ui$Font$color(
											hasReactedTo ? $author$project$MyUi$highlightedBorder : $author$project$MyUi$font2),
											$author$project$Ui$border(1),
											$author$project$Ui$width(
											$author$project$Ui$px(
												$author$project$MessageView$reactionButtonWidth(users))),
											$author$project$Ui$contentCenterX,
											$author$project$Ui$Font$weight(500)
										]),
									function () {
										switch (isHovered.$) {
											case 0:
												return _List_fromArray(
													[
														$author$project$Ui$above(
														$author$project$MessageView$reactionPopup$(emojiData, customEmojis, allUsers, placement, emoji, users))
													]);
											case 1:
												return _List_Nil;
											default:
												var longPressedIndex = isHovered.a;
												return _Utils_eq(longPressedIndex, index) ? _List_fromArray(
													[
														$author$project$Ui$above(
														$author$project$MessageView$reactionPopup$(emojiData, customEmojis, allUsers, placement, emoji, users)),
														$author$project$Ui$htmlAttribute(
														$elm$html$Html$Attributes$class('reaction-long-pressed'))
													]) : _List_Nil;
										}
									}()),
								_List_fromArray(
									[
										function () {
										if (!emoji.$) {
											var emoji2 = emoji.a;
											return $author$project$Emoji$view$(emojiData, emoji2);
										} else {
											var customEmojiId = emoji.a;
											return $author$project$Ui$el$(
												_List_fromArray(
													[
														$author$project$Ui$inFront(
														$author$project$Ui$el$(
															_List_fromArray(
																[
																	$author$project$Ui$centerY,
																	$author$project$Ui$move(
																	{x: 1, y: 0, z: 0})
																]),
															$author$project$Ui$html(
																$author$project$CustomEmoji$view$('1.1em', '0em', customEmojiId, customEmojis, animationMode)))),
														$author$project$Ui$Font$color(
														$author$project$Ui$rgba$(0, 0, 0, 0)),
														$author$project$Ui$Font$size(20)
													]),
												$author$project$Ui$text('❓'));
										}
									}(),
										$author$project$MessageView$reactionCountView(users)
									]));
						}),
					A3($elm$core$List$map2, $elm$core$Tuple$pair, entries, placements))));
	}
};
var $author$project$MessageView$reactionEmojiView = F8($author$project$MessageView$reactionEmojiView$);
var $author$project$MyUi$replyToColor = $author$project$Ui$rgb$(51, 51, 118);
var $author$project$SheepGame$reactableResult$ = function (paddingX2, localUser, contentWidth, target, hoveredResult, highlightedResult, reactions, content) {
	var isHovered = _Utils_eq(
		hoveredResult,
		$elm$core$Maybe$Just(target));
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$id(
				$lamdera$program_test$Effect$Browser$Dom$idToString(
					$author$project$SheepGame$reactionTargetId(target))),
				$author$project$Ui$paddingXY$(paddingX2, 4),
				$author$project$Ui$spacing(4),
				$author$project$Ui$attrIf$(isHovered, $author$project$MyUi$hoverHighlightLayer),
				$author$project$Ui$Events$onMouseEnter(
				$author$project$SheepGame$ReactionMsg$(target, $author$project$MessageView$MessageView_MouseEnteredMessage)),
				$author$project$Ui$Events$onMouseLeave(
				$author$project$SheepGame$ReactionMsg$(target, $author$project$MessageView$MessageView_MouseExitedMessage)),
				isHovered ? $author$project$Ui$inFront(
				A2(
					$author$project$Ui$map,
					$author$project$SheepGame$ReactionMsg(target),
					$author$project$MessageView$gameMiniViewNearEdge$(localUser.user, localUser.user.availableCustomEmojis, localUser.emojiData, localUser.customEmojis))) : $author$project$Ui$noAttr,
				$author$project$Ui$attrIf$(
				_Utils_eq(
					highlightedResult,
					$elm$core$Maybe$Just(target)),
				$author$project$MyUi$highlightFadeOut($author$project$MyUi$replyToColor))
			]),
		A2(
			$elm$core$List$cons,
			content,
			function () {
				var _v0 = $author$project$MessageView$reactionEmojiView$(
					localUser.emojiData,
					isHovered ? $author$project$MessageView$ReactionsHovered : $author$project$MessageView$ReactionsNotHovered,
					localUser.session.userId,
					localUser.customEmojis,
					$author$project$User$allUsers(localUser),
					isHovered ? 1 : 0,
					contentWidth - (paddingX2 * 2),
					reactions);
				if (!_v0.$) {
					var reactionRow = _v0.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$map,
							$author$project$SheepGame$ReactionMsg(target),
							reactionRow)
						]);
				} else {
					return _List_Nil;
				}
			}()));
};
var $author$project$SheepGame$reactableResult = F8($author$project$SheepGame$reactableResult$);
var $author$project$SheepGame$groupingNotesPreview$ = function (isMobile, minutes, contentWidth, localUser, questionIndex, draft) {
	var _v0 = $author$project$SheepGame$validateInput$(
		localUser.timezone,
		$author$project$User$allUsers(localUser),
		draft);
	if (!_v0.$) {
		var toNotes = _v0.a;
		var notes = toNotes(0);
		return $author$project$SheepGame$reactableResult$(
			$author$project$SheepGame$paddingX(isMobile),
			localUser,
			contentWidth,
			$author$project$SheepGame$NotesReaction(
				$author$project$Id$fromInt(questionIndex)),
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			notes.reactions,
			$author$project$SheepGame$messageWithProfile$(
				localUser.session.userId,
				localUser,
				$author$project$SheepGame$contentView$(
					$author$project$SheepGame$fromMinutes(minutes),
					contentWidth,
					localUser,
					false,
					$lamdera$program_test$Effect$Browser$Dom$id(
						'sheepGame_groupingNotesPreview_' + $elm$core$String$fromInt(questionIndex)),
					notes.attachedFiles,
					notes.text)));
	} else {
		return $author$project$Ui$none;
	}
};
var $author$project$SheepGame$groupingNotesPreview = F6($author$project$SheepGame$groupingNotesPreview$);
var $author$project$SheepGame$answerGroupPaddingX = 8;
var $author$project$RichText$hasLargeContent = function (richText) {
	return $mgold$elm_nonempty_list$List$Nonempty$any$(
		function (richText2) {
			switch (richText2.$) {
				case 3:
					var a = richText2.a;
					return $author$project$RichText$hasLargeContent(a);
				case 0:
					return false;
				case 1:
					return false;
				case 2:
					return false;
				case 4:
					var a = richText2.a;
					return $author$project$RichText$hasLargeContent(a);
				case 5:
					var a = richText2.a;
					return $author$project$RichText$hasLargeContent(a);
				case 6:
					var a = richText2.a;
					return $author$project$RichText$hasLargeContent(a);
				case 7:
					var a = richText2.a;
					return $author$project$RichText$hasLargeContent(a);
				case 8:
					return true;
				case 9:
					var a = richText2.c;
					return $author$project$RichText$hasLargeContent(a);
				case 10:
					return false;
				case 11:
					return false;
				case 12:
					return false;
				case 13:
					return true;
				case 14:
					return true;
				case 15:
					return false;
				case 16:
					return true;
				case 17:
					return false;
				case 18:
					var a = richText2.b;
					return $mgold$elm_nonempty_list$List$Nonempty$any$(
						function (list) {
							var _v1 = $mgold$elm_nonempty_list$List$Nonempty$fromList(list);
							if (!_v1.$) {
								var nonempty = _v1.a;
								return $author$project$RichText$hasLargeContent(nonempty);
							} else {
								return false;
							}
						},
						a);
				default:
					return false;
			}
		},
		richText);
};
var $author$project$SheepGame$userColor$ = function (userId, local) {
	var _v0 = $author$project$User$getUser$(userId, local);
	if (!_v0.$) {
		var user = _v0.a;
		return $author$project$UserColor$toColor(user.color);
	} else {
		return $author$project$UserColor$toColor($author$project$RichText$defaultColor);
	}
};
var $author$project$SheepGame$userColor = F2($author$project$SheepGame$userColor$);
var $author$project$Ui$widthMax = function (x) {
	return $author$project$Internal$Model2$styleAndClass$(
		$author$project$Internal$Flag$skip,
		{
			_class: $author$project$Internal$Style2$classes.widthBounded,
			styleName: 'max-width',
			styleVal: $author$project$Internal$Style2$px(x)
		});
};
var $author$project$Ui$widthMin = function (x) {
	return $author$project$Internal$Model2$styleAndClass$(
		$author$project$Internal$Flag$skip,
		{
			_class: $author$project$Internal$Style2$classes.widthBounded,
			styleName: 'min-width',
			styleVal: $author$project$Internal$Style2$px(x)
		});
};
var $author$project$SheepGame$answerResultView$ = function (time, localUser, contentWidth, hoveredResult, highlightedResult, questionId, userId, answer) {
	return $author$project$SheepGame$reactableResult$(
		$author$project$SheepGame$answerGroupPaddingX,
		localUser,
		contentWidth,
		$author$project$SheepGame$AnswerReaction$(userId, questionId),
		hoveredResult,
		highlightedResult,
		answer.reactions,
		($author$project$RichText$hasLargeContent(answer.text) ? $author$project$Ui$column(
			_List_fromArray(
				[
					$author$project$Ui$spacing(8),
					$author$project$Ui$widthMin(200)
				])) : $author$project$Ui$row(
			_List_fromArray(
				[
					$author$project$Ui$spacing(8),
					$author$project$Ui$widthMin(200)
				])))(
			_List_fromArray(
				[
					$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$widthMax(
							$elm$core$Basics$round(contentWidth * 0.5)),
							$author$project$Ui$width($author$project$Ui$shrink),
							$author$project$Ui$Font$bold,
							$author$project$Ui$Font$color(
							$author$project$SheepGame$userColor$(userId, localUser)),
							$author$project$Ui$alignTop,
							$author$project$Ui$clipWithEllipsis
						]),
					$author$project$Ui$text(
						$author$project$User$toStringAlt$(userId, localUser))),
					$author$project$SheepGame$contentView$(
					time,
					$elm$core$Basics$min$(300, contentWidth - ($author$project$SheepGame$answerGroupPaddingX * 2)),
					localUser,
					_Utils_eq(
						hoveredResult,
						$elm$core$Maybe$Just(
							$author$project$SheepGame$AnswerReaction$(userId, questionId))),
					$lamdera$program_test$Effect$Browser$Dom$id(
						'sheepGame_answerReveal_' + ($author$project$Id$toString(questionId) + ('_' + $author$project$Id$toString(userId)))),
					answer.attachedFiles,
					answer.text)
				])));
};
var $author$project$SheepGame$answerResultView = F8($author$project$SheepGame$answerResultView$);
var $author$project$SheepGame$groupingPreviewAnswer$ = function (minutes, contentWidth, localUser, questionIndex, userIdInt, answer) {
	return $author$project$SheepGame$answerResultView$(
		$author$project$SheepGame$fromMinutes(minutes),
		localUser,
		contentWidth,
		$elm$core$Maybe$Nothing,
		$elm$core$Maybe$Nothing,
		$author$project$Id$fromInt(questionIndex),
		$author$project$Id$fromInt(userIdInt),
		answer);
};
var $author$project$SheepGame$groupingPreviewAnswer = F6($author$project$SheepGame$groupingPreviewAnswer$);
var $author$project$SheepGame$groupingQuestionText$ = function (minutes, contentWidth, localUser, isHovered, questionIndex, question) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$Font$weight(600)
			]),
		$author$project$SheepGame$questionView$(
			$author$project$SheepGame$fromMinutes(minutes),
			contentWidth,
			localUser,
			isHovered ? $elm$core$Maybe$Just(
				$author$project$Id$fromInt(questionIndex)) : $elm$core$Maybe$Nothing,
			$author$project$Id$fromInt(questionIndex),
			$lamdera$program_test$Effect$Browser$Dom$id(
				'sheepGame_groupingQuestion_' + $elm$core$String$fromInt(questionIndex)),
			question));
};
var $author$project$SheepGame$groupingQuestionText = F6($author$project$SheepGame$groupingQuestionText$);
var $author$project$Ui$Lazy$apply5$ = function (fn, a, b, c, d, e, s) {
	return $author$project$Internal$Model2$unwrap$(
		s,
		A5(fn, a, b, c, d, e));
};
var $author$project$Ui$Lazy$apply5 = F7($author$project$Ui$Lazy$apply5$);
var $elm$virtual_dom$VirtualDom$lazy7 = _VirtualDom_lazy7;
var $elm$html$Html$Lazy$lazy7 = $elm$virtual_dom$VirtualDom$lazy7;
var $author$project$Ui$Lazy$lazy5$ = function (fn, a, b, c, d, e) {
	return function (s) {
		return A8($elm$html$Html$Lazy$lazy7, $author$project$Ui$Lazy$apply5, fn, a, b, c, d, e, s);
	};
};
var $author$project$Ui$Lazy$lazy5 = F6($author$project$Ui$Lazy$lazy5$);
var $author$project$SheepGame$PressedDeleteNotesFile$ = function (a, b) {
	return {$: 12, a: a, b: b};
};
var $author$project$SheepGame$PressedDeleteNotesFile = F2($author$project$SheepGame$PressedDeleteNotesFile$);
var $author$project$SheepGame$PressedToggleNotesFileSpoiler$ = function (a, b) {
	return {$: 14, a: a, b: b};
};
var $author$project$SheepGame$PressedToggleNotesFileSpoiler = F2($author$project$SheepGame$PressedToggleNotesFileSpoiler$);
var $author$project$SheepGame$PressedViewNotesFileInfo$ = function (a, b) {
	return {$: 13, a: a, b: b};
};
var $author$project$SheepGame$PressedViewNotesFileInfo = F2($author$project$SheepGame$PressedViewNotesFileInfo$);
var $author$project$SheepGame$TypedNotes$ = function (a, b) {
	return {$: 9, a: a, b: b};
};
var $author$project$SheepGame$TypedNotes = F2($author$project$SheepGame$TypedNotes$);
var $author$project$SheepGame$maxNoteLength = 400;
var $author$project$SheepGame$notesInput$ = function (localUser, typedTextCounter, textInputFocus, questionIndex, notes) {
	var users = $author$project$User$allUsers(localUser);
	var richText = $elm$core$Maybe$map$(
		A3($author$project$RichText$fromNonemptyString, localUser.timezone, users, $lamdera$containers$SeqDict$empty),
		$MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(notes.text));
	var questionId = $author$project$Id$fromInt(questionIndex);
	var htmlId = $author$project$SheepGame$inputId(
		$author$project$SheepGame$NotesInput(questionId));
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(4)
			]),
		_List_fromArray(
			[
				function () {
				var _v0 = $author$project$NonemptyDict$fromSeqDict(notes.attachedFiles);
				if (!_v0.$) {
					var attachedFiles = _v0.a;
					return $author$project$Ui$row$(
						_List_fromArray(
							[
								$author$project$Ui$spacing(2),
								$author$project$Ui$width($author$project$Ui$shrink)
							]),
						$author$project$SheepGame$fileUploadPreview$(
							$author$project$SheepGame$PressedDeleteNotesFile(questionId),
							$author$project$SheepGame$PressedViewNotesFileInfo(questionId),
							$elm$core$Maybe$Just(
								$author$project$SheepGame$PressedToggleNotesFileSpoiler(questionId)),
							richText,
							attachedFiles));
				} else {
					return $author$project$Ui$none;
				}
			}(),
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$map,
						$author$project$SheepGame$TypedNotes(questionId),
						$author$project$MessageInput$attachmentButton(
							$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId))),
						A2(
						$author$project$Ui$map,
						$author$project$SheepGame$TypedNotes(questionId),
						$author$project$MessageInput$showEmojiSelectorButton(
							$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId))),
						$author$project$Ui$el$(
						_List_Nil,
						$author$project$Ui$el$(
							A2(
								$elm$core$List$cons,
								$author$project$Ui$heightMax(200),
								A2(
									$elm$core$List$cons,
									$author$project$Ui$id(
										$lamdera$program_test$Effect$Browser$Dom$idToString(
											$author$project$SheepGame$inputContainerId(
												$author$project$SheepGame$NotesInput(questionId)))),
									$author$project$MessageInput$containerAttributes(true))),
							A2(
								$author$project$Ui$map,
								$author$project$SheepGame$TypedNotes(questionId),
								$author$project$Ui$html(
									$author$project$MessageInput$textarea$(
										true,
										htmlId,
										$elm$html$Html$text('\u00A0'),
										$author$project$SheepGame$maxNoteLength - $elm$core$String$length(notes.text),
										notes.text,
										richText,
										notes.attachedFiles,
										localUser,
										{textInputFocus: textInputFocus, typedTextCounter: typedTextCounter},
										users,
										$lamdera$containers$SeqDict$empty)))))
					]))
			]));
};
var $author$project$SheepGame$notesInput = F5($author$project$SheepGame$notesInput$);
var $author$project$SheepGame$toMinutes = function (time) {
	return ($lamdera$program_test$Effect$Time$posixToMillis(time) / 60000) | 0;
};
var $author$project$SheepGame$groupingQuestionView$ = function (isMobile, time, contentWidth, localUser, loggedIn, shared, model, playerIds, questionIndex, question) {
	var questionId = $author$project$Id$fromInt(questionIndex);
	var minutes = $author$project$SheepGame$toMinutes(time);
	var answers = $elm$core$List$filterMap$(
		function (userId) {
			var _v3 = $author$project$SheepGame$answerFor$(userId, questionId, shared);
			if (!_v3.$) {
				var answer = _v3.a;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(userId, answer));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		playerIds);
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Lazy$lazy6$(
				$author$project$SheepGame$groupingQuestionText,
				minutes,
				contentWidth,
				localUser,
				_Utils_eq(
					model.hoveredQuestion,
					$elm$core$Maybe$Just(questionId)),
				questionIndex,
				question),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				$elm$core$List$map$(
					function (_v0) {
						var userId = _v0.a;
						var answer = _v0.b;
						return $author$project$SheepGame$groupingAnswerView$(minutes, contentWidth, localUser, questionId, userId, shared, answer);
					},
					answers)),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(2)
					]),
				_List_fromArray(
					[
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$Font$color($author$project$MyUi$font3),
								$author$project$Ui$Font$size(14)
							]),
						$author$project$Ui$text('Notes')),
						$author$project$Ui$Lazy$lazy5$(
						$author$project$SheepGame$notesInput,
						localUser,
						loggedIn.typedTextCounter,
						loggedIn.textInputFocus,
						questionIndex,
						$elm$core$Maybe$withDefault$(
							$author$project$SheepGame$emptyInput,
							$author$project$IdArray$get$(questionId, model.noteDrafts)))
					])),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(2)
					]),
				_List_fromArray(
					[
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$Font$color($author$project$MyUi$font3),
								$author$project$Ui$Font$size(14)
							]),
						$author$project$Ui$text('Preview')),
						$author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$spacing(16)
							]),
						_List_fromArray(
							[
								$author$project$SheepGame$answerGroupsColumn$(
								isMobile,
								$elm$core$List$map$(
									$elm$core$List$map(
										function (_v2) {
											var userId = _v2.a;
											var answer = _v2.b;
											return $author$project$Ui$Lazy$lazy6$(
												$author$project$SheepGame$groupingPreviewAnswer,
												minutes,
												contentWidth,
												localUser,
												questionIndex,
												$author$project$Id$toInt(userId),
												answer);
										}),
									$author$project$SheepGame$answerGroups(
										$elm$core$List$map$(
											function (_v1) {
												var userId = _v1.a;
												var answer = _v1.b;
												return _Utils_Tuple3(
													userId,
													$elm$core$Maybe$withDefault$(
														'',
														$lamdera$containers$SeqDict$get$(
															_Utils_Tuple2(userId, questionId),
															shared.groups)),
													answer);
											},
											answers)))),
								$author$project$Ui$Lazy$lazy6$(
								$author$project$SheepGame$groupingNotesPreview,
								isMobile,
								minutes,
								contentWidth,
								localUser,
								questionIndex,
								$elm$core$Maybe$withDefault$(
									$author$project$SheepGame$emptyInput,
									$author$project$IdArray$get$(questionId, model.noteDrafts)))
							]))
					]))
			]));
};
var $author$project$SheepGame$groupingQuestionView = function (isMobile) {
	return function (time) {
		return function (contentWidth) {
			return function (localUser) {
				return function (loggedIn) {
					return function (shared) {
						return function (model) {
							return function (playerIds) {
								return function (questionIndex) {
									return function (question) {
										return $author$project$SheepGame$groupingQuestionView$(isMobile, time, contentWidth, localUser, loggedIn, shared, model, playerIds, questionIndex, question);
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$MyUi$secondaryButtonTall$ = function (htmlId, onPress, label2) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$Input$button(onPress),
				$author$project$MyUi$id(htmlId),
				$author$project$Ui$background($author$project$MyUi$secondaryGray),
				$author$project$Ui$border(1),
				$author$project$Ui$Font$color($author$project$MyUi$black),
				$author$project$Ui$rounded(4),
				$author$project$Ui$width($author$project$Ui$shrink),
				$author$project$Ui$paddingXY$(16, 8),
				$author$project$Ui$Font$weight(500)
			]),
		$author$project$Ui$text(label2));
};
var $author$project$MyUi$secondaryButtonTall = F3($author$project$MyUi$secondaryButtonTall$);
var $author$project$SheepGame$groupingView$ = function (isMobile, time, contentWidth, localUser, loggedIn, setup, shared, model) {
	return $author$project$SheepGame$isHost$(localUser.session.userId, setup) ? _List_fromArray(
		[
			$author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$Font$bold,
					$author$project$Ui$Font$size(20)
				]),
			$author$project$Ui$text('Group the answers')),
			$author$project$Ui$Prose$paragraph$(
			_List_fromArray(
				[
					$author$project$Ui$Font$color($author$project$MyUi$font3)
				]),
			_List_fromArray(
				[
					$author$project$Ui$text('Answers sharing a letter score together. Change a letter to split an answer off or to merge it with another.')
				])),
			$author$project$Ui$column$(
			_List_fromArray(
				[
					$author$project$Ui$spacing(48)
				]),
			$elm$core$List$indexedMap$(
				A8(
					$author$project$SheepGame$groupingQuestionView,
					isMobile,
					time,
					contentWidth,
					localUser,
					loggedIn,
					shared,
					model,
					$author$project$SheepGame$players(shared)),
				$mgold$elm_nonempty_list$List$Nonempty$toList(setup.questions))),
			$author$project$Ui$row$(
			_List_fromArray(
				[
					$author$project$Ui$spacing(8)
				]),
			_List_fromArray(
				[
					$author$project$MyUi$secondaryButtonTall$(
					$lamdera$program_test$Effect$Browser$Dom$id('sheepGame_unlockAnswers'),
					$author$project$SheepGame$PressedUnlockAnswers,
					'Unlock answers'),
					$author$project$MyUi$simpleButton$(
					$lamdera$program_test$Effect$Browser$Dom$id('sheepGame_revealScores'),
					$author$project$SheepGame$PressedRevealScores,
					$author$project$Ui$text('Reveal scores'))
				]))
		]) : _List_fromArray(
		[
			$author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$Font$bold,
					$author$project$Ui$Font$size(20)
				]),
			$author$project$Ui$text('Answers are locked')),
			$author$project$Ui$Prose$paragraph$(
			_List_fromArray(
				[
					$author$project$Ui$Font$color($author$project$MyUi$font3)
				]),
			_List_fromArray(
				[
					$author$project$Ui$text('The host is grouping the answers together. The scores show up here once they\u0027re done.')
				]))
		]);
};
var $author$project$SheepGame$groupingView = F8($author$project$SheepGame$groupingView$);
var $author$project$SheepGame$PressedNewQuestionRevealed = {$: 26};
var $author$project$SheepGame$newQuestionRevealedId = $lamdera$program_test$Effect$Browser$Dom$id('sheepGame_newQuestionRevealed');
var $author$project$SheepGame$newQuestionRevealedText = 'New question revealed!';
var $author$project$SheepGame$newQuestionRevealedView = function (isMobile) {
	return $author$project$MyUi$elButton$(
		$author$project$SheepGame$newQuestionRevealedId,
		$author$project$SheepGame$PressedNewQuestionRevealed,
		_List_fromArray(
			[
				$author$project$Ui$alignBottom,
				$author$project$Ui$centerX,
				$author$project$Ui$width($author$project$Ui$shrink),
				$author$project$Ui$move(
				{x: 0, y: -16, z: 0}),
				$author$project$Ui$paddingXY$(12, 8),
				$author$project$Ui$rounded(8),
				$author$project$Ui$border(1),
				$author$project$Ui$borderColor($author$project$MyUi$buttonBorder),
				$author$project$Ui$background($author$project$MyUi$buttonBackground),
				$author$project$Ui$Font$color($author$project$MyUi$font1),
				$author$project$Ui$pointer,
				$author$project$MyUi$hover$(
				isMobile,
				_List_fromArray(
					[
						$author$project$Ui$Anim$backgroundColor($author$project$MyUi$highlightedBorder)
					]))
			]),
		$author$project$Ui$text($author$project$SheepGame$newQuestionRevealedText));
};
var $author$project$Ui$Events$on$ = function (name, decoder) {
	return $author$project$Internal$Model2$attribute(
		$elm$html$Html$Events$on$(name, decoder));
};
var $author$project$Ui$Events$on = F2($author$project$Ui$Events$on$);
var $author$project$Ui$opacity = function (o) {
	return $author$project$Internal$Model2$style$(
		'opacity',
		$elm$core$String$fromFloat(o));
};
var $author$project$SheepGame$decodeContentWidthAndTime = function (value) {
	return {
		contentWidth: (8192 - 1) & (value >>> 1),
		isMobile: (1 & value) === 1,
		time: $lamdera$program_test$Effect$Time$millisToPosix((1000 * 60) * ((value / (8192 * 2)) | 0))
	};
};
var $author$project$SheepGame$decodeUserIdAndQuestionId = function (value) {
	return {
		questionId: $author$project$Id$fromInt(((1 << 6) - 1) & value),
		userId: $author$project$Id$fromInt(value >>> 6)
	};
};
var $author$project$MyUi$fadeIn = $author$project$Ui$htmlAttribute(
	$elm$html$Html$Attributes$class('fade-in'));
var $author$project$SheepGame$sheepEmoji = $author$project$Twemoji$spriteView$('1em', $author$project$Emoji$animalsNatureSpriteName, '🐑');
var $author$project$SheepGame$finalResultsView$ = function (localUser, winners) {
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(48),
				$author$project$Ui$Font$size(24)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Prose$paragraph$(
				_List_fromArray(
					[$author$project$Ui$Font$center]),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$html($author$project$SheepGame$sheepEmoji),
					A2(
						$elm$core$List$cons,
						$author$project$Ui$text(' And the winner is '),
						_Utils_ap(
							function () {
								if (!winners.b) {
									return _List_fromArray(
										[
											$author$project$Ui$text('...no one?')
										]);
								} else {
									return $elm$core$List$intersperse$(
										$author$project$Ui$text(', '),
										$elm$core$List$map$(
											function (userId) {
												return $author$project$Ui$el$(
													_List_fromArray(
														[
															$author$project$Ui$width($author$project$Ui$shrink),
															$author$project$Ui$Font$bold,
															$author$project$Ui$Font$color(
															$author$project$SheepGame$userColor$(userId, localUser))
														]),
													$author$project$Ui$text(
														$author$project$User$toStringAlt$(userId, localUser)));
											},
											winners));
								}
							}(),
							_List_fromArray(
								[
									$author$project$Ui$text(' '),
									$author$project$Ui$html($author$project$SheepGame$sheepEmoji)
								]))))),
				$author$project$Ui$Prose$paragraph$(
				_List_fromArray(
					[$author$project$Ui$Font$center]),
				_List_fromArray(
					[
						$author$project$Ui$text('Thanks for playing!')
					]))
			]));
};
var $author$project$SheepGame$finalResultsView = F2($author$project$SheepGame$finalResultsView$);
var $author$project$SheepGame$RankDown = 1;
var $author$project$SheepGame$RankUnchanged = 2;
var $author$project$SheepGame$RankUp = 0;
var $author$project$SheepGame$placeIn$ = function (userId, scores) {
	var score = $elm$core$Maybe$withDefault$(
		0,
		$lamdera$containers$SeqDict$get$(userId, scores));
	return $elm$core$List$length(
		$elm$core$List$filter$(
			function (_v0) {
				var otherId = _v0.a;
				var otherScore = _v0.b;
				return (_Utils_cmp(otherScore, score) < 0) || (_Utils_eq(otherScore, score) && (_Utils_cmp(
					$author$project$Id$toInt(userId),
					$author$project$Id$toInt(otherId)) < 0));
			},
			$lamdera$containers$SeqDict$toList(scores)));
};
var $author$project$SheepGame$placeIn = F2($author$project$SheepGame$placeIn$);
var $author$project$SheepGame$groupsForQuestion$ = function (questionId, shared) {
	return $elm$core$List$map$(
		function (_v1) {
			var _v2 = _v1.a;
			var group = _v2.a;
			var userId = _v2.b;
			var rest = _v1.b;
			return _Utils_Tuple2(
				group,
				A2(
					$elm$core$List$cons,
					userId,
					$elm$core$List$map$($elm$core$Tuple$second, rest)));
		},
		$elmcraft$core_extra$List$Extra$gatherEqualsBy$(
			$elm$core$Tuple$first,
			$elm$core$List$filterMap$(
				function (userId) {
					var _v0 = $author$project$SheepGame$answerFor$(userId, questionId, shared);
					if (!_v0.$) {
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(
								$elm$core$Maybe$withDefault$(
									'',
									$lamdera$containers$SeqDict$get$(
										_Utils_Tuple2(userId, questionId),
										shared.groups)),
								userId));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				$author$project$SheepGame$players(shared))));
};
var $author$project$SheepGame$groupsForQuestion = F2($author$project$SheepGame$groupsForQuestion$);
var $author$project$SheepGame$scoresThroughQuestion$ = function (questionCount, shared) {
	return $elm$core$List$foldl$(
		F2(
			function (questionIndex, scores) {
				return $elm$core$List$foldl$(
					F2(
						function (_v0, scores2) {
							var group = _v0.b;
							return $elm$core$List$foldl$(
								F2(
									function (userId, scores3) {
										return $lamdera$containers$SeqDict$update$(
											userId,
											function (maybe) {
												return $elm$core$Maybe$Just(
													$elm$core$Maybe$withDefault$(0, maybe) + $elm$core$List$length(group));
											},
											scores3);
									}),
								scores2,
								group);
						}),
					scores,
					$author$project$SheepGame$groupsForQuestion$(
						$author$project$Id$fromInt(questionIndex),
						shared));
			}),
		$lamdera$containers$SeqDict$fromList(
			$elm$core$List$map$(
				function (userId) {
					return _Utils_Tuple2(userId, 0);
				},
				$author$project$SheepGame$players(shared))),
		$elm$core$List$range$(0, questionCount - 1));
};
var $author$project$SheepGame$scoresThroughQuestion = F2($author$project$SheepGame$scoresThroughQuestion$);
var $author$project$SheepGame$resultsData$ = function (setup, shared) {
	var finalScores = $author$project$SheepGame$scoresThroughQuestion$(
		$mgold$elm_nonempty_list$List$Nonempty$length(setup.questions),
		shared);
	var maxPoints = $elm$core$Maybe$withDefault$(
		0,
		$elm$core$List$maximum(
			$lamdera$containers$SeqDict$values(finalScores)));
	var everyone = $author$project$SheepGame$players(shared);
	return {
		maxPoints: maxPoints,
		questions: $elm$core$List$indexedMap$(
			F2(
				function (index, question) {
					var questionId = $author$project$Id$fromInt(index);
					var before = $author$project$SheepGame$scoresThroughQuestion$(index, shared);
					var after = $author$project$SheepGame$scoresThroughQuestion$(index + 1, shared);
					return {
						answers: $elm$core$List$map$(
							function (userId) {
								return {
									answer: $author$project$SheepGame$answerFor$(userId, questionId, shared),
									group: $elm$core$Maybe$withDefault$(
										'',
										$lamdera$containers$SeqDict$get$(
											_Utils_Tuple2(userId, questionId),
											shared.groups)),
									rankChange: function () {
										if (!index) {
											return 2;
										} else {
											var _v0 = A2(
												$elm$core$Basics$compare,
												$author$project$SheepGame$placeIn$(userId, before),
												$author$project$SheepGame$placeIn$(userId, after));
											switch (_v0) {
												case 0:
													return 0;
												case 2:
													return 1;
												default:
													return 2;
											}
										}
									}(),
									score: $elm$core$Maybe$withDefault$(
										0,
										$lamdera$containers$SeqDict$get$(userId, after)),
									userId: userId
								};
							},
							everyone),
						notes: $elm$core$Maybe$withDefault$(
							$elm$core$Maybe$Nothing,
							$lamdera$containers$SeqDict$get$(questionId, shared.notes)),
						question: question
					};
				}),
			$mgold$elm_nonempty_list$List$Nonempty$toList(setup.questions)),
		winners: $elm$core$List$filterMap$(
			function (_v1) {
				var userId = _v1.a;
				var score = _v1.b;
				return _Utils_eq(score, maxPoints) ? $elm$core$Maybe$Just(userId) : $elm$core$Maybe$Nothing;
			},
			$lamdera$containers$SeqDict$toList(finalScores))
	};
};
var $author$project$SheepGame$resultsData = F2($author$project$SheepGame$resultsData$);
var $author$project$SheepGame$gridCellSize = 30;
var $author$project$Ui$left = function (x) {
	return {x: -x, y: 0, z: 0};
};
var $author$project$SheepGame$matchingAnswerCounts$ = function (setup, shared) {
	var everyone = $author$project$SheepGame$players(shared);
	return $elm$core$List$foldl$(
		F2(
			function (_v2, counts) {
				var pair = _v2.a;
				var matched = _v2.b;
				return $lamdera$containers$SeqDict$update$(
					pair,
					function (maybe) {
						return $elm$core$Maybe$Just(
							$elm$core$Maybe$withDefault$(0, maybe) + (matched ? 1 : 0));
					},
					counts);
			}),
		$lamdera$containers$SeqDict$empty,
		$elm$core$List$concatMap$(
			function (index) {
				var questionId = $author$project$Id$fromInt(index);
				var groupOf = function (userId) {
					var _v1 = $author$project$SheepGame$answerFor$(userId, questionId, shared);
					if (!_v1.$) {
						return $elm$core$Maybe$Just(
							$elm$core$Maybe$withDefault$(
								'',
								$lamdera$containers$SeqDict$get$(
									_Utils_Tuple2(userId, questionId),
									shared.groups)));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				};
				return $elm$core$List$concatMap$(
					function (userId) {
						return $elm$core$List$filterMap$(
							function (otherUserId) {
								if (_Utils_eq(userId, otherUserId)) {
									return $elm$core$Maybe$Nothing;
								} else {
									var _v0 = _Utils_Tuple2(
										groupOf(userId),
										groupOf(otherUserId));
									if ((!_v0.a.$) && (!_v0.b.$)) {
										var group = _v0.a.a;
										var otherGroup = _v0.b.a;
										return $elm$core$Maybe$Just(
											_Utils_Tuple2(
												_Utils_Tuple2(userId, otherUserId),
												_Utils_eq(group, otherGroup)));
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}
							},
							everyone);
					},
					everyone);
			},
			$elm$core$List$range$(
				0,
				$mgold$elm_nonempty_list$List$Nonempty$length(setup.questions) - 1)));
};
var $author$project$SheepGame$matchingAnswerCounts = F2($author$project$SheepGame$matchingAnswerCounts$);
var $author$project$Internal$Model2$OnRight = 2;
var $author$project$Ui$onRight = function (element) {
	return $author$project$Internal$Model2$nearby$(2, element);
};
var $author$project$Internal$Style2$Angle = $elm$core$Basics$identity;
var $author$project$Ui$radians = $elm$core$Basics$identity;
var $author$project$SheepGame$ExitedResultsGrid = function (a) {
	return {$: 21, a: a};
};
var $author$project$SheepGame$HoveredResultsGrid = function (a) {
	return {$: 20, a: a};
};
var $author$project$SheepGame$resultsGridLabel$ = function (localUser, gridHovered, hoveredSide, userId) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$width($author$project$Ui$shrink),
				$author$project$Ui$height(
				$author$project$Ui$px($author$project$SheepGame$gridCellSize)),
				$author$project$Ui$paddingXY$(8, 0),
				$author$project$Ui$contentCenterY,
				$author$project$MyUi$noPointerEvents,
				$author$project$Ui$Font$color(
				$author$project$SheepGame$userColor$(userId, localUser)),
				_Utils_eq(
				$elm$core$Maybe$map$(hoveredSide, gridHovered),
				$elm$core$Maybe$Just(userId)) ? $author$project$Ui$background(
				$author$project$Ui$rgba$(255, 255, 255, 0.1)) : $author$project$Ui$noAttr
			]),
		$author$project$Ui$text(
			$author$project$User$toStringAlt$(userId, localUser)));
};
var $author$project$SheepGame$resultsGridLabel = F4($author$project$SheepGame$resultsGridLabel$);
var $author$project$Ui$rotate = function (_v0) {
	var rads = _v0;
	return $author$project$Internal$Model2$style$(
		'rotate',
		$elm$core$String$fromFloat(rads) + 'rad');
};
var $author$project$Ui$turns = function (t) {
	return (t * 2) * $elm$core$Basics$pi;
};
var $author$project$SheepGame$resultsGridCell$ = function (localUser, gridHovered, overlap, highestMatchCount, _v0, _v1) {
	var rowIndex = _v0.rowIndex;
	var columnIndex = _v0.columnIndex;
	var userId = _v1.a;
	var otherUserId = _v1.b;
	var matched = (highestMatchCount <= 0) ? 0 : function (count) {
		return $elm$core$Basics$round((count / highestMatchCount) * 255);
	}(
		$elm$core$Maybe$withDefault$(
			0,
			$lamdera$containers$SeqDict$get$(
				_Utils_Tuple2(userId, otherUserId),
				overlap)));
	var isFilled = _Utils_cmp(columnIndex, rowIndex) < 0;
	var highlight = function () {
		if (!gridHovered.$) {
			var _v3 = gridHovered.a;
			var hoveredColumn = _v3.a;
			var hoveredRow = _v3.b;
			return (_Utils_eq(hoveredRow, otherUserId) || _Utils_eq(hoveredColumn, userId)) ? 50 : 0;
		} else {
			return 0;
		}
	}();
	return $author$project$Ui$el$(
		_Utils_ap(
			_List_fromArray(
				[
					$author$project$Ui$width(
					$author$project$Ui$px($author$project$SheepGame$gridCellSize)),
					$author$project$Ui$height(
					$author$project$Ui$px($author$project$SheepGame$gridCellSize)),
					$author$project$Ui$background(
					isFilled ? $author$project$Ui$rgb$(highlight, matched, highlight) : $author$project$Ui$rgba$(0, 0, 0, 0)),
					((!columnIndex) && (rowIndex > 0)) ? $author$project$Ui$above(
					$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$rotate(
								$author$project$Ui$turns(-0.25))
							]),
						$author$project$SheepGame$resultsGridLabel$(localUser, gridHovered, $elm$core$Tuple$second, otherUserId))) : $author$project$Ui$noAttr
				]),
			isFilled ? _List_fromArray(
				[
					$author$project$Ui$Events$onMouseEnter(
					$author$project$SheepGame$HoveredResultsGrid(
						_Utils_Tuple2(userId, otherUserId))),
					$author$project$Ui$Events$onMouseLeave(
					$author$project$SheepGame$ExitedResultsGrid(
						_Utils_Tuple2(userId, otherUserId)))
				]) : _List_Nil),
		$author$project$Ui$none);
};
var $author$project$SheepGame$resultsGridCell = F6($author$project$SheepGame$resultsGridCell$);
var $author$project$SheepGame$resultsGridView$ = function (isMobile, localUser, setup, shared, gridHovered) {
	var overlap = $author$project$SheepGame$matchingAnswerCounts$(setup, shared);
	var highestMatchCount = $elm$core$Maybe$withDefault$(
		0,
		$elm$core$List$maximum(
			$lamdera$containers$SeqDict$values(overlap)));
	var everyone = $author$project$SheepGame$players(shared);
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(16),
				$author$project$Ui$paddingXY$(
				0,
				isMobile ? 100 : 32)
			]),
		_List_fromArray(
			[
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$width($author$project$Ui$shrink),
						$author$project$Ui$Font$bold,
						$author$project$Ui$rotate(
						$author$project$Ui$radians($elm$core$Basics$pi / 4)),
						$author$project$Ui$move(
						$author$project$Ui$left(
							(($elm$core$List$length(everyone) * $author$project$SheepGame$gridCellSize) / 2) | 0))
					]),
				$elm$core$List$indexedMap$(
					F2(
						function (columnIndex, userId) {
							return $author$project$Ui$row$(
								_List_fromArray(
									[
										$author$project$Ui$width($author$project$Ui$shrink),
										(_Utils_cmp(
										columnIndex,
										$elm$core$List$length(everyone) - 1) < 0) ? $author$project$Ui$onRight(
										$author$project$SheepGame$resultsGridLabel$(localUser, gridHovered, $elm$core$Tuple$first, userId)) : $author$project$Ui$noAttr
									]),
								$elm$core$List$indexedMap$(
									F2(
										function (rowIndex, otherUserId) {
											return $author$project$SheepGame$resultsGridCell$(
												localUser,
												gridHovered,
												overlap,
												highestMatchCount,
												{columnIndex: columnIndex, rowIndex: rowIndex},
												_Utils_Tuple2(userId, otherUserId));
										}),
									everyone));
						}),
					everyone)),
				function () {
				if (isMobile) {
					return $author$project$Ui$none;
				} else {
					var _v0 = $elm$core$Maybe$andThen$(
						function (pair) {
							return $elm$core$Maybe$map$(
								$elm$core$Tuple$pair(pair),
								$lamdera$containers$SeqDict$get$(pair, overlap));
						},
						gridHovered);
					if (!_v0.$) {
						var _v1 = _v0.a;
						var _v2 = _v1.a;
						var userIdA = _v2.a;
						var userIdB = _v2.b;
						var count = _v1.b;
						return $author$project$Ui$column$(
							_List_fromArray(
								[
									$author$project$Ui$spacing(16),
									$author$project$Ui$Font$size(16)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Prose$paragraph$(
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Ui$text(
											$author$project$User$toStringAlt$(userIdA, localUser)),
											$author$project$Ui$text(' and '),
											$author$project$Ui$text(
											$author$project$User$toStringAlt$(userIdB, localUser)),
											$author$project$Ui$text(' have '),
											$author$project$Ui$el$(
											_List_fromArray(
												[
													$author$project$Ui$width($author$project$Ui$shrink),
													$author$project$Ui$Font$bold
												]),
											$author$project$Ui$text(
												$elm$core$String$fromInt(count))),
											$author$project$Ui$text(
											(count === 1) ? ' matching answer.' : ' matching answers.')
										])),
									(_Utils_eq(count, highestMatchCount) && (count > 0)) ? $author$project$Ui$Prose$paragraph$(
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Ui$html($author$project$SheepGame$sheepEmoji),
											$author$project$Ui$text(' This is the highest number of matching answers! '),
											$author$project$Ui$html($author$project$SheepGame$sheepEmoji)
										])) : $author$project$Ui$none
								]));
					} else {
						return $author$project$Ui$Prose$paragraph$(
							_List_fromArray(
								[
									$author$project$Ui$widthMax(400),
									$author$project$Ui$Font$size(16),
									$author$project$Ui$Font$color($author$project$MyUi$font3)
								]),
							_List_fromArray(
								[
									$author$project$Ui$text('Move your cursor over a grid square to see how many matching answers two players got.')
								]));
					}
				}
			}()
			]));
};
var $author$project$SheepGame$resultsGridView = F5($author$project$SheepGame$resultsGridView$);
var $author$project$SheepGame$answerGroupsView$ = function (isMobile, time, localUser, contentWidth, hoveredResult, highlightedResult, questionId, answers) {
	return $author$project$SheepGame$answerGroupsColumn$(
		isMobile,
		$elm$core$List$map$(
			$elm$core$List$map(
				function (_v0) {
					var userId = _v0.a;
					var answer = _v0.b;
					return $author$project$SheepGame$answerResultView$(time, localUser, contentWidth, hoveredResult, highlightedResult, questionId, userId, answer);
				}),
			$author$project$SheepGame$answerGroups(
				$elm$core$List$filterMap$(
					function (answerResult) {
						return $elm$core$Maybe$map$(
							function (answer) {
								return _Utils_Tuple3(answerResult.userId, answerResult.group, answer);
							},
							answerResult.answer);
					},
					answers))));
};
var $author$project$SheepGame$answerGroupsView = F8($author$project$SheepGame$answerGroupsView$);
var $author$project$Ui$portion = function (i) {
	return $author$project$Ui$Fill(
		$elm$core$Basics$max$(1, i));
};
var $author$project$SheepGame$rankDownArrow = '▼';
var $author$project$SheepGame$rankUpArrow = '▲';
var $author$project$Ui$right = function (x) {
	return {x: x, y: 0, z: 0};
};
var $author$project$SheepGame$scoreRowView$ = function (localUser, maxPoints, answerResult) {
	var _v0 = answerResult;
	var rankChange = _v0.rankChange;
	var score = _v0.score;
	var userId = _v0.userId;
	var filled = (maxPoints <= 0) ? 0 : $elm$core$Basics$round((score / maxPoints) * 1000);
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(1)
			]),
		_List_fromArray(
			[
				$author$project$User$smallProfileImage$(
				true,
				$author$project$User$getUser$(userId, localUser)),
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$height($author$project$Ui$fill)
					]),
				_List_fromArray(
					[
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$width(
								$author$project$Ui$portion(filled)),
								$author$project$Ui$height($author$project$Ui$fill),
								$author$project$Ui$paddingWith(
								{bottom: 0, left: 6, right: 4, top: 0}),
								$author$project$Ui$Font$color($author$project$GuildIcon$iconFontColor),
								$author$project$Ui$roundedWith(
								{bottomLeft: 0, bottomRight: $author$project$User$smallProfileImageRounding, topLeft: 0, topRight: $author$project$User$smallProfileImageRounding}),
								$author$project$Ui$background(
								$author$project$SheepGame$userColor$(userId, localUser)),
								$author$project$Ui$onRight(
								$author$project$Ui$row$(
									_List_fromArray(
										[
											$author$project$Ui$width($author$project$Ui$shrink),
											$author$project$Ui$move(
											$author$project$Ui$right(8)),
											$author$project$Ui$centerY,
											$author$project$Ui$spacing(4),
											$author$project$Ui$Font$color($author$project$MyUi$font1)
										]),
									_List_fromArray(
										[
											$author$project$Ui$text(
											$elm$core$String$fromInt(score)),
											function () {
											switch (rankChange) {
												case 0:
													return $author$project$Ui$el$(
														_List_fromArray(
															[
																$author$project$Ui$Font$color(
																$author$project$Ui$rgb$(25, 230, 25)),
																$author$project$Ui$move(
																{x: 0, y: -1, z: 0})
															]),
														$author$project$Ui$text($author$project$SheepGame$rankUpArrow));
												case 1:
													return $author$project$Ui$el$(
														_List_fromArray(
															[
																$author$project$Ui$Font$color(
																$author$project$Ui$rgb$(230, 25, 25)),
																$author$project$Ui$move(
																{x: 0, y: -1, z: 0})
															]),
														$author$project$Ui$text($author$project$SheepGame$rankDownArrow));
												default:
													return $author$project$Ui$none;
											}
										}()
										]))),
								$author$project$Ui$clipWithEllipsis
							]),
						$author$project$Ui$text(
							$author$project$User$toStringAlt$(userId, localUser))),
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$width(
								$author$project$Ui$portion(1000 - filled))
							]),
						$author$project$Ui$none)
					])),
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$width(
						$author$project$Ui$px(40))
					]),
				$author$project$Ui$none)
			]));
};
var $author$project$SheepGame$scoreRowView = F3($author$project$SheepGame$scoreRowView$);
var $elm$core$List$sortWith = _List_sortWith;
var $author$project$SheepGame$scoreTableView$ = function (isMobile, localUser, maxPoints, answers) {
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(2),
				$author$project$Ui$Font$bold,
				$author$project$Ui$paddingXY$(
				$author$project$SheepGame$paddingX(isMobile),
				0)
			]),
		$elm$core$List$map$(
			A2($author$project$SheepGame$scoreRowView, localUser, maxPoints),
			A2(
				$elm$core$List$sortWith,
				F2(
					function (a, b) {
						var _v0 = A2($elm$core$Basics$compare, b.score, a.score);
						if (_v0 === 1) {
							return A2(
								$elm$core$Basics$compare,
								$author$project$Id$toInt(a.userId),
								$author$project$Id$toInt(b.userId));
						} else {
							var order = _v0;
							return order;
						}
					}),
				answers)));
};
var $author$project$SheepGame$scoreTableView = F4($author$project$SheepGame$scoreTableView$);
var $author$project$SheepGame$resultsQuestionView$ = function (isMobile, time, contentWidth, localUser, setup, hoveredQuestion, hoveredResult, highlightedResult, maxPoints, index, result) {
	var numberWidth = (index < 9) ? 20 : 30;
	var numberSpacing = 6;
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8),
				$author$project$Ui$paddingXY$(0, 16),
				$author$project$MyUi$fadeIn
			]),
		_List_fromArray(
			[
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$Font$size(20),
						$author$project$Ui$spacing(numberSpacing),
						$author$project$Ui$paddingXY$(
						$author$project$SheepGame$paddingX(isMobile),
						0)
					]),
				_List_fromArray(
					[
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$width(
								$author$project$Ui$px(numberWidth)),
								$author$project$Ui$alignTop,
								$author$project$Ui$Font$bold
							]),
						$author$project$Ui$text(
							$elm$core$String$fromInt(index + 1) + '. ')),
						$author$project$SheepGame$questionView$(
						time,
						contentWidth - (numberWidth + numberSpacing),
						localUser,
						hoveredQuestion,
						$author$project$Id$fromInt(index),
						$author$project$SheepGame$revealedQuestionId(index),
						result.question)
					])),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(16)
					]),
				_List_fromArray(
					[
						$author$project$SheepGame$answerGroupsView$(
						isMobile,
						time,
						localUser,
						contentWidth,
						hoveredResult,
						highlightedResult,
						$author$project$Id$fromInt(index),
						result.answers),
						$author$project$SheepGame$scoreTableView$(isMobile, localUser, maxPoints, result.answers),
						function () {
						var _v0 = result.notes;
						if (_v0.$ === 1) {
							return $author$project$Ui$none;
						} else {
							var notes = _v0.a;
							return $author$project$SheepGame$reactableResult$(
								$author$project$SheepGame$paddingX(isMobile),
								localUser,
								contentWidth,
								$author$project$SheepGame$NotesReaction(
									$author$project$Id$fromInt(index)),
								hoveredResult,
								highlightedResult,
								notes.reactions,
								$author$project$SheepGame$messageWithProfile$(
									setup.createdBy,
									localUser,
									$author$project$SheepGame$contentView$(
										time,
										contentWidth,
										localUser,
										_Utils_eq(
											hoveredResult,
											$elm$core$Maybe$Just(
												$author$project$SheepGame$NotesReaction(
													$author$project$Id$fromInt(index)))),
										$lamdera$program_test$Effect$Browser$Dom$id(
											'sheepGame_questionNotes_' + $elm$core$String$fromInt(index)),
										notes.attachedFiles,
										notes.text)));
						}
					}()
					]))
			]));
};
var $author$project$SheepGame$resultsQuestionView = function (isMobile) {
	return function (time) {
		return function (contentWidth) {
			return function (localUser) {
				return function (setup) {
					return function (hoveredQuestion) {
						return function (hoveredResult) {
							return function (highlightedResult) {
								return function (maxPoints) {
									return function (index) {
										return function (result) {
											return $author$project$SheepGame$resultsQuestionView$(isMobile, time, contentWidth, localUser, setup, hoveredQuestion, hoveredResult, highlightedResult, maxPoints, index, result);
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$SheepGame$scoringText = 'Scoring';
var $author$project$SheepGame$revealingView$ = function (isMobile, time, contentWidth, localUser, highlightedResult, setup, shared, model) {
	var results = $author$project$SheepGame$resultsData$(setup, shared);
	var questionCount = $mgold$elm_nonempty_list$List$Nonempty$length(setup.questions);
	var padding = $author$project$Ui$paddingXY$(
		$author$project$SheepGame$paddingX(isMobile),
		0);
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(16)
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Font$bold,
						$author$project$Ui$Font$size(28),
						padding,
						$author$project$Ui$Font$color($author$project$MyUi$font2),
						$author$project$Ui$attrIf$(isMobile, $author$project$Ui$Font$center)
					]),
				$author$project$Ui$text('Sheep game results')),
				(!shared.questionsRevealed) ? $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$Font$size(20),
						$author$project$Ui$Font$center,
						$author$project$Ui$padding(16),
						$author$project$MyUi$fadeIn,
						padding,
						$author$project$Ui$spacing(16)
					]),
				_List_fromArray(
					[
						$author$project$Ui$image$(
						_List_fromArray(
							[
								$author$project$Ui$widthMax(502)
							]),
						{description: 'A sheep with a laptop and wearing headphones', onLoad: $elm$core$Maybe$Nothing, source: '/cacheable/sheep-game.webp'}),
						$author$project$Ui$text('Stay tuned. The results will be revealed shortly.')
					])) : $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(32)
					]),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$spacing(8),
								$author$project$Ui$id(
								$lamdera$program_test$Effect$Browser$Dom$idToString($author$project$SheepGame$scoringId)),
								$author$project$MyUi$fadeIn,
								padding
							]),
						_List_fromArray(
							[
								$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$Font$bold,
										$author$project$Ui$Font$size(20)
									]),
								$author$project$Ui$text($author$project$SheepGame$scoringText)),
								$author$project$Ui$column$(
								_List_fromArray(
									[
										$author$project$Ui$spacing(12),
										$author$project$Ui$padding(8),
										$author$project$Ui$Font$color($author$project$MyUi$font3)
									]),
								_List_fromArray(
									[
										$author$project$Ui$text('For each question you get points equal to the number of people who picked the same answer as you (including yourself). For example, if you pick a unique answer, you get 1 point. If you and two others pick the same answer, you three get 3 points.'),
										$author$project$Ui$text('The person with the most points at the end wins!')
									]))
							])),
					$elm$core$List$indexedMap$(
						A9($author$project$SheepGame$resultsQuestionView, isMobile, time, contentWidth, localUser, setup, model.hoveredQuestion, model.hoveredResult, highlightedResult, results.maxPoints),
						$elm$core$List$take$(shared.questionsRevealed - 1, results.questions)))),
				(_Utils_cmp(shared.questionsRevealed, questionCount) > 0) ? $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(32),
						$author$project$Ui$paddingWith(
						{
							bottom: 0,
							left: $author$project$SheepGame$paddingX(isMobile),
							right: $author$project$SheepGame$paddingX(isMobile),
							top: 32
						}),
						$author$project$MyUi$fadeIn
					]),
				_List_fromArray(
					[
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$height(
								$author$project$Ui$px(2)),
								$author$project$Ui$background($author$project$MyUi$border1)
							]),
						$author$project$Ui$none),
						$author$project$SheepGame$finalResultsView$(localUser, results.winners),
						($lamdera$containers$SeqDict$size(shared.answers) > 2) ? $author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$spacing(16)
							]),
						_List_fromArray(
							[
								$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$Font$size(20),
										$author$project$Ui$Font$bold,
										$author$project$Ui$Font$center
									]),
								$author$project$Ui$text('Statistics: Which players think most alike?')),
								$author$project$SheepGame$resultsGridView$(isMobile, localUser, setup, shared, model.gridHovered)
							])) : $author$project$Ui$none,
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$Font$size(12),
								$author$project$Ui$Font$center,
								$author$project$Ui$Font$color($author$project$MyUi$font3)
							]),
						$author$project$Ui$text('No sheep were impersonated in the playing of this game.'))
					])) : $author$project$Ui$none
			]));
};
var $author$project$SheepGame$revealingView = F8($author$project$SheepGame$revealingView$);
var $author$project$SheepGame$revealingView_HighlightAnswer$ = function (value, userIdAndQuestionId, localUser, setup, shared, model) {
	var _v0 = $author$project$SheepGame$decodeUserIdAndQuestionId(userIdAndQuestionId);
	var questionId = _v0.questionId;
	var userId = _v0.userId;
	var _v1 = $author$project$SheepGame$decodeContentWidthAndTime(value);
	var time = _v1.time;
	var contentWidth = _v1.contentWidth;
	var isMobile = _v1.isMobile;
	return $author$project$SheepGame$revealingView$(
		isMobile,
		time,
		contentWidth,
		localUser,
		$elm$core$Maybe$Just(
			$author$project$SheepGame$AnswerReaction$(userId, questionId)),
		setup,
		shared,
		model);
};
var $author$project$SheepGame$revealingView_HighlightAnswer = F6($author$project$SheepGame$revealingView_HighlightAnswer$);
var $author$project$SheepGame$revealingView_HighlightNotes$ = function (value, questionId, localUser, setup, shared, model) {
	var _v0 = $author$project$SheepGame$decodeContentWidthAndTime(value);
	var time = _v0.time;
	var contentWidth = _v0.contentWidth;
	var isMobile = _v0.isMobile;
	return $author$project$SheepGame$revealingView$(
		isMobile,
		time,
		contentWidth,
		localUser,
		$elm$core$Maybe$Just(
			$author$project$SheepGame$NotesReaction(questionId)),
		setup,
		shared,
		model);
};
var $author$project$SheepGame$revealingView_HighlightNotes = F6($author$project$SheepGame$revealingView_HighlightNotes$);
var $author$project$SheepGame$revealingView_NoHighlight$ = function (value, localUser, setup, shared, model) {
	var _v0 = $author$project$SheepGame$decodeContentWidthAndTime(value);
	var time = _v0.time;
	var contentWidth = _v0.contentWidth;
	var isMobile = _v0.isMobile;
	return $author$project$SheepGame$revealingView$(isMobile, time, contentWidth, localUser, $elm$core$Maybe$Nothing, setup, shared, model);
};
var $author$project$SheepGame$revealingView_NoHighlight = F5($author$project$SheepGame$revealingView_NoHighlight$);
var $author$project$SheepGame$tabBodyHeight$ = function (isAnsweringQuestions, windowSize) {
	return (isAnsweringQuestions && $author$project$MyUi$isMobileAlt(windowSize)) ? ($author$project$Coord$yRaw(windowSize) - $author$project$MyUi$channelHeaderHeight) : $elm$core$Basics$min$(
		$author$project$Coord$yRaw(windowSize) - ($author$project$MyUi$channelHeaderHeight + 150),
		$elm$core$Basics$round(
			$author$project$Coord$yRaw(windowSize) * 0.8) - $author$project$MyUi$channelHeaderHeight);
};
var $author$project$SheepGame$tabBodyHeight = F2($author$project$SheepGame$tabBodyHeight$);
var $author$project$SheepGame$gameView$ = function (time, windowSize, showMemberTab, localUser, drag, loggedIn, highlightedResult, setup, shared, model) {
	var maxWidth = 1000;
	var isMobile = $author$project$MyUi$isMobileAlt(windowSize);
	var isHost2 = $author$project$SheepGame$isHost$(localUser.session.userId, setup);
	var contentWidth = $elm$core$Basics$min$(
		maxWidth,
		$author$project$MyUi$conversationWidthIgnoreScrollbar$(windowSize, showMemberTab) - ($author$project$SheepGame$paddingX(isMobile) * 2));
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$height(
				$author$project$Ui$px(
					$author$project$SheepGame$tabBodyHeight$(!shared.phase, windowSize))),
				(model.newQuestionRevealed && (!isHost2)) ? $author$project$Ui$inFront(
				$author$project$SheepGame$newQuestionRevealedView(isMobile)) : $author$project$Ui$noAttr,
				function () {
				var _v0 = _Utils_Tuple2(shared.phase, isHost2);
				if ((_v0.a === 2) && _v0.b) {
					var _v1 = _v0.a;
					return $author$project$Ui$inFront(
						$author$project$Ui$row$(
							_List_fromArray(
								[
									$author$project$Ui$spacing(8),
									$author$project$Ui$padding(8),
									$author$project$Ui$attrIf$(
									!isMobile,
									$author$project$Ui$width($author$project$Ui$shrink)),
									$author$project$Ui$background($author$project$MyUi$background1),
									$author$project$Ui$alignBottom
								]),
							_List_fromArray(
								[
									$author$project$Ui$el$(
									_List_fromArray(
										[
											(!shared.questionsRevealed) ? $author$project$Ui$opacity(0.5) : $author$project$Ui$opacity(1),
											$author$project$Ui$width($author$project$Ui$shrink)
										]),
									$author$project$MyUi$secondaryButtonTall$(
										$lamdera$program_test$Effect$Browser$Dom$id('sheepGame_hidePreviousQuestion'),
										$author$project$SheepGame$PressedHidePreviousQuestion,
										'Back')),
									$author$project$Ui$el$(
									_List_fromArray(
										[
											(_Utils_cmp(
											shared.questionsRevealed,
											$mgold$elm_nonempty_list$List$Nonempty$length(setup.questions)) > 0) ? $author$project$Ui$opacity(0.5) : $author$project$Ui$opacity(1),
											$author$project$Ui$width($author$project$Ui$shrink)
										]),
									$author$project$MyUi$simpleButton$(
										$lamdera$program_test$Effect$Browser$Dom$id('sheepGame_showNextQuestion'),
										$author$project$SheepGame$PressedShowNextQuestion,
										$author$project$Ui$text('Show next question')))
								])));
				} else {
					return $author$project$Ui$noAttr;
				}
			}()
			]),
		$author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$background($author$project$MyUi$background1),
					$author$project$MyUi$scrollable(
					$author$project$MyUi$canScroll$(
						$author$project$MyUi$isMobileAlt(windowSize),
						drag)),
					$author$project$Ui$height(
					$author$project$Ui$px(
						$author$project$SheepGame$tabBodyHeight$(!shared.phase, windowSize))),
					$author$project$Ui$heightMin(0),
					$author$project$Ui$id(
					$lamdera$program_test$Effect$Browser$Dom$idToString($author$project$SheepGame$gameViewId)),
					$author$project$Ui$Events$on$(
					'scroll',
					$author$project$Scroll$decodeScrollToBottom$($author$project$SheepGame$UserScrolledResults, model.scrollPosition)),
					$author$project$MyUi$htmlStyle$('isolation', 'isolate')
				]),
			function () {
				var _v2 = shared.phase;
				switch (_v2) {
					case 0:
						return $author$project$Ui$column$(
							_List_fromArray(
								[
									$author$project$Ui$paddingWith(
									{
										bottom: 16 + localUser.safeAreaInsetBottom,
										left: $author$project$SheepGame$paddingX(isMobile),
										right: $author$project$SheepGame$paddingX(isMobile),
										top: 16
									}),
									$author$project$Ui$centerX,
									$author$project$Ui$widthMax(maxWidth),
									$author$project$Ui$spacing(16)
								]),
							$author$project$SheepGame$answeringView$(time, contentWidth, localUser, loggedIn, setup, shared, model));
					case 1:
						return $author$project$Ui$column$(
							_List_fromArray(
								[
									$author$project$Ui$paddingXY$(
									$author$project$SheepGame$paddingX(isMobile),
									16),
									$author$project$Ui$centerX,
									$author$project$Ui$widthMax(maxWidth),
									$author$project$Ui$spacing(16)
								]),
							$author$project$SheepGame$groupingView$(isMobile, time, contentWidth, localUser, loggedIn, setup, shared, model));
					default:
						return $author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$paddingWith(
									{
										bottom: isHost2 ? (16 + 56) : 16,
										left: 0,
										right: 0,
										top: 16
									}),
									$author$project$Ui$centerX,
									$author$project$Ui$widthMax(maxWidth)
								]),
							function () {
								if (highlightedResult.$ === 1) {
									return $author$project$Ui$Lazy$lazy5$(
										$author$project$SheepGame$revealingView_NoHighlight,
										$author$project$SheepGame$encodeContentWidthAndTime$(isMobile, time, contentWidth),
										localUser,
										setup,
										shared,
										model);
								} else {
									if (highlightedResult.a.$ === 1) {
										var questionId = highlightedResult.a.a;
										return $author$project$Ui$Lazy$lazy6$(
											$author$project$SheepGame$revealingView_HighlightNotes,
											$author$project$SheepGame$encodeContentWidthAndTime$(isMobile, time, contentWidth),
											questionId,
											localUser,
											setup,
											shared,
											model);
									} else {
										var _v4 = highlightedResult.a;
										var userId = _v4.a;
										var questionId = _v4.b;
										return $author$project$Ui$Lazy$lazy6$(
											$author$project$SheepGame$revealingView_HighlightAnswer,
											$author$project$SheepGame$encodeContentWidthAndTime$(isMobile, time, contentWidth),
											$author$project$SheepGame$encodeUserIdAndQuestionId$(userId, questionId),
											localUser,
											setup,
											shared,
											model);
									}
								}
							}());
				}
			}()));
};
var $author$project$SheepGame$gameView = function (time) {
	return function (windowSize) {
		return function (showMemberTab) {
			return function (localUser) {
				return function (drag) {
					return function (loggedIn) {
						return function (highlightedResult) {
							return function (setup) {
								return function (shared) {
									return function (model) {
										return $author$project$SheepGame$gameView$(time, windowSize, showMemberTab, localUser, drag, loggedIn, highlightedResult, setup, shared, model);
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$WordSpellingGame$PressedToggleSettings = {$: 4};
var $author$project$WordSpellingGame$PressedClearBoard = {$: 3};
var $author$project$WordSpellingGame$PressedJoinGame = {$: 1};
var $author$project$WordSpellingGame$PressedReplaceTrayOrPass = {$: 2};
var $author$project$WordSpellingGame$committedTileColor = $author$project$Ui$rgb$(186, 171, 103);
var $author$project$WordSpellingGame$letterOrWildcardText = function (letterOrWildcard) {
	if (!letterOrWildcard.$) {
		var letter = letterOrWildcard.a;
		return $elm$core$String$fromChar(letter);
	} else {
		return ' ';
	}
};
var $author$project$WordSpellingGame$tileScoreView$ = function (value, cellSize2) {
	return $author$project$Ui$inFront(
		$author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$Font$size(
					$elm$core$Basics$ceiling(cellSize2 * 0.3)),
					$author$project$Ui$alignBottom,
					$author$project$Ui$alignRight,
					$author$project$Ui$move(
					{x: -2, y: 0, z: 0})
				]),
			$author$project$Ui$text(value)));
};
var $author$project$WordSpellingGame$tileScoreView = F2($author$project$WordSpellingGame$tileScoreView$);
var $author$project$WordSpellingGame$animatedTileInFront$ = function (setup, cellSize2, offset, red, letterOrWildcard) {
	return $author$project$Ui$inFront(
		$author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$background(
					red ? $author$project$Ui$rgb$(214, 69, 69) : $author$project$WordSpellingGame$committedTileColor),
					$author$project$Ui$width(
					$author$project$Ui$px(cellSize2 - 1)),
					$author$project$Ui$height(
					$author$project$Ui$px(cellSize2 - 1)),
					$author$project$Ui$contentCenterX,
					$author$project$Ui$contentCenterY,
					$author$project$Ui$Font$size(
					$elm$core$Basics$ceiling(cellSize2 * 0.7)),
					$author$project$Ui$Font$bold,
					$author$project$Ui$move(
					{
						x: $author$project$Coord$xRaw(offset),
						y: $author$project$Coord$yRaw(offset),
						z: 0
					}),
					$author$project$Ui$Font$color(
					red ? $author$project$MyUi$white : $author$project$MyUi$black),
					$author$project$MyUi$noPointerEvents,
					$author$project$WordSpellingGame$tileScoreView$(
					function () {
						if (!letterOrWildcard.$) {
							var letter2 = letterOrWildcard.a;
							return $elm$core$String$fromInt(
								$author$project$WordSpellingGame$letterValue$(setup, letter2));
						} else {
							return '';
						}
					}(),
					cellSize2)
				]),
			$author$project$Ui$text(
				$author$project$WordSpellingGame$letterOrWildcardText(letterOrWildcard))));
};
var $author$project$WordSpellingGame$animatedTileInFront = F5($author$project$WordSpellingGame$animatedTileInFront$);
var $author$project$WordSpellingGame$animatedTilePlacement$ = function (isPlayerWhoPlacedTiles, elapsed, isValid, tileCount, index) {
	var launch = index * $ianmackenzie$elm_units$Duration$inMilliseconds($author$project$WordSpellingGame$tileSlideStagger);
	var slideEnd = launch + $ianmackenzie$elm_units$Duration$inMilliseconds($author$project$WordSpellingGame$tileSlideDuration);
	var slideInProgress = isPlayerWhoPlacedTiles ? 1 : ((_Utils_cmp(elapsed, launch) < 0) ? 0 : $author$project$WordSpellingGame$easeOutCubic(
		(elapsed - launch) / $ianmackenzie$elm_units$Duration$inMilliseconds($author$project$WordSpellingGame$tileSlideDuration)));
	if ((isValid.$ === 1) && (isValid.a.$ === 1)) {
		var _v1 = isValid.a;
		var leaveStart = $ianmackenzie$elm_units$Duration$inMilliseconds(
			$ianmackenzie$elm_units$Quantity$sum(
				_List_fromArray(
					[
						$author$project$WordSpellingGame$invalidHoldDuration,
						$ianmackenzie$elm_units$Quantity$multiplyBy$(index, $author$project$WordSpellingGame$tileSlideStagger),
						$author$project$WordSpellingGame$slideInEnd(tileCount)
					])));
		var leaveEnd = leaveStart + $ianmackenzie$elm_units$Duration$inMilliseconds($author$project$WordSpellingGame$tileSlideDuration);
		return (_Utils_cmp(elapsed, slideEnd) < 0) ? $elm$core$Maybe$Just(
			{progress: slideInProgress, red: false}) : ((_Utils_cmp(elapsed, (leaveStart + slideEnd) * 0.5) < 0) ? $elm$core$Maybe$Just(
			{progress: 1, red: false}) : ((_Utils_cmp(elapsed, leaveStart) < 0) ? $elm$core$Maybe$Just(
			{progress: 1, red: true}) : ((_Utils_cmp(elapsed, leaveEnd) < 0) ? $elm$core$Maybe$Just(
			{
				progress: 1 - $author$project$WordSpellingGame$easeOutCubic(
					(elapsed - leaveStart) / $ianmackenzie$elm_units$Duration$inMilliseconds($author$project$WordSpellingGame$tileSlideDuration)),
				red: true
			}) : $elm$core$Maybe$Nothing)));
	} else {
		return $elm$core$Maybe$Just(
			{progress: slideInProgress, red: false});
	}
};
var $author$project$WordSpellingGame$animatedTilePlacement = F5($author$project$WordSpellingGame$animatedTilePlacement$);
var $author$project$WordSpellingGame$trayTilePos$ = function (traySize, windowSize, _v0) {
	var index = _v0;
	return $author$project$Coord$xy$(
		$author$project$WordSpellingGame$boardX(windowSize) + $elm$core$Basics$round(
			index * ($author$project$WordSpellingGame$trayTileSize$(traySize, windowSize) + $author$project$WordSpellingGame$trayTileSpacing)),
		$author$project$WordSpellingGame$trayY$(traySize, windowSize));
};
var $author$project$WordSpellingGame$trayTilePos = F3($author$project$WordSpellingGame$trayTilePos$);
var $author$project$WordSpellingGame$animatedTrayTilePos$ = function (setup, windowSize, currentTime, trayIndex, shiftAnimation) {
	var dest = $author$project$WordSpellingGame$trayTilePos$(setup.traySize, windowSize, trayIndex);
	if (!shiftAnimation.$) {
		var _v1 = shiftAnimation.a;
		var startTime = _v1.a;
		var fromSlot = _v1.b;
		var from = $author$project$WordSpellingGame$trayTilePos$(setup.traySize, windowSize, fromSlot);
		var eased = $elm$core$Basics$clamp$(
			0,
			1,
			$author$project$WordSpellingGame$elapsedMs$(currentTime, startTime) / $author$project$WordSpellingGame$trayShiftDuration);
		var lerp = F2(
			function (a, b) {
				return $elm$core$Basics$round(a + (eased * (b - a)));
			});
		return $author$project$Coord$xy$(
			A2(
				lerp,
				$author$project$Coord$xRaw(from),
				$author$project$Coord$xRaw(dest)),
			A2(
				lerp,
				$author$project$Coord$yRaw(from),
				$author$project$Coord$yRaw(dest)));
	} else {
		return dest;
	}
};
var $author$project$WordSpellingGame$animatedTrayTilePos = F5($author$project$WordSpellingGame$animatedTrayTilePos$);
var $author$project$WordSpellingGame$animatingCells$ = function (currentTime, shared) {
	var _v0 = shared.lastPlacement;
	if (!_v0.$) {
		var placement = _v0.a;
		return $author$project$WordSpellingGame$isAnimating$(currentTime, shared) ? $elm$core$Set$fromList(
			$elm$core$List$map$($elm$core$Tuple$first, placement.cells)) : $elm$core$Set$empty;
	} else {
		return $elm$core$Set$empty;
	}
};
var $author$project$WordSpellingGame$animatingCells = F2($author$project$WordSpellingGame$animatingCells$);
var $author$project$WordSpellingGame$boardTileInFront$ = function (value, highlight, cellSize2, offset, letterOrWildcard) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$background(
				highlight ? $author$project$MyUi$replyToColor : $author$project$WordSpellingGame$committedTileColor),
				$author$project$Ui$width(
				$author$project$Ui$px(cellSize2 - 1)),
				$author$project$Ui$height(
				$author$project$Ui$px(cellSize2 - 1)),
				$author$project$Ui$contentCenterX,
				$author$project$Ui$contentCenterY,
				$author$project$Ui$Font$size(
				$elm$core$Basics$ceiling(cellSize2 * 0.7)),
				$author$project$Ui$Font$bold,
				$author$project$Ui$move(
				{
					x: $author$project$Coord$xRaw(offset),
					y: $author$project$Coord$yRaw(offset),
					z: 0
				}),
				$author$project$Ui$Font$color(
				highlight ? $author$project$MyUi$white : $author$project$MyUi$black),
				$author$project$MyUi$noPointerEvents,
				$author$project$WordSpellingGame$tileScoreView$(value, cellSize2)
			]),
		$author$project$Ui$text(
			$author$project$WordSpellingGame$letterOrWildcardText(letterOrWildcard)));
};
var $author$project$WordSpellingGame$boardTileInFront = F5($author$project$WordSpellingGame$boardTileInFront$);
var $author$project$WordSpellingGame$bonusCellColor = function (bonus) {
	switch (bonus) {
		case 0:
			return $author$project$Ui$rgb$(225, 163, 163);
		case 1:
			return $author$project$Ui$rgb$(228, 46, 46);
		case 2:
			return $author$project$Ui$rgb$(123, 208, 232);
		case 3:
			return $author$project$Ui$rgb$(24, 116, 191);
		default:
			return $author$project$Ui$rgb$(241, 154, 154);
	}
};
var $author$project$WordSpellingGame$bonusCellLabel = function (bonus) {
	switch (bonus) {
		case 0:
			return 'DW';
		case 1:
			return 'TW';
		case 2:
			return 'DL';
		case 3:
			return 'TL';
		default:
			return '★';
	}
};
var $noahzgordon$elm_color_extra$Color$Manipulate$limit = A2($elm$core$Basics$clamp, 0, 1);
var $avh4$elm_color$Color$toHsla = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	var minColor = $elm$core$Basics$min$(
		r,
		$elm$core$Basics$min$(g, b));
	var maxColor = $elm$core$Basics$max$(
		r,
		$elm$core$Basics$max$(g, b));
	var l = (minColor + maxColor) / 2;
	var s = _Utils_eq(minColor, maxColor) ? 0 : ((l < 0.5) ? ((maxColor - minColor) / (maxColor + minColor)) : ((maxColor - minColor) / ((2 - maxColor) - minColor)));
	var h1 = _Utils_eq(maxColor, r) ? ((g - b) / (maxColor - minColor)) : (_Utils_eq(maxColor, g) ? (2 + ((b - r) / (maxColor - minColor))) : (4 + ((r - g) / (maxColor - minColor))));
	var h2 = h1 * (1 / 6);
	var h3 = $elm$core$Basics$isNaN(h2) ? 0 : ((h2 < 0) ? (h2 + 1) : h2);
	return {alpha: a, hue: h3, lightness: l, saturation: s};
};
var $noahzgordon$elm_color_extra$Color$Manipulate$darken$ = function (offset, cl) {
	var _v0 = $avh4$elm_color$Color$toHsla(cl);
	var alpha = _v0.alpha;
	var lightness = _v0.lightness;
	var saturation = _v0.saturation;
	var hue = _v0.hue;
	return $avh4$elm_color$Color$hsla$(
		hue,
		saturation,
		$noahzgordon$elm_color_extra$Color$Manipulate$limit(lightness - offset),
		alpha);
};
var $noahzgordon$elm_color_extra$Color$Manipulate$darken = F2($noahzgordon$elm_color_extra$Color$Manipulate$darken$);
var $author$project$WordSpellingGame$emptyCellColor = $author$project$Ui$rgb$(250, 250, 250);
var $author$project$WordSpellingGame$cellView$ = function (cellSize2, position) {
	var maybeBonus = $lamdera$containers$SeqDict$get$(position, $author$project$WordSpellingGame$bonusCells);
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				function () {
				if (!maybeBonus.$) {
					var specialCell = maybeBonus.a;
					return $author$project$Ui$background(
						$author$project$WordSpellingGame$bonusCellColor(specialCell));
				} else {
					return $author$project$Ui$background($author$project$WordSpellingGame$emptyCellColor);
				}
			}(),
				$author$project$Ui$width(
				$author$project$Ui$px(cellSize2)),
				$author$project$Ui$height(
				$author$project$Ui$px(cellSize2)),
				$author$project$MyUi$htmlStyle$('min-height', '0'),
				$author$project$Ui$borderWith(
				{bottom: 1, left: 0, right: 1, top: 0}),
				$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
				$author$project$Ui$contentCenterX,
				$author$project$Ui$contentCenterY
			]),
		function () {
			if (!maybeBonus.$) {
				var bonus = maybeBonus.a;
				return $author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$centerX,
							$author$project$Ui$centerY,
							$author$project$Ui$Font$size(
							function () {
								if (bonus === 4) {
									return $elm$core$Basics$round(cellSize2 * 0.8);
								} else {
									return $elm$core$Basics$round(cellSize2 * 0.5);
								}
							}()),
							$author$project$Ui$Font$color(
							$noahzgordon$elm_color_extra$Color$Manipulate$darken$(
								0.3,
								$author$project$WordSpellingGame$bonusCellColor(bonus))),
							$author$project$Ui$Font$bold
						]),
					$author$project$Ui$text(
						$author$project$WordSpellingGame$bonusCellLabel(bonus)));
			} else {
				return $author$project$Ui$none;
			}
		}());
};
var $author$project$WordSpellingGame$cellView = F2($author$project$WordSpellingGame$cellView$);
var $author$project$WordSpellingGame$boardViewBackground = function (cellSize2) {
	return $author$project$Ui$column$(
		_List_fromArray(
			[$author$project$MyUi$noPointerEvents]),
		$elm$core$List$map$(
			function (y) {
				return $author$project$Ui$row$(
					_List_Nil,
					$elm$core$List$map$(
						function (x) {
							return $author$project$WordSpellingGame$cellView$(
								cellSize2,
								_Utils_Tuple2(x, y));
						},
						$elm$core$List$range$(0, $author$project$WordSpellingGame$gridSize - 1)));
			},
			$elm$core$List$range$(0, $author$project$WordSpellingGame$gridSize - 1)));
};
var $author$project$Ui$Lazy$apply1$ = function (fn, a, s) {
	return $author$project$Internal$Model2$unwrap$(
		s,
		fn(a));
};
var $author$project$Ui$Lazy$apply1 = F3($author$project$Ui$Lazy$apply1$);
var $elm$virtual_dom$VirtualDom$lazy3 = _VirtualDom_lazy3;
var $elm$html$Html$Lazy$lazy3 = $elm$virtual_dom$VirtualDom$lazy3;
var $author$project$Ui$Lazy$lazy$ = function (fn, a) {
	return function (s) {
		return A4($elm$html$Html$Lazy$lazy3, $author$project$Ui$Lazy$apply1, fn, a, s);
	};
};
var $author$project$Ui$Lazy$lazy = F2($author$project$Ui$Lazy$lazy$);
var $author$project$WordSpellingGame$placedTiles$ = function (currentUserId, shared, model) {
	var _v0 = $author$project$WordSpellingGame$getPlayer$(currentUserId, shared);
	if (!_v0.$) {
		var player = _v0.a;
		return $elm$core$List$filterMap$(
			function (_v1) {
				var tile = _v1.a;
				var letter = _v1.b;
				var _v2 = tile.position;
				if (_v2.$ === 1) {
					var cell = _v2.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(cell, letter));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			A3(
				$elm$core$List$map2,
				$elm$core$Tuple$pair,
				$elm$core$Array$toList(model.tiles),
				$author$project$IdArray$toList(player.tray)));
	} else {
		return _List_Nil;
	}
};
var $author$project$WordSpellingGame$placedTiles = F3($author$project$WordSpellingGame$placedTiles$);
var $author$project$WordSpellingGame$premoveColor = $author$project$Ui$rgb$(98, 43, 227);
var $author$project$WordSpellingGame$project$ = function (boardTranslate, zoomedCellSize, x, y) {
	return {
		pos: $author$project$Coord$xy$(
			$author$project$Coord$xRaw(boardTranslate) + (zoomedCellSize * x),
			$author$project$Coord$yRaw(boardTranslate) + (zoomedCellSize * y)),
		size: zoomedCellSize
	};
};
var $author$project$WordSpellingGame$project = F4($author$project$WordSpellingGame$project$);
var $author$project$Icons$recycle = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor'),
			$elm$svg$Svg$Attributes$width('24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99')
				]),
			_List_Nil)
		]));
var $author$project$WordSpellingGame$PressedSubmitPremove = function (a) {
	return {$: 11, a: a};
};
var $author$project$WordSpellingGame$PressedSubmitWord = function (a) {
	return {$: 0, a: a};
};
var $elmcraft$core_extra$List$Extra$last = function (items) {
	last:
	while (true) {
		if (!items.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!items.b.b) {
				var x = items.a;
				return $elm$core$Maybe$Just(x);
			} else {
				var rest = items.b;
				var $temp$items = rest;
				items = $temp$items;
				continue last;
			}
		}
	}
};
var $author$project$WordSpellingGame$nonemptyLetters = function (list) {
	return $mgold$elm_nonempty_list$List$Nonempty$fromList(
		$elm$core$List$map$($elm$core$Tuple$second, list));
};
var $author$project$WordSpellingGame$centerCell = _Utils_Tuple2(($author$project$WordSpellingGame$gridSize / 2) | 0, ($author$project$WordSpellingGame$gridSize / 2) | 0);
var $author$project$WordSpellingGame$orthogonalNeighbors = function (_v0) {
	var x = _v0.a;
	var y = _v0.b;
	return _List_fromArray(
		[
			_Utils_Tuple2(x - 1, y),
			_Utils_Tuple2(x + 1, y),
			_Utils_Tuple2(x, y - 1),
			_Utils_Tuple2(x, y + 1)
		]);
};
var $author$project$WordSpellingGame$placementConnects$ = function (board, placedCells) {
	return $lamdera$containers$SeqDict$isEmpty(board) ? $elm$core$List$member$($author$project$WordSpellingGame$centerCell, placedCells) : $elm$core$List$any$(
		function (cell) {
			return $elm$core$List$any$(
				function (neighbor) {
					return $lamdera$containers$SeqDict$member$(neighbor, board);
				},
				$author$project$WordSpellingGame$orthogonalNeighbors(cell));
		},
		placedCells);
};
var $author$project$WordSpellingGame$placementConnects = F2($author$project$WordSpellingGame$placementConnects$);
var $author$project$WordSpellingGame$buildPlacedWord$ = function (isVertical, shared, placed) {
	var lineCoord = function (_v3) {
		var x = _v3.a;
		var y = _v3.b;
		return isVertical ? y : x;
	};
	var sorted = A2(
		$elm$core$List$sortBy,
		function (_v2) {
			var cell = _v2.a;
			return lineCoord(cell);
		},
		placed);
	var placedCells = $elm$core$List$map$($elm$core$Tuple$first, sorted);
	var _v0 = _Utils_Tuple2(
		$elm$core$List$head(placedCells),
		$elmcraft$core_extra$List$Extra$last(placedCells));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var startCell = _v0.a.a;
		var endCell = _v0.b.a;
		var contiguous = $elm$core$List$all$(
			function (n) {
				var cell = isVertical ? _Utils_Tuple2(startCell.a, n) : _Utils_Tuple2(n, startCell.b);
				return $elm$core$List$member$(cell, placedCells) || $lamdera$containers$SeqDict$member$(cell, shared.board);
			},
			$elm$core$List$range$(
				lineCoord(startCell),
				lineCoord(endCell)));
		var connected = $author$project$WordSpellingGame$placementConnects$(shared.board, placedCells);
		var _v1 = _Utils_Tuple2(
			contiguous && connected,
			$author$project$WordSpellingGame$nonemptyLetters(sorted));
		if (_v1.a && (!_v1.b.$)) {
			var letters = _v1.b.a;
			return $elm$core$Result$Ok(
				{isVertical: isVertical, letters: letters, start: startCell});
		} else {
			return $elm$core$Result$Err(0);
		}
	} else {
		return $elm$core$Result$Err(0);
	}
};
var $author$project$WordSpellingGame$buildPlacedWord = F3($author$project$WordSpellingGame$buildPlacedWord$);
var $elm$core$Dict$values = function (dict) {
	return $elm$core$Dict$foldr$(
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$WordSpellingGame$lineRuns$ = function (isVertical, board, placed) {
	var linePos = function (_v7) {
		var x = _v7.a;
		var y = _v7.b;
		return isVertical ? y : x;
	};
	var lineKey = function (_v6) {
		var x = _v6.a;
		var y = _v6.b;
		return isVertical ? x : y;
	};
	var groups = $elm$core$Dict$values(
		$elm$core$List$foldr$(
			F2(
				function (item, dict) {
					return $elm$core$Dict$update$(
						lineKey(item.a),
						function (m) {
							return $elm$core$Maybe$Just(
								A2(
									$elm$core$List$cons,
									item,
									$elm$core$Maybe$withDefault$(_List_Nil, m)));
						},
						dict);
				}),
			$elm$core$Dict$empty,
			placed));
	var cellAt = F2(
		function (key, pos) {
			return isVertical ? _Utils_Tuple2(key, pos) : _Utils_Tuple2(pos, key);
		});
	var bridged = F3(
		function (key, from, to) {
			return $elm$core$List$all$(
				function (pos) {
					return $lamdera$containers$SeqDict$member$(
						A2(cellAt, key, pos),
						board);
				},
				$elm$core$List$range$(from + 1, to - 1));
		});
	return $elm$core$List$concatMap$(
		function (group) {
			var sorted = A2(
				$elm$core$List$sortBy,
				function (_v5) {
					var cell = _v5.a;
					return linePos(cell);
				},
				group);
			var key = function () {
				if (group.b) {
					var _v4 = group.a;
					var cell = _v4.a;
					return lineKey(cell);
				} else {
					return 0;
				}
			}();
			return $elm$core$List$map$(
				$elm$core$List$reverse,
				$elm$core$List$foldl$(
					F2(
						function (item, runs) {
							if (runs.b) {
								var currentRun = runs.a;
								var doneRuns = runs.b;
								if (currentRun.b) {
									var _v2 = currentRun.a;
									var lastCell = _v2.a;
									return A3(
										bridged,
										key,
										linePos(lastCell),
										linePos(item.a)) ? A2(
										$elm$core$List$cons,
										A2($elm$core$List$cons, item, currentRun),
										doneRuns) : A2(
										$elm$core$List$cons,
										_List_fromArray(
											[item]),
										A2($elm$core$List$cons, currentRun, doneRuns));
								} else {
									return A2(
										$elm$core$List$cons,
										_List_fromArray(
											[item]),
										doneRuns);
								}
							} else {
								return _List_fromArray(
									[
										_List_fromArray(
										[item])
									]);
							}
						}),
					_List_Nil,
					sorted));
		},
		groups);
};
var $author$project$WordSpellingGame$lineRuns = F3($author$project$WordSpellingGame$lineRuns$);
var $author$project$WordSpellingGame$submitButtonCell$ = function (isVertical, runCells, placedCells, board) {
	var vacant = function (cell) {
		return (!$lamdera$containers$SeqDict$member$(cell, board)) && (!$elm$core$Set$member$(cell, placedCells));
	};
	var onBoard = function (_v6) {
		var x = _v6.a;
		var y = _v6.b;
		return (x >= 0) && ((y >= 0) && ((_Utils_cmp(x, $author$project$WordSpellingGame$gridSize) < 0) && (_Utils_cmp(y, $author$project$WordSpellingGame$gridSize) < 0)));
	};
	var linePos = function (_v5) {
		var x = _v5.a;
		var y = _v5.b;
		return isVertical ? y : x;
	};
	var sorted = A2($elm$core$List$sortBy, linePos, runCells);
	var _v0 = isVertical ? _Utils_Tuple2(0, 1) : _Utils_Tuple2(1, 0);
	var dx = _v0.a;
	var dy = _v0.b;
	var afterEnd = function () {
		var _v3 = $elmcraft$core_extra$List$Extra$last(sorted);
		if (!_v3.$) {
			var _v4 = _v3.a;
			var x = _v4.a;
			var y = _v4.b;
			return _Utils_Tuple2(x + dx, y + dy);
		} else {
			return _Utils_Tuple2(0, 0);
		}
	}();
	var beforeStart = function () {
		var _v1 = $elm$core$List$head(sorted);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var x = _v2.a;
			var y = _v2.b;
			return _Utils_Tuple2(x - dx, y - dy);
		} else {
			return _Utils_Tuple2(0, 0);
		}
	}();
	return (onBoard(afterEnd) && vacant(afterEnd)) ? afterEnd : ((onBoard(beforeStart) && vacant(beforeStart)) ? beforeStart : (onBoard(afterEnd) ? afterEnd : beforeStart));
};
var $author$project$WordSpellingGame$submitButtonCell = F4($author$project$WordSpellingGame$submitButtonCell$);
var $author$project$WordSpellingGame$submittableLines$ = function (currentUserId, shared, model) {
	var placed = $author$project$WordSpellingGame$placedTiles$(currentUserId, shared, model);
	var placedCells = $elm$core$Set$fromList(
		$elm$core$List$map$($elm$core$Tuple$first, placed));
	var runsFor = function (isVertical) {
		return $elm$core$List$map$(
			function (run) {
				return _Utils_Tuple2(isVertical, run);
			},
			$elm$core$List$filter$(
				function (run) {
					return $elm$core$List$length(run) >= 2;
				},
				$author$project$WordSpellingGame$lineRuns$(isVertical, shared.board, placed)));
	};
	var bigRuns = _Utils_ap(
		runsFor(false),
		runsFor(true));
	var inBigRun = $elm$core$Set$fromList(
		$elm$core$List$concatMap$(
			function (_v3) {
				var run = _v3.b;
				return $elm$core$List$map$($elm$core$Tuple$first, run);
			},
			bigRuns));
	var loneRuns = $elm$core$List$map$(
		function (tile) {
			return _Utils_Tuple2(
				false,
				_List_fromArray(
					[tile]));
		},
		$elm$core$List$filter$(
			function (_v2) {
				var cell = _v2.a;
				return !$elm$core$Set$member$(cell, inBigRun);
			},
			placed));
	return $elm$core$List$filterMap$(
		function (_v0) {
			var isVertical = _v0.a;
			var run = _v0.b;
			var _v1 = $author$project$WordSpellingGame$buildPlacedWord$(isVertical, shared, run);
			if (!_v1.$) {
				var placedWord = _v1.a;
				return $elm$core$Maybe$Just(
					{
						buttonCell: $author$project$WordSpellingGame$submitButtonCell$(
							isVertical,
							$elm$core$List$map$($elm$core$Tuple$first, run),
							placedCells,
							shared.board),
						placedWord: placedWord
					});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		_Utils_ap(bigRuns, loneRuns));
};
var $author$project$WordSpellingGame$submittableLines = F3($author$project$WordSpellingGame$submittableLines$);
var $author$project$WordSpellingGame$submitLineButtons$ = function (htmlIdPrefix, isPremove, boardTranslate, zoomedCellSize, currentUserId, shared, model) {
	return $elm$core$List$map$(
		function (line) {
			var idString = htmlIdPrefix + ((line.placedWord.isVertical ? 'v' : 'h') + ('_' + ($elm$core$String$fromInt(line.placedWord.start.a) + ('_' + $elm$core$String$fromInt(line.placedWord.start.b)))));
			var _v0 = line.buttonCell;
			var bx = _v0.a;
			var by = _v0.b;
			var p = $author$project$WordSpellingGame$project$(boardTranslate, zoomedCellSize, bx, by);
			return $author$project$Ui$inFront(
				$author$project$MyUi$elButton$(
					$lamdera$program_test$Effect$Browser$Dom$id(idString),
					isPremove ? $author$project$WordSpellingGame$PressedSubmitPremove(line.placedWord) : $author$project$WordSpellingGame$PressedSubmitWord(line.placedWord),
					_List_fromArray(
						[
							$author$project$Ui$move(
							{
								x: $author$project$Coord$xRaw(p.pos),
								y: $author$project$Coord$yRaw(p.pos),
								z: 0
							}),
							$author$project$Ui$width(
							$author$project$Ui$px(p.size)),
							$author$project$Ui$height(
							$author$project$Ui$px(p.size)),
							$author$project$Ui$background(
							isPremove ? $author$project$WordSpellingGame$premoveColor : $author$project$MyUi$buttonBackground),
							$author$project$Ui$rounded((p.size / 4) | 0),
							$author$project$Ui$borderColor($author$project$MyUi$white),
							$author$project$Ui$border(2),
							$author$project$Ui$contentCenterX,
							$author$project$Ui$contentCenterY,
							$author$project$Ui$Font$color($author$project$MyUi$white),
							$author$project$MyUi$hoverText(
							isPremove ? 'Premove word (play automatically when it\u0027s your turn)' : 'Submit word')
						]),
					$author$project$Ui$html($author$project$Icons$sendMessage)));
		},
		$author$project$WordSpellingGame$submittableLines$(currentUserId, shared, model));
};
var $author$project$WordSpellingGame$submitLineButtons = F7($author$project$WordSpellingGame$submitLineButtons$);
var $author$project$WordSpellingGame$freshTileColor = $author$project$Ui$rgb$(240, 220, 130);
var $author$project$WordSpellingGame$tileFade$ = function (currentTime, createdAt) {
	var progress = $elm$core$Basics$clamp$(
		0,
		1,
		($author$project$WordSpellingGame$elapsedMs$(currentTime, createdAt) - $ianmackenzie$elm_units$Duration$inMilliseconds($author$project$WordSpellingGame$tileFadeDelay)) / $author$project$WordSpellingGame$tileFadeDuration);
	return {
		drift: 1 - $author$project$WordSpellingGame$easeOutCubic(progress),
		opacity: progress
	};
};
var $author$project$WordSpellingGame$tileFade = F2($author$project$WordSpellingGame$tileFade$);
var $author$project$WordSpellingGame$tileFadeDrift = 0.2;
var $author$project$WordSpellingGame$tileInFront$ = function (setup, currentTime, createdAt, premove, cellSize2, offset, letterOrWildcard) {
	var fade = $author$project$WordSpellingGame$tileFade$(currentTime, createdAt);
	return $author$project$Ui$inFront(
		$author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$background(
					premove ? $author$project$WordSpellingGame$premoveColor : $author$project$WordSpellingGame$freshTileColor),
					$author$project$Ui$width(
					$author$project$Ui$px(cellSize2 - 1)),
					$author$project$Ui$height(
					$author$project$Ui$px(cellSize2 - 1)),
					$author$project$Ui$contentCenterX,
					$author$project$Ui$contentCenterY,
					$author$project$Ui$Font$size(
					$elm$core$Basics$ceiling(cellSize2 * 0.7)),
					$author$project$Ui$Font$bold,
					$author$project$Ui$move(
					{
						x: $author$project$Coord$xRaw(offset),
						y: $author$project$Coord$yRaw(offset) - $elm$core$Basics$round((fade.drift * $author$project$WordSpellingGame$tileFadeDrift) * cellSize2),
						z: 0
					}),
					$author$project$Ui$Font$color(
					premove ? $author$project$MyUi$white : $author$project$MyUi$black),
					$author$project$Ui$opacity(fade.opacity),
					$author$project$MyUi$noPointerEvents,
					$author$project$WordSpellingGame$tileScoreView$(
					function () {
						if (!letterOrWildcard.$) {
							var letter2 = letterOrWildcard.a;
							return $elm$core$String$fromInt(
								$author$project$WordSpellingGame$letterValue$(setup, letter2));
						} else {
							return '';
						}
					}(),
					cellSize2)
				]),
			$author$project$Ui$text(
				$author$project$WordSpellingGame$letterOrWildcardText(letterOrWildcard))));
};
var $author$project$WordSpellingGame$tileInFront = F7($author$project$WordSpellingGame$tileInFront$);
var $author$project$WordSpellingGame$boardView$ = function (currentTime, windowSize, maybeDragging, localUser, setup, shared, highlightedCells, model) {
	var zoom = $author$project$WordSpellingGame$boardZoom$(currentTime, setup.traySize, windowSize, model);
	var trayWidth = ($author$project$Coord$xRaw(
		$author$project$WordSpellingGame$trayTilePos$(
			setup.traySize,
			windowSize,
			$author$project$OneOrGreater$toInt(setup.traySize))) - $author$project$WordSpellingGame$trayTileSpacing) - $author$project$WordSpellingGame$trayX(windowSize);
	var trayHeight2 = $author$project$WordSpellingGame$trayHeight$(setup.traySize, windowSize);
	var replaceTrayButton = function () {
		var pos = $author$project$WordSpellingGame$trayTilePos$(
			setup.traySize,
			windowSize,
			$author$project$OneOrGreater$toInt(setup.traySize));
		var buttonSize = $elm$core$Basics$round(
			$author$project$WordSpellingGame$trayTileSize$(setup.traySize, windowSize));
		var attributes = _List_fromArray(
			[
				$author$project$Ui$move(
				{
					x: $author$project$Coord$xRaw(pos),
					y: $author$project$Coord$yRaw(pos),
					z: 0
				}),
				$author$project$Ui$width(
				$author$project$Ui$px(buttonSize)),
				$author$project$Ui$height(
				$author$project$Ui$px(buttonSize)),
				$author$project$Ui$rounded((buttonSize / 6) | 0),
				$author$project$Ui$contentCenterX,
				$author$project$Ui$contentCenterY,
				$author$project$Ui$Font$color($author$project$MyUi$white),
				$author$project$Ui$background($author$project$MyUi$buttonBackground),
				$author$project$Ui$Font$center,
				$author$project$Ui$Font$bold
			]);
		return $author$project$Ui$inFront(
			function () {
				var _v47 = $author$project$WordSpellingGame$isPlayerTurn$(localUser.session.userId, shared);
				switch (_v47) {
					case 2:
						var _v48 = $author$project$WordSpellingGame$getWinner(shared);
						if (!_v48.$) {
							return $author$project$Ui$none;
						} else {
							var _v49 = $author$project$WordSpellingGame$passBehavior$(setup, shared);
							switch (_v49) {
								case 0:
									return $author$project$MyUi$elButton$(
										$lamdera$program_test$Effect$Browser$Dom$id('wordSpellingGame_replaceTray'),
										$author$project$WordSpellingGame$PressedReplaceTrayOrPass,
										attributes,
										$author$project$Ui$el$(
											_List_fromArray(
												[
													$author$project$MyUi$hoverText('Replace tray'),
													$author$project$Ui$width($author$project$Ui$shrink),
													$author$project$Ui$centerX
												]),
											$author$project$Ui$html($author$project$Icons$recycle)));
								case 1:
									return $author$project$MyUi$elButton$(
										$lamdera$program_test$Effect$Browser$Dom$id('wordSpellingGame_passOrEndTurn'),
										$author$project$WordSpellingGame$PressedReplaceTrayOrPass,
										attributes,
										$author$project$Ui$text('Pass'));
								default:
									return $author$project$MyUi$elButton$(
										$lamdera$program_test$Effect$Browser$Dom$id('wordSpellingGame_passOrEndTurn'),
										$author$project$WordSpellingGame$PressedReplaceTrayOrPass,
										attributes,
										$author$project$Ui$text('End game'));
							}
						}
					case 1:
						return $author$project$Ui$none;
					default:
						return $author$project$WordSpellingGame$canJoin(shared) ? $author$project$MyUi$elButton$(
							$lamdera$program_test$Effect$Browser$Dom$id('wordSpellingGame_joinGame'),
							$author$project$WordSpellingGame$PressedJoinGame,
							attributes,
							$author$project$Ui$text('Join')) : $author$project$Ui$none;
				}
			}());
	}();
	var currentUserId = localUser.session.userId;
	var isPreviousPlayer = _Utils_eq(
		currentUserId,
		$mgold$elm_nonempty_list$List$Nonempty$get$(shared.turnCount - 1, shared.players).userId);
	var maybePlayer = $author$project$WordSpellingGame$getPlayer$(currentUserId, shared);
	var cellSize2 = $author$project$WordSpellingGame$cellSize$(setup.traySize, windowSize);
	var zoomedCellSize = function () {
		if (!zoom.$) {
			var z = zoom.a;
			return z.zoomedCellSize;
		} else {
			return cellSize2;
		}
	}();
	var boardTranslate = function () {
		if (!zoom.$) {
			var z = zoom.a;
			return z.translate;
		} else {
			return $author$project$Coord$origin;
		}
	}();
	var dragHighlight = function () {
		var _v41 = _Utils_Tuple2(model.dragging, maybeDragging);
		if ((!_v41.a.$) && (!_v41.b.$)) {
			var dragging2 = _v41.b.a;
			var _v42 = $author$project$WordSpellingGame$boardCellAtPosition$(
				currentTime,
				windowSize,
				setup,
				model,
				$author$project$Touch$touchCentroid(dragging2));
			if (!_v42.$) {
				var _v43 = _v42.a;
				var x = _v43.a;
				var y = _v43.b;
				if ($lamdera$containers$SeqDict$member$(
					_Utils_Tuple2(x, y),
					shared.board) || $elmcraft$core_extra$Array$Extra$any$(
					function (tile) {
						var _v44 = tile.position;
						if (_v44.$ === 1) {
							var pos = _v44.a;
							return _Utils_eq(
								pos,
								_Utils_Tuple2(x, y));
						} else {
							return false;
						}
					},
					model.tiles)) {
					return $author$project$Ui$noAttr;
				} else {
					var p = $author$project$WordSpellingGame$project$(boardTranslate, zoomedCellSize, x, y);
					return $author$project$Ui$inFront(
						$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$borderColor(
									$author$project$Ui$rgb$(0, 200, 255)),
									$author$project$Ui$border(3),
									$author$project$Ui$width(
									$author$project$Ui$px(p.size)),
									$author$project$Ui$height(
									$author$project$Ui$px(p.size)),
									$author$project$Ui$move(
									{
										x: $author$project$Coord$xRaw(p.pos),
										y: $author$project$Coord$yRaw(p.pos),
										z: 0
									}),
									$author$project$MyUi$noPointerEvents
								]),
							$author$project$Ui$none));
				}
			} else {
				return $author$project$Ui$noAttr;
			}
		} else {
			return $author$project$Ui$noAttr;
		}
	}();
	var lineButtons = function () {
		var _v32 = _Utils_Tuple3(
			model.dragging,
			$author$project$WordSpellingGame$getWinner(shared),
			$author$project$WordSpellingGame$isPlayerTurn$(currentUserId, shared));
		_v32$2:
		while (true) {
			if ((_v32.a.$ === 1) && (_v32.b.$ === 1)) {
				switch (_v32.c) {
					case 2:
						var _v33 = _v32.a;
						var _v34 = _v32.b;
						var _v35 = _v32.c;
						return $author$project$WordSpellingGame$submitLineButtons$('wordSpellingGame_submitLine_', false, boardTranslate, zoomedCellSize, currentUserId, shared, model);
					case 1:
						var _v36 = _v32.a;
						var _v37 = _v32.b;
						var _v38 = _v32.c;
						if (!maybePlayer.$) {
							var player = maybePlayer.a;
							var _v40 = player.premove;
							if (!_v40.$) {
								return _List_Nil;
							} else {
								return $author$project$WordSpellingGame$submitLineButtons$('wsg_submitPremove_', true, boardTranslate, zoomedCellSize, currentUserId, shared, model);
							}
						} else {
							return _List_Nil;
						}
					default:
						break _v32$2;
				}
			} else {
				break _v32$2;
			}
		}
		return _List_Nil;
	}();
	var selectedHighlight = function () {
		var _v30 = model.selectedCell;
		if (!_v30.$) {
			var _v31 = _v30.a;
			var x = _v31.a;
			var y = _v31.b;
			var p = $author$project$WordSpellingGame$project$(boardTranslate, zoomedCellSize, x, y);
			return $author$project$Ui$inFront(
				$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$borderColor(
							$author$project$Ui$rgb$(0, 200, 255)),
							$author$project$Ui$border(4),
							$author$project$Ui$width(
							$author$project$Ui$px(p.size)),
							$author$project$Ui$height(
							$author$project$Ui$px(p.size)),
							$author$project$Ui$move(
							{
								x: $author$project$Coord$xRaw(p.pos),
								y: $author$project$Coord$yRaw(p.pos),
								z: 0
							}),
							$author$project$MyUi$noPointerEvents
						]),
					$author$project$Ui$none));
		} else {
			return $author$project$Ui$noAttr;
		}
	}();
	var boardPx = $author$project$WordSpellingGame$gridSize * cellSize2;
	var clearButton = function () {
		var placed = $author$project$WordSpellingGame$placedTiles$(currentUserId, shared, model);
		var _v24 = _Utils_Tuple2(
			$author$project$WordSpellingGame$getWinner(shared),
			placed);
		if ((_v24.a.$ === 1) && _v24.b.b) {
			var _v25 = _v24.a;
			var _v26 = _v24.b;
			var hasPremove = function () {
				if (!maybePlayer.$) {
					var player = maybePlayer.a;
					return !_Utils_eq(player.premove, $elm$core$Maybe$Nothing);
				} else {
					return false;
				}
			}();
			var count = $elm$core$List$length(placed);
			var centers = $elm$core$List$map$(
				function (_v27) {
					var _v28 = _v27.a;
					var x = _v28.a;
					var y = _v28.b;
					var p = $author$project$WordSpellingGame$project$(boardTranslate, zoomedCellSize, x, y);
					return _Utils_Tuple2(
						$author$project$Coord$xRaw(p.pos) + (p.size / 2),
						$author$project$Coord$yRaw(p.pos) + (p.size / 2));
				},
				placed);
			var centroidX = $elm$core$List$sum(
				$elm$core$List$map$($elm$core$Tuple$first, centers)) / count;
			var centroidY = $elm$core$List$sum(
				$elm$core$List$map$($elm$core$Tuple$second, centers)) / count;
			var distanceSquaredTo = function (cornerX) {
				return A2($elm$core$Basics$pow, centroidX - cornerX, 2) + A2($elm$core$Basics$pow, centroidY, 2);
			};
			var buttonSize = $elm$core$Basics$round(cellSize2 * 1.6);
			var buttonX = (_Utils_cmp(
				distanceSquaredTo(boardPx),
				distanceSquaredTo(0)) > 0) ? (boardPx - buttonSize) : 0;
			return $author$project$Ui$inFront(
				$author$project$MyUi$elButton$(
					$lamdera$program_test$Effect$Browser$Dom$id('wordSpellingGame_clearBoard'),
					$author$project$WordSpellingGame$PressedClearBoard,
					_List_fromArray(
						[
							$author$project$Ui$move(
							{x: buttonX, y: 0, z: 0}),
							$author$project$Ui$width(
							$author$project$Ui$px(buttonSize)),
							$author$project$Ui$height(
							$author$project$Ui$px(buttonSize)),
							$author$project$Ui$background(
							hasPremove ? $author$project$WordSpellingGame$premoveColor : $author$project$MyUi$buttonBackground),
							$author$project$Ui$rounded((buttonSize / 5) | 0),
							$author$project$Ui$borderColor($author$project$MyUi$white),
							$author$project$Ui$border(2),
							$author$project$Ui$contentCenterX,
							$author$project$Ui$contentCenterY,
							$author$project$Ui$Font$color($author$project$MyUi$white),
							$author$project$MyUi$hoverText(
							hasPremove ? 'Clear premove' : 'Clear board')
						]),
					$author$project$Ui$html($author$project$Icons$delete)));
		} else {
			return $author$project$Ui$noAttr;
		}
	}();
	var animatingCellSet = function () {
		var _v23 = model.hoveredMove;
		if (!_v23.$) {
			return $elm$core$Set$empty;
		} else {
			return $author$project$WordSpellingGame$animatingCells$(currentTime, shared);
		}
	}();
	var boardTiles = _Utils_ap(
		$elm$core$List$map$(
			function (_v17) {
				var _v18 = _v17.a;
				var x = _v18.a;
				var y = _v18.b;
				var letter = _v17.b;
				var p = $author$project$WordSpellingGame$project$(boardTranslate, zoomedCellSize, x, y);
				return $author$project$Ui$inFront(
					$author$project$WordSpellingGame$boardTileInFront$(
						function () {
							if (!letter.$) {
								var letter2 = letter.a;
								return $elm$core$String$fromInt(
									$author$project$WordSpellingGame$letterValue$(setup, letter2));
							} else {
								return '';
							}
						}(),
						true,
						p.size,
						p.pos,
						letter));
			},
			$elm$core$Dict$toList(highlightedCells)),
		$lamdera$containers$SeqDict$foldl$(
			F3(
				function (_v20, letter, list) {
					var x = _v20.a;
					var y = _v20.b;
					if ($elm$core$Set$member$(
						_Utils_Tuple2(x, y),
						animatingCellSet)) {
						return list;
					} else {
						var p = $author$project$WordSpellingGame$project$(boardTranslate, zoomedCellSize, x, y);
						return A2(
							$elm$core$List$cons,
							$author$project$Ui$inFront(
								$author$project$WordSpellingGame$boardTileInFront$(
									function () {
										if (!letter.$) {
											var letter2 = letter.a;
											return $elm$core$String$fromInt(
												$author$project$WordSpellingGame$letterValue$(setup, letter2));
										} else {
											return '';
										}
									}(),
									false,
									p.size,
									p.pos,
									letter)),
							list);
					}
				}),
			_List_Nil,
			function () {
				var _v22 = model.hoveredMove;
				if (!_v22.$) {
					var hovered = _v22.a;
					return hovered.shared.board;
				} else {
					return shared.board;
				}
			}()));
	var animatedTiles = function () {
		var _v13 = shared.lastPlacement;
		if (!_v13.$) {
			var placement = _v13.a;
			if ($author$project$WordSpellingGame$isAnimating$(currentTime, shared)) {
				var tileCount = $elm$core$List$length(placement.cells);
				var elapsed = $author$project$WordSpellingGame$elapsedMs$(currentTime, placement.startTime);
				return $elm$core$List$filterMap$(
					$elm$core$Basics$identity,
					$elm$core$List$indexedMap$(
						F2(
							function (index, _v14) {
								var _v15 = _v14.a;
								var x = _v15.a;
								var y = _v15.b;
								var letterOrWildcard = _v14.b;
								var _v16 = $author$project$WordSpellingGame$animatedTilePlacement$(isPreviousPlayer, elapsed, placement.isValid, tileCount, index);
								if (!_v16.$) {
									var red = _v16.a.red;
									var progress = _v16.a.progress;
									var p = $author$project$WordSpellingGame$project$(boardTranslate, zoomedCellSize, x, y);
									var startX = (red && isPreviousPlayer) ? ((-p.size) + (((cellSize2 * $author$project$WordSpellingGame$gridSize) / 2) | 0)) : (-p.size);
									var startY = (red && isPreviousPlayer) ? (cellSize2 * $author$project$WordSpellingGame$gridSize) : (-p.size);
									var destY = $author$project$Coord$yRaw(p.pos);
									var destX = $author$project$Coord$xRaw(p.pos);
									return $elm$core$Maybe$Just(
										$author$project$WordSpellingGame$animatedTileInFront$(
											setup,
											p.size,
											$author$project$Coord$xy$(
												$elm$core$Basics$round(startX + (progress * (destX - startX))),
												$elm$core$Basics$round(startY + (progress * (destY - startY)))),
											red,
											letterOrWildcard));
								} else {
									return $elm$core$Maybe$Nothing;
								}
							}),
						placement.cells));
			} else {
				return _List_Nil;
			}
		} else {
			return _List_Nil;
		}
	}();
	var _v0 = $elm$core$List$foldr$(
		F2(
			function (_v2, _v4) {
				var index = _v2.a;
				var _v3 = _v2.b;
				var tile = _v3.a;
				var letter = _v3.b;
				var boardAcc = _v4.a;
				var trayAcc = _v4.b;
				var _v5 = _Utils_Tuple2(
					maybeDragging,
					_Utils_eq(
						$author$project$WordSpellingGame$Dragging(index),
						model.dragging));
				if ((!_v5.a.$) && _v5.b) {
					var dragging2 = _v5.a.a;
					var center = $author$project$Touch$touchCentroid(dragging2);
					return _Utils_Tuple2(
						boardAcc,
						A2(
							$elm$core$List$cons,
							$author$project$WordSpellingGame$tileInFront$(
								setup,
								currentTime,
								tile.createdAt,
								false,
								zoomedCellSize,
								$author$project$Coord$xy$(
									$author$project$Coord$xRaw(center) - ((zoomedCellSize / 2) | 0),
									$author$project$Coord$yRaw(center) - ((zoomedCellSize / 2) | 0)),
								letter),
							trayAcc));
				} else {
					var _v6 = tile.position;
					if (!_v6.$) {
						var trayIndex = _v6.a;
						var shiftAnimation = _v6.b;
						return _Utils_Tuple2(
							boardAcc,
							A2(
								$elm$core$List$cons,
								$author$project$WordSpellingGame$tileInFront$(
									setup,
									currentTime,
									tile.createdAt,
									false,
									$elm$core$Basics$round(
										$author$project$WordSpellingGame$trayTileSize$(setup.traySize, windowSize)),
									$author$project$WordSpellingGame$animatedTrayTilePos$(setup, windowSize, currentTime, trayIndex, shiftAnimation),
									letter),
								trayAcc));
					} else {
						var _v7 = _v6.a;
						var x = _v7.a;
						var y = _v7.b;
						var p = $author$project$WordSpellingGame$project$(boardTranslate, zoomedCellSize, x, y);
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								$author$project$WordSpellingGame$tileInFront$(
									setup,
									currentTime,
									tile.createdAt,
									function () {
										if (!maybePlayer.$) {
											var player = maybePlayer.a;
											var _v9 = player.premove;
											if (!_v9.$) {
												var _v10 = _v9.a;
												var result = _v10.b;
												return $elm$core$List$any$(
													function (_v11) {
														var _v12 = _v11.a;
														var xA = _v12.a;
														var yA = _v12.b;
														return _Utils_eq(xA, x) && _Utils_eq(yA, y);
													},
													result.placedCells);
											} else {
												return false;
											}
										} else {
											return false;
										}
									}(),
									p.size,
									p.pos,
									letter),
								boardAcc),
							trayAcc);
					}
				}
			}),
		_Utils_Tuple2(_List_Nil, _List_Nil),
		$elm$core$List$indexedMap$(
			$elm$core$Tuple$pair,
			A3(
				$elm$core$List$map2,
				$elm$core$Tuple$pair,
				$elm$core$Array$toList(model.tiles),
				function () {
					if (!maybePlayer.$) {
						var player = maybePlayer.a;
						return $author$project$IdArray$toList(player.tray);
					} else {
						return _List_Nil;
					}
				}())));
	var boardHeldTiles = _v0.a;
	var trayHeldTiles = _v0.b;
	var boardLayer = $author$project$Ui$el$(
		A2(
			$elm$core$List$cons,
			$author$project$Ui$width(
				$author$project$Ui$px(boardPx)),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$height(
					$author$project$Ui$px(boardPx)),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$clip,
					A2(
						$elm$core$List$cons,
						$author$project$MyUi$htmlStyle$('min-height', '0'),
						A2(
							$elm$core$List$cons,
							clearButton,
							_Utils_ap(
								lineButtons,
								_Utils_ap(
									boardTiles,
									_Utils_ap(
										animatedTiles,
										_Utils_ap(
											boardHeldTiles,
											_List_fromArray(
												[selectedHighlight, dragHighlight])))))))))),
		$author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$move(
					{
						x: $author$project$Coord$xRaw(boardTranslate),
						y: $author$project$Coord$yRaw(boardTranslate),
						z: 0
					})
				]),
			$author$project$Ui$Lazy$lazy$($author$project$WordSpellingGame$boardViewBackground, zoomedCellSize)));
	var trayLayer = $author$project$Ui$inFront(
		$author$project$Ui$el$(
			A2(
				$elm$core$List$cons,
				$author$project$Ui$move(
					{
						x: -$author$project$WordSpellingGame$boardX(windowSize),
						y: -$author$project$WordSpellingGame$boardY,
						z: 0
					}),
				A2(
					$elm$core$List$cons,
					replaceTrayButton,
					_Utils_ap(
						trayHeldTiles,
						_List_fromArray(
							[
								$author$project$Ui$inFront(
								$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$background(
											$author$project$Ui$rgb$(119, 97, 97)),
											$author$project$Ui$move(
											{
												x: $author$project$WordSpellingGame$trayX(windowSize),
												y: $author$project$WordSpellingGame$trayY$(setup.traySize, windowSize),
												z: 0
											}),
											$author$project$Ui$width(
											$author$project$Ui$px(trayWidth)),
											$author$project$Ui$height(
											$author$project$Ui$px(trayHeight2 + 4))
										]),
									$author$project$Ui$none))
							])))),
			$author$project$Ui$none));
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$width(
				$author$project$Ui$px(boardPx)),
				$author$project$Ui$height(
				$author$project$Ui$px(boardPx + trayHeight2)),
				$author$project$Ui$pointer,
				trayLayer,
				$author$project$MyUi$htmlStyle$('user-select', 'none')
			]),
		boardLayer);
};
var $author$project$WordSpellingGame$boardView = F8($author$project$WordSpellingGame$boardView$);
var $author$project$Ui$contentTop = $author$project$Internal$Model2$classWith$($author$project$Internal$Flag$yContentAlign, $author$project$Internal$Style2$classes.contentTop);
var $author$project$WordSpellingGame$ChangedFullTrayBonusInput = function (a) {
	return {$: 1, a: a};
};
var $author$project$WordSpellingGame$ChangedPlaceWordAttempts = function (a) {
	return {$: 4, a: a};
};
var $author$project$WordSpellingGame$ChangedTraySizeInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$WordSpellingGame$PressedCancel = {$: 7};
var $author$project$WordSpellingGame$PressedExpandAdvancedSettings = {$: 9};
var $author$project$WordSpellingGame$PressedLanguage = function (a) {
	return {$: 8, a: a};
};
var $author$project$WordSpellingGame$PressedResetLetters = {$: 5};
var $author$project$WordSpellingGame$PressedStartGame = {$: 6};
var $author$project$WordSpellingGame$Swedish = 1;
var $author$project$WordSpellingGame$allLanguages = _List_fromArray(
	[0, 1]);
var $author$project$Icons$collapseContainer = $author$project$Ui$html(
	A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$strokeWidth('1.5'),
				$elm$svg$Svg$Attributes$stroke('currentColor'),
				$elm$svg$Svg$Attributes$width('24')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$d('M15 12H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z')
					]),
				_List_Nil)
			])));
var $author$project$Icons$expandContainer = $author$project$Ui$html(
	A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$strokeWidth('1.5'),
				$elm$svg$Svg$Attributes$stroke('currentColor'),
				$elm$svg$Svg$Attributes$width('24')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$d('M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z')
					]),
				_List_Nil)
			])));
var $author$project$MyUi$container$ = function (topPadding, bottomPadding, isExpanded, htmlId, onPressedExpand, backgroundColor, isMobile2, label2, contents) {
	return isExpanded ? $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$paddingWith(
				{
					bottom: 0,
					left: 16,
					right: isMobile2 ? 8 : 16,
					top: 12
				}),
				$author$project$Ui$inFront(
				$author$project$Ui$row$(
					_List_fromArray(
						[
							$author$project$Ui$Font$bold,
							$author$project$Ui$Font$size(16),
							$author$project$Ui$spacing(8),
							$author$project$Ui$paddingXY$(5, 0),
							$author$project$Ui$width($author$project$Ui$shrink),
							$author$project$Ui$background(backgroundColor),
							$author$project$Ui$Input$button(onPressedExpand),
							$author$project$Ui$id(
							$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId))
						]),
					_List_fromArray(
						[
							$author$project$Icons$collapseContainer,
							$author$project$Ui$text(label2)
						])))
			]),
		$author$project$Ui$column$(
			_List_fromArray(
				[
					$author$project$Ui$border(1),
					$author$project$Ui$rounded(4),
					$author$project$Ui$paddingWith(
					{bottom: bottomPadding, left: 0, right: 0, top: 4 + topPadding}),
					$author$project$Ui$spacing(16)
				]),
			contents)) : $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$Font$bold,
				$author$project$Ui$Font$size(16),
				$author$project$Ui$spacing(8),
				$author$project$Ui$paddingXY$(5, 0),
				$author$project$Ui$width($author$project$Ui$shrink),
				$author$project$Ui$background(backgroundColor),
				$author$project$Ui$Input$button(onPressedExpand),
				$author$project$Ui$id(
				$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId))
			]),
		_List_fromArray(
			[
				$author$project$Icons$expandContainer,
				$author$project$Ui$text(label2)
			]));
};
var $author$project$MyUi$container = F9($author$project$MyUi$container$);
var $elm$core$Char$toUpper = _Char_toUpper;
var $elmcraft$core_extra$List$Extra$uniqueHelp$ = function (f, existing, remaining, accumulator) {
	uniqueHelp:
	while (true) {
		if (!remaining.b) {
			return $elm$core$List$reverse(accumulator);
		} else {
			var first = remaining.a;
			var rest = remaining.b;
			var computedFirst = f(first);
			if ($elm$core$List$member$(computedFirst, existing)) {
				var $temp$remaining = rest;
				remaining = $temp$remaining;
				continue uniqueHelp;
			} else {
				var $temp$existing = A2($elm$core$List$cons, computedFirst, existing),
					$temp$remaining = rest,
					$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
				existing = $temp$existing;
				remaining = $temp$remaining;
				accumulator = $temp$accumulator;
				continue uniqueHelp;
			}
		}
	}
};
var $elmcraft$core_extra$List$Extra$uniqueHelp = F4($elmcraft$core_extra$List$Extra$uniqueHelp$);
var $elmcraft$core_extra$List$Extra$unique = function (list) {
	return $elmcraft$core_extra$List$Extra$uniqueHelp$($elm$core$Basics$identity, _List_Nil, list, _List_Nil);
};
var $author$project$WordSpellingGame$distributionInputLetters = function (string) {
	return $elm$core$List$sort(
		$elmcraft$core_extra$List$Extra$unique(
			$elm$core$List$map$(
				$elm$core$Char$toUpper,
				$elm$core$List$filter$(
					function (_char) {
						return !$elm$core$List$member$(
							_char,
							_List_fromArray(
								[' ', '\n', '\r', '\t']));
					},
					$elm$core$String$toList(string)))));
};
var $author$project$OneOrGreater$fromString = function (text) {
	var _v0 = $elm$core$String$toInt(text);
	if (!_v0.$) {
		var _int = _v0.a;
		return $author$project$OneOrGreater$fromInt(_int);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$WordSpellingGame$languageToString = function (language) {
	if (!language) {
		return 'English (NWL23)';
	} else {
		return 'Swedish (SAOl13)';
	}
};
var $author$project$WordSpellingGame$ChangedLetterValue$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$WordSpellingGame$ChangedLetterValue = F2($author$project$WordSpellingGame$ChangedLetterValue$);
var $author$project$Internal$Font$render$ = function (faces, str) {
	render:
	while (true) {
		if (!faces.b) {
			return str;
		} else {
			switch (faces.a.$) {
				case 0:
					var _v1 = faces.a;
					var remain = faces.b;
					if (str === '') {
						var $temp$faces = remain,
							$temp$str = 'serif';
						faces = $temp$faces;
						str = $temp$str;
						continue render;
					} else {
						var $temp$faces = remain,
							$temp$str = str + ', serif';
						faces = $temp$faces;
						str = $temp$str;
						continue render;
					}
				case 1:
					var _v3 = faces.a;
					var remain = faces.b;
					if (str === '') {
						var $temp$faces = remain,
							$temp$str = 'sans-serif';
						faces = $temp$faces;
						str = $temp$str;
						continue render;
					} else {
						var $temp$faces = remain,
							$temp$str = str + ', sans-serif';
						faces = $temp$faces;
						str = $temp$str;
						continue render;
					}
				case 2:
					var _v5 = faces.a;
					var remain = faces.b;
					if (str === '') {
						var $temp$faces = remain,
							$temp$str = 'monospace';
						faces = $temp$faces;
						str = $temp$str;
						continue render;
					} else {
						var $temp$faces = remain,
							$temp$str = str + ', monospace';
						faces = $temp$faces;
						str = $temp$str;
						continue render;
					}
				default:
					var name = faces.a.a;
					var remain = faces.b;
					if (str === '') {
						var $temp$faces = remain,
							$temp$str = '\u0022' + (name + '\u0022');
						faces = $temp$faces;
						str = $temp$str;
						continue render;
					} else {
						var $temp$faces = remain,
							$temp$str = str + (', \u0022' + (name + '\u0022'));
						faces = $temp$faces;
						str = $temp$str;
						continue render;
					}
			}
		}
	}
};
var $author$project$Internal$Font$render = F2($author$project$Internal$Font$render$);
var $author$project$Ui$Font$family = function (typefaces) {
	return $author$project$Internal$Model2$style$(
		'font-family',
		$author$project$Internal$Font$render$(typefaces, ''));
};
var $author$project$Internal$Font$Monospace = {$: 2};
var $author$project$Ui$Font$monospace = $author$project$Internal$Font$Monospace;
var $author$project$Internal$Font$Typeface = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Font$typeface = $author$project$Internal$Font$Typeface;
var $author$project$MyUi$monospace = $author$project$Ui$Font$family(
	_List_fromArray(
		[
			$author$project$Ui$Font$typeface('DejaVu Sans Mono'),
			$author$project$Ui$Font$monospace
		]));
var $author$project$Go$inputBackgroundColor = function (isReadonly) {
	return A2(
		$elm$html$Html$Attributes$style,
		'background-color',
		isReadonly ? $author$project$MyUi$colorToStyle($author$project$MyUi$secondaryGray) : 'white');
};
var $author$project$Go$numberInput = function (args) {
	return $author$project$Ui$html(
		A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(args.htmlId),
					$elm$html$Html$Attributes$type_('number'),
					$elm$html$Html$Attributes$min(
					$elm$core$String$fromInt(args.minValue)),
					$elm$html$Html$Attributes$max(
					$elm$core$String$fromInt(args.maxValue)),
					$elm$html$Html$Attributes$value(args.value),
					$elm$html$Html$Attributes$disabled(args.isReadonly),
					$author$project$Go$inputBackgroundColor(args.isReadonly),
					A2($elm$html$Html$Attributes$style, 'font-size', 'inherit'),
					A2($elm$html$Html$Attributes$style, 'color', 'black'),
					A2(
					$elm$html$Html$Attributes$style,
					'width',
					$elm$core$String$fromInt(args.width) + 'px'),
					A2($elm$html$Html$Attributes$style, 'padding', '4px'),
					A2(
					$elm$html$Html$Attributes$style,
					'border',
					'1px solid ' + $author$project$MyUi$colorToStyle($author$project$MyUi$inputBorder)),
					A2($elm$html$Html$Attributes$style, 'border-radius', '4px'),
					A2($elm$html$Html$Attributes$style, 'text-align', 'right'),
					$elm$html$Html$Events$onInput(args.onChange)
				]),
			_List_Nil));
};
var $author$project$WordSpellingGame$letterValueInput$ = function (isReadonly, _char, value) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(4),
				$author$project$Ui$width($author$project$Ui$shrink)
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[$author$project$Ui$Font$bold, $author$project$MyUi$monospace]),
				$author$project$Ui$text(
					$elm$core$String$fromChar(_char))),
				$author$project$Go$numberInput(
				{
					htmlId: 'wsg_letterValue_' + $elm$core$String$fromChar(_char),
					isReadonly: isReadonly,
					maxValue: 999,
					minValue: 0,
					onChange: $author$project$WordSpellingGame$ChangedLetterValue(_char),
					value: value,
					width: 44
				})
			]));
};
var $author$project$WordSpellingGame$letterValueInput = F3($author$project$WordSpellingGame$letterValueInput$);
var $author$project$WordSpellingGame$ChangedLettersInput = function (a) {
	return {$: 2, a: a};
};
var $author$project$WordSpellingGame$lettersInput$ = function (isReadonly, value) {
	return $author$project$Ui$html(
		A2(
			$elm$html$Html$textarea,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('wsg_lettersInput'),
					$elm$html$Html$Attributes$value(value),
					$elm$html$Html$Attributes$disabled(isReadonly),
					$author$project$Go$inputBackgroundColor(isReadonly),
					A2($elm$html$Html$Attributes$style, 'font-size', 'inherit'),
					A2($elm$html$Html$Attributes$style, 'color', 'black'),
					A2($elm$html$Html$Attributes$style, 'font-family', '\u0027DejaVu Sans Mono\u0027, monospace'),
					A2($elm$html$Html$Attributes$style, 'width', '100%'),
					A2($elm$html$Html$Attributes$style, 'height', '100px'),
					A2($elm$html$Html$Attributes$style, 'word-break', 'break-all'),
					A2($elm$html$Html$Attributes$style, 'padding', '8px'),
					A2($elm$html$Html$Attributes$style, 'box-sizing', 'border-box'),
					A2(
					$elm$html$Html$Attributes$style,
					'border',
					'1px solid ' + $author$project$MyUi$colorToStyle($author$project$MyUi$inputBorder)),
					A2($elm$html$Html$Attributes$style, 'border-radius', '4px'),
					$elm$html$Html$Events$onInput($author$project$WordSpellingGame$ChangedLettersInput)
				]),
			_List_Nil));
};
var $author$project$WordSpellingGame$lettersInput = F2($author$project$WordSpellingGame$lettersInput$);
var $author$project$Go$setupSection$ = function (isMobile, title, subtitle, content) {
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(2),
				$author$project$MyUi$prewrap,
				$author$project$Ui$paddingXY$(
				isMobile ? 8 : 16,
				0)
			]),
		_List_fromArray(
			[
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$Font$weight(600)
					]),
				_List_fromArray(
					[
						title,
						function () {
						if (!subtitle.$) {
							var subtitle2 = subtitle.a;
							return $author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$Font$color($author$project$MyUi$font3)
									]),
								$author$project$Ui$text(subtitle2));
						} else {
							return $author$project$Ui$none;
						}
					}()
					])),
				content
			]));
};
var $author$project$Go$setupSection = F4($author$project$Go$setupSection$);
var $author$project$OneOrGreater$seven = 7;
var $author$project$Go$startOrCancel$ = function (domIdPrefix, isMobile, pressedCancel, pressedStart) {
	var start = $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$Input$button(pressedStart),
				$author$project$Ui$borderColor($author$project$MyUi$buttonBorder),
				$author$project$Ui$border(1),
				$author$project$Ui$background($author$project$MyUi$buttonBackground),
				$author$project$Ui$rounded(4),
				$author$project$Ui$id(domIdPrefix + '_start'),
				$author$project$Ui$paddingXY$(
				16,
				isMobile ? 16 : 8),
				$author$project$Ui$contentCenterX,
				$author$project$Ui$Font$weight(500)
			]),
		$author$project$Ui$text('Start game'));
	var cancel = $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$Input$button(pressedCancel),
				$author$project$Ui$id(domIdPrefix + '_cancel'),
				$author$project$Ui$background($author$project$MyUi$secondaryGray),
				$author$project$Ui$border(1),
				$author$project$Ui$Font$color($author$project$MyUi$black),
				$author$project$Ui$contentCenterX,
				$author$project$Ui$rounded(4),
				$author$project$Ui$paddingXY$(
				16,
				isMobile ? 16 : 8),
				$author$project$Ui$Font$weight(500)
			]),
		$author$project$Ui$text('Cancel'));
	return $author$project$Ui$row$(
		isMobile ? _List_fromArray(
			[
				$author$project$Ui$paddingXY$(8, 0),
				$author$project$Ui$spacing(8)
			]) : _List_fromArray(
			[
				$author$project$Ui$paddingXY$(16, 0),
				$author$project$Ui$spacing(16),
				$author$project$Ui$width($author$project$Ui$shrink)
			]),
		_List_fromArray(
			[cancel, start]));
};
var $author$project$Go$startOrCancel = F4($author$project$Go$startOrCancel$);
var $author$project$WordSpellingGame$tabBodyHeight$ = function (windowSize, traySize) {
	return ((($author$project$WordSpellingGame$cellSize$(traySize, windowSize) * $author$project$WordSpellingGame$gridSize) + $author$project$WordSpellingGame$trayHeight$(traySize, windowSize)) + ($author$project$MyUi$isMobileAlt(windowSize) ? $author$project$WordSpellingGame$statusHeight : 0)) + 10;
};
var $author$project$WordSpellingGame$tabBodyHeight = F2($author$project$WordSpellingGame$tabBodyHeight$);
var $author$project$OneOrGreater$toString = function (_v0) {
	var a = _v0;
	return $elm$core$String$fromInt(a);
};
var $author$project$WordSpellingGame$setupView$ = function (windowSize, isReadonly, setup) {
	var isMobile = $author$project$MyUi$isMobileAlt(windowSize);
	var padding = $author$project$Ui$paddingXY$(
		isMobile ? 8 : 16,
		0);
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(
				isMobile ? 8 : 16),
				$author$project$Ui$paddingXY$(0, 16),
				$author$project$Ui$background($author$project$MyUi$tabBackground),
				$author$project$Ui$height(
				$author$project$Ui$px(
					$author$project$WordSpellingGame$tabBodyHeight$(windowSize, $author$project$OneOrGreater$seven))),
				$author$project$Ui$heightMin(0),
				$author$project$Ui$scrollable
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Font$size(24),
						padding
					]),
				$author$project$Ui$text('Word Spelling Game settings')),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(
						isMobile ? 8 : 16)
					]),
				_List_fromArray(
					[
						isReadonly ? $author$project$Go$setupSection$(
						isMobile,
						$author$project$Ui$text('Dictionary'),
						$elm$core$Maybe$Nothing,
						$author$project$Ui$text(
							$author$project$WordSpellingGame$languageToString(setup.language))) : $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$(
								isMobile ? 8 : 16,
								0)
							]),
						$author$project$MyUi$radioColumn$(
							$lamdera$program_test$Effect$Browser$Dom$id('ws_language'),
							$author$project$WordSpellingGame$PressedLanguage,
							$elm$core$Maybe$Just(setup.language),
							$author$project$Ui$text('Dictionary'),
							$elm$core$List$map$(
								function (language) {
									return _Utils_Tuple2(
										language,
										$author$project$WordSpellingGame$languageToString(language));
								},
								$author$project$WordSpellingGame$allLanguages))),
						$author$project$Go$setupSection$(
						isMobile,
						$author$project$Ui$text('Attempts per turn'),
						$elm$core$Maybe$Just(' (# of tries to place a word)'),
						$author$project$Go$numberInput(
							{
								htmlId: 'wsg_attemptsPerTurn',
								isReadonly: isReadonly,
								maxValue: 999,
								minValue: 1,
								onChange: function (value) {
									return $author$project$WordSpellingGame$ChangedPlaceWordAttempts(
										$elm$core$Maybe$withDefault$(
											$author$project$OneOrGreater$one,
											$author$project$OneOrGreater$fromString(value)));
								},
								value: $author$project$OneOrGreater$toString(setup.placeWordAttempts),
								width: 60
							}))
					])),
				$author$project$MyUi$container$(
				16,
				16,
				setup.advancedSettingsExpanded,
				$lamdera$program_test$Effect$Browser$Dom$id('wsg_advancedSection'),
				$author$project$WordSpellingGame$PressedExpandAdvancedSettings,
				$author$project$MyUi$background1,
				isMobile,
				'Advanced settings',
				_List_fromArray(
					[
						$author$project$Go$setupSection$(
						isMobile,
						$author$project$Ui$text('Bingo bonus'),
						$elm$core$Maybe$Just(' (points for using a full tray)'),
						$author$project$Go$numberInput(
							{
								htmlId: 'wsg_fullTrayBonusInput',
								isReadonly: isReadonly,
								maxValue: 999,
								minValue: -999,
								onChange: $author$project$WordSpellingGame$ChangedFullTrayBonusInput,
								value: $elm$core$String$fromInt(setup.fullTrayBonus),
								width: 60
							})),
						$author$project$Go$setupSection$(
						isMobile,
						$author$project$Ui$text('Tray size'),
						$elm$core$Maybe$Just(' (how many letters you get)'),
						$author$project$Go$numberInput(
							{
								htmlId: 'wsg_traySizeInput',
								isReadonly: isReadonly,
								maxValue: 10,
								minValue: 1,
								onChange: $author$project$WordSpellingGame$ChangedTraySizeInput,
								value: $elm$core$String$fromInt(setup.traySize),
								width: 60
							})),
						$author$project$Go$setupSection$(
						isMobile,
						$author$project$Ui$text('Letter distribution'),
						$elm$core$Maybe$Just(' (spaces are wildcards)'),
						$author$project$WordSpellingGame$lettersInput$(isReadonly, setup.letters)),
						function () {
						var _v0 = $author$project$WordSpellingGame$distributionInputLetters(setup.letters);
						if (!_v0.b) {
							return $author$project$Ui$none;
						} else {
							var distributionChars = _v0;
							return $author$project$Go$setupSection$(
								isMobile,
								$author$project$Ui$text('Letter values'),
								$elm$core$Maybe$Nothing,
								$author$project$Ui$row$(
									_List_fromArray(
										[
											$author$project$Ui$spacing(8),
											$author$project$Ui$wrap,
											$author$project$Ui$width($author$project$Ui$shrink)
										]),
									$elm$core$List$map$(
										function (_char) {
											return $author$project$WordSpellingGame$letterValueInput$(
												isReadonly,
												_char,
												$author$project$WordSpellingGame$letterValueInputFor$(_char, setup));
										},
										distributionChars)));
						}
					}(),
						(isReadonly || (_Utils_eq(
						setup.letters,
						$author$project$WordSpellingGame$defaultLetters(setup.language)) && $lamdera$containers$SeqDict$isEmpty(setup.letterValues))) ? $author$project$Ui$none : $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$(16, 0)
							]),
						$author$project$MyUi$simpleButton$(
							$lamdera$program_test$Effect$Browser$Dom$id('wsg_resetLetters'),
							$author$project$WordSpellingGame$PressedResetLetters,
							$author$project$Ui$text('Reset to default')))
					])),
				function () {
				var _v1 = setup.error;
				if (!_v1.$) {
					var error = _v1.a;
					return $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$Font$color($author$project$MyUi$dangerRed),
								padding
							]),
						$author$project$Ui$text(error));
				} else {
					return $author$project$Ui$none;
				}
			}(),
				isReadonly ? $author$project$Ui$none : $author$project$Go$startOrCancel$('wsg', isMobile, $author$project$WordSpellingGame$PressedCancel, $author$project$WordSpellingGame$PressedStartGame)
			]));
};
var $author$project$WordSpellingGame$setupView = F3($author$project$WordSpellingGame$setupView$);
var $author$project$WordSpellingGame$highlightedMovePackingOffset = A2($elm$core$Basics$pow, 2, 20);
var $author$project$WordSpellingGame$encodeLogState$ = function (scrollPosition, hoveredIndex, highlightedMove) {
	return (function () {
		switch (scrollPosition) {
			case 2:
				return 0;
			case 3:
				return 1;
			case 0:
				return 2;
			default:
				return 3;
		}
	}() + function () {
		if (!hoveredIndex.$) {
			var index = hoveredIndex.a;
			return (index + 1) * 4;
		} else {
			return 0;
		}
	}()) + function () {
		if (!highlightedMove.$) {
			var moveNumber = highlightedMove.a;
			return moveNumber * $author$project$WordSpellingGame$highlightedMovePackingOffset;
		} else {
			return 0;
		}
	}();
};
var $author$project$WordSpellingGame$encodeLogState = F3($author$project$WordSpellingGame$encodeLogState$);
var $author$project$WordSpellingGame$gameOverText = 'Game over';
var $author$project$WordSpellingGame$joinWarning$ = function (isPersonalDm, playerCount, localUser, shared) {
	var soloJoinWarning = (!isPersonalDm) && ((playerCount === 1) && ((shared.turnCount === 1) && ($author$project$WordSpellingGame$isPlayerTurn$(localUser.session.userId, shared) === 2)));
	return soloJoinWarning ? $elm$core$Maybe$Just(
		$author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$Font$color($author$project$MyUi$errorColor),
					$author$project$MyUi$prewrap,
					$author$project$Ui$paddingXY$(16, 0)
				]),
			$author$project$Ui$text('No one else has joined yet.\u000AOnce you make a second move no one can join.'))) : $elm$core$Maybe$Nothing;
};
var $author$project$WordSpellingGame$joinWarning = F4($author$project$WordSpellingGame$joinWarning$);
var $mgold$elm_nonempty_list$List$Nonempty$member$ = function (y, _v0) {
	var x = _v0.a;
	var xs = _v0.b;
	return _Utils_eq(x, y) || $elm$core$List$member$(y, xs);
};
var $mgold$elm_nonempty_list$List$Nonempty$member = F2($mgold$elm_nonempty_list$List$Nonempty$member$);
var $author$project$WordSpellingGame$MouseEnterPlayerRow = function (a) {
	return {$: 6, a: a};
};
var $author$project$WordSpellingGame$MouseExitPlayerRow = function (a) {
	return {$: 7, a: a};
};
var $author$project$WordSpellingGame$PressedPlayerRow = function (a) {
	return {$: 5, a: a};
};
var $author$project$MyUi$mentionColor = $author$project$Ui$rgb$(112, 90, 78);
var $author$project$WordSpellingGame$selectionBlue = $author$project$Ui$rgb$(40, 90, 220);
var $author$project$WordSpellingGame$playerRow$ = function (localUser, userId, highlight, isSelected, suffix) {
	var maybeUser = $author$project$User$getUser$(userId, localUser);
	return $author$project$MyUi$rowButton$(
		$lamdera$program_test$Effect$Browser$Dom$id(
			'wsg_player_' + $author$project$Id$toString(userId)),
		$author$project$WordSpellingGame$PressedPlayerRow(userId),
		_List_fromArray(
			[
				$author$project$Ui$spacing(8),
				$author$project$Ui$width($author$project$Ui$shrink),
				$author$project$Ui$Events$onMouseEnter(
				$author$project$WordSpellingGame$MouseEnterPlayerRow(userId)),
				$author$project$Ui$Events$onMouseLeave(
				$author$project$WordSpellingGame$MouseExitPlayerRow(userId)),
				highlight ? $author$project$Ui$background($author$project$MyUi$mentionColor) : $author$project$Ui$noAttr,
				$author$project$MyUi$htmlStyle$(
				'outline',
				isSelected ? ('4px solid ' + $author$project$MyUi$colorToStyle($author$project$WordSpellingGame$selectionBlue)) : '0 solid rgba(0,0,0,0)'),
				$author$project$Ui$rounded(8),
				$author$project$Ui$paddingWith(
				{bottom: 0, left: 0, right: 8, top: 0}),
				$author$project$Ui$clip
			]),
		_List_fromArray(
			[
				highlight ? $author$project$User$profileImageNoRounding(maybeUser) : $author$project$User$profileImage(maybeUser),
				$author$project$Ui$row$(
				_List_fromArray(
					[$author$project$MyUi$prewrap]),
				_List_fromArray(
					[
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$Font$bold,
								$author$project$Ui$clipWithEllipsis,
								$author$project$Ui$widthMax(250)
							]),
						$author$project$Ui$text(
							$author$project$User$toStringAlt$(userId, localUser))),
						$author$project$Ui$text(suffix)
					]))
			]));
};
var $author$project$WordSpellingGame$playerRow = F5($author$project$WordSpellingGame$playerRow$);
var $author$project$WordSpellingGame$leaderboardView$ = function (isMobile, highlightedPlayer, winners, shared, localUser) {
	var sortedPlayers = A2(
		$elm$core$List$sortBy,
		function (player) {
			return -player.score;
		},
		$mgold$elm_nonempty_list$List$Nonempty$toList(shared.players));
	var isTie = $mgold$elm_nonempty_list$List$Nonempty$length(winners) > 1;
	return $elm$core$List$filterMap$(
		function (player) {
			var isWinner = $mgold$elm_nonempty_list$List$Nonempty$member$(player.userId, winners);
			return (isMobile && (!isWinner)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				$author$project$WordSpellingGame$playerRow$(
					localUser,
					player.userId,
					isWinner,
					_Utils_eq(
						highlightedPlayer,
						$elm$core$Maybe$Just(player.userId)),
					': ' + ($elm$core$String$fromInt(player.score) + (isWinner ? (isTie ? ' (tied for first)' : ' (winner)') : ''))));
		},
		sortedPlayers);
};
var $author$project$WordSpellingGame$leaderboardView = F5($author$project$WordSpellingGame$leaderboardView$);
var $author$project$WordSpellingGame$lettersLeftHeight = 40;
var $author$project$WordSpellingGame$mobilePlayerRow$ = function (highlightedPlayer, userId, highlight, user, suffix) {
	return $author$project$MyUi$rowButton$(
		$lamdera$program_test$Effect$Browser$Dom$id(
			'wsg_playerMobile_' + ((highlight ? 'current_' : 'next_') + $author$project$Id$toString(userId))),
		$author$project$WordSpellingGame$PressedPlayerRow(userId),
		_List_fromArray(
			[
				$author$project$Ui$width($author$project$Ui$shrink),
				$author$project$Ui$paddingXY$(8, 2),
				highlight ? $author$project$Ui$background($author$project$MyUi$mentionColor) : $author$project$Ui$noAttr,
				$author$project$Ui$border(2),
				$author$project$Ui$borderColor(
				_Utils_eq(
					highlightedPlayer,
					$elm$core$Maybe$Just(userId)) ? $author$project$WordSpellingGame$selectionBlue : $author$project$Ui$rgba$(0, 0, 0, 0)),
				$author$project$Ui$rounded(4),
				$author$project$MyUi$htmlStyle$('cursor', 'pointer')
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[$author$project$Ui$Font$bold]),
				$author$project$Ui$text(
					$author$project$PersonName$toString(user.name))),
				$author$project$Ui$text(suffix)
			]));
};
var $author$project$WordSpellingGame$mobilePlayerRow = F5($author$project$WordSpellingGame$mobilePlayerRow$);
var $author$project$WordSpellingGame$playerRowSpacing = 8;
var $author$project$WordSpellingGame$MouseEnterWord$ = function (a, b, c) {
	return {$: 8, a: a, b: b, c: c};
};
var $author$project$WordSpellingGame$MouseEnterWord = F3($author$project$WordSpellingGame$MouseEnterWord$);
var $author$project$WordSpellingGame$PressedWordDefinition = function (a) {
	return {$: 12, a: a};
};
var $author$project$WordSpellingGame$UserScrolledPastMoves = function (a) {
	return {$: 10, a: a};
};
var $author$project$Internal$Style2$anchorXToString$ = function (anchorX, x) {
	switch (anchorX) {
		case 0:
			return 'left calc(50% + ' + ($elm$core$String$fromInt(x) + 'px)');
		case 1:
			return 'left';
		default:
			return 'right';
	}
};
var $author$project$Internal$Style2$anchorXToString = F2($author$project$Internal$Style2$anchorXToString$);
var $author$project$Internal$Style2$anchorYToString$ = function (anchorY, y) {
	switch (anchorY) {
		case 0:
			return 'top calc(50% - ' + ($elm$core$String$fromInt(y) + 'px)');
		case 1:
			return 'top ' + ($elm$core$String$fromInt(y) + 'px');
		default:
			return 'bottom ' + ($elm$core$String$fromInt(y) + 'px');
	}
};
var $author$project$Internal$Style2$anchorYToString = F2($author$project$Internal$Style2$anchorYToString$);
var $author$project$Internal$Style2$anchorToString = function (anchor) {
	if ((((!anchor.a) && (!anchor.b)) && (!anchor.c)) && (!anchor.d)) {
		var _v1 = anchor.a;
		var _v2 = anchor.b;
		return 'center';
	} else {
		var anchorX = anchor.a;
		var anchorY = anchor.b;
		var x = anchor.c;
		var y = anchor.d;
		return $author$project$Internal$Style2$anchorXToString$(anchorX, x) + (' ' + $author$project$Internal$Style2$anchorYToString$(anchorY, y));
	}
};
var $author$project$Internal$Style2$renderStep = function (step) {
	if (!step.$) {
		var perc = step.a;
		var clr = step.b;
		return $author$project$Internal$Style2$color(clr) + (' ' + ($elm$core$String$fromInt(perc) + '%'));
	} else {
		var pixel = step.a;
		var clr = step.b;
		return $author$project$Internal$Style2$color(clr) + (' ' + ($elm$core$String$fromInt(pixel) + 'px'));
	}
};
var $author$project$Internal$Style2$toRadians = function (_v0) {
	var r = _v0;
	return r;
};
var $author$project$Internal$Style2$toCssGradient = function (grad) {
	switch (grad.$) {
		case 0:
			var clr = grad.a;
			return $author$project$Internal$Style2$color(clr);
		case 1:
			var angle = grad.a;
			var steps = grad.b;
			return 'linear-gradient(' + ($elm$core$String$join$(
				', ',
				A2(
					$elm$core$List$cons,
					$elm$core$String$fromFloat(
						$author$project$Internal$Style2$toRadians(angle)) + 'rad',
					$elm$core$List$map$($author$project$Internal$Style2$renderStep, steps))) + ')');
		case 2:
			var isCircle = grad.a;
			var anchor = grad.b;
			var steps = grad.c;
			return 'repeating-radial-gradient(' + ((isCircle ? 'circle at ' : 'ellipse at ') + ($elm$core$String$join$(
				', ',
				A2(
					$elm$core$List$cons,
					$author$project$Internal$Style2$anchorToString(anchor),
					$elm$core$List$map$($author$project$Internal$Style2$renderStep, steps))) + ')'));
		default:
			var anchor = grad.a;
			var angle = grad.b;
			var steps = grad.c;
			return 'repeating-conic-gradient(' + ($elm$core$String$join$(
				', ',
				A2(
					$elm$core$List$cons,
					$elm$core$String$fromFloat(
						$author$project$Internal$Style2$toRadians(angle)) + 'rad',
					A2(
						$elm$core$List$cons,
						$author$project$Internal$Style2$anchorToString(anchor),
						$elm$core$List$map$(
							function (_v1) {
								var ang = _v1.a;
								var clr = _v1.b;
								return $author$project$Internal$Style2$color(clr) + (' ' + ($elm$core$String$fromFloat(
									$author$project$Internal$Style2$toRadians(ang)) + 'rad'));
							},
							steps)))) + ')');
	}
};
var $author$project$Ui$backgroundGradient = function (gradient) {
	return $author$project$Internal$Model2$styleWith$(
		$author$project$Internal$Flag$background,
		'background-image',
		$elm$core$String$join$(
			', ',
			$elm$core$List$map$($author$project$Internal$Style2$toCssGradient, gradient)));
};
var $author$project$WordSpellingGame$decodeLogState = function (packed) {
	var value = A2($elm$core$Basics$modBy, $author$project$WordSpellingGame$highlightedMovePackingOffset, packed);
	return {
		highlightedMove: function () {
			var _v0 = (packed / $author$project$WordSpellingGame$highlightedMovePackingOffset) | 0;
			if (!_v0) {
				return $elm$core$Maybe$Nothing;
			} else {
				var moveNumber = _v0;
				return $elm$core$Maybe$Just(moveNumber);
			}
		}(),
		hoveredIndex: function () {
			var _v1 = (value / 4) | 0;
			if (!_v1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var hovered = _v1;
				return $elm$core$Maybe$Just(hovered - 1);
			}
		}(),
		scrollPosition: function () {
			var _v2 = A2($elm$core$Basics$modBy, 4, value);
			switch (_v2) {
				case 0:
					return 2;
				case 1:
					return 3;
				case 3:
					return 1;
				default:
					return 0;
			}
		}()
	};
};
var $author$project$WordSpellingGame$resolveWildcards$ = function (fillIns, word) {
	return A3(
		$elm$core$String$foldl,
		F2(
			function (_char, _v0) {
				var remaining = _v0.a;
				var resolved = _v0.b;
				var _v1 = _Utils_Tuple2(_char, remaining);
				if (('_' === _v1.a) && _v1.b.b) {
					var _v2 = _v1.b;
					var fillIn = _v2.a;
					var rest = _v2.b;
					return _Utils_Tuple2(
						rest,
						_Utils_ap(
							resolved,
							$elm$core$String$fromChar(fillIn)));
				} else {
					return _Utils_Tuple2(
						remaining,
						_Utils_ap(
							resolved,
							$elm$core$String$fromChar(_char)));
				}
			}),
		_Utils_Tuple2(
			$elm$core$String$toList(fillIns),
			''),
		word).b;
};
var $author$project$WordSpellingGame$resolveWildcards = F2($author$project$WordSpellingGame$resolveWildcards$);
var $author$project$WordSpellingGame$definitionWords$ = function (wildcardMatches, word) {
	var _v0 = $elm$core$List$map$(
		function (fillIns) {
			return $author$project$WordSpellingGame$resolveWildcards$(fillIns, word);
		},
		$elm$core$Set$toList(wildcardMatches));
	if (_v0.b) {
		var first = _v0.a;
		var rest = _v0.b;
		return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(first, rest);
	} else {
		return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(word, _List_Nil);
	}
};
var $author$project$WordSpellingGame$definitionWords = F2($author$project$WordSpellingGame$definitionWords$);
var $author$project$WordSpellingGame$descriptionToString = function (description) {
	switch (description.$) {
		case 0:
			var isPremove = description.b.isPremove;
			var isBingo = description.b.isBingo;
			var points = description.b.points;
			var word = description.b.word;
			return (isPremove ? ' premoved ' : ' played ') + (word + (' (+' + ($elm$core$String$fromInt(points) + ((isBingo ? ', bingo!' : '') + ')'))));
		case 1:
			var attemptsLeft = description.b.attemptsLeft;
			var word = description.b.word;
			if (!attemptsLeft.$) {
				var attemptsLeft2 = attemptsLeft.a;
				return ' tried placing ' + (word + (' but failed (' + function () {
					var _v2 = $author$project$OneOrGreater$toString(attemptsLeft2);
					if (_v2 === '1') {
						return '1 attempt left)';
					} else {
						var n = _v2;
						return n + ' attempts left)';
					}
				}()));
			} else {
				return ' tried placing ' + (word + ' but failed (turn ended)');
			}
		case 2:
			return ' swapped their tiles';
		case 3:
			return ' passed';
		case 4:
			return ' passed';
		case 5:
			return ' joined the game';
		default:
			return '\u0027s premove got blocked';
	}
};
var $author$project$WordSpellingGame$descriptionUserId = function (description) {
	switch (description.$) {
		case 0:
			var userId = description.a;
			return userId;
		case 1:
			var userId = description.a;
			return userId;
		case 2:
			var userId = description.a;
			return userId;
		case 3:
			var userId = description.a;
			return userId;
		case 4:
			var userId = description.a;
			return userId;
		case 5:
			var userId = description.a;
			return userId;
		default:
			var userId = description.a;
			return userId;
	}
};
var $author$project$WordSpellingGame$MouseExitWord = {$: 9};
var $author$project$Ui$Font$noWrap = $author$project$Internal$Model2$style$('white-space', 'nowrap');
var $author$project$Internal$Font$VariantActive = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Font$tabularNumbers = $author$project$Internal$Font$VariantActive('tnum');
var $author$project$Internal$Font$renderVariants$ = function (variants, str) {
	renderVariants:
	while (true) {
		var withComma = function () {
			if (str === '') {
				return '';
			} else {
				return str + ', ';
			}
		}();
		if (!variants.b) {
			return str;
		} else {
			switch (variants.a.$) {
				case 0:
					if (variants.a.a === 'smcp') {
						var remain = variants.b;
						var $temp$variants = remain;
						variants = $temp$variants;
						continue renderVariants;
					} else {
						var name = variants.a.a;
						var remain = variants.b;
						var $temp$variants = remain,
							$temp$str = withComma + ('\u0022' + (name + '\u0022'));
						variants = $temp$variants;
						str = $temp$str;
						continue renderVariants;
					}
				case 1:
					var name = variants.a.a;
					var remain = variants.b;
					var $temp$variants = remain,
						$temp$str = withComma + ('\u0022' + (name + '\u0022 0'));
					variants = $temp$variants;
					str = $temp$str;
					continue renderVariants;
				default:
					var _v1 = variants.a;
					var name = _v1.a;
					var index = _v1.b;
					var remain = variants.b;
					var $temp$variants = remain,
						$temp$str = withComma + ('\u0022' + (name + ('\u0022 ' + $elm$core$String$fromInt(index))));
					variants = $temp$variants;
					str = $temp$str;
					continue renderVariants;
			}
		}
	}
};
var $author$project$Internal$Font$renderVariants = F2($author$project$Internal$Font$renderVariants$);
var $author$project$Ui$Font$variants = function (variantList) {
	return $author$project$Internal$Model2$style$(
		'font-feature-settings',
		$author$project$Internal$Font$renderVariants$(variantList, ''));
};
var $author$project$WordSpellingGame$countsView = function (entries) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8),
				$author$project$Ui$paddingXY$(4, 0)
			]),
		_List_fromArray(
			[
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$width($author$project$Ui$shrink),
						$author$project$Ui$spacing(4),
						$author$project$Ui$Font$variants(
						_List_fromArray(
							[$author$project$Ui$Font$tabularNumbers]))
					]),
				$elm$core$List$map$(
					function (entry) {
						return $author$project$Ui$text(
							$elm$core$String$fromInt(entry.count));
					},
					entries)),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				$elm$core$List$map$(
					function (entry) {
						return $author$project$Ui$el$(
							_List_fromArray(
								[$author$project$Ui$Font$noWrap]),
							$author$project$Ui$text(entry.name));
					},
					entries))
			]));
};
var $author$project$WordSpellingGame$gameSummary = function (log) {
	return $elm$core$List$foldl$(
		F2(
			function (entry, summary) {
				var _v0 = entry.description;
				switch (_v0.$) {
					case 0:
						var userId = _v0.a;
						var placedWord = _v0.b;
						return _Utils_update(
							summary,
							{
								bestWord: function () {
									var _v1 = summary.bestWord;
									if (!_v1.$) {
										var bestWord = _v1.a;
										return (_Utils_cmp(placedWord.points, bestWord.points) > -1) ? $elm$core$Maybe$Just(
											{placedCells: placedWord.placedCells, points: placedWord.points, shared: entry.shared, userId: userId, wildcardMatches: placedWord.wildcardMatches, word: placedWord.word}) : summary.bestWord;
									} else {
										return $elm$core$Maybe$Just(
											{placedCells: placedWord.placedCells, points: placedWord.points, shared: entry.shared, userId: userId, wildcardMatches: placedWord.wildcardMatches, word: placedWord.word});
									}
								}(),
								tilesPlaced: $author$project$SeqDictHelper$updateOrInsert$(
									userId,
									function (count) {
										return $elm$core$Maybe$withDefault$(0, count) + $elm$core$List$length(placedWord.placedCells);
									},
									summary.tilesPlaced)
							});
					case 1:
						var userId = _v0.a;
						return _Utils_update(
							summary,
							{
								invalidWords: $author$project$SeqDictHelper$updateOrInsert$(
									userId,
									function (count) {
										return $elm$core$Maybe$withDefault$(0, count) + 1;
									},
									summary.invalidWords)
							});
					default:
						return summary;
				}
			}),
		{bestWord: $elm$core$Maybe$Nothing, invalidWords: $lamdera$containers$SeqDict$empty, tilesPlaced: $lamdera$containers$SeqDict$empty},
		log);
};
var $author$project$WordSpellingGame$invalidWordsText = 'Invalid words:';
var $author$project$WordSpellingGame$tilesPlacedText = 'Tiles placed:';
var $author$project$WordSpellingGame$topScoringWordText = 'Top scoring word:';
var $author$project$WordSpellingGame$gameSummaryView$ = function (windowSize, localUser, shared, log) {
	var summary = $author$project$WordSpellingGame$gameSummary(log);
	var counts = function (tally) {
		return A2(
			$elm$core$List$sortBy,
			function (entry) {
				return -entry.count;
			},
			$elm$core$List$map$(
				function (player) {
					return {
						count: $elm$core$Maybe$withDefault$(
							0,
							$lamdera$containers$SeqDict$get$(player.userId, tally)),
						name: $author$project$User$toStringAlt$(player.userId, localUser)
					};
				},
				$mgold$elm_nonempty_list$List$Nonempty$toList(shared.players)));
	};
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(12),
				$author$project$Ui$paddingWith(
				{bottom: 8, left: 0, right: 0, top: 16}),
				$author$project$Ui$Font$color($author$project$MyUi$font3)
			]),
		_Utils_ap(
			_List_fromArray(
				[
					$author$project$Ui$column$(
					_List_fromArray(
						[
							$author$project$Ui$spacing(4)
						]),
					_List_fromArray(
						[
							$author$project$Ui$el$(
							_List_fromArray(
								[$author$project$Ui$Font$bold]),
							$author$project$Ui$text($author$project$WordSpellingGame$tilesPlacedText)),
							$author$project$WordSpellingGame$countsView(
							counts(summary.tilesPlaced))
						])),
					$author$project$Ui$column$(
					_List_fromArray(
						[
							$author$project$Ui$spacing(4)
						]),
					_List_fromArray(
						[
							$author$project$Ui$el$(
							_List_fromArray(
								[$author$project$Ui$Font$bold]),
							$author$project$Ui$text($author$project$WordSpellingGame$invalidWordsText)),
							$author$project$WordSpellingGame$countsView(
							counts(summary.invalidWords))
						]))
				]),
			function () {
				var _v0 = summary.bestWord;
				if (!_v0.$) {
					var bestWord = _v0.a;
					return _List_fromArray(
						[
							$author$project$Ui$column$(
							_List_fromArray(
								[
									$author$project$Ui$spacing(4)
								]),
							_List_fromArray(
								[
									$author$project$Ui$el$(
									_List_fromArray(
										[$author$project$Ui$Font$bold]),
									$author$project$Ui$text($author$project$WordSpellingGame$topScoringWordText)),
									$author$project$MyUi$rowButton$(
									$lamdera$program_test$Effect$Browser$Dom$id('wsg_topWord'),
									$author$project$WordSpellingGame$PressedWordDefinition(
										$author$project$WordSpellingGame$definitionWords$(bestWord.wildcardMatches, bestWord.word)),
									_List_fromArray(
										[
											$author$project$Ui$paddingXY$(4, 4),
											$author$project$Ui$rounded(4),
											$author$project$Ui$width($author$project$Ui$shrink),
											$author$project$MyUi$htmlStyle$('cursor', 'pointer'),
											$author$project$MyUi$hover$(
											$author$project$MyUi$isMobileAlt(windowSize),
											_List_fromArray(
												[
													$author$project$Ui$Anim$fontColor($author$project$MyUi$font1)
												])),
											$author$project$Ui$Events$onMouseEnter(
											$author$project$WordSpellingGame$MouseEnterWord$($elm$core$Maybe$Nothing, bestWord.placedCells, bestWord.shared)),
											$author$project$Ui$Events$onMouseLeave($author$project$WordSpellingGame$MouseExitWord)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Prose$paragraph$(
											_List_fromArray(
												[
													$author$project$Ui$alignTop,
													$author$project$MyUi$htmlStyle$('word-wrap', 'anywhere')
												]),
											_List_fromArray(
												[
													$author$project$Ui$text(
													bestWord.word + (' (+' + ($elm$core$String$fromInt(bestWord.points) + ') by '))),
													$author$project$Ui$el$(
													_List_fromArray(
														[$author$project$Ui$Font$bold]),
													$author$project$Ui$text(
														$author$project$User$toStringAlt$(bestWord.userId, localUser)))
												]))
										]))
								]))
						]);
				} else {
					return _List_Nil;
				}
			}()));
};
var $author$project$WordSpellingGame$gameSummaryView = F4($author$project$WordSpellingGame$gameSummaryView$);
var $author$project$Internal$Style2$Linear$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Internal$Style2$Linear = F2($author$project$Internal$Style2$Linear$);
var $author$project$Ui$Gradient$linear$ = function (angle, steps) {
	if (steps.b && (!steps.b.b)) {
		var single = steps.a;
		return $author$project$Internal$Style2$Linear$(
			angle,
			_List_fromArray(
				[single, single]));
	} else {
		return $author$project$Internal$Style2$Linear$(angle, steps);
	}
};
var $author$project$Ui$Gradient$linear = F2($author$project$Ui$Gradient$linear$);
var $author$project$WordSpellingGame$logPadding = 16;
var $author$project$WordSpellingGame$movesText = 'Moves';
var $author$project$Internal$Style2$Percent$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Internal$Style2$Percent = F2($author$project$Internal$Style2$Percent$);
var $author$project$Ui$Gradient$percent = $author$project$Internal$Style2$Percent;
var $author$project$WordSpellingGame$playerRowHeight = $author$project$User$profileImageSize;
var $author$project$Internal$Style2$Pixel$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Internal$Style2$Pixel = F2($author$project$Internal$Style2$Pixel$);
var $author$project$Ui$Gradient$px = $author$project$Internal$Style2$Pixel;
var $author$project$WordSpellingGame$ReactionMsg$ = function (a, b) {
	return {$: 17, a: a, b: b};
};
var $author$project$WordSpellingGame$ReactionMsg = F2($author$project$WordSpellingGame$ReactionMsg$);
var $author$project$WordSpellingGame$reactableMove$ = function (localUser, contentWidth, target, hoveredTarget, highlightedTarget, onMouseEnter, reactions, content) {
	var isHovered = _Utils_eq(
		hoveredTarget,
		$elm$core$Maybe$Just(target));
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$id(
				$lamdera$program_test$Effect$Browser$Dom$idToString(
					$author$project$WordSpellingGame$reactionTargetId(target))),
				$author$project$Ui$spacing(4),
				$author$project$Ui$Events$onMouseEnter(onMouseEnter),
				$author$project$Ui$Events$onMouseLeave($author$project$WordSpellingGame$MouseExitWord),
				isHovered ? $author$project$Ui$inFront(
				A2(
					$author$project$Ui$map,
					$author$project$WordSpellingGame$ReactionMsg(target),
					$author$project$MessageView$gameMiniViewNearEdge$(localUser.user, localUser.user.availableCustomEmojis, localUser.emojiData, localUser.customEmojis))) : $author$project$Ui$noAttr,
				$author$project$Ui$attrIf$(
				_Utils_eq(
					highlightedTarget,
					$elm$core$Maybe$Just(target)),
				$author$project$MyUi$highlightFadeOut($author$project$MyUi$replyToColor))
			]),
		A2(
			$elm$core$List$cons,
			content,
			function () {
				var _v0 = $author$project$MessageView$reactionEmojiView$(
					localUser.emojiData,
					isHovered ? $author$project$MessageView$ReactionsHovered : $author$project$MessageView$ReactionsNotHovered,
					localUser.session.userId,
					localUser.customEmojis,
					$author$project$User$allUsers(localUser),
					0,
					contentWidth,
					reactions);
				if (!_v0.$) {
					var reactionRow = _v0.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$map,
							$author$project$WordSpellingGame$ReactionMsg(target),
							reactionRow)
						]);
				} else {
					return _List_Nil;
				}
			}()));
};
var $author$project$WordSpellingGame$reactableMove = F8($author$project$WordSpellingGame$reactableMove$);
var $author$project$WordSpellingGame$recentActionsView$ = function (packedLogState, windowSize, localUser, setup, actions, shared) {
	var playerCount = $mgold$elm_nonempty_list$List$Nonempty$length(shared.players);
	var logState = $author$project$WordSpellingGame$decodeLogState(packedLogState);
	var log = $elm$core$Array$foldl$(
		F2(
			function (action, _v9) {
				var shared2 = _v9.a;
				var acc = _v9.b;
				var _v10 = $author$project$WordSpellingGame$updateAction$(setup, action, shared2);
				var shared3 = _v10.a;
				var descriptions = _v10.b;
				return _Utils_Tuple2(
					shared3,
					_Utils_ap(
						$elm$core$List$map$(
							function (description) {
								return {description: description, shared: shared3};
							},
							$elm$core$List$reverse(descriptions)),
						acc));
			}),
		_Utils_Tuple2(
			$author$project$WordSpellingGame$initShared(setup),
			_List_Nil),
		actions).b;
	var logLength = $elm$core$List$length(log);
	var hoveredTarget = $elm$core$Maybe$map$(
		function (index) {
			return logLength - index;
		},
		logState.hoveredIndex);
	var highlightedTarget = $elm$core$Maybe$map$($elm$core$Basics$identity, logState.highlightedMove);
	var contentWidth = ($author$project$Coord$xRaw(windowSize) - $author$project$WordSpellingGame$boardWidth$(setup.traySize, windowSize)) - ($author$project$WordSpellingGame$logPadding * 2);
	var log2 = _Utils_ap(
		function () {
			var _v1 = $author$project$WordSpellingGame$getWinner(shared);
			if (!_v1.$) {
				var _v2 = _v1.a;
				var gameEndReason = _v2.b;
				return _List_fromArray(
					[
						$author$project$WordSpellingGame$gameSummaryView$(windowSize, localUser, shared, log),
						$author$project$Ui$Prose$paragraph$(
						_List_fromArray(
							[
								$author$project$Ui$alignTop,
								$author$project$Ui$paddingWith(
								{bottom: 6, left: 0, right: 0, top: 30}),
								$author$project$Ui$Font$color($author$project$MyUi$font3)
							]),
						function () {
							if (!gameEndReason.$) {
								return _List_fromArray(
									[
										$author$project$Ui$text('Everyone passed and the game has ended!')
									]);
							} else {
								var userId = gameEndReason.a;
								return _List_fromArray(
									[
										$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$Font$bold,
												$author$project$MyUi$htmlStyle$('word-wrap', 'anywhere')
											]),
										$author$project$Ui$text(
											$author$project$User$toStringAlt$(userId, localUser))),
										$author$project$Ui$text(' ran out of letters and the game has ended!')
									]);
							}
						}())
					]);
			} else {
				var _v4 = $author$project$WordSpellingGame$getPlayer$(localUser.session.userId, shared);
				if (!_v4.$) {
					var player = _v4.a;
					var _v5 = player.premove;
					if (!_v5.$) {
						var _v6 = _v5.a;
						var result = _v6.b;
						return _List_fromArray(
							[
								$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$background($author$project$WordSpellingGame$premoveColor),
										$author$project$Ui$Font$color($author$project$MyUi$white),
										$author$project$Ui$paddingXY$(4, 0),
										$author$project$Ui$width($author$project$Ui$shrink)
									]),
								$author$project$Ui$text(
									'You\u0027ll automatically try placing ' + ($author$project$WordSpellingGame$headlineWord(result.words) + ' when it\u0027s your turn.')))
							]);
					} else {
						return _List_Nil;
					}
				} else {
					return _List_Nil;
				}
			}
		}(),
		$elm$core$List$indexedMap$(
			F2(
				function (index, entry) {
					var moveNumber = logLength - index;
					var description = entry.description;
					var hoveredCells = function () {
						switch (description.$) {
							case 0:
								var placedCells = description.b.placedCells;
								return placedCells;
							case 1:
								var placedCells = description.b.placedCells;
								return placedCells;
							default:
								return _List_Nil;
						}
					}();
					var name = $author$project$User$toStringAlt$(
						$author$project$WordSpellingGame$descriptionUserId(description),
						localUser);
					var rowContent = _List_fromArray(
						[
							$author$project$Ui$Prose$paragraph$(
							_List_fromArray(
								[
									$author$project$Ui$Font$color($author$project$MyUi$font3),
									$author$project$MyUi$noShrinking,
									$author$project$Ui$alignTop,
									$author$project$Ui$width($author$project$Ui$shrink)
								]),
							_List_fromArray(
								[
									$author$project$Ui$text(
									$elm$core$String$fromInt(moveNumber) + '. ')
								])),
							$author$project$Ui$Prose$paragraph$(
							_List_fromArray(
								[
									$author$project$Ui$alignTop,
									$author$project$MyUi$htmlStyle$('word-wrap', 'anywhere')
								]),
							_List_fromArray(
								[
									$author$project$Ui$el$(
									_List_fromArray(
										[$author$project$Ui$Font$bold]),
									$author$project$Ui$text(name)),
									$author$project$Ui$text(
									$author$project$WordSpellingGame$descriptionToString(description))
								]))
						]);
					return $author$project$WordSpellingGame$reactableMove$(
						localUser,
						contentWidth,
						moveNumber,
						hoveredTarget,
						highlightedTarget,
						$author$project$WordSpellingGame$MouseEnterWord$(
							$elm$core$Maybe$Just(index),
							hoveredCells,
							entry.shared),
						$elm$core$Maybe$withDefault$(
							$lamdera$containers$SeqDict$empty,
							$lamdera$containers$SeqDict$get$(moveNumber, shared.reactions)),
						function () {
							switch (description.$) {
								case 0:
									var wildcardMatches = description.b.wildcardMatches;
									var word = description.b.word;
									return $author$project$MyUi$rowButton$(
										$lamdera$program_test$Effect$Browser$Dom$id(
											'wsg_moveWord_' + $elm$core$String$fromInt(moveNumber)),
										$author$project$WordSpellingGame$PressedWordDefinition(
											$author$project$WordSpellingGame$definitionWords$(wildcardMatches, word)),
										_List_fromArray(
											[
												$author$project$Ui$Font$color($author$project$MyUi$font3),
												$author$project$Ui$spacing(8),
												$author$project$Ui$paddingXY$(4, 6),
												$author$project$Ui$rounded(4),
												$author$project$Ui$width($author$project$Ui$shrink),
												$author$project$MyUi$htmlStyle$('cursor', 'pointer'),
												$author$project$MyUi$hover$(
												$author$project$MyUi$isMobileAlt(windowSize),
												_List_fromArray(
													[
														$author$project$Ui$Anim$fontColor($author$project$MyUi$font1)
													]))
											]),
										rowContent);
								case 1:
									var word = description.b.word;
									return $author$project$MyUi$rowButton$(
										$lamdera$program_test$Effect$Browser$Dom$id(
											'wsg_moveWord_' + $elm$core$String$fromInt(moveNumber)),
										$author$project$WordSpellingGame$PressedWordDefinition(
											$author$project$WordSpellingGame$definitionWords$($elm$core$Set$empty, word)),
										_List_fromArray(
											[
												$author$project$Ui$Font$color($author$project$MyUi$font3),
												$author$project$Ui$spacing(8),
												$author$project$Ui$paddingXY$(4, 6),
												$author$project$Ui$rounded(4),
												$author$project$Ui$width($author$project$Ui$shrink),
												$author$project$MyUi$htmlStyle$('cursor', 'pointer'),
												$author$project$MyUi$hover$(
												$author$project$MyUi$isMobileAlt(windowSize),
												_List_fromArray(
													[
														$author$project$Ui$Anim$fontColor($author$project$MyUi$font1)
													]))
											]),
										rowContent);
								default:
									return $author$project$Ui$row$(
										_List_fromArray(
											[
												$author$project$Ui$Font$color($author$project$MyUi$font3),
												$author$project$Ui$spacing(8),
												$author$project$Ui$paddingXY$(4, 6)
											]),
										rowContent);
							}
						}());
				}),
			log));
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$height(
				$author$project$Ui$px(
					((($author$project$WordSpellingGame$tabBodyHeight$(windowSize, setup.traySize) - ($author$project$WordSpellingGame$playerRowHeight * playerCount)) - ($author$project$WordSpellingGame$playerRowSpacing * (playerCount - 1))) - $author$project$WordSpellingGame$lettersLeftHeight) - 16)),
				$author$project$Ui$heightMin(0),
				$author$project$Ui$inFront(
				$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$Font$color($author$project$MyUi$font3),
							$author$project$Ui$paddingWith(
							{bottom: 0, left: 16, right: 24, top: 0}),
							$author$project$Ui$Font$bold,
							$author$project$MyUi$noPointerEvents
						]),
					$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$height(
								$author$project$Ui$px(32)),
								$author$project$Ui$backgroundGradient(
								_List_fromArray(
									[
										$author$project$Ui$Gradient$linear$(
										$author$project$Ui$turns(0.5),
										_List_fromArray(
											[
												A2($author$project$Ui$Gradient$px, 0, $author$project$MyUi$background1),
												A2(
												$author$project$Ui$Gradient$percent,
												100,
												$author$project$Ui$rgba$(0, 0, 0, 0))
											])),
										$author$project$Ui$Gradient$linear$(
										$author$project$Ui$turns(0.5),
										_List_fromArray(
											[
												A2($author$project$Ui$Gradient$px, 0, $author$project$MyUi$background1),
												A2(
												$author$project$Ui$Gradient$percent,
												100,
												$author$project$Ui$rgba$(0, 0, 0, 0))
											]))
									]))
							]),
						$author$project$Ui$text($author$project$WordSpellingGame$movesText)))),
				function () {
				var _v0 = logState.scrollPosition;
				if (!_v0) {
					return $author$project$Ui$noAttr;
				} else {
					return $author$project$Ui$inFront(
						$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$Font$color($author$project$MyUi$font3),
									$author$project$Ui$paddingWith(
									{bottom: 0, left: 0, right: 24, top: 0}),
									$author$project$Ui$Font$bold,
									$author$project$MyUi$noPointerEvents,
									$author$project$Ui$alignBottom
								]),
							$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$height(
										$author$project$Ui$px(40)),
										$author$project$Ui$backgroundGradient(
										_List_fromArray(
											[
												$author$project$Ui$Gradient$linear$(
												$author$project$Ui$turns(0),
												_List_fromArray(
													[
														A2($author$project$Ui$Gradient$px, 0, $author$project$MyUi$background1),
														A2(
														$author$project$Ui$Gradient$percent,
														100,
														$author$project$Ui$rgba$(0, 0, 0, 0))
													]))
											]))
									]),
								$author$project$Ui$none)));
				}
			}()
			]),
		$author$project$Ui$column$(
			_List_fromArray(
				[
					$author$project$Ui$id(
					$lamdera$program_test$Effect$Browser$Dom$idToString($author$project$WordSpellingGame$pastWordsContainerId)),
					$author$project$Ui$Events$on$(
					'scroll',
					$author$project$Scroll$decodeScrollToBottom$($author$project$WordSpellingGame$UserScrolledPastMoves, logState.scrollPosition)),
					$author$project$Ui$paddingWith(
					{bottom: 16, left: $author$project$WordSpellingGame$logPadding, right: $author$project$WordSpellingGame$logPadding, top: 24}),
					$author$project$Ui$scrollable,
					$author$project$Ui$heightMin(0),
					$author$project$Ui$height($author$project$Ui$fill)
				]),
			$elm$core$List$isEmpty(log2) ? _List_fromArray(
				[
					$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$Font$color($author$project$MyUi$font3),
							$author$project$Ui$Font$italic
						]),
					$author$project$Ui$text('No moves made yet...'))
				]) : $elm$core$List$reverse(log2)));
};
var $author$project$WordSpellingGame$recentActionsView = F6($author$project$WordSpellingGame$recentActionsView$);
var $author$project$WordSpellingGame$statusView$ = function (windowSize, isPersonalDm, localUser, highlightedMove, setup, actions, shared, model) {
	var winners = $author$project$WordSpellingGame$getWinner(shared);
	var playerCount = $mgold$elm_nonempty_list$List$Nonempty$length(shared.players);
	var nextPlayer = $mgold$elm_nonempty_list$List$Nonempty$get$(shared.turnCount + 1, shared.players);
	var isMobile = $author$project$MyUi$isMobileAlt(windowSize);
	var currentPlayer = $mgold$elm_nonempty_list$List$Nonempty$get$(shared.turnCount, shared.players);
	return isMobile ? $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$paddingXY$(8, 0),
				$author$project$Ui$spacing(8),
				$author$project$Ui$height(
				$author$project$Ui$px($author$project$WordSpellingGame$statusHeight)),
				$author$project$MyUi$prewrap
			]),
		_List_fromArray(
			[
				$author$project$Ui$column$(
				_List_fromArray(
					[$author$project$Ui$centerY]),
				function () {
					if (!winners.$) {
						var _v1 = winners.a;
						var winners2 = _v1.a;
						return $author$project$WordSpellingGame$leaderboardView$(isMobile, model.highlightedPlayer, winners2, shared, localUser);
					} else {
						return _List_fromArray(
							[
								function () {
								var _v2 = $author$project$User$getUser$(currentPlayer.userId, localUser);
								if (!_v2.$) {
									var user = _v2.a;
									return $author$project$WordSpellingGame$mobilePlayerRow$(
										model.highlightedPlayer,
										currentPlayer.userId,
										true,
										user,
										'\u0027s turn (' + ($elm$core$String$fromInt(currentPlayer.score) + ')'));
								} else {
									return $author$project$Ui$none;
								}
							}(),
								function () {
								var _v3 = $author$project$User$getUser$(nextPlayer.userId, localUser);
								if (!_v3.$) {
									var user = _v3.a;
									return $author$project$WordSpellingGame$mobilePlayerRow$(
										model.highlightedPlayer,
										nextPlayer.userId,
										false,
										user,
										' is next (' + ($elm$core$String$fromInt(nextPlayer.score) + ')'));
								} else {
									return $author$project$Ui$none;
								}
							}(),
								$elm$core$Maybe$withDefault$(
								$author$project$Ui$none,
								$author$project$WordSpellingGame$joinWarning$(isPersonalDm, playerCount, localUser, shared))
							]);
					}
				}())
			])) : $author$project$Ui$column$(
		_List_fromArray(
			[
				function () {
				var _v4 = $author$project$WordSpellingGame$joinWarning$(isPersonalDm, playerCount, localUser, shared);
				if (!_v4.$) {
					var element = _v4.a;
					return $author$project$Ui$inFront(
						$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$alignBottom,
									$author$project$Ui$paddingXY$(0, 8)
								]),
							element));
				} else {
					return $author$project$Ui$noAttr;
				}
			}()
			]),
		_List_fromArray(
			[
				function () {
				if (!winners.$) {
					return $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$(16, 0),
								$author$project$Ui$Font$bold,
								$author$project$Ui$contentCenterY,
								$author$project$Ui$height(
								$author$project$Ui$px($author$project$WordSpellingGame$lettersLeftHeight))
							]),
						$author$project$Ui$text($author$project$WordSpellingGame$gameOverText));
				} else {
					return $author$project$Ui$row$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$(16, 0),
								$author$project$Ui$contentCenterY,
								$author$project$Ui$height(
								$author$project$Ui$px($author$project$WordSpellingGame$lettersLeftHeight)),
								$author$project$Ui$Font$color($author$project$MyUi$font3),
								$author$project$MyUi$prewrap
							]),
						function () {
							var _v6 = $author$project$WordSpellingGame$remainingLettersInBagCount$(
								setup,
								shared.board,
								$mgold$elm_nonempty_list$List$Nonempty$toList(shared.players));
							if (_v6 === 1) {
								return _List_fromArray(
									[
										$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$Font$bold,
												$author$project$Ui$width($author$project$Ui$shrink)
											]),
										$author$project$Ui$text('1')),
										$author$project$Ui$text(' letter left!')
									]);
							} else {
								var remaining = _v6;
								return _List_fromArray(
									[
										$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$Font$bold,
												$author$project$Ui$width($author$project$Ui$shrink)
											]),
										$author$project$Ui$text(
											$elm$core$String$fromInt(remaining))),
										$author$project$Ui$text(' letters left')
									]);
							}
						}());
				}
			}(),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$paddingWith(
						{bottom: 16, left: 16, right: 8, top: 0}),
						$author$project$Ui$spacing($author$project$WordSpellingGame$playerRowSpacing)
					]),
				function () {
					if (!winners.$) {
						var _v8 = winners.a;
						var winners2 = _v8.a;
						return $author$project$WordSpellingGame$leaderboardView$(isMobile, model.highlightedPlayer, winners2, shared, localUser);
					} else {
						return $elm$core$List$indexedMap$(
							F2(
								function (index, player) {
									return $author$project$WordSpellingGame$playerRow$(
										localUser,
										player.userId,
										_Utils_eq(
											index,
											A2($elm$core$Basics$modBy, playerCount, shared.turnCount)),
										_Utils_eq(
											model.highlightedPlayer,
											$elm$core$Maybe$Just(player.userId)),
										_Utils_eq(
											index,
											A2($elm$core$Basics$modBy, playerCount, shared.turnCount)) ? ('\u0027s turn (' + ($elm$core$String$fromInt(player.score) + ')')) : (_Utils_eq(
											index,
											A2($elm$core$Basics$modBy, playerCount, shared.turnCount + 1)) ? (' is next (' + ($elm$core$String$fromInt(player.score) + ')')) : (' (' + ($elm$core$String$fromInt(player.score) + ')'))));
								}),
							$mgold$elm_nonempty_list$List$Nonempty$toList(shared.players));
					}
				}()),
				$author$project$Ui$Lazy$lazy6$(
				$author$project$WordSpellingGame$recentActionsView,
				$author$project$WordSpellingGame$encodeLogState$(
					model.scrollPosition,
					$elm$core$Maybe$andThen$(
						function ($) {
							return $.index;
						},
						model.hoveredMove),
					highlightedMove),
				windowSize,
				localUser,
				setup,
				actions,
				shared)
			]));
};
var $author$project$WordSpellingGame$statusView = F8($author$project$WordSpellingGame$statusView$);
var $author$project$WordSpellingGame$tileOwners$ = function (setup, actions) {
	return $elm$core$Array$foldl$(
		F2(
			function (action, _v0) {
				var shared = _v0.a;
				var owners = _v0.b;
				var _v1 = $author$project$WordSpellingGame$updateAction$(setup, action, shared);
				var shared2 = _v1.a;
				var descriptions = _v1.b;
				return _Utils_Tuple2(
					shared2,
					$elm$core$List$foldl$(
						F2(
							function (description, owners2) {
								if (!description.$) {
									var userId = description.a;
									var placedCells = description.b.placedCells;
									return $elm$core$List$foldl$(
										F2(
											function (_v3, acc) {
												var position = _v3.a;
												var letter = _v3.b;
												return $lamdera$containers$SeqDict$insert$(
													position,
													{letter: letter, userId: userId},
													acc);
											}),
										owners2,
										placedCells);
								} else {
									return owners2;
								}
							}),
						owners,
						descriptions));
			}),
		_Utils_Tuple2(
			$author$project$WordSpellingGame$initShared(setup),
			$lamdera$containers$SeqDict$empty),
		actions).b;
};
var $author$project$WordSpellingGame$tileOwners = F2($author$project$WordSpellingGame$tileOwners$);
var $author$project$WordSpellingGame$validatedToSetupModel = function (setup) {
	return {
		advancedSettingsExpanded: true,
		error: $elm$core$Maybe$Nothing,
		fullTrayBonus: setup.fullTrayBonus,
		incrementInput: $elm$core$String$fromFloat(
			$ianmackenzie$elm_units$Duration$inSeconds(setup.timeControls.increment)),
		language: setup.language,
		letterValues: $lamdera$containers$SeqDict$fromList(
			$elm$core$List$filterMap$(
				function (_v0) {
					var letterOrWildcard = _v0.a;
					var data = _v0.b;
					if (!letterOrWildcard.$) {
						var _char = letterOrWildcard.a;
						return $elm$core$Maybe$Just(
							_Utils_Tuple2(
								_char,
								$elm$core$String$fromInt(data.value)));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				$author$project$NonemptyDict$toList(setup.letters))),
		letters: $elm$core$String$concat(
			$elm$core$List$map$(
				function (_v2) {
					var letterOrWildcard = _v2.a;
					var data = _v2.b;
					return $elm$core$String$repeat$(
						$author$project$OneOrGreater$toInt(data.count),
						$author$project$WordSpellingGame$letterOrWildcardText(letterOrWildcard));
				},
				$author$project$NonemptyDict$toList(setup.letters))),
		mainTimeInput: $elm$core$String$fromFloat(
			$ianmackenzie$elm_units$Duration$inMinutes(setup.timeControls.mainTime)),
		placeWordAttempts: setup.placeWordAttempts,
		traySize: $author$project$OneOrGreater$toInt(setup.traySize)
	};
};
var $author$project$WordSpellingGame$wordDefinitionColumnWidth = 400;
var $author$project$WordSpellingGame$wideEnoughForDefinitionColumn$ = function (windowSize, showMemberTab) {
	return (_Utils_cmp(
		$author$project$MyUi$conversationWidthIgnoreScrollbar$(windowSize, showMemberTab),
		700 + $author$project$WordSpellingGame$wordDefinitionColumnWidth) > -1) && (!$author$project$MyUi$isMobileAlt(windowSize));
};
var $author$project$WordSpellingGame$wideEnoughForDefinitionColumn = F2($author$project$WordSpellingGame$wideEnoughForDefinitionColumn$);
var $author$project$Internal$Model2$link = function (details) {
	return {
		attr: {
			additionalInheritance: $author$project$Internal$BitField$none,
			attrs: _List_fromArray(
				[
					$elm$html$Html$Attributes$href(details.url),
					$elm$html$Html$Attributes$rel('noopener noreferrer'),
					function () {
					var _v0 = details.download;
					if (_v0.$ === 1) {
						return details.newTab ? $elm$html$Html$Attributes$target('_blank') : $elm$html$Html$Attributes$class('');
					} else {
						var downloadName = _v0.a;
						return $elm$html$Html$Attributes$download(downloadName);
					}
				}()
				]),
			_class: $elm$core$Maybe$Nothing,
			nearby: $elm$core$Maybe$Nothing,
			node: $author$project$Internal$Model2$NodeAsLink,
			styles: $author$project$Internal$Model2$noStyles
		},
		flag: $author$project$Internal$Flag$skip
	};
};
var $author$project$Ui$linkNewTab = function (uri) {
	return $author$project$Internal$Model2$link(
		{download: $elm$core$Maybe$Nothing, newTab: true, url: uri});
};
var $author$project$WordSpellingGame$definitionCredits = $author$project$Ui$Prose$paragraph$(
	_List_fromArray(
		[
			$author$project$Ui$alignBottom,
			$author$project$Ui$Font$size(14),
			$author$project$Ui$paddingWith(
			{bottom: 16, left: 0, right: 0, top: 24}),
			$author$project$Ui$Font$color($author$project$MyUi$font3)
		]),
	_List_fromArray(
		[
			$author$project$Ui$text('Definitions from '),
			$author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$linkNewTab('https://en.wiktionary.org/'),
					$author$project$Ui$Font$noWrap
				]),
			$author$project$Ui$text('Wiktionary')),
			$author$project$Ui$text(', via '),
			$author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$linkNewTab('https://www.datamuse.com/api/'),
					$author$project$Ui$Font$noWrap
				]),
			$author$project$Ui$text('Datamuse'))
		]));
var $author$project$Animator$set = function (attrs) {
	return A2($author$project$Animator$step, $author$project$InternalAnim$Time$zeroDuration, attrs);
};
var $author$project$Ui$Anim$intro$ = function (dur, attrs) {
	return $author$project$Ui$Anim$toAttr$(
		3,
		$author$project$Animator$toCss(
			$author$project$Animator$keyframes(
				_List_fromArray(
					[
						$author$project$Animator$set(attrs.start),
						A2($author$project$Animator$step, dur, attrs.to)
					]))));
};
var $author$project$Ui$Anim$intro = F2($author$project$Ui$Anim$intro$);
var $author$project$WordSpellingGame$wordDefinitionEntryView = function (entry) {
	var shouldNumber = $elm$core$List$length(entry.definitions) > 1;
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(6)
			]),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Font$bold,
						$author$project$Ui$Font$italic,
						$author$project$Ui$Font$color($author$project$MyUi$font3)
					]),
				$author$project$Ui$text(entry.partOfSpeech)),
			$elm$core$List$indexedMap$(
				F2(
					function (index, def) {
						return $author$project$Ui$row$(
							_List_fromArray(
								[
									$author$project$Ui$spacing(8),
									$author$project$Ui$contentTop
								]),
							_List_fromArray(
								[
									shouldNumber ? $author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$Font$bold,
											$author$project$Ui$width($author$project$Ui$shrink),
											$author$project$MyUi$noShrinking
										]),
									$author$project$Ui$text(
										$elm$core$String$fromInt(index + 1) + '.')) : $author$project$Ui$none,
									$author$project$Ui$text(def)
								]));
					}),
				entry.definitions)));
};
var $author$project$WordSpellingGame$wordDefinitionBody$ = function (word, data) {
	switch (data.$) {
		case 0:
			return $author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Font$color($author$project$MyUi$font3),
						$author$project$Ui$Font$italic,
						$author$project$Ui$Anim$intro$(
						$author$project$Ui$Anim$ms(200),
						{
							start: _List_fromArray(
								[
									$author$project$Ui$Anim$opacity(0)
								]),
							to: _List_fromArray(
								[
									$author$project$Ui$Anim$opacity(1)
								])
						})
					]),
				$author$project$Ui$text('Loading definition...'));
		case 1:
			return $author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Font$color($author$project$MyUi$font3)
					]),
				$author$project$Ui$text('Swedish dictionary definitions not supported'));
		case 2:
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$Font$color($author$project$MyUi$font3),
						$author$project$Ui$height($author$project$Ui$fill)
					]),
				_List_fromArray(
					[
						$author$project$Ui$text('No definition found for ' + (word + '.')),
						$author$project$WordSpellingGame$definitionCredits
					]));
		case 3:
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$Font$color($author$project$MyUi$font3),
						$author$project$Ui$height($author$project$Ui$fill)
					]),
				_List_fromArray(
					[
						$author$project$Ui$text('Couldn\u0027t reach the dictionary. Try again in a moment.'),
						$author$project$WordSpellingGame$definitionCredits
					]));
		default:
			var entries = data.a;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(16),
						$author$project$Ui$height($author$project$Ui$fill)
					]),
				_Utils_ap(
					$elm$core$List$map$($author$project$WordSpellingGame$wordDefinitionEntryView, entries),
					_List_fromArray(
						[$author$project$WordSpellingGame$definitionCredits])));
	}
};
var $author$project$WordSpellingGame$wordDefinitionBody = F2($author$project$WordSpellingGame$wordDefinitionBody$);
var $author$project$WordSpellingGame$wordDefinitionContainerId = $lamdera$program_test$Effect$Browser$Dom$id('wsg_wordDefinition');
var $author$project$WordSpellingGame$PressedCloseWordDefinition = {$: 15};
var $author$project$WordSpellingGame$PressedNextWordDefinition = {$: 14};
var $author$project$WordSpellingGame$PressedPreviousWordDefinition = {$: 13};
var $author$project$WordSpellingGame$wordDefinitionArrow$ = function (htmlId, onPress, label, icon) {
	return $author$project$MyUi$elButton$(
		htmlId,
		onPress,
		_List_fromArray(
			[
				$author$project$Ui$width(
				$author$project$Ui$px(32)),
				$author$project$Ui$height(
				$author$project$Ui$px(42)),
				$author$project$Ui$contentCenterX,
				$author$project$Ui$contentCenterY,
				$author$project$Ui$rounded(4),
				$author$project$Ui$Font$color($author$project$MyUi$font3),
				$author$project$Ui$Accessibility$description(label),
				$author$project$MyUi$hover$(
				false,
				_List_fromArray(
					[
						$author$project$Ui$Anim$fontColor($author$project$MyUi$font1)
					]))
			]),
		$author$project$Ui$html(icon));
};
var $author$project$WordSpellingGame$wordDefinitionArrow = F4($author$project$WordSpellingGame$wordDefinitionArrow$);
var $author$project$WordSpellingGame$wordDefinitionHeader = function (open) {
	var wordCount = $mgold$elm_nonempty_list$List$Nonempty$length(open.words);
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8),
				$author$project$Ui$paddingWith(
				{bottom: 0, left: 16, right: 0, top: 0}),
				$author$project$Ui$borderWith(
				{bottom: 1, left: 0, right: 0, top: 0}),
				$author$project$Ui$borderColor($author$project$MyUi$border1),
				$author$project$Ui$Font$color($author$project$MyUi$font1),
				$author$project$Ui$height(
				$author$project$Ui$px(42)),
				$author$project$MyUi$noShrinking,
				$author$project$Ui$contentCenterY,
				$author$project$Ui$background($author$project$MyUi$background1)
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Font$bold,
						$author$project$Ui$Font$size(18),
						$author$project$Ui$width($author$project$Ui$shrink),
						$author$project$MyUi$monospace,
						$author$project$Ui$Font$letterSpacing(1.5)
					]),
				$author$project$Ui$text(
					$author$project$WordSpellingGame$currentDefinitionWord(open))),
				function () {
				if (wordCount > 1) {
					var total = $elm$core$String$fromInt(wordCount);
					var current = $elm$core$String$fromInt(open.index + 1);
					var diff = $elm$core$String$length(total) - $elm$core$String$length(current);
					return $author$project$Ui$row$(
						_List_fromArray(
							[
								$author$project$Ui$width($author$project$Ui$shrink),
								$author$project$Ui$contentCenterY
							]),
						_List_fromArray(
							[
								$author$project$WordSpellingGame$wordDefinitionArrow$(
								$lamdera$program_test$Effect$Browser$Dom$id('wsg_previousWordDefinition'),
								$author$project$WordSpellingGame$PressedPreviousWordDefinition,
								'Previous word',
								$author$project$Icons$arrowLeft(16)),
								$author$project$Ui$row$(
								_List_fromArray(
									[
										$author$project$Ui$Font$size(14),
										$author$project$Ui$Font$color($author$project$MyUi$font3),
										$author$project$Ui$width($author$project$Ui$shrink),
										$author$project$Ui$Font$noWrap
									]),
								_List_fromArray(
									[
										$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$opacity(0.5)
											]),
										$author$project$Ui$text(
											$elm$core$String$repeat$(diff, '0'))),
										$author$project$Ui$text(current + ('/' + total))
									])),
								$author$project$WordSpellingGame$wordDefinitionArrow$(
								$lamdera$program_test$Effect$Browser$Dom$id('wsg_nextWordDefinition'),
								$author$project$WordSpellingGame$PressedNextWordDefinition,
								'Next word',
								$author$project$Icons$arrowRight(16))
							]));
				} else {
					return $author$project$Ui$none;
				}
			}(),
				$author$project$Ui$el$(_List_Nil, $author$project$Ui$none),
				$author$project$MyUi$elButton$(
				$lamdera$program_test$Effect$Browser$Dom$id('wsg_closeWordDefinition'),
				$author$project$WordSpellingGame$PressedCloseWordDefinition,
				_List_fromArray(
					[
						$author$project$Ui$width(
						$author$project$Ui$px(42)),
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$alignRight,
						$author$project$Ui$contentCenterX,
						$author$project$Ui$contentCenterY,
						$author$project$Ui$rounded(4),
						$author$project$Ui$Font$color($author$project$MyUi$font3),
						$author$project$Ui$Accessibility$description('Close word definition'),
						$author$project$MyUi$hoverText('Close word definition'),
						$author$project$MyUi$hover$(
						false,
						_List_fromArray(
							[
								$author$project$Ui$Anim$fontColor($author$project$MyUi$font1)
							]))
					]),
				$author$project$Ui$html($author$project$Icons$x))
			]));
};
var $author$project$WordSpellingGame$wordDefinitionColumn$ = function (windowSize, setup, open, data) {
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$id(
				$lamdera$program_test$Effect$Browser$Dom$idToString($author$project$WordSpellingGame$wordDefinitionContainerId)),
				$author$project$Ui$width(
				$author$project$Ui$px($author$project$WordSpellingGame$wordDefinitionColumnWidth)),
				$author$project$Ui$height(
				$author$project$Ui$px(
					$author$project$WordSpellingGame$tabBodyHeight$(windowSize, setup.traySize))),
				$author$project$Ui$borderWith(
				{bottom: 0, left: 1, right: 0, top: 0}),
				$author$project$Ui$borderColor($author$project$MyUi$border1),
				$author$project$Ui$background($author$project$MyUi$background1),
				$author$project$MyUi$noShrinking,
				$author$project$Ui$clip
			]),
		_List_fromArray(
			[
				$author$project$WordSpellingGame$wordDefinitionHeader(open),
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$scrollable,
						$author$project$Ui$paddingXY$(16, 8),
						$author$project$Ui$heightMin(0)
					]),
				$author$project$WordSpellingGame$wordDefinitionBody$(
					$author$project$WordSpellingGame$currentDefinitionWord(open),
					data))
			]));
};
var $author$project$WordSpellingGame$wordDefinitionColumn = F4($author$project$WordSpellingGame$wordDefinitionColumn$);
var $author$project$WordSpellingGame$wordDefinitionOverlay$ = function (boardPx, open, data) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$id(
				$lamdera$program_test$Effect$Browser$Dom$idToString($author$project$WordSpellingGame$wordDefinitionContainerId)),
				$author$project$Ui$width(
				$author$project$Ui$px(boardPx)),
				$author$project$Ui$height(
				$author$project$Ui$px(boardPx)),
				$author$project$Ui$background(
				$author$project$Ui$rgba$(0, 0, 0, 0.4)),
				$author$project$Ui$padding(12),
				$author$project$Ui$heightMin(0)
			]),
		$author$project$Ui$column$(
			_List_fromArray(
				[
					$author$project$Ui$background(
					$author$project$MyUi$colorWithAlpha$(0.85, $author$project$MyUi$background1)),
					$author$project$Ui$rounded(8),
					$author$project$Ui$border(1),
					$author$project$Ui$borderColor($author$project$MyUi$border1),
					$author$project$Ui$height($author$project$Ui$fill),
					$author$project$Ui$clip,
					$author$project$Ui$heightMin(0)
				]),
			_List_fromArray(
				[
					$author$project$WordSpellingGame$wordDefinitionHeader(open),
					$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$height($author$project$Ui$fill),
							$author$project$Ui$scrollable,
							$author$project$Ui$paddingXY$(16, 8),
							$author$project$Ui$heightMin(0)
						]),
					$author$project$WordSpellingGame$wordDefinitionBody$(
						$author$project$WordSpellingGame$currentDefinitionWord(open),
						data))
				])));
};
var $author$project$WordSpellingGame$wordDefinitionOverlay = F3($author$project$WordSpellingGame$wordDefinitionOverlay$);
var $author$project$WordSpellingGame$gameView$ = function (currentTime, windowSize, showMemberTab, maybeDragging, isPersonalDm, localUser, highlightedMove, setup, actions, shared, oldModel) {
	var model = _Utils_update(
		oldModel,
		{
			tiles: $author$project$WordSpellingGame$getTiles$(windowSize, localUser.session.userId, setup, shared, oldModel.tiles)
		});
	var isMobile = $author$project$MyUi$isMobileAlt(windowSize);
	var settingsButton = $author$project$Ui$inFront(
		isMobile ? $author$project$MyUi$elButton$(
			$lamdera$program_test$Effect$Browser$Dom$id('wsg_settings'),
			$author$project$WordSpellingGame$PressedToggleSettings,
			_List_fromArray(
				[
					$author$project$Ui$width(
					$author$project$Ui$px(40)),
					$author$project$Ui$padding(8),
					$author$project$Ui$alignRight,
					$author$project$Ui$alignBottom,
					$author$project$Ui$Font$color($author$project$MyUi$font1),
					$author$project$Ui$Accessibility$description('Game settings'),
					$author$project$MyUi$hoverText('Game settings'),
					$author$project$Ui$background($author$project$MyUi$background1)
				]),
			$author$project$Ui$html($author$project$Icons$gear)) : $author$project$MyUi$elButton$(
			$lamdera$program_test$Effect$Browser$Dom$id('wsg_settings'),
			$author$project$WordSpellingGame$PressedToggleSettings,
			_List_fromArray(
				[
					$author$project$Ui$width(
					$author$project$Ui$px(40)),
					$author$project$Ui$padding(8),
					$author$project$Ui$alignRight,
					function () {
					var _v7 = _Utils_Tuple2(
						$author$project$WordSpellingGame$wideEnoughForDefinitionColumn$(windowSize, showMemberTab),
						model.wordDefinition);
					if (_v7.a && (_v7.b.$ === 1)) {
						var _v8 = _v7.b;
						return $author$project$Ui$move(
							{x: -$author$project$WordSpellingGame$wordDefinitionColumnWidth, y: 0, z: 0});
					} else {
						return $author$project$Ui$noAttr;
					}
				}(),
					$author$project$Ui$Font$color($author$project$MyUi$font1),
					$author$project$Ui$Accessibility$description('Game settings'),
					$author$project$MyUi$hoverText('Game settings')
				]),
			$author$project$Ui$html($author$project$Icons$gear)));
	var hoveredWordCells = function () {
		var _v6 = model.hoveredMove;
		if (!_v6.$) {
			var hovered = _v6.a;
			return hovered.cells;
		} else {
			return $elm$core$Dict$empty;
		}
	}();
	var highlightedCells = function () {
		var _v5 = model.highlightedPlayer;
		if (!_v5.$) {
			var userId = _v5.a;
			return $lamdera$containers$SeqDict$foldl$(
				F3(
					function (pos, data, acc) {
						return _Utils_eq(data.userId, userId) ? $elm$core$Dict$insert$(pos, data.letter, acc) : acc;
					}),
				$elm$core$Dict$empty,
				$author$project$WordSpellingGame$tileOwners$(setup, actions));
		} else {
			return $elm$core$Dict$empty;
		}
	}();
	if (model.showSettings) {
		return $author$project$Ui$el$(
			_List_fromArray(
				[settingsButton]),
			A2(
				$author$project$Ui$map,
				function (_v0) {
					return $author$project$WordSpellingGame$PressedToggleSettings;
				},
				$author$project$WordSpellingGame$setupView$(
					windowSize,
					true,
					$author$project$WordSpellingGame$validatedToSetupModel(setup))));
	} else {
		var wideEnough = $author$project$WordSpellingGame$wideEnoughForDefinitionColumn$(windowSize, showMemberTab);
		var boardPx = $author$project$WordSpellingGame$cellSize$(setup.traySize, windowSize) * $author$project$WordSpellingGame$gridSize;
		var overlayAttr = function () {
			var _v3 = _Utils_Tuple2(wideEnough, model.wordDefinition);
			if ((!_v3.a) && (_v3.b.$ === 1)) {
				var _v4 = _v3.b;
				var open = _v4.a;
				var data = _v4.b;
				return $author$project$Ui$inFront(
					$author$project$WordSpellingGame$wordDefinitionOverlay$(boardPx, open, data));
			} else {
				return $author$project$Ui$noAttr;
			}
		}();
		return A2(
			isMobile ? $author$project$Ui$column : $author$project$Ui$row,
			_List_fromArray(
				[
					$author$project$Ui$height(
					$author$project$Ui$px(
						$author$project$WordSpellingGame$tabBodyHeight$(windowSize, setup.traySize))),
					$author$project$Ui$background($author$project$MyUi$tabBackground),
					$author$project$Ui$borderWith(
					{bottom: 1, left: 0, right: 0, top: 0}),
					$author$project$Ui$borderColor($author$project$MyUi$border2),
					$author$project$MyUi$noShrinking,
					settingsButton,
					$author$project$Ui$contentTop,
					overlayAttr
				]),
			_Utils_ap(
				_List_fromArray(
					[
						$author$project$WordSpellingGame$boardView$(
						currentTime,
						windowSize,
						maybeDragging,
						localUser,
						setup,
						shared,
						$elm$core$Dict$union$(highlightedCells, hoveredWordCells),
						model),
						$author$project$WordSpellingGame$statusView$(windowSize, isPersonalDm, localUser, highlightedMove, setup, actions, shared, model)
					]),
				function () {
					var _v1 = _Utils_Tuple2(wideEnough, model.wordDefinition);
					if (_v1.a && (_v1.b.$ === 1)) {
						var _v2 = _v1.b;
						var open = _v2.a;
						var data = _v2.b;
						return _List_fromArray(
							[
								$author$project$WordSpellingGame$wordDefinitionColumn$(windowSize, setup, open, data)
							]);
					} else {
						return _List_Nil;
					}
				}()));
	}
};
var $author$project$WordSpellingGame$gameView = function (currentTime) {
	return function (windowSize) {
		return function (showMemberTab) {
			return function (maybeDragging) {
				return function (isPersonalDm) {
					return function (localUser) {
						return function (highlightedMove) {
							return function (setup) {
								return function (actions) {
									return function (shared) {
										return function (oldModel) {
											return $author$project$WordSpellingGame$gameView$(currentTime, windowSize, showMemberTab, maybeDragging, isPersonalDm, localUser, highlightedMove, setup, actions, shared, oldModel);
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Game$NoOpMsg = {$: 11};
var $author$project$Game$PressedCopyLink = function (a) {
	return {$: 7, a: a};
};
var $author$project$Game$PressedShareMatch = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Input$HiddenLabel = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Input$labelHidden = $author$project$Ui$Input$HiddenLabel;
var $elm$html$Html$Attributes$readonly = $elm$html$Html$Attributes$boolProperty('readOnly');
var $author$project$MyUi$copyBoxAlt$ = function (htmlId, label2, pressedCopyText, noOp, loaded, text) {
	var label4 = function () {
		if (!label2.$) {
			var _v3 = label2.a;
			var labelAttribute = _v3.a;
			var labelText = _v3.b;
			return $author$project$Ui$Input$label$(
				$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId) + '_textInput',
				labelAttribute,
				labelText);
		} else {
			return {
				element: $author$project$Ui$none,
				id: $author$project$Ui$Input$labelHidden(
					$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId) + '_textInput')
			};
		}
	}();
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(2)
			]),
		_List_fromArray(
			[
				label4.element,
				$author$project$Ui$row$(
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Input$text,
						_List_fromArray(
							[
								$author$project$Ui$clipWithEllipsis,
								$author$project$Ui$paddingWith(
								{bottom: 2, left: 8, right: 0, top: 2}),
								$author$project$Ui$htmlAttribute(
								$elm$html$Html$Attributes$readonly(true)),
								$author$project$Ui$background(
								$author$project$Ui$rgba$(0, 0, 0, 0.2)),
								$author$project$Ui$border(1),
								$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
								$author$project$Ui$roundedWith(
								{bottomLeft: 4, bottomRight: 0, topLeft: 4, topRight: 0}),
								$author$project$Ui$height($author$project$Ui$fill)
							]),
						{
							label: label4.id,
							onChange: function (_v0) {
								return noOp;
							},
							placeholder: $elm$core$Maybe$Nothing,
							text: text
						}),
						$author$project$MyUi$elButton$(
						$lamdera$program_test$Effect$Browser$Dom$id(
							$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId) + '_copy'),
						pressedCopyText(text),
						_List_fromArray(
							[
								$author$project$Ui$width($author$project$Ui$shrink),
								$author$project$Ui$paddingWith(
								{bottom: 2, left: 8, right: 8, top: 2}),
								$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
								$author$project$Ui$borderWith(
								{bottom: 1, left: 0, right: 1, top: 1}),
								$author$project$Ui$roundedWith(
								{bottomLeft: 0, bottomRight: 4, topLeft: 0, topRight: 4}),
								$author$project$Ui$spacing(4),
								$author$project$Ui$background($author$project$MyUi$buttonBackground),
								$author$project$Ui$height(
								$author$project$Ui$px(40)),
								$author$project$Ui$contentCenterY
							]),
						function () {
							var _v1 = loaded.lastCopied;
							if (!_v1.$) {
								var copied = _v1.a;
								return _Utils_eq(
									copied.copied,
									$author$project$MyUi$CopiedText(text)) ? $author$project$Ui$text('Copied!') : $author$project$Ui$html(
									$author$project$Icons$copy(22));
							} else {
								return $author$project$Ui$html(
									$author$project$Icons$copy(22));
							}
						}())
					]))
			]));
};
var $author$project$MyUi$copyBoxAlt = F6($author$project$MyUi$copyBoxAlt$);
var $author$project$MyUi$copyBox$ = function (htmlId, label2, pressedCopyText, noOp, loaded, text) {
	return $author$project$MyUi$copyBoxAlt$(
		htmlId,
		$elm$core$Maybe$map$(
			function (labelText) {
				return _Utils_Tuple2(
					_List_fromArray(
						[
							$author$project$Ui$Font$size(14),
							$author$project$Ui$Font$color($author$project$MyUi$font3),
							$author$project$Ui$Font$bold
						]),
					$author$project$Ui$text(labelText));
			},
			label2),
		pressedCopyText,
		noOp,
		loaded,
		text);
};
var $author$project$MyUi$copyBox = F6($author$project$MyUi$copyBox$);
var $author$project$Go$publicGoMatchUrl = function (publicLink) {
	return $author$project$Env$domain + ('/go-match/' + $author$project$SecretId$toString(publicLink));
};
var $author$project$Game$goShareView$ = function (lastCopied, matchId, maybePublicLink) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(4),
				$author$project$Ui$width($author$project$Ui$shrink)
			]),
		function () {
			if (!maybePublicLink.$) {
				var publicLink = maybePublicLink.a;
				return _List_fromArray(
					[
						$author$project$Ui$text('Share'),
						$author$project$MyUi$copyBox$(
						$lamdera$program_test$Effect$Browser$Dom$id('go_shareLink'),
						$elm$core$Maybe$Nothing,
						$author$project$Game$PressedCopyLink,
						$author$project$Game$NoOpMsg,
						{lastCopied: lastCopied},
						$author$project$Go$publicGoMatchUrl(publicLink))
					]);
			} else {
				return _List_fromArray(
					[
						$author$project$MyUi$simpleButton$(
						$lamdera$program_test$Effect$Browser$Dom$id('go_share'),
						$author$project$Game$PressedShareMatch(matchId),
						$author$project$Ui$text('Share'))
					]);
			}
		}());
};
var $author$project$Game$goShareView = F3($author$project$Game$goShareView$);
var $author$project$Ui$Lazy$apply3$ = function (fn, a, b, c, s) {
	return $author$project$Internal$Model2$unwrap$(
		s,
		A3(fn, a, b, c));
};
var $author$project$Ui$Lazy$apply3 = F5($author$project$Ui$Lazy$apply3$);
var $elm$virtual_dom$VirtualDom$lazy5 = _VirtualDom_lazy5;
var $elm$html$Html$Lazy$lazy5 = $elm$virtual_dom$VirtualDom$lazy5;
var $author$project$Ui$Lazy$lazy3$ = function (fn, a, b, c) {
	return function (s) {
		return A6($elm$html$Html$Lazy$lazy5, $author$project$Ui$Lazy$apply3, fn, a, b, c, s);
	};
};
var $author$project$Ui$Lazy$lazy3 = F4($author$project$Ui$Lazy$lazy3$);
var $author$project$Game$loadingMatchText = 'Loading match';
var $author$project$Game$matchNotFound = $author$project$Ui$el$(
	_List_fromArray(
		[
			$author$project$Ui$contentCenterX,
			$author$project$Ui$centerY,
			$author$project$Ui$Font$bold,
			$author$project$Ui$Font$size(20),
			$author$project$Ui$background($author$project$MyUi$background1),
			$author$project$Ui$paddingXY$(0, 16)
		]),
	$author$project$Ui$text('Match not found'));
var $author$project$Game$PressedReset = {$: 9};
var $author$project$Game$SelectedMatch = function (a) {
	return {$: 8, a: a};
};
var $elm$html$Html$option = _VirtualDom_node('option');
var $elm$html$Html$select = _VirtualDom_node('select');
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $author$project$Game$matchSwitcherView$ = function (isMobile, maybeMatchId, matches) {
	if ($lamdera$containers$SeqDict$isEmpty(matches)) {
		return $author$project$Ui$none;
	} else {
		var newMatchValue = ' ';
		var onSelect = function (text) {
			if (_Utils_eq(text, newMatchValue)) {
				return $author$project$Game$PressedReset;
			} else {
				var _v4 = $elm$core$String$toInt(text);
				if (!_v4.$) {
					var n = _v4.a;
					return $author$project$Game$SelectedMatch(
						$author$project$Id$fromInt(n));
				} else {
					return $author$project$Game$PressedReset;
				}
			}
		};
		var currentValue = function () {
			if (!maybeMatchId.$) {
				var matchId = maybeMatchId.a;
				return $elm$core$String$fromInt(
					$author$project$Id$toInt(matchId));
			} else {
				return newMatchValue;
			}
		}();
		return $author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$padding(8)
				]),
			$author$project$Ui$html(
				A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('game_matchSwitcher'),
							$elm$html$Html$Attributes$value(currentValue),
							$elm$html$Html$Events$onInput(onSelect),
							A2($elm$html$Html$Attributes$style, 'width', 'fit-content'),
							A2($elm$html$Html$Attributes$attribute, 'aria-label', 'View match'),
							A2(
							$elm$html$Html$Attributes$style,
							'padding',
							isMobile ? '4px' : '7px 8px'),
							A2(
							$elm$html$Html$Attributes$style,
							'border',
							'1px solid ' + $author$project$MyUi$colorToStyle($author$project$MyUi$inputBorder)),
							A2($elm$html$Html$Attributes$style, 'border-radius', '4px'),
							A2(
							$elm$html$Html$Attributes$style,
							'font-size',
							isMobile ? '14px' : '16px'),
							A2(
							$elm$html$Html$Attributes$style,
							'background-color',
							$author$project$MyUi$colorToStyle($author$project$MyUi$background2)),
							A2(
							$elm$html$Html$Attributes$style,
							'color',
							$author$project$MyUi$colorToStyle($author$project$MyUi$white)),
							A2($elm$html$Html$Attributes$style, 'cursor', 'pointer')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$option,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value(newMatchValue),
									$elm$html$Html$Attributes$selected(
									_Utils_eq(maybeMatchId, $elm$core$Maybe$Nothing))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('View existing match')
								])),
						$elm$core$List$map$(
							function (_v0) {
								var matchId = _v0.a;
								var matchData = _v0.b;
								var text = function () {
									if (!matchData.$) {
										var matchData2 = matchData.a;
										var _v2 = matchData2.data;
										switch (_v2.$) {
											case 0:
												return $author$project$Game$goName;
											case 1:
												return $author$project$Game$wordSpellingGameName;
											default:
												return $author$project$Game$sheepGameName;
										}
									} else {
										var gameType = matchData.a;
										return $author$project$Game$gameToString(gameType);
									}
								}();
								var matchIdText = $author$project$Id$toString(matchId);
								return A2(
									$elm$html$Html$option,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$value(matchIdText),
											$elm$html$Html$Attributes$selected(
											_Utils_eq(
												$elm$core$Maybe$Just(matchId),
												maybeMatchId))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('#' + (matchIdText + (' ' + text)))
										]));
							},
							$lamdera$containers$SeqDict$toList(matches))))));
	}
};
var $author$project$Game$matchSwitcherView = F3($author$project$Game$matchSwitcherView$);
var $author$project$Go$ChangedHandicapInput = function (a) {
	return {$: 2, a: a};
};
var $author$project$Go$ChangedHeightInput = function (a) {
	return {$: 1, a: a};
};
var $author$project$Go$ChangedIncrementInput = function (a) {
	return {$: 5, a: a};
};
var $author$project$Go$ChangedMainTimeInput = function (a) {
	return {$: 4, a: a};
};
var $author$project$Go$ChangedWidthInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Go$CustomSize = 3;
var $author$project$Go$PressedCancel = {$: 9};
var $author$project$Go$PressedStartGame = {$: 8};
var $author$project$Go$SelectedPlayingAs = function (a) {
	return {$: 7, a: a};
};
var $author$project$Go$SelectedSize = function (a) {
	return {$: 6, a: a};
};
var $author$project$Go$Standard13 = 1;
var $author$project$Go$Standard19 = 2;
var $author$project$Ui$contentBottom = $author$project$Internal$Model2$classWith$($author$project$Internal$Flag$yContentAlign, $author$project$Internal$Style2$classes.contentBottom);
var $author$project$Go$dimensionInput$ = function (htmlId, value, onChange) {
	return $author$project$Go$numberInput(
		{htmlId: htmlId, isReadonly: false, maxValue: $author$project$Go$maxDimension, minValue: $author$project$Go$minDimension, onChange: onChange, value: value, width: 60});
};
var $author$project$Go$dimensionInput = F3($author$project$Go$dimensionInput$);
var $author$project$Go$ChangedKomiInput = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Attributes$step = function (n) {
	return A2(_VirtualDom_attribute, 'step', n);
};
var $author$project$Go$komiInput = function (value) {
	return $author$project$Ui$html(
		A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('go_komiInput'),
					$elm$html$Html$Attributes$type_('number'),
					$elm$html$Html$Attributes$step('0.5'),
					$elm$html$Html$Attributes$value(value),
					A2($elm$html$Html$Attributes$style, 'font-size', 'inherit'),
					A2($elm$html$Html$Attributes$style, 'width', '50px'),
					A2($elm$html$Html$Attributes$style, 'padding', '8px'),
					A2(
					$elm$html$Html$Attributes$style,
					'border',
					'1px solid ' + $author$project$MyUi$colorToStyle($author$project$MyUi$inputBorder)),
					A2($elm$html$Html$Attributes$style, 'border-radius', '4px'),
					$elm$html$Html$Events$onInput($author$project$Go$ChangedKomiInput)
				]),
			_List_Nil));
};
var $author$project$MyUi$radioRow$ = function (htmlId, onPress, maybeValue, title, options) {
	var label2 = $author$project$Ui$Input$label$(
		$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId),
		_List_fromArray(
			[$author$project$Ui$Font$bold]),
		$author$project$Ui$text(title));
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8)
			]),
		_List_fromArray(
			[
				label2.element,
				$author$project$Ui$Input$chooseOne$(
				$author$project$Ui$row,
				_List_fromArray(
					[
						$author$project$Ui$spacing(24),
						$author$project$Ui$wrap
					]),
				{
					label: label2.id,
					onChange: onPress,
					options: $elm$core$List$map$(
						function (_v0) {
							var value = _v0.a;
							var text = _v0.b;
							return $author$project$MyUi$radioOption$(htmlId, value, text);
						},
						options),
					selected: maybeValue
				})
			]));
};
var $author$project$MyUi$radioRow = F5($author$project$MyUi$radioRow$);
var $author$project$Go$sizeRadioButtonId = $lamdera$program_test$Effect$Browser$Dom$id('go_boardSize');
var $author$project$Go$timeInput$ = function (htmlId, label, value, onChange) {
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(4),
				$author$project$Ui$width($author$project$Ui$shrink)
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Font$size(12)
					]),
				$author$project$Ui$text(label)),
				$author$project$Ui$html(
				A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(htmlId),
							$elm$html$Html$Attributes$type_('number'),
							$elm$html$Html$Attributes$min('0'),
							$elm$html$Html$Attributes$step('1'),
							$elm$html$Html$Attributes$value(value),
							A2($elm$html$Html$Attributes$style, 'font-size', 'inherit'),
							A2($elm$html$Html$Attributes$style, 'width', '70px'),
							A2($elm$html$Html$Attributes$style, 'padding', '8px'),
							A2(
							$elm$html$Html$Attributes$style,
							'border',
							'1px solid ' + $author$project$MyUi$colorToStyle($author$project$MyUi$inputBorder)),
							A2($elm$html$Html$Attributes$style, 'border-radius', '4px'),
							$elm$html$Html$Events$onInput(onChange)
						]),
					_List_Nil))
			]));
};
var $author$project$Go$timeInput = F4($author$project$Go$timeInput$);
var $author$project$Go$setupView$ = function (playingAgainstSelf, windowSize, model) {
	var isMobile = $author$project$MyUi$isMobileAlt(windowSize);
	var boardSizeLabel = $author$project$Ui$Input$label$(
		$lamdera$program_test$Effect$Browser$Dom$idToString($author$project$Go$sizeRadioButtonId),
		_List_fromArray(
			[
				$author$project$Ui$Font$weight(600)
			]),
		$author$project$Ui$text('Board size'));
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(
				isMobile ? 8 : 16),
				$author$project$Ui$paddingXY$(0, 16),
				$author$project$Ui$background($author$project$MyUi$tabBackground)
			]),
		_List_fromArray(
			[
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(16)
					]),
				_List_fromArray(
					[
						$author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$spacing(8),
								$author$project$Ui$paddingXY$(
								isMobile ? 8 : 16,
								0)
							]),
						_List_fromArray(
							[
								boardSizeLabel.element,
								$author$project$Ui$Input$chooseOne$(
								$author$project$Ui$row,
								_List_fromArray(
									[
										$author$project$Ui$spacing(24),
										$author$project$Ui$wrap
									]),
								{
									label: boardSizeLabel.id,
									onChange: $author$project$Go$SelectedSize,
									options: _List_fromArray(
										[
											$author$project$MyUi$radioOption$($author$project$Go$sizeRadioButtonId, 0, '9 x 9'),
											$author$project$MyUi$radioOption$($author$project$Go$sizeRadioButtonId, 1, '13 x 13'),
											$author$project$MyUi$radioOption$($author$project$Go$sizeRadioButtonId, 2, '19 x 19'),
											$author$project$Ui$Input$optionWith$(
											3,
											function (option) {
												return $author$project$Ui$row$(
													_List_fromArray(
														[
															$author$project$Ui$spacing(6),
															$author$project$Ui$id(
															$lamdera$program_test$Effect$Browser$Dom$idToString($author$project$Go$sizeRadioButtonId) + '_Custom')
														]),
													_List_fromArray(
														[
															$author$project$MyUi$radioCircle(option),
															$author$project$Ui$row$(
															_List_fromArray(
																[
																	$author$project$Ui$spacing(8),
																	$author$project$Ui$width($author$project$Ui$shrink)
																]),
															_List_fromArray(
																[
																	$author$project$Ui$text('Custom'),
																	$author$project$Go$dimensionInput$('go_widthInput', model.widthInput, $author$project$Go$ChangedWidthInput),
																	$author$project$Ui$text('x'),
																	$author$project$Go$dimensionInput$('go_heightInput', model.heightInput, $author$project$Go$ChangedHeightInput)
																]))
														]));
											})
										]),
									selected: $elm$core$Maybe$Just(model.sizeSelection)
								})
							])),
						playingAgainstSelf ? $author$project$Ui$none : $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$(
								isMobile ? 8 : 16,
								0)
							]),
						$author$project$MyUi$radioRow$(
							$lamdera$program_test$Effect$Browser$Dom$id('go_boardSize'),
							$author$project$Go$SelectedPlayingAs,
							$elm$core$Maybe$Just(model.gameCreatorPlayingAs),
							'Playing as',
							_List_fromArray(
								[
									_Utils_Tuple2(0, 'Black'),
									_Utils_Tuple2(1, 'White')
								]))),
						$author$project$Go$setupSection$(
						isMobile,
						$author$project$Ui$text('Handicap'),
						$elm$core$Maybe$Just(' (extra black starting stones)'),
						$author$project$Go$numberInput(
							{htmlId: 'go_handicapInput', isReadonly: false, maxValue: $author$project$Go$maxHandicap, minValue: 0, onChange: $author$project$Go$ChangedHandicapInput, value: model.handicapInput, width: 60})),
						$author$project$Go$setupSection$(
						isMobile,
						$author$project$Ui$text('Komi'),
						$elm$core$Maybe$Just(' (extra points for White)'),
						$author$project$Go$komiInput(model.komiInput)),
						$author$project$Go$setupSection$(
						isMobile,
						$author$project$Ui$text('Time control'),
						$elm$core$Maybe$Just(' (set main time to 0 to disable)'),
						$author$project$Ui$row$(
							_List_fromArray(
								[
									$author$project$Ui$spacing(8),
									$author$project$Ui$width($author$project$Ui$shrink),
									$author$project$Ui$contentBottom
								]),
							_List_fromArray(
								[
									$author$project$Go$timeInput$('go_mainTimeInput', 'Main time (minutes)', model.mainTimeInput, $author$project$Go$ChangedMainTimeInput),
									$author$project$Go$timeInput$('go_incrementInput', 'Increment (seconds)', model.incrementInput, $author$project$Go$ChangedIncrementInput)
								]))),
						function () {
						var _v0 = model.error;
						if (!_v0.$) {
							var err = _v0.a;
							return $author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$Font$color($author$project$MyUi$dangerRed)
									]),
								$author$project$Ui$text(err));
						} else {
							return $author$project$Ui$none;
						}
					}()
					])),
				$author$project$Go$startOrCancel$('go', isMobile, $author$project$Go$PressedCancel, $author$project$Go$PressedStartGame)
			]));
};
var $author$project$Go$setupView = F3($author$project$Go$setupView$);
var $author$project$SheepGame$PressedAddQuestion = {$: 1};
var $author$project$SheepGame$PressedCancel = {$: 4};
var $author$project$SheepGame$PressedStartGame = {$: 3};
var $author$project$SheepGame$PressedDeleteAttachedFile$ = function (a, b) {
	return {$: 7, a: a, b: b};
};
var $author$project$SheepGame$PressedDeleteAttachedFile = F2($author$project$SheepGame$PressedDeleteAttachedFile$);
var $author$project$SheepGame$PressedRemoveQuestion = function (a) {
	return {$: 2, a: a};
};
var $author$project$SheepGame$PressedToggleAttachedFileSpoiler$ = function (a, b) {
	return {$: 9, a: a, b: b};
};
var $author$project$SheepGame$PressedToggleAttachedFileSpoiler = F2($author$project$SheepGame$PressedToggleAttachedFileSpoiler$);
var $author$project$SheepGame$PressedViewAttachedFileInfo$ = function (a, b) {
	return {$: 8, a: a, b: b};
};
var $author$project$SheepGame$PressedViewAttachedFileInfo = F2($author$project$SheepGame$PressedViewAttachedFileInfo$);
var $author$project$SheepGame$TypedQuestion$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$SheepGame$TypedQuestion = F2($author$project$SheepGame$TypedQuestion$);
var $author$project$MyUi$deleteButton$ = function (htmlId, onPress) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$Input$button(onPress),
				$author$project$Ui$id(
				$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId)),
				$author$project$MyUi$hoverText('Delete'),
				$author$project$Ui$width(
				$author$project$Ui$px(40)),
				$author$project$Ui$height(
				$author$project$Ui$px(40)),
				$author$project$Ui$contentCenterX,
				$author$project$Ui$contentCenterY,
				$author$project$Ui$background($author$project$MyUi$deleteButtonBackground),
				$author$project$Ui$border(1),
				$author$project$Ui$borderColor($author$project$MyUi$deleteButtonBorder),
				$author$project$Ui$Font$color($author$project$MyUi$deleteButtonFont),
				$author$project$Ui$rounded(4),
				$author$project$Ui$Shadow$shadows(
				_List_fromArray(
					[
						{
						blur: 2,
						color: $author$project$Ui$rgba$(0, 0, 0, 0.1),
						size: 0,
						x: 0,
						y: 1
					}
					]))
			]),
		$author$project$Ui$html($author$project$Icons$delete));
};
var $author$project$MyUi$deleteButton = F2($author$project$MyUi$deleteButton$);
var $author$project$SheepGame$questionInput$ = function (localUser, loggedIn, users, index, question) {
	var richText = $elm$core$Maybe$map$(
		A3($author$project$RichText$fromNonemptyString, localUser.timezone, users, $lamdera$containers$SeqDict$empty),
		$MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(question.text));
	var questionId = $author$project$Id$fromInt(index);
	var htmlId = $author$project$SheepGame$inputId(
		$author$project$SheepGame$QuestionInput(questionId));
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(4)
			]),
		_List_fromArray(
			[
				function () {
				var _v0 = $author$project$NonemptyDict$fromSeqDict(question.attachedFiles);
				if (!_v0.$) {
					var attachedFiles = _v0.a;
					return $author$project$Ui$row$(
						_List_fromArray(
							[
								$author$project$Ui$spacing(2),
								$author$project$Ui$width($author$project$Ui$shrink)
							]),
						$author$project$SheepGame$fileUploadPreview$(
							$author$project$SheepGame$PressedDeleteAttachedFile(questionId),
							$author$project$SheepGame$PressedViewAttachedFileInfo(questionId),
							$elm$core$Maybe$Just(
								$author$project$SheepGame$PressedToggleAttachedFileSpoiler(questionId)),
							richText,
							attachedFiles));
				} else {
					return $author$project$Ui$none;
				}
			}(),
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Ui$row$(
						_List_fromArray(
							[
								$author$project$Ui$width($author$project$Ui$shrink),
								$author$project$Ui$alignTop,
								$author$project$Ui$spacing(4)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$map,
								$author$project$SheepGame$TypedQuestion(questionId),
								$author$project$MessageInput$attachmentButton(
									$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId))),
								A2(
								$author$project$Ui$map,
								$author$project$SheepGame$TypedQuestion(questionId),
								$author$project$MessageInput$showEmojiSelectorButton(
									$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId)))
							])),
						$author$project$Ui$el$(
						_List_Nil,
						$author$project$Ui$el$(
							A2(
								$elm$core$List$cons,
								$author$project$Ui$heightMax(300),
								A2(
									$elm$core$List$cons,
									$author$project$Ui$id(
										$lamdera$program_test$Effect$Browser$Dom$idToString(
											$author$project$SheepGame$inputContainerId(
												$author$project$SheepGame$QuestionInput(questionId)))),
									$author$project$MessageInput$containerAttributes(true))),
							A2(
								$author$project$Ui$map,
								$author$project$SheepGame$TypedQuestion(questionId),
								$author$project$Ui$html(
									$author$project$MessageInput$textarea$(
										false,
										htmlId,
										$author$project$MessageInput$emptyPlaceholder,
										$author$project$SheepGame$maxQuestionLength - $elm$core$String$length(question.text),
										question.text,
										richText,
										question.attachedFiles,
										localUser,
										loggedIn,
										users,
										$lamdera$containers$SeqDict$empty))))),
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$width($author$project$Ui$shrink),
								$author$project$Ui$alignTop
							]),
						$author$project$MyUi$deleteButton$(
							$lamdera$program_test$Effect$Browser$Dom$id(
								'sheepGame_removeQuestion_' + $elm$core$String$fromInt(index)),
							$author$project$SheepGame$PressedRemoveQuestion(questionId)))
					]))
			]));
};
var $author$project$SheepGame$questionInput = F5($author$project$SheepGame$questionInput$);
var $author$project$SheepGame$setupView$ = function (windowSize, localUser, loggedIn, users, model) {
	var isMobile = $author$project$MyUi$isMobileAlt(windowSize);
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(16),
				$author$project$Ui$background($author$project$MyUi$tabBackground),
				$author$project$Ui$heightMax(
				$author$project$SheepGame$tabBodyHeight$(false, windowSize)),
				$author$project$Ui$scrollable,
				$author$project$Ui$heightMin(0),
				$author$project$Ui$paddingXY$(0, 16)
			]),
		_List_fromArray(
			[
				$author$project$Go$setupSection$(
				isMobile,
				$author$project$Ui$text('Sheep Questions'),
				$elm$core$Maybe$Nothing,
				$author$project$Ui$column$(
					_List_fromArray(
						[
							$author$project$Ui$spacing(8)
						]),
					_Utils_ap(
						$elm$core$List$indexedMap$(
							F2(
								function (index, question) {
									return $author$project$Ui$column$(
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Lazy$lazy5$($author$project$SheepGame$questionInput, localUser, loggedIn, users, index, question),
												function () {
												var _v0 = _Utils_Tuple2(
													model.pressedSubmit,
													$author$project$SheepGame$validateInput$(localUser.timezone, users, question));
												if (_v0.a && (_v0.b.$ === 1)) {
													var error = _v0.b.a;
													return $author$project$Ui$el$(
														_List_fromArray(
															[
																$author$project$Ui$Font$color($author$project$MyUi$errorColor)
															]),
														$author$project$Ui$text(error));
												} else {
													return $author$project$Ui$none;
												}
											}()
											]));
								}),
							$author$project$IdArray$toList(model.questions)),
						_List_fromArray(
							[
								$author$project$MyUi$secondaryButton$(
								$lamdera$program_test$Effect$Browser$Dom$id('sheepGame_addQuestion'),
								$author$project$SheepGame$PressedAddQuestion,
								'Add question')
							])))),
				function () {
				var _v1 = model.error;
				if (!_v1.$) {
					var error = _v1.a;
					return $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$Font$color($author$project$MyUi$errorColor)
							]),
						$author$project$Ui$text(error));
				} else {
					return $author$project$Ui$none;
				}
			}(),
				$author$project$Go$startOrCancel$('sheepGame', isMobile, $author$project$SheepGame$PressedCancel, $author$project$SheepGame$PressedStartGame)
			]));
};
var $author$project$SheepGame$setupView = F5($author$project$SheepGame$setupView$);
var $author$project$Game$view$ = function (currentTime, windowSize, showMemberTab, drag, startupData, lastCopied, localUser, loggedIn, guildOrDmId, maybeMatchId, repliedTo, matches, model) {
	var isPersonalDm = _Utils_eq(
		guildOrDmId,
		$author$project$Id$GuildOrDmId_Dm(
			{otherUserId: localUser.session.userId}));
	var isMobile = $author$project$MyUi$isMobileAlt(windowSize);
	var highlightedResult = function () {
		_v9$2:
		while (true) {
			if (!repliedTo.$) {
				switch (repliedTo.a.$) {
					case 1:
						var _v10 = repliedTo.a;
						var userId = _v10.a;
						var questionId = _v10.b;
						return $elm$core$Maybe$Just(
							$author$project$SheepGame$AnswerReaction$(userId, questionId));
					case 2:
						var questionId = repliedTo.a.a;
						return $elm$core$Maybe$Just(
							$author$project$SheepGame$NotesReaction(questionId));
					default:
						break _v9$2;
				}
			} else {
				break _v9$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	}();
	var highlightedMove = function () {
		if ((!repliedTo.$) && (!repliedTo.a.$)) {
			var moveNumber = repliedTo.a.a;
			return $elm$core$Maybe$Just(moveNumber);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	if (!maybeMatchId.$) {
		var matchId = maybeMatchId.a;
		var _v1 = _Utils_Tuple2(
			$lamdera$containers$SeqDict$get$(matchId, matches),
			$lamdera$containers$SeqDict$get$(matchId, model.startedGames));
		_v1$2:
		while (true) {
			if (!_v1.a.$) {
				if (_v1.a.a.$ === 1) {
					return $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$Font$center,
								$author$project$Ui$paddingXY$(0, 16),
								$author$project$Ui$Font$bold,
								$author$project$Ui$Font$size(20),
								$author$project$Ui$background($author$project$MyUi$background1)
							]),
						$author$project$Ui$text($author$project$Game$loadingMatchText));
				} else {
					if (!_v1.b.$) {
						var match = _v1.a.a.a;
						var game = _v1.b.a;
						var _v2 = match.data;
						switch (_v2.$) {
							case 0:
								var setup = _v2.a;
								var cache = _v2.c;
								if (!game.$) {
									var game2 = game.a;
									return $author$project$Ui$column$(
										_List_fromArray(
											[
												$author$project$Ui$height(
												$author$project$Ui$px(
													$author$project$Go$viewHeight(windowSize))),
												$author$project$Ui$scrollable,
												$author$project$Ui$background($author$project$MyUi$tabBackground),
												$author$project$Ui$borderWith(
												{bottom: 1, left: 0, right: 0, top: 0}),
												$author$project$Ui$borderColor($author$project$MyUi$border2),
												$author$project$MyUi$noShrinking,
												$author$project$Ui$spacing(8)
											]),
										_List_fromArray(
											[
												$author$project$Ui$el$(
												_List_fromArray(
													[
														$author$project$Ui$padding(8)
													]),
												$author$project$Game$goShareView$(lastCopied, matchId, match.publicLink)),
												A2(
												$author$project$Ui$map,
												$author$project$Game$GoGameMsg,
												$author$project$Go$gameView$(currentTime, windowSize, localUser, setup, cache, game2))
											]));
								} else {
									return $author$project$Game$matchNotFound;
								}
							case 1:
								var setup = _v2.a;
								var actions = _v2.b;
								var cache = _v2.c;
								if (game.$ === 1) {
									var game2 = game.a;
									return A2(
										$author$project$Ui$map,
										$author$project$Game$WordSpellingGameMsg,
										$author$project$WordSpellingGame$gameView$(
											currentTime,
											windowSize,
											showMemberTab,
											function () {
												switch (drag.$) {
													case 0:
														return $elm$core$Maybe$Nothing;
													case 1:
														var dragging = drag.b;
														return $elm$core$Maybe$Just(
															$author$project$Touch$removeSafeAreaTopInset$(startupData.safeAreaInsetTop, dragging));
													default:
														var dragging = drag.a;
														return $elm$core$Maybe$Just(
															$author$project$Touch$removeSafeAreaTopInset$(startupData.safeAreaInsetTop, dragging.touches));
												}
											}(),
											isPersonalDm,
											localUser,
											highlightedMove,
											setup,
											actions,
											cache,
											game2));
								} else {
									return $author$project$Game$matchNotFound;
								}
							default:
								var setup = _v2.a;
								var cache = _v2.c;
								if (game.$ === 2) {
									var game2 = game.a;
									return A2(
										$author$project$Ui$map,
										$author$project$Game$SheepGameMsg,
										$author$project$SheepGame$gameView$(currentTime, windowSize, showMemberTab, localUser, drag, loggedIn, highlightedResult, setup, cache, game2));
								} else {
									return $author$project$Game$matchNotFound;
								}
						}
					} else {
						break _v1$2;
					}
				}
			} else {
				break _v1$2;
			}
		}
		return $author$project$Game$matchNotFound;
	} else {
		return $author$project$Ui$column$(
			_List_fromArray(
				[
					$author$project$Ui$height(
					$author$project$Ui$px(
						$author$project$Go$viewHeight(windowSize))),
					$author$project$Ui$scrollable,
					$author$project$Ui$background($author$project$MyUi$tabBackground),
					$author$project$Ui$borderWith(
					{bottom: 1, left: 0, right: 0, top: 0}),
					$author$project$Ui$borderColor($author$project$MyUi$border2),
					$author$project$MyUi$noShrinking
				]),
			_List_fromArray(
				[
					$author$project$Ui$Lazy$lazy3$($author$project$Game$matchSwitcherView, isMobile, maybeMatchId, matches),
					function () {
					var _v7 = model.setup;
					switch (_v7.$) {
						case 1:
							var setup = _v7.a;
							return A2(
								$author$project$Ui$map,
								$author$project$Game$GoSetupMsg,
								$author$project$Go$setupView$(isPersonalDm, windowSize, setup));
						case 2:
							var setup = _v7.a;
							return A2(
								$author$project$Ui$map,
								$author$project$Game$WordSpellingSetupMsg,
								$author$project$WordSpellingGame$setupView$(windowSize, false, setup));
						case 3:
							var setup = _v7.a;
							return A2(
								$author$project$Ui$map,
								$author$project$Game$SheepSetupMsg,
								$author$project$SheepGame$setupView$(
									windowSize,
									localUser,
									loggedIn,
									$author$project$User$allUsers(localUser),
									setup));
						default:
							return $author$project$Ui$row$(
								_List_fromArray(
									[
										$author$project$Ui$spacing(8),
										$author$project$Ui$wrap,
										$author$project$Ui$padding(8),
										isMobile ? $author$project$Ui$centerX : $author$project$Ui$alignLeft
									]),
								$elm$core$List$map$(
									$author$project$Game$gameSelectButton(isMobile),
									$author$project$Game$allGames));
					}
				}()
				]));
	}
};
var $author$project$Game$view = function (currentTime) {
	return function (windowSize) {
		return function (showMemberTab) {
			return function (drag) {
				return function (startupData) {
					return function (lastCopied) {
						return function (localUser) {
							return function (loggedIn) {
								return function (guildOrDmId) {
									return function (maybeMatchId) {
										return function (repliedTo) {
											return function (matches) {
												return function (model) {
													return $author$project$Game$view$(currentTime, windowSize, showMemberTab, drag, startupData, lastCopied, localUser, loggedIn, guildOrDmId, maybeMatchId, repliedTo, matches, model);
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$ChannelHeader$gameTabBody$ = function (guildOrDmId, maybeMatchId, repliedTo, local, loggedIn, matchData, model) {
	return $elm$core$Maybe$Just(
		A2(
			$author$project$Ui$map,
			$author$project$Types$GameMsg,
			$author$project$Game$view$(
				model.time,
				model.windowSize,
				function () {
					var _v0 = $author$project$Route$toShowMembersTab(model.route);
					if (!_v0.a) {
						var _v1 = _v0.a;
						return true;
					} else {
						var _v2 = _v0.a;
						return false;
					}
				}(),
				model.drag,
				model.startupData,
				model.lastCopied,
				local.localUser,
				loggedIn,
				guildOrDmId,
				maybeMatchId,
				repliedTo,
				matchData,
				$elm$core$Maybe$withDefault$(
					$author$project$Game$initModel,
					$lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.games)))));
};
var $author$project$ChannelHeader$gameTabBody = F7($author$project$ChannelHeader$gameTabBody$);
var $author$project$ChannelDescription$toString = function (_v0) {
	var a = _v0;
	return a;
};
var $author$project$Call$PressedCopyError = function (a) {
	return {$: 10, a: a};
};
var $author$project$Call$PressedJoinCall = function (a) {
	return {$: 5, a: a};
};
var $author$project$Call$PressedLeaveCall = {$: 6};
var $author$project$Call$PressedToggleMute = {$: 2};
var $author$project$Call$PressedTogglePauseVideo = {$: 3};
var $author$project$Call$PressedToggleDeviceSettings = {$: 16};
var $author$project$Call$deviceSettingsButton = function (isOpen) {
	return $author$project$MyUi$elButton$(
		$lamdera$program_test$Effect$Browser$Dom$id('guild_voiceChatDeviceSettings'),
		$author$project$Call$PressedToggleDeviceSettings,
		_List_fromArray(
			[
				$author$project$Ui$width(
				$author$project$Ui$px(40)),
				$author$project$Ui$height(
				$author$project$Ui$px(40)),
				$author$project$Ui$contentCenterX,
				$author$project$Ui$contentCenterY,
				$author$project$Ui$rounded(20),
				$author$project$MyUi$hoverText('Microphone and camera'),
				$author$project$Ui$border(1),
				$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
				$author$project$Ui$background(
				isOpen ? $author$project$Ui$rgb$(70, 82, 122) : $author$project$Ui$rgb$(42, 50, 78)),
				$author$project$Ui$Font$color($author$project$MyUi$white)
			]),
		$author$project$Ui$html($author$project$Icons$gear));
};
var $author$project$MyUi$errorBackground = $author$project$Ui$background(
	$author$project$Ui$rgb$(38, 10, 22));
var $author$project$MyUi$errorBox$ = function (htmlId, onPress, error) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$border(1),
				$author$project$Ui$borderColor($author$project$MyUi$errorColor),
				$author$project$Ui$Font$color($author$project$MyUi$errorColor),
				$author$project$Ui$rounded(2),
				$author$project$MyUi$errorBackground,
				$author$project$Ui$spacing(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$clipWithEllipsis,
						$author$project$MyUi$hoverText(error),
						$author$project$Ui$paddingWith(
						{bottom: 2, left: 4, right: 0, top: 2})
					]),
				$author$project$Ui$text(error)),
				$author$project$MyUi$elButton$(
				htmlId,
				onPress(error),
				_List_fromArray(
					[
						$author$project$Ui$width($author$project$Ui$shrink),
						$author$project$Ui$paddingWith(
						{bottom: 2, left: 4, right: 4, top: 2}),
						$author$project$Ui$Font$bold,
						$author$project$Ui$borderWith(
						{bottom: 0, left: 1, right: 0, top: 0}),
						$author$project$Ui$spacing(4)
					]),
				$author$project$Ui$html(
					$author$project$Icons$copy(22)))
			]));
};
var $author$project$MyUi$errorBox = F3($author$project$MyUi$errorBox$);
var $author$project$Call$green = $author$project$Ui$rgb$(60, 160, 70);
var $author$project$Call$hasJoined$ = function (roomId, model) {
	return _Utils_eq(
		model.currentRoom,
		$elm$core$Maybe$Just(roomId));
};
var $author$project$Call$hasJoined = F2($author$project$Call$hasJoined$);
var $author$project$Call$SelectedAudioInputDevice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Call$SelectedVideoInputDevice = function (a) {
	return {$: 1, a: a};
};
var $author$project$Call$deviceSelect$ = function (isMobile, labelText, devices, selected, onSelect) {
	return A2(
		$elm$html$Html$select,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$value(
				function () {
					if (!selected.$) {
						var a = selected.a;
						return $author$project$IdString$toString(a);
					} else {
						return '';
					}
				}()),
				$elm$html$Html$Events$onInput(
				function (text) {
					return onSelect(
						$author$project$IdString$fromString(text));
				}),
				A2($elm$html$Html$Attributes$style, 'width', '100%'),
				A2(
				$elm$html$Html$Attributes$style,
				'padding',
				isMobile ? '4px' : '7px 8px'),
				A2(
				$elm$html$Html$Attributes$style,
				'border',
				'1px solid ' + $author$project$MyUi$colorToStyle($author$project$MyUi$inputBorder)),
				A2($elm$html$Html$Attributes$style, 'border-radius', '4px'),
				A2(
				$elm$html$Html$Attributes$style,
				'font-size',
				isMobile ? '14px' : '16px'),
				A2(
				$elm$html$Html$Attributes$style,
				'background-color',
				$author$project$MyUi$colorToStyle($author$project$MyUi$background2)),
				A2(
				$elm$html$Html$Attributes$style,
				'color',
				$author$project$MyUi$colorToStyle($author$project$MyUi$white)),
				A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
				A2($elm$html$Html$Attributes$attribute, 'aria-label', labelText)
			]),
		$elm$core$List$map$(
			function (device) {
				return A2(
					$elm$html$Html$option,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(
							$author$project$IdString$toString(device.deviceId)),
							$elm$html$Html$Attributes$selected(
							_Utils_eq(
								$elm$core$Maybe$Just(device.deviceId),
								selected))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$isEmpty(device.label) ? $author$project$IdString$toString(device.deviceId) : device.label)
						]));
			},
			devices));
};
var $author$project$Call$deviceSelect = F5($author$project$Call$deviceSelect$);
var $author$project$Call$deviceDropdown$ = function (isMobile, labelText, icon, devices, selected, onSelect) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$html(icon),
				$author$project$Ui$html(
				$author$project$Call$deviceSelect$(isMobile, labelText, devices, selected, onSelect))
			]));
};
var $author$project$Call$deviceDropdown = F6($author$project$Call$deviceDropdown$);
var $author$project$Icons$microphone = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor'),
			$elm$svg$Svg$Attributes$width('24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M12 18.75a6 6 0 0 0 6-6v-1.5m-6 7.5a6 6 0 0 1-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 0 1-3-3V4.5a3 3 0 1 1 6 0v8.25a3 3 0 0 1-3 3Z')
				]),
			_List_Nil)
		]));
var $author$project$Call$mediaDeviceSelectors$ = function (isMobile, model) {
	var _v0 = model.userMediaDevices;
	switch (_v0.$) {
		case 0:
			return $author$project$Ui$none;
		case 2:
			var error = _v0.a;
			return $author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$alignBottom,
						$author$project$Ui$Font$color($author$project$MyUi$font1)
					]),
				$author$project$Ui$text('Failed to get media devices: ' + error));
		default:
			var devices = _v0.a;
			var videoDevices = $elm$core$List$filter$(
				function (d) {
					return d.kind === 1;
				},
				devices);
			var audioDevices = $elm$core$List$filter$(
				function (d) {
					return !d.kind;
				},
				devices);
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(8),
						$author$project$Ui$alignBottom,
						$author$project$Ui$widthMax(400),
						$author$project$Ui$attrIf$(isMobile, $author$project$Ui$alignRight)
					]),
				_List_fromArray(
					[
						$author$project$Call$deviceDropdown$(isMobile, 'Microphone', $author$project$Icons$microphone, audioDevices, model.selectedAudioInputDevice, $author$project$Call$SelectedAudioInputDevice),
						$author$project$Call$deviceDropdown$(
						isMobile,
						'Camera',
						$author$project$Icons$camera(24),
						videoDevices,
						model.selectedVideoInputDevice,
						$author$project$Call$SelectedVideoInputDevice)
					]));
	}
};
var $author$project$Call$mediaDeviceSelectors = F2($author$project$Call$mediaDeviceSelectors$);
var $author$project$Call$red = $author$project$MyUi$dangerRed;
var $author$project$Call$PressedToggleScreenShare = {$: 4};
var $author$project$Icons$screenShare = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor'),
			$elm$svg$Svg$Attributes$width('24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M9 17.25v1.007a3 3 0 0 1-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0 1 15 18.257V17.25m6-12V15a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 15V5.25A2.25 2.25 0 0 1 5.25 3h13.5A2.25 2.25 0 0 1 21 5.25Z')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M12 13.5v-6m0 0-2.25 2.25M12 7.5l2.25 2.25')
				]),
			_List_Nil)
		]));
var $author$project$Call$screenShareButton = function (isSharing) {
	return $author$project$MyUi$elButton$(
		$lamdera$program_test$Effect$Browser$Dom$id('guild_voiceChatScreenShare'),
		$author$project$Call$PressedToggleScreenShare,
		_List_fromArray(
			[
				$author$project$Ui$width(
				$author$project$Ui$px(40)),
				$author$project$Ui$height(
				$author$project$Ui$px(40)),
				$author$project$Ui$contentCenterX,
				$author$project$Ui$contentCenterY,
				$author$project$Ui$rounded(20),
				$author$project$MyUi$hoverText(
				isSharing ? 'Stop sharing screen' : 'Share screen'),
				$author$project$Ui$border(1),
				$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
				$author$project$Ui$background(
				isSharing ? $author$project$Call$green : $author$project$Ui$rgb$(42, 50, 78)),
				$author$project$Ui$Font$color($author$project$MyUi$white)
			]),
		$author$project$Ui$html($author$project$Icons$screenShare));
};
var $author$project$Call$viewHeight = function (windowSize) {
	return $elm$core$Basics$round(
		($author$project$Coord$yRaw(windowSize) * 2) / 3);
};
var $author$project$Icons$diagonalSlash = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$width('100%'),
			$elm$svg$Svg$Attributes$height('100%'),
			$elm$svg$Svg$Attributes$preserveAspectRatio('none')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('18'),
					$elm$svg$Svg$Attributes$y1('19'),
					$elm$svg$Svg$Attributes$x2('6'),
					$elm$svg$Svg$Attributes$y2('7'),
					$elm$svg$Svg$Attributes$stroke('rgb(200,60,60)'),
					$elm$svg$Svg$Attributes$strokeWidth('1'),
					$elm$svg$Svg$Attributes$strokeLinecap('round')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('18'),
					$elm$svg$Svg$Attributes$y1('18'),
					$elm$svg$Svg$Attributes$x2('6'),
					$elm$svg$Svg$Attributes$y2('6'),
					$elm$svg$Svg$Attributes$stroke('white'),
					$elm$svg$Svg$Attributes$strokeWidth('1'),
					$elm$svg$Svg$Attributes$strokeLinecap('round')
				]),
			_List_Nil)
		]));
var $author$project$Call$redBorder = $author$project$Ui$rgb$(202, 92, 92);
var $author$project$Call$voiceChatControlButton$ = function (htmlId, title, iconHtml, isEnabled, onPress) {
	return $author$project$MyUi$elButton$(
		$lamdera$program_test$Effect$Browser$Dom$id(htmlId),
		onPress,
		_List_fromArray(
			[
				$author$project$Ui$width(
				$author$project$Ui$px(40)),
				$author$project$Ui$height(
				$author$project$Ui$px(40)),
				$author$project$Ui$contentCenterX,
				$author$project$Ui$contentCenterY,
				$author$project$Ui$rounded(20),
				$author$project$MyUi$hoverText(title),
				$author$project$Ui$border(1),
				$author$project$Ui$borderColor(
				isEnabled ? $author$project$MyUi$inputBorder : $author$project$Call$redBorder),
				$author$project$Ui$background(
				isEnabled ? $author$project$Ui$rgb$(42, 50, 78) : $author$project$Call$red),
				$author$project$Ui$Font$color($author$project$MyUi$white),
				isEnabled ? $author$project$Ui$noAttr : $author$project$Ui$inFront(
				$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$height($author$project$Ui$fill)
						]),
					$author$project$Ui$html($author$project$Icons$diagonalSlash)))
			]),
		iconHtml);
};
var $author$project$Call$voiceChatControlButton = F5($author$project$Call$voiceChatControlButton$);
var $author$project$Call$view$ = function (canShareScreen2, windowSize, roomId, calls, model) {
	var recordingStatus = $lamdera$containers$SeqDict$get$(roomId, calls.recordings);
	var ongoingCall = $lamdera$containers$SeqDict$get$(roomId, calls.voiceChats);
	var muteButton = $author$project$Call$voiceChatControlButton$(
		'guild_voiceChatMute',
		model.remoteCallData.audioInputEnabled ? 'Mute microphone' : 'Unmute microphone',
		$author$project$Ui$html($author$project$Icons$microphone),
		model.remoteCallData.audioInputEnabled,
		$author$project$Call$PressedToggleMute);
	var isMobile = $author$project$MyUi$isMobileAlt(windowSize);
	var hasJoined2 = $author$project$Call$hasJoined$(roomId, calls);
	var cameraButton = $author$project$Call$voiceChatControlButton$(
		'guild_voiceChatPauseVideo',
		model.remoteCallData.videoInputEnabled ? 'Turn off camera' : 'Turn on camera',
		$author$project$Ui$html(
			$author$project$Icons$camera(24)),
		model.remoteCallData.videoInputEnabled,
		$author$project$Call$PressedTogglePauseVideo);
	var callButton = function (text) {
		return $author$project$MyUi$rowButton$(
			hasJoined2 ? $lamdera$program_test$Effect$Browser$Dom$id('guild_leaveVoiceChat') : $lamdera$program_test$Effect$Browser$Dom$id('guild_startVoiceChat'),
			hasJoined2 ? $author$project$Call$PressedLeaveCall : $author$project$Call$PressedJoinCall(roomId),
			_List_fromArray(
				[
					$author$project$Ui$spacing(8),
					$author$project$Ui$background(
					hasJoined2 ? $author$project$Call$red : $author$project$Call$green),
					$author$project$Ui$rounded(99),
					$author$project$Ui$height($author$project$Ui$fill),
					$author$project$Ui$paddingWith(
					{bottom: 0, left: 12, right: 16, top: 0})
				]),
			_List_fromArray(
				[
					$author$project$Ui$html($author$project$Icons$phone),
					$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$move(
							{x: 0, y: 1, z: 0})
						]),
					$author$project$Ui$text(text))
				]));
	};
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$height(
				$author$project$Ui$px(
					$author$project$Call$viewHeight(windowSize))),
				$author$project$Ui$borderWith(
				{bottom: 1, left: 0, right: 0, top: 0}),
				$author$project$Ui$borderColor($author$project$MyUi$border2),
				$author$project$Ui$background($author$project$MyUi$tabBackground),
				$author$project$MyUi$noShrinking,
				$author$project$Ui$inFront(
				$author$project$Ui$column$(
					_List_fromArray(
						[$author$project$Ui$alignBottom]),
					_List_fromArray(
						[
							function () {
							var _v0 = model.startConnectionError;
							if (!_v0.$) {
								var error = _v0.a;
								return $author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$paddingXY$(16, 0)
										]),
									$author$project$MyUi$errorBox$(
										$lamdera$program_test$Effect$Browser$Dom$id('voiceChat_errorBox'),
										$author$project$Call$PressedCopyError,
										error));
							} else {
								return $author$project$Ui$none;
							}
						}(),
							hasJoined2 ? $author$project$Ui$row$(
							_List_fromArray(
								[
									$author$project$Ui$spacing(8),
									isMobile ? $author$project$Ui$paddingXY$(8, 0) : $author$project$Ui$paddingXY$(16, 8),
									$author$project$Ui$widthMax(380)
								]),
							_List_fromArray(
								[
									muteButton,
									cameraButton,
									canShareScreen2 ? $author$project$Call$screenShareButton(model.remoteCallData.screenShareEnabled) : $author$project$Ui$none,
									$author$project$Call$deviceSettingsButton(model.showDeviceSettings),
									$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$alignRight,
											$author$project$Ui$width($author$project$Ui$shrink),
											$author$project$Ui$height($author$project$Ui$fill)
										]),
									callButton(
										function () {
											if (ongoingCall.$ === 1) {
												return 'End\u00A0Call';
											} else {
												return isMobile ? 'Leave' : 'Leave\u00A0Call';
											}
										}()))
								])) : A2(
							isMobile ? $author$project$Ui$column : $author$project$Ui$row,
							_List_fromArray(
								[
									$author$project$Ui$contentBottom,
									isMobile ? $author$project$Ui$paddingXY$(8, 0) : $author$project$Ui$paddingXY$(16, 8),
									$author$project$Ui$spacing(8)
								]),
							_List_fromArray(
								[
									$author$project$Call$mediaDeviceSelectors$(isMobile, model),
									$author$project$Ui$row$(
									_List_fromArray(
										[
											$author$project$Ui$spacing(8),
											$author$project$Ui$width($author$project$Ui$shrink)
										]),
									_List_fromArray(
										[
											muteButton,
											cameraButton,
											callButton(
											function () {
												if (ongoingCall.$ === 1) {
													return 'Start\u00A0Call';
												} else {
													if (!recordingStatus.$) {
														switch (recordingStatus.a.$) {
															case 2:
																return 'Join\u00A0Recorded\u00A0Call';
															case 0:
																return 'Join\u00A0Call';
															default:
																return 'Join\u00A0Call';
														}
													} else {
														return 'Join\u00A0Call';
													}
												}
											}())
										]))
								]))
						])))
			]),
		$author$project$Ui$none);
};
var $author$project$Call$view = F5($author$project$Call$view$);
var $author$project$ChannelHeader$tabBodyView$ = function (isMobile, local, loggedIn, model) {
	var _v0 = model.route;
	switch (_v0.$) {
		case 3:
			var guildId = _v0.a;
			var channelRoute = _v0.b;
			switch (channelRoute.$) {
				case 0:
					if (!channelRoute.c.$) {
						var channelId = channelRoute.a;
						var tab = channelRoute.c.a;
						switch (tab.$) {
							case 2:
								var _v3 = $author$project$LocalState$getGuildAndChannel$(
									{channelId: channelId, guildId: guildId},
									local);
								if (!_v3.$) {
									var _v4 = _v3.a;
									var channel2 = _v4.b;
									return $elm$core$Maybe$Just(
										$author$project$ChannelHeader$channelDescriptionView$(
											$elm$core$Maybe$Just(channel2.name),
											$author$project$ChannelDescription$toString(channel2.description)));
								} else {
									return $elm$core$Maybe$Nothing;
								}
							case 0:
								return $elm$core$Maybe$Just(
									A2(
										$author$project$Ui$map,
										$author$project$Types$VoiceChatMsg,
										$author$project$Call$view$(
											$author$project$Call$canShareScreen(model.startupData.userAgent),
											model.windowSize,
											$author$project$Call$GuildRoomId(
												{channelId: channelId, guildId: guildId}),
											local.calls,
											loggedIn.voiceChat)));
							case 1:
								var maybeMatchId = tab.a;
								var repliedTo = tab.b;
								var _v5 = $author$project$LocalState$getGuildAndChannel$(
									{channelId: channelId, guildId: guildId},
									local);
								if (!_v5.$) {
									var _v6 = _v5.a;
									var channel2 = _v6.b;
									return $author$project$ChannelHeader$gameTabBody$(
										$author$project$Id$GuildOrDmId_Guild(
											{channelId: channelId, guildId: guildId}),
										maybeMatchId,
										repliedTo,
										local,
										loggedIn,
										channel2.games,
										model);
								} else {
									return $elm$core$Maybe$Nothing;
								}
							default:
								return $elm$core$Maybe$Just(
									$author$project$ChannelHeader$drawingTabView$(isMobile, loggedIn.drawingMode, local));
						}
					} else {
						return $elm$core$Maybe$Nothing;
					}
				case 1:
					return $elm$core$Maybe$Nothing;
				case 2:
					return $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		case 5:
			var dmRoute = _v0.a;
			var _v7 = $author$project$DmChannelId$otherUserId$(local.localUser.session.userId, dmRoute.channelId);
			if (!_v7.$) {
				var otherUserId = _v7.a;
				var _v8 = dmRoute.tab;
				if (!_v8.$) {
					switch (_v8.a.$) {
						case 1:
							var _v9 = _v8.a;
							var maybeMatchId = _v9.a;
							var repliedTo = _v9.b;
							return $author$project$ChannelHeader$gameTabBody$(
								$author$project$Id$GuildOrDmId_Dm(
									{otherUserId: otherUserId}),
								maybeMatchId,
								repliedTo,
								local,
								loggedIn,
								$elm$core$Maybe$withDefault$(
									$author$project$DmChannel$frontendInit,
									$lamdera$containers$SeqDict$get$(otherUserId, local.dmChannels)).games,
								model);
						case 0:
							var _v10 = _v8.a;
							return $elm$core$Maybe$Just(
								A2(
									$author$project$Ui$map,
									$author$project$Types$VoiceChatMsg,
									$author$project$Call$view$(
										$author$project$Call$canShareScreen(model.startupData.userAgent),
										model.windowSize,
										$author$project$Call$DmRoomId(
											{otherUserId: otherUserId}),
										local.calls,
										loggedIn.voiceChat)));
						case 2:
							var _v11 = _v8.a;
							return $elm$core$Maybe$Just(
								$author$project$ChannelHeader$channelDescriptionView$(
									$elm$core$Maybe$Nothing,
									_Utils_eq(otherUserId, local.localUser.session.userId) ? 'A channel where you can write things down you want to remember.' : ('A private channel for just you and ' + $author$project$User$toString$(otherUserId, local.localUser.otherUsers))));
						default:
							var _v12 = _v8.a;
							return $elm$core$Maybe$Just(
								$author$project$ChannelHeader$drawingTabView$(isMobile, loggedIn.drawingMode, local));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 2:
			return $elm$core$Maybe$Nothing;
		case 4:
			var routeData = _v0.a;
			var _v13 = routeData.channelRoute;
			switch (_v13.$) {
				case 0:
					if (!_v13.c.$) {
						var channelId = _v13.a;
						var tab = _v13.c.a;
						switch (tab.$) {
							case 2:
								var _v15 = $author$project$LocalState$getDiscordGuildAndChannel$(routeData.guildId, channelId, local);
								if (!_v15.$) {
									var _v16 = _v15.a;
									var channel2 = _v16.b;
									return $elm$core$Maybe$Just(
										$author$project$ChannelHeader$channelDescriptionView$(
											$elm$core$Maybe$Just(channel2.name),
											$author$project$ChannelDescription$toString(channel2.description)));
								} else {
									return $elm$core$Maybe$Nothing;
								}
							case 0:
								return $elm$core$Maybe$Nothing;
							case 1:
								return $elm$core$Maybe$Nothing;
							default:
								return $elm$core$Maybe$Just(
									$author$project$ChannelHeader$drawingTabView$(isMobile, loggedIn.drawingMode, local));
						}
					} else {
						return $elm$core$Maybe$Nothing;
					}
				case 1:
					return $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		case 6:
			var routeData = _v0.a;
			var _v17 = routeData.tab;
			_v17$2:
			while (true) {
				if (!_v17.$) {
					switch (_v17.a.$) {
						case 2:
							var _v18 = _v17.a;
							return $elm$core$Maybe$Just(
								$author$project$ChannelHeader$channelDescriptionView$(
									$elm$core$Maybe$Nothing,
									function () {
										if ($author$project$ChannelHeader$chattingWithYourself$(
											{channelId: routeData.channelId, currentUserId: routeData.currentDiscordUserId},
											local)) {
											return 'A channel where you can write things down you want to remember.';
										} else {
											var _v19 = $lamdera$containers$SeqDict$get$(routeData.channelId, local.discordDmChannels);
											if (!_v19.$) {
												var channel2 = _v19.a;
												var _v20 = $lamdera$containers$SeqDict$toList(
													$lamdera$containers$SeqDict$remove$(
														routeData.currentDiscordUserId,
														$author$project$NonemptyDict$toSeqDict(channel2.members)));
												if (_v20.b && (!_v20.b.b)) {
													var _v21 = _v20.a;
													var single = _v21.a;
													return 'A Discord DM channel for you and ' + function () {
														var _v22 = $author$project$User$getDiscordUser$(single, local.localUser);
														if (!_v22.$) {
															var user = _v22.a;
															return $author$project$PersonName$toString(user.name);
														} else {
															return $author$project$User$missingName;
														}
													}();
												} else {
													var many = _v20;
													return 'A Discord group channel for ' + ($elm$core$String$join$(
														', ',
														$elm$core$List$map$(
															function (_v23) {
																var userId = _v23.a;
																var _v24 = $author$project$User$getDiscordUser$(userId, local.localUser);
																if (!_v24.$) {
																	var user = _v24.a;
																	return $author$project$PersonName$toString(user.name);
																} else {
																	return $author$project$User$missingName;
																}
															},
															many)) + ' and you.');
												}
											} else {
												return '';
											}
										}
									}()));
						case 3:
							var _v25 = _v17.a;
							return $elm$core$Maybe$Just(
								$author$project$ChannelHeader$drawingTabView$(isMobile, loggedIn.drawingMode, local));
						default:
							break _v17$2;
					}
				} else {
					break _v17$2;
				}
			}
			return $elm$core$Maybe$Nothing;
		case 9:
			return $elm$core$Maybe$Nothing;
		case 10:
			return $elm$core$Maybe$Nothing;
		case 11:
			return $elm$core$Maybe$Nothing;
		case 12:
			return $elm$core$Maybe$Nothing;
		case 13:
			return $elm$core$Maybe$Nothing;
		case 7:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ChannelHeader$tabBodyView = F4($author$project$ChannelHeader$tabBodyView$);
var $author$project$ChannelHeader$discordChannel$ = function (isMobile, name, guildOrDmIdNoThread, local, loggedIn, model) {
	var currentChannelHeaderTab = $author$project$Route$toChannelHeaderTab(model.route);
	return $author$project$ChannelHeader$channelHeader$(
		isMobile,
		function () {
			if (guildOrDmIdNoThread.$ === 1) {
				var data = guildOrDmIdNoThread.a;
				return $author$project$Ui$row$(
					_List_fromArray(
						[
							$author$project$Ui$height($author$project$Ui$fill),
							$author$project$Ui$clipWithEllipsis
						]),
					_List_fromArray(
						[
							$author$project$ChannelHeader$chattingWithYourself$(data, local) ? $author$project$ChannelHeader$privateChatWithYourself$(isMobile, model.route, false, currentChannelHeaderTab, local) : $author$project$ChannelHeader$discordPrivateChatWith$(isMobile, model.route, currentChannelHeaderTab, name)
						]));
			} else {
				return $author$project$Ui$row$(
					_List_fromArray(
						[
							$author$project$Ui$Font$color($author$project$MyUi$font1),
							$author$project$Ui$spacing(2),
							$author$project$Ui$clipWithEllipsis,
							$author$project$Ui$height($author$project$Ui$fill)
						]),
					_List_fromArray(
						[
							$author$project$ChannelHeader$channelHeaderTabRow$(
							isMobile,
							$lamdera$program_test$Effect$Browser$Dom$id('guild_openChannelDescription'),
							$author$project$UserSession$ChannelHeaderTab_ChannelDescription,
							currentChannelHeaderTab,
							false,
							_List_fromArray(
								[
									$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$MyUi$noShrinking,
											$author$project$Ui$width($author$project$Ui$shrink)
										]),
									$author$project$Ui$html($author$project$Icons$hashtag)),
									$author$project$Ui$text(name)
								])),
							$author$project$Ui$row$(
							_List_fromArray(
								[
									$author$project$MyUi$noShrinking,
									$author$project$Ui$width($author$project$Ui$shrink),
									$author$project$Ui$alignRight,
									$author$project$Ui$height($author$project$Ui$fill)
								]),
							_List_fromArray(
								[
									$author$project$ChannelHeader$drawingTab$(isMobile, currentChannelHeaderTab, false),
									$elm$core$Maybe$withDefault$(
									$author$project$Ui$none,
									$author$project$ChannelHeader$channelSettingsTab$(isMobile, model.route))
								]))
						]));
			}
		}(),
		$author$project$ChannelHeader$tabBodyView$(isMobile, local, loggedIn, model));
};
var $author$project$ChannelHeader$discordChannel = F6($author$project$ChannelHeader$discordChannel$);
var $author$project$RichText$escapeDiscordText = function (text) {
	return $elm$core$String$replace$(
		'-',
		'\u005C-',
		$elm$core$String$replace$(
			'#',
			'\u005C#',
			$elm$core$String$replace$(
				'|',
				'\u005C|',
				$elm$core$String$replace$(
					'~',
					'\u005C~',
					$elm$core$String$replace$(
						'@',
						'\u005C@',
						$elm$core$String$replace$(
							'>',
							'\u005C>',
							$elm$core$String$replace$(
								'`',
								'\u005C`',
								$elm$core$String$replace$(
									'*',
									'\u005C*',
									$elm$core$String$replace$(
										'_',
										'\u005C_',
										$elm$core$String$replace$('\u005C', '\u005C\u005C', text))))))))));
};
var $author$project$RichText$toDiscordHelper$ = function (customEmojis2, channels, content) {
	return $elm$core$String$concat(
		$elm$core$List$map$(
			function (item) {
				switch (item.$) {
					case 0:
						var discordUserId = item.a;
						return '<@!' + ($author$project$Discord$idToString(discordUserId) + '>');
					case 1:
						var channelId = item.a;
						var maybeThread = item.b;
						if (!maybeThread.$) {
							var threadId = maybeThread.a;
							var messageId = $lamdera$containers$SeqDict$foldl$(
								F3(
									function (_v3, channel, data) {
										if (data.$ === 1) {
											return $author$project$OneToOne$first$(threadId, channel.linkedMessageIds);
										} else {
											return data;
										}
									}),
								$elm$core$Maybe$Nothing,
								channels);
							if (!messageId.$) {
								var messageId2 = messageId.a;
								return '<#' + ($author$project$Discord$idToString(messageId2) + '>');
							} else {
								return '<#0000000000000000000>';
							}
						} else {
							return '<#' + ($author$project$Discord$idToString(channelId) + '>');
						}
					case 2:
						var _char = item.a;
						var string = item.b;
						return $author$project$RichText$escapeDiscordText(
							A2($elm$core$String$cons, _char, string));
					case 3:
						var nonempty = item.a;
						return '**' + ($author$project$RichText$toDiscordHelper$(
							customEmojis2,
							channels,
							$mgold$elm_nonempty_list$List$Nonempty$toList(nonempty)) + '**');
					case 4:
						var nonempty = item.a;
						var inner = $author$project$RichText$toDiscordHelper$(
							customEmojis2,
							channels,
							$mgold$elm_nonempty_list$List$Nonempty$toList(nonempty));
						return (A2($elm$core$String$startsWith, '*', inner) || A2($elm$core$String$endsWith, '*', inner)) ? ('_' + (inner + '_')) : ('*' + (inner + '*'));
					case 5:
						var nonempty = item.a;
						return '__' + ($author$project$RichText$toDiscordHelper$(
							customEmojis2,
							channels,
							$mgold$elm_nonempty_list$List$Nonempty$toList(nonempty)) + '__');
					case 6:
						var nonempty = item.a;
						return '~~' + ($author$project$RichText$toDiscordHelper$(
							customEmojis2,
							channels,
							$mgold$elm_nonempty_list$List$Nonempty$toList(nonempty)) + '~~');
					case 7:
						var nonempty = item.a;
						return '||' + ($author$project$RichText$toDiscordHelper$(
							customEmojis2,
							channels,
							$mgold$elm_nonempty_list$List$Nonempty$toList(nonempty)) + '||');
					case 8:
						var hasLeadingLineBreak = item.a;
						var list = item.b;
						return function () {
							if (!hasLeadingLineBreak) {
								return '\u000A';
							} else {
								return '';
							}
						}() + ('> ' + $elm$core$String$replace$(
							'\u000A',
							'\u000A> ',
							$author$project$RichText$toDiscordHelper$(customEmojis2, channels, list)));
					case 9:
						var level = item.a;
						var hasLeadingLineBreak = item.b;
						var nonempty = item.c;
						var prefix = _Utils_ap(
							function () {
								if (!hasLeadingLineBreak) {
									return '\u000A';
								} else {
									return '';
								}
							}(),
							$author$project$RichText$headingLevelToMarker(level));
						return _Utils_ap(
							prefix,
							$author$project$RichText$toDiscordHelper$(
								customEmojis2,
								channels,
								$mgold$elm_nonempty_list$List$Nonempty$toList(nonempty)));
					case 10:
						var data = item.a;
						return $elm$url$Url$toString(data);
					case 11:
						var alias = item.a;
						var url = item.b;
						return '[' + ($MartinSStewart$elm_nonempty_string$String$Nonempty$toString(alias) + ('](' + ($elm$url$Url$toString(url) + ')')));
					case 12:
						var _char = item.a;
						var string = item.b;
						return '`' + (A2($elm$core$String$cons, _char, string) + '`');
					case 13:
						var language = item.a;
						var string = item.b;
						return '```' + (function () {
							if (!language.$) {
								var language2 = language.a;
								return $MartinSStewart$elm_nonempty_string$String$Nonempty$toString(language2) + '\u000A';
							} else {
								return '';
							}
						}() + (string + '```'));
					case 14:
						return '';
					case 15:
						var _char = item.a;
						return $author$project$RichText$escapeDiscordText(
							$author$project$RichText$escapedCharToString(_char));
					case 16:
						return '';
					case 17:
						var id = item.a;
						var _v8 = $author$project$OneToOne$first$(id, customEmojis2);
						if (!_v8.$) {
							var discordIdAndName = _v8.a;
							return '<:' + ($author$project$CustomEmoji$emojiNameToString(discordIdAndName.name) + (':' + ($author$project$Discord$idToString(discordIdAndName.id) + '>')));
						} else {
							return '<missing:123123123>';
						}
					case 18:
						var hasLeadingLineBreak = item.a;
						var items = item.b;
						return _Utils_ap(
							function () {
								if (!hasLeadingLineBreak) {
									return '\u000A';
								} else {
									return '';
								}
							}(),
							$elm$core$String$join$(
								'\u000A',
								$elm$core$List$map$(
									function (bulletItem) {
										return '* ' + $author$project$RichText$toDiscordHelper$(customEmojis2, channels, bulletItem);
									},
									$mgold$elm_nonempty_list$List$Nonempty$toList(items))));
					default:
						var time = item.a;
						return $author$project$RichText$timestampToDiscordString(time);
				}
			},
			content));
};
var $author$project$RichText$toDiscordHelper = F3($author$project$RichText$toDiscordHelper$);
var $author$project$RichText$toDiscord$ = function (customEmojis2, channels, content) {
	var text = $author$project$RichText$toDiscordHelper$(
		customEmojis2,
		channels,
		$mgold$elm_nonempty_list$List$Nonempty$toList(content));
	return (_Utils_cmp(
		$elm$core$String$length(text),
		$author$project$RichText$maxLength) > 0) ? $elm$core$Result$Err(
		$author$project$RichText$maxLength - $elm$core$String$length(text)) : $elm$core$Result$Ok(text);
};
var $author$project$RichText$toDiscord = F3($author$project$RichText$toDiscord$);
var $author$project$RichText$discordCharsLeft$ = function (customEmojis2, richText) {
	if (!richText.$) {
		var richText2 = richText.a;
		var _v1 = $author$project$RichText$toDiscord$(customEmojis2, $lamdera$containers$SeqDict$empty, richText2);
		if (!_v1.$) {
			var text = _v1.a;
			return $author$project$RichText$maxLength - $elm$core$String$length(text);
		} else {
			var charsLeft = _v1.a;
			return charsLeft;
		}
	} else {
		return $author$project$RichText$maxLength;
	}
};
var $author$project$RichText$discordCharsLeft = F2($author$project$RichText$discordCharsLeft$);
var $author$project$Types$MessageViewMsg$ = function (a, b, c) {
	return {$: 96, a: a, b: b, c: c};
};
var $author$project$Types$MessageViewMsg = F3($author$project$Types$MessageViewMsg$);
var $author$project$Pages$Guild$NoHighlight = 0;
var $author$project$Pages$Guild$ReplyToHighlight = 1;
var $author$project$Pages$Guild$UrlHighlight = 3;
var $author$project$Pages$Guild$messagePaddingX = 8;
var $author$project$Pages$Guild$conversationWidth = function (model) {
	return ($author$project$MyUi$conversationWidthIgnoreScrollbar$(
		model.windowSize,
		function () {
			var _v0 = $author$project$Route$toShowMembersTab(model.route);
			if (!_v0.a) {
				var _v1 = _v0.a;
				return true;
			} else {
				var _v2 = _v0.a;
				return false;
			}
		}()) - model.startupData.scrollbarWidth) - (($author$project$User$profileImageSize + ($author$project$Pages$Guild$messagePaddingX * 2)) + $author$project$MessageView$profileImagePaddingRight);
};
var $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor = {$: 4};
var $author$project$Pages$Guild$MentionHighlight = 2;
var $author$project$Ui$downloadAs = function (opts) {
	return $author$project$Internal$Model2$link(
		{
			download: $elm$core$Maybe$Just(opts.filename),
			newTab: false,
			url: opts.url
		});
};
var $author$project$Icons$warning = function (width) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$strokeWidth('1.5'),
				$elm$svg$Svg$Attributes$stroke('currentColor'),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromInt(width))
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$d('M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z')
					]),
				_List_Nil)
			]));
};
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $author$project$CallRecording$zipName$ = function (timezone, startedAt) {
	return 'Call recording ' + ($elm$core$String$fromInt(
		$lamdera$program_test$Effect$Time$toYear$(timezone, startedAt)) + ('-' + ($elm$core$String$padLeft$(
		2,
		'0',
		$elm$core$String$fromInt(
			$justinmimbs$date$Date$monthToNumber(
				A2($lamdera$program_test$Effect$Time$toMonth, timezone, startedAt)))) + ('-' + ($elm$core$String$padLeft$(
		2,
		'0',
		$elm$core$String$fromInt(
			$lamdera$program_test$Effect$Time$toDay$(timezone, startedAt))) + (' ' + ($elm$core$String$padLeft$(
		2,
		'0',
		$elm$core$String$fromInt(
			$lamdera$program_test$Effect$Time$toHour$(timezone, startedAt))) + ('-' + ($elm$core$String$padLeft$(
		2,
		'0',
		$elm$core$String$fromInt(
			$lamdera$program_test$Effect$Time$toMinute$(timezone, startedAt))) + '.zip')))))))));
};
var $author$project$CallRecording$zipName = F2($author$project$CallRecording$zipName$);
var $author$project$Pages$Guild$callRecordingsButton$ = function (isMobile, timezone, messageId, maybeRecording, allUsers) {
	if (!maybeRecording.$) {
		var recording = maybeRecording.a;
		var _v1 = recording.zip;
		if (!_v1.$) {
			var zip = _v1.a;
			var notFinished = $elm$core$List$filter$(
				function (userId) {
					return !$lamdera$containers$SeqSet$member$(userId, recording.finishedUploading);
				},
				$author$project$NonemptySet$toList(recording.participants));
			return $author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$id(
						'guild_callRecordings_' + $author$project$Id$toString(messageId)),
						$author$project$Ui$downloadAs(
						{
							filename: $author$project$CallRecording$zipName$(timezone, recording.startedAt),
							url: $author$project$FileStatus$fileUrl$(
								$author$project$FileStatus$contentType('application/zip'),
								zip.fileHash)
						}),
						$author$project$Ui$spacing(8),
						$author$project$Ui$paddingXY$(14, 0),
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$contentCenterY,
						$author$project$Ui$background($author$project$MyUi$background2),
						$author$project$Ui$border(1),
						$author$project$Ui$borderColor($author$project$MyUi$border1),
						$author$project$Ui$rounded(6),
						$author$project$Ui$width($author$project$Ui$shrink),
						$author$project$Ui$Font$color($author$project$MyUi$font3),
						$author$project$MyUi$hover$(
						false,
						_List_fromArray(
							[
								$author$project$Ui$Anim$fontColor($author$project$MyUi$font1)
							]))
					]),
				_List_fromArray(
					[
						$author$project$Ui$html($author$project$Icons$download),
						isMobile ? $author$project$Ui$none : $author$project$Ui$text('Download\u00A0recording'),
						function () {
						if (!notFinished.b) {
							return $author$project$Ui$none;
						} else {
							return $author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$id(
										'guild_callRecordingsMissing_' + $author$project$Id$toString(messageId)),
										$author$project$Ui$width($author$project$Ui$shrink),
										$author$project$Ui$Font$color($author$project$MyUi$errorColor),
										$author$project$MyUi$hoverText(
										'Not everyone\u0027s part is in it yet. Still waiting on ' + ($elm$core$String$join$(
											', ',
											$elm$core$List$map$(
												function (userId) {
													return $author$project$User$toString$(userId, allUsers);
												},
												notFinished)) + '. They need to open at-chat on the device they were in the call with for their part to finish uploading.'))
									]),
								$author$project$Ui$html(
									$author$project$Icons$warning(20)));
						}
					}()
					]));
		} else {
			return $author$project$Ui$none;
		}
	} else {
		return $author$project$Ui$none;
	}
};
var $author$project$Pages$Guild$callRecordingsButton = F5($author$project$Pages$Guild$callRecordingsButton$);
var $author$project$MessageView$MessageViewMsg_PressedCallStartedCard = {$: 17};
var $author$project$MessageView$MessageView_PressedCardAnchor$ = function (a, b) {
	return {$: 22, a: a, b: b};
};
var $author$project$MessageView$MessageView_PressedCardAnchor = F2($author$project$MessageView$MessageView_PressedCardAnchor$);
var $author$project$Ui$Anim$outlineColor = function (clr) {
	return $author$project$Animator$color$('outline-color', clr);
};
var $author$project$Drawing$overlayAttribute$ = function (getColor, drawing) {
	var _v0 = $author$project$Drawing$strokesFor(drawing);
	if (!_v0.b) {
		return $author$project$Ui$none;
	} else {
		var strokes = _v0;
		return $author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$width(
					$author$project$Ui$px(0)),
					$author$project$Ui$height(
					$author$project$Ui$px(0)),
					$author$project$MyUi$htmlStyle$('pointer-events', 'none')
				]),
			$author$project$Ui$html(
				A2(
					$elm$html$Html$div,
					_List_Nil,
					$elm$core$List$map$(
						function (_v1) {
							var createdBy = _v1.a;
							var points = _v1.b;
							return $author$project$Drawing$strokeSvg$(
								1,
								$author$project$UserColor$toStyle(
									getColor(createdBy)),
								points);
						},
						strokes))));
	}
};
var $author$project$Drawing$overlayAttribute = F2($author$project$Drawing$overlayAttribute$);
var $author$project$Drawing$currentTargetFloatWithDefault = function (fieldName) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$at$(
				_List_fromArray(
					['currentTarget', fieldName]),
				$elm$json$Json$Decode$float),
				$elm$json$Json$Decode$succeed(0)
			]));
};
var $author$project$Drawing$decodeTargetHalfSize = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (width, height) {
			return _Utils_Tuple2(width / 2, height / 2);
		}),
	$author$project$Drawing$currentTargetFloatWithDefault('offsetWidth'),
	$author$project$Drawing$currentTargetFloatWithDefault('offsetHeight'));
var $author$project$Drawing$selectingAnchorHighlight$ = function (htmlId, onPress) {
	return _List_fromArray(
		[
			$author$project$MyUi$htmlStyle$('outline-style', 'solid'),
			$author$project$MyUi$htmlStyle$('outline-width', '2px'),
			$author$project$MyUi$htmlStyle$('outline-color', 'rgba(0,0,0,0)'),
			$author$project$Ui$pointer,
			$author$project$Ui$Events$on$(
			'click',
			A3($elm$json$Json$Decode$map2, onPress, $author$project$Drawing$decodeWithTargetScreenPosition, $author$project$Drawing$decodeTargetHalfSize)),
			$author$project$Ui$id(
			$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId))
		]);
};
var $author$project$Drawing$selectingAnchorHighlight = F2($author$project$Drawing$selectingAnchorHighlight$);
var $author$project$Drawing$anchorHighlight$ = function (htmlId, userIdToColor, onPress, isSelectingAnchor, drawings) {
	return _Utils_ap(
		_List_fromArray(
			[
				$author$project$Ui$inFront(
				$author$project$Ui$Lazy$lazy2$($author$project$Drawing$overlayAttribute, userIdToColor, drawings)),
				$author$project$Ui$width($author$project$Ui$shrink),
				$author$project$Ui$Anim$hovered$(
				$author$project$Ui$Anim$ms(10),
				isSelectingAnchor ? _List_fromArray(
					[
						$author$project$Ui$Anim$backgroundColor(
						$author$project$Ui$rgba$(96, 165, 250, 0.3)),
						$author$project$Ui$Anim$outlineColor(
						$author$project$Ui$rgba$(96, 165, 250, 1))
					]) : _List_Nil)
			]),
		isSelectingAnchor ? $author$project$Drawing$selectingAnchorHighlight$(htmlId, onPress) : _List_Nil);
};
var $author$project$Drawing$anchorHighlight = F5($author$project$Drawing$anchorHighlight$);
var $author$project$Pages$Guild$eventDurationText$ = function (start, end) {
	if (!end.$) {
		var endedAt2 = end.a;
		return ', lasted ' + $author$project$MyUi$timeElapsed$(start, endedAt2);
	} else {
		return '';
	}
};
var $author$project$Pages$Guild$eventDurationText = F2($author$project$Pages$Guild$eventDurationText$);
var $elm$svg$Svg$Attributes$fontFamily = _VirtualDom_attribute('font-family');
var $elm$svg$Svg$Attributes$fontSize = _VirtualDom_attribute('font-size');
var $elm$svg$Svg$Attributes$fontWeight = _VirtualDom_attribute('font-weight');
var $elm$svg$Svg$Attributes$rx = _VirtualDom_attribute('rx');
var $elm$svg$Svg$text = $elm$virtual_dom$VirtualDom$text;
var $elm$svg$Svg$text_ = $elm$svg$Svg$trustedNode('text');
var $author$project$Icons$recording = function (height) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('0 0 52 24'),
				$elm$svg$Svg$Attributes$height(
				$elm$core$String$fromInt(height)),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromInt(((height * 52) / 24) | 0))
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$rect,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$x('1'),
						$elm$svg$Svg$Attributes$y('1'),
						$elm$svg$Svg$Attributes$width('50'),
						$elm$svg$Svg$Attributes$height('22'),
						$elm$svg$Svg$Attributes$rx('5'),
						$elm$svg$Svg$Attributes$fill('red')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$circle,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$cx('12'),
						$elm$svg$Svg$Attributes$cy('12'),
						$elm$svg$Svg$Attributes$r('5'),
						$elm$svg$Svg$Attributes$fill('white')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$text_,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$x('21'),
						$elm$svg$Svg$Attributes$y('16.5'),
						$elm$svg$Svg$Attributes$fontSize('12.5'),
						$elm$svg$Svg$Attributes$fontWeight('bold'),
						$elm$svg$Svg$Attributes$fontFamily('sans-serif'),
						$elm$svg$Svg$Attributes$fill('white')
					]),
				_List_fromArray(
					[
						$elm$svg$Svg$text('REC')
					]))
			]));
};
var $author$project$Pages$Guild$startedACallText = 'started a call';
var $author$project$Pages$Guild$callStartedCard$ = function (userIdToColor, isSelectingAnchor, messageId, drawings, userId, startedAt, endedAt, recording, allUsers) {
	return $author$project$Ui$el$(
		_List_Nil,
		$author$project$Ui$el$(
			A2(
				$elm$core$List$cons,
				$author$project$Ui$rounded(6),
				$author$project$Drawing$anchorHighlight$(
					$lamdera$program_test$Effect$Browser$Dom$id(
						'guild_eventCard_' + $author$project$Id$toString(messageId)),
					userIdToColor,
					$author$project$MessageView$MessageView_PressedCardAnchor,
					isSelectingAnchor,
					drawings)),
			$author$project$MyUi$rowButton$(
				$lamdera$program_test$Effect$Browser$Dom$id('guild_callStartedCard'),
				$author$project$MessageView$MessageViewMsg_PressedCallStartedCard,
				_List_fromArray(
					[
						$author$project$Ui$spacing(12),
						$author$project$Ui$paddingXY$(16, 6),
						$author$project$Ui$background($author$project$MyUi$background2),
						$author$project$Ui$border(1),
						$author$project$Ui$borderColor($author$project$MyUi$border1),
						$author$project$Ui$rounded(6),
						$author$project$Ui$width($author$project$Ui$shrink),
						$author$project$Ui$Font$color($author$project$MyUi$font3),
						$author$project$MyUi$hover$(
						false,
						_List_fromArray(
							[
								$author$project$Ui$Anim$fontColor($author$project$MyUi$font1)
							])),
						isSelectingAnchor ? $author$project$MyUi$noPointerEvents : $author$project$Ui$noAttr
					]),
				_List_fromArray(
					[
						$author$project$Ui$html($author$project$Icons$phone),
						$author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$spacing(2),
								$author$project$Ui$width($author$project$Ui$shrink)
							]),
						_List_fromArray(
							[
								$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$Font$bold,
										$author$project$Ui$Font$color($author$project$MyUi$font1),
										$author$project$Ui$widthMax(200),
										$author$project$Ui$clipWithEllipsis
									]),
								$author$project$Ui$text(
									$author$project$User$toString$(userId, allUsers))),
								$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$Font$size(13)
									]),
								$author$project$Ui$text(
									_Utils_ap(
										$author$project$Pages$Guild$startedACallText,
										$author$project$Pages$Guild$eventDurationText$(startedAt, endedAt))))
							])),
						function () {
						var _v0 = _Utils_Tuple2(endedAt, recording);
						if (_v0.a.$ === 1) {
							if (!_v0.b.$) {
								var _v1 = _v0.a;
								return $author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$id(
											'guild_callRecorded_' + $author$project$Id$toString(messageId)),
											$author$project$Ui$width($author$project$Ui$shrink),
											$author$project$MyUi$hoverText('This call is being recorded')
										]),
									$author$project$Ui$html(
										$author$project$Icons$recording(22)));
							} else {
								var _v2 = _v0.a;
								var _v3 = _v0.b;
								return $author$project$Ui$none;
							}
						} else {
							if (!_v0.b.$) {
								return $author$project$Ui$none;
							} else {
								var _v4 = _v0.b;
								return $author$project$Ui$none;
							}
						}
					}()
					]))));
};
var $author$project$Pages$Guild$callStartedCard = F9($author$project$Pages$Guild$callStartedCard$);
var $author$project$MessageView$MessageView_PressedTimestamp$ = function (a, b) {
	return {$: 20, a: a, b: b};
};
var $author$project$MessageView$MessageView_PressedTimestamp = F2($author$project$MessageView$MessageView_PressedTimestamp$);
var $author$project$Pages$Guild$messageTimestamp$ = function (userIdToColor, drawings, isSelectingAnchor, messageId, createdAt, timezone) {
	return $author$project$Ui$el$(
		_Utils_ap(
			_List_fromArray(
				[
					$author$project$Ui$Font$size(14),
					$author$project$Ui$Font$color($author$project$MyUi$font3),
					$author$project$Ui$paddingXY$(4, 0),
					$author$project$Ui$rounded(4)
				]),
			$author$project$Drawing$anchorHighlight$(
				$lamdera$program_test$Effect$Browser$Dom$id(
					'guild_messageTimestamp_' + $author$project$Id$toString(messageId)),
				userIdToColor,
				$author$project$MessageView$MessageView_PressedTimestamp,
				isSelectingAnchor,
				drawings)),
		$author$project$Ui$el$(
			_List_fromArray(
				[$author$project$MyUi$noPointerEvents]),
			$author$project$Ui$text(
				$author$project$MyUi$timestamp$(createdAt, timezone))));
};
var $author$project$Pages$Guild$messageTimestamp = F6($author$project$Pages$Guild$messageTimestamp$);
var $author$project$Pages$Guild$deletedMessageContent$ = function (messageId, isSelectingAnchor, createdAt, timezone) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$paddingWith(
				{bottom: 0, left: 4, right: 0, top: 4})
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Font$color($author$project$MyUi$font3),
						$author$project$Ui$Font$italic,
						$author$project$Ui$Font$size(14)
					]),
				$author$project$Ui$text($author$project$LocalState$messageDeleted)),
				$author$project$Pages$Guild$messageTimestamp$(
				function (_v0) {
					return $author$project$RichText$defaultColor;
				},
				$author$project$Drawing$emptyDrawing,
				isSelectingAnchor,
				messageId,
				createdAt,
				timezone)
			]));
};
var $author$project$Pages$Guild$deletedMessageContent = F4($author$project$Pages$Guild$deletedMessageContent$);
var $author$project$Pages$Guild$discordQuickReactionCustomEmojis = $lamdera$containers$SeqSet$empty;
var $author$project$User$discordUserColor$ = function (localUser, userId) {
	var _v0 = $author$project$User$getDiscordUser$(userId, localUser);
	if (!_v0.$) {
		var user = _v0.a;
		return user.color;
	} else {
		return $author$project$RichText$defaultColor;
	}
};
var $author$project$User$discordUserColor = F2($author$project$User$discordUserColor$);
var $author$project$MessageView$MessageView_NoOp = {$: 15};
var $author$project$MessageView$MessageView_PressedCopyCode = function (a) {
	return {$: 27, a: a};
};
var $author$project$MessageView$MessageView_PressedDiscordChannelMention$ = function (a, b) {
	return {$: 26, a: a, b: b};
};
var $author$project$MessageView$MessageView_PressedDiscordChannelMention = F2($author$project$MessageView$MessageView_PressedDiscordChannelMention$);
var $author$project$MessageView$MessageView_PressedDiscordUserIconButton = function (a) {
	return {$: 24, a: a};
};
var $author$project$MessageView$MessageView_PressedImage = function (a) {
	return {$: 2, a: a};
};
var $author$project$MessageView$MessageView_PressedNonWhitelistLink = function (a) {
	return {$: 1, a: a};
};
var $author$project$MessageView$MessageView_PressedSpoiler = function (a) {
	return {$: 0, a: a};
};
var $author$project$MessageView$MessageView_PressedUserIconAnchor$ = function (a, b) {
	return {$: 19, a: a, b: b};
};
var $author$project$MessageView$MessageView_PressedUserIconAnchor = F2($author$project$MessageView$MessageView_PressedUserIconAnchor$);
var $author$project$Ui$paddingLeft = function (x) {
	return $author$project$Internal$Model2$style$(
		'padding-left',
		$elm$core$String$fromInt(x) + 'px');
};
var $author$project$Pages$Guild$indentPastProfileImage$ = function (maybeRepliedTo2, header) {
	if (!maybeRepliedTo2.$) {
		return $author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$paddingLeft($author$project$User$profileImageSize + $author$project$MessageView$profileImagePaddingRight)
				]),
			header);
	} else {
		return header;
	}
};
var $author$project$Pages$Guild$indentPastProfileImage = F2($author$project$Pages$Guild$indentPastProfileImage$);
var $author$project$Pages$Guild$isHoveredToAnimationMode = function (isHovered) {
	switch (isHovered.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 1;
		case 3:
			return 1;
		case 4:
			return 1;
		default:
			return 0;
	}
};
var $author$project$Pages$Guild$messageIdView = function (_v0) {
	return $author$project$Ui$none;
};
var $author$project$Pages$Guild$profileImageButtonId = function (messageId) {
	return $lamdera$program_test$Effect$Browser$Dom$id(
		'guild_profileImage_' + $author$project$Id$toString(messageId));
};
var $author$project$Pages$Guild$openDmButton$ = function (messageId, onPress) {
	return _List_fromArray(
		[
			$author$project$Ui$pointer,
			$author$project$Ui$id(
			$lamdera$program_test$Effect$Browser$Dom$idToString(
				$author$project$Pages$Guild$profileImageButtonId(messageId))),
			$author$project$Ui$Events$onClick(onPress),
			$author$project$MyUi$hoverText('Go to direct messages')
		]);
};
var $author$project$Pages$Guild$openDmButton = F2($author$project$Pages$Guild$openDmButton$);
var $author$project$Drawing$profileImageAnchorId = function (messageId) {
	return $lamdera$program_test$Effect$Browser$Dom$id(
		'drawAnchorProfile_' + $author$project$Id$toString(messageId));
};
var $author$project$MessageView$MessageView_PressedReplyLink = {$: 9};
var $author$project$Pages$Guild$callStarted$ = function (userId, startedAt, endedAt, allUsers) {
	return $author$project$Ui$Prose$paragraph$(
		_List_fromArray(
			[
				$author$project$Ui$paddingXY$(0, 4)
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[$author$project$Ui$Font$bold]),
				$author$project$Ui$text(
					$author$project$User$toString$(userId, allUsers))),
				$author$project$Ui$el$(
				_List_Nil,
				$author$project$Ui$text(
					' started a call' + $author$project$Pages$Guild$eventDurationText$(startedAt, endedAt)))
			]));
};
var $author$project$Pages$Guild$callStarted = F4($author$project$Pages$Guild$callStarted$);
var $author$project$Pages$Guild$startedGameText = function (game) {
	switch (game) {
		case 0:
			return 'started a Go match';
		case 1:
			return 'started a Word Spelling game';
		default:
			return 'started a Sheep Game';
	}
};
var $author$project$Pages$Guild$gameStartedContent$ = function (userId, game, allUsers) {
	return $author$project$Ui$Prose$paragraph$(
		_List_fromArray(
			[
				$author$project$Ui$paddingXY$(0, 4)
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[$author$project$Ui$Font$bold]),
				$author$project$Ui$text(
					$author$project$User$toString$(userId, allUsers))),
				$author$project$Ui$el$(
				_List_Nil,
				$author$project$Ui$text(
					' ' + $author$project$Pages$Guild$startedGameText(game)))
			]));
};
var $author$project$Pages$Guild$gameStartedContent = F3($author$project$Pages$Guild$gameStartedContent$);
var $author$project$Pages$Guild$replyToHeaderAboveMessageAttributes = function (isMobile) {
	return _List_fromArray(
		[
			$author$project$Ui$Font$size(14),
			$author$project$Ui$paddingWith(
			{bottom: 0, left: 0, right: 8, top: 2}),
			$author$project$Ui$Font$color($author$project$MyUi$font3),
			$author$project$MyUi$hover$(
			isMobile,
			_List_fromArray(
				[
					$author$project$Ui$Anim$fontColor($author$project$MyUi$font1)
				]))
		]);
};
var $author$project$Pages$Guild$replyToHeaderAboveMessageIcon = $author$project$Ui$el$(
	_List_fromArray(
		[
			$author$project$Ui$width($author$project$Ui$shrink),
			$author$project$Ui$move(
			{x: 0, y: 3, z: 0}),
			$author$project$MyUi$noShrinking
		]),
	$author$project$Ui$html(
		$author$project$Icons$reply(18)));
var $author$project$Pages$Guild$replyToHeaderAboveMessageHelper$ = function (isMobile, messageId, content) {
	return $author$project$MyUi$rowButton$(
		$lamdera$program_test$Effect$Browser$Dom$id(
			'guild_replyLink_' + $author$project$Id$toString(messageId)),
		$author$project$MessageView$MessageView_PressedReplyLink,
		$author$project$Pages$Guild$replyToHeaderAboveMessageAttributes(isMobile),
		_List_fromArray(
			[$author$project$Pages$Guild$replyToHeaderAboveMessageIcon, content]));
};
var $author$project$Pages$Guild$replyToHeaderAboveMessageHelper = F3($author$project$Pages$Guild$replyToHeaderAboveMessageHelper$);
var $author$project$RichText$preview$ = function (noOp, onPressLink, onPressChannelMention, config, nonempty) {
	return function (_v2) {
		var a = _v2.c;
		return a;
	}(
		$author$project$RichText$viewHelper$(
			false,
			$author$project$RichText$NoLargeContent,
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			onPressLink,
			0,
			{bold: false, italic: false, spoiler: false, strikethrough: false, underline: false},
			{
				animationMode: 0,
				attachedFiles: config.attachedFiles,
				channels: config.channels,
				customEmojis: config.customEmojis,
				devicePixelRatio: 1,
				domainWhitelist: config.domainWhitelist,
				drawingUserColor: function (_v0) {
					return $author$project$RichText$defaultColor;
				},
				drawings: $lamdera$containers$SeqDict$empty,
				embedDrawings: $lamdera$containers$SeqDict$empty,
				emojiData: config.emojiData,
				isHovered: false,
				isSelectingAnchor: false,
				noOp: noOp,
				onPressChannelMention: onPressChannelMention,
				onPressCopyCode: function (_v1) {
					return noOp;
				},
				revealedSpoilers: config.revealedSpoilers,
				stickers: $lamdera$containers$SeqDict$empty,
				time: config.time,
				timezone: config.timezone,
				users: config.users
			},
			$elm$core$Array$empty,
			0,
			nonempty));
};
var $author$project$RichText$preview = F5($author$project$RichText$preview$);
var $author$project$Pages$Guild$userTextMessagePreview$ = function (timezone, time, emojiData, customEmojis, allUsers, channels, revealedSpoilers, contentAndEmbeds, createdBy) {
	return $author$project$Ui$html(
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
					A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
					A2($elm$html$Html$Attributes$style, 'text-overflow', 'ellipsis')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$Attributes$style,
							'color',
							$author$project$MyUi$colorToStyle($author$project$MyUi$dimFont)),
							A2($elm$html$Html$Attributes$style, 'padding', '0 6px 0 2px')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$User$toString$(createdBy, allUsers))
						])),
				$author$project$RichText$preview$(
					$author$project$MessageView$MessageView_NoOp,
					function (_v0) {
						return $author$project$MessageView$MessageView_NoOp;
					},
					F2(
						function (_v1, _v2) {
							return $author$project$MessageView$MessageView_NoOp;
						}),
					{attachedFiles: contentAndEmbeds.attachedFiles, channels: channels, customEmojis: customEmojis, domainWhitelist: $lamdera$containers$SeqSet$empty, emojiData: emojiData, revealedSpoilers: revealedSpoilers, time: time, timezone: timezone, users: allUsers},
					contentAndEmbeds.content))));
};
var $author$project$Pages$Guild$userTextMessagePreview = F9($author$project$Pages$Guild$userTextMessagePreview$);
var $author$project$Pages$Guild$replyToHeaderAboveMessage_userTextMessage$ = function (isMobile, repliedToIndex, timezone, time, emojiData, customEmojis, allUsers, channels, revealedSpoilers, contentAndEmbeds, createdBy) {
	return $author$project$Pages$Guild$replyToHeaderAboveMessageHelper$(
		isMobile,
		repliedToIndex,
		$author$project$Pages$Guild$userTextMessagePreview$(
			timezone,
			time,
			emojiData,
			customEmojis,
			allUsers,
			channels,
			function () {
				var _v0 = $lamdera$containers$SeqDict$get$(repliedToIndex, revealedSpoilers);
				if (!_v0.$) {
					var set = _v0.a;
					return $author$project$NonemptySet$toSeqSet(set);
				} else {
					return $lamdera$containers$SeqSet$empty;
				}
			}(),
			contentAndEmbeds,
			createdBy));
};
var $author$project$Pages$Guild$replyToHeaderAboveMessage_userTextMessage = function (isMobile) {
	return function (repliedToIndex) {
		return function (timezone) {
			return function (time) {
				return function (emojiData) {
					return function (customEmojis) {
						return function (allUsers) {
							return function (channels) {
								return function (revealedSpoilers) {
									return function (contentAndEmbeds) {
										return function (createdBy) {
											return $author$project$Pages$Guild$replyToHeaderAboveMessage_userTextMessage$(isMobile, repliedToIndex, timezone, time, emojiData, customEmojis, allUsers, channels, revealedSpoilers, contentAndEmbeds, createdBy);
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Guild$userJoinedContent$ = function (userId, allUsers) {
	return $author$project$Ui$Prose$paragraph$(
		_List_fromArray(
			[
				$author$project$Ui$paddingXY$(0, 4)
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[$author$project$Ui$Font$bold]),
				$author$project$Ui$text(
					$author$project$User$toString$(userId, allUsers))),
				$author$project$Ui$el$(
				_List_Nil,
				$author$project$Ui$text(' joined!'))
			]));
};
var $author$project$Pages$Guild$userJoinedContent = F2($author$project$Pages$Guild$userJoinedContent$);
var $author$project$Pages$Guild$replyToHeaderAboveMessage$ = function (isMobile, timezone, time, maybeRepliedTo2, revealedSpoilers, emojiData, customEmojis, decrypted, allUsers, channels) {
	if (!maybeRepliedTo2.$) {
		if (!maybeRepliedTo2.a.$) {
			switch (maybeRepliedTo2.a.b.$) {
				case 0:
					var _v1 = maybeRepliedTo2.a;
					var repliedToIndex = _v1.a;
					var repliedToData = _v1.b.a;
					return $author$project$Pages$Guild$replyToHeaderAboveMessage_userTextMessage$(isMobile, repliedToIndex, timezone, time, emojiData, customEmojis, allUsers, channels, revealedSpoilers, repliedToData.content, repliedToData.createdBy);
				case 1:
					var _v2 = maybeRepliedTo2.a;
					var repliedToIndex = _v2.a;
					var repliedToData = _v2.b.a;
					var _v3 = $lamdera$containers$SeqDict$get$(
						$author$project$Encryption$hash(repliedToData.content),
						decrypted);
					if (!_v3.$) {
						var result = _v3.a;
						return $author$project$Pages$Guild$replyToHeaderAboveMessage_userTextMessage$(
							isMobile,
							repliedToIndex,
							timezone,
							time,
							emojiData,
							customEmojis,
							allUsers,
							channels,
							revealedSpoilers,
							$elm$core$Result$withDefault$(
								{attachedFiles: $lamdera$containers$SeqDict$empty, content: $author$project$RichText$failedToDecryptMessage, embeds: $elm$core$Array$empty},
								result),
							repliedToData.createdBy);
					} else {
						return $author$project$Ui$none;
					}
				case 2:
					var _v4 = maybeRepliedTo2.a;
					var repliedToIndex = _v4.a;
					var _v5 = _v4.b;
					var userId = _v5.b;
					return $author$project$Pages$Guild$replyToHeaderAboveMessageHelper$(
						isMobile,
						repliedToIndex,
						$author$project$Pages$Guild$userJoinedContent$(userId, allUsers));
				case 3:
					var _v6 = maybeRepliedTo2.a;
					var repliedToIndex = _v6.a;
					return $author$project$Pages$Guild$replyToHeaderAboveMessageHelper$(
						isMobile,
						repliedToIndex,
						$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$Font$italic,
									$author$project$Ui$Font$color($author$project$MyUi$font3)
								]),
							$author$project$Ui$text($author$project$LocalState$messageDeleted)));
				case 4:
					var _v7 = maybeRepliedTo2.a;
					var repliedToIndex = _v7.a;
					var startedBy = _v7.b.a.startedBy;
					var endedAt = _v7.b.a.endedAt;
					var startedAt = _v7.b.a.startedAt;
					return $author$project$Pages$Guild$replyToHeaderAboveMessageHelper$(
						isMobile,
						repliedToIndex,
						$author$project$Pages$Guild$callStarted$(startedBy, startedAt, endedAt, allUsers));
				default:
					var _v8 = maybeRepliedTo2.a;
					var repliedToIndex = _v8.a;
					var gameType = _v8.b.a.gameType;
					var startedBy = _v8.b.a.startedBy;
					return $author$project$Pages$Guild$replyToHeaderAboveMessageHelper$(
						isMobile,
						repliedToIndex,
						$author$project$Pages$Guild$gameStartedContent$(startedBy, gameType, allUsers));
			}
		} else {
			var _v9 = maybeRepliedTo2.a;
			var matchId = _v9.a;
			var preview = _v9.c;
			return $author$project$MyUi$rowButton$(
				$lamdera$program_test$Effect$Browser$Dom$id(
					'guild_gameReplyLink_' + $author$project$Id$toString(matchId)),
				$author$project$MessageView$MessageView_PressedReplyLink,
				$author$project$Pages$Guild$replyToHeaderAboveMessageAttributes(isMobile),
				_List_fromArray(
					[
						$author$project$Pages$Guild$replyToHeaderAboveMessageIcon,
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$width(
								$author$project$Ui$px(4))
							]),
						$author$project$Ui$none),
						preview
					]));
		}
	} else {
		return $author$project$Ui$none;
	}
};
var $author$project$Pages$Guild$replyToHeaderAboveMessage = function (isMobile) {
	return function (timezone) {
		return function (time) {
			return function (maybeRepliedTo2) {
				return function (revealedSpoilers) {
					return function (emojiData) {
						return function (customEmojis) {
							return function (decrypted) {
								return function (allUsers) {
									return function (channels) {
										return $author$project$Pages$Guild$replyToHeaderAboveMessage$(isMobile, timezone, time, maybeRepliedTo2, revealedSpoilers, emojiData, customEmojis, decrypted, allUsers, channels);
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Guild$discordUserTextMessageContent$ = function (time, spoilerHtmlId, containerWidth, isMobile, maybeRepliedTo2, localUser, revealedSpoilers, allUsers, channels, isHovered, messageId, _v0, message2) {
	var attachedFiles = _v0.attachedFiles;
	var embeds = _v0.embeds;
	var content = _v0.content;
	var drawings = $elm$core$Maybe$withDefault$($author$project$Message$noDrawings, message2.drawings);
	return $author$project$Ui$column$(
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Pages$Guild$indentPastProfileImage$(
				maybeRepliedTo2,
				$author$project$Pages$Guild$replyToHeaderAboveMessage$(isMobile, localUser.timezone, time, maybeRepliedTo2, revealedSpoilers, localUser.emojiData, localUser.customEmojis, $lamdera$containers$SeqDict$empty, allUsers, channels)),
				$author$project$Ui$row$(
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$paddingWith(
								{bottom: 0, left: 0, right: $author$project$MessageView$profileImagePaddingRight, top: 2}),
								$author$project$Ui$width($author$project$Ui$shrink),
								$author$project$Ui$alignTop
							]),
						$author$project$Ui$el$(
							_Utils_ap(
								$author$project$Drawing$anchorHighlight$(
									$author$project$Drawing$profileImageAnchorId(messageId),
									$author$project$User$discordUserColor(localUser),
									$author$project$MessageView$MessageView_PressedUserIconAnchor,
									_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
									drawings.userIconDrawings),
								_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor) ? _List_fromArray(
									[
										$author$project$Ui$rounded($author$project$User$profileImageRounding)
									]) : $author$project$Pages$Guild$openDmButton$(
									messageId,
									$author$project$MessageView$MessageView_PressedDiscordUserIconButton(message2.createdBy))),
							function () {
								var _v1 = $lamdera$containers$SeqDict$get$(message2.createdBy, allUsers);
								if (!_v1.$) {
									var user = _v1.a;
									return $author$project$User$discordProfileImage$(message2.createdBy, user.icon);
								} else {
									return $author$project$User$discordProfileImage$(message2.createdBy, $elm$core$Maybe$Nothing);
								}
							}())),
						$author$project$Ui$column$(
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$row$(
								_List_Nil,
								_List_fromArray(
									[
										$author$project$User$toColoredString$(message2.createdBy, allUsers),
										$author$project$Pages$Guild$messageTimestamp$(
										$author$project$User$discordUserColor(localUser),
										drawings.timestampDrawings,
										_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
										messageId,
										message2.createdAt,
										localUser.timezone),
										$author$project$Pages$Guild$messageIdView(messageId)
									])),
								$author$project$Ui$html(
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'white-space', 'pre-wrap')
										]),
									_Utils_ap(
										$author$project$RichText$view$(
											$lamdera$program_test$Effect$Browser$Dom$id(
												$lamdera$program_test$Effect$Browser$Dom$idToString(spoilerHtmlId) + ('_' + $author$project$Id$toString(messageId))),
											containerWidth,
											$author$project$MessageView$MessageView_PressedNonWhitelistLink,
											$author$project$MessageView$MessageView_PressedSpoiler,
											$author$project$MessageView$MessageView_PressedImage,
											{
												animationMode: $author$project$Pages$Guild$isHoveredToAnimationMode(isHovered),
												attachedFiles: attachedFiles,
												channels: channels,
												customEmojis: localUser.customEmojis,
												devicePixelRatio: localUser.devicePixelRatio,
												domainWhitelist: localUser.user.domainWhitelist,
												drawingUserColor: $author$project$User$discordUserColor(localUser),
												drawings: drawings.imageAttachmentDrawings,
												embedDrawings: drawings.embedDrawings,
												emojiData: localUser.emojiData,
												isHovered: function () {
													switch (isHovered.$) {
														case 0:
															return false;
														case 1:
															return true;
														case 2:
															return true;
														case 3:
															return true;
														case 4:
															return false;
														default:
															return false;
													}
												}(),
												isSelectingAnchor: _Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
												noOp: $author$project$MessageView$MessageView_NoOp,
												onPressChannelMention: $author$project$MessageView$MessageView_PressedDiscordChannelMention,
												onPressCopyCode: $author$project$MessageView$MessageView_PressedCopyCode,
												revealedSpoilers: function () {
													var _v3 = $lamdera$containers$SeqDict$get$(messageId, revealedSpoilers);
													if (!_v3.$) {
														var nonempty = _v3.a;
														return $author$project$NonemptySet$toSeqSet(nonempty);
													} else {
														return $lamdera$containers$SeqSet$empty;
													}
												}(),
												stickers: localUser.stickers,
												time: time,
												timezone: localUser.timezone,
												users: allUsers
											},
											function () {
												var _v4 = localUser.user.embedVisibility;
												if (!_v4) {
													return embeds;
												} else {
													return $elm$core$Array$empty;
												}
											}(),
											content),
										function () {
											var _v5 = message2.editedAt;
											if (!_v5.$) {
												var editedAt = _v5.a;
												return _List_fromArray(
													[
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$Attributes$style,
																'color',
																$author$project$MyUi$colorToStyle($author$project$MyUi$dimFont)),
																A2($elm$html$Html$Attributes$style, 'font-size', '12px'),
																$elm$html$Html$Attributes$title(
																$author$project$MyUi$datestamp$(localUser.timezone, editedAt))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(' (edited)')
															]))
													]);
											} else {
												return _List_Nil;
											}
										}())))
							]))
					]))
			]));
};
var $author$project$Pages$Guild$discordUserTextMessageContent = function (time) {
	return function (spoilerHtmlId) {
		return function (containerWidth) {
			return function (isMobile) {
				return function (maybeRepliedTo2) {
					return function (localUser) {
						return function (revealedSpoilers) {
							return function (allUsers) {
								return function (channels) {
									return function (isHovered) {
										return function (messageId) {
											return function (_v0) {
												return function (message2) {
													return $author$project$Pages$Guild$discordUserTextMessageContent$(time, spoilerHtmlId, containerWidth, isMobile, maybeRepliedTo2, localUser, revealedSpoilers, allUsers, channels, isHovered, messageId, _v0, message2);
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$MessageView$MessageViewMsg_PressedGameStartedCard = {$: 18};
var $author$project$Pages$Guild$eventCard$ = function (userIdToColor, isSelectingAnchor, messageId, drawings, htmlId, onPress, icon, userName, action) {
	return $author$project$Ui$el$(
		_List_Nil,
		$author$project$Ui$el$(
			A2(
				$elm$core$List$cons,
				$author$project$Ui$rounded(6),
				$author$project$Drawing$anchorHighlight$(
					$lamdera$program_test$Effect$Browser$Dom$id(
						'guild_eventCard_' + $author$project$Id$toString(messageId)),
					userIdToColor,
					$author$project$MessageView$MessageView_PressedCardAnchor,
					isSelectingAnchor,
					drawings)),
			$author$project$MyUi$rowButton$(
				htmlId,
				onPress,
				_List_fromArray(
					[
						$author$project$Ui$spacing(12),
						$author$project$Ui$paddingXY$(16, 6),
						$author$project$Ui$background($author$project$MyUi$background2),
						$author$project$Ui$border(1),
						$author$project$Ui$borderColor($author$project$MyUi$border1),
						$author$project$Ui$rounded(6),
						$author$project$Ui$width($author$project$Ui$shrink),
						$author$project$Ui$Font$color($author$project$MyUi$font3),
						$author$project$MyUi$hover$(
						false,
						_List_fromArray(
							[
								$author$project$Ui$Anim$fontColor($author$project$MyUi$font1)
							])),
						isSelectingAnchor ? $author$project$MyUi$noPointerEvents : $author$project$Ui$noAttr
					]),
				_List_fromArray(
					[
						icon,
						$author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$spacing(2),
								$author$project$Ui$width($author$project$Ui$shrink)
							]),
						_List_fromArray(
							[
								$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$Font$bold,
										$author$project$Ui$Font$color($author$project$MyUi$font1),
										$author$project$Ui$widthMax(200),
										$author$project$Ui$clipWithEllipsis
									]),
								$author$project$Ui$text(userName)),
								$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$Font$size(13)
									]),
								$author$project$Ui$text(action))
							]))
					]))));
};
var $author$project$Pages$Guild$eventCard = F9($author$project$Pages$Guild$eventCard$);
var $author$project$Pages$Guild$goMatchStartedCard$ = function (userIdToColor, isSelectingAnchor, drawings, messageId, userId, allUsers, game) {
	return $author$project$Pages$Guild$eventCard$(
		userIdToColor,
		isSelectingAnchor,
		messageId,
		drawings,
		$lamdera$program_test$Effect$Browser$Dom$id(
			'guild_gameStartedCard_' + $author$project$Id$toString(messageId)),
		$author$project$MessageView$MessageViewMsg_PressedGameStartedCard,
		$author$project$Ui$html($author$project$Icons$go),
		$author$project$User$toString$(userId, allUsers),
		$author$project$Pages$Guild$startedGameText(game));
};
var $author$project$Pages$Guild$goMatchStartedCard = F7($author$project$Pages$Guild$goMatchStartedCard$);
var $author$project$MessageView$MessageView_TouchStart$ = function (a, b, c, d, e, f) {
	return {$: 5, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$MessageView$MessageView_TouchStart = F6($author$project$MessageView$MessageView_TouchStart$);
var $author$project$Pages$Guild$ContextMenuTarget$ = function (imageUrl, linkUrl, reactionIndex) {
	return {imageUrl: imageUrl, linkUrl: linkUrl, reactionIndex: reactionIndex};
};
var $author$project$Pages$Guild$ContextMenuTarget = F3($author$project$Pages$Guild$ContextMenuTarget$);
var $author$project$Pages$Guild$emptyContextMenuTarget = {imageUrl: $elm$core$Maybe$Nothing, linkUrl: $elm$core$Maybe$Nothing, reactionIndex: $elm$core$Maybe$Nothing};
var $author$project$Pages$Guild$orElseMaybe$ = function (first, second) {
	if (!first.$) {
		return first;
	} else {
		return second;
	}
};
var $author$project$Pages$Guild$orElseMaybe = F2($author$project$Pages$Guild$orElseMaybe$);
var $author$project$Pages$Guild$decodeContextMenuTarget = function (depth) {
	return A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (here, parent) {
				return {
					imageUrl: $author$project$Pages$Guild$orElseMaybe$(here.imageUrl, parent.imageUrl),
					linkUrl: $author$project$Pages$Guild$orElseMaybe$(here.linkUrl, parent.linkUrl),
					reactionIndex: $author$project$Pages$Guild$orElseMaybe$(here.reactionIndex, parent.reactionIndex)
				};
			}),
		A4(
			$elm$json$Json$Decode$map3,
			$author$project$Pages$Guild$ContextMenuTarget,
			$elm$json$Json$Decode$maybe(
				$elm$json$Json$Decode$at$(
					_List_fromArray(
						['dataset', 'imageUrl']),
					$elm$json$Json$Decode$string)),
			$elm$json$Json$Decode$maybe(
				$elm$json$Json$Decode$at$(
					_List_fromArray(
						['dataset', 'linkUrl']),
					$elm$json$Json$Decode$string)),
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$andThen($elm$core$String$toInt),
				$elm$json$Json$Decode$maybe(
					$elm$json$Json$Decode$at$(
						_List_fromArray(
							['dataset', 'reactionIndex']),
						$elm$json$Json$Decode$string)))),
		(depth <= 0) ? $elm$json$Json$Decode$succeed($author$project$Pages$Guild$emptyContextMenuTarget) : $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$field,
					'parentElement',
					$elm$json$Json$Decode$lazy(
						function (_v0) {
							return $author$project$Pages$Guild$decodeContextMenuTarget(depth - 1);
						})),
					$elm$json$Json$Decode$succeed($author$project$Pages$Guild$emptyContextMenuTarget)
				])));
};
var $author$project$Pages$Guild$decodeEventTarget = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$field,
			'target',
			$author$project$Pages$Guild$decodeContextMenuTarget(20)),
			$elm$json$Json$Decode$succeed($author$project$Pages$Guild$emptyContextMenuTarget)
		]));
var $author$project$MessageView$MessageView_AltPressedMessage$ = function (a, b, c, d, e) {
	return {$: 6, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$MessageView$MessageView_AltPressedMessage = F5($author$project$MessageView$MessageView_AltPressedMessage$);
var $author$project$Pages$Guild$decodeMessageContextMenu = function (isThreadStarter) {
	return A4(
		$elm$json$Json$Decode$map3,
		F3(
			function (x, y, target) {
				return _Utils_Tuple2(
					$author$project$MessageView$MessageView_AltPressedMessage$(
						isThreadStarter,
						target.imageUrl,
						target.linkUrl,
						target.reactionIndex,
						$author$project$Coord$xy$(
							$elm$core$Basics$round(x),
							$elm$core$Basics$round(y))),
					true);
			}),
		A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float),
		A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float),
		$author$project$Pages$Guild$decodeEventTarget);
};
var $author$project$Touch$decodeIsTextInput = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$map,
			function (tagName) {
				return (tagName === 'TEXTAREA') || (tagName === 'INPUT');
			},
			A2($elm$json$Json$Decode$field, 'tagName', $elm$json$Json$Decode$string)),
			$elm$json$Json$Decode$succeed(false)
		]));
var $author$project$Touch$decodeQuantity = A2($elm$json$Json$Decode$map, $ianmackenzie$elm_units$Quantity$unsafe, $elm$json$Json$Decode$float);
var $author$project$Touch$decodeTouch = A5(
	$elm$json$Json$Decode$map4,
	F4(
		function (identifier, clientX, clientY, targetIsTextInput) {
			return _Utils_Tuple2(
				identifier,
				{
					client: $author$project$Point2d$xy$(clientX, clientY),
					targetIsTextInput: targetIsTextInput
				});
		}),
	A2($elm$json$Json$Decode$field, 'identifier', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'clientX', $author$project$Touch$decodeQuantity),
	A2($elm$json$Json$Decode$field, 'clientY', $author$project$Touch$decodeQuantity),
	A2($elm$json$Json$Decode$field, 'target', $author$project$Touch$decodeIsTextInput));
var $author$project$Touch$dynamicListOf = function (itemDecoder) {
	var decodeOne = function (n) {
		return A2(
			$elm$json$Json$Decode$field,
			$elm$core$String$fromInt(n),
			itemDecoder);
	};
	var decodeN = function (n) {
		return $elm$core$List$foldr$(
			$elm$json$Json$Decode$map2($elm$core$List$cons),
			$elm$json$Json$Decode$succeed(_List_Nil),
			$elm$core$List$map$(
				decodeOne,
				$elm$core$List$range$(0, n - 1)));
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		decodeN,
		A2($elm$json$Json$Decode$field, 'length', $elm$json$Json$Decode$int));
};
var $author$project$Touch$decodeTouchEvent = function (msg) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			var list = _v0.a;
			var time = _v0.b;
			var _v1 = $author$project$NonemptyDict$fromList(list);
			if (!_v1.$) {
				var nonempty = _v1.a;
				return $elm$json$Json$Decode$succeed(
					A2(
						msg,
						$ianmackenzie$elm_units$Duration$milliseconds(time),
						nonempty));
			} else {
				return $elm$json$Json$Decode$fail('');
			}
		},
		A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Tuple$pair,
			A2(
				$elm$json$Json$Decode$field,
				'touches',
				$author$project$Touch$dynamicListOf($author$project$Touch$decodeTouch)),
			A2($elm$json$Json$Decode$field, 'timeStamp', $elm$json$Json$Decode$float)));
};
var $author$project$Pages$Guild$highlightLayer = function (highlight) {
	switch (highlight) {
		case 0:
			return $author$project$Ui$behindContent($author$project$Ui$none);
		case 1:
			return $author$project$MyUi$highlightFadeOut($author$project$MyUi$replyToColor);
		case 2:
			return $author$project$MyUi$highlightFadeOut($author$project$MyUi$mentionColor);
		default:
			return $author$project$MyUi$highlightFadeOut($author$project$MyUi$replyToColor);
	}
};
var $author$project$MessageView$MessageViewMsg_PressedEditMessage = {$: 11};
var $author$project$MessageView$MessageViewMsg_PressedShowFullMenu$ = function (a, b) {
	return {$: 13, a: a, b: b};
};
var $author$project$MessageView$MessageViewMsg_PressedShowFullMenu = F2($author$project$MessageView$MessageViewMsg_PressedShowFullMenu$);
var $author$project$Icons$dotDotDot = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M6.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM18.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z')
				]),
			_List_Nil)
		]));
var $author$project$MessageView$miniButtonWithPosition$ = function (htmlId, onPress, svg) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$width(
				$author$project$Ui$px($author$project$MessageView$miniButtonSize)),
				$author$project$Ui$height(
				$author$project$Ui$px($author$project$MessageView$miniButtonSize)),
				$author$project$Ui$contentCenterX,
				$author$project$Ui$contentCenterY,
				$author$project$Ui$htmlAttribute(
				A2($elm$html$Html$Attributes$attribute, 'role', 'button')),
				$author$project$Ui$id(
				$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId)),
				$author$project$Ui$Events$stopPropagationOn$(
				'click',
				A3(
					$elm$json$Json$Decode$map2,
					F2(
						function (x, y) {
							return _Utils_Tuple2(
								onPress(
									$author$project$Coord$xy$(
										$elm$core$Basics$round(x),
										$elm$core$Basics$round(y))),
								true);
						}),
					A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float),
					A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float))),
				$author$project$Ui$pointer,
				$author$project$MyUi$hover$(
				false,
				_List_fromArray(
					[
						$author$project$Ui$Anim$backgroundColor($author$project$MyUi$hoverHighlight)
					]))
			]),
		$author$project$Ui$html(svg));
};
var $author$project$MessageView$miniButtonWithPosition = F3($author$project$MessageView$miniButtonWithPosition$);
var $author$project$MessageView$miniViewContainer$ = function (xOffset, buttons) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$alignRight,
				$author$project$Ui$background($author$project$MyUi$background1),
				$author$project$Ui$rounded(4),
				$author$project$Ui$borderColor($author$project$MyUi$border1),
				$author$project$Ui$border(1),
				$author$project$Ui$move(
				{x: xOffset, y: -16, z: 0}),
				$author$project$Ui$height(
				$author$project$Ui$px($author$project$MessageView$miniButtonSize)),
				$author$project$Ui$clip,
				$author$project$MyUi$noShrinking
			]),
		buttons);
};
var $author$project$MessageView$miniViewContainer = F2($author$project$MessageView$miniViewContainer$);
var $author$project$MessageView$miniView$ = function (user, isThreadStarter, canEdit, availableCustomEmojis, emojiData, customEmojis) {
	return $author$project$MessageView$miniViewContainer$(
		-48,
		_Utils_ap(
			$author$project$MessageView$recentEmojiButtons$(user, availableCustomEmojis, emojiData, customEmojis),
			_List_fromArray(
				[
					$author$project$MessageView$miniButton$(
					$lamdera$program_test$Effect$Browser$Dom$id('miniView_showReactionEmojiSelector'),
					$author$project$MessageView$MessageViewMsg_PressedShowReactionEmojiSelector,
					'Add reaction',
					$author$project$Icons$smile),
					canEdit ? $author$project$MessageView$miniButton$(
					$lamdera$program_test$Effect$Browser$Dom$id('miniView_editMessage'),
					$author$project$MessageView$MessageViewMsg_PressedEditMessage,
					'Edit message',
					$author$project$Icons$pencil) : $author$project$Ui$none,
					isThreadStarter ? $author$project$Ui$none : $author$project$MessageView$miniButton$(
					$lamdera$program_test$Effect$Browser$Dom$id('miniView_reply'),
					$author$project$MessageView$MessageViewMsg_PressedReply,
					'Reply',
					$author$project$Icons$reply(24)),
					$author$project$MessageView$miniButtonWithPosition$(
					$lamdera$program_test$Effect$Browser$Dom$id('miniView_showFullMenu'),
					$author$project$MessageView$MessageViewMsg_PressedShowFullMenu(isThreadStarter),
					$author$project$Icons$dotDotDot)
				])));
};
var $author$project$MessageView$miniView = F6($author$project$MessageView$miniView$);
var $author$project$Ui$Events$preventDefaultOn$ = function (name, decoder) {
	return $author$project$Internal$Model2$attribute(
		$elm$html$Html$Events$preventDefaultOn$(name, decoder));
};
var $author$project$Ui$Events$preventDefaultOn = F2($author$project$Ui$Events$preventDefaultOn$);
var $author$project$MessageView$MessageView_PressedViewThreadLink = {$: 14};
var $elm$html$Html$b = _VirtualDom_node('b');
var $elm$html$Html$i = _VirtualDom_node('i');
var $author$project$Pages$Guild$messagePreviewTimestamp$ = function (createdAt, timezone) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'font-size', '14px'),
				A2(
				$elm$html$Html$Attributes$style,
				'color',
				$author$project$MyUi$colorToStyle($author$project$MyUi$font3))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$MyUi$timestamp$(createdAt, timezone))
			]));
};
var $author$project$Pages$Guild$messagePreviewTimestamp = F2($author$project$Pages$Guild$messagePreviewTimestamp$);
var $author$project$Pages$Guild$previewThreadLastMessage_userTextMessage$ = function (time, timezone, emojiData, customEmojis, allUsers, channels, contentAndEmbeds, createdBy) {
	return A2(
		$elm$core$List$cons,
		A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$Attributes$style,
					'color',
					$author$project$MyUi$colorToStyle($author$project$MyUi$font3)),
					A2($elm$html$Html$Attributes$style, 'padding', '0 6px 0 2px')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$User$toString$(createdBy, allUsers))
				])),
		$author$project$RichText$preview$(
			$author$project$MessageView$MessageView_NoOp,
			function (_v0) {
				return $author$project$MessageView$MessageView_NoOp;
			},
			F2(
				function (_v1, _v2) {
					return $author$project$MessageView$MessageView_NoOp;
				}),
			{attachedFiles: contentAndEmbeds.attachedFiles, channels: channels, customEmojis: customEmojis, domainWhitelist: $lamdera$containers$SeqSet$empty, emojiData: emojiData, revealedSpoilers: $lamdera$containers$SeqSet$empty, time: time, timezone: timezone, users: allUsers},
			contentAndEmbeds.content));
};
var $author$project$Pages$Guild$previewThreadLastMessage_userTextMessage = F8($author$project$Pages$Guild$previewThreadLastMessage_userTextMessage$);
var $author$project$Pages$Guild$previewThreadLastMessage$ = function (timezone, time, emojiData, customEmojis, allUsers, channels, decrypted, messageId, thread) {
	var lastMessage = $author$project$MessageArray$last(thread.messages);
	return $author$project$Ui$html(
		A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
					A2($elm$html$Html$Attributes$style, 'text-overflow', 'ellipsis'),
					A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
					A2(
					$elm$html$Html$Attributes$style,
					'background-color',
					$author$project$MyUi$colorToStyle($author$project$MyUi$background1)),
					A2(
					$elm$html$Html$Attributes$style,
					'border',
					'1px solid ' + $author$project$MyUi$colorToStyle($author$project$MyUi$border1)),
					A2($elm$html$Html$Attributes$style, 'padding', '4px 8px 4px 8px'),
					A2($elm$html$Html$Attributes$style, 'width', 'fit-content'),
					A2($elm$html$Html$Attributes$style, 'max-width', 'calc(min(100% - 16px, 800px))'),
					A2($elm$html$Html$Attributes$style, 'min-width', '250px'),
					A2($elm$html$Html$Attributes$style, 'margin', '0'),
					A2($elm$html$Html$Attributes$style, 'color', 'inherit'),
					A2($elm$html$Html$Attributes$style, 'font-size', 'inherit'),
					A2($elm$html$Html$Attributes$style, 'text-align', 'left'),
					$elm$html$Html$Attributes$id(
					'guild_threadStarterIndicator_' + $author$project$Id$toString(messageId)),
					$elm$html$Html$Events$onClick($author$project$MessageView$MessageView_PressedViewThreadLink),
					A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
					A2($elm$html$Html$Attributes$style, 'position', 'relative')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'align-content', 'center'),
							A2(
							$elm$html$Html$Attributes$style,
							'color',
							$author$project$MyUi$colorToStyle($author$project$MyUi$font3))
						]),
					_List_fromArray(
						[
							$author$project$Icons$hashtag,
							function () {
							var _v0 = $author$project$MessageArray$length(thread.messages);
							if (_v0 === 1) {
								return $elm$html$Html$text('1 message');
							} else {
								var count = _v0;
								return $elm$html$Html$text(
									$elm$core$String$fromInt(count) + ' messages');
							}
						}(),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'flex-grow', '1')
								]),
							_List_Nil),
							function () {
							if (!lastMessage.$) {
								var message = lastMessage.a;
								return $author$project$Pages$Guild$messagePreviewTimestamp$(
									$author$project$Message$createdAt(message),
									timezone);
							} else {
								return $elm$html$Html$text('');
							}
						}()
						])),
				function () {
					if (!lastMessage.$) {
						var last = lastMessage.a;
						switch (last.$) {
							case 0:
								var data = last.a;
								return $author$project$Pages$Guild$previewThreadLastMessage_userTextMessage$(time, timezone, emojiData, customEmojis, allUsers, channels, data.content, data.createdBy);
							case 1:
								var data = last.a;
								var _v4 = $lamdera$containers$SeqDict$get$(
									$author$project$Encryption$hash(data.content),
									decrypted);
								if (!_v4.$) {
									var result = _v4.a;
									return $author$project$Pages$Guild$previewThreadLastMessage_userTextMessage$(
										time,
										timezone,
										emojiData,
										customEmojis,
										allUsers,
										channels,
										$elm$core$Result$withDefault$(
											{attachedFiles: $lamdera$containers$SeqDict$empty, content: $author$project$RichText$failedToDecryptMessage, embeds: $elm$core$Array$empty},
											result),
										data.createdBy);
								} else {
									return _List_Nil;
								}
							case 2:
								var userId = last.b;
								return _List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$b,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$User$toString$(userId, allUsers))
													])),
												$elm$html$Html$text(' joined!')
											]))
									]);
							case 3:
								return _List_fromArray(
									[
										A2(
										$elm$html$Html$i,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$Attributes$style,
												'color',
												$author$project$MyUi$colorToStyle($author$project$MyUi$font3))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text($author$project$LocalState$messageDeleted)
											]))
									]);
							case 4:
								var startedBy = last.a.startedBy;
								var endedAt = last.a.endedAt;
								return _List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$b,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$User$toString$(startedBy, allUsers))
													])),
												function () {
												if (!endedAt.$) {
													return $elm$html$Html$text('\u0027s call ended');
												} else {
													return $elm$html$Html$text(' started a call');
												}
											}()
											]))
									]);
							default:
								var gameType = last.a.gameType;
								var startedBy = last.a.startedBy;
								return _List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$b,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$User$toString$(startedBy, allUsers))
													])),
												$elm$html$Html$text(
												' ' + $author$project$Pages$Guild$startedGameText(gameType))
											]))
									]);
						}
					} else {
						return _List_Nil;
					}
				}())));
};
var $author$project$Pages$Guild$previewThreadLastMessage = F9($author$project$Pages$Guild$previewThreadLastMessage$);
var $author$project$MessageView$ReactionLongPressed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Guild$reactionsHover = function (isHovered) {
	switch (isHovered.$) {
		case 1:
			return $author$project$MessageView$ReactionsHovered;
		case 0:
			return $author$project$MessageView$ReactionsNotHovered;
		case 2:
			return $author$project$MessageView$ReactionsNotHovered;
		case 3:
			return $author$project$MessageView$ReactionsNotHovered;
		case 4:
			return $author$project$MessageView$ReactionsNotHovered;
		default:
			var reactionIndex = isHovered.a;
			return $author$project$MessageView$ReactionLongPressed(reactionIndex);
	}
};
var $author$project$MessageView$reactionsMiniView$ = function (user, availableCustomEmojis, emojiData, customEmojis) {
	return $author$project$MessageView$miniViewContainer$(
		-48,
		_Utils_ap(
			$author$project$MessageView$recentEmojiButtons$(user, availableCustomEmojis, emojiData, customEmojis),
			_List_fromArray(
				[
					$author$project$MessageView$miniButton$(
					$lamdera$program_test$Effect$Browser$Dom$id('miniView_showReactionEmojiSelector'),
					$author$project$MessageView$MessageViewMsg_PressedShowReactionEmojiSelector,
					'Add reaction',
					$author$project$Icons$smile)
				])));
};
var $author$project$MessageView$reactionsMiniView = F4($author$project$MessageView$reactionsMiniView$);
var $author$project$Pages$Guild$messageContainer$ = function (containerWidth, isThreadStarter, timezone, currentTime, availableCustomEmojis, customEmojis, emojiData, allUsers, channels, highlight, messageIndex, canEdit, currentUserId, currentUser, reactions, maybeThread, decrypted, isHovered, messageContent) {
	var maybeReactions = $author$project$MessageView$reactionEmojiView$(
		emojiData,
		$author$project$Pages$Guild$reactionsHover(isHovered),
		currentUserId,
		customEmojis,
		allUsers,
		$author$project$Pages$Guild$isHoveredToAnimationMode(isHovered),
		containerWidth,
		reactions);
	return $author$project$Ui$column$(
		_Utils_ap(
			_List_fromArray(
				[
					$author$project$Ui$Font$color($author$project$MyUi$font1),
					$author$project$Ui$Events$onMouseEnter($author$project$MessageView$MessageView_MouseEnteredMessage),
					$author$project$Ui$Events$onMouseLeave($author$project$MessageView$MessageView_MouseExitedMessage),
					$author$project$Ui$Events$on$(
					'touchstart',
					A3(
						$elm$json$Json$Decode$map2,
						F2(
							function (toMsg, target) {
								return A3(toMsg, target.imageUrl, target.linkUrl, target.reactionIndex);
							}),
						$author$project$Touch$decodeTouchEvent(
							F5(
								function (time, touches, imageUrl, linkUrl, reactionIndex) {
									return $author$project$MessageView$MessageView_TouchStart$(time, isThreadStarter, imageUrl, linkUrl, reactionIndex, touches);
								})),
						$author$project$Pages$Guild$decodeEventTarget)),
					$author$project$Ui$Events$preventDefaultOn$(
					'contextmenu',
					$author$project$Pages$Guild$decodeMessageContextMenu(isThreadStarter)),
					$author$project$Ui$paddingWith(
					{
						bottom: _Utils_eq(maybeReactions, $elm$core$Maybe$Nothing) ? 8 : 4,
						left: $author$project$Pages$Guild$messagePaddingX,
						right: $author$project$Pages$Guild$messagePaddingX,
						top: 4
					}),
					$author$project$Ui$spacing(4),
					$author$project$Ui$id(
					$lamdera$program_test$Effect$Browser$Dom$idToString(
						$author$project$Pages$Guild$channelMessageHtmlId(messageIndex)))
				]),
			_Utils_ap(
				function () {
					switch (isHovered.$) {
						case 0:
							return _List_fromArray(
								[
									$author$project$Ui$behindContent($author$project$Ui$none)
								]);
						case 1:
							return _List_fromArray(
								[
									$author$project$MyUi$hoverHighlightLayer,
									$author$project$Ui$inFront(
									$author$project$MessageView$miniView$(currentUser, isThreadStarter, canEdit, availableCustomEmojis, emojiData, customEmojis))
								]);
						case 2:
							return _List_fromArray(
								[$author$project$MyUi$hoverHighlightLayer]);
						case 3:
							return _List_fromArray(
								[
									$author$project$MyUi$hoverHighlightLayer,
									$author$project$Ui$inFront(
									$author$project$MessageView$reactionsMiniView$(currentUser, availableCustomEmojis, emojiData, customEmojis))
								]);
						case 4:
							return _List_fromArray(
								[
									$author$project$Ui$behindContent($author$project$Ui$none)
								]);
						default:
							return _List_fromArray(
								[
									$author$project$Ui$behindContent($author$project$Ui$none)
								]);
					}
				}(),
				_List_fromArray(
					[
						$author$project$Pages$Guild$highlightLayer(highlight)
					]))),
		A2(
			$elm$core$List$cons,
			messageContent,
			_Utils_ap(
				$elmcraft$core_extra$Maybe$Extra$toList(maybeReactions),
				function () {
					if (!maybeThread.$) {
						var thread = maybeThread.a;
						return _List_fromArray(
							[
								$author$project$Pages$Guild$previewThreadLastMessage$(timezone, currentTime, emojiData, customEmojis, allUsers, channels, decrypted, messageIndex, thread)
							]);
					} else {
						return _List_Nil;
					}
				}())));
};
var $author$project$Pages$Guild$messageContainer = function (containerWidth) {
	return function (isThreadStarter) {
		return function (timezone) {
			return function (currentTime) {
				return function (availableCustomEmojis) {
					return function (customEmojis) {
						return function (emojiData) {
							return function (allUsers) {
								return function (channels) {
									return function (highlight) {
										return function (messageIndex) {
											return function (canEdit) {
												return function (currentUserId) {
													return function (currentUser) {
														return function (reactions) {
															return function (maybeThread) {
																return function (decrypted) {
																	return function (isHovered) {
																		return function (messageContent) {
																			return $author$project$Pages$Guild$messageContainer$(containerWidth, isThreadStarter, timezone, currentTime, availableCustomEmojis, customEmojis, emojiData, allUsers, channels, highlight, messageIndex, canEdit, currentUserId, currentUser, reactions, maybeThread, decrypted, isHovered, messageContent);
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Guild$discordMessageView$ = function (time, isMobile, containerWidth, isThreadStarter, revealedSpoilers, highlight, isHovered, currentUserId, allUsers, channels, localUser, maybeRepliedTo2, maybeThreadStarter, messageId, message) {
	switch (message.$) {
		case 0:
			var data = message.a;
			return $author$project$Pages$Guild$messageContainer$(
				containerWidth,
				isThreadStarter,
				localUser.timezone,
				time,
				$author$project$Pages$Guild$discordQuickReactionCustomEmojis,
				localUser.customEmojis,
				localUser.emojiData,
				allUsers,
				channels,
				function () {
					if (!highlight) {
						return $lamdera$containers$SeqSet$member$(
							currentUserId,
							$author$project$RichText$mentionsUser(data.content.content)) ? 2 : highlight;
					} else {
						return highlight;
					}
				}(),
				messageId,
				_Utils_eq(currentUserId, data.createdBy),
				currentUserId,
				localUser.user,
				data.reactions,
				maybeThreadStarter,
				$lamdera$containers$SeqDict$empty,
				isHovered,
				$author$project$Pages$Guild$discordUserTextMessageContent$(
					time,
					$lamdera$program_test$Effect$Browser$Dom$id('spoiler'),
					containerWidth,
					isMobile,
					maybeRepliedTo2,
					localUser,
					revealedSpoilers,
					allUsers,
					channels,
					isHovered,
					messageId,
					data.content,
					data));
		case 1:
			var data = message.a;
			return $author$project$Pages$Guild$messageContainer$(
				containerWidth,
				isThreadStarter,
				localUser.timezone,
				time,
				$author$project$Pages$Guild$discordQuickReactionCustomEmojis,
				localUser.customEmojis,
				localUser.emojiData,
				allUsers,
				channels,
				highlight,
				messageId,
				_Utils_eq(currentUserId, data.createdBy),
				currentUserId,
				localUser.user,
				data.reactions,
				maybeThreadStarter,
				$lamdera$containers$SeqDict$empty,
				isHovered,
				$author$project$Pages$Guild$discordUserTextMessageContent$(
					time,
					$lamdera$program_test$Effect$Browser$Dom$id('spoiler'),
					containerWidth,
					isMobile,
					maybeRepliedTo2,
					localUser,
					revealedSpoilers,
					allUsers,
					channels,
					isHovered,
					messageId,
					{attachedFiles: $lamdera$containers$SeqDict$empty, content: $author$project$RichText$failedToDecryptMessage, embeds: $elm$core$Array$empty},
					data));
		case 2:
			var joinedAt = message.a;
			var userId = message.b;
			var reactions = message.c;
			var drawings = message.d;
			return $author$project$Pages$Guild$messageContainer$(
				containerWidth,
				isThreadStarter,
				localUser.timezone,
				time,
				$author$project$Pages$Guild$discordQuickReactionCustomEmojis,
				localUser.customEmojis,
				localUser.emojiData,
				allUsers,
				channels,
				highlight,
				messageId,
				false,
				currentUserId,
				localUser.user,
				reactions,
				maybeThreadStarter,
				$lamdera$containers$SeqDict$empty,
				isHovered,
				$author$project$Ui$row$(
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Guild$userJoinedContent$(userId, allUsers),
							$author$project$Pages$Guild$messageTimestamp$(
							$author$project$User$discordUserColor(localUser),
							drawings,
							_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
							messageId,
							joinedAt,
							localUser.timezone),
							$author$project$Pages$Guild$messageIdView(messageId)
						])));
		case 3:
			var createdAt = message.a;
			return $author$project$Pages$Guild$messageContainer$(
				containerWidth,
				isThreadStarter,
				localUser.timezone,
				time,
				$author$project$Pages$Guild$discordQuickReactionCustomEmojis,
				localUser.customEmojis,
				localUser.emojiData,
				allUsers,
				channels,
				highlight,
				messageId,
				false,
				currentUserId,
				localUser.user,
				$lamdera$containers$SeqDict$empty,
				maybeThreadStarter,
				$lamdera$containers$SeqDict$empty,
				isHovered,
				$author$project$Pages$Guild$deletedMessageContent$(
					messageId,
					_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
					createdAt,
					localUser.timezone));
		case 4:
			var callStartedData = message.a;
			return $author$project$Pages$Guild$messageContainer$(
				containerWidth,
				isThreadStarter,
				localUser.timezone,
				time,
				$author$project$Pages$Guild$discordQuickReactionCustomEmojis,
				localUser.customEmojis,
				localUser.emojiData,
				allUsers,
				channels,
				highlight,
				messageId,
				false,
				currentUserId,
				localUser.user,
				callStartedData.reactions,
				maybeThreadStarter,
				$lamdera$containers$SeqDict$empty,
				isHovered,
				$author$project$Ui$row$(
					_List_fromArray(
						[$author$project$Ui$contentTop]),
					_List_fromArray(
						[
							$author$project$Ui$row$(
							_List_fromArray(
								[
									$author$project$Ui$spacing(8),
									$author$project$Ui$contentCenterY
								]),
							_List_fromArray(
								[
									$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$width($author$project$Ui$shrink)
										]),
									$author$project$Pages$Guild$callStartedCard$(
										$author$project$User$discordUserColor(localUser),
										_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
										messageId,
										callStartedData.cardDrawings,
										callStartedData.startedBy,
										callStartedData.startedAt,
										callStartedData.endedAt,
										callStartedData.recordings,
										allUsers)),
									$author$project$Pages$Guild$callRecordingsButton$(isMobile, localUser.timezone, messageId, callStartedData.recordings, allUsers)
								])),
							$author$project$Pages$Guild$messageTimestamp$(
							$author$project$User$discordUserColor(localUser),
							callStartedData.timestampDrawings,
							_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
							messageId,
							callStartedData.startedAt,
							localUser.timezone),
							$author$project$Pages$Guild$messageIdView(messageId)
						])));
		default:
			var gameStarted = message.a;
			return $author$project$Pages$Guild$messageContainer$(
				containerWidth,
				isThreadStarter,
				localUser.timezone,
				time,
				$author$project$Pages$Guild$discordQuickReactionCustomEmojis,
				localUser.customEmojis,
				localUser.emojiData,
				allUsers,
				channels,
				highlight,
				messageId,
				false,
				currentUserId,
				localUser.user,
				gameStarted.reactions,
				maybeThreadStarter,
				$lamdera$containers$SeqDict$empty,
				isHovered,
				$author$project$Ui$row$(
					_List_fromArray(
						[$author$project$Ui$contentTop]),
					_List_fromArray(
						[
							$author$project$Pages$Guild$goMatchStartedCard$(
							$author$project$User$discordUserColor(localUser),
							_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
							gameStarted.cardDrawings,
							messageId,
							gameStarted.startedBy,
							allUsers,
							gameStarted.gameType),
							$author$project$Pages$Guild$messageTimestamp$(
							$author$project$User$discordUserColor(localUser),
							gameStarted.timestampDrawings,
							_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
							messageId,
							gameStarted.startedAt,
							localUser.timezone),
							$author$project$Pages$Guild$messageIdView(messageId)
						])));
	}
};
var $author$project$Pages$Guild$discordMessageView = function (time) {
	return function (isMobile) {
		return function (containerWidth) {
			return function (isThreadStarter) {
				return function (revealedSpoilers) {
					return function (highlight) {
						return function (isHovered) {
							return function (currentUserId) {
								return function (allUsers) {
									return function (channels) {
										return function (localUser) {
											return function (maybeRepliedTo2) {
												return function (maybeThreadStarter) {
													return function (messageId) {
														return function (message) {
															return $author$project$Pages$Guild$discordMessageView$(time, isMobile, containerWidth, isThreadStarter, revealedSpoilers, highlight, isHovered, currentUserId, allUsers, channels, localUser, maybeRepliedTo2, maybeThreadStarter, messageId, message);
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Guild$IsHovered = {$: 1};
var $author$project$Pages$Guild$IsHoveredButNoMenu = {$: 2};
var $author$project$Pages$Guild$IsHoveredReactionsOnly = {$: 3};
var $author$project$Pages$Guild$IsNotHovered = {$: 0};
var $author$project$Pages$Guild$IsReactionLongPressed = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Guild$msInMinute = 1000 * 60;
var $author$project$Pages$Guild$timePackingOffset = A2($elm$core$Basics$pow, 2, 27);
var $author$project$Pages$Guild$decodeMessageView = function (packed) {
	var value = A2($elm$core$Basics$modBy, $author$project$Pages$Guild$timePackingOffset, packed);
	return {
		containerWidth: 65535 & (value >> 4),
		highlight: function () {
			var _v0 = 3 & (value >> 1);
			switch (_v0) {
				case 1:
					return 1;
				case 2:
					return 2;
				case 3:
					return 3;
				default:
					return 0;
			}
		}(),
		isEditing: (1 & value) === 1,
		isHovered: function () {
			var _v1 = value >> 20;
			switch (_v1) {
				case 0:
					return $author$project$Pages$Guild$IsNotHovered;
				case 1:
					return $author$project$Pages$Guild$IsHovered;
				case 2:
					return $author$project$Pages$Guild$IsHoveredButNoMenu;
				case 3:
					return $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor;
				case 4:
					return $author$project$Pages$Guild$IsHoveredReactionsOnly;
				default:
					var hover = _v1;
					return $author$project$Pages$Guild$IsReactionLongPressed(hover - 5);
			}
		}(),
		isMobile: 1 === (1 & (value >> 3)),
		time: $elm$time$Time$millisToPosix(((packed / $author$project$Pages$Guild$timePackingOffset) | 0) * $author$project$Pages$Guild$msInMinute)
	};
};
var $author$project$Pages$Guild$discordMessageViewNotThreadStarter$ = function (data, revealedSpoilers, currentDiscordUserId, localUser, messageIndex, message) {
	var _v0 = $author$project$Pages$Guild$decodeMessageView(data);
	var time = _v0.time;
	var isMobile = _v0.isMobile;
	var isHovered = _v0.isHovered;
	var highlight = _v0.highlight;
	var containerWidth = _v0.containerWidth;
	return $author$project$Pages$Guild$discordMessageView$(
		time,
		isMobile,
		containerWidth,
		false,
		revealedSpoilers,
		highlight,
		isHovered,
		currentDiscordUserId,
		$author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(localUser.discordUsers),
		$lamdera$containers$SeqDict$empty,
		localUser,
		$elm$core$Maybe$Nothing,
		$elm$core$Maybe$Nothing,
		$author$project$Id$fromInt(messageIndex),
		message);
};
var $author$project$Pages$Guild$discordMessageViewNotThreadStarter = F6($author$project$Pages$Guild$discordMessageViewNotThreadStarter$);
var $author$project$Pages$Guild$decodeDiscordMessageViewWithReply = function (packed) {
	var _v0 = $elm$core$String$split$(' ', packed);
	if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
		var data = _v0.a;
		var _v1 = _v0.b;
		var messageIndexAndReplyMessageIndex = _v1.a;
		return {
			data: $elm$core$Maybe$withDefault$(
				0,
				$elm$core$String$toInt(data)),
			messageIndexAndReplyMessageIndex: $elm$core$Maybe$withDefault$(
				0,
				$elm$core$String$toInt(messageIndexAndReplyMessageIndex))
		};
	} else {
		return {data: 0, messageIndexAndReplyMessageIndex: 0};
	}
};
var $author$project$Pages$Guild$messageIndexPackingOffset = A2($elm$core$Basics$pow, 2, 26);
var $author$project$Pages$Guild$decodeMessageIndex = function (packed) {
	return {
		messageIndex: A2($elm$core$Basics$modBy, $author$project$Pages$Guild$messageIndexPackingOffset, packed),
		replyMessageIndex: (packed / $author$project$Pages$Guild$messageIndexPackingOffset) | 0
	};
};
var $author$project$Pages$Guild$discordMessageViewNotThreadStarterWithChannelMention$ = function (dataAndMessageIndex, revealedSpoilers, currentDiscordUserId, localUser, message, guildChannels) {
	var _v0 = $author$project$Pages$Guild$decodeDiscordMessageViewWithReply(dataAndMessageIndex);
	var messageIndexAndReplyMessageIndex = _v0.messageIndexAndReplyMessageIndex;
	var data = _v0.data;
	var _v1 = $author$project$Pages$Guild$decodeMessageIndex(messageIndexAndReplyMessageIndex);
	var messageIndex = _v1.messageIndex;
	var _v2 = $author$project$Pages$Guild$decodeMessageView(data);
	var time = _v2.time;
	var isMobile = _v2.isMobile;
	var isHovered = _v2.isHovered;
	var highlight = _v2.highlight;
	var containerWidth = _v2.containerWidth;
	return $author$project$Pages$Guild$discordMessageView$(
		time,
		isMobile,
		containerWidth,
		false,
		revealedSpoilers,
		highlight,
		isHovered,
		currentDiscordUserId,
		$author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(localUser.discordUsers),
		$author$project$LocalState$discordGuildChannelMentions$(localUser, guildChannels),
		localUser,
		$elm$core$Maybe$Nothing,
		$elm$core$Maybe$Nothing,
		$author$project$Id$fromInt(messageIndex),
		message);
};
var $author$project$Pages$Guild$discordMessageViewNotThreadStarterWithChannelMention = F6($author$project$Pages$Guild$discordMessageViewNotThreadStarterWithChannelMention$);
var $author$project$Pages$Guild$RepliedToView_Message$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Pages$Guild$RepliedToView_Message = F2($author$project$Pages$Guild$RepliedToView_Message$);
var $author$project$Pages$Guild$discordMessageViewNotThreadStarterWithReply$ = function (dataAndMessageIndex, revealedSpoilers, currentDiscordUserId, localUser, message, replyMessage) {
	var _v0 = $author$project$Pages$Guild$decodeDiscordMessageViewWithReply(dataAndMessageIndex);
	var messageIndexAndReplyMessageIndex = _v0.messageIndexAndReplyMessageIndex;
	var data = _v0.data;
	var _v1 = $author$project$Pages$Guild$decodeMessageIndex(messageIndexAndReplyMessageIndex);
	var replyMessageIndex = _v1.replyMessageIndex;
	var messageIndex = _v1.messageIndex;
	var _v2 = $author$project$Pages$Guild$decodeMessageView(data);
	var time = _v2.time;
	var isMobile = _v2.isMobile;
	var isHovered = _v2.isHovered;
	var highlight = _v2.highlight;
	var containerWidth = _v2.containerWidth;
	return $author$project$Pages$Guild$discordMessageView$(
		time,
		isMobile,
		containerWidth,
		false,
		revealedSpoilers,
		highlight,
		isHovered,
		currentDiscordUserId,
		$author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(localUser.discordUsers),
		$lamdera$containers$SeqDict$empty,
		localUser,
		$elm$core$Maybe$Just(
			$author$project$Pages$Guild$RepliedToView_Message$(
				$author$project$Id$fromInt(replyMessageIndex),
				replyMessage)),
		$elm$core$Maybe$Nothing,
		$author$project$Id$fromInt(messageIndex),
		message);
};
var $author$project$Pages$Guild$discordMessageViewNotThreadStarterWithReply = F6($author$project$Pages$Guild$discordMessageViewNotThreadStarterWithReply$);
var $author$project$Pages$Guild$discordMessageViewThreadStarter$ = function (data, revealedSpoilers, currentDiscordUserId, localUser, messageIndex, thread, message) {
	var _v0 = $author$project$Pages$Guild$decodeMessageView(data);
	var time = _v0.time;
	var isMobile = _v0.isMobile;
	var isHovered = _v0.isHovered;
	var highlight = _v0.highlight;
	var containerWidth = _v0.containerWidth;
	return $author$project$Pages$Guild$discordMessageView$(
		time,
		isMobile,
		containerWidth,
		false,
		revealedSpoilers,
		highlight,
		isHovered,
		currentDiscordUserId,
		$author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(localUser.discordUsers),
		$lamdera$containers$SeqDict$empty,
		localUser,
		$elm$core$Maybe$Nothing,
		$elm$core$Maybe$Just(thread),
		$author$project$Id$fromInt(messageIndex),
		message);
};
var $author$project$Pages$Guild$discordMessageViewThreadStarter = F7($author$project$Pages$Guild$discordMessageViewThreadStarter$);
var $author$project$LocalState$discordTypingIn$ = function (guildOrDmId, local) {
	if (!guildOrDmId.$) {
		var channelId = guildOrDmId.a.channelId;
		var guildId = guildOrDmId.a.guildId;
		var _v1 = $lamdera$containers$SeqDict$get$(guildId, local.discordGuilds);
		if (!_v1.$) {
			var guild = _v1.a;
			return $lamdera$containers$SeqDict$filterMap$(
				F2(
					function (_v2, typing) {
						return _Utils_eq(typing.channelId, channelId) ? $elm$core$Maybe$Just(
							{threadRoute: typing.threadRoute, time: typing.time}) : $elm$core$Maybe$Nothing;
					}),
				guild.lastTypedAt);
		} else {
			return $lamdera$containers$SeqDict$empty;
		}
	} else {
		var channelId = guildOrDmId.a.channelId;
		var _v3 = $lamdera$containers$SeqDict$get$(channelId, local.discordDmChannels);
		if (!_v3.$) {
			var dmChannel = _v3.a;
			return $lamdera$containers$SeqDict$map$(
				F2(
					function (_v4, typing) {
						return {
							threadRoute: $author$project$Id$NoThreadWithMaybeMessage(typing.messageIndex),
							time: typing.time
						};
					}),
				dmChannel.lastTypedAt);
		} else {
			return $lamdera$containers$SeqDict$empty;
		}
	}
};
var $author$project$LocalState$discordTypingIn = F2($author$project$LocalState$discordTypingIn$);
var $author$project$Pages$Guild$drawingIsSelectingAnchor$ = function (loggedIn, model) {
	return _Utils_eq(loggedIn.drawingMode, $author$project$Drawing$NoSelectedAnchor) && _Utils_eq(
		$author$project$Route$toChannelHeaderTab(model.route),
		$elm$core$Maybe$Just($author$project$UserSession$ChannelHeaderTab_Draw));
};
var $author$project$Pages$Guild$drawingIsSelectingAnchor = F2($author$project$Pages$Guild$drawingIsSelectingAnchor$);
var $author$project$Pages$Guild$encodeDiscordMessageViewWithReply$ = function (data, messageIndexAndReplyMessageIndex) {
	return $elm$core$String$fromInt(data) + (' ' + $elm$core$String$fromInt(messageIndexAndReplyMessageIndex));
};
var $author$project$Pages$Guild$encodeDiscordMessageViewWithReply = F2($author$project$Pages$Guild$encodeDiscordMessageViewWithReply$);
var $author$project$Pages$Guild$encodeMessageIndex$ = function (messageIndex, replyMessageIndex) {
	return messageIndex + ($author$project$Id$toInt(replyMessageIndex) * $author$project$Pages$Guild$messageIndexPackingOffset);
};
var $author$project$Pages$Guild$encodeMessageIndex = F2($author$project$Pages$Guild$encodeMessageIndex$);
var $author$project$Pages$Guild$encodeMessageView$ = function (isMobile, isHovered, containerWidth, otherUserIsEditing, highlight, time) {
	return (((((otherUserIsEditing ? 1 : 0) + (function () {
		switch (highlight) {
			case 0:
				return 0;
			case 1:
				return 1;
			case 2:
				return 2;
			default:
				return 3;
		}
	}() << 1)) + ((isMobile ? 1 : 0) << 3)) + (containerWidth << 4)) + (function () {
		switch (isHovered.$) {
			case 0:
				return 0;
			case 1:
				return 1;
			case 2:
				return 2;
			case 4:
				return 3;
			case 3:
				return 4;
			default:
				var reactionIndex = isHovered.a;
				return (_Utils_cmp(reactionIndex, $author$project$Message$maxReactionEmojis) > 0) ? 0 : (5 + reactionIndex);
		}
	}() << 20)) + ((($elm$time$Time$posixToMillis(time) / $author$project$Pages$Guild$msInMinute) | 0) * $author$project$Pages$Guild$timePackingOffset);
};
var $author$project$Pages$Guild$encodeMessageView = F6($author$project$Pages$Guild$encodeMessageView$);
var $justinmimbs$date$Date$fromPosix$ = function (zone, posix) {
	return $justinmimbs$date$Date$fromCalendarDate$(
		$elm$time$Time$toYear$(zone, posix),
		$elm$time$Time$toMonth$(zone, posix),
		$elm$time$Time$toDay$(zone, posix));
};
var $justinmimbs$date$Date$fromPosix = F2($justinmimbs$date$Date$fromPosix$);
var $author$project$RichText$mentionsChannel = function (richText) {
	return $mgold$elm_nonempty_list$List$Nonempty$any$(
		function (richText2) {
			switch (richText2.$) {
				case 1:
					return true;
				case 0:
					return false;
				case 2:
					return false;
				case 3:
					var a = richText2.a;
					return $author$project$RichText$mentionsChannel(a);
				case 4:
					var a = richText2.a;
					return $author$project$RichText$mentionsChannel(a);
				case 5:
					var a = richText2.a;
					return $author$project$RichText$mentionsChannel(a);
				case 6:
					var a = richText2.a;
					return $author$project$RichText$mentionsChannel(a);
				case 7:
					var a = richText2.a;
					return $author$project$RichText$mentionsChannel(a);
				case 8:
					var a = richText2.b;
					return $elm$core$Maybe$withDefault$(
						false,
						$elm$core$Maybe$map$(
							$author$project$RichText$mentionsChannel,
							$mgold$elm_nonempty_list$List$Nonempty$fromList(a)));
				case 9:
					var a = richText2.c;
					return $author$project$RichText$mentionsChannel(a);
				case 10:
					return false;
				case 11:
					return false;
				case 12:
					return false;
				case 13:
					return false;
				case 14:
					return false;
				case 15:
					return false;
				case 16:
					return false;
				case 17:
					return false;
				case 18:
					var a = richText2.b;
					return $mgold$elm_nonempty_list$List$Nonempty$any$(
						function (list) {
							return $elm$core$Maybe$withDefault$(
								false,
								$elm$core$Maybe$map$(
									$author$project$RichText$mentionsChannel,
									$mgold$elm_nonempty_list$List$Nonempty$fromList(list)));
						},
						a);
				default:
					return false;
			}
		},
		richText);
};
var $author$project$Message$mentionsChannel = function (message) {
	switch (message.$) {
		case 0:
			var data = message.a;
			return $author$project$RichText$mentionsChannel(data.content.content);
		case 1:
			return false;
		case 2:
			return false;
		case 3:
			return false;
		case 4:
			return false;
		default:
			return false;
	}
};
var $author$project$Pages$Guild$lastThreadMessageMentionsChannel = function (thread) {
	var _v0 = $author$project$MessageArray$last(thread.messages);
	if (!_v0.$) {
		var last = _v0.a;
		return $author$project$Message$mentionsChannel(last);
	} else {
		return false;
	}
};
var $author$project$Pages$Guild$RepliedToView_Game$ = function (a, b, c) {
	return {$: 1, a: a, b: b, c: c};
};
var $author$project$Pages$Guild$RepliedToView_Game = F3($author$project$Pages$Guild$RepliedToView_Game$);
var $author$project$Pages$Guild$userTextMessageRepliedTo$ = function (data, channel) {
	var _v0 = data.repliedTo;
	switch (_v0.$) {
		case 1:
			var repliedToIndex = _v0.a;
			var _v1 = $author$project$MessageArray$get$(repliedToIndex, channel.messages);
			if (!_v1.$) {
				var message2 = _v1.a;
				return $elm$core$Maybe$Just(
					$author$project$Pages$Guild$RepliedToView_Message$(repliedToIndex, message2));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		case 2:
			var matchId = _v0.a;
			var game = _v0.b;
			return $elm$core$Maybe$Just(
				$author$project$Pages$Guild$RepliedToView_Game$(matchId, game, $author$project$Ui$none));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Guild$userTextMessageRepliedTo = F2($author$project$Pages$Guild$userTextMessageRepliedTo$);
var $author$project$Pages$Guild$maybeRepliedTo$ = function (message, channel) {
	switch (message.$) {
		case 0:
			var data = message.a;
			return $author$project$Pages$Guild$userTextMessageRepliedTo$(data, channel);
		case 1:
			var data = message.a;
			return $author$project$Pages$Guild$userTextMessageRepliedTo$(data, channel);
		case 2:
			return $elm$core$Maybe$Nothing;
		case 3:
			return $elm$core$Maybe$Nothing;
		case 4:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Guild$maybeRepliedTo = F2($author$project$Pages$Guild$maybeRepliedTo$);
var $author$project$Types$EditMessage_MessageInputMsg$ = function (a, b, c) {
	return {$: 146, a: a, b: b, c: c};
};
var $author$project$Types$EditMessage_MessageInputMsg = F3($author$project$Types$EditMessage_MessageInputMsg$);
var $author$project$Types$EditMessage_PressedDeleteAttachedFile$ = function (a, b) {
	return {$: 90, a: a, b: b};
};
var $author$project$Types$EditMessage_PressedDeleteAttachedFile = F2($author$project$Types$EditMessage_PressedDeleteAttachedFile$);
var $author$project$Types$EditMessage_PressedToggleAttachedFileSpoiler$ = function (a, b) {
	return {$: 92, a: a, b: b};
};
var $author$project$Types$EditMessage_PressedToggleAttachedFileSpoiler = F2($author$project$Types$EditMessage_PressedToggleAttachedFileSpoiler$);
var $author$project$Types$EditMessage_PressedViewAttachedFileInfo$ = function (a, b) {
	return {$: 91, a: a, b: b};
};
var $author$project$Types$EditMessage_PressedViewAttachedFileInfo = F2($author$project$Types$EditMessage_PressedViewAttachedFileInfo$);
var $author$project$Types$PressedCancelMessageEdit = function (a) {
	return {$: 70, a: a};
};
var $author$project$Pages$Guild$fileUploadPreview$ = function (onPressDelete, onPressInfo, onPressSpoiler, richText, filesToUpload2) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(4),
				$author$project$Ui$move(
				{x: 0, y: -$author$project$SheepGame$fileUploadPreviewSize, z: 0}),
				$author$project$Ui$width($author$project$Ui$shrink),
				$author$project$Ui$paddingXY$(8, 0)
			]),
		$author$project$SheepGame$fileUploadPreview$(onPressDelete, onPressInfo, onPressSpoiler, richText, filesToUpload2));
};
var $author$project$Pages$Guild$fileUploadPreview = F5($author$project$Pages$Guild$fileUploadPreview$);
var $author$project$MessageInput$counterThreshold = 900;
var $author$project$MessageInput$characterCounter = function (charsLeft) {
	return (_Utils_cmp(charsLeft, $author$project$MessageInput$counterThreshold) < 1) ? $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$alignBottom,
				$author$project$Ui$alignLeft,
				$author$project$Ui$width($author$project$Ui$shrink),
				$author$project$Ui$paddingXY$(6, 2),
				$author$project$Ui$Font$color(
				(charsLeft < 0) ? $author$project$MyUi$errorColor : $author$project$MyUi$font3),
				$author$project$Ui$move(
				{x: 2, y: -2, z: 0})
			]),
		$author$project$Ui$text(
			$elm$core$String$fromInt(charsLeft) + ('/' + $elm$core$String$fromInt($author$project$RichText$maxLength)))) : $author$project$Ui$none;
};
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Events$custom$ = function (event, decoder) {
	return A2(
		$elm$virtual_dom$VirtualDom$on,
		event,
		$elm$virtual_dom$VirtualDom$Custom(decoder));
};
var $elm$html$Html$Events$custom = F2($elm$html$Html$Events$custom$);
var $author$project$MessageInput$textareaPadding = {bottom: 0, left: 80, right: 36, top: 0};
var $author$project$MessageInput$view$ = function (htmlId, roundTopCorners, isMobileKeyboard, channelTextInputId, placeholderText, charsLeft, text, richText, attachedFiles, localUser, loggedIn, users, channels) {
	var htmlIdPrefix = $lamdera$program_test$Effect$Browser$Dom$idToString(htmlId);
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$paddingWith($author$project$MessageInput$textareaPadding),
				$author$project$Ui$inFront(
				$author$project$Ui$row$(
					_List_fromArray(
						[
							$author$project$Ui$width($author$project$Ui$shrink),
							$author$project$Ui$move(
							{x: 2, y: -2, z: 0}),
							$author$project$Ui$spacing(4),
							$author$project$Ui$alignBottom
						]),
					_List_fromArray(
						[
							$author$project$MessageInput$attachmentButton(htmlIdPrefix),
							$author$project$MessageInput$showEmojiSelectorButton(htmlIdPrefix)
						]))),
				$author$project$Ui$inFront(
				$author$project$MessageInput$characterCounter(charsLeft)),
				$author$project$Ui$inFront(
				$author$project$MyUi$elButton$(
					$lamdera$program_test$Effect$Browser$Dom$id(htmlIdPrefix + '_sendMessage'),
					$author$project$MessageInput$PressedSendMessage(
						{charsLeft: charsLeft}),
					_List_fromArray(
						[
							$author$project$Ui$alignRight,
							$author$project$Ui$width($author$project$Ui$shrink),
							$author$project$Ui$rounded(4),
							$author$project$Ui$paddingXY$(4, 0),
							$author$project$Ui$height(
							$author$project$Ui$px(38)),
							$author$project$Ui$background(
							((charsLeft < 0) || $author$project$FileStatus$hasUploadingFile(attachedFiles)) ? $author$project$MyUi$disabledButtonBackground : $author$project$MyUi$buttonBackground),
							$author$project$Ui$move(
							{x: -2, y: -4, z: 0}),
							$author$project$Ui$contentCenterY,
							$author$project$Ui$alignBottom,
							$author$project$MyUi$hoverText('Send message'),
							$author$project$Ui$htmlAttribute(
							$elm$html$Html$Events$custom$(
								'touchstart',
								$elm$json$Json$Decode$succeed(
									{
										message: $author$project$MessageInput$PressedSendMessage(
											{charsLeft: charsLeft}),
										preventDefault: true,
										stopPropagation: true
									})))
						]),
					$author$project$Ui$html($author$project$Icons$sendMessage)))
			]),
		$author$project$Ui$el$(
			A2(
				$elm$core$List$cons,
				$author$project$Ui$heightMax(400),
				$author$project$MessageInput$containerAttributes(roundTopCorners)),
			$author$project$Ui$html(
				$author$project$MessageInput$textarea$(isMobileKeyboard, channelTextInputId, placeholderText, charsLeft, text, richText, attachedFiles, localUser, loggedIn, users, channels))));
};
var $author$project$MessageInput$view = function (htmlId) {
	return function (roundTopCorners) {
		return function (isMobileKeyboard) {
			return function (channelTextInputId) {
				return function (placeholderText) {
					return function (charsLeft) {
						return function (text) {
							return function (richText) {
								return function (attachedFiles) {
									return function (localUser) {
										return function (loggedIn) {
											return function (users) {
												return function (channels) {
													return $author$project$MessageInput$view$(htmlId, roundTopCorners, isMobileKeyboard, channelTextInputId, placeholderText, charsLeft, text, richText, attachedFiles, localUser, loggedIn, users, channels);
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Guild$messageEditingView$ = function (containerWidth, time, isMobile, guildOrDmId, threadRouteWithMessage, message, maybeRepliedTo2, maybeThread, revealedSpoilers, charsLeft, editing, editingRichText, loggedIn, decrypted, currentUserId, allUsers, channels, local) {
	var editingView = F2(
		function (createdBy, reactions) {
			var messageInput = $author$project$MessageInput$view$(
				$lamdera$program_test$Effect$Browser$Dom$id('messageMenu_editDesktop'),
				true,
				false,
				$author$project$MessageMenu$editMessageTextInputId,
				$author$project$MessageInput$emptyPlaceholder,
				charsLeft,
				editing.text,
				editingRichText,
				editing.attachedFiles,
				local.localUser,
				loggedIn,
				allUsers,
				channels);
			var maybeReactions = $author$project$MessageView$reactionEmojiView$(local.localUser.emojiData, $author$project$MessageView$ReactionsHovered, currentUserId, local.localUser.customEmojis, allUsers, 0, containerWidth, reactions);
			var _v1 = guildOrDmId;
			var guildOrDmIdNoThread = _v1.a;
			var threadRoute = _v1.b;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$Font$color($author$project$MyUi$font1),
						$author$project$Ui$background($author$project$MyUi$hoverHighlight),
						$author$project$Ui$paddingWith(
						{
							bottom: _Utils_eq(maybeReactions, $elm$core$Maybe$Nothing) ? 8 : 4,
							left: 0,
							right: 0,
							top: 4
						}),
						$author$project$Ui$spacing(4),
						$author$project$Ui$id(
						$lamdera$program_test$Effect$Browser$Dom$idToString(
							$author$project$Pages$Guild$channelMessageHtmlId(
								function () {
									if (threadRouteWithMessage.$ === 1) {
										var messageId = threadRouteWithMessage.b;
										return $author$project$Id$changeType(messageId);
									} else {
										var messageId = threadRouteWithMessage.a;
										return messageId;
									}
								}())))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$map,
						A2($author$project$Types$MessageViewMsg, guildOrDmIdNoThread, threadRouteWithMessage),
						$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$paddingXY$(8, 0)
								]),
							$author$project$Pages$Guild$replyToHeaderAboveMessage$(isMobile, local.localUser.timezone, time, maybeRepliedTo2, revealedSpoilers, local.localUser.emojiData, local.localUser.customEmojis, decrypted, allUsers, channels))),
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$Font$bold,
								$author$project$Ui$paddingXY$(8, 0)
							]),
						$author$project$Ui$text(
							$author$project$User$toString$(createdBy, allUsers) + ' ')),
						$author$project$Ui$column$(
						_List_fromArray(
							[
								function () {
								var _v3 = $author$project$NonemptyDict$fromSeqDict(editing.attachedFiles);
								if (!_v3.$) {
									var filesToUpload = _v3.a;
									return $author$project$Ui$inFront(
										$author$project$Pages$Guild$fileUploadPreview$(
											$author$project$Types$EditMessage_PressedDeleteAttachedFile(guildOrDmId),
											$author$project$Types$EditMessage_PressedViewAttachedFileInfo(guildOrDmId),
											$elm$core$Maybe$Just(
												$author$project$Types$EditMessage_PressedToggleAttachedFileSpoiler(guildOrDmId)),
											editingRichText,
											filesToUpload));
								} else {
									return $author$project$Ui$noAttr;
								}
							}()
							]),
						_List_fromArray(
							[
								$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$paddingXY$(5, 0)
									]),
								A2(
									$author$project$Ui$map,
									A2($author$project$Types$EditMessage_MessageInputMsg, guildOrDmIdNoThread, threadRoute),
									messageInput)),
								$author$project$Ui$row$(
								_List_fromArray(
									[
										$author$project$Ui$Font$size(14),
										$author$project$Ui$Font$color($author$project$MyUi$font3),
										$author$project$Ui$paddingXY$(12, 0),
										$author$project$MyUi$prewrap
									]),
								_List_fromArray(
									[
										$author$project$Ui$text('Press '),
										$author$project$MyUi$elButton$(
										$lamdera$program_test$Effect$Browser$Dom$id('guild_exitEditMessage'),
										$author$project$Types$PressedCancelMessageEdit(guildOrDmId),
										_List_fromArray(
											[
												$author$project$Ui$Font$color($author$project$MyUi$font1),
												$author$project$Ui$width($author$project$Ui$shrink)
											]),
										$author$project$Ui$text('escape')),
										$author$project$Ui$text(' to cancel edit')
									]))
							])),
						function () {
						if (!maybeReactions.$) {
							var reactionView = maybeReactions.a;
							return A2(
								$author$project$Ui$map,
								A2($author$project$Types$MessageViewMsg, guildOrDmIdNoThread, threadRouteWithMessage),
								$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$paddingXY$(8, 0)
										]),
									reactionView));
						} else {
							return $author$project$Ui$none;
						}
					}(),
						function () {
						var _v5 = _Utils_Tuple2(threadRouteWithMessage, maybeThread);
						if ((!_v5.a.$) && (!_v5.b.$)) {
							var messageId = _v5.a.a;
							var thread = _v5.b.a;
							return A2(
								$author$project$Ui$map,
								A2($author$project$Types$MessageViewMsg, guildOrDmIdNoThread, threadRouteWithMessage),
								$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$paddingXY$(8, 0)
										]),
									$author$project$Pages$Guild$previewThreadLastMessage$(local.localUser.timezone, time, local.localUser.emojiData, local.localUser.customEmojis, allUsers, channels, decrypted, messageId, thread)));
						} else {
							return $author$project$Ui$none;
						}
					}()
					]));
		});
	switch (message.$) {
		case 0:
			var data = message.a;
			return A2(editingView, data.createdBy, data.reactions);
		case 1:
			var data = message.a;
			return A2(editingView, data.createdBy, data.reactions);
		case 2:
			return $author$project$Ui$none;
		case 3:
			return $author$project$Ui$none;
		case 4:
			return $author$project$Ui$none;
		default:
			return $author$project$Ui$none;
	}
};
var $author$project$Pages$Guild$messageEditingView = function (containerWidth) {
	return function (time) {
		return function (isMobile) {
			return function (guildOrDmId) {
				return function (threadRouteWithMessage) {
					return function (message) {
						return function (maybeRepliedTo2) {
							return function (maybeThread) {
								return function (revealedSpoilers) {
									return function (charsLeft) {
										return function (editing) {
											return function (editingRichText) {
												return function (loggedIn) {
													return function (decrypted) {
														return function (currentUserId) {
															return function (allUsers) {
																return function (channels) {
																	return function (local) {
																		return $author$project$Pages$Guild$messageEditingView$(containerWidth, time, isMobile, guildOrDmId, threadRouteWithMessage, message, maybeRepliedTo2, maybeThread, revealedSpoilers, charsLeft, editing, editingRichText, loggedIn, decrypted, currentUserId, allUsers, channels, local);
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Guild$notHoveredWhileSelectingAnchor$ = function (loggedIn, model) {
	return ($author$project$MyUi$isMobile(model) && $author$project$Pages$Guild$drawingIsSelectingAnchor$(loggedIn, model)) ? $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor : $author$project$Pages$Guild$IsNotHovered;
};
var $author$project$Pages$Guild$notHoveredWhileSelectingAnchor = F2($author$project$Pages$Guild$notHoveredWhileSelectingAnchor$);
var $author$project$Pages$Guild$messageHover$ = function (guildOrDmId, threadRoute, loggedIn, model) {
	var _v0 = loggedIn.messageHover;
	switch (_v0.$) {
		case 2:
			var messageMenu = _v0.a;
			return (_Utils_eq(guildOrDmId, messageMenu.guildOrDmId) && _Utils_eq(threadRoute, messageMenu.threadRoute)) ? $author$project$Pages$Guild$IsHoveredButNoMenu : $author$project$Pages$Guild$IsNotHovered;
		case 1:
			var guildOrDmIdA = _v0.a;
			var threadRouteA = _v0.b;
			return _Utils_eq(guildOrDmId, guildOrDmIdA) ? (_Utils_eq(threadRouteA, threadRoute) ? ($author$project$Pages$Guild$drawingIsSelectingAnchor$(loggedIn, model) ? $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor : $author$project$Pages$Guild$IsHovered) : $author$project$Pages$Guild$notHoveredWhileSelectingAnchor$(loggedIn, model)) : $author$project$Pages$Guild$notHoveredWhileSelectingAnchor$(loggedIn, model);
		case 3:
			var guildOrDmIdA = _v0.a;
			var threadRouteA = _v0.b;
			var reactionIndex = _v0.c;
			return (_Utils_eq(guildOrDmId, guildOrDmIdA) && _Utils_eq(threadRouteA, threadRoute)) ? $author$project$Pages$Guild$IsReactionLongPressed(reactionIndex) : $author$project$Pages$Guild$notHoveredWhileSelectingAnchor$(loggedIn, model);
		default:
			return $author$project$Pages$Guild$notHoveredWhileSelectingAnchor$(loggedIn, model);
	}
};
var $author$project$Pages$Guild$messageHover = F4($author$project$Pages$Guild$messageHover$);
var $author$project$MessageView$MessageView_PressedDateDivider$ = function (a, b, c) {
	return {$: 21, a: a, b: b, c: c};
};
var $author$project$MessageView$MessageView_PressedDateDivider = F3($author$project$MessageView$MessageView_PressedDateDivider$);
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = $elm$core$Basics$max$(1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp$ = function (y, m, d) {
	toCalendarDateHelp:
	while (true) {
		var monthDays = $justinmimbs$date$Date$daysInMonth$(y, m);
		var mn = $justinmimbs$date$Date$monthToNumber(m);
		if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
			var $temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
				$temp$d = d - monthDays;
			m = $temp$m;
			d = $temp$d;
			continue toCalendarDateHelp;
		} else {
			return {day: d, month: m, year: y};
		}
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3($justinmimbs$date$Date$toCalendarDateHelp$);
var $justinmimbs$date$Date$divWithRemainder$ = function (a, b) {
	return _Utils_Tuple2(
		$justinmimbs$date$Date$floorDiv$(a, b),
		A2($elm$core$Basics$modBy, b, a));
};
var $justinmimbs$date$Date$divWithRemainder = F2($justinmimbs$date$Date$divWithRemainder$);
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = $justinmimbs$date$Date$divWithRemainder$(rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = $justinmimbs$date$Date$divWithRemainder$(r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = $justinmimbs$date$Date$divWithRemainder$(r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = $justinmimbs$date$Date$divWithRemainder$(r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		ordinalDay: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		year: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return $justinmimbs$date$Date$toCalendarDateHelp$(date.year, 0, date.ordinalDay);
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.day;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.month;
	});
var $author$project$MyUi$datestampDate = function (date) {
	return $author$project$MyUi$monthToString(
		$justinmimbs$date$Date$month(date)) + (' ' + ($elm$core$String$fromInt(
		$justinmimbs$date$Date$day(date)) + (', ' + $elm$core$String$fromInt(
		$justinmimbs$date$Date$year(date)))));
};
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.ordinalDay;
	});
var $justinmimbs$date$Date$padSignedInt$ = function (length, _int) {
	return _Utils_ap(
		(_int < 0) ? '-' : '',
		$elm$core$String$padLeft$(
			length,
			'0',
			$elm$core$String$fromInt(
				$elm$core$Basics$abs(_int))));
};
var $justinmimbs$date$Date$padSignedInt = F2($justinmimbs$date$Date$padSignedInt$);
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = $elm$core$Basics$max$(1, wdn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		default:
			return 6;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0;
	var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
	var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		weekNumber: 1 + (((rd - week1Day1) / 7) | 0),
		weekYear: wy,
		weekday: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.weekNumber;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.weekYear;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = $elm$core$Basics$min$(
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField$ = function (language, _char, length, date) {
	switch (_char) {
		case 'y':
			if (length === 2) {
				return $elm$core$String$right$(
					2,
					$elm$core$String$padLeft$(
						2,
						'0',
						$elm$core$String$fromInt(
							$justinmimbs$date$Date$year(date))));
			} else {
				return $justinmimbs$date$Date$padSignedInt$(
					length,
					$justinmimbs$date$Date$year(date));
			}
		case 'Y':
			if (length === 2) {
				return $elm$core$String$right$(
					2,
					$elm$core$String$padLeft$(
						2,
						'0',
						$elm$core$String$fromInt(
							$justinmimbs$date$Date$weekYear(date))));
			} else {
				return $justinmimbs$date$Date$padSignedInt$(
					length,
					$justinmimbs$date$Date$weekYear(date));
			}
		case 'Q':
			switch (length) {
				case 1:
					return $elm$core$String$fromInt(
						$justinmimbs$date$Date$quarter(date));
				case 2:
					return $elm$core$String$fromInt(
						$justinmimbs$date$Date$quarter(date));
				case 3:
					return 'Q' + $elm$core$String$fromInt(
						$justinmimbs$date$Date$quarter(date));
				case 4:
					return $justinmimbs$date$Date$withOrdinalSuffix(
						$justinmimbs$date$Date$quarter(date));
				case 5:
					return $elm$core$String$fromInt(
						$justinmimbs$date$Date$quarter(date));
				default:
					return '';
			}
		case 'M':
			switch (length) {
				case 1:
					return $elm$core$String$fromInt(
						$justinmimbs$date$Date$monthNumber(date));
				case 2:
					return $elm$core$String$padLeft$(
						2,
						'0',
						$elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date)));
				case 3:
					return language.monthNameShort(
						$justinmimbs$date$Date$month(date));
				case 4:
					return language.monthName(
						$justinmimbs$date$Date$month(date));
				case 5:
					return $elm$core$String$left$(
						1,
						language.monthNameShort(
							$justinmimbs$date$Date$month(date)));
				default:
					return '';
			}
		case 'w':
			switch (length) {
				case 1:
					return $elm$core$String$fromInt(
						$justinmimbs$date$Date$weekNumber(date));
				case 2:
					return $elm$core$String$padLeft$(
						2,
						'0',
						$elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date)));
				default:
					return '';
			}
		case 'd':
			switch (length) {
				case 1:
					return $elm$core$String$fromInt(
						$justinmimbs$date$Date$day(date));
				case 2:
					return $elm$core$String$padLeft$(
						2,
						'0',
						$elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date)));
				case 3:
					return language.dayWithSuffix(
						$justinmimbs$date$Date$day(date));
				default:
					return '';
			}
		case 'D':
			switch (length) {
				case 1:
					return $elm$core$String$fromInt(
						$justinmimbs$date$Date$ordinalDay(date));
				case 2:
					return $elm$core$String$padLeft$(
						2,
						'0',
						$elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date)));
				case 3:
					return $elm$core$String$padLeft$(
						3,
						'0',
						$elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date)));
				default:
					return '';
			}
		case 'E':
			switch (length) {
				case 1:
					return language.weekdayNameShort(
						$justinmimbs$date$Date$weekday(date));
				case 2:
					return language.weekdayNameShort(
						$justinmimbs$date$Date$weekday(date));
				case 3:
					return language.weekdayNameShort(
						$justinmimbs$date$Date$weekday(date));
				case 4:
					return language.weekdayName(
						$justinmimbs$date$Date$weekday(date));
				case 5:
					return $elm$core$String$left$(
						1,
						language.weekdayNameShort(
							$justinmimbs$date$Date$weekday(date)));
				case 6:
					return $elm$core$String$left$(
						2,
						language.weekdayNameShort(
							$justinmimbs$date$Date$weekday(date)));
				default:
					return '';
			}
		case 'e':
			switch (length) {
				case 1:
					return $elm$core$String$fromInt(
						$justinmimbs$date$Date$weekdayNumber(date));
				case 2:
					return $elm$core$String$fromInt(
						$justinmimbs$date$Date$weekdayNumber(date));
				default:
					return $justinmimbs$date$Date$formatField$(language, 'E', length, date);
			}
		default:
			return '';
	}
};
var $justinmimbs$date$Date$formatField = F4($justinmimbs$date$Date$formatField$);
var $justinmimbs$date$Date$formatWithTokens$ = function (language, tokens, date) {
	return $elm$core$List$foldl$(
		F2(
			function (token, formatted) {
				if (!token.$) {
					var _char = token.a;
					var length = token.b;
					return _Utils_ap(
						$justinmimbs$date$Date$formatField$(language, _char, length, date),
						formatted);
				} else {
					var str = token.a;
					return _Utils_ap(str, formatted);
				}
			}),
		'',
		tokens);
};
var $justinmimbs$date$Date$formatWithTokens = F3($justinmimbs$date$Date$formatWithTokens$);
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toToken = function (str) {
	return $elm$parser$Parser$Advanced$Token$(
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\u0027')),
	$elm$parser$Parser$token('\u0027\u0027'));
var $justinmimbs$date$Pattern$Field$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $justinmimbs$date$Pattern$Field = F2($justinmimbs$date$Pattern$Field$);
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return $elm$parser$Parser$Advanced$Good$(false, s.offset, s);
};
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return $justinmimbs$date$Pattern$Field$(_char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _v0 = thunk(0);
		var parse = _v0;
		return parse(s);
	};
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (_char !== '\'') && (!$elm$core$Char$isAlpha(_char));
};
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq('\''))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq('\''))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\u0027');
				},
				$elm$parser$Parser$token('\u0027\u0027')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('\''))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('\'')),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $justinmimbs$date$Pattern$fromString = function (str) {
	return $elm$core$Result$withDefault$(
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		$elm$parser$Parser$run$(
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage$ = function (language, pattern) {
	var tokens = $elm$core$List$reverse(
		$justinmimbs$date$Pattern$fromString(pattern));
	return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
};
var $justinmimbs$date$Date$formatWithLanguage = F2($justinmimbs$date$Date$formatWithLanguage$);
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	dayWithSuffix: $justinmimbs$date$Date$withOrdinalSuffix,
	monthName: $justinmimbs$date$Date$monthToName,
	monthNameShort: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	weekdayName: $justinmimbs$date$Date$weekdayToName,
	weekdayNameShort: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return $justinmimbs$date$Date$formatWithLanguage$($justinmimbs$date$Date$language_en, pattern);
};
var $justinmimbs$date$Date$toIsoString = $justinmimbs$date$Date$format('yyyy-MM-dd');
var $author$project$Pages$Guild$dateDivider$ = function (userIdToColor, isSelectingAnchor, dateDividerDrawings, laterDate, newDate) {
	return $author$project$Ui$inFront(
		$author$project$Ui$column$(
			_Utils_ap(
				_List_fromArray(
					[
						$author$project$Ui$Font$color($author$project$MyUi$font3),
						$author$project$Ui$centerX,
						$author$project$Ui$Font$size(14),
						$author$project$Ui$Font$bold,
						$author$project$Ui$move(
						{x: 0, y: -20, z: 0}),
						$author$project$Ui$rounded(4),
						$author$project$Ui$paddingXY$(4, 0)
					]),
				$author$project$Drawing$anchorHighlight$(
					$lamdera$program_test$Effect$Browser$Dom$id(
						'guild_dateDivider_' + $justinmimbs$date$Date$toIsoString(newDate)),
					userIdToColor,
					$author$project$MessageView$MessageView_PressedDateDivider(newDate),
					isSelectingAnchor,
					$elm$core$Maybe$withDefault$(
						$author$project$Drawing$emptyDrawing,
						$lamdera$containers$SeqDict$get$(newDate, dateDividerDrawings)))),
			_List_fromArray(
				[
					$author$project$Ui$el$(
					_List_fromArray(
						[$author$project$MyUi$noPointerEvents, $author$project$Ui$Font$center]),
					$author$project$Ui$text(
						$author$project$MyUi$datestampDate(laterDate))),
					$author$project$Ui$el$(
					_List_fromArray(
						[$author$project$MyUi$noPointerEvents, $author$project$Ui$Font$center]),
					$author$project$Ui$text(
						$author$project$MyUi$datestampDate(newDate)))
				])));
};
var $author$project$Pages$Guild$dateDivider = F5($author$project$Pages$Guild$dateDivider$);
var $author$project$Pages$Guild$newMessagesBadgeText = 'new';
var $author$project$Pages$Guild$newContentLabel = _List_fromArray(
	[
		$author$project$Ui$inFront(
		$author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$move(
					{x: -6, y: -11, z: 0}),
					$author$project$Ui$alignRight,
					$author$project$Ui$width($author$project$Ui$shrink),
					$author$project$Ui$Font$bold,
					$author$project$Ui$Font$size(14)
				]),
			$author$project$Ui$text($author$project$Pages$Guild$newMessagesBadgeText))),
		$author$project$Ui$inFront(
		$author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$Font$color($author$project$MyUi$font1),
					$author$project$Ui$background($author$project$MyUi$alertColor),
					$author$project$Ui$width(
					$author$project$Ui$px(42)),
					$author$project$Ui$alignRight,
					$author$project$Ui$height(
					$author$project$Ui$px(15)),
					$author$project$Ui$roundedWith(
					{bottomLeft: 8, bottomRight: 0, topLeft: 8, topRight: 0}),
					$author$project$Ui$move(
					{x: 0, y: -8, z: 0})
				]),
			$author$project$Ui$none))
	]);
var $author$project$Pages$Guild$newMessageLine$ = function (drawingUserColor, isSelectingAnchor, dateDividerDrawings, maybeLastDate, date, lastViewedIndex, index, messageId) {
	if (!maybeLastDate.$) {
		var lastDate = maybeLastDate.a;
		var _v1 = _Utils_Tuple2(
			_Utils_eq(lastViewedIndex, messageId),
			_Utils_eq(date, lastDate));
		if (_v1.a) {
			if (_v1.b) {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'n' + $elm$core$String$fromInt(index),
						$author$project$Ui$el$(
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Ui$borderWith(
										{bottom: 0, left: 0, right: 0, top: 1}),
										$author$project$Ui$borderColor($author$project$MyUi$alertColor)
									]),
								$author$project$Pages$Guild$newContentLabel),
							$author$project$Ui$none))
					]);
			} else {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'n' + $elm$core$String$fromInt(index),
						$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$height(
									$author$project$Ui$px(36)),
									$author$project$Ui$contentCenterY,
									$author$project$MyUi$noShrinking
								]),
							$author$project$Ui$el$(
								_Utils_ap(
									_List_fromArray(
										[
											$author$project$Ui$borderWith(
											{bottom: 0, left: 0, right: 0, top: 1}),
											$author$project$Ui$borderColor($author$project$MyUi$alertColor),
											$author$project$Pages$Guild$dateDivider$(drawingUserColor, isSelectingAnchor, dateDividerDrawings, date, lastDate)
										]),
									$author$project$Pages$Guild$newContentLabel),
								$author$project$Ui$none)))
					]);
			}
		} else {
			if (!_v1.b) {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'n' + $elm$core$String$fromInt(index),
						$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$paddingXY$(8, 0),
									$author$project$Ui$height(
									$author$project$Ui$px(36)),
									$author$project$Ui$contentCenterY,
									$author$project$MyUi$noShrinking
								]),
							$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$borderWith(
										{bottom: 0, left: 0, right: 0, top: 1}),
										$author$project$Ui$borderColor($author$project$MyUi$font3),
										$author$project$Pages$Guild$dateDivider$(drawingUserColor, isSelectingAnchor, dateDividerDrawings, date, lastDate)
									]),
								$author$project$Ui$none)))
					]);
			} else {
				return _List_Nil;
			}
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Pages$Guild$newMessageLine = F8($author$project$Pages$Guild$newMessageLine$);
var $author$project$Pages$Guild$prependUnreadDivider$ = function (lastViewedIndex, oldestVisibleMessage, list) {
	return ($elm$core$List$isEmpty(list) || (_Utils_cmp(
		$author$project$Id$toInt(lastViewedIndex),
		$author$project$Id$toInt(oldestVisibleMessage)) > -1)) ? list : A2(
		$elm$core$List$cons,
		_Utils_Tuple2(
			'nTop',
			$author$project$Ui$el$(
				_Utils_ap(
					_List_fromArray(
						[
							$author$project$Ui$borderWith(
							{bottom: 0, left: 0, right: 0, top: 1}),
							$author$project$Ui$borderColor($author$project$MyUi$alertColor)
						]),
					$author$project$Pages$Guild$newContentLabel),
				$author$project$Ui$none)),
		list);
};
var $author$project$Pages$Guild$prependUnreadDivider = F3($author$project$Pages$Guild$prependUnreadDivider$);
var $author$project$Pages$Guild$repliedToMentionsChannel = function (maybeRepliedTo2) {
	if (!maybeRepliedTo2.$) {
		if (!maybeRepliedTo2.a.$) {
			var _v1 = maybeRepliedTo2.a;
			var repliedTo = _v1.b;
			return $author$project$Message$mentionsChannel(repliedTo);
		} else {
			var _v2 = maybeRepliedTo2.a;
			return false;
		}
	} else {
		return false;
	}
};
var $author$project$Pages$Guild$revealedChannelSpoilers$ = function (guildOrDmId, loggedIn) {
	var _v0 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.revealedSpoilers);
	if (!_v0.$) {
		var revealed = _v0.a;
		return revealed.messages;
	} else {
		return $lamdera$containers$SeqDict$empty;
	}
};
var $author$project$Pages$Guild$revealedChannelSpoilers = F2($author$project$Pages$Guild$revealedChannelSpoilers$);
var $author$project$Pages$Guild$unloadedMessageView = function (index) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$paddingXY$(8, 8),
				$author$project$Ui$background($author$project$MyUi$alertColor),
				$author$project$Ui$Font$italic
			]),
		$author$project$Ui$text(
			'Something went wrong when loading message ' + $elm$core$String$fromInt(index)));
};
var $author$project$Pages$Guild$discordConversationViewHelper$ = function (lastViewedIndex, currentDiscordUserId, guildOrDmIdNoThread, maybeUrlMessageId, channel, loggedIn, local, model) {
	var revealedSpoilers = $author$project$Pages$Guild$revealedChannelSpoilers$(
		$author$project$Id$DiscordGuildOrDmId(guildOrDmIdNoThread),
		loggedIn);
	var othersEditing = $lamdera$containers$SeqSet$fromList(
		$elm$core$List$filterMap$(
			function (a) {
				var _v14 = a.threadRoute;
				if (!_v14.$) {
					var maybeMessageId = _v14.a;
					return $ianmackenzie$elm_units$Quantity$lessThan$(
						$ianmackenzie$elm_units$Duration$seconds(3),
						$ianmackenzie$elm_units$Duration$from$(a.time, model.time)) ? maybeMessageId : $elm$core$Maybe$Nothing;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			$lamdera$containers$SeqDict$values(
				$lamdera$containers$SeqDict$remove$(
					currentDiscordUserId,
					$author$project$LocalState$discordTypingIn$(guildOrDmIdNoThread, local)))));
	var isSelectingAnchor = $author$project$Pages$Guild$drawingIsSelectingAnchor$(loggedIn, model);
	var isMobile = $author$project$MyUi$isMobile(model);
	var guildOrDmId = _Utils_Tuple2(
		$author$project$Id$DiscordGuildOrDmId(guildOrDmIdNoThread),
		$author$project$Id$NoThread);
	var maybeEditing = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.editMessage);
	var replyToIndex = $elm$core$Maybe$andThen$(
		$author$project$Message$replyToMaybe,
		$lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.replyTo));
	var containerWidth = $author$project$Pages$Guild$conversationWidth(model);
	return $author$project$Pages$Guild$prependUnreadDivider$(
		lastViewedIndex,
		channel.visibleMessages.oldest,
		$author$project$MessageArray$foldr$(
			F3(
				function (messageId, maybeMessage, _v0) {
					var maybeLastDate = _v0.a;
					var list = _v0.b;
					var index = $author$project$Id$toInt(messageId);
					if (!maybeMessage.$) {
						var message = maybeMessage.a;
						var threadRoute2 = $author$project$Id$NoThreadWithMessage(messageId);
						var threadId = $author$project$Id$fromInt(index);
						var otherUserIsEditing = $lamdera$containers$SeqSet$member$(
							$author$project$Id$changeType(messageId),
							othersEditing);
						var messageHover2 = $author$project$Pages$Guild$messageHover$(
							$author$project$Id$DiscordGuildOrDmId(guildOrDmIdNoThread),
							threadRoute2,
							loggedIn,
							model);
						var maybeRepliedTo2 = $author$project$Pages$Guild$maybeRepliedTo$(message, channel);
						var isEditing = function () {
							if (!maybeEditing.$) {
								var editing = maybeEditing.a;
								return _Utils_eq(editing.messageIndex, messageId) ? $elm$core$Maybe$Just(editing) : $elm$core$Maybe$Nothing;
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}();
						var highlight = _Utils_eq(
							maybeUrlMessageId,
							$elm$core$Maybe$Just(messageId)) ? 3 : (_Utils_eq(
							replyToIndex,
							$elm$core$Maybe$Just(messageId)) ? 1 : 0);
						var date = $justinmimbs$date$Date$fromPosix$(
							local.localUser.timezone,
							$author$project$Message$createdAt(message));
						return _Utils_Tuple2(
							$elm$core$Maybe$Just(date),
							function (keyedMessage) {
								return A2(
									$elm$core$List$cons,
									keyedMessage,
									_Utils_ap(
										$elm$core$List$map$(
											$elm$core$Tuple$mapSecond(
												$author$project$Ui$map(
													A2(
														$author$project$Types$MessageViewMsg,
														$author$project$Id$DiscordGuildOrDmId(guildOrDmIdNoThread),
														threadRoute2))),
											$author$project$Pages$Guild$newMessageLine$(
												$author$project$User$discordUserColor(local.localUser),
												isSelectingAnchor,
												channel.dateDividerDrawings,
												maybeLastDate,
												date,
												lastViewedIndex,
												index,
												messageId)),
										list));
							}(
								_Utils_Tuple2(
									$elm$core$String$fromInt(index),
									function () {
										if (!isEditing.$) {
											var edit = isEditing.a;
											var channels = $author$project$LocalState$discordChannelMentions$(guildOrDmIdNoThread, local);
											if ($author$project$MyUi$isMobile(model)) {
												return A2(
													$author$project$Ui$map,
													A2(
														$author$project$Types$MessageViewMsg,
														$author$project$Id$DiscordGuildOrDmId(guildOrDmIdNoThread),
														threadRoute2),
													$author$project$Pages$Guild$discordMessageView$(
														model.time,
														isMobile,
														containerWidth,
														false,
														revealedSpoilers,
														highlight,
														messageHover2,
														currentDiscordUserId,
														$author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(local.localUser.discordUsers),
														channels,
														local.localUser,
														maybeRepliedTo2,
														$lamdera$containers$SeqDict$get$(threadId, channel.threads),
														messageId,
														message));
											} else {
												var allUsers = $author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(local.localUser.discordUsers);
												var editRichText = function () {
													var _v3 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(edit.text);
													if (!_v3.$) {
														var nonempty = _v3.a;
														return $elm$core$Maybe$Just(
															$author$project$RichText$fromNonemptyString$(local.localUser.timezone, allUsers, channels, nonempty));
													} else {
														return $elm$core$Maybe$Nothing;
													}
												}();
												return $author$project$Pages$Guild$messageEditingView$(
													containerWidth,
													model.time,
													isMobile,
													guildOrDmId,
													threadRoute2,
													message,
													maybeRepliedTo2,
													$lamdera$containers$SeqDict$get$(threadId, channel.threads),
													revealedSpoilers,
													$author$project$RichText$discordCharsLeft$($author$project$OneToOne$empty, editRichText),
													edit,
													editRichText,
													loggedIn,
													$lamdera$containers$SeqDict$empty,
													currentDiscordUserId,
													allUsers,
													channels,
													local);
											}
										} else {
											var _v4 = $lamdera$containers$SeqDict$get$(threadId, channel.threads);
											if (_v4.$ === 1) {
												var _v5 = _Utils_Tuple2(
													maybeRepliedTo2,
													$author$project$Message$mentionsChannel(message) || $author$project$Pages$Guild$repliedToMentionsChannel(maybeRepliedTo2));
												if (_v5.a.$ === 1) {
													if (!_v5.b) {
														var _v6 = _v5.a;
														return A2(
															$author$project$Ui$map,
															A2(
																$author$project$Types$MessageViewMsg,
																$author$project$Id$DiscordGuildOrDmId(guildOrDmIdNoThread),
																threadRoute2),
															$author$project$Ui$Lazy$lazy6$(
																$author$project$Pages$Guild$discordMessageViewNotThreadStarter,
																$author$project$Pages$Guild$encodeMessageView$(isMobile, messageHover2, containerWidth, otherUserIsEditing, highlight, model.time),
																revealedSpoilers,
																currentDiscordUserId,
																local.localUser,
																index,
																message));
													} else {
														var _v7 = _v5.a;
														return A2(
															$author$project$Ui$map,
															A2(
																$author$project$Types$MessageViewMsg,
																$author$project$Id$DiscordGuildOrDmId(guildOrDmIdNoThread),
																threadRoute2),
															$author$project$Ui$Lazy$lazy6$(
																$author$project$Pages$Guild$discordMessageViewNotThreadStarterWithChannelMention,
																$author$project$Pages$Guild$encodeDiscordMessageViewWithReply$(
																	$author$project$Pages$Guild$encodeMessageView$(isMobile, messageHover2, containerWidth, otherUserIsEditing, highlight, model.time),
																	$author$project$Pages$Guild$encodeMessageIndex$(
																		index,
																		$author$project$Id$fromInt(0))),
																revealedSpoilers,
																currentDiscordUserId,
																local.localUser,
																message,
																function () {
																	if (!guildOrDmIdNoThread.$) {
																		var guildId = guildOrDmIdNoThread.a.guildId;
																		var _v9 = $lamdera$containers$SeqDict$get$(guildId, local.discordGuilds);
																		if (!_v9.$) {
																			var guild = _v9.a;
																			return guild.channels;
																		} else {
																			return $lamdera$containers$SeqDict$empty;
																		}
																	} else {
																		return $lamdera$containers$SeqDict$empty;
																	}
																}()));
													}
												} else {
													if ((!_v5.a.a.$) && (!_v5.b)) {
														var _v10 = _v5.a.a;
														var replyMessageIndex = _v10.a;
														var repliedToMessage = _v10.b;
														return A2(
															$author$project$Ui$map,
															A2(
																$author$project$Types$MessageViewMsg,
																$author$project$Id$DiscordGuildOrDmId(guildOrDmIdNoThread),
																threadRoute2),
															$author$project$Ui$Lazy$lazy6$(
																$author$project$Pages$Guild$discordMessageViewNotThreadStarterWithReply,
																$author$project$Pages$Guild$encodeDiscordMessageViewWithReply$(
																	$author$project$Pages$Guild$encodeMessageView$(isMobile, messageHover2, containerWidth, otherUserIsEditing, highlight, model.time),
																	$author$project$Pages$Guild$encodeMessageIndex$(index, replyMessageIndex)),
																revealedSpoilers,
																currentDiscordUserId,
																local.localUser,
																message,
																repliedToMessage));
													} else {
														return A2(
															$author$project$Ui$map,
															A2(
																$author$project$Types$MessageViewMsg,
																$author$project$Id$DiscordGuildOrDmId(guildOrDmIdNoThread),
																threadRoute2),
															$author$project$Pages$Guild$discordMessageView$(
																model.time,
																isMobile,
																containerWidth,
																false,
																revealedSpoilers,
																highlight,
																messageHover2,
																currentDiscordUserId,
																$author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(local.localUser.discordUsers),
																$author$project$LocalState$discordChannelMentions$(guildOrDmIdNoThread, local),
																local.localUser,
																maybeRepliedTo2,
																$elm$core$Maybe$Nothing,
																messageId,
																message));
													}
												}
											} else {
												var thread = _v4.a;
												var _v11 = _Utils_Tuple2(
													maybeRepliedTo2,
													$author$project$Message$mentionsChannel(message) || $author$project$Pages$Guild$lastThreadMessageMentionsChannel(thread));
												if ((_v11.a.$ === 1) && (!_v11.b)) {
													var _v12 = _v11.a;
													return A2(
														$author$project$Ui$map,
														A2(
															$author$project$Types$MessageViewMsg,
															$author$project$Id$DiscordGuildOrDmId(guildOrDmIdNoThread),
															threadRoute2),
														$author$project$Pages$Guild$discordMessageViewThreadStarter$(
															$author$project$Pages$Guild$encodeMessageView$(isMobile, messageHover2, containerWidth, otherUserIsEditing, highlight, model.time),
															revealedSpoilers,
															currentDiscordUserId,
															local.localUser,
															index,
															thread,
															message));
												} else {
													return A2(
														$author$project$Ui$map,
														A2(
															$author$project$Types$MessageViewMsg,
															$author$project$Id$DiscordGuildOrDmId(guildOrDmIdNoThread),
															threadRoute2),
														$author$project$Pages$Guild$discordMessageView$(
															model.time,
															isMobile,
															containerWidth,
															false,
															revealedSpoilers,
															highlight,
															messageHover2,
															currentDiscordUserId,
															$author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(local.localUser.discordUsers),
															$author$project$LocalState$discordChannelMentions$(guildOrDmIdNoThread, local),
															local.localUser,
															maybeRepliedTo2,
															$elm$core$Maybe$Just(thread),
															messageId,
															message));
												}
											}
										}
									}())));
					} else {
						return _Utils_Tuple2(
							maybeLastDate,
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									$elm$core$String$fromInt(index),
									$author$project$Pages$Guild$unloadedMessageView(index)),
								list));
					}
				}),
			_Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil),
			$author$project$VisibleMessages$slice(channel)).b);
};
var $author$project$Pages$Guild$discordConversationViewHelper = F8($author$project$Pages$Guild$discordConversationViewHelper$);
var $author$project$Drawing$PointerMoved$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Drawing$PointerMoved = F2($author$project$Drawing$PointerMoved$);
var $author$project$Drawing$PointerUp = {$: 2};
var $author$project$Drawing$PointerDown$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Drawing$PointerDown = F2($author$project$Drawing$PointerDown$);
var $author$project$Drawing$boolFieldWithDefault = function (fieldName) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$field, fieldName, $elm$json$Json$Decode$bool),
				$elm$json$Json$Decode$succeed(true)
			]));
};
var $author$project$Drawing$decodePointerPosition = function (toMsg) {
	return A3(
		$elm$json$Json$Decode$map2,
		toMsg,
		A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float),
		A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float));
};
var $author$project$Drawing$decodePointerDown = A2(
	$elm$json$Json$Decode$andThen,
	function (_v0) {
		var buttonValue = _v0.a;
		var isPrimary = _v0.b;
		return ((!buttonValue) && isPrimary) ? $author$project$Drawing$decodePointerPosition($author$project$Drawing$PointerDown) : $elm$json$Json$Decode$fail('Only the primary pointer\u0027s primary button draws');
	},
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$Tuple$pair,
		A2($elm$json$Json$Decode$field, 'button', $elm$json$Json$Decode$int),
		$author$project$Drawing$boolFieldWithDefault('isPrimary')));
var $author$project$Drawing$inputOverlayId = $lamdera$program_test$Effect$Browser$Dom$id('drawing_inputOverlay');
var $author$project$Drawing$inputOverlay$ = function (strokeActive, toMsg) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$height($author$project$Ui$fill)
			]),
		$author$project$Ui$html(
			A2(
				$elm$html$Html$map,
				toMsg,
				A2(
					$elm$html$Html$div,
					_Utils_ap(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id(
								$lamdera$program_test$Effect$Browser$Dom$idToString($author$project$Drawing$inputOverlayId)),
								A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
								A2($elm$html$Html$Attributes$style, 'left', '0'),
								A2($elm$html$Html$Attributes$style, 'top', '0'),
								A2($elm$html$Html$Attributes$style, 'width', '100%'),
								A2($elm$html$Html$Attributes$style, 'height', '100%'),
								A2($elm$html$Html$Attributes$style, 'cursor', 'crosshair'),
								A2($elm$html$Html$Attributes$style, 'touch-action', 'none'),
								A2($elm$html$Html$Attributes$style, 'user-select', 'none'),
								A2($elm$html$Html$Attributes$style, '-webkit-user-select', 'none'),
								$elm$html$Html$Events$on$('pointerdown', $author$project$Drawing$decodePointerDown)
							]),
						strokeActive ? _List_fromArray(
							[
								$elm$html$Html$Events$on$(
								'pointermove',
								$author$project$Drawing$decodePointerPosition($author$project$Drawing$PointerMoved)),
								$elm$html$Html$Events$on$(
								'pointerup',
								$elm$json$Json$Decode$succeed($author$project$Drawing$PointerUp)),
								$elm$html$Html$Events$on$(
								'pointercancel',
								$elm$json$Json$Decode$succeed($author$project$Drawing$PointerUp)),
								$elm$html$Html$Events$on$(
								'pointerleave',
								$elm$json$Json$Decode$succeed($author$project$Drawing$PointerUp))
							]) : _List_Nil),
					_List_Nil))));
};
var $author$project$Drawing$inputOverlay = F2($author$project$Drawing$inputOverlay$);
var $author$project$Pages$Guild$drawingModeAttributes$ = function (route, drawingMode) {
	if (_Utils_eq(
		$author$project$Route$toChannelHeaderTab(route),
		$elm$core$Maybe$Just($author$project$UserSession$ChannelHeaderTab_Draw))) {
		if (!drawingMode.$) {
			return _List_Nil;
		} else {
			var selected = drawingMode.a;
			return A2(
				$elm$core$List$cons,
				$author$project$Ui$inFront(
					$author$project$Drawing$inputOverlay$(
						!_Utils_eq(selected.stroke, $elm$core$Maybe$Nothing),
						$author$project$Types$DrawingMsg)),
				(selected.zoom !== 1) ? _List_fromArray(
					[$author$project$Ui$clip]) : _List_Nil);
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Pages$Guild$drawingModeAttributes = F2($author$project$Pages$Guild$drawingModeAttributes$);
var $author$project$Pages$Guild$drawingZoomAttributes$ = function (route, drawingMode) {
	var _v0 = _Utils_Tuple2(
		$author$project$Route$toChannelHeaderTab(route),
		drawingMode);
	if (((!_v0.a.$) && (_v0.a.a.$ === 3)) && (_v0.b.$ === 1)) {
		var _v1 = _v0.a.a;
		var selected = _v0.b.a;
		var _v2 = _Utils_Tuple2(
			selected.zoom !== 1,
			$author$project$Drawing$zoomCssOrigin(selected));
		if (_v2.a && (!_v2.b.$)) {
			var _v3 = _v2.b.a;
			var originX = _v3.a;
			var originY = _v3.b;
			return _List_fromArray(
				[
					$author$project$MyUi$htmlStyle$(
					'transform',
					'scale(' + ($elm$core$String$fromFloat(selected.zoom) + ')')),
					$author$project$MyUi$htmlStyle$(
					'transform-origin',
					$elm$core$String$fromFloat(originX) + ('px ' + ($elm$core$String$fromFloat(originY) + 'px')))
				]);
		} else {
			return _List_Nil;
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Pages$Guild$drawingZoomAttributes = F2($author$project$Pages$Guild$drawingZoomAttributes$);
var $author$project$Types$EmojiSelectorMsg = function (a) {
	return {$: 45, a: a};
};
var $author$project$Pages$Guild$emojiSelectorPaddingX = 4;
var $author$project$Pages$Guild$emojiSelectorX$ = function (isMobile, model) {
	return isMobile ? ($author$project$Coord$xRaw(model.windowSize) - ($author$project$Pages$Guild$emojiSelectorPaddingX * 2)) : (($author$project$Coord$xRaw(model.windowSize) - $author$project$MyUi$channelAndGuildColumnWidth(model.windowSize)) - ($author$project$Pages$Guild$emojiSelectorPaddingX * 2));
};
var $author$project$Pages$Guild$emojiSelectorX = F2($author$project$Pages$Guild$emojiSelectorX$);
var $author$project$Pages$Guild$emojiSelectorZIndex = $author$project$MyUi$htmlStyle$('z-index', '30');
var $author$project$Emoji$maxSelectorHeight = 500;
var $author$project$Emoji$CustomEmojiCategory = {$: 2};
var $author$project$Emoji$NoOp = {$: 10};
var $author$project$Emoji$PressedContainer = {$: 0};
var $author$project$Emoji$StickerCategory = {$: 1};
var $author$project$MyUi$blockClickPropagation = function (msg) {
	return $author$project$Ui$Events$stopPropagationOn$(
		'click',
		$elm$json$Json$Decode$succeed(
			_Utils_Tuple2(msg, true)));
};
var $author$project$MyUi$blockTouchEndPropagation = function (msg) {
	return $author$project$Ui$Events$stopPropagationOn$(
		'touchend',
		$elm$json$Json$Decode$succeed(
			_Utils_Tuple2(msg, true)));
};
var $author$project$Emoji$PressedCategory$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Emoji$PressedCategory = F2($author$project$Emoji$PressedCategory$);
var $author$project$Emoji$emojiCategoryToString = function (emojiCategory) {
	switch (emojiCategory) {
		case 0:
			return 'Activities';
		case 1:
			return 'Animals & Nature';
		case 2:
			return 'Component';
		case 3:
			return 'Flags';
		case 4:
			return 'Food & Drink';
		case 5:
			return 'Objects';
		case 6:
			return 'People & Body';
		case 7:
			return 'Smileys & Emotion';
		case 8:
			return 'Symbols';
		default:
			return 'Travel & Places';
	}
};
var $author$project$Emoji$categoryToString = function (category) {
	switch (category.$) {
		case 0:
			var emojiCategory = category.a;
			return $author$project$Emoji$emojiCategoryToString(emojiCategory);
		case 1:
			return 'Stickers';
		default:
			return 'Custom emojis';
	}
};
var $author$project$Emoji$categoryButtonId = function (category) {
	return $lamdera$program_test$Effect$Browser$Dom$id(
		'emoji_category_' + $author$project$Emoji$categoryToString(category));
};
var $author$project$Emoji$categoryColumnWidth = 40;
var $author$project$Emoji$tabsSpriteName = 'tabs';
var $author$project$Emoji$categoryToEmojiString$ = function (skinTone, category) {
	switch (category.$) {
		case 0:
			var emojiCategory = category.a;
			switch (emojiCategory) {
				case 0:
					return $author$project$Ui$html(
						$author$project$Twemoji$spriteView$('1em', $author$project$Emoji$tabsSpriteName, '🎉'));
				case 1:
					return $author$project$Ui$html(
						$author$project$Twemoji$spriteView$('1em', $author$project$Emoji$tabsSpriteName, '🐟'));
				case 2:
					return $author$project$Ui$text('C');
				case 3:
					return $author$project$Ui$html(
						$author$project$Twemoji$spriteView$('1em', $author$project$Emoji$tabsSpriteName, '🚩'));
				case 4:
					return $author$project$Ui$html(
						$author$project$Twemoji$spriteView$('1em', $author$project$Emoji$tabsSpriteName, '🥦'));
				case 5:
					return $author$project$Ui$html(
						$author$project$Twemoji$spriteView$('1em', $author$project$Emoji$tabsSpriteName, '🔬'));
				case 6:
					return $author$project$Ui$html(
						$author$project$Twemoji$spriteView$(
							'1em',
							$author$project$Emoji$tabsSpriteName,
							function () {
								if (skinTone.$ === 1) {
									return '👍';
								} else {
									switch (skinTone.a) {
										case 0:
											var _v3 = skinTone.a;
											return '👍🏻';
										case 1:
											var _v4 = skinTone.a;
											return '👍🏼';
										case 2:
											var _v5 = skinTone.a;
											return '👍🏽';
										case 3:
											var _v6 = skinTone.a;
											return '👍🏾';
										default:
											var _v7 = skinTone.a;
											return '👍🏿';
									}
								}
							}()));
				case 7:
					return $author$project$Ui$html(
						$author$project$Twemoji$spriteView$('1em', $author$project$Emoji$tabsSpriteName, '🙂'));
				case 8:
					return $author$project$Ui$html(
						$author$project$Twemoji$spriteView$('1em', $author$project$Emoji$tabsSpriteName, '⬇️'));
				default:
					return $author$project$Ui$html(
						$author$project$Twemoji$spriteView$('1em', $author$project$Emoji$tabsSpriteName, '🚆'));
			}
		case 1:
			return $author$project$Ui$text('S');
		default:
			return $author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$inFront(
						$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$move(
									{x: 8, y: 2, z: 0}),
									$author$project$Ui$Font$color($author$project$MyUi$white),
									$author$project$Ui$Font$bold,
									$author$project$Ui$Shadow$font(
									{
										blur: 2,
										color: $author$project$MyUi$black,
										offset: _Utils_Tuple2(0, 0)
									})
								]),
							$author$project$Ui$text('+'))),
						$author$project$Ui$centerX
					]),
				$author$project$Ui$html(
					$author$project$Twemoji$spriteView$('1em', $author$project$Emoji$tabsSpriteName, '🙂')));
	}
};
var $author$project$Emoji$categoryToEmojiString = F2($author$project$Emoji$categoryToEmojiString$);
var $author$project$Emoji$overscrollContain = $author$project$MyUi$htmlStyle$('overscroll-behavior', 'contain');
var $author$project$Emoji$categoryColumn$ = function (skinTone, selectedCategory, offsets) {
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$width(
				$author$project$Ui$px($author$project$Emoji$categoryColumnWidth)),
				$author$project$Ui$scrollable,
				$author$project$Emoji$overscrollContain,
				$author$project$Ui$height($author$project$Ui$fill)
			]),
		$elm$core$List$map$(
			function (_v0) {
				var category = _v0.a;
				var offset = _v0.b;
				return $author$project$MyUi$elButton$(
					$author$project$Emoji$categoryButtonId(category),
					$author$project$Emoji$PressedCategory$(category, offset),
					_List_fromArray(
						[
							$author$project$Ui$height(
							$author$project$Ui$px($author$project$Emoji$categoryColumnWidth)),
							$author$project$Ui$contentCenterX,
							$author$project$Ui$contentCenterY,
							$author$project$Ui$Font$size(24),
							$author$project$MyUi$noShrinking,
							$author$project$MyUi$hoverText(
							$author$project$Emoji$categoryToString(category)),
							$author$project$Ui$attrIf$(
							_Utils_eq(
								$elm$core$Maybe$Just(category),
								selectedCategory),
							$author$project$Ui$background($author$project$MyUi$background3))
						]),
					$author$project$Emoji$categoryToEmojiString$(skinTone, category));
			},
			offsets));
};
var $author$project$Emoji$categoryColumn = F3($author$project$Emoji$categoryColumn$);
var $author$project$Emoji$emojiHeight = 40;
var $author$project$Emoji$categorySectionBodyHeight$ = function (columns, itemCount) {
	return ((((itemCount + columns) - 1) / columns) | 0) * $author$project$Emoji$emojiHeight;
};
var $author$project$Emoji$categorySectionBodyHeight = F2($author$project$Emoji$categorySectionBodyHeight$);
var $author$project$Emoji$categoryTitleHeight = 24;
var $author$project$Emoji$categorySectionHeight$ = function (columns, itemCount) {
	return $author$project$Emoji$categoryTitleHeight + $author$project$Emoji$categorySectionBodyHeight$(columns, itemCount);
};
var $author$project$Emoji$categorySectionHeight = F2($author$project$Emoji$categorySectionHeight$);
var $author$project$Emoji$categoryOffsets$ = function (columns, recentEmojis, categories) {
	var offsets = $elm$core$List$reverse(
		$elm$core$List$foldl$(
			F2(
				function (_v2, _v3) {
					var category = _v2.a;
					var items = _v2.b;
					var offset = _v3.a;
					var list = _v3.b;
					return _Utils_Tuple2(
						offset + $author$project$Emoji$categorySectionHeight$(
							columns,
							$elm$core$List$length(items)),
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(category, offset),
							list));
				}),
			_Utils_Tuple2(
				$elm$core$List$isEmpty(recentEmojis) ? 0 : $author$project$Emoji$categorySectionHeight$(
					columns,
					$elm$core$List$length(recentEmojis)),
				_List_Nil),
			categories).b);
	if (offsets.b) {
		var _v1 = offsets.a;
		var firstCategory = _v1.a;
		var rest = offsets.b;
		return A2(
			$elm$core$List$cons,
			_Utils_Tuple2(firstCategory, 0),
			rest);
	} else {
		return _List_Nil;
	}
};
var $author$project$Emoji$categoryOffsets = F3($author$project$Emoji$categoryOffsets$);
var $author$project$Ui$clipX = $author$project$Internal$Model2$classWith$($author$project$Internal$Flag$overflow, $author$project$Internal$Style2$classes.clipX);
var $author$project$Emoji$ScrolledToCategory = function (a) {
	return {$: 2, a: a};
};
var $author$project$Emoji$categoryAtScrollPosition$ = function (scrollTop, offsets) {
	return $elm$core$List$foldl$(
		F2(
			function (_v0, current) {
				var category = _v0.a;
				var offset = _v0.b;
				return (_Utils_cmp(offset, scrollTop) < 1) ? $elm$core$Maybe$Just(category) : current;
			}),
		$elm$core$Maybe$Nothing,
		offsets);
};
var $author$project$Emoji$categoryAtScrollPosition = F2($author$project$Emoji$categoryAtScrollPosition$);
var $author$project$Emoji$decodeScroll$ = function (currentCategory, offsets) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (scrollTop) {
			var _v0 = $author$project$Emoji$categoryAtScrollPosition$(
				$elm$core$Basics$round(scrollTop),
				offsets);
			if (!_v0.$) {
				var category = _v0.a;
				return _Utils_eq(category, currentCategory) ? $elm$json$Json$Decode$fail('') : $elm$json$Json$Decode$succeed(
					$author$project$Emoji$ScrolledToCategory(category));
			} else {
				return $elm$json$Json$Decode$fail('');
			}
		},
		$elm$json$Json$Decode$at$(
			_List_fromArray(
				['target', 'scrollTop']),
			$elm$json$Json$Decode$float));
};
var $author$project$Emoji$decodeScroll = F2($author$project$Emoji$decodeScroll$);
var $author$project$Emoji$MouseEnteredEmoji$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$Emoji$MouseEnteredEmoji = F2($author$project$Emoji$MouseEnteredEmoji$);
var $author$project$Emoji$PressedSelectEmoji = function (a) {
	return {$: 3, a: a};
};
var $author$project$Emoji$emojiWidth = 40;
var $author$project$Emoji$emojiButtonHelper$ = function (index, item, model, content) {
	return $author$project$MyUi$elButton$(
		$author$project$Emoji$emojiButtonId(index),
		$author$project$Emoji$PressedSelectEmoji(item),
		_List_fromArray(
			[
				$author$project$Ui$Events$onMouseEnter(
				$author$project$Emoji$MouseEnteredEmoji$(index, item)),
				$author$project$Ui$attrIf$(
				_Utils_eq(
					$elm$core$Maybe$map$(
						function ($) {
							return $.index;
						},
						model.emojiHovered),
					$elm$core$Maybe$Just(index)),
				$author$project$Ui$background($author$project$MyUi$hoverHighlight)),
				$author$project$Ui$contentCenterX,
				$author$project$Ui$contentCenterY,
				$author$project$Ui$width(
				$author$project$Ui$px($author$project$Emoji$emojiWidth)),
				$author$project$Ui$height(
				$author$project$Ui$px($author$project$Emoji$emojiHeight)),
				$author$project$Ui$heightMin(0)
			]),
		content);
};
var $author$project$Emoji$emojiButtonHelper = F4($author$project$Emoji$emojiButtonHelper$);
var $author$project$Emoji$emojiCategoryContainer$ = function (title, content) {
	return $author$project$Ui$column$(
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Font$size(16),
						$author$project$Ui$height(
						$author$project$Ui$px($author$project$Emoji$categoryTitleHeight)),
						$author$project$Ui$heightMin(0),
						$author$project$Ui$contentCenterY,
						$author$project$Ui$Font$color($author$project$MyUi$font3),
						$author$project$Ui$paddingXY$(8, 0)
					]),
				$author$project$Ui$text(title)),
				$author$project$Ui$row$(
				_List_fromArray(
					[$author$project$Ui$wrap]),
				content)
			]));
};
var $author$project$Emoji$emojiCategoryContainer = F2($author$project$Emoji$emojiCategoryContainer$);
var $author$project$Emoji$stickerWidth = $author$project$Emoji$emojiWidth * 2;
var $author$project$Emoji$unicodeEmojiView$ = function (size, maybeSkinTone, emoji, emojiData) {
	return $author$project$Emoji$sequenceView$(
		size,
		emojiData,
		$author$project$Emoji$emojiWithSkinTone$(maybeSkinTone, emoji, emojiData));
};
var $author$project$Emoji$unicodeEmojiView = F4($author$project$Emoji$unicodeEmojiView$);
var $author$project$Emoji$emojiHoverPreview$ = function (stickersData, customEmojisData, userData, emojiData2, model) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$contentCenterY,
				$author$project$Ui$spacing(8),
				$author$project$Ui$alignBottom,
				$author$project$Ui$background($author$project$MyUi$background2),
				$author$project$Ui$paddingXY$(4, 0)
			]),
		function () {
			var _v0 = $elm$core$Maybe$map$(
				function ($) {
					return $.emoji;
				},
				model.emojiHovered);
			if (!_v0.$) {
				switch (_v0.a.$) {
					case 0:
						var emoji = _v0.a.a;
						return A2(
							$elm$core$List$cons,
							$author$project$Ui$html(
								$author$project$Emoji$unicodeEmojiView$('1em', userData.skinTone, emoji, emojiData2)),
							function () {
								var _v1 = $lamdera$containers$SeqDict$get$(emoji, emojiData2.emojis);
								if (!_v1.$) {
									var emoji2 = _v1.a;
									return $elm$core$List$map$(
										function (name) {
											return $author$project$Ui$el$(
												_List_fromArray(
													[
														$author$project$Ui$Font$size(16),
														$author$project$Ui$width($author$project$Ui$shrink)
													]),
												$author$project$Ui$text(':' + (name + ':')));
										},
										emoji2.shortNames);
								} else {
									return _List_Nil;
								}
							}());
					case 1:
						var stickerId = _v0.a.a;
						var _v2 = $lamdera$containers$SeqDict$get$(stickerId, stickersData);
						if (!_v2.$) {
							var sticker = _v2.a;
							return _List_fromArray(
								[
									$author$project$Ui$html(
									$author$project$Sticker$view$(
										$elm$core$String$fromInt($author$project$Emoji$stickerWidth) + 'px',
										stickerId,
										stickersData,
										2)),
									$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$Font$size(16),
											$author$project$Ui$width($author$project$Ui$shrink)
										]),
									$author$project$Ui$text(':' + (sticker.name + ':')))
								]);
						} else {
							return _List_Nil;
						}
					default:
						var customEmojiId = _v0.a.a;
						var _v3 = $lamdera$containers$SeqDict$get$(customEmojiId, customEmojisData);
						if (!_v3.$) {
							var sticker = _v3.a;
							return _List_fromArray(
								[
									$author$project$Ui$html(
									$author$project$CustomEmoji$view$(
										$elm$core$String$fromInt($author$project$Emoji$emojiWidth) + 'px',
										'0',
										customEmojiId,
										customEmojisData,
										2)),
									$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$Font$size(16),
											$author$project$Ui$width($author$project$Ui$shrink)
										]),
									$author$project$Ui$text(
										':' + ($author$project$CustomEmoji$emojiNameToString(sticker.name) + ':')))
								]);
						} else {
							return _List_Nil;
						}
				}
			} else {
				return _List_Nil;
			}
		}());
};
var $author$project$Emoji$emojiHoverPreview = F5($author$project$Emoji$emojiHoverPreview$);
var $author$project$Emoji$filterBySearch$ = function (query, toNames, list) {
	return (query === '') ? list : $elm$core$List$filter$(
		function (item) {
			return $elm$core$List$any$(
				function (name) {
					return A2(
						$elm$core$String$contains,
						query,
						A2(
							$elm$core$String$filter,
							$elm$core$Char$isAlphaNum,
							$elm$core$String$toLower(name)));
				},
				toNames(item));
		},
		list);
};
var $author$project$Emoji$filterBySearch = F3($author$project$Emoji$filterBySearch$);
var $author$project$Emoji$keepFocusOnMouseDown = $elm$html$Html$Events$preventDefaultOn$(
	'mousedown',
	A2(
		$elm$json$Json$Decode$andThen,
		function (tagName) {
			return ((tagName === 'INPUT') || ((tagName === 'SELECT') || (tagName === 'OPTION'))) ? $elm$json$Json$Decode$fail('Let this take focus') : $elm$json$Json$Decode$succeed(
				_Utils_Tuple2($author$project$Emoji$NoOp, true));
		},
		$elm$json$Json$Decode$at$(
			_List_fromArray(
				['target', 'tagName']),
			$elm$json$Json$Decode$string)));
var $author$project$Emoji$maxSelectorWidth = 620;
var $author$project$Emoji$PressedClearSearch = {$: 9};
var $author$project$Emoji$TypedSearchText = function (a) {
	return {$: 8, a: a};
};
var $author$project$Emoji$ClearEmojiHover = {$: 7};
var $author$project$Emoji$KeyboardMovedHover$ = function (a, b) {
	return {$: 6, a: a, b: b};
};
var $author$project$Emoji$KeyboardMovedHover = F2($author$project$Emoji$KeyboardMovedHover$);
var $author$project$Emoji$categoryRanges = function (categories) {
	return $elm$core$List$reverse(
		$elm$core$List$foldl$(
			F2(
				function (category, _v0) {
					var start = _v0.a;
					var list = _v0.b;
					return _Utils_Tuple2(
						start + $elm$core$List$length(category),
						$elm$core$List$isEmpty(category) ? list : A2(
							$elm$core$List$cons,
							{
								count: $elm$core$List$length(category),
								start: start
							},
							list));
				}),
			_Utils_Tuple2(0, _List_Nil),
			categories).b);
};
var $author$project$Emoji$moveDown$ = function (columns, index, categories) {
	moveDown:
	while (true) {
		if (categories.b) {
			var current = categories.a;
			var rest = categories.b;
			if (_Utils_cmp(index, current.start + current.count) < 0) {
				var local = index - current.start;
				var lastLocal = current.count - 1;
				if (_Utils_cmp(local + columns, lastLocal) < 1) {
					return $elm$core$Maybe$Just(index + columns);
				} else {
					if (_Utils_cmp((local / columns) | 0, (lastLocal / columns) | 0) < 0) {
						return $elm$core$Maybe$Just(current.start + lastLocal);
					} else {
						if (rest.b) {
							var next = rest.a;
							return $elm$core$Maybe$Just(
								next.start + $elm$core$Basics$min$(
									A2($elm$core$Basics$modBy, columns, local),
									next.count - 1));
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}
				}
			} else {
				var $temp$categories = rest;
				categories = $temp$categories;
				continue moveDown;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$Emoji$moveDown = F3($author$project$Emoji$moveDown$);
var $author$project$Emoji$moveUp$ = function (columns, index, previous, categories) {
	moveUp:
	while (true) {
		if (categories.b) {
			var current = categories.a;
			var rest = categories.b;
			if (_Utils_cmp(index, current.start + current.count) < 0) {
				var column = A2($elm$core$Basics$modBy, columns, index - current.start);
				if (_Utils_cmp(index - current.start, columns) > -1) {
					return $elm$core$Maybe$Just(index - columns);
				} else {
					if (!previous.$) {
						var previous2 = previous.a;
						var lastRowStart = (((previous2.count - 1) / columns) | 0) * columns;
						return $elm$core$Maybe$Just(
							previous2.start + $elm$core$Basics$min$(lastRowStart + column, previous2.count - 1));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}
			} else {
				var $temp$previous = $elm$core$Maybe$Just(current),
					$temp$categories = rest;
				previous = $temp$previous;
				categories = $temp$categories;
				continue moveUp;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$Emoji$moveUp = F4($author$project$Emoji$moveUp$);
var $author$project$Emoji$decodeArrowKey$ = function (model, categories, columns) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (key) {
			var ranges = $author$project$Emoji$categoryRanges(categories);
			var items = $elm$core$Array$fromList(
				$elm$core$List$concat(categories));
			var moveTo = function (newIndex) {
				var _v9 = $elm$core$Array$get$(newIndex, items);
				if (!_v9.$) {
					var item = _v9.a;
					return $elm$json$Json$Decode$succeed(
						_Utils_Tuple2(
							$author$project$Emoji$KeyboardMovedHover$(newIndex, item),
							true));
				} else {
					return $elm$json$Json$Decode$fail('');
				}
			};
			var currentIndex = $elm$core$Maybe$map$(
				function ($) {
					return $.index;
				},
				model.emojiHovered);
			var count = $elm$core$Array$length(items);
			switch (key) {
				case 'ArrowLeft':
					if (!currentIndex.$) {
						var index = currentIndex.a;
						return moveTo(
							$elm$core$Basics$clamp$(0, count - 1, index - 1));
					} else {
						return $elm$json$Json$Decode$succeed(
							_Utils_Tuple2($author$project$Emoji$NoOp, false));
					}
				case 'ArrowRight':
					if (!currentIndex.$) {
						var index = currentIndex.a;
						return moveTo(
							$elm$core$Basics$clamp$(0, count - 1, index + 1));
					} else {
						return $elm$json$Json$Decode$succeed(
							_Utils_Tuple2($author$project$Emoji$NoOp, false));
					}
				case 'ArrowUp':
					if (!currentIndex.$) {
						var index = currentIndex.a;
						var _v4 = $author$project$Emoji$moveUp$(columns, index, $elm$core$Maybe$Nothing, ranges);
						if (!_v4.$) {
							var newIndex = _v4.a;
							return moveTo(newIndex);
						} else {
							return $elm$json$Json$Decode$succeed(
								_Utils_Tuple2($author$project$Emoji$ClearEmojiHover, true));
						}
					} else {
						return $elm$json$Json$Decode$succeed(
							_Utils_Tuple2($author$project$Emoji$NoOp, false));
					}
				case 'ArrowDown':
					if (!currentIndex.$) {
						var index = currentIndex.a;
						var _v6 = $author$project$Emoji$moveDown$(columns, index, ranges);
						if (!_v6.$) {
							var newIndex = _v6.a;
							return moveTo(newIndex);
						} else {
							return $elm$json$Json$Decode$succeed(
								_Utils_Tuple2($author$project$Emoji$NoOp, true));
						}
					} else {
						return moveTo(0);
					}
				case 'Enter':
					var _v7 = model.emojiHovered;
					if (!_v7.$) {
						var hovered = _v7.a;
						return $elm$json$Json$Decode$succeed(
							_Utils_Tuple2(
								$author$project$Emoji$PressedSelectEmoji(hovered.emoji),
								true));
					} else {
						var _v8 = $elm$core$Array$get$(0, items);
						if (!_v8.$) {
							var first = _v8.a;
							return $elm$json$Json$Decode$succeed(
								_Utils_Tuple2(
									$author$project$Emoji$PressedSelectEmoji(first),
									true));
						} else {
							return $elm$json$Json$Decode$succeed(
								_Utils_Tuple2($author$project$Emoji$NoOp, false));
						}
					}
				default:
					return $elm$json$Json$Decode$succeed(
						_Utils_Tuple2($author$project$Emoji$NoOp, false));
			}
		},
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
};
var $author$project$Emoji$decodeArrowKey = F3($author$project$Emoji$decodeArrowKey$);
var $author$project$Emoji$searchInputHeight = 40;
var $author$project$Emoji$PressedSkinTone = function (a) {
	return {$: 4, a: a};
};
var $author$project$Emoji$skinToneFromId = function (text) {
	switch (text) {
		case '1':
			return $elm$core$Maybe$Just(0);
		case '2':
			return $elm$core$Maybe$Just(1);
		case '3':
			return $elm$core$Maybe$Just(2);
		case '4':
			return $elm$core$Maybe$Just(3);
		case '5':
			return $elm$core$Maybe$Just(4);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Emoji$skinToneSelectorId = $lamdera$program_test$Effect$Browser$Dom$id('guild_skinToneSelector');
var $author$project$Emoji$skinToneToId = function (skinTone) {
	if (skinTone.$ === 1) {
		return 'default';
	} else {
		switch (skinTone.a) {
			case 0:
				var _v1 = skinTone.a;
				return '1';
			case 1:
				var _v2 = skinTone.a;
				return '2';
			case 2:
				var _v3 = skinTone.a;
				return '3';
			case 3:
				var _v4 = skinTone.a;
				return '4';
			default:
				var _v5 = skinTone.a;
				return '5';
		}
	}
};
var $author$project$Emoji$skinToneView = function (selectedSkinTone) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$width($author$project$Ui$shrink),
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$MyUi$noShrinking
			]),
		$author$project$Ui$html(
			A2(
				$elm$html$Html$select,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id(
						$lamdera$program_test$Effect$Browser$Dom$idToString($author$project$Emoji$skinToneSelectorId)),
						$elm$html$Html$Attributes$value(
						$author$project$Emoji$skinToneToId(selectedSkinTone)),
						$elm$html$Html$Events$onInput(
						function (text) {
							return $author$project$Emoji$PressedSkinTone(
								$author$project$Emoji$skinToneFromId(text));
						}),
						A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Skin tone'),
						$elm$html$Html$Attributes$title('Skin tone'),
						A2($elm$html$Html$Attributes$style, 'height', '100%'),
						A2(
						$elm$html$Html$Attributes$style,
						'border',
						'1px solid ' + $author$project$MyUi$colorToStyle($author$project$MyUi$inputBorder)),
						A2($elm$html$Html$Attributes$style, 'border-radius', '4px'),
						A2($elm$html$Html$Attributes$style, 'padding', '0 4px'),
						A2($elm$html$Html$Attributes$style, 'font-size', '20px'),
						A2(
						$elm$html$Html$Attributes$style,
						'background-color',
						$author$project$MyUi$colorToStyle($author$project$MyUi$background3)),
						A2(
						$elm$html$Html$Attributes$style,
						'color',
						$author$project$MyUi$colorToStyle($author$project$MyUi$white)),
						A2($elm$html$Html$Attributes$style, 'cursor', 'pointer')
					]),
				$elm$core$List$map$(
					function (skinTone) {
						var text = function () {
							if (skinTone.$ === 1) {
								return '👍';
							} else {
								var skinTone2 = skinTone.a;
								return '👍' + $author$project$Emoji$skinToneToString(skinTone2);
							}
						}();
						return A2(
							$elm$html$Html$option,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value(
									$author$project$Emoji$skinToneToId(skinTone)),
									$elm$html$Html$Attributes$selected(
									_Utils_eq(skinTone, selectedSkinTone))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(text)
								]));
					},
					A2(
						$elm$core$List$cons,
						$elm$core$Maybe$Nothing,
						$elm$core$List$map$($elm$core$Maybe$Just, $author$project$Emoji$allSkinTones))))));
};
var $author$project$Emoji$searchInput$ = function (model, skinTone, categories, columns) {
	var isSearching = model.searchText !== '';
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$Font$size(16),
				$author$project$Ui$paddingXY$(8, 4),
				$author$project$Ui$spacing(8),
				$author$project$Ui$height(
				$author$project$Ui$px($author$project$Emoji$searchInputHeight))
			]),
		_List_fromArray(
			[
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$border(1),
						$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
						$author$project$Ui$rounded(4),
						$author$project$Ui$clip,
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$inFront(
						isSearching ? $author$project$Ui$none : $author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$centerY,
									$author$project$Ui$paddingXY$(8, 0),
									$author$project$Ui$Font$color($author$project$MyUi$font3),
									$author$project$MyUi$noPointerEvents
								]),
							$author$project$Ui$text('Search by name')))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Input$text,
						_List_fromArray(
							[
								isSearching ? $author$project$Ui$background($author$project$MyUi$background3) : $author$project$Ui$background($author$project$MyUi$background2),
								$author$project$Ui$border(0),
								$author$project$Ui$height($author$project$Ui$fill),
								$author$project$Ui$paddingXY$(8, 8),
								$author$project$Ui$width($author$project$Ui$fill),
								$author$project$Ui$id(
								$lamdera$program_test$Effect$Browser$Dom$idToString($author$project$Emoji$searchInputId)),
								$author$project$Ui$htmlAttribute(
								$elm$html$Html$Events$preventDefaultOn$(
									'keydown',
									$author$project$Emoji$decodeArrowKey$(model, categories, columns)))
							]),
						{
							label: $author$project$Ui$Input$labelHidden(
								$lamdera$program_test$Effect$Browser$Dom$idToString($author$project$Emoji$searchInputId)),
							onChange: $author$project$Emoji$TypedSearchText,
							placeholder: $elm$core$Maybe$Nothing,
							text: model.searchText
						}),
						isSearching ? $author$project$MyUi$elButton$(
						$lamdera$program_test$Effect$Browser$Dom$id('emoji_clearSearch'),
						$author$project$Emoji$PressedClearSearch,
						_List_fromArray(
							[
								$author$project$Ui$width(
								$author$project$Ui$px(40)),
								$author$project$Ui$background($author$project$MyUi$background3),
								$author$project$Ui$height($author$project$Ui$fill),
								$author$project$Ui$contentCenterX,
								$author$project$Ui$contentCenterY,
								$author$project$MyUi$hoverText('Clear search')
							]),
						$author$project$Ui$html($author$project$Icons$x)) : $author$project$Ui$none
					])),
				$author$project$Emoji$skinToneView(skinTone)
			]));
};
var $author$project$Emoji$searchInput = F4($author$project$Emoji$searchInput$);
var $author$project$Emoji$maxScrollViewportHeight = $author$project$Emoji$maxSelectorHeight - $author$project$Emoji$searchInputHeight;
var $author$project$Emoji$visibleRange$ = function (contentHeight, selectedCategory, offsets) {
	visibleRange:
	while (true) {
		if (offsets.b) {
			var _v1 = offsets.a;
			var category = _v1.a;
			var offset = _v1.b;
			var rest = offsets.b;
			if (_Utils_eq(
				$elm$core$Maybe$Just(category),
				selectedCategory)) {
				return {
					from: offset,
					to: function () {
						if (rest.b) {
							var _v3 = rest.a;
							var nextOffset = _v3.b;
							return nextOffset;
						} else {
							return contentHeight;
						}
					}() + $author$project$Emoji$maxScrollViewportHeight
				};
			} else {
				var $temp$offsets = rest;
				offsets = $temp$offsets;
				continue visibleRange;
			}
		} else {
			return {from: 0, to: $author$project$Emoji$maxScrollViewportHeight};
		}
	}
};
var $author$project$Emoji$visibleRange = F3($author$project$Emoji$visibleRange$);
var $author$project$Emoji$selector$ = function (isMobile, scrollbarWidth, width, model, userData, emojiData, availableCustomEmojis, customEmojisData, availableStickers, stickersData) {
	if (!emojiData.$) {
		var emojiData2 = emojiData.a;
		var selectorWidth = $elm$core$Basics$min$($author$project$Emoji$maxSelectorWidth, width);
		var query = A2(
			$elm$core$String$filter,
			$elm$core$Char$isAlphaNum,
			$elm$core$String$toLower(model.searchText));
		var itemNames = function (item) {
			switch (item.$) {
				case 0:
					var emoji = item.a;
					var _v9 = $lamdera$containers$SeqDict$get$(emoji, emojiData2.emojis);
					if (!_v9.$) {
						var emojiData3 = _v9.a;
						return emojiData3.shortNames;
					} else {
						return _List_Nil;
					}
				case 1:
					var stickerId = item.a;
					var _v10 = $lamdera$containers$SeqDict$get$(stickerId, stickersData);
					if (!_v10.$) {
						var sticker = _v10.a;
						return _List_fromArray(
							[sticker.name]);
					} else {
						return _List_Nil;
					}
				default:
					var customEmojiId = item.a;
					var _v11 = $lamdera$containers$SeqDict$get$(customEmojiId, customEmojisData);
					if (!_v11.$) {
						var customEmoji = _v11.a;
						return _List_fromArray(
							[
								$author$project$CustomEmoji$emojiNameToString(customEmoji.name)
							]);
					} else {
						return _List_Nil;
					}
			}
		};
		var recentEmojis = $author$project$Emoji$filterBySearch$(
			query,
			itemNames,
			$elm$core$List$reverse(
				$elm$core$List$foldl$(
					F2(
						function (emoji, list) {
							return $elm$core$List$member$(emoji, list) ? list : A2($elm$core$List$cons, emoji, list);
						}),
					_List_Nil,
					$elm$core$List$filterMap$(
						function (emoji) {
							if (!emoji.$) {
								var emoji2 = emoji.a;
								return $elm$core$Maybe$Just(
									$author$project$Emoji$EmojiOrSticker_UnicodeEmoji(emoji2));
							} else {
								var customEmojiId = emoji.a;
								return $lamdera$containers$SeqSet$member$(customEmojiId, availableCustomEmojis) ? $elm$core$Maybe$Just(
									$author$project$Emoji$EmojiOrSticker_CustomEmoji(customEmojiId)) : $elm$core$Maybe$Nothing;
							}
						},
						$elm$core$List$reverse(
							$elm$core$Array$toList(userData.lastUsedEmojis))))));
		var columns = $elm$core$Basics$max$(1, (((selectorWidth - $author$project$Emoji$categoryColumnWidth) - scrollbarWidth) / $author$project$Emoji$emojiWidth) | 0);
		var categories = $elm$core$List$filterMap$(
			function (category) {
				var items = $author$project$Emoji$filterBySearch$(
					query,
					itemNames,
					function () {
						switch (category.$) {
							case 0:
								var emojiCategory = category.a;
								return $elm$core$List$map$(
									$author$project$Emoji$EmojiOrSticker_UnicodeEmoji,
									$elm$core$Maybe$withDefault$(
										_List_Nil,
										$lamdera$containers$SeqDict$get$(emojiCategory, emojiData2.categories)));
							case 1:
								return $elm$core$List$map$(
									$author$project$Emoji$EmojiOrSticker_Sticker,
									$lamdera$containers$SeqSet$toList(availableStickers));
							default:
								return $elm$core$List$map$(
									$author$project$Emoji$EmojiOrSticker_CustomEmoji,
									$lamdera$containers$SeqSet$toList(availableCustomEmojis));
						}
					}());
				if (!items.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(category, items));
				}
			},
			_Utils_ap(
				$elm$core$List$filterMap$(
					function (emojiCategory) {
						if (emojiCategory === 2) {
							return $elm$core$Maybe$Nothing;
						} else {
							return $elm$core$Maybe$Just(
								$author$project$Emoji$EmojiCategory(emojiCategory));
						}
					},
					$author$project$Emoji$allEmojiCategories),
				_List_fromArray(
					[$author$project$Emoji$StickerCategory, $author$project$Emoji$CustomEmojiCategory])));
		var offsets = $author$project$Emoji$categoryOffsets$(columns, recentEmojis, categories);
		var selectedCategory = $elm$core$List$any$(
			function (_v3) {
				var category = _v3.a;
				return _Utils_eq(category, model.category);
			},
			offsets) ? $elm$core$Maybe$Just(model.category) : $elm$core$Maybe$map$(
			$elm$core$Tuple$first,
			$elm$core$List$head(offsets));
		var sections = _Utils_ap(
			$elm$core$List$isEmpty(recentEmojis) ? _List_Nil : _List_fromArray(
				[
					{items: recentEmojis, title: 'Recently used'}
				]),
			$elm$core$List$map$(
				function (_v2) {
					var category = _v2.a;
					var items = _v2.b;
					return {
						items: items,
						title: $author$project$Emoji$categoryToString(category)
					};
				},
				categories));
		var contentHeight = $elm$core$List$foldl$(
			F2(
				function (section, total) {
					return total + $author$project$Emoji$categorySectionHeight$(
						columns,
						$elm$core$List$length(section.items));
				}),
			0,
			sections);
		var onScreen = $author$project$Emoji$visibleRange$(contentHeight, selectedCategory, offsets);
		var emojis = $elm$core$List$reverse(
			$elm$core$List$foldl$(
				F2(
					function (section, state) {
						var itemCount = $elm$core$List$length(section.items);
						var height = $author$project$Emoji$categorySectionHeight$(columns, itemCount);
						return {
							itemOffset: state.itemOffset + itemCount,
							sections: A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									section.items,
									$author$project$Emoji$emojiCategoryContainer$(
										section.title,
										((_Utils_cmp(state.top, onScreen.to) < 0) && (_Utils_cmp(state.top + height, onScreen.from) > 0)) ? $elm$core$List$indexedMap$(
											F2(
												function (index, item) {
													return $author$project$Emoji$emojiButtonHelper$(
														state.itemOffset + index,
														item,
														model,
														function () {
															switch (item.$) {
																case 0:
																	var emoji = item.a;
																	return $author$project$Ui$el$(
																		_List_fromArray(
																			[
																				$author$project$Ui$width(
																				$author$project$Ui$px($author$project$Emoji$emojiWidth)),
																				$author$project$Ui$contentCenterX
																			]),
																		$author$project$Ui$html(
																			$author$project$Emoji$unicodeEmojiView$('1em', userData.skinTone, emoji, emojiData2)));
																case 1:
																	var stickerId = item.a;
																	return $author$project$Ui$html(
																		$author$project$Sticker$view$(
																			$elm$core$String$fromInt($author$project$Emoji$emojiWidth) + 'px',
																			stickerId,
																			stickersData,
																			2));
																default:
																	var customEmojiId = item.a;
																	return $author$project$Ui$html(
																		$author$project$CustomEmoji$view$(
																			$elm$core$String$fromInt($author$project$Emoji$emojiWidth) + 'px',
																			'0',
																			customEmojiId,
																			customEmojisData,
																			2));
															}
														}());
												}),
											section.items) : _List_fromArray(
											[
												$author$project$Ui$el$(
												_List_fromArray(
													[
														$author$project$Ui$height(
														$author$project$Ui$px(
															$author$project$Emoji$categorySectionBodyHeight$(columns, itemCount)))
													]),
												$author$project$Ui$none)
											]))),
								state.sections),
							top: state.top + height
						};
					}),
				{itemOffset: 0, sections: _List_Nil, top: 0},
				sections).sections);
		var emojiContent = $author$project$Ui$row$(
			_List_fromArray(
				[
					$author$project$Ui$height($author$project$Ui$fill),
					$author$project$Ui$heightMin(0),
					$author$project$MyUi$htmlStyle$('flex-basis', '0')
				]),
			_List_fromArray(
				[
					$author$project$Emoji$categoryColumn$(userData.skinTone, selectedCategory, offsets),
					$author$project$Ui$column$(
					_List_fromArray(
						[
							$author$project$Ui$height($author$project$Ui$fill),
							$author$project$Ui$inFront(
							$author$project$Emoji$emojiHoverPreview$(stickersData, customEmojisData, userData, emojiData2, model))
						]),
					_List_fromArray(
						[
							$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$background($author$project$MyUi$background3),
									$author$project$Ui$scrollable,
									$author$project$Emoji$overscrollContain,
									$author$project$Ui$clipX,
									$author$project$Ui$height($author$project$Ui$fill),
									$author$project$Ui$heightMin(0),
									$author$project$Ui$id(
									$lamdera$program_test$Effect$Browser$Dom$idToString($author$project$Emoji$scrollContainerId)),
									$author$project$Ui$htmlAttribute(
									$elm$html$Html$Events$on$(
										'scroll',
										$author$project$Emoji$decodeScroll$(model.category, offsets)))
								]),
							$author$project$Ui$column$(
								_List_fromArray(
									[
										$author$project$Ui$width(
										$author$project$Ui$px(columns * $author$project$Emoji$emojiWidth)),
										$author$project$Ui$paddingWith(
										{bottom: $author$project$Emoji$stickerWidth, left: 0, right: 0, top: 0})
									]),
								$elm$core$List$map$($elm$core$Tuple$second, emojis)))
						]))
				]));
		var searchInput2 = $author$project$Emoji$searchInput$(
			model,
			userData.skinTone,
			$elm$core$List$map$($elm$core$Tuple$first, emojis),
			columns);
		return $author$project$Ui$column$(
			_List_fromArray(
				[
					$author$project$Ui$width(
					$author$project$Ui$px(selectorWidth)),
					$author$project$Ui$height($author$project$Ui$fill),
					$author$project$Ui$background($author$project$MyUi$background2),
					$author$project$Ui$border(1),
					$author$project$Ui$borderColor($author$project$MyUi$highlightedBorder),
					$author$project$Ui$rounded(8),
					$author$project$Ui$Font$size(32),
					$author$project$MyUi$blockClickPropagation($author$project$Emoji$PressedContainer),
					$author$project$Ui$htmlAttribute($author$project$Emoji$keepFocusOnMouseDown),
					$author$project$Ui$heightMin(0),
					$author$project$Ui$clip,
					$author$project$MyUi$blockTouchStartPropagation($author$project$Emoji$NoOp),
					$author$project$MyUi$blockTouchEndPropagation($author$project$Emoji$NoOp)
				]),
			isMobile ? _List_fromArray(
				[emojiContent, searchInput2]) : _List_fromArray(
				[searchInput2, emojiContent]));
	} else {
		return $author$project$Ui$text('Emojis didn\u0027t load for some reason');
	}
};
var $author$project$Emoji$selector = function (isMobile) {
	return function (scrollbarWidth) {
		return function (width) {
			return function (model) {
				return function (userData) {
					return function (emojiData) {
						return function (availableCustomEmojis) {
							return function (customEmojisData) {
								return function (availableStickers) {
									return function (stickersData) {
										return $author$project$Emoji$selector$(isMobile, scrollbarWidth, width, model, userData, emojiData, availableCustomEmojis, customEmojisData, availableStickers, stickersData);
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Guild$emojiSelectorAtBottomOfTheConversation$ = function (isMobile, availableCustomEmojis, availableStickers, local, loggedIn, model) {
	return $author$project$Ui$inFront(
		A2(
			$author$project$Ui$map,
			$author$project$Types$EmojiSelectorMsg,
			$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$heightMin(0),
						$author$project$Ui$contentBottom,
						$author$project$Ui$paddingWith(
						{
							bottom: 0,
							left: $author$project$Pages$Guild$emojiSelectorPaddingX,
							right: $author$project$Pages$Guild$emojiSelectorPaddingX,
							top: $elm$core$Basics$max$(0, ((model.visualViewportTop + $author$project$Pages$Guild$emojiSelectorPaddingX) - $author$project$MyUi$channelHeaderHeight) - 1)
						}),
						isMobile ? $author$project$Ui$width($author$project$Ui$fill) : $author$project$Ui$width($author$project$Ui$shrink),
						$author$project$MyUi$noPointerEvents,
						$author$project$Pages$Guild$emojiSelectorZIndex
					]),
				$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$height($author$project$Ui$fill),
							$author$project$Ui$heightMin(0),
							$author$project$Ui$heightMax($author$project$Emoji$maxSelectorHeight),
							$author$project$MyUi$htmlStyle$('pointer-events', 'auto')
						]),
					$author$project$Emoji$selector$(
						isMobile,
						model.startupData.scrollbarWidth,
						$author$project$Pages$Guild$emojiSelectorX$(isMobile, model),
						loggedIn.emojiSelector,
						local.localUser.user.emojiConfig,
						model.emojiData,
						availableCustomEmojis,
						local.localUser.customEmojis,
						availableStickers,
						local.localUser.stickers)))));
};
var $author$project$Pages$Guild$emojiSelectorAtBottomOfTheConversation = F6($author$project$Pages$Guild$emojiSelectorAtBottomOfTheConversation$);
var $author$project$Emoji$selectorHeight = function (availableHeight) {
	return $elm$core$Basics$min$(availableHeight, $author$project$Emoji$maxSelectorHeight);
};
var $author$project$Pages$Guild$emojiSelector$ = function (isMobile, availableCustomEmojis, availableStickers, local, loggedIn, model) {
	var emojiConfig = local.localUser.user.emojiConfig;
	var availableHeight = (model.visualViewportHeight - 54) - model.startupData.safeAreaInsetTop;
	var _v0 = loggedIn.showEmojiSelector;
	switch (_v0.$) {
		case 0:
			return $author$project$Ui$noAttr;
		case 1:
			return $author$project$Pages$Guild$emojiSelectorAtBottomOfTheConversation$(isMobile, availableCustomEmojis, availableStickers, local, loggedIn, model);
		case 5:
			return $author$project$Pages$Guild$emojiSelectorAtBottomOfTheConversation$(isMobile, availableCustomEmojis, availableStickers, local, loggedIn, model);
		case 6:
			return $author$project$Pages$Guild$emojiSelectorAtBottomOfTheConversation$(isMobile, availableCustomEmojis, availableStickers, local, loggedIn, model);
		case 2:
			return $author$project$Pages$Guild$emojiSelectorAtBottomOfTheConversation$(isMobile, availableCustomEmojis, availableStickers, local, loggedIn, model);
		case 3:
			var position = _v0.a;
			var y = ($author$project$Coord$yRaw(position) - $author$project$Emoji$selectorHeight(availableHeight)) - $author$project$MyUi$channelHeaderHeight;
			return $author$project$Ui$inFront(
				A2(
					$author$project$Ui$map,
					$author$project$Types$EmojiSelectorMsg,
					$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$($author$project$Pages$Guild$emojiSelectorPaddingX, 0),
								$author$project$Ui$height(
								$author$project$Ui$px(
									$author$project$Emoji$selectorHeight(availableHeight))),
								$author$project$Ui$move(
								{
									x: 0,
									y: (y < 0) ? $author$project$Coord$yRaw(position) : y,
									z: 0
								}),
								$author$project$Pages$Guild$emojiSelectorZIndex
							]),
						$author$project$Emoji$selector$(
							isMobile,
							model.startupData.scrollbarWidth,
							$author$project$Pages$Guild$emojiSelectorX$(isMobile, model),
							loggedIn.emojiSelector,
							emojiConfig,
							model.emojiData,
							availableCustomEmojis,
							local.localUser.customEmojis,
							availableStickers,
							local.localUser.stickers))));
		default:
			var position = _v0.b;
			var y = $elm$core$Basics$max$(
				0,
				$elm$core$Basics$min$(
					($author$project$Coord$yRaw(model.windowSize) - $author$project$MyUi$channelHeaderHeight) - $author$project$Emoji$selectorHeight(availableHeight),
					$author$project$Coord$yRaw(position) - $author$project$MyUi$channelHeaderHeight));
			return $author$project$Ui$inFront(
				A2(
					$author$project$Ui$map,
					$author$project$Types$EmojiSelectorMsg,
					$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$($author$project$Pages$Guild$emojiSelectorPaddingX, 0),
								$author$project$Ui$height(
								$author$project$Ui$px(
									$author$project$Emoji$selectorHeight(availableHeight))),
								$author$project$Ui$move(
								{x: 0, y: y, z: 0}),
								$author$project$Pages$Guild$emojiSelectorZIndex
							]),
						$author$project$Emoji$selector$(
							isMobile,
							model.startupData.scrollbarWidth,
							$author$project$Pages$Guild$emojiSelectorX$(isMobile, model),
							loggedIn.emojiSelector,
							emojiConfig,
							model.emojiData,
							availableCustomEmojis,
							local.localUser.customEmojis,
							availableStickers,
							local.localUser.stickers))));
	}
};
var $author$project$Pages$Guild$emojiSelector = F6($author$project$Pages$Guild$emojiSelector$);
var $author$project$Types$PressedNewMessagesWarning = {$: 165};
var $author$project$Pages$Guild$newMessagesId = $lamdera$program_test$Effect$Browser$Dom$id('guild_newMessages');
var $author$project$Pages$Guild$newMessagesView$ = function (model, loggedIn, channel) {
	var button = function (text) {
		return $author$project$MyUi$elButton$(
			$author$project$Pages$Guild$newMessagesId,
			$author$project$Types$PressedNewMessagesWarning,
			_List_fromArray(
				[
					$author$project$Ui$Font$color($author$project$MyUi$font1),
					$author$project$Ui$background($author$project$MyUi$buttonBackground),
					$author$project$Ui$paddingXY$(12, 8),
					$author$project$Ui$roundedWith(
					{bottomLeft: 0, bottomRight: 0, topLeft: 8, topRight: 8}),
					$author$project$Ui$borderWith(
					{bottom: 0, left: 1, right: 1, top: 1}),
					$author$project$Ui$borderColor($author$project$MyUi$buttonBorder),
					$author$project$Ui$pointer,
					$author$project$MyUi$hover$(
					$author$project$MyUi$isMobile(model),
					_List_fromArray(
						[
							$author$project$Ui$Anim$backgroundColor($author$project$MyUi$highlightedBorder)
						]))
				]),
			$author$project$Ui$Prose$paragraph$(
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$text(text)
					])));
	};
	return (loggedIn.newMessagesWhileNotScrolledToBottom === 1) ? button('1 new message. Click here to jump to the bottom.') : ((loggedIn.newMessagesWhileNotScrolledToBottom > 1) ? button(
		$elm$core$String$fromInt(loggedIn.newMessagesWhileNotScrolledToBottom) + ' new messages. Click here to jump to the bottom.') : (($author$project$VisibleMessages$reachesEnd$(
		$author$project$MessageArray$length(channel.messages),
		channel.visibleMessages) || (!channel.visibleMessages.count)) ? $author$project$Ui$none : button('Click here to return to most recent messages')));
};
var $author$project$Pages$Guild$newMessagesView = F3($author$project$Pages$Guild$newMessagesView$);
var $author$project$MyUi$virtualKeyboardOpen = function (model) {
	return ($author$project$Coord$yRaw(model.windowSize) - model.visualViewportHeight) > 100;
};
var $author$project$Pages$Guild$peopleAreTypingView$ = function (allUsers, threadRoute, typing, currentUserId, model) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$Font$bold,
				$author$project$Ui$Font$size(13),
				$author$project$Ui$Font$color($author$project$MyUi$font3),
				$author$project$MyUi$prewrap,
				$author$project$MyUi$noShrinking,
				$author$project$Ui$contentCenterY,
				$author$project$MyUi$htmlStyle$('user-select', 'none'),
				$author$project$Ui$paddingWith(
				{
					bottom: $author$project$MyUi$virtualKeyboardOpen(model) ? 0 : model.startupData.safeAreaInsetBottom,
					left: 12 + ((model.startupData.safeAreaInsetBottom / 2) | 0),
					right: 12 + ((model.startupData.safeAreaInsetBottom / 2) | 0),
					top: 0
				})
			]),
		$author$project$Ui$text(
			function () {
				var _v0 = $lamdera$containers$SeqDict$keys(
					$lamdera$containers$SeqDict$filter$(
						F2(
							function (_v1, a) {
								return $ianmackenzie$elm_units$Quantity$lessThan$(
									$ianmackenzie$elm_units$Quantity$plus$($ianmackenzie$elm_units$Duration$second, $author$project$Pages$Guild$typingDebouncerDelay),
									$ianmackenzie$elm_units$Duration$from$(a.time, model.time)) && _Utils_eq(
									a.threadRoute,
									$author$project$Id$threadRouteWithNoMessage(threadRoute));
							}),
						$lamdera$containers$SeqDict$remove$(currentUserId, typing)));
				if (!_v0.b) {
					return ' ';
				} else {
					if (!_v0.b.b) {
						var single = _v0.a;
						return $author$project$User$toString$(single, allUsers) + ' is typing...';
					} else {
						if (!_v0.b.b.b) {
							var one = _v0.a;
							var _v2 = _v0.b;
							var two = _v2.a;
							return $author$project$User$toString$(one, allUsers) + (' and ' + ($author$project$User$toString$(two, allUsers) + ' are typing...'));
						} else {
							if (!_v0.b.b.b.b) {
								var one = _v0.a;
								var _v3 = _v0.b;
								var two = _v3.a;
								var _v4 = _v3.b;
								var three = _v4.a;
								return $author$project$User$toString$(one, allUsers) + (', ' + ($author$project$User$toString$(two, allUsers) + (', and ' + ($author$project$User$toString$(three, allUsers) + ' are typing...'))));
							} else {
								var _v5 = _v0.b;
								var _v6 = _v5.b;
								return 'Several people are typing...';
							}
						}
					}
				}
			}()));
};
var $author$project$Pages$Guild$peopleAreTypingView = F5($author$project$Pages$Guild$peopleAreTypingView$);
var $author$project$Types$PressedCloseReplyTo = function (a) {
	return {$: 48, a: a};
};
var $author$project$Pages$Guild$replyToHeaderId = $lamdera$program_test$Effect$Browser$Dom$id('guild_replyToHeader');
var $author$project$Pages$Guild$replyToHeaderRow$ = function (isMobile, onPress, content) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$paddingWith($author$project$MessageInput$textareaPadding),
				$author$project$Ui$move(
				{x: 0, y: 1, z: 0})
			]),
		$author$project$Ui$row$(
			_List_fromArray(
				[
					$author$project$Ui$id(
					$lamdera$program_test$Effect$Browser$Dom$idToString($author$project$Pages$Guild$replyToHeaderId)),
					$author$project$Ui$Font$color($author$project$MyUi$font2),
					$author$project$Ui$background($author$project$MyUi$background2),
					$author$project$Ui$paddingWith(
					{bottom: 8, left: 12, right: 32, top: 8}),
					$author$project$Ui$roundedWith(
					{bottomLeft: 0, bottomRight: 0, topLeft: 8, topRight: 8}),
					$author$project$Ui$borderWith(
					{bottom: 0, left: 1, right: 1, top: 1}),
					$author$project$Ui$borderColor($author$project$MyUi$border1),
					$author$project$Ui$spacing(5),
					$author$project$Ui$inFront(
					$author$project$MyUi$elButton$(
						$lamdera$program_test$Effect$Browser$Dom$id('guild_closeReplyToHeader'),
						onPress,
						_List_fromArray(
							[
								$author$project$Ui$width(
								$author$project$Ui$px(32)),
								$author$project$Ui$paddingXY$(4, 0),
								$author$project$Ui$height($author$project$Ui$fill),
								$author$project$Ui$contentCenterY,
								$author$project$Ui$alignRight,
								$author$project$MyUi$hoverText('Cancel reply')
							]),
						$author$project$Ui$html($author$project$Icons$x)))
				]),
			A2(
				$elm$core$List$cons,
				isMobile ? $author$project$Ui$none : $author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$width($author$project$Ui$shrink),
							$author$project$Ui$move(
							{x: 0, y: 2, z: 0})
						]),
					$author$project$Ui$html(
						$author$project$Icons$reply(18))),
				content)));
};
var $author$project$Pages$Guild$replyToHeaderRow = F3($author$project$Pages$Guild$replyToHeaderRow$);
var $author$project$Pages$Guild$replyToHeaderHelper$ = function (isMobile, onPress, userId, allUsers) {
	return $author$project$Pages$Guild$replyToHeaderRow$(
		isMobile,
		onPress,
		_List_fromArray(
			[
				$author$project$Ui$text('Reply to '),
				function () {
				if (!userId.$) {
					var userId2 = userId.a;
					return $author$project$User$toColoredString$(userId2, allUsers);
				} else {
					return $author$project$Ui$text('message');
				}
			}()
			]));
};
var $author$project$Pages$Guild$replyToHeaderHelper = F4($author$project$Pages$Guild$replyToHeaderHelper$);
var $author$project$Pages$Guild$replyToHeader$ = function (isMobile, guildOrDmIdNoThread, replyTo, allUsers, channel) {
	if (!replyTo.$) {
		switch (replyTo.a.$) {
			case 1:
				var messageIndex = replyTo.a.a;
				var _v1 = $author$project$MessageArray$get$(
					$author$project$Id$changeType(messageIndex),
					channel.messages);
				if (!_v1.$) {
					var message = _v1.a;
					switch (message.$) {
						case 0:
							var data = message.a;
							return $author$project$Pages$Guild$replyToHeaderHelper$(
								isMobile,
								$author$project$Types$PressedCloseReplyTo(guildOrDmIdNoThread),
								$elm$core$Maybe$Just(data.createdBy),
								allUsers);
						case 1:
							var data = message.a;
							return $author$project$Pages$Guild$replyToHeaderHelper$(
								isMobile,
								$author$project$Types$PressedCloseReplyTo(guildOrDmIdNoThread),
								$elm$core$Maybe$Just(data.createdBy),
								allUsers);
						case 2:
							var userId = message.b;
							return $author$project$Pages$Guild$replyToHeaderHelper$(
								isMobile,
								$author$project$Types$PressedCloseReplyTo(guildOrDmIdNoThread),
								$elm$core$Maybe$Just(userId),
								allUsers);
						case 3:
							return $author$project$Ui$none;
						case 4:
							var startedBy = message.a.startedBy;
							return $author$project$Pages$Guild$replyToHeaderHelper$(
								isMobile,
								$author$project$Types$PressedCloseReplyTo(guildOrDmIdNoThread),
								$elm$core$Maybe$Just(startedBy),
								allUsers);
						default:
							var startedBy = message.a.startedBy;
							return $author$project$Pages$Guild$replyToHeaderHelper$(
								isMobile,
								$author$project$Types$PressedCloseReplyTo(guildOrDmIdNoThread),
								$elm$core$Maybe$Just(startedBy),
								allUsers);
					}
				} else {
					return $author$project$Ui$none;
				}
			case 2:
				var _v3 = replyTo.a;
				return $author$project$Ui$none;
			default:
				var _v4 = replyTo.a;
				return $author$project$Ui$none;
		}
	} else {
		return $author$project$Ui$none;
	}
};
var $author$project$Pages$Guild$replyToHeader = F5($author$project$Pages$Guild$replyToHeader$);
var $author$project$VisibleMessages$startIsVisible = function (visibleMessages) {
	return ($author$project$Id$toInt(visibleMessages.oldest) <= 0) && (!visibleMessages.loadingMessages);
};
var $author$project$Pages$Guild$discordConversationView$ = function (lastViewedIndex, currentDiscordUserId, guildOrDmIdNoThread, maybeUrlMessageId, loggedIn, model, local, name, channel, availableCustomEmojis, availableStickers) {
	var isMobile = $author$project$MyUi$isMobile(model);
	var guildOrDmId = _Utils_Tuple2(
		$author$project$Id$DiscordGuildOrDmId(guildOrDmIdNoThread),
		$author$project$Id$NoThread);
	var replyTo = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.replyTo);
	var draft = function () {
		var _v10 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.drafts);
		if (!_v10.$) {
			var text = _v10.a;
			return $MartinSStewart$elm_nonempty_string$String$Nonempty$toString(text);
		} else {
			return '';
		}
	}();
	var channels = $author$project$LocalState$discordChannelMentions$(guildOrDmIdNoThread, local);
	var allUsers = $author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(local.localUser.discordUsers);
	var draftRichText = function () {
		var _v9 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.drafts);
		if (!_v9.$) {
			var text = _v9.a;
			return $elm$core$Maybe$Just(
				$author$project$RichText$fromNonemptyString$(local.localUser.timezone, allUsers, channels, text));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$Ui$heightMin(0)
			]),
		_List_fromArray(
			[
				$author$project$ChannelHeader$discordChannel$(isMobile, name, guildOrDmIdNoThread, local, loggedIn, model),
				$author$project$Ui$el$(
				_Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Guild$emojiSelector$(isMobile, availableCustomEmojis, availableStickers, local, loggedIn, model),
							$author$project$Ui$heightMin(0),
							$author$project$Ui$height($author$project$Ui$fill)
						]),
					$author$project$Pages$Guild$drawingModeAttributes$(model.route, loggedIn.drawingMode)),
				$author$project$Ui$Keyed$column$(
					_Utils_ap(
						_List_fromArray(
							[
								$author$project$Ui$height($author$project$Ui$fill),
								$author$project$Ui$width($author$project$Ui$fill),
								$author$project$Ui$paddingWith(
								{bottom: 16, left: 0, right: 0, top: 200}),
								$author$project$MyUi$scrollable(
								$author$project$MyUi$canScroll$(
									$author$project$MyUi$isMobile(model),
									model.drag)),
								$author$project$MyUi$htmlStyle$('overflow-wrap', 'break-word'),
								$author$project$Ui$id(
								$lamdera$program_test$Effect$Browser$Dom$idToString($author$project$Pages$Guild$conversationContainerId)),
								$author$project$Ui$Events$on$(
								'scroll',
								$author$project$Scroll$decodeScrollToBottom$(
									A2(
										$author$project$Types$UserScrolled,
										$author$project$Id$DiscordGuildOrDmId(guildOrDmIdNoThread),
										$author$project$Id$NoThread),
									loggedIn.channelScrollPosition)),
								$author$project$Ui$heightMin(0),
								$author$project$MyUi$bounceScroll(isMobile),
								$author$project$MyUi$htmlStyle$('background-image', 'url(/cacheable/grid1.png)')
							]),
						$author$project$Pages$Guild$drawingZoomAttributes$(model.route, loggedIn.drawingMode)),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'a',
							$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$Font$color($author$project$MyUi$font2),
										$author$project$Ui$paddingXY$(8, 4),
										$author$project$Ui$alignBottom,
										$author$project$Ui$Font$size(20)
									]),
								function () {
									if ($author$project$VisibleMessages$startIsVisible(channel.visibleMessages)) {
										if (!guildOrDmIdNoThread.$) {
											return $author$project$Ui$text('This is the start of #' + name);
										} else {
											var data = guildOrDmIdNoThread.a;
											return $author$project$Ui$text(
												$author$project$ChannelHeader$chattingWithYourself$(data, local) ? 'This is the start of a conversation with yourself' : ('This is the start of your conversation with ' + name));
										}
									} else {
										return $author$project$Ui$none;
									}
								}())),
						$author$project$Pages$Guild$discordConversationViewHelper$(lastViewedIndex, currentDiscordUserId, guildOrDmIdNoThread, maybeUrlMessageId, channel, loggedIn, local, model)))),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$paddingXY$(2, 0),
						$author$project$Ui$heightMin(0),
						$author$project$MyUi$noShrinking,
						function () {
						var _v1 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.filesToUpload);
						if (!_v1.$) {
							var filesToUpload2 = _v1.a;
							return $author$project$Ui$inFront(
								$author$project$Pages$Guild$fileUploadPreview$(
									$author$project$Types$PressedDeleteAttachedFile(guildOrDmId),
									$author$project$Types$PressedViewAttachedFileInfo(guildOrDmId),
									$elm$core$Maybe$Just(
										$author$project$Types$PressedToggleAttachedFileSpoiler(guildOrDmId)),
									draftRichText,
									filesToUpload2));
						} else {
							return $author$project$Ui$noAttr;
						}
					}()
					]),
				_List_fromArray(
					[
						$author$project$Pages$Guild$newMessagesView$(model, loggedIn, channel),
						$author$project$Pages$Guild$replyToHeader$(
						isMobile,
						_Utils_Tuple2(
							$author$project$Id$DiscordGuildOrDmId(guildOrDmIdNoThread),
							$author$project$Id$NoThread),
						replyTo,
						allUsers,
						channel),
						function () {
						var _v2 = _Utils_Tuple2(
							$author$project$LocalState$canSendDiscordMessage$(local, guildOrDmIdNoThread),
							channel.isForum);
						if (!_v2.a.$) {
							if (!_v2.b) {
								return A2(
									$author$project$Ui$map,
									A2(
										$author$project$Types$MessageInputMsg,
										$author$project$Id$DiscordGuildOrDmId(guildOrDmIdNoThread),
										$author$project$Id$NoThread),
									$author$project$MessageInput$view$(
										$lamdera$program_test$Effect$Browser$Dom$id('messageMenu_channelInput'),
										_Utils_eq(replyTo, $elm$core$Maybe$Nothing),
										$author$project$MyUi$isMobile(model),
										$author$project$Pages$Guild$channelTextInputId,
										$author$project$MessageInput$textPlaceholder(
											function () {
												if (!guildOrDmIdNoThread.$) {
													return 'Write a message in #' + name;
												} else {
													var data = guildOrDmIdNoThread.a;
													return 'Write a message to ' + ($author$project$ChannelHeader$chattingWithYourself$(data, local) ? 'yourself' : name);
												}
											}()),
										$author$project$RichText$discordCharsLeft$($author$project$OneToOne$empty, draftRichText),
										draft,
										draftRichText,
										function () {
											var _v4 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.filesToUpload);
											if (!_v4.$) {
												var attachedFiles = _v4.a;
												return $author$project$NonemptyDict$toSeqDict(attachedFiles);
											} else {
												return $lamdera$containers$SeqDict$empty;
											}
										}(),
										local.localUser,
										loggedIn,
										$author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(local.localUser.discordUsers),
										channels));
							} else {
								return $author$project$MessageInput$disabledView$(
									_Utils_eq(replyTo, $elm$core$Maybe$Nothing),
									'Forum channel posting is unsupported',
									function () {
										var _v7 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.drafts);
										if (!_v7.$) {
											var text = _v7.a;
											return $MartinSStewart$elm_nonempty_string$String$Nonempty$toString(text);
										} else {
											return '';
										}
									}(),
									function () {
										var _v8 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.filesToUpload);
										if (!_v8.$) {
											var attachedFiles = _v8.a;
											return $author$project$NonemptyDict$toSeqDict(attachedFiles);
										} else {
											return $lamdera$containers$SeqDict$empty;
										}
									}(),
									local.localUser);
							}
						} else {
							var error = _v2.a.a;
							return $author$project$MessageInput$disabledView$(
								_Utils_eq(replyTo, $elm$core$Maybe$Nothing),
								error,
								function () {
									var _v5 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.drafts);
									if (!_v5.$) {
										var text = _v5.a;
										return $MartinSStewart$elm_nonempty_string$String$Nonempty$toString(text);
									} else {
										return '';
									}
								}(),
								function () {
									var _v6 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.filesToUpload);
									if (!_v6.$) {
										var attachedFiles = _v6.a;
										return $author$project$NonemptyDict$toSeqDict(attachedFiles);
									} else {
										return $lamdera$containers$SeqDict$empty;
									}
								}(),
								local.localUser);
						}
					}(),
						$author$project$Pages$Guild$peopleAreTypingView$(
						allUsers,
						$author$project$Id$NoThread,
						$author$project$LocalState$discordTypingIn$(guildOrDmIdNoThread, local),
						currentDiscordUserId,
						model)
					]))
			]));
};
var $author$project$Pages$Guild$discordConversationView = function (lastViewedIndex) {
	return function (currentDiscordUserId) {
		return function (guildOrDmIdNoThread) {
			return function (maybeUrlMessageId) {
				return function (loggedIn) {
					return function (model) {
						return function (local) {
							return function (name) {
								return function (channel) {
									return function (availableCustomEmojis) {
										return function (availableStickers) {
											return $author$project$Pages$Guild$discordConversationView$(lastViewedIndex, currentDiscordUserId, guildOrDmIdNoThread, maybeUrlMessageId, loggedIn, model, local, name, channel, availableCustomEmojis, availableStickers);
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$User$NotifyOnEveryMessage = 0;
var $author$project$User$NotifyOnMention = 1;
var $author$project$Types$PressedDiscordGuildNotificationLevel$ = function (a, b, c) {
	return {$: 106, a: a, b: b, c: c};
};
var $author$project$Types$PressedDiscordGuildNotificationLevel = F3($author$project$Types$PressedDiscordGuildNotificationLevel$);
var $author$project$Types$PressedMuteDiscordGuild$ = function (a, b, c) {
	return {$: 179, a: a, b: b, c: c};
};
var $author$project$Types$PressedMuteDiscordGuild = F3($author$project$Types$PressedMuteDiscordGuild$);
var $author$project$Pages$Guild$discordGuildSettingsView$ = function (model, currentUserId, guildId, guild, local) {
	var isMobile = $author$project$MyUi$isMobile(model);
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$Ui$Font$color($author$project$MyUi$font1)
			]),
		_List_fromArray(
			[
				$author$project$ChannelHeader$channelHeader$(
				isMobile,
				$author$project$Ui$text('Guild settings'),
				$elm$core$Maybe$Nothing),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(16),
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$heightMin(0),
						$author$project$MyUi$scrollable(
						$author$project$MyUi$canScroll$(isMobile, model.drag)),
						$author$project$Ui$paddingWith(
						{bottom: local.localUser.safeAreaInsetBottom + 16, left: 0, right: 0, top: 16})
					]),
				_List_fromArray(
					[
						$author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$(8, 0)
							]),
						_List_fromArray(
							[
								$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$paddingXY$(8, 0),
										$author$project$Ui$Font$bold
									]),
								$author$project$Ui$text('Owner')),
								$author$project$Pages$Guild$discordMemberLabel$(
								isMobile,
								local.localUser,
								currentUserId,
								$author$project$MembersAndOwner$owner(guild.membersAndOwner))
							])),
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$(16, 0)
							]),
						$author$project$MyUi$radioColumn$(
							$lamdera$program_test$Effect$Browser$Dom$id('guild_discordNotificationLevel'),
							A2($author$project$Types$PressedDiscordGuildNotificationLevel, currentUserId, guildId),
							$lamdera$containers$SeqSet$member$(guildId, local.localUser.user.discordNotifyOnAllMessages) ? $elm$core$Maybe$Just(0) : $elm$core$Maybe$Just(1),
							$author$project$Ui$text('Guild notifications'),
							_List_fromArray(
								[
									_Utils_Tuple2(1, 'Only when mentioned'),
									_Utils_Tuple2(0, 'On every message')
								]))),
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$(16, 0)
							]),
						$author$project$MuteSettings$view$(
							A2($author$project$Types$PressedMuteDiscordGuild, currentUserId, guildId),
							$author$project$MuteSettings$isDiscordGuildSpecificallyMute$(local.localUser.user.muteSettings, guildId)))
					]))
			]));
};
var $author$project$Pages$Guild$discordGuildSettingsView = F5($author$project$Pages$Guild$discordGuildSettingsView$);
var $author$project$ChannelHeader$discordThread$ = function (isMobile, name, guildOrDmIdNoThread, local, loggedIn, model) {
	return $author$project$ChannelHeader$channelHeader$(
		isMobile,
		function () {
			if (guildOrDmIdNoThread.$ === 1) {
				var data = guildOrDmIdNoThread.a;
				return $author$project$ChannelHeader$chattingWithYourself$(data, local) ? $author$project$ChannelHeader$privateChatWithYourself$(
					isMobile,
					model.route,
					false,
					$author$project$Route$toChannelHeaderTab(model.route),
					local) : $author$project$ChannelHeader$discordPrivateChatWith$(
					isMobile,
					model.route,
					$author$project$Route$toChannelHeaderTab(model.route),
					name);
			} else {
				return $author$project$Ui$row$(
					_List_fromArray(
						[
							$author$project$Ui$Font$color($author$project$MyUi$font1),
							$author$project$Ui$spacing(2),
							$author$project$Ui$clipWithEllipsis,
							$author$project$Ui$contentCenterY,
							$author$project$Ui$height($author$project$Ui$fill)
						]),
					_List_fromArray(
						[
							$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$MyUi$noShrinking,
									$author$project$Ui$width($author$project$Ui$shrink)
								]),
							$author$project$Ui$html($author$project$Icons$hashtag)),
							$author$project$Ui$text(name),
							$author$project$Ui$row$(
							_List_fromArray(
								[
									$author$project$MyUi$noShrinking,
									$author$project$Ui$width($author$project$Ui$shrink),
									$author$project$Ui$alignRight,
									$author$project$Ui$height($author$project$Ui$fill)
								]),
							_List_fromArray(
								[
									$author$project$ChannelHeader$drawingTab$(
									isMobile,
									$author$project$Route$toChannelHeaderTab(model.route),
									false),
									$elm$core$Maybe$withDefault$(
									$author$project$Ui$none,
									$author$project$ChannelHeader$channelSettingsTab$(isMobile, model.route))
								]))
						]));
			}
		}(),
		$author$project$ChannelHeader$tabBodyView$(isMobile, local, loggedIn, model));
};
var $author$project$ChannelHeader$discordThread = F6($author$project$ChannelHeader$discordThread$);
var $author$project$Pages$Guild$threadMessageContainer$ = function (containerWidth, highlight, messageIndex, canEdit, currentUserId, currentUser, reactions, availableCustomEmojis, customEmojis, emojiData, allUsers, isHovered, messageContent) {
	var maybeReactions = $author$project$MessageView$reactionEmojiView$(
		emojiData,
		$author$project$Pages$Guild$reactionsHover(isHovered),
		currentUserId,
		customEmojis,
		allUsers,
		$author$project$Pages$Guild$isHoveredToAnimationMode(isHovered),
		containerWidth,
		reactions);
	return $author$project$Ui$column$(
		_Utils_ap(
			_List_fromArray(
				[
					$author$project$Ui$Font$color($author$project$MyUi$font1),
					$author$project$Ui$Events$onMouseEnter($author$project$MessageView$MessageView_MouseEnteredMessage),
					$author$project$Ui$Events$onMouseLeave($author$project$MessageView$MessageView_MouseExitedMessage),
					$author$project$Ui$Events$on$(
					'touchstart',
					A3(
						$elm$json$Json$Decode$map2,
						F2(
							function (toMsg, target) {
								return A3(toMsg, target.imageUrl, target.linkUrl, target.reactionIndex);
							}),
						$author$project$Touch$decodeTouchEvent(
							F5(
								function (time, touches, imageUrl, linkUrl, reactionIndex) {
									return $author$project$MessageView$MessageView_TouchStart$(time, false, imageUrl, linkUrl, reactionIndex, touches);
								})),
						$author$project$Pages$Guild$decodeEventTarget)),
					$author$project$Ui$Events$preventDefaultOn$(
					'contextmenu',
					$author$project$Pages$Guild$decodeMessageContextMenu(false)),
					$author$project$Ui$paddingWith(
					{
						bottom: _Utils_eq(maybeReactions, $elm$core$Maybe$Nothing) ? 8 : 4,
						left: $author$project$Pages$Guild$messagePaddingX,
						right: $author$project$Pages$Guild$messagePaddingX,
						top: 4
					}),
					$author$project$Ui$spacing(4),
					$author$project$Ui$id(
					$lamdera$program_test$Effect$Browser$Dom$idToString(
						$author$project$Pages$Guild$threadMessageHtmlId(messageIndex)))
				]),
			_Utils_ap(
				function () {
					switch (isHovered.$) {
						case 0:
							return _List_fromArray(
								[
									$author$project$Ui$behindContent($author$project$Ui$none)
								]);
						case 1:
							return _List_fromArray(
								[
									$author$project$MyUi$hoverHighlightLayer,
									$author$project$Ui$inFront(
									$author$project$MessageView$miniView$(currentUser, false, canEdit, availableCustomEmojis, emojiData, customEmojis))
								]);
						case 2:
							return _List_fromArray(
								[$author$project$MyUi$hoverHighlightLayer]);
						case 3:
							return _List_fromArray(
								[
									$author$project$MyUi$hoverHighlightLayer,
									$author$project$Ui$inFront(
									$author$project$MessageView$reactionsMiniView$(currentUser, availableCustomEmojis, emojiData, customEmojis))
								]);
						case 4:
							return _List_fromArray(
								[
									$author$project$Ui$behindContent($author$project$Ui$none)
								]);
						default:
							return _List_fromArray(
								[
									$author$project$Ui$behindContent($author$project$Ui$none)
								]);
					}
				}(),
				_List_fromArray(
					[
						$author$project$Pages$Guild$highlightLayer(highlight)
					]))),
		A2(
			$elm$core$List$cons,
			messageContent,
			$elmcraft$core_extra$Maybe$Extra$toList(maybeReactions)));
};
var $author$project$Pages$Guild$threadMessageContainer = function (containerWidth) {
	return function (highlight) {
		return function (messageIndex) {
			return function (canEdit) {
				return function (currentUserId) {
					return function (currentUser) {
						return function (reactions) {
							return function (availableCustomEmojis) {
								return function (customEmojis) {
									return function (emojiData) {
										return function (allUsers) {
											return function (isHovered) {
												return function (messageContent) {
													return $author$project$Pages$Guild$threadMessageContainer$(containerWidth, highlight, messageIndex, canEdit, currentUserId, currentUser, reactions, availableCustomEmojis, customEmojis, emojiData, allUsers, isHovered, messageContent);
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Guild$discordThreadMessageView$ = function (time, isMobile, containerWidth, revealedSpoilers, highlight, isHovered, allUsers, channels, currentUserId, localUser, maybeRepliedTo2, messageId, message) {
	switch (message.$) {
		case 0:
			var message2 = message.a;
			return $author$project$Pages$Guild$threadMessageContainer$(
				containerWidth,
				function () {
					if (!highlight) {
						return $lamdera$containers$SeqSet$member$(
							currentUserId,
							$author$project$RichText$mentionsUser(message2.content.content)) ? 2 : highlight;
					} else {
						return highlight;
					}
				}(),
				messageId,
				_Utils_eq(currentUserId, message2.createdBy),
				currentUserId,
				localUser.user,
				message2.reactions,
				$author$project$Pages$Guild$discordQuickReactionCustomEmojis,
				localUser.customEmojis,
				localUser.emojiData,
				allUsers,
				isHovered,
				$author$project$Pages$Guild$discordUserTextMessageContent$(
					time,
					$lamdera$program_test$Effect$Browser$Dom$id('threadSpoiler'),
					containerWidth,
					isMobile,
					maybeRepliedTo2,
					localUser,
					revealedSpoilers,
					allUsers,
					channels,
					isHovered,
					messageId,
					message2.content,
					message2));
		case 1:
			var message2 = message.a;
			return $author$project$Pages$Guild$threadMessageContainer$(
				containerWidth,
				highlight,
				messageId,
				_Utils_eq(currentUserId, message2.createdBy),
				currentUserId,
				localUser.user,
				message2.reactions,
				$author$project$Pages$Guild$discordQuickReactionCustomEmojis,
				localUser.customEmojis,
				localUser.emojiData,
				allUsers,
				isHovered,
				$author$project$Pages$Guild$discordUserTextMessageContent$(
					time,
					$lamdera$program_test$Effect$Browser$Dom$id('threadSpoiler'),
					containerWidth,
					isMobile,
					maybeRepliedTo2,
					localUser,
					revealedSpoilers,
					allUsers,
					channels,
					isHovered,
					messageId,
					{attachedFiles: $lamdera$containers$SeqDict$empty, content: $author$project$RichText$failedToDecryptMessage, embeds: $elm$core$Array$empty},
					message2));
		case 2:
			var joinedAt = message.a;
			var userId = message.b;
			var reactions = message.c;
			var drawings = message.d;
			return $author$project$Pages$Guild$threadMessageContainer$(
				containerWidth,
				highlight,
				messageId,
				false,
				currentUserId,
				localUser.user,
				reactions,
				$author$project$Pages$Guild$discordQuickReactionCustomEmojis,
				localUser.customEmojis,
				localUser.emojiData,
				allUsers,
				isHovered,
				$author$project$Ui$row$(
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Guild$userJoinedContent$(userId, allUsers),
							$author$project$Pages$Guild$messageTimestamp$(
							$author$project$User$discordUserColor(localUser),
							drawings,
							_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
							messageId,
							joinedAt,
							localUser.timezone)
						])));
		case 3:
			var createdAt = message.a;
			return $author$project$Pages$Guild$threadMessageContainer$(
				containerWidth,
				highlight,
				messageId,
				false,
				currentUserId,
				localUser.user,
				$lamdera$containers$SeqDict$empty,
				$author$project$Pages$Guild$discordQuickReactionCustomEmojis,
				localUser.customEmojis,
				localUser.emojiData,
				allUsers,
				isHovered,
				$author$project$Pages$Guild$deletedMessageContent$(
					messageId,
					_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
					createdAt,
					localUser.timezone));
		case 4:
			var callStartedData = message.a;
			return $author$project$Pages$Guild$threadMessageContainer$(
				containerWidth,
				highlight,
				messageId,
				false,
				currentUserId,
				localUser.user,
				callStartedData.reactions,
				$author$project$Pages$Guild$discordQuickReactionCustomEmojis,
				localUser.customEmojis,
				localUser.emojiData,
				allUsers,
				isHovered,
				$author$project$Ui$row$(
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$row$(
							_List_fromArray(
								[
									$author$project$Ui$spacing(8),
									$author$project$Ui$contentCenterY
								]),
							_List_fromArray(
								[
									$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$width($author$project$Ui$shrink)
										]),
									$author$project$Pages$Guild$callStartedCard$(
										$author$project$User$discordUserColor(localUser),
										_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
										messageId,
										callStartedData.cardDrawings,
										callStartedData.startedBy,
										callStartedData.startedAt,
										callStartedData.endedAt,
										callStartedData.recordings,
										allUsers)),
									$author$project$Pages$Guild$callRecordingsButton$(isMobile, localUser.timezone, messageId, callStartedData.recordings, allUsers)
								])),
							$author$project$Pages$Guild$messageTimestamp$(
							$author$project$User$discordUserColor(localUser),
							callStartedData.timestampDrawings,
							_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
							messageId,
							callStartedData.startedAt,
							localUser.timezone)
						])));
		default:
			var gameStarted = message.a;
			return $author$project$Pages$Guild$threadMessageContainer$(
				containerWidth,
				highlight,
				messageId,
				false,
				currentUserId,
				localUser.user,
				gameStarted.reactions,
				$author$project$Pages$Guild$discordQuickReactionCustomEmojis,
				localUser.customEmojis,
				localUser.emojiData,
				allUsers,
				isHovered,
				$author$project$Ui$row$(
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Guild$goMatchStartedCard$(
							$author$project$User$discordUserColor(localUser),
							_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
							gameStarted.cardDrawings,
							messageId,
							gameStarted.startedBy,
							allUsers,
							gameStarted.gameType),
							$author$project$Pages$Guild$messageTimestamp$(
							$author$project$User$discordUserColor(localUser),
							gameStarted.timestampDrawings,
							_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
							messageId,
							gameStarted.startedAt,
							localUser.timezone)
						])));
	}
};
var $author$project$Pages$Guild$discordThreadMessageView = function (time) {
	return function (isMobile) {
		return function (containerWidth) {
			return function (revealedSpoilers) {
				return function (highlight) {
					return function (isHovered) {
						return function (allUsers) {
							return function (channels) {
								return function (currentUserId) {
									return function (localUser) {
										return function (maybeRepliedTo2) {
											return function (messageId) {
												return function (message) {
													return $author$project$Pages$Guild$discordThreadMessageView$(time, isMobile, containerWidth, revealedSpoilers, highlight, isHovered, allUsers, channels, currentUserId, localUser, maybeRepliedTo2, messageId, message);
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Guild$discordThreadMessageViewLazy$ = function (data, revealedSpoilers, currentDiscordUserId, localUser, messageIndex, message) {
	var _v0 = $author$project$Pages$Guild$decodeMessageView(data);
	var time = _v0.time;
	var isMobile = _v0.isMobile;
	var isHovered = _v0.isHovered;
	var highlight = _v0.highlight;
	var containerWidth = _v0.containerWidth;
	return $author$project$Pages$Guild$discordThreadMessageView$(
		time,
		isMobile,
		containerWidth,
		revealedSpoilers,
		highlight,
		isHovered,
		$author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(localUser.discordUsers),
		$lamdera$containers$SeqDict$empty,
		currentDiscordUserId,
		localUser,
		$elm$core$Maybe$Nothing,
		$author$project$Id$fromInt(messageIndex),
		message);
};
var $author$project$Pages$Guild$discordThreadMessageViewLazy = F6($author$project$Pages$Guild$discordThreadMessageViewLazy$);
var $author$project$Pages$Guild$revealedThreadSpoilers$ = function (guildOrDmId, threadId, loggedIn) {
	var _v0 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.revealedSpoilers);
	if (!_v0.$) {
		var revealedSpoilers2 = _v0.a;
		return $elm$core$Maybe$withDefault$(
			$lamdera$containers$SeqDict$empty,
			$lamdera$containers$SeqDict$get$(threadId, revealedSpoilers2.threadMessages));
	} else {
		return $lamdera$containers$SeqDict$empty;
	}
};
var $author$project$Pages$Guild$revealedThreadSpoilers = F3($author$project$Pages$Guild$revealedThreadSpoilers$);
var $author$project$Pages$Guild$threadMessageEditingView$ = function (containerWidth, time, isMobile, guildOrDmId, threadId, messageId, message, maybeRepliedTo2, revealedSpoilers, charsLeft, editing, editingRichText, loggedIn, decrypted, currentUserId, allUsers, channels, local) {
	var editingView = F2(
		function (createdBy, reactions) {
			var threadRouteWithMessage = $author$project$Id$ViewThreadWithMessage$(threadId, messageId);
			var messageInput = $author$project$MessageInput$view$(
				$lamdera$program_test$Effect$Browser$Dom$id('messageMenu_editDesktop'),
				true,
				false,
				$author$project$MessageMenu$editMessageTextInputId,
				$author$project$MessageInput$emptyPlaceholder,
				charsLeft,
				editing.text,
				editingRichText,
				editing.attachedFiles,
				local.localUser,
				loggedIn,
				allUsers,
				channels);
			var maybeReactions = $author$project$MessageView$reactionEmojiView$(local.localUser.emojiData, $author$project$MessageView$ReactionsHovered, currentUserId, local.localUser.customEmojis, allUsers, 0, containerWidth, reactions);
			var _v1 = guildOrDmId;
			var guildOrDmIdNoThread = _v1.a;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$Font$color($author$project$MyUi$font1),
						$author$project$Ui$background($author$project$MyUi$hoverHighlight),
						$author$project$Ui$paddingWith(
						{
							bottom: _Utils_eq(maybeReactions, $elm$core$Maybe$Nothing) ? 8 : 4,
							left: 0,
							right: 0,
							top: 4
						}),
						$author$project$Ui$spacing(4),
						$author$project$Ui$id(
						$lamdera$program_test$Effect$Browser$Dom$idToString(
							$author$project$Pages$Guild$threadMessageHtmlId(messageId)))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$map,
						A2($author$project$Types$MessageViewMsg, guildOrDmIdNoThread, threadRouteWithMessage),
						$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$paddingXY$(8, 0)
								]),
							$author$project$Pages$Guild$replyToHeaderAboveMessage$(isMobile, local.localUser.timezone, time, maybeRepliedTo2, revealedSpoilers, local.localUser.emojiData, local.localUser.customEmojis, decrypted, allUsers, channels))),
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$Font$bold,
								$author$project$Ui$paddingXY$(8, 0)
							]),
						$author$project$Ui$text(
							$author$project$User$toString$(createdBy, allUsers) + ' ')),
						$author$project$Ui$column$(
						_List_fromArray(
							[
								function () {
								var _v2 = $author$project$NonemptyDict$fromSeqDict(editing.attachedFiles);
								if (!_v2.$) {
									var filesToUpload = _v2.a;
									return $author$project$Ui$inFront(
										$author$project$Pages$Guild$fileUploadPreview$(
											$author$project$Types$EditMessage_PressedDeleteAttachedFile(guildOrDmId),
											$author$project$Types$EditMessage_PressedViewAttachedFileInfo(guildOrDmId),
											$elm$core$Maybe$Just(
												$author$project$Types$EditMessage_PressedToggleAttachedFileSpoiler(guildOrDmId)),
											editingRichText,
											filesToUpload));
								} else {
									return $author$project$Ui$noAttr;
								}
							}()
							]),
						_List_fromArray(
							[
								$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$paddingXY$(5, 0)
									]),
								A2(
									$author$project$Ui$map,
									A2(
										$author$project$Types$EditMessage_MessageInputMsg,
										guildOrDmIdNoThread,
										$author$project$Id$ViewThread(threadId)),
									messageInput)),
								$author$project$Ui$row$(
								_List_fromArray(
									[
										$author$project$Ui$Font$size(14),
										$author$project$Ui$Font$color($author$project$MyUi$font3),
										$author$project$Ui$paddingXY$(12, 0),
										$author$project$MyUi$prewrap
									]),
								_List_fromArray(
									[
										$author$project$Ui$text('Press '),
										$author$project$MyUi$elButton$(
										$lamdera$program_test$Effect$Browser$Dom$id('guild_exitEditMessage'),
										$author$project$Types$PressedCancelMessageEdit(guildOrDmId),
										_List_fromArray(
											[
												$author$project$Ui$Font$color($author$project$MyUi$font1),
												$author$project$Ui$width($author$project$Ui$shrink)
											]),
										$author$project$Ui$text('escape')),
										$author$project$Ui$text(' to cancel edit')
									]))
							])),
						function () {
						if (!maybeReactions.$) {
							var reactionView = maybeReactions.a;
							return A2(
								$author$project$Ui$map,
								A2($author$project$Types$MessageViewMsg, guildOrDmIdNoThread, threadRouteWithMessage),
								$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$paddingXY$(8, 0)
										]),
									reactionView));
						} else {
							return $author$project$Ui$none;
						}
					}()
					]));
		});
	switch (message.$) {
		case 0:
			var data = message.a;
			return A2(editingView, data.createdBy, data.reactions);
		case 1:
			var data = message.a;
			return A2(editingView, data.createdBy, data.reactions);
		case 2:
			return $author$project$Ui$none;
		case 3:
			return $author$project$Ui$none;
		case 4:
			return $author$project$Ui$none;
		default:
			return $author$project$Ui$none;
	}
};
var $author$project$Pages$Guild$threadMessageEditingView = function (containerWidth) {
	return function (time) {
		return function (isMobile) {
			return function (guildOrDmId) {
				return function (threadId) {
					return function (messageId) {
						return function (message) {
							return function (maybeRepliedTo2) {
								return function (revealedSpoilers) {
									return function (charsLeft) {
										return function (editing) {
											return function (editingRichText) {
												return function (loggedIn) {
													return function (decrypted) {
														return function (currentUserId) {
															return function (allUsers) {
																return function (channels) {
																	return function (local) {
																		return $author$project$Pages$Guild$threadMessageEditingView$(containerWidth, time, isMobile, guildOrDmId, threadId, messageId, message, maybeRepliedTo2, revealedSpoilers, charsLeft, editing, editingRichText, loggedIn, decrypted, currentUserId, allUsers, channels, local);
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Guild$discordThreadConversationViewHelper$ = function (lastViewedIndex, currentDiscordUserId, guildOrDmIdNoThread, threadId, maybeUrlMessageId, thread, loggedIn, local, model) {
	var revealedSpoilers = $author$project$Pages$Guild$revealedThreadSpoilers$(
		$author$project$Id$DiscordGuildOrDmId(guildOrDmIdNoThread),
		threadId,
		loggedIn);
	var othersEditing = $lamdera$containers$SeqSet$fromList(
		$elm$core$List$filterMap$(
			function (a) {
				var _v7 = a.threadRoute;
				if (_v7.$ === 1) {
					var typingThreadId = _v7.a;
					var maybeMessageId = _v7.b;
					return (_Utils_eq(typingThreadId, threadId) && $ianmackenzie$elm_units$Quantity$lessThan$(
						$ianmackenzie$elm_units$Duration$seconds(3),
						$ianmackenzie$elm_units$Duration$from$(a.time, model.time))) ? maybeMessageId : $elm$core$Maybe$Nothing;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			$lamdera$containers$SeqDict$values(
				$lamdera$containers$SeqDict$remove$(
					currentDiscordUserId,
					$author$project$LocalState$discordTypingIn$(guildOrDmIdNoThread, local)))));
	var isSelectingAnchor = $author$project$Pages$Guild$drawingIsSelectingAnchor$(loggedIn, model);
	var isMobile = $author$project$MyUi$isMobile(model);
	var guildOrDmId = _Utils_Tuple2(
		$author$project$Id$DiscordGuildOrDmId(guildOrDmIdNoThread),
		$author$project$Id$ViewThread(threadId));
	var maybeEditing = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.editMessage);
	var replyToIndex = $elm$core$Maybe$map$(
		$author$project$Id$changeType,
		$elm$core$Maybe$andThen$(
			$author$project$Message$replyToMaybe,
			$lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.replyTo)));
	var containerWidth = $author$project$Pages$Guild$conversationWidth(model);
	var channels = $author$project$LocalState$discordChannelMentions$(guildOrDmIdNoThread, local);
	return $author$project$Pages$Guild$prependUnreadDivider$(
		lastViewedIndex,
		thread.visibleMessages.oldest,
		$author$project$MessageArray$foldr$(
			F3(
				function (messageId, maybeMessage, _v0) {
					var maybeLastDate = _v0.a;
					var list = _v0.b;
					var index = $author$project$Id$toInt(messageId);
					if (!maybeMessage.$) {
						var message = maybeMessage.a;
						var threadRoute2 = $author$project$Id$ViewThreadWithMessage$(threadId, messageId);
						var otherUserIsEditing = $lamdera$containers$SeqSet$member$(messageId, othersEditing);
						var messageHover2 = $author$project$Pages$Guild$messageHover$(
							$author$project$Id$DiscordGuildOrDmId(guildOrDmIdNoThread),
							threadRoute2,
							loggedIn,
							model);
						var maybeRepliedTo2 = $author$project$Pages$Guild$maybeRepliedTo$(message, thread);
						var isEditing = function () {
							if (!maybeEditing.$) {
								var editing = maybeEditing.a;
								return _Utils_eq(
									editing.messageIndex,
									$author$project$Id$changeType(messageId)) ? $elm$core$Maybe$Just(editing) : $elm$core$Maybe$Nothing;
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}();
						var highlight = _Utils_eq(
							maybeUrlMessageId,
							$elm$core$Maybe$Just(messageId)) ? 3 : (_Utils_eq(
							replyToIndex,
							$elm$core$Maybe$Just(messageId)) ? 1 : 0);
						var date = $justinmimbs$date$Date$fromPosix$(
							local.localUser.timezone,
							$author$project$Message$createdAt(message));
						return _Utils_Tuple2(
							$elm$core$Maybe$Just(date),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									$elm$core$String$fromInt(index),
									function () {
										if (!isEditing.$) {
											var editing = isEditing.a;
											if ($author$project$MyUi$isMobile(model)) {
												return A2(
													$author$project$Ui$map,
													A2(
														$author$project$Types$MessageViewMsg,
														$author$project$Id$DiscordGuildOrDmId(guildOrDmIdNoThread),
														threadRoute2),
													$author$project$Pages$Guild$discordThreadMessageView$(
														model.time,
														isMobile,
														containerWidth,
														revealedSpoilers,
														highlight,
														messageHover2,
														$author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(local.localUser.discordUsers),
														channels,
														currentDiscordUserId,
														local.localUser,
														maybeRepliedTo2,
														messageId,
														message));
											} else {
												var allUsers = $author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(local.localUser.discordUsers);
												var editRichText = function () {
													var _v3 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(editing.text);
													if (!_v3.$) {
														var text = _v3.a;
														return $elm$core$Maybe$Just(
															$author$project$RichText$fromNonemptyString$(local.localUser.timezone, allUsers, channels, text));
													} else {
														return $elm$core$Maybe$Nothing;
													}
												}();
												return $author$project$Pages$Guild$threadMessageEditingView$(
													containerWidth,
													model.time,
													isMobile,
													guildOrDmId,
													threadId,
													$author$project$Id$fromInt(index),
													message,
													maybeRepliedTo2,
													revealedSpoilers,
													$author$project$RichText$discordCharsLeft$($author$project$OneToOne$empty, editRichText),
													editing,
													editRichText,
													loggedIn,
													$lamdera$containers$SeqDict$empty,
													currentDiscordUserId,
													allUsers,
													channels,
													local);
											}
										} else {
											var _v4 = _Utils_Tuple2(
												maybeRepliedTo2,
												$author$project$Message$mentionsChannel(message));
											if ((_v4.a.$ === 1) && (!_v4.b)) {
												var _v5 = _v4.a;
												return A2(
													$author$project$Ui$map,
													A2(
														$author$project$Types$MessageViewMsg,
														$author$project$Id$DiscordGuildOrDmId(guildOrDmIdNoThread),
														threadRoute2),
													$author$project$Ui$Lazy$lazy6$(
														$author$project$Pages$Guild$discordThreadMessageViewLazy,
														$author$project$Pages$Guild$encodeMessageView$(isMobile, messageHover2, containerWidth, otherUserIsEditing, highlight, model.time),
														revealedSpoilers,
														currentDiscordUserId,
														local.localUser,
														index,
														message));
											} else {
												return A2(
													$author$project$Ui$map,
													A2(
														$author$project$Types$MessageViewMsg,
														$author$project$Id$DiscordGuildOrDmId(guildOrDmIdNoThread),
														threadRoute2),
													$author$project$Pages$Guild$discordThreadMessageView$(
														model.time,
														isMobile,
														containerWidth,
														revealedSpoilers,
														highlight,
														messageHover2,
														$author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(local.localUser.discordUsers),
														channels,
														currentDiscordUserId,
														local.localUser,
														maybeRepliedTo2,
														messageId,
														message));
											}
										}
									}()),
								_Utils_ap(
									$elm$core$List$map$(
										$elm$core$Tuple$mapSecond(
											$author$project$Ui$map(
												A2(
													$author$project$Types$MessageViewMsg,
													$author$project$Id$DiscordGuildOrDmId(guildOrDmIdNoThread),
													threadRoute2))),
										$author$project$Pages$Guild$newMessageLine$(
											$author$project$User$discordUserColor(local.localUser),
											isSelectingAnchor,
											thread.dateDividerDrawings,
											maybeLastDate,
											date,
											lastViewedIndex,
											index,
											messageId)),
									list)));
					} else {
						return _Utils_Tuple2(
							maybeLastDate,
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									$elm$core$String$fromInt(index),
									$author$project$Pages$Guild$unloadedMessageView(index)),
								list));
					}
				}),
			_Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil),
			$author$project$VisibleMessages$slice(thread)).b);
};
var $author$project$Pages$Guild$discordThreadConversationViewHelper = F9($author$project$Pages$Guild$discordThreadConversationViewHelper$);
var $author$project$Pages$Guild$discordThreadStarterMessage$ = function (isMobile, discordGuildOrDmId, threadMessageIndex, channel, loggedIn, local, model) {
	var threadRoute = $author$project$Id$NoThreadWithMessage(threadMessageIndex);
	var guildOrDmIdNoThread = $author$project$Id$DiscordGuildOrDmId(discordGuildOrDmId);
	var revealedSpoilers = $author$project$Pages$Guild$revealedChannelSpoilers$(guildOrDmIdNoThread, loggedIn);
	var guildOrDmId = _Utils_Tuple2(guildOrDmIdNoThread, $author$project$Id$NoThread);
	var currentUserId = function () {
		if (!discordGuildOrDmId.$) {
			var id = discordGuildOrDmId.a;
			return id.currentUserId;
		} else {
			var data = discordGuildOrDmId.a;
			return data.currentUserId;
		}
	}();
	var containerWidth = $author$project$Pages$Guild$conversationWidth(model);
	var channels = $author$project$LocalState$discordChannelMentions$(discordGuildOrDmId, local);
	var _v0 = $author$project$MessageArray$get$(threadMessageIndex, channel.messages);
	if (!_v0.$) {
		var message = _v0.a;
		var _v1 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.editMessage);
		if (!_v1.$) {
			var edit = _v1.a;
			if (_Utils_eq(edit.messageIndex, threadMessageIndex)) {
				var allUsers = $author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(local.localUser.discordUsers);
				var editRichText = function () {
					var _v2 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(edit.text);
					if (!_v2.$) {
						var nonempty = _v2.a;
						return $elm$core$Maybe$Just(
							$author$project$RichText$fromNonemptyString$(local.localUser.timezone, allUsers, channels, nonempty));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				return $author$project$Pages$Guild$messageEditingView$(
					containerWidth,
					model.time,
					isMobile,
					guildOrDmId,
					$author$project$Id$NoThreadWithMessage(threadMessageIndex),
					message,
					$elm$core$Maybe$Nothing,
					$elm$core$Maybe$Nothing,
					$lamdera$containers$SeqDict$empty,
					$author$project$RichText$discordCharsLeft$($author$project$OneToOne$empty, editRichText),
					edit,
					editRichText,
					loggedIn,
					$lamdera$containers$SeqDict$empty,
					currentUserId,
					allUsers,
					channels,
					local);
			} else {
				return A2(
					$author$project$Ui$map,
					A2($author$project$Types$MessageViewMsg, guildOrDmIdNoThread, threadRoute),
					$author$project$Pages$Guild$discordMessageView$(
						model.time,
						isMobile,
						$author$project$Pages$Guild$conversationWidth(model),
						true,
						revealedSpoilers,
						0,
						$author$project$Pages$Guild$messageHover$(guildOrDmIdNoThread, threadRoute, loggedIn, model),
						currentUserId,
						$author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(local.localUser.discordUsers),
						channels,
						local.localUser,
						$elm$core$Maybe$Nothing,
						$elm$core$Maybe$Nothing,
						threadMessageIndex,
						message));
			}
		} else {
			return A2(
				$author$project$Ui$map,
				A2($author$project$Types$MessageViewMsg, guildOrDmIdNoThread, threadRoute),
				$author$project$Pages$Guild$discordMessageView$(
					model.time,
					isMobile,
					$author$project$Pages$Guild$conversationWidth(model),
					true,
					revealedSpoilers,
					0,
					$author$project$Pages$Guild$messageHover$(guildOrDmIdNoThread, threadRoute, loggedIn, model),
					currentUserId,
					$author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(local.localUser.discordUsers),
					channels,
					local.localUser,
					$elm$core$Maybe$Nothing,
					$elm$core$Maybe$Nothing,
					threadMessageIndex,
					message));
		}
	} else {
		return $author$project$Ui$none;
	}
};
var $author$project$Pages$Guild$discordThreadStarterMessage = F7($author$project$Pages$Guild$discordThreadStarterMessage$);
var $author$project$Pages$Guild$startOfThreadText = 'Start of thread';
var $author$project$Pages$Guild$discordThreadConversationView$ = function (lastViewedIndex, currentDiscordUserId, guildOrDmIdNoThread, maybeUrlMessageId, threadId, loggedIn, model, local, name, availableCustomEmojis, availableStickers, channel) {
	var isMobile = $author$project$MyUi$isMobile(model);
	var guildOrDmId = _Utils_Tuple2(
		$author$project$Id$DiscordGuildOrDmId(guildOrDmIdNoThread),
		$author$project$Id$ViewThread(threadId));
	var replyTo = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.replyTo);
	var draft = function () {
		var _v7 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.drafts);
		if (!_v7.$) {
			var text = _v7.a;
			return $MartinSStewart$elm_nonempty_string$String$Nonempty$toString(text);
		} else {
			return '';
		}
	}();
	var channels = $author$project$LocalState$discordChannelMentions$(guildOrDmIdNoThread, local);
	var allUsers = $author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(local.localUser.discordUsers);
	var draftRichText = function () {
		var _v6 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.drafts);
		if (!_v6.$) {
			var text = _v6.a;
			return $elm$core$Maybe$Just(
				$author$project$RichText$fromNonemptyString$(local.localUser.timezone, allUsers, channels, text));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$Ui$heightMin(0)
			]),
		_List_fromArray(
			[
				$author$project$ChannelHeader$discordThread$(isMobile, name, guildOrDmIdNoThread, local, loggedIn, model),
				$author$project$Ui$el$(
				_Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Guild$emojiSelector$(isMobile, availableCustomEmojis, availableStickers, local, loggedIn, model),
							$author$project$Ui$heightMin(0),
							$author$project$Ui$height($author$project$Ui$fill)
						]),
					$author$project$Pages$Guild$drawingModeAttributes$(model.route, loggedIn.drawingMode)),
				$author$project$Ui$Keyed$column$(
					_Utils_ap(
						_List_fromArray(
							[
								$author$project$Ui$height($author$project$Ui$fill),
								$author$project$Ui$width($author$project$Ui$fill),
								$author$project$Ui$paddingWith(
								{bottom: 16, left: 0, right: 0, top: 200}),
								$author$project$MyUi$scrollable(
								$author$project$MyUi$canScroll$(
									$author$project$MyUi$isMobile(model),
									model.drag)),
								$author$project$MyUi$htmlStyle$('overflow-wrap', 'break-word'),
								$author$project$Ui$id(
								$lamdera$program_test$Effect$Browser$Dom$idToString($author$project$Pages$Guild$conversationContainerId)),
								$author$project$Ui$Events$on$(
								'scroll',
								$author$project$Scroll$decodeScrollToBottom$(
									A2(
										$author$project$Types$UserScrolled,
										$author$project$Id$DiscordGuildOrDmId(guildOrDmIdNoThread),
										$author$project$Id$ViewThread(threadId)),
									loggedIn.channelScrollPosition)),
								$author$project$Ui$heightMin(0),
								$author$project$MyUi$bounceScroll(isMobile),
								$author$project$MyUi$htmlStyle$('background-image', 'url(/cacheable/grid1.png)')
							]),
						$author$project$Pages$Guild$drawingZoomAttributes$(model.route, loggedIn.drawingMode)),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'a',
							$author$project$Ui$column$(
								_List_fromArray(
									[$author$project$Ui$alignBottom]),
								$author$project$VisibleMessages$startIsVisible(channel.visibleMessages) ? _List_fromArray(
									[
										$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$Font$color($author$project$MyUi$font2),
												$author$project$Ui$paddingXY$(8, 4),
												$author$project$Ui$alignBottom,
												$author$project$Ui$Font$size(20)
											]),
										$author$project$Ui$text($author$project$Pages$Guild$startOfThreadText)),
										function () {
										if (!guildOrDmIdNoThread.$) {
											var channelId = guildOrDmIdNoThread.a.channelId;
											var guildId = guildOrDmIdNoThread.a.guildId;
											var _v1 = $author$project$LocalState$getDiscordGuildAndChannel$(guildId, channelId, local);
											if (!_v1.$) {
												var _v2 = _v1.a;
												var channel2 = _v2.b;
												return $author$project$Pages$Guild$discordThreadStarterMessage$(isMobile, guildOrDmIdNoThread, threadId, channel2, loggedIn, local, model);
											} else {
												return $author$project$Ui$none;
											}
										} else {
											return $author$project$Ui$none;
										}
									}()
									]) : _List_Nil)),
						$author$project$Pages$Guild$discordThreadConversationViewHelper$(lastViewedIndex, currentDiscordUserId, guildOrDmIdNoThread, threadId, maybeUrlMessageId, channel, loggedIn, local, model)))),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$paddingXY$(2, 0),
						$author$project$Ui$heightMin(0),
						$author$project$MyUi$noShrinking,
						function () {
						var _v3 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.filesToUpload);
						if (!_v3.$) {
							var filesToUpload2 = _v3.a;
							return $author$project$Ui$inFront(
								$author$project$Pages$Guild$fileUploadPreview$(
									$author$project$Types$PressedDeleteAttachedFile(guildOrDmId),
									$author$project$Types$PressedViewAttachedFileInfo(guildOrDmId),
									$elm$core$Maybe$Just(
										$author$project$Types$PressedToggleAttachedFileSpoiler(guildOrDmId)),
									draftRichText,
									filesToUpload2));
						} else {
							return $author$project$Ui$noAttr;
						}
					}()
					]),
				_List_fromArray(
					[
						$author$project$Pages$Guild$newMessagesView$(model, loggedIn, channel),
						$author$project$Pages$Guild$replyToHeader$(isMobile, guildOrDmId, replyTo, allUsers, channel),
						A2(
						$author$project$Ui$map,
						A2(
							$author$project$Types$MessageInputMsg,
							$author$project$Id$DiscordGuildOrDmId(guildOrDmIdNoThread),
							$author$project$Id$ViewThread(threadId)),
						$author$project$MessageInput$view$(
							$lamdera$program_test$Effect$Browser$Dom$id('messageMenu_channelInput'),
							_Utils_eq(replyTo, $elm$core$Maybe$Nothing),
							$author$project$MyUi$isMobile(model),
							$author$project$Pages$Guild$channelTextInputId,
							$author$project$MessageInput$textPlaceholder(
								function () {
									if (!guildOrDmIdNoThread.$) {
										return 'Write a message in this thread';
									} else {
										return 'Write a message in this thread';
									}
								}()),
							$author$project$RichText$discordCharsLeft$($author$project$OneToOne$empty, draftRichText),
							draft,
							draftRichText,
							function () {
								var _v5 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.filesToUpload);
								if (!_v5.$) {
									var attachedFiles = _v5.a;
									return $author$project$NonemptyDict$toSeqDict(attachedFiles);
								} else {
									return $lamdera$containers$SeqDict$empty;
								}
							}(),
							local.localUser,
							loggedIn,
							$author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(local.localUser.discordUsers),
							channels)),
						$author$project$Pages$Guild$peopleAreTypingView$(
						allUsers,
						$author$project$Id$ViewThread(threadId),
						$author$project$LocalState$discordTypingIn$(guildOrDmIdNoThread, local),
						currentDiscordUserId,
						model)
					]))
			]));
};
var $author$project$Pages$Guild$discordThreadConversationView = function (lastViewedIndex) {
	return function (currentDiscordUserId) {
		return function (guildOrDmIdNoThread) {
			return function (maybeUrlMessageId) {
				return function (threadId) {
					return function (loggedIn) {
						return function (model) {
							return function (local) {
								return function (name) {
									return function (availableCustomEmojis) {
										return function (availableStickers) {
											return function (channel) {
												return $author$project$Pages$Guild$discordThreadConversationView$(lastViewedIndex, currentDiscordUserId, guildOrDmIdNoThread, maybeUrlMessageId, threadId, loggedIn, model, local, name, availableCustomEmojis, availableStickers, channel);
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Guild$pageMissing = function (text) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$Ui$contentCenterY,
				$author$project$Ui$Font$center,
				$author$project$Ui$Font$color($author$project$MyUi$font1),
				$author$project$Ui$Font$size(20),
				$author$project$Ui$background($author$project$MyUi$background3)
			]),
		$author$project$Ui$text(text));
};
var $author$project$Pages$Guild$unreadDividerAt$ = function (lastViewed, previouslyLastViewedMessage) {
	if (previouslyLastViewedMessage.$ === 1) {
		var messageId = previouslyLastViewedMessage.a;
		return messageId;
	} else {
		return lastViewed;
	}
};
var $author$project$Pages$Guild$unreadDividerAt = F2($author$project$Pages$Guild$unreadDividerAt$);
var $author$project$Pages$Guild$discordChannelView$ = function (routeData, guild, loggedIn, local, model) {
	var _v0 = routeData.channelRoute;
	switch (_v0.$) {
		case 0:
			var channelId = _v0.a;
			var threadRoute = _v0.b;
			var _v1 = $lamdera$containers$SeqDict$get$(channelId, guild.channels);
			if (!_v1.$) {
				var channel = _v1.a;
				var _v2 = $author$project$LocalState$discordGuildAvailableStickersAndCustomEmojis$(local.localUser, guild);
				var availableCustomEmojis = _v2.a;
				var availableStickers = _v2.b;
				if (threadRoute.$ === 1) {
					var threadMessageIndex = threadRoute.a;
					var maybeUrlMessageId = threadRoute.b;
					return $author$project$Pages$Guild$discordThreadConversationView$(
						function () {
							var lastViewed = $elm$core$Maybe$withDefault$(
								$author$project$Id$fromInt(-1),
								$lamdera$containers$SeqDict$get$(
									_Utils_Tuple2(
										$author$project$Id$DiscordGuildOrDmId(
											$author$project$Id$DiscordGuildOrDmId_Guild(
												{channelId: channelId, currentUserId: routeData.currentDiscordUserId, guildId: routeData.guildId})),
										threadMessageIndex),
									local.localUser.user.lastViewedThreadMessage));
							var _v4 = local.localUser.currentlyViewing;
							if (_v4.$ === 6) {
								var data = _v4.a;
								return _Utils_eq(
									data.id,
									{channelId: channelId, currentUserId: routeData.currentDiscordUserId, guildId: routeData.guildId, threadId: threadMessageIndex}) ? $author$project$Pages$Guild$unreadDividerAt$(lastViewed, data.previouslyLastViewedMessage) : lastViewed;
							} else {
								return lastViewed;
							}
						}(),
						routeData.currentDiscordUserId,
						$author$project$Id$DiscordGuildOrDmId_Guild(
							{channelId: channelId, currentUserId: routeData.currentDiscordUserId, guildId: routeData.guildId}),
						maybeUrlMessageId,
						threadMessageIndex,
						loggedIn,
						model,
						local,
						$author$project$ChannelName$toString(channel.name) + (' / ' + $author$project$Pages$Guild$threadPreviewText$(
							local.localUser.timezone,
							$author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(local.localUser.discordUsers),
							$author$project$LocalState$discordChannelMentions$(
								$author$project$Id$DiscordGuildOrDmId_Guild(
									{channelId: channelId, currentUserId: routeData.currentDiscordUserId, guildId: routeData.guildId}),
								local),
							threadMessageIndex,
							$lamdera$containers$SeqDict$empty,
							channel)),
						availableCustomEmojis,
						availableStickers,
						$elm$core$Maybe$withDefault$(
							$author$project$Thread$discordFrontendInit,
							$lamdera$containers$SeqDict$get$(threadMessageIndex, channel.threads)));
				} else {
					var maybeUrlMessageId = threadRoute.a;
					return $author$project$Pages$Guild$discordConversationView$(
						function () {
							var lastViewed = $elm$core$Maybe$withDefault$(
								$author$project$Id$fromInt(-1),
								$lamdera$containers$SeqDict$get$(
									$author$project$Id$DiscordGuildOrDmId(
										$author$project$Id$DiscordGuildOrDmId_Guild(
											{channelId: channelId, currentUserId: routeData.currentDiscordUserId, guildId: routeData.guildId})),
									local.localUser.user.lastViewedMessage));
							var _v5 = local.localUser.currentlyViewing;
							if (_v5.$ === 5) {
								var data = _v5.a;
								return _Utils_eq(
									data.id,
									{channelId: channelId, currentUserId: routeData.currentDiscordUserId, guildId: routeData.guildId}) ? $author$project$Pages$Guild$unreadDividerAt$(lastViewed, data.previouslyLastViewedMessage) : lastViewed;
							} else {
								return lastViewed;
							}
						}(),
						routeData.currentDiscordUserId,
						$author$project$Id$DiscordGuildOrDmId_Guild(
							{channelId: channelId, currentUserId: routeData.currentDiscordUserId, guildId: routeData.guildId}),
						maybeUrlMessageId,
						loggedIn,
						model,
						local,
						$author$project$ChannelName$toString(channel.name),
						channel,
						availableCustomEmojis,
						availableStickers);
				}
			} else {
				return $author$project$Pages$Guild$pageMissing($author$project$Pages$Guild$channelDoesNotExistText);
			}
		case 1:
			return $author$project$Pages$Guild$pageMissing('Adding Discord channels not supported yet');
		default:
			return $author$project$Pages$Guild$discordGuildSettingsView$(model, routeData.currentDiscordUserId, routeData.guildId, guild, local);
	}
};
var $author$project$Pages$Guild$discordChannelView = F5($author$project$Pages$Guild$discordChannelView$);
var $author$project$Pages$Guild$discordMemberColumnContainer = function (contents) {
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$Ui$alignRight,
				$author$project$Ui$background($author$project$MyUi$background2),
				$author$project$Ui$Font$color($author$project$MyUi$font1),
				$author$project$Ui$width(
				$author$project$Ui$px($author$project$MyUi$memberColumnWidth)),
				$author$project$Ui$scrollable,
				$author$project$Ui$heightMin(0),
				$author$project$Ui$paddingXY$(8, 4)
			]),
		contents);
};
var $author$project$GuildIcon$IsSelected = {$: 1};
var $author$project$GuildIcon$Normal = function (a) {
	return {$: 0, a: a};
};
var $author$project$GuildIcon$iconRounding = $elm$core$Basics$round(($author$project$GuildIcon$size * 10) / 50);
var $author$project$GuildIcon$notSelectedRounding = $author$project$Ui$roundedWith(
	{bottomLeft: 0, bottomRight: $author$project$GuildIcon$iconRounding, topLeft: 0, topRight: $author$project$GuildIcon$iconRounding});
var $author$project$Internal$Font$SansSerif = {$: 1};
var $author$project$Ui$Font$sansSerif = $author$project$Internal$Font$SansSerif;
var $author$project$MyUi$notoSans = $author$project$Ui$Font$family(
	_List_fromArray(
		[
			$author$project$Ui$Font$typeface('Noto Sans'),
			$author$project$Ui$Font$sansSerif
		]));
var $author$project$MyUi$secondaryGrayBorder = $author$project$Ui$rgb$(215, 215, 215);
var $author$project$GuildIcon$invertedRadius = $author$project$GuildIcon$iconRounding + 6;
var $elm$svg$Svg$defs = $elm$svg$Svg$trustedNode('defs');
var $author$project$FileStatus$fileHashToString = function (_v0) {
	var a = _v0;
	return a;
};
var $elm$svg$Svg$Attributes$gradientUnits = _VirtualDom_attribute('gradientUnits');
var $author$project$MyUi$guildIconBackground = $author$project$MyUi$background2;
var $elm$svg$Svg$image = $elm$svg$Svg$trustedNode('image');
var $elm$svg$Svg$linearGradient = $elm$svg$Svg$trustedNode('linearGradient');
var $elm$svg$Svg$Attributes$offset = _VirtualDom_attribute('offset');
var $elm$svg$Svg$pattern = $elm$svg$Svg$trustedNode('pattern');
var $elm$svg$Svg$Attributes$patternUnits = _VirtualDom_attribute('patternUnits');
var $author$project$GuildIcon$selectedOutline = function () {
	var corner = 'A ' + ($elm$core$String$fromFloat($author$project$GuildIcon$iconRounding + 0.5) + (' ' + ($elm$core$String$fromFloat($author$project$GuildIcon$iconRounding + 0.5) + ' 0 0 0 ')));
	var arc = 'A ' + ($elm$core$String$fromFloat($author$project$GuildIcon$invertedRadius - 0.5) + (' ' + ($elm$core$String$fromFloat($author$project$GuildIcon$invertedRadius - 0.5) + ' 0 0 1 ')));
	return $elm$core$String$join$(
		' ',
		_List_fromArray(
			[
				'M ' + ($elm$core$String$fromFloat($author$project$GuildIcon$size - 0.5) + (',' + $elm$core$String$fromInt(-$author$project$GuildIcon$invertedRadius))),
				arc + ($elm$core$String$fromInt($author$project$GuildIcon$size - $author$project$GuildIcon$invertedRadius) + ',-0.5'),
				'H ' + $elm$core$String$fromInt($author$project$GuildIcon$iconRounding),
				corner + ('-0.5,' + $elm$core$String$fromInt($author$project$GuildIcon$iconRounding)),
				'V ' + $elm$core$String$fromInt($author$project$GuildIcon$size - $author$project$GuildIcon$iconRounding),
				corner + ($elm$core$String$fromInt($author$project$GuildIcon$iconRounding) + (',' + $elm$core$String$fromFloat($author$project$GuildIcon$size + 0.5))),
				'H ' + $elm$core$String$fromInt($author$project$GuildIcon$size - $author$project$GuildIcon$invertedRadius),
				arc + ($elm$core$String$fromFloat($author$project$GuildIcon$size - 0.5) + (',' + $elm$core$String$fromInt($author$project$GuildIcon$size + $author$project$GuildIcon$invertedRadius)))
			]));
}();
var $author$project$GuildIcon$selectedShape = $author$project$GuildIcon$selectedOutline + (' H ' + ($elm$core$String$fromInt($author$project$GuildIcon$size) + (' V ' + ($elm$core$String$fromInt(-$author$project$GuildIcon$invertedRadius) + ' Z'))));
var $elm$svg$Svg$stop = $elm$svg$Svg$trustedNode('stop');
var $elm$svg$Svg$Attributes$stopColor = _VirtualDom_attribute('stop-color');
var $author$project$GuildIcon$selectedTile = function (maybeIcon) {
	var id = $elm$core$Maybe$withDefault$(
		'plain',
		$elm$core$Maybe$map$($author$project$FileStatus$fileHashToString, maybeIcon));
	var patternId = 'guildIconPicture_' + id;
	var height = $author$project$GuildIcon$size + (2 * $author$project$GuildIcon$invertedRadius);
	var gradientId = 'guildIconOutline_' + id;
	return $author$project$Ui$html(
		A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$width(
					$elm$core$String$fromInt($author$project$GuildIcon$size)),
					$elm$svg$Svg$Attributes$height(
					$elm$core$String$fromInt(height)),
					$elm$svg$Svg$Attributes$viewBox(
					'0 ' + ($elm$core$String$fromInt(-$author$project$GuildIcon$invertedRadius) + (' ' + ($elm$core$String$fromInt($author$project$GuildIcon$size) + (' ' + $elm$core$String$fromInt(height)))))),
					$elm$svg$Svg$Attributes$style('display:block;overflow:visible')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$defs,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2(
							$elm$svg$Svg$linearGradient,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id(gradientId),
									$elm$svg$Svg$Attributes$gradientUnits('userSpaceOnUse'),
									$elm$svg$Svg$Attributes$x1('0'),
									$elm$svg$Svg$Attributes$x2('0'),
									$elm$svg$Svg$Attributes$y1(
									$elm$core$String$fromInt(-$author$project$GuildIcon$invertedRadius)),
									$elm$svg$Svg$Attributes$y2(
									$elm$core$String$fromInt($author$project$GuildIcon$size + $author$project$GuildIcon$invertedRadius))
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$stop,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$offset('0'),
											$elm$svg$Svg$Attributes$stopColor(
											$author$project$MyUi$colorToStyle($author$project$MyUi$guildColumnBorder))
										]),
									_List_Nil),
									A2(
									$elm$svg$Svg$stop,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$offset(
											$elm$core$String$fromFloat(($author$project$GuildIcon$invertedRadius - 0.5) / height)),
											$elm$svg$Svg$Attributes$stopColor(
											$author$project$MyUi$colorToStyle($author$project$MyUi$guildIconSelectedBorder))
										]),
									_List_Nil),
									A2(
									$elm$svg$Svg$stop,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$offset(
											$elm$core$String$fromFloat((($author$project$GuildIcon$size + $author$project$GuildIcon$invertedRadius) + 0.5) / height)),
											$elm$svg$Svg$Attributes$stopColor(
											$author$project$MyUi$colorToStyle($author$project$MyUi$guildIconSelectedBorder))
										]),
									_List_Nil),
									A2(
									$elm$svg$Svg$stop,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$offset('1'),
											$elm$svg$Svg$Attributes$stopColor(
											$author$project$MyUi$colorToStyle($author$project$MyUi$guildColumnBorder))
										]),
									_List_Nil)
								])),
						function () {
							if (maybeIcon.$ === 1) {
								return _List_Nil;
							} else {
								var icon = maybeIcon.a;
								var url = $author$project$FileStatus$fileUrl$($author$project$FileStatus$pngContent, icon);
								return _List_fromArray(
									[
										A2(
										$elm$svg$Svg$pattern,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$id(patternId),
												$elm$svg$Svg$Attributes$patternUnits('userSpaceOnUse'),
												$elm$svg$Svg$Attributes$width(
												$elm$core$String$fromInt($author$project$GuildIcon$size)),
												$elm$svg$Svg$Attributes$height(
												$elm$core$String$fromInt($author$project$GuildIcon$size * 2))
											]),
										_List_fromArray(
											[
												A2(
												$elm$svg$Svg$rect,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$width(
														$elm$core$String$fromInt($author$project$GuildIcon$size)),
														$elm$svg$Svg$Attributes$height(
														$elm$core$String$fromInt($author$project$GuildIcon$size * 2)),
														$elm$svg$Svg$Attributes$fill(
														$author$project$MyUi$colorToStyle($author$project$MyUi$guildIconBackground))
													]),
												_List_Nil),
												A2(
												$elm$svg$Svg$image,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$xlinkHref(url),
														$elm$svg$Svg$Attributes$width(
														$elm$core$String$fromInt($author$project$GuildIcon$size)),
														$elm$svg$Svg$Attributes$height(
														$elm$core$String$fromInt($author$project$GuildIcon$size)),
														$elm$svg$Svg$Attributes$preserveAspectRatio('xMidYMid slice')
													]),
												_List_Nil),
												A2(
												$elm$svg$Svg$image,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$xlinkHref(url),
														$elm$svg$Svg$Attributes$width(
														$elm$core$String$fromInt($author$project$GuildIcon$size)),
														$elm$svg$Svg$Attributes$height(
														$elm$core$String$fromInt($author$project$GuildIcon$size)),
														$elm$svg$Svg$Attributes$preserveAspectRatio('xMidYMid slice'),
														$elm$svg$Svg$Attributes$transform(
														'translate(0,' + ($elm$core$String$fromInt($author$project$GuildIcon$size * 2) + ') scale(1,-1)'))
													]),
												_List_Nil)
											]))
									]);
							}
						}())),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d($author$project$GuildIcon$selectedShape),
							$elm$svg$Svg$Attributes$fill(
							function () {
								if (maybeIcon.$ === 1) {
									return $author$project$MyUi$colorToStyle($author$project$MyUi$secondaryGray);
								} else {
									return 'url(#' + (patternId + ')');
								}
							}())
						]),
					_List_Nil),
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d($author$project$GuildIcon$selectedOutline),
							$elm$svg$Svg$Attributes$fill('none'),
							$elm$svg$Svg$Attributes$stroke('url(#' + (gradientId + ')')),
							$elm$svg$Svg$Attributes$strokeWidth('var(--guild-outline-width, 1px)')
						]),
					_List_Nil)
				])));
};
var $author$project$GuildIcon$selectedEdgeCurves$ = function (mode, maybeIcon) {
	return _List_fromArray(
		[
			$author$project$MyUi$htmlStyle$(
			'z-index',
			function () {
				if (mode.$ === 1) {
					return '1';
				} else {
					return '0';
				}
			}()),
			$author$project$Ui$behindContent(
			$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$alignRight,
						$author$project$Ui$width(
						$author$project$Ui$px($author$project$GuildIcon$size)),
						$author$project$Ui$move(
						{x: 0, y: -$author$project$GuildIcon$invertedRadius, z: 0}),
						$author$project$MyUi$noPointerEvents,
						$author$project$MyUi$htmlStyle$(
						'visibility',
						function () {
							if (mode.$ === 1) {
								return 'visible';
							} else {
								return 'hidden';
							}
						}())
					]),
				$author$project$GuildIcon$selectedTile(maybeIcon)))
		]);
};
var $author$project$GuildIcon$selectedEdgeCurves = F2($author$project$GuildIcon$selectedEdgeCurves$);
var $author$project$GuildIcon$selectedRounding = $author$project$Ui$roundedWith(
	{bottomLeft: $author$project$GuildIcon$iconRounding, bottomRight: 0, topLeft: $author$project$GuildIcon$iconRounding, topRight: 0});
var $author$project$GuildIcon$addGuildButton$ = function (htmlId, isSelected, onPress) {
	return $author$project$MyUi$elButton$(
		htmlId,
		onPress,
		_Utils_ap(
			_List_fromArray(
				[
					$author$project$Ui$contentCenterX,
					$author$project$Ui$contentCenterY,
					isSelected ? $author$project$Ui$alignRight : $author$project$Ui$alignLeft,
					isSelected ? $author$project$GuildIcon$selectedRounding : $author$project$GuildIcon$notSelectedRounding,
					$author$project$MyUi$notoSans,
					$author$project$Ui$Font$weight(600),
					$author$project$Ui$background(
					isSelected ? $author$project$Ui$rgba$(0, 0, 0, 0) : $author$project$MyUi$secondaryGray),
					$author$project$Ui$border(
					isSelected ? 0 : 1),
					$author$project$Ui$borderColor($author$project$MyUi$secondaryGrayBorder),
					$author$project$Ui$width(
					$author$project$Ui$px($author$project$GuildIcon$size)),
					$author$project$Ui$height(
					$author$project$Ui$px($author$project$GuildIcon$size)),
					$author$project$Ui$padding(8),
					$author$project$Ui$Font$color($author$project$GuildIcon$iconFontColor),
					$author$project$MyUi$hoverText('Create new guild')
				]),
			$author$project$GuildIcon$selectedEdgeCurves$(
				isSelected ? $author$project$GuildIcon$IsSelected : $author$project$GuildIcon$Normal($author$project$GuildIcon$NoNotification),
				$elm$core$Maybe$Nothing)),
		$author$project$Ui$el$(
			_List_Nil,
			$author$project$Ui$html($author$project$Icons$plusIcon)));
};
var $author$project$GuildIcon$addGuildButton = F3($author$project$GuildIcon$addGuildButton$);
var $noahzgordon$elm_color_extra$Color$Manipulate$calculateWeight$ = function (a1, a2, weight) {
	var w1 = (weight * 2) - 1;
	var a = a1 - a2;
	var w2 = _Utils_eq(w1 * a, -1) ? w1 : ((w1 + a) / (1 + (w1 * a)));
	return (w2 + 1) / 2;
};
var $noahzgordon$elm_color_extra$Color$Manipulate$calculateWeight = F3($noahzgordon$elm_color_extra$Color$Manipulate$calculateWeight$);
var $noahzgordon$elm_color_extra$Color$Manipulate$mixChannel$ = function (weight, c1, c2) {
	return (c1 * weight) + (c2 * (1 - weight));
};
var $noahzgordon$elm_color_extra$Color$Manipulate$mixChannel = F3($noahzgordon$elm_color_extra$Color$Manipulate$mixChannel$);
var $noahzgordon$elm_color_extra$Color$Manipulate$weightedMix$ = function (color1, color2, weight) {
	var clampedWeight = $elm$core$Basics$clamp$(0, 1, weight);
	var c2 = $avh4$elm_color$Color$toRgba(color2);
	var c1 = $avh4$elm_color$Color$toRgba(color1);
	var w = $noahzgordon$elm_color_extra$Color$Manipulate$calculateWeight$(c1.alpha, c2.alpha, clampedWeight);
	var gMixed = $noahzgordon$elm_color_extra$Color$Manipulate$mixChannel$(w, c1.green, c2.green);
	var rMixed = $noahzgordon$elm_color_extra$Color$Manipulate$mixChannel$(w, c1.red, c2.red);
	var bMixed = $noahzgordon$elm_color_extra$Color$Manipulate$mixChannel$(w, c1.blue, c2.blue);
	var alphaMixed = (c1.alpha * clampedWeight) + (c2.alpha * (1 - clampedWeight));
	return $avh4$elm_color$Color$rgba$(rMixed, gMixed, bMixed, alphaMixed);
};
var $noahzgordon$elm_color_extra$Color$Manipulate$weightedMix = F3($noahzgordon$elm_color_extra$Color$Manipulate$weightedMix$);
var $author$project$GuildIcon$discordBlurpleDark = $noahzgordon$elm_color_extra$Color$Manipulate$weightedMix$($author$project$MyUi$background1, $author$project$GuildIcon$discordBlurple, 0.3);
var $author$project$GuildIcon$discordBlurpleFont = $author$project$Ui$rgb$(193, 197, 239);
var $author$project$GuildIcon$discordNotificationView$ = function (xOffset, yOffset, notification) {
	switch (notification.$) {
		case 0:
			return $author$project$Ui$inFront(
				$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$rounded(99),
							$author$project$Ui$background($author$project$GuildIcon$discordBlurpleDark),
							$author$project$Ui$width(
							$author$project$Ui$px($author$project$GuildIcon$notificationHeight)),
							$author$project$Ui$height(
							$author$project$Ui$px($author$project$GuildIcon$notificationHeight)),
							$author$project$Ui$move(
							{x: xOffset, y: yOffset, z: 0}),
							$author$project$Ui$alignRight,
							$author$project$Ui$contentCenterX,
							$author$project$Ui$contentCenterY,
							$author$project$Ui$Font$color($author$project$GuildIcon$discordBlurpleFont),
							$author$project$Ui$Accessibility$description($author$project$GuildIcon$discordLabel),
							$author$project$MyUi$noPointerEvents
						]),
					$author$project$Ui$html($author$project$Icons$discord)));
		case 1:
			var count = notification.a;
			return $author$project$GuildIcon$notificationHelper$($author$project$MyUi$white, $author$project$MyUi$black, $author$project$GuildIcon$discordBlurpleDark, xOffset, yOffset, count);
		default:
			var count = notification.a;
			return $author$project$GuildIcon$notificationHelper$($author$project$MyUi$alertColor, $author$project$MyUi$white, $author$project$GuildIcon$discordBlurpleDark, xOffset, yOffset, count);
	}
};
var $author$project$GuildIcon$discordNotificationView = F3($author$project$GuildIcon$discordNotificationView$);
var $author$project$GuildIcon$iconView = function (url) {
	return $author$project$Ui$html(
		A2(
			$elm$html$Html$img,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$Attributes$style,
					'width',
					$elm$core$String$fromInt($author$project$GuildIcon$size) + 'px'),
					A2(
					$elm$html$Html$Attributes$style,
					'height',
					$elm$core$String$fromInt($author$project$GuildIcon$size) + 'px'),
					$elm$html$Html$Attributes$src(url),
					$author$project$MyUi$lazyLoading,
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2($elm$html$Html$Attributes$style, 'align-self', 'flex-start'),
					A2($elm$html$Html$Attributes$style, 'object-fit', 'cover'),
					A2(
					$elm$html$Html$Attributes$style,
					'border-radius',
					'0 ' + ($elm$core$String$fromInt($author$project$GuildIcon$iconRounding) + ('px ' + ($elm$core$String$fromInt($author$project$GuildIcon$iconRounding) + 'px 0'))))
				]),
			_List_Nil));
};
var $author$project$GuildIcon$discordUserView$ = function (notification, maybeIcon, userId) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$GuildIcon$discordNotificationView$(-4, -3, notification)
			]),
		$author$project$GuildIcon$iconView(
			function () {
				if (!maybeIcon.$) {
					var icon = maybeIcon.a;
					return $author$project$FileStatus$fileUrl$($author$project$FileStatus$pngContent, icon);
				} else {
					return $author$project$Discord$defaultUserAvatarUrl$(
						$author$project$Discord$TwoToNthPower(7),
						userId);
				}
			}()));
};
var $author$project$GuildIcon$discordUserView = F3($author$project$GuildIcon$discordUserView$);
var $author$project$GuildColumn$elLinkButton$ = function (htmlId, route, attributes, content) {
	return $author$project$MyUi$elButton$(
		htmlId,
		$author$project$Types$PressedLink(route),
		attributes,
		content);
};
var $author$project$GuildColumn$elLinkButton = F4($author$project$GuildColumn$elLinkButton$);
var $author$project$GuildColumn$discordDmGuildIcon$ = function (route, localUser, channelId, dmChannel) {
	var dmIcon = function () {
		var _v1 = $author$project$GuildColumn$discordDmHasNotifications$(localUser, channelId, dmChannel);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var currentUserId = _v2.a;
			var count = _v2.b;
			var userId = $elm$core$Maybe$withDefault$(
				currentUserId,
				$elm$core$List$head(
					$lamdera$containers$SeqDict$keys(
						$author$project$NonemptyDict$remove$(currentUserId, dmChannel.members))));
			var maybeIcon = $elm$core$Maybe$andThen$(
				function ($) {
					return $.icon;
				},
				$author$project$User$getDiscordUser$(userId, localUser));
			return $author$project$GuildColumn$elLinkButton$(
				$lamdera$program_test$Effect$Browser$Dom$id(
					'guildsColumn_openDiscordDm_' + $author$project$Discord$idToString(channelId)),
				$author$project$Route$DiscordDmRoute(
					{channelId: channelId, channelsVisible: 0, currentDiscordUserId: currentUserId, overlay: $elm$core$Maybe$Nothing, showMembersTab: 1, tab: $elm$core$Maybe$Nothing, viewingMessage: $elm$core$Maybe$Nothing}),
				_List_Nil,
				$author$project$GuildIcon$discordUserView$(
					$author$project$GuildIcon$NewMessageForUser(count),
					maybeIcon,
					userId));
		} else {
			return $author$project$Ui$none;
		}
	}();
	if (route.$ === 6) {
		var dmRoute = route.a;
		return _Utils_eq(dmRoute.channelId, channelId) ? $author$project$Ui$none : dmIcon;
	} else {
		return dmIcon;
	}
};
var $author$project$GuildColumn$discordDmGuildIcon = F4($author$project$GuildColumn$discordDmGuildIcon$);
var $author$project$GuildIcon$guildIconView$ = function (mode, url) {
	return $author$project$Ui$html(
		A2(
			$elm$html$Html$img,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$Attributes$style,
					'width',
					$elm$core$String$fromInt($author$project$GuildIcon$size) + 'px'),
					A2(
					$elm$html$Html$Attributes$style,
					'height',
					$elm$core$String$fromInt($author$project$GuildIcon$size) + 'px'),
					$elm$html$Html$Attributes$src(url),
					$author$project$MyUi$lazyLoading,
					A2($elm$html$Html$Attributes$style, 'display', 'flex'),
					A2(
					$elm$html$Html$Attributes$style,
					'background-color',
					$author$project$MyUi$colorToStyle($author$project$MyUi$guildIconBackground)),
					A2(
					$elm$html$Html$Attributes$style,
					'opacity',
					function () {
						if (mode.$ === 1) {
							return '0';
						} else {
							return '1';
						}
					}()),
					A2(
					$elm$html$Html$Attributes$style,
					'align-self',
					function () {
						if (mode.$ === 1) {
							return 'flex-end';
						} else {
							return 'flex-start';
						}
					}()),
					A2($elm$html$Html$Attributes$style, 'object-fit', 'cover'),
					A2(
					$elm$html$Html$Attributes$style,
					'border-radius',
					function () {
						if (mode.$ === 1) {
							return $elm$core$String$fromInt($author$project$GuildIcon$iconRounding) + ('px 0 0 ' + ($elm$core$String$fromInt($author$project$GuildIcon$iconRounding) + 'px'));
						} else {
							return '0 ' + ($elm$core$String$fromInt($author$project$GuildIcon$iconRounding) + ('px ' + ($elm$core$String$fromInt($author$project$GuildIcon$iconRounding) + 'px 0')));
						}
					}())
				]),
			_List_Nil));
};
var $author$project$GuildIcon$guildIconView = F2($author$project$GuildIcon$guildIconView$);
var $author$project$GuildIcon$guildIcon$ = function (guild, mode, name) {
	var _v0 = guild.icon;
	if (!_v0.$) {
		var icon = _v0.a;
		return $author$project$GuildIcon$guildIconView$(
			mode,
			$author$project$FileStatus$fileUrl$($author$project$FileStatus$pngContent, icon));
	} else {
		return $author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$contentCenterX,
					$author$project$Ui$contentCenterY,
					function () {
					if (mode.$ === 1) {
						return $author$project$GuildIcon$selectedRounding;
					} else {
						return $author$project$GuildIcon$notSelectedRounding;
					}
				}(),
					$author$project$MyUi$notoSans,
					$author$project$Ui$Font$weight(600),
					$author$project$Ui$background(
					function () {
						if (mode.$ === 1) {
							return $author$project$Ui$rgba$(0, 0, 0, 0);
						} else {
							return $author$project$MyUi$secondaryGray;
						}
					}()),
					function () {
					if (mode.$ === 1) {
						return $author$project$Ui$alignRight;
					} else {
						return $author$project$Ui$alignLeft;
					}
				}(),
					$author$project$Ui$width(
					$author$project$Ui$px($author$project$GuildIcon$size)),
					$author$project$Ui$height(
					$author$project$Ui$px($author$project$GuildIcon$size)),
					$author$project$Ui$Font$size(
					$elm$core$Basics$round(($author$project$GuildIcon$size * 18) / 50)),
					$author$project$Ui$Font$color($author$project$GuildIcon$iconFontColor),
					$author$project$MyUi$hoverText(name)
				]),
			$author$project$Ui$text(
				$elm$core$String$concat(
					$elm$core$List$map$(
						$elm$core$String$left(1),
						$elm$core$List$take$(
							3,
							$elm$core$String$words(
								A2(
									$elm$core$String$filter,
									function (_char) {
										return $elm$core$Char$isAlphaNum(_char) || (_char === ' ');
									},
									$elm$core$String$replace$('-', ' ', name))))))));
	}
};
var $author$project$GuildIcon$guildIcon = F3($author$project$GuildIcon$guildIcon$);
var $author$project$GuildIcon$view$ = function (mode, guild) {
	return $author$project$Ui$el$(
		A2(
			$elm$core$List$cons,
			$author$project$GuildIcon$notificationView$(
				-4,
				-3,
				$author$project$MyUi$background1,
				function () {
					if (mode.$ === 1) {
						return $author$project$GuildIcon$NoNotification;
					} else {
						var notification = mode.a;
						return notification;
					}
				}()),
			$author$project$GuildIcon$selectedEdgeCurves$(mode, guild.icon)),
		$author$project$GuildIcon$guildIcon$(
			guild,
			mode,
			$author$project$GuildName$toString(guild.name)));
};
var $author$project$GuildIcon$view = F2($author$project$GuildIcon$view$);
var $author$project$GuildColumn$discordGuildIcon$ = function (localUser, route, guildId, guild) {
	var _v0 = $author$project$GuildColumn$discordGuildCurrentUserId$(localUser, guild);
	if (!_v0.$) {
		var discordUserId = _v0.a;
		return $author$project$GuildColumn$elLinkButton$(
			$lamdera$program_test$Effect$Browser$Dom$id(
				'guild_openDiscordGuild_' + $author$project$Discord$idToString(guildId)),
			$author$project$GuildColumn$discordGuildRoute$(localUser, discordUserId, guildId, guild),
			_List_Nil,
			$author$project$GuildIcon$view$(
				function () {
					if (route.$ === 4) {
						var data = route.a;
						return _Utils_eq(data.guildId, guildId) ? $author$project$GuildIcon$IsSelected : $author$project$GuildIcon$Normal(
							$author$project$GuildColumn$discordGuildHasNotifications$(discordUserId, localUser.user, guildId, guild));
					} else {
						return $author$project$GuildIcon$Normal(
							$author$project$GuildColumn$discordGuildHasNotifications$(discordUserId, localUser.user, guildId, guild));
					}
				}(),
				guild));
	} else {
		return $author$project$Ui$none;
	}
};
var $author$project$GuildColumn$discordGuildIcon = F4($author$project$GuildColumn$discordGuildIcon$);
var $author$project$GuildIcon$userView$ = function (notification, maybeIcon, color) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$GuildIcon$notificationView$(-4, -3, $author$project$MyUi$background1, notification)
			]),
		function () {
			if (!maybeIcon.$) {
				var icon = maybeIcon.a;
				return $author$project$GuildIcon$iconView(
					$author$project$FileStatus$fileUrl$($author$project$FileStatus$pngContent, icon));
			} else {
				return $author$project$GuildIcon$defaultUser$($author$project$GuildIcon$size, $author$project$GuildIcon$notSelectedRounding, color);
			}
		}());
};
var $author$project$GuildIcon$userView = F3($author$project$GuildIcon$userView$);
var $author$project$GuildColumn$dmGuildIcon$ = function (route, localUser, otherUserId, dmChannel) {
	var dmIcon = function () {
		var _v1 = $author$project$GuildColumn$dmHasNotifications$(localUser.user, otherUserId, dmChannel);
		if (!_v1.$) {
			var count = _v1.a;
			return $author$project$GuildColumn$elLinkButton$(
				$lamdera$program_test$Effect$Browser$Dom$id(
					'guildsColumn_openDm_' + $author$project$Id$toString(otherUserId)),
				$author$project$Route$DmRoute(
					{
						channelId: $author$project$DmChannelId$fromUserIds$(localUser.session.userId, otherUserId),
						channelsVisible: 0,
						overlay: $elm$core$Maybe$Nothing,
						tab: $elm$core$Maybe$Nothing,
						threadRoute: $author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1)
					}),
				_List_Nil,
				function () {
					var _v2 = $author$project$User$getUser$(otherUserId, localUser);
					if (!_v2.$) {
						var otherUser = _v2.a;
						return $author$project$GuildIcon$userView$(
							$author$project$GuildIcon$NewMessageForUser(count),
							otherUser.icon,
							otherUser.color);
					} else {
						return $author$project$GuildIcon$userView$(
							$author$project$GuildIcon$NewMessageForUser(count),
							$elm$core$Maybe$Nothing,
							$author$project$RichText$defaultColor);
					}
				}());
		} else {
			return $author$project$Ui$none;
		}
	}();
	if (route.$ === 5) {
		var dmRoute = route.a;
		return _Utils_eq(
			$elm$core$Maybe$Just(otherUserId),
			$author$project$DmChannelId$otherUserId$(localUser.session.userId, dmRoute.channelId)) ? $author$project$Ui$none : dmIcon;
	} else {
		return dmIcon;
	}
};
var $author$project$GuildColumn$dmGuildIcon = F4($author$project$GuildColumn$dmGuildIcon$);
var $author$project$GuildColumn$guildIcon$ = function (localUser, route, guildId, guild) {
	return $author$project$GuildColumn$elLinkButton$(
		$lamdera$program_test$Effect$Browser$Dom$id(
			'guild_openGuild_' + $author$project$Id$toString(guildId)),
		$author$project$GuildColumn$guildRoute$(localUser, guildId, guild),
		_List_Nil,
		$author$project$GuildIcon$view$(
			function () {
				if (route.$ === 3) {
					var a = route.a;
					return _Utils_eq(a, guildId) ? $author$project$GuildIcon$IsSelected : $author$project$GuildIcon$Normal(
						$author$project$GuildColumn$guildHasNotifications$(localUser.user, guildId, guild));
				} else {
					return $author$project$GuildIcon$Normal(
						$author$project$GuildColumn$guildHasNotifications$(localUser.user, guildId, guild));
				}
			}(),
			guild));
};
var $author$project$GuildColumn$guildIcon = F4($author$project$GuildColumn$guildIcon$);
var $author$project$Icons$userGroup = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$width('32'),
			$elm$svg$Svg$Attributes$fill('currentColor')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$d('M8.25 6.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0ZM15.75 9.75a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM2.25 9.75a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM6.31 15.117A6.745 6.745 0 0 1 12 12a6.745 6.745 0 0 1 6.709 7.498.75.75 0 0 1-.372.568A12.696 12.696 0 0 1 12 21.75c-2.305 0-4.47-.612-6.337-1.684a.75.75 0 0 1-.372-.568 6.787 6.787 0 0 1 1.019-4.38Z'),
					$elm$svg$Svg$Attributes$clipRule('evenodd')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M5.082 14.254a8.287 8.287 0 0 0-1.308 5.135 9.687 9.687 0 0 1-1.764-.44l-.115-.04a.563.563 0 0 1-.373-.487l-.01-.121a3.75 3.75 0 0 1 3.57-4.047ZM20.226 19.389a8.287 8.287 0 0 0-1.308-5.135 3.75 3.75 0 0 1 3.57 4.047l-.01.121a.563.563 0 0 1-.373.486l-.115.04c-.567.2-1.156.349-1.764.441Z')
				]),
			_List_Nil)
		]));
var $author$project$GuildIcon$showFriendsButton = function (onPress) {
	return $author$project$MyUi$elButton$(
		$lamdera$program_test$Effect$Browser$Dom$id('guildIcon_showFriends'),
		onPress,
		_List_fromArray(
			[
				$author$project$Ui$contentCenterX,
				$author$project$Ui$contentCenterY,
				$author$project$Ui$alignLeft,
				$author$project$GuildIcon$notSelectedRounding,
				$author$project$MyUi$notoSans,
				$author$project$Ui$Font$weight(600),
				$author$project$Ui$background($author$project$MyUi$secondaryGray),
				$author$project$Ui$border(1),
				$author$project$Ui$borderColor($author$project$MyUi$secondaryGrayBorder),
				$author$project$Ui$width(
				$author$project$Ui$px($author$project$GuildIcon$size)),
				$author$project$Ui$height(
				$author$project$Ui$px($author$project$GuildIcon$size)),
				$author$project$Ui$padding(8),
				$author$project$Ui$Font$color($author$project$GuildIcon$iconFontColor),
				$author$project$MyUi$hoverText('Show friends list')
			]),
		$author$project$Ui$html($author$project$Icons$userGroup));
};
var $author$project$User$slackUserColor$ = function (localUser, userId) {
	var _v0 = $lamdera$containers$SeqDict$get$(userId, localUser.slackUsers);
	if (!_v0.$) {
		var user = _v0.a;
		return user.color;
	} else {
		return $author$project$RichText$defaultColor;
	}
};
var $author$project$User$slackUserColor = F2($author$project$User$slackUserColor$);
var $author$project$GuildColumn$slackDmGuildIcon$ = function (route, localUser, channelId, dmChannel) {
	var dmIcon = function () {
		var _v1 = $author$project$GuildColumn$slackDmHasNotifications$(localUser, channelId, dmChannel);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var currentUserId = _v2.a;
			var count = _v2.b;
			var otherUserId = $elm$core$Maybe$withDefault$(
				currentUserId,
				$elmcraft$core_extra$List$Extra$find$(
					function (userId) {
						return !_Utils_eq(userId, currentUserId);
					},
					$author$project$NonemptySet$toList(dmChannel.members)));
			return $author$project$GuildColumn$elLinkButton$(
				$lamdera$program_test$Effect$Browser$Dom$id(
					'guildsColumn_openSlackDm_' + $author$project$Slack$idToString(channelId)),
				$author$project$Route$SlackDmRoute(
					{
						channelId: channelId,
						channelsVisible: 0,
						currentSlackUserId: currentUserId,
						overlay: $elm$core$Maybe$Nothing,
						threadRoute: $author$project$Id$NoThreadWithMaybeMessage($elm$core$Maybe$Nothing)
					}),
				_List_Nil,
				$author$project$GuildIcon$userView$(
					$author$project$GuildIcon$NewMessageForUser(count),
					$elm$core$Maybe$andThen$(
						function ($) {
							return $.icon;
						},
						$lamdera$containers$SeqDict$get$(otherUserId, localUser.slackUsers)),
					$author$project$User$slackUserColor$(localUser, otherUserId)));
		} else {
			return $author$project$Ui$none;
		}
	}();
	if (route.$ === 8) {
		var dmRoute = route.a;
		return _Utils_eq(dmRoute.channelId, channelId) ? $author$project$Ui$none : dmIcon;
	} else {
		return dmIcon;
	}
};
var $author$project$GuildColumn$slackDmGuildIcon = F4($author$project$GuildColumn$slackDmGuildIcon$);
var $author$project$GuildIcon$slackView$ = function (mode, name, icon) {
	return $author$project$Ui$el$(
		A2(
			$elm$core$List$cons,
			$author$project$GuildIcon$notificationView$(
				-4,
				-3,
				$author$project$MyUi$background1,
				function () {
					if (mode.$ === 1) {
						return $author$project$GuildIcon$NoNotification;
					} else {
						var notification = mode.a;
						return notification;
					}
				}()),
			$author$project$GuildIcon$selectedEdgeCurves$(mode, icon)),
		$author$project$GuildIcon$guildIcon$(
			{icon: icon},
			mode,
			name));
};
var $author$project$GuildIcon$slackView = F3($author$project$GuildIcon$slackView$);
var $author$project$GuildColumn$slackWorkspaceIcons$ = function (route, localUser, teamId, workspace) {
	var _v0 = $author$project$GuildColumn$slackWorkspaceCurrentUserId$(localUser, teamId);
	if (!_v0.$) {
		var currentSlackUserId = _v0.a;
		var _v1 = $author$project$GuildColumn$slackWorkspaceRoute$(localUser, currentSlackUserId, teamId, workspace);
		if (!_v1.$) {
			var workspaceRoute = _v1.a;
			return $author$project$GuildColumn$elLinkButton$(
				$lamdera$program_test$Effect$Browser$Dom$id(
					'guild_openSlackWorkspace_' + $author$project$Slack$idToString(teamId)),
				workspaceRoute,
				_List_Nil,
				$author$project$GuildIcon$slackView$(
					function () {
						if (route.$ === 7) {
							var data = route.a;
							return _Utils_eq(data.teamId, teamId) ? $author$project$GuildIcon$IsSelected : $author$project$GuildIcon$Normal(
								$author$project$GuildColumn$slackWorkspaceHasNotifications$(currentSlackUserId, localUser.user, teamId, workspace));
						} else {
							return $author$project$GuildIcon$Normal(
								$author$project$GuildColumn$slackWorkspaceHasNotifications$(currentSlackUserId, localUser.user, teamId, workspace));
						}
					}(),
					workspace.name,
					workspace.icon));
		} else {
			return $author$project$Ui$none;
		}
	} else {
		return $author$project$Ui$none;
	}
};
var $author$project$GuildColumn$slackWorkspaceIcons = F4($author$project$GuildColumn$slackWorkspaceIcons$);
var $author$project$GuildColumn$guildColumn$ = function (isMobile, route, local, canScroll2) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$inFront(
				$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$backgroundGradient(
							_List_fromArray(
								[
									$author$project$Ui$Gradient$linear$(
									$author$project$Ui$radians(0),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Gradient$percent,
											0,
											$author$project$Ui$rgba$(0, 0, 0, 0)),
											A2($author$project$Ui$Gradient$percent, 100, $author$project$MyUi$black)
										]))
								])),
							$author$project$MyUi$htmlStyle$(
							'height',
							$elm$core$String$fromInt(
								$elm$core$Basics$max$(6, local.localUser.safeAreaInsetTop)) + 'px')
						]),
					$author$project$Ui$none)),
				$author$project$Ui$width(
				$author$project$Ui$px($author$project$MyUi$guildIconFullWidth - 1)),
				$author$project$Ui$height($author$project$Ui$fill)
			]),
		$author$project$Ui$column$(
			_List_fromArray(
				[
					$author$project$Ui$spacing(6),
					$author$project$Ui$width(
					$author$project$Ui$px($author$project$MyUi$guildIconFullWidth)),
					$author$project$Ui$height($author$project$Ui$fill),
					$author$project$MyUi$scrollable(canScroll2),
					$author$project$MyUi$htmlStyle$('overflow-x', 'hidden'),
					$author$project$Ui$htmlAttribute(
					$elm$html$Html$Attributes$class('disable-scrollbars')),
					$author$project$Ui$paddingWith(
					{
						bottom: 4,
						left: 0,
						right: 0,
						top: $elm$core$Basics$max$(6, local.localUser.safeAreaInsetTop)
					}),
					$author$project$MyUi$bounceScroll(isMobile)
				]),
			_Utils_ap(
				$elm$core$List$map$(
					function (_v0) {
						var otherUserId = _v0.a;
						var dmChannel = _v0.b;
						return $author$project$Ui$Lazy$lazy4$($author$project$GuildColumn$dmGuildIcon, route, local.localUser, otherUserId, dmChannel);
					},
					$lamdera$containers$SeqDict$toList(local.dmChannels)),
				_Utils_ap(
					$elm$core$List$map$(
						function (_v1) {
							var channelId = _v1.a;
							var dmChannel = _v1.b;
							return $author$project$Ui$Lazy$lazy4$($author$project$GuildColumn$discordDmGuildIcon, route, local.localUser, channelId, dmChannel);
						},
						$lamdera$containers$SeqDict$toList(local.discordDmChannels)),
					_Utils_ap(
						$elm$core$List$map$(
							function (_v2) {
								var channelId = _v2.a;
								var dmChannel = _v2.b;
								return $author$project$Ui$Lazy$lazy4$($author$project$GuildColumn$slackDmGuildIcon, route, local.localUser, channelId, dmChannel);
							},
							$lamdera$containers$SeqDict$toList(local.slackDmChannels)),
						A2(
							$elm$core$List$cons,
							$author$project$GuildIcon$showFriendsButton(
								$author$project$Types$PressedLink(
									$author$project$Route$HomePageRoute($elm$core$Maybe$Nothing))),
							_Utils_ap(
								$elm$core$List$map$(
									function (_v3) {
										var guildId = _v3.a;
										var guild = _v3.b;
										return $author$project$Ui$Lazy$lazy4$($author$project$GuildColumn$guildIcon, local.localUser, route, guildId, guild);
									},
									$lamdera$containers$SeqDict$toList(local.guilds)),
								_Utils_ap(
									$elm$core$List$map$(
										function (_v4) {
											var teamId = _v4.a;
											var workspace = _v4.b;
											return $author$project$Ui$Lazy$lazy4$($author$project$GuildColumn$slackWorkspaceIcons, route, local.localUser, teamId, workspace);
										},
										$lamdera$containers$SeqDict$toList(local.slackWorkspaces)),
									_Utils_ap(
										$elm$core$List$map$(
											function (_v5) {
												var guildId = _v5.a;
												var guild = _v5.b;
												return $author$project$Ui$Lazy$lazy4$($author$project$GuildColumn$discordGuildIcon, local.localUser, route, guildId, guild);
											},
											$lamdera$containers$SeqDict$toList(local.discordGuilds)),
										_List_fromArray(
											[
												$author$project$GuildIcon$addGuildButton$(
												$lamdera$program_test$Effect$Browser$Dom$id('guild_createGuild'),
												_Utils_eq(route, $author$project$Route$NewGuildRoute),
												$author$project$Types$PressedLink($author$project$Route$NewGuildRoute))
											]))))))))));
};
var $author$project$GuildColumn$guildColumn = F4($author$project$GuildColumn$guildColumn$);
var $author$project$GuildColumn$guildColumnCanScrollMobile$ = function (route, local) {
	return $author$project$GuildColumn$guildColumn$(true, route, local, true);
};
var $author$project$GuildColumn$guildColumnCanScrollMobile = F2($author$project$GuildColumn$guildColumnCanScrollMobile$);
var $author$project$GuildColumn$guildColumnCanScrollNotMobile$ = function (route, local) {
	return $author$project$GuildColumn$guildColumn$(false, route, local, true);
};
var $author$project$GuildColumn$guildColumnCanScrollNotMobile = F2($author$project$GuildColumn$guildColumnCanScrollNotMobile$);
var $author$project$GuildColumn$guildColumnCannotScrollMobile$ = function (route, local) {
	return $author$project$GuildColumn$guildColumn$(true, route, local, false);
};
var $author$project$GuildColumn$guildColumnCannotScrollMobile = F2($author$project$GuildColumn$guildColumnCannotScrollMobile$);
var $author$project$GuildColumn$guildColumnCannotScrollNotMobile$ = function (route, local) {
	return $author$project$GuildColumn$guildColumn$(false, route, local, false);
};
var $author$project$GuildColumn$guildColumnCannotScrollNotMobile = F2($author$project$GuildColumn$guildColumnCannotScrollNotMobile$);
var $author$project$GuildColumn$guildColumnLazy$ = function (isMobile, model, local) {
	return $author$project$Ui$Lazy$lazy2$(
		function () {
			var _v0 = _Utils_Tuple2(
				$author$project$MyUi$canScroll$(isMobile, model.drag),
				isMobile);
			if (_v0.a) {
				if (_v0.b) {
					return $author$project$GuildColumn$guildColumnCanScrollMobile;
				} else {
					return $author$project$GuildColumn$guildColumnCanScrollNotMobile;
				}
			} else {
				if (_v0.b) {
					return $author$project$GuildColumn$guildColumnCannotScrollMobile;
				} else {
					return $author$project$GuildColumn$guildColumnCannotScrollNotMobile;
				}
			}
		}(),
		model.route,
		local);
};
var $author$project$GuildColumn$guildColumnLazy = F3($author$project$GuildColumn$guildColumnLazy$);
var $author$project$Types$PressedShowUserOption = {$: 72};
var $author$project$Pages$Guild$loggedInAsView = function (localUser) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$Font$color($author$project$MyUi$font2),
				$author$project$Ui$borderColor($author$project$MyUi$border1),
				$author$project$Ui$borderWith(
				{bottom: 0, left: 0, right: 0, top: 1}),
				$author$project$Ui$background($author$project$MyUi$background1),
				$author$project$Ui$paddingWith(
				{bottom: localUser.safeAreaInsetBottom + 4, left: 4, right: 4, top: 4}),
				$author$project$Ui$spacing(8),
				$author$project$Ui$clipWithEllipsis
			]),
		_List_fromArray(
			[
				$author$project$User$profileImage(
				$elm$core$Maybe$Just(localUser.user)),
				$author$project$Ui$text(
				$author$project$PersonName$toString(localUser.user.name)),
				$author$project$MyUi$elButton$(
				$lamdera$program_test$Effect$Browser$Dom$id('guild_showUserOptions'),
				$author$project$Types$PressedShowUserOption,
				_List_fromArray(
					[
						$author$project$Ui$width(
						$author$project$Ui$px(38)),
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$contentCenterY,
						$author$project$Ui$paddingXY$(8, 0),
						$author$project$Ui$alignRight,
						$author$project$MyUi$hoverText('User settings')
					]),
				$author$project$Ui$html($author$project$Icons$gear))
			]));
};
var $author$project$Pages$Guild$pageMissingMobile = function (text) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$Ui$contentCenterY,
				$author$project$Ui$Font$center,
				$author$project$Ui$Font$color($author$project$MyUi$font1),
				$author$project$Ui$Font$size(20),
				$author$project$Ui$background($author$project$MyUi$background2)
			]),
		$author$project$Ui$text(text));
};
var $author$project$Pages$Guild$guildErrorPage$ = function (error, local, model) {
	return $author$project$MyUi$isMobile(model) ? $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$Ui$background($author$project$MyUi$background1),
				$author$project$Ui$heightMin(0),
				$author$project$Ui$clip
			]),
		_List_fromArray(
			[
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$heightMin(0)
					]),
				_List_fromArray(
					[
						$author$project$GuildColumn$guildColumnLazy$(true, model, local),
						$author$project$Pages$Guild$pageMissingMobile(error)
					])),
				$author$project$Ui$Lazy$lazy$($author$project$Pages$Guild$loggedInAsView, local.localUser)
			])) : $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$Ui$background($author$project$MyUi$background1)
			]),
		_List_fromArray(
			[
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$width(
						$author$project$Ui$px(
							$author$project$MyUi$channelAndGuildColumnWidth(model.windowSize)))
					]),
				_List_fromArray(
					[
						$author$project$GuildColumn$guildColumnLazy$(false, model, local),
						$author$project$Ui$Lazy$lazy$($author$project$Pages$Guild$loggedInAsView, local.localUser)
					])),
				$author$project$Pages$Guild$pageMissing(error)
			]));
};
var $author$project$Pages$Guild$guildErrorPage = F3($author$project$Pages$Guild$guildErrorPage$);
var $author$project$FileStatus$durationToString = function (duration) {
	var total = $elm$core$Basics$round(
		$ianmackenzie$elm_units$Duration$inSeconds(duration));
	var pad = function (value) {
		return $elm$core$String$padLeft$(
			2,
			'0',
			$elm$core$String$fromInt(value));
	};
	return (total >= 3600) ? ($elm$core$String$fromInt((total / 3600) | 0) + (':' + (pad(
		A2($elm$core$Basics$modBy, 60, (total / 60) | 0)) + (':' + pad(
		A2($elm$core$Basics$modBy, 60, total)))))) : ($elm$core$String$fromInt((total / 60) | 0) + (':' + pad(
		A2($elm$core$Basics$modBy, 60, total))));
};
var $author$project$FileStatus$exposureTimeToString = function (exposure) {
	return (exposure.numerator === 1) ? ('1/' + ($elm$core$String$fromInt(exposure.denominator) + 's')) : ($elm$core$String$fromInt(exposure.numerator) + ('/' + ($elm$core$String$fromInt(exposure.denominator) + 's')));
};
var $author$project$FileStatus$imageLabel$ = function (title, value) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$MyUi$htmlStyle$('white-space', 'pre-wrap')
			]),
		_List_fromArray(
			[
				$author$project$Ui$text(title + ': '),
				$author$project$Ui$text(value)
			]));
};
var $author$project$FileStatus$imageLabel = F2($author$project$FileStatus$imageLabel$);
var $author$project$FileStatus$infoPanel$ = function (safeAreaInsetTop, safeAreaInsetBottom, contents) {
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$Ui$scrollable,
				$author$project$Ui$heightMin(0),
				$author$project$Ui$background($author$project$MyUi$background1),
				$author$project$Ui$paddingWith(
				{bottom: safeAreaInsetBottom, left: 0, right: 0, top: safeAreaInsetTop + 16}),
				$author$project$Ui$spacing(16)
			]),
		contents);
};
var $author$project$FileStatus$infoPanel = F3($author$project$FileStatus$infoPanel$);
var $author$project$FileStatus$locationToString = function (location) {
	return $author$project$SafeFloat$toString(location.lat) + (', ' + $author$project$SafeFloat$toString(location.lon));
};
var $author$project$FileStatus$orientationToString = function (orientation) {
	switch (orientation) {
		case 0:
			return 'Normal';
		case 1:
			return 'Rotate 90°';
		case 2:
			return 'Rotate 180°';
		case 3:
			return 'Rotate 270°';
		case 4:
			return 'Mirrored';
		case 5:
			return 'Mirrored, rotate 90°';
		case 6:
			return 'Mirrored, rotate 180°';
		default:
			return 'Mirrored, rotate 270°';
	}
};
var $author$project$FileStatus$imageInfoView$ = function (safeAreaInsetTop, safeAreaInsetBottom, timezone, onPressClose, fileData) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$inFront(
				$author$project$MyUi$elButton$(
					$lamdera$program_test$Effect$Browser$Dom$id('fileStatus_closeImageInfo'),
					onPressClose,
					_List_fromArray(
						[
							$author$project$Ui$alignRight,
							$author$project$Ui$paddingXY$(16, 16),
							$author$project$MyUi$htmlStyle$(
							'transform',
							'translateY(' + ($elm$core$String$fromInt(safeAreaInsetTop) + 'px)')),
							$author$project$MyUi$hoverText('Close')
						]),
					$author$project$Ui$html($author$project$Icons$x)))
			]),
		function () {
			var _v0 = fileData.metadata;
			if (!_v0.$) {
				var metadata = _v0.a;
				return $author$project$FileStatus$infoPanel$(
					safeAreaInsetTop,
					safeAreaInsetBottom,
					_List_fromArray(
						[
							$author$project$Ui$column$(
							_List_fromArray(
								[
									$author$project$Ui$spacing(2),
									$author$project$Ui$alignBottom,
									$author$project$Ui$paddingXY$(8, 0)
								]),
							A2(
								$elm$core$List$cons,
								$author$project$FileStatus$imageLabel$(
									'Image size',
									$elm$core$String$fromInt(
										$author$project$Coord$xRaw(metadata.imageSize)) + ('×' + $elm$core$String$fromInt(
										$author$project$Coord$yRaw(metadata.imageSize)))),
								$elm$core$List$filterMap$(
									$elm$core$Basics$identity,
									_List_fromArray(
										[
											$elm$core$Maybe$map$(
											function (orientation) {
												return $author$project$FileStatus$imageLabel$(
													'Orientation',
													$author$project$FileStatus$orientationToString(orientation));
											},
											metadata.orientation),
											$elm$core$Maybe$map$(
											function (location) {
												return $author$project$FileStatus$imageLabel$(
													'Location',
													$author$project$FileStatus$locationToString(location));
											},
											metadata.gpsLocation),
											$elm$core$Maybe$map$(
											$author$project$FileStatus$imageLabel('Camera owner'),
											metadata.cameraOwner),
											$elm$core$Maybe$map$(
											function (exposure) {
												return $author$project$FileStatus$imageLabel$(
													'Exposure time',
													$author$project$FileStatus$exposureTimeToString(exposure));
											},
											metadata.exposureTime),
											$elm$core$Maybe$map$(
											function (fNumber) {
												return $author$project$FileStatus$imageLabel$(
													'F-number',
													'f/' + $author$project$SafeFloat$toString(fNumber));
											},
											metadata.fNumber),
											$elm$core$Maybe$map$(
											function (focal) {
												return $author$project$FileStatus$imageLabel$(
													'Focal length',
													$author$project$SafeFloat$toString(focal) + 'mm');
											},
											metadata.focalLength),
											$elm$core$Maybe$map$(
											function (iso) {
												return $author$project$FileStatus$imageLabel$(
													'ISO',
													$elm$core$String$fromInt(iso));
											},
											metadata.isoSpeedRating),
											$elm$core$Maybe$map$(
											$author$project$FileStatus$imageLabel('Make'),
											metadata.make),
											$elm$core$Maybe$map$(
											$author$project$FileStatus$imageLabel('Model'),
											metadata.model),
											$elm$core$Maybe$map$(
											$author$project$FileStatus$imageLabel('Software'),
											metadata.software),
											$elm$core$Maybe$map$(
											$author$project$FileStatus$imageLabel('Comment'),
											metadata.userComment)
										])))),
							$author$project$Ui$image$(
							_List_fromArray(
								[
									$author$project$Ui$widthMax(
									$author$project$Coord$xRaw(metadata.imageSize)),
									$author$project$Ui$centerX
								]),
							{
								description: '',
								onLoad: $elm$core$Maybe$Nothing,
								source: $author$project$FileStatus$fileDataUrl(fileData)
							})
						]));
			} else {
				var metadata = _v0.a;
				return $author$project$FileStatus$infoPanel$(
					safeAreaInsetTop,
					safeAreaInsetBottom,
					_List_fromArray(
						[
							$author$project$Ui$column$(
							_List_fromArray(
								[
									$author$project$Ui$spacing(2),
									$author$project$Ui$alignBottom,
									$author$project$Ui$paddingXY$(8, 0)
								]),
							A2(
								$elm$core$List$cons,
								$author$project$FileStatus$imageLabel$(
									'Video size',
									$elm$core$String$fromInt(
										$author$project$Coord$xRaw(metadata.videoSize)) + ('×' + $elm$core$String$fromInt(
										$author$project$Coord$yRaw(metadata.videoSize)))),
								$elm$core$List$filterMap$(
									$elm$core$Basics$identity,
									_List_fromArray(
										[
											$elm$core$Maybe$map$(
											$author$project$FileStatus$imageLabel('Title'),
											metadata.title),
											$elm$core$Maybe$map$(
											function (duration) {
												return $author$project$FileStatus$imageLabel$(
													'Duration',
													$author$project$FileStatus$durationToString(duration));
											},
											metadata.duration),
											(!metadata.orientation) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
											$author$project$FileStatus$imageLabel$(
												'Orientation',
												$author$project$FileStatus$orientationToString(metadata.orientation))),
											$elm$core$Maybe$map$(
											$author$project$FileStatus$imageLabel('Codec'),
											metadata.codec),
											$elm$core$Maybe$map$(
											function (time) {
												return $author$project$FileStatus$imageLabel$(
													'Recorded',
													$author$project$MyUi$datestamp$(timezone, time) + (' ' + $author$project$MyUi$timestamp$(time, timezone)));
											},
											metadata.createdAt),
											$elm$core$Maybe$map$(
											function (location) {
												return $author$project$FileStatus$imageLabel$(
													'Location',
													$author$project$FileStatus$locationToString(location));
											},
											metadata.gpsLocation)
										])))),
							$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$widthMax(
									$author$project$Coord$xRaw(metadata.videoSize)),
									$author$project$Ui$centerX
								]),
							$author$project$Ui$html(
								A2(
									$elm$html$Html$video,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src(
											$author$project$FileStatus$fileDataUrl(fileData)),
											$elm$html$Html$Attributes$controls(true),
											A2($elm$html$Html$Attributes$style, 'display', 'block'),
											A2($elm$html$Html$Attributes$style, 'width', '100%')
										]),
									_List_Nil)))
						]));
			}
		}());
};
var $author$project$FileStatus$imageInfoView = F5($author$project$FileStatus$imageInfoView$);
var $author$project$Call$memberColumnOffset$ = function (sidebarMode, model) {
	return $elm$core$Basics$round(
		$elm$core$Basics$clamp$(
			0,
			1,
			$author$project$Call$sidebarOffset(sidebarMode)) * $author$project$Coord$xRaw(model.windowSize));
};
var $author$project$Call$memberColumnOffset = F2($author$project$Call$memberColumnOffset$);
var $author$project$Route$toShowMembersTabVisible$ = function (_v0, route) {
	var sidebarMode = _v0.sidebarMode;
	var helper = function (showChannelSettings) {
		if (!sidebarMode.$) {
			var offset = sidebarMode.a.offset;
			if (!showChannelSettings) {
				return 0;
			} else {
				return (offset < 1) ? 0 : 1;
			}
		} else {
			var offset = sidebarMode.a.offset;
			if (!showChannelSettings) {
				return 0;
			} else {
				return (offset < 1) ? 0 : 1;
			}
		}
	};
	switch (route.$) {
		case 5:
			var dmRoute = route.a;
			return $elm$core$Tuple$mapFirst$(
				helper,
				$author$project$Route$threadRouteToShowMembersTab(dmRoute.threadRoute));
		case 0:
			return _Utils_Tuple2(1, false);
		case 1:
			return _Utils_Tuple2(1, false);
		case 2:
			return _Utils_Tuple2(1, false);
		case 3:
			var channelRoute = route.b;
			switch (channelRoute.$) {
				case 0:
					var threadRoute = channelRoute.b;
					return $elm$core$Tuple$mapFirst$(
						helper,
						$author$project$Route$threadRouteToShowMembersTab(threadRoute));
				case 1:
					return _Utils_Tuple2(1, false);
				case 2:
					return _Utils_Tuple2(1, false);
				default:
					return _Utils_Tuple2(1, false);
			}
		case 4:
			var routeData = route.a;
			var _v3 = routeData.channelRoute;
			switch (_v3.$) {
				case 0:
					var threadRoute = _v3.b;
					return $elm$core$Tuple$mapFirst$(
						helper,
						$author$project$Route$threadRouteToShowMembersTab(threadRoute));
				case 1:
					return _Utils_Tuple2(1, false);
				default:
					return _Utils_Tuple2(1, false);
			}
		case 6:
			var routeData = route.a;
			return _Utils_Tuple2(routeData.showMembersTab, false);
		case 7:
			var routeData = route.a;
			var _v4 = routeData.channelRoute;
			if (!_v4.$) {
				var threadRoute = _v4.b;
				var showMembers = _v4.c;
				return _Utils_Tuple2(
					helper(showMembers),
					$author$project$Route$slackIsThread(threadRoute));
			} else {
				return _Utils_Tuple2(1, false);
			}
		case 8:
			return _Utils_Tuple2(1, false);
		case 9:
			return _Utils_Tuple2(1, false);
		case 10:
			return _Utils_Tuple2(1, false);
		case 11:
			return _Utils_Tuple2(1, false);
		case 12:
			return _Utils_Tuple2(1, false);
		default:
			return _Utils_Tuple2(1, false);
	}
};
var $author$project$Route$toShowMembersTabVisible = F2($author$project$Route$toShowMembersTabVisible$);
var $author$project$MyUi$unscrollable = $author$project$MyUi$htmlStyle$('overflow', 'clip');
var $author$project$Pages$Guild$discordGuildView$ = function (model, routeData, loggedIn, local) {
	var _v0 = loggedIn.showFileToUploadInfo;
	if (!_v0.$) {
		var fileData = _v0.a;
		return $author$project$FileStatus$imageInfoView$(local.localUser.safeAreaInsetTop, local.localUser.safeAreaInsetBottom, model.timezone, $author$project$Types$PressedCloseImageInfo, fileData);
	} else {
		var _v1 = _Utils_Tuple2(
			$lamdera$containers$SeqDict$get$(routeData.guildId, local.discordGuilds),
			$author$project$LinkedAndOtherDiscordUsers$getLinkedUser$(routeData.currentDiscordUserId, local.localUser.discordUsers));
		if (!_v1.a.$) {
			if (!_v1.b.$) {
				var guild = _v1.a.a;
				var currentDiscordUser = _v1.b.a;
				if ($author$project$MembersAndOwner$isMember$(routeData.currentDiscordUserId, guild.membersAndOwner) === 2) {
					return $author$project$Pages$Guild$guildErrorPage$(
						'Selected Discord user (' + ($author$project$PersonName$toString(currentDiscordUser.name) + ') is not a member of this guild'),
						local,
						model);
				} else {
					if ($author$project$MyUi$isMobile(model)) {
						var showMembers = $author$project$Route$toShowMembersTabVisible$(loggedIn, model.route);
						var canScroll2 = $author$project$MyUi$canScroll$(
							$author$project$MyUi$isMobile(model),
							model.drag);
						return $author$project$Ui$column$(
							_List_fromArray(
								[
									$author$project$Ui$height($author$project$Ui$fill),
									$author$project$Ui$background($author$project$MyUi$background1),
									$author$project$Ui$heightMin(0),
									$author$project$MyUi$unscrollable,
									$author$project$Ui$inFront(
									function () {
										if (!showMembers.a) {
											var _v3 = showMembers.a;
											var _v4 = routeData.channelRoute;
											switch (_v4.$) {
												case 0:
													var channelId = _v4.a;
													var threadRoute = _v4.b;
													return $author$project$Ui$el$(
														_List_fromArray(
															[
																$author$project$Ui$height($author$project$Ui$fill),
																$author$project$Ui$background($author$project$MyUi$background3),
																$author$project$Ui$paddingWith(
																{bottom: 0, left: 0, right: 0, top: local.localUser.safeAreaInsetTop}),
																$author$project$Ui$move(
																{
																	x: $author$project$Call$memberColumnOffset$(loggedIn.sidebarMode, model),
																	y: 0,
																	z: 0
																}),
																$author$project$Ui$heightMin(0)
															]),
														$author$project$Ui$Lazy$lazy6$($author$project$Pages$Guild$discordChannelSettingsMobile, canScroll2, local.localUser, routeData, guild, channelId, threadRoute));
												case 1:
													return $author$project$Pages$Guild$discordMemberColumnContainer(_List_Nil);
												default:
													return $author$project$Pages$Guild$discordMemberColumnContainer(_List_Nil);
											}
										} else {
											var _v5 = showMembers.a;
											return $author$project$Ui$none;
										}
									}()),
									$author$project$Ui$inFront(
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$height($author$project$Ui$fill),
												$author$project$Ui$background($author$project$MyUi$background3),
												$author$project$Ui$paddingWith(
												{bottom: 0, left: 0, right: 0, top: local.localUser.safeAreaInsetTop}),
												$author$project$Ui$move(
												{
													x: $author$project$Call$conversationOffset$(loggedIn.sidebarMode, model),
													y: 0,
													z: 0
												}),
												$author$project$Ui$heightMin(0)
											]),
										$author$project$Pages$Guild$discordChannelView$(routeData, guild, loggedIn, local, model)))
								]),
							_List_fromArray(
								[
									$author$project$Ui$row$(
									_List_fromArray(
										[
											$author$project$Ui$height($author$project$Ui$fill),
											$author$project$Ui$heightMin(0),
											$author$project$MyUi$htmlStyle$('isolation', 'isolate')
										]),
									_List_fromArray(
										[
											$author$project$GuildColumn$guildColumnLazy$(true, model, local),
											$author$project$Pages$Guild$discordChannelColumnLazy$(true, canScroll2, model, local.localUser, routeData, guild)
										])),
									$author$project$Ui$Lazy$lazy$($author$project$Pages$Guild$loggedInAsView, local.localUser)
								]));
					} else {
						return $author$project$Ui$row$(
							_List_fromArray(
								[
									$author$project$Ui$height($author$project$Ui$fill),
									$author$project$Ui$background($author$project$MyUi$background1)
								]),
							_List_fromArray(
								[
									$author$project$Ui$column$(
									_List_fromArray(
										[
											$author$project$Ui$height($author$project$Ui$fill),
											$author$project$Ui$width(
											$author$project$Ui$px(
												$author$project$MyUi$channelAndGuildColumnWidth(model.windowSize)))
										]),
									_List_fromArray(
										[
											$author$project$Ui$row$(
											_List_fromArray(
												[
													$author$project$Ui$height($author$project$Ui$fill),
													$author$project$Ui$heightMin(0)
												]),
											_List_fromArray(
												[
													$author$project$GuildColumn$guildColumnLazy$(false, model, local),
													$author$project$Pages$Guild$discordChannelColumnLazy$(false, true, model, local.localUser, routeData, guild)
												])),
											$author$project$Ui$Lazy$lazy$($author$project$Pages$Guild$loggedInAsView, local.localUser)
										])),
									$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$height($author$project$Ui$fill),
											$author$project$Ui$paddingWith(
											{bottom: 0, left: 0, right: 0, top: local.localUser.safeAreaInsetTop})
										]),
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$height($author$project$Ui$fill),
												$author$project$Ui$background($author$project$MyUi$background3),
												$author$project$Ui$heightMin(0),
												$author$project$Ui$borderColor($author$project$MyUi$border1),
												$author$project$Ui$borderWith(
												{bottom: 0, left: 0, right: 0, top: 1})
											]),
										$author$project$Pages$Guild$discordChannelView$(routeData, guild, loggedIn, local, model))),
									function () {
									var _v6 = $author$project$Route$toShowMembersTabVisible$(loggedIn, model.route);
									if (!_v6.a) {
										var _v7 = _v6.a;
										var _v8 = routeData.channelRoute;
										switch (_v8.$) {
											case 0:
												var channelId = _v8.a;
												var threadRoute = _v8.b;
												return $author$project$Ui$el$(
													_List_fromArray(
														[
															$author$project$Ui$width($author$project$Ui$shrink),
															$author$project$Ui$height($author$project$Ui$fill),
															$author$project$Ui$paddingWith(
															{bottom: 0, left: 0, right: 0, top: local.localUser.safeAreaInsetTop})
														]),
													$author$project$Ui$Lazy$lazy6$($author$project$Pages$Guild$discordChannelSettingsNotMobile, local.localUser, routeData.guildId, routeData.currentDiscordUserId, guild, channelId, threadRoute));
											case 1:
												return $author$project$Ui$none;
											default:
												return $author$project$Ui$none;
										}
									} else {
										var _v9 = _v6.a;
										return $author$project$Ui$none;
									}
								}()
								]));
					}
				}
			} else {
				var _v10 = _v1.b;
				return $author$project$Pages$Guild$guildErrorPage$('Discord user not found', local, model);
			}
		} else {
			var _v11 = _v1.a;
			return $author$project$Pages$Guild$guildErrorPage$('Discord guild not found', local, model);
		}
	}
};
var $author$project$Pages$Guild$discordGuildView = F4($author$project$Pages$Guild$discordGuildView$);
var $author$project$Frontend$discordLinkExpiredText = 'This Discord link has expired';
var $author$project$Frontend$discordLinkLimitReachedText = 'Sorry, too many people have already linked Discord accounts. We starting with only a small number of slots to make sure nothing breaks.';
var $author$project$Frontend$discordLinkServerErrorText = 'Failed to link your Discord account due to a server error';
var $author$project$Types$PressedShowLogin = {$: 6};
var $author$project$MyUi$outwardBottomCorner$ = function (radius, isLeft, color) {
	var r = $elm$core$String$fromInt(radius);
	var translate = isLeft ? ('translate(-' + (r + 'px, 0)')) : ('translate(' + (r + 'px, 0)'));
	var overlap = 1;
	var w = $elm$core$String$fromInt(radius + overlap);
	var path = isLeft ? ('M ' + (w + (',0 L ' + (r + (',0 A ' + (r + (' ' + (r + (' 0 0 1 0,' + (r + (' L ' + (w + (',' + (r + ' Z')))))))))))))) : ('M 0,0 L ' + ($elm$core$String$fromInt(overlap) + (',0 A ' + (r + (' ' + (r + (' 0 0 0 ' + (w + (',' + (r + (' L 0,' + (r + ' Z'))))))))))));
	return $author$project$Ui$inFront(
		$author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$alignBottom,
					isLeft ? $author$project$Ui$alignLeft : $author$project$Ui$alignRight,
					$author$project$Ui$move(
					{x: 0, y: 1, z: 0}),
					$author$project$Ui$width(
					$author$project$Ui$px(radius + overlap)),
					$author$project$Ui$height(
					$author$project$Ui$px(radius)),
					$author$project$Ui$Font$color(color),
					$author$project$MyUi$htmlStyle$('transform', translate),
					$author$project$MyUi$htmlStyle$('pointer-events', 'none')
				]),
			$author$project$Ui$html(
				A2(
					$elm$svg$Svg$svg,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$width(w),
							$elm$svg$Svg$Attributes$height(r),
							$elm$svg$Svg$Attributes$viewBox('0 0 ' + (w + (' ' + r))),
							$elm$svg$Svg$Attributes$style('display:block')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$path,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$d(path),
									$elm$svg$Svg$Attributes$fill('currentColor')
								]),
							_List_Nil)
						])))));
};
var $author$project$MyUi$outwardBottomCorner = F3($author$project$MyUi$outwardBottomCorner$);
var $author$project$Pages$Home$buttonAttributes$ = function (isMobile, isSelected) {
	return _List_fromArray(
		[
			$author$project$Ui$Font$weight(600),
			$author$project$Ui$rounded(8),
			$author$project$Ui$padding(8),
			$author$project$Ui$width($author$project$Ui$shrink),
			$author$project$Ui$height($author$project$Ui$fill),
			$author$project$Ui$paddingWith(
			{bottom: 8, left: 16, right: 16, top: 4}),
			$author$project$Ui$roundedWith(
			{bottomLeft: 0, bottomRight: 0, topLeft: 8, topRight: 8}),
			$author$project$Ui$attrIf$(
			isSelected,
			$author$project$Ui$background($author$project$MyUi$background3)),
			$author$project$Ui$attrIf$(
			isSelected,
			$author$project$MyUi$outwardBottomCorner$(16, true, $author$project$MyUi$background3)),
			$author$project$Ui$attrIf$(
			isSelected,
			$author$project$MyUi$outwardBottomCorner$(16, false, $author$project$MyUi$background3)),
			$author$project$Ui$contentCenterY,
			$author$project$Ui$Font$color(
			isSelected ? $author$project$MyUi$font1 : $author$project$MyUi$font3),
			$author$project$MyUi$hover$(
			isMobile,
			_List_fromArray(
				[
					$author$project$Ui$Anim$fontColor($author$project$MyUi$font1)
				]))
		]);
};
var $author$project$Pages$Home$buttonAttributes = F2($author$project$Pages$Home$buttonAttributes$);
var $author$project$Icons$github = function (width) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromInt(width))
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.01 8.01 0 0 0 16 8c0-4.42-3.58-8-8-8z')
					]),
				_List_Nil)
			]));
};
var $author$project$Pages$Home$loginButtonId = $lamdera$program_test$Effect$Browser$Dom$id('homePage_loginButton');
var $author$project$Pages$Home$loginSignupText = 'Login/Signup';
var $author$project$Pages$Privacy$repoUrl = 'https://github.com/MartinSStewart/at-chat';
var $author$project$Pages$Home$header$ = function (isMobile, safeAreaInsetTop, route, loginStatus) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$background($author$project$MyUi$background1),
				$author$project$Ui$Shadow$shadows(
				_List_fromArray(
					[
						{
						blur: 2,
						color: $author$project$Ui$rgba$(0, 0, 0, 0.05),
						size: 0,
						x: 0,
						y: 1
					}
					]))
			]),
		$author$project$Ui$row$(
			_List_fromArray(
				[
					$author$project$Ui$paddingWith(
					{bottom: 0, left: 16, right: 16, top: 4 + safeAreaInsetTop}),
					$author$project$Ui$contentCenterY,
					$author$project$MyUi$notoSans,
					$author$project$Ui$widthMax(1280),
					$author$project$Ui$centerX
				]),
			_List_fromArray(
				[
					$author$project$Ui$image$(
					_List_fromArray(
						[
							$author$project$Ui$width(
							$author$project$Ui$px(64)),
							$author$project$Ui$paddingWith(
							{bottom: 8, left: 8, right: 8, top: 4}),
							$author$project$Ui$Input$button(
							$author$project$Types$PressedLink(
								$author$project$Route$HomePageRoute($elm$core$Maybe$Nothing)))
						]),
					{description: 'Logo', onLoad: $elm$core$Maybe$Nothing, source: '/cacheable/at-logo-no-background.png'}),
					$author$project$Ui$row$(
					_List_fromArray(
						[
							$author$project$Ui$width($author$project$Ui$shrink),
							$author$project$Ui$height($author$project$Ui$fill),
							$author$project$Ui$alignRight
						]),
					_List_fromArray(
						[
							$author$project$MyUi$elButton$(
							$lamdera$program_test$Effect$Browser$Dom$id('homePage_privacyButton'),
							$author$project$Types$PressedLink($author$project$Route$PrivacyRoute),
							$author$project$Pages$Home$buttonAttributes$(
								isMobile,
								function () {
									if (!loginStatus.$) {
										return _Utils_eq(route, $author$project$Route$PrivacyRoute);
									} else {
										var notLoggedIn = loginStatus.a;
										return _Utils_eq(route, $author$project$Route$PrivacyRoute) && _Utils_eq(notLoggedIn.loginForm, $elm$core$Maybe$Nothing);
									}
								}()),
							$author$project$Ui$text('Privacy')),
							$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$width($author$project$Ui$shrink),
									$author$project$Ui$height($author$project$Ui$fill),
									$author$project$Ui$contentCenterY,
									$author$project$Ui$paddingWith(
									{
										bottom: 8,
										left: isMobile ? 8 : 16,
										right: isMobile ? 8 : 16,
										top: 4
									}),
									$author$project$Ui$linkNewTab($author$project$Pages$Privacy$repoUrl),
									$author$project$MyUi$hoverText('Source code on GitHub'),
									$author$project$Ui$Font$color($author$project$MyUi$font3),
									$author$project$MyUi$hover$(
									isMobile,
									_List_fromArray(
										[
											$author$project$Ui$Anim$fontColor($author$project$MyUi$font1)
										]))
								]),
							$author$project$Ui$html(
								$author$project$Icons$github(20))),
							function () {
							if (!loginStatus.$) {
								return $author$project$Ui$none;
							} else {
								var notLoggedIn = loginStatus.a;
								return $author$project$MyUi$elButton$(
									$author$project$Pages$Home$loginButtonId,
									$author$project$Types$PressedShowLogin,
									$author$project$Pages$Home$buttonAttributes$(
										isMobile,
										(!_Utils_eq(notLoggedIn.loginForm, $elm$core$Maybe$Nothing)) || $author$project$Route$requiresLogin(route)),
									$author$project$Ui$text($author$project$Pages$Home$loginSignupText));
							}
						}()
						]))
				])));
};
var $author$project$Pages$Home$header = F4($author$project$Pages$Home$header$);
var $author$project$Frontend$errorPage$ = function (model, text) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$inFront(
				$author$project$Pages$Home$header$(
					$author$project$MyUi$isMobile(model),
					model.startupData.safeAreaInsetTop,
					model.route,
					model.loginStatus)),
				$author$project$Ui$height($author$project$Ui$fill)
			]),
		$author$project$Ui$column$(
			_List_fromArray(
				[
					$author$project$Ui$centerY,
					$author$project$Ui$spacing(16)
				]),
			_List_fromArray(
				[
					$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$width($author$project$Ui$shrink),
							$author$project$Ui$centerX
						]),
					$author$project$Ui$text(text)),
					$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$width($author$project$Ui$shrink),
							$author$project$Ui$centerX
						]),
					$author$project$MyUi$simpleButton$(
						$lamdera$program_test$Effect$Browser$Dom$id('frontend_goToHomepage'),
						$author$project$Types$PressedLink(
							$author$project$Route$HomePageRoute($elm$core$Maybe$Nothing)),
						$author$project$Ui$text('Go to homepage')))
				])));
};
var $author$project$Frontend$errorPage = F2($author$project$Frontend$errorPage$);
var $author$project$Types$PressedAddDomainToWhitelist = function (a) {
	return {$: 137, a: a};
};
var $author$project$Types$PressedCloseExternalLinkWarning = {$: 136};
var $author$project$Types$PressedContinueToSite = {$: 145};
var $author$project$Ui$Input$blue = $author$project$Ui$rgb$(59, 153, 252);
var $author$project$Ui$up = function (y) {
	return {x: 0, y: -y, z: 0};
};
var $author$project$Ui$Input$defaultCheckbox = function (checked) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$width(
				$author$project$Ui$px(14)),
				$author$project$Ui$height(
				$author$project$Ui$px(14)),
				$author$project$Ui$Font$color($author$project$Ui$Input$white),
				$author$project$Ui$Font$size(9),
				$author$project$Ui$Font$center,
				$author$project$Ui$centerY,
				$author$project$Ui$rounded(3),
				$author$project$Ui$borderColor(
				checked ? $author$project$Ui$rgb$(59, 153, 252) : $author$project$Ui$rgb$(211, 211, 211)),
				$author$project$Ui$border(
				checked ? 0 : 1),
				checked ? $author$project$Ui$noAttr : $author$project$Ui$Shadow$shadows(
				_List_fromArray(
					[
						{
						blur: 1,
						color: $author$project$Ui$rgb$(238, 238, 238),
						size: 1,
						x: 0,
						y: 0
					}
					])),
				$author$project$Ui$background(
				checked ? $author$project$Ui$Input$blue : $author$project$Ui$Input$white)
			]),
		checked ? $author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$borderWith(
					{bottom: 2, left: 2, right: 0, top: 0}),
					$author$project$Ui$borderColor($author$project$Ui$Input$white),
					$author$project$Ui$height(
					$author$project$Ui$px(6)),
					$author$project$Ui$width(
					$author$project$Ui$px(9)),
					$author$project$Ui$rotate(
					$author$project$Ui$turns(1 - 0.125)),
					$author$project$Ui$centerX,
					$author$project$Ui$centerY,
					$author$project$Ui$move(
					$author$project$Ui$up(1))
				]),
			$author$project$Ui$none) : $author$project$Ui$none);
};
var $author$project$Ui$Input$enter = 'Enter';
var $author$project$Ui$Input$checkbox$ = function (attrs, options) {
	var input = $author$project$Internal$Model2$element$(
		$author$project$Internal$Model2$NodeAsInput,
		2,
		_Utils_ap(
			_List_fromArray(
				[
					$author$project$Internal$Model2$attribute(
					$elm$html$Html$Attributes$type_('checkbox')),
					$author$project$Internal$Model2$attribute(
					A2(
						$elm$html$Html$Attributes$attribute,
						'aria-checked',
						options.checked ? 'true' : 'false')),
					$author$project$Internal$Model2$attribute(
					$elm$html$Html$Attributes$class($author$project$Internal$Style$Generated$classes.inputReset)),
					$author$project$Ui$Input$labelAttribute(options.label),
					$author$project$Internal$Model2$attribute(
					$elm$html$Html$Events$onClick(
						options.onChange(!options.checked))),
					$author$project$Ui$Input$onKeyLookup2(
					function (code) {
						return _Utils_eq(code, $author$project$Ui$Input$enter) ? $elm$core$Maybe$Just(
							options.onChange(!options.checked)) : (_Utils_eq(code, $author$project$Ui$Input$space) ? $elm$core$Maybe$Just(
							options.onChange(!options.checked)) : $elm$core$Maybe$Nothing);
					}),
					$author$project$Internal$Model2$attribute(
					$elm$html$Html$Attributes$tabindex(0)),
					$author$project$Ui$pointer,
					$author$project$Ui$width($author$project$Ui$fill),
					$author$project$Ui$height($author$project$Ui$fill)
				]),
			attrs),
		_List_Nil);
	var icon = function () {
		var viewIcon = $elm$core$Maybe$withDefault$($author$project$Ui$Input$defaultCheckbox, options.icon);
		return viewIcon(options.checked);
	}();
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$inFront(input),
				$author$project$Ui$width($author$project$Ui$shrink),
				$author$project$Ui$height($author$project$Ui$shrink)
			]),
		icon);
};
var $author$project$Ui$Input$checkbox = F2($author$project$Ui$Input$checkbox$);
var $author$project$MyUi$scrim = $author$project$Ui$rgba$(0, 0, 0, 0.5);
var $author$project$FrontendExtra$externalLinkWarning$ = function (domainWhitelist, isMobile, url) {
	var urlText = $elm$url$Url$toString(url);
	var label = $author$project$Ui$Input$label$(
		'frontend_addDomainToWhitelist',
		_List_fromArray(
			[
				$author$project$MyUi$htmlStyle$('cursor', 'pointer'),
				$author$project$Ui$paddingLeft(12)
			]),
		$author$project$Ui$Prose$paragraph$(
			_List_fromArray(
				[
					$author$project$Ui$paddingXY$(0, 4)
				]),
			_List_fromArray(
				[
					$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$Font$color($author$project$MyUi$font3)
						]),
					$author$project$Ui$text('Don\u0027t ask again about links to ')),
					$author$project$Ui$el$(
					_List_fromArray(
						[$author$project$Ui$Font$noWrap]),
					$author$project$Ui$text(url.host))
				])));
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$behindContent(
				$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$background($author$project$MyUi$scrim),
							$author$project$Ui$height($author$project$Ui$fill),
							$author$project$Ui$Events$onClick($author$project$Types$PressedCloseExternalLinkWarning)
						]),
					$author$project$Ui$none)),
				$author$project$Ui$height($author$project$Ui$fill)
			]),
		$author$project$Ui$column$(
			_List_fromArray(
				[
					$author$project$Ui$centerX,
					isMobile ? $author$project$Ui$alignBottom : $author$project$Ui$centerY,
					$author$project$Ui$attrIf$(
					!isMobile,
					$author$project$Ui$rounded(16)),
					isMobile ? $author$project$Ui$paddingXY$(16, 16) : $author$project$Ui$paddingXY$(24, 24),
					$author$project$Ui$background($author$project$MyUi$background3),
					isMobile ? $author$project$Ui$width($author$project$Ui$fill) : $author$project$Ui$widthMax(600),
					$author$project$Ui$width($author$project$Ui$shrink),
					$author$project$Ui$spacing(24),
					$author$project$Ui$borderColor($author$project$MyUi$border1),
					$author$project$Ui$border(1)
				]),
			_List_fromArray(
				[
					$author$project$Ui$column$(
					_List_fromArray(
						[
							$author$project$Ui$spacing(8)
						]),
					_List_fromArray(
						[
							$author$project$Ui$row$(
							_List_fromArray(
								[
									$author$project$Ui$Font$color($author$project$MyUi$font3),
									$author$project$Ui$spacing(16),
									$author$project$Ui$contentCenterY,
									$author$project$Ui$Font$bold
								]),
							_List_fromArray(
								[
									$author$project$Ui$html(
									$author$project$Icons$warning(36)),
									$author$project$Ui$text('Heads up, you are leaving at-chat and going to:')
								])),
							$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$MyUi$htmlStyle$('word-break', 'break-all')
								]),
							$author$project$Ui$text(urlText))
						])),
					$author$project$Ui$row$(
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Input$checkbox$(
							_List_fromArray(
								[
									$author$project$Ui$Font$size(14)
								]),
							{
								checked: $lamdera$containers$SeqSet$member$(
									$author$project$RichText$urlToDomain(url),
									domainWhitelist),
								icon: $elm$core$Maybe$Nothing,
								label: label.id,
								onChange: $author$project$Types$PressedAddDomainToWhitelist
							}),
							label.element
						])),
					$author$project$Ui$row$(
					_List_Nil,
					_List_fromArray(
						[
							$author$project$MyUi$secondaryButtonTall$(
							$lamdera$program_test$Effect$Browser$Dom$id('frontend_cancelLeaveExternal'),
							$author$project$Types$PressedCloseExternalLinkWarning,
							'Back'),
							$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$linkNewTab(urlText),
									$author$project$Ui$Events$onClick($author$project$Types$PressedContinueToSite),
									$author$project$Ui$borderColor($author$project$MyUi$buttonBorder),
									$author$project$Ui$border(1),
									$author$project$Ui$background($author$project$MyUi$buttonBackground),
									$author$project$Ui$rounded(4),
									$author$project$Ui$width($author$project$Ui$shrink),
									$author$project$Ui$paddingXY$(16, 8),
									$author$project$Ui$Font$weight(500),
									$author$project$Ui$Font$color($author$project$MyUi$white),
									$author$project$MyUi$htmlStyle$('text-decoration', 'none'),
									$author$project$Ui$alignRight
								]),
							$author$project$Ui$text('Continue to site'))
						]))
				])));
};
var $author$project$FrontendExtra$externalLinkWarning = F3($author$project$FrontendExtra$externalLinkWarning$);
var $author$project$Frontend$goMatchNotFoundText = 'Go match not found';
var $author$project$Pages$Guild$channelColumnRow$ = function (isMobile, isMuted, hasNotification, usersInCall, channelRoute, guildId, channelId, channel) {
	var isSelected = function () {
		if ((!channelRoute.$) && (!channelRoute.b.$)) {
			var a = channelRoute.a;
			var _v1 = channelRoute.b;
			return _Utils_eq(a, channelId);
		} else {
			return false;
		}
	}();
	return $author$project$GuildColumn$rowLinkButton$(
		$lamdera$program_test$Effect$Browser$Dom$id(
			'guild_openChannel_' + $author$project$Id$toString(channelId)),
		$author$project$Route$GuildRoute$(
			guildId,
			$author$project$Route$ChannelRoute$(
				channelId,
				$author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1),
				$elm$core$Maybe$Nothing),
			0,
			$elm$core$Maybe$Nothing),
		_List_fromArray(
			[
				$author$project$Ui$paddingWith(
				{bottom: 0, left: 26, right: 8, top: 0}),
				$author$project$Ui$inFront(
				$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$GuildIcon$notificationView$(
							0,
							-3,
							$author$project$MyUi$background2,
							(isSelected && (!isMobile)) ? $author$project$GuildIcon$NoNotification : hasNotification),
							$author$project$Ui$width(
							$author$project$Ui$px(20)),
							$author$project$Ui$move(
							{x: 4, y: 0, z: 0}),
							$author$project$Ui$centerY
						]),
					$author$project$Ui$html($author$project$Icons$hashtag))),
				isSelected ? $author$project$Ui$Font$color($author$project$MyUi$font1) : $author$project$Ui$Font$color($author$project$MyUi$font3),
				$author$project$MyUi$hover$(
				isMobile,
				_List_fromArray(
					[
						$author$project$Ui$Anim$fontColor($author$project$MyUi$font1)
					])),
				$author$project$Ui$attrIf$(
				isSelected,
				$author$project$Ui$background($author$project$MyUi$selectedHighlight)),
				$author$project$Ui$clipWithEllipsis,
				$author$project$Ui$height(
				$author$project$Ui$px($author$project$MyUi$channelHeaderHeight)),
				$author$project$MyUi$hoverText(
				$author$project$ChannelName$toString(channel.name)),
				$author$project$Ui$contentCenterY,
				$author$project$MyUi$noShrinking
			]),
		_List_fromArray(
			[
				$author$project$Ui$text(
				$author$project$ChannelName$toString(channel.name)),
				$author$project$User$multipleProfileImages(usersInCall),
				$author$project$Pages$Guild$channelIsMuted(isMuted)
			]));
};
var $author$project$Pages$Guild$channelColumnRow = F8($author$project$Pages$Guild$channelColumnRow$);
var $author$project$Pages$Guild$channelColumnThreads$ = function (isMobile, now, channelRoute, directMentions, localUser, channels, guildId, channelId, channel, threads) {
	var threads2 = $elm$core$List$filterMap$(
		function (_v2) {
			var threadMessageIndex = _v2.a;
			var thread = _v2.b;
			var isSelected = function () {
				if ((!channelRoute.$) && (channelRoute.b.$ === 1)) {
					var a = channelRoute.a;
					var _v6 = channelRoute.b;
					var b = _v6.a;
					return _Utils_eq(a, channelId) && _Utils_eq(b, threadMessageIndex);
				} else {
					return false;
				}
			}();
			var isMuted = $author$project$MuteSettings$isChannelMuted$(
				localUser.user.muteSettings,
				guildId,
				channelId,
				$author$project$Id$ViewThread(threadMessageIndex));
			var hasNotifications = $author$project$GuildColumn$channelOrThreadHasNotifications$(
				isMuted,
				directMentions,
				$lamdera$containers$SeqSet$member$(guildId, localUser.user.notifyOnAllMessages),
				channelId,
				$author$project$Id$ViewThread(threadMessageIndex),
				$lamdera$containers$SeqDict$get$(
					_Utils_Tuple2(
						$author$project$Id$GuildOrDmId(
							$author$project$Id$GuildOrDmId_Guild(
								{channelId: channelId, guildId: guildId})),
						threadMessageIndex),
					localUser.user.lastViewedThreadMessage),
				thread);
			var _v3 = _Utils_Tuple3(
				hasNotifications,
				isSelected,
				$author$project$MessageArray$last(thread.messages));
			if (((!_v3.a.$) && (!_v3.b)) && (!_v3.c.$)) {
				var _v4 = _v3.a;
				var message = _v3.c.a;
				return $ianmackenzie$elm_units$Quantity$lessThan$(
					$ianmackenzie$elm_units$Duration$week,
					$ianmackenzie$elm_units$Duration$from$(
						$author$project$Message$createdAt(message),
						now)) ? $elm$core$Maybe$Just(
					_Utils_Tuple3(
						threadMessageIndex,
						_Utils_Tuple2(isMuted, hasNotifications),
						isSelected)) : $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Just(
					_Utils_Tuple3(
						threadMessageIndex,
						_Utils_Tuple2(isMuted, hasNotifications),
						isSelected));
			}
		},
		$lamdera$containers$SeqDict$toList(threads));
	var count = $elm$core$List$length(threads2);
	return $author$project$Ui$column$(
		_List_Nil,
		$elm$core$List$indexedMap$(
			F2(
				function (index, _v0) {
					var threadMessageIndex = _v0.a;
					var _v1 = _v0.b;
					var isMuted = _v1.a;
					var hasNotifications = _v1.b;
					var isSelected = _v0.c;
					return $author$project$Pages$Guild$channelColumnThreadsHelper$(
						isMobile,
						isSelected,
						isMuted,
						hasNotifications,
						index,
						count,
						$lamdera$program_test$Effect$Browser$Dom$id(
							'guild_viewThread_' + ($author$project$Id$toString(channelId) + ('_' + $author$project$Id$toString(threadMessageIndex)))),
						$author$project$Route$GuildRoute$(
							guildId,
							$author$project$Route$ChannelRoute$(
								channelId,
								$author$project$Route$ViewThreadWithFriends$(threadMessageIndex, $elm$core$Maybe$Nothing, 1),
								$elm$core$Maybe$Nothing),
							0,
							$elm$core$Maybe$Nothing),
						$author$project$Pages$Guild$threadPreviewText$(
							localUser.timezone,
							$author$project$User$allUsers(localUser),
							channels,
							threadMessageIndex,
							localUser.decryptedMessages,
							channel));
				}),
			threads2));
};
var $author$project$Pages$Guild$channelColumnThreads = function (isMobile) {
	return function (now) {
		return function (channelRoute) {
			return function (directMentions) {
				return function (localUser) {
					return function (channels) {
						return function (guildId) {
							return function (channelId) {
								return function (channel) {
									return function (threads) {
										return $author$project$Pages$Guild$channelColumnThreads$(isMobile, now, channelRoute, directMentions, localUser, channels, guildId, channelId, channel, threads);
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Guild$channelColumn$ = function (isMobile, time, localUser, calls, guildId, guild, channelRoute, canScroll2) {
	var newChannelButton = function () {
		var _v4 = $author$project$MembersAndOwner$isMember$(localUser.session.userId, guild.membersAndOwner);
		if (_v4 === 1) {
			var isSelected = _Utils_eq(channelRoute, $author$project$Route$NewChannelRoute);
			return $author$project$GuildColumn$rowLinkButton$(
				$lamdera$program_test$Effect$Browser$Dom$id('guild_newChannel'),
				$author$project$Route$GuildRoute$(guildId, $author$project$Route$NewChannelRoute, 0, $elm$core$Maybe$Nothing),
				_List_fromArray(
					[
						$author$project$Ui$paddingXY$(4, 8),
						$author$project$Ui$Font$color($author$project$MyUi$font3),
						$author$project$Ui$attrIf$(
						isSelected,
						$author$project$Ui$background($author$project$MyUi$selectedHighlight)),
						$author$project$MyUi$hover$(
						isMobile,
						_List_fromArray(
							[
								$author$project$Ui$Anim$fontColor($author$project$MyUi$font1)
							])),
						isSelected ? $author$project$Ui$Font$color($author$project$MyUi$font1) : $author$project$Ui$Font$color($author$project$MyUi$font3)
					]),
				_List_fromArray(
					[
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$width(
								$author$project$Ui$px(22))
							]),
						$author$project$Ui$html($author$project$Icons$plusIcon)),
						$author$project$Ui$text(' Add new channel')
					]));
		} else {
			return $author$project$Ui$none;
		}
	}();
	var guildName = $author$project$GuildName$toString(guild.name);
	var directMentions = $lamdera$containers$SeqDict$get$(guildId, localUser.user.directMentions);
	var channels = $author$project$LocalState$guildChannelMentions$(localUser, guild.channels);
	return $author$project$Pages$Guild$channelColumnContainer$(
		localUser.safeAreaInsetTop,
		_List_fromArray(
			[
				$author$project$GuildColumn$elLinkButton$(
				$lamdera$program_test$Effect$Browser$Dom$id('guild_inviteLinkCreatorRoute'),
				$author$project$Route$GuildRoute$(guildId, $author$project$Route$GuildSettingsRoute, 0, $elm$core$Maybe$Nothing),
				_List_fromArray(
					[
						$author$project$Ui$Font$color($author$project$MyUi$font2),
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$contentCenterY,
						$author$project$MyUi$hoverText(guildName)
					]),
				$author$project$Ui$text(guildName)),
				$author$project$Pages$Guild$searchIcon(isMobile)
			]),
		$author$project$Ui$column$(
			_List_fromArray(
				[
					$author$project$MyUi$scrollable(canScroll2),
					$author$project$Ui$heightMin(0),
					$author$project$Ui$paddingXY$(0, 8),
					$author$project$Ui$attrIf$(
					isMobile,
					$author$project$Ui$height($author$project$Ui$fill)),
					$author$project$MyUi$bounceScroll(isMobile)
				]),
			_Utils_ap(
				$elm$core$List$map$(
					$elm$core$Tuple$second,
					A2(
						$elm$core$List$sortBy,
						$elm$core$Tuple$first,
						$elm$core$List$map$(
							function (_v0) {
								var channelId = _v0.a;
								var channel = _v0.b;
								var threadNotifications = $elm$core$List$map$(
									function (_v3) {
										var threadId = _v3.a;
										var thread = _v3.b;
										return $author$project$GuildColumn$channelOrThreadHasNotifications$(
											$author$project$MuteSettings$isChannelMuted$(
												localUser.user.muteSettings,
												guildId,
												channelId,
												$author$project$Id$ViewThread(threadId)),
											directMentions,
											$lamdera$containers$SeqSet$member$(guildId, localUser.user.notifyOnAllMessages),
											channelId,
											$author$project$Id$ViewThread(threadId),
											$lamdera$containers$SeqDict$get$(
												_Utils_Tuple2(
													$author$project$Id$GuildOrDmId(
														$author$project$Id$GuildOrDmId_Guild(
															{channelId: channelId, guildId: guildId})),
													threadId),
												localUser.user.lastViewedThreadMessage),
											thread);
									},
									$lamdera$containers$SeqDict$toList(channel.threads));
								var channelMuted = $author$project$MuteSettings$isChannelMuted$(localUser.user.muteSettings, guildId, channelId, $author$project$Id$NoThread);
								var hasNotifications = $author$project$GuildColumn$channelOrThreadHasNotifications$(
									channelMuted,
									directMentions,
									$lamdera$containers$SeqSet$member$(guildId, localUser.user.notifyOnAllMessages),
									channelId,
									$author$project$Id$NoThread,
									$lamdera$containers$SeqDict$get$(
										$author$project$Id$GuildOrDmId(
											$author$project$Id$GuildOrDmId_Guild(
												{channelId: channelId, guildId: guildId})),
										localUser.user.lastViewedMessage),
									channel);
								return _Utils_Tuple2(
									$author$project$Pages$Guild$channelSortName$(
										A2($elm$core$List$cons, hasNotifications, threadNotifications),
										channel),
									$author$project$Ui$column$(
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Pages$Guild$channelColumnRow$(
												isMobile,
												channelMuted,
												hasNotifications,
												$elm$core$List$filterMap$(
													function (userId) {
														return $author$project$User$getUser$(userId, localUser);
													},
													$lamdera$containers$SeqDict$keys(
														$author$project$Call$joinedUsers$(
															localUser.session.userId,
															$author$project$Call$GuildRoomId(
																{channelId: channelId, guildId: guildId}),
															calls))),
												channelRoute,
												guildId,
												channelId,
												channel),
												$author$project$Pages$Guild$channelColumnThreads$(
												isMobile,
												time,
												channelRoute,
												directMentions,
												localUser,
												channels,
												guildId,
												channelId,
												channel,
												function () {
													if ((!channelRoute.$) && (channelRoute.b.$ === 1)) {
														var channelIdB = channelRoute.a;
														var _v2 = channelRoute.b;
														var threadMessageIndex = _v2.a;
														return _Utils_eq(channelIdB, channelId) ? $lamdera$containers$SeqDict$insert$(threadMessageIndex, $author$project$Thread$frontendInit, channel.threads) : channel.threads;
													} else {
														return channel.threads;
													}
												}())
											])));
							},
							$lamdera$containers$SeqDict$toList(guild.channels)))),
				_List_fromArray(
					[newChannelButton]))));
};
var $author$project$Pages$Guild$channelColumn = F8($author$project$Pages$Guild$channelColumn$);
var $author$project$Pages$Guild$channelColumnCanScrollMobile$ = function (localUser, calls, time, guildId, guild, channelRoute) {
	return $author$project$Pages$Guild$channelColumn$(
		true,
		$elm$time$Time$millisToPosix(time),
		localUser,
		calls,
		guildId,
		guild,
		channelRoute,
		true);
};
var $author$project$Pages$Guild$channelColumnCanScrollMobile = F6($author$project$Pages$Guild$channelColumnCanScrollMobile$);
var $author$project$Pages$Guild$channelColumnCannotScrollMobile$ = function (localUser, calls, time, guildId, guild, channelRoute) {
	return $author$project$Pages$Guild$channelColumn$(
		true,
		$elm$time$Time$millisToPosix(time),
		localUser,
		calls,
		guildId,
		guild,
		channelRoute,
		false);
};
var $author$project$Pages$Guild$channelColumnCannotScrollMobile = F6($author$project$Pages$Guild$channelColumnCannotScrollMobile$);
var $author$project$Pages$Guild$channelColumnNotMobile$ = function (localUser, calls, time, guildId, guild, channelRoute) {
	return $author$project$Pages$Guild$channelColumn$(
		false,
		$elm$time$Time$millisToPosix(time),
		localUser,
		calls,
		guildId,
		guild,
		channelRoute,
		true);
};
var $author$project$Pages$Guild$channelColumnNotMobile = F6($author$project$Pages$Guild$channelColumnNotMobile$);
var $author$project$Pages$Guild$channelColumnLazy$ = function (isMobile, canScroll2, model, localUser, calls, guildId, guild, channelRoute) {
	return $author$project$Ui$Lazy$lazy6$(
		isMobile ? (canScroll2 ? $author$project$Pages$Guild$channelColumnCanScrollMobile : $author$project$Pages$Guild$channelColumnCannotScrollMobile) : $author$project$Pages$Guild$channelColumnNotMobile,
		localUser,
		calls,
		$author$project$Pages$Guild$nearestHour(model.time),
		guildId,
		guild,
		channelRoute);
};
var $author$project$Pages$Guild$channelColumnLazy = F8($author$project$Pages$Guild$channelColumnLazy$);
var $author$project$Types$EditChannelFormChanged$ = function (a, b, c) {
	return {$: 16, a: a, b: b, c: c};
};
var $author$project$Types$EditChannelFormChanged = F3($author$project$Types$EditChannelFormChanged$);
var $author$project$Id$ExportChannel_Guild$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Id$ExportChannel_Guild = F2($author$project$Id$ExportChannel_Guild$);
var $author$project$Types$PressedDeleteChannel$ = function (a, b) {
	return {$: 19, a: a, b: b};
};
var $author$project$Types$PressedDeleteChannel = F2($author$project$Types$PressedDeleteChannel$);
var $author$project$Types$PressedMuteChannel$ = function (a, b, c) {
	return {$: 172, a: a, b: b, c: c};
};
var $author$project$Types$PressedMuteChannel = F3($author$project$Types$PressedMuteChannel$);
var $author$project$Types$PressedMuteThread$ = function (a, b, c, d) {
	return {$: 173, a: a, b: b, c: c, d: d};
};
var $author$project$Types$PressedMuteThread = F4($author$project$Types$PressedMuteThread$);
var $author$project$Types$PressedResetEditChannelChanges$ = function (a, b) {
	return {$: 17, a: a, b: b};
};
var $author$project$Types$PressedResetEditChannelChanges = F2($author$project$Types$PressedResetEditChannelChanges$);
var $author$project$Types$PressedSubmitEditChannelChanges$ = function (a, b, c) {
	return {$: 18, a: a, b: b, c: c};
};
var $author$project$Types$PressedSubmitEditChannelChanges = F3($author$project$Types$PressedSubmitEditChannelChanges$);
var $author$project$Ui$Input$TextArea = {$: 1};
var $author$project$Ui$Input$multiline$ = function (attrs, multi) {
	return $author$project$Ui$Input$textHelper$(
		{autofill: $elm$core$Maybe$Nothing, spellchecked: multi.spellcheck, type_: $author$project$Ui$Input$TextArea},
		attrs,
		{label: multi.label, onChange: multi.onChange, placeholder: multi.placeholder, text: multi.text});
};
var $author$project$Ui$Input$multiline = F2($author$project$Ui$Input$multiline$);
var $author$project$Pages$Guild$channelDescriptionInput = function (form) {
	var descriptionLabel = $author$project$Ui$Input$label$(
		'channelDescription',
		_List_fromArray(
			[
				$author$project$Ui$Font$color($author$project$MyUi$font2),
				$author$project$Ui$paddingXY$(2, 0)
			]),
		$author$project$Ui$text('Description'));
	return $author$project$Ui$column$(
		_List_Nil,
		_List_fromArray(
			[
				descriptionLabel.element,
				$author$project$Ui$Input$multiline$(
				_List_fromArray(
					[
						$author$project$Ui$padding(6),
						$author$project$Ui$background($author$project$MyUi$inputBackground),
						$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
						$author$project$Ui$widthMax(500)
					]),
				{
					label: descriptionLabel.id,
					onChange: function (text) {
						return _Utils_update(
							form,
							{description: text});
					},
					placeholder: $elm$core$Maybe$Nothing,
					spellcheck: true,
					text: form.description
				}),
				function () {
				var _v0 = _Utils_Tuple2(
					form.pressedSubmit,
					$author$project$ChannelDescription$fromString(form.description));
				if (_v0.a && (_v0.b.$ === 1)) {
					var error = _v0.b.a;
					return $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$(2, 0),
								$author$project$Ui$Font$color($author$project$MyUi$errorColor)
							]),
						$author$project$Ui$text(error));
				} else {
					return $author$project$Ui$none;
				}
			}()
			]));
};
var $author$project$Pages$Guild$channelNameInput = function (form) {
	var nameLabel = $author$project$Ui$Input$label$(
		'newChannelName',
		_List_fromArray(
			[
				$author$project$Ui$Font$color($author$project$MyUi$font2),
				$author$project$Ui$paddingXY$(2, 0)
			]),
		$author$project$Ui$text('Name'));
	return $author$project$Ui$column$(
		_List_Nil,
		_List_fromArray(
			[
				nameLabel.element,
				A2(
				$author$project$Ui$Input$text,
				_List_fromArray(
					[
						$author$project$Ui$padding(6),
						$author$project$Ui$background($author$project$MyUi$inputBackground),
						$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
						$author$project$Ui$widthMax(500)
					]),
				{
					label: nameLabel.id,
					onChange: function (text) {
						return _Utils_update(
							form,
							{name: text});
					},
					placeholder: $elm$core$Maybe$Nothing,
					text: form.name
				}),
				function () {
				var _v0 = _Utils_Tuple2(
					form.pressedSubmit,
					$author$project$ChannelName$fromString(form.name));
				if (_v0.a && (_v0.b.$ === 1)) {
					var error = _v0.b.a;
					return $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$(2, 0),
								$author$project$Ui$Font$color($author$project$MyUi$errorColor)
							]),
						$author$project$Ui$text(error));
				} else {
					return $author$project$Ui$none;
				}
			}()
			]));
};
var $author$project$Pages$Guild$threadRouteWithFriends = function (threadRoute) {
	if (threadRoute.$ === 1) {
		var threadId = threadRoute.a;
		return $author$project$Id$ViewThread(threadId);
	} else {
		return $author$project$Id$NoThread;
	}
};
var $author$project$Pages$Guild$channelRouteToChannelIdAndThread = function (channelRoute) {
	switch (channelRoute.$) {
		case 0:
			var channelId = channelRoute.a;
			var threadRoute = channelRoute.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					channelId,
					$author$project$Pages$Guild$threadRouteWithFriends(threadRoute)));
		case 1:
			return $elm$core$Maybe$Nothing;
		case 2:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Guild$deleteConfirmationInput$ = function (channelNameString, form) {
	var confirmLabel = $author$project$Ui$Input$label$(
		'deleteChannelConfirmation',
		_List_fromArray(
			[
				$author$project$Ui$Font$color($author$project$MyUi$font2),
				$author$project$Ui$paddingXY$(2, 0)
			]),
		$author$project$Ui$text('Type \u0022' + (channelNameString + '\u0022 to confirm deletion')));
	return $author$project$Ui$column$(
		_List_Nil,
		_List_fromArray(
			[
				confirmLabel.element,
				A2(
				$author$project$Ui$Input$text,
				_List_fromArray(
					[
						$author$project$Ui$padding(6),
						$author$project$Ui$background($author$project$MyUi$inputBackground),
						$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
						$author$project$Ui$widthMax(500)
					]),
				{
					label: confirmLabel.id,
					onChange: function (text) {
						return _Utils_update(
							form,
							{deleteConfirmation: text});
					},
					placeholder: $elm$core$Maybe$Nothing,
					text: form.deleteConfirmation
				})
			]));
};
var $author$project$Pages$Guild$deleteConfirmationInput = F2($author$project$Pages$Guild$deleteConfirmationInput$);
var $author$project$MyUi$disabledButtonBorder = $author$project$Ui$rgb$(140, 142, 143);
var $author$project$Pages$Guild$editChannelFormInit = function (channel) {
	return {
		deleteConfirmation: '',
		description: $author$project$ChannelDescription$toString(channel.description),
		name: $author$project$ChannelName$toString(channel.name),
		pressedSubmit: false,
		showDeleteConfirmation: false
	};
};
var $author$project$MuteSettings$isChannelSpecificallyMuted$ = function (model, guildId, channelId) {
	var _v0 = $lamdera$containers$SeqDict$get$(guildId, model.mutedGuilds);
	if (!_v0.$) {
		var guild = _v0.a;
		var _v1 = $lamdera$containers$SeqDict$get$(channelId, guild.channels);
		if (!_v1.$) {
			var channel = _v1.a;
			return channel.mutedChannel;
		} else {
			return 0;
		}
	} else {
		return 0;
	}
};
var $author$project$MuteSettings$isChannelSpecificallyMuted = F3($author$project$MuteSettings$isChannelSpecificallyMuted$);
var $author$project$MessageArray$isEmpty = function (_v0) {
	var array = _v0;
	return _Utils_cmp(array.end, array.start) < 1;
};
var $author$project$MuteSettings$isThreadSpecificallyMuted$ = function (model, guildId, channelId, threadId) {
	var _v0 = $lamdera$containers$SeqDict$get$(guildId, model.mutedGuilds);
	if (!_v0.$) {
		var guild = _v0.a;
		var _v1 = $lamdera$containers$SeqDict$get$(channelId, guild.channels);
		if (!_v1.$) {
			var channel = _v1.a;
			return $elm$core$Maybe$withDefault$(
				0,
				$lamdera$containers$SeqDict$get$(threadId, channel.mutedThreads));
		} else {
			return 0;
		}
	} else {
		return 0;
	}
};
var $author$project$MuteSettings$isThreadSpecificallyMuted = F4($author$project$MuteSettings$isThreadSpecificallyMuted$);
var $author$project$Pages$Guild$submitButtonWide$ = function (htmlId, onPress, text) {
	return $author$project$MyUi$elButton$(
		htmlId,
		onPress,
		_List_fromArray(
			[
				$author$project$Ui$paddingXY$(8, 4),
				$author$project$Ui$background($author$project$MyUi$buttonBackground),
				$author$project$Ui$Font$center,
				$author$project$Ui$rounded(4),
				$author$project$Ui$Font$weight(500),
				$author$project$Ui$borderColor($author$project$MyUi$buttonBorder),
				$author$project$Ui$border(1)
			]),
		$author$project$Ui$text(text));
};
var $author$project$Pages$Guild$submitButtonWide = F3($author$project$Pages$Guild$submitButtonWide$);
var $author$project$Pages$Guild$channelSettingsForm$ = function (localUser, guildId, channelRoute, guild, editChannelForm) {
	var _v0 = $author$project$Pages$Guild$channelRouteToChannelIdAndThread(channelRoute);
	if (!_v0.$) {
		if (!_v0.a.b.$) {
			var _v1 = _v0.a;
			var channelId = _v1.a;
			var _v2 = _v1.b;
			var _v3 = $lamdera$containers$SeqDict$get$(channelId, guild.channels);
			if (!_v3.$) {
				var channel = _v3.a;
				return $author$project$Ui$column$(
					_List_fromArray(
						[
							$author$project$Ui$Font$color($author$project$MyUi$font1),
							$author$project$Ui$padding(8),
							$author$project$Ui$spacing(16)
						]),
					function () {
						if (_Utils_eq(
							localUser.session.userId,
							$author$project$MembersAndOwner$owner(guild.membersAndOwner))) {
							var isEmpty = $author$project$MessageArray$isEmpty(channel.messages);
							var form = $elm$core$Maybe$withDefault$(
								$author$project$Pages$Guild$editChannelFormInit(channel),
								$lamdera$containers$SeqDict$get$(
									_Utils_Tuple2(guildId, channelId),
									editChannelForm));
							var channelNameString = $author$project$ChannelName$toString(channel.name);
							var confirmationMatches = _Utils_eq(form.deleteConfirmation, channelNameString);
							var channelDescriptionString = $author$project$ChannelDescription$toString(channel.description);
							var hasChanges = (!_Utils_eq(form.name, channelNameString)) || (!_Utils_eq(form.description, channelDescriptionString));
							var _v4 = isEmpty ? _Utils_Tuple2(
								$author$project$Types$PressedDeleteChannel$(guildId, channelId),
								true) : ((!form.showDeleteConfirmation) ? _Utils_Tuple2(
								$author$project$Types$EditChannelFormChanged$(
									guildId,
									channelId,
									_Utils_update(
										form,
										{showDeleteConfirmation: true})),
								true) : (confirmationMatches ? _Utils_Tuple2(
								$author$project$Types$PressedDeleteChannel$(guildId, channelId),
								true) : _Utils_Tuple2($author$project$Types$FrontendNoOp, false)));
							var deleteOnPress = _v4.a;
							var deleteEnabled = _v4.b;
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$map,
									A2($author$project$Types$EditChannelFormChanged, guildId, channelId),
									$author$project$Pages$Guild$channelNameInput(form)),
									A2(
									$author$project$Ui$map,
									A2($author$project$Types$EditChannelFormChanged, guildId, channelId),
									$author$project$Pages$Guild$channelDescriptionInput(form)),
									$author$project$MuteSettings$view$(
									A2($author$project$Types$PressedMuteChannel, guildId, channelId),
									$author$project$MuteSettings$isChannelSpecificallyMuted$(localUser.user.muteSettings, guildId, channelId)),
									hasChanges ? $author$project$Ui$row$(
									_List_fromArray(
										[
											$author$project$Ui$spacing(8)
										]),
									_List_fromArray(
										[
											$author$project$MyUi$secondaryButton$(
											$lamdera$program_test$Effect$Browser$Dom$id('guild_resetEditChannel'),
											$author$project$Types$PressedResetEditChannelChanges$(guildId, channelId),
											'Reset'),
											$author$project$Pages$Guild$submitButtonWide$(
											$lamdera$program_test$Effect$Browser$Dom$id('guild_submitEditChannel'),
											$author$project$Types$PressedSubmitEditChannelChanges$(guildId, channelId, form),
											'Save changes')
										])) : $author$project$Ui$none,
									$author$project$Pages$Guild$exportChannelButton(
									$author$project$Id$ExportChannel_Guild$(guildId, channelId)),
									$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$height(
											$author$project$Ui$px(1)),
											$author$project$Ui$background($author$project$MyUi$border1)
										]),
									$author$project$Ui$none),
									((!isEmpty) && form.showDeleteConfirmation) ? A2(
									$author$project$Ui$map,
									A2($author$project$Types$EditChannelFormChanged, guildId, channelId),
									$author$project$Pages$Guild$deleteConfirmationInput$(channelNameString, form)) : $author$project$Ui$none,
									$author$project$MyUi$elButton$(
									$lamdera$program_test$Effect$Browser$Dom$id('guild_deleteChannel'),
									deleteOnPress,
									_List_fromArray(
										[
											$author$project$Ui$background(
											deleteEnabled ? $author$project$MyUi$deleteButtonBackground : $author$project$MyUi$disabledButtonBackground),
											$author$project$Ui$paddingXY$(8, 4),
											$author$project$Ui$rounded(4),
											$author$project$Ui$Font$color($author$project$MyUi$deleteButtonFont),
											$author$project$Ui$Font$weight(500),
											$author$project$Ui$Font$center,
											$author$project$Ui$borderColor(
											deleteEnabled ? $author$project$MyUi$deleteButtonBorder : $author$project$MyUi$disabledButtonBorder),
											$author$project$Ui$border(1)
										]),
									$author$project$Ui$text('Delete channel'))
								]);
						} else {
							return _List_fromArray(
								[
									$author$project$MuteSettings$view$(
									A2($author$project$Types$PressedMuteChannel, guildId, channelId),
									$author$project$MuteSettings$isChannelSpecificallyMuted$(localUser.user.muteSettings, guildId, channelId)),
									$author$project$Pages$Guild$exportChannelButton(
									$author$project$Id$ExportChannel_Guild$(guildId, channelId))
								]);
						}
					}());
			} else {
				return $author$project$Ui$none;
			}
		} else {
			var _v5 = _v0.a;
			var channelId = _v5.a;
			var threadId = _v5.b.a;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$Font$color($author$project$MyUi$font1),
						$author$project$Ui$padding(8),
						$author$project$Ui$spacing(16)
					]),
				_List_fromArray(
					[
						$author$project$MuteSettings$view$(
						A3($author$project$Types$PressedMuteThread, guildId, channelId, threadId),
						$author$project$MuteSettings$isThreadSpecificallyMuted$(localUser.user.muteSettings, guildId, channelId, threadId))
					]));
		}
	} else {
		return $author$project$Ui$none;
	}
};
var $author$project$Pages$Guild$channelSettingsForm = F5($author$project$Pages$Guild$channelSettingsForm$);
var $author$project$Pages$Guild$memberLabel$ = function (isMobile, localUser, userId) {
	return $author$project$GuildColumn$rowLinkButton$(
		$lamdera$program_test$Effect$Browser$Dom$id(
			'guild_openDm_' + $author$project$Id$toString(userId)),
		$author$project$Route$DmRoute(
			{
				channelId: $author$project$DmChannelId$fromUserIds$(localUser.session.userId, userId),
				channelsVisible: 0,
				overlay: $elm$core$Maybe$Nothing,
				tab: $elm$core$Maybe$Nothing,
				threadRoute: $author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1)
			}),
		_List_fromArray(
			[
				$author$project$Ui$spacing(8),
				$author$project$Ui$paddingXY$(8, 4),
				$author$project$MyUi$hover$(
				isMobile,
				_List_fromArray(
					[
						$author$project$Ui$Anim$backgroundColor($author$project$MyUi$weakHoverHighlight),
						$author$project$Ui$Anim$fontColor($author$project$MyUi$font1)
					])),
				$author$project$Ui$Font$color($author$project$MyUi$font3),
				$author$project$Ui$clipWithEllipsis
			]),
		function () {
			var _v0 = $author$project$User$getUser$(userId, localUser);
			if (!_v0.$) {
				var user = _v0.a;
				return _List_fromArray(
					[
						$author$project$User$profileImage(
						$elm$core$Maybe$Just(user)),
						$author$project$Ui$text(
						$author$project$PersonName$toString(user.name))
					]);
			} else {
				return _List_Nil;
			}
		}());
};
var $author$project$Pages$Guild$memberLabel = F3($author$project$Pages$Guild$memberLabel$);
var $author$project$Pages$Guild$memberListView$ = function (isMobile, localUser, membersAndOwner) {
	var members = $author$project$MembersAndOwner$members(membersAndOwner);
	return $author$project$Ui$column$(
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$paddingXY$(8, 4)
					]),
				$author$project$Ui$text(
					'Members (' + ($elm$core$String$fromInt(
						$lamdera$containers$SeqDict$size(members) + 1) + ')'))),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$height($author$project$Ui$fill)
					]),
				A2(
					$elm$core$List$cons,
					$author$project$Pages$Guild$memberLabel$(
						isMobile,
						localUser,
						$author$project$MembersAndOwner$owner(membersAndOwner)),
					$lamdera$containers$SeqDict$foldr$(
						F3(
							function (userId, _v0, list) {
								return A2(
									$elm$core$List$cons,
									$author$project$Pages$Guild$memberLabel$(isMobile, localUser, userId),
									list);
							}),
						_List_Nil,
						members)))
			]));
};
var $author$project$Pages$Guild$memberListView = F3($author$project$Pages$Guild$memberListView$);
var $author$project$Pages$Guild$channelSettingsMobile$ = function (canScroll2, localUser, guildId, channelRoute, guild, editChannelForm, isThread) {
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$height($author$project$Ui$fill)
			]),
		_List_fromArray(
			[
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$contentCenterY,
						$author$project$Ui$borderWith(
						{bottom: 1, left: 0, right: 0, top: 0}),
						$author$project$Ui$borderColor($author$project$MyUi$border2),
						$author$project$Ui$background($author$project$MyUi$background3),
						$author$project$Ui$height(
						$author$project$Ui$px($author$project$MyUi$channelHeaderHeight)),
						$author$project$MyUi$noShrinking
					]),
				_List_fromArray(
					[
						$author$project$ChannelHeader$headerBackButton$(
						$lamdera$program_test$Effect$Browser$Dom$id('guild_memberColumnBack'),
						$author$project$Types$PressedMemberListBack),
						isThread ? $author$project$Ui$text('Thread settings') : $author$project$Ui$text('Channel settings')
					])),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$background($author$project$MyUi$background2),
						$author$project$Ui$Font$color($author$project$MyUi$font1),
						$author$project$Ui$paddingWith(
						{bottom: localUser.safeAreaInsetBottom + 16, left: 0, right: 0, top: 16}),
						$author$project$MyUi$scrollable(canScroll2),
						$author$project$Ui$heightMin(0)
					]),
				_List_fromArray(
					[
						$author$project$Pages$Guild$channelSettingsForm$(localUser, guildId, channelRoute, guild, editChannelForm),
						$author$project$Ui$Lazy$lazy3$($author$project$Pages$Guild$memberListView, true, localUser, guild.membersAndOwner)
					]))
			]));
};
var $author$project$Pages$Guild$channelSettingsMobile = F7($author$project$Pages$Guild$channelSettingsMobile$);
var $author$project$Pages$Guild$channelSettingsNotMobile$ = function (localUser, guildId, channelRoute, guild, editChannelForm, isThread) {
	return $author$project$Pages$Guild$memberColumnContainerNotMobile$(
		isThread,
		_List_fromArray(
			[
				$author$project$Pages$Guild$channelSettingsForm$(localUser, guildId, channelRoute, guild, editChannelForm),
				$author$project$Ui$Lazy$lazy3$($author$project$Pages$Guild$memberListView, false, localUser, guild.membersAndOwner)
			]));
};
var $author$project$Pages$Guild$channelSettingsNotMobile = F6($author$project$Pages$Guild$channelSettingsNotMobile$);
var $author$project$ChannelHeader$privateChatWith$ = function (isMobile, route, showSettingsRedDot, currentTab, otherUserId, local, name) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$Font$color($author$project$MyUi$font1),
				$author$project$Ui$spacing(6),
				$author$project$Ui$clipWithEllipsis,
				$author$project$Ui$height($author$project$Ui$fill)
			]),
		_List_fromArray(
			[
				$author$project$ChannelHeader$channelHeaderTab$(
				isMobile,
				$lamdera$program_test$Effect$Browser$Dom$id('guild_openDescription'),
				$author$project$UserSession$ChannelHeaderTab_ChannelDescription,
				currentTab,
				isMobile ? $author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$Font$color($author$project$MyUi$font1)
						]),
					$author$project$Ui$text(name)) : $author$project$Ui$row$(
					_List_fromArray(
						[
							$author$project$Ui$spacing(5)
						]),
					_List_fromArray(
						[
							$author$project$Ui$text('Chat with '),
							$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$Font$color($author$project$MyUi$font1)
								]),
							$author$project$Ui$text(name))
						]))),
				$author$project$ChannelHeader$dmHeaderButtons$(isMobile, route, showSettingsRedDot, currentTab, otherUserId, local)
			]));
};
var $author$project$ChannelHeader$privateChatWith = F7($author$project$ChannelHeader$privateChatWith$);
var $author$project$ChannelHeader$channel$ = function (isMobile, name, guildOrDmIdNoThread, local, loggedIn, model) {
	var currentChannelHeaderTab = $author$project$Route$toChannelHeaderTab(model.route);
	return $author$project$ChannelHeader$channelHeader$(
		isMobile,
		function () {
			if (guildOrDmIdNoThread.$ === 1) {
				var otherUserId = guildOrDmIdNoThread.a.otherUserId;
				return _Utils_eq(otherUserId, local.localUser.session.userId) ? $author$project$ChannelHeader$privateChatWithYourself$(
					isMobile,
					model.route,
					$author$project$ChannelHeader$showDmSettingsRedDot$(otherUserId, local, loggedIn),
					currentChannelHeaderTab,
					local) : $author$project$ChannelHeader$privateChatWith$(
					isMobile,
					model.route,
					$author$project$ChannelHeader$showDmSettingsRedDot$(otherUserId, local, loggedIn),
					currentChannelHeaderTab,
					otherUserId,
					local,
					name);
			} else {
				var channelId = guildOrDmIdNoThread.a.channelId;
				var guildId = guildOrDmIdNoThread.a.guildId;
				return $author$project$Ui$row$(
					_List_fromArray(
						[
							$author$project$Ui$spacing(2),
							$author$project$Ui$clipWithEllipsis,
							$author$project$Ui$height($author$project$Ui$fill)
						]),
					_List_fromArray(
						[
							$author$project$ChannelHeader$channelHeaderTabRow$(
							isMobile,
							$lamdera$program_test$Effect$Browser$Dom$id('guild_openChannelDescription'),
							$author$project$UserSession$ChannelHeaderTab_ChannelDescription,
							currentChannelHeaderTab,
							false,
							_List_fromArray(
								[
									$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$MyUi$noShrinking,
											$author$project$Ui$width($author$project$Ui$shrink)
										]),
									$author$project$Ui$html($author$project$Icons$hashtag)),
									$author$project$Ui$text(name)
								])),
							$author$project$Ui$row$(
							_List_fromArray(
								[
									$author$project$Ui$width($author$project$Ui$shrink),
									$author$project$Ui$alignRight,
									$author$project$Ui$height($author$project$Ui$fill)
								]),
							_List_fromArray(
								[
									$author$project$ChannelHeader$callTab$(
									isMobile,
									$author$project$Route$toChannelHeaderTab(model.route),
									$author$project$Call$GuildRoomId(
										{channelId: channelId, guildId: guildId}),
									local.localUser,
									local.calls),
									$author$project$Ui$Lazy$lazy2$($author$project$ChannelHeader$gameButton, isMobile, currentChannelHeaderTab),
									$author$project$ChannelHeader$drawingTab$(isMobile, currentChannelHeaderTab, false),
									$elm$core$Maybe$withDefault$(
									$author$project$Ui$none,
									$author$project$ChannelHeader$channelSettingsTab$(isMobile, model.route))
								]))
						]));
			}
		}(),
		$author$project$ChannelHeader$tabBodyView$(isMobile, local, loggedIn, model));
};
var $author$project$ChannelHeader$channel = F6($author$project$ChannelHeader$channel$);
var $author$project$WordSpellingGame$moveReplyPreview$ = function (allUsers, setup, actions, moveNumber) {
	return $elm$core$Maybe$withDefault$(
		$author$project$Ui$none,
		$elm$core$Maybe$map$(
			function (description) {
				return $author$project$Ui$row$(
					_List_fromArray(
						[
							$author$project$Ui$spacing(4),
							$author$project$Ui$paddingXY$(4, 0)
						]),
					_List_fromArray(
						[
							$author$project$WordSpellingGame$boardTileInFront$(
							'4',
							false,
							20,
							$author$project$Coord$xy$(0, 0),
							$author$project$WordSpellingGame$Letter('W')),
							$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$Font$bold,
									$author$project$Ui$width($author$project$Ui$shrink)
								]),
							$author$project$Ui$text(
								$author$project$User$toString$(
									$author$project$WordSpellingGame$descriptionUserId(description),
									allUsers))),
							$author$project$Ui$text(
							$author$project$WordSpellingGame$descriptionToString(description))
						]));
			},
			$elmcraft$core_extra$List$Extra$getAt$(
				moveNumber - 1,
				$elm$core$List$reverse(
					$elm$core$Array$foldl$(
						F2(
							function (action, _v0) {
								var shared = _v0.a;
								var descriptions = _v0.b;
								var _v1 = $author$project$WordSpellingGame$updateAction$(setup, action, shared);
								var shared2 = _v1.a;
								var newDescriptions = _v1.b;
								return _Utils_Tuple2(
									shared2,
									_Utils_ap(
										$elm$core$List$reverse(newDescriptions),
										descriptions));
							}),
						_Utils_Tuple2(
							$author$project$WordSpellingGame$initShared(setup),
							_List_Nil),
						actions).b))));
};
var $author$project$WordSpellingGame$moveReplyPreview = F4($author$project$WordSpellingGame$moveReplyPreview$);
var $author$project$SheepGame$replyPreviewText = function (input) {
	return $elm$core$String$trim(
		$author$project$RichText$toString$($lamdera$program_test$Effect$Time$utc, true, $lamdera$containers$SeqDict$empty, $lamdera$containers$SeqDict$empty, input.text));
};
var $author$project$SheepGame$replyPreview$ = function (shared, target) {
	if (!target.$) {
		var userId = target.a;
		var questionId = target.b;
		var _v1 = $lamdera$containers$SeqDict$get$(userId, shared.answers);
		if (!_v1.$) {
			var answers = _v1.a;
			var _v2 = $author$project$IdArray$get$(questionId, answers);
			if ((!_v2.$) && (!_v2.a.$)) {
				var answer = _v2.a.a;
				return $author$project$Ui$row$(
					_List_fromArray(
						[
							$author$project$Ui$spacing(4)
						]),
					_List_fromArray(
						[
							$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$Font$size(20),
									$author$project$Ui$width($author$project$Ui$shrink)
								]),
							$author$project$Ui$html($author$project$SheepGame$sheepEmoji)),
							$author$project$Ui$el$(
							_List_fromArray(
								[$author$project$Ui$clipWithEllipsis]),
							$author$project$Ui$text(
								$author$project$SheepGame$replyPreviewText(answer)))
						]));
			} else {
				return $author$project$Ui$none;
			}
		} else {
			return $author$project$Ui$none;
		}
	} else {
		var questionId = target.a;
		var _v3 = $lamdera$containers$SeqDict$get$(questionId, shared.notes);
		if ((!_v3.$) && (!_v3.a.$)) {
			var notes = _v3.a.a;
			return $author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$Font$size(20),
								$author$project$Ui$width($author$project$Ui$shrink)
							]),
						$author$project$Ui$html($author$project$SheepGame$sheepEmoji)),
						$author$project$Ui$el$(
						_List_fromArray(
							[$author$project$Ui$clipWithEllipsis]),
						$author$project$Ui$text(
							$author$project$SheepGame$replyPreviewText(notes)))
					]));
		} else {
			return $author$project$Ui$none;
		}
	}
};
var $author$project$SheepGame$replyPreview = F2($author$project$SheepGame$replyPreview$);
var $author$project$Game$replyPreview$ = function (allUsers, repliedTo, matchData) {
	if (!matchData.$) {
		var data = matchData.a.data;
		switch (repliedTo.$) {
			case 0:
				var moveNumber = repliedTo.a;
				if (data.$ === 1) {
					var setup = data.a;
					var actions = data.b;
					return $author$project$WordSpellingGame$moveReplyPreview$(allUsers, setup, actions, moveNumber);
				} else {
					return $author$project$Ui$none;
				}
			case 1:
				var userId = repliedTo.a;
				var questionId = repliedTo.b;
				if (data.$ === 2) {
					var shared = data.c;
					return $author$project$SheepGame$replyPreview$(
						shared,
						$author$project$SheepGame$AnswerReaction$(userId, questionId));
				} else {
					return $author$project$Ui$none;
				}
			default:
				var questionId = repliedTo.a;
				if (data.$ === 2) {
					var shared = data.c;
					return $author$project$SheepGame$replyPreview$(
						shared,
						$author$project$SheepGame$NotesReaction(questionId));
				} else {
					return $author$project$Ui$none;
				}
		}
	} else {
		return $author$project$Ui$none;
	}
};
var $author$project$Game$replyPreview = F3($author$project$Game$replyPreview$);
var $author$project$Pages$Guild$channelReplyToHeader$ = function (isMobile, guildOrDmIdNoThread, replyTo, allUsers, games, channel) {
	if ((!replyTo.$) && (replyTo.a.$ === 2)) {
		var _v1 = replyTo.a;
		var matchId = _v1.a;
		var game = _v1.b;
		return $author$project$Pages$Guild$replyToHeaderRow$(
			isMobile,
			$author$project$Types$PressedCloseReplyTo(guildOrDmIdNoThread),
			function () {
				var _v2 = $lamdera$containers$SeqDict$get$(matchId, games);
				if (!_v2.$) {
					var matchData = _v2.a;
					return _List_fromArray(
						[
							$author$project$Game$replyPreview$(allUsers, game, matchData)
						]);
				} else {
					return _List_Nil;
				}
			}());
	} else {
		return $author$project$Pages$Guild$replyToHeader$(isMobile, guildOrDmIdNoThread, replyTo, allUsers, channel);
	}
};
var $author$project$Pages$Guild$channelReplyToHeader = F6($author$project$Pages$Guild$channelReplyToHeader$);
var $author$project$Pages$Guild$gameReplyPreview$ = function (localUser, game, matchData) {
	return $author$project$Game$replyPreview$(
		$author$project$User$allUsers(localUser),
		game,
		matchData);
};
var $author$project$Pages$Guild$gameReplyPreview = F3($author$project$Pages$Guild$gameReplyPreview$);
var $author$project$Pages$Guild$channelMessageRepliedTo$ = function (localUser, games, message, channel) {
	var _v0 = $author$project$Pages$Guild$maybeRepliedTo$(message, channel);
	if ((!_v0.$) && (_v0.a.$ === 1)) {
		var _v1 = _v0.a;
		var matchId = _v1.a;
		var game = _v1.b;
		var a = _v1.c;
		var _v2 = $lamdera$containers$SeqDict$get$(matchId, games);
		if (!_v2.$) {
			var matchData = _v2.a;
			return $elm$core$Maybe$Just(
				$author$project$Pages$Guild$RepliedToView_Game$(
					matchId,
					game,
					$author$project$Ui$Lazy$lazy3$($author$project$Pages$Guild$gameReplyPreview, localUser, game, matchData)));
		} else {
			return $elm$core$Maybe$Just(
				$author$project$Pages$Guild$RepliedToView_Game$(matchId, game, a));
		}
	} else {
		var maybeRepliedTo2 = _v0;
		return maybeRepliedTo2;
	}
};
var $author$project$Pages$Guild$channelMessageRepliedTo = F4($author$project$Pages$Guild$channelMessageRepliedTo$);
var $author$project$User$userColor$ = function (localUser, userId) {
	var _v0 = $author$project$User$getUser$(userId, localUser);
	if (!_v0.$) {
		var user = _v0.a;
		return user.color;
	} else {
		return $author$project$RichText$defaultColor;
	}
};
var $author$project$User$userColor = F2($author$project$User$userColor$);
var $author$project$MessageView$MessageView_PressedChannelMention$ = function (a, b) {
	return {$: 25, a: a, b: b};
};
var $author$project$MessageView$MessageView_PressedChannelMention = F2($author$project$MessageView$MessageView_PressedChannelMention$);
var $author$project$MessageView$MessageView_PressedUserIconButton = function (a) {
	return {$: 23, a: a};
};
var $author$project$Icons$lockClosed = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$fill('currentColor'),
			$elm$svg$Svg$Attributes$width('14')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$d('M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z'),
					$elm$svg$Svg$Attributes$clipRule('evenodd')
				]),
			_List_Nil)
		]));
var $author$project$Pages$Guild$userTextMessageContent$ = function (time, spoilerHtmlId, containerWidth, isBeingEdited, isMobile, maybeRepliedTo2, localUser, revealedSpoilers, allUsers, channels, drawingColor, isHovered, messageId, _v0, showEncryptionIcon, message2) {
	var attachedFiles = _v0.attachedFiles;
	var embeds = _v0.embeds;
	var content = _v0.content;
	var drawings = $elm$core$Maybe$withDefault$($author$project$Message$noDrawings, message2.drawings);
	var decrypted = localUser.decryptedMessages;
	return $author$project$Ui$column$(
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Pages$Guild$indentPastProfileImage$(
				maybeRepliedTo2,
				$author$project$Pages$Guild$replyToHeaderAboveMessage$(isMobile, localUser.timezone, time, maybeRepliedTo2, revealedSpoilers, localUser.emojiData, localUser.customEmojis, decrypted, allUsers, channels)),
				$author$project$Ui$row$(
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$paddingWith(
								{bottom: 0, left: 0, right: $author$project$MessageView$profileImagePaddingRight, top: 2}),
								$author$project$Ui$width($author$project$Ui$shrink),
								$author$project$Ui$alignTop
							]),
						$author$project$Ui$el$(
							_Utils_ap(
								$author$project$Drawing$anchorHighlight$(
									$author$project$Drawing$profileImageAnchorId(messageId),
									drawingColor,
									$author$project$MessageView$MessageView_PressedUserIconAnchor,
									_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
									drawings.userIconDrawings),
								_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor) ? _List_fromArray(
									[
										$author$project$Ui$rounded($author$project$User$profileImageRounding)
									]) : $author$project$Pages$Guild$openDmButton$(
									messageId,
									$author$project$MessageView$MessageView_PressedUserIconButton(message2.createdBy))),
							$author$project$User$profileImage(
								$lamdera$containers$SeqDict$get$(message2.createdBy, allUsers)))),
						$author$project$Ui$column$(
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$row$(
								_List_Nil,
								_List_fromArray(
									[
										$author$project$User$toColoredString$(message2.createdBy, allUsers),
										showEncryptionIcon ? $author$project$Ui$html($author$project$Icons$lockClosed) : $author$project$Ui$none,
										$author$project$Pages$Guild$messageTimestamp$(
										drawingColor,
										drawings.timestampDrawings,
										_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
										messageId,
										message2.createdAt,
										localUser.timezone)
									])),
								$author$project$Ui$html(
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'white-space', 'pre-wrap')
										]),
									_Utils_ap(
										$author$project$RichText$view$(
											$lamdera$program_test$Effect$Browser$Dom$id(
												$lamdera$program_test$Effect$Browser$Dom$idToString(spoilerHtmlId) + ('_' + $author$project$Id$toString(messageId))),
											containerWidth,
											$author$project$MessageView$MessageView_PressedNonWhitelistLink,
											$author$project$MessageView$MessageView_PressedSpoiler,
											$author$project$MessageView$MessageView_PressedImage,
											{
												animationMode: $author$project$Pages$Guild$isHoveredToAnimationMode(isHovered),
												attachedFiles: attachedFiles,
												channels: channels,
												customEmojis: localUser.customEmojis,
												devicePixelRatio: localUser.devicePixelRatio,
												domainWhitelist: localUser.user.domainWhitelist,
												drawingUserColor: drawingColor,
												drawings: drawings.imageAttachmentDrawings,
												embedDrawings: drawings.embedDrawings,
												emojiData: localUser.emojiData,
												isHovered: function () {
													switch (isHovered.$) {
														case 0:
															return false;
														case 1:
															return true;
														case 2:
															return true;
														case 3:
															return true;
														case 4:
															return false;
														default:
															return false;
													}
												}(),
												isSelectingAnchor: _Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
												noOp: $author$project$MessageView$MessageView_NoOp,
												onPressChannelMention: $author$project$MessageView$MessageView_PressedChannelMention,
												onPressCopyCode: $author$project$MessageView$MessageView_PressedCopyCode,
												revealedSpoilers: function () {
													var _v2 = $lamdera$containers$SeqDict$get$(messageId, revealedSpoilers);
													if (!_v2.$) {
														var nonempty = _v2.a;
														return $author$project$NonemptySet$toSeqSet(nonempty);
													} else {
														return $lamdera$containers$SeqSet$empty;
													}
												}(),
												stickers: localUser.stickers,
												time: time,
												timezone: localUser.timezone,
												users: allUsers
											},
											function () {
												var _v3 = localUser.user.embedVisibility;
												if (!_v3) {
													return embeds;
												} else {
													return $elm$core$Array$empty;
												}
											}(),
											content),
										function () {
											if (isBeingEdited) {
												return _List_fromArray(
													[
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$Attributes$style,
																'color',
																$author$project$MyUi$colorToStyle($author$project$MyUi$dimFont)),
																A2($elm$html$Html$Attributes$style, 'font-size', '12px')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(' (editing...)')
															]))
													]);
											} else {
												var _v4 = message2.editedAt;
												if (!_v4.$) {
													var editedAt = _v4.a;
													return _List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$Attributes$style,
																	'color',
																	$author$project$MyUi$colorToStyle($author$project$MyUi$dimFont)),
																	A2($elm$html$Html$Attributes$style, 'font-size', '12px'),
																	$elm$html$Html$Attributes$title(
																	$author$project$MyUi$datestamp$(localUser.timezone, editedAt))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(' (edited)')
																]))
														]);
												} else {
													return _List_Nil;
												}
											}
										}())))
							]))
					]))
			]));
};
var $author$project$Pages$Guild$userTextMessageContent = function (time) {
	return function (spoilerHtmlId) {
		return function (containerWidth) {
			return function (isBeingEdited) {
				return function (isMobile) {
					return function (maybeRepliedTo2) {
						return function (localUser) {
							return function (revealedSpoilers) {
								return function (allUsers) {
									return function (channels) {
										return function (drawingColor) {
											return function (isHovered) {
												return function (messageId) {
													return function (_v0) {
														return function (showEncryptionIcon) {
															return function (message2) {
																return $author$project$Pages$Guild$userTextMessageContent$(time, spoilerHtmlId, containerWidth, isBeingEdited, isMobile, maybeRepliedTo2, localUser, revealedSpoilers, allUsers, channels, drawingColor, isHovered, messageId, _v0, showEncryptionIcon, message2);
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Guild$messageView$ = function (time, isMobile, containerWidth, isThreadStarter, revealedSpoilers, highlight, isHovered, isBeingEdited, currentUserId, allUsers, channels, localUser, maybeRepliedTo2, maybeThreadStarter, messageId, message) {
	var decrypted = localUser.decryptedMessages;
	var channelMentions = $author$project$LocalState$guildChannelMentions$(localUser, channels);
	switch (message.$) {
		case 0:
			var data = message.a;
			return $author$project$Pages$Guild$messageContainer$(
				containerWidth,
				isThreadStarter,
				localUser.timezone,
				time,
				localUser.user.availableCustomEmojis,
				localUser.customEmojis,
				localUser.emojiData,
				allUsers,
				channelMentions,
				function () {
					if (!highlight) {
						return $lamdera$containers$SeqSet$member$(
							currentUserId,
							$author$project$RichText$mentionsUser(data.content.content)) ? 2 : highlight;
					} else {
						return highlight;
					}
				}(),
				messageId,
				_Utils_eq(currentUserId, data.createdBy),
				currentUserId,
				localUser.user,
				data.reactions,
				maybeThreadStarter,
				decrypted,
				isHovered,
				$author$project$Pages$Guild$userTextMessageContent$(
					time,
					$lamdera$program_test$Effect$Browser$Dom$id('spoiler'),
					containerWidth,
					isBeingEdited,
					isMobile,
					maybeRepliedTo2,
					localUser,
					revealedSpoilers,
					allUsers,
					channelMentions,
					$author$project$User$userColor(localUser),
					isHovered,
					messageId,
					data.content,
					false,
					data));
		case 1:
			var data = message.a;
			var _v2 = $lamdera$containers$SeqDict$get$(
				$author$project$Encryption$hash(data.content),
				decrypted);
			if (!_v2.$) {
				var result = _v2.a;
				return $author$project$Pages$Guild$messageContainer$(
					containerWidth,
					isThreadStarter,
					localUser.timezone,
					time,
					localUser.user.availableCustomEmojis,
					localUser.customEmojis,
					localUser.emojiData,
					allUsers,
					channelMentions,
					highlight,
					messageId,
					_Utils_eq(currentUserId, data.createdBy),
					currentUserId,
					localUser.user,
					data.reactions,
					maybeThreadStarter,
					decrypted,
					isHovered,
					$author$project$Pages$Guild$userTextMessageContent$(
						time,
						$lamdera$program_test$Effect$Browser$Dom$id('spoiler'),
						containerWidth,
						isBeingEdited,
						isMobile,
						maybeRepliedTo2,
						localUser,
						revealedSpoilers,
						allUsers,
						channelMentions,
						$author$project$User$userColor(localUser),
						isHovered,
						messageId,
						$elm$core$Result$withDefault$(
							{attachedFiles: $lamdera$containers$SeqDict$empty, content: $author$project$RichText$failedToDecryptMessage, embeds: $elm$core$Array$empty},
							result),
						true,
						data));
			} else {
				return $author$project$Ui$none;
			}
		case 2:
			var joinedAt = message.a;
			var userId = message.b;
			var reactions = message.c;
			var drawings = message.d;
			return $author$project$Pages$Guild$messageContainer$(
				containerWidth,
				isThreadStarter,
				localUser.timezone,
				time,
				localUser.user.availableCustomEmojis,
				localUser.customEmojis,
				localUser.emojiData,
				allUsers,
				channelMentions,
				highlight,
				messageId,
				false,
				currentUserId,
				localUser.user,
				reactions,
				maybeThreadStarter,
				decrypted,
				isHovered,
				$author$project$Ui$row$(
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Guild$userJoinedContent$(userId, allUsers),
							$author$project$Pages$Guild$messageTimestamp$(
							$author$project$User$userColor(localUser),
							drawings,
							_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
							messageId,
							joinedAt,
							localUser.timezone),
							$author$project$Pages$Guild$messageIdView(messageId)
						])));
		case 3:
			var createdAt = message.a;
			return $author$project$Pages$Guild$messageContainer$(
				containerWidth,
				isThreadStarter,
				localUser.timezone,
				time,
				localUser.user.availableCustomEmojis,
				localUser.customEmojis,
				localUser.emojiData,
				allUsers,
				channelMentions,
				highlight,
				messageId,
				false,
				currentUserId,
				localUser.user,
				$lamdera$containers$SeqDict$empty,
				maybeThreadStarter,
				decrypted,
				isHovered,
				$author$project$Pages$Guild$deletedMessageContent$(
					messageId,
					_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
					createdAt,
					localUser.timezone));
		case 4:
			var callStartedData = message.a;
			return $author$project$Pages$Guild$messageContainer$(
				containerWidth,
				isThreadStarter,
				localUser.timezone,
				time,
				localUser.user.availableCustomEmojis,
				localUser.customEmojis,
				localUser.emojiData,
				allUsers,
				channelMentions,
				highlight,
				messageId,
				false,
				currentUserId,
				localUser.user,
				callStartedData.reactions,
				maybeThreadStarter,
				decrypted,
				isHovered,
				$author$project$Ui$row$(
					_List_fromArray(
						[$author$project$Ui$contentTop]),
					_List_fromArray(
						[
							$author$project$Ui$row$(
							_List_fromArray(
								[
									$author$project$Ui$spacing(8),
									$author$project$Ui$contentCenterY
								]),
							_List_fromArray(
								[
									$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$width($author$project$Ui$shrink)
										]),
									$author$project$Pages$Guild$callStartedCard$(
										$author$project$User$userColor(localUser),
										_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
										messageId,
										callStartedData.cardDrawings,
										callStartedData.startedBy,
										callStartedData.startedAt,
										callStartedData.endedAt,
										callStartedData.recordings,
										allUsers)),
									$author$project$Pages$Guild$callRecordingsButton$(isMobile, localUser.timezone, messageId, callStartedData.recordings, allUsers)
								])),
							$author$project$Pages$Guild$messageTimestamp$(
							$author$project$User$userColor(localUser),
							callStartedData.timestampDrawings,
							_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
							messageId,
							callStartedData.startedAt,
							localUser.timezone),
							$author$project$Pages$Guild$messageIdView(messageId)
						])));
		default:
			var gameStarted = message.a;
			return $author$project$Pages$Guild$messageContainer$(
				containerWidth,
				isThreadStarter,
				localUser.timezone,
				time,
				localUser.user.availableCustomEmojis,
				localUser.customEmojis,
				localUser.emojiData,
				allUsers,
				channelMentions,
				highlight,
				messageId,
				false,
				currentUserId,
				localUser.user,
				gameStarted.reactions,
				maybeThreadStarter,
				decrypted,
				isHovered,
				$author$project$Ui$row$(
					_List_fromArray(
						[$author$project$Ui$contentTop]),
					_List_fromArray(
						[
							$author$project$Pages$Guild$goMatchStartedCard$(
							$author$project$User$userColor(localUser),
							_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
							gameStarted.cardDrawings,
							messageId,
							gameStarted.startedBy,
							allUsers,
							gameStarted.gameType),
							$author$project$Pages$Guild$messageTimestamp$(
							$author$project$User$userColor(localUser),
							gameStarted.timestampDrawings,
							_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
							messageId,
							gameStarted.startedAt,
							localUser.timezone),
							$author$project$Pages$Guild$messageIdView(messageId)
						])));
	}
};
var $author$project$Pages$Guild$messageView = function (time) {
	return function (isMobile) {
		return function (containerWidth) {
			return function (isThreadStarter) {
				return function (revealedSpoilers) {
					return function (highlight) {
						return function (isHovered) {
							return function (isBeingEdited) {
								return function (currentUserId) {
									return function (allUsers) {
										return function (channels) {
											return function (localUser) {
												return function (maybeRepliedTo2) {
													return function (maybeThreadStarter) {
														return function (messageId) {
															return function (message) {
																return $author$project$Pages$Guild$messageView$(time, isMobile, containerWidth, isThreadStarter, revealedSpoilers, highlight, isHovered, isBeingEdited, currentUserId, allUsers, channels, localUser, maybeRepliedTo2, maybeThreadStarter, messageId, message);
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Guild$messageViewNotThreadStarter$ = function (data, revealedSpoilers, localUser, messageIndex, message) {
	var _v0 = $author$project$Pages$Guild$decodeMessageView(data);
	var time = _v0.time;
	var isMobile = _v0.isMobile;
	var isHovered = _v0.isHovered;
	var highlight = _v0.highlight;
	var isEditing = _v0.isEditing;
	var containerWidth = _v0.containerWidth;
	return $author$project$Pages$Guild$messageView$(
		time,
		isMobile,
		containerWidth,
		false,
		revealedSpoilers,
		highlight,
		isHovered,
		isEditing,
		localUser.session.userId,
		$author$project$User$allUsers(localUser),
		$lamdera$containers$SeqDict$empty,
		localUser,
		$elm$core$Maybe$Nothing,
		$elm$core$Maybe$Nothing,
		$author$project$Id$fromInt(messageIndex),
		message);
};
var $author$project$Pages$Guild$messageViewNotThreadStarter = F5($author$project$Pages$Guild$messageViewNotThreadStarter$);
var $author$project$Pages$Guild$messageViewNotThreadStarterWithChannelMention$ = function (data, revealedSpoilers, localUser, messageIndex, message, channels) {
	var _v0 = $author$project$Pages$Guild$decodeMessageView(data);
	var time = _v0.time;
	var isMobile = _v0.isMobile;
	var isHovered = _v0.isHovered;
	var highlight = _v0.highlight;
	var isEditing = _v0.isEditing;
	var containerWidth = _v0.containerWidth;
	return $author$project$Pages$Guild$messageView$(
		time,
		isMobile,
		containerWidth,
		false,
		revealedSpoilers,
		highlight,
		isHovered,
		isEditing,
		localUser.session.userId,
		$author$project$User$allUsers(localUser),
		channels,
		localUser,
		$elm$core$Maybe$Nothing,
		$elm$core$Maybe$Nothing,
		$author$project$Id$fromInt(messageIndex),
		message);
};
var $author$project$Pages$Guild$messageViewNotThreadStarterWithChannelMention = F6($author$project$Pages$Guild$messageViewNotThreadStarterWithChannelMention$);
var $author$project$Pages$Guild$messageViewNotThreadStarterWithReply$ = function (data, revealedSpoilers, localUser, messageIndexAndReplyMessageIndex, message, replyMessage) {
	var _v0 = $author$project$Pages$Guild$decodeMessageIndex(messageIndexAndReplyMessageIndex);
	var replyMessageIndex = _v0.replyMessageIndex;
	var messageIndex = _v0.messageIndex;
	var _v1 = $author$project$Pages$Guild$decodeMessageView(data);
	var time = _v1.time;
	var isMobile = _v1.isMobile;
	var isHovered = _v1.isHovered;
	var highlight = _v1.highlight;
	var isEditing = _v1.isEditing;
	var containerWidth = _v1.containerWidth;
	return $author$project$Pages$Guild$messageView$(
		time,
		isMobile,
		containerWidth,
		false,
		revealedSpoilers,
		highlight,
		isHovered,
		isEditing,
		localUser.session.userId,
		$author$project$User$allUsers(localUser),
		$lamdera$containers$SeqDict$empty,
		localUser,
		$elm$core$Maybe$Just(
			$author$project$Pages$Guild$RepliedToView_Message$(
				$author$project$Id$fromInt(replyMessageIndex),
				replyMessage)),
		$elm$core$Maybe$Nothing,
		$author$project$Id$fromInt(messageIndex),
		message);
};
var $author$project$Pages$Guild$messageViewNotThreadStarterWithReply = F6($author$project$Pages$Guild$messageViewNotThreadStarterWithReply$);
var $author$project$Pages$Guild$messageViewThreadStarter$ = function (data, revealedSpoilers, localUser, messageIndex, thread, message) {
	var _v0 = $author$project$Pages$Guild$decodeMessageView(data);
	var time = _v0.time;
	var isMobile = _v0.isMobile;
	var isHovered = _v0.isHovered;
	var highlight = _v0.highlight;
	var isEditing = _v0.isEditing;
	var containerWidth = _v0.containerWidth;
	return $author$project$Pages$Guild$messageView$(
		time,
		isMobile,
		containerWidth,
		false,
		revealedSpoilers,
		highlight,
		isHovered,
		isEditing,
		localUser.session.userId,
		$author$project$User$allUsers(localUser),
		$lamdera$containers$SeqDict$empty,
		localUser,
		$elm$core$Maybe$Nothing,
		$elm$core$Maybe$Just(thread),
		$author$project$Id$fromInt(messageIndex),
		message);
};
var $author$project$Pages$Guild$messageViewThreadStarter = F6($author$project$Pages$Guild$messageViewThreadStarter$);
var $author$project$LocalState$typingIn$ = function (guildOrDmId, local) {
	if (!guildOrDmId.$) {
		var channelId = guildOrDmId.a.channelId;
		var guildId = guildOrDmId.a.guildId;
		var _v1 = $lamdera$containers$SeqDict$get$(guildId, local.guilds);
		if (!_v1.$) {
			var guild = _v1.a;
			return $lamdera$containers$SeqDict$filterMap$(
				F2(
					function (_v2, typing) {
						return _Utils_eq(typing.channelId, channelId) ? $elm$core$Maybe$Just(
							{threadRoute: typing.threadRoute, time: typing.time}) : $elm$core$Maybe$Nothing;
					}),
				guild.lastTypedAt);
		} else {
			return $lamdera$containers$SeqDict$empty;
		}
	} else {
		var otherUserId = guildOrDmId.a.otherUserId;
		var _v3 = $lamdera$containers$SeqDict$get$(otherUserId, local.dmChannels);
		if (!_v3.$) {
			var dmChannel = _v3.a;
			return dmChannel.lastTypedAt;
		} else {
			return $lamdera$containers$SeqDict$empty;
		}
	}
};
var $author$project$LocalState$typingIn = F2($author$project$LocalState$typingIn$);
var $author$project$Pages$Guild$conversationViewHelper$ = function (lastViewedIndex, guildOrDmIdNoThread, maybeUrlMessageId, channel, loggedIn, local, model) {
	var revealedSpoilers = $author$project$Pages$Guild$revealedChannelSpoilers$(
		$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
		loggedIn);
	var othersEditing = $lamdera$containers$SeqSet$fromList(
		$elm$core$List$filterMap$(
			function (a) {
				var _v12 = a.threadRoute;
				if (!_v12.$) {
					var maybeMessageId = _v12.a;
					return $ianmackenzie$elm_units$Quantity$lessThan$(
						$ianmackenzie$elm_units$Duration$seconds(3),
						$ianmackenzie$elm_units$Duration$from$(a.time, model.time)) ? maybeMessageId : $elm$core$Maybe$Nothing;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			$lamdera$containers$SeqDict$values(
				$lamdera$containers$SeqDict$remove$(
					local.localUser.session.userId,
					$author$project$LocalState$typingIn$(guildOrDmIdNoThread, local)))));
	var isSelectingAnchor = $author$project$Pages$Guild$drawingIsSelectingAnchor$(loggedIn, model);
	var isMobile = $author$project$MyUi$isMobile(model);
	var guildOrDmId = _Utils_Tuple2(
		$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
		$author$project$Id$NoThread);
	var maybeEditing = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.editMessage);
	var replyToIndex = $elm$core$Maybe$andThen$(
		$author$project$Message$replyToMaybe,
		$lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.replyTo));
	var containerWidth = $author$project$Pages$Guild$conversationWidth(model);
	var channels = $author$project$LocalState$guildChannels$(guildOrDmIdNoThread, local);
	return $author$project$Pages$Guild$prependUnreadDivider$(
		lastViewedIndex,
		channel.visibleMessages.oldest,
		$author$project$MessageArray$foldr$(
			F3(
				function (messageId, maybeMessage, _v0) {
					var maybeLastDate = _v0.a;
					var list = _v0.b;
					var index = $author$project$Id$toInt(messageId);
					if (!maybeMessage.$) {
						var message = maybeMessage.a;
						var threadRoute2 = $author$project$Id$NoThreadWithMessage(messageId);
						var threadId = $author$project$Id$fromInt(index);
						var otherUserIsEditing = $lamdera$containers$SeqSet$member$(
							$author$project$Id$changeType(messageId),
							othersEditing);
						var messageHover2 = $author$project$Pages$Guild$messageHover$(
							$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
							threadRoute2,
							loggedIn,
							model);
						var maybeRepliedTo2 = $author$project$Pages$Guild$channelMessageRepliedTo$(local.localUser, channel.games, message, channel);
						var isEditing = function () {
							if (!maybeEditing.$) {
								var editing = maybeEditing.a;
								return _Utils_eq(editing.messageIndex, messageId) ? $elm$core$Maybe$Just(editing) : $elm$core$Maybe$Nothing;
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}();
						var highlight = _Utils_eq(
							maybeUrlMessageId,
							$elm$core$Maybe$Just(messageId)) ? 3 : (_Utils_eq(
							replyToIndex,
							$elm$core$Maybe$Just(messageId)) ? 1 : 0);
						var date = $justinmimbs$date$Date$fromPosix$(
							local.localUser.timezone,
							$author$project$Message$createdAt(message));
						return _Utils_Tuple2(
							$elm$core$Maybe$Just(date),
							function (keyedMessage) {
								return A2(
									$elm$core$List$cons,
									keyedMessage,
									_Utils_ap(
										$elm$core$List$map$(
											$elm$core$Tuple$mapSecond(
												$author$project$Ui$map(
													A2(
														$author$project$Types$MessageViewMsg,
														$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
														threadRoute2))),
											$author$project$Pages$Guild$newMessageLine$(
												$author$project$User$userColor(local.localUser),
												isSelectingAnchor,
												channel.dateDividerDrawings,
												maybeLastDate,
												date,
												lastViewedIndex,
												index,
												messageId)),
										list));
							}(
								_Utils_Tuple2(
									$elm$core$String$fromInt(index),
									function () {
										if (!isEditing.$) {
											var edit = isEditing.a;
											if ($author$project$MyUi$isMobile(model)) {
												return A2(
													$author$project$Ui$map,
													A2(
														$author$project$Types$MessageViewMsg,
														$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
														threadRoute2),
													$author$project$Pages$Guild$messageView$(
														model.time,
														isMobile,
														containerWidth,
														false,
														revealedSpoilers,
														highlight,
														messageHover2,
														otherUserIsEditing,
														local.localUser.session.userId,
														$author$project$User$allUsers(local.localUser),
														channels,
														local.localUser,
														maybeRepliedTo2,
														$lamdera$containers$SeqDict$get$(threadId, channel.threads),
														messageId,
														message));
											} else {
												var charsLeft = $author$project$RichText$maxLength - $elm$core$String$length(edit.text);
												var channelMentions = $author$project$LocalState$guildChannelMentions$(local.localUser, channels);
												var allUsers = $author$project$User$allUsers(local.localUser);
												var editRichText = function () {
													var _v3 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(edit.text);
													if (!_v3.$) {
														var nonempty = _v3.a;
														return $elm$core$Maybe$Just(
															$author$project$RichText$fromNonemptyString$(local.localUser.timezone, allUsers, channelMentions, nonempty));
													} else {
														return $elm$core$Maybe$Nothing;
													}
												}();
												return $author$project$Pages$Guild$messageEditingView$(
													containerWidth,
													model.time,
													isMobile,
													guildOrDmId,
													threadRoute2,
													message,
													maybeRepliedTo2,
													$lamdera$containers$SeqDict$get$(threadId, channel.threads),
													revealedSpoilers,
													charsLeft,
													edit,
													editRichText,
													loggedIn,
													local.localUser.decryptedMessages,
													local.localUser.session.userId,
													allUsers,
													channelMentions,
													local);
											}
										} else {
											var _v4 = $lamdera$containers$SeqDict$get$(threadId, channel.threads);
											if (_v4.$ === 1) {
												var _v5 = _Utils_Tuple2(
													maybeRepliedTo2,
													$author$project$Message$mentionsChannel(message) || $author$project$Pages$Guild$repliedToMentionsChannel(maybeRepliedTo2));
												if (_v5.a.$ === 1) {
													if (!_v5.b) {
														var _v6 = _v5.a;
														return A2(
															$author$project$Ui$map,
															A2(
																$author$project$Types$MessageViewMsg,
																$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
																threadRoute2),
															$author$project$Ui$Lazy$lazy5$(
																$author$project$Pages$Guild$messageViewNotThreadStarter,
																$author$project$Pages$Guild$encodeMessageView$(isMobile, messageHover2, containerWidth, otherUserIsEditing, highlight, model.time),
																revealedSpoilers,
																local.localUser,
																index,
																message));
													} else {
														var _v7 = _v5.a;
														return A2(
															$author$project$Ui$map,
															A2(
																$author$project$Types$MessageViewMsg,
																$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
																threadRoute2),
															$author$project$Ui$Lazy$lazy6$(
																$author$project$Pages$Guild$messageViewNotThreadStarterWithChannelMention,
																$author$project$Pages$Guild$encodeMessageView$(isMobile, messageHover2, containerWidth, otherUserIsEditing, highlight, model.time),
																revealedSpoilers,
																local.localUser,
																index,
																message,
																channels));
													}
												} else {
													if ((!_v5.a.a.$) && (!_v5.b)) {
														var _v8 = _v5.a.a;
														var replyMessageIndex = _v8.a;
														var repliedToMessage = _v8.b;
														return A2(
															$author$project$Ui$map,
															A2(
																$author$project$Types$MessageViewMsg,
																$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
																threadRoute2),
															$author$project$Ui$Lazy$lazy6$(
																$author$project$Pages$Guild$messageViewNotThreadStarterWithReply,
																$author$project$Pages$Guild$encodeMessageView$(isMobile, messageHover2, containerWidth, otherUserIsEditing, highlight, model.time),
																revealedSpoilers,
																local.localUser,
																$author$project$Pages$Guild$encodeMessageIndex$(index, replyMessageIndex),
																message,
																repliedToMessage));
													} else {
														return A2(
															$author$project$Ui$map,
															A2(
																$author$project$Types$MessageViewMsg,
																$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
																threadRoute2),
															$author$project$Pages$Guild$messageView$(
																model.time,
																isMobile,
																containerWidth,
																false,
																revealedSpoilers,
																highlight,
																messageHover2,
																otherUserIsEditing,
																local.localUser.session.userId,
																$author$project$User$allUsers(local.localUser),
																channels,
																local.localUser,
																maybeRepliedTo2,
																$elm$core$Maybe$Nothing,
																messageId,
																message));
													}
												}
											} else {
												var thread = _v4.a;
												var _v9 = _Utils_Tuple2(
													maybeRepliedTo2,
													$author$project$Message$mentionsChannel(message) || $author$project$Pages$Guild$lastThreadMessageMentionsChannel(thread));
												if ((_v9.a.$ === 1) && (!_v9.b)) {
													var _v10 = _v9.a;
													return A2(
														$author$project$Ui$map,
														A2(
															$author$project$Types$MessageViewMsg,
															$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
															threadRoute2),
														$author$project$Ui$Lazy$lazy6$(
															$author$project$Pages$Guild$messageViewThreadStarter,
															$author$project$Pages$Guild$encodeMessageView$(isMobile, messageHover2, containerWidth, otherUserIsEditing, highlight, model.time),
															revealedSpoilers,
															local.localUser,
															index,
															thread,
															message));
												} else {
													return A2(
														$author$project$Ui$map,
														A2(
															$author$project$Types$MessageViewMsg,
															$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
															threadRoute2),
														$author$project$Pages$Guild$messageView$(
															model.time,
															isMobile,
															containerWidth,
															false,
															revealedSpoilers,
															highlight,
															messageHover2,
															otherUserIsEditing,
															local.localUser.session.userId,
															$author$project$User$allUsers(local.localUser),
															channels,
															local.localUser,
															maybeRepliedTo2,
															$elm$core$Maybe$Just(thread),
															messageId,
															message));
												}
											}
										}
									}())));
					} else {
						return _Utils_Tuple2(
							maybeLastDate,
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									$elm$core$String$fromInt(index),
									$author$project$Pages$Guild$unloadedMessageView(index)),
								list));
					}
				}),
			_Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil),
			$author$project$VisibleMessages$slice(channel)).b);
};
var $author$project$Pages$Guild$conversationViewHelper = F7($author$project$Pages$Guild$conversationViewHelper$);
var $author$project$Pages$Guild$missingPrivateKeyPlaceholder = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$Attributes$style,
			'color',
			$author$project$MyUi$colorToStyle($author$project$MyUi$errorColor))
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Private key missing. Goto\u00A0'),
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'position', 'absolute')
				]),
			_List_fromArray(
				[$author$project$Icons$gear]))
		]));
var $author$project$Pages$Guild$conversationView$ = function (lastViewedIndex, guildOrDmIdNoThread, maybeUrlMessageId, loggedIn, model, local, missingPrivateKey, name, channel) {
	var replyTo = $lamdera$containers$SeqDict$get$(
		_Utils_Tuple2(
			$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
			$author$project$Id$NoThread),
		loggedIn.replyTo);
	var isMobile = $author$project$MyUi$isMobile(model);
	var draft = function () {
		var _v5 = $lamdera$containers$SeqDict$get$(
			_Utils_Tuple2(
				$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
				$author$project$Id$NoThread),
			loggedIn.drafts);
		if (!_v5.$) {
			var text = _v5.a;
			return $MartinSStewart$elm_nonempty_string$String$Nonempty$toString(text);
		} else {
			return '';
		}
	}();
	var channels = $author$project$LocalState$channelMentions$(guildOrDmIdNoThread, local);
	var allUsers = $author$project$User$allUsers(local.localUser);
	var draftRichText = function () {
		var _v4 = $lamdera$containers$SeqDict$get$(
			_Utils_Tuple2(
				$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
				$author$project$Id$NoThread),
			loggedIn.drafts);
		if (!_v4.$) {
			var text = _v4.a;
			return $elm$core$Maybe$Just(
				$author$project$RichText$fromNonemptyString$(local.localUser.timezone, allUsers, channels, text));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$Ui$heightMin(0)
			]),
		_List_fromArray(
			[
				$author$project$ChannelHeader$channel$(isMobile, name, guildOrDmIdNoThread, local, loggedIn, model),
				$author$project$Ui$el$(
				_Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Guild$emojiSelector$(isMobile, local.localUser.user.availableCustomEmojis, local.localUser.user.availableStickers, local, loggedIn, model),
							$author$project$Ui$heightMin(0),
							$author$project$Ui$height($author$project$Ui$fill)
						]),
					$author$project$Pages$Guild$drawingModeAttributes$(model.route, loggedIn.drawingMode)),
				$author$project$Ui$Keyed$column$(
					_Utils_ap(
						_List_fromArray(
							[
								$author$project$Ui$height($author$project$Ui$fill),
								$author$project$Ui$width($author$project$Ui$fill),
								$author$project$Ui$paddingWith(
								{bottom: 16, left: 0, right: 0, top: 200}),
								$author$project$MyUi$scrollable(
								$author$project$MyUi$canScroll$(
									$author$project$MyUi$isMobile(model),
									model.drag)),
								$author$project$MyUi$htmlStyle$('overflow-wrap', 'break-word'),
								$author$project$Ui$id(
								$lamdera$program_test$Effect$Browser$Dom$idToString($author$project$Pages$Guild$conversationContainerId)),
								$author$project$Ui$Events$on$(
								'scroll',
								$author$project$Scroll$decodeScrollToBottom$(
									A2(
										$author$project$Types$UserScrolled,
										$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
										$author$project$Id$NoThread),
									loggedIn.channelScrollPosition)),
								$author$project$Ui$heightMin(0),
								$author$project$MyUi$bounceScroll(isMobile),
								$author$project$MyUi$htmlStyle$('background-image', 'url(/cacheable/grid1.png)')
							]),
						$author$project$Pages$Guild$drawingZoomAttributes$(model.route, loggedIn.drawingMode)),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'a',
							$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$Font$color($author$project$MyUi$font2),
										$author$project$Ui$paddingXY$(8, 4),
										$author$project$Ui$alignBottom,
										$author$project$Ui$Font$size(20)
									]),
								function () {
									if ($author$project$VisibleMessages$startIsVisible(channel.visibleMessages)) {
										if (!guildOrDmIdNoThread.$) {
											return $author$project$Ui$text('This is the start of #' + name);
										} else {
											var otherUserId = guildOrDmIdNoThread.a.otherUserId;
											return $author$project$Ui$text(
												_Utils_eq(otherUserId, local.localUser.session.userId) ? 'This is the start of a conversation with yourself' : ('This is the start of your conversation with ' + name));
										}
									} else {
										return $author$project$Ui$none;
									}
								}())),
						$author$project$Pages$Guild$conversationViewHelper$(lastViewedIndex, guildOrDmIdNoThread, maybeUrlMessageId, channel, loggedIn, local, model)))),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$paddingXY$(2, 0),
						$author$project$Ui$heightMin(0),
						$author$project$MyUi$noShrinking,
						function () {
						var _v1 = $lamdera$containers$SeqDict$get$(
							_Utils_Tuple2(
								$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
								$author$project$Id$NoThread),
							loggedIn.filesToUpload);
						if (!_v1.$) {
							var filesToUpload2 = _v1.a;
							return $author$project$Ui$inFront(
								$author$project$Pages$Guild$fileUploadPreview$(
									$author$project$Types$PressedDeleteAttachedFile(
										_Utils_Tuple2(
											$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
											$author$project$Id$NoThread)),
									$author$project$Types$PressedViewAttachedFileInfo(
										_Utils_Tuple2(
											$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
											$author$project$Id$NoThread)),
									$elm$core$Maybe$Just(
										$author$project$Types$PressedToggleAttachedFileSpoiler(
											_Utils_Tuple2(
												$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
												$author$project$Id$NoThread))),
									draftRichText,
									filesToUpload2));
						} else {
							return $author$project$Ui$noAttr;
						}
					}()
					]),
				_List_fromArray(
					[
						$author$project$Pages$Guild$newMessagesView$(model, loggedIn, channel),
						$author$project$Pages$Guild$channelReplyToHeader$(
						isMobile,
						_Utils_Tuple2(
							$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
							$author$project$Id$NoThread),
						replyTo,
						allUsers,
						channel.games,
						channel),
						A2(
						$author$project$Ui$map,
						A2(
							$author$project$Types$MessageInputMsg,
							$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
							$author$project$Id$NoThread),
						$author$project$MessageInput$view$(
							$lamdera$program_test$Effect$Browser$Dom$id('messageMenu_channelInput'),
							_Utils_eq(replyTo, $elm$core$Maybe$Nothing),
							$author$project$MyUi$isMobile(model),
							$author$project$Pages$Guild$channelTextInputId,
							missingPrivateKey ? $author$project$Pages$Guild$missingPrivateKeyPlaceholder : $author$project$MessageInput$textPlaceholder(
								function () {
									if (!guildOrDmIdNoThread.$) {
										return 'Write a message in #' + name;
									} else {
										var otherUserId = guildOrDmIdNoThread.a.otherUserId;
										return 'Write a message to ' + (_Utils_eq(otherUserId, local.localUser.session.userId) ? 'yourself' : name);
									}
								}()),
							$author$project$RichText$maxLength - $elm$core$String$length(draft),
							draft,
							draftRichText,
							function () {
								var _v3 = $lamdera$containers$SeqDict$get$(
									_Utils_Tuple2(
										$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
										$author$project$Id$NoThread),
									loggedIn.filesToUpload);
								if (!_v3.$) {
									var attachedFiles = _v3.a;
									return $author$project$NonemptyDict$toSeqDict(attachedFiles);
								} else {
									return $lamdera$containers$SeqDict$empty;
								}
							}(),
							local.localUser,
							loggedIn,
							$author$project$User$allUsers(local.localUser),
							channels)),
						$author$project$Pages$Guild$peopleAreTypingView$(
						allUsers,
						$author$project$Id$NoThread,
						$author$project$LocalState$typingIn$(guildOrDmIdNoThread, local),
						local.localUser.session.userId,
						model)
					]))
			]));
};
var $author$project$Pages$Guild$conversationView = F9($author$project$Pages$Guild$conversationView$);
var $author$project$Types$PressedCreateInviteLink = function (a) {
	return {$: 28, a: a};
};
var $author$project$Types$PressedDeleteInviteLink$ = function (a, b) {
	return {$: 29, a: a, b: b};
};
var $author$project$Types$PressedDeleteInviteLink = F2($author$project$Types$PressedDeleteInviteLink$);
var $author$project$Types$PressedGuildNotificationLevel$ = function (a, b) {
	return {$: 105, a: a, b: b};
};
var $author$project$Types$PressedGuildNotificationLevel = F2($author$project$Types$PressedGuildNotificationLevel$);
var $author$project$Types$PressedMuteGuild$ = function (a, b) {
	return {$: 178, a: a, b: b};
};
var $author$project$Types$PressedMuteGuild = F2($author$project$Types$PressedMuteGuild$);
var $author$project$Types$PressedToggleInviteLinkQrCode = function (a) {
	return {$: 31, a: a};
};
var $author$project$Types$EditGuildFormChanged$ = function (a, b) {
	return {$: 20, a: a, b: b};
};
var $author$project$Types$EditGuildFormChanged = F2($author$project$Types$EditGuildFormChanged$);
var $author$project$Types$PressedDeleteGuild = function (a) {
	return {$: 23, a: a};
};
var $author$project$Pages$Guild$deleteGuildConfirmationInput$ = function (guildId, guildNameString, form) {
	var confirmLabel = $author$project$Ui$Input$label$(
		'deleteGuildConfirmation',
		_List_fromArray(
			[
				$author$project$Ui$Font$color($author$project$MyUi$font2),
				$author$project$Ui$paddingXY$(2, 0)
			]),
		$author$project$Ui$text('Type \u0022' + (guildNameString + '\u0022 to confirm deletion')));
	return $author$project$Ui$column$(
		_List_Nil,
		_List_fromArray(
			[
				confirmLabel.element,
				A2(
				$author$project$Ui$Input$text,
				_List_fromArray(
					[
						$author$project$Ui$padding(6),
						$author$project$Ui$background($author$project$MyUi$inputBackground),
						$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
						$author$project$Ui$widthMax(500)
					]),
				{
					label: confirmLabel.id,
					onChange: function (text) {
						return $author$project$Types$EditGuildFormChanged$(
							guildId,
							_Utils_update(
								form,
								{deleteConfirmation: text}));
					},
					placeholder: $elm$core$Maybe$Nothing,
					text: form.deleteConfirmation
				})
			]));
};
var $author$project$Pages$Guild$deleteGuildConfirmationInput = F3($author$project$Pages$Guild$deleteGuildConfirmationInput$);
var $author$project$Pages$Guild$deleteGuildText = 'Delete guild';
var $author$project$Pages$Guild$deleteGuildSection$ = function (guildId, guild, form) {
	var guildNameString = $author$project$GuildName$toString(guild.name);
	var confirmationMatches = _Utils_eq(form.deleteConfirmation, guildNameString);
	var _v0 = (!form.showDeleteConfirmation) ? _Utils_Tuple2(
		$author$project$Types$EditGuildFormChanged$(
			guildId,
			_Utils_update(
				form,
				{showDeleteConfirmation: true})),
		true) : (confirmationMatches ? _Utils_Tuple2(
		$author$project$Types$PressedDeleteGuild(guildId),
		true) : _Utils_Tuple2($author$project$Types$FrontendNoOp, false));
	var deleteOnPress = _v0.a;
	var deleteEnabled = _v0.b;
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(12),
				$author$project$Ui$paddingXY$(16, 0)
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$height(
						$author$project$Ui$px(1)),
						$author$project$Ui$background($author$project$MyUi$border2)
					]),
				$author$project$Ui$none),
				form.showDeleteConfirmation ? $author$project$Pages$Guild$deleteGuildConfirmationInput$(guildId, guildNameString, form) : $author$project$Ui$none,
				$author$project$MyUi$elButton$(
				$lamdera$program_test$Effect$Browser$Dom$id('guild_deleteGuild'),
				deleteOnPress,
				_List_fromArray(
					[
						$author$project$Ui$paddingXY$(16, 4),
						$author$project$Ui$background(
						deleteEnabled ? $author$project$MyUi$deleteButtonBackground : $author$project$MyUi$disabledButtonBackground),
						$author$project$Ui$width($author$project$Ui$shrink),
						$author$project$Ui$rounded(4),
						$author$project$Ui$Font$color($author$project$MyUi$deleteButtonFont),
						$author$project$Ui$Font$bold,
						$author$project$Ui$borderColor(
						deleteEnabled ? $author$project$MyUi$deleteButtonBorder : $author$project$MyUi$disabledButtonBorder),
						$author$project$Ui$border(1)
					]),
				$author$project$Ui$text($author$project$Pages$Guild$deleteGuildText))
			]));
};
var $author$project$Pages$Guild$deleteGuildSection = F3($author$project$Pages$Guild$deleteGuildSection$);
var $author$project$Types$NotImportingChannel = {$: 0};
var $author$project$Pages$Guild$editGuildFormInit = function (guild) {
	return {
		deleteConfirmation: '',
		importChannel: $author$project$Types$NotImportingChannel,
		name: $author$project$GuildName$toString(guild.name),
		pressedSubmit: false,
		showDeleteConfirmation: false,
		showLeaveConfirmation: false
	};
};
var $author$project$Types$PressedResetEditGuildChanges = function (a) {
	return {$: 21, a: a};
};
var $author$project$Types$PressedSubmitEditGuildChanges$ = function (a, b) {
	return {$: 22, a: a, b: b};
};
var $author$project$Types$PressedSubmitEditGuildChanges = F2($author$project$Types$PressedSubmitEditGuildChanges$);
var $author$project$Pages$Guild$submitButton$ = function (htmlId, onPress, text) {
	return $author$project$MyUi$elButton$(
		htmlId,
		onPress,
		_List_fromArray(
			[
				$author$project$Ui$paddingXY$(16, 4),
				$author$project$Ui$background($author$project$MyUi$buttonBackground),
				$author$project$Ui$width($author$project$Ui$shrink),
				$author$project$Ui$rounded(4),
				$author$project$Ui$Font$weight(500),
				$author$project$Ui$borderColor($author$project$MyUi$buttonBorder),
				$author$project$Ui$border(1)
			]),
		$author$project$Ui$text(text));
};
var $author$project$Pages$Guild$submitButton = F3($author$project$Pages$Guild$submitButton$);
var $author$project$Pages$Guild$editGuildNameSection$ = function (guildId, guild, form) {
	var nameLabel = $author$project$Ui$Input$label$(
		'editGuildName',
		_List_fromArray(
			[
				$author$project$Ui$Font$bold,
				$author$project$Ui$paddingXY$(2, 0)
			]),
		$author$project$Ui$text('Guild name'));
	var hasChanges = !_Utils_eq(
		form.name,
		$author$project$GuildName$toString(guild.name));
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8),
				$author$project$Ui$paddingXY$(16, 0)
			]),
		_List_fromArray(
			[
				nameLabel.element,
				A2(
				$author$project$Ui$Input$text,
				_List_fromArray(
					[
						$author$project$Ui$padding(6),
						$author$project$Ui$background($author$project$MyUi$inputBackground),
						$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
						$author$project$Ui$widthMax(500)
					]),
				{
					label: nameLabel.id,
					onChange: function (text) {
						return $author$project$Types$EditGuildFormChanged$(
							guildId,
							_Utils_update(
								form,
								{name: text}));
					},
					placeholder: $elm$core$Maybe$Nothing,
					text: form.name
				}),
				function () {
				var _v0 = _Utils_Tuple2(
					form.pressedSubmit,
					$author$project$GuildName$fromString(form.name));
				if (_v0.a && (_v0.b.$ === 1)) {
					var error = _v0.b.a;
					return $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$(2, 0),
								$author$project$Ui$Font$color($author$project$MyUi$errorColor)
							]),
						$author$project$Ui$text(error));
				} else {
					return $author$project$Ui$none;
				}
			}(),
				hasChanges ? $author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(8)
					]),
				_List_fromArray(
					[
						$author$project$MyUi$secondaryButton$(
						$lamdera$program_test$Effect$Browser$Dom$id('guild_resetEditGuild'),
						$author$project$Types$PressedResetEditGuildChanges(guildId),
						'Reset'),
						$author$project$Pages$Guild$submitButton$(
						$lamdera$program_test$Effect$Browser$Dom$id('guild_submitEditGuild'),
						$author$project$Types$PressedSubmitEditGuildChanges$(guildId, form),
						'Save changes')
					])) : $author$project$Ui$none
			]));
};
var $author$project$Pages$Guild$editGuildNameSection = F3($author$project$Pages$Guild$editGuildNameSection$);
var $author$project$Types$PressedBanMember$ = function (a, b) {
	return {$: 30, a: a, b: b};
};
var $author$project$Types$PressedBanMember = F2($author$project$Types$PressedBanMember$);
var $author$project$Pages$Guild$banMemberText = 'Ban';
var $author$project$Ui$Table$Cell$ = function (attrs, children) {
	return {attrs: attrs, children: children};
};
var $author$project$Ui$Table$Cell = F2($author$project$Ui$Table$Cell$);
var $author$project$Ui$Table$cell$ = function (attrs, child) {
	return $author$project$Ui$Table$Cell$(
		attrs,
		_List_fromArray(
			[child]));
};
var $author$project$Ui$Table$cell = F2($author$project$Ui$Table$cell$);
var $author$project$Ui$Table$Column = $elm$core$Basics$identity;
var $author$project$Ui$Table$defaultWidth = {fill: false, max: $elm$core$Maybe$Nothing, min: $elm$core$Maybe$Nothing};
var $author$project$Ui$Table$column = function (input) {
	return {
		columnSpan: 1,
		header: function (_v0) {
			return input.header;
		},
		order: $elm$core$Maybe$Nothing,
		summary: $elm$core$Maybe$Nothing,
		view: F3(
			function (_v1, _v2, data) {
				return _List_fromArray(
					[
						input.view(data)
					]);
			}),
		visible: $elm$core$Maybe$Nothing,
		widths: _List_fromArray(
			[$author$project$Ui$Table$defaultWidth])
	};
};
var $author$project$Ui$Table$columns = function (cols) {
	return {
		columns: cols,
		scrollable: false,
		sort: $elm$core$Maybe$Nothing,
		stickFirstColumn: false,
		stickHeader: false,
		stickRow: function (_v0) {
			return false;
		},
		toKey: function (_v1) {
			return 'keyed';
		},
		toRowAttrs: $elm$core$Maybe$Nothing,
		toRowState: $elm$core$Maybe$Nothing
	};
};
var $author$project$Pages$Guild$guildMemberCellPadding = _List_fromArray(
	[
		$author$project$Ui$paddingXY$(8, 4),
		$author$project$Ui$contentCenterY
	]);
var $author$project$Pages$Guild$guildMembersText = 'Members';
var $author$project$Ui$Font$alignLeft = $author$project$Internal$Model2$classWith$($author$project$Internal$Flag$fontAlignment, $author$project$Internal$Style2$classes.textLeft);
var $author$project$Ui$Table$default = {
	borderHeader: $author$project$Ui$borderWith(
		{bottom: 1, left: 0, right: 0, top: 0}),
	fontAlignment: $author$project$Ui$Font$alignLeft,
	padding: $author$project$Ui$paddingXY$(16, 8),
	paddingFirstRow: $author$project$Ui$paddingWith(
		{bottom: 8, left: 16, right: 16, top: 8})
};
var $author$project$Ui$Table$header = function (str) {
	return $author$project$Ui$Table$cell$(
		_List_fromArray(
			[
				$author$project$Ui$Table$default.padding,
				$author$project$Ui$Table$default.borderHeader,
				$author$project$Ui$height($author$project$Ui$fill)
			]),
		$author$project$Ui$text(str));
};
var $author$project$Pages$Guild$neverPostedText = 'Never';
var $author$project$Internal$Model2$NodeAsTable = {$: 5};
var $author$project$Internal$Model2$attrIf$ = function (bool, attr) {
	return bool ? attr : $author$project$Internal$Model2$noAttr;
};
var $author$project$Internal$Model2$attrIf = F2($author$project$Internal$Model2$attrIf$);
var $author$project$Ui$Table$hasColumnMods = function (_v0) {
	var col = _v0;
	return (!_Utils_eq(col.visible, $elm$core$Maybe$Nothing)) || (!_Utils_eq(col.order, $elm$core$Maybe$Nothing));
};
var $author$project$Ui$Table$getColumns$ = function (config, state) {
	return $elm$core$List$any$($author$project$Ui$Table$hasColumnMods, config.columns) ? A2(
		$elm$core$List$sortBy,
		function (_v2) {
			var col = _v2;
			var _v3 = col.order;
			if (_v3.$ === 1) {
				return 0;
			} else {
				var getOrder = _v3.a;
				return getOrder(state);
			}
		},
		$elm$core$List$filter$(
			function (_v0) {
				var col = _v0;
				var _v1 = col.visible;
				if (_v1.$ === 1) {
					return true;
				} else {
					var isVisible = _v1.a;
					return isVisible(state);
				}
			},
			config.columns)) : config.columns;
};
var $author$project$Ui$Table$getColumns = F2($author$project$Ui$Table$getColumns$);
var $author$project$Ui$Table$renderWidth = function (w) {
	var _v0 = w.min;
	if (_v0.$ === 1) {
		var _v1 = w.max;
		if (_v1.$ === 1) {
			return w.fill ? '1fr' : 'minmax(min-content, max-content)';
		} else {
			var max = _v1.a;
			return w.fill ? ('minmax(1fr, ' + ($elm$core$String$fromInt(max) + 'px)')) : ('minmax(min-content, ' + ($elm$core$String$fromInt(max) + 'px)'));
		}
	} else {
		var min = _v0.a;
		var _v2 = w.max;
		if (_v2.$ === 1) {
			return w.fill ? ('minmax(' + ($elm$core$String$fromInt(min) + 'px , 1fr)')) : ('minmax(' + ($elm$core$String$fromInt(min) + 'px , max-content)'));
		} else {
			var max = _v2.a;
			return 'minmax(' + ($elm$core$String$fromInt(min) + ('px , ' + ($elm$core$String$fromInt(max) + ')')));
		}
	}
};
var $author$project$Ui$Table$renderWidthList$ = function (width, str) {
	renderWidthList:
	while (true) {
		if (!width.b) {
			return str;
		} else {
			var w = width.a;
			var remain = width.b;
			if (str === '') {
				var $temp$width = remain,
					$temp$str = $author$project$Ui$Table$renderWidth(w);
				width = $temp$width;
				str = $temp$str;
				continue renderWidthList;
			} else {
				var $temp$width = remain,
					$temp$str = str + (' ' + $author$project$Ui$Table$renderWidth(w));
				width = $temp$width;
				str = $temp$str;
				continue renderWidthList;
			}
		}
	}
};
var $author$project$Ui$Table$renderWidthList = F2($author$project$Ui$Table$renderWidthList$);
var $author$project$Ui$Table$columnToGridTemplate = function (col) {
	return $author$project$Ui$Table$renderWidthList$(col.widths, '');
};
var $author$project$Ui$Table$gridTemplateColumns$ = function (state, cols, str) {
	gridTemplateColumns:
	while (true) {
		if (!cols.b) {
			return str;
		} else {
			var col = cols.a;
			var remain = cols.b;
			var $temp$cols = remain,
				$temp$str = str + (' ' + $author$project$Ui$Table$columnToGridTemplate(col));
			cols = $temp$cols;
			str = $temp$str;
			continue gridTemplateColumns;
		}
	}
};
var $author$project$Ui$Table$gridTemplateColumns = F3($author$project$Ui$Table$gridTemplateColumns$);
var $author$project$Ui$Table$hasSummary = function (_v0) {
	var col = _v0;
	var _v1 = col.summary;
	if (_v1.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Internal$Model2$NodeAsTableHead = {$: 6};
var $author$project$Internal$Model2$NodeAsTableRow = {$: 8};
var $author$project$Internal$Model2$NodeAsTableHeaderCell = {$: 7};
var $author$project$Ui$Table$toGridCoords$ = function (rowStart, columnStart, rowEnd, columnEnd) {
	return $author$project$Internal$Model2$style$(
		'grid-area',
		_Utils_ap(
			$elm$core$String$fromInt(rowStart) + ' / ',
			_Utils_ap(
				$elm$core$String$fromInt(columnStart) + ' / ',
				_Utils_ap(
					$elm$core$String$fromInt(rowEnd) + ' / ',
					$elm$core$String$fromInt(columnEnd)))));
};
var $author$project$Ui$Table$toGridCoords = F4($author$project$Ui$Table$toGridCoords$);
var $author$project$Ui$Table$viewHeaderCell$ = function (cfg, state, negativeIndex, _v0) {
	var col = _v0;
	var columnIndex = negativeIndex + 1;
	var isFirstColumn = columnIndex === 1;
	var stickyColumn = cfg.stickFirstColumn && isFirstColumn;
	var _v1 = col.header(state);
	var children = _v1.children;
	var attrs = _v1.attrs;
	return $author$project$Internal$Model2$element$(
		$author$project$Internal$Model2$NodeAsTableHeaderCell,
		2,
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Table$default.padding,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Table$toGridCoords$(1, columnIndex, 2, columnIndex + col.columnSpan),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Table$default.fontAlignment,
					A2(
						$elm$core$List$cons,
						$author$project$Internal$Model2$attrIf$(
							cfg.stickHeader,
							$author$project$Internal$Model2$class($author$project$Internal$Style2$classes.stickyTop)),
						A2(
							$elm$core$List$cons,
							$author$project$Internal$Model2$attrIf$(
								stickyColumn,
								$author$project$Internal$Model2$class($author$project$Internal$Style2$classes.stickyLeft)),
							A2(
								$elm$core$List$cons,
								$author$project$Internal$Model2$attrIf$(
									cfg.stickHeader || stickyColumn,
									$author$project$Ui$background(
										$author$project$Ui$rgb$(255, 255, 255))),
								A2(
									$elm$core$List$cons,
									$author$project$Internal$Model2$attrIf$(
										cfg.stickHeader || stickyColumn,
										(cfg.stickHeader && stickyColumn) ? $author$project$Internal$Model2$style$('z-index', '2') : $author$project$Internal$Model2$style$('z-index', '1')),
									attrs))))))),
		children);
};
var $author$project$Ui$Table$viewHeaderCell = F4($author$project$Ui$Table$viewHeaderCell$);
var $author$project$Ui$Table$viewHeaderHelper$ = function (config, state, col, _v0) {
	var colData = col;
	var columnIndex = _v0.a;
	var existingCols = _v0.b;
	return _Utils_Tuple2(
		columnIndex + colData.columnSpan,
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$elm$core$String$fromInt(columnIndex),
				$author$project$Ui$Lazy$lazy4$($author$project$Ui$Table$viewHeaderCell, config, state, columnIndex, col)),
			existingCols));
};
var $author$project$Ui$Table$viewHeaderHelper = F4($author$project$Ui$Table$viewHeaderHelper$);
var $author$project$Ui$Table$viewHeader$ = function (state, config) {
	var cols = $author$project$Ui$Table$getColumns$(config, state);
	var _v0 = $elm$core$List$foldl$(
		A2($author$project$Ui$Table$viewHeaderHelper, config, state),
		_Utils_Tuple2(0, _List_Nil),
		cols);
	var cells = _v0.b;
	return $author$project$Internal$Model2$element$(
		$author$project$Internal$Model2$NodeAsTableHead,
		0,
		_List_fromArray(
			[
				$author$project$Internal$Model2$style$('display', 'contents')
			]),
		_List_fromArray(
			[
				$author$project$Internal$Model2$elementKeyed$(
				$author$project$Internal$Model2$NodeAsTableRow,
				0,
				_List_fromArray(
					[
						$author$project$Internal$Model2$style$('display', 'contents')
					]),
				$elm$core$List$reverse(cells))
			]));
};
var $author$project$Ui$Table$viewHeader = F2($author$project$Ui$Table$viewHeader$);
var $author$project$Internal$Model2$NodeAsTableFoot = {$: 10};
var $author$project$Internal$Model2$NodeAsTableD = {$: 9};
var $author$project$Ui$Table$viewSummaryColumn$ = function (config, state, rows, rowCount, columnIndex, _v0) {
	var col = _v0;
	var padding = $author$project$Ui$Table$default.padding;
	var isFirstColumn = columnIndex === 1;
	var _v1 = function () {
		var _v2 = col.summary;
		if (_v2.$ === 1) {
			return $author$project$Ui$Table$cell$(_List_Nil, $author$project$Ui$none);
		} else {
			var sum = _v2.a;
			return A2(sum, state, rows);
		}
	}();
	var children = _v1.children;
	var attrs = _v1.attrs;
	return $author$project$Internal$Model2$element$(
		$author$project$Internal$Model2$NodeAsTableD,
		2,
		A2(
			$elm$core$List$cons,
			padding,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Table$toGridCoords$(rowCount + 2, columnIndex, rowCount + 3, columnIndex + col.columnSpan),
				A2(
					$elm$core$List$cons,
					$author$project$Internal$Model2$attrIf$(
						config.stickHeader,
						$author$project$Internal$Model2$class($author$project$Internal$Style2$classes.stickyBottom)),
					A2(
						$elm$core$List$cons,
						$author$project$Internal$Model2$attrIf$(
							config.stickFirstColumn && isFirstColumn,
							$author$project$Internal$Model2$class($author$project$Internal$Style2$classes.stickyLeft)),
						A2(
							$elm$core$List$cons,
							$author$project$Internal$Model2$attrIf$(
								config.stickHeader,
								$author$project$Ui$background(
									$author$project$Ui$rgb$(255, 255, 255))),
							A2(
								$elm$core$List$cons,
								$author$project$Internal$Model2$attrIf$(
									config.stickFirstColumn && isFirstColumn,
									$author$project$Internal$Model2$style$('z-index', '1')),
								A2(
									$elm$core$List$cons,
									$author$project$Ui$height($author$project$Ui$fill),
									attrs))))))),
		children);
};
var $author$project$Ui$Table$viewSummaryColumn = F6($author$project$Ui$Table$viewSummaryColumn$);
var $author$project$Ui$Table$viewSummaryHelper$ = function (config, state, rows, rowCount, col, _v0) {
	var colData = col;
	var columnIndex = _v0.a;
	var existingCols = _v0.b;
	return _Utils_Tuple2(
		columnIndex + colData.columnSpan,
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$elm$core$String$fromInt(columnIndex),
				$author$project$Ui$Lazy$lazy6$($author$project$Ui$Table$viewSummaryColumn, config, state, rows, rowCount, columnIndex, col)),
			existingCols));
};
var $author$project$Ui$Table$viewSummaryHelper = F6($author$project$Ui$Table$viewSummaryHelper$);
var $author$project$Ui$Table$viewSummary$ = function (config, cols, state, rows) {
	var rowCount = $elm$core$List$length(rows);
	var _v0 = $elm$core$List$foldl$(
		A4($author$project$Ui$Table$viewSummaryHelper, config, state, rows, rowCount),
		_Utils_Tuple2(1, _List_Nil),
		cols);
	var cells = _v0.b;
	return $author$project$Internal$Model2$element$(
		$author$project$Internal$Model2$NodeAsTableFoot,
		0,
		_List_fromArray(
			[
				$author$project$Internal$Model2$style$('display', 'contents')
			]),
		_List_fromArray(
			[
				$author$project$Internal$Model2$elementKeyed$(
				$author$project$Internal$Model2$NodeAsTableRow,
				0,
				_List_fromArray(
					[
						$author$project$Internal$Model2$style$('display', 'contents')
					]),
				$elm$core$List$reverse(cells))
			]));
};
var $author$project$Ui$Table$viewSummary = F4($author$project$Ui$Table$viewSummary$);
var $author$project$Internal$Model2$NodeAsTableBody = {$: 11};
var $author$project$Ui$Table$viewActiveRow$ = function (config, globalState, row, _v0) {
	var rowZeroIndex = _v0.a;
	var acc = _v0.b;
	var _v1 = config.toRowAttrs;
	if (_v1.$ === 1) {
		return _Utils_Tuple2(rowZeroIndex + 1, acc);
	} else {
		var toAttrs = _v1.a;
		var maybeRowState = function () {
			var _v3 = config.toRowState;
			if (_v3.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var toState = _v3.a;
				return A3(toState, globalState, rowZeroIndex, row);
			}
		}();
		var rowAttrs = A2(toAttrs, maybeRowState, row);
		if (!rowAttrs.b) {
			return _Utils_Tuple2(rowZeroIndex + 1, acc);
		} else {
			return _Utils_Tuple2(
				rowZeroIndex + 1,
				A2(
					$elm$core$List$cons,
					$author$project$Ui$el$(
						A2(
							$elm$core$List$cons,
							$author$project$Ui$Table$toGridCoords$(rowZeroIndex + 2, 1, rowZeroIndex + 3, -1),
							rowAttrs),
						$author$project$Ui$none),
					acc));
		}
	}
};
var $author$project$Ui$Table$viewActiveRow = F4($author$project$Ui$Table$viewActiveRow$);
var $author$project$Ui$Table$viewActiveRows$ = function (config, globalState, rows) {
	var _v0 = $elm$core$List$foldl$(
		A2($author$project$Ui$Table$viewActiveRow, config, globalState),
		_Utils_Tuple2(0, _List_Nil),
		rows);
	var selected = _v0.b;
	if (!selected.b) {
		return $author$project$Ui$none;
	} else {
		return $author$project$Internal$Model2$element$(
			$author$project$Internal$Model2$NodeAsTableRow,
			0,
			_List_fromArray(
				[
					$author$project$Internal$Model2$style$('display', 'contents')
				]),
			selected);
	}
};
var $author$project$Ui$Table$viewActiveRows = F3($author$project$Ui$Table$viewActiveRows$);
var $author$project$Internal$Model2$NodeAsSpan = {$: 1};
var $author$project$Ui$Table$viewCellInner$ = function (config, nodeType, rowIndex, columnIndex, cellIndex, cellCount, _v0) {
	var children = _v0.children;
	var attrs = _v0.attrs;
	var padding = (cellCount === 1) ? ((!rowIndex) ? $author$project$Ui$Table$default.paddingFirstRow : $author$project$Ui$Table$default.padding) : ((!cellIndex) ? $author$project$Ui$paddingWith(
		{bottom: 8, left: 16, right: 0, top: 8}) : (_Utils_eq(cellIndex, cellCount - 1) ? $author$project$Ui$paddingWith(
		{bottom: 8, left: 0, right: 16, top: 8}) : $author$project$Ui$paddingXY$(0, 8)));
	var isFirstColumn = columnIndex === 1;
	return $author$project$Internal$Model2$element$(
		nodeType,
		2,
		A2(
			$elm$core$List$cons,
			padding,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Table$toGridCoords$(rowIndex + 2, columnIndex, rowIndex + 3, columnIndex + 1),
				A2(
					$elm$core$List$cons,
					$author$project$Internal$Model2$attrIf$(
						config.stickFirstColumn && isFirstColumn,
						$author$project$Internal$Model2$class($author$project$Internal$Style2$classes.stickyLeft)),
					A2(
						$elm$core$List$cons,
						$author$project$Internal$Model2$attrIf$(
							config.stickFirstColumn && isFirstColumn,
							$author$project$Ui$background(
								$author$project$Ui$rgb$(255, 255, 255))),
						A2(
							$elm$core$List$cons,
							$author$project$Internal$Model2$attrIf$(
								config.stickFirstColumn && isFirstColumn,
								$author$project$Internal$Model2$style$('z-index', '1')),
							attrs))))),
		children);
};
var $author$project$Ui$Table$viewCellInner = F7($author$project$Ui$Table$viewCellInner$);
var $author$project$Ui$Table$viewCell$ = function (config, state, rowIndex, row, _v0, columnIndexZero) {
	var col = _v0;
	var columnIndex = columnIndexZero + 1;
	var isFirstColumn = columnIndex === 1;
	var _v1 = A3(col.view, rowIndex, state, row);
	if (!_v1.b) {
		return $author$project$Internal$Model2$element$($author$project$Internal$Model2$NodeAsTableD, 2, _List_Nil, _List_Nil);
	} else {
		if (!_v1.b.b) {
			var single = _v1.a;
			return $author$project$Ui$Table$viewCellInner$(config, $author$project$Internal$Model2$NodeAsTableD, rowIndex, columnIndex, 0, col.columnSpan, single);
		} else {
			var cells = _v1;
			return $author$project$Internal$Model2$element$(
				$author$project$Internal$Model2$NodeAsTableD,
				2,
				_List_fromArray(
					[
						$author$project$Internal$Model2$style$('display', 'contents')
					]),
				$elm$core$List$indexedMap$(
					F2(
						function (i, data) {
							return $author$project$Ui$Table$viewCellInner$(config, $author$project$Internal$Model2$NodeAsSpan, rowIndex, columnIndex + i, i, col.columnSpan, data);
						}),
					cells));
		}
	}
};
var $author$project$Ui$Table$viewCell = F6($author$project$Ui$Table$viewCell$);
var $author$project$Ui$Table$viewCellHelper$ = function (config, state, rowIndex, row, col, _v0) {
	var colData = col;
	var columnIndex = _v0.a;
	var existingCols = _v0.b;
	return _Utils_Tuple2(
		columnIndex + colData.columnSpan,
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$elm$core$String$fromInt(columnIndex),
				$author$project$Ui$Lazy$lazy6$($author$project$Ui$Table$viewCell, config, state, rowIndex, row, col, columnIndex)),
			existingCols));
};
var $author$project$Ui$Table$viewCellHelper = F6($author$project$Ui$Table$viewCellHelper$);
var $author$project$Ui$Table$viewRow$ = function (config, cols, rowState, row, rowIndex) {
	var attrs = function () {
		var _v1 = config.toRowAttrs;
		if (_v1.$ === 1) {
			return _List_Nil;
		} else {
			var toAttrs = _v1.a;
			return A2(toAttrs, rowState, row);
		}
	}();
	var _v0 = $elm$core$List$foldl$(
		A4($author$project$Ui$Table$viewCellHelper, config, rowState, rowIndex, row),
		_Utils_Tuple2(0, _List_Nil),
		cols);
	var cells = _v0.b;
	return $author$project$Internal$Model2$elementKeyed$(
		$author$project$Internal$Model2$NodeAsTableRow,
		0,
		A2(
			$elm$core$List$cons,
			$author$project$Internal$Model2$style$('display', 'contents'),
			attrs),
		$elm$core$List$reverse(cells));
};
var $author$project$Ui$Table$viewRow = F5($author$project$Ui$Table$viewRow$);
var $author$project$Ui$Table$viewRowWithKey$ = function (config, cols, state, index, row) {
	var rowState = function () {
		var _v0 = config.toRowState;
		if (_v0.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var toState = _v0.a;
			return A3(toState, state, index, row);
		}
	}();
	return _Utils_Tuple2(
		config.toKey(row),
		$author$project$Ui$Lazy$lazy5$($author$project$Ui$Table$viewRow, config, cols, rowState, row, index));
};
var $author$project$Ui$Table$viewRowWithKey = F5($author$project$Ui$Table$viewRowWithKey$);
var $author$project$Ui$Table$viewTableBody$ = function (config, cols, state, data) {
	var sorted = function () {
		var _v0 = config.sort;
		if (_v0.$ === 1) {
			return data;
		} else {
			var sortFn = _v0.a;
			return A2(sortFn, state, data);
		}
	}();
	return $author$project$Internal$Model2$elementKeyed$(
		$author$project$Internal$Model2$NodeAsTableBody,
		0,
		_List_fromArray(
			[
				$author$project$Internal$Model2$style$('display', 'contents')
			]),
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'active',
				$author$project$Ui$Lazy$lazy3$($author$project$Ui$Table$viewActiveRows, config, state, sorted)),
			$elm$core$List$indexedMap$(
				A3($author$project$Ui$Table$viewRowWithKey, config, cols, state),
				sorted)));
};
var $author$project$Ui$Table$viewTableBody = F4($author$project$Ui$Table$viewTableBody$);
var $author$project$Ui$Table$viewWithState$ = function (attrs, config, state, data) {
	var headerRow = $author$project$Ui$Lazy$lazy2$($author$project$Ui$Table$viewHeader, state, config);
	var cols = $author$project$Ui$Table$getColumns$(config, state);
	var rows = $author$project$Ui$Lazy$lazy4$($author$project$Ui$Table$viewTableBody, config, cols, state, data);
	return $author$project$Internal$Model2$element$(
		$author$project$Internal$Model2$NodeAsTable,
		1,
		A2(
			$elm$core$List$cons,
			$author$project$Internal$Model2$style$('display', 'grid'),
			A2(
				$elm$core$List$cons,
				$author$project$Internal$Model2$attrIf$(
					config.scrollable,
					$author$project$Internal$Model2$classWith$($author$project$Internal$Flag$overflow, $author$project$Internal$Style2$classes.scrollbars)),
				A2(
					$elm$core$List$cons,
					$author$project$Internal$Model2$style$(
						'grid-template-columns',
						$author$project$Ui$Table$gridTemplateColumns$(state, cols, '')),
					A2(
						$elm$core$List$cons,
						$author$project$Internal$Model2$style$('grid-auto-rows', 'minmax(min-content, max-content)'),
						A2(
							$elm$core$List$cons,
							$author$project$Ui$width($author$project$Ui$fill),
							attrs))))),
		_List_fromArray(
			[
				headerRow,
				rows,
				$elm$core$List$any$($author$project$Ui$Table$hasSummary, config.columns) ? $author$project$Ui$Lazy$lazy4$($author$project$Ui$Table$viewSummary, config, cols, state, data) : $author$project$Ui$none
			]));
};
var $author$project$Ui$Table$viewWithState = F4($author$project$Ui$Table$viewWithState$);
var $author$project$Ui$Table$view$ = function (attrs, config, data) {
	return $author$project$Ui$Table$viewWithState$(attrs, config, 0, data);
};
var $author$project$Ui$Table$view = F3($author$project$Ui$Table$view$);
var $author$project$Pages$Guild$guildMemberTable$ = function (localUser, guildId, guild) {
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8),
				$author$project$Ui$paddingXY$(16, 0)
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[$author$project$Ui$Font$bold]),
				$author$project$Ui$text($author$project$Pages$Guild$guildMembersText)),
				$author$project$Ui$Table$view$(
				_List_fromArray(
					[
						$author$project$Ui$Font$size(14)
					]),
				$author$project$Ui$Table$columns(
					_List_fromArray(
						[
							$author$project$Ui$Table$column(
							{
								header: $author$project$Ui$Table$header('Name'),
								view: function (_v0) {
									var userId = _v0.a;
									return $author$project$Ui$Table$cell$(
										$author$project$Pages$Guild$guildMemberCellPadding,
										$author$project$Ui$text(
											function () {
												var _v1 = $author$project$User$getUser$(userId, localUser);
												if (!_v1.$) {
													var user = _v1.a;
													return $author$project$PersonName$toString(user.name);
												} else {
													return $author$project$User$missingName;
												}
											}()));
								}
							}),
							$author$project$Ui$Table$column(
							{
								header: $author$project$Ui$Table$header('Joined'),
								view: function (_v2) {
									var member = _v2.b;
									return $author$project$Ui$Table$cell$(
										$author$project$Pages$Guild$guildMemberCellPadding,
										$author$project$Ui$text(
											$author$project$MyUi$datestamp$(localUser.timezone, member.joinedAt)));
								}
							}),
							$author$project$Ui$Table$column(
							{
								header: $author$project$Ui$Table$header('Last posted'),
								view: function (_v3) {
									var member = _v3.b;
									return $author$project$Ui$Table$cell$(
										$author$project$Pages$Guild$guildMemberCellPadding,
										$author$project$Ui$text(
											function () {
												var _v4 = member.lastPostedAt;
												if (!_v4.$) {
													var lastPostedAt = _v4.a;
													return $author$project$MyUi$datestamp$(localUser.timezone, lastPostedAt);
												} else {
													return $author$project$Pages$Guild$neverPostedText;
												}
											}()));
								}
							}),
							$author$project$Ui$Table$column(
							{
								header: $author$project$Ui$Table$header(''),
								view: function (_v5) {
									var userId = _v5.a;
									return $author$project$Ui$Table$cell$(
										$author$project$Pages$Guild$guildMemberCellPadding,
										$author$project$MyUi$elButton$(
											$lamdera$program_test$Effect$Browser$Dom$id(
												'guild_banMember_' + $author$project$Id$toString(userId)),
											$author$project$Types$PressedBanMember$(guildId, userId),
											_List_fromArray(
												[
													$author$project$Ui$paddingXY$(8, 2),
													$author$project$Ui$background($author$project$MyUi$deleteButtonBackground),
													$author$project$Ui$width($author$project$Ui$shrink),
													$author$project$Ui$rounded(4),
													$author$project$Ui$Font$color($author$project$MyUi$deleteButtonFont),
													$author$project$Ui$Font$weight(500),
													$author$project$Ui$borderColor($author$project$MyUi$deleteButtonBorder),
													$author$project$Ui$border(1)
												]),
											$author$project$Ui$text($author$project$Pages$Guild$banMemberText)));
								}
							})
						])),
				$lamdera$containers$SeqDict$toList(
					$author$project$MembersAndOwner$members(guild.membersAndOwner)))
			]));
};
var $author$project$Pages$Guild$guildMemberTable = F3($author$project$Pages$Guild$guildMemberTable$);
var $author$project$Types$PressedImportChannel = function (a) {
	return {$: 24, a: a};
};
var $author$project$Pages$Guild$importChannelFailedText = function (error) {
	return 'That file isn\u0027t a channel export';
};
var $author$project$Pages$Guild$importChannelText = 'Import channel';
var $author$project$Pages$Guild$importedChannelText = function (encryptedMessages) {
	return (!encryptedMessages) ? 'Imported!' : ((encryptedMessages === 1) ? 'Imported! 1 encrypted message was left out' : ('Imported! ' + ($elm$core$String$fromInt(encryptedMessages) + ' encrypted messages were left out')));
};
var $author$project$Pages$Guild$importChannelSection$ = function (guildId, form) {
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8),
				$author$project$Ui$paddingXY$(16, 0)
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[$author$project$Ui$Font$bold]),
				$author$project$Ui$text($author$project$Pages$Guild$importChannelText)),
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(8)
					]),
				_List_fromArray(
					[
						$author$project$Pages$Guild$submitButton$(
						$lamdera$program_test$Effect$Browser$Dom$id('guild_importChannel'),
						$author$project$Types$PressedImportChannel(guildId),
						$author$project$Pages$Guild$importChannelText),
						function () {
						var _v0 = form.importChannel;
						switch (_v0.$) {
							case 0:
								return $author$project$Ui$none;
							case 1:
								return $author$project$Ui$text('Importing...');
							case 2:
								var error = _v0.a;
								return $author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$Font$color($author$project$MyUi$errorColor)
										]),
									$author$project$Ui$text(
										$author$project$Pages$Guild$importChannelFailedText(error)));
							default:
								var encryptedMessages = _v0.a.encryptedMessages;
								return $author$project$Ui$text(
									$author$project$Pages$Guild$importedChannelText(encryptedMessages));
						}
					}()
					]))
			]));
};
var $author$project$Pages$Guild$importChannelSection = F2($author$project$Pages$Guild$importChannelSection$);
var $pablohirafuji$elm_qrcode$QRCode$Quartile = 2;
var $pablohirafuji$elm_qrcode$QRCode$QRCode = $elm$core$Basics$identity;
var $elm$core$Result$andThen$ = function (callback, result) {
	if (!result.$) {
		var value = result.a;
		return callback(value);
	} else {
		var msg = result.a;
		return $elm$core$Result$Err(msg);
	}
};
var $elm$core$Result$andThen = F2($elm$core$Result$andThen$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex$ = function (size, row, col) {
	return (size * row) + col;
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex = F3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$isOccupy$ = function (row, col, size, matrix) {
	var _v0 = $elm$core$Array$get$(
		$pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex$(size, row, col),
		matrix);
	if ((!_v0.$) && (!_v0.a.$)) {
		return true;
	} else {
		return false;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$isOccupy = F4($pablohirafuji$elm_qrcode$QRCode$Matrix$isOccupy$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$nextModule = function (placement) {
	var isUp = placement.isUp;
	var isRight = placement.isRight;
	var col = placement.col;
	var row = placement.row;
	return isRight ? _Utils_update(
		placement,
		{col: col - 1, isRight: false}) : (isUp ? _Utils_update(
		placement,
		{col: col + 1, isRight: true, row: row - 1}) : _Utils_update(
		placement,
		{col: col + 1, isRight: true, row: row + 1}));
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$bitToColor$ = function (_byte, offset) {
	return (1 & (_byte >> (7 - offset))) === 1;
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$bitToColor = F2($pablohirafuji$elm_qrcode$QRCode$Matrix$bitToColor$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setDataModule$ = function (_v0, _byte, offset) {
	var col = _v0.col;
	var row = _v0.row;
	var size = _v0.size;
	return A2(
		$elm$core$Array$set,
		$pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex$(size, row, col),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(
				false,
				$pablohirafuji$elm_qrcode$QRCode$Matrix$bitToColor$(_byte, offset))));
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setDataModule = F3($pablohirafuji$elm_qrcode$QRCode$Matrix$setDataModule$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$addDataModule$ = function (placement, bytes, offset, matrix) {
	addDataModule:
	while (true) {
		var col = placement.col;
		var row = placement.row;
		var size = placement.size;
		if (!bytes.b) {
			return matrix;
		} else {
			var head = bytes.a;
			var tail = bytes.b;
			if (offset >= 8) {
				var $temp$bytes = tail,
					$temp$offset = 0;
				bytes = $temp$bytes;
				offset = $temp$offset;
				continue addDataModule;
			} else {
				if (col === 6) {
					var $temp$placement = _Utils_update(
						placement,
						{col: col - 1, isRight: true});
					placement = $temp$placement;
					continue addDataModule;
				} else {
					if (row < 0) {
						var $temp$placement = _Utils_update(
							placement,
							{col: col - 2, isRight: true, isUp: false, row: 0});
						placement = $temp$placement;
						continue addDataModule;
					} else {
						if (_Utils_cmp(row, size) > -1) {
							var $temp$placement = _Utils_update(
								placement,
								{col: col - 2, isRight: true, isUp: true, row: size - 1});
							placement = $temp$placement;
							continue addDataModule;
						} else {
							if ($pablohirafuji$elm_qrcode$QRCode$Matrix$isOccupy$(row, col, size, matrix)) {
								var $temp$placement = $pablohirafuji$elm_qrcode$QRCode$Matrix$nextModule(placement);
								placement = $temp$placement;
								continue addDataModule;
							} else {
								var $temp$placement = $pablohirafuji$elm_qrcode$QRCode$Matrix$nextModule(placement),
									$temp$offset = offset + 1,
									$temp$matrix = A4($pablohirafuji$elm_qrcode$QRCode$Matrix$setDataModule, placement, head, offset, matrix);
								placement = $temp$placement;
								offset = $temp$offset;
								matrix = $temp$matrix;
								continue addDataModule;
							}
						}
					}
				}
			}
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$addDataModule = F4($pablohirafuji$elm_qrcode$QRCode$Matrix$addDataModule$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$initPlacement = function (size) {
	return {col: size + 1, isRight: true, isUp: true, row: size + 1, size: size};
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$addData$ = function (size, bytes, matrix) {
	return $pablohirafuji$elm_qrcode$QRCode$Matrix$addDataModule$(
		$pablohirafuji$elm_qrcode$QRCode$Matrix$initPlacement(size),
		bytes,
		0,
		matrix);
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$addData = F3($pablohirafuji$elm_qrcode$QRCode$Matrix$addData$);
var $pablohirafuji$elm_qrcode$QRCode$Error$AlignmentPatternNotFound = {$: 0};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPatternData = $elm$core$Array$fromList(
	_List_fromArray(
		[
			_List_Nil,
			_List_fromArray(
			[6, 18]),
			_List_fromArray(
			[6, 22]),
			_List_fromArray(
			[6, 26]),
			_List_fromArray(
			[6, 30]),
			_List_fromArray(
			[6, 34]),
			_List_fromArray(
			[6, 22, 38]),
			_List_fromArray(
			[6, 24, 42]),
			_List_fromArray(
			[6, 26, 46]),
			_List_fromArray(
			[6, 28, 50]),
			_List_fromArray(
			[6, 30, 54]),
			_List_fromArray(
			[6, 32, 58]),
			_List_fromArray(
			[6, 34, 62]),
			_List_fromArray(
			[6, 26, 46, 66]),
			_List_fromArray(
			[6, 26, 48, 70]),
			_List_fromArray(
			[6, 26, 50, 74]),
			_List_fromArray(
			[6, 30, 54, 78]),
			_List_fromArray(
			[6, 30, 56, 82]),
			_List_fromArray(
			[6, 30, 58, 86]),
			_List_fromArray(
			[6, 34, 62, 90]),
			_List_fromArray(
			[6, 28, 50, 72, 94]),
			_List_fromArray(
			[6, 26, 50, 74, 98]),
			_List_fromArray(
			[6, 30, 54, 78, 102]),
			_List_fromArray(
			[6, 28, 54, 80, 106]),
			_List_fromArray(
			[6, 32, 58, 84, 110]),
			_List_fromArray(
			[6, 30, 58, 86, 114]),
			_List_fromArray(
			[6, 34, 62, 90, 118]),
			_List_fromArray(
			[6, 26, 50, 74, 98, 122]),
			_List_fromArray(
			[6, 30, 54, 78, 102, 126]),
			_List_fromArray(
			[6, 26, 52, 78, 104, 130]),
			_List_fromArray(
			[6, 30, 56, 82, 108, 134]),
			_List_fromArray(
			[6, 34, 60, 86, 112, 138]),
			_List_fromArray(
			[6, 30, 58, 86, 114, 142]),
			_List_fromArray(
			[6, 34, 62, 90, 118, 146]),
			_List_fromArray(
			[6, 30, 54, 78, 102, 126, 150]),
			_List_fromArray(
			[6, 24, 50, 76, 102, 128, 154]),
			_List_fromArray(
			[6, 28, 54, 80, 106, 132, 158]),
			_List_fromArray(
			[6, 32, 58, 84, 110, 136, 162]),
			_List_fromArray(
			[6, 26, 54, 82, 110, 138, 166]),
			_List_fromArray(
			[6, 30, 58, 86, 114, 142, 170])
		]));
var $elm$core$Result$fromMaybe$ = function (err, maybe) {
	if (!maybe.$) {
		var v = maybe.a;
		return $elm$core$Result$Ok(v);
	} else {
		return $elm$core$Result$Err(err);
	}
};
var $elm$core$Result$fromMaybe = F2($elm$core$Result$fromMaybe$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord$ = function (rows, cols) {
	return $elm$core$List$foldl$(
		F2(
			function (row, list) {
				return $elm$core$List$foldl$(
					F2(
						function (col, list_) {
							return A2(
								$elm$core$List$cons,
								_Utils_Tuple2(row, col),
								list_);
						}),
					list,
					cols);
			}),
		_List_Nil,
		rows);
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord = F2($pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$isValidAlign$ = function (size, _v0) {
	var row = _v0.a;
	var col = _v0.b;
	return ((row > 10) || ((10 < col) && (_Utils_cmp(col, size - 10) < 0))) && ((_Utils_cmp(row, size - 10) < 0) || (col > 10));
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$isValidAlign = F2($pablohirafuji$elm_qrcode$QRCode$Matrix$isValidAlign$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentRange = $elm$core$List$range$(-2, 2);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentColor$ = function (row, col) {
	return (_Utils_eq(row, -2) || ((row === 2) || (_Utils_eq(col, -2) || ((col === 2) || ((!row) && (!col)))))) ? $elm$core$Maybe$Just(
		_Utils_Tuple2(true, true)) : $elm$core$Maybe$Just(
		_Utils_Tuple2(true, false));
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentColor = F2($pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentColor$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignModule$ = function (size, rowPos, colPos, _v0) {
	var row = _v0.a;
	var col = _v0.b;
	return A2(
		$elm$core$Array$set,
		$pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex$(size, row + rowPos, col + colPos),
		$pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentColor$(row, col));
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignModule = F4($pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignModule$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignment$ = function (size, _v0, matrix) {
	var row = _v0.a;
	var col = _v0.b;
	return $elm$core$List$foldl$(
		A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignModule, size, row, col),
		matrix,
		$pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord$($pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentRange, $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentRange));
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignment = F3($pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignment$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignments$ = function (size, locations, matrix) {
	return $elm$core$List$foldl$(
		$pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignment(size),
		matrix,
		$elm$core$List$filter$(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$isValidAlign(size),
			$pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord$(locations, locations)));
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignments = F3($pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignments$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPattern$ = function (version, size, matrix) {
	return $elm$core$Result$map$(
		function (a) {
			return $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignments$(size, a, matrix);
		},
		$elm$core$Result$fromMaybe$(
			$pablohirafuji$elm_qrcode$QRCode$Error$AlignmentPatternNotFound,
			$elm$core$Array$get$(version - 1, $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPatternData)));
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPattern = F3($pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPattern$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$darkModule$ = function (version, size) {
	return A2(
		$elm$core$Array$set,
		$pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex$(size, (4 * version) + 9, 8),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(true, true)));
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$darkModule = F2($pablohirafuji$elm_qrcode$QRCode$Matrix$darkModule$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$finderRange = $elm$core$List$range$(0, 8);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$finderColor$ = function (row, col) {
	return ((1 <= row) && ((row <= 7) && ((col === 1) || (col === 7)))) || (((1 <= col) && ((col <= 7) && ((row === 1) || (row === 7)))) || ((3 <= row) && ((row <= 5) && ((3 <= col) && (col <= 5)))));
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$finderColor = F2($pablohirafuji$elm_qrcode$QRCode$Matrix$finderColor$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFinder$ = function (size, rowOffset, colOffset, _v0, matrix) {
	var row = _v0.a;
	var col = _v0.b;
	var finalRow = row + rowOffset;
	var finalCol = col + colOffset;
	return ((finalRow < 0) || ((finalCol < 0) || ((_Utils_cmp(finalRow, size) > -1) || (_Utils_cmp(finalCol, size) > -1)))) ? matrix : $elm$core$Array$set$(
		$pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex$(size, finalRow, finalCol),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(
				true,
				$pablohirafuji$elm_qrcode$QRCode$Matrix$finderColor$(row, col))),
		matrix);
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFinder = F5($pablohirafuji$elm_qrcode$QRCode$Matrix$setFinder$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern$ = function (size, rowOffset, colOffset, matrix) {
	return $elm$core$List$foldl$(
		A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setFinder, size, rowOffset, colOffset),
		matrix,
		$pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord$($pablohirafuji$elm_qrcode$QRCode$Matrix$finderRange, $pablohirafuji$elm_qrcode$QRCode$Matrix$finderRange));
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern = F4($pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskColor$ = function (maybeModule, isChange) {
	if (isChange) {
		if ((!maybeModule.$) && (!maybeModule.a.a)) {
			var _v1 = maybeModule.a;
			var isDark = _v1.b;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(false, !isDark));
		} else {
			return maybeModule;
		}
	} else {
		return maybeModule;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskColor = F2($pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskColor$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getCoord$ = function (size, index) {
	return _Utils_Tuple2(
		(index / size) | 0,
		A2($elm$core$Basics$modBy, size, index));
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getCoord = F2($pablohirafuji$elm_qrcode$QRCode$Matrix$getCoord$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskFunction$ = function (_function, size, index, maybeModule) {
	return $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskColor$(
		maybeModule,
		_function(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$getCoord$(size, index)));
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskFunction = F4($pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskFunction$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$maskFunction = function (mask) {
	switch (mask) {
		case 0:
			return function (_v1) {
				var row = _v1.a;
				var col = _v1.b;
				return !A2($elm$core$Basics$modBy, 2, row + col);
			};
		case 1:
			return function (_v2) {
				var row = _v2.a;
				return !A2($elm$core$Basics$modBy, 2, row);
			};
		case 2:
			return function (_v3) {
				var col = _v3.b;
				return !A2($elm$core$Basics$modBy, 3, col);
			};
		case 3:
			return function (_v4) {
				var row = _v4.a;
				var col = _v4.b;
				return !A2($elm$core$Basics$modBy, 3, row + col);
			};
		case 4:
			return function (_v5) {
				var row = _v5.a;
				var col = _v5.b;
				return !A2(
					$elm$core$Basics$modBy,
					2,
					$elm$core$Basics$floor(row / 2) + $elm$core$Basics$floor(col / 3));
			};
		case 5:
			return function (_v6) {
				var row = _v6.a;
				var col = _v6.b;
				return !(A2($elm$core$Basics$modBy, 2, row * col) + A2($elm$core$Basics$modBy, 3, row * col));
			};
		case 6:
			return function (_v7) {
				var row = _v7.a;
				var col = _v7.b;
				return !A2(
					$elm$core$Basics$modBy,
					2,
					A2($elm$core$Basics$modBy, 2, row * col) + A2($elm$core$Basics$modBy, 3, row * col));
			};
		default:
			return function (_v8) {
				var row = _v8.a;
				var col = _v8.b;
				return !A2(
					$elm$core$Basics$modBy,
					2,
					A2($elm$core$Basics$modBy, 3, row * col) + A2($elm$core$Basics$modBy, 2, row + col));
			};
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMask$ = function (size, mask, matrix) {
	return $elm$core$Array$indexedMap$(
		A2(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskFunction,
			$pablohirafuji$elm_qrcode$QRCode$Matrix$maskFunction(mask),
			size),
		matrix);
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMask = F3($pablohirafuji$elm_qrcode$QRCode$Matrix$applyMask$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$breakList$ = function (width, list, acc) {
	breakList:
	while (true) {
		if (!list.b) {
			return $elm$core$List$reverse(acc);
		} else {
			var $temp$list = $elm$core$List$drop$(width, list),
				$temp$acc = A2(
				$elm$core$List$cons,
				$elm$core$List$take$(width, list),
				acc);
			list = $temp$list;
			acc = $temp$acc;
			continue breakList;
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$breakList = F3($pablohirafuji$elm_qrcode$QRCode$Matrix$breakList$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$isDarkModule = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map($elm$core$Tuple$second),
	$elm$core$Maybe$withDefault(false));
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score_$ = function (simplifiedList, _v0) {
	rule1Score_:
	while (true) {
		var last = _v0.a;
		var partialScore = _v0.b;
		var score = _v0.c;
		if (!simplifiedList.b) {
			return (partialScore >= 5) ? ((score + partialScore) - 2) : score;
		} else {
			var head = simplifiedList.a;
			var tail = simplifiedList.b;
			if (_Utils_eq(last, head)) {
				var $temp$simplifiedList = tail,
					$temp$_v0 = _Utils_Tuple3(last, partialScore + 1, score);
				simplifiedList = $temp$simplifiedList;
				_v0 = $temp$_v0;
				continue rule1Score_;
			} else {
				if (partialScore >= 5) {
					var $temp$simplifiedList = tail,
						$temp$_v0 = _Utils_Tuple3(head, 0, (score + partialScore) - 2);
					simplifiedList = $temp$simplifiedList;
					_v0 = $temp$_v0;
					continue rule1Score_;
				} else {
					var $temp$simplifiedList = tail,
						$temp$_v0 = _Utils_Tuple3(head, 0, score);
					simplifiedList = $temp$simplifiedList;
					_v0 = $temp$_v0;
					continue rule1Score_;
				}
			}
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score_ = F2($pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score_$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map(
		function (a) {
			return $pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score_$(
				a,
				_Utils_Tuple3(false, 0, 0));
		}),
	$elm$core$List$sum);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score_$ = function (row1, row2, maybeLast, score) {
	rule2Score_:
	while (true) {
		if (!row1.b) {
			return score;
		} else {
			var head = row1.a;
			var tail = row1.b;
			if (!row2.b) {
				return score;
			} else {
				var head2 = row2.a;
				var tail2 = row2.b;
				if (_Utils_eq(head, head2)) {
					if (_Utils_eq(
						$elm$core$Maybe$Just(head),
						maybeLast)) {
						var $temp$row1 = tail,
							$temp$row2 = tail2,
							$temp$maybeLast = $elm$core$Maybe$Just(head),
							$temp$score = score + 3;
						row1 = $temp$row1;
						row2 = $temp$row2;
						maybeLast = $temp$maybeLast;
						score = $temp$score;
						continue rule2Score_;
					} else {
						var $temp$row1 = tail,
							$temp$row2 = tail2,
							$temp$maybeLast = $elm$core$Maybe$Just(head);
						row1 = $temp$row1;
						row2 = $temp$row2;
						maybeLast = $temp$maybeLast;
						continue rule2Score_;
					}
				} else {
					var $temp$row1 = tail,
						$temp$row2 = tail2,
						$temp$maybeLast = $elm$core$Maybe$Nothing;
					row1 = $temp$row1;
					row2 = $temp$row2;
					maybeLast = $temp$maybeLast;
					continue rule2Score_;
				}
			}
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score_ = F4($pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score_$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score$ = function (list, score) {
	rule2Score:
	while (true) {
		if (list.b && list.b.b) {
			var head1 = list.a;
			var _v1 = list.b;
			var head2 = _v1.a;
			var tail = _v1.b;
			var $temp$list = tail,
				$temp$score = score + $pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score_$(head1, head2, $elm$core$Maybe$Nothing, 0);
			list = $temp$list;
			score = $temp$score;
			continue rule2Score;
		} else {
			return score;
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score = F2($pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score_$ = function (simplifiedList, score) {
	rule3Score_:
	while (true) {
		_v0$3:
		while (true) {
			if (!simplifiedList.b) {
				return score;
			} else {
				if (!simplifiedList.a) {
					if (((((((((((((((((((simplifiedList.b.b && (!simplifiedList.b.a)) && simplifiedList.b.b.b) && (!simplifiedList.b.b.a)) && simplifiedList.b.b.b.b) && (!simplifiedList.b.b.b.a)) && simplifiedList.b.b.b.b.b) && simplifiedList.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.b.b.b.b.a) {
						var _v1 = simplifiedList.b;
						var _v2 = _v1.b;
						var _v3 = _v2.b;
						var _v4 = _v3.b;
						var _v5 = _v4.b;
						var _v6 = _v5.b;
						var _v7 = _v6.b;
						var _v8 = _v7.b;
						var _v9 = _v8.b;
						var _v10 = _v9.b;
						var tail = _v10.b;
						var $temp$simplifiedList = tail,
							$temp$score = score + 40;
						simplifiedList = $temp$simplifiedList;
						score = $temp$score;
						continue rule3Score_;
					} else {
						break _v0$3;
					}
				} else {
					if (((((((((((((((((((simplifiedList.b.b && (!simplifiedList.b.a)) && simplifiedList.b.b.b) && simplifiedList.b.b.a) && simplifiedList.b.b.b.b) && simplifiedList.b.b.b.a) && simplifiedList.b.b.b.b.b) && simplifiedList.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.b.b.a)) {
						var _v11 = simplifiedList.b;
						var _v12 = _v11.b;
						var _v13 = _v12.b;
						var _v14 = _v13.b;
						var _v15 = _v14.b;
						var _v16 = _v15.b;
						var _v17 = _v16.b;
						var _v18 = _v17.b;
						var _v19 = _v18.b;
						var _v20 = _v19.b;
						var tail = _v20.b;
						var $temp$simplifiedList = tail,
							$temp$score = score + 40;
						simplifiedList = $temp$simplifiedList;
						score = $temp$score;
						continue rule3Score_;
					} else {
						break _v0$3;
					}
				}
			}
		}
		var head = simplifiedList.a;
		var tail = simplifiedList.b;
		var $temp$simplifiedList = tail;
		simplifiedList = $temp$simplifiedList;
		continue rule3Score_;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score_ = F2($pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score_$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score = A2($elm$core$List$foldl, $pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score_, 0);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule4Score$ = function (size, simplifiedList) {
	var moduleCount = size * size;
	var darkCount = $elm$core$List$length(
		$elm$core$List$filter$($elm$core$Basics$identity, simplifiedList));
	var darkPerc = $elm$core$Basics$round((100 * darkCount) / moduleCount);
	var remOf5 = darkPerc % 5;
	var nextMult5 = $elm$core$Basics$round(
		$elm$core$Basics$abs((darkPerc + (5 - remOf5)) - 50) / 5);
	var prevMult5 = $elm$core$Basics$round(
		$elm$core$Basics$abs((darkPerc - remOf5) - 50) / 5);
	return $elm$core$Basics$min$(prevMult5, nextMult5) * 10;
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule4Score = F2($pablohirafuji$elm_qrcode$QRCode$Matrix$rule4Score$);
var $pablohirafuji$elm_qrcode$QRCode$Helpers$transpose = function (ll) {
	transpose:
	while (true) {
		if (!ll.b) {
			return _List_Nil;
		} else {
			if (!ll.a.b) {
				var xss = ll.b;
				var $temp$ll = xss;
				ll = $temp$ll;
				continue transpose;
			} else {
				var _v1 = ll.a;
				var x = _v1.a;
				var xs = _v1.b;
				var xss = ll.b;
				var tails = $elm$core$List$filterMap$($elm$core$List$tail, xss);
				var heads = $elm$core$List$filterMap$($elm$core$List$head, xss);
				return A2(
					$elm$core$List$cons,
					A2($elm$core$List$cons, x, heads),
					$pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(
						A2($elm$core$List$cons, xs, tails)));
			}
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getMaskScore$ = function (size, matrix) {
	var list = $elm$core$List$map$(
		$pablohirafuji$elm_qrcode$QRCode$Matrix$isDarkModule,
		$elm$core$Array$toList(matrix));
	var rowList = $pablohirafuji$elm_qrcode$QRCode$Matrix$breakList$(size, list, _List_Nil);
	var transposedRowList = $pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(rowList);
	return function (b) {
		return _Utils_Tuple2(rowList, b);
	}(
		$pablohirafuji$elm_qrcode$QRCode$Matrix$rule4Score$(size, list) + ($pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score(transposedRowList) + ($pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score(rowList) + ($pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score$(rowList, 0) + ($pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score(transposedRowList) + $pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score(rowList))))));
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getMaskScore = F2($pablohirafuji$elm_qrcode$QRCode$Matrix$getMaskScore$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$ecLevelToInt = function (ecLevel) {
	switch (ecLevel) {
		case 0:
			return 1;
		case 1:
			return 0;
		case 2:
			return 3;
		default:
			return 2;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit = function (_int) {
	var helper = F2(
		function (digit, int_) {
			helper:
			while (true) {
				if (!(!int_)) {
					var $temp$digit = digit + 1,
						$temp$int_ = int_ >>> 1;
					digit = $temp$digit;
					int_ = $temp$int_;
					continue helper;
				} else {
					return digit;
				}
			}
		});
	return A2(helper, 0, _int);
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$maskToInt = function (mask) {
	switch (mask) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		case 6:
			return 6;
		default:
			return 7;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$encodeFormatInfo$ = function (ecLevel, mask) {
	var g15Mask = 21522;
	var g15Int = 1335;
	var g15Digit = $pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(g15Int);
	var formatInfoInt = $pablohirafuji$elm_qrcode$QRCode$Matrix$maskToInt(mask) | ($pablohirafuji$elm_qrcode$QRCode$Matrix$ecLevelToInt(ecLevel) << 3);
	var helper = function (d_) {
		helper:
		while (true) {
			if (($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g15Digit) >= 0) {
				var $temp$d_ = d_ ^ (g15Int << ($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g15Digit));
				d_ = $temp$d_;
				continue helper;
			} else {
				return g15Mask ^ (d_ | (formatInfoInt << 10));
			}
		}
	};
	var d = formatInfoInt << 10;
	return helper(d);
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$encodeFormatInfo = F2($pablohirafuji$elm_qrcode$QRCode$Matrix$encodeFormatInfo$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoHorizontal$ = function (size, count) {
	return (count < 8) ? _Utils_Tuple2(8, (size - count) - 1) : ((count < 9) ? _Utils_Tuple2(8, 15 - count) : _Utils_Tuple2(8, (15 - count) - 1));
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoHorizontal = F2($pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoHorizontal$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoVertical$ = function (size, count) {
	return (count < 6) ? _Utils_Tuple2(count, 8) : ((count < 8) ? _Utils_Tuple2(count + 1, 8) : _Utils_Tuple2((size - 15) + count, 8));
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoVertical = F2($pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoVertical$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatModule$ = function (size, isBlack, row, col) {
	return A2(
		$elm$core$Array$set,
		$pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex$(size, row, col),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(true, isBlack)));
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatModule = F4($pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatModule$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_$ = function (size, isBlackFn, count, matrix) {
	setFormatInfo_:
	while (true) {
		if (count < 15) {
			var isBlack = isBlackFn(count);
			var _v0 = $pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoVertical$(size, count);
			var x2 = _v0.a;
			var y2 = _v0.b;
			var _v1 = $pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoHorizontal$(size, count);
			var x1 = _v1.a;
			var y1 = _v1.b;
			var $temp$count = count + 1,
				$temp$matrix = A5(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatModule,
				size,
				isBlack,
				x2,
				y2,
				A5($pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatModule, size, isBlack, x1, y1, matrix));
			count = $temp$count;
			matrix = $temp$matrix;
			continue setFormatInfo_;
		} else {
			return matrix;
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_ = F4($pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo$ = function (ecLevel, size, mask, matrix) {
	var isBlack = F2(
		function (bits_, count) {
			return (1 & (bits_ >> count)) === 1;
		});
	var bits = $pablohirafuji$elm_qrcode$QRCode$Matrix$encodeFormatInfo$(ecLevel, mask);
	return $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_$(
		size,
		isBlack(bits),
		0,
		matrix);
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo = F4($pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask_$ = function (ecLevel, size, matrix, mask, _v0) {
	var minSMatrix = _v0.a;
	var minScore = _v0.b;
	var maskedMatrix = $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo$(
		ecLevel,
		size,
		mask,
		$pablohirafuji$elm_qrcode$QRCode$Matrix$applyMask$(size, mask, matrix));
	var _v1 = $pablohirafuji$elm_qrcode$QRCode$Matrix$getMaskScore$(size, maskedMatrix);
	var maskSMatrix = _v1.a;
	var maskScore = _v1.b;
	return ((_Utils_cmp(minScore, maskScore) < 0) && (!_Utils_eq(minScore, -1))) ? _Utils_Tuple2(minSMatrix, minScore) : _Utils_Tuple2(maskSMatrix, maskScore);
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask_ = F5($pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask_$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern0 = 0;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern1 = 1;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern2 = 2;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern3 = 3;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern4 = 4;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern5 = 5;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern6 = 6;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern7 = 7;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$patternList = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7]);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask$ = function (ecLevel, size, matrix) {
	return $elm$core$List$foldl$(
		A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask_, ecLevel, size, matrix),
		_Utils_Tuple2(_List_Nil, -1),
		$pablohirafuji$elm_qrcode$QRCode$Matrix$patternList).a;
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask = F3($pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$reserveFormatInfo$ = function (size, matrix) {
	return $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_$(
		size,
		$elm$core$Basics$always(true),
		0,
		matrix);
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$reserveFormatInfo = F2($pablohirafuji$elm_qrcode$QRCode$Matrix$reserveFormatInfo$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$encodeVersionInfo = function (version) {
	var g18Int = 7973;
	var g18Digit = $pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(g18Int);
	var helper = function (d_) {
		helper:
		while (true) {
			if (($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g18Digit) >= 0) {
				var $temp$d_ = d_ ^ (g18Int << ($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g18Digit));
				d_ = $temp$d_;
				continue helper;
			} else {
				return d_ | (version << 12);
			}
		}
	};
	var d = version << 12;
	return helper(d);
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionModule$ = function (size, isBlack, _v0) {
	var row = _v0.a;
	var col = _v0.b;
	return A2(
		$elm$core$Array$set,
		$pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex$(size, row, col),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(true, isBlack)));
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionModule = F3($pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionModule$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo_$ = function (size, isBlackFn, count, matrix) {
	setVersionInfo_:
	while (true) {
		if (count < 18) {
			var topRight = _Utils_Tuple2(
				$elm$core$Basics$floor(count / 3),
				((A2($elm$core$Basics$modBy, 3, count) + size) - 8) - 3);
			var isBlack = isBlackFn(count);
			var bottomLeft = _Utils_Tuple2(
				((A2($elm$core$Basics$modBy, 3, count) + size) - 8) - 3,
				$elm$core$Basics$floor(count / 3));
			var $temp$count = count + 1,
				$temp$matrix = A4(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionModule,
				size,
				isBlack,
				bottomLeft,
				A4($pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionModule, size, isBlack, topRight, matrix));
			count = $temp$count;
			matrix = $temp$matrix;
			continue setVersionInfo_;
		} else {
			return matrix;
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo_ = F4($pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo_$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo$ = function (version, size, matrix) {
	if (version >= 7) {
		var isBlack = F2(
			function (bits_, count) {
				return (1 & (bits_ >> count)) === 1;
			});
		var bits = $pablohirafuji$elm_qrcode$QRCode$Matrix$encodeVersionInfo(version);
		return $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo_$(
			size,
			isBlack(bits),
			0,
			matrix);
	} else {
		return matrix;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo = F3($pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$timingColor$ = function (row, col) {
	return (!A2($elm$core$Basics$modBy, 2, row + col)) ? $elm$core$Maybe$Just(
		_Utils_Tuple2(true, true)) : $elm$core$Maybe$Just(
		_Utils_Tuple2(true, false));
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$timingColor = F2($pablohirafuji$elm_qrcode$QRCode$Matrix$timingColor$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setTiming$ = function (size, row, col) {
	return A2(
		$elm$core$Array$set,
		$pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex$(size, row, col),
		$pablohirafuji$elm_qrcode$QRCode$Matrix$timingColor$(row, col));
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setTiming = F3($pablohirafuji$elm_qrcode$QRCode$Matrix$setTiming$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$timingPattern$ = function (size, matrix) {
	var range = $elm$core$List$range$(8, size - 9);
	return $elm$core$List$foldl$(
		function (b) {
			return $pablohirafuji$elm_qrcode$QRCode$Matrix$setTiming$(size, b, 6);
		},
		$elm$core$List$foldl$(
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$setTiming, size, 6),
			matrix,
			range),
		range);
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$timingPattern = F2($pablohirafuji$elm_qrcode$QRCode$Matrix$timingPattern$);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$apply = function (_v0) {
	var groupInfo = _v0.a.groupInfo;
	var ecLevel = _v0.a.ecLevel;
	var bytes = _v0.b;
	var version = groupInfo.version;
	var size = ((version - 1) * 4) + 21;
	return $elm$core$Result$map$(
		A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask, ecLevel, size),
		$elm$core$Result$map$(
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$addData, size, bytes),
			$pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPattern$(
				version,
				size,
				$pablohirafuji$elm_qrcode$QRCode$Matrix$timingPattern$(
					size,
					A3(
						$pablohirafuji$elm_qrcode$QRCode$Matrix$darkModule,
						version,
						size,
						$pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo$(
							version,
							size,
							$pablohirafuji$elm_qrcode$QRCode$Matrix$reserveFormatInfo$(
								size,
								$pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern$(
									size,
									-1,
									size - 8,
									$pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern$(
										size,
										size - 8,
										-1,
										$pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern$(
											size,
											-1,
											-1,
											$elm$core$Array$initialize$(
												size * size,
												$elm$core$Basics$always($elm$core$Maybe$Nothing))))))))))));
};
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$H = 3;
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$L = 0;
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$M = 1;
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$Q = 2;
var $pablohirafuji$elm_qrcode$QRCode$convertEC = function (ec) {
	switch (ec) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$AlignmentPatternNotFound = {$: 0};
var $pablohirafuji$elm_qrcode$QRCode$InputLengthOverflow = {$: 7};
var $pablohirafuji$elm_qrcode$QRCode$InvalidAlphanumericChar = {$: 2};
var $pablohirafuji$elm_qrcode$QRCode$InvalidNumericChar = {$: 1};
var $pablohirafuji$elm_qrcode$QRCode$InvalidUTF8Char = {$: 3};
var $pablohirafuji$elm_qrcode$QRCode$LogTableException = function (a) {
	return {$: 4, a: a};
};
var $pablohirafuji$elm_qrcode$QRCode$PolynomialModException = {$: 6};
var $pablohirafuji$elm_qrcode$QRCode$PolynomialMultiplyException = {$: 5};
var $pablohirafuji$elm_qrcode$QRCode$convertError = function (e) {
	switch (e.$) {
		case 0:
			return $pablohirafuji$elm_qrcode$QRCode$AlignmentPatternNotFound;
		case 1:
			return $pablohirafuji$elm_qrcode$QRCode$InvalidNumericChar;
		case 2:
			return $pablohirafuji$elm_qrcode$QRCode$InvalidAlphanumericChar;
		case 3:
			return $pablohirafuji$elm_qrcode$QRCode$InvalidUTF8Char;
		case 4:
			var n = e.a;
			return $pablohirafuji$elm_qrcode$QRCode$LogTableException(n);
		case 5:
			return $pablohirafuji$elm_qrcode$QRCode$PolynomialMultiplyException;
		case 6:
			return $pablohirafuji$elm_qrcode$QRCode$PolynomialModException;
		default:
			return $pablohirafuji$elm_qrcode$QRCode$InputLengthOverflow;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$firstFillerByte = 236;
var $pablohirafuji$elm_qrcode$QRCode$Encode$secondFillerByte = 17;
var $pablohirafuji$elm_qrcode$QRCode$Encode$addFiller$ = function (capacity, bytes) {
	var fillerLength = ((capacity / 8) | 0) - $elm$core$List$length(bytes);
	var ns = $elm$core$List$concat(
		$elm$core$List$repeat$(
			(fillerLength / 2) | 0,
			_List_fromArray(
				[$pablohirafuji$elm_qrcode$QRCode$Encode$firstFillerByte, $pablohirafuji$elm_qrcode$QRCode$Encode$secondFillerByte])));
	return (!A2($elm$core$Basics$modBy, 2, fillerLength)) ? _Utils_ap(bytes, ns) : _Utils_ap(
		bytes,
		_Utils_ap(
			ns,
			_List_fromArray(
				[$pablohirafuji$elm_qrcode$QRCode$Encode$firstFillerByte])));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$addFiller = F2($pablohirafuji$elm_qrcode$QRCode$Encode$addFiller$);
var $pablohirafuji$elm_qrcode$QRCode$Encode$addTerminator$ = function (capacity, bitsCount, bits) {
	return _Utils_ap(
		bits,
		_List_fromArray(
			[
				_Utils_Tuple2(
				0,
				$elm$core$Basics$min$(4, capacity - bitsCount))
			]));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$addTerminator = F3($pablohirafuji$elm_qrcode$QRCode$Encode$addTerminator$);
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes3 = function (_v0) {
	bitsToBytes3:
	while (true) {
		var _v1 = _v0.a;
		var bits = _v1.a;
		var length = _v1.b;
		var bytes = _v0.b;
		if (length >= 8) {
			var remLength = length - 8;
			var remBits = bits & ((1 << remLength) - 1);
			var _byte = bits >> remLength;
			var $temp$_v0 = _Utils_Tuple2(
				_Utils_Tuple2(remBits, remLength),
				A2($elm$core$List$cons, _byte, bytes));
			_v0 = $temp$_v0;
			continue bitsToBytes3;
		} else {
			return _Utils_Tuple2(
				_Utils_Tuple2(bits, length),
				bytes);
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes2$ = function (_v0, _v1) {
	var curBits = _v0.a;
	var curLength = _v0.b;
	var _v2 = _v1.a;
	var remBits = _v2.a;
	var remLength = _v2.b;
	var bytes = _v1.b;
	var lengthSum = curLength + remLength;
	var bitsSum = curBits | (remBits << curLength);
	return $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes3(
		_Utils_Tuple2(
			_Utils_Tuple2(bitsSum, lengthSum),
			bytes));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes2 = F2($pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes2$);
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes1$ = function (bits, _v0) {
	bitsToBytes1:
	while (true) {
		var _v1 = _v0.a;
		var remBits = _v1.a;
		var remLength = _v1.b;
		var bytes = _v0.b;
		if (bits.b) {
			var head = bits.a;
			var tail = bits.b;
			var $temp$bits = tail,
				$temp$_v0 = $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes2$(
				head,
				_Utils_Tuple2(
					_Utils_Tuple2(remBits, remLength),
					bytes));
			bits = $temp$bits;
			_v0 = $temp$_v0;
			continue bitsToBytes1;
		} else {
			return (!remLength) ? $elm$core$List$reverse(bytes) : $elm$core$List$reverse(
				A2($elm$core$List$cons, remBits << (8 - remLength), bytes));
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes1 = F2($pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes1$);
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes = function (bits) {
	return $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes1$(
		bits,
		_Utils_Tuple2(
			_Utils_Tuple2(0, 0),
			_List_Nil));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8 = 3;
var $pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength$ = function (mode, version) {
	if (version <= 9) {
		switch (mode) {
			case 0:
				return 10;
			case 1:
				return 9;
			case 2:
				return 8;
			default:
				return 8;
		}
	} else {
		if (version <= 26) {
			switch (mode) {
				case 0:
					return 12;
				case 1:
					return 11;
				case 2:
					return 16;
				default:
					return 16;
			}
		} else {
			switch (mode) {
				case 0:
					return 14;
				case 1:
					return 13;
				case 2:
					return 16;
				default:
					return 16;
			}
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength = F2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength$);
var $pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicator$ = function (_v0, bits) {
	var mode = _v0.mode;
	var inputStr = _v0.inputStr;
	var groupInfo = _v0.groupInfo;
	var length = $pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength$(mode, groupInfo.version);
	var charCount = (mode === 3) ? $elm$core$List$length(bits) : $elm$core$String$length(inputStr);
	return _Utils_Tuple2(charCount, length);
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicator = F2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicator$);
var $pablohirafuji$elm_qrcode$QRCode$Encode$modeIndicator = function (mode) {
	switch (mode) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 4;
		default:
			return 4;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$addInfoAndFinalBits = function (_v0) {
	var bits = _v0.a;
	var model = _v0.b;
	return _Utils_Tuple2(
		model,
		$pablohirafuji$elm_qrcode$QRCode$Encode$addFiller$(
			model.groupInfo.capacity,
			$pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes(
				$pablohirafuji$elm_qrcode$QRCode$Encode$addTerminator$(
					model.groupInfo.capacity,
					model.bitsCount,
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							$pablohirafuji$elm_qrcode$QRCode$Encode$modeIndicator(model.mode),
							4),
						A2(
							$elm$core$List$cons,
							$pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicator$(model, bits),
							bits))))));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$concatTranspose = function (_v0) {
	var model = _v0.a;
	var dataBlocks = _v0.b;
	var ecBlocks = _v0.c;
	return _Utils_Tuple2(
		model,
		$elm$core$List$concat(
			_Utils_ap(
				$pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(dataBlocks),
				$pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(ecBlocks))));
};
var $elm_community$list_extra$List$Extra$greedyGroupsOfWithStep$ = function (size, step, list) {
	if ((size <= 0) || (step <= 0)) {
		return _List_Nil;
	} else {
		var go = F2(
			function (xs, acc) {
				go:
				while (true) {
					if ($elm$core$List$isEmpty(xs)) {
						return $elm$core$List$reverse(acc);
					} else {
						var $temp$xs = $elm$core$List$drop$(step, xs),
							$temp$acc = A2(
							$elm$core$List$cons,
							$elm$core$List$take$(size, xs),
							acc);
						xs = $temp$xs;
						acc = $temp$acc;
						continue go;
					}
				}
			});
		return A2(go, list, _List_Nil);
	}
};
var $elm_community$list_extra$List$Extra$greedyGroupsOfWithStep = F3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep$);
var $elm_community$list_extra$List$Extra$greedyGroupsOf$ = function (size, xs) {
	return $elm_community$list_extra$List$Extra$greedyGroupsOfWithStep$(size, size, xs);
};
var $elm_community$list_extra$List$Extra$greedyGroupsOf = F2($elm_community$list_extra$List$Extra$greedyGroupsOf$);
var $pablohirafuji$elm_qrcode$QRCode$Error$InvalidAlphanumericChar = {$: 2};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$alphanumericCodes = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('0', 0),
			_Utils_Tuple2('1', 1),
			_Utils_Tuple2('2', 2),
			_Utils_Tuple2('3', 3),
			_Utils_Tuple2('4', 4),
			_Utils_Tuple2('5', 5),
			_Utils_Tuple2('6', 6),
			_Utils_Tuple2('7', 7),
			_Utils_Tuple2('8', 8),
			_Utils_Tuple2('9', 9),
			_Utils_Tuple2('A', 10),
			_Utils_Tuple2('B', 11),
			_Utils_Tuple2('C', 12),
			_Utils_Tuple2('D', 13),
			_Utils_Tuple2('E', 14),
			_Utils_Tuple2('F', 15),
			_Utils_Tuple2('G', 16),
			_Utils_Tuple2('H', 17),
			_Utils_Tuple2('I', 18),
			_Utils_Tuple2('J', 19),
			_Utils_Tuple2('K', 20),
			_Utils_Tuple2('L', 21),
			_Utils_Tuple2('M', 22),
			_Utils_Tuple2('N', 23),
			_Utils_Tuple2('O', 24),
			_Utils_Tuple2('P', 25),
			_Utils_Tuple2('Q', 26),
			_Utils_Tuple2('R', 27),
			_Utils_Tuple2('S', 28),
			_Utils_Tuple2('T', 29),
			_Utils_Tuple2('U', 30),
			_Utils_Tuple2('V', 31),
			_Utils_Tuple2('W', 32),
			_Utils_Tuple2('X', 33),
			_Utils_Tuple2('Y', 34),
			_Utils_Tuple2('Z', 35),
			_Utils_Tuple2(' ', 36),
			_Utils_Tuple2('$', 37),
			_Utils_Tuple2('%', 38),
			_Utils_Tuple2('*', 39),
			_Utils_Tuple2('+', 40),
			_Utils_Tuple2('-', 41),
			_Utils_Tuple2('.', 42),
			_Utils_Tuple2('/', 43),
			_Utils_Tuple2(':', 44)
		]));
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode = function (_char) {
	return $elm$core$Result$fromMaybe$(
		$pablohirafuji$elm_qrcode$QRCode$Error$InvalidAlphanumericChar,
		$elm$core$Dict$get$(_char, $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$alphanumericCodes));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toBinary = function (chars) {
	_v0$2:
	while (true) {
		if (chars.b) {
			if (chars.b.b) {
				if (!chars.b.b.b) {
					var firstChar = chars.a;
					var _v1 = chars.b;
					var secondChar = _v1.a;
					return $elm$core$Result$map2$(
						F2(
							function (firstCode, secondCode) {
								return _Utils_Tuple2((firstCode * 45) + secondCode, 11);
							}),
						$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode(firstChar),
						$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode(secondChar));
				} else {
					break _v0$2;
				}
			} else {
				var _char = chars.a;
				return $elm$core$Result$map$(
					function (a) {
						return _Utils_Tuple2(a, 6);
					},
					$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode(_char));
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Result$Err($pablohirafuji$elm_qrcode$QRCode$Error$InvalidAlphanumericChar);
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$encode = function (str) {
	return $elm$core$List$foldr$(
		$elm$core$Result$map2($elm$core$List$cons),
		$elm$core$Result$Ok(_List_Nil),
		$elm$core$List$map$(
			$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toBinary,
			$elm_community$list_extra$List$Extra$greedyGroupsOf$(
				2,
				$elm$core$String$toList(str))));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$encode = function (str) {
	return $elm$core$Result$Ok(
		$elm$core$List$map$(
			function (a) {
				return _Utils_Tuple2(
					$elm$core$Char$toCode(a),
					8);
			},
			$elm$core$String$toList(str)));
};
var $pablohirafuji$elm_qrcode$QRCode$Error$InvalidNumericChar = {$: 1};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$numericLength = function (str) {
	var _v0 = $elm$core$String$length(str);
	switch (_v0) {
		case 1:
			return 4;
		case 2:
			return 7;
		default:
			return 10;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encodeHelp = function (chars) {
	var str = $elm$core$String$fromList(chars);
	return $elm$core$Result$fromMaybe$(
		$pablohirafuji$elm_qrcode$QRCode$Error$InvalidNumericChar,
		$elm$core$Maybe$map$(
			function (a) {
				return _Utils_Tuple2(
					a,
					$pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$numericLength(str));
			},
			$elm$core$String$toInt(str)));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encode = function (str) {
	return $elm$core$List$foldr$(
		$elm$core$Result$map2($elm$core$List$cons),
		$elm$core$Result$Ok(_List_Nil),
		$elm$core$List$map$(
			$pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encodeHelp,
			$elm_community$list_extra$List$Extra$greedyGroupsOf$(
				3,
				$elm$core$String$toList(str))));
};
var $pablohirafuji$elm_qrcode$QRCode$Error$InvalidUTF8Char = {$: 3};
var $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$step = function (_v0) {
	var n = _v0.a;
	var xs = _v0.b;
	return (n <= 0) ? $elm$bytes$Bytes$Decode$succeed(
		$elm$bytes$Bytes$Decode$Done(
			$elm$core$List$reverse(xs))) : $elm$bytes$Bytes$Decode$map$(
		function (x) {
			return $elm$bytes$Bytes$Decode$Loop(
				_Utils_Tuple2(
					n - 1,
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(x, 8),
						xs)));
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$encode = function (str) {
	var utf8BytesWidth = $elm$bytes$Bytes$Encode$getStringWidth(str);
	var decoder = $elm$bytes$Bytes$Decode$loop$(
		_Utils_Tuple2(utf8BytesWidth, _List_Nil),
		$pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$step);
	return $elm$core$Result$fromMaybe$(
		$pablohirafuji$elm_qrcode$QRCode$Error$InvalidUTF8Char,
		$elm$bytes$Bytes$Decode$decode$(
			decoder,
			$elm$bytes$Bytes$Encode$encode(
				$elm$bytes$Bytes$Encode$string(str))));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$encoder = function (mode) {
	switch (mode) {
		case 0:
			return $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encode;
		case 1:
			return $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$encode;
		case 2:
			return $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$encode;
		default:
			return $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$encode;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$expTable = $elm$core$Array$fromList(
	_List_fromArray(
		[1, 2, 4, 8, 16, 32, 64, 128, 29, 58, 116, 232, 205, 135, 19, 38, 76, 152, 45, 90, 180, 117, 234, 201, 143, 3, 6, 12, 24, 48, 96, 192, 157, 39, 78, 156, 37, 74, 148, 53, 106, 212, 181, 119, 238, 193, 159, 35, 70, 140, 5, 10, 20, 40, 80, 160, 93, 186, 105, 210, 185, 111, 222, 161, 95, 190, 97, 194, 153, 47, 94, 188, 101, 202, 137, 15, 30, 60, 120, 240, 253, 231, 211, 187, 107, 214, 177, 127, 254, 225, 223, 163, 91, 182, 113, 226, 217, 175, 67, 134, 17, 34, 68, 136, 13, 26, 52, 104, 208, 189, 103, 206, 129, 31, 62, 124, 248, 237, 199, 147, 59, 118, 236, 197, 151, 51, 102, 204, 133, 23, 46, 92, 184, 109, 218, 169, 79, 158, 33, 66, 132, 21, 42, 84, 168, 77, 154, 41, 82, 164, 85, 170, 73, 146, 57, 114, 228, 213, 183, 115, 230, 209, 191, 99, 198, 145, 63, 126, 252, 229, 215, 179, 123, 246, 241, 255, 227, 219, 171, 75, 150, 49, 98, 196, 149, 55, 110, 220, 165, 87, 174, 65, 130, 25, 50, 100, 200, 141, 7, 14, 28, 56, 112, 224, 221, 167, 83, 166, 81, 162, 89, 178, 121, 242, 249, 239, 195, 155, 43, 86, 172, 69, 138, 9, 18, 36, 72, 144, 61, 122, 244, 245, 247, 243, 251, 235, 203, 139, 11, 22, 44, 88, 176, 125, 250, 233, 207, 131, 27, 54, 108, 216, 173, 71, 142, 1]));
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp = function (index) {
	return $elm$core$Maybe$withDefault$(
		0,
		$elm$core$Array$get$(
			A2($elm$core$Basics$modBy, 255, index),
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$expTable));
};
var $pablohirafuji$elm_qrcode$QRCode$Error$PolynomialMultiplyException = {$: 5};
var $pablohirafuji$elm_qrcode$QRCode$Error$LogTableException = function (a) {
	return {$: 4, a: a};
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$logTable = $elm$core$Array$fromList(
	_List_fromArray(
		[0, 1, 25, 2, 50, 26, 198, 3, 223, 51, 238, 27, 104, 199, 75, 4, 100, 224, 14, 52, 141, 239, 129, 28, 193, 105, 248, 200, 8, 76, 113, 5, 138, 101, 47, 225, 36, 15, 33, 53, 147, 142, 218, 240, 18, 130, 69, 29, 181, 194, 125, 106, 39, 249, 185, 201, 154, 9, 120, 77, 228, 114, 166, 6, 191, 139, 98, 102, 221, 48, 253, 226, 152, 37, 179, 16, 145, 34, 136, 54, 208, 148, 206, 143, 150, 219, 189, 241, 210, 19, 92, 131, 56, 70, 64, 30, 66, 182, 163, 195, 72, 126, 110, 107, 58, 40, 84, 250, 133, 186, 61, 202, 94, 155, 159, 10, 21, 121, 43, 78, 212, 229, 172, 115, 243, 167, 87, 7, 112, 192, 247, 140, 128, 99, 13, 103, 74, 222, 237, 49, 197, 254, 24, 227, 165, 153, 119, 38, 184, 180, 124, 17, 68, 146, 217, 35, 32, 137, 46, 55, 63, 209, 91, 149, 188, 207, 205, 144, 135, 151, 178, 220, 252, 190, 97, 242, 86, 211, 171, 20, 42, 93, 158, 132, 60, 57, 83, 71, 109, 65, 162, 31, 45, 67, 216, 183, 123, 164, 118, 196, 23, 73, 236, 127, 12, 111, 246, 108, 161, 59, 82, 41, 157, 85, 170, 251, 96, 134, 177, 187, 204, 62, 90, 203, 89, 95, 176, 156, 169, 160, 81, 11, 245, 22, 235, 122, 117, 44, 215, 79, 174, 213, 233, 230, 231, 173, 232, 116, 214, 244, 234, 168, 80, 88, 175]));
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog = function (index) {
	return (index < 1) ? $elm$core$Result$Err(
		$pablohirafuji$elm_qrcode$QRCode$Error$LogTableException(index)) : $elm$core$Result$fromMaybe$(
		$pablohirafuji$elm_qrcode$QRCode$Error$LogTableException(index),
		$elm$core$Array$get$(index - 1, $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$logTable));
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getOffset = function (_v0) {
	getOffset:
	while (true) {
		var num = _v0.a;
		var offset = _v0.b;
		if (num.b) {
			var head = num.a;
			var tail = num.b;
			if (!head) {
				var $temp$_v0 = _Utils_Tuple2(tail, offset + 1);
				_v0 = $temp$_v0;
				continue getOffset;
			} else {
				return offset;
			}
		} else {
			return offset;
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial$ = function (num, shift) {
	var offset = $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getOffset(
		_Utils_Tuple2(num, 0));
	var numArray = $elm$core$Array$fromList(num);
	return $elm$core$Array$initialize$(
		($elm$core$List$length(num) - offset) + shift,
		function (index) {
			return $elm$core$Maybe$withDefault$(
				0,
				$elm$core$Array$get$(index + offset, numArray));
		});
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial = F2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial$);
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$multiply$ = function (poly1, poly2) {
	var valuesArray = $elm$core$List$indexedMap$(
		F2(
			function (index1, value1) {
				return $elm$core$List$indexedMap$(
					F2(
						function (index2, value2) {
							return _Utils_Tuple3(index1 + index2, value1, value2);
						}),
					$elm$core$Array$toList(poly2));
			}),
		$elm$core$Array$toList(poly1));
	var process__ = F3(
		function (indexSum, num_, exp) {
			return $elm$core$Result$fromMaybe$(
				$pablohirafuji$elm_qrcode$QRCode$Error$PolynomialMultiplyException,
				$elm$core$Maybe$map$(
					$elm$core$Bitwise$xor(exp),
					$elm$core$Array$get$(indexSum, num_)));
		});
	var process_ = F2(
		function (_v0, num_) {
			var indexSum = _v0.a;
			var value1 = _v0.b;
			var value2 = _v0.c;
			return $elm$core$Result$map$(
				function (r) {
					return $elm$core$Array$set$(indexSum, r, num_);
				},
				$elm$core$Result$andThen$(
					A2(process__, indexSum, num_),
					$elm$core$Result$map$(
						$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp,
						$elm$core$Result$map2$(
							$elm$core$Basics$add,
							$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog(value1),
							$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog(value2)))));
		});
	var process = F2(
		function (args, numResult) {
			return $elm$core$Result$andThen$(
				process_(args),
				numResult);
		});
	var num = $elm$core$Array$initialize$(
		($elm$core$Array$length(poly1) + $elm$core$Array$length(poly2)) - 1,
		$elm$core$Basics$always(0));
	return $elm$core$Result$map$(
		function (a) {
			return $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial$(a, 0);
		},
		$elm$core$Result$map$(
			$elm$core$Array$toList,
			$elm$core$List$foldl$(
				process,
				$elm$core$Result$Ok(num),
				$elm$core$List$concat(valuesArray))));
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$multiply = F2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$multiply$);
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getECPolynomial = function (ecLength) {
	var generate = F2(
		function (count, polyResult) {
			generate:
			while (true) {
				if (_Utils_cmp(count, ecLength) < 0) {
					var $temp$count = count + 1,
						$temp$polyResult = $elm$core$Result$andThen$(
						function (a) {
							return $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$multiply$(
								a,
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial$(
									_List_fromArray(
										[
											1,
											$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp(count)
										]),
									0));
						},
						polyResult);
					count = $temp$count;
					polyResult = $temp$polyResult;
					continue generate;
				} else {
					return polyResult;
				}
			}
		});
	return A2(
		generate,
		0,
		$elm$core$Result$Ok(
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial$(
				_List_fromArray(
					[1]),
				0)));
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get___$ = function (ecLength, modPoly) {
	return $elm$core$Array$toList(
		$elm$core$Array$initialize$(
			ecLength,
			function (index) {
				var modIndex = (index + $elm$core$Array$length(modPoly)) - ecLength;
				return (modIndex >= 0) ? $elm$core$Maybe$withDefault$(
					0,
					$elm$core$Array$get$(modIndex, modPoly)) : 0;
			}));
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get___ = F2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get___$);
var $pablohirafuji$elm_qrcode$QRCode$Error$PolynomialModException = {$: 6};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$mod$ = function (poly1, poly2) {
	if (($elm$core$Array$length(poly1) - $elm$core$Array$length(poly2)) < 0) {
		return $elm$core$Result$Ok(poly1);
	} else {
		var helper_ = F3(
			function (index2, poly1_, exp) {
				return $elm$core$Result$fromMaybe$(
					$pablohirafuji$elm_qrcode$QRCode$Error$PolynomialModException,
					$elm$core$Maybe$map$(
						$elm$core$Bitwise$xor(exp),
						$elm$core$Array$get$(index2, poly1_)));
			});
		var getHead = function (poly) {
			return $elm$core$Result$andThen$(
				$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog,
				$elm$core$Result$fromMaybe$(
					$pablohirafuji$elm_qrcode$QRCode$Error$PolynomialModException,
					$elm$core$Array$get$(0, poly)));
		};
		var ratio = $elm$core$Result$map2$(
			$elm$core$Basics$sub,
			getHead(poly1),
			getHead(poly2));
		var helper = F2(
			function (_v0, poly1_) {
				var index2 = _v0.a;
				var value2 = _v0.b;
				return $elm$core$Result$map$(
					function (r) {
						return $elm$core$Array$set$(index2, r, poly1_);
					},
					$elm$core$Result$andThen$(
						A2(helper_, index2, poly1_),
						$elm$core$Result$map$(
							$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp,
							$elm$core$Result$map2$(
								$elm$core$Basics$add,
								ratio,
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog(value2)))));
			});
		var numFold = F2(
			function (args, poly1Result) {
				return $elm$core$Result$andThen$(
					helper(args),
					poly1Result);
			});
		var numResult = $elm$core$Array$foldl$(
			numFold,
			$elm$core$Result$Ok(poly1),
			$elm$core$Array$indexedMap$(
				F2(
					function (a, b) {
						return _Utils_Tuple2(a, b);
					}),
				poly2));
		return $elm$core$Result$andThen$(
			function (a) {
				return $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$mod$(a, poly2);
			},
			$elm$core$Result$map$(
				function (a) {
					return $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial$(a, 0);
				},
				$elm$core$Result$map$($elm$core$Array$toList, numResult)));
	}
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$mod = F2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$mod$);
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get__$ = function (rsPoly, dataCodewords) {
	return $elm$core$Result$map$(
		$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get___(
			$elm$core$Array$length(rsPoly) - 1),
		$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$mod$(
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial$(
				dataCodewords,
				$elm$core$Array$length(rsPoly) - 1),
			rsPoly));
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get__ = F2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get__$);
var $pablohirafuji$elm_qrcode$QRCode$Helpers$listResult$ = function (fun, listb, lista) {
	if (lista.b) {
		var head = lista.a;
		var tail = lista.b;
		return $elm$core$Result$andThen$(
			function (a) {
				return $pablohirafuji$elm_qrcode$QRCode$Helpers$listResult$(fun, a, tail);
			},
			$elm$core$Result$map$(
				function (r) {
					return A2($elm$core$List$cons, r, listb);
				},
				fun(head)));
	} else {
		return $elm$core$Result$Ok(
			$elm$core$List$reverse(listb));
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Helpers$listResult = F3($pablohirafuji$elm_qrcode$QRCode$Helpers$listResult$);
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get_$ = function (byteBlocks, rsPoly) {
	return $pablohirafuji$elm_qrcode$QRCode$Helpers$listResult$(
		$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get__(rsPoly),
		_List_Nil,
		byteBlocks);
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get_ = F2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get_$);
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get$ = function (ecPerBlock, byteBlocks) {
	return $elm$core$Result$andThen$(
		$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get_(byteBlocks),
		$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getECPolynomial(ecPerBlock));
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get = F2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get$);
var $pablohirafuji$elm_qrcode$QRCode$Encode$getErrorCorrection = function (_v0) {
	var model = _v0.a;
	var dataBlocks = _v0.b;
	return $elm$core$Result$map$(
		function (c) {
			return _Utils_Tuple3(model, dataBlocks, c);
		},
		$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get$(model.groupInfo.ecPerBlock, dataBlocks));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric = 1;
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte = 2;
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric = 0;
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$onlyAlphanumeric = A2(
	$elm$regex$Regex$fromStringWith,
	{caseInsensitive: false, multiline: false},
	'^[0-9A-Z $%*+\u005C-.\u005C/:]+$');
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$isValid = function (input) {
	return $elm$core$Maybe$withDefault$(
		false,
		$elm$core$Maybe$map$(
			function (r) {
				return A2($elm$regex$Regex$contains, r, input);
			},
			$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$onlyAlphanumeric));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$only8Bit = A2(
	$elm$regex$Regex$fromStringWith,
	{caseInsensitive: false, multiline: false},
	'^[\u005Cu0000-\u005Cu00ff]+$');
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$isValid = function (input) {
	return $elm$core$Maybe$withDefault$(
		false,
		$elm$core$Maybe$map$(
			function (r) {
				return A2($elm$regex$Regex$contains, r, input);
			},
			$pablohirafuji$elm_qrcode$QRCode$Encode$Byte$only8Bit));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$onlyNumber = A2(
	$elm$regex$Regex$fromStringWith,
	{caseInsensitive: false, multiline: false},
	'^[0-9]+$');
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$isValid = function (input) {
	return $elm$core$Maybe$withDefault$(
		false,
		$elm$core$Maybe$map$(
			function (r) {
				return A2($elm$regex$Regex$contains, r, input);
			},
			$pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$onlyNumber));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$selectMode = function (input) {
	return $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$isValid(input) ? 0 : ($pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$isValid(input) ? 1 : ($pablohirafuji$elm_qrcode$QRCode$Encode$Byte$isValid(input) ? 2 : 3));
};
var $pablohirafuji$elm_qrcode$QRCode$Error$InputLengthOverflow = {$: 7};
var $pablohirafuji$elm_qrcode$QRCode$Encode$filterCapacity$ = function (mode, dataLength, _v0) {
	var capacity = _v0.capacity;
	var version = _v0.version;
	return _Utils_cmp(
		$pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength$(mode, version) + dataLength,
		capacity) < 1;
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$filterCapacity = F3($pablohirafuji$elm_qrcode$QRCode$Encode$filterCapacity$);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity = function (_v0) {
	var blockCount = _v0.a;
	var bytePerBlock = _v0.b;
	return blockCount * bytePerBlock;
};
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$byteCapacity$ = function (group1, maybeGroup2) {
	if (!maybeGroup2.$) {
		var block2 = maybeGroup2.a;
		return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity(group1) + $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity(block2);
	} else {
		return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity(group1);
	}
};
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$byteCapacity = F2($pablohirafuji$elm_qrcode$QRCode$GroupInfo$byteCapacity$);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$ = function (version, ecPerBlock, group1, maybeGroup2) {
	return {
		capacity: $pablohirafuji$elm_qrcode$QRCode$GroupInfo$byteCapacity$(group1, maybeGroup2) * 8,
		ecPerBlock: ecPerBlock,
		group1: group1,
		maybeGroup2: maybeGroup2,
		version: version
	};
};
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo = F4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataH = _List_fromArray(
	[
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		1,
		17,
		_Utils_Tuple2(1, 9),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		2,
		28,
		_Utils_Tuple2(1, 16),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		3,
		22,
		_Utils_Tuple2(2, 13),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		4,
		16,
		_Utils_Tuple2(4, 9),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		5,
		22,
		_Utils_Tuple2(2, 11),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 12))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		6,
		28,
		_Utils_Tuple2(4, 15),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		7,
		26,
		_Utils_Tuple2(4, 13),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 14))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		8,
		26,
		_Utils_Tuple2(4, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 15))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		9,
		24,
		_Utils_Tuple2(4, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 13))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		10,
		28,
		_Utils_Tuple2(6, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 16))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		11,
		24,
		_Utils_Tuple2(3, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(8, 13))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		12,
		28,
		_Utils_Tuple2(7, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 15))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		13,
		22,
		_Utils_Tuple2(12, 11),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 12))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		14,
		24,
		_Utils_Tuple2(11, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 13))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		15,
		24,
		_Utils_Tuple2(11, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 13))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		16,
		30,
		_Utils_Tuple2(3, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 16))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		17,
		28,
		_Utils_Tuple2(2, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(17, 15))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		18,
		28,
		_Utils_Tuple2(2, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(19, 15))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		19,
		26,
		_Utils_Tuple2(9, 13),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(16, 14))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		20,
		28,
		_Utils_Tuple2(15, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 16))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		21,
		30,
		_Utils_Tuple2(19, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 17))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		22,
		24,
		_Utils_Tuple2(34, 13),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		23,
		30,
		_Utils_Tuple2(16, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 16))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		24,
		30,
		_Utils_Tuple2(30, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 17))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		25,
		30,
		_Utils_Tuple2(22, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 16))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		26,
		30,
		_Utils_Tuple2(33, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 17))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		27,
		30,
		_Utils_Tuple2(12, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(28, 16))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		28,
		30,
		_Utils_Tuple2(11, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(31, 16))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		29,
		30,
		_Utils_Tuple2(19, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(26, 16))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		30,
		30,
		_Utils_Tuple2(23, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(25, 16))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		31,
		30,
		_Utils_Tuple2(23, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(28, 16))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		32,
		30,
		_Utils_Tuple2(19, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(35, 16))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		33,
		30,
		_Utils_Tuple2(11, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(46, 16))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		34,
		30,
		_Utils_Tuple2(59, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 17))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		35,
		30,
		_Utils_Tuple2(22, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(41, 16))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		36,
		30,
		_Utils_Tuple2(2, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(64, 16))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		37,
		30,
		_Utils_Tuple2(24, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(46, 16))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		38,
		30,
		_Utils_Tuple2(42, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(32, 16))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		39,
		30,
		_Utils_Tuple2(10, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(67, 16))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		40,
		30,
		_Utils_Tuple2(20, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(61, 16)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataL = _List_fromArray(
	[
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		1,
		7,
		_Utils_Tuple2(1, 19),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		2,
		10,
		_Utils_Tuple2(1, 34),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		3,
		15,
		_Utils_Tuple2(1, 55),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		4,
		20,
		_Utils_Tuple2(1, 80),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		5,
		26,
		_Utils_Tuple2(1, 108),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		6,
		18,
		_Utils_Tuple2(2, 68),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		7,
		20,
		_Utils_Tuple2(2, 78),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		8,
		24,
		_Utils_Tuple2(2, 97),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		9,
		30,
		_Utils_Tuple2(2, 116),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		10,
		18,
		_Utils_Tuple2(2, 68),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 69))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		11,
		20,
		_Utils_Tuple2(4, 81),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		12,
		24,
		_Utils_Tuple2(2, 92),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 93))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		13,
		26,
		_Utils_Tuple2(4, 107),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		14,
		30,
		_Utils_Tuple2(3, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 116))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		15,
		22,
		_Utils_Tuple2(5, 87),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 88))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		16,
		24,
		_Utils_Tuple2(5, 98),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 99))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		17,
		28,
		_Utils_Tuple2(1, 107),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 108))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		18,
		30,
		_Utils_Tuple2(5, 120),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 121))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		19,
		28,
		_Utils_Tuple2(3, 113),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 114))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		20,
		28,
		_Utils_Tuple2(3, 107),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 108))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		21,
		28,
		_Utils_Tuple2(4, 116),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 117))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		22,
		28,
		_Utils_Tuple2(2, 111),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 112))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		23,
		30,
		_Utils_Tuple2(4, 121),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 122))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		24,
		30,
		_Utils_Tuple2(6, 117),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 118))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		25,
		26,
		_Utils_Tuple2(8, 106),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 107))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		26,
		28,
		_Utils_Tuple2(10, 114),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 115))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		27,
		30,
		_Utils_Tuple2(8, 122),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 123))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		28,
		30,
		_Utils_Tuple2(3, 117),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 118))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		29,
		30,
		_Utils_Tuple2(7, 116),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 117))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		30,
		30,
		_Utils_Tuple2(5, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 116))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		31,
		30,
		_Utils_Tuple2(13, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(3, 116))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		32,
		30,
		_Utils_Tuple2(17, 115),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		33,
		30,
		_Utils_Tuple2(17, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 116))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		34,
		30,
		_Utils_Tuple2(13, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 116))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		35,
		30,
		_Utils_Tuple2(12, 121),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 122))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		36,
		30,
		_Utils_Tuple2(6, 121),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 122))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		37,
		30,
		_Utils_Tuple2(17, 122),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 123))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		38,
		30,
		_Utils_Tuple2(4, 122),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(18, 123))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		39,
		30,
		_Utils_Tuple2(20, 117),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 118))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		40,
		30,
		_Utils_Tuple2(19, 118),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 119)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataM = _List_fromArray(
	[
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		1,
		10,
		_Utils_Tuple2(1, 16),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		2,
		16,
		_Utils_Tuple2(1, 28),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		3,
		26,
		_Utils_Tuple2(1, 44),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		4,
		18,
		_Utils_Tuple2(2, 32),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		5,
		24,
		_Utils_Tuple2(2, 43),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		6,
		16,
		_Utils_Tuple2(4, 27),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		7,
		18,
		_Utils_Tuple2(4, 31),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		8,
		22,
		_Utils_Tuple2(2, 38),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 39))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		9,
		22,
		_Utils_Tuple2(3, 36),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 37))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		10,
		26,
		_Utils_Tuple2(4, 43),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 44))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		11,
		30,
		_Utils_Tuple2(1, 50),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 51))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		12,
		22,
		_Utils_Tuple2(6, 36),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 37))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		13,
		22,
		_Utils_Tuple2(8, 37),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 38))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		14,
		24,
		_Utils_Tuple2(4, 40),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 41))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		15,
		24,
		_Utils_Tuple2(5, 41),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 42))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		16,
		28,
		_Utils_Tuple2(7, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(3, 46))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		17,
		28,
		_Utils_Tuple2(10, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 47))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		18,
		26,
		_Utils_Tuple2(9, 43),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 44))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		19,
		26,
		_Utils_Tuple2(3, 44),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(11, 45))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		20,
		26,
		_Utils_Tuple2(3, 41),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 42))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		21,
		26,
		_Utils_Tuple2(17, 42),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		22,
		28,
		_Utils_Tuple2(17, 46),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		23,
		28,
		_Utils_Tuple2(4, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 48))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		24,
		28,
		_Utils_Tuple2(6, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 46))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		25,
		28,
		_Utils_Tuple2(8, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 48))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		26,
		28,
		_Utils_Tuple2(19, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 47))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		27,
		28,
		_Utils_Tuple2(22, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(3, 46))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		28,
		28,
		_Utils_Tuple2(3, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(23, 46))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		29,
		28,
		_Utils_Tuple2(21, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 46))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		30,
		28,
		_Utils_Tuple2(19, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 48))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		31,
		28,
		_Utils_Tuple2(2, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(29, 47))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		32,
		28,
		_Utils_Tuple2(10, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(23, 47))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		33,
		28,
		_Utils_Tuple2(14, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(21, 47))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		34,
		28,
		_Utils_Tuple2(14, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(23, 47))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		35,
		28,
		_Utils_Tuple2(12, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(26, 48))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		36,
		28,
		_Utils_Tuple2(6, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(34, 48))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		37,
		28,
		_Utils_Tuple2(29, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 47))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		38,
		28,
		_Utils_Tuple2(13, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(32, 47))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		39,
		28,
		_Utils_Tuple2(40, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 48))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		40,
		28,
		_Utils_Tuple2(18, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(31, 48)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataQ = _List_fromArray(
	[
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		1,
		13,
		_Utils_Tuple2(1, 13),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		2,
		22,
		_Utils_Tuple2(1, 22),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		3,
		18,
		_Utils_Tuple2(2, 17),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		4,
		26,
		_Utils_Tuple2(2, 24),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		5,
		18,
		_Utils_Tuple2(2, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 16))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		6,
		24,
		_Utils_Tuple2(4, 19),
		$elm$core$Maybe$Nothing),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		7,
		18,
		_Utils_Tuple2(2, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 15))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		8,
		22,
		_Utils_Tuple2(4, 18),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 19))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		9,
		20,
		_Utils_Tuple2(4, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 17))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		10,
		24,
		_Utils_Tuple2(6, 19),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 20))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		11,
		28,
		_Utils_Tuple2(4, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 23))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		12,
		26,
		_Utils_Tuple2(4, 20),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 21))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		13,
		24,
		_Utils_Tuple2(8, 20),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 21))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		14,
		20,
		_Utils_Tuple2(11, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 17))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		15,
		30,
		_Utils_Tuple2(5, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 25))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		16,
		24,
		_Utils_Tuple2(15, 19),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 20))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		17,
		28,
		_Utils_Tuple2(1, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(15, 23))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		18,
		28,
		_Utils_Tuple2(17, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 23))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		19,
		26,
		_Utils_Tuple2(17, 21),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 22))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		20,
		30,
		_Utils_Tuple2(15, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 25))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		21,
		28,
		_Utils_Tuple2(17, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 23))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		22,
		30,
		_Utils_Tuple2(7, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(16, 25))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		23,
		30,
		_Utils_Tuple2(11, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 25))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		24,
		30,
		_Utils_Tuple2(11, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(16, 25))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		25,
		30,
		_Utils_Tuple2(7, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(22, 25))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		26,
		28,
		_Utils_Tuple2(28, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 23))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		27,
		30,
		_Utils_Tuple2(8, 23),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(26, 24))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		28,
		30,
		_Utils_Tuple2(4, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(31, 25))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		29,
		30,
		_Utils_Tuple2(1, 23),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(37, 24))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		30,
		30,
		_Utils_Tuple2(15, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(25, 25))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		31,
		30,
		_Utils_Tuple2(42, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 25))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		32,
		30,
		_Utils_Tuple2(10, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(35, 25))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		33,
		30,
		_Utils_Tuple2(29, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(19, 25))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		34,
		30,
		_Utils_Tuple2(44, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 25))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		35,
		30,
		_Utils_Tuple2(39, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 25))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		36,
		30,
		_Utils_Tuple2(46, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 25))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		37,
		30,
		_Utils_Tuple2(49, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 25))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		38,
		30,
		_Utils_Tuple2(48, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 25))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		39,
		30,
		_Utils_Tuple2(43, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(22, 25))),
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo$(
		40,
		30,
		_Utils_Tuple2(34, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(34, 25)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$getGroupData = function (ecLevel) {
	switch (ecLevel) {
		case 0:
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataL;
		case 1:
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataM;
		case 2:
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataQ;
		default:
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataH;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$getVersion$ = function (ecLevel, mode, dataLength) {
	return $elm$core$Result$fromMaybe$(
		$pablohirafuji$elm_qrcode$QRCode$Error$InputLengthOverflow,
		$elm$core$List$head(
			A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.capacity;
				},
				$elm$core$List$filter$(
					A2($pablohirafuji$elm_qrcode$QRCode$Encode$filterCapacity, mode, dataLength),
					$pablohirafuji$elm_qrcode$QRCode$GroupInfo$getGroupData(ecLevel)))));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$getVersion = F3($pablohirafuji$elm_qrcode$QRCode$Encode$getVersion$);
var $pablohirafuji$elm_qrcode$QRCode$Encode$versionToModel$ = function (inputStr, ecLevel, mode, partialBitsCount, groupInfo) {
	return {
		bitsCount: partialBitsCount + $pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength$(mode, groupInfo.version),
		ecLevel: ecLevel,
		groupInfo: groupInfo,
		inputStr: inputStr,
		mode: mode
	};
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$versionToModel = F5($pablohirafuji$elm_qrcode$QRCode$Encode$versionToModel$);
var $pablohirafuji$elm_qrcode$QRCode$Encode$selectVersion$ = function (inputStr, ecLevel, mode, encodedStr) {
	var partialBitsCount = 4 + $elm$core$List$foldl$(
		F2(
			function (a, b) {
				return a.b + b;
			}),
		0,
		encodedStr);
	return $elm$core$Result$map$(
		function (b) {
			return _Utils_Tuple2(encodedStr, b);
		},
		$elm$core$Result$map$(
			A4($pablohirafuji$elm_qrcode$QRCode$Encode$versionToModel, inputStr, ecLevel, mode, partialBitsCount),
			$pablohirafuji$elm_qrcode$QRCode$Encode$getVersion$(ecLevel, mode, partialBitsCount)));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$selectVersion = F4($pablohirafuji$elm_qrcode$QRCode$Encode$selectVersion$);
var $pablohirafuji$elm_qrcode$QRCode$Encode$breakList$ = function (checkFinish, _v0, _v1) {
	breakList:
	while (true) {
		var times = _v0.a;
		var itemCount = _v0.b;
		var byteList = _v1.a;
		var progress = _v1.b;
		if (times > 0) {
			var remainList = $elm$core$List$drop$(itemCount, byteList);
			var block = $elm$core$List$take$(itemCount, byteList);
			var $temp$_v0 = _Utils_Tuple2(times - 1, itemCount),
				$temp$_v1 = _Utils_Tuple2(
				remainList,
				A2($elm$core$List$cons, block, progress));
			_v0 = $temp$_v0;
			_v1 = $temp$_v1;
			continue breakList;
		} else {
			if (checkFinish && ($elm$core$List$length(byteList) > 0)) {
				return $elm$core$Result$Err($pablohirafuji$elm_qrcode$QRCode$Error$InputLengthOverflow);
			} else {
				return $elm$core$Result$Ok(
					_Utils_Tuple2(byteList, progress));
			}
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$breakList = F3($pablohirafuji$elm_qrcode$QRCode$Encode$breakList$);
var $pablohirafuji$elm_qrcode$QRCode$Encode$toBlocks = function (_v0) {
	var model = _v0.a;
	var groupInfo = model.groupInfo;
	var byteList = _v0.b;
	var _v1 = groupInfo.maybeGroup2;
	if (!_v1.$) {
		var group2 = _v1.a;
		return $elm$core$Result$map$(
			function (b) {
				return _Utils_Tuple2(model, b);
			},
			$elm$core$Result$map$(
				A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$List$reverse),
				$elm$core$Result$andThen$(
					A2($pablohirafuji$elm_qrcode$QRCode$Encode$breakList, true, group2),
					$pablohirafuji$elm_qrcode$QRCode$Encode$breakList$(
						false,
						groupInfo.group1,
						_Utils_Tuple2(byteList, _List_Nil)))));
	} else {
		return $elm$core$Result$map$(
			function (b) {
				return _Utils_Tuple2(model, b);
			},
			$elm$core$Result$map$(
				A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$List$reverse),
				$pablohirafuji$elm_qrcode$QRCode$Encode$breakList$(
					true,
					groupInfo.group1,
					_Utils_Tuple2(byteList, _List_Nil))));
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$encode$ = function (inputStr, ecLevel) {
	var mode = $pablohirafuji$elm_qrcode$QRCode$Encode$selectMode(inputStr);
	return $elm$core$Result$map$(
		$pablohirafuji$elm_qrcode$QRCode$Encode$concatTranspose,
		$elm$core$Result$andThen$(
			$pablohirafuji$elm_qrcode$QRCode$Encode$getErrorCorrection,
			$elm$core$Result$andThen$(
				$pablohirafuji$elm_qrcode$QRCode$Encode$toBlocks,
				$elm$core$Result$map$(
					$pablohirafuji$elm_qrcode$QRCode$Encode$addInfoAndFinalBits,
					$elm$core$Result$andThen$(
						A3($pablohirafuji$elm_qrcode$QRCode$Encode$selectVersion, inputStr, ecLevel, mode),
						A2($pablohirafuji$elm_qrcode$QRCode$Encode$encoder, mode, inputStr))))));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$encode = F2($pablohirafuji$elm_qrcode$QRCode$Encode$encode$);
var $pablohirafuji$elm_qrcode$QRCode$fromStringWith$ = function (ecLevel, input) {
	return $elm$core$Result$mapError$(
		$pablohirafuji$elm_qrcode$QRCode$convertError,
		$elm$core$Result$andThen$(
			function (_v0) {
				var encodeModel = _v0.a;
				var encodedData = _v0.b;
				return $elm$core$Result$map$(
					function (matrix) {
						return {matrix: matrix, version: encodeModel.groupInfo.version};
					},
					$pablohirafuji$elm_qrcode$QRCode$Matrix$apply(
						_Utils_Tuple2(encodeModel, encodedData)));
			},
			$pablohirafuji$elm_qrcode$QRCode$Encode$encode$(
				input,
				$pablohirafuji$elm_qrcode$QRCode$convertEC(ecLevel))));
};
var $pablohirafuji$elm_qrcode$QRCode$fromStringWith = F2($pablohirafuji$elm_qrcode$QRCode$fromStringWith$);
var $pablohirafuji$elm_qrcode$QRCode$fromString = $pablohirafuji$elm_qrcode$QRCode$fromStringWith(2);
var $author$project$MyUi$heightAttr = function (height) {
	return A2(
		$elm$html$Html$Attributes$style,
		'height',
		$elm$core$String$fromInt(height) + 'px');
};
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize = 5;
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$appendLastRect = function (_v0) {
	var lastRect = _v0.a;
	var rowLines = _v0.b;
	return A2(
		$elm$core$List$cons,
		'h' + $elm$core$String$fromInt(lastRect.width * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize),
		rowLines);
};
var $elm$svg$Svg$Attributes$shapeRendering = _VirtualDom_attribute('shape-rendering');
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$toRowLines$ = function (isDark, _v0) {
	var lastRect = _v0.a;
	var rowLines = _v0.b;
	return isDark ? ((!lastRect.space) ? _Utils_Tuple2(
		_Utils_update(
			lastRect,
			{width: lastRect.width + 1}),
		rowLines) : _Utils_Tuple2(
		{space: 0, width: 1},
		A2(
			$elm$core$List$cons,
			$elm$core$String$concat(
				_List_fromArray(
					[
						(lastRect.width > 0) ? ('h' + $elm$core$String$fromInt(lastRect.width * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize)) : '',
						'm',
						$elm$core$String$fromInt(lastRect.space * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize),
						' 0'
					])),
			rowLines))) : _Utils_Tuple2(
		_Utils_update(
			lastRect,
			{space: lastRect.space + 1}),
		rowLines);
};
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$toRowLines = F2($pablohirafuji$elm_qrcode$QRCode$Render$Svg$toRowLines$);
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewRow$ = function (quietZoneSize, rowIndex, rowLines) {
	return A2(
		$elm$core$List$cons,
		'M0 ',
		A2(
			$elm$core$List$cons,
			$elm$core$String$fromInt(rowIndex * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize),
			rowLines));
};
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewRow = F3($pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewRow$);
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewBase$ = function (quietZoneSize, extraAttrs, matrix) {
	var quietZonePx = quietZoneSize * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize;
	var sizePx = $elm$core$String$fromInt(
		($elm$core$List$length(matrix) * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize) + (2 * quietZonePx));
	return A2(
		$elm$svg$Svg$svg,
		_Utils_ap(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$viewBox('0 0 ' + (sizePx + (' ' + sizePx))),
					$elm$svg$Svg$Attributes$shapeRendering('crispEdges'),
					$elm$svg$Svg$Attributes$stroke('#000'),
					$elm$svg$Svg$Attributes$strokeWidth(
					$elm$core$String$fromInt($pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize) + 'px')
				]),
			extraAttrs),
		function (d) {
			return _List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							d,
							$elm$svg$Svg$Attributes$transform(
							'translate(' + ($elm$core$String$fromInt(quietZonePx) + (', ' + ($elm$core$String$fromFloat(quietZonePx + ($pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize / 2)) + ')')))),
							$elm$svg$Svg$Attributes$strokeWidth('5px')
						]),
					_List_Nil)
				]);
		}(
			$elm$svg$Svg$Attributes$d(
				$elm$core$String$concat(
					$elm$core$List$concat(
						$elm$core$List$indexedMap$(
							$pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewRow(quietZoneSize),
							$elm$core$List$map$(
								A2(
									$elm$core$Basics$composeR,
									A2(
										$elm$core$List$foldl,
										$pablohirafuji$elm_qrcode$QRCode$Render$Svg$toRowLines,
										_Utils_Tuple2(
											{space: 0, width: 0},
											_List_Nil)),
									A2($elm$core$Basics$composeR, $pablohirafuji$elm_qrcode$QRCode$Render$Svg$appendLastRect, $elm$core$List$reverse)),
								matrix)))))));
};
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewBase = F3($pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewBase$);
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewWithoutQuietZone = $pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewBase(0);
var $pablohirafuji$elm_qrcode$QRCode$toSvgWithoutQuietZone$ = function (extraAttrs, _v0) {
	var matrix = _v0.matrix;
	return A2($pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewWithoutQuietZone, extraAttrs, matrix);
};
var $pablohirafuji$elm_qrcode$QRCode$toSvgWithoutQuietZone = F2($pablohirafuji$elm_qrcode$QRCode$toSvgWithoutQuietZone$);
var $author$project$MyUi$widthAttr = function (width) {
	return A2(
		$elm$html$Html$Attributes$style,
		'width',
		$elm$core$String$fromInt(width) + 'px');
};
var $author$project$Pages$Guild$inviteLinkQrCodeView$ = function (containerWidth, inviteLink) {
	var _v0 = $pablohirafuji$elm_qrcode$QRCode$fromString(inviteLink);
	if (!_v0.$) {
		var qrCode = _v0.a;
		var size = $elm$core$Basics$min$(300, containerWidth);
		return $author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$background($author$project$MyUi$white),
					$author$project$Ui$padding(12),
					$author$project$Ui$rounded(8),
					$author$project$Ui$width($author$project$Ui$shrink)
				]),
			$author$project$Ui$html(
				$pablohirafuji$elm_qrcode$QRCode$toSvgWithoutQuietZone$(
					_List_fromArray(
						[
							$author$project$MyUi$widthAttr(size),
							$author$project$MyUi$heightAttr(size)
						]),
					qrCode)));
	} else {
		return $author$project$Ui$none;
	}
};
var $author$project$Pages$Guild$inviteLinkQrCodeView = F2($author$project$Pages$Guild$inviteLinkQrCodeView$);
var $author$project$Types$PressedLeaveGuild = function (a) {
	return {$: 27, a: a};
};
var $author$project$Pages$Guild$confirmLeaveGuildText = 'Yes, leave guild';
var $author$project$Pages$Guild$leaveGuildText = 'Leave guild';
var $author$project$Pages$Guild$leaveGuildSection$ = function (guildId, form) {
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(12),
				$author$project$Ui$paddingXY$(16, 0)
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$height(
						$author$project$Ui$px(1)),
						$author$project$Ui$background($author$project$MyUi$border2)
					]),
				$author$project$Ui$none),
				form.showLeaveConfirmation ? $author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Font$color($author$project$MyUi$font2)
					]),
				$author$project$Ui$text('You\u0027ll need to use an invite link to rejoin. Are you sure?')) : $author$project$Ui$none,
				$author$project$MyUi$elButton$(
				$lamdera$program_test$Effect$Browser$Dom$id('guild_leaveGuild'),
				form.showLeaveConfirmation ? $author$project$Types$PressedLeaveGuild(guildId) : $author$project$Types$EditGuildFormChanged$(
					guildId,
					_Utils_update(
						form,
						{showLeaveConfirmation: true})),
				_List_fromArray(
					[
						$author$project$Ui$paddingXY$(16, 4),
						$author$project$Ui$background($author$project$MyUi$deleteButtonBackground),
						$author$project$Ui$width($author$project$Ui$shrink),
						$author$project$Ui$rounded(4),
						$author$project$Ui$Font$color($author$project$MyUi$deleteButtonFont),
						$author$project$Ui$Font$bold,
						$author$project$Ui$borderColor($author$project$MyUi$deleteButtonBorder),
						$author$project$Ui$border(1)
					]),
				$author$project$Ui$text(
					form.showLeaveConfirmation ? $author$project$Pages$Guild$confirmLeaveGuildText : $author$project$Pages$Guild$leaveGuildText))
			]));
};
var $author$project$Pages$Guild$leaveGuildSection = F2($author$project$Pages$Guild$leaveGuildSection$);
var $author$project$ImageEditor$MouseDownImageEditor$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$ImageEditor$MouseDownImageEditor = F2($author$project$ImageEditor$MouseDownImageEditor$);
var $author$project$ImageEditor$MovedImageEditor$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$ImageEditor$MovedImageEditor = F2($author$project$ImageEditor$MovedImageEditor$);
var $author$project$ImageEditor$PressedCancel = {$: 10};
var $author$project$ImageEditor$PressedConfirmImage = {$: 7};
var $author$project$ImageEditor$PressedProfileImage = {$: 0};
var $author$project$ImageEditor$PressedRemoveImage = {$: 11};
var $author$project$ImageEditor$TouchEndImageEditor = {$: 6};
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$defaultOptions = {preventDefault: true, stopPropagation: false};
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$Event$ = function (keys, changedTouches, targetTouches, touches) {
	return {changedTouches: changedTouches, keys: keys, targetTouches: targetTouches, touches: touches};
};
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$Event = F4($mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$Event$);
var $mpizenberg$elm_pointer_events$Internal$Decode$Keys$ = function (alt, ctrl, meta, shift) {
	return {alt: alt, ctrl: ctrl, meta: meta, shift: shift};
};
var $mpizenberg$elm_pointer_events$Internal$Decode$Keys = F4($mpizenberg$elm_pointer_events$Internal$Decode$Keys$);
var $mpizenberg$elm_pointer_events$Internal$Decode$keys = A5(
	$elm$json$Json$Decode$map4,
	$mpizenberg$elm_pointer_events$Internal$Decode$Keys,
	A2($elm$json$Json$Decode$field, 'altKey', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'ctrlKey', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'metaKey', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'shiftKey', $elm$json$Json$Decode$bool));
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$Touch$ = function (identifier, clientPos, pagePos, screenPos) {
	return {clientPos: clientPos, identifier: identifier, pagePos: pagePos, screenPos: screenPos};
};
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$Touch = F4($mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$Touch$);
var $mpizenberg$elm_pointer_events$Internal$Decode$clientPos = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float));
var $mpizenberg$elm_pointer_events$Internal$Decode$pagePos = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'pageX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'pageY', $elm$json$Json$Decode$float));
var $mpizenberg$elm_pointer_events$Internal$Decode$screenPos = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (a, b) {
			return _Utils_Tuple2(a, b);
		}),
	A2($elm$json$Json$Decode$field, 'screenX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'screenY', $elm$json$Json$Decode$float));
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchDecoder = A5(
	$elm$json$Json$Decode$map4,
	$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$Touch,
	A2($elm$json$Json$Decode$field, 'identifier', $elm$json$Json$Decode$int),
	$mpizenberg$elm_pointer_events$Internal$Decode$clientPos,
	$mpizenberg$elm_pointer_events$Internal$Decode$pagePos,
	$mpizenberg$elm_pointer_events$Internal$Decode$screenPos);
var $mpizenberg$elm_pointer_events$Internal$Decode$all = A2(
	$elm$core$List$foldr,
	$elm$json$Json$Decode$map2($elm$core$List$cons),
	$elm$json$Json$Decode$succeed(_List_Nil));
var $mpizenberg$elm_pointer_events$Internal$Decode$dynamicListOf = function (itemDecoder) {
	var decodeOne = function (n) {
		return A2(
			$elm$json$Json$Decode$field,
			$elm$core$String$fromInt(n),
			itemDecoder);
	};
	var decodeN = function (n) {
		return $mpizenberg$elm_pointer_events$Internal$Decode$all(
			$elm$core$List$map$(
				decodeOne,
				$elm$core$List$range$(0, n - 1)));
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		decodeN,
		A2($elm$json$Json$Decode$field, 'length', $elm$json$Json$Decode$int));
};
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchListDecoder = $mpizenberg$elm_pointer_events$Internal$Decode$dynamicListOf;
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$eventDecoder = A5(
	$elm$json$Json$Decode$map4,
	$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$Event,
	$mpizenberg$elm_pointer_events$Internal$Decode$keys,
	A2(
		$elm$json$Json$Decode$field,
		'changedTouches',
		$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchListDecoder($mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'targetTouches',
		$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchListDecoder($mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'touches',
		$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchListDecoder($mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$touchDecoder)));
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onWithOptions$ = function (event, options, tag) {
	return $elm$html$Html$Events$custom$(
		event,
		A2(
			$elm$json$Json$Decode$map,
			function (ev) {
				return {
					message: tag(ev),
					preventDefault: options.preventDefault,
					stopPropagation: options.stopPropagation
				};
			},
			$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$eventDecoder));
};
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onWithOptions = F3($mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onWithOptions$);
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onEnd = A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onWithOptions, 'touchend', $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$defaultOptions);
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onMove = A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onWithOptions, 'touchmove', $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$defaultOptions);
var $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onStart = A2($mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onWithOptions, 'touchstart', $mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$defaultOptions);
var $author$project$ImageEditor$tToPixel$ = function (windowSize, value) {
	return value * $author$project$ImageEditor$imageEditorWidth(windowSize);
};
var $author$project$ImageEditor$tToPixel = F2($author$project$ImageEditor$tToPixel$);
var $author$project$ImageEditor$view$ = function (windowSize, hasImage, model) {
	var _v0 = model.imageUrl;
	if (_v0.$ === 1) {
		return $author$project$Ui$row$(
			_List_fromArray(
				[
					$author$project$Ui$spacing(8)
				]),
			_List_fromArray(
				[
					hasImage ? $author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$Input$button($author$project$ImageEditor$PressedRemoveImage),
							$author$project$Ui$id('imageEditor_removeImage'),
							$author$project$MyUi$hoverText('Remove profile image'),
							$author$project$Ui$paddingXY$(8, 0),
							$author$project$Ui$background($author$project$MyUi$deleteButtonBackground),
							$author$project$Ui$border(1),
							$author$project$Ui$borderColor($author$project$MyUi$deleteButtonBorder),
							$author$project$Ui$Font$color($author$project$MyUi$deleteButtonFont),
							$author$project$Ui$rounded(4),
							$author$project$Ui$width($author$project$Ui$shrink),
							$author$project$Ui$height($author$project$Ui$fill),
							$author$project$Ui$contentCenterY
						]),
					$author$project$Ui$html($author$project$Icons$delete)) : $author$project$Ui$none,
					$author$project$MyUi$secondaryButtonTall$(
					$lamdera$program_test$Effect$Browser$Dom$id('imageEditor_selectImage'),
					$author$project$ImageEditor$PressedProfileImage,
					hasImage ? 'Select new image' : 'Select image')
				]));
	} else {
		var imageUrl = _v0.a;
		var imageEditorWidth_ = $author$project$ImageEditor$imageEditorWidth(windowSize);
		var drawVerticalLine = F3(
			function (x_, y_, height) {
				return $author$project$Ui$inFront(
					$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$height(
								$author$project$Ui$px(
									$elm$core$Basics$round(
										$author$project$ImageEditor$tToPixel$(windowSize, height)))),
								$author$project$Ui$width(
								$author$project$Ui$px(6)),
								$author$project$Ui$move(
								{
									x: $elm$core$Basics$round(
										$author$project$ImageEditor$tToPixel$(windowSize, x_) - 3),
									y: $elm$core$Basics$round(
										$author$project$ImageEditor$tToPixel$(windowSize, y_)),
									z: 0
								}),
								$author$project$Ui$background($author$project$MyUi$white),
								$author$project$Ui$border(2),
								$author$project$MyUi$htmlStyle$('pointer-events', 'none')
							]),
						$author$project$Ui$none));
			});
		var drawNode = F2(
			function (x_, y_) {
				return $author$project$Ui$inFront(
					$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$width(
								$author$project$Ui$px(8)),
								$author$project$Ui$height(
								$author$project$Ui$px(8)),
								$author$project$Ui$move(
								{
									x: $elm$core$Basics$round(
										$author$project$ImageEditor$tToPixel$(windowSize, x_) - 4),
									y: $elm$core$Basics$round(
										$author$project$ImageEditor$tToPixel$(windowSize, y_) - 4),
									z: 0
								}),
								$author$project$Ui$background($author$project$MyUi$white),
								$author$project$Ui$border(2),
								$author$project$MyUi$htmlStyle$('pointer-events', 'none')
							]),
						$author$project$Ui$none));
			});
		var drawHorizontalLine = F3(
			function (x_, y_, width) {
				return $author$project$Ui$inFront(
					$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$width(
								$author$project$Ui$px(
									$elm$core$Basics$round(
										$author$project$ImageEditor$tToPixel$(windowSize, width)))),
								$author$project$Ui$height(
								$author$project$Ui$px(6)),
								$author$project$Ui$move(
								{
									x: $elm$core$Basics$round(
										$author$project$ImageEditor$tToPixel$(windowSize, x_)),
									y: $elm$core$Basics$round(
										$author$project$ImageEditor$tToPixel$(windowSize, y_) - 3),
									z: 0
								}),
								$author$project$Ui$background($author$project$MyUi$white),
								$author$project$Ui$border(2),
								$author$project$MyUi$htmlStyle$('pointer-events', 'none')
							]),
						$author$project$Ui$none));
			});
		var _v1 = $author$project$ImageEditor$getActualImageState(model);
		var dragState = _v1.dragState;
		var size = _v1.size;
		var y = _v1.y;
		var x = _v1.x;
		return $author$project$Ui$column$(
			_List_fromArray(
				[
					$author$project$Ui$spacing(8),
					$author$project$Ui$inFront(
					function () {
						var _v2 = model.imageSize;
						if (!_v2.$) {
							return $author$project$Ui$none;
						} else {
							return $author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$MyUi$htmlStyle$('pointer-events', 'none')
									]),
								$author$project$Ui$html(
									A2(
										$elm$html$Html$img,
										_List_fromArray(
											[
												$lamdera$program_test$Effect$Browser$Dom$idToAttribute($author$project$ImageEditor$profileImagePlaceholderId),
												$elm$html$Html$Attributes$src(imageUrl)
											]),
										_List_Nil)));
						}
					}())
				]),
			_List_fromArray(
				[
					$author$project$Ui$image$(
					_List_fromArray(
						[
							$author$project$Ui$width(
							$author$project$Ui$px(imageEditorWidth_)),
							function () {
							var _v3 = model.imageSize;
							if (!_v3.$) {
								var _v4 = _v3.a;
								var w = _v4.a;
								var h = _v4.b;
								return $author$project$Ui$height(
									$author$project$Ui$px(
										$elm$core$Basics$round((imageEditorWidth_ * h) / w)));
							} else {
								return $author$project$Ui$inFront($author$project$Ui$none);
							}
						}(),
							$author$project$Ui$htmlAttribute(
							$elm$html$Html$Events$preventDefaultOn$(
								'mousedown',
								A3(
									$elm$json$Json$Decode$map2,
									F2(
										function (x_, y_) {
											return _Utils_Tuple2(
												$author$project$ImageEditor$MouseDownImageEditor$(x_, y_),
												true);
										}),
									A2($elm$json$Json$Decode$field, 'offsetX', $elm$json$Json$Decode$float),
									A2($elm$json$Json$Decode$field, 'offsetY', $elm$json$Json$Decode$float)))),
							_Utils_eq(dragState, $elm$core$Maybe$Nothing) ? $author$project$Ui$htmlAttribute(
							$elm$html$Html$Events$on$(
								'',
								$elm$json$Json$Decode$succeed(
									$author$project$ImageEditor$MovedImageEditor$(0, 0)))) : $author$project$Ui$htmlAttribute(
							$elm$html$Html$Events$preventDefaultOn$(
								'mousemove',
								A3(
									$elm$json$Json$Decode$map2,
									F2(
										function (x_, y_) {
											return _Utils_Tuple2(
												$author$project$ImageEditor$MovedImageEditor$(x_, y_),
												true);
										}),
									A2($elm$json$Json$Decode$field, 'offsetX', $elm$json$Json$Decode$float),
									A2($elm$json$Json$Decode$field, 'offsetY', $elm$json$Json$Decode$float)))),
							$author$project$Ui$htmlAttribute(
							$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onStart(
								function (event) {
									var _v5 = $elm$core$List$head(
										$elm$core$List$reverse(event.touches));
									if (!_v5.$) {
										var last = _v5.a;
										return $author$project$ImageEditor$MouseDownImageEditor$(last.clientPos.a, last.clientPos.b);
									} else {
										return $author$project$ImageEditor$MouseDownImageEditor$(0, 0);
									}
								})),
							$author$project$Ui$htmlAttribute(
							$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onEnd(
								function (_v6) {
									return $author$project$ImageEditor$TouchEndImageEditor;
								})),
							_Utils_eq(dragState, $elm$core$Maybe$Nothing) ? $author$project$Ui$htmlAttribute(
							$elm$html$Html$Events$on$(
								'',
								$elm$json$Json$Decode$succeed(
									$author$project$ImageEditor$MovedImageEditor$(0, 0)))) : $author$project$Ui$htmlAttribute(
							$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onMove(
								function (event) {
									var _v7 = $elm$core$List$head(
										$elm$core$List$reverse(event.touches));
									if (!_v7.$) {
										var last = _v7.a;
										return $author$project$ImageEditor$MovedImageEditor$(last.clientPos.a, last.clientPos.b);
									} else {
										return $author$project$ImageEditor$MovedImageEditor$(0, 0);
									}
								})),
							A2(drawNode, x, y),
							A2(drawNode, x + size, y),
							A2(drawNode, x, y + size),
							A2(drawNode, x + size, y + size),
							A3(drawHorizontalLine, x, y, size),
							A3(drawHorizontalLine, x, y + size, size),
							A3(drawVerticalLine, x, y, size),
							A3(drawVerticalLine, x + size, y, size)
						]),
					{description: 'Image editor', onLoad: $elm$core$Maybe$Nothing, source: imageUrl}),
					$author$project$Ui$row$(
					_List_fromArray(
						[
							$author$project$Ui$spacing(16)
						]),
					_List_fromArray(
						[
							$author$project$MyUi$secondaryButton$(
							$lamdera$program_test$Effect$Browser$Dom$id('imageEditor_cancel'),
							$author$project$ImageEditor$PressedCancel,
							'Cancel'),
							$author$project$MyUi$simpleButton$(
							$lamdera$program_test$Effect$Browser$Dom$id('imageEditor_confirm'),
							$author$project$ImageEditor$PressedConfirmImage,
							$author$project$Ui$text('Confirm')),
							function () {
							var _v8 = model.status;
							switch (_v8.$) {
								case 1:
									return $author$project$Ui$text('Uploading...');
								case 2:
									return $author$project$Ui$text('Uploading...');
								case 3:
									return $author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$Font$color($author$project$MyUi$errorColor)
											]),
										$author$project$Ui$text('Upload failed'));
								default:
									return $author$project$Ui$none;
							}
						}()
						]))
				]));
	}
};
var $author$project$ImageEditor$view = F3($author$project$ImageEditor$view$);
var $author$project$Pages$Guild$guildSettingsView$ = function (model, loggedIn, local, guildId, guild) {
	var owner = $author$project$MembersAndOwner$owner(guild.membersAndOwner);
	var isOwner = _Utils_eq(owner, local.localUser.session.userId);
	var isMobile = $author$project$MyUi$isMobile(model);
	var guildIconEditor = function () {
		var _v2 = loggedIn.guildIconEditor;
		if (!_v2.$) {
			var _v3 = _v2.a;
			var existingGuildId = _v3.a;
			var editor = _v3.b;
			return _Utils_eq(existingGuildId, guildId) ? editor : $author$project$ImageEditor$init;
		} else {
			return $author$project$ImageEditor$init;
		}
	}();
	var editGuildForm = $elm$core$Maybe$withDefault$(
		$author$project$Pages$Guild$editGuildFormInit(guild),
		$lamdera$containers$SeqDict$get$(guildId, loggedIn.editGuildForm));
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$Ui$Font$color($author$project$MyUi$font1)
			]),
		_List_fromArray(
			[
				$author$project$ChannelHeader$channelHeader$(
				isMobile,
				$author$project$Ui$text('Guild settings'),
				$elm$core$Maybe$Nothing),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(16),
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$heightMin(0),
						$author$project$MyUi$scrollable(
						$author$project$MyUi$canScroll$(isMobile, model.drag)),
						$author$project$Ui$paddingWith(
						{bottom: local.localUser.safeAreaInsetBottom + 16, left: 0, right: 0, top: 16})
					]),
				_List_fromArray(
					[
						$author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$(8, 0)
							]),
						_List_fromArray(
							[
								$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$paddingXY$(8, 0),
										$author$project$Ui$Font$bold
									]),
								$author$project$Ui$text('Owner')),
								$author$project$Pages$Guild$memberLabel$(isMobile, local.localUser, owner)
							])),
						isOwner ? $author$project$Pages$Guild$guildMemberTable$(local.localUser, guildId, guild) : $author$project$Ui$none,
						isOwner ? $author$project$Pages$Guild$editGuildNameSection$(guildId, guild, editGuildForm) : $author$project$Ui$none,
						isOwner ? $author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$spacing(8),
								$author$project$Ui$paddingXY$(16, 0)
							]),
						_List_fromArray(
							[
								$author$project$Ui$el$(
								_List_fromArray(
									[$author$project$Ui$Font$bold]),
								$author$project$Ui$text('Guild icon')),
								$author$project$Ui$row$(
								_List_fromArray(
									[
										$author$project$Ui$spacing(12),
										$author$project$Ui$alignLeft
									]),
								_List_fromArray(
									[
										$author$project$GuildIcon$view$(
										$author$project$GuildIcon$Normal($author$project$GuildIcon$NoNotification),
										guild),
										A2(
										$author$project$Ui$map,
										$author$project$Types$GuildIconEditorMsg(guildId),
										$author$project$ImageEditor$view$(
											model.windowSize,
											!_Utils_eq(guild.icon, $elm$core$Maybe$Nothing),
											guildIconEditor))
									]))
							])) : $author$project$Ui$none,
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$(16, 0)
							]),
						$author$project$Pages$Guild$submitButton$(
							$lamdera$program_test$Effect$Browser$Dom$id('guild_createInviteLink'),
							$author$project$Types$PressedCreateInviteLink(guildId),
							'Create invite link')),
						$lamdera$containers$SeqDict$isEmpty(guild.invites) ? $author$project$Ui$none : $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$Font$bold,
								$author$project$Ui$paddingXY$(16, 0)
							]),
						$author$project$Ui$text('Existing invites')),
						$author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$spacing(8),
								$author$project$Ui$paddingXY$(16, 0)
							]),
						$elm$core$List$map$(
							function (_v1) {
								var inviteId = _v1.a;
								var data = _v1.b;
								var url = $author$project$Route$encode(
									$author$project$Route$GuildRoute$(
										guildId,
										$author$project$Route$JoinRoute(inviteId),
										0,
										$elm$core$Maybe$Nothing));
								var showQrCode = _Utils_eq(
									$elm$core$Maybe$Just(inviteId),
									loggedIn.showInviteLinkQrCode);
								var inviteLink = _Utils_ap($author$project$Env$domain, url);
								return $author$project$Ui$column$(
									_List_fromArray(
										[
											$author$project$Ui$spacing(8)
										]),
									_List_fromArray(
										[
											$author$project$Ui$row$(
											_List_fromArray(
												[
													$author$project$Ui$spacing(16)
												]),
											_List_fromArray(
												[
													$author$project$Ui$el$(
													_List_fromArray(
														[
															$author$project$Ui$widthMax(300)
														]),
													$author$project$MyUi$copyBox$(
														$lamdera$program_test$Effect$Browser$Dom$id('guild_inviteLinkCopy'),
														$elm$core$Maybe$Nothing,
														$author$project$Types$PressedCopyText,
														$author$project$Types$FrontendNoOp,
														model,
														inviteLink)),
													$author$project$MyUi$elButton$(
													$lamdera$program_test$Effect$Browser$Dom$id(
														'guild_inviteLinkQrCode_' + $author$project$SecretId$toString(inviteId)),
													$author$project$Types$PressedToggleInviteLinkQrCode(inviteId),
													_List_fromArray(
														[
															$author$project$Ui$Font$color($author$project$MyUi$font2),
															$author$project$Ui$rounded(4),
															$author$project$Ui$border(1),
															$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
															$author$project$Ui$paddingXY$(6, 0),
															$author$project$Ui$width($author$project$Ui$shrink),
															$author$project$Ui$height($author$project$Ui$fill),
															$author$project$Ui$contentCenterY,
															$author$project$Ui$Font$size(14)
														]),
													$author$project$Ui$text(
														showQrCode ? 'Hide QR code' : 'Show QR code')),
													isOwner ? $author$project$MyUi$deleteButton$(
													$lamdera$program_test$Effect$Browser$Dom$id(
														'guild_deleteInviteLink_' + $author$project$SecretId$toString(inviteId)),
													$author$project$Types$PressedDeleteInviteLink$(guildId, inviteId)) : $author$project$Ui$none,
													$ianmackenzie$elm_units$Quantity$lessThan$(
													$ianmackenzie$elm_units$Duration$minutes(5),
													$ianmackenzie$elm_units$Duration$from$(data.createdAt, model.time)) ? $author$project$Ui$text('Created just now!') : $author$project$Ui$none
												])),
											showQrCode ? $author$project$Ui$Lazy$lazy2$(
											$author$project$Pages$Guild$inviteLinkQrCodeView,
											$author$project$Pages$Guild$conversationWidth(model),
											inviteLink) : $author$project$Ui$none
										]));
							},
							A2(
								$elm$core$List$sortBy,
								function (_v0) {
									var data = _v0.b;
									return -$elm$time$Time$posixToMillis(data.createdAt);
								},
								$lamdera$containers$SeqDict$toList(guild.invites)))),
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$(16, 0)
							]),
						$author$project$MyUi$radioColumn$(
							$lamdera$program_test$Effect$Browser$Dom$id('guild_notificationLevel'),
							$author$project$Types$PressedGuildNotificationLevel(guildId),
							$lamdera$containers$SeqSet$member$(guildId, local.localUser.user.notifyOnAllMessages) ? $elm$core$Maybe$Just(0) : $elm$core$Maybe$Just(1),
							$author$project$Ui$text('Guild notifications'),
							_List_fromArray(
								[
									_Utils_Tuple2(1, 'Only when mentioned'),
									_Utils_Tuple2(0, 'On every message')
								]))),
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$(16, 0)
							]),
						$author$project$MuteSettings$view$(
							$author$project$Types$PressedMuteGuild(guildId),
							$author$project$MuteSettings$isGuildSpecificallyMute$(local.localUser.user.muteSettings, guildId))),
						isOwner ? $author$project$Pages$Guild$importChannelSection$(guildId, editGuildForm) : $author$project$Ui$none,
						isOwner ? $author$project$Pages$Guild$deleteGuildSection$(guildId, guild, editGuildForm) : $author$project$Pages$Guild$leaveGuildSection$(guildId, editGuildForm)
					]))
			]));
};
var $author$project$Pages$Guild$guildSettingsView = F5($author$project$Pages$Guild$guildSettingsView$);
var $author$project$Pages$Guild$newChannelFormInit = {description: '', name: '', pressedSubmit: false};
var $author$project$Types$NewChannelFormChanged$ = function (a, b) {
	return {$: 14, a: a, b: b};
};
var $author$project$Types$NewChannelFormChanged = F2($author$project$Types$NewChannelFormChanged$);
var $author$project$Types$PressedSubmitNewChannel$ = function (a, b) {
	return {$: 15, a: a, b: b};
};
var $author$project$Types$PressedSubmitNewChannel = F2($author$project$Types$PressedSubmitNewChannel$);
var $author$project$Pages$Guild$newChannelFormView$ = function (isMobile2, guildId, form) {
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$Font$color($author$project$MyUi$font1),
				$author$project$Ui$alignTop
			]),
		_List_fromArray(
			[
				$author$project$ChannelHeader$channelHeader$(
				isMobile2,
				$author$project$Ui$text('Create new channel'),
				$elm$core$Maybe$Nothing),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(16),
						$author$project$Ui$padding(16)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$map,
						$author$project$Types$NewChannelFormChanged(guildId),
						$author$project$Pages$Guild$channelNameInput(form)),
						A2(
						$author$project$Ui$map,
						$author$project$Types$NewChannelFormChanged(guildId),
						$author$project$Pages$Guild$channelDescriptionInput(form)),
						$author$project$Pages$Guild$submitButton$(
						$lamdera$program_test$Effect$Browser$Dom$id('guild_createChannel'),
						$author$project$Types$PressedSubmitNewChannel$(guildId, form),
						'Create channel')
					]))
			]));
};
var $author$project$Pages$Guild$newChannelFormView = F3($author$project$Pages$Guild$newChannelFormView$);
var $author$project$ChannelHeader$privateChatWithInThread$ = function (isMobile, route, showSettingsRedDot, currentTab, otherUserId, local, name, threadName) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$Font$color($author$project$MyUi$font1),
				$author$project$Ui$spacing(6),
				$author$project$Ui$clipWithEllipsis,
				$author$project$Ui$height($author$project$Ui$fill)
			]),
		_List_fromArray(
			[
				$author$project$ChannelHeader$channelHeaderTab$(
				isMobile,
				$lamdera$program_test$Effect$Browser$Dom$id('guild_openDescription'),
				$author$project$UserSession$ChannelHeaderTab_ChannelDescription,
				currentTab,
				isMobile ? $author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$Font$color($author$project$MyUi$font1)
						]),
					$author$project$Ui$text(name + (' / ' + threadName))) : $author$project$Ui$row$(
					_List_fromArray(
						[
							$author$project$Ui$spacing(5)
						]),
					_List_fromArray(
						[
							$author$project$Ui$text('Chat with '),
							$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$Font$color($author$project$MyUi$font1)
								]),
							$author$project$Ui$text(name + (' / ' + threadName)))
						]))),
				$author$project$ChannelHeader$dmHeaderButtons$(isMobile, route, showSettingsRedDot, currentTab, otherUserId, local)
			]));
};
var $author$project$ChannelHeader$privateChatWithInThread = F8($author$project$ChannelHeader$privateChatWithInThread$);
var $author$project$ChannelHeader$privateChatWithYourselfInThread$ = function (isMobile, route, showSettingsRedDot, currentTab, local, threadName) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$Font$color($author$project$MyUi$font1),
				$author$project$Ui$spacing(6),
				$author$project$Ui$clipWithEllipsis,
				$author$project$Ui$height($author$project$Ui$fill)
			]),
		_List_fromArray(
			[
				$author$project$ChannelHeader$channelHeaderTab$(
				isMobile,
				$lamdera$program_test$Effect$Browser$Dom$id('guild_openDescription'),
				$author$project$UserSession$ChannelHeaderTab_ChannelDescription,
				currentTab,
				$author$project$Ui$text('Solo chat / ' + threadName)),
				$author$project$ChannelHeader$dmHeaderButtons$(isMobile, route, showSettingsRedDot, currentTab, local.localUser.session.userId, local)
			]));
};
var $author$project$ChannelHeader$privateChatWithYourselfInThread = F6($author$project$ChannelHeader$privateChatWithYourselfInThread$);
var $author$project$ChannelHeader$thread$ = function (isMobile, name, threadName, guildOrDmIdNoThread, local, loggedIn, model) {
	return $author$project$ChannelHeader$channelHeader$(
		isMobile,
		function () {
			if (guildOrDmIdNoThread.$ === 1) {
				var otherUserId = guildOrDmIdNoThread.a.otherUserId;
				return _Utils_eq(otherUserId, local.localUser.session.userId) ? $author$project$ChannelHeader$privateChatWithYourselfInThread$(
					isMobile,
					model.route,
					$author$project$ChannelHeader$showDmSettingsRedDot$(otherUserId, local, loggedIn),
					$author$project$Route$toChannelHeaderTab(model.route),
					local,
					threadName) : $author$project$ChannelHeader$privateChatWithInThread$(
					isMobile,
					model.route,
					$author$project$ChannelHeader$showDmSettingsRedDot$(otherUserId, local, loggedIn),
					$author$project$Route$toChannelHeaderTab(model.route),
					otherUserId,
					local,
					name,
					threadName);
			} else {
				return $author$project$Ui$row$(
					_List_fromArray(
						[
							$author$project$Ui$Font$color($author$project$MyUi$font1),
							$author$project$Ui$spacing(2),
							$author$project$Ui$clipWithEllipsis,
							$author$project$Ui$height($author$project$Ui$fill)
						]),
					_List_fromArray(
						[
							$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$MyUi$noShrinking,
									$author$project$Ui$width($author$project$Ui$shrink)
								]),
							$author$project$Ui$html($author$project$Icons$hashtag)),
							$author$project$Ui$text(name + (' / ' + threadName)),
							$author$project$Ui$row$(
							_List_fromArray(
								[
									$author$project$MyUi$noShrinking,
									$author$project$Ui$width($author$project$Ui$shrink),
									$author$project$Ui$alignRight,
									$author$project$Ui$height($author$project$Ui$fill)
								]),
							_List_fromArray(
								[
									$author$project$ChannelHeader$drawingTab$(
									isMobile,
									$author$project$Route$toChannelHeaderTab(model.route),
									false),
									$elm$core$Maybe$withDefault$(
									$author$project$Ui$none,
									$author$project$ChannelHeader$channelSettingsTab$(isMobile, model.route))
								]))
						]));
			}
		}(),
		$author$project$ChannelHeader$tabBodyView$(isMobile, local, loggedIn, model));
};
var $author$project$ChannelHeader$thread = F7($author$project$ChannelHeader$thread$);
var $author$project$Pages$Guild$threadMessageView$ = function (time, isMobile, containerWidth, revealedSpoilers, highlight, isHovered, isBeingEdited, allUsers, channels, currentUserId, localUser, maybeRepliedTo2, messageId, message) {
	var decrypted = localUser.decryptedMessages;
	switch (message.$) {
		case 0:
			var message2 = message.a;
			return $author$project$Pages$Guild$threadMessageContainer$(
				containerWidth,
				function () {
					if (!highlight) {
						return $lamdera$containers$SeqSet$member$(
							currentUserId,
							$author$project$RichText$mentionsUser(message2.content.content)) ? 2 : highlight;
					} else {
						return highlight;
					}
				}(),
				messageId,
				_Utils_eq(currentUserId, message2.createdBy),
				currentUserId,
				localUser.user,
				message2.reactions,
				localUser.user.availableCustomEmojis,
				localUser.customEmojis,
				localUser.emojiData,
				allUsers,
				isHovered,
				$author$project$Pages$Guild$userTextMessageContent$(
					time,
					$lamdera$program_test$Effect$Browser$Dom$id('threadSpoiler'),
					containerWidth,
					isBeingEdited,
					isMobile,
					maybeRepliedTo2,
					localUser,
					revealedSpoilers,
					allUsers,
					channels,
					$author$project$User$userColor(localUser),
					isHovered,
					messageId,
					message2.content,
					false,
					message2));
		case 1:
			var message2 = message.a;
			var _v2 = $lamdera$containers$SeqDict$get$(
				$author$project$Encryption$hash(message2.content),
				decrypted);
			if (!_v2.$) {
				var result = _v2.a;
				return $author$project$Pages$Guild$threadMessageContainer$(
					containerWidth,
					highlight,
					messageId,
					_Utils_eq(currentUserId, message2.createdBy),
					currentUserId,
					localUser.user,
					message2.reactions,
					localUser.user.availableCustomEmojis,
					localUser.customEmojis,
					localUser.emojiData,
					allUsers,
					isHovered,
					$author$project$Pages$Guild$userTextMessageContent$(
						time,
						$lamdera$program_test$Effect$Browser$Dom$id('threadSpoiler'),
						containerWidth,
						isBeingEdited,
						isMobile,
						maybeRepliedTo2,
						localUser,
						revealedSpoilers,
						allUsers,
						channels,
						$author$project$User$userColor(localUser),
						isHovered,
						messageId,
						$elm$core$Result$withDefault$(
							{attachedFiles: $lamdera$containers$SeqDict$empty, content: $author$project$RichText$failedToDecryptMessage, embeds: $elm$core$Array$empty},
							result),
						true,
						message2));
			} else {
				return $author$project$Ui$none;
			}
		case 2:
			var joinedAt = message.a;
			var userId = message.b;
			var reactions = message.c;
			var drawings = message.d;
			return $author$project$Pages$Guild$threadMessageContainer$(
				containerWidth,
				highlight,
				messageId,
				false,
				currentUserId,
				localUser.user,
				reactions,
				localUser.user.availableCustomEmojis,
				localUser.customEmojis,
				localUser.emojiData,
				allUsers,
				isHovered,
				$author$project$Ui$row$(
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Guild$userJoinedContent$(userId, allUsers),
							$author$project$Pages$Guild$messageTimestamp$(
							$author$project$User$userColor(localUser),
							drawings,
							_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
							messageId,
							joinedAt,
							localUser.timezone)
						])));
		case 3:
			var createdAt = message.a;
			return $author$project$Pages$Guild$threadMessageContainer$(
				containerWidth,
				highlight,
				messageId,
				false,
				currentUserId,
				localUser.user,
				$lamdera$containers$SeqDict$empty,
				localUser.user.availableCustomEmojis,
				localUser.customEmojis,
				localUser.emojiData,
				allUsers,
				isHovered,
				$author$project$Pages$Guild$deletedMessageContent$(
					messageId,
					_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
					createdAt,
					localUser.timezone));
		case 4:
			var callStartedData = message.a;
			return $author$project$Pages$Guild$threadMessageContainer$(
				containerWidth,
				highlight,
				messageId,
				false,
				currentUserId,
				localUser.user,
				callStartedData.reactions,
				localUser.user.availableCustomEmojis,
				localUser.customEmojis,
				localUser.emojiData,
				allUsers,
				isHovered,
				$author$project$Ui$row$(
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$row$(
							_List_fromArray(
								[
									$author$project$Ui$spacing(8),
									$author$project$Ui$contentCenterY
								]),
							_List_fromArray(
								[
									$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$width($author$project$Ui$shrink)
										]),
									$author$project$Pages$Guild$callStartedCard$(
										$author$project$User$userColor(localUser),
										_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
										messageId,
										callStartedData.cardDrawings,
										callStartedData.startedBy,
										callStartedData.startedAt,
										callStartedData.endedAt,
										callStartedData.recordings,
										allUsers)),
									$author$project$Pages$Guild$callRecordingsButton$(isMobile, localUser.timezone, messageId, callStartedData.recordings, allUsers)
								])),
							$author$project$Pages$Guild$messageTimestamp$(
							$author$project$User$userColor(localUser),
							callStartedData.timestampDrawings,
							_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
							messageId,
							callStartedData.startedAt,
							localUser.timezone)
						])));
		default:
			var gameStarted = message.a;
			return $author$project$Pages$Guild$threadMessageContainer$(
				containerWidth,
				highlight,
				messageId,
				false,
				currentUserId,
				localUser.user,
				gameStarted.reactions,
				localUser.user.availableCustomEmojis,
				localUser.customEmojis,
				localUser.emojiData,
				allUsers,
				isHovered,
				$author$project$Ui$row$(
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Guild$goMatchStartedCard$(
							$author$project$User$userColor(localUser),
							_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
							gameStarted.cardDrawings,
							messageId,
							gameStarted.startedBy,
							allUsers,
							gameStarted.gameType),
							$author$project$Pages$Guild$messageTimestamp$(
							$author$project$User$userColor(localUser),
							gameStarted.timestampDrawings,
							_Utils_eq(isHovered, $author$project$Pages$Guild$IsHoveredWhileSelectingAnchor),
							messageId,
							gameStarted.startedAt,
							localUser.timezone)
						])));
	}
};
var $author$project$Pages$Guild$threadMessageView = function (time) {
	return function (isMobile) {
		return function (containerWidth) {
			return function (revealedSpoilers) {
				return function (highlight) {
					return function (isHovered) {
						return function (isBeingEdited) {
							return function (allUsers) {
								return function (channels) {
									return function (currentUserId) {
										return function (localUser) {
											return function (maybeRepliedTo2) {
												return function (messageId) {
													return function (message) {
														return $author$project$Pages$Guild$threadMessageView$(time, isMobile, containerWidth, revealedSpoilers, highlight, isHovered, isBeingEdited, allUsers, channels, currentUserId, localUser, maybeRepliedTo2, messageId, message);
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Guild$threadMessageViewLazy$ = function (data, revealedSpoilers, localUser, messageIndex, message) {
	var _v0 = $author$project$Pages$Guild$decodeMessageView(data);
	var time = _v0.time;
	var isMobile = _v0.isMobile;
	var isHovered = _v0.isHovered;
	var highlight = _v0.highlight;
	var isEditing = _v0.isEditing;
	var containerWidth = _v0.containerWidth;
	return $author$project$Pages$Guild$threadMessageView$(
		time,
		isMobile,
		containerWidth,
		revealedSpoilers,
		highlight,
		isHovered,
		isEditing,
		$author$project$User$allUsers(localUser),
		$lamdera$containers$SeqDict$empty,
		localUser.session.userId,
		localUser,
		$elm$core$Maybe$Nothing,
		$author$project$Id$fromInt(messageIndex),
		message);
};
var $author$project$Pages$Guild$threadMessageViewLazy = F5($author$project$Pages$Guild$threadMessageViewLazy$);
var $author$project$Pages$Guild$threadConversationViewHelper$ = function (lastViewedIndex, guildOrDmIdNoThread, threadId, maybeUrlMessageId, thread, loggedIn, local, model) {
	var revealedSpoilers = $author$project$Pages$Guild$revealedThreadSpoilers$(
		$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
		threadId,
		loggedIn);
	var othersEditing = $lamdera$containers$SeqSet$fromList(
		$elm$core$List$filterMap$(
			function (a) {
				var _v7 = a.threadRoute;
				if (_v7.$ === 1) {
					var typingThreadId = _v7.a;
					var maybeMessageId = _v7.b;
					return (_Utils_eq(typingThreadId, threadId) && $ianmackenzie$elm_units$Quantity$lessThan$(
						$ianmackenzie$elm_units$Duration$seconds(3),
						$ianmackenzie$elm_units$Duration$from$(a.time, model.time))) ? maybeMessageId : $elm$core$Maybe$Nothing;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			$lamdera$containers$SeqDict$values(
				$lamdera$containers$SeqDict$remove$(
					local.localUser.session.userId,
					$author$project$LocalState$typingIn$(guildOrDmIdNoThread, local)))));
	var isSelectingAnchor = $author$project$Pages$Guild$drawingIsSelectingAnchor$(loggedIn, model);
	var isMobile = $author$project$MyUi$isMobile(model);
	var guildOrDmId = _Utils_Tuple2(
		$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
		$author$project$Id$ViewThread(threadId));
	var maybeEditing = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.editMessage);
	var replyToIndex = $elm$core$Maybe$map$(
		$author$project$Id$changeType,
		$elm$core$Maybe$andThen$(
			$author$project$Message$replyToMaybe,
			$lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.replyTo)));
	var containerWidth = $author$project$Pages$Guild$conversationWidth(model);
	var channels = $author$project$LocalState$channelMentions$(guildOrDmIdNoThread, local);
	return $author$project$Pages$Guild$prependUnreadDivider$(
		lastViewedIndex,
		thread.visibleMessages.oldest,
		$author$project$MessageArray$foldr$(
			F3(
				function (messageId, maybeMessage, _v0) {
					var maybeLastDate = _v0.a;
					var list = _v0.b;
					var index = $author$project$Id$toInt(messageId);
					if (!maybeMessage.$) {
						var message = maybeMessage.a;
						var threadRoute2 = $author$project$Id$ViewThreadWithMessage$(threadId, messageId);
						var otherUserIsEditing = $lamdera$containers$SeqSet$member$(messageId, othersEditing);
						var messageHover2 = $author$project$Pages$Guild$messageHover$(
							$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
							threadRoute2,
							loggedIn,
							model);
						var maybeRepliedTo2 = $author$project$Pages$Guild$maybeRepliedTo$(message, thread);
						var isEditing = function () {
							if (!maybeEditing.$) {
								var editing = maybeEditing.a;
								return _Utils_eq(
									editing.messageIndex,
									$author$project$Id$changeType(messageId)) ? $elm$core$Maybe$Just(editing) : $elm$core$Maybe$Nothing;
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}();
						var highlight = _Utils_eq(
							maybeUrlMessageId,
							$elm$core$Maybe$Just(messageId)) ? 3 : (_Utils_eq(
							replyToIndex,
							$elm$core$Maybe$Just(messageId)) ? 1 : 0);
						var date = $justinmimbs$date$Date$fromPosix$(
							local.localUser.timezone,
							$author$project$Message$createdAt(message));
						return _Utils_Tuple2(
							$elm$core$Maybe$Just(date),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									$elm$core$String$fromInt(index),
									function () {
										if (!isEditing.$) {
											var editing = isEditing.a;
											if ($author$project$MyUi$isMobile(model)) {
												return A2(
													$author$project$Ui$map,
													A2(
														$author$project$Types$MessageViewMsg,
														$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
														threadRoute2),
													$author$project$Pages$Guild$threadMessageView$(
														model.time,
														isMobile,
														containerWidth,
														revealedSpoilers,
														highlight,
														messageHover2,
														otherUserIsEditing,
														$author$project$User$allUsers(local.localUser),
														channels,
														local.localUser.session.userId,
														local.localUser,
														maybeRepliedTo2,
														messageId,
														message));
											} else {
												var allUsers = $author$project$User$allUsers(local.localUser);
												var editRichText = function () {
													var _v3 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(editing.text);
													if (!_v3.$) {
														var text = _v3.a;
														return $elm$core$Maybe$Just(
															$author$project$RichText$fromNonemptyString$(local.localUser.timezone, allUsers, channels, text));
													} else {
														return $elm$core$Maybe$Nothing;
													}
												}();
												return $author$project$Pages$Guild$threadMessageEditingView$(
													containerWidth,
													model.time,
													isMobile,
													guildOrDmId,
													threadId,
													$author$project$Id$fromInt(index),
													message,
													maybeRepliedTo2,
													revealedSpoilers,
													$author$project$RichText$maxLength - $elm$core$String$length(editing.text),
													editing,
													editRichText,
													loggedIn,
													local.localUser.decryptedMessages,
													local.localUser.session.userId,
													allUsers,
													channels,
													local);
											}
										} else {
											var _v4 = _Utils_Tuple2(
												maybeRepliedTo2,
												$author$project$Message$mentionsChannel(message));
											if ((_v4.a.$ === 1) && (!_v4.b)) {
												var _v5 = _v4.a;
												return A2(
													$author$project$Ui$map,
													A2(
														$author$project$Types$MessageViewMsg,
														$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
														threadRoute2),
													$author$project$Ui$Lazy$lazy5$(
														$author$project$Pages$Guild$threadMessageViewLazy,
														$author$project$Pages$Guild$encodeMessageView$(isMobile, messageHover2, containerWidth, otherUserIsEditing, highlight, model.time),
														revealedSpoilers,
														local.localUser,
														index,
														message));
											} else {
												return A2(
													$author$project$Ui$map,
													A2(
														$author$project$Types$MessageViewMsg,
														$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
														threadRoute2),
													$author$project$Pages$Guild$threadMessageView$(
														model.time,
														isMobile,
														containerWidth,
														revealedSpoilers,
														highlight,
														messageHover2,
														otherUserIsEditing,
														$author$project$User$allUsers(local.localUser),
														channels,
														local.localUser.session.userId,
														local.localUser,
														maybeRepliedTo2,
														messageId,
														message));
											}
										}
									}()),
								_Utils_ap(
									$elm$core$List$map$(
										$elm$core$Tuple$mapSecond(
											$author$project$Ui$map(
												A2(
													$author$project$Types$MessageViewMsg,
													$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
													threadRoute2))),
										$author$project$Pages$Guild$newMessageLine$(
											$author$project$User$userColor(local.localUser),
											isSelectingAnchor,
											thread.dateDividerDrawings,
											maybeLastDate,
											date,
											lastViewedIndex,
											index,
											messageId)),
									list)));
					} else {
						return _Utils_Tuple2(
							maybeLastDate,
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									$elm$core$String$fromInt(index),
									$author$project$Pages$Guild$unloadedMessageView(index)),
								list));
					}
				}),
			_Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil),
			$author$project$VisibleMessages$slice(thread)).b);
};
var $author$project$Pages$Guild$threadConversationViewHelper = F8($author$project$Pages$Guild$threadConversationViewHelper$);
var $author$project$Pages$Guild$threadStarterMessage$ = function (isMobile, normalGuildOrDmIdNoThread, threadMessageIndex, channel, loggedIn, local, model) {
	var threadRoute = $author$project$Id$NoThreadWithMessage(threadMessageIndex);
	var revealedSpoilers = $author$project$Pages$Guild$revealedChannelSpoilers$(
		$author$project$Id$GuildOrDmId(normalGuildOrDmIdNoThread),
		loggedIn);
	var guildOrDmIdNoThread = $author$project$Id$GuildOrDmId(normalGuildOrDmIdNoThread);
	var guildOrDmId = _Utils_Tuple2(guildOrDmIdNoThread, $author$project$Id$NoThread);
	var containerWidth = $author$project$Pages$Guild$conversationWidth(model);
	var channels = $author$project$LocalState$guildChannels$(normalGuildOrDmIdNoThread, local);
	var _v0 = $author$project$MessageArray$get$(threadMessageIndex, channel.messages);
	if (!_v0.$) {
		var message = _v0.a;
		var _v1 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.editMessage);
		if (!_v1.$) {
			var edit = _v1.a;
			if (_Utils_eq(edit.messageIndex, threadMessageIndex)) {
				var charsLeft = $author$project$RichText$maxLength - $elm$core$String$length(edit.text);
				var channelMentions = $author$project$LocalState$guildChannelMentions$(local.localUser, channels);
				var allUsers = $author$project$User$allUsers(local.localUser);
				var editRichText = function () {
					var _v2 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(edit.text);
					if (!_v2.$) {
						var nonempty = _v2.a;
						return $elm$core$Maybe$Just(
							$author$project$RichText$fromNonemptyString$(local.localUser.timezone, allUsers, channelMentions, nonempty));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				return $author$project$Pages$Guild$messageEditingView$(
					containerWidth,
					model.time,
					isMobile,
					guildOrDmId,
					$author$project$Id$NoThreadWithMessage(threadMessageIndex),
					message,
					$elm$core$Maybe$Nothing,
					$elm$core$Maybe$Nothing,
					$lamdera$containers$SeqDict$empty,
					charsLeft,
					edit,
					editRichText,
					loggedIn,
					local.localUser.decryptedMessages,
					local.localUser.session.userId,
					allUsers,
					channelMentions,
					local);
			} else {
				return A2(
					$author$project$Ui$map,
					A2($author$project$Types$MessageViewMsg, guildOrDmIdNoThread, threadRoute),
					$author$project$Pages$Guild$messageView$(
						model.time,
						isMobile,
						$author$project$Pages$Guild$conversationWidth(model),
						true,
						revealedSpoilers,
						0,
						$author$project$Pages$Guild$messageHover$(guildOrDmIdNoThread, threadRoute, loggedIn, model),
						false,
						local.localUser.session.userId,
						$author$project$User$allUsers(local.localUser),
						channels,
						local.localUser,
						$elm$core$Maybe$Nothing,
						$elm$core$Maybe$Nothing,
						threadMessageIndex,
						message));
			}
		} else {
			return A2(
				$author$project$Ui$map,
				A2($author$project$Types$MessageViewMsg, guildOrDmIdNoThread, threadRoute),
				$author$project$Pages$Guild$messageView$(
					model.time,
					isMobile,
					$author$project$Pages$Guild$conversationWidth(model),
					true,
					revealedSpoilers,
					0,
					$author$project$Pages$Guild$messageHover$(guildOrDmIdNoThread, threadRoute, loggedIn, model),
					false,
					local.localUser.session.userId,
					$author$project$User$allUsers(local.localUser),
					channels,
					local.localUser,
					$elm$core$Maybe$Nothing,
					$elm$core$Maybe$Nothing,
					threadMessageIndex,
					message));
		}
	} else {
		return $author$project$Ui$none;
	}
};
var $author$project$Pages$Guild$threadStarterMessage = F7($author$project$Pages$Guild$threadStarterMessage$);
var $author$project$Pages$Guild$threadConversationView$ = function (lastViewedIndex, guildOrDmIdNoThread, maybeUrlMessageId, threadId, loggedIn, model, local, missingPrivateKey, name, threadName, channel) {
	var isMobile = $author$project$MyUi$isMobile(model);
	var guildOrDmId = _Utils_Tuple2(
		$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
		$author$project$Id$ViewThread(threadId));
	var replyTo = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.replyTo);
	var draft = function () {
		var _v8 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.drafts);
		if (!_v8.$) {
			var text = _v8.a;
			return $MartinSStewart$elm_nonempty_string$String$Nonempty$toString(text);
		} else {
			return '';
		}
	}();
	var channels = $author$project$LocalState$channelMentions$(guildOrDmIdNoThread, local);
	var allUsers = $author$project$User$allUsers(local.localUser);
	var draftRichText = function () {
		var _v7 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.drafts);
		if (!_v7.$) {
			var text = _v7.a;
			return $elm$core$Maybe$Just(
				$author$project$RichText$fromNonemptyString$(local.localUser.timezone, allUsers, channels, text));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$Ui$heightMin(0)
			]),
		_List_fromArray(
			[
				$author$project$ChannelHeader$thread$(isMobile, name, threadName, guildOrDmIdNoThread, local, loggedIn, model),
				$author$project$Ui$el$(
				_Utils_ap(
					_List_fromArray(
						[
							$author$project$Pages$Guild$emojiSelector$(isMobile, local.localUser.user.availableCustomEmojis, local.localUser.user.availableStickers, local, loggedIn, model),
							$author$project$Ui$heightMin(0),
							$author$project$Ui$height($author$project$Ui$fill)
						]),
					$author$project$Pages$Guild$drawingModeAttributes$(model.route, loggedIn.drawingMode)),
				$author$project$Ui$Keyed$column$(
					_Utils_ap(
						_List_fromArray(
							[
								$author$project$Ui$height($author$project$Ui$fill),
								$author$project$Ui$width($author$project$Ui$fill),
								$author$project$Ui$paddingWith(
								{bottom: 16, left: 0, right: 0, top: 200}),
								$author$project$MyUi$scrollable(
								$author$project$MyUi$canScroll$(
									$author$project$MyUi$isMobile(model),
									model.drag)),
								$author$project$MyUi$htmlStyle$('overflow-wrap', 'break-word'),
								$author$project$Ui$id(
								$lamdera$program_test$Effect$Browser$Dom$idToString($author$project$Pages$Guild$conversationContainerId)),
								$author$project$Ui$Events$on$(
								'scroll',
								$author$project$Scroll$decodeScrollToBottom$(
									A2(
										$author$project$Types$UserScrolled,
										$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
										$author$project$Id$ViewThread(threadId)),
									loggedIn.channelScrollPosition)),
								$author$project$Ui$heightMin(0),
								$author$project$MyUi$bounceScroll(isMobile),
								$author$project$MyUi$htmlStyle$('background-image', 'url(/cacheable/grid1.png)')
							]),
						$author$project$Pages$Guild$drawingZoomAttributes$(model.route, loggedIn.drawingMode)),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'a',
							$author$project$Ui$column$(
								_List_fromArray(
									[$author$project$Ui$alignBottom]),
								$author$project$VisibleMessages$startIsVisible(channel.visibleMessages) ? _List_fromArray(
									[
										$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$Font$color($author$project$MyUi$font2),
												$author$project$Ui$paddingXY$(8, 4),
												$author$project$Ui$alignBottom,
												$author$project$Ui$Font$size(20)
											]),
										$author$project$Ui$text($author$project$Pages$Guild$startOfThreadText)),
										function () {
										if (!guildOrDmIdNoThread.$) {
											var channelId = guildOrDmIdNoThread.a.channelId;
											var guildId = guildOrDmIdNoThread.a.guildId;
											var _v1 = $author$project$LocalState$getGuildAndChannel$(
												{channelId: channelId, guildId: guildId},
												local);
											if (!_v1.$) {
												var _v2 = _v1.a;
												var channel2 = _v2.b;
												return $author$project$Pages$Guild$threadStarterMessage$(isMobile, guildOrDmIdNoThread, threadId, channel2, loggedIn, local, model);
											} else {
												return $author$project$Ui$none;
											}
										} else {
											var otherUserId = guildOrDmIdNoThread.a.otherUserId;
											var _v3 = $lamdera$containers$SeqDict$get$(otherUserId, local.dmChannels);
											if (!_v3.$) {
												var dmChannel2 = _v3.a;
												return $author$project$Pages$Guild$threadStarterMessage$(isMobile, guildOrDmIdNoThread, threadId, dmChannel2, loggedIn, local, model);
											} else {
												return $author$project$Ui$none;
											}
										}
									}()
									]) : _List_Nil)),
						$author$project$Pages$Guild$threadConversationViewHelper$(lastViewedIndex, guildOrDmIdNoThread, threadId, maybeUrlMessageId, channel, loggedIn, local, model)))),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$paddingXY$(2, 0),
						$author$project$Ui$heightMin(0),
						$author$project$MyUi$noShrinking,
						function () {
						var _v4 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.filesToUpload);
						if (!_v4.$) {
							var filesToUpload2 = _v4.a;
							return $author$project$Ui$inFront(
								$author$project$Pages$Guild$fileUploadPreview$(
									$author$project$Types$PressedDeleteAttachedFile(guildOrDmId),
									$author$project$Types$PressedViewAttachedFileInfo(guildOrDmId),
									$elm$core$Maybe$Just(
										$author$project$Types$PressedToggleAttachedFileSpoiler(guildOrDmId)),
									draftRichText,
									filesToUpload2));
						} else {
							return $author$project$Ui$noAttr;
						}
					}()
					]),
				_List_fromArray(
					[
						$author$project$Pages$Guild$newMessagesView$(model, loggedIn, channel),
						$author$project$Pages$Guild$replyToHeader$(isMobile, guildOrDmId, replyTo, allUsers, channel),
						A2(
						$author$project$Ui$map,
						A2(
							$author$project$Types$MessageInputMsg,
							$author$project$Id$GuildOrDmId(guildOrDmIdNoThread),
							$author$project$Id$ViewThread(threadId)),
						$author$project$MessageInput$view$(
							$lamdera$program_test$Effect$Browser$Dom$id('messageMenu_channelInput'),
							_Utils_eq(replyTo, $elm$core$Maybe$Nothing),
							$author$project$MyUi$isMobile(model),
							$author$project$Pages$Guild$channelTextInputId,
							missingPrivateKey ? $author$project$Pages$Guild$missingPrivateKeyPlaceholder : $author$project$MessageInput$textPlaceholder(
								function () {
									if (!guildOrDmIdNoThread.$) {
										return 'Write a message in this thread';
									} else {
										return 'Write a message in this thread';
									}
								}()),
							$author$project$RichText$maxLength - $elm$core$String$length(draft),
							draft,
							draftRichText,
							function () {
								var _v6 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.filesToUpload);
								if (!_v6.$) {
									var attachedFiles = _v6.a;
									return $author$project$NonemptyDict$toSeqDict(attachedFiles);
								} else {
									return $lamdera$containers$SeqDict$empty;
								}
							}(),
							local.localUser,
							loggedIn,
							$author$project$User$allUsers(local.localUser),
							channels)),
						$author$project$Pages$Guild$peopleAreTypingView$(
						allUsers,
						$author$project$Id$ViewThread(threadId),
						$author$project$LocalState$typingIn$(guildOrDmIdNoThread, local),
						local.localUser.session.userId,
						model)
					]))
			]));
};
var $author$project$Pages$Guild$threadConversationView = function (lastViewedIndex) {
	return function (guildOrDmIdNoThread) {
		return function (maybeUrlMessageId) {
			return function (threadId) {
				return function (loggedIn) {
					return function (model) {
						return function (local) {
							return function (missingPrivateKey) {
								return function (name) {
									return function (threadName) {
										return function (channel) {
											return $author$project$Pages$Guild$threadConversationView$(lastViewedIndex, guildOrDmIdNoThread, maybeUrlMessageId, threadId, loggedIn, model, local, missingPrivateKey, name, threadName, channel);
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Guild$channelView$ = function (channelRoute, guildId, guild, loggedIn, local, model) {
	switch (channelRoute.$) {
		case 0:
			var channelId = channelRoute.a;
			var threadRoute = channelRoute.b;
			var _v1 = $lamdera$containers$SeqDict$get$(channelId, guild.channels);
			if (!_v1.$) {
				var channel = _v1.a;
				if (threadRoute.$ === 1) {
					var threadMessageIndex = threadRoute.a;
					var maybeUrlMessageId = threadRoute.b;
					return $author$project$Pages$Guild$threadConversationView$(
						function () {
							var lastViewed = $elm$core$Maybe$withDefault$(
								$author$project$Id$fromInt(-1),
								$lamdera$containers$SeqDict$get$(
									_Utils_Tuple2(
										$author$project$Id$GuildOrDmId(
											$author$project$Id$GuildOrDmId_Guild(
												{channelId: channelId, guildId: guildId})),
										threadMessageIndex),
									local.localUser.user.lastViewedThreadMessage));
							var _v3 = local.localUser.currentlyViewing;
							if (_v3.$ === 4) {
								var data = _v3.a;
								return _Utils_eq(
									data.id,
									{channelId: channelId, guildId: guildId, threadId: threadMessageIndex}) ? $author$project$Pages$Guild$unreadDividerAt$(lastViewed, data.previouslyLastViewedMessage) : lastViewed;
							} else {
								return lastViewed;
							}
						}(),
						$author$project$Id$GuildOrDmId_Guild(
							{channelId: channelId, guildId: guildId}),
						maybeUrlMessageId,
						threadMessageIndex,
						loggedIn,
						model,
						local,
						false,
						$author$project$ChannelName$toString(channel.name),
						$author$project$Pages$Guild$threadPreviewText$(
							local.localUser.timezone,
							$author$project$User$allUsers(local.localUser),
							$author$project$LocalState$channelMentions$(
								$author$project$Id$GuildOrDmId_Guild(
									{channelId: channelId, guildId: guildId}),
								local),
							threadMessageIndex,
							local.localUser.decryptedMessages,
							channel),
						$elm$core$Maybe$withDefault$(
							$author$project$Thread$frontendInit,
							$lamdera$containers$SeqDict$get$(threadMessageIndex, channel.threads)));
				} else {
					var maybeUrlMessageId = threadRoute.a;
					return $author$project$Pages$Guild$conversationView$(
						function () {
							var lastViewed = $elm$core$Maybe$withDefault$(
								$author$project$Id$fromInt(-1),
								$lamdera$containers$SeqDict$get$(
									$author$project$Id$GuildOrDmId(
										$author$project$Id$GuildOrDmId_Guild(
											{channelId: channelId, guildId: guildId})),
									local.localUser.user.lastViewedMessage));
							var _v4 = local.localUser.currentlyViewing;
							if (_v4.$ === 3) {
								var data = _v4.a;
								return _Utils_eq(
									data.id,
									{channelId: channelId, guildId: guildId}) ? $author$project$Pages$Guild$unreadDividerAt$(lastViewed, data.previouslyLastViewedMessage) : lastViewed;
							} else {
								return lastViewed;
							}
						}(),
						$author$project$Id$GuildOrDmId_Guild(
							{channelId: channelId, guildId: guildId}),
						maybeUrlMessageId,
						loggedIn,
						model,
						local,
						false,
						$author$project$ChannelName$toString(channel.name),
						channel);
				}
			} else {
				return $author$project$Pages$Guild$pageMissing($author$project$Pages$Guild$channelDoesNotExistText);
			}
		case 1:
			return $author$project$Pages$Guild$newChannelFormView$(
				$author$project$MyUi$isMobile(model),
				guildId,
				$elm$core$Maybe$withDefault$(
					$author$project$Pages$Guild$newChannelFormInit,
					$lamdera$containers$SeqDict$get$(guildId, loggedIn.newChannelForm)));
		case 2:
			return $author$project$Pages$Guild$guildSettingsView$(model, loggedIn, local, guildId, guild);
		default:
			return $author$project$Ui$none;
	}
};
var $author$project$Pages$Guild$channelView = F6($author$project$Pages$Guild$channelView$);
var $author$project$Pages$Guild$guildNotFoundText = 'Guild not found';
var $author$project$Pages$Guild$guildView$ = function (model, guildId, channelRoute, loggedIn, local) {
	var _v0 = loggedIn.showFileToUploadInfo;
	if (!_v0.$) {
		var fileData = _v0.a;
		return $author$project$FileStatus$imageInfoView$(local.localUser.safeAreaInsetTop, local.localUser.safeAreaInsetBottom, model.timezone, $author$project$Types$PressedCloseImageInfo, fileData);
	} else {
		var _v1 = $lamdera$containers$SeqDict$get$(guildId, local.guilds);
		if (!_v1.$) {
			var guild = _v1.a;
			if ($author$project$MyUi$isMobile(model)) {
				var showMembers = $author$project$Route$toShowMembersTabVisible$(loggedIn, model.route);
				var canScroll2 = $author$project$MyUi$canScroll$(
					$author$project$MyUi$isMobile(model),
					model.drag);
				return $author$project$Ui$column$(
					_List_fromArray(
						[
							$author$project$Ui$height($author$project$Ui$fill),
							$author$project$Ui$background($author$project$MyUi$background1),
							$author$project$Ui$heightMin(0),
							$author$project$MyUi$unscrollable,
							$author$project$Ui$inFront(
							function () {
								if (!showMembers.a) {
									var _v3 = showMembers.a;
									var isThread = showMembers.b;
									return $author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$height($author$project$Ui$fill),
												$author$project$Ui$background($author$project$MyUi$background3),
												$author$project$Ui$paddingWith(
												{bottom: 0, left: 0, right: 0, top: local.localUser.safeAreaInsetTop}),
												$author$project$Ui$move(
												{
													x: $author$project$Call$memberColumnOffset$(loggedIn.sidebarMode, model),
													y: 0,
													z: 0
												}),
												$author$project$Ui$heightMin(0)
											]),
										$author$project$Pages$Guild$channelSettingsMobile$(canScroll2, local.localUser, guildId, channelRoute, guild, loggedIn.editChannelForm, isThread));
								} else {
									var _v4 = showMembers.a;
									return $author$project$Ui$none;
								}
							}()),
							$author$project$Ui$inFront(
							$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$height($author$project$Ui$fill),
										$author$project$Ui$background($author$project$MyUi$background3),
										$author$project$Ui$paddingWith(
										{bottom: 0, left: 0, right: 0, top: local.localUser.safeAreaInsetTop}),
										$author$project$Ui$move(
										{
											x: $author$project$Call$conversationOffset$(loggedIn.sidebarMode, model),
											y: 0,
											z: 0
										}),
										$author$project$Ui$heightMin(0)
									]),
								$author$project$Pages$Guild$channelView$(channelRoute, guildId, guild, loggedIn, local, model)))
						]),
					_List_fromArray(
						[
							$author$project$Ui$row$(
							_List_fromArray(
								[
									$author$project$Ui$height($author$project$Ui$fill),
									$author$project$Ui$heightMin(0),
									$author$project$MyUi$htmlStyle$('isolation', 'isolate')
								]),
							_List_fromArray(
								[
									$author$project$GuildColumn$guildColumnLazy$(true, model, local),
									$author$project$Pages$Guild$channelColumnLazy$(true, canScroll2, model, local.localUser, local.calls, guildId, guild, channelRoute)
								])),
							$author$project$Ui$Lazy$lazy$($author$project$Pages$Guild$loggedInAsView, local.localUser)
						]));
			} else {
				return $author$project$Ui$row$(
					_List_fromArray(
						[
							$author$project$Ui$height($author$project$Ui$fill),
							$author$project$Ui$background($author$project$MyUi$background1)
						]),
					_List_fromArray(
						[
							$author$project$Ui$column$(
							_List_fromArray(
								[
									$author$project$Ui$height($author$project$Ui$fill),
									$author$project$Ui$width(
									$author$project$Ui$px(
										$author$project$MyUi$channelAndGuildColumnWidth(model.windowSize)))
								]),
							_List_fromArray(
								[
									$author$project$Ui$row$(
									_List_fromArray(
										[
											$author$project$Ui$height($author$project$Ui$fill),
											$author$project$Ui$heightMin(0)
										]),
									_List_fromArray(
										[
											$author$project$GuildColumn$guildColumnLazy$(false, model, local),
											$author$project$Pages$Guild$channelColumnLazy$(false, true, model, local.localUser, local.calls, guildId, guild, channelRoute)
										])),
									$author$project$Ui$Lazy$lazy$($author$project$Pages$Guild$loggedInAsView, local.localUser)
								])),
							$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$height($author$project$Ui$fill),
									$author$project$Ui$paddingWith(
									{bottom: 0, left: 0, right: 0, top: local.localUser.safeAreaInsetTop})
								]),
							$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$height($author$project$Ui$fill),
										$author$project$Ui$background($author$project$MyUi$background3),
										$author$project$Ui$heightMin(0),
										$author$project$Ui$borderColor($author$project$MyUi$border1),
										$author$project$Ui$borderWith(
										{bottom: 0, left: 0, right: 0, top: 1})
									]),
								$author$project$Pages$Guild$channelView$(channelRoute, guildId, guild, loggedIn, local, model))),
							function () {
							var _v5 = $author$project$Route$toShowMembersTabVisible$(loggedIn, model.route);
							if (!_v5.a) {
								var _v6 = _v5.a;
								var isThread = _v5.b;
								return $author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$width($author$project$Ui$shrink),
											$author$project$Ui$height($author$project$Ui$fill),
											$author$project$Ui$paddingWith(
											{bottom: 0, left: 0, right: 0, top: local.localUser.safeAreaInsetTop})
										]),
									$author$project$Pages$Guild$channelSettingsNotMobile$(local.localUser, guildId, channelRoute, guild, loggedIn.editChannelForm, isThread));
							} else {
								var _v7 = _v5.a;
								return $author$project$Ui$none;
							}
						}()
						]));
			}
		} else {
			return $author$project$MyUi$isMobile(model) ? $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$background($author$project$MyUi$background1),
						$author$project$Ui$heightMin(0),
						$author$project$Ui$clip
					]),
				_List_fromArray(
					[
						$author$project$Ui$row$(
						_List_fromArray(
							[
								$author$project$Ui$height($author$project$Ui$fill),
								$author$project$Ui$heightMin(0)
							]),
						_List_fromArray(
							[
								$author$project$GuildColumn$guildColumnLazy$(true, model, local),
								$author$project$Pages$Guild$pageMissingMobile($author$project$Pages$Guild$guildNotFoundText)
							])),
						$author$project$Ui$Lazy$lazy$($author$project$Pages$Guild$loggedInAsView, local.localUser)
					])) : $author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$background($author$project$MyUi$background1)
					]),
				_List_fromArray(
					[
						$author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$height($author$project$Ui$fill),
								$author$project$Ui$width(
								$author$project$Ui$px(
									$author$project$MyUi$channelAndGuildColumnWidth(model.windowSize)))
							]),
						_List_fromArray(
							[
								$author$project$GuildColumn$guildColumnLazy$(false, model, local),
								$author$project$Ui$Lazy$lazy$($author$project$Pages$Guild$loggedInAsView, local.localUser)
							])),
						$author$project$Pages$Guild$pageMissing($author$project$Pages$Guild$guildNotFoundText)
					]));
		}
	}
};
var $author$project$Pages$Guild$guildView = F5($author$project$Pages$Guild$guildView$);
var $author$project$Id$ExportChannel_DiscordDm$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Id$ExportChannel_DiscordDm = F2($author$project$Id$ExportChannel_DiscordDm$);
var $author$project$Pages$Guild$discordDmChannelSettingsMobile$ = function (canScroll2, localUser, currentDiscordUserId, channelId, dmChannel) {
	var members = $mgold$elm_nonempty_list$List$Nonempty$toList(
		$author$project$NonemptyDict$keys(dmChannel.members));
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$height($author$project$Ui$fill)
			]),
		_List_fromArray(
			[
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$contentCenterY,
						$author$project$Ui$borderWith(
						{bottom: 1, left: 0, right: 0, top: 0}),
						$author$project$Ui$borderColor($author$project$MyUi$border2),
						$author$project$Ui$background($author$project$MyUi$background3),
						$author$project$Ui$height(
						$author$project$Ui$px($author$project$MyUi$channelHeaderHeight)),
						$author$project$MyUi$noShrinking
					]),
				_List_fromArray(
					[
						$author$project$ChannelHeader$headerBackButton$(
						$lamdera$program_test$Effect$Browser$Dom$id('guild_memberColumnBack'),
						$author$project$Types$PressedMemberListBack),
						$author$project$Ui$text('Channel settings')
					])),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$background($author$project$MyUi$background2),
						$author$project$Ui$Font$color($author$project$MyUi$font1),
						$author$project$Ui$paddingWith(
						{bottom: localUser.safeAreaInsetBottom + 16, left: 0, right: 0, top: 16}),
						$author$project$MyUi$scrollable(canScroll2),
						$author$project$Ui$heightMin(0)
					]),
				_List_fromArray(
					[
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$(8, 4)
							]),
						$author$project$Pages$Guild$exportChannelButton(
							$author$project$Id$ExportChannel_DiscordDm$(currentDiscordUserId, channelId))),
						$author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$(8, 4)
							]),
						_List_fromArray(
							[
								$author$project$Ui$text(
								'Members (' + ($elm$core$String$fromInt(
									$elm$core$List$length(members)) + ')')),
								$author$project$Ui$column$(
								_List_fromArray(
									[
										$author$project$Ui$height($author$project$Ui$fill)
									]),
								$elm$core$List$map$(
									A3($author$project$Pages$Guild$discordMemberLabel, true, localUser, currentDiscordUserId),
									members))
							]))
					]))
			]));
};
var $author$project$Pages$Guild$discordDmChannelSettingsMobile = F5($author$project$Pages$Guild$discordDmChannelSettingsMobile$);
var $author$project$Pages$Guild$discordDmChannelView$ = function (routeData, loggedIn, local, model) {
	var _v0 = $lamdera$containers$SeqDict$get$(routeData.channelId, local.discordDmChannels);
	if (!_v0.$) {
		var dmChannel = _v0.a;
		return $author$project$Pages$Guild$discordConversationView$(
			function () {
				var lastViewed = $elm$core$Maybe$withDefault$(
					$author$project$Id$fromInt(-1),
					$lamdera$containers$SeqDict$get$(
						$author$project$Id$DiscordGuildOrDmId(
							$author$project$Id$DiscordGuildOrDmId_Dm(
								{channelId: routeData.channelId, currentUserId: routeData.currentDiscordUserId})),
						local.localUser.user.lastViewedMessage));
				var _v1 = local.localUser.currentlyViewing;
				if (_v1.$ === 2) {
					var data = _v1.a;
					return _Utils_eq(
						data.id,
						{channelId: routeData.channelId, currentUserId: routeData.currentDiscordUserId}) ? $author$project$Pages$Guild$unreadDividerAt$(lastViewed, data.previouslyLastViewedMessage) : lastViewed;
				} else {
					return lastViewed;
				}
			}(),
			routeData.currentDiscordUserId,
			$author$project$Id$DiscordGuildOrDmId_Dm(
				{channelId: routeData.channelId, currentUserId: routeData.currentDiscordUserId}),
			routeData.viewingMessage,
			loggedIn,
			model,
			local,
			$elm$core$String$join$(
				', ',
				$elm$core$List$filterMap$(
					function (_v2) {
						var userId = _v2.a;
						var _v3 = $author$project$User$getDiscordUser$(userId, local.localUser);
						if (!_v3.$) {
							var user = _v3.a;
							return $elm$core$Maybe$Just(
								$author$project$PersonName$toString(user.name));
						} else {
							return $elm$core$Maybe$Nothing;
						}
					},
					$lamdera$containers$SeqDict$toList(
						$lamdera$containers$SeqDict$remove$(
							routeData.currentDiscordUserId,
							$author$project$NonemptyDict$toSeqDict(dmChannel.members))))),
			{dateDividerDrawings: dmChannel.dateDividerDrawings, isForum: false, messages: dmChannel.messages, threads: $lamdera$containers$SeqDict$empty, visibleMessages: dmChannel.visibleMessages},
			$lamdera$containers$SeqSet$empty,
			$lamdera$containers$SeqSet$empty);
	} else {
		return $author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$centerY,
					$author$project$Ui$Font$center,
					$author$project$Ui$Font$color($author$project$MyUi$font1),
					$author$project$Ui$Font$size(20)
				]),
			$author$project$Ui$text('DM channel not found'));
	}
};
var $author$project$Pages$Guild$discordDmChannelView = F4($author$project$Pages$Guild$discordDmChannelView$);
var $author$project$Pages$Guild$discordDmMemberColumnNotMobile$ = function (localUser, currentDiscordUserId, channelId, dmChannel) {
	var members = $mgold$elm_nonempty_list$List$Nonempty$toList(
		$author$project$NonemptyDict$keys(dmChannel.members));
	return $author$project$Pages$Guild$memberColumnContainerNotMobile$(
		false,
		_List_fromArray(
			[
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$paddingXY$(8, 4)
					]),
				_List_fromArray(
					[
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$(0, 4)
							]),
						$author$project$Pages$Guild$exportChannelButton(
							$author$project$Id$ExportChannel_DiscordDm$(currentDiscordUserId, channelId))),
						$author$project$Ui$text(
						'Members (' + ($elm$core$String$fromInt(
							$elm$core$List$length(members)) + ')')),
						$author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$height($author$project$Ui$fill)
							]),
						$elm$core$List$map$(
							A3($author$project$Pages$Guild$discordMemberLabel, false, localUser, currentDiscordUserId),
							members))
					]))
			]));
};
var $author$project$Pages$Guild$discordDmMemberColumnNotMobile = F4($author$project$Pages$Guild$discordDmMemberColumnNotMobile$);
var $author$project$Id$ExportChannel_Dm = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Guild$dmMembers$ = function (localUser, otherUserId) {
	return _Utils_eq(localUser.session.userId, otherUserId) ? _List_fromArray(
		[otherUserId]) : _List_fromArray(
		[localUser.session.userId, otherUserId]);
};
var $author$project$Pages$Guild$dmMembers = F2($author$project$Pages$Guild$dmMembers$);
var $author$project$Types$PressedCancelE2eeRequest = function (a) {
	return {$: 118, a: a};
};
var $author$project$Types$PressedDeclineE2eeRequest = function (a) {
	return {$: 120, a: a};
};
var $author$project$Types$PressedDisableE2ee = function (a) {
	return {$: 119, a: a};
};
var $author$project$Types$PressedE2eeRisksAccepted = function (a) {
	return {$: 116, a: a};
};
var $author$project$Types$PressedEnableE2ee = function (a) {
	return {$: 117, a: a};
};
var $author$project$Types$PressedExpandE2eeSection = function (a) {
	return {$: 115, a: a};
};
var $author$project$Types$PressedAddPrivateKeyToAccount = {$: 113};
var $author$project$Pages$Guild$createPrivateKeyButton = $author$project$MyUi$simpleButton$(
	$lamdera$program_test$Effect$Browser$Dom$id('guild_addPrivateKey'),
	$author$project$Types$PressedAddPrivateKeyToAccount,
	$author$project$Ui$text('Create a private key'));
var $author$project$MyUi$datestampNoLineBreaks$ = function (timezone, time) {
	return $author$project$MyUi$monthToString(
		$elm$time$Time$toMonth$(timezone, time)) + ('\u00A0' + ($elm$core$String$fromInt(
		$elm$time$Time$toDay$(timezone, time)) + (',\u00A0' + $elm$core$String$fromInt(
		$elm$time$Time$toYear$(timezone, time)))));
};
var $author$project$MyUi$datestampNoLineBreaks = F2($author$project$MyUi$datestampNoLineBreaks$);
var $author$project$Encryption$declineE2eeText = 'Decline request';
var $author$project$Encryption$disableE2eeText = 'Disable E2EE';
var $author$project$Encryption$e2eeDeclinedText = 'declined your E2EE request';
var $author$project$Encryption$e2eeSectionTitle = 'End-to-end encryption (E2EE)';
var $author$project$Encryption$enableE2eeText = function (disabledBy) {
	if (!disabledBy.$) {
		return 'Re-enable E2EE';
	} else {
		return 'Enable E2EE';
	}
};
var $author$project$Encryption$enterPrivateKeyText = '2. Enter your private key to enable E2EE';
var $author$project$Ui$link = function (uri) {
	return $author$project$Internal$Model2$link(
		{download: $elm$core$Maybe$Nothing, newTab: false, url: uri});
};
var $author$project$Encryption$missingPrivateKeyText = '3. Your private key is needed for this device. Without it you can\u0027t decrypt existing messages or send encrypted messages. Enter your private key here.';
var $author$project$Types$TypedPrivateKey$ = function (a, b) {
	return {$: 121, a: a, b: b};
};
var $author$project$Types$TypedPrivateKey = F2($author$project$Types$TypedPrivateKey$);
var $author$project$Ui$Input$currentPassword$ = function (attrs, pass) {
	return $author$project$Ui$Input$textHelper$(
		{
			autofill: $elm$core$Maybe$Just('current-password'),
			spellchecked: false,
			type_: $author$project$Ui$Input$TextInputNode(
				pass.show ? 'text' : 'password')
		},
		attrs,
		{label: pass.label, onChange: pass.onChange, placeholder: pass.placeholder, text: pass.text});
};
var $author$project$Ui$Input$currentPassword = F2($author$project$Ui$Input$currentPassword$);
var $author$project$Pages$Guild$privateKeyInput$ = function (otherUserId, prompt, keyInput) {
	var keyLabel = $author$project$Ui$Input$label$(
		'guild_e2eePrivateKey',
		_List_fromArray(
			[
				$author$project$MyUi$htmlStyle$('word-wrap', 'anywhere')
			]),
		prompt);
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(4)
			]),
		_List_fromArray(
			[
				keyLabel.element,
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$ChannelHeader$e2eeRequestDot,
						$author$project$Ui$widthMax(300)
					]),
				$author$project$Ui$Input$currentPassword$(
					_List_fromArray(
						[
							$author$project$Ui$background($author$project$MyUi$inputBackground),
							$author$project$Ui$paddingXY$(8, 8),
							$author$project$Ui$borderColor($author$project$MyUi$inputBorder)
						]),
					{
						label: keyLabel.id,
						onChange: $author$project$Types$TypedPrivateKey(otherUserId),
						placeholder: $elm$core$Maybe$Just('Your private key'),
						show: false,
						text: keyInput.text
					})),
				function () {
				var _v0 = keyInput.error;
				if (!_v0.$) {
					var error = _v0.a;
					return $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$Font$color($author$project$MyUi$errorColor)
							]),
						$author$project$Ui$text(error));
				} else {
					return $author$project$Ui$none;
				}
			}()
			]));
};
var $author$project$Pages$Guild$privateKeyInput = F3($author$project$Pages$Guild$privateKeyInput$);
var $author$project$Encryption$requestAcceptedText = 'accepted and E2EE is now enabled. Enter your private key here to decrypted messages';
var $author$project$Encryption$toAcceptE2eeText = ' to accept message encryption.';
var $author$project$Encryption$waitingForE2eeText = '2. Waiting for ';
var $author$project$MyUi$warningHeader = function (text) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8),
				$author$project$Ui$Font$bold,
				$author$project$Ui$Font$color($author$project$MyUi$font3)
			]),
		_List_fromArray(
			[
				$author$project$Ui$html(
				$author$project$Icons$warning(24)),
				$author$project$Ui$text(text)
			]));
};
var $author$project$Encryption$youDeclinedE2eeText = 'You declined the request to to enable E2EE.';
var $author$project$Pages$Guild$e2eeSectionView$ = function (localUser, otherUserId, e2ee, isExpanded, keyInput) {
	var risksLabel = $author$project$Ui$Input$label$(
		'guild_e2eeAcceptRisks',
		_List_fromArray(
			[
				$author$project$Ui$paddingWith(
				{bottom: 0, left: 16, right: 0, top: 0}),
				$author$project$Ui$pointer,
				$author$project$Ui$width($author$project$Ui$shrink)
			]),
		$author$project$Ui$text('I understand and accept the\u00A0risks'));
	var risksAccepted = localUser.user.e2eeRisksAccepted;
	var showsPrivateKeyInput = function () {
		switch (e2ee.$) {
			case 0:
				return false;
			case 1:
				var _v11 = e2ee.a;
				var requestedBy = _v11.a;
				return (!_Utils_eq(requestedBy, localUser.session.userId)) ? (risksAccepted && (!_Utils_eq(localUser.user.publicKey, $elm$core$Maybe$Nothing))) : _Utils_eq(otherUserId, localUser.session.userId);
			case 2:
				return false;
			default:
				return !keyInput.hasKeyOnThisDevice;
		}
	}();
	return $author$project$MyUi$container$(
		16,
		showsPrivateKeyInput ? 8 : 16,
		isExpanded,
		$lamdera$program_test$Effect$Browser$Dom$id('guild_e2eeSection'),
		$author$project$Types$PressedExpandE2eeSection(otherUserId),
		$author$project$MyUi$background2,
		true,
		$author$project$Encryption$e2eeSectionTitle,
		_List_fromArray(
			[
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$paddingWith(
						{bottom: 0, left: 8, right: 8, top: 8}),
						$author$project$Ui$spacing(16)
					]),
				_List_fromArray(
					[
						function () {
						switch (e2ee.$) {
							case 1:
								var _v1 = e2ee.a;
								var requestedBy = _v1.a;
								return _Utils_eq(requestedBy, localUser.session.userId) ? $author$project$Ui$none : $author$project$Ui$column$(
									_List_fromArray(
										[
											$author$project$Ui$spacing(16)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Prose$paragraph$(
											_List_fromArray(
												[
													$author$project$MyUi$htmlStyle$('word-wrap', 'anywhere'),
													$author$project$Ui$paddingXY$(0, 4)
												]),
											_List_fromArray(
												[
													$author$project$Ui$el$(
													_List_fromArray(
														[$author$project$Ui$Font$bold]),
													$author$project$Ui$text(
														$author$project$User$toStringAlt$(otherUserId, localUser))),
													$author$project$Ui$text(' would like to enable E2EE. You can either:')
												])),
											$author$project$MyUi$simpleButton$(
											$lamdera$program_test$Effect$Browser$Dom$id('guild_declineE2ee'),
											$author$project$Types$PressedDeclineE2eeRequest(otherUserId),
											$author$project$Ui$text($author$project$Encryption$declineE2eeText)),
											$author$project$Ui$text('Or follow the instructions below to set it up.'),
											$author$project$Ui$el$(
											_List_fromArray(
												[
													$author$project$Ui$height(
													$author$project$Ui$px(1)),
													$author$project$Ui$background($author$project$MyUi$font1)
												]),
											$author$project$Ui$none)
										]));
							case 0:
								return $author$project$Ui$none;
							case 2:
								return $author$project$Ui$none;
							default:
								return $author$project$Ui$none;
						}
					}(),
						$author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$attrIf$(
								risksAccepted,
								$author$project$Ui$opacity(0.5)),
								$author$project$Ui$spacing(8)
							]),
						_List_fromArray(
							[
								$author$project$MyUi$warningHeader('Before you enable E2EE:'),
								$author$project$Ui$text('You\u0027ll get a private key that you need to store in a password manager. If you lose it, you\u0027ll permanently lose access to all your encrypted messages.'),
								$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$Font$color($author$project$MyUi$textLinkColorOnDarkBackground),
										$author$project$Ui$link(
										$author$project$Route$encode(
											$author$project$Route$DmRoute(
												{
													channelId: $author$project$DmChannelId$fromUserIds$(otherUserId, localUser.session.userId),
													channelsVisible: 1,
													overlay: $elm$core$Maybe$Just(0),
													tab: $elm$core$Maybe$Nothing,
													threadRoute: $author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 0)
												})))
									]),
								$author$project$Ui$text('Read more about E2EE here')),
								$author$project$Ui$row$(
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Input$checkbox$(
										_List_Nil,
										{checked: risksAccepted, icon: $elm$core$Maybe$Nothing, label: risksLabel.id, onChange: $author$project$Types$PressedE2eeRisksAccepted}),
										risksLabel.element
									]))
							])),
						function () {
						var _v2 = localUser.user.publicKey;
						if (!_v2.$) {
							return $author$project$Ui$text('1. Create private key: completed!');
						} else {
							return $author$project$Ui$none;
						}
					}(),
						function () {
						switch (e2ee.$) {
							case 0:
								var disabledBy = e2ee.a;
								return $author$project$Ui$column$(
									_List_fromArray(
										[
											$author$project$Ui$spacing(16)
										]),
									_List_fromArray(
										[
											function () {
											if (!disabledBy.$) {
												var _v5 = disabledBy.a;
												var disabledBy2 = _v5.a;
												var disabledAt = _v5.b;
												return $author$project$Ui$Prose$paragraph$(
													_List_fromArray(
														[
															$author$project$MyUi$htmlStyle$('word-wrap', 'anywhere'),
															$author$project$Ui$paddingXY$(0, 4)
														]),
													_List_fromArray(
														[
															$author$project$Ui$text('2. '),
															_Utils_eq(disabledBy2, localUser.session.userId) ? $author$project$Ui$text('You') : $author$project$Ui$el$(
															_List_fromArray(
																[$author$project$Ui$Font$bold]),
															$author$project$Ui$text(
																$author$project$User$toStringAlt$(disabledBy2, localUser))),
															$author$project$Ui$text(
															' disabled E2EE on ' + $author$project$MyUi$datestampNoLineBreaks$(localUser.timezone, disabledAt))
														]));
											} else {
												return $author$project$Ui$none;
											}
										}(),
											function () {
											if (!risksAccepted) {
												return $author$project$Ui$none;
											} else {
												var _v6 = localUser.user.publicKey;
												if (_v6.$ === 1) {
													return $author$project$Pages$Guild$createPrivateKeyButton;
												} else {
													return $author$project$MyUi$simpleButton$(
														$lamdera$program_test$Effect$Browser$Dom$id('guild_enableE2ee'),
														$author$project$Types$PressedEnableE2ee(otherUserId),
														$author$project$Ui$text(
															$author$project$Encryption$enableE2eeText(disabledBy)));
												}
											}
										}()
										]));
							case 1:
								var _v7 = e2ee.a;
								var requestedBy = _v7.a;
								return (!_Utils_eq(requestedBy, localUser.session.userId)) ? $author$project$Ui$column$(
									_List_fromArray(
										[
											$author$project$Ui$spacing(16)
										]),
									_List_fromArray(
										[
											function () {
											if (!risksAccepted) {
												return $author$project$Ui$none;
											} else {
												var _v8 = localUser.user.publicKey;
												if (_v8.$ === 1) {
													return $author$project$Pages$Guild$createPrivateKeyButton;
												} else {
													return $author$project$Pages$Guild$privateKeyInput$(
														otherUserId,
														$author$project$Ui$text($author$project$Encryption$enterPrivateKeyText),
														keyInput);
												}
											}
										}()
										])) : (_Utils_eq(otherUserId, localUser.session.userId) ? $author$project$Pages$Guild$privateKeyInput$(
									otherUserId,
									$author$project$Ui$text($author$project$Encryption$enterPrivateKeyText),
									keyInput) : $author$project$Ui$column$(
									_List_fromArray(
										[
											$author$project$Ui$spacing(16)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Prose$paragraph$(
											_List_fromArray(
												[
													$author$project$MyUi$htmlStyle$('word-wrap', 'anywhere'),
													$author$project$Ui$paddingXY$(0, 4)
												]),
											_List_fromArray(
												[
													$author$project$Ui$text($author$project$Encryption$waitingForE2eeText),
													$author$project$Ui$el$(
													_List_fromArray(
														[$author$project$Ui$Font$bold]),
													$author$project$Ui$text(
														$author$project$User$toStringAlt$(otherUserId, localUser))),
													$author$project$Ui$text($author$project$Encryption$toAcceptE2eeText)
												])),
											$author$project$MyUi$simpleButton$(
											$lamdera$program_test$Effect$Browser$Dom$id('guild_cancelE2ee'),
											$author$project$Types$PressedCancelE2eeRequest(otherUserId),
											$author$project$Ui$text('Cancel'))
										])));
							case 2:
								var declinedBy = e2ee.a;
								return _Utils_eq(declinedBy, localUser.session.userId) ? $author$project$Ui$column$(
									_List_fromArray(
										[
											$author$project$Ui$spacing(16)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Prose$paragraph$(
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Ui$text($author$project$Encryption$youDeclinedE2eeText)
												])),
											function () {
											if (!risksAccepted) {
												return $author$project$Ui$none;
											} else {
												var _v9 = localUser.user.publicKey;
												if (_v9.$ === 1) {
													return $author$project$Pages$Guild$createPrivateKeyButton;
												} else {
													return $author$project$MyUi$simpleButton$(
														$lamdera$program_test$Effect$Browser$Dom$id('guild_enableE2ee'),
														$author$project$Types$PressedEnableE2ee(otherUserId),
														$author$project$Ui$text(
															$author$project$Encryption$enableE2eeText($elm$core$Maybe$Nothing)));
												}
											}
										}()
										])) : $author$project$Ui$Prose$paragraph$(
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Ui$text(
											$author$project$User$toStringAlt$(otherUserId, localUser) + (' ' + $author$project$Encryption$e2eeDeclinedText))
										]));
							default:
								var data = e2ee.a;
								return $author$project$Ui$column$(
									_List_fromArray(
										[
											$author$project$Ui$spacing(16)
										]),
									_List_fromArray(
										[
											$author$project$Ui$text(
											'2. E2EE was enabled on ' + $author$project$MyUi$datestampNoLineBreaks$(localUser.timezone, data.enabledAt)),
											keyInput.hasKeyOnThisDevice ? $author$project$MyUi$simpleButton$(
											$lamdera$program_test$Effect$Browser$Dom$id('guild_disableE2ee'),
											$author$project$Types$PressedDisableE2ee(otherUserId),
											$author$project$Ui$text($author$project$Encryption$disableE2eeText)) : $author$project$Pages$Guild$privateKeyInput$(
											otherUserId,
											_Utils_eq(
												data.requestedBy,
												_Utils_Tuple2(localUser.session.userId, localUser.session.sessionIdHash)) ? $author$project$Ui$text(
												'3. ' + ($author$project$User$toStringAlt$(otherUserId, localUser) + (' ' + $author$project$Encryption$requestAcceptedText))) : $author$project$Ui$text($author$project$Encryption$missingPrivateKeyText),
											keyInput)
										]));
						}
					}()
					]))
			]));
};
var $author$project$Pages$Guild$e2eeSectionView = F5($author$project$Pages$Guild$e2eeSectionView$);
var $author$project$Pages$Guild$dmChannelSettingsMobile$ = function (canScroll2, localUser, otherUserId, isThread, e2ee, isExpanded, keyInput) {
	var members = $author$project$Pages$Guild$dmMembers$(localUser, otherUserId);
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$height($author$project$Ui$fill)
			]),
		_List_fromArray(
			[
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$contentCenterY,
						$author$project$Ui$borderWith(
						{bottom: 1, left: 0, right: 0, top: 0}),
						$author$project$Ui$borderColor($author$project$MyUi$border2),
						$author$project$Ui$background($author$project$MyUi$background3),
						$author$project$Ui$height(
						$author$project$Ui$px($author$project$MyUi$channelHeaderHeight)),
						$author$project$MyUi$noShrinking
					]),
				_List_fromArray(
					[
						$author$project$ChannelHeader$headerBackButton$(
						$lamdera$program_test$Effect$Browser$Dom$id('guild_memberColumnBack'),
						$author$project$Types$PressedMemberListBack),
						isThread ? $author$project$Ui$text('Thread settings') : $author$project$Ui$text('Channel settings')
					])),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$background($author$project$MyUi$background2),
						$author$project$Ui$Font$color($author$project$MyUi$font1),
						$author$project$Ui$paddingWith(
						{bottom: localUser.safeAreaInsetBottom + 16, left: 0, right: 0, top: 16}),
						$author$project$MyUi$scrollable(canScroll2),
						$author$project$Ui$heightMin(0)
					]),
				_List_fromArray(
					[
						isThread ? $author$project$Ui$none : $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$(8, 4)
							]),
						$author$project$Pages$Guild$exportChannelButton(
							$author$project$Id$ExportChannel_Dm(otherUserId))),
						$author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$(8, 4)
							]),
						_List_fromArray(
							[
								$author$project$Ui$text(
								'Members (' + ($elm$core$String$fromInt(
									$elm$core$List$length(members)) + ')')),
								$author$project$Ui$column$(
								_List_fromArray(
									[
										$author$project$Ui$height($author$project$Ui$fill)
									]),
								$elm$core$List$map$(
									A2($author$project$Pages$Guild$memberLabel, true, localUser),
									members))
							])),
						isThread ? $author$project$Ui$none : $author$project$Pages$Guild$e2eeSectionView$(localUser, otherUserId, e2ee, isExpanded, keyInput)
					]))
			]));
};
var $author$project$Pages$Guild$dmChannelSettingsMobile = F7($author$project$Pages$Guild$dmChannelSettingsMobile$);
var $author$project$Pages$Guild$dmChannelSettingsNotMobile$ = function (localUser, otherUserId, isThread, e2ee, isExpanded, keyInput) {
	var members = $author$project$Pages$Guild$dmMembers$(localUser, otherUserId);
	return $author$project$Pages$Guild$memberColumnContainerNotMobile$(
		isThread,
		_List_fromArray(
			[
				isThread ? $author$project$Ui$none : $author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$paddingXY$(8, 8)
					]),
				$author$project$Pages$Guild$exportChannelButton(
					$author$project$Id$ExportChannel_Dm(otherUserId))),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$paddingWith(
						{bottom: 16, left: 0, right: 0, top: 4})
					]),
				_List_fromArray(
					[
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$(8, 0)
							]),
						$author$project$Ui$text(
							'Members (' + ($elm$core$String$fromInt(
								$elm$core$List$length(members)) + ')'))),
						$author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$height($author$project$Ui$fill)
							]),
						$elm$core$List$map$(
							A2($author$project$Pages$Guild$memberLabel, false, localUser),
							members))
					])),
				isThread ? $author$project$Ui$none : $author$project$Pages$Guild$e2eeSectionView$(localUser, otherUserId, e2ee, isExpanded, keyInput)
			]));
};
var $author$project$Pages$Guild$dmChannelSettingsNotMobile = F6($author$project$Pages$Guild$dmChannelSettingsNotMobile$);
var $author$project$Pages$Guild$dmChannelView$ = function (dmRoute, loggedIn, local, model) {
	var _v0 = $author$project$DmChannelId$otherUserId$(local.localUser.session.userId, dmRoute.channelId);
	if (_v0.$ === 1) {
		return $author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$centerY,
					$author$project$Ui$Font$center,
					$author$project$Ui$Font$color($author$project$MyUi$font1),
					$author$project$Ui$Font$size(20)
				]),
			$author$project$Ui$text('Conversation not found'));
	} else {
		var otherUserId = _v0.a;
		var _v1 = $author$project$User$getUser$(otherUserId, local.localUser);
		if (!_v1.$) {
			var otherUser = _v1.a;
			var dmChannel = $elm$core$Maybe$withDefault$(
				$author$project$DmChannel$frontendInit,
				$lamdera$containers$SeqDict$get$(otherUserId, local.dmChannels));
			var missingPrivateKey = function () {
				var _v5 = dmChannel.e2ee;
				switch (_v5.$) {
					case 3:
						return !$lamdera$containers$SeqSet$member$(otherUserId, loggedIn.e2eeKeysOnThisDevice);
					case 0:
						return false;
					case 1:
						return false;
					default:
						return false;
				}
			}();
			var _v2 = dmRoute.threadRoute;
			if (_v2.$ === 1) {
				var threadMessageIndex = _v2.a;
				var maybeUrlMessageId = _v2.b;
				return $author$project$Pages$Guild$threadConversationView$(
					function () {
						var lastViewed = $elm$core$Maybe$withDefault$(
							$author$project$Id$fromInt(-1),
							$lamdera$containers$SeqDict$get$(
								_Utils_Tuple2(
									$author$project$Id$GuildOrDmId(
										$author$project$Id$GuildOrDmId_Dm(
											{otherUserId: otherUserId})),
									threadMessageIndex),
								local.localUser.user.lastViewedThreadMessage));
						var _v3 = local.localUser.currentlyViewing;
						if (_v3.$ === 1) {
							var data = _v3.a;
							return _Utils_eq(
								data.id,
								{otherUserId: otherUserId, threadId: threadMessageIndex}) ? $author$project$Pages$Guild$unreadDividerAt$(lastViewed, data.previouslyLastViewedMessage) : lastViewed;
						} else {
							return lastViewed;
						}
					}(),
					$author$project$Id$GuildOrDmId_Dm(
						{otherUserId: otherUserId}),
					maybeUrlMessageId,
					threadMessageIndex,
					loggedIn,
					model,
					local,
					missingPrivateKey,
					$author$project$PersonName$toString(otherUser.name),
					$author$project$Pages$Guild$threadPreviewText$(
						local.localUser.timezone,
						$author$project$User$allUsers(local.localUser),
						$lamdera$containers$SeqDict$empty,
						threadMessageIndex,
						local.localUser.decryptedMessages,
						dmChannel),
					$elm$core$Maybe$withDefault$(
						$author$project$Thread$frontendInit,
						$lamdera$containers$SeqDict$get$(threadMessageIndex, dmChannel.threads)));
			} else {
				var maybeUrlMessageId = _v2.a;
				return $author$project$Pages$Guild$conversationView$(
					function () {
						var lastViewed = $elm$core$Maybe$withDefault$(
							$author$project$Id$fromInt(-1),
							$lamdera$containers$SeqDict$get$(
								$author$project$Id$GuildOrDmId(
									$author$project$Id$GuildOrDmId_Dm(
										{otherUserId: otherUserId})),
								local.localUser.user.lastViewedMessage));
						var _v4 = local.localUser.currentlyViewing;
						if (!_v4.$) {
							var data = _v4.a;
							return _Utils_eq(
								data.id,
								{otherUserId: otherUserId}) ? $author$project$Pages$Guild$unreadDividerAt$(lastViewed, data.previouslyLastViewedMessage) : lastViewed;
						} else {
							return lastViewed;
						}
					}(),
					$author$project$Id$GuildOrDmId_Dm(
						{otherUserId: otherUserId}),
					maybeUrlMessageId,
					loggedIn,
					model,
					local,
					missingPrivateKey,
					$author$project$PersonName$toString(otherUser.name),
					dmChannel);
			}
		} else {
			return $author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$centerY,
						$author$project$Ui$Font$center,
						$author$project$Ui$Font$color($author$project$MyUi$font1),
						$author$project$Ui$Font$size(20)
					]),
				$author$project$Ui$text('User not found'));
		}
	}
};
var $author$project$Pages$Guild$dmChannelView = F4($author$project$Pages$Guild$dmChannelView$);
var $author$project$Pages$Guild$dmE2eeStatus$ = function (otherUserId, local) {
	var _v0 = $lamdera$containers$SeqDict$get$(otherUserId, local.dmChannels);
	if (!_v0.$) {
		var dmChannel = _v0.a;
		return dmChannel.e2ee;
	} else {
		return $author$project$DmChannel$E2eeDisabled($elm$core$Maybe$Nothing);
	}
};
var $author$project$Pages$Guild$dmE2eeStatus = F2($author$project$Pages$Guild$dmE2eeStatus$);
var $author$project$Pages$Guild$e2eeKeyInput$ = function (otherUserId, loggedIn) {
	return {
		error: loggedIn.e2eeError,
		hasKeyOnThisDevice: $lamdera$containers$SeqSet$member$(otherUserId, loggedIn.e2eeKeysOnThisDevice),
		text: loggedIn.e2eePrivateKeyText
	};
};
var $author$project$Pages$Guild$e2eeKeyInput = F2($author$project$Pages$Guild$e2eeKeyInput$);
var $author$project$Pages$Guild$encodeFriendsColumn$ = function (canScroll, time) {
	return (canScroll ? 1 : 0) + (((time / $author$project$Pages$Guild$msInMinute) | 0) * 2);
};
var $author$project$Pages$Guild$encodeFriendsColumn = F2($author$project$Pages$Guild$encodeFriendsColumn$);
var $author$project$Pages$Guild$decodeFriendsColumn = function (packed) {
	return {
		canScroll: A2($elm$core$Basics$modBy, 2, packed) === 1,
		time: ((packed / 2) | 0) * $author$project$Pages$Guild$msInMinute
	};
};
var $author$project$Pages$Guild$directMessagesText = 'Direct messages';
var $author$project$Pages$Guild$editingText = 'Editing...';
var $author$project$MyUi$timeElapsedShort$ = function (now, event) {
	var difference = $ianmackenzie$elm_units$Quantity$abs(
		$ianmackenzie$elm_units$Duration$from$(event, now));
	var years = $elm$core$Basics$floor(
		$ianmackenzie$elm_units$Duration$inDays(difference) / 365);
	if (years >= 1) {
		return $elm$core$String$fromInt(years) + 'y';
	} else {
		var days = $elm$core$Basics$round(
			$ianmackenzie$elm_units$Duration$inDays(difference));
		if (days > 1) {
			return $elm$core$String$fromInt(days) + 'd';
		} else {
			var hours = $elm$core$Basics$floor(
				$ianmackenzie$elm_units$Duration$inHours(difference));
			if (hours > 6) {
				return $elm$core$String$fromInt(hours) + 'h';
			} else {
				if ($ianmackenzie$elm_units$Duration$inHours(difference) >= 1.5) {
					return $author$project$MyUi$removeTrailing0s$(
						1,
						$ianmackenzie$elm_units$Duration$inHours(difference)) + 'h';
				} else {
					var minutes = $elm$core$Basics$round(
						$ianmackenzie$elm_units$Duration$inMinutes(difference));
					return $elm$core$String$fromInt(minutes) + 'm';
				}
			}
		}
	}
};
var $author$project$MyUi$timeElapsedShort = F2($author$project$MyUi$timeElapsedShort$);
var $author$project$Pages$Guild$friendLabelMessagePreview$ = function (time, messagePreview, message) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$Font$size(13),
				$author$project$Ui$spacing(4)
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_Nil,
				$author$project$Ui$text(messagePreview)),
				function () {
				if (!message.$) {
					var message2 = message.a;
					return $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$alignRight,
								$author$project$Ui$opacity(0.7)
							]),
						$author$project$Ui$text(
							$author$project$MyUi$timeElapsedShort$(
								time,
								$author$project$Message$createdAt(message2))));
				} else {
					return $author$project$Ui$none;
				}
			}()
			]));
};
var $author$project$Pages$Guild$friendLabelMessagePreview = F3($author$project$Pages$Guild$friendLabelMessagePreview$);
var $author$project$User$discordSmallProfileImage = function (_v0) {
	var userId = _v0.a;
	var maybeFileHash = _v0.b;
	return $author$project$Ui$imageLazy$(
		_List_fromArray(
			[
				$author$project$Ui$rounded($author$project$User$smallProfileImageRounding),
				$author$project$Ui$width(
				$author$project$Ui$px($author$project$User$smallProfileImageSize)),
				$author$project$Ui$height(
				$author$project$Ui$px($author$project$User$smallProfileImageSize)),
				$author$project$Ui$clip
			]),
		{
			description: '',
			onLoad: $elm$core$Maybe$Nothing,
			source: function () {
				if (!maybeFileHash.$) {
					var fileHash = maybeFileHash.a;
					return $author$project$FileStatus$fileUrl$($author$project$FileStatus$pngContent, fileHash);
				} else {
					return $author$project$Discord$defaultUserAvatarUrl$(
						$author$project$Discord$TwoToNthPower(7),
						userId);
				}
			}()
		});
};
var $author$project$User$multipleDiscordProfileImages = function (profileImages) {
	if (!profileImages.b) {
		return $author$project$Ui$none;
	} else {
		if (!profileImages.b.b) {
			var _v1 = profileImages.a;
			var userId = _v1.a;
			var single = _v1.b;
			return $author$project$User$discordProfileImage$(userId, single);
		} else {
			if (!profileImages.b.b.b) {
				var one = profileImages.a;
				var _v2 = profileImages.b;
				var two = _v2.a;
				return $author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$width(
							$author$project$Ui$px(40)),
							$author$project$Ui$height(
							$author$project$Ui$px(40)),
							$author$project$Ui$inFront(
							$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$move(
										{x: 15, y: 15, z: 0})
									]),
								$author$project$User$discordSmallProfileImage(two))),
							$author$project$Ui$inFront(
							$author$project$User$discordSmallProfileImage(one))
						]),
					$author$project$Ui$none);
			} else {
				if (!profileImages.b.b.b.b) {
					var one = profileImages.a;
					var _v3 = profileImages.b;
					var two = _v3.a;
					var _v4 = _v3.b;
					var three = _v4.a;
					return $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$width(
								$author$project$Ui$px(55)),
								$author$project$Ui$height(
								$author$project$Ui$px(40)),
								$author$project$Ui$inFront(
								$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$move(
											{x: 30, y: 0, z: 0})
										]),
									$author$project$User$discordSmallProfileImage(three))),
								$author$project$Ui$inFront(
								$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$move(
											{x: 15, y: 15, z: 0})
										]),
									$author$project$User$discordSmallProfileImage(two))),
								$author$project$Ui$inFront(
								$author$project$User$discordSmallProfileImage(one))
							]),
						$author$project$Ui$none);
				} else {
					if (!profileImages.b.b.b.b.b) {
						var one = profileImages.a;
						var _v5 = profileImages.b;
						var two = _v5.a;
						var _v6 = _v5.b;
						var three = _v6.a;
						var _v7 = _v6.b;
						var four = _v7.a;
						return $author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$width(
									$author$project$Ui$px(70)),
									$author$project$Ui$height(
									$author$project$Ui$px(40)),
									$author$project$Ui$inFront(
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$move(
												{x: 45, y: 15, z: 0})
											]),
										$author$project$User$discordSmallProfileImage(four))),
									$author$project$Ui$inFront(
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$move(
												{x: 30, y: 0, z: 0})
											]),
										$author$project$User$discordSmallProfileImage(three))),
									$author$project$Ui$inFront(
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$move(
												{x: 15, y: 15, z: 0})
											]),
										$author$project$User$discordSmallProfileImage(two))),
									$author$project$Ui$inFront(
									$author$project$User$discordSmallProfileImage(one))
								]),
							$author$project$Ui$none);
					} else {
						var one = profileImages.a;
						var _v8 = profileImages.b;
						var two = _v8.a;
						var _v9 = _v8.b;
						var three = _v9.a;
						var rest = _v9.b;
						return $author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$width(
									$author$project$Ui$px(70)),
									$author$project$Ui$height(
									$author$project$Ui$px(40)),
									$author$project$Ui$inFront(
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$move(
												{x: 30, y: 0, z: 0})
											]),
										$author$project$User$discordSmallProfileImage(three))),
									$author$project$Ui$inFront(
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$move(
												{x: 15, y: 15, z: 0})
											]),
										$author$project$User$discordSmallProfileImage(two))),
									$author$project$Ui$inFront(
									$author$project$User$discordSmallProfileImage(one)),
									$author$project$Ui$inFront(
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$move(
												{x: 45, y: 15, z: 0}),
												$author$project$Ui$background($author$project$MyUi$background1),
												$author$project$Ui$width(
												$author$project$Ui$px($author$project$User$smallProfileImageSize)),
												$author$project$Ui$height(
												$author$project$Ui$px($author$project$User$smallProfileImageSize)),
												$author$project$Ui$Font$center,
												$author$project$Ui$Font$bold,
												$author$project$Ui$rounded(8),
												$author$project$Ui$Font$color($author$project$MyUi$font3),
												$author$project$Ui$Font$size(14),
												$author$project$Ui$contentCenterY,
												$author$project$MyUi$htmlStyle$('white-space', 'pre')
											]),
										$author$project$Ui$text(
											'+' + $elm$core$String$fromInt(
												$elm$core$List$length(rest)))))
								]),
							$author$project$Ui$none);
					}
				}
			}
		}
	}
};
var $author$project$Pages$Guild$NoOneIsTyping = 2;
var $author$project$Pages$Guild$SomeoneIsEditing = 1;
var $author$project$Pages$Guild$SomeoneIsTyping = 0;
var $author$project$Pages$Guild$someoneIsTyping$ = function (time, lastTypedAt) {
	return $lamdera$containers$SeqDict$foldl$(
		F3(
			function (_v0, a, state) {
				if (!state) {
					return state;
				} else {
					if ($ianmackenzie$elm_units$Quantity$lessThan$(
						$ianmackenzie$elm_units$Quantity$plus$($ianmackenzie$elm_units$Duration$second, $author$project$Pages$Guild$typingDebouncerDelay),
						$ianmackenzie$elm_units$Duration$from$(a.time, time))) {
						var _v2 = a.threadRoute;
						if (!_v2.$) {
							if (!_v2.a.$) {
								return 1;
							} else {
								var _v3 = _v2.a;
								return 0;
							}
						} else {
							return state;
						}
					} else {
						return state;
					}
				}
			}),
		2,
		lastTypedAt);
};
var $author$project$Pages$Guild$someoneIsTyping = F2($author$project$Pages$Guild$someoneIsTyping$);
var $author$project$Pages$Guild$typingText = 'Typing...';
var $author$project$Pages$Guild$discordFriendLabel$ = function (isMobile, time, isSelected, dmChannelId, channel, localUser) {
	var message = $author$project$MessageArray$last(channel.messages);
	var messagePreview = function () {
		var _v8 = $author$project$Pages$Guild$someoneIsTyping$(
			time,
			$lamdera$containers$SeqDict$map$(
				F2(
					function (_v9, a) {
						return {
							threadRoute: $author$project$Id$NoThreadWithMaybeMessage(a.messageIndex),
							time: a.time
						};
					}),
				$lamdera$containers$SeqDict$diff$(
					channel.lastTypedAt,
					$author$project$LinkedAndOtherDiscordUsers$linkedUsers(localUser.discordUsers))));
		switch (_v8) {
			case 0:
				return $author$project$Pages$Guild$typingText;
			case 1:
				return $author$project$Pages$Guild$editingText;
			default:
				if (!message.$) {
					var message2 = message.a;
					switch (message2.$) {
						case 0:
							var a = message2.a;
							return _Utils_ap(
								$author$project$LinkedAndOtherDiscordUsers$isLinkedUser$(a.createdBy, localUser.discordUsers) ? 'You: ' : '',
								$author$project$RichText$toString$(
									localUser.timezone,
									true,
									$author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(localUser.discordUsers),
									$lamdera$containers$SeqDict$empty,
									a.content.content));
						case 1:
							var a = message2.a;
							return $author$project$LinkedAndOtherDiscordUsers$isLinkedUser$(a.createdBy, localUser.discordUsers) ? ('You: ' + $author$project$RichText$failedToDecryptMessageText) : $author$project$RichText$failedToDecryptMessageText;
						case 2:
							var userId = message2.b;
							return $author$project$User$toString$(
								userId,
								$author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(localUser.discordUsers)) + ' joined!';
						case 3:
							return $author$project$LocalState$messageDeleted;
						case 4:
							var endedAt = message2.a.endedAt;
							return $author$project$LocalState$callStartedText(endedAt);
						default:
							var gameType = message2.a.gameType;
							return $author$project$LocalState$gameStartedText(gameType);
					}
				} else {
					return '';
				}
		}
	}();
	var maybeCurrentUserId = $elmcraft$core_extra$List$Extra$findMap$(
		function (_v7) {
			var userId = _v7.a;
			return $author$project$NonemptyDict$member$(userId, channel.members) ? $elm$core$Maybe$Just(userId) : $elm$core$Maybe$Nothing;
		},
		$lamdera$containers$SeqDict$toList(
			$author$project$LinkedAndOtherDiscordUsers$linkedUsers(localUser.discordUsers)));
	if (!maybeCurrentUserId.$) {
		var currentUserId = maybeCurrentUserId.a;
		var notification = function () {
			if (isSelected) {
				return $author$project$GuildIcon$NoNotification;
			} else {
				var _v5 = $author$project$GuildColumn$discordDmHasNotifications$(localUser, dmChannelId, channel);
				if (!_v5.$) {
					var _v6 = _v5.a;
					var count = _v6.b;
					return $author$project$GuildIcon$NewMessageForUser(count);
				} else {
					return $author$project$GuildIcon$NoNotification;
				}
			}
		}();
		var members2 = $lamdera$containers$SeqDict$keys(
			$author$project$NonemptyDict$remove$(currentUserId, channel.members));
		return $author$project$MyUi$rowButton$(
			$lamdera$program_test$Effect$Browser$Dom$id(
				'guild_discordFriendLabel_' + $author$project$Discord$idToString(dmChannelId)),
			$author$project$Types$PressedLink(
				$author$project$Route$DiscordDmRoute(
					{channelId: dmChannelId, channelsVisible: 0, currentDiscordUserId: currentUserId, overlay: $elm$core$Maybe$Nothing, showMembersTab: 1, tab: $elm$core$Maybe$Nothing, viewingMessage: $elm$core$Maybe$Nothing})),
			_List_fromArray(
				[
					$author$project$Ui$clipWithEllipsis,
					$author$project$Ui$spacing(8),
					$author$project$MyUi$hoverText(messagePreview),
					$author$project$Ui$padding(4),
					$author$project$Ui$Font$color(
					isSelected ? $author$project$MyUi$font1 : $author$project$MyUi$font3),
					$author$project$MyUi$hover$(
					isMobile,
					_List_fromArray(
						[
							$author$project$Ui$Anim$fontColor($author$project$MyUi$font1)
						])),
					$author$project$Ui$attrIf$(
					isSelected,
					$author$project$Ui$background($author$project$MyUi$selectedHighlight))
				]),
			function () {
				if (!members2.b) {
					var _v2 = $author$project$User$getDiscordUser$(currentUserId, localUser);
					if (!_v2.$) {
						var otherUser = _v2.a;
						return _List_fromArray(
							[
								$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$GuildIcon$discordNotificationView$(4, -3, notification),
										$author$project$Ui$width($author$project$Ui$shrink)
									]),
								$author$project$User$discordProfileImage$(currentUserId, otherUser.icon)),
								$author$project$Ui$column$(
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$el$(
										_List_fromArray(
											[$author$project$Ui$Font$bold]),
										$author$project$Ui$text(
											$author$project$PersonName$toString(otherUser.name))),
										$author$project$Pages$Guild$friendLabelMessagePreview$(time, messagePreview, message)
									]))
							]);
					} else {
						return _List_Nil;
					}
				} else {
					var rest = members2;
					return _List_fromArray(
						[
							$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$GuildIcon$discordNotificationView$(4, -3, notification),
									$author$project$Ui$width($author$project$Ui$shrink)
								]),
							$author$project$User$multipleDiscordProfileImages(
								$elm$core$List$filterMap$(
									function (userId) {
										var _v3 = $author$project$User$getDiscordUser$(userId, localUser);
										if (!_v3.$) {
											var user = _v3.a;
											return $elm$core$Maybe$Just(
												_Utils_Tuple2(userId, user.icon));
										} else {
											return $elm$core$Maybe$Nothing;
										}
									},
									members2))),
							$author$project$Ui$column$(
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$el$(
									_List_fromArray(
										[$author$project$Ui$Font$bold]),
									$author$project$Ui$text(
										$elm$core$String$join$(
											', ',
											$elm$core$List$filterMap$(
												function (userId) {
													var _v4 = $author$project$User$getDiscordUser$(userId, localUser);
													if (!_v4.$) {
														var otherUser = _v4.a;
														return $elm$core$Maybe$Just(
															$author$project$PersonName$toString(otherUser.name));
													} else {
														return $elm$core$Maybe$Nothing;
													}
												},
												rest)))),
									$author$project$Pages$Guild$friendLabelMessagePreview$(time, messagePreview, message)
								]))
						]);
				}
			}());
	} else {
		return $author$project$Ui$text('Something went wrong');
	}
};
var $author$project$Pages$Guild$discordFriendLabel = F6($author$project$Pages$Guild$discordFriendLabel$);
var $author$project$Pages$Guild$discordFriendLabelMobile$ = function (time, isSelected, dmChannelId, channel, localUser) {
	return $author$project$Pages$Guild$discordFriendLabel$(
		true,
		$elm$time$Time$millisToPosix(time),
		isSelected,
		dmChannelId,
		channel,
		localUser);
};
var $author$project$Pages$Guild$discordFriendLabelMobile = F5($author$project$Pages$Guild$discordFriendLabelMobile$);
var $author$project$Pages$Guild$discordFriendLabelNotMobile$ = function (time, isSelected, dmChannelId, channel, localUser) {
	return $author$project$Pages$Guild$discordFriendLabel$(
		false,
		$elm$time$Time$millisToPosix(time),
		isSelected,
		dmChannelId,
		channel,
		localUser);
};
var $author$project$Pages$Guild$discordFriendLabelNotMobile = F5($author$project$Pages$Guild$discordFriendLabelNotMobile$);
var $author$project$MuteSettings$isDmMuted$ = function (model, otherUserId, threadRoute) {
	var _v0 = $lamdera$containers$SeqDict$get$(otherUserId, model.mutedDms);
	if (!_v0.$) {
		var channel = _v0.a;
		return $author$project$MuteSettings$channelOrThreadMuted$(threadRoute, channel);
	} else {
		return 0;
	}
};
var $author$project$MuteSettings$isDmMuted = F3($author$project$MuteSettings$isDmMuted$);
var $author$project$Pages$Guild$dmColumnThreads$ = function (isMobile, now, threadRoute, localUser, otherUserId, channel, threads) {
	var threads2 = $elm$core$List$filterMap$(
		function (_v2) {
			var threadMessageIndex = _v2.a;
			var thread = _v2.b;
			var isSelected = function () {
				if ((!threadRoute.$) && (threadRoute.a.$ === 1)) {
					var _v7 = threadRoute.a;
					var b = _v7.a;
					return _Utils_eq(b, threadMessageIndex);
				} else {
					return false;
				}
			}();
			var isMuted = $author$project$MuteSettings$isDmMuted$(
				localUser.user.muteSettings,
				otherUserId,
				$author$project$Id$ViewThread(threadMessageIndex));
			var hasNotifications = function () {
				if ($author$project$MuteSettings$hidesRedDot(isMuted)) {
					return $author$project$GuildIcon$NoNotification;
				} else {
					var _v5 = $author$project$OneOrGreater$fromInt(
						$author$project$GuildColumn$newMessageCount$(
							$lamdera$containers$SeqDict$get$(
								_Utils_Tuple2(
									$author$project$Id$GuildOrDmId(
										$author$project$Id$GuildOrDmId_Dm(
											{otherUserId: otherUserId})),
									threadMessageIndex),
								localUser.user.lastViewedThreadMessage),
							thread));
					if (!_v5.$) {
						var unreadCount = _v5.a;
						return $author$project$GuildIcon$NewMessageForUser(unreadCount);
					} else {
						return $author$project$GuildIcon$NoNotification;
					}
				}
			}();
			var _v3 = _Utils_Tuple3(
				hasNotifications,
				isSelected,
				$author$project$MessageArray$last(thread.messages));
			if (((!_v3.a.$) && (!_v3.b)) && (!_v3.c.$)) {
				var _v4 = _v3.a;
				var message = _v3.c.a;
				return $ianmackenzie$elm_units$Quantity$lessThan$(
					$ianmackenzie$elm_units$Duration$week,
					$ianmackenzie$elm_units$Duration$from$(
						$author$project$Message$createdAt(message),
						now)) ? $elm$core$Maybe$Just(
					_Utils_Tuple3(
						threadMessageIndex,
						_Utils_Tuple2(isMuted, hasNotifications),
						isSelected)) : $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Just(
					_Utils_Tuple3(
						threadMessageIndex,
						_Utils_Tuple2(isMuted, hasNotifications),
						isSelected));
			}
		},
		$lamdera$containers$SeqDict$toList(threads));
	var count = $elm$core$List$length(threads2);
	return $author$project$Ui$column$(
		_List_Nil,
		$elm$core$List$indexedMap$(
			F2(
				function (index, _v0) {
					var threadMessageIndex = _v0.a;
					var _v1 = _v0.b;
					var isMuted = _v1.a;
					var hasNotifications = _v1.b;
					var isSelected = _v0.c;
					return $author$project$Pages$Guild$channelColumnThreadsHelper$(
						isMobile,
						isSelected,
						isMuted,
						hasNotifications,
						index,
						count,
						$lamdera$program_test$Effect$Browser$Dom$id(
							'guild_viewDmThread_' + ($author$project$Id$toString(otherUserId) + ('_' + $author$project$Id$toString(threadMessageIndex)))),
						$author$project$Route$DmRoute(
							{
								channelId: $author$project$DmChannelId$fromUserIds$(otherUserId, localUser.session.userId),
								channelsVisible: 0,
								overlay: $elm$core$Maybe$Nothing,
								tab: $elm$core$Maybe$Nothing,
								threadRoute: $author$project$Route$ViewThreadWithFriends$(threadMessageIndex, $elm$core$Maybe$Nothing, 1)
							}),
						$author$project$Pages$Guild$threadPreviewText$(
							localUser.timezone,
							$author$project$User$allUsers(localUser),
							$lamdera$containers$SeqDict$empty,
							threadMessageIndex,
							localUser.decryptedMessages,
							channel));
				}),
			threads2));
};
var $author$project$Pages$Guild$dmColumnThreads = F7($author$project$Pages$Guild$dmColumnThreads$);
var $author$project$Pages$Guild$encodeFriendLabel$ = function (isSelected, time) {
	return (isSelected ? 1 : 0) + (((time / $author$project$Pages$Guild$msInMinute) | 0) * 2);
};
var $author$project$Pages$Guild$encodeFriendLabel = F2($author$project$Pages$Guild$encodeFriendLabel$);
var $author$project$Pages$Guild$decodeFriendLabel = function (packed) {
	return {
		isSelected: A2($elm$core$Basics$modBy, 2, packed) === 1,
		time: $elm$time$Time$millisToPosix(((packed / 2) | 0) * $author$project$Pages$Guild$msInMinute)
	};
};
var $author$project$Pages$Guild$friendLabel$ = function (isMobile, time, isSelected, localUser, otherUserId, otherUser, channel) {
	var message = $author$project$MessageArray$last(channel.messages);
	var decrypted = localUser.decryptedMessages;
	var allUsers = $author$project$User$allUsers(localUser);
	var messagePreview = function () {
		var _v0 = $author$project$Pages$Guild$someoneIsTyping$(
			time,
			$lamdera$containers$SeqDict$remove$(localUser.session.userId, channel.lastTypedAt));
		switch (_v0) {
			case 0:
				return $author$project$Pages$Guild$typingText;
			case 1:
				return $author$project$Pages$Guild$editingText;
			default:
				if (!message.$) {
					var message2 = message.a;
					switch (message2.$) {
						case 0:
							var a = message2.a;
							return _Utils_ap(
								_Utils_eq(a.createdBy, localUser.session.userId) ? 'You: ' : '',
								$author$project$RichText$toString$(localUser.timezone, true, allUsers, $lamdera$containers$SeqDict$empty, a.content.content));
						case 1:
							var a = message2.a;
							return _Utils_ap(
								_Utils_eq(a.createdBy, localUser.session.userId) ? 'You: ' : '',
								function () {
									var _v3 = $lamdera$containers$SeqDict$get$(
										$author$project$Encryption$hash(a.content),
										decrypted);
									if (!_v3.$) {
										var result = _v3.a;
										return $author$project$RichText$toString$(
											localUser.timezone,
											true,
											allUsers,
											$lamdera$containers$SeqDict$empty,
											function () {
												if (!result.$) {
													var ok = result.a;
													return ok.content;
												} else {
													return $author$project$RichText$failedToDecryptMessage;
												}
											}());
									} else {
										return '';
									}
								}());
						case 2:
							var userId = message2.b;
							return $author$project$User$toString$(userId, allUsers) + ' joined!';
						case 3:
							return $author$project$LocalState$messageDeleted;
						case 4:
							var endedAt = message2.a.endedAt;
							return $author$project$LocalState$callStartedText(endedAt);
						default:
							var gameType = message2.a.gameType;
							return $author$project$LocalState$gameStartedText(gameType);
					}
				} else {
					return '';
				}
		}
	}();
	return $author$project$GuildColumn$rowLinkButton$(
		$lamdera$program_test$Effect$Browser$Dom$id(
			'guild_friendLabel_' + $author$project$Id$toString(otherUserId)),
		$author$project$Route$DmRoute(
			{
				channelId: $author$project$DmChannelId$fromUserIds$(localUser.session.userId, otherUserId),
				channelsVisible: 0,
				overlay: $elm$core$Maybe$Nothing,
				tab: $elm$core$Maybe$Nothing,
				threadRoute: $author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1)
			}),
		_List_fromArray(
			[
				$author$project$Ui$clipWithEllipsis,
				$author$project$Ui$spacing(8),
				$author$project$Ui$padding(4),
				$author$project$MyUi$hoverText(messagePreview),
				$author$project$Ui$Font$color(
				isSelected ? $author$project$MyUi$font1 : $author$project$MyUi$font3),
				$author$project$MyUi$hover$(
				isMobile,
				_List_fromArray(
					[
						$author$project$Ui$Anim$fontColor($author$project$MyUi$font1)
					])),
				$author$project$Ui$attrIf$(
				isSelected,
				$author$project$Ui$background($author$project$MyUi$selectedHighlight))
			]),
		_List_fromArray(
			[
				$author$project$User$profileImage(
				$elm$core$Maybe$Just(otherUser)),
				$author$project$Ui$column$(
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$el$(
						_List_fromArray(
							[$author$project$Ui$Font$bold]),
						$author$project$Ui$text(
							$author$project$PersonName$toString(otherUser.name))),
						$author$project$Pages$Guild$friendLabelMessagePreview$(time, messagePreview, message)
					]))
			]));
};
var $author$project$Pages$Guild$friendLabel = F7($author$project$Pages$Guild$friendLabel$);
var $author$project$Pages$Guild$friendLabelMobile$ = function (packed, localUser, otherUserId, otherUser, channel) {
	var _v0 = $author$project$Pages$Guild$decodeFriendLabel(packed);
	var time = _v0.time;
	var isSelected = _v0.isSelected;
	return $author$project$Pages$Guild$friendLabel$(true, time, isSelected, localUser, otherUserId, otherUser, channel);
};
var $author$project$Pages$Guild$friendLabelMobile = F5($author$project$Pages$Guild$friendLabelMobile$);
var $author$project$Pages$Guild$friendLabelNotMobile$ = function (packed, localUser, otherUserId, otherUser, channel) {
	var _v0 = $author$project$Pages$Guild$decodeFriendLabel(packed);
	var time = _v0.time;
	var isSelected = _v0.isSelected;
	return $author$project$Pages$Guild$friendLabel$(false, time, isSelected, localUser, otherUserId, otherUser, channel);
};
var $author$project$Pages$Guild$friendLabelNotMobile = F5($author$project$Pages$Guild$friendLabelNotMobile$);
var $author$project$Pages$Guild$slackDmColumnThreads$ = function (isMobile, now, threadRoute, localUser, dmChannelId, dmChannel, threads) {
	var _v0 = $elmcraft$core_extra$List$Extra$find$(
		function (userId) {
			return $lamdera$containers$SeqDict$member$(userId, localUser.linkedSlackUsers);
		},
		$author$project$NonemptySet$toList(dmChannel.members));
	if (!_v0.$) {
		var currentUserId = _v0.a;
		var threads2 = $elm$core$List$filterMap$(
			function (_v2) {
				var threadMessageIndex = _v2.a;
				var thread = _v2.b;
				var isSelected = function () {
					if (!threadRoute.$) {
						if (threadRoute.a.$ === 1) {
							var _v6 = threadRoute.a;
							var threadId = _v6.a;
							return _Utils_eq(threadId, threadMessageIndex);
						} else {
							return false;
						}
					} else {
						return false;
					}
				}();
				var hasNotifications = function () {
					var _v4 = $author$project$OneOrGreater$fromInt(
						$author$project$GuildColumn$newMessageCount$(
							$lamdera$containers$SeqDict$get$(
								_Utils_Tuple2(
									$author$project$Id$SlackGuildOrDmId(
										$author$project$Id$SlackGuildOrDmId_Dm(
											{channelId: dmChannelId, currentUserId: currentUserId})),
									threadMessageIndex),
								localUser.user.lastViewedThreadMessage),
							thread));
					if (!_v4.$) {
						var unreadCount = _v4.a;
						return $author$project$GuildIcon$NewMessageForUser(unreadCount);
					} else {
						return $author$project$GuildIcon$NoNotification;
					}
				}();
				if (isSelected || (!_Utils_eq(hasNotifications, $author$project$GuildIcon$NoNotification))) {
					return $elm$core$Maybe$Just(
						_Utils_Tuple3(threadMessageIndex, hasNotifications, isSelected));
				} else {
					var _v3 = $author$project$MessageArray$last(thread.messages);
					if (!_v3.$) {
						var message = _v3.a;
						return $ianmackenzie$elm_units$Quantity$lessThan$(
							$ianmackenzie$elm_units$Duration$week,
							$ianmackenzie$elm_units$Duration$from$(
								$author$project$Message$createdAt(message),
								now)) ? $elm$core$Maybe$Just(
							_Utils_Tuple3(threadMessageIndex, hasNotifications, isSelected)) : $elm$core$Maybe$Nothing;
					} else {
						return $elm$core$Maybe$Just(
							_Utils_Tuple3(threadMessageIndex, hasNotifications, isSelected));
					}
				}
			},
			$lamdera$containers$SeqDict$toList(threads));
		var count = $elm$core$List$length(threads2);
		return $author$project$Ui$column$(
			_List_Nil,
			$elm$core$List$indexedMap$(
				F2(
					function (index, _v1) {
						var threadMessageIndex = _v1.a;
						var hasNotifications = _v1.b;
						var isSelected = _v1.c;
						return $author$project$Pages$Guild$channelColumnThreadsHelper$(
							isMobile,
							isSelected,
							0,
							hasNotifications,
							index,
							count,
							$lamdera$program_test$Effect$Browser$Dom$id(
								'guild_viewSlackDmThread_' + ($author$project$Slack$idToString(dmChannelId) + ('_' + $author$project$Id$toString(threadMessageIndex)))),
							$author$project$Route$SlackDmRoute(
								{
									channelId: dmChannelId,
									channelsVisible: 0,
									currentSlackUserId: currentUserId,
									overlay: $elm$core$Maybe$Nothing,
									threadRoute: $author$project$Id$ViewThreadWithMaybeMessage$(threadMessageIndex, $elm$core$Maybe$Nothing)
								}),
							$author$project$Pages$Guild$threadPreviewText$(localUser.timezone, localUser.slackUsers, $lamdera$containers$SeqDict$empty, threadMessageIndex, $lamdera$containers$SeqDict$empty, dmChannel));
					}),
				threads2));
	} else {
		return $author$project$Ui$none;
	}
};
var $author$project$Pages$Guild$slackDmColumnThreads = F7($author$project$Pages$Guild$slackDmColumnThreads$);
var $author$project$User$multipleSlackProfileImages = function (profileImages) {
	if (!profileImages.b) {
		return $author$project$Ui$none;
	} else {
		if (!profileImages.b.b) {
			var single = profileImages.a;
			return $author$project$User$profileImage(
				$elm$core$Maybe$Just(single));
		} else {
			if (!profileImages.b.b.b) {
				var one = profileImages.a;
				var _v1 = profileImages.b;
				var two = _v1.a;
				return $author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$width(
							$author$project$Ui$px(40)),
							$author$project$Ui$height(
							$author$project$Ui$px(40)),
							$author$project$Ui$inFront(
							$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$move(
										{x: 15, y: 15, z: 0})
									]),
								$author$project$User$smallProfileImage$(
									false,
									$elm$core$Maybe$Just(two)))),
							$author$project$Ui$inFront(
							$author$project$User$smallProfileImage$(
								false,
								$elm$core$Maybe$Just(one)))
						]),
					$author$project$Ui$none);
			} else {
				if (!profileImages.b.b.b.b) {
					var one = profileImages.a;
					var _v2 = profileImages.b;
					var two = _v2.a;
					var _v3 = _v2.b;
					var three = _v3.a;
					return $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$width(
								$author$project$Ui$px(55)),
								$author$project$Ui$height(
								$author$project$Ui$px(40)),
								$author$project$Ui$inFront(
								$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$move(
											{x: 30, y: 0, z: 0})
										]),
									$author$project$User$smallProfileImage$(
										false,
										$elm$core$Maybe$Just(three)))),
								$author$project$Ui$inFront(
								$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$move(
											{x: 15, y: 15, z: 0})
										]),
									$author$project$User$smallProfileImage$(
										false,
										$elm$core$Maybe$Just(two)))),
								$author$project$Ui$inFront(
								$author$project$User$smallProfileImage$(
									false,
									$elm$core$Maybe$Just(one)))
							]),
						$author$project$Ui$none);
				} else {
					if (!profileImages.b.b.b.b.b) {
						var one = profileImages.a;
						var _v4 = profileImages.b;
						var two = _v4.a;
						var _v5 = _v4.b;
						var three = _v5.a;
						var _v6 = _v5.b;
						var four = _v6.a;
						return $author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$width(
									$author$project$Ui$px(70)),
									$author$project$Ui$height(
									$author$project$Ui$px(40)),
									$author$project$Ui$inFront(
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$move(
												{x: 45, y: 15, z: 0})
											]),
										$author$project$User$smallProfileImage$(
											false,
											$elm$core$Maybe$Just(four)))),
									$author$project$Ui$inFront(
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$move(
												{x: 30, y: 0, z: 0})
											]),
										$author$project$User$smallProfileImage$(
											false,
											$elm$core$Maybe$Just(three)))),
									$author$project$Ui$inFront(
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$move(
												{x: 15, y: 15, z: 0})
											]),
										$author$project$User$smallProfileImage$(
											false,
											$elm$core$Maybe$Just(two)))),
									$author$project$Ui$inFront(
									$author$project$User$smallProfileImage$(
										false,
										$elm$core$Maybe$Just(one)))
								]),
							$author$project$Ui$none);
					} else {
						var one = profileImages.a;
						var _v7 = profileImages.b;
						var two = _v7.a;
						var _v8 = _v7.b;
						var three = _v8.a;
						var rest = _v8.b;
						return $author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$width(
									$author$project$Ui$px(70)),
									$author$project$Ui$height(
									$author$project$Ui$px(40)),
									$author$project$Ui$inFront(
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$move(
												{x: 30, y: 0, z: 0})
											]),
										$author$project$User$smallProfileImage$(
											false,
											$elm$core$Maybe$Just(three)))),
									$author$project$Ui$inFront(
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$move(
												{x: 15, y: 15, z: 0})
											]),
										$author$project$User$smallProfileImage$(
											false,
											$elm$core$Maybe$Just(two)))),
									$author$project$Ui$inFront(
									$author$project$User$smallProfileImage$(
										false,
										$elm$core$Maybe$Just(one))),
									$author$project$Ui$inFront(
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$move(
												{x: 45, y: 15, z: 0}),
												$author$project$Ui$background($author$project$MyUi$background1),
												$author$project$Ui$width(
												$author$project$Ui$px($author$project$User$smallProfileImageSize)),
												$author$project$Ui$height(
												$author$project$Ui$px($author$project$User$smallProfileImageSize)),
												$author$project$Ui$Font$center,
												$author$project$Ui$Font$bold,
												$author$project$Ui$rounded(8),
												$author$project$Ui$Font$color($author$project$MyUi$font3),
												$author$project$Ui$Font$size(14),
												$author$project$Ui$contentCenterY,
												$author$project$MyUi$htmlStyle$('white-space', 'pre')
											]),
										$author$project$Ui$text(
											'+' + $elm$core$String$fromInt(
												$elm$core$List$length(rest)))))
								]),
							$author$project$Ui$none);
					}
				}
			}
		}
	}
};
var $author$project$Pages$Guild$slackDmMembers$ = function (currentSlackUserId, dmChannel) {
	var _v0 = $elm$core$List$filter$(
		function (userId) {
			return !_Utils_eq(userId, currentSlackUserId);
		},
		$author$project$NonemptySet$toList(dmChannel.members));
	if (!_v0.b) {
		return _List_fromArray(
			[currentSlackUserId]);
	} else {
		var otherMembers = _v0;
		return otherMembers;
	}
};
var $author$project$Pages$Guild$slackDmMembers = F2($author$project$Pages$Guild$slackDmMembers$);
var $elm$svg$Svg$Attributes$enableBackground = _VirtualDom_attribute('enable-background');
var $author$project$Icons$slack = function (size) {
	return A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$enableBackground('new 0 0 2447.6 2452.5'),
				$elm$svg$Svg$Attributes$viewBox('0 0 2447.6 2452.5'),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromInt(size))
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$clipRule('evenodd'),
						$elm$svg$Svg$Attributes$fillRule('evenodd')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m897.4 0c-135.3.1-244.8 109.9-244.7 245.2-.1 135.3 109.5 245.1 244.8 245.2h244.8v-245.1c.1-135.3-109.5-245.1-244.9-245.3.1 0 .1 0 0 0m0 654h-652.6c-135.3.1-244.9 109.9-244.8 245.2-.2 135.3 109.4 245.1 244.7 245.3h652.7c135.3-.1 244.9-109.9 244.8-245.2.1-135.4-109.5-245.2-244.8-245.3z'),
								$elm$svg$Svg$Attributes$fill('#36c5f0')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m2447.6 899.2c.1-135.3-109.5-245.1-244.8-245.2-135.3.1-244.9 109.9-244.8 245.2v245.3h244.8c135.3-.1 244.9-109.9 244.8-245.3zm-652.7 0v-654c.1-135.2-109.4-245-244.7-245.2-135.3.1-244.9 109.9-244.8 245.2v654c-.2 135.3 109.4 245.1 244.7 245.3 135.3-.1 244.9-109.9 244.8-245.3z'),
								$elm$svg$Svg$Attributes$fill('#2eb67d')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m1550.1 2452.5c135.3-.1 244.9-109.9 244.8-245.2.1-135.3-109.5-245.1-244.8-245.2h-244.8v245.2c-.1 135.2 109.5 245 244.8 245.2zm0-654.1h652.7c135.3-.1 244.9-109.9 244.8-245.2.2-135.3-109.4-245.1-244.7-245.3h-652.7c-135.3.1-244.9 109.9-244.8 245.2-.1 135.4 109.4 245.2 244.7 245.3z'),
								$elm$svg$Svg$Attributes$fill('#ecb22e')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('m0 1553.2c-.1 135.3 109.5 245.1 244.8 245.2 135.3-.1 244.9-109.9 244.8-245.2v-245.2h-244.8c-135.3.1-244.9 109.9-244.8 245.2zm652.7 0v654c-.2 135.3 109.4 245.1 244.7 245.3 135.3-.1 244.9-109.9 244.8-245.2v-653.9c.2-135.3-109.4-245.1-244.7-245.3-135.4 0-244.9 109.8-244.8 245.1 0 0 0 .1 0 0'),
								$elm$svg$Svg$Attributes$fill('#e01e5a')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$GuildIcon$slackNotificationView$ = function (xOffset, yOffset, borderColor, notification) {
	switch (notification.$) {
		case 0:
			return $author$project$Ui$inFront(
				$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$width(
							$author$project$Ui$px($author$project$GuildIcon$notificationHeight)),
							$author$project$Ui$height(
							$author$project$Ui$px($author$project$GuildIcon$notificationHeight)),
							$author$project$Ui$move(
							{x: xOffset, y: yOffset, z: 0}),
							$author$project$Ui$alignRight,
							$author$project$Ui$contentCenterX,
							$author$project$Ui$contentCenterY,
							$author$project$Ui$Accessibility$description('Slack'),
							$author$project$MyUi$noPointerEvents,
							$author$project$Ui$background(
							$author$project$Ui$rgb$(230, 230, 230)),
							$author$project$Ui$rounded(99)
						]),
					$author$project$Ui$html(
						$author$project$Icons$slack(13))));
		case 1:
			var count = notification.a;
			return $author$project$GuildIcon$notificationHelper$($author$project$MyUi$white, $author$project$MyUi$black, borderColor, xOffset, yOffset, count);
		default:
			var count = notification.a;
			return $author$project$GuildIcon$notificationHelper$($author$project$MyUi$alertColor, $author$project$MyUi$white, borderColor, xOffset, yOffset, count);
	}
};
var $author$project$GuildIcon$slackNotificationView = F4($author$project$GuildIcon$slackNotificationView$);
var $author$project$Pages$Guild$slackFriendLabel$ = function (isMobile, time, isSelected, dmChannelId, channel, localUser) {
	var message = $author$project$MessageArray$last(channel.messages);
	var messagePreview = function () {
		if (!message.$) {
			var message2 = message.a;
			switch (message2.$) {
				case 0:
					var a = message2.a;
					return _Utils_ap(
						$lamdera$containers$SeqDict$member$(a.createdBy, localUser.linkedSlackUsers) ? 'You: ' : '',
						$author$project$RichText$toString$(localUser.timezone, true, localUser.slackUsers, $lamdera$containers$SeqDict$empty, a.content.content));
				case 1:
					var a = message2.a;
					return $lamdera$containers$SeqDict$member$(a.createdBy, localUser.linkedSlackUsers) ? ('You: ' + $author$project$RichText$failedToDecryptMessageText) : $author$project$RichText$failedToDecryptMessageText;
				case 2:
					var userId = message2.b;
					return $author$project$User$toString$(userId, localUser.slackUsers) + ' joined!';
				case 3:
					return $author$project$LocalState$messageDeleted;
				case 4:
					var endedAt = message2.a.endedAt;
					return $author$project$LocalState$callStartedText(endedAt);
				default:
					var gameType = message2.a.gameType;
					return $author$project$LocalState$gameStartedText(gameType);
			}
		} else {
			return '';
		}
	}();
	var _v0 = $elmcraft$core_extra$List$Extra$find$(
		function (userId) {
			return $lamdera$containers$SeqDict$member$(userId, localUser.linkedSlackUsers);
		},
		$author$project$NonemptySet$toList(channel.members));
	if (!_v0.$) {
		var currentUserId = _v0.a;
		var members = $author$project$Pages$Guild$slackDmMembers$(currentUserId, channel);
		return $author$project$MyUi$rowButton$(
			$lamdera$program_test$Effect$Browser$Dom$id(
				'guild_slackFriendLabel_' + $author$project$Slack$idToString(dmChannelId)),
			$author$project$Types$PressedLink(
				$author$project$Route$SlackDmRoute(
					{
						channelId: dmChannelId,
						channelsVisible: 0,
						currentSlackUserId: currentUserId,
						overlay: $elm$core$Maybe$Nothing,
						threadRoute: $author$project$Id$NoThreadWithMaybeMessage($elm$core$Maybe$Nothing)
					})),
			_List_fromArray(
				[
					$author$project$Ui$clipWithEllipsis,
					$author$project$Ui$spacing(8),
					$author$project$MyUi$hoverText(messagePreview),
					$author$project$Ui$padding(4),
					$author$project$Ui$Font$color(
					isSelected ? $author$project$MyUi$font1 : $author$project$MyUi$font3),
					$author$project$MyUi$hover$(
					isMobile,
					_List_fromArray(
						[
							$author$project$Ui$Anim$fontColor($author$project$MyUi$font1)
						])),
					$author$project$Ui$attrIf$(
					isSelected,
					$author$project$Ui$background($author$project$MyUi$selectedHighlight))
				]),
			_List_fromArray(
				[
					$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$GuildIcon$slackNotificationView$(
							4,
							-3,
							$author$project$MyUi$background2,
							function () {
								if (isSelected) {
									return $author$project$GuildIcon$NoNotification;
								} else {
									var _v1 = $author$project$GuildColumn$slackDmHasNotifications$(localUser, dmChannelId, channel);
									if (!_v1.$) {
										var _v2 = _v1.a;
										var count = _v2.b;
										return $author$project$GuildIcon$NewMessageForUser(count);
									} else {
										return $author$project$GuildIcon$NoNotification;
									}
								}
							}()),
							$author$project$Ui$width($author$project$Ui$shrink)
						]),
					$author$project$User$multipleSlackProfileImages(
						$elm$core$List$filterMap$(
							function (userId) {
								return $lamdera$containers$SeqDict$get$(userId, localUser.slackUsers);
							},
							members))),
					$author$project$Ui$column$(
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$el$(
							_List_fromArray(
								[$author$project$Ui$Font$bold]),
							$author$project$Ui$text(
								$elm$core$String$join$(
									', ',
									$elm$core$List$map$(
										function (userId) {
											return $author$project$User$toString$(userId, localUser.slackUsers);
										},
										members)))),
							$author$project$Pages$Guild$friendLabelMessagePreview$(time, messagePreview, message)
						]))
				]));
	} else {
		return $author$project$Ui$none;
	}
};
var $author$project$Pages$Guild$slackFriendLabel = F6($author$project$Pages$Guild$slackFriendLabel$);
var $author$project$Pages$Guild$slackFriendLabelMobile$ = function (time, isSelected, dmChannelId, channel, localUser) {
	return $author$project$Pages$Guild$slackFriendLabel$(
		true,
		$elm$time$Time$millisToPosix(time),
		isSelected,
		dmChannelId,
		channel,
		localUser);
};
var $author$project$Pages$Guild$slackFriendLabelMobile = F5($author$project$Pages$Guild$slackFriendLabelMobile$);
var $author$project$Pages$Guild$slackFriendLabelNotMobile$ = function (time, isSelected, dmChannelId, channel, localUser) {
	return $author$project$Pages$Guild$slackFriendLabel$(
		false,
		$elm$time$Time$millisToPosix(time),
		isSelected,
		dmChannelId,
		channel,
		localUser);
};
var $author$project$Pages$Guild$slackFriendLabelNotMobile = F5($author$project$Pages$Guild$slackFriendLabelNotMobile$);
var $author$project$Pages$Guild$friendsColumn$ = function (canScroll2, isMobile, currentTime, dmChannelSelection, dmChannels, discordDmChannels, slackDmChannels, localUser) {
	var dmChannelsIncludingCurrentUser = $lamdera$containers$SeqDict$update$(
		localUser.session.userId,
		function (maybe) {
			return $elm$core$Maybe$Just(
				$elm$core$Maybe$withDefault$($author$project$DmChannel$frontendInit, maybe));
		},
		dmChannels);
	var discordDmChannelsIncludingLinkedUsers = discordDmChannels;
	var columnItems = _Utils_ap(
		$elm$core$List$filterMap$(
			function (_v3) {
				var otherUserId = _v3.a;
				var dmChannel = _v3.b;
				var _v4 = $author$project$User$getUser$(otherUserId, localUser);
				if (!_v4.$) {
					var otherUser = _v4.a;
					var threadRoute = function () {
						switch (dmChannelSelection.$) {
							case 0:
								var dmRoute = dmChannelSelection.a;
								return _Utils_eq(
									$author$project$DmChannelId$otherUserId$(localUser.session.userId, dmRoute.channelId),
									$elm$core$Maybe$Just(otherUserId)) ? $elm$core$Maybe$Just(dmRoute.threadRoute) : $elm$core$Maybe$Nothing;
							case 1:
								return $elm$core$Maybe$Nothing;
							case 2:
								return $elm$core$Maybe$Nothing;
							default:
								return $elm$core$Maybe$Nothing;
						}
					}();
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							function () {
								var _v5 = $author$project$MessageArray$last(dmChannel.messages);
								if (!_v5.$) {
									var message2 = _v5.a;
									return $author$project$Message$createdAt(message2);
								} else {
									return $elm$time$Time$millisToPosix(0);
								}
							}(),
							$author$project$Ui$column$(
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Lazy$lazy5$(
										isMobile ? $author$project$Pages$Guild$friendLabelMobile : $author$project$Pages$Guild$friendLabelNotMobile,
										$author$project$Pages$Guild$encodeFriendLabel$(
											function () {
												if ((!threadRoute.$) && (!threadRoute.a.$)) {
													var _v7 = threadRoute.a;
													return true;
												} else {
													return false;
												}
											}(),
											currentTime),
										localUser,
										otherUserId,
										otherUser,
										dmChannel),
										$author$project$Pages$Guild$dmColumnThreads$(
										isMobile,
										$elm$time$Time$millisToPosix(currentTime),
										threadRoute,
										localUser,
										otherUserId,
										dmChannel,
										function () {
											if ((!threadRoute.$) && (threadRoute.a.$ === 1)) {
												var _v9 = threadRoute.a;
												var threadMessageIndex = _v9.a;
												return $lamdera$containers$SeqDict$insert$(threadMessageIndex, $author$project$Thread$frontendInit, dmChannel.threads);
											} else {
												return dmChannel.threads;
											}
										}())
									]))));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			$lamdera$containers$SeqDict$toList(dmChannelsIncludingCurrentUser)),
		_Utils_ap(
			$elm$core$List$map$(
				function (_v11) {
					var channelId = _v11.a;
					var dmChannel = _v11.b;
					return _Utils_Tuple2(
						function () {
							var _v12 = $author$project$MessageArray$last(dmChannel.messages);
							if (!_v12.$) {
								var message2 = _v12.a;
								return $author$project$Message$createdAt(message2);
							} else {
								return $elm$time$Time$millisToPosix(0);
							}
						}(),
						$author$project$Ui$Lazy$lazy5$(
							isMobile ? $author$project$Pages$Guild$discordFriendLabelMobile : $author$project$Pages$Guild$discordFriendLabelNotMobile,
							currentTime,
							function () {
								if (dmChannelSelection.$ === 1) {
									var routeData = dmChannelSelection.a;
									return _Utils_eq(routeData.channelId, channelId);
								} else {
									return false;
								}
							}(),
							channelId,
							dmChannel,
							localUser));
				},
				$lamdera$containers$SeqDict$toList(discordDmChannelsIncludingLinkedUsers)),
			$elm$core$List$map$(
				function (_v14) {
					var channelId = _v14.a;
					var dmChannel = _v14.b;
					return _Utils_Tuple2(
						function () {
							var _v15 = $author$project$MessageArray$last(dmChannel.messages);
							if (!_v15.$) {
								var message2 = _v15.a;
								return $author$project$Message$createdAt(message2);
							} else {
								return $elm$time$Time$millisToPosix(0);
							}
						}(),
						function () {
							var threadRoute = function () {
								switch (dmChannelSelection.$) {
									case 2:
										var routeData = dmChannelSelection.a;
										return _Utils_eq(routeData.channelId, channelId) ? $elm$core$Maybe$Just(routeData.threadRoute) : $elm$core$Maybe$Nothing;
									case 0:
										return $elm$core$Maybe$Nothing;
									case 1:
										return $elm$core$Maybe$Nothing;
									default:
										return $elm$core$Maybe$Nothing;
								}
							}();
							return $author$project$Ui$column$(
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Lazy$lazy5$(
										isMobile ? $author$project$Pages$Guild$slackFriendLabelMobile : $author$project$Pages$Guild$slackFriendLabelNotMobile,
										currentTime,
										function () {
											if (!threadRoute.$) {
												if (!threadRoute.a.$) {
													return true;
												} else {
													var _v17 = threadRoute.a;
													return false;
												}
											} else {
												return false;
											}
										}(),
										channelId,
										dmChannel,
										localUser),
										$author$project$Pages$Guild$slackDmColumnThreads$(
										isMobile,
										$elm$time$Time$millisToPosix(currentTime),
										threadRoute,
										localUser,
										channelId,
										dmChannel,
										function () {
											if (!threadRoute.$) {
												if (threadRoute.a.$ === 1) {
													var _v19 = threadRoute.a;
													var threadId = _v19.a;
													return $lamdera$containers$SeqDict$update$(
														threadId,
														function (maybeThread) {
															return $elm$core$Maybe$Just(
																$elm$core$Maybe$withDefault$($author$project$Thread$frontendInit, maybeThread));
														},
														dmChannel.threads);
												} else {
													return dmChannel.threads;
												}
											} else {
												return dmChannel.threads;
											}
										}())
									]));
						}());
				},
				$lamdera$containers$SeqDict$toList(slackDmChannels))));
	return $author$project$Pages$Guild$channelColumnContainer$(
		localUser.safeAreaInsetTop,
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Font$bold,
						$author$project$Ui$paddingXY$(0, 8),
						$author$project$Ui$Font$color($author$project$MyUi$font2)
					]),
				$author$project$Ui$text($author$project$Pages$Guild$directMessagesText)),
				$author$project$Pages$Guild$searchIcon(isMobile)
			]),
		function () {
			if (columnItems.b && (!columnItems.b.b)) {
				var _v1 = columnItems.a;
				var single = _v1.b;
				return $author$project$Ui$column$(
					_List_fromArray(
						[
							$author$project$MyUi$scrollable(canScroll2),
							$author$project$Ui$heightMin(0)
						]),
					_List_fromArray(
						[
							single,
							$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$Font$size(16),
									$author$project$Ui$padding(8),
									$author$project$Ui$Font$color($author$project$MyUi$font3)
								]),
							$author$project$Ui$text('Join a guild and then click on someone\u0027s profile image to start a chat!'))
						]));
			} else {
				return $author$project$Ui$column$(
					_List_fromArray(
						[
							$author$project$MyUi$scrollable(canScroll2),
							$author$project$Ui$heightMin(0)
						]),
					$elm$core$List$map$(
						$elm$core$Tuple$second,
						A2(
							$elm$core$List$sortBy,
							function (_v2) {
								var time = _v2.a;
								return -$elm$time$Time$posixToMillis(time);
							},
							columnItems)));
			}
		}());
};
var $author$project$Pages$Guild$friendsColumn = F8($author$project$Pages$Guild$friendsColumn$);
var $author$project$Pages$Guild$friendsColumn_NoDmChannelSelected$ = function (packed, isMobile, dmChannels, discordDmChannels, slackDmChannels, localUser) {
	var _v0 = $author$project$Pages$Guild$decodeFriendsColumn(packed);
	var time = _v0.time;
	var canScroll = _v0.canScroll;
	return $author$project$Pages$Guild$friendsColumn$(canScroll, isMobile, time, $author$project$Pages$Guild$NoDmChannelSelected, dmChannels, discordDmChannels, slackDmChannels, localUser);
};
var $author$project$Pages$Guild$friendsColumn_NoDmChannelSelected = F6($author$project$Pages$Guild$friendsColumn_NoDmChannelSelected$);
var $author$project$Pages$Guild$friendsColumn_SelectedDiscordDmChannel_Mobile$ = function (packed, discordDmRoute, dmChannels, discordDmChannels, slackDmChannels, localUser) {
	var _v0 = $author$project$Pages$Guild$decodeFriendsColumn(packed);
	var time = _v0.time;
	var canScroll = _v0.canScroll;
	return $author$project$Pages$Guild$friendsColumn$(
		canScroll,
		true,
		time,
		$author$project$Pages$Guild$SelectedDiscordDmChannel(discordDmRoute),
		dmChannels,
		discordDmChannels,
		slackDmChannels,
		localUser);
};
var $author$project$Pages$Guild$friendsColumn_SelectedDiscordDmChannel_Mobile = F6($author$project$Pages$Guild$friendsColumn_SelectedDiscordDmChannel_Mobile$);
var $author$project$Pages$Guild$friendsColumn_SelectedDiscordDmChannel_NotMobile$ = function (packed, discordDmRoute, dmChannels, discordDmChannels, slackDmChannels, localUser) {
	var _v0 = $author$project$Pages$Guild$decodeFriendsColumn(packed);
	var time = _v0.time;
	var canScroll = _v0.canScroll;
	return $author$project$Pages$Guild$friendsColumn$(
		canScroll,
		false,
		time,
		$author$project$Pages$Guild$SelectedDiscordDmChannel(discordDmRoute),
		dmChannels,
		discordDmChannels,
		slackDmChannels,
		localUser);
};
var $author$project$Pages$Guild$friendsColumn_SelectedDiscordDmChannel_NotMobile = F6($author$project$Pages$Guild$friendsColumn_SelectedDiscordDmChannel_NotMobile$);
var $author$project$Pages$Guild$friendsColumn_SelectedDmChannel_Mobile$ = function (packed, dmRoute, dmChannels, discordDmChannels, slackDmChannels, localUser) {
	var _v0 = $author$project$Pages$Guild$decodeFriendsColumn(packed);
	var time = _v0.time;
	var canScroll = _v0.canScroll;
	return $author$project$Pages$Guild$friendsColumn$(
		canScroll,
		true,
		time,
		$author$project$Pages$Guild$SelectedDmChannel(dmRoute),
		dmChannels,
		discordDmChannels,
		slackDmChannels,
		localUser);
};
var $author$project$Pages$Guild$friendsColumn_SelectedDmChannel_Mobile = F6($author$project$Pages$Guild$friendsColumn_SelectedDmChannel_Mobile$);
var $author$project$Pages$Guild$friendsColumn_SelectedDmChannel_NotMobile$ = function (packed, dmRoute, dmChannels, discordDmChannels, slackDmChannels, localUser) {
	var _v0 = $author$project$Pages$Guild$decodeFriendsColumn(packed);
	var time = _v0.time;
	var canScroll = _v0.canScroll;
	return $author$project$Pages$Guild$friendsColumn$(
		canScroll,
		false,
		time,
		$author$project$Pages$Guild$SelectedDmChannel(dmRoute),
		dmChannels,
		discordDmChannels,
		slackDmChannels,
		localUser);
};
var $author$project$Pages$Guild$friendsColumn_SelectedDmChannel_NotMobile = F6($author$project$Pages$Guild$friendsColumn_SelectedDmChannel_NotMobile$);
var $author$project$Pages$Guild$friendsColumn_SelectedSlackDmChannel_Mobile$ = function (packed, slackDmRoute, dmChannels, discordDmChannels, slackDmChannels, localUser) {
	var _v0 = $author$project$Pages$Guild$decodeFriendsColumn(packed);
	var time = _v0.time;
	var canScroll = _v0.canScroll;
	return $author$project$Pages$Guild$friendsColumn$(
		canScroll,
		true,
		time,
		$author$project$Pages$Guild$SelectedSlackDmChannel(slackDmRoute),
		dmChannels,
		discordDmChannels,
		slackDmChannels,
		localUser);
};
var $author$project$Pages$Guild$friendsColumn_SelectedSlackDmChannel_Mobile = F6($author$project$Pages$Guild$friendsColumn_SelectedSlackDmChannel_Mobile$);
var $author$project$Pages$Guild$friendsColumn_SelectedSlackDmChannel_NotMobile$ = function (packed, slackDmRoute, dmChannels, discordDmChannels, slackDmChannels, localUser) {
	var _v0 = $author$project$Pages$Guild$decodeFriendsColumn(packed);
	var time = _v0.time;
	var canScroll = _v0.canScroll;
	return $author$project$Pages$Guild$friendsColumn$(
		canScroll,
		false,
		time,
		$author$project$Pages$Guild$SelectedSlackDmChannel(slackDmRoute),
		dmChannels,
		discordDmChannels,
		slackDmChannels,
		localUser);
};
var $author$project$Pages$Guild$friendsColumn_SelectedSlackDmChannel_NotMobile = F6($author$project$Pages$Guild$friendsColumn_SelectedSlackDmChannel_NotMobile$);
var $author$project$Pages$Guild$friendsColumnLazy$ = function (canScroll2, isMobile, currentTime, openedOtherUserId, local) {
	var currentTimeRoundedToMinute = $author$project$Pages$Guild$msInMinute * (($elm$time$Time$posixToMillis(currentTime) / $author$project$Pages$Guild$msInMinute) | 0);
	var packed = $author$project$Pages$Guild$encodeFriendsColumn$(canScroll2, currentTimeRoundedToMinute);
	switch (openedOtherUserId.$) {
		case 3:
			return $author$project$Ui$Lazy$lazy6$($author$project$Pages$Guild$friendsColumn_NoDmChannelSelected, packed, isMobile, local.dmChannels, local.discordDmChannels, local.slackDmChannels, local.localUser);
		case 0:
			var dmRouteData = openedOtherUserId.a;
			return $author$project$Ui$Lazy$lazy6$(
				isMobile ? $author$project$Pages$Guild$friendsColumn_SelectedDmChannel_Mobile : $author$project$Pages$Guild$friendsColumn_SelectedDmChannel_NotMobile,
				packed,
				dmRouteData,
				local.dmChannels,
				local.discordDmChannels,
				local.slackDmChannels,
				local.localUser);
		case 2:
			var slackDmRouteData = openedOtherUserId.a;
			return $author$project$Ui$Lazy$lazy6$(
				isMobile ? $author$project$Pages$Guild$friendsColumn_SelectedSlackDmChannel_Mobile : $author$project$Pages$Guild$friendsColumn_SelectedSlackDmChannel_NotMobile,
				packed,
				slackDmRouteData,
				local.dmChannels,
				local.discordDmChannels,
				local.slackDmChannels,
				local.localUser);
		default:
			var discordDmRouteData = openedOtherUserId.a;
			return $author$project$Ui$Lazy$lazy6$(
				isMobile ? $author$project$Pages$Guild$friendsColumn_SelectedDiscordDmChannel_Mobile : $author$project$Pages$Guild$friendsColumn_SelectedDiscordDmChannel_NotMobile,
				packed,
				discordDmRouteData,
				local.dmChannels,
				local.discordDmChannels,
				local.slackDmChannels,
				local.localUser);
	}
};
var $author$project$Pages$Guild$friendsColumnLazy = F5($author$project$Pages$Guild$friendsColumnLazy$);
var $author$project$ChannelHeader$slackChannel$ = function (isMobile, name, guildOrDmIdNoThread, route) {
	return $author$project$ChannelHeader$channelHeader$(
		isMobile,
		function () {
			if (guildOrDmIdNoThread.$ === 1) {
				return $author$project$Ui$row$(
					_List_fromArray(
						[
							$author$project$Ui$Font$color($author$project$MyUi$font1),
							$author$project$Ui$spacing(5),
							$author$project$Ui$clipWithEllipsis,
							$author$project$Ui$contentCenterY,
							$author$project$Ui$height($author$project$Ui$fill)
						]),
					isMobile ? _List_fromArray(
						[
							$author$project$Ui$text(name)
						]) : _List_fromArray(
						[
							$author$project$Ui$text('Chat with '),
							$author$project$Ui$text(name)
						]));
			} else {
				return $author$project$Ui$row$(
					_List_fromArray(
						[
							$author$project$Ui$Font$color($author$project$MyUi$font1),
							$author$project$Ui$spacing(2),
							$author$project$Ui$clipWithEllipsis,
							$author$project$Ui$contentCenterY,
							$author$project$Ui$height($author$project$Ui$fill)
						]),
					_List_fromArray(
						[
							$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$MyUi$noShrinking,
									$author$project$Ui$width($author$project$Ui$shrink)
								]),
							$author$project$Ui$html($author$project$Icons$hashtag)),
							$author$project$Ui$text(name),
							$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$MyUi$noShrinking,
									$author$project$Ui$width($author$project$Ui$shrink),
									$author$project$Ui$alignRight,
									$author$project$Ui$height($author$project$Ui$fill)
								]),
							$elm$core$Maybe$withDefault$(
								$author$project$Ui$none,
								$author$project$ChannelHeader$channelSettingsTab$(isMobile, route)))
						]));
			}
		}(),
		$elm$core$Maybe$Nothing);
};
var $author$project$ChannelHeader$slackChannel = F4($author$project$ChannelHeader$slackChannel$);
var $author$project$MessageView$slackMiniView$ = function (user, isThreadStarter, canEdit, emojiData, customEmojis) {
	return $author$project$MessageView$miniViewContainer$(
		-48,
		_Utils_ap(
			$author$project$MessageView$recentEmojiButtons$(user, $lamdera$containers$SeqSet$empty, emojiData, customEmojis),
			_List_fromArray(
				[
					$author$project$MessageView$miniButton$(
					$lamdera$program_test$Effect$Browser$Dom$id('miniView_showReactionEmojiSelector'),
					$author$project$MessageView$MessageViewMsg_PressedShowReactionEmojiSelector,
					'Add reaction',
					$author$project$Icons$smile),
					canEdit ? $author$project$MessageView$miniButton$(
					$lamdera$program_test$Effect$Browser$Dom$id('miniView_editMessage'),
					$author$project$MessageView$MessageViewMsg_PressedEditMessage,
					'Edit message',
					$author$project$Icons$pencil) : $author$project$Ui$none,
					isThreadStarter ? $author$project$Ui$none : $author$project$MessageView$miniButton$(
					$lamdera$program_test$Effect$Browser$Dom$id('miniView_startThread'),
					$author$project$MessageView$MessageView_PressedViewThreadLink,
					'Start thread',
					$author$project$Icons$hashtag),
					$author$project$MessageView$miniButtonWithPosition$(
					$lamdera$program_test$Effect$Browser$Dom$id('miniView_showFullMenu'),
					$author$project$MessageView$MessageViewMsg_PressedShowFullMenu(isThreadStarter),
					$author$project$Icons$dotDotDot)
				])));
};
var $author$project$MessageView$slackMiniView = F5($author$project$MessageView$slackMiniView$);
var $author$project$Pages$Guild$slackMessageContainer$ = function (containerWidth, canEdit, isThreadStarter, timezone, currentTime, customEmojis, emojiData, allUsers, channels, highlight, messageIndex, currentUserId, currentUser, reactions, maybeThread, isHovered, messageContent) {
	var maybeReactions = $author$project$MessageView$reactionEmojiView$(
		emojiData,
		$author$project$Pages$Guild$reactionsHover(isHovered),
		currentUserId,
		customEmojis,
		allUsers,
		$author$project$Pages$Guild$isHoveredToAnimationMode(isHovered),
		containerWidth,
		reactions);
	return $author$project$Ui$column$(
		_Utils_ap(
			_List_fromArray(
				[
					$author$project$Ui$Font$color($author$project$MyUi$font1),
					$author$project$Ui$Events$onMouseEnter($author$project$MessageView$MessageView_MouseEnteredMessage),
					$author$project$Ui$Events$onMouseLeave($author$project$MessageView$MessageView_MouseExitedMessage),
					$author$project$Ui$Events$on$(
					'touchstart',
					A3(
						$elm$json$Json$Decode$map2,
						F2(
							function (toMsg, target) {
								return A3(toMsg, target.imageUrl, target.linkUrl, target.reactionIndex);
							}),
						$author$project$Touch$decodeTouchEvent(
							F5(
								function (time, touches, imageUrl, linkUrl, reactionIndex) {
									return $author$project$MessageView$MessageView_TouchStart$(time, isThreadStarter, imageUrl, linkUrl, reactionIndex, touches);
								})),
						$author$project$Pages$Guild$decodeEventTarget)),
					$author$project$Ui$Events$preventDefaultOn$(
					'contextmenu',
					$author$project$Pages$Guild$decodeMessageContextMenu(isThreadStarter)),
					$author$project$Ui$paddingWith(
					{
						bottom: _Utils_eq(maybeReactions, $elm$core$Maybe$Nothing) ? 8 : 4,
						left: $author$project$Pages$Guild$messagePaddingX,
						right: $author$project$Pages$Guild$messagePaddingX,
						top: 4
					}),
					$author$project$Ui$spacing(4),
					$author$project$Ui$id(
					$lamdera$program_test$Effect$Browser$Dom$idToString(
						$author$project$Pages$Guild$channelMessageHtmlId(messageIndex)))
				]),
			_Utils_ap(
				function () {
					switch (isHovered.$) {
						case 0:
							return _List_fromArray(
								[
									$author$project$Ui$behindContent($author$project$Ui$none)
								]);
						case 1:
							return _List_fromArray(
								[
									$author$project$MyUi$hoverHighlightLayer,
									$author$project$Ui$inFront(
									$author$project$MessageView$slackMiniView$(currentUser, isThreadStarter, canEdit, emojiData, customEmojis))
								]);
						case 2:
							return _List_fromArray(
								[$author$project$MyUi$hoverHighlightLayer]);
						case 3:
							return _List_fromArray(
								[
									$author$project$MyUi$hoverHighlightLayer,
									$author$project$Ui$inFront(
									$author$project$MessageView$reactionsMiniView$(currentUser, $lamdera$containers$SeqSet$empty, emojiData, customEmojis))
								]);
						case 4:
							return _List_fromArray(
								[
									$author$project$Ui$behindContent($author$project$Ui$none)
								]);
						default:
							return _List_fromArray(
								[
									$author$project$Ui$behindContent($author$project$Ui$none)
								]);
					}
				}(),
				_List_fromArray(
					[
						$author$project$Pages$Guild$highlightLayer(highlight)
					]))),
		A2(
			$elm$core$List$cons,
			messageContent,
			_Utils_ap(
				$elmcraft$core_extra$Maybe$Extra$toList(maybeReactions),
				function () {
					if (!maybeThread.$) {
						var thread = maybeThread.a;
						return _List_fromArray(
							[
								$author$project$Pages$Guild$previewThreadLastMessage$(timezone, currentTime, emojiData, customEmojis, allUsers, channels, $lamdera$containers$SeqDict$empty, messageIndex, thread)
							]);
					} else {
						return _List_Nil;
					}
				}())));
};
var $author$project$Pages$Guild$slackMessageContainer = function (containerWidth) {
	return function (canEdit) {
		return function (isThreadStarter) {
			return function (timezone) {
				return function (currentTime) {
					return function (customEmojis) {
						return function (emojiData) {
							return function (allUsers) {
								return function (channels) {
									return function (highlight) {
										return function (messageIndex) {
											return function (currentUserId) {
												return function (currentUser) {
													return function (reactions) {
														return function (maybeThread) {
															return function (isHovered) {
																return function (messageContent) {
																	return $author$project$Pages$Guild$slackMessageContainer$(containerWidth, canEdit, isThreadStarter, timezone, currentTime, customEmojis, emojiData, allUsers, channels, highlight, messageIndex, currentUserId, currentUser, reactions, maybeThread, isHovered, messageContent);
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Guild$slackUserTextMessageContent$ = function (time, containerWidth, localUser, revealedSpoilers, channels, messageId, _v0, message2) {
	var attachedFiles = _v0.attachedFiles;
	var embeds = _v0.embeds;
	var content = _v0.content;
	var drawings = $elm$core$Maybe$withDefault$($author$project$Message$noDrawings, message2.drawings);
	return $author$project$Ui$row$(
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$paddingWith(
						{bottom: 0, left: 0, right: $author$project$MessageView$profileImagePaddingRight, top: 2}),
						$author$project$Ui$width($author$project$Ui$shrink),
						$author$project$Ui$alignTop
					]),
				$author$project$User$profileImage(
					$lamdera$containers$SeqDict$get$(message2.createdBy, localUser.slackUsers))),
				$author$project$Ui$column$(
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$row$(
						_List_Nil,
						_List_fromArray(
							[
								$author$project$User$toColoredString$(message2.createdBy, localUser.slackUsers),
								$author$project$Pages$Guild$messageTimestamp$(
								$author$project$User$slackUserColor(localUser),
								drawings.timestampDrawings,
								false,
								messageId,
								message2.createdAt,
								localUser.timezone)
							])),
						$author$project$Ui$html(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'white-space', 'pre-wrap')
								]),
							_Utils_ap(
								$author$project$RichText$view$(
									$lamdera$program_test$Effect$Browser$Dom$id(
										'spoiler_' + $author$project$Id$toString(messageId)),
									containerWidth,
									$author$project$MessageView$MessageView_PressedNonWhitelistLink,
									$author$project$MessageView$MessageView_PressedSpoiler,
									$author$project$MessageView$MessageView_PressedImage,
									{
										animationMode: $author$project$Pages$Guild$isHoveredToAnimationMode($author$project$Pages$Guild$IsNotHovered),
										attachedFiles: attachedFiles,
										channels: channels,
										customEmojis: localUser.customEmojis,
										devicePixelRatio: localUser.devicePixelRatio,
										domainWhitelist: localUser.user.domainWhitelist,
										drawingUserColor: $author$project$User$slackUserColor(localUser),
										drawings: drawings.imageAttachmentDrawings,
										embedDrawings: drawings.embedDrawings,
										emojiData: localUser.emojiData,
										isHovered: false,
										isSelectingAnchor: false,
										noOp: $author$project$MessageView$MessageView_NoOp,
										onPressChannelMention: F2(
											function (_v1, _v2) {
												return $author$project$MessageView$MessageView_NoOp;
											}),
										onPressCopyCode: $author$project$MessageView$MessageView_PressedCopyCode,
										revealedSpoilers: function () {
											var _v3 = $lamdera$containers$SeqDict$get$(messageId, revealedSpoilers);
											if (!_v3.$) {
												var nonempty = _v3.a;
												return $author$project$NonemptySet$toSeqSet(nonempty);
											} else {
												return $lamdera$containers$SeqSet$empty;
											}
										}(),
										stickers: localUser.stickers,
										time: time,
										timezone: localUser.timezone,
										users: localUser.slackUsers
									},
									function () {
										var _v4 = localUser.user.embedVisibility;
										if (!_v4) {
											return embeds;
										} else {
											return $elm$core$Array$empty;
										}
									}(),
									content),
								function () {
									var _v5 = message2.editedAt;
									if (!_v5.$) {
										var editedAt = _v5.a;
										return _List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$Attributes$style,
														'color',
														$author$project$MyUi$colorToStyle($author$project$MyUi$dimFont)),
														A2($elm$html$Html$Attributes$style, 'font-size', '12px'),
														$elm$html$Html$Attributes$title(
														$author$project$MyUi$datestamp$(localUser.timezone, editedAt))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(' (edited)')
													]))
											]);
									} else {
										return _List_Nil;
									}
								}())))
					]))
			]));
};
var $author$project$Pages$Guild$slackUserTextMessageContent = F8($author$project$Pages$Guild$slackUserTextMessageContent$);
var $author$project$Pages$Guild$slackMessageView$ = function (time, containerWidth, revealedSpoilers, highlight, currentUserId, channels, localUser, maybeThread, isThreadStarter, isHovered, messageId, message) {
	switch (message.$) {
		case 0:
			var data = message.a;
			return $author$project$Pages$Guild$slackMessageContainer$(
				containerWidth,
				_Utils_eq(data.createdBy, currentUserId),
				isThreadStarter,
				localUser.timezone,
				time,
				localUser.customEmojis,
				localUser.emojiData,
				localUser.slackUsers,
				channels,
				function () {
					if (!highlight) {
						return $lamdera$containers$SeqSet$member$(
							currentUserId,
							$author$project$RichText$mentionsUser(data.content.content)) ? 2 : highlight;
					} else {
						return highlight;
					}
				}(),
				messageId,
				currentUserId,
				localUser.user,
				data.reactions,
				maybeThread,
				isHovered,
				$author$project$Pages$Guild$slackUserTextMessageContent$(time, containerWidth, localUser, revealedSpoilers, channels, messageId, data.content, data));
		case 1:
			return $author$project$Ui$none;
		case 2:
			var joinedAt = message.a;
			var userId = message.b;
			var reactions = message.c;
			var drawings = message.d;
			return $author$project$Pages$Guild$slackMessageContainer$(
				containerWidth,
				false,
				isThreadStarter,
				localUser.timezone,
				time,
				localUser.customEmojis,
				localUser.emojiData,
				localUser.slackUsers,
				channels,
				highlight,
				messageId,
				currentUserId,
				localUser.user,
				reactions,
				maybeThread,
				isHovered,
				$author$project$Ui$row$(
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Guild$userJoinedContent$(userId, localUser.slackUsers),
							$author$project$Pages$Guild$messageTimestamp$(
							$author$project$User$slackUserColor(localUser),
							drawings,
							false,
							messageId,
							joinedAt,
							localUser.timezone)
						])));
		case 3:
			var createdAt = message.a;
			return $author$project$Pages$Guild$slackMessageContainer$(
				containerWidth,
				false,
				isThreadStarter,
				localUser.timezone,
				time,
				localUser.customEmojis,
				localUser.emojiData,
				localUser.slackUsers,
				channels,
				highlight,
				messageId,
				currentUserId,
				localUser.user,
				$lamdera$containers$SeqDict$empty,
				maybeThread,
				isHovered,
				$author$project$Pages$Guild$deletedMessageContent$(messageId, false, createdAt, localUser.timezone));
		case 4:
			return $author$project$Ui$none;
		default:
			return $author$project$Ui$none;
	}
};
var $author$project$Pages$Guild$slackMessageView = function (time) {
	return function (containerWidth) {
		return function (revealedSpoilers) {
			return function (highlight) {
				return function (currentUserId) {
					return function (channels) {
						return function (localUser) {
							return function (maybeThread) {
								return function (isThreadStarter) {
									return function (isHovered) {
										return function (messageId) {
											return function (message) {
												return $author$project$Pages$Guild$slackMessageView$(time, containerWidth, revealedSpoilers, highlight, currentUserId, channels, localUser, maybeThread, isThreadStarter, isHovered, messageId, message);
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Guild$slackConversationViewHelper$ = function (lastViewedIndex, currentSlackUserId, guildOrDmIdNoThread, maybeUrlMessageId, channel, loggedIn, local, model) {
	var revealedSpoilers = $author$project$Pages$Guild$revealedChannelSpoilers$(
		$author$project$Id$SlackGuildOrDmId(guildOrDmIdNoThread),
		loggedIn);
	var isMobile = $author$project$MyUi$isMobile(model);
	var guildOrDmId = _Utils_Tuple2(
		$author$project$Id$SlackGuildOrDmId(guildOrDmIdNoThread),
		$author$project$Id$NoThread);
	var maybeEditing = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.editMessage);
	var containerWidth = $author$project$Pages$Guild$conversationWidth(model);
	var channels = $author$project$LocalState$slackChannelMentions$(guildOrDmIdNoThread, local);
	return $author$project$MessageArray$foldr$(
		F3(
			function (messageId, maybeMessage, _v0) {
				var maybeLastDate = _v0.a;
				var list = _v0.b;
				var index = $author$project$Id$toInt(messageId);
				if (!maybeMessage.$) {
					var message = maybeMessage.a;
					var threadRoute2 = $author$project$Id$NoThreadWithMessage(messageId);
					var highlight = _Utils_eq(
						maybeUrlMessageId,
						$elm$core$Maybe$Just(messageId)) ? 3 : 0;
					var date = $justinmimbs$date$Date$fromPosix$(
						local.localUser.timezone,
						$author$project$Message$createdAt(message));
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(date),
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$elm$core$String$fromInt(index),
								function () {
									if (!maybeEditing.$) {
										var editing = maybeEditing.a;
										if (_Utils_eq(editing.messageIndex, messageId) && (!isMobile)) {
											var editRichText = function () {
												var _v3 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(editing.text);
												if (!_v3.$) {
													var nonempty = _v3.a;
													return $elm$core$Maybe$Just(
														$author$project$RichText$fromNonemptyString$(local.localUser.timezone, local.localUser.slackUsers, channels, nonempty));
												} else {
													return $elm$core$Maybe$Nothing;
												}
											}();
											return $author$project$Pages$Guild$messageEditingView$(
												containerWidth,
												model.time,
												isMobile,
												guildOrDmId,
												threadRoute2,
												message,
												$elm$core$Maybe$Nothing,
												$lamdera$containers$SeqDict$get$(messageId, channel.threads),
												revealedSpoilers,
												$author$project$RichText$maxLength - $elm$core$String$length(editing.text),
												editing,
												editRichText,
												loggedIn,
												$lamdera$containers$SeqDict$empty,
												currentSlackUserId,
												local.localUser.slackUsers,
												channels,
												local);
										} else {
											return A2(
												$author$project$Ui$map,
												A2(
													$author$project$Types$MessageViewMsg,
													$author$project$Id$SlackGuildOrDmId(guildOrDmIdNoThread),
													threadRoute2),
												$author$project$Pages$Guild$slackMessageView$(
													model.time,
													containerWidth,
													revealedSpoilers,
													highlight,
													currentSlackUserId,
													channels,
													local.localUser,
													$lamdera$containers$SeqDict$get$(messageId, channel.threads),
													false,
													$author$project$Pages$Guild$messageHover$(
														$author$project$Id$SlackGuildOrDmId(guildOrDmIdNoThread),
														threadRoute2,
														loggedIn,
														model),
													messageId,
													message));
										}
									} else {
										return A2(
											$author$project$Ui$map,
											A2(
												$author$project$Types$MessageViewMsg,
												$author$project$Id$SlackGuildOrDmId(guildOrDmIdNoThread),
												threadRoute2),
											$author$project$Pages$Guild$slackMessageView$(
												model.time,
												containerWidth,
												revealedSpoilers,
												highlight,
												currentSlackUserId,
												channels,
												local.localUser,
												$lamdera$containers$SeqDict$get$(messageId, channel.threads),
												false,
												$author$project$Pages$Guild$messageHover$(
													$author$project$Id$SlackGuildOrDmId(guildOrDmIdNoThread),
													threadRoute2,
													loggedIn,
													model),
												messageId,
												message));
									}
								}()),
							_Utils_ap(
								$elm$core$List$map$(
									$elm$core$Tuple$mapSecond(
										$author$project$Ui$map(
											A2(
												$author$project$Types$MessageViewMsg,
												$author$project$Id$SlackGuildOrDmId(guildOrDmIdNoThread),
												threadRoute2))),
									$author$project$Pages$Guild$newMessageLine$(
										$author$project$User$slackUserColor(local.localUser),
										false,
										$lamdera$containers$SeqDict$empty,
										maybeLastDate,
										date,
										lastViewedIndex,
										index,
										messageId)),
								list)));
				} else {
					return _Utils_Tuple2(
						maybeLastDate,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$elm$core$String$fromInt(index),
								$author$project$Pages$Guild$unloadedMessageView(index)),
							list));
				}
			}),
		_Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil),
		$author$project$VisibleMessages$slice(channel)).b;
};
var $author$project$Pages$Guild$slackConversationViewHelper = F8($author$project$Pages$Guild$slackConversationViewHelper$);
var $author$project$Pages$Guild$slackLastViewedIndex$ = function (guildOrDmId, local) {
	var lastViewed = $elm$core$Maybe$withDefault$(
		$author$project$Id$fromInt(-1),
		$lamdera$containers$SeqDict$get$(
			$author$project$Id$SlackGuildOrDmId(guildOrDmId),
			local.localUser.user.lastViewedMessage));
	var _v0 = local.localUser.currentlyViewing;
	switch (_v0.$) {
		case 7:
			var data = _v0.a;
			return _Utils_eq(
				$author$project$Id$SlackGuildOrDmId_Workspace(data.id),
				guildOrDmId) ? $author$project$Pages$Guild$unreadDividerAt$(lastViewed, data.previouslyLastViewedMessage) : lastViewed;
		case 9:
			var data = _v0.a;
			return _Utils_eq(
				$author$project$Id$SlackGuildOrDmId_Dm(data.id),
				guildOrDmId) ? $author$project$Pages$Guild$unreadDividerAt$(lastViewed, data.previouslyLastViewedMessage) : lastViewed;
		default:
			return lastViewed;
	}
};
var $author$project$Pages$Guild$slackLastViewedIndex = F2($author$project$Pages$Guild$slackLastViewedIndex$);
var $author$project$Pages$Guild$slackConversationView$ = function (currentSlackUserId, guildOrDmIdNoThread, maybeUrlMessageId, loggedIn, model, local, name, channel) {
	var isMobile = $author$project$MyUi$isMobile(model);
	var guildOrDmId = _Utils_Tuple2(
		$author$project$Id$SlackGuildOrDmId(guildOrDmIdNoThread),
		$author$project$Id$NoThread);
	var draft = function () {
		var _v5 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.drafts);
		if (!_v5.$) {
			var text = _v5.a;
			return $MartinSStewart$elm_nonempty_string$String$Nonempty$toString(text);
		} else {
			return '';
		}
	}();
	var channels = $author$project$LocalState$slackChannelMentions$(guildOrDmIdNoThread, local);
	var draftRichText = function () {
		var _v4 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.drafts);
		if (!_v4.$) {
			var text = _v4.a;
			return $elm$core$Maybe$Just(
				$author$project$RichText$fromNonemptyString$(local.localUser.timezone, local.localUser.slackUsers, channels, text));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$Ui$heightMin(0)
			]),
		_List_fromArray(
			[
				$author$project$ChannelHeader$slackChannel$(isMobile, name, guildOrDmIdNoThread, model.route),
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Pages$Guild$emojiSelector$(
						isMobile,
						$author$project$MessageMenu$availableCustomEmojisAndStickers$(
							$author$project$Id$SlackGuildOrDmId(guildOrDmIdNoThread),
							local).a,
						$lamdera$containers$SeqSet$empty,
						local,
						loggedIn,
						model),
						$author$project$Ui$heightMin(0),
						$author$project$Ui$height($author$project$Ui$fill)
					]),
				$author$project$Ui$Keyed$column$(
					_List_fromArray(
						[
							$author$project$Ui$height($author$project$Ui$fill),
							$author$project$Ui$width($author$project$Ui$fill),
							$author$project$Ui$paddingWith(
							{bottom: 16, left: 0, right: 0, top: 200}),
							$author$project$MyUi$scrollable(
							$author$project$MyUi$canScroll$(isMobile, model.drag)),
							$author$project$MyUi$htmlStyle$('overflow-wrap', 'break-word'),
							$author$project$Ui$id(
							$lamdera$program_test$Effect$Browser$Dom$idToString($author$project$Pages$Guild$conversationContainerId)),
							$author$project$Ui$Events$on$(
							'scroll',
							$author$project$Scroll$decodeScrollToBottom$(
								A2(
									$author$project$Types$UserScrolled,
									$author$project$Id$SlackGuildOrDmId(guildOrDmIdNoThread),
									$author$project$Id$NoThread),
								loggedIn.channelScrollPosition)),
							$author$project$Ui$heightMin(0),
							$author$project$MyUi$bounceScroll(isMobile),
							$author$project$MyUi$htmlStyle$('background-image', 'url(/cacheable/grid1.png)')
						]),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'a',
							$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$Font$color($author$project$MyUi$font2),
										$author$project$Ui$paddingXY$(8, 4),
										$author$project$Ui$alignBottom,
										$author$project$Ui$Font$size(20)
									]),
								function () {
									if ($author$project$VisibleMessages$startIsVisible(channel.visibleMessages)) {
										if (!guildOrDmIdNoThread.$) {
											return $author$project$Ui$text('This is the start of #' + name);
										} else {
											return $author$project$Ui$text('This is the start of your conversation with ' + name);
										}
									} else {
										return $author$project$Ui$none;
									}
								}())),
						$author$project$Pages$Guild$slackConversationViewHelper$(
							$author$project$Pages$Guild$slackLastViewedIndex$(guildOrDmIdNoThread, local),
							currentSlackUserId,
							guildOrDmIdNoThread,
							maybeUrlMessageId,
							channel,
							loggedIn,
							local,
							model)))),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$paddingXY$(2, 0),
						$author$project$Ui$heightMin(0),
						$author$project$MyUi$noShrinking,
						function () {
						var _v1 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.filesToUpload);
						if (!_v1.$) {
							var filesToUpload2 = _v1.a;
							return $author$project$Ui$inFront(
								$author$project$Pages$Guild$fileUploadPreview$(
									$author$project$Types$PressedDeleteAttachedFile(guildOrDmId),
									$author$project$Types$PressedViewAttachedFileInfo(guildOrDmId),
									$elm$core$Maybe$Nothing,
									draftRichText,
									filesToUpload2));
						} else {
							return $author$project$Ui$noAttr;
						}
					}()
					]),
				_List_fromArray(
					[
						$author$project$Pages$Guild$newMessagesView$(model, loggedIn, channel),
						A2(
						$author$project$Ui$map,
						A2(
							$author$project$Types$MessageInputMsg,
							$author$project$Id$SlackGuildOrDmId(guildOrDmIdNoThread),
							$author$project$Id$NoThread),
						$author$project$MessageInput$view$(
							$lamdera$program_test$Effect$Browser$Dom$id('messageMenu_channelInput'),
							true,
							isMobile,
							$author$project$Pages$Guild$channelTextInputId,
							$author$project$MessageInput$textPlaceholder(
								function () {
									if (!guildOrDmIdNoThread.$) {
										return 'Write a message in #' + name;
									} else {
										return 'Write a message to ' + name;
									}
								}()),
							$author$project$RichText$maxLength - $elm$core$String$length(draft),
							draft,
							draftRichText,
							function () {
								var _v3 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.filesToUpload);
								if (!_v3.$) {
									var attachedFiles = _v3.a;
									return $author$project$NonemptyDict$toSeqDict(attachedFiles);
								} else {
									return $lamdera$containers$SeqDict$empty;
								}
							}(),
							local.localUser,
							loggedIn,
							local.localUser.slackUsers,
							channels)),
						$author$project$Pages$Guild$peopleAreTypingView$(local.localUser.slackUsers, $author$project$Id$NoThread, $lamdera$containers$SeqDict$empty, currentSlackUserId, model)
					]))
			]));
};
var $author$project$Pages$Guild$slackConversationView = F8($author$project$Pages$Guild$slackConversationView$);
var $author$project$MessageView$slackThreadMiniView$ = function (user, canEdit, emojiData, customEmojis) {
	return $author$project$MessageView$miniViewContainer$(
		-48,
		_Utils_ap(
			$author$project$MessageView$recentEmojiButtons$(user, $lamdera$containers$SeqSet$empty, emojiData, customEmojis),
			_List_fromArray(
				[
					$author$project$MessageView$miniButton$(
					$lamdera$program_test$Effect$Browser$Dom$id('miniView_showReactionEmojiSelector'),
					$author$project$MessageView$MessageViewMsg_PressedShowReactionEmojiSelector,
					'Add reaction',
					$author$project$Icons$smile),
					canEdit ? $author$project$MessageView$miniButton$(
					$lamdera$program_test$Effect$Browser$Dom$id('miniView_editMessage'),
					$author$project$MessageView$MessageViewMsg_PressedEditMessage,
					'Edit message',
					$author$project$Icons$pencil) : $author$project$Ui$none,
					$author$project$MessageView$miniButtonWithPosition$(
					$lamdera$program_test$Effect$Browser$Dom$id('miniView_showFullMenu'),
					$author$project$MessageView$MessageViewMsg_PressedShowFullMenu(false),
					$author$project$Icons$dotDotDot)
				])));
};
var $author$project$MessageView$slackThreadMiniView = F4($author$project$MessageView$slackThreadMiniView$);
var $author$project$Pages$Guild$slackThreadMessageContainer$ = function (containerWidth, canEdit, highlight, messageIndex, currentUserId, currentUser, reactions, customEmojis, emojiData, allUsers, isHovered, messageContent) {
	var maybeReactions = $author$project$MessageView$reactionEmojiView$(
		emojiData,
		$author$project$Pages$Guild$reactionsHover(isHovered),
		currentUserId,
		customEmojis,
		allUsers,
		$author$project$Pages$Guild$isHoveredToAnimationMode(isHovered),
		containerWidth,
		reactions);
	return $author$project$Ui$column$(
		_Utils_ap(
			_List_fromArray(
				[
					$author$project$Ui$Font$color($author$project$MyUi$font1),
					$author$project$Ui$Events$onMouseEnter($author$project$MessageView$MessageView_MouseEnteredMessage),
					$author$project$Ui$Events$onMouseLeave($author$project$MessageView$MessageView_MouseExitedMessage),
					$author$project$Ui$Events$on$(
					'touchstart',
					A3(
						$elm$json$Json$Decode$map2,
						F2(
							function (toMsg, target) {
								return A3(toMsg, target.imageUrl, target.linkUrl, target.reactionIndex);
							}),
						$author$project$Touch$decodeTouchEvent(
							F5(
								function (time, touches, imageUrl, linkUrl, reactionIndex) {
									return $author$project$MessageView$MessageView_TouchStart$(time, false, imageUrl, linkUrl, reactionIndex, touches);
								})),
						$author$project$Pages$Guild$decodeEventTarget)),
					$author$project$Ui$Events$preventDefaultOn$(
					'contextmenu',
					$author$project$Pages$Guild$decodeMessageContextMenu(false)),
					$author$project$Ui$paddingWith(
					{
						bottom: _Utils_eq(maybeReactions, $elm$core$Maybe$Nothing) ? 8 : 4,
						left: $author$project$Pages$Guild$messagePaddingX,
						right: $author$project$Pages$Guild$messagePaddingX,
						top: 4
					}),
					$author$project$Ui$spacing(4),
					$author$project$Ui$id(
					$lamdera$program_test$Effect$Browser$Dom$idToString(
						$author$project$Pages$Guild$threadMessageHtmlId(messageIndex)))
				]),
			_Utils_ap(
				function () {
					switch (isHovered.$) {
						case 0:
							return _List_fromArray(
								[
									$author$project$Ui$behindContent($author$project$Ui$none)
								]);
						case 1:
							return _List_fromArray(
								[
									$author$project$MyUi$hoverHighlightLayer,
									$author$project$Ui$inFront(
									$author$project$MessageView$slackThreadMiniView$(currentUser, canEdit, emojiData, customEmojis))
								]);
						case 2:
							return _List_fromArray(
								[$author$project$MyUi$hoverHighlightLayer]);
						case 3:
							return _List_fromArray(
								[
									$author$project$MyUi$hoverHighlightLayer,
									$author$project$Ui$inFront(
									$author$project$MessageView$reactionsMiniView$(currentUser, $lamdera$containers$SeqSet$empty, emojiData, customEmojis))
								]);
						case 4:
							return _List_fromArray(
								[
									$author$project$Ui$behindContent($author$project$Ui$none)
								]);
						default:
							return _List_fromArray(
								[
									$author$project$Ui$behindContent($author$project$Ui$none)
								]);
					}
				}(),
				_List_fromArray(
					[
						$author$project$Pages$Guild$highlightLayer(highlight)
					]))),
		A2(
			$elm$core$List$cons,
			messageContent,
			$elmcraft$core_extra$Maybe$Extra$toList(maybeReactions)));
};
var $author$project$Pages$Guild$slackThreadMessageContainer = function (containerWidth) {
	return function (canEdit) {
		return function (highlight) {
			return function (messageIndex) {
				return function (currentUserId) {
					return function (currentUser) {
						return function (reactions) {
							return function (customEmojis) {
								return function (emojiData) {
									return function (allUsers) {
										return function (isHovered) {
											return function (messageContent) {
												return $author$project$Pages$Guild$slackThreadMessageContainer$(containerWidth, canEdit, highlight, messageIndex, currentUserId, currentUser, reactions, customEmojis, emojiData, allUsers, isHovered, messageContent);
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Guild$slackThreadMessageView$ = function (time, containerWidth, revealedSpoilers, highlight, currentUserId, channels, localUser, isHovered, messageId, message) {
	switch (message.$) {
		case 0:
			var data = message.a;
			return $author$project$Pages$Guild$slackThreadMessageContainer$(
				containerWidth,
				_Utils_eq(data.createdBy, currentUserId),
				function () {
					if (!highlight) {
						return $lamdera$containers$SeqSet$member$(
							currentUserId,
							$author$project$RichText$mentionsUser(data.content.content)) ? 2 : highlight;
					} else {
						return highlight;
					}
				}(),
				messageId,
				currentUserId,
				localUser.user,
				data.reactions,
				localUser.customEmojis,
				localUser.emojiData,
				localUser.slackUsers,
				isHovered,
				$author$project$Pages$Guild$slackUserTextMessageContent$(time, containerWidth, localUser, revealedSpoilers, channels, messageId, data.content, data));
		case 1:
			return $author$project$Ui$none;
		case 2:
			var joinedAt = message.a;
			var userId = message.b;
			var reactions = message.c;
			var drawings = message.d;
			return $author$project$Pages$Guild$slackThreadMessageContainer$(
				containerWidth,
				false,
				highlight,
				messageId,
				currentUserId,
				localUser.user,
				reactions,
				localUser.customEmojis,
				localUser.emojiData,
				localUser.slackUsers,
				isHovered,
				$author$project$Ui$row$(
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Guild$userJoinedContent$(userId, localUser.slackUsers),
							$author$project$Pages$Guild$messageTimestamp$(
							$author$project$User$slackUserColor(localUser),
							drawings,
							false,
							messageId,
							joinedAt,
							localUser.timezone)
						])));
		case 3:
			var createdAt = message.a;
			return $author$project$Pages$Guild$slackThreadMessageContainer$(
				containerWidth,
				false,
				highlight,
				messageId,
				currentUserId,
				localUser.user,
				$lamdera$containers$SeqDict$empty,
				localUser.customEmojis,
				localUser.emojiData,
				localUser.slackUsers,
				isHovered,
				$author$project$Pages$Guild$deletedMessageContent$(messageId, false, createdAt, localUser.timezone));
		case 4:
			return $author$project$Ui$none;
		default:
			return $author$project$Ui$none;
	}
};
var $author$project$Pages$Guild$slackThreadMessageView = function (time) {
	return function (containerWidth) {
		return function (revealedSpoilers) {
			return function (highlight) {
				return function (currentUserId) {
					return function (channels) {
						return function (localUser) {
							return function (isHovered) {
								return function (messageId) {
									return function (message) {
										return $author$project$Pages$Guild$slackThreadMessageView$(time, containerWidth, revealedSpoilers, highlight, currentUserId, channels, localUser, isHovered, messageId, message);
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Guild$slackThreadConversationViewHelper$ = function (lastViewedIndex, currentSlackUserId, guildOrDmIdNoThread, threadId, maybeUrlMessageId, thread, loggedIn, local, model) {
	var revealedSpoilers = $author$project$Pages$Guild$revealedThreadSpoilers$(
		$author$project$Id$SlackGuildOrDmId(guildOrDmIdNoThread),
		threadId,
		loggedIn);
	var isMobile = $author$project$MyUi$isMobile(model);
	var guildOrDmId = _Utils_Tuple2(
		$author$project$Id$SlackGuildOrDmId(guildOrDmIdNoThread),
		$author$project$Id$ViewThread(threadId));
	var maybeEditing = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.editMessage);
	var containerWidth = $author$project$Pages$Guild$conversationWidth(model);
	var channels = $author$project$LocalState$slackChannelMentions$(guildOrDmIdNoThread, local);
	return $author$project$MessageArray$foldr$(
		F3(
			function (messageId, maybeMessage, _v0) {
				var maybeLastDate = _v0.a;
				var list = _v0.b;
				var index = $author$project$Id$toInt(messageId);
				if (!maybeMessage.$) {
					var message = maybeMessage.a;
					var threadRoute2 = $author$project$Id$ViewThreadWithMessage$(threadId, messageId);
					var highlight = _Utils_eq(
						maybeUrlMessageId,
						$elm$core$Maybe$Just(messageId)) ? 3 : 0;
					var date = $justinmimbs$date$Date$fromPosix$(
						local.localUser.timezone,
						$author$project$Message$createdAt(message));
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(date),
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$elm$core$String$fromInt(index),
								function () {
									if (!maybeEditing.$) {
										var editing = maybeEditing.a;
										if (_Utils_eq(
											editing.messageIndex,
											$author$project$Id$changeType(messageId)) && (!isMobile)) {
											var editRichText = function () {
												var _v3 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(editing.text);
												if (!_v3.$) {
													var nonempty = _v3.a;
													return $elm$core$Maybe$Just(
														$author$project$RichText$fromNonemptyString$(local.localUser.timezone, local.localUser.slackUsers, channels, nonempty));
												} else {
													return $elm$core$Maybe$Nothing;
												}
											}();
											return $author$project$Pages$Guild$threadMessageEditingView$(
												containerWidth,
												model.time,
												isMobile,
												guildOrDmId,
												threadId,
												messageId,
												message,
												$elm$core$Maybe$Nothing,
												revealedSpoilers,
												$author$project$RichText$maxLength - $elm$core$String$length(editing.text),
												editing,
												editRichText,
												loggedIn,
												$lamdera$containers$SeqDict$empty,
												currentSlackUserId,
												local.localUser.slackUsers,
												channels,
												local);
										} else {
											return A2(
												$author$project$Ui$map,
												A2(
													$author$project$Types$MessageViewMsg,
													$author$project$Id$SlackGuildOrDmId(guildOrDmIdNoThread),
													threadRoute2),
												$author$project$Pages$Guild$slackThreadMessageView$(
													model.time,
													containerWidth,
													revealedSpoilers,
													highlight,
													currentSlackUserId,
													channels,
													local.localUser,
													$author$project$Pages$Guild$messageHover$(
														$author$project$Id$SlackGuildOrDmId(guildOrDmIdNoThread),
														threadRoute2,
														loggedIn,
														model),
													messageId,
													message));
										}
									} else {
										return A2(
											$author$project$Ui$map,
											A2(
												$author$project$Types$MessageViewMsg,
												$author$project$Id$SlackGuildOrDmId(guildOrDmIdNoThread),
												threadRoute2),
											$author$project$Pages$Guild$slackThreadMessageView$(
												model.time,
												containerWidth,
												revealedSpoilers,
												highlight,
												currentSlackUserId,
												channels,
												local.localUser,
												$author$project$Pages$Guild$messageHover$(
													$author$project$Id$SlackGuildOrDmId(guildOrDmIdNoThread),
													threadRoute2,
													loggedIn,
													model),
												messageId,
												message));
									}
								}()),
							_Utils_ap(
								$elm$core$List$map$(
									$elm$core$Tuple$mapSecond(
										$author$project$Ui$map(
											A2(
												$author$project$Types$MessageViewMsg,
												$author$project$Id$SlackGuildOrDmId(guildOrDmIdNoThread),
												threadRoute2))),
									$author$project$Pages$Guild$newMessageLine$(
										$author$project$User$slackUserColor(local.localUser),
										false,
										$lamdera$containers$SeqDict$empty,
										maybeLastDate,
										date,
										lastViewedIndex,
										index,
										messageId)),
								list)));
				} else {
					return _Utils_Tuple2(
						maybeLastDate,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$elm$core$String$fromInt(index),
								$author$project$Pages$Guild$unloadedMessageView(index)),
							list));
				}
			}),
		_Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil),
		$author$project$VisibleMessages$slice(thread)).b;
};
var $author$project$Pages$Guild$slackThreadConversationViewHelper = F9($author$project$Pages$Guild$slackThreadConversationViewHelper$);
var $author$project$Pages$Guild$slackThreadLastViewedIndex$ = function (guildOrDmId, threadId, local) {
	var lastViewed = $elm$core$Maybe$withDefault$(
		$author$project$Id$fromInt(-1),
		$lamdera$containers$SeqDict$get$(
			_Utils_Tuple2(
				$author$project$Id$SlackGuildOrDmId(guildOrDmId),
				threadId),
			local.localUser.user.lastViewedThreadMessage));
	var _v0 = local.localUser.currentlyViewing;
	switch (_v0.$) {
		case 8:
			var data = _v0.a;
			return (_Utils_eq(
				$author$project$Id$SlackGuildOrDmId_Workspace(data.id),
				guildOrDmId) && _Utils_eq(data.threadId, threadId)) ? $author$project$Pages$Guild$unreadDividerAt$(lastViewed, data.previouslyLastViewedMessage) : lastViewed;
		case 10:
			var data = _v0.a;
			return (_Utils_eq(
				$author$project$Id$SlackGuildOrDmId_Dm(data.id),
				guildOrDmId) && _Utils_eq(data.threadId, threadId)) ? $author$project$Pages$Guild$unreadDividerAt$(lastViewed, data.previouslyLastViewedMessage) : lastViewed;
		default:
			return lastViewed;
	}
};
var $author$project$Pages$Guild$slackThreadLastViewedIndex = F3($author$project$Pages$Guild$slackThreadLastViewedIndex$);
var $author$project$Pages$Guild$slackThreadConversationView$ = function (currentSlackUserId, guildOrDmIdNoThread, threadId, maybeUrlMessageId, loggedIn, model, local, name, channel) {
	var thread = $elm$core$Maybe$withDefault$(
		$author$project$Thread$frontendInit,
		$lamdera$containers$SeqDict$get$(threadId, channel.threads));
	var isMobile = $author$project$MyUi$isMobile(model);
	var guildOrDmId = _Utils_Tuple2(
		$author$project$Id$SlackGuildOrDmId(guildOrDmIdNoThread),
		$author$project$Id$ViewThread(threadId));
	var draft = function () {
		var _v4 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.drafts);
		if (!_v4.$) {
			var text = _v4.a;
			return $MartinSStewart$elm_nonempty_string$String$Nonempty$toString(text);
		} else {
			return '';
		}
	}();
	var channels = $author$project$LocalState$slackChannelMentions$(guildOrDmIdNoThread, local);
	var draftRichText = function () {
		var _v3 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.drafts);
		if (!_v3.$) {
			var text = _v3.a;
			return $elm$core$Maybe$Just(
				$author$project$RichText$fromNonemptyString$(local.localUser.timezone, local.localUser.slackUsers, channels, text));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$Ui$heightMin(0)
			]),
		_List_fromArray(
			[
				$author$project$ChannelHeader$slackChannel$(isMobile, name, guildOrDmIdNoThread, model.route),
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Pages$Guild$emojiSelector$(
						isMobile,
						$author$project$MessageMenu$availableCustomEmojisAndStickers$(
							$author$project$Id$SlackGuildOrDmId(guildOrDmIdNoThread),
							local).a,
						$lamdera$containers$SeqSet$empty,
						local,
						loggedIn,
						model),
						$author$project$Ui$heightMin(0),
						$author$project$Ui$height($author$project$Ui$fill)
					]),
				$author$project$Ui$Keyed$column$(
					_List_fromArray(
						[
							$author$project$Ui$height($author$project$Ui$fill),
							$author$project$Ui$width($author$project$Ui$fill),
							$author$project$Ui$paddingWith(
							{bottom: 16, left: 0, right: 0, top: 200}),
							$author$project$MyUi$scrollable(
							$author$project$MyUi$canScroll$(isMobile, model.drag)),
							$author$project$MyUi$htmlStyle$('overflow-wrap', 'break-word'),
							$author$project$Ui$id(
							$lamdera$program_test$Effect$Browser$Dom$idToString($author$project$Pages$Guild$conversationContainerId)),
							$author$project$Ui$Events$on$(
							'scroll',
							$author$project$Scroll$decodeScrollToBottom$(
								A2(
									$author$project$Types$UserScrolled,
									$author$project$Id$SlackGuildOrDmId(guildOrDmIdNoThread),
									$author$project$Id$ViewThread(threadId)),
								loggedIn.channelScrollPosition)),
							$author$project$Ui$heightMin(0),
							$author$project$MyUi$bounceScroll(isMobile),
							$author$project$MyUi$htmlStyle$('background-image', 'url(/cacheable/grid1.png)')
						]),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'a',
							$author$project$Ui$column$(
								_List_fromArray(
									[$author$project$Ui$alignBottom]),
								$author$project$VisibleMessages$startIsVisible(thread.visibleMessages) ? _List_fromArray(
									[
										$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$Font$color($author$project$MyUi$font2),
												$author$project$Ui$paddingXY$(8, 4),
												$author$project$Ui$alignBottom,
												$author$project$Ui$Font$size(20)
											]),
										$author$project$Ui$text($author$project$Pages$Guild$startOfThreadText)),
										function () {
										var _v0 = $author$project$MessageArray$get$(threadId, channel.messages);
										if (!_v0.$) {
											var message = _v0.a;
											return A2(
												$author$project$Ui$map,
												A2(
													$author$project$Types$MessageViewMsg,
													$author$project$Id$SlackGuildOrDmId(guildOrDmIdNoThread),
													$author$project$Id$NoThreadWithMessage(threadId)),
												$author$project$Pages$Guild$slackMessageView$(
													model.time,
													$author$project$Pages$Guild$conversationWidth(model),
													$author$project$Pages$Guild$revealedChannelSpoilers$(
														$author$project$Id$SlackGuildOrDmId(guildOrDmIdNoThread),
														loggedIn),
													0,
													currentSlackUserId,
													channels,
													local.localUser,
													$elm$core$Maybe$Nothing,
													true,
													$author$project$Pages$Guild$messageHover$(
														$author$project$Id$SlackGuildOrDmId(guildOrDmIdNoThread),
														$author$project$Id$NoThreadWithMessage(threadId),
														loggedIn,
														model),
													threadId,
													message));
										} else {
											return $author$project$Ui$none;
										}
									}()
									]) : _List_Nil)),
						$author$project$Pages$Guild$slackThreadConversationViewHelper$(
							$author$project$Pages$Guild$slackThreadLastViewedIndex$(guildOrDmIdNoThread, threadId, local),
							currentSlackUserId,
							guildOrDmIdNoThread,
							threadId,
							maybeUrlMessageId,
							thread,
							loggedIn,
							local,
							model)))),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$paddingXY$(2, 0),
						$author$project$Ui$heightMin(0),
						$author$project$MyUi$noShrinking,
						function () {
						var _v1 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.filesToUpload);
						if (!_v1.$) {
							var filesToUpload2 = _v1.a;
							return $author$project$Ui$inFront(
								$author$project$Pages$Guild$fileUploadPreview$(
									$author$project$Types$PressedDeleteAttachedFile(guildOrDmId),
									$author$project$Types$PressedViewAttachedFileInfo(guildOrDmId),
									$elm$core$Maybe$Nothing,
									draftRichText,
									filesToUpload2));
						} else {
							return $author$project$Ui$noAttr;
						}
					}()
					]),
				_List_fromArray(
					[
						$author$project$Pages$Guild$newMessagesView$(model, loggedIn, thread),
						A2(
						$author$project$Ui$map,
						A2(
							$author$project$Types$MessageInputMsg,
							$author$project$Id$SlackGuildOrDmId(guildOrDmIdNoThread),
							$author$project$Id$ViewThread(threadId)),
						$author$project$MessageInput$view$(
							$lamdera$program_test$Effect$Browser$Dom$id('messageMenu_channelInput'),
							true,
							isMobile,
							$author$project$Pages$Guild$channelTextInputId,
							$author$project$MessageInput$textPlaceholder('Write a message in this thread'),
							$author$project$RichText$maxLength - $elm$core$String$length(draft),
							draft,
							draftRichText,
							function () {
								var _v2 = $lamdera$containers$SeqDict$get$(guildOrDmId, loggedIn.filesToUpload);
								if (!_v2.$) {
									var attachedFiles = _v2.a;
									return $author$project$NonemptyDict$toSeqDict(attachedFiles);
								} else {
									return $lamdera$containers$SeqDict$empty;
								}
							}(),
							local.localUser,
							loggedIn,
							local.localUser.slackUsers,
							channels)),
						$author$project$Pages$Guild$peopleAreTypingView$(
						local.localUser.slackUsers,
						$author$project$Id$ViewThread(threadId),
						$lamdera$containers$SeqDict$empty,
						currentSlackUserId,
						model)
					]))
			]));
};
var $author$project$Pages$Guild$slackThreadConversationView = F9($author$project$Pages$Guild$slackThreadConversationView$);
var $author$project$Pages$Guild$slackDmChannelView$ = function (routeData, loggedIn, local, model) {
	var _v0 = $lamdera$containers$SeqDict$get$(routeData.channelId, local.slackDmChannels);
	if (!_v0.$) {
		var dmChannel = _v0.a;
		var name = $elm$core$String$join$(
			', ',
			$elm$core$List$map$(
				function (userId) {
					return $author$project$User$toString$(userId, local.localUser.slackUsers);
				},
				$author$project$Pages$Guild$slackDmMembers$(routeData.currentSlackUserId, dmChannel)));
		var guildOrDmId = $author$project$Id$SlackGuildOrDmId_Dm(
			{channelId: routeData.channelId, currentUserId: routeData.currentSlackUserId});
		var _v1 = routeData.threadRoute;
		if (!_v1.$) {
			var maybeMessageId = _v1.a;
			return $author$project$Pages$Guild$slackConversationView$(routeData.currentSlackUserId, guildOrDmId, maybeMessageId, loggedIn, model, local, name, dmChannel);
		} else {
			var threadId = _v1.a;
			var maybeMessageId = _v1.b;
			return $author$project$Pages$Guild$slackThreadConversationView$(routeData.currentSlackUserId, guildOrDmId, threadId, maybeMessageId, loggedIn, model, local, name, dmChannel);
		}
	} else {
		return $author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$centerY,
					$author$project$Ui$Font$center,
					$author$project$Ui$Font$color($author$project$MyUi$font1),
					$author$project$Ui$Font$size(20)
				]),
			$author$project$Ui$text('DM channel not found'));
	}
};
var $author$project$Pages$Guild$slackDmChannelView = F4($author$project$Pages$Guild$slackDmChannelView$);
var $author$project$Types$PressedMarkAllChannelsAsRead = function (a) {
	return {$: 177, a: a};
};
var $author$project$Types$UnreadOverviewChannelMsg$ = function (a, b, c) {
	return {$: 183, a: a, b: b, c: c};
};
var $author$project$Types$UnreadOverviewChannelMsg = F3($author$project$Types$UnreadOverviewChannelMsg$);
var $author$project$Types$UnreadOverviewThreadMsg$ = function (a, b, c, d) {
	return {$: 184, a: a, b: b, c: c, d: d};
};
var $author$project$Types$UnreadOverviewThreadMsg = F4($author$project$Types$UnreadOverviewThreadMsg$);
var $author$project$AsciiArt$art = $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
	{
		coordinates: $author$project$Coord$xy$(-68, 122),
		size: $author$project$Coord$xy$(145, 157),
		url: 'ascii-party-popper'
	},
	_List_fromArray(
		[
			{
			coordinates: $author$project$Coord$xy$(1173, -47),
			size: $author$project$Coord$xy$(276, 103),
			url: 'ascii-bari-gisher'
		},
			{
			coordinates: $author$project$Coord$xy$(23, -58),
			size: $author$project$Coord$xy$(284, 229),
			url: 'ascii-fishermoon'
		},
			{
			coordinates: $author$project$Coord$xy$(125, -91),
			size: $author$project$Coord$xy$(122, 134),
			url: 'ascii-lamb'
		},
			{
			coordinates: $author$project$Coord$xy$(-723, -150),
			size: $author$project$Coord$xy$(385, 309),
			url: 'ascii-sandwich'
		},
			{
			coordinates: $author$project$Coord$xy$(-892, -187),
			size: $author$project$Coord$xy$(399, 747),
			url: 'ascii-princess'
		},
			{
			coordinates: $author$project$Coord$xy$(-662, -344),
			size: $author$project$Coord$xy$(163, 76),
			url: 'ascii-crab'
		},
			{
			coordinates: $author$project$Coord$xy$(-630, -344),
			size: $author$project$Coord$xy$(137, 127),
			url: 'ascii-squirrel'
		},
			{
			coordinates: $author$project$Coord$xy$(-860, -353),
			size: $author$project$Coord$xy$(286, 136),
			url: 'ascii-cat-and-soup'
		},
			{
			coordinates: $author$project$Coord$xy$(-812, -226),
			size: $author$project$Coord$xy$(297, 101),
			url: 'ascii-bat'
		},
			{
			coordinates: $author$project$Coord$xy$(-189, 169),
			size: $author$project$Coord$xy$(483, 147),
			url: 'ascii-paintings'
		},
			{
			coordinates: $author$project$Coord$xy$(24, 146),
			size: $author$project$Coord$xy$(205, 203),
			url: 'ascii-key'
		},
			{
			coordinates: $author$project$Coord$xy$(189, -202),
			size: $author$project$Coord$xy$(266, 298),
			url: 'ascii-cat-and-fish'
		},
			{
			coordinates: $author$project$Coord$xy$(621, -20),
			size: $author$project$Coord$xy$(255, 215),
			url: 'ascii-snail'
		},
			{
			coordinates: $author$project$Coord$xy$(916, 201),
			size: $author$project$Coord$xy$(214, 216),
			url: 'ascii-sister'
		},
			{
			coordinates: $author$project$Coord$xy$(707, 192),
			size: $author$project$Coord$xy$(245, 274),
			url: 'ascii-brother'
		},
			{
			coordinates: $author$project$Coord$xy$(326, 95),
			size: $author$project$Coord$xy$(255, 222),
			url: 'ascii-cheese'
		},
			{
			coordinates: $author$project$Coord$xy$(-730, -169),
			size: $author$project$Coord$xy$(103, 282),
			url: 'ascii-ice-cream'
		},
			{
			coordinates: $author$project$Coord$xy$(-434, -141),
			size: $author$project$Coord$xy$(365, 371),
			url: 'ascii-sw-home'
		},
			{
			coordinates: $author$project$Coord$xy$(-169, -176),
			size: $author$project$Coord$xy$(303, 198),
			url: 'ascii-box-house'
		},
			{
			coordinates: $author$project$Coord$xy$(89, -243),
			size: $author$project$Coord$xy$(765, 401),
			url: 'ascii-man-on-moon'
		},
			{
			coordinates: $author$project$Coord$xy$(2, -109),
			size: $author$project$Coord$xy$(76, 195),
			url: 'ascii-cat-hat'
		},
			{
			coordinates: $author$project$Coord$xy$(-557, 350),
			size: $author$project$Coord$xy$(82, 84),
			url: 'ascii-at-chat-logo'
		}
		]));
var $author$project$Pages$Guild$noUnreadMessagesText = 'You have no unread messages!';
var $author$project$Pages$Guild$UnreadOverviewDiscordMessages$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Pages$Guild$UnreadOverviewDiscordMessages = F2($author$project$Pages$Guild$UnreadOverviewDiscordMessages$);
var $author$project$Pages$Guild$UnreadOverviewDiscordThreadMessages$ = function (a, b, c) {
	return {$: 3, a: a, b: b, c: c};
};
var $author$project$Pages$Guild$UnreadOverviewDiscordThreadMessages = F3($author$project$Pages$Guild$UnreadOverviewDiscordThreadMessages$);
var $author$project$Pages$Guild$UnreadOverviewMessages = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Guild$UnreadOverviewSlackMessages$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $author$project$Pages$Guild$UnreadOverviewSlackMessages = F2($author$project$Pages$Guild$UnreadOverviewSlackMessages$);
var $author$project$Pages$Guild$UnreadOverviewSlackThreadMessages$ = function (a, b, c) {
	return {$: 5, a: a, b: b, c: c};
};
var $author$project$Pages$Guild$UnreadOverviewSlackThreadMessages = F3($author$project$Pages$Guild$UnreadOverviewSlackThreadMessages$);
var $author$project$Pages$Guild$UnreadOverviewThreadMessages$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Pages$Guild$UnreadOverviewThreadMessages = F2($author$project$Pages$Guild$UnreadOverviewThreadMessages$);
var $author$project$Pages$Guild$channelSource$ = function (guildName, channelName) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8),
				$author$project$Ui$width($author$project$Ui$shrink)
			]),
		_List_fromArray(
			[
				$author$project$Ui$text(
				$author$project$GuildName$toString(guildName)),
				$author$project$Ui$text('/'),
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$width($author$project$Ui$shrink)
					]),
				_List_fromArray(
					[
						$author$project$Ui$html($author$project$Icons$hashtag),
						$author$project$Ui$text(
						$author$project$ChannelName$toString(channelName))
					]))
			]));
};
var $author$project$Pages$Guild$channelSource = F2($author$project$Pages$Guild$channelSource$);
var $author$project$Pages$Guild$discordDmSource$ = function (currentDiscordUserId, allDiscordUsers, dmChannel) {
	var _v0 = $lamdera$containers$SeqDict$keys(
		$author$project$NonemptyDict$remove$(currentDiscordUserId, dmChannel.members));
	if (!_v0.b) {
		return $author$project$Ui$text(
			$author$project$User$toString$(currentDiscordUserId, allDiscordUsers));
	} else {
		var others = _v0;
		return $author$project$Ui$text(
			$elm$core$String$join$(
				', ',
				$elm$core$List$map$(
					function (userId) {
						return $author$project$User$toString$(userId, allDiscordUsers);
					},
					others)));
	}
};
var $author$project$Pages$Guild$discordDmSource = F3($author$project$Pages$Guild$discordDmSource$);
var $author$project$Pages$Guild$chatWithText = 'Chat with';
var $author$project$Pages$Guild$dmSource$ = function (otherUserId, localUser) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(4),
				$author$project$Ui$width($author$project$Ui$shrink),
				$author$project$MyUi$noShrinking
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Font$weight(400),
						$author$project$Ui$width($author$project$Ui$shrink)
					]),
				$author$project$Ui$text($author$project$Pages$Guild$chatWithText)),
				$author$project$Ui$text(
				$author$project$User$toStringAlt$(otherUserId, localUser))
			]));
};
var $author$project$Pages$Guild$dmSource = F2($author$project$Pages$Guild$dmSource$);
var $author$project$Pages$Guild$dmThreadSource$ = function (otherUserId, localUser, threadName) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(8),
						$author$project$Ui$width($author$project$Ui$shrink),
						$author$project$MyUi$noShrinking
					]),
				_List_fromArray(
					[
						$author$project$Pages$Guild$dmSource$(otherUserId, localUser),
						$author$project$Ui$text('/')
					])),
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$clipWithEllipsis,
						$author$project$MyUi$hoverText(threadName)
					]),
				$author$project$Ui$text(threadName))
			]));
};
var $author$project$Pages$Guild$dmThreadSource = F3($author$project$Pages$Guild$dmThreadSource$);
var $author$project$MuteSettings$isDiscordDmMuted$ = function (model, channelId) {
	return $elm$core$Maybe$withDefault$(
		0,
		$lamdera$containers$SeqDict$get$(channelId, model.mutedDiscordDms));
};
var $author$project$MuteSettings$isDiscordDmMuted = F2($author$project$MuteSettings$isDiscordDmMuted$);
var $author$project$Pages$Guild$isMentioned$ = function (maybeDirectMentions, key) {
	if (!maybeDirectMentions.$) {
		var directMentions = maybeDirectMentions.a;
		return $author$project$NonemptyDict$member$(key, directMentions);
	} else {
		return false;
	}
};
var $author$project$Pages$Guild$isMentioned = F2($author$project$Pages$Guild$isMentioned$);
var $author$project$Pages$Guild$showInUnreadOverview$ = function (isMuted, hasRedNotification) {
	switch (isMuted) {
		case 0:
			return true;
		case 1:
			return hasRedNotification;
		default:
			return false;
	}
};
var $author$project$Pages$Guild$showInUnreadOverview = F2($author$project$Pages$Guild$showInUnreadOverview$);
var $author$project$Pages$Guild$slackChannelSource$ = function (workspaceName, channelName) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8),
				$author$project$Ui$width($author$project$Ui$shrink)
			]),
		_List_fromArray(
			[
				$author$project$Ui$text(workspaceName),
				$author$project$Ui$text('/'),
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$width($author$project$Ui$shrink)
					]),
				_List_fromArray(
					[
						$author$project$Ui$html($author$project$Icons$hashtag),
						$author$project$Ui$text(
						$author$project$ChannelName$toString(channelName))
					]))
			]));
};
var $author$project$Pages$Guild$slackChannelSource = F2($author$project$Pages$Guild$slackChannelSource$);
var $author$project$Pages$Guild$slackDmThreadSource$ = function (dmName, threadName) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(8),
						$author$project$Ui$width($author$project$Ui$shrink),
						$author$project$MyUi$noShrinking
					]),
				_List_fromArray(
					[
						$author$project$Ui$text(dmName),
						$author$project$Ui$text('/')
					])),
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$clipWithEllipsis,
						$author$project$MyUi$hoverText(threadName)
					]),
				$author$project$Ui$text(threadName))
			]));
};
var $author$project$Pages$Guild$slackDmThreadSource = F2($author$project$Pages$Guild$slackDmThreadSource$);
var $author$project$Pages$Guild$slackThreadSource$ = function (workspaceName, channelName, threadName) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(8),
						$author$project$Ui$width($author$project$Ui$shrink),
						$author$project$MyUi$noShrinking
					]),
				_List_fromArray(
					[
						$author$project$Ui$text(workspaceName),
						$author$project$Ui$text('/'),
						$author$project$Ui$row$(
						_List_fromArray(
							[
								$author$project$Ui$width($author$project$Ui$shrink)
							]),
						_List_fromArray(
							[
								$author$project$Ui$html($author$project$Icons$hashtag),
								$author$project$Ui$text(
								$author$project$ChannelName$toString(channelName))
							])),
						$author$project$Ui$text('/')
					])),
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$clipWithEllipsis,
						$author$project$MyUi$hoverText(threadName)
					]),
				$author$project$Ui$text(threadName))
			]));
};
var $author$project$Pages$Guild$slackThreadSource = F3($author$project$Pages$Guild$slackThreadSource$);
var $author$project$Pages$Guild$threadSource$ = function (guildName, channelName, threadName) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(8),
						$author$project$Ui$width($author$project$Ui$shrink),
						$author$project$MyUi$noShrinking
					]),
				_List_fromArray(
					[
						$author$project$Ui$text(
						$author$project$GuildName$toString(guildName)),
						$author$project$Ui$text('/'),
						$author$project$Ui$row$(
						_List_fromArray(
							[
								$author$project$Ui$width($author$project$Ui$shrink)
							]),
						_List_fromArray(
							[
								$author$project$Ui$html($author$project$Icons$hashtag),
								$author$project$Ui$text(
								$author$project$ChannelName$toString(channelName))
							])),
						$author$project$Ui$text('/')
					])),
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$clipWithEllipsis,
						$author$project$MyUi$hoverText(threadName)
					]),
				$author$project$Ui$text(threadName))
			]));
};
var $author$project$Pages$Guild$threadSource = F3($author$project$Pages$Guild$threadSource$);
var $author$project$UserSession$unreadOverviewMessageLimit = 3;
var $author$project$Pages$Guild$unreadMessages$ = function (maybeLastViewed, channel) {
	var unreadCount = $author$project$GuildColumn$newMessageCount$(maybeLastViewed, channel);
	var messageCount = $author$project$MessageArray$length(channel.messages);
	var loaded = $author$project$MessageArray$toList(
		$author$project$MessageArray$slice$(
			$author$project$Id$fromInt(messageCount - unreadCount),
			$author$project$Id$fromInt(messageCount),
			channel.messages));
	var shown = $elm$core$List$drop$(
		$elm$core$List$length(loaded) - $author$project$UserSession$unreadOverviewMessageLimit,
		loaded);
	var _v0 = _Utils_Tuple2(
		$elm$core$List$head(loaded),
		$elmcraft$core_extra$List$Extra$last(shown));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var _v1 = _v0.a.a;
		var oldest = _v1.b;
		var _v2 = _v0.b.a;
		var newestMessageId = _v2.a;
		return $elm$core$Maybe$Just(
			{
				additionalUnread: unreadCount - $elm$core$List$length(shown),
				messages: shown,
				newestMessageId: newestMessageId,
				oldestAt: $author$project$Message$createdAt(oldest)
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Guild$unreadMessages = F2($author$project$Pages$Guild$unreadMessages$);
var $author$project$Pages$Guild$unreadOverviewChannels$ = function (local, allDiscordUsers) {
	var currentUser = local.localUser.user;
	var allUsers = $author$project$User$allUsers(local.localUser);
	return A2(
		$elm$core$List$sortBy,
		function (unread) {
			return $elm$time$Time$posixToMillis(unread.oldestAt);
		},
		_Utils_ap(
			$elm$core$List$concatMap$(
				function (_v0) {
					var guildId = _v0.a;
					var guild = _v0.b;
					return $elm$core$List$concatMap$(
						function (_v1) {
							var channelId = _v1.a;
							var channel = _v1.b;
							var guildOrDmId = $author$project$Id$GuildOrDmId(
								$author$project$Id$GuildOrDmId_Guild(
									{channelId: channelId, guildId: guildId}));
							return _Utils_ap(
								$author$project$Pages$Guild$showInUnreadOverview$(
									$author$project$MuteSettings$isChannelMuted$(currentUser.muteSettings, guildId, channelId, $author$project$Id$NoThread),
									$lamdera$containers$SeqSet$member$(guildId, currentUser.notifyOnAllMessages) || $author$project$Pages$Guild$isMentioned$(
										$lamdera$containers$SeqDict$get$(guildId, currentUser.directMentions),
										_Utils_Tuple2(channelId, $author$project$Id$NoThread))) ? $elm$core$Maybe$withDefault$(
									_List_Nil,
									$elm$core$Maybe$map$(
										function (unread) {
											return _List_fromArray(
												[
													{
													additionalUnread: unread.additionalUnread,
													guildOrDmId: guildOrDmId,
													messages: $author$project$Pages$Guild$UnreadOverviewMessages(unread.messages),
													oldestAt: unread.oldestAt,
													route: $author$project$Route$GuildRoute$(
														guildId,
														$author$project$Route$ChannelRoute$(
															channelId,
															$author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1),
															$elm$core$Maybe$Nothing),
														0,
														$elm$core$Maybe$Nothing),
													source: $author$project$Pages$Guild$channelSource$(guild.name, channel.name),
													threadRoute: $author$project$Id$NoThreadWithMessage(unread.newestMessageId)
												}
												]);
										},
										$author$project$Pages$Guild$unreadMessages$(
											$lamdera$containers$SeqDict$get$(guildOrDmId, currentUser.lastViewedMessage),
											channel))) : _List_Nil,
								$elm$core$List$filterMap$(
									function (_v2) {
										var threadId = _v2.a;
										var thread = _v2.b;
										return $author$project$Pages$Guild$showInUnreadOverview$(
											$author$project$MuteSettings$isChannelMuted$(
												currentUser.muteSettings,
												guildId,
												channelId,
												$author$project$Id$ViewThread(threadId)),
											$lamdera$containers$SeqSet$member$(guildId, currentUser.notifyOnAllMessages) || $author$project$Pages$Guild$isMentioned$(
												$lamdera$containers$SeqDict$get$(guildId, currentUser.directMentions),
												_Utils_Tuple2(
													channelId,
													$author$project$Id$ViewThread(threadId)))) ? $elm$core$Maybe$map$(
											function (unread) {
												return {
													additionalUnread: unread.additionalUnread,
													guildOrDmId: guildOrDmId,
													messages: $author$project$Pages$Guild$UnreadOverviewThreadMessages$(threadId, unread.messages),
													oldestAt: unread.oldestAt,
													route: $author$project$Route$GuildRoute$(
														guildId,
														$author$project$Route$ChannelRoute$(
															channelId,
															$author$project$Route$ViewThreadWithFriends$(threadId, $elm$core$Maybe$Nothing, 1),
															$elm$core$Maybe$Nothing),
														0,
														$elm$core$Maybe$Nothing),
													source: $author$project$Pages$Guild$threadSource$(
														guild.name,
														channel.name,
														$author$project$Pages$Guild$threadPreviewText$(
															local.localUser.timezone,
															allUsers,
															$author$project$LocalState$guildChannelMentions$(local.localUser, guild.channels),
															threadId,
															local.localUser.decryptedMessages,
															channel)),
													threadRoute: $author$project$Id$ViewThreadWithMessage$(threadId, unread.newestMessageId)
												};
											},
											$author$project$Pages$Guild$unreadMessages$(
												$lamdera$containers$SeqDict$get$(
													_Utils_Tuple2(guildOrDmId, threadId),
													currentUser.lastViewedThreadMessage),
												thread)) : $elm$core$Maybe$Nothing;
									},
									$lamdera$containers$SeqDict$toList(channel.threads)));
						},
						$lamdera$containers$SeqDict$toList(guild.channels));
				},
				$lamdera$containers$SeqDict$toList(local.guilds)),
			_Utils_ap(
				$elm$core$List$concatMap$(
					function (_v3) {
						var otherUserId = _v3.a;
						var dmChannel = _v3.b;
						var guildOrDmId = $author$project$Id$GuildOrDmId(
							$author$project$Id$GuildOrDmId_Dm(
								{otherUserId: otherUserId}));
						return _Utils_ap(
							$author$project$MuteSettings$hidesRedDot(
								$author$project$MuteSettings$isDmMuted$(currentUser.muteSettings, otherUserId, $author$project$Id$NoThread)) ? _List_Nil : $elm$core$Maybe$withDefault$(
								_List_Nil,
								$elm$core$Maybe$map$(
									function (unread) {
										return _List_fromArray(
											[
												{
												additionalUnread: unread.additionalUnread,
												guildOrDmId: guildOrDmId,
												messages: $author$project$Pages$Guild$UnreadOverviewMessages(unread.messages),
												oldestAt: unread.oldestAt,
												route: $author$project$Route$DmRoute(
													{
														channelId: $author$project$DmChannelId$fromUserIds$(local.localUser.session.userId, otherUserId),
														channelsVisible: 0,
														overlay: $elm$core$Maybe$Nothing,
														tab: $elm$core$Maybe$Nothing,
														threadRoute: $author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1)
													}),
												source: $author$project$Pages$Guild$dmSource$(otherUserId, local.localUser),
												threadRoute: $author$project$Id$NoThreadWithMessage(unread.newestMessageId)
											}
											]);
									},
									$author$project$Pages$Guild$unreadMessages$(
										$lamdera$containers$SeqDict$get$(guildOrDmId, currentUser.lastViewedMessage),
										dmChannel))),
							$elm$core$List$filterMap$(
								function (_v4) {
									var threadId = _v4.a;
									var thread = _v4.b;
									return $author$project$MuteSettings$hidesRedDot(
										$author$project$MuteSettings$isDmMuted$(
											currentUser.muteSettings,
											otherUserId,
											$author$project$Id$ViewThread(threadId))) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$map$(
										function (unread) {
											return {
												additionalUnread: unread.additionalUnread,
												guildOrDmId: guildOrDmId,
												messages: $author$project$Pages$Guild$UnreadOverviewThreadMessages$(threadId, unread.messages),
												oldestAt: unread.oldestAt,
												route: $author$project$Route$DmRoute(
													{
														channelId: $author$project$DmChannelId$fromUserIds$(local.localUser.session.userId, otherUserId),
														channelsVisible: 0,
														overlay: $elm$core$Maybe$Nothing,
														tab: $elm$core$Maybe$Nothing,
														threadRoute: $author$project$Route$ViewThreadWithFriends$(threadId, $elm$core$Maybe$Nothing, 1)
													}),
												source: $author$project$Pages$Guild$dmThreadSource$(
													otherUserId,
													local.localUser,
													$author$project$Pages$Guild$threadPreviewText$(local.localUser.timezone, allUsers, $lamdera$containers$SeqDict$empty, threadId, local.localUser.decryptedMessages, dmChannel)),
												threadRoute: $author$project$Id$ViewThreadWithMessage$(threadId, unread.newestMessageId)
											};
										},
										$author$project$Pages$Guild$unreadMessages$(
											$lamdera$containers$SeqDict$get$(
												_Utils_Tuple2(guildOrDmId, threadId),
												currentUser.lastViewedThreadMessage),
											thread));
								},
								$lamdera$containers$SeqDict$toList(dmChannel.threads)));
					},
					$lamdera$containers$SeqDict$toList(local.dmChannels)),
				_Utils_ap(
					$elm$core$List$concatMap$(
						function (_v5) {
							var guildId = _v5.a;
							var guild = _v5.b;
							var _v6 = $author$project$GuildColumn$discordGuildCurrentUserId$(local.localUser, guild);
							if (!_v6.$) {
								var currentDiscordUserId = _v6.a;
								return $elm$core$List$concatMap$(
									function (_v7) {
										var channelId = _v7.a;
										var channel = _v7.b;
										var guildOrDmId = $author$project$Id$DiscordGuildOrDmId(
											$author$project$Id$DiscordGuildOrDmId_Guild(
												{channelId: channelId, currentUserId: currentDiscordUserId, guildId: guildId}));
										return _Utils_ap(
											$author$project$Pages$Guild$showInUnreadOverview$(
												$author$project$MuteSettings$isDiscordChannelMuted$(currentUser.muteSettings, guildId, channelId, $author$project$Id$NoThread),
												$lamdera$containers$SeqSet$member$(guildId, currentUser.discordNotifyOnAllMessages) || $author$project$Pages$Guild$isMentioned$(
													$lamdera$containers$SeqDict$get$(guildId, currentUser.discordDirectMentions),
													_Utils_Tuple2(channelId, $author$project$Id$NoThread))) ? $elm$core$Maybe$withDefault$(
												_List_Nil,
												$elm$core$Maybe$map$(
													function (unread) {
														return _List_fromArray(
															[
																{
																additionalUnread: unread.additionalUnread,
																guildOrDmId: guildOrDmId,
																messages: $author$project$Pages$Guild$UnreadOverviewDiscordMessages$(currentDiscordUserId, unread.messages),
																oldestAt: unread.oldestAt,
																route: $author$project$Route$DiscordGuildRoute(
																	{
																		channelRoute: $author$project$Route$DiscordChannel_ChannelRoute$(
																			channelId,
																			$author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1),
																			$elm$core$Maybe$Nothing),
																		channelsVisible: 0,
																		currentDiscordUserId: currentDiscordUserId,
																		guildId: guildId,
																		overlay: $elm$core$Maybe$Nothing
																	}),
																source: $author$project$Pages$Guild$channelSource$(guild.name, channel.name),
																threadRoute: $author$project$Id$NoThreadWithMessage(unread.newestMessageId)
															}
															]);
													},
													$author$project$Pages$Guild$unreadMessages$(
														$lamdera$containers$SeqDict$get$(guildOrDmId, currentUser.lastViewedMessage),
														channel))) : _List_Nil,
											$elm$core$List$filterMap$(
												function (_v8) {
													var threadId = _v8.a;
													var thread = _v8.b;
													return $author$project$Pages$Guild$showInUnreadOverview$(
														$author$project$MuteSettings$isDiscordChannelMuted$(
															currentUser.muteSettings,
															guildId,
															channelId,
															$author$project$Id$ViewThread(threadId)),
														$lamdera$containers$SeqSet$member$(guildId, currentUser.discordNotifyOnAllMessages) || $author$project$Pages$Guild$isMentioned$(
															$lamdera$containers$SeqDict$get$(guildId, currentUser.discordDirectMentions),
															_Utils_Tuple2(
																channelId,
																$author$project$Id$ViewThread(threadId)))) ? $elm$core$Maybe$map$(
														function (unread) {
															return {
																additionalUnread: unread.additionalUnread,
																guildOrDmId: guildOrDmId,
																messages: $author$project$Pages$Guild$UnreadOverviewDiscordThreadMessages$(threadId, currentDiscordUserId, unread.messages),
																oldestAt: unread.oldestAt,
																route: $author$project$Route$DiscordGuildRoute(
																	{
																		channelRoute: $author$project$Route$DiscordChannel_ChannelRoute$(
																			channelId,
																			$author$project$Route$ViewThreadWithFriends$(threadId, $elm$core$Maybe$Nothing, 1),
																			$elm$core$Maybe$Nothing),
																		channelsVisible: 0,
																		currentDiscordUserId: currentDiscordUserId,
																		guildId: guildId,
																		overlay: $elm$core$Maybe$Nothing
																	}),
																source: $author$project$Pages$Guild$threadSource$(
																	guild.name,
																	channel.name,
																	$author$project$Pages$Guild$threadPreviewText$(
																		local.localUser.timezone,
																		allDiscordUsers,
																		$author$project$LocalState$discordGuildChannelMentions$(local.localUser, guild.channels),
																		threadId,
																		$lamdera$containers$SeqDict$empty,
																		channel)),
																threadRoute: $author$project$Id$ViewThreadWithMessage$(threadId, unread.newestMessageId)
															};
														},
														$author$project$Pages$Guild$unreadMessages$(
															$lamdera$containers$SeqDict$get$(
																_Utils_Tuple2(guildOrDmId, threadId),
																currentUser.lastViewedThreadMessage),
															thread)) : $elm$core$Maybe$Nothing;
												},
												$lamdera$containers$SeqDict$toList(channel.threads)));
									},
									$lamdera$containers$SeqDict$toList(guild.channels));
							} else {
								return _List_Nil;
							}
						},
						$lamdera$containers$SeqDict$toList(local.discordGuilds)),
					_Utils_ap(
						$elm$core$List$filterMap$(
							function (_v9) {
								var channelId = _v9.a;
								var dmChannel = _v9.b;
								var _v10 = _Utils_Tuple2(
									$author$project$GuildColumn$discordDmCurrentUserId$(local.localUser, dmChannel),
									$author$project$MuteSettings$hidesRedDot(
										$author$project$MuteSettings$isDiscordDmMuted$(currentUser.muteSettings, channelId)));
								if ((!_v10.a.$) && (!_v10.b)) {
									var currentDiscordUserId = _v10.a.a;
									var guildOrDmId = $author$project$Id$DiscordGuildOrDmId(
										$author$project$Id$DiscordGuildOrDmId_Dm(
											{channelId: channelId, currentUserId: currentDiscordUserId}));
									return $elm$core$Maybe$map$(
										function (unread) {
											return {
												additionalUnread: unread.additionalUnread,
												guildOrDmId: guildOrDmId,
												messages: $author$project$Pages$Guild$UnreadOverviewDiscordMessages$(currentDiscordUserId, unread.messages),
												oldestAt: unread.oldestAt,
												route: $author$project$Route$DiscordDmRoute(
													{channelId: channelId, channelsVisible: 0, currentDiscordUserId: currentDiscordUserId, overlay: $elm$core$Maybe$Nothing, showMembersTab: 1, tab: $elm$core$Maybe$Nothing, viewingMessage: $elm$core$Maybe$Nothing}),
												source: $author$project$Pages$Guild$discordDmSource$(currentDiscordUserId, allDiscordUsers, dmChannel),
												threadRoute: $author$project$Id$NoThreadWithMessage(unread.newestMessageId)
											};
										},
										$author$project$Pages$Guild$unreadMessages$(
											$lamdera$containers$SeqDict$get$(guildOrDmId, currentUser.lastViewedMessage),
											dmChannel));
								} else {
									return $elm$core$Maybe$Nothing;
								}
							},
							$lamdera$containers$SeqDict$toList(local.discordDmChannels)),
						_Utils_ap(
							$elm$core$List$concatMap$(
								function (_v11) {
									var teamId = _v11.a;
									var workspace = _v11.b;
									var _v12 = $author$project$GuildColumn$slackWorkspaceCurrentUserId$(local.localUser, teamId);
									if (!_v12.$) {
										var currentSlackUserId = _v12.a;
										return $elm$core$List$concatMap$(
											function (_v13) {
												var channelId = _v13.a;
												var channel = _v13.b;
												var slackGuildOrDmId = $author$project$Id$SlackGuildOrDmId_Workspace(
													{channelId: channelId, currentUserId: currentSlackUserId, teamId: teamId});
												var guildOrDmId = $author$project$Id$SlackGuildOrDmId(slackGuildOrDmId);
												return _Utils_ap(
													$author$project$Pages$Guild$showInUnreadOverview$(
														$author$project$MuteSettings$isSlackChannelMuted$(currentUser.muteSettings, teamId, channelId, $author$project$Id$NoThread),
														$lamdera$containers$SeqSet$member$(teamId, currentUser.slackNotifyOnAllMessages) || $author$project$Pages$Guild$isMentioned$(
															$lamdera$containers$SeqDict$get$(teamId, currentUser.slackDirectMentions),
															_Utils_Tuple2(channelId, $author$project$Id$NoThread))) ? $elm$core$Maybe$withDefault$(
														_List_Nil,
														$elm$core$Maybe$map$(
															function (unread) {
																return _List_fromArray(
																	[
																		{
																		additionalUnread: unread.additionalUnread,
																		guildOrDmId: guildOrDmId,
																		messages: $author$project$Pages$Guild$UnreadOverviewSlackMessages$(currentSlackUserId, unread.messages),
																		oldestAt: unread.oldestAt,
																		route: $author$project$Route$SlackWorkspaceRoute(
																			{
																				channelRoute: $author$project$Route$SlackChannel_ChannelRoute$(
																					channelId,
																					$author$project$Id$NoThreadWithMaybeMessage($elm$core$Maybe$Nothing),
																					1),
																				channelsVisible: 0,
																				currentSlackUserId: currentSlackUserId,
																				overlay: $elm$core$Maybe$Nothing,
																				teamId: teamId
																			}),
																		source: $author$project$Pages$Guild$slackChannelSource$(workspace.name, channel.name),
																		threadRoute: $author$project$Id$NoThreadWithMessage(unread.newestMessageId)
																	}
																	]);
															},
															$author$project$Pages$Guild$unreadMessages$(
																$lamdera$containers$SeqDict$get$(guildOrDmId, currentUser.lastViewedMessage),
																channel))) : _List_Nil,
													$elm$core$List$filterMap$(
														function (_v14) {
															var threadId = _v14.a;
															var thread = _v14.b;
															return $author$project$Pages$Guild$showInUnreadOverview$(
																$author$project$MuteSettings$isSlackChannelMuted$(
																	currentUser.muteSettings,
																	teamId,
																	channelId,
																	$author$project$Id$ViewThread(threadId)),
																$lamdera$containers$SeqSet$member$(teamId, currentUser.slackNotifyOnAllMessages) || $author$project$Pages$Guild$isMentioned$(
																	$lamdera$containers$SeqDict$get$(teamId, currentUser.slackDirectMentions),
																	_Utils_Tuple2(
																		channelId,
																		$author$project$Id$ViewThread(threadId)))) ? $elm$core$Maybe$map$(
																function (unread) {
																	return {
																		additionalUnread: unread.additionalUnread,
																		guildOrDmId: guildOrDmId,
																		messages: $author$project$Pages$Guild$UnreadOverviewSlackThreadMessages$(threadId, currentSlackUserId, unread.messages),
																		oldestAt: unread.oldestAt,
																		route: $author$project$Route$SlackWorkspaceRoute(
																			{
																				channelRoute: $author$project$Route$SlackChannel_ChannelRoute$(
																					channelId,
																					$author$project$Id$ViewThreadWithMaybeMessage$(threadId, $elm$core$Maybe$Nothing),
																					1),
																				channelsVisible: 0,
																				currentSlackUserId: currentSlackUserId,
																				overlay: $elm$core$Maybe$Nothing,
																				teamId: teamId
																			}),
																		source: $author$project$Pages$Guild$slackThreadSource$(
																			workspace.name,
																			channel.name,
																			$author$project$Pages$Guild$threadPreviewText$(
																				local.localUser.timezone,
																				local.localUser.slackUsers,
																				$author$project$LocalState$slackChannelMentions$(slackGuildOrDmId, local),
																				threadId,
																				$lamdera$containers$SeqDict$empty,
																				channel)),
																		threadRoute: $author$project$Id$ViewThreadWithMessage$(threadId, unread.newestMessageId)
																	};
																},
																$author$project$Pages$Guild$unreadMessages$(
																	$lamdera$containers$SeqDict$get$(
																		_Utils_Tuple2(guildOrDmId, threadId),
																		currentUser.lastViewedThreadMessage),
																	thread)) : $elm$core$Maybe$Nothing;
														},
														$lamdera$containers$SeqDict$toList(channel.threads)));
											},
											$lamdera$containers$SeqDict$toList(workspace.channels));
									} else {
										return _List_Nil;
									}
								},
								$lamdera$containers$SeqDict$toList(local.slackWorkspaces)),
							$elm$core$List$concatMap$(
								function (_v15) {
									var channelId = _v15.a;
									var dmChannel = _v15.b;
									var _v16 = $author$project$GuildColumn$slackDmCurrentUserId$(local.localUser, dmChannel);
									if (!_v16.$) {
										var currentSlackUserId = _v16.a;
										var guildOrDmId = $author$project$Id$SlackGuildOrDmId(
											$author$project$Id$SlackGuildOrDmId_Dm(
												{channelId: channelId, currentUserId: currentSlackUserId}));
										var dmName = $elm$core$String$join$(
											', ',
											$elm$core$List$map$(
												function (userId) {
													return $author$project$User$toString$(userId, local.localUser.slackUsers);
												},
												$author$project$Pages$Guild$slackDmMembers$(currentSlackUserId, dmChannel)));
										return _Utils_ap(
											$elm$core$Maybe$withDefault$(
												_List_Nil,
												$elm$core$Maybe$map$(
													function (unread) {
														return _List_fromArray(
															[
																{
																additionalUnread: unread.additionalUnread,
																guildOrDmId: guildOrDmId,
																messages: $author$project$Pages$Guild$UnreadOverviewSlackMessages$(currentSlackUserId, unread.messages),
																oldestAt: unread.oldestAt,
																route: $author$project$Route$SlackDmRoute(
																	{
																		channelId: channelId,
																		channelsVisible: 0,
																		currentSlackUserId: currentSlackUserId,
																		overlay: $elm$core$Maybe$Nothing,
																		threadRoute: $author$project$Id$NoThreadWithMaybeMessage($elm$core$Maybe$Nothing)
																	}),
																source: $author$project$Ui$text(dmName),
																threadRoute: $author$project$Id$NoThreadWithMessage(unread.newestMessageId)
															}
															]);
													},
													$author$project$Pages$Guild$unreadMessages$(
														$lamdera$containers$SeqDict$get$(guildOrDmId, currentUser.lastViewedMessage),
														dmChannel))),
											$elm$core$List$filterMap$(
												function (_v17) {
													var threadId = _v17.a;
													var thread = _v17.b;
													return $elm$core$Maybe$map$(
														function (unread) {
															return {
																additionalUnread: unread.additionalUnread,
																guildOrDmId: guildOrDmId,
																messages: $author$project$Pages$Guild$UnreadOverviewSlackThreadMessages$(threadId, currentSlackUserId, unread.messages),
																oldestAt: unread.oldestAt,
																route: $author$project$Route$SlackDmRoute(
																	{
																		channelId: channelId,
																		channelsVisible: 0,
																		currentSlackUserId: currentSlackUserId,
																		overlay: $elm$core$Maybe$Nothing,
																		threadRoute: $author$project$Id$ViewThreadWithMaybeMessage$(threadId, $elm$core$Maybe$Nothing)
																	}),
																source: $author$project$Pages$Guild$slackDmThreadSource$(
																	dmName,
																	$author$project$Pages$Guild$threadPreviewText$(local.localUser.timezone, local.localUser.slackUsers, $lamdera$containers$SeqDict$empty, threadId, $lamdera$containers$SeqDict$empty, dmChannel)),
																threadRoute: $author$project$Id$ViewThreadWithMessage$(threadId, unread.newestMessageId)
															};
														},
														$author$project$Pages$Guild$unreadMessages$(
															$lamdera$containers$SeqDict$get$(
																_Utils_Tuple2(guildOrDmId, threadId),
																currentUser.lastViewedThreadMessage),
															thread));
												},
												$lamdera$containers$SeqDict$toList(dmChannel.threads)));
									} else {
										return _List_Nil;
									}
								},
								$lamdera$containers$SeqDict$toList(local.slackDmChannels))))))));
};
var $author$project$Pages$Guild$unreadOverviewChannels = F2($author$project$Pages$Guild$unreadOverviewChannels$);
var $author$project$Types$PressedMarkChannelAsRead$ = function (a, b) {
	return {$: 176, a: a, b: b};
};
var $author$project$Types$PressedMarkChannelAsRead = F2($author$project$Types$PressedMarkChannelAsRead$);
var $author$project$Pages$Guild$olderUnreadMessagesText = function (count) {
	return (count === 1) ? '1 older unread message' : ($elm$core$String$fromInt(count) + ' older unread messages');
};
var $author$project$Pages$Guild$unreadOverviewHtmlId$ = function (prefix, guildOrDmId, threadRoute) {
	return function (suffix) {
		return $lamdera$program_test$Effect$Browser$Dom$id(
			_Utils_ap(prefix, suffix));
	}(
		_Utils_ap(
			function () {
				switch (guildOrDmId.$) {
					case 0:
						if (!guildOrDmId.a.$) {
							var channelId = guildOrDmId.a.a.channelId;
							var guildId = guildOrDmId.a.a.guildId;
							return 'guild_' + ($author$project$Id$toString(guildId) + ('_' + $author$project$Id$toString(channelId)));
						} else {
							var otherUserId = guildOrDmId.a.a.otherUserId;
							return 'dm_' + $author$project$Id$toString(otherUserId);
						}
					case 1:
						if (!guildOrDmId.a.$) {
							var channelId = guildOrDmId.a.a.channelId;
							var guildId = guildOrDmId.a.a.guildId;
							return 'discord_' + ($author$project$Discord$idToString(guildId) + ('_' + $author$project$Discord$idToString(channelId)));
						} else {
							var data = guildOrDmId.a.a;
							return 'discordDm_' + $author$project$Discord$idToString(data.channelId);
						}
					default:
						if (!guildOrDmId.a.$) {
							var channelId = guildOrDmId.a.a.channelId;
							var teamId = guildOrDmId.a.a.teamId;
							return 'slack_' + ($author$project$Slack$idToString(teamId) + ('_' + $author$project$Slack$idToString(channelId)));
						} else {
							var data = guildOrDmId.a.a;
							return 'slackDm_' + $author$project$Slack$idToString(data.channelId);
						}
				}
			}(),
			function () {
				if (!threadRoute.$) {
					return '';
				} else {
					var threadId = threadRoute.a;
					return '_thread_' + $author$project$Id$toString(threadId);
				}
			}()));
};
var $author$project$Pages$Guild$unreadOverviewHtmlId = F3($author$project$Pages$Guild$unreadOverviewHtmlId$);
var $author$project$Pages$Guild$unreadOverviewDateDivider = function (date) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$paddingXY$(8, 0),
				$author$project$Ui$height(
				$author$project$Ui$px(20)),
				$author$project$Ui$contentCenterY,
				$author$project$MyUi$noShrinking
			]),
		$author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$borderWith(
					{bottom: 0, left: 0, right: 0, top: 1}),
					$author$project$Ui$borderColor($author$project$MyUi$font3),
					$author$project$Ui$inFront(
					$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$centerX,
								$author$project$Ui$width($author$project$Ui$shrink),
								$author$project$Ui$move(
								{x: 0, y: -9, z: 0}),
								$author$project$Ui$background($author$project$MyUi$background3),
								$author$project$Ui$paddingXY$(6, 0),
								$author$project$Ui$Font$color($author$project$MyUi$font3),
								$author$project$Ui$Font$size(14),
								$author$project$Ui$Font$bold
							]),
						$author$project$Ui$text(
							$author$project$MyUi$datestampDate(date))))
				]),
			$author$project$Ui$none));
};
var $author$project$Pages$Guild$unreadOverviewMessages = function (messageViews) {
	return $elm$core$List$reverse(
		$elm$core$List$foldl$(
			F2(
				function (_v0, _v1) {
					var date = _v0.a;
					var messageView2 = _v0.b;
					var maybeLastDate = _v1.a;
					var list = _v1.b;
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(date),
						_Utils_eq(
							maybeLastDate,
							$elm$core$Maybe$Just(date)) ? A2($elm$core$List$cons, messageView2, list) : A2(
							$elm$core$List$cons,
							messageView2,
							A2(
								$elm$core$List$cons,
								$author$project$Pages$Guild$unreadOverviewDateDivider(date),
								list)));
				}),
			_Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil),
			messageViews).b);
};
var $author$project$Pages$Guild$unreadOverviewContainer$ = function (unread, messageViews) {
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$MyUi$noShrinking,
				$author$project$Ui$borderColor($author$project$MyUi$border2),
				$author$project$Ui$borderWith(
				{bottom: 2, left: 0, right: 0, top: 0})
			]),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(8),
						$author$project$Ui$paddingWith(
						{bottom: 0, left: 8, right: 8, top: 6}),
						$author$project$Ui$contentCenterY
					]),
				_List_fromArray(
					[
						$author$project$GuildColumn$elLinkButton$(
						$author$project$Pages$Guild$unreadOverviewHtmlId$('guild_unreadOverviewOpenChannel_', unread.guildOrDmId, unread.threadRoute),
						unread.route,
						_List_fromArray(
							[
								$author$project$Ui$Font$bold,
								$author$project$Ui$Font$color($author$project$MyUi$font3),
								$author$project$Ui$clipWithEllipsis,
								$author$project$MyUi$hover$(
								false,
								_List_fromArray(
									[
										$author$project$Ui$Anim$fontColor($author$project$MyUi$font1)
									]))
							]),
						unread.source),
						$author$project$MyUi$elButton$(
						$author$project$Pages$Guild$unreadOverviewHtmlId$('guild_unreadOverviewMarkAsRead_', unread.guildOrDmId, unread.threadRoute),
						$author$project$Types$PressedMarkChannelAsRead$(unread.guildOrDmId, unread.threadRoute),
						_List_fromArray(
							[
								$author$project$Ui$width($author$project$Ui$shrink),
								$author$project$Ui$alignRight,
								$author$project$Ui$paddingXY$(8, 2),
								$author$project$Ui$rounded(4),
								$author$project$Ui$border(1),
								$author$project$Ui$borderColor($author$project$MyUi$buttonBorder),
								$author$project$Ui$background($author$project$MyUi$buttonBackground),
								$author$project$Ui$Font$color($author$project$MyUi$font1),
								$author$project$MyUi$noShrinking
							]),
						$author$project$Ui$text('Mark as read'))
					])),
			A2(
				$elm$core$List$cons,
				(unread.additionalUnread > 0) ? $author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$Font$color($author$project$MyUi$font3),
							$author$project$Ui$Font$italic,
							$author$project$Ui$paddingWith(
							{bottom: 4, left: 8, right: 8, top: 0})
						]),
					$author$project$Ui$text(
						$author$project$Pages$Guild$olderUnreadMessagesText(unread.additionalUnread))) : $author$project$Ui$none,
				$author$project$Pages$Guild$unreadOverviewMessages(messageViews))));
};
var $author$project$Pages$Guild$unreadOverviewContainer = F2($author$project$Pages$Guild$unreadOverviewContainer$);
var $author$project$Pages$Guild$unreadOverviewMarkAllAsReadId = $lamdera$program_test$Effect$Browser$Dom$id('guild_unreadOverviewMarkAllAsRead');
var $author$project$Pages$Guild$unreadOverviewMessageHover$ = function (guildOrDmId, threadRoute, loggedIn) {
	var _v0 = loggedIn.messageHover;
	switch (_v0.$) {
		case 1:
			var hoveredGuildOrDmId = _v0.a;
			var hoveredThreadRoute = _v0.b;
			return (_Utils_eq(guildOrDmId, hoveredGuildOrDmId) && _Utils_eq(threadRoute, hoveredThreadRoute)) ? $author$project$Pages$Guild$IsHoveredReactionsOnly : $author$project$Pages$Guild$IsNotHovered;
		case 3:
			var hoveredGuildOrDmId = _v0.a;
			var hoveredThreadRoute = _v0.b;
			var reactionIndex = _v0.c;
			return (_Utils_eq(guildOrDmId, hoveredGuildOrDmId) && _Utils_eq(threadRoute, hoveredThreadRoute)) ? $author$project$Pages$Guild$IsReactionLongPressed(reactionIndex) : $author$project$Pages$Guild$IsNotHovered;
		case 0:
			return $author$project$Pages$Guild$IsNotHovered;
		default:
			return $author$project$Pages$Guild$IsNotHovered;
	}
};
var $author$project$Pages$Guild$unreadOverviewMessageHover = F3($author$project$Pages$Guild$unreadOverviewMessageHover$);
var $author$project$Pages$Guild$unreadOverviewNotMobile$ = function (local, loggedIn, model) {
	var containerWidth = $author$project$Pages$Guild$conversationWidth(model);
	var allUsers = $author$project$User$allUsers(local.localUser);
	var allDiscordUsers = $author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(local.localUser.discordUsers);
	var unreads = $author$project$Pages$Guild$unreadOverviewChannels$(local, allDiscordUsers);
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$Ui$heightMin(0),
				$author$project$Ui$Font$color($author$project$MyUi$font1),
				$author$project$Pages$Guild$emojiSelector$(
				$author$project$MyUi$isMobile(model),
				local.localUser.user.availableCustomEmojis,
				local.localUser.user.availableStickers,
				local,
				loggedIn,
				model)
			]),
		_List_fromArray(
			[
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$paddingXY$(8, 0),
						$author$project$Ui$spacing(8),
						$author$project$Ui$height(
						$author$project$Ui$px($author$project$MyUi$channelHeaderHeight)),
						$author$project$Ui$contentCenterY,
						$author$project$MyUi$noShrinking,
						$author$project$Ui$borderWith(
						{bottom: 1, left: 0, right: 0, top: 0}),
						$author$project$Ui$borderColor($author$project$MyUi$border2)
					]),
				_List_fromArray(
					[
						$author$project$Ui$el$(
						_List_fromArray(
							[$author$project$Ui$Font$bold]),
						$author$project$Ui$text('All unread messages')),
						function () {
						if (!unreads.b) {
							return $author$project$Ui$none;
						} else {
							return $author$project$MyUi$elButton$(
								$author$project$Pages$Guild$unreadOverviewMarkAllAsReadId,
								$author$project$Types$PressedMarkAllChannelsAsRead(
									$elm$core$List$map$(
										function (unread) {
											return _Utils_Tuple2(unread.guildOrDmId, unread.threadRoute);
										},
										unreads)),
								_List_fromArray(
									[
										$author$project$Ui$width($author$project$Ui$shrink),
										$author$project$Ui$alignRight,
										$author$project$Ui$paddingXY$(8, 2),
										$author$project$Ui$rounded(4),
										$author$project$Ui$border(1),
										$author$project$Ui$borderColor($author$project$MyUi$buttonBorder),
										$author$project$Ui$background($author$project$MyUi$buttonBackground),
										$author$project$MyUi$noShrinking
									]),
								$author$project$Ui$text('Mark all as read'));
						}
					}()
					])),
				function () {
				if (!unreads.b) {
					var dpi = model.startupData.devicePixelRatio;
					var art = $mgold$elm_nonempty_list$List$Nonempty$get$(
						$elm$time$Time$toDay$(model.timezone, model.time) - $elm$time$Time$toDay$(model.timezone, local.localUser.user.createdAt),
						$author$project$AsciiArt$art);
					var scaleFactor = $elm$core$Basics$clamp$(
						1,
						$elm$core$Basics$round(2 * dpi),
						$elm$core$Basics$min$(
							($elm$core$Basics$round(dpi * containerWidth) / $author$project$Coord$xRaw(art.size)) | 0,
							($elm$core$Basics$round(
								dpi * (($author$project$Coord$yRaw(model.windowSize) - $author$project$MyUi$channelHeaderHeight) - 80)) / $author$project$Coord$yRaw(art.size)) | 0));
					return $author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$height($author$project$Ui$fill),
								$author$project$Ui$inFront(
								$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$Font$center,
											$author$project$Ui$padding(16),
											$author$project$Ui$Font$color($author$project$MyUi$font3),
											$author$project$Ui$Font$bold,
											$author$project$Ui$Font$size(20)
										]),
									$author$project$Ui$text($author$project$Pages$Guild$noUnreadMessagesText)))
							]),
						_List_fromArray(
							[
								$author$project$Ui$image$(
								_List_fromArray(
									[
										$author$project$MyUi$htmlStyle$('image-rendering', 'pixelated'),
										$author$project$Ui$centerX,
										$author$project$Ui$centerY,
										$author$project$Ui$paddingXY$(0, 16),
										$author$project$MyUi$htmlStyle$(
										'width',
										$elm$core$String$fromFloat(
											($author$project$Coord$xRaw(art.size) * scaleFactor) / dpi) + 'px'),
										$author$project$Ui$opacity(0.3),
										$author$project$MyUi$hover$(
										false,
										_List_fromArray(
											[
												$author$project$Ui$Anim$opacity(0.6)
											])),
										$author$project$Ui$linkNewTab(
										'https://ascii-collab.app/?x=' + ($elm$core$String$fromInt(
											$author$project$Coord$xRaw(art.coordinates)) + ('&y=' + $elm$core$String$fromInt(
											$author$project$Coord$yRaw(art.coordinates)))))
									]),
								{description: 'Pleasing ascii art drawing', onLoad: $elm$core$Maybe$Nothing, source: '/cacheable/art/' + (art.url + '.png')})
							]));
				} else {
					return $author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$height($author$project$Ui$fill),
								$author$project$Ui$heightMin(0),
								$author$project$MyUi$scrollable(true),
								$author$project$Ui$paddingWith(
								{bottom: 0, left: 0, right: 0, top: 2})
							]),
						$elm$core$List$map$(
							function (unread) {
								return $author$project$Pages$Guild$unreadOverviewContainer$(
									unread,
									function () {
										var _v2 = unread.messages;
										switch (_v2.$) {
											case 0:
												var messages = _v2.a;
												var revealedSpoilers = $author$project$Pages$Guild$revealedChannelSpoilers$(unread.guildOrDmId, loggedIn);
												return $elm$core$List$map$(
													function (_v3) {
														var messageId = _v3.a;
														var message = _v3.b;
														return _Utils_Tuple2(
															$justinmimbs$date$Date$fromPosix$(
																local.localUser.timezone,
																$author$project$Message$createdAt(message)),
															A2(
																$author$project$Ui$map,
																A2($author$project$Types$UnreadOverviewChannelMsg, unread.guildOrDmId, messageId),
																$author$project$Pages$Guild$messageView$(
																	model.time,
																	false,
																	containerWidth,
																	false,
																	revealedSpoilers,
																	0,
																	$author$project$Pages$Guild$unreadOverviewMessageHover$(
																		unread.guildOrDmId,
																		$author$project$Id$NoThreadWithMessage(messageId),
																		loggedIn),
																	false,
																	local.localUser.session.userId,
																	allUsers,
																	function () {
																		var _v4 = unread.guildOrDmId;
																		switch (_v4.$) {
																			case 0:
																				var guildOrDmId = _v4.a;
																				return $author$project$LocalState$guildChannels$(guildOrDmId, local);
																			case 1:
																				return $lamdera$containers$SeqDict$empty;
																			default:
																				return $lamdera$containers$SeqDict$empty;
																		}
																	}(),
																	local.localUser,
																	$elm$core$Maybe$Nothing,
																	$elm$core$Maybe$Nothing,
																	messageId,
																	message)));
													},
													messages);
											case 1:
												var threadId = _v2.a;
												var messages = _v2.b;
												var revealedSpoilers = $author$project$Pages$Guild$revealedThreadSpoilers$(unread.guildOrDmId, threadId, loggedIn);
												return $elm$core$List$map$(
													function (_v5) {
														var messageId = _v5.a;
														var message = _v5.b;
														return _Utils_Tuple2(
															$justinmimbs$date$Date$fromPosix$(
																local.localUser.timezone,
																$author$project$Message$createdAt(message)),
															A2(
																$author$project$Ui$map,
																A3($author$project$Types$UnreadOverviewThreadMsg, unread.guildOrDmId, threadId, messageId),
																$author$project$Pages$Guild$threadMessageView$(
																	model.time,
																	false,
																	containerWidth,
																	revealedSpoilers,
																	0,
																	$author$project$Pages$Guild$unreadOverviewMessageHover$(
																		unread.guildOrDmId,
																		$author$project$Id$ViewThreadWithMessage$(threadId, messageId),
																		loggedIn),
																	false,
																	allUsers,
																	function () {
																		var _v6 = unread.guildOrDmId;
																		switch (_v6.$) {
																			case 0:
																				var guildOrDmId = _v6.a;
																				return $author$project$LocalState$channelMentions$(guildOrDmId, local);
																			case 1:
																				return $lamdera$containers$SeqDict$empty;
																			default:
																				return $lamdera$containers$SeqDict$empty;
																		}
																	}(),
																	local.localUser.session.userId,
																	local.localUser,
																	$elm$core$Maybe$Nothing,
																	messageId,
																	message)));
													},
													messages);
											case 2:
												var currentDiscordUserId = _v2.a;
												var messages = _v2.b;
												var revealedSpoilers = $author$project$Pages$Guild$revealedChannelSpoilers$(unread.guildOrDmId, loggedIn);
												return $elm$core$List$map$(
													function (_v7) {
														var messageId = _v7.a;
														var message = _v7.b;
														return _Utils_Tuple2(
															$justinmimbs$date$Date$fromPosix$(
																local.localUser.timezone,
																$author$project$Message$createdAt(message)),
															A2(
																$author$project$Ui$map,
																A2($author$project$Types$UnreadOverviewChannelMsg, unread.guildOrDmId, messageId),
																$author$project$Pages$Guild$discordMessageView$(
																	model.time,
																	false,
																	containerWidth,
																	false,
																	revealedSpoilers,
																	0,
																	$author$project$Pages$Guild$unreadOverviewMessageHover$(
																		unread.guildOrDmId,
																		$author$project$Id$NoThreadWithMessage(messageId),
																		loggedIn),
																	currentDiscordUserId,
																	allDiscordUsers,
																	function () {
																		var _v8 = unread.guildOrDmId;
																		switch (_v8.$) {
																			case 0:
																				return $lamdera$containers$SeqDict$empty;
																			case 1:
																				var guildOrDmId = _v8.a;
																				return $author$project$LocalState$discordChannelMentions$(guildOrDmId, local);
																			default:
																				return $lamdera$containers$SeqDict$empty;
																		}
																	}(),
																	local.localUser,
																	$elm$core$Maybe$Nothing,
																	$elm$core$Maybe$Nothing,
																	messageId,
																	message)));
													},
													messages);
											case 3:
												var threadId = _v2.a;
												var currentDiscordUserId = _v2.b;
												var messages = _v2.c;
												var revealedSpoilers = $author$project$Pages$Guild$revealedThreadSpoilers$(unread.guildOrDmId, threadId, loggedIn);
												return $elm$core$List$map$(
													function (_v9) {
														var messageId = _v9.a;
														var message = _v9.b;
														return _Utils_Tuple2(
															$justinmimbs$date$Date$fromPosix$(
																local.localUser.timezone,
																$author$project$Message$createdAt(message)),
															A2(
																$author$project$Ui$map,
																A3($author$project$Types$UnreadOverviewThreadMsg, unread.guildOrDmId, threadId, messageId),
																$author$project$Pages$Guild$discordThreadMessageView$(
																	model.time,
																	false,
																	containerWidth,
																	revealedSpoilers,
																	0,
																	$author$project$Pages$Guild$unreadOverviewMessageHover$(
																		unread.guildOrDmId,
																		$author$project$Id$ViewThreadWithMessage$(threadId, messageId),
																		loggedIn),
																	allDiscordUsers,
																	function () {
																		var _v10 = unread.guildOrDmId;
																		switch (_v10.$) {
																			case 0:
																				return $lamdera$containers$SeqDict$empty;
																			case 1:
																				var guildOrDmId = _v10.a;
																				return $author$project$LocalState$discordChannelMentions$(guildOrDmId, local);
																			default:
																				return $lamdera$containers$SeqDict$empty;
																		}
																	}(),
																	currentDiscordUserId,
																	local.localUser,
																	$elm$core$Maybe$Nothing,
																	messageId,
																	message)));
													},
													messages);
											case 4:
												var currentSlackUserId = _v2.a;
												var messages = _v2.b;
												var revealedSpoilers = $author$project$Pages$Guild$revealedChannelSpoilers$(unread.guildOrDmId, loggedIn);
												return $elm$core$List$map$(
													function (_v11) {
														var messageId = _v11.a;
														var message = _v11.b;
														return _Utils_Tuple2(
															$justinmimbs$date$Date$fromPosix$(
																local.localUser.timezone,
																$author$project$Message$createdAt(message)),
															A2(
																$author$project$Ui$map,
																A2($author$project$Types$UnreadOverviewChannelMsg, unread.guildOrDmId, messageId),
																$author$project$Pages$Guild$slackMessageView$(
																	model.time,
																	containerWidth,
																	revealedSpoilers,
																	0,
																	currentSlackUserId,
																	function () {
																		var _v12 = unread.guildOrDmId;
																		switch (_v12.$) {
																			case 0:
																				return $lamdera$containers$SeqDict$empty;
																			case 1:
																				return $lamdera$containers$SeqDict$empty;
																			default:
																				var guildOrDmId = _v12.a;
																				return $author$project$LocalState$slackChannelMentions$(guildOrDmId, local);
																		}
																	}(),
																	local.localUser,
																	$elm$core$Maybe$Nothing,
																	false,
																	$author$project$Pages$Guild$unreadOverviewMessageHover$(
																		unread.guildOrDmId,
																		$author$project$Id$NoThreadWithMessage(messageId),
																		loggedIn),
																	messageId,
																	message)));
													},
													messages);
											default:
												var threadId = _v2.a;
												var currentSlackUserId = _v2.b;
												var messages = _v2.c;
												var revealedSpoilers = $author$project$Pages$Guild$revealedThreadSpoilers$(unread.guildOrDmId, threadId, loggedIn);
												return $elm$core$List$map$(
													function (_v13) {
														var messageId = _v13.a;
														var message = _v13.b;
														return _Utils_Tuple2(
															$justinmimbs$date$Date$fromPosix$(
																local.localUser.timezone,
																$author$project$Message$createdAt(message)),
															A2(
																$author$project$Ui$map,
																A3($author$project$Types$UnreadOverviewThreadMsg, unread.guildOrDmId, threadId, messageId),
																$author$project$Pages$Guild$slackThreadMessageView$(
																	model.time,
																	containerWidth,
																	revealedSpoilers,
																	0,
																	currentSlackUserId,
																	function () {
																		var _v14 = unread.guildOrDmId;
																		switch (_v14.$) {
																			case 0:
																				return $lamdera$containers$SeqDict$empty;
																			case 1:
																				return $lamdera$containers$SeqDict$empty;
																			default:
																				var guildOrDmId = _v14.a;
																				return $author$project$LocalState$slackChannelMentions$(guildOrDmId, local);
																		}
																	}(),
																	local.localUser,
																	$author$project$Pages$Guild$unreadOverviewMessageHover$(
																		unread.guildOrDmId,
																		$author$project$Id$ViewThreadWithMessage$(threadId, messageId),
																		loggedIn),
																	messageId,
																	message)));
													},
													messages);
										}
									}());
							},
							unreads));
				}
			}()
			]));
};
var $author$project$Pages$Guild$unreadOverviewNotMobile = F3($author$project$Pages$Guild$unreadOverviewNotMobile$);
var $author$project$Pages$Guild$homePageLoggedInView$ = function (maybeOtherUserId, model, loggedIn, local) {
	var _v0 = loggedIn.showFileToUploadInfo;
	if (!_v0.$) {
		var fileData = _v0.a;
		return $author$project$FileStatus$imageInfoView$(local.localUser.safeAreaInsetTop, local.localUser.safeAreaInsetBottom, model.timezone, $author$project$Types$PressedCloseImageInfo, fileData);
	} else {
		if ($author$project$MyUi$isMobile(model)) {
			var showMembers = $author$project$Route$toShowMembersTabVisible$(loggedIn, model.route);
			var canScroll2 = $author$project$MyUi$canScroll$(true, model.drag);
			var memberColumn = function () {
				if (!showMembers.a) {
					var _v3 = showMembers.a;
					var isThread = showMembers.b;
					switch (maybeOtherUserId.$) {
						case 0:
							var dmRoute = maybeOtherUserId.a;
							var _v5 = $author$project$DmChannelId$otherUserId$(local.localUser.session.userId, dmRoute.channelId);
							if (!_v5.$) {
								var otherUserId = _v5.a;
								return $author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$height($author$project$Ui$fill),
											$author$project$Ui$background($author$project$MyUi$background3),
											$author$project$Ui$paddingWith(
											{bottom: 0, left: 0, right: 0, top: local.localUser.safeAreaInsetTop}),
											$author$project$Ui$move(
											{
												x: $author$project$Call$memberColumnOffset$(loggedIn.sidebarMode, model),
												y: 0,
												z: 0
											}),
											$author$project$Ui$heightMin(0)
										]),
									$author$project$Pages$Guild$dmChannelSettingsMobile$(
										canScroll2,
										local.localUser,
										otherUserId,
										isThread,
										$author$project$Pages$Guild$dmE2eeStatus$(otherUserId, local),
										$author$project$Pages$Guild$e2eeSectionIsExpanded$(otherUserId, local, loggedIn),
										$author$project$Pages$Guild$e2eeKeyInput$(otherUserId, loggedIn)));
							} else {
								return $author$project$Ui$none;
							}
						case 1:
							var routeData = maybeOtherUserId.a;
							var _v6 = $lamdera$containers$SeqDict$get$(routeData.channelId, local.discordDmChannels);
							if (!_v6.$) {
								var dmChannel = _v6.a;
								return $author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$height($author$project$Ui$fill),
											$author$project$Ui$background($author$project$MyUi$background3),
											$author$project$Ui$paddingWith(
											{bottom: 0, left: 0, right: 0, top: local.localUser.safeAreaInsetTop}),
											$author$project$Ui$move(
											{
												x: $author$project$Call$memberColumnOffset$(loggedIn.sidebarMode, model),
												y: 0,
												z: 0
											}),
											$author$project$Ui$heightMin(0)
										]),
									$author$project$Pages$Guild$discordDmChannelSettingsMobile$(canScroll2, local.localUser, routeData.currentDiscordUserId, routeData.channelId, dmChannel));
							} else {
								return $author$project$Ui$none;
							}
						case 2:
							return $author$project$Ui$none;
						default:
							return $author$project$Ui$none;
					}
				} else {
					var _v7 = showMembers.a;
					return $author$project$Ui$none;
				}
			}();
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$background($author$project$MyUi$background1),
						$author$project$Ui$heightMin(0),
						$author$project$MyUi$unscrollable,
						$author$project$Ui$inFront(memberColumn),
						function () {
						switch (maybeOtherUserId.$) {
							case 0:
								var dmRoute = maybeOtherUserId.a;
								return $author$project$Ui$inFront(
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$height($author$project$Ui$fill),
												$author$project$Ui$background($author$project$MyUi$background3),
												$author$project$Ui$paddingWith(
												{bottom: 0, left: 0, right: 0, top: local.localUser.safeAreaInsetTop}),
												$author$project$Ui$move(
												{
													x: $author$project$Call$conversationOffset$(loggedIn.sidebarMode, model),
													y: 0,
													z: 0
												}),
												$author$project$Ui$heightMin(0),
												$author$project$Ui$borderColor($author$project$MyUi$border1),
												$author$project$Ui$borderWith(
												{bottom: 0, left: 0, right: 0, top: 1})
											]),
										$author$project$Pages$Guild$dmChannelView$(dmRoute, loggedIn, local, model)));
							case 1:
								var routeData = maybeOtherUserId.a;
								return $author$project$Ui$inFront(
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$height($author$project$Ui$fill),
												$author$project$Ui$background($author$project$MyUi$background3),
												$author$project$Ui$paddingWith(
												{bottom: 0, left: 0, right: 0, top: local.localUser.safeAreaInsetTop}),
												$author$project$Ui$move(
												{
													x: $author$project$Call$conversationOffset$(loggedIn.sidebarMode, model),
													y: 0,
													z: 0
												}),
												$author$project$Ui$heightMin(0),
												$author$project$Ui$borderColor($author$project$MyUi$border1),
												$author$project$Ui$borderWith(
												{bottom: 0, left: 0, right: 0, top: 1})
											]),
										$author$project$Pages$Guild$discordDmChannelView$(routeData, loggedIn, local, model)));
							case 2:
								var routeData = maybeOtherUserId.a;
								return $author$project$Ui$inFront(
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$height($author$project$Ui$fill),
												$author$project$Ui$background($author$project$MyUi$background3),
												$author$project$Ui$paddingWith(
												{bottom: 0, left: 0, right: 0, top: local.localUser.safeAreaInsetTop}),
												$author$project$Ui$move(
												{
													x: $author$project$Call$conversationOffset$(loggedIn.sidebarMode, model),
													y: 0,
													z: 0
												}),
												$author$project$Ui$heightMin(0),
												$author$project$Ui$borderColor($author$project$MyUi$border1),
												$author$project$Ui$borderWith(
												{bottom: 0, left: 0, right: 0, top: 1})
											]),
										$author$project$Pages$Guild$slackDmChannelView$(routeData, loggedIn, local, model)));
							default:
								return $author$project$Ui$noAttr;
						}
					}()
					]),
				_List_fromArray(
					[
						$author$project$Ui$row$(
						_List_fromArray(
							[
								$author$project$Ui$height($author$project$Ui$fill),
								$author$project$Ui$heightMin(0),
								$author$project$MyUi$htmlStyle$('isolation', 'isolate')
							]),
						_List_fromArray(
							[
								$author$project$GuildColumn$guildColumnLazy$(true, model, local),
								$author$project$Pages$Guild$friendsColumnLazy$(canScroll2, true, model.time, maybeOtherUserId, local)
							])),
						$author$project$Ui$Lazy$lazy$($author$project$Pages$Guild$loggedInAsView, local.localUser)
					]));
		} else {
			return $author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$background($author$project$MyUi$background1)
					]),
				_List_fromArray(
					[
						$author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$height($author$project$Ui$fill),
								$author$project$Ui$width(
								$author$project$Ui$px(
									$author$project$MyUi$channelAndGuildColumnWidth(model.windowSize)))
							]),
						_List_fromArray(
							[
								$author$project$Ui$row$(
								_List_fromArray(
									[
										$author$project$Ui$height($author$project$Ui$fill),
										$author$project$Ui$heightMin(0)
									]),
								_List_fromArray(
									[
										$author$project$GuildColumn$guildColumnLazy$(false, model, local),
										$author$project$Pages$Guild$friendsColumnLazy$(
										$author$project$MyUi$canScroll$(false, model.drag),
										false,
										model.time,
										maybeOtherUserId,
										local)
									])),
								$author$project$Ui$Lazy$lazy$($author$project$Pages$Guild$loggedInAsView, local.localUser)
							])),
						function () {
						switch (maybeOtherUserId.$) {
							case 0:
								var dmRoute = maybeOtherUserId.a;
								return $author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$height($author$project$Ui$fill),
											$author$project$Ui$paddingWith(
											{bottom: 0, left: 0, right: 0, top: local.localUser.safeAreaInsetTop})
										]),
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$height($author$project$Ui$fill),
												$author$project$Ui$background($author$project$MyUi$background3),
												$author$project$Ui$heightMin(0),
												$author$project$Ui$borderColor($author$project$MyUi$border1),
												$author$project$Ui$borderWith(
												{bottom: 0, left: 0, right: 0, top: 1})
											]),
										$author$project$Pages$Guild$dmChannelView$(dmRoute, loggedIn, local, model)));
							case 1:
								var routeData = maybeOtherUserId.a;
								return $author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$height($author$project$Ui$fill),
											$author$project$Ui$paddingWith(
											{bottom: 0, left: 0, right: 0, top: local.localUser.safeAreaInsetTop})
										]),
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$height($author$project$Ui$fill),
												$author$project$Ui$background($author$project$MyUi$background3),
												$author$project$Ui$heightMin(0),
												$author$project$Ui$borderColor($author$project$MyUi$border1),
												$author$project$Ui$borderWith(
												{bottom: 0, left: 0, right: 0, top: 1})
											]),
										$author$project$Pages$Guild$discordDmChannelView$(routeData, loggedIn, local, model)));
							case 2:
								var routeData = maybeOtherUserId.a;
								return $author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$height($author$project$Ui$fill),
											$author$project$Ui$paddingWith(
											{bottom: 0, left: 0, right: 0, top: local.localUser.safeAreaInsetTop})
										]),
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$height($author$project$Ui$fill),
												$author$project$Ui$background($author$project$MyUi$background3),
												$author$project$Ui$heightMin(0),
												$author$project$Ui$borderColor($author$project$MyUi$border1),
												$author$project$Ui$borderWith(
												{bottom: 0, left: 0, right: 0, top: 1})
											]),
										$author$project$Pages$Guild$slackDmChannelView$(routeData, loggedIn, local, model)));
							default:
								return $author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$height($author$project$Ui$fill),
											$author$project$Ui$paddingWith(
											{bottom: 0, left: 0, right: 0, top: local.localUser.safeAreaInsetTop})
										]),
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$height($author$project$Ui$fill),
												$author$project$Ui$background($author$project$MyUi$background3),
												$author$project$Ui$heightMin(0),
												$author$project$Ui$borderColor($author$project$MyUi$border1),
												$author$project$Ui$borderWith(
												{bottom: 0, left: 0, right: 0, top: 1})
											]),
										$author$project$Pages$Guild$unreadOverviewNotMobile$(local, loggedIn, model)));
						}
					}(),
						function () {
						var _v9 = _Utils_Tuple2(
							$author$project$Route$toShowMembersTabVisible$(loggedIn, model.route),
							maybeOtherUserId);
						if (!_v9.a.a) {
							switch (_v9.b.$) {
								case 0:
									var _v10 = _v9.a;
									var _v11 = _v10.a;
									var isThread = _v10.b;
									var dmRoute = _v9.b.a;
									var _v12 = $author$project$DmChannelId$otherUserId$(local.localUser.session.userId, dmRoute.channelId);
									if (!_v12.$) {
										var otherUserId = _v12.a;
										return $author$project$Ui$el$(
											_List_fromArray(
												[
													$author$project$Ui$width($author$project$Ui$shrink),
													$author$project$Ui$height($author$project$Ui$fill),
													$author$project$Ui$paddingWith(
													{bottom: 0, left: 0, right: 0, top: local.localUser.safeAreaInsetTop})
												]),
											$author$project$Pages$Guild$dmChannelSettingsNotMobile$(
												local.localUser,
												otherUserId,
												isThread,
												$author$project$Pages$Guild$dmE2eeStatus$(otherUserId, local),
												$author$project$Pages$Guild$e2eeSectionIsExpanded$(otherUserId, local, loggedIn),
												$author$project$Pages$Guild$e2eeKeyInput$(otherUserId, loggedIn)));
									} else {
										return $author$project$Ui$none;
									}
								case 1:
									var _v13 = _v9.a;
									var _v14 = _v13.a;
									var routeData = _v9.b.a;
									var _v15 = $lamdera$containers$SeqDict$get$(routeData.channelId, local.discordDmChannels);
									if (!_v15.$) {
										var dmChannel = _v15.a;
										return $author$project$Ui$el$(
											_List_fromArray(
												[
													$author$project$Ui$width($author$project$Ui$shrink),
													$author$project$Ui$height($author$project$Ui$fill),
													$author$project$Ui$paddingWith(
													{bottom: 0, left: 0, right: 0, top: local.localUser.safeAreaInsetTop})
												]),
											$author$project$Ui$Lazy$lazy4$($author$project$Pages$Guild$discordDmMemberColumnNotMobile, local.localUser, routeData.currentDiscordUserId, routeData.channelId, dmChannel));
									} else {
										return $author$project$Ui$none;
									}
								case 2:
									var _v16 = _v9.a;
									var _v17 = _v16.a;
									return $author$project$Ui$none;
								default:
									var _v18 = _v9.a;
									var _v19 = _v18.a;
									var _v20 = _v9.b;
									return $author$project$Ui$none;
							}
						} else {
							var _v21 = _v9.a;
							var _v22 = _v21.a;
							return $author$project$Ui$none;
						}
					}()
					]));
		}
	}
};
var $author$project$Pages$Guild$homePageLoggedInView = F4($author$project$Pages$Guild$homePageLoggedInView$);
var $author$project$Types$FileDragEnter = function (a) {
	return {$: 158, a: a};
};
var $author$project$Types$FileDragLeave = {$: 159};
var $author$project$Types$FileDropped = function (a) {
	return {$: 160, a: a};
};
var $author$project$Types$PressedBody = {$: 61};
var $author$project$Types$TouchCancel = function (a) {
	return {$: 53, a: a};
};
var $author$project$Types$TouchEnd = function (a) {
	return {$: 52, a: a};
};
var $author$project$Types$TouchMoved$ = function (a, b) {
	return {$: 51, a: a, b: b};
};
var $author$project$Types$TouchMoved = F2($author$project$Types$TouchMoved$);
var $author$project$Types$TouchStart$ = function (a, b) {
	return {$: 50, a: a, b: b};
};
var $author$project$Types$TouchStart = F2($author$project$Types$TouchStart$);
var $author$project$Touch$decoderPointerEvent = function (msg) {
	return A5(
		$elm$json$Json$Decode$map4,
		F4(
			function (identifier, clientX, clientY, time) {
				return A2(
					msg,
					$ianmackenzie$elm_units$Duration$milliseconds(time),
					$author$project$NonemptyDict$singleton$(
						identifier,
						{
							client: $author$project$Point2d$xy$(clientX, clientY),
							targetIsTextInput: false
						}));
			}),
		A2($elm$json$Json$Decode$field, 'pointerId', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'clientX', $author$project$Touch$decodeQuantity),
		A2($elm$json$Json$Decode$field, 'clientY', $author$project$Touch$decodeQuantity),
		A2($elm$json$Json$Decode$field, 'timeStamp', $elm$json$Json$Decode$float));
};
var $author$project$FrontendExtra$disableTextSelect$ = function (isMobile, model) {
	if (isMobile) {
		return true;
	} else {
		if (_Utils_eq(
			$author$project$Route$toChannelHeaderTab(model.route),
			$elm$core$Maybe$Just($author$project$UserSession$ChannelHeaderTab_Draw))) {
			return true;
		} else {
			var _v0 = model.drag;
			switch (_v0.$) {
				case 0:
					return false;
				case 1:
					return false;
				default:
					var dragging = _v0.a;
					var _v1 = dragging.target;
					switch (_v1) {
						case 1:
							return true;
						case 0:
							return false;
						default:
							return true;
					}
			}
		}
	}
};
var $author$project$FrontendExtra$disableTextSelect = F2($author$project$FrontendExtra$disableTextSelect$);
var $author$project$Pages$Guild$dropdownButtonId = function (index) {
	return $lamdera$program_test$Effect$Browser$Dom$id(
		'dropdown_button' + $elm$core$String$fromInt(index));
};
var $author$project$Types$PressedCloseOverlay = {$: 73};
var $author$project$UserOptions$closeButton$ = function (isMobile, onPress) {
	return $author$project$MyUi$rowButton$(
		$lamdera$program_test$Effect$Browser$Dom$id('userOptions_closeUserOptions'),
		onPress,
		_List_fromArray(
			[
				$author$project$Ui$padding(16),
				$author$project$Ui$alignRight,
				$author$project$Ui$Font$size(20),
				$author$project$Ui$Font$color(
				isMobile ? $author$project$MyUi$font1 : $author$project$MyUi$font3),
				$author$project$MyUi$hover$(
				isMobile,
				_List_fromArray(
					[
						$author$project$Ui$Anim$fontColor($author$project$MyUi$font1)
					])),
				$author$project$Ui$spacing(8),
				$author$project$MyUi$hoverText('Close')
			]),
		_List_fromArray(
			[
				isMobile ? $author$project$Ui$none : $author$project$Ui$el$(
				_List_fromArray(
					[$author$project$Ui$alignBottom]),
				$author$project$Ui$text('Close')),
				$author$project$Ui$html($author$project$Icons$x)
			]));
};
var $author$project$UserOptions$closeButton = F2($author$project$UserOptions$closeButton$);
var $author$project$Encryption$info = function (noOp) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$centerX,
				$author$project$Ui$widthMax(1000),
				$author$project$Ui$paddingXY$(16, 32)
			]),
		$author$project$Ui$html(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'white-space', 'pre-wrap')
					]),
				$author$project$RichText$view$(
					$lamdera$program_test$Effect$Browser$Dom$id('e2ee-info'),
					1000,
					function (_v0) {
						return noOp;
					},
					function (_v1) {
						return noOp;
					},
					function (_v2) {
						return noOp;
					},
					{
						animationMode: 0,
						attachedFiles: $lamdera$containers$SeqDict$empty,
						channels: $lamdera$containers$SeqDict$empty,
						customEmojis: $lamdera$containers$SeqDict$empty,
						devicePixelRatio: 1,
						domainWhitelist: $lamdera$containers$SeqSet$empty,
						drawingUserColor: function (_v3) {
							return $author$project$RichText$defaultColor;
						},
						drawings: $lamdera$containers$SeqDict$empty,
						embedDrawings: $lamdera$containers$SeqDict$empty,
						emojiData: $elm$core$Maybe$Nothing,
						isHovered: false,
						isSelectingAnchor: false,
						noOp: noOp,
						onPressChannelMention: F2(
							function (_v4, _v5) {
								return noOp;
							}),
						onPressCopyCode: function (_v6) {
							return noOp;
						},
						revealedSpoilers: $lamdera$containers$SeqSet$empty,
						stickers: $lamdera$containers$SeqDict$empty,
						time: $lamdera$program_test$Effect$Time$millisToPosix(0),
						timezone: $lamdera$program_test$Effect$Time$utc,
						users: $lamdera$containers$SeqDict$empty
					},
					$elm$core$Array$empty,
					$author$project$RichText$fromNonemptyString$(
						$lamdera$program_test$Effect$Time$utc,
						$lamdera$containers$SeqDict$empty,
						$lamdera$containers$SeqDict$empty,
						$MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('#', ' End-to-end encryption (E2EE) in at-chat\u000A\u000A## Quick summary of E2EE\u000AWith E2EE enabled your messages are encrypted when stored on the server. This means, even if a hacker gets access to the at-chat server data, they won\u0027t be able to read your conversation.\u000A\u000A## How to enable E2EE\u000AGo to a direct message channel (not a Discord direct message channel) and then click the gear icon in the top right. You should see a section titled ' + ($author$project$Encryption$e2eeSectionTitle + '. Open it and follow the instructions.\u000A\u000A## Limitations\u000A* One of the web\u0027s best features is that it\u0027s very easy to distribute new versions of a website/webapp. Unfortunately for E2EE this is a disadvantage. Anyone with the power to change what JS code the server sends to a client (either a hacker or malicious admin) can modify the webapp to covertly spy on you since messages are not encrypted once loaded on your webapp.\u000A* Because Browsers can\u0027t be relied upon to store data indefinitely, some compromises have been made to user experience. [Forward secrecy](https://en.wikipedia.org/wiki/Forward_secrecy) is not supported and you have to manually store your private key outside of at-chat.\u000A* Browser extensions can also potentially spy on your conversation\u000A* File uploading and downloading might take longer\u000A\u000AFor these reasons, consider at-chat\u0027s E2EE \u0022best effort\u0022. It will protect you from a lazy malicious admin (who can\u0027t be bothered of going through the trouble of deploying spyware to the client) and from a hacker who gets read-only access to the server.\u000A\u000AIf privacy is important to you, Signal is probably a better choice.\u000A\u000A## What exactly gets encrypted\u000Aat-chat encrypts message contents and attached files.\u000A\u000AThe following is not encrypted:\u000A* Message creation time\u000A* Approximate size of message contents\u000A* Attached file IDs and the approximate size of the files\u000A* Previously uploaded files from before E2EE was enabled\u000A* Who wrote the message\u000A* If the message is a reply to a previous message or part of a thread\u000A* Drawings\u000A* Message edit time\u000A* Emoji reactions\u000A* Games\u000A* Voice chats (E2EE voice chats might be added in the future)\u000A')))))));
};
var $author$project$FrontendExtra$e2eeInfoOverlay = function (isMobile) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$Ui$heightMin(0),
				$author$project$Ui$background($author$project$MyUi$background1),
				$author$project$Ui$inFront(
				$author$project$UserOptions$closeButton$(isMobile, $author$project$Types$PressedCloseOverlay))
			]),
		$author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$scrollable,
					$author$project$Ui$heightMin(0)
				]),
			$author$project$Encryption$info($author$project$Types$FrontendNoOp)));
};
var $author$project$FrontendExtra$fileDragOverlay$ = function (loggedIn, model) {
	var opacity = $author$project$FrontendExtra$fileDragOverlayOpacity$(loggedIn, model);
	if (opacity <= 0) {
		return $author$project$Ui$none;
	} else {
		var canDrop = !_Utils_eq(
			$author$project$FrontendExtra$canDropFiles$(
				$author$project$MyUi$isMobile(model),
				$author$project$Local$model(loggedIn.localState).localUser.session.userId,
				model.route),
			$elm$core$Maybe$Nothing);
		var accentColor = canDrop ? $author$project$MyUi$font1 : $author$project$MyUi$deleteButtonBackground;
		return $author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$height($author$project$Ui$fill),
					$author$project$Ui$contentCenterX,
					$author$project$Ui$contentCenterY,
					$author$project$Ui$Font$size(32),
					$author$project$Ui$Font$bold,
					$author$project$MyUi$htmlStyle$('border', '8px dashed'),
					$author$project$MyUi$htmlStyle$('box-sizing', 'border-box'),
					$author$project$MyUi$noPointerEvents,
					$author$project$Ui$background(
					$author$project$Ui$rgba$(0, 0, 0, 0.6)),
					$author$project$Ui$Font$color(accentColor),
					$author$project$Ui$borderColor(accentColor),
					$author$project$Ui$opacity(opacity)
				]),
			canDrop ? $author$project$Ui$text('Drop files anywhere to upload') : $author$project$Ui$text('You can\u0027t drop the file here'));
	}
};
var $author$project$FrontendExtra$fileDragOverlay = F2($author$project$FrontendExtra$fileDragOverlay$);
var $author$project$Internal$Model2$Teleported$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Internal$Model2$Teleported = F2($author$project$Internal$Model2$Teleported$);
var $author$project$Internal$Teleport$Event$ = function (timestamp, data) {
	return {data: data, timestamp: timestamp};
};
var $author$project$Internal$Teleport$Event = F2($author$project$Internal$Teleport$Event$);
var $author$project$Internal$Teleport$ParentTrigger = function (a) {
	return {$: 1, a: a};
};
var $author$project$Internal$Teleport$ParentTriggerDetails$ = function (trigger, identifierClass, children) {
	return {children: children, identifierClass: identifierClass, trigger: trigger};
};
var $author$project$Internal$Teleport$ParentTriggerDetails = F3($author$project$Internal$Teleport$ParentTriggerDetails$);
var $author$project$Internal$Teleport$CssAnimation$ = function (trigger, hash, keyframesHash, keyframes, transition, props) {
	return {hash: hash, keyframes: keyframes, keyframesHash: keyframesHash, props: props, transition: transition, trigger: trigger};
};
var $author$project$Internal$Teleport$CssAnimation = F6($author$project$Internal$Teleport$CssAnimation$);
var $author$project$Internal$Teleport$decodeProp = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (key, value) {
			return _Utils_Tuple2(key, value);
		}),
	A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$string));
var $elm$json$Json$Decode$map6 = _Json_map6;
var $author$project$Internal$Teleport$decodeCss = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Internal$Teleport$CssAnimation,
	A2($elm$json$Json$Decode$field, 'trigger', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'hash', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'keyframesHash', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'keyframes', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'transition', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'props',
		$elm$json$Json$Decode$list($author$project$Internal$Teleport$decodeProp)));
var $author$project$Internal$Teleport$reactionPropertyName = function (identifier) {
	return 'data-elm-ui-reaction-' + identifier;
};
var $author$project$Internal$Teleport$decodeTriggeredChild = function (identifier) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				$author$project$Internal$Teleport$reactionPropertyName(identifier),
				$elm$json$Json$Decode$list($author$project$Internal$Teleport$decodeCss)),
				$elm$json$Json$Decode$succeed(_List_Nil)
			]));
};
var $author$project$Internal$Teleport$decodeCssChildren = function (identifier) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (triggeredChildren) {
			if (!triggeredChildren.b) {
				return A3(
					$elm$json$Json$Decode$map2,
					$elm$core$Basics$append,
					A2(
						$elm$json$Json$Decode$field,
						'nextElementSibling',
						$elm$json$Json$Decode$oneOf(
							_List_fromArray(
								[
									$elm$json$Json$Decode$null(_List_Nil),
									$elm$json$Json$Decode$lazy(
									function (_v1) {
										return $author$project$Internal$Teleport$decodeCssChildren(identifier);
									})
								]))),
					A2(
						$elm$json$Json$Decode$field,
						'firstElementChild',
						$elm$json$Json$Decode$oneOf(
							_List_fromArray(
								[
									$elm$json$Json$Decode$null(_List_Nil),
									$elm$json$Json$Decode$lazy(
									function (_v2) {
										return $author$project$Internal$Teleport$decodeCssChildren(identifier);
									})
								]))));
			} else {
				var nonEmpty = triggeredChildren;
				return A2(
					$elm$json$Json$Decode$map,
					function (next) {
						return _Utils_ap(nonEmpty, next);
					},
					A2(
						$elm$json$Json$Decode$field,
						'nextElementSibling',
						$elm$json$Json$Decode$oneOf(
							_List_fromArray(
								[
									$elm$json$Json$Decode$null(_List_Nil),
									$elm$json$Json$Decode$lazy(
									function (_v3) {
										return $author$project$Internal$Teleport$decodeCssChildren(identifier);
									})
								]))));
			}
		},
		$author$project$Internal$Teleport$decodeTriggeredChild(identifier));
};
var $author$project$Internal$Teleport$Css = function (a) {
	return {$: 0, a: a};
};
var $author$project$Internal$Teleport$decodeCssData = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		if (str === 'css') {
			return A2($elm$json$Json$Decode$map, $author$project$Internal$Teleport$Css, $author$project$Internal$Teleport$decodeCss);
		} else {
			return $elm$json$Json$Decode$fail('Unknown type: ' + str);
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Internal$Teleport$decode = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Internal$Teleport$Event,
	A2($elm$json$Json$Decode$field, 'timeStamp', $elm$json$Json$Decode$float),
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'target',
				A2(
					$elm$json$Json$Decode$field,
					'data-elm-ui',
					$elm$json$Json$Decode$list($author$project$Internal$Teleport$decodeCssData))),
				A2(
				$elm$json$Json$Decode$field,
				'target',
				A2(
					$elm$json$Json$Decode$andThen,
					function (idents) {
						return A2(
							$elm$json$Json$Decode$map,
							function (cssChildren) {
								return _List_fromArray(
									[
										$author$project$Internal$Teleport$ParentTrigger(
										$author$project$Internal$Teleport$ParentTriggerDetails$(idents.trigger, idents.identifierClass, cssChildren))
									]);
							},
							A2(
								$elm$json$Json$Decode$field,
								'parentNode',
								$author$project$Internal$Teleport$decodeCssChildren(idents.identifierClass)));
					},
					A2(
						$elm$json$Json$Decode$field,
						'data-elm-ui',
						A3(
							$elm$json$Json$Decode$map2,
							F2(
								function (trigger, identifierClass) {
									return {identifierClass: identifierClass, trigger: trigger};
								}),
							A2($elm$json$Json$Decode$field, 'trigger', $elm$json$Json$Decode$string),
							A2($elm$json$Json$Decode$field, 'identifierClass', $elm$json$Json$Decode$string)))))
			])));
var $author$project$Internal$Teleport$OnFocusWithin = 3;
var $author$project$Internal$Teleport$OnHover = 0;
var $author$project$Internal$Teleport$OnRender = 1;
var $author$project$Internal$Teleport$stringToTrigger = function (str) {
	switch (str) {
		case 'on-rendered':
			return $elm$core$Maybe$Just(1);
		case 'on-focused':
			return $elm$core$Maybe$Just(1);
		case 'on-hovered':
			return $elm$core$Maybe$Just(0);
		case 'on-focused-within':
			return $elm$core$Maybe$Just(3);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Ui$Anim$onAnimationStart = function (onMsg) {
	return $author$project$Ui$Events$on$(
		'animationstart',
		A2(
			$elm$json$Json$Decode$andThen,
			function (name) {
				var _v0 = $author$project$Internal$Teleport$stringToTrigger(name);
				if (!_v0.$) {
					var trigger = _v0.a;
					return A2(
						$elm$json$Json$Decode$map,
						A2(
							$elm$core$Basics$composeL,
							onMsg,
							$author$project$Internal$Model2$Teleported(trigger)),
						$author$project$Internal$Teleport$decode);
				} else {
					return $elm$json$Json$Decode$fail('Nonmatching animation');
				}
			},
			A2($elm$json$Json$Decode$field, 'animationName', $elm$json$Json$Decode$string)));
};
var $author$project$Internal$Teleport$OnDismount = 5;
var $author$project$Ui$Anim$onAnimationUnmount = function (onMsg) {
	return $author$project$Ui$Events$on$(
		'animationcancel',
		A2(
			$elm$json$Json$Decode$andThen,
			function (name) {
				return (name === 'on-dismount') ? A2(
					$elm$json$Json$Decode$map,
					A2(
						$elm$core$Basics$composeL,
						onMsg,
						$author$project$Internal$Model2$Teleported(5)),
					$author$project$Internal$Teleport$decode) : $elm$json$Json$Decode$fail('Nonmatching animation');
			},
			A2($elm$json$Json$Decode$field, 'animationName', $elm$json$Json$Decode$string)));
};
var $author$project$Internal$Model2$AsRoot = 6;
var $author$project$Internal$Model2$keyframeRules = function (styleStr) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id('elm-ui-keyframe-rules')
			]),
		_List_fromArray(
			[
				A3(
				$elm$html$Html$node,
				'style',
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$join$('\u000A', styleStr))
					]))
			]));
};
var $elm$virtual_dom$VirtualDom$lazy = _VirtualDom_lazy;
var $elm$html$Html$Lazy$lazy = $elm$virtual_dom$VirtualDom$lazy;
var $author$project$Internal$Model2$andAdd$ = function (one, two) {
	return _Utils_ap(two, one);
};
var $author$project$Internal$Model2$andAdd = F2($author$project$Internal$Model2$andAdd$);
var $elm$core$String$append = _String_append;
var $author$project$Internal$Model2$dot = function (str) {
	return '.' + str;
};
var $author$project$Internal$Model2$maybeString$ = function (fn, maybeStr) {
	if (maybeStr.$ === 1) {
		return '';
	} else {
		var str = maybeStr.a;
		return fn(str);
	}
};
var $author$project$Internal$Model2$maybeString = F2($author$project$Internal$Model2$maybeString$);
var $author$project$Internal$Model2$renderFocusStyle = function (focus) {
	var focusProps = $author$project$Internal$Model2$andAdd$(
		$author$project$Internal$Model2$maybeString$(
			function (shadow) {
				return 'box-shadow: ' + ($author$project$Internal$Style2$singleShadow(shadow) + ';');
			},
			focus.shadow),
		$author$project$Internal$Model2$andAdd$(
			$author$project$Internal$Model2$maybeString$(
				function (color) {
					return 'background-color: ' + ($author$project$Internal$Style2$color(color) + ';');
				},
				focus.backgroundColor),
			$author$project$Internal$Model2$andAdd$(
				$author$project$Internal$Model2$maybeString$(
					function (color) {
						return 'border-color: ' + ($author$project$Internal$Style2$color(color) + ';');
					},
					focus.borderColor),
				'outline: none;')));
	return $elm$html$Html$text(
		A2(
			$elm$core$String$append,
			A2(
				$elm$core$String$append,
				$author$project$Internal$Model2$dot($author$project$Internal$Style2$classes.focusedWithin) + ':focus-within',
				focusProps),
			A2(
				$elm$core$String$append,
				$author$project$Internal$Model2$dot($author$project$Internal$Style2$classes.any) + (':focus .focusable, ' + ($author$project$Internal$Model2$dot($author$project$Internal$Style2$classes.any) + '.focusable:focus')),
				focusProps)));
};
var $author$project$Internal$Model2$curlyBrackets = function (lines) {
	return '{' + ($elm$core$String$concat(lines) + '}');
};
var $author$project$Internal$Style$Generated$lineHeightAdjustment = function (i) {
	var offsetInt = i * 5;
	var lineHeightOffset = offsetInt / 100;
	var offset = lineHeightOffset / (1 + lineHeightOffset);
	var offsetString = $elm$core$String$fromFloat(offset / 2);
	return '-' + (offsetString + 'lh');
};
var $author$project$Internal$Model2$renderFontAdjustment = function (adjustment) {
	var fontid = adjustment.family;
	var sizeAdjustmentRule = _Utils_ap(
		'.' + fontid,
		$author$project$Internal$Model2$curlyBrackets(
			_List_fromArray(
				[
					'font-size:' + ($elm$core$String$fromFloat(adjustment.height) + '%;')
				])));
	return _Utils_ap(
		sizeAdjustmentRule,
		$elm$core$String$concat(
			$elm$core$List$map$(
				function (i) {
					var offsetInt = i * 5;
					var body = $author$project$Internal$Model2$curlyBrackets(
						_List_fromArray(
							[
								'margin-top:' + ($author$project$Internal$Style$Generated$lineHeightAdjustment(i) + ';'),
								'margin-bottom:' + ($author$project$Internal$Style$Generated$lineHeightAdjustment(i) + ';')
							]));
					return _Utils_ap(
						_Utils_ap(
							'.' + (fontid + (' .lh-' + ($elm$core$String$fromInt(offsetInt) + ' .s.p '))),
							body),
						_Utils_ap(
							'.' + (fontid + (' .lh-' + ($elm$core$String$fromInt(offsetInt) + ' .s.t '))),
							body));
				},
				$elm$core$List$range$(1, 20))));
};
var $author$project$Internal$Model2$maxWidth = function (_int) {
	return '(max-width:' + ($elm$core$String$fromInt(_int) + 'px)');
};
var $author$project$Internal$Model2$renderMediaProps = function (i) {
	return (':root {--ui-bp-' + ($elm$core$String$fromInt(i) + ': 1;}')) + (('.s.ui-bp-' + ($elm$core$String$fromInt(i) + '-hidden {display:none !important;}')) + ('.s.r.ui-bp-' + ($elm$core$String$fromInt(i) + '-as-col {flex-direction: column; align-content: flex-start;}')));
};
var $author$project$Internal$Model2$maxWidthMediaQuery$ = function (i, upperBound) {
	return '@media ' + ($author$project$Internal$Model2$maxWidth(upperBound) + (' { ' + ($author$project$Internal$Model2$renderMediaProps(i) + ' }')));
};
var $author$project$Internal$Model2$maxWidthMediaQuery = F2($author$project$Internal$Model2$maxWidthMediaQuery$);
var $author$project$Internal$Model2$renderResponsiveCssVars$ = function (i, lower, upper) {
	return ('--ui-bp-' + ($elm$core$String$fromInt(i) + ': 0;')) + (('--ui-bp-' + ($elm$core$String$fromInt(i) + ('-lower: ' + ($elm$core$String$fromInt(lower) + 'px;')))) + (('--ui-bp-' + ($elm$core$String$fromInt(i) + ('-upper: ' + ($elm$core$String$fromInt(upper) + 'px;')))) + ('--ui-bp-' + ($elm$core$String$fromInt(i) + ('-progress: calc(calc(100vw - ' + ($elm$core$String$fromInt(lower) + ('px) / ' + ($elm$core$String$fromInt(upper - lower) + ');'))))))));
};
var $author$project$Internal$Model2$renderResponsiveCssVars = F3($author$project$Internal$Model2$renderResponsiveCssVars$);
var $author$project$Internal$Model2$minWidth = function (_int) {
	return '(min-width:' + ($elm$core$String$fromInt(_int + 1) + 'px)');
};
var $author$project$Internal$Model2$minWidthMediaQuery$ = function (i, lowerBound) {
	return '@media' + ($author$project$Internal$Model2$minWidth(lowerBound) + (' { ' + ($author$project$Internal$Model2$renderMediaProps(i) + ' }')));
};
var $author$project$Internal$Model2$minWidthMediaQuery = F2($author$project$Internal$Model2$minWidthMediaQuery$);
var $author$project$Internal$Model2$renderBoundedMediaQuery$ = function (upper, lower, i) {
	return '@media ' + ($author$project$Internal$Model2$minWidth(lower) + (' and ' + ($author$project$Internal$Model2$maxWidth(upper) + (' { ' + ($author$project$Internal$Model2$renderMediaProps(i) + ' }')))));
};
var $author$project$Internal$Model2$renderBoundedMediaQuery = F3($author$project$Internal$Model2$renderBoundedMediaQuery$);
var $author$project$Internal$Model2$toBoundedMediaQuery$ = function (breaks, i, rendered) {
	toBoundedMediaQuery:
	while (true) {
		if (!breaks.b) {
			return rendered;
		} else {
			if (!breaks.b.b) {
				var upper = breaks.a;
				return _Utils_ap(
					rendered,
					$author$project$Internal$Model2$minWidthMediaQuery$(i, upper));
			} else {
				var lower = breaks.a;
				var tail = breaks.b;
				var upper = tail.a;
				var $temp$breaks = tail,
					$temp$i = i + 1,
					$temp$rendered = _Utils_ap(
					rendered,
					$author$project$Internal$Model2$renderBoundedMediaQuery$(upper, lower, i));
				breaks = $temp$breaks;
				i = $temp$i;
				rendered = $temp$rendered;
				continue toBoundedMediaQuery;
			}
		}
	}
};
var $author$project$Internal$Model2$toBoundedMediaQuery = F3($author$project$Internal$Model2$toBoundedMediaQuery$);
var $author$project$Internal$Model2$toRoot$ = function (breaks, i, rendered) {
	toRoot:
	while (true) {
		if (!breaks.b) {
			return rendered;
		} else {
			if (!breaks.b.b) {
				var upper = breaks.a;
				return _Utils_ap(
					rendered,
					$author$project$Internal$Model2$renderResponsiveCssVars$(i, upper, upper + 1000));
			} else {
				var lower = breaks.a;
				var tail = breaks.b;
				var upper = tail.a;
				var $temp$breaks = tail,
					$temp$i = i + 1,
					$temp$rendered = _Utils_ap(
					rendered,
					$author$project$Internal$Model2$renderResponsiveCssVars$(i, lower, upper));
				breaks = $temp$breaks;
				i = $temp$i;
				rendered = $temp$rendered;
				continue toRoot;
			}
		}
	}
};
var $author$project$Internal$Model2$toRoot = F3($author$project$Internal$Model2$toRoot$);
var $author$project$Internal$Model2$toMediaQuery = function (breaks) {
	if (!breaks.b) {
		return $elm$html$Html$text('');
	} else {
		var lowerBound = breaks.a;
		var remain = breaks.b;
		return $elm$html$Html$text(
			':root {' + ($author$project$Internal$Model2$toRoot$(
				breaks,
				1,
				$author$project$Internal$Model2$renderResponsiveCssVars$(0, 0, lowerBound)) + (' }' + $author$project$Internal$Model2$toBoundedMediaQuery$(
				breaks,
				1,
				$author$project$Internal$Model2$maxWidthMediaQuery$(0, lowerBound)))));
	}
};
var $author$project$Internal$Model2$renderOptionItem$ = function (alreadyRendered, renderedNodes, opts) {
	renderOptionItem:
	while (true) {
		if (!opts.b) {
			return renderedNodes;
		} else {
			switch (opts.a.$) {
				case 0:
					var focus = opts.a.a;
					var remain = opts.b;
					if (alreadyRendered.focus) {
						var $temp$opts = remain;
						opts = $temp$opts;
						continue renderOptionItem;
					} else {
						var $temp$alreadyRendered = _Utils_update(
							alreadyRendered,
							{focus: true}),
							$temp$renderedNodes = A2(
							$elm$core$List$cons,
							A2($elm$html$Html$Lazy$lazy, $author$project$Internal$Model2$renderFocusStyle, focus),
							renderedNodes),
							$temp$opts = remain;
						alreadyRendered = $temp$alreadyRendered;
						renderedNodes = $temp$renderedNodes;
						opts = $temp$opts;
						continue renderOptionItem;
					}
				case 1:
					var breakpoints = opts.a.a;
					var remain = opts.b;
					if (alreadyRendered.breakpoints) {
						var $temp$opts = remain;
						opts = $temp$opts;
						continue renderOptionItem;
					} else {
						var $temp$alreadyRendered = _Utils_update(
							alreadyRendered,
							{breakpoints: true}),
							$temp$renderedNodes = A2(
							$elm$core$List$cons,
							A2($elm$html$Html$Lazy$lazy, $author$project$Internal$Model2$toMediaQuery, breakpoints),
							renderedNodes),
							$temp$opts = remain;
						alreadyRendered = $temp$alreadyRendered;
						renderedNodes = $temp$renderedNodes;
						opts = $temp$opts;
						continue renderOptionItem;
					}
				default:
					var adjustment = opts.a.a;
					var remain = opts.b;
					var $temp$renderedNodes = A2(
						$elm$core$List$cons,
						$elm$html$Html$text(
							$author$project$Internal$Model2$renderFontAdjustment(adjustment)),
						renderedNodes),
						$temp$opts = remain;
					renderedNodes = $temp$renderedNodes;
					opts = $temp$opts;
					continue renderOptionItem;
			}
		}
	}
};
var $author$project$Internal$Model2$renderOptionItem = F3($author$project$Internal$Model2$renderOptionItem$);
var $author$project$Internal$Model2$renderOptions = function (opts) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id('elm-ui-responsiveness')
			]),
		_List_fromArray(
			[
				A3(
				$elm$html$Html$node,
				'style',
				_List_Nil,
				$author$project$Internal$Model2$renderOptionItem$(
					{breakpoints: false, focus: false},
					_List_Nil,
					opts))
			]));
};
var $author$project$Internal$Style$Generated$stylesheet = 'input[type=\u0022search\u0022],\u000Ainput[type=\u0022search\u0022]::-webkit-search-decoration,\u000Ainput[type=\u0022search\u0022]::-webkit-search-cancel-button,\u000Ainput[type=\u0022search\u0022]::-webkit-search-results-button,\u000Ainput[type=\u0022search\u0022]::-webkit-search-results-decoration {\u000A  -webkit-appearance:none;\u000A}\u000Ainput[type=range].sldr {\u000A    -webkit-appearance: none;\u000A    background: transparent;\u000A    opacity: 0;\u000A}\u000A            \u000Ainput[type=range].sldr::-moz-range-track {\u000A    background: transparent;\u000A}\u000Ainput[type=range].sldr::-ms-track {\u000A    background: transparent;\u000A}\u000Ainput[type=range].sldr::-webkit-slider-runnable-track {\u000A    background: transparent;\u000A}\u000A            @keyframes show-redraw { 0% { background-color:red; }}@keyframes on-hovered { from {} to {} }\u000A@keyframes on-focused { from {} to {} }\u000A@keyframes on-activated { from {} to {} }\u000A@keyframes on-rendered { from {} to {} }\u000A@keyframes on-dismount { from {} to {} }html,body{height:100%;padding:0;margin:0;}.irs{appearance:none;-webkit-appearance:none;-moz-appearance:none;}.s.e.ic{display:block;object-fit:cover;width:max-content;}.s:focus{outline:none;}.explain{outline:6px solid rgb(174, 121, 15) !important;}.explain > .s{outline:4px dashed rgb(0, 151, 167) !important;}.explain *{animation:show-redraw 0.4s ease;}.elm-ui-root{width:100%;height:auto;min-height:100%;font-size:16px;font-family:\u0022Open Sans\u0022, sans-serif;line-height:1.4;}.elm-ui-root{position:relative;z-index:0;}.elm-ui-root.s.hf{height:100%;}.elm-ui-root.s.hf > .hf{height:100%;}.elm-ui-root > .fr.nb{position:fixed;z-index:20;}.hnb{position:relative;}.hnb > .s{position:relative;}li.s.e{display:list-item;}.ui-trigger{position:absolute;}.nb{position:relative;border:none;display:flex;flex-direction:row;flex-basis:auto;border-radius:inherit;}.nb.e{display:flex;flex-direction:column;}.nb.e.hbh{z-index:0;}.nb.e.hbh > .bh{z-index:-1;}.nb.e > .hc{height:auto;}.nb.e > .hf{flex-grow:1;max-height:100%;}.nb.e > .wf:not(.ar, .al, .cx){width:100%;}.nb.e > .wf.wb{width:100%;}.nb.e > .wc{align-self:flex-start;}.nb.e.ccx{align-items:center;}.nb.e > .s.cx{align-self:center;}.nb.e.ccy{justify-content:center;}.nb.e > .s.cy{margin-top:auto !important;margin-bottom:auto !important;}.nb.e.ct{justify-content:flex-start;}.nb.e > .s.at{margin-bottom:auto !important;margin-top:0 !important;}.nb.e.cb{justify-content:flex-end;}.nb.e > .s.ab{margin-top:auto !important;margin-bottom:0 !important;}.nb.e.cr{align-items:flex-end;}.nb.e > .s.ar{align-self:flex-end;}.nb.e.cl{align-items:flex-start;}.nb.e > .s.al{align-self:flex-start;}.nb.a{position:absolute;bottom:100%;left:0;width:100%;z-index:20;margin:0 !important;pointer-events:none;}.nb.a > .hf{height:auto;}.nb.a > .wf:not(.ar, .al, .cx){width:100%;}.nb.a > *{pointer-events:auto;}.nb.b{position:absolute;bottom:0;left:0;height:0;width:100%;z-index:20;margin:0 !important;pointer-events:none;}.nb.b > *{pointer-events:auto;}.nb.b > .hf{height:auto;}.nb.or{position:absolute;left:100%;top:0;height:100%;margin:0 !important;z-index:20;pointer-events:none;}.nb.or > *{pointer-events:auto;}.nb.ol{position:absolute;right:100%;top:0;height:100%;margin:0 !important;z-index:20;pointer-events:none;}.nb.ol > *{pointer-events:auto;}.nb.fr{position:absolute;width:100%;height:100%;left:0;top:0;margin:0 !important;pointer-events:none;}.nb.fr > *{pointer-events:auto;}.nb.bh{position:absolute;width:100%;height:100%;left:0;top:0;margin:0 !important;z-index:0;pointer-events:none;}.nb.bh > *{pointer-events:auto;}.e{flex:0 0 0px;align-items:flex-start;min-height:min-content;display:flex;flex-direction:column;}.e.we{flex-shrink:0;}button.s{background-color:transparent;text-align:start;}.s{border:none;flex-shrink:1;flex-basis:auto;display:flex;flex-direction:row;resize:none;box-sizing:border-box;margin:0;padding:0;border-width:0;border-style:solid;min-width:0;font-size:inherit;color:inherit;font-family:inherit;font-weight:inherit;font-feature-settings:inherit;text-decoration:none;font-style:inherit;}.s.on-hovered:hover > .ui-trigger{animation:on-hovered 1ms;}.s.on-focused:focus > .ui-trigger{animation:on-focused 1ms;}.s.on-focused-within:focus-within > .ui-trigger{animation:on-focused 1ms;}.s.on-activated:active > .ui-trigger{animation:on-activated 1ms;}.s.on-rendered > .ui-trigger{animation:on-rendered 1ms;}.s.on-dismount > .ui-trigger{animation:on-dismount 31449600s;}.s.stick-top{position:sticky;top:0;}.s.stick-bottom{position:sticky;bottom:-1px;}.s.stick-left{position:sticky;left:0;}.s.tgrd{-webkit-background-clip:text;-webkit-text-fill-color:transparent;}.s.f-adj{font-size:calc(1em * var(--font-size-factor));}.s.ellip .t{text-overflow:ellipsis;white-space:nowrap;overflow:hidden;}.s.notxt{user-select:none;}.s.cptr{cursor:pointer;}.s.grab{cursor:grab;}.s.grabbing{cursor:grabbing;}.s.ctxt{cursor:text;}.s.ppe{pointer-events:none !important;}.s.cpe{pointer-events:auto !important;}.s.clr{opacity:0;}.s.oq{opacity:1;}.s.hvclr:hover{opacity:0;}.s.hvoq:hover{opacity:1;}.s.fcsclr:focus{opacity:0;}.s.fcsoq:focus{opacity:1;}.s.atvclr:active{opacity:0;}.s.atvoq:active{opacity:1;}.s.ts{transition:transform 160ms, opacity 160ms, filter 160ms, background-color 160ms, color 160ms, font-size 160ms;}.s.sb{overflow:auto;flex-shrink:1;}.s.sb.c{flex-shrink:1;flex-basis:auto;}.s.sb.e{flex-shrink:1;flex-basis:auto;}.s.sbx{overflow-x:auto;}.s.sbx.r{flex-shrink:1;}.s.sby{overflow-y:auto;}.s.sby.c{flex-shrink:1;flex-basis:auto;}.s.sby.e{flex-shrink:1;flex-basis:auto;}.s.cp{overflow:hidden;}.s.cpx{overflow-x:hidden;}.s.cpy{overflow-y:hidden;}.s.wc{width:auto;}.s.t{display:inline-block;max-width:100%;}.s.e{display:flex;flex-direction:column;}.s.e.hbh{z-index:0;}.s.e.hbh > .bh{z-index:-1;}.s.e > .hc{height:auto;}.s.e > .hf{flex-grow:1;max-height:100%;}.s.e > .wf:not(.ar, .al, .cx){width:100%;}.s.e > .wf.wb{width:100%;}.s.e > .wc{align-self:flex-start;}.s.e.ccx{align-items:center;}.s.e > .s.cx{align-self:center;}.s.e.ccy{justify-content:center;}.s.e > .s.cy{margin-top:auto !important;margin-bottom:auto !important;}.s.e.ct{justify-content:flex-start;}.s.e > .s.at{margin-bottom:auto !important;margin-top:0 !important;}.s.e.cb{justify-content:flex-end;}.s.e > .s.ab{margin-top:auto !important;margin-bottom:0 !important;}.s.e.cr{align-items:flex-end;}.s.e > .s.ar{align-self:flex-end;}.s.e.cl{align-items:flex-start;}.s.e > .s.al{align-self:flex-start;}.s.r{display:flex;flex-direction:row;align-items:center;}.s.r.wf:not(.ar, .al, .cx) > .wf:not(.ar, .al, .cx){flex-basis:0%;}.s.r > .s{flex-basis:auto;flex-shrink:1;}.s.r > .s.wf:not(.ar, .al, .cx){flex-grow:1;}.s.r > .s.wf:has(> :where(.we, .wb)){min-width:min-content;}.s.r > .s.cp.wf:not(.ar, .al, .cx){min-width:auto;}.s.r > .s.cpx.wf:not(.ar, .al, .cx){min-width:auto;}.s.r > .s.we{flex-shrink:0;}.s.r > .hf:not(.at, .ab, .cy, .hb){align-self:stretch;}.s.r > .hf.hb{height:max(2000px, 100vh);}.s.r.ccx{justify-content:center;}.s.r > .s.cx{margin:0 auto;}.s.r.ccy{align-items:center;}.s.r > .s.cy{margin:auto 0;}.s.r.ct{align-items:flex-start;}.s.r > .s.at{margin-bottom:auto;}.s.r.cb{align-items:flex-end;}.s.r > .s.ab{margin-top:auto;}.s.r.cr{justify-content:flex-end;}.s.r > .s.ar{margin-left:auto;}.s.r.cl{justify-content:flex-start;}.s.r > .s.al{margin-right:auto;}.s.r.sev{justify-content:space-between;}.s.r.lbl{align-items:baseline;}.s.c{display:flex;flex-direction:column;align-content:flex-start;}.s.c.we{flex-shrink:0;}.s.c > .s{min-height:min-content;}.s.c > .s.he{flex-basis:auto;}.s.c > .s.cp{flex-basis:auto;}.s.c > .s.sb{flex-basis:auto;}.s.c > .s.wb.wf{width:100%;}.s.c > .hf{flex-grow:1;max-height:100%;}.s.c > .wf:not(.ar, .al, .cx){width:100%;}.s.c > .wc{align-self:flex-start;}.s.c.ccx{align-items:center;}.s.c > .s.cx{align-self:center;}.s.c.ccy{justify-content:center;}.s.c > .s.cy{margin:auto 0;}.s.c.ct{justify-content:flex-start;}.s.c > .s.at{margin-bottom:auto;}.s.c.cb{justify-content:flex-end;}.s.c > .s.ab{margin-top:auto;}.s.c.cr{align-items:flex-end;}.s.c > .s.ar{align-self:flex-end;}.s.c.cl{align-items:flex-start;}.s.c > .s.al{align-self:flex-start;}.s.c.sev{justify-content:space-between;}.s.g{display:-ms-grid;display:grid;}.s.g > .gp > .s{width:100%;}.s.g > .s.cx{align-items:center;}.s.g > .s.cy{justify-content:center;}.s.g > .s.at{justify-content:flex-start;}.s.g > .s.ab{justify-content:flex-end;}.s.g > .s.ar{align-items:flex-end;}.s.g > .s.al{align-items:flex-start;}.s.pg{display:block;}.s.pg > .s:first-child{margin:0 !important;}.s.pg > .s.al:first-child + .s{margin:0 !important;}.s.pg > .s.ar:first-child + .s{margin:0 !important;}.s.pg > .s.ar{float:right;}.s.pg > .s.ar::after{content:\u0022\u0022;display:table;clear:both;}.s.pg > .s.al{float:left;}.s.pg > .s.al::after{content:\u0022\u0022;display:table;clear:both;}.s.iml{white-space:pre-wrap !important;height:100%;width:100%;background-color:transparent !important;border-color:transparent !important;}.s.implw.e{flex-basis:auto;}.s.imlp{white-space:pre-wrap !important;cursor:text;}.s.imlp > .imlf{white-space:pre-wrap !important;color:transparent;}.s.p{display:block;overflow-wrap:break-word;}.s.p .t{display:inline;}.s.p .t::after{content:none;}.s.p .t::before{content:none;}.s.p::after{content:\u0022 \u0022;margin-top:calc((1lh - 1cap) / -2);display:table;}.s.p::before{content:\u0022 \u0022;margin-bottom:calc((1lh - 1cap) / -2);display:table;}.s.p.hbh{z-index:0;}.s.p.hbh > .bh{z-index:-1;}.s.p .t{display:inline;}.s.p > .p{display:inline;}.s.p > .p::after{content:none;}.s.p > .p::before{content:none;}.s.p .e{display:inline;}.s.p .e.we{display:inline-block;}.s.p .e.nb{display:flex;}.s.p .e > .t{display:inline;}.s.p > .r{display:inline;}.s.p > .c{display:inline-flex;}.s.p > .g{display:inline-grid;}.s.p > .s.ar{float:right;}.s.p > .s.al{float:left;}.s.hidden{display:none;}.s.tj{text-align:justify;}.s.tja{text-align:justify-all;}.s.tc{text-align:center;align-items:center;}.s.tr{text-align:end;align-items:flex-end;}.s.tl{text-align:start;}.s.i{font-style:italic;}.s.sk{text-decoration:line-through;}.s.u{text-decoration:underline;text-decoration-skip-ink:auto;text-decoration-skip:ink;}.s.u.sk{text-decoration:line-through underline;text-decoration-skip-ink:auto;text-decoration-skip:ink;}.itp{padding:0 !important;border-width:0 !important;transform:none;}.it{background-color:rgba(255,255,255,0);}.sldr{flex:none;flex-direction:unset;padding:0;margin:0;}input[type=\u0022range\u0022].sldr::-moz-range-thumb{width:16px;height:16px;}input[type=\u0022range\u0022].sldr::-webkit-slider-thumb{width:16px;height:16px;}input[type=\u0022range\u0022].sldr::-ms-thumb{width:16px;height:16px;}';
var $author$project$Internal$Style2$rules = $author$project$Internal$Style$Generated$stylesheet;
var $author$project$Internal$Model2$staticStyles = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$id('elm-ui-static-styles')
		]),
	_List_fromArray(
		[
			A3(
			$elm$html$Html$node,
			'style',
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text($author$project$Internal$Style2$rules)
				]))
		]));
var $author$project$Internal$Model2$styleRules = function (styleStr) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id('elm-ui-dynamic-styles')
			]),
		_List_fromArray(
			[
				A3(
				$elm$html$Html$node,
				'style',
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$join$('\u000A', styleStr))
					]))
			]));
};
var $author$project$Internal$Model2$zero = $author$project$Internal$BitField$init;
var $author$project$Internal$Model2$renderLayout$ = function (_v0, _v1, attrs, content) {
	var includeStaticStylesheet = _v0.includeStaticStylesheet;
	var options = _v0.options;
	var state = _v1;
	var rendered = $author$project$Internal$Model2$element$(
		$author$project$Internal$Model2$NodeAsDiv,
		6,
		attrs,
		_List_fromArray(
			[
				function (_v3) {
				return A3(
					$elm$html$Html$Keyed$node,
					'div',
					_List_Nil,
					_List_fromArray(
						[
							_Utils_Tuple2(
							'options',
							A2($elm$html$Html$Lazy$lazy, $author$project$Internal$Model2$renderOptions, options)),
							_Utils_Tuple2(
							'static',
							includeStaticStylesheet ? $author$project$Internal$Model2$staticStyles : $elm$html$Html$text('')),
							_Utils_Tuple2(
							'keyframes',
							A2($elm$html$Html$Lazy$lazy, $author$project$Internal$Model2$keyframeRules, state.keyframes)),
							_Utils_Tuple2(
							'animations',
							A2($elm$html$Html$Lazy$lazy, $author$project$Internal$Model2$styleRules, state.rules))
						]));
			},
				content
			]));
	var toFinalLayout = rendered;
	return toFinalLayout($author$project$Internal$Model2$zero);
};
var $author$project$Internal$Model2$renderLayout = F4($author$project$Internal$Model2$renderLayout$);
var $author$project$Ui$Anim$layout$ = function (opts, state, attrs, els) {
	return $author$project$Internal$Model2$renderLayout$(
		{
			includeStaticStylesheet: true,
			options: function () {
				var _v0 = opts.breakpoints;
				if (!_v0.$) {
					var breakpoints = _v0.a;
					return A2($elm$core$List$cons, breakpoints.breakpoints, opts.options);
				} else {
					return opts.options;
				}
			}()
		},
		state,
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Anim$onAnimationStart(opts.toMsg),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Anim$onAnimationUnmount(opts.toMsg),
				attrs)),
		els);
};
var $author$project$Ui$Anim$layout = F4($author$project$Ui$Anim$layout$);
var $author$project$Local$networkError$ = function (msgToString, currentTime, _v0) {
	var localModel_ = _v0;
	var hasNetworkIssue = $elm$core$List$filterMap$(
		function (_v2) {
			var changeId = _v2.a;
			var a = _v2.b;
			var _v3 = _Utils_Tuple2(
				$ianmackenzie$elm_units$Quantity$greaterThan$(
					$ianmackenzie$elm_units$Duration$seconds(10),
					$ianmackenzie$elm_units$Duration$from$(a.createdAt, currentTime)),
				msgToString(a.msg));
			if (_v3.a && (!_v3.b.$)) {
				var text = _v3.b.a;
				return $elm$core$Maybe$Just(
					$author$project$Ui$text(
						$elm$core$String$fromInt(changeId) + ('. ' + text)));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		$elm$core$Dict$toList(localModel_.localMsgs));
	if (!hasNetworkIssue.b) {
		return $author$project$Ui$none;
	} else {
		return $author$project$Ui$column$(
			_List_fromArray(
				[
					$author$project$Ui$background(
					$author$project$Ui$rgb$(77, 42, 42)),
					$author$project$Ui$centerX,
					$author$project$Ui$paddingXY$(16, 8),
					$author$project$Ui$rounded(8),
					$author$project$Ui$border(1),
					$author$project$Ui$borderColor(
					$author$project$Ui$rgb$(40, 26, 26)),
					$author$project$Ui$Shadow$shadows(
					_List_fromArray(
						[
							{
							blur: 6,
							color: $author$project$Ui$rgba$(0, 0, 0, 0.2),
							size: -1,
							x: 0,
							y: 0
						},
							{
							blur: 4,
							color: $author$project$Ui$rgba$(0, 0, 0, 0.2),
							size: -2,
							x: 0,
							y: 0
						}
						])),
					$author$project$Ui$move(
					{x: 0, y: -4, z: 0})
				]),
			_List_fromArray(
				[
					$author$project$Ui$el$(
					_List_fromArray(
						[$author$project$Ui$Font$bold]),
					$author$project$Ui$text('Unable to reach the server. The following are not saved:')),
					$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$paddingWith(
							{bottom: 4, left: 0, right: 0, top: 4})
						]),
					$author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$spacing(4),
								$author$project$Ui$Font$size(14),
								$author$project$Ui$paddingLeft(16),
								$author$project$Ui$scrollable,
								$author$project$Ui$heightMax(100)
							]),
						hasNetworkIssue))
				]));
	}
};
var $author$project$Local$networkError = F3($author$project$Local$networkError$);
var $author$project$Pages$Admin$pendingChangesText = function (change) {
	switch (change.$) {
		case 0:
			return 'Changed users via admin page';
		case 1:
			var pageId = change.a;
			return 'Switched to log page ' + $author$project$Id$toString(pageId);
		case 2:
			return 'Loading users in admin page';
		case 3:
			return 'Loading guilds in admin page';
		case 4:
			return 'Loading deleted guilds in admin page';
		case 5:
			return 'Loading DM channels in admin page';
		case 6:
			return 'Loading Discord guilds in admin page';
		case 7:
			return 'Loading Discord DM channels in admin page';
		case 8:
			return 'Loading Discord users in admin page';
		case 9:
			return 'Loading Slack workspaces in admin page';
		case 10:
			return 'Loading Slack DM channels in admin page';
		case 11:
			return 'Loading sessions in admin page';
		case 12:
			return 'Loading websocket close events in admin page';
		case 13:
			return 'Loading orphaned files in admin page';
		case 14:
			return 'Loading toBackend logs in admin page';
		case 15:
			return 'Loading backendMsg logs in admin page';
		case 16:
			var isEnabled = change.a;
			return isEnabled ? 'Enabled email notifications' : 'Disabled email notifications';
		case 17:
			var isEnabled = change.a;
			return isEnabled ? 'Enabled sign ups' : 'Disabled sign ups';
		case 18:
			var isEnabled = change.a;
			return isEnabled ? 'Enabled Discord account linking' : 'Disabled Discord account linking';
		case 19:
			if (!change.a.$) {
				var limit = change.a.a;
				return 'Set linked Discord user limit to ' + $elm$core$String$fromInt(limit);
			} else {
				var _v1 = change.a;
				return 'Removed linked Discord user limit';
			}
		case 20:
			var isEnabled = change.a;
			return isEnabled ? 'Enabled Slack account linking' : 'Disabled Slack account linking';
		case 21:
			if (!change.a.$) {
				var limit = change.a.a;
				return 'Set linked Slack user limit to ' + $elm$core$String$fromInt(limit);
			} else {
				var _v2 = change.a;
				return 'Removed linked Slack user limit';
			}
		case 22:
			return 'Set private vapid key';
		case 23:
			return 'Set public vapid key';
		case 24:
			return 'Set OpenRouter key';
		case 25:
			return 'Set notify admins token';
		case 26:
			return 'Set notify admins bot user id';
		case 27:
			return 'Set Postmark key';
		case 28:
			return 'Deleted Discord DM channel';
		case 29:
			return 'Deleted Discord guild';
		case 30:
			return 'Deleted Slack workspace';
		case 31:
			return 'Deleted Slack DM channel';
		case 32:
			return 'Deleted guild';
		case 33:
			return 'Restored guild';
		case 34:
			return 'Reset Discord channel';
		case 35:
			return 'Reset Discord DM channel';
		case 36:
			return 'Reloaded Discord guild roles and channel permissions';
		case 37:
			return 'Disconnect client';
		case 38:
			return 'Deleted session';
		case 39:
			return 'Regenerate server secret';
		default:
			return 'Delete orphaned files';
	}
};
var $author$project$FrontendExtra$pendingChangesText = function (localChange) {
	switch (localChange.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var adminChange = localChange.a;
			return $elm$core$Maybe$Just(
				$author$project$Pages$Admin$pendingChangesText(adminChange));
		case 2:
			return $elm$core$Maybe$Just('Sent a message');
		case 3:
			return $elm$core$Maybe$Just('Sent a message');
		case 4:
			return $elm$core$Maybe$Just('Sent a message');
		case 5:
			return $elm$core$Maybe$Just('Edit message');
		case 6:
			return $elm$core$Maybe$Just('Unlink Slack user');
		case 7:
			return $elm$core$Maybe$Just('Reload Slack user');
		case 8:
			return $elm$core$Maybe$Just('Created new channel');
		case 9:
			return $elm$core$Maybe$Just('Edited channel');
		case 10:
			return $elm$core$Maybe$Just('Deleted channel');
		case 11:
			return $elm$core$Maybe$Just('Edited guild name');
		case 12:
			return $elm$core$Maybe$Just('Deleted guild');
		case 13:
			return $elm$core$Maybe$Just('Left guild');
		case 14:
			return $elm$core$Maybe$Just('Created invite link');
		case 15:
			return $elm$core$Maybe$Just('Deleted invite link');
		case 16:
			return $elm$core$Maybe$Just('Banned member');
		case 17:
			return $elm$core$Maybe$Just('Created new guild');
		case 18:
			return $elm$core$Maybe$Nothing;
		case 19:
			return $elm$core$Maybe$Just('Added reaction emoji');
		case 20:
			return $elm$core$Maybe$Just('Removed reaction emoji');
		case 21:
			return $elm$core$Maybe$Just('Edit message');
		case 22:
			return $elm$core$Maybe$Just('Edit message');
		case 23:
			return $elm$core$Maybe$Just('Edit message');
		case 24:
			return $elm$core$Maybe$Just('Editing message');
		case 25:
			return $elm$core$Maybe$Nothing;
		case 26:
			return $elm$core$Maybe$Just('Delete message');
		case 27:
			return $elm$core$Maybe$Nothing;
		case 28:
			return $elm$core$Maybe$Just('Set display name');
		case 29:
			return $elm$core$Maybe$Just('Load channel messages');
		case 30:
			return $elm$core$Maybe$Nothing;
		case 31:
			return $elm$core$Maybe$Nothing;
		case 32:
			return $elm$core$Maybe$Nothing;
		case 33:
			return $elm$core$Maybe$Nothing;
		case 34:
			return $elm$core$Maybe$Nothing;
		case 35:
			var notificationLevel = localChange.b;
			if (!notificationLevel) {
				return $elm$core$Maybe$Just('Enabled notifications for all messages');
			} else {
				return $elm$core$Maybe$Just('Disabled notifications for all messages');
			}
		case 36:
			var notificationLevel = localChange.c;
			if (!notificationLevel) {
				return $elm$core$Maybe$Just('Enabled notifications for all messages');
			} else {
				return $elm$core$Maybe$Just('Disabled notifications for all messages');
			}
		case 37:
			var notificationLevel = localChange.c;
			if (!notificationLevel) {
				return $elm$core$Maybe$Just('Enabled notifications for all messages');
			} else {
				return $elm$core$Maybe$Just('Disabled notifications for all messages');
			}
		case 38:
			return $elm$core$Maybe$Just('Set notification mode');
		case 39:
			return $elm$core$Maybe$Nothing;
		case 40:
			return $elm$core$Maybe$Nothing;
		case 41:
			return $elm$core$Maybe$Just('Saved sheep game questions');
		case 42:
			return $elm$core$Maybe$Just('Set email notifications');
		case 43:
			return $elm$core$Maybe$Just('Set embed visibility');
		case 44:
			return $elm$core$Maybe$Just('Scheduled account deletion');
		case 45:
			return $elm$core$Maybe$Just('Cancelled account deletion');
		case 46:
			return $elm$core$Maybe$Just('Register push subscription');
		case 47:
			return $elm$core$Maybe$Just('Text editor change');
		case 48:
			return $elm$core$Maybe$Just('Unlink Discord user');
		case 49:
			return $elm$core$Maybe$Just('Reload Discord user');
		case 50:
			return $elm$core$Maybe$Just('Checked link Discord account acknowledgement');
		case 51:
			return $elm$core$Maybe$Just('Checked link Slack account acknowledgement');
		case 52:
			return $elm$core$Maybe$Just('Whitelist domain');
		case 53:
			return $elm$core$Maybe$Just('Selected emoji skin tone');
		case 54:
			return $elm$core$Maybe$Just('Picked a colour');
		case 55:
			return $elm$core$Maybe$Just('Add custom emojis to user');
		case 56:
			var voiceChatChange = localChange.a;
			switch (voiceChatChange.$) {
				case 0:
					return $elm$core$Maybe$Just('Left voice chat');
				case 1:
					return $elm$core$Maybe$Just('Set audio/video input enabled');
				case 2:
					return $elm$core$Maybe$Just('Asked to record call');
				case 3:
					if (voiceChatChange.a) {
						return $elm$core$Maybe$Just('Allowed call recording');
					} else {
						return $elm$core$Maybe$Just('Declined call recording');
					}
				default:
					return $elm$core$Maybe$Just('Cancelled asking to record call');
			}
		case 57:
			var change = localChange.b;
			switch (change.$) {
				case 0:
					return $elm$core$Maybe$Just('Shared match');
				case 1:
					return $elm$core$Maybe$Just('Opened match');
				case 2:
					var goChange = change.b;
					if (!goChange.$) {
						return $elm$core$Maybe$Just('Started Go match');
					} else {
						return $elm$core$Maybe$Just('Made a move in Go');
					}
				case 3:
					return $elm$core$Maybe$Just('Word spelling game change');
				default:
					return $elm$core$Maybe$Just('Sheep game change');
			}
		case 58:
			return $elm$core$Maybe$Just('Drew on a message');
		case 59:
			return $elm$core$Maybe$Just('Changed channel notifications');
		case 60:
			return $elm$core$Maybe$Just('Changed thread notifications');
		case 61:
			return $elm$core$Maybe$Just('Changed channel notifications');
		case 62:
			return $elm$core$Maybe$Just('Changed thread notifications');
		case 63:
			return $elm$core$Maybe$Just('Set mute guild');
		case 64:
			return $elm$core$Maybe$Just('Set mute Discord guild');
		case 65:
			return $elm$core$Maybe$Just('Set mute Slack workspace');
		case 66:
			return $elm$core$Maybe$Just('Changed channel notifications');
		case 67:
			return $elm$core$Maybe$Just('Changed thread notifications');
		case 68:
			return $elm$core$Maybe$Just('Asked to start end-to-end encryption');
		case 69:
			return $elm$core$Maybe$Just('Cancelled the end-to-end encryption request');
		case 70:
			return $elm$core$Maybe$Just('Declined the end-to-end encryption request');
		case 71:
			return $elm$core$Maybe$Just('Added a private key to the account');
		case 72:
			return $elm$core$Maybe$Just('Encrypted the messages written before this conversation was encrypted');
		case 73:
			return $elm$core$Maybe$Just('Turned off end-to-end encryption');
		case 74:
			return $elm$core$Maybe$Just('Removed the encryption from the messages written while this conversation was encrypted');
		case 75:
			return $elm$core$Maybe$Just('Accepted the end-to-end encryption risks');
		case 76:
			return $elm$core$Maybe$Just('Started end-to-end encryption');
		case 77:
			return $elm$core$Maybe$Just('Sent an encrypted message');
		default:
			return $elm$core$Maybe$Just('Edited an encrypted message');
	}
};
var $author$project$ImageViewer$MouseDown$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $author$project$ImageViewer$MouseDown = F2($author$project$ImageViewer$MouseDown$);
var $author$project$ImageViewer$MouseMove$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$ImageViewer$MouseMove = F2($author$project$ImageViewer$MouseMove$);
var $author$project$ImageViewer$MouseUp = {$: 6};
var $author$project$ImageViewer$TouchEnd = {$: 10};
var $author$project$ImageViewer$TouchMove = function (a) {
	return {$: 9, a: a};
};
var $author$project$ImageViewer$TouchStart = function (a) {
	return {$: 8, a: a};
};
var $author$project$ImageViewer$Wheeled$ = function (a, b, c) {
	return {$: 7, a: a, b: b, c: c};
};
var $author$project$ImageViewer$Wheeled = F3($author$project$ImageViewer$Wheeled$);
var $author$project$ImageViewer$PressedClose = {$: 0};
var $author$project$ImageViewer$PressStartedOnButton = {$: 3};
var $author$project$ImageViewer$stopPressPropagation = _List_fromArray(
	[
		$author$project$Ui$htmlAttribute(
		$elm$html$Html$Events$stopPropagationOn$(
			'mousedown',
			$elm$json$Json$Decode$succeed(
				_Utils_Tuple2($author$project$ImageViewer$PressStartedOnButton, true)))),
		$author$project$Ui$htmlAttribute(
		$elm$html$Html$Events$stopPropagationOn$(
			'touchstart',
			$elm$json$Json$Decode$succeed(
				_Utils_Tuple2($author$project$ImageViewer$PressStartedOnButton, true))))
	]);
var $author$project$ImageViewer$closeButton = function (safeAreaInsetTop) {
	return $author$project$MyUi$elButton$(
		$lamdera$program_test$Effect$Browser$Dom$id('imageViewer_close'),
		$author$project$ImageViewer$PressedClose,
		_Utils_ap(
			_List_fromArray(
				[
					$author$project$Ui$alignRight,
					$author$project$Ui$alignTop,
					$author$project$Ui$paddingXY$(16, 16),
					$author$project$Ui$Font$color($author$project$MyUi$white),
					$author$project$MyUi$htmlStyle$(
					'transform',
					'translateY(' + ($elm$core$String$fromInt(safeAreaInsetTop) + 'px)')),
					$author$project$Ui$background($author$project$MyUi$scrim),
					$author$project$MyUi$hoverText('Close')
				]),
			$author$project$ImageViewer$stopPressPropagation),
		$author$project$Ui$html($author$project$Icons$x));
};
var $author$project$ImageViewer$decodeClientPosition = function (toMsg) {
	return A3(
		$elm$json$Json$Decode$map2,
		toMsg,
		A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float),
		A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float));
};
var $author$project$ImageViewer$touchPositions = function (event) {
	return $elm$core$List$map$(
		function ($) {
			return $.clientPos;
		},
		event.touches);
};
var $author$project$ImageViewer$PressedZoomIn = {$: 1};
var $author$project$ImageViewer$PressedZoomOut = {$: 2};
var $author$project$ImageViewer$zoomButton$ = function (htmlId, onPress, title, label) {
	return $author$project$MyUi$elButton$(
		htmlId,
		onPress,
		_List_fromArray(
			[
				$author$project$Ui$width(
				$author$project$Ui$px(40)),
				$author$project$Ui$height(
				$author$project$Ui$px(40)),
				$author$project$Ui$rounded(20),
				$author$project$Ui$background($author$project$MyUi$scrim),
				$author$project$Ui$Font$color($author$project$MyUi$white),
				$author$project$Ui$Font$size(24),
				$author$project$Ui$contentCenterX,
				$author$project$Ui$contentCenterY,
				$author$project$MyUi$hoverText(title)
			]),
		$author$project$Ui$text(label));
};
var $author$project$ImageViewer$zoomButton = F4($author$project$ImageViewer$zoomButton$);
var $author$project$ImageViewer$zoomButtons = function (safeAreaInsetBottom) {
	return $author$project$Ui$row$(
		_Utils_ap(
			_List_fromArray(
				[
					$author$project$Ui$alignBottom,
					$author$project$Ui$centerX,
					$author$project$Ui$width($author$project$Ui$shrink),
					$author$project$Ui$spacing(16),
					$author$project$Ui$paddingXY$(16, 24),
					$author$project$MyUi$htmlStyle$(
					'transform',
					'translateY(-' + ($elm$core$String$fromInt(safeAreaInsetBottom) + 'px)'))
				]),
			$author$project$ImageViewer$stopPressPropagation),
		_List_fromArray(
			[
				$author$project$ImageViewer$zoomButton$(
				$lamdera$program_test$Effect$Browser$Dom$id('imageViewer_zoomOut'),
				$author$project$ImageViewer$PressedZoomOut,
				'Zoom out',
				'−'),
				$author$project$ImageViewer$zoomButton$(
				$lamdera$program_test$Effect$Browser$Dom$id('imageViewer_zoomIn'),
				$author$project$ImageViewer$PressedZoomIn,
				'Zoom in',
				'+')
			]));
};
var $author$project$ImageViewer$view$ = function (isMobile, windowSize, safeAreaInsetTop, safeAreaInsetBottom, model) {
	var _v0 = $author$project$ImageViewer$fittedSize$(windowSize, model);
	var fittedWidth = _v0.a;
	var fittedHeight = _v0.b;
	return $author$project$Ui$el$(
		_Utils_ap(
			_List_fromArray(
				[
					$author$project$Ui$id('imageViewer_overlay'),
					$author$project$Ui$width($author$project$Ui$fill),
					$author$project$Ui$height($author$project$Ui$fill),
					$author$project$Ui$background(
					$author$project$Ui$rgba$(
						0,
						0,
						0,
						$author$project$ImageViewer$nearestViewportEdge$(windowSize, model).b)),
					$author$project$Ui$clip,
					$author$project$Ui$htmlAttribute(
					$elm$html$Html$Events$preventDefaultOn$(
						'mousedown',
						A2(
							$elm$json$Json$Decode$map,
							function (msg) {
								return _Utils_Tuple2(msg, true);
							},
							$author$project$ImageViewer$decodeClientPosition($author$project$ImageViewer$MouseDown)))),
					function () {
					var _v1 = model.interaction;
					if (_v1.$ === 1) {
						return $author$project$Ui$htmlAttribute(
							$elm$html$Html$Events$on$(
								'mousemove',
								$author$project$ImageViewer$decodeClientPosition($author$project$ImageViewer$MouseMove)));
					} else {
						return $author$project$Ui$noAttr;
					}
				}(),
					$author$project$Ui$htmlAttribute(
					$elm$html$Html$Events$on$(
						'mouseup',
						$elm$json$Json$Decode$succeed($author$project$ImageViewer$MouseUp))),
					$author$project$Ui$htmlAttribute(
					$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onWithOptions$(
						'touchstart',
						{preventDefault: true, stopPropagation: true},
						function (event) {
							return $author$project$ImageViewer$TouchStart(
								$author$project$ImageViewer$touchPositions(event));
						})),
					$author$project$Ui$htmlAttribute(
					$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onWithOptions$(
						'touchmove',
						{preventDefault: true, stopPropagation: true},
						function (event) {
							return $author$project$ImageViewer$TouchMove(
								$author$project$ImageViewer$touchPositions(event));
						})),
					$author$project$Ui$htmlAttribute(
					$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onWithOptions$(
						'touchend',
						{preventDefault: true, stopPropagation: true},
						function (_v2) {
							return $author$project$ImageViewer$TouchEnd;
						})),
					$author$project$Ui$htmlAttribute(
					$elm$html$Html$Events$preventDefaultOn$(
						'wheel',
						A4(
							$elm$json$Json$Decode$map3,
							F3(
								function (deltaY, x, y) {
									return _Utils_Tuple2(
										$author$project$ImageViewer$Wheeled$(deltaY, x, y),
										true);
								}),
							A2($elm$json$Json$Decode$field, 'deltaY', $elm$json$Json$Decode$float),
							A2($elm$json$Json$Decode$field, 'clientX', $elm$json$Json$Decode$float),
							A2($elm$json$Json$Decode$field, 'clientY', $elm$json$Json$Decode$float))))
				]),
			isMobile ? _List_Nil : _List_fromArray(
				[
					$author$project$Ui$inFront(
					$author$project$ImageViewer$closeButton(safeAreaInsetTop)),
					$author$project$Ui$inFront(
					$author$project$ImageViewer$zoomButtons(safeAreaInsetBottom))
				])),
		$author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$centerX,
					$author$project$Ui$centerY,
					$author$project$MyUi$htmlStyle$('pointer-events', 'none')
				]),
			$author$project$Ui$html(
				A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(model.imageUrl),
							A2(
							$elm$html$Html$Attributes$style,
							'width',
							$elm$core$String$fromFloat(fittedWidth) + 'px'),
							A2(
							$elm$html$Html$Attributes$style,
							'height',
							$elm$core$String$fromFloat(fittedHeight) + 'px'),
							$author$project$MyUi$imagePlaceholderStyle,
							A2($elm$html$Html$Attributes$style, 'display', 'block'),
							A2(
							$elm$html$Html$Attributes$style,
							'image-rendering',
							(model.scale > 1) ? 'pixelated' : 'auto'),
							A2(
							$elm$html$Html$Attributes$style,
							'transform',
							'translate(' + ($elm$core$String$fromFloat(model.offsetX) + ('px,' + ($elm$core$String$fromFloat(model.offsetY) + ('px) scale(' + ($elm$core$String$fromFloat(model.scale) + ')'))))))
						]),
					_List_Nil))));
};
var $author$project$ImageViewer$view = F5($author$project$ImageViewer$view$);
var $author$project$MessageDropdown$dropdownButtonHeight$ = function (isMobile, isLarge) {
	return isLarge ? (isMobile ? 80 : 50) : (isMobile ? 50 : 30);
};
var $author$project$MessageDropdown$dropdownButtonHeight = F2($author$project$MessageDropdown$dropdownButtonHeight$);
var $author$project$Ui$Anim$Focus = 1;
var $author$project$Ui$Anim$focused$ = function (dur, attrs) {
	return $author$project$Ui$Anim$transitionWithTrigger$(1, dur, attrs);
};
var $author$project$Ui$Anim$focused = F2($author$project$Ui$Anim$focused$);
var $elm$html$Html$Events$onMouseDown = function (msg) {
	return $elm$html$Html$Events$on$(
		'mousedown',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Ui$Events$onMouseDown = A2($elm$core$Basics$composeL, $author$project$Internal$Model2$attribute, $elm$html$Html$Events$onMouseDown);
var $author$project$MyUi$touchPress = function (onPress) {
	return $author$project$Ui$htmlAttribute(
		$mpizenberg$elm_pointer_events$Html$Events$Extra$Touch$onStart(
			function (_v0) {
				return onPress;
			}));
};
var $author$project$MessageDropdown$dropdownButton$ = function (isMobile, isLarge, dropdown, dropdownButtonId, index, content) {
	return $author$project$MyUi$elButton$(
		dropdownButtonId(index),
		$author$project$MessageInput$PressedDropdownItem(index),
		_List_fromArray(
			[
				$author$project$Ui$Events$onMouseDown(
				$author$project$MessageInput$PressedDropdownItem(index)),
				$author$project$MyUi$touchPress(
				$author$project$MessageInput$PressedDropdownItem(index)),
				$author$project$Ui$paddingXY$(8, 0),
				$author$project$Ui$contentCenterY,
				$author$project$MyUi$hover$(
				isMobile,
				_List_fromArray(
					[
						$author$project$Ui$Anim$backgroundColor($author$project$MyUi$hoverHighlight)
					])),
				$author$project$Ui$height(
				$author$project$Ui$px(
					$author$project$MessageDropdown$dropdownButtonHeight$(isMobile, isLarge))),
				$author$project$Ui$Anim$focused$(
				$author$project$Ui$Anim$ms(100),
				_List_fromArray(
					[
						$author$project$Ui$Anim$backgroundColor($author$project$MyUi$background3)
					])),
				_Utils_eq(dropdown.dropdownIndex, index) ? $author$project$Ui$background($author$project$MyUi$background3) : $author$project$Ui$noAttr,
				$author$project$Ui$htmlAttribute(
				$elm$html$Html$Events$on$(
					'keydown',
					A2(
						$elm$json$Json$Decode$andThen,
						function (key) {
							return (key === 'ArrowDown') ? $elm$json$Json$Decode$succeed(
								$author$project$MessageInput$TypedArrowInDropdown(index + 1)) : ((key === 'ArrowUp') ? $elm$json$Json$Decode$succeed(
								$author$project$MessageInput$TypedArrowInDropdown(index - 1)) : $elm$json$Json$Decode$fail(''));
						},
						A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string))))
			]),
		content);
};
var $author$project$MessageDropdown$dropdownButton = F6($author$project$MessageDropdown$dropdownButton$);
var $author$project$MessageInput$PressedPingDropdownContainer = {$: 6};
var $author$project$MessageDropdown$addStickerOrEmojiText = 'Add a sticker or emoji';
var $author$project$MessageDropdown$addTimestampText = 'Add a timestamp';
var $author$project$MessageDropdown$mentionChannelText = 'Mention a channel';
var $author$project$MessageDropdown$mentionUserText = 'Mention a user';
var $author$project$MessageDropdown$dropdownContainer$ = function (nameSoFar, dropdown, contentHeight, content) {
	var headerHeight = 20;
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$background($author$project$MyUi$background2),
				$author$project$MyUi$blockClickPropagation($author$project$MessageInput$PressedPingDropdownContainer),
				$author$project$MyUi$blockTouchStartPropagation($author$project$MessageInput$PressedPingDropdownContainer),
				$author$project$Ui$borderColor($author$project$MyUi$border1),
				$author$project$Ui$border(1),
				$author$project$Ui$Font$color($author$project$MyUi$font2),
				$author$project$Ui$move(
				{
					x: $elm$core$Basics$round(dropdown.inputElement.x),
					y: $elm$core$Basics$round((dropdown.inputElement.y - (contentHeight + headerHeight)) + 1),
					z: 0
				}),
				$author$project$Ui$width(
				$author$project$Ui$px(
					$elm$core$Basics$round(dropdown.inputElement.width))),
				$author$project$Ui$height(
				$author$project$Ui$px(contentHeight + headerHeight)),
				$author$project$Ui$clip,
				$author$project$Ui$roundedWith(
				{bottomLeft: 0, bottomRight: 0, topLeft: 8, topRight: 8})
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Font$size(14),
						$author$project$Ui$Font$bold,
						$author$project$Ui$paddingXY$(8, 0),
						$author$project$Ui$height(
						$author$project$Ui$px(headerHeight))
					]),
				$author$project$Ui$text(
					function () {
						switch (nameSoFar.$) {
							case 0:
								return $author$project$MessageDropdown$mentionUserText;
							case 1:
								return $author$project$MessageDropdown$addStickerOrEmojiText;
							case 2:
								return $author$project$MessageDropdown$mentionChannelText;
							default:
								return $author$project$MessageDropdown$addTimestampText;
						}
					}())),
				$author$project$Ui$column$(_List_Nil, content)
			]));
};
var $author$project$MessageDropdown$dropdownContainer = F4($author$project$MessageDropdown$dropdownContainer$);
var $author$project$MessageDropdown$view$ = function (isMobile, time, nameSoFar, guildOrDmId, skinTone, emojiData, local, dropdownButtonId, dropdown) {
	switch (nameSoFar.$) {
		case 0:
			var nameSoFarData = nameSoFar.a;
			var rows = function () {
				switch (guildOrDmId.$) {
					case 0:
						var guildOrDmId2 = guildOrDmId.a;
						return $elm$core$List$indexedMap$(
							F2(
								function (index, _v2) {
									var user = _v2.b;
									return $author$project$MessageDropdown$dropdownButton$(
										isMobile,
										false,
										dropdown,
										dropdownButtonId,
										index,
										$author$project$Ui$text(
											$author$project$PersonName$toString(user.name)));
								}),
							$author$project$MessageDropdown$userDropdownList$(isMobile, nameSoFarData, guildOrDmId2, local));
					case 1:
						var guildOrDmId2 = guildOrDmId.a;
						return $elm$core$List$indexedMap$(
							F2(
								function (index, _v3) {
									var user = _v3.b;
									return $author$project$MessageDropdown$dropdownButton$(
										isMobile,
										false,
										dropdown,
										dropdownButtonId,
										index,
										$author$project$Ui$text(
											$author$project$PersonName$toString(user.name)));
								}),
							$author$project$MessageDropdown$discordUserDropdownList$(isMobile, nameSoFarData, guildOrDmId2, local));
					default:
						var guildOrDmId2 = guildOrDmId.a;
						return $elm$core$List$indexedMap$(
							F2(
								function (index, _v4) {
									var user = _v4.b;
									return $author$project$MessageDropdown$dropdownButton$(
										isMobile,
										false,
										dropdown,
										dropdownButtonId,
										index,
										$author$project$Ui$text(
											$author$project$PersonName$toString(user.name)));
								}),
							$author$project$MessageDropdown$slackUserDropdownList$(isMobile, nameSoFarData, guildOrDmId2, local));
				}
			}();
			var dropdownViewHeight = $elm$core$List$length(rows) * $author$project$MessageDropdown$dropdownButtonHeight$(isMobile, false);
			return $author$project$MessageDropdown$dropdownContainer$(nameSoFar, dropdown, dropdownViewHeight, rows);
		case 1:
			var emojiSoFar = nameSoFar.a;
			if (!emojiData.$) {
				var emojiData2 = emojiData.a;
				var _v6 = $author$project$MessageMenu$availableCustomEmojisAndStickers$(guildOrDmId, local);
				var availableCustomEmojis = _v6.a;
				var availableStickers = _v6.b;
				var _v7 = $elm$core$List$foldl$(
					F2(
						function (emojiOrSticker, _v8) {
							var rows2 = _v8.a;
							var index = _v8.b;
							var height2 = _v8.c;
							var helper = F2(
								function (isLarge, content) {
									return _Utils_Tuple3(
										A2(
											$elm$core$List$cons,
											$author$project$MessageDropdown$dropdownButton$(isMobile, isLarge, dropdown, dropdownButtonId, index, content),
											rows2),
										index + 1,
										height2 + $author$project$MessageDropdown$dropdownButtonHeight$(isMobile, isLarge));
								});
							switch (emojiOrSticker.$) {
								case 0:
									var emoji = emojiOrSticker.a;
									return A2(
										helper,
										false,
										$author$project$Ui$row$(
											_List_fromArray(
												[
													$author$project$Ui$spacing(8)
												]),
											_List_fromArray(
												[
													$author$project$Ui$el$(
													_List_fromArray(
														[
															$author$project$Ui$Font$size(24),
															$author$project$Ui$width($author$project$Ui$shrink)
														]),
													$author$project$Ui$html(
														$author$project$Emoji$sequenceView$(
															'1em',
															emojiData2,
															$author$project$Emoji$emojiWithSkinTone$(skinTone, emoji, emojiData2)))),
													function () {
													var _v10 = $lamdera$containers$SeqDict$get$(emoji, emojiData2.emojis);
													if (!_v10.$) {
														var emoji2 = _v10.a;
														return $author$project$Ui$row$(
															_List_fromArray(
																[
																	$author$project$Ui$spacing(8)
																]),
															$elm$core$List$map$(
																function (shortName) {
																	return $author$project$Ui$text(':' + (shortName + ':'));
																},
																emoji2.shortNames));
													} else {
														return $author$project$Ui$none;
													}
												}()
												])));
								case 1:
									var stickerId = emojiOrSticker.a;
									var _v11 = $lamdera$containers$SeqDict$get$(stickerId, local.localUser.stickers);
									if (!_v11.$) {
										var sticker = _v11.a;
										return A2(
											helper,
											true,
											$author$project$Ui$row$(
												_List_fromArray(
													[
														$author$project$Ui$spacing(8)
													]),
												_List_fromArray(
													[
														$author$project$Ui$html(
														$author$project$Sticker$viewHelper$(
															$elm$core$String$fromInt(
																$author$project$MessageDropdown$dropdownButtonHeight$(isMobile, true)) + 'px',
															sticker,
															2)),
														$author$project$Ui$text(':' + (sticker.name + ':'))
													])));
									} else {
										return A2(
											helper,
											false,
											$author$project$Ui$el$(
												_List_fromArray(
													[
														$author$project$Ui$Font$size(24),
														$author$project$Ui$Font$italic
													]),
												$author$project$Ui$text('Sticker missing')));
									}
								default:
									var customEmojiId = emojiOrSticker.a;
									var _v12 = $lamdera$containers$SeqDict$get$(customEmojiId, local.localUser.customEmojis);
									if (!_v12.$) {
										var emoji = _v12.a;
										return A2(
											helper,
											false,
											$author$project$Ui$row$(
												_List_fromArray(
													[
														$author$project$Ui$spacing(8)
													]),
												_List_fromArray(
													[
														$author$project$Ui$el$(
														_List_fromArray(
															[
																$author$project$Ui$Font$size(24),
																$author$project$Ui$width($author$project$Ui$shrink)
															]),
														$author$project$Ui$html(
															$author$project$CustomEmoji$viewHelper$('1.1em', '0', emoji, 2))),
														$author$project$Ui$text(
														':' + ($author$project$CustomEmoji$emojiNameToString(emoji.name) + ':'))
													])));
									} else {
										return A2(
											helper,
											false,
											$author$project$Ui$el$(
												_List_fromArray(
													[
														$author$project$Ui$Font$size(24),
														$author$project$Ui$Font$italic
													]),
												$author$project$Ui$text('Emoji missing')));
									}
							}
						}),
					_Utils_Tuple3(_List_Nil, 0, 0),
					$author$project$MessageDropdown$emojiDropdownList$(isMobile, emojiSoFar, availableCustomEmojis, availableStickers, local.localUser, emojiData2));
				var rows = _v7.a;
				var height = _v7.c;
				return $author$project$MessageDropdown$dropdownContainer$(
					nameSoFar,
					dropdown,
					height,
					$elm$core$List$reverse(rows));
			} else {
				return $author$project$MessageDropdown$dropdownContainer$(
					nameSoFar,
					dropdown,
					40,
					_List_fromArray(
						[
							$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$height(
									$author$project$Ui$px(40))
								]),
							$author$project$Ui$text('Loading emojis...'))
						]));
			}
		case 2:
			var nameSoFarData = nameSoFar.a;
			var rows = $elm$core$List$indexedMap$(
				F2(
					function (index, _v13) {
						var name = _v13.name;
						return $author$project$MessageDropdown$dropdownButton$(
							isMobile,
							false,
							dropdown,
							dropdownButtonId,
							index,
							$author$project$Ui$row$(
								_List_fromArray(
									[
										$author$project$Ui$height($author$project$Ui$fill),
										$author$project$Ui$clipWithEllipsis
									]),
								_List_fromArray(
									[
										$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$width($author$project$Ui$shrink),
												$author$project$Ui$centerY,
												$author$project$Ui$Font$color($author$project$MyUi$font3)
											]),
										$author$project$Ui$html($author$project$Icons$hashtag)),
										$author$project$Ui$text(name)
									])));
					}),
				$author$project$MessageDropdown$channelDropdownList$(isMobile, nameSoFarData, guildOrDmId, local));
			var dropdownViewHeight = $elm$core$List$length(rows) * $author$project$MessageDropdown$dropdownButtonHeight$(isMobile, false);
			return $author$project$MessageDropdown$dropdownContainer$(nameSoFar, dropdown, dropdownViewHeight, rows);
		default:
			var timestamp = nameSoFar.b;
			var rows = $elm$core$List$indexedMap$(
				F2(
					function (index, timestamp2) {
						return $author$project$MessageDropdown$dropdownButton$(
							isMobile,
							false,
							dropdown,
							dropdownButtonId,
							index,
							$author$project$Ui$text(
								$author$project$RichText$timestampToString$(time, local.localUser.timezone, timestamp2)));
					}),
				$author$project$MessageDropdown$timestampDropdownList$(local.localUser.timezone, time, timestamp));
			var dropdownViewHeight = $elm$core$List$length(rows) * $author$project$MessageDropdown$dropdownButtonHeight$(isMobile, false);
			return $author$project$MessageDropdown$dropdownContainer$(nameSoFar, dropdown, dropdownViewHeight, rows);
	}
};
var $author$project$MessageDropdown$view = F9($author$project$MessageDropdown$view$);
var $author$project$Types$MessageMenu_PressedContainer = {$: 69};
var $author$project$Internal$Model2$Below = 1;
var $author$project$Ui$below = function (element) {
	return $author$project$Internal$Model2$nearby$(1, element);
};
var $author$project$MessageMenu$desktopMenuPaddingBottom = 16;
var $author$project$MessageMenu$desktopMenuPaddingTop = 8;
var $author$project$CssPixels$inCssPixels = $ianmackenzie$elm_units$Quantity$unwrap;
var $author$project$Types$MessageMenu_PressedClose = {$: 68};
var $author$project$MessageInput$editView$ = function (htmlId, height, roundTopCorners, isMobileKeyboard, channelTextInputId, placeholderText, charsLeft, text, richText, attachmentsUploading, attachedFiles, localUser, loggedIn, users, channels) {
	var htmlIdPrefix = $lamdera$program_test$Effect$Browser$Dom$idToString(htmlId);
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$paddingWith($author$project$MessageInput$textareaPadding),
				$author$project$Ui$inFront(
				$author$project$Ui$row$(
					_List_fromArray(
						[
							$author$project$Ui$width($author$project$Ui$shrink),
							$author$project$Ui$move(
							{x: 2, y: 0, z: 0}),
							$author$project$Ui$spacing(4),
							$author$project$Ui$alignBottom
						]),
					_List_fromArray(
						[
							$author$project$MessageInput$attachmentButton(htmlIdPrefix),
							$author$project$MessageInput$showEmojiSelectorButton(htmlIdPrefix)
						]))),
				$author$project$Ui$inFront(
				$author$project$MessageInput$characterCounter(charsLeft)),
				$author$project$Ui$inFront(
				$author$project$MyUi$elButton$(
					$lamdera$program_test$Effect$Browser$Dom$id(htmlIdPrefix + '_sendMessage'),
					$author$project$MessageInput$PressedSendMessage(
						{charsLeft: charsLeft}),
					_List_fromArray(
						[
							$author$project$Ui$alignRight,
							$author$project$Ui$width($author$project$Ui$shrink),
							$author$project$Ui$rounded(4),
							$author$project$Ui$paddingXY$(4, 0),
							$author$project$Ui$height(
							$author$project$Ui$px(38)),
							$author$project$Ui$background(
							((charsLeft < 0) || attachmentsUploading) ? $author$project$MyUi$disabledButtonBackground : $author$project$MyUi$buttonBackground),
							$author$project$Ui$move(
							{x: -2, y: 0, z: 0}),
							$author$project$Ui$contentCenterY,
							$author$project$Ui$alignBottom,
							$author$project$MyUi$hoverText('Send message'),
							$author$project$Ui$htmlAttribute(
							$elm$html$Html$Events$preventDefaultOn$(
								'touchend',
								$elm$json$Json$Decode$succeed(
									_Utils_Tuple2(
										$author$project$MessageInput$PressedSendMessage(
											{charsLeft: charsLeft}),
										true))))
						]),
					$author$project$Ui$html($author$project$Icons$sendMessage)))
			]),
		$author$project$Ui$el$(
			A2(
				$elm$core$List$cons,
				$author$project$Ui$height(
					$author$project$Ui$px(height)),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$heightMax(height),
					$author$project$MessageInput$containerAttributes(roundTopCorners))),
			$author$project$Ui$html(
				$author$project$MessageInput$textarea$(
					isMobileKeyboard,
					channelTextInputId,
					$author$project$MessageInput$textPlaceholder(placeholderText),
					charsLeft,
					text,
					richText,
					attachedFiles,
					localUser,
					loggedIn,
					users,
					channels))));
};
var $author$project$MessageInput$editView = function (htmlId) {
	return function (height) {
		return function (roundTopCorners) {
			return function (isMobileKeyboard) {
				return function (channelTextInputId) {
					return function (placeholderText) {
						return function (charsLeft) {
							return function (text) {
								return function (richText) {
									return function (attachmentsUploading) {
										return function (attachedFiles) {
											return function (localUser) {
												return function (loggedIn) {
													return function (users) {
														return function (channels) {
															return $author$project$MessageInput$editView$(htmlId, height, roundTopCorners, isMobileKeyboard, channelTextInputId, placeholderText, charsLeft, text, richText, attachmentsUploading, attachedFiles, localUser, loggedIn, users, channels);
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$MessageMenu$showEditViewed$ = function (extraOptions, loggedIn) {
	var _v0 = extraOptions.mobileMode;
	switch (_v0.$) {
		case 0:
			var maybeEditing = _v0.b;
			return maybeEditing;
		case 1:
			return $author$project$MessageMenu$showEdit$(extraOptions, loggedIn);
		case 2:
			return $author$project$MessageMenu$showEdit$(extraOptions, loggedIn);
		default:
			return $author$project$MessageMenu$showEdit$(extraOptions, loggedIn);
	}
};
var $author$project$MessageMenu$showEditViewed = F2($author$project$MessageMenu$showEditViewed$);
var $author$project$MessageMenu$viewMobile$ = function (offset, extraOptions, loggedIn, local, model) {
	var menuItemsData = $author$project$MessageMenu$menuItems$(true, extraOptions.guildOrDmId, extraOptions.threadRoute, extraOptions.isThreadStarter, extraOptions.imageUrl, extraOptions.linkUrl, extraOptions.position, local, model);
	var height = 1000;
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$move(
				{
					x: 0,
					y: height + $elm$core$Basics$round(-offset),
					z: 0
				}),
				$author$project$MyUi$htmlStyle$('position', 'absolute'),
				$author$project$MyUi$htmlStyle$('bottom', '0'),
				$author$project$Ui$roundedWith(
				{bottomLeft: 0, bottomRight: 0, topLeft: 16, topRight: 16}),
				$author$project$Ui$background($author$project$MyUi$black),
				$author$project$Ui$paddingWith(
				{bottom: ((local.localUser.safeAreaInsetBottom / 2) | 0) + $author$project$MessageMenu$bottomPadding, left: 8, right: 8, top: $author$project$MessageMenu$topPadding}),
				$author$project$MyUi$blockClickPropagation($author$project$Types$MessageMenu_PressedContainer),
				$author$project$Ui$height(
				$author$project$Ui$px(height))
			]),
		A2(
			$elm$core$List$cons,
			$author$project$MyUi$elButton$(
				$lamdera$program_test$Effect$Browser$Dom$id('messageMenu_close'),
				$author$project$Types$MessageMenu_PressedClose,
				_List_fromArray(
					[
						$author$project$Ui$height(
						$author$project$Ui$px($author$project$MessageMenu$mobileCloseButton))
					]),
				$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$background(
							$author$project$Ui$rgb$(22, 30, 38)),
							$author$project$Ui$rounded(99),
							$author$project$Ui$width(
							$author$project$Ui$px(40)),
							$author$project$Ui$height(
							$author$project$Ui$px(4)),
							$author$project$Ui$centerX,
							$author$project$Ui$centerY
						]),
					$author$project$Ui$none)),
			function () {
				var _v0 = $author$project$MessageMenu$showEditViewed$(extraOptions, loggedIn);
				if (!_v0.$) {
					var edit = _v0.a;
					var editView = F4(
						function (charsLeft, richText, allUsers, channels) {
							return $author$project$MessageInput$editView$(
								$lamdera$program_test$Effect$Browser$Dom$id('messageMenu_editMobile'),
								(-32) + $elm$core$Basics$round(
									$author$project$MessageMenu$mobileMenuMaxHeightHelper(menuItemsData)),
								true,
								true,
								$author$project$MessageMenu$editMessageTextInputId,
								'',
								charsLeft,
								edit.text,
								richText,
								$author$project$FileStatus$hasUploadingFile(edit.attachedFiles),
								edit.attachedFiles,
								local.localUser,
								loggedIn,
								allUsers,
								channels);
						});
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$map,
							A2(
								$author$project$Types$EditMessage_MessageInputMsg,
								extraOptions.guildOrDmId,
								$author$project$Id$threadRouteWithoutMessage(extraOptions.threadRoute)),
							function () {
								var _v1 = extraOptions.guildOrDmId;
								switch (_v1.$) {
									case 0:
										var guildOrDmId = _v1.a;
										var channels = $author$project$LocalState$channelMentions$(guildOrDmId, local);
										var allUsers = $author$project$User$allUsers(local.localUser);
										var richText = function () {
											var _v2 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(edit.text);
											if (!_v2.$) {
												var nonempty = _v2.a;
												return $elm$core$Maybe$Just(
													$author$project$RichText$fromNonemptyString$(local.localUser.timezone, allUsers, channels, nonempty));
											} else {
												return $elm$core$Maybe$Nothing;
											}
										}();
										return A4(
											editView,
											$author$project$RichText$maxLength - $elm$core$String$length(edit.text),
											richText,
											allUsers,
											channels);
									case 1:
										var guildOrDmId = _v1.a;
										var channels = $author$project$LocalState$discordChannelMentions$(guildOrDmId, local);
										var allUsers = $author$project$LinkedAndOtherDiscordUsers$allDiscordUsers(local.localUser.discordUsers);
										var richText = function () {
											var _v3 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(edit.text);
											if (!_v3.$) {
												var nonempty = _v3.a;
												return $elm$core$Maybe$Just(
													$author$project$RichText$fromNonemptyString$(local.localUser.timezone, allUsers, channels, nonempty));
											} else {
												return $elm$core$Maybe$Nothing;
											}
										}();
										return A4(
											editView,
											$author$project$RichText$discordCharsLeft$($author$project$OneToOne$empty, richText),
											richText,
											allUsers,
											channels);
									default:
										var guildOrDmId = _v1.a;
										var channels = $author$project$LocalState$slackChannelMentions$(guildOrDmId, local);
										var richText = function () {
											var _v4 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(edit.text);
											if (!_v4.$) {
												var nonempty = _v4.a;
												return $elm$core$Maybe$Just(
													$author$project$RichText$fromNonemptyString$(local.localUser.timezone, local.localUser.slackUsers, channels, nonempty));
											} else {
												return $elm$core$Maybe$Nothing;
											}
										}();
										return A4(
											editView,
											$author$project$RichText$maxLength - $elm$core$String$length(edit.text),
											richText,
											local.localUser.slackUsers,
											channels);
								}
							}())
						]);
				} else {
					return $elm$core$List$intersperse$(
						$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$borderWith(
									{bottom: 0, left: 0, right: 0, top: 1}),
									$author$project$Ui$borderColor($author$project$MyUi$border2)
								]),
							$author$project$Ui$none),
						menuItemsData.items);
				}
			}()));
};
var $author$project$MessageMenu$viewMobile = F5($author$project$MessageMenu$viewMobile$);
var $author$project$MessageMenu$width = 240;
var $author$project$MessageMenu$view$ = function (model, extraOptions, local, loggedIn) {
	if ($author$project$MyUi$isMobile(model)) {
		var offset = $author$project$CssPixels$inCssPixels(
			$author$project$Types$messageMenuMobileOffset(extraOptions.mobileMode));
		return $author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$height($author$project$Ui$fill),
					$author$project$Ui$background(
					$author$project$Ui$rgba$(
						0,
						0,
						0,
						0.3 * $elm$core$Basics$clamp$(0, 1, (offset - 30) / 30))),
					$author$project$Ui$below(
					$author$project$MessageMenu$viewMobile$(offset, extraOptions, loggedIn, local, model))
				]),
			$author$project$Ui$none);
	} else {
		var y = $author$project$Coord$yRaw(extraOptions.position);
		var x = $author$project$Coord$xRaw(extraOptions.position);
		var _v0 = $author$project$MessageMenu$menuItems$(false, extraOptions.guildOrDmId, extraOptions.threadRoute, extraOptions.isThreadStarter, extraOptions.imageUrl, extraOptions.linkUrl, extraOptions.position, local, model);
		var height = _v0.height;
		var items = _v0.items;
		return $author$project$Ui$column$(
			_List_fromArray(
				[
					$author$project$Ui$move(
					{
						x: (_Utils_cmp(
							$author$project$MessageMenu$width + x,
							$author$project$Coord$xRaw(model.windowSize)) > 0) ? (x - $author$project$MessageMenu$width) : x,
						y: (_Utils_cmp(
							height + y,
							$author$project$Coord$yRaw(model.windowSize)) > 0) ? (y - height) : y,
						z: 0
					}),
					$author$project$Ui$background($author$project$MyUi$background1),
					$author$project$Ui$border(1),
					$author$project$Ui$borderColor($author$project$MyUi$border1),
					$author$project$Ui$width(
					$author$project$Ui$px($author$project$MessageMenu$width)),
					$author$project$Ui$rounded(8),
					$author$project$Ui$paddingWith(
					{bottom: $author$project$MessageMenu$desktopMenuPaddingBottom, left: 8, right: 8, top: $author$project$MessageMenu$desktopMenuPaddingTop}),
					$author$project$MyUi$blockClickPropagation($author$project$Types$MessageMenu_PressedContainer)
				]),
			items);
	}
};
var $author$project$MessageMenu$view = F4($author$project$MessageMenu$view$);
var $author$project$FrontendExtra$layout$ = function (model, attributes, child) {
	var isMobile = $author$project$MyUi$isMobile(model);
	return $author$project$Ui$Anim$layout$(
		{breakpoints: $elm$core$Maybe$Nothing, options: _List_Nil, toMsg: $author$project$Types$ElmUiMsg},
		model.elmUiState,
		_Utils_ap(
			function () {
				var _v0 = model.loginStatus;
				if (!_v0.$) {
					var loggedIn = _v0.a;
					var local = $author$project$Local$model(loggedIn.localState);
					var maybeMessageId = $author$project$Route$toGuildOrDmId$(local.localUser.session.userId, model.route);
					return _List_fromArray(
						[
							$author$project$Ui$htmlAttribute(
							$elm$html$Html$Events$preventDefaultOn$(
								'dragenter',
								A3(
									$elm$json$Json$Decode$map2,
									F2(
										function (time, types) {
											return $elm$core$List$member$('Files', types) ? _Utils_Tuple2(
												$author$project$Types$FileDragEnter(
													$ianmackenzie$elm_units$Duration$milliseconds(time)),
												true) : _Utils_Tuple2($author$project$Types$FrontendNoOp, false);
										}),
									A2($elm$json$Json$Decode$field, 'timeStamp', $elm$json$Json$Decode$float),
									$elm$json$Json$Decode$at$(
										_List_fromArray(
											['dataTransfer', 'types']),
										$elm$json$Json$Decode$list($elm$json$Json$Decode$string))))),
							$author$project$Ui$htmlAttribute(
							$elm$html$Html$Events$preventDefaultOn$(
								'dragover',
								$elm$json$Json$Decode$succeed(
									_Utils_Tuple2($author$project$Types$FrontendNoOp, true)))),
							$author$project$Ui$htmlAttribute(
							$elm$html$Html$Events$preventDefaultOn$(
								'dragleave',
								$elm$json$Json$Decode$succeed(
									_Utils_Tuple2($author$project$Types$FileDragLeave, true)))),
							$author$project$Ui$htmlAttribute(
							$elm$html$Html$Events$preventDefaultOn$(
								'drop',
								A2(
									$elm$json$Json$Decode$map,
									function (list) {
										return _Utils_Tuple2(
											$author$project$Types$FileDropped(list),
											true);
									},
									$elm$json$Json$Decode$at$(
										_List_fromArray(
											['dataTransfer', 'files']),
										$elm_community$json_extra$Json$Decode$Extra$collection($lamdera$program_test$Effect$File$decoder))))),
							$author$project$Ui$inFront(
							$author$project$FrontendExtra$fileDragOverlay$(loggedIn, model)),
							$author$project$Ui$inFront(
							$author$project$Local$networkError$(
								function (change) {
									if (!change.$) {
										var localChange = change.b;
										return $author$project$FrontendExtra$pendingChangesText(localChange);
									} else {
										return $elm$core$Maybe$Nothing;
									}
								},
								model.time,
								loggedIn.localState)),
							function () {
							if (!maybeMessageId.$) {
								var _v3 = maybeMessageId.a;
								var guildOrDmId = _v3.a;
								var threadRoute = _v3.b;
								var _v4 = loggedIn.textInputFocus;
								if (!_v4.$) {
									var textInputFocus = _v4.a;
									var _v5 = _Utils_Tuple2(
										$author$project$FrontendExtra$pingUserNameSoFar$(textInputFocus.htmlId, textInputFocus.selection, guildOrDmId, threadRoute, loggedIn),
										textInputFocus.dropdown);
									if ((!_v5.a.$) && (!_v5.b.$)) {
										var nameSoFar = _v5.a.a;
										var dropdown = _v5.b.a;
										return _Utils_eq(textInputFocus.htmlId, $author$project$Pages$Guild$channelTextInputId) ? $author$project$Ui$inFront(
											A2(
												$author$project$Ui$map,
												A2($author$project$Types$MessageInputMsg, guildOrDmId, threadRoute),
												$author$project$MessageDropdown$view$(isMobile, model.time, nameSoFar, guildOrDmId, local.localUser.user.emojiConfig.skinTone, model.emojiData, local, $author$project$Pages$Guild$dropdownButtonId, dropdown))) : (_Utils_eq(textInputFocus.htmlId, $author$project$MessageMenu$editMessageTextInputId) ? $author$project$Ui$inFront(
											A2(
												$author$project$Ui$map,
												A2($author$project$Types$EditMessage_MessageInputMsg, guildOrDmId, threadRoute),
												$author$project$MessageDropdown$view$(isMobile, model.time, nameSoFar, guildOrDmId, local.localUser.user.emojiConfig.skinTone, model.emojiData, local, $author$project$Pages$Guild$dropdownButtonId, dropdown))) : $author$project$Ui$noAttr);
									} else {
										return $author$project$Ui$noAttr;
									}
								} else {
									return $author$project$Ui$noAttr;
								}
							} else {
								return $author$project$Ui$noAttr;
							}
						}(),
							function () {
							var _v6 = loggedIn.messageHover;
							switch (_v6.$) {
								case 2:
									var extraOptions = _v6.a;
									return $author$project$Ui$inFront(
										$author$project$MessageMenu$view$(model, extraOptions, local, loggedIn));
								case 1:
									return $author$project$Ui$noAttr;
								case 3:
									return $author$project$Ui$noAttr;
								default:
									return $author$project$Ui$noAttr;
							}
						}()
						]);
				} else {
					return _List_Nil;
				}
			}(),
			A2(
				$elm$core$List$cons,
				$author$project$MyUi$notoSans,
				A2(
					$elm$core$List$cons,
					$author$project$Ui$id('elm-ui-root-id'),
					A2(
						$elm$core$List$cons,
						$author$project$Ui$height($author$project$Ui$fill),
						A2(
							$elm$core$List$cons,
							$author$project$Ui$behindContent(
								$author$project$Ui$html($author$project$MyUi$css)),
							A2(
								$elm$core$List$cons,
								$author$project$Ui$behindContent(
									$author$project$Ui$html(
										A3(
											$elm$html$Html$node,
											'style',
											_List_Nil,
											_List_fromArray(
												[
													function () {
													var _v7 = model.startupData.pwaStatus;
													if (!_v7) {
														return $elm$html$Html$text('body { height:100vh !important; }');
													} else {
														return $elm$html$Html$text('body { height:100dvh !important; }');
													}
												}()
												])))),
								A2(
									$elm$core$List$cons,
									$author$project$Ui$Font$size(16),
									A2(
										$elm$core$List$cons,
										$author$project$Ui$Font$color($author$project$MyUi$font1),
										A2(
											$elm$core$List$cons,
											$author$project$Ui$htmlAttribute(
												$elm$html$Html$Events$onClick($author$project$Types$PressedBody)),
											A2(
												$elm$core$List$cons,
												function () {
													var _v8 = model.imageViewer;
													if (!_v8.$) {
														var imageViewer = _v8.a;
														return $author$project$Ui$inFront(
															A2(
																$author$project$Ui$map,
																$author$project$Types$ImageViewerMsg,
																$author$project$ImageViewer$view$(isMobile, model.windowSize, model.startupData.safeAreaInsetTop, model.startupData.safeAreaInsetBottom, imageViewer)));
													} else {
														return $author$project$Ui$noAttr;
													}
												}(),
												A2(
													$elm$core$List$cons,
													function () {
														var _v9 = $author$project$Route$toOverlay(model.route);
														if (!_v9.$) {
															switch (_v9.a) {
																case 0:
																	var _v10 = _v9.a;
																	return $author$project$Ui$inFront(
																		$author$project$Ui$Lazy$lazy$($author$project$FrontendExtra$e2eeInfoOverlay, isMobile));
																case 1:
																	var _v11 = _v9.a;
																	return $author$project$Ui$noAttr;
																default:
																	var _v12 = _v9.a;
																	return $author$project$Ui$noAttr;
															}
														} else {
															return $author$project$Ui$noAttr;
														}
													}(),
													_Utils_ap(
														attributes,
														_Utils_ap(
															$author$project$MyUi$isMobile(model) ? _List_fromArray(
																[
																	$author$project$Ui$clip,
																	$author$project$Ui$htmlAttribute(
																	$elm$html$Html$Events$on$(
																		'touchstart',
																		$author$project$Touch$decodeTouchEvent($author$project$Types$TouchStart))),
																	$author$project$Ui$htmlAttribute(
																	$elm$html$Html$Events$on$(
																		'touchmove',
																		$author$project$Touch$decodeTouchEvent($author$project$Types$TouchMoved))),
																	$author$project$Ui$htmlAttribute(
																	$elm$html$Html$Events$on$(
																		'touchend',
																		A2(
																			$elm$json$Json$Decode$map,
																			function (time) {
																				return $author$project$Types$TouchEnd(
																					$ianmackenzie$elm_units$Duration$milliseconds(time));
																			},
																			A2($elm$json$Json$Decode$field, 'timeStamp', $elm$json$Json$Decode$float)))),
																	$author$project$Ui$htmlAttribute(
																	$elm$html$Html$Events$on$(
																		'touchcancel',
																		A2(
																			$elm$json$Json$Decode$map,
																			function (time) {
																				return $author$project$Types$TouchCancel(
																					$ianmackenzie$elm_units$Duration$milliseconds(time));
																			},
																			A2($elm$json$Json$Decode$field, 'timeStamp', $elm$json$Json$Decode$float))))
																]) : _List_fromArray(
																[
																	$author$project$Ui$htmlAttribute(
																	$elm$html$Html$Events$on$(
																		'pointerdown',
																		$author$project$Touch$decoderPointerEvent($author$project$Types$TouchStart))),
																	function () {
																	var _v13 = model.drag;
																	if (!_v13.$) {
																		return $author$project$Ui$noAttr;
																	} else {
																		return $author$project$Ui$htmlAttribute(
																			$elm$html$Html$Events$on$(
																				'pointermove',
																				$author$project$Touch$decoderPointerEvent($author$project$Types$TouchMoved)));
																	}
																}(),
																	$author$project$Ui$htmlAttribute(
																	$elm$html$Html$Events$on$(
																		'pointerup',
																		A2(
																			$elm$json$Json$Decode$map,
																			function (time) {
																				return $author$project$Types$TouchEnd(
																					$ianmackenzie$elm_units$Duration$milliseconds(time));
																			},
																			A2($elm$json$Json$Decode$field, 'timeStamp', $elm$json$Json$Decode$float)))),
																	$author$project$Ui$htmlAttribute(
																	$elm$html$Html$Events$on$(
																		'pointercancel',
																		A2(
																			$elm$json$Json$Decode$map,
																			function (time) {
																				return $author$project$Types$TouchCancel(
																					$ianmackenzie$elm_units$Duration$milliseconds(time));
																			},
																			A2($elm$json$Json$Decode$field, 'timeStamp', $elm$json$Json$Decode$float))))
																]),
															$author$project$FrontendExtra$disableTextSelect$(isMobile, model) ? _List_fromArray(
																[
																	$author$project$MyUi$htmlStyle$('user-select', 'none'),
																	$author$project$MyUi$htmlStyle$('-webkit-user-select', 'none')
																]) : _List_Nil))))))))))))),
		child);
};
var $author$project$FrontendExtra$layout = F3($author$project$FrontendExtra$layout$);
var $author$project$Icons$addApp = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M13.5 16.875h3.375m0 0h3.375m-3.375 0V13.5m0 3.375v3.375M6 10.5h2.25a2.25 2.25 0 0 0 2.25-2.25V6a2.25 2.25 0 0 0-2.25-2.25H6A2.25 2.25 0 0 0 3.75 6v2.25A2.25 2.25 0 0 0 6 10.5Zm0 9.75h2.25A2.25 2.25 0 0 0 10.5 18v-2.25a2.25 2.25 0 0 0-2.25-2.25H6a2.25 2.25 0 0 0-2.25 2.25V18A2.25 2.25 0 0 0 6 20.25Zm9.75-9.75H18a2.25 2.25 0 0 0 2.25-2.25V6A2.25 2.25 0 0 0 18 3.75h-2.25A2.25 2.25 0 0 0 13.5 6v2.25a2.25 2.25 0 0 0 2.25 2.25Z')
				]),
			_List_Nil)
		]));
var $author$project$LoginForm$mobileWarning$ = function (windowSize, browser) {
	var wideEnoughForIcon = $author$project$Coord$xRaw(windowSize) >= 400;
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$html(
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							wideEnoughForIcon ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'float', 'left'),
									A2($elm$html$Html$Attributes$style, 'width', '44px'),
									A2($elm$html$Html$Attributes$style, 'height', '40px'),
									A2($elm$html$Html$Attributes$style, 'margin-right', '4px'),
									A2(
									$elm$html$Html$Attributes$style,
									'color',
									$author$project$MyUi$colorToStyle($author$project$MyUi$font3))
								]),
							_List_fromArray(
								[$author$project$Icons$addApp])) : $elm$html$Html$text(''),
							A2(
							$elm$html$Html$b,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Please install this app from the browser menu' + function () {
										switch (browser) {
											case 2:
												return ' (Add\u00A0to\u00A0Home\u00A0Screen)';
											case 0:
												return ' (Install\u00A0and\u00A0Create\u00A0Shortcut)';
											case 1:
												return '';
											case 3:
												return '';
											case 4:
												return '';
											default:
												return '';
										}
									}())
								]))
						]))),
				$author$project$Ui$Prose$paragraph$(
				_List_fromArray(
					[
						$author$project$Ui$Font$color($author$project$MyUi$font3),
						$author$project$Ui$Font$size(16),
						wideEnoughForIcon ? $author$project$Ui$padding(4) : $author$project$Ui$paddingXY$(0, 4)
					]),
				_List_fromArray(
					[
						$author$project$Ui$text('You can still use it in a browser but you\u0027re not going to have a good time.')
					]))
			]));
};
var $author$project$LoginForm$mobileWarning = F2($author$project$LoginForm$mobileWarning$);
var $author$project$Pages$Guild$newGuildFormInit = {name: '', pressedSubmit: false};
var $author$project$Types$NewGuildFormChanged = function (a) {
	return {$: 35, a: a};
};
var $author$project$Types$PressedSubmitNewGuild = function (a) {
	return {$: 36, a: a};
};
var $author$project$Pages$Guild$guildNameInput = function (form) {
	var nameLabel = $author$project$Ui$Input$label$(
		'newGuildName',
		_List_fromArray(
			[
				$author$project$Ui$Font$color($author$project$MyUi$font2),
				$author$project$Ui$paddingXY$(2, 0)
			]),
		$author$project$Ui$text('Guild name'));
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$paddingXY$(16, 0)
			]),
		_List_fromArray(
			[
				nameLabel.element,
				A2(
				$author$project$Ui$Input$text,
				_List_fromArray(
					[
						$author$project$Ui$padding(6),
						$author$project$Ui$background($author$project$MyUi$inputBackground),
						$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
						$author$project$Ui$widthMax(500)
					]),
				{
					label: nameLabel.id,
					onChange: function (text) {
						return _Utils_update(
							form,
							{name: text});
					},
					placeholder: $elm$core$Maybe$Nothing,
					text: form.name
				}),
				function () {
				var _v0 = _Utils_Tuple2(
					form.pressedSubmit,
					$author$project$GuildName$fromString(form.name));
				if (_v0.a && (_v0.b.$ === 1)) {
					var error = _v0.b.a;
					return $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$(2, 0),
								$author$project$Ui$Font$color($author$project$MyUi$errorColor)
							]),
						$author$project$Ui$text(error));
				} else {
					return $author$project$Ui$none;
				}
			}()
			]));
};
var $author$project$Pages$Guild$newGuildFormView$ = function (safeAreaInsetTop, form) {
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$Font$color($author$project$MyUi$font1),
				$author$project$Ui$paddingWith(
				{bottom: 16, left: 0, right: 0, top: safeAreaInsetTop}),
				$author$project$Ui$alignTop,
				$author$project$Ui$spacing(16),
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$Ui$background($author$project$MyUi$background1)
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Font$size(24),
						$author$project$Ui$paddingXY$(16, 0)
					]),
				$author$project$Ui$text('Create new guild')),
				A2(
				$author$project$Ui$map,
				$author$project$Types$NewGuildFormChanged,
				$author$project$Pages$Guild$guildNameInput(form)),
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(16),
						$author$project$Ui$paddingXY$(16, 0)
					]),
				_List_fromArray(
					[
						$author$project$MyUi$secondaryButton$(
						$lamdera$program_test$Effect$Browser$Dom$id('guild_cancelNewGuild'),
						$author$project$Types$PressedLink(
							$author$project$Route$HomePageRoute($elm$core$Maybe$Nothing)),
						'Cancel'),
						$author$project$Pages$Guild$submitButton$(
						$lamdera$program_test$Effect$Browser$Dom$id('guild_createGuildSubmit'),
						$author$project$Types$PressedSubmitNewGuild(form),
						'Create guild')
					]))
			]));
};
var $author$project$Pages$Guild$newGuildFormView = F2($author$project$Pages$Guild$newGuildFormView$);
var $author$project$Types$PressedCloseNewPrivateKey = {$: 114};
var $author$project$Ui$Input$newPassword$ = function (attrs, pass) {
	return $author$project$Ui$Input$textHelper$(
		{
			autofill: $elm$core$Maybe$Just('new-password'),
			spellchecked: false,
			type_: $author$project$Ui$Input$TextInputNode(
				pass.show ? 'text' : 'password')
		},
		attrs,
		{label: pass.label, onChange: pass.onChange, placeholder: pass.placeholder, text: pass.text});
};
var $author$project$Ui$Input$newPassword = F2($author$project$Ui$Input$newPassword$);
var $author$project$MyUi$newPasswordCopyBox$ = function (htmlId, label2, pressedCopyText, noOp, loaded, text) {
	var label3 = $author$project$Ui$Input$label$(
		$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId) + '_textInput',
		_List_fromArray(
			[
				$author$project$Ui$Font$size(14),
				$author$project$Ui$Font$color($author$project$MyUi$font3),
				$author$project$Ui$Font$bold
			]),
		$author$project$Ui$text(label2));
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(2)
			]),
		_List_fromArray(
			[
				label3.element,
				$author$project$Ui$row$(
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Input$newPassword$(
						_List_fromArray(
							[
								$author$project$Ui$clipWithEllipsis,
								$author$project$Ui$paddingWith(
								{bottom: 2, left: 8, right: 0, top: 2}),
								$author$project$Ui$htmlAttribute(
								$elm$html$Html$Attributes$readonly(true)),
								$author$project$Ui$background(
								$author$project$Ui$rgba$(0, 0, 0, 0.2)),
								$author$project$Ui$border(1),
								$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
								$author$project$Ui$roundedWith(
								{bottomLeft: 4, bottomRight: 0, topLeft: 4, topRight: 0}),
								$author$project$Ui$height($author$project$Ui$fill)
							]),
						{
							label: label3.id,
							onChange: function (_v0) {
								return noOp;
							},
							placeholder: $elm$core$Maybe$Nothing,
							show: false,
							text: text
						}),
						$author$project$MyUi$elButton$(
						$lamdera$program_test$Effect$Browser$Dom$id(
							$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId) + '_copy'),
						pressedCopyText(text),
						_List_fromArray(
							[
								$author$project$Ui$width($author$project$Ui$shrink),
								$author$project$Ui$paddingWith(
								{bottom: 2, left: 8, right: 8, top: 2}),
								$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
								$author$project$Ui$borderWith(
								{bottom: 1, left: 0, right: 1, top: 1}),
								$author$project$Ui$roundedWith(
								{bottomLeft: 0, bottomRight: 4, topLeft: 0, topRight: 4}),
								$author$project$Ui$spacing(4),
								$author$project$Ui$background($author$project$MyUi$buttonBackground),
								$author$project$Ui$height(
								$author$project$Ui$px(40)),
								$author$project$Ui$contentCenterY
							]),
						function () {
							var _v1 = loaded.lastCopied;
							if (!_v1.$) {
								var copied = _v1.a;
								return _Utils_eq(
									copied.copied,
									$author$project$MyUi$CopiedText(text)) ? $author$project$Ui$text('Copied!') : $author$project$Ui$html(
									$author$project$Icons$copy(22));
							} else {
								return $author$project$Ui$html(
									$author$project$Icons$copy(22));
							}
						}())
					]))
			]));
};
var $author$project$MyUi$newPasswordCopyBox = F6($author$project$MyUi$newPasswordCopyBox$);
var $author$project$X25519$privateKeyToBytes = function (_v0) {
	var key = _v0;
	return $author$project$X25519$keyToBytes(key);
};
var $author$project$X25519$privateKeyToString = function (key) {
	return $elm$core$Maybe$withDefault$(
		'',
		$danfishgold$base64_bytes$Base64$fromBytes(
			$author$project$X25519$privateKeyToBytes(key)));
};
var $author$project$FrontendExtra$savePrivateKeyTitle = 'Save your private key now';
var $author$project$Ui$Input$username = $author$project$Ui$Input$textHelper(
	{
		autofill: $elm$core$Maybe$Just('username'),
		spellchecked: false,
		type_: $author$project$Ui$Input$TextInputNode('text')
	});
var $author$project$FrontendExtra$newPrivateKeyWarning$ = function (isMobile, loaded, email, privateKey) {
	var accountLabel = $author$project$Ui$Input$label$(
		'frontend_newPrivateKeyAccount',
		_List_fromArray(
			[
				$author$project$Ui$Font$size(14),
				$author$project$Ui$Font$color($author$project$MyUi$font3),
				$author$project$Ui$Font$bold
			]),
		$author$project$Ui$text('Account'));
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$behindContent(
				$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$background($author$project$MyUi$scrim),
							$author$project$Ui$height($author$project$Ui$fill)
						]),
					$author$project$Ui$none)),
				$author$project$Ui$height($author$project$Ui$fill)
			]),
		$author$project$Ui$column$(
			_List_fromArray(
				[
					$author$project$Ui$centerX,
					isMobile ? $author$project$Ui$alignBottom : $author$project$Ui$centerY,
					$author$project$Ui$attrIf$(
					!isMobile,
					$author$project$Ui$rounded(16)),
					isMobile ? $author$project$Ui$paddingXY$(16, 16) : $author$project$Ui$paddingXY$(24, 24),
					$author$project$Ui$background($author$project$MyUi$background3),
					isMobile ? $author$project$Ui$width($author$project$Ui$fill) : $author$project$Ui$widthMax(600),
					$author$project$Ui$width($author$project$Ui$shrink),
					$author$project$Ui$spacing(24),
					$author$project$Ui$borderColor($author$project$MyUi$border1),
					$author$project$Ui$border(1)
				]),
			_List_fromArray(
				[
					$author$project$Ui$column$(
					_List_fromArray(
						[
							$author$project$Ui$spacing(8)
						]),
					_List_fromArray(
						[
							$author$project$Ui$row$(
							_List_fromArray(
								[
									$author$project$Ui$Font$color($author$project$MyUi$font3),
									$author$project$Ui$spacing(16),
									$author$project$Ui$contentCenterY,
									$author$project$Ui$Font$bold
								]),
							_List_fromArray(
								[
									$author$project$Ui$html(
									$author$project$Icons$warning(36)),
									$author$project$Ui$text($author$project$FrontendExtra$savePrivateKeyTitle)
								])),
							$author$project$Ui$Prose$paragraph$(
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$text('Put this in a password manager. It is not stored anywhere else, so this is the only chance you have to save it. Without it your encrypted messages can\u0027t be decrypted.')
								]))
						])),
					$author$project$Ui$column$(
					_List_fromArray(
						[
							$author$project$Ui$spacing(12)
						]),
					_List_fromArray(
						[
							$author$project$Ui$column$(
							_List_fromArray(
								[
									$author$project$Ui$spacing(2)
								]),
							_List_fromArray(
								[
									accountLabel.element,
									A2(
									$author$project$Ui$Input$username,
									_List_fromArray(
										[
											$author$project$Ui$paddingWith(
											{bottom: 2, left: 8, right: 8, top: 2}),
											$author$project$Ui$htmlAttribute(
											$elm$html$Html$Attributes$readonly(true)),
											$author$project$Ui$background(
											$author$project$Ui$rgba$(0, 0, 0, 0.2)),
											$author$project$Ui$border(1),
											$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
											$author$project$Ui$rounded(4),
											$author$project$Ui$height(
											$author$project$Ui$px(40))
										]),
									{
										label: accountLabel.id,
										onChange: function (_v0) {
											return $author$project$Types$FrontendNoOp;
										},
										placeholder: $elm$core$Maybe$Nothing,
										text: $author$project$EmailAddress$toString(email)
									})
								])),
							$author$project$MyUi$newPasswordCopyBox$(
							$lamdera$program_test$Effect$Browser$Dom$id('frontend_newPrivateKey'),
							'Private key',
							$author$project$Types$PressedCopyText,
							$author$project$Types$FrontendNoOp,
							loaded,
							$author$project$X25519$privateKeyToString(privateKey))
						])),
					$author$project$MyUi$secondaryButton$(
					$lamdera$program_test$Effect$Browser$Dom$id('frontend_closeNewPrivateKey'),
					$author$project$Types$PressedCloseNewPrivateKey,
					'I\u0027ve saved it')
				])));
};
var $author$project$FrontendExtra$newPrivateKeyWarning = F4($author$project$FrontendExtra$newPrivateKeyWarning$);
var $author$project$Pages$Privacy$view = function (noOp) {
	return $author$project$Ui$html(
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'white-space', 'pre-wrap')
				]),
			$author$project$RichText$view$(
				$lamdera$program_test$Effect$Browser$Dom$id('privacy-page'),
				1000,
				function (_v0) {
					return noOp;
				},
				function (_v1) {
					return noOp;
				},
				function (_v2) {
					return noOp;
				},
				{
					animationMode: 0,
					attachedFiles: $lamdera$containers$SeqDict$empty,
					channels: $lamdera$containers$SeqDict$empty,
					customEmojis: $lamdera$containers$SeqDict$empty,
					devicePixelRatio: 1,
					domainWhitelist: $lamdera$containers$SeqSet$empty,
					drawingUserColor: function (_v3) {
						return $author$project$RichText$defaultColor;
					},
					drawings: $lamdera$containers$SeqDict$empty,
					embedDrawings: $lamdera$containers$SeqDict$empty,
					emojiData: $elm$core$Maybe$Nothing,
					isHovered: false,
					isSelectingAnchor: false,
					noOp: noOp,
					onPressChannelMention: F2(
						function (_v4, _v5) {
							return noOp;
						}),
					onPressCopyCode: function (_v6) {
						return noOp;
					},
					revealedSpoilers: $lamdera$containers$SeqSet$empty,
					stickers: $lamdera$containers$SeqDict$empty,
					time: $lamdera$program_test$Effect$Time$millisToPosix(0),
					timezone: $lamdera$program_test$Effect$Time$utc,
					users: $lamdera$containers$SeqDict$empty
				},
				$elm$core$Array$empty,
				$author$project$RichText$fromNonemptyString$(
					$lamdera$program_test$Effect$Time$utc,
					$lamdera$containers$SeqDict$empty,
					$lamdera$containers$SeqDict$empty,
					$MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$(
						'#',
						' Privacy policy\u000A\u000A## What is stored\u000A\u000Aat-chat stores the following sensitive data:\u000A* Your email address\u000A* Your name (should you choose to provide your real name)\u000A* Any messages you write that contain sensitive data\u000A* Any files you upload that contain sensitive data\u000A* Should you choose to use the Discord/Slack integration:\u000A      *-*  A session token with full access to your account (the setup explains the risks in more detail)\u000A      *-*  Your account\u0027s email address\u000A      *-*  Cached messages and files\u000A* Recorded calls (calls are only recorded if all participants agree to enable it)\u000A\u000A_Custom emojis and stickers are assumed to not contain any sensitive information_\u000A\u000A## What it is for\u000A\u000ASensitive data is stored in order to provide you chat app features. It is not used for marketing, advertising, AI training, and it is not sold to 3rd parties.\u000A\u000ASensitive data may be used by an administrator for the sole purpose of fixing software issues within at-chat. If this is a concern, you can [enable end-to-end encryption](' + ($author$project$Env$domain + ($author$project$Route$encode(
							$author$project$Route$HomePageRoute(
								$elm$core$Maybe$Just(0))) + (') on direct messages to restrict what is visible to an admin.\u000A\u000ASensitive data can be accessed by 3rd parties in the following ways:\u000A* [Hetzner](https://www.hetzner.com/) owns the hardware at-chat runs on. The server being rented is located in Finland.\u000A* If you use the Discord/Slack integration feature, then messages and files sent to a Discord guild, Discord user, or Slack workspace will of course be available to Discord or Slack respectively.\u000A* If someone you are writing to has enabled email notifications then your messages, profile image, and name will be sent to [Postmark](https://postmarkapp.com/) and that user\u0027s email provider.\u000A* If you have message embeds enabled then the site serving that embedded image or video can potentially store your IP address\u000A\u000A## When is it deleted\u000A\u000AYour email address, name, messages, and Discord/Slack session tokens will all be deleted when you delete your account. Account deletion takes ' + ($elm$core$String$fromInt($author$project$User$accountDeletionDelayInWeeks) + ' weeks in order to give other users a chance to export any conversations they want a personal copy of.\u000A\u000AUploaded files are deleted once they are no longer are attached to any messages. Note that this means if you attach a file to a message, and then someone duplicates your message, the file won\u0027t be deleted until both messages are deleted.\u000A\u000ABackups of the server are generated regularly. These are stored for up to 30 days before being deleted.\u000A')))))))));
};
var $author$project$Frontend$privacyPage$ = function (isMobile, loaded) {
	return $author$project$FrontendExtra$layout$(
		loaded,
		_List_fromArray(
			[
				$author$project$Ui$background($author$project$MyUi$background3),
				$author$project$Ui$inFront(
				$author$project$Pages$Home$header$(isMobile, loaded.startupData.safeAreaInsetTop, loaded.route, loaded.loginStatus))
			]),
		$author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$MyUi$notoSans,
					$author$project$Ui$scrollable,
					$author$project$Ui$heightMin(0),
					$author$project$Ui$paddingWith(
					{bottom: 32, left: 0, right: 0, top: 64})
				]),
			$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$centerX,
						$author$project$Ui$widthMax(1000),
						$author$project$Ui$paddingXY$(16, 32)
					]),
				$author$project$Pages$Privacy$view($author$project$Types$FrontendNoOp))));
};
var $author$project$Frontend$privacyPage = F2($author$project$Frontend$privacyPage$);
var $author$project$Call$PressedAnswerRecording = function (a) {
	return {$: 9, a: a};
};
var $author$project$Call$recordingNoticeView$ = function (localUser, time, local) {
	var notice = function (content) {
		return $author$project$Ui$column$(
			_List_fromArray(
				[
					$author$project$Ui$width($author$project$Ui$shrink),
					$author$project$Ui$widthMax(400),
					$author$project$Ui$centerX,
					$author$project$Ui$alignTop,
					$author$project$Ui$move(
					{x: 0, y: (localUser.safeAreaInsetTop + $author$project$MyUi$channelHeaderHeight) + 16, z: 0}),
					$author$project$Ui$padding(12),
					$author$project$Ui$spacing(12),
					$author$project$Ui$rounded(8),
					$author$project$Ui$border(1),
					$author$project$Ui$borderColor($author$project$MyUi$border1),
					$author$project$Ui$background($author$project$MyUi$background1),
					$author$project$Ui$Font$color($author$project$MyUi$font1),
					$author$project$MyUi$htmlStyle$('box-shadow', '0 4px 16px rgba(0,0,0,0.4)')
				]),
			content);
	};
	var isRecent = function (since) {
		return $ianmackenzie$elm_units$Quantity$lessThan$(
			$ianmackenzie$elm_units$Duration$seconds(8),
			$ianmackenzie$elm_units$Duration$from$(since, time));
	};
	var currentUserId = localUser.session.userId;
	var _v0 = local.currentRoom;
	if (!_v0.$) {
		var callId = _v0.a;
		var _v1 = $lamdera$containers$SeqDict$get$(callId, local.recordings);
		if (!_v1.$) {
			switch (_v1.a.$) {
				case 0:
					var asking = _v1.a.a;
					return _Utils_eq(asking.requestedBy, currentUserId) ? notice(
						_List_fromArray(
							[
								$author$project$Ui$text('Asking everyone if this call can be recorded…')
							])) : ($lamdera$containers$SeqSet$member$(currentUserId, asking.allowedBy) ? notice(
						_List_fromArray(
							[
								$author$project$Ui$text('Waiting for everyone else to allow recording…')
							])) : notice(
						_List_fromArray(
							[
								$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$Font$bold,
										$author$project$MyUi$htmlStyle$('word-break', 'break-all')
									]),
								$author$project$Ui$text(
									$author$project$User$toStringAlt$(asking.requestedBy, localUser) + ' wants to record this call')),
								$author$project$Ui$Prose$paragraph$(
								_List_fromArray(
									[
										$author$project$Ui$Font$size(14)
									]),
								_List_fromArray(
									[
										$author$project$Ui$text('Cameras, microphones, and any screen sharing will be recorded.')
									])),
								$author$project$Ui$row$(
								_List_fromArray(
									[
										$author$project$Ui$spacing(8)
									]),
								_List_fromArray(
									[
										$author$project$MyUi$simpleButton$(
										$lamdera$program_test$Effect$Browser$Dom$id('voiceChat_allowRecording'),
										$author$project$Call$PressedAnswerRecording(true),
										$author$project$Ui$text('Allow')),
										$author$project$MyUi$secondaryButtonTall$(
										$lamdera$program_test$Effect$Browser$Dom$id('voiceChat_declineRecording'),
										$author$project$Call$PressedAnswerRecording(false),
										'Decline')
									]))
							])));
				case 1:
					var declined = _v1.a.a;
					return isRecent(declined.declinedAt) ? notice(
						_List_fromArray(
							[
								$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$MyUi$htmlStyle$('word-break', 'break-all')
									]),
								function () {
									var _v2 = declined.declinedBy;
									if (!_v2.$) {
										var declinedBy = _v2.a;
										return _Utils_eq(declinedBy, currentUserId) ? $author$project$Ui$text('Recording wasn\u0027t started because you declined') : $author$project$Ui$text(
											'Recording wasn\u0027t started because ' + ($author$project$User$toStringAlt$(declinedBy, localUser) + ' declined'));
									} else {
										return $author$project$Ui$text('Recording wasn\u0027t started because not everyone answered in time');
									}
								}())
							])) : $author$project$Ui$none;
				default:
					var since = _v1.a.a;
					return isRecent(since) ? notice(
						_List_fromArray(
							[
								$author$project$Ui$text('This call is now being recorded')
							])) : $author$project$Ui$none;
			}
		} else {
			return $author$project$Ui$none;
		}
	} else {
		return $author$project$Ui$none;
	}
};
var $author$project$Call$recordingNoticeView = F3($author$project$Call$recordingNoticeView$);
var $author$project$Call$megabytes = function (bytes) {
	return $elm$core$String$fromFloat(
		$elm$core$Basics$round((bytes / (1024 * 1024)) * 10) / 10);
};
var $author$project$Call$recordingUploadView$ = function (localUser, model) {
	var _v0 = model.recordingUpload;
	if (!_v0.$) {
		var progress = _v0.a;
		var filled = (progress.total > 0) ? $elm$core$Basics$clamp$(0, 1000, ((progress.uploaded * 1000) / progress.total) | 0) : 0;
		return $author$project$Ui$column$(
			_List_fromArray(
				[
					$author$project$Ui$id('voiceChat_recordingUpload'),
					$author$project$Ui$width($author$project$Ui$shrink),
					$author$project$Ui$widthMax(400),
					$author$project$Ui$centerX,
					$author$project$Ui$alignTop,
					$author$project$Ui$move(
					{x: 0, y: localUser.safeAreaInsetTop + 8, z: 0}),
					$author$project$Ui$padding(12),
					$author$project$Ui$spacing(8),
					$author$project$Ui$rounded(8),
					$author$project$Ui$border(1),
					$author$project$Ui$borderColor($author$project$MyUi$border1),
					$author$project$Ui$background($author$project$MyUi$background1),
					$author$project$Ui$Font$color($author$project$MyUi$font1),
					$author$project$MyUi$htmlStyle$('box-shadow', '0 4px 16px rgba(0,0,0,0.4)')
				]),
			_List_fromArray(
				[
					$author$project$Ui$el$(
					_List_fromArray(
						[$author$project$Ui$Font$bold]),
					$author$project$Ui$text(
						'Uploading recording (' + ($author$project$Call$megabytes(progress.uploaded) + (' of ' + ($author$project$Call$megabytes(progress.total) + ' MB)'))))),
					$author$project$Ui$Prose$paragraph$(
					_List_fromArray(
						[
							$author$project$Ui$Font$size(14)
						]),
					_List_fromArray(
						[
							$author$project$Ui$text('Please leave this page open until it\u0027s finished (if closed, uploading will be paused until reopened).')
						])),
					$author$project$Ui$row$(
					_List_fromArray(
						[
							$author$project$Ui$height(
							$author$project$Ui$px(6)),
							$author$project$Ui$rounded(3),
							$author$project$Ui$clip,
							$author$project$Ui$background($author$project$MyUi$background3)
						]),
					_List_fromArray(
						[
							$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$width(
									$author$project$Ui$portion(filled)),
									$author$project$Ui$height($author$project$Ui$fill),
									$author$project$Ui$background($author$project$MyUi$buttonBackground)
								]),
							$author$project$Ui$none),
							$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$width(
									$author$project$Ui$portion(1000 - filled))
								]),
							$author$project$Ui$none)
						]))
				]));
	} else {
		return $author$project$Ui$none;
	}
};
var $author$project$Call$recordingUploadView = F2($author$project$Call$recordingUploadView$);
var $author$project$Pages$Guild$slackChannelColumnRow$ = function (isMobile, isMuted, hasNotifications, routeData, channelId, channel) {
	var isSelected = function () {
		var _v0 = routeData.channelRoute;
		if (!_v0.$) {
			if (!_v0.b.$) {
				var selectedChannelId = _v0.a;
				return _Utils_eq(selectedChannelId, channelId);
			} else {
				var _v1 = _v0.b;
				return false;
			}
		} else {
			return false;
		}
	}();
	return $author$project$GuildColumn$rowLinkButton$(
		$lamdera$program_test$Effect$Browser$Dom$id(
			'guild_openSlackChannel_' + $author$project$Slack$idToString(channelId)),
		$author$project$Route$SlackWorkspaceRoute(
			{
				channelRoute: $author$project$Route$SlackChannel_ChannelRoute$(
					channelId,
					$author$project$Id$NoThreadWithMaybeMessage($elm$core$Maybe$Nothing),
					1),
				channelsVisible: 0,
				currentSlackUserId: routeData.currentSlackUserId,
				overlay: $elm$core$Maybe$Nothing,
				teamId: routeData.teamId
			}),
		_List_fromArray(
			[
				$author$project$Ui$paddingWith(
				{bottom: 0, left: 26, right: 8, top: 0}),
				$author$project$Ui$inFront(
				$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$GuildIcon$notificationView$(
							0,
							-3,
							$author$project$MyUi$background2,
							(isSelected && (!isMobile)) ? $author$project$GuildIcon$NoNotification : hasNotifications),
							$author$project$Ui$width(
							$author$project$Ui$px(20)),
							$author$project$Ui$move(
							{x: 4, y: 0, z: 0}),
							$author$project$Ui$centerY
						]),
					$author$project$Ui$html($author$project$Icons$hashtag))),
				isSelected ? $author$project$Ui$Font$color($author$project$MyUi$font1) : $author$project$Ui$Font$color($author$project$MyUi$font3),
				$author$project$MyUi$hover$(
				isMobile,
				_List_fromArray(
					[
						$author$project$Ui$Anim$fontColor($author$project$MyUi$font1)
					])),
				$author$project$Ui$attrIf$(
				isSelected,
				$author$project$Ui$background($author$project$MyUi$selectedHighlight)),
				$author$project$Ui$clipWithEllipsis,
				$author$project$Ui$height(
				$author$project$Ui$px($author$project$MyUi$channelHeaderHeight)),
				$author$project$MyUi$hoverText(
				$author$project$ChannelName$toString(channel.name)),
				$author$project$Ui$contentCenterY,
				$author$project$MyUi$noShrinking
			]),
		_List_fromArray(
			[
				$author$project$Ui$text(
				$author$project$ChannelName$toString(channel.name)),
				$author$project$Pages$Guild$channelIsMuted(isMuted)
			]));
};
var $author$project$Pages$Guild$slackChannelColumnRow = F6($author$project$Pages$Guild$slackChannelColumnRow$);
var $author$project$Pages$Guild$slackChannelColumnThreads$ = function (isMobile, now, routeData, directMentions, localUser, channels, channelId, channel, threads) {
	var threads2 = $elm$core$List$filterMap$(
		function (_v2) {
			var threadMessageIndex = _v2.a;
			var thread = _v2.b;
			var isSelected = function () {
				var _v4 = routeData.channelRoute;
				if (!_v4.$) {
					if (_v4.b.$ === 1) {
						var selectedChannelId = _v4.a;
						var _v5 = _v4.b;
						var threadId = _v5.a;
						return _Utils_eq(selectedChannelId, channelId) && _Utils_eq(threadId, threadMessageIndex);
					} else {
						return false;
					}
				} else {
					return false;
				}
			}();
			var isMuted = $author$project$MuteSettings$isSlackChannelMuted$(
				localUser.user.muteSettings,
				routeData.teamId,
				channelId,
				$author$project$Id$ViewThread(threadMessageIndex));
			var hasNotifications = $author$project$GuildColumn$channelOrThreadHasNotifications$(
				isMuted,
				directMentions,
				$lamdera$containers$SeqSet$member$(routeData.teamId, localUser.user.slackNotifyOnAllMessages),
				channelId,
				$author$project$Id$ViewThread(threadMessageIndex),
				$lamdera$containers$SeqDict$get$(
					_Utils_Tuple2(
						$author$project$Id$SlackGuildOrDmId(
							$author$project$Id$SlackGuildOrDmId_Workspace(
								{channelId: channelId, currentUserId: routeData.currentSlackUserId, teamId: routeData.teamId})),
						threadMessageIndex),
					localUser.user.lastViewedThreadMessage),
				thread);
			if (isSelected || (!_Utils_eq(hasNotifications, $author$project$GuildIcon$NoNotification))) {
				return $elm$core$Maybe$Just(
					_Utils_Tuple3(
						threadMessageIndex,
						_Utils_Tuple2(isMuted, hasNotifications),
						isSelected));
			} else {
				var _v3 = $author$project$MessageArray$last(thread.messages);
				if (!_v3.$) {
					var message = _v3.a;
					return $ianmackenzie$elm_units$Quantity$lessThan$(
						$ianmackenzie$elm_units$Duration$week,
						$ianmackenzie$elm_units$Duration$from$(
							$author$project$Message$createdAt(message),
							now)) ? $elm$core$Maybe$Just(
						_Utils_Tuple3(
							threadMessageIndex,
							_Utils_Tuple2(isMuted, hasNotifications),
							isSelected)) : $elm$core$Maybe$Nothing;
				} else {
					return $elm$core$Maybe$Just(
						_Utils_Tuple3(
							threadMessageIndex,
							_Utils_Tuple2(isMuted, hasNotifications),
							isSelected));
				}
			}
		},
		$lamdera$containers$SeqDict$toList(threads));
	var count = $elm$core$List$length(threads2);
	return $author$project$Ui$column$(
		_List_Nil,
		$elm$core$List$indexedMap$(
			F2(
				function (index, _v0) {
					var threadMessageIndex = _v0.a;
					var _v1 = _v0.b;
					var isMuted = _v1.a;
					var hasNotifications = _v1.b;
					var isSelected = _v0.c;
					return $author$project$Pages$Guild$channelColumnThreadsHelper$(
						isMobile,
						isSelected,
						isMuted,
						hasNotifications,
						index,
						count,
						$lamdera$program_test$Effect$Browser$Dom$id(
							'guild_viewThread_' + ($author$project$Slack$idToString(channelId) + ('_' + $author$project$Id$toString(threadMessageIndex)))),
						$author$project$Route$SlackWorkspaceRoute(
							{
								channelRoute: $author$project$Route$SlackChannel_ChannelRoute$(
									channelId,
									$author$project$Id$ViewThreadWithMaybeMessage$(threadMessageIndex, $elm$core$Maybe$Nothing),
									1),
								channelsVisible: 0,
								currentSlackUserId: routeData.currentSlackUserId,
								overlay: $elm$core$Maybe$Nothing,
								teamId: routeData.teamId
							}),
						$author$project$Pages$Guild$threadPreviewText$(localUser.timezone, localUser.slackUsers, channels, threadMessageIndex, $lamdera$containers$SeqDict$empty, channel));
				}),
			threads2));
};
var $author$project$Pages$Guild$slackChannelColumnThreads = F9($author$project$Pages$Guild$slackChannelColumnThreads$);
var $author$project$Pages$Guild$slackWorkspaceSettingsButtonId = $lamdera$program_test$Effect$Browser$Dom$id('guild_slackWorkspaceSettings');
var $author$project$Pages$Guild$slackChannelColumn$ = function (isMobile, canScroll2, time, localUser, routeData, workspace) {
	var directMentions = $lamdera$containers$SeqDict$get$(routeData.teamId, localUser.user.slackDirectMentions);
	var channelNames = $lamdera$containers$SeqDict$foldl$(
		F3(
			function (channelId, channel, dict) {
				return $lamdera$containers$SeqDict$insert$(
					_Utils_Tuple2(channelId, $elm$core$Maybe$Nothing),
					{
						name: $author$project$ChannelName$toString(channel.name)
					},
					dict);
			}),
		$lamdera$containers$SeqDict$empty,
		workspace.channels);
	return $author$project$Pages$Guild$channelColumnContainer$(
		localUser.safeAreaInsetTop,
		_List_fromArray(
			[
				$author$project$GuildColumn$rowLinkButton$(
				$author$project$Pages$Guild$slackWorkspaceSettingsButtonId,
				$author$project$Route$SlackWorkspaceRoute(
					{channelRoute: $author$project$Route$SlackChannel_WorkspaceSettingsRoute, channelsVisible: 0, currentSlackUserId: routeData.currentSlackUserId, overlay: $elm$core$Maybe$Nothing, teamId: routeData.teamId}),
				_List_fromArray(
					[
						$author$project$Ui$Font$color($author$project$MyUi$font2),
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$contentCenterY,
						$author$project$Ui$spacing(6),
						$author$project$MyUi$hoverText(workspace.name)
					]),
				_List_fromArray(
					[
						$author$project$Ui$html(
						$author$project$Icons$slack(16)),
						$author$project$Ui$text(workspace.name)
					])),
				$author$project$Pages$Guild$searchIcon(isMobile)
			]),
		$author$project$Ui$column$(
			_List_fromArray(
				[
					$author$project$MyUi$scrollable(canScroll2),
					$author$project$Ui$heightMin(0),
					$author$project$Ui$paddingXY$(0, 8),
					$author$project$Ui$attrIf$(
					isMobile,
					$author$project$Ui$height($author$project$Ui$fill)),
					$author$project$MyUi$bounceScroll(isMobile)
				]),
			$elm$core$List$map$(
				$elm$core$Tuple$second,
				A2(
					$elm$core$List$sortBy,
					$elm$core$Tuple$first,
					$elm$core$List$map$(
						function (_v0) {
							var channelId = _v0.a;
							var channel = _v0.b;
							var guildOrDmId = $author$project$Id$SlackGuildOrDmId(
								$author$project$Id$SlackGuildOrDmId_Workspace(
									{channelId: channelId, currentUserId: routeData.currentSlackUserId, teamId: routeData.teamId}));
							var threadNotifications = $elm$core$List$map$(
								function (_v3) {
									var threadId = _v3.a;
									var thread = _v3.b;
									return $author$project$GuildColumn$channelOrThreadHasNotifications$(
										$author$project$MuteSettings$isSlackChannelMuted$(
											localUser.user.muteSettings,
											routeData.teamId,
											channelId,
											$author$project$Id$ViewThread(threadId)),
										directMentions,
										$lamdera$containers$SeqSet$member$(routeData.teamId, localUser.user.slackNotifyOnAllMessages),
										channelId,
										$author$project$Id$ViewThread(threadId),
										$lamdera$containers$SeqDict$get$(
											_Utils_Tuple2(guildOrDmId, threadId),
											localUser.user.lastViewedThreadMessage),
										thread);
								},
								$lamdera$containers$SeqDict$toList(channel.threads));
							var channelMuted = $author$project$MuteSettings$isSlackChannelMuted$(localUser.user.muteSettings, routeData.teamId, channelId, $author$project$Id$NoThread);
							var hasNotifications = $author$project$GuildColumn$channelOrThreadHasNotifications$(
								channelMuted,
								directMentions,
								$lamdera$containers$SeqSet$member$(routeData.teamId, localUser.user.slackNotifyOnAllMessages),
								channelId,
								$author$project$Id$NoThread,
								$lamdera$containers$SeqDict$get$(guildOrDmId, localUser.user.lastViewedMessage),
								channel);
							return _Utils_Tuple2(
								$author$project$Pages$Guild$channelSortName$(
									A2($elm$core$List$cons, hasNotifications, threadNotifications),
									channel),
								$author$project$Ui$column$(
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Pages$Guild$slackChannelColumnRow$(isMobile, channelMuted, hasNotifications, routeData, channelId, channel),
											$author$project$Pages$Guild$slackChannelColumnThreads$(
											isMobile,
											$elm$time$Time$millisToPosix(time),
											routeData,
											directMentions,
											localUser,
											channelNames,
											channelId,
											channel,
											function () {
												var _v1 = routeData.channelRoute;
												if (!_v1.$) {
													if (_v1.b.$ === 1) {
														var selectedChannelId = _v1.a;
														var _v2 = _v1.b;
														var threadId = _v2.a;
														return _Utils_eq(selectedChannelId, channelId) ? $lamdera$containers$SeqDict$update$(
															threadId,
															function (maybeThread) {
																return $elm$core$Maybe$Just(
																	$elm$core$Maybe$withDefault$($author$project$Thread$frontendInit, maybeThread));
															},
															channel.threads) : channel.threads;
													} else {
														return channel.threads;
													}
												} else {
													return channel.threads;
												}
											}())
										])));
						},
						$lamdera$containers$SeqDict$toList(workspace.channels))))));
};
var $author$project$Pages$Guild$slackChannelColumn = F6($author$project$Pages$Guild$slackChannelColumn$);
var $author$project$Types$PressedMuteSlackChannel$ = function (a, b, c, d) {
	return {$: 181, a: a, b: b, c: c, d: d};
};
var $author$project$Types$PressedMuteSlackChannel = F4($author$project$Types$PressedMuteSlackChannel$);
var $author$project$Types$PressedMuteSlackThread$ = function (a, b, c, d, e) {
	return {$: 182, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Types$PressedMuteSlackThread = F5($author$project$Types$PressedMuteSlackThread$);
var $author$project$MuteSettings$isSlackChannelSpecificallyMuted$ = function (model, teamId, channelId) {
	var _v0 = $lamdera$containers$SeqDict$get$(teamId, model.mutedSlackWorkspaces);
	if (!_v0.$) {
		var workspace = _v0.a;
		var _v1 = $lamdera$containers$SeqDict$get$(channelId, workspace.channels);
		if (!_v1.$) {
			var channel = _v1.a;
			return channel.mutedChannel;
		} else {
			return 0;
		}
	} else {
		return 0;
	}
};
var $author$project$MuteSettings$isSlackChannelSpecificallyMuted = F3($author$project$MuteSettings$isSlackChannelSpecificallyMuted$);
var $author$project$MuteSettings$isSlackThreadSpecificallyMuted$ = function (model, teamId, channelId, threadId) {
	var _v0 = $lamdera$containers$SeqDict$get$(teamId, model.mutedSlackWorkspaces);
	if (!_v0.$) {
		var workspace = _v0.a;
		var _v1 = $lamdera$containers$SeqDict$get$(channelId, workspace.channels);
		if (!_v1.$) {
			var channel = _v1.a;
			return $elm$core$Maybe$withDefault$(
				0,
				$lamdera$containers$SeqDict$get$(threadId, channel.mutedThreads));
		} else {
			return 0;
		}
	} else {
		return 0;
	}
};
var $author$project$MuteSettings$isSlackThreadSpecificallyMuted = F4($author$project$MuteSettings$isSlackThreadSpecificallyMuted$);
var $author$project$Pages$Guild$slackChannelSettingsForm$ = function (localUser, currentSlackUserId, teamId, channelId, threadRoute) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$Font$color($author$project$MyUi$font1),
				$author$project$Ui$padding(8)
			]),
		function () {
			if (!threadRoute.$) {
				return $author$project$MuteSettings$view$(
					A3($author$project$Types$PressedMuteSlackChannel, currentSlackUserId, teamId, channelId),
					$author$project$MuteSettings$isSlackChannelSpecificallyMuted$(localUser.user.muteSettings, teamId, channelId));
			} else {
				var threadId = threadRoute.a;
				return $author$project$MuteSettings$view$(
					A4($author$project$Types$PressedMuteSlackThread, currentSlackUserId, teamId, channelId, threadId),
					$author$project$MuteSettings$isSlackThreadSpecificallyMuted$(localUser.user.muteSettings, teamId, channelId, threadId));
			}
		}());
};
var $author$project$Pages$Guild$slackChannelSettingsForm = F5($author$project$Pages$Guild$slackChannelSettingsForm$);
var $author$project$Pages$Guild$slackChannelSettingsMobile$ = function (canScroll2, localUser, currentSlackUserId, teamId, channelId, threadRoute) {
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$height($author$project$Ui$fill)
			]),
		_List_fromArray(
			[
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$contentCenterY,
						$author$project$Ui$borderWith(
						{bottom: 1, left: 0, right: 0, top: 0}),
						$author$project$Ui$borderColor($author$project$MyUi$border2),
						$author$project$Ui$background($author$project$MyUi$background3),
						$author$project$Ui$height(
						$author$project$Ui$px($author$project$MyUi$channelHeaderHeight)),
						$author$project$MyUi$noShrinking
					]),
				_List_fromArray(
					[
						$author$project$ChannelHeader$headerBackButton$(
						$lamdera$program_test$Effect$Browser$Dom$id('guild_memberColumnBack'),
						$author$project$Types$PressedMemberListBack),
						function () {
						if (threadRoute.$ === 1) {
							return $author$project$Ui$text('Thread settings');
						} else {
							return $author$project$Ui$text('Channel settings');
						}
					}()
					])),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$background($author$project$MyUi$background2),
						$author$project$Ui$Font$color($author$project$MyUi$font1),
						$author$project$Ui$paddingWith(
						{bottom: localUser.safeAreaInsetBottom + 16, left: 0, right: 0, top: 16}),
						$author$project$MyUi$scrollable(canScroll2),
						$author$project$Ui$heightMin(0)
					]),
				_List_fromArray(
					[
						$author$project$Pages$Guild$slackChannelSettingsForm$(localUser, currentSlackUserId, teamId, channelId, threadRoute)
					]))
			]));
};
var $author$project$Pages$Guild$slackChannelSettingsMobile = F6($author$project$Pages$Guild$slackChannelSettingsMobile$);
var $author$project$Pages$Guild$slackChannelSettingsNotMobile$ = function (localUser, currentSlackUserId, teamId, channelId, threadRoute) {
	return $author$project$Pages$Guild$memberColumnContainerNotMobile$(
		function () {
			if (!threadRoute.$) {
				return false;
			} else {
				return true;
			}
		}(),
		_List_fromArray(
			[
				$author$project$Pages$Guild$slackChannelSettingsForm$(localUser, currentSlackUserId, teamId, channelId, threadRoute)
			]));
};
var $author$project$Pages$Guild$slackChannelSettingsNotMobile = F5($author$project$Pages$Guild$slackChannelSettingsNotMobile$);
var $author$project$Types$PressedMuteSlackWorkspace$ = function (a, b, c) {
	return {$: 180, a: a, b: b, c: c};
};
var $author$project$Types$PressedMuteSlackWorkspace = F3($author$project$Types$PressedMuteSlackWorkspace$);
var $author$project$Types$PressedSlackWorkspaceNotificationLevel$ = function (a, b, c) {
	return {$: 107, a: a, b: b, c: c};
};
var $author$project$Types$PressedSlackWorkspaceNotificationLevel = F3($author$project$Types$PressedSlackWorkspaceNotificationLevel$);
var $author$project$Pages$Guild$slackNotificationLevelId = $lamdera$program_test$Effect$Browser$Dom$id('guild_slackNotificationLevel');
var $author$project$Pages$Guild$slackWorkspaceSettingsView$ = function (model, currentUserId, teamId, local) {
	var isMobile = $author$project$MyUi$isMobile(model);
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$Ui$Font$color($author$project$MyUi$font1)
			]),
		_List_fromArray(
			[
				$author$project$ChannelHeader$channelHeader$(
				isMobile,
				$author$project$Ui$text('Workspace settings'),
				$elm$core$Maybe$Nothing),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(16),
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$heightMin(0),
						$author$project$MyUi$scrollable(
						$author$project$MyUi$canScroll$(isMobile, model.drag)),
						$author$project$Ui$paddingWith(
						{bottom: local.localUser.safeAreaInsetBottom + 16, left: 0, right: 0, top: 16})
					]),
				_List_fromArray(
					[
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$(16, 0)
							]),
						$author$project$MyUi$radioColumn$(
							$author$project$Pages$Guild$slackNotificationLevelId,
							A2($author$project$Types$PressedSlackWorkspaceNotificationLevel, currentUserId, teamId),
							$lamdera$containers$SeqSet$member$(teamId, local.localUser.user.slackNotifyOnAllMessages) ? $elm$core$Maybe$Just(0) : $elm$core$Maybe$Just(1),
							$author$project$Ui$text('Workspace notifications'),
							_List_fromArray(
								[
									_Utils_Tuple2(1, 'Only when mentioned'),
									_Utils_Tuple2(0, 'On every message')
								]))),
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$(16, 0)
							]),
						$author$project$MuteSettings$view$(
							A2($author$project$Types$PressedMuteSlackWorkspace, currentUserId, teamId),
							$author$project$MuteSettings$isSlackWorkspaceSpecificallyMuted$(local.localUser.user.muteSettings, teamId)))
					]))
			]));
};
var $author$project$Pages$Guild$slackWorkspaceSettingsView = F4($author$project$Pages$Guild$slackWorkspaceSettingsView$);
var $author$project$Pages$Guild$slackChannelView$ = function (routeData, workspace, loggedIn, local, model) {
	var _v0 = routeData.channelRoute;
	if (!_v0.$) {
		var channelId = _v0.a;
		var threadRoute = _v0.b;
		var _v1 = $lamdera$containers$SeqDict$get$(channelId, workspace.channels);
		if (!_v1.$) {
			var channel = _v1.a;
			var guildOrDmId = $author$project$Id$SlackGuildOrDmId_Workspace(
				{channelId: channelId, currentUserId: routeData.currentSlackUserId, teamId: routeData.teamId});
			if (!threadRoute.$) {
				var maybeMessageId = threadRoute.a;
				return $author$project$Pages$Guild$slackConversationView$(
					routeData.currentSlackUserId,
					guildOrDmId,
					maybeMessageId,
					loggedIn,
					model,
					local,
					$author$project$ChannelName$toString(channel.name),
					channel);
			} else {
				var threadId = threadRoute.a;
				var maybeMessageId = threadRoute.b;
				return $author$project$Pages$Guild$slackThreadConversationView$(
					routeData.currentSlackUserId,
					guildOrDmId,
					threadId,
					maybeMessageId,
					loggedIn,
					model,
					local,
					$author$project$ChannelName$toString(channel.name),
					channel);
			}
		} else {
			return $author$project$Pages$Guild$pageMissing($author$project$Pages$Guild$channelDoesNotExistText);
		}
	} else {
		return $author$project$Pages$Guild$slackWorkspaceSettingsView$(model, routeData.currentSlackUserId, routeData.teamId, local);
	}
};
var $author$project$Pages$Guild$slackChannelView = F5($author$project$Pages$Guild$slackChannelView$);
var $author$project$Pages$Guild$slackWorkspaceView$ = function (model, routeData, loggedIn, local) {
	var _v0 = loggedIn.showFileToUploadInfo;
	if (!_v0.$) {
		var fileData = _v0.a;
		return $author$project$FileStatus$imageInfoView$(local.localUser.safeAreaInsetTop, local.localUser.safeAreaInsetBottom, model.timezone, $author$project$Types$PressedCloseImageInfo, fileData);
	} else {
		var _v1 = $lamdera$containers$SeqDict$get$(routeData.teamId, local.slackWorkspaces);
		if (!_v1.$) {
			var workspace = _v1.a;
			return $author$project$MyUi$isMobile(model) ? $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$background($author$project$MyUi$background1),
						$author$project$Ui$heightMin(0),
						$author$project$MyUi$unscrollable,
						$author$project$Ui$inFront(
						function () {
							var _v2 = _Utils_Tuple2(
								$author$project$Route$toShowMembersTabVisible$(loggedIn, model.route),
								routeData.channelRoute);
							if (!_v2.a.a) {
								if (!_v2.b.$) {
									var _v3 = _v2.a;
									var _v4 = _v3.a;
									var _v5 = _v2.b;
									var channelId = _v5.a;
									var threadRoute = _v5.b;
									return $author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$height($author$project$Ui$fill),
												$author$project$Ui$background($author$project$MyUi$background3),
												$author$project$Ui$paddingWith(
												{bottom: 0, left: 0, right: 0, top: local.localUser.safeAreaInsetTop}),
												$author$project$Ui$move(
												{
													x: $author$project$Call$memberColumnOffset$(loggedIn.sidebarMode, model),
													y: 0,
													z: 0
												}),
												$author$project$Ui$heightMin(0)
											]),
										$author$project$Ui$Lazy$lazy6$(
											$author$project$Pages$Guild$slackChannelSettingsMobile,
											$author$project$MyUi$canScroll$(true, model.drag),
											local.localUser,
											routeData.currentSlackUserId,
											routeData.teamId,
											channelId,
											threadRoute));
								} else {
									var _v6 = _v2.a;
									var _v7 = _v6.a;
									var _v8 = _v2.b;
									return $author$project$Ui$none;
								}
							} else {
								var _v9 = _v2.a;
								var _v10 = _v9.a;
								return $author$project$Ui$none;
							}
						}()),
						$author$project$Ui$inFront(
						$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$height($author$project$Ui$fill),
									$author$project$Ui$background($author$project$MyUi$background3),
									$author$project$Ui$paddingWith(
									{bottom: 0, left: 0, right: 0, top: local.localUser.safeAreaInsetTop}),
									$author$project$Ui$move(
									{
										x: $author$project$Call$conversationOffset$(loggedIn.sidebarMode, model),
										y: 0,
										z: 0
									}),
									$author$project$Ui$heightMin(0)
								]),
							$author$project$Pages$Guild$slackChannelView$(routeData, workspace, loggedIn, local, model)))
					]),
				_List_fromArray(
					[
						$author$project$Ui$row$(
						_List_fromArray(
							[
								$author$project$Ui$height($author$project$Ui$fill),
								$author$project$Ui$heightMin(0),
								$author$project$MyUi$htmlStyle$('isolation', 'isolate')
							]),
						_List_fromArray(
							[
								$author$project$GuildColumn$guildColumnLazy$(true, model, local),
								$author$project$Ui$Lazy$lazy6$(
								$author$project$Pages$Guild$slackChannelColumn,
								true,
								$author$project$MyUi$canScroll$(true, model.drag),
								$author$project$Pages$Guild$nearestHour(model.time),
								local.localUser,
								routeData,
								workspace)
							])),
						$author$project$Ui$Lazy$lazy$($author$project$Pages$Guild$loggedInAsView, local.localUser)
					])) : $author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$background($author$project$MyUi$background1)
					]),
				_List_fromArray(
					[
						$author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$height($author$project$Ui$fill),
								$author$project$Ui$width(
								$author$project$Ui$px(
									$author$project$MyUi$channelAndGuildColumnWidth(model.windowSize)))
							]),
						_List_fromArray(
							[
								$author$project$Ui$row$(
								_List_fromArray(
									[
										$author$project$Ui$height($author$project$Ui$fill),
										$author$project$Ui$heightMin(0)
									]),
								_List_fromArray(
									[
										$author$project$GuildColumn$guildColumnLazy$(false, model, local),
										$author$project$Ui$Lazy$lazy6$(
										$author$project$Pages$Guild$slackChannelColumn,
										false,
										true,
										$author$project$Pages$Guild$nearestHour(model.time),
										local.localUser,
										routeData,
										workspace)
									])),
								$author$project$Ui$Lazy$lazy$($author$project$Pages$Guild$loggedInAsView, local.localUser)
							])),
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$height($author$project$Ui$fill),
								$author$project$Ui$paddingWith(
								{bottom: 0, left: 0, right: 0, top: local.localUser.safeAreaInsetTop})
							]),
						$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$height($author$project$Ui$fill),
									$author$project$Ui$background($author$project$MyUi$background3),
									$author$project$Ui$heightMin(0),
									$author$project$Ui$borderColor($author$project$MyUi$border1),
									$author$project$Ui$borderWith(
									{bottom: 0, left: 0, right: 0, top: 1})
								]),
							$author$project$Pages$Guild$slackChannelView$(routeData, workspace, loggedIn, local, model))),
						function () {
						var _v11 = _Utils_Tuple2(
							$author$project$Route$toShowMembersTabVisible$(loggedIn, model.route),
							routeData.channelRoute);
						if (!_v11.a.a) {
							if (!_v11.b.$) {
								var _v12 = _v11.a;
								var _v13 = _v12.a;
								var _v14 = _v11.b;
								var channelId = _v14.a;
								var threadRoute = _v14.b;
								return $author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$width($author$project$Ui$shrink),
											$author$project$Ui$height($author$project$Ui$fill),
											$author$project$Ui$paddingWith(
											{bottom: 0, left: 0, right: 0, top: local.localUser.safeAreaInsetTop})
										]),
									$author$project$Ui$Lazy$lazy5$($author$project$Pages$Guild$slackChannelSettingsNotMobile, local.localUser, routeData.currentSlackUserId, routeData.teamId, channelId, threadRoute));
							} else {
								var _v15 = _v11.a;
								var _v16 = _v15.a;
								var _v17 = _v11.b;
								return $author$project$Ui$none;
							}
						} else {
							var _v18 = _v11.a;
							var _v19 = _v18.a;
							return $author$project$Ui$none;
						}
					}()
					]));
		} else {
			return $author$project$Pages$Guild$guildErrorPage$('Slack workspace not found', local, model);
		}
	}
};
var $author$project$Pages$Guild$slackWorkspaceView = F4($author$project$Pages$Guild$slackWorkspaceView$);
var $author$project$Go$Spectator_PressedCell = function (a) {
	return {$: 3, a: a};
};
var $elm$core$Maybe$map2$ = function (func, ma, mb) {
	if (ma.$ === 1) {
		return $elm$core$Maybe$Nothing;
	} else {
		var a = ma.a;
		if (mb.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var b = mb.a;
			return $elm$core$Maybe$Just(
				A2(func, a, b));
		}
	}
};
var $elm$core$Maybe$map2 = F3($elm$core$Maybe$map2$);
var $author$project$Go$getPlayersWithUser = function (data) {
	var _v0 = data.setup.gameCreatorPlayingAs;
	if (_v0 === 1) {
		return {
			black: $elm$core$Maybe$map2$($elm$core$Tuple$pair, data.cache.joinedUserId, data.joinedUser),
			white: $elm$core$Maybe$Just(
				_Utils_Tuple2(data.setup.createdBy, data.creatorUser))
		};
	} else {
		return {
			black: $elm$core$Maybe$Just(
				_Utils_Tuple2(data.setup.createdBy, data.creatorUser)),
			white: $elm$core$Maybe$map2$($elm$core$Tuple$pair, data.cache.joinedUserId, data.joinedUser)
		};
	}
};
var $author$project$Go$spectatorView$ = function (currentTime, windowSize, data, model) {
	var state = data.cache;
	var players = $author$project$Go$getPlayersWithUser(data);
	var isMobile = $author$project$MyUi$isMobileAlt(windowSize);
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(
				isMobile ? 8 : 16),
				$author$project$Ui$paddingXY$(
				0,
				isMobile ? 8 : 16),
				$author$project$Ui$background($author$project$MyUi$background1)
			]),
		_List_fromArray(
			[
				$author$project$Go$statusView$(currentTime, state),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$width($author$project$Ui$shrink),
						$author$project$Ui$background($author$project$Go$boardColor),
						$author$project$Ui$rounded(4)
					]),
				_List_fromArray(
					[
						$author$project$Go$clockView$(currentTime, players.black, players.white, state, data.setup),
						A2(
						$author$project$Ui$map,
						$author$project$Go$Spectator_PressedCell,
						$author$project$Ui$Lazy$lazy4$($author$project$Go$boardView, windowSize, data.setup, state, model))
					])),
				isMobile ? $author$project$Ui$none : $author$project$Go$historyView$(state, model)
			]));
};
var $author$project$Go$spectatorView = F4($author$project$Go$spectatorView$);
var $author$project$Call$CameraTile = function (a) {
	return {$: 0, a: a};
};
var $author$project$Call$ScreenShareTile = function (a) {
	return {$: 1, a: a};
};
var $author$project$Call$VideoNodeFullSize = 2;
var $author$project$Call$VideoNodeHidden = 0;
var $author$project$Call$VideoNodeThumbnail = 1;
var $author$project$Call$debugRowView = function (debugRow) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'gap', '8px')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'flex', '0 0 45%'),
						A2($elm$html$Html$Attributes$style, 'color', 'rgb(170, 180, 190)'),
						A2($elm$html$Html$Attributes$style, 'overflow-wrap', 'anywhere')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(debugRow.label)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'flex', '1'),
						A2($elm$html$Html$Attributes$style, 'overflow-wrap', 'anywhere')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(debugRow.value)
					]))
			]));
};
var $author$project$Call$debugSectionView = function (section) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'margin-bottom', '8px')
			]),
		A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'font-weight', 'bold'),
						A2($elm$html$Html$Attributes$style, 'color', 'rgb(150, 200, 255)')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(section.title)
					])),
			$elm$core$List$map$($author$project$Call$debugRowView, section.rows)));
};
var $author$project$Call$debugDataView$ = function (position, sections) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
				A2(
				$elm$html$Html$Attributes$style,
				'left',
				$elm$core$String$fromInt(position.left) + 'px'),
				A2(
				$elm$html$Html$Attributes$style,
				'top',
				$elm$core$String$fromInt(position.top) + 'px'),
				A2($elm$html$Html$Attributes$style, 'width', '440px'),
				A2($elm$html$Html$Attributes$style, 'max-width', 'calc(100% - 16px)'),
				A2(
				$elm$html$Html$Attributes$style,
				'max-height',
				$elm$core$String$fromInt(position.maxHeight) + 'px'),
				A2($elm$html$Html$Attributes$style, 'overflow-y', 'auto'),
				A2($elm$html$Html$Attributes$style, 'z-index', '1000'),
				A2($elm$html$Html$Attributes$style, 'background-color', 'rgba(0,0,0,0.85)'),
				A2($elm$html$Html$Attributes$style, 'color', 'white'),
				A2($elm$html$Html$Attributes$style, 'font-family', 'monospace'),
				A2($elm$html$Html$Attributes$style, 'font-size', '11px'),
				A2($elm$html$Html$Attributes$style, 'line-height', '1.5'),
				A2($elm$html$Html$Attributes$style, 'padding', '8px'),
				A2($elm$html$Html$Attributes$style, 'border-radius', '8px'),
				A2($elm$html$Html$Attributes$style, 'pointer-events', 'auto')
			]),
		function () {
			if (!sections.b) {
				return _List_fromArray(
					[
						$elm$html$Html$text('Waiting for JS to reply...')
					]);
			} else {
				return $elm$core$List$map$($author$project$Call$debugSectionView, sections);
			}
		}());
};
var $author$project$Call$debugDataView = F2($author$project$Call$debugDataView$);
var $author$project$Call$debugTileLabel$ = function (localUser, ownClientId, videoTile, position) {
	var _v0 = function () {
		if (!videoTile.$) {
			var owner2 = videoTile.a;
			return _Utils_Tuple2(owner2, 'video');
		} else {
			var owner2 = videoTile.a;
			return _Utils_Tuple2(owner2, 'screen');
		}
	}();
	var owner = _v0.a;
	var kind = _v0.b;
	var _v2 = function () {
		if (!owner.$) {
			return _Utils_Tuple2(localUser.session.userId, ownClientId);
		} else {
			var connectionId = owner.a;
			return connectionId.otherClientId;
		}
	}();
	var userId = _v2.a;
	var clientId = _v2.b;
	return _Utils_Tuple2(
		'call_debugLabel ' + (kind + (' ' + $author$project$Call$otherUserIdToString(
			_Utils_Tuple2(userId, clientId)))),
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
					A2(
					$elm$html$Html$Attributes$style,
					'left',
					$elm$core$String$fromInt(
						$author$project$Coord$xRaw(position) + 8) + 'px'),
					A2(
					$elm$html$Html$Attributes$style,
					'top',
					$elm$core$String$fromInt(
						(localUser.safeAreaInsetTop + $author$project$Coord$yRaw(position)) + 8) + 'px'),
					A2($elm$html$Html$Attributes$style, 'z-index', '1001'),
					A2($elm$html$Html$Attributes$style, 'padding', '2px 6px'),
					A2($elm$html$Html$Attributes$style, 'border-radius', '4px'),
					A2($elm$html$Html$Attributes$style, 'background-color', 'rgba(0,0,0,0.75)'),
					A2($elm$html$Html$Attributes$style, 'color', 'white'),
					A2($elm$html$Html$Attributes$style, 'font-family', 'monospace'),
					A2($elm$html$Html$Attributes$style, 'font-size', '11px'),
					A2($elm$html$Html$Attributes$style, 'line-height', '1.4'),
					A2($elm$html$Html$Attributes$style, 'pointer-events', 'none')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'user ' + $author$project$Id$toString(userId))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'client ' + $lamdera$program_test$Effect$Lamdera$clientIdToString(clientId))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(kind)
						]))
				])));
};
var $author$project$Call$debugTileLabel = F4($author$project$Call$debugTileLabel$);
var $author$project$Call$PressedToggleDebugData = {$: 17};
var $author$project$Call$deviceSettingsRow$ = function (icon, select) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
				A2($elm$html$Html$Attributes$style, 'gap', '8px')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'flex', '0 0 24px'),
						A2($elm$html$Html$Attributes$style, 'line-height', '0')
					]),
				_List_fromArray(
					[icon])),
				select
			]));
};
var $author$project$Call$deviceSettingsRow = F2($author$project$Call$deviceSettingsRow$);
var $author$project$Call$popupButton$ = function (htmlId, onPress, children) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id(htmlId),
				$elm$html$Html$Events$onClick(onPress),
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
				A2($elm$html$Html$Attributes$style, 'gap', '8px'),
				A2($elm$html$Html$Attributes$style, 'padding', '4px 10px'),
				A2(
				$elm$html$Html$Attributes$style,
				'border',
				'1px solid ' + $author$project$MyUi$colorToStyle($author$project$MyUi$inputBorder)),
				A2($elm$html$Html$Attributes$style, 'border-radius', '4px'),
				A2(
				$elm$html$Html$Attributes$style,
				'background-color',
				$author$project$MyUi$colorToStyle($author$project$MyUi$background2)),
				A2(
				$elm$html$Html$Attributes$style,
				'color',
				$author$project$MyUi$colorToStyle($author$project$MyUi$white)),
				A2($elm$html$Html$Attributes$style, 'font-size', '14px'),
				A2($elm$html$Html$Attributes$style, 'cursor', 'pointer')
			]),
		children);
};
var $author$project$Call$popupButton = F3($author$project$Call$popupButton$);
var $author$project$Call$PressedCancelRecording = {$: 8};
var $author$project$Call$PressedRecord = {$: 7};
var $author$project$Call$recordRed = $author$project$Ui$rgb$(240, 60, 60);
var $author$project$Call$recordButton = function (recordingStatus) {
	var redDot = A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'width', '12px'),
				A2($elm$html$Html$Attributes$style, 'height', '12px'),
				A2($elm$html$Html$Attributes$style, 'border-radius', '6px'),
				A2(
				$elm$html$Html$Attributes$style,
				'background-color',
				$author$project$MyUi$colorToStyle($author$project$Call$recordRed))
			]),
		_List_Nil);
	if (!recordingStatus.$) {
		switch (recordingStatus.a.$) {
			case 2:
				return $elm$html$Html$text('');
			case 0:
				return $author$project$Call$popupButton$(
					'voiceChat_cancelRecording',
					$author$project$Call$PressedCancelRecording,
					_List_fromArray(
						[
							redDot,
							$elm$html$Html$text('Cancel recording')
						]));
			default:
				return $author$project$Call$popupButton$(
					'voiceChat_record',
					$author$project$Call$PressedRecord,
					_List_fromArray(
						[
							redDot,
							$elm$html$Html$text('Record')
						]));
		}
	} else {
		return $author$project$Call$popupButton$(
			'voiceChat_record',
			$author$project$Call$PressedRecord,
			_List_fromArray(
				[
					redDot,
					$elm$html$Html$text('Record')
				]));
	}
};
var $author$project$Call$deviceSettingsView$ = function (position, isMobile, recordingStatus, model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id('voiceChat_deviceSettings'),
				A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
				A2(
				$elm$html$Html$Attributes$style,
				'left',
				$elm$core$String$fromInt(position.left) + 'px'),
				A2(
				$elm$html$Html$Attributes$style,
				'bottom',
				$elm$core$String$fromInt(position.bottom) + 'px'),
				A2($elm$html$Html$Attributes$style, 'width', '400px'),
				A2($elm$html$Html$Attributes$style, 'max-width', 'calc(100% - 16px)'),
				A2($elm$html$Html$Attributes$style, 'box-sizing', 'border-box'),
				A2($elm$html$Html$Attributes$style, 'z-index', '1000'),
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
				A2($elm$html$Html$Attributes$style, 'gap', '8px'),
				A2($elm$html$Html$Attributes$style, 'padding', '8px'),
				A2($elm$html$Html$Attributes$style, 'border-radius', '8px'),
				A2(
				$elm$html$Html$Attributes$style,
				'border',
				'1px solid ' + $author$project$MyUi$colorToStyle($author$project$MyUi$border1)),
				A2(
				$elm$html$Html$Attributes$style,
				'background-color',
				$author$project$MyUi$colorToStyle($author$project$MyUi$background1)),
				A2(
				$elm$html$Html$Attributes$style,
				'color',
				$author$project$MyUi$colorToStyle($author$project$MyUi$font1)),
				A2($elm$html$Html$Attributes$style, 'pointer-events', 'auto')
			]),
		_Utils_ap(
			function () {
				var _v0 = model.userMediaDevices;
				switch (_v0.$) {
					case 0:
						return _List_fromArray(
							[
								$elm$html$Html$text('Loading microphones and cameras...')
							]);
					case 2:
						var error = _v0.a;
						return _List_fromArray(
							[
								$elm$html$Html$text('Failed to get media devices: ' + error)
							]);
					default:
						var devices = _v0.a;
						return _List_fromArray(
							[
								$author$project$Call$deviceSettingsRow$(
								$author$project$Icons$microphone,
								$author$project$Call$deviceSelect$(
									isMobile,
									'Microphone',
									$elm$core$List$filter$(
										function (d) {
											return !d.kind;
										},
										devices),
									model.selectedAudioInputDevice,
									$author$project$Call$SelectedAudioInputDevice)),
								$author$project$Call$deviceSettingsRow$(
								$author$project$Icons$camera(24),
								$author$project$Call$deviceSelect$(
									isMobile,
									'Camera',
									$elm$core$List$filter$(
										function (d) {
											return d.kind === 1;
										},
										devices),
									model.selectedVideoInputDevice,
									$author$project$Call$SelectedVideoInputDevice))
							]);
				}
			}(),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'flex'),
							A2($elm$html$Html$Attributes$style, 'justify-content', 'flex-end'),
							A2($elm$html$Html$Attributes$style, 'gap', '8px')
						]),
					_List_fromArray(
						[
							isMobile ? $elm$html$Html$text('') : $author$project$Call$recordButton(recordingStatus),
							$author$project$Call$popupButton$(
							'voiceChat_toggleDebugData',
							$author$project$Call$PressedToggleDebugData,
							_List_fromArray(
								[
									$elm$html$Html$text(
									model.pollDebugData ? 'Hide debug info' : 'Show debug info')
								]))
						]))
				])));
};
var $author$project$Call$deviceSettingsView = F4($author$project$Call$deviceSettingsView$);
var $author$project$Call$PressedVideoTile = function (a) {
	return {$: 15, a: a};
};
var $elm$html$Html$canvas = _VirtualDom_node('canvas');
var $author$project$Call$localScreenShareNodeId = 'local-screen-share';
var $author$project$Call$screenShareNodeId = function (connectionId) {
	return $author$project$Call$connectionIdToString(connectionId) + ' screen';
};
var $author$project$Call$screenShareNode$ = function (localUser, id, _v0) {
	var position = _v0.a;
	var width = _v0.b;
	var idString = function () {
		if (!id.$) {
			return $author$project$Call$localScreenShareNodeId;
		} else {
			var connectionId = id.a;
			return $author$project$Call$screenShareNodeId(connectionId);
		}
	}();
	var height = width / $author$project$Call$aspectRatio;
	var mediaAttributes = _List_fromArray(
		[
			$elm$html$Html$Attributes$id(idString),
			A2($elm$html$Html$Attributes$style, 'background-color', 'rgba(0,0,0)'),
			A2(
			$elm$html$Html$Attributes$style,
			'width',
			$elm$core$String$fromInt(width) + 'px'),
			A2(
			$elm$html$Html$Attributes$style,
			'height',
			$elm$core$String$fromFloat(height) + 'px'),
			A2($elm$html$Html$Attributes$style, 'border-radius', '8px'),
			A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
			A2($elm$html$Html$Attributes$style, 'object-fit', 'contain')
		]);
	return _Utils_Tuple2(
		idString,
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$Attributes$style,
					'width',
					$elm$core$String$fromInt(width) + 'px'),
					A2(
					$elm$html$Html$Attributes$style,
					'height',
					$elm$core$String$fromFloat(height) + 'px'),
					A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
					A2(
					$elm$html$Html$Attributes$style,
					'left',
					$elm$core$String$fromInt(
						$author$project$Coord$xRaw(position)) + 'px'),
					A2(
					$elm$html$Html$Attributes$style,
					'top',
					$elm$core$String$fromInt(
						localUser.safeAreaInsetTop + $author$project$Coord$yRaw(position)) + 'px'),
					A2($elm$html$Html$Attributes$style, 'pointer-events', 'auto'),
					$elm$html$Html$Events$onClick(
					$author$project$Call$PressedVideoTile(
						$author$project$Call$ScreenShareTile(id)))
				]),
			_List_fromArray(
				[
					function () {
					if (!id.$) {
						return A2(
							$elm$html$Html$video,
							A2(
								$elm$core$List$cons,
								A2($elm$html$Html$Attributes$attribute, 'playsinline', ''),
								A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$attribute, 'webkit-playsinline', ''),
									mediaAttributes)),
							_List_Nil);
					} else {
						return A2($elm$html$Html$canvas, mediaAttributes, _List_Nil);
					}
				}(),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
							A2($elm$html$Html$Attributes$style, 'left', '8px'),
							A2($elm$html$Html$Attributes$style, 'bottom', '8px'),
							A2($elm$html$Html$Attributes$style, 'padding', '2px 6px'),
							A2($elm$html$Html$Attributes$style, 'border-radius', '4px'),
							A2($elm$html$Html$Attributes$style, 'background-color', 'rgba(0,0,0,0.6)'),
							A2($elm$html$Html$Attributes$style, 'color', 'white'),
							A2($elm$html$Html$Attributes$style, 'font-size', '14px'),
							A2($elm$html$Html$Attributes$style, 'max-width', 'calc(100% - 28px)'),
							A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
							A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
							A2($elm$html$Html$Attributes$style, 'text-overflow', 'ellipsis'),
							A2($elm$html$Html$Attributes$style, 'pointer-events', 'none')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							function () {
								if (!id.$) {
									return 'Your screen';
								} else {
									var connectionId = id.a;
									return $author$project$User$toStringAlt$(connectionId.otherClientId.a, localUser) + '\u0027s screen';
								}
							}())
						]))
				])));
};
var $author$project$Call$screenShareNode = F3($author$project$Call$screenShareNode$);
var $author$project$Call$ChangedVolume$ = function (a, b) {
	return {$: 11, a: a, b: b};
};
var $author$project$Call$ChangedVolume = F2($author$project$Call$ChangedVolume$);
var $author$project$Call$DoubleClickedVideoNode = {$: 14};
var $author$project$Call$MouseEnterVideoNode = function (a) {
	return {$: 12, a: a};
};
var $author$project$Call$MouseExitVideoNode = function (a) {
	return {$: 13, a: a};
};
var $elm$html$Html$Events$onDoubleClick = function (msg) {
	return $elm$html$Html$Events$on$(
		'dblclick',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Call$speakingOutline = function (isSpeaking) {
	return isSpeaking ? '4px solid rgb(131, 147, 167)' : '0 solid rgb(131, 147, 167)';
};
var $author$project$Call$videoNode$ = function (userId, localUser, id, remoteCallData, videoNodeState, _v0, isSpeaking, model) {
	var position = _v0.a;
	var width = _v0.b;
	var idString = function () {
		if (!id.$) {
			return $author$project$Call$localVideoNodeId;
		} else {
			var connectionId = id.a;
			return $author$project$Call$connectionIdToString(connectionId);
		}
	}();
	var height = width / $author$project$Call$aspectRatio;
	return _Utils_Tuple2(
		idString,
		A2(
			$elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$Attributes$style,
						'width',
						$elm$core$String$fromInt(width) + 'px'),
						A2(
						$elm$html$Html$Attributes$style,
						'height',
						$elm$core$String$fromFloat(height) + 'px'),
						A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
						A2(
						$elm$html$Html$Attributes$style,
						'left',
						$elm$core$String$fromInt(
							$author$project$Coord$xRaw(position)) + 'px'),
						A2(
						$elm$html$Html$Attributes$style,
						'top',
						$elm$core$String$fromInt(
							localUser.safeAreaInsetTop + $author$project$Coord$yRaw(position)) + 'px'),
						A2(
						$elm$html$Html$Attributes$style,
						'pointer-events',
						(!videoNodeState) ? 'none' : 'auto'),
						$elm$html$Html$Events$onDoubleClick($author$project$Call$DoubleClickedVideoNode),
						$elm$html$Html$Events$onMouseEnter(
						$author$project$Call$MouseEnterVideoNode(id)),
						$elm$html$Html$Events$onMouseLeave(
						$author$project$Call$MouseExitVideoNode(id)),
						A2(
						$elm$html$Html$Attributes$style,
						'opacity',
						(!videoNodeState) ? '0' : '1')
					]),
				function () {
					switch (videoNodeState) {
						case 1:
							return _List_fromArray(
								[
									$elm$html$Html$Attributes$id('call_videoThumbnail')
								]);
						case 0:
							return _List_Nil;
						default:
							return _List_Nil;
					}
				}()),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
							A2(
							$elm$html$Html$Attributes$style,
							'left',
							$elm$core$String$fromInt(((width - $author$project$User$profileImageSize) / 2) | 0) + 'px'),
							A2(
							$elm$html$Html$Attributes$style,
							'top',
							$elm$core$String$fromFloat((height - $author$project$User$profileImageSize) / 2) + 'px'),
							A2(
							$elm$html$Html$Attributes$style,
							'opacity',
							remoteCallData.videoInputEnabled ? '0' : '0.8'),
							A2($elm$html$Html$Attributes$style, 'pointer-events', 'none')
						]),
					_List_fromArray(
						[
							$author$project$User$profileImageHtml(
							$author$project$User$getUser$(userId, localUser))
						])),
					A2(
					$elm$html$Html$div,
					function () {
						switch (videoNodeState) {
							case 2:
								return _List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										$author$project$Call$PressedVideoTile(
											$author$project$Call$CameraTile(id)))
									]);
							case 1:
								return _List_Nil;
							default:
								return _List_Nil;
						}
					}(),
					_List_fromArray(
						[
							function () {
							if (!id.$) {
								return A2(
									$elm$html$Html$video,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id(idString),
											A2($elm$html$Html$Attributes$style, 'background-color', 'rgba(0,0,0)'),
											A2(
											$elm$html$Html$Attributes$style,
											'width',
											$elm$core$String$fromInt(width) + 'px'),
											A2(
											$elm$html$Html$Attributes$style,
											'height',
											$elm$core$String$fromFloat(height) + 'px'),
											A2(
											$elm$html$Html$Attributes$style,
											'outline',
											$author$project$Call$speakingOutline(isSpeaking)),
											A2($elm$html$Html$Attributes$style, 'transition', 'outline-width 50ms ease-out'),
											A2($elm$html$Html$Attributes$style, 'border-radius', '8px'),
											A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
											A2($elm$html$Html$Attributes$attribute, 'playsinline', ''),
											A2($elm$html$Html$Attributes$attribute, 'webkit-playsinline', '')
										]),
									_List_Nil);
							} else {
								return A2(
									$elm$html$Html$canvas,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id(idString),
											A2($elm$html$Html$Attributes$style, 'background-color', 'rgba(0,0,0)'),
											A2(
											$elm$html$Html$Attributes$style,
											'width',
											$elm$core$String$fromInt(width) + 'px'),
											A2(
											$elm$html$Html$Attributes$style,
											'height',
											$elm$core$String$fromFloat(height) + 'px'),
											A2(
											$elm$html$Html$Attributes$style,
											'outline',
											$author$project$Call$speakingOutline(isSpeaking)),
											A2($elm$html$Html$Attributes$style, 'transition', 'outline-width 50ms ease-out'),
											A2($elm$html$Html$Attributes$style, 'border-radius', '8px'),
											A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
											A2($elm$html$Html$Attributes$style, 'object-fit', 'cover')
										]),
									_List_Nil);
							}
						}()
						])),
					function () {
					var _v4 = _Utils_Tuple2(id, videoNodeState);
					if ((_v4.a.$ === 1) && (_v4.b === 2)) {
						var connectionId = _v4.a.a;
						var _v5 = _v4.b;
						var volume = $elm$core$Maybe$withDefault$(
							1,
							$lamdera$containers$SeqDict$get$(connectionId.otherClientId, model.volume));
						var spacing = 4;
						var sliderHeight = 80;
						var sliderBottomMargin = 4;
						var padding = 4;
						var isVisible = _Utils_eq(
							model.videoHover,
							$elm$core$Maybe$Just(id));
						var iconSize = 20;
						var containerHeight = (((sliderHeight + iconSize) + spacing) + sliderBottomMargin) + (padding * 2);
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
									A2(
									$elm$html$Html$Attributes$style,
									'left',
									$elm$core$String$fromInt(8) + 'px'),
									A2($elm$html$Html$Attributes$style, 'z-index', '999'),
									A2(
									$elm$html$Html$Attributes$style,
									'top',
									$elm$core$String$fromInt(
										($elm$core$Basics$round(height) - containerHeight) - 8) + 'px'),
									A2($elm$html$Html$Attributes$style, 'display', 'flex'),
									A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
									A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
									A2(
									$elm$html$Html$Attributes$style,
									'gap',
									$elm$core$String$fromInt(spacing) + 'px'),
									A2(
									$elm$html$Html$Attributes$style,
									'padding',
									$elm$core$String$fromInt(padding) + 'px'),
									A2($elm$html$Html$Attributes$style, 'background-color', 'rgba(0,0,0,0.4)'),
									A2($elm$html$Html$Attributes$style, 'border-radius', '6px'),
									A2($elm$html$Html$Attributes$style, 'color', 'white'),
									A2(
									$elm$html$Html$Attributes$style,
									'opacity',
									isVisible ? '1' : '0'),
									A2(
									$elm$html$Html$Attributes$style,
									'pointer-events',
									isVisible ? 'auto' : 'none'),
									A2($elm$html$Html$Attributes$style, 'transition', 'opacity 0.2s ease-in-out')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$Attributes$style,
											'width',
											$elm$core$String$fromInt(iconSize) + 'px'),
											A2(
											$elm$html$Html$Attributes$style,
											'height',
											$elm$core$String$fromInt(iconSize) + 'px')
										]),
									_List_fromArray(
										[$author$project$Icons$volume])),
									A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('range'),
											$elm$html$Html$Attributes$min('0'),
											$elm$html$Html$Attributes$max('1'),
											$elm$html$Html$Attributes$step('0.01'),
											A2($elm$html$Html$Attributes$attribute, 'orient', 'vertical'),
											A2(
											$elm$html$Html$Attributes$style,
											'margin-bottom',
											$elm$core$String$fromInt(sliderBottomMargin) + 'px'),
											$elm$html$Html$Attributes$value(
											$elm$core$String$fromFloat(volume)),
											$elm$html$Html$Events$onInput(
											function (str) {
												return $author$project$Call$ChangedVolume$(
													connectionId,
													$elm$core$Maybe$withDefault$(
														1,
														$elm$core$String$toFloat(str)));
											}),
											A2(
											$elm$html$Html$Attributes$style,
											'height',
											$elm$core$String$fromInt(sliderHeight) + 'px'),
											A2($elm$html$Html$Attributes$style, 'appearance', 'slider-vertical'),
											A2($elm$html$Html$Attributes$style, '-webkit-appearance', 'slider-vertical'),
											A2(
											$elm$html$Html$Attributes$style,
											'width',
											$elm$core$String$fromInt(iconSize) + 'px')
										]),
									_List_Nil)
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}()
				])));
};
var $author$project$Call$videoNode = F8($author$project$Call$videoNode$);
var $author$project$Call$localTiles$ = function (localUser, model) {
	var cameraTile = function (posAndSize) {
		return $author$project$Call$videoNode$(localUser.session.userId, localUser, $author$project$Call$IsLocal, model.remoteCallData, 2, posAndSize, model.localIsSpeaking, model);
	};
	return model.remoteCallData.screenShareEnabled ? _List_fromArray(
		[
			_Utils_Tuple2(
			$author$project$Call$CameraTile($author$project$Call$IsLocal),
			cameraTile),
			_Utils_Tuple2(
			$author$project$Call$ScreenShareTile($author$project$Call$IsLocal),
			A2($author$project$Call$screenShareNode, localUser, $author$project$Call$IsLocal))
		]) : _List_fromArray(
		[
			_Utils_Tuple2(
			$author$project$Call$CameraTile($author$project$Call$IsLocal),
			cameraTile)
		]);
};
var $author$project$Call$localTiles = F2($author$project$Call$localTiles$);
var $author$project$Call$recordingIndicator = function (position) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id('voiceChat_recordingIndicator'),
				A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
				A2(
				$elm$html$Html$Attributes$style,
				'right',
				$elm$core$String$fromInt(position.right) + 'px'),
				A2(
				$elm$html$Html$Attributes$style,
				'top',
				$elm$core$String$fromInt(position.top) + 'px'),
				A2($elm$html$Html$Attributes$style, 'z-index', '1000'),
				A2($elm$html$Html$Attributes$style, 'line-height', '0'),
				$elm$html$Html$Attributes$title('This call is being recorded')
			]),
		_List_fromArray(
			[
				$author$project$Icons$recording(24)
			]));
};
var $author$project$Call$layoutScore$ = function (container, videos, cols) {
	var spacing = container.spacing;
	var rows = ((($elm$core$List$length(videos) + cols) - 1) / cols) | 0;
	var cellWidth = (container.containerWidth - ((cols - 1) * spacing)) / cols;
	var cellHeight = (container.containerHeight - ((rows - 1) * spacing)) / rows;
	return ((cellWidth <= 0) || (cellHeight <= 0)) ? 0 : $elm$core$List$foldl$(
		F2(
			function (video, total) {
				var fittedWidth = $elm$core$Basics$min$(cellWidth, cellHeight * video.aspectRatio);
				var fittedHeight = fittedWidth / video.aspectRatio;
				return total + (fittedWidth * fittedHeight);
			}),
		0,
		videos);
};
var $author$project$Call$layoutScore = F3($author$project$Call$layoutScore$);
var $elmcraft$core_extra$List$Extra$takeReverse$ = function (n, list, kept) {
	takeReverse:
	while (true) {
		if (n <= 0) {
			return kept;
		} else {
			if (!list.b) {
				return kept;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$n = n - 1,
					$temp$list = xs,
					$temp$kept = A2($elm$core$List$cons, x, kept);
				n = $temp$n;
				list = $temp$list;
				kept = $temp$kept;
				continue takeReverse;
			}
		}
	}
};
var $elmcraft$core_extra$List$Extra$takeReverse = F3($elmcraft$core_extra$List$Extra$takeReverse$);
var $elmcraft$core_extra$List$Extra$takeTailRec$ = function (n, list) {
	return $elm$core$List$reverse(
		$elmcraft$core_extra$List$Extra$takeReverse$(n, list, _List_Nil));
};
var $elmcraft$core_extra$List$Extra$takeTailRec = F2($elmcraft$core_extra$List$Extra$takeTailRec$);
var $elmcraft$core_extra$List$Extra$greedyGroupsOfWithStep$ = function (size, step, list) {
	if ((size <= 0) || (step <= 0)) {
		return _List_Nil;
	} else {
		var go = F2(
			function (xs, acc) {
				go:
				while (true) {
					if ($elm$core$List$isEmpty(xs)) {
						return $elm$core$List$reverse(acc);
					} else {
						var $temp$xs = $elm$core$List$drop$(step, xs),
							$temp$acc = A2(
							$elm$core$List$cons,
							$elmcraft$core_extra$List$Extra$takeTailRec$(size, xs),
							acc);
						xs = $temp$xs;
						acc = $temp$acc;
						continue go;
					}
				}
			});
		return A2(go, list, _List_Nil);
	}
};
var $elmcraft$core_extra$List$Extra$greedyGroupsOfWithStep = F3($elmcraft$core_extra$List$Extra$greedyGroupsOfWithStep$);
var $elmcraft$core_extra$List$Extra$greedyGroupsOf$ = function (size, xs) {
	return $elmcraft$core_extra$List$Extra$greedyGroupsOfWithStep$(size, size, xs);
};
var $elmcraft$core_extra$List$Extra$greedyGroupsOf = F2($elmcraft$core_extra$List$Extra$greedyGroupsOf$);
var $author$project$Call$layoutVideos$ = function (container, videos, cols) {
	var videoRows = $elmcraft$core_extra$List$Extra$greedyGroupsOf$(cols, videos);
	var spacing = container.spacing;
	var layoutRow = F2(
		function (_v2, _v3) {
			var rowVideos = _v2.a;
			var height = _v2.b;
			var y = _v3.a;
			var acc = _v3.b;
			var k = $elm$core$List$length(rowVideos);
			var rowWidth = (height * $elm$core$List$sum(
				$elm$core$List$map$(
					function ($) {
						return $.aspectRatio;
					},
					rowVideos))) + ((k - 1) * spacing);
			var xStart = (container.containerWidth - rowWidth) / 2;
			var _v0 = $elm$core$List$foldl$(
				F2(
					function (video, _v1) {
						var x = _v1.a;
						var list = _v1.b;
						var w = height * video.aspectRatio;
						return _Utils_Tuple2(
							(x + w) + spacing,
							A2(
								$elm$core$List$cons,
								{
									height: $elm$core$Basics$round(height),
									id: video.id,
									width: $elm$core$Basics$round(w),
									x: $elm$core$Basics$round(x),
									y: $elm$core$Basics$round(y)
								},
								list));
					}),
				_Utils_Tuple2(xStart, _List_Nil),
				rowVideos);
			var rowResults = _v0.b;
			return _Utils_Tuple2(
				(y + height) + spacing,
				_Utils_ap(rowResults, acc));
		});
	var count = $elm$core$List$length(videos);
	var rows = (((count + cols) - 1) / cols) | 0;
	var rowBudget = (container.containerHeight - ((rows - 1) * spacing)) / rows;
	var rowHeight = function (rowVideos) {
		var sumAspectRatio = $elm$core$List$sum(
			$elm$core$List$map$(
				function ($) {
					return $.aspectRatio;
				},
				rowVideos));
		var k = $elm$core$List$length(rowVideos);
		var availableWidth = container.containerWidth - ((k - 1) * spacing);
		return ((sumAspectRatio <= 0) || (availableWidth <= 0)) ? 0 : $elm$core$Basics$min$(rowBudget, availableWidth / sumAspectRatio);
	};
	var rowsWithHeights = $elm$core$List$map$(
		function (rowVideos) {
			return _Utils_Tuple2(
				rowVideos,
				rowHeight(rowVideos));
		},
		videoRows);
	var totalHeight = $elm$core$List$sum(
		$elm$core$List$map$($elm$core$Tuple$second, rowsWithHeights)) + ((rows - 1) * spacing);
	var yStart = (container.containerHeight - totalHeight) / 2;
	return $elm$core$List$reverse(
		$elm$core$List$foldl$(
			layoutRow,
			_Utils_Tuple2(yStart, _List_Nil),
			rowsWithHeights).b);
};
var $author$project$Call$layoutVideos = F3($author$project$Call$layoutVideos$);
var $author$project$Call$videoPosAndSize$ = function (container, videos) {
	var count = $elm$core$List$length(videos);
	if (!count) {
		return _List_Nil;
	} else {
		var bestCols = $elm$core$Maybe$withDefault$(
			1,
			$elmcraft$core_extra$List$Extra$maximumBy$(
				function (cols) {
					return $author$project$Call$layoutScore$(container, videos, cols);
				},
				$elm$core$List$range$(1, count)));
		return $author$project$Call$layoutVideos$(container, videos, bestCols);
	}
};
var $author$project$Call$videoPosAndSize = F2($author$project$Call$videoPosAndSize$);
var $author$project$Call$videoNodes$ = function (localUser, config, loggedIn, local) {
	var voiceChatY = $author$project$MyUi$channelHeaderHeight + 8;
	var spacing = 8;
	var padding = 8;
	var model = loggedIn.voiceChat;
	var maxWidth = $author$project$MyUi$conversationWidthIgnoreScrollbar$(
		config.windowSize,
		function () {
			var _v24 = $author$project$Route$toShowMembersTab(config.route);
			if (!_v24.a) {
				var _v25 = _v24.a;
				return true;
			} else {
				var _v26 = _v24.a;
				return false;
			}
		}()) - (padding * 2);
	var isMobile = $author$project$MyUi$isMobile(
		{windowSize: config.windowSize});
	var voiceChatX = isMobile ? (padding + $author$project$Call$conversationOffset$(loggedIn.sidebarMode, config)) : ($author$project$MyUi$channelAndGuildColumnWidth(config.windowSize) + padding);
	var getPosAndSize = F2(
		function (index, list) {
			return $elm$core$Maybe$withDefault$(
				_Utils_Tuple2($author$project$Coord$origin, 100),
				$elmcraft$core_extra$List$Extra$getAt$(index, list));
		});
	var displayMode2 = $author$project$Call$displayMode$(isMobile, localUser.session.userId, config.route, local);
	var joinedCall = function () {
		switch (displayMode2.$) {
			case 2:
				var callId = displayMode2.a;
				return $elm$core$Maybe$Just(callId);
			case 1:
				var callId = displayMode2.a;
				return _Utils_eq(
					local.currentRoom,
					$elm$core$Maybe$Just(callId)) ? $elm$core$Maybe$Just(callId) : $elm$core$Maybe$Nothing;
			case 3:
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Nothing;
		}
	}();
	var showDebugData = model.pollDebugData && function () {
		if (!joinedCall.$) {
			return true;
		} else {
			return false;
		}
	}();
	var viewedCall = function () {
		switch (displayMode2.$) {
			case 0:
				return $elm$core$Maybe$Nothing;
			case 1:
				var callId = displayMode2.a;
				return $elm$core$Maybe$Just(callId);
			case 2:
				var callId = displayMode2.a;
				return $elm$core$Maybe$Just(callId);
			default:
				return $elm$core$Maybe$Nothing;
		}
	}();
	var controlsHeight = function () {
		var _v18 = _Utils_Tuple2(joinedCall, isMobile);
		if (!_v18.a.$) {
			if (_v18.b) {
				return 33;
			} else {
				return 41;
			}
		} else {
			if (_v18.b) {
				var _v19 = _v18.a;
				return 150;
			} else {
				var _v20 = _v18.a;
				return 90;
			}
		}
	}();
	var maxHeight = (($author$project$Call$viewHeight(config.windowSize) - (voiceChatY - $author$project$MyUi$channelHeaderHeight)) - controlsHeight) - (padding * 2);
	var focusedLayout = function (count) {
		var columnWidth = $elm$core$Basics$min$(
			$elm$core$Basics$min$(280, (maxWidth / 4) | 0),
			$elm$core$Basics$floor(((maxHeight - ((count - 1) * spacing)) / count) * $author$project$Call$aspectRatio));
		var focusedWidth = $elm$core$Basics$min$(
			(maxWidth - columnWidth) - spacing,
			$elm$core$Basics$floor(maxHeight * $author$project$Call$aspectRatio));
		var focusedX = voiceChatX + (((((maxWidth - focusedWidth) - spacing) - columnWidth) / 2) | 0);
		var columnTileHeight = columnWidth / $author$project$Call$aspectRatio;
		var columnY = ((maxHeight - (count * columnTileHeight)) - ((count - 1) * spacing)) / 2;
		return A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				$author$project$Coord$xy$(
					focusedX,
					voiceChatY + $elm$core$Basics$round((maxHeight - (focusedWidth / $author$project$Call$aspectRatio)) / 2)),
				focusedWidth),
			$elm$core$List$map$(
				function (index) {
					return _Utils_Tuple2(
						$author$project$Coord$xy$(
							(focusedX + focusedWidth) + spacing,
							voiceChatY + $elm$core$Basics$round(columnY + (index * (columnTileHeight + spacing)))),
						columnWidth);
				},
				$elm$core$List$range$(0, count - 1)));
	};
	var posAndSizes = function (total) {
		return $elm$core$List$map$(
			function (a) {
				return _Utils_Tuple2(
					$author$project$Coord$xy$(a.x + voiceChatX, a.y + voiceChatY),
					a.width);
			},
			$author$project$Call$videoPosAndSize$(
				{containerHeight: maxHeight, containerWidth: maxWidth, spacing: spacing},
				$elm$core$List$map$(
					function (index) {
						return {
							aspectRatio: $author$project$Call$aspectRatio,
							id: $author$project$Id$fromInt(index)
						};
					},
					$elm$core$List$range$(1, total))));
	};
	var layoutTiles = function (tiles) {
		var placed = function () {
			var _v14 = _Utils_Tuple2(
				isMobile,
				$elm$core$List$partition$(
					function (_v15) {
						var tile = _v15.a;
						return _Utils_eq(
							$elm$core$Maybe$Just(tile),
							model.focusedTile);
					},
					tiles));
			if ((((!_v14.a) && _v14.b.a.b) && (!_v14.b.a.b.b)) && _v14.b.b.b) {
				var _v16 = _v14.b;
				var _v17 = _v16.a;
				var focusedTile = _v17.a;
				var otherTiles = _v16.b;
				return A3(
					$elm$core$List$map2,
					$elm$core$Tuple$pair,
					A2($elm$core$List$cons, focusedTile, otherTiles),
					focusedLayout(
						$elm$core$List$length(otherTiles)));
			} else {
				return A3(
					$elm$core$List$map2,
					$elm$core$Tuple$pair,
					tiles,
					posAndSizes(
						$elm$core$List$length(tiles)));
			}
		}();
		return _Utils_ap(
			$elm$core$List$map$(
				function (_v9) {
					var _v10 = _v9.a;
					var tile = _v10.b;
					var posAndSize = _v9.b;
					return tile(posAndSize);
				},
				placed),
			showDebugData ? $elm$core$List$map$(
				function (_v11) {
					var _v12 = _v11.a;
					var videoTile = _v12.a;
					var _v13 = _v11.b;
					var position = _v13.a;
					return $author$project$Call$debugTileLabel$(localUser, config.clientId, videoTile, position);
				},
				placed) : _List_Nil);
	};
	return A3(
		$elm$html$Html$Keyed$node,
		'div',
		_List_Nil,
		_Utils_ap(
			function () {
				switch (displayMode2.$) {
					case 0:
						return _List_fromArray(
							[
								$author$project$Call$videoNode$(
								localUser.session.userId,
								localUser,
								$author$project$Call$IsLocal,
								model.remoteCallData,
								0,
								A2(
									getPosAndSize,
									0,
									posAndSizes(1)),
								model.localIsSpeaking,
								model)
							]);
					case 1:
						return layoutTiles(
							$author$project$Call$localTiles$(localUser, model));
					case 2:
						var callId = displayMode2.a;
						var sessions = function () {
							var _v2 = $lamdera$containers$SeqDict$get$(callId, local.voiceChats);
							if (!_v2.$) {
								var sessions2 = _v2.a;
								return $author$project$NonemptyDict$toList(sessions2);
							} else {
								return _List_Nil;
							}
						}();
						var tiles = _Utils_ap(
							$author$project$Call$localTiles$(localUser, model),
							$elm$core$List$concatMap$(
								function (_v1) {
									var session = _v1.a;
									var data = _v1.b;
									var connectionId = {otherClientId: session, roomId: callId};
									var cameraTile = function (posAndSize) {
										return $author$project$Call$videoNode$(
											session.a,
											localUser,
											$author$project$Call$IsConnection(connectionId),
											data,
											2,
											posAndSize,
											$lamdera$containers$SeqSet$member$(connectionId, model.isSpeaking),
											model);
									};
									return data.screenShareEnabled ? _List_fromArray(
										[
											_Utils_Tuple2(
											$author$project$Call$CameraTile(
												$author$project$Call$IsConnection(connectionId)),
											cameraTile),
											_Utils_Tuple2(
											$author$project$Call$ScreenShareTile(
												$author$project$Call$IsConnection(connectionId)),
											A2(
												$author$project$Call$screenShareNode,
												localUser,
												$author$project$Call$IsConnection(connectionId)))
										]) : _List_fromArray(
										[
											_Utils_Tuple2(
											$author$project$Call$CameraTile(
												$author$project$Call$IsConnection(connectionId)),
											cameraTile)
										]);
								},
								sessions));
						return layoutTiles(tiles);
					default:
						var callId = displayMode2.a;
						var sessions = function () {
							var _v5 = $lamdera$containers$SeqDict$get$(callId, local.voiceChats);
							if (!_v5.$) {
								var sessions2 = _v5.a;
								return $author$project$NonemptyDict$toList(sessions2);
							} else {
								return _List_Nil;
							}
						}();
						var visibleIndex = function () {
							if (!sessions.b) {
								return 0;
							} else {
								return 1;
							}
						}();
						return A2(
							$elm$core$List$cons,
							$author$project$Call$videoNode$(
								localUser.session.userId,
								localUser,
								$author$project$Call$IsLocal,
								model.remoteCallData,
								(!visibleIndex) ? 1 : 0,
								_Utils_Tuple2(
									$author$project$Call$thumbnailPosition$(isMobile, config.windowSize, model),
									$author$project$Call$thumbnailWindowWidth(isMobile)),
								model.localIsSpeaking,
								model),
							$elm$core$List$indexedMap$(
								F2(
									function (index, _v3) {
										var session = _v3.a;
										var data = _v3.b;
										var connectionId = {otherClientId: session, roomId: callId};
										return $author$project$Call$videoNode$(
											session.a,
											localUser,
											$author$project$Call$IsConnection(connectionId),
											data,
											_Utils_eq(visibleIndex, index + 1) ? 1 : 0,
											_Utils_Tuple2(
												$author$project$Call$thumbnailPosition$(isMobile, config.windowSize, model),
												$author$project$Call$thumbnailWindowWidth(isMobile)),
											$lamdera$containers$SeqSet$member$(connectionId, model.isSpeaking),
											model);
									}),
								sessions));
				}
			}(),
			_Utils_ap(
				function () {
					if (!viewedCall.$) {
						var callId = viewedCall.a;
						var _v7 = $lamdera$containers$SeqDict$get$(callId, local.recordings);
						if (!_v7.$) {
							switch (_v7.a.$) {
								case 2:
									return _List_fromArray(
										[
											_Utils_Tuple2(
											'call_recordingIndicator',
											$author$project$Call$recordingIndicator(
												{
													right: (($author$project$Coord$xRaw(config.windowSize) - voiceChatX) - maxWidth) + padding,
													top: (localUser.safeAreaInsetTop + voiceChatY) + padding
												}))
										]);
								case 0:
									return _List_Nil;
								default:
									return _List_Nil;
							}
						} else {
							return _List_Nil;
						}
					} else {
						return _List_Nil;
					}
				}(),
				_Utils_ap(
					function () {
						if (!joinedCall.$) {
							var callId = joinedCall.a;
							return model.showDeviceSettings ? _List_fromArray(
								[
									_Utils_Tuple2(
									'call_deviceSettings',
									$author$project$Call$deviceSettingsView$(
										{
											bottom: $author$project$Coord$yRaw(config.windowSize) - ((localUser.safeAreaInsetTop + voiceChatY) + maxHeight),
											left: (voiceChatX - padding) + (isMobile ? 8 : 16)
										},
										isMobile,
										$lamdera$containers$SeqDict$get$(callId, local.recordings),
										model))
								]) : _List_Nil;
						} else {
							return _List_Nil;
						}
					}(),
					showDebugData ? _List_fromArray(
						[
							_Utils_Tuple2(
							'call_debugData',
							$author$project$Call$debugDataView$(
								{left: voiceChatX, maxHeight: maxHeight, top: localUser.safeAreaInsetTop + voiceChatY},
								model.debugData))
						]) : _List_Nil))));
};
var $author$project$Call$videoNodes = F4($author$project$Call$videoNodes$);
var $author$project$AiChat$PressedChatHistoryContainer = {$: 6};
var $author$project$AiChat$PressedClearChatHistory = {$: 7};
var $author$project$AiChat$TypedChatHistory = function (a) {
	return {$: 2, a: a};
};
var $author$project$AiChat$containerShadow = $author$project$Ui$Shadow$shadows(
	_List_fromArray(
		[
			{
			blur: 8,
			color: $author$project$Ui$rgba$(0, 0, 0, 0.1),
			size: 0,
			x: 0,
			y: 2
		}
		]));
var $author$project$AiChat$deleteIcon = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0')
				]),
			_List_Nil)
		]));
var $author$project$AiChat$isMobile = function (windowSize) {
	return $author$project$Coord$xRaw(windowSize) < 800;
};
var $author$project$AiChat$PressedOptionsButton = {$: 8};
var $author$project$AiChat$SelectedSendMessageWith = function (a) {
	return {$: 12, a: a};
};
var $author$project$AiChat$PressedAddModel = {$: 10};
var $author$project$AiChat$addModelButton = $author$project$Ui$el$(
	_List_fromArray(
		[
			$author$project$Ui$Input$button($author$project$AiChat$PressedAddModel),
			$author$project$Ui$paddingXY$(8, 6),
			$author$project$Ui$background($author$project$MyUi$buttonBackground),
			$author$project$Ui$border(1),
			$author$project$Ui$borderColor($author$project$MyUi$border1),
			$author$project$Ui$rounded(4),
			$author$project$Ui$Font$size(14),
			$author$project$Ui$Font$bold,
			$author$project$Ui$width($author$project$Ui$shrink)
		]),
	$author$project$Ui$text('+ Add model'));
var $author$project$AiChat$PressedRemoveModel = function (a) {
	return {$: 11, a: a};
};
var $author$project$AiChat$SelectedAiModel$ = function (a, b) {
	return {$: 9, a: a, b: b};
};
var $author$project$AiChat$SelectedAiModel = F2($author$project$AiChat$SelectedAiModel$);
var $author$project$AiChat$aiModelSelect$ = function (aiModels, selected, index) {
	return A2(
		$elm$html$Html$select,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$value(
				$elm$core$Maybe$withDefault$(
					'',
					$elm$core$Maybe$map$($author$project$AiChat$aiModelNameToString, selected))),
				$elm$html$Html$Events$onInput(
				function (a) {
					return $author$project$AiChat$SelectedAiModel$(index, a);
				}),
				A2($elm$html$Html$Attributes$style, 'width', '100%'),
				A2($elm$html$Html$Attributes$style, 'padding', '7px 8px'),
				A2(
				$elm$html$Html$Attributes$style,
				'border',
				'1px solid ' + $author$project$MyUi$colorToStyle($author$project$MyUi$inputBorder)),
				A2($elm$html$Html$Attributes$style, 'border-radius', '4px'),
				A2($elm$html$Html$Attributes$style, 'font-size', '16px'),
				A2(
				$elm$html$Html$Attributes$style,
				'background-color',
				$author$project$MyUi$colorToStyle($author$project$MyUi$background2)),
				A2(
				$elm$html$Html$Attributes$style,
				'color',
				$author$project$MyUi$colorToStyle($author$project$MyUi$white)),
				A2($elm$html$Html$Attributes$style, 'cursor', 'pointer')
			]),
		$elm$core$List$map$(
			function (aiModel) {
				return A2(
					$elm$html$Html$option,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(
							$author$project$AiChat$aiModelNameToString(aiModel.id)),
							$elm$html$Html$Attributes$selected(
							_Utils_eq(
								$elm$core$Maybe$Just(aiModel.id),
								selected))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$AiChat$aiModelNameToString(aiModel.id) + ' '),
							$elm$core$List$member$('image', aiModel.inputs) ? $elm$html$Html$text('🖼️') : $elm$html$Html$text(''),
							$elm$core$List$member$('file', aiModel.inputs) ? $elm$html$Html$text('🗎') : $elm$html$Html$text(''),
							$elm$core$List$member$('audio', aiModel.inputs) ? $elm$html$Html$text('🔈') : $elm$html$Html$text('')
						]));
			},
			aiModels));
};
var $author$project$AiChat$aiModelSelect = F3($author$project$AiChat$aiModelSelect$);
var $author$project$AiChat$closeIcon = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M6 18 18 6M6 6l12 12')
				]),
			_List_Nil)
		]));
var $author$project$AiChat$aiModelDropdownRow$ = function (aiModels, selected, index, showRemove) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(4)
			]),
		_List_fromArray(
			[
				$author$project$Ui$html(
				$author$project$AiChat$aiModelSelect$(aiModels, selected, index)),
				showRemove ? $author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Input$button(
						$author$project$AiChat$PressedRemoveModel(index)),
						$author$project$Ui$width(
						$author$project$Ui$px(36)),
						$author$project$Ui$height(
						$author$project$Ui$px(36)),
						$author$project$Ui$background($author$project$MyUi$buttonBackground),
						$author$project$Ui$border(1),
						$author$project$Ui$borderColor($author$project$MyUi$border1),
						$author$project$Ui$rounded(4),
						$author$project$Ui$paddingXY$(8, 8),
						$author$project$MyUi$noShrinking,
						$author$project$MyUi$hoverText('Remove model')
					]),
				$author$project$Ui$html($author$project$AiChat$closeIcon)) : $author$project$Ui$none
			]));
};
var $author$project$AiChat$aiModelDropdownRow = F4($author$project$AiChat$aiModelDropdownRow$);
var $author$project$AiChat$aiModelDropdowns$ = function (status, selectedModels) {
	switch (status.$) {
		case 1:
			var aiModels = status.a;
			var rows = $elm$core$List$isEmpty(selectedModels) ? _List_fromArray(
				[
					$author$project$AiChat$aiModelDropdownRow$(aiModels, $elm$core$Maybe$Nothing, 0, false)
				]) : $elm$core$List$indexedMap$(
				F2(
					function (index, selected) {
						return $author$project$AiChat$aiModelDropdownRow$(
							aiModels,
							$elm$core$Maybe$Just(selected),
							index,
							$elm$core$List$length(selectedModels) > 1);
					}),
				selectedModels);
			var addButton = (_Utils_cmp(
				$elm$core$List$length(selectedModels),
				$author$project$AiChat$maxModels) < 0) ? _List_fromArray(
				[$author$project$AiChat$addModelButton]) : _List_Nil;
			return _Utils_ap(rows, addButton);
		case 0:
			return _List_fromArray(
				[
					$author$project$Ui$html(
					$elm$html$Html$text('Loading...'))
				]);
		default:
			var error = status.a;
			return _List_fromArray(
				[
					$author$project$Ui$html(
					$elm$html$Html$text(
						function () {
							switch (error.$) {
								case 0:
									var url = error.a;
									return 'Bad url: ' + url;
								case 1:
									return 'Request timed out';
								case 2:
									return 'Network error';
								case 3:
									var _int = error.a;
									return 'Bad status code ' + $elm$core$String$fromInt(_int);
								default:
									var string = error.a;
									return 'Bad body: ' + string;
							}
						}()))
				]);
	}
};
var $author$project$AiChat$aiModelDropdowns = F2($author$project$AiChat$aiModelDropdowns$);
var $author$project$Ui$Input$defaultRadioOption$ = function (optionLabel, status) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(10),
				$author$project$Ui$alignLeft
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$width(
						$author$project$Ui$px(14)),
						$author$project$Ui$height(
						$author$project$Ui$px(14)),
						$author$project$Ui$background($author$project$Ui$Input$white),
						$author$project$Ui$rounded(7),
						function () {
						if (status === 2) {
							return $author$project$Internal$Model2$class('focusable');
						} else {
							return $author$project$Internal$Model2$noAttr;
						}
					}(),
						$author$project$Ui$borderColor(
						function () {
							switch (status) {
								case 0:
									return $author$project$Ui$rgb$(208, 208, 208);
								case 1:
									return $author$project$Ui$rgb$(208, 208, 208);
								default:
									return $author$project$Ui$rgb$(59, 153, 252);
							}
						}()),
						$author$project$Ui$border(
						function () {
							switch (status) {
								case 0:
									return 1;
								case 1:
									return 1;
								default:
									return 5;
							}
						}())
					]),
				$author$project$Ui$none),
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$width($author$project$Ui$fill),
						$author$project$Internal$Model2$class('unfocusable')
					]),
				optionLabel)
			]));
};
var $author$project$Ui$Input$defaultRadioOption = F2($author$project$Ui$Input$defaultRadioOption$);
var $author$project$Ui$Input$option$ = function (val, txt) {
	return $author$project$Ui$Input$Option$(
		val,
		$author$project$Ui$Input$defaultRadioOption(txt));
};
var $author$project$Ui$Input$option = F2($author$project$Ui$Input$option$);
var $author$project$AiChat$optionsView = function (model) {
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$widthMax(1000),
				$author$project$Ui$centerX,
				$author$project$Ui$background($author$project$MyUi$background2),
				$author$project$Ui$border(1),
				$author$project$Ui$borderColor($author$project$MyUi$border1),
				$author$project$Ui$rounded(4),
				$author$project$Ui$spacing(12),
				$author$project$AiChat$containerShadow,
				$author$project$Ui$paddingWith(
				{bottom: 16, left: 0, right: 0, top: 0})
			]),
		_List_fromArray(
			[
				$author$project$Ui$row$(
				_List_fromArray(
					[$author$project$Ui$contentCenterY]),
				_List_fromArray(
					[
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$Font$bold,
								$author$project$Ui$Font$size(16),
								$author$project$Ui$paddingXY$(16, 0)
							]),
						$author$project$Ui$text('Options')),
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$alignRight,
								$author$project$Ui$Input$button($author$project$AiChat$PressedOptionsButton),
								$author$project$Ui$paddingXY$(8, 8),
								$author$project$Ui$rounded(4),
								$author$project$Ui$width(
								$author$project$Ui$px(42)),
								$author$project$Ui$height(
								$author$project$Ui$px(42)),
								$author$project$MyUi$hoverText('Close')
							]),
						$author$project$Ui$html($author$project$AiChat$closeIcon))
					])),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(8),
						$author$project$Ui$paddingXY$(16, 0)
					]),
				_List_fromArray(
					[
						$author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$spacing(4)
							]),
						A2(
							$elm$core$List$cons,
							$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$Font$size(14),
										$author$project$Ui$paddingXY$(4, 4)
									]),
								$author$project$Ui$text('AI Models')),
							$author$project$AiChat$aiModelDropdowns$(model.aiModels, model.selectedModels))),
						$author$project$Ui$column$(
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$Font$size(14),
										$author$project$Ui$paddingXY$(4, 4)
									]),
								$author$project$Ui$text('Send Message With')),
								$author$project$Ui$column$(
								_List_fromArray(
									[
										$author$project$Ui$spacing(4),
										$author$project$Ui$paddingXY$(4, 0)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Input$chooseOne$(
										$author$project$Ui$column,
										_List_fromArray(
											[
												$author$project$Ui$spacing(8)
											]),
										{
											label: $author$project$Ui$Input$labelHidden('send-message-with'),
											onChange: $author$project$AiChat$SelectedSendMessageWith,
											options: _List_fromArray(
												[
													$author$project$Ui$Input$option$(
													0,
													$author$project$Ui$text('Enter')),
													$author$project$Ui$Input$option$(
													1,
													$author$project$Ui$text('Shift + Enter'))
												]),
											selected: $elm$core$Maybe$Just(model.sendMessageWith)
										})
									]))
							]))
					]))
			]));
};
var $author$project$AiChat$EditedResponse$ = function (a, b) {
	return {$: 15, a: a, b: b};
};
var $author$project$AiChat$EditedResponse = F2($author$project$AiChat$EditedResponse$);
var $author$project$AiChat$PressedDelete = function (a) {
	return {$: 4, a: a};
};
var $author$project$AiChat$PressedKeep = function (a) {
	return {$: 3, a: a};
};
var $author$project$AiChat$PressedRetry = function (a) {
	return {$: 5, a: a};
};
var $author$project$Icons$checkmark = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 20 20'),
			$elm$svg$Svg$Attributes$fill('currentColor')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$d('M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z'),
					$elm$svg$Svg$Attributes$clipRule('evenodd')
				]),
			_List_Nil)
		]));
var $author$project$AiChat$formatCost = function (cost) {
	return '$' + $elm$core$String$fromFloat(
		$elm$core$Basics$round(cost * 1000000) / 1000000);
};
var $author$project$AiChat$pendingResponseCost = function (response) {
	switch (response.$) {
		case 1:
			var cost = response.d;
			return cost;
		case 0:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $elm$html$Html$details = _VirtualDom_node('details');
var $elm$html$Html$summary = _VirtualDom_node('summary');
var $author$project$AiChat$reasoningView = function (reasoning) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$paddingXY$(8, 8),
				$author$project$Ui$Font$size(14),
				$author$project$Ui$Font$color($author$project$MyUi$font3),
				$author$project$Ui$background($author$project$MyUi$background2),
				$author$project$Ui$borderWith(
				{bottom: 1, left: 0, right: 0, top: 0}),
				$author$project$Ui$borderColor($author$project$MyUi$inputBorder)
			]),
		$author$project$Ui$html(
			A2(
				$elm$html$Html$details,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$summary,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'cursor', 'pointer')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Chain of thought')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'white-space', 'pre-wrap'),
								A2($elm$html$Html$Attributes$style, 'padding-top', '8px')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(reasoning)
							]))
					]))));
};
var $author$project$AiChat$refreshIcon = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99')
				]),
			_List_Nil)
		]));
var $author$project$AiChat$responseButton$ = function (msg, color, attributes, icon, text) {
	return $author$project$Ui$row$(
		A2(
			$elm$core$List$cons,
			$author$project$Ui$background(color),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$paddingXY$(16, 4),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Font$bold,
					A2(
						$elm$core$List$cons,
						$author$project$Ui$Input$button(msg),
						A2(
							$elm$core$List$cons,
							$author$project$Ui$width($author$project$Ui$shrink),
							A2(
								$elm$core$List$cons,
								$author$project$Ui$spacing(4),
								attributes)))))),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$width(
						$author$project$Ui$px(20)),
						$author$project$Ui$centerY
					]),
				$author$project$Ui$html(icon)),
				$author$project$Ui$text(text)
			]));
};
var $author$project$AiChat$responseButton = F5($author$project$AiChat$responseButton$);
var $author$project$AiChat$responseView$ = function (windowWidth, responseCount, responseId, response) {
	var modelId = $author$project$AiChat$pendingResponseModelId(response);
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$width(
				$author$project$Ui$px(
					$elm$core$Basics$min$(1000, (((windowWidth - 32) - 8) / responseCount) | 0))),
				$author$project$Ui$above(
				$author$project$Ui$row$(
					_List_fromArray(
						[
							$author$project$Ui$alignRight,
							$author$project$Ui$width($author$project$Ui$shrink),
							$author$project$Ui$borderWith(
							{bottom: 0, left: 1, right: 1, top: 1}),
							$author$project$Ui$roundedWith(
							{bottomLeft: 0, bottomRight: 0, topLeft: 4, topRight: 4}),
							$author$project$Ui$move(
							{x: -32, y: 0, z: 0}),
							$author$project$Ui$clip,
							$author$project$Ui$borderColor($author$project$MyUi$inputBorder)
						]),
					_List_fromArray(
						[
							function () {
							switch (response.$) {
								case 1:
									return $author$project$AiChat$responseButton$(
										$author$project$AiChat$PressedKeep(responseId),
										$author$project$MyUi$background2,
										_List_Nil,
										$author$project$Icons$checkmark,
										'Keep');
								case 0:
									return $author$project$Ui$none;
								default:
									return $author$project$Ui$none;
							}
						}(),
							$author$project$AiChat$responseButton$(
							$author$project$AiChat$PressedRetry(responseId),
							$author$project$MyUi$background3,
							_List_Nil,
							$author$project$AiChat$refreshIcon,
							'Retry'),
							$author$project$AiChat$responseButton$(
							$author$project$AiChat$PressedDelete(responseId),
							$author$project$MyUi$deleteButtonBackground,
							_List_fromArray(
								[
									$author$project$Ui$border(1),
									$author$project$Ui$borderColor($author$project$MyUi$deleteButtonBorder)
								]),
							$author$project$AiChat$deleteIcon,
							'Delete')
						]))),
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$AiChat$containerShadow,
				$author$project$Ui$htmlAttribute(
				A2($elm$html$Html$Attributes$style, 'min-height', '0'))
			]),
		$author$project$Ui$column$(
			_List_fromArray(
				[
					$author$project$Ui$height($author$project$Ui$fill),
					$author$project$Ui$htmlAttribute(
					A2($elm$html$Html$Attributes$style, 'min-height', '0'))
				]),
			_List_fromArray(
				[
					function () {
					switch (response.$) {
						case 0:
							return $author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$border(1),
										$author$project$Ui$paddingXY$(8, 8),
										$author$project$Ui$height($author$project$Ui$fill),
										$author$project$Ui$scrollable,
										$author$project$MyUi$id(
										$author$project$AiChat$responseContainerId(responseId)),
										$author$project$Ui$roundedWith(
										{bottomLeft: 0, bottomRight: 0, topLeft: 4, topRight: 4}),
										$author$project$Ui$borderColor($author$project$MyUi$inputBorder)
									]),
								$author$project$Ui$text('Loading...'));
						case 1:
							var response2 = response.b;
							var maybeReasoning = response.c;
							return $author$project$Ui$column$(
								_List_fromArray(
									[
										$author$project$Ui$scrollable,
										$author$project$Ui$roundedWith(
										{bottomLeft: 0, bottomRight: 0, topLeft: 4, topRight: 4}),
										$author$project$Ui$border(1),
										$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
										$author$project$MyUi$id(
										$author$project$AiChat$responseContainerId(responseId)),
										$author$project$Ui$htmlAttribute(
										A2($elm$html$Html$Attributes$style, 'min-height', '0'))
									]),
								_List_fromArray(
									[
										function () {
										if (!maybeReasoning.$) {
											var reasoning = maybeReasoning.a;
											return $author$project$AiChat$reasoningView(reasoning);
										} else {
											return $author$project$Ui$none;
										}
									}(),
										$author$project$Ui$Input$multiline$(
										_List_fromArray(
											[
												$author$project$Ui$paddingXY$(8, 8),
												$author$project$MyUi$htmlStyle$('white-space', 'pre-wrap'),
												$author$project$Ui$border(0),
												$author$project$Ui$background($author$project$MyUi$inputBackground)
											]),
										{
											label: $author$project$Ui$Input$labelHidden('AI response'),
											onChange: $author$project$AiChat$EditedResponse(responseId),
											placeholder: $elm$core$Maybe$Just('No response'),
											spellcheck: true,
											text: response2
										})
									]));
						default:
							var error = response.b;
							return $author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$border(1),
										$author$project$Ui$paddingXY$(8, 8),
										$author$project$Ui$height($author$project$Ui$fill),
										$author$project$Ui$roundedWith(
										{bottomLeft: 0, bottomRight: 0, topLeft: 4, topRight: 4}),
										$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
										$author$project$Ui$scrollable,
										$author$project$Ui$htmlAttribute(
										A2($elm$html$Html$Attributes$style, 'min-height', '0')),
										$author$project$Ui$Font$italic,
										$author$project$Ui$Font$color($author$project$MyUi$errorColor)
									]),
								function () {
									switch (error.$) {
										case 2:
											return $author$project$Ui$text('Network error');
										case 0:
											var url = error.a;
											return $author$project$Ui$text('Bad url: ' + url);
										case 1:
											return $author$project$Ui$text('Request timed out');
										case 3:
											var _int = error.a;
											return $author$project$Ui$text(
												'Bad status code: ' + $elm$core$String$fromInt(_int));
										default:
											var string = error.a;
											return $author$project$Ui$text('Error in response body: ' + string);
									}
								}());
					}
				}(),
					$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$Font$size(14),
							$author$project$Ui$Font$color($author$project$MyUi$font3),
							$author$project$Ui$paddingXY$(8, 3),
							$author$project$Ui$borderWith(
							{bottom: 1, left: 1, right: 1, top: 0}),
							$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
							$author$project$Ui$roundedWith(
							{bottomLeft: 4, bottomRight: 4, topLeft: 0, topRight: 0})
						]),
					$author$project$Ui$text(
						_Utils_ap(
							$author$project$AiChat$aiModelNameToString(modelId),
							function () {
								var _v4 = $author$project$AiChat$pendingResponseCost(response);
								if (!_v4.$) {
									var cost = _v4.a;
									return ' · ' + $author$project$AiChat$formatCost(cost);
								} else {
									return '';
								}
							}())))
				])));
};
var $author$project$AiChat$responseView = F4($author$project$AiChat$responseView$);
var $author$project$AiChat$showOptionsButton = $author$project$Ui$el$(
	_List_fromArray(
		[
			$author$project$Ui$Input$button($author$project$AiChat$PressedOptionsButton),
			$author$project$Ui$paddingXY$(4, 4),
			$author$project$Ui$background($author$project$MyUi$buttonBackground),
			$author$project$Ui$border(1),
			$author$project$Ui$borderColor($author$project$MyUi$border1),
			$author$project$Ui$rounded(4),
			$author$project$Ui$width(
			$author$project$Ui$px(36)),
			$author$project$Ui$height(
			$author$project$Ui$px(36)),
			$author$project$MyUi$hoverText('Options')
		]),
	$author$project$Ui$html($author$project$Icons$gear));
var $author$project$AiChat$PressedSend = {$: 1};
var $author$project$AiChat$TypedMessage = function (a) {
	return {$: 0, a: a};
};
var $author$project$AiChat$sendIcon = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5')
				]),
			_List_Nil)
		]));
var $author$project$AiChat$userMessageView = function (model) {
	var message = model.message;
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$AiChat$containerShadow,
				$author$project$Ui$rounded(4)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Input$multiline$(
				_List_fromArray(
					[
						$author$project$Ui$Events$preventDefaultOn$(
						'keydown',
						A2(
							$elm$json$Json$Decode$andThen,
							function (_v0) {
								var key = _v0.a;
								var shiftHeld = _v0.b;
								var _v1 = model.sendMessageWith;
								if (!_v1) {
									return ((key === 'Enter') && (!shiftHeld)) ? $elm$json$Json$Decode$succeed(
										_Utils_Tuple2($author$project$AiChat$PressedSend, true)) : $elm$json$Json$Decode$fail('');
								} else {
									return ((key === 'Enter') && shiftHeld) ? $elm$json$Json$Decode$succeed(
										_Utils_Tuple2($author$project$AiChat$PressedSend, true)) : $elm$json$Json$Decode$fail('');
								}
							},
							A3(
								$elm$json$Json$Decode$map2,
								$elm$core$Tuple$pair,
								A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
								A2($elm$json$Json$Decode$field, 'shiftKey', $elm$json$Json$Decode$bool)))),
						$author$project$Ui$paddingXY$(8, 6),
						$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
						$author$project$Ui$roundedWith(
						{bottomLeft: 4, bottomRight: 0, topLeft: 4, topRight: 0}),
						$author$project$Ui$attrIf$(message === '', $author$project$Ui$Font$italic),
						$author$project$Ui$attrIf$(
						message === '',
						$author$project$Ui$Font$color($author$project$MyUi$font3)),
						$author$project$Ui$background($author$project$MyUi$inputBackground)
					]),
				{
					label: $author$project$Ui$Input$labelHidden('message'),
					onChange: $author$project$AiChat$TypedMessage,
					placeholder: $elm$core$Maybe$Just('Type a message'),
					spellcheck: true,
					text: message
				}),
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Input$button($author$project$AiChat$PressedSend),
						$author$project$Ui$width(
						$author$project$Ui$px(40)),
						$author$project$Ui$paddingXY$(8, 0),
						$author$project$Ui$background($author$project$MyUi$buttonBackground),
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$contentCenterY,
						$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
						$author$project$Ui$borderWith(
						{bottom: 1, left: 0, right: 1, top: 1}),
						$author$project$Ui$roundedWith(
						{bottomLeft: 0, bottomRight: 4, topLeft: 0, topRight: 4}),
						$author$project$MyUi$noShrinking,
						$author$project$MyUi$hoverText('Send')
					]),
				$author$project$Ui$html($author$project$AiChat$sendIcon))
			]));
};
var $author$project$AiChat$view$ = function (windowSize, safeAreaInsetTop, safeAreaInsetBottom, model) {
	var responseCount = $lamdera$containers$SeqDict$size(model.pendingResponses);
	var isMobile2 = $author$project$AiChat$isMobile(windowSize);
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				isMobile2 ? $author$project$Ui$paddingWith(
				{bottom: safeAreaInsetBottom, left: 0, right: 0, top: 0}) : $author$project$Ui$paddingXY$(16, 16),
				isMobile2 ? $author$project$Ui$spacing(8) : $author$project$Ui$spacing(16),
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$Ui$htmlAttribute(
				A2($elm$html$Html$Attributes$style, 'min-height', '0')),
				$author$project$Ui$Font$color($author$project$MyUi$font1),
				$author$project$Ui$background($author$project$MyUi$background1),
				$author$project$Ui$inFront(
				$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$MyUi$htmlStyle$(
							'height',
							$elm$core$String$fromInt(safeAreaInsetTop) + 'px'),
							$author$project$Ui$backgroundGradient(
							_List_fromArray(
								[
									$author$project$Ui$Gradient$linear$(
									$author$project$Ui$radians(0),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Gradient$percent,
											0,
											$author$project$Ui$rgba$(0, 0, 0, 0)),
											A2($author$project$Ui$Gradient$percent, 100, $author$project$MyUi$background1)
										]))
								]))
						]),
					$author$project$Ui$none))
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$htmlAttribute(
						A2($elm$html$Html$Attributes$style, 'min-height', '0')),
						$author$project$Ui$inFront(
						($elm$core$String$trim(model.chatHistory) === '') ? $author$project$Ui$none : $author$project$Ui$row$(
							_List_fromArray(
								[
									$author$project$Ui$alignRight,
									$author$project$Ui$Input$button($author$project$AiChat$PressedClearChatHistory),
									$author$project$Ui$paddingXY$(6, 4),
									$author$project$Ui$rounded(4),
									$author$project$Ui$background($author$project$MyUi$buttonBackground),
									$author$project$Ui$border(1),
									$author$project$Ui$borderColor($author$project$MyUi$border1),
									$author$project$MyUi$htmlStyle$(
									'transform',
									'translateX(-21px) translateY(' + ($elm$core$String$fromInt(4 + safeAreaInsetTop) + 'px)')),
									$author$project$Ui$Font$size(14),
									$author$project$Ui$Font$bold,
									$author$project$Ui$spacing(4)
								]),
							_List_fromArray(
								[
									$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$width(
											$author$project$Ui$px(16)),
											$author$project$Ui$centerY
										]),
									$author$project$Ui$html($author$project$AiChat$deleteIcon)),
									$author$project$Ui$text('Reset')
								]))),
						$author$project$Ui$widthMax(1000),
						$author$project$Ui$centerX,
						$author$project$Ui$attrIf$(
						responseCount > 0,
						$author$project$Ui$heightMax(
							($author$project$Coord$yRaw(windowSize) / 2) | 0)),
						$author$project$Ui$height($author$project$Ui$fill)
					]),
				$author$project$Ui$column$(
					_List_fromArray(
						[
							$author$project$Ui$htmlAttribute(
							A2($elm$html$Html$Attributes$style, 'min-height', '0')),
							$author$project$MyUi$htmlStyle$('overflow-y', 'scroll'),
							$author$project$Ui$attrIf$(
							!isMobile2,
							$author$project$Ui$rounded(4)),
							$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
							isMobile2 ? $author$project$Ui$borderWith(
							{bottom: 1, left: 0, right: 0, top: 0}) : $author$project$Ui$border(1),
							$author$project$MyUi$id($author$project$AiChat$chatHistoryId),
							$author$project$Ui$Events$onClick($author$project$AiChat$PressedChatHistoryContainer),
							$author$project$Ui$attrIf$(
							model.chatHistory === '',
							$author$project$Ui$Font$color($author$project$MyUi$font3)),
							$author$project$Ui$attrIf$(model.chatHistory === '', $author$project$Ui$Font$italic),
							$author$project$AiChat$containerShadow,
							$author$project$Ui$height($author$project$Ui$fill),
							$author$project$Ui$background($author$project$MyUi$inputBackground),
							$author$project$Ui$paddingWith(
							{bottom: 0, left: 0, right: 0, top: safeAreaInsetTop})
						]),
					_List_fromArray(
						[
							$author$project$Ui$Input$multiline$(
							_List_fromArray(
								[
									$author$project$Ui$border(0),
									$author$project$MyUi$id($author$project$AiChat$chatHistoryInputId),
									$author$project$Ui$paddingXY$(12, 8),
									$author$project$Ui$background($author$project$MyUi$inputBackground)
								]),
							{
								label: $author$project$Ui$Input$labelHidden('chat-history-label'),
								onChange: $author$project$AiChat$TypedChatHistory,
								placeholder: $elm$core$Maybe$Just('Nothing in the chat history yet...'),
								spellcheck: true,
								text: model.chatHistory
							})
						]))),
				(!responseCount) ? $author$project$Ui$none : $author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$htmlAttribute(
						A2($elm$html$Html$Attributes$style, 'min-height', '0')),
						isMobile2 ? $author$project$Ui$paddingXY$(0, 0) : $author$project$Ui$paddingXY$(16, 0),
						$author$project$Ui$centerX,
						$author$project$Ui$spacing(8),
						$author$project$Ui$height(
						$author$project$Ui$px(
							($author$project$Coord$yRaw(windowSize) / 2) | 0))
					]),
				$elm$core$List$map$(
					function (_v0) {
						var responseId = _v0.a;
						var response = _v0.b;
						return $author$project$AiChat$responseView$(
							$author$project$Coord$xRaw(windowSize),
							responseCount,
							responseId,
							response);
					},
					$lamdera$containers$SeqDict$toList(model.pendingResponses))),
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(8),
						$author$project$Ui$widthMax(1000),
						$author$project$Ui$centerX,
						$author$project$Ui$paddingXY$(8, 0)
					]),
				_List_fromArray(
					[
						((model.message === '') || (!isMobile2)) ? $author$project$AiChat$showOptionsButton : $author$project$Ui$none,
						$author$project$AiChat$userMessageView(model)
					])),
				model.showOptions ? $author$project$AiChat$optionsView(model) : $author$project$Ui$none
			]));
};
var $author$project$AiChat$view = F4($author$project$AiChat$view$);
var $author$project$LoginForm$PressedSubmitUserData = {$: 6};
var $author$project$LoginForm$TypedName = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Events$Enter = {$: 0};
var $author$project$Ui$Events$enter = $author$project$Ui$Events$Enter;
var $author$project$LoginForm$PressedCancelLogin = {$: 1};
var $author$project$LoginForm$PressedSubmitEmail = {$: 0};
var $author$project$LoginForm$TypedLoginFormEmail = function (a) {
	return {$: 2, a: a};
};
var $author$project$LoginForm$cancelButtonId = $lamdera$program_test$Effect$Browser$Dom$id('loginForm_cancelButton');
var $author$project$MyUi$rhythm = 8;
var $author$project$MyUi$spacing = $author$project$Ui$spacing($author$project$MyUi$rhythm);
var $author$project$MyUi$column$ = function (attrs, children) {
	return $author$project$Ui$column$(
		A2($elm$core$List$cons, $author$project$MyUi$spacing, attrs),
		children);
};
var $author$project$MyUi$column = F2($author$project$MyUi$column$);
var $author$project$Ui$Input$email = function (attrs) {
	return A2(
		$author$project$Ui$Input$textHelper,
		{
			autofill: $elm$core$Maybe$Just('email'),
			spellchecked: false,
			type_: $author$project$Ui$Input$TextInputNode('email')
		},
		_Utils_ap(
			attrs,
			_List_fromArray(
				[
					$author$project$Ui$id('email')
				])));
};
var $author$project$LoginForm$emailInputId = $lamdera$program_test$Effect$Browser$Dom$id('loginForm_emailInput');
var $author$project$LoginForm$errorView = function (errorMessage) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$width($author$project$Ui$shrink),
				$author$project$Ui$Font$color($author$project$MyUi$errorColor),
				$author$project$Ui$Font$weight(500)
			]),
		$author$project$Ui$text(errorMessage));
};
var $author$project$Internal$Model2$onKey = function (details) {
	var decode = function (code) {
		return _Utils_eq(code, details.key) ? $elm$json$Json$Decode$succeed(details.msg) : $elm$json$Json$Decode$fail('Not the enter key');
	};
	var isKey = A2(
		$elm$json$Json$Decode$andThen,
		decode,
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
	return {
		attr: {
			additionalInheritance: $author$project$Internal$BitField$none,
			attrs: _List_fromArray(
				[
					$elm$html$Html$Events$preventDefaultOn$(
					'keyup',
					A2(
						$elm$json$Json$Decode$map,
						function (fired) {
							return _Utils_Tuple2(fired, true);
						},
						isKey)),
					$elm$html$Html$Attributes$tabindex(0)
				]),
			_class: $elm$core$Maybe$Nothing,
			nearby: $elm$core$Maybe$Nothing,
			node: $author$project$Internal$Model2$NodeAsDiv,
			styles: $author$project$Internal$Model2$noStyles
		},
		flag: $author$project$Internal$Flag$skip
	};
};
var $author$project$Ui$Events$toCodeString = function (myKey) {
	switch (myKey.$) {
		case 0:
			return 'Enter';
		case 1:
			return 'Space';
		case 2:
			return 'ArrowUp';
		case 3:
			return 'ArrowDown';
		case 4:
			return 'ArrowLeft';
		case 5:
			return 'ArrowRight';
		case 6:
			return 'Backspace';
		default:
			var str = myKey.a;
			return str;
	}
};
var $author$project$Ui$Events$onKey$ = function (desiredKey, msg) {
	return $author$project$Internal$Model2$onKey(
		{
			key: $author$project$Ui$Events$toCodeString(desiredKey),
			msg: msg
		});
};
var $author$project$Ui$Events$onKey = F2($author$project$Ui$Events$onKey$);
var $author$project$LoginForm$emailInput$ = function (onSubmit, onChange, text, labelText, maybeError) {
	var label = $author$project$Ui$Input$label$(
		$lamdera$program_test$Effect$Browser$Dom$idToString($author$project$LoginForm$emailInputId),
		_List_fromArray(
			[
				$author$project$Ui$Font$weight(600)
			]),
		$author$project$Ui$text(labelText));
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(4)
			]),
		_List_fromArray(
			[
				$author$project$MyUi$column$(
				_List_Nil,
				_List_fromArray(
					[
						label.element,
						A2(
						$author$project$Ui$Input$email,
						_List_fromArray(
							[
								$author$project$Ui$Events$onKey$($author$project$Ui$Events$enter, onSubmit),
								$author$project$Ui$background($author$project$MyUi$inputBackground),
								$author$project$Ui$Font$color($author$project$MyUi$font1),
								function () {
								if (!maybeError.$) {
									return $author$project$Ui$borderColor($author$project$MyUi$errorColor);
								} else {
									return $author$project$Ui$borderColor($author$project$MyUi$inputBorder);
								}
							}()
							]),
						{label: label.id, onChange: onChange, placeholder: $elm$core$Maybe$Nothing, text: text})
					])),
				$elm$core$Maybe$withDefault$(
				$author$project$Ui$none,
				$elm$core$Maybe$map$($author$project$LoginForm$errorView, maybeError))
			]));
};
var $author$project$LoginForm$emailInput = F5($author$project$LoginForm$emailInput$);
var $author$project$LoginForm$submitEmailButtonId = $lamdera$program_test$Effect$Browser$Dom$id('loginForm_loginButton');
var $author$project$LoginForm$validateEmail = function (text) {
	return $elm$core$Result$fromMaybe$(
		$elm$core$String$isEmpty(text) ? 'Enter your email first' : 'Invalid email address',
		$author$project$EmailAddress$fromString(text));
};
var $author$project$LoginForm$enterEmailView = function (model) {
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(16)
			]),
		_List_fromArray(
			[
				$author$project$LoginForm$emailInput$(
				$author$project$LoginForm$PressedSubmitEmail,
				$author$project$LoginForm$TypedLoginFormEmail,
				model.email,
				'Enter your email address to login/signup',
				function () {
					var _v0 = _Utils_Tuple2(
						model.pressedSubmitEmail,
						$author$project$LoginForm$validateEmail(model.email));
					if (_v0.a && (_v0.b.$ === 1)) {
						var error = _v0.b.a;
						return $elm$core$Maybe$Just(error);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}()),
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(16)
					]),
				_List_fromArray(
					[
						$author$project$MyUi$secondaryButtonTall$($author$project$LoginForm$cancelButtonId, $author$project$LoginForm$PressedCancelLogin, 'Cancel'),
						$author$project$MyUi$simpleButton$(
						$author$project$LoginForm$submitEmailButtonId,
						$author$project$LoginForm$PressedSubmitEmail,
						$author$project$Ui$text('Login'))
					])),
				model.rateLimited ? $author$project$LoginForm$errorView('Too many login attempts have been made. Please try again later.') : (model.showSignupsDisabled ? $author$project$LoginForm$errorView('New sign ups are currently disabled.') : (model.showUserIsDeleted ? $author$project$LoginForm$errorView('Your account was deleted as you were logging in.') : $author$project$Ui$none))
			]));
};
var $author$project$LoginForm$TypedLoginCode = function (a) {
	return {$: 3, a: a};
};
var $author$project$LoginForm$checkYourEmailText = 'Check your email for a code';
var $author$project$Animator$loop = function (steps) {
	return $author$project$Animator$loopFor$(-1, steps);
};
var $author$project$Ui$Anim$loop = $author$project$Animator$loop;
var $author$project$Ui$Anim$set = $author$project$Animator$set;
var $author$project$LoginForm$cursorBlinking = $author$project$Ui$Anim$keyframes(
	_List_fromArray(
		[
			$author$project$Ui$Anim$loop(
			_List_fromArray(
				[
					$author$project$Ui$Anim$set(
					_List_fromArray(
						[
							$author$project$Ui$Anim$opacity(1)
						])),
					A2(
					$author$project$Ui$Anim$step,
					$author$project$Ui$Anim$ms(999),
					_List_fromArray(
						[
							$author$project$Ui$Anim$opacity(1)
						])),
					A2(
					$author$project$Ui$Anim$step,
					$author$project$Ui$Anim$ms(1),
					_List_fromArray(
						[
							$author$project$Ui$Anim$opacity(0)
						])),
					A2(
					$author$project$Ui$Anim$step,
					$author$project$Ui$Anim$ms(999),
					_List_fromArray(
						[
							$author$project$Ui$Anim$opacity(0)
						]))
				]))
		]));
var $author$project$LoginForm$inputFont = $author$project$MyUi$monospace;
var $author$project$Ui$scale = function (s) {
	return $author$project$Internal$Model2$style$(
		'scale',
		$elm$core$String$fromFloat(s));
};
var $author$project$LoginForm$loginCodeInput$ = function (windowSize, codeLength, onInput, textInputFocus, loginCode, label) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$Font$size(36),
				($author$project$Coord$xRaw(windowSize) < 380) ? $author$project$Ui$scale(0.85) : (($author$project$Coord$xRaw(windowSize) < 430) ? $author$project$Ui$scale(0.9) : $author$project$Ui$noAttr),
				$author$project$Ui$behindContent(
				$author$project$Ui$Prose$paragraph$(
					_List_fromArray(
						[
							$author$project$Ui$Font$letterSpacing(26),
							$author$project$Ui$paddingXY$(0, 6),
							$author$project$LoginForm$inputFont,
							$author$project$MyUi$noPointerEvents
						]),
					$elm$core$List$map$(
						function (index) {
							var _char = function () {
								if (_Utils_cmp(
									$elm$core$String$length(loginCode),
									index) > 0) {
									var _v1 = $elm$core$String$uncons(
										A3($elm$core$String$slice, index, index + 1, loginCode));
									if (!_v1.$) {
										var _v2 = _v1.a;
										var head = _v2.a;
										return $author$project$Ui$el$(
											_List_fromArray(
												[
													$author$project$Ui$width($author$project$Ui$shrink),
													$author$project$Ui$centerX,
													$author$project$Ui$centerY,
													$author$project$MyUi$noPointerEvents
												]),
											$author$project$Ui$html(
												A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															A2($elm$html$Html$Attributes$style, 'display', 'flex')
														]),
													_List_fromArray(
														[
															$author$project$Icons$number$(20, head)
														]))));
									} else {
										return $author$project$Ui$none;
									}
								} else {
									return $author$project$Ui$none;
								}
							}();
							return $author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$paddingXY$(-1, -1),
										$author$project$Ui$behindContent(
										$author$project$Ui$el$(
											_Utils_ap(
												_List_fromArray(
													[
														$author$project$Ui$height(
														$author$project$Ui$px(54)),
														$author$project$Ui$paddingXY$(0, 24),
														$author$project$Ui$width(
														$author$project$Ui$px(32)),
														$author$project$Ui$Font$color($author$project$MyUi$font1),
														$author$project$Ui$inFront(_char),
														_Utils_eq(index, ((codeLength - 1) / 2) | 0) ? $author$project$Ui$onRight(
														$author$project$Ui$el$(
															_List_fromArray(
																[
																	$author$project$Ui$borderWith(
																	{bottom: 1, left: 0, right: 0, top: 1}),
																	$author$project$Ui$move(
																	$author$project$Ui$right(3)),
																	$author$project$Ui$centerY,
																	$author$project$Ui$width(
																	$author$project$Ui$px(9))
																]),
															$author$project$Ui$none)) : $author$project$Ui$noAttr,
														$author$project$Ui$border(1),
														$author$project$Ui$rounded(8),
														$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
														$author$project$Ui$Shadow$shadows(
														_List_fromArray(
															[
																{
																blur: 2,
																color: $author$project$Ui$rgba$(0, 0, 0, 0.2),
																size: 0,
																x: 0,
																y: 1
															}
															])),
														$author$project$MyUi$noPointerEvents
													]),
												function () {
													if (!textInputFocus.$) {
														var textInputFocus2 = textInputFocus.a;
														var range = textInputFocus2.selection;
														return (_Utils_eq(range.start, range.end) && _Utils_eq(index, range.start)) ? _List_fromArray(
															[
																$author$project$Ui$background($author$project$MyUi$inputBackground),
																$author$project$Ui$inFront(
																$author$project$Ui$el$(
																	_List_fromArray(
																		[
																			$author$project$Ui$paddingXY$(4, 0),
																			$author$project$Ui$height($author$project$Ui$fill),
																			$author$project$MyUi$noPointerEvents
																		]),
																	$author$project$Ui$el$(
																		_List_fromArray(
																			[
																				$author$project$Ui$height($author$project$Ui$fill),
																				$author$project$Ui$background($author$project$MyUi$white),
																				$author$project$Ui$borderWith(
																				{bottom: 0, left: 2, right: 0, top: 0}),
																				$author$project$LoginForm$cursorBlinking
																			]),
																		$author$project$Ui$none)))
															]) : ((_Utils_eq(range.start, range.end) && (_Utils_eq(range.start, codeLength) && _Utils_eq(index, codeLength - 1))) ? _List_fromArray(
															[
																$author$project$Ui$background($author$project$MyUi$inputBackground),
																$author$project$Ui$inFront(
																$author$project$Ui$el$(
																	_List_fromArray(
																		[
																			$author$project$Ui$paddingXY$(4, 0),
																			$author$project$Ui$height($author$project$Ui$fill),
																			$author$project$Ui$alignRight,
																			$author$project$MyUi$noPointerEvents
																		]),
																	$author$project$Ui$el$(
																		_List_fromArray(
																			[
																				$author$project$Ui$height($author$project$Ui$fill),
																				$author$project$Ui$background($author$project$MyUi$white),
																				$author$project$Ui$borderWith(
																				{bottom: 0, left: 2, right: 0, top: 0}),
																				$author$project$LoginForm$cursorBlinking
																			]),
																		$author$project$Ui$none)))
															]) : (((_Utils_cmp(range.start, index) < 1) && (_Utils_cmp(index, range.end) < 0)) ? _List_fromArray(
															[
																$author$project$Ui$background($author$project$MyUi$selectedTextBackground)
															]) : _List_fromArray(
															[
																$author$project$Ui$background($author$project$MyUi$inputBackground)
															])));
													} else {
														return _List_fromArray(
															[
																$author$project$Ui$background($author$project$MyUi$inputBackground)
															]);
													}
												}()),
											$author$project$Ui$none)),
										$author$project$Ui$Font$color(
										$author$project$Ui$rgba$(0, 0, 0, 0)),
										$author$project$MyUi$noPointerEvents
									]),
								$author$project$Ui$text('_'));
						},
						$elm$core$List$range$(0, codeLength - 1)))),
				$author$project$Ui$width(
				$author$project$Ui$px(50 * codeLength))
			]),
		A2(
			$author$project$Ui$Input$text,
			_List_fromArray(
				[
					$author$project$Ui$Font$letterSpacing(26),
					$author$project$Ui$paddingWith(
					{bottom: 8, left: 6, right: 0, top: 0}),
					$author$project$LoginForm$inputFont,
					$author$project$Ui$htmlAttribute(
					A2($elm$html$Html$Attributes$attribute, 'inputmode', 'numeric')),
					$author$project$Ui$htmlAttribute(
					A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'one-time-code')),
					$author$project$Ui$border(0),
					$author$project$Ui$background(
					$author$project$Ui$rgba$(0, 0, 0, 0)),
					$author$project$Ui$Font$color(
					$author$project$Ui$rgba$(0, 0, 0, 0)),
					$author$project$Ui$htmlAttribute(
					A2($elm$html$Html$Attributes$style, '-webkit-text-fill-color', 'transparent')),
					$author$project$Ui$htmlAttribute(
					A2($elm$html$Html$Attributes$style, 'caret-color', 'transparent')),
					$author$project$Ui$htmlAttribute(
					A2($elm$html$Html$Attributes$style, 'outline', 'none')),
					$author$project$Ui$htmlAttribute(
					$elm$html$Html$Attributes$class('rich-text-input'))
				]),
			{label: label.id, onChange: onInput, placeholder: $elm$core$Maybe$Nothing, text: loginCode}));
};
var $author$project$LoginForm$loginCodeInput = F6($author$project$LoginForm$loginCodeInput$);
var $author$project$LoginForm$loginCodeInputId = $lamdera$program_test$Effect$Browser$Dom$id('loginForm_loginCodeInput');
var $author$project$LoginForm$maxLoginAttempts = 10;
var $author$project$LoginForm$enterLoginCodeView$ = function (windowSize, textSelection, model) {
	var label = $author$project$Ui$Input$label$(
		$lamdera$program_test$Effect$Browser$Dom$idToString($author$project$LoginForm$loginCodeInputId),
		_List_Nil,
		$author$project$MyUi$column$(
			_List_fromArray(
				[
					$author$project$Ui$Font$center,
					$author$project$Ui$spacing(16)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Prose$paragraph$(
					_List_fromArray(
						[
							$author$project$Ui$Font$size(30),
							$author$project$Ui$Font$weight(600)
						]),
					_List_fromArray(
						[
							$author$project$Ui$text($author$project$LoginForm$checkYourEmailText)
						])),
					$author$project$Ui$Prose$paragraph$(
					_List_fromArray(
						[
							$author$project$Ui$width($author$project$Ui$shrink)
						]),
					_List_fromArray(
						[
							$author$project$Ui$text('An email has been sent to '),
							$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$Font$weight(600)
								]),
							$author$project$Ui$text(
								$author$project$EmailAddress$toString(model.sentTo))),
							$author$project$Ui$text(
							' containing an ' + ($elm$core$String$fromInt($author$project$LoginForm$loginCodeLength) + ' digit code. Please enter that code here.'))
						]))
				])));
	return $author$project$Ui$column$(
		_List_Nil,
		_List_fromArray(
			[
				label.element,
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4),
						$author$project$Ui$centerX,
						$author$project$Ui$width($author$project$Ui$shrink),
						$author$project$Ui$move(
						$author$project$Ui$right(18)),
						$author$project$Ui$paddingWith(
						{bottom: 4, left: 0, right: 0, top: 24})
					]),
				_List_fromArray(
					[
						$author$project$Ui$el$(
						_List_fromArray(
							[$author$project$Ui$centerX]),
						$author$project$LoginForm$loginCodeInput$(windowSize, $author$project$LoginForm$loginCodeLength, $author$project$LoginForm$TypedLoginCode, textSelection, model.code, label)),
						function () {
						if (_Utils_cmp(
							$lamdera$containers$SeqDict$size(model.attempts),
							$author$project$LoginForm$maxLoginAttempts) < 0) {
							var _v0 = $author$project$LoginForm$validateCode$($author$project$LoginForm$loginCodeLength, model.code);
							if (!_v0.$) {
								var loginCode = _v0.a;
								var _v1 = $lamdera$containers$SeqDict$get$(loginCode, model.attempts);
								if ((!_v1.$) && (_v1.a === 1)) {
									var _v2 = _v1.a;
									return $author$project$LoginForm$errorView('Incorrect code');
								} else {
									return $author$project$Ui$text('\u00A0');
								}
							} else {
								var error = _v0.a;
								return $author$project$LoginForm$errorView(error);
							}
						} else {
							return $author$project$LoginForm$errorView('Too many incorrect attempts. Please refresh the page and try again.');
						}
					}()
					])),
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$centerX,
						$author$project$Ui$width($author$project$Ui$shrink)
					]),
				$author$project$MyUi$secondaryButtonTall$(
					$author$project$LoginForm$cancelButtonId,
					$author$project$LoginForm$PressedCancelLogin,
					$author$project$LoginForm$isCheckingCode$($author$project$LoginForm$loginCodeLength, model) ? 'Submitting...' : 'Cancel login'))
			]));
};
var $author$project$LoginForm$enterLoginCodeView = F3($author$project$LoginForm$enterLoginCodeView$);
var $author$project$LoginForm$TypedTwoFactorCode = function (a) {
	return {$: 4, a: a};
};
var $author$project$LoginForm$enterTwoFactorCodeView$ = function (windowSize, textSelection, model) {
	var label = $author$project$Ui$Input$label$(
		'loginForm_twoFactorCodeInput',
		_List_Nil,
		$author$project$MyUi$column$(
			_List_fromArray(
				[
					$author$project$Ui$Font$center,
					$author$project$Ui$spacing(16)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Prose$paragraph$(
					_List_fromArray(
						[
							$author$project$Ui$Font$size(30),
							$author$project$Ui$Font$weight(600)
						]),
					_List_fromArray(
						[
							$author$project$Ui$text('Two Factor Authentication')
						])),
					$author$project$Ui$text(
					'Open your authenticator app and copy the ' + ($elm$core$String$fromInt($author$project$LoginForm$twoFactorCodeLength) + ' digit code here'))
				])));
	return $author$project$Ui$column$(
		_List_Nil,
		_List_fromArray(
			[
				label.element,
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(8),
						$author$project$Ui$centerX,
						$author$project$Ui$width($author$project$Ui$shrink),
						$author$project$Ui$move(
						$author$project$Ui$right(18)),
						$author$project$Ui$paddingWith(
						{bottom: 4, left: 0, right: 0, top: 24})
					]),
				_List_fromArray(
					[
						$author$project$Ui$el$(
						_List_fromArray(
							[$author$project$Ui$centerX]),
						$author$project$LoginForm$loginCodeInput$(windowSize, $author$project$LoginForm$twoFactorCodeLength, $author$project$LoginForm$TypedTwoFactorCode, textSelection, model.code, label)),
						function () {
						if (_Utils_cmp(model.attemptCount, $author$project$LoginForm$maxLoginAttempts) < 0) {
							var _v0 = $author$project$LoginForm$validateCode$($author$project$LoginForm$twoFactorCodeLength, model.code);
							if (!_v0.$) {
								var loginCode = _v0.a;
								var _v1 = $lamdera$containers$SeqDict$get$(loginCode, model.attempts);
								if ((!_v1.$) && (_v1.a === 1)) {
									var _v2 = _v1.a;
									return $author$project$LoginForm$errorView('Incorrect code');
								} else {
									return $author$project$Ui$text('\u00A0');
								}
							} else {
								var error = _v0.a;
								return $author$project$LoginForm$errorView(error);
							}
						} else {
							return $author$project$LoginForm$errorView('Too many incorrect attempts. Please refresh the page and try again.');
						}
					}()
					])),
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$centerX,
						$author$project$Ui$width($author$project$Ui$shrink)
					]),
				$author$project$MyUi$secondaryButtonTall$(
					$author$project$LoginForm$cancelButtonId,
					$author$project$LoginForm$PressedCancelLogin,
					$author$project$LoginForm$isCheckingCode$($author$project$LoginForm$twoFactorCodeLength, model) ? 'Submitting...' : 'Cancel login'))
			]));
};
var $author$project$LoginForm$enterTwoFactorCodeView = F3($author$project$LoginForm$enterTwoFactorCodeView$);
var $author$project$LoginForm$view$ = function (textSelection, loginForm, windowSize, safeAreaInsetTop, pwaStatus, browser) {
	var isMobile = $author$project$MyUi$isMobileAlt(windowSize);
	var installWarning = isMobile && (pwaStatus === 1);
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$MyUi$notoSans,
				isMobile ? $author$project$Ui$paddingWith(
				{bottom: 0, left: 8, right: 8, top: safeAreaInsetTop + 88}) : $author$project$Ui$padding(16),
				$author$project$Ui$centerX,
				isMobile ? $author$project$Ui$alignTop : $author$project$Ui$centerY,
				$author$project$Ui$widthMax(520),
				$author$project$Ui$spacing(24),
				installWarning ? $author$project$Ui$Font$color($author$project$MyUi$font3) : $author$project$Ui$Font$color($author$project$MyUi$font1)
			]),
		_List_fromArray(
			[
				installWarning ? $author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$background(
						$author$project$Ui$rgba$(255, 242, 204, 0.1)),
						$author$project$Ui$border(1),
						$author$project$Ui$borderColor($author$project$MyUi$white),
						$author$project$Ui$rounded(8),
						$author$project$Ui$paddingXY$(8, 16),
						$author$project$Ui$Font$color($author$project$MyUi$font1)
					]),
				$author$project$LoginForm$mobileWarning$(windowSize, browser)) : $author$project$Ui$none,
				function () {
				switch (loginForm.$) {
					case 0:
						var enterEmail2 = loginForm.a;
						return $author$project$LoginForm$enterEmailView(enterEmail2);
					case 1:
						var enterLoginCode = loginForm.a;
						return $author$project$LoginForm$enterLoginCodeView$(windowSize, textSelection, enterLoginCode);
					case 2:
						var enterTwoFactorCode = loginForm.a;
						return $author$project$LoginForm$enterTwoFactorCodeView$(windowSize, textSelection, enterTwoFactorCode);
					default:
						var data = loginForm.a;
						var label = $author$project$Ui$Input$label$(
							'loginForm_name',
							_List_Nil,
							$author$project$Ui$text('Pick a username (you can change it later)'));
						return $author$project$Ui$column$(
							_List_fromArray(
								[
									$author$project$Ui$spacing(16)
								]),
							_List_fromArray(
								[
									$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$Font$size(20)
										]),
									$author$project$Ui$text('Just one thing before you get started!')),
									$author$project$Ui$column$(
									_List_Nil,
									_List_fromArray(
										[
											label.element,
											A2(
											$author$project$Ui$Input$text,
											_List_fromArray(
												[
													$author$project$Ui$Events$onKey$($author$project$Ui$Events$enter, $author$project$LoginForm$PressedSubmitUserData),
													$author$project$Ui$background($author$project$MyUi$inputBackground),
													$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
													$author$project$Ui$Font$color($author$project$MyUi$font1)
												]),
											{label: label.id, onChange: $author$project$LoginForm$TypedName, placeholder: $elm$core$Maybe$Nothing, text: data.name}),
											function () {
											var _v1 = _Utils_Tuple2(
												data.pressedSubmit,
												$author$project$PersonName$fromString(data.name));
											if (((!_v1.a.$) && _v1.a.a) && (_v1.b.$ === 1)) {
												var error = _v1.b.a;
												return $author$project$LoginForm$errorView(error);
											} else {
												return $author$project$Ui$none;
											}
										}()
										])),
									$author$project$MyUi$elButton$(
									$lamdera$program_test$Effect$Browser$Dom$id('loginForm_submit'),
									$author$project$LoginForm$PressedSubmitUserData,
									_List_fromArray(
										[
											$author$project$Ui$paddingXY$(16, 8),
											$author$project$Ui$background($author$project$MyUi$buttonBackground),
											$author$project$Ui$width($author$project$Ui$shrink),
											$author$project$Ui$border(1),
											$author$project$Ui$borderColor($author$project$MyUi$buttonBorder),
											$author$project$Ui$rounded(4),
											$author$project$Ui$Font$color($author$project$MyUi$font1)
										]),
									$author$project$Ui$text('Submit'))
								]));
				}
			}()
			]));
};
var $author$project$LoginForm$view = F6($author$project$LoginForm$view$);
var $author$project$Pages$Admin$PressedHomepageLink = {$: 38};
var $author$project$Pages$Admin$ApiKeysSection = 10;
var $author$project$Pages$Admin$NotifyAdminsBotUserIdEditableMsg = function (a) {
	return {$: 36, a: a};
};
var $author$project$Pages$Admin$NotifyAdminsTokenEditableMsg = function (a) {
	return {$: 35, a: a};
};
var $author$project$Pages$Admin$OpenRouterKeyEditableMsg = function (a) {
	return {$: 34, a: a};
};
var $author$project$Pages$Admin$PostmarkKeyEditableMsg = function (a) {
	return {$: 37, a: a};
};
var $author$project$Pages$Admin$PressedCopyText = function (a) {
	return {$: 42, a: a};
};
var $author$project$Pages$Admin$PressedRegenerateServerSecret = {$: 58};
var $author$project$LocalState$PrivateVapidKey = $elm$core$Basics$identity;
var $author$project$Pages$Admin$PrivateVapidKeyEditableMsg = function (a) {
	return {$: 33, a: a};
};
var $author$project$Pages$Admin$PublicVapidKeyEditableMsg = function (a) {
	return {$: 32, a: a};
};
var $author$project$Postmark$ApiKey = $elm$core$Basics$identity;
var $author$project$Postmark$apiKey = function (apiKey_) {
	return apiKey_;
};
var $author$project$Postmark$apiKeyToString = function (_v0) {
	var apiKey_ = _v0;
	return apiKey_;
};
var $author$project$Log$httpErrorToString = function (error) {
	switch (error.$) {
		case 4:
			var body = error.a;
			return body;
		case 0:
			var string = error.a;
			return 'bad url ' + string;
		case 1:
			return 'timeout';
		case 2:
			return 'network error';
		default:
			var _int = error.a;
			return 'bad status ' + $elm$core$String$fromInt(_int);
	}
};
var $author$project$Pages$Admin$lastRegeneratedAtText = 'Last regenerated at ';
var $author$project$Pages$Admin$notRegeneratedText = 'Not regenerated';
var $author$project$Pages$Admin$regeneratingText = 'Regenerating';
var $author$project$Pages$Admin$PressedExpandSection = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$sectionToString = function (section2) {
	switch (section2) {
		case 0:
			return 'Users';
		case 1:
			return 'Logs';
		case 2:
			return 'DM channels';
		case 3:
			return 'Discord DM channels';
		case 4:
			return 'Discord users';
		case 5:
			return 'Discord guilds';
		case 6:
			return 'Slack workspaces';
		case 7:
			return 'Slack DM channels';
		case 8:
			return 'Guilds';
		case 9:
			return 'Deleted guilds';
		case 10:
			return 'API keys';
		case 11:
			return 'Export/Import';
		case 12:
			return 'Connections';
		case 13:
			return 'Files';
		case 14:
			return 'ToBackend and BackendMsg logs';
		case 15:
			return 'Stickers and emojis';
		case 16:
			return 'Websocket close events';
		case 17:
			return 'Sessions';
		default:
			return 'Word spelling game word lists';
	}
};
var $author$project$Pages$Admin$expandSectionButtonId = function (section2) {
	return $lamdera$program_test$Effect$Browser$Dom$id(
		'admin_expandSectionButton_' + $author$project$Pages$Admin$sectionToString(section2));
};
var $author$project$Pages$Admin$section$ = function (isMobile, expandedSections, section2, content) {
	return $author$project$MyUi$container$(
		16,
		16,
		$lamdera$containers$SeqSet$member$(section2, expandedSections),
		$author$project$Pages$Admin$expandSectionButtonId(section2),
		$author$project$Pages$Admin$PressedExpandSection(section2),
		$author$project$Env$isProduction ? $author$project$MyUi$errorColor : $author$project$MyUi$background3,
		isMobile,
		$author$project$Pages$Admin$sectionToString(section2),
		_List_fromArray(
			[
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$paddingXY$(16, 0),
						$author$project$Ui$spacing(16)
					]),
				content)
			]));
};
var $author$project$Pages$Admin$section = F4($author$project$Pages$Admin$section$);
var $author$project$Editable$Edit = function (a) {
	return {$: 0, a: a};
};
var $author$project$Editable$Editing = function (a) {
	return {$: 1, a: a};
};
var $author$project$Editable$PressedAcceptEdit = function (a) {
	return {$: 1, a: a};
};
var $author$project$Editable$view$ = function (htmlId, isSecret, label, validation, msg, value, model) {
	var htmlIdPrefix = $lamdera$program_test$Effect$Browser$Dom$idToString(htmlId);
	var label2 = $author$project$Ui$Input$label$(
		htmlIdPrefix + '_label',
		_List_fromArray(
			[
				$author$project$Ui$Font$size(14),
				$author$project$Ui$Font$bold
			]),
		$author$project$Ui$text(label));
	var editing = function () {
		var _v8 = model.editing;
		if (_v8.$ === 1) {
			var editing2 = _v8.a;
			return _Utils_eq(editing2, value) ? $author$project$Editable$NotEditing : model.editing;
		} else {
			return model.editing;
		}
	}();
	var result = function () {
		if (!editing.$) {
			return $elm$core$Maybe$Nothing;
		} else {
			var text = editing.a;
			return $elm$core$Maybe$Just(
				validation(text));
		}
	}();
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$widthMax(400)
			]),
		_List_fromArray(
			[
				$author$project$Ui$row$(
				_List_Nil,
				_List_fromArray(
					[
						label2.element,
						function () {
						if ((!result.$) && (result.a.$ === 1)) {
							var error = result.a.a;
							return $author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$Font$color($author$project$MyUi$errorColor),
										$author$project$Ui$Font$size(14),
										$author$project$Ui$paddingXY$(8, 0),
										$author$project$Ui$alignRight,
										$author$project$Ui$Font$bold
									]),
								$author$project$Ui$text(error));
						} else {
							return $author$project$Ui$none;
						}
					}()
					])),
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$height(
						$author$project$Ui$px(40))
					]),
				A2(
					$elm$core$List$cons,
					isSecret ? $author$project$Ui$Input$newPassword$(
						_List_fromArray(
							[
								$author$project$Ui$border(1),
								$author$project$Ui$height($author$project$Ui$fill),
								$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
								$author$project$Ui$background($author$project$MyUi$inputBackground),
								$author$project$Ui$roundedWith(
								{bottomLeft: 4, bottomRight: 0, topLeft: 4, topRight: 0}),
								$author$project$Ui$paddingXY$(8, 0)
							]),
						{
							label: label2.id,
							onChange: function (text2) {
								return msg(
									$author$project$Editable$Edit(
										_Utils_update(
											model,
											{
												editing: $author$project$Editable$Editing(text2)
											})));
							},
							placeholder: $elm$core$Maybe$Nothing,
							show: model.showSecret,
							text: function () {
								if (!editing.$) {
									return value;
								} else {
									var text = editing.a;
									return text;
								}
							}()
						}) : A2(
						$author$project$Ui$Input$text,
						_List_fromArray(
							[
								$author$project$Ui$border(1),
								$author$project$Ui$height($author$project$Ui$fill),
								$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
								$author$project$Ui$background($author$project$MyUi$inputBackground),
								function () {
								if (!editing.$) {
									return $author$project$Ui$rounded(4);
								} else {
									return $author$project$Ui$roundedWith(
										{bottomLeft: 4, bottomRight: 0, topLeft: 4, topRight: 0});
								}
							}(),
								$author$project$Ui$paddingXY$(8, 0)
							]),
						{
							label: label2.id,
							onChange: function (text2) {
								return msg(
									$author$project$Editable$Edit(
										_Utils_update(
											model,
											{
												editing: $author$project$Editable$Editing(text2)
											})));
							},
							placeholder: $elm$core$Maybe$Nothing,
							text: function () {
								if (!editing.$) {
									return value;
								} else {
									var text = editing.a;
									return text;
								}
							}()
						}),
					_Utils_ap(
						isSecret ? _List_fromArray(
							[
								$author$project$MyUi$elButton$(
								$lamdera$program_test$Effect$Browser$Dom$id(htmlIdPrefix + '_toggleSecret'),
								msg(
									$author$project$Editable$Edit(
										_Utils_update(
											model,
											{showSecret: !model.showSecret}))),
								_List_fromArray(
									[
										$author$project$Ui$width(
										$author$project$Ui$px(40)),
										$author$project$Ui$contentCenterX,
										$author$project$Ui$contentCenterY,
										$author$project$Ui$height($author$project$Ui$fill),
										$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
										$author$project$Ui$borderWith(
										{bottom: 1, left: 0, right: 1, top: 1}),
										$author$project$Ui$background($author$project$MyUi$inputBackground),
										_Utils_eq(result, $elm$core$Maybe$Nothing) ? $author$project$Ui$roundedWith(
										{bottomLeft: 0, bottomRight: 4, topLeft: 0, topRight: 4}) : $author$project$Ui$noAttr,
										$author$project$MyUi$hoverText(
										model.showSecret ? 'Hide value' : 'Show value')
									]),
								$author$project$Ui$html(
									model.showSecret ? $author$project$Icons$openEye : $author$project$Icons$closedEye))
							]) : _List_Nil,
						function () {
							if (!result.$) {
								var result2 = result.a;
								return _List_fromArray(
									[
										$author$project$MyUi$elButton$(
										$lamdera$program_test$Effect$Browser$Dom$id(htmlIdPrefix + '_acceptEdit'),
										msg(
											function () {
												if (!result2.$) {
													var ok = result2.a;
													return $author$project$Editable$PressedAcceptEdit(ok);
												} else {
													return $author$project$Editable$Edit(
														_Utils_update(
															model,
															{pressedSubmit: true}));
												}
											}()),
										_List_fromArray(
											[
												$author$project$Ui$width(
												$author$project$Ui$px(40)),
												$author$project$Ui$paddingXY$(5, 0),
												$author$project$Ui$height($author$project$Ui$fill),
												$author$project$Ui$contentCenterX,
												$author$project$Ui$contentCenterY,
												$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
												$author$project$Ui$borderWith(
												{bottom: 1, left: 0, right: 0, top: 1}),
												function () {
												if (!result2.$) {
													return $author$project$Ui$background($author$project$MyUi$buttonBackground);
												} else {
													return $author$project$Ui$background($author$project$MyUi$disabledButtonBackground);
												}
											}(),
												$author$project$MyUi$hoverText('Save')
											]),
										$author$project$Ui$html($author$project$Icons$checkmark)),
										$author$project$MyUi$elButton$(
										$lamdera$program_test$Effect$Browser$Dom$id(htmlIdPrefix + '_delete'),
										msg(
											$author$project$Editable$Edit($author$project$Editable$init)),
										_List_fromArray(
											[
												$author$project$Ui$width(
												$author$project$Ui$px(42)),
												$author$project$Ui$contentCenterX,
												$author$project$Ui$contentCenterY,
												$author$project$Ui$height($author$project$Ui$fill),
												$author$project$Ui$borderColor($author$project$MyUi$deleteButtonBorder),
												$author$project$Ui$border(1),
												$author$project$Ui$background($author$project$MyUi$deleteButtonBackground),
												$author$project$Ui$Font$color($author$project$MyUi$deleteButtonFont),
												$author$project$Ui$roundedWith(
												{bottomLeft: 0, bottomRight: 4, topLeft: 0, topRight: 4}),
												$author$project$MyUi$hoverText('Cancel')
											]),
										$author$project$Ui$html($author$project$Icons$delete))
									]);
							} else {
								return _List_Nil;
							}
						}())))
			]));
};
var $author$project$Editable$view = F7($author$project$Editable$view$);
var $author$project$Pages$Admin$apiKeysSection$ = function (isMobile, local, expandedSections, adminData2, model) {
	return $author$project$Pages$Admin$section$(
		isMobile,
		expandedSections,
		10,
		_List_fromArray(
			[
				$author$project$Editable$view$(
				$lamdera$program_test$Effect$Browser$Dom$id('userOptions_publicVapidKey'),
				true,
				'Public VAPID key',
				function (text) {
					return $elm$core$Result$Ok(
						$elm$core$String$trim(text));
				},
				$author$project$Pages$Admin$PublicVapidKeyEditableMsg,
				local.publicVapidKey,
				model.publicVapidKey),
				$author$project$Editable$view$(
				$lamdera$program_test$Effect$Browser$Dom$id('userOptions_privateVapidKey'),
				true,
				'Private VAPID key',
				function (text) {
					return $elm$core$Result$Ok(
						$elm$core$String$trim(text));
				},
				$author$project$Pages$Admin$PrivateVapidKeyEditableMsg,
				function (_v0) {
					var a = _v0;
					return a;
				}(adminData2.privateVapidKey),
				model.privateVapidKey),
				$author$project$Editable$view$(
				$lamdera$program_test$Effect$Browser$Dom$id('userOptions_openRouterKey'),
				true,
				'OpenRouter API key',
				function (text) {
					var text2 = $elm$core$String$trim(text);
					return (text2 === '') ? $elm$core$Result$Ok($elm$core$Maybe$Nothing) : $elm$core$Result$Ok(
						$elm$core$Maybe$Just(text2));
				},
				$author$project$Pages$Admin$OpenRouterKeyEditableMsg,
				function () {
					var _v1 = adminData2.openRouterKey;
					if (!_v1.$) {
						var key = _v1.a;
						return key;
					} else {
						return '';
					}
				}(),
				model.openRouterKey),
				$author$project$Editable$view$(
				$lamdera$program_test$Effect$Browser$Dom$id('admin_notifyAdminsToken'),
				true,
				'Notify admins token',
				function (text) {
					var text2 = $elm$core$String$trim(text);
					return (text2 === '') ? $elm$core$Result$Ok($elm$core$Maybe$Nothing) : $elm$core$Result$Ok(
						$elm$core$Maybe$Just(text2));
				},
				$author$project$Pages$Admin$NotifyAdminsTokenEditableMsg,
				function () {
					var _v2 = adminData2.notifyAdminsToken;
					if (!_v2.$) {
						var token = _v2.a;
						return token;
					} else {
						return '';
					}
				}(),
				model.notifyAdminsToken),
				$author$project$Editable$view$(
				$lamdera$program_test$Effect$Browser$Dom$id('admin_notifyAdminsBotUserId'),
				false,
				'Notify admins bot user id',
				function (text) {
					var text2 = $elm$core$String$trim(text);
					if (text2 === '') {
						return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
					} else {
						var _v3 = $elm$core$String$toInt(text2);
						if (!_v3.$) {
							var userId = _v3.a;
							return $elm$core$Result$Ok(
								$elm$core$Maybe$Just(
									$author$project$Id$fromInt(userId)));
						} else {
							return $elm$core$Result$Err('Invalid user id');
						}
					}
				},
				$author$project$Pages$Admin$NotifyAdminsBotUserIdEditableMsg,
				function () {
					var _v4 = adminData2.notifyAdminsBotUserId;
					if (!_v4.$) {
						var userId = _v4.a;
						return $author$project$Id$toString(userId);
					} else {
						return '';
					}
				}(),
				model.notifyAdminsBotUserId),
				$author$project$Editable$view$(
				$lamdera$program_test$Effect$Browser$Dom$id('userOptions_postmarkKey'),
				true,
				'Postmark API key',
				function (text) {
					var _v5 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(text);
					if (!_v5.$) {
						return $elm$core$Result$Ok(
							$author$project$Postmark$apiKey(text));
					} else {
						return $elm$core$Result$Err('String can\u0027t be empty');
					}
				},
				$author$project$Pages$Admin$PostmarkKeyEditableMsg,
				$author$project$Postmark$apiKeyToString(adminData2.postmarkKey),
				model.postmarkKey),
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(8)
					]),
				_List_fromArray(
					[
						$author$project$MyUi$simpleButton$(
						$lamdera$program_test$Effect$Browser$Dom$id('admin_regenerateServerSecret'),
						$author$project$Pages$Admin$PressedRegenerateServerSecret,
						$author$project$Ui$text('Regenerate server secret')),
						function () {
						var _v6 = adminData2.serverSecretRefreshedAt;
						switch (_v6.$) {
							case 0:
								var time = _v6.a;
								if (!time.$) {
									var time2 = time.a;
									return $author$project$Ui$text(
										$author$project$Pages$Admin$lastRegeneratedAtText + ($author$project$MyUi$datestamp$(local.localUser.timezone, time2) + (' ' + $author$project$MyUi$timestamp$(time2, local.localUser.timezone))));
								} else {
									return $author$project$Ui$text($author$project$Pages$Admin$notRegeneratedText);
								}
							case 1:
								return $author$project$Ui$text($author$project$Pages$Admin$regeneratingText);
							default:
								var error = _v6.a;
								return $author$project$MyUi$errorBox$(
									$lamdera$program_test$Effect$Browser$Dom$id('Admin_serverSecretError'),
									$author$project$Pages$Admin$PressedCopyText,
									$author$project$Log$httpErrorToString(error));
						}
					}()
					]))
			]));
};
var $author$project$Pages$Admin$apiKeysSection = F5($author$project$Pages$Admin$apiKeysSection$);
var $author$project$Pages$Admin$ConnectionsSection = 12;
var $author$project$Pages$Admin$PressedDisconnectClient$ = function (a, b) {
	return {$: 56, a: a, b: b};
};
var $author$project$Pages$Admin$PressedDisconnectClient = F2($author$project$Pages$Admin$PressedDisconnectClient$);
var $author$project$SessionIdHash$toString = function (_v0) {
	var a = _v0;
	return a;
};
var $author$project$LocalState$getAdminData$ = function (key, adminDataStatus) {
	switch (adminDataStatus.$) {
		case 2:
			var dict = adminDataStatus.a;
			return $lamdera$containers$SeqDict$get$(key, dict);
		case 1:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$LocalState$getAdminData = F2($author$project$LocalState$getAdminData$);
var $author$project$Pages$Admin$viewingChannelName$ = function (adminData, guildId, channelId) {
	var _v0 = $author$project$LocalState$getAdminData$(guildId, adminData.guilds);
	if (!_v0.$) {
		var guild = _v0.a;
		return $author$project$GuildName$toString(guild.name) + (' #' + function () {
			var _v1 = $lamdera$containers$SeqDict$get$(channelId, guild.channels);
			if (!_v1.$) {
				var channel = _v1.a;
				return $author$project$ChannelName$toString(channel.name);
			} else {
				return $author$project$Id$toString(channelId);
			}
		}());
	} else {
		return 'guild ' + ($author$project$Id$toString(guildId) + (' #' + $author$project$Id$toString(channelId)));
	}
};
var $author$project$Pages$Admin$viewingChannelName = F3($author$project$Pages$Admin$viewingChannelName$);
var $author$project$Pages$Admin$viewingDiscordChannelName$ = function (adminData, guildId, channelId) {
	var _v0 = $author$project$LocalState$getAdminData$(guildId, adminData.discordGuilds);
	if (!_v0.$) {
		var guild = _v0.a;
		return $author$project$GuildName$toString(guild.name) + (' #' + function () {
			var _v1 = $lamdera$containers$SeqDict$get$(channelId, guild.channels);
			if (!_v1.$) {
				var channel = _v1.a;
				return $author$project$ChannelName$toString(channel.name);
			} else {
				return $author$project$Discord$idToString(channelId);
			}
		}());
	} else {
		return 'guild ' + ($author$project$Discord$idToString(guildId) + (' #' + $author$project$Discord$idToString(channelId)));
	}
};
var $author$project$Pages$Admin$viewingDiscordChannelName = F3($author$project$Pages$Admin$viewingDiscordChannelName$);
var $author$project$Pages$Admin$viewingDiscordUserName$ = function (adminData, discordUserId) {
	var _v0 = $author$project$LocalState$getAdminData$(discordUserId, adminData.discordUsers);
	if (!_v0.$) {
		switch (_v0.a.$) {
			case 1:
				var data = _v0.a.a;
				return data.user.username;
			case 0:
				var data = _v0.a.a;
				return data.user.username;
			default:
				var data = _v0.a.a;
				return data.user.username;
		}
	} else {
		return 'user ' + $author$project$Discord$idToString(discordUserId);
	}
};
var $author$project$Pages$Admin$viewingDiscordUserName = F2($author$project$Pages$Admin$viewingDiscordUserName$);
var $author$project$Pages$Admin$viewingDiscordDmName$ = function (adminData, currentUserId, channelId) {
	var _v0 = $author$project$LocalState$getAdminData$(channelId, adminData.discordDmChannels);
	if (!_v0.$) {
		var channel = _v0.a;
		var _v1 = $elm$core$List$map$(
			$author$project$Pages$Admin$viewingDiscordUserName(adminData),
			$elm$core$List$filter$(
				function (discordUserId) {
					return !_Utils_eq(discordUserId, currentUserId);
				},
				$mgold$elm_nonempty_list$List$Nonempty$toList(
					$author$project$NonemptyDict$keys(channel.members))));
		if (!_v1.b) {
			return $author$project$Discord$idToString(channelId);
		} else {
			var names = _v1;
			return 'with ' + $elm$core$String$join$(', ', names);
		}
	} else {
		return $author$project$Discord$idToString(channelId);
	}
};
var $author$project$Pages$Admin$viewingDiscordDmName = F3($author$project$Pages$Admin$viewingDiscordDmName$);
var $author$project$Pages$Admin$viewingUserName$ = function (adminData, userId) {
	var _v0 = $author$project$Pages$Admin$adminUser$(userId, adminData);
	if (!_v0.$) {
		var user = _v0.a;
		return $author$project$PersonName$toString(user.name);
	} else {
		return 'user ' + $author$project$Id$toString(userId);
	}
};
var $author$project$Pages$Admin$viewingUserName = F2($author$project$Pages$Admin$viewingUserName$);
var $author$project$Pages$Admin$viewingToString$ = function (adminData, viewing) {
	switch (viewing.$) {
		case 0:
			var data = viewing.a;
			return 'DM with ' + $author$project$Pages$Admin$viewingUserName$(adminData, data.id.otherUserId);
		case 1:
			var data = viewing.a;
			return 'DM with ' + ($author$project$Pages$Admin$viewingUserName$(adminData, data.id.otherUserId) + (', thread ' + $author$project$Id$toString(data.id.threadId)));
		case 2:
			var data = viewing.a;
			return 'Discord DM ' + $author$project$Pages$Admin$viewingDiscordDmName$(adminData, data.id.currentUserId, data.id.channelId);
		case 3:
			var data = viewing.a;
			return $author$project$Pages$Admin$viewingChannelName$(adminData, data.id.guildId, data.id.channelId);
		case 4:
			var data = viewing.a;
			return $author$project$Pages$Admin$viewingChannelName$(adminData, data.id.guildId, data.id.channelId) + (', thread ' + $author$project$Id$toString(data.id.threadId));
		case 5:
			var data = viewing.a;
			return 'Discord ' + $author$project$Pages$Admin$viewingDiscordChannelName$(adminData, data.id.guildId, data.id.channelId);
		case 6:
			var data = viewing.a;
			return 'Discord ' + ($author$project$Pages$Admin$viewingDiscordChannelName$(adminData, data.id.guildId, data.id.channelId) + (', thread ' + $author$project$Id$toString(data.id.threadId)));
		case 7:
			var data = viewing.a;
			return 'Slack channel ' + $author$project$Slack$idToString(data.id.channelId);
		case 9:
			var data = viewing.a;
			return 'Slack DM ' + $author$project$Slack$idToString(data.id.channelId);
		case 8:
			var data = viewing.a;
			return 'Slack channel ' + ($author$project$Slack$idToString(data.id.channelId) + (' thread ' + $author$project$Id$toString(data.threadId)));
		case 10:
			var data = viewing.a;
			return 'Slack DM ' + ($author$project$Slack$idToString(data.id.channelId) + (' thread ' + $author$project$Id$toString(data.threadId)));
		case 11:
			return 'Nothing';
		default:
			return 'Unread overview';
	}
};
var $author$project$Pages$Admin$viewingToString = F2($author$project$Pages$Admin$viewingToString$);
var $author$project$Pages$Admin$connectionsSection$ = function (isMobile, timezone, expandedSections, adminData) {
	return $author$project$Pages$Admin$section$(
		isMobile,
		expandedSections,
		12,
		_List_fromArray(
			[
				$elm$core$List$isEmpty(adminData.connections) ? $author$project$Ui$text('No connections') : $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(16)
					]),
				$elm$core$List$map$(
					function (_v0) {
						var sessionIdHash = _v0.a;
						var clients = _v0.b;
						return $author$project$Ui$column$(
							_List_fromArray(
								[
									$author$project$Ui$spacing(2)
								]),
							_List_fromArray(
								[
									$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$Font$bold,
											$author$project$Ui$Font$size(14)
										]),
									$author$project$Ui$text(
										'Session hash: ' + $author$project$SessionIdHash$toString(sessionIdHash))),
									$author$project$Ui$column$(
									_List_fromArray(
										[
											$author$project$Ui$paddingWith(
											{bottom: 0, left: 16, right: 0, top: 0}),
											$author$project$Ui$spacing(2)
										]),
									$elm$core$List$map$(
										function (_v1) {
											var clientId = _v1.a;
											var data = _v1.b;
											return $author$project$Ui$column$(
												_List_fromArray(
													[
														$author$project$Ui$spacing(2),
														$author$project$Ui$Font$size(14),
														$author$project$Ui$widthMax(600)
													]),
												_List_fromArray(
													[
														$author$project$Ui$row$(
														_List_fromArray(
															[
																$author$project$Ui$spacing(8)
															]),
														_List_fromArray(
															[
																$author$project$Ui$text(
																'Client: ' + $lamdera$program_test$Effect$Lamdera$clientIdToString(clientId)),
																$author$project$Ui$el$(
																_List_fromArray(
																	[
																		$author$project$Ui$alignRight,
																		$author$project$Ui$width($author$project$Ui$shrink)
																	]),
																function () {
																	var _v2 = data.lastRequest;
																	if (_v2.$ === 1) {
																		var time = _v2.a;
																		return $author$project$Ui$text(
																			'Last request: ' + ($author$project$MyUi$datestamp$(timezone, time) + (' ' + $author$project$MyUi$timestamp$(time, timezone))));
																	} else {
																		return $author$project$Ui$text('No requests made');
																	}
																}()),
																$author$project$MyUi$deleteButton$(
																$lamdera$program_test$Effect$Browser$Dom$id(
																	'admin_disconnectClient_' + $lamdera$program_test$Effect$Lamdera$clientIdToString(clientId)),
																$author$project$Pages$Admin$PressedDisconnectClient$(sessionIdHash, clientId))
															])),
														$author$project$Ui$text(
														'Viewing: ' + $author$project$Pages$Admin$viewingToString$(adminData, data.currentlyViewing))
													]));
										},
										$author$project$NonemptyDict$toList(clients)))
								]));
					},
					adminData.connections))
			]));
};
var $author$project$Pages$Admin$connectionsSection = F4($author$project$Pages$Admin$connectionsSection$);
var $author$project$Pages$Admin$DeletedGuildsSection = 9;
var $author$project$Pages$Admin$PressedRestoreGuild = function (a) {
	return {$: 31, a: a};
};
var $author$project$Pages$Admin$loadingText = 'Loading...';
var $author$project$Pages$Admin$restoreGuildButtonId = function (guildId) {
	return $lamdera$program_test$Effect$Browser$Dom$id(
		'Admin_restoreGuildButton_' + $author$project$Id$toString(guildId));
};
var $author$project$Pages$Admin$userLabel = function (user) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8),
				$author$project$Ui$width($author$project$Ui$shrink)
			]),
		_List_fromArray(
			[
				$author$project$User$profileImage(
				$elm$core$Maybe$Just(user)),
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$width($author$project$Ui$shrink)
					]),
				$author$project$Ui$text(
					$author$project$PersonName$toString(user.name)))
			]));
};
var $author$project$Pages$Admin$deletedGuildsSection$ = function (isMobile, expandedSections, adminData) {
	return $author$project$Pages$Admin$section$(
		isMobile,
		expandedSections,
		9,
		_List_fromArray(
			[
				function () {
				var _v0 = adminData.deletedGuilds;
				switch (_v0.$) {
					case 0:
						return $author$project$Ui$text($author$project$Pages$Admin$loadingText);
					case 1:
						return $author$project$Ui$text($author$project$Pages$Admin$loadingText);
					default:
						var deletedGuilds = _v0.a;
						return $lamdera$containers$SeqDict$isEmpty(deletedGuilds) ? $author$project$Ui$text('No deleted guilds') : $author$project$Ui$column$(
							_List_fromArray(
								[
									$author$project$Ui$spacing(4)
								]),
							$elm$core$List$map$(
								function (_v1) {
									var guildId = _v1.a;
									var deletedGuild = _v1.b;
									return $author$project$Ui$row$(
										_List_fromArray(
											[
												$author$project$Ui$spacing(8),
												$author$project$Ui$Font$size(14)
											]),
										_List_fromArray(
											[
												$author$project$Ui$text(
												$author$project$Id$toString(guildId)),
												$author$project$Ui$text(
												$author$project$GuildName$toString(deletedGuild.name)),
												$author$project$Ui$row$(
												_List_fromArray(
													[
														$author$project$Ui$spacing(8)
													]),
												_List_fromArray(
													[
														$author$project$Ui$text('Owner:'),
														function () {
														var _v2 = $author$project$Pages$Admin$adminUser$(deletedGuild.owner, adminData);
														if (!_v2.$) {
															var user2 = _v2.a;
															return $author$project$Pages$Admin$userLabel(user2);
														} else {
															return $author$project$Ui$text(
																$author$project$Id$toString(deletedGuild.owner));
														}
													}()
													])),
												$author$project$Ui$text(
												'Members: ' + $elm$core$String$fromInt(deletedGuild.memberCount)),
												$author$project$MyUi$simpleButton$(
												$author$project$Pages$Admin$restoreGuildButtonId(guildId),
												$author$project$Pages$Admin$PressedRestoreGuild(guildId),
												$author$project$Ui$text('Restore'))
											]));
								},
								$lamdera$containers$SeqDict$toList(deletedGuilds)));
				}
			}()
			]));
};
var $author$project$Pages$Admin$deletedGuildsSection = F3($author$project$Pages$Admin$deletedGuildsSection$);
var $author$project$Pages$Admin$DiscordDmChannelsSection = 3;
var $author$project$Pages$Admin$PressedDeleteDiscordDmChannel = function (a) {
	return {$: 23, a: a};
};
var $author$project$Pages$Admin$PressedReloadDiscordDmChannel$ = function (a, b) {
	return {$: 40, a: a, b: b};
};
var $author$project$Pages$Admin$PressedReloadDiscordDmChannel = F2($author$project$Pages$Admin$PressedReloadDiscordDmChannel$);
var $author$project$Pages$Admin$deleteDiscordDmChannelButtonId = function (channelId) {
	return $lamdera$program_test$Effect$Browser$Dom$id(
		'Admin_deleteDiscordDmChannelButton_' + $author$project$Discord$idToString(channelId));
};
var $author$project$Pages$Admin$discordUserLabel$ = function (userId, discordUser) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8),
				$author$project$Ui$width($author$project$Ui$shrink)
			]),
		_List_fromArray(
			[
				$author$project$User$discordProfileImage$(
				userId,
				function () {
					switch (discordUser.$) {
						case 1:
							var data = discordUser.a;
							return data.icon;
						case 0:
							var data = discordUser.a;
							return data.icon;
						default:
							var data = discordUser.a;
							return data.icon;
					}
				}()),
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$width($author$project$Ui$shrink)
					]),
				function () {
					switch (discordUser.$) {
						case 1:
							var data = discordUser.a;
							return $author$project$Ui$text(data.user.username);
						case 0:
							var data = discordUser.a;
							return $author$project$Ui$text(data.user.username);
						default:
							var data = discordUser.a;
							return $author$project$Ui$text(data.user.username);
					}
				}())
			]));
};
var $author$project$Pages$Admin$discordUserLabel = F2($author$project$Pages$Admin$discordUserLabel$);
var $author$project$Pages$Admin$TypedInReadOnlyTextInput = {$: 43};
var $author$project$Pages$Admin$channelRowHeight = 30;
var $author$project$Pages$Admin$firstMessageView = function (channel) {
	var _v0 = channel.firstMessage;
	if (!_v0.$) {
		var firstMessage = _v0.a;
		var firstMessageLabel = $author$project$Ui$Input$label$(
			'admin_discordGuildChannelFirstMessage',
			_List_fromArray(
				[
					$author$project$Ui$width($author$project$Ui$shrink)
				]),
			$author$project$Ui$text('First message:'));
		return $author$project$Ui$row$(
			_List_fromArray(
				[
					$author$project$Ui$spacing(8)
				]),
			_List_fromArray(
				[
					firstMessageLabel.element,
					A2(
					$author$project$Ui$Input$text,
					_List_fromArray(
						[
							$author$project$Ui$htmlAttribute(
							$elm$html$Html$Attributes$readonly(true)),
							$author$project$Ui$paddingXY$(4, 0),
							$author$project$Ui$background($author$project$MyUi$background2),
							$author$project$Ui$height(
							$author$project$Ui$px($author$project$Pages$Admin$channelRowHeight))
						]),
					{
						label: firstMessageLabel.id,
						onChange: function (_v1) {
							return $author$project$Pages$Admin$TypedInReadOnlyTextInput;
						},
						placeholder: $elm$core$Maybe$Nothing,
						text: $author$project$LocalState$messageToString$($lamdera$program_test$Effect$Time$utc, $lamdera$containers$SeqDict$empty, $lamdera$containers$SeqDict$empty, $lamdera$containers$SeqDict$empty, firstMessage)
					})
				]));
	} else {
		return $author$project$Ui$none;
	}
};
var $author$project$LocalState$isDiscordDmChannelReloading$ = function (channelId, loadingDiscordChannels) {
	return $elmcraft$core_extra$List$Extra$findMap$(
		function (_v0) {
			var loading = _v0.b;
			if (loading.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var otherChannelId = loading.b;
				var step = loading.c;
				return _Utils_eq(channelId, otherChannelId) ? $elm$core$Maybe$Just(step) : $elm$core$Maybe$Nothing;
			}
		},
		$lamdera$containers$SeqDict$toList(loadingDiscordChannels));
};
var $author$project$LocalState$isDiscordDmChannelReloading = F2($author$project$LocalState$isDiscordDmChannelReloading$);
var $author$project$Discord$errorCodeToString = function (errorCode) {
	switch (errorCode) {
		case 0:
			return 'General error (such as a malformed request body, amongst other things)';
		case 1:
			return 'Unknown account';
		case 2:
			return 'Unknown application';
		case 3:
			return 'Unknown channel';
		case 4:
			return 'Unknown guild';
		case 5:
			return 'Unknown integration';
		case 6:
			return 'Unknown invite';
		case 7:
			return 'Unknown member';
		case 8:
			return 'Unknown message';
		case 9:
			return 'Unknown permission overwrite';
		case 10:
			return 'Unknown provider';
		case 11:
			return 'Unknown role';
		case 12:
			return 'Unknown token';
		case 13:
			return 'Unknown user';
		case 14:
			return 'Unknown emoji';
		case 15:
			return 'Unknown webhook';
		case 16:
			return 'Unknown ban';
		case 17:
			return 'Unknown SKU';
		case 18:
			return 'Unknown Store Listing';
		case 19:
			return 'Unknown entitlement';
		case 20:
			return 'Unknown build';
		case 21:
			return 'Unknown lobby';
		case 22:
			return 'Unknown branch';
		case 23:
			return 'Unknown redistributable';
		case 24:
			return 'Bots cannot use this endpoint';
		case 25:
			return 'Only bots can use this endpoint';
		case 26:
			return 'Maximum number of guilds reached (100)';
		case 27:
			return 'Maximum number of friends reached (1000)';
		case 28:
			return 'Maximum number of pins reached for the channel (50)';
		case 29:
			return 'Maximum number of guild roles reached (250)';
		case 30:
			return 'Maximum number of webhooks reached (10)';
		case 31:
			return 'Maximum number of reactions reached (20)';
		case 32:
			return 'Maximum number of guild channels reached (500)';
		case 33:
			return 'Maximum number of attachments in a message reached (10)';
		case 34:
			return 'Maximum number of invites reached (1000)';
		case 35:
			return 'Unauthorized. Provide a valid token and try again';
		case 36:
			return 'You need to verify your account in order to perform this action';
		case 37:
			return 'Request entity too large. Try sending something smaller in size';
		case 38:
			return 'This feature has been temporarily disabled server-side';
		case 39:
			return 'The user is banned from this guild';
		case 40:
			return 'Missing access';
		case 41:
			return 'Invalid account type';
		case 42:
			return 'Cannot execute action on a DM channel';
		case 43:
			return 'Guild widget disabled';
		case 44:
			return 'Cannot edit a message authored by another user';
		case 45:
			return 'Cannot send an empty message';
		case 46:
			return 'Cannot send messages to this user';
		case 47:
			return 'Cannot send messages in a voice channel';
		case 48:
			return 'Channel verification level is too high for you to gain access';
		case 49:
			return 'OAuth2 application does not have a bot';
		case 50:
			return 'OAuth2 application limit reached';
		case 51:
			return 'Invalid OAuth2 state';
		case 52:
			return 'You lack permissions to perform that action';
		case 53:
			return 'Invalid authentication token provided';
		case 54:
			return 'Note was too long';
		case 55:
			return 'Provided too few or too many messages to delete. Must provide at least 2 and fewer than 100 messages to delete';
		case 56:
			return 'A message can only be pinned to the channel it was sent in';
		case 57:
			return 'Invite code was either invalid or taken';
		case 58:
			return 'Cannot execute action on a system message';
		case 59:
			return 'Invalid OAuth2 access token provided';
		case 60:
			return 'A message provided was too old to bulk delete';
		case 61:
			return 'Invalid form body (returned for both application/json and multipart/form-data bodies), or invalid Content-Type provided';
		case 62:
			return 'An invite was accepted to a guild the application\u0027s bot is not in';
		case 63:
			return 'Invalid API version provided';
		case 64:
			return 'Reaction was blocked';
		default:
			return 'API resource is currently overloaded. Try again a little later';
	}
};
var $author$project$Discord$httpErrorToString = function (httpError) {
	var statusCodeText = F2(
		function (statusCode, errorCode) {
			return 'Status code ' + ($elm$core$String$fromInt(statusCode) + (': ' + $author$project$Discord$errorCodeToString(errorCode)));
		});
	switch (httpError.$) {
		case 0:
			var errorCode = httpError.a;
			return A2(statusCodeText, 304, errorCode);
		case 1:
			var errorCode = httpError.a;
			return A2(statusCodeText, 400, errorCode);
		case 2:
			var errorCode = httpError.a;
			return A2(statusCodeText, 401, errorCode);
		case 3:
			var errorCode = httpError.a;
			return A2(statusCodeText, 403, errorCode);
		case 4:
			var errorCode = httpError.a;
			return A2(statusCodeText, 404, errorCode);
		case 5:
			var rateLimit = httpError.a;
			var value = $elm$core$String$fromInt(
				$elm$core$Basics$round(
					$ianmackenzie$elm_units$Duration$inMilliseconds(rateLimit.retryAfter)));
			return 'Status code ' + ($elm$core$String$fromInt(429) + (': Too many requests. Retry after ' + (value + ' milliseconds.')));
		case 6:
			var errorCode = httpError.a;
			return A2(statusCodeText, 502, errorCode);
		case 7:
			var errorCode = httpError.a.errorCode;
			var statusCode = httpError.a.statusCode;
			return A2(statusCodeText, statusCode, errorCode);
		case 8:
			return 'Network error';
		case 9:
			return 'Request timed out';
		default:
			var message = httpError.a;
			return 'Unexpected error: ' + message;
	}
};
var $author$project$Pages$Admin$loadingChannelErrorView$ = function (channelId, isReloading) {
	if ((!isReloading.$) && (isReloading.a.$ === 1)) {
		var error = isReloading.a.a;
		return $author$project$MyUi$errorBox$(
			$lamdera$program_test$Effect$Browser$Dom$id('Admin_errorBox_' + channelId),
			$author$project$Pages$Admin$PressedCopyText,
			'Loading messages failed: ' + $author$project$Discord$httpErrorToString(error));
	} else {
		return $author$project$Ui$none;
	}
};
var $author$project$Pages$Admin$loadingChannelErrorView = F2($author$project$Pages$Admin$loadingChannelErrorView$);
var $author$project$Animator$Transition$linear = $author$project$InternalAnim$Transition$linear;
var $author$project$InternalAnim$Css$Props$Turns = function (a) {
	return {$: 3, a: a};
};
var $author$project$InternalAnim$Css$Props$turns = function (vec) {
	return $author$project$InternalAnim$Css$Props$Turns(vec);
};
var $author$project$Animator$zAxis = {x: 0, y: 0, z: 1};
var $author$project$Animator$rotation = function (n) {
	return $author$project$InternalAnim$Css$Prop$(
		$author$project$InternalAnim$Css$Props$ids.rotation,
		'rotate',
		$author$project$InternalAnim$Move$to(1000 * n),
		$author$project$InternalAnim$Css$Props$turns($author$project$Animator$zAxis));
};
var $author$project$InternalAnim$Move$withTransition$ = function (trans, _v0) {
	var value = _v0.b;
	var sequence = _v0.c;
	return $author$project$InternalAnim$Move$Pos$(trans, value, sequence);
};
var $author$project$InternalAnim$Move$withTransition = F2($author$project$InternalAnim$Move$withTransition$);
var $author$project$Animator$withTransition$ = function (trans, prop) {
	if (!prop.$) {
		var id = prop.a;
		var name = prop.b;
		var move = prop.c;
		var format = prop.d;
		return $author$project$InternalAnim$Css$Prop$(
			id,
			name,
			$author$project$InternalAnim$Move$withTransition$(trans, move),
			format);
	} else {
		var name = prop.a;
		var move = prop.b;
		return $author$project$InternalAnim$Css$ColorProp$(
			name,
			$author$project$InternalAnim$Move$withTransition$(trans, move));
	}
};
var $author$project$Animator$withTransition = F2($author$project$Animator$withTransition$);
var $author$project$Animator$spinning = function (dur) {
	return $author$project$Animator$keyframes(
		_List_fromArray(
			[
				$author$project$Animator$loop(
				_List_fromArray(
					[
						$author$project$Animator$set(
						_List_fromArray(
							[
								$author$project$Animator$rotation(0)
							])),
						A2(
						$author$project$Animator$step,
						dur,
						_List_fromArray(
							[
								$author$project$Animator$withTransition$(
								$author$project$Animator$Transition$linear,
								$author$project$Animator$rotation(1))
							]))
					]))
			]));
};
var $author$project$Ui$Anim$spinning = function (dur) {
	return $author$project$Ui$Anim$toAttr$(
		3,
		$author$project$Animator$toCss(
			$author$project$Animator$spinning(dur)));
};
var $author$project$Icons$spinner = $author$project$Ui$el$(
	_List_fromArray(
		[
			$author$project$Ui$width(
			$author$project$Ui$px(16)),
			$author$project$Ui$height(
			$author$project$Ui$px(16)),
			$author$project$Ui$Anim$spinning(
			$author$project$Ui$Anim$ms(1000)),
			$author$project$Ui$htmlAttribute(
			A2($elm$html$Html$Attributes$style, 'border-top-color', 'transparent')),
			$author$project$Ui$htmlAttribute(
			A2($elm$html$Html$Attributes$style, 'border', '2px solid #fff')),
			$author$project$Ui$htmlAttribute(
			A2($elm$html$Html$Attributes$style, 'border-radius', '50px'))
		]),
	$author$project$Ui$none);
var $author$project$Pages$Admin$spinner = $author$project$Ui$el$(
	_List_fromArray(
		[
			$author$project$Ui$width(
			$author$project$Ui$px($author$project$Pages$Admin$channelRowHeight)),
			$author$project$Ui$height(
			$author$project$Ui$px($author$project$Pages$Admin$channelRowHeight)),
			$author$project$Ui$contentCenterX,
			$author$project$Ui$contentCenterY
		]),
	$author$project$Icons$spinner);
var $author$project$Pages$Admin$loadingChannelView$ = function (isReloading, resetButton2) {
	_v0$2:
	while (true) {
		if (!isReloading.$) {
			switch (isReloading.a.$) {
				case 0:
					var _v1 = isReloading.a;
					return $author$project$Ui$row$(
						_List_fromArray(
							[
								$author$project$Ui$contentCenterY,
								$author$project$Ui$spacing(8)
							]),
						_List_fromArray(
							[
								$author$project$Pages$Admin$spinner,
								$author$project$Ui$text('Loading messages')
							]));
				case 2:
					var _v2 = isReloading.a;
					var attachmentCount = _v2.b;
					return $author$project$Ui$row$(
						_List_fromArray(
							[
								$author$project$Ui$contentCenterY,
								$author$project$Ui$spacing(8)
							]),
						_List_fromArray(
							[
								$author$project$Pages$Admin$spinner,
								$author$project$Ui$text(
								'Loading ' + ($elm$core$String$fromInt(attachmentCount) + ' attachments'))
							]));
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return resetButton2;
};
var $author$project$Pages$Admin$loadingChannelView = F2($author$project$Pages$Admin$loadingChannelView$);
var $author$project$Icons$reset = $author$project$Ui$html(
	A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$strokeWidth('1.5'),
				$elm$svg$Svg$Attributes$stroke('currentColor'),
				$elm$svg$Svg$Attributes$width('24')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$d('M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99')
					]),
				_List_Nil)
			])));
var $author$project$Pages$Admin$reloadButton$ = function (hoverText, htmlId, onPress) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$Input$button(onPress),
				$author$project$Ui$id(
				$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId)),
				$author$project$MyUi$hoverText(hoverText),
				$author$project$Ui$padding(3),
				$author$project$Ui$background(
				$author$project$Ui$rgb$(50, 100, 255)),
				$author$project$Ui$Font$color($author$project$MyUi$white),
				$author$project$Ui$rounded(4),
				$author$project$Ui$width($author$project$Ui$shrink),
				$author$project$Ui$Shadow$shadows(
				_List_fromArray(
					[
						{
						blur: 2,
						color: $author$project$Ui$rgba$(0, 0, 0, 0.1),
						size: 0,
						x: 0,
						y: 1
					}
					]))
			]),
		$author$project$Icons$reset);
};
var $author$project$Pages$Admin$reloadButton = F3($author$project$Pages$Admin$reloadButton$);
var $author$project$Pages$Admin$resetButton$ = function (htmlId, onPress) {
	return $author$project$Pages$Admin$reloadButton$('Reset', htmlId, onPress);
};
var $author$project$Pages$Admin$resetButton = F2($author$project$Pages$Admin$resetButton$);
var $author$project$Pages$Admin$discordDmChannelsSection$ = function (isMobile, expandedSections, adminData) {
	return $author$project$Pages$Admin$section$(
		isMobile,
		expandedSections,
		3,
		_List_fromArray(
			[
				function () {
				var _v0 = _Utils_Tuple2(adminData.discordDmChannels, adminData.discordUsers);
				if ((_v0.a.$ === 2) && (_v0.b.$ === 2)) {
					var discordDmChannels = _v0.a.a;
					var discordUsers = _v0.b.a;
					return $lamdera$containers$SeqDict$isEmpty(discordDmChannels) ? $author$project$Ui$text('No Discord DM channels') : $author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$spacing(4)
							]),
						$elm$core$List$map$(
							function (_v1) {
								var channelId = _v1.a;
								var channel = _v1.b;
								var userThatCanReload = $elm$core$List$head(
									$lamdera$containers$SeqSet$toList(
										$lamdera$containers$SeqSet$intersect$(
											$lamdera$containers$SeqSet$fromList(
												$lamdera$containers$SeqDict$keys(
													$lamdera$containers$SeqDict$filter$(
														F2(
															function (_v5, discordUser) {
																if (discordUser.$ === 1) {
																	return true;
																} else {
																	return false;
																}
															}),
														discordUsers))),
											$lamdera$containers$SeqSet$fromList(
												$mgold$elm_nonempty_list$List$Nonempty$toList(
													$author$project$NonemptyDict$keys(channel.members))))));
								var isReloading = $author$project$LocalState$isDiscordDmChannelReloading$(channelId, adminData.loadingDiscordChannels);
								return $author$project$Ui$row$(
									_List_fromArray(
										[
											$author$project$Ui$spacing(8),
											$author$project$Ui$Font$size(14)
										]),
									_List_fromArray(
										[
											$author$project$Pages$Admin$loadingChannelView$(
											isReloading,
											function () {
												if (!userThatCanReload.$) {
													var userId = userThatCanReload.a;
													return $author$project$Pages$Admin$resetButton$(
														$lamdera$program_test$Effect$Browser$Dom$id(
															'admin_reloadDiscordDmChannel_' + $author$project$Discord$idToString(channelId)),
														$author$project$Pages$Admin$PressedReloadDiscordDmChannel$(userId, channelId));
												} else {
													return $author$project$Ui$none;
												}
											}()),
											$author$project$Ui$text(
											$author$project$Discord$idToString(channelId)),
											$author$project$Ui$row$(
											_List_fromArray(
												[
													$author$project$Ui$spacing(8)
												]),
											_List_fromArray(
												[
													$author$project$Ui$text('Members:'),
													$author$project$Ui$row$(
													_List_fromArray(
														[
															$author$project$Ui$spacing(8),
															$author$project$Ui$width($author$project$Ui$shrink)
														]),
													$elm$core$List$map$(
														function (_v3) {
															var discordUserId = _v3.a;
															var _v4 = $lamdera$containers$SeqDict$get$(discordUserId, discordUsers);
															if (!_v4.$) {
																var discordUser = _v4.a;
																return $author$project$Pages$Admin$discordUserLabel$(discordUserId, discordUser);
															} else {
																return $author$project$Ui$text(
																	$author$project$Discord$idToString(discordUserId));
															}
														},
														$author$project$NonemptyDict$toList(channel.members)))
												])),
											$author$project$Ui$text(
											'Messages: ' + $elm$core$String$fromInt(channel.messageCount)),
											$author$project$Pages$Admin$firstMessageView(channel),
											$author$project$Pages$Admin$loadingChannelErrorView$(
											$author$project$Discord$idToString(channelId),
											isReloading),
											$author$project$MyUi$deleteButton$(
											$author$project$Pages$Admin$deleteDiscordDmChannelButtonId(channelId),
											$author$project$Pages$Admin$PressedDeleteDiscordDmChannel(channelId))
										]));
							},
							$lamdera$containers$SeqDict$toList(discordDmChannels)));
				} else {
					return $author$project$Ui$text($author$project$Pages$Admin$loadingText);
				}
			}()
			]));
};
var $author$project$Pages$Admin$discordDmChannelsSection = F3($author$project$Pages$Admin$discordDmChannelsSection$);
var $author$project$Pages$Admin$DiscordGuildsSection = 5;
var $author$project$Pages$Admin$PressedDeleteDiscordGuild = function (a) {
	return {$: 24, a: a};
};
var $author$project$Pages$Admin$PressedExpandDiscordGuild = function (a) {
	return {$: 25, a: a};
};
var $author$project$Pages$Admin$deleteDiscordGuildButtonId = function (guildId) {
	return $lamdera$program_test$Effect$Browser$Dom$id(
		'Admin_deleteDiscordGuildButton_' + $author$project$Discord$idToString(guildId));
};
var $author$project$Pages$Admin$PressedReloadDiscordChannel$ = function (a, b, c) {
	return {$: 39, a: a, b: b, c: c};
};
var $author$project$Pages$Admin$PressedReloadDiscordChannel = F3($author$project$Pages$Admin$PressedReloadDiscordChannel$);
var $author$project$Pages$Admin$discordChannelReloadUser$ = function (linkedGuildMembers, guildId, guild, channel) {
	return $elm$core$List$head(
		$elm$core$List$filter$(
			A3($author$project$LocalState$canViewDiscordChannel, guildId, channel, guild),
			linkedGuildMembers));
};
var $author$project$Pages$Admin$discordChannelReloadUser = F4($author$project$Pages$Admin$discordChannelReloadUser$);
var $author$project$LocalState$isDiscordGuildChannelReloading$ = function (channelId, loadingDiscordChannels) {
	return $elmcraft$core_extra$List$Extra$findMap$(
		function (_v0) {
			var loading = _v0.b;
			if (loading.$ === 1) {
				var otherChannelId = loading.c;
				var step = loading.d;
				return _Utils_eq(channelId, otherChannelId) ? $elm$core$Maybe$Just(step) : $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		$lamdera$containers$SeqDict$toList(loadingDiscordChannels));
};
var $author$project$LocalState$isDiscordGuildChannelReloading = F2($author$project$LocalState$isDiscordGuildChannelReloading$);
var $author$project$Pages$Admin$discordGuildChannel$ = function (linkedGuildMembers, guild, guildId, adminData, _v0) {
	var channelId = _v0.a;
	var channel = _v0.b;
	var maybeUserId = $author$project$Pages$Admin$discordChannelReloadUser$(linkedGuildMembers, guildId, guild, channel);
	var isReloading = $author$project$LocalState$isDiscordGuildChannelReloading$(channelId, adminData.loadingDiscordChannels);
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8),
				$author$project$Ui$Font$size(13)
			]),
		_List_fromArray(
			[
				$author$project$Pages$Admin$loadingChannelView$(
				isReloading,
				function () {
					if (!maybeUserId.$) {
						var userId = maybeUserId.a;
						return $author$project$Pages$Admin$resetButton$(
							$lamdera$program_test$Effect$Browser$Dom$id(
								'admin_reloadDiscordChannel_' + $author$project$Discord$idToString(channelId)),
							$author$project$Pages$Admin$PressedReloadDiscordChannel$(userId, guildId, channelId));
					} else {
						return $author$project$Ui$none;
					}
				}()),
				$author$project$Ui$text(
				'#' + $author$project$ChannelName$toString(channel.name)),
				$author$project$Ui$text(
				'Messages: ' + $elm$core$String$fromInt(channel.messageCount)),
				$author$project$Pages$Admin$firstMessageView(channel),
				$author$project$Ui$text(
				'Threads: ' + $elm$core$String$fromInt(channel.threadCount)),
				$author$project$Pages$Admin$loadingChannelErrorView$(
				$author$project$Discord$idToString(channelId),
				isReloading)
			]));
};
var $author$project$Pages$Admin$discordGuildChannel = F5($author$project$Pages$Admin$discordGuildChannel$);
var $author$project$Pages$Admin$discordGuildRoleMembers$ = function (guildId, roles, members, discordUsers) {
	var userName = function (userId) {
		var _v7 = $lamdera$containers$SeqDict$get$(userId, discordUsers);
		if (!_v7.$) {
			switch (_v7.a.$) {
				case 1:
					var data = _v7.a.a;
					return data.user.username;
				case 0:
					var data = _v7.a.a;
					return data.user.username;
				default:
					var data = _v7.a.a;
					return data.user.username;
			}
		} else {
			return $author$project$Discord$idToString(userId);
		}
	};
	var roleName = function (roleId) {
		var _v6 = $lamdera$containers$SeqDict$get$(roleId, roles);
		if (!_v6.$) {
			var role = _v6.a;
			return role.name;
		} else {
			return $author$project$Discord$idToString(roleId);
		}
	};
	var everyoneRoleId = $author$project$Discord$idToString(guildId);
	var membersWithRoles = A2(
		$elm$core$List$sortBy,
		function (_v5) {
			var userId = _v5.a;
			return $elm$core$String$toLower(
				userName(userId));
		},
		$elm$core$List$filterMap$(
			function (_v3) {
				var userId = _v3.a;
				var member = _v3.b;
				var _v4 = $elm$core$List$sort(
					$elm$core$List$map$(
						roleName,
						$elm$core$List$filter$(
							function (roleId) {
								return !_Utils_eq(
									$author$project$Discord$idToString(roleId),
									everyoneRoleId);
							},
							$lamdera$containers$SeqSet$toList(member.roles))));
				if (!_v4.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					var roleNames = _v4;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(userId, roleNames));
				}
			},
			$lamdera$containers$SeqDict$toList(members)));
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(2),
				$author$project$Ui$Font$size(13)
			]),
		function () {
			if (!membersWithRoles.b) {
				return _List_fromArray(
					[
						$author$project$Ui$text('No users with roles (besides @everyone)')
					]);
			} else {
				return A2(
					$elm$core$List$cons,
					$author$project$Ui$text(
						'Users with roles (' + ($elm$core$String$fromInt(
							$elm$core$List$length(membersWithRoles)) + '):')),
					$elm$core$List$map$(
						function (_v1) {
							var userId = _v1.a;
							var roleNames = _v1.b;
							return $author$project$Ui$row$(
								_List_fromArray(
									[
										$author$project$Ui$spacing(8),
										$author$project$Ui$paddingWith(
										{bottom: 0, left: 16, right: 0, top: 0})
									]),
								_List_fromArray(
									[
										function () {
										var _v2 = $lamdera$containers$SeqDict$get$(userId, discordUsers);
										if (!_v2.$) {
											var discordUser = _v2.a;
											return $author$project$Pages$Admin$discordUserLabel$(userId, discordUser);
										} else {
											return $author$project$Ui$text(
												$author$project$Discord$idToString(userId));
										}
									}(),
										$author$project$Ui$text(
										$elm$core$String$join$(', ', roleNames))
									]));
						},
						membersWithRoles));
			}
		}());
};
var $author$project$Pages$Admin$discordGuildRoleMembers = F4($author$project$Pages$Admin$discordGuildRoleMembers$);
var $author$project$Pages$Admin$PressedReloadDiscordGuild$ = function (a, b) {
	return {$: 41, a: a, b: b};
};
var $author$project$Pages$Admin$PressedReloadDiscordGuild = F2($author$project$Pages$Admin$PressedReloadDiscordGuild$);
var $author$project$Pages$Admin$reloadDiscordGuildButtonId = function (guildId) {
	return $lamdera$program_test$Effect$Browser$Dom$id(
		'admin_reloadDiscordGuild_' + $author$project$Discord$idToString(guildId));
};
var $author$project$Pages$Admin$discordGuildRoles$ = function (maybeUserId, guildId, roles) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8),
				$author$project$Ui$Font$size(13)
			]),
		_List_fromArray(
			[
				function () {
				if (!maybeUserId.$) {
					var userId = maybeUserId.a;
					return $author$project$Pages$Admin$reloadButton$(
						'Reload roles and channel permissions',
						$author$project$Pages$Admin$reloadDiscordGuildButtonId(guildId),
						$author$project$Pages$Admin$PressedReloadDiscordGuild$(userId, guildId));
				} else {
					return $author$project$Ui$none;
				}
			}(),
				$lamdera$containers$SeqDict$isEmpty(roles) ? $author$project$Ui$text('No roles loaded. Press reload to fetch roles and channel permissions.') : function (text) {
				return $author$project$Ui$text(
					'Roles (' + ($elm$core$String$fromInt(
						$lamdera$containers$SeqDict$size(roles)) + ('): ' + text)));
			}(
				$elm$core$String$join$(
					', ',
					$elm$core$List$map$(
						function ($) {
							return $.name;
						},
						A2(
							$elm$core$List$sortBy,
							function ($) {
								return $.name;
							},
							$lamdera$containers$SeqDict$values(roles)))))
			]));
};
var $author$project$Pages$Admin$discordGuildRoles = F3($author$project$Pages$Admin$discordGuildRoles$);
var $author$project$Pages$Admin$discordGuildsSection$ = function (isMobile, expandedSections, expandedDiscordGuilds, adminData) {
	return $author$project$Pages$Admin$section$(
		isMobile,
		expandedSections,
		5,
		_List_fromArray(
			[
				function () {
				var _v0 = _Utils_Tuple2(adminData.discordGuilds, adminData.discordUsers);
				if ((_v0.a.$ === 2) && (_v0.b.$ === 2)) {
					var discordGuilds = _v0.a.a;
					var discordUsers = _v0.b.a;
					if ($lamdera$containers$SeqDict$isEmpty(discordGuilds)) {
						return $author$project$Ui$text('No Discord guilds');
					} else {
						var linkedDiscordUsers = $lamdera$containers$SeqDict$filter$(
							F2(
								function (_v5, discordUser) {
									switch (discordUser.$) {
										case 1:
											return true;
										case 2:
											return true;
										default:
											return false;
									}
								}),
							discordUsers);
						return $author$project$Ui$column$(
							_List_fromArray(
								[
									$author$project$Ui$spacing(4)
								]),
							$elm$core$List$map$(
								function (_v1) {
									var guildId = _v1.a;
									var guild = _v1.b;
									var owner = $author$project$MembersAndOwner$owner(guild.membersAndOwner);
									var members = $author$project$MembersAndOwner$members(guild.membersAndOwner);
									var isExpanded = $lamdera$containers$SeqSet$member$(guildId, expandedDiscordGuilds);
									var channelCount = $lamdera$containers$SeqDict$size(guild.channels);
									return $author$project$Ui$column$(
										_List_fromArray(
											[
												$author$project$Ui$spacing(4)
											]),
										_List_fromArray(
											[
												$author$project$Ui$row$(
												_List_fromArray(
													[
														$author$project$Ui$spacing(8),
														$author$project$Ui$Font$size(14)
													]),
												_List_fromArray(
													[
														$author$project$Ui$el$(
														_List_fromArray(
															[
																$author$project$Ui$width($author$project$Ui$shrink),
																$author$project$Ui$Input$button(
																$author$project$Pages$Admin$PressedExpandDiscordGuild(guildId)),
																$author$project$MyUi$hoverText(
																isExpanded ? 'Collapse' : 'Expand')
															]),
														isExpanded ? $author$project$Icons$collapseContainer : $author$project$Icons$expandContainer),
														$author$project$Ui$text(
														$author$project$Discord$idToString(guildId)),
														$author$project$Ui$text(
														$author$project$GuildName$toString(guild.name)),
														$author$project$Ui$row$(
														_List_fromArray(
															[
																$author$project$Ui$spacing(8)
															]),
														_List_fromArray(
															[
																$author$project$Ui$text('Owner:'),
																function () {
																var _v2 = $lamdera$containers$SeqDict$get$(owner, discordUsers);
																if (!_v2.$) {
																	var discordUser = _v2.a;
																	return $author$project$Pages$Admin$discordUserLabel$(owner, discordUser);
																} else {
																	return $author$project$Ui$text(
																		$author$project$Discord$idToString(owner));
																}
															}()
															])),
														$author$project$Ui$text(
														'Channels: ' + $elm$core$String$fromInt(channelCount)),
														$author$project$Ui$text(
														'Members: ' + $elm$core$String$fromInt(
															$lamdera$containers$SeqDict$size(members))),
														$author$project$LocalState$canViewDiscordGuild$(linkedDiscordUsers, guild.membersAndOwner) ? $author$project$Ui$none : $author$project$Ui$el$(
														_List_fromArray(
															[
																$author$project$Ui$width($author$project$Ui$shrink),
																$author$project$Ui$Font$color($author$project$MyUi$errorColor),
																$author$project$MyUi$hoverText('No linked Discord user is in this guild. It gets deleted once an hourly update has found it orphaned twice in a row.')
															]),
														$author$project$Ui$text('Orphaned')),
														$author$project$MyUi$deleteButton$(
														$author$project$Pages$Admin$deleteDiscordGuildButtonId(guildId),
														$author$project$Pages$Admin$PressedDeleteDiscordGuild(guildId))
													])),
												function () {
												if (isExpanded) {
													var linkedGuildMembers = $lamdera$containers$SeqDict$keys(
														$lamdera$containers$SeqDict$intersect$(
															$lamdera$containers$SeqDict$filter$(
																F2(
																	function (_v3, discordUser) {
																		if (discordUser.$ === 1) {
																			return true;
																		} else {
																			return false;
																		}
																	}),
																discordUsers),
															$lamdera$containers$SeqDict$insert$(
																owner,
																{joinedAt: $elm$core$Maybe$Nothing, roles: $lamdera$containers$SeqSet$empty},
																members)));
													return $author$project$Ui$column$(
														_List_fromArray(
															[
																$author$project$Ui$spacing(2),
																$author$project$Ui$paddingWith(
																{bottom: 0, left: 32, right: 0, top: 0})
															]),
														A2(
															$elm$core$List$cons,
															$author$project$Pages$Admin$discordGuildRoles$(
																$elm$core$List$head(linkedGuildMembers),
																guildId,
																guild.roles),
															A2(
																$elm$core$List$cons,
																$author$project$Pages$Admin$discordGuildRoleMembers$(guildId, guild.roles, members, discordUsers),
																$elm$core$List$map$(
																	A4($author$project$Pages$Admin$discordGuildChannel, linkedGuildMembers, guild, guildId, adminData),
																	$lamdera$containers$SeqDict$toList(guild.channels)))));
												} else {
													return $author$project$Ui$none;
												}
											}()
											]));
								},
								$lamdera$containers$SeqDict$toList(discordGuilds)));
					}
				} else {
					return $author$project$Ui$text($author$project$Pages$Admin$loadingText);
				}
			}()
			]));
};
var $author$project$Pages$Admin$discordGuildsSection = F4($author$project$Pages$Admin$discordGuildsSection$);
var $author$project$Pages$Admin$DiscordUsersSection = 4;
var $author$project$Pages$Admin$gatewayStatusView = function (gateway) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8),
				$author$project$Ui$width($author$project$Ui$shrink)
			]),
		_List_fromArray(
			[
				gateway.websocketIsOpen ? $author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$width($author$project$Ui$shrink)
					]),
				$author$project$Ui$text('Websocket open')) : $author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$width($author$project$Ui$shrink),
						$author$project$Ui$Font$color($author$project$MyUi$errorColor)
					]),
				$author$project$Ui$text('Websocket closed')),
				(!gateway.failedReconnectAttempts) ? $author$project$Ui$none : $author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$width($author$project$Ui$shrink),
						$author$project$Ui$Font$color($author$project$MyUi$errorColor)
					]),
				$author$project$Ui$text(
					_Utils_ap(
						$elm$core$String$fromInt(gateway.failedReconnectAttempts),
						(gateway.failedReconnectAttempts === 1) ? ' failed reconnect' : ' failed reconnects')))
			]));
};
var $author$project$Pages$Admin$linkedToView$ = function (adminData, userId) {
	var _v0 = $author$project$Pages$Admin$adminUser$(userId, adminData);
	if (!_v0.$) {
		var user = _v0.a;
		return $author$project$Ui$row$(
			_List_fromArray(
				[
					$author$project$Ui$spacing(8),
					$author$project$Ui$width($author$project$Ui$shrink)
				]),
			_List_fromArray(
				[
					$author$project$User$profileImage(
					$elm$core$Maybe$Just(user)),
					$author$project$Ui$text(
					$author$project$PersonName$toString(user.name))
				]));
	} else {
		return $author$project$Ui$none;
	}
};
var $author$project$Pages$Admin$linkedToView = F2($author$project$Pages$Admin$linkedToView$);
var $author$project$Pages$Admin$discordUsersSection$ = function (isMobile, expandedSections, adminData) {
	return $author$project$Pages$Admin$section$(
		isMobile,
		expandedSections,
		4,
		_List_fromArray(
			[
				function () {
				var _v0 = adminData.discordUsers;
				switch (_v0.$) {
					case 0:
						return $author$project$Ui$text($author$project$Pages$Admin$loadingText);
					case 1:
						return $author$project$Ui$text($author$project$Pages$Admin$loadingText);
					default:
						var discordUsers = _v0.a;
						return $lamdera$containers$SeqDict$isEmpty(discordUsers) ? $author$project$Ui$text('No Discord user') : $author$project$Ui$column$(
							_List_fromArray(
								[
									$author$project$Ui$spacing(4)
								]),
							$elm$core$List$map$(
								function (_v1) {
									var discordUserId = _v1.a;
									var discordUser = _v1.b;
									return $author$project$Ui$row$(
										_List_fromArray(
											[
												$author$project$Ui$spacing(8),
												$author$project$Ui$Font$size(14)
											]),
										_List_fromArray(
											[
												$author$project$Ui$el$(
												_List_fromArray(
													[
														$author$project$Ui$width(
														$author$project$Ui$px(150))
													]),
												$author$project$Ui$text(
													$author$project$Discord$idToString(discordUserId))),
												$author$project$Pages$Admin$discordUserLabel$(discordUserId, discordUser),
												$author$project$Ui$el$(
												_List_fromArray(
													[
														$author$project$Ui$widthMin(200),
														$author$project$Ui$width($author$project$Ui$shrink)
													]),
												function () {
													switch (discordUser.$) {
														case 1:
															var data = discordUser.a;
															return $author$project$Pages$Admin$linkedToView$(adminData, data.linkedTo);
														case 0:
															return $author$project$Ui$none;
														default:
															var data = discordUser.a;
															return $author$project$Pages$Admin$linkedToView$(adminData, data.linkedTo);
													}
												}()),
												$author$project$Ui$el$(
												_List_fromArray(
													[
														$author$project$Ui$width(
														$author$project$Ui$px(260))
													]),
												function () {
													switch (discordUser.$) {
														case 1:
															var data = discordUser.a;
															return $author$project$Pages$Admin$gatewayStatusView(data.gateway);
														case 0:
															return $author$project$Ui$none;
														default:
															return $author$project$Ui$el$(
																_List_fromArray(
																	[
																		$author$project$Ui$Font$color($author$project$MyUi$errorColor)
																	]),
																$author$project$Ui$text('No websocket, needs auth again'));
													}
												}())
											]));
								},
								$lamdera$containers$SeqDict$toList(discordUsers)));
				}
			}()
			]));
};
var $author$project$Pages$Admin$discordUsersSection = F3($author$project$Pages$Admin$discordUsersSection$);
var $author$project$Pages$Admin$DmChannelsSection = 2;
var $author$project$DmChannelId$toUserIds = function (_v0) {
	var userIdA = _v0.a;
	var userIdB = _v0.b;
	return _Utils_Tuple2(userIdA, userIdB);
};
var $author$project$Pages$Admin$dmChannelParticipants$ = function (adminData, channelId) {
	var _v0 = $author$project$DmChannelId$toUserIds(channelId);
	var userIdA = _v0.a;
	var userIdB = _v0.b;
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8),
				$author$project$Ui$width($author$project$Ui$shrink)
			]),
		$elm$core$List$map$(
			function (userId) {
				var _v1 = $author$project$Pages$Admin$adminUser$(userId, adminData);
				if (!_v1.$) {
					var user = _v1.a;
					return $author$project$Pages$Admin$userLabel(user);
				} else {
					return $author$project$Ui$text(
						$author$project$Id$toString(userId));
				}
			},
			_List_fromArray(
				[userIdA, userIdB])));
};
var $author$project$Pages$Admin$dmChannelParticipants = F2($author$project$Pages$Admin$dmChannelParticipants$);
var $author$project$Pages$Admin$dmChannelsSection$ = function (isMobile, expandedSections, adminData) {
	return $author$project$Pages$Admin$section$(
		isMobile,
		expandedSections,
		2,
		_List_fromArray(
			[
				function () {
				var _v0 = adminData.dmChannels;
				switch (_v0.$) {
					case 0:
						return $author$project$Ui$text($author$project$Pages$Admin$loadingText);
					case 1:
						return $author$project$Ui$text($author$project$Pages$Admin$loadingText);
					default:
						var dmChannels = _v0.a;
						return $lamdera$containers$SeqDict$isEmpty(dmChannels) ? $author$project$Ui$text('No DM channels') : $author$project$Ui$column$(
							_List_fromArray(
								[
									$author$project$Ui$spacing(4)
								]),
							$elm$core$List$map$(
								function (_v1) {
									var channelId = _v1.a;
									var channel = _v1.b;
									return $author$project$Ui$row$(
										_List_fromArray(
											[
												$author$project$Ui$spacing(8),
												$author$project$Ui$Font$size(14)
											]),
										_List_fromArray(
											[
												$author$project$Pages$Admin$dmChannelParticipants$(adminData, channelId),
												$author$project$Ui$text(
												'Messages: ' + $elm$core$String$fromInt(channel.messageCount)),
												$author$project$Ui$text(
												'Threads: ' + $elm$core$String$fromInt(channel.threadCount))
											]));
								},
								$lamdera$containers$SeqDict$toList(dmChannels)));
				}
			}()
			]));
};
var $author$project$Pages$Admin$dmChannelsSection = F3($author$project$Pages$Admin$dmChannelsSection$);
var $author$project$Pages$Admin$ExportSection = 11;
var $author$project$Pages$Admin$PressedDownloadLastBackup = {$: 46};
var $author$project$Pages$Admin$PressedExportBackend = {$: 44};
var $author$project$Pages$Admin$PressedExportSubsetBackend = {$: 45};
var $author$project$Pages$Admin$PressedImportBackend = {$: 53};
var $author$project$Pages$Admin$PressedSendTypeThatIsAlwaysInvalid = {$: 61};
var $author$project$Pages$Admin$downloadingBackupText = function (downloading) {
	return 'Downloading ' + ($elm$core$String$fromInt((downloading.receivedBytes / (1024 * 1024)) | 0) + ('MB of ' + ($elm$core$String$fromInt((downloading.totalBytes / (1024 * 1024)) | 0) + 'MB...')));
};
var $author$project$Pages$Admin$exportProgressText = function (progress) {
	switch (progress.$) {
		case 0:
			return 'Starting export...';
		case 1:
			var total = progress.a.total;
			var encoded = progress.a.encoded;
			var channelsRemaining = progress.a.channelsRemaining;
			return 'Encoding guilds ' + ($elm$core$String$fromInt(encoded) + ('/' + ($elm$core$String$fromInt(total) + function () {
				switch (channelsRemaining) {
					case 0:
						return '';
					case 1:
						return ' (1 channel remaining)';
					default:
						return ' (' + ($elm$core$String$fromInt(channelsRemaining) + ' channels remaining)');
				}
			}())));
		case 2:
			var total = progress.a.total;
			var encoded = progress.a.encoded;
			return 'Encoding DM channels ' + ($elm$core$String$fromInt(encoded) + ('/' + $elm$core$String$fromInt(total)));
		case 3:
			var total = progress.a.total;
			var encoded = progress.a.encoded;
			var channelsRemaining = progress.a.channelsRemaining;
			return 'Encoding Discord guilds ' + ($elm$core$String$fromInt(encoded) + ('/' + ($elm$core$String$fromInt(total) + function () {
				switch (channelsRemaining) {
					case 0:
						return '';
					case 1:
						return ' (1 channel remaining)';
					default:
						return ' (' + ($elm$core$String$fromInt(channelsRemaining) + ' channels remaining)');
				}
			}())));
		default:
			var total = progress.a.total;
			var encoded = progress.a.encoded;
			return 'Encoding Discord DM channels ' + ($elm$core$String$fromInt(encoded) + ('/' + $elm$core$String$fromInt(total)));
	}
};
var $author$project$Pages$Admin$PressedCancelExportSubset = {$: 52};
var $author$project$Pages$Admin$PressedConfirmExportSubset = {$: 51};
var $author$project$Pages$Admin$ToggledExportSubsetDiscordDmChannel$ = function (a, b) {
	return {$: 50, a: a, b: b};
};
var $author$project$Pages$Admin$ToggledExportSubsetDiscordDmChannel = F2($author$project$Pages$Admin$ToggledExportSubsetDiscordDmChannel$);
var $author$project$Pages$Admin$ToggledExportSubsetDiscordGuild$ = function (a, b) {
	return {$: 49, a: a, b: b};
};
var $author$project$Pages$Admin$ToggledExportSubsetDiscordGuild = F2($author$project$Pages$Admin$ToggledExportSubsetDiscordGuild$);
var $author$project$Pages$Admin$ToggledExportSubsetDmChannel$ = function (a, b) {
	return {$: 48, a: a, b: b};
};
var $author$project$Pages$Admin$ToggledExportSubsetDmChannel = F2($author$project$Pages$Admin$ToggledExportSubsetDmChannel$);
var $author$project$Pages$Admin$ToggledExportSubsetGuild$ = function (a, b) {
	return {$: 47, a: a, b: b};
};
var $author$project$Pages$Admin$ToggledExportSubsetGuild = F2($author$project$Pages$Admin$ToggledExportSubsetGuild$);
var $author$project$Ui$emptyState = {added: $elm$core$Set$empty, keyframes: _List_Nil, rules: _List_Nil};
var $author$project$Ui$embed$ = function (attrs, content) {
	return $author$project$Internal$Model2$renderLayout$(
		{includeStaticStylesheet: false, options: _List_Nil},
		$author$project$Ui$emptyState,
		attrs,
		content);
};
var $author$project$Ui$embed = F2($author$project$Ui$embed$);
var $author$project$MyUi$details$ = function (summaryText, contents) {
	return $author$project$Ui$html(
		A2(
			$elm$html$Html$details,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$summary,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
							A2($elm$html$Html$Attributes$style, 'font-weight', 'bold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(summaryText)
						])),
					$author$project$Ui$embed$(
					_List_fromArray(
						[
							$author$project$MyUi$notoSans,
							$author$project$Ui$Font$size(16),
							$author$project$Ui$Font$color($author$project$MyUi$font1)
						]),
					contents)
				])));
};
var $author$project$MyUi$details = F2($author$project$MyUi$details$);
var $author$project$Pages$Admin$selectionSummary$ = function (name, selected, total) {
	return name + (' (' + ($elm$core$String$fromInt(selected) + ('/' + ($elm$core$String$fromInt(total) + ' selected)'))));
};
var $author$project$Pages$Admin$selectionSummary = F3($author$project$Pages$Admin$selectionSummary$);
var $author$project$Pages$Admin$exportSubsetSelector$ = function (adminData, selection) {
	var _v0 = _Utils_Tuple3(
		_Utils_Tuple2(adminData.guilds, adminData.dmChannels),
		_Utils_Tuple2(adminData.discordGuilds, adminData.discordDmChannels),
		adminData.discordUsers);
	if (((((_v0.a.a.$ === 2) && (_v0.a.b.$ === 2)) && (_v0.b.a.$ === 2)) && (_v0.b.b.$ === 2)) && (_v0.c.$ === 2)) {
		var _v1 = _v0.a;
		var guilds = _v1.a.a;
		var dmChannels = _v1.b.a;
		var _v2 = _v0.b;
		var discordGuilds = _v2.a.a;
		var discordDmChannels = _v2.b.a;
		var discordUsers = _v0.c.a;
		var selectedCount = (($lamdera$containers$SeqSet$size(selection.guilds) + $lamdera$containers$SeqSet$size(selection.dmChannels)) + $lamdera$containers$SeqSet$size(selection.discordGuilds)) + $lamdera$containers$SeqSet$size(selection.discordDmChannels);
		return $author$project$Ui$column$(
			_List_fromArray(
				[
					$author$project$Ui$spacing(8),
					$author$project$Ui$padding(8),
					$author$project$Ui$border(1),
					$author$project$Ui$borderColor(
					$author$project$Ui$rgb$(100, 100, 100)),
					$author$project$Ui$rounded(4)
				]),
			_List_fromArray(
				[
					$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$Font$weight(600)
						]),
					$author$project$Ui$text('Select what to export')),
					$author$project$MyUi$details$(
					$author$project$Pages$Admin$selectionSummary$(
						'Guilds',
						$lamdera$containers$SeqSet$size(selection.guilds),
						$lamdera$containers$SeqDict$size(guilds)),
					$lamdera$containers$SeqDict$isEmpty(guilds) ? $author$project$Ui$text('No guilds') : $author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$spacing(4)
							]),
						$elm$core$List$map$(
							function (_v3) {
								var guildId = _v3.a;
								var guild = _v3.b;
								var label = $author$project$Ui$Input$label$(
									'admin_exportSubsetGuildToggle_' + $author$project$Id$toString(guildId),
									_List_fromArray(
										[
											$author$project$Ui$pointer,
											$author$project$Ui$width($author$project$Ui$shrink),
											$author$project$Ui$paddingXY$(8, 0)
										]),
									$author$project$Ui$text(
										$author$project$GuildName$toString(guild.name)));
								return $author$project$Ui$row$(
									_List_fromArray(
										[
											$author$project$Ui$Font$size(14)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Input$checkbox$(
											_List_fromArray(
												[
													$author$project$Ui$Font$size(14)
												]),
											{
												checked: $lamdera$containers$SeqSet$member$(guildId, selection.guilds),
												icon: $elm$core$Maybe$Nothing,
												label: label.id,
												onChange: $author$project$Pages$Admin$ToggledExportSubsetGuild(guildId)
											}),
											label.element,
											$author$project$Ui$row$(
											_List_fromArray(
												[
													$author$project$Ui$spacing(8)
												]),
											_List_fromArray(
												[
													$author$project$Ui$text(
													'Channels: ' + $elm$core$String$fromInt(
														$lamdera$containers$SeqDict$size(guild.channels))),
													$author$project$Ui$text(
													'Messages: ' + $elm$core$String$fromInt(
														$lamdera$containers$SeqDict$foldl$(
															F3(
																function (_v4, channel, total) {
																	return total + channel.messageCount;
																}),
															0,
															guild.channels)))
												]))
										]));
							},
							$lamdera$containers$SeqDict$toList(guilds)))),
					$author$project$MyUi$details$(
					$author$project$Pages$Admin$selectionSummary$(
						'DM channels',
						$lamdera$containers$SeqSet$size(selection.dmChannels),
						$lamdera$containers$SeqDict$size(dmChannels)),
					$lamdera$containers$SeqDict$isEmpty(dmChannels) ? $author$project$Ui$text('No DM channels') : $author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$spacing(4)
							]),
						$elm$core$List$map$(
							function (_v5) {
								var channelId = _v5.a;
								var channel = _v5.b;
								var label = $author$project$Ui$Input$label$(
									'admin_exportSubsetDmToggle_' + $author$project$DmChannelId$toString(channelId),
									_List_fromArray(
										[
											$author$project$Ui$pointer,
											$author$project$Ui$width($author$project$Ui$shrink),
											$author$project$Ui$paddingXY$(8, 0)
										]),
									$author$project$Pages$Admin$dmChannelParticipants$(adminData, channelId));
								return $author$project$Ui$row$(
									_List_fromArray(
										[
											$author$project$Ui$Font$size(14)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Input$checkbox$(
											_List_fromArray(
												[
													$author$project$Ui$Font$size(14)
												]),
											{
												checked: $lamdera$containers$SeqSet$member$(channelId, selection.dmChannels),
												icon: $elm$core$Maybe$Nothing,
												label: label.id,
												onChange: $author$project$Pages$Admin$ToggledExportSubsetDmChannel(channelId)
											}),
											label.element,
											$author$project$Ui$row$(
											_List_fromArray(
												[
													$author$project$Ui$spacing(8)
												]),
											_List_fromArray(
												[
													$author$project$Ui$text(
													'Messages: ' + $elm$core$String$fromInt(channel.messageCount)),
													$author$project$Ui$text(
													'Threads: ' + $elm$core$String$fromInt(channel.threadCount))
												]))
										]));
							},
							$lamdera$containers$SeqDict$toList(dmChannels)))),
					$author$project$MyUi$details$(
					$author$project$Pages$Admin$selectionSummary$(
						'Discord guilds',
						$lamdera$containers$SeqSet$size(selection.discordGuilds),
						$lamdera$containers$SeqDict$size(discordGuilds)),
					$lamdera$containers$SeqDict$isEmpty(discordGuilds) ? $author$project$Ui$text('No Discord guilds') : $author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$spacing(4)
							]),
						$elm$core$List$map$(
							function (_v6) {
								var guildId = _v6.a;
								var guild = _v6.b;
								var label = $author$project$Ui$Input$label$(
									'admin_exportSubsetDiscordGuildToggle_' + $author$project$Discord$idToString(guildId),
									_List_fromArray(
										[
											$author$project$Ui$pointer,
											$author$project$Ui$width($author$project$Ui$shrink),
											$author$project$Ui$paddingXY$(8, 0)
										]),
									$author$project$Ui$text(
										$author$project$GuildName$toString(guild.name)));
								return $author$project$Ui$row$(
									_List_fromArray(
										[
											$author$project$Ui$Font$size(14)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Input$checkbox$(
											_List_fromArray(
												[
													$author$project$Ui$Font$size(14)
												]),
											{
												checked: $lamdera$containers$SeqSet$member$(guildId, selection.discordGuilds),
												icon: $elm$core$Maybe$Nothing,
												label: label.id,
												onChange: $author$project$Pages$Admin$ToggledExportSubsetDiscordGuild(guildId)
											}),
											label.element,
											$author$project$Ui$row$(
											_List_fromArray(
												[
													$author$project$Ui$spacing(8)
												]),
											_List_fromArray(
												[
													$author$project$Ui$text(
													'Channels: ' + $elm$core$String$fromInt(
														$lamdera$containers$SeqDict$size(guild.channels))),
													$author$project$Ui$text(
													'Messages: ' + $elm$core$String$fromInt(
														$lamdera$containers$SeqDict$foldl$(
															F3(
																function (_v7, channel, total) {
																	return total + channel.messageCount;
																}),
															0,
															guild.channels)))
												]))
										]));
							},
							$lamdera$containers$SeqDict$toList(discordGuilds)))),
					$author$project$MyUi$details$(
					$author$project$Pages$Admin$selectionSummary$(
						'Discord DM channels',
						$lamdera$containers$SeqSet$size(selection.discordDmChannels),
						$lamdera$containers$SeqDict$size(discordDmChannels)),
					$lamdera$containers$SeqDict$isEmpty(discordDmChannels) ? $author$project$Ui$text('No Discord DM channels') : $author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$spacing(4)
							]),
						$elm$core$List$map$(
							function (_v8) {
								var channelId = _v8.a;
								var channel = _v8.b;
								var label = $author$project$Ui$Input$label$(
									'admin_exportSubsetToggle_' + $author$project$Discord$idToString(channelId),
									_List_fromArray(
										[
											$author$project$Ui$pointer,
											$author$project$Ui$width($author$project$Ui$shrink),
											$author$project$Ui$paddingXY$(8, 0)
										]),
									$author$project$Ui$text(
										$author$project$Discord$idToString(channelId)));
								return $author$project$Ui$row$(
									_List_fromArray(
										[
											$author$project$Ui$Font$size(14)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Input$checkbox$(
											_List_fromArray(
												[
													$author$project$Ui$Font$size(14)
												]),
											{
												checked: $lamdera$containers$SeqSet$member$(channelId, selection.discordDmChannels),
												icon: $elm$core$Maybe$Nothing,
												label: label.id,
												onChange: $author$project$Pages$Admin$ToggledExportSubsetDiscordDmChannel(channelId)
											}),
											label.element,
											$author$project$Ui$row$(
											_List_fromArray(
												[
													$author$project$Ui$spacing(8)
												]),
											_List_fromArray(
												[
													$author$project$Ui$row$(
													_List_fromArray(
														[
															$author$project$Ui$spacing(8),
															$author$project$Ui$width($author$project$Ui$shrink)
														]),
													$elm$core$List$map$(
														function (_v9) {
															var discordUserId = _v9.a;
															var _v10 = $lamdera$containers$SeqDict$get$(discordUserId, discordUsers);
															if (!_v10.$) {
																var discordUser = _v10.a;
																return $author$project$Pages$Admin$discordUserLabel$(discordUserId, discordUser);
															} else {
																return $author$project$Ui$text(
																	$author$project$Discord$idToString(discordUserId));
															}
														},
														$author$project$NonemptyDict$toList(channel.members))),
													$author$project$Ui$text(
													'Messages: ' + $elm$core$String$fromInt(channel.messageCount))
												]))
										]));
							},
							$lamdera$containers$SeqDict$toList(discordDmChannels)))),
					$author$project$Ui$row$(
					_List_fromArray(
						[
							$author$project$Ui$spacing(8)
						]),
					_List_fromArray(
						[
							$author$project$MyUi$simpleButton$(
							$lamdera$program_test$Effect$Browser$Dom$id('admin_confirmExportSubsetButton'),
							$author$project$Pages$Admin$PressedConfirmExportSubset,
							$author$project$Ui$text(
								'Confirm Export (' + ($elm$core$String$fromInt(selectedCount) + ')'))),
							$author$project$MyUi$secondaryButton$(
							$lamdera$program_test$Effect$Browser$Dom$id('admin_cancelExportSubsetButton'),
							$author$project$Pages$Admin$PressedCancelExportSubset,
							'Cancel')
						]))
				]));
	} else {
		return $author$project$Ui$text($author$project$Pages$Admin$loadingText);
	}
};
var $author$project$Pages$Admin$exportSubsetSelector = F2($author$project$Pages$Admin$exportSubsetSelector$);
var $author$project$Pages$Admin$importedText = 'Imported!';
var $author$project$Pages$Admin$exportSection$ = function (isMobile, timezone, expandedSections, adminData, model) {
	return $author$project$Pages$Admin$section$(
		isMobile,
		expandedSections,
		11,
		_List_fromArray(
			[
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(8)
					]),
				_List_fromArray(
					[
						$author$project$MyUi$simpleButton$(
						$lamdera$program_test$Effect$Browser$Dom$id('admin_exportBackendButton'),
						$author$project$Pages$Admin$PressedExportBackend,
						$author$project$Ui$text('Export backend')),
						$author$project$MyUi$simpleButton$(
						$lamdera$program_test$Effect$Browser$Dom$id('admin_exportSubsetBackendButton'),
						$author$project$Pages$Admin$PressedExportSubsetBackend,
						$author$project$Ui$text('Export subset')),
						function () {
						var _v0 = model.exportProgress;
						if (_v0.$ === 1) {
							return $author$project$Ui$none;
						} else {
							var progress = _v0.a;
							return $author$project$Ui$text(
								$author$project$Pages$Admin$exportProgressText(progress));
						}
					}()
					])),
				function () {
				var _v1 = model.exportSubsetSelection;
				if (!_v1.$) {
					var selected = _v1.a;
					return $author$project$Pages$Admin$exportSubsetSelector$(adminData, selected);
				} else {
					return $author$project$Ui$none;
				}
			}(),
				function () {
				var _v2 = adminData.lastBackup;
				if (!_v2.$) {
					var lastBackup = _v2.a;
					return $author$project$Ui$row$(
						_List_fromArray(
							[
								$author$project$Ui$spacing(8)
							]),
						_List_fromArray(
							[
								$author$project$MyUi$simpleButton$(
								$lamdera$program_test$Effect$Browser$Dom$id('admin_downloadLastBackupButton'),
								$author$project$Pages$Admin$PressedDownloadLastBackup,
								$author$project$Ui$text(
									function () {
										var _v3 = lastBackup.contents;
										if (!_v3) {
											return 'Download backup';
										} else {
											return 'Download subset backup';
										}
									}())),
								function () {
								var _v4 = model.downloadingBackup;
								if (!_v4.$) {
									var downloading = _v4.a;
									return $author$project$Ui$text(
										$author$project$Pages$Admin$downloadingBackupText(downloading));
								} else {
									return $author$project$Ui$text(
										'Generated at ' + ($author$project$MyUi$datestamp$(timezone, lastBackup.createdAt) + (' ' + $author$project$MyUi$timestamp$(lastBackup.createdAt, timezone))));
								}
							}()
							]));
				} else {
					return $author$project$Ui$text('No backup has been generated yet');
				}
			}(),
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(8)
					]),
				_List_fromArray(
					[
						$author$project$MyUi$simpleButton$(
						$lamdera$program_test$Effect$Browser$Dom$id('admin_importBackendButton'),
						$author$project$Pages$Admin$PressedImportBackend,
						$author$project$Ui$text('Import backend')),
						function () {
						var _v5 = model.importBackendStatus;
						switch (_v5.$) {
							case 0:
								return $author$project$Ui$none;
							case 1:
								return $author$project$Ui$text('Failed to import backend');
							case 2:
								var importing = _v5.a;
								return $author$project$Ui$text(
									'Importing... ' + ($elm$core$String$fromInt(
										((100 * importing.sentBytes) / $elm$core$Basics$max$(1, importing.totalBytes)) | 0) + '%'));
							default:
								return $author$project$Ui$text($author$project$Pages$Admin$importedText);
						}
					}()
					])),
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(8)
					]),
				_List_fromArray(
					[
						$author$project$MyUi$simpleButton$(
						$lamdera$program_test$Effect$Browser$Dom$id('admin_typeThatIsAlwaysInvalidButton'),
						$author$project$Pages$Admin$PressedSendTypeThatIsAlwaysInvalid,
						$author$project$Ui$text('Send invalid type')),
						$author$project$Ui$text('The backend should never receive this. If it does, an error gets logged.')
					])),
				$author$project$Ui$text(
				$elm$core$String$join$(
					', ',
					$elm$core$List$map$(
						function (_v6) {
							var key = _v6.a;
							var value = _v6.b;
							return '(' + (key + (',' + ($elm$core$String$fromInt(value) + ')')));
						},
						adminData.seqDictWorks)))
			]));
};
var $author$project$Pages$Admin$exportSection = F5($author$project$Pages$Admin$exportSection$);
var $author$project$Pages$Admin$FilesSection = 13;
var $author$project$Pages$Admin$PressedDeleteOrphanedFiles = {$: 59};
var $author$project$Pages$Admin$deleteOrphanedFilesButtonId = $lamdera$program_test$Effect$Browser$Dom$id('admin_deleteOrphanedFiles');
var $author$project$Pages$Admin$filesSection$ = function (isMobile, expandedSections, adminData) {
	return $author$project$Pages$Admin$section$(
		isMobile,
		expandedSections,
		13,
		_List_fromArray(
			[
				$author$project$Ui$text(
				'File count: ' + $elm$core$String$fromInt(adminData.filesCount)),
				function () {
				var _v0 = adminData.orphanedFiles;
				switch (_v0.$) {
					case 0:
						return $author$project$Ui$text($author$project$Pages$Admin$loadingText);
					case 1:
						return $author$project$Ui$text($author$project$Pages$Admin$loadingText);
					default:
						var orphanedFiles = _v0.a;
						if ($lamdera$containers$SeqDict$isEmpty(orphanedFiles)) {
							return $author$project$Ui$text('No orphaned files');
						} else {
							var largestFirst = A2(
								$elm$core$List$sortBy,
								function (_v6) {
									var file = _v6.b;
									return -file.fileSize;
								},
								$lamdera$containers$SeqDict$toList(orphanedFiles));
							return $author$project$Ui$column$(
								_List_fromArray(
									[
										$author$project$Ui$spacing(8)
									]),
								_List_fromArray(
									[
										$author$project$Ui$row$(
										_List_fromArray(
											[
												$author$project$Ui$spacing(8)
											]),
										_List_fromArray(
											[
												$author$project$MyUi$simpleButton$(
												$author$project$Pages$Admin$deleteOrphanedFilesButtonId,
												$author$project$Pages$Admin$PressedDeleteOrphanedFiles,
												$author$project$Ui$text('Delete orphaned files')),
												function () {
												var _v1 = adminData.deleteOrphanedFiles;
												switch (_v1.$) {
													case 0:
														return $author$project$Ui$none;
													case 1:
														return $author$project$Ui$text('Deleting...');
													default:
														var error = _v1.a;
														return $author$project$MyUi$errorBox$(
															$lamdera$program_test$Effect$Browser$Dom$id('admin_deleteOrphanedFilesError'),
															$author$project$Pages$Admin$PressedCopyText,
															$author$project$Log$httpErrorToString(error));
												}
											}()
											])),
										$author$project$Ui$text(
										'Orphaned file count: ' + ($elm$core$String$fromInt(
											$lamdera$containers$SeqDict$size(orphanedFiles)) + (', total size: ' + $author$project$FileStatus$sizeToString(
											$elm$core$List$sum(
												$elm$core$List$map$(
													function (_v2) {
														var file = _v2.b;
														return file.fileSize;
													},
													largestFirst)))))),
										$author$project$Ui$column$(
										_List_fromArray(
											[
												$author$project$Ui$spacing(2),
												$author$project$Ui$Font$size(14)
											]),
										$elm$core$List$map$(
											function (_v3) {
												var fileHash = _v3.a;
												var file = _v3.b;
												return $author$project$Ui$row$(
													_List_fromArray(
														[
															$author$project$Ui$spacing(16)
														]),
													_List_fromArray(
														[
															$author$project$Ui$el$(
															_List_fromArray(
																[
																	$author$project$Ui$width(
																	$author$project$Ui$px(80))
																]),
															$author$project$Ui$text(
																$author$project$FileStatus$sizeToString(file.fileSize))),
															$author$project$Ui$el$(
															_List_fromArray(
																[
																	$author$project$Ui$width(
																	$author$project$Ui$px(100))
																]),
															function () {
																var _v4 = file.imageSize;
																if (!_v4.$) {
																	var imageSize = _v4.a;
																	return $author$project$Ui$text(
																		$elm$core$String$fromInt(
																			$author$project$Coord$xRaw(imageSize)) + ('×' + $elm$core$String$fromInt(
																			$author$project$Coord$yRaw(imageSize))));
																} else {
																	return $author$project$Ui$none;
																}
															}()),
															$author$project$Ui$el$(
															_List_fromArray(
																[
																	$author$project$Ui$linkNewTab(
																	function () {
																		var _v5 = file.imageSize;
																		if (!_v5.$) {
																			return $author$project$FileStatus$fileUrl$($author$project$FileStatus$pngContent, fileHash);
																		} else {
																			return $author$project$FileStatus$fileUrl$($author$project$FileStatus$unknownContentType, fileHash);
																		}
																	}()),
																	$author$project$Ui$Font$color($author$project$MyUi$textLinkColor),
																	$author$project$Ui$width($author$project$Ui$shrink)
																]),
															$author$project$Ui$text(
																$author$project$FileStatus$fileHashToString(fileHash)))
														]));
											},
											largestFirst))
									]));
						}
				}
			}()
			]));
};
var $author$project$Pages$Admin$filesSection = F3($author$project$Pages$Admin$filesSection$);
var $author$project$Pages$Admin$GuildsSection = 8;
var $author$project$Pages$Admin$PressedDeleteGuild = function (a) {
	return {$: 30, a: a};
};
var $author$project$Pages$Admin$PressedExpandGuild = function (a) {
	return {$: 29, a: a};
};
var $author$project$Pages$Admin$deleteGuildButtonId = function (guildId) {
	return $lamdera$program_test$Effect$Browser$Dom$id(
		'Admin_deleteGuildButton_' + $author$project$Id$toString(guildId));
};
var $author$project$Pages$Admin$guildsSection$ = function (isMobile, expandedSections, expandedGuilds, adminData) {
	return $author$project$Pages$Admin$section$(
		isMobile,
		expandedSections,
		8,
		_List_fromArray(
			[
				function () {
				var _v0 = adminData.guilds;
				switch (_v0.$) {
					case 0:
						return $author$project$Ui$text($author$project$Pages$Admin$loadingText);
					case 1:
						return $author$project$Ui$text($author$project$Pages$Admin$loadingText);
					default:
						var guilds = _v0.a;
						return $lamdera$containers$SeqDict$isEmpty(guilds) ? $author$project$Ui$text('No guilds') : $author$project$Ui$column$(
							_List_fromArray(
								[
									$author$project$Ui$spacing(4)
								]),
							$elm$core$List$map$(
								function (_v1) {
									var guildId = _v1.a;
									var guild = _v1.b;
									var isExpanded = $lamdera$containers$SeqSet$member$(guildId, expandedGuilds);
									var channelCount = $lamdera$containers$SeqDict$size(guild.channels);
									return $author$project$Ui$column$(
										_List_fromArray(
											[
												$author$project$Ui$spacing(4)
											]),
										_List_fromArray(
											[
												$author$project$Ui$row$(
												_List_fromArray(
													[
														$author$project$Ui$spacing(8),
														$author$project$Ui$Font$size(14)
													]),
												_List_fromArray(
													[
														$author$project$Ui$el$(
														_List_fromArray(
															[
																$author$project$Ui$width($author$project$Ui$shrink),
																$author$project$Ui$Input$button(
																$author$project$Pages$Admin$PressedExpandGuild(guildId)),
																$author$project$MyUi$hoverText(
																isExpanded ? 'Collapse' : 'Expand')
															]),
														isExpanded ? $author$project$Icons$collapseContainer : $author$project$Icons$expandContainer),
														$author$project$Ui$text(
														$author$project$Id$toString(guildId)),
														$author$project$Ui$text(
														$author$project$GuildName$toString(guild.name)),
														$author$project$Ui$row$(
														_List_fromArray(
															[
																$author$project$Ui$spacing(8)
															]),
														_List_fromArray(
															[
																$author$project$Ui$text('Owner:'),
																function () {
																var _v2 = $author$project$Pages$Admin$adminUser$(guild.owner, adminData);
																if (!_v2.$) {
																	var user2 = _v2.a;
																	return $author$project$Pages$Admin$userLabel(user2);
																} else {
																	return $author$project$Ui$text(
																		$author$project$Id$toString(guild.owner));
																}
															}()
															])),
														$author$project$Ui$text(
														'Channels: ' + $elm$core$String$fromInt(channelCount)),
														$author$project$Ui$text(
														'Members: ' + $elm$core$String$fromInt(guild.memberCount)),
														$author$project$MyUi$deleteButton$(
														$author$project$Pages$Admin$deleteGuildButtonId(guildId),
														$author$project$Pages$Admin$PressedDeleteGuild(guildId))
													])),
												isExpanded ? $author$project$Ui$column$(
												_List_fromArray(
													[
														$author$project$Ui$spacing(2),
														$author$project$Ui$paddingWith(
														{bottom: 0, left: 32, right: 0, top: 0})
													]),
												$elm$core$List$map$(
													function (_v3) {
														var channel = _v3.b;
														return $author$project$Ui$row$(
															_List_fromArray(
																[
																	$author$project$Ui$spacing(8),
																	$author$project$Ui$Font$size(13)
																]),
															_List_fromArray(
																[
																	$author$project$Ui$text(
																	'#' + $author$project$ChannelName$toString(channel.name)),
																	$author$project$Ui$text(
																	'Messages: ' + $elm$core$String$fromInt(channel.messageCount))
																]));
													},
													$lamdera$containers$SeqDict$toList(guild.channels))) : $author$project$Ui$none
											]));
								},
								$lamdera$containers$SeqDict$toList(guilds)));
				}
			}()
			]));
};
var $author$project$Pages$Admin$guildsSection = F4($author$project$Pages$Admin$guildsSection$);
var $author$project$Pages$Admin$LogSection = 1;
var $author$project$Pages$Admin$PressedCopyLogLink = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$PressedLogPage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$logPageRange = 4;
var $author$project$Pages$Admin$maxVisiblePages = 20;
var $author$project$Pagination$pageCount = function (model) {
	return ((($author$project$Pagination$pageSize - 1) + model.totalItems) / $author$project$Pagination$pageSize) | 0;
};
var $author$project$MyUi$buttonShadows = _List_fromArray(
	[
		{
		blur: 4,
		color: $author$project$Ui$rgba$(0, 0, 0, 0.1),
		size: -1,
		x: 0,
		y: 2
	},
		{
		blur: 2,
		color: $author$project$Ui$rgba$(0, 0, 0, 0.1),
		size: -2,
		x: 0,
		y: 0
	}
	]);
var $author$project$MyUi$button$ = function (attrs, text) {
	return $author$project$Ui$el$(
		_Utils_ap(
			_List_fromArray(
				[
					$author$project$Ui$paddingXY$(8, 4),
					$author$project$Ui$rounded(8),
					$author$project$Ui$border(1),
					$author$project$Ui$width($author$project$Ui$shrink),
					$author$project$Ui$background($author$project$MyUi$buttonBackground),
					$author$project$Ui$borderColor($author$project$MyUi$buttonBorder),
					$author$project$Ui$Font$weight(600),
					$author$project$Ui$Font$color($author$project$MyUi$white),
					$author$project$Ui$Shadow$shadows($author$project$MyUi$buttonShadows),
					$author$project$Ui$contentCenterY
				]),
			attrs),
		$author$project$Ui$text(text));
};
var $author$project$MyUi$button = F2($author$project$MyUi$button$);
var $author$project$MyUi$unselectedGray = $author$project$Ui$rgb$(220, 220, 220);
var $author$project$MyUi$unselectedBackground = $author$project$Ui$background($author$project$MyUi$unselectedGray);
var $author$project$MyUi$radioRowWithSeparators$ = function (attrs, selected, onPress, separator, children) {
	var outerCount = $elm$core$List$length(children);
	return $author$project$Ui$row$(
		attrs,
		$elm$core$List$intersperse$(
			separator,
			$elm$core$List$indexedMap$(
				F2(
					function (outerIndex, innerChildren) {
						var innerCount = $elm$core$List$length(innerChildren);
						return $author$project$Ui$row$(
							_List_fromArray(
								[
									$author$project$Ui$Shadow$shadows($author$project$MyUi$buttonShadows)
								]),
							$elm$core$List$indexedMap$(
								F2(
									function (innerIndex, _v0) {
										var child = _v0.a;
										var label2 = _v0.b;
										var commonAttrs = _List_fromArray(
											[
												$author$project$Ui$Input$button(
												onPress(child)),
												$author$project$MyUi$touchPress(
												onPress(child)),
												$author$project$Ui$attrIf$(
												!_Utils_eq(child, selected),
												$author$project$MyUi$unselectedBackground),
												$author$project$Ui$attrIf$(
												!_Utils_eq(child, selected),
												$author$project$Ui$Font$color($author$project$MyUi$black)),
												$author$project$Ui$width($author$project$Ui$fill),
												$author$project$Ui$Shadow$shadows(_List_Nil)
											]);
										var borderAttrs = ((innerCount === 1) && (outerCount === 1)) ? _List_fromArray(
											[
												$author$project$Ui$rounded(8)
											]) : (((!innerIndex) && (!outerIndex)) ? _List_fromArray(
											[
												$author$project$Ui$roundedWith(
												{bottomLeft: 8, bottomRight: 0, topLeft: 8, topRight: 0})
											]) : (((!innerIndex) && (outerIndex > 0)) ? _List_fromArray(
											[
												$author$project$Ui$rounded(0),
												$author$project$Ui$borderWith(
												{bottom: 1, left: 1, right: 1, top: 1})
											]) : ((_Utils_eq(innerIndex, innerCount - 1) && _Utils_eq(outerIndex, outerCount - 1)) ? _List_fromArray(
											[
												$author$project$Ui$roundedWith(
												{bottomLeft: 0, bottomRight: 8, topLeft: 0, topRight: 8}),
												$author$project$Ui$borderWith(
												{bottom: 1, left: 0, right: 1, top: 1})
											]) : _List_fromArray(
											[
												$author$project$Ui$rounded(0),
												$author$project$Ui$borderWith(
												{bottom: 1, left: 0, right: 1, top: 1})
											]))));
										return $author$project$MyUi$button$(
											_Utils_ap(commonAttrs, borderAttrs),
											label2);
									}),
								innerChildren));
					}),
				children)));
};
var $author$project$MyUi$radioRowWithSeparators = F5($author$project$MyUi$radioRowWithSeparators$);
var $author$project$MyUi$emailAddress = function (emailAddress2) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[$author$project$Ui$Font$bold]),
		$author$project$Ui$text(
			$author$project$EmailAddress$toString(emailAddress2)));
};
var $author$project$Log$emojiOrCustomEmojiView$ = function (emojiData, customEmojis, emoji) {
	if (!emoji.$) {
		var emoji2 = emoji.a;
		return $author$project$Emoji$view$(emojiData, emoji2);
	} else {
		var customEmojiId = emoji.a;
		var _v1 = $lamdera$containers$SeqDict$get$(customEmojiId, customEmojis);
		if (!_v1.$) {
			var customEmoji = _v1.a;
			return $author$project$Ui$html(
				$author$project$CustomEmoji$viewHelper$('1.1em', '0', customEmoji, 0));
		} else {
			return $author$project$Ui$text(
				$author$project$Id$toString(customEmojiId));
		}
	}
};
var $author$project$Log$emojiOrCustomEmojiView = F3($author$project$Log$emojiOrCustomEmojiView$);
var $author$project$Log$errorDetails = function (content) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(6)
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Font$color($author$project$MyUi$font3),
						$author$project$Ui$Font$size(13),
						$author$project$Ui$width($author$project$Ui$shrink),
						$author$project$MyUi$noShrinking,
						$author$project$Ui$alignTop
					]),
				$author$project$Ui$text('Error:')),
				$author$project$Ui$Prose$paragraph$(
				_List_fromArray(
					[
						$author$project$Ui$Font$size(13),
						$author$project$Ui$paddingXY$(0, 5)
					]),
				content)
			]));
};
var $author$project$Log$errorTag = {
	background: $author$project$Ui$rgb$(254, 226, 226),
	border: $author$project$Ui$rgb$(254, 202, 202),
	font: $author$project$Ui$rgb$(153, 27, 27)
};
var $author$project$Log$fieldRow$ = function (label, value) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(6)
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Font$color($author$project$MyUi$font3),
						$author$project$Ui$Font$size(13),
						$author$project$Ui$width($author$project$Ui$shrink),
						$author$project$MyUi$noShrinking,
						$author$project$Ui$alignTop
					]),
				$author$project$Ui$text(label + ':')),
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Font$size(13)
					]),
				value)
			]));
};
var $author$project$Log$fieldRow = F2($author$project$Log$fieldRow$);
var $author$project$Slack$httpErrorToString = function (error) {
	switch (error.$) {
		case 0:
			var text = error.a;
			return 'Slack said ' + text;
		case 1:
			return 'Rate limited';
		case 2:
			var status = error.a;
			var body = error.b;
			return 'Status ' + ($elm$core$String$fromInt(status) + (': ' + $elm$core$String$left$(200, body)));
		case 3:
			var text = error.a;
			return 'Unexpected response: ' + text;
		case 4:
			return 'Timed out';
		case 5:
			return 'Network error';
		default:
			var url = error.a;
			return 'Bad url ' + url;
	}
};
var $author$project$Log$infoTag = {
	background: $author$project$Ui$rgb$(224, 231, 255),
	border: $author$project$Ui$rgb$(199, 210, 254),
	font: $author$project$Ui$rgb$(55, 48, 163)
};
var $author$project$Log$sendEmailErrorToString = function (sendEmailError) {
	switch (sendEmailError.$) {
		case 0:
			var body = sendEmailError.a.body;
			var statusCode = sendEmailError.a.statusCode;
			return _List_fromArray(
				[
					$author$project$Ui$text(
					$elm$core$String$fromInt(statusCode) + (' ' + body))
				]);
		case 1:
			var response = sendEmailError.a;
			return A2(
				$elm$core$List$cons,
				$author$project$Ui$text(
					'PostmarkError ' + ($elm$core$String$fromInt(response.errorCode) + (' ' + (response.message + ' ')))),
				$elm$core$List$intersperse$(
					$author$project$Ui$text(', '),
					$elm$core$List$map$($author$project$MyUi$emailAddress, response.to)));
		case 2:
			return _List_fromArray(
				[
					$author$project$Ui$text('NetworkError')
				]);
		case 3:
			return _List_fromArray(
				[
					$author$project$Ui$text('Timeout')
				]);
		default:
			var string = sendEmailError.a;
			return _List_fromArray(
				[
					$author$project$Ui$text('BadUrl ' + string)
				]);
	}
};
var $author$project$Log$successColor = $author$project$Ui$rgb$(22, 101, 52);
var $author$project$Log$successTag = {
	background: $author$project$Ui$rgb$(220, 252, 231),
	border: $author$project$Ui$rgb$(187, 247, 208),
	font: $author$project$Ui$rgb$(22, 101, 52)
};
var $author$project$Log$tag$ = function (style, label) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$background(style.background),
				$author$project$Ui$Font$color(style.font),
				$author$project$Ui$borderColor(style.border),
				$author$project$Ui$border(1),
				$author$project$Ui$rounded(4),
				$author$project$Ui$paddingXY$(6, 2),
				$author$project$Ui$Font$size(12),
				$author$project$Ui$Font$bold,
				$author$project$Ui$width($author$project$Ui$shrink)
			]),
		$author$project$Ui$text(label));
};
var $author$project$Log$tag = F2($author$project$Log$tag$);
var $author$project$Log$warningTag = {
	background: $author$project$Ui$rgb$(254, 249, 195),
	border: $author$project$Ui$rgb$(253, 224, 71),
	font: $author$project$Ui$rgb$(133, 77, 14)
};
var $author$project$Log$logContent$ = function (onPressCopy, emojiData, customEmojis, log) {
	switch (log.$) {
		case 0:
			var result = log.a;
			var emailAddress = log.b;
			if (!result.$) {
				return $author$project$Ui$column$(
					_List_fromArray(
						[
							$author$project$Ui$spacing(4)
						]),
					_List_fromArray(
						[
							$author$project$Log$tag$($author$project$Log$successTag, 'Login Email'),
							$author$project$Log$fieldRow$(
							'To',
							$author$project$MyUi$emailAddress(emailAddress)),
							$author$project$Log$fieldRow$(
							'Status',
							$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$Font$color($author$project$Log$successColor)
									]),
								$author$project$Ui$text('Sent')))
						]));
			} else {
				var error = result.a;
				return $author$project$Ui$column$(
					_List_fromArray(
						[
							$author$project$Ui$spacing(4)
						]),
					_List_fromArray(
						[
							$author$project$Log$tag$($author$project$Log$errorTag, 'Login Email Failed'),
							$author$project$Log$fieldRow$(
							'To',
							$author$project$MyUi$emailAddress(emailAddress)),
							$author$project$Log$errorDetails(
							$author$project$Log$sendEmailErrorToString(error))
						]));
			}
		case 1:
			var error = log.a;
			var emailAddress = log.b;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$errorTag, 'Notification Email Failed'),
						$author$project$Log$fieldRow$(
						'To',
						$author$project$MyUi$emailAddress(emailAddress)),
						$author$project$Log$errorDetails(
						$author$project$Log$sendEmailErrorToString(error))
					]));
		case 2:
			var id = log.a;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$warningTag, 'Rate Limited'),
						$author$project$Log$fieldRow$(
						'User',
						$author$project$Ui$text(
							$author$project$Id$toString(id)))
					]));
		case 3:
			var id = log.a;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$infoTag, 'User Table Modified'),
						$author$project$Log$fieldRow$(
						'By',
						$author$project$Ui$text(
							$author$project$Id$toString(id)))
					]));
		case 4:
			var error = log.a;
			var emailAddress = log.b;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$errorTag, 'Log Email Failed'),
						$author$project$Log$fieldRow$(
						'To',
						$author$project$MyUi$emailAddress(emailAddress)),
						$author$project$Log$errorDetails(
						$author$project$Log$sendEmailErrorToString(error))
					]));
		case 5:
			var userId = log.a;
			var error = log.b;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$errorTag, 'Push Notification Error'),
						$author$project$Log$fieldRow$(
						'User',
						$author$project$Ui$text(
							$author$project$Id$toString(userId))),
						$author$project$Log$fieldRow$(
						'Error',
						$author$project$Ui$text(
							$author$project$Log$httpErrorToString(error)))
					]));
		case 6:
			var guildId = log.a;
			var channelId = log.b;
			var discordMessageId = log.d;
			var httpError = log.e;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$errorTag, 'Discord guild message delete failed'),
						$author$project$Log$fieldRow$(
						'Guild',
						$author$project$Ui$text(
							$author$project$Discord$idToString(guildId))),
						$author$project$Log$fieldRow$(
						'Channel',
						$author$project$Ui$text(
							$author$project$Discord$idToString(channelId))),
						$author$project$Log$fieldRow$(
						'Discord message id',
						$author$project$Ui$text(
							$author$project$Discord$idToString(discordMessageId))),
						$author$project$Log$fieldRow$(
						'Error',
						$author$project$Ui$text(
							$author$project$Discord$httpErrorToString(httpError)))
					]));
		case 7:
			var channelId = log.a;
			var messageId = log.b;
			var discordMessageId = log.c;
			var httpError = log.d;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$errorTag, 'Discord DM message delete failed'),
						$author$project$Log$fieldRow$(
						'Channel',
						$author$project$Ui$text(
							$author$project$Discord$idToString(channelId))),
						$author$project$Log$fieldRow$(
						'Message id',
						$author$project$Ui$text(
							$author$project$Id$toString(messageId))),
						$author$project$Log$fieldRow$(
						'Discord message id',
						$author$project$Ui$text(
							$author$project$Discord$idToString(discordMessageId))),
						$author$project$Log$fieldRow$(
						'Error',
						$author$project$Ui$text(
							$author$project$Discord$httpErrorToString(httpError)))
					]));
		case 8:
			var guildId = log.a;
			var channelId = log.b;
			var discordMessageId = log.d;
			var httpError = log.e;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$errorTag, 'Discord guild message edit failed'),
						$author$project$Log$fieldRow$(
						'Guild',
						$author$project$Ui$text(
							$author$project$Discord$idToString(guildId))),
						$author$project$Log$fieldRow$(
						'Channel',
						$author$project$Ui$text(
							$author$project$Discord$idToString(channelId))),
						$author$project$Log$fieldRow$(
						'Discord message id',
						$author$project$Ui$text(
							$author$project$Discord$idToString(discordMessageId))),
						$author$project$Log$fieldRow$(
						'Error',
						$author$project$Ui$text(
							$author$project$Discord$httpErrorToString(httpError)))
					]));
		case 9:
			var channelId = log.a;
			var messageId = log.b;
			var discordMessageId = log.c;
			var httpError = log.d;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$errorTag, 'Discord DM message edit failed'),
						$author$project$Log$fieldRow$(
						'Channel',
						$author$project$Ui$text(
							$author$project$Discord$idToString(channelId))),
						$author$project$Log$fieldRow$(
						'Message id',
						$author$project$Ui$text(
							$author$project$Id$toString(messageId))),
						$author$project$Log$fieldRow$(
						'Discord message id',
						$author$project$Ui$text(
							$author$project$Discord$idToString(discordMessageId))),
						$author$project$Log$fieldRow$(
						'Error',
						$author$project$Ui$text(
							$author$project$Discord$httpErrorToString(httpError)))
					]));
		case 10:
			var guildId = log.a;
			var channelId = log.b;
			var discordMessageId = log.d;
			var emoji = log.e;
			var httpError = log.f;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$errorTag, 'Adding Discord guild reaction failed'),
						$author$project$Log$fieldRow$(
						'Guild',
						$author$project$Ui$text(
							$author$project$Discord$idToString(guildId))),
						$author$project$Log$fieldRow$(
						'Channel',
						$author$project$Ui$text(
							$author$project$Discord$idToString(channelId))),
						$author$project$Log$fieldRow$(
						'Discord message id',
						$author$project$Ui$text(
							$author$project$Discord$idToString(discordMessageId))),
						$author$project$Log$fieldRow$(
						'Emoji',
						$author$project$Log$emojiOrCustomEmojiView$(emojiData, customEmojis, emoji)),
						$author$project$Log$fieldRow$(
						'Error',
						$author$project$Ui$text(
							$author$project$Discord$httpErrorToString(httpError)))
					]));
		case 11:
			var channelId = log.a;
			var messageId = log.b;
			var discordMessageId = log.c;
			var emoji = log.d;
			var httpError = log.e;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$errorTag, 'Adding Discord DM reaction failed'),
						$author$project$Log$fieldRow$(
						'Channel',
						$author$project$Ui$text(
							$author$project$Discord$idToString(channelId))),
						$author$project$Log$fieldRow$(
						'Message id',
						$author$project$Ui$text(
							$author$project$Id$toString(messageId))),
						$author$project$Log$fieldRow$(
						'Discord message id',
						$author$project$Ui$text(
							$author$project$Discord$idToString(discordMessageId))),
						$author$project$Log$fieldRow$(
						'Emoji',
						$author$project$Log$emojiOrCustomEmojiView$(emojiData, customEmojis, emoji)),
						$author$project$Log$fieldRow$(
						'Error',
						$author$project$Ui$text(
							$author$project$Discord$httpErrorToString(httpError)))
					]));
		case 12:
			var guildId = log.a;
			var channelId = log.b;
			var discordMessageId = log.d;
			var emoji = log.e;
			var httpError = log.f;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$errorTag, 'Removing Discord guild reaction failed'),
						$author$project$Log$fieldRow$(
						'Guild',
						$author$project$Ui$text(
							$author$project$Discord$idToString(guildId))),
						$author$project$Log$fieldRow$(
						'Channel',
						$author$project$Ui$text(
							$author$project$Discord$idToString(channelId))),
						$author$project$Log$fieldRow$(
						'Discord message id',
						$author$project$Ui$text(
							$author$project$Discord$idToString(discordMessageId))),
						$author$project$Log$fieldRow$(
						'Emoji',
						$author$project$Log$emojiOrCustomEmojiView$(emojiData, customEmojis, emoji)),
						$author$project$Log$fieldRow$(
						'Error',
						$author$project$Ui$text(
							$author$project$Discord$httpErrorToString(httpError)))
					]));
		case 13:
			var channelId = log.a;
			var messageId = log.b;
			var discordMessageId = log.c;
			var emoji = log.d;
			var httpError = log.e;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$errorTag, 'Removing Discord DM reaction failed'),
						$author$project$Log$fieldRow$(
						'Channel',
						$author$project$Ui$text(
							$author$project$Discord$idToString(channelId))),
						$author$project$Log$fieldRow$(
						'Message id',
						$author$project$Ui$text(
							$author$project$Id$toString(messageId))),
						$author$project$Log$fieldRow$(
						'Discord message id',
						$author$project$Ui$text(
							$author$project$Discord$idToString(discordMessageId))),
						$author$project$Log$fieldRow$(
						'Emoji',
						$author$project$Log$emojiOrCustomEmojiView$(emojiData, customEmojis, emoji)),
						$author$project$Log$fieldRow$(
						'Error',
						$author$project$Ui$text(
							$author$project$Discord$httpErrorToString(httpError)))
					]));
		case 14:
			var discordUserId = log.a;
			var httpError = log.b;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$errorTag, 'Loading Discord user data failed'),
						$author$project$Log$fieldRow$(
						'Discord user id',
						$author$project$Ui$text(
							$author$project$Discord$idToString(discordUserId))),
						$author$project$Log$fieldRow$(
						'Error',
						$author$project$Ui$text(
							$author$project$Discord$httpErrorToString(httpError)))
					]));
		case 15:
			var discordUserId = log.a;
			var guildId = log.b;
			var channelId = log.c;
			var httpError = log.e;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$errorTag, 'Sending Discord guild message failed'),
						$author$project$Log$fieldRow$(
						'User',
						$author$project$Ui$text(
							$author$project$Discord$idToString(discordUserId))),
						$author$project$Log$fieldRow$(
						'Guild',
						$author$project$Ui$text(
							$author$project$Discord$idToString(guildId))),
						$author$project$Log$fieldRow$(
						'Channel',
						$author$project$Ui$text(
							$author$project$Discord$idToString(channelId))),
						$author$project$Log$fieldRow$(
						'Error',
						$author$project$Ui$text(
							$author$project$Discord$httpErrorToString(httpError)))
					]));
		case 16:
			var discordUserId = log.a;
			var channelId = log.b;
			var httpError = log.c;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$errorTag, 'Sending Discord DM message failed'),
						$author$project$Log$fieldRow$(
						'User',
						$author$project$Ui$text(
							$author$project$Discord$idToString(discordUserId))),
						$author$project$Log$fieldRow$(
						'Channel',
						$author$project$Ui$text(
							$author$project$Discord$idToString(channelId))),
						$author$project$Log$fieldRow$(
						'Error',
						$author$project$Ui$text(
							$author$project$Discord$httpErrorToString(httpError)))
					]));
		case 17:
			var httpError = log.a;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$errorTag, 'Loading Discord user avatars failed'),
						$author$project$Log$fieldRow$(
						'Error',
						$author$project$Ui$text(
							$author$project$Discord$httpErrorToString(httpError)))
					]));
		case 18:
			var maybeName = log.a;
			var jsonError = log.b;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$(
						$author$project$Log$errorTag,
						function () {
							if (!maybeName.$) {
								var name = maybeName.a;
								return 'Parsing Discord websocket failed (' + (name + ')');
							} else {
								return 'Parsing Discord websocket failed';
							}
						}()),
						$author$project$MyUi$errorBox$(
						$lamdera$program_test$Effect$Browser$Dom$id('admin_FailedToParseDiscordWebsocket'),
						onPressCopy,
						jsonError)
					]));
		case 19:
			var discordUserId = log.a;
			var guildId = log.b;
			var httpError = log.c;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$errorTag, 'Discord data for guild that was created or joined failed'),
						$author$project$Log$fieldRow$(
						'User',
						$author$project$Ui$text(
							$author$project$Discord$idToString(discordUserId))),
						$author$project$Log$fieldRow$(
						'Guild',
						$author$project$Ui$text(
							$author$project$Discord$idToString(guildId))),
						$author$project$Log$fieldRow$(
						'Error',
						$author$project$Ui$text(
							$author$project$Discord$httpErrorToString(httpError)))
					]));
		case 20:
			var guildId = log.a;
			var httpError = log.b;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$errorTag, 'Reloading Discord guild failed'),
						$author$project$Log$fieldRow$(
						'Guild',
						$author$project$Ui$text(
							$author$project$Discord$idToString(guildId))),
						$author$project$Log$fieldRow$(
						'Error',
						$author$project$Ui$text(
							$author$project$Discord$httpErrorToString(httpError)))
					]));
		case 21:
			var guildId = log.a;
			var httpError = log.b;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$errorTag, 'Joining Discord thread failed'),
						$author$project$Log$fieldRow$(
						'Guild',
						$author$project$Ui$text(
							$author$project$Discord$idToString(guildId))),
						$author$project$Log$fieldRow$(
						'Error',
						$author$project$Ui$text(
							$author$project$Discord$httpErrorToString(httpError)))
					]));
		case 22:
			var message = log.a;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$errorTag, 'Discord message has no content'),
						$author$project$MyUi$errorBox$(
						$lamdera$program_test$Effect$Browser$Dom$id('admin_DiscordMessageNoContent'),
						onPressCopy,
						message)
					]));
		case 23:
			var nonempty = log.a;
			var totalStickers = log.b;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				A2(
					$elm$core$List$cons,
					$author$project$Log$tag$($author$project$Log$errorTag, 'Discord guild stickers failed to load'),
					A2(
						$elm$core$List$cons,
						$author$project$Log$fieldRow$(
							'Total stickers',
							$author$project$Ui$text(
								$elm$core$String$fromInt(totalStickers))),
						$elm$core$List$map$(
							function (_v3) {
								var stickerId = _v3.a;
								var error = _v3.b;
								return $author$project$Log$fieldRow$(
									'Sticker ' + $author$project$Id$toString(stickerId),
									$author$project$Ui$text(
										$author$project$Log$httpErrorToString(error)));
							},
							$mgold$elm_nonempty_list$List$Nonempty$toList(nonempty)))));
		case 24:
			var httpError = log.a;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$errorTag, 'Discord standard sticker packs failed to load'),
						$author$project$Log$fieldRow$(
						'Error',
						$author$project$Ui$text(
							$author$project$Discord$httpErrorToString(httpError)))
					]));
		case 25:
			var nonempty = log.a;
			var totalCustomEmojis = log.b;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				A2(
					$elm$core$List$cons,
					$author$project$Log$tag$($author$project$Log$errorTag, 'Discord guild custom emojis failed to load'),
					A2(
						$elm$core$List$cons,
						$author$project$Log$fieldRow$(
							'Total custom emojis',
							$author$project$Ui$text(
								$elm$core$String$fromInt(totalCustomEmojis))),
						$elm$core$List$map$(
							function (_v4) {
								var customEmojiId = _v4.a;
								var error = _v4.b;
								return $author$project$Log$fieldRow$(
									'Custom emoji ' + $author$project$Id$toString(customEmojiId),
									$author$project$Ui$text(
										$author$project$Log$httpErrorToString(error)));
							},
							$mgold$elm_nonempty_list$List$Nonempty$toList(nonempty)))));
		case 26:
			var httpError = log.a;
			var backupSize = log.b;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$errorTag, 'Scheduled backend backup generation failed'),
						$author$project$Log$fieldRow$(
						'Error',
						$author$project$Ui$text(
							$author$project$Log$httpErrorToString(httpError))),
						$author$project$Log$fieldRow$(
						'Backup size',
						$author$project$Ui$text(
							$author$project$FileStatus$sizeToString(backupSize)))
					]));
		case 27:
			var error = log.a;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$errorTag, 'Regenerating server secret failed'),
						$author$project$Log$fieldRow$(
						'Error',
						$author$project$Ui$text(
							$author$project$Log$httpErrorToString(error)))
					]));
		case 28:
			var error = log.a;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$errorTag, 'Deleting orphaned files failed'),
						$author$project$Log$fieldRow$(
						'Error',
						$author$project$Ui$text(
							$author$project$Log$httpErrorToString(error)))
					]));
		case 29:
			var teamId = log.a;
			var error = log.b;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$errorTag, 'Loading Slack channels and DMs failed'),
						$author$project$Log$fieldRow$(
						'Workspace',
						$author$project$Ui$text(
							$author$project$Slack$idToString(teamId))),
						$author$project$Log$fieldRow$(
						'Error',
						$author$project$Ui$text(
							$author$project$Slack$httpErrorToString(error)))
					]));
		case 30:
			var teamId = log.a;
			var nonempty = log.b;
			var totalCustomEmojis = log.c;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				A2(
					$elm$core$List$cons,
					$author$project$Log$tag$($author$project$Log$errorTag, 'Slack custom emojis failed to load'),
					A2(
						$elm$core$List$cons,
						$author$project$Log$fieldRow$(
							'Workspace',
							$author$project$Ui$text(
								$author$project$Slack$idToString(teamId))),
						A2(
							$elm$core$List$cons,
							$author$project$Log$fieldRow$(
								'Total custom emojis',
								$author$project$Ui$text(
									$elm$core$String$fromInt(totalCustomEmojis))),
							$elm$core$List$map$(
								function (_v5) {
									var customEmojiId = _v5.a;
									var error = _v5.b;
									return $author$project$Log$fieldRow$(
										'Custom emoji ' + $author$project$Id$toString(customEmojiId),
										$author$project$Ui$text(
											$author$project$Log$httpErrorToString(error)));
								},
								$mgold$elm_nonempty_list$List$Nonempty$toList(nonempty))))));
		case 31:
			var guildOrDmId = log.a;
			var error = log.b;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$errorTag, 'Sending Slack message failed'),
						function () {
						if (!guildOrDmId.$) {
							var currentUserId = guildOrDmId.a.currentUserId;
							var channelId = guildOrDmId.a.channelId;
							var teamId = guildOrDmId.a.teamId;
							return $author$project$Ui$column$(
								_List_fromArray(
									[
										$author$project$Ui$spacing(4)
									]),
								_List_fromArray(
									[
										$author$project$Log$fieldRow$(
										'User',
										$author$project$Ui$text(
											$author$project$Slack$idToString(currentUserId))),
										$author$project$Log$fieldRow$(
										'Workspace',
										$author$project$Ui$text(
											$author$project$Slack$idToString(teamId))),
										$author$project$Log$fieldRow$(
										'Channel',
										$author$project$Ui$text(
											$author$project$Slack$idToString(channelId)))
									]));
						} else {
							var channelId = guildOrDmId.a.channelId;
							var currentUserId = guildOrDmId.a.currentUserId;
							return $author$project$Ui$column$(
								_List_fromArray(
									[
										$author$project$Ui$spacing(4)
									]),
								_List_fromArray(
									[
										$author$project$Log$fieldRow$(
										'User',
										$author$project$Ui$text(
											$author$project$Slack$idToString(currentUserId))),
										$author$project$Log$fieldRow$(
										'DM',
										$author$project$Ui$text(
											$author$project$Slack$idToString(channelId)))
									]));
						}
					}(),
						$author$project$Log$fieldRow$(
						'Error',
						$author$project$Ui$text(
							$author$project$Slack$httpErrorToString(error)))
					]));
		case 32:
			var guildOrDmId = log.a;
			var error = log.b;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$errorTag, 'Adding or removing a Slack reaction failed'),
						function () {
						if (!guildOrDmId.$) {
							var currentUserId = guildOrDmId.a.currentUserId;
							var channelId = guildOrDmId.a.channelId;
							var teamId = guildOrDmId.a.teamId;
							return $author$project$Ui$column$(
								_List_fromArray(
									[
										$author$project$Ui$spacing(4)
									]),
								_List_fromArray(
									[
										$author$project$Log$fieldRow$(
										'User',
										$author$project$Ui$text(
											$author$project$Slack$idToString(currentUserId))),
										$author$project$Log$fieldRow$(
										'Workspace',
										$author$project$Ui$text(
											$author$project$Slack$idToString(teamId))),
										$author$project$Log$fieldRow$(
										'Channel',
										$author$project$Ui$text(
											$author$project$Slack$idToString(channelId)))
									]));
						} else {
							var channelId = guildOrDmId.a.channelId;
							var currentUserId = guildOrDmId.a.currentUserId;
							return $author$project$Ui$column$(
								_List_fromArray(
									[
										$author$project$Ui$spacing(4)
									]),
								_List_fromArray(
									[
										$author$project$Log$fieldRow$(
										'User',
										$author$project$Ui$text(
											$author$project$Slack$idToString(currentUserId))),
										$author$project$Log$fieldRow$(
										'DM',
										$author$project$Ui$text(
											$author$project$Slack$idToString(channelId)))
									]));
						}
					}(),
						$author$project$Log$fieldRow$(
						'Error',
						$author$project$Ui$text(
							$author$project$Slack$httpErrorToString(error)))
					]));
		case 33:
			var guildOrDmId = log.a;
			var error = log.b;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$errorTag, 'Deleting a Slack message failed'),
						function () {
						if (!guildOrDmId.$) {
							var currentUserId = guildOrDmId.a.currentUserId;
							var channelId = guildOrDmId.a.channelId;
							var teamId = guildOrDmId.a.teamId;
							return $author$project$Ui$column$(
								_List_fromArray(
									[
										$author$project$Ui$spacing(4)
									]),
								_List_fromArray(
									[
										$author$project$Log$fieldRow$(
										'User',
										$author$project$Ui$text(
											$author$project$Slack$idToString(currentUserId))),
										$author$project$Log$fieldRow$(
										'Workspace',
										$author$project$Ui$text(
											$author$project$Slack$idToString(teamId))),
										$author$project$Log$fieldRow$(
										'Channel',
										$author$project$Ui$text(
											$author$project$Slack$idToString(channelId)))
									]));
						} else {
							var channelId = guildOrDmId.a.channelId;
							var currentUserId = guildOrDmId.a.currentUserId;
							return $author$project$Ui$column$(
								_List_fromArray(
									[
										$author$project$Ui$spacing(4)
									]),
								_List_fromArray(
									[
										$author$project$Log$fieldRow$(
										'User',
										$author$project$Ui$text(
											$author$project$Slack$idToString(currentUserId))),
										$author$project$Log$fieldRow$(
										'DM',
										$author$project$Ui$text(
											$author$project$Slack$idToString(channelId)))
									]));
						}
					}(),
						$author$project$Log$fieldRow$(
						'Error',
						$author$project$Ui$text(
							$author$project$Slack$httpErrorToString(error)))
					]));
		case 34:
			var guildOrDmId = log.a;
			var error = log.b;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$errorTag, 'Editing a Slack message failed'),
						function () {
						if (!guildOrDmId.$) {
							var currentUserId = guildOrDmId.a.currentUserId;
							var channelId = guildOrDmId.a.channelId;
							var teamId = guildOrDmId.a.teamId;
							return $author$project$Ui$column$(
								_List_fromArray(
									[
										$author$project$Ui$spacing(4)
									]),
								_List_fromArray(
									[
										$author$project$Log$fieldRow$(
										'User',
										$author$project$Ui$text(
											$author$project$Slack$idToString(currentUserId))),
										$author$project$Log$fieldRow$(
										'Workspace',
										$author$project$Ui$text(
											$author$project$Slack$idToString(teamId))),
										$author$project$Log$fieldRow$(
										'Channel',
										$author$project$Ui$text(
											$author$project$Slack$idToString(channelId)))
									]));
						} else {
							var channelId = guildOrDmId.a.channelId;
							var currentUserId = guildOrDmId.a.currentUserId;
							return $author$project$Ui$column$(
								_List_fromArray(
									[
										$author$project$Ui$spacing(4)
									]),
								_List_fromArray(
									[
										$author$project$Log$fieldRow$(
										'User',
										$author$project$Ui$text(
											$author$project$Slack$idToString(currentUserId))),
										$author$project$Log$fieldRow$(
										'DM',
										$author$project$Ui$text(
											$author$project$Slack$idToString(channelId)))
									]));
						}
					}(),
						$author$project$Log$fieldRow$(
						'Error',
						$author$project$Ui$text(
							$author$project$Slack$httpErrorToString(error)))
					]));
		case 35:
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Log$tag$($author$project$Log$errorTag, 'Received TypeThatIsAlwaysInvalid'),
						$author$project$Log$fieldRow$(
						'Error',
						$author$project$Ui$text('A ToBackend message that should have failed wire validation reached the backend'))
					]));
		default:
			return $author$project$Log$tag$($author$project$Log$infoTag, 'Deleted after 30 days');
	}
};
var $author$project$Log$logContent = F4($author$project$Log$logContent$);
var $author$project$Log$monthToString = function (month) {
	switch (month) {
		case 0:
			return '1';
		case 1:
			return '2';
		case 2:
			return '3';
		case 3:
			return '4';
		case 4:
			return '5';
		case 5:
			return '6';
		case 6:
			return '7';
		case 7:
			return '8';
		case 8:
			return '9';
		case 9:
			return '10';
		case 10:
			return '11';
		default:
			return '12';
	}
};
var $author$project$Log$timeToString$ = function (timezone, includeYear, time) {
	return $elm$core$String$padLeft$(
		2,
		'0',
		$elm$core$String$fromInt(
			$elm$time$Time$toHour$(timezone, time))) + (':' + ($elm$core$String$padLeft$(
		2,
		'0',
		$elm$core$String$fromInt(
			$elm$time$Time$toMinute$(timezone, time))) + ('\u00A0' + ($elm$core$String$fromInt(
		$elm$time$Time$toDay$(timezone, time)) + ('/' + ($author$project$Log$monthToString(
		$elm$time$Time$toMonth$(timezone, time)) + (includeYear ? ('/' + $elm$core$String$fromInt(
		$elm$time$Time$toYear$(timezone, time))) : '')))))));
};
var $author$project$Log$timeToString = F3($author$project$Log$timeToString$);
var $author$project$Log$view$ = function (isMobile2, timezone, emojiData, customEmojis, msgConfig, isCopied, isHighlighted, _v0) {
	var log = _v0.log;
	var time = _v0.time;
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$attrIf$(
				isHighlighted,
				$author$project$Ui$background($author$project$MyUi$mentionColor)),
				$author$project$Ui$paddingXY$(8, 4),
				$author$project$Ui$widthMin(350),
				$author$project$Ui$inFront(
				$author$project$Ui$row$(
					_List_fromArray(
						[
							$author$project$Ui$Font$color($author$project$MyUi$font3),
							$author$project$Ui$width($author$project$Ui$shrink),
							$author$project$Ui$spacing(4),
							$author$project$Ui$contentCenterY,
							$author$project$Ui$Font$size(14),
							$author$project$Ui$alignRight,
							$author$project$Ui$paddingXY$(8, 4)
						]),
					_List_fromArray(
						[
							isCopied ? $author$project$Ui$text('Link copied!') : $author$project$Ui$none,
							$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$move(
									$author$project$Ui$up(1)),
									$author$project$Ui$Input$button(msgConfig.onPressCopyLink),
									$author$project$Ui$id('Log_copyLink'),
									$author$project$MyUi$hover$(
									isMobile2,
									_List_fromArray(
										[
											$author$project$Ui$Anim$fontColor($author$project$MyUi$font1)
										])),
									$author$project$MyUi$hoverText('Copy link')
								]),
							$author$project$Ui$html($author$project$Icons$link)),
							$author$project$Ui$text(
							$author$project$Log$timeToString$(timezone, false, time))
						])))
			]),
		$author$project$Log$logContent$(msgConfig.onPressCopy, emojiData, customEmojis, log));
};
var $author$project$Log$view = F8($author$project$Log$view$);
var $author$project$Pagination$offsetToItemId$ = function (index, model) {
	return $author$project$Id$fromInt(
		($author$project$Pagination$pageSize * $author$project$Id$toInt(model.currentPage)) + index);
};
var $author$project$Pagination$offsetToItemId = F2($author$project$Pagination$offsetToItemId$);
var $author$project$Pagination$viewPage$ = function (htmlId, itemView, model) {
	var _v0 = $lamdera$containers$SeqDict$get$(model.currentPage, model.pages);
	if ((!_v0.$) && (_v0.a.$ === 1)) {
		var page = _v0.a.a;
		return $author$project$Ui$el$(
			_List_Nil,
			$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$id(
						$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId))
					]),
				$elm$core$List$indexedMap$(
					F2(
						function (index, log) {
							return A2(
								itemView,
								$author$project$Pagination$offsetToItemId$(index, model),
								log);
						}),
					$elm$core$Array$toList(page))));
	} else {
		var _v1 = $lamdera$containers$SeqDict$get$(model.previousPage, model.pages);
		if ((!_v1.$) && (_v1.a.$ === 1)) {
			var page = _v1.a.a;
			return $author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$inFront(
						$author$project$Ui$row$(
							_List_fromArray(
								[
									$author$project$Ui$spacing(8)
								]),
							_List_fromArray(
								[
									$author$project$Ui$text('Loading'),
									$author$project$Icons$spinner
								])))
					]),
				$author$project$Ui$column$(
					_List_fromArray(
						[
							$author$project$Ui$id(
							$lamdera$program_test$Effect$Browser$Dom$idToString(htmlId)),
							$author$project$Ui$opacity(0)
						]),
					$elm$core$List$indexedMap$(
						F2(
							function (index, log) {
								return A2(
									itemView,
									$author$project$Pagination$offsetToItemId$(index, model),
									log);
							}),
						$elm$core$Array$toList(page))));
		} else {
			return $author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(8)
					]),
				_List_fromArray(
					[
						$author$project$Ui$text('Loading'),
						$author$project$Icons$spinner
					]));
		}
	}
};
var $author$project$Pagination$viewPage = F3($author$project$Pagination$viewPage$);
var $author$project$Pages$Admin$logSection$ = function (isMobile2, localUser, expandedSections, adminData, model) {
	var pageIndex = $author$project$Id$toInt(adminData.logs.currentPage);
	var pageCount = $author$project$Pagination$pageCount(adminData.logs);
	return $author$project$Pages$Admin$section$(
		isMobile2,
		expandedSections,
		1,
		_List_fromArray(
			[
				$author$project$Pagination$viewPage$(
				$author$project$Pages$Admin$logSectionId,
				F2(
					function (logId, log) {
						return $author$project$Log$view$(
							isMobile2,
							localUser.timezone,
							localUser.emojiData,
							localUser.customEmojis,
							{
								onPressCopy: $author$project$Pages$Admin$PressedCopyText,
								onPressCopyLink: $author$project$Pages$Admin$PressedCopyLogLink(logId)
							},
							_Utils_eq(
								$elm$core$Maybe$Just(logId),
								model.copiedLogLink),
							_Utils_eq(
								$elm$core$Maybe$Just(logId),
								model.highlightLog),
							log);
					}),
				adminData.logs),
				$author$project$MyUi$radioRowWithSeparators$(
				_List_fromArray(
					[
						$author$project$Ui$width($author$project$Ui$shrink),
						$author$project$Ui$centerX
					]),
				pageIndex,
				function (index) {
					return $author$project$Pages$Admin$PressedLogPage(
						$author$project$Id$fromInt(index));
				},
				$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$paddingXY$(2, 0)
						]),
					$author$project$Ui$text('...')),
				$elm$core$List$map$(
					$elm$core$List$map(
						function (index) {
							return _Utils_Tuple2(
								index,
								$elm$core$String$fromInt(index + 1));
						}),
					(pageCount <= 1) ? _List_Nil : ((_Utils_cmp(pageCount, $author$project$Pages$Admin$maxVisiblePages) < 1) ? _List_fromArray(
						[
							$elm$core$List$range$(0, pageCount - 1)
						]) : (((pageIndex - $author$project$Pages$Admin$logPageRange) <= 2) ? _List_fromArray(
						[
							$elm$core$List$range$(0, 2 + ($author$project$Pages$Admin$logPageRange * 2)),
							$elm$core$List$range$(pageCount - 3, pageCount - 1)
						]) : ((_Utils_cmp(pageIndex + $author$project$Pages$Admin$logPageRange, pageCount - 2) > -1) ? _List_fromArray(
						[
							$elm$core$List$range$(0, 2),
							$elm$core$List$range$((pageCount - 3) - ($author$project$Pages$Admin$logPageRange * 2), pageCount - 1)
						]) : _List_fromArray(
						[
							$elm$core$List$range$(0, 2),
							$elm$core$List$range$(pageIndex - $author$project$Pages$Admin$logPageRange, pageIndex + $author$project$Pages$Admin$logPageRange),
							$elm$core$List$range$(pageCount - 3, pageCount - 1)
						]))))))
			]));
};
var $author$project$Pages$Admin$logSection = F5($author$project$Pages$Admin$logSection$);
var $author$project$Pages$Admin$PressedDeleteSession = function (a) {
	return {$: 57, a: a};
};
var $author$project$Pages$Admin$SessionsSection = 17;
var $author$project$Pages$Admin$notificationModeToString = function (mode) {
	switch (mode) {
		case 0:
			return 'None';
		case 1:
			return 'When running';
		default:
			return 'Push';
	}
};
var $miniBill$elm_codec$Codec$encodeToString$ = function (indentation, codec) {
	return A2(
		$elm$core$Basics$composeR,
		$miniBill$elm_codec$Codec$encoder(codec),
		$elm$json$Json$Encode$encode(indentation));
};
var $miniBill$elm_codec$Codec$encodeToString = F2($miniBill$elm_codec$Codec$encodeToString$);
var $author$project$Pages$Admin$pushSubscriptionToString$ = function (timezone, pushSubscription) {
	switch (pushSubscription.$) {
		case 0:
			return 'Not subscribed';
		case 1:
			var subscribeData = pushSubscription.a;
			var time = pushSubscription.b;
			return 'Subscribed, last notification sent at ' + ($author$project$MyUi$datestamp$(timezone, time) + (' ' + ($author$project$MyUi$timestamp$(time, timezone) + (', Subscription: ' + A3($miniBill$elm_codec$Codec$encodeToString, 0, $author$project$Ports$subscribeDataCodec, subscribeData)))));
		case 2:
			var subscribeData = pushSubscription.a;
			var error = pushSubscription.b;
			return $author$project$Log$httpErrorToString(error) + (', Subscription: ' + A3($miniBill$elm_codec$Codec$encodeToString, 0, $author$project$Ports$subscribeDataCodec, subscribeData));
		default:
			var jsError = pushSubscription.a;
			var time = pushSubscription.b;
			return 'JS error at ' + ($author$project$MyUi$datestamp$(timezone, time) + (' ' + ($author$project$MyUi$timestamp$(time, timezone) + (': ' + jsError))));
	}
};
var $author$project$Pages$Admin$pushSubscriptionToString = F2($author$project$Pages$Admin$pushSubscriptionToString$);
var $author$project$UserAgent$browserToString = function (browser) {
	switch (browser) {
		case 0:
			return 'chrome';
		case 1:
			return 'firefox';
		case 2:
			return 'safari';
		case 3:
			return 'edge';
		case 4:
			return 'opera';
		default:
			return 'unknown browser';
	}
};
var $author$project$UserAgent$deviceToString = function (device) {
	switch (device) {
		case 0:
			return 'iPhone';
		case 1:
			return 'iPad';
		case 2:
			return 'Android phone';
		case 3:
			return 'Android tablet';
		case 4:
			return 'Windows';
		case 5:
			return 'macOS';
		case 6:
			return 'ChromeOS';
		case 7:
			return 'Linux';
		case 8:
			return 'Mobile';
		case 9:
			return 'Tablet';
		default:
			return 'Desktop';
	}
};
var $author$project$Pages$Admin$userAgentToString = function (userAgent) {
	return $author$project$UserAgent$browserToString(userAgent.browser) + (' (' + ($elm$core$String$toLower(
		$author$project$UserAgent$deviceToString(userAgent.device)) + ')'));
};
var $author$project$Pages$Admin$sessionsSection$ = function (isMobile, timezone, expandedSections, adminData) {
	return $author$project$Pages$Admin$section$(
		isMobile,
		expandedSections,
		17,
		_List_fromArray(
			[
				function () {
				var _v0 = adminData.sessions;
				switch (_v0.$) {
					case 0:
						return $author$project$Ui$text($author$project$Pages$Admin$loadingText);
					case 1:
						return $author$project$Ui$text($author$project$Pages$Admin$loadingText);
					default:
						var sessions = _v0.a;
						return $lamdera$containers$SeqDict$isEmpty(sessions) ? $author$project$Ui$text('No sessions') : $author$project$Ui$column$(
							_List_fromArray(
								[
									$author$project$Ui$spacing(8)
								]),
							$elm$core$List$map$(
								function (_v1) {
									var sessionIdHash = _v1.a;
									var session = _v1.b;
									return $author$project$Ui$column$(
										_List_fromArray(
											[
												$author$project$Ui$spacing(2),
												$author$project$Ui$Font$size(14),
												$author$project$Ui$widthMax(600)
											]),
										_List_fromArray(
											[
												$author$project$Ui$row$(
												_List_fromArray(
													[
														$author$project$Ui$spacing(8)
													]),
												_List_fromArray(
													[
														$author$project$Ui$el$(
														_List_fromArray(
															[$author$project$Ui$Font$bold]),
														$author$project$Ui$text(
															'Session hash: ' + $author$project$SessionIdHash$toString(sessionIdHash))),
														$author$project$MyUi$deleteButton$(
														$lamdera$program_test$Effect$Browser$Dom$id(
															'admin_deleteSession_' + $author$project$SessionIdHash$toString(sessionIdHash)),
														$author$project$Pages$Admin$PressedDeleteSession(sessionIdHash))
													])),
												$author$project$Ui$text(
												'User ID: ' + $author$project$Id$toString(session.userId)),
												$author$project$Ui$text(
												'Notifications: ' + $author$project$Pages$Admin$notificationModeToString(session.notificationMode)),
												$author$project$Ui$text(
												'Push subscription: ' + $author$project$Pages$Admin$pushSubscriptionToString$(timezone, session.pushSubscription)),
												$author$project$Ui$text(
												'User agent: ' + $author$project$Pages$Admin$userAgentToString(session.userAgent)),
												$author$project$Ui$text(
												'Signed in at: ' + ($author$project$MyUi$datestamp$(timezone, session.signedInAt) + (' ' + $author$project$MyUi$timestamp$(session.signedInAt, timezone))))
											]));
								},
								$lamdera$containers$SeqDict$toList(sessions)));
				}
			}()
			]));
};
var $author$project$Pages$Admin$sessionsSection = F4($author$project$Pages$Admin$sessionsSection$);
var $author$project$Pages$Admin$PressedDeleteSlackDmChannel = function (a) {
	return {$: 28, a: a};
};
var $author$project$Pages$Admin$SlackDmChannelsSection = 7;
var $author$project$Pages$Admin$deleteSlackDmChannelButtonId = function (channelId) {
	return $lamdera$program_test$Effect$Browser$Dom$id(
		'Admin_deleteSlackDmChannelButton_' + $author$project$Slack$idToString(channelId));
};
var $author$project$Pages$Admin$slackDmChannelsSection$ = function (isMobile, expandedSections, adminData) {
	return $author$project$Pages$Admin$section$(
		isMobile,
		expandedSections,
		7,
		_List_fromArray(
			[
				function () {
				var _v0 = _Utils_Tuple2(adminData.slackDmChannels, adminData.slackWorkspaces);
				if ((_v0.a.$ === 2) && (_v0.b.$ === 2)) {
					var slackDmChannels = _v0.a.a;
					var slackWorkspaces = _v0.b.a;
					return $lamdera$containers$SeqDict$isEmpty(slackDmChannels) ? $author$project$Ui$text('No Slack DM channels') : $author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$spacing(4)
							]),
						$elm$core$List$map$(
							function (_v1) {
								var channelId = _v1.a;
								var channel = _v1.b;
								return $author$project$Ui$row$(
									_List_fromArray(
										[
											$author$project$Ui$spacing(8),
											$author$project$Ui$Font$size(14)
										]),
									_List_fromArray(
										[
											$author$project$Ui$text(
											$author$project$Slack$idToString(channelId)),
											function () {
											var _v2 = $lamdera$containers$SeqDict$get$(channel.teamId, slackWorkspaces);
											if (!_v2.$) {
												var workspace = _v2.a;
												return $author$project$Ui$text(workspace.name);
											} else {
												return $author$project$Ui$text(
													$author$project$Slack$idToString(channel.teamId));
											}
										}(),
											$author$project$Ui$row$(
											_List_fromArray(
												[
													$author$project$Ui$spacing(8)
												]),
											A2(
												$elm$core$List$cons,
												$author$project$Ui$text('Members:'),
												$elm$core$List$map$(
													function (member) {
														return $author$project$Ui$el$(
															_List_fromArray(
																[
																	$author$project$MyUi$hoverText(
																	$author$project$Slack$idToString(member.id))
																]),
															$author$project$Ui$text(member.name));
													},
													channel.members))),
											$author$project$Ui$text(
											'Messages: ' + $elm$core$String$fromInt(channel.messageCount)),
											$author$project$Pages$Admin$firstMessageView(channel),
											$elm$core$List$any$(
											function (member) {
												var _v3 = $lamdera$containers$SeqDict$get$(channel.teamId, slackWorkspaces);
												if (!_v3.$) {
													var workspace = _v3.a;
													return $lamdera$containers$SeqDict$member$(member.id, workspace.linkedUsers);
												} else {
													return false;
												}
											},
											channel.members) ? $author$project$Ui$none : $author$project$Ui$el$(
											_List_fromArray(
												[
													$author$project$Ui$width($author$project$Ui$shrink),
													$author$project$Ui$Font$color($author$project$MyUi$errorColor),
													$author$project$MyUi$hoverText('No linked Slack user is in this DM. It gets deleted once an hourly update has found it orphaned twice in a row.')
												]),
											$author$project$Ui$text('Orphaned')),
											$author$project$MyUi$deleteButton$(
											$author$project$Pages$Admin$deleteSlackDmChannelButtonId(channelId),
											$author$project$Pages$Admin$PressedDeleteSlackDmChannel(channelId))
										]));
							},
							$lamdera$containers$SeqDict$toList(slackDmChannels)));
				} else {
					return $author$project$Ui$text($author$project$Pages$Admin$loadingText);
				}
			}()
			]));
};
var $author$project$Pages$Admin$slackDmChannelsSection = F3($author$project$Pages$Admin$slackDmChannelsSection$);
var $author$project$Pages$Admin$PressedDeleteSlackWorkspace = function (a) {
	return {$: 26, a: a};
};
var $author$project$Pages$Admin$PressedExpandSlackWorkspace = function (a) {
	return {$: 27, a: a};
};
var $author$project$Pages$Admin$SlackWorkspacesSection = 6;
var $author$project$Pages$Admin$deleteSlackWorkspaceButtonId = function (teamId) {
	return $lamdera$program_test$Effect$Browser$Dom$id(
		'Admin_deleteSlackWorkspaceButton_' + $author$project$Slack$idToString(teamId));
};
var $author$project$Pages$Admin$expandSlackWorkspaceButtonId = function (teamId) {
	return $lamdera$program_test$Effect$Browser$Dom$id(
		'Admin_expandSlackWorkspaceButton_' + $author$project$Slack$idToString(teamId));
};
var $author$project$Pages$Admin$slackWorkspacesSection$ = function (isMobile, expandedSections, expandedSlackWorkspaces, adminData) {
	return $author$project$Pages$Admin$section$(
		isMobile,
		expandedSections,
		6,
		_List_fromArray(
			[
				function () {
				var _v0 = adminData.slackWorkspaces;
				switch (_v0.$) {
					case 2:
						var slackWorkspaces = _v0.a;
						return $lamdera$containers$SeqDict$isEmpty(slackWorkspaces) ? $author$project$Ui$text('No Slack workspaces') : $author$project$Ui$column$(
							_List_fromArray(
								[
									$author$project$Ui$spacing(4)
								]),
							$elm$core$List$map$(
								function (_v1) {
									var teamId = _v1.a;
									var workspace = _v1.b;
									var isExpanded = $lamdera$containers$SeqSet$member$(teamId, expandedSlackWorkspaces);
									return $author$project$Ui$column$(
										_List_fromArray(
											[
												$author$project$Ui$spacing(4)
											]),
										_List_fromArray(
											[
												$author$project$Ui$row$(
												_List_fromArray(
													[
														$author$project$Ui$spacing(8),
														$author$project$Ui$Font$size(14)
													]),
												_List_fromArray(
													[
														$author$project$Ui$el$(
														_List_fromArray(
															[
																$author$project$Ui$width($author$project$Ui$shrink),
																$author$project$Ui$Input$button(
																$author$project$Pages$Admin$PressedExpandSlackWorkspace(teamId)),
																$author$project$Ui$id(
																$lamdera$program_test$Effect$Browser$Dom$idToString(
																	$author$project$Pages$Admin$expandSlackWorkspaceButtonId(teamId))),
																$author$project$MyUi$hoverText(
																isExpanded ? 'Collapse' : 'Expand')
															]),
														isExpanded ? $author$project$Icons$collapseContainer : $author$project$Icons$expandContainer),
														$author$project$Ui$text(
														$author$project$Slack$idToString(teamId)),
														$author$project$Ui$text(workspace.name),
														$author$project$Ui$text(workspace.domain),
														$author$project$Ui$text(
														'Channels: ' + $elm$core$String$fromInt(
															$lamdera$containers$SeqDict$size(workspace.channels))),
														$author$project$Ui$text(
														'Users: ' + $elm$core$String$fromInt(workspace.userCount)),
														$author$project$Ui$row$(
														_List_fromArray(
															[
																$author$project$Ui$spacing(8)
															]),
														A2(
															$elm$core$List$cons,
															$author$project$Ui$text('Linked:'),
															$elm$core$List$map$(
																function (_v2) {
																	var slackUserId = _v2.a;
																	var slackUser = _v2.b;
																	return $author$project$Ui$el$(
																		_List_fromArray(
																			[
																				$author$project$MyUi$hoverText(
																				$author$project$Slack$idToString(slackUserId))
																			]),
																		$author$project$Ui$row$(
																			_List_fromArray(
																				[
																					$author$project$Ui$spacing(4),
																					$author$project$Ui$width($author$project$Ui$shrink)
																				]),
																			_List_fromArray(
																				[
																					$author$project$Ui$text(slackUser.name),
																					$author$project$Ui$text('→'),
																					function () {
																					var _v3 = $author$project$Pages$Admin$adminUser$(slackUser.linkedTo, adminData);
																					if (!_v3.$) {
																						var user = _v3.a;
																						return $author$project$Pages$Admin$userLabel(user);
																					} else {
																						return $author$project$Ui$text(
																							$author$project$Id$toString(slackUser.linkedTo));
																					}
																				}()
																				])));
																},
																$lamdera$containers$SeqDict$toList(workspace.linkedUsers)))),
														$lamdera$containers$SeqDict$isEmpty(workspace.linkedUsers) ? $author$project$Ui$el$(
														_List_fromArray(
															[
																$author$project$Ui$width($author$project$Ui$shrink),
																$author$project$Ui$Font$color($author$project$MyUi$errorColor),
																$author$project$MyUi$hoverText('No linked Slack user is in this workspace. It gets deleted once an hourly update has found it orphaned twice in a row.')
															]),
														$author$project$Ui$text('Orphaned')) : $author$project$Ui$none,
														$author$project$MyUi$deleteButton$(
														$author$project$Pages$Admin$deleteSlackWorkspaceButtonId(teamId),
														$author$project$Pages$Admin$PressedDeleteSlackWorkspace(teamId))
													])),
												isExpanded ? $author$project$Ui$column$(
												_List_fromArray(
													[
														$author$project$Ui$spacing(2),
														$author$project$Ui$paddingWith(
														{bottom: 0, left: 32, right: 0, top: 0})
													]),
												$elm$core$List$map$(
													function (_v4) {
														var channelId = _v4.a;
														var channel = _v4.b;
														return $author$project$Ui$row$(
															_List_fromArray(
																[
																	$author$project$Ui$spacing(8),
																	$author$project$Ui$Font$size(13)
																]),
															_List_fromArray(
																[
																	$author$project$Ui$text(
																	$author$project$Slack$idToString(channelId)),
																	$author$project$Ui$text(
																	'#' + $author$project$ChannelName$toString(channel.name)),
																	channel.isPrivate ? $author$project$Ui$text('Private') : $author$project$Ui$none,
																	$author$project$Ui$text(
																	'Messages: ' + $elm$core$String$fromInt(channel.messageCount)),
																	$author$project$Pages$Admin$firstMessageView(channel),
																	$author$project$Ui$row$(
																	_List_fromArray(
																		[
																			$author$project$Ui$spacing(8)
																		]),
																	A2(
																		$elm$core$List$cons,
																		$author$project$Ui$text('Visible to:'),
																		$elm$core$List$map$(
																			function (slackUserId) {
																				var _v5 = $lamdera$containers$SeqDict$get$(slackUserId, workspace.linkedUsers);
																				if (!_v5.$) {
																					var slackUser = _v5.a;
																					return $author$project$Ui$text(slackUser.name);
																				} else {
																					return $author$project$Ui$text(
																						$author$project$Slack$idToString(slackUserId));
																				}
																			},
																			$lamdera$containers$SeqSet$toList(channel.linkedMembers))))
																]));
													},
													$lamdera$containers$SeqDict$toList(workspace.channels))) : $author$project$Ui$none
											]));
								},
								$lamdera$containers$SeqDict$toList(slackWorkspaces)));
					case 1:
						return $author$project$Ui$text($author$project$Pages$Admin$loadingText);
					default:
						return $author$project$Ui$text($author$project$Pages$Admin$loadingText);
				}
			}()
			]));
};
var $author$project$Pages$Admin$slackWorkspacesSection = F4($author$project$Pages$Admin$slackWorkspacesSection$);
var $author$project$Pages$Admin$StickersAndEmojisSection = 15;
var $author$project$Pages$Admin$stickerFormatToString = function (format) {
	switch (format) {
		case 0:
			return 'PNG';
		case 1:
			return 'APNG';
		case 2:
			return 'Lottie';
		default:
			return 'GIF';
	}
};
var $author$project$Pages$Admin$stickerUrlToString = function (url) {
	switch (url.$) {
		case 0:
			return 'Internal';
		case 1:
			return 'Discord Standard';
		default:
			return 'Loading';
	}
};
var $author$project$Pages$Admin$stickersAndEmojisSection$ = function (isMobile, local, expandedSections) {
	var stickers = local.localUser.stickers;
	var urlTypeCounts = $lamdera$containers$SeqDict$foldl$(
		F3(
			function (_v5, stickerData, acc) {
				var urlTypeStr = $author$project$Pages$Admin$stickerUrlToString(stickerData.url);
				return $lamdera$containers$SeqDict$update$(
					urlTypeStr,
					function (maybe) {
						if (!maybe.$) {
							var count = maybe.a;
							return $elm$core$Maybe$Just(count + 1);
						} else {
							return $elm$core$Maybe$Just(1);
						}
					},
					acc);
			}),
		$lamdera$containers$SeqDict$empty,
		stickers);
	var stickerCount = $lamdera$containers$SeqDict$size(stickers);
	var formatCounts = $lamdera$containers$SeqDict$foldl$(
		F3(
			function (_v3, stickerData, acc) {
				var formatStr = $author$project$Pages$Admin$stickerFormatToString(stickerData.format);
				return $lamdera$containers$SeqDict$update$(
					formatStr,
					function (maybe) {
						if (!maybe.$) {
							var count = maybe.a;
							return $elm$core$Maybe$Just(count + 1);
						} else {
							return $elm$core$Maybe$Just(1);
						}
					},
					acc);
			}),
		$lamdera$containers$SeqDict$empty,
		stickers);
	var customEmojis = local.localUser.customEmojis;
	var customEmojiCount = $lamdera$containers$SeqDict$size(customEmojis);
	return $author$project$Pages$Admin$section$(
		isMobile,
		expandedSections,
		15,
		_List_fromArray(
			[
				$author$project$Ui$text(
				'Sticker count: ' + $elm$core$String$fromInt(stickerCount)),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(2)
					]),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$el$(
						_List_fromArray(
							[$author$project$Ui$Font$bold]),
						$author$project$Ui$text('By format:')),
					$elm$core$List$map$(
						function (_v0) {
							var format = _v0.a;
							var count = _v0.b;
							return $author$project$Ui$text(
								'  ' + (format + (': ' + $elm$core$String$fromInt(count))));
						},
						$lamdera$containers$SeqDict$toList(formatCounts)))),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(2)
					]),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$el$(
						_List_fromArray(
							[$author$project$Ui$Font$bold]),
						$author$project$Ui$text('By URL type:')),
					$elm$core$List$map$(
						function (_v1) {
							var urlType = _v1.a;
							var count = _v1.b;
							return $author$project$Ui$text(
								'  ' + (urlType + (': ' + $elm$core$String$fromInt(count))));
						},
						$lamdera$containers$SeqDict$toList(urlTypeCounts)))),
				$author$project$Ui$text(
				'Custom emoji count: ' + $elm$core$String$fromInt(customEmojiCount)),
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4),
						$author$project$Ui$wrap
					]),
				$elm$core$List$map$(
					function (_v2) {
						var customEmoji = _v2.b;
						return $author$project$Ui$row$(
							_List_fromArray(
								[
									$author$project$Ui$spacing(6),
									$author$project$Ui$width(
									$author$project$Ui$px(300)),
									$author$project$Ui$contentCenterY
								]),
							_List_fromArray(
								[
									$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$width($author$project$Ui$shrink)
										]),
									$author$project$Ui$html(
										$author$project$CustomEmoji$viewHelper$('32px', '0', customEmoji, 2))),
									$author$project$Ui$text(
									$author$project$CustomEmoji$emojiNameToString(customEmoji.name))
								]));
					},
					$lamdera$containers$SeqDict$toList(customEmojis)))
			]));
};
var $author$project$Pages$Admin$stickersAndEmojisSection = F3($author$project$Pages$Admin$stickersAndEmojisSection$);
var $author$project$Pages$Admin$UpdateLogsSection = 14;
var $author$project$BackendMsgLog$backendMsgLogToString = function (log) {
	switch (log) {
		case 0:
			return 'SentLoginEmail';
		case 1:
			return 'UserConnected';
		case 2:
			return 'UserDisconnected';
		case 3:
			return 'UserDisconnectedWithTime';
		case 4:
			return 'RecordingRequestTick';
		case 5:
			return 'BackendGotTime';
		case 6:
			return 'SentLogErrorEmail';
		case 7:
			return 'SentNotificationEmail';
		case 8:
			return 'DiscordUserWebsocketMsg';
		case 9:
			return 'SentDiscordGuildMessage';
		case 10:
			return 'SentDiscordDmMessage';
		case 11:
			return 'DeletedDiscordGuildMessage';
		case 12:
			return 'DeletedDiscordDmMessage';
		case 13:
			return 'EditedDiscordGuildMessage';
		case 14:
			return 'EditedDiscordDmMessage';
		case 15:
			return 'DiscordAddedReactionToGuildMessage';
		case 16:
			return 'DiscordAddedReactionToDmMessage';
		case 17:
			return 'DiscordRemovedReactionToGuildMessage';
		case 18:
			return 'DiscordRemovedReactionToDmMessage';
		case 19:
			return 'DiscordTypingIndicatorSent';
		case 20:
			return 'AiChatBackendMsg';
		case 21:
			return 'GotDiscordUserAvatars';
		case 22:
			return 'SentNotification';
		case 23:
			return 'GotVapidKeys';
		case 24:
			return 'LinkDiscordUserStep1';
		case 25:
			return 'GotSlackUser';
		case 26:
			return 'GotChangedSlackUser';
		case 27:
			return 'SlackChangedReaction';
		case 28:
			return 'SlackDeletedMessage';
		case 29:
			return 'SlackEditedMessage';
		case 30:
			return 'SlackMessageFilesUploaded';
		case 31:
			return 'LinkSlackUserStep1';
		case 32:
			return 'LinkSlackUserStep2';
		case 33:
			return 'RefreshedSlackConversations';
		case 34:
			return 'CaughtUpSlackMessages';
		case 35:
			return 'CheckedSlackAuth';
		case 36:
			return 'SlackGotMessageEmbed';
		case 37:
			return 'SentSlackMessage';
		case 38:
			return 'SlackWebsocketCreatedHandle';
		case 39:
			return 'SlackWebsocketClosedByBackend';
		case 40:
			return 'SlackWebsocketMsg';
		case 41:
			return 'SlackWebsocketSentData';
		case 42:
			return 'SlackWebsocketReconnectTick';
		case 43:
			return 'ReloadDiscordUserStep1';
		case 44:
			return 'HandleReadyDataStep2';
		case 45:
			return 'WebsocketCreatedHandleForUser';
		case 46:
			return 'WebsocketClosedByBackendForUser';
		case 47:
			return 'GatewayReconnectTick';
		case 48:
			return 'WebsocketSentDataForUser';
		case 49:
			return 'DiscordMessageCreate_AttachmentsUploaded';
		case 50:
			return 'DiscordMessageUpdate_AttachmentsUploaded';
		case 51:
			return 'ReloadedDiscordGuildChannel';
		case 52:
			return 'ReloadedDiscordDmChannel';
		case 53:
			return 'ExportBackendStep';
		case 54:
			return 'CountToFrontendStep';
		case 55:
			return 'DownloadBackupChunkStep';
		case 56:
			return 'ScheduledExportBackendStep';
		case 57:
			return 'GotDiscordGuildChannelMessages';
		case 58:
			return 'GotDiscordDmChannelMessages';
		case 59:
			return 'GotTimeForFailedToParseDiscordWebsocket';
		case 60:
			return 'GotTimeForDiscordForumPostRenamed';
		case 61:
			return 'GotGuildMessageEmbed';
		case 62:
			return 'GotDmMessageEmbed';
		case 63:
			return 'DiscordGotGuildMessageEmbed';
		case 64:
			return 'DiscordGotDmMessageEmbed';
		case 65:
			return 'DiscordGotDataForJoinedOrCreatedGuild';
		case 66:
			return 'DiscordGotGuildIcon';
		case 67:
			return 'JoinedDiscordThread';
		case 68:
			return 'ToBackendCompleted';
		case 69:
			return 'GotDiscordReadyDataStickers';
		case 70:
			return 'GotDiscordMessageStickers';
		case 71:
			return 'GotDiscordReadyDataCustomEmojis';
		case 72:
			return 'GotSlackCustomEmojis';
		case 73:
			return 'GotDiscordMessageCustomEmojis';
		case 74:
			return 'HourlyUpdate';
		case 75:
			return 'GotDiscordStandardStickerPacks';
		case 76:
			return 'ScheduledExportUploadResult';
		case 77:
			return 'RegeneratedServerSecret';
		case 78:
			return 'DeletedOrphanedFiles';
		case 79:
			return 'HourlyDeletedOrphanedFiles';
		case 80:
			return 'ReloadedDiscordGuildForAdmin';
		case 81:
			return 'GotTimeForWebsocketListenClose';
		case 82:
			return 'Rpc_GotFileUpload';
		case 83:
			return 'GotEnglishWordList';
		case 84:
			return 'GotSwedishWordList';
		case 85:
			return 'Rpc_UserJoinedCall';
		case 86:
			return 'Rpc_NotifyAdmins';
		case 87:
			return 'Rpc_RecordingUploadProgress';
		case 88:
			return 'Rpc_RecordingUploadFinished';
		case 89:
			return 'Rpc_RecordingZipBuilt';
		case 90:
			return 'GotTimeForBackendMsg';
		default:
			return 'BackendMsgCompleted';
	}
};
var $author$project$Ui$Font$alignRight = $author$project$Internal$Model2$classWith$($author$project$Internal$Flag$fontAlignment, $author$project$Internal$Style2$classes.textRight);
var $ianmackenzie$elm_units$Quantity$maximum = function (quantities) {
	if (!quantities.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var first = quantities.a;
		var rest = quantities.b;
		return $elm$core$Maybe$Just(
			$elm$core$List$foldl$($ianmackenzie$elm_units$Quantity$max, first, rest));
	}
};
var $ianmackenzie$elm_units$Quantity$minimum = function (quantities) {
	if (!quantities.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var first = quantities.a;
		var rest = quantities.b;
		return $elm$core$Maybe$Just(
			$elm$core$List$foldl$($ianmackenzie$elm_units$Quantity$min, first, rest));
	}
};
var $ianmackenzie$elm_units$Quantity$sort = function (quantities) {
	return A2($elm$core$List$sortBy, $ianmackenzie$elm_units$Quantity$unwrap, quantities);
};
var $author$project$Pages$Admin$logDurationsTable = function (logs) {
	var msText = function (ms) {
		return $elm$core$String$fromInt(
			$elm$core$Basics$round(
				$ianmackenzie$elm_units$Duration$inMilliseconds(ms))) + 'ms';
	};
	var header = F3(
		function (alignRight, width, content) {
			return $author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Font$bold,
						$author$project$Ui$Font$size(13),
						$author$project$Ui$paddingXY$(8, 4),
						$author$project$Ui$width(
						$author$project$Ui$px(width)),
						$author$project$Ui$attrIf$(alignRight, $author$project$Ui$Font$alignRight)
					]),
				content);
		});
	var grouped = $elm$core$List$foldl$(
		F2(
			function (log, acc) {
				var durations = $elm$core$Maybe$withDefault$(
					_List_Nil,
					$lamdera$containers$SeqDict$get$(log.name, acc));
				return $lamdera$containers$SeqDict$insert$(
					log.name,
					A2($elm$core$List$cons, log.duration, durations),
					acc);
			}),
		$lamdera$containers$SeqDict$empty,
		logs);
	var sorted = A2(
		$elm$core$List$sortBy,
		function (row) {
			return -row.count;
		},
		$elm$core$List$map$(
			function (_v0) {
				var name = _v0.a;
				var durations = _v0.b;
				var sortedDurations = $ianmackenzie$elm_units$Quantity$sort(durations);
				var slowest = $elm$core$Maybe$withDefault$(
					$ianmackenzie$elm_units$Quantity$zero,
					$ianmackenzie$elm_units$Quantity$maximum(sortedDurations));
				var fastest = $elm$core$Maybe$withDefault$(
					$ianmackenzie$elm_units$Quantity$zero,
					$ianmackenzie$elm_units$Quantity$minimum(sortedDurations));
				var count = $elm$core$List$length(sortedDurations);
				var median = function () {
					if (!count) {
						return $ianmackenzie$elm_units$Quantity$zero;
					} else {
						var mid = (count / 2) | 0;
						return $elm$core$Maybe$withDefault$(
							$ianmackenzie$elm_units$Quantity$zero,
							$elm$core$List$head(
								$elm$core$List$drop$(mid, sortedDurations)));
					}
				}();
				return {count: count, fastest: fastest, median: median, name: name, slowest: slowest};
			},
			$lamdera$containers$SeqDict$toList(grouped)));
	var cell = F3(
		function (alignRight, width, content) {
			return $author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Font$size(13),
						$author$project$Ui$paddingXY$(8, 4),
						$author$project$Ui$width(
						$author$project$Ui$px(width)),
						$author$project$Ui$attrIf$(alignRight, $author$project$Ui$Font$alignRight)
					]),
				content);
		});
	return $author$project$Ui$column$(
		_List_Nil,
		A2(
			$elm$core$List$cons,
			$author$project$Ui$row$(
				_List_Nil,
				_List_fromArray(
					[
						A3(
						header,
						false,
						200,
						$author$project$Ui$text('Log type')),
						A3(
						header,
						true,
						100,
						$author$project$Ui$text(
							'Count\u00A0(' + ($elm$core$String$fromInt(
								$elm$core$List$length(logs)) + ')'))),
						A3(
						header,
						true,
						80,
						$author$project$Ui$text('Fastest')),
						A3(
						header,
						true,
						80,
						$author$project$Ui$text('Median')),
						A3(
						header,
						true,
						80,
						$author$project$Ui$text('Slowest'))
					])),
			$elm$core$List$map$(
				function (row) {
					return $author$project$Ui$row$(
						_List_Nil,
						_List_fromArray(
							[
								A3(
								cell,
								false,
								200,
								$author$project$Ui$text(row.name)),
								A3(
								cell,
								true,
								100,
								$author$project$Ui$text(
									$elm$core$String$fromInt(row.count))),
								A3(
								cell,
								true,
								80,
								$author$project$Ui$text(
									msText(row.fastest))),
								A3(
								cell,
								true,
								80,
								$author$project$Ui$text(
									msText(row.median))),
								A3(
								cell,
								true,
								80,
								$author$project$Ui$text(
									msText(row.slowest)))
							]));
				},
				sorted)));
};
var $author$project$Pages$Admin$backendMsgLogsTable = function (logs) {
	return $author$project$Pages$Admin$logDurationsTable(
		$elm$core$List$map$(
			function (log) {
				return {
					duration: $ianmackenzie$elm_units$Duration$from$(log.startTime, log.endTime),
					name: $author$project$BackendMsgLog$backendMsgLogToString(log.backendMsgLog)
				};
			},
			$elm$core$Array$toList(logs)));
};
var $author$project$Pages$Admin$noUpdateLogsText = 'No ToBackend or BackendMsg logs';
var $author$project$ToBackendLog$toBackendLogToString = function (log) {
	switch (log) {
		case 0:
			return 'CheckLoginRequest';
		case 1:
			return 'LoginWithTokenRequest';
		case 2:
			return 'LoginWithTwoFactorRequest';
		case 3:
			return 'LoginWithRecoveryPasswordRequest';
		case 4:
			return 'GetLoginTokenRequest';
		case 5:
			return 'AdminToBackend';
		case 6:
			return 'LogOutRequest';
		case 7:
			return 'TwoFactorToBackend';
		case 8:
			return 'JoinGuildByInviteRequest';
		case 9:
			return 'FinishUserCreationRequest';
		case 10:
			return 'AiChatToBackend';
		case 11:
			return 'ReloadDataRequest';
		case 12:
			return 'LinkDiscordRequest';
		case 13:
			return 'LinkSlackRequest';
		case 14:
			return 'ProfilePictureEditorToBackend';
		case 15:
			return 'AdminDataRequest';
		case 16:
			return 'GetPublicGoMatchRequest';
		case 17:
			return 'ExportChannelRequest';
		case 18:
			return 'ImportChannelRequest';
		case 19:
			return 'Local_Invalid';
		case 20:
			return 'Local_Admin';
		case 21:
			return 'Local_SendMessage';
		case 22:
			return 'Local_Discord_SendMessage';
		case 23:
			return 'Local_Slack_SendMessage';
		case 24:
			return 'Local_Slack_SendEditMessage';
		case 25:
			return 'Local_Slack_UnlinkUser';
		case 26:
			return 'Local_Slack_ReloadUser';
		case 27:
			return 'Local_NewChannel';
		case 28:
			return 'Local_EditChannel';
		case 29:
			return 'Local_DeleteChannel';
		case 30:
			return 'Local_EditGuildName';
		case 31:
			return 'Local_DeleteGuild';
		case 32:
			return 'Local_LeaveGuild';
		case 33:
			return 'Local_NewInviteLink';
		case 34:
			return 'Local_DeleteInviteLink';
		case 35:
			return 'Local_BanMember';
		case 36:
			return 'Local_NewGuild';
		case 37:
			return 'Local_MemberTyping';
		case 38:
			return 'Local_AddReactionEmoji';
		case 39:
			return 'Local_RemoveReactionEmoji';
		case 40:
			return 'Local_SendEditMessage';
		case 41:
			return 'Local_Discord_SendEditGuildMessage';
		case 42:
			return 'Local_Discord_SendEditDmMessage';
		case 43:
			return 'Local_MemberEditTyping';
		case 44:
			return 'Local_SetLastViewed';
		case 45:
			return 'Local_DeleteMessage';
		case 46:
			return 'Local_CurrentlyViewing';
		case 47:
			return 'Local_SetName';
		case 48:
			return 'Local_LoadChannelMessages';
		case 49:
			return 'Local_LoadThreadMessages';
		case 50:
			return 'Local_Discord_LoadChannelMessages';
		case 51:
			return 'Local_Slack_LoadChannelMessages';
		case 52:
			return 'Local_Slack_LoadThreadMessages';
		case 53:
			return 'Local_Discord_LoadThreadMessages';
		case 54:
			return 'Local_SetGuildNotificationLevel';
		case 55:
			return 'Local_SetDiscordGuildNotificationLevel';
		case 56:
			return 'Local_SetNotificationMode';
		case 57:
			return 'Local_ExpandUserOptionSection';
		case 58:
			return 'Local_SetSheepGameQuestions';
		case 59:
			return 'Local_CollapseUserOptionSection';
		case 60:
			return 'Local_SetEmailNotifications';
		case 61:
			return 'Local_SetEmbedVisibility';
		case 62:
			return 'Local_ScheduleAccountDeletion';
		case 63:
			return 'Local_CancelAccountDeletion';
		case 64:
			return 'Local_RegisterPushSubscription';
		case 65:
			return 'Local_TextEditor';
		case 66:
			return 'Local_UnlinkDiscordUser';
		case 67:
			return 'Local_StartReloadingDiscordUser';
		case 68:
			return 'Local_LinkDiscordAcknowledgementIsChecked';
		case 69:
			return 'Local_LinkSlackAcknowledgementIsChecked';
		case 70:
			return 'Local_SetDomainWhitelist';
		case 71:
			return 'Local_SetEmojiSkinTone';
		case 72:
			return 'Local_SetUserColor';
		case 73:
			return 'Local_AddCustomEmojisToUser';
		case 74:
			return 'Local_VoiceChatChange';
		case 75:
			return 'Local_Game';
		case 76:
			return 'Local_Drawing';
		case 77:
			return 'Local_SetMuteChannel';
		case 78:
			return 'Local_SetMuteThread';
		case 79:
			return 'Local_SetMuteDiscordChannel';
		case 80:
			return 'Local_SetMuteDiscordThread';
		case 81:
			return 'Local_SetMuteGuild';
		case 82:
			return 'Local_SetMuteDiscordGuild';
		case 83:
			return 'Local_SetSlackWorkspaceNotificationLevel';
		case 84:
			return 'Local_SetMuteSlackWorkspace';
		case 85:
			return 'Local_SetMuteSlackChannel';
		case 86:
			return 'Local_SetMuteSlackThread';
		case 87:
			return 'Local_RequestE2ee';
		case 88:
			return 'Local_CancelE2eeRequest';
		case 89:
			return 'Local_DeclineE2eeRequest';
		case 90:
			return 'Local_SetPublicKey';
		case 91:
			return 'Local_EncryptOldMessages';
		case 92:
			return 'Local_DisableE2ee';
		case 93:
			return 'Local_DecryptOldMessages';
		case 94:
			return 'Local_SetE2eeRisksAccepted';
		case 95:
			return 'Local_AcceptE2ee';
		case 96:
			return 'Local_SendEncryptedMessage';
		default:
			return 'Local_SendEncryptedEditMessage';
	}
};
var $author$project$Pages$Admin$toBackendLogsTable = function (logs) {
	return $author$project$Pages$Admin$logDurationsTable(
		$elm$core$List$map$(
			function (log) {
				return {
					duration: $ianmackenzie$elm_units$Duration$from$(log.startTime, log.endTime),
					name: $author$project$ToBackendLog$toBackendLogToString(log.toBackendLog)
				};
			},
			$elm$core$Array$toList(logs)));
};
var $author$project$Pages$Admin$backendMsgColor = '#e8913a';
var $author$project$Pages$Admin$millisecondsText = function (ms) {
	return $elm$core$String$fromInt(
		$elm$core$Basics$round(ms)) + 'ms';
};
var $elm$svg$Svg$title = $elm$svg$Svg$trustedNode('title');
var $author$project$Pages$Admin$toBackendColor = '#4a90d9';
var $author$project$Pages$Admin$updateTimePerMinuteGraph$ = function (now, toBackendLogs, backendMsgLogs) {
	var minuteMs = 60 * 1000;
	var nowMinute = ($lamdera$program_test$Effect$Time$posixToMillis(now) / minuteMs) | 0;
	var oldestMinute = function (logs) {
		return $elm$core$List$minimum(
			$elm$core$List$map$(
				function (log) {
					return ($lamdera$program_test$Effect$Time$posixToMillis(log.startTime) / minuteMs) | 0;
				},
				logs));
	};
	var legend = F2(
		function (color, label) {
			return $author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4),
						$author$project$Ui$width($author$project$Ui$shrink)
					]),
				_List_fromArray(
					[
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$width(
								$author$project$Ui$px(12)),
								$author$project$Ui$height(
								$author$project$Ui$px(3)),
								$author$project$Ui$htmlAttribute(
								A2($elm$html$Html$Attributes$style, 'background', color))
							]),
						$author$project$Ui$none),
						$author$project$Ui$text(label)
					]));
		});
	var firstMinute = $elm$core$Basics$min$(
		nowMinute,
		$elm$core$Basics$max$(
			(nowMinute - (24 * 60)) + 1,
			$elm$core$Maybe$withDefault$(
				nowMinute,
				$elm$core$List$maximum(
					$elm$core$List$filterMap$(
						oldestMinute,
						_List_fromArray(
							[toBackendLogs, backendMsgLogs]))))));
	var chartWidth = 600;
	var chartHeight = 100;
	var bucketCount = (nowMinute - firstMinute) + 1;
	var msPerMinute = function (logs) {
		return $elm$core$List$foldl$(
			F2(
				function (log, acc) {
					var index = $elm$core$Basics$min$(
						bucketCount - 1,
						(($lamdera$program_test$Effect$Time$posixToMillis(log.startTime) / minuteMs) | 0) - firstMinute);
					var _v0 = $elm$core$Array$get$(index, acc);
					if (!_v0.$) {
						var ms = _v0.a;
						return $elm$core$Array$set$(
							index,
							ms + $ianmackenzie$elm_units$Duration$inMilliseconds(
								$ianmackenzie$elm_units$Duration$from$(log.startTime, log.endTime)),
							acc);
					} else {
						return acc;
					}
				}),
			$elm$core$Array$repeat$(bucketCount, 0),
			logs);
	};
	var toBackendBuckets = msPerMinute(toBackendLogs);
	var stepX = (bucketCount <= 1) ? 0 : (chartWidth / (bucketCount - 1));
	var baseline = A2(
		$elm$svg$Svg$line,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$x1('0'),
				$elm$svg$Svg$Attributes$y1(
				$elm$core$String$fromInt(chartHeight)),
				$elm$svg$Svg$Attributes$x2(
				$elm$core$String$fromInt(chartWidth)),
				$elm$svg$Svg$Attributes$y2(
				$elm$core$String$fromInt(chartHeight)),
				$elm$svg$Svg$Attributes$stroke('#888'),
				$elm$svg$Svg$Attributes$strokeWidth('1')
			]),
		_List_Nil);
	var backendMsgBuckets = msPerMinute(backendMsgLogs);
	var hoverAreas = $elm$core$List$map$(
		function (i) {
			var msAt = function (buckets) {
				return $elm$core$Maybe$withDefault$(
					0,
					$elm$core$Array$get$(i, buckets));
			};
			return A2(
				$elm$svg$Svg$rect,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$x(
						$elm$core$String$fromFloat((i * stepX) - (stepX / 2))),
						$elm$svg$Svg$Attributes$y('0'),
						$elm$svg$Svg$Attributes$width(
						$elm$core$String$fromFloat(
							$elm$core$Basics$max$(1, stepX))),
						$elm$svg$Svg$Attributes$height(
						$elm$core$String$fromInt(chartHeight)),
						$elm$svg$Svg$Attributes$fill('transparent')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$title,
						_List_Nil,
						_List_fromArray(
							[
								$elm$svg$Svg$text(
								$elm$core$String$fromInt((bucketCount - 1) - i) + (' min ago\u000AToBackend: ' + ($author$project$Pages$Admin$millisecondsText(
									msAt(toBackendBuckets)) + ('\u000ABackendMsg: ' + $author$project$Pages$Admin$millisecondsText(
									msAt(backendMsgBuckets))))))
							]))
					]));
		},
		$elm$core$List$range$(0, bucketCount - 1));
	var peakMs = $elm$core$Basics$max$(
		$elm$core$Array$foldl$($elm$core$Basics$max, 0, toBackendBuckets),
		$elm$core$Array$foldl$($elm$core$Basics$max, 0, backendMsgBuckets));
	var polyline = F2(
		function (color, buckets) {
			return A2(
				$elm$svg$Svg$polyline,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fill('none'),
						$elm$svg$Svg$Attributes$stroke(color),
						$elm$svg$Svg$Attributes$strokeWidth('2'),
						$elm$svg$Svg$Attributes$points(
						$elm$core$String$join$(
							' ',
							$elm$core$List$indexedMap$(
								F2(
									function (i, ms) {
										return $elm$core$String$fromFloat(i * stepX) + (',' + $elm$core$String$fromFloat(
											chartHeight - ((ms / $elm$core$Basics$max$(1, peakMs)) * chartHeight)));
									}),
								$elm$core$Array$toList(buckets))))
					]),
				_List_Nil);
		});
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(4),
				$author$project$Ui$width($author$project$Ui$shrink)
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Font$bold,
						$author$project$Ui$Font$size(14)
					]),
				$author$project$Ui$text('Time spent on updates per minute')),
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$Font$size(12),
						$author$project$Ui$spacing(12)
					]),
				_List_fromArray(
					[
						A2(legend, $author$project$Pages$Admin$toBackendColor, 'ToBackend'),
						A2(legend, $author$project$Pages$Admin$backendMsgColor, 'BackendMsg'),
						$author$project$Ui$text(
						'peak: ' + $author$project$Pages$Admin$millisecondsText(peakMs))
					])),
				$author$project$Ui$html(
				A2(
					$elm$svg$Svg$svg,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$viewBox(
							'0 0 ' + ($elm$core$String$fromInt(chartWidth) + (' ' + $elm$core$String$fromInt(chartHeight)))),
							$elm$svg$Svg$Attributes$width(
							$elm$core$String$fromInt(chartWidth)),
							$elm$svg$Svg$Attributes$height(
							$elm$core$String$fromInt(chartHeight)),
							A2($elm$html$Html$Attributes$style, 'max-width', '100%'),
							A2($elm$html$Html$Attributes$style, 'height', 'auto'),
							A2($elm$html$Html$Attributes$style, 'overflow', 'visible')
						]),
					A2(
						$elm$core$List$cons,
						baseline,
						A2(
							$elm$core$List$cons,
							A2(polyline, $author$project$Pages$Admin$toBackendColor, toBackendBuckets),
							A2(
								$elm$core$List$cons,
								A2(polyline, $author$project$Pages$Admin$backendMsgColor, backendMsgBuckets),
								hoverAreas))))),
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$Font$size(11),
						$author$project$Ui$spacing(8)
					]),
				_List_fromArray(
					[
						$author$project$Ui$text(
						$elm$core$String$fromInt(bucketCount - 1) + ' min ago'),
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$alignRight,
								$author$project$Ui$width($author$project$Ui$shrink)
							]),
						$author$project$Ui$text('now'))
					]))
			]));
};
var $author$project$Pages$Admin$updateTimePerMinuteGraph = F3($author$project$Pages$Admin$updateTimePerMinuteGraph$);
var $author$project$Pages$Admin$updateLogsSection$ = function (isMobile, currentTime, expandedSections, adminData) {
	return $author$project$Pages$Admin$section$(
		isMobile,
		expandedSections,
		14,
		_List_fromArray(
			[
				function () {
				var _v0 = _Utils_Tuple2(adminData.toBackendLogs, adminData.backendMsgLogs);
				if ((_v0.a.$ === 2) && (_v0.b.$ === 2)) {
					var toBackendLogs = _v0.a.a;
					var backendMsgLogs = _v0.b.a;
					return ($elm$core$Array$isEmpty(toBackendLogs) && $elm$core$Array$isEmpty(backendMsgLogs)) ? $author$project$Ui$text($author$project$Pages$Admin$noUpdateLogsText) : $author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$spacing(12)
							]),
						_List_fromArray(
							[
								$author$project$Pages$Admin$updateTimePerMinuteGraph$(
								currentTime,
								$elm$core$List$map$(
									function (log) {
										return {endTime: log.endTime, startTime: log.startTime};
									},
									$elm$core$Array$toList(toBackendLogs)),
								$elm$core$List$map$(
									function (log) {
										return {endTime: log.endTime, startTime: log.startTime};
									},
									$elm$core$Array$toList(backendMsgLogs))),
								$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$Font$bold,
										$author$project$Ui$Font$size(14)
									]),
								$author$project$Ui$text('ToBackend')),
								$author$project$Pages$Admin$toBackendLogsTable(toBackendLogs),
								$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$Font$bold,
										$author$project$Ui$Font$size(14)
									]),
								$author$project$Ui$text('BackendMsg')),
								$author$project$Pages$Admin$backendMsgLogsTable(backendMsgLogs)
							]));
				} else {
					return $author$project$Ui$text($author$project$Pages$Admin$loadingText);
				}
			}()
			]));
};
var $author$project$Pages$Admin$updateLogsSection = F4($author$project$Pages$Admin$updateLogsSection$);
var $author$project$Pages$Admin$DiscordLinkLimitEditableMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Admin$PressedAddUserRow = {$: 12};
var $author$project$Pages$Admin$PressedResetUserChanges = {$: 10};
var $author$project$Pages$Admin$PressedSaveUserChanges = {$: 8};
var $author$project$Pages$Admin$SlackLinkLimitEditableMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$Admin$ToggledDiscordLinkingEnabled = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Admin$ToggledEmailNotifications = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Admin$ToggledSignupsEnabled = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Admin$ToggledSlackLinkingEnabled = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$Admin$UsersSection = 0;
var $author$project$Pages$Admin$addUserRowButtonId = $lamdera$program_test$Effect$Browser$Dom$id('admin_adduserRowButton');
var $author$project$Pages$Admin$discordLinkLimitId = $lamdera$program_test$Effect$Browser$Dom$id('Admin_discordLinkLimit');
var $author$project$Pages$Admin$discordLinkingEnabledText = 'Discord account linking enabled';
var $author$project$Pages$Admin$parseLinkLimit = function (text) {
	var text2 = $elm$core$String$trim(text);
	if (text2 === '') {
		return $elm$core$Result$Ok($elm$core$Maybe$Nothing);
	} else {
		var _v0 = $elm$core$String$toInt(text2);
		if (!_v0.$) {
			var limit = _v0.a;
			return (limit < 0) ? $elm$core$Result$Err('Can\u0027t be negative') : $elm$core$Result$Ok(
				$elm$core$Maybe$Just(limit));
		} else {
			return $elm$core$Result$Err('Not a whole number');
		}
	}
};
var $author$project$Pages$Admin$saveUserChangesButtonId = $lamdera$program_test$Effect$Browser$Dom$id('admin_saveUserChangesButton');
var $author$project$Pages$Admin$slackLinkLimitId = $lamdera$program_test$Effect$Browser$Dom$id('Admin_slackLinkLimit');
var $author$project$Pages$Admin$slackLinkingEnabledText = 'Slack account linking enabled';
var $author$project$Pages$Admin$ExistingUserId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$NewUserId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$linkedDiscordAccounts = function (discordUsers) {
	switch (discordUsers.$) {
		case 2:
			var discordUsers2 = discordUsers.a;
			return $elm$core$Maybe$Just(
				$lamdera$containers$SeqDict$foldl$(
					F3(
						function (_v1, discordUser, dict) {
							switch (discordUser.$) {
								case 1:
									var data = discordUser.a;
									return $lamdera$containers$SeqDict$update$(
										data.linkedTo,
										function (list) {
											return $elm$core$Maybe$Just(
												A2(
													$elm$core$List$cons,
													data.user.username,
													$elm$core$Maybe$withDefault$(_List_Nil, list)));
										},
										dict);
								case 2:
									var data = discordUser.a;
									return $lamdera$containers$SeqDict$update$(
										data.linkedTo,
										function (list) {
											return $elm$core$Maybe$Just(
												A2(
													$elm$core$List$cons,
													data.user.username,
													$elm$core$Maybe$withDefault$(_List_Nil, list)));
										},
										dict);
								default:
									return dict;
							}
						}),
					$lamdera$containers$SeqDict$empty,
					discordUsers2));
		case 1:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Admin$cellBorderColor = $author$project$Ui$borderColor($author$project$MyUi$buttonBorder);
var $author$project$Pages$Admin$tableAttributes = _List_fromArray(
	[
		$author$project$Ui$width($author$project$Ui$fill),
		$author$project$Ui$borderWith(
		{bottom: 1, left: 0, right: 0, top: 1}),
		$author$project$Pages$Admin$cellBorderColor
	]);
var $author$project$Pages$Admin$DeleteButton = {$: 0};
var $author$project$Pages$Admin$PressedDeleteUser = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Admin$PressedResetUser = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Admin$ResetButton = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$ToggleIsAdmin$ = function (a, b) {
	return {$: 22, a: a, b: b};
};
var $author$project$Pages$Admin$ToggleIsAdmin = F2($author$project$Pages$Admin$ToggleIsAdmin$);
var $author$project$Pages$Admin$UserTableMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Admin$deleteColor = $author$project$Ui$rgb$(108, 70, 68);
var $author$project$Pages$Admin$editColor = $author$project$Ui$rgb$(104, 95, 65);
var $author$project$Pages$Admin$newRowColor = $author$project$Ui$rgb$(45, 69, 41);
var $author$project$Pages$Admin$cellBackgroundColor$ = function (userTableId, state) {
	if (!userTableId.$) {
		var userId = userTableId.a;
		return $lamdera$containers$SeqSet$member$(userId, state.deletedUsers) ? $author$project$Ui$background($author$project$Pages$Admin$deleteColor) : ($lamdera$containers$SeqDict$member$(userId, state.changedUsers) ? $author$project$Ui$background($author$project$Pages$Admin$editColor) : $author$project$Ui$noAttr);
	} else {
		return $author$project$Ui$background($author$project$Pages$Admin$newRowColor);
	}
};
var $author$project$Pages$Admin$cellBackgroundColor = F2($author$project$Pages$Admin$cellBackgroundColor$);
var $author$project$Pages$Admin$userTableIdToDomId = function (userTableId) {
	if (!userTableId.$) {
		var userId = userTableId.a;
		return 'a_' + ($author$project$Id$toString(userId) + '_');
	} else {
		var index = userTableId.a;
		return 'b_' + ($elm$core$String$fromInt(index) + '_');
	}
};
var $author$project$Pages$Admin$deleteUserButtonId = function (userTableId) {
	return $lamdera$program_test$Effect$Browser$Dom$id(
		'Admin_deleteUserButton_' + $author$project$Pages$Admin$userTableIdToDomId(userTableId));
};
var $author$project$Pages$Admin$EditCellLostFocus$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$Pages$Admin$EditCellLostFocus = F2($author$project$Pages$Admin$EditCellLostFocus$);
var $author$project$Pages$Admin$EnterKeyInEditCell$ = function (a, b) {
	return {$: 7, a: a, b: b};
};
var $author$project$Pages$Admin$EnterKeyInEditCell = F2($author$project$Pages$Admin$EnterKeyInEditCell$);
var $author$project$Pages$Admin$EscapeKeyInEditCell = {$: 11};
var $author$project$Pages$Admin$PressedEditCell$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Pages$Admin$PressedEditCell = F2($author$project$Pages$Admin$PressedEditCell$);
var $author$project$Pages$Admin$TabKeyInEditCell = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$TypedEditCell = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$down = function (y) {
	return {x: 0, y: y, z: 0};
};
var $elm$html$Html$Events$onBlur = function (msg) {
	return $elm$html$Html$Events$on$(
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Ui$Events$onLoseFocus = A2($elm$core$Basics$composeL, $author$project$Internal$Model2$attribute, $elm$html$Html$Events$onBlur);
var $author$project$Pages$Admin$userColumnToTitle = function (userColumn) {
	if (!userColumn) {
		return 'Name';
	} else {
		return 'Email';
	}
};
var $author$project$Pages$Admin$userTableCellButtonId$ = function (userTableId, userColumn) {
	return $lamdera$program_test$Effect$Browser$Dom$id(
		'admin_userTableCellButton_' + ($author$project$Pages$Admin$userTableIdToDomId(userTableId) + $author$project$Pages$Admin$userColumnToTitle(userColumn)));
};
var $author$project$Pages$Admin$userTableCellButtonId = F2($author$project$Pages$Admin$userTableCellButtonId$);
var $author$project$Pages$Admin$validateColumn$ = function (column, text) {
	if (!column) {
		var _v1 = $author$project$PersonName$fromString(text);
		if (!_v1.$) {
			return $elm$core$Result$Ok(0);
		} else {
			var error = _v1.a;
			return $elm$core$Result$Err(error);
		}
	} else {
		var _v2 = $author$project$EmailAddress$fromString(text);
		if (!_v2.$) {
			return $elm$core$Result$Ok(0);
		} else {
			return $elm$core$Result$Err('Invalid email');
		}
	}
};
var $author$project$Pages$Admin$validateColumn = F2($author$project$Pages$Admin$validateColumn$);
var $author$project$Pages$Admin$tableCell$ = function (isEmail, state, column, _v0) {
	var userTableId = _v0.a;
	var user = _v0.b;
	var isEditing = function () {
		var _v4 = state.editingCell;
		if (!_v4.$) {
			var editingCell = _v4.a;
			return (_Utils_eq(editingCell.column, column) && _Utils_eq(editingCell.userId, userTableId)) ? $elm$core$Maybe$Just(editingCell.text) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	if (!isEditing.$) {
		var text = isEditing.a;
		return $author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$Font$size(14)
				]),
			A2(
				isEmail ? $author$project$Ui$Input$email : $author$project$Ui$Input$text,
				_List_fromArray(
					[
						$author$project$Ui$width($author$project$Ui$fill),
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$paddingXY$(8, 4),
						$author$project$Ui$Events$onLoseFocus(
						$author$project$Pages$Admin$EditCellLostFocus$(userTableId, column)),
						$author$project$Ui$id(
						$lamdera$program_test$Effect$Browser$Dom$idToString($author$project$Pages$Admin$editCellTextInputId)),
						$author$project$Ui$rounded(0),
						$author$project$Ui$htmlAttribute(
						$elm$html$Html$Events$on$(
							'keydown',
							A2(
								$elm$json$Json$Decode$andThen,
								function (_v2) {
									var shift = _v2.a;
									var key = _v2.b;
									return (key === 'Enter') ? $elm$json$Json$Decode$succeed(
										$author$project$Pages$Admin$EnterKeyInEditCell$(userTableId, column)) : ((key === 'Tab') ? $elm$json$Json$Decode$succeed(
										$author$project$Pages$Admin$TabKeyInEditCell(shift)) : ((key === 'Escape') ? $elm$json$Json$Decode$succeed($author$project$Pages$Admin$EscapeKeyInEditCell) : $elm$json$Json$Decode$fail('')));
								},
								A3(
									$elm$json$Json$Decode$map2,
									$elm$core$Tuple$pair,
									A2($elm$json$Json$Decode$field, 'shiftKey', $elm$json$Json$Decode$bool),
									A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)))))
					]),
				{
					label: $author$project$Ui$Input$labelHidden('Edit cell'),
					onChange: $author$project$Pages$Admin$TypedEditCell,
					placeholder: $elm$core$Maybe$Nothing,
					text: text
				}));
	} else {
		var text = $author$project$Pages$Admin$localChangeToText$(column, user);
		var _v3 = $author$project$Pages$Admin$validateColumn$(column, text);
		if (!_v3.$) {
			return $author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Events$onMouseDown(
						$author$project$Pages$Admin$PressedEditCell$(userTableId, column)),
						$author$project$Ui$Font$size(14),
						$author$project$Ui$paddingXY$(8, 4),
						$author$project$Pages$Admin$cellBackgroundColor$(userTableId, state),
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$contentCenterY,
						$author$project$Ui$id(
						$lamdera$program_test$Effect$Browser$Dom$idToString(
							$author$project$Pages$Admin$userTableCellButtonId$(userTableId, column)))
					]),
				$author$project$Ui$text(text));
		} else {
			var error = _v3.a;
			return $author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Events$onMouseDown(
						$author$project$Pages$Admin$PressedEditCell$(userTableId, column)),
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$contentCenterY,
						$author$project$Ui$Font$size(14),
						$author$project$Ui$paddingWith(
						{bottom: 16, left: 8, right: 8, top: 4}),
						$author$project$Pages$Admin$cellBackgroundColor$(userTableId, state),
						$author$project$Ui$borderColor($author$project$MyUi$errorColor),
						$author$project$Ui$border(1),
						$author$project$Ui$id(
						$lamdera$program_test$Effect$Browser$Dom$idToString(
							$author$project$Pages$Admin$userTableCellButtonId$(userTableId, column))),
						$author$project$Ui$inFront(
						$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$alignBottom,
									$author$project$Ui$Font$size(12),
									$author$project$Ui$Font$color($author$project$MyUi$white),
									$author$project$Ui$background($author$project$MyUi$errorColor),
									$author$project$Ui$move(
									$author$project$Ui$down(1)),
									$author$project$Ui$width($author$project$Ui$shrink),
									$author$project$Ui$paddingXY$(4, 0)
								]),
							$author$project$Ui$text(error)))
					]),
				$author$project$Ui$text(text));
		}
	}
};
var $author$project$Pages$Admin$tableCell = F4($author$project$Pages$Admin$tableCell$);
var $author$project$Table$PressedShowAll = {$: 1};
var $author$project$Table$PressedSortBy = function (a) {
	return {$: 0, a: a};
};
var $author$project$Table$cellBorderColor = $author$project$Ui$borderColor($author$project$MyUi$buttonBorder);
var $author$project$Ui$Table$columnWithState = function (input) {
	return {
		columnSpan: 1,
		header: input.header,
		order: $elm$core$Maybe$Nothing,
		summary: $elm$core$Maybe$Nothing,
		view: F3(
			function (index, state, data) {
				return _List_fromArray(
					[
						A3(input.view, index, state, data)
					]);
			}),
		visible: $elm$core$Maybe$Nothing,
		widths: _List_fromArray(
			[$author$project$Ui$Table$defaultWidth])
	};
};
var $author$project$Table$headerBackgroundColor = $author$project$Ui$background($author$project$MyUi$background2);
var $author$project$Table$headerHeight = 30;
var $author$project$Icons$sortAscending = $author$project$Ui$html(
	A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$strokeWidth('1.5'),
				$elm$svg$Svg$Attributes$stroke('currentColor'),
				$elm$svg$Svg$Attributes$width('24')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$d('m19.5 8.25-7.5 7.5-7.5-7.5')
					]),
				_List_Nil)
			])));
var $author$project$Icons$sortDescending = $author$project$Ui$html(
	A2(
		$elm$svg$Svg$svg,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
				$elm$svg$Svg$Attributes$strokeWidth('1.5'),
				$elm$svg$Svg$Attributes$stroke('currentColor'),
				$elm$svg$Svg$Attributes$width('24')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$strokeLinecap('round'),
						$elm$svg$Svg$Attributes$strokeLinejoin('round'),
						$elm$svg$Svg$Attributes$d('m4.5 15.75 7.5-7.5 7.5 7.5')
					]),
				_List_Nil)
			])));
var $author$project$Table$header$ = function (maybePressedSortBy, columnIndex, name, model) {
	return $author$project$Ui$Table$cell$(
		_List_fromArray(
			[
				$author$project$Ui$borderWith(
				{bottom: 1, left: 1, right: 0, top: 0}),
				$author$project$Ui$Font$size(14),
				$author$project$Ui$Font$bold,
				$author$project$Ui$contentCenterY,
				$author$project$Table$headerBackgroundColor,
				$author$project$Table$cellBorderColor,
				$author$project$Ui$paddingWith(
				{bottom: 0, left: 8, right: 8, top: 0}),
				$author$project$Ui$height(
				$author$project$Ui$px($author$project$Table$headerHeight)),
				function () {
				if (!maybePressedSortBy.$) {
					var pressedSortBy = maybePressedSortBy.a;
					return $author$project$Ui$Input$button(
						pressedSortBy(columnIndex));
				} else {
					return $author$project$Ui$noAttr;
				}
			}()
			]),
		$author$project$Ui$row$(
			_List_fromArray(
				[
					$author$project$Ui$spacing(4)
				]),
			_List_fromArray(
				[
					$author$project$Ui$text(name),
					function () {
					if (!maybePressedSortBy.$) {
						return $author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$width(
									$author$project$Ui$px(16)),
									$author$project$Ui$move(
									{x: 0, y: -1, z: 0})
								]),
							_Utils_eq(columnIndex, model.columnToSortBy) ? (model.ascendingOrder ? $author$project$Icons$sortAscending : $author$project$Icons$sortDescending) : $author$project$Ui$text(''));
					} else {
						return $author$project$Ui$text('');
					}
				}()
				])));
};
var $author$project$Table$header = F4($author$project$Table$header$);
var $author$project$Table$lastRow = 99;
var $author$project$Table$rowOrder$ = function (userColumns, model, data) {
	var _v0 = $elmcraft$core_extra$List$Extra$getAt$(model.columnToSortBy, userColumns);
	if (!_v0.$) {
		var column = _v0.a;
		var _v1 = column.sortBy;
		if (!_v1.$) {
			var sortBy = _v1.a;
			var sorted = model.ascendingOrder ? $elm$core$List$reverse(
				sortBy(data)) : sortBy(data);
			return model.showAll ? sorted : $elm$core$List$take$($author$project$Table$lastRow + 1, sorted);
		} else {
			return data;
		}
	} else {
		return data;
	}
};
var $author$project$Table$rowOrder = F3($author$project$Table$rowOrder$);
var $author$project$Ui$Table$withScrollable$ = function (input, cfg) {
	return _Utils_update(
		cfg,
		{scrollable: true, stickFirstColumn: input.stickFirstColumn, stickHeader: true});
};
var $author$project$Ui$Table$withScrollable = F2($author$project$Ui$Table$withScrollable$);
var $author$project$Ui$Table$withSort$ = function (sort, cfg) {
	return _Utils_update(
		cfg,
		{
			sort: $elm$core$Maybe$Just(sort)
		});
};
var $author$project$Ui$Table$withSort = F2($author$project$Ui$Table$withSort$);
var $author$project$Table$tableConfig$ = function (id, showAll, onMsg, getModel, userColumns) {
	return $author$project$Ui$Table$withSort$(
		F2(
			function (model, list) {
				return $author$project$Table$rowOrder$(
					userColumns,
					getModel(model),
					list);
			}),
		$author$project$Ui$Table$withScrollable$(
			{stickFirstColumn: false},
			$author$project$Ui$Table$columns(
				$elm$core$List$indexedMap$(
					F2(
						function (columnIndex, userColumn) {
							return $author$project$Ui$Table$columnWithState(
								{
									header: function (model) {
										return $author$project$Table$header$(
											function () {
												var _v0 = userColumn.sortBy;
												if (!_v0.$) {
													return $elm$core$Maybe$Just(
														function (index) {
															return onMsg(
																$author$project$Table$PressedSortBy(index));
														});
												} else {
													return $elm$core$Maybe$Nothing;
												}
											}(),
											columnIndex,
											userColumn.title,
											getModel(model));
									},
									view: F3(
										function (index, _v1, data) {
											return $author$project$Ui$Table$cell$(
												_List_fromArray(
													[
														$author$project$Ui$contentCenterY,
														$author$project$Ui$padding(0),
														$author$project$Ui$borderWith(
														{bottom: 1, left: 1, right: 0, top: 0}),
														$author$project$Ui$height($author$project$Ui$fill),
														$author$project$Table$cellBorderColor
													]),
												((!showAll) && _Utils_eq(index, $author$project$Table$lastRow)) ? ((columnIndex === 3) ? $author$project$Ui$el$(
													_List_fromArray(
														[
															$author$project$Ui$paddingXY$(0, 16)
														]),
													$author$project$Ui$el$(
														_List_fromArray(
															[
																$author$project$Ui$Input$button(
																onMsg($author$project$Table$PressedShowAll)),
																$author$project$Ui$id(
																$lamdera$program_test$Effect$Browser$Dom$idToString(id) + '_showAll'),
																$author$project$Ui$Font$color($author$project$MyUi$black),
																$author$project$Ui$rounded(4),
																$author$project$Ui$Font$center
															]),
														$author$project$Ui$text('Show all'))) : $author$project$Ui$none) : $author$project$Ui$Lazy$lazy$(userColumn.view, data));
										})
								});
						}),
					userColumns))));
};
var $author$project$Table$tableConfig = F5($author$project$Table$tableConfig$);
var $author$project$Pages$Admin$userTableColumns$ = function (timezone, tableState, users, twoFactorAuthentication, discordAccounts) {
	return $author$project$Table$tableConfig$(
		$lamdera$program_test$Effect$Browser$Dom$id('Admin_userTable'),
		true,
		$author$project$Pages$Admin$UserTableMsg,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				{
				sortBy: $elm$core$Maybe$Nothing,
				title: '',
				view: function (_v0) {
					var userTableId = _v0.a;
					var showButton = function () {
						if (!userTableId.$) {
							var userId = userTableId.a;
							return $lamdera$containers$SeqDict$member$(userId, tableState.changedUsers) ? $author$project$Pages$Admin$ResetButton(userId) : ($lamdera$containers$SeqSet$member$(userId, tableState.deletedUsers) ? $author$project$Pages$Admin$ResetButton(userId) : $author$project$Pages$Admin$DeleteButton);
						} else {
							return $author$project$Pages$Admin$DeleteButton;
						}
					}();
					return $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Pages$Admin$cellBackgroundColor$(userTableId, tableState),
								$author$project$Ui$paddingWith(
								{bottom: 0, left: 8, right: 4, top: 0}),
								$author$project$Ui$height($author$project$Ui$fill),
								$author$project$Ui$contentCenterY
							]),
						function () {
							if (!showButton.$) {
								return $author$project$MyUi$deleteButton$(
									$author$project$Pages$Admin$deleteUserButtonId(userTableId),
									$author$project$Pages$Admin$PressedDeleteUser(userTableId));
							} else {
								var userId = showButton.a;
								return $author$project$Pages$Admin$resetButton$(
									$lamdera$program_test$Effect$Browser$Dom$id('Admin_resetUser'),
									$author$project$Pages$Admin$PressedResetUser(userId));
							}
						}());
				}
			},
				{
				sortBy: $elm$core$Maybe$Just(
					$elm$core$List$sortBy(
						function (_v3) {
							var userTableId = _v3.a;
							if (!userTableId.$) {
								var userId = userTableId.a;
								return _Utils_Tuple2(
									0,
									$author$project$Id$toInt(userId));
							} else {
								var index = userTableId.a;
								return _Utils_Tuple2(1, index);
							}
						})),
				title: 'Id',
				view: function (_v5) {
					var userTableId = _v5.a;
					return $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$(8, 4),
								$author$project$Ui$Font$size(14),
								$author$project$Ui$contentCenterY,
								$author$project$Pages$Admin$cellBackgroundColor$(userTableId, tableState),
								$author$project$Ui$height($author$project$Ui$fill)
							]),
						function () {
							if (!userTableId.$) {
								var userId = userTableId.a;
								return $author$project$Ui$text(
									$author$project$Id$toString(userId));
							} else {
								return $author$project$Ui$none;
							}
						}());
				}
			},
				{
				sortBy: $elm$core$Maybe$Just(
					$elm$core$List$sortBy(
						function (_v7) {
							var user = _v7.b;
							return user.name;
						})),
				title: $author$project$Pages$Admin$userColumnToTitle(0),
				view: A3($author$project$Pages$Admin$tableCell, false, tableState, 0)
			},
				{
				sortBy: $elm$core$Maybe$Just(
					$elm$core$List$sortBy(
						function (_v8) {
							var user = _v8.b;
							return user.email;
						})),
				title: $author$project$Pages$Admin$userColumnToTitle(1),
				view: A3($author$project$Pages$Admin$tableCell, true, tableState, 1)
			},
				{
				sortBy: $elm$core$Maybe$Just(
					$elm$core$List$sortBy(
						function (_v9) {
							var user = _v9.b;
							return $lamdera$program_test$Effect$Time$posixToMillis(user.createdAt);
						})),
				title: 'Created at',
				view: function (_v10) {
					var userTableId = _v10.a;
					var user = _v10.b;
					return $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$(8, 4),
								$author$project$Ui$Font$size(14),
								$author$project$Ui$contentCenterY,
								$author$project$Pages$Admin$cellBackgroundColor$(userTableId, tableState),
								$author$project$Ui$height($author$project$Ui$fill)
							]),
						$author$project$Ui$text(
							$author$project$MyUi$datestamp$(timezone, user.createdAt)));
				}
			},
				{
				sortBy: $elm$core$Maybe$Nothing,
				title: 'Admin',
				view: function (_v11) {
					var userTableId = _v11.a;
					var user = _v11.b;
					return $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Pages$Admin$cellBackgroundColor$(userTableId, tableState),
								$author$project$Ui$height($author$project$Ui$fill)
							]),
						$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$width($author$project$Ui$shrink),
									$author$project$Ui$centerX,
									$author$project$Ui$centerY
								]),
							$author$project$Ui$Input$checkbox$(
								_List_fromArray(
									[
										$author$project$Ui$id(
										'admin_isAdmin_' + $author$project$Pages$Admin$userTableIdToDomId(userTableId))
									]),
								{
									checked: user.isAdmin,
									icon: $elm$core$Maybe$Nothing,
									label: $author$project$Ui$Input$labelHidden('Is admin'),
									onChange: $author$project$Pages$Admin$ToggleIsAdmin(userTableId)
								})));
				}
			},
				{
				sortBy: $elm$core$Maybe$Nothing,
				title: 'Has 2FA',
				view: function (_v12) {
					var userTableId = _v12.a;
					return $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Pages$Admin$cellBackgroundColor$(userTableId, tableState),
								$author$project$Ui$Font$size(14),
								$author$project$Ui$paddingXY$(8, 4),
								$author$project$Ui$height($author$project$Ui$fill)
							]),
						function () {
							if (!userTableId.$) {
								var userId = userTableId.a;
								var _v14 = $lamdera$containers$SeqDict$get$(userId, twoFactorAuthentication);
								if (!_v14.$) {
									var enabledAt = _v14.a;
									return $author$project$Ui$text(
										$author$project$MyUi$datestamp$(timezone, enabledAt));
								} else {
									return $author$project$Ui$none;
								}
							} else {
								return $author$project$Ui$none;
							}
						}());
				}
			},
				{
				sortBy: $elm$core$Maybe$Nothing,
				title: 'Discord accounts',
				view: function (_v15) {
					var userTableId = _v15.a;
					return $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Pages$Admin$cellBackgroundColor$(userTableId, tableState),
								$author$project$Ui$Font$size(14),
								$author$project$Ui$paddingXY$(8, 4),
								$author$project$Ui$height($author$project$Ui$fill),
								$author$project$Ui$id(
								'admin_discordAccounts_' + $author$project$Pages$Admin$userTableIdToDomId(userTableId))
							]),
						function () {
							var _v16 = _Utils_Tuple2(userTableId, discordAccounts);
							if (!_v16.a.$) {
								if (!_v16.b.$) {
									var userId = _v16.a.a;
									var discordAccounts2 = _v16.b.a;
									var _v17 = $lamdera$containers$SeqDict$get$(userId, discordAccounts2);
									if (!_v17.$) {
										var usernames = _v17.a;
										return $author$project$Ui$text(
											$elm$core$String$join$(
												', ',
												$elm$core$List$sort(usernames)));
									} else {
										return $author$project$Ui$none;
									}
								} else {
									var _v18 = _v16.b;
									return $author$project$Ui$text($author$project$Pages$Admin$loadingText);
								}
							} else {
								return $author$project$Ui$none;
							}
						}());
				}
			},
				{
				sortBy: $elm$core$Maybe$Nothing,
				title: 'Email notifications',
				view: function (_v19) {
					var userTableId = _v19.a;
					return $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Pages$Admin$cellBackgroundColor$(userTableId, tableState),
								$author$project$Ui$Font$size(14),
								$author$project$Ui$paddingXY$(8, 4),
								$author$project$Ui$height($author$project$Ui$fill),
								$author$project$Ui$contentCenterY
							]),
						function () {
							if (!userTableId.$) {
								var userId = userTableId.a;
								var _v21 = $author$project$NonemptyDict$get$(userId, users);
								if (!_v21.$) {
									var user = _v21.a;
									var _v22 = user.emailNotifications;
									if (!_v22) {
										return $author$project$Ui$none;
									} else {
										return $author$project$Ui$text('Enabled');
									}
								} else {
									return $author$project$Ui$none;
								}
							} else {
								return $author$project$Ui$none;
							}
						}());
				}
			},
				{
				sortBy: $elm$core$Maybe$Just(
					$elm$core$List$sortBy(
						function (_v23) {
							var user = _v23.b;
							var _v24 = user.deleteAccountAt;
							if (!_v24.$) {
								var deleteAt = _v24.a;
								return $lamdera$program_test$Effect$Time$posixToMillis(deleteAt);
							} else {
								return -9999;
							}
						})),
				title: 'Marked for deletion',
				view: function (_v25) {
					var userTableId = _v25.a;
					var user = _v25.b;
					return $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Pages$Admin$cellBackgroundColor$(userTableId, tableState),
								$author$project$Ui$Font$size(14),
								$author$project$Ui$paddingXY$(8, 4),
								$author$project$Ui$height($author$project$Ui$fill),
								$author$project$Ui$contentCenterY,
								$author$project$Ui$contentCenterX
							]),
						function () {
							var _v26 = user.deleteAccountAt;
							if (!_v26.$) {
								var deleteAt = _v26.a;
								return $author$project$Ui$text(
									$author$project$MyUi$datestamp$(timezone, deleteAt));
							} else {
								return $author$project$Ui$text('');
							}
						}());
				}
			}
			]));
};
var $author$project$Pages$Admin$userTableColumns = F5($author$project$Pages$Admin$userTableColumns$);
var $author$project$Pages$Admin$userTableView$ = function (timezone, tableState, users, twoFactorAuthentication, discordUsers) {
	return $author$project$Ui$Table$viewWithState$(
		$author$project$Pages$Admin$tableAttributes,
		$author$project$Pages$Admin$userTableColumns$(
			timezone,
			tableState,
			users,
			twoFactorAuthentication,
			$author$project$Pages$Admin$linkedDiscordAccounts(discordUsers)),
		tableState.table,
		_Utils_ap(
			$elm$core$List$map$(
				function (_v0) {
					var userId = _v0.a;
					var user = _v0.b;
					return _Utils_Tuple2(
						$author$project$Pages$Admin$ExistingUserId(userId),
						function () {
							var _v1 = $lamdera$containers$SeqDict$get$(userId, tableState.changedUsers);
							if (!_v1.$) {
								var change = _v1.a;
								return change;
							} else {
								return $author$project$Pages$Admin$userToEditUser(user);
							}
						}());
				},
				$author$project$NonemptyDict$toList(users)),
			$elm$core$List$indexedMap$(
				F2(
					function (index, user) {
						return _Utils_Tuple2(
							$author$project$Pages$Admin$NewUserId(index),
							user);
					}),
				$elm$core$Array$toList(tableState.newUsers))));
};
var $author$project$Pages$Admin$userTableView = F5($author$project$Pages$Admin$userTableView$);
var $author$project$Pages$Admin$userSection$ = function (isMobile, timezone, expandedSections, adminData, model) {
	var slackLinkingEnabledLabel = $author$project$MyUi$label$(
		$lamdera$program_test$Effect$Browser$Dom$id('slackLinkingEnabledId'),
		_List_Nil,
		$author$project$Ui$text($author$project$Pages$Admin$slackLinkingEnabledText));
	var signupsEnabledLabel = $author$project$MyUi$label$(
		$lamdera$program_test$Effect$Browser$Dom$id('signupsEnabledId'),
		_List_Nil,
		$author$project$Ui$text('New sign ups enabled'));
	var emailNotificationsLabel = $author$project$MyUi$label$(
		$lamdera$program_test$Effect$Browser$Dom$id('emailNotificationsId'),
		_List_Nil,
		$author$project$Ui$text('Email notifications enabled (does not affect login emails)'));
	var discordLinkingEnabledLabel = $author$project$MyUi$label$(
		$lamdera$program_test$Effect$Browser$Dom$id('discordLinkingEnabledId'),
		_List_Nil,
		$author$project$Ui$text($author$project$Pages$Admin$discordLinkingEnabledText));
	return $author$project$Pages$Admin$section$(
		isMobile,
		expandedSections,
		0,
		_List_fromArray(
			[
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Input$checkbox$(
						_List_Nil,
						{checked: adminData.emailNotificationsEnabled, icon: $elm$core$Maybe$Nothing, label: emailNotificationsLabel.id, onChange: $author$project$Pages$Admin$ToggledEmailNotifications}),
						emailNotificationsLabel.element
					])),
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Input$checkbox$(
						_List_Nil,
						{checked: adminData.signupsEnabled, icon: $elm$core$Maybe$Nothing, label: signupsEnabledLabel.id, onChange: $author$project$Pages$Admin$ToggledSignupsEnabled}),
						signupsEnabledLabel.element
					])),
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Input$checkbox$(
						_List_Nil,
						{checked: adminData.discordLinkingEnabled, icon: $elm$core$Maybe$Nothing, label: discordLinkingEnabledLabel.id, onChange: $author$project$Pages$Admin$ToggledDiscordLinkingEnabled}),
						discordLinkingEnabledLabel.element
					])),
				$author$project$Editable$view$(
				$author$project$Pages$Admin$discordLinkLimitId,
				false,
				'Maximum linked Discord users (leave empty for no limit)',
				$author$project$Pages$Admin$parseLinkLimit,
				$author$project$Pages$Admin$DiscordLinkLimitEditableMsg,
				function () {
					var _v0 = adminData.discordLinkLimit;
					if (!_v0.$) {
						var limit = _v0.a;
						return $elm$core$String$fromInt(limit);
					} else {
						return '';
					}
				}(),
				model.discordLinkLimit),
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(4)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Input$checkbox$(
						_List_Nil,
						{checked: adminData.slackLinkingEnabled, icon: $elm$core$Maybe$Nothing, label: slackLinkingEnabledLabel.id, onChange: $author$project$Pages$Admin$ToggledSlackLinkingEnabled}),
						slackLinkingEnabledLabel.element
					])),
				$author$project$Editable$view$(
				$author$project$Pages$Admin$slackLinkLimitId,
				false,
				'Maximum linked Slack users (leave empty for no limit)',
				$author$project$Pages$Admin$parseLinkLimit,
				$author$project$Pages$Admin$SlackLinkLimitEditableMsg,
				function () {
					var _v1 = adminData.slackLinkLimit;
					if (!_v1.$) {
						var limit = _v1.a;
						return $elm$core$String$fromInt(limit);
					} else {
						return '';
					}
				}(),
				model.slackLinkLimit),
				function () {
				var _v2 = adminData.users;
				switch (_v2.$) {
					case 0:
						return $author$project$Ui$text($author$project$Pages$Admin$loadingText);
					case 1:
						return $author$project$Ui$text($author$project$Pages$Admin$loadingText);
					default:
						var users = _v2.a;
						return $author$project$Ui$Lazy$lazy5$($author$project$Pages$Admin$userTableView, timezone, model.userTable, users, adminData.twoFactorAuthentication, adminData.discordUsers);
				}
			}(),
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(16)
					]),
				A2(
					$elm$core$List$cons,
					$author$project$MyUi$simpleButton$(
						$author$project$Pages$Admin$addUserRowButtonId,
						$author$project$Pages$Admin$PressedAddUserRow,
						$author$project$Ui$text('Add new user')),
					($lamdera$containers$SeqDict$isEmpty(model.userTable.changedUsers) && ($elm$core$Array$isEmpty(model.userTable.newUsers) && $lamdera$containers$SeqSet$isEmpty(model.userTable.deletedUsers))) ? _List_Nil : _List_fromArray(
						[
							$author$project$MyUi$simpleButton$(
							$lamdera$program_test$Effect$Browser$Dom$id('Admin_resetUserChanges'),
							$author$project$Pages$Admin$PressedResetUserChanges,
							$author$project$Ui$text('Reset')),
							$author$project$MyUi$simpleButton$(
							$author$project$Pages$Admin$saveUserChangesButtonId,
							$author$project$Pages$Admin$PressedSaveUserChanges,
							$author$project$Ui$text('Save changes')),
							function () {
							var _v3 = model.submitError;
							if (!_v3.$) {
								var error = _v3.a;
								return $author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$Font$color($author$project$MyUi$errorColor)
										]),
									$author$project$Ui$text(
										function () {
											switch (error.$) {
												case 0:
													return 'Email addresses are not unique';
												case 1:
													return 'One or more user rows have invalid fields';
												case 2:
													var id = error.a;
													return 'User ID ' + ($author$project$Id$toString(id) + ' not found. Try reloading the page.');
												case 3:
													return 'You can\u0027t remove your own admin role';
												case 4:
													return 'You can\u0027t delete your own account';
												default:
													return 'One or more new user rows have invalid fields';
											}
										}()));
							} else {
								return $author$project$Ui$none;
							}
						}()
						])))
			]));
};
var $author$project$Pages$Admin$userSection = F5($author$project$Pages$Admin$userSection$);
var $author$project$Pages$Admin$WebsocketCloseEventsSection = 16;
var $mgold$elm_nonempty_list$List$Nonempty$singleton = function (x) {
	return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(x, _List_Nil);
};
var $author$project$SeqDictHelper$addToList$ = function (key, item, dict) {
	return $lamdera$containers$SeqDict$update$(
		key,
		function (maybe) {
			if (!maybe.$) {
				var nonempty = maybe.a;
				return $elm$core$Maybe$Just(
					$mgold$elm_nonempty_list$List$Nonempty$cons$(item, nonempty));
			} else {
				return $elm$core$Maybe$Just(
					$mgold$elm_nonempty_list$List$Nonempty$singleton(item));
			}
		},
		dict);
};
var $author$project$SeqDictHelper$addToList = F3($author$project$SeqDictHelper$addToList$);
var $author$project$Pages$Admin$eventsPerHourLineGraph$ = function (now, color, eventTimes) {
	var nowMs = $lamdera$program_test$Effect$Time$posixToMillis(now);
	var chartWidth = 600;
	var chartHeight = 100;
	var bucketDurationMs = (60 * 60) * 1000;
	var bucketCount = 24;
	var emptyBuckets = $elm$core$Array$repeat$(bucketCount, 0);
	var pointStepX = (bucketCount <= 1) ? 0 : (chartWidth / (bucketCount - 1));
	var windowMs = bucketCount * bucketDurationMs;
	var windowStartMs = nowMs - windowMs;
	var buckets = $elm$core$List$foldl$(
		F2(
			function (eventTime, acc) {
				var ms = $lamdera$program_test$Effect$Time$posixToMillis(eventTime);
				if ((_Utils_cmp(ms, windowStartMs) < 0) || (_Utils_cmp(ms, nowMs) > 0)) {
					return acc;
				} else {
					var index = $elm$core$Basics$min$(bucketCount - 1, ((ms - windowStartMs) / bucketDurationMs) | 0);
					return $elm$core$Array$set$(
						index,
						$elm$core$Maybe$withDefault$(
							0,
							$elm$core$Array$get$(index, acc)) + 1,
						acc);
				}
			}),
		emptyBuckets,
		eventTimes);
	var maxCount = $elm$core$Array$foldl$($elm$core$Basics$max, 0, buckets);
	var scaleDenominator = $elm$core$Basics$max$(1, maxCount);
	var pointAt = F2(
		function (i, count) {
			var y = chartHeight - ((count / scaleDenominator) * chartHeight);
			var x = i * pointStepX;
			return _Utils_Tuple2(x, y);
		});
	var points = $elm$core$List$indexedMap$(
		pointAt,
		$elm$core$Array$toList(buckets));
	var dots = $elm$core$List$indexedMap$(
		F2(
			function (i, _v1) {
				var x = _v1.a;
				var y = _v1.b;
				var count = $elm$core$Maybe$withDefault$(
					0,
					$elm$core$Array$get$(i, buckets));
				return A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx(
							$elm$core$String$fromFloat(x)),
							$elm$svg$Svg$Attributes$cy(
							$elm$core$String$fromFloat(y)),
							$elm$svg$Svg$Attributes$r('2.5'),
							$elm$svg$Svg$Attributes$fill(color)
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$title,
							_List_Nil,
							_List_fromArray(
								[
									$elm$svg$Svg$text(
									$elm$core$String$fromInt(count) + (' events, ' + ($elm$core$String$fromInt((bucketCount - 1) - i) + 'h ago')))
								]))
						]));
			}),
		points);
	var pointsAttr = $elm$core$String$join$(
		' ',
		$elm$core$List$map$(
			function (_v0) {
				var x = _v0.a;
				var y = _v0.b;
				return $elm$core$String$fromFloat(x) + (',' + $elm$core$String$fromFloat(y));
			},
			points));
	var polyline = A2(
		$elm$svg$Svg$polyline,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$stroke(color),
				$elm$svg$Svg$Attributes$strokeWidth('2'),
				$elm$svg$Svg$Attributes$points(pointsAttr)
			]),
		_List_Nil);
	var baseline = A2(
		$elm$svg$Svg$line,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$x1('0'),
				$elm$svg$Svg$Attributes$y1(
				$elm$core$String$fromInt(chartHeight)),
				$elm$svg$Svg$Attributes$x2(
				$elm$core$String$fromInt(chartWidth)),
				$elm$svg$Svg$Attributes$y2(
				$elm$core$String$fromInt(chartHeight)),
				$elm$svg$Svg$Attributes$stroke('#888'),
				$elm$svg$Svg$Attributes$strokeWidth('1')
			]),
		_List_Nil);
	var graphSvg = $author$project$Ui$html(
		A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$viewBox(
					'0 0 ' + ($elm$core$String$fromInt(chartWidth) + (' ' + $elm$core$String$fromInt(chartHeight)))),
					$elm$svg$Svg$Attributes$width(
					$elm$core$String$fromInt(chartWidth)),
					$elm$svg$Svg$Attributes$height(
					$elm$core$String$fromInt(chartHeight)),
					A2($elm$html$Html$Attributes$style, 'max-width', '100%'),
					A2($elm$html$Html$Attributes$style, 'height', 'auto')
				]),
			A2(
				$elm$core$List$cons,
				baseline,
				A2($elm$core$List$cons, polyline, dots))));
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(4),
				$author$project$Ui$width($author$project$Ui$shrink)
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Font$size(12)
					]),
				$author$project$Ui$text(
					'Events per hour over the last 24 hours (peak: ' + ($elm$core$String$fromInt(maxCount) + ')'))),
				graphSvg,
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$Font$size(11),
						$author$project$Ui$spacing(8)
					]),
				_List_fromArray(
					[
						$author$project$Ui$text('24h ago'),
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$alignRight,
								$author$project$Ui$width($author$project$Ui$shrink)
							]),
						$author$project$Ui$text('now'))
					]))
			]));
};
var $author$project$Pages$Admin$eventsPerHourLineGraph = F3($author$project$Pages$Admin$eventsPerHourLineGraph$);
var $author$project$Pages$Admin$websocketCloseEventToString = function (event) {
	switch (event.$) {
		case 0:
			var time = event.b;
			return _Utils_Tuple2(
				_Utils_Tuple2('CloseAndReopenForUser', '#e0625e'),
				time);
		case 1:
			var time = event.b;
			return _Utils_Tuple2(
				_Utils_Tuple2('UnlinkDiscordUser', '#5e9be0'),
				time);
		case 2:
			var time = event.b;
			return _Utils_Tuple2(
				_Utils_Tuple2('ClosedByBackendForUser', '#5ee07d'),
				time);
		default:
			var time = event.d;
			return _Utils_Tuple2(
				_Utils_Tuple2('ListenCloseEvent', '#bb5ee0'),
				time);
	}
};
var $author$project$Pages$Admin$PressedWebsocketCloseEventsPage = function (a) {
	return {$: 60, a: a};
};
var $author$project$Pages$Admin$websocketCloseEventListItem$ = function (timezone, _v0) {
	var index = _v0.a;
	var event = _v0.b;
	var details = function () {
		switch (event.$) {
			case 0:
				var userId = event.a;
				return 'user ' + $author$project$Discord$idToString(userId);
			case 1:
				var userId = event.a;
				return 'user ' + $author$project$Discord$idToString(userId);
			case 2:
				var userId = event.a;
				return 'user ' + $author$project$Discord$idToString(userId);
			default:
				var userId = event.a;
				var code = event.b;
				var reason = event.c;
				return 'user ' + ($author$project$Discord$idToString(userId) + (', code: ' + (function () {
					switch (code.$) {
						case 0:
							return '1000 Normal Closure';
						case 1:
							return '1001 GoingAway';
						case 2:
							return '1002 ProtocolError';
						case 3:
							return '1003 UnsupportedData';
						case 4:
							return '1005 NoStatusReceived';
						case 5:
							return '1006 AbnormalClosure';
						case 6:
							return '1007 InvalidFramePayloadData';
						case 7:
							return '1008 PolicyViolation';
						case 8:
							return '1009 MessageTooBig';
						case 9:
							return '1010 MissingExtension';
						case 10:
							return '1011 InternalError';
						case 11:
							return '1012 ServiceRestart';
						case 12:
							return '1013 TryAgainLater';
						case 13:
							return '1014 BadGateway';
						case 14:
							return '1015 TlsHandshake';
						default:
							var _int = code.a;
							return $elm$core$String$fromInt(_int) + ' Unknown code';
					}
				}() + (', reason: ' + reason))));
		}
	}();
	var _v1 = $author$project$Pages$Admin$websocketCloseEventToString(event);
	var _v2 = _v1.a;
	var label = _v2.a;
	var time = _v1.b;
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$width($author$project$Ui$shrink)
					]),
				$author$project$Ui$text(
					'#' + $elm$core$String$fromInt(index + 1))),
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$width($author$project$Ui$shrink)
					]),
				$author$project$Ui$text(
					$author$project$MyUi$datestamp$(timezone, time) + (' ' + $author$project$MyUi$timestamp$(time, timezone)))),
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$width($author$project$Ui$shrink),
						$author$project$Ui$Font$bold
					]),
				$author$project$Ui$text(label)),
				$author$project$Ui$text(details)
			]));
};
var $author$project$Pages$Admin$websocketCloseEventListItem = F2($author$project$Pages$Admin$websocketCloseEventListItem$);
var $author$project$Pages$Admin$websocketCloseEventsPageSize = 20;
var $author$project$Pages$Admin$websocketCloseEventsList$ = function (timezone, model, events) {
	var total = $elm$core$Array$length(events);
	var pageCount = ((($author$project$Pages$Admin$websocketCloseEventsPageSize - 1) + total) / $author$project$Pages$Admin$websocketCloseEventsPageSize) | 0;
	var currentPage = $elm$core$Basics$clamp$(
		0,
		$elm$core$Basics$max$(0, pageCount - 1),
		model.websocketCloseEventsPage);
	var endIndex = total - (currentPage * $author$project$Pages$Admin$websocketCloseEventsPageSize);
	var startIndex = $elm$core$Basics$max$(0, total - ((currentPage + 1) * $author$project$Pages$Admin$websocketCloseEventsPageSize));
	var pageItems = $elm$core$List$reverse(
		$elm$core$List$map$(
			function (_v0) {
				var i = _v0.a;
				var e = _v0.b;
				return _Utils_Tuple2(startIndex + i, e);
			},
			$elm$core$Array$toIndexedList(
				$elm$core$Array$slice$(startIndex, endIndex, events))));
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(6)
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Font$bold,
						$author$project$Ui$Font$size(14)
					]),
				$author$project$Ui$text('All events')),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(2),
						$author$project$Ui$Font$size(13)
					]),
				$elm$core$List$map$(
					$author$project$Pages$Admin$websocketCloseEventListItem(timezone),
					pageItems)),
				(pageCount <= 1) ? $author$project$Ui$none : $author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(8),
						$author$project$Ui$Font$size(12)
					]),
				_List_fromArray(
					[
						(_Utils_cmp(currentPage + 1, pageCount) > -1) ? $author$project$Ui$none : $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$width($author$project$Ui$shrink)
							]),
						$author$project$MyUi$simpleButton$(
							$lamdera$program_test$Effect$Browser$Dom$id('admin_websocketCloseEventsPrev'),
							$author$project$Pages$Admin$PressedWebsocketCloseEventsPage(currentPage + 1),
							$author$project$Ui$text('← Older'))),
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$width($author$project$Ui$shrink),
								$author$project$Ui$centerY
							]),
						$author$project$Ui$text(
							'Page ' + ($elm$core$String$fromInt(currentPage + 1) + (' of ' + $elm$core$String$fromInt(pageCount))))),
						(currentPage <= 0) ? $author$project$Ui$none : $author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$width($author$project$Ui$shrink)
							]),
						$author$project$MyUi$simpleButton$(
							$lamdera$program_test$Effect$Browser$Dom$id('admin_websocketCloseEventsNext'),
							$author$project$Pages$Admin$PressedWebsocketCloseEventsPage(currentPage - 1),
							$author$project$Ui$text('Newer →')))
					]))
			]));
};
var $author$project$Pages$Admin$websocketCloseEventsList = F3($author$project$Pages$Admin$websocketCloseEventsList$);
var $author$project$Pages$Admin$websocketCloseEventsSection$ = function (isMobile, currentTime, timezone, expandedSections, adminData, model) {
	return $author$project$Pages$Admin$section$(
		isMobile,
		expandedSections,
		16,
		_List_fromArray(
			[
				function () {
				var _v0 = adminData.websocketCloseEvents;
				switch (_v0.$) {
					case 0:
						return $author$project$Ui$text($author$project$Pages$Admin$loadingText);
					case 1:
						return $author$project$Ui$text($author$project$Pages$Admin$loadingText);
					default:
						var events = _v0.a;
						if ($elm$core$Array$isEmpty(events)) {
							return $author$project$Ui$text('No websocket close events recorded');
						} else {
							var eventsByType = $elm$core$Array$foldl$(
								F2(
									function (event, dict) {
										var _v3 = $author$project$Pages$Admin$websocketCloseEventToString(event);
										var name = _v3.a;
										var time = _v3.b;
										return $author$project$SeqDictHelper$addToList$(name, time, dict);
									}),
								$lamdera$containers$SeqDict$empty,
								events);
							return $author$project$Ui$column$(
								_List_fromArray(
									[
										$author$project$Ui$spacing(12)
									]),
								A2(
									$elm$core$List$cons,
									$author$project$Ui$text(
										'Total recorded: ' + $elm$core$String$fromInt(
											$elm$core$Array$length(events))),
									_Utils_ap(
										$elm$core$List$map$(
											function (_v1) {
												var _v2 = _v1.a;
												var label = _v2.a;
												var color = _v2.b;
												var times = _v1.b;
												return $author$project$Ui$column$(
													_List_fromArray(
														[
															$author$project$Ui$spacing(4)
														]),
													_List_fromArray(
														[
															$author$project$Ui$el$(
															_List_fromArray(
																[
																	$author$project$Ui$Font$bold,
																	$author$project$Ui$Font$size(14)
																]),
															$author$project$Ui$text(
																label + (' (' + ($elm$core$String$fromInt(
																	$mgold$elm_nonempty_list$List$Nonempty$length(times)) + ')')))),
															$author$project$Pages$Admin$eventsPerHourLineGraph$(
															currentTime,
															color,
															$mgold$elm_nonempty_list$List$Nonempty$toList(times))
														]));
											},
											$lamdera$containers$SeqDict$toList(eventsByType)),
										_List_fromArray(
											[
												$author$project$Pages$Admin$websocketCloseEventsList$(timezone, model, events)
											]))));
						}
				}
			}()
			]));
};
var $author$project$Pages$Admin$websocketCloseEventsSection = F6($author$project$Pages$Admin$websocketCloseEventsSection$);
var $author$project$Pages$Admin$WordSpellingGameSwedishSection = 18;
var $author$project$Pages$Admin$wordSpellingGameStatusText = function (status) {
	switch (status.$) {
		case 0:
			return 'Not loaded';
		case 1:
			return 'Loading...';
		case 2:
			var error = status.a;
			return 'Failed to load: ' + $author$project$Log$httpErrorToString(error);
		default:
			return 'Loaded';
	}
};
var $author$project$Pages$Admin$wordSpellingGameSwedishSection$ = function (isMobile, expandedSections, adminData) {
	return $author$project$Pages$Admin$section$(
		isMobile,
		expandedSections,
		18,
		_List_fromArray(
			[
				$author$project$Ui$text(
				'English: ' + $author$project$Pages$Admin$wordSpellingGameStatusText(adminData.wordSpellingGameEnglish)),
				$author$project$Ui$text(
				'Swedish: ' + $author$project$Pages$Admin$wordSpellingGameStatusText(adminData.wordSpellingGameSwedish))
			]));
};
var $author$project$Pages$Admin$wordSpellingGameSwedishSection = F3($author$project$Pages$Admin$wordSpellingGameSwedishSection$);
var $author$project$Pages$Admin$view$ = function (isMobile2, version, time, local, adminData, model) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$scrollable,
				$author$project$Ui$background($author$project$MyUi$background3),
				$author$project$Ui$paddingWith(
				{bottom: local.localUser.safeAreaInsetBottom, left: 0, right: 0, top: local.localUser.safeAreaInsetTop}),
				$author$project$Ui$heightMin(0)
			]),
		$author$project$MyUi$column$(
			_List_fromArray(
				[
					$author$project$Ui$paddingWith(
					{bottom: 64, left: 8, right: 8, top: 16})
				]),
			_List_fromArray(
				[
					$author$project$Ui$row$(
					_List_Nil,
					_List_fromArray(
						[
							$author$project$MyUi$simpleButton$(
							$lamdera$program_test$Effect$Browser$Dom$id('admin_goToHomepage'),
							$author$project$Pages$Admin$PressedHomepageLink,
							$author$project$Ui$text('Go to homepage')),
							$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$alignRight,
									$author$project$Ui$width($author$project$Ui$shrink)
								]),
							function () {
								if (!version.$) {
									var version2 = version.a;
									return $author$project$Ui$text(
										'Version ' + $elm$core$String$fromInt(version2));
								} else {
									return $author$project$Ui$text('Version unknown');
								}
							}())
						])),
					$author$project$Ui$text(adminData.vulnerabilityChecks),
					$author$project$Ui$Lazy$lazy5$($author$project$Pages$Admin$userSection, isMobile2, local.localUser.timezone, model.expandedSections, adminData, model),
					$author$project$Ui$Lazy$lazy4$($author$project$Pages$Admin$guildsSection, isMobile2, model.expandedSections, model.expandedGuilds, adminData),
					$author$project$Ui$Lazy$lazy3$($author$project$Pages$Admin$deletedGuildsSection, isMobile2, model.expandedSections, adminData),
					$author$project$Ui$Lazy$lazy4$($author$project$Pages$Admin$discordGuildsSection, isMobile2, model.expandedSections, model.expandedDiscordGuilds, adminData),
					$author$project$Ui$Lazy$lazy4$($author$project$Pages$Admin$slackWorkspacesSection, isMobile2, model.expandedSections, model.expandedSlackWorkspaces, adminData),
					$author$project$Ui$Lazy$lazy3$($author$project$Pages$Admin$dmChannelsSection, isMobile2, model.expandedSections, adminData),
					$author$project$Ui$Lazy$lazy3$($author$project$Pages$Admin$discordDmChannelsSection, isMobile2, model.expandedSections, adminData),
					$author$project$Ui$Lazy$lazy3$($author$project$Pages$Admin$slackDmChannelsSection, isMobile2, model.expandedSections, adminData),
					$author$project$Ui$Lazy$lazy3$($author$project$Pages$Admin$discordUsersSection, isMobile2, model.expandedSections, adminData),
					$author$project$Ui$Lazy$lazy5$($author$project$Pages$Admin$logSection, isMobile2, local.localUser, model.expandedSections, adminData, model),
					$author$project$Ui$Lazy$lazy5$($author$project$Pages$Admin$apiKeysSection, isMobile2, local, model.expandedSections, adminData, model),
					$author$project$Ui$Lazy$lazy4$($author$project$Pages$Admin$connectionsSection, isMobile2, local.localUser.timezone, model.expandedSections, adminData),
					$author$project$Ui$Lazy$lazy4$($author$project$Pages$Admin$sessionsSection, isMobile2, local.localUser.timezone, model.expandedSections, adminData),
					$author$project$Pages$Admin$websocketCloseEventsSection$(isMobile2, time, local.localUser.timezone, model.expandedSections, adminData, model),
					$author$project$Ui$Lazy$lazy3$($author$project$Pages$Admin$wordSpellingGameSwedishSection, isMobile2, model.expandedSections, adminData),
					$author$project$Ui$Lazy$lazy3$($author$project$Pages$Admin$filesSection, isMobile2, model.expandedSections, adminData),
					$author$project$Ui$Lazy$lazy3$($author$project$Pages$Admin$stickersAndEmojisSection, isMobile2, local, model.expandedSections),
					$author$project$Ui$Lazy$lazy4$($author$project$Pages$Admin$updateLogsSection, isMobile2, time, model.expandedSections, adminData),
					$author$project$Ui$Lazy$lazy5$($author$project$Pages$Admin$exportSection, isMobile2, local.localUser.timezone, model.expandedSections, adminData, model)
				])));
};
var $author$project$Pages$Admin$view = F6($author$project$Pages$Admin$view$);
var $author$project$Pages$Home$previewIntervalMillis = 8000;
var $author$project$Pages$Home$PreviewCall = {$: 2};
var $author$project$Pages$Home$PreviewChannel$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Pages$Home$PreviewChannel = F2($author$project$Pages$Home$PreviewChannel$);
var $author$project$Pages$Home$PreviewUnreadOverview = {$: 1};
var $author$project$Pages$Home$previewChannelId = $author$project$Id$fromInt(0);
var $author$project$Pages$Home$previewGameGuildId = $author$project$Id$fromInt(1);
var $author$project$Pages$Home$previewGameMatchId = $author$project$Id$fromInt(7);
var $author$project$Pages$Home$previewUserId = $author$project$Id$fromInt(0);
var $author$project$Pages$Home$previewGameSetup = $author$project$WordSpellingGame$validateSetup$(
	$author$project$Pages$Home$previewUserId,
	$lamdera$program_test$Effect$Time$millisToPosix(0),
	$author$project$WordSpellingGame$initSetup);
var $author$project$Pages$Home$previewPages = _Utils_ap(
	A2(
		$elm$core$List$cons,
		$author$project$Pages$Home$PreviewChannel$(
			$author$project$Pages$Home$previewGuildId,
			$author$project$Route$ChannelRoute$(
				$author$project$Pages$Home$previewChannelId,
				$author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1),
				$elm$core$Maybe$Nothing)),
		function () {
			var _v0 = $author$project$Pages$Home$previewGameSetup;
			if (!_v0.$) {
				return _List_fromArray(
					[
						$author$project$Pages$Home$PreviewChannel$(
						$author$project$Pages$Home$previewGameGuildId,
						$author$project$Route$ChannelRoute$(
							$author$project$Pages$Home$previewChannelId,
							$author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1),
							$elm$core$Maybe$Just(
								$author$project$UserSession$ChannelHeaderTab_Games$(
									$elm$core$Maybe$Just($author$project$Pages$Home$previewGameMatchId),
									$elm$core$Maybe$Nothing))))
					]);
			} else {
				return _List_Nil;
			}
		}()),
	_List_fromArray(
		[$author$project$Pages$Home$PreviewCall, $author$project$Pages$Home$PreviewUnreadOverview]));
var $author$project$Pages$Home$activePreview = function (loaded) {
	if (loaded.homePagePreview.rotate) {
		var elapsed = $elm$core$Basics$max$(
			0,
			$lamdera$program_test$Effect$Time$posixToMillis(loaded.time) - $lamdera$program_test$Effect$Time$posixToMillis(loaded.homePagePreview.changedAt));
		return A2(
			$elm$core$Basics$modBy,
			$elm$core$List$length($author$project$Pages$Home$previewPages),
			loaded.homePagePreview.index + ((elapsed / $author$project$Pages$Home$previewIntervalMillis) | 0));
	} else {
		return loaded.homePagePreview.index;
	}
};
var $author$project$Types$PressedHomePagePreview = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Home$nextPreviewButton = function (activeIndex) {
	return $author$project$MyUi$elButton$(
		$lamdera$program_test$Effect$Browser$Dom$id('homePage_nextPreview'),
		$author$project$Types$PressedHomePagePreview(
			A2(
				$elm$core$Basics$modBy,
				$elm$core$List$length($author$project$Pages$Home$previewPages),
				activeIndex + 1)),
		_List_fromArray(
			[
				$author$project$Ui$alignRight,
				$author$project$Ui$width(
				$author$project$Ui$px(64)),
				$author$project$Ui$height($author$project$Ui$fill)
			]),
		$author$project$Ui$none);
};
var $author$project$Pages$Home$previewCameraId = $author$project$IdString$fromString('previewCamera');
var $author$project$Pages$Home$previewDots = function (activeIndex) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$width($author$project$Ui$shrink),
				$author$project$Ui$centerX
			]),
		$elm$core$List$map$(
			function (index) {
				return $author$project$MyUi$elButton$(
					$lamdera$program_test$Effect$Browser$Dom$id(
						'homePage_preview_' + $elm$core$String$fromInt(index)),
					$author$project$Types$PressedHomePagePreview(index),
					_List_fromArray(
						[
							$author$project$Ui$padding(8)
						]),
					$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$width(
								$author$project$Ui$px(12)),
								$author$project$Ui$height(
								$author$project$Ui$px(12)),
								$author$project$Ui$rounded(99),
								$author$project$Ui$background(
								_Utils_eq(index, activeIndex) ? $author$project$MyUi$white : $author$project$Ui$rgba$(255, 255, 255, 0.4))
							]),
						$author$project$Ui$none));
			},
			$elm$core$List$range$(
				0,
				$elm$core$List$length($author$project$Pages$Home$previewPages) - 1)));
};
var $author$project$Emoji$fromString = $elm$core$Basics$identity;
var $author$project$Pages$Home$previewGameLetters$ = function (first, rest) {
	return $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
		$author$project$WordSpellingGame$Letter(first),
		$elm$core$List$map$(
			function (_char) {
				return $author$project$WordSpellingGame$Letter(_char);
			},
			$elm$core$String$toList(rest)));
};
var $author$project$Pages$Home$previewGameLetters = F2($author$project$Pages$Home$previewGameLetters$);
var $author$project$WordSpellingGame$IsValid = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Home$previewGameMove$ = function (time, secondsAgo, userId, start, isVertical, letters) {
	return {
		change: $author$project$WordSpellingGame$PlaceWord$(
			{isVertical: isVertical, letters: letters, start: start},
			$author$project$UserSession$FilledInByBackend(
				$author$project$WordSpellingGame$IsValid($elm$core$Set$empty))),
		time: $ianmackenzie$elm_units$Duration$addTo$(
			time,
			$ianmackenzie$elm_units$Duration$seconds(-secondsAgo)),
		userId: userId
	};
};
var $author$project$Pages$Home$previewGameMove = F6($author$project$Pages$Home$previewGameMove$);
var $author$project$Pages$Home$previewGameActions = function (time) {
	return $elm$core$Array$fromList(
		_List_fromArray(
			[
				{
				change: $author$project$WordSpellingGame$JoinGame,
				time: $ianmackenzie$elm_units$Duration$addTo$(
					time,
					$ianmackenzie$elm_units$Duration$seconds(-430)),
				userId: $author$project$Id$fromInt(4)
			},
				{
				change: $author$project$WordSpellingGame$JoinGame,
				time: $ianmackenzie$elm_units$Duration$addTo$(
					time,
					$ianmackenzie$elm_units$Duration$seconds(-420)),
				userId: $author$project$Id$fromInt(3)
			},
				$author$project$Pages$Home$previewGameMove$(
				time,
				360,
				$author$project$Pages$Home$previewUserId,
				_Utils_Tuple2(4, 7),
				false,
				$author$project$Pages$Home$previewGameLetters$('Q', 'UARTZ')),
				{
				change: $author$project$WordSpellingGame$AddedReaction$(
					3,
					$author$project$Emoji$EmojiOrCustomEmoji_Emoji(
						$author$project$Emoji$fromString('🔥'))),
				time: $ianmackenzie$elm_units$Duration$addTo$(
					time,
					$ianmackenzie$elm_units$Duration$seconds(-350)),
				userId: $author$project$Id$fromInt(3)
			},
				{
				change: $author$project$WordSpellingGame$AddedReaction$(
					3,
					$author$project$Emoji$EmojiOrCustomEmoji_Emoji(
						$author$project$Emoji$fromString('💎'))),
				time: $ianmackenzie$elm_units$Duration$addTo$(
					time,
					$ianmackenzie$elm_units$Duration$seconds(-350)),
				userId: $author$project$Id$fromInt(3)
			},
				$author$project$Pages$Home$previewGameMove$(
				time,
				300,
				$author$project$Id$fromInt(4),
				_Utils_Tuple2(9, 7),
				true,
				$author$project$Pages$Home$previewGameLetters$('E', 'BRA')),
				$author$project$Pages$Home$previewGameMove$(
				time,
				240,
				$author$project$Id$fromInt(3),
				_Utils_Tuple2(9, 9),
				false,
				$author$project$Pages$Home$previewGameLetters$('R', 'INK')),
				$author$project$Pages$Home$previewGameMove$(
				time,
				180,
				$author$project$Pages$Home$previewUserId,
				_Utils_Tuple2(6, 7),
				true,
				$author$project$Pages$Home$previewGameLetters$('X', 'E')),
				$author$project$Pages$Home$previewGameMove$(
				time,
				120,
				$author$project$Id$fromInt(4),
				_Utils_Tuple2(9, 11),
				false,
				$author$project$Pages$Home$previewGameLetters$('G', 'ILE')),
				$author$project$Pages$Home$previewGameMove$(
				time,
				60,
				$author$project$Id$fromInt(3),
				_Utils_Tuple2(10, 11),
				true,
				$author$project$Pages$Home$previewGameLetters$('U', 'ST'))
			]));
};
var $author$project$Pages$Home$previewGameShared$ = function (time, setup) {
	return $elm$core$Array$foldl$(
		F2(
			function (action, shared) {
				return $author$project$WordSpellingGame$updateAction$(setup, action, shared).a;
			}),
		$author$project$WordSpellingGame$initShared(setup),
		$author$project$Pages$Home$previewGameActions(time));
};
var $author$project$Pages$Home$previewGameShared = F2($author$project$Pages$Home$previewGameShared$);
var $author$project$Pages$Home$previewGameModels = function (time) {
	var _v0 = $author$project$Pages$Home$previewGameSetup;
	if (!_v0.$) {
		var setup = _v0.a;
		var gameModel = $author$project$Game$initModel;
		return $lamdera$containers$SeqDict$singleton$(
			$author$project$Id$GuildOrDmId_Guild(
				{channelId: $author$project$Pages$Home$previewChannelId, guildId: $author$project$Pages$Home$previewGameGuildId}),
			_Utils_update(
				gameModel,
				{
					startedGames: $lamdera$containers$SeqDict$singleton$(
						$author$project$Pages$Home$previewGameMatchId,
						$author$project$Game$WordSpellingGame_Game(
							$author$project$WordSpellingGame$initGame$(
								$ianmackenzie$elm_units$Duration$addTo$(
									time,
									$ianmackenzie$elm_units$Duration$seconds(-10)),
								$author$project$Pages$Home$previewUserId,
								setup,
								$author$project$Pages$Home$previewGameShared$(time, setup))))
				}));
	} else {
		return $lamdera$containers$SeqDict$empty;
	}
};
var $author$project$Types$IsNotAdminLoginData = {$: 2};
var $author$project$UserSession$NoNotifications = 0;
var $author$project$UserSession$NotSubscribed = {$: 0};
var $author$project$SessionIdHash$SessionIdHash = $elm$core$Basics$identity;
var $author$project$SessionIdHash$fromString = $elm$core$Basics$identity;
var $author$project$Unsafe$uint64 = function (text) {
	var _v0 = $MartinSStewart$elm_uint64$UInt64$fromString(text);
	if (!_v0.$) {
		var b = _v0.a;
		return b;
	} else {
		return $author$project$Unsafe$unreachable(0);
	}
};
var $author$project$Pages$Home$previewDiscordDmChannelId = $author$project$Discord$idFromUInt64(
	$author$project$Unsafe$uint64('1072828564317159465'));
var $author$project$Pages$Home$previewDiscordUserId = $author$project$Discord$idFromUInt64(
	$author$project$Unsafe$uint64('185574444641550336'));
var $author$project$Pages$Home$previewMessage$ = function (createdAt, createdBy, text) {
	return $author$project$Message$UserTextMessage(
		{
			content: {
				attachedFiles: $lamdera$containers$SeqDict$empty,
				content: $author$project$RichText$fromNonemptyString$($lamdera$program_test$Effect$Time$utc, $lamdera$containers$SeqDict$empty, $lamdera$containers$SeqDict$empty, text),
				embeds: $elm$core$Array$empty
			},
			createdAt: createdAt,
			createdBy: createdBy,
			drawings: $elm$core$Maybe$Nothing,
			editedAt: $elm$core$Maybe$Nothing,
			reactions: $lamdera$containers$SeqDict$empty,
			repliedTo: $author$project$Message$NoReply
		});
};
var $author$project$Pages$Home$previewMessage = F3($author$project$Pages$Home$previewMessage$);
var $author$project$Pages$Home$previewMinutesAgo$ = function (time, minutes) {
	return $ianmackenzie$elm_units$Duration$addTo$(
		time,
		$ianmackenzie$elm_units$Duration$minutes(-minutes));
};
var $author$project$Pages$Home$previewMinutesAgo = F2($author$project$Pages$Home$previewMinutesAgo$);
var $author$project$Pages$Home$previewOtherDiscordUserId = $author$project$Discord$idFromUInt64(
	$author$project$Unsafe$uint64('705745250815311942'));
var $author$project$Pages$Home$previewDiscordDmChannels = function (time) {
	var messages = $elm$core$List$foldl$(
		$author$project$MessageArray$push,
		$author$project$MessageArray$empty,
		_List_fromArray(
			[
				$author$project$Pages$Home$previewMessage$(
				$author$project$Pages$Home$previewMinutesAgo$(time, 1519),
				$author$project$Pages$Home$previewDiscordUserId,
				$MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('r', 'ematch?'))
			]));
	return $lamdera$containers$SeqDict$singleton$(
		$author$project$Pages$Home$previewDiscordDmChannelId,
		{
			dateDividerDrawings: $lamdera$containers$SeqDict$empty,
			lastTypedAt: $lamdera$containers$SeqDict$empty,
			members: $author$project$NonemptyDict$insert$(
				$author$project$Pages$Home$previewOtherDiscordUserId,
				{messagesSent: 1},
				$author$project$NonemptyDict$singleton$(
					$author$project$Pages$Home$previewDiscordUserId,
					{messagesSent: 1})),
			messages: messages,
			visibleMessages: $author$project$VisibleMessages$init$(
				true,
				$author$project$MessageArray$length(messages))
		});
};
var $author$project$Pages$Home$previewDiscordGuildId = $author$project$Discord$idFromUInt64(
	$author$project$Unsafe$uint64('161098476632014848'));
var $author$project$Unsafe$guildName = function (a) {
	var _v0 = $author$project$GuildName$fromString(a);
	if (!_v0.$) {
		var b = _v0.a;
		return b;
	} else {
		return $author$project$Unsafe$unreachable(0);
	}
};
var $author$project$Pages$Home$previewDiscordGuildName = $author$project$Unsafe$guildName('speedrun club');
var $author$project$Pages$Home$previewDiscordGuilds = function (time) {
	return $lamdera$containers$SeqDict$singleton$(
		$author$project$Pages$Home$previewDiscordGuildId,
		{
			channels: $lamdera$containers$SeqDict$empty,
			customEmojis: $lamdera$containers$SeqSet$empty,
			icon: $elm$core$Maybe$Just(
				$author$project$FileStatus$fileHash('oZrA2YpsYOdRoJdkgHqQTNEpgNvznKNeSmwOeA')),
			lastTypedAt: $lamdera$containers$SeqDict$empty,
			membersAndOwner: $author$project$MembersAndOwner$init$(
				$lamdera$containers$SeqDict$singleton$(
					$author$project$Pages$Home$previewDiscordUserId,
					{
						joinedAt: $elm$core$Maybe$Just(time),
						roles: $lamdera$containers$SeqSet$empty
					}),
				$author$project$Pages$Home$previewOtherDiscordUserId),
			name: $author$project$Pages$Home$previewDiscordGuildName,
			roles: $lamdera$containers$SeqDict$empty,
			stickers: $lamdera$containers$SeqSet$empty
		});
};
var $author$project$Unsafe$personName = function (a) {
	var _v0 = $author$project$PersonName$fromString(a);
	if (!_v0.$) {
		var b = _v0.a;
		return b;
	} else {
		return $author$project$Unsafe$unreachable(0);
	}
};
var $author$project$Pages$Home$previewDiscordUsers = $author$project$LinkedAndOtherDiscordUsers$LinkedAndOtherDiscordUsers$(
	$lamdera$containers$SeqDict$singleton$(
		$author$project$Pages$Home$previewOtherDiscordUserId,
		{
			color: $author$project$Unsafe$userColor(
				{hue: 10, lightness: 11, saturation: 13}),
			icon: $elm$core$Maybe$Nothing,
			name: $author$project$Unsafe$personName('rkyle')
		}),
	$lamdera$containers$SeqDict$singleton$(
		$author$project$Pages$Home$previewDiscordUserId,
		{
			color: $author$project$RichText$defaultColor,
			email: $elm$core$Maybe$Nothing,
			icon: $elm$core$Maybe$Nothing,
			isLoadingData: $author$project$DiscordUserData$DiscordUserLoadedSuccessfully,
			linkedAt: $lamdera$program_test$Effect$Time$millisToPosix(0),
			name: $author$project$Unsafe$personName('Sven Svensson'),
			needsAuthAgain: false
		}));
var $author$project$Pages$Home$previewDmChannel$ = function (messages, threads) {
	var messages2 = $elm$core$List$foldl$($author$project$MessageArray$push, $author$project$MessageArray$empty, messages);
	var dmChannel = $author$project$DmChannel$frontendInit;
	return _Utils_update(
		dmChannel,
		{
			messages: messages2,
			threads: threads,
			visibleMessages: $author$project$VisibleMessages$init$(
				true,
				$author$project$MessageArray$length(messages2))
		});
};
var $author$project$Pages$Home$previewDmChannel = F2($author$project$Pages$Home$previewDmChannel$);
var $author$project$Pages$Home$previewThread = function (messages) {
	var messages2 = $elm$core$List$foldl$($author$project$MessageArray$push, $author$project$MessageArray$empty, messages);
	return {
		dateDividerDrawings: $lamdera$containers$SeqDict$empty,
		messages: messages2,
		visibleMessages: $author$project$VisibleMessages$init$(
			true,
			$author$project$MessageArray$length(messages2))
	};
};
var $author$project$Pages$Home$previewDmChannels = function (time) {
	return $lamdera$containers$SeqDict$fromList(
		_List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Id$fromInt(1),
				$author$project$Pages$Home$previewDmChannel$(
					_List_fromArray(
						[
							$author$project$Pages$Home$previewMessage$(
							$author$project$Pages$Home$previewMinutesAgo$(time, 1612),
							$author$project$Id$fromInt(1),
							$MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('d', 'id you ever find out what it was')),
							$author$project$Pages$Home$previewMessage$(
							$author$project$Pages$Home$previewMinutesAgo$(time, 1612),
							$author$project$Id$fromInt(1),
							$MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('N', 'ot today no'))
						]),
					$lamdera$containers$SeqDict$singleton$(
						$author$project$Id$fromInt(0),
						$author$project$Pages$Home$previewThread(
							_List_fromArray(
								[
									$author$project$Pages$Home$previewMessage$(
									$author$project$Pages$Home$previewMinutesAgo$(time, 1598),
									$author$project$Pages$Home$previewUserId,
									$MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('l', 'ooked it up, they nest on gravel roofs'))
								]))))),
				_Utils_Tuple2(
				$author$project$Id$fromInt(3),
				$author$project$Pages$Home$previewDmChannel$(
					_List_fromArray(
						[
							$author$project$Pages$Home$previewMessage$(
							$author$project$Pages$Home$previewMinutesAgo$(time, 396),
							$author$project$Id$fromInt(3),
							$MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('i', ' ran out of green!'))
						]),
					$lamdera$containers$SeqDict$empty))
			]));
};
var $author$project$Pages$Home$petPicsChannelName = $author$project$Unsafe$channelName('pet-pics');
var $author$project$Pages$Home$previewChannelName = $author$project$Unsafe$channelName('general');
var $author$project$Pages$Home$previewGames = function (time) {
	var _v0 = $author$project$Pages$Home$previewGameSetup;
	if (!_v0.$) {
		var setup = _v0.a;
		return $lamdera$containers$SeqDict$singleton$(
			$author$project$Pages$Home$previewGameMatchId,
			$author$project$Game$initMatchData$(
				$author$project$Game$GameData_WordSpellingGame$(
					setup,
					$author$project$Pages$Home$previewGameActions(time),
					$author$project$Pages$Home$previewGameShared$(time, setup)),
				$elm$core$Maybe$Nothing));
	} else {
		return $lamdera$containers$SeqDict$empty;
	}
};
var $author$project$Pages$Home$previewGameChannel = function (time) {
	var messages = $elm$core$List$foldl$(
		$author$project$MessageArray$push,
		$author$project$MessageArray$empty,
		_List_fromArray(
			[
				$author$project$Pages$Home$previewMessage$(
				$author$project$Pages$Home$previewMinutesAgo$(time, 1198),
				$author$project$Id$fromInt(3),
				$MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('g', 'g')),
				$author$project$Pages$Home$previewMessage$(
				$author$project$Pages$Home$previewMinutesAgo$(time, 1198),
				$author$project$Id$fromInt(4),
				$MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('g', 'g!')),
				$author$project$Pages$Home$previewMessage$(
				$author$project$Pages$Home$previewMinutesAgo$(time, 1198),
				$author$project$Id$fromInt(0),
				$MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('R', 'ematch whenever')),
				$author$project$Message$GameStarted(
				{
					cardDrawings: $author$project$Drawing$emptyDrawing,
					gameType: 1,
					reactions: $lamdera$containers$SeqDict$empty,
					startedAt: $author$project$Pages$Home$previewMinutesAgo$(time, 8),
					startedBy: $author$project$Id$fromInt(3),
					timestampDrawings: $author$project$Drawing$emptyDrawing
				}),
				$author$project$Message$UserTextMessage(
				{
					content: {
						attachedFiles: $lamdera$containers$SeqDict$empty,
						content: $author$project$RichText$fromNonemptyString$(
							$lamdera$program_test$Effect$Time$utc,
							$lamdera$containers$SeqDict$empty,
							$lamdera$containers$SeqDict$empty,
							$MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('C', 'ould have gotten a triple with that 😛')),
						embeds: $elm$core$Array$empty
					},
					createdAt: $author$project$Pages$Home$previewMinutesAgo$(time, 1),
					createdBy: $author$project$Id$fromInt(4),
					drawings: $elm$core$Maybe$Nothing,
					editedAt: $elm$core$Maybe$Nothing,
					reactions: $lamdera$containers$SeqDict$empty,
					repliedTo: $author$project$Message$RepliedToGame$(
						$author$project$Pages$Home$previewGameMatchId,
						$author$project$Message$RepliedTo_WordSpellingGameMove(8))
				})
			]));
	return {
		createdAt: $author$project$Pages$Home$previewMinutesAgo$(time, 60000),
		createdBy: $author$project$Id$fromInt(1),
		dateDividerDrawings: $lamdera$containers$SeqDict$empty,
		description: $author$project$ChannelDescription$empty,
		games: $author$project$Pages$Home$previewGames(time),
		isArchived: $elm$core$Maybe$Nothing,
		messages: messages,
		name: $author$project$Pages$Home$previewChannelName,
		threads: $lamdera$containers$SeqDict$empty,
		visibleMessages: $author$project$VisibleMessages$init$(
			true,
			$author$project$MessageArray$length(messages))
	};
};
var $author$project$Pages$Home$previewGameGuildName = $author$project$Unsafe$guildName('video game gang');
var $author$project$Pages$Home$doodleUserId = $author$project$Id$fromInt(10);
var $author$project$Pages$Home$previewOtherUsers = $lamdera$containers$SeqDict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			$author$project$Id$fromInt(1),
			{
				color: $author$project$Unsafe$userColor(
					{hue: 16, lightness: 8, saturation: 2}),
				icon: $elm$core$Maybe$Nothing,
				name: $author$project$Unsafe$personName('jobaly Joe'),
				publicKey: $elm$core$Maybe$Nothing
			}),
			_Utils_Tuple2(
			$author$project$Id$fromInt(2),
			{
				color: $author$project$Unsafe$userColor(
					{hue: 0, lightness: 12, saturation: $author$project$UserColor$saturationCount - 1}),
				icon: $elm$core$Maybe$Just(
					$author$project$FileStatus$fileHash('defrqz-9TjEnuXDZnPc8zD1VoeugOLHh_7-sWw')),
				name: $author$project$Unsafe$personName('boog\u0027les_the_spy.jpig'),
				publicKey: $elm$core$Maybe$Nothing
			}),
			_Utils_Tuple2(
			$author$project$Id$fromInt(3),
			{
				color: $author$project$Unsafe$userColor(
					{hue: 4, lightness: 10, saturation: 2}),
				icon: $elm$core$Maybe$Just(
					$author$project$FileStatus$fileHash('7kTsE8OAyWGK_3AsOpZje0ySNF-kqCH_RnemPg')),
				name: $author$project$Unsafe$personName('antichokehards'),
				publicKey: $elm$core$Maybe$Nothing
			}),
			_Utils_Tuple2(
			$author$project$Id$fromInt(4),
			{
				color: $author$project$Unsafe$userColor(
					{hue: 8, lightness: 8, saturation: 4}),
				icon: $elm$core$Maybe$Nothing,
				name: $author$project$Unsafe$personName('ABC*123'),
				publicKey: $elm$core$Maybe$Nothing
			}),
			_Utils_Tuple2(
			$author$project$Pages$Home$doodleUserId,
			{
				color: $author$project$Unsafe$userColor(
					{hue: 10, lightness: 10, saturation: $author$project$UserColor$saturationCount - 7}),
				icon: $elm$core$Maybe$Nothing,
				name: $author$project$Unsafe$personName('123'),
				publicKey: $elm$core$Maybe$Nothing
			})
		]));
var $author$project$Pages$Home$previewGameGuild = function (time) {
	return {
		channels: $lamdera$containers$SeqDict$fromList(
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Pages$Home$previewChannelId,
					$author$project$Pages$Home$previewGameChannel(time)),
					_Utils_Tuple2(
					$author$project$Id$fromInt(1),
					{
						createdAt: $author$project$Pages$Home$previewMinutesAgo$(time, 59000),
						createdBy: $author$project$Id$fromInt(1),
						dateDividerDrawings: $lamdera$containers$SeqDict$empty,
						description: $author$project$ChannelDescription$empty,
						games: $lamdera$containers$SeqDict$empty,
						isArchived: $elm$core$Maybe$Nothing,
						messages: $author$project$MessageArray$empty,
						name: $author$project$Pages$Home$petPicsChannelName,
						threads: $lamdera$containers$SeqDict$empty,
						visibleMessages: $author$project$VisibleMessages$init$(true, 0)
					})
				])),
		createdAt: $author$project$Pages$Home$previewMinutesAgo$(time, 60000),
		createdBy: $author$project$Id$fromInt(1),
		icon: $elm$core$Maybe$Just(
			$author$project$FileStatus$fileHash('OW5CQBd1c1K1WO7VYOsgq8BL6Fimp-EE2e141g')),
		invites: $lamdera$containers$SeqDict$empty,
		lastTypedAt: $lamdera$containers$SeqDict$singleton$(
			$author$project$Id$fromInt(3),
			{
				channelId: $author$project$Pages$Home$previewChannelId,
				threadRoute: $author$project$Id$NoThreadWithMaybeMessage($elm$core$Maybe$Nothing),
				time: time
			}),
		membersAndOwner: $author$project$MembersAndOwner$init$(
			$lamdera$containers$SeqDict$insert$(
				$author$project$Pages$Home$previewUserId,
				{
					joinedAt: $author$project$Pages$Home$previewMinutesAgo$(time, 59500),
					lastPostedAt: $elm$core$Maybe$Nothing
				},
				$lamdera$containers$SeqDict$map$(
					F2(
						function (_v0, _v1) {
							return {
								joinedAt: $author$project$Pages$Home$previewMinutesAgo$(time, 59500),
								lastPostedAt: $elm$core$Maybe$Nothing
							};
						}),
					$author$project$Pages$Home$previewOtherUsers)),
			$author$project$Id$fromInt(1)),
		name: $author$project$Pages$Home$previewGameGuildName
	};
};
var $author$project$Pages$Home$newsChannelName = $author$project$Unsafe$channelName('the-news');
var $author$project$Pages$Home$previewDoodlePoint = function (_v0) {
	var x = _v0.a;
	var y = _v0.b;
	return _Utils_Tuple2(
		$elm$core$Result$withDefault$(
			$author$project$SafeFloat$zero,
			$author$project$SafeFloat$fromFloat(x)),
		$elm$core$Result$withDefault$(
			$author$project$SafeFloat$zero,
			$author$project$SafeFloat$fromFloat(y + 120)));
};
var $author$project$Pages$Home$previewDoodleStroke$ = function (createdBy, firstPoint, rest) {
	return {
		createdBy: createdBy,
		points: $mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
			$author$project$Pages$Home$previewDoodlePoint(firstPoint),
			$elm$core$List$map$($author$project$Pages$Home$previewDoodlePoint, rest))
	};
};
var $author$project$Pages$Home$previewDoodleStroke = F3($author$project$Pages$Home$previewDoodleStroke$);
var $author$project$Pages$Home$previewDoodles = {
	embedDrawings: $lamdera$containers$SeqDict$empty,
	imageAttachmentDrawings: $lamdera$containers$SeqDict$empty,
	timestampDrawings: {
		finished: _List_fromArray(
			[
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-15, 231.5),
				_List_fromArray(
					[
						_Utils_Tuple2(-23.7, 225.8),
						_Utils_Tuple2(-25.7, 223.8),
						_Utils_Tuple2(-26.7, 221.5)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-25, 241.5),
				_List_fromArray(
					[
						_Utils_Tuple2(-17.7, 234.5),
						_Utils_Tuple2(-15.3, 231.1)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(7.7, 235.5),
				_List_fromArray(
					[
						_Utils_Tuple2(5.3, 231.5),
						_Utils_Tuple2(-4.3, 219.5),
						_Utils_Tuple2(-28.3, 199.5)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-12, 256.1),
				_List_fromArray(
					[
						_Utils_Tuple2(-5.3, 246.8),
						_Utils_Tuple2(-1.7, 243.5),
						_Utils_Tuple2(5, 239.5),
						_Utils_Tuple2(6, 237.1)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-23.7, 245.1),
				_List_fromArray(
					[
						_Utils_Tuple2(-28.3, 245.1),
						_Utils_Tuple2(-33.7, 247.5),
						_Utils_Tuple2(-35, 248.8),
						_Utils_Tuple2(-35, 254.1),
						_Utils_Tuple2(-34.3, 257.5),
						_Utils_Tuple2(-33, 261.1),
						_Utils_Tuple2(-30.7, 264.1),
						_Utils_Tuple2(-26.7, 266.1),
						_Utils_Tuple2(-20.3, 266.1),
						_Utils_Tuple2(-16.3, 265.5),
						_Utils_Tuple2(-14, 264.1),
						_Utils_Tuple2(-12, 261.5),
						_Utils_Tuple2(-12, 257.5)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-37.3, 192.5),
				_List_fromArray(
					[
						_Utils_Tuple2(-35, 196.1),
						_Utils_Tuple2(-33, 202.5),
						_Utils_Tuple2(-29.7, 218.1),
						_Utils_Tuple2(-29.7, 226.1),
						_Utils_Tuple2(-33.3, 251.8)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-118, 212.1),
				_List_fromArray(
					[
						_Utils_Tuple2(-121.3, 222.1),
						_Utils_Tuple2(-122, 230.1),
						_Utils_Tuple2(-120.7, 239.8),
						_Utils_Tuple2(-116.7, 254.5),
						_Utils_Tuple2(-116.3, 260.5)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-172.3, 228.8),
				_List_fromArray(
					[
						_Utils_Tuple2(-177.7, 230.8),
						_Utils_Tuple2(-191.3, 233.1),
						_Utils_Tuple2(-194.7, 234.8),
						_Utils_Tuple2(-194.3, 238.1),
						_Utils_Tuple2(-188.3, 242.8),
						_Utils_Tuple2(-185, 244.5),
						_Utils_Tuple2(-181, 245.5),
						_Utils_Tuple2(-168.3, 243.8),
						_Utils_Tuple2(-166.3, 243.1),
						_Utils_Tuple2(-159, 238.5),
						_Utils_Tuple2(-158, 236.8)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-175, 216.5),
				_List_fromArray(
					[
						_Utils_Tuple2(-191.3, 217.8),
						_Utils_Tuple2(-194.3, 219.1),
						_Utils_Tuple2(-195, 221.5),
						_Utils_Tuple2(-193.3, 225.1),
						_Utils_Tuple2(-189, 228.1),
						_Utils_Tuple2(-180, 228.5),
						_Utils_Tuple2(-174, 230.1)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-172, 199.8),
				_List_fromArray(
					[
						_Utils_Tuple2(-190.7, 198.1),
						_Utils_Tuple2(-195.3, 198.8),
						_Utils_Tuple2(-197.7, 200.1),
						_Utils_Tuple2(-198.3, 205.1),
						_Utils_Tuple2(-193.7, 212.8),
						_Utils_Tuple2(-189.7, 214.5),
						_Utils_Tuple2(-182.7, 214.5)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-193.7, 159.1),
				_List_fromArray(
					[
						_Utils_Tuple2(-193.7, 182.5),
						_Utils_Tuple2(-191.3, 194.1),
						_Utils_Tuple2(-189.3, 196.5),
						_Utils_Tuple2(-189, 197.8)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-177, 159.5),
				_List_fromArray(
					[
						_Utils_Tuple2(-178.3, 156.8),
						_Utils_Tuple2(-180.7, 154.5),
						_Utils_Tuple2(-187.3, 154.8),
						_Utils_Tuple2(-193.7, 158.1)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-162.3, 187.1),
				_List_fromArray(
					[
						_Utils_Tuple2(-166, 184.1),
						_Utils_Tuple2(-168.7, 180.8),
						_Utils_Tuple2(-170, 176.5),
						_Utils_Tuple2(-174.3, 168.5),
						_Utils_Tuple2(-176.3, 158.5)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-117.3, 210.8),
				_List_fromArray(
					[
						_Utils_Tuple2(-143.3, 228.5),
						_Utils_Tuple2(-158.3, 236.1),
						_Utils_Tuple2(-161, 236.8)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-116.3, 196.5),
				_List_fromArray(
					[
						_Utils_Tuple2(-162.7, 187.1)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-82.7, 190.1),
				_List_fromArray(
					[
						_Utils_Tuple2(-81, 193.8),
						_Utils_Tuple2(-78.3, 195.8),
						_Utils_Tuple2(-67.7, 197.5),
						_Utils_Tuple2(-62, 196.8),
						_Utils_Tuple2(-60, 190.1)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-133.7, 180.5),
				_List_fromArray(
					[
						_Utils_Tuple2(-133.3, 180.8),
						_Utils_Tuple2(-131.3, 178.1),
						_Utils_Tuple2(-125, 172.8),
						_Utils_Tuple2(-123.7, 172.8)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-133.3, 132.8),
				_List_fromArray(
					[
						_Utils_Tuple2(-137, 139.8),
						_Utils_Tuple2(-139.3, 151.1),
						_Utils_Tuple2(-139.3, 163.5),
						_Utils_Tuple2(-136.7, 173.5),
						_Utils_Tuple2(-136.7, 175.5),
						_Utils_Tuple2(-135.3, 177.5)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-142, 133.1),
				_List_fromArray(
					[
						_Utils_Tuple2(-136, 130.1),
						_Utils_Tuple2(-131, 129.1),
						_Utils_Tuple2(-123.3, 129.1)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-92, 105.8),
				_List_fromArray(
					[
						_Utils_Tuple2(-100.3, 106.5),
						_Utils_Tuple2(-119.3, 111.5),
						_Utils_Tuple2(-126, 114.5),
						_Utils_Tuple2(-130.7, 116.8),
						_Utils_Tuple2(-138.7, 122.5),
						_Utils_Tuple2(-142, 126.8),
						_Utils_Tuple2(-142.7, 130.8)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-91.3, 104.8),
				_List_fromArray(
					[
						_Utils_Tuple2(-86, 97.1),
						_Utils_Tuple2(-85.3, 92.1)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-12.3, 121.8),
				_List_fromArray(
					[
						_Utils_Tuple2(-14.3, 118.1),
						_Utils_Tuple2(-17.3, 115.1),
						_Utils_Tuple2(-30, 109.5),
						_Utils_Tuple2(-38.3, 107.1),
						_Utils_Tuple2(-50, 104.8),
						_Utils_Tuple2(-61, 103.5),
						_Utils_Tuple2(-74.7, 103.5),
						_Utils_Tuple2(-85.7, 105.1),
						_Utils_Tuple2(-90.7, 105.1)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-38, 120.8),
				_List_fromArray(
					[
						_Utils_Tuple2(-35.3, 122.5),
						_Utils_Tuple2(-31.3, 123.8),
						_Utils_Tuple2(-23, 123.8),
						_Utils_Tuple2(-13, 122.1)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(10.7, 195.1),
				_List_fromArray(
					[
						_Utils_Tuple2(3.3, 184.1),
						_Utils_Tuple2(-3, 176.1),
						_Utils_Tuple2(-12.3, 161.5),
						_Utils_Tuple2(-19.3, 146.5),
						_Utils_Tuple2(-27, 124.1)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-22.7, 185.1),
				_List_fromArray(
					[
						_Utils_Tuple2(-15.3, 189.8),
						_Utils_Tuple2(-10.3, 191.8),
						_Utils_Tuple2(1.7, 195.8),
						_Utils_Tuple2(8, 197.1),
						_Utils_Tuple2(10.3, 196.5)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-22, 198.1),
				_List_fromArray(
					[
						_Utils_Tuple2(-23, 185.5)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-33, 184.5),
				_List_fromArray(
					[
						_Utils_Tuple2(-27.7, 191.5),
						_Utils_Tuple2(-25, 196.5),
						_Utils_Tuple2(-23.7, 197.5)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-45.7, 192.1),
				_List_fromArray(
					[
						_Utils_Tuple2(-38.7, 190.5),
						_Utils_Tuple2(-35, 186.5),
						_Utils_Tuple2(-33.7, 183.5)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-41.7, 148.8),
				_List_fromArray(
					[
						_Utils_Tuple2(-38, 167.5),
						_Utils_Tuple2(-37.7, 176.5),
						_Utils_Tuple2(-38.3, 180.8),
						_Utils_Tuple2(-40, 184.8),
						_Utils_Tuple2(-43.3, 189.1),
						_Utils_Tuple2(-44.7, 189.5)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-52.7, 149.8),
				_List_fromArray(
					[
						_Utils_Tuple2(-55, 151.8),
						_Utils_Tuple2(-62.3, 155.5),
						_Utils_Tuple2(-67, 160.5),
						_Utils_Tuple2(-57, 161.5),
						_Utils_Tuple2(-49, 163.5)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-53.3, 146.8),
				_List_fromArray(
					[
						_Utils_Tuple2(-63, 154.5),
						_Utils_Tuple2(-68.7, 160.1),
						_Utils_Tuple2(-69.3, 161.8),
						_Utils_Tuple2(-59, 164.5),
						_Utils_Tuple2(-47.3, 165.8),
						_Utils_Tuple2(-44.3, 166.8)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-94, 167.1),
				_List_fromArray(
					[
						_Utils_Tuple2(-97.3, 173.1)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-95, 158.1),
				_List_fromArray(
					[
						_Utils_Tuple2(-100.3, 167.1),
						_Utils_Tuple2(-100.7, 169.1)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-99, 155.8),
				_List_fromArray(
					[
						_Utils_Tuple2(-103.3, 163.1)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-99.3, 151.5),
				_List_fromArray(
					[
						_Utils_Tuple2(-105.3, 157.1)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Pages$Home$doodleUserId,
				_Utils_Tuple2(-109.7, 180.5),
				_List_fromArray(
					[
						_Utils_Tuple2(-112.3, 172.5),
						_Utils_Tuple2(-112.3, 161.8),
						_Utils_Tuple2(-109.7, 155.5),
						_Utils_Tuple2(-105.3, 149.5),
						_Utils_Tuple2(-101.3, 148.1),
						_Utils_Tuple2(-98.3, 148.1),
						_Utils_Tuple2(-92.3, 152.1),
						_Utils_Tuple2(-89.7, 158.8),
						_Utils_Tuple2(-89.7, 168.5),
						_Utils_Tuple2(-90.3, 171.1),
						_Utils_Tuple2(-92.7, 175.8),
						_Utils_Tuple2(-93.3, 176.1),
						_Utils_Tuple2(-98, 175.1),
						_Utils_Tuple2(-101, 173.5),
						_Utils_Tuple2(-104.7, 170.1),
						_Utils_Tuple2(-106.3, 167.5),
						_Utils_Tuple2(-108, 159.5),
						_Utils_Tuple2(-108, 154.1)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Id$fromInt(3),
				_Utils_Tuple2(-144.5, 39),
				_List_fromArray(
					[
						_Utils_Tuple2(-140, 46.5),
						_Utils_Tuple2(-138.5, 51.5),
						_Utils_Tuple2(-129, 64),
						_Utils_Tuple2(-125, 67),
						_Utils_Tuple2(-116, 70.5),
						_Utils_Tuple2(-102, 71),
						_Utils_Tuple2(-98.5, 68.5),
						_Utils_Tuple2(-94, 61),
						_Utils_Tuple2(-91, 49),
						_Utils_Tuple2(-90.5, 39),
						_Utils_Tuple2(-89, 32),
						_Utils_Tuple2(-89, 19),
						_Utils_Tuple2(-88.5, 17.5)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Id$fromInt(3),
				_Utils_Tuple2(-153, 29.5),
				_List_fromArray(
					[
						_Utils_Tuple2(-142.5, 30.5),
						_Utils_Tuple2(-135, 29.5),
						_Utils_Tuple2(-99.5, 15),
						_Utils_Tuple2(-90.5, 12.5)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Id$fromInt(3),
				_Utils_Tuple2(-111, -40.5),
				_List_fromArray(
					[
						_Utils_Tuple2(-110, -28.5),
						_Utils_Tuple2(-108.5, -25),
						_Utils_Tuple2(-103, -17.5),
						_Utils_Tuple2(-103, -16.5)
					])),
				$author$project$Pages$Home$previewDoodleStroke$(
				$author$project$Id$fromInt(3),
				_Utils_Tuple2(-152.5, -28),
				_List_fromArray(
					[
						_Utils_Tuple2(-150.5, -18.5),
						_Utils_Tuple2(-150.5, -14),
						_Utils_Tuple2(-147.5, -1.5)
					]))
			]),
		inProgress: $lamdera$containers$SeqDict$empty,
		undone: $lamdera$containers$SeqDict$empty
	},
	userIconDrawings: $author$project$Drawing$emptyDrawing
};
var $author$project$FileStatus$webpContent = $author$project$FileStatus$contentType('image/webp');
var $author$project$Pages$Home$previewChannel = function (time) {
	var messages = $elm$core$List$foldl$(
		$author$project$MessageArray$push,
		$author$project$MessageArray$empty,
		_List_fromArray(
			[
				$author$project$Pages$Home$previewMessage$(
				$author$project$Pages$Home$previewMinutesAgo$(time, 20000),
				$author$project$Pages$Home$previewUserId,
				$MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('I', ' watched an old western yesterday, it was decent')),
				$author$project$Message$UserTextMessage(
				{
					content: {
						attachedFiles: $lamdera$containers$SeqDict$fromList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									$author$project$Id$fromInt(1),
									{
										contentType: $author$project$FileStatus$webpContent,
										fileHash: $author$project$FileStatus$fileHash('mnQelyTECkZW5RjIFCZjNirt8R_nuWGtV0WEzQ'),
										fileName: $author$project$FileName$fromString('birb.webp'),
										fileSize: 71812,
										isEncrypted: $author$project$FileStatus$IsNotEncrypted,
										metadata: $elm$core$Maybe$Just(
											$author$project$FileStatus$FileMetadata_Image(
												{
													cameraOwner: $elm$core$Maybe$Nothing,
													exposureTime: $elm$core$Maybe$Nothing,
													fNumber: $elm$core$Maybe$Nothing,
													focalLength: $elm$core$Maybe$Nothing,
													gpsLocation: $elm$core$Maybe$Nothing,
													imageSize: $author$project$Coord$xy$(949, 538),
													isoSpeedRating: $elm$core$Maybe$Nothing,
													make: $elm$core$Maybe$Nothing,
													model: $elm$core$Maybe$Nothing,
													orientation: $elm$core$Maybe$Nothing,
													software: $elm$core$Maybe$Nothing,
													userComment: $elm$core$Maybe$Nothing
												}))
									})
								])),
						content: $author$project$RichText$fromNonemptyString$(
							$lamdera$program_test$Effect$Time$utc,
							$lamdera$containers$SeqDict$empty,
							$lamdera$containers$SeqDict$empty,
							$MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('[', '!1] here\u0027s that bird I drew, now on my backpack!')),
						embeds: $elm$core$Array$empty
					},
					createdAt: $author$project$Pages$Home$previewMinutesAgo$(time, 1624),
					createdBy: $author$project$Id$fromInt(3),
					drawings: $elm$core$Maybe$Just($author$project$Pages$Home$previewDoodles),
					editedAt: $elm$core$Maybe$Nothing,
					reactions: $lamdera$containers$SeqDict$fromList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								$author$project$Emoji$EmojiOrCustomEmoji_Emoji($author$project$Emoji$heart),
								$author$project$NonemptySet$singleton(
									$author$project$Id$fromInt(1))),
								_Utils_Tuple2(
								$author$project$Emoji$EmojiOrCustomEmoji_Emoji(
									$author$project$Emoji$fromString('🐦')),
								$author$project$NonemptySet$fromNonemptyList(
									$mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
										$author$project$Id$fromInt(1),
										_List_fromArray(
											[
												$author$project$Id$fromInt(2)
											]))))
							])),
					repliedTo: $author$project$Message$NoReply
				}),
				$author$project$Message$UserTextMessage(
				{
					content: {
						attachedFiles: $lamdera$containers$SeqDict$empty,
						content: $author$project$RichText$fromNonemptyString$(
							$lamdera$program_test$Effect$Time$utc,
							$lamdera$containers$SeqDict$empty,
							$lamdera$containers$SeqDict$empty,
							$MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('b', 'ird!')),
						embeds: $elm$core$Array$empty
					},
					createdAt: $author$project$Pages$Home$previewMinutesAgo$(time, 1621),
					createdBy: $author$project$Pages$Home$previewUserId,
					drawings: $elm$core$Maybe$Nothing,
					editedAt: $elm$core$Maybe$Nothing,
					reactions: $lamdera$containers$SeqDict$empty,
					repliedTo: $author$project$Message$NoReply
				}),
				$author$project$Pages$Home$previewMessage$(
				$author$project$Pages$Home$previewMinutesAgo$(time, 1544),
				$author$project$Id$fromInt(2),
				$MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('_', 'Once upon a midnight dreary while I pondered weak and weary_')),
				$author$project$Pages$Home$previewMessage$(
				$author$project$Pages$Home$previewMinutesAgo$(time, 1543),
				$author$project$Pages$Home$previewUserId,
				$MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('#', '## *NO!*')),
				$author$project$Pages$Home$previewMessage$(
				$author$project$Pages$Home$previewMinutesAgo$(time, 1542),
				$author$project$Id$fromInt(2),
				$MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('_', 'Over many a quaint and curious volume of forgotten lore_')),
				$author$project$Pages$Home$previewMessage$(
				$author$project$Pages$Home$previewMinutesAgo$(time, 1541),
				$author$project$Id$fromInt(2),
				$MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('_', 'While I nodded, nearly napping, suddenly there came a tapping_')),
				$author$project$Pages$Home$previewMessage$(
				$author$project$Pages$Home$previewMinutesAgo$(time, 26),
				$author$project$Id$fromInt(3),
				$MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('t', 'hat\u0027s not a raven!!'))
			]));
	return {
		createdAt: $author$project$Pages$Home$previewMinutesAgo$(time, 40000),
		createdBy: $author$project$Id$fromInt(1),
		dateDividerDrawings: $lamdera$containers$SeqDict$empty,
		description: $author$project$ChannelDescription$empty,
		games: $lamdera$containers$SeqDict$empty,
		isArchived: $elm$core$Maybe$Nothing,
		messages: messages,
		name: $author$project$Pages$Home$previewChannelName,
		threads: $lamdera$containers$SeqDict$fromList(
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Id$fromInt(0),
					$author$project$Pages$Home$previewThread(
						_List_fromArray(
							[
								$author$project$Pages$Home$previewMessage$(
								$author$project$Pages$Home$previewMinutesAgo$(time, 1621),
								$author$project$Pages$Home$previewUserId,
								$MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('b', ''))
							]))),
					_Utils_Tuple2(
					$author$project$Id$fromInt(6),
					$author$project$Pages$Home$previewThread(
						_Utils_ap(
							$elm$core$List$repeat$(
								104,
								$author$project$Pages$Home$previewMessage$(
									$author$project$Pages$Home$previewMinutesAgo$(time, 1540),
									$author$project$Pages$Home$previewUserId,
									$MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('a', ''))),
							_List_fromArray(
								[
									$author$project$Pages$Home$previewMessage$(
									$author$project$Pages$Home$previewMinutesAgo$(time, 31),
									$author$project$Id$fromInt(2),
									$MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('_', 'Shall be lifted—nevermore!_'))
								]))))
				])),
		visibleMessages: $author$project$VisibleMessages$init$(
			true,
			$author$project$MessageArray$length(messages))
	};
};
var $author$project$Pages$Home$previewGuildName = $author$project$Unsafe$guildName('Friends & chat');
var $author$project$Pages$Home$previewPetPicsChannel = function (time) {
	var messages = $elm$core$List$foldl$(
		$author$project$MessageArray$push,
		$author$project$MessageArray$empty,
		_List_fromArray(
			[
				$author$project$Message$CallStarted(
				{
					cardDrawings: $author$project$Drawing$emptyDrawing,
					endedAt: $elm$core$Maybe$Nothing,
					joinedBy: $lamdera$containers$SeqSet$empty,
					reactions: $lamdera$containers$SeqDict$empty,
					recordings: $elm$core$Maybe$Nothing,
					startedAt: $author$project$Pages$Home$previewMinutesAgo$(time, 4),
					startedBy: $author$project$Id$fromInt(1),
					timestampDrawings: $author$project$Drawing$emptyDrawing
				}),
				$author$project$Pages$Home$previewMessage$(
				$author$project$Pages$Home$previewMinutesAgo$(time, 2),
				$author$project$Pages$Home$previewCallMutedPeer.a,
				$MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('C', 'an anyone hear me?')),
				$author$project$Pages$Home$previewMessage$(
				$author$project$Pages$Home$previewMinutesAgo$(time, 1),
				$author$project$Id$fromInt(3),
				$MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('Y', 'ou\u0027re muted'))
			]));
	return {
		createdAt: $author$project$Pages$Home$previewMinutesAgo$(time, 39000),
		createdBy: $author$project$Id$fromInt(1),
		dateDividerDrawings: $lamdera$containers$SeqDict$empty,
		description: $author$project$ChannelDescription$empty,
		games: $lamdera$containers$SeqDict$empty,
		isArchived: $elm$core$Maybe$Nothing,
		messages: messages,
		name: $author$project$Pages$Home$petPicsChannelName,
		threads: $lamdera$containers$SeqDict$empty,
		visibleMessages: $author$project$VisibleMessages$init$(
			true,
			$author$project$MessageArray$length(messages))
	};
};
var $author$project$Pages$Home$previewGuild = function (time) {
	return {
		channels: $lamdera$containers$SeqDict$fromList(
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Pages$Home$previewChannelId,
					$author$project$Pages$Home$previewChannel(time)),
					_Utils_Tuple2(
					$author$project$Pages$Home$previewPetPicsChannelId,
					$author$project$Pages$Home$previewPetPicsChannel(time)),
					_Utils_Tuple2(
					$author$project$Id$fromInt(2),
					{
						createdAt: $author$project$Pages$Home$previewMinutesAgo$(time, 39000),
						createdBy: $author$project$Id$fromInt(1),
						dateDividerDrawings: $lamdera$containers$SeqDict$empty,
						description: $author$project$ChannelDescription$empty,
						games: $lamdera$containers$SeqDict$empty,
						isArchived: $elm$core$Maybe$Nothing,
						messages: $author$project$MessageArray$empty,
						name: $author$project$Pages$Home$newsChannelName,
						threads: $lamdera$containers$SeqDict$empty,
						visibleMessages: $author$project$VisibleMessages$init$(true, 0)
					})
				])),
		createdAt: $author$project$Pages$Home$previewMinutesAgo$(time, 40000),
		createdBy: $author$project$Id$fromInt(1),
		icon: $elm$core$Maybe$Just(
			$author$project$FileStatus$fileHash('c_fknEBFP2Tbqh4_2NcGxm7qHXm8lRZfOpXfzg')),
		invites: $lamdera$containers$SeqDict$empty,
		lastTypedAt: $lamdera$containers$SeqDict$singleton$(
			$author$project$Id$fromInt(2),
			{
				channelId: $author$project$Pages$Home$previewChannelId,
				threadRoute: $author$project$Id$NoThreadWithMaybeMessage($elm$core$Maybe$Nothing),
				time: time
			}),
		membersAndOwner: $author$project$MembersAndOwner$init$(
			$lamdera$containers$SeqDict$insert$(
				$author$project$Pages$Home$previewUserId,
				{
					joinedAt: $author$project$Pages$Home$previewMinutesAgo$(time, 39500),
					lastPostedAt: $elm$core$Maybe$Nothing
				},
				$lamdera$containers$SeqDict$map$(
					F2(
						function (_v0, _v1) {
							return {
								joinedAt: $author$project$Pages$Home$previewMinutesAgo$(time, 39500),
								lastPostedAt: $elm$core$Maybe$Nothing
							};
						}),
					$author$project$Pages$Home$previewOtherUsers)),
			$author$project$Id$fromInt(1)),
		name: $author$project$Pages$Home$previewGuildName
	};
};
var $author$project$Pages$Home$previewTime = $lamdera$program_test$Effect$Time$millisToPosix(1790023692000);
var $author$project$User$backendToFrontendCurrent$ = function (email, user) {
	return {availableCustomEmojis: user.availableCustomEmojis, availableStickers: user.availableStickers, color: user.color, createdAt: user.createdAt, deleteAccountAt: user.deleteAccountAt, directMentions: user.directMentions, discordDirectMentions: user.discordDirectMentions, discordNotifyOnAllMessages: user.discordNotifyOnAllMessages, domainWhitelist: user.domainWhitelist, e2eeRisksAccepted: user.e2eeRisksAccepted, email: email, emailNotifications: user.emailNotifications, embedVisibility: user.embedVisibility, emojiConfig: user.emojiConfig, icon: user.icon, isAdmin: user.isAdmin, lastChannelViewed: user.lastChannelViewed, lastDiscordChannelViewed: user.lastDiscordChannelViewed, lastDmViewed: user.lastDmViewed, lastEmailNotification: user.lastEmailNotification, lastLogPageViewed: user.lastLogPageViewed, lastPushNotification: user.lastPushNotification, lastSlackChannelViewed: user.lastSlackChannelViewed, lastViewedMessage: user.lastViewedMessage, lastViewedThreadMessage: user.lastViewedThreadMessage, linkDiscordAcknowledgementIsChecked: user.linkDiscordAcknowledgementIsChecked, linkSlackAcknowledgementIsChecked: user.linkSlackAcknowledgementIsChecked, muteSettings: user.muteSettings, name: user.name, notifyOnAllMessages: user.notifyOnAllMessages, publicKey: user.publicKey, recentLoginEmails: user.recentLoginEmails, slackDirectMentions: user.slackDirectMentions, slackNotifyOnAllMessages: user.slackNotifyOnAllMessages};
};
var $author$project$User$backendToFrontendCurrent = F2($author$project$User$backendToFrontendCurrent$);
var $author$project$Unsafe$emailAddress = function (a) {
	var _v0 = $author$project$EmailAddress$fromString(a);
	if (!_v0.$) {
		var b = _v0.a;
		return b;
	} else {
		return $author$project$Unsafe$unreachable(0);
	}
};
var $author$project$Pages$Home$previewUser = function () {
	var email = $author$project$Unsafe$emailAddress('you@at-chat.app');
	var user = $author$project$User$init$(
		$lamdera$program_test$Effect$Time$millisToPosix(0),
		$author$project$Unsafe$personName('Sven Svensson'),
		$author$project$User$UserHasEmail(email),
		false);
	return $author$project$User$backendToFrontendCurrent$(
		email,
		_Utils_update(
			user,
			{
				lastViewedMessage: $lamdera$containers$SeqDict$fromList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Id$GuildOrDmId(
								$author$project$Id$GuildOrDmId_Guild(
									{channelId: $author$project$Pages$Home$previewChannelId, guildId: $author$project$Pages$Home$previewGuildId})),
							$author$project$Id$fromInt(6)),
							_Utils_Tuple2(
							$author$project$Id$GuildOrDmId(
								$author$project$Id$GuildOrDmId_Guild(
									{channelId: $author$project$Pages$Home$previewPetPicsChannelId, guildId: $author$project$Pages$Home$previewGuildId})),
							$author$project$Id$fromInt(2)),
							_Utils_Tuple2(
							$author$project$Id$GuildOrDmId(
								$author$project$Id$GuildOrDmId_Dm(
									{
										otherUserId: $author$project$Id$fromInt(1)
									})),
							$author$project$Id$fromInt(5))
						])),
				lastViewedThreadMessage: $lamdera$containers$SeqDict$fromList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							_Utils_Tuple2(
								$author$project$Id$GuildOrDmId(
									$author$project$Id$GuildOrDmId_Guild(
										{channelId: $author$project$Pages$Home$previewChannelId, guildId: $author$project$Pages$Home$previewGuildId})),
								$author$project$Id$fromInt(0)),
							$author$project$Id$fromInt(5))
						]))
			}));
}();
var $author$project$Pages$Home$previewLoginData = function (userAgent) {
	return {
		adminData: $author$project$Types$IsNotAdminLoginData,
		callRecordings: $lamdera$containers$SeqDict$empty,
		currentlyViewing: $author$project$UserSession$Viewing_None,
		customEmojis: $lamdera$containers$SeqDict$empty,
		discordDmChannels: $author$project$Pages$Home$previewDiscordDmChannels($author$project$Pages$Home$previewTime),
		discordGuilds: $author$project$Pages$Home$previewDiscordGuilds($author$project$Pages$Home$previewTime),
		discordUsers: $author$project$Pages$Home$previewDiscordUsers,
		dmChannels: $author$project$Pages$Home$previewDmChannels($author$project$Pages$Home$previewTime),
		guilds: $lamdera$containers$SeqDict$fromList(
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Pages$Home$previewGuildId,
					$author$project$Pages$Home$previewGuild($author$project$Pages$Home$previewTime)),
					_Utils_Tuple2(
					$author$project$Pages$Home$previewGameGuildId,
					$author$project$Pages$Home$previewGameGuild($author$project$Pages$Home$previewTime))
				])),
		linkedSlackUsers: $lamdera$containers$SeqDict$empty,
		otherSessions: $lamdera$containers$SeqDict$empty,
		otherUsers: $author$project$Pages$Home$previewOtherUsers,
		publicVapidKey: '',
		session: {
			expandedUserOptions: $lamdera$containers$SeqSet$empty,
			lastClientDisconnect: $elm$core$Maybe$Nothing,
			lastViewedGuild: $elm$core$Maybe$Nothing,
			notificationMode: 0,
			pushSubscription: $author$project$UserSession$NotSubscribed,
			savedSheepGameQuestions: $author$project$IdArray$empty,
			sessionIdHash: $author$project$SessionIdHash$fromString(''),
			signedInAt: $author$project$Pages$Home$previewMinutesAgo$($author$project$Pages$Home$previewTime, 120),
			userAgent: userAgent,
			userId: $author$project$Pages$Home$previewUserId
		},
		slackDmChannels: $lamdera$containers$SeqDict$empty,
		slackUsers: $lamdera$containers$SeqDict$empty,
		slackUsersNeedingAuth: $lamdera$containers$SeqSet$empty,
		slackWorkspaces: $lamdera$containers$SeqDict$empty,
		stickers: $lamdera$containers$SeqDict$empty,
		textEditor: $author$project$TextEditor$initLocalState,
		twoFactorAuthenticationEnabled: $elm$core$Maybe$Nothing,
		user: $author$project$Pages$Home$previewUser,
		voiceChatPeers: $lamdera$containers$SeqDict$empty
	};
};
var $author$project$Pages$Home$previewMicrophoneId = $author$project$IdString$fromString('previewMicrophone');
var $author$project$Pages$Home$previewReadLoginData = function (userAgent) {
	var loginData = $author$project$Pages$Home$previewLoginData(userAgent);
	var threadMessageCounts = _Utils_ap(
		$elm$core$List$concatMap$(
			function (_v5) {
				var guildId = _v5.a;
				var guild = _v5.b;
				return $elm$core$List$concatMap$(
					function (_v6) {
						var channelId = _v6.a;
						var channel = _v6.b;
						return $elm$core$List$map$(
							function (_v7) {
								var threadId = _v7.a;
								var thread = _v7.b;
								return _Utils_Tuple2(
									_Utils_Tuple2(
										$author$project$Id$GuildOrDmId(
											$author$project$Id$GuildOrDmId_Guild(
												{channelId: channelId, guildId: guildId})),
										threadId),
									$author$project$MessageArray$length(thread.messages));
							},
							$lamdera$containers$SeqDict$toList(channel.threads));
					},
					$lamdera$containers$SeqDict$toList(guild.channels));
			},
			$lamdera$containers$SeqDict$toList(loginData.guilds)),
		$elm$core$List$concatMap$(
			function (_v8) {
				var otherUserId = _v8.a;
				var dmChannel = _v8.b;
				return $elm$core$List$map$(
					function (_v9) {
						var threadId = _v9.a;
						var thread = _v9.b;
						return _Utils_Tuple2(
							_Utils_Tuple2(
								$author$project$Id$GuildOrDmId(
									$author$project$Id$GuildOrDmId_Dm(
										{otherUserId: otherUserId})),
								threadId),
							$author$project$MessageArray$length(thread.messages));
					},
					$lamdera$containers$SeqDict$toList(dmChannel.threads));
			},
			$lamdera$containers$SeqDict$toList(loginData.dmChannels)));
	var user = loginData.user;
	var lastViewed = function (messageCounts) {
		return $elm$core$List$foldl$(
			F2(
				function (_v4, acc) {
					var key = _v4.a;
					var messageCount = _v4.b;
					return (!messageCount) ? acc : $lamdera$containers$SeqDict$insert$(
						key,
						$author$project$Id$fromInt(messageCount - 1),
						acc);
				}),
			$lamdera$containers$SeqDict$empty,
			messageCounts);
	};
	var channelMessageCounts = _Utils_ap(
		$elm$core$List$concatMap$(
			function (_v0) {
				var guildId = _v0.a;
				var guild = _v0.b;
				return $elm$core$List$map$(
					function (_v1) {
						var channelId = _v1.a;
						var channel = _v1.b;
						return _Utils_Tuple2(
							$author$project$Id$GuildOrDmId(
								$author$project$Id$GuildOrDmId_Guild(
									{channelId: channelId, guildId: guildId})),
							$author$project$MessageArray$length(channel.messages));
					},
					$lamdera$containers$SeqDict$toList(guild.channels));
			},
			$lamdera$containers$SeqDict$toList(loginData.guilds)),
		_Utils_ap(
			$elm$core$List$map$(
				function (_v2) {
					var otherUserId = _v2.a;
					var dmChannel = _v2.b;
					return _Utils_Tuple2(
						$author$project$Id$GuildOrDmId(
							$author$project$Id$GuildOrDmId_Dm(
								{otherUserId: otherUserId})),
						$author$project$MessageArray$length(dmChannel.messages));
				},
				$lamdera$containers$SeqDict$toList(loginData.dmChannels)),
			$elm$core$List$map$(
				function (_v3) {
					var channelId = _v3.a;
					var dmChannel = _v3.b;
					return _Utils_Tuple2(
						$author$project$Id$DiscordGuildOrDmId(
							$author$project$Id$DiscordGuildOrDmId_Dm(
								{channelId: channelId, currentUserId: $author$project$Pages$Home$previewDiscordUserId})),
						$author$project$MessageArray$length(dmChannel.messages));
				},
				$lamdera$containers$SeqDict$toList(loginData.discordDmChannels))));
	return _Utils_update(
		loginData,
		{
			user: _Utils_update(
				user,
				{
					lastViewedMessage: lastViewed(channelMessageCounts),
					lastViewedThreadMessage: lastViewed(threadMessageCounts)
				})
		});
};
var $author$project$Pages$Home$previousPreviewButton = function (activeIndex) {
	return $author$project$MyUi$elButton$(
		$lamdera$program_test$Effect$Browser$Dom$id('homePage_previousPreview'),
		$author$project$Types$PressedHomePagePreview(
			A2(
				$elm$core$Basics$modBy,
				$elm$core$List$length($author$project$Pages$Home$previewPages),
				activeIndex - 1)),
		_List_fromArray(
			[
				$author$project$Ui$alignLeft,
				$author$project$Ui$width(
				$author$project$Ui$px(64)),
				$author$project$Ui$height($author$project$Ui$fill)
			]),
		$author$project$Ui$none);
};
var $author$project$Pages$Home$view = function (loaded) {
	var widthMax = 1280;
	var startupData = loaded.startupData;
	var previewStartupData = _Utils_update(
		startupData,
		{loadStartupDataTime: $author$project$Pages$Home$previewTime, safeAreaInsetBottom: 0, safeAreaInsetTop: 0, timeOrigin: $author$project$Pages$Home$previewTime});
	var previewReadLoggedIn = $author$project$FrontendExtra$loadedInitHelper$(
		previewStartupData,
		loaded.emojiData,
		$author$project$Pages$Home$previewReadLoginData(loaded.startupData.userAgent),
		loaded).a;
	var previewLoggedIn = $author$project$FrontendExtra$loadedInitHelper$(
		previewStartupData,
		loaded.emojiData,
		$author$project$Pages$Home$previewLoginData(loaded.startupData.userAgent),
		loaded).a;
	var isMobile = $author$project$MyUi$isMobile(loaded);
	var paddingX = isMobile ? 16 : (($author$project$Coord$xRaw(loaded.windowSize) < 800) ? 24 : 48);
	var previewWidth = $elm$core$Basics$min$(
		$author$project$Coord$xRaw(loaded.windowSize),
		widthMax) - (paddingX * 2);
	var previewContentHeight = isMobile ? 750 : 850;
	var topPadding = isMobile ? 80 : 96;
	var headingSpacing = isMobile ? 16 : 32;
	var headingHeight = 30;
	var dotsSpacing = 12;
	var dotsHeight = 28;
	var bottomPadding = 48;
	var previewHeight = $elm$core$Basics$max$(
		200,
		$elm$core$Basics$min$(
			isMobile ? 600 : 850,
			$author$project$Coord$yRaw(loaded.windowSize) - (((((topPadding + headingHeight) + headingSpacing) + dotsSpacing) + dotsHeight) + bottomPadding)));
	var previewScale = previewHeight / previewContentHeight;
	var innerSize = $author$project$Coord$xy$(
		$elm$core$Basics$round(previewWidth / previewScale),
		previewContentHeight);
	var slide = function (page) {
		return $author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$width(
					$author$project$Ui$px(previewWidth)),
					$author$project$Ui$height(
					$author$project$Ui$px(previewHeight)),
					$author$project$Ui$heightMin(0),
					$author$project$Ui$clip,
					$author$project$MyUi$noShrinking
				]),
			$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$width(
						$author$project$Ui$px(
							$author$project$Coord$xRaw(innerSize))),
						$author$project$Ui$height(
						$author$project$Ui$px(
							$author$project$Coord$yRaw(innerSize))),
						$author$project$Ui$heightMin(0),
						$author$project$MyUi$htmlStyle$(
						'zoom',
						$elm$core$String$fromFloat(previewScale)),
						$author$project$Ui$htmlAttribute(
						$elm$html$Html$Attributes$class('homepage-preview'))
					]),
				function () {
					switch (page.$) {
						case 0:
							var guildId = page.a;
							var slideRoute = page.b;
							return $author$project$Pages$Guild$guildView$(
								_Utils_update(
									loaded,
									{
										route: $author$project$Route$GuildRoute$(guildId, slideRoute, 1, $elm$core$Maybe$Nothing),
										startupData: previewStartupData,
										time: $author$project$Pages$Home$previewTime,
										windowSize: innerSize
									}),
								guildId,
								slideRoute,
								_Utils_update(
									previewLoggedIn,
									{
										games: $author$project$Pages$Home$previewGameModels($author$project$Pages$Home$previewTime),
										sidebarMode: $author$project$Route$ChannelSidebarNotDragging(
											{offset: 1})
									}),
								$author$project$Local$model(previewLoggedIn.localState));
						case 1:
							return $author$project$Pages$Guild$homePageLoggedInView$(
								$author$project$Pages$Guild$NoDmChannelSelected,
								_Utils_update(
									loaded,
									{
										route: $author$project$Route$HomePageRoute($elm$core$Maybe$Nothing),
										startupData: previewStartupData,
										windowSize: innerSize
									}),
								_Utils_update(
									previewReadLoggedIn,
									{
										sidebarMode: $author$project$Route$ChannelSidebarNotDragging(
											{offset: 1})
									}),
								$author$project$Local$model(previewReadLoggedIn.localState));
						default:
							var voiceChat = previewLoggedIn.voiceChat;
							var local = $author$project$Local$model(previewLoggedIn.localState);
							var callRoute = $author$project$Route$ChannelRoute$(
								$author$project$Pages$Home$previewPetPicsChannelId,
								$author$project$Route$NoThreadWithFriends$($elm$core$Maybe$Nothing, 1),
								$elm$core$Maybe$Just($author$project$UserSession$ChannelHeaderTab_VoiceChat));
							var callLoggedIn = _Utils_update(
								previewLoggedIn,
								{
									sidebarMode: $author$project$Route$ChannelSidebarNotDragging(
										{offset: 1}),
									voiceChat: _Utils_update(
										voiceChat,
										{
											isSpeaking: $lamdera$containers$SeqSet$singleton(
												$author$project$Pages$Home$previewCallConnectionId(
													$mgold$elm_nonempty_list$List$Nonempty$head($author$project$Pages$Home$previewCallPeers))),
											selectedAudioInputDevice: $elm$core$Maybe$Just($author$project$Pages$Home$previewMicrophoneId),
											selectedVideoInputDevice: $elm$core$Maybe$Just($author$project$Pages$Home$previewCameraId),
											userMediaDevices: $author$project$Call$HasMediaDevices(
												_List_fromArray(
													[
														{deviceId: $author$project$Pages$Home$previewMicrophoneId, groupId: '', kind: 0, label: 'Default microphone'},
														{deviceId: $author$project$Pages$Home$previewCameraId, groupId: '', kind: 1, label: 'Default camera'}
													]))
										})
								});
							var callLocal = _Utils_update(
								local,
								{
									calls: {
										currentRoom: $elm$core$Maybe$Just($author$project$Pages$Home$previewCallId),
										recordings: $lamdera$containers$SeqDict$empty,
										voiceChats: $lamdera$containers$SeqDict$singleton$(
											$author$project$Pages$Home$previewCallId,
											$author$project$NonemptyDict$fromNonemptyList(
												$mgold$elm_nonempty_list$List$Nonempty$map$(
													function (peer) {
														return _Utils_Tuple2(
															peer,
															_Utils_eq(peer, $author$project$Pages$Home$previewCallMutedPeer) ? {audioInputEnabled: false, screenShareEnabled: false, videoInputEnabled: true} : $author$project$Call$defaultRemoteCallData);
													},
													$author$project$Pages$Home$previewCallPeers)))
									}
								});
							var callLoaded = _Utils_update(
								loaded,
								{
									route: $author$project$Route$GuildRoute$($author$project$Pages$Home$previewGuildId, callRoute, 0, $elm$core$Maybe$Nothing),
									startupData: previewStartupData,
									time: $author$project$Pages$Home$previewTime,
									windowSize: innerSize
								});
							return $author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$height($author$project$Ui$fill),
										$author$project$Ui$heightMin(0),
										$author$project$Ui$inFront(
										$author$project$Ui$el$(
											_List_fromArray(
												[
													$author$project$MyUi$htmlStyle$('z-index', '21')
												]),
											$author$project$Ui$html(
												A2(
													$elm$html$Html$map,
													$author$project$Types$VoiceChatMsg,
													$author$project$Call$videoNodes$(callLocal.localUser, callLoaded, callLoggedIn, callLocal.calls)))))
									]),
								$author$project$Pages$Guild$guildView$(callLoaded, $author$project$Pages$Home$previewGuildId, callRoute, callLoggedIn, callLocal));
					}
				}()));
	};
	var activeIndex = $author$project$Pages$Home$activePreview(loaded);
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$MyUi$notoSans,
				$author$project$Ui$paddingWith(
				{bottom: bottomPadding, left: paddingX, right: paddingX, top: topPadding}),
				$author$project$Ui$widthMax(widthMax),
				$author$project$Ui$centerX,
				$author$project$Ui$spacing(headingSpacing),
				$author$project$Ui$behindContent(
				$author$project$Ui$html(
					A3(
						$elm$html$Html$node,
						'style',
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								'.homepage-preview { --guild-outline-width: ' + ($elm$core$String$fromFloat(1 / previewScale) + 'px; }'))
							]))))
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Font$size(
						isMobile ? 20 : 24),
						$author$project$Ui$attrIf$(isMobile, $author$project$Ui$contentCenterX)
					]),
				$author$project$Ui$text('A place to chat with friends')),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(dotsSpacing)
					]),
				_List_fromArray(
					[
						$author$project$Ui$el$(
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Ui$id(
									$lamdera$program_test$Effect$Browser$Dom$idToString($author$project$Pages$Home$previewContainerId)),
									$author$project$Ui$width(
									$author$project$Ui$px(previewWidth)),
									$author$project$Ui$height(
									$author$project$Ui$px(previewHeight)),
									$author$project$Ui$heightMin(0),
									$author$project$Ui$clip,
									$author$project$Ui$Shadow$shadows(
									_List_fromArray(
										[
											{
											blur: 10,
											color: $author$project$Ui$rgba$(255, 255, 255, 0.5),
											size: 0,
											x: 0,
											y: 0
										}
										]))
								]),
							($elm$core$List$length($author$project$Pages$Home$previewPages) > 1) ? _List_fromArray(
								[
									$author$project$Ui$inFront(
									$author$project$Pages$Home$previousPreviewButton(activeIndex)),
									$author$project$Ui$inFront(
									$author$project$Pages$Home$nextPreviewButton(activeIndex))
								]) : _List_Nil),
						$author$project$Ui$row$(
							_List_fromArray(
								[
									$author$project$Ui$width(
									$author$project$Ui$px(
										previewWidth * $elm$core$List$length($author$project$Pages$Home$previewPages))),
									$author$project$Ui$height(
									$author$project$Ui$px(previewHeight)),
									$author$project$Ui$heightMin(0),
									$author$project$MyUi$noPointerEvents,
									$author$project$Ui$move(
									{x: (-activeIndex) * previewWidth, y: 0, z: 0}),
									$author$project$MyUi$htmlStyle$('transition', 'translate 300ms ease-out')
								]),
							$elm$core$List$map$(slide, $author$project$Pages$Home$previewPages))),
						($elm$core$List$length($author$project$Pages$Home$previewPages) > 1) ? $author$project$Pages$Home$previewDots(activeIndex) : $author$project$Ui$none
					]))
			]));
};
var $author$project$RecoveryLogin$PressedSubmit = {$: 1};
var $author$project$RecoveryLogin$TypedPassword = function (a) {
	return {$: 0, a: a};
};
var $author$project$RecoveryLogin$errorView = function (errorMessage) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$width($author$project$Ui$shrink),
				$author$project$Ui$Font$color($author$project$MyUi$errorColor),
				$author$project$Ui$Font$weight(500)
			]),
		$author$project$Ui$text(errorMessage));
};
var $author$project$RecoveryLogin$incorrectPasswordText = 'Incorrect password';
var $author$project$RecoveryLogin$passwordInputId = $lamdera$program_test$Effect$Browser$Dom$id('recoveryLogin_passwordInput');
var $author$project$RecoveryLogin$recoveryLoginTitle = 'Recovery login';
var $author$project$RecoveryLogin$submitButtonId = $lamdera$program_test$Effect$Browser$Dom$id('recoveryLogin_submitButton');
var $author$project$RecoveryLogin$view = function (_v0) {
	var model = _v0;
	var label = $author$project$Ui$Input$label$(
		$lamdera$program_test$Effect$Browser$Dom$idToString($author$project$RecoveryLogin$passwordInputId),
		_List_fromArray(
			[
				$author$project$Ui$Font$weight(600)
			]),
		$author$project$Ui$text('Enter the recovery password'));
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$MyUi$notoSans,
				$author$project$Ui$padding(16),
				$author$project$Ui$centerX,
				$author$project$Ui$centerY,
				$author$project$Ui$widthMax(520),
				$author$project$Ui$spacing(16),
				$author$project$Ui$Font$color($author$project$MyUi$font1)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Prose$paragraph$(
				_List_fromArray(
					[
						$author$project$Ui$Font$size(30),
						$author$project$Ui$Font$weight(600)
					]),
				_List_fromArray(
					[
						$author$project$Ui$text($author$project$RecoveryLogin$recoveryLoginTitle)
					])),
				$author$project$Ui$Prose$paragraph$(
				_List_fromArray(
					[
						$author$project$Ui$Font$color($author$project$MyUi$font3),
						$author$project$Ui$Font$size(16)
					]),
				_List_fromArray(
					[
						$author$project$Ui$text('This server has no Postmark API key configured, so it can\u0027t email login codes to anyone. Enter the recovery password to log in as the admin user.')
					])),
				$author$project$MyUi$column$(
				_List_Nil,
				_List_fromArray(
					[
						label.element,
						$author$project$Ui$Input$currentPassword$(
						_List_fromArray(
							[
								$author$project$Ui$Events$onKey$($author$project$Ui$Events$enter, $author$project$RecoveryLogin$PressedSubmit),
								$author$project$Ui$background($author$project$MyUi$inputBackground),
								$author$project$Ui$Font$color($author$project$MyUi$font1),
								function () {
								var _v1 = model.submitStatus;
								if (_v1.$ === 2) {
									return $author$project$Ui$borderColor($author$project$MyUi$errorColor);
								} else {
									return $author$project$Ui$borderColor($author$project$MyUi$inputBorder);
								}
							}()
							]),
						{label: label.id, onChange: $author$project$RecoveryLogin$TypedPassword, placeholder: $elm$core$Maybe$Nothing, show: false, text: model.password})
					])),
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$width($author$project$Ui$shrink)
					]),
				$author$project$MyUi$simpleButton$(
					$author$project$RecoveryLogin$submitButtonId,
					$author$project$RecoveryLogin$PressedSubmit,
					$author$project$Ui$text('Login'))),
				function () {
				var _v2 = model.submitStatus;
				switch (_v2.$) {
					case 2:
						return $author$project$RecoveryLogin$errorView($author$project$RecoveryLogin$incorrectPasswordText);
					case 0:
						if (_v2.a) {
							return $author$project$RecoveryLogin$errorView('Enter the recovery password first');
						} else {
							return $author$project$Ui$none;
						}
					default:
						return $author$project$Ui$Prose$paragraph$(
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$text('Submitting...')
								]));
				}
			}()
			]));
};
var $author$project$Types$TypedSearchOverlay = function (a) {
	return {$: 168, a: a};
};
var $author$project$Types$PressedSearchOverlayArrowKey = function (a) {
	return {$: 169, a: a};
};
var $author$project$Types$PressedSearchOverlayEnter = {$: 170};
var $author$project$SearchOverlay$decodeKeyDown = A2(
	$elm$json$Json$Decode$andThen,
	function (key) {
		switch (key) {
			case 'ArrowDown':
				return $elm$json$Json$Decode$succeed(
					_Utils_Tuple2(
						$author$project$Types$PressedSearchOverlayArrowKey(1),
						true));
			case 'ArrowUp':
				return $elm$json$Json$Decode$succeed(
					_Utils_Tuple2(
						$author$project$Types$PressedSearchOverlayArrowKey(-1),
						true));
			case 'Enter':
				return $elm$json$Json$Decode$succeed(
					_Utils_Tuple2($author$project$Types$PressedSearchOverlayEnter, true));
			default:
				return $elm$json$Json$Decode$fail('');
		}
	},
	A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
var $author$project$Types$PressedSearchOverlayResult = function (a) {
	return {$: 171, a: a};
};
var $author$project$User$smallDiscordProfileImage$ = function (userId, maybeFileHash) {
	return $author$project$Ui$imageLazy$(
		_List_fromArray(
			[
				$author$project$Ui$rounded($author$project$User$smallProfileImageRounding),
				$author$project$Ui$width(
				$author$project$Ui$px($author$project$User$smallProfileImageSize)),
				$author$project$Ui$height(
				$author$project$Ui$px($author$project$User$smallProfileImageSize)),
				$author$project$Ui$clip
			]),
		{
			description: '',
			onLoad: $elm$core$Maybe$Nothing,
			source: function () {
				if (!maybeFileHash.$) {
					var fileHash = maybeFileHash.a;
					return $author$project$FileStatus$fileUrl$($author$project$FileStatus$pngContent, fileHash);
				} else {
					return $author$project$Discord$defaultUserAvatarUrl$(
						$author$project$Discord$TwoToNthPower(7),
						userId);
				}
			}()
		});
};
var $author$project$User$smallDiscordProfileImage = F2($author$project$User$smallDiscordProfileImage$);
var $author$project$SearchOverlay$resultView$ = function (isMobile, isSelected, index, result) {
	return $author$project$MyUi$rowButton$(
		$lamdera$program_test$Effect$Browser$Dom$id(
			'searchOverlay_result_' + $elm$core$String$fromInt(index)),
		$author$project$Types$PressedSearchOverlayResult(result.route),
		_List_fromArray(
			[
				$author$project$Ui$height(
				$author$project$Ui$px(
					$author$project$SearchOverlay$rowHeight(isMobile))),
				$author$project$MyUi$noShrinking,
				$author$project$Ui$spacing(8),
				$author$project$Ui$paddingXY$(8, 0),
				$author$project$Ui$contentCenterY,
				$author$project$MyUi$hover$(
				isMobile,
				_List_fromArray(
					[
						$author$project$Ui$Anim$backgroundColor($author$project$MyUi$hoverHighlight)
					])),
				$author$project$Ui$attrIf$(
				isSelected,
				$author$project$Ui$background($author$project$MyUi$background3))
			]),
		_List_fromArray(
			[
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$clipWithEllipsis,
						$author$project$MyUi$hoverText(result.name)
					]),
				_List_fromArray(
					[
						function () {
						var _v0 = result.icon;
						switch (_v0.$) {
							case 0:
								return $author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$width($author$project$Ui$shrink),
											$author$project$MyUi$noShrinking,
											$author$project$Ui$centerY,
											$author$project$Ui$Font$color($author$project$MyUi$font3)
										]),
									$author$project$Ui$html($author$project$Icons$hashtag));
							case 1:
								var user = _v0.a;
								return $author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$width($author$project$Ui$shrink),
											$author$project$MyUi$noShrinking,
											$author$project$Ui$centerY,
											$author$project$Ui$paddingWith(
											{bottom: 0, left: 0, right: 8, top: 0})
										]),
									$author$project$User$smallProfileImage$(false, user));
							case 2:
								var userId = _v0.a;
								var icon = _v0.b;
								return $author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$width($author$project$Ui$shrink),
											$author$project$MyUi$noShrinking,
											$author$project$Ui$centerY,
											$author$project$Ui$paddingWith(
											{bottom: 0, left: 0, right: 8, top: 0})
										]),
									$author$project$User$smallDiscordProfileImage$(userId, icon));
							default:
								var user = _v0.a;
								return $author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$width($author$project$Ui$shrink),
											$author$project$MyUi$noShrinking,
											$author$project$Ui$centerY,
											$author$project$Ui$paddingWith(
											{bottom: 0, left: 0, right: 8, top: 0})
										]),
									$author$project$User$smallProfileImage$(false, user));
						}
					}(),
						$author$project$Ui$text(result.name)
					])),
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$width($author$project$Ui$shrink),
						$author$project$Ui$widthMax(240),
						$author$project$Ui$spacing(4),
						$author$project$Ui$alignRight,
						$author$project$Ui$Font$size(14),
						$author$project$Ui$Font$color($author$project$MyUi$font3),
						$author$project$Ui$contentCenterY
					]),
				_List_fromArray(
					[
						function () {
						var _v1 = result.location;
						if (!_v1.$) {
							var location = _v1.a;
							return $author$project$Ui$el$(
								_List_fromArray(
									[$author$project$Ui$clipWithEllipsis]),
								$author$project$Ui$text(location));
						} else {
							return $author$project$Ui$none;
						}
					}(),
						function () {
						var _v2 = result.source;
						switch (_v2) {
							case 0:
								return $author$project$Ui$none;
							case 1:
								return $author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$width($author$project$Ui$shrink),
											$author$project$MyUi$noShrinking,
											$author$project$MyUi$hoverText('Discord')
										]),
									$author$project$Ui$html($author$project$Icons$discord));
							default:
								return $author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$width($author$project$Ui$shrink),
											$author$project$MyUi$noShrinking,
											$author$project$MyUi$hoverText('Slack')
										]),
									$author$project$Ui$html(
										$author$project$Icons$slack(16)));
						}
					}()
					]))
			]));
};
var $author$project$SearchOverlay$resultView = F4($author$project$SearchOverlay$resultView$);
var $author$project$SearchOverlay$view$ = function (isMobile, query, selection, results) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$behindContent(
				$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$background($author$project$MyUi$scrim),
							$author$project$Ui$height($author$project$Ui$fill),
							$author$project$Ui$Events$onClick($author$project$Types$PressedCloseOverlay)
						]),
					$author$project$Ui$none)),
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$Ui$paddingXY$(16, 16)
			]),
		$author$project$Ui$column$(
			_List_fromArray(
				[
					$author$project$Ui$centerX,
					$author$project$Ui$centerY,
					$author$project$Ui$widthMax(600),
					$author$project$Ui$height($author$project$Ui$fill),
					$author$project$Ui$heightMax(480),
					$author$project$Ui$heightMin(0),
					$author$project$Ui$background($author$project$MyUi$background2),
					$author$project$Ui$Font$color($author$project$MyUi$font2),
					$author$project$Ui$rounded(16),
					$author$project$Ui$border(1),
					$author$project$Ui$borderColor($author$project$MyUi$buttonBorder)
				]),
			_List_fromArray(
				[
					$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$borderWith(
							{bottom: 1, left: 0, right: 0, top: 0}),
							$author$project$Ui$borderColor($author$project$MyUi$buttonBorder),
							$author$project$MyUi$noShrinking,
							$author$project$Ui$inFront(
							$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$Font$color($author$project$MyUi$font3),
										$author$project$Ui$width($author$project$Ui$shrink),
										$author$project$Ui$height($author$project$Ui$fill),
										$author$project$Ui$contentCenterY,
										$author$project$Ui$paddingXY$(16, 0),
										$author$project$MyUi$noPointerEvents
									]),
								$author$project$Ui$html($author$project$Icons$magnifyingGlass)))
						]),
					A2(
						$author$project$Ui$Input$text,
						_List_fromArray(
							[
								$author$project$Ui$id(
								$lamdera$program_test$Effect$Browser$Dom$idToString($author$project$SearchOverlay$inputId)),
								$author$project$Ui$background(
								$author$project$Ui$rgba$(0, 0, 0, 0)),
								$author$project$Ui$border(0),
								$author$project$Ui$roundedWith(
								{bottomLeft: 0, bottomRight: 0, topLeft: 15, topRight: 15}),
								$author$project$Ui$paddingWith(
								{bottom: 16, left: 44, right: 16, top: 16}),
								$author$project$Ui$Font$color($author$project$MyUi$font1),
								$author$project$Ui$Font$size(18),
								$author$project$Ui$htmlAttribute(
								$elm$html$Html$Events$preventDefaultOn$('keydown', $author$project$SearchOverlay$decodeKeyDown)),
								$author$project$Ui$htmlAttribute(
								A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'off')),
								$author$project$MyUi$htmlStyle$('outline-offset', '-1px')
							]),
						{
							label: $author$project$Ui$Input$labelHidden(
								$lamdera$program_test$Effect$Browser$Dom$idToString($author$project$SearchOverlay$inputId)),
							onChange: $author$project$Types$TypedSearchOverlay,
							placeholder: $elm$core$Maybe$Just('Search channels, threads and DMs'),
							text: query
						})),
					function () {
					if (!results.b) {
						return $author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$Font$color($author$project$MyUi$font3),
									$author$project$Ui$Font$italic,
									$author$project$Ui$padding(16)
								]),
							$author$project$Ui$text('No results found'));
					} else {
						return $author$project$Ui$column$(
							_List_fromArray(
								[
									$author$project$Ui$id(
									$lamdera$program_test$Effect$Browser$Dom$idToString($author$project$SearchOverlay$resultsContainerId)),
									$author$project$Ui$scrollable,
									$author$project$Ui$heightMin(0),
									$author$project$Ui$height($author$project$Ui$fill)
								]),
							$elm$core$List$indexedMap$(
								F2(
									function (index, result) {
										return $author$project$SearchOverlay$resultView$(
											isMobile,
											_Utils_eq(index, selection),
											index,
											result);
									}),
								results));
					}
				}()
				])));
};
var $author$project$SearchOverlay$view = F4($author$project$SearchOverlay$view$);
var $author$project$TextEditor$PressedBack = {$: 4};
var $author$project$TextEditor$PressedReset = {$: 1};
var $noahzgordon$elm_color_extra$Color$Manipulate$lighten$ = function (offset, cl) {
	return $noahzgordon$elm_color_extra$Color$Manipulate$darken$(-offset, cl);
};
var $noahzgordon$elm_color_extra$Color$Manipulate$lighten = F2($noahzgordon$elm_color_extra$Color$Manipulate$lighten$);
var $author$project$TextEditor$RedoChange = {$: 3};
var $author$project$TextEditor$TypedText = function (a) {
	return {$: 0, a: a};
};
var $author$project$TextEditor$UndoChange = {$: 2};
var $author$project$TextEditor$EndRange = 2;
var $author$project$TextEditor$PointRange = 0;
var $author$project$TextEditor$StartRange = 1;
var $author$project$TextEditor$mixColors$ = function (first, rest) {
	return A2(
		$elm$html$Html$Attributes$style,
		'background',
		'repeating-linear-gradient(45deg' + ($elm$core$String$concat(
			$elm$core$List$indexedMap$(
				F2(
					function (index, color) {
						var offsetB = ' ' + ($elm$core$String$fromInt((index + 1) * 6) + 'px');
						var offsetA = ' ' + ($elm$core$String$fromInt(index * 6) + 'px,');
						var colorText = $avh4$elm_color$Color$toCssString(color);
						return (!index) ? (',' + (colorText + (',' + (colorText + offsetB)))) : (',' + (colorText + (offsetA + (colorText + offsetB))));
					}),
				A2($elm$core$List$cons, first, rest))) + ')'));
};
var $author$project$TextEditor$mixColors = F2($author$project$TextEditor$mixColors$);
var $author$project$TextEditor$userIdColor = function (userId) {
	var _v0 = A2(
		$elm$core$Basics$modBy,
		6,
		$author$project$Id$toInt(userId));
	switch (_v0) {
		case 0:
			return $avh4$elm_color$Color$rgb255$(158, 0, 0);
		case 1:
			return $avh4$elm_color$Color$rgb255$(0, 127, 0);
		case 2:
			return $avh4$elm_color$Color$rgb255$(115, 115, 0);
		case 3:
			return $avh4$elm_color$Color$rgb255$(0, 121, 121);
		case 4:
			return $avh4$elm_color$Color$rgb255$(118, 0, 118);
		default:
			return $avh4$elm_color$Color$rgb255$(147, 105, 105);
	}
};
var $author$project$TextEditor$highlightText$ = function (text, currentUserId, _v0, local) {
	var list = $lamdera$containers$SeqDict$toList(
		$lamdera$containers$SeqDict$remove$(currentUserId, local.cursorPosition));
	var _v1 = A2(
		$elm$core$List$sortBy,
		function (_v2) {
			var range = _v2.b;
			return range.start;
		},
		list);
	if (_v1.b) {
		var _v3 = _v1.a;
		var first = _v3.b;
		return function (state) {
			return _Utils_ap(
				state.html,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A3(
							$elm$core$String$slice,
							state.lastPos,
							$elm$core$String$length(text),
							text))
					]));
		}(
			$elm$core$List$foldl$(
				F2(
					function (_v6, state) {
						var userId = _v6.a;
						var pos = _v6.b;
						var isStart = _v6.c;
						if (!isStart) {
							return {
								activeSelections: state.activeSelections,
								html: _Utils_ap(
									state.html,
									_List_fromArray(
										[
											function () {
											var _v8 = state.activeSelections;
											if (_v8.b) {
												var head = _v8.a;
												var rest = _v8.b;
												return A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$TextEditor$mixColors$(
															$author$project$TextEditor$userIdColor(head),
															$elm$core$List$map$($author$project$TextEditor$userIdColor, rest))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A3($elm$core$String$slice, state.lastPos, pos, text))
														]));
											} else {
												return $elm$html$Html$text(
													A3($elm$core$String$slice, state.lastPos, pos, text));
											}
										}(),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$style, 'position', 'relative')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
															A2($elm$html$Html$Attributes$style, 'width', '4px'),
															A2($elm$html$Html$Attributes$style, 'height', '18px'),
															A2(
															$elm$html$Html$Attributes$style,
															'background-color',
															$author$project$MyUi$colorToStyle(
																$author$project$TextEditor$userIdColor(userId))),
															A2($elm$html$Html$Attributes$style, 'top', '0'),
															A2($elm$html$Html$Attributes$style, 'left', '-2px')
														]),
													_List_Nil)
												]))
										])),
								lastPos: pos
							};
						} else {
							return {
								activeSelections: function () {
									switch (isStart) {
										case 1:
											return A2($elm$core$List$cons, userId, state.activeSelections);
										case 2:
											return $elmcraft$core_extra$List$Extra$remove$(userId, state.activeSelections);
										default:
											return state.activeSelections;
									}
								}(),
								html: _Utils_ap(
									state.html,
									_List_fromArray(
										[
											function () {
											var _v10 = state.activeSelections;
											if (_v10.b) {
												var head = _v10.a;
												var rest = _v10.b;
												return A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$TextEditor$mixColors$(
															$author$project$TextEditor$userIdColor(head),
															$elm$core$List$map$($author$project$TextEditor$userIdColor, rest))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A3($elm$core$String$slice, state.lastPos, pos, text))
														]));
											} else {
												return $elm$html$Html$text(
													A3($elm$core$String$slice, state.lastPos, pos, text));
											}
										}()
										])),
								lastPos: pos
							};
						}
					}),
				{
					activeSelections: _List_Nil,
					html: _List_fromArray(
						[
							$elm$html$Html$text(
							A3($elm$core$String$slice, 0, first.start, text))
						]),
					lastPos: first.start
				},
				A2(
					$elm$core$List$sortBy,
					function (_v5) {
						var pos = _v5.b;
						return pos;
					},
					$elm$core$List$concatMap$(
						function (_v4) {
							var userId = _v4.a;
							var range = _v4.b;
							return _Utils_eq(range.start, range.end) ? _List_fromArray(
								[
									_Utils_Tuple3(userId, range.start, 0)
								]) : _List_fromArray(
								[
									_Utils_Tuple3(userId, range.start, 1),
									_Utils_Tuple3(userId, range.end, 2)
								]);
						},
						list))));
	} else {
		return _List_fromArray(
			[
				$elm$html$Html$text(text)
			]);
	}
};
var $author$project$TextEditor$highlightText = F4($author$project$TextEditor$highlightText$);
var $author$project$TextEditor$textarea$ = function (local, currentUserId, placeholderText, editorState) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'display', 'flex'),
				A2($elm$html$Html$Attributes$style, 'position', 'relative'),
				A2($elm$html$Html$Attributes$style, 'min-height', 'min-content'),
				A2($elm$html$Html$Attributes$style, 'width', '100%'),
				A2($elm$html$Html$Attributes$style, 'height', 'fit-content')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$textarea,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'color', 'rgba(255,0,0,1)'),
						A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
						A2($elm$html$Html$Attributes$style, 'font-size', 'inherit'),
						A2($elm$html$Html$Attributes$style, 'font-family', 'inherit'),
						A2($elm$html$Html$Attributes$style, 'line-height', 'inherit'),
						A2($elm$html$Html$Attributes$style, 'width', 'calc(100% - 18px)'),
						A2($elm$html$Html$Attributes$style, 'height', 'calc(100% - 2px)'),
						A2($elm$html$Html$Attributes$style, 'background-color', 'transparent'),
						A2($elm$html$Html$Attributes$style, 'border', '0'),
						A2($elm$html$Html$Attributes$style, 'resize', 'none'),
						A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
						A2($elm$html$Html$Attributes$style, 'caret-color', 'white'),
						A2($elm$html$Html$Attributes$style, 'padding', '8px'),
						A2($elm$html$Html$Attributes$style, 'outline', 'none'),
						$elm$html$Html$Events$onInput($author$project$TextEditor$TypedText),
						$elm$html$Html$Attributes$value(editorState.text),
						$lamdera$program_test$Effect$Browser$Dom$idToAttribute($author$project$TextEditor$inputId),
						$elm$html$Html$Events$preventDefaultOn$(
						'keydown',
						A2(
							$elm$json$Json$Decode$andThen,
							function (_v0) {
								var key = _v0.a;
								var ctrlHeld = _v0.b;
								var metaHeld = _v0.c;
								return ((ctrlHeld || metaHeld) && (key === 'z')) ? $elm$json$Json$Decode$succeed(
									_Utils_Tuple2($author$project$TextEditor$UndoChange, true)) : (((ctrlHeld || metaHeld) && (key === 'y')) ? $elm$json$Json$Decode$succeed(
									_Utils_Tuple2($author$project$TextEditor$RedoChange, true)) : $elm$json$Json$Decode$fail(''));
							},
							A4(
								$elm$json$Json$Decode$map3,
								F3(
									function (a, b, c) {
										return _Utils_Tuple3(a, b, c);
									}),
								A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
								A2($elm$json$Json$Decode$field, 'ctrlKey', $elm$json$Json$Decode$bool),
								A2($elm$json$Json$Decode$field, 'metaKey', $elm$json$Json$Decode$bool))))
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
						A2($elm$html$Html$Attributes$style, 'padding', '0 9px 0 9px'),
						A2($elm$html$Html$Attributes$style, 'transform', 'translateX(-1px) translateY(8px)'),
						A2($elm$html$Html$Attributes$style, 'white-space', 'pre-wrap'),
						A2($elm$html$Html$Attributes$style, 'overflow-wrap', 'anywhere'),
						A2($elm$html$Html$Attributes$style, 'height', 'fit-content'),
						A2($elm$html$Html$Attributes$style, 'min-height', '100%'),
						A2(
						$elm$html$Html$Attributes$style,
						'color',
						(editorState.text === '') ? 'rgb(180,180,180)' : 'rgb(255,255,255)')
					]),
				function () {
					var _v1 = $MartinSStewart$elm_nonempty_string$String$Nonempty$fromString(editorState.text);
					if (!_v1.$) {
						return _Utils_ap(
							$author$project$TextEditor$highlightText$(editorState.text, currentUserId, editorState, local),
							_List_fromArray(
								[
									$elm$html$Html$text('\u000A')
								]));
					} else {
						return _List_fromArray(
							[
								(placeholderText === '') ? $elm$html$Html$text(' ') : $elm$html$Html$text(placeholderText)
							]);
					}
				}())
			]));
};
var $author$project$TextEditor$textarea = F4($author$project$TextEditor$textarea$);
var $author$project$TextEditor$view$ = function (safeAreaInsetTop, safeAreaInsetBottom, currentUserId, local) {
	var editorState = $author$project$TextEditor$getEditorState(local);
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$Ui$inFront(
				$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$height($author$project$Ui$fill),
							$author$project$Ui$background(
							$author$project$Ui$rgba$(0, 0, 0, 0.4))
						]),
					$author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$centerX,
								$author$project$Ui$centerY,
								$author$project$Ui$width(
								$author$project$Ui$px(300)),
								$author$project$Ui$spacing(8)
							]),
						_List_fromArray(
							[
								$author$project$Ui$text('Sorry, this feature is incomplete! Nothing you can really do here at the moment.'),
								$author$project$MyUi$secondaryButton$(
								$lamdera$program_test$Effect$Browser$Dom$id('textEditor_back'),
								$author$project$TextEditor$PressedBack,
								'Back to homepage')
							])))),
				$author$project$Ui$paddingWith(
				{bottom: safeAreaInsetBottom, left: 0, right: 0, top: safeAreaInsetTop}),
				$author$project$Ui$inFront(
				$author$project$MyUi$elButton$(
					$lamdera$program_test$Effect$Browser$Dom$id('textEditor_reset'),
					$author$project$TextEditor$PressedReset,
					_List_fromArray(
						[
							$author$project$Ui$width($author$project$Ui$shrink),
							$author$project$Ui$alignRight,
							$author$project$Ui$paddingXY$(16, 8),
							$author$project$Ui$background($author$project$MyUi$buttonBackground),
							$author$project$Ui$border(1),
							$author$project$Ui$borderColor($author$project$MyUi$buttonBorder),
							$author$project$MyUi$htmlStyle$(
							'transform',
							'translateY(' + ($elm$core$String$fromInt(safeAreaInsetTop) + 'px)'))
						]),
					$author$project$Ui$text('Reset'))),
				$author$project$Ui$contentTop
			]),
		_List_fromArray(
			[
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$background($author$project$MyUi$background1),
						$author$project$Ui$width(
						$author$project$Ui$px(200)),
						$author$project$Ui$scrollable,
						$author$project$Ui$heightMin(0),
						$author$project$Ui$Font$size(14)
					]),
				$elm$core$List$indexedMap$(
					F2(
						function (index, _v0) {
							var changeBy = _v0.a;
							var edit = _v0.b;
							var color = $author$project$TextEditor$userIdColor(changeBy);
							return $author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$background(color),
										_Utils_eq(
										$lamdera$containers$SeqDict$get$(changeBy, local.undoPoint),
										$elm$core$Maybe$Just(index)) ? $author$project$Ui$borderColor(
										$noahzgordon$elm_color_extra$Color$Manipulate$lighten$(0.4, color)) : $author$project$Ui$borderColor(color),
										$author$project$Ui$borderWith(
										{bottom: 0, left: 4, right: 0, top: 0}),
										$author$project$Ui$paddingWith(
										{bottom: 0, left: 0, right: 4, top: 0}),
										$author$project$Ui$clipWithEllipsis
									]),
								$author$project$Ui$text(
									function () {
										var string = edit.b;
										return 'Typed \u0022' + (string + '\u0022');
									}()));
						}),
					$elm$core$Array$toList(local.history))),
				$author$project$Ui$el$(
				_List_Nil,
				$author$project$Ui$html(
					$author$project$TextEditor$textarea$(local, currentUserId, 'Nothing written yet...', editorState)))
			]));
};
var $author$project$TextEditor$view = F4($author$project$TextEditor$view$);
var $author$project$Types$E2eeKeys_Error = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$E2eeKeys_Valid = {$: 2};
var $author$project$User$HideEmbeds = 1;
var $author$project$User$NotifyMeWhenMentioned = 1;
var $author$project$UserSession$NotifyWhenRunning = 1;
var $author$project$Types$PressedDeleteAccount = {$: 102};
var $author$project$Types$PressedExpandContainer = function (a) {
	return {$: 74, a: a};
};
var $author$project$Types$PressedLoadDebugData = {$: 162};
var $author$project$Types$PressedResetDomainWhitelist = {$: 144};
var $author$project$Types$PressedResetUserColor = {$: 142};
var $author$project$Types$PressedSaveDomainWhitelist = {$: 143};
var $author$project$Types$PressedSelectNewColor = {$: 139};
var $author$project$Types$PressedSubmitSlackData = {$: 190};
var $author$project$Types$PressedSubmitUserColor = {$: 141};
var $author$project$Types$PressedUnregisterServiceWorkers = {$: 161};
var $author$project$UserSession$PushNotifications = 2;
var $author$project$Types$SelectedEmailNotifications = function (a) {
	return {$: 100, a: a};
};
var $author$project$Types$SelectedEmbedVisibility = function (a) {
	return {$: 101, a: a};
};
var $author$project$Types$SelectedNotificationMode = function (a) {
	return {$: 99, a: a};
};
var $author$project$Types$SelectedUserColor = function (a) {
	return {$: 140, a: a};
};
var $author$project$Types$TypedDiscordLinkBookmarklet = {$: 134};
var $author$project$Types$TypedDomainWhitelist = function (a) {
	return {$: 138, a: a};
};
var $author$project$Types$TypedSlackCookie = function (a) {
	return {$: 187, a: a};
};
var $author$project$Types$TypedSlackTeamsJson = function (a) {
	return {$: 188, a: a};
};
var $author$project$Types$UserNameEditableMsg = function (a) {
	return {$: 81, a: a};
};
var $author$project$UserSession$UserOption_ConnectedDevices = 5;
var $author$project$UserSession$UserOption_Debug = 6;
var $author$project$UserSession$UserOption_E2ee = 3;
var $author$project$UserSession$UserOption_Privacy = 7;
var $author$project$UserSession$UserOption_Slack = 8;
var $author$project$UserSession$UserOption_TwoFactorAuthentication = 0;
var $author$project$UserSession$UserOption_WhitelistedDomains = 2;
var $author$project$Types$ValidatedE2eePrivateKey$ = function (a, b) {
	return {$: 185, a: a, b: b};
};
var $author$project$Types$ValidatedE2eePrivateKey = F2($author$project$Types$ValidatedE2eePrivateKey$);
var $author$project$UserOptions$bookmarklet = $elm$core$String$replace$(
	'  ',
	' ',
	$elm$core$String$replace$(
		'  ',
		' ',
		$elm$core$String$replace$(
			'  ',
			' ',
			$elm$core$String$replace$('\u000A', ' ', 'javascript:(function()\u000A{\u000A    location.reload();\u000A    var i = document.createElement(\u0027iframe\u0027);\u000A    document.body.appendChild(i);\u000A    stop();\u000A    const data = JSON.stringify(\u000A        { token: i.contentWindow.localStorage.token.replaceAll(\u0022\u005C\u0022\u0022, \u0022\u0022)\u000A        , userAgent: window.navigator.userAgent\u000A        , xSuperProperties: \u0022eyJvcyI6IkxpbnV4IiwiYnJvd3NlciI6IkZpcmVmb3giLCJkZXZpY2UiOiIiLCJzeXN0ZW1fbG9jYWxlIjoiZW4tVVMiLCJoYXNfY2xpZW50X21vZHMiOmZhbHNlLCJicm93c2VyX3VzZXJfYWdlbnQiOiJNb3ppbGxhLzUuMCAoWDExOyBVYnVudHU7IExpbnV4IHg4Nl82NDsgcnY6MTQzLjApIEdlY2tvLzIwMTAwMTAxIEZpcmVmb3gvMTQzLjAiLCJicm93c2VyX3ZlcnNpb24iOiIxNDMuMCIsIm9zX3ZlcnNpb24iOiIiLCJyZWZlcnJlciI6Imh0dHBzOi8vd3d3Lmdvb2dsZS5jb20vIiwicmVmZXJyaW5nX2RvbWFpbiI6Ind3dy5nb29nbGUuY29tIiwic2VhcmNoX2VuZ2luZSI6Imdvb2dsZSIsInJlZmVycmVyX2N1cnJlbnQiOiIiLCJyZWZlcnJpbmdfZG9tYWluX2N1cnJlbnQiOiIiLCJyZWxlYXNlX2NoYW5uZWwiOiJzdGFibGUiLCJjbGllbnRfYnVpbGRfbnVtYmVyIjo0NTMyNDgsImNsaWVudF9ldmVudF9zb3VyY2UiOm51bGwsImNsaWVudF9sYXVuY2hfaWQiOiI4NzBkNjM4MC0wZDViLTQwNjYtYmI3Zi0zNThkYjRiYmI2NzgiLCJsYXVuY2hfc2lnbmF0dXJlIjoiOGY1MTYzNjItNTBlMS00NmNmLThiMjQtMmNiZDI4M2IwMjQ3IiwiY2xpZW50X2hlYXJ0YmVhdF9zZXNzaW9uX2lkIjoiNGYwNzU4YmItNjNjZS00Njk2LWFiNDUtYTA0NmNlZGIzNTk5IiwiY2xpZW50X2FwcF9zdGF0ZSI6InVuZm9jdXNlZCJ9\u0022\u000A        });\u000A    \u000A    window.location.href = \u0022' + ($author$project$Env$domain + ('/' + ($author$project$Route$linkDiscordPath + ('/?' + ($author$project$Route$linkDiscordQueryParam + '=\u0022 + encodeURIComponent(data);\u000A\u000A})()')))))))));
var $author$project$UserOptions$cancelAccountDeletionText = 'Cancel account deletion';
var $author$project$UserOptions$exampleDrawing = function (userId) {
	return {
		finished: $elm$core$List$map$(
			function (points) {
				return {
					createdBy: userId,
					points: $mgold$elm_nonempty_list$List$Nonempty$map$(
						function (_v0) {
							var x = _v0.a;
							var y = _v0.b;
							return _Utils_Tuple2(
								$elm$core$Result$withDefault$(
									$author$project$SafeFloat$zero,
									$author$project$SafeFloat$fromFloat(x + 20)),
								$elm$core$Result$withDefault$(
									$author$project$SafeFloat$zero,
									$author$project$SafeFloat$fromFloat(y + 10)));
						},
						points)
				};
			},
			_List_fromArray(
				[
					$mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
					_Utils_Tuple2(205, 28.503),
					_List_fromArray(
						[
							_Utils_Tuple2(205, 28.503),
							_Utils_Tuple2(205, 27.5),
							_Utils_Tuple2(205, 25.5),
							_Utils_Tuple2(205, 22.497),
							_Utils_Tuple2(205, 19.503),
							_Utils_Tuple2(205, 16.5),
							_Utils_Tuple2(205, 13.501),
							_Utils_Tuple2(205, 11.501),
							_Utils_Tuple2(205, 10.499)
						])),
					$mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
					_Utils_Tuple2(204.4, 35.5),
					_List_fromArray(
						[
							_Utils_Tuple2(204.4, 34.5),
							_Utils_Tuple2(204.4, 34.5),
							_Utils_Tuple2(204.4, 34.5),
							_Utils_Tuple2(204.4, 34.5),
							_Utils_Tuple2(204.6, 34.5),
							_Utils_Tuple2(204.6, 34.5),
							_Utils_Tuple2(204.6, 34.5),
							_Utils_Tuple2(204.6, 34.5),
							_Utils_Tuple2(204.6, 34.5),
							_Utils_Tuple2(204.6, 33.5),
							_Utils_Tuple2(204.6, 33.5),
							_Utils_Tuple2(204.6, 33.5),
							_Utils_Tuple2(204.6, 33.5),
							_Utils_Tuple2(204.6, 33.5),
							_Utils_Tuple2(204.6, 33.5),
							_Utils_Tuple2(204.6, 33.5),
							_Utils_Tuple2(204.6, 33.5)
						])),
					$mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
					_Utils_Tuple2(184.2, 17.5),
					_List_fromArray(
						[
							_Utils_Tuple2(184.4, 17.5),
							_Utils_Tuple2(184.6, 17.5),
							_Utils_Tuple2(185.6, 17.5),
							_Utils_Tuple2(187.2, 17.5),
							_Utils_Tuple2(189, 17.5),
							_Utils_Tuple2(190.8, 17.5),
							_Utils_Tuple2(192.2, 17.5),
							_Utils_Tuple2(193.8, 17.5),
							_Utils_Tuple2(194.6, 17.5),
							_Utils_Tuple2(195.2, 17.5),
							_Utils_Tuple2(195.4, 17.5),
							_Utils_Tuple2(195.6, 17.5),
							_Utils_Tuple2(195.6, 17.5)
						])),
					$mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
					_Utils_Tuple2(190.4, 35.5),
					_List_fromArray(
						[
							_Utils_Tuple2(190.4, 35.5),
							_Utils_Tuple2(190.4, 34.5),
							_Utils_Tuple2(190.4, 33.5),
							_Utils_Tuple2(190.4, 31.503),
							_Utils_Tuple2(190.4, 29.5),
							_Utils_Tuple2(190.4, 27.503),
							_Utils_Tuple2(190.4, 25.5),
							_Utils_Tuple2(190.4, 24.5),
							_Utils_Tuple2(190.4, 22.497),
							_Utils_Tuple2(190.4, 21.5),
							_Utils_Tuple2(190.4, 20.5),
							_Utils_Tuple2(190.4, 19.503),
							_Utils_Tuple2(190.4, 17.497),
							_Utils_Tuple2(190.4, 16.5),
							_Utils_Tuple2(190.4, 15.497),
							_Utils_Tuple2(190.4, 15.499),
							_Utils_Tuple2(190.4, 15.503),
							_Utils_Tuple2(190.4, 15.503),
							_Utils_Tuple2(190.4, 15.5),
							_Utils_Tuple2(190.4, 15.5),
							_Utils_Tuple2(190.4, 14.497),
							_Utils_Tuple2(190.4, 14.503),
							_Utils_Tuple2(190.4, 13.501),
							_Utils_Tuple2(190.4, 13.503),
							_Utils_Tuple2(190.4, 13.5),
							_Utils_Tuple2(190.4, 12.497),
							_Utils_Tuple2(190.4, 12.497)
						])),
					$mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
					_Utils_Tuple2(182, 35.5),
					_List_fromArray(
						[
							_Utils_Tuple2(182, 35.5),
							_Utils_Tuple2(182, 34.5),
							_Utils_Tuple2(182, 34.5),
							_Utils_Tuple2(182, 33.5),
							_Utils_Tuple2(182, 32.5),
							_Utils_Tuple2(182, 31.503),
							_Utils_Tuple2(182, 30.503),
							_Utils_Tuple2(181.8, 29.5),
							_Utils_Tuple2(181.6, 28.5),
							_Utils_Tuple2(181.4, 27.5),
							_Utils_Tuple2(181.2, 26.497),
							_Utils_Tuple2(180.8, 26.503),
							_Utils_Tuple2(180.6, 25.497),
							_Utils_Tuple2(180.4, 25.5),
							_Utils_Tuple2(180.2, 25.5),
							_Utils_Tuple2(180, 24.5),
							_Utils_Tuple2(180, 24.503),
							_Utils_Tuple2(179.8, 24.5),
							_Utils_Tuple2(179.4, 23.497),
							_Utils_Tuple2(179, 23.5),
							_Utils_Tuple2(178.6, 23.503),
							_Utils_Tuple2(177.8, 22.497),
							_Utils_Tuple2(177.6, 22.5),
							_Utils_Tuple2(176.8, 22.5),
							_Utils_Tuple2(176.8, 22.5),
							_Utils_Tuple2(176.6, 22.5),
							_Utils_Tuple2(176.2, 22.5),
							_Utils_Tuple2(176, 22.5),
							_Utils_Tuple2(175.8, 22.5),
							_Utils_Tuple2(175.4, 22.5),
							_Utils_Tuple2(175.2, 22.5),
							_Utils_Tuple2(175, 22.497),
							_Utils_Tuple2(174.8, 23.503),
							_Utils_Tuple2(174.8, 23.503),
							_Utils_Tuple2(174.6, 23.5),
							_Utils_Tuple2(174.6, 23.5),
							_Utils_Tuple2(174.4, 24.5),
							_Utils_Tuple2(174.2, 24.5),
							_Utils_Tuple2(174, 25.5),
							_Utils_Tuple2(173.8, 25.5),
							_Utils_Tuple2(173.6, 26.503),
							_Utils_Tuple2(173.6, 26.5),
							_Utils_Tuple2(173.6, 27.503),
							_Utils_Tuple2(173.4, 28.5),
							_Utils_Tuple2(173.4, 28.5),
							_Utils_Tuple2(173.4, 29.503),
							_Utils_Tuple2(173.4, 29.5),
							_Utils_Tuple2(173.4, 30.503),
							_Utils_Tuple2(173.4, 30.5),
							_Utils_Tuple2(173.4, 30.497),
							_Utils_Tuple2(173.4, 31.503),
							_Utils_Tuple2(173.4, 31.5),
							_Utils_Tuple2(173.4, 31.5),
							_Utils_Tuple2(173.4, 31.497),
							_Utils_Tuple2(173.4, 32.5),
							_Utils_Tuple2(173.6, 32.5),
							_Utils_Tuple2(173.6, 32.5),
							_Utils_Tuple2(173.8, 32.5),
							_Utils_Tuple2(174.2, 32.5),
							_Utils_Tuple2(174.4, 32.5),
							_Utils_Tuple2(174.8, 33.5),
							_Utils_Tuple2(175, 33.5),
							_Utils_Tuple2(175.2, 33.5),
							_Utils_Tuple2(175.4, 33.5),
							_Utils_Tuple2(175.6, 33.5),
							_Utils_Tuple2(176, 33.5),
							_Utils_Tuple2(176.4, 33.5),
							_Utils_Tuple2(176.8, 33.5),
							_Utils_Tuple2(177.2, 33.5),
							_Utils_Tuple2(177.6, 33.5),
							_Utils_Tuple2(178, 33.5),
							_Utils_Tuple2(178.2, 33.5),
							_Utils_Tuple2(178.6, 33.5),
							_Utils_Tuple2(178.8, 33.5),
							_Utils_Tuple2(179, 33.5),
							_Utils_Tuple2(179.2, 33.5),
							_Utils_Tuple2(179.4, 33.5),
							_Utils_Tuple2(179.6, 32.5),
							_Utils_Tuple2(179.8, 32.5),
							_Utils_Tuple2(180, 32.5),
							_Utils_Tuple2(180.4, 32.5),
							_Utils_Tuple2(180.4, 32.5),
							_Utils_Tuple2(180.4, 32.5),
							_Utils_Tuple2(180.6, 32.5),
							_Utils_Tuple2(180.6, 32.5),
							_Utils_Tuple2(180.8, 32.5),
							_Utils_Tuple2(180.8, 32.5),
							_Utils_Tuple2(180.8, 32.5),
							_Utils_Tuple2(181, 32.5),
							_Utils_Tuple2(181, 31.497)
						])),
					$mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
					_Utils_Tuple2(157.8, 35.5),
					_List_fromArray(
						[
							_Utils_Tuple2(157.8, 35.5),
							_Utils_Tuple2(157.8, 34.5),
							_Utils_Tuple2(157.8, 33.5),
							_Utils_Tuple2(157.8, 32.5),
							_Utils_Tuple2(157.6, 31.5),
							_Utils_Tuple2(157.8, 30.503),
							_Utils_Tuple2(158.2, 29.503),
							_Utils_Tuple2(158.4, 28.5),
							_Utils_Tuple2(158.8, 28.5),
							_Utils_Tuple2(159.4, 27.503),
							_Utils_Tuple2(160, 26.5),
							_Utils_Tuple2(160.4, 25.497),
							_Utils_Tuple2(160.8, 25.503),
							_Utils_Tuple2(161, 24.5),
							_Utils_Tuple2(161.4, 24.5),
							_Utils_Tuple2(161.6, 24.5),
							_Utils_Tuple2(161.8, 23.497),
							_Utils_Tuple2(162, 23.5),
							_Utils_Tuple2(162.2, 23.5),
							_Utils_Tuple2(162.4, 23.5),
							_Utils_Tuple2(162.6, 23.5),
							_Utils_Tuple2(162.8, 23.5),
							_Utils_Tuple2(163.2, 23.5),
							_Utils_Tuple2(163.6, 23.5),
							_Utils_Tuple2(163.8, 23.5),
							_Utils_Tuple2(164.2, 23.5),
							_Utils_Tuple2(164.4, 23.5),
							_Utils_Tuple2(164.6, 23.5),
							_Utils_Tuple2(164.8, 23.5),
							_Utils_Tuple2(165, 23.5),
							_Utils_Tuple2(165.2, 23.497),
							_Utils_Tuple2(165.4, 24.503),
							_Utils_Tuple2(165.8, 24.5),
							_Utils_Tuple2(166.2, 25.5),
							_Utils_Tuple2(166.4, 25.5),
							_Utils_Tuple2(166.8, 26.5),
							_Utils_Tuple2(167.2, 26.5),
							_Utils_Tuple2(167.6, 27.5),
							_Utils_Tuple2(168, 27.5),
							_Utils_Tuple2(168.2, 28.5),
							_Utils_Tuple2(168.4, 28.5),
							_Utils_Tuple2(168.8, 29.5),
							_Utils_Tuple2(168.8, 29.5),
							_Utils_Tuple2(169, 30.503),
							_Utils_Tuple2(169.2, 30.497),
							_Utils_Tuple2(169.2, 31.503),
							_Utils_Tuple2(169.4, 31.497),
							_Utils_Tuple2(169.4, 32.5),
							_Utils_Tuple2(169.4, 32.5),
							_Utils_Tuple2(169.4, 32.5),
							_Utils_Tuple2(169.4, 33.5),
							_Utils_Tuple2(169.4, 33.5),
							_Utils_Tuple2(169.4, 33.5),
							_Utils_Tuple2(169.4, 33.5),
							_Utils_Tuple2(169.4, 33.5),
							_Utils_Tuple2(169.4, 33.5),
							_Utils_Tuple2(169.4, 34.5),
							_Utils_Tuple2(169.4, 34.5)
						])),
					$mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
					_Utils_Tuple2(157.6, 35.5),
					_List_fromArray(
						[
							_Utils_Tuple2(157.6, 35.5),
							_Utils_Tuple2(157.6, 35.5),
							_Utils_Tuple2(157.6, 33.5),
							_Utils_Tuple2(157.6, 31.5),
							_Utils_Tuple2(157.6, 27.503),
							_Utils_Tuple2(157.6, 22.5),
							_Utils_Tuple2(157.6, 18.5),
							_Utils_Tuple2(157.6, 15.497),
							_Utils_Tuple2(157.6, 14.5),
							_Utils_Tuple2(157.6, 13.503),
							_Utils_Tuple2(157.6, 12.497),
							_Utils_Tuple2(157.6, 12.501),
							_Utils_Tuple2(157.6, 12.499),
							_Utils_Tuple2(157.6, 12.503),
							_Utils_Tuple2(157.6, 12.5),
							_Utils_Tuple2(157.6, 11.497),
							_Utils_Tuple2(157.8, 11.501),
							_Utils_Tuple2(157.8, 11.499),
							_Utils_Tuple2(157.8, 11.499)
						])),
					$mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
					_Utils_Tuple2(151.2, 37.5),
					_List_fromArray(
						[
							_Utils_Tuple2(151, 37.5),
							_Utils_Tuple2(150.6, 37.5),
							_Utils_Tuple2(150, 37.5),
							_Utils_Tuple2(149.2, 37.5),
							_Utils_Tuple2(148.2, 37.5),
							_Utils_Tuple2(147.4, 37.5),
							_Utils_Tuple2(146.8, 37.5),
							_Utils_Tuple2(146.4, 37.5),
							_Utils_Tuple2(145.8, 37.5),
							_Utils_Tuple2(145.4, 37.5),
							_Utils_Tuple2(144.8, 36.5),
							_Utils_Tuple2(144, 36.5),
							_Utils_Tuple2(143.4, 35.5),
							_Utils_Tuple2(142.8, 35.5),
							_Utils_Tuple2(142.4, 34.5),
							_Utils_Tuple2(142, 34.5),
							_Utils_Tuple2(141.6, 34.5),
							_Utils_Tuple2(141.4, 33.5),
							_Utils_Tuple2(141.2, 33.5),
							_Utils_Tuple2(141.2, 33.5),
							_Utils_Tuple2(141, 32.5),
							_Utils_Tuple2(141, 32.5),
							_Utils_Tuple2(141, 31.5),
							_Utils_Tuple2(141, 31.503),
							_Utils_Tuple2(141, 30.5),
							_Utils_Tuple2(141.2, 30.503),
							_Utils_Tuple2(141.4, 29.497),
							_Utils_Tuple2(141.8, 29.5),
							_Utils_Tuple2(142.6, 29.5),
							_Utils_Tuple2(143.4, 28.5),
							_Utils_Tuple2(144.2, 28.5),
							_Utils_Tuple2(145.2, 27.5),
							_Utils_Tuple2(146.6, 26.5),
							_Utils_Tuple2(147.2, 26.503),
							_Utils_Tuple2(147.6, 26.503),
							_Utils_Tuple2(148.2, 26.5),
							_Utils_Tuple2(149.4, 25.497),
							_Utils_Tuple2(150, 25.5),
							_Utils_Tuple2(150.8, 25.5),
							_Utils_Tuple2(151.2, 25.5),
							_Utils_Tuple2(151.6, 25.5),
							_Utils_Tuple2(151.8, 25.5),
							_Utils_Tuple2(152, 25.5)
						])),
					$mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
					_Utils_Tuple2(126.6, 28.503),
					_List_fromArray(
						[
							_Utils_Tuple2(126.6, 28.503),
							_Utils_Tuple2(126.01, 28.503),
							_Utils_Tuple2(127.99, 28.503),
							_Utils_Tuple2(127.01, 28.503),
							_Utils_Tuple2(128.8, 28.503),
							_Utils_Tuple2(129.6, 28.503),
							_Utils_Tuple2(130.2, 28.503),
							_Utils_Tuple2(131.6, 28.503),
							_Utils_Tuple2(132, 28.503),
							_Utils_Tuple2(132.4, 28.503),
							_Utils_Tuple2(132.6, 28.503),
							_Utils_Tuple2(132.6, 28.503)
						])),
					$mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
					_Utils_Tuple2(109.6, 22.497),
					_List_fromArray(
						[
							_Utils_Tuple2(109.8, 22.497),
							_Utils_Tuple2(111, 22.497),
							_Utils_Tuple2(112.8, 22.497),
							_Utils_Tuple2(115.2, 22.497),
							_Utils_Tuple2(117.6, 22.497),
							_Utils_Tuple2(119.2, 22.497),
							_Utils_Tuple2(120.6, 22.497),
							_Utils_Tuple2(122, 22.497),
							_Utils_Tuple2(122.01, 22.497),
							_Utils_Tuple2(123.4, 22.497),
							_Utils_Tuple2(123.01, 22.497),
							_Utils_Tuple2(123.01, 22.497),
							_Utils_Tuple2(124, 22.497),
							_Utils_Tuple2(124.99, 22.497)
						])),
					$mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
					_Utils_Tuple2(117.4, 17.503),
					_List_fromArray(
						[
							_Utils_Tuple2(117.4, 17.5),
							_Utils_Tuple2(117.4, 18.5),
							_Utils_Tuple2(117.4, 20.5),
							_Utils_Tuple2(117.4, 21.5),
							_Utils_Tuple2(117.4, 22.497),
							_Utils_Tuple2(117.4, 25.5),
							_Utils_Tuple2(117.4, 26.5),
							_Utils_Tuple2(117.4, 27.503),
							_Utils_Tuple2(117.4, 28.5),
							_Utils_Tuple2(117.4, 30.5),
							_Utils_Tuple2(117.4, 31.5),
							_Utils_Tuple2(117.4, 32.5),
							_Utils_Tuple2(117.6, 34.5),
							_Utils_Tuple2(117.6, 35.5),
							_Utils_Tuple2(117.8, 36.5),
							_Utils_Tuple2(118, 36.5),
							_Utils_Tuple2(118, 37.5),
							_Utils_Tuple2(118, 37.5),
							_Utils_Tuple2(118.2, 37.5),
							_Utils_Tuple2(118.2, 37.5),
							_Utils_Tuple2(118.2, 37.5)
						])),
					$mgold$elm_nonempty_list$List$Nonempty$Nonempty$(
					_Utils_Tuple2(111, 37.5),
					_List_fromArray(
						[
							_Utils_Tuple2(111, 37.5),
							_Utils_Tuple2(111, 37.5),
							_Utils_Tuple2(111, 36.5),
							_Utils_Tuple2(111, 35.5),
							_Utils_Tuple2(110.6, 35.5),
							_Utils_Tuple2(110, 34.5),
							_Utils_Tuple2(109.4, 33.5),
							_Utils_Tuple2(108.8, 32.5),
							_Utils_Tuple2(108.2, 31.503),
							_Utils_Tuple2(107.6, 30.5),
							_Utils_Tuple2(107.2, 30.5),
							_Utils_Tuple2(107, 29.5),
							_Utils_Tuple2(106.6, 29.5),
							_Utils_Tuple2(106.4, 28.5),
							_Utils_Tuple2(106.2, 28.5),
							_Utils_Tuple2(105.8, 27.5),
							_Utils_Tuple2(105.4, 27.503),
							_Utils_Tuple2(105, 26.5),
							_Utils_Tuple2(104.6, 26.5),
							_Utils_Tuple2(104, 25.5),
							_Utils_Tuple2(103.6, 25.503),
							_Utils_Tuple2(103.2, 25.5),
							_Utils_Tuple2(102.6, 24.497),
							_Utils_Tuple2(102.2, 24.5),
							_Utils_Tuple2(101.6, 24.5),
							_Utils_Tuple2(101.2, 24.5),
							_Utils_Tuple2(100.8, 24.5),
							_Utils_Tuple2(100.4, 24.5),
							_Utils_Tuple2(100.2, 24.5),
							_Utils_Tuple2(100, 24.5),
							_Utils_Tuple2(99.4, 24.497),
							_Utils_Tuple2(99, 25.5),
							_Utils_Tuple2(98.8, 25.5),
							_Utils_Tuple2(98.4, 26.5),
							_Utils_Tuple2(98.4, 26.5),
							_Utils_Tuple2(98.2, 27.503),
							_Utils_Tuple2(98, 27.497),
							_Utils_Tuple2(98, 28.5),
							_Utils_Tuple2(97.8, 29.5),
							_Utils_Tuple2(97.8, 30.503),
							_Utils_Tuple2(97.8, 31.5),
							_Utils_Tuple2(97.8, 31.497),
							_Utils_Tuple2(97.8, 32.5),
							_Utils_Tuple2(97.8, 33.5),
							_Utils_Tuple2(97.8, 33.5),
							_Utils_Tuple2(98, 34.5),
							_Utils_Tuple2(98, 34.5),
							_Utils_Tuple2(98, 34.5),
							_Utils_Tuple2(98.2, 35.5),
							_Utils_Tuple2(98.4, 35.5),
							_Utils_Tuple2(98.6, 36.5),
							_Utils_Tuple2(98.8, 36.5),
							_Utils_Tuple2(99, 36.5),
							_Utils_Tuple2(99.2, 37.5),
							_Utils_Tuple2(99.6, 37.5),
							_Utils_Tuple2(99.8, 37.5),
							_Utils_Tuple2(100.2, 37.5),
							_Utils_Tuple2(100.6, 37.5),
							_Utils_Tuple2(101.2, 37.5),
							_Utils_Tuple2(101.8, 37.5),
							_Utils_Tuple2(102.2, 37.5),
							_Utils_Tuple2(102.8, 37.5),
							_Utils_Tuple2(103.2, 37.5),
							_Utils_Tuple2(103.8, 37.5),
							_Utils_Tuple2(104.2, 36.5),
							_Utils_Tuple2(104.8, 36.5),
							_Utils_Tuple2(105.4, 36.5),
							_Utils_Tuple2(106, 35.5),
							_Utils_Tuple2(106.4, 35.5),
							_Utils_Tuple2(106.8, 35.5),
							_Utils_Tuple2(107.2, 34.5),
							_Utils_Tuple2(107.4, 34.5),
							_Utils_Tuple2(107.6, 34.5),
							_Utils_Tuple2(107.8, 34.5),
							_Utils_Tuple2(108, 34.5),
							_Utils_Tuple2(108, 33.5),
							_Utils_Tuple2(108.2, 33.5),
							_Utils_Tuple2(108.4, 33.5),
							_Utils_Tuple2(108.4, 33.5),
							_Utils_Tuple2(108.6, 33.5),
							_Utils_Tuple2(108.6, 33.5),
							_Utils_Tuple2(108.6, 33.5),
							_Utils_Tuple2(108.6, 33.5),
							_Utils_Tuple2(108.6, 33.5),
							_Utils_Tuple2(108.6, 33.5),
							_Utils_Tuple2(108.6, 33.5)
						]))
				])),
		inProgress: $lamdera$containers$SeqDict$empty,
		undone: $lamdera$containers$SeqDict$empty
	};
};
var $author$project$Message$userTextMessageNoEmbeds$ = function (createdAt2, createdBy, content, reactions, repliedTo2, attachedFiles) {
	return {
		content: {attachedFiles: attachedFiles, content: content, embeds: $elm$core$Array$empty},
		createdAt: createdAt2,
		createdBy: createdBy,
		drawings: $elm$core$Maybe$Nothing,
		editedAt: $elm$core$Maybe$Nothing,
		reactions: reactions,
		repliedTo: repliedTo2
	};
};
var $author$project$Message$userTextMessageNoEmbeds = F6($author$project$Message$userTextMessageNoEmbeds$);
var $author$project$UserOptions$colorPreview$ = function (time, isMobile, local, allUsers, color) {
	var message = $author$project$Message$userTextMessageNoEmbeds$(
		time,
		local.localUser.session.userId,
		$author$project$RichText$fromNonemptyString$(
			local.localUser.timezone,
			allUsers,
			$lamdera$containers$SeqDict$empty,
			$MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString$('#', '# Hello')),
		$lamdera$containers$SeqDict$empty,
		$author$project$Message$NoReply,
		$lamdera$containers$SeqDict$empty);
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$background($author$project$MyUi$background3),
				$author$project$Ui$widthMax(400),
				$author$project$Ui$paddingXY$(8, 4)
			]),
		A2(
			$author$project$Ui$map,
			function (_v1) {
				return $author$project$Types$FrontendNoOp;
			},
			$author$project$Pages$Guild$userTextMessageContent$(
				time,
				$lamdera$program_test$Effect$Browser$Dom$id('userOptions_colorPreviewSpoiler'),
				200,
				false,
				isMobile,
				$elm$core$Maybe$Nothing,
				local.localUser,
				$lamdera$containers$SeqDict$empty,
				$lamdera$containers$SeqDict$fromList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							local.localUser.session.userId,
							{color: color, icon: local.localUser.user.icon, name: local.localUser.user.name, publicKey: $elm$core$Maybe$Nothing})
						])),
				$lamdera$containers$SeqDict$empty,
				function (_v0) {
					return color;
				},
				$author$project$Pages$Guild$IsNotHovered,
				$author$project$Id$fromInt(0),
				message.content,
				false,
				_Utils_update(
					message,
					{
						drawings: $elm$core$Maybe$Just(
							{
								embedDrawings: $lamdera$containers$SeqDict$empty,
								imageAttachmentDrawings: $lamdera$containers$SeqDict$empty,
								timestampDrawings: $author$project$Drawing$emptyDrawing,
								userIconDrawings: $author$project$UserOptions$exampleDrawing(local.localUser.session.userId)
							})
					}))));
};
var $author$project$UserOptions$colorPreview = F5($author$project$UserOptions$colorPreview$);
var $author$project$UserOptions$currentColorSquare = function (color) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$id(
				$lamdera$program_test$Effect$Browser$Dom$idToString(
					$lamdera$program_test$Effect$Browser$Dom$id('userOptions_currentColor'))),
				$author$project$Ui$width(
				$author$project$Ui$px(40)),
				$author$project$Ui$height(
				$author$project$Ui$px(40)),
				$author$project$Ui$alignTop,
				$author$project$Ui$rounded(3),
				$author$project$Ui$border(1),
				$author$project$Ui$borderColor($author$project$MyUi$border1),
				$author$project$Ui$background(
				$author$project$UserColor$toColor(color))
			]),
		$author$project$Ui$none);
};
var $author$project$UserOptions$deleteAccountButtonId = $lamdera$program_test$Effect$Browser$Dom$id('userOptions_deleteAccount');
var $author$project$Types$PressedDiscordAcknowledgment = function (a) {
	return {$: 129, a: a};
};
var $author$project$UserOptions$numberPoint$ = function (index, content) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[$author$project$Ui$contentTop]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$MyUi$noShrinking,
						$author$project$Ui$width(
						$author$project$Ui$px(24))
					]),
				$author$project$Ui$text(
					$elm$core$String$fromInt(index) + '.')),
				content
			]));
};
var $author$project$UserOptions$numberPoint = F2($author$project$UserOptions$numberPoint$);
var $author$project$UserOptions$discordAcknowledgement = function (discordAcknowledged) {
	var acknowledgmentLabel = $author$project$Ui$Input$label$(
		'userOptions_discordAcknowledgment',
		_List_fromArray(
			[
				$author$project$Ui$paddingWith(
				{bottom: 0, left: 16, right: 0, top: 0}),
				$author$project$Ui$pointer,
				$author$project$Ui$width($author$project$Ui$shrink)
			]),
		$author$project$Ui$text('I have read the above and accept the risks'));
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(16),
				$author$project$Ui$attrIf$(
				discordAcknowledged,
				$author$project$Ui$opacity(0.5))
			]),
		_List_fromArray(
			[
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(8)
					]),
				_List_fromArray(
					[
						$author$project$MyUi$warningHeader('Before you link your Discord account, please note:'),
						$author$project$UserOptions$numberPoint$(
						1,
						$author$project$Ui$text('Using your Discord account via a 3rd party client breaks their terms of service. Discord can temporarily or even permanently ban your account for it. In practice this doesn\u0027t seem to happen as long as you don\u0027t act like a spam bot but the risk is still present.')),
						$author$project$UserOptions$numberPoint$(
						2,
						$author$project$Ui$text('Discord doesn\u0027t have any permission system for 3rd party clients. This means that if you link your Discord account with this app, you are giving us complete access to your data and to act on your behalf. You are trusting us to not abuse that level of access or accidentally let hackers access your account.'))
					])),
				$author$project$Ui$row$(
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Input$checkbox$(
						_List_Nil,
						{checked: discordAcknowledged, icon: $elm$core$Maybe$Nothing, label: acknowledgmentLabel.id, onChange: $author$project$Types$PressedDiscordAcknowledgment}),
						acknowledgmentLabel.element
					]))
			]));
};
var $author$project$Types$PressedReloadDiscordUser = function (a) {
	return {$: 131, a: a};
};
var $author$project$Types$PressedUnlinkDiscordUser = function (a) {
	return {$: 132, a: a};
};
var $author$project$UserOptions$loadingUserDataText = 'Loading data (can take a while)';
var $author$project$UserOptions$discordUserCard$ = function (loaded, discordUserId, data) {
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8),
				$author$project$Ui$padding(12),
				$author$project$Ui$border(1),
				$author$project$Ui$borderColor($author$project$MyUi$border1),
				$author$project$Ui$rounded(8),
				$author$project$Ui$widthMax(400)
			]),
		_List_fromArray(
			[
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(8)
					]),
				_List_fromArray(
					[
						$author$project$User$discordProfileImage$(discordUserId, data.icon),
						$author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$spacing(2)
							]),
						_List_fromArray(
							[
								$author$project$Ui$text(
								$author$project$PersonName$toString(data.name)),
								function () {
								var _v0 = data.email;
								if (!_v0.$) {
									var email = _v0.a;
									return $author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$Font$size(14),
												$author$project$Ui$Font$color($author$project$MyUi$font3)
											]),
										$author$project$Ui$text(
											$author$project$EmailAddress$toString(email)));
								} else {
									return $author$project$Ui$none;
								}
							}()
							]))
					])),
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Font$size(13),
						$author$project$Ui$Font$color($author$project$MyUi$font3)
					]),
				$author$project$Ui$text(
					'Linked ' + $author$project$Log$timeToString$(loaded.timezone, true, data.linkedAt))),
				data.needsAuthAgain ? $author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Font$color($author$project$MyUi$errorColor),
						$author$project$Ui$Font$size(14)
					]),
				$author$project$Ui$text('This account needs to be linked again before you can use it')) : $author$project$Ui$none,
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(8)
					]),
				_List_fromArray(
					[
						data.needsAuthAgain ? $author$project$Ui$none : $author$project$MyUi$elButton$(
						$lamdera$program_test$Effect$Browser$Dom$id(
							'userOptions_relinkDiscord_' + $author$project$PersonName$toString(data.name)),
						function () {
							var _v1 = data.isLoadingData;
							if (_v1.$ === 1) {
								return $author$project$Types$FrontendNoOp;
							} else {
								return $author$project$Types$PressedReloadDiscordUser(discordUserId);
							}
						}(),
						_List_fromArray(
							[
								$author$project$Ui$background($author$project$MyUi$buttonBackground),
								$author$project$Ui$Font$color($author$project$MyUi$font1),
								$author$project$Ui$width($author$project$Ui$shrink),
								$author$project$Ui$paddingXY$(12, 0),
								$author$project$Ui$rounded(4),
								$author$project$Ui$Font$size(14),
								$author$project$Ui$contentCenterY,
								$author$project$Ui$height(
								$author$project$Ui$px(30))
							]),
						function () {
							var _v2 = data.isLoadingData;
							if (_v2.$ === 1) {
								return $author$project$Ui$row$(
									_List_fromArray(
										[
											$author$project$Ui$spacing(8),
											$author$project$Ui$contentCenterY
										]),
									_List_fromArray(
										[
											$author$project$Ui$text($author$project$UserOptions$loadingUserDataText),
											$author$project$Icons$spinner
										]));
							} else {
								return $author$project$Ui$text('Reload user data');
							}
						}()),
						$author$project$MyUi$elButton$(
						$lamdera$program_test$Effect$Browser$Dom$id(
							'userOptions_unlinkDiscord_' + $author$project$PersonName$toString(data.name)),
						$author$project$Types$PressedUnlinkDiscordUser(discordUserId),
						_List_fromArray(
							[
								$author$project$Ui$background($author$project$MyUi$deleteButtonBackground),
								$author$project$Ui$border(1),
								$author$project$Ui$borderColor($author$project$MyUi$deleteButtonBorder),
								$author$project$Ui$Font$color($author$project$MyUi$deleteButtonFont),
								$author$project$Ui$width($author$project$Ui$shrink),
								$author$project$Ui$paddingXY$(12, 0),
								$author$project$Ui$rounded(4),
								$author$project$Ui$Font$size(14),
								$author$project$Ui$contentCenterY,
								$author$project$Ui$height(
								$author$project$Ui$px(30))
							]),
						$author$project$Ui$text('Unlink user'))
					])),
				function () {
				var _v3 = data.isLoadingData;
				switch (_v3.$) {
					case 2:
						return $author$project$MyUi$errorBox$(
							$lamdera$program_test$Effect$Browser$Dom$id('userOptions_failedToLoadDiscordUserData'),
							$author$project$Types$PressedCopyText,
							'Failed to load user data');
					case 0:
						return $author$project$Ui$none;
					default:
						return $author$project$Ui$none;
				}
			}()
			]));
};
var $author$project$UserOptions$discordUserCard = F3($author$project$UserOptions$discordUserCard$);
var $author$project$UserOptions$gotoAdmin = $author$project$Ui$el$(
	_List_fromArray(
		[
			$author$project$Ui$paddingXY$(32, 0)
		]),
	$author$project$MyUi$simpleButton$(
		$lamdera$program_test$Effect$Browser$Dom$id('userOptions_gotoAdmin'),
		$author$project$Types$PressedLink(
			$author$project$Route$AdminRoute(
				{highlightLog: $elm$core$Maybe$Nothing})),
		$author$project$Ui$text('Go to Admin')));
var $author$project$UserOptions$horizontalLine = $author$project$Ui$el$(
	_List_fromArray(
		[
			$author$project$Ui$height(
			$author$project$Ui$px(2)),
			$author$project$Ui$background($author$project$MyUi$border1)
		]),
	$author$project$Ui$none);
var $author$project$Types$PressedRemoveSlackTeam = function (a) {
	return {$: 189, a: a};
};
var $author$project$UserOptions$pastedSlackWorkspace = function (workspace) {
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8),
				$author$project$Ui$paddingWith(
				{bottom: 8, left: 12, right: 8, top: 8}),
				$author$project$Ui$border(1),
				$author$project$Ui$borderColor($author$project$MyUi$border1),
				$author$project$Ui$rounded(8),
				$author$project$Ui$contentCenterY
			]),
		_List_fromArray(
			[
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(2),
						$author$project$Ui$clip
					]),
				_List_fromArray(
					[
						$author$project$Ui$text(
						$elm$core$Maybe$withDefault$(
							$author$project$Slack$idToString(workspace.teamId),
							workspace.name)),
						function () {
						var _v0 = workspace.url;
						if (!_v0.$) {
							var url = _v0.a;
							return $author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$Font$size(14),
										$author$project$Ui$Font$color($author$project$MyUi$font3)
									]),
								$author$project$Ui$text(url));
						} else {
							return $author$project$Ui$none;
						}
					}()
					])),
				$author$project$MyUi$deleteButton$(
				$lamdera$program_test$Effect$Browser$Dom$id(
					'userOptions_removeSlackTeam_' + $author$project$Slack$idToString(workspace.teamId)),
				$author$project$Types$PressedRemoveSlackTeam(workspace.teamId))
			]));
};
var $author$project$UserOptions$pastedSlackWorkspaces$ = function (removedTeams, workspaces) {
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8),
				$author$project$Ui$paddingWith(
				{bottom: 0, left: 0, right: 0, top: 8}),
				$author$project$Ui$widthMax(400)
			]),
		$elm$core$List$map$(
			$author$project$UserOptions$pastedSlackWorkspace,
			$elm$core$List$filter$(
				function (workspace) {
					return !$lamdera$containers$SeqSet$member$(workspace.teamId, removedTeams);
				},
				$mgold$elm_nonempty_list$List$Nonempty$toList(workspaces))));
};
var $author$project$UserOptions$pastedSlackWorkspaces = F2($author$project$UserOptions$pastedSlackWorkspaces$);
var $author$project$UserColor$select$ = function (selection, color) {
	return {
		lastValid: function () {
			var _v0 = $author$project$UserColor$fromParts(color);
			if (!_v0.$) {
				var ok = _v0.a;
				return ok;
			} else {
				return selection.lastValid;
			}
		}(),
		selected: color
	};
};
var $author$project$UserColor$select = F2($author$project$UserColor$select$);
var $author$project$Ui$Input$Horizontal = 0;
var $author$project$Ui$Input$attrIf$ = function (condition, attr) {
	return condition ? attr : $elm$html$Html$Attributes$class('');
};
var $author$project$Ui$Input$attrIf = F2($author$project$Ui$Input$attrIf$);
var $author$project$Ui$Input$Thumb = $elm$core$Basics$identity;
var $author$project$Ui$Input$charcoal = $author$project$Ui$rgb$(136, 138, 133);
var $author$project$Ui$Input$defaultThumb = function (direction) {
	return {
		above: function () {
			if (!direction) {
				return _List_fromArray(
					[
						$author$project$Ui$height(
						$author$project$Ui$px(8)),
						$author$project$Ui$roundedWith(
						{bottomLeft: 0, bottomRight: 8, topLeft: 0, topRight: 8}),
						$author$project$Ui$border(1),
						$author$project$Ui$borderColor($author$project$Ui$Input$charcoal),
						$author$project$Ui$background($author$project$Ui$Input$white),
						$author$project$Ui$widthMin(8)
					]);
			} else {
				return _List_fromArray(
					[
						$author$project$Ui$width(
						$author$project$Ui$px(8)),
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$roundedWith(
						{bottomLeft: 0, bottomRight: 0, topLeft: 8, topRight: 8}),
						$author$project$Ui$border(1),
						$author$project$Ui$centerX,
						$author$project$Ui$borderColor($author$project$Ui$Input$charcoal),
						$author$project$Ui$background($author$project$Ui$Input$white),
						$author$project$Ui$heightMin(8)
					]);
			}
		}(),
		below: function () {
			if (!direction) {
				return _List_fromArray(
					[
						$author$project$Ui$height(
						$author$project$Ui$px(8)),
						$author$project$Ui$roundedWith(
						{bottomLeft: 8, bottomRight: 0, topLeft: 8, topRight: 0}),
						$author$project$Ui$border(1),
						$author$project$Ui$borderColor($author$project$Ui$Input$charcoal),
						$author$project$Ui$background($author$project$Ui$Input$blue),
						$author$project$Ui$widthMin(8)
					]);
			} else {
				return _List_fromArray(
					[
						$author$project$Ui$height($author$project$Ui$fill),
						$author$project$Ui$width(
						$author$project$Ui$px(8)),
						$author$project$Ui$centerX,
						$author$project$Ui$roundedWith(
						{bottomLeft: 8, bottomRight: 8, topLeft: 0, topRight: 0}),
						$author$project$Ui$border(1),
						$author$project$Ui$borderColor(
						$author$project$Ui$rgb$(100, 100, 100)),
						$author$project$Ui$background($author$project$Ui$Input$blue),
						$author$project$Ui$heightMin(8)
					]);
			}
		}(),
		thumb: _List_fromArray(
			[
				$author$project$Ui$width(
				$author$project$Ui$px(16)),
				$author$project$Ui$height(
				$author$project$Ui$px(16)),
				$author$project$Ui$rounded(8),
				$author$project$Ui$border(1),
				$author$project$Ui$borderColor($author$project$Ui$Input$charcoal),
				$author$project$Ui$background($author$project$Ui$Input$white)
			])
	};
};
var $author$project$Ui$Input$labelHtmlAttribute = function (lbl) {
	if (!lbl.$) {
		var textLabel = lbl.a;
		return A2($elm$html$Html$Attributes$attribute, 'aria-label', textLabel);
	} else {
		var id = lbl.a;
		return $elm$html$Html$Attributes$id(id);
	}
};
var $author$project$Ui$Input$viewThumb$ = function (factor, _v0, direction) {
	var toThumbAttrs = _v0;
	var thumbAttributes = toThumbAttrs(direction);
	var layout = function () {
		if (!direction) {
			return $author$project$Ui$row;
		} else {
			return $author$project$Ui$column;
		}
	}();
	var below = $author$project$Ui$el$(
		A2(
			$elm$core$List$cons,
			$author$project$Internal$Model2$style$(
				'flex-grow',
				$elm$core$String$fromInt(
					$elm$core$Basics$round(factor * 5000))),
			thumbAttributes.below),
		$author$project$Ui$none);
	var alignment = function () {
		if (!direction) {
			return $author$project$Ui$centerY;
		} else {
			return $author$project$Ui$centerX;
		}
	}();
	var above = $author$project$Ui$el$(
		A2(
			$elm$core$List$cons,
			$author$project$Internal$Model2$style$(
				'flex-grow',
				$elm$core$String$fromInt(
					$elm$core$Basics$round((1 - factor) * 5000))),
			thumbAttributes.above),
		$author$project$Ui$none);
	return A2(
		layout,
		_List_fromArray(
			[
				$author$project$Ui$width($author$project$Ui$fill),
				$author$project$Ui$height($author$project$Ui$fill),
				alignment,
				$author$project$Internal$Model2$attribute(
				A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'))
			]),
		_List_fromArray(
			[
				function () {
				if (!direction) {
					return below;
				} else {
					return above;
				}
			}(),
				$author$project$Ui$el$(
				_List_fromArray(
					[
						alignment,
						function () {
						if (!direction) {
							return $author$project$Ui$width(
								$author$project$Ui$px(0));
						} else {
							return $author$project$Ui$height(
								$author$project$Ui$px(0));
						}
					}(),
						$author$project$Ui$inFront(
						$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$contentCenterY,
									$author$project$Ui$contentCenterX,
									$author$project$Ui$width(
									$author$project$Ui$px(0)),
									$author$project$Ui$height(
									$author$project$Ui$px(0))
								]),
							$author$project$Ui$el$(thumbAttributes.thumb, $author$project$Ui$none)))
					]),
				$author$project$Ui$none),
				function () {
				if (!direction) {
					return above;
				} else {
					return below;
				}
			}()
			]));
};
var $author$project$Ui$Input$viewThumb = F3($author$project$Ui$Input$viewThumb$);
var $author$project$Ui$Input$viewSlider$ = function (attributes, input, direction) {
	var realThumb = $elm$core$Maybe$withDefault$($author$project$Ui$Input$defaultThumb, input.thumb);
	var isVertical = function () {
		if (!direction) {
			return false;
		} else {
			return true;
		}
	}();
	var factor = (input.value - input.min) / (input.max - input.min);
	return $author$project$Ui$el$(
		_Utils_ap(
			_List_fromArray(
				[
					$author$project$Ui$behindContent(
					$author$project$Ui$Input$viewThumb$(factor, realThumb, direction)),
					function () {
					if (!direction) {
						return $author$project$Ui$width($author$project$Ui$fill);
					} else {
						return $author$project$Ui$width(
							$author$project$Ui$px(20));
					}
				}(),
					function () {
					if (!direction) {
						return $author$project$Ui$height(
							$author$project$Ui$px(20));
					} else {
						return $author$project$Ui$height($author$project$Ui$fill);
					}
				}()
				]),
			attributes),
		$author$project$Ui$html(
			A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$author$project$Ui$Input$labelHtmlAttribute(input.label),
						$elm$html$Html$Attributes$class($author$project$Internal$Style2$classes.slider),
						$author$project$Ui$Input$attrIf$(
						isVertical,
						A2($elm$html$Html$Attributes$attribute, 'orient', 'vertical')),
						$author$project$Ui$Input$attrIf$(
						isVertical,
						A2($elm$html$Html$Attributes$attribute, 'writing-mode', 'bt-lr')),
						$author$project$Ui$Input$attrIf$(
						isVertical,
						A2($elm$html$Html$Attributes$style, 'appearance', 'slider-vertical')),
						A2($elm$html$Html$Attributes$style, 'height', '100%'),
						A2($elm$html$Html$Attributes$style, 'width', '100%'),
						$elm$html$Html$Events$onInput(
						function (str) {
							var _v2 = $elm$core$String$toFloat(str);
							if (_v2.$ === 1) {
								return input.onChange(0);
							} else {
								var val = _v2.a;
								return input.onChange(val);
							}
						}),
						$elm$html$Html$Attributes$type_('range'),
						$elm$html$Html$Attributes$step(
						function () {
							var _v3 = input.step;
							if (_v3.$ === 1) {
								return 'any';
							} else {
								var step = _v3.a;
								return $elm$core$String$fromFloat(step);
							}
						}()),
						$elm$html$Html$Attributes$min(
						$elm$core$String$fromFloat(input.min)),
						$elm$html$Html$Attributes$max(
						$elm$core$String$fromFloat(input.max)),
						$elm$html$Html$Attributes$value(
						$elm$core$String$fromFloat(input.value))
					]),
				_List_Nil)));
};
var $author$project$Ui$Input$viewSlider = F3($author$project$Ui$Input$viewSlider$);
var $author$project$Ui$Input$sliderHorizontal$ = function (attributes, input) {
	return $author$project$Ui$Input$viewSlider$(attributes, input, 0);
};
var $author$project$Ui$Input$sliderHorizontal = F2($author$project$Ui$Input$sliderHorizontal$);
var $author$project$UserColor$lightnessSlider$ = function (selection, parts, onChange) {
	var sliderLabel = $author$project$MyUi$label$(
		$lamdera$program_test$Effect$Browser$Dom$id('userColor_lightness'),
		_List_fromArray(
			[
				$author$project$Ui$Font$color($author$project$MyUi$font3),
				$author$project$Ui$Font$size(14)
			]),
		$author$project$Ui$text('Brightness'));
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(2),
				$author$project$Ui$widthMax(300)
			]),
		_List_fromArray(
			[
				sliderLabel.element,
				$author$project$Ui$Input$sliderHorizontal$(
				_List_fromArray(
					[
						$author$project$Ui$background($author$project$MyUi$background3),
						$author$project$Ui$rounded(4)
					]),
				{
					label: sliderLabel.id,
					max: $author$project$UserColor$maxLightness,
					min: $author$project$UserColor$minLightness,
					onChange: function (value) {
						return onChange(
							$author$project$UserColor$select$(
								selection,
								_Utils_update(
									parts,
									{
										lightness: $elm$core$Basics$round(value)
									})));
					},
					step: $elm$core$Maybe$Just(1),
					thumb: $elm$core$Maybe$Nothing,
					value: parts.lightness
				})
			]));
};
var $author$project$UserColor$lightnessSlider = F3($author$project$UserColor$lightnessSlider$);
var $author$project$UserColor$swatchSizeMobile = 17;
var $author$project$UserColor$swatchSize = function (isMobile) {
	return isMobile ? $author$project$UserColor$swatchSizeMobile : 20;
};
var $author$project$UserColor$struckOutLine = function () {
	var line = $author$project$MyUi$colorToStyle($author$project$MyUi$white);
	return 'linear-gradient(to top right, transparent calc(50% - 1px), ' + (line + (' calc(50% - 1px), ' + (line + ' calc(50% + 1px), transparent calc(50% + 1px))')));
}();
var $author$project$UserColor$selectionOutline = function (usable) {
	return $author$project$Ui$el$(
		A2(
			$elm$core$List$cons,
			$author$project$Ui$border(2),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$height($author$project$Ui$fill),
				function () {
					if (!usable.$) {
						return _List_fromArray(
							[
								$author$project$Ui$borderColor($author$project$MyUi$black)
							]);
					} else {
						return _List_fromArray(
							[
								$author$project$Ui$borderColor($author$project$MyUi$white),
								$author$project$MyUi$htmlStyle$('background-image', $author$project$UserColor$struckOutLine)
							]);
					}
				}())),
		$author$project$Ui$none);
};
var $author$project$UserColor$swatchId = function (index) {
	return $lamdera$program_test$Effect$Browser$Dom$id(
		'userColor_swatch_' + $elm$core$String$fromInt(index));
};
var $author$project$UserColor$swatchView$ = function (isMobile, columnsToDrop, selected, onChange, index) {
	var saturation = isMobile ? A2($elm$core$Basics$modBy, $author$project$UserColor$saturationCount, index) : ((index / $author$project$UserColor$hueCount) | 0);
	var hue = isMobile ? ((index / $author$project$UserColor$saturationCount) | 0) : A2($elm$core$Basics$modBy, $author$project$UserColor$hueCount, index);
	if (isMobile && ((_Utils_cmp(saturation, columnsToDrop) < 0) && (!A2($elm$core$Basics$modBy, 2, hue)))) {
		return $elm$core$Maybe$Nothing;
	} else {
		var swatchSize2 = $author$project$Ui$px(
			$author$project$UserColor$swatchSize(isMobile));
		var saturation2 = (isMobile && (A2($elm$core$Basics$modBy, 2, hue) === 1)) ? (($author$project$UserColor$saturationCount - saturation) - 1) : saturation;
		var parts = {hue: hue, lightness: selected.lightness, saturation: saturation2};
		var userColor = $author$project$UserColor$fromParts(parts);
		return $elm$core$Maybe$Just(
			$author$project$Ui$el$(
				A2(
					$elm$core$List$cons,
					$author$project$Ui$id(
						$lamdera$program_test$Effect$Browser$Dom$idToString(
							$author$project$UserColor$swatchId(index))),
					A2(
						$elm$core$List$cons,
						$author$project$Ui$width(swatchSize2),
						A2(
							$elm$core$List$cons,
							$author$project$Ui$height(swatchSize2),
							_Utils_ap(
								function () {
									if (!userColor.$) {
										var userColor2 = userColor.a;
										var color = $author$project$UserColor$toColor(userColor2);
										return _List_fromArray(
											[
												$author$project$Ui$background(color),
												$author$project$Ui$Events$onClick(
												onChange(
													{lastValid: userColor2, selected: parts})),
												$author$project$MyUi$htmlStyle$('cursor', 'pointer')
											]);
									} else {
										return _List_Nil;
									}
								}(),
								(_Utils_eq(hue, selected.hue) && _Utils_eq(saturation2, selected.saturation)) ? _List_fromArray(
									[
										$author$project$Ui$inFront(
										$author$project$UserColor$selectionOutline(userColor))
									]) : _List_Nil)))),
				$author$project$Ui$none));
	}
};
var $author$project$UserColor$swatchView = F5($author$project$UserColor$swatchView$);
var $author$project$UserColor$picker$ = function (isMobile, containerSize, selection, onChange) {
	if (isMobile) {
		var rowSize = (containerSize / $author$project$UserColor$swatchSizeMobile) | 0;
		return $author$project$Ui$column$(
			_List_fromArray(
				[
					$author$project$Ui$spacing(8),
					$author$project$Ui$width(
					$author$project$Ui$px(
						$author$project$UserColor$swatchSizeMobile * $elm$core$Basics$min$($author$project$UserColor$saturationCount * 2, rowSize))),
					$author$project$Ui$centerX
				]),
			_List_fromArray(
				[
					$author$project$Ui$el$(
					_List_fromArray(
						[$author$project$Ui$contentCenterX]),
					$author$project$UserColor$lightnessSlider$(selection, selection.selected, onChange)),
					$author$project$Ui$row$(
					_List_fromArray(
						[$author$project$Ui$wrap]),
					$elm$core$List$filterMap$(
						A4($author$project$UserColor$swatchView, isMobile, ($author$project$UserColor$saturationCount * 2) - rowSize, selection.selected, onChange),
						$elm$core$List$range$(0, ($author$project$UserColor$hueCount * $author$project$UserColor$saturationCount) - 1)))
				]));
	} else {
		return $author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$paddingXY$(16, 0)
				]),
			$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(8),
						$author$project$Ui$width(
						$author$project$Ui$px(
							$author$project$UserColor$swatchSize(isMobile) * $author$project$UserColor$hueCount))
					]),
				_List_fromArray(
					[
						$author$project$Ui$row$(
						_List_fromArray(
							[$author$project$Ui$wrap]),
						$elm$core$List$filterMap$(
							A4($author$project$UserColor$swatchView, isMobile, 0, selection.selected, onChange),
							$elm$core$List$range$(0, ($author$project$UserColor$hueCount * $author$project$UserColor$saturationCount) - 1))),
						$author$project$UserColor$lightnessSlider$(selection, selection.selected, onChange)
					])));
	}
};
var $author$project$UserColor$picker = F4($author$project$UserColor$picker$);
var $author$project$X25519$publicKeyToBytes = function (_v0) {
	var key = _v0;
	return $author$project$X25519$keyToBytes(key);
};
var $author$project$X25519$publicKeyToString = function (key) {
	return $elm$core$Maybe$withDefault$(
		'',
		$danfishgold$base64_bytes$Base64$fromBytes(
			$author$project$X25519$publicKeyToBytes(key)));
};
var $author$project$Types$PressedSlackAcknowledgment = function (a) {
	return {$: 130, a: a};
};
var $author$project$UserOptions$slackAcknowledgement = function (slackAcknowledged) {
	var acknowledgmentLabel = $author$project$Ui$Input$label$(
		'userOptions_slackAcknowledgment',
		_List_fromArray(
			[
				$author$project$Ui$paddingWith(
				{bottom: 0, left: 16, right: 0, top: 0}),
				$author$project$Ui$pointer,
				$author$project$Ui$width($author$project$Ui$shrink)
			]),
		$author$project$Ui$text('I have read the above and accept the risks'));
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(16),
				$author$project$Ui$attrIf$(
				slackAcknowledged,
				$author$project$Ui$opacity(0.5))
			]),
		_List_fromArray(
			[
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(8)
					]),
				_List_fromArray(
					[
						$author$project$MyUi$warningHeader('Before you link your Slack account, please note:'),
						$author$project$UserOptions$numberPoint$(
						1,
						$author$project$Ui$text('In order to link your Slack account, you\u0027ll need to provide a session cookie and one or more workspace tokens. Doing so gives us complete access to your Slack account in every workspace you provide. You are trusting us to not abuse that level of access or accidentally let hackers access your account.')),
						$author$project$UserOptions$numberPoint$(
						2,
						$author$project$Ui$text('This is likely not allowed by Slack\u0027s terms of service and there is a risk that your account might be temporarily or permanently banned.')),
						$author$project$UserOptions$numberPoint$(
						3,
						$author$project$Ui$text('Consider that if you link a private workspace, you are not just increasing the risk that a hacker gets access to your sensitive data in that workspace but also sensitive data any other user may have posted there.'))
					])),
				$author$project$Ui$row$(
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Input$checkbox$(
						_List_Nil,
						{checked: slackAcknowledged, icon: $elm$core$Maybe$Nothing, label: acknowledgmentLabel.id, onChange: $author$project$Types$PressedSlackAcknowledgment}),
						acknowledgmentLabel.element
					]))
			]));
};
var $author$project$UserOptions$slackLinkLimitReachedText = 'This workspace couldn\u0027t be linked because the Slack account limit has been reached';
var $author$project$Types$PressedReloadSlackUser = function (a) {
	return {$: 192, a: a};
};
var $author$project$Types$PressedUnlinkSlackUser = function (a) {
	return {$: 191, a: a};
};
var $author$project$UserOptions$slackNeedsAuthAgainText = 'This account\u0027s login has expired. Link it again below to keep using it';
var $author$project$UserOptions$slackUserCard$ = function (local, slackUserId, teamId) {
	var user = $lamdera$containers$SeqDict$get$(slackUserId, local.localUser.slackUsers);
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8),
				$author$project$Ui$padding(12),
				$author$project$Ui$border(1),
				$author$project$Ui$borderColor($author$project$MyUi$border1),
				$author$project$Ui$rounded(8),
				$author$project$Ui$widthMax(400)
			]),
		_List_fromArray(
			[
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(8)
					]),
				_List_fromArray(
					[
						$author$project$User$profileImage(user),
						$author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$spacing(2)
							]),
						_List_fromArray(
							[
								$author$project$Ui$text(
								function () {
									if (!user.$) {
										var user2 = user.a;
										return $author$project$PersonName$toString(user2.name);
									} else {
										return $author$project$Slack$idToString(slackUserId);
									}
								}()),
								function () {
								var _v1 = $lamdera$containers$SeqDict$get$(teamId, local.slackWorkspaces);
								if (!_v1.$) {
									var workspace = _v1.a;
									return $author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$Font$size(14),
												$author$project$Ui$Font$color($author$project$MyUi$font3)
											]),
										$author$project$Ui$text(workspace.name));
								} else {
									return $author$project$Ui$none;
								}
							}()
							]))
					])),
				$lamdera$containers$SeqSet$member$(slackUserId, local.localUser.slackUsersNeedingAuth) ? $author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$Font$color($author$project$MyUi$errorColor),
						$author$project$Ui$Font$size(14)
					]),
				$author$project$Ui$text($author$project$UserOptions$slackNeedsAuthAgainText)) : $author$project$Ui$none,
				$author$project$Ui$row$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(8)
					]),
				_List_fromArray(
					[
						$lamdera$containers$SeqSet$member$(slackUserId, local.localUser.slackUsersNeedingAuth) ? $author$project$Ui$none : $author$project$MyUi$elButton$(
						$lamdera$program_test$Effect$Browser$Dom$id(
							'userOptions_reloadSlack_' + $author$project$Slack$idToString(slackUserId)),
						$author$project$Types$PressedReloadSlackUser(slackUserId),
						_List_fromArray(
							[
								$author$project$Ui$background($author$project$MyUi$buttonBackground),
								$author$project$Ui$Font$color($author$project$MyUi$font1),
								$author$project$Ui$width($author$project$Ui$shrink),
								$author$project$Ui$paddingXY$(12, 0),
								$author$project$Ui$rounded(4),
								$author$project$Ui$Font$size(14),
								$author$project$Ui$contentCenterY,
								$author$project$Ui$height(
								$author$project$Ui$px(30))
							]),
						$author$project$Ui$text('Reload user data')),
						$author$project$MyUi$elButton$(
						$lamdera$program_test$Effect$Browser$Dom$id(
							'userOptions_unlinkSlack_' + $author$project$Slack$idToString(slackUserId)),
						$author$project$Types$PressedUnlinkSlackUser(slackUserId),
						_List_fromArray(
							[
								$author$project$Ui$background($author$project$MyUi$deleteButtonBackground),
								$author$project$Ui$border(1),
								$author$project$Ui$borderColor($author$project$MyUi$deleteButtonBorder),
								$author$project$Ui$Font$color($author$project$MyUi$deleteButtonFont),
								$author$project$Ui$width($author$project$Ui$shrink),
								$author$project$Ui$paddingXY$(12, 0),
								$author$project$Ui$rounded(4),
								$author$project$Ui$Font$size(14),
								$author$project$Ui$contentCenterY,
								$author$project$Ui$height(
								$author$project$Ui$px(30))
							]),
						$author$project$Ui$text('Unlink user'))
					]))
			]));
};
var $author$project$UserOptions$slackUserCard = F3($author$project$UserOptions$slackUserCard$);
var $author$project$Ui$Font$underline = $author$project$Internal$Model2$class($author$project$Internal$Style2$classes.underline);
var $author$project$UserOptions$textLink$ = function (url, text) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$Font$color($author$project$MyUi$textLinkColorOnDarkBackground),
				$author$project$Ui$Font$underline,
				$author$project$Ui$linkNewTab(url)
			]),
		$author$project$Ui$text(text));
};
var $author$project$UserOptions$textLink = F2($author$project$UserOptions$textLink$);
var $author$project$TwoFactorAuthentication$PressedStart2FaSetup = {$: 0};
var $author$project$TwoFactorAuthentication$PressedStartDisable2Fa = {$: 3};
var $author$project$TwoFactorAuthentication$addTwoFactorText = 'Add two factor authentication';
var $author$project$TwoFactorAuthentication$PressedCancelDisable2Fa = {$: 4};
var $author$project$TwoFactorAuthentication$TypedDisableTwoFactorCode = function (a) {
	return {$: 5, a: a};
};
var $author$project$TwoFactorAuthentication$disableView$ = function (windowSize, textInputFocus, _v0) {
	var attempts = _v0.attempts;
	var code = _v0.code;
	var label = $author$project$Ui$Input$label$(
		'userOverview_disableTwoFactorCodeInput',
		_List_Nil,
		$author$project$Ui$text(
			'Enter the ' + ($elm$core$String$fromInt($author$project$LoginForm$twoFactorCodeLength) + ' digit code from your authenticator app to disable two factor authentication:')));
	return $author$project$Ui$column$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(16)
			]),
		_List_fromArray(
			[
				label.element,
				$author$project$LoginForm$loginCodeInput$(windowSize, $author$project$LoginForm$twoFactorCodeLength, $author$project$TwoFactorAuthentication$TypedDisableTwoFactorCode, textInputFocus, code, label),
				function () {
				var _v1 = $author$project$LoginForm$validateCode$($author$project$LoginForm$twoFactorCodeLength, code);
				if (!_v1.$) {
					var code2 = _v1.a;
					var _v2 = $lamdera$containers$SeqDict$get$(code2, attempts);
					if ((!_v2.$) && (_v2.a === 1)) {
						var _v3 = _v2.a;
						return $author$project$LoginForm$errorView('Incorrect code');
					} else {
						return $author$project$Ui$Prose$paragraph$(
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$text('Submitting...')
								]));
					}
				} else {
					var error = _v1.a;
					return $author$project$LoginForm$errorView(error);
				}
			}(),
				$author$project$MyUi$simpleButton$(
				$lamdera$program_test$Effect$Browser$Dom$id('userOverview_cancelDisable2Fa'),
				$author$project$TwoFactorAuthentication$PressedCancelDisable2Fa,
				$author$project$Ui$text('Cancel'))
			]));
};
var $author$project$TwoFactorAuthentication$disableView = F3($author$project$TwoFactorAuthentication$disableView$);
var $author$project$TwoFactorAuthentication$PressedCopy = function (a) {
	return {$: 1, a: a};
};
var $author$project$TwoFactorAuthentication$TypedTwoFactorCode = function (a) {
	return {$: 2, a: a};
};
var $author$project$TwoFactorAuthentication$setupView$ = function (windowSize, textInputFocus, _v0) {
	var attempts = _v0.attempts;
	var code = _v0.code;
	var qrCodeUrl = _v0.qrCodeUrl;
	var _v1 = $pablohirafuji$elm_qrcode$QRCode$fromString(qrCodeUrl);
	if (!_v1.$) {
		var qrCode = _v1.a;
		var step = F2(
			function (count, content) {
				return $author$project$Ui$column$(
					_List_fromArray(
						[
							$author$project$Ui$spacing(2)
						]),
					_List_fromArray(
						[
							$author$project$Ui$el$(
							_List_fromArray(
								[
									$author$project$Ui$Font$bold,
									$author$project$Ui$Font$color($author$project$MyUi$font3)
								]),
							$author$project$Ui$text(
								'Step ' + $elm$core$String$fromInt(count))),
							content
						]));
			});
		var link = F2(
			function (text, url) {
				return $author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$linkNewTab(url),
							$author$project$Ui$Font$color($author$project$MyUi$textLinkColor)
						]),
					$author$project$Ui$text(text));
			});
		var label = $author$project$Ui$Input$label$(
			'userOverview_twoFactorCodeInput',
			_List_Nil,
			$author$project$Ui$text(
				'The app will provide you with a ' + ($elm$core$String$fromInt($author$project$LoginForm$twoFactorCodeLength) + ' digit code. Enter that code here:')));
		return $author$project$Ui$column$(
			_List_fromArray(
				[
					$author$project$Ui$spacing(24)
				]),
			_List_fromArray(
				[
					$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$Font$size(20),
							$author$project$Ui$Font$bold,
							$author$project$Ui$Font$color($author$project$MyUi$font3)
						]),
					$author$project$Ui$text('In order to setup two factor authentication, please do the following:')),
					A2(
					step,
					1,
					$author$project$Ui$Prose$paragraph$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$(0, 4)
							]),
						_List_fromArray(
							[
								$author$project$Ui$text('Install Google Authenticator ('),
								A2(link, 'Apple', 'https://apps.apple.com/us/app/google-authenticator/id388497605'),
								$author$project$Ui$text(', '),
								A2(link, 'Android', 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en-US'),
								$author$project$Ui$text(') or Microsoft Authenticator ('),
								A2(link, 'Apple', 'https://apps.apple.com/us/app/microsoft-authenticator/id983156458'),
								$author$project$Ui$text(', '),
								A2(link, 'Android', 'https://play.google.com/store/apps/details?id=com.azure.authenticator&hl=en-us'),
								$author$project$Ui$text(') onto your mobile device.')
							]))),
					A2(
					step,
					2,
					$author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$spacing(8)
							]),
						_List_fromArray(
							[
								$author$project$Ui$text('Scan this QR code using the app'),
								$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$background($author$project$MyUi$white),
										$author$project$Ui$padding(12),
										$author$project$Ui$rounded(8),
										$author$project$Ui$width($author$project$Ui$shrink),
										$author$project$MyUi$isMobileAlt(windowSize) ? $author$project$Ui$centerX : $author$project$Ui$noAttr
									]),
								$author$project$Ui$html(
									$pablohirafuji$elm_qrcode$QRCode$toSvgWithoutQuietZone$(
										_List_fromArray(
											[
												$author$project$MyUi$widthAttr(260),
												$author$project$MyUi$heightAttr(260)
											]),
										qrCode)))
							]))),
					A2(
					step,
					3,
					$author$project$Ui$column$(
						_List_fromArray(
							[
								$author$project$Ui$spacing(8)
							]),
						_List_fromArray(
							[
								label.element,
								$author$project$LoginForm$loginCodeInput$(windowSize, $author$project$LoginForm$twoFactorCodeLength, $author$project$TwoFactorAuthentication$TypedTwoFactorCode, textInputFocus, code, label),
								function () {
								var _v2 = $author$project$LoginForm$validateCode$($author$project$LoginForm$twoFactorCodeLength, code);
								if (!_v2.$) {
									var code2 = _v2.a;
									var _v3 = $lamdera$containers$SeqDict$get$(code2, attempts);
									if ((!_v3.$) && (_v3.a === 1)) {
										var _v4 = _v3.a;
										return $author$project$LoginForm$errorView('Incorrect code');
									} else {
										return $author$project$Ui$Prose$paragraph$(
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Ui$text('Submitting...')
												]));
									}
								} else {
									var error = _v2.a;
									return $author$project$LoginForm$errorView(error);
								}
							}()
							])))
				]));
	} else {
		return $author$project$MyUi$errorBox$(
			$lamdera$program_test$Effect$Browser$Dom$id('userOverview_qrCodeError'),
			$author$project$TwoFactorAuthentication$PressedCopy,
			'Something went wrong when setting up two factor authentication');
	}
};
var $author$project$TwoFactorAuthentication$setupView = F3($author$project$TwoFactorAuthentication$setupView$);
var $author$project$MyUi$timeElapsedView$ = function (timezone, now, event) {
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$MyUi$hoverText(
				$author$project$MyUi$datestamp$(timezone, now))
			]),
		$author$project$Ui$text(
			$author$project$MyUi$timeElapsed$(now, event)));
};
var $author$project$MyUi$timeElapsedView = F3($author$project$MyUi$timeElapsedView$);
var $author$project$TwoFactorAuthentication$twoFactorEnabledAtText = 'Two factor authentication was enabled ';
var $author$project$TwoFactorAuthentication$view$ = function (windowSize, textInputFocus, timezone, time, twoFactorStatus) {
	switch (twoFactorStatus.$) {
		case 0:
			return $author$project$MyUi$simpleButton$(
				$lamdera$program_test$Effect$Browser$Dom$id('userOverview_start2FaSetup'),
				$author$project$TwoFactorAuthentication$PressedStart2FaSetup,
				$author$project$Ui$text($author$project$TwoFactorAuthentication$addTwoFactorText));
		case 1:
			return $author$project$MyUi$simpleButton$(
				$lamdera$program_test$Effect$Browser$Dom$id('userOverview_start2FaSetup'),
				$author$project$TwoFactorAuthentication$PressedStart2FaSetup,
				$author$project$Ui$text('Loading...'));
		case 2:
			var data = twoFactorStatus.a;
			return $author$project$TwoFactorAuthentication$setupView$(windowSize, textInputFocus, data);
		case 3:
			return $author$project$Ui$column$(
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$Font$size(18),
								$author$project$Ui$Font$bold,
								$author$project$Ui$paddingXY$(0, 4)
							]),
						$author$project$Ui$text('Two factor authentication enabled!')),
						$author$project$Ui$text('Next time you log in you\u0027ll be prompted to use your authenticator app in addition to the normal login.')
					]));
		case 4:
			var enabledAt = twoFactorStatus.a;
			return $author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(12)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Prose$paragraph$(
						_List_fromArray(
							[
								$author$project$Ui$paddingXY$(0, 4)
							]),
						_List_fromArray(
							[
								$author$project$Ui$text($author$project$TwoFactorAuthentication$twoFactorEnabledAtText),
								$author$project$MyUi$timeElapsedView$(timezone, time, enabledAt),
								$author$project$Ui$text('.')
							])),
						$author$project$MyUi$simpleButton$(
						$lamdera$program_test$Effect$Browser$Dom$id('userOverview_startDisable2Fa'),
						$author$project$TwoFactorAuthentication$PressedStartDisable2Fa,
						$author$project$Ui$text('Disable two factor authentication'))
					]));
		default:
			var data = twoFactorStatus.b;
			return $author$project$TwoFactorAuthentication$disableView$(windowSize, textInputFocus, data);
	}
};
var $author$project$TwoFactorAuthentication$view = F5($author$project$TwoFactorAuthentication$view$);
var $author$project$Types$PressedLogOut = function (a) {
	return {$: 9, a: a};
};
var $author$project$UserOptions$currentDeviceText = 'Current device';
var $author$project$Icons$desktop = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M9 17.25v1.007a3 3 0 0 1-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0 1 15 18.257V17.25m6-12V15a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 15V5.25m18 0A2.25 2.25 0 0 0 18.75 3H5.25A2.25 2.25 0 0 0 3 5.25m18 0V12a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 12V5.25')
				]),
			_List_Nil)
		]));
var $author$project$Icons$logoutSvg = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$fill('currentColor')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fillRule('evenodd'),
					$elm$svg$Svg$Attributes$d('M7.5 3.75A1.5 1.5 0 0 0 6 5.25v13.5a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5V15a.75.75 0 0 1 1.5 0v3.75a3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3V5.25a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3V9A.75.75 0 0 1 15 9V5.25a1.5 1.5 0 0 0-1.5-1.5h-6Zm5.03 4.72a.75.75 0 0 1 0 1.06l-1.72 1.72h10.94a.75.75 0 0 1 0 1.5H10.81l1.72 1.72a.75.75 0 1 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06l3-3a.75.75 0 0 1 1.06 0Z'),
					$elm$svg$Svg$Attributes$clipRule('evenodd')
				]),
			_List_Nil)
		]));
var $author$project$Icons$mobile = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h7.5A2.25 2.25 0 0 0 18 20.25V3.75a2.25 2.25 0 0 0-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3')
				]),
			_List_Nil)
		]));
var $author$project$Icons$tablet = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$fill('none'),
			$elm$svg$Svg$Attributes$viewBox('0 0 24 24'),
			$elm$svg$Svg$Attributes$strokeWidth('1.5'),
			$elm$svg$Svg$Attributes$stroke('currentColor')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeLinecap('round'),
					$elm$svg$Svg$Attributes$strokeLinejoin('round'),
					$elm$svg$Svg$Attributes$d('M10.5 19.5h3m-6.75 2.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-15a2.25 2.25 0 0 0-2.25-2.25H6.75A2.25 2.25 0 0 0 4.5 4.5v15a2.25 2.25 0 0 0 2.25 2.25Z')
				]),
			_List_Nil)
		]));
var $author$project$UserOptions$viewConnectedDevice$ = function (isMobile, time, sessionId, otherSession, userAgent) {
	var deviceText = $author$project$UserAgent$deviceToString(userAgent.device);
	var browserText = function () {
		var _v5 = userAgent.browser;
		switch (_v5) {
			case 0:
				return 'Chrome';
			case 1:
				return 'Firefox';
			case 2:
				return 'Safari';
			case 3:
				return 'Edge';
			case 4:
				return 'Opera';
			default:
				return 'Unknown browser';
		}
	}();
	return $author$project$Ui$row$(
		_List_fromArray(
			[
				$author$project$Ui$spacing(8),
				$author$project$Ui$paddingWith(
				{
					bottom: 0,
					left: 16,
					right: isMobile ? 8 : 16,
					top: 0
				})
			]),
		_List_fromArray(
			[
				$author$project$Ui$el$(
				_List_fromArray(
					[
						$author$project$Ui$width(
						$author$project$Ui$px(36)),
						$author$project$Ui$height(
						$author$project$Ui$px(36))
					]),
				function () {
					var _v0 = userAgent.device;
					switch (_v0) {
						case 0:
							return $author$project$Ui$html($author$project$Icons$mobile);
						case 1:
							return $author$project$Ui$html($author$project$Icons$tablet);
						case 2:
							return $author$project$Ui$html($author$project$Icons$mobile);
						case 3:
							return $author$project$Ui$html($author$project$Icons$tablet);
						case 4:
							return $author$project$Ui$html($author$project$Icons$desktop);
						case 5:
							return $author$project$Ui$html($author$project$Icons$desktop);
						case 6:
							return $author$project$Ui$html($author$project$Icons$desktop);
						case 7:
							return $author$project$Ui$html($author$project$Icons$desktop);
						case 8:
							return $author$project$Ui$html($author$project$Icons$mobile);
						case 9:
							return $author$project$Ui$html($author$project$Icons$tablet);
						default:
							return $author$project$Ui$html($author$project$Icons$desktop);
					}
				}()),
				$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$spacing(2)
					]),
				_List_fromArray(
					[
						$author$project$Ui$text(deviceText + (' • ' + browserText)),
						$author$project$Ui$el$(
						_List_fromArray(
							[
								$author$project$Ui$Font$color($author$project$MyUi$font3),
								$author$project$Ui$Font$size(14)
							]),
						$author$project$Ui$text(
							function () {
								if (!otherSession.$) {
									var session = otherSession.a;
									return 'Last active ' + ($author$project$MyUi$timeElapsed$(time, session.lastActiveAt) + function () {
										var _v2 = $lamdera$containers$SeqDict$size(session.currentlyViewing);
										switch (_v2) {
											case 0:
												return '';
											case 1:
												return '';
											default:
												var count = _v2;
												return ' (' + ($elm$core$String$fromInt(count) + ' connections)');
										}
									}());
								} else {
									return $author$project$UserOptions$currentDeviceText;
								}
							}()))
					])),
				$author$project$MyUi$simpleButton$(
				function () {
					if (!otherSession.$) {
						return $lamdera$program_test$Effect$Browser$Dom$id(
							'options_logout_other_' + $author$project$SessionIdHash$toString(sessionId));
					} else {
						return $lamdera$program_test$Effect$Browser$Dom$id('options_logout');
					}
				}(),
				$author$project$Types$PressedLogOut(sessionId),
				function () {
					if (!otherSession.$) {
						return $author$project$Ui$text('Logout other');
					} else {
						return $author$project$Ui$row$(
							_List_fromArray(
								[
									$author$project$Ui$spacing(8),
									$author$project$Ui$paddingWith(
									{bottom: 0, left: 0, right: 8, top: 0}),
									$author$project$Ui$contentCenterY
								]),
							_List_fromArray(
								[
									$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$width(
											$author$project$Ui$px(24))
										]),
									$author$project$Ui$html($author$project$Icons$logoutSvg)),
									$author$project$Ui$text('Logout')
								]));
					}
				}())
			]));
};
var $author$project$UserOptions$viewConnectedDevice = F5($author$project$UserOptions$viewConnectedDevice$);
var $author$project$UserOptions$view$ = function (windowSize, textInputFocus, time, local, loggedIn, loaded, model) {
	var isMobile = $author$project$MyUi$isMobileAlt(windowSize);
	var allUsers = $author$project$User$allUsers(local.localUser);
	return $author$project$Ui$el$(
		_List_fromArray(
			[
				$author$project$Ui$height($author$project$Ui$fill),
				$author$project$Ui$heightMin(0),
				$author$project$Ui$background($author$project$MyUi$background1),
				$author$project$Ui$inFront(
				$author$project$Ui$el$(
					_List_fromArray(
						[
							$author$project$Ui$background($author$project$MyUi$background1),
							$author$project$Ui$paddingWith(
							{bottom: 0, left: 0, right: 0, top: local.localUser.safeAreaInsetTop}),
							$author$project$Ui$inFront(
							$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$alignBottom,
										$author$project$Ui$paddingXY$(
										isMobile ? 8 : 16,
										0)
									]),
								$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$borderWith(
											{bottom: 1, left: 0, right: 0, top: 0}),
											$author$project$Ui$borderColor($author$project$MyUi$white)
										]),
									$author$project$Ui$none)))
						]),
					$author$project$Ui$row$(
						_List_fromArray(
							[
								$author$project$Ui$widthMax(1000),
								$author$project$Ui$centerX
							]),
						_List_fromArray(
							[
								$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$paddingXY$(16, 0),
										$author$project$Ui$Font$size(20)
									]),
								$author$project$Ui$text('User settings')),
								$author$project$UserOptions$closeButton$(isMobile, $author$project$Types$PressedCloseOverlay)
							]))))
			]),
		$author$project$Ui$el$(
			_List_fromArray(
				[
					$author$project$Ui$scrollable,
					$author$project$Ui$heightMin(0)
				]),
			$author$project$Ui$column$(
				_List_fromArray(
					[
						$author$project$Ui$paddingWith(
						{bottom: 24 + local.localUser.safeAreaInsetBottom, left: 0, right: 0, top: 80 + local.localUser.safeAreaInsetTop}),
						$author$project$Ui$spacing(16),
						$author$project$Ui$widthMax(1000),
						$author$project$Ui$centerX
					]),
				_List_fromArray(
					[
						function () {
						var _v0 = local.adminData;
						switch (_v0.$) {
							case 0:
								return $author$project$UserOptions$gotoAdmin;
							case 1:
								return $author$project$UserOptions$gotoAdmin;
							default:
								return $author$project$Ui$none;
						}
					}(),
						$author$project$MyUi$container$(
						16,
						16,
						$lamdera$containers$SeqSet$member$(1, local.localUser.session.expandedUserOptions),
						$lamdera$program_test$Effect$Browser$Dom$id('userOptions_settings'),
						$author$project$Types$PressedExpandContainer(1),
						$author$project$MyUi$background1,
						isMobile,
						'Account settings',
						_List_fromArray(
							[
								$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$paddingXY$(16, 0)
									]),
								$author$project$Editable$view$(
									$lamdera$program_test$Effect$Browser$Dom$id('userOptions_name'),
									false,
									'Display Name',
									$author$project$PersonName$fromString,
									$author$project$Types$UserNameEditableMsg,
									$author$project$PersonName$toString(local.localUser.user.name),
									model.name)),
								$author$project$Ui$column$(
								_List_fromArray(
									[
										$author$project$Ui$spacing(8),
										$author$project$Ui$paddingXY$(16, 0)
									]),
								_List_fromArray(
									[
										$author$project$Ui$el$(
										_List_fromArray(
											[$author$project$Ui$Font$bold]),
										$author$project$Ui$text('Email')),
										$author$project$Ui$text(
										$author$project$EmailAddress$toString(local.localUser.user.email))
									])),
								$author$project$Ui$column$(
								_List_fromArray(
									[
										$author$project$Ui$spacing(8),
										$author$project$Ui$paddingXY$(16, 0)
									]),
								_List_fromArray(
									[
										$author$project$Ui$el$(
										_List_fromArray(
											[$author$project$Ui$Font$bold]),
										$author$project$Ui$text('Profile Picture')),
										$author$project$Ui$row$(
										_List_fromArray(
											[
												$author$project$Ui$spacing(12),
												$author$project$Ui$alignLeft
											]),
										_List_fromArray(
											[
												$author$project$User$profileImage(
												$elm$core$Maybe$Just(local.localUser.user)),
												A2(
												$author$project$Ui$map,
												$author$project$Types$ProfilePictureEditorMsg,
												$author$project$ImageEditor$view$(
													loaded.windowSize,
													!_Utils_eq(local.localUser.user.icon, $elm$core$Maybe$Nothing),
													loggedIn.profilePictureEditor))
											]))
									])),
								$author$project$Ui$column$(
								_List_fromArray(
									[
										$author$project$Ui$spacing(8),
										$author$project$Ui$paddingXY$(16, 0)
									]),
								_List_fromArray(
									[
										$author$project$MyUi$radioColumn$(
										$lamdera$program_test$Effect$Browser$Dom$id('userOptions_notificationMode'),
										$author$project$Types$SelectedNotificationMode,
										$elm$core$Maybe$Just(local.localUser.session.notificationMode),
										isMobile ? $author$project$Ui$text('Notifications') : $author$project$Ui$text('Desktop notifications'),
										isMobile ? _List_fromArray(
											[
												_Utils_Tuple2(0, 'No notifications'),
												_Utils_Tuple2(2, 'Allow notifications')
											]) : _List_fromArray(
											[
												_Utils_Tuple2(0, 'No notifications'),
												_Utils_Tuple2(1, 'When the app is running'),
												_Utils_Tuple2(2, 'Even when the app is closed (as long as your web browser is open)')
											])),
										function () {
										var _v1 = local.localUser.session.pushSubscription;
										switch (_v1.$) {
											case 0:
												return $author$project$Ui$none;
											case 1:
												return $author$project$Ui$none;
											case 2:
												var subscribeData = _v1.a;
												var error = _v1.b;
												return $author$project$MyUi$errorBox$(
													$lamdera$program_test$Effect$Browser$Dom$id('userOptions_pushNotificationError'),
													$author$project$Types$PressedCopyText,
													$author$project$Log$httpErrorToString(error) + (', Subscription: ' + A3($miniBill$elm_codec$Codec$encodeToString, 0, $author$project$Ports$subscribeDataCodec, subscribeData)));
											default:
												var jsError = _v1.a;
												return $author$project$MyUi$errorBox$(
													$lamdera$program_test$Effect$Browser$Dom$id('userOptions_pushNotificationError'),
													$author$project$Types$PressedCopyText,
													'JS Exception: ' + jsError);
										}
									}()
									])),
								$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$paddingXY$(16, 0)
									]),
								$author$project$MyUi$radioColumn$(
									$lamdera$program_test$Effect$Browser$Dom$id('userOptions_emailNotifications'),
									$author$project$Types$SelectedEmailNotifications,
									$elm$core$Maybe$Just(local.localUser.user.emailNotifications),
									$author$project$Ui$text('Email notifications'),
									_List_fromArray(
										[
											_Utils_Tuple2(0, 'No email notifications'),
											_Utils_Tuple2(1, 'Send me email notifications')
										]))),
								$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$paddingXY$(16, 0)
									]),
								$author$project$MyUi$radioColumn$(
									$lamdera$program_test$Effect$Browser$Dom$id('userOptions_embedVisibility'),
									$author$project$Types$SelectedEmbedVisibility,
									$elm$core$Maybe$Just(local.localUser.user.embedVisibility),
									$author$project$Ui$text('Link embeds'),
									_List_fromArray(
										[
											_Utils_Tuple2(0, 'Show embeds (embedded images and videos may allow 3rd parties to track your IP address)'),
											_Utils_Tuple2(1, 'Don\u0027t show embeds')
										]))),
								$author$project$Ui$column$(
								_List_fromArray(
									[
										$author$project$Ui$spacing(8)
									]),
								A2(
									$elm$core$List$cons,
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$Font$bold,
												$author$project$Ui$paddingXY$(16, 0)
											]),
										$author$project$Ui$text('Color')),
									A2(
										$elm$core$List$cons,
										$author$project$Ui$el$(
											_List_fromArray(
												[
													$author$project$Ui$paddingXY$(16, 0)
												]),
											$author$project$Ui$text('This is the color used for your drawings or to represent you in some games.')),
										function () {
											var _v2 = model.color;
											if (_v2.$ === 1) {
												return _List_fromArray(
													[
														$author$project$Ui$row$(
														_List_fromArray(
															[
																$author$project$Ui$spacing(8),
																$author$project$Ui$paddingXY$(16, 0)
															]),
														_List_fromArray(
															[
																$author$project$UserOptions$currentColorSquare(local.localUser.user.color),
																$author$project$MyUi$secondaryButtonTall$(
																$lamdera$program_test$Effect$Browser$Dom$id('userOptions_selectColor'),
																$author$project$Types$PressedSelectNewColor,
																'Select new color')
															]))
													]);
											} else {
												var selection = _v2.a;
												return _List_fromArray(
													[
														$author$project$Ui$el$(
														_List_fromArray(
															[
																$author$project$Ui$paddingXY$(16, 0)
															]),
														$author$project$UserOptions$colorPreview$(
															time,
															isMobile,
															local,
															allUsers,
															$author$project$UserColor$picked(selection))),
														$author$project$UserColor$picker$(
														isMobile,
														$author$project$Coord$xRaw(windowSize) - (16 * 2),
														selection,
														$author$project$Types$SelectedUserColor),
														$author$project$Ui$row$(
														_List_fromArray(
															[
																$author$project$Ui$spacing(8),
																$author$project$Ui$paddingXY$(16, 0)
															]),
														_List_fromArray(
															[
																_Utils_eq(
																$author$project$UserColor$picked(selection),
																local.localUser.user.color) ? $author$project$Ui$none : $author$project$MyUi$simpleButton$(
																$lamdera$program_test$Effect$Browser$Dom$id('userOptions_submitColor'),
																$author$project$Types$PressedSubmitUserColor,
																$author$project$Ui$text('Submit')),
																$author$project$MyUi$secondaryButtonTall$(
																$lamdera$program_test$Effect$Browser$Dom$id('userOptions_resetColor'),
																$author$project$Types$PressedResetUserColor,
																'Reset')
															]))
													]);
											}
										}()))),
								$author$project$Ui$column$(
								_List_fromArray(
									[
										$author$project$Ui$spacing(8),
										$author$project$Ui$paddingXY$(16, 0)
									]),
								function () {
									var _v3 = local.localUser.user.deleteAccountAt;
									if (!_v3.$) {
										var deleteAt = _v3.a;
										return _List_fromArray(
											[
												$author$project$Ui$el$(
												_List_fromArray(
													[$author$project$Ui$Font$bold]),
												$author$project$Ui$text('Account deletion')),
												$author$project$Ui$text(
												'Your account and all your messages will be permanently deleted on ' + ($author$project$MyUi$datestamp$(local.localUser.timezone, time) + (' (in ' + ($author$project$MyUi$timeElapsed$(time, deleteAt) + ')')))),
												$author$project$MyUi$secondaryButtonTall$($author$project$UserOptions$deleteAccountButtonId, $author$project$Types$PressedDeleteAccount, $author$project$UserOptions$cancelAccountDeletionText)
											]);
									} else {
										return _List_fromArray(
											[
												$author$project$Ui$el$(
												_List_fromArray(
													[$author$project$Ui$Font$bold]),
												$author$project$Ui$text('Account deletion')),
												$author$project$Ui$text(
												'Pressing this will delete your account and all your messages from at-chat in ' + ($elm$core$String$fromInt($author$project$User$accountDeletionDelayInWeeks) + ' weeks. The delay is to give other users a chance to export their conversation with you should they want a personal copy.')),
												$author$project$MyUi$elButton$(
												$author$project$UserOptions$deleteAccountButtonId,
												$author$project$Types$PressedDeleteAccount,
												_List_fromArray(
													[
														$author$project$Ui$paddingXY$(16, 8),
														$author$project$Ui$background($author$project$MyUi$deleteButtonBackground),
														$author$project$Ui$width($author$project$Ui$shrink),
														$author$project$Ui$rounded(4),
														$author$project$Ui$Font$color($author$project$MyUi$deleteButtonFont),
														$author$project$Ui$Font$weight(500),
														$author$project$Ui$borderColor($author$project$MyUi$deleteButtonBorder),
														$author$project$Ui$border(1)
													]),
												$author$project$Ui$text(
													local.localUser.user.isAdmin ? 'Admins can\u0027t delete their account' : 'Delete your account'))
											]);
									}
								}())
							])),
						$author$project$MyUi$container$(
						16,
						16,
						$lamdera$containers$SeqSet$member$(0, local.localUser.session.expandedUserOptions),
						$lamdera$program_test$Effect$Browser$Dom$id('userOptions_twoFactor'),
						$author$project$Types$PressedExpandContainer(0),
						$author$project$MyUi$background1,
						isMobile,
						'Two-factor authentication',
						_List_fromArray(
							[
								$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$paddingXY$(16, 0)
									]),
								A2(
									$author$project$Ui$map,
									$author$project$Types$TwoFactorMsg,
									$author$project$TwoFactorAuthentication$view$(loaded.windowSize, textInputFocus, local.localUser.timezone, time, loggedIn.twoFactor)))
							])),
						function () {
						if ($lamdera$containers$SeqSet$isEmpty(local.localUser.user.domainWhitelist)) {
							return $author$project$Ui$none;
						} else {
							var hasChanges = !_Utils_eq(
								model.domainWhitelistInput,
								$author$project$UserOptions$domainWhitelistToString(local.localUser.user.domainWhitelist));
							return $author$project$MyUi$container$(
								16,
								16,
								$lamdera$containers$SeqSet$member$(2, local.localUser.session.expandedUserOptions),
								$lamdera$program_test$Effect$Browser$Dom$id('userOptions_whitelistedDomains'),
								$author$project$Types$PressedExpandContainer(2),
								$author$project$MyUi$background1,
								isMobile,
								'Whitelisted domains (' + ($elm$core$String$fromInt(
									$lamdera$containers$SeqSet$size(local.localUser.user.domainWhitelist)) + ')'),
								_List_fromArray(
									[
										$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$paddingXY$(16, 0)
											]),
										$author$project$Ui$Input$multiline$(
											_List_fromArray(
												[
													$author$project$MyUi$id(
													$lamdera$program_test$Effect$Browser$Dom$id('userOptions_whitelistDomains')),
													$author$project$Ui$paddingXY$(8, 6),
													$author$project$Ui$background($author$project$MyUi$inputBackground),
													$author$project$Ui$border(1),
													$author$project$Ui$borderColor($author$project$MyUi$inputBorder),
													$author$project$Ui$rounded(4)
												]),
											{
												label: $author$project$Ui$Input$labelHidden('Whitelisted domains'),
												onChange: $author$project$Types$TypedDomainWhitelist,
												placeholder: $elm$core$Maybe$Nothing,
												spellcheck: false,
												text: model.domainWhitelistInput
											})),
										hasChanges ? $author$project$Ui$row$(
										_List_fromArray(
											[
												$author$project$Ui$spacing(8),
												$author$project$Ui$width($author$project$Ui$shrink),
												$author$project$Ui$paddingXY$(16, 0)
											]),
										_List_fromArray(
											[
												$author$project$MyUi$simpleButton$(
												$lamdera$program_test$Effect$Browser$Dom$id('userOptions_saveWhitelistDomains'),
												$author$project$Types$PressedSaveDomainWhitelist,
												$author$project$Ui$text('Save')),
												$author$project$MyUi$simpleButton$(
												$lamdera$program_test$Effect$Browser$Dom$id('userOptions_resetWhitelistDomains'),
												$author$project$Types$PressedResetDomainWhitelist,
												$author$project$Ui$text('Reset'))
											])) : $author$project$Ui$none
									]));
						}
					}(),
						$author$project$MyUi$container$(
						16,
						16,
						$lamdera$containers$SeqSet$member$(3, local.localUser.session.expandedUserOptions),
						$lamdera$program_test$Effect$Browser$Dom$id('userOptions_e2eeSection'),
						$author$project$Types$PressedExpandContainer(3),
						$author$project$MyUi$background1,
						isMobile,
						'End-to-end encryption',
						function () {
							var _v4 = local.localUser.user.publicKey;
							if (!_v4.$) {
								var publicKey = _v4.a;
								var privateKeyLabel = $author$project$Ui$Input$label$(
									'userOptions_privateKey',
									_List_Nil,
									$author$project$Ui$text('You can enter your private key here to check that it matches your public key.'));
								var e2eeDmChannels = $elm$core$List$filterMap$(
									function (_v8) {
										var otherUserId = _v8.a;
										var channel = _v8.b;
										var _v9 = _Utils_Tuple2(
											channel.e2ee,
											$author$project$User$getUser$(otherUserId, local.localUser));
										if ((_v9.a.$ === 3) && (!_v9.b.$)) {
											var otherUser = _v9.b.a;
											return $elm$core$Maybe$Just(
												$author$project$Pages$Guild$friendLabel$(isMobile, time, false, local.localUser, otherUserId, otherUser, channel));
										} else {
											return $elm$core$Maybe$Nothing;
										}
									},
									$lamdera$containers$SeqDict$toList(local.dmChannels));
								return _List_fromArray(
									[
										$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$paddingXY$(16, 0),
												$author$project$Ui$widthMax(400)
											]),
										$author$project$MyUi$copyBox$(
											$lamdera$program_test$Effect$Browser$Dom$id('userOptions_publicKey'),
											$elm$core$Maybe$Just('Your public key'),
											$author$project$Types$PressedCopyText,
											$author$project$Types$FrontendNoOp,
											loaded,
											$author$project$X25519$publicKeyToString(publicKey))),
										$author$project$Ui$column$(
										_List_fromArray(
											[
												$author$project$Ui$paddingXY$(16, 0),
												$author$project$Ui$spacing(4)
											]),
										_List_fromArray(
											[
												privateKeyLabel.element,
												$author$project$Ui$Input$currentPassword$(
												_List_fromArray(
													[
														$author$project$Ui$background($author$project$MyUi$inputBackground),
														$author$project$Ui$paddingXY$(8, 8),
														$author$project$Ui$widthMax(300),
														$author$project$Ui$borderColor($author$project$MyUi$inputBorder)
													]),
												{
													label: privateKeyLabel.id,
													onChange: function (text) {
														if (A2(
															$elm$core$String$endsWith,
															'=',
															$elm$core$String$trim(text))) {
															var _v5 = $author$project$User$privateKeyForAccount$(text, local.localUser.user);
															if (!_v5.$) {
																return $author$project$Types$ValidatedE2eePrivateKey$('', $author$project$Types$E2eeKeys_Valid);
															} else {
																var error = _v5.a;
																return $author$project$Types$ValidatedE2eePrivateKey$(
																	text,
																	$author$project$Types$E2eeKeys_Error(error));
															}
														} else {
															return $author$project$Types$ValidatedE2eePrivateKey$(text, $author$project$Types$E2eeKeys_NotChecked);
														}
													},
													placeholder: $elm$core$Maybe$Just('Your private key'),
													show: false,
													text: model.privateKeyText
												}),
												function () {
												var _v6 = model.e2eeKeysValid;
												switch (_v6.$) {
													case 0:
														return $author$project$Ui$none;
													case 1:
														var error = _v6.a;
														return $author$project$Ui$el$(
															_List_fromArray(
																[
																	$author$project$Ui$Font$color($author$project$MyUi$errorColor)
																]),
															$author$project$Ui$text(error));
													default:
														return $author$project$Ui$text('Public + private key pair is valid!');
												}
											}()
											])),
										function () {
										if (!e2eeDmChannels.b) {
											return $author$project$Ui$el$(
												_List_fromArray(
													[
														$author$project$Ui$paddingXY$(16, 0)
													]),
												$author$project$Ui$text('E2EE not enabled for an DM channels yet.'));
										} else {
											return $author$project$Ui$column$(
												_List_fromArray(
													[
														$author$project$Ui$spacing(8)
													]),
												_List_fromArray(
													[
														$author$project$Ui$el$(
														_List_fromArray(
															[
																$author$project$Ui$paddingXY$(16, 0)
															]),
														$author$project$Ui$text('E2EE enabled for ')),
														$author$project$Ui$column$(
														_List_fromArray(
															[
																$author$project$Ui$paddingXY$(12, 0),
																$author$project$Ui$widthMax(400)
															]),
														e2eeDmChannels)
													]));
										}
									}()
									]);
							} else {
								return _List_fromArray(
									[
										$author$project$Ui$Prose$paragraph$(
										_List_fromArray(
											[
												$author$project$Ui$paddingXY$(16, 4)
											]),
										_List_fromArray(
											[
												$author$project$Ui$text('You have not enabled E2EE for any direct message channels yet. Open a direct message channel and click on the '),
												$author$project$Ui$html($author$project$Icons$gear),
												$author$project$Ui$text(' to do so.')
											]))
									]);
							}
						}()),
						$author$project$MyUi$container$(
						16,
						16,
						$lamdera$containers$SeqSet$member$(8, local.localUser.session.expandedUserOptions),
						$lamdera$program_test$Effect$Browser$Dom$id('userOptions_slackSection'),
						$author$project$Types$PressedExpandContainer(8),
						$author$project$MyUi$background1,
						isMobile,
						'Slack',
						_Utils_ap(
							_List_fromArray(
								[
									$lamdera$containers$SeqDict$isEmpty(local.localUser.linkedSlackUsers) ? $author$project$Ui$none : $author$project$Ui$column$(
									_List_fromArray(
										[
											$author$project$Ui$spacing(8),
											$author$project$Ui$paddingXY$(16, 0)
										]),
									_List_fromArray(
										[
											$author$project$Ui$el$(
											_List_fromArray(
												[
													$author$project$Ui$Font$size(14),
													$author$project$Ui$Font$color($author$project$MyUi$font3)
												]),
											$author$project$Ui$text('Linked Slack users')),
											$author$project$Ui$column$(
											_List_fromArray(
												[
													$author$project$Ui$spacing(8)
												]),
											$elm$core$List$map$(
												function (_v10) {
													var slackUserId = _v10.a;
													var teamId = _v10.b;
													return $author$project$UserOptions$slackUserCard$(local, slackUserId, teamId);
												},
												$lamdera$containers$SeqDict$toList(local.localUser.linkedSlackUsers)))
										])),
									$author$project$Ui$el$(
									_List_fromArray(
										[
											$author$project$Ui$paddingXY$(16, 0)
										]),
									$author$project$UserOptions$slackAcknowledgement(local.localUser.user.linkSlackAcknowledgementIsChecked))
								]),
							_Utils_ap(
								function () {
									if (local.localUser.user.linkSlackAcknowledgementIsChecked) {
										var slackTeamsJsonLabel = $author$project$Ui$Input$label$(
											'userOptions_slackTeamsJson',
											_List_Nil,
											$author$project$Ui$text('5. Right click the output and click \u0022Copy object\u0022 and paste it here'));
										var slackCookieLabel = $author$project$Ui$Input$label$(
											'userOptions_slackCookie',
											_List_Nil,
											$author$project$Ui$text('3. Paste in the value for the cookie named \u0022d\u0022'));
										return _List_fromArray(
											[
												$author$project$Ui$column$(
												_List_fromArray(
													[
														$author$project$Ui$paddingXY$(16, 0),
														$author$project$Ui$spacing(16)
													]),
												_List_fromArray(
													[
														$author$project$UserOptions$horizontalLine,
														$author$project$Ui$column$(
														_List_fromArray(
															[
																$author$project$Ui$spacing(4)
															]),
														_List_fromArray(
															[
																$author$project$Ui$el$(
																_List_fromArray(
																	[
																		$author$project$Ui$Font$bold,
																		$author$project$Ui$Font$color($author$project$MyUi$font3)
																	]),
																$author$project$Ui$text('To link your Slack account:\u000A')),
																$author$project$Ui$Prose$paragraph$(
																_List_fromArray(
																	[
																		$author$project$Ui$paddingXY$(0, 5)
																	]),
																_List_fromArray(
																	[
																		$author$project$Ui$text('1. Go to '),
																		$author$project$UserOptions$textLink$('https://app.slack.com/client', 'app.slack.com/client'),
																		$author$project$Ui$text(' in your browser')
																	])),
																$author$project$Ui$text('2. Open the browser developer tools and click on the Application tab (for Chrome) or Storage tab (Firefox)\u000A'),
																$author$project$Ui$column$(
																_List_Nil,
																_List_fromArray(
																	[
																		slackCookieLabel.element,
																		$author$project$Ui$el$(
																		_List_fromArray(
																			[
																				$author$project$Ui$paddingXY$(16, 0)
																			]),
																		A2(
																			$author$project$Ui$Input$text,
																			_List_fromArray(
																				[
																					$author$project$Ui$background($author$project$MyUi$inputBackground),
																					$author$project$Ui$paddingXY$(8, 8),
																					$author$project$Ui$widthMax(400),
																					$author$project$Ui$borderColor($author$project$MyUi$inputBorder)
																				]),
																			{
																				label: slackCookieLabel.id,
																				onChange: $author$project$Types$TypedSlackCookie,
																				placeholder: $elm$core$Maybe$Just('xoxd-...'),
																				text: model.slackCookie
																			})),
																		function () {
																		var _v11 = _Utils_Tuple2(
																			model.pressedSubmitSlackData,
																			$author$project$Slack$stringToSlackCookie(model.slackCookie));
																		if (_v11.a && (_v11.b.$ === 1)) {
																			var error = _v11.b.a;
																			return $author$project$Ui$el$(
																				_List_fromArray(
																					[
																						$author$project$Ui$Font$color($author$project$MyUi$errorColor),
																						$author$project$Ui$paddingXY$(16, 0)
																					]),
																				$author$project$Ui$text(error));
																		} else {
																			return $author$project$Ui$none;
																		}
																	}()
																	])),
																$author$project$Ui$row$(
																_List_fromArray(
																	[
																		$author$project$Ui$contentTop,
																		$author$project$Ui$widthMax(416),
																		$author$project$Ui$spacing(4)
																	]),
																_List_fromArray(
																	[
																		$author$project$Ui$text('4. '),
																		$author$project$MyUi$copyBoxAlt$(
																		$lamdera$program_test$Effect$Browser$Dom$id('userOptions_slackConsoleCommand'),
																		$elm$core$Maybe$Just(
																			_Utils_Tuple2(
																				_List_Nil,
																				$author$project$Ui$text('Open the console tab and paste in this text (you\u00A0might\u00A0need\u00A0to\u00A0type\u00A0in\u00A0\u0022allow pasting\u0022 first)'))),
																		$author$project$Types$PressedCopyText,
																		$author$project$Types$FrontendNoOp,
																		loaded,
																		'JSON.parse(localStorage.localConfig_v2).teams')
																	])),
																$author$project$Ui$column$(
																_List_Nil,
																_List_fromArray(
																	[
																		slackTeamsJsonLabel.element,
																		$author$project$Ui$el$(
																		_List_fromArray(
																			[
																				$author$project$Ui$paddingXY$(16, 0)
																			]),
																		A2(
																			$author$project$Ui$Input$text,
																			_List_fromArray(
																				[
																					$author$project$Ui$background($author$project$MyUi$inputBackground),
																					$author$project$Ui$paddingXY$(8, 8),
																					$author$project$Ui$widthMax(400),
																					$author$project$Ui$borderColor($author$project$MyUi$inputBorder)
																				]),
																			{label: slackTeamsJsonLabel.id, onChange: $author$project$Types$TypedSlackTeamsJson, placeholder: $elm$core$Maybe$Nothing, text: model.slackTeamsJson})),
																		function () {
																		var _v12 = $author$project$Slack$teamsJsonToWorkspaces(model.slackTeamsJson);
																		if (!_v12.$) {
																			var workspaces = _v12.a;
																			return $author$project$UserOptions$pastedSlackWorkspaces$(model.removedSlackTeams, workspaces);
																		} else {
																			return $author$project$Ui$none;
																		}
																	}(),
																		function () {
																		var _v13 = _Utils_Tuple2(
																			model.pressedSubmitSlackData,
																			$author$project$Slack$teamsJsonToSlackTokens$(model.removedSlackTeams, model.slackTeamsJson));
																		if (_v13.a && (_v13.b.$ === 1)) {
																			var error = _v13.b.a;
																			return $author$project$Ui$el$(
																				_List_fromArray(
																					[
																						$author$project$Ui$Font$color($author$project$MyUi$errorColor),
																						$author$project$Ui$paddingXY$(16, 0)
																					]),
																				$author$project$Ui$text(error));
																		} else {
																			return $author$project$Ui$none;
																		}
																	}()
																	]))
															]))
													])),
												$author$project$Ui$el$(
												_List_fromArray(
													[
														$author$project$Ui$paddingXY$(16, 0)
													]),
												$author$project$MyUi$elButton$(
													$lamdera$program_test$Effect$Browser$Dom$id('userOptions_submitSlackData'),
													$author$project$Types$PressedSubmitSlackData,
													_List_fromArray(
														[
															$author$project$Ui$background($author$project$MyUi$buttonBackground),
															$author$project$Ui$width($author$project$Ui$shrink),
															$author$project$Ui$paddingXY$(16, 8),
															$author$project$Ui$rounded(4),
															$author$project$Ui$borderColor($author$project$MyUi$buttonBorder),
															$author$project$Ui$border(1)
														]),
													$author$project$Ui$text('Link Slack account and workspaces')))
											]);
									} else {
										return _List_Nil;
									}
								}(),
								_List_fromArray(
									[
										function () {
										var _v14 = model.linkSlackResult;
										if (!_v14.$) {
											if (!_v14.a.$) {
												var _v15 = _v14.a;
												return $author$project$Ui$el$(
													_List_fromArray(
														[
															$author$project$Ui$paddingXY$(16, 0),
															$author$project$Ui$Font$color($author$project$MyUi$errorColor)
														]),
													$author$project$Ui$text('Slack account linking is disabled'));
											} else {
												var results = _v14.a.a;
												return $author$project$Ui$column$(
													_List_fromArray(
														[
															$author$project$Ui$paddingXY$(16, 0)
														]),
													$elm$core$List$map$(
														function (result) {
															if (!result.$) {
																var workspaceName = result.a;
																return $author$project$Ui$text('Loaded ' + workspaceName);
															} else {
																if (!result.a.$) {
																	var error = result.a.a;
																	return $author$project$Ui$el$(
																		_List_fromArray(
																			[
																				$author$project$Ui$Font$color($author$project$MyUi$errorColor)
																			]),
																		$author$project$Ui$text(
																			'Couldn\u0027t load a workspace: ' + $author$project$Slack$httpErrorToString(error)));
																} else {
																	var _v17 = result.a;
																	return $author$project$Ui$el$(
																		_List_fromArray(
																			[
																				$author$project$Ui$Font$color($author$project$MyUi$errorColor)
																			]),
																		$author$project$Ui$text($author$project$UserOptions$slackLinkLimitReachedText));
																}
															}
														},
														$mgold$elm_nonempty_list$List$Nonempty$toList(results)));
											}
										} else {
											return $author$project$Ui$none;
										}
									}()
									])))),
						$author$project$MyUi$container$(
						16,
						16,
						$lamdera$containers$SeqSet$member$(4, local.localUser.session.expandedUserOptions),
						$lamdera$program_test$Effect$Browser$Dom$id('userOptions_discordSection'),
						$author$project$Types$PressedExpandContainer(4),
						$author$project$MyUi$background1,
						isMobile,
						'Discord',
						_List_fromArray(
							[
								$lamdera$containers$SeqDict$isEmpty(
								$author$project$LinkedAndOtherDiscordUsers$linkedUsers(local.localUser.discordUsers)) ? $author$project$Ui$none : $author$project$Ui$column$(
								_List_fromArray(
									[
										$author$project$Ui$spacing(8),
										$author$project$Ui$paddingXY$(16, 0)
									]),
								_List_fromArray(
									[
										$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$Font$size(14),
												$author$project$Ui$Font$color($author$project$MyUi$font3)
											]),
										$author$project$Ui$text('Linked Discord users')),
										$author$project$Ui$column$(
										_List_fromArray(
											[
												$author$project$Ui$spacing(8)
											]),
										$elm$core$List$map$(
											function (_v18) {
												var discordUserId = _v18.a;
												var data = _v18.b;
												return $author$project$UserOptions$discordUserCard$(loaded, discordUserId, data);
											},
											$lamdera$containers$SeqDict$toList(
												$author$project$LinkedAndOtherDiscordUsers$linkedUsers(local.localUser.discordUsers))))
									])),
								$author$project$Ui$column$(
								_List_fromArray(
									[
										$author$project$Ui$spacing(16),
										$author$project$Ui$paddingXY$(16, 0)
									]),
								_List_fromArray(
									[
										$author$project$UserOptions$discordAcknowledgement(local.localUser.user.linkDiscordAcknowledgementIsChecked),
										local.localUser.user.linkDiscordAcknowledgementIsChecked ? $author$project$Ui$column$(
										_List_fromArray(
											[
												$author$project$Ui$spacing(16)
											]),
										_List_fromArray(
											[
												$author$project$UserOptions$horizontalLine,
												$author$project$Ui$column$(
												_List_fromArray(
													[
														$author$project$Ui$spacing(4)
													]),
												_List_fromArray(
													[
														$author$project$Ui$el$(
														_List_fromArray(
															[
																$author$project$Ui$Font$bold,
																$author$project$Ui$Font$color($author$project$MyUi$font3)
															]),
														$author$project$Ui$text('To link your Discord account:\u000A')),
														$author$project$Ui$text('1. Copy the bookmarklet URL below\u000A'),
														$author$project$Ui$text('2. Create a new bookmark in your browser\u000A'),
														$author$project$Ui$text('3. Paste the URL as the bookmark address\u000A'),
														$author$project$Ui$Prose$paragraph$(
														_List_fromArray(
															[
																$author$project$Ui$paddingXY$(0, 5)
															]),
														_List_fromArray(
															[
																$author$project$Ui$text('4. Go to '),
																$author$project$UserOptions$textLink$('https://discord.com/app', 'discord.com/app'),
																$author$project$Ui$text(' in your browser')
															])),
														$author$project$Ui$text('5. Make sure you are logged in on Discord and then click on the bookmark')
													])),
												$author$project$Ui$el$(
												_List_fromArray(
													[
														$author$project$Ui$widthMax(400)
													]),
												$author$project$MyUi$copyBox$(
													$lamdera$program_test$Effect$Browser$Dom$id('userOptions_bookmarklet'),
													$elm$core$Maybe$Just('Bookmarklet URL'),
													$author$project$Types$PressedCopyText,
													$author$project$Types$TypedDiscordLinkBookmarklet,
													loaded,
													$author$project$UserOptions$bookmarklet))
											])) : $author$project$Ui$none
									]))
							])),
						$author$project$MyUi$container$(
						10,
						16,
						$lamdera$containers$SeqSet$member$(5, local.localUser.session.expandedUserOptions),
						$lamdera$program_test$Effect$Browser$Dom$id('userOptions_connectedDevices'),
						$author$project$Types$PressedExpandContainer(5),
						$author$project$MyUi$background1,
						isMobile,
						'Connected devices',
						A2(
							$elm$core$List$cons,
							$author$project$UserOptions$viewConnectedDevice$(isMobile, time, local.localUser.session.sessionIdHash, $elm$core$Maybe$Nothing, local.localUser.session.userAgent),
							$elm$core$List$map$(
								function (_v19) {
									var otherSessionId = _v19.a;
									var otherSession = _v19.b;
									return $author$project$UserOptions$viewConnectedDevice$(
										isMobile,
										time,
										otherSessionId,
										$elm$core$Maybe$Just(otherSession),
										otherSession.userAgent);
								},
								$lamdera$containers$SeqDict$toList(local.otherSessions)))),
						$author$project$MyUi$container$(
						16,
						16,
						$lamdera$containers$SeqSet$member$(6, local.localUser.session.expandedUserOptions),
						$lamdera$program_test$Effect$Browser$Dom$id('userOptions_debug'),
						$author$project$Types$PressedExpandContainer(6),
						$author$project$MyUi$background1,
						isMobile,
						'Debug',
						_List_fromArray(
							[
								$author$project$Ui$column$(
								_List_fromArray(
									[
										isMobile ? $author$project$Ui$width($author$project$Ui$fill) : $author$project$Ui$width($author$project$Ui$shrink),
										$author$project$Ui$paddingXY$(16, 0),
										$author$project$Ui$spacing(16)
									]),
								_List_fromArray(
									[
										$author$project$MyUi$copyBox$(
										$lamdera$program_test$Effect$Browser$Dom$id('userOptions_sessionIdHash'),
										$elm$core$Maybe$Just('SessionId hash'),
										$author$project$Types$PressedCopyText,
										$author$project$Types$FrontendNoOp,
										loaded,
										$author$project$SessionIdHash$toString(local.localUser.session.sessionIdHash)),
										$author$project$MyUi$copyBox$(
										$lamdera$program_test$Effect$Browser$Dom$id('userOptions_clientIdHash'),
										$elm$core$Maybe$Just('ClientId'),
										$author$project$Types$PressedCopyText,
										$author$project$Types$FrontendNoOp,
										loaded,
										$lamdera$program_test$Effect$Lamdera$clientIdToString(loaded.clientId))
									])),
								$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$paddingXY$(16, 0)
									]),
								$author$project$MyUi$secondaryButton$(
									$lamdera$program_test$Effect$Browser$Dom$id('userOptions_unregisterServiceWorkers'),
									$author$project$Types$PressedUnregisterServiceWorkers,
									'Unregister service workers')),
								$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$paddingXY$(16, 0)
									]),
								$author$project$MyUi$secondaryButton$(
									$lamdera$program_test$Effect$Browser$Dom$id('userOptions_loadDebugData'),
									$author$project$Types$PressedLoadDebugData,
									'Load debug data')),
								function () {
								var _v20 = model.debugData;
								if (!_v20.$) {
									var debugData = _v20.a;
									return $author$project$Ui$el$(
										_List_fromArray(
											[
												isMobile ? $author$project$Ui$width($author$project$Ui$fill) : $author$project$Ui$width($author$project$Ui$shrink),
												$author$project$Ui$paddingXY$(16, 0)
											]),
										$author$project$MyUi$copyBox$(
											$lamdera$program_test$Effect$Browser$Dom$id('userOptions_debugData'),
											$elm$core$Maybe$Just(
												'Debug data (loaded at ' + ($author$project$MyUi$timestamp$(debugData.loadedAt, loaded.timezone) + ')')),
											$author$project$Types$PressedCopyText,
											$author$project$Types$FrontendNoOp,
											loaded,
											debugData.data));
								} else {
									return $author$project$Ui$none;
								}
							}(),
								$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$paddingXY$(16, 0)
									]),
								$author$project$Ui$text(
									'App version: ' + function () {
										var _v21 = loaded.versionNumber;
										if (!_v21.$) {
											var version = _v21.a;
											return $elm$core$String$fromInt(version);
										} else {
											return 'unknown';
										}
									}())),
								$author$project$Ui$row$(
								_List_fromArray(
									[
										$author$project$Ui$width($author$project$Ui$shrink),
										$author$project$Ui$spacing(8),
										$author$project$Ui$paddingXY$(16, 0),
										$author$project$Ui$linkNewTab($author$project$Pages$Privacy$repoUrl),
										$author$project$Ui$Font$color($author$project$MyUi$textLinkColorOnDarkBackground)
									]),
								_List_fromArray(
									[
										$author$project$Ui$html(
										$author$project$Icons$github(20)),
										$author$project$Ui$text('Source code')
									]))
							])),
						$author$project$MyUi$container$(
						16,
						16,
						$lamdera$containers$SeqSet$member$(7, local.localUser.session.expandedUserOptions),
						$lamdera$program_test$Effect$Browser$Dom$id('userOptions_privacy'),
						$author$project$Types$PressedExpandContainer(7),
						$author$project$MyUi$background1,
						isMobile,
						'Privacy policy',
						_List_fromArray(
							[
								$author$project$Ui$el$(
								_List_fromArray(
									[
										$author$project$Ui$paddingXY$(16, 0)
									]),
								$author$project$Pages$Privacy$view($author$project$Types$FrontendNoOp))
							]))
					]))));
};
var $author$project$UserOptions$view = F7($author$project$UserOptions$view$);
var $author$project$Frontend$view$ = function (_v0, model) {
	return {
		body: _List_fromArray(
			[
				function () {
				if (!model.$) {
					var loading = model.a;
					return A2(
						$elm$html$Html$span,
						_List_Nil,
						function () {
							var _v2 = loading.loginStatus;
							switch (_v2.$) {
								case 0:
									return _List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$id('loading')
												]),
											_List_Nil),
											$author$project$MyUi$css
										]);
								case 1:
									var _v3 = loading.time;
									if (!_v3.$) {
										return _List_fromArray(
											[
												$elm$html$Html$text('Something isn\u0027t working.')
											]);
									} else {
										return _List_fromArray(
											[
												$elm$html$Html$text('Something went wrong')
											]);
									}
								default:
									return _List_fromArray(
										[
											$elm$html$Html$text('Something went wrong when loading the page.')
										]);
							}
						}());
				} else {
					var loaded = model.a;
					var isMobile = $author$project$MyUi$isMobile(loaded);
					var requiresLogin = function (page) {
						var _v19 = loaded.loginStatus;
						if (!_v19.$) {
							var loggedIn = _v19.a;
							var local = $author$project$Local$model(loggedIn.localState);
							return $author$project$FrontendExtra$layout$(
								loaded,
								_List_fromArray(
									[
										function () {
										var _v20 = _Utils_Tuple2(
											$author$project$Route$toOverlay(loaded.route),
											loggedIn.userOptions);
										if (((!_v20.a.$) && (_v20.a.a === 1)) && (!_v20.b.$)) {
											var _v21 = _v20.a.a;
											var userOptions = _v20.b.a;
											return $author$project$Ui$inFront(
												$author$project$UserOptions$view$(loaded.windowSize, loggedIn.textInputFocus, loaded.time, local, loggedIn, loaded, userOptions));
										} else {
											return $author$project$Ui$noAttr;
										}
									}(),
										_Utils_eq(
										$author$project$Route$toOverlay(loaded.route),
										$elm$core$Maybe$Just(2)) ? $author$project$Ui$inFront(
										$author$project$SearchOverlay$view$(
											isMobile,
											loggedIn.searchOverlayQuery,
											loggedIn.searchOverlaySelection,
											$author$project$SearchOverlay$search$(loggedIn.searchOverlayQuery, local))) : $author$project$Ui$noAttr,
										function () {
										var _v22 = _Utils_Tuple2(
											local.localUser.user.deleteAccountAt,
											$author$project$Route$toOverlay(loaded.route));
										if (!_v22.a.$) {
											if ((!_v22.b.$) && (_v22.b.a === 1)) {
												var _v23 = _v22.b.a;
												return $author$project$Ui$noAttr;
											} else {
												var deleteAt = _v22.a.a;
												return loggedIn.accountDeletionBannerClosed ? $author$project$Ui$noAttr : $author$project$Ui$inFront(
													$author$project$FrontendExtra$accountDeletionBanner$(local.localUser.safeAreaInsetTop, loaded.time, deleteAt));
											}
										} else {
											var _v24 = _v22.a;
											return $author$project$Ui$noAttr;
										}
									}(),
										function () {
										var _v25 = loggedIn.externalLinkWarning;
										if (!_v25.$) {
											var url = _v25.a;
											return $author$project$Ui$inFront(
												$author$project$FrontendExtra$externalLinkWarning$(local.localUser.user.domainWhitelist, isMobile, url));
										} else {
											return $author$project$Ui$noAttr;
										}
									}(),
										function () {
										var _v26 = loggedIn.showNewPrivateKey;
										if (!_v26.$) {
											var privateKey = _v26.a;
											return $author$project$Ui$inFront(
												$author$project$FrontendExtra$newPrivateKeyWarning$(isMobile, loaded, local.localUser.user.email, privateKey));
										} else {
											return $author$project$Ui$noAttr;
										}
									}(),
										loggedIn.isReloading ? $author$project$Ui$inFront(
										$author$project$Ui$el$(
											_List_fromArray(
												[
													$author$project$Ui$background($author$project$MyUi$background1),
													$author$project$Ui$padding(8),
													$author$project$Ui$width($author$project$Ui$shrink),
													$author$project$Ui$border(1),
													$author$project$Ui$borderColor($author$project$MyUi$border1),
													$author$project$Ui$alignBottom,
													$author$project$Ui$centerX
												]),
											$author$project$Ui$text('Reloading...'))) : $author$project$Ui$noAttr,
										$author$project$Ui$inFront(
										A2(
											$author$project$Ui$map,
											$author$project$Types$VoiceChatMsg,
											$author$project$Call$recordingNoticeView$(local.localUser, loaded.time, local.calls))),
										$author$project$Ui$inFront(
										$author$project$Call$recordingUploadView$(local.localUser, loggedIn.voiceChat)),
										$author$project$Ui$inFront(
										$author$project$Ui$html(
											A2(
												$elm$html$Html$map,
												$author$project$Types$VoiceChatMsg,
												$author$project$Call$videoNodes$(local.localUser, loaded, loggedIn, local.calls))))
									]),
								A2(page, loggedIn, local));
						} else {
							var notLoggedIn = _v19.a;
							return $author$project$FrontendExtra$layout$(
								loaded,
								_List_fromArray(
									[
										$author$project$Ui$background($author$project$MyUi$background3),
										$author$project$Ui$inFront(
										$author$project$Pages$Home$header$(isMobile, loaded.startupData.safeAreaInsetTop, loaded.route, loaded.loginStatus))
									]),
								A2(
									$author$project$Ui$map,
									$author$project$Types$LoginFormMsg,
									$author$project$LoginForm$view$(
										notLoggedIn.textInputFocus,
										$elm$core$Maybe$withDefault$($author$project$LoginForm$init, notLoggedIn.loginForm),
										loaded.windowSize,
										loaded.startupData.safeAreaInsetTop,
										loaded.startupData.pwaStatus,
										loaded.startupData.userAgent.browser)));
						}
					};
					var _v4 = loaded.route;
					switch (_v4.$) {
						case 0:
							var _v5 = loaded.loginStatus;
							if (!_v5.$) {
								return requiresLogin(
									F2(
										function (loggedIn, local) {
											return $author$project$Pages$Guild$homePageLoggedInView$($author$project$Pages$Guild$NoDmChannelSelected, loaded, loggedIn, local);
										}));
							} else {
								var notLoggedIn = _v5.a;
								return $author$project$FrontendExtra$layout$(
									loaded,
									_List_fromArray(
										[
											$author$project$Ui$background($author$project$MyUi$background3)
										]),
									$author$project$Ui$el$(
										_List_fromArray(
											[
												$author$project$Ui$inFront(
												$author$project$Pages$Home$header$(isMobile, loaded.startupData.safeAreaInsetTop, loaded.route, loaded.loginStatus)),
												$author$project$Ui$height($author$project$Ui$fill)
											]),
										function () {
											var _v6 = notLoggedIn.loginForm;
											if (!_v6.$) {
												var loginForm2 = _v6.a;
												return A2(
													$author$project$Ui$map,
													$author$project$Types$LoginFormMsg,
													$author$project$LoginForm$view$(notLoggedIn.textInputFocus, loginForm2, loaded.windowSize, loaded.startupData.safeAreaInsetTop, loaded.startupData.pwaStatus, loaded.startupData.userAgent.browser));
											} else {
												return $author$project$Ui$Lazy$lazy$($author$project$Pages$Home$view, loaded);
											}
										}()));
							}
						case 1:
							var _v7 = _Utils_Tuple2(loaded.loginStatus, loaded.loginType);
							if ((_v7.a.$ === 1) && (_v7.b === 1)) {
								var notLoggedIn = _v7.a.a;
								var _v8 = _v7.b;
								return $author$project$FrontendExtra$layout$(
									loaded,
									_List_fromArray(
										[
											$author$project$Ui$background($author$project$MyUi$background3),
											$author$project$Ui$inFront(
											$author$project$Pages$Home$header$(isMobile, loaded.startupData.safeAreaInsetTop, loaded.route, loaded.loginStatus))
										]),
									A2(
										$author$project$Ui$map,
										$author$project$Types$RecoveryLoginMsg,
										$author$project$RecoveryLogin$view(notLoggedIn.recoveryLogin)));
							} else {
								return requiresLogin(
									F2(
										function (loggedIn, local) {
											var _v9 = local.adminData;
											switch (_v9.$) {
												case 0:
													var adminData = _v9.a;
													return A2(
														$author$project$Ui$map,
														$author$project$Types$AdminPageMsg,
														$author$project$Pages$Admin$view$(
															$author$project$MyUi$isMobile(loaded),
															loaded.versionNumber,
															loaded.time,
															local,
															adminData,
															loggedIn.admin));
												case 1:
													return $author$project$Ui$text('Loading admin page...');
												default:
													return $author$project$Frontend$errorPage$(loaded, 'Admin access required to view this page');
											}
										}));
							}
						case 2:
							return requiresLogin(
								F2(
									function (loggedIn, _v10) {
										return $author$project$Pages$Guild$newGuildFormView$(
											loaded.startupData.safeAreaInsetTop,
											$elm$core$Maybe$withDefault$($author$project$Pages$Guild$newGuildFormInit, loggedIn.newGuildForm));
									}));
						case 9:
							return requiresLogin(
								F2(
									function (_v11, local) {
										var _v12 = local.adminData;
										if (_v12.$ === 2) {
											return $author$project$Frontend$errorPage$(loaded, 'Admin access required to view this page');
										} else {
											return $author$project$Ui$el$(
												_List_fromArray(
													[
														$author$project$Ui$height($author$project$Ui$fill),
														((loaded.aiChatModel.chatHistory === '') && ((loaded.aiChatModel.message === '') && ($author$project$MyUi$isMobile(loaded) && (loaded.startupData.pwaStatus === 1)))) ? $author$project$Ui$inFront(
														$author$project$Ui$el$(
															_List_fromArray(
																[
																	$author$project$Ui$centerX,
																	$author$project$Ui$centerY,
																	$author$project$Ui$widthMax(380),
																	$author$project$Ui$padding(16)
																]),
															$author$project$LoginForm$mobileWarning$(loaded.windowSize, loaded.startupData.userAgent.browser))) : $author$project$Ui$noAttr
													]),
												A2(
													$author$project$Ui$map,
													$author$project$Types$AiChatMsg,
													$author$project$AiChat$view$(loaded.windowSize, loaded.startupData.safeAreaInsetTop, loaded.startupData.safeAreaInsetBottom, loaded.aiChatModel)));
										}
									}));
						case 3:
							var guildId = _v4.a;
							var maybeChannelId = _v4.b;
							return requiresLogin(
								A3($author$project$Pages$Guild$guildView, loaded, guildId, maybeChannelId));
						case 4:
							var data = _v4.a;
							return requiresLogin(
								A2($author$project$Pages$Guild$discordGuildView, loaded, data));
						case 5:
							var dmRoute = _v4.a;
							return requiresLogin(
								A2(
									$author$project$Pages$Guild$homePageLoggedInView,
									$author$project$Pages$Guild$SelectedDmChannel(dmRoute),
									loaded));
						case 10:
							return requiresLogin(
								F2(
									function (_v13, local) {
										return A2(
											$author$project$Ui$map,
											$author$project$Types$TextEditorMsg,
											$author$project$TextEditor$view$(loaded.startupData.safeAreaInsetTop, loaded.startupData.safeAreaInsetBottom, local.localUser.session.userId, local.textEditor));
									}));
						case 11:
							var _v14 = loaded.loginStatus;
							if (_v14.$ === 1) {
								var textInputFocus = _v14.a.textInputFocus;
								var loginForm = _v14.a.loginForm;
								if (!loginForm.$) {
									var loginForm2 = loginForm.a;
									return $author$project$FrontendExtra$layout$(
										loaded,
										_List_fromArray(
											[
												$author$project$Ui$background($author$project$MyUi$background3),
												$author$project$Ui$inFront(
												$author$project$Pages$Home$header$(isMobile, loaded.startupData.safeAreaInsetTop, loaded.route, loaded.loginStatus))
											]),
										A2(
											$author$project$Ui$map,
											$author$project$Types$LoginFormMsg,
											$author$project$LoginForm$view$(textInputFocus, loginForm2, loaded.windowSize, loaded.startupData.safeAreaInsetTop, loaded.startupData.pwaStatus, loaded.startupData.userAgent.browser)));
								} else {
									return $author$project$Frontend$privacyPage$(isMobile, loaded);
								}
							} else {
								return $author$project$Frontend$privacyPage$(isMobile, loaded);
							}
						case 6:
							var routeData = _v4.a;
							return requiresLogin(
								A2(
									$author$project$Pages$Guild$homePageLoggedInView,
									$author$project$Pages$Guild$SelectedDiscordDmChannel(routeData),
									loaded));
						case 7:
							var routeData = _v4.a;
							return requiresLogin(
								A2($author$project$Pages$Guild$slackWorkspaceView, loaded, routeData));
						case 8:
							var routeData = _v4.a;
							return requiresLogin(
								A2(
									$author$project$Pages$Guild$homePageLoggedInView,
									$author$project$Pages$Guild$SelectedSlackDmChannel(routeData),
									loaded));
						case 12:
							var result = _v4.a;
							return $author$project$FrontendExtra$layout$(
								loaded,
								_List_fromArray(
									[$author$project$Ui$contentCenterX, $author$project$Ui$contentCenterY]),
								function () {
									var _v16 = _Utils_Tuple2(loaded.loginStatus, result);
									if (!_v16.b.$) {
										if (_v16.a.$ === 1) {
											var notLoggedIn = _v16.a.a;
											return $author$project$Ui$column$(
												_List_fromArray(
													[
														$author$project$Ui$spacing(32)
													]),
												_List_fromArray(
													[
														$author$project$Ui$el$(
														_List_fromArray(
															[
																$author$project$Ui$Font$size(20),
																$author$project$Ui$Font$center,
																$author$project$Ui$widthMax(400),
																$author$project$Ui$centerX
															]),
														$author$project$Ui$text('You aren\u0027t logged in here. Please log in and then we can link your Discord account.')),
														A2(
														$author$project$Ui$map,
														$author$project$Types$LoginFormMsg,
														$author$project$LoginForm$view$(
															notLoggedIn.textInputFocus,
															$elm$core$Maybe$withDefault$($author$project$LoginForm$init, notLoggedIn.loginForm),
															loaded.windowSize,
															loaded.startupData.safeAreaInsetTop,
															0,
															loaded.startupData.userAgent.browser))
													]));
										} else {
											return $author$project$Ui$text('Linking...');
										}
									} else {
										var error = _v16.b.a;
										return $author$project$Frontend$errorPage$(
											loaded,
											function () {
												switch (error) {
													case 0:
														return $author$project$Frontend$discordLinkExpiredText;
													case 1:
														return $author$project$Frontend$discordLinkServerErrorText;
													case 2:
														return 'Failed to link your Discord account due to some problem with the bookmarklet';
													default:
														return $author$project$Frontend$discordLinkLimitReachedText;
												}
											}());
									}
								}());
						default:
							return $author$project$FrontendExtra$layout$(
								loaded,
								_List_fromArray(
									[
										$author$project$Ui$background($author$project$MyUi$background3),
										$author$project$Ui$contentCenterX,
										$author$project$Ui$contentCenterY
									]),
								function () {
									var _v18 = loaded.publicGoMatch;
									switch (_v18.$) {
										case 2:
											var data = _v18.a;
											var gameModel = _v18.b;
											return $author$project$Ui$el$(
												_List_fromArray(
													[
														$author$project$Ui$htmlAttribute(
														$elm$html$Html$Attributes$id('public_go_container')),
														$author$project$Ui$centerX,
														$author$project$Ui$centerY,
														$author$project$Ui$width($author$project$Ui$shrink)
													]),
												A2(
													$author$project$Ui$map,
													$author$project$Types$GoSpectatorMsg,
													$author$project$Go$spectatorView$(loaded.time, loaded.windowSize, data, gameModel)));
										case 3:
											return $author$project$Frontend$errorPage$(loaded, $author$project$Frontend$goMatchNotFoundText);
										case 1:
											return $author$project$Ui$el$(
												_List_fromArray(
													[
														$author$project$Ui$centerX,
														$author$project$Ui$centerY,
														$author$project$Ui$htmlAttribute(
														$elm$html$Html$Attributes$id('public_go_loading'))
													]),
												$author$project$Ui$text('Loading match...'));
										default:
											return $author$project$Frontend$errorPage$(loaded, 'Something went wrong when loading Go match');
									}
								}());
					}
				}
			}()
			]),
		title: 'at-chat'
	};
};
var $author$project$Frontend$view = F2($author$project$Frontend$view$);
var $author$project$Frontend$app_ = $author$project$Audio$lamderaFrontendWithAudio(
	{
		audio: $author$project$FrontendExtra$audio,
		audioPort: {fromJS: $author$project$Ports$audioPortFromJS, toJS: $author$project$Ports$audioPortToJS},
		init: $author$project$Frontend$init,
		onUrlChange: $author$project$Frontend$onUrlChange,
		onUrlRequest: $author$project$Frontend$onUrlRequest,
		subscriptions: $author$project$Frontend$subscriptions,
		update: $author$project$Frontend$update,
		updateFromBackend: $author$project$Frontend$updateFromBackend,
		view: $author$project$Frontend$view
	});
var $lamdera$program_test$Effect$Browser$Navigation$MockNavigationKey = {$: 1};
var $lamdera$program_test$Effect$Browser$Navigation$RealNavigationKey = function (a) {
	return {$: 0, a: a};
};
var $lamdera$program_test$Effect$Browser$Navigation$fromInternalKey = function (key) {
	if (!key.$) {
		var key_ = key.a;
		return $lamdera$program_test$Effect$Browser$Navigation$RealNavigationKey(key_);
	} else {
		return $lamdera$program_test$Effect$Browser$Navigation$MockNavigationKey;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$Task$map$ = function (func, taskA) {
	return A2(
		$elm$core$Task$andThen,
		function (a) {
			return $elm$core$Task$succeed(
				func(a));
		},
		taskA);
};
var $elm$core$Task$map = F2($elm$core$Task$map$);
var $elm$core$Task$map2$ = function (func, taskA, taskB) {
	return A2(
		$elm$core$Task$andThen,
		function (a) {
			return A2(
				$elm$core$Task$andThen,
				function (b) {
					return $elm$core$Task$succeed(
						A2(func, a, b));
				},
				taskB);
		},
		taskA);
};
var $elm$core$Task$map2 = F3($elm$core$Task$map2$);
var $elm$core$Task$sequence = function (tasks) {
	return $elm$core$List$foldr$(
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd$ = function (router, _v0) {
	var task = _v0;
	return _Scheduler_spawn(
		A2(
			$elm$core$Task$andThen,
			$elm$core$Platform$sendToApp(router),
			task));
};
var $elm$core$Task$spawnCmd = F2($elm$core$Task$spawnCmd$);
var $elm$core$Task$onEffects$ = function (router, commands, state) {
	return $elm$core$Task$map$(
		function (_v0) {
			return 0;
		},
		$elm$core$Task$sequence(
			$elm$core$List$map$(
				$elm$core$Task$spawnCmd(router),
				commands)));
};
var $elm$core$Task$onEffects = F3($elm$core$Task$onEffects$);
var $elm$core$Task$onSelfMsg$ = function (_v0, _v1, _v2) {
	return $elm$core$Task$succeed(0);
};
var $elm$core$Task$onSelfMsg = F3($elm$core$Task$onSelfMsg$);
var $elm$core$Task$cmdMap$ = function (tagger, _v0) {
	var task = _v0;
	return $elm$core$Task$map$(tagger, task);
};
var $elm$core$Task$cmdMap = F2($elm$core$Task$cmdMap$);
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt$ = function (resultToMessage, task) {
	return $elm$core$Task$command(
		A2(
			$elm$core$Task$onError,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
				$elm$core$Result$Err),
			A2(
				$elm$core$Task$andThen,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Ok),
				task)));
};
var $elm$core$Task$attempt = F2($elm$core$Task$attempt$);
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$core$Task$perform$ = function (toMessage, task) {
	return $elm$core$Task$command(
		$elm$core$Task$map$(toMessage, task));
};
var $elm$core$Task$perform = F2($elm$core$Task$perform$);
var $elm$browser$Browser$Navigation$back$ = function (key, n) {
	return A2(_Browser_go, key, -n);
};
var $elm$browser$Browser$Navigation$back = F2($elm$browser$Browser$Navigation$back$);
var $elm$file$File$Download$bytes$ = function (name, mime, content) {
	return $elm$core$Task$perform$(
		$elm$core$Basics$never,
		A3(
			_File_download,
			name,
			mime,
			_File_makeBytesSafeForInternetExplorer(content)));
};
var $elm$file$File$Download$bytes = F3($elm$file$File$Download$bytes$);
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$State$ = function (reqs, subs) {
	return {reqs: reqs, subs: subs};
};
var $elm$http$Http$State = F2($elm$http$Http$State$);
var $elm$http$Http$init = $elm$core$Task$succeed(
	$elm$http$Http$State$($elm$core$Dict$empty, _List_Nil));
var $elm$http$Http$BadStatus_$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $elm$http$Http$BadStatus_ = F2($elm$http$Http$BadStatus_$);
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $elm$http$Http$GoodStatus_ = F2($elm$http$Http$GoodStatus_$);
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs$ = function (router, cmds, reqs) {
	updateReqs:
	while (true) {
		if (!cmds.b) {
			return $elm$core$Task$succeed(reqs);
		} else {
			var cmd = cmds.a;
			var otherCmds = cmds.b;
			if (!cmd.$) {
				var tracker = cmd.a;
				var _v2 = $elm$core$Dict$get$(tracker, reqs);
				if (_v2.$ === 1) {
					var $temp$cmds = otherCmds;
					cmds = $temp$cmds;
					continue updateReqs;
				} else {
					var pid = _v2.a;
					return A2(
						$elm$core$Task$andThen,
						function (_v3) {
							return $elm$http$Http$updateReqs$(
								router,
								otherCmds,
								$elm$core$Dict$remove$(tracker, reqs));
						},
						$elm$core$Process$kill(pid));
				}
			} else {
				var req = cmd.a;
				return A2(
					$elm$core$Task$andThen,
					function (pid) {
						var _v4 = req.tracker;
						if (_v4.$ === 1) {
							return $elm$http$Http$updateReqs$(router, otherCmds, reqs);
						} else {
							var tracker = _v4.a;
							return $elm$http$Http$updateReqs$(
								router,
								otherCmds,
								$elm$core$Dict$insert$(tracker, pid, reqs));
						}
					},
					$elm$core$Process$spawn(
						A3(
							_Http_toTask,
							router,
							$elm$core$Platform$sendToApp(router),
							req)));
			}
		}
	}
};
var $elm$http$Http$updateReqs = F3($elm$http$Http$updateReqs$);
var $elm$http$Http$onEffects$ = function (router, cmds, subs, state) {
	return A2(
		$elm$core$Task$andThen,
		function (reqs) {
			return $elm$core$Task$succeed(
				$elm$http$Http$State$(reqs, subs));
		},
		$elm$http$Http$updateReqs$(router, cmds, state.reqs));
};
var $elm$http$Http$onEffects = F4($elm$http$Http$onEffects$);
var $elm$http$Http$maybeSend$ = function (router, desiredTracker, progress, _v0) {
	var actualTracker = _v0.a;
	var toMsg = _v0.b;
	return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
		A2(
			$elm$core$Platform$sendToApp,
			router,
			toMsg(progress))) : $elm$core$Maybe$Nothing;
};
var $elm$http$Http$maybeSend = F4($elm$http$Http$maybeSend$);
var $elm$http$Http$onSelfMsg$ = function (router, _v0, state) {
	var tracker = _v0.a;
	var progress = _v0.b;
	return A2(
		$elm$core$Task$andThen,
		function (_v1) {
			return $elm$core$Task$succeed(state);
		},
		$elm$core$Task$sequence(
			$elm$core$List$filterMap$(
				A3($elm$http$Http$maybeSend, router, tracker, progress),
				state.subs)));
};
var $elm$http$Http$onSelfMsg = F3($elm$http$Http$onSelfMsg$);
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$cmdMap$ = function (func, cmd) {
	if (!cmd.$) {
		var tracker = cmd.a;
		return $elm$http$Http$Cancel(tracker);
	} else {
		var r = cmd.a;
		return $elm$http$Http$Request(
			{
				allowCookiesFromOtherDomains: r.allowCookiesFromOtherDomains,
				body: r.body,
				expect: A2(_Http_mapExpect, func, r.expect),
				headers: r.headers,
				method: r.method,
				timeout: r.timeout,
				tracker: r.tracker,
				url: r.url
			});
	}
};
var $elm$http$Http$cmdMap = F2($elm$http$Http$cmdMap$);
var $elm$http$Http$MySub$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $elm$http$Http$MySub = F2($elm$http$Http$MySub$);
var $elm$http$Http$subMap$ = function (func, _v0) {
	var tracker = _v0.a;
	var toMsg = _v0.b;
	return $elm$http$Http$MySub$(
		tracker,
		A2($elm$core$Basics$composeR, toMsg, func));
};
var $elm$http$Http$subMap = F2($elm$http$Http$subMap$);
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$cancel = function (tracker) {
	return $elm$http$Http$command(
		$elm$http$Http$Cancel(tracker));
};
var $elm$file$File$Select$file$ = function (mimes, toMsg) {
	return $elm$core$Task$perform$(
		toMsg,
		_File_uploadOne(mimes));
};
var $elm$file$File$Select$file = F2($elm$file$File$Select$file$);
var $elm$file$File$Select$files$ = function (mimes, toMsg) {
	return $elm$core$Task$perform$(
		function (_v0) {
			var f = _v0.a;
			var fs = _v0.b;
			return A2(toMsg, f, fs);
		},
		_File_uploadOneOrMore(mimes));
};
var $elm$file$File$Select$files = F2($elm$file$File$Select$files$);
var $elm$browser$Browser$Navigation$forward = _Browser_go;
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $elm$browser$Browser$Navigation$reload = _Browser_reload(false);
var $elm$browser$Browser$Navigation$reloadAndSkipCache = _Browser_reload(true);
var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
var $elm$file$File$Download$string$ = function (name, mime, content) {
	return $elm$core$Task$perform$(
		$elm$core$Basics$never,
		A3(_File_download, name, mime, content));
};
var $elm$file$File$Download$string = F3($elm$file$File$Download$string$);
var $lamdera$program_test$Effect$Internal$BrowserDomNotFound = $elm$core$Basics$identity;
var $elm$browser$Browser$Dom$blur = _Browser_call('blur');
var $elm$http$Http$bytesResolver = A2(_Http_expect, 'arraybuffer', _Http_toDataView);
var $lamdera$program_test$WebGLFix$Texture$Wrap = $elm$core$Basics$identity;
var $lamdera$program_test$WebGLFix$Texture$clampToEdge = 33071;
var $lamdera$program_test$Websocket$ClosedEvent = function (a) {
	return {$: 1, a: a};
};
var $lamdera$program_test$Websocket$AbnormalClosure = {$: 5};
var $lamdera$program_test$Websocket$BadGateway = {$: 13};
var $lamdera$program_test$Websocket$GoingAway = {$: 1};
var $lamdera$program_test$Websocket$InternalError = {$: 10};
var $lamdera$program_test$Websocket$InvalidFramePayloadData = {$: 6};
var $lamdera$program_test$Websocket$MessageTooBig = {$: 8};
var $lamdera$program_test$Websocket$MissingExtension = {$: 9};
var $lamdera$program_test$Websocket$NoStatusReceived = {$: 4};
var $lamdera$program_test$Websocket$NormalClosure = {$: 0};
var $lamdera$program_test$Websocket$PolicyViolation = {$: 7};
var $lamdera$program_test$Websocket$ProtocolError = {$: 2};
var $lamdera$program_test$Websocket$ServiceRestart = {$: 11};
var $lamdera$program_test$Websocket$TlsHandshake = {$: 14};
var $lamdera$program_test$Websocket$TryAgainLater = {$: 12};
var $lamdera$program_test$Websocket$UnknownCode = function (a) {
	return {$: 15, a: a};
};
var $lamdera$program_test$Websocket$UnsupportedData = {$: 3};
var $lamdera$program_test$Websocket$decodeCloseEventCode = function (code) {
	switch (code) {
		case 1000:
			return $lamdera$program_test$Websocket$NormalClosure;
		case 1001:
			return $lamdera$program_test$Websocket$GoingAway;
		case 1002:
			return $lamdera$program_test$Websocket$ProtocolError;
		case 1003:
			return $lamdera$program_test$Websocket$UnsupportedData;
		case 1005:
			return $lamdera$program_test$Websocket$NoStatusReceived;
		case 1006:
			return $lamdera$program_test$Websocket$AbnormalClosure;
		case 1007:
			return $lamdera$program_test$Websocket$InvalidFramePayloadData;
		case 1008:
			return $lamdera$program_test$Websocket$PolicyViolation;
		case 1009:
			return $lamdera$program_test$Websocket$MessageTooBig;
		case 1010:
			return $lamdera$program_test$Websocket$MissingExtension;
		case 1011:
			return $lamdera$program_test$Websocket$InternalError;
		case 1012:
			return $lamdera$program_test$Websocket$ServiceRestart;
		case 1013:
			return $lamdera$program_test$Websocket$TryAgainLater;
		case 1014:
			return $lamdera$program_test$Websocket$BadGateway;
		case 1015:
			return $lamdera$program_test$Websocket$TlsHandshake;
		default:
			return $lamdera$program_test$Websocket$UnknownCode(code);
	}
};
var $lamdera$program_test$Websocket$closedEvent$ = function (code, reason) {
	return $lamdera$program_test$Websocket$ClosedEvent(
		{
			code: $lamdera$program_test$Websocket$decodeCloseEventCode(code),
			reason: reason
		});
};
var $lamdera$program_test$Websocket$closedEvent = F2($lamdera$program_test$Websocket$closedEvent$);
var $lamdera$program_test$Websocket$Connection$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $lamdera$program_test$Websocket$Connection = F2($lamdera$program_test$Websocket$Connection$);
var $lamdera$program_test$Websocket$connection = $lamdera$program_test$Websocket$Connection;
var $lamdera$program_test$Websocket$ConnectionClosed = 0;
var $lamdera$program_test$Websocket$connectionClosed = 0;
var $lamdera$program_test$Websocket$DataEvent = function (a) {
	return {$: 0, a: a};
};
var $lamdera$program_test$Websocket$dataEvent = $lamdera$program_test$Websocket$DataEvent;
var $lamdera$program_test$Websocket$close = function (connection_) {
	return $elm$core$Task$map$(
		function (_v0) {
			return 0;
		},
		A2(_LamderaWebsocket_close, 0, connection_));
};
var $lamdera$program_test$Websocket$createHandle = function (url) {
	return A2(_LamderaWebsocket_createHandle, 0, url);
};
var $lamdera$program_test$Effect$Internal$AlreadyStarted = 0;
var $lamdera$program_test$Effect$Internal$LeftEye = 0;
var $lamdera$program_test$Effect$Internal$LeftHand = 0;
var $lamdera$program_test$Effect$Internal$NotSupported = 1;
var $lamdera$program_test$Effect$Internal$OtherEye = 2;
var $lamdera$program_test$Effect$Internal$RightEye = 1;
var $lamdera$program_test$Effect$Internal$RightHand = 1;
var $lamdera$program_test$Effect$Internal$Unknown = 2;
var $lamdera$program_test$Effect$Internal$XrLostTracking = 1;
var $lamdera$program_test$Effect$Internal$XrSessionNotStarted = 0;
var $lamdera$program_test$WebGLFix$Internal$enableOption$ = function (ctx, option) {
	switch (option.$) {
		case 0:
			return A2(_WebGLFix_enableAlpha, ctx, option);
		case 1:
			return A2(_WebGLFix_enableDepth, ctx, option);
		case 2:
			return A2(_WebGLFix_enableStencil, ctx, option);
		case 3:
			return A2(_WebGLFix_enableAntialias, ctx, option);
		case 4:
			return A2(_WebGLFix_enableClearColor, ctx, option);
		default:
			return A2(_WebGLFix_enablePreserveDrawingBuffer, ctx, option);
	}
};
var $lamdera$program_test$WebGLFix$Internal$enableOption = F2($lamdera$program_test$WebGLFix$Internal$enableOption$);
var $lamdera$program_test$WebGLFix$Internal$enableSetting$ = function (cache, setting) {
	switch (setting.$) {
		case 0:
			return A2(_WebGLFix_enableBlend, cache, setting);
		case 1:
			return A2(_WebGLFix_enableDepthTest, cache, setting);
		case 2:
			return A2(_WebGLFix_enableStencilTest, cache, setting);
		case 3:
			return A2(_WebGLFix_enableScissor, cache, setting);
		case 4:
			return A2(_WebGLFix_enableColorMask, cache, setting);
		case 5:
			return A2(_WebGLFix_enableCullFace, cache, setting);
		case 6:
			return A2(_WebGLFix_enablePolygonOffset, cache, setting);
		case 7:
			return A2(_WebGLFix_enableSampleCoverage, cache, setting);
		default:
			return _WebGLFix_enableSampleAlphaToCoverage(cache);
	}
};
var $lamdera$program_test$WebGLFix$Internal$enableSetting = F2($lamdera$program_test$WebGLFix$Internal$enableSetting$);
var $lamdera$program_test$WebGLFix$endXrSession = $elm$core$Task$map$(
	function (_v0) {
		return 0;
	},
	_WebGLFix_xrEnd(0));
var $elm$core$Task$fail = _Scheduler_fail;
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
var $elm$browser$Browser$Dom$getViewport = _Browser_withWindow(_Browser_getViewport);
var $elm$browser$Browser$Dom$getViewportOf = _Browser_getViewportOf;
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$getZoneName = _Time_getZoneName(0);
var $elm$http$Http$Header$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $elm$http$Http$Header = F2($elm$http$Http$Header$);
var $elm$http$Http$header = $elm$http$Http$Header;
var $elm$time$Time$here = _Time_here(0);
var $lamdera$program_test$WebGLFix$Texture$Resize = $elm$core$Basics$identity;
var $lamdera$program_test$WebGLFix$Texture$linear = 9729;
var $lamdera$program_test$WebGLFix$Texture$linearMipmapLinear = 9987;
var $lamdera$program_test$WebGLFix$Texture$linearMipmapNearest = 9985;
var $lamdera$program_test$WebGLFix$Texture$LoadError = {$: 0};
var $lamdera$program_test$WebGLFix$Texture$SizeError$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $lamdera$program_test$WebGLFix$Texture$SizeError = F2($lamdera$program_test$WebGLFix$Texture$SizeError$);
var $lamdera$program_test$WebGLFix$Texture$loadWith$ = function (_v0, url) {
	var premultiplyAlpha = _v0.premultiplyAlpha;
	var flipY = _v0.flipY;
	var verticalWrap = _v0.verticalWrap;
	var horizontalWrap = _v0.horizontalWrap;
	var minify = _v0.minify;
	var magnify = _v0.magnify;
	var expand = F4(
		function (_v1, _v2, _v3, _v4) {
			var mag = _v1;
			var min = _v2;
			var hor = _v3;
			var vert = _v4;
			return A7(_TextureFix_load, mag, min, hor, vert, flipY, premultiplyAlpha, url);
		});
	return A4(expand, magnify, minify, horizontalWrap, verticalWrap);
};
var $lamdera$program_test$WebGLFix$Texture$loadWith = F2($lamdera$program_test$WebGLFix$Texture$loadWith$);
var $lamdera$program_test$WebGLFix$Texture$mirroredRepeat = 33648;
var $lamdera$program_test$WebGLFix$Texture$nearest = 9728;
var $lamdera$program_test$WebGLFix$Texture$nearestMipmapLinear = 9986;
var $lamdera$program_test$WebGLFix$Texture$nearestMipmapNearest = 9984;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $lamdera$program_test$WebGLFix$renderXrFrame = function (entities) {
	return _WebGLFix_renderXrFrame(entities);
};
var $lamdera$program_test$WebGLFix$Texture$repeat = 10497;
var $lamdera$program_test$WebGLFix$requestXrStart = function (options) {
	return _WebGLFix_requestXrStart(options);
};
var $lamdera$program_test$Websocket$sendString$ = function (connection_, data) {
	return $elm$core$Task$map$(
		function (_v0) {
			return 0;
		},
		A3(_LamderaWebsocket_sendString, 0, connection_, data));
};
var $lamdera$program_test$Websocket$sendString = F2($lamdera$program_test$Websocket$sendString$);
var $elm$browser$Browser$Dom$setViewport = _Browser_setViewport;
var $elm$browser$Browser$Dom$setViewportOf = _Browser_setViewportOf;
var $elm$core$Process$sleep = _Process_sleep;
var $elm$http$Http$stringResolver = A2(_Http_expect, '', $elm$core$Basics$identity);
var $elm$http$Http$resultToTask = function (result) {
	if (!result.$) {
		var a = result.a;
		return $elm$core$Task$succeed(a);
	} else {
		var x = result.a;
		return $elm$core$Task$fail(x);
	}
};
var $elm$http$Http$task = function (r) {
	return A3(
		_Http_toTask,
		0,
		$elm$http$Http$resultToTask,
		{allowCookiesFromOtherDomains: false, body: r.body, expect: r.resolver, headers: r.headers, method: r.method, timeout: r.timeout, tracker: $elm$core$Maybe$Nothing, url: r.url});
};
var $elm$file$File$toBytes = _File_toBytes;
var $elm$http$Http$bytesBody = _Http_pair;
var $elm$http$Http$bytesPart$ = function (key, mime, bytes) {
	return A2(
		_Http_pair,
		key,
		A2(_Http_bytesToBlob, mime, bytes));
};
var $elm$http$Http$bytesPart = F3($elm$http$Http$bytesPart$);
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$http$Http$fileBody = _Http_pair('');
var $elm$http$Http$filePart = _Http_pair;
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $elm$http$Http$multipartBody = function (parts) {
	return A2(
		_Http_pair,
		'',
		_Http_toFormData(parts));
};
var $elm$http$Http$stringBody = _Http_pair;
var $elm$http$Http$stringPart = _Http_pair;
var $lamdera$program_test$Effect$Lamdera$toHttpBody = function (body) {
	switch (body.$) {
		case 0:
			return $elm$http$Http$emptyBody;
		case 1:
			var content = body.a.content;
			var contentType = body.a.contentType;
			return A2($elm$http$Http$stringBody, contentType, content);
		case 2:
			var value = body.a;
			return $elm$http$Http$jsonBody(value);
		case 3:
			var httpParts = body.a;
			return $elm$http$Http$multipartBody(
				$elm$core$List$map$(
					function (part) {
						switch (part.$) {
							case 0:
								var a = part.a;
								var b = part.b;
								return A2($elm$http$Http$stringPart, a, b);
							case 1:
								var a = part.a;
								var b = part.b;
								if (!b.$) {
									var file = b.a;
									return A2($elm$http$Http$filePart, a, file);
								} else {
									return A2($elm$http$Http$stringPart, '', '');
								}
							default:
								var key = part.a;
								var mimeType = part.b;
								var content = part.c;
								return $elm$http$Http$bytesPart$(key, mimeType, content);
						}
					},
					httpParts));
		case 4:
			var a = body.a;
			var b = body.b;
			return A2($elm$http$Http$bytesBody, a, b);
		default:
			var file = body.a;
			if (!file.$) {
				var realFile = file.a;
				return $elm$http$Http$fileBody(realFile);
			} else {
				return $elm$http$Http$emptyBody;
			}
	}
};
var $elm$file$File$toString = _File_toString;
var $elm$file$File$toUrl = _File_toUrl;
var $lamdera$program_test$Effect$Lamdera$httpHelper$ = function (httpRequest, resolver) {
	return A2(
		$elm$core$Task$andThen,
		function (response) {
			return $lamdera$program_test$Effect$Lamdera$toTask(
				httpRequest.onRequestComplete(response));
		},
		$elm$http$Http$task(
			{
				body: $lamdera$program_test$Effect$Lamdera$toHttpBody(httpRequest.body),
				headers: $elm$core$List$map$(
					function (_v17) {
						var key = _v17.a;
						var value = _v17.b;
						return A2($elm$http$Http$header, key, value);
					},
					httpRequest.headers),
				method: httpRequest.method,
				resolver: resolver($elm$core$Result$Ok),
				timeout: $elm$core$Maybe$map$($ianmackenzie$elm_units$Duration$inMilliseconds, httpRequest.timeout),
				url: httpRequest.url
			}));
};
var $lamdera$program_test$Effect$Lamdera$httpHelper = F2($lamdera$program_test$Effect$Lamdera$httpHelper$);
var $lamdera$program_test$Effect$Lamdera$toTask = function (simulatedTask) {
	switch (simulatedTask.$) {
		case 0:
			var a = simulatedTask.a;
			return $elm$core$Task$succeed(a);
		case 1:
			var x = simulatedTask.a;
			return $elm$core$Task$fail(x);
		case 2:
			var httpRequest = simulatedTask.a;
			return $lamdera$program_test$Effect$Lamdera$httpHelper$(httpRequest, $elm$http$Http$stringResolver);
		case 3:
			var httpRequest = simulatedTask.a;
			return $lamdera$program_test$Effect$Lamdera$httpHelper$(httpRequest, $elm$http$Http$bytesResolver);
		case 4:
			var duration = simulatedTask.a;
			var _function = simulatedTask.b;
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $lamdera$program_test$Effect$Lamdera$toTask(
						_function(0));
				},
				$elm$core$Process$sleep(
					$ianmackenzie$elm_units$Duration$inMilliseconds(duration)));
		case 5:
			var gotTime = simulatedTask.a;
			return A2(
				$elm$core$Task$andThen,
				function (time) {
					return $lamdera$program_test$Effect$Lamdera$toTask(
						gotTime(time));
				},
				$elm$time$Time$now);
		case 6:
			var gotTimeZone = simulatedTask.a;
			return A2(
				$elm$core$Task$andThen,
				function (timeZone) {
					return $lamdera$program_test$Effect$Lamdera$toTask(
						gotTimeZone(timeZone));
				},
				$elm$time$Time$here);
		case 7:
			var gotTimeZoneName = simulatedTask.a;
			return A2(
				$elm$core$Task$andThen,
				function (time) {
					return $lamdera$program_test$Effect$Lamdera$toTask(
						gotTimeZoneName(time));
				},
				$elm$time$Time$getZoneName);
		case 11:
			var x = simulatedTask.a;
			var y = simulatedTask.b;
			var _function = simulatedTask.c;
			return A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return $lamdera$program_test$Effect$Lamdera$toTask(
						_function(0));
				},
				A2($elm$browser$Browser$Dom$setViewport, x, y));
		case 10:
			var _function = simulatedTask.a;
			return A2(
				$elm$core$Task$andThen,
				function (viewport) {
					return $lamdera$program_test$Effect$Lamdera$toTask(
						_function(viewport));
				},
				$elm$browser$Browser$Dom$getViewport);
		case 14:
			var string = simulatedTask.a;
			var _function = simulatedTask.b;
			return A2(
				$elm$core$Task$andThen,
				function (result) {
					return $lamdera$program_test$Effect$Lamdera$toTask(
						_function(result));
				},
				A2(
					$elm$core$Task$onError,
					function (_v3) {
						var id = _v3;
						return $elm$core$Task$succeed(
							$elm$core$Result$Err(id));
					},
					$elm$core$Task$map$(
						$elm$core$Result$Ok,
						$elm$browser$Browser$Dom$getElement(string))));
		case 8:
			var string = simulatedTask.a;
			var msg = simulatedTask.b;
			return A2(
				$elm$core$Task$andThen,
				function (result) {
					return $lamdera$program_test$Effect$Lamdera$toTask(
						msg(result));
				},
				A2(
					$elm$core$Task$onError,
					function (_v4) {
						var id = _v4;
						return $elm$core$Task$succeed(
							$elm$core$Result$Err(id));
					},
					$elm$core$Task$map$(
						$elm$core$Result$Ok,
						$elm$browser$Browser$Dom$focus(string))));
		case 9:
			var string = simulatedTask.a;
			var msg = simulatedTask.b;
			return A2(
				$elm$core$Task$andThen,
				function (result) {
					return $lamdera$program_test$Effect$Lamdera$toTask(
						msg(result));
				},
				A2(
					$elm$core$Task$onError,
					function (_v5) {
						var id = _v5;
						return $elm$core$Task$succeed(
							$elm$core$Result$Err(id));
					},
					$elm$core$Task$map$(
						$elm$core$Result$Ok,
						$elm$browser$Browser$Dom$blur(string))));
		case 12:
			var string = simulatedTask.a;
			var msg = simulatedTask.b;
			return A2(
				$elm$core$Task$andThen,
				function (result) {
					return $lamdera$program_test$Effect$Lamdera$toTask(
						msg(result));
				},
				A2(
					$elm$core$Task$onError,
					function (_v6) {
						var id = _v6;
						return $elm$core$Task$succeed(
							$elm$core$Result$Err(id));
					},
					$elm$core$Task$map$(
						$elm$core$Result$Ok,
						$elm$browser$Browser$Dom$getViewportOf(string))));
		case 13:
			var string = simulatedTask.a;
			var x = simulatedTask.b;
			var y = simulatedTask.c;
			var msg = simulatedTask.d;
			return A2(
				$elm$core$Task$andThen,
				function (result) {
					return $lamdera$program_test$Effect$Lamdera$toTask(
						msg(result));
				},
				A2(
					$elm$core$Task$onError,
					function (_v7) {
						var id = _v7;
						return $elm$core$Task$succeed(
							$elm$core$Result$Err(id));
					},
					$elm$core$Task$map$(
						$elm$core$Result$Ok,
						A3($elm$browser$Browser$Dom$setViewportOf, string, x, y))));
		case 15:
			var file = simulatedTask.a;
			var _function = simulatedTask.b;
			if (!file.$) {
				var file_ = file.a;
				return A2(
					$elm$core$Task$andThen,
					function (result) {
						return $lamdera$program_test$Effect$Lamdera$toTask(
							_function(result));
					},
					$elm$file$File$toString(file_));
			} else {
				var content = file.a.content;
				return $lamdera$program_test$Effect$Lamdera$toTask(
					_function(
						function () {
							if (content.$ === 1) {
								var a = content.a;
								return a;
							} else {
								var a = content.a;
								return $elm$core$Maybe$withDefault$(
									'',
									$elm$bytes$Bytes$Decode$decode$(
										$elm$bytes$Bytes$Decode$string(
											$elm$bytes$Bytes$width(a)),
										a));
							}
						}()));
			}
		case 16:
			var file = simulatedTask.a;
			var _function = simulatedTask.b;
			if (!file.$) {
				var file_ = file.a;
				return A2(
					$elm$core$Task$andThen,
					function (result) {
						return $lamdera$program_test$Effect$Lamdera$toTask(
							_function(result));
					},
					$elm$file$File$toBytes(file_));
			} else {
				var content = file.a.content;
				return $lamdera$program_test$Effect$Lamdera$toTask(
					_function(
						function () {
							if (content.$ === 1) {
								var a = content.a;
								return $elm$bytes$Bytes$Encode$encode(
									$elm$bytes$Bytes$Encode$string(a));
							} else {
								var a = content.a;
								return a;
							}
						}()));
			}
		case 17:
			var file = simulatedTask.a;
			var _function = simulatedTask.b;
			if (!file.$) {
				var file_ = file.a;
				return A2(
					$elm$core$Task$andThen,
					function (result) {
						return $lamdera$program_test$Effect$Lamdera$toTask(
							_function(result));
					},
					$elm$file$File$toUrl(file_));
			} else {
				var content = file.a.content;
				return $lamdera$program_test$Effect$Lamdera$toTask(
					_function(
						function () {
							if (content.$ === 1) {
								var a = content.a;
								return 'data:*/*;base64,' + $elm$core$Maybe$withDefault$(
									'',
									$danfishgold$base64_bytes$Base64$fromString(a));
							} else {
								var a = content.a;
								return 'data:*/*;base64,' + $elm$core$Maybe$withDefault$(
									'',
									$danfishgold$base64_bytes$Base64$fromBytes(a));
							}
						}()));
			}
		case 18:
			var options = simulatedTask.a;
			var string = simulatedTask.b;
			var _function = simulatedTask.c;
			var convertWrap = function (wrap) {
				switch (wrap) {
					case 0:
						return $lamdera$program_test$WebGLFix$Texture$repeat;
					case 1:
						return $lamdera$program_test$WebGLFix$Texture$clampToEdge;
					default:
						return $lamdera$program_test$WebGLFix$Texture$mirroredRepeat;
				}
			};
			return A2(
				$elm$core$Task$andThen,
				function (result) {
					return $lamdera$program_test$Effect$Lamdera$toTask(
						_function(result));
				},
				A2(
					$elm$core$Task$onError,
					A2($elm$core$Basics$composeR, $elm$core$Result$Err, $elm$core$Task$succeed),
					$elm$core$Task$map$(
						$elm$core$Result$Ok,
						$lamdera$program_test$WebGLFix$Texture$loadWith$(
							{
								flipY: options.flipY,
								horizontalWrap: convertWrap(options.horizontalWrap),
								magnify: function () {
									var _v14 = options.magnify;
									if (!_v14) {
										return $lamdera$program_test$WebGLFix$Texture$linear;
									} else {
										return $lamdera$program_test$WebGLFix$Texture$nearest;
									}
								}(),
								minify: function () {
									var _v15 = options.minify;
									switch (_v15) {
										case 0:
											return $lamdera$program_test$WebGLFix$Texture$linear;
										case 1:
											return $lamdera$program_test$WebGLFix$Texture$nearest;
										case 2:
											return $lamdera$program_test$WebGLFix$Texture$nearestMipmapNearest;
										case 3:
											return $lamdera$program_test$WebGLFix$Texture$linearMipmapNearest;
										case 4:
											return $lamdera$program_test$WebGLFix$Texture$nearestMipmapLinear;
										default:
											return $lamdera$program_test$WebGLFix$Texture$linearMipmapLinear;
									}
								}(),
								premultiplyAlpha: options.premultiplyAlpha,
								verticalWrap: convertWrap(options.verticalWrap)
							},
							string))));
		case 19:
			var options = simulatedTask.a;
			var _function = simulatedTask.b;
			return A2(
				$elm$core$Task$andThen,
				function (result) {
					return $lamdera$program_test$Effect$Lamdera$toTask(
						_function(result));
				},
				A2(
					$elm$core$Task$onError,
					A2($elm$core$Basics$composeR, $elm$core$Result$Err, $elm$core$Task$succeed),
					$elm$core$Task$map$(
						$elm$core$Result$Ok,
						$lamdera$program_test$WebGLFix$requestXrStart(options))));
		case 20:
			var entities = simulatedTask.a;
			var _function = simulatedTask.b;
			return A2(
				$elm$core$Task$andThen,
				function (result) {
					return $lamdera$program_test$Effect$Lamdera$toTask(
						_function(result));
				},
				A2(
					$elm$core$Task$onError,
					A2($elm$core$Basics$composeR, $elm$core$Result$Err, $elm$core$Task$succeed),
					$elm$core$Task$map$(
						$elm$core$Result$Ok,
						$lamdera$program_test$WebGLFix$renderXrFrame(entities))));
		case 21:
			var _function = simulatedTask.a;
			return A2(
				$elm$core$Task$andThen,
				function (result) {
					return $lamdera$program_test$Effect$Lamdera$toTask(
						_function(result));
				},
				$lamdera$program_test$WebGLFix$endXrSession);
		case 22:
			var url = simulatedTask.a;
			var _function = simulatedTask.b;
			return A2(
				$elm$core$Task$andThen,
				function (result) {
					return $lamdera$program_test$Effect$Lamdera$toTask(
						_function(result));
				},
				$lamdera$program_test$Websocket$createHandle(url));
		case 23:
			var connection = simulatedTask.a;
			var data = simulatedTask.b;
			var _function = simulatedTask.c;
			return A2(
				$elm$core$Task$andThen,
				function (result) {
					return $lamdera$program_test$Effect$Lamdera$toTask(
						_function(result));
				},
				A2(
					$elm$core$Task$onError,
					A2($elm$core$Basics$composeR, $elm$core$Result$Err, $elm$core$Task$succeed),
					$elm$core$Task$map$(
						$elm$core$Result$Ok,
						$lamdera$program_test$Websocket$sendString$(connection, data))));
		default:
			var connection = simulatedTask.a;
			var _function = simulatedTask.b;
			return A2(
				$elm$core$Task$andThen,
				function (result) {
					return $lamdera$program_test$Effect$Lamdera$toTask(
						_function(result));
				},
				$lamdera$program_test$Websocket$close(connection));
	}
};
var $elm$http$Http$expectBytesResponse$ = function (toMsg, toResult) {
	return A3(
		_Http_expect,
		'arraybuffer',
		_Http_toDataView,
		A2($elm$core$Basics$composeR, toResult, toMsg));
};
var $elm$http$Http$expectBytesResponse = F2($elm$http$Http$expectBytesResponse$);
var $elm$http$Http$expectStringResponse$ = function (toMsg, toResult) {
	return A3(
		_Http_expect,
		'',
		$elm$core$Basics$identity,
		A2($elm$core$Basics$composeR, toResult, toMsg));
};
var $elm$http$Http$expectStringResponse = F2($elm$http$Http$expectStringResponse$);
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{allowCookiesFromOtherDomains: false, body: r.body, expect: r.expect, headers: r.headers, method: r.method, timeout: r.timeout, tracker: r.tracker, url: r.url}));
};
var $elm$http$Http$riskyRequest = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{allowCookiesFromOtherDomains: true, body: r.body, expect: r.expect, headers: r.headers, method: r.method, timeout: r.timeout, tracker: r.tracker, url: r.url}));
};
var $lamdera$program_test$Effect$Lamdera$trackedHttpRequestCmd = function (httpRequest) {
	var toMsg = function (result) {
		if (!result.$) {
			var msg = result.a;
			return msg;
		} else {
			var msg = result.a;
			return msg;
		}
	};
	var request = {
		body: $lamdera$program_test$Effect$Lamdera$toHttpBody(httpRequest.body),
		expect: function () {
			var _v0 = httpRequest.expect;
			if (!_v0.$) {
				var onRequestComplete = _v0.a;
				return $elm$http$Http$expectStringResponse$(
					toMsg,
					function (response) {
						return $elm$core$Result$Ok(
							onRequestComplete(response));
					});
			} else {
				var onRequestComplete = _v0.a;
				return $elm$http$Http$expectBytesResponse$(
					toMsg,
					function (response) {
						return $elm$core$Result$Ok(
							onRequestComplete(response));
					});
			}
		}(),
		headers: $elm$core$List$map$(
			function (_v1) {
				var key = _v1.a;
				var value = _v1.b;
				return A2($elm$http$Http$header, key, value);
			},
			httpRequest.headers),
		method: httpRequest.method,
		timeout: $elm$core$Maybe$map$($ianmackenzie$elm_units$Duration$inMilliseconds, httpRequest.timeout),
		tracker: $elm$core$Maybe$Just(httpRequest.tracker),
		url: httpRequest.url
	};
	return httpRequest.isRisky ? $elm$http$Http$riskyRequest(request) : $elm$http$Http$request(request);
};
var $elm$file$File$Download$url = function (href) {
	return $elm$core$Task$perform$(
		$elm$core$Basics$never,
		_File_downloadUrl(href));
};
var $lamdera$program_test$Effect$Lamdera$toCmd$ = function (broadcastCmd, toFrontendCmd, toBackendCmd, effect) {
	switch (effect.$) {
		case 0:
			var effects = effect.a;
			return $elm$core$Platform$Cmd$batch(
				$elm$core$List$map$(
					A3($lamdera$program_test$Effect$Lamdera$toCmd, broadcastCmd, toFrontendCmd, toBackendCmd),
					effects));
		case 1:
			return $elm$core$Platform$Cmd$none;
		case 2:
			var toBackend = effect.a;
			return toBackendCmd(toBackend);
		case 3:
			var navigationKey = effect.a;
			var string = effect.b;
			if (!navigationKey.$) {
				var key = navigationKey.a;
				return A2($elm$browser$Browser$Navigation$pushUrl, key, string);
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		case 4:
			var navigationKey = effect.a;
			var string = effect.b;
			if (!navigationKey.$) {
				var key = navigationKey.a;
				return A2($elm$browser$Browser$Navigation$replaceUrl, key, string);
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		case 7:
			var url = effect.a;
			return $elm$browser$Browser$Navigation$load(url);
		case 5:
			var navigationKey = effect.a;
			var _int = effect.b;
			if (!navigationKey.$) {
				var key = navigationKey.a;
				return $elm$browser$Browser$Navigation$back$(key, _int);
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		case 6:
			var navigationKey = effect.a;
			var _int = effect.b;
			if (!navigationKey.$) {
				var key = navigationKey.a;
				return A2($elm$browser$Browser$Navigation$forward, key, _int);
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		case 8:
			return $elm$browser$Browser$Navigation$reload;
		case 9:
			return $elm$browser$Browser$Navigation$reloadAndSkipCache;
		case 10:
			var simulatedTask = effect.a;
			return $elm$core$Task$attempt$(
				function (result) {
					if (!result.$) {
						var ok = result.a;
						return ok;
					} else {
						var err = result.a;
						return err;
					}
				},
				$lamdera$program_test$Effect$Lamdera$toTask(simulatedTask));
		case 11:
			var portFunction = effect.b;
			var value = effect.c;
			return portFunction(value);
		case 12:
			var portFunction = effect.b;
			var value = effect.c;
			return portFunction(value);
		case 13:
			var clientId = effect.a;
			var toFrontend = effect.b;
			return A2(toFrontendCmd, clientId, toFrontend);
		case 14:
			var sessionId = effect.a;
			var toFrontend = effect.b;
			return A2(toFrontendCmd, sessionId, toFrontend);
		case 16:
			var href = effect.a.href;
			return $elm$file$File$Download$url(href);
		case 17:
			var content = effect.a.content;
			var mimeType = effect.a.mimeType;
			var name = effect.a.name;
			return $elm$file$File$Download$string$(name, mimeType, content);
		case 18:
			var content = effect.a.content;
			var mimeType = effect.a.mimeType;
			var name = effect.a.name;
			return $elm$file$File$Download$bytes$(name, mimeType, content);
		case 19:
			var mimeTypes = effect.a;
			var msg = effect.b;
			return $elm$file$File$Select$file$(
				mimeTypes,
				A2($elm$core$Basics$composeR, $lamdera$program_test$Effect$Internal$RealFile, msg));
		case 20:
			var mimeTypes = effect.a;
			var msg = effect.b;
			return $elm$file$File$Select$files$(
				mimeTypes,
				F2(
					function (file, restOfFiles) {
						return A2(
							msg,
							$lamdera$program_test$Effect$Internal$RealFile(file),
							$elm$core$List$map$($lamdera$program_test$Effect$Internal$RealFile, restOfFiles));
					}));
		case 15:
			var toMsg = effect.a;
			return broadcastCmd(toMsg);
		case 21:
			var string = effect.a;
			return $elm$http$Http$cancel(string);
		case 22:
			var httpRequest = effect.a;
			return $lamdera$program_test$Effect$Lamdera$trackedHttpRequestCmd(httpRequest);
		default:
			var cmd = effect.a;
			return cmd;
	}
};
var $lamdera$program_test$Effect$Lamdera$toCmd = F4($lamdera$program_test$Effect$Lamdera$toCmd$);
var $lamdera$program_test$Effect$Internal$ClientId = $elm$core$Basics$identity;
var $lamdera$program_test$Effect$Internal$Hidden = 1;
var $lamdera$program_test$Effect$Internal$SessionId = $elm$core$Basics$identity;
var $lamdera$program_test$Effect$Internal$Visible = 0;
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$time$Time$Every$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $elm$time$Time$Every = F2($elm$time$Time$Every$);
var $elm$time$Time$State$ = function (taggers, processes) {
	return {processes: processes, taggers: taggers};
};
var $elm$time$Time$State = F2($elm$time$Time$State$);
var $elm$time$Time$init = $elm$core$Task$succeed(
	$elm$time$Time$State$($elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$time$Time$addMySub$ = function (_v0, state) {
	var interval = _v0.a;
	var tagger = _v0.b;
	var _v1 = $elm$core$Dict$get$(interval, state);
	if (_v1.$ === 1) {
		return $elm$core$Dict$insert$(
			interval,
			_List_fromArray(
				[tagger]),
			state);
	} else {
		var taggers = _v1.a;
		return $elm$core$Dict$insert$(
			interval,
			A2($elm$core$List$cons, tagger, taggers),
			state);
	}
};
var $elm$time$Time$addMySub = F2($elm$time$Time$addMySub$);
var $elm$core$Dict$merge$ = function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
	var stepState = F3(
		function (rKey, rValue, _v0) {
			stepState:
			while (true) {
				var list = _v0.a;
				var result = _v0.b;
				if (!list.b) {
					return _Utils_Tuple2(
						list,
						A3(rightStep, rKey, rValue, result));
				} else {
					var _v2 = list.a;
					var lKey = _v2.a;
					var lValue = _v2.b;
					var rest = list.b;
					if (_Utils_cmp(lKey, rKey) < 0) {
						var $temp$_v0 = _Utils_Tuple2(
							rest,
							A3(leftStep, lKey, lValue, result));
						_v0 = $temp$_v0;
						continue stepState;
					} else {
						if (_Utils_cmp(lKey, rKey) > 0) {
							return _Utils_Tuple2(
								list,
								A3(rightStep, rKey, rValue, result));
						} else {
							return _Utils_Tuple2(
								rest,
								A4(bothStep, lKey, lValue, rValue, result));
						}
					}
				}
			}
		});
	var _v3 = $elm$core$Dict$foldl$(
		stepState,
		_Utils_Tuple2(
			$elm$core$Dict$toList(leftDict),
			initialResult),
		rightDict);
	var leftovers = _v3.a;
	var intermediateResult = _v3.b;
	return $elm$core$List$foldl$(
		F2(
			function (_v4, result) {
				var k = _v4.a;
				var v = _v4.b;
				return A3(leftStep, k, v, result);
			}),
		intermediateResult,
		leftovers);
};
var $elm$core$Dict$merge = F6($elm$core$Dict$merge$);
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$time$Time$spawnHelp$ = function (router, intervals, processes) {
	if (!intervals.b) {
		return $elm$core$Task$succeed(processes);
	} else {
		var interval = intervals.a;
		var rest = intervals.b;
		var spawnTimer = $elm$core$Process$spawn(
			A2(
				$elm$time$Time$setInterval,
				interval,
				A2($elm$core$Platform$sendToSelf, router, interval)));
		var spawnRest = function (id) {
			return $elm$time$Time$spawnHelp$(
				router,
				rest,
				$elm$core$Dict$insert$(interval, id, processes));
		};
		return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
	}
};
var $elm$time$Time$spawnHelp = F3($elm$time$Time$spawnHelp$);
var $elm$time$Time$onEffects$ = function (router, subs, _v0) {
	var processes = _v0.processes;
	var rightStep = F3(
		function (_v6, id, _v7) {
			var spawns = _v7.a;
			var existing = _v7.b;
			var kills = _v7.c;
			return _Utils_Tuple3(
				spawns,
				existing,
				A2(
					$elm$core$Task$andThen,
					function (_v5) {
						return kills;
					},
					$elm$core$Process$kill(id)));
		});
	var newTaggers = $elm$core$List$foldl$($elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
	var leftStep = F3(
		function (interval, taggers, _v4) {
			var spawns = _v4.a;
			var existing = _v4.b;
			var kills = _v4.c;
			return _Utils_Tuple3(
				A2($elm$core$List$cons, interval, spawns),
				existing,
				kills);
		});
	var bothStep = F4(
		function (interval, taggers, id, _v3) {
			var spawns = _v3.a;
			var existing = _v3.b;
			var kills = _v3.c;
			return _Utils_Tuple3(
				spawns,
				$elm$core$Dict$insert$(interval, id, existing),
				kills);
		});
	var _v1 = $elm$core$Dict$merge$(
		leftStep,
		bothStep,
		rightStep,
		newTaggers,
		processes,
		_Utils_Tuple3(
			_List_Nil,
			$elm$core$Dict$empty,
			$elm$core$Task$succeed(0)));
	var spawnList = _v1.a;
	var existingDict = _v1.b;
	var killTask = _v1.c;
	return A2(
		$elm$core$Task$andThen,
		function (newProcesses) {
			return $elm$core$Task$succeed(
				$elm$time$Time$State$(newTaggers, newProcesses));
		},
		A2(
			$elm$core$Task$andThen,
			function (_v2) {
				return $elm$time$Time$spawnHelp$(router, spawnList, existingDict);
			},
			killTask));
};
var $elm$time$Time$onEffects = F3($elm$time$Time$onEffects$);
var $elm$time$Time$onSelfMsg$ = function (router, interval, state) {
	var _v0 = $elm$core$Dict$get$(interval, state.taggers);
	if (_v0.$ === 1) {
		return $elm$core$Task$succeed(state);
	} else {
		var taggers = _v0.a;
		var tellTaggers = function (time) {
			return $elm$core$Task$sequence(
				$elm$core$List$map$(
					function (tagger) {
						return A2(
							$elm$core$Platform$sendToApp,
							router,
							tagger(time));
					},
					taggers));
		};
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
	}
};
var $elm$time$Time$onSelfMsg = F3($elm$time$Time$onSelfMsg$);
var $elm$time$Time$subMap$ = function (f, _v0) {
	var interval = _v0.a;
	var tagger = _v0.b;
	return $elm$time$Time$Every$(
		interval,
		A2($elm$core$Basics$composeL, f, tagger));
};
var $elm$time$Time$subMap = F2($elm$time$Time$subMap$);
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every$ = function (interval, tagger) {
	return $elm$time$Time$subscription(
		$elm$time$Time$Every$(interval, tagger));
};
var $elm$time$Time$every = F2($elm$time$Time$every$);
var $lamdera$program_test$Websocket$Listen$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $lamdera$program_test$Websocket$Listen = F3($lamdera$program_test$Websocket$Listen$);
var $lamdera$program_test$Websocket$init = $elm$core$Task$succeed(
	{connections: $elm$core$Dict$empty});
var $lamdera$program_test$Websocket$onEffects$ = function (router, _v0, subs, state) {
	var handleSubs = F2(
		function (remainingSubs, newDict) {
			handleSubs:
			while (true) {
				if (!remainingSubs.b) {
					return $elm$core$Task$succeed(newDict);
				} else {
					var _v2 = remainingSubs.a;
					var connection_ = _v2.a;
					var connectionId = connection_.a;
					var onData = _v2.b;
					var onClose = _v2.c;
					var rest = remainingSubs.b;
					var _v3 = $elm$core$Dict$get$(connectionId, newDict);
					if (!_v3.$) {
						var _v4 = _v3.a;
						var pid = _v4.a;
						var msgs = _v4.b;
						var $temp$remainingSubs = rest,
							$temp$newDict = $elm$core$Dict$insert$(
							connectionId,
							_Utils_Tuple2(
								pid,
								A2(
									$elm$core$List$cons,
									{onClose: onClose, onData: onData},
									msgs)),
							newDict);
						remainingSubs = $temp$remainingSubs;
						newDict = $temp$newDict;
						continue handleSubs;
					} else {
						return A2(
							$elm$core$Task$andThen,
							function (pid) {
								return A2(
									handleSubs,
									rest,
									$elm$core$Dict$insert$(
										connectionId,
										_Utils_Tuple2(
											pid,
											_List_fromArray(
												[
													{onClose: onClose, onData: onData}
												])),
										newDict));
							},
							$elm$core$Process$spawn(
								A2(_LamderaWebsocket_listen, router, connection_)));
					}
				}
			}
		});
	return $elm$core$Task$map$(
		function (dict) {
			return _Utils_update(
				state,
				{connections: dict});
		},
		A2(
			handleSubs,
			subs,
			$elm$core$Dict$map$(
				F2(
					function (_v5, _v6) {
						var pid = _v6.a;
						return _Utils_Tuple2(pid, _List_Nil);
					}),
				state.connections)));
};
var $lamdera$program_test$Websocket$onEffects = F4($lamdera$program_test$Websocket$onEffects$);
var $lamdera$program_test$Websocket$onSelfMsg$ = function (router, _v0, state) {
	var _v1 = _v0.a;
	var connectionId = _v1.a;
	var event = _v0.b;
	var _v2 = $elm$core$Dict$get$(connectionId, state.connections);
	if (!_v2.$) {
		var _v3 = _v2.a;
		var msgs = _v3.b;
		if (event.$ === 1) {
			var data = event.a;
			return $elm$core$Task$map$(
				function (_v6) {
					return state;
				},
				$elm$core$Task$sequence(
					$elm$core$List$map$(
						function (_v5) {
							var onClose = _v5.onClose;
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								onClose(data));
						},
						msgs)));
		} else {
			var data = event.a;
			return $elm$core$Task$map$(
				function (_v8) {
					return state;
				},
				$elm$core$Task$sequence(
					$elm$core$List$map$(
						function (_v7) {
							var onData = _v7.onData;
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								onData(data));
						},
						msgs)));
		}
	} else {
		return $elm$core$Task$succeed(state);
	}
};
var $lamdera$program_test$Websocket$onSelfMsg = F3($lamdera$program_test$Websocket$onSelfMsg$);
var $lamdera$program_test$Websocket$CloseConnection = function (a) {
	return {$: 2, a: a};
};
var $lamdera$program_test$Websocket$OpenConnection$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $lamdera$program_test$Websocket$OpenConnection = F2($lamdera$program_test$Websocket$OpenConnection$);
var $lamdera$program_test$Websocket$SentData$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $lamdera$program_test$Websocket$SentData = F2($lamdera$program_test$Websocket$SentData$);
var $lamdera$program_test$Websocket$cmdMap$ = function (f, cmd) {
	switch (cmd.$) {
		case 0:
			var connection_ = cmd.a;
			var data = cmd.b;
			return $lamdera$program_test$Websocket$SentData$(connection_, data);
		case 1:
			var url = cmd.a;
			var onOpen = cmd.b;
			return $lamdera$program_test$Websocket$OpenConnection$(
				url,
				function (a) {
					return f(
						onOpen(a));
				});
		default:
			var connection_ = cmd.a;
			return $lamdera$program_test$Websocket$CloseConnection(connection_);
	}
};
var $lamdera$program_test$Websocket$cmdMap = F2($lamdera$program_test$Websocket$cmdMap$);
var $lamdera$program_test$Websocket$subMap$ = function (func, sub) {
	var url = sub.a;
	var onData = sub.b;
	var onClose = sub.c;
	return $lamdera$program_test$Websocket$Listen$(
		url,
		function (a) {
			return func(
				onData(a));
		},
		function (a) {
			return func(
				onClose(a));
		});
};
var $lamdera$program_test$Websocket$subMap = F2($lamdera$program_test$Websocket$subMap$);
_Platform_effectManagers['Websocket'] = _Platform_createManager($lamdera$program_test$Websocket$init, $lamdera$program_test$Websocket$onEffects, $lamdera$program_test$Websocket$onSelfMsg, $lamdera$program_test$Websocket$cmdMap, $lamdera$program_test$Websocket$subMap);
var $lamdera$program_test$Websocket$command = _Platform_leaf('Websocket');
var $lamdera$program_test$Websocket$subscription = _Platform_leaf('Websocket');
var $lamdera$program_test$Websocket$listen$ = function (connection_, onData, onClose) {
	return $lamdera$program_test$Websocket$subscription(
		$lamdera$program_test$Websocket$Listen$(connection_, onData, onClose));
};
var $lamdera$program_test$Websocket$listen = F3($lamdera$program_test$Websocket$listen$);
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $elm$browser$Browser$AnimationManager$Time = function (a) {
	return {$: 0, a: a};
};
var $elm$browser$Browser$AnimationManager$State$ = function (subs, request, oldTime) {
	return {oldTime: oldTime, request: request, subs: subs};
};
var $elm$browser$Browser$AnimationManager$State = F3($elm$browser$Browser$AnimationManager$State$);
var $elm$browser$Browser$AnimationManager$init = $elm$core$Task$succeed(
	$elm$browser$Browser$AnimationManager$State$(_List_Nil, $elm$core$Maybe$Nothing, 0));
var $elm$browser$Browser$AnimationManager$now = _Browser_now(0);
var $elm$browser$Browser$AnimationManager$rAF = _Browser_rAF(0);
var $elm$browser$Browser$AnimationManager$onEffects$ = function (router, subs, _v0) {
	var oldTime = _v0.oldTime;
	var request = _v0.request;
	var _v1 = _Utils_Tuple2(request, subs);
	if (_v1.a.$ === 1) {
		if (!_v1.b.b) {
			var _v2 = _v1.a;
			return $elm$browser$Browser$AnimationManager$init;
		} else {
			var _v4 = _v1.a;
			return A2(
				$elm$core$Task$andThen,
				function (pid) {
					return A2(
						$elm$core$Task$andThen,
						function (time) {
							return $elm$core$Task$succeed(
								$elm$browser$Browser$AnimationManager$State$(
									subs,
									$elm$core$Maybe$Just(pid),
									time));
						},
						$elm$browser$Browser$AnimationManager$now);
				},
				$elm$core$Process$spawn(
					A2(
						$elm$core$Task$andThen,
						$elm$core$Platform$sendToSelf(router),
						$elm$browser$Browser$AnimationManager$rAF)));
		}
	} else {
		if (!_v1.b.b) {
			var pid = _v1.a.a;
			return A2(
				$elm$core$Task$andThen,
				function (_v3) {
					return $elm$browser$Browser$AnimationManager$init;
				},
				$elm$core$Process$kill(pid));
		} else {
			return $elm$core$Task$succeed(
				$elm$browser$Browser$AnimationManager$State$(subs, request, oldTime));
		}
	}
};
var $elm$browser$Browser$AnimationManager$onEffects = F3($elm$browser$Browser$AnimationManager$onEffects$);
var $elm$browser$Browser$AnimationManager$onSelfMsg$ = function (router, newTime, _v0) {
	var oldTime = _v0.oldTime;
	var subs = _v0.subs;
	var send = function (sub) {
		if (!sub.$) {
			var tagger = sub.a;
			return A2(
				$elm$core$Platform$sendToApp,
				router,
				tagger(
					$elm$time$Time$millisToPosix(newTime)));
		} else {
			var tagger = sub.a;
			return A2(
				$elm$core$Platform$sendToApp,
				router,
				tagger(newTime - oldTime));
		}
	};
	return A2(
		$elm$core$Task$andThen,
		function (pid) {
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(
						$elm$browser$Browser$AnimationManager$State$(
							subs,
							$elm$core$Maybe$Just(pid),
							newTime));
				},
				$elm$core$Task$sequence(
					$elm$core$List$map$(send, subs)));
		},
		$elm$core$Process$spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToSelf(router),
				$elm$browser$Browser$AnimationManager$rAF)));
};
var $elm$browser$Browser$AnimationManager$onSelfMsg = F3($elm$browser$Browser$AnimationManager$onSelfMsg$);
var $elm$browser$Browser$AnimationManager$Delta = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$AnimationManager$subMap$ = function (func, sub) {
	if (!sub.$) {
		var tagger = sub.a;
		return $elm$browser$Browser$AnimationManager$Time(
			A2($elm$core$Basics$composeL, func, tagger));
	} else {
		var tagger = sub.a;
		return $elm$browser$Browser$AnimationManager$Delta(
			A2($elm$core$Basics$composeL, func, tagger));
	}
};
var $elm$browser$Browser$AnimationManager$subMap = F2($elm$browser$Browser$AnimationManager$subMap$);
_Platform_effectManagers['Browser.AnimationManager'] = _Platform_createManager($elm$browser$Browser$AnimationManager$init, $elm$browser$Browser$AnimationManager$onEffects, $elm$browser$Browser$AnimationManager$onSelfMsg, 0, $elm$browser$Browser$AnimationManager$subMap);
var $elm$browser$Browser$AnimationManager$subscription = _Platform_leaf('Browser.AnimationManager');
var $elm$browser$Browser$AnimationManager$onAnimationFrame = function (tagger) {
	return $elm$browser$Browser$AnimationManager$subscription(
		$elm$browser$Browser$AnimationManager$Time(tagger));
};
var $elm$browser$Browser$Events$onAnimationFrame = $elm$browser$Browser$AnimationManager$onAnimationFrame;
var $elm$browser$Browser$AnimationManager$onAnimationFrameDelta = function (tagger) {
	return $elm$browser$Browser$AnimationManager$subscription(
		$elm$browser$Browser$AnimationManager$Delta(tagger));
};
var $elm$browser$Browser$Events$onAnimationFrameDelta = $elm$browser$Browser$AnimationManager$onAnimationFrameDelta;
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$MySub$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $elm$browser$Browser$Events$MySub = F3($elm$browser$Browser$Events$MySub$);
var $elm$browser$Browser$Events$State$ = function (subs, pids) {
	return {pids: pids, subs: subs};
};
var $elm$browser$Browser$Events$State = F2($elm$browser$Browser$Events$State$);
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	$elm$browser$Browser$Events$State$(_List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$browser$Browser$Events$Event$ = function (key, event) {
	return {event: event, key: key};
};
var $elm$browser$Browser$Events$Event = F2($elm$browser$Browser$Events$Event$);
var $elm$browser$Browser$Events$spawn$ = function (router, key, _v0) {
	var node = _v0.a;
	var name = _v0.b;
	var actualNode = function () {
		if (!node) {
			return _Browser_doc;
		} else {
			return _Browser_window;
		}
	}();
	return $elm$core$Task$map$(
		function (value) {
			return _Utils_Tuple2(key, value);
		},
		A3(
			_Browser_on,
			actualNode,
			name,
			function (event) {
				return A2(
					$elm$core$Platform$sendToSelf,
					router,
					$elm$browser$Browser$Events$Event$(key, event));
			}));
};
var $elm$browser$Browser$Events$spawn = F3($elm$browser$Browser$Events$spawn$);
var $elm$browser$Browser$Events$onEffects$ = function (router, subs, state) {
	var stepRight = F3(
		function (key, sub, _v6) {
			var deads = _v6.a;
			var lives = _v6.b;
			var news = _v6.c;
			return _Utils_Tuple3(
				deads,
				lives,
				A2(
					$elm$core$List$cons,
					$elm$browser$Browser$Events$spawn$(router, key, sub),
					news));
		});
	var stepLeft = F3(
		function (_v4, pid, _v5) {
			var deads = _v5.a;
			var lives = _v5.b;
			var news = _v5.c;
			return _Utils_Tuple3(
				A2($elm$core$List$cons, pid, deads),
				lives,
				news);
		});
	var stepBoth = F4(
		function (key, pid, _v2, _v3) {
			var deads = _v3.a;
			var lives = _v3.b;
			var news = _v3.c;
			return _Utils_Tuple3(
				deads,
				$elm$core$Dict$insert$(key, pid, lives),
				news);
		});
	var newSubs = $elm$core$List$map$($elm$browser$Browser$Events$addKey, subs);
	var _v0 = $elm$core$Dict$merge$(
		stepLeft,
		stepBoth,
		stepRight,
		state.pids,
		$elm$core$Dict$fromList(newSubs),
		_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
	var deadPids = _v0.a;
	var livePids = _v0.b;
	var makeNewPids = _v0.c;
	return A2(
		$elm$core$Task$andThen,
		function (pids) {
			return $elm$core$Task$succeed(
				$elm$browser$Browser$Events$State$(
					newSubs,
					$elm$core$Dict$union$(
						livePids,
						$elm$core$Dict$fromList(pids))));
		},
		A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$sequence(makeNewPids);
			},
			$elm$core$Task$sequence(
				$elm$core$List$map$($elm$core$Process$kill, deadPids))));
};
var $elm$browser$Browser$Events$onEffects = F3($elm$browser$Browser$Events$onEffects$);
var $elm$browser$Browser$Events$onSelfMsg$ = function (router, _v0, state) {
	var event = _v0.event;
	var key = _v0.key;
	var toMessage = function (_v2) {
		var subKey = _v2.a;
		var _v3 = _v2.b;
		var node = _v3.a;
		var name = _v3.b;
		var decoder = _v3.c;
		return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
	};
	var messages = $elm$core$List$filterMap$(toMessage, state.subs);
	return A2(
		$elm$core$Task$andThen,
		function (_v1) {
			return $elm$core$Task$succeed(state);
		},
		$elm$core$Task$sequence(
			$elm$core$List$map$(
				$elm$core$Platform$sendToApp(router),
				messages)));
};
var $elm$browser$Browser$Events$onSelfMsg = F3($elm$browser$Browser$Events$onSelfMsg$);
var $elm$browser$Browser$Events$subMap$ = function (func, _v0) {
	var node = _v0.a;
	var name = _v0.b;
	var decoder = _v0.c;
	return $elm$browser$Browser$Events$MySub$(
		node,
		name,
		A2($elm$json$Json$Decode$map, func, decoder));
};
var $elm$browser$Browser$Events$subMap = F2($elm$browser$Browser$Events$subMap$);
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on$ = function (node, name, decoder) {
	return $elm$browser$Browser$Events$subscription(
		$elm$browser$Browser$Events$MySub$(node, name, decoder));
};
var $elm$browser$Browser$Events$on = F3($elm$browser$Browser$Events$on$);
var $elm$browser$Browser$Events$onClick = A2($elm$browser$Browser$Events$on, 0, 'click');
var $lamdera$core$Lamdera$Effect$ClientConnected = function (a) {
	return {$: 0, a: a};
};
var $lamdera$core$Lamdera$Effect$init = $elm$core$Task$succeed(0);
var $lamdera$core$Lamdera$Effect$BEtoFE$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $lamdera$core$Lamdera$Effect$BEtoFE = F2($lamdera$core$Lamdera$Effect$BEtoFE$);
var $lamdera$core$Lamdera$Effect$FEtoBE = function (a) {
	return {$: 0, a: a};
};
var $lamdera$core$Lamdera$Effect$unsafeCoerce = _Lamdera_unsafeCoerce;
var $lamdera$core$Lamdera$Effect$onEffects$ = function (router, cmds, subs, state) {
	if (!cmds.b) {
		return $elm$core$Task$succeed(state);
	} else {
		switch (cmds.a.$) {
			case 0:
				var toBackend = cmds.a.a;
				var cmdsRest = cmds.b;
				return A2(
					$elm$core$Task$andThen,
					function (_v1) {
						return $lamdera$core$Lamdera$Effect$onEffects$(router, cmdsRest, subs, state);
					},
					A2(
						$elm$core$Platform$sendToApp,
						router,
						$lamdera$core$Lamdera$Effect$unsafeCoerce(
							$lamdera$core$Lamdera$Effect$FEtoBE(
								$lamdera$core$Lamdera$Effect$unsafeCoerce(toBackend)))));
			case 1:
				var _v2 = cmds.a;
				var clientId = _v2.a;
				var toFrontend = _v2.b;
				var cmdsRest = cmds.b;
				return A2(
					$elm$core$Task$andThen,
					function (_v3) {
						return $lamdera$core$Lamdera$Effect$onEffects$(router, cmdsRest, subs, state);
					},
					A2(
						$elm$core$Platform$sendToApp,
						router,
						$lamdera$core$Lamdera$Effect$unsafeCoerce(
							$lamdera$core$Lamdera$Effect$BEtoFE$(
								clientId,
								$lamdera$core$Lamdera$Effect$unsafeCoerce(toFrontend)))));
			case 2:
				var _v4 = cmds.a;
				var sessionId = _v4.a;
				var clientId = _v4.b;
				var cmdsRest = cmds.b;
				var sends = $elm$core$List$map$(
					function (sub) {
						if (!sub.$) {
							var tagger = sub.a;
							return A2(
								$elm$core$Task$andThen,
								function (_v7) {
									return $elm$core$Task$succeed(state);
								},
								A2(
									$elm$core$Platform$sendToApp,
									router,
									A2(tagger, sessionId, clientId)));
						} else {
							var tagger = sub.a;
							return $elm$core$Task$succeed(state);
						}
					},
					subs);
				return A2(
					$elm$core$Task$andThen,
					function (_v5) {
						return $lamdera$core$Lamdera$Effect$onEffects$(router, cmdsRest, subs, state);
					},
					$elm$core$Task$sequence(sends));
			default:
				var _v8 = cmds.a;
				var sessionId = _v8.a;
				var clientId = _v8.b;
				var cmdsRest = cmds.b;
				var sends = $elm$core$List$map$(
					function (sub) {
						if (!sub.$) {
							var tagger = sub.a;
							return $elm$core$Task$succeed(state);
						} else {
							var tagger = sub.a;
							return A2(
								$elm$core$Task$andThen,
								function (_v11) {
									return $elm$core$Task$succeed(state);
								},
								A2(
									$elm$core$Platform$sendToApp,
									router,
									A2(tagger, sessionId, clientId)));
						}
					},
					subs);
				return A2(
					$elm$core$Task$andThen,
					function (_v9) {
						return $lamdera$core$Lamdera$Effect$onEffects$(router, cmdsRest, subs, state);
					},
					$elm$core$Task$sequence(sends));
		}
	}
};
var $lamdera$core$Lamdera$Effect$onEffects = F4($lamdera$core$Lamdera$Effect$onEffects$);
var $lamdera$core$Lamdera$Effect$onSelfMsg$ = function (_v0, _v1, state) {
	return $elm$core$Task$succeed(state);
};
var $lamdera$core$Lamdera$Effect$onSelfMsg = F3($lamdera$core$Lamdera$Effect$onSelfMsg$);
var $lamdera$core$Lamdera$Effect$ClientConnected_$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $lamdera$core$Lamdera$Effect$ClientConnected_ = F2($lamdera$core$Lamdera$Effect$ClientConnected_$);
var $lamdera$core$Lamdera$Effect$ClientDisconnected_$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $lamdera$core$Lamdera$Effect$ClientDisconnected_ = F2($lamdera$core$Lamdera$Effect$ClientDisconnected_$);
var $lamdera$core$Lamdera$Effect$SendToBackend = function (a) {
	return {$: 0, a: a};
};
var $lamdera$core$Lamdera$Effect$SendToFrontend$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $lamdera$core$Lamdera$Effect$SendToFrontend = F2($lamdera$core$Lamdera$Effect$SendToFrontend$);
var $lamdera$core$Lamdera$Effect$cmdMap$ = function (f, cmd) {
	switch (cmd.$) {
		case 0:
			var toBackend = cmd.a;
			return $lamdera$core$Lamdera$Effect$SendToBackend(
				$lamdera$core$Lamdera$Effect$unsafeCoerce(toBackend));
		case 1:
			var clientId = cmd.a;
			var toFrontend = cmd.b;
			return $lamdera$core$Lamdera$Effect$SendToFrontend$(
				clientId,
				$lamdera$core$Lamdera$Effect$unsafeCoerce(toFrontend));
		case 2:
			var sessionId = cmd.a;
			var clientId = cmd.b;
			return $lamdera$core$Lamdera$Effect$ClientConnected_$(sessionId, clientId);
		default:
			var sessionId = cmd.a;
			var clientId = cmd.b;
			return $lamdera$core$Lamdera$Effect$ClientDisconnected_$(sessionId, clientId);
	}
};
var $lamdera$core$Lamdera$Effect$cmdMap = F2($lamdera$core$Lamdera$Effect$cmdMap$);
var $lamdera$core$Lamdera$Effect$ClientDisconnected = function (a) {
	return {$: 1, a: a};
};
var $lamdera$core$Lamdera$Effect$subMap$ = function (func, sub) {
	if (!sub.$) {
		var tagger = sub.a;
		return $lamdera$core$Lamdera$Effect$ClientConnected(
			F2(
				function (s, c) {
					return func(
						A2(tagger, s, c));
				}));
	} else {
		var tagger = sub.a;
		return $lamdera$core$Lamdera$Effect$ClientDisconnected(
			F2(
				function (s, c) {
					return func(
						A2(tagger, s, c));
				}));
	}
};
var $lamdera$core$Lamdera$Effect$subMap = F2($lamdera$core$Lamdera$Effect$subMap$);
_Platform_effectManagers['Lamdera.Effect'] = _Platform_createManager($lamdera$core$Lamdera$Effect$init, $lamdera$core$Lamdera$Effect$onEffects, $lamdera$core$Lamdera$Effect$onSelfMsg, $lamdera$core$Lamdera$Effect$cmdMap, $lamdera$core$Lamdera$Effect$subMap);
var $lamdera$core$Lamdera$Effect$command = _Platform_leaf('Lamdera.Effect');
var $lamdera$core$Lamdera$Effect$subscription = _Platform_leaf('Lamdera.Effect');
var $lamdera$core$Lamdera$Effect$onConnect = function (tagger) {
	return $lamdera$core$Lamdera$Effect$subscription(
		$lamdera$core$Lamdera$Effect$ClientConnected(tagger));
};
var $lamdera$core$Lamdera$onConnect = function (tagger) {
	return $lamdera$core$Lamdera$Effect$onConnect(tagger);
};
var $lamdera$core$Lamdera$Effect$onDisconnect = function (tagger) {
	return $lamdera$core$Lamdera$Effect$subscription(
		$lamdera$core$Lamdera$Effect$ClientDisconnected(tagger));
};
var $lamdera$core$Lamdera$onDisconnect = function (tagger) {
	return $lamdera$core$Lamdera$Effect$onDisconnect(tagger);
};
var $elm$browser$Browser$Events$onKeyDown = A2($elm$browser$Browser$Events$on, 0, 'keydown');
var $elm$browser$Browser$Events$onKeyPress = A2($elm$browser$Browser$Events$on, 0, 'keypress');
var $elm$browser$Browser$Events$onKeyUp = A2($elm$browser$Browser$Events$on, 0, 'keyup');
var $elm$browser$Browser$Events$onMouseDown = A2($elm$browser$Browser$Events$on, 0, 'mousedown');
var $elm$browser$Browser$Events$onMouseMove = A2($elm$browser$Browser$Events$on, 0, 'mousemove');
var $elm$browser$Browser$Events$onMouseUp = A2($elm$browser$Browser$Events$on, 0, 'mouseup');
var $elm$browser$Browser$Events$Window = 1;
var $elm$browser$Browser$Events$onResize = function (func) {
	return $elm$browser$Browser$Events$on$(
		1,
		'resize',
		A2(
			$elm$json$Json$Decode$field,
			'target',
			A3(
				$elm$json$Json$Decode$map2,
				func,
				A2($elm$json$Json$Decode$field, 'innerWidth', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'innerHeight', $elm$json$Json$Decode$int))));
};
var $elm$browser$Browser$Events$Hidden = 1;
var $elm$browser$Browser$Events$Visible = 0;
var $elm$browser$Browser$Events$withHidden$ = function (func, isHidden) {
	return func(
		isHidden ? 1 : 0);
};
var $elm$browser$Browser$Events$withHidden = F2($elm$browser$Browser$Events$withHidden$);
var $elm$browser$Browser$Events$onVisibilityChange = function (func) {
	var info = _Browser_visibilityInfo(0);
	return $elm$browser$Browser$Events$on$(
		0,
		info.change,
		A2(
			$elm$json$Json$Decode$map,
			$elm$browser$Browser$Events$withHidden(func),
			A2(
				$elm$json$Json$Decode$field,
				'target',
				A2($elm$json$Json$Decode$field, info.hidden, $elm$json$Json$Decode$bool))));
};
var $elm$http$Http$track$ = function (tracker, toMsg) {
	return $elm$http$Http$subscription(
		$elm$http$Http$MySub$(tracker, toMsg));
};
var $elm$http$Http$track = F2($elm$http$Http$track$);
var $lamdera$program_test$Effect$Lamdera$toSub = function (sub) {
	switch (sub.$) {
		case 0:
			var subs = sub.a;
			return $elm$core$Platform$Sub$batch(
				$elm$core$List$map$($lamdera$program_test$Effect$Lamdera$toSub, subs));
		case 1:
			return $elm$core$Platform$Sub$none;
		case 2:
			var duration = sub.a;
			var msg = sub.b;
			return $elm$time$Time$every$(
				$ianmackenzie$elm_units$Duration$inMilliseconds(duration),
				msg);
		case 3:
			var msg = sub.a;
			return $elm$browser$Browser$Events$onAnimationFrame(msg);
		case 4:
			var msg = sub.a;
			return $elm$browser$Browser$Events$onAnimationFrameDelta(
				A2($elm$core$Basics$composeR, $ianmackenzie$elm_units$Duration$milliseconds, msg));
		case 5:
			var decoder = sub.a;
			return $elm$browser$Browser$Events$onKeyPress(decoder);
		case 6:
			var decoder = sub.a;
			return $elm$browser$Browser$Events$onKeyDown(decoder);
		case 7:
			var decoder = sub.a;
			return $elm$browser$Browser$Events$onKeyUp(decoder);
		case 8:
			var decoder = sub.a;
			return $elm$browser$Browser$Events$onClick(decoder);
		case 9:
			var decoder = sub.a;
			return $elm$browser$Browser$Events$onMouseMove(decoder);
		case 10:
			var decoder = sub.a;
			return $elm$browser$Browser$Events$onMouseDown(decoder);
		case 11:
			var decoder = sub.a;
			return $elm$browser$Browser$Events$onMouseUp(decoder);
		case 13:
			var msg = sub.a;
			return $elm$browser$Browser$Events$onVisibilityChange(
				function (visibility) {
					if (!visibility) {
						return msg(0);
					} else {
						return msg(1);
					}
				});
		case 12:
			var msg = sub.a;
			return $elm$browser$Browser$Events$onResize(msg);
		case 14:
			var portFunction = sub.b;
			return portFunction;
		case 15:
			var portFunction = sub.b;
			return portFunction;
		case 16:
			var msg = sub.a;
			return $lamdera$core$Lamdera$onConnect(
				F2(
					function (sessionId, clientId) {
						return A2(msg, sessionId, clientId);
					}));
		case 17:
			var msg = sub.a;
			return $lamdera$core$Lamdera$onDisconnect(
				F2(
					function (sessionId, clientId) {
						return A2(msg, sessionId, clientId);
					}));
		case 18:
			var string = sub.a;
			var _function = sub.b;
			return $elm$http$Http$track$(string, _function);
		default:
			var connection = sub.a;
			var onData = sub.b;
			var onClose = sub.c;
			return $lamdera$program_test$Websocket$listen$(connection, onData, onClose);
	}
};
var $lamdera$program_test$Effect$Lamdera$frontend$ = function (toBackend, userApp) {
	return {
		init: F2(
			function (url, navigationKey) {
				return $elm$core$Tuple$mapSecond$(
					A3(
						$lamdera$program_test$Effect$Lamdera$toCmd,
						function (_v0) {
							return $elm$core$Platform$Cmd$none;
						},
						F2(
							function (_v1, _v2) {
								return $elm$core$Platform$Cmd$none;
							}),
						toBackend),
					A2(
						userApp.init,
						url,
						$lamdera$program_test$Effect$Browser$Navigation$fromInternalKey(
							$lamdera$program_test$Effect$Internal$RealNavigationKey(navigationKey))));
			}),
		onUrlChange: userApp.onUrlChange,
		onUrlRequest: userApp.onUrlRequest,
		subscriptions: A2($elm$core$Basics$composeR, userApp.subscriptions, $lamdera$program_test$Effect$Lamdera$toSub),
		update: F2(
			function (msg, model) {
				return $elm$core$Tuple$mapSecond$(
					A3(
						$lamdera$program_test$Effect$Lamdera$toCmd,
						function (_v3) {
							return $elm$core$Platform$Cmd$none;
						},
						F2(
							function (_v4, _v5) {
								return $elm$core$Platform$Cmd$none;
							}),
						toBackend),
					A2(userApp.update, msg, model));
			}),
		updateFromBackend: F2(
			function (msg, model) {
				return $elm$core$Tuple$mapSecond$(
					A3(
						$lamdera$program_test$Effect$Lamdera$toCmd,
						function (_v6) {
							return $elm$core$Platform$Cmd$none;
						},
						F2(
							function (_v7, _v8) {
								return $elm$core$Platform$Cmd$none;
							}),
						toBackend),
					A2(userApp.updateFromBackend, msg, model));
			}),
		view: userApp.view
	};
};
var $lamdera$program_test$Effect$Lamdera$frontend = F2($lamdera$program_test$Effect$Lamdera$frontend$);
var $lamdera$core$Lamdera$Effect$sendToBackend = function (toBackend) {
	return $lamdera$core$Lamdera$Effect$command(
		$lamdera$core$Lamdera$Effect$SendToBackend(
			$lamdera$core$Lamdera$Effect$unsafeCoerce(toBackend)));
};
var $lamdera$core$Lamdera$sendToBackend = function (msg) {
	return $lamdera$core$Lamdera$Effect$sendToBackend(msg);
};
var $author$project$Frontend$app = $lamdera$program_test$Effect$Lamdera$frontend$($lamdera$core$Lamdera$sendToBackend, $author$project$Frontend$app_);
var $author$project$LFR$FEMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$LFR$FERRM = function (a) {
	return {$: 5, a: a};
};
var $author$project$LFR$FEUM = function (a) {
	return {$: 4, a: a};
};
var $author$project$LFR$FrontendUrlChanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$LFR$Received_ToFrontend = function (a) {
	return {$: 2, a: a};
};
var $lamdera$codecs$Lamdera$Wire3$andMapDecode$ = function (d, d2) {
	return $elm$bytes$Bytes$Decode$andThen$(
		function (v) {
			return $elm$bytes$Bytes$Decode$map$(v, d);
		},
		d2);
};
var $lamdera$codecs$Lamdera$Wire3$andMapDecode = F2($lamdera$codecs$Lamdera$Wire3$andMapDecode$);
var $elm$browser$Browser$application = _Browser_application;
var $lamdera$codecs$Lamdera$Wire3$bytesDecodeStrict = _LamderaCodecs_bytesDecodeStrict;
var $lamdera$codecs$Lamdera$Wire3$bytesEncode = $elm$bytes$Bytes$Encode$encode;
var $lamdera$codecs$Lamdera$Wire3$endianness = 0;
var $lamdera$codecs$Lamdera$Wire3$decodeFloat64 = $elm$bytes$Bytes$Decode$float64($lamdera$codecs$Lamdera$Wire3$endianness);
var $elm$bytes$Bytes$Decode$fail = _Bytes_decodeFailure;
var $lamdera$codecs$Lamdera$Wire3$intDivBy$ = function (b, a) {
	var v = a / b;
	return (v < 0) ? (-$elm$core$Basics$floor(-v)) : $elm$core$Basics$floor(v);
};
var $lamdera$codecs$Lamdera$Wire3$intDivBy = F2($lamdera$codecs$Lamdera$Wire3$intDivBy$);
var $lamdera$codecs$Lamdera$Wire3$unsignedToSigned = function (i) {
	return (A2($elm$core$Basics$modBy, 2, i) === 1) ? $lamdera$codecs$Lamdera$Wire3$intDivBy$(-2, i + 1) : $lamdera$codecs$Lamdera$Wire3$intDivBy$(2, i);
};
var $lamdera$codecs$Lamdera$Wire3$decodeInt64 = function () {
	var d = $lamdera$codecs$Lamdera$Wire3$andMapDecode($elm$bytes$Bytes$Decode$unsignedInt8);
	return $elm$bytes$Bytes$Decode$andThen$(
		function (n0) {
			return (n0 <= 215) ? $elm$bytes$Bytes$Decode$map$(
				$lamdera$codecs$Lamdera$Wire3$unsignedToSigned,
				$elm$bytes$Bytes$Decode$succeed(n0)) : ((n0 < 252) ? $elm$bytes$Bytes$Decode$map$(
				$lamdera$codecs$Lamdera$Wire3$unsignedToSigned,
				d(
					$elm$bytes$Bytes$Decode$succeed(
						function (b0) {
							return (((n0 - 216) * 256) + b0) + 216;
						}))) : ((n0 === 252) ? $elm$bytes$Bytes$Decode$map$(
				$lamdera$codecs$Lamdera$Wire3$unsignedToSigned,
				d(
					d(
						$elm$bytes$Bytes$Decode$succeed(
							F2(
								function (b0, b1) {
									return (b0 * 256) + b1;
								}))))) : ((n0 === 253) ? $elm$bytes$Bytes$Decode$map$(
				$lamdera$codecs$Lamdera$Wire3$unsignedToSigned,
				d(
					d(
						d(
							$elm$bytes$Bytes$Decode$succeed(
								F3(
									function (b0, b1, b2) {
										return (((b0 * 256) + b1) * 256) + b2;
									})))))) : ((n0 === 254) ? $elm$bytes$Bytes$Decode$map$(
				$lamdera$codecs$Lamdera$Wire3$unsignedToSigned,
				d(
					d(
						d(
							d(
								$elm$bytes$Bytes$Decode$succeed(
									F4(
										function (b0, b1, b2, b3) {
											return (((((b0 * 256) + b1) * 256) + b2) * 256) + b3;
										}))))))) : $elm$bytes$Bytes$Decode$andThen$(
				function (n1) {
					return ($elm$core$Basics$isNaN(n1) || $elm$core$Basics$isInfinite(n1)) ? $elm$bytes$Bytes$Decode$fail : $elm$bytes$Bytes$Decode$succeed(
						$elm$core$Basics$floor(n1));
				},
				$lamdera$codecs$Lamdera$Wire3$decodeFloat64)))));
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
}();
var $lamdera$codecs$Lamdera$Wire3$decodeInt = $lamdera$codecs$Lamdera$Wire3$decodeInt64;
var $lamdera$codecs$Lamdera$Wire3$decodeUnsignedInt8 = $elm$bytes$Bytes$Decode$unsignedInt8;
var $lamdera$codecs$Lamdera$Wire3$bytesDecode = $elm$bytes$Bytes$Decode$decode;
var $lamdera$codecs$Lamdera$Wire3$succeedDecode = $elm$bytes$Bytes$Decode$succeed;
var $author$project$LamderaHelpers$decodeWirePayloadHeader = function (bytes) {
	return $elm$core$Maybe$withDefault$(
		_Utils_Tuple2(-1, -1),
		A2(
			$lamdera$codecs$Lamdera$Wire3$bytesDecode,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeUnsignedInt8,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F2(
							function (msgType, version) {
								return _Utils_Tuple2(msgType, version);
							})))),
			bytes));
};
var $author$project$LamderaGenerated$currentVersion = 420;
var $author$project$LFR$dl = _Platform_outgoingPort('dl', $elm$json$Json$Encode$string);
var $author$project$LamderaHelpers$logVersion$ = function (dlog, version, identifier, values) {
	var ident = function () {
		if (!version) {
			return '_';
		} else {
			var v = version;
			return $elm$core$String$fromInt(v);
		}
	}();
	var line = '[v' + (ident + ('] [' + (identifier + ('] ' + values))));
	return dlog(line);
};
var $author$project$LamderaHelpers$logVersion = F4($author$project$LamderaHelpers$logVersion$);
var $author$project$LFR$log = A2($author$project$LamderaHelpers$logVersion, $author$project$LFR$dl, $author$project$LamderaGenerated$currentVersion);
var $author$project$LFR$withEvergreen$ = function (model, initModel, decodeAndUpgradeFn, version, bytes, fn) {
	var _v0 = A2(decodeAndUpgradeFn, version, bytes);
	switch (_v0.$) {
		case 0:
			var pair = _v0.a;
			return function (_v1) {
				var m = _v1.a;
				var cmds = _v1.b;
				return _Utils_Tuple2(
					m,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$author$project$LFR$log,
								'AlreadyCurrent for v' + $elm$core$String$fromInt(version),
								''),
								cmds
							])));
			}(
				fn(pair));
		case 2:
			return _Utils_Tuple2(
				initModel,
				A2($author$project$LFR$log, 'ModelReset', ''));
		case 1:
			var pair = _v0.a;
			return function (_v2) {
				var m = _v2.a;
				var cmds = _v2.b;
				return _Utils_Tuple2(
					m,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$LFR$log, 'Upgraded', ''),
								cmds
							])));
			}(
				fn(pair));
		case 3:
			var _v3 = _v0.a;
			var v = _v3.a;
			var s = _v3.b;
			return _Utils_Tuple2(
				model,
				A2(
					$author$project$LFR$log,
					'Unknown version',
					$elm$core$String$fromInt(v) + (', ' + s)));
		case 4:
			var info = _v0.a;
			return _Utils_Tuple2(
				model,
				A2($author$project$LFR$log, 'Unknown type', info));
		default:
			var err = _v0.a;
			return _Utils_Tuple2(
				model,
				A2($author$project$LFR$log, 'Decoder error', err));
	}
};
var $author$project$LFR$withEvergreen = F6($author$project$LFR$withEvergreen$);
var $author$project$LFR$evergreenFrontendModel$ = function (userInitModel, codecs, userApp, args) {
	return $author$project$LFR$withEvergreen$(
		$elm$core$Maybe$Nothing,
		$elm$core$Maybe$Just(userInitModel),
		codecs.decodeAndUpgradeFrontendModel,
		args.v,
		args.b,
		$elm$core$Tuple$mapFirst($elm$core$Maybe$Just));
};
var $author$project$LFR$evergreenFrontendModel = F4($author$project$LFR$evergreenFrontendModel$);
var $author$project$LFR$evergreenFrontendMsg$ = function (codecs, model, userApp, args) {
	return $author$project$LFR$withEvergreen$(
		model,
		model,
		codecs.decodeAndUpgradeFrontendMsg,
		args.v,
		args.b,
		function (_v0) {
			var frontendMsg = _v0.a;
			var userFrontendMsgCmds = _v0.b;
			var _v1 = A2(userApp.update, frontendMsg, model.userModel);
			var newUserModel = _v1.a;
			var newFrontendMsgCmds = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{userModel: newUserModel}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[userFrontendMsgCmds, newFrontendMsgCmds])));
		});
};
var $author$project$LFR$evergreenFrontendMsg = F4($author$project$LFR$evergreenFrontendMsg$);
var $author$project$LFR$mapDocument$ = function (fn, _v0) {
	var body = _v0.body;
	var title = _v0.title;
	return {
		body: $elm$core$List$map$(
			$elm$html$Html$map(fn),
			body),
		title: title
	};
};
var $author$project$LFR$mapDocument = F2($author$project$LFR$mapDocument$);
var $lamdera$codecs$Lamdera$Wire3$encodeFloat64 = function (f) {
	return A2($elm$bytes$Bytes$Encode$float64, $lamdera$codecs$Lamdera$Wire3$endianness, f);
};
var $lamdera$codecs$Lamdera$Wire3$signedToUnsigned = function (i) {
	return (i < 0) ? (((-2) * i) - 1) : (2 * i);
};
var $lamdera$codecs$Lamdera$Wire3$encodeInt64 = function (i) {
	var n = $lamdera$codecs$Lamdera$Wire3$signedToUnsigned(i);
	var n0 = A2($elm$core$Basics$modBy, 256, n);
	var n1 = A2(
		$elm$core$Basics$modBy,
		256,
		$lamdera$codecs$Lamdera$Wire3$intDivBy$(256, n));
	var n2 = A2(
		$elm$core$Basics$modBy,
		256,
		$lamdera$codecs$Lamdera$Wire3$intDivBy$(
			256,
			$lamdera$codecs$Lamdera$Wire3$intDivBy$(256, n)));
	var n3 = A2(
		$elm$core$Basics$modBy,
		256,
		$lamdera$codecs$Lamdera$Wire3$intDivBy$(
			256,
			$lamdera$codecs$Lamdera$Wire3$intDivBy$(
				256,
				$lamdera$codecs$Lamdera$Wire3$intDivBy$(256, n))));
	var ei = function (e) {
		return $elm$bytes$Bytes$Encode$sequence(
			$elm$core$List$map$($elm$bytes$Bytes$Encode$unsignedInt8, e));
	};
	return (n <= 215) ? ei(
		_List_fromArray(
			[n])) : ((n <= 9431) ? ei(
		_List_fromArray(
			[
				216 + $lamdera$codecs$Lamdera$Wire3$intDivBy$(256, n - 216),
				A2($elm$core$Basics$modBy, 256, n - 216)
			])) : ((_Utils_cmp(n, 256 * 256) < 0) ? ei(
		_List_fromArray(
			[252, n1, n0])) : ((_Utils_cmp(n, (256 * 256) * 256) < 0) ? ei(
		_List_fromArray(
			[253, n2, n1, n0])) : ((_Utils_cmp(n, ((256 * 256) * 256) * 256) < 0) ? ei(
		_List_fromArray(
			[254, n3, n2, n1, n0])) : $elm$bytes$Bytes$Encode$sequence(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(255),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat64(i)
			]))))));
};
var $lamdera$codecs$Lamdera$Wire3$encodeInt = $lamdera$codecs$Lamdera$Wire3$encodeInt64;
var $lamdera$codecs$Lamdera$Wire3$encodeList$ = function (enc, s) {
	return $elm$bytes$Bytes$Encode$sequence(
		A2(
			$elm$core$List$cons,
			$lamdera$codecs$Lamdera$Wire3$encodeInt64(
				$elm$core$List$length(s)),
			$elm$core$List$map$(enc, s)));
};
var $lamdera$codecs$Lamdera$Wire3$encodeList = F2($lamdera$codecs$Lamdera$Wire3$encodeList$);
var $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength = function (s) {
	return $elm$bytes$Bytes$Encode$sequence(s);
};
var $lamdera$codecs$Lamdera$Wire3$encodeString = function (s) {
	return $elm$bytes$Bytes$Encode$sequence(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt64(
				$elm$bytes$Bytes$Encode$getStringWidth(s)),
				$elm$bytes$Bytes$Encode$string(s)
			]));
};
var $lamdera$codecs$Lamdera$Wire3$encodeUnsignedInt8 = $elm$bytes$Bytes$Encode$unsignedInt8;
var $lamdera$core$Lamdera$Debug$urlProtocolToString = function (protocol) {
	if (!protocol) {
		return 'http';
	} else {
		return 'https';
	}
};
var $author$project$LamderaHelpers$sendWireAnalytics$ = function (codecs, url) {
	return codecs.sendToBackend(
		$lamdera$codecs$Lamdera$Wire3$bytesEncode(
			$lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$lamdera$codecs$Lamdera$Wire3$encodeUnsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(codecs.version),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						$lamdera$codecs$Lamdera$Wire3$encodeString,
						_List_fromArray(
							[
								$lamdera$core$Lamdera$Debug$urlProtocolToString(url.protocol),
								url.host,
								url.path,
								$elm$core$Maybe$withDefault$('', url.query),
								$elm$core$Maybe$withDefault$('', url.fragment)
							]))
					]))));
};
var $author$project$LamderaHelpers$sendWireAnalytics = F2($author$project$LamderaHelpers$sendWireAnalytics$);
var $author$project$LamderaHelpers$sendWireToBackendMsg$ = function (codecs, toBackend) {
	return codecs.sendToBackend(
		$lamdera$codecs$Lamdera$Wire3$bytesEncode(
			$lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$lamdera$codecs$Lamdera$Wire3$encodeUnsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(codecs.version),
						codecs.encodeToBackend(toBackend)
					]))));
};
var $author$project$LamderaHelpers$sendWireToBackendMsg = F2($author$project$LamderaHelpers$sendWireToBackendMsg$);
var $author$project$LamderaHelpers$tipeIntToString = function (tipe) {
	switch (tipe) {
		case 0:
			return 'FrontendMsg';
		case 1:
			return 'ToBackend';
		case 2:
			return 'BackendMsg';
		case 3:
			return 'ToFrontend';
		case 4:
			return 'FrontendModel';
		case 5:
			return 'BackendModel';
		default:
			return 'tipeIntToString FAILED';
	}
};
var $author$project$LamderaHelpers$tipeStringToInt = function (tipe) {
	switch (tipe) {
		case 'FrontendMsg':
			return 0;
		case 'ToBackend':
			return 1;
		case 'BackendMsg':
			return 2;
		case 'ToFrontend':
			return 3;
		case 'FrontendModel':
			return 4;
		case 'BackendModel':
			return 5;
		default:
			return -1;
	}
};
var $author$project$LFR$application$ = function (userApp, codecs) {
	var ensureOutputInclusion = $author$project$LamderaHelpers$decodeWirePayloadHeader;
	return $elm$browser$Browser$application(
		{
			init: F3(
				function (flags, url, key) {
					var initModel = function (userModel) {
						return {initKey: key, initUrl: url, upgradeMode: false, userModel: userModel};
					};
					var _v0 = A2(userApp.init, url, key);
					var userInitModel = _v0.a;
					var userInitCmds = _v0.b;
					var _v1 = flags.b;
					if (!_v1.$) {
						var b = _v1.a;
						var _v2 = $author$project$LFR$evergreenFrontendModel$(
							userInitModel,
							codecs,
							userApp,
							{
								b: b,
								t: $author$project$LamderaHelpers$tipeStringToInt('FrontendModel'),
								v: flags.bv - 1
							});
						var maybeUserModel = _v2.a;
						var cmd = _v2.b;
						return _Utils_Tuple2(
							function () {
								if (!maybeUserModel.$) {
									var userModel = maybeUserModel.a;
									return initModel(userModel);
								} else {
									return initModel(
										A2(userApp.init, url, key).a);
								}
							}(),
							A2($elm$core$Platform$Cmd$map, $author$project$LFR$FEMsg, cmd));
					} else {
						return _Utils_Tuple2(
							initModel(userInitModel),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2(
										$elm$core$Platform$Cmd$map,
										$author$project$LFR$FEMsg,
										$author$project$LamderaHelpers$sendWireAnalytics$(codecs, url)),
										A2($elm$core$Platform$Cmd$map, $author$project$LFR$FEMsg, userInitCmds)
									])));
					}
				}),
			onUrlChange: $author$project$LFR$FrontendUrlChanged,
			onUrlRequest: A2($elm$core$Basics$composeR, userApp.onUrlRequest, $author$project$LFR$FEMsg),
			subscriptions: function (model) {
				return (!model.upgradeMode) ? $elm$core$Platform$Sub$batch(
					_List_fromArray(
						[
							A2(
							$elm$core$Platform$Sub$map,
							$author$project$LFR$FEMsg,
							userApp.subscriptions(model.userModel)),
							codecs.received_ToFrontend($author$project$LFR$Received_ToFrontend),
							codecs.enterUpgradeMode($author$project$LFR$FEUM),
							codecs.receiveRedirectMsg($author$project$LFR$FERRM)
						])) : $elm$core$Platform$Sub$none;
			},
			update: F2(
				function (msg, model) {
					return $elm$core$Tuple$mapSecond$(
						$elm$core$Platform$Cmd$map($author$project$LFR$FEMsg),
						function () {
							switch (msg.$) {
								case 1:
									var frontendMsg = msg.a;
									var _v5 = (!model.upgradeMode) ? A2(userApp.update, frontendMsg, model.userModel) : _Utils_Tuple2(
										model.userModel,
										$elm$core$Platform$Cmd$batch(
											_List_fromArray(
												[
													codecs.redirectMsg(
													{
														b: $lamdera$codecs$Lamdera$Wire3$bytesEncode(
															codecs.encodeFrontendMsg(frontendMsg)),
														t: $author$project$LamderaHelpers$tipeStringToInt('FrontendMsg'),
														v: codecs.version
													}),
													A2($author$project$LFR$log, 'FEMsg', 'Redirecting msg')
												])));
									var newUserModel = _v5.a;
									var userCmds = _v5.b;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{userModel: newUserModel}),
										userCmds);
								case 2:
									var bytes = msg.a;
									var res = A2(
										$lamdera$codecs$Lamdera$Wire3$bytesDecodeStrict,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											codecs.decodeToFrontend,
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeInt,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$codecs$Lamdera$Wire3$decodeUnsignedInt8,
													$lamdera$codecs$Lamdera$Wire3$succeedDecode(
														F3(
															function (wireMsgType, wireVersion, toFrontend) {
																return toFrontend;
															}))))),
										bytes);
									if (!res.$) {
										var toFrontend = res.a;
										var _v7 = (!model.upgradeMode) ? A2(userApp.updateFromBackend, toFrontend, model.userModel) : _Utils_Tuple2(
											model.userModel,
											A2($author$project$LFR$log, 'FERTF', 'Unexpectedly got Received_ToFrontend when not subscribed (after entering upgrade mode).'));
										var newUserModel = _v7.a;
										var userCmds = _v7.b;
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{userModel: newUserModel}),
											userCmds);
									} else {
										return _Utils_Tuple2(
											model,
											A2($author$project$LFR$log, 'FERTF', 'ToFrontend msg decoding error'));
									}
								case 0:
									var toBackend = msg.a;
									return _Utils_Tuple2(
										model,
										$elm$core$Platform$Cmd$batch(
											_List_fromArray(
												[
													$author$project$LamderaHelpers$sendWireToBackendMsg$(codecs, toBackend)
												])));
								case 3:
									var url = msg.a;
									var frontendMsg = userApp.onUrlChange(url);
									if (!model.upgradeMode) {
										var _v8 = A2(userApp.update, frontendMsg, model.userModel);
										var newUserModel = _v8.a;
										var userCmds = _v8.b;
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{userModel: newUserModel}),
											$elm$core$Platform$Cmd$batch(
												_List_fromArray(
													[
														$author$project$LamderaHelpers$sendWireAnalytics$(codecs, url),
														userCmds
													])));
									} else {
										return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
									}
								case 4:
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{upgradeMode: true}),
										codecs.createFinalSnapshot(
											$lamdera$codecs$Lamdera$Wire3$bytesEncode(
												codecs.encodeFrontendModel(model.userModel))));
								default:
									var args = msg.a;
									var _v9 = args.t;
									if (!_v9) {
										return $author$project$LFR$evergreenFrontendMsg$(codecs, model, userApp, args);
									} else {
										return _Utils_Tuple2(
											model,
											A2(
												$author$project$LFR$log,
												'FERRM',
												'💥 Unexpected redirect type ' + $author$project$LamderaHelpers$tipeIntToString(args.t)));
									}
							}
						}());
				}),
			view: function (model) {
				return $author$project$LFR$mapDocument$(
					$author$project$LFR$FEMsg,
					userApp.view(model.userModel));
			}
		});
};
var $author$project$LFR$application = F2($author$project$LFR$application$);
var $lamdera$codecs$Lamdera$Migrations$ModelUnchanged = {$: 0};
var $author$project$LamderaHelpers$UnknownVersion = function (a) {
	return {$: 3, a: a};
};
var $author$project$LamderaHelpers$decodeType$ = function (tipe, version, bytes, decoder) {
	var _v0 = A2($lamdera$codecs$Lamdera$Wire3$bytesDecodeStrict, decoder, bytes);
	if (!_v0.$) {
		var value = _v0.a;
		return $elm$core$Result$Ok(
			_Utils_Tuple2(value, $elm$core$Platform$Cmd$none));
	} else {
		return $elm$core$Result$Err(
			'[decodeType] the impossible happened; failed to decode ' + ($author$project$LamderaHelpers$tipeIntToString(tipe) + ('.v' + $elm$core$String$fromInt(version))));
	}
};
var $author$project$LamderaHelpers$decodeType = F4($author$project$LamderaHelpers$decodeType$);
var $lamdera$codecs$Lamdera$Migrations$ModelMigrated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Audio$Model = $elm$core$Basics$identity;
var $elm$core$Tuple$mapBoth$ = function (funcA, funcB, _v0) {
	var x = _v0.a;
	var y = _v0.b;
	return _Utils_Tuple2(
		funcA(x),
		funcB(y));
};
var $elm$core$Tuple$mapBoth = F3($elm$core$Tuple$mapBoth$);
var $author$project$Evergreen$V419$Audio$ErrorThatHappensWhenYouLoadMoreThan1000SoundsDueToHackyWorkAroundToMakeThisPackageBehaveMoreLikeAnEffectPackage = 3;
var $author$project$Evergreen$V419$Audio$FailedToDecode = 0;
var $author$project$Evergreen$V419$Audio$NetworkError = 1;
var $author$project$Evergreen$V419$Audio$UnknownError = 2;
var $author$project$Evergreen$Migrate$V419$migrate_Audio_LoadError = function (old) {
	switch (old) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $author$project$Evergreen$V419$Audio$File = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Audio$BufferId = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_Audio_BufferId = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$Migrate$V419$migrate_Audio_Source = function (old) {
	var p0 = old;
	return {
		bufferId: $author$project$Evergreen$Migrate$V419$migrate_Audio_BufferId(p0.bufferId)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty$ = function (migrate_a, old) {
	return $mgold$elm_nonempty_list$List$Nonempty$map$(migrate_a, old);
};
var $author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty = F2($author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty$);
var $author$project$Evergreen$Migrate$V419$migrate_Audio_AudioLoadRequest_$ = function (migrate_userMsg, old) {
	return {
		audioUrl: old.audioUrl,
		userMsg: $author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty$(
			A2(
				$elm$core$Tuple$mapBoth,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Result$mapError($author$project$Evergreen$Migrate$V419$migrate_Audio_LoadError),
					$elm$core$Result$map($author$project$Evergreen$Migrate$V419$migrate_Audio_Source)),
				migrate_userMsg),
			old.userMsg)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Audio_AudioLoadRequest_ = F2($author$project$Evergreen$Migrate$V419$migrate_Audio_AudioLoadRequest_$);
var $author$project$Evergreen$Migrate$V419$migrate_Audio_FlattenedAudio = function (old) {
	return {
		loop: old.loop,
		offset: old.offset,
		playbackRate: old.playbackRate,
		source: $author$project$Evergreen$Migrate$V419$migrate_Audio_Source(old.source),
		startAt: old.startAt,
		startTime: old.startTime,
		volume: old.volume,
		volumeTimelines: old.volumeTimelines
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Audio_Model_$ = function (migrate_userMsg, migrate_userModel, old) {
	return {
		audioState: $elm$core$Dict$map$(
			function (k) {
				return $author$project$Evergreen$Migrate$V419$migrate_Audio_FlattenedAudio;
			},
			old.audioState),
		nodeGroupIdCounter: old.nodeGroupIdCounter,
		pendingRequests: $elm$core$Dict$map$(
			function (k) {
				return $author$project$Evergreen$Migrate$V419$migrate_Audio_AudioLoadRequest_(migrate_userMsg);
			},
			old.pendingRequests),
		requestCount: old.requestCount,
		samplesPerSecond: old.samplesPerSecond,
		sourceData: old.sourceData,
		userModel: migrate_userModel(old.userModel)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Audio_Model_ = F3($author$project$Evergreen$Migrate$V419$migrate_Audio_Model_$);
var $author$project$Evergreen$Migrate$V419$migrate_Audio_Model$ = function (migrate_userMsg, migrate_userModel, old) {
	var p0 = old;
	return $author$project$Evergreen$Migrate$V419$migrate_Audio_Model_$(migrate_userMsg, migrate_userModel, p0);
};
var $author$project$Evergreen$Migrate$V419$migrate_Audio_Model = F3($author$project$Evergreen$Migrate$V419$migrate_Audio_Model$);
var $author$project$Evergreen$V419$Types$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Types$Loading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$AiChat$AiModelName = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_AiChat_AiModelName = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$V419$AiChat$LoadedAiModels = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$AiChat$LoadingAiModels = {$: 0};
var $author$project$Evergreen$V419$AiChat$LoadingFailed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_AiChat_AiModel = function (old) {
	return {
		id: $author$project$Evergreen$Migrate$V419$migrate_AiChat_AiModelName(old.id),
		inputs: old.inputs
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_AiChat_AiModelsStatus = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$AiChat$LoadingAiModels;
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$AiChat$LoadedAiModels(
				$elm$core$List$map$($author$project$Evergreen$Migrate$V419$migrate_AiChat_AiModel, p0));
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$AiChat$LoadingFailed(p0);
	}
};
var $author$project$Evergreen$V419$AiChat$GotError$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V419$AiChat$GotError = F2($author$project$Evergreen$V419$AiChat$GotError$);
var $author$project$Evergreen$V419$AiChat$GotResponse$ = function (a, b, c, d) {
	return {$: 1, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$AiChat$GotResponse = F4($author$project$Evergreen$V419$AiChat$GotResponse$);
var $author$project$Evergreen$V419$AiChat$Pending = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_AiChat_PendingResponse = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$AiChat$Pending(
				$author$project$Evergreen$Migrate$V419$migrate_AiChat_AiModelName(p0));
		case 1:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$AiChat$GotResponse$(
				$author$project$Evergreen$Migrate$V419$migrate_AiChat_AiModelName(p0),
				p1,
				p2,
				p3);
		default:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$AiChat$GotError$(
				$author$project$Evergreen$Migrate$V419$migrate_AiChat_AiModelName(p0),
				p1);
	}
};
var $author$project$Evergreen$V419$AiChat$RespondId = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_AiChat_ResponseId = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$V419$AiChat$SendWithEnter = 0;
var $author$project$Evergreen$V419$AiChat$SendWithShiftEnter = 1;
var $author$project$Evergreen$Migrate$V419$migrate_AiChat_SendMessageWith = function (old) {
	if (!old) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_AiChat_FrontendModel = function (old) {
	return {
		aiModels: $author$project$Evergreen$Migrate$V419$migrate_AiChat_AiModelsStatus(old.aiModels),
		chatHistory: old.chatHistory,
		debounceCounter: old.debounceCounter,
		message: old.message,
		pendingResponses: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_AiChat_ResponseId, $author$project$Evergreen$Migrate$V419$migrate_AiChat_PendingResponse)),
				$lamdera$containers$SeqDict$fromList),
			old.pendingResponses),
		responseCounter: old.responseCounter,
		selectedModels: $elm$core$List$map$($author$project$Evergreen$Migrate$V419$migrate_AiChat_AiModelName, old.selectedModels),
		sendMessageWith: $author$project$Evergreen$Migrate$V419$migrate_AiChat_SendMessageWith(old.sendMessageWith),
		showOptions: old.showOptions
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Quantity_Quantity = function (old) {
	return $ianmackenzie$elm_units$Quantity$unsafe(
		$ianmackenzie$elm_units$Quantity$unwrap(old));
};
var $author$project$Evergreen$Migrate$V419$migrate_Coord_Coord$ = function (migrate_units, old) {
	return $elm$core$Tuple$mapBoth$($author$project$Evergreen$Migrate$V419$migrate_Quantity_Quantity, $author$project$Evergreen$Migrate$V419$migrate_Quantity_Quantity, old);
};
var $author$project$Evergreen$Migrate$V419$migrate_Coord_Coord = F2($author$project$Evergreen$Migrate$V419$migrate_Coord_Coord$);
var $author$project$Evergreen$V419$CssPixels$CssPixels = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_CssPixels_CssPixels = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$V419$Emoji$Activities = 0;
var $author$project$Evergreen$V419$Emoji$AnimalsAndNature = 1;
var $author$project$Evergreen$V419$Emoji$Components = 2;
var $author$project$Evergreen$V419$Emoji$Flags = 3;
var $author$project$Evergreen$V419$Emoji$FoodAndDrink = 4;
var $author$project$Evergreen$V419$Emoji$Objects = 5;
var $author$project$Evergreen$V419$Emoji$PeopleAndBody = 6;
var $author$project$Evergreen$V419$Emoji$SmileysAndEmotion = 7;
var $author$project$Evergreen$V419$Emoji$Symbols = 8;
var $author$project$Evergreen$V419$Emoji$TravelAndPlaces = 9;
var $author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiCategory = function (old) {
	switch (old) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		case 6:
			return 6;
		case 7:
			return 7;
		case 8:
			return 8;
		default:
			return 9;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiData = function (old) {
	return {
		category: $author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiCategory(old.category),
		shortNames: old.shortNames,
		skinVariations: old.skinVariations
	};
};
var $author$project$Evergreen$V419$Emoji$UnicodeEmoji = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_Emoji_UnicodeEmoji = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$Migrate$V419$migrate_Emoji_CachedEmojiData = function (old) {
	return {
		art: old.art,
		categories: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiCategory,
						$elm$core$List$map($author$project$Evergreen$Migrate$V419$migrate_Emoji_UnicodeEmoji))),
				$lamdera$containers$SeqDict$fromList),
			old.categories),
		emojis: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Emoji_UnicodeEmoji, $author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiData)),
				$lamdera$containers$SeqDict$fromList),
			old.emojis),
		shortNames: $elm$core$Array$map$(
			function (rec) {
				return {
					emoji: $author$project$Evergreen$Migrate$V419$migrate_Emoji_UnicodeEmoji(rec.emoji),
					shortName: rec.shortName
				};
			},
			old.shortNames)
	};
};
var $author$project$Evergreen$V419$ImageViewer$Dragging = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$ImageViewer$NoInteraction = {$: 0};
var $author$project$Evergreen$V419$ImageViewer$Pinching = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_ImageViewer_Interaction = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$ImageViewer$NoInteraction;
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$ImageViewer$Dragging(p0);
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$ImageViewer$Pinching(p0);
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_ImageViewer_Model = function (old) {
	return {
		imageSize: $author$project$Evergreen$Migrate$V419$migrate_Coord_Coord$($author$project$Evergreen$Migrate$V419$migrate_CssPixels_CssPixels, old.imageSize),
		imageUrl: old.imageUrl,
		interaction: $author$project$Evergreen$Migrate$V419$migrate_ImageViewer_Interaction(old.interaction),
		offsetX: old.offsetX,
		offsetY: old.offsetY,
		prevOffsetX: old.prevOffsetX,
		prevOffsetY: old.prevOffsetY,
		scale: old.scale,
		targetScale: old.targetScale,
		velocityX: old.velocityX,
		velocityY: old.velocityY,
		zoomFocusX: old.zoomFocusX,
		zoomFocusY: old.zoomFocusY
	};
};
var $author$project$Evergreen$V419$MyUi$CopiedImage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$MyUi$CopiedText = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_MyUi_Copied = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$MyUi$CopiedText(p0);
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$MyUi$CopiedImage(p0);
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_MyUi_LastCopy = function (old) {
	return {
		copied: $author$project$Evergreen$Migrate$V419$migrate_MyUi_Copied(old.copied),
		copiedAt: old.copiedAt
	};
};
var $author$project$Evergreen$V419$Id$Id = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_Id_Id = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$V419$Ports$Denied = 1;
var $author$project$Evergreen$V419$Ports$Granted = 2;
var $author$project$Evergreen$V419$Ports$NotAsked = 0;
var $author$project$Evergreen$V419$Ports$Unsupported = 3;
var $author$project$Evergreen$Migrate$V419$migrate_Ports_NotificationPermission = function (old) {
	switch (old) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $author$project$Evergreen$V419$Ports$BrowserView = 1;
var $author$project$Evergreen$V419$Ports$InstalledPwa = 0;
var $author$project$Evergreen$Migrate$V419$migrate_Ports_PwaStatus = function (old) {
	if (!old) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Evergreen$V419$UserAgent$Chrome = 0;
var $author$project$Evergreen$V419$UserAgent$Edge = 3;
var $author$project$Evergreen$V419$UserAgent$Firefox = 1;
var $author$project$Evergreen$V419$UserAgent$Opera = 4;
var $author$project$Evergreen$V419$UserAgent$Safari = 2;
var $author$project$Evergreen$V419$UserAgent$UnknownBrowser = 5;
var $author$project$Evergreen$Migrate$V419$migrate_UserAgent_Browser = function (old) {
	switch (old) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		default:
			return 5;
	}
};
var $author$project$Evergreen$V419$UserAgent$AndroidPhone = 2;
var $author$project$Evergreen$V419$UserAgent$AndroidTablet = 3;
var $author$project$Evergreen$V419$UserAgent$ChromeOS = 6;
var $author$project$Evergreen$V419$UserAgent$Desktop = 10;
var $author$project$Evergreen$V419$UserAgent$IPad = 1;
var $author$project$Evergreen$V419$UserAgent$IPhone = 0;
var $author$project$Evergreen$V419$UserAgent$Linux = 7;
var $author$project$Evergreen$V419$UserAgent$MacOS = 5;
var $author$project$Evergreen$V419$UserAgent$Mobile = 8;
var $author$project$Evergreen$V419$UserAgent$Tablet = 9;
var $author$project$Evergreen$V419$UserAgent$Windows = 4;
var $author$project$Evergreen$Migrate$V419$migrate_UserAgent_Device = function (old) {
	switch (old) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		case 6:
			return 6;
		case 7:
			return 7;
		case 8:
			return 8;
		case 9:
			return 9;
		default:
			return 10;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_UserAgent_UserAgent = function (old) {
	return {
		browser: $author$project$Evergreen$Migrate$V419$migrate_UserAgent_Browser(old.browser),
		device: $author$project$Evergreen$Migrate$V419$migrate_UserAgent_Device(old.device)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Ports_StartupData = function (old) {
	return {
		devicePixelRatio: old.devicePixelRatio,
		e2eeKeys: $elm$core$List$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, old.e2eeKeys),
		loadStartupDataTime: old.loadStartupDataTime,
		notificationPermission: $author$project$Evergreen$Migrate$V419$migrate_Ports_NotificationPermission(old.notificationPermission),
		pwaStatus: $author$project$Evergreen$Migrate$V419$migrate_Ports_PwaStatus(old.pwaStatus),
		randomSeed: old.randomSeed,
		safeAreaInsetBottom: old.safeAreaInsetBottom,
		safeAreaInsetTop: old.safeAreaInsetTop,
		scrollbarWidth: old.scrollbarWidth,
		timeOrigin: old.timeOrigin,
		timezone: old.timezone,
		userAgent: $author$project$Evergreen$Migrate$V419$migrate_UserAgent_UserAgent(old.userAgent)
	};
};
var $author$project$Evergreen$V419$Route$AdminRoute = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Route$AiChatRoute = {$: 9};
var $author$project$Evergreen$V419$Route$DiscordDmRoute = function (a) {
	return {$: 6, a: a};
};
var $author$project$Evergreen$V419$Route$DiscordGuildRoute = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V419$Route$DmRoute = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V419$Route$GuildRoute$ = function (a, b, c, d) {
	return {$: 3, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Route$GuildRoute = F4($author$project$Evergreen$V419$Route$GuildRoute$);
var $author$project$Evergreen$V419$Route$HomePageRoute = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Route$LinkDiscord = function (a) {
	return {$: 12, a: a};
};
var $author$project$Evergreen$V419$Route$NewGuildRoute = {$: 2};
var $author$project$Evergreen$V419$Route$PrivacyRoute = {$: 11};
var $author$project$Evergreen$V419$Route$PublicGoMatchRoute = function (a) {
	return {$: 13, a: a};
};
var $author$project$Evergreen$V419$Route$SlackDmRoute = function (a) {
	return {$: 8, a: a};
};
var $author$project$Evergreen$V419$Route$SlackWorkspaceRoute = function (a) {
	return {$: 7, a: a};
};
var $author$project$Evergreen$V419$Route$TextEditorRoute = {$: 10};
var $author$project$Evergreen$V419$SafeJson$JsonArray = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V419$SafeJson$JsonBool = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$SafeJson$JsonNull = {$: 5};
var $author$project$Evergreen$V419$SafeJson$JsonNumber = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$SafeJson$JsonObject = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V419$SafeJson$JsonString = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$SafeFloat$SafeFloat = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_SafeFloat_SafeFloat = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$Migrate$V419$migrate_SafeJson_SafeJson = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$SafeJson$JsonString(p0);
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$SafeJson$JsonNumber(
				$author$project$Evergreen$Migrate$V419$migrate_SafeFloat_SafeFloat(p0));
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$SafeJson$JsonBool(p0);
		case 3:
			var p0 = old.a;
			return $author$project$Evergreen$V419$SafeJson$JsonObject(
				$elm$core$Dict$map$(
					function (k) {
						return $author$project$Evergreen$Migrate$V419$migrate_SafeJson_SafeJson;
					},
					p0));
		case 4:
			var p0 = old.a;
			return $author$project$Evergreen$V419$SafeJson$JsonArray(
				$elm$core$List$map$($author$project$Evergreen$Migrate$V419$migrate_SafeJson_SafeJson, p0));
		default:
			return $author$project$Evergreen$V419$SafeJson$JsonNull;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Discord_UserAuth = function (old) {
	return {
		token: old.token,
		userAgent: old.userAgent,
		xSuperProperties: $author$project$Evergreen$Migrate$V419$migrate_SafeJson_SafeJson(old.xSuperProperties)
	};
};
var $author$project$Evergreen$V419$Route$ChannelRoute$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Route$ChannelRoute = F3($author$project$Evergreen$V419$Route$ChannelRoute$);
var $author$project$Evergreen$V419$Route$GuildSettingsRoute = {$: 2};
var $author$project$Evergreen$V419$Route$JoinRoute = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V419$Route$NewChannelRoute = {$: 1};
var $author$project$Evergreen$V419$Route$NoThreadWithFriends$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$Route$NoThreadWithFriends = F2($author$project$Evergreen$V419$Route$NoThreadWithFriends$);
var $author$project$Evergreen$V419$Route$ViewThreadWithFriends$ = function (a, b, c) {
	return {$: 1, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Route$ViewThreadWithFriends = F3($author$project$Evergreen$V419$Route$ViewThreadWithFriends$);
var $author$project$Evergreen$V419$Route$HideChannelSettings = 1;
var $author$project$Evergreen$V419$Route$ShowChannelSettings = 0;
var $author$project$Evergreen$Migrate$V419$migrate_Route_ShowChannelSettings = function (old) {
	if (!old) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Route_ThreadRouteWithFriends = function (old) {
	if (!old.$) {
		var p0 = old.a;
		var p1 = old.b;
		return $author$project$Evergreen$V419$Route$NoThreadWithFriends$(
			$elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, p0),
			$author$project$Evergreen$Migrate$V419$migrate_Route_ShowChannelSettings(p1));
	} else {
		var p0 = old.a;
		var p1 = old.b;
		var p2 = old.c;
		return $author$project$Evergreen$V419$Route$ViewThreadWithFriends$(
			$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
			$elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, p1),
			$author$project$Evergreen$Migrate$V419$migrate_Route_ShowChannelSettings(p2));
	}
};
var $author$project$Evergreen$V419$SecretId$SecretId = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_SecretId_SecretId = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$V419$UserSession$ChannelHeaderTab_ChannelDescription = {$: 2};
var $author$project$Evergreen$V419$UserSession$ChannelHeaderTab_Draw = {$: 3};
var $author$project$Evergreen$V419$UserSession$ChannelHeaderTab_Games$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V419$UserSession$ChannelHeaderTab_Games = F2($author$project$Evergreen$V419$UserSession$ChannelHeaderTab_Games$);
var $author$project$Evergreen$V419$UserSession$ChannelHeaderTab_VoiceChat = {$: 0};
var $author$project$Evergreen$V419$Message$RepliedTo_SheepGameAnswer$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V419$Message$RepliedTo_SheepGameAnswer = F2($author$project$Evergreen$V419$Message$RepliedTo_SheepGameAnswer$);
var $author$project$Evergreen$V419$Message$RepliedTo_SheepGameNotes = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$Message$RepliedTo_WordSpellingGameMove = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Message_RepliedToGame = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Message$RepliedTo_WordSpellingGameMove(p0);
		case 1:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Message$RepliedTo_SheepGameAnswer$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1));
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Message$RepliedTo_SheepGameNotes(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_UserSession_ChannelHeaderTab = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$UserSession$ChannelHeaderTab_VoiceChat;
		case 1:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$UserSession$ChannelHeaderTab_Games$(
				$elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, p0),
				$elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Message_RepliedToGame, p1));
		case 2:
			return $author$project$Evergreen$V419$UserSession$ChannelHeaderTab_ChannelDescription;
		default:
			return $author$project$Evergreen$V419$UserSession$ChannelHeaderTab_Draw;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Route_ChannelRoute = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Route$ChannelRoute$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Route_ThreadRouteWithFriends(p1),
				$elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_UserSession_ChannelHeaderTab, p2));
		case 1:
			return $author$project$Evergreen$V419$Route$NewChannelRoute;
		case 2:
			return $author$project$Evergreen$V419$Route$GuildSettingsRoute;
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Route$JoinRoute(
				$author$project$Evergreen$Migrate$V419$migrate_SecretId_SecretId(p0));
	}
};
var $author$project$Evergreen$V419$Route$ChannelsHiddenOnMobile = 0;
var $author$project$Evergreen$V419$Route$ChannelsVisibleOnMobile = 1;
var $author$project$Evergreen$Migrate$V419$migrate_Route_ChannelsVisibleOnMobile = function (old) {
	if (!old) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Evergreen$V419$Discord$Id = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_Discord_Id = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$V419$Route$E2eeInfoOverlay = 0;
var $author$project$Evergreen$V419$Route$SearchOverlay = 2;
var $author$project$Evergreen$V419$Route$UserOptionsOverlay = 1;
var $author$project$Evergreen$Migrate$V419$migrate_Route_Overlay = function (old) {
	switch (old) {
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			return 2;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Route_DiscordDmRouteData = function (old) {
	return {
		channelId: $author$project$Evergreen$Migrate$V419$migrate_Discord_Id(old.channelId),
		channelsVisible: $author$project$Evergreen$Migrate$V419$migrate_Route_ChannelsVisibleOnMobile(old.channelsVisible),
		currentDiscordUserId: $author$project$Evergreen$Migrate$V419$migrate_Discord_Id(old.currentDiscordUserId),
		overlay: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Route_Overlay, old.overlay),
		showMembersTab: $author$project$Evergreen$Migrate$V419$migrate_Route_ShowChannelSettings(old.showMembersTab),
		tab: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_UserSession_ChannelHeaderTab, old.tab),
		viewingMessage: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, old.viewingMessage)
	};
};
var $author$project$Evergreen$V419$Route$DiscordChannel_ChannelRoute$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Route$DiscordChannel_ChannelRoute = F3($author$project$Evergreen$V419$Route$DiscordChannel_ChannelRoute$);
var $author$project$Evergreen$V419$Route$DiscordChannel_GuildSettingsRoute = {$: 2};
var $author$project$Evergreen$V419$Route$DiscordChannel_NewChannelRoute = {$: 1};
var $author$project$Evergreen$Migrate$V419$migrate_Route_DiscordChannelRoute = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Route$DiscordChannel_ChannelRoute$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Route_ThreadRouteWithFriends(p1),
				$elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_UserSession_ChannelHeaderTab, p2));
		case 1:
			return $author$project$Evergreen$V419$Route$DiscordChannel_NewChannelRoute;
		default:
			return $author$project$Evergreen$V419$Route$DiscordChannel_GuildSettingsRoute;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Route_DiscordGuildRouteData = function (old) {
	return {
		channelRoute: $author$project$Evergreen$Migrate$V419$migrate_Route_DiscordChannelRoute(old.channelRoute),
		channelsVisible: $author$project$Evergreen$Migrate$V419$migrate_Route_ChannelsVisibleOnMobile(old.channelsVisible),
		currentDiscordUserId: $author$project$Evergreen$Migrate$V419$migrate_Discord_Id(old.currentDiscordUserId),
		guildId: $author$project$Evergreen$Migrate$V419$migrate_Discord_Id(old.guildId),
		overlay: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Route_Overlay, old.overlay)
	};
};
var $author$project$Evergreen$V419$DmChannelId$DmChannelId$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$DmChannelId$DmChannelId = F2($author$project$Evergreen$V419$DmChannelId$DmChannelId$);
var $author$project$Evergreen$Migrate$V419$migrate_DmChannelId_DmChannelId = function (old) {
	var p0 = old.a;
	var p1 = old.b;
	return $author$project$Evergreen$V419$DmChannelId$DmChannelId$(
		$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
		$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1));
};
var $author$project$Evergreen$Migrate$V419$migrate_Route_DmRouteData = function (old) {
	return {
		channelId: $author$project$Evergreen$Migrate$V419$migrate_DmChannelId_DmChannelId(old.channelId),
		channelsVisible: $author$project$Evergreen$Migrate$V419$migrate_Route_ChannelsVisibleOnMobile(old.channelsVisible),
		overlay: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Route_Overlay, old.overlay),
		tab: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_UserSession_ChannelHeaderTab, old.tab),
		threadRoute: $author$project$Evergreen$Migrate$V419$migrate_Route_ThreadRouteWithFriends(old.threadRoute)
	};
};
var $author$project$Evergreen$V419$Route$LinkDiscordExpired = 0;
var $author$project$Evergreen$V419$Route$LinkDiscordInvalidData = 2;
var $author$project$Evergreen$V419$Route$LinkDiscordLimitReachedError = 3;
var $author$project$Evergreen$V419$Route$LinkDiscordServerError = 1;
var $author$project$Evergreen$Migrate$V419$migrate_Route_LinkDiscordError = function (old) {
	switch (old) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $author$project$Evergreen$V419$Id$NoThreadWithMaybeMessage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Id$ViewThreadWithMaybeMessage$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V419$Id$ViewThreadWithMaybeMessage = F2($author$project$Evergreen$V419$Id$ViewThreadWithMaybeMessage$);
var $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMaybeMessage = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Id$NoThreadWithMaybeMessage(
			$elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, p0));
	} else {
		var p0 = old.a;
		var p1 = old.b;
		return $author$project$Evergreen$V419$Id$ViewThreadWithMaybeMessage$(
			$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
			$elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, p1));
	}
};
var $author$project$Evergreen$V419$Slack$Id = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_Slack_Id = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$Migrate$V419$migrate_Route_SlackDmRouteData = function (old) {
	return {
		channelId: $author$project$Evergreen$Migrate$V419$migrate_Slack_Id(old.channelId),
		channelsVisible: $author$project$Evergreen$Migrate$V419$migrate_Route_ChannelsVisibleOnMobile(old.channelsVisible),
		currentSlackUserId: $author$project$Evergreen$Migrate$V419$migrate_Slack_Id(old.currentSlackUserId),
		overlay: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Route_Overlay, old.overlay),
		threadRoute: $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMaybeMessage(old.threadRoute)
	};
};
var $author$project$Evergreen$V419$Route$SlackChannel_ChannelRoute$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Route$SlackChannel_ChannelRoute = F3($author$project$Evergreen$V419$Route$SlackChannel_ChannelRoute$);
var $author$project$Evergreen$V419$Route$SlackChannel_WorkspaceSettingsRoute = {$: 1};
var $author$project$Evergreen$Migrate$V419$migrate_Route_SlackChannelRoute = function (old) {
	if (!old.$) {
		var p0 = old.a;
		var p1 = old.b;
		var p2 = old.c;
		return $author$project$Evergreen$V419$Route$SlackChannel_ChannelRoute$(
			$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0),
			$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMaybeMessage(p1),
			$author$project$Evergreen$Migrate$V419$migrate_Route_ShowChannelSettings(p2));
	} else {
		return $author$project$Evergreen$V419$Route$SlackChannel_WorkspaceSettingsRoute;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Route_SlackWorkspaceRouteData = function (old) {
	return {
		channelRoute: $author$project$Evergreen$Migrate$V419$migrate_Route_SlackChannelRoute(old.channelRoute),
		channelsVisible: $author$project$Evergreen$Migrate$V419$migrate_Route_ChannelsVisibleOnMobile(old.channelsVisible),
		currentSlackUserId: $author$project$Evergreen$Migrate$V419$migrate_Slack_Id(old.currentSlackUserId),
		overlay: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Route_Overlay, old.overlay),
		teamId: $author$project$Evergreen$Migrate$V419$migrate_Slack_Id(old.teamId)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Route_Route = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Route$HomePageRoute(
				$elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Route_Overlay, p0));
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Route$AdminRoute(
				{
					highlightLog: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, p0.highlightLog)
				});
		case 2:
			return $author$project$Evergreen$V419$Route$NewGuildRoute;
		case 3:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Route$GuildRoute$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Route_ChannelRoute(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Route_ChannelsVisibleOnMobile(p2),
				$elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Route_Overlay, p3));
		case 4:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Route$DiscordGuildRoute(
				$author$project$Evergreen$Migrate$V419$migrate_Route_DiscordGuildRouteData(p0));
		case 5:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Route$DmRoute(
				$author$project$Evergreen$Migrate$V419$migrate_Route_DmRouteData(p0));
		case 6:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Route$DiscordDmRoute(
				$author$project$Evergreen$Migrate$V419$migrate_Route_DiscordDmRouteData(p0));
		case 7:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Route$SlackWorkspaceRoute(
				$author$project$Evergreen$Migrate$V419$migrate_Route_SlackWorkspaceRouteData(p0));
		case 8:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Route$SlackDmRoute(
				$author$project$Evergreen$Migrate$V419$migrate_Route_SlackDmRouteData(p0));
		case 9:
			return $author$project$Evergreen$V419$Route$AiChatRoute;
		case 10:
			return $author$project$Evergreen$V419$Route$TextEditorRoute;
		case 11:
			return $author$project$Evergreen$V419$Route$PrivacyRoute;
		case 12:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Route$LinkDiscord(
				$elm$core$Basics$composeR$(
					$elm$core$Result$mapError($author$project$Evergreen$Migrate$V419$migrate_Route_LinkDiscordError),
					$elm$core$Result$map($author$project$Evergreen$Migrate$V419$migrate_Discord_UserAuth),
					p0));
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Route$PublicGoMatchRoute(
				$author$project$Evergreen$Migrate$V419$migrate_SecretId_SecretId(p0));
	}
};
var $author$project$Evergreen$V419$Touch$DragStart$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V419$Touch$DragStart = F2($author$project$Evergreen$V419$Touch$DragStart$);
var $author$project$Evergreen$V419$Touch$Dragging = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$Touch$NoDrag = {$: 0};
var $author$project$Evergreen$V419$NonemptyDict$NonemptyDict$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$NonemptyDict$NonemptyDict = F3($author$project$Evergreen$V419$NonemptyDict$NonemptyDict$);
var $author$project$Evergreen$Migrate$V419$migrate_NonemptyDict_NonemptyDict$ = function (migrate_id, migrate_a, old) {
	var p0 = old.a;
	var p1 = old.b;
	var p2 = old.c;
	return $author$project$Evergreen$V419$NonemptyDict$NonemptyDict$(
		migrate_id(p0),
		migrate_a(p1),
		$elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, migrate_id, migrate_a)),
				$lamdera$containers$SeqDict$fromList),
			p2));
};
var $author$project$Evergreen$Migrate$V419$migrate_NonemptyDict_NonemptyDict = F3($author$project$Evergreen$Migrate$V419$migrate_NonemptyDict_NonemptyDict$);
var $author$project$Evergreen$V419$Touch$Drag_CallThumbnail = 1;
var $author$project$Evergreen$V419$Touch$Drag_Channel = 0;
var $author$project$Evergreen$V419$Touch$Drag_Game = 2;
var $author$project$Evergreen$Migrate$V419$migrate_Touch_DragTarget = function (old) {
	switch (old) {
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			return 2;
	}
};
var $author$project$Evergreen$V419$Geometry$Types$Point2d = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_Geometry_Types_Point2d = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$Migrate$V419$migrate_Point2d_Point2d$ = function (migrate_units, migrate_coordinates, old) {
	return $author$project$Evergreen$Migrate$V419$migrate_Geometry_Types_Point2d(old);
};
var $author$project$Evergreen$Migrate$V419$migrate_Point2d_Point2d = F3($author$project$Evergreen$Migrate$V419$migrate_Point2d_Point2d$);
var $author$project$Evergreen$V419$Touch$ScreenCoordinate = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_Touch_ScreenCoordinate = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$Migrate$V419$migrate_Touch_Touch = function (old) {
	return {
		client: $author$project$Evergreen$Migrate$V419$migrate_Point2d_Point2d$($author$project$Evergreen$Migrate$V419$migrate_CssPixels_CssPixels, $author$project$Evergreen$Migrate$V419$migrate_Touch_ScreenCoordinate, old.client),
		targetIsTextInput: old.targetIsTextInput
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Touch_Drag = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$Touch$NoDrag;
		case 1:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Touch$DragStart$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_NonemptyDict_NonemptyDict$($elm$core$Basics$identity, $author$project$Evergreen$Migrate$V419$migrate_Touch_Touch, p1));
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Touch$Dragging(
				{
					horizontalStart: p0.horizontalStart,
					target: $author$project$Evergreen$Migrate$V419$migrate_Touch_DragTarget(p0.target),
					touches: $author$project$Evergreen$Migrate$V419$migrate_NonemptyDict_NonemptyDict$($elm$core$Basics$identity, $author$project$Evergreen$Migrate$V419$migrate_Touch_Touch, p0.touches)
				});
	}
};
var $author$project$Evergreen$V419$Types$LoggedIn = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Types$NotLoggedIn = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$LoginForm$EnterEmail = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$LoginForm$EnterLoginCode = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$LoginForm$EnterTwoFactorCode = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$LoginForm$EnterUserData = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_LoginForm_EnterEmail2 = function (old) {
	return old;
};
var $author$project$Evergreen$V419$EmailAddress$EmailAddress = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_EmailAddress_EmailAddress = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$V419$LoginForm$Checking = 0;
var $author$project$Evergreen$V419$LoginForm$NotValid = 1;
var $author$project$Evergreen$Migrate$V419$migrate_LoginForm_CodeStatus = function (old) {
	if (!old) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_LoginForm_EnterLoginCode2 = function (old) {
	return {
		attempts: $lamdera$containers$SeqDict$map$(
			function (k) {
				return $author$project$Evergreen$Migrate$V419$migrate_LoginForm_CodeStatus;
			},
			old.attempts),
		code: old.code,
		sentTo: $author$project$Evergreen$Migrate$V419$migrate_EmailAddress_EmailAddress(old.sentTo)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_LoginForm_EnterTwoFactorCode2 = function (old) {
	return {
		attemptCount: old.attemptCount,
		attempts: $lamdera$containers$SeqDict$map$(
			function (k) {
				return $author$project$Evergreen$Migrate$V419$migrate_LoginForm_CodeStatus;
			},
			old.attempts),
		code: old.code
	};
};
var $author$project$Evergreen$V419$LoginForm$NotSubmitted = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$LoginForm$Submitting = {$: 1};
var $author$project$Evergreen$Migrate$V419$migrate_LoginForm_SubmitStatus = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$LoginForm$NotSubmitted(p0);
	} else {
		return $author$project$Evergreen$V419$LoginForm$Submitting;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_LoginForm_EnterUserData2 = function (old) {
	return {
		name: old.name,
		pressedSubmit: $author$project$Evergreen$Migrate$V419$migrate_LoginForm_SubmitStatus(old.pressedSubmit)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_LoginForm_LoginForm = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$LoginForm$EnterEmail(
				$author$project$Evergreen$Migrate$V419$migrate_LoginForm_EnterEmail2(p0));
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$LoginForm$EnterLoginCode(
				$author$project$Evergreen$Migrate$V419$migrate_LoginForm_EnterLoginCode2(p0));
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$LoginForm$EnterTwoFactorCode(
				$author$project$Evergreen$Migrate$V419$migrate_LoginForm_EnterTwoFactorCode2(p0));
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$LoginForm$EnterUserData(
				$author$project$Evergreen$Migrate$V419$migrate_LoginForm_EnterUserData2(p0));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Range_Range = function (old) {
	return old;
};
var $author$project$Evergreen$V419$Range$SelectBackward = 1;
var $author$project$Evergreen$V419$Range$SelectForward = 0;
var $author$project$Evergreen$Migrate$V419$migrate_Range_SelectionDirection = function (old) {
	if (!old) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Evergreen$V419$RecoveryLogin$Model = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$RecoveryLogin$IncorrectPassword = {$: 2};
var $author$project$Evergreen$V419$RecoveryLogin$NotSubmitted = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$RecoveryLogin$Submitting = {$: 1};
var $author$project$Evergreen$Migrate$V419$migrate_RecoveryLogin_SubmitStatus = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$RecoveryLogin$NotSubmitted(p0);
		case 1:
			return $author$project$Evergreen$V419$RecoveryLogin$Submitting;
		default:
			return $author$project$Evergreen$V419$RecoveryLogin$IncorrectPassword;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_RecoveryLogin_Model = function (old) {
	var p0 = old;
	return {
		password: p0.password,
		submitStatus: $author$project$Evergreen$Migrate$V419$migrate_RecoveryLogin_SubmitStatus(p0.submitStatus)
	};
};
var $lamdera$containers$SeqSet$map$ = function (fn, _v0) {
	var dict = _v0;
	return $lamdera$containers$SeqDict$foldl$(
		F3(
			function (k, _v1, b2) {
				return $lamdera$containers$SeqDict$insert$(
					fn(k),
					true,
					b2);
			}),
		$lamdera$containers$SeqDict$empty,
		dict);
};
var $lamdera$containers$SeqSet$map = F2($lamdera$containers$SeqSet$map$);
var $author$project$Evergreen$V419$Call$DmRoomId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Call$GuildRoomId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_ChannelId = function (old) {
	return {
		channelId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.channelId),
		guildId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.guildId)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DmId = function (old) {
	return {
		otherUserId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.otherUserId)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Call_CallId = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Call$DmRoomId(
			$author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DmId(p0));
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Call$GuildRoomId(
			$author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_ChannelId(p0));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Call_ConnectionId = function (old) {
	return {
		otherClientId: $elm$core$Tuple$mapFirst$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, old.otherClientId),
		roomId: $author$project$Evergreen$Migrate$V419$migrate_Call_CallId(old.roomId)
	};
};
var $author$project$Evergreen$V419$Call$IsConnection = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Call$IsLocal = {$: 0};
var $author$project$Evergreen$Migrate$V419$migrate_Call_LocalOrConnection = function (old) {
	if (!old.$) {
		return $author$project$Evergreen$V419$Call$IsLocal;
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Call$IsConnection(
			$author$project$Evergreen$Migrate$V419$migrate_Call_ConnectionId(p0));
	}
};
var $author$project$Evergreen$V419$Call$FailedToGetMediaDevices = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$Call$HasMediaDevices = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Call$MediaDevicesNotLoaded = {$: 0};
var $author$project$Evergreen$V419$Call$AudioInput = 0;
var $author$project$Evergreen$V419$Call$AudioOutput = 2;
var $author$project$Evergreen$V419$Call$VideoInput = 1;
var $author$project$Evergreen$Migrate$V419$migrate_Call_DeviceKind = function (old) {
	switch (old) {
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			return 2;
	}
};
var $author$project$Evergreen$V419$IdString$IdString = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_IdString_IdString = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$Migrate$V419$migrate_Call_MediaDevice = function (old) {
	return {
		deviceId: $author$project$Evergreen$Migrate$V419$migrate_IdString_IdString(old.deviceId),
		groupId: old.groupId,
		kind: $author$project$Evergreen$Migrate$V419$migrate_Call_DeviceKind(old.kind),
		label: old.label
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Call_MediaDevicesStatus = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$Call$MediaDevicesNotLoaded;
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Call$HasMediaDevices(
				$elm$core$List$map$($author$project$Evergreen$Migrate$V419$migrate_Call_MediaDevice, p0));
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Call$FailedToGetMediaDevices(p0);
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Call_RemoteCallData = function (old) {
	return old;
};
var $author$project$Evergreen$V419$Call$CameraTile = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Call$ScreenShareTile = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Call_VideoTile = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Call$CameraTile(
			$author$project$Evergreen$Migrate$V419$migrate_Call_LocalOrConnection(p0));
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Call$ScreenShareTile(
			$author$project$Evergreen$Migrate$V419$migrate_Call_LocalOrConnection(p0));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Call_Model = function (old) {
	return {
		debugData: old.debugData,
		focusedTile: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Call_VideoTile, old.focusedTile),
		isSpeaking: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Call_ConnectionId, old.isSpeaking),
		localIsSpeaking: old.localIsSpeaking,
		pollDebugData: old.pollDebugData,
		recordingUpload: old.recordingUpload,
		remoteCallData: $author$project$Evergreen$Migrate$V419$migrate_Call_RemoteCallData(old.remoteCallData),
		selectedAudioInputDevice: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_IdString_IdString, old.selectedAudioInputDevice),
		selectedVideoInputDevice: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_IdString_IdString, old.selectedVideoInputDevice),
		showDeviceSettings: old.showDeviceSettings,
		startConnectionError: old.startConnectionError,
		thumbnailPosition: old.thumbnailPosition,
		userMediaDevices: $author$project$Evergreen$Migrate$V419$migrate_Call_MediaDevicesStatus(old.userMediaDevices),
		videoHover: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Call_LocalOrConnection, old.videoHover),
		volume: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					$elm$core$Tuple$mapFirst(
						$elm$core$Tuple$mapFirst($author$project$Evergreen$Migrate$V419$migrate_Id_Id))),
				$lamdera$containers$SeqDict$fromList),
			old.volume)
	};
};
var $author$project$Evergreen$V419$Drawing$NoSelectedAnchor = {$: 0};
var $author$project$Evergreen$V419$Drawing$SelectedAnchor = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Drawing_ActiveStroke = function (old) {
	return {
		unsent: $elm$core$List$map$(
			A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_SafeFloat_SafeFloat, $author$project$Evergreen$Migrate$V419$migrate_SafeFloat_SafeFloat),
			old.unsent)
	};
};
var $author$project$Evergreen$V419$Drawing$DateDividerAnchor$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V419$Drawing$DateDividerAnchor = F2($author$project$Evergreen$V419$Drawing$DateDividerAnchor$);
var $author$project$Evergreen$V419$Drawing$MessageAnchor$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$Drawing$MessageAnchor = F2($author$project$Evergreen$V419$Drawing$MessageAnchor$);
var $author$project$Evergreen$V419$Drawing$CardAnchor = {$: 4};
var $author$project$Evergreen$V419$Drawing$EmbedImageAnchor = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V419$Drawing$ImageAttachmentAnchor = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$Drawing$TimestampAnchor = {$: 1};
var $author$project$Evergreen$V419$Drawing$UserIconAnchor = {$: 0};
var $author$project$Evergreen$Migrate$V419$migrate_Drawing_MessageAnchor = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$Drawing$UserIconAnchor;
		case 1:
			return $author$project$Evergreen$V419$Drawing$TimestampAnchor;
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Drawing$ImageAttachmentAnchor(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 3:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Drawing$EmbedImageAnchor(p0);
		default:
			return $author$project$Evergreen$V419$Drawing$CardAnchor;
	}
};
var $author$project$Evergreen$V419$Id$NoThread = {$: 0};
var $author$project$Evergreen$V419$Id$ViewThread = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute = function (old) {
	if (!old.$) {
		return $author$project$Evergreen$V419$Id$NoThread;
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Id$ViewThread(
			$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
	}
};
var $author$project$Evergreen$V419$Id$NoThreadWithMessage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Id$ViewThreadWithMessage$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V419$Id$ViewThreadWithMessage = F2($author$project$Evergreen$V419$Id$ViewThreadWithMessage$);
var $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Id$NoThreadWithMessage(
			$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
	} else {
		var p0 = old.a;
		var p1 = old.b;
		return $author$project$Evergreen$V419$Id$ViewThreadWithMessage$(
			$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
			$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Drawing_AnchorType = function (old) {
	if (!old.$) {
		var p0 = old.a;
		var p1 = old.b;
		return $author$project$Evergreen$V419$Drawing$MessageAnchor$(
			$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p0),
			$author$project$Evergreen$Migrate$V419$migrate_Drawing_MessageAnchor(p1));
	} else {
		var p0 = old.a;
		var p1 = old.b;
		return $author$project$Evergreen$V419$Drawing$DateDividerAnchor$(
			$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute(p0),
			p1);
	}
};
var $author$project$Evergreen$V419$Id$DiscordGuildOrDmId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Id$GuildOrDmId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Id$SlackGuildOrDmId = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$Id$DiscordGuildOrDmId_Dm = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Id$DiscordGuildOrDmId_Guild = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DiscordChannelId = function (old) {
	return {
		channelId: $author$project$Evergreen$Migrate$V419$migrate_Discord_Id(old.channelId),
		currentUserId: $author$project$Evergreen$Migrate$V419$migrate_Discord_Id(old.currentUserId),
		guildId: $author$project$Evergreen$Migrate$V419$migrate_Discord_Id(old.guildId)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DiscordDmId = function (old) {
	return {
		channelId: $author$project$Evergreen$Migrate$V419$migrate_Discord_Id(old.channelId),
		currentUserId: $author$project$Evergreen$Migrate$V419$migrate_Discord_Id(old.currentUserId)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Id_DiscordGuildOrDmId = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Id$DiscordGuildOrDmId_Guild(
			$author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DiscordChannelId(p0));
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Id$DiscordGuildOrDmId_Dm(
			$author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DiscordDmId(p0));
	}
};
var $author$project$Evergreen$V419$Id$GuildOrDmId_Dm = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Id$GuildOrDmId_Guild = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Id_GuildOrDmId = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Id$GuildOrDmId_Guild(
			$author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_ChannelId(p0));
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Id$GuildOrDmId_Dm(
			$author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DmId(p0));
	}
};
var $author$project$Evergreen$V419$Id$SlackGuildOrDmId_Dm = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Id$SlackGuildOrDmId_Workspace = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_SlackChannelId = function (old) {
	return {
		channelId: $author$project$Evergreen$Migrate$V419$migrate_Slack_Id(old.channelId),
		currentUserId: $author$project$Evergreen$Migrate$V419$migrate_Slack_Id(old.currentUserId),
		teamId: $author$project$Evergreen$Migrate$V419$migrate_Slack_Id(old.teamId)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_SlackDmId = function (old) {
	return {
		channelId: $author$project$Evergreen$Migrate$V419$migrate_Slack_Id(old.channelId),
		currentUserId: $author$project$Evergreen$Migrate$V419$migrate_Slack_Id(old.currentUserId)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Id_SlackGuildOrDmId = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Id$SlackGuildOrDmId_Workspace(
			$author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_SlackChannelId(p0));
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Id$SlackGuildOrDmId_Dm(
			$author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_SlackDmId(p0));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Id$GuildOrDmId(
				$author$project$Evergreen$Migrate$V419$migrate_Id_GuildOrDmId(p0));
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Id$DiscordGuildOrDmId(
				$author$project$Evergreen$Migrate$V419$migrate_Id_DiscordGuildOrDmId(p0));
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Id$SlackGuildOrDmId(
				$author$project$Evergreen$Migrate$V419$migrate_Id_SlackGuildOrDmId(p0));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Drawing_SelectedAnchorData = function (old) {
	return {
		anchorHalfSize: old.anchorHalfSize,
		anchorType: $author$project$Evergreen$Migrate$V419$migrate_Drawing_AnchorType(old.anchorType),
		guildOrDmId: $author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId(old.guildOrDmId),
		pointScale: old.pointScale,
		position: $author$project$Evergreen$Migrate$V419$migrate_Point2d_Point2d$($author$project$Evergreen$Migrate$V419$migrate_CssPixels_CssPixels, $author$project$Evergreen$Migrate$V419$migrate_Touch_ScreenCoordinate, old.position),
		stroke: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Drawing_ActiveStroke, old.stroke),
		zoom: old.zoom,
		zoomContainer: old.zoomContainer
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Drawing_Model = function (old) {
	if (!old.$) {
		return $author$project$Evergreen$V419$Drawing$NoSelectedAnchor;
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Drawing$SelectedAnchor(
			$author$project$Evergreen$Migrate$V419$migrate_Drawing_SelectedAnchorData(p0));
	}
};
var $author$project$Evergreen$V419$Emoji$CustomEmojiCategory = {$: 2};
var $author$project$Evergreen$V419$Emoji$EmojiCategory = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Emoji$StickerCategory = {$: 1};
var $author$project$Evergreen$Migrate$V419$migrate_Emoji_Category = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Emoji$EmojiCategory(
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiCategory(p0));
		case 1:
			return $author$project$Evergreen$V419$Emoji$StickerCategory;
		default:
			return $author$project$Evergreen$V419$Emoji$CustomEmojiCategory;
	}
};
var $author$project$Evergreen$V419$Emoji$EmojiOrSticker_CustomEmoji = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$Emoji$EmojiOrSticker_Sticker = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Emoji$EmojiOrSticker_UnicodeEmoji = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrSticker = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Emoji$EmojiOrSticker_UnicodeEmoji(
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_UnicodeEmoji(p0));
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Emoji$EmojiOrSticker_Sticker(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Emoji$EmojiOrSticker_CustomEmoji(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Emoji_Model = function (old) {
	return {
		category: $author$project$Evergreen$Migrate$V419$migrate_Emoji_Category(old.category),
		emojiHovered: $elm$core$Maybe$map$(
			function (rec) {
				return {
					emoji: $author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrSticker(rec.emoji),
					index: rec.index
				};
			},
			old.emojiHovered),
		searchText: old.searchText
	};
};
var $author$project$Evergreen$V419$FileName$FileName = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_FileName_FileName = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$V419$FileStatus$ContentType = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_FileStatus_ContentType = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$V419$FileStatus$FileHash = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$V419$FileStatus$FileMetadata_Image = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$FileStatus$FileMetadata_Video = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_FileStatus_Location = function (old) {
	return {
		lat: $author$project$Evergreen$Migrate$V419$migrate_SafeFloat_SafeFloat(old.lat),
		lon: $author$project$Evergreen$Migrate$V419$migrate_SafeFloat_SafeFloat(old.lon)
	};
};
var $author$project$Evergreen$V419$FileStatus$Mirrored = 4;
var $author$project$Evergreen$V419$FileStatus$MirroredRotation180 = 6;
var $author$project$Evergreen$V419$FileStatus$MirroredRotation270 = 7;
var $author$project$Evergreen$V419$FileStatus$MirroredRotation90 = 5;
var $author$project$Evergreen$V419$FileStatus$NoChange = 0;
var $author$project$Evergreen$V419$FileStatus$Rotation180 = 2;
var $author$project$Evergreen$V419$FileStatus$Rotation270 = 3;
var $author$project$Evergreen$V419$FileStatus$Rotation90 = 1;
var $author$project$Evergreen$Migrate$V419$migrate_FileStatus_Orientation = function (old) {
	switch (old) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		case 6:
			return 6;
		default:
			return 7;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_FileStatus_ImageMetadata = function (old) {
	return {
		cameraOwner: old.cameraOwner,
		exposureTime: old.exposureTime,
		fNumber: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_SafeFloat_SafeFloat, old.fNumber),
		focalLength: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_SafeFloat_SafeFloat, old.focalLength),
		gpsLocation: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_Location, old.gpsLocation),
		imageSize: $author$project$Evergreen$Migrate$V419$migrate_Coord_Coord$($author$project$Evergreen$Migrate$V419$migrate_CssPixels_CssPixels, old.imageSize),
		isoSpeedRating: old.isoSpeedRating,
		make: old.make,
		model: old.model,
		orientation: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_Orientation, old.orientation),
		software: old.software,
		userComment: old.userComment
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_FileStatus_VideoMetadata = function (old) {
	return {
		codec: old.codec,
		createdAt: old.createdAt,
		duration: old.duration,
		gpsLocation: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_Location, old.gpsLocation),
		orientation: $author$project$Evergreen$Migrate$V419$migrate_FileStatus_Orientation(old.orientation),
		title: old.title,
		videoSize: $author$project$Evergreen$Migrate$V419$migrate_Coord_Coord$($author$project$Evergreen$Migrate$V419$migrate_CssPixels_CssPixels, old.videoSize)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileMetadata = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$FileStatus$FileMetadata_Image(
			$author$project$Evergreen$Migrate$V419$migrate_FileStatus_ImageMetadata(p0));
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$FileStatus$FileMetadata_Video(
			$author$project$Evergreen$Migrate$V419$migrate_FileStatus_VideoMetadata(p0));
	}
};
var $author$project$Evergreen$V419$FileStatus$IsEncrypted$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V419$FileStatus$IsEncrypted = F2($author$project$Evergreen$V419$FileStatus$IsEncrypted$);
var $author$project$Evergreen$V419$FileStatus$IsNotEncrypted = {$: 0};
var $author$project$Evergreen$V419$FileStatus$AesPrivateKey = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_FileStatus_AesPrivateKey = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$V419$FileStatus$HasEncryptedThumbnail = 1;
var $author$project$Evergreen$V419$FileStatus$NoEncryptedThumbnail = 0;
var $author$project$Evergreen$Migrate$V419$migrate_FileStatus_EncryptedThumbnail = function (old) {
	if (!old) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_FileStatus_IsEncrypted = function (old) {
	if (!old.$) {
		return $author$project$Evergreen$V419$FileStatus$IsNotEncrypted;
	} else {
		var p0 = old.a;
		var p1 = old.b;
		return $author$project$Evergreen$V419$FileStatus$IsEncrypted$(
			$author$project$Evergreen$Migrate$V419$migrate_FileStatus_AesPrivateKey(p0),
			$author$project$Evergreen$Migrate$V419$migrate_FileStatus_EncryptedThumbnail(p1));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileDataWithImage = function (old) {
	return {
		contentType: $author$project$Evergreen$Migrate$V419$migrate_FileStatus_ContentType(old.contentType),
		fileHash: $author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash(old.fileHash),
		fileName: $author$project$Evergreen$Migrate$V419$migrate_FileName_FileName(old.fileName),
		fileSize: old.fileSize,
		isEncrypted: $author$project$Evergreen$Migrate$V419$migrate_FileStatus_IsEncrypted(old.isEncrypted),
		metadata: $author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileMetadata(old.metadata)
	};
};
var $author$project$Evergreen$V419$FileStatus$FileError$ = function (a, b, c, d, e) {
	return {$: 2, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V419$FileStatus$FileError = F5($author$project$Evergreen$V419$FileStatus$FileError$);
var $author$project$Evergreen$V419$FileStatus$FileUploaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$FileStatus$FileUploading$ = function (a, b, c, d) {
	return {$: 0, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$FileStatus$FileUploading = F4($author$project$Evergreen$V419$FileStatus$FileUploading$);
var $author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileData = function (old) {
	return {
		contentType: $author$project$Evergreen$Migrate$V419$migrate_FileStatus_ContentType(old.contentType),
		fileHash: $author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash(old.fileHash),
		fileName: $author$project$Evergreen$Migrate$V419$migrate_FileName_FileName(old.fileName),
		fileSize: old.fileSize,
		isEncrypted: $author$project$Evergreen$Migrate$V419$migrate_FileStatus_IsEncrypted(old.isEncrypted),
		metadata: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileMetadata, old.metadata)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileStatus = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$FileStatus$FileUploading$(
				$author$project$Evergreen$Migrate$V419$migrate_FileName_FileName(p0),
				p1,
				$author$project$Evergreen$Migrate$V419$migrate_FileStatus_ContentType(p2),
				$author$project$Evergreen$Migrate$V419$migrate_FileStatus_IsEncrypted(p3));
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$FileStatus$FileUploaded(
				$author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileData(p0));
		default:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			return $author$project$Evergreen$V419$FileStatus$FileError$(
				$author$project$Evergreen$Migrate$V419$migrate_FileName_FileName(p0),
				p1,
				$author$project$Evergreen$Migrate$V419$migrate_FileStatus_ContentType(p2),
				p3,
				$author$project$Evergreen$Migrate$V419$migrate_FileStatus_IsEncrypted(p4));
	}
};
var $author$project$Evergreen$V419$Game$GoModel_Game = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Game$SheepGame_Game = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$Game$WordSpellingGame_Game = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Go_GameModel = function (old) {
	return old;
};
var $author$project$Evergreen$V419$IdArray$IdArray = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_IdArray_IdArray$ = function (migrate_v, old) {
	var p0 = old;
	return $elm$core$Array$map$(migrate_v, p0);
};
var $author$project$Evergreen$Migrate$V419$migrate_IdArray_IdArray = F2($author$project$Evergreen$Migrate$V419$migrate_IdArray_IdArray$);
var $author$project$Evergreen$V419$Scroll$ScrolledCloseToBottom = 1;
var $author$project$Evergreen$V419$Scroll$ScrolledToBottom = 0;
var $author$project$Evergreen$V419$Scroll$ScrolledToMiddle = 3;
var $author$project$Evergreen$V419$Scroll$ScrolledToTop = 2;
var $author$project$Evergreen$Migrate$V419$migrate_Scroll_ScrollPosition = function (old) {
	switch (old) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $author$project$Evergreen$V419$SheepGame$AnswerReaction$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$SheepGame$AnswerReaction = F2($author$project$Evergreen$V419$SheepGame$AnswerReaction$);
var $author$project$Evergreen$V419$SheepGame$NotesReaction = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_SheepGame_ReactionTarget = function (old) {
	if (!old.$) {
		var p0 = old.a;
		var p1 = old.b;
		return $author$project$Evergreen$V419$SheepGame$AnswerReaction$(
			$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
			$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1));
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$SheepGame$NotesReaction(
			$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_SheepGame_UnvalidatedInput = function (old) {
	return {
		attachedFiles: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileStatus)),
				$lamdera$containers$SeqDict$fromList),
			old.attachedFiles),
		text: old.text
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_SheepGame_GameData = function (old) {
	return {
		answerDrafts: $author$project$Evergreen$Migrate$V419$migrate_IdArray_IdArray$($author$project$Evergreen$Migrate$V419$migrate_SheepGame_UnvalidatedInput, old.answerDrafts),
		gridHovered: $elm$core$Maybe$map$(
			A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id),
			old.gridHovered),
		hoveredQuestion: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, old.hoveredQuestion),
		hoveredResult: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_SheepGame_ReactionTarget, old.hoveredResult),
		newQuestionRevealed: old.newQuestionRevealed,
		noteDrafts: $author$project$Evergreen$Migrate$V419$migrate_IdArray_IdArray$($author$project$Evergreen$Migrate$V419$migrate_SheepGame_UnvalidatedInput, old.noteDrafts),
		questionsRevealedSeen: old.questionsRevealedSeen,
		scrollPosition: $author$project$Evergreen$Migrate$V419$migrate_Scroll_ScrollPosition(old.scrollPosition)
	};
};
var $author$project$Evergreen$V419$WordSpellingGame$Dragging = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$WordSpellingGame$NotDragging = {$: 1};
var $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_Drag = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$WordSpellingGame$Dragging(p0);
	} else {
		return $author$project$Evergreen$V419$WordSpellingGame$NotDragging;
	}
};
var $author$project$Evergreen$V419$WordSpellingGame$Letter = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$WordSpellingGame$Wildcard = {$: 1};
var $author$project$Evergreen$V419$WordSpellingGame$LetterChar = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_Letter = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_LetterOrWildcard = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$WordSpellingGame$Letter(
			$author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_Letter(p0));
	} else {
		return $author$project$Evergreen$V419$WordSpellingGame$Wildcard;
	}
};
var $author$project$Evergreen$V419$OneOrGreater$OneOrGreater = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_OneOrGreater_OneOrGreater = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$V419$UserSession$EmptyPlaceholder = {$: 0};
var $author$project$Evergreen$V419$UserSession$FilledInByBackend = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$ = function (migrate_a, old) {
	if (!old.$) {
		return $author$project$Evergreen$V419$UserSession$EmptyPlaceholder;
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$UserSession$FilledInByBackend(
			migrate_a(p0));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend = F2($author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$);
var $author$project$Evergreen$V419$WordSpellingGame$IsNotValid = {$: 1};
var $author$project$Evergreen$V419$WordSpellingGame$IsValid = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_IsValid = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$WordSpellingGame$IsValid(p0);
	} else {
		return $author$project$Evergreen$V419$WordSpellingGame$IsNotValid;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_AnimatedPlacement = function (old) {
	return {
		cells: $elm$core$List$map$(
			$elm$core$Tuple$mapSecond($author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_LetterOrWildcard),
			old.cells),
		isValid: $author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$($author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_IsValid, old.isValid),
		startTime: old.startTime
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_PlacedWord = function (old) {
	return {
		isVertical: old.isVertical,
		letters: $author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty$($author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_LetterOrWildcard, old.letters),
		start: old.start
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_PlacementResult = function (old) {
	return {
		placedCells: $elm$core$List$map$(
			$elm$core$Tuple$mapSecond($author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_LetterOrWildcard),
			old.placedCells),
		score: old.score,
		words: $elm$core$List$map$(
			function (rec) {
				return {
					letters: $elm$core$List$map$($author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_LetterOrWildcard, rec.letters),
					placedCount: rec.placedCount
				};
			},
			old.words)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_Player = function (old) {
	return {
		premove: $elm$core$Maybe$map$(
			function (_v0) {
				var t1 = _v0.a;
				var t2 = _v0.b;
				var t3 = _v0.c;
				return _Utils_Tuple3(
					$author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_PlacedWord(t1),
					$author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_PlacementResult(t2),
					$author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_IsValid(t3));
			},
			old.premove),
		score: old.score,
		tray: $author$project$Evergreen$Migrate$V419$migrate_IdArray_IdArray$($author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_LetterOrWildcard, old.tray),
		userId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.userId)
	};
};
var $author$project$Evergreen$V419$WordSpellingGame$MoveReaction = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_ReactionTarget = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$V419$Emoji$EmojiOrCustomEmoji_CustomEmoji = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Emoji$EmojiOrCustomEmoji_Emoji = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Emoji$EmojiOrCustomEmoji_Emoji(
			$author$project$Evergreen$Migrate$V419$migrate_Emoji_UnicodeEmoji(p0));
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Emoji$EmojiOrCustomEmoji_CustomEmoji(
			$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
	}
};
var $author$project$Evergreen$V419$NonemptySet$NonemptySet$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$NonemptySet$NonemptySet = F2($author$project$Evergreen$V419$NonemptySet$NonemptySet$);
var $author$project$Evergreen$Migrate$V419$migrate_NonemptySet_NonemptySet$ = function (migrate_a, old) {
	var p0 = old.a;
	var p1 = old.b;
	return $author$project$Evergreen$V419$NonemptySet$NonemptySet$(
		migrate_a(p0),
		$lamdera$containers$SeqSet$map$(migrate_a, p1));
};
var $author$project$Evergreen$Migrate$V419$migrate_NonemptySet_NonemptySet = F2($author$project$Evergreen$Migrate$V419$migrate_NonemptySet_NonemptySet$);
var $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_Reactions = function (old) {
	return $elm$core$Basics$composeR$(
		$lamdera$containers$SeqDict$toList,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map(
				A2(
					$elm$core$Tuple$mapBoth,
					$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji,
					$author$project$Evergreen$Migrate$V419$migrate_NonemptySet_NonemptySet($author$project$Evergreen$Migrate$V419$migrate_Id_Id))),
			$lamdera$containers$SeqDict$fromList),
		old);
};
var $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_Shared = function (old) {
	return {
		attemptsLeft: $author$project$Evergreen$Migrate$V419$migrate_OneOrGreater_OneOrGreater(old.attemptsLeft),
		board: $lamdera$containers$SeqDict$map$(
			function (k) {
				return $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_LetterOrWildcard;
			},
			old.board),
		lastPlacement: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_AnimatedPlacement, old.lastPlacement),
		passingStartedAt: old.passingStartedAt,
		players: $author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty$($author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_Player, old.players),
		reactions: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_ReactionTarget, $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_Reactions)),
				$lamdera$containers$SeqDict$fromList),
			old.reactions),
		turnCount: old.turnCount
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_HoveredMove = function (old) {
	return {
		cells: $elm$core$Dict$map$(
			function (k) {
				return $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_LetterOrWildcard;
			},
			old.cells),
		index: old.index,
		shared: $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_Shared(old.shared)
	};
};
var $author$project$Evergreen$V419$WordSpellingGame$TileInTray$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$WordSpellingGame$TileInTray = F2($author$project$Evergreen$V419$WordSpellingGame$TileInTray$);
var $author$project$Evergreen$V419$WordSpellingGame$TileOnBoard$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V419$WordSpellingGame$TileOnBoard = F2($author$project$Evergreen$V419$WordSpellingGame$TileOnBoard$);
var $author$project$Evergreen$V419$WordSpellingGame$TrayIndex = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_TrayIndex = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_TilePosition = function (old) {
	if (!old.$) {
		var p0 = old.a;
		var p1 = old.b;
		return $author$project$Evergreen$V419$WordSpellingGame$TileInTray$(
			$author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_TrayIndex(p0),
			p1);
	} else {
		var p0 = old.a;
		var p1 = old.b;
		return $author$project$Evergreen$V419$WordSpellingGame$TileOnBoard$(p0, p1);
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_Tile = function (old) {
	return {
		createdAt: old.createdAt,
		position: $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_TilePosition(old.position)
	};
};
var $author$project$Evergreen$V419$WordSpellingGame$WordDefinition_None = {$: 0};
var $author$project$Evergreen$V419$WordSpellingGame$WordDefinition_Open$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V419$WordSpellingGame$WordDefinition_Open = F2($author$project$Evergreen$V419$WordSpellingGame$WordDefinition_Open$);
var $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_OpenWordDefinition = function (old) {
	return old;
};
var $author$project$Evergreen$V419$WordSpellingGame$WordDefinition_Failed = {$: 3};
var $author$project$Evergreen$V419$WordSpellingGame$WordDefinition_Loaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V419$WordSpellingGame$WordDefinition_Loading = {$: 0};
var $author$project$Evergreen$V419$WordSpellingGame$WordDefinition_NotFound = {$: 2};
var $author$project$Evergreen$V419$WordSpellingGame$WordDefinition_SwedishUnsupported = {$: 1};
var $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_WordDefinitionData = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$WordSpellingGame$WordDefinition_Loading;
		case 1:
			return $author$project$Evergreen$V419$WordSpellingGame$WordDefinition_SwedishUnsupported;
		case 2:
			return $author$project$Evergreen$V419$WordSpellingGame$WordDefinition_NotFound;
		case 3:
			return $author$project$Evergreen$V419$WordSpellingGame$WordDefinition_Failed;
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$WordSpellingGame$WordDefinition_Loaded(p0);
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_WordDefinition = function (old) {
	if (!old.$) {
		return $author$project$Evergreen$V419$WordSpellingGame$WordDefinition_None;
	} else {
		var p0 = old.a;
		var p1 = old.b;
		return $author$project$Evergreen$V419$WordSpellingGame$WordDefinition_Open$(
			$author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_OpenWordDefinition(p0),
			$author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_WordDefinitionData(p1));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_ZoomState = function (old) {
	return old;
};
var $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_ZoomAnimation = function (old) {
	return {
		from: $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_ZoomState(old.from),
		start: old.start
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_GameData = function (old) {
	return {
		dragging: $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_Drag(old.dragging),
		highlightedPlayer: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, old.highlightedPlayer),
		hoveredMove: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_HoveredMove, old.hoveredMove),
		lastWordPlaced: old.lastWordPlaced,
		scrollPosition: $author$project$Evergreen$Migrate$V419$migrate_Scroll_ScrollPosition(old.scrollPosition),
		selectedCell: old.selectedCell,
		showSettings: old.showSettings,
		tiles: $elm$core$Array$map$($author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_Tile, old.tiles),
		wordDefinition: $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_WordDefinition(old.wordDefinition),
		zoomAnimation: $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_ZoomAnimation(old.zoomAnimation)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Game_Game = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Game$GoModel_Game(
				$author$project$Evergreen$Migrate$V419$migrate_Go_GameModel(p0));
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Game$WordSpellingGame_Game(
				$author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_GameData(p0));
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Game$SheepGame_Game(
				$author$project$Evergreen$Migrate$V419$migrate_SheepGame_GameData(p0));
	}
};
var $author$project$Evergreen$V419$Game$GameSelect = {$: 0};
var $author$project$Evergreen$V419$Game$GoModel_Setup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Game$SheepGame_Setup = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V419$Game$WordSpellingGame_Setup = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$Go$CustomSize = 3;
var $author$project$Evergreen$V419$Go$Standard13 = 1;
var $author$project$Evergreen$V419$Go$Standard19 = 2;
var $author$project$Evergreen$V419$Go$Standard9 = 0;
var $author$project$Evergreen$Migrate$V419$migrate_Go_SizeSelection = function (old) {
	switch (old) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $author$project$Evergreen$V419$Go$Black = 0;
var $author$project$Evergreen$V419$Go$White = 1;
var $author$project$Evergreen$Migrate$V419$migrate_Go_Stone = function (old) {
	if (!old) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Go_SetupModel = function (old) {
	return {
		error: old.error,
		gameCreatorPlayingAs: $author$project$Evergreen$Migrate$V419$migrate_Go_Stone(old.gameCreatorPlayingAs),
		handicapInput: old.handicapInput,
		heightInput: old.heightInput,
		incrementInput: old.incrementInput,
		komiInput: old.komiInput,
		mainTimeInput: old.mainTimeInput,
		sizeSelection: $author$project$Evergreen$Migrate$V419$migrate_Go_SizeSelection(old.sizeSelection),
		widthInput: old.widthInput
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_SheepGame_SetupModel = function (old) {
	return {
		error: old.error,
		pressedSubmit: old.pressedSubmit,
		questions: $author$project$Evergreen$Migrate$V419$migrate_IdArray_IdArray$($author$project$Evergreen$Migrate$V419$migrate_SheepGame_UnvalidatedInput, old.questions)
	};
};
var $author$project$Evergreen$V419$WordSpellingGame$English = 0;
var $author$project$Evergreen$V419$WordSpellingGame$Swedish = 1;
var $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_Language = function (old) {
	if (!old) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_SetupModel = function (old) {
	return {
		advancedSettingsExpanded: old.advancedSettingsExpanded,
		error: old.error,
		fullTrayBonus: old.fullTrayBonus,
		incrementInput: old.incrementInput,
		language: $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_Language(old.language),
		letterValues: old.letterValues,
		letters: old.letters,
		mainTimeInput: old.mainTimeInput,
		placeWordAttempts: $author$project$Evergreen$Migrate$V419$migrate_OneOrGreater_OneOrGreater(old.placeWordAttempts),
		traySize: old.traySize
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Game_Setup = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$Game$GameSelect;
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Game$GoModel_Setup(
				$author$project$Evergreen$Migrate$V419$migrate_Go_SetupModel(p0));
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Game$WordSpellingGame_Setup(
				$author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_SetupModel(p0));
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Game$SheepGame_Setup(
				$author$project$Evergreen$Migrate$V419$migrate_SheepGame_SetupModel(p0));
	}
};
var $author$project$Evergreen$V419$SheepGame$AnswerInput = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$SheepGame$NotesInput = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$SheepGame$QuestionInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_SheepGame_Input = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$SheepGame$QuestionInput(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$SheepGame$AnswerInput(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$SheepGame$NotesInput(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Game_Model = function (old) {
	return {
		setup: $author$project$Evergreen$Migrate$V419$migrate_Game_Setup(old.setup),
		sheepGameQuestionsCounter: old.sheepGameQuestionsCounter,
		sheepGameSaveCounters: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					$elm$core$Tuple$mapFirst(
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_SheepGame_Input))),
				$lamdera$containers$SeqDict$fromList),
			old.sheepGameSaveCounters),
		startedGames: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Game_Game)),
				$lamdera$containers$SeqDict$fromList),
			old.startedGames)
	};
};
var $author$project$Evergreen$V419$Id$ChannelMessageId = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$V419$ImageEditor$BottomLeft = 2;
var $author$project$Evergreen$V419$ImageEditor$BottomRight = 3;
var $author$project$Evergreen$V419$ImageEditor$Center = 4;
var $author$project$Evergreen$V419$ImageEditor$TopLeft = 0;
var $author$project$Evergreen$V419$ImageEditor$TopRight = 1;
var $author$project$Evergreen$Migrate$V419$migrate_ImageEditor_DragPart = function (old) {
	switch (old) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		default:
			return 4;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_ImageEditor_DragState = function (old) {
	return {
		currentX: old.currentX,
		currentY: old.currentY,
		dragPart: $author$project$Evergreen$Migrate$V419$migrate_ImageEditor_DragPart(old.dragPart),
		startX: old.startX,
		startY: old.startY
	};
};
var $author$project$Evergreen$V419$ImageEditor$Cropping = {$: 1};
var $author$project$Evergreen$V419$ImageEditor$NotUploaded = {$: 0};
var $author$project$Evergreen$V419$ImageEditor$Uploading = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$ImageEditor$UploadingError = {$: 3};
var $author$project$Evergreen$Migrate$V419$migrate_ImageEditor_UploadStatus = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$ImageEditor$NotUploaded;
		case 1:
			return $author$project$Evergreen$V419$ImageEditor$Cropping;
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$ImageEditor$Uploading(
				$author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash(p0));
		default:
			return $author$project$Evergreen$V419$ImageEditor$UploadingError;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_ImageEditor_Model = function (old) {
	return {
		dragState: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_ImageEditor_DragState, old.dragState),
		imageSize: old.imageSize,
		imageUrl: old.imageUrl,
		size: old.size,
		status: $author$project$Evergreen$Migrate$V419$migrate_ImageEditor_UploadStatus(old.status),
		x: old.x,
		y: old.y
	};
};
var $author$project$Evergreen$V419$Call$AskingToRecord = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Call$RecordingDeclined = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Call$RecordingSince = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Call_RecordingStatus = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Call$AskingToRecord(
				{
					allowedBy: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, p0.allowedBy),
					requestedAt: p0.requestedAt,
					requestedBy: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0.requestedBy)
				});
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Call$RecordingDeclined(
				{
					declinedAt: p0.declinedAt,
					declinedBy: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, p0.declinedBy),
					requestedBy: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0.requestedBy)
				});
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Call$RecordingSince(p0);
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Call_Local = function (old) {
	return {
		currentRoom: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Call_CallId, old.currentRoom),
		recordings: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Call_CallId, $author$project$Evergreen$Migrate$V419$migrate_Call_RecordingStatus)),
				$lamdera$containers$SeqDict$fromList),
			old.recordings),
		voiceChats: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Call_CallId,
						A2(
							$author$project$Evergreen$Migrate$V419$migrate_NonemptyDict_NonemptyDict,
							$elm$core$Tuple$mapFirst($author$project$Evergreen$Migrate$V419$migrate_Id_Id),
							$author$project$Evergreen$Migrate$V419$migrate_Call_RemoteCallData))),
				$lamdera$containers$SeqDict$fromList),
			old.voiceChats)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Drawing_Stroke = function (old) {
	return {
		points: $author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty$(
			A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_SafeFloat_SafeFloat, $author$project$Evergreen$Migrate$V419$migrate_SafeFloat_SafeFloat),
			old.points)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Drawing_Drawing$ = function (migrate_userId, old) {
	return {
		finished: $elm$core$List$map$(
			function (rec) {
				return {
					createdBy: migrate_userId(rec.createdBy),
					points: $author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty$(
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_SafeFloat_SafeFloat, $author$project$Evergreen$Migrate$V419$migrate_SafeFloat_SafeFloat),
						rec.points)
				};
			},
			old.finished),
		inProgress: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, migrate_userId, $author$project$Evergreen$Migrate$V419$migrate_Drawing_Stroke)),
				$lamdera$containers$SeqDict$fromList),
			old.inProgress),
		undone: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						migrate_userId,
						$elm$core$List$map($author$project$Evergreen$Migrate$V419$migrate_Drawing_Stroke))),
				$lamdera$containers$SeqDict$fromList),
			old.undone)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Drawing_Drawing = F2($author$project$Evergreen$Migrate$V419$migrate_Drawing_Drawing$);
var $author$project$Evergreen$V419$MessageArray$MessageArray = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Message$CallStarted = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V419$Message$DeletedMessage = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V419$Message$EncryptedUserTextMessage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Message$GameStarted = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V419$Message$UserJoinedMessage$ = function (a, b, c, d) {
	return {$: 2, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Message$UserJoinedMessage = F4($author$project$Evergreen$V419$Message$UserJoinedMessage$);
var $author$project$Evergreen$V419$Message$UserTextMessage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Message_CallRecordingFile$ = function (migrate_userId, old) {
	return {
		endedAt: old.endedAt,
		name: old.name,
		recordedBy: migrate_userId(old.recordedBy),
		size: old.size,
		startedAt: old.startedAt,
		uploaded: old.uploaded
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Message_CallRecordingFile = F2($author$project$Evergreen$Migrate$V419$migrate_Message_CallRecordingFile$);
var $author$project$Evergreen$Migrate$V419$migrate_Message_CallRecordingZip = function (old) {
	return {
		fileCount: old.fileCount,
		fileHash: $author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash(old.fileHash),
		size: old.size
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Message_CallRecording$ = function (migrate_userId, old) {
	return {
		files: $elm$core$List$map$(
			$author$project$Evergreen$Migrate$V419$migrate_Message_CallRecordingFile(migrate_userId),
			old.files),
		finishedUploading: $lamdera$containers$SeqSet$map$(migrate_userId, old.finishedUploading),
		participants: $author$project$Evergreen$Migrate$V419$migrate_NonemptySet_NonemptySet$(migrate_userId, old.participants),
		startedAt: old.startedAt,
		zip: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Message_CallRecordingZip, old.zip)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Message_CallRecording = F2($author$project$Evergreen$Migrate$V419$migrate_Message_CallRecording$);
var $author$project$Evergreen$Migrate$V419$migrate_Message_CallStartedData$ = function (migrate_userId, old) {
	return {
		cardDrawings: $author$project$Evergreen$Migrate$V419$migrate_Drawing_Drawing$(migrate_userId, old.cardDrawings),
		endedAt: old.endedAt,
		joinedBy: $lamdera$containers$SeqSet$map$(migrate_userId, old.joinedBy),
		reactions: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji,
						$author$project$Evergreen$Migrate$V419$migrate_NonemptySet_NonemptySet(migrate_userId))),
				$lamdera$containers$SeqDict$fromList),
			old.reactions),
		recordings: $elm$core$Maybe$map$(
			$author$project$Evergreen$Migrate$V419$migrate_Message_CallRecording(migrate_userId),
			old.recordings),
		startedAt: old.startedAt,
		startedBy: migrate_userId(old.startedBy),
		timestampDrawings: $author$project$Evergreen$Migrate$V419$migrate_Drawing_Drawing$(migrate_userId, old.timestampDrawings)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Message_CallStartedData = F2($author$project$Evergreen$Migrate$V419$migrate_Message_CallStartedData$);
var $author$project$Evergreen$V419$Encryption$EncryptedData = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_Encryption_EncryptedData = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$V419$Message$NoReply = {$: 0};
var $author$project$Evergreen$V419$Message$RepliedToGame$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V419$Message$RepliedToGame = F2($author$project$Evergreen$V419$Message$RepliedToGame$);
var $author$project$Evergreen$V419$Message$RepliedToMessage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Message_RepliedTo$ = function (migrate_messageId, old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$Message$NoReply;
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Message$RepliedToMessage(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		default:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Message$RepliedToGame$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Message_RepliedToGame(p1));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Message_RepliedTo = F2($author$project$Evergreen$Migrate$V419$migrate_Message_RepliedTo$);
var $author$project$Evergreen$Migrate$V419$migrate_Message_UserTextMessageDrawings$ = function (migrate_userId, old) {
	return {
		embedDrawings: $lamdera$containers$SeqDict$map$(
			function (k) {
				return $author$project$Evergreen$Migrate$V419$migrate_Drawing_Drawing(migrate_userId);
			},
			old.embedDrawings),
		imageAttachmentDrawings: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
						$author$project$Evergreen$Migrate$V419$migrate_Drawing_Drawing(migrate_userId))),
				$lamdera$containers$SeqDict$fromList),
			old.imageAttachmentDrawings),
		timestampDrawings: $author$project$Evergreen$Migrate$V419$migrate_Drawing_Drawing$(migrate_userId, old.timestampDrawings),
		userIconDrawings: $author$project$Evergreen$Migrate$V419$migrate_Drawing_Drawing$(migrate_userId, old.userIconDrawings)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Message_UserTextMessageDrawings = F2($author$project$Evergreen$Migrate$V419$migrate_Message_UserTextMessageDrawings$);
var $author$project$Evergreen$Migrate$V419$migrate_Message_EncryptedUserTextMessageData$ = function (migrate_messageId, migrate_userId, old) {
	return {
		content: $author$project$Evergreen$Migrate$V419$migrate_Encryption_EncryptedData(old.content),
		createdAt: old.createdAt,
		createdBy: migrate_userId(old.createdBy),
		drawings: $elm$core$Maybe$map$(
			$author$project$Evergreen$Migrate$V419$migrate_Message_UserTextMessageDrawings(migrate_userId),
			old.drawings),
		editedAt: old.editedAt,
		fileHashes: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash, old.fileHashes),
		reactions: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji,
						$author$project$Evergreen$Migrate$V419$migrate_NonemptySet_NonemptySet(migrate_userId))),
				$lamdera$containers$SeqDict$fromList),
			old.reactions),
		repliedTo: $author$project$Evergreen$Migrate$V419$migrate_Message_RepliedTo$(migrate_messageId, old.repliedTo)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Message_EncryptedUserTextMessageData = F3($author$project$Evergreen$Migrate$V419$migrate_Message_EncryptedUserTextMessageData$);
var $author$project$Evergreen$V419$Message$GameType_Go = 0;
var $author$project$Evergreen$V419$Message$GameType_SheepGame = 2;
var $author$project$Evergreen$V419$Message$GameType_WordSpellingGame = 1;
var $author$project$Evergreen$Migrate$V419$migrate_Message_GameType = function (old) {
	switch (old) {
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			return 2;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Message_GameStartedData$ = function (migrate_userId, old) {
	return {
		cardDrawings: $author$project$Evergreen$Migrate$V419$migrate_Drawing_Drawing$(migrate_userId, old.cardDrawings),
		gameType: $author$project$Evergreen$Migrate$V419$migrate_Message_GameType(old.gameType),
		reactions: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji,
						$author$project$Evergreen$Migrate$V419$migrate_NonemptySet_NonemptySet(migrate_userId))),
				$lamdera$containers$SeqDict$fromList),
			old.reactions),
		startedAt: old.startedAt,
		startedBy: migrate_userId(old.startedBy),
		timestampDrawings: $author$project$Evergreen$Migrate$V419$migrate_Drawing_Drawing$(migrate_userId, old.timestampDrawings)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Message_GameStartedData = F2($author$project$Evergreen$Migrate$V419$migrate_Message_GameStartedData$);
var $author$project$Evergreen$V419$Embed$EmbedLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Embed$EmbedLoading = {$: 0};
var $author$project$Evergreen$V419$Embed$Avif = 13;
var $author$project$Evergreen$V419$Embed$Bmp = 8;
var $author$project$Evergreen$V419$Embed$Dds = 7;
var $author$project$Evergreen$V419$Embed$Farbfeld = 12;
var $author$project$Evergreen$V419$Embed$Gif = 2;
var $author$project$Evergreen$V419$Embed$Hdr = 10;
var $author$project$Evergreen$V419$Embed$Ico = 9;
var $author$project$Evergreen$V419$Embed$Jpeg = 1;
var $author$project$Evergreen$V419$Embed$OpenExr = 11;
var $author$project$Evergreen$V419$Embed$Png = 0;
var $author$project$Evergreen$V419$Embed$Pnm = 4;
var $author$project$Evergreen$V419$Embed$Qoi = 14;
var $author$project$Evergreen$V419$Embed$Tga = 6;
var $author$project$Evergreen$V419$Embed$Tiff = 5;
var $author$project$Evergreen$V419$Embed$WebP = 3;
var $author$project$Evergreen$Migrate$V419$migrate_Embed_EmbedImageFormat = function (old) {
	switch (old) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		case 6:
			return 6;
		case 7:
			return 7;
		case 8:
			return 8;
		case 9:
			return 9;
		case 10:
			return 10;
		case 11:
			return 11;
		case 12:
			return 12;
		case 13:
			return 13;
		default:
			return 14;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Embed_EmbedImageData = function (old) {
	return {
		format: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Embed_EmbedImageFormat, old.format),
		imageSize: $author$project$Evergreen$Migrate$V419$migrate_Coord_Coord$($author$project$Evergreen$Migrate$V419$migrate_CssPixels_CssPixels, old.imageSize),
		url: old.url
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Embed_EmbedData = function (old) {
	return {
		createdAt: old.createdAt,
		description: old.description,
		image: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Embed_EmbedImageData, old.image),
		title: old.title
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Embed_Embed = function (old) {
	if (!old.$) {
		return $author$project$Evergreen$V419$Embed$EmbedLoading;
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Embed$EmbedLoaded(
			$author$project$Evergreen$Migrate$V419$migrate_Embed_EmbedData(p0));
	}
};
var $author$project$Evergreen$V419$RichText$AttachedFile = function (a) {
	return {$: 14, a: a};
};
var $author$project$Evergreen$V419$RichText$BlockQuote$ = function (a, b) {
	return {$: 8, a: a, b: b};
};
var $author$project$Evergreen$V419$RichText$BlockQuote = F2($author$project$Evergreen$V419$RichText$BlockQuote$);
var $author$project$Evergreen$V419$RichText$Bold = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V419$RichText$BulletPoint$ = function (a, b) {
	return {$: 18, a: a, b: b};
};
var $author$project$Evergreen$V419$RichText$BulletPoint = F2($author$project$Evergreen$V419$RichText$BulletPoint$);
var $author$project$Evergreen$V419$RichText$ChannelMention$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V419$RichText$ChannelMention = F2($author$project$Evergreen$V419$RichText$ChannelMention$);
var $author$project$Evergreen$V419$RichText$CodeBlock$ = function (a, b) {
	return {$: 13, a: a, b: b};
};
var $author$project$Evergreen$V419$RichText$CodeBlock = F2($author$project$Evergreen$V419$RichText$CodeBlock$);
var $author$project$Evergreen$V419$RichText$CustomEmoji = function (a) {
	return {$: 17, a: a};
};
var $author$project$Evergreen$V419$RichText$EscapedChar = function (a) {
	return {$: 15, a: a};
};
var $author$project$Evergreen$V419$RichText$Heading$ = function (a, b, c) {
	return {$: 9, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$RichText$Heading = F3($author$project$Evergreen$V419$RichText$Heading$);
var $author$project$Evergreen$V419$RichText$Hyperlink = function (a) {
	return {$: 10, a: a};
};
var $author$project$Evergreen$V419$RichText$InlineCode$ = function (a, b) {
	return {$: 12, a: a, b: b};
};
var $author$project$Evergreen$V419$RichText$InlineCode = F2($author$project$Evergreen$V419$RichText$InlineCode$);
var $author$project$Evergreen$V419$RichText$Italic = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V419$RichText$MarkdownLink$ = function (a, b) {
	return {$: 11, a: a, b: b};
};
var $author$project$Evergreen$V419$RichText$MarkdownLink = F2($author$project$Evergreen$V419$RichText$MarkdownLink$);
var $author$project$Evergreen$V419$RichText$NormalText$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V419$RichText$NormalText = F2($author$project$Evergreen$V419$RichText$NormalText$);
var $author$project$Evergreen$V419$RichText$Spoiler = function (a) {
	return {$: 7, a: a};
};
var $author$project$Evergreen$V419$RichText$Sticker = function (a) {
	return {$: 16, a: a};
};
var $author$project$Evergreen$V419$RichText$Strikethrough = function (a) {
	return {$: 6, a: a};
};
var $author$project$Evergreen$V419$RichText$Timestamp = function (a) {
	return {$: 19, a: a};
};
var $author$project$Evergreen$V419$RichText$Underline = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V419$RichText$UserMention = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$RichText$EscapedAtSymbol = 3;
var $author$project$Evergreen$V419$RichText$EscapedBackslash = 1;
var $author$project$Evergreen$V419$RichText$EscapedBacktick = 2;
var $author$project$Evergreen$V419$RichText$EscapedBold = 4;
var $author$project$Evergreen$V419$RichText$EscapedItalic = 5;
var $author$project$Evergreen$V419$RichText$EscapedSpoilered = 7;
var $author$project$Evergreen$V419$RichText$EscapedSquareBracket = 0;
var $author$project$Evergreen$V419$RichText$EscapedStrikethrough = 6;
var $author$project$Evergreen$Migrate$V419$migrate_RichText_EscapedChar = function (old) {
	switch (old) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		case 6:
			return 6;
		default:
			return 7;
	}
};
var $author$project$Evergreen$V419$RichText$HasLeadingLineBreak = 0;
var $author$project$Evergreen$V419$RichText$NoLeadingLineBreak = 1;
var $author$project$Evergreen$Migrate$V419$migrate_RichText_HasLeadingLineBreak = function (old) {
	if (!old) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Evergreen$V419$RichText$H1 = 0;
var $author$project$Evergreen$V419$RichText$H2 = 1;
var $author$project$Evergreen$V419$RichText$H3 = 2;
var $author$project$Evergreen$V419$RichText$Small = 3;
var $author$project$Evergreen$Migrate$V419$migrate_RichText_HeadingLevel = function (old) {
	switch (old) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $author$project$Evergreen$V419$RichText$Language = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$RichText$NoLanguage = {$: 1};
var $author$project$Evergreen$Migrate$V419$migrate_RichText_Language = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$RichText$Language(p0);
	} else {
		return $author$project$Evergreen$V419$RichText$NoLanguage;
	}
};
var $author$project$Evergreen$V419$TimeInMinutes$TimeInMinutes = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_TimeInMinutes_TimeInMinutes = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$Migrate$V419$migrate_RichText_RichText$ = function (migrate_userId, migrate_channelId, old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$RichText$UserMention(
				migrate_userId(p0));
		case 1:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$RichText$ChannelMention$(
				migrate_channelId(p0),
				$elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, p1));
		case 2:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$RichText$NormalText$(p0, p1);
		case 3:
			var p0 = old.a;
			return $author$project$Evergreen$V419$RichText$Bold(
				$author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty$(
					A2($author$project$Evergreen$Migrate$V419$migrate_RichText_RichText, migrate_userId, migrate_channelId),
					p0));
		case 4:
			var p0 = old.a;
			return $author$project$Evergreen$V419$RichText$Italic(
				$author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty$(
					A2($author$project$Evergreen$Migrate$V419$migrate_RichText_RichText, migrate_userId, migrate_channelId),
					p0));
		case 5:
			var p0 = old.a;
			return $author$project$Evergreen$V419$RichText$Underline(
				$author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty$(
					A2($author$project$Evergreen$Migrate$V419$migrate_RichText_RichText, migrate_userId, migrate_channelId),
					p0));
		case 6:
			var p0 = old.a;
			return $author$project$Evergreen$V419$RichText$Strikethrough(
				$author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty$(
					A2($author$project$Evergreen$Migrate$V419$migrate_RichText_RichText, migrate_userId, migrate_channelId),
					p0));
		case 7:
			var p0 = old.a;
			return $author$project$Evergreen$V419$RichText$Spoiler(
				$author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty$(
					A2($author$project$Evergreen$Migrate$V419$migrate_RichText_RichText, migrate_userId, migrate_channelId),
					p0));
		case 8:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$RichText$BlockQuote$(
				$author$project$Evergreen$Migrate$V419$migrate_RichText_HasLeadingLineBreak(p0),
				$elm$core$List$map$(
					A2($author$project$Evergreen$Migrate$V419$migrate_RichText_RichText, migrate_userId, migrate_channelId),
					p1));
		case 9:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$RichText$Heading$(
				$author$project$Evergreen$Migrate$V419$migrate_RichText_HeadingLevel(p0),
				$author$project$Evergreen$Migrate$V419$migrate_RichText_HasLeadingLineBreak(p1),
				$author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty$(
					A2($author$project$Evergreen$Migrate$V419$migrate_RichText_RichText, migrate_userId, migrate_channelId),
					p2));
		case 10:
			var p0 = old.a;
			return $author$project$Evergreen$V419$RichText$Hyperlink(p0);
		case 11:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$RichText$MarkdownLink$(p0, p1);
		case 12:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$RichText$InlineCode$(p0, p1);
		case 13:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$RichText$CodeBlock$(
				$author$project$Evergreen$Migrate$V419$migrate_RichText_Language(p0),
				p1);
		case 14:
			var p0 = old.a;
			return $author$project$Evergreen$V419$RichText$AttachedFile(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 15:
			var p0 = old.a;
			return $author$project$Evergreen$V419$RichText$EscapedChar(
				$author$project$Evergreen$Migrate$V419$migrate_RichText_EscapedChar(p0));
		case 16:
			var p0 = old.a;
			return $author$project$Evergreen$V419$RichText$Sticker(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 17:
			var p0 = old.a;
			return $author$project$Evergreen$V419$RichText$CustomEmoji(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 18:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$RichText$BulletPoint$(
				$author$project$Evergreen$Migrate$V419$migrate_RichText_HasLeadingLineBreak(p0),
				$author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty$(
					$elm$core$List$map(
						A2($author$project$Evergreen$Migrate$V419$migrate_RichText_RichText, migrate_userId, migrate_channelId)),
					p1));
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$RichText$Timestamp(
				$author$project$Evergreen$Migrate$V419$migrate_TimeInMinutes_TimeInMinutes(p0));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_RichText_RichText = F3($author$project$Evergreen$Migrate$V419$migrate_RichText_RichText$);
var $author$project$Evergreen$Migrate$V419$migrate_Message_MessageContent$ = function (migrate_userId, migrate_channelId, old) {
	return {
		attachedFiles: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileData)),
				$lamdera$containers$SeqDict$fromList),
			old.attachedFiles),
		content: $author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty$(
			A2($author$project$Evergreen$Migrate$V419$migrate_RichText_RichText, migrate_userId, migrate_channelId),
			old.content),
		embeds: $elm$core$Array$map$($author$project$Evergreen$Migrate$V419$migrate_Embed_Embed, old.embeds)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Message_MessageContent = F3($author$project$Evergreen$Migrate$V419$migrate_Message_MessageContent$);
var $author$project$Evergreen$Migrate$V419$migrate_Message_UserTextMessageData$ = function (migrate_messageId, migrate_userId, migrate_channelId, old) {
	return {
		content: $author$project$Evergreen$Migrate$V419$migrate_Message_MessageContent$(migrate_userId, migrate_channelId, old.content),
		createdAt: old.createdAt,
		createdBy: migrate_userId(old.createdBy),
		drawings: $elm$core$Maybe$map$(
			$author$project$Evergreen$Migrate$V419$migrate_Message_UserTextMessageDrawings(migrate_userId),
			old.drawings),
		editedAt: old.editedAt,
		reactions: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji,
						$author$project$Evergreen$Migrate$V419$migrate_NonemptySet_NonemptySet(migrate_userId))),
				$lamdera$containers$SeqDict$fromList),
			old.reactions),
		repliedTo: $author$project$Evergreen$Migrate$V419$migrate_Message_RepliedTo$(migrate_messageId, old.repliedTo)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Message_UserTextMessageData = F4($author$project$Evergreen$Migrate$V419$migrate_Message_UserTextMessageData$);
var $author$project$Evergreen$Migrate$V419$migrate_Message_Message$ = function (migrate_messageId, migrate_userId, migrate_channelId, old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Message$UserTextMessage(
				$author$project$Evergreen$Migrate$V419$migrate_Message_UserTextMessageData$(migrate_messageId, migrate_userId, migrate_channelId, p0));
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Message$EncryptedUserTextMessage(
				$author$project$Evergreen$Migrate$V419$migrate_Message_EncryptedUserTextMessageData$(migrate_messageId, migrate_userId, p0));
		case 2:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Message$UserJoinedMessage$(
				p0,
				migrate_userId(p1),
				$elm$core$Basics$composeR$(
					$lamdera$containers$SeqDict$toList,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map(
							A2(
								$elm$core$Tuple$mapBoth,
								$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji,
								$author$project$Evergreen$Migrate$V419$migrate_NonemptySet_NonemptySet(migrate_userId))),
						$lamdera$containers$SeqDict$fromList),
					p2),
				$author$project$Evergreen$Migrate$V419$migrate_Drawing_Drawing$(migrate_userId, p3));
		case 3:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Message$DeletedMessage(p0);
		case 4:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Message$CallStarted(
				$author$project$Evergreen$Migrate$V419$migrate_Message_CallStartedData$(migrate_userId, p0));
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Message$GameStarted(
				$author$project$Evergreen$Migrate$V419$migrate_Message_GameStartedData$(migrate_userId, p0));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Message_Message = F4($author$project$Evergreen$Migrate$V419$migrate_Message_Message$);
var $author$project$Evergreen$Migrate$V419$migrate_MessageArray_Run$ = function (migrate_messageId, migrate_userId, migrate_channelId, old) {
	return {
		start: old.start,
		values: $elm$core$Array$map$(
			A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, migrate_messageId, migrate_userId, migrate_channelId),
			old.values)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_MessageArray_Run = F4($author$project$Evergreen$Migrate$V419$migrate_MessageArray_Run$);
var $author$project$Evergreen$Migrate$V419$migrate_MessageArray_MessageArray$ = function (migrate_messageId, migrate_userId, migrate_channelId, old) {
	var p0 = old;
	return {
		end: p0.end,
		runs: $elm$core$Array$map$(
			A3($author$project$Evergreen$Migrate$V419$migrate_MessageArray_Run, migrate_messageId, migrate_userId, migrate_channelId),
			p0.runs),
		start: p0.start
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_MessageArray_MessageArray = F4($author$project$Evergreen$Migrate$V419$migrate_MessageArray_MessageArray$);
var $author$project$Evergreen$Migrate$V419$migrate_VisibleMessages_VisibleMessages$ = function (migrate_messageId, old) {
	return {
		count: old.count,
		loadingMessages: old.loadingMessages,
		oldest: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.oldest)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_VisibleMessages_VisibleMessages = F2($author$project$Evergreen$Migrate$V419$migrate_VisibleMessages_VisibleMessages$);
var $author$project$Evergreen$Migrate$V419$migrate_DmChannel_DiscordFrontendDmChannel = function (old) {
	return {
		dateDividerDrawings: $lamdera$containers$SeqDict$map$(
			function (k) {
				return $author$project$Evergreen$Migrate$V419$migrate_Drawing_Drawing($author$project$Evergreen$Migrate$V419$migrate_Discord_Id);
			},
			old.dateDividerDrawings),
		lastTypedAt: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Discord_Id,
						function (rec) {
							return {
								messageIndex: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, rec.messageIndex),
								time: rec.time
							};
						})),
				$lamdera$containers$SeqDict$fromList),
			old.lastTypedAt),
		members: $author$project$Evergreen$Migrate$V419$migrate_NonemptyDict_NonemptyDict$(
			$author$project$Evergreen$Migrate$V419$migrate_Discord_Id,
			function (rec) {
				return rec;
			},
			old.members),
		messages: $author$project$Evergreen$Migrate$V419$migrate_MessageArray_MessageArray$($author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, old.messages),
		visibleMessages: $author$project$Evergreen$Migrate$V419$migrate_VisibleMessages_VisibleMessages$($author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, old.visibleMessages)
	};
};
var $author$project$Evergreen$V419$DmChannel$E2eeDeclinedBy = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$DmChannel$E2eeDisabled = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$DmChannel$E2eeEnabled = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V419$DmChannel$E2eeRequestedBy = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$SessionIdHash$SessionIdHash = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_SessionIdHash_SessionIdHash = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$Migrate$V419$migrate_DmChannel_E2eeEnabledData = function (old) {
	return {
		enabledAt: old.enabledAt,
		requestedBy: $elm$core$Tuple$mapBoth$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_SessionIdHash_SessionIdHash, old.requestedBy)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_DmChannel_E2eeStatus = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$DmChannel$E2eeDisabled(
				$elm$core$Maybe$map$(
					$elm$core$Tuple$mapFirst($author$project$Evergreen$Migrate$V419$migrate_Id_Id),
					p0));
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$DmChannel$E2eeRequestedBy(
				$elm$core$Tuple$mapBoth$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_SessionIdHash_SessionIdHash, p0));
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$DmChannel$E2eeDeclinedBy(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$DmChannel$E2eeEnabled(
				$author$project$Evergreen$Migrate$V419$migrate_DmChannel_E2eeEnabledData(p0));
	}
};
var $author$project$Evergreen$V419$Game$MatchData = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Game$MatchNotLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Game$FrontendGameData_Go$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Game$FrontendGameData_Go = F3($author$project$Evergreen$V419$Game$FrontendGameData_Go$);
var $author$project$Evergreen$V419$Game$FrontendGameData_SheepGame$ = function (a, b, c) {
	return {$: 2, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Game$FrontendGameData_SheepGame = F3($author$project$Evergreen$V419$Game$FrontendGameData_SheepGame$);
var $author$project$Evergreen$V419$Game$FrontendGameData_WordSpellingGame$ = function (a, b, c) {
	return {$: 1, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Game$FrontendGameData_WordSpellingGame = F3($author$project$Evergreen$V419$Game$FrontendGameData_WordSpellingGame$);
var $author$project$Evergreen$V419$Go$AcceptTerritory = {$: 4};
var $author$project$Evergreen$V419$Go$FinishedMarking = {$: 3};
var $author$project$Evergreen$V419$Go$Joined = function (a) {
	return {$: 6, a: a};
};
var $author$project$Evergreen$V419$Go$MarkTerritory$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V419$Go$MarkTerritory = F2($author$project$Evergreen$V419$Go$MarkTerritory$);
var $author$project$Evergreen$V419$Go$PassTurn = {$: 1};
var $author$project$Evergreen$V419$Go$PlaceStone$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$Go$PlaceStone = F2($author$project$Evergreen$V419$Go$PlaceStone$);
var $author$project$Evergreen$V419$Go$RejectTerritory = {$: 5};
var $author$project$Evergreen$Migrate$V419$migrate_Go_Action = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Go$PlaceStone$(p0, p1);
		case 1:
			return $author$project$Evergreen$V419$Go$PassTurn;
		case 2:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Go$MarkTerritory$(p0, p1);
		case 3:
			return $author$project$Evergreen$V419$Go$FinishedMarking;
		case 4:
			return $author$project$Evergreen$V419$Go$AcceptTerritory;
		case 5:
			return $author$project$Evergreen$V419$Go$RejectTerritory;
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Go$Joined(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Go_ActionWithTime = function (old) {
	return {
		change: $author$project$Evergreen$Migrate$V419$migrate_Go_Action(old.change),
		time: old.time
	};
};
var $author$project$Evergreen$V419$Go$Confirming = {$: 2};
var $author$project$Evergreen$V419$Go$Marking = {$: 1};
var $author$project$Evergreen$V419$Go$Playing = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Go$Scored = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Go_Phase = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Go$Playing(p0);
		case 1:
			return $author$project$Evergreen$V419$Go$Marking;
		case 2:
			return $author$project$Evergreen$V419$Go$Confirming;
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Go$Scored(p0);
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Go_Snapshot = function (old) {
	return {
		blackCaptures: old.blackCaptures,
		board: $elm$core$Dict$map$(
			function (k) {
				return $author$project$Evergreen$Migrate$V419$migrate_Go_Stone;
			},
			old.board),
		currentPlayer: $author$project$Evergreen$Migrate$V419$migrate_Go_Stone(old.currentPlayer),
		whiteCaptures: old.whiteCaptures
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Go_Shared = function (old) {
	return {
		blackCaptures: old.blackCaptures,
		board: $elm$core$Dict$map$(
			function (k) {
				return $author$project$Evergreen$Migrate$V419$migrate_Go_Stone;
			},
			old.board),
		currentPlayer: $author$project$Evergreen$Migrate$V419$migrate_Go_Stone(old.currentPlayer),
		history: $elm$core$List$map$($author$project$Evergreen$Migrate$V419$migrate_Go_Snapshot, old.history),
		joinedUserId: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, old.joinedUserId),
		lastAction: old.lastAction,
		lastMove: old.lastMove,
		phase: $author$project$Evergreen$Migrate$V419$migrate_Go_Phase(old.phase),
		territoryMarks: $elm$core$Dict$map$(
			function (k) {
				return $author$project$Evergreen$Migrate$V419$migrate_Go_Stone;
			},
			old.territoryMarks),
		timeLeft: old.timeLeft,
		turnCount: old.turnCount,
		whiteCaptures: old.whiteCaptures
	};
};
var $author$project$Evergreen$V419$Go$BoardSize = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_Go_BoardSize = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$V419$Go$KomiHalfPoints = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_Go_KomiHalfPoints = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$Migrate$V419$migrate_Go_ValidatedSetup = function (old) {
	return {
		createdBy: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.createdBy),
		gameCreatorPlayingAs: $author$project$Evergreen$Migrate$V419$migrate_Go_Stone(old.gameCreatorPlayingAs),
		handicap: old.handicap,
		height: $author$project$Evergreen$Migrate$V419$migrate_Go_BoardSize(old.height),
		komiHalfPoints: $author$project$Evergreen$Migrate$V419$migrate_Go_KomiHalfPoints(old.komiHalfPoints),
		timeControl: old.timeControl,
		width: $author$project$Evergreen$Migrate$V419$migrate_Go_BoardSize(old.width)
	};
};
var $author$project$Evergreen$V419$SheepGame$AddedReaction$ = function (a, b) {
	return {$: 7, a: a, b: b};
};
var $author$project$Evergreen$V419$SheepGame$AddedReaction = F2($author$project$Evergreen$V419$SheepGame$AddedReaction$);
var $author$project$Evergreen$V419$SheepGame$ChangedGroup$ = function (a, b, c) {
	return {$: 3, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$SheepGame$ChangedGroup = F3($author$project$Evergreen$V419$SheepGame$ChangedGroup$);
var $author$project$Evergreen$V419$SheepGame$ChangedNotes$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $author$project$Evergreen$V419$SheepGame$ChangedNotes = F2($author$project$Evergreen$V419$SheepGame$ChangedNotes$);
var $author$project$Evergreen$V419$SheepGame$ChangedQuestionsRevealed = function (a) {
	return {$: 6, a: a};
};
var $author$project$Evergreen$V419$SheepGame$FinishedGrouping = {$: 5};
var $author$project$Evergreen$V419$SheepGame$LockedAnswers = {$: 1};
var $author$project$Evergreen$V419$SheepGame$RemovedReaction$ = function (a, b) {
	return {$: 8, a: a, b: b};
};
var $author$project$Evergreen$V419$SheepGame$RemovedReaction = F2($author$project$Evergreen$V419$SheepGame$RemovedReaction$);
var $author$project$Evergreen$V419$SheepGame$SubmittedAnswer$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$SheepGame$SubmittedAnswer = F2($author$project$Evergreen$V419$SheepGame$SubmittedAnswer$);
var $author$project$Evergreen$V419$SheepGame$UnlockedAnswers = {$: 2};
var $author$project$Evergreen$Migrate$V419$migrate_SheepGame_Reactions = function (old) {
	return $elm$core$Basics$composeR$(
		$lamdera$containers$SeqDict$toList,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map(
				A2(
					$elm$core$Tuple$mapBoth,
					$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji,
					$author$project$Evergreen$Migrate$V419$migrate_NonemptySet_NonemptySet($author$project$Evergreen$Migrate$V419$migrate_Id_Id))),
			$lamdera$containers$SeqDict$fromList),
		old);
};
var $author$project$Evergreen$Migrate$V419$migrate_SheepGame_ValidatedInput = function (old) {
	return {
		attachedFiles: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileData)),
				$lamdera$containers$SeqDict$fromList),
			old.attachedFiles),
		reactions: $author$project$Evergreen$Migrate$V419$migrate_SheepGame_Reactions(old.reactions),
		text: $author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty$(
			A2($author$project$Evergreen$Migrate$V419$migrate_RichText_RichText, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id),
			old.text)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_SheepGame_Action = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SheepGame$SubmittedAnswer$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_SheepGame_ValidatedInput, p1));
		case 1:
			return $author$project$Evergreen$V419$SheepGame$LockedAnswers;
		case 2:
			return $author$project$Evergreen$V419$SheepGame$UnlockedAnswers;
		case 3:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$SheepGame$ChangedGroup$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				p2);
		case 4:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SheepGame$ChangedNotes$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_SheepGame_ValidatedInput, p1));
		case 5:
			return $author$project$Evergreen$V419$SheepGame$FinishedGrouping;
		case 6:
			var p0 = old.a;
			return $author$project$Evergreen$V419$SheepGame$ChangedQuestionsRevealed(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 7:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SheepGame$AddedReaction$(
				$author$project$Evergreen$Migrate$V419$migrate_SheepGame_ReactionTarget(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji(p1));
		default:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SheepGame$RemovedReaction$(
				$author$project$Evergreen$Migrate$V419$migrate_SheepGame_ReactionTarget(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji(p1));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_SheepGame_ActionWithTime = function (old) {
	return {
		change: $author$project$Evergreen$Migrate$V419$migrate_SheepGame_Action(old.change),
		time: old.time,
		userId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.userId)
	};
};
var $author$project$Evergreen$V419$SheepGame$Answering = 0;
var $author$project$Evergreen$V419$SheepGame$Grouping = 1;
var $author$project$Evergreen$V419$SheepGame$Revealing = 2;
var $author$project$Evergreen$Migrate$V419$migrate_SheepGame_Phase = function (old) {
	switch (old) {
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			return 2;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_SheepGame_Shared = function (old) {
	return {
		answers: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
						$author$project$Evergreen$Migrate$V419$migrate_IdArray_IdArray(
							$elm$core$Maybe$map($author$project$Evergreen$Migrate$V419$migrate_SheepGame_ValidatedInput)))),
				$lamdera$containers$SeqDict$fromList),
			old.answers),
		groups: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					$elm$core$Tuple$mapFirst(
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id))),
				$lamdera$containers$SeqDict$fromList),
			old.groups),
		notes: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
						$elm$core$Maybe$map($author$project$Evergreen$Migrate$V419$migrate_SheepGame_ValidatedInput))),
				$lamdera$containers$SeqDict$fromList),
			old.notes),
		phase: $author$project$Evergreen$Migrate$V419$migrate_SheepGame_Phase(old.phase),
		questionsRevealed: old.questionsRevealed
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_SheepGame_ValidatedSetup = function (old) {
	return {
		createdBy: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.createdBy),
		questions: $author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty$($author$project$Evergreen$Migrate$V419$migrate_SheepGame_ValidatedInput, old.questions)
	};
};
var $author$project$Evergreen$V419$WordSpellingGame$AddedReaction$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$Evergreen$V419$WordSpellingGame$AddedReaction = F2($author$project$Evergreen$V419$WordSpellingGame$AddedReaction$);
var $author$project$Evergreen$V419$WordSpellingGame$CancelPremove = {$: 4};
var $author$project$Evergreen$V419$WordSpellingGame$JoinGame = {$: 2};
var $author$project$Evergreen$V419$WordSpellingGame$PlaceWord$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$WordSpellingGame$PlaceWord = F2($author$project$Evergreen$V419$WordSpellingGame$PlaceWord$);
var $author$project$Evergreen$V419$WordSpellingGame$Premove$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Evergreen$V419$WordSpellingGame$Premove = F2($author$project$Evergreen$V419$WordSpellingGame$Premove$);
var $author$project$Evergreen$V419$WordSpellingGame$RemovedReaction$ = function (a, b) {
	return {$: 6, a: a, b: b};
};
var $author$project$Evergreen$V419$WordSpellingGame$RemovedReaction = F2($author$project$Evergreen$V419$WordSpellingGame$RemovedReaction$);
var $author$project$Evergreen$V419$WordSpellingGame$ReplaceTrayOrPass = {$: 1};
var $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_Action = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$WordSpellingGame$PlaceWord$(
				$author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_PlacedWord(p0),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$($author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_IsValid, p1));
		case 1:
			return $author$project$Evergreen$V419$WordSpellingGame$ReplaceTrayOrPass;
		case 2:
			return $author$project$Evergreen$V419$WordSpellingGame$JoinGame;
		case 3:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$WordSpellingGame$Premove$(
				$author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_PlacedWord(p0),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$($author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_IsValid, p1));
		case 4:
			return $author$project$Evergreen$V419$WordSpellingGame$CancelPremove;
		case 5:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$WordSpellingGame$AddedReaction$(
				$author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_ReactionTarget(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji(p1));
		default:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$WordSpellingGame$RemovedReaction$(
				$author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_ReactionTarget(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji(p1));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_ActionWithTime = function (old) {
	return {
		change: $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_Action(old.change),
		time: old.time,
		userId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.userId)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Go_TimeControl = function (old) {
	return old;
};
var $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_ValidatedSetup = function (old) {
	return {
		createdBy: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.createdBy),
		fullTrayBonus: old.fullTrayBonus,
		language: $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_Language(old.language),
		letters: $author$project$Evergreen$Migrate$V419$migrate_NonemptyDict_NonemptyDict$(
			$author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_LetterOrWildcard,
			function (rec) {
				return {
					count: $author$project$Evergreen$Migrate$V419$migrate_OneOrGreater_OneOrGreater(rec.count),
					value: rec.value
				};
			},
			old.letters),
		placeWordAttempts: $author$project$Evergreen$Migrate$V419$migrate_OneOrGreater_OneOrGreater(old.placeWordAttempts),
		seed: old.seed,
		timeControls: $author$project$Evergreen$Migrate$V419$migrate_Go_TimeControl(old.timeControls),
		traySize: $author$project$Evergreen$Migrate$V419$migrate_OneOrGreater_OneOrGreater(old.traySize)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Game_FrontendGameData = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Game$FrontendGameData_Go$(
				$author$project$Evergreen$Migrate$V419$migrate_Go_ValidatedSetup(p0),
				$elm$core$Array$map$($author$project$Evergreen$Migrate$V419$migrate_Go_ActionWithTime, p1),
				$author$project$Evergreen$Migrate$V419$migrate_Go_Shared(p2));
		case 1:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Game$FrontendGameData_WordSpellingGame$(
				$author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_ValidatedSetup(p0),
				$elm$core$Array$map$($author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_ActionWithTime, p1),
				$author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_Shared(p2));
		default:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Game$FrontendGameData_SheepGame$(
				$author$project$Evergreen$Migrate$V419$migrate_SheepGame_ValidatedSetup(p0),
				$elm$core$Array$map$($author$project$Evergreen$Migrate$V419$migrate_SheepGame_ActionWithTime, p1),
				$author$project$Evergreen$Migrate$V419$migrate_SheepGame_Shared(p2));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Game_MatchData = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Game$MatchData(
			{
				data: $author$project$Evergreen$Migrate$V419$migrate_Game_FrontendGameData(p0.data),
				publicLink: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_SecretId_SecretId, p0.publicLink)
			});
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Game$MatchNotLoaded(
			$author$project$Evergreen$Migrate$V419$migrate_Message_GameType(p0));
	}
};
var $author$project$Evergreen$V419$Id$ThreadMessageId = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadMessageId = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$Migrate$V419$migrate_Thread_FrontendThread = function (old) {
	return {
		dateDividerDrawings: $lamdera$containers$SeqDict$map$(
			function (k) {
				return $author$project$Evergreen$Migrate$V419$migrate_Drawing_Drawing($author$project$Evergreen$Migrate$V419$migrate_Id_Id);
			},
			old.dateDividerDrawings),
		messages: $author$project$Evergreen$Migrate$V419$migrate_MessageArray_MessageArray$($author$project$Evergreen$Migrate$V419$migrate_Id_ThreadMessageId, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, old.messages),
		visibleMessages: $author$project$Evergreen$Migrate$V419$migrate_VisibleMessages_VisibleMessages$($author$project$Evergreen$Migrate$V419$migrate_Id_ThreadMessageId, old.visibleMessages)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_DmChannel_FrontendDmChannel = function (old) {
	return {
		dateDividerDrawings: $lamdera$containers$SeqDict$map$(
			function (k) {
				return $author$project$Evergreen$Migrate$V419$migrate_Drawing_Drawing($author$project$Evergreen$Migrate$V419$migrate_Id_Id);
			},
			old.dateDividerDrawings),
		e2ee: $author$project$Evergreen$Migrate$V419$migrate_DmChannel_E2eeStatus(old.e2ee),
		games: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Game_MatchData)),
				$lamdera$containers$SeqDict$fromList),
			old.games),
		lastTypedAt: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
						function (rec) {
							return {
								threadRoute: $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMaybeMessage(rec.threadRoute),
								time: rec.time
							};
						})),
				$lamdera$containers$SeqDict$fromList),
			old.lastTypedAt),
		messages: $author$project$Evergreen$Migrate$V419$migrate_MessageArray_MessageArray$($author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, old.messages),
		threads: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Thread_FrontendThread)),
				$lamdera$containers$SeqDict$fromList),
			old.threads),
		visibleMessages: $author$project$Evergreen$Migrate$V419$migrate_VisibleMessages_VisibleMessages$($author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, old.visibleMessages)
	};
};
var $author$project$Evergreen$V419$LocalState$IsAdmin = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$LocalState$IsAdminButDataNotLoaded = {$: 1};
var $author$project$Evergreen$V419$LocalState$IsNotAdmin = {$: 2};
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_AiChatBackendMsg = 20;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_BackendGotTime = 5;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_BackendMsgCompleted = 91;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_CaughtUpSlackMessages = 34;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_CheckedSlackAuth = 35;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_CountToFrontendStep = 54;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_DeletedDiscordDmMessage = 12;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_DeletedDiscordGuildMessage = 11;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_DeletedOrphanedFiles = 78;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_DiscordAddedReactionToDmMessage = 16;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_DiscordAddedReactionToGuildMessage = 15;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_DiscordGotDataForJoinedOrCreatedGuild = 65;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_DiscordGotDmMessageEmbed = 64;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_DiscordGotGuildIcon = 66;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_DiscordGotGuildMessageEmbed = 63;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_DiscordMessageCreate_AttachmentsUploaded = 49;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_DiscordMessageUpdate_AttachmentsUploaded = 50;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_DiscordRemovedReactionToDmMessage = 18;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_DiscordRemovedReactionToGuildMessage = 17;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_DiscordTypingIndicatorSent = 19;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_DiscordUserWebsocketMsg = 8;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_DownloadBackupChunkStep = 55;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_EditedDiscordDmMessage = 14;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_EditedDiscordGuildMessage = 13;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_ExportBackendStep = 53;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_GatewayReconnectTick = 47;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_GotChangedSlackUser = 26;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_GotDiscordDmChannelMessages = 58;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_GotDiscordGuildChannelMessages = 57;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_GotDiscordMessageCustomEmojis = 73;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_GotDiscordMessageStickers = 70;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_GotDiscordReadyDataCustomEmojis = 71;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_GotDiscordReadyDataStickers = 69;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_GotDiscordStandardStickerPacks = 75;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_GotDiscordUserAvatars = 21;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_GotDmMessageEmbed = 62;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_GotEnglishWordList = 83;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_GotGuildMessageEmbed = 61;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_GotSlackCustomEmojis = 72;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_GotSlackUser = 25;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_GotSwedishWordList = 84;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_GotTimeForBackendMsg = 90;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_GotTimeForDiscordForumPostRenamed = 60;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_GotTimeForFailedToParseDiscordWebsocket = 59;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_GotTimeForWebsocketListenClose = 81;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_GotVapidKeys = 23;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_HandleReadyDataStep2 = 44;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_HourlyDeletedOrphanedFiles = 79;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_HourlyUpdate = 74;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_JoinedDiscordThread = 67;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_LinkDiscordUserStep1 = 24;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_LinkSlackUserStep1 = 31;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_LinkSlackUserStep2 = 32;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_RecordingRequestTick = 4;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_RefreshedSlackConversations = 33;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_RegeneratedServerSecret = 77;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_ReloadDiscordUserStep1 = 43;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_ReloadedDiscordDmChannel = 52;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_ReloadedDiscordGuildChannel = 51;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_ReloadedDiscordGuildForAdmin = 80;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_Rpc_GotFileUpload = 82;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_Rpc_NotifyAdmins = 86;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_Rpc_RecordingUploadFinished = 88;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_Rpc_RecordingUploadProgress = 87;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_Rpc_RecordingZipBuilt = 89;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_Rpc_UserJoinedCall = 85;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_ScheduledExportBackendStep = 56;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_ScheduledExportUploadResult = 76;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_SentDiscordDmMessage = 10;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_SentDiscordGuildMessage = 9;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_SentLogErrorEmail = 6;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_SentLoginEmail = 0;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_SentNotification = 22;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_SentNotificationEmail = 7;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_SentSlackMessage = 37;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_SlackChangedReaction = 27;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_SlackDeletedMessage = 28;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_SlackEditedMessage = 29;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_SlackGotMessageEmbed = 36;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_SlackMessageFilesUploaded = 30;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_SlackWebsocketClosedByBackend = 39;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_SlackWebsocketCreatedHandle = 38;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_SlackWebsocketMsg = 40;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_SlackWebsocketReconnectTick = 42;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_SlackWebsocketSentData = 41;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_ToBackendCompleted = 68;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_UserConnected = 1;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_UserDisconnected = 2;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_UserDisconnectedWithTime = 3;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_WebsocketClosedByBackendForUser = 46;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_WebsocketCreatedHandleForUser = 45;
var $author$project$Evergreen$V419$BackendMsgLog$BackendMsgLog_WebsocketSentDataForUser = 48;
var $author$project$Evergreen$Migrate$V419$migrate_BackendMsgLog_BackendMsgLog = function (old) {
	switch (old) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		case 6:
			return 6;
		case 7:
			return 7;
		case 8:
			return 8;
		case 9:
			return 9;
		case 10:
			return 10;
		case 11:
			return 11;
		case 12:
			return 12;
		case 13:
			return 13;
		case 14:
			return 14;
		case 15:
			return 15;
		case 16:
			return 16;
		case 17:
			return 17;
		case 18:
			return 18;
		case 19:
			return 19;
		case 20:
			return 20;
		case 21:
			return 21;
		case 22:
			return 22;
		case 23:
			return 23;
		case 24:
			return 24;
		case 25:
			return 25;
		case 26:
			return 26;
		case 27:
			return 27;
		case 28:
			return 28;
		case 29:
			return 29;
		case 30:
			return 30;
		case 31:
			return 31;
		case 32:
			return 32;
		case 33:
			return 33;
		case 34:
			return 34;
		case 35:
			return 35;
		case 36:
			return 36;
		case 37:
			return 37;
		case 38:
			return 38;
		case 39:
			return 39;
		case 40:
			return 40;
		case 41:
			return 41;
		case 42:
			return 42;
		case 43:
			return 43;
		case 44:
			return 44;
		case 45:
			return 45;
		case 46:
			return 46;
		case 47:
			return 47;
		case 48:
			return 48;
		case 49:
			return 49;
		case 50:
			return 50;
		case 51:
			return 51;
		case 52:
			return 52;
		case 53:
			return 53;
		case 54:
			return 54;
		case 55:
			return 55;
		case 56:
			return 56;
		case 57:
			return 57;
		case 58:
			return 58;
		case 59:
			return 59;
		case 60:
			return 60;
		case 61:
			return 61;
		case 62:
			return 62;
		case 63:
			return 63;
		case 64:
			return 64;
		case 65:
			return 65;
		case 66:
			return 66;
		case 67:
			return 67;
		case 68:
			return 68;
		case 69:
			return 69;
		case 70:
			return 70;
		case 71:
			return 71;
		case 72:
			return 72;
		case 73:
			return 73;
		case 74:
			return 74;
		case 75:
			return 75;
		case 76:
			return 76;
		case 77:
			return 77;
		case 78:
			return 78;
		case 79:
			return 79;
		case 80:
			return 80;
		case 81:
			return 81;
		case 82:
			return 82;
		case 83:
			return 83;
		case 84:
			return 84;
		case 85:
			return 85;
		case 86:
			return 86;
		case 87:
			return 87;
		case 88:
			return 88;
		case 89:
			return 89;
		case 90:
			return 90;
		default:
			return 91;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_BackendMsgLog_BackendMsgLogData = function (old) {
	return {
		backendMsgLog: $author$project$Evergreen$Migrate$V419$migrate_BackendMsgLog_BackendMsgLog(old.backendMsgLog),
		endTime: old.endTime,
		startTime: old.startTime
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_FileStatus_BackendFileData = function (old) {
	return {
		fileSize: old.fileSize,
		imageSize: $elm$core$Maybe$map$(
			$author$project$Evergreen$Migrate$V419$migrate_Coord_Coord($author$project$Evergreen$Migrate$V419$migrate_CssPixels_CssPixels),
			old.imageSize)
	};
};
var $author$project$Evergreen$V419$LocalState$AdminDataLoaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$LocalState$AdminDataLoading = {$: 1};
var $author$project$Evergreen$V419$LocalState$AdminDataNotLoaded = {$: 0};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminDataStatus$ = function (migrate_a, old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$LocalState$AdminDataNotLoaded;
		case 1:
			return $author$project$Evergreen$V419$LocalState$AdminDataLoading;
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$LocalState$AdminDataLoaded(
				migrate_a(p0));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminDataStatus = F2($author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminDataStatus$);
var $author$project$Evergreen$V419$GuildName$GuildName = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_GuildName_GuildName = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminData_DeletedGuild = function (old) {
	return {
		deletedAt: old.deletedAt,
		memberCount: old.memberCount,
		name: $author$project$Evergreen$Migrate$V419$migrate_GuildName_GuildName(old.name),
		owner: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.owner)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminData_DiscordDmChannel = function (old) {
	return {
		firstMessage: $elm$core$Maybe$map$(
			A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, $author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id),
			old.firstMessage),
		members: $author$project$Evergreen$Migrate$V419$migrate_NonemptyDict_NonemptyDict$(
			$author$project$Evergreen$Migrate$V419$migrate_Discord_Id,
			function (rec) {
				return rec;
			},
			old.members),
		messageCount: old.messageCount
	};
};
var $author$project$Evergreen$V419$ChannelName$ChannelName = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_ChannelName_ChannelName = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$Migrate$V419$migrate_Discord_Permissions = function (old) {
	return old;
};
var $author$project$Evergreen$V419$Discord$RoleOrUserId_RoleId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Discord$RoleOrUserId_UserId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Discord_RoleOrUserId = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Discord$RoleOrUserId_RoleId(
			$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0));
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Discord$RoleOrUserId_UserId(
			$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Discord_Overwrite = function (old) {
	return {
		allow: $author$project$Evergreen$Migrate$V419$migrate_Discord_Permissions(old.allow),
		deny: $author$project$Evergreen$Migrate$V419$migrate_Discord_Permissions(old.deny),
		id: $author$project$Evergreen$Migrate$V419$migrate_Discord_RoleOrUserId(old.id)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminData_DiscordChannel = function (old) {
	return {
		firstMessage: $elm$core$Maybe$map$(
			A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, $author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id),
			old.firstMessage),
		messageCount: old.messageCount,
		name: $author$project$Evergreen$Migrate$V419$migrate_ChannelName_ChannelName(old.name),
		permissionOverwrites: $elm$core$List$map$($author$project$Evergreen$Migrate$V419$migrate_Discord_Overwrite, old.permissionOverwrites),
		threadCount: old.threadCount
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_DiscordRole = function (old) {
	return {
		description: old.description,
		name: old.name,
		permissions: $author$project$Evergreen$Migrate$V419$migrate_Discord_Permissions(old.permissions)
	};
};
var $author$project$Evergreen$V419$MembersAndOwner$MembersAndOwner$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$MembersAndOwner$MembersAndOwner = F2($author$project$Evergreen$V419$MembersAndOwner$MembersAndOwner$);
var $author$project$Evergreen$Migrate$V419$migrate_MembersAndOwner_MembersAndOwner$ = function (migrate_userId, migrate_a, old) {
	var p0 = old.a;
	var p1 = old.b;
	return $author$project$Evergreen$V419$MembersAndOwner$MembersAndOwner$(
		$elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, migrate_userId, migrate_a)),
				$lamdera$containers$SeqDict$fromList),
			p0),
		migrate_userId(p1));
};
var $author$project$Evergreen$Migrate$V419$migrate_MembersAndOwner_MembersAndOwner = F3($author$project$Evergreen$Migrate$V419$migrate_MembersAndOwner_MembersAndOwner$);
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminData_DiscordGuild = function (old) {
	return {
		channels: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminData_DiscordChannel)),
				$lamdera$containers$SeqDict$fromList),
			old.channels),
		membersAndOwner: $author$project$Evergreen$Migrate$V419$migrate_MembersAndOwner_MembersAndOwner$(
			$author$project$Evergreen$Migrate$V419$migrate_Discord_Id,
			function (rec) {
				return {
					joinedAt: rec.joinedAt,
					roles: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Discord_Id, rec.roles)
				};
			},
			old.membersAndOwner),
		name: $author$project$Evergreen$Migrate$V419$migrate_GuildName_GuildName(old.name),
		roles: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_DiscordRole)),
				$lamdera$containers$SeqDict$fromList),
			old.roles)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminData_DmChannel = function (old) {
	return old;
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminData_GuildChannel = function (old) {
	return {
		messageCount: old.messageCount,
		name: $author$project$Evergreen$Migrate$V419$migrate_ChannelName_ChannelName(old.name)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminData_Guild = function (old) {
	return {
		channels: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminData_GuildChannel)),
				$lamdera$containers$SeqDict$fromList),
			old.channels),
		memberCount: old.memberCount,
		name: $author$project$Evergreen$Migrate$V419$migrate_GuildName_GuildName(old.name),
		owner: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.owner)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminData_SlackDmChannel = function (old) {
	return {
		firstMessage: $elm$core$Maybe$map$(
			A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, $author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id),
			old.firstMessage),
		members: $elm$core$List$map$(
			function (rec) {
				return {
					id: $author$project$Evergreen$Migrate$V419$migrate_Slack_Id(rec.id),
					name: rec.name
				};
			},
			old.members),
		messageCount: old.messageCount,
		teamId: $author$project$Evergreen$Migrate$V419$migrate_Slack_Id(old.teamId)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminData_SlackWorkspace = function (old) {
	return {
		channels: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Slack_Id,
						function (rec) {
							return {
								firstMessage: $elm$core$Maybe$map$(
									A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, $author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id),
									rec.firstMessage),
								isPrivate: rec.isPrivate,
								linkedMembers: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Slack_Id, rec.linkedMembers),
								messageCount: rec.messageCount,
								name: $author$project$Evergreen$Migrate$V419$migrate_ChannelName_ChannelName(rec.name)
							};
						})),
				$lamdera$containers$SeqDict$fromList),
			old.channels),
		domain: old.domain,
		linkedUsers: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Slack_Id,
						function (rec) {
							return {
								linkedTo: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(rec.linkedTo),
								name: rec.name
							};
						})),
				$lamdera$containers$SeqDict$fromList),
			old.linkedUsers),
		name: old.name,
		userCount: old.userCount
	};
};
var $author$project$Evergreen$V419$LocalState$ConnectedToCall = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$LocalState$NotInCall = {$: 0};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_CallStatus = function (old) {
	if (!old.$) {
		return $author$project$Evergreen$V419$LocalState$NotInCall;
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$LocalState$ConnectedToCall(
			$author$project$Evergreen$Migrate$V419$migrate_Call_CallId(p0));
	}
};
var $author$project$Evergreen$V419$LocalState$LastRequest = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$LocalState$NoRequestsMade = {$: 0};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_LastRequest = function (old) {
	if (!old.$) {
		return $author$project$Evergreen$V419$LocalState$NoRequestsMade;
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$LocalState$LastRequest(p0);
	}
};
var $author$project$Evergreen$V419$UserSession$Viewing_Channel = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V419$UserSession$Viewing_ChannelThread = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V419$UserSession$Viewing_DiscordChannel = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V419$UserSession$Viewing_DiscordChannelThread = function (a) {
	return {$: 6, a: a};
};
var $author$project$Evergreen$V419$UserSession$Viewing_DiscordDm = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$UserSession$Viewing_Dm = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$UserSession$Viewing_DmThread = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$UserSession$Viewing_None = {$: 11};
var $author$project$Evergreen$V419$UserSession$Viewing_Overview = {$: 12};
var $author$project$Evergreen$V419$UserSession$Viewing_SlackChannel = function (a) {
	return {$: 7, a: a};
};
var $author$project$Evergreen$V419$UserSession$Viewing_SlackChannelThread = function (a) {
	return {$: 8, a: a};
};
var $author$project$Evergreen$V419$UserSession$Viewing_SlackDm = function (a) {
	return {$: 9, a: a};
};
var $author$project$Evergreen$V419$UserSession$Viewing_SlackDmThread = function (a) {
	return {$: 10, a: a};
};
var $author$project$Evergreen$V419$UserSession$DontCare = {$: 0};
var $author$project$Evergreen$V419$UserSession$PreviouslyLastViewedMessage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_UserSession_PreviouslyLastViewedMessage$ = function (migrate_messageId, old) {
	if (!old.$) {
		return $author$project$Evergreen$V419$UserSession$DontCare;
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$UserSession$PreviouslyLastViewedMessage(
			$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_UserSession_PreviouslyLastViewedMessage = F2($author$project$Evergreen$Migrate$V419$migrate_UserSession_PreviouslyLastViewedMessage$);
var $author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_ChannelData = function (old) {
	return {
		channelHeaderTab: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_UserSession_ChannelHeaderTab, old.channelHeaderTab),
		id: $author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_ChannelId(old.id),
		previouslyLastViewedMessage: $author$project$Evergreen$Migrate$V419$migrate_UserSession_PreviouslyLastViewedMessage$($author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, old.previouslyLastViewedMessage)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_ChannelThreadId = function (old) {
	return {
		channelId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.channelId),
		guildId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.guildId),
		threadId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.threadId)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_ChannelThreadData = function (old) {
	return {
		id: $author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_ChannelThreadId(old.id),
		previouslyLastViewedMessage: $author$project$Evergreen$Migrate$V419$migrate_UserSession_PreviouslyLastViewedMessage$($author$project$Evergreen$Migrate$V419$migrate_Id_ThreadMessageId, old.previouslyLastViewedMessage)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_DiscordChannelData = function (old) {
	return {
		id: $author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DiscordChannelId(old.id),
		previouslyLastViewedMessage: $author$project$Evergreen$Migrate$V419$migrate_UserSession_PreviouslyLastViewedMessage$($author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, old.previouslyLastViewedMessage)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DiscordChannelThreadId = function (old) {
	return {
		channelId: $author$project$Evergreen$Migrate$V419$migrate_Discord_Id(old.channelId),
		currentUserId: $author$project$Evergreen$Migrate$V419$migrate_Discord_Id(old.currentUserId),
		guildId: $author$project$Evergreen$Migrate$V419$migrate_Discord_Id(old.guildId),
		threadId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.threadId)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_DiscordChannelThreadData = function (old) {
	return {
		id: $author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DiscordChannelThreadId(old.id),
		previouslyLastViewedMessage: $author$project$Evergreen$Migrate$V419$migrate_UserSession_PreviouslyLastViewedMessage$($author$project$Evergreen$Migrate$V419$migrate_Id_ThreadMessageId, old.previouslyLastViewedMessage)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_DiscordDmData = function (old) {
	return {
		id: $author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DiscordDmId(old.id),
		previouslyLastViewedMessage: $author$project$Evergreen$Migrate$V419$migrate_UserSession_PreviouslyLastViewedMessage$($author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, old.previouslyLastViewedMessage)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_DmData = function (old) {
	return {
		channelHeaderTab: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_UserSession_ChannelHeaderTab, old.channelHeaderTab),
		id: $author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DmId(old.id),
		previouslyLastViewedMessage: $author$project$Evergreen$Migrate$V419$migrate_UserSession_PreviouslyLastViewedMessage$($author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, old.previouslyLastViewedMessage)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DmThreadId = function (old) {
	return {
		otherUserId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.otherUserId),
		threadId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.threadId)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_DmThreadData = function (old) {
	return {
		id: $author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DmThreadId(old.id),
		previouslyLastViewedMessage: $author$project$Evergreen$Migrate$V419$migrate_UserSession_PreviouslyLastViewedMessage$($author$project$Evergreen$Migrate$V419$migrate_Id_ThreadMessageId, old.previouslyLastViewedMessage)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_SlackChannelData = function (old) {
	return {
		id: $author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_SlackChannelId(old.id),
		previouslyLastViewedMessage: $author$project$Evergreen$Migrate$V419$migrate_UserSession_PreviouslyLastViewedMessage$($author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, old.previouslyLastViewedMessage)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_SlackChannelThreadData = function (old) {
	return {
		id: $author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_SlackChannelId(old.id),
		previouslyLastViewedMessage: $author$project$Evergreen$Migrate$V419$migrate_UserSession_PreviouslyLastViewedMessage$($author$project$Evergreen$Migrate$V419$migrate_Id_ThreadMessageId, old.previouslyLastViewedMessage),
		threadId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.threadId)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_SlackDmData = function (old) {
	return {
		id: $author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_SlackDmId(old.id),
		previouslyLastViewedMessage: $author$project$Evergreen$Migrate$V419$migrate_UserSession_PreviouslyLastViewedMessage$($author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, old.previouslyLastViewedMessage)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_SlackDmThreadData = function (old) {
	return {
		id: $author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_SlackDmId(old.id),
		previouslyLastViewedMessage: $author$project$Evergreen$Migrate$V419$migrate_UserSession_PreviouslyLastViewedMessage$($author$project$Evergreen$Migrate$V419$migrate_Id_ThreadMessageId, old.previouslyLastViewedMessage),
		threadId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.threadId)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$UserSession$Viewing_Dm(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_DmData(p0));
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$UserSession$Viewing_DmThread(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_DmThreadData(p0));
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$UserSession$Viewing_DiscordDm(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_DiscordDmData(p0));
		case 3:
			var p0 = old.a;
			return $author$project$Evergreen$V419$UserSession$Viewing_Channel(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_ChannelData(p0));
		case 4:
			var p0 = old.a;
			return $author$project$Evergreen$V419$UserSession$Viewing_ChannelThread(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_ChannelThreadData(p0));
		case 5:
			var p0 = old.a;
			return $author$project$Evergreen$V419$UserSession$Viewing_DiscordChannel(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_DiscordChannelData(p0));
		case 6:
			var p0 = old.a;
			return $author$project$Evergreen$V419$UserSession$Viewing_DiscordChannelThread(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_DiscordChannelThreadData(p0));
		case 7:
			var p0 = old.a;
			return $author$project$Evergreen$V419$UserSession$Viewing_SlackChannel(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_SlackChannelData(p0));
		case 8:
			var p0 = old.a;
			return $author$project$Evergreen$V419$UserSession$Viewing_SlackChannelThread(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_SlackChannelThreadData(p0));
		case 9:
			var p0 = old.a;
			return $author$project$Evergreen$V419$UserSession$Viewing_SlackDm(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_SlackDmData(p0));
		case 10:
			var p0 = old.a;
			return $author$project$Evergreen$V419$UserSession$Viewing_SlackDmThread(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_SlackDmThreadData(p0));
		case 11:
			return $author$project$Evergreen$V419$UserSession$Viewing_None;
		default:
			return $author$project$Evergreen$V419$UserSession$Viewing_Overview;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_ConnectionData = function (old) {
	return {
		call: $author$project$Evergreen$Migrate$V419$migrate_LocalState_CallStatus(old.call),
		currentlyViewing: $author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing(old.currentlyViewing),
		lastRequest: $author$project$Evergreen$Migrate$V419$migrate_LocalState_LastRequest(old.lastRequest),
		remoteCallData: $author$project$Evergreen$Migrate$V419$migrate_Call_RemoteCallData(old.remoteCallData)
	};
};
var $author$project$Evergreen$V419$LocalState$DeletingOrphanedFiles = {$: 1};
var $author$project$Evergreen$V419$LocalState$DeletingOrphanedFilesFailed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$LocalState$NotDeletingOrphanedFiles = {$: 0};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_DeleteOrphanedFilesStatus = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$LocalState$NotDeletingOrphanedFiles;
		case 1:
			return $author$project$Evergreen$V419$LocalState$DeletingOrphanedFiles;
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$LocalState$DeletingOrphanedFilesFailed(p0);
	}
};
var $author$project$Evergreen$V419$LocalState$BasicData_ForAdmin = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$LocalState$FullData_ForAdmin = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$LocalState$NeedsAuthAgain_ForAdmin = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$DiscordUserData$DiscordUserLoadedSuccessfully = {$: 0};
var $author$project$Evergreen$V419$DiscordUserData$DiscordUserLoadingData = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$DiscordUserData$DiscordUserLoadingFailed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_DiscordUserData_DiscordUserLoadingData = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$DiscordUserData$DiscordUserLoadedSuccessfully;
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$DiscordUserData$DiscordUserLoadingData(p0);
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$DiscordUserData$DiscordUserLoadingFailed(p0);
	}
};
var $author$project$Evergreen$V419$Discord$ImageHash = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_Discord_ImageHash = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$V419$Discord$UserDiscriminator = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_Discord_UserDiscriminator = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$Migrate$V419$migrate_Discord_PartialUser = function (old) {
	return {
		avatar: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Discord_ImageHash, old.avatar),
		discriminator: $author$project$Evergreen$Migrate$V419$migrate_Discord_UserDiscriminator(old.discriminator),
		id: $author$project$Evergreen$Migrate$V419$migrate_Discord_Id(old.id),
		username: old.username
	};
};
var $author$project$Evergreen$V419$Discord$Included = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Discord$Missing = {$: 1};
var $author$project$Evergreen$Migrate$V419$migrate_Discord_OptionalData$ = function (migrate_a, old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Discord$Included(
			migrate_a(p0));
	} else {
		return $author$project$Evergreen$V419$Discord$Missing;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Discord_OptionalData = F2($author$project$Evergreen$Migrate$V419$migrate_Discord_OptionalData$);
var $author$project$Evergreen$Migrate$V419$migrate_Discord_User = function (old) {
	return {
		avatar: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Discord_ImageHash, old.avatar),
		bot: $author$project$Evergreen$Migrate$V419$migrate_Discord_OptionalData$($elm$core$Basics$identity, old.bot),
		discriminator: $author$project$Evergreen$Migrate$V419$migrate_Discord_UserDiscriminator(old.discriminator),
		email: $author$project$Evergreen$Migrate$V419$migrate_Discord_OptionalData$($elm$core$Basics$identity, old.email),
		flags: $author$project$Evergreen$Migrate$V419$migrate_Discord_OptionalData$($elm$core$Basics$identity, old.flags),
		id: $author$project$Evergreen$Migrate$V419$migrate_Discord_Id(old.id),
		locale: $author$project$Evergreen$Migrate$V419$migrate_Discord_OptionalData$($elm$core$Basics$identity, old.locale),
		mfaEnabled: $author$project$Evergreen$Migrate$V419$migrate_Discord_OptionalData$($elm$core$Basics$identity, old.mfaEnabled),
		premiumType: $author$project$Evergreen$Migrate$V419$migrate_Discord_OptionalData$($elm$core$Basics$identity, old.premiumType),
		publicFlags: $author$project$Evergreen$Migrate$V419$migrate_Discord_OptionalData$($elm$core$Basics$identity, old.publicFlags),
		system: $author$project$Evergreen$Migrate$V419$migrate_Discord_OptionalData$($elm$core$Basics$identity, old.system),
		username: old.username,
		verified: $author$project$Evergreen$Migrate$V419$migrate_Discord_OptionalData$($elm$core$Basics$identity, old.verified)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_DiscordGatewayStatus = function (old) {
	return old;
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_DiscordUserData_ForAdmin = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$LocalState$BasicData_ForAdmin(
				{
					icon: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash, p0.icon),
					user: $author$project$Evergreen$Migrate$V419$migrate_Discord_PartialUser(p0.user)
				});
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$LocalState$FullData_ForAdmin(
				{
					gateway: $author$project$Evergreen$Migrate$V419$migrate_LocalState_DiscordGatewayStatus(p0.gateway),
					icon: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash, p0.icon),
					isLoadingData: $author$project$Evergreen$Migrate$V419$migrate_DiscordUserData_DiscordUserLoadingData(p0.isLoadingData),
					linkedAt: p0.linkedAt,
					linkedTo: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0.linkedTo),
					user: $author$project$Evergreen$Migrate$V419$migrate_Discord_User(p0.user)
				});
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$LocalState$NeedsAuthAgain_ForAdmin(
				{
					icon: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash, p0.icon),
					linkedAt: p0.linkedAt,
					linkedTo: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0.linkedTo),
					user: $author$project$Evergreen$Migrate$V419$migrate_Discord_User(p0.user)
				});
	}
};
var $author$project$Evergreen$V419$LocalState$FullBackup = 0;
var $author$project$Evergreen$V419$LocalState$SubsetBackup = 1;
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_BackupContents = function (old) {
	if (!old) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_LastBackup = function (old) {
	return {
		contents: $author$project$Evergreen$Migrate$V419$migrate_LocalState_BackupContents(old.contents),
		createdAt: old.createdAt
	};
};
var $author$project$Evergreen$V419$LocalState$LoadingDiscordDmChannel$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$LocalState$LoadingDiscordDmChannel = F3($author$project$Evergreen$V419$LocalState$LoadingDiscordDmChannel$);
var $author$project$Evergreen$V419$LocalState$LoadingDiscordGuildChannel$ = function (a, b, c, d) {
	return {$: 1, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$LocalState$LoadingDiscordGuildChannel = F4($author$project$Evergreen$V419$LocalState$LoadingDiscordGuildChannel$);
var $author$project$Evergreen$V419$LocalState$LoadingDiscordChannelAttachments$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V419$LocalState$LoadingDiscordChannelAttachments = F2($author$project$Evergreen$V419$LocalState$LoadingDiscordChannelAttachments$);
var $author$project$Evergreen$V419$LocalState$LoadingDiscordChannelMessages = {$: 0};
var $author$project$Evergreen$V419$LocalState$LoadingDiscordChannelMessagesFailed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Discord$BadRequest400 = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Discord$Forbidden403 = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V419$Discord$GatewayUnavailable502 = function (a) {
	return {$: 6, a: a};
};
var $author$project$Evergreen$V419$Discord$NetworkError = {$: 8};
var $author$project$Evergreen$V419$Discord$NotFound404 = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V419$Discord$NotModified304 = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Discord$ServerError5xx = function (a) {
	return {$: 7, a: a};
};
var $author$project$Evergreen$V419$Discord$Timeout = {$: 9};
var $author$project$Evergreen$V419$Discord$TooManyRequests429 = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V419$Discord$Unauthorized401 = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$Discord$UnexpectedError = function (a) {
	return {$: 10, a: a};
};
var $author$project$Evergreen$V419$Discord$ApiIsCurrentlyOverloaded130000 = 65;
var $author$project$Evergreen$V419$Discord$BotsCannotUseThisEndpoint20001 = 24;
var $author$project$Evergreen$V419$Discord$CannotEditAMessageAuthoredByAnotherUser50005 = 44;
var $author$project$Evergreen$V419$Discord$CannotExecuteActionOnADmChannel50003 = 42;
var $author$project$Evergreen$V419$Discord$CannotExecuteActionOnASystemMessage50021 = 58;
var $author$project$Evergreen$V419$Discord$CannotSendAnEmptyMessage50006 = 45;
var $author$project$Evergreen$V419$Discord$CannotSendMessagesInAVoiceChannel50008 = 47;
var $author$project$Evergreen$V419$Discord$CannotSendMessagesToThisUser50007 = 46;
var $author$project$Evergreen$V419$Discord$ChannelVerificationLevelTooHigh50009 = 48;
var $author$project$Evergreen$V419$Discord$FeatureTemporarilyDisabledServerSide40006 = 38;
var $author$project$Evergreen$V419$Discord$GeneralError0 = 0;
var $author$project$Evergreen$V419$Discord$GuildWidgetDisabled50004 = 43;
var $author$project$Evergreen$V419$Discord$InvalidAccountType50002 = 41;
var $author$project$Evergreen$V419$Discord$InvalidApiVersionProvided50041 = 63;
var $author$project$Evergreen$V419$Discord$InvalidAuthenticationTokenProvided50014 = 53;
var $author$project$Evergreen$V419$Discord$InvalidFormBody50035 = 61;
var $author$project$Evergreen$V419$Discord$InvalidOAuth2AccessTokenProvided50025 = 59;
var $author$project$Evergreen$V419$Discord$InvalidOAuth2State50012 = 51;
var $author$project$Evergreen$V419$Discord$InviteCodeWasEitherInvalidOrTaken50020 = 57;
var $author$project$Evergreen$V419$Discord$InviteWasAcceptedToAGuildTheAppsBotIsNotIn50036 = 62;
var $author$project$Evergreen$V419$Discord$MaxNumberOfAttachmentsInAMessage30015 = 33;
var $author$project$Evergreen$V419$Discord$MaxNumberOfFriends30002 = 27;
var $author$project$Evergreen$V419$Discord$MaxNumberOfGuildChannels30013 = 32;
var $author$project$Evergreen$V419$Discord$MaxNumberOfGuilds30001 = 26;
var $author$project$Evergreen$V419$Discord$MaxNumberOfGuildsRoles30005 = 29;
var $author$project$Evergreen$V419$Discord$MaxNumberOfInvitesReached30016 = 34;
var $author$project$Evergreen$V419$Discord$MaxNumberOfPinsForChannel30003 = 28;
var $author$project$Evergreen$V419$Discord$MaxNumberOfReactions30010 = 31;
var $author$project$Evergreen$V419$Discord$MaxNumberOfWebhooks30007 = 30;
var $author$project$Evergreen$V419$Discord$MessageCanOnlyBePinnedToChannelItIsIn50019 = 56;
var $author$project$Evergreen$V419$Discord$MessageProvidedWasTooOldToBulkDelete50034 = 60;
var $author$project$Evergreen$V419$Discord$MissingAccess50001 = 40;
var $author$project$Evergreen$V419$Discord$NoteWasTooLong50015 = 54;
var $author$project$Evergreen$V419$Discord$OAuth2AppDoesNotHaveABot50010 = 49;
var $author$project$Evergreen$V419$Discord$OAuth2AppLimitReached50011 = 50;
var $author$project$Evergreen$V419$Discord$OnlyBotsCanUseThisEndpoint20002 = 25;
var $author$project$Evergreen$V419$Discord$ProvidedTooFewOrTooManyMessagesToDelete50016 = 55;
var $author$project$Evergreen$V419$Discord$ReactionWasBlocked90001 = 64;
var $author$project$Evergreen$V419$Discord$RequestEntityTooLarge40005 = 37;
var $author$project$Evergreen$V419$Discord$UnauthorizedProvideAValidTokenAndTryAgain40001 = 35;
var $author$project$Evergreen$V419$Discord$UnknownAccount10001 = 1;
var $author$project$Evergreen$V419$Discord$UnknownApp10002 = 2;
var $author$project$Evergreen$V419$Discord$UnknownBan10026 = 16;
var $author$project$Evergreen$V419$Discord$UnknownBranch10032 = 22;
var $author$project$Evergreen$V419$Discord$UnknownBuild10030 = 20;
var $author$project$Evergreen$V419$Discord$UnknownChannel10003 = 3;
var $author$project$Evergreen$V419$Discord$UnknownEmoji10014 = 14;
var $author$project$Evergreen$V419$Discord$UnknownEntitlement10029 = 19;
var $author$project$Evergreen$V419$Discord$UnknownGuild10004 = 4;
var $author$project$Evergreen$V419$Discord$UnknownIntegration1005 = 5;
var $author$project$Evergreen$V419$Discord$UnknownInvite10006 = 6;
var $author$project$Evergreen$V419$Discord$UnknownLobby10031 = 21;
var $author$project$Evergreen$V419$Discord$UnknownMember10007 = 7;
var $author$project$Evergreen$V419$Discord$UnknownMessage10008 = 8;
var $author$project$Evergreen$V419$Discord$UnknownPermissionOverwrite10009 = 9;
var $author$project$Evergreen$V419$Discord$UnknownProvider10010 = 10;
var $author$project$Evergreen$V419$Discord$UnknownRedistributable10036 = 23;
var $author$project$Evergreen$V419$Discord$UnknownRole10011 = 11;
var $author$project$Evergreen$V419$Discord$UnknownSku10027 = 17;
var $author$project$Evergreen$V419$Discord$UnknownStoreListing10028 = 18;
var $author$project$Evergreen$V419$Discord$UnknownToken10012 = 12;
var $author$project$Evergreen$V419$Discord$UnknownUser10013 = 13;
var $author$project$Evergreen$V419$Discord$UnknownWebhook10015 = 15;
var $author$project$Evergreen$V419$Discord$UserIsBannedFromThisGuild40007 = 39;
var $author$project$Evergreen$V419$Discord$VerifyYourAccount40002 = 36;
var $author$project$Evergreen$V419$Discord$YouLackPermissionsToPerformThatAction50013 = 52;
var $author$project$Evergreen$Migrate$V419$migrate_Discord_ErrorCode = function (old) {
	switch (old) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		case 6:
			return 6;
		case 7:
			return 7;
		case 8:
			return 8;
		case 9:
			return 9;
		case 10:
			return 10;
		case 11:
			return 11;
		case 12:
			return 12;
		case 13:
			return 13;
		case 14:
			return 14;
		case 15:
			return 15;
		case 16:
			return 16;
		case 17:
			return 17;
		case 18:
			return 18;
		case 19:
			return 19;
		case 20:
			return 20;
		case 21:
			return 21;
		case 22:
			return 22;
		case 23:
			return 23;
		case 24:
			return 24;
		case 25:
			return 25;
		case 26:
			return 26;
		case 27:
			return 27;
		case 28:
			return 28;
		case 29:
			return 29;
		case 30:
			return 30;
		case 31:
			return 31;
		case 32:
			return 32;
		case 33:
			return 33;
		case 34:
			return 34;
		case 35:
			return 35;
		case 36:
			return 36;
		case 37:
			return 37;
		case 38:
			return 38;
		case 39:
			return 39;
		case 40:
			return 40;
		case 41:
			return 41;
		case 42:
			return 42;
		case 43:
			return 43;
		case 44:
			return 44;
		case 45:
			return 45;
		case 46:
			return 46;
		case 47:
			return 47;
		case 48:
			return 48;
		case 49:
			return 49;
		case 50:
			return 50;
		case 51:
			return 51;
		case 52:
			return 52;
		case 53:
			return 53;
		case 54:
			return 54;
		case 55:
			return 55;
		case 56:
			return 56;
		case 57:
			return 57;
		case 58:
			return 58;
		case 59:
			return 59;
		case 60:
			return 60;
		case 61:
			return 61;
		case 62:
			return 62;
		case 63:
			return 63;
		case 64:
			return 64;
		default:
			return 65;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Discord_RateLimit = function (old) {
	return old;
};
var $author$project$Evergreen$Migrate$V419$migrate_Discord_HttpError = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Discord$NotModified304(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_ErrorCode(p0));
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Discord$BadRequest400(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_ErrorCode(p0));
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Discord$Unauthorized401(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_ErrorCode(p0));
		case 3:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Discord$Forbidden403(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_ErrorCode(p0));
		case 4:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Discord$NotFound404(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_ErrorCode(p0));
		case 5:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Discord$TooManyRequests429(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_RateLimit(p0));
		case 6:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Discord$GatewayUnavailable502(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_ErrorCode(p0));
		case 7:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Discord$ServerError5xx(
				{
					errorCode: $author$project$Evergreen$Migrate$V419$migrate_Discord_ErrorCode(p0.errorCode),
					statusCode: p0.statusCode
				});
		case 8:
			return $author$project$Evergreen$V419$Discord$NetworkError;
		case 9:
			return $author$project$Evergreen$V419$Discord$Timeout;
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Discord$UnexpectedError(p0);
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_LoadingDiscordChannelStep$ = function (migrate_messages, old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$LocalState$LoadingDiscordChannelMessages;
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$LocalState$LoadingDiscordChannelMessagesFailed(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_HttpError(p0));
		default:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$LocalState$LoadingDiscordChannelAttachments$(
				p0,
				migrate_messages(p1));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_LoadingDiscordChannelStep = F2($author$project$Evergreen$Migrate$V419$migrate_LocalState_LoadingDiscordChannelStep$);
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_LoadingDiscordChannel$ = function (migrate_messages, old) {
	if (!old.$) {
		var p0 = old.a;
		var p1 = old.b;
		var p2 = old.c;
		return $author$project$Evergreen$V419$LocalState$LoadingDiscordDmChannel$(
			p0,
			$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
			$author$project$Evergreen$Migrate$V419$migrate_LocalState_LoadingDiscordChannelStep$(migrate_messages, p2));
	} else {
		var p0 = old.a;
		var p1 = old.b;
		var p2 = old.c;
		var p3 = old.d;
		return $author$project$Evergreen$V419$LocalState$LoadingDiscordGuildChannel$(
			p0,
			$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
			$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p2),
			$author$project$Evergreen$Migrate$V419$migrate_LocalState_LoadingDiscordChannelStep$(migrate_messages, p3));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_LoadingDiscordChannel = F2($author$project$Evergreen$Migrate$V419$migrate_LocalState_LoadingDiscordChannel$);
var $author$project$Evergreen$V419$Log$ChangedUsers = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V419$Log$DeletedLog = {$: 36};
var $author$project$Evergreen$V419$Log$EmptyDiscordMessage = function (a) {
	return {$: 22, a: a};
};
var $author$project$Evergreen$V419$Log$FailedToAddReactionToDiscordDmMessage$ = function (a, b, c, d, e) {
	return {$: 11, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V419$Log$FailedToAddReactionToDiscordDmMessage = F5($author$project$Evergreen$V419$Log$FailedToAddReactionToDiscordDmMessage$);
var $author$project$Evergreen$V419$Log$FailedToAddReactionToDiscordGuildMessage$ = function (a, b, c, d, e, f) {
	return {$: 10, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Evergreen$V419$Log$FailedToAddReactionToDiscordGuildMessage = F6($author$project$Evergreen$V419$Log$FailedToAddReactionToDiscordGuildMessage$);
var $author$project$Evergreen$V419$Log$FailedToChangeSlackReaction$ = function (a, b) {
	return {$: 32, a: a, b: b};
};
var $author$project$Evergreen$V419$Log$FailedToChangeSlackReaction = F2($author$project$Evergreen$V419$Log$FailedToChangeSlackReaction$);
var $author$project$Evergreen$V419$Log$FailedToDeleteDiscordDmMessage$ = function (a, b, c, d) {
	return {$: 7, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Log$FailedToDeleteDiscordDmMessage = F4($author$project$Evergreen$V419$Log$FailedToDeleteDiscordDmMessage$);
var $author$project$Evergreen$V419$Log$FailedToDeleteDiscordGuildMessage$ = function (a, b, c, d, e) {
	return {$: 6, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V419$Log$FailedToDeleteDiscordGuildMessage = F5($author$project$Evergreen$V419$Log$FailedToDeleteDiscordGuildMessage$);
var $author$project$Evergreen$V419$Log$FailedToDeleteOrphanedFiles = function (a) {
	return {$: 28, a: a};
};
var $author$project$Evergreen$V419$Log$FailedToDeleteSlackMessage$ = function (a, b) {
	return {$: 33, a: a, b: b};
};
var $author$project$Evergreen$V419$Log$FailedToDeleteSlackMessage = F2($author$project$Evergreen$V419$Log$FailedToDeleteSlackMessage$);
var $author$project$Evergreen$V419$Log$FailedToEditDiscordDmMessage$ = function (a, b, c, d) {
	return {$: 9, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Log$FailedToEditDiscordDmMessage = F4($author$project$Evergreen$V419$Log$FailedToEditDiscordDmMessage$);
var $author$project$Evergreen$V419$Log$FailedToEditDiscordGuildMessage$ = function (a, b, c, d, e) {
	return {$: 8, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V419$Log$FailedToEditDiscordGuildMessage = F5($author$project$Evergreen$V419$Log$FailedToEditDiscordGuildMessage$);
var $author$project$Evergreen$V419$Log$FailedToEditSlackMessage$ = function (a, b) {
	return {$: 34, a: a, b: b};
};
var $author$project$Evergreen$V419$Log$FailedToEditSlackMessage = F2($author$project$Evergreen$V419$Log$FailedToEditSlackMessage$);
var $author$project$Evergreen$V419$Log$FailedToGenerateScheduledBackup$ = function (a, b) {
	return {$: 26, a: a, b: b};
};
var $author$project$Evergreen$V419$Log$FailedToGenerateScheduledBackup = F2($author$project$Evergreen$V419$Log$FailedToGenerateScheduledBackup$);
var $author$project$Evergreen$V419$Log$FailedToGetDataForJoinedOrCreatedDiscordGuild$ = function (a, b, c) {
	return {$: 19, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Log$FailedToGetDataForJoinedOrCreatedDiscordGuild = F3($author$project$Evergreen$V419$Log$FailedToGetDataForJoinedOrCreatedDiscordGuild$);
var $author$project$Evergreen$V419$Log$FailedToGetDiscordUserAvatars = function (a) {
	return {$: 17, a: a};
};
var $author$project$Evergreen$V419$Log$FailedToLoadDiscordGuildCustomEmojis$ = function (a, b) {
	return {$: 25, a: a, b: b};
};
var $author$project$Evergreen$V419$Log$FailedToLoadDiscordGuildCustomEmojis = F2($author$project$Evergreen$V419$Log$FailedToLoadDiscordGuildCustomEmojis$);
var $author$project$Evergreen$V419$Log$FailedToLoadDiscordGuildStickers$ = function (a, b) {
	return {$: 23, a: a, b: b};
};
var $author$project$Evergreen$V419$Log$FailedToLoadDiscordGuildStickers = F2($author$project$Evergreen$V419$Log$FailedToLoadDiscordGuildStickers$);
var $author$project$Evergreen$V419$Log$FailedToLoadDiscordStandardStickerPacks = function (a) {
	return {$: 24, a: a};
};
var $author$project$Evergreen$V419$Log$FailedToLoadDiscordUserData$ = function (a, b) {
	return {$: 14, a: a, b: b};
};
var $author$project$Evergreen$V419$Log$FailedToLoadDiscordUserData = F2($author$project$Evergreen$V419$Log$FailedToLoadDiscordUserData$);
var $author$project$Evergreen$V419$Log$FailedToLoadSlackConversations$ = function (a, b) {
	return {$: 29, a: a, b: b};
};
var $author$project$Evergreen$V419$Log$FailedToLoadSlackConversations = F2($author$project$Evergreen$V419$Log$FailedToLoadSlackConversations$);
var $author$project$Evergreen$V419$Log$FailedToLoadSlackCustomEmojis$ = function (a, b, c) {
	return {$: 30, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Log$FailedToLoadSlackCustomEmojis = F3($author$project$Evergreen$V419$Log$FailedToLoadSlackCustomEmojis$);
var $author$project$Evergreen$V419$Log$FailedToParseDiscordWebsocket$ = function (a, b) {
	return {$: 18, a: a, b: b};
};
var $author$project$Evergreen$V419$Log$FailedToParseDiscordWebsocket = F2($author$project$Evergreen$V419$Log$FailedToParseDiscordWebsocket$);
var $author$project$Evergreen$V419$Log$FailedToRegenerateServerSecret = function (a) {
	return {$: 27, a: a};
};
var $author$project$Evergreen$V419$Log$FailedToReloadDiscordGuild$ = function (a, b) {
	return {$: 20, a: a, b: b};
};
var $author$project$Evergreen$V419$Log$FailedToReloadDiscordGuild = F2($author$project$Evergreen$V419$Log$FailedToReloadDiscordGuild$);
var $author$project$Evergreen$V419$Log$FailedToRemoveReactionToDiscordDmMessage$ = function (a, b, c, d, e) {
	return {$: 13, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V419$Log$FailedToRemoveReactionToDiscordDmMessage = F5($author$project$Evergreen$V419$Log$FailedToRemoveReactionToDiscordDmMessage$);
var $author$project$Evergreen$V419$Log$FailedToRemoveReactionToDiscordGuildMessage$ = function (a, b, c, d, e, f) {
	return {$: 12, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Evergreen$V419$Log$FailedToRemoveReactionToDiscordGuildMessage = F6($author$project$Evergreen$V419$Log$FailedToRemoveReactionToDiscordGuildMessage$);
var $author$project$Evergreen$V419$Log$FailedToSendDiscordDmMessage$ = function (a, b, c) {
	return {$: 16, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Log$FailedToSendDiscordDmMessage = F3($author$project$Evergreen$V419$Log$FailedToSendDiscordDmMessage$);
var $author$project$Evergreen$V419$Log$FailedToSendDiscordGuildMessage$ = function (a, b, c, d, e) {
	return {$: 15, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V419$Log$FailedToSendDiscordGuildMessage = F5($author$project$Evergreen$V419$Log$FailedToSendDiscordGuildMessage$);
var $author$project$Evergreen$V419$Log$FailedToSendNotificationEmail$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V419$Log$FailedToSendNotificationEmail = F2($author$project$Evergreen$V419$Log$FailedToSendNotificationEmail$);
var $author$project$Evergreen$V419$Log$FailedToSendSlackMessage$ = function (a, b) {
	return {$: 31, a: a, b: b};
};
var $author$project$Evergreen$V419$Log$FailedToSendSlackMessage = F2($author$project$Evergreen$V419$Log$FailedToSendSlackMessage$);
var $author$project$Evergreen$V419$Log$JoinedDiscordThreadFailed$ = function (a, b) {
	return {$: 21, a: a, b: b};
};
var $author$project$Evergreen$V419$Log$JoinedDiscordThreadFailed = F2($author$project$Evergreen$V419$Log$JoinedDiscordThreadFailed$);
var $author$project$Evergreen$V419$Log$LoginEmail$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$Log$LoginEmail = F2($author$project$Evergreen$V419$Log$LoginEmail$);
var $author$project$Evergreen$V419$Log$LoginsRateLimited = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$Log$PushNotificationError$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$Evergreen$V419$Log$PushNotificationError = F2($author$project$Evergreen$V419$Log$PushNotificationError$);
var $author$project$Evergreen$V419$Log$ReceivedTypeThatIsAlwaysInvalid = {$: 35};
var $author$project$Evergreen$V419$Log$SendLogErrorEmailFailed$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $author$project$Evergreen$V419$Log$SendLogErrorEmailFailed = F2($author$project$Evergreen$V419$Log$SendLogErrorEmailFailed$);
var $author$project$Evergreen$V419$Postmark$BadUrl = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V419$Postmark$NetworkError = {$: 2};
var $author$project$Evergreen$V419$Postmark$PostmarkError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Postmark$Timeout = {$: 3};
var $author$project$Evergreen$V419$Postmark$UnknownError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Postmark_PostmarkSendResponse = function (old) {
	return {
		errorCode: old.errorCode,
		message: old.message,
		to: $elm$core$List$map$($author$project$Evergreen$Migrate$V419$migrate_EmailAddress_EmailAddress, old.to)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Postmark_SendEmailError = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Postmark$UnknownError(p0);
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Postmark$PostmarkError(
				$author$project$Evergreen$Migrate$V419$migrate_Postmark_PostmarkSendResponse(p0));
		case 2:
			return $author$project$Evergreen$V419$Postmark$NetworkError;
		case 3:
			return $author$project$Evergreen$V419$Postmark$Timeout;
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Postmark$BadUrl(p0);
	}
};
var $author$project$Evergreen$V419$Slack$BadBody = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V419$Slack$BadStatus$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V419$Slack$BadStatus = F2($author$project$Evergreen$V419$Slack$BadStatus$);
var $author$project$Evergreen$V419$Slack$BadUrl = function (a) {
	return {$: 6, a: a};
};
var $author$project$Evergreen$V419$Slack$NetworkError = {$: 5};
var $author$project$Evergreen$V419$Slack$RateLimited = {$: 1};
var $author$project$Evergreen$V419$Slack$SlackError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Slack$Timeout = {$: 4};
var $author$project$Evergreen$Migrate$V419$migrate_Slack_HttpError = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Slack$SlackError(p0);
		case 1:
			return $author$project$Evergreen$V419$Slack$RateLimited;
		case 2:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Slack$BadStatus$(p0, p1);
		case 3:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Slack$BadBody(p0);
		case 4:
			return $author$project$Evergreen$V419$Slack$Timeout;
		case 5:
			return $author$project$Evergreen$V419$Slack$NetworkError;
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Slack$BadUrl(p0);
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Log_Log = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Log$LoginEmail$(
				$elm$core$Result$mapError$($author$project$Evergreen$Migrate$V419$migrate_Postmark_SendEmailError, p0),
				$author$project$Evergreen$Migrate$V419$migrate_EmailAddress_EmailAddress(p1));
		case 1:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Log$FailedToSendNotificationEmail$(
				$author$project$Evergreen$Migrate$V419$migrate_Postmark_SendEmailError(p0),
				$author$project$Evergreen$Migrate$V419$migrate_EmailAddress_EmailAddress(p1));
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Log$LoginsRateLimited(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 3:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Log$ChangedUsers(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 4:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Log$SendLogErrorEmailFailed$(
				$author$project$Evergreen$Migrate$V419$migrate_Postmark_SendEmailError(p0),
				$author$project$Evergreen$Migrate$V419$migrate_EmailAddress_EmailAddress(p1));
		case 5:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Log$PushNotificationError$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				p1);
		case 6:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			return $author$project$Evergreen$V419$Log$FailedToDeleteDiscordGuildMessage$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p3),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_HttpError(p4));
		case 7:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Log$FailedToDeleteDiscordDmMessage$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_HttpError(p3));
		case 8:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			return $author$project$Evergreen$V419$Log$FailedToEditDiscordGuildMessage$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p3),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_HttpError(p4));
		case 9:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Log$FailedToEditDiscordDmMessage$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_HttpError(p3));
		case 10:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			var p5 = old.f;
			return $author$project$Evergreen$V419$Log$FailedToAddReactionToDiscordGuildMessage$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p3),
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji(p4),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_HttpError(p5));
		case 11:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			return $author$project$Evergreen$V419$Log$FailedToAddReactionToDiscordDmMessage$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji(p3),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_HttpError(p4));
		case 12:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			var p5 = old.f;
			return $author$project$Evergreen$V419$Log$FailedToRemoveReactionToDiscordGuildMessage$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p3),
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji(p4),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_HttpError(p5));
		case 13:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			return $author$project$Evergreen$V419$Log$FailedToRemoveReactionToDiscordDmMessage$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji(p3),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_HttpError(p4));
		case 14:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Log$FailedToLoadDiscordUserData$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_HttpError(p1));
		case 15:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			return $author$project$Evergreen$V419$Log$FailedToSendDiscordGuildMessage$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMaybeMessage(p3),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_HttpError(p4));
		case 16:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Log$FailedToSendDiscordDmMessage$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_HttpError(p2));
		case 17:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Log$FailedToGetDiscordUserAvatars(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_HttpError(p0));
		case 18:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Log$FailedToParseDiscordWebsocket$(p0, p1);
		case 19:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Log$FailedToGetDataForJoinedOrCreatedDiscordGuild$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_HttpError(p2));
		case 20:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Log$FailedToReloadDiscordGuild$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_HttpError(p1));
		case 21:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Log$JoinedDiscordThreadFailed$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_HttpError(p1));
		case 22:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Log$EmptyDiscordMessage(p0);
		case 23:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Log$FailedToLoadDiscordGuildStickers$(
				$author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty$(
					$elm$core$Tuple$mapFirst($author$project$Evergreen$Migrate$V419$migrate_Id_Id),
					p0),
				p1);
		case 24:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Log$FailedToLoadDiscordStandardStickerPacks(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_HttpError(p0));
		case 25:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Log$FailedToLoadDiscordGuildCustomEmojis$(
				$author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty$(
					$elm$core$Tuple$mapFirst($author$project$Evergreen$Migrate$V419$migrate_Id_Id),
					p0),
				p1);
		case 26:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Log$FailedToGenerateScheduledBackup$(p0, p1);
		case 27:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Log$FailedToRegenerateServerSecret(p0);
		case 28:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Log$FailedToDeleteOrphanedFiles(p0);
		case 29:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Log$FailedToLoadSlackConversations$(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Slack_HttpError(p1));
		case 30:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Log$FailedToLoadSlackCustomEmojis$(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty$(
					$elm$core$Tuple$mapFirst($author$project$Evergreen$Migrate$V419$migrate_Id_Id),
					p1),
				p2);
		case 31:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Log$FailedToSendSlackMessage$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_SlackGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Slack_HttpError(p1));
		case 32:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Log$FailedToChangeSlackReaction$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_SlackGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Slack_HttpError(p1));
		case 33:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Log$FailedToDeleteSlackMessage$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_SlackGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Slack_HttpError(p1));
		case 34:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Log$FailedToEditSlackMessage$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_SlackGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Slack_HttpError(p1));
		case 35:
			return $author$project$Evergreen$V419$Log$ReceivedTypeThatIsAlwaysInvalid;
		default:
			return $author$project$Evergreen$V419$Log$DeletedLog;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_LogWithTime = function (old) {
	return {
		log: $author$project$Evergreen$Migrate$V419$migrate_Log_Log(old.log),
		time: old.time
	};
};
var $author$project$Evergreen$V419$LocalState$PrivateVapidKey = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_PrivateVapidKey = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$V419$LocalState$BeingRegenerated = {$: 1};
var $author$project$Evergreen$V419$LocalState$NotBeingRegenerated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$LocalState$RegenerationFailed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_ServerSecretStatus = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$LocalState$NotBeingRegenerated(p0);
		case 1:
			return $author$project$Evergreen$V419$LocalState$BeingRegenerated;
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$LocalState$RegenerationFailed(p0);
	}
};
var $author$project$Evergreen$V419$LocalState$WebsocketClosed_CloseAndReopenForUser$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$LocalState$WebsocketClosed_CloseAndReopenForUser = F2($author$project$Evergreen$V419$LocalState$WebsocketClosed_CloseAndReopenForUser$);
var $author$project$Evergreen$V419$LocalState$WebsocketClosed_ClosedByBackendForUser$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V419$LocalState$WebsocketClosed_ClosedByBackendForUser = F2($author$project$Evergreen$V419$LocalState$WebsocketClosed_ClosedByBackendForUser$);
var $author$project$Evergreen$V419$LocalState$WebsocketClosed_ListenCloseEvent$ = function (a, b, c, d) {
	return {$: 3, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$LocalState$WebsocketClosed_ListenCloseEvent = F4($author$project$Evergreen$V419$LocalState$WebsocketClosed_ListenCloseEvent$);
var $author$project$Evergreen$V419$LocalState$WebsocketClosed_UnlinkDiscordUser$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V419$LocalState$WebsocketClosed_UnlinkDiscordUser = F2($author$project$Evergreen$V419$LocalState$WebsocketClosed_UnlinkDiscordUser$);
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_WebsocketClosedEvent = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$LocalState$WebsocketClosed_CloseAndReopenForUser$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				p1);
		case 1:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$LocalState$WebsocketClosed_UnlinkDiscordUser$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				p1);
		case 2:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$LocalState$WebsocketClosed_ClosedByBackendForUser$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				p1);
		default:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$LocalState$WebsocketClosed_ListenCloseEvent$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				p1,
				p2,
				p3);
	}
};
var $author$project$Evergreen$V419$LocalState$WordSpellingGameStatus_Error = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$LocalState$WordSpellingGameStatus_Loaded = {$: 3};
var $author$project$Evergreen$V419$LocalState$WordSpellingGameStatus_Loading = {$: 1};
var $author$project$Evergreen$V419$LocalState$WordSpellingGameStatus_NotLoaded = {$: 0};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_WordSpellingGameStatus = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$LocalState$WordSpellingGameStatus_NotLoaded;
		case 1:
			return $author$project$Evergreen$V419$LocalState$WordSpellingGameStatus_Loading;
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$LocalState$WordSpellingGameStatus_Error(p0);
		default:
			return $author$project$Evergreen$V419$LocalState$WordSpellingGameStatus_Loaded;
	}
};
var $author$project$Evergreen$V419$Pagination$PageLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Pagination$PageLoading = {$: 0};
var $author$project$Evergreen$Migrate$V419$migrate_Pagination_PageStatus$ = function (migrate_a, old) {
	if (!old.$) {
		return $author$project$Evergreen$V419$Pagination$PageLoading;
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Pagination$PageLoaded(
			$elm$core$Array$map$(migrate_a, p0));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Pagination_PageStatus = F2($author$project$Evergreen$Migrate$V419$migrate_Pagination_PageStatus$);
var $author$project$Evergreen$Migrate$V419$migrate_Pagination_Pagination$ = function (migrate_a, old) {
	return {
		currentPage: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.currentPage),
		pages: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
						$author$project$Evergreen$Migrate$V419$migrate_Pagination_PageStatus(migrate_a))),
				$lamdera$containers$SeqDict$fromList),
			old.pages),
		previousPage: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.previousPage),
		totalItems: old.totalItems
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Pagination_Pagination = F2($author$project$Evergreen$Migrate$V419$migrate_Pagination_Pagination$);
var $author$project$Evergreen$V419$Postmark$ApiKey = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_Postmark_ApiKey = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_AdminDataRequest = 15;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_AdminToBackend = 5;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_AiChatToBackend = 10;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_CheckLoginRequest = 0;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_ExportChannelRequest = 17;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_FinishUserCreationRequest = 9;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_GetLoginTokenRequest = 4;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_GetPublicGoMatchRequest = 16;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_ImportChannelRequest = 18;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_JoinGuildByInviteRequest = 8;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_LinkDiscordRequest = 12;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_LinkSlackRequest = 13;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_AcceptE2ee = 95;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_AddCustomEmojisToUser = 73;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_AddReactionEmoji = 38;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_Admin = 20;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_BanMember = 35;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_CancelAccountDeletion = 63;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_CancelE2eeRequest = 88;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_CollapseUserOptionSection = 59;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_CurrentlyViewing = 46;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_DeclineE2eeRequest = 89;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_DecryptOldMessages = 93;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_DeleteChannel = 29;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_DeleteGuild = 31;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_DeleteInviteLink = 34;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_DeleteMessage = 45;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_DisableE2ee = 92;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_Discord_LoadChannelMessages = 50;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_Discord_LoadThreadMessages = 53;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_Discord_SendEditDmMessage = 42;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_Discord_SendEditGuildMessage = 41;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_Discord_SendMessage = 22;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_Drawing = 76;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_EditChannel = 28;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_EditGuildName = 30;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_EncryptOldMessages = 91;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_ExpandUserOptionSection = 57;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_Game = 75;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_Invalid = 19;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_LeaveGuild = 32;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_LinkDiscordAcknowledgementIsChecked = 68;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_LinkSlackAcknowledgementIsChecked = 69;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_LoadChannelMessages = 48;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_LoadThreadMessages = 49;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_MemberEditTyping = 43;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_MemberTyping = 37;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_NewChannel = 27;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_NewGuild = 36;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_NewInviteLink = 33;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_RegisterPushSubscription = 64;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_RemoveReactionEmoji = 39;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_RequestE2ee = 87;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_ScheduleAccountDeletion = 62;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_SendEditMessage = 40;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_SendEncryptedEditMessage = 97;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_SendEncryptedMessage = 96;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_SendMessage = 21;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_SetDiscordGuildNotificationLevel = 55;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_SetDomainWhitelist = 70;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_SetE2eeRisksAccepted = 94;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_SetEmailNotifications = 60;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_SetEmbedVisibility = 61;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_SetEmojiSkinTone = 71;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_SetGuildNotificationLevel = 54;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_SetLastViewed = 44;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_SetMuteChannel = 77;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_SetMuteDiscordChannel = 79;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_SetMuteDiscordGuild = 82;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_SetMuteDiscordThread = 80;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_SetMuteGuild = 81;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_SetMuteSlackChannel = 85;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_SetMuteSlackThread = 86;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_SetMuteSlackWorkspace = 84;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_SetMuteThread = 78;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_SetName = 47;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_SetNotificationMode = 56;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_SetPublicKey = 90;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_SetSheepGameQuestions = 58;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_SetSlackWorkspaceNotificationLevel = 83;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_SetUserColor = 72;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_Slack_LoadChannelMessages = 51;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_Slack_LoadThreadMessages = 52;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_Slack_ReloadUser = 26;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_Slack_SendEditMessage = 24;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_Slack_SendMessage = 23;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_Slack_UnlinkUser = 25;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_StartReloadingDiscordUser = 67;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_TextEditor = 65;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_UnlinkDiscordUser = 66;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_Local_VoiceChatChange = 74;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_LogOutRequest = 6;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_LoginWithRecoveryPasswordRequest = 3;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_LoginWithTokenRequest = 1;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_LoginWithTwoFactorRequest = 2;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_ProfilePictureEditorToBackend = 14;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_ReloadDataRequest = 11;
var $author$project$Evergreen$V419$ToBackendLog$ToBackendLog_TwoFactorToBackend = 7;
var $author$project$Evergreen$Migrate$V419$migrate_ToBackendLog_ToBackendLog = function (old) {
	switch (old) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		case 6:
			return 6;
		case 7:
			return 7;
		case 8:
			return 8;
		case 9:
			return 9;
		case 10:
			return 10;
		case 11:
			return 11;
		case 12:
			return 12;
		case 13:
			return 13;
		case 14:
			return 14;
		case 15:
			return 15;
		case 16:
			return 16;
		case 17:
			return 17;
		case 18:
			return 18;
		case 19:
			return 19;
		case 20:
			return 20;
		case 21:
			return 21;
		case 22:
			return 22;
		case 23:
			return 23;
		case 24:
			return 24;
		case 25:
			return 25;
		case 26:
			return 26;
		case 27:
			return 27;
		case 28:
			return 28;
		case 29:
			return 29;
		case 30:
			return 30;
		case 31:
			return 31;
		case 32:
			return 32;
		case 33:
			return 33;
		case 34:
			return 34;
		case 35:
			return 35;
		case 36:
			return 36;
		case 37:
			return 37;
		case 38:
			return 38;
		case 39:
			return 39;
		case 40:
			return 40;
		case 41:
			return 41;
		case 42:
			return 42;
		case 43:
			return 43;
		case 44:
			return 44;
		case 45:
			return 45;
		case 46:
			return 46;
		case 47:
			return 47;
		case 48:
			return 48;
		case 49:
			return 49;
		case 50:
			return 50;
		case 51:
			return 51;
		case 52:
			return 52;
		case 53:
			return 53;
		case 54:
			return 54;
		case 55:
			return 55;
		case 56:
			return 56;
		case 57:
			return 57;
		case 58:
			return 58;
		case 59:
			return 59;
		case 60:
			return 60;
		case 61:
			return 61;
		case 62:
			return 62;
		case 63:
			return 63;
		case 64:
			return 64;
		case 65:
			return 65;
		case 66:
			return 66;
		case 67:
			return 67;
		case 68:
			return 68;
		case 69:
			return 69;
		case 70:
			return 70;
		case 71:
			return 71;
		case 72:
			return 72;
		case 73:
			return 73;
		case 74:
			return 74;
		case 75:
			return 75;
		case 76:
			return 76;
		case 77:
			return 77;
		case 78:
			return 78;
		case 79:
			return 79;
		case 80:
			return 80;
		case 81:
			return 81;
		case 82:
			return 82;
		case 83:
			return 83;
		case 84:
			return 84;
		case 85:
			return 85;
		case 86:
			return 86;
		case 87:
			return 87;
		case 88:
			return 88;
		case 89:
			return 89;
		case 90:
			return 90;
		case 91:
			return 91;
		case 92:
			return 92;
		case 93:
			return 93;
		case 94:
			return 94;
		case 95:
			return 95;
		case 96:
			return 96;
		default:
			return 97;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_ToBackendLog_ToBackendLogData = function (old) {
	return {
		endTime: old.endTime,
		startTime: old.startTime,
		toBackendLog: $author$project$Evergreen$Migrate$V419$migrate_ToBackendLog_ToBackendLog(old.toBackendLog),
		userId: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, old.userId)
	};
};
var $author$project$Evergreen$V419$UserSession$LastViewedDiscordGuild = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$UserSession$LastViewedGuild = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$UserSession$LastViewedSlackWorkspace = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_UserSession_LastViewedGuild = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$UserSession$LastViewedGuild(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$UserSession$LastViewedDiscordGuild(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0));
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$UserSession$LastViewedSlackWorkspace(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0));
	}
};
var $author$project$Evergreen$V419$UserSession$NoNotifications = 0;
var $author$project$Evergreen$V419$UserSession$NotifyWhenRunning = 1;
var $author$project$Evergreen$V419$UserSession$PushNotifications = 2;
var $author$project$Evergreen$Migrate$V419$migrate_UserSession_NotificationMode = function (old) {
	switch (old) {
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			return 2;
	}
};
var $author$project$Evergreen$V419$UserSession$NotSubscribed = {$: 0};
var $author$project$Evergreen$V419$UserSession$Subscribed$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V419$UserSession$Subscribed = F2($author$project$Evergreen$V419$UserSession$Subscribed$);
var $author$project$Evergreen$V419$UserSession$SubscriptionError$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V419$UserSession$SubscriptionError = F2($author$project$Evergreen$V419$UserSession$SubscriptionError$);
var $author$project$Evergreen$V419$UserSession$SubscriptionJsException$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Evergreen$V419$UserSession$SubscriptionJsException = F2($author$project$Evergreen$V419$UserSession$SubscriptionJsException$);
var $author$project$Evergreen$Migrate$V419$migrate_Ports_SubscribeKeys = function (old) {
	return old;
};
var $author$project$Evergreen$Migrate$V419$migrate_Ports_SubscribeData = function (old) {
	return {
		endpoint: old.endpoint,
		expirationTime: old.expirationTime,
		keys: $author$project$Evergreen$Migrate$V419$migrate_Ports_SubscribeKeys(old.keys)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_UserSession_PushSubscription = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$UserSession$NotSubscribed;
		case 1:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$UserSession$Subscribed$(
				$author$project$Evergreen$Migrate$V419$migrate_Ports_SubscribeData(p0),
				p1);
		case 2:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$UserSession$SubscriptionError$(
				$author$project$Evergreen$Migrate$V419$migrate_Ports_SubscribeData(p0),
				p1);
		default:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$UserSession$SubscriptionJsException$(p0, p1);
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_UserSession_SheepGameQuestion = function (old) {
	return {
		attachedFiles: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileStatus)),
				$lamdera$containers$SeqDict$fromList),
			old.attachedFiles),
		text: old.text
	};
};
var $author$project$Evergreen$V419$UserSession$UserOption_ConnectedDevices = 5;
var $author$project$Evergreen$V419$UserSession$UserOption_Debug = 6;
var $author$project$Evergreen$V419$UserSession$UserOption_Discord = 4;
var $author$project$Evergreen$V419$UserSession$UserOption_E2ee = 3;
var $author$project$Evergreen$V419$UserSession$UserOption_Privacy = 7;
var $author$project$Evergreen$V419$UserSession$UserOption_Settings = 1;
var $author$project$Evergreen$V419$UserSession$UserOption_Slack = 8;
var $author$project$Evergreen$V419$UserSession$UserOption_TwoFactorAuthentication = 0;
var $author$project$Evergreen$V419$UserSession$UserOption_WhitelistedDomains = 2;
var $author$project$Evergreen$Migrate$V419$migrate_UserSession_UserOptionSection = function (old) {
	switch (old) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		case 6:
			return 6;
		case 7:
			return 7;
		default:
			return 8;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_UserSession_UserSession = function (old) {
	return {
		expandedUserOptions: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_UserSession_UserOptionSection, old.expandedUserOptions),
		lastClientDisconnect: old.lastClientDisconnect,
		lastViewedGuild: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_UserSession_LastViewedGuild, old.lastViewedGuild),
		notificationMode: $author$project$Evergreen$Migrate$V419$migrate_UserSession_NotificationMode(old.notificationMode),
		pushSubscription: $author$project$Evergreen$Migrate$V419$migrate_UserSession_PushSubscription(old.pushSubscription),
		savedSheepGameQuestions: $author$project$Evergreen$Migrate$V419$migrate_IdArray_IdArray$($author$project$Evergreen$Migrate$V419$migrate_UserSession_SheepGameQuestion, old.savedSheepGameQuestions),
		sessionIdHash: $author$project$Evergreen$Migrate$V419$migrate_SessionIdHash_SessionIdHash(old.sessionIdHash),
		signedInAt: old.signedInAt,
		userAgent: $author$project$Evergreen$Migrate$V419$migrate_UserAgent_UserAgent(old.userAgent),
		userId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.userId)
	};
};
var $author$project$Evergreen$V419$Emoji$SkinTone1 = 0;
var $author$project$Evergreen$V419$Emoji$SkinTone2 = 1;
var $author$project$Evergreen$V419$Emoji$SkinTone3 = 2;
var $author$project$Evergreen$V419$Emoji$SkinTone4 = 3;
var $author$project$Evergreen$V419$Emoji$SkinTone5 = 4;
var $author$project$Evergreen$Migrate$V419$migrate_Emoji_SkinTone = function (old) {
	switch (old) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		default:
			return 4;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiConfig = function (old) {
	return {
		lastUsedEmojis: $elm$core$Array$map$($author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji, old.lastUsedEmojis),
		skinTone: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Emoji_SkinTone, old.skinTone)
	};
};
var $author$project$Evergreen$V419$MuteSettings$IsFullyMuted = 2;
var $author$project$Evergreen$V419$MuteSettings$IsNotMuted = 0;
var $author$project$Evergreen$V419$MuteSettings$IsPartiallyMuted = 1;
var $author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted = function (old) {
	switch (old) {
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			return 2;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_MuteSettings_MutedChannel = function (old) {
	return {
		mutedChannel: $author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(old.mutedChannel),
		mutedThreads: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted)),
				$lamdera$containers$SeqDict$fromList),
			old.mutedThreads)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_MuteSettings_MutedDiscordGuild = function (old) {
	return {
		channels: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_MuteSettings_MutedChannel)),
				$lamdera$containers$SeqDict$fromList),
			old.channels),
		mutedGuild: $author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(old.mutedGuild)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_MuteSettings_MutedGuild = function (old) {
	return {
		channels: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_MuteSettings_MutedChannel)),
				$lamdera$containers$SeqDict$fromList),
			old.channels),
		mutedGuild: $author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(old.mutedGuild)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_MuteSettings_MutedSlackWorkspace = function (old) {
	return {
		channels: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_MuteSettings_MutedChannel)),
				$lamdera$containers$SeqDict$fromList),
			old.channels),
		mutedWorkspace: $author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(old.mutedWorkspace)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_MuteSettings_Model = function (old) {
	return {
		mutedDiscordDms: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted)),
				$lamdera$containers$SeqDict$fromList),
			old.mutedDiscordDms),
		mutedDiscordGuilds: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_MuteSettings_MutedDiscordGuild)),
				$lamdera$containers$SeqDict$fromList),
			old.mutedDiscordGuilds),
		mutedDms: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_MuteSettings_MutedChannel)),
				$lamdera$containers$SeqDict$fromList),
			old.mutedDms),
		mutedGuilds: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_MuteSettings_MutedGuild)),
				$lamdera$containers$SeqDict$fromList),
			old.mutedGuilds),
		mutedSlackWorkspaces: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_MuteSettings_MutedSlackWorkspace)),
				$lamdera$containers$SeqDict$fromList),
			old.mutedSlackWorkspaces)
	};
};
var $author$project$Evergreen$V419$PersonName$PersonName = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_PersonName_PersonName = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$V419$RichText$Domain = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_RichText_Domain = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$V419$UserColor$UserColor = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_UserColor_UserColor = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$V419$User$DeletedUser = {$: 0};
var $author$project$Evergreen$V419$User$UserHasEmail = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_User_BackendUserStatus = function (old) {
	if (!old.$) {
		return $author$project$Evergreen$V419$User$DeletedUser;
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$User$UserHasEmail(
			$author$project$Evergreen$Migrate$V419$migrate_EmailAddress_EmailAddress(p0));
	}
};
var $author$project$Evergreen$V419$User$NeverNotifyMe = 0;
var $author$project$Evergreen$V419$User$NotifyMeWhenMentioned = 1;
var $author$project$Evergreen$Migrate$V419$migrate_User_EmailNotifications = function (old) {
	if (!old) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Evergreen$V419$User$HideEmbeds = 1;
var $author$project$Evergreen$V419$User$ShowEmbeds = 0;
var $author$project$Evergreen$Migrate$V419$migrate_User_EmbedVisibility = function (old) {
	if (!old) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Evergreen$V419$User$DiscordDmChannelLastViewed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$User$DmChannelLastViewed$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$User$DmChannelLastViewed = F2($author$project$Evergreen$V419$User$DmChannelLastViewed$);
var $author$project$Evergreen$V419$User$NoLastDmViewed = {$: 2};
var $author$project$Evergreen$Migrate$V419$migrate_User_LastDmViewed = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$User$DmChannelLastViewed$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute(p1));
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$User$DiscordDmChannelLastViewed(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0));
		default:
			return $author$project$Evergreen$V419$User$NoLastDmViewed;
	}
};
var $author$project$Evergreen$V419$X25519$PublicKey = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_X25519_Key = function (old) {
	return old;
};
var $author$project$Evergreen$Migrate$V419$migrate_X25519_PublicKey = function (old) {
	var p0 = old;
	return $author$project$Evergreen$Migrate$V419$migrate_X25519_Key(p0);
};
var $author$project$Evergreen$Migrate$V419$migrate_User_BackendUser = function (old) {
	return {
		availableCustomEmojis: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, old.availableCustomEmojis),
		availableStickers: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, old.availableStickers),
		color: $author$project$Evergreen$Migrate$V419$migrate_UserColor_UserColor(old.color),
		createdAt: old.createdAt,
		deleteAccountAt: old.deleteAccountAt,
		directMentions: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
						A2(
							$author$project$Evergreen$Migrate$V419$migrate_NonemptyDict_NonemptyDict,
							A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute),
							$author$project$Evergreen$Migrate$V419$migrate_OneOrGreater_OneOrGreater))),
				$lamdera$containers$SeqDict$fromList),
			old.directMentions),
		discordDirectMentions: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Discord_Id,
						A2(
							$author$project$Evergreen$Migrate$V419$migrate_NonemptyDict_NonemptyDict,
							A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute),
							$author$project$Evergreen$Migrate$V419$migrate_OneOrGreater_OneOrGreater))),
				$lamdera$containers$SeqDict$fromList),
			old.discordDirectMentions),
		discordNotifyOnAllMessages: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Discord_Id, old.discordNotifyOnAllMessages),
		domainWhitelist: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_RichText_Domain, old.domainWhitelist),
		e2eeRisksAccepted: old.e2eeRisksAccepted,
		email: $author$project$Evergreen$Migrate$V419$migrate_User_BackendUserStatus(old.email),
		emailNotifications: $author$project$Evergreen$Migrate$V419$migrate_User_EmailNotifications(old.emailNotifications),
		embedVisibility: $author$project$Evergreen$Migrate$V419$migrate_User_EmbedVisibility(old.embedVisibility),
		emojiConfig: $author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiConfig(old.emojiConfig),
		icon: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash, old.icon),
		isAdmin: old.isAdmin,
		lastChannelViewed: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute))),
				$lamdera$containers$SeqDict$fromList),
			old.lastChannelViewed),
		lastDiscordChannelViewed: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Discord_Id,
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute))),
				$lamdera$containers$SeqDict$fromList),
			old.lastDiscordChannelViewed),
		lastDmViewed: $author$project$Evergreen$Migrate$V419$migrate_User_LastDmViewed(old.lastDmViewed),
		lastEmailNotification: old.lastEmailNotification,
		lastLogPageViewed: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.lastLogPageViewed),
		lastPushNotification: old.lastPushNotification,
		lastSlackChannelViewed: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Slack_Id,
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute))),
				$lamdera$containers$SeqDict$fromList),
			old.lastSlackChannelViewed),
		lastViewedMessage: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId, $author$project$Evergreen$Migrate$V419$migrate_Id_Id)),
				$lamdera$containers$SeqDict$fromList),
			old.lastViewedMessage),
		lastViewedThreadMessage: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId, $author$project$Evergreen$Migrate$V419$migrate_Id_Id),
						$author$project$Evergreen$Migrate$V419$migrate_Id_Id)),
				$lamdera$containers$SeqDict$fromList),
			old.lastViewedThreadMessage),
		linkDiscordAcknowledgementIsChecked: old.linkDiscordAcknowledgementIsChecked,
		linkSlackAcknowledgementIsChecked: old.linkSlackAcknowledgementIsChecked,
		muteSettings: $author$project$Evergreen$Migrate$V419$migrate_MuteSettings_Model(old.muteSettings),
		name: $author$project$Evergreen$Migrate$V419$migrate_PersonName_PersonName(old.name),
		notifyOnAllMessages: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, old.notifyOnAllMessages),
		publicKey: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_X25519_PublicKey, old.publicKey),
		recentLoginEmails: old.recentLoginEmails,
		slackDirectMentions: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Slack_Id,
						A2(
							$author$project$Evergreen$Migrate$V419$migrate_NonemptyDict_NonemptyDict,
							A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute),
							$author$project$Evergreen$Migrate$V419$migrate_OneOrGreater_OneOrGreater))),
				$lamdera$containers$SeqDict$fromList),
			old.slackDirectMentions),
		slackNotifyOnAllMessages: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Slack_Id, old.slackNotifyOnAllMessages)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminData = function (old) {
	return {
		backendMsgLogs: $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminDataStatus$(
			$elm$core$Array$map($author$project$Evergreen$Migrate$V419$migrate_BackendMsgLog_BackendMsgLogData),
			old.backendMsgLogs),
		connections: $elm$core$List$map$(
			A2(
				$elm$core$Tuple$mapBoth,
				$author$project$Evergreen$Migrate$V419$migrate_SessionIdHash_SessionIdHash,
				A2($author$project$Evergreen$Migrate$V419$migrate_NonemptyDict_NonemptyDict, $elm$core$Basics$identity, $author$project$Evergreen$Migrate$V419$migrate_LocalState_ConnectionData)),
			old.connections),
		deleteOrphanedFiles: $author$project$Evergreen$Migrate$V419$migrate_LocalState_DeleteOrphanedFilesStatus(old.deleteOrphanedFiles),
		deletedGuilds: $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminDataStatus$(
			A2(
				$elm$core$Basics$composeR,
				$lamdera$containers$SeqDict$toList,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$map(
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminData_DeletedGuild)),
					$lamdera$containers$SeqDict$fromList)),
			old.deletedGuilds),
		discordDmChannels: $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminDataStatus$(
			A2(
				$elm$core$Basics$composeR,
				$lamdera$containers$SeqDict$toList,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$map(
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminData_DiscordDmChannel)),
					$lamdera$containers$SeqDict$fromList)),
			old.discordDmChannels),
		discordGuilds: $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminDataStatus$(
			A2(
				$elm$core$Basics$composeR,
				$lamdera$containers$SeqDict$toList,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$map(
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminData_DiscordGuild)),
					$lamdera$containers$SeqDict$fromList)),
			old.discordGuilds),
		discordLinkLimit: old.discordLinkLimit,
		discordLinkingEnabled: old.discordLinkingEnabled,
		discordUsers: $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminDataStatus$(
			A2(
				$elm$core$Basics$composeR,
				$lamdera$containers$SeqDict$toList,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$map(
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_DiscordUserData_ForAdmin)),
					$lamdera$containers$SeqDict$fromList)),
			old.discordUsers),
		dmChannels: $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminDataStatus$(
			A2(
				$elm$core$Basics$composeR,
				$lamdera$containers$SeqDict$toList,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$map(
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_DmChannelId_DmChannelId, $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminData_DmChannel)),
					$lamdera$containers$SeqDict$fromList)),
			old.dmChannels),
		emailNotificationsEnabled: old.emailNotificationsEnabled,
		filesCount: old.filesCount,
		guilds: $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminDataStatus$(
			A2(
				$elm$core$Basics$composeR,
				$lamdera$containers$SeqDict$toList,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$map(
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminData_Guild)),
					$lamdera$containers$SeqDict$fromList)),
			old.guilds),
		lastBackup: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_LocalState_LastBackup, old.lastBackup),
		loadingDiscordChannels: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Discord_Id,
						$author$project$Evergreen$Migrate$V419$migrate_LocalState_LoadingDiscordChannel($elm$core$Basics$identity))),
				$lamdera$containers$SeqDict$fromList),
			old.loadingDiscordChannels),
		logs: $author$project$Evergreen$Migrate$V419$migrate_Pagination_Pagination$($author$project$Evergreen$Migrate$V419$migrate_LocalState_LogWithTime, old.logs),
		notifyAdminsBotUserId: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, old.notifyAdminsBotUserId),
		notifyAdminsToken: old.notifyAdminsToken,
		openRouterKey: old.openRouterKey,
		orphanedFiles: $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminDataStatus$(
			A2(
				$elm$core$Basics$composeR,
				$lamdera$containers$SeqDict$toList,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$map(
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash, $author$project$Evergreen$Migrate$V419$migrate_FileStatus_BackendFileData)),
					$lamdera$containers$SeqDict$fromList)),
			old.orphanedFiles),
		postmarkKey: $author$project$Evergreen$Migrate$V419$migrate_Postmark_ApiKey(old.postmarkKey),
		privateVapidKey: $author$project$Evergreen$Migrate$V419$migrate_LocalState_PrivateVapidKey(old.privateVapidKey),
		seqDictWorks: old.seqDictWorks,
		serverSecretRefreshedAt: $author$project$Evergreen$Migrate$V419$migrate_LocalState_ServerSecretStatus(old.serverSecretRefreshedAt),
		sessions: $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminDataStatus$(
			A2(
				$elm$core$Basics$composeR,
				$lamdera$containers$SeqDict$toList,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$map(
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_SessionIdHash_SessionIdHash, $author$project$Evergreen$Migrate$V419$migrate_UserSession_UserSession)),
					$lamdera$containers$SeqDict$fromList)),
			old.sessions),
		signupsEnabled: old.signupsEnabled,
		slackDmChannels: $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminDataStatus$(
			A2(
				$elm$core$Basics$composeR,
				$lamdera$containers$SeqDict$toList,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$map(
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminData_SlackDmChannel)),
					$lamdera$containers$SeqDict$fromList)),
			old.slackDmChannels),
		slackLinkLimit: old.slackLinkLimit,
		slackLinkingEnabled: old.slackLinkingEnabled,
		slackWorkspaces: $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminDataStatus$(
			A2(
				$elm$core$Basics$composeR,
				$lamdera$containers$SeqDict$toList,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$map(
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminData_SlackWorkspace)),
					$lamdera$containers$SeqDict$fromList)),
			old.slackWorkspaces),
		toBackendLogs: $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminDataStatus$(
			$elm$core$Array$map($author$project$Evergreen$Migrate$V419$migrate_ToBackendLog_ToBackendLogData),
			old.toBackendLogs),
		twoFactorAuthentication: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					$elm$core$Tuple$mapFirst($author$project$Evergreen$Migrate$V419$migrate_Id_Id)),
				$lamdera$containers$SeqDict$fromList),
			old.twoFactorAuthentication),
		users: $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminDataStatus$(
			A2($author$project$Evergreen$Migrate$V419$migrate_NonemptyDict_NonemptyDict, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_User_BackendUser),
			old.users),
		vulnerabilityChecks: old.vulnerabilityChecks,
		websocketCloseEvents: $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminDataStatus$(
			$elm$core$Array$map($author$project$Evergreen$Migrate$V419$migrate_LocalState_WebsocketClosedEvent),
			old.websocketCloseEvents),
		wordSpellingGameEnglish: $author$project$Evergreen$Migrate$V419$migrate_LocalState_WordSpellingGameStatus(old.wordSpellingGameEnglish),
		wordSpellingGameSwedish: $author$project$Evergreen$Migrate$V419$migrate_LocalState_WordSpellingGameStatus(old.wordSpellingGameSwedish)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminStatus = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$LocalState$IsAdmin(
				$author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminData(p0));
		case 1:
			return $author$project$Evergreen$V419$LocalState$IsAdminButDataNotLoaded;
		default:
			return $author$project$Evergreen$V419$LocalState$IsNotAdmin;
	}
};
var $author$project$Evergreen$V419$ChannelDescription$ChannelDescription = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_ChannelDescription_ChannelDescription = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$Migrate$V419$migrate_Thread_DiscordFrontendThread = function (old) {
	return {
		dateDividerDrawings: $lamdera$containers$SeqDict$map$(
			function (k) {
				return $author$project$Evergreen$Migrate$V419$migrate_Drawing_Drawing($author$project$Evergreen$Migrate$V419$migrate_Discord_Id);
			},
			old.dateDividerDrawings),
		messages: $author$project$Evergreen$Migrate$V419$migrate_MessageArray_MessageArray$($author$project$Evergreen$Migrate$V419$migrate_Id_ThreadMessageId, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, old.messages),
		visibleMessages: $author$project$Evergreen$Migrate$V419$migrate_VisibleMessages_VisibleMessages$($author$project$Evergreen$Migrate$V419$migrate_Id_ThreadMessageId, old.visibleMessages)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_DiscordFrontendChannel = function (old) {
	return {
		dateDividerDrawings: $lamdera$containers$SeqDict$map$(
			function (k) {
				return $author$project$Evergreen$Migrate$V419$migrate_Drawing_Drawing($author$project$Evergreen$Migrate$V419$migrate_Discord_Id);
			},
			old.dateDividerDrawings),
		description: $author$project$Evergreen$Migrate$V419$migrate_ChannelDescription_ChannelDescription(old.description),
		isForum: old.isForum,
		messages: $author$project$Evergreen$Migrate$V419$migrate_MessageArray_MessageArray$($author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, old.messages),
		name: $author$project$Evergreen$Migrate$V419$migrate_ChannelName_ChannelName(old.name),
		permissionOverwrites: $elm$core$List$map$($author$project$Evergreen$Migrate$V419$migrate_Discord_Overwrite, old.permissionOverwrites),
		threads: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Thread_DiscordFrontendThread)),
				$lamdera$containers$SeqDict$fromList),
			old.threads),
		visibleMessages: $author$project$Evergreen$Migrate$V419$migrate_VisibleMessages_VisibleMessages$($author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, old.visibleMessages)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Thread_LastTypedAt$ = function (migrate_channelId, old) {
	return {
		channelId: migrate_channelId(old.channelId),
		threadRoute: $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMaybeMessage(old.threadRoute),
		time: old.time
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Thread_LastTypedAt = F2($author$project$Evergreen$Migrate$V419$migrate_Thread_LastTypedAt$);
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_DiscordFrontendGuild = function (old) {
	return {
		channels: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_DiscordFrontendChannel)),
				$lamdera$containers$SeqDict$fromList),
			old.channels),
		customEmojis: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, old.customEmojis),
		icon: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash, old.icon),
		lastTypedAt: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Discord_Id,
						$author$project$Evergreen$Migrate$V419$migrate_Thread_LastTypedAt($author$project$Evergreen$Migrate$V419$migrate_Discord_Id))),
				$lamdera$containers$SeqDict$fromList),
			old.lastTypedAt),
		membersAndOwner: $author$project$Evergreen$Migrate$V419$migrate_MembersAndOwner_MembersAndOwner$(
			$author$project$Evergreen$Migrate$V419$migrate_Discord_Id,
			function (rec) {
				return {
					joinedAt: rec.joinedAt,
					roles: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Discord_Id, rec.roles)
				};
			},
			old.membersAndOwner),
		name: $author$project$Evergreen$Migrate$V419$migrate_GuildName_GuildName(old.name),
		roles: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_DiscordRole)),
				$lamdera$containers$SeqDict$fromList),
			old.roles),
		stickers: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, old.stickers)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_Archived = function (old) {
	return {
		archivedAt: old.archivedAt,
		archivedBy: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.archivedBy)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_FrontendChannel = function (old) {
	return {
		createdAt: old.createdAt,
		createdBy: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.createdBy),
		dateDividerDrawings: $lamdera$containers$SeqDict$map$(
			function (k) {
				return $author$project$Evergreen$Migrate$V419$migrate_Drawing_Drawing($author$project$Evergreen$Migrate$V419$migrate_Id_Id);
			},
			old.dateDividerDrawings),
		description: $author$project$Evergreen$Migrate$V419$migrate_ChannelDescription_ChannelDescription(old.description),
		games: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Game_MatchData)),
				$lamdera$containers$SeqDict$fromList),
			old.games),
		isArchived: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_LocalState_Archived, old.isArchived),
		messages: $author$project$Evergreen$Migrate$V419$migrate_MessageArray_MessageArray$($author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, old.messages),
		name: $author$project$Evergreen$Migrate$V419$migrate_ChannelName_ChannelName(old.name),
		threads: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Thread_FrontendThread)),
				$lamdera$containers$SeqDict$fromList),
			old.threads),
		visibleMessages: $author$project$Evergreen$Migrate$V419$migrate_VisibleMessages_VisibleMessages$($author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, old.visibleMessages)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_GuildMember = function (old) {
	return old;
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_FrontendGuild = function (old) {
	return {
		channels: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_FrontendChannel)),
				$lamdera$containers$SeqDict$fromList),
			old.channels),
		createdAt: old.createdAt,
		createdBy: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.createdBy),
		icon: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash, old.icon),
		invites: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_SecretId_SecretId,
						function (rec) {
							return {
								createdAt: rec.createdAt,
								createdBy: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(rec.createdBy)
							};
						})),
				$lamdera$containers$SeqDict$fromList),
			old.invites),
		lastTypedAt: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
						$author$project$Evergreen$Migrate$V419$migrate_Thread_LastTypedAt($author$project$Evergreen$Migrate$V419$migrate_Id_Id))),
				$lamdera$containers$SeqDict$fromList),
			old.lastTypedAt),
		membersAndOwner: $author$project$Evergreen$Migrate$V419$migrate_MembersAndOwner_MembersAndOwner$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_GuildMember, old.membersAndOwner),
		name: $author$project$Evergreen$Migrate$V419$migrate_GuildName_GuildName(old.name)
	};
};
var $author$project$Evergreen$V419$LocalState$AlreadyJoined = 0;
var $author$project$Evergreen$V419$LocalState$InviteIsInvalid = 1;
var $author$project$Evergreen$V419$LocalState$YouAreBanned = 2;
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_JoinGuildError = function (old) {
	switch (old) {
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			return 2;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Thread_FrontendGenericThread$ = function (migrate_userId, migrate_channelId, old) {
	return {
		dateDividerDrawings: $lamdera$containers$SeqDict$map$(
			function (k) {
				return $author$project$Evergreen$Migrate$V419$migrate_Drawing_Drawing(migrate_userId);
			},
			old.dateDividerDrawings),
		messages: $author$project$Evergreen$Migrate$V419$migrate_MessageArray_MessageArray$($author$project$Evergreen$Migrate$V419$migrate_Id_ThreadMessageId, migrate_userId, migrate_channelId, old.messages),
		visibleMessages: $author$project$Evergreen$Migrate$V419$migrate_VisibleMessages_VisibleMessages$($author$project$Evergreen$Migrate$V419$migrate_Id_ThreadMessageId, old.visibleMessages)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Thread_FrontendGenericThread = F3($author$project$Evergreen$Migrate$V419$migrate_Thread_FrontendGenericThread$);
var $author$project$Evergreen$Migrate$V419$migrate_Thread_SlackFrontendThread = function (old) {
	return $author$project$Evergreen$Migrate$V419$migrate_Thread_FrontendGenericThread$($author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, old);
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_SlackFrontendDmChannel = function (old) {
	return {
		members: $author$project$Evergreen$Migrate$V419$migrate_NonemptySet_NonemptySet$($author$project$Evergreen$Migrate$V419$migrate_Slack_Id, old.members),
		messages: $author$project$Evergreen$Migrate$V419$migrate_MessageArray_MessageArray$($author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, old.messages),
		teamId: $author$project$Evergreen$Migrate$V419$migrate_Slack_Id(old.teamId),
		threads: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Thread_SlackFrontendThread)),
				$lamdera$containers$SeqDict$fromList),
			old.threads),
		visibleMessages: $author$project$Evergreen$Migrate$V419$migrate_VisibleMessages_VisibleMessages$($author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, old.visibleMessages)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_SlackFrontendChannel = function (old) {
	return {
		isPrivate: old.isPrivate,
		messages: $author$project$Evergreen$Migrate$V419$migrate_MessageArray_MessageArray$($author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, old.messages),
		name: $author$project$Evergreen$Migrate$V419$migrate_ChannelName_ChannelName(old.name),
		threads: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Thread_SlackFrontendThread)),
				$lamdera$containers$SeqDict$fromList),
			old.threads),
		visibleMessages: $author$project$Evergreen$Migrate$V419$migrate_VisibleMessages_VisibleMessages$($author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, old.visibleMessages)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_SlackFrontendWorkspace = function (old) {
	return {
		channels: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_SlackFrontendChannel)),
				$lamdera$containers$SeqDict$fromList),
			old.channels),
		customEmojis: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, old.customEmojis),
		icon: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash, old.icon),
		name: old.name
	};
};
var $author$project$Evergreen$V419$TextEditor$Edit_TypedText$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$TextEditor$Edit_TypedText = F2($author$project$Evergreen$V419$TextEditor$Edit_TypedText$);
var $author$project$Evergreen$Migrate$V419$migrate_TextEditor_EditChange = function (old) {
	var p0 = old.a;
	var p1 = old.b;
	return $author$project$Evergreen$V419$TextEditor$Edit_TypedText$(
		$author$project$Evergreen$Migrate$V419$migrate_Range_Range(p0),
		p1);
};
var $author$project$Evergreen$Migrate$V419$migrate_TextEditor_LocalState = function (old) {
	return {
		cursorPosition: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Range_Range)),
				$lamdera$containers$SeqDict$fromList),
			old.cursorPosition),
		history: $elm$core$Array$map$(
			A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_TextEditor_EditChange),
			old.history),
		undoPoint: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					$elm$core$Tuple$mapFirst($author$project$Evergreen$Migrate$V419$migrate_Id_Id)),
				$lamdera$containers$SeqDict$fromList),
			old.undoPoint)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_UserSession_FrontendUserSession = function (old) {
	return {
		currentlyViewing: $lamdera$containers$SeqDict$map$(
			function (k) {
				return $author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing;
			},
			old.currentlyViewing),
		lastActiveAt: old.lastActiveAt,
		notificationMode: $author$project$Evergreen$Migrate$V419$migrate_UserSession_NotificationMode(old.notificationMode),
		userAgent: $author$project$Evergreen$Migrate$V419$migrate_UserAgent_UserAgent(old.userAgent)
	};
};
var $author$project$Evergreen$V419$CustomEmoji$CustomEmojiInternal$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$CustomEmoji$CustomEmojiInternal = F2($author$project$Evergreen$V419$CustomEmoji$CustomEmojiInternal$);
var $author$project$Evergreen$V419$CustomEmoji$CustomEmojiLoading = {$: 1};
var $author$project$Evergreen$Migrate$V419$migrate_CustomEmoji_CustomEmojiUrl = function (old) {
	if (!old.$) {
		var p0 = old.a;
		var p1 = old.b;
		return $author$project$Evergreen$V419$CustomEmoji$CustomEmojiInternal$(
			$author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash(p0),
			$elm$core$Maybe$map$(
				$author$project$Evergreen$Migrate$V419$migrate_Coord_Coord($author$project$Evergreen$Migrate$V419$migrate_CssPixels_CssPixels),
				p1));
	} else {
		return $author$project$Evergreen$V419$CustomEmoji$CustomEmojiLoading;
	}
};
var $author$project$Evergreen$V419$CustomEmoji$EmojiName = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_CustomEmoji_EmojiName = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$Migrate$V419$migrate_CustomEmoji_CustomEmojiData = function (old) {
	return {
		isAnimated: old.isAnimated,
		name: $author$project$Evergreen$Migrate$V419$migrate_CustomEmoji_EmojiName(old.name),
		url: $author$project$Evergreen$Migrate$V419$migrate_CustomEmoji_CustomEmojiUrl(old.url)
	};
};
var $author$project$Evergreen$V419$Encryption$BytesHash = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_Encryption_BytesHash = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$V419$LinkedAndOtherDiscordUsers$LinkedAndOtherDiscordUsers$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$LinkedAndOtherDiscordUsers$LinkedAndOtherDiscordUsers = F2($author$project$Evergreen$V419$LinkedAndOtherDiscordUsers$LinkedAndOtherDiscordUsers$);
var $author$project$Evergreen$Migrate$V419$migrate_LinkedAndOtherDiscordUsers_DiscordFrontendCurrentUser = function (old) {
	return {
		color: $author$project$Evergreen$Migrate$V419$migrate_UserColor_UserColor(old.color),
		email: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_EmailAddress_EmailAddress, old.email),
		icon: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash, old.icon),
		isLoadingData: $author$project$Evergreen$Migrate$V419$migrate_DiscordUserData_DiscordUserLoadingData(old.isLoadingData),
		linkedAt: old.linkedAt,
		name: $author$project$Evergreen$Migrate$V419$migrate_PersonName_PersonName(old.name),
		needsAuthAgain: old.needsAuthAgain
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_UserSession_DiscordFrontendUser = function (old) {
	return {
		color: $author$project$Evergreen$Migrate$V419$migrate_UserColor_UserColor(old.color),
		icon: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash, old.icon),
		name: $author$project$Evergreen$Migrate$V419$migrate_PersonName_PersonName(old.name)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_LinkedAndOtherDiscordUsers_LinkedAndOtherDiscordUsers = function (old) {
	var p0 = old.a;
	var p1 = old.b;
	return $author$project$Evergreen$V419$LinkedAndOtherDiscordUsers$LinkedAndOtherDiscordUsers$(
		$elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_UserSession_DiscordFrontendUser)),
				$lamdera$containers$SeqDict$fromList),
			p0),
		$elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_LinkedAndOtherDiscordUsers_DiscordFrontendCurrentUser)),
				$lamdera$containers$SeqDict$fromList),
			p1));
};
var $author$project$Evergreen$V419$Discord$ApngFormat = 1;
var $author$project$Evergreen$V419$Discord$GifFormat = 3;
var $author$project$Evergreen$V419$Discord$LottieFormat = 2;
var $author$project$Evergreen$V419$Discord$PngFormat = 0;
var $author$project$Evergreen$Migrate$V419$migrate_Discord_StickerFormatType = function (old) {
	switch (old) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $author$project$Evergreen$V419$Sticker$DiscordStandardSticker = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Sticker$StickerInternal$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$Sticker$StickerInternal = F2($author$project$Evergreen$V419$Sticker$StickerInternal$);
var $author$project$Evergreen$V419$Sticker$StickerLoading = {$: 2};
var $author$project$Evergreen$Migrate$V419$migrate_Sticker_StickerUrl = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Sticker$StickerInternal$(
				$author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash(p0),
				$elm$core$Maybe$map$(
					$author$project$Evergreen$Migrate$V419$migrate_Coord_Coord($author$project$Evergreen$Migrate$V419$migrate_CssPixels_CssPixels),
					p1));
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Sticker$DiscordStandardSticker(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0));
		default:
			return $author$project$Evergreen$V419$Sticker$StickerLoading;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Sticker_StickerData = function (old) {
	return {
		format: $author$project$Evergreen$Migrate$V419$migrate_Discord_StickerFormatType(old.format),
		name: old.name,
		url: $author$project$Evergreen$Migrate$V419$migrate_Sticker_StickerUrl(old.url)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_UserSession_SlackFrontendUser = function (old) {
	return {
		color: $author$project$Evergreen$Migrate$V419$migrate_UserColor_UserColor(old.color),
		icon: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash, old.icon),
		name: $author$project$Evergreen$Migrate$V419$migrate_PersonName_PersonName(old.name),
		teamId: $author$project$Evergreen$Migrate$V419$migrate_Slack_Id(old.teamId)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_User_FrontendCurrentUser = function (old) {
	return {
		availableCustomEmojis: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, old.availableCustomEmojis),
		availableStickers: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, old.availableStickers),
		color: $author$project$Evergreen$Migrate$V419$migrate_UserColor_UserColor(old.color),
		createdAt: old.createdAt,
		deleteAccountAt: old.deleteAccountAt,
		directMentions: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
						A2(
							$author$project$Evergreen$Migrate$V419$migrate_NonemptyDict_NonemptyDict,
							A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute),
							$author$project$Evergreen$Migrate$V419$migrate_OneOrGreater_OneOrGreater))),
				$lamdera$containers$SeqDict$fromList),
			old.directMentions),
		discordDirectMentions: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Discord_Id,
						A2(
							$author$project$Evergreen$Migrate$V419$migrate_NonemptyDict_NonemptyDict,
							A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute),
							$author$project$Evergreen$Migrate$V419$migrate_OneOrGreater_OneOrGreater))),
				$lamdera$containers$SeqDict$fromList),
			old.discordDirectMentions),
		discordNotifyOnAllMessages: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Discord_Id, old.discordNotifyOnAllMessages),
		domainWhitelist: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_RichText_Domain, old.domainWhitelist),
		e2eeRisksAccepted: old.e2eeRisksAccepted,
		email: $author$project$Evergreen$Migrate$V419$migrate_EmailAddress_EmailAddress(old.email),
		emailNotifications: $author$project$Evergreen$Migrate$V419$migrate_User_EmailNotifications(old.emailNotifications),
		embedVisibility: $author$project$Evergreen$Migrate$V419$migrate_User_EmbedVisibility(old.embedVisibility),
		emojiConfig: $author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiConfig(old.emojiConfig),
		icon: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash, old.icon),
		isAdmin: old.isAdmin,
		lastChannelViewed: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute))),
				$lamdera$containers$SeqDict$fromList),
			old.lastChannelViewed),
		lastDiscordChannelViewed: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Discord_Id,
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute))),
				$lamdera$containers$SeqDict$fromList),
			old.lastDiscordChannelViewed),
		lastDmViewed: $author$project$Evergreen$Migrate$V419$migrate_User_LastDmViewed(old.lastDmViewed),
		lastEmailNotification: old.lastEmailNotification,
		lastLogPageViewed: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.lastLogPageViewed),
		lastPushNotification: old.lastPushNotification,
		lastSlackChannelViewed: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Slack_Id,
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute))),
				$lamdera$containers$SeqDict$fromList),
			old.lastSlackChannelViewed),
		lastViewedMessage: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId, $author$project$Evergreen$Migrate$V419$migrate_Id_Id)),
				$lamdera$containers$SeqDict$fromList),
			old.lastViewedMessage),
		lastViewedThreadMessage: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId, $author$project$Evergreen$Migrate$V419$migrate_Id_Id),
						$author$project$Evergreen$Migrate$V419$migrate_Id_Id)),
				$lamdera$containers$SeqDict$fromList),
			old.lastViewedThreadMessage),
		linkDiscordAcknowledgementIsChecked: old.linkDiscordAcknowledgementIsChecked,
		linkSlackAcknowledgementIsChecked: old.linkSlackAcknowledgementIsChecked,
		muteSettings: $author$project$Evergreen$Migrate$V419$migrate_MuteSettings_Model(old.muteSettings),
		name: $author$project$Evergreen$Migrate$V419$migrate_PersonName_PersonName(old.name),
		notifyOnAllMessages: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, old.notifyOnAllMessages),
		publicKey: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_X25519_PublicKey, old.publicKey),
		recentLoginEmails: old.recentLoginEmails,
		slackDirectMentions: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Slack_Id,
						A2(
							$author$project$Evergreen$Migrate$V419$migrate_NonemptyDict_NonemptyDict,
							A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute),
							$author$project$Evergreen$Migrate$V419$migrate_OneOrGreater_OneOrGreater))),
				$lamdera$containers$SeqDict$fromList),
			old.slackDirectMentions),
		slackNotifyOnAllMessages: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Slack_Id, old.slackNotifyOnAllMessages)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_User_FrontendUser = function (old) {
	return {
		color: $author$project$Evergreen$Migrate$V419$migrate_UserColor_UserColor(old.color),
		icon: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash, old.icon),
		name: $author$project$Evergreen$Migrate$V419$migrate_PersonName_PersonName(old.name),
		publicKey: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_X25519_PublicKey, old.publicKey)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_User_LocalUser = function (old) {
	return {
		currentlyViewing: $author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing(old.currentlyViewing),
		customEmojis: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_CustomEmoji_CustomEmojiData)),
				$lamdera$containers$SeqDict$fromList),
			old.customEmojis),
		decryptedMessages: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Encryption_BytesHash,
						$elm$core$Result$map(
							A2($author$project$Evergreen$Migrate$V419$migrate_Message_MessageContent, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id)))),
				$lamdera$containers$SeqDict$fromList),
			old.decryptedMessages),
		devicePixelRatio: old.devicePixelRatio,
		discordUsers: $author$project$Evergreen$Migrate$V419$migrate_LinkedAndOtherDiscordUsers_LinkedAndOtherDiscordUsers(old.discordUsers),
		emojiData: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Emoji_CachedEmojiData, old.emojiData),
		linkedSlackUsers: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id)),
				$lamdera$containers$SeqDict$fromList),
			old.linkedSlackUsers),
		otherUsers: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_User_FrontendUser)),
				$lamdera$containers$SeqDict$fromList),
			old.otherUsers),
		safeAreaInsetBottom: old.safeAreaInsetBottom,
		safeAreaInsetTop: old.safeAreaInsetTop,
		session: $author$project$Evergreen$Migrate$V419$migrate_UserSession_UserSession(old.session),
		slackUsers: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_UserSession_SlackFrontendUser)),
				$lamdera$containers$SeqDict$fromList),
			old.slackUsers),
		slackUsersNeedingAuth: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Slack_Id, old.slackUsersNeedingAuth),
		stickers: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Sticker_StickerData)),
				$lamdera$containers$SeqDict$fromList),
			old.stickers),
		timezone: old.timezone,
		user: $author$project$Evergreen$Migrate$V419$migrate_User_FrontendCurrentUser(old.user),
		userAgent: $author$project$Evergreen$Migrate$V419$migrate_UserAgent_UserAgent(old.userAgent)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_LocalState_LocalState = function (old) {
	return {
		adminData: $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminStatus(old.adminData),
		calls: $author$project$Evergreen$Migrate$V419$migrate_Call_Local(old.calls),
		discordDmChannels: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_DmChannel_DiscordFrontendDmChannel)),
				$lamdera$containers$SeqDict$fromList),
			old.discordDmChannels),
		discordGuilds: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_DiscordFrontendGuild)),
				$lamdera$containers$SeqDict$fromList),
			old.discordGuilds),
		dmChannels: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_DmChannel_FrontendDmChannel)),
				$lamdera$containers$SeqDict$fromList),
			old.dmChannels),
		guilds: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_FrontendGuild)),
				$lamdera$containers$SeqDict$fromList),
			old.guilds),
		joinGuildError: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_LocalState_JoinGuildError, old.joinGuildError),
		localUser: $author$project$Evergreen$Migrate$V419$migrate_User_LocalUser(old.localUser),
		otherSessions: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_SessionIdHash_SessionIdHash, $author$project$Evergreen$Migrate$V419$migrate_UserSession_FrontendUserSession)),
				$lamdera$containers$SeqDict$fromList),
			old.otherSessions),
		publicVapidKey: old.publicVapidKey,
		slackDmChannels: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_SlackFrontendDmChannel)),
				$lamdera$containers$SeqDict$fromList),
			old.slackDmChannels),
		slackWorkspaces: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_SlackFrontendWorkspace)),
				$lamdera$containers$SeqDict$fromList),
			old.slackWorkspaces),
		textEditor: $author$project$Evergreen$Migrate$V419$migrate_TextEditor_LocalState(old.textEditor)
	};
};
var $author$project$Evergreen$V419$Local$Local = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Local$ChangeId = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_Local_ChangeId = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$Migrate$V419$migrate_Local_Local$ = function (migrate_msg, migrate_model, old) {
	var p0 = old;
	return {
		counter: $author$project$Evergreen$Migrate$V419$migrate_Local_ChangeId(p0.counter),
		localModel: migrate_model(p0.localModel),
		localMsgs: $elm$core$Dict$map$(
			function (k) {
				return function (rec1) {
					return {
						createdAt: rec1.createdAt,
						msg: migrate_msg(rec1.msg)
					};
				};
			},
			p0.localMsgs),
		serverModel: migrate_model(p0.serverModel)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Local_Local = F3($author$project$Evergreen$Migrate$V419$migrate_Local_Local$);
var $author$project$Evergreen$Migrate$V419$migrate_MessageInput_TextInputFocus = function (old) {
	return {
		direction: $author$project$Evergreen$Migrate$V419$migrate_Range_SelectionDirection(old.direction),
		dropdown: old.dropdown,
		htmlId: old.htmlId,
		selection: $author$project$Evergreen$Migrate$V419$migrate_Range_Range(old.selection)
	};
};
var $author$project$Evergreen$V419$Editable$Editing = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Editable$NotEditing = {$: 0};
var $author$project$Evergreen$Migrate$V419$migrate_Editable_Editing = function (old) {
	if (!old.$) {
		return $author$project$Evergreen$V419$Editable$NotEditing;
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Editable$Editing(p0);
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Editable_Model = function (old) {
	return {
		editing: $author$project$Evergreen$Migrate$V419$migrate_Editable_Editing(old.editing),
		pressedSubmit: old.pressedSubmit,
		showSecret: old.showSecret
	};
};
var $author$project$Evergreen$V419$Pages$Admin$ApiKeysSection = 10;
var $author$project$Evergreen$V419$Pages$Admin$ConnectionsSection = 12;
var $author$project$Evergreen$V419$Pages$Admin$DeletedGuildsSection = 9;
var $author$project$Evergreen$V419$Pages$Admin$DiscordDmChannelsSection = 3;
var $author$project$Evergreen$V419$Pages$Admin$DiscordGuildsSection = 5;
var $author$project$Evergreen$V419$Pages$Admin$DiscordUsersSection = 4;
var $author$project$Evergreen$V419$Pages$Admin$DmChannelsSection = 2;
var $author$project$Evergreen$V419$Pages$Admin$ExportSection = 11;
var $author$project$Evergreen$V419$Pages$Admin$FilesSection = 13;
var $author$project$Evergreen$V419$Pages$Admin$GuildsSection = 8;
var $author$project$Evergreen$V419$Pages$Admin$LogSection = 1;
var $author$project$Evergreen$V419$Pages$Admin$SessionsSection = 17;
var $author$project$Evergreen$V419$Pages$Admin$SlackDmChannelsSection = 7;
var $author$project$Evergreen$V419$Pages$Admin$SlackWorkspacesSection = 6;
var $author$project$Evergreen$V419$Pages$Admin$StickersAndEmojisSection = 15;
var $author$project$Evergreen$V419$Pages$Admin$UpdateLogsSection = 14;
var $author$project$Evergreen$V419$Pages$Admin$UsersSection = 0;
var $author$project$Evergreen$V419$Pages$Admin$WebsocketCloseEventsSection = 16;
var $author$project$Evergreen$V419$Pages$Admin$WordSpellingGameSwedishSection = 18;
var $author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_AdminUiSection = function (old) {
	switch (old) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		case 6:
			return 6;
		case 7:
			return 7;
		case 8:
			return 8;
		case 9:
			return 9;
		case 10:
			return 10;
		case 11:
			return 11;
		case 12:
			return 12;
		case 13:
			return 13;
		case 14:
			return 14;
		case 15:
			return 15;
		case 16:
			return 16;
		case 17:
			return 17;
		default:
			return 18;
	}
};
var $author$project$Evergreen$V419$Pages$Admin$ExportStarting = {$: 0};
var $author$project$Evergreen$V419$Pages$Admin$ExportingDiscordDmChannels = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$ExportingDiscordGuilds = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$ExportingDmChannels = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$ExportingGuilds = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_ExportProgress = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$Pages$Admin$ExportStarting;
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$ExportingGuilds(p0);
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$ExportingDmChannels(p0);
		case 3:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$ExportingDiscordGuilds(p0);
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$ExportingDiscordDmChannels(p0);
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_ExportSubsetSelection = function (old) {
	return {
		discordDmChannels: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Discord_Id, old.discordDmChannels),
		discordGuilds: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Discord_Id, old.discordGuilds),
		dmChannels: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_DmChannelId_DmChannelId, old.dmChannels),
		guilds: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, old.guilds)
	};
};
var $author$project$Evergreen$V419$Pages$Admin$ImportBackendFailed = {$: 1};
var $author$project$Evergreen$V419$Pages$Admin$ImportedBackendSuccessfully = {$: 3};
var $author$project$Evergreen$V419$Pages$Admin$ImportingBackend = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$NotImportingBackend = {$: 0};
var $author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_ImportBackendStatus = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$Pages$Admin$NotImportingBackend;
		case 1:
			return $author$project$Evergreen$V419$Pages$Admin$ImportBackendFailed;
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$ImportingBackend(p0);
		default:
			return $author$project$Evergreen$V419$Pages$Admin$ImportedBackendSuccessfully;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_EditedBackendUser = function (old) {
	return old;
};
var $author$project$Evergreen$V419$Pages$Admin$EmailAddressColumn = 1;
var $author$project$Evergreen$V419$Pages$Admin$NameColumn = 0;
var $author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_UserColumn = function (old) {
	if (!old) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Evergreen$V419$Pages$Admin$ExistingUserId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$NewUserId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_UserTableId = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Pages$Admin$ExistingUserId(
			$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Pages$Admin$NewUserId(p0);
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_EditingCell = function (old) {
	return {
		column: $author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_UserColumn(old.column),
		text: old.text,
		userId: $author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_UserTableId(old.userId)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Table_Model = function (old) {
	return old;
};
var $author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_UserTable = function (old) {
	return {
		changedUsers: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_EditedBackendUser)),
				$lamdera$containers$SeqDict$fromList),
			old.changedUsers),
		deletedUsers: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, old.deletedUsers),
		editingCell: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_EditingCell, old.editingCell),
		newUsers: old.newUsers,
		table: $author$project$Evergreen$Migrate$V419$migrate_Table_Model(old.table)
	};
};
var $author$project$Evergreen$V419$Pages$Admin$CantDeleteYourself = {$: 4};
var $author$project$Evergreen$V419$Pages$Admin$CantRemoveAdminRoleFromYourself = {$: 3};
var $author$project$Evergreen$V419$Pages$Admin$ChangesAppliedToNonExistentUser = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$EmailAddressesAreNotUnique = {$: 0};
var $author$project$Evergreen$V419$Pages$Admin$InvalidChangesToUser = {$: 1};
var $author$project$Evergreen$V419$Pages$Admin$InvalidNewUser = {$: 5};
var $author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_UsersChangeError = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$Pages$Admin$EmailAddressesAreNotUnique;
		case 1:
			return $author$project$Evergreen$V419$Pages$Admin$InvalidChangesToUser;
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$ChangesAppliedToNonExistentUser(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 3:
			return $author$project$Evergreen$V419$Pages$Admin$CantRemoveAdminRoleFromYourself;
		case 4:
			return $author$project$Evergreen$V419$Pages$Admin$CantDeleteYourself;
		default:
			return $author$project$Evergreen$V419$Pages$Admin$InvalidNewUser;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_Model = function (old) {
	return {
		copiedLogLink: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, old.copiedLogLink),
		discordLinkLimit: $author$project$Evergreen$Migrate$V419$migrate_Editable_Model(old.discordLinkLimit),
		downloadingBackup: old.downloadingBackup,
		expandedDiscordGuilds: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Discord_Id, old.expandedDiscordGuilds),
		expandedGuilds: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, old.expandedGuilds),
		expandedSections: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_AdminUiSection, old.expandedSections),
		expandedSlackWorkspaces: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Slack_Id, old.expandedSlackWorkspaces),
		exportProgress: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_ExportProgress, old.exportProgress),
		exportSubsetSelection: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_ExportSubsetSelection, old.exportSubsetSelection),
		highlightLog: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, old.highlightLog),
		importBackendStatus: $author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_ImportBackendStatus(old.importBackendStatus),
		notifyAdminsBotUserId: $author$project$Evergreen$Migrate$V419$migrate_Editable_Model(old.notifyAdminsBotUserId),
		notifyAdminsToken: $author$project$Evergreen$Migrate$V419$migrate_Editable_Model(old.notifyAdminsToken),
		openRouterKey: $author$project$Evergreen$Migrate$V419$migrate_Editable_Model(old.openRouterKey),
		postmarkKey: $author$project$Evergreen$Migrate$V419$migrate_Editable_Model(old.postmarkKey),
		privateVapidKey: $author$project$Evergreen$Migrate$V419$migrate_Editable_Model(old.privateVapidKey),
		publicVapidKey: $author$project$Evergreen$Migrate$V419$migrate_Editable_Model(old.publicVapidKey),
		slackLinkLimit: $author$project$Evergreen$Migrate$V419$migrate_Editable_Model(old.slackLinkLimit),
		submitError: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_UsersChangeError, old.submitError),
		userTable: $author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_UserTable(old.userTable),
		websocketCloseEventsPage: old.websocketCloseEventsPage
	};
};
var $author$project$Evergreen$V419$Route$ChannelSidebarDragging = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Route$ChannelSidebarNotDragging = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Route_ChannelSidebarMode = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Route$ChannelSidebarNotDragging(p0);
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Route$ChannelSidebarDragging(p0);
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_TextEditor_Model = function (old) {
	return old;
};
var $author$project$Evergreen$V419$TwoFactorAuthentication$TwoFactorAlreadyComplete = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V419$TwoFactorAuthentication$TwoFactorComplete = {$: 3};
var $author$project$Evergreen$V419$TwoFactorAuthentication$TwoFactorDisable$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$Evergreen$V419$TwoFactorAuthentication$TwoFactorDisable = F2($author$project$Evergreen$V419$TwoFactorAuthentication$TwoFactorDisable$);
var $author$project$Evergreen$V419$TwoFactorAuthentication$TwoFactorLoading = {$: 1};
var $author$project$Evergreen$V419$TwoFactorAuthentication$TwoFactorNotStarted = {$: 0};
var $author$project$Evergreen$V419$TwoFactorAuthentication$TwoFactorSetup = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_TwoFactorAuthentication_TwoFactorDisableData = function (old) {
	return {
		attempts: $lamdera$containers$SeqDict$map$(
			function (k) {
				return $author$project$Evergreen$Migrate$V419$migrate_LoginForm_CodeStatus;
			},
			old.attempts),
		code: old.code
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_TwoFactorAuthentication_TwoFactorSetupData = function (old) {
	return {
		attempts: $lamdera$containers$SeqDict$map$(
			function (k) {
				return $author$project$Evergreen$Migrate$V419$migrate_LoginForm_CodeStatus;
			},
			old.attempts),
		code: old.code,
		qrCodeUrl: old.qrCodeUrl
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_TwoFactorAuthentication_TwoFactorState = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$TwoFactorAuthentication$TwoFactorNotStarted;
		case 1:
			return $author$project$Evergreen$V419$TwoFactorAuthentication$TwoFactorLoading;
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$TwoFactorAuthentication$TwoFactorSetup(
				$author$project$Evergreen$Migrate$V419$migrate_TwoFactorAuthentication_TwoFactorSetupData(p0));
		case 3:
			return $author$project$Evergreen$V419$TwoFactorAuthentication$TwoFactorComplete;
		case 4:
			var p0 = old.a;
			return $author$project$Evergreen$V419$TwoFactorAuthentication$TwoFactorAlreadyComplete(p0);
		default:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$TwoFactorAuthentication$TwoFactorDisable$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_TwoFactorAuthentication_TwoFactorDisableData(p1));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_EditChannelForm = function (old) {
	return old;
};
var $author$project$Evergreen$V419$Types$ImportChannelFailed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$Types$ImportedChannel = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V419$Types$ImportingChannel = {$: 1};
var $author$project$Evergreen$V419$Types$NotImportingChannel = {$: 0};
var $author$project$Evergreen$V419$Types$NotAChannelExport = 0;
var $author$project$Evergreen$Migrate$V419$migrate_Types_ImportChannelError = function (old) {
	return 0;
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_ImportChannelStatus = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$Types$NotImportingChannel;
		case 1:
			return $author$project$Evergreen$V419$Types$ImportingChannel;
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$ImportChannelFailed(
				$author$project$Evergreen$Migrate$V419$migrate_Types_ImportChannelError(p0));
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$ImportedChannel(p0);
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_EditGuildForm = function (old) {
	return {
		deleteConfirmation: old.deleteConfirmation,
		importChannel: $author$project$Evergreen$Migrate$V419$migrate_Types_ImportChannelStatus(old.importChannel),
		name: old.name,
		pressedSubmit: old.pressedSubmit,
		showDeleteConfirmation: old.showDeleteConfirmation,
		showLeaveConfirmation: old.showLeaveConfirmation
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_EditMessage = function (old) {
	return {
		attachedFiles: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileStatus)),
				$lamdera$containers$SeqDict$fromList),
			old.attachedFiles),
		messageIndex: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.messageIndex),
		text: old.text
	};
};
var $author$project$Evergreen$V419$Types$EmojiSelectorForEditMessage$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$EmojiSelectorForEditMessage = F2($author$project$Evergreen$V419$Types$EmojiSelectorForEditMessage$);
var $author$project$Evergreen$V419$Types$EmojiSelectorForMessage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$Types$EmojiSelectorForReaction$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$EmojiSelectorForReaction = F2($author$project$Evergreen$V419$Types$EmojiSelectorForReaction$);
var $author$project$Evergreen$V419$Types$EmojiSelectorForSheepGameInput$ = function (a, b, c) {
	return {$: 4, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$EmojiSelectorForSheepGameInput = F3($author$project$Evergreen$V419$Types$EmojiSelectorForSheepGameInput$);
var $author$project$Evergreen$V419$Types$EmojiSelectorForSheepGameReaction$ = function (a, b, c) {
	return {$: 5, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$EmojiSelectorForSheepGameReaction = F3($author$project$Evergreen$V419$Types$EmojiSelectorForSheepGameReaction$);
var $author$project$Evergreen$V419$Types$EmojiSelectorForWordSpellingGameReaction$ = function (a, b, c) {
	return {$: 6, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$EmojiSelectorForWordSpellingGameReaction = F3($author$project$Evergreen$V419$Types$EmojiSelectorForWordSpellingGameReaction$);
var $author$project$Evergreen$V419$Types$EmojiSelectorHidden = {$: 0};
var $author$project$Evergreen$Migrate$V419$migrate_Types_EmojiSelector = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$Types$EmojiSelectorHidden;
		case 1:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$EmojiSelectorForReaction$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p1));
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$EmojiSelectorForMessage(p0);
		case 3:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$EmojiSelectorForEditMessage$(
				$author$project$Evergreen$Migrate$V419$migrate_Coord_Coord$($author$project$Evergreen$Migrate$V419$migrate_CssPixels_CssPixels, p0),
				p1);
		case 4:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$EmojiSelectorForSheepGameInput$(
				$author$project$Evergreen$Migrate$V419$migrate_SheepGame_Input(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Coord_Coord$($author$project$Evergreen$Migrate$V419$migrate_CssPixels_CssPixels, p1),
				p2);
		case 5:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$EmojiSelectorForSheepGameReaction$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_GuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_SheepGame_ReactionTarget(p2));
		default:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$EmojiSelectorForWordSpellingGameReaction$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_GuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_ReactionTarget(p2));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_PendingDecryptedManyMessages = function (old) {
	return {
		messageHashes: $elm$core$List$map$($author$project$Evergreen$Migrate$V419$migrate_Encryption_BytesHash, old.messageHashes),
		shiftScrollFrom: old.shiftScrollFrom
	};
};
var $author$project$Evergreen$V419$Message$NoThreadWithRepliedTo = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Message$ViewThreadWithRepliedTo$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V419$Message$ViewThreadWithRepliedTo = F2($author$project$Evergreen$V419$Message$ViewThreadWithRepliedTo$);
var $author$project$Evergreen$Migrate$V419$migrate_Message_ThreadRouteWithRepliedTo = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Message$NoThreadWithRepliedTo(
			$author$project$Evergreen$Migrate$V419$migrate_Message_RepliedTo$($author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, p0));
	} else {
		var p0 = old.a;
		var p1 = old.b;
		return $author$project$Evergreen$V419$Message$ViewThreadWithRepliedTo$(
			$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
			$elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, p1));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_PendingDecryptedMessage = function (old) {
	return {
		hash: $author$project$Evergreen$Migrate$V419$migrate_Encryption_BytesHash(old.hash),
		id: $author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DmId(old.id),
		senderId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.senderId),
		threadRoute: $author$project$Evergreen$Migrate$V419$migrate_Message_ThreadRouteWithRepliedTo(old.threadRoute)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_PendingDecryptedOldMessages = function (old) {
	return {
		id: $author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DmId(old.id),
		messages: $elm$core$List$map$($author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage, old.messages)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_PendingEncryptedEdit = function (old) {
	return {
		contentAndEmbeds: $author$project$Evergreen$Migrate$V419$migrate_Message_MessageContent$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, old.contentAndEmbeds),
		id: $author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DmId(old.id),
		threadRoute: $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(old.threadRoute)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_PendingEncryptedFile = function (old) {
	return {
		fileId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.fileId),
		guildOrDmId: $elm$core$Tuple$mapBoth$($author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute, old.guildOrDmId)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_PendingEncryptedManyMessages = function (old) {
	return {
		id: $author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DmId(old.id),
		messages: $elm$core$List$map$(
			A2(
				$elm$core$Tuple$mapBoth,
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage,
				A2($author$project$Evergreen$Migrate$V419$migrate_Message_MessageContent, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id)),
			old.messages)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_PendingEncryptedMessage = function (old) {
	return {
		contentAndEmbeds: $author$project$Evergreen$Migrate$V419$migrate_Message_MessageContent$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, old.contentAndEmbeds),
		otherUserId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.otherUserId),
		threadRoute: $author$project$Evergreen$Migrate$V419$migrate_Message_ThreadRouteWithRepliedTo(old.threadRoute)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_EncryptionRequests = function (old) {
	return {
		nextDecryptManyRequestId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.nextDecryptManyRequestId),
		nextDecryptionRequestId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.nextDecryptionRequestId),
		nextEncryptFileRequestId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.nextEncryptFileRequestId),
		nextEncryptManyRequestId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.nextEncryptManyRequestId),
		nextEncryptionRequestId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(old.nextEncryptionRequestId),
		pendingDecryptedManyMessages: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Types_PendingDecryptedManyMessages)),
				$lamdera$containers$SeqDict$fromList),
			old.pendingDecryptedManyMessages),
		pendingDecryptedMessages: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Types_PendingDecryptedMessage)),
				$lamdera$containers$SeqDict$fromList),
			old.pendingDecryptedMessages),
		pendingDecryptedOldMessages: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Types_PendingDecryptedOldMessages)),
				$lamdera$containers$SeqDict$fromList),
			old.pendingDecryptedOldMessages),
		pendingEncryptedEdits: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Types_PendingEncryptedEdit)),
				$lamdera$containers$SeqDict$fromList),
			old.pendingEncryptedEdits),
		pendingEncryptedFiles: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Types_PendingEncryptedFile)),
				$lamdera$containers$SeqDict$fromList),
			old.pendingEncryptedFiles),
		pendingEncryptedManyMessages: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Types_PendingEncryptedManyMessages)),
				$lamdera$containers$SeqDict$fromList),
			old.pendingEncryptedManyMessages),
		pendingEncryptedMessages: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Types_PendingEncryptedMessage)),
				$lamdera$containers$SeqDict$fromList),
			old.pendingEncryptedMessages)
	};
};
var $author$project$Evergreen$V419$Types$FileDragging$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$FileDragging = F2($author$project$Evergreen$V419$Types$FileDragging$);
var $author$project$Evergreen$V419$Types$NoFileDrag = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_FileDrag = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Types$NoFileDrag(p0);
	} else {
		var p0 = old.a;
		var p1 = old.b;
		return $author$project$Evergreen$V419$Types$FileDragging$(
			p0,
			$author$project$Evergreen$Migrate$V419$migrate_OneOrGreater_OneOrGreater(p1));
	}
};
var $author$project$Evergreen$V419$Types$LocalChange$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$LocalChange = F2($author$project$Evergreen$V419$Types$LocalChange$);
var $author$project$Evergreen$V419$Types$ServerChange = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Types$Local_AcceptE2ee$ = function (a, b, c) {
	return {$: 76, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Local_AcceptE2ee = F3($author$project$Evergreen$V419$Types$Local_AcceptE2ee$);
var $author$project$Evergreen$V419$Types$Local_AddCustomEmojisToUser = function (a) {
	return {$: 55, a: a};
};
var $author$project$Evergreen$V419$Types$Local_AddReactionEmoji$ = function (a, b, c) {
	return {$: 19, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Local_AddReactionEmoji = F3($author$project$Evergreen$V419$Types$Local_AddReactionEmoji$);
var $author$project$Evergreen$V419$Types$Local_Admin = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Types$Local_BanMember$ = function (a, b) {
	return {$: 16, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Local_BanMember = F2($author$project$Evergreen$V419$Types$Local_BanMember$);
var $author$project$Evergreen$V419$Types$Local_CancelAccountDeletion = {$: 45};
var $author$project$Evergreen$V419$Types$Local_CollapseUserOptionSection = function (a) {
	return {$: 40, a: a};
};
var $author$project$Evergreen$V419$Types$Local_CurrentlyViewing$ = function (a, b) {
	return {$: 27, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Local_CurrentlyViewing = F2($author$project$Evergreen$V419$Types$Local_CurrentlyViewing$);
var $author$project$Evergreen$V419$Types$Local_DeclineE2eeRequest = function (a) {
	return {$: 70, a: a};
};
var $author$project$Evergreen$V419$Types$Local_DeclineE2eeRequestAsInitiator = function (a) {
	return {$: 69, a: a};
};
var $author$project$Evergreen$V419$Types$Local_DecryptOldMessages$ = function (a, b, c) {
	return {$: 74, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Local_DecryptOldMessages = F3($author$project$Evergreen$V419$Types$Local_DecryptOldMessages$);
var $author$project$Evergreen$V419$Types$Local_DeleteChannel$ = function (a, b) {
	return {$: 10, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Local_DeleteChannel = F2($author$project$Evergreen$V419$Types$Local_DeleteChannel$);
var $author$project$Evergreen$V419$Types$Local_DeleteGuild = function (a) {
	return {$: 12, a: a};
};
var $author$project$Evergreen$V419$Types$Local_DeleteInviteLink$ = function (a, b) {
	return {$: 15, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Local_DeleteInviteLink = F2($author$project$Evergreen$V419$Types$Local_DeleteInviteLink$);
var $author$project$Evergreen$V419$Types$Local_DeleteMessage$ = function (a, b) {
	return {$: 26, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Local_DeleteMessage = F2($author$project$Evergreen$V419$Types$Local_DeleteMessage$);
var $author$project$Evergreen$V419$Types$Local_DisableE2ee$ = function (a, b) {
	return {$: 73, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Local_DisableE2ee = F2($author$project$Evergreen$V419$Types$Local_DisableE2ee$);
var $author$project$Evergreen$V419$Types$Local_Discord_LoadChannelMessages$ = function (a, b, c) {
	return {$: 33, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Local_Discord_LoadChannelMessages = F3($author$project$Evergreen$V419$Types$Local_Discord_LoadChannelMessages$);
var $author$project$Evergreen$V419$Types$Local_Discord_LoadThreadMessages$ = function (a, b, c, d) {
	return {$: 34, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$Local_Discord_LoadThreadMessages = F4($author$project$Evergreen$V419$Types$Local_Discord_LoadThreadMessages$);
var $author$project$Evergreen$V419$Types$Local_Discord_SendEditDmMessage$ = function (a, b, c, d, e) {
	return {$: 23, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V419$Types$Local_Discord_SendEditDmMessage = F5($author$project$Evergreen$V419$Types$Local_Discord_SendEditDmMessage$);
var $author$project$Evergreen$V419$Types$Local_Discord_SendEditGuildMessage$ = function (a, b, c, d, e, f, g) {
	return {$: 22, a: a, b: b, c: c, d: d, e: e, f: f, g: g};
};
var $author$project$Evergreen$V419$Types$Local_Discord_SendEditGuildMessage = F7($author$project$Evergreen$V419$Types$Local_Discord_SendEditGuildMessage$);
var $author$project$Evergreen$V419$Types$Local_Discord_SendMessage$ = function (a, b, c, d, e, f) {
	return {$: 3, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Evergreen$V419$Types$Local_Discord_SendMessage = F6($author$project$Evergreen$V419$Types$Local_Discord_SendMessage$);
var $author$project$Evergreen$V419$Types$Local_Drawing$ = function (a, b, c) {
	return {$: 58, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Local_Drawing = F3($author$project$Evergreen$V419$Types$Local_Drawing$);
var $author$project$Evergreen$V419$Types$Local_EditChannel$ = function (a, b, c, d) {
	return {$: 9, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$Local_EditChannel = F4($author$project$Evergreen$V419$Types$Local_EditChannel$);
var $author$project$Evergreen$V419$Types$Local_EditGuildName$ = function (a, b) {
	return {$: 11, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Local_EditGuildName = F2($author$project$Evergreen$V419$Types$Local_EditGuildName$);
var $author$project$Evergreen$V419$Types$Local_EncryptOldMessages$ = function (a, b) {
	return {$: 72, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Local_EncryptOldMessages = F2($author$project$Evergreen$V419$Types$Local_EncryptOldMessages$);
var $author$project$Evergreen$V419$Types$Local_ExpandUserOptionSection$ = function (a, b) {
	return {$: 39, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Local_ExpandUserOptionSection = F2($author$project$Evergreen$V419$Types$Local_ExpandUserOptionSection$);
var $author$project$Evergreen$V419$Types$Local_Game$ = function (a, b) {
	return {$: 57, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Local_Game = F2($author$project$Evergreen$V419$Types$Local_Game$);
var $author$project$Evergreen$V419$Types$Local_Invalid = {$: 0};
var $author$project$Evergreen$V419$Types$Local_LeaveGuild = function (a) {
	return {$: 13, a: a};
};
var $author$project$Evergreen$V419$Types$Local_LinkDiscordAcknowledgementIsChecked = function (a) {
	return {$: 50, a: a};
};
var $author$project$Evergreen$V419$Types$Local_LinkSlackAcknowledgementIsChecked = function (a) {
	return {$: 51, a: a};
};
var $author$project$Evergreen$V419$Types$Local_LoadChannelMessages$ = function (a, b, c) {
	return {$: 29, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Local_LoadChannelMessages = F3($author$project$Evergreen$V419$Types$Local_LoadChannelMessages$);
var $author$project$Evergreen$V419$Types$Local_LoadThreadMessages$ = function (a, b, c, d) {
	return {$: 30, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$Local_LoadThreadMessages = F4($author$project$Evergreen$V419$Types$Local_LoadThreadMessages$);
var $author$project$Evergreen$V419$Types$Local_MemberEditTyping$ = function (a, b, c) {
	return {$: 24, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Local_MemberEditTyping = F3($author$project$Evergreen$V419$Types$Local_MemberEditTyping$);
var $author$project$Evergreen$V419$Types$Local_MemberTyping$ = function (a, b) {
	return {$: 18, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Local_MemberTyping = F2($author$project$Evergreen$V419$Types$Local_MemberTyping$);
var $author$project$Evergreen$V419$Types$Local_NewChannel$ = function (a, b, c, d) {
	return {$: 8, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$Local_NewChannel = F4($author$project$Evergreen$V419$Types$Local_NewChannel$);
var $author$project$Evergreen$V419$Types$Local_NewGuild$ = function (a, b, c) {
	return {$: 17, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Local_NewGuild = F3($author$project$Evergreen$V419$Types$Local_NewGuild$);
var $author$project$Evergreen$V419$Types$Local_NewInviteLink$ = function (a, b, c) {
	return {$: 14, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Local_NewInviteLink = F3($author$project$Evergreen$V419$Types$Local_NewInviteLink$);
var $author$project$Evergreen$V419$Types$Local_RegisterPushSubscription$ = function (a, b) {
	return {$: 46, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Local_RegisterPushSubscription = F2($author$project$Evergreen$V419$Types$Local_RegisterPushSubscription$);
var $author$project$Evergreen$V419$Types$Local_RemoveReactionEmoji$ = function (a, b, c) {
	return {$: 20, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Local_RemoveReactionEmoji = F3($author$project$Evergreen$V419$Types$Local_RemoveReactionEmoji$);
var $author$project$Evergreen$V419$Types$Local_RequestE2ee = function (a) {
	return {$: 68, a: a};
};
var $author$project$Evergreen$V419$Types$Local_ScheduleAccountDeletion = function (a) {
	return {$: 44, a: a};
};
var $author$project$Evergreen$V419$Types$Local_SendEditMessage$ = function (a, b, c, d, e, f) {
	return {$: 21, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Evergreen$V419$Types$Local_SendEditMessage = F6($author$project$Evergreen$V419$Types$Local_SendEditMessage$);
var $author$project$Evergreen$V419$Types$Local_SendEncryptedEditMessage$ = function (a, b, c, d, e) {
	return {$: 78, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V419$Types$Local_SendEncryptedEditMessage = F5($author$project$Evergreen$V419$Types$Local_SendEncryptedEditMessage$);
var $author$project$Evergreen$V419$Types$Local_SendEncryptedMessage$ = function (a, b, c, d, e, f) {
	return {$: 77, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Evergreen$V419$Types$Local_SendEncryptedMessage = F6($author$project$Evergreen$V419$Types$Local_SendEncryptedMessage$);
var $author$project$Evergreen$V419$Types$Local_SendMessage$ = function (a, b, c, d, e, f, g) {
	return {$: 2, a: a, b: b, c: c, d: d, e: e, f: f, g: g};
};
var $author$project$Evergreen$V419$Types$Local_SendMessage = F7($author$project$Evergreen$V419$Types$Local_SendMessage$);
var $author$project$Evergreen$V419$Types$Local_SetDiscordGuildNotificationLevel$ = function (a, b, c) {
	return {$: 36, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Local_SetDiscordGuildNotificationLevel = F3($author$project$Evergreen$V419$Types$Local_SetDiscordGuildNotificationLevel$);
var $author$project$Evergreen$V419$Types$Local_SetDomainWhitelist$ = function (a, b) {
	return {$: 52, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Local_SetDomainWhitelist = F2($author$project$Evergreen$V419$Types$Local_SetDomainWhitelist$);
var $author$project$Evergreen$V419$Types$Local_SetE2eeRisksAccepted = function (a) {
	return {$: 75, a: a};
};
var $author$project$Evergreen$V419$Types$Local_SetEmailNotifications = function (a) {
	return {$: 42, a: a};
};
var $author$project$Evergreen$V419$Types$Local_SetEmbedVisibility = function (a) {
	return {$: 43, a: a};
};
var $author$project$Evergreen$V419$Types$Local_SetEmojiSkinTone = function (a) {
	return {$: 53, a: a};
};
var $author$project$Evergreen$V419$Types$Local_SetGuildNotificationLevel$ = function (a, b) {
	return {$: 35, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Local_SetGuildNotificationLevel = F2($author$project$Evergreen$V419$Types$Local_SetGuildNotificationLevel$);
var $author$project$Evergreen$V419$Types$Local_SetLastViewed$ = function (a, b) {
	return {$: 25, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Local_SetLastViewed = F2($author$project$Evergreen$V419$Types$Local_SetLastViewed$);
var $author$project$Evergreen$V419$Types$Local_SetMuteChannel$ = function (a, b, c) {
	return {$: 59, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Local_SetMuteChannel = F3($author$project$Evergreen$V419$Types$Local_SetMuteChannel$);
var $author$project$Evergreen$V419$Types$Local_SetMuteDiscordChannel$ = function (a, b, c, d) {
	return {$: 61, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$Local_SetMuteDiscordChannel = F4($author$project$Evergreen$V419$Types$Local_SetMuteDiscordChannel$);
var $author$project$Evergreen$V419$Types$Local_SetMuteDiscordGuild$ = function (a, b, c) {
	return {$: 64, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Local_SetMuteDiscordGuild = F3($author$project$Evergreen$V419$Types$Local_SetMuteDiscordGuild$);
var $author$project$Evergreen$V419$Types$Local_SetMuteDiscordThread$ = function (a, b, c, d, e) {
	return {$: 62, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V419$Types$Local_SetMuteDiscordThread = F5($author$project$Evergreen$V419$Types$Local_SetMuteDiscordThread$);
var $author$project$Evergreen$V419$Types$Local_SetMuteGuild$ = function (a, b) {
	return {$: 63, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Local_SetMuteGuild = F2($author$project$Evergreen$V419$Types$Local_SetMuteGuild$);
var $author$project$Evergreen$V419$Types$Local_SetMuteSlackChannel$ = function (a, b, c, d) {
	return {$: 66, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$Local_SetMuteSlackChannel = F4($author$project$Evergreen$V419$Types$Local_SetMuteSlackChannel$);
var $author$project$Evergreen$V419$Types$Local_SetMuteSlackThread$ = function (a, b, c, d, e) {
	return {$: 67, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V419$Types$Local_SetMuteSlackThread = F5($author$project$Evergreen$V419$Types$Local_SetMuteSlackThread$);
var $author$project$Evergreen$V419$Types$Local_SetMuteSlackWorkspace$ = function (a, b, c) {
	return {$: 65, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Local_SetMuteSlackWorkspace = F3($author$project$Evergreen$V419$Types$Local_SetMuteSlackWorkspace$);
var $author$project$Evergreen$V419$Types$Local_SetMuteThread$ = function (a, b, c, d) {
	return {$: 60, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$Local_SetMuteThread = F4($author$project$Evergreen$V419$Types$Local_SetMuteThread$);
var $author$project$Evergreen$V419$Types$Local_SetName = function (a) {
	return {$: 28, a: a};
};
var $author$project$Evergreen$V419$Types$Local_SetNotificationMode = function (a) {
	return {$: 38, a: a};
};
var $author$project$Evergreen$V419$Types$Local_SetPublicKey$ = function (a, b) {
	return {$: 71, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Local_SetPublicKey = F2($author$project$Evergreen$V419$Types$Local_SetPublicKey$);
var $author$project$Evergreen$V419$Types$Local_SetSheepGameQuestions = function (a) {
	return {$: 41, a: a};
};
var $author$project$Evergreen$V419$Types$Local_SetSlackWorkspaceNotificationLevel$ = function (a, b, c) {
	return {$: 37, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Local_SetSlackWorkspaceNotificationLevel = F3($author$project$Evergreen$V419$Types$Local_SetSlackWorkspaceNotificationLevel$);
var $author$project$Evergreen$V419$Types$Local_SetUserColor = function (a) {
	return {$: 54, a: a};
};
var $author$project$Evergreen$V419$Types$Local_Slack_LoadChannelMessages$ = function (a, b, c) {
	return {$: 31, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Local_Slack_LoadChannelMessages = F3($author$project$Evergreen$V419$Types$Local_Slack_LoadChannelMessages$);
var $author$project$Evergreen$V419$Types$Local_Slack_LoadThreadMessages$ = function (a, b, c, d) {
	return {$: 32, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$Local_Slack_LoadThreadMessages = F4($author$project$Evergreen$V419$Types$Local_Slack_LoadThreadMessages$);
var $author$project$Evergreen$V419$Types$Local_Slack_ReloadUser = function (a) {
	return {$: 7, a: a};
};
var $author$project$Evergreen$V419$Types$Local_Slack_SendEditMessage$ = function (a, b, c, d, e) {
	return {$: 5, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V419$Types$Local_Slack_SendEditMessage = F5($author$project$Evergreen$V419$Types$Local_Slack_SendEditMessage$);
var $author$project$Evergreen$V419$Types$Local_Slack_SendMessage$ = function (a, b, c, d, e, f) {
	return {$: 4, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Evergreen$V419$Types$Local_Slack_SendMessage = F6($author$project$Evergreen$V419$Types$Local_Slack_SendMessage$);
var $author$project$Evergreen$V419$Types$Local_Slack_UnlinkUser = function (a) {
	return {$: 6, a: a};
};
var $author$project$Evergreen$V419$Types$Local_StartReloadingDiscordUser$ = function (a, b) {
	return {$: 49, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Local_StartReloadingDiscordUser = F2($author$project$Evergreen$V419$Types$Local_StartReloadingDiscordUser$);
var $author$project$Evergreen$V419$Types$Local_TextEditor = function (a) {
	return {$: 47, a: a};
};
var $author$project$Evergreen$V419$Types$Local_UnlinkDiscordUser = function (a) {
	return {$: 48, a: a};
};
var $author$project$Evergreen$V419$Types$Local_VoiceChatChange = function (a) {
	return {$: 56, a: a};
};
var $author$project$Evergreen$V419$Call$Local_AnswerRecording = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V419$Call$Local_CancelRecording = {$: 4};
var $author$project$Evergreen$V419$Call$Local_Leave = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Call$Local_RequestRecording = {$: 2};
var $author$project$Evergreen$V419$Call$Local_SetRemoteCallData = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Call_LocalChange = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Call$Local_Leave(p0);
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Call$Local_SetRemoteCallData(
				$author$project$Evergreen$Migrate$V419$migrate_Call_RemoteCallData(p0));
		case 2:
			return $author$project$Evergreen$V419$Call$Local_RequestRecording;
		case 3:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Call$Local_AnswerRecording(p0);
		default:
			return $author$project$Evergreen$V419$Call$Local_CancelRecording;
	}
};
var $author$project$Evergreen$V419$Game$GameData_Go$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$Game$GameData_Go = F2($author$project$Evergreen$V419$Game$GameData_Go$);
var $author$project$Evergreen$V419$Game$GameData_SheepGame$ = function (a, b, c) {
	return {$: 2, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Game$GameData_SheepGame = F3($author$project$Evergreen$V419$Game$GameData_SheepGame$);
var $author$project$Evergreen$V419$Game$GameData_WordSpellingGame$ = function (a, b, c) {
	return {$: 1, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Game$GameData_WordSpellingGame = F3($author$project$Evergreen$V419$Game$GameData_WordSpellingGame$);
var $author$project$Evergreen$Migrate$V419$migrate_Game_BackendGameData = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Game$GameData_Go$(
				$author$project$Evergreen$Migrate$V419$migrate_Go_ValidatedSetup(p0),
				$elm$core$Array$map$($author$project$Evergreen$Migrate$V419$migrate_Go_ActionWithTime, p1));
		case 1:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Game$GameData_WordSpellingGame$(
				$author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_ValidatedSetup(p0),
				$elm$core$Array$map$($author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_ActionWithTime, p1),
				$author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_Shared(p2));
		default:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Game$GameData_SheepGame$(
				$author$project$Evergreen$Migrate$V419$migrate_SheepGame_ValidatedSetup(p0),
				$elm$core$Array$map$($author$project$Evergreen$Migrate$V419$migrate_SheepGame_ActionWithTime, p1),
				$author$project$Evergreen$Migrate$V419$migrate_SheepGame_Shared(p2));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Game_LoadedMatch = function (old) {
	return {
		gameData: $author$project$Evergreen$Migrate$V419$migrate_Game_BackendGameData(old.gameData),
		publicLink: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_SecretId_SecretId, old.publicLink)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_DmChannel_LoadedMessages = function (old) {
	return {
		messages: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
						A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, $author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id))),
				$lamdera$containers$SeqDict$fromList),
			old.messages),
		repliedToMatches: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Game_LoadedMatch)),
				$lamdera$containers$SeqDict$fromList),
			old.repliedToMatches)
	};
};
var $author$project$Evergreen$V419$Drawing$ContinueStroke = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Drawing$EndStroke = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$Drawing$RedoStroke = {$: 4};
var $author$project$Evergreen$V419$Drawing$StartStroke = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Drawing$UndoStroke = {$: 3};
var $author$project$Evergreen$Migrate$V419$migrate_Drawing_LocalChange = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Drawing$StartStroke(
				$elm$core$Tuple$mapBoth$($author$project$Evergreen$Migrate$V419$migrate_SafeFloat_SafeFloat, $author$project$Evergreen$Migrate$V419$migrate_SafeFloat_SafeFloat, p0));
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Drawing$ContinueStroke(
				$author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty$(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_SafeFloat_SafeFloat, $author$project$Evergreen$Migrate$V419$migrate_SafeFloat_SafeFloat),
					p0));
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Drawing$EndStroke(
				$elm$core$List$map$(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_SafeFloat_SafeFloat, $author$project$Evergreen$Migrate$V419$migrate_SafeFloat_SafeFloat),
					p0));
		case 3:
			return $author$project$Evergreen$V419$Drawing$UndoStroke;
		default:
			return $author$project$Evergreen$V419$Drawing$RedoStroke;
	}
};
var $author$project$Evergreen$V419$Game$CreatePublicLink$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$Game$CreatePublicLink = F2($author$project$Evergreen$V419$Game$CreatePublicLink$);
var $author$project$Evergreen$V419$Game$LoadMatch$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V419$Game$LoadMatch = F2($author$project$Evergreen$V419$Game$LoadMatch$);
var $author$project$Evergreen$V419$Game$LocalChange_Go$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V419$Game$LocalChange_Go = F2($author$project$Evergreen$V419$Game$LocalChange_Go$);
var $author$project$Evergreen$V419$Game$LocalChange_SheepGame$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $author$project$Evergreen$V419$Game$LocalChange_SheepGame = F2($author$project$Evergreen$V419$Game$LocalChange_SheepGame$);
var $author$project$Evergreen$V419$Game$LocalChange_WordSpellingGame$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Evergreen$V419$Game$LocalChange_WordSpellingGame = F2($author$project$Evergreen$V419$Game$LocalChange_WordSpellingGame$);
var $author$project$Evergreen$V419$Go$Action = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Go$StartMatch$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$Go$StartMatch = F2($author$project$Evergreen$V419$Go$StartMatch$);
var $author$project$Evergreen$Migrate$V419$migrate_Go_LocalChange = function (old) {
	if (!old.$) {
		var p0 = old.a;
		var p1 = old.b;
		return $author$project$Evergreen$V419$Go$StartMatch$(
			p0,
			$author$project$Evergreen$Migrate$V419$migrate_Go_ValidatedSetup(p1));
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Go$Action(
			$author$project$Evergreen$Migrate$V419$migrate_Go_ActionWithTime(p0));
	}
};
var $author$project$Evergreen$V419$SheepGame$Action = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$SheepGame$StartMatch$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$SheepGame$StartMatch = F2($author$project$Evergreen$V419$SheepGame$StartMatch$);
var $author$project$Evergreen$Migrate$V419$migrate_SheepGame_LocalChange = function (old) {
	if (!old.$) {
		var p0 = old.a;
		var p1 = old.b;
		return $author$project$Evergreen$V419$SheepGame$StartMatch$(
			p0,
			$author$project$Evergreen$Migrate$V419$migrate_SheepGame_ValidatedSetup(p1));
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$SheepGame$Action(
			$author$project$Evergreen$Migrate$V419$migrate_SheepGame_ActionWithTime(p0));
	}
};
var $author$project$Evergreen$V419$WordSpellingGame$Action = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$WordSpellingGame$StartMatch$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$WordSpellingGame$StartMatch = F2($author$project$Evergreen$V419$WordSpellingGame$StartMatch$);
var $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_LocalChange = function (old) {
	if (!old.$) {
		var p0 = old.a;
		var p1 = old.b;
		return $author$project$Evergreen$V419$WordSpellingGame$StartMatch$(
			p0,
			$author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_ValidatedSetup(p1));
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$WordSpellingGame$Action(
			$author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_ActionWithTime(p0));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Game_LocalChange = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Game$CreatePublicLink$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$($author$project$Evergreen$Migrate$V419$migrate_SecretId_SecretId, p1));
		case 1:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Game$LoadMatch$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$($author$project$Evergreen$Migrate$V419$migrate_Game_LoadedMatch, p1));
		case 2:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Game$LocalChange_Go$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Go_LocalChange(p1));
		case 3:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Game$LocalChange_WordSpellingGame$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_LocalChange(p1));
		default:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Game$LocalChange_SheepGame$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_SheepGame_LocalChange(p1));
	}
};
var $author$project$Evergreen$V419$Pages$Admin$ChangeUsers = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$DeleteDiscordDmChannel = function (a) {
	return {$: 28, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$DeleteDiscordGuild = function (a) {
	return {$: 29, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$DeleteGuild = function (a) {
	return {$: 32, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$DeleteOrphanedFiles = function (a) {
	return {$: 40, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$DeleteSession = function (a) {
	return {$: 38, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$DeleteSlackDmChannel = function (a) {
	return {$: 31, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$DeleteSlackWorkspace = function (a) {
	return {$: 30, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$DisconnectClient$ = function (a, b) {
	return {$: 37, a: a, b: b};
};
var $author$project$Evergreen$V419$Pages$Admin$DisconnectClient = F2($author$project$Evergreen$V419$Pages$Admin$DisconnectClient$);
var $author$project$Evergreen$V419$Pages$Admin$LoadBackendMsgLogs = function (a) {
	return {$: 15, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$LoadDeletedGuilds = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$LoadDiscordDmChannels = function (a) {
	return {$: 7, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$LoadDiscordGuilds = function (a) {
	return {$: 6, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$LoadDiscordUsers = function (a) {
	return {$: 8, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$LoadDmChannels = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$LoadGuilds = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$LoadOrphanedFiles = function (a) {
	return {$: 13, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$LoadSessions = function (a) {
	return {$: 11, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$LoadSlackDmChannels = function (a) {
	return {$: 10, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$LoadSlackWorkspaces = function (a) {
	return {$: 9, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$LoadToBackendLogs = function (a) {
	return {$: 14, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$LoadUsers = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$LoadWebsocketCloseEvents = function (a) {
	return {$: 12, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$LogPageChanged$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V419$Pages$Admin$LogPageChanged = F2($author$project$Evergreen$V419$Pages$Admin$LogPageChanged$);
var $author$project$Evergreen$V419$Pages$Admin$RegenerateServerSecret = function (a) {
	return {$: 39, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$ReloadDiscordGuild$ = function (a, b, c) {
	return {$: 36, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Pages$Admin$ReloadDiscordGuild = F3($author$project$Evergreen$V419$Pages$Admin$ReloadDiscordGuild$);
var $author$project$Evergreen$V419$Pages$Admin$RestoreGuild = function (a) {
	return {$: 33, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$SetDiscordLinkLimit = function (a) {
	return {$: 19, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$SetDiscordLinkingEnabled = function (a) {
	return {$: 18, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$SetEmailNotificationsEnabled = function (a) {
	return {$: 16, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$SetNotifyAdminsBotUserId = function (a) {
	return {$: 26, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$SetNotifyAdminsToken = function (a) {
	return {$: 25, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$SetOpenRouterKey = function (a) {
	return {$: 24, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$SetPostmarkKey = function (a) {
	return {$: 27, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$SetPrivateVapidKey = function (a) {
	return {$: 22, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$SetPublicVapidKey = function (a) {
	return {$: 23, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$SetSignupsEnabled = function (a) {
	return {$: 17, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$SetSlackLinkLimit = function (a) {
	return {$: 21, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$SetSlackLinkingEnabled = function (a) {
	return {$: 20, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$StartReloadingDiscordDmChannel$ = function (a, b, c) {
	return {$: 35, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Pages$Admin$StartReloadingDiscordDmChannel = F3($author$project$Evergreen$V419$Pages$Admin$StartReloadingDiscordDmChannel$);
var $author$project$Evergreen$V419$Pages$Admin$StartReloadingDiscordGuildChannel$ = function (a, b, c, d) {
	return {$: 34, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Pages$Admin$StartReloadingDiscordGuildChannel = F4($author$project$Evergreen$V419$Pages$Admin$StartReloadingDiscordGuildChannel$);
var $author$project$Evergreen$Migrate$V419$migrate_Discord_RoleColors = function (old) {
	return old;
};
var $author$project$Evergreen$Migrate$V419$migrate_Discord_RoleTags = function (old) {
	return {
		availableForPurchase: old.availableForPurchase,
		botId: $author$project$Evergreen$Migrate$V419$migrate_Discord_OptionalData$($author$project$Evergreen$Migrate$V419$migrate_Discord_Id, old.botId),
		guildConnections: old.guildConnections,
		integrationId: $author$project$Evergreen$Migrate$V419$migrate_Discord_OptionalData$($author$project$Evergreen$Migrate$V419$migrate_Discord_Id, old.integrationId),
		premiumSubscriber: old.premiumSubscriber,
		subscriptionListingId: $author$project$Evergreen$Migrate$V419$migrate_Discord_OptionalData$($author$project$Evergreen$Migrate$V419$migrate_Discord_Id, old.subscriptionListingId)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Discord_Role = function (old) {
	return {
		colors: $author$project$Evergreen$Migrate$V419$migrate_Discord_OptionalData$($author$project$Evergreen$Migrate$V419$migrate_Discord_RoleColors, old.colors),
		description: old.description,
		flags: $author$project$Evergreen$Migrate$V419$migrate_Discord_OptionalData$($elm$core$Basics$identity, old.flags),
		hoist: old.hoist,
		icon: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Discord_ImageHash, old.icon),
		id: $author$project$Evergreen$Migrate$V419$migrate_Discord_Id(old.id),
		managed: old.managed,
		mentionable: old.mentionable,
		name: old.name,
		permissions: $author$project$Evergreen$Migrate$V419$migrate_Discord_Permissions(old.permissions),
		position: old.position,
		tags: $author$project$Evergreen$Migrate$V419$migrate_Discord_OptionalData$($author$project$Evergreen$Migrate$V419$migrate_Discord_RoleTags, old.tags),
		unicodeEmoji: old.unicodeEmoji
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_AdminChange = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$ChangeUsers(
				{
					changedUsers: $elm$core$Basics$composeR$(
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_EditedBackendUser)),
							$lamdera$containers$SeqDict$fromList),
						p0.changedUsers),
					deletedUsers: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, p0.deletedUsers),
					newUsers: p0.newUsers,
					time: p0.time
				});
		case 1:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Pages$Admin$LogPageChanged$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					$elm$core$Array$map($author$project$Evergreen$Migrate$V419$migrate_LocalState_LogWithTime),
					p1));
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$LoadUsers(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					A2($author$project$Evergreen$Migrate$V419$migrate_NonemptyDict_NonemptyDict, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_User_BackendUser),
					p0));
		case 3:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$LoadGuilds(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					A2(
						$elm$core$Basics$composeR,
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminData_Guild)),
							$lamdera$containers$SeqDict$fromList)),
					p0));
		case 4:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$LoadDeletedGuilds(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					A2(
						$elm$core$Basics$composeR,
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminData_DeletedGuild)),
							$lamdera$containers$SeqDict$fromList)),
					p0));
		case 5:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$LoadDmChannels(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					A2(
						$elm$core$Basics$composeR,
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_DmChannelId_DmChannelId, $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminData_DmChannel)),
							$lamdera$containers$SeqDict$fromList)),
					p0));
		case 6:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$LoadDiscordGuilds(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					A2(
						$elm$core$Basics$composeR,
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminData_DiscordGuild)),
							$lamdera$containers$SeqDict$fromList)),
					p0));
		case 7:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$LoadDiscordDmChannels(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					A2(
						$elm$core$Basics$composeR,
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminData_DiscordDmChannel)),
							$lamdera$containers$SeqDict$fromList)),
					p0));
		case 8:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$LoadDiscordUsers(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					A2(
						$elm$core$Basics$composeR,
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_DiscordUserData_ForAdmin)),
							$lamdera$containers$SeqDict$fromList)),
					p0));
		case 9:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$LoadSlackWorkspaces(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					A2(
						$elm$core$Basics$composeR,
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminData_SlackWorkspace)),
							$lamdera$containers$SeqDict$fromList)),
					p0));
		case 10:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$LoadSlackDmChannels(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					A2(
						$elm$core$Basics$composeR,
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_AdminData_SlackDmChannel)),
							$lamdera$containers$SeqDict$fromList)),
					p0));
		case 11:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$LoadSessions(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					A2(
						$elm$core$Basics$composeR,
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_SessionIdHash_SessionIdHash, $author$project$Evergreen$Migrate$V419$migrate_UserSession_UserSession)),
							$lamdera$containers$SeqDict$fromList)),
					p0));
		case 12:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$LoadWebsocketCloseEvents(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					$elm$core$Array$map($author$project$Evergreen$Migrate$V419$migrate_LocalState_WebsocketClosedEvent),
					p0));
		case 13:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$LoadOrphanedFiles(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					A2(
						$elm$core$Basics$composeR,
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash, $author$project$Evergreen$Migrate$V419$migrate_FileStatus_BackendFileData)),
							$lamdera$containers$SeqDict$fromList)),
					p0));
		case 14:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$LoadToBackendLogs(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					$elm$core$Array$map($author$project$Evergreen$Migrate$V419$migrate_ToBackendLog_ToBackendLogData),
					p0));
		case 15:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$LoadBackendMsgLogs(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					$elm$core$Array$map($author$project$Evergreen$Migrate$V419$migrate_BackendMsgLog_BackendMsgLogData),
					p0));
		case 16:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$SetEmailNotificationsEnabled(p0);
		case 17:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$SetSignupsEnabled(p0);
		case 18:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$SetDiscordLinkingEnabled(p0);
		case 19:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$SetDiscordLinkLimit(p0);
		case 20:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$SetSlackLinkingEnabled(p0);
		case 21:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$SetSlackLinkLimit(p0);
		case 22:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$SetPrivateVapidKey(
				$author$project$Evergreen$Migrate$V419$migrate_LocalState_PrivateVapidKey(p0));
		case 23:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$SetPublicVapidKey(p0);
		case 24:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$SetOpenRouterKey(p0);
		case 25:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$SetNotifyAdminsToken(p0);
		case 26:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$SetNotifyAdminsBotUserId(
				$elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, p0));
		case 27:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$SetPostmarkKey(
				$author$project$Evergreen$Migrate$V419$migrate_Postmark_ApiKey(p0));
		case 28:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$DeleteDiscordDmChannel(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0));
		case 29:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$DeleteDiscordGuild(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0));
		case 30:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$DeleteSlackWorkspace(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0));
		case 31:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$DeleteSlackDmChannel(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0));
		case 32:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$DeleteGuild(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 33:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$RestoreGuild(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 34:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Pages$Admin$StartReloadingDiscordGuildChannel$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p3));
		case 35:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Pages$Admin$StartReloadingDiscordDmChannel$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p2));
		case 36:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Pages$Admin$ReloadDiscordGuild$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Result$mapError($author$project$Evergreen$Migrate$V419$migrate_Discord_HttpError),
						$elm$core$Result$map(
							$elm$core$List$map($author$project$Evergreen$Migrate$V419$migrate_Discord_Role))),
					p2));
		case 37:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Pages$Admin$DisconnectClient$(
				$author$project$Evergreen$Migrate$V419$migrate_SessionIdHash_SessionIdHash(p0),
				p1);
		case 38:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$DeleteSession(
				$author$project$Evergreen$Migrate$V419$migrate_SessionIdHash_SessionIdHash(p0));
		case 39:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$RegenerateServerSecret(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$($elm$core$Basics$identity, p0));
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$DeleteOrphanedFiles(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					$elm$core$Result$map(
						$elm$core$List$map($author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash)),
					p0));
	}
};
var $author$project$Evergreen$V419$Ports$GotSubscribeData = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Ports$SubscribeJsException = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Ports_RegisterPushSubscription = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Ports$GotSubscribeData(
			$author$project$Evergreen$Migrate$V419$migrate_Ports_SubscribeData(p0));
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Ports$SubscribeJsException(p0);
	}
};
var $author$project$Evergreen$V419$SetViewing$StopViewingChannel = {$: 11};
var $author$project$Evergreen$V419$SetViewing$ViewChannel$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Evergreen$V419$SetViewing$ViewChannel = F2($author$project$Evergreen$V419$SetViewing$ViewChannel$);
var $author$project$Evergreen$V419$SetViewing$ViewChannelThread$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $author$project$Evergreen$V419$SetViewing$ViewChannelThread = F2($author$project$Evergreen$V419$SetViewing$ViewChannelThread$);
var $author$project$Evergreen$V419$SetViewing$ViewDiscordChannel$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$Evergreen$V419$SetViewing$ViewDiscordChannel = F2($author$project$Evergreen$V419$SetViewing$ViewDiscordChannel$);
var $author$project$Evergreen$V419$SetViewing$ViewDiscordChannelThread$ = function (a, b) {
	return {$: 6, a: a, b: b};
};
var $author$project$Evergreen$V419$SetViewing$ViewDiscordChannelThread = F2($author$project$Evergreen$V419$SetViewing$ViewDiscordChannelThread$);
var $author$project$Evergreen$V419$SetViewing$ViewDiscordDm$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V419$SetViewing$ViewDiscordDm = F2($author$project$Evergreen$V419$SetViewing$ViewDiscordDm$);
var $author$project$Evergreen$V419$SetViewing$ViewDm$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$SetViewing$ViewDm = F2($author$project$Evergreen$V419$SetViewing$ViewDm$);
var $author$project$Evergreen$V419$SetViewing$ViewDmThread$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V419$SetViewing$ViewDmThread = F2($author$project$Evergreen$V419$SetViewing$ViewDmThread$);
var $author$project$Evergreen$V419$SetViewing$ViewOverview = function (a) {
	return {$: 12, a: a};
};
var $author$project$Evergreen$V419$SetViewing$ViewSlackChannel$ = function (a, b) {
	return {$: 7, a: a, b: b};
};
var $author$project$Evergreen$V419$SetViewing$ViewSlackChannel = F2($author$project$Evergreen$V419$SetViewing$ViewSlackChannel$);
var $author$project$Evergreen$V419$SetViewing$ViewSlackChannelThread$ = function (a, b) {
	return {$: 9, a: a, b: b};
};
var $author$project$Evergreen$V419$SetViewing$ViewSlackChannelThread = F2($author$project$Evergreen$V419$SetViewing$ViewSlackChannelThread$);
var $author$project$Evergreen$V419$SetViewing$ViewSlackDm$ = function (a, b) {
	return {$: 8, a: a, b: b};
};
var $author$project$Evergreen$V419$SetViewing$ViewSlackDm = F2($author$project$Evergreen$V419$SetViewing$ViewSlackDm$);
var $author$project$Evergreen$V419$SetViewing$ViewSlackDmThread$ = function (a, b) {
	return {$: 10, a: a, b: b};
};
var $author$project$Evergreen$V419$SetViewing$ViewSlackDmThread = F2($author$project$Evergreen$V419$SetViewing$ViewSlackDmThread$);
var $author$project$Evergreen$Migrate$V419$migrate_UserSession_UnreadOverviewData = function (old) {
	return {
		discordDmChannels: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Discord_Id,
						A2(
							$elm$core$Basics$composeR,
							$lamdera$containers$SeqDict$toList,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$map(
									A2(
										$elm$core$Tuple$mapBoth,
										$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
										A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, $author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id))),
								$lamdera$containers$SeqDict$fromList)))),
				$lamdera$containers$SeqDict$fromList),
			old.discordDmChannels),
		discordGuildChannels: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id),
						A2(
							$elm$core$Basics$composeR,
							$lamdera$containers$SeqDict$toList,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$map(
									A2(
										$elm$core$Tuple$mapBoth,
										$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
										A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, $author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id))),
								$lamdera$containers$SeqDict$fromList)))),
				$lamdera$containers$SeqDict$fromList),
			old.discordGuildChannels),
		discordGuildThreads: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						function (_v0) {
							var t1 = _v0.a;
							var t2 = _v0.b;
							var t3 = _v0.c;
							return _Utils_Tuple3(
								$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(t1),
								$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(t2),
								$author$project$Evergreen$Migrate$V419$migrate_Id_Id(t3));
						},
						A2(
							$elm$core$Basics$composeR,
							$lamdera$containers$SeqDict$toList,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$map(
									A2(
										$elm$core$Tuple$mapBoth,
										$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
										A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadMessageId, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id))),
								$lamdera$containers$SeqDict$fromList)))),
				$lamdera$containers$SeqDict$fromList),
			old.discordGuildThreads),
		discordUsers: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_UserSession_DiscordFrontendUser)),
				$lamdera$containers$SeqDict$fromList),
			old.discordUsers),
		dmChannels: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
						A2(
							$elm$core$Basics$composeR,
							$lamdera$containers$SeqDict$toList,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$map(
									A2(
										$elm$core$Tuple$mapBoth,
										$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
										A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, $author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id))),
								$lamdera$containers$SeqDict$fromList)))),
				$lamdera$containers$SeqDict$fromList),
			old.dmChannels),
		dmThreads: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id),
						A2(
							$elm$core$Basics$composeR,
							$lamdera$containers$SeqDict$toList,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$map(
									A2(
										$elm$core$Tuple$mapBoth,
										$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
										A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadMessageId, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id))),
								$lamdera$containers$SeqDict$fromList)))),
				$lamdera$containers$SeqDict$fromList),
			old.dmThreads),
		guildChannels: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id),
						A2(
							$elm$core$Basics$composeR,
							$lamdera$containers$SeqDict$toList,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$map(
									A2(
										$elm$core$Tuple$mapBoth,
										$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
										A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, $author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id))),
								$lamdera$containers$SeqDict$fromList)))),
				$lamdera$containers$SeqDict$fromList),
			old.guildChannels),
		guildThreads: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						function (_v1) {
							var t1 = _v1.a;
							var t2 = _v1.b;
							var t3 = _v1.c;
							return _Utils_Tuple3(
								$author$project$Evergreen$Migrate$V419$migrate_Id_Id(t1),
								$author$project$Evergreen$Migrate$V419$migrate_Id_Id(t2),
								$author$project$Evergreen$Migrate$V419$migrate_Id_Id(t3));
						},
						A2(
							$elm$core$Basics$composeR,
							$lamdera$containers$SeqDict$toList,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$map(
									A2(
										$elm$core$Tuple$mapBoth,
										$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
										A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadMessageId, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id))),
								$lamdera$containers$SeqDict$fromList)))),
				$lamdera$containers$SeqDict$fromList),
			old.guildThreads),
		slackChannels: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id),
						A2(
							$elm$core$Basics$composeR,
							$lamdera$containers$SeqDict$toList,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$map(
									A2(
										$elm$core$Tuple$mapBoth,
										$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
										A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, $author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id))),
								$lamdera$containers$SeqDict$fromList)))),
				$lamdera$containers$SeqDict$fromList),
			old.slackChannels),
		slackDmChannels: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Slack_Id,
						A2(
							$elm$core$Basics$composeR,
							$lamdera$containers$SeqDict$toList,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$map(
									A2(
										$elm$core$Tuple$mapBoth,
										$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
										A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, $author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id))),
								$lamdera$containers$SeqDict$fromList)))),
				$lamdera$containers$SeqDict$fromList),
			old.slackDmChannels),
		slackDmThreads: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id),
						A2(
							$elm$core$Basics$composeR,
							$lamdera$containers$SeqDict$toList,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$map(
									A2(
										$elm$core$Tuple$mapBoth,
										$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
										A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadMessageId, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id))),
								$lamdera$containers$SeqDict$fromList)))),
				$lamdera$containers$SeqDict$fromList),
			old.slackDmThreads),
		slackThreads: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						function (_v2) {
							var t1 = _v2.a;
							var t2 = _v2.b;
							var t3 = _v2.c;
							return _Utils_Tuple3(
								$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(t1),
								$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(t2),
								$author$project$Evergreen$Migrate$V419$migrate_Id_Id(t3));
						},
						A2(
							$elm$core$Basics$composeR,
							$lamdera$containers$SeqDict$toList,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$map(
									A2(
										$elm$core$Tuple$mapBoth,
										$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
										A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadMessageId, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id))),
								$lamdera$containers$SeqDict$fromList)))),
				$lamdera$containers$SeqDict$fromList),
			old.slackThreads)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_UserSession_ViewDiscordGuildData$ = function (migrate_messageId, old) {
	return {
		messages: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
						A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, migrate_messageId, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id))),
				$lamdera$containers$SeqDict$fromList),
			old.messages),
		newUsers: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_UserSession_DiscordFrontendUser)),
				$lamdera$containers$SeqDict$fromList),
			old.newUsers)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_UserSession_ViewDiscordGuildData = F2($author$project$Evergreen$Migrate$V419$migrate_UserSession_ViewDiscordGuildData$);
var $author$project$Evergreen$Migrate$V419$migrate_SetViewing_SetViewing = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SetViewing$ViewDm$(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_DmData(p0),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$($author$project$Evergreen$Migrate$V419$migrate_DmChannel_LoadedMessages, p1));
		case 1:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SetViewing$ViewDmThread$(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_DmThreadData(p0),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					A2(
						$elm$core$Basics$composeR,
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2(
									$elm$core$Tuple$mapBoth,
									$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
									A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadMessageId, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id))),
							$lamdera$containers$SeqDict$fromList)),
					p1));
		case 2:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SetViewing$ViewDiscordDm$(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_DiscordDmData(p0),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					A2(
						$elm$core$Basics$composeR,
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2(
									$elm$core$Tuple$mapBoth,
									$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
									A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, $author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id))),
							$lamdera$containers$SeqDict$fromList)),
					p1));
		case 3:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SetViewing$ViewChannel$(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_ChannelData(p0),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$($author$project$Evergreen$Migrate$V419$migrate_DmChannel_LoadedMessages, p1));
		case 4:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SetViewing$ViewChannelThread$(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_ChannelThreadData(p0),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					A2(
						$elm$core$Basics$composeR,
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2(
									$elm$core$Tuple$mapBoth,
									$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
									A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadMessageId, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id))),
							$lamdera$containers$SeqDict$fromList)),
					p1));
		case 5:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SetViewing$ViewDiscordChannel$(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_DiscordChannelData(p0),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					$author$project$Evergreen$Migrate$V419$migrate_UserSession_ViewDiscordGuildData($author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId),
					p1));
		case 6:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SetViewing$ViewDiscordChannelThread$(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_DiscordChannelThreadData(p0),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					$author$project$Evergreen$Migrate$V419$migrate_UserSession_ViewDiscordGuildData($author$project$Evergreen$Migrate$V419$migrate_Id_ThreadMessageId),
					p1));
		case 7:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SetViewing$ViewSlackChannel$(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_SlackChannelData(p0),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					A2(
						$elm$core$Basics$composeR,
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2(
									$elm$core$Tuple$mapBoth,
									$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
									A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, $author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id))),
							$lamdera$containers$SeqDict$fromList)),
					p1));
		case 8:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SetViewing$ViewSlackDm$(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_SlackDmData(p0),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					A2(
						$elm$core$Basics$composeR,
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2(
									$elm$core$Tuple$mapBoth,
									$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
									A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, $author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id))),
							$lamdera$containers$SeqDict$fromList)),
					p1));
		case 9:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SetViewing$ViewSlackChannelThread$(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_SlackChannelThreadData(p0),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					A2(
						$elm$core$Basics$composeR,
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2(
									$elm$core$Tuple$mapBoth,
									$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
									A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadMessageId, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id))),
							$lamdera$containers$SeqDict$fromList)),
					p1));
		case 10:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SetViewing$ViewSlackDmThread$(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing_SlackDmThreadData(p0),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					A2(
						$elm$core$Basics$composeR,
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2(
									$elm$core$Tuple$mapBoth,
									$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
									A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadMessageId, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id))),
							$lamdera$containers$SeqDict$fromList)),
					p1));
		case 11:
			return $author$project$Evergreen$V419$SetViewing$StopViewingChannel;
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$SetViewing$ViewOverview(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$($author$project$Evergreen$Migrate$V419$migrate_UserSession_UnreadOverviewData, p0));
	}
};
var $author$project$Evergreen$V419$TextEditor$Local_EditChange = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$TextEditor$Local_Redo = {$: 3};
var $author$project$Evergreen$V419$TextEditor$Local_Reset = {$: 1};
var $author$project$Evergreen$V419$TextEditor$Local_Undo = {$: 2};
var $author$project$Evergreen$Migrate$V419$migrate_TextEditor_LocalChange = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$TextEditor$Local_EditChange(
				$author$project$Evergreen$Migrate$V419$migrate_TextEditor_EditChange(p0));
		case 1:
			return $author$project$Evergreen$V419$TextEditor$Local_Reset;
		case 2:
			return $author$project$Evergreen$V419$TextEditor$Local_Undo;
		default:
			return $author$project$Evergreen$V419$TextEditor$Local_Redo;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_ChannelDataToDecrypt = function (old) {
	return {
		channel: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Encryption_EncryptedData)),
				$lamdera$containers$SeqDict$fromList),
			old.channel),
		threads: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
						A2($author$project$Evergreen$Migrate$V419$migrate_NonemptyDict_NonemptyDict, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Encryption_EncryptedData))),
				$lamdera$containers$SeqDict$fromList),
			old.threads)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_ChannelDataToEncrypt = function (old) {
	return {
		channel: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
						A2($author$project$Evergreen$Migrate$V419$migrate_Message_MessageContent, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id))),
				$lamdera$containers$SeqDict$fromList),
			old.channel),
		threads: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
						A2(
							$elm$core$Basics$composeR,
							$lamdera$containers$SeqDict$toList,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$map(
									A2(
										$elm$core$Tuple$mapBoth,
										$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
										A2($author$project$Evergreen$Migrate$V419$migrate_Message_MessageContent, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id))),
								$lamdera$containers$SeqDict$fromList)))),
				$lamdera$containers$SeqDict$fromList),
			old.threads)
	};
};
var $author$project$Evergreen$V419$User$NotifyOnEveryMessage = 0;
var $author$project$Evergreen$V419$User$NotifyOnMention = 1;
var $author$project$Evergreen$Migrate$V419$migrate_User_NotificationLevel = function (old) {
	if (!old) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Evergreen$V419$VisibleMessages$PageBefore = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$VisibleMessages$PageFrom = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_VisibleMessages_PageRequest$ = function (migrate_messageId, old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$VisibleMessages$PageBefore(
			$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$VisibleMessages$PageFrom(
			$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_VisibleMessages_PageRequest = F2($author$project$Evergreen$Migrate$V419$migrate_VisibleMessages_PageRequest$);
var $author$project$Evergreen$Migrate$V419$migrate_Types_LocalChange = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$Types$Local_Invalid;
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Local_Admin(
				$author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_AdminChange(p0));
		case 2:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			var p5 = old.f;
			var p6 = old.g;
			return $author$project$Evergreen$V419$Types$Local_SendMessage$(
				p0,
				p1,
				$author$project$Evergreen$Migrate$V419$migrate_Id_GuildOrDmId(p2),
				p3,
				$author$project$Evergreen$Migrate$V419$migrate_Message_ThreadRouteWithRepliedTo(p4),
				$elm$core$Basics$composeR$(
					$lamdera$containers$SeqDict$toList,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map(
							A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileData)),
						$lamdera$containers$SeqDict$fromList),
					p5),
				$elm$core$List$map$($author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji, p6));
		case 3:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			var p5 = old.f;
			return $author$project$Evergreen$V419$Types$Local_Discord_SendMessage$(
				p0,
				p1,
				$author$project$Evergreen$Migrate$V419$migrate_Id_DiscordGuildOrDmId(p2),
				p3,
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMaybeMessage(p4),
				$elm$core$Basics$composeR$(
					$lamdera$containers$SeqDict$toList,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map(
							A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileData)),
						$lamdera$containers$SeqDict$fromList),
					p5));
		case 4:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			var p5 = old.f;
			return $author$project$Evergreen$V419$Types$Local_Slack_SendMessage$(
				p0,
				p1,
				$author$project$Evergreen$Migrate$V419$migrate_Id_SlackGuildOrDmId(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute(p3),
				p4,
				$elm$core$Basics$composeR$(
					$lamdera$containers$SeqDict$toList,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map(
							A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileData)),
						$lamdera$containers$SeqDict$fromList),
					p5));
		case 5:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			return $author$project$Evergreen$V419$Types$Local_Slack_SendEditMessage$(
				p0,
				p1,
				$author$project$Evergreen$Migrate$V419$migrate_Id_SlackGuildOrDmId(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p3),
				p4);
		case 6:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Local_Slack_UnlinkUser(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0));
		case 7:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Local_Slack_ReloadUser(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0));
		case 8:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$Local_NewChannel$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_ChannelName_ChannelName(p2),
				$author$project$Evergreen$Migrate$V419$migrate_ChannelDescription_ChannelDescription(p3));
		case 9:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$Local_EditChannel$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_ChannelName_ChannelName(p2),
				$author$project$Evergreen$Migrate$V419$migrate_ChannelDescription_ChannelDescription(p3));
		case 10:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Local_DeleteChannel$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1));
		case 11:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Local_EditGuildName$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_GuildName_GuildName(p1));
		case 12:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Local_DeleteGuild(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 13:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Local_LeaveGuild(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 14:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Local_NewInviteLink$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$($author$project$Evergreen$Migrate$V419$migrate_SecretId_SecretId, p2));
		case 15:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Local_DeleteInviteLink$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_SecretId_SecretId(p1));
		case 16:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Local_BanMember$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1));
		case 17:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Local_NewGuild$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_GuildName_GuildName(p1),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, p2));
		case 18:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Local_MemberTyping$(
				p0,
				$elm$core$Tuple$mapBoth$($author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute, p1));
		case 19:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Local_AddReactionEmoji$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji(p2));
		case 20:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Local_RemoveReactionEmoji$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji(p2));
		case 21:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			var p5 = old.f;
			return $author$project$Evergreen$V419$Types$Local_SendEditMessage$(
				p0,
				p1,
				$author$project$Evergreen$Migrate$V419$migrate_Id_GuildOrDmId(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p3),
				p4,
				$elm$core$Basics$composeR$(
					$lamdera$containers$SeqDict$toList,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map(
							A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileData)),
						$lamdera$containers$SeqDict$fromList),
					p5));
		case 22:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			var p5 = old.f;
			var p6 = old.g;
			return $author$project$Evergreen$V419$Types$Local_Discord_SendEditGuildMessage$(
				p0,
				p1,
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p3),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p4),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p5),
				p6);
		case 23:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			return $author$project$Evergreen$V419$Types$Local_Discord_SendEditDmMessage$(
				p0,
				p1,
				$author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DiscordDmId(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p3),
				p4);
		case 24:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Local_MemberEditTyping$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p2));
		case 25:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Local_SetLastViewed$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p1));
		case 26:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Local_DeleteMessage$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p1));
		case 27:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Local_CurrentlyViewing$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_SetViewing_SetViewing(p1));
		case 28:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Local_SetName(
				$author$project$Evergreen$Migrate$V419$migrate_PersonName_PersonName(p0));
		case 29:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Local_LoadChannelMessages$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_GuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_VisibleMessages_PageRequest$($author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, p1),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$($author$project$Evergreen$Migrate$V419$migrate_DmChannel_LoadedMessages, p2));
		case 30:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$Local_LoadThreadMessages$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_GuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_VisibleMessages_PageRequest$($author$project$Evergreen$Migrate$V419$migrate_Id_ThreadMessageId, p2),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					A2(
						$elm$core$Basics$composeR,
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2(
									$elm$core$Tuple$mapBoth,
									$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
									A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadMessageId, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id))),
							$lamdera$containers$SeqDict$fromList)),
					p3));
		case 31:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Local_Slack_LoadChannelMessages$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_SlackGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_VisibleMessages_PageRequest$($author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, p1),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					A2(
						$elm$core$Basics$composeR,
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2(
									$elm$core$Tuple$mapBoth,
									$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
									A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, $author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id))),
							$lamdera$containers$SeqDict$fromList)),
					p2));
		case 32:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$Local_Slack_LoadThreadMessages$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_SlackGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_VisibleMessages_PageRequest$($author$project$Evergreen$Migrate$V419$migrate_Id_ThreadMessageId, p2),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					A2(
						$elm$core$Basics$composeR,
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2(
									$elm$core$Tuple$mapBoth,
									$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
									A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadMessageId, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id))),
							$lamdera$containers$SeqDict$fromList)),
					p3));
		case 33:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Local_Discord_LoadChannelMessages$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_DiscordGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_VisibleMessages_PageRequest$($author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, p1),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					A2(
						$elm$core$Basics$composeR,
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2(
									$elm$core$Tuple$mapBoth,
									$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
									A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, $author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id))),
							$lamdera$containers$SeqDict$fromList)),
					p2));
		case 34:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$Local_Discord_LoadThreadMessages$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_DiscordGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_VisibleMessages_PageRequest$($author$project$Evergreen$Migrate$V419$migrate_Id_ThreadMessageId, p2),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					A2(
						$elm$core$Basics$composeR,
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2(
									$elm$core$Tuple$mapBoth,
									$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
									A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadMessageId, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id))),
							$lamdera$containers$SeqDict$fromList)),
					p3));
		case 35:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Local_SetGuildNotificationLevel$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_User_NotificationLevel(p1));
		case 36:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Local_SetDiscordGuildNotificationLevel$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_User_NotificationLevel(p2));
		case 37:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Local_SetSlackWorkspaceNotificationLevel$(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_User_NotificationLevel(p2));
		case 38:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Local_SetNotificationMode(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_NotificationMode(p0));
		case 39:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Local_ExpandUserOptionSection$(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_UserOptionSection(p0),
				p1);
		case 40:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Local_CollapseUserOptionSection(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_UserOptionSection(p0));
		case 41:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Local_SetSheepGameQuestions(
				$author$project$Evergreen$Migrate$V419$migrate_IdArray_IdArray$($author$project$Evergreen$Migrate$V419$migrate_UserSession_SheepGameQuestion, p0));
		case 42:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Local_SetEmailNotifications(
				$author$project$Evergreen$Migrate$V419$migrate_User_EmailNotifications(p0));
		case 43:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Local_SetEmbedVisibility(
				$author$project$Evergreen$Migrate$V419$migrate_User_EmbedVisibility(p0));
		case 44:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Local_ScheduleAccountDeletion(p0);
		case 45:
			return $author$project$Evergreen$V419$Types$Local_CancelAccountDeletion;
		case 46:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Local_RegisterPushSubscription$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Ports_RegisterPushSubscription(p1));
		case 47:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Local_TextEditor(
				$author$project$Evergreen$Migrate$V419$migrate_TextEditor_LocalChange(p0));
		case 48:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Local_UnlinkDiscordUser(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0));
		case 49:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Local_StartReloadingDiscordUser$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1));
		case 50:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Local_LinkDiscordAcknowledgementIsChecked(p0);
		case 51:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Local_LinkSlackAcknowledgementIsChecked(p0);
		case 52:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Local_SetDomainWhitelist$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_RichText_Domain(p1));
		case 53:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Local_SetEmojiSkinTone(
				$elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Emoji_SkinTone, p0));
		case 54:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Local_SetUserColor(
				$author$project$Evergreen$Migrate$V419$migrate_UserColor_UserColor(p0));
		case 55:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Local_AddCustomEmojisToUser(
				$author$project$Evergreen$Migrate$V419$migrate_NonemptySet_NonemptySet$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, p0));
		case 56:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Local_VoiceChatChange(
				$author$project$Evergreen$Migrate$V419$migrate_Call_LocalChange(p0));
		case 57:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Local_Game$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_GuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Game_LocalChange(p1));
		case 58:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Local_Drawing$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Drawing_AnchorType(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Drawing_LocalChange(p2));
		case 59:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Local_SetMuteChannel$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(p2));
		case 60:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$Local_SetMuteThread$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(p3));
		case 61:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$Local_SetMuteDiscordChannel$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(p3));
		case 62:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			return $author$project$Evergreen$V419$Types$Local_SetMuteDiscordThread$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p3),
				$author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(p4));
		case 63:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Local_SetMuteGuild$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(p1));
		case 64:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Local_SetMuteDiscordGuild$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(p2));
		case 65:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Local_SetMuteSlackWorkspace$(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(p2));
		case 66:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$Local_SetMuteSlackChannel$(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(p3));
		case 67:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			return $author$project$Evergreen$V419$Types$Local_SetMuteSlackThread$(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p3),
				$author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(p4));
		case 68:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Local_RequestE2ee(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DmId(p0));
		case 69:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Local_DeclineE2eeRequestAsInitiator(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DmId(p0));
		case 70:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Local_DeclineE2eeRequest(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DmId(p0));
		case 71:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Local_SetPublicKey$(
				$author$project$Evergreen$Migrate$V419$migrate_X25519_PublicKey(p0),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					A2(
						$elm$core$Basics$composeR,
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DmId, $author$project$Evergreen$Migrate$V419$migrate_Types_ChannelDataToEncrypt)),
							$lamdera$containers$SeqDict$fromList)),
					p1));
		case 72:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Local_EncryptOldMessages$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DmId(p0),
				$elm$core$List$map$(
					function (_v1) {
						var t1 = _v1.a;
						var t2 = _v1.b;
						var t3 = _v1.c;
						return _Utils_Tuple3(
							$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(t1),
							$lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash, t2),
							$author$project$Evergreen$Migrate$V419$migrate_Encryption_EncryptedData(t3));
					},
					p1));
		case 73:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Local_DisableE2ee$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$($author$project$Evergreen$Migrate$V419$migrate_Types_ChannelDataToDecrypt, p1));
		case 74:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Local_DecryptOldMessages$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DmId(p0),
				p1,
				$elm$core$List$map$(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage,
						A2($author$project$Evergreen$Migrate$V419$migrate_Message_MessageContent, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id)),
					p2));
		case 75:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Local_SetE2eeRisksAccepted(p0);
		case 76:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Local_AcceptE2ee$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DmId(p0),
				p1,
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ToBeFilledInByBackend$(
					A2(
						$elm$core$Basics$composeR,
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DmId, $author$project$Evergreen$Migrate$V419$migrate_Types_ChannelDataToEncrypt)),
							$lamdera$containers$SeqDict$fromList)),
					p2));
		case 77:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			var p5 = old.f;
			return $author$project$Evergreen$V419$Types$Local_SendEncryptedMessage$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DmId(p1),
				$lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash, p2),
				$author$project$Evergreen$Migrate$V419$migrate_Encryption_EncryptedData(p3),
				$author$project$Evergreen$Migrate$V419$migrate_Encryption_EncryptedData(p4),
				$author$project$Evergreen$Migrate$V419$migrate_Message_ThreadRouteWithRepliedTo(p5));
		default:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			return $author$project$Evergreen$V419$Types$Local_SendEncryptedEditMessage$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DmId(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p2),
				$lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash, p3),
				$author$project$Evergreen$Migrate$V419$migrate_Encryption_EncryptedData(p4));
	}
};
var $author$project$Evergreen$V419$Types$Server_AddReactionEmoji$ = function (a, b, c, d) {
	return {$: 30, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$Server_AddReactionEmoji = F4($author$project$Evergreen$V419$Types$Server_AddReactionEmoji$);
var $author$project$Evergreen$V419$Types$Server_BackupGenerated = function (a) {
	return {$: 73, a: a};
};
var $author$project$Evergreen$V419$Types$Server_CallRecordingStarted$ = function (a, b, c, d) {
	return {$: 31, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$Server_CallRecordingStarted = F4($author$project$Evergreen$V419$Types$Server_CallRecordingStarted$);
var $author$project$Evergreen$V419$Types$Server_CallRecordingUploadFinished$ = function (a, b, c) {
	return {$: 33, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Server_CallRecordingUploadFinished = F3($author$project$Evergreen$V419$Types$Server_CallRecordingUploadFinished$);
var $author$project$Evergreen$V419$Types$Server_CallRecordingUploadProgress$ = function (a, b, c) {
	return {$: 32, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Server_CallRecordingUploadProgress = F3($author$project$Evergreen$V419$Types$Server_CallRecordingUploadProgress$);
var $author$project$Evergreen$V419$Types$Server_CallRecordingZipBuilt$ = function (a, b, c) {
	return {$: 34, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Server_CallRecordingZipBuilt = F3($author$project$Evergreen$V419$Types$Server_CallRecordingZipBuilt$);
var $author$project$Evergreen$V419$Types$Server_ClientDisconnected$ = function (a, b, c) {
	return {$: 60, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Server_ClientDisconnected = F3($author$project$Evergreen$V419$Types$Server_ClientDisconnected$);
var $author$project$Evergreen$V419$Types$Server_CurrentlyViewing$ = function (a, b, c) {
	return {$: 59, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Server_CurrentlyViewing = F3($author$project$Evergreen$V419$Types$Server_CurrentlyViewing$);
var $author$project$Evergreen$V419$Types$Server_DeleteChannel$ = function (a, b) {
	return {$: 19, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_DeleteChannel = F2($author$project$Evergreen$V419$Types$Server_DeleteChannel$);
var $author$project$Evergreen$V419$Types$Server_DeleteGuild = function (a) {
	return {$: 21, a: a};
};
var $author$project$Evergreen$V419$Types$Server_DeleteInviteLink$ = function (a, b) {
	return {$: 23, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_DeleteInviteLink = F2($author$project$Evergreen$V419$Types$Server_DeleteInviteLink$);
var $author$project$Evergreen$V419$Types$Server_DeleteMessage$ = function (a, b) {
	return {$: 44, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_DeleteMessage = F2($author$project$Evergreen$V419$Types$Server_DeleteMessage$);
var $author$project$Evergreen$V419$Types$Server_DisableE2ee$ = function (a, b, c) {
	return {$: 109, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Server_DisableE2ee = F3($author$project$Evergreen$V419$Types$Server_DisableE2ee$);
var $author$project$Evergreen$V419$Types$Server_DiscordAddReactionDmEmoji$ = function (a, b, c, d) {
	return {$: 37, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$Server_DiscordAddReactionDmEmoji = F4($author$project$Evergreen$V419$Types$Server_DiscordAddReactionDmEmoji$);
var $author$project$Evergreen$V419$Types$Server_DiscordAddReactionGuildEmoji$ = function (a, b, c, d, e) {
	return {$: 36, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V419$Types$Server_DiscordAddReactionGuildEmoji = F5($author$project$Evergreen$V419$Types$Server_DiscordAddReactionGuildEmoji$);
var $author$project$Evergreen$V419$Types$Server_DiscordAvatarsLoaded$ = function (a, b) {
	return {$: 101, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_DiscordAvatarsLoaded = F2($author$project$Evergreen$V419$Types$Server_DiscordAvatarsLoaded$);
var $author$project$Evergreen$V419$Types$Server_DiscordChannelCreated$ = function (a, b, c, d, e, f) {
	return {$: 64, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Evergreen$V419$Types$Server_DiscordChannelCreated = F6($author$project$Evergreen$V419$Types$Server_DiscordChannelCreated$);
var $author$project$Evergreen$V419$Types$Server_DiscordChannelDeleted$ = function (a, b) {
	return {$: 81, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_DiscordChannelDeleted = F2($author$project$Evergreen$V419$Types$Server_DiscordChannelDeleted$);
var $author$project$Evergreen$V419$Types$Server_DiscordDeleteDmMessage$ = function (a, b) {
	return {$: 47, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_DiscordDeleteDmMessage = F2($author$project$Evergreen$V419$Types$Server_DiscordDeleteDmMessage$);
var $author$project$Evergreen$V419$Types$Server_DiscordDeleteGuildMessage$ = function (a, b, c) {
	return {$: 45, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Server_DiscordDeleteGuildMessage = F3($author$project$Evergreen$V419$Types$Server_DiscordDeleteGuildMessage$);
var $author$project$Evergreen$V419$Types$Server_DiscordDmChannelCreated$ = function (a, b) {
	return {$: 65, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_DiscordDmChannelCreated = F2($author$project$Evergreen$V419$Types$Server_DiscordDmChannelCreated$);
var $author$project$Evergreen$V419$Types$Server_DiscordDmChannelRecipientRemoved$ = function (a, b) {
	return {$: 66, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_DiscordDmChannelRecipientRemoved = F2($author$project$Evergreen$V419$Types$Server_DiscordDmChannelRecipientRemoved$);
var $author$project$Evergreen$V419$Types$Server_DiscordDmMemberTyping$ = function (a, b, c) {
	return {$: 29, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Server_DiscordDmMemberTyping = F3($author$project$Evergreen$V419$Types$Server_DiscordDmMemberTyping$);
var $author$project$Evergreen$V419$Types$Server_DiscordForumPostDeleted$ = function (a, b, c) {
	return {$: 46, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Server_DiscordForumPostDeleted = F3($author$project$Evergreen$V419$Types$Server_DiscordForumPostDeleted$);
var $author$project$Evergreen$V419$Types$Server_DiscordGuildJoinedOrCreated$ = function (a, b, c) {
	return {$: 78, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Server_DiscordGuildJoinedOrCreated = F3($author$project$Evergreen$V419$Types$Server_DiscordGuildJoinedOrCreated$);
var $author$project$Evergreen$V419$Types$Server_DiscordGuildLeftOrDeleted$ = function (a, b) {
	return {$: 79, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_DiscordGuildLeftOrDeleted = F2($author$project$Evergreen$V419$Types$Server_DiscordGuildLeftOrDeleted$);
var $author$project$Evergreen$V419$Types$Server_DiscordGuildMemberJoined$ = function (a, b, c, d, e, f) {
	return {$: 86, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Evergreen$V419$Types$Server_DiscordGuildMemberJoined = F6($author$project$Evergreen$V419$Types$Server_DiscordGuildMemberJoined$);
var $author$project$Evergreen$V419$Types$Server_DiscordGuildMemberTyping$ = function (a, b, c, d, e) {
	return {$: 28, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V419$Types$Server_DiscordGuildMemberTyping = F5($author$project$Evergreen$V419$Types$Server_DiscordGuildMemberTyping$);
var $author$project$Evergreen$V419$Types$Server_DiscordNeedsAuthAgain = function (a) {
	return {$: 67, a: a};
};
var $author$project$Evergreen$V419$Types$Server_DiscordRemoveReactionDmEmoji$ = function (a, b, c, d) {
	return {$: 39, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$Server_DiscordRemoveReactionDmEmoji = F4($author$project$Evergreen$V419$Types$Server_DiscordRemoveReactionDmEmoji$);
var $author$project$Evergreen$V419$Types$Server_DiscordRemoveReactionGuildEmoji$ = function (a, b, c, d, e) {
	return {$: 38, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V419$Types$Server_DiscordRemoveReactionGuildEmoji = F5($author$project$Evergreen$V419$Types$Server_DiscordRemoveReactionGuildEmoji$);
var $author$project$Evergreen$V419$Types$Server_DiscordSendEditDmMessage$ = function (a, b, c, d) {
	return {$: 42, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$Server_DiscordSendEditDmMessage = F4($author$project$Evergreen$V419$Types$Server_DiscordSendEditDmMessage$);
var $author$project$Evergreen$V419$Types$Server_DiscordSendEditGuildMessage$ = function (a, b, c, d, e, f) {
	return {$: 41, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Evergreen$V419$Types$Server_DiscordSendEditGuildMessage = F6($author$project$Evergreen$V419$Types$Server_DiscordSendEditGuildMessage$);
var $author$project$Evergreen$V419$Types$Server_DiscordUpdateChannel$ = function (a, b, c, d, e) {
	return {$: 80, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V419$Types$Server_DiscordUpdateChannel = F5($author$project$Evergreen$V419$Types$Server_DiscordUpdateChannel$);
var $author$project$Evergreen$V419$Types$Server_DiscordUpdateGuild$ = function (a, b, c, d) {
	return {$: 82, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$Server_DiscordUpdateGuild = F4($author$project$Evergreen$V419$Types$Server_DiscordUpdateGuild$);
var $author$project$Evergreen$V419$Types$Server_DiscordUpdateGuildCustomEmojis$ = function (a, b) {
	return {$: 84, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_DiscordUpdateGuildCustomEmojis = F2($author$project$Evergreen$V419$Types$Server_DiscordUpdateGuildCustomEmojis$);
var $author$project$Evergreen$V419$Types$Server_DiscordUpdateRole$ = function (a, b, c) {
	return {$: 83, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Server_DiscordUpdateRole = F3($author$project$Evergreen$V419$Types$Server_DiscordUpdateRole$);
var $author$project$Evergreen$V419$Types$Server_DiscordUserLoadingDataIsDone$ = function (a, b) {
	return {$: 68, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_DiscordUserLoadingDataIsDone = F2($author$project$Evergreen$V419$Types$Server_DiscordUserLoadingDataIsDone$);
var $author$project$Evergreen$V419$Types$Server_Discord_SendMessage$ = function (a, b, c, d, e, f, g) {
	return {$: 15, a: a, b: b, c: c, d: d, e: e, f: f, g: g};
};
var $author$project$Evergreen$V419$Types$Server_Discord_SendMessage = F7($author$project$Evergreen$V419$Types$Server_Discord_SendMessage$);
var $author$project$Evergreen$V419$Types$Server_Drawing$ = function (a, b, c, d) {
	return {$: 91, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$Server_Drawing = F4($author$project$Evergreen$V419$Types$Server_Drawing$);
var $author$project$Evergreen$V419$Types$Server_E2eeAccepted$ = function (a, b) {
	return {$: 105, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_E2eeAccepted = F2($author$project$Evergreen$V419$Types$Server_E2eeAccepted$);
var $author$project$Evergreen$V419$Types$Server_E2eeRequestCancelled = function (a) {
	return {$: 103, a: a};
};
var $author$project$Evergreen$V419$Types$Server_E2eeRequestDeclined$ = function (a, b) {
	return {$: 104, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_E2eeRequestDeclined = F2($author$project$Evergreen$V419$Types$Server_E2eeRequestDeclined$);
var $author$project$Evergreen$V419$Types$Server_E2eeRequested$ = function (a, b) {
	return {$: 102, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_E2eeRequested = F2($author$project$Evergreen$V419$Types$Server_E2eeRequested$);
var $author$project$Evergreen$V419$Types$Server_EditChannel$ = function (a, b, c, d) {
	return {$: 18, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$Server_EditChannel = F4($author$project$Evergreen$V419$Types$Server_EditChannel$);
var $author$project$Evergreen$V419$Types$Server_EditGuildName$ = function (a, b) {
	return {$: 20, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_EditGuildName = F2($author$project$Evergreen$V419$Types$Server_EditGuildName$);
var $author$project$Evergreen$V419$Types$Server_Game$ = function (a, b, c) {
	return {$: 90, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Server_Game = F3($author$project$Evergreen$V419$Types$Server_Game$);
var $author$project$Evergreen$V419$Types$Server_GotDiscordDmMessageEmbed$ = function (a, b, c) {
	return {$: 77, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Server_GotDiscordDmMessageEmbed = F3($author$project$Evergreen$V419$Types$Server_GotDiscordDmMessageEmbed$);
var $author$project$Evergreen$V419$Types$Server_GotDiscordGuildMessageEmbed$ = function (a, b, c, d) {
	return {$: 76, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$Server_GotDiscordGuildMessageEmbed = F4($author$project$Evergreen$V419$Types$Server_GotDiscordGuildMessageEmbed$);
var $author$project$Evergreen$V419$Types$Server_GotDmMessageEmbed$ = function (a, b, c) {
	return {$: 75, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Server_GotDmMessageEmbed = F3($author$project$Evergreen$V419$Types$Server_GotDmMessageEmbed$);
var $author$project$Evergreen$V419$Types$Server_GotGuildMessageEmbed$ = function (a, b, c, d) {
	return {$: 74, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$Server_GotGuildMessageEmbed = F4($author$project$Evergreen$V419$Types$Server_GotGuildMessageEmbed$);
var $author$project$Evergreen$V419$Types$Server_ImportedChannel$ = function (a, b, c) {
	return {$: 17, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Server_ImportedChannel = F3($author$project$Evergreen$V419$Types$Server_ImportedChannel$);
var $author$project$Evergreen$V419$Types$Server_LinkDiscordUser$ = function (a, b) {
	return {$: 62, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_LinkDiscordUser = F2($author$project$Evergreen$V419$Types$Server_LinkDiscordUser$);
var $author$project$Evergreen$V419$Types$Server_LinkedDiscordUserCustomEmojisLoaded = function (a) {
	return {$: 88, a: a};
};
var $author$project$Evergreen$V419$Types$Server_LinkedDiscordUserStickersLoaded = function (a) {
	return {$: 87, a: a};
};
var $author$project$Evergreen$V419$Types$Server_LoadAdminData = function (a) {
	return {$: 71, a: a};
};
var $author$project$Evergreen$V419$Types$Server_LoadingDiscordChannelChanged$ = function (a, b) {
	return {$: 70, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_LoadingDiscordChannelChanged = F2($author$project$Evergreen$V419$Types$Server_LoadingDiscordChannelChanged$);
var $author$project$Evergreen$V419$Types$Server_LoggedOut = function (a) {
	return {$: 58, a: a};
};
var $author$project$Evergreen$V419$Types$Server_MemberEditTyping$ = function (a, b, c, d) {
	return {$: 43, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$Server_MemberEditTyping = F4($author$project$Evergreen$V419$Types$Server_MemberEditTyping$);
var $author$project$Evergreen$V419$Types$Server_MemberJoined$ = function (a, b, c, d) {
	return {$: 24, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$Server_MemberJoined = F4($author$project$Evergreen$V419$Types$Server_MemberJoined$);
var $author$project$Evergreen$V419$Types$Server_MemberLeft$ = function (a, b) {
	return {$: 25, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_MemberLeft = F2($author$project$Evergreen$V419$Types$Server_MemberLeft$);
var $author$project$Evergreen$V419$Types$Server_MemberTyping$ = function (a, b, c, d) {
	return {$: 27, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$Server_MemberTyping = F4($author$project$Evergreen$V419$Types$Server_MemberTyping$);
var $author$project$Evergreen$V419$Types$Server_NewChannel$ = function (a, b, c, d) {
	return {$: 16, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$Server_NewChannel = F4($author$project$Evergreen$V419$Types$Server_NewChannel$);
var $author$project$Evergreen$V419$Types$Server_NewInviteLink$ = function (a, b, c, d) {
	return {$: 22, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$Server_NewInviteLink = F4($author$project$Evergreen$V419$Types$Server_NewInviteLink$);
var $author$project$Evergreen$V419$Types$Server_NewLog$ = function (a, b) {
	return {$: 72, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_NewLog = F2($author$project$Evergreen$V419$Types$Server_NewLog$);
var $author$project$Evergreen$V419$Types$Server_NewSession$ = function (a, b) {
	return {$: 57, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_NewSession = F2($author$project$Evergreen$V419$Types$Server_NewSession$);
var $author$project$Evergreen$V419$Types$Server_PushNotificationFailed$ = function (a, b) {
	return {$: 56, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_PushNotificationFailed = F2($author$project$Evergreen$V419$Types$Server_PushNotificationFailed$);
var $author$project$Evergreen$V419$Types$Server_PushNotificationsReset = function (a) {
	return {$: 52, a: a};
};
var $author$project$Evergreen$V419$Types$Server_RemoveReactionEmoji$ = function (a, b, c, d) {
	return {$: 35, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$Server_RemoveReactionEmoji = F4($author$project$Evergreen$V419$Types$Server_RemoveReactionEmoji$);
var $author$project$Evergreen$V419$Types$Server_SendEditMessage$ = function (a, b, c, d, e, f) {
	return {$: 40, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Evergreen$V419$Types$Server_SendEditMessage = F6($author$project$Evergreen$V419$Types$Server_SendEditMessage$);
var $author$project$Evergreen$V419$Types$Server_SendEncryptedEditMessage$ = function (a, b, c, d, e, f) {
	return {$: 108, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Evergreen$V419$Types$Server_SendEncryptedEditMessage = F6($author$project$Evergreen$V419$Types$Server_SendEncryptedEditMessage$);
var $author$project$Evergreen$V419$Types$Server_SendEncryptedMessage = function (a) {
	return {$: 107, a: a};
};
var $author$project$Evergreen$V419$Types$Server_SendMessage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Types$Server_SetDiscordGuildNotificationLevel$ = function (a, b) {
	return {$: 54, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_SetDiscordGuildNotificationLevel = F2($author$project$Evergreen$V419$Types$Server_SetDiscordGuildNotificationLevel$);
var $author$project$Evergreen$V419$Types$Server_SetGuildIcon$ = function (a, b) {
	return {$: 51, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_SetGuildIcon = F2($author$project$Evergreen$V419$Types$Server_SetGuildIcon$);
var $author$project$Evergreen$V419$Types$Server_SetGuildNotificationLevel$ = function (a, b) {
	return {$: 53, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_SetGuildNotificationLevel = F2($author$project$Evergreen$V419$Types$Server_SetGuildNotificationLevel$);
var $author$project$Evergreen$V419$Types$Server_SetMuteChannel$ = function (a, b, c) {
	return {$: 92, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Server_SetMuteChannel = F3($author$project$Evergreen$V419$Types$Server_SetMuteChannel$);
var $author$project$Evergreen$V419$Types$Server_SetMuteDiscordChannel$ = function (a, b, c) {
	return {$: 94, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Server_SetMuteDiscordChannel = F3($author$project$Evergreen$V419$Types$Server_SetMuteDiscordChannel$);
var $author$project$Evergreen$V419$Types$Server_SetMuteDiscordGuild$ = function (a, b) {
	return {$: 97, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_SetMuteDiscordGuild = F2($author$project$Evergreen$V419$Types$Server_SetMuteDiscordGuild$);
var $author$project$Evergreen$V419$Types$Server_SetMuteDiscordThread$ = function (a, b, c, d) {
	return {$: 95, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$Server_SetMuteDiscordThread = F4($author$project$Evergreen$V419$Types$Server_SetMuteDiscordThread$);
var $author$project$Evergreen$V419$Types$Server_SetMuteGuild$ = function (a, b) {
	return {$: 96, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_SetMuteGuild = F2($author$project$Evergreen$V419$Types$Server_SetMuteGuild$);
var $author$project$Evergreen$V419$Types$Server_SetMuteSlackChannel$ = function (a, b, c) {
	return {$: 99, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Server_SetMuteSlackChannel = F3($author$project$Evergreen$V419$Types$Server_SetMuteSlackChannel$);
var $author$project$Evergreen$V419$Types$Server_SetMuteSlackThread$ = function (a, b, c, d) {
	return {$: 100, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$Server_SetMuteSlackThread = F4($author$project$Evergreen$V419$Types$Server_SetMuteSlackThread$);
var $author$project$Evergreen$V419$Types$Server_SetMuteSlackWorkspace$ = function (a, b) {
	return {$: 98, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_SetMuteSlackWorkspace = F2($author$project$Evergreen$V419$Types$Server_SetMuteSlackWorkspace$);
var $author$project$Evergreen$V419$Types$Server_SetMuteThread$ = function (a, b, c, d) {
	return {$: 93, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$Server_SetMuteThread = F4($author$project$Evergreen$V419$Types$Server_SetMuteThread$);
var $author$project$Evergreen$V419$Types$Server_SetName$ = function (a, b) {
	return {$: 48, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_SetName = F2($author$project$Evergreen$V419$Types$Server_SetName$);
var $author$project$Evergreen$V419$Types$Server_SetPublicKey$ = function (a, b) {
	return {$: 106, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_SetPublicKey = F2($author$project$Evergreen$V419$Types$Server_SetPublicKey$);
var $author$project$Evergreen$V419$Types$Server_SetSlackWorkspaceNotificationLevel$ = function (a, b) {
	return {$: 55, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_SetSlackWorkspaceNotificationLevel = F2($author$project$Evergreen$V419$Types$Server_SetSlackWorkspaceNotificationLevel$);
var $author$project$Evergreen$V419$Types$Server_SetUserColor$ = function (a, b) {
	return {$: 49, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_SetUserColor = F2($author$project$Evergreen$V419$Types$Server_SetUserColor$);
var $author$project$Evergreen$V419$Types$Server_SetUserIcon$ = function (a, b) {
	return {$: 50, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_SetUserIcon = F2($author$project$Evergreen$V419$Types$Server_SetUserIcon$);
var $author$project$Evergreen$V419$Types$Server_Slack_AddReactionEmoji$ = function (a, b, c, d) {
	return {$: 13, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$Server_Slack_AddReactionEmoji = F4($author$project$Evergreen$V419$Types$Server_Slack_AddReactionEmoji$);
var $author$project$Evergreen$V419$Types$Server_Slack_ChannelRenamed$ = function (a, b, c) {
	return {$: 7, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Server_Slack_ChannelRenamed = F3($author$project$Evergreen$V419$Types$Server_Slack_ChannelRenamed$);
var $author$project$Evergreen$V419$Types$Server_Slack_CustomEmojiAdded$ = function (a, b, c) {
	return {$: 12, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Server_Slack_CustomEmojiAdded = F3($author$project$Evergreen$V419$Types$Server_Slack_CustomEmojiAdded$);
var $author$project$Evergreen$V419$Types$Server_Slack_CustomEmojisLoaded = function (a) {
	return {$: 11, a: a};
};
var $author$project$Evergreen$V419$Types$Server_Slack_DeleteMessage$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_Slack_DeleteMessage = F2($author$project$Evergreen$V419$Types$Server_Slack_DeleteMessage$);
var $author$project$Evergreen$V419$Types$Server_Slack_EditMessage$ = function (a, b, c, d, e) {
	return {$: 2, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V419$Types$Server_Slack_EditMessage = F5($author$project$Evergreen$V419$Types$Server_Slack_EditMessage$);
var $author$project$Evergreen$V419$Types$Server_Slack_GotMessageEmbed$ = function (a, b, c) {
	return {$: 9, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Server_Slack_GotMessageEmbed = F3($author$project$Evergreen$V419$Types$Server_Slack_GotMessageEmbed$);
var $author$project$Evergreen$V419$Types$Server_Slack_LinkedUserLoaded$ = function (a, b, c) {
	return {$: 10, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$Server_Slack_LinkedUserLoaded = F3($author$project$Evergreen$V419$Types$Server_Slack_LinkedUserLoaded$);
var $author$project$Evergreen$V419$Types$Server_Slack_NeedsAuthAgain = function (a) {
	return {$: 8, a: a};
};
var $author$project$Evergreen$V419$Types$Server_Slack_RemoveReactionEmoji$ = function (a, b, c, d) {
	return {$: 14, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$Server_Slack_RemoveReactionEmoji = F4($author$project$Evergreen$V419$Types$Server_Slack_RemoveReactionEmoji$);
var $author$project$Evergreen$V419$Types$Server_Slack_SendMessage$ = function (a, b, c, d, e, f) {
	return {$: 1, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Evergreen$V419$Types$Server_Slack_SendMessage = F6($author$project$Evergreen$V419$Types$Server_Slack_SendMessage$);
var $author$project$Evergreen$V419$Types$Server_Slack_UnlinkUser = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V419$Types$Server_Slack_UserLoaded$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_Slack_UserLoaded = F2($author$project$Evergreen$V419$Types$Server_Slack_UserLoaded$);
var $author$project$Evergreen$V419$Types$Server_Slack_WorkspaceRenamed$ = function (a, b) {
	return {$: 6, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_Slack_WorkspaceRenamed = F2($author$project$Evergreen$V419$Types$Server_Slack_WorkspaceRenamed$);
var $author$project$Evergreen$V419$Types$Server_StartReloadingDiscordUser$ = function (a, b) {
	return {$: 69, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_StartReloadingDiscordUser = F2($author$project$Evergreen$V419$Types$Server_StartReloadingDiscordUser$);
var $author$project$Evergreen$V419$Types$Server_TextEditor = function (a) {
	return {$: 61, a: a};
};
var $author$project$Evergreen$V419$Types$Server_UnlinkDiscordUser = function (a) {
	return {$: 63, a: a};
};
var $author$project$Evergreen$V419$Types$Server_UpdateDiscordMembers$ = function (a, b) {
	return {$: 85, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$Server_UpdateDiscordMembers = F2($author$project$Evergreen$V419$Types$Server_UpdateDiscordMembers$);
var $author$project$Evergreen$V419$Types$Server_VoiceChatChange = function (a) {
	return {$: 89, a: a};
};
var $author$project$Evergreen$V419$Types$Server_YouJoinedGuildByInvite = function (a) {
	return {$: 26, a: a};
};
var $author$project$Evergreen$V419$Call$Server_Left$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V419$Call$Server_Left = F2($author$project$Evergreen$V419$Call$Server_Left$);
var $author$project$Evergreen$V419$Call$Server_OtherJoined$ = function (a, b, c) {
	return {$: 1, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Call$Server_OtherJoined = F3($author$project$Evergreen$V419$Call$Server_OtherJoined$);
var $author$project$Evergreen$V419$Call$Server_RecordingChanged$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $author$project$Evergreen$V419$Call$Server_RecordingChanged = F2($author$project$Evergreen$V419$Call$Server_RecordingChanged$);
var $author$project$Evergreen$V419$Call$Server_SetRemoteCallData$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Evergreen$V419$Call$Server_SetRemoteCallData = F2($author$project$Evergreen$V419$Call$Server_SetRemoteCallData$);
var $author$project$Evergreen$V419$Call$Server_YouJoined$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$Call$Server_YouJoined = F2($author$project$Evergreen$V419$Call$Server_YouJoined$);
var $author$project$Evergreen$Migrate$V419$migrate_Call_ServerChange = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Call$Server_YouJoined$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Call_CallId(p1));
		case 1:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Call$Server_OtherJoined$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Call_ConnectionId(p1),
				{audioInputEnabled: true, screenShareEnabled: false, videoInputEnabled: true});
		case 2:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Call$Server_Left$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Call_ConnectionId(p1));
		case 3:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Call$Server_SetRemoteCallData$(
				$author$project$Evergreen$Migrate$V419$migrate_Call_ConnectionId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Call_RemoteCallData(p1));
		default:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Call$Server_RecordingChanged$(
				$author$project$Evergreen$Migrate$V419$migrate_Call_CallId(p0),
				$elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Call_RecordingStatus, p1));
	}
};
var $author$project$Evergreen$V419$Pages$Admin$TypeThatIsAlwaysInvalid = 0;
var $author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_TypeThatIsAlwaysInvalid = function (old) {
	return 0;
};
var $author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_InitAdminData = function (old) {
	return {
		checkToFrontendValidation: $author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_TypeThatIsAlwaysInvalid(old.checkToFrontendValidation),
		connections: $elm$core$List$map$(
			A2(
				$elm$core$Tuple$mapBoth,
				$author$project$Evergreen$Migrate$V419$migrate_SessionIdHash_SessionIdHash,
				A2($author$project$Evergreen$Migrate$V419$migrate_NonemptyDict_NonemptyDict, $elm$core$Basics$identity, $author$project$Evergreen$Migrate$V419$migrate_LocalState_ConnectionData)),
			old.connections),
		discordLinkLimit: old.discordLinkLimit,
		discordLinkingEnabled: old.discordLinkingEnabled,
		emailNotificationsEnabled: old.emailNotificationsEnabled,
		filesCount: old.filesCount,
		lastBackup: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_LocalState_LastBackup, old.lastBackup),
		loadingDiscordChannels: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Discord_Id,
						$author$project$Evergreen$Migrate$V419$migrate_LocalState_LoadingDiscordChannel($elm$core$Basics$identity))),
				$lamdera$containers$SeqDict$fromList),
			old.loadingDiscordChannels),
		logs: $author$project$Evergreen$Migrate$V419$migrate_Pagination_Pagination$($author$project$Evergreen$Migrate$V419$migrate_LocalState_LogWithTime, old.logs),
		notifyAdminsBotUserId: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, old.notifyAdminsBotUserId),
		notifyAdminsToken: old.notifyAdminsToken,
		openRouterKey: old.openRouterKey,
		postmarkApiKey: $author$project$Evergreen$Migrate$V419$migrate_Postmark_ApiKey(old.postmarkApiKey),
		privateVapidKey: $author$project$Evergreen$Migrate$V419$migrate_LocalState_PrivateVapidKey(old.privateVapidKey),
		seqDictWorks: old.seqDictWorks,
		serverSecretRegeneratedAt: old.serverSecretRegeneratedAt,
		signupsEnabled: old.signupsEnabled,
		slackLinkLimit: old.slackLinkLimit,
		slackLinkingEnabled: old.slackLinkingEnabled,
		twoFactorAuthentication: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					$elm$core$Tuple$mapFirst($author$project$Evergreen$Migrate$V419$migrate_Id_Id)),
				$lamdera$containers$SeqDict$fromList),
			old.twoFactorAuthentication),
		vulnerabilityChecks: old.vulnerabilityChecks,
		wordSpellingGameEnglish: $author$project$Evergreen$Migrate$V419$migrate_LocalState_WordSpellingGameStatus(old.wordSpellingGameEnglish),
		wordSpellingGameSwedish: $author$project$Evergreen$Migrate$V419$migrate_LocalState_WordSpellingGameStatus(old.wordSpellingGameSwedish)
	};
};
var $author$project$Evergreen$V419$TextEditor$Server_EditChange$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$TextEditor$Server_EditChange = F2($author$project$Evergreen$V419$TextEditor$Server_EditChange$);
var $author$project$Evergreen$V419$TextEditor$Server_Redo = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V419$TextEditor$Server_Reset = {$: 1};
var $author$project$Evergreen$V419$TextEditor$Server_Undo = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_TextEditor_ServerChange = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$TextEditor$Server_EditChange$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_TextEditor_EditChange(p1));
		case 1:
			return $author$project$Evergreen$V419$TextEditor$Server_Reset;
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$TextEditor$Server_Undo(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$TextEditor$Server_Redo(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
	}
};
var $author$project$Evergreen$V419$Types$NoReplyData = {$: 0};
var $author$project$Evergreen$V419$Types$RepliedToGame = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V419$Types$RepliedToMessage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Types$RepliedToThreadMessage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_RepliedToData = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$Types$NoReplyData;
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$RepliedToMessage(
				$author$project$Evergreen$Migrate$V419$migrate_Message_Message$($author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, p0));
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$RepliedToThreadMessage(
				$author$project$Evergreen$Migrate$V419$migrate_Message_Message$($author$project$Evergreen$Migrate$V419$migrate_Id_ThreadMessageId, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, p0));
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$RepliedToGame(
				$author$project$Evergreen$Migrate$V419$migrate_Game_LoadedMatch(p0));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_ServerChange = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Server_SendMessage(
				{
					attachedFiles: $elm$core$Basics$composeR$(
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileData)),
							$lamdera$containers$SeqDict$fromList),
						p0.attachedFiles),
					content: $author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty$(
						A2($author$project$Evergreen$Migrate$V419$migrate_RichText_RichText, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id),
						p0.content),
					guildOrDmId: $author$project$Evergreen$Migrate$V419$migrate_Id_GuildOrDmId(p0.guildOrDmId),
					repliedToData: $author$project$Evergreen$Migrate$V419$migrate_Types_RepliedToData(p0.repliedToData),
					sender: $author$project$Evergreen$Migrate$V419$migrate_User_FrontendUser(p0.sender),
					senderId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0.senderId),
					sentAt: p0.sentAt,
					stickers: $elm$core$Basics$composeR$(
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Sticker_StickerData)),
							$lamdera$containers$SeqDict$fromList),
						p0.stickers),
					threadRoute: $author$project$Evergreen$Migrate$V419$migrate_Message_ThreadRouteWithRepliedTo(p0.threadRoute)
				});
		case 1:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			var p5 = old.f;
			return $author$project$Evergreen$V419$Types$Server_Slack_SendMessage$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Id_SlackGuildOrDmId(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute(p2),
				$author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty$(
					A2($author$project$Evergreen$Migrate$V419$migrate_RichText_RichText, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id),
					p3),
				$elm$core$Basics$composeR$(
					$lamdera$containers$SeqDict$toList,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map(
							A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileData)),
						$lamdera$containers$SeqDict$fromList),
					p4),
				$elm$core$Maybe$map$(
					A3($author$project$Evergreen$Migrate$V419$migrate_Message_Message, $author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id),
					p5));
		case 2:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			return $author$project$Evergreen$V419$Types$Server_Slack_EditMessage$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_SlackGuildOrDmId(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p3),
				$author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty$(
					A2($author$project$Evergreen$Migrate$V419$migrate_RichText_RichText, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id),
					p4));
		case 3:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_Slack_DeleteMessage$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_SlackGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p1));
		case 4:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Server_Slack_UnlinkUser(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0));
		case 5:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_Slack_UserLoaded$(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_SlackFrontendUser(p1));
		case 6:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_Slack_WorkspaceRenamed$(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0),
				p1);
		case 7:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Server_Slack_ChannelRenamed$(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_ChannelName_ChannelName(p2));
		case 8:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Server_Slack_NeedsAuthAgain(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0));
		case 9:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Server_Slack_GotMessageEmbed$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_SlackGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p1),
				$elm$core$Tuple$mapSecond$(
					$elm$core$Result$map($author$project$Evergreen$Migrate$V419$migrate_Embed_EmbedData),
					p2));
		case 10:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Server_Slack_LinkedUserLoaded$(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p1),
				{
					customEmojis: $elm$core$Basics$composeR$(
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_CustomEmoji_CustomEmojiData)),
							$lamdera$containers$SeqDict$fromList),
						p2.customEmojis),
					dmChannels: $elm$core$Basics$composeR$(
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_SlackFrontendDmChannel)),
							$lamdera$containers$SeqDict$fromList),
						p2.dmChannels),
					markNewDmsAsViewed: p2.markNewDmsAsViewed,
					users: $elm$core$Basics$composeR$(
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_UserSession_SlackFrontendUser)),
							$lamdera$containers$SeqDict$fromList),
						p2.users),
					workspaces: $elm$core$Basics$composeR$(
						$lamdera$containers$SeqDict$toList,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_SlackFrontendWorkspace)),
							$lamdera$containers$SeqDict$fromList),
						p2.workspaces)
				});
		case 11:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Server_Slack_CustomEmojisLoaded(
				$elm$core$Basics$composeR$(
					$lamdera$containers$SeqDict$toList,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map(
							A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_CustomEmoji_CustomEmojiData)),
						$lamdera$containers$SeqDict$fromList),
					p0));
		case 12:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Server_Slack_CustomEmojiAdded$(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_CustomEmoji_CustomEmojiData(p2));
		case 13:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$Server_Slack_AddReactionEmoji$(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_SlackGuildOrDmId(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji(p3));
		case 14:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$Server_Slack_RemoveReactionEmoji$(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_SlackGuildOrDmId(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji(p3));
		case 15:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			var p5 = old.f;
			var p6 = old.g;
			return $author$project$Evergreen$V419$Types$Server_Discord_SendMessage$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Id_DiscordGuildOrDmId(p1),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_DiscordFrontendUser(p2),
				$author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty$(
					A2($author$project$Evergreen$Migrate$V419$migrate_RichText_RichText, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id),
					p3),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMaybeMessage(p4),
				$elm$core$Basics$composeR$(
					$lamdera$containers$SeqDict$toList,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map(
							A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileData)),
						$lamdera$containers$SeqDict$fromList),
					p5),
				$elm$core$Basics$composeR$(
					$lamdera$containers$SeqDict$toList,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map(
							A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Sticker_StickerData)),
						$lamdera$containers$SeqDict$fromList),
					p6));
		case 16:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$Server_NewChannel$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_ChannelName_ChannelName(p2),
				$author$project$Evergreen$Migrate$V419$migrate_ChannelDescription_ChannelDescription(p3));
		case 17:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Server_ImportedChannel$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_LocalState_FrontendChannel(p2));
		case 18:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$Server_EditChannel$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_ChannelName_ChannelName(p2),
				$author$project$Evergreen$Migrate$V419$migrate_ChannelDescription_ChannelDescription(p3));
		case 19:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_DeleteChannel$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1));
		case 20:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_EditGuildName$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_GuildName_GuildName(p1));
		case 21:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Server_DeleteGuild(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 22:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$Server_NewInviteLink$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_SecretId_SecretId(p3));
		case 23:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_DeleteInviteLink$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_SecretId_SecretId(p1));
		case 24:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$Server_MemberJoined$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_User_FrontendUser(p3));
		case 25:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_MemberLeft$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1));
		case 26:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Server_YouJoinedGuildByInvite(
				$elm$core$Basics$composeR$(
					$elm$core$Result$mapError($author$project$Evergreen$Migrate$V419$migrate_LocalState_JoinGuildError),
					$elm$core$Result$map(
						function (rec1) {
							return {
								guild: $author$project$Evergreen$Migrate$V419$migrate_LocalState_FrontendGuild(rec1.guild),
								guildId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(rec1.guildId),
								members: $elm$core$Basics$composeR$(
									$lamdera$containers$SeqDict$toList,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$List$map(
											A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_User_FrontendUser)),
										$lamdera$containers$SeqDict$fromList),
									rec1.members),
								owner: $author$project$Evergreen$Migrate$V419$migrate_User_FrontendUser(rec1.owner)
							};
						}),
					p0));
		case 27:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$Server_MemberTyping$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_GuildOrDmId(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute(p3));
		case 28:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			return $author$project$Evergreen$V419$Types$Server_DiscordGuildMemberTyping$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p3),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute(p4));
		case 29:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Server_DiscordDmMemberTyping$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p2));
		case 30:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$Server_AddReactionEmoji$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_GuildOrDmId(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji(p3));
		case 31:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$Server_CallRecordingStarted$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_GuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				p2,
				$author$project$Evergreen$Migrate$V419$migrate_NonemptySet_NonemptySet$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, p3));
		case 32:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Server_CallRecordingUploadProgress$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_GuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Message_CallRecordingFile$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, p2));
		case 33:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Server_CallRecordingUploadFinished$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_GuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p2));
		case 34:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Server_CallRecordingZipBuilt$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_GuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Message_CallRecordingZip(p2));
		case 35:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$Server_RemoveReactionEmoji$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_GuildOrDmId(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji(p3));
		case 36:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			return $author$project$Evergreen$V419$Types$Server_DiscordAddReactionGuildEmoji$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p3),
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji(p4));
		case 37:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$Server_DiscordAddReactionDmEmoji$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji(p3));
		case 38:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			return $author$project$Evergreen$V419$Types$Server_DiscordRemoveReactionGuildEmoji$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p3),
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji(p4));
		case 39:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$Server_DiscordRemoveReactionDmEmoji$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji(p3));
		case 40:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			var p5 = old.f;
			return $author$project$Evergreen$V419$Types$Server_SendEditMessage$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_GuildOrDmId(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p3),
				$author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty$(
					A2($author$project$Evergreen$Migrate$V419$migrate_RichText_RichText, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id),
					p4),
				$elm$core$Basics$composeR$(
					$lamdera$containers$SeqDict$toList,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map(
							A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileData)),
						$lamdera$containers$SeqDict$fromList),
					p5));
		case 41:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			var p5 = old.f;
			return $author$project$Evergreen$V419$Types$Server_DiscordSendEditGuildMessage$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p3),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p4),
				$author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty$(
					A2($author$project$Evergreen$Migrate$V419$migrate_RichText_RichText, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id),
					p5));
		case 42:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$Server_DiscordSendEditDmMessage$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DiscordDmId(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty$(
					A2($author$project$Evergreen$Migrate$V419$migrate_RichText_RichText, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id),
					p3));
		case 43:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$Server_MemberEditTyping$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p3));
		case 44:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_DeleteMessage$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p1));
		case 45:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Server_DiscordDeleteGuildMessage$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p2));
		case 46:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Server_DiscordForumPostDeleted$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p2));
		case 47:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_DiscordDeleteDmMessage$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1));
		case 48:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_SetName$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_PersonName_PersonName(p1));
		case 49:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_SetUserColor$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_UserColor_UserColor(p1));
		case 50:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_SetUserIcon$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash, p1));
		case 51:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_SetGuildIcon$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash, p1));
		case 52:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Server_PushNotificationsReset(p0);
		case 53:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_SetGuildNotificationLevel$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_User_NotificationLevel(p1));
		case 54:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_SetDiscordGuildNotificationLevel$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_User_NotificationLevel(p1));
		case 55:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_SetSlackWorkspaceNotificationLevel$(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_User_NotificationLevel(p1));
		case 56:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_PushNotificationFailed$(
				$author$project$Evergreen$Migrate$V419$migrate_Ports_SubscribeData(p0),
				p1);
		case 57:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_NewSession$(
				$author$project$Evergreen$Migrate$V419$migrate_SessionIdHash_SessionIdHash(p0),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_FrontendUserSession(p1));
		case 58:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Server_LoggedOut(
				$author$project$Evergreen$Migrate$V419$migrate_SessionIdHash_SessionIdHash(p0));
		case 59:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Server_CurrentlyViewing$(
				$author$project$Evergreen$Migrate$V419$migrate_SessionIdHash_SessionIdHash(p0),
				p1,
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing(p2));
		case 60:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Server_ClientDisconnected$(
				$author$project$Evergreen$Migrate$V419$migrate_SessionIdHash_SessionIdHash(p0),
				p1,
				p2);
		case 61:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Server_TextEditor(
				$author$project$Evergreen$Migrate$V419$migrate_TextEditor_ServerChange(p0));
		case 62:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_LinkDiscordUser$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_LinkedAndOtherDiscordUsers_DiscordFrontendCurrentUser(p1));
		case 63:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Server_UnlinkDiscordUser(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0));
		case 64:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			var p5 = old.f;
			return $author$project$Evergreen$V419$Types$Server_DiscordChannelCreated$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				p2,
				$author$project$Evergreen$Migrate$V419$migrate_ChannelName_ChannelName(p3),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_OptionalData$($elm$core$Basics$identity, p4),
				$elm$core$List$map$($author$project$Evergreen$Migrate$V419$migrate_Discord_Overwrite, p5));
		case 65:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_DiscordDmChannelCreated$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_NonemptyDict_NonemptyDict$(
					$author$project$Evergreen$Migrate$V419$migrate_Discord_Id,
					function (rec) {
						return rec;
					},
					p1));
		case 66:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_DiscordDmChannelRecipientRemoved$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1));
		case 67:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Server_DiscordNeedsAuthAgain(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0));
		case 68:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_DiscordUserLoadingDataIsDone$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$elm$core$Result$map$(
					function (rec1) {
						return {
							discordDms: $elm$core$Basics$composeR$(
								$lamdera$containers$SeqDict$toList,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$List$map(
										A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_DmChannel_DiscordFrontendDmChannel)),
									$lamdera$containers$SeqDict$fromList),
								rec1.discordDms),
							discordGuilds: $elm$core$Basics$composeR$(
								$lamdera$containers$SeqDict$toList,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$List$map(
										A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_DiscordFrontendGuild)),
									$lamdera$containers$SeqDict$fromList),
								rec1.discordGuilds),
							discordUsers: $elm$core$Basics$composeR$(
								$lamdera$containers$SeqDict$toList,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$List$map(
										A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_UserSession_DiscordFrontendUser)),
									$lamdera$containers$SeqDict$fromList),
								rec1.discordUsers),
							markEverythingAsViewed: rec1.markEverythingAsViewed
						};
					},
					p1));
		case 69:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_StartReloadingDiscordUser$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1));
		case 70:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_LoadingDiscordChannelChanged$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$elm$core$Maybe$map$(
					$author$project$Evergreen$Migrate$V419$migrate_LocalState_LoadingDiscordChannel($elm$core$Basics$identity),
					p1));
		case 71:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Server_LoadAdminData(
				$author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_InitAdminData(p0));
		case 72:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_NewLog$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Log_Log(p1));
		case 73:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Server_BackupGenerated(
				$author$project$Evergreen$Migrate$V419$migrate_LocalState_LastBackup(p0));
		case 74:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$Server_GotGuildMessageEmbed$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p2),
				$elm$core$Tuple$mapSecond$(
					$elm$core$Result$map($author$project$Evergreen$Migrate$V419$migrate_Embed_EmbedData),
					p3));
		case 75:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Server_GotDmMessageEmbed$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p1),
				$elm$core$Tuple$mapSecond$(
					$elm$core$Result$map($author$project$Evergreen$Migrate$V419$migrate_Embed_EmbedData),
					p2));
		case 76:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$Server_GotDiscordGuildMessageEmbed$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p2),
				$elm$core$Tuple$mapSecond$(
					$elm$core$Result$map($author$project$Evergreen$Migrate$V419$migrate_Embed_EmbedData),
					p3));
		case 77:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Server_GotDiscordDmMessageEmbed$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$elm$core$Tuple$mapSecond$(
					$elm$core$Result$map($author$project$Evergreen$Migrate$V419$migrate_Embed_EmbedData),
					p2));
		case 78:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Server_DiscordGuildJoinedOrCreated$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_LocalState_DiscordFrontendGuild(p2));
		case 79:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_DiscordGuildLeftOrDeleted$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1));
		case 80:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			return $author$project$Evergreen$V419$Types$Server_DiscordUpdateChannel$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_OptionalData$($elm$core$Basics$identity, p2),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_OptionalData$($elm$core$Basics$identity, p3),
				$elm$core$List$map$($author$project$Evergreen$Migrate$V419$migrate_Discord_Overwrite, p4));
		case 81:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_DiscordChannelDeleted$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1));
		case 82:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$Server_DiscordUpdateGuild$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_GuildName_GuildName(p1),
				$elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash, p2),
				$elm$core$Basics$composeR$(
					$lamdera$containers$SeqDict$toList,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map(
							A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_DiscordRole)),
						$lamdera$containers$SeqDict$fromList),
					p3));
		case 83:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Server_DiscordUpdateRole$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_LocalState_DiscordRole(p2));
		case 84:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_DiscordUpdateGuildCustomEmojis$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, p1));
		case 85:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_UpdateDiscordMembers$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_MembersAndOwner_MembersAndOwner$(
					$author$project$Evergreen$Migrate$V419$migrate_Discord_Id,
					function (rec) {
						return {
							joinedAt: rec.joinedAt,
							roles: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Discord_Id, rec.roles)
						};
					},
					p1));
		case 86:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			var p5 = old.f;
			return $author$project$Evergreen$V419$Types$Server_DiscordGuildMemberJoined$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p3),
				$author$project$Evergreen$Migrate$V419$migrate_PersonName_PersonName(p4),
				$author$project$Evergreen$Migrate$V419$migrate_UserColor_UserColor(p5));
		case 87:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Server_LinkedDiscordUserStickersLoaded(
				$elm$core$Basics$composeR$(
					$lamdera$containers$SeqDict$toList,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map(
							A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Sticker_StickerData)),
						$lamdera$containers$SeqDict$fromList),
					p0));
		case 88:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Server_LinkedDiscordUserCustomEmojisLoaded(
				$elm$core$Basics$composeR$(
					$lamdera$containers$SeqDict$toList,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map(
							A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_CustomEmoji_CustomEmojiData)),
						$lamdera$containers$SeqDict$fromList),
					p0));
		case 89:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Server_VoiceChatChange(
				$author$project$Evergreen$Migrate$V419$migrate_Call_ServerChange(p0));
		case 90:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Server_Game$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_GuildOrDmId(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Game_LocalChange(p2));
		case 91:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$Server_Drawing$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Drawing_AnchorType(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Drawing_LocalChange(p3));
		case 92:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Server_SetMuteChannel$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(p2));
		case 93:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$Server_SetMuteThread$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(p3));
		case 94:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Server_SetMuteDiscordChannel$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(p2));
		case 95:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$Server_SetMuteDiscordThread$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(p3));
		case 96:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_SetMuteGuild$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(p1));
		case 97:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_SetMuteDiscordGuild$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(p1));
		case 98:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_SetMuteSlackWorkspace$(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(p1));
		case 99:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Server_SetMuteSlackChannel$(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(p2));
		case 100:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$Server_SetMuteSlackThread$(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(p3));
		case 101:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_DiscordAvatarsLoaded$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_DiscordFrontendUser(p1));
		case 102:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_E2eeRequested$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DmId(p0),
				$elm$core$Tuple$mapBoth$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_SessionIdHash_SessionIdHash, p1));
		case 103:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Server_E2eeRequestCancelled(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DmId(p0));
		case 104:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_E2eeRequestDeclined$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1));
		case 105:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_E2eeAccepted$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DmId(p0),
				p1);
		case 106:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$Server_SetPublicKey$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_X25519_PublicKey(p1));
		case 107:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$Server_SendEncryptedMessage(
				{
					content: $author$project$Evergreen$Migrate$V419$migrate_Encryption_EncryptedData(p0.content),
					fileHashes: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash, p0.fileHashes),
					id: $author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DmId(p0.id),
					repliedToData: $author$project$Evergreen$Migrate$V419$migrate_Types_RepliedToData(p0.repliedToData),
					sender: $author$project$Evergreen$Migrate$V419$migrate_User_FrontendUser(p0.sender),
					senderId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0.senderId),
					sentAt: p0.sentAt,
					threadRoute: $author$project$Evergreen$Migrate$V419$migrate_Message_ThreadRouteWithRepliedTo(p0.threadRoute)
				});
		case 108:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			var p5 = old.f;
			return $author$project$Evergreen$V419$Types$Server_SendEncryptedEditMessage$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DmId(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p3),
				$lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash, p4),
				$author$project$Evergreen$Migrate$V419$migrate_Encryption_EncryptedData(p5));
		default:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$Server_DisableE2ee$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Viewing_DmId(p2));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_LocalMsg = function (old) {
	if (!old.$) {
		var p0 = old.a;
		var p1 = old.b;
		return $author$project$Evergreen$V419$Types$LocalChange$(
			$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
			$author$project$Evergreen$Migrate$V419$migrate_Types_LocalChange(p1));
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Types$ServerChange(
			$author$project$Evergreen$Migrate$V419$migrate_Types_ServerChange(p0));
	}
};
var $author$project$Evergreen$V419$Types$MessageHover$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$MessageHover = F2($author$project$Evergreen$V419$Types$MessageHover$);
var $author$project$Evergreen$V419$Types$MessageMenu = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$Types$NoMessageHover = {$: 0};
var $author$project$Evergreen$V419$Types$ReactionPopup$ = function (a, b, c) {
	return {$: 3, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$ReactionPopup = F3($author$project$Evergreen$V419$Types$ReactionPopup$);
var $author$project$Evergreen$V419$Types$MessageMenuClosing$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$MessageMenuClosing = F2($author$project$Evergreen$V419$Types$MessageMenuClosing$);
var $author$project$Evergreen$V419$Types$MessageMenuDragging = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$Types$MessageMenuFixed = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V419$Types$MessageMenuOpening = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_MessageHoverMobileMode = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$MessageMenuClosing$(
				$author$project$Evergreen$Migrate$V419$migrate_Quantity_Quantity(p0),
				$elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Types_EditMessage, p1));
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$MessageMenuOpening(
				{
					offset: $author$project$Evergreen$Migrate$V419$migrate_Quantity_Quantity(p0.offset),
					targetOffset: $author$project$Evergreen$Migrate$V419$migrate_Quantity_Quantity(p0.targetOffset)
				});
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$MessageMenuDragging(
				{
					offset: $author$project$Evergreen$Migrate$V419$migrate_Quantity_Quantity(p0.offset),
					previousOffset: $author$project$Evergreen$Migrate$V419$migrate_Quantity_Quantity(p0.previousOffset),
					time: p0.time
				});
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$MessageMenuFixed(
				$author$project$Evergreen$Migrate$V419$migrate_Quantity_Quantity(p0));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_MessageMenuExtraOptions = function (old) {
	return {
		guildOrDmId: $author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId(old.guildOrDmId),
		imageUrl: old.imageUrl,
		isThreadStarter: old.isThreadStarter,
		linkUrl: old.linkUrl,
		mobileMode: $author$project$Evergreen$Migrate$V419$migrate_Types_MessageHoverMobileMode(old.mobileMode),
		position: $author$project$Evergreen$Migrate$V419$migrate_Coord_Coord$($author$project$Evergreen$Migrate$V419$migrate_CssPixels_CssPixels, old.position),
		threadRoute: $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(old.threadRoute)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_MessageHover = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$Types$NoMessageHover;
		case 1:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$MessageHover$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p1));
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$MessageMenu(
				$author$project$Evergreen$Migrate$V419$migrate_Types_MessageMenuExtraOptions(p0));
		default:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$ReactionPopup$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p1),
				p2);
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_NewChannelForm = function (old) {
	return old;
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_RevealedSpoilers = function (old) {
	return {
		messages: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
						$author$project$Evergreen$Migrate$V419$migrate_NonemptySet_NonemptySet($elm$core$Basics$identity))),
				$lamdera$containers$SeqDict$fromList),
			old.messages),
		threadMessages: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
						A2(
							$elm$core$Basics$composeR,
							$lamdera$containers$SeqDict$toList,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$map(
									A2(
										$elm$core$Tuple$mapBoth,
										$author$project$Evergreen$Migrate$V419$migrate_Id_Id,
										$author$project$Evergreen$Migrate$V419$migrate_NonemptySet_NonemptySet($elm$core$Basics$identity))),
								$lamdera$containers$SeqDict$fromList)))),
				$lamdera$containers$SeqDict$fromList),
			old.threadMessages)
	};
};
var $author$project$Evergreen$V419$Types$E2eeKeys_Error = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Types$E2eeKeys_NotChecked = {$: 0};
var $author$project$Evergreen$V419$Types$E2eeKeys_Valid = {$: 2};
var $author$project$Evergreen$Migrate$V419$migrate_Types_E2eeKeysValid = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$Types$E2eeKeys_NotChecked;
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$E2eeKeys_Error(p0);
		default:
			return $author$project$Evergreen$V419$Types$E2eeKeys_Valid;
	}
};
var $author$project$Evergreen$V419$Types$LoadedSlackWorkspaces = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Types$SlackLinkingDisabled = {$: 0};
var $author$project$Evergreen$V419$Types$SlackLinkLimitReached = {$: 1};
var $author$project$Evergreen$V419$Types$SlackWorkspaceHttpError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_LinkSlackWorkspaceError = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Types$SlackWorkspaceHttpError(
			$author$project$Evergreen$Migrate$V419$migrate_Slack_HttpError(p0));
	} else {
		return $author$project$Evergreen$V419$Types$SlackLinkLimitReached;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_LinkSlackResult = function (old) {
	if (!old.$) {
		return $author$project$Evergreen$V419$Types$SlackLinkingDisabled;
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Types$LoadedSlackWorkspaces(
			$author$project$Evergreen$Migrate$V419$migrate_List_Nonempty_Nonempty$(
				$elm$core$Result$mapError($author$project$Evergreen$Migrate$V419$migrate_Types_LinkSlackWorkspaceError),
				p0));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_UserColor_Selection = function (old) {
	return {
		lastValid: $author$project$Evergreen$Migrate$V419$migrate_UserColor_UserColor(old.lastValid),
		selected: function (rec) {
			return rec;
		}(old.selected)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_UserOptionsModel = function (old) {
	return {
		color: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_UserColor_Selection, old.color),
		debugData: old.debugData,
		domainWhitelistInput: old.domainWhitelistInput,
		e2eeKeysValid: $author$project$Evergreen$Migrate$V419$migrate_Types_E2eeKeysValid(old.e2eeKeysValid),
		linkSlackResult: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Types_LinkSlackResult, old.linkSlackResult),
		name: $author$project$Evergreen$Migrate$V419$migrate_Editable_Model(old.name),
		pressedSubmitSlackData: old.pressedSubmitSlackData,
		privateKeyText: old.privateKeyText,
		removedSlackTeams: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Slack_Id, old.removedSlackTeams),
		slackCookie: old.slackCookie,
		slackTeamsJson: old.slackTeamsJson
	};
};
var $author$project$Evergreen$V419$X25519$PrivateKey = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_X25519_PrivateKey = function (old) {
	var p0 = old;
	return $author$project$Evergreen$Migrate$V419$migrate_X25519_Key(p0);
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_LoggedIn2 = function (old) {
	return {
		accountDeletionBannerClosed: old.accountDeletionBannerClosed,
		admin: $author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_Model(old.admin),
		channelScrollPosition: $author$project$Evergreen$Migrate$V419$migrate_Scroll_ScrollPosition(old.channelScrollPosition),
		drafts: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					$elm$core$Tuple$mapFirst(
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute))),
				$lamdera$containers$SeqDict$fromList),
			old.drafts),
		drawingMode: $author$project$Evergreen$Migrate$V419$migrate_Drawing_Model(old.drawingMode),
		e2eeError: old.e2eeError,
		e2eeKeysOnThisDevice: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, old.e2eeKeysOnThisDevice),
		e2eePrivateKeyText: old.e2eePrivateKeyText,
		e2eeSectionsExpanded: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					$elm$core$Tuple$mapFirst($author$project$Evergreen$Migrate$V419$migrate_Id_Id)),
				$lamdera$containers$SeqDict$fromList),
			old.e2eeSectionsExpanded),
		editChannelForm: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id),
						$author$project$Evergreen$Migrate$V419$migrate_Types_EditChannelForm)),
				$lamdera$containers$SeqDict$fromList),
			old.editChannelForm),
		editGuildForm: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Types_EditGuildForm)),
				$lamdera$containers$SeqDict$fromList),
			old.editGuildForm),
		editMessage: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute),
						$author$project$Evergreen$Migrate$V419$migrate_Types_EditMessage)),
				$lamdera$containers$SeqDict$fromList),
			old.editMessage),
		emojiSelector: $author$project$Evergreen$Migrate$V419$migrate_Emoji_Model(old.emojiSelector),
		encryptionRequests: $author$project$Evergreen$Migrate$V419$migrate_Types_EncryptionRequests(old.encryptionRequests),
		externalLinkWarning: old.externalLinkWarning,
		fileDragOverCount: $author$project$Evergreen$Migrate$V419$migrate_Types_FileDrag(old.fileDragOverCount),
		filesToUpload: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute),
						A2($author$project$Evergreen$Migrate$V419$migrate_NonemptyDict_NonemptyDict, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileStatus))),
				$lamdera$containers$SeqDict$fromList),
			old.filesToUpload),
		games: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_GuildOrDmId, $author$project$Evergreen$Migrate$V419$migrate_Game_Model)),
				$lamdera$containers$SeqDict$fromList),
			old.games),
		guildIconEditor: $elm$core$Maybe$map$(
			A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_ImageEditor_Model),
			old.guildIconEditor),
		isReloading: old.isReloading,
		localState: $author$project$Evergreen$Migrate$V419$migrate_Local_Local$($author$project$Evergreen$Migrate$V419$migrate_Types_LocalMsg, $author$project$Evergreen$Migrate$V419$migrate_LocalState_LocalState, old.localState),
		messageHover: $author$project$Evergreen$Migrate$V419$migrate_Types_MessageHover(old.messageHover),
		newChannelForm: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Types_NewChannelForm)),
				$lamdera$containers$SeqDict$fromList),
			old.newChannelForm),
		newGuildForm: old.newGuildForm,
		newMessagesWhileNotScrolledToBottom: old.newMessagesWhileNotScrolledToBottom,
		previousTextInputFocus: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_MessageInput_TextInputFocus, old.previousTextInputFocus),
		profilePictureEditor: $author$project$Evergreen$Migrate$V419$migrate_ImageEditor_Model(old.profilePictureEditor),
		replyTo: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute),
						$author$project$Evergreen$Migrate$V419$migrate_Message_RepliedTo($author$project$Evergreen$Migrate$V419$migrate_Id_ChannelMessageId))),
				$lamdera$containers$SeqDict$fromList),
			old.replyTo),
		revealedSpoilers: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId, $author$project$Evergreen$Migrate$V419$migrate_Types_RevealedSpoilers)),
				$lamdera$containers$SeqDict$fromList),
			old.revealedSpoilers),
		searchOverlayQuery: old.searchOverlayQuery,
		searchOverlaySelection: old.searchOverlaySelection,
		showEmojiSelector: $author$project$Evergreen$Migrate$V419$migrate_Types_EmojiSelector(old.showEmojiSelector),
		showFileToUploadInfo: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileDataWithImage, old.showFileToUploadInfo),
		showInviteLinkQrCode: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_SecretId_SecretId, old.showInviteLinkQrCode),
		showNewPrivateKey: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_X25519_PrivateKey, old.showNewPrivateKey),
		sidebarMode: $author$project$Evergreen$Migrate$V419$migrate_Route_ChannelSidebarMode(old.sidebarMode),
		textEditor: $author$project$Evergreen$Migrate$V419$migrate_TextEditor_Model(old.textEditor),
		textInputFocus: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_MessageInput_TextInputFocus, old.textInputFocus),
		twoFactor: $author$project$Evergreen$Migrate$V419$migrate_TwoFactorAuthentication_TwoFactorState(old.twoFactor),
		typedTextCounter: old.typedTextCounter,
		typingDebouncer: old.typingDebouncer,
		userOptions: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Types_UserOptionsModel, old.userOptions),
		voiceChat: $author$project$Evergreen$Migrate$V419$migrate_Call_Model(old.voiceChat)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_LoginStatus = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Types$LoggedIn(
			$author$project$Evergreen$Migrate$V419$migrate_Types_LoggedIn2(p0));
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Types$NotLoggedIn(
			{
				loginForm: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_LoginForm_LoginForm, p0.loginForm),
				recoveryLogin: $author$project$Evergreen$Migrate$V419$migrate_RecoveryLogin_Model(p0.recoveryLogin),
				textInputFocus: $elm$core$Maybe$map$(
					function (rec1) {
						return {
							direction: $author$project$Evergreen$Migrate$V419$migrate_Range_SelectionDirection(rec1.direction),
							htmlId: rec1.htmlId,
							selection: $author$project$Evergreen$Migrate$V419$migrate_Range_Range(rec1.selection)
						};
					},
					p0.textInputFocus),
				useInviteAfterLoggedIn: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_SecretId_SecretId, p0.useInviteAfterLoggedIn)
			});
	}
};
var $author$project$Evergreen$V419$Types$LoginWithEmail = 0;
var $author$project$Evergreen$V419$Types$LoginWithRecoveryPassword = 1;
var $author$project$Evergreen$Migrate$V419$migrate_Types_LoginType = function (old) {
	if (!old) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Evergreen$V419$Types$PublicGoMatch_Loaded$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$PublicGoMatch_Loaded = F2($author$project$Evergreen$V419$Types$PublicGoMatch_Loaded$);
var $author$project$Evergreen$V419$Types$PublicGoMatch_Loading = {$: 1};
var $author$project$Evergreen$V419$Types$PublicGoMatch_Missing = {$: 3};
var $author$project$Evergreen$V419$Types$PublicGoMatch_NotLoaded = {$: 0};
var $author$project$Evergreen$Migrate$V419$migrate_Go_PublicGoMatchData = function (old) {
	return {
		actions: $elm$core$Array$map$($author$project$Evergreen$Migrate$V419$migrate_Go_ActionWithTime, old.actions),
		cache: $author$project$Evergreen$Migrate$V419$migrate_Go_Shared(old.cache),
		creatorUser: $author$project$Evergreen$Migrate$V419$migrate_User_FrontendUser(old.creatorUser),
		joinedUser: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_User_FrontendUser, old.joinedUser),
		setup: $author$project$Evergreen$Migrate$V419$migrate_Go_ValidatedSetup(old.setup)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_PublicGoMatch = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$Types$PublicGoMatch_NotLoaded;
		case 1:
			return $author$project$Evergreen$V419$Types$PublicGoMatch_Loading;
		case 2:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$PublicGoMatch_Loaded$(
				$author$project$Evergreen$Migrate$V419$migrate_Go_PublicGoMatchData(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Go_GameModel(p1));
		default:
			return $author$project$Evergreen$V419$Types$PublicGoMatch_Missing;
	}
};
var $author$project$Evergreen$V419$Types$AdminToFrontend = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V419$Types$AiChatToFrontend = function (a) {
	return {$: 9, a: a};
};
var $author$project$Evergreen$V419$Types$ChangeBroadcast = function (a) {
	return {$: 7, a: a};
};
var $author$project$Evergreen$V419$Types$CheckLoginResponse$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$CheckLoginResponse = F2($author$project$Evergreen$V419$Types$CheckLoginResponse$);
var $author$project$Evergreen$V419$Types$ExportChannelResponse = function (a) {
	return {$: 16, a: a};
};
var $author$project$Evergreen$V419$Types$GetLoginTokenRateLimited = {$: 2};
var $author$project$Evergreen$V419$Types$GetPublicGoMatchResponse = function (a) {
	return {$: 15, a: a};
};
var $author$project$Evergreen$V419$Types$ImportChannelResponse$ = function (a, b) {
	return {$: 17, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$ImportChannelResponse = F2($author$project$Evergreen$V419$Types$ImportChannelResponse$);
var $author$project$Evergreen$V419$Types$LinkDiscordResponse = function (a) {
	return {$: 12, a: a};
};
var $author$project$Evergreen$V419$Types$LinkSlackResponse = function (a) {
	return {$: 13, a: a};
};
var $author$project$Evergreen$V419$Types$LocalChangeResponse$ = function (a, b) {
	return {$: 6, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$LocalChangeResponse = F2($author$project$Evergreen$V419$Types$LocalChangeResponse$);
var $author$project$Evergreen$V419$Types$LoggedOutSession = {$: 4};
var $author$project$Evergreen$V419$Types$LoginWithTokenResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Types$ProfilePictureEditorToFrontend = function (a) {
	return {$: 14, a: a};
};
var $author$project$Evergreen$V419$Types$ReloadDataResponse = function (a) {
	return {$: 11, a: a};
};
var $author$project$Evergreen$V419$Types$SignupsDisabledResponse = {$: 3};
var $author$project$Evergreen$V419$Types$TwoFactorAuthenticationToFrontend = function (a) {
	return {$: 8, a: a};
};
var $author$project$Evergreen$V419$Types$YouConnected = function (a) {
	return {$: 10, a: a};
};
var $author$project$Evergreen$V419$AiChat$AiMessageResponse$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$AiChat$AiMessageResponse = F2($author$project$Evergreen$V419$AiChat$AiMessageResponse$);
var $author$project$Evergreen$Migrate$V419$migrate_AiChat_ToFrontend = function (old) {
	var p0 = old.a;
	var p1 = old.b;
	return $author$project$Evergreen$V419$AiChat$AiMessageResponse$(
		$author$project$Evergreen$Migrate$V419$migrate_AiChat_ResponseId(p0),
		p1);
};
var $author$project$Evergreen$Migrate$V419$migrate_Go_PublicGoMatchResponse = function (old) {
	return {
		actions: $elm$core$Array$map$($author$project$Evergreen$Migrate$V419$migrate_Go_ActionWithTime, old.actions),
		creatorUser: $author$project$Evergreen$Migrate$V419$migrate_User_FrontendUser(old.creatorUser),
		joinedUser: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_User_FrontendUser, old.joinedUser),
		setup: $author$project$Evergreen$Migrate$V419$migrate_Go_ValidatedSetup(old.setup)
	};
};
var $author$project$Evergreen$V419$ImageEditor$ChangeGuildIconResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$ImageEditor$ChangeUserAvatarResponse = {$: 0};
var $author$project$Evergreen$Migrate$V419$migrate_ImageEditor_ToFrontend = function (old) {
	if (!old.$) {
		return $author$project$Evergreen$V419$ImageEditor$ChangeUserAvatarResponse;
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$ImageEditor$ChangeGuildIconResponse(
			$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
	}
};
var $author$project$Evergreen$V419$Pages$Admin$DownloadLastBackupChunk$ = function (a, b, c) {
	return {$: 4, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Pages$Admin$DownloadLastBackupChunk = F3($author$project$Evergreen$V419$Pages$Admin$DownloadLastBackupChunk$);
var $author$project$Evergreen$V419$Pages$Admin$ExportBackendFinished = {$: 3};
var $author$project$Evergreen$V419$Pages$Admin$ExportBackendProgress$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V419$Pages$Admin$ExportBackendProgress = F2($author$project$Evergreen$V419$Pages$Admin$ExportBackendProgress$);
var $author$project$Evergreen$V419$Pages$Admin$ImportBackendChunkReceived = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$ImportBackendResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$ExportAll = {$: 1};
var $author$project$Evergreen$V419$Pages$Admin$ExportSubset = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_ExportSubset = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Pages$Admin$ExportSubset(
			$author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_ExportSubsetSelection(p0));
	} else {
		return $author$project$Evergreen$V419$Pages$Admin$ExportAll;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_ToFrontend = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$ImportBackendResponse(p0);
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$ImportBackendChunkReceived(p0);
		case 2:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Pages$Admin$ExportBackendProgress$(
				$author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_ExportSubset(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_ExportProgress(p1));
		case 3:
			return $author$project$Evergreen$V419$Pages$Admin$ExportBackendFinished;
		default:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Pages$Admin$DownloadLastBackupChunk$(
				$author$project$Evergreen$Migrate$V419$migrate_LocalState_BackupContents(p0),
				p1,
				p2);
	}
};
var $author$project$Evergreen$V419$TwoFactorAuthentication$ConfirmTwoFactorAuthenticationResponse$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V419$TwoFactorAuthentication$ConfirmTwoFactorAuthenticationResponse = F2($author$project$Evergreen$V419$TwoFactorAuthentication$ConfirmTwoFactorAuthenticationResponse$);
var $author$project$Evergreen$V419$TwoFactorAuthentication$DisableTwoFactorAuthenticationResponse$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V419$TwoFactorAuthentication$DisableTwoFactorAuthenticationResponse = F2($author$project$Evergreen$V419$TwoFactorAuthentication$DisableTwoFactorAuthenticationResponse$);
var $author$project$Evergreen$V419$TwoFactorAuthentication$EnableTwoFactorAuthenticationResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_TwoFactorAuthentication_ToFrontend = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$TwoFactorAuthentication$EnableTwoFactorAuthenticationResponse(p0);
		case 1:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$TwoFactorAuthentication$ConfirmTwoFactorAuthenticationResponse$(p0, p1);
		default:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$TwoFactorAuthentication$DisableTwoFactorAuthenticationResponse$(p0, p1);
	}
};
var $author$project$Evergreen$V419$Types$LinkDiscordHttpError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Types$LinkDiscordLimitReached = {$: 1};
var $author$project$Evergreen$Migrate$V419$migrate_Types_LinkDiscordFailure = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Types$LinkDiscordHttpError(
			$author$project$Evergreen$Migrate$V419$migrate_Discord_HttpError(p0));
	} else {
		return $author$project$Evergreen$V419$Types$LinkDiscordLimitReached;
	}
};
var $author$project$Evergreen$V419$Types$IsAdminButNoData = {$: 1};
var $author$project$Evergreen$V419$Types$IsAdminLoginData = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Types$IsNotAdminLoginData = {$: 2};
var $author$project$Evergreen$Migrate$V419$migrate_Types_AdminStatusLoginData = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$IsAdminLoginData(
				$author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_InitAdminData(p0));
		case 1:
			return $author$project$Evergreen$V419$Types$IsAdminButNoData;
		default:
			return $author$project$Evergreen$V419$Types$IsNotAdminLoginData;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_LoginData = function (old) {
	return {
		adminData: $author$project$Evergreen$Migrate$V419$migrate_Types_AdminStatusLoginData(old.adminData),
		callRecordings: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Call_CallId, $author$project$Evergreen$Migrate$V419$migrate_Call_RecordingStatus)),
				$lamdera$containers$SeqDict$fromList),
			old.callRecordings),
		currentlyViewing: $author$project$Evergreen$Migrate$V419$migrate_UserSession_Viewing(old.currentlyViewing),
		customEmojis: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_CustomEmoji_CustomEmojiData)),
				$lamdera$containers$SeqDict$fromList),
			old.customEmojis),
		discordDmChannels: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_DmChannel_DiscordFrontendDmChannel)),
				$lamdera$containers$SeqDict$fromList),
			old.discordDmChannels),
		discordGuilds: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Discord_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_DiscordFrontendGuild)),
				$lamdera$containers$SeqDict$fromList),
			old.discordGuilds),
		discordUsers: $author$project$Evergreen$Migrate$V419$migrate_LinkedAndOtherDiscordUsers_LinkedAndOtherDiscordUsers(old.discordUsers),
		dmChannels: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_DmChannel_FrontendDmChannel)),
				$lamdera$containers$SeqDict$fromList),
			old.dmChannels),
		guilds: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_FrontendGuild)),
				$lamdera$containers$SeqDict$fromList),
			old.guilds),
		linkedSlackUsers: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id)),
				$lamdera$containers$SeqDict$fromList),
			old.linkedSlackUsers),
		otherSessions: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_SessionIdHash_SessionIdHash, $author$project$Evergreen$Migrate$V419$migrate_UserSession_FrontendUserSession)),
				$lamdera$containers$SeqDict$fromList),
			old.otherSessions),
		otherUsers: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_User_FrontendUser)),
				$lamdera$containers$SeqDict$fromList),
			old.otherUsers),
		publicVapidKey: old.publicVapidKey,
		session: $author$project$Evergreen$Migrate$V419$migrate_UserSession_UserSession(old.session),
		slackDmChannels: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_SlackFrontendDmChannel)),
				$lamdera$containers$SeqDict$fromList),
			old.slackDmChannels),
		slackUsers: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_UserSession_SlackFrontendUser)),
				$lamdera$containers$SeqDict$fromList),
			old.slackUsers),
		slackUsersNeedingAuth: $lamdera$containers$SeqSet$map$($author$project$Evergreen$Migrate$V419$migrate_Slack_Id, old.slackUsersNeedingAuth),
		slackWorkspaces: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Slack_Id, $author$project$Evergreen$Migrate$V419$migrate_LocalState_SlackFrontendWorkspace)),
				$lamdera$containers$SeqDict$fromList),
			old.slackWorkspaces),
		stickers: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Sticker_StickerData)),
				$lamdera$containers$SeqDict$fromList),
			old.stickers),
		textEditor: $author$project$Evergreen$Migrate$V419$migrate_TextEditor_LocalState(old.textEditor),
		twoFactorAuthenticationEnabled: old.twoFactorAuthenticationEnabled,
		user: $author$project$Evergreen$Migrate$V419$migrate_User_FrontendCurrentUser(old.user),
		voiceChatPeers: $elm$core$Basics$composeR$(
			$lamdera$containers$SeqDict$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					A2(
						$elm$core$Tuple$mapBoth,
						$author$project$Evergreen$Migrate$V419$migrate_Call_CallId,
						A2(
							$author$project$Evergreen$Migrate$V419$migrate_NonemptyDict_NonemptyDict,
							$elm$core$Tuple$mapFirst($author$project$Evergreen$Migrate$V419$migrate_Id_Id),
							$author$project$Evergreen$Migrate$V419$migrate_Call_RemoteCallData))),
				$lamdera$containers$SeqDict$fromList),
			old.voiceChatPeers)
	};
};
var $author$project$Evergreen$V419$Types$LoginSuccess = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Types$LoginTokenInvalid = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Types$NeedsAccountSetup = {$: 3};
var $author$project$Evergreen$V419$Types$NeedsTwoFactorToken = {$: 2};
var $author$project$Evergreen$V419$Types$RecoveryPasswordInvalid = {$: 4};
var $author$project$Evergreen$V419$Types$UserIsDeleted = {$: 5};
var $author$project$Evergreen$Migrate$V419$migrate_Types_LoginResult = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$LoginSuccess(
				$author$project$Evergreen$Migrate$V419$migrate_Types_LoginData(p0));
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$LoginTokenInvalid(p0);
		case 2:
			return $author$project$Evergreen$V419$Types$NeedsTwoFactorToken;
		case 3:
			return $author$project$Evergreen$V419$Types$NeedsAccountSetup;
		case 4:
			return $author$project$Evergreen$V419$Types$RecoveryPasswordInvalid;
		default:
			return $author$project$Evergreen$V419$Types$UserIsDeleted;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_ToFrontend = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$CheckLoginResponse$(
				$author$project$Evergreen$Migrate$V419$migrate_Types_LoginType(p0),
				$elm$core$Result$map$($author$project$Evergreen$Migrate$V419$migrate_Types_LoginData, p1));
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$LoginWithTokenResponse(
				$author$project$Evergreen$Migrate$V419$migrate_Types_LoginResult(p0));
		case 2:
			return $author$project$Evergreen$V419$Types$GetLoginTokenRateLimited;
		case 3:
			return $author$project$Evergreen$V419$Types$SignupsDisabledResponse;
		case 4:
			return $author$project$Evergreen$V419$Types$LoggedOutSession;
		case 5:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$AdminToFrontend(
				$author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_ToFrontend(p0));
		case 6:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$LocalChangeResponse$(
				$author$project$Evergreen$Migrate$V419$migrate_Local_ChangeId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Types_LocalChange(p1));
		case 7:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$ChangeBroadcast(
				$author$project$Evergreen$Migrate$V419$migrate_Types_LocalMsg(p0));
		case 8:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$TwoFactorAuthenticationToFrontend(
				$author$project$Evergreen$Migrate$V419$migrate_TwoFactorAuthentication_ToFrontend(p0));
		case 9:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$AiChatToFrontend(
				$author$project$Evergreen$Migrate$V419$migrate_AiChat_ToFrontend(p0));
		case 10:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$YouConnected(p0);
		case 11:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$ReloadDataResponse(
				$elm$core$Result$map$($author$project$Evergreen$Migrate$V419$migrate_Types_LoginData, p0));
		case 12:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$LinkDiscordResponse(
				$elm$core$Result$mapError$($author$project$Evergreen$Migrate$V419$migrate_Types_LinkDiscordFailure, p0));
		case 13:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$LinkSlackResponse(
				$author$project$Evergreen$Migrate$V419$migrate_Types_LinkSlackResult(p0));
		case 14:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$ProfilePictureEditorToFrontend(
				$author$project$Evergreen$Migrate$V419$migrate_ImageEditor_ToFrontend(p0));
		case 15:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$GetPublicGoMatchResponse(
				$elm$core$Result$map$($author$project$Evergreen$Migrate$V419$migrate_Go_PublicGoMatchResponse, p0));
		case 16:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$ExportChannelResponse(p0);
		default:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$ImportChannelResponse$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$elm$core$Basics$composeR$(
					$elm$core$Result$mapError($author$project$Evergreen$Migrate$V419$migrate_Types_ImportChannelError),
					$elm$core$Result$map(
						function (rec1) {
							return rec1;
						}),
					p1));
	}
};
var $author$project$Evergreen$V419$Internal$Model2$State = $elm$core$Basics$identity;
var $author$project$Evergreen$Migrate$V419$migrate_Internal_Model2_State = function (old) {
	var p0 = old;
	return p0;
};
var $author$project$Evergreen$Migrate$V419$migrate_Ui_Anim_State = function (old) {
	return $author$project$Evergreen$Migrate$V419$migrate_Internal_Model2_State(old);
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_LoadedFrontend = function (old) {
	return {
		aiChatModel: $author$project$Evergreen$Migrate$V419$migrate_AiChat_FrontendModel(old.aiChatModel),
		clientId: old.clientId,
		drag: $author$project$Evergreen$Migrate$V419$migrate_Touch_Drag(old.drag),
		dragPrevious: $author$project$Evergreen$Migrate$V419$migrate_Touch_Drag(old.dragPrevious),
		elmUiState: $author$project$Evergreen$Migrate$V419$migrate_Ui_Anim_State(old.elmUiState),
		emojiData: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Emoji_CachedEmojiData, old.emojiData),
		homePagePreview: function (rec) {
			return rec;
		}(old.homePagePreview),
		imageViewer: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_ImageViewer_Model, old.imageViewer),
		lastCopied: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_MyUi_LastCopy, old.lastCopied),
		loginStatus: $author$project$Evergreen$Migrate$V419$migrate_Types_LoginStatus(old.loginStatus),
		loginType: $author$project$Evergreen$Migrate$V419$migrate_Types_LoginType(old.loginType),
		navigationKey: old.navigationKey,
		pageHasFocus: old.pageHasFocus,
		popSound: $elm$core$Basics$composeR$(
			$elm$core$Result$mapError($author$project$Evergreen$Migrate$V419$migrate_Audio_LoadError),
			$elm$core$Result$map($author$project$Evergreen$Migrate$V419$migrate_Audio_Source),
			old.popSound),
		publicGoMatch: $author$project$Evergreen$Migrate$V419$migrate_Types_PublicGoMatch(old.publicGoMatch),
		route: $author$project$Evergreen$Migrate$V419$migrate_Route_Route(old.route),
		startupData: $author$project$Evergreen$Migrate$V419$migrate_Ports_StartupData(old.startupData),
		time: old.time,
		timezone: old.timezone,
		toFrontendLogs: $elm$core$Maybe$map$(
			$elm$core$Array$map($author$project$Evergreen$Migrate$V419$migrate_Types_ToFrontend),
			old.toFrontendLogs),
		versionNumber: old.versionNumber,
		visualViewportHeight: old.visualViewportHeight,
		visualViewportTop: old.visualViewportTop,
		windowSize: $author$project$Evergreen$Migrate$V419$migrate_Coord_Coord$($author$project$Evergreen$Migrate$V419$migrate_CssPixels_CssPixels, old.windowSize)
	};
};
var $author$project$Evergreen$V419$Types$LoadError = {$: 2};
var $author$project$Evergreen$V419$Types$LoadSuccess = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Types$LoadingData = {$: 0};
var $author$project$Evergreen$Migrate$V419$migrate_Types_LoadStatus = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$Types$LoadingData;
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$LoadSuccess(
				$author$project$Evergreen$Migrate$V419$migrate_Types_LoginData(p0));
		default:
			return $author$project$Evergreen$V419$Types$LoadError;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_LoadingFrontend = function (old) {
	return {
		clientId: old.clientId,
		loginStatus: $author$project$Evergreen$Migrate$V419$migrate_Types_LoadStatus(old.loginStatus),
		loginType: $author$project$Evergreen$Migrate$V419$migrate_Types_LoginType(old.loginType),
		navigationKey: old.navigationKey,
		popSound: $elm$core$Basics$composeR$(
			$elm$core$Result$mapError($author$project$Evergreen$Migrate$V419$migrate_Audio_LoadError),
			$elm$core$Result$map($author$project$Evergreen$Migrate$V419$migrate_Audio_Source),
			old.popSound),
		publicGoMatch: $author$project$Evergreen$Migrate$V419$migrate_Types_PublicGoMatch(old.publicGoMatch),
		route: $author$project$Evergreen$Migrate$V419$migrate_Route_Route(old.route),
		startupData: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Ports_StartupData, old.startupData),
		time: old.time,
		windowSize: $author$project$Evergreen$Migrate$V419$migrate_Coord_Coord$($author$project$Evergreen$Migrate$V419$migrate_CssPixels_CssPixels, old.windowSize)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_FrontendModel_ = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Types$Loading(
			$author$project$Evergreen$Migrate$V419$migrate_Types_LoadingFrontend(p0));
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Types$Loaded(
			$author$project$Evergreen$Migrate$V419$migrate_Types_LoadedFrontend(p0));
	}
};
var $author$project$Evergreen$V419$Types$AdminPageMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Evergreen$V419$Types$AiChatMsg = function (a) {
	return {$: 76, a: a};
};
var $author$project$Evergreen$V419$Types$ChannelSidebarAnimated = function (a) {
	return {$: 54, a: a};
};
var $author$project$Evergreen$V419$Types$CheckMessageAltPress$ = function (a, b, c, d, e, f, g) {
	return {$: 71, a: a, b: b, c: c, d: d, e: e, f: f, g: g};
};
var $author$project$Evergreen$V419$Types$CheckMessageAltPress = F7($author$project$Evergreen$V419$Types$CheckMessageAltPress$);
var $author$project$Evergreen$V419$Types$CheckedNotificationPermission = function (a) {
	return {$: 49, a: a};
};
var $author$project$Evergreen$V419$Types$CheckedSheepGameQuestionsDebounce$ = function (a, b) {
	return {$: 79, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$CheckedSheepGameQuestionsDebounce = F2($author$project$Evergreen$V419$Types$CheckedSheepGameQuestionsDebounce$);
var $author$project$Evergreen$V419$Types$CheckedSheepGameSaveDebounce$ = function (a, b, c, d) {
	return {$: 78, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$CheckedSheepGameSaveDebounce = F4($author$project$Evergreen$V419$Types$CheckedSheepGameSaveDebounce$);
var $author$project$Evergreen$V419$Types$DebouncedTyping = {$: 37};
var $author$project$Evergreen$V419$Types$DomFocusChanged = function (a) {
	return {$: 153, a: a};
};
var $author$project$Evergreen$V419$Types$DrawingMsg = function (a) {
	return {$: 164, a: a};
};
var $author$project$Evergreen$V419$Types$EditChannelFormChanged$ = function (a, b, c) {
	return {$: 16, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$EditChannelFormChanged = F3($author$project$Evergreen$V419$Types$EditChannelFormChanged$);
var $author$project$Evergreen$V419$Types$EditGuildFormChanged$ = function (a, b) {
	return {$: 20, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$EditGuildFormChanged = F2($author$project$Evergreen$V419$Types$EditGuildFormChanged$);
var $author$project$Evergreen$V419$Types$EditMessage_GotFileHashName$ = function (a, b, c, d) {
	return {$: 94, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$EditMessage_GotFileHashName = F4($author$project$Evergreen$V419$Types$EditMessage_GotFileHashName$);
var $author$project$Evergreen$V419$Types$EditMessage_MessageInputMsg$ = function (a, b, c) {
	return {$: 146, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$EditMessage_MessageInputMsg = F3($author$project$Evergreen$V419$Types$EditMessage_MessageInputMsg$);
var $author$project$Evergreen$V419$Types$EditMessage_PressedDeleteAttachedFile$ = function (a, b) {
	return {$: 90, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$EditMessage_PressedDeleteAttachedFile = F2($author$project$Evergreen$V419$Types$EditMessage_PressedDeleteAttachedFile$);
var $author$project$Evergreen$V419$Types$EditMessage_PressedToggleAttachedFileSpoiler$ = function (a, b) {
	return {$: 92, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$EditMessage_PressedToggleAttachedFileSpoiler = F2($author$project$Evergreen$V419$Types$EditMessage_PressedToggleAttachedFileSpoiler$);
var $author$project$Evergreen$V419$Types$EditMessage_PressedViewAttachedFileInfo$ = function (a, b) {
	return {$: 91, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$EditMessage_PressedViewAttachedFileInfo = F2($author$project$Evergreen$V419$Types$EditMessage_PressedViewAttachedFileInfo$);
var $author$project$Evergreen$V419$Types$EditMessage_SelectedFilesToAttach$ = function (a, b, c) {
	return {$: 93, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$EditMessage_SelectedFilesToAttach = F3($author$project$Evergreen$V419$Types$EditMessage_SelectedFilesToAttach$);
var $author$project$Evergreen$V419$Types$ElmUiMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Evergreen$V419$Types$EmojiSelectorMsg = function (a) {
	return {$: 45, a: a};
};
var $author$project$Evergreen$V419$Types$EnableToFrontendLogging = {$: 151};
var $author$project$Evergreen$V419$Types$EncryptionFromJs = function (a) {
	return {$: 186, a: a};
};
var $author$project$Evergreen$V419$Types$FileDragEnter = function (a) {
	return {$: 158, a: a};
};
var $author$project$Evergreen$V419$Types$FileDragLeave = {$: 159};
var $author$project$Evergreen$V419$Types$FileDropped = function (a) {
	return {$: 160, a: a};
};
var $author$project$Evergreen$V419$Types$FileUploadProgress$ = function (a, b, c) {
	return {$: 95, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$FileUploadProgress = F3($author$project$Evergreen$V419$Types$FileUploadProgress$);
var $author$project$Evergreen$V419$Types$FrontendNoOp = {$: 32};
var $author$project$Evergreen$V419$Types$GameMsg = function (a) {
	return {$: 77, a: a};
};
var $author$project$Evergreen$V419$Types$GoSpectatorMsg = function (a) {
	return {$: 80, a: a};
};
var $author$project$Evergreen$V419$Types$GotDevicePixelRatio = function (a) {
	return {$: 109, a: a};
};
var $author$project$Evergreen$V419$Types$GotEmojiData = function (a) {
	return {$: 148, a: a};
};
var $author$project$Evergreen$V419$Types$GotFileHashName$ = function (a, b, c, d) {
	return {$: 86, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$GotFileHashName = F4($author$project$Evergreen$V419$Types$GotFileHashName$);
var $author$project$Evergreen$V419$Types$GotFileToEncrypt$ = function (a, b, c, d) {
	return {$: 85, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$GotFileToEncrypt = F4($author$project$Evergreen$V419$Types$GotFileToEncrypt$);
var $author$project$Evergreen$V419$Types$GotImportChannelFile$ = function (a, b) {
	return {$: 26, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$GotImportChannelFile = F2($author$project$Evergreen$V419$Types$GotImportChannelFile$);
var $author$project$Evergreen$V419$Types$GotPingUserPosition$ = function (a, b) {
	return {$: 38, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$GotPingUserPosition = F2($author$project$Evergreen$V419$Types$GotPingUserPosition$);
var $author$project$Evergreen$V419$Types$GotPositionForEmojiSelector_EditMessage = function (a) {
	return {$: 149, a: a};
};
var $author$project$Evergreen$V419$Types$GotPositionForEmojiSelector_SheepGameInput$ = function (a, b) {
	return {$: 150, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$GotPositionForEmojiSelector_SheepGameInput = F2($author$project$Evergreen$V419$Types$GotPositionForEmojiSelector_SheepGameInput$);
var $author$project$Evergreen$V419$Types$GotRegisterPushSubscription = function (a) {
	return {$: 98, a: a};
};
var $author$project$Evergreen$V419$Types$GotServiceWorkerData = function (a) {
	return {$: 163, a: a};
};
var $author$project$Evergreen$V419$Types$GotServiceWorkerMessage = function (a) {
	return {$: 124, a: a};
};
var $author$project$Evergreen$V419$Types$GotStartupData = function (a) {
	return {$: 108, a: a};
};
var $author$project$Evergreen$V419$Types$GotTime = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$Types$GotVersionNumber = function (a) {
	return {$: 135, a: a};
};
var $author$project$Evergreen$V419$Types$GotVoiceChatSignalFromJs = function (a) {
	return {$: 155, a: a};
};
var $author$project$Evergreen$V419$Types$GotWindowSize$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$GotWindowSize = F2($author$project$Evergreen$V419$Types$GotWindowSize$);
var $author$project$Evergreen$V419$Types$GuildIconEditorMsg$ = function (a, b) {
	return {$: 83, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$GuildIconEditorMsg = F2($author$project$Evergreen$V419$Types$GuildIconEditorMsg$);
var $author$project$Evergreen$V419$Types$ImageViewerMsg = function (a) {
	return {$: 97, a: a};
};
var $author$project$Evergreen$V419$Types$KeyDown = function (a) {
	return {$: 41, a: a};
};
var $author$project$Evergreen$V419$Types$LoadedPopSound = function (a) {
	return {$: 166, a: a};
};
var $author$project$Evergreen$V419$Types$LoginFormMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V419$Types$MessageInputMsg$ = function (a, b, c) {
	return {$: 147, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$MessageInputMsg = F3($author$project$Evergreen$V419$Types$MessageInputMsg$);
var $author$project$Evergreen$V419$Types$MessageMenuAnimated = function (a) {
	return {$: 55, a: a};
};
var $author$project$Evergreen$V419$Types$MessageMenu_PressedAddCustomEmojisToUser = function (a) {
	return {$: 64, a: a};
};
var $author$project$Evergreen$V419$Types$MessageMenu_PressedClose = {$: 68};
var $author$project$Evergreen$V419$Types$MessageMenu_PressedContainer = {$: 69};
var $author$project$Evergreen$V419$Types$MessageMenu_PressedDeleteMessage$ = function (a, b) {
	return {$: 62, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$MessageMenu_PressedDeleteMessage = F2($author$project$Evergreen$V419$Types$MessageMenu_PressedDeleteMessage$);
var $author$project$Evergreen$V419$Types$MessageMenu_PressedEditMessage$ = function (a, b) {
	return {$: 44, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$MessageMenu_PressedEditMessage = F2($author$project$Evergreen$V419$Types$MessageMenu_PressedEditMessage$);
var $author$project$Evergreen$V419$Types$MessageMenu_PressedMarkAsUnread$ = function (a, b) {
	return {$: 63, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$MessageMenu_PressedMarkAsUnread = F2($author$project$Evergreen$V419$Types$MessageMenu_PressedMarkAsUnread$);
var $author$project$Evergreen$V419$Types$MessageMenu_PressedOpenDiscordDm$ = function (a, b) {
	return {$: 66, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$MessageMenu_PressedOpenDiscordDm = F2($author$project$Evergreen$V419$Types$MessageMenu_PressedOpenDiscordDm$);
var $author$project$Evergreen$V419$Types$MessageMenu_PressedOpenDm = function (a) {
	return {$: 65, a: a};
};
var $author$project$Evergreen$V419$Types$MessageMenu_PressedOpenThread = function (a) {
	return {$: 47, a: a};
};
var $author$project$Evergreen$V419$Types$MessageMenu_PressedReactionEmoji = function (a) {
	return {$: 43, a: a};
};
var $author$project$Evergreen$V419$Types$MessageMenu_PressedReply = function (a) {
	return {$: 46, a: a};
};
var $author$project$Evergreen$V419$Types$MessageMenu_PressedShowReactionEmojiSelector$ = function (a, b, c) {
	return {$: 42, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$MessageMenu_PressedShowReactionEmojiSelector = F3($author$project$Evergreen$V419$Types$MessageMenu_PressedShowReactionEmojiSelector$);
var $author$project$Evergreen$V419$Types$MessageViewMsg$ = function (a, b, c) {
	return {$: 96, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$MessageViewMsg = F3($author$project$Evergreen$V419$Types$MessageViewMsg$);
var $author$project$Evergreen$V419$Types$NewChannelFormChanged$ = function (a, b) {
	return {$: 14, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$NewChannelFormChanged = F2($author$project$Evergreen$V419$Types$NewChannelFormChanged$);
var $author$project$Evergreen$V419$Types$NewGuildFormChanged = function (a) {
	return {$: 35, a: a};
};
var $author$project$Evergreen$V419$Types$OneFrameAfterDragEnd = {$: 84};
var $author$project$Evergreen$V419$Types$PageFocusSettled = {$: 123};
var $author$project$Evergreen$V419$Types$PageHasFocusChanged = function (a) {
	return {$: 122, a: a};
};
var $author$project$Evergreen$V419$Types$PageUpGotViewport = function (a) {
	return {$: 154, a: a};
};
var $author$project$Evergreen$V419$Types$PressedAccountDeletionBanner = {$: 103};
var $author$project$Evergreen$V419$Types$PressedAddDomainToWhitelist = function (a) {
	return {$: 137, a: a};
};
var $author$project$Evergreen$V419$Types$PressedAddPrivateKeyToAccount = {$: 113};
var $author$project$Evergreen$V419$Types$PressedBanMember$ = function (a, b) {
	return {$: 30, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$PressedBanMember = F2($author$project$Evergreen$V419$Types$PressedBanMember$);
var $author$project$Evergreen$V419$Types$PressedBody = {$: 61};
var $author$project$Evergreen$V419$Types$PressedCancelE2eeRequest = function (a) {
	return {$: 118, a: a};
};
var $author$project$Evergreen$V419$Types$PressedCancelMessageEdit = function (a) {
	return {$: 70, a: a};
};
var $author$project$Evergreen$V419$Types$PressedChannelHeaderBackButton = {$: 57};
var $author$project$Evergreen$V419$Types$PressedChannelHeaderTab = function (a) {
	return {$: 157, a: a};
};
var $author$project$Evergreen$V419$Types$PressedCloseAccountDeletionBanner = {$: 104};
var $author$project$Evergreen$V419$Types$PressedCloseExternalLinkWarning = {$: 136};
var $author$project$Evergreen$V419$Types$PressedCloseImageInfo = {$: 110};
var $author$project$Evergreen$V419$Types$PressedCloseNewPrivateKey = {$: 114};
var $author$project$Evergreen$V419$Types$PressedCloseOverlay = {$: 73};
var $author$project$Evergreen$V419$Types$PressedCloseReplyTo = function (a) {
	return {$: 48, a: a};
};
var $author$project$Evergreen$V419$Types$PressedContinueToSite = {$: 145};
var $author$project$Evergreen$V419$Types$PressedCopyImage = function (a) {
	return {$: 34, a: a};
};
var $author$project$Evergreen$V419$Types$PressedCopyText = function (a) {
	return {$: 33, a: a};
};
var $author$project$Evergreen$V419$Types$PressedCreateInviteLink = function (a) {
	return {$: 28, a: a};
};
var $author$project$Evergreen$V419$Types$PressedDeclineE2eeRequest = function (a) {
	return {$: 120, a: a};
};
var $author$project$Evergreen$V419$Types$PressedDeleteAccount = {$: 102};
var $author$project$Evergreen$V419$Types$PressedDeleteAttachedFile$ = function (a, b) {
	return {$: 87, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$PressedDeleteAttachedFile = F2($author$project$Evergreen$V419$Types$PressedDeleteAttachedFile$);
var $author$project$Evergreen$V419$Types$PressedDeleteChannel$ = function (a, b) {
	return {$: 19, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$PressedDeleteChannel = F2($author$project$Evergreen$V419$Types$PressedDeleteChannel$);
var $author$project$Evergreen$V419$Types$PressedDeleteGuild = function (a) {
	return {$: 23, a: a};
};
var $author$project$Evergreen$V419$Types$PressedDeleteInviteLink$ = function (a, b) {
	return {$: 29, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$PressedDeleteInviteLink = F2($author$project$Evergreen$V419$Types$PressedDeleteInviteLink$);
var $author$project$Evergreen$V419$Types$PressedDisableE2ee = function (a) {
	return {$: 119, a: a};
};
var $author$project$Evergreen$V419$Types$PressedDiscordAcknowledgment = function (a) {
	return {$: 129, a: a};
};
var $author$project$Evergreen$V419$Types$PressedDiscordGuildMemberLabel = function (a) {
	return {$: 133, a: a};
};
var $author$project$Evergreen$V419$Types$PressedDiscordGuildNotificationLevel$ = function (a, b, c) {
	return {$: 106, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$PressedDiscordGuildNotificationLevel = F3($author$project$Evergreen$V419$Types$PressedDiscordGuildNotificationLevel$);
var $author$project$Evergreen$V419$Types$PressedE2eeRisksAccepted = function (a) {
	return {$: 116, a: a};
};
var $author$project$Evergreen$V419$Types$PressedEnableE2ee = function (a) {
	return {$: 117, a: a};
};
var $author$project$Evergreen$V419$Types$PressedExpandContainer = function (a) {
	return {$: 74, a: a};
};
var $author$project$Evergreen$V419$Types$PressedExpandE2eeSection = function (a) {
	return {$: 115, a: a};
};
var $author$project$Evergreen$V419$Types$PressedExportChannel = function (a) {
	return {$: 112, a: a};
};
var $author$project$Evergreen$V419$Types$PressedGuildNotificationLevel$ = function (a, b) {
	return {$: 105, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$PressedGuildNotificationLevel = F2($author$project$Evergreen$V419$Types$PressedGuildNotificationLevel$);
var $author$project$Evergreen$V419$Types$PressedHideMembers = {$: 59};
var $author$project$Evergreen$V419$Types$PressedHomePagePreview = function (a) {
	return {$: 7, a: a};
};
var $author$project$Evergreen$V419$Types$PressedImportChannel = function (a) {
	return {$: 24, a: a};
};
var $author$project$Evergreen$V419$Types$PressedLeaveGuild = function (a) {
	return {$: 27, a: a};
};
var $author$project$Evergreen$V419$Types$PressedLink = function (a) {
	return {$: 12, a: a};
};
var $author$project$Evergreen$V419$Types$PressedLoadDebugData = {$: 162};
var $author$project$Evergreen$V419$Types$PressedLogOut = function (a) {
	return {$: 9, a: a};
};
var $author$project$Evergreen$V419$Types$PressedMarkAllChannelsAsRead = function (a) {
	return {$: 177, a: a};
};
var $author$project$Evergreen$V419$Types$PressedMarkChannelAsRead$ = function (a, b) {
	return {$: 176, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$PressedMarkChannelAsRead = F2($author$project$Evergreen$V419$Types$PressedMarkChannelAsRead$);
var $author$project$Evergreen$V419$Types$PressedMemberListBack = {$: 111};
var $author$project$Evergreen$V419$Types$PressedMuteChannel$ = function (a, b, c) {
	return {$: 172, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$PressedMuteChannel = F3($author$project$Evergreen$V419$Types$PressedMuteChannel$);
var $author$project$Evergreen$V419$Types$PressedMuteDiscordChannel$ = function (a, b, c, d) {
	return {$: 174, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$PressedMuteDiscordChannel = F4($author$project$Evergreen$V419$Types$PressedMuteDiscordChannel$);
var $author$project$Evergreen$V419$Types$PressedMuteDiscordGuild$ = function (a, b, c) {
	return {$: 179, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$PressedMuteDiscordGuild = F3($author$project$Evergreen$V419$Types$PressedMuteDiscordGuild$);
var $author$project$Evergreen$V419$Types$PressedMuteDiscordThread$ = function (a, b, c, d, e) {
	return {$: 175, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V419$Types$PressedMuteDiscordThread = F5($author$project$Evergreen$V419$Types$PressedMuteDiscordThread$);
var $author$project$Evergreen$V419$Types$PressedMuteGuild$ = function (a, b) {
	return {$: 178, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$PressedMuteGuild = F2($author$project$Evergreen$V419$Types$PressedMuteGuild$);
var $author$project$Evergreen$V419$Types$PressedMuteSlackChannel$ = function (a, b, c, d) {
	return {$: 181, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$PressedMuteSlackChannel = F4($author$project$Evergreen$V419$Types$PressedMuteSlackChannel$);
var $author$project$Evergreen$V419$Types$PressedMuteSlackThread$ = function (a, b, c, d, e) {
	return {$: 182, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V419$Types$PressedMuteSlackThread = F5($author$project$Evergreen$V419$Types$PressedMuteSlackThread$);
var $author$project$Evergreen$V419$Types$PressedMuteSlackWorkspace$ = function (a, b, c) {
	return {$: 180, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$PressedMuteSlackWorkspace = F3($author$project$Evergreen$V419$Types$PressedMuteSlackWorkspace$);
var $author$project$Evergreen$V419$Types$PressedMuteThread$ = function (a, b, c, d) {
	return {$: 173, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$PressedMuteThread = F4($author$project$Evergreen$V419$Types$PressedMuteThread$);
var $author$project$Evergreen$V419$Types$PressedNewMessagesWarning = {$: 165};
var $author$project$Evergreen$V419$Types$PressedNotification = function (a) {
	return {$: 125, a: a};
};
var $author$project$Evergreen$V419$Types$PressedReloadDiscordUser = function (a) {
	return {$: 131, a: a};
};
var $author$project$Evergreen$V419$Types$PressedReloadSlackUser = function (a) {
	return {$: 192, a: a};
};
var $author$project$Evergreen$V419$Types$PressedRemoveSlackTeam = function (a) {
	return {$: 189, a: a};
};
var $author$project$Evergreen$V419$Types$PressedResetDomainWhitelist = {$: 144};
var $author$project$Evergreen$V419$Types$PressedResetEditChannelChanges$ = function (a, b) {
	return {$: 17, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$PressedResetEditChannelChanges = F2($author$project$Evergreen$V419$Types$PressedResetEditChannelChanges$);
var $author$project$Evergreen$V419$Types$PressedResetEditGuildChanges = function (a) {
	return {$: 21, a: a};
};
var $author$project$Evergreen$V419$Types$PressedResetUserColor = {$: 142};
var $author$project$Evergreen$V419$Types$PressedSaveDomainWhitelist = {$: 143};
var $author$project$Evergreen$V419$Types$PressedSearchOverlayArrowKey = function (a) {
	return {$: 169, a: a};
};
var $author$project$Evergreen$V419$Types$PressedSearchOverlayEnter = {$: 170};
var $author$project$Evergreen$V419$Types$PressedSearchOverlayResult = function (a) {
	return {$: 171, a: a};
};
var $author$project$Evergreen$V419$Types$PressedSelectNewColor = {$: 139};
var $author$project$Evergreen$V419$Types$PressedShowLogin = {$: 6};
var $author$project$Evergreen$V419$Types$PressedShowMembers = {$: 58};
var $author$project$Evergreen$V419$Types$PressedShowSearchOverlay = {$: 167};
var $author$project$Evergreen$V419$Types$PressedShowUserOption = {$: 72};
var $author$project$Evergreen$V419$Types$PressedSlackAcknowledgment = function (a) {
	return {$: 130, a: a};
};
var $author$project$Evergreen$V419$Types$PressedSlackWorkspaceNotificationLevel$ = function (a, b, c) {
	return {$: 107, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$PressedSlackWorkspaceNotificationLevel = F3($author$project$Evergreen$V419$Types$PressedSlackWorkspaceNotificationLevel$);
var $author$project$Evergreen$V419$Types$PressedSubmitEditChannelChanges$ = function (a, b, c) {
	return {$: 18, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$PressedSubmitEditChannelChanges = F3($author$project$Evergreen$V419$Types$PressedSubmitEditChannelChanges$);
var $author$project$Evergreen$V419$Types$PressedSubmitEditGuildChanges$ = function (a, b) {
	return {$: 22, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$PressedSubmitEditGuildChanges = F2($author$project$Evergreen$V419$Types$PressedSubmitEditGuildChanges$);
var $author$project$Evergreen$V419$Types$PressedSubmitNewChannel$ = function (a, b) {
	return {$: 15, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$PressedSubmitNewChannel = F2($author$project$Evergreen$V419$Types$PressedSubmitNewChannel$);
var $author$project$Evergreen$V419$Types$PressedSubmitNewGuild = function (a) {
	return {$: 36, a: a};
};
var $author$project$Evergreen$V419$Types$PressedSubmitSlackData = {$: 190};
var $author$project$Evergreen$V419$Types$PressedSubmitUserColor = {$: 141};
var $author$project$Evergreen$V419$Types$PressedToggleAttachedFileSpoiler$ = function (a, b) {
	return {$: 89, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$PressedToggleAttachedFileSpoiler = F2($author$project$Evergreen$V419$Types$PressedToggleAttachedFileSpoiler$);
var $author$project$Evergreen$V419$Types$PressedToggleInviteLinkQrCode = function (a) {
	return {$: 31, a: a};
};
var $author$project$Evergreen$V419$Types$PressedUnlinkDiscordUser = function (a) {
	return {$: 132, a: a};
};
var $author$project$Evergreen$V419$Types$PressedUnlinkSlackUser = function (a) {
	return {$: 191, a: a};
};
var $author$project$Evergreen$V419$Types$PressedUnregisterServiceWorkers = {$: 161};
var $author$project$Evergreen$V419$Types$PressedViewAttachedFileInfo$ = function (a, b) {
	return {$: 88, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$PressedViewAttachedFileInfo = F2($author$project$Evergreen$V419$Types$PressedViewAttachedFileInfo$);
var $author$project$Evergreen$V419$Types$ProfilePictureEditorMsg = function (a) {
	return {$: 82, a: a};
};
var $author$project$Evergreen$V419$Types$RecoveryLoginMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V419$Types$RemoveFocus = {$: 40};
var $author$project$Evergreen$V419$Types$SafeAreaInsetsChanged = function (a) {
	return {$: 127, a: a};
};
var $author$project$Evergreen$V419$Types$ScrolledToLogSection = {$: 11};
var $author$project$Evergreen$V419$Types$ScrolledToMessage = {$: 67};
var $author$project$Evergreen$V419$Types$SelectedEmailNotifications = function (a) {
	return {$: 100, a: a};
};
var $author$project$Evergreen$V419$Types$SelectedEmbedVisibility = function (a) {
	return {$: 101, a: a};
};
var $author$project$Evergreen$V419$Types$SelectedFilesToAttach$ = function (a, b, c) {
	return {$: 13, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$SelectedFilesToAttach = F3($author$project$Evergreen$V419$Types$SelectedFilesToAttach$);
var $author$project$Evergreen$V419$Types$SelectedImportChannelFile$ = function (a, b) {
	return {$: 25, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$SelectedImportChannelFile = F2($author$project$Evergreen$V419$Types$SelectedImportChannelFile$);
var $author$project$Evergreen$V419$Types$SelectedNotificationMode = function (a) {
	return {$: 99, a: a};
};
var $author$project$Evergreen$V419$Types$SelectedUserColor = function (a) {
	return {$: 140, a: a};
};
var $author$project$Evergreen$V419$Types$SetFocus = {$: 39};
var $author$project$Evergreen$V419$Types$SetScrollToBottom = {$: 56};
var $author$project$Evergreen$V419$Types$TextEditorMsg = function (a) {
	return {$: 128, a: a};
};
var $author$project$Evergreen$V419$Types$TextSelectionChanged = function (a) {
	return {$: 152, a: a};
};
var $author$project$Evergreen$V419$Types$TouchCancel = function (a) {
	return {$: 53, a: a};
};
var $author$project$Evergreen$V419$Types$TouchEnd = function (a) {
	return {$: 52, a: a};
};
var $author$project$Evergreen$V419$Types$TouchMoved$ = function (a, b) {
	return {$: 51, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$TouchMoved = F2($author$project$Evergreen$V419$Types$TouchMoved$);
var $author$project$Evergreen$V419$Types$TouchStart$ = function (a, b) {
	return {$: 50, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$TouchStart = F2($author$project$Evergreen$V419$Types$TouchStart$);
var $author$project$Evergreen$V419$Types$TwoFactorMsg = function (a) {
	return {$: 75, a: a};
};
var $author$project$Evergreen$V419$Types$TypedDiscordLinkBookmarklet = {$: 134};
var $author$project$Evergreen$V419$Types$TypedDomainWhitelist = function (a) {
	return {$: 138, a: a};
};
var $author$project$Evergreen$V419$Types$TypedPrivateKey$ = function (a, b) {
	return {$: 121, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$TypedPrivateKey = F2($author$project$Evergreen$V419$Types$TypedPrivateKey$);
var $author$project$Evergreen$V419$Types$TypedSearchOverlay = function (a) {
	return {$: 168, a: a};
};
var $author$project$Evergreen$V419$Types$TypedSlackCookie = function (a) {
	return {$: 187, a: a};
};
var $author$project$Evergreen$V419$Types$TypedSlackTeamsJson = function (a) {
	return {$: 188, a: a};
};
var $author$project$Evergreen$V419$Types$UnreadOverviewChannelMsg$ = function (a, b, c) {
	return {$: 183, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$UnreadOverviewChannelMsg = F3($author$project$Evergreen$V419$Types$UnreadOverviewChannelMsg$);
var $author$project$Evergreen$V419$Types$UnreadOverviewThreadMsg$ = function (a, b, c, d) {
	return {$: 184, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V419$Types$UnreadOverviewThreadMsg = F4($author$project$Evergreen$V419$Types$UnreadOverviewThreadMsg$);
var $author$project$Evergreen$V419$Types$UrlChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Types$UrlClicked = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Types$UserNameEditableMsg = function (a) {
	return {$: 81, a: a};
};
var $author$project$Evergreen$V419$Types$UserScrolled$ = function (a, b, c) {
	return {$: 60, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Types$UserScrolled = F3($author$project$Evergreen$V419$Types$UserScrolled$);
var $author$project$Evergreen$V419$Types$ValidatedE2eePrivateKey$ = function (a, b) {
	return {$: 185, a: a, b: b};
};
var $author$project$Evergreen$V419$Types$ValidatedE2eePrivateKey = F2($author$project$Evergreen$V419$Types$ValidatedE2eePrivateKey$);
var $author$project$Evergreen$V419$Types$VisualViewportChanged = function (a) {
	return {$: 126, a: a};
};
var $author$project$Evergreen$V419$Types$VoiceChatMsg = function (a) {
	return {$: 156, a: a};
};
var $author$project$Evergreen$V419$AiChat$CheckDebounce = function (a) {
	return {$: 13, a: a};
};
var $author$project$Evergreen$V419$AiChat$EditedResponse$ = function (a, b) {
	return {$: 15, a: a, b: b};
};
var $author$project$Evergreen$V419$AiChat$EditedResponse = F2($author$project$Evergreen$V419$AiChat$EditedResponse$);
var $author$project$Evergreen$V419$AiChat$GotAiModels = function (a) {
	return {$: 17, a: a};
};
var $author$project$Evergreen$V419$AiChat$GotLocalStorage = function (a) {
	return {$: 14, a: a};
};
var $author$project$Evergreen$V419$AiChat$NoOp = {$: 16};
var $author$project$Evergreen$V419$AiChat$PressedAddModel = {$: 10};
var $author$project$Evergreen$V419$AiChat$PressedChatHistoryContainer = {$: 6};
var $author$project$Evergreen$V419$AiChat$PressedClearChatHistory = {$: 7};
var $author$project$Evergreen$V419$AiChat$PressedDelete = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V419$AiChat$PressedKeep = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V419$AiChat$PressedOptionsButton = {$: 8};
var $author$project$Evergreen$V419$AiChat$PressedRemoveModel = function (a) {
	return {$: 11, a: a};
};
var $author$project$Evergreen$V419$AiChat$PressedRetry = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V419$AiChat$PressedSend = {$: 1};
var $author$project$Evergreen$V419$AiChat$SelectedAiModel$ = function (a, b) {
	return {$: 9, a: a, b: b};
};
var $author$project$Evergreen$V419$AiChat$SelectedAiModel = F2($author$project$Evergreen$V419$AiChat$SelectedAiModel$);
var $author$project$Evergreen$V419$AiChat$SelectedSendMessageWith = function (a) {
	return {$: 12, a: a};
};
var $author$project$Evergreen$V419$AiChat$TypedChatHistory = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$AiChat$TypedMessage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_AiChat_Msg = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$AiChat$TypedMessage(p0);
		case 1:
			return $author$project$Evergreen$V419$AiChat$PressedSend;
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$AiChat$TypedChatHistory(p0);
		case 3:
			var p0 = old.a;
			return $author$project$Evergreen$V419$AiChat$PressedKeep(
				$author$project$Evergreen$Migrate$V419$migrate_AiChat_ResponseId(p0));
		case 4:
			var p0 = old.a;
			return $author$project$Evergreen$V419$AiChat$PressedDelete(
				$author$project$Evergreen$Migrate$V419$migrate_AiChat_ResponseId(p0));
		case 5:
			var p0 = old.a;
			return $author$project$Evergreen$V419$AiChat$PressedRetry(
				$author$project$Evergreen$Migrate$V419$migrate_AiChat_ResponseId(p0));
		case 6:
			return $author$project$Evergreen$V419$AiChat$PressedChatHistoryContainer;
		case 7:
			return $author$project$Evergreen$V419$AiChat$PressedClearChatHistory;
		case 8:
			return $author$project$Evergreen$V419$AiChat$PressedOptionsButton;
		case 9:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$AiChat$SelectedAiModel$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_AiChat_AiModelName(p1));
		case 10:
			return $author$project$Evergreen$V419$AiChat$PressedAddModel;
		case 11:
			var p0 = old.a;
			return $author$project$Evergreen$V419$AiChat$PressedRemoveModel(p0);
		case 12:
			var p0 = old.a;
			return $author$project$Evergreen$V419$AiChat$SelectedSendMessageWith(
				$author$project$Evergreen$Migrate$V419$migrate_AiChat_SendMessageWith(p0));
		case 13:
			var p0 = old.a;
			return $author$project$Evergreen$V419$AiChat$CheckDebounce(p0);
		case 14:
			var p0 = old.a;
			return $author$project$Evergreen$V419$AiChat$GotLocalStorage(p0);
		case 15:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$AiChat$EditedResponse$(
				$author$project$Evergreen$Migrate$V419$migrate_AiChat_ResponseId(p0),
				p1);
		case 16:
			return $author$project$Evergreen$V419$AiChat$NoOp;
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$AiChat$GotAiModels(
				$elm$core$Result$map$(
					$elm$core$List$map($author$project$Evergreen$Migrate$V419$migrate_AiChat_AiModel),
					p0));
	}
};
var $author$project$Evergreen$V419$Call$FromJs_DebugData = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V419$Call$FromJs_GotUserMediaDevices$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$Call$FromJs_GotUserMediaDevices = F2($author$project$Evergreen$V419$Call$FromJs_GotUserMediaDevices$);
var $author$project$Evergreen$V419$Call$FromJs_GotUserMediaDevicesError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Call$FromJs_RecordingUploadProgress$ = function (a, b) {
	return {$: 7, a: a, b: b};
};
var $author$project$Evergreen$V419$Call$FromJs_RecordingUploadProgress = F2($author$project$Evergreen$V419$Call$FromJs_RecordingUploadProgress$);
var $author$project$Evergreen$V419$Call$FromJs_RecordingUploadsStopped = {$: 8};
var $author$project$Evergreen$V419$Call$FromJs_ScreenShareStarted = {$: 5};
var $author$project$Evergreen$V419$Call$FromJs_ScreenShareStopped = {$: 6};
var $author$project$Evergreen$V419$Call$FromJs_SpeakingChanged$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V419$Call$FromJs_SpeakingChanged = F2($author$project$Evergreen$V419$Call$FromJs_SpeakingChanged$);
var $author$project$Evergreen$V419$Call$FromJs_StartConnectionError = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Call_FromJs = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Call$FromJs_GotUserMediaDevices$(
				$elm$core$List$map$($author$project$Evergreen$Migrate$V419$migrate_Call_MediaDevice, p0),
				$elm$core$List$map$($author$project$Evergreen$Migrate$V419$migrate_IdString_IdString, p1));
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Call$FromJs_GotUserMediaDevicesError(p0);
		case 2:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Call$FromJs_SpeakingChanged$(
				$author$project$Evergreen$Migrate$V419$migrate_Call_LocalOrConnection(p0),
				p1);
		case 3:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Call$FromJs_StartConnectionError(p0);
		case 4:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Call$FromJs_DebugData(p0);
		case 5:
			return $author$project$Evergreen$V419$Call$FromJs_ScreenShareStarted;
		case 6:
			return $author$project$Evergreen$V419$Call$FromJs_ScreenShareStopped;
		case 7:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Call$FromJs_RecordingUploadProgress$(p0, p1);
		default:
			return $author$project$Evergreen$V419$Call$FromJs_RecordingUploadsStopped;
	}
};
var $author$project$Evergreen$V419$Call$ChangedVolume$ = function (a, b) {
	return {$: 11, a: a, b: b};
};
var $author$project$Evergreen$V419$Call$ChangedVolume = F2($author$project$Evergreen$V419$Call$ChangedVolume$);
var $author$project$Evergreen$V419$Call$DoubleClickedVideoNode = {$: 14};
var $author$project$Evergreen$V419$Call$MouseEnterVideoNode = function (a) {
	return {$: 12, a: a};
};
var $author$project$Evergreen$V419$Call$MouseExitVideoNode = function (a) {
	return {$: 13, a: a};
};
var $author$project$Evergreen$V419$Call$PolledDebugData = {$: 18};
var $author$project$Evergreen$V419$Call$PressedAnswerRecording = function (a) {
	return {$: 9, a: a};
};
var $author$project$Evergreen$V419$Call$PressedCancelRecording = {$: 8};
var $author$project$Evergreen$V419$Call$PressedCopyError = function (a) {
	return {$: 10, a: a};
};
var $author$project$Evergreen$V419$Call$PressedJoinCall = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V419$Call$PressedLeaveCall = {$: 6};
var $author$project$Evergreen$V419$Call$PressedRecord = {$: 7};
var $author$project$Evergreen$V419$Call$PressedToggleDebugData = {$: 17};
var $author$project$Evergreen$V419$Call$PressedToggleDeviceSettings = {$: 16};
var $author$project$Evergreen$V419$Call$PressedToggleMute = {$: 2};
var $author$project$Evergreen$V419$Call$PressedTogglePauseVideo = {$: 3};
var $author$project$Evergreen$V419$Call$PressedToggleScreenShare = {$: 4};
var $author$project$Evergreen$V419$Call$PressedVideoTile = function (a) {
	return {$: 15, a: a};
};
var $author$project$Evergreen$V419$Call$SelectedAudioInputDevice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Call$SelectedVideoInputDevice = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Call_Msg = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Call$SelectedAudioInputDevice(
				$author$project$Evergreen$Migrate$V419$migrate_IdString_IdString(p0));
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Call$SelectedVideoInputDevice(
				$author$project$Evergreen$Migrate$V419$migrate_IdString_IdString(p0));
		case 2:
			return $author$project$Evergreen$V419$Call$PressedToggleMute;
		case 3:
			return $author$project$Evergreen$V419$Call$PressedTogglePauseVideo;
		case 4:
			return $author$project$Evergreen$V419$Call$PressedToggleScreenShare;
		case 5:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Call$PressedJoinCall(
				$author$project$Evergreen$Migrate$V419$migrate_Call_CallId(p0));
		case 6:
			return $author$project$Evergreen$V419$Call$PressedLeaveCall;
		case 7:
			return $author$project$Evergreen$V419$Call$PressedRecord;
		case 8:
			return $author$project$Evergreen$V419$Call$PressedCancelRecording;
		case 9:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Call$PressedAnswerRecording(p0);
		case 10:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Call$PressedCopyError(p0);
		case 11:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Call$ChangedVolume$(
				$author$project$Evergreen$Migrate$V419$migrate_Call_ConnectionId(p0),
				p1);
		case 12:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Call$MouseEnterVideoNode(
				$author$project$Evergreen$Migrate$V419$migrate_Call_LocalOrConnection(p0));
		case 13:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Call$MouseExitVideoNode(
				$author$project$Evergreen$Migrate$V419$migrate_Call_LocalOrConnection(p0));
		case 14:
			return $author$project$Evergreen$V419$Call$DoubleClickedVideoNode;
		case 15:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Call$PressedVideoTile(
				$author$project$Evergreen$Migrate$V419$migrate_Call_VideoTile(p0));
		case 16:
			return $author$project$Evergreen$V419$Call$PressedToggleDeviceSettings;
		case 17:
			return $author$project$Evergreen$V419$Call$PressedToggleDebugData;
		default:
			return $author$project$Evergreen$V419$Call$PolledDebugData;
	}
};
var $author$project$Evergreen$V419$Drawing$GotZoomContainer = function (a) {
	return {$: 6, a: a};
};
var $author$project$Evergreen$V419$Drawing$PointerDown$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$Drawing$PointerDown = F2($author$project$Evergreen$V419$Drawing$PointerDown$);
var $author$project$Evergreen$V419$Drawing$PointerMoved$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V419$Drawing$PointerMoved = F2($author$project$Evergreen$V419$Drawing$PointerMoved$);
var $author$project$Evergreen$V419$Drawing$PointerUp = {$: 2};
var $author$project$Evergreen$V419$Drawing$PressedDone = {$: 7};
var $author$project$Evergreen$V419$Drawing$PressedRedo = {$: 4};
var $author$project$Evergreen$V419$Drawing$PressedUndo = {$: 3};
var $author$project$Evergreen$V419$Drawing$PressedZoom = {$: 5};
var $author$project$Evergreen$Migrate$V419$migrate_Drawing_Msg = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Drawing$PointerDown$(p0, p1);
		case 1:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Drawing$PointerMoved$(p0, p1);
		case 2:
			return $author$project$Evergreen$V419$Drawing$PointerUp;
		case 3:
			return $author$project$Evergreen$V419$Drawing$PressedUndo;
		case 4:
			return $author$project$Evergreen$V419$Drawing$PressedRedo;
		case 5:
			return $author$project$Evergreen$V419$Drawing$PressedZoom;
		case 6:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Drawing$GotZoomContainer(p0);
		default:
			return $author$project$Evergreen$V419$Drawing$PressedDone;
	}
};
var $author$project$Evergreen$V419$Editable$Edit = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Editable$PressedAcceptEdit = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Editable_Msg$ = function (migrate_value, old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Editable$Edit(
			$author$project$Evergreen$Migrate$V419$migrate_Editable_Model(p0));
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Editable$PressedAcceptEdit(
			migrate_value(p0));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Editable_Msg = F2($author$project$Evergreen$Migrate$V419$migrate_Editable_Msg$);
var $author$project$Evergreen$V419$Emoji$ClearEmojiHover = {$: 7};
var $author$project$Evergreen$V419$Emoji$KeyboardMovedHover$ = function (a, b) {
	return {$: 6, a: a, b: b};
};
var $author$project$Evergreen$V419$Emoji$KeyboardMovedHover = F2($author$project$Evergreen$V419$Emoji$KeyboardMovedHover$);
var $author$project$Evergreen$V419$Emoji$MouseEnteredEmoji$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$Evergreen$V419$Emoji$MouseEnteredEmoji = F2($author$project$Evergreen$V419$Emoji$MouseEnteredEmoji$);
var $author$project$Evergreen$V419$Emoji$NoOp = {$: 10};
var $author$project$Evergreen$V419$Emoji$PressedCategory$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V419$Emoji$PressedCategory = F2($author$project$Evergreen$V419$Emoji$PressedCategory$);
var $author$project$Evergreen$V419$Emoji$PressedClearSearch = {$: 9};
var $author$project$Evergreen$V419$Emoji$PressedContainer = {$: 0};
var $author$project$Evergreen$V419$Emoji$PressedSelectEmoji = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V419$Emoji$PressedSkinTone = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V419$Emoji$ScrolledToCategory = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$Emoji$TypedSearchText = function (a) {
	return {$: 8, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Emoji_Msg = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$Emoji$PressedContainer;
		case 1:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Emoji$PressedCategory$(
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_Category(p0),
				p1);
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Emoji$ScrolledToCategory(
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_Category(p0));
		case 3:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Emoji$PressedSelectEmoji(
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrSticker(p0));
		case 4:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Emoji$PressedSkinTone(
				$elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_Emoji_SkinTone, p0));
		case 5:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Emoji$MouseEnteredEmoji$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrSticker(p1));
		case 6:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Emoji$KeyboardMovedHover$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrSticker(p1));
		case 7:
			return $author$project$Evergreen$V419$Emoji$ClearEmojiHover;
		case 8:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Emoji$TypedSearchText(p0);
		case 9:
			return $author$project$Evergreen$V419$Emoji$PressedClearSearch;
		default:
			return $author$project$Evergreen$V419$Emoji$NoOp;
	}
};
var $author$project$Evergreen$V419$Encryption$FromJs_FileEncryptFailed$ = function (a, b) {
	return {$: 10, a: a, b: b};
};
var $author$project$Evergreen$V419$Encryption$FromJs_FileEncryptFailed = F2($author$project$Evergreen$V419$Encryption$FromJs_FileEncryptFailed$);
var $author$project$Evergreen$V419$Encryption$FromJs_FileEncrypted$ = function (a, b) {
	return {$: 9, a: a, b: b};
};
var $author$project$Evergreen$V419$Encryption$FromJs_FileEncrypted = F2($author$project$Evergreen$V419$Encryption$FromJs_FileEncrypted$);
var $author$project$Evergreen$V419$Encryption$FromJs_ManyMessagesDecrypted$ = function (a, b) {
	return {$: 6, a: a, b: b};
};
var $author$project$Evergreen$V419$Encryption$FromJs_ManyMessagesDecrypted = F2($author$project$Evergreen$V419$Encryption$FromJs_ManyMessagesDecrypted$);
var $author$project$Evergreen$V419$Encryption$FromJs_ManyMessagesEncryptFailed$ = function (a, b) {
	return {$: 8, a: a, b: b};
};
var $author$project$Evergreen$V419$Encryption$FromJs_ManyMessagesEncryptFailed = F2($author$project$Evergreen$V419$Encryption$FromJs_ManyMessagesEncryptFailed$);
var $author$project$Evergreen$V419$Encryption$FromJs_ManyMessagesEncrypted$ = function (a, b) {
	return {$: 7, a: a, b: b};
};
var $author$project$Evergreen$V419$Encryption$FromJs_ManyMessagesEncrypted = F2($author$project$Evergreen$V419$Encryption$FromJs_ManyMessagesEncrypted$);
var $author$project$Evergreen$V419$Encryption$FromJs_NewMessageDecryptFailed = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V419$Encryption$FromJs_NewMessageDecrypted$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $author$project$Evergreen$V419$Encryption$FromJs_NewMessageDecrypted = F2($author$project$Evergreen$V419$Encryption$FromJs_NewMessageDecrypted$);
var $author$project$Evergreen$V419$Encryption$FromJs_NewMessageEncryptFailed$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Evergreen$V419$Encryption$FromJs_NewMessageEncryptFailed = F2($author$project$Evergreen$V419$Encryption$FromJs_NewMessageEncryptFailed$);
var $author$project$Evergreen$V419$Encryption$FromJs_NewMessageEncrypted$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V419$Encryption$FromJs_NewMessageEncrypted = F2($author$project$Evergreen$V419$Encryption$FromJs_NewMessageEncrypted$);
var $author$project$Evergreen$V419$Encryption$FromJs_SharedSecretFailed$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V419$Encryption$FromJs_SharedSecretFailed = F2($author$project$Evergreen$V419$Encryption$FromJs_SharedSecretFailed$);
var $author$project$Evergreen$V419$Encryption$FromJs_SharedSecretStored = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$FileStatus$MeasuredImage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$FileStatus$MeasuredVideo$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V419$FileStatus$MeasuredVideo = F2($author$project$Evergreen$V419$FileStatus$MeasuredVideo$);
var $author$project$Evergreen$Migrate$V419$migrate_FileStatus_MeasuredFile = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$FileStatus$MeasuredImage(
			$author$project$Evergreen$Migrate$V419$migrate_Coord_Coord$($author$project$Evergreen$Migrate$V419$migrate_CssPixels_CssPixels, p0));
	} else {
		var p0 = old.a;
		var p1 = old.b;
		return $author$project$Evergreen$V419$FileStatus$MeasuredVideo$(
			$author$project$Evergreen$Migrate$V419$migrate_Coord_Coord$($author$project$Evergreen$Migrate$V419$migrate_CssPixels_CssPixels, p0),
			p1);
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Encryption_FromJs$ = function (migrate_a, old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Encryption$FromJs_SharedSecretStored(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 1:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Encryption$FromJs_SharedSecretFailed$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				p1);
		case 2:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Encryption$FromJs_NewMessageEncrypted$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Encryption_EncryptedData(p1));
		case 3:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Encryption$FromJs_NewMessageEncryptFailed$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				p1);
		case 4:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Encryption$FromJs_NewMessageDecrypted$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				migrate_a(p1));
		case 5:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Encryption$FromJs_NewMessageDecryptFailed(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 6:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Encryption$FromJs_ManyMessagesDecrypted$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$elm$core$List$map$(
					$elm$core$Result$map(migrate_a),
					p1));
		case 7:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Encryption$FromJs_ManyMessagesEncrypted$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$elm$core$List$map$($author$project$Evergreen$Migrate$V419$migrate_Encryption_EncryptedData, p1));
		case 8:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Encryption$FromJs_ManyMessagesEncryptFailed$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				p1);
		case 9:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Encryption$FromJs_FileEncrypted$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				{
					data: p1.data,
					key: p1.key,
					measured: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_MeasuredFile, p1.measured),
					thumbnail: p1.thumbnail
				});
		default:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Encryption$FromJs_FileEncryptFailed$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				p1);
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Encryption_FromJs = F2($author$project$Evergreen$Migrate$V419$migrate_Encryption_FromJs$);
var $author$project$Evergreen$Migrate$V419$migrate_FileStatus_UploadResponse = function (old) {
	return {
		fileHash: $author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileHash(old.fileHash),
		imageMetadata: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_ImageMetadata, old.imageMetadata),
		videoMetadata: $elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_VideoMetadata, old.videoMetadata)
	};
};
var $author$project$Evergreen$V419$Game$GoGameMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Game$GoSetupMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Game$NoOpMsg = {$: 11};
var $author$project$Evergreen$V419$Game$PressedCopyLink = function (a) {
	return {$: 7, a: a};
};
var $author$project$Evergreen$V419$Game$PressedReset = {$: 9};
var $author$project$Evergreen$V419$Game$PressedSelectGame = function (a) {
	return {$: 10, a: a};
};
var $author$project$Evergreen$V419$Game$PressedShareMatch = function (a) {
	return {$: 6, a: a};
};
var $author$project$Evergreen$V419$Game$SelectedMatch = function (a) {
	return {$: 8, a: a};
};
var $author$project$Evergreen$V419$Game$SheepGameMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V419$Game$SheepSetupMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V419$Game$WordSpellingGameMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$Game$WordSpellingSetupMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V419$Go$PressedAgree = {$: 3};
var $author$project$Evergreen$V419$Go$PressedCell = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Go$PressedDisagree = {$: 4};
var $author$project$Evergreen$V419$Go$PressedDoneMarking = {$: 2};
var $author$project$Evergreen$V419$Go$PressedJoinGame = {$: 5};
var $author$project$Evergreen$V419$Go$PressedPass = {$: 1};
var $author$project$Evergreen$V419$Go$SpectatorMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Evergreen$V419$Go$ChangedViewingMove = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$Go$PressedArrowLeft = {$: 0};
var $author$project$Evergreen$V419$Go$PressedArrowRight = {$: 1};
var $author$project$Evergreen$V419$Go$Spectator_PressedCell = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Go_SpectatorMsg = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$Go$PressedArrowLeft;
		case 1:
			return $author$project$Evergreen$V419$Go$PressedArrowRight;
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Go$ChangedViewingMove(p0);
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Go$Spectator_PressedCell(p0);
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Go_GameMsg = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Go$PressedCell(p0);
		case 1:
			return $author$project$Evergreen$V419$Go$PressedPass;
		case 2:
			return $author$project$Evergreen$V419$Go$PressedDoneMarking;
		case 3:
			return $author$project$Evergreen$V419$Go$PressedAgree;
		case 4:
			return $author$project$Evergreen$V419$Go$PressedDisagree;
		case 5:
			return $author$project$Evergreen$V419$Go$PressedJoinGame;
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Go$SpectatorMsg(
				$author$project$Evergreen$Migrate$V419$migrate_Go_SpectatorMsg(p0));
	}
};
var $author$project$Evergreen$V419$Go$ChangedHandicapInput = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$Go$ChangedHeightInput = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Go$ChangedIncrementInput = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V419$Go$ChangedKomiInput = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V419$Go$ChangedMainTimeInput = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V419$Go$ChangedWidthInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Go$PressedCancel = {$: 9};
var $author$project$Evergreen$V419$Go$PressedStartGame = {$: 8};
var $author$project$Evergreen$V419$Go$SelectedPlayingAs = function (a) {
	return {$: 7, a: a};
};
var $author$project$Evergreen$V419$Go$SelectedSize = function (a) {
	return {$: 6, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Go_SetupMsg = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Go$ChangedWidthInput(p0);
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Go$ChangedHeightInput(p0);
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Go$ChangedHandicapInput(p0);
		case 3:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Go$ChangedKomiInput(p0);
		case 4:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Go$ChangedMainTimeInput(p0);
		case 5:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Go$ChangedIncrementInput(p0);
		case 6:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Go$SelectedSize(
				$author$project$Evergreen$Migrate$V419$migrate_Go_SizeSelection(p0));
		case 7:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Go$SelectedPlayingAs(
				$author$project$Evergreen$Migrate$V419$migrate_Go_Stone(p0));
		case 8:
			return $author$project$Evergreen$V419$Go$PressedStartGame;
		default:
			return $author$project$Evergreen$V419$Go$PressedCancel;
	}
};
var $author$project$Evergreen$V419$SheepGame$ExitedQuestion = function (a) {
	return {$: 19, a: a};
};
var $author$project$Evergreen$V419$SheepGame$ExitedResultsGrid = function (a) {
	return {$: 21, a: a};
};
var $author$project$Evergreen$V419$SheepGame$GotAnswerFileUpload$ = function (a, b, c) {
	return {$: 2, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$SheepGame$GotAnswerFileUpload = F3($author$project$Evergreen$V419$SheepGame$GotAnswerFileUpload$);
var $author$project$Evergreen$V419$SheepGame$GotAnswerFiles$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V419$SheepGame$GotAnswerFiles = F2($author$project$Evergreen$V419$SheepGame$GotAnswerFiles$);
var $author$project$Evergreen$V419$SheepGame$GotNotesFileUpload$ = function (a, b, c) {
	return {$: 11, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$SheepGame$GotNotesFileUpload = F3($author$project$Evergreen$V419$SheepGame$GotNotesFileUpload$);
var $author$project$Evergreen$V419$SheepGame$GotNotesFiles$ = function (a, b) {
	return {$: 10, a: a, b: b};
};
var $author$project$Evergreen$V419$SheepGame$GotNotesFiles = F2($author$project$Evergreen$V419$SheepGame$GotNotesFiles$);
var $author$project$Evergreen$V419$SheepGame$HoveredQuestion = function (a) {
	return {$: 18, a: a};
};
var $author$project$Evergreen$V419$SheepGame$HoveredResultsGrid = function (a) {
	return {$: 20, a: a};
};
var $author$project$Evergreen$V419$SheepGame$NoOp = {$: 27};
var $author$project$Evergreen$V419$SheepGame$PressedCopyCode = function (a) {
	return {$: 25, a: a};
};
var $author$project$Evergreen$V419$SheepGame$PressedDeleteAnswerFile$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Evergreen$V419$SheepGame$PressedDeleteAnswerFile = F2($author$project$Evergreen$V419$SheepGame$PressedDeleteAnswerFile$);
var $author$project$Evergreen$V419$SheepGame$PressedDeleteNotesFile$ = function (a, b) {
	return {$: 12, a: a, b: b};
};
var $author$project$Evergreen$V419$SheepGame$PressedDeleteNotesFile = F2($author$project$Evergreen$V419$SheepGame$PressedDeleteNotesFile$);
var $author$project$Evergreen$V419$SheepGame$PressedHidePreviousQuestion = {$: 17};
var $author$project$Evergreen$V419$SheepGame$PressedImage = function (a) {
	return {$: 24, a: a};
};
var $author$project$Evergreen$V419$SheepGame$PressedLockAnswers = {$: 6};
var $author$project$Evergreen$V419$SheepGame$PressedNewQuestionRevealed = {$: 26};
var $author$project$Evergreen$V419$SheepGame$PressedRevealScores = {$: 15};
var $author$project$Evergreen$V419$SheepGame$PressedShowNextQuestion = {$: 16};
var $author$project$Evergreen$V419$SheepGame$PressedToggleAnswerFileSpoiler$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$Evergreen$V419$SheepGame$PressedToggleAnswerFileSpoiler = F2($author$project$Evergreen$V419$SheepGame$PressedToggleAnswerFileSpoiler$);
var $author$project$Evergreen$V419$SheepGame$PressedToggleNotesFileSpoiler$ = function (a, b) {
	return {$: 14, a: a, b: b};
};
var $author$project$Evergreen$V419$SheepGame$PressedToggleNotesFileSpoiler = F2($author$project$Evergreen$V419$SheepGame$PressedToggleNotesFileSpoiler$);
var $author$project$Evergreen$V419$SheepGame$PressedUnlockAnswers = {$: 7};
var $author$project$Evergreen$V419$SheepGame$PressedViewAnswerFileInfo$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $author$project$Evergreen$V419$SheepGame$PressedViewAnswerFileInfo = F2($author$project$Evergreen$V419$SheepGame$PressedViewAnswerFileInfo$);
var $author$project$Evergreen$V419$SheepGame$PressedViewNotesFileInfo$ = function (a, b) {
	return {$: 13, a: a, b: b};
};
var $author$project$Evergreen$V419$SheepGame$PressedViewNotesFileInfo = F2($author$project$Evergreen$V419$SheepGame$PressedViewNotesFileInfo$);
var $author$project$Evergreen$V419$SheepGame$ReactionMsg$ = function (a, b) {
	return {$: 23, a: a, b: b};
};
var $author$project$Evergreen$V419$SheepGame$ReactionMsg = F2($author$project$Evergreen$V419$SheepGame$ReactionMsg$);
var $author$project$Evergreen$V419$SheepGame$TypedAnswer$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$SheepGame$TypedAnswer = F2($author$project$Evergreen$V419$SheepGame$TypedAnswer$);
var $author$project$Evergreen$V419$SheepGame$TypedGroup$ = function (a, b, c) {
	return {$: 8, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$SheepGame$TypedGroup = F3($author$project$Evergreen$V419$SheepGame$TypedGroup$);
var $author$project$Evergreen$V419$SheepGame$TypedNotes$ = function (a, b) {
	return {$: 9, a: a, b: b};
};
var $author$project$Evergreen$V419$SheepGame$TypedNotes = F2($author$project$Evergreen$V419$SheepGame$TypedNotes$);
var $author$project$Evergreen$V419$SheepGame$UserScrolledResults = function (a) {
	return {$: 22, a: a};
};
var $author$project$Evergreen$V419$MessageInput$IgnoreTouchStart = {$: 14};
var $author$project$Evergreen$V419$MessageInput$IgnoredKeyPress = {$: 13};
var $author$project$Evergreen$V419$MessageInput$OnPasteFiles = function (a) {
	return {$: 9, a: a};
};
var $author$project$Evergreen$V419$MessageInput$PressedDropdownItem = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V419$MessageInput$PressedOpenEmojiSelector = {$: 8};
var $author$project$Evergreen$V419$MessageInput$PressedPingDropdownContainer = {$: 6};
var $author$project$Evergreen$V419$MessageInput$PressedSendMessage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$MessageInput$PressedTextInput = {$: 0};
var $author$project$Evergreen$V419$MessageInput$PressedUploadFile = {$: 7};
var $author$project$Evergreen$V419$MessageInput$TypedArrowInDropdown = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V419$MessageInput$TypedArrowUpInEmptyInput = {$: 4};
var $author$project$Evergreen$V419$MessageInput$TypedMessage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$MessageInput$TypedPageDown = {$: 11};
var $author$project$Evergreen$V419$MessageInput$TypedPageUp = {$: 10};
var $author$project$Evergreen$V419$MessageInput$TypedTabInCodeBlock = function (a) {
	return {$: 12, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_MessageInput_Msg = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$MessageInput$PressedTextInput;
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$MessageInput$TypedMessage(p0);
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$MessageInput$PressedSendMessage(p0);
		case 3:
			var p0 = old.a;
			return $author$project$Evergreen$V419$MessageInput$TypedArrowInDropdown(p0);
		case 4:
			return $author$project$Evergreen$V419$MessageInput$TypedArrowUpInEmptyInput;
		case 5:
			var p0 = old.a;
			return $author$project$Evergreen$V419$MessageInput$PressedDropdownItem(p0);
		case 6:
			return $author$project$Evergreen$V419$MessageInput$PressedPingDropdownContainer;
		case 7:
			return $author$project$Evergreen$V419$MessageInput$PressedUploadFile;
		case 8:
			return $author$project$Evergreen$V419$MessageInput$PressedOpenEmojiSelector;
		case 9:
			var p0 = old.a;
			return $author$project$Evergreen$V419$MessageInput$OnPasteFiles(p0);
		case 10:
			return $author$project$Evergreen$V419$MessageInput$TypedPageUp;
		case 11:
			return $author$project$Evergreen$V419$MessageInput$TypedPageDown;
		case 12:
			var p0 = old.a;
			return $author$project$Evergreen$V419$MessageInput$TypedTabInCodeBlock(
				$author$project$Evergreen$Migrate$V419$migrate_Range_Range(p0));
		case 13:
			return $author$project$Evergreen$V419$MessageInput$IgnoredKeyPress;
		default:
			return $author$project$Evergreen$V419$MessageInput$IgnoreTouchStart;
	}
};
var $author$project$Evergreen$V419$MessageView$MessageViewMsg_PressedCallStartedCard = {$: 17};
var $author$project$Evergreen$V419$MessageView$MessageViewMsg_PressedEditMessage = {$: 11};
var $author$project$Evergreen$V419$MessageView$MessageViewMsg_PressedGameStartedCard = {$: 18};
var $author$project$Evergreen$V419$MessageView$MessageViewMsg_PressedReactionEmoji = function (a) {
	return {$: 16, a: a};
};
var $author$project$Evergreen$V419$MessageView$MessageViewMsg_PressedReply = {$: 12};
var $author$project$Evergreen$V419$MessageView$MessageViewMsg_PressedShowFullMenu$ = function (a, b) {
	return {$: 13, a: a, b: b};
};
var $author$project$Evergreen$V419$MessageView$MessageViewMsg_PressedShowFullMenu = F2($author$project$Evergreen$V419$MessageView$MessageViewMsg_PressedShowFullMenu$);
var $author$project$Evergreen$V419$MessageView$MessageViewMsg_PressedShowReactionEmojiSelector = {$: 10};
var $author$project$Evergreen$V419$MessageView$MessageView_AltPressedMessage$ = function (a, b, c, d, e) {
	return {$: 6, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V419$MessageView$MessageView_AltPressedMessage = F5($author$project$Evergreen$V419$MessageView$MessageView_AltPressedMessage$);
var $author$project$Evergreen$V419$MessageView$MessageView_MouseEnteredMessage = {$: 3};
var $author$project$Evergreen$V419$MessageView$MessageView_MouseExitedMessage = {$: 4};
var $author$project$Evergreen$V419$MessageView$MessageView_NoOp = {$: 15};
var $author$project$Evergreen$V419$MessageView$MessageView_PressedCardAnchor$ = function (a, b) {
	return {$: 22, a: a, b: b};
};
var $author$project$Evergreen$V419$MessageView$MessageView_PressedCardAnchor = F2($author$project$Evergreen$V419$MessageView$MessageView_PressedCardAnchor$);
var $author$project$Evergreen$V419$MessageView$MessageView_PressedChannelMention$ = function (a, b) {
	return {$: 25, a: a, b: b};
};
var $author$project$Evergreen$V419$MessageView$MessageView_PressedChannelMention = F2($author$project$Evergreen$V419$MessageView$MessageView_PressedChannelMention$);
var $author$project$Evergreen$V419$MessageView$MessageView_PressedCopyCode = function (a) {
	return {$: 27, a: a};
};
var $author$project$Evergreen$V419$MessageView$MessageView_PressedDateDivider$ = function (a, b, c) {
	return {$: 21, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$MessageView$MessageView_PressedDateDivider = F3($author$project$Evergreen$V419$MessageView$MessageView_PressedDateDivider$);
var $author$project$Evergreen$V419$MessageView$MessageView_PressedDiscordChannelMention$ = function (a, b) {
	return {$: 26, a: a, b: b};
};
var $author$project$Evergreen$V419$MessageView$MessageView_PressedDiscordChannelMention = F2($author$project$Evergreen$V419$MessageView$MessageView_PressedDiscordChannelMention$);
var $author$project$Evergreen$V419$MessageView$MessageView_PressedDiscordUserIconButton = function (a) {
	return {$: 24, a: a};
};
var $author$project$Evergreen$V419$MessageView$MessageView_PressedImage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$MessageView$MessageView_PressedNonWhitelistLink = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$MessageView$MessageView_PressedReactionEmoji_Add = function (a) {
	return {$: 8, a: a};
};
var $author$project$Evergreen$V419$MessageView$MessageView_PressedReactionEmoji_Remove = function (a) {
	return {$: 7, a: a};
};
var $author$project$Evergreen$V419$MessageView$MessageView_PressedReplyLink = {$: 9};
var $author$project$Evergreen$V419$MessageView$MessageView_PressedSpoiler = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$MessageView$MessageView_PressedTimestamp$ = function (a, b) {
	return {$: 20, a: a, b: b};
};
var $author$project$Evergreen$V419$MessageView$MessageView_PressedTimestamp = F2($author$project$Evergreen$V419$MessageView$MessageView_PressedTimestamp$);
var $author$project$Evergreen$V419$MessageView$MessageView_PressedUserIconAnchor$ = function (a, b) {
	return {$: 19, a: a, b: b};
};
var $author$project$Evergreen$V419$MessageView$MessageView_PressedUserIconAnchor = F2($author$project$Evergreen$V419$MessageView$MessageView_PressedUserIconAnchor$);
var $author$project$Evergreen$V419$MessageView$MessageView_PressedUserIconButton = function (a) {
	return {$: 23, a: a};
};
var $author$project$Evergreen$V419$MessageView$MessageView_PressedViewThreadLink = {$: 14};
var $author$project$Evergreen$V419$MessageView$MessageView_TouchStart$ = function (a, b, c, d, e, f) {
	return {$: 5, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Evergreen$V419$MessageView$MessageView_TouchStart = F6($author$project$Evergreen$V419$MessageView$MessageView_TouchStart$);
var $author$project$Evergreen$V419$RichText$PressedAttachedFileImage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$RichText$PressedEmbedImage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_RichText_PressedImageId = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$RichText$PressedAttachedFileImage(
			$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$RichText$PressedEmbedImage(p0);
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_RichText_PressedImageData = function (old) {
	return {
		displayWidth: old.displayWidth,
		fileUrl: old.fileUrl,
		imageId: $author$project$Evergreen$Migrate$V419$migrate_RichText_PressedImageId(old.imageId),
		imageSize: $author$project$Evergreen$Migrate$V419$migrate_Coord_Coord$($author$project$Evergreen$Migrate$V419$migrate_CssPixels_CssPixels, old.imageSize),
		position: $author$project$Evergreen$Migrate$V419$migrate_Point2d_Point2d$($author$project$Evergreen$Migrate$V419$migrate_CssPixels_CssPixels, $author$project$Evergreen$Migrate$V419$migrate_Touch_ScreenCoordinate, old.position)
	};
};
var $author$project$Evergreen$Migrate$V419$migrate_MessageView_MessageViewMsg = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$MessageView$MessageView_PressedSpoiler(p0);
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$MessageView$MessageView_PressedNonWhitelistLink(p0);
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$MessageView$MessageView_PressedImage(
				$author$project$Evergreen$Migrate$V419$migrate_RichText_PressedImageData(p0));
		case 3:
			return $author$project$Evergreen$V419$MessageView$MessageView_MouseEnteredMessage;
		case 4:
			return $author$project$Evergreen$V419$MessageView$MessageView_MouseExitedMessage;
		case 5:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			var p5 = old.f;
			return $author$project$Evergreen$V419$MessageView$MessageView_TouchStart$(
				p0,
				p1,
				p2,
				p3,
				p4,
				$author$project$Evergreen$Migrate$V419$migrate_NonemptyDict_NonemptyDict$($elm$core$Basics$identity, $author$project$Evergreen$Migrate$V419$migrate_Touch_Touch, p5));
		case 6:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			return $author$project$Evergreen$V419$MessageView$MessageView_AltPressedMessage$(
				p0,
				p1,
				p2,
				p3,
				$author$project$Evergreen$Migrate$V419$migrate_Coord_Coord$($author$project$Evergreen$Migrate$V419$migrate_CssPixels_CssPixels, p4));
		case 7:
			var p0 = old.a;
			return $author$project$Evergreen$V419$MessageView$MessageView_PressedReactionEmoji_Remove(
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji(p0));
		case 8:
			var p0 = old.a;
			return $author$project$Evergreen$V419$MessageView$MessageView_PressedReactionEmoji_Add(
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji(p0));
		case 9:
			return $author$project$Evergreen$V419$MessageView$MessageView_PressedReplyLink;
		case 10:
			return $author$project$Evergreen$V419$MessageView$MessageViewMsg_PressedShowReactionEmojiSelector;
		case 11:
			return $author$project$Evergreen$V419$MessageView$MessageViewMsg_PressedEditMessage;
		case 12:
			return $author$project$Evergreen$V419$MessageView$MessageViewMsg_PressedReply;
		case 13:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$MessageView$MessageViewMsg_PressedShowFullMenu$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Coord_Coord$($author$project$Evergreen$Migrate$V419$migrate_CssPixels_CssPixels, p1));
		case 14:
			return $author$project$Evergreen$V419$MessageView$MessageView_PressedViewThreadLink;
		case 15:
			return $author$project$Evergreen$V419$MessageView$MessageView_NoOp;
		case 16:
			var p0 = old.a;
			return $author$project$Evergreen$V419$MessageView$MessageViewMsg_PressedReactionEmoji(
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji(p0));
		case 17:
			return $author$project$Evergreen$V419$MessageView$MessageViewMsg_PressedCallStartedCard;
		case 18:
			return $author$project$Evergreen$V419$MessageView$MessageViewMsg_PressedGameStartedCard;
		case 19:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$MessageView$MessageView_PressedUserIconAnchor$(
				$author$project$Evergreen$Migrate$V419$migrate_Point2d_Point2d$($author$project$Evergreen$Migrate$V419$migrate_CssPixels_CssPixels, $author$project$Evergreen$Migrate$V419$migrate_Touch_ScreenCoordinate, p0),
				p1);
		case 20:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$MessageView$MessageView_PressedTimestamp$(
				$author$project$Evergreen$Migrate$V419$migrate_Point2d_Point2d$($author$project$Evergreen$Migrate$V419$migrate_CssPixels_CssPixels, $author$project$Evergreen$Migrate$V419$migrate_Touch_ScreenCoordinate, p0),
				p1);
		case 21:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$MessageView$MessageView_PressedDateDivider$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Point2d_Point2d$($author$project$Evergreen$Migrate$V419$migrate_CssPixels_CssPixels, $author$project$Evergreen$Migrate$V419$migrate_Touch_ScreenCoordinate, p1),
				p2);
		case 22:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$MessageView$MessageView_PressedCardAnchor$(
				$author$project$Evergreen$Migrate$V419$migrate_Point2d_Point2d$($author$project$Evergreen$Migrate$V419$migrate_CssPixels_CssPixels, $author$project$Evergreen$Migrate$V419$migrate_Touch_ScreenCoordinate, p0),
				p1);
		case 23:
			var p0 = old.a;
			return $author$project$Evergreen$V419$MessageView$MessageView_PressedUserIconButton(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 24:
			var p0 = old.a;
			return $author$project$Evergreen$V419$MessageView$MessageView_PressedDiscordUserIconButton(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0));
		case 25:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$MessageView$MessageView_PressedChannelMention$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute(p1));
		case 26:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$MessageView$MessageView_PressedDiscordChannelMention$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute(p1));
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$MessageView$MessageView_PressedCopyCode(p0);
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_SheepGame_GameMsg = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SheepGame$TypedAnswer$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_MessageInput_Msg(p1));
		case 1:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SheepGame$GotAnswerFiles$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				p1);
		case 2:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$SheepGame$GotAnswerFileUpload$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$elm$core$Result$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_UploadResponse, p2));
		case 3:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SheepGame$PressedDeleteAnswerFile$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1));
		case 4:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SheepGame$PressedViewAnswerFileInfo$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1));
		case 5:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SheepGame$PressedToggleAnswerFileSpoiler$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				{
					fileId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1.fileId),
					removeSpoiler: p1.removeSpoiler
				});
		case 6:
			return $author$project$Evergreen$V419$SheepGame$PressedLockAnswers;
		case 7:
			return $author$project$Evergreen$V419$SheepGame$PressedUnlockAnswers;
		case 8:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$SheepGame$TypedGroup$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				p2);
		case 9:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SheepGame$TypedNotes$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_MessageInput_Msg(p1));
		case 10:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SheepGame$GotNotesFiles$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				p1);
		case 11:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$SheepGame$GotNotesFileUpload$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$elm$core$Result$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_UploadResponse, p2));
		case 12:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SheepGame$PressedDeleteNotesFile$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1));
		case 13:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SheepGame$PressedViewNotesFileInfo$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1));
		case 14:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SheepGame$PressedToggleNotesFileSpoiler$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				{
					fileId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1.fileId),
					removeSpoiler: p1.removeSpoiler
				});
		case 15:
			return $author$project$Evergreen$V419$SheepGame$PressedRevealScores;
		case 16:
			return $author$project$Evergreen$V419$SheepGame$PressedShowNextQuestion;
		case 17:
			return $author$project$Evergreen$V419$SheepGame$PressedHidePreviousQuestion;
		case 18:
			var p0 = old.a;
			return $author$project$Evergreen$V419$SheepGame$HoveredQuestion(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 19:
			var p0 = old.a;
			return $author$project$Evergreen$V419$SheepGame$ExitedQuestion(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 20:
			var p0 = old.a;
			return $author$project$Evergreen$V419$SheepGame$HoveredResultsGrid(
				$elm$core$Tuple$mapBoth$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, p0));
		case 21:
			var p0 = old.a;
			return $author$project$Evergreen$V419$SheepGame$ExitedResultsGrid(
				$elm$core$Tuple$mapBoth$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, p0));
		case 22:
			var p0 = old.a;
			return $author$project$Evergreen$V419$SheepGame$UserScrolledResults(
				$author$project$Evergreen$Migrate$V419$migrate_Scroll_ScrollPosition(p0));
		case 23:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SheepGame$ReactionMsg$(
				$author$project$Evergreen$Migrate$V419$migrate_SheepGame_ReactionTarget(p0),
				$author$project$Evergreen$Migrate$V419$migrate_MessageView_MessageViewMsg(p1));
		case 24:
			var p0 = old.a;
			return $author$project$Evergreen$V419$SheepGame$PressedImage(
				$author$project$Evergreen$Migrate$V419$migrate_RichText_PressedImageData(p0));
		case 25:
			var p0 = old.a;
			return $author$project$Evergreen$V419$SheepGame$PressedCopyCode(p0);
		case 26:
			return $author$project$Evergreen$V419$SheepGame$PressedNewQuestionRevealed;
		default:
			return $author$project$Evergreen$V419$SheepGame$NoOp;
	}
};
var $author$project$Evergreen$V419$SheepGame$GotAttachedFileUpload$ = function (a, b, c) {
	return {$: 6, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$SheepGame$GotAttachedFileUpload = F3($author$project$Evergreen$V419$SheepGame$GotAttachedFileUpload$);
var $author$project$Evergreen$V419$SheepGame$GotFilesToAttach$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$Evergreen$V419$SheepGame$GotFilesToAttach = F2($author$project$Evergreen$V419$SheepGame$GotFilesToAttach$);
var $author$project$Evergreen$V419$SheepGame$PressedAddQuestion = {$: 1};
var $author$project$Evergreen$V419$SheepGame$PressedCancel = {$: 4};
var $author$project$Evergreen$V419$SheepGame$PressedDeleteAttachedFile$ = function (a, b) {
	return {$: 7, a: a, b: b};
};
var $author$project$Evergreen$V419$SheepGame$PressedDeleteAttachedFile = F2($author$project$Evergreen$V419$SheepGame$PressedDeleteAttachedFile$);
var $author$project$Evergreen$V419$SheepGame$PressedRemoveQuestion = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$SheepGame$PressedStartGame = {$: 3};
var $author$project$Evergreen$V419$SheepGame$PressedToggleAttachedFileSpoiler$ = function (a, b) {
	return {$: 9, a: a, b: b};
};
var $author$project$Evergreen$V419$SheepGame$PressedToggleAttachedFileSpoiler = F2($author$project$Evergreen$V419$SheepGame$PressedToggleAttachedFileSpoiler$);
var $author$project$Evergreen$V419$SheepGame$PressedViewAttachedFileInfo$ = function (a, b) {
	return {$: 8, a: a, b: b};
};
var $author$project$Evergreen$V419$SheepGame$PressedViewAttachedFileInfo = F2($author$project$Evergreen$V419$SheepGame$PressedViewAttachedFileInfo$);
var $author$project$Evergreen$V419$SheepGame$TypedQuestion$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$SheepGame$TypedQuestion = F2($author$project$Evergreen$V419$SheepGame$TypedQuestion$);
var $author$project$Evergreen$Migrate$V419$migrate_SheepGame_SetupMsg = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SheepGame$TypedQuestion$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_MessageInput_Msg(p1));
		case 1:
			return $author$project$Evergreen$V419$SheepGame$PressedAddQuestion;
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$SheepGame$PressedRemoveQuestion(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 3:
			return $author$project$Evergreen$V419$SheepGame$PressedStartGame;
		case 4:
			return $author$project$Evergreen$V419$SheepGame$PressedCancel;
		case 5:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SheepGame$GotFilesToAttach$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				p1);
		case 6:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$SheepGame$GotAttachedFileUpload$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$elm$core$Result$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_UploadResponse, p2));
		case 7:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SheepGame$PressedDeleteAttachedFile$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1));
		case 8:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SheepGame$PressedViewAttachedFileInfo$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1));
		default:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$SheepGame$PressedToggleAttachedFileSpoiler$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				{
					fileId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1.fileId),
					removeSpoiler: p1.removeSpoiler
				});
	}
};
var $author$project$Evergreen$V419$WordSpellingGame$GotWordDefinition$ = function (a, b) {
	return {$: 16, a: a, b: b};
};
var $author$project$Evergreen$V419$WordSpellingGame$GotWordDefinition = F2($author$project$Evergreen$V419$WordSpellingGame$GotWordDefinition$);
var $author$project$Evergreen$V419$WordSpellingGame$MouseEnterPlayerRow = function (a) {
	return {$: 6, a: a};
};
var $author$project$Evergreen$V419$WordSpellingGame$MouseEnterWord$ = function (a, b, c) {
	return {$: 8, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$WordSpellingGame$MouseEnterWord = F3($author$project$Evergreen$V419$WordSpellingGame$MouseEnterWord$);
var $author$project$Evergreen$V419$WordSpellingGame$MouseExitPlayerRow = function (a) {
	return {$: 7, a: a};
};
var $author$project$Evergreen$V419$WordSpellingGame$MouseExitWord = {$: 9};
var $author$project$Evergreen$V419$WordSpellingGame$PressedClearBoard = {$: 3};
var $author$project$Evergreen$V419$WordSpellingGame$PressedCloseWordDefinition = {$: 15};
var $author$project$Evergreen$V419$WordSpellingGame$PressedJoinGame = {$: 1};
var $author$project$Evergreen$V419$WordSpellingGame$PressedNextWordDefinition = {$: 14};
var $author$project$Evergreen$V419$WordSpellingGame$PressedPlayerRow = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V419$WordSpellingGame$PressedPreviousWordDefinition = {$: 13};
var $author$project$Evergreen$V419$WordSpellingGame$PressedReplaceTrayOrPass = {$: 2};
var $author$project$Evergreen$V419$WordSpellingGame$PressedSubmitPremove = function (a) {
	return {$: 11, a: a};
};
var $author$project$Evergreen$V419$WordSpellingGame$PressedSubmitWord = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$WordSpellingGame$PressedToggleSettings = {$: 4};
var $author$project$Evergreen$V419$WordSpellingGame$PressedWordDefinition = function (a) {
	return {$: 12, a: a};
};
var $author$project$Evergreen$V419$WordSpellingGame$ReactionMsg$ = function (a, b) {
	return {$: 17, a: a, b: b};
};
var $author$project$Evergreen$V419$WordSpellingGame$ReactionMsg = F2($author$project$Evergreen$V419$WordSpellingGame$ReactionMsg$);
var $author$project$Evergreen$V419$WordSpellingGame$UserScrolledPastMoves = function (a) {
	return {$: 10, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_GameMsg = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$WordSpellingGame$PressedSubmitWord(
				$author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_PlacedWord(p0));
		case 1:
			return $author$project$Evergreen$V419$WordSpellingGame$PressedJoinGame;
		case 2:
			return $author$project$Evergreen$V419$WordSpellingGame$PressedReplaceTrayOrPass;
		case 3:
			return $author$project$Evergreen$V419$WordSpellingGame$PressedClearBoard;
		case 4:
			return $author$project$Evergreen$V419$WordSpellingGame$PressedToggleSettings;
		case 5:
			var p0 = old.a;
			return $author$project$Evergreen$V419$WordSpellingGame$PressedPlayerRow(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 6:
			var p0 = old.a;
			return $author$project$Evergreen$V419$WordSpellingGame$MouseEnterPlayerRow(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 7:
			var p0 = old.a;
			return $author$project$Evergreen$V419$WordSpellingGame$MouseExitPlayerRow(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 8:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$WordSpellingGame$MouseEnterWord$(
				p0,
				$elm$core$List$map$(
					$elm$core$Tuple$mapSecond($author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_LetterOrWildcard),
					p1),
				$author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_Shared(p2));
		case 9:
			return $author$project$Evergreen$V419$WordSpellingGame$MouseExitWord;
		case 10:
			var p0 = old.a;
			return $author$project$Evergreen$V419$WordSpellingGame$UserScrolledPastMoves(
				$author$project$Evergreen$Migrate$V419$migrate_Scroll_ScrollPosition(p0));
		case 11:
			var p0 = old.a;
			return $author$project$Evergreen$V419$WordSpellingGame$PressedSubmitPremove(
				$author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_PlacedWord(p0));
		case 12:
			var p0 = old.a;
			return $author$project$Evergreen$V419$WordSpellingGame$PressedWordDefinition(p0);
		case 13:
			return $author$project$Evergreen$V419$WordSpellingGame$PressedPreviousWordDefinition;
		case 14:
			return $author$project$Evergreen$V419$WordSpellingGame$PressedNextWordDefinition;
		case 15:
			return $author$project$Evergreen$V419$WordSpellingGame$PressedCloseWordDefinition;
		case 16:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$WordSpellingGame$GotWordDefinition$(p0, p1);
		default:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$WordSpellingGame$ReactionMsg$(
				$author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_ReactionTarget(p0),
				$author$project$Evergreen$Migrate$V419$migrate_MessageView_MessageViewMsg(p1));
	}
};
var $author$project$Evergreen$V419$WordSpellingGame$ChangedFullTrayBonusInput = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$WordSpellingGame$ChangedLetterValue$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Evergreen$V419$WordSpellingGame$ChangedLetterValue = F2($author$project$Evergreen$V419$WordSpellingGame$ChangedLetterValue$);
var $author$project$Evergreen$V419$WordSpellingGame$ChangedLettersInput = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$WordSpellingGame$ChangedPlaceWordAttempts = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V419$WordSpellingGame$ChangedTraySizeInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$WordSpellingGame$PressedCancel = {$: 7};
var $author$project$Evergreen$V419$WordSpellingGame$PressedExpandAdvancedSettings = {$: 9};
var $author$project$Evergreen$V419$WordSpellingGame$PressedLanguage = function (a) {
	return {$: 8, a: a};
};
var $author$project$Evergreen$V419$WordSpellingGame$PressedResetLetters = {$: 5};
var $author$project$Evergreen$V419$WordSpellingGame$PressedStartGame = {$: 6};
var $author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_SetupMsg = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$WordSpellingGame$ChangedTraySizeInput(p0);
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$WordSpellingGame$ChangedFullTrayBonusInput(p0);
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$WordSpellingGame$ChangedLettersInput(p0);
		case 3:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$WordSpellingGame$ChangedLetterValue$(p0, p1);
		case 4:
			var p0 = old.a;
			return $author$project$Evergreen$V419$WordSpellingGame$ChangedPlaceWordAttempts(
				$author$project$Evergreen$Migrate$V419$migrate_OneOrGreater_OneOrGreater(p0));
		case 5:
			return $author$project$Evergreen$V419$WordSpellingGame$PressedResetLetters;
		case 6:
			return $author$project$Evergreen$V419$WordSpellingGame$PressedStartGame;
		case 7:
			return $author$project$Evergreen$V419$WordSpellingGame$PressedCancel;
		case 8:
			var p0 = old.a;
			return $author$project$Evergreen$V419$WordSpellingGame$PressedLanguage(
				$author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_Language(p0));
		default:
			return $author$project$Evergreen$V419$WordSpellingGame$PressedExpandAdvancedSettings;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Game_Msg = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Game$GoGameMsg(
				$author$project$Evergreen$Migrate$V419$migrate_Go_GameMsg(p0));
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Game$GoSetupMsg(
				$author$project$Evergreen$Migrate$V419$migrate_Go_SetupMsg(p0));
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Game$WordSpellingGameMsg(
				$author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_GameMsg(p0));
		case 3:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Game$WordSpellingSetupMsg(
				$author$project$Evergreen$Migrate$V419$migrate_WordSpellingGame_SetupMsg(p0));
		case 4:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Game$SheepGameMsg(
				$author$project$Evergreen$Migrate$V419$migrate_SheepGame_GameMsg(p0));
		case 5:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Game$SheepSetupMsg(
				$author$project$Evergreen$Migrate$V419$migrate_SheepGame_SetupMsg(p0));
		case 6:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Game$PressedShareMatch(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 7:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Game$PressedCopyLink(p0);
		case 8:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Game$SelectedMatch(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 9:
			return $author$project$Evergreen$V419$Game$PressedReset;
		case 10:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Game$PressedSelectGame(
				$author$project$Evergreen$Migrate$V419$migrate_Message_GameType(p0));
		default:
			return $author$project$Evergreen$V419$Game$NoOpMsg;
	}
};
var $author$project$Evergreen$V419$Id$ExportChannel_Discord$ = function (a, b, c) {
	return {$: 1, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Id$ExportChannel_Discord = F3($author$project$Evergreen$V419$Id$ExportChannel_Discord$);
var $author$project$Evergreen$V419$Id$ExportChannel_DiscordDm$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Evergreen$V419$Id$ExportChannel_DiscordDm = F2($author$project$Evergreen$V419$Id$ExportChannel_DiscordDm$);
var $author$project$Evergreen$V419$Id$ExportChannel_Dm = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$Id$ExportChannel_Guild$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V419$Id$ExportChannel_Guild = F2($author$project$Evergreen$V419$Id$ExportChannel_Guild$);
var $author$project$Evergreen$Migrate$V419$migrate_Id_ExportChannelId = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Id$ExportChannel_Guild$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1));
		case 1:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Id$ExportChannel_Discord$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p2));
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Id$ExportChannel_Dm(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		default:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Id$ExportChannel_DiscordDm$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1));
	}
};
var $author$project$Evergreen$V419$ImageEditor$CroppedImage = function (a) {
	return {$: 9, a: a};
};
var $author$project$Evergreen$V419$ImageEditor$GotImageSize = function (a) {
	return {$: 8, a: a};
};
var $author$project$Evergreen$V419$ImageEditor$GotImageUrl = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$ImageEditor$MouseDownImageEditor$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Evergreen$V419$ImageEditor$MouseDownImageEditor = F2($author$project$Evergreen$V419$ImageEditor$MouseDownImageEditor$);
var $author$project$Evergreen$V419$ImageEditor$MouseUpImageEditor = {$: 4};
var $author$project$Evergreen$V419$ImageEditor$MovedImageEditor$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$Evergreen$V419$ImageEditor$MovedImageEditor = F2($author$project$Evergreen$V419$ImageEditor$MovedImageEditor$);
var $author$project$Evergreen$V419$ImageEditor$PressedCancel = {$: 10};
var $author$project$Evergreen$V419$ImageEditor$PressedConfirmImage = {$: 7};
var $author$project$Evergreen$V419$ImageEditor$PressedProfileImage = {$: 0};
var $author$project$Evergreen$V419$ImageEditor$PressedRemoveImage = {$: 11};
var $author$project$Evergreen$V419$ImageEditor$SelectedImage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$ImageEditor$TouchEndImageEditor = {$: 6};
var $author$project$Evergreen$V419$ImageEditor$UploadedImage = function (a) {
	return {$: 12, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_ImageEditor_Msg = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$ImageEditor$PressedProfileImage;
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$ImageEditor$SelectedImage(p0);
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$ImageEditor$GotImageUrl(p0);
		case 3:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$ImageEditor$MouseDownImageEditor$(p0, p1);
		case 4:
			return $author$project$Evergreen$V419$ImageEditor$MouseUpImageEditor;
		case 5:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$ImageEditor$MovedImageEditor$(p0, p1);
		case 6:
			return $author$project$Evergreen$V419$ImageEditor$TouchEndImageEditor;
		case 7:
			return $author$project$Evergreen$V419$ImageEditor$PressedConfirmImage;
		case 8:
			var p0 = old.a;
			return $author$project$Evergreen$V419$ImageEditor$GotImageSize(p0);
		case 9:
			var p0 = old.a;
			return $author$project$Evergreen$V419$ImageEditor$CroppedImage(p0);
		case 10:
			return $author$project$Evergreen$V419$ImageEditor$PressedCancel;
		case 11:
			return $author$project$Evergreen$V419$ImageEditor$PressedRemoveImage;
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$ImageEditor$UploadedImage(
				$elm$core$Result$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_UploadResponse, p0));
	}
};
var $author$project$Evergreen$V419$ImageViewer$AnimationFrame = function (a) {
	return {$: 11, a: a};
};
var $author$project$Evergreen$V419$ImageViewer$MouseDown$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $author$project$Evergreen$V419$ImageViewer$MouseDown = F2($author$project$Evergreen$V419$ImageViewer$MouseDown$);
var $author$project$Evergreen$V419$ImageViewer$MouseMove$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$Evergreen$V419$ImageViewer$MouseMove = F2($author$project$Evergreen$V419$ImageViewer$MouseMove$);
var $author$project$Evergreen$V419$ImageViewer$MouseUp = {$: 6};
var $author$project$Evergreen$V419$ImageViewer$PressStartedOnButton = {$: 3};
var $author$project$Evergreen$V419$ImageViewer$PressedClose = {$: 0};
var $author$project$Evergreen$V419$ImageViewer$PressedZoomIn = {$: 1};
var $author$project$Evergreen$V419$ImageViewer$PressedZoomOut = {$: 2};
var $author$project$Evergreen$V419$ImageViewer$TouchEnd = {$: 10};
var $author$project$Evergreen$V419$ImageViewer$TouchMove = function (a) {
	return {$: 9, a: a};
};
var $author$project$Evergreen$V419$ImageViewer$TouchStart = function (a) {
	return {$: 8, a: a};
};
var $author$project$Evergreen$V419$ImageViewer$Wheeled$ = function (a, b, c) {
	return {$: 7, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$ImageViewer$Wheeled = F3($author$project$Evergreen$V419$ImageViewer$Wheeled$);
var $author$project$Evergreen$Migrate$V419$migrate_ImageViewer_Msg = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$ImageViewer$PressedClose;
		case 1:
			return $author$project$Evergreen$V419$ImageViewer$PressedZoomIn;
		case 2:
			return $author$project$Evergreen$V419$ImageViewer$PressedZoomOut;
		case 3:
			return $author$project$Evergreen$V419$ImageViewer$PressStartedOnButton;
		case 4:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$ImageViewer$MouseDown$(p0, p1);
		case 5:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$ImageViewer$MouseMove$(p0, p1);
		case 6:
			return $author$project$Evergreen$V419$ImageViewer$MouseUp;
		case 7:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$ImageViewer$Wheeled$(p0, p1, p2);
		case 8:
			var p0 = old.a;
			return $author$project$Evergreen$V419$ImageViewer$TouchStart(p0);
		case 9:
			var p0 = old.a;
			return $author$project$Evergreen$V419$ImageViewer$TouchMove(p0);
		case 10:
			return $author$project$Evergreen$V419$ImageViewer$TouchEnd;
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$ImageViewer$AnimationFrame(p0);
	}
};
var $author$project$Evergreen$V419$LoginForm$PressedCancelLogin = {$: 1};
var $author$project$Evergreen$V419$LoginForm$PressedSubmitEmail = {$: 0};
var $author$project$Evergreen$V419$LoginForm$PressedSubmitUserData = {$: 6};
var $author$project$Evergreen$V419$LoginForm$TypedLoginCode = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V419$LoginForm$TypedLoginFormEmail = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$LoginForm$TypedName = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V419$LoginForm$TypedTwoFactorCode = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_LoginForm_Msg = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$LoginForm$PressedSubmitEmail;
		case 1:
			return $author$project$Evergreen$V419$LoginForm$PressedCancelLogin;
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$LoginForm$TypedLoginFormEmail(p0);
		case 3:
			var p0 = old.a;
			return $author$project$Evergreen$V419$LoginForm$TypedLoginCode(p0);
		case 4:
			var p0 = old.a;
			return $author$project$Evergreen$V419$LoginForm$TypedTwoFactorCode(p0);
		case 5:
			var p0 = old.a;
			return $author$project$Evergreen$V419$LoginForm$TypedName(p0);
		default:
			return $author$project$Evergreen$V419$LoginForm$PressedSubmitUserData;
	}
};
var $author$project$Evergreen$V419$Pages$Admin$DiscordLinkLimitEditableMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$EditCellLostFocus$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$Evergreen$V419$Pages$Admin$EditCellLostFocus = F2($author$project$Evergreen$V419$Pages$Admin$EditCellLostFocus$);
var $author$project$Evergreen$V419$Pages$Admin$EnterKeyInEditCell$ = function (a, b) {
	return {$: 7, a: a, b: b};
};
var $author$project$Evergreen$V419$Pages$Admin$EnterKeyInEditCell = F2($author$project$Evergreen$V419$Pages$Admin$EnterKeyInEditCell$);
var $author$project$Evergreen$V419$Pages$Admin$EscapeKeyInEditCell = {$: 11};
var $author$project$Evergreen$V419$Pages$Admin$FocusedOnEditCell = {$: 6};
var $author$project$Evergreen$V419$Pages$Admin$GotImportBackendFileContent = function (a) {
	return {$: 55, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$ImportBackendFileSelected = function (a) {
	return {$: 54, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$NotifyAdminsBotUserIdEditableMsg = function (a) {
	return {$: 36, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$NotifyAdminsTokenEditableMsg = function (a) {
	return {$: 35, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$OpenRouterKeyEditableMsg = function (a) {
	return {$: 34, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$PostmarkKeyEditableMsg = function (a) {
	return {$: 37, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$PressedAddUserRow = {$: 12};
var $author$project$Evergreen$V419$Pages$Admin$PressedCancelExportSubset = {$: 52};
var $author$project$Evergreen$V419$Pages$Admin$PressedConfirmExportSubset = {$: 51};
var $author$project$Evergreen$V419$Pages$Admin$PressedCopyLogLink = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$PressedCopyText = function (a) {
	return {$: 42, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$PressedDeleteDiscordDmChannel = function (a) {
	return {$: 23, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$PressedDeleteDiscordGuild = function (a) {
	return {$: 24, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$PressedDeleteGuild = function (a) {
	return {$: 30, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$PressedDeleteOrphanedFiles = {$: 59};
var $author$project$Evergreen$V419$Pages$Admin$PressedDeleteSession = function (a) {
	return {$: 57, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$PressedDeleteSlackDmChannel = function (a) {
	return {$: 28, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$PressedDeleteSlackWorkspace = function (a) {
	return {$: 26, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$PressedDeleteUser = function (a) {
	return {$: 13, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$PressedDisconnectClient$ = function (a, b) {
	return {$: 56, a: a, b: b};
};
var $author$project$Evergreen$V419$Pages$Admin$PressedDisconnectClient = F2($author$project$Evergreen$V419$Pages$Admin$PressedDisconnectClient$);
var $author$project$Evergreen$V419$Pages$Admin$PressedDownloadLastBackup = {$: 46};
var $author$project$Evergreen$V419$Pages$Admin$PressedEditCell$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Evergreen$V419$Pages$Admin$PressedEditCell = F2($author$project$Evergreen$V419$Pages$Admin$PressedEditCell$);
var $author$project$Evergreen$V419$Pages$Admin$PressedExpandDiscordGuild = function (a) {
	return {$: 25, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$PressedExpandGuild = function (a) {
	return {$: 29, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$PressedExpandSection = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$PressedExpandSlackWorkspace = function (a) {
	return {$: 27, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$PressedExportBackend = {$: 44};
var $author$project$Evergreen$V419$Pages$Admin$PressedExportSubsetBackend = {$: 45};
var $author$project$Evergreen$V419$Pages$Admin$PressedHomepageLink = {$: 38};
var $author$project$Evergreen$V419$Pages$Admin$PressedImportBackend = {$: 53};
var $author$project$Evergreen$V419$Pages$Admin$PressedLogPage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$PressedRegenerateServerSecret = {$: 58};
var $author$project$Evergreen$V419$Pages$Admin$PressedReloadDiscordChannel$ = function (a, b, c) {
	return {$: 39, a: a, b: b, c: c};
};
var $author$project$Evergreen$V419$Pages$Admin$PressedReloadDiscordChannel = F3($author$project$Evergreen$V419$Pages$Admin$PressedReloadDiscordChannel$);
var $author$project$Evergreen$V419$Pages$Admin$PressedReloadDiscordDmChannel$ = function (a, b) {
	return {$: 40, a: a, b: b};
};
var $author$project$Evergreen$V419$Pages$Admin$PressedReloadDiscordDmChannel = F2($author$project$Evergreen$V419$Pages$Admin$PressedReloadDiscordDmChannel$);
var $author$project$Evergreen$V419$Pages$Admin$PressedReloadDiscordGuild$ = function (a, b) {
	return {$: 41, a: a, b: b};
};
var $author$project$Evergreen$V419$Pages$Admin$PressedReloadDiscordGuild = F2($author$project$Evergreen$V419$Pages$Admin$PressedReloadDiscordGuild$);
var $author$project$Evergreen$V419$Pages$Admin$PressedResetUser = function (a) {
	return {$: 14, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$PressedResetUserChanges = {$: 10};
var $author$project$Evergreen$V419$Pages$Admin$PressedRestoreGuild = function (a) {
	return {$: 31, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$PressedSaveUserChanges = {$: 8};
var $author$project$Evergreen$V419$Pages$Admin$PressedSendTypeThatIsAlwaysInvalid = {$: 61};
var $author$project$Evergreen$V419$Pages$Admin$PressedWebsocketCloseEventsPage = function (a) {
	return {$: 60, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$PrivateVapidKeyEditableMsg = function (a) {
	return {$: 33, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$PublicVapidKeyEditableMsg = function (a) {
	return {$: 32, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$SlackLinkLimitEditableMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$TabKeyInEditCell = function (a) {
	return {$: 9, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$ToggleIsAdmin$ = function (a, b) {
	return {$: 22, a: a, b: b};
};
var $author$project$Evergreen$V419$Pages$Admin$ToggleIsAdmin = F2($author$project$Evergreen$V419$Pages$Admin$ToggleIsAdmin$);
var $author$project$Evergreen$V419$Pages$Admin$ToggledDiscordLinkingEnabled = function (a) {
	return {$: 18, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$ToggledEmailNotifications = function (a) {
	return {$: 16, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$ToggledExportSubsetDiscordDmChannel$ = function (a, b) {
	return {$: 50, a: a, b: b};
};
var $author$project$Evergreen$V419$Pages$Admin$ToggledExportSubsetDiscordDmChannel = F2($author$project$Evergreen$V419$Pages$Admin$ToggledExportSubsetDiscordDmChannel$);
var $author$project$Evergreen$V419$Pages$Admin$ToggledExportSubsetDiscordGuild$ = function (a, b) {
	return {$: 49, a: a, b: b};
};
var $author$project$Evergreen$V419$Pages$Admin$ToggledExportSubsetDiscordGuild = F2($author$project$Evergreen$V419$Pages$Admin$ToggledExportSubsetDiscordGuild$);
var $author$project$Evergreen$V419$Pages$Admin$ToggledExportSubsetDmChannel$ = function (a, b) {
	return {$: 48, a: a, b: b};
};
var $author$project$Evergreen$V419$Pages$Admin$ToggledExportSubsetDmChannel = F2($author$project$Evergreen$V419$Pages$Admin$ToggledExportSubsetDmChannel$);
var $author$project$Evergreen$V419$Pages$Admin$ToggledExportSubsetGuild$ = function (a, b) {
	return {$: 47, a: a, b: b};
};
var $author$project$Evergreen$V419$Pages$Admin$ToggledExportSubsetGuild = F2($author$project$Evergreen$V419$Pages$Admin$ToggledExportSubsetGuild$);
var $author$project$Evergreen$V419$Pages$Admin$ToggledSignupsEnabled = function (a) {
	return {$: 17, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$ToggledSlackLinkingEnabled = function (a) {
	return {$: 20, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$TypedEditCell = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V419$Pages$Admin$TypedInReadOnlyTextInput = {$: 43};
var $author$project$Evergreen$V419$Pages$Admin$UserTableMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Evergreen$V419$Table$PressedShowAll = {$: 1};
var $author$project$Evergreen$V419$Table$PressedSortBy = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Table_Msg = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Table$PressedSortBy(p0);
	} else {
		return $author$project$Evergreen$V419$Table$PressedShowAll;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_Msg = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$PressedLogPage(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$PressedCopyLogLink(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$PressedExpandSection(
				$author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_AdminUiSection(p0));
		case 3:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Pages$Admin$PressedEditCell$(
				$author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_UserTableId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_UserColumn(p1));
		case 4:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$TypedEditCell(p0);
		case 5:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Pages$Admin$EditCellLostFocus$(
				$author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_UserTableId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_UserColumn(p1));
		case 6:
			return $author$project$Evergreen$V419$Pages$Admin$FocusedOnEditCell;
		case 7:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Pages$Admin$EnterKeyInEditCell$(
				$author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_UserTableId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_UserColumn(p1));
		case 8:
			return $author$project$Evergreen$V419$Pages$Admin$PressedSaveUserChanges;
		case 9:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$TabKeyInEditCell(p0);
		case 10:
			return $author$project$Evergreen$V419$Pages$Admin$PressedResetUserChanges;
		case 11:
			return $author$project$Evergreen$V419$Pages$Admin$EscapeKeyInEditCell;
		case 12:
			return $author$project$Evergreen$V419$Pages$Admin$PressedAddUserRow;
		case 13:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$PressedDeleteUser(
				$author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_UserTableId(p0));
		case 14:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$PressedResetUser(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 15:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$UserTableMsg(
				$author$project$Evergreen$Migrate$V419$migrate_Table_Msg(p0));
		case 16:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$ToggledEmailNotifications(p0);
		case 17:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$ToggledSignupsEnabled(p0);
		case 18:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$ToggledDiscordLinkingEnabled(p0);
		case 19:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$DiscordLinkLimitEditableMsg(
				$author$project$Evergreen$Migrate$V419$migrate_Editable_Msg$($elm$core$Basics$identity, p0));
		case 20:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$ToggledSlackLinkingEnabled(p0);
		case 21:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$SlackLinkLimitEditableMsg(
				$author$project$Evergreen$Migrate$V419$migrate_Editable_Msg$($elm$core$Basics$identity, p0));
		case 22:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Pages$Admin$ToggleIsAdmin$(
				$author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_UserTableId(p0),
				p1);
		case 23:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$PressedDeleteDiscordDmChannel(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0));
		case 24:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$PressedDeleteDiscordGuild(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0));
		case 25:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$PressedExpandDiscordGuild(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0));
		case 26:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$PressedDeleteSlackWorkspace(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0));
		case 27:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$PressedExpandSlackWorkspace(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0));
		case 28:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$PressedDeleteSlackDmChannel(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0));
		case 29:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$PressedExpandGuild(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 30:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$PressedDeleteGuild(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 31:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$PressedRestoreGuild(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 32:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$PublicVapidKeyEditableMsg(
				$author$project$Evergreen$Migrate$V419$migrate_Editable_Msg$($elm$core$Basics$identity, p0));
		case 33:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$PrivateVapidKeyEditableMsg(
				$author$project$Evergreen$Migrate$V419$migrate_Editable_Msg$($author$project$Evergreen$Migrate$V419$migrate_LocalState_PrivateVapidKey, p0));
		case 34:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$OpenRouterKeyEditableMsg(
				$author$project$Evergreen$Migrate$V419$migrate_Editable_Msg$($elm$core$Basics$identity, p0));
		case 35:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$NotifyAdminsTokenEditableMsg(
				$author$project$Evergreen$Migrate$V419$migrate_Editable_Msg$($elm$core$Basics$identity, p0));
		case 36:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$NotifyAdminsBotUserIdEditableMsg(
				$author$project$Evergreen$Migrate$V419$migrate_Editable_Msg$(
					$elm$core$Maybe$map($author$project$Evergreen$Migrate$V419$migrate_Id_Id),
					p0));
		case 37:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$PostmarkKeyEditableMsg(
				$author$project$Evergreen$Migrate$V419$migrate_Editable_Msg$($author$project$Evergreen$Migrate$V419$migrate_Postmark_ApiKey, p0));
		case 38:
			return $author$project$Evergreen$V419$Pages$Admin$PressedHomepageLink;
		case 39:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Pages$Admin$PressedReloadDiscordChannel$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p2));
		case 40:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Pages$Admin$PressedReloadDiscordDmChannel$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1));
		case 41:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Pages$Admin$PressedReloadDiscordGuild$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1));
		case 42:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$PressedCopyText(p0);
		case 43:
			return $author$project$Evergreen$V419$Pages$Admin$TypedInReadOnlyTextInput;
		case 44:
			return $author$project$Evergreen$V419$Pages$Admin$PressedExportBackend;
		case 45:
			return $author$project$Evergreen$V419$Pages$Admin$PressedExportSubsetBackend;
		case 46:
			return $author$project$Evergreen$V419$Pages$Admin$PressedDownloadLastBackup;
		case 47:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Pages$Admin$ToggledExportSubsetGuild$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				p1);
		case 48:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Pages$Admin$ToggledExportSubsetDmChannel$(
				$author$project$Evergreen$Migrate$V419$migrate_DmChannelId_DmChannelId(p0),
				p1);
		case 49:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Pages$Admin$ToggledExportSubsetDiscordGuild$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				p1);
		case 50:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Pages$Admin$ToggledExportSubsetDiscordDmChannel$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				p1);
		case 51:
			return $author$project$Evergreen$V419$Pages$Admin$PressedConfirmExportSubset;
		case 52:
			return $author$project$Evergreen$V419$Pages$Admin$PressedCancelExportSubset;
		case 53:
			return $author$project$Evergreen$V419$Pages$Admin$PressedImportBackend;
		case 54:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$ImportBackendFileSelected(p0);
		case 55:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$GotImportBackendFileContent(p0);
		case 56:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Pages$Admin$PressedDisconnectClient$(
				$author$project$Evergreen$Migrate$V419$migrate_SessionIdHash_SessionIdHash(p0),
				p1);
		case 57:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$PressedDeleteSession(
				$author$project$Evergreen$Migrate$V419$migrate_SessionIdHash_SessionIdHash(p0));
		case 58:
			return $author$project$Evergreen$V419$Pages$Admin$PressedRegenerateServerSecret;
		case 59:
			return $author$project$Evergreen$V419$Pages$Admin$PressedDeleteOrphanedFiles;
		case 60:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Pages$Admin$PressedWebsocketCloseEventsPage(p0);
		default:
			return $author$project$Evergreen$V419$Pages$Admin$PressedSendTypeThatIsAlwaysInvalid;
	}
};
var $author$project$Evergreen$V419$RecoveryLogin$PressedSubmit = {$: 1};
var $author$project$Evergreen$V419$RecoveryLogin$TypedPassword = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_RecoveryLogin_Msg = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$RecoveryLogin$TypedPassword(p0);
	} else {
		return $author$project$Evergreen$V419$RecoveryLogin$PressedSubmit;
	}
};
var $author$project$Evergreen$V419$TextEditor$PressedBack = {$: 4};
var $author$project$Evergreen$V419$TextEditor$PressedReset = {$: 1};
var $author$project$Evergreen$V419$TextEditor$RedoChange = {$: 3};
var $author$project$Evergreen$V419$TextEditor$TypedText = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$TextEditor$UndoChange = {$: 2};
var $author$project$Evergreen$Migrate$V419$migrate_TextEditor_Msg = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$TextEditor$TypedText(p0);
		case 1:
			return $author$project$Evergreen$V419$TextEditor$PressedReset;
		case 2:
			return $author$project$Evergreen$V419$TextEditor$UndoChange;
		case 3:
			return $author$project$Evergreen$V419$TextEditor$RedoChange;
		default:
			return $author$project$Evergreen$V419$TextEditor$PressedBack;
	}
};
var $author$project$Evergreen$V419$TwoFactorAuthentication$PressedCancelDisable2Fa = {$: 4};
var $author$project$Evergreen$V419$TwoFactorAuthentication$PressedCopy = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$TwoFactorAuthentication$PressedStart2FaSetup = {$: 0};
var $author$project$Evergreen$V419$TwoFactorAuthentication$PressedStartDisable2Fa = {$: 3};
var $author$project$Evergreen$V419$TwoFactorAuthentication$TypedDisableTwoFactorCode = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V419$TwoFactorAuthentication$TypedTwoFactorCode = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_TwoFactorAuthentication_Msg = function (old) {
	switch (old.$) {
		case 0:
			return $author$project$Evergreen$V419$TwoFactorAuthentication$PressedStart2FaSetup;
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$TwoFactorAuthentication$PressedCopy(p0);
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$TwoFactorAuthentication$TypedTwoFactorCode(p0);
		case 3:
			return $author$project$Evergreen$V419$TwoFactorAuthentication$PressedStartDisable2Fa;
		case 4:
			return $author$project$Evergreen$V419$TwoFactorAuthentication$PressedCancelDisable2Fa;
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$TwoFactorAuthentication$TypedDisableTwoFactorCode(p0);
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_NewGuildForm = function (old) {
	return old;
};
var $author$project$Evergreen$V419$Internal$Model2$Teleported$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V419$Internal$Model2$Teleported = F2($author$project$Evergreen$V419$Internal$Model2$Teleported$);
var $author$project$Evergreen$V419$Internal$Model2$Tick = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Internal$Teleport$Css = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Internal$Teleport$ParentTrigger = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$Migrate$V419$migrate_Internal_Teleport_CssAnimation = function (old) {
	return old;
};
var $author$project$Evergreen$Migrate$V419$migrate_Internal_Teleport_ParentTriggerDetails = function (old) {
	return old;
};
var $author$project$Evergreen$Migrate$V419$migrate_Internal_Teleport_Data = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Internal$Teleport$Css(
			$author$project$Evergreen$Migrate$V419$migrate_Internal_Teleport_CssAnimation(p0));
	} else {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Internal$Teleport$ParentTrigger(
			$author$project$Evergreen$Migrate$V419$migrate_Internal_Teleport_ParentTriggerDetails(p0));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Internal_Teleport_Event = function (old) {
	return {
		data: $elm$core$List$map$($author$project$Evergreen$Migrate$V419$migrate_Internal_Teleport_Data, old.data),
		timestamp: old.timestamp
	};
};
var $author$project$Evergreen$V419$Internal$Teleport$OnActive = 4;
var $author$project$Evergreen$V419$Internal$Teleport$OnDismount = 5;
var $author$project$Evergreen$V419$Internal$Teleport$OnFocus = 2;
var $author$project$Evergreen$V419$Internal$Teleport$OnFocusWithin = 3;
var $author$project$Evergreen$V419$Internal$Teleport$OnHover = 0;
var $author$project$Evergreen$V419$Internal$Teleport$OnRender = 1;
var $author$project$Evergreen$Migrate$V419$migrate_Internal_Teleport_Trigger = function (old) {
	switch (old) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		default:
			return 5;
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Internal_Model2_Msg = function (old) {
	if (!old.$) {
		var p0 = old.a;
		return $author$project$Evergreen$V419$Internal$Model2$Tick(p0);
	} else {
		var p0 = old.a;
		var p1 = old.b;
		return $author$project$Evergreen$V419$Internal$Model2$Teleported$(
			$author$project$Evergreen$Migrate$V419$migrate_Internal_Teleport_Trigger(p0),
			$author$project$Evergreen$Migrate$V419$migrate_Internal_Teleport_Event(p1));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Ui_Anim_Msg = function (old) {
	return $author$project$Evergreen$Migrate$V419$migrate_Internal_Model2_Msg(old);
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_FrontendMsg_ = function (old) {
	switch (old.$) {
		case 0:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$UrlClicked(p0);
		case 1:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$UrlChanged(p0);
		case 2:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$GotTime(p0);
		case 3:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$GotWindowSize$(p0, p1);
		case 4:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$LoginFormMsg(
				$author$project$Evergreen$Migrate$V419$migrate_LoginForm_Msg(p0));
		case 5:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$RecoveryLoginMsg(
				$author$project$Evergreen$Migrate$V419$migrate_RecoveryLogin_Msg(p0));
		case 6:
			return $author$project$Evergreen$V419$Types$PressedShowLogin;
		case 7:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedHomePagePreview(p0);
		case 8:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$AdminPageMsg(
				$author$project$Evergreen$Migrate$V419$migrate_Pages_Admin_Msg(p0));
		case 9:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedLogOut(
				$author$project$Evergreen$Migrate$V419$migrate_SessionIdHash_SessionIdHash(p0));
		case 10:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$ElmUiMsg(
				$author$project$Evergreen$Migrate$V419$migrate_Ui_Anim_Msg(p0));
		case 11:
			return $author$project$Evergreen$V419$Types$ScrolledToLogSection;
		case 12:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedLink(
				$author$project$Evergreen$Migrate$V419$migrate_Route_Route(p0));
		case 13:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$SelectedFilesToAttach$(
				$elm$core$Tuple$mapBoth$($author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute, p0),
				p1,
				p2);
		case 14:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$NewChannelFormChanged$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Types_NewChannelForm(p1));
		case 15:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$PressedSubmitNewChannel$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Types_NewChannelForm(p1));
		case 16:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$EditChannelFormChanged$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Types_EditChannelForm(p2));
		case 17:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$PressedResetEditChannelChanges$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1));
		case 18:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$PressedSubmitEditChannelChanges$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Types_EditChannelForm(p2));
		case 19:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$PressedDeleteChannel$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1));
		case 20:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$EditGuildFormChanged$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Types_EditGuildForm(p1));
		case 21:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedResetEditGuildChanges(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 22:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$PressedSubmitEditGuildChanges$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Types_EditGuildForm(p1));
		case 23:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedDeleteGuild(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 24:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedImportChannel(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 25:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$SelectedImportChannelFile$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				p1);
		case 26:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$GotImportChannelFile$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				p1);
		case 27:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedLeaveGuild(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 28:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedCreateInviteLink(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 29:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$PressedDeleteInviteLink$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_SecretId_SecretId(p1));
		case 30:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$PressedBanMember$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1));
		case 31:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedToggleInviteLinkQrCode(
				$author$project$Evergreen$Migrate$V419$migrate_SecretId_SecretId(p0));
		case 32:
			return $author$project$Evergreen$V419$Types$FrontendNoOp;
		case 33:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedCopyText(p0);
		case 34:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedCopyImage(p0);
		case 35:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$NewGuildFormChanged(
				$author$project$Evergreen$Migrate$V419$migrate_Types_NewGuildForm(p0));
		case 36:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedSubmitNewGuild(
				$author$project$Evergreen$Migrate$V419$migrate_Types_NewGuildForm(p0));
		case 37:
			return $author$project$Evergreen$V419$Types$DebouncedTyping;
		case 38:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$GotPingUserPosition$(p0, p1);
		case 39:
			return $author$project$Evergreen$V419$Types$SetFocus;
		case 40:
			return $author$project$Evergreen$V419$Types$RemoveFocus;
		case 41:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$KeyDown(p0);
		case 42:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$MessageMenu_PressedShowReactionEmojiSelector$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Coord_Coord$($author$project$Evergreen$Migrate$V419$migrate_CssPixels_CssPixels, p2));
		case 43:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$MessageMenu_PressedReactionEmoji(
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_EmojiOrCustomEmoji(p0));
		case 44:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$MessageMenu_PressedEditMessage$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p1));
		case 45:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$EmojiSelectorMsg(
				$author$project$Evergreen$Migrate$V419$migrate_Emoji_Msg(p0));
		case 46:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$MessageMenu_PressedReply(
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p0));
		case 47:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$MessageMenu_PressedOpenThread(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 48:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedCloseReplyTo(
				$elm$core$Tuple$mapBoth$($author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute, p0));
		case 49:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$CheckedNotificationPermission(
				$author$project$Evergreen$Migrate$V419$migrate_Ports_NotificationPermission(p0));
		case 50:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$TouchStart$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_NonemptyDict_NonemptyDict$($elm$core$Basics$identity, $author$project$Evergreen$Migrate$V419$migrate_Touch_Touch, p1));
		case 51:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$TouchMoved$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_NonemptyDict_NonemptyDict$($elm$core$Basics$identity, $author$project$Evergreen$Migrate$V419$migrate_Touch_Touch, p1));
		case 52:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$TouchEnd(p0);
		case 53:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$TouchCancel(p0);
		case 54:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$ChannelSidebarAnimated(p0);
		case 55:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$MessageMenuAnimated(p0);
		case 56:
			return $author$project$Evergreen$V419$Types$SetScrollToBottom;
		case 57:
			return $author$project$Evergreen$V419$Types$PressedChannelHeaderBackButton;
		case 58:
			return $author$project$Evergreen$V419$Types$PressedShowMembers;
		case 59:
			return $author$project$Evergreen$V419$Types$PressedHideMembers;
		case 60:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$UserScrolled$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Scroll_ScrollPosition(p2));
		case 61:
			return $author$project$Evergreen$V419$Types$PressedBody;
		case 62:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$MessageMenu_PressedDeleteMessage$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p1));
		case 63:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$MessageMenu_PressedMarkAsUnread$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p1));
		case 64:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$MessageMenu_PressedAddCustomEmojisToUser(
				$author$project$Evergreen$Migrate$V419$migrate_NonemptySet_NonemptySet$($author$project$Evergreen$Migrate$V419$migrate_Id_Id, p0));
		case 65:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$MessageMenu_PressedOpenDm(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 66:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$MessageMenu_PressedOpenDiscordDm$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1));
		case 67:
			return $author$project$Evergreen$V419$Types$ScrolledToMessage;
		case 68:
			return $author$project$Evergreen$V419$Types$MessageMenu_PressedClose;
		case 69:
			return $author$project$Evergreen$V419$Types$MessageMenu_PressedContainer;
		case 70:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedCancelMessageEdit(
				$elm$core$Tuple$mapBoth$($author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute, p0));
		case 71:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			var p5 = old.f;
			var p6 = old.g;
			return $author$project$Evergreen$V419$Types$CheckMessageAltPress$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p2),
				p3,
				p4,
				p5,
				p6);
		case 72:
			return $author$project$Evergreen$V419$Types$PressedShowUserOption;
		case 73:
			return $author$project$Evergreen$V419$Types$PressedCloseOverlay;
		case 74:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedExpandContainer(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_UserOptionSection(p0));
		case 75:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$TwoFactorMsg(
				$author$project$Evergreen$Migrate$V419$migrate_TwoFactorAuthentication_Msg(p0));
		case 76:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$AiChatMsg(
				$author$project$Evergreen$Migrate$V419$migrate_AiChat_Msg(p0));
		case 77:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$GameMsg(
				$author$project$Evergreen$Migrate$V419$migrate_Game_Msg(p0));
		case 78:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$CheckedSheepGameSaveDebounce$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_GuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_SheepGame_Input(p2),
				p3);
		case 79:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$CheckedSheepGameQuestionsDebounce$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_GuildOrDmId(p0),
				p1);
		case 80:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$GoSpectatorMsg(
				$author$project$Evergreen$Migrate$V419$migrate_Go_SpectatorMsg(p0));
		case 81:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$UserNameEditableMsg(
				$author$project$Evergreen$Migrate$V419$migrate_Editable_Msg$($author$project$Evergreen$Migrate$V419$migrate_PersonName_PersonName, p0));
		case 82:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$ProfilePictureEditorMsg(
				$author$project$Evergreen$Migrate$V419$migrate_ImageEditor_Msg(p0));
		case 83:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$GuildIconEditorMsg$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_ImageEditor_Msg(p1));
		case 84:
			return $author$project$Evergreen$V419$Types$OneFrameAfterDragEnd;
		case 85:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$GotFileToEncrypt$(
				$elm$core$Tuple$mapBoth$($author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute, p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				p2,
				p3);
		case 86:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$GotFileHashName$(
				$elm$core$Tuple$mapBoth$($author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute, p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$elm$core$Maybe$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_FileMetadata, p2),
				$elm$core$Result$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_UploadResponse, p3));
		case 87:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$PressedDeleteAttachedFile$(
				$elm$core$Tuple$mapBoth$($author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute, p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1));
		case 88:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$PressedViewAttachedFileInfo$(
				$elm$core$Tuple$mapBoth$($author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute, p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1));
		case 89:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$PressedToggleAttachedFileSpoiler$(
				$elm$core$Tuple$mapBoth$($author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute, p0),
				{
					fileId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1.fileId),
					removeSpoiler: p1.removeSpoiler
				});
		case 90:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$EditMessage_PressedDeleteAttachedFile$(
				$elm$core$Tuple$mapBoth$($author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute, p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1));
		case 91:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$EditMessage_PressedViewAttachedFileInfo$(
				$elm$core$Tuple$mapBoth$($author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute, p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1));
		case 92:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$EditMessage_PressedToggleAttachedFileSpoiler$(
				$elm$core$Tuple$mapBoth$($author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute, p0),
				{
					fileId: $author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1.fileId),
					removeSpoiler: p1.removeSpoiler
				});
		case 93:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$EditMessage_SelectedFilesToAttach$(
				$elm$core$Tuple$mapBoth$($author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute, p0),
				p1,
				p2);
		case 94:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$EditMessage_GotFileHashName$(
				$elm$core$Tuple$mapBoth$($author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute, p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p2),
				$elm$core$Result$map$($author$project$Evergreen$Migrate$V419$migrate_FileStatus_UploadResponse, p3));
		case 95:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$FileUploadProgress$(
				$elm$core$Tuple$mapBoth$($author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute, p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				p2);
		case 96:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$MessageViewMsg$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p1),
				$author$project$Evergreen$Migrate$V419$migrate_MessageView_MessageViewMsg(p2));
		case 97:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$ImageViewerMsg(
				$author$project$Evergreen$Migrate$V419$migrate_ImageViewer_Msg(p0));
		case 98:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$GotRegisterPushSubscription(
				$author$project$Evergreen$Migrate$V419$migrate_Ports_RegisterPushSubscription(p0));
		case 99:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$SelectedNotificationMode(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_NotificationMode(p0));
		case 100:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$SelectedEmailNotifications(
				$author$project$Evergreen$Migrate$V419$migrate_User_EmailNotifications(p0));
		case 101:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$SelectedEmbedVisibility(
				$author$project$Evergreen$Migrate$V419$migrate_User_EmbedVisibility(p0));
		case 102:
			return $author$project$Evergreen$V419$Types$PressedDeleteAccount;
		case 103:
			return $author$project$Evergreen$V419$Types$PressedAccountDeletionBanner;
		case 104:
			return $author$project$Evergreen$V419$Types$PressedCloseAccountDeletionBanner;
		case 105:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$PressedGuildNotificationLevel$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_User_NotificationLevel(p1));
		case 106:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$PressedDiscordGuildNotificationLevel$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_User_NotificationLevel(p2));
		case 107:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$PressedSlackWorkspaceNotificationLevel$(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_User_NotificationLevel(p2));
		case 108:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$GotStartupData(
				$elm$core$Result$map$($author$project$Evergreen$Migrate$V419$migrate_Ports_StartupData, p0));
		case 109:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$GotDevicePixelRatio(p0);
		case 110:
			return $author$project$Evergreen$V419$Types$PressedCloseImageInfo;
		case 111:
			return $author$project$Evergreen$V419$Types$PressedMemberListBack;
		case 112:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedExportChannel(
				$author$project$Evergreen$Migrate$V419$migrate_Id_ExportChannelId(p0));
		case 113:
			return $author$project$Evergreen$V419$Types$PressedAddPrivateKeyToAccount;
		case 114:
			return $author$project$Evergreen$V419$Types$PressedCloseNewPrivateKey;
		case 115:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedExpandE2eeSection(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 116:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedE2eeRisksAccepted(p0);
		case 117:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedEnableE2ee(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 118:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedCancelE2eeRequest(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 119:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedDisableE2ee(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 120:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedDeclineE2eeRequest(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0));
		case 121:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$TypedPrivateKey$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				p1);
		case 122:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PageHasFocusChanged(p0);
		case 123:
			return $author$project$Evergreen$V419$Types$PageFocusSettled;
		case 124:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$GotServiceWorkerMessage(p0);
		case 125:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedNotification(p0);
		case 126:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$VisualViewportChanged(p0);
		case 127:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$SafeAreaInsetsChanged(p0);
		case 128:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$TextEditorMsg(
				$author$project$Evergreen$Migrate$V419$migrate_TextEditor_Msg(p0));
		case 129:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedDiscordAcknowledgment(p0);
		case 130:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedSlackAcknowledgment(p0);
		case 131:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedReloadDiscordUser(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0));
		case 132:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedUnlinkDiscordUser(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0));
		case 133:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedDiscordGuildMemberLabel(
				{
					currentUserId: $author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0.currentUserId),
					otherUserId: $author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0.otherUserId)
				});
		case 134:
			return $author$project$Evergreen$V419$Types$TypedDiscordLinkBookmarklet;
		case 135:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$GotVersionNumber(p0);
		case 136:
			return $author$project$Evergreen$V419$Types$PressedCloseExternalLinkWarning;
		case 137:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedAddDomainToWhitelist(p0);
		case 138:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$TypedDomainWhitelist(p0);
		case 139:
			return $author$project$Evergreen$V419$Types$PressedSelectNewColor;
		case 140:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$SelectedUserColor(
				$author$project$Evergreen$Migrate$V419$migrate_UserColor_Selection(p0));
		case 141:
			return $author$project$Evergreen$V419$Types$PressedSubmitUserColor;
		case 142:
			return $author$project$Evergreen$V419$Types$PressedResetUserColor;
		case 143:
			return $author$project$Evergreen$V419$Types$PressedSaveDomainWhitelist;
		case 144:
			return $author$project$Evergreen$V419$Types$PressedResetDomainWhitelist;
		case 145:
			return $author$project$Evergreen$V419$Types$PressedContinueToSite;
		case 146:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$EditMessage_MessageInputMsg$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute(p1),
				$author$project$Evergreen$Migrate$V419$migrate_MessageInput_Msg(p2));
		case 147:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$MessageInputMsg$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRoute(p1),
				$author$project$Evergreen$Migrate$V419$migrate_MessageInput_Msg(p2));
		case 148:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$GotEmojiData(
				$elm$core$Result$map$($author$project$Evergreen$Migrate$V419$migrate_Emoji_CachedEmojiData, p0));
		case 149:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$GotPositionForEmojiSelector_EditMessage(p0);
		case 150:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$GotPositionForEmojiSelector_SheepGameInput$(
				$author$project$Evergreen$Migrate$V419$migrate_SheepGame_Input(p0),
				p1);
		case 151:
			return $author$project$Evergreen$V419$Types$EnableToFrontendLogging;
		case 152:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$TextSelectionChanged(
				$elm$core$Tuple$mapSecond$(
					$elm$core$Maybe$map(
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Range_Range, $author$project$Evergreen$Migrate$V419$migrate_Range_SelectionDirection)),
					p0));
		case 153:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$DomFocusChanged(
				$elm$core$Tuple$mapSecond$(
					$elm$core$Maybe$map(
						A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Range_Range, $author$project$Evergreen$Migrate$V419$migrate_Range_SelectionDirection)),
					p0));
		case 154:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PageUpGotViewport(p0);
		case 155:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$GotVoiceChatSignalFromJs(
				$elm$core$Result$map$($author$project$Evergreen$Migrate$V419$migrate_Call_FromJs, p0));
		case 156:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$VoiceChatMsg(
				$author$project$Evergreen$Migrate$V419$migrate_Call_Msg(p0));
		case 157:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedChannelHeaderTab(
				$author$project$Evergreen$Migrate$V419$migrate_UserSession_ChannelHeaderTab(p0));
		case 158:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$FileDragEnter(p0);
		case 159:
			return $author$project$Evergreen$V419$Types$FileDragLeave;
		case 160:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$FileDropped(p0);
		case 161:
			return $author$project$Evergreen$V419$Types$PressedUnregisterServiceWorkers;
		case 162:
			return $author$project$Evergreen$V419$Types$PressedLoadDebugData;
		case 163:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$GotServiceWorkerData(p0);
		case 164:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$DrawingMsg(
				$author$project$Evergreen$Migrate$V419$migrate_Drawing_Msg(p0));
		case 165:
			return $author$project$Evergreen$V419$Types$PressedNewMessagesWarning;
		case 166:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$LoadedPopSound(
				$elm$core$Basics$composeR$(
					$elm$core$Result$mapError($author$project$Evergreen$Migrate$V419$migrate_Audio_LoadError),
					$elm$core$Result$map($author$project$Evergreen$Migrate$V419$migrate_Audio_Source),
					p0));
		case 167:
			return $author$project$Evergreen$V419$Types$PressedShowSearchOverlay;
		case 168:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$TypedSearchOverlay(p0);
		case 169:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedSearchOverlayArrowKey(p0);
		case 170:
			return $author$project$Evergreen$V419$Types$PressedSearchOverlayEnter;
		case 171:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedSearchOverlayResult(
				$author$project$Evergreen$Migrate$V419$migrate_Route_Route(p0));
		case 172:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$PressedMuteChannel$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(p2));
		case 173:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$PressedMuteThread$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(p3));
		case 174:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$PressedMuteDiscordChannel$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(p3));
		case 175:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			return $author$project$Evergreen$V419$Types$PressedMuteDiscordThread$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p3),
				$author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(p4));
		case 176:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$PressedMarkChannelAsRead$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage(p1));
		case 177:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedMarkAllChannelsAsRead(
				$elm$core$List$map$(
					A2($elm$core$Tuple$mapBoth, $author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId, $author$project$Evergreen$Migrate$V419$migrate_Id_ThreadRouteWithMessage),
					p0));
		case 178:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$PressedMuteGuild$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(p1));
		case 179:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$PressedMuteDiscordGuild$(
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Discord_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(p2));
		case 180:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$PressedMuteSlackWorkspace$(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(p2));
		case 181:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$PressedMuteSlackChannel$(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(p3));
		case 182:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			var p4 = old.e;
			return $author$project$Evergreen$V419$Types$PressedMuteSlackThread$(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p3),
				$author$project$Evergreen$Migrate$V419$migrate_MuteSettings_IsMuted(p4));
		case 183:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			return $author$project$Evergreen$V419$Types$UnreadOverviewChannelMsg$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_MessageView_MessageViewMsg(p2));
		case 184:
			var p0 = old.a;
			var p1 = old.b;
			var p2 = old.c;
			var p3 = old.d;
			return $author$project$Evergreen$V419$Types$UnreadOverviewThreadMsg$(
				$author$project$Evergreen$Migrate$V419$migrate_Id_AnyGuildOrDmId(p0),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p1),
				$author$project$Evergreen$Migrate$V419$migrate_Id_Id(p2),
				$author$project$Evergreen$Migrate$V419$migrate_MessageView_MessageViewMsg(p3));
		case 185:
			var p0 = old.a;
			var p1 = old.b;
			return $author$project$Evergreen$V419$Types$ValidatedE2eePrivateKey$(
				p0,
				$author$project$Evergreen$Migrate$V419$migrate_Types_E2eeKeysValid(p1));
		case 186:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$EncryptionFromJs(
				$elm$core$Result$map$(
					$author$project$Evergreen$Migrate$V419$migrate_Encryption_FromJs(
						A2($author$project$Evergreen$Migrate$V419$migrate_Message_MessageContent, $author$project$Evergreen$Migrate$V419$migrate_Id_Id, $author$project$Evergreen$Migrate$V419$migrate_Id_Id)),
					p0));
		case 187:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$TypedSlackCookie(p0);
		case 188:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$TypedSlackTeamsJson(p0);
		case 189:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedRemoveSlackTeam(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0));
		case 190:
			return $author$project$Evergreen$V419$Types$PressedSubmitSlackData;
		case 191:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedUnlinkSlackUser(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0));
		default:
			var p0 = old.a;
			return $author$project$Evergreen$V419$Types$PressedReloadSlackUser(
				$author$project$Evergreen$Migrate$V419$migrate_Slack_Id(p0));
	}
};
var $author$project$Evergreen$Migrate$V419$migrate_Types_FrontendModel = function (old) {
	return $author$project$Evergreen$Migrate$V419$migrate_Audio_Model$($author$project$Evergreen$Migrate$V419$migrate_Types_FrontendMsg_, $author$project$Evergreen$Migrate$V419$migrate_Types_FrontendModel_, old);
};
var $author$project$Evergreen$Migrate$V419$frontendModel = function (old) {
	return $lamdera$codecs$Lamdera$Migrations$ModelMigrated(
		_Utils_Tuple2(
			$author$project$Evergreen$Migrate$V419$migrate_Types_FrontendModel(old),
			$elm$core$Platform$Cmd$none));
};
var $author$project$LamderaHelpers$DecoderError = function (a) {
	return {$: 5, a: a};
};
var $author$project$LamderaHelpers$Reset = {$: 2};
var $author$project$LamderaHelpers$otherwiseError = function (priorResult) {
	if (!priorResult.$) {
		var upgradeResult = priorResult.a;
		return upgradeResult;
	} else {
		if (priorResult.a === 'reset') {
			return $author$project$LamderaHelpers$Reset;
		} else {
			var err = priorResult.a;
			return $author$project$LamderaHelpers$DecoderError(err);
		}
	}
};
var $author$project$LamderaHelpers$migrateModelValue$ = function (tipe, migrationFn, oldValue, oldEncoder, newDecoder, newVersion) {
	var _v0 = migrationFn(oldValue);
	switch (_v0.$) {
		case 1:
			var _v1 = _v0.a;
			var newValue = _v1.a;
			var cmds = _v1.b;
			return $elm$core$Result$Ok(
				_Utils_Tuple2(newValue, cmds));
		case 2:
			return $elm$core$Result$Err('reset');
		default:
			return function (bytes) {
				return $author$project$LamderaHelpers$decodeType$(tipe, newVersion, bytes, newDecoder);
			}(
				$lamdera$codecs$Lamdera$Wire3$bytesEncode(
					oldEncoder(oldValue)));
	}
};
var $author$project$LamderaHelpers$migrateModelValue = F6($author$project$LamderaHelpers$migrateModelValue$);
var $author$project$LamderaHelpers$thenMigrateModel$ = function (tipe, migrationFn, oldEncoder, newDecoder, newVersion, priorResult) {
	return $elm$core$Result$andThen$(
		function (_v0) {
			var oldValue = _v0.a;
			return $author$project$LamderaHelpers$migrateModelValue$(tipe, migrationFn, oldValue, oldEncoder, newDecoder, newVersion);
		},
		priorResult);
};
var $author$project$LamderaHelpers$thenMigrateModel = F6($author$project$LamderaHelpers$thenMigrateModel$);
var $author$project$LamderaHelpers$AlreadyCurrent = function (a) {
	return {$: 0, a: a};
};
var $author$project$LamderaHelpers$upgradeIsCurrent = function (priorResult) {
	return $elm$core$Result$map$($author$project$LamderaHelpers$AlreadyCurrent, priorResult);
};
var $author$project$LamderaHelpers$Upgraded = function (a) {
	return {$: 1, a: a};
};
var $author$project$LamderaHelpers$upgradeSucceeds = function (priorResult) {
	return $elm$core$Result$map$($author$project$LamderaHelpers$Upgraded, priorResult);
};
var $lamdera$codecs$Lamdera$Wire3$encodeArray$ = function (enc, a) {
	return $lamdera$codecs$Lamdera$Wire3$encodeList$(
		enc,
		$elm$core$Array$toList(a));
};
var $lamdera$codecs$Lamdera$Wire3$encodeArray = F2($lamdera$codecs$Lamdera$Wire3$encodeArray$);
var $lamdera$codecs$Lamdera$Wire3$encodeBool = function (b) {
	return $elm$bytes$Bytes$Encode$unsignedInt8(
		function () {
			if (!b) {
				return 0;
			} else {
				return 1;
			}
		}());
};
var $lamdera$codecs$Lamdera$Wire3$encodeMaybe$ = function (encVal, s) {
	if (s.$ === 1) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0)
				]));
	} else {
		var v = s.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					encVal(v)
				]));
	}
};
var $lamdera$codecs$Lamdera$Wire3$encodeMaybe = F2($lamdera$codecs$Lamdera$Wire3$encodeMaybe$);
var $lamdera$codecs$Lamdera$Wire3$encodeResult$ = function (encErr, encVal, s) {
	if (!s.$) {
		var v = s.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					encVal(v)
				]));
	} else {
		var v = s.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					encErr(v)
				]));
	}
};
var $lamdera$codecs$Lamdera$Wire3$encodeResult = F3($lamdera$codecs$Lamdera$Wire3$encodeResult$);
var $lamdera$codecs$Lamdera$Wire3$encodeChar = function (c) {
	return $lamdera$codecs$Lamdera$Wire3$encodeInt64(
		$elm$core$Char$toCode(c));
};
var $lamdera$codecs$Lamdera$Wire3$encodePair$ = function (c_a, c_b, _v0) {
	var a = _v0.a;
	var b = _v0.b;
	return $elm$bytes$Bytes$Encode$sequence(
		_List_fromArray(
			[
				c_a(a),
				c_b(b)
			]));
};
var $lamdera$codecs$Lamdera$Wire3$encodePair = F3($lamdera$codecs$Lamdera$Wire3$encodePair$);
var $lamdera$codecs$Lamdera$Wire3$encodeDict$ = function (encKey, encValue, d) {
	return $lamdera$codecs$Lamdera$Wire3$encodeList$(
		A2($lamdera$codecs$Lamdera$Wire3$encodePair, encKey, encValue),
		$elm$core$Dict$toList(d));
};
var $lamdera$codecs$Lamdera$Wire3$encodeDict = F3($lamdera$codecs$Lamdera$Wire3$encodeDict$);
var $lamdera$containers$SeqDict$encodeDict$ = function (encKey, encValue, d) {
	return $lamdera$codecs$Lamdera$Wire3$encodeList$(
		A2($lamdera$codecs$Lamdera$Wire3$encodePair, encKey, encValue),
		$lamdera$containers$SeqDict$toList(d));
};
var $lamdera$containers$SeqDict$encodeDict = F3($lamdera$containers$SeqDict$encodeDict$);
var $author$project$Evergreen$V417$Emoji$w3_encode_EmojiArt = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.sequence),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.sprite)
			]));
};
var $author$project$Evergreen$V417$Emoji$w3_encode_EmojiCategory = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
	}
};
var $author$project$Evergreen$V417$Emoji$w3_encode_EmojiData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Emoji$w3_encode_EmojiCategory(w3_rec_var0.category),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.shortNames),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.skinVariations)
			]));
};
var $author$project$Evergreen$V417$Emoji$w3_encode_UnicodeEmoji = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Evergreen$V417$Emoji$w3_encode_CachedEmojiData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeDict$(
				$lamdera$codecs$Lamdera$Wire3$encodeChar,
				$lamdera$codecs$Lamdera$Wire3$encodeArray($author$project$Evergreen$V417$Emoji$w3_encode_EmojiArt),
				w3_rec_var0.art),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Emoji$w3_encode_EmojiCategory,
				$lamdera$codecs$Lamdera$Wire3$encodeList($author$project$Evergreen$V417$Emoji$w3_encode_UnicodeEmoji),
				w3_rec_var0.categories),
				$lamdera$containers$SeqDict$encodeDict$($author$project$Evergreen$V417$Emoji$w3_encode_UnicodeEmoji, $author$project$Evergreen$V417$Emoji$w3_encode_EmojiData, w3_rec_var0.emojis),
				$lamdera$codecs$Lamdera$Wire3$encodeArray$(
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$author$project$Evergreen$V417$Emoji$w3_encode_UnicodeEmoji(w3_rec_var1.emoji),
								$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var1.shortName)
							]));
				},
				w3_rec_var0.shortNames)
			]));
};
var $lamdera$program_test$Effect$Lamdera$w3_encode_ClientId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $ianmackenzie$elm_units$Quantity$w3_encode_Quantity$ = function (w3_x_c_number, w3_x_c_units, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				w3_x_c_number(v0)
			]));
};
var $ianmackenzie$elm_units$Quantity$w3_encode_Quantity = F3($ianmackenzie$elm_units$Quantity$w3_encode_Quantity$);
var $author$project$Evergreen$V417$Coord$w3_encode_Coord = function (w3_x_c_units) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$encodePair,
		A2($ianmackenzie$elm_units$Quantity$w3_encode_Quantity, $lamdera$codecs$Lamdera$Wire3$encodeInt, w3_x_c_units),
		A2($ianmackenzie$elm_units$Quantity$w3_encode_Quantity, $lamdera$codecs$Lamdera$Wire3$encodeInt, w3_x_c_units));
};
var $lamdera$codecs$Lamdera$Wire3$failEncode = function (a) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(_List_Nil);
};
var $author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$Touch$w3_encode_DragTarget = function (w3v) {
	switch (w3v) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V417$NonemptyDict$w3_encode_NonemptyDict$ = function (w3_x_c_id, w3_x_c_a, w3v) {
	var v0 = w3v.a;
	var v1 = w3v.b;
	var v2 = w3v.c;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				w3_x_c_id(v0),
				w3_x_c_a(v1),
				$lamdera$containers$SeqDict$encodeDict$(w3_x_c_id, w3_x_c_a, v2)
			]));
};
var $author$project$Evergreen$V417$NonemptyDict$w3_encode_NonemptyDict = F3($author$project$Evergreen$V417$NonemptyDict$w3_encode_NonemptyDict$);
var $lamdera$program_test$Effect$Time$w3_encode_Posix = function (t) {
	return $lamdera$codecs$Lamdera$Wire3$encodeInt(
		$elm$time$Time$posixToMillis(t));
};
var $lamdera$codecs$Lamdera$Wire3$encodeFloat = $lamdera$codecs$Lamdera$Wire3$encodeFloat64;
var $author$project$Evergreen$V417$Geometry$Types$w3_encode_Point2d$ = function (w3_x_c_units, w3_x_c_coordinates, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				function (w3_rec_var0) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.x),
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.y)
						]));
			}(v0)
			]));
};
var $author$project$Evergreen$V417$Geometry$Types$w3_encode_Point2d = F3($author$project$Evergreen$V417$Geometry$Types$w3_encode_Point2d$);
var $author$project$Evergreen$V417$Point2d$w3_encode_Point2d$ = function (w3_x_c_units, w3_x_c_coordinates) {
	return A2($author$project$Evergreen$V417$Geometry$Types$w3_encode_Point2d, w3_x_c_units, w3_x_c_coordinates);
};
var $author$project$Evergreen$V417$Point2d$w3_encode_Point2d = F2($author$project$Evergreen$V417$Point2d$w3_encode_Point2d$);
var $author$project$Evergreen$V417$Touch$w3_encode_ScreenCoordinate = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$Touch$w3_encode_Touch = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				A3($author$project$Evergreen$V417$Point2d$w3_encode_Point2d, $author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels, $author$project$Evergreen$V417$Touch$w3_encode_ScreenCoordinate, w3_rec_var0.client),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.targetIsTextInput)
			]));
};
var $author$project$Evergreen$V417$Touch$w3_encode_Drag = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$NonemptyDict$w3_encode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$Evergreen$V417$Touch$w3_encode_Touch, v1)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.horizontalStart),
									$author$project$Evergreen$V417$Touch$w3_encode_DragTarget(w3_rec_var0.target),
									$author$project$Evergreen$V417$NonemptyDict$w3_encode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$Evergreen$V417$Touch$w3_encode_Touch, w3_rec_var0.touches)
								]));
					}(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V417$AiChat$w3_encode_AiModelName = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Evergreen$V417$AiChat$w3_encode_AiModel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$AiChat$w3_encode_AiModelName(w3_rec_var0.id),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.inputs)
			]));
};
var $lamdera$program_test$Effect$Http$w3_encode_Error = function (w3v) {
	switch (w3v.$) {
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
	}
};
var $author$project$Evergreen$V417$AiChat$w3_encode_AiModelsStatus = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V417$AiChat$w3_encode_AiModel, v0)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v0)
					]));
	}
};
var $author$project$Evergreen$V417$AiChat$w3_encode_PendingResponse = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$AiChat$w3_encode_AiModelName(v0),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v1)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$AiChat$w3_encode_AiModelName(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v2),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeFloat, v3)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$AiChat$w3_encode_AiModelName(v0)
					]));
	}
};
var $author$project$Evergreen$V417$AiChat$w3_encode_ResponseId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Evergreen$V417$AiChat$w3_encode_SendMessageWith = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$AiChat$w3_encode_FrontendModel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$AiChat$w3_encode_AiModelsStatus(w3_rec_var0.aiModels),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.chatHistory),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.debounceCounter),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.message),
				$lamdera$containers$SeqDict$encodeDict$($author$project$Evergreen$V417$AiChat$w3_encode_ResponseId, $author$project$Evergreen$V417$AiChat$w3_encode_PendingResponse, w3_rec_var0.pendingResponses),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.responseCounter),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V417$AiChat$w3_encode_AiModelName, w3_rec_var0.selectedModels),
				$author$project$Evergreen$V417$AiChat$w3_encode_SendMessageWith(w3_rec_var0.sendMessageWith),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showOptions)
			]));
};
var $elm$browser$Browser$Navigation$w3_encode_Key = function (w3v) {
	return $elm$bytes$Bytes$Encode$unsignedInt8(0);
};
var $lamdera$program_test$Effect$Browser$Navigation$w3_encode_Key = function (w3v) {
	if (w3v.$ === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$elm$browser$Browser$Navigation$w3_encode_Key(v0)
				]));
	}
};
var $author$project$Evergreen$V417$MyUi$w3_encode_Copied = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
				]));
	}
};
var $author$project$Evergreen$V417$MyUi$w3_encode_LastCopy = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$MyUi$w3_encode_Copied(w3_rec_var0.copied),
				function (t) {
				return $lamdera$codecs$Lamdera$Wire3$encodeInt(
					$elm$time$Time$posixToMillis(t));
			}(w3_rec_var0.copiedAt)
			]));
};
var $author$project$Evergreen$V417$Audio$w3_encode_LoadError = function (w3v) {
	switch (w3v) {
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $lamdera$program_test$Effect$Browser$Dom$w3_encode_HtmlId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Evergreen$V417$Id$w3_encode_InviteLinkId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $lamdera$containers$SeqSet$encodeSet$ = function (encVal, s) {
	return $lamdera$codecs$Lamdera$Wire3$encodeList$(
		encVal,
		$lamdera$containers$SeqSet$toList(s));
};
var $lamdera$containers$SeqSet$encodeSet = F2($lamdera$containers$SeqSet$encodeSet$);
var $author$project$Evergreen$V417$Discord$w3_encode_ChannelId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$Discord$w3_encode_GuildId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $lamdera$codecs$Lamdera$Wire3$encodeTriple$ = function (c_a, c_b, c_c, _v0) {
	var a = _v0.a;
	var b = _v0.b;
	var c = _v0.c;
	return $elm$bytes$Bytes$Encode$sequence(
		_List_fromArray(
			[
				c_a(a),
				c_b(b),
				c_c(c)
			]));
};
var $lamdera$codecs$Lamdera$Wire3$encodeTriple = F4($lamdera$codecs$Lamdera$Wire3$encodeTriple$);
var $MartinSStewart$elm_uint64$UInt64$w3_encode_UInt16 = $lamdera$codecs$Lamdera$Wire3$encodeInt;
var $MartinSStewart$elm_uint64$UInt64$w3_encode_UInt24 = $lamdera$codecs$Lamdera$Wire3$encodeInt;
var $MartinSStewart$elm_uint64$UInt64$w3_encode_UInt64 = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeTriple$($MartinSStewart$elm_uint64$UInt64$w3_encode_UInt16, $MartinSStewart$elm_uint64$UInt64$w3_encode_UInt24, $MartinSStewart$elm_uint64$UInt64$w3_encode_UInt24, v0)
			]));
};
var $author$project$Evergreen$V417$Discord$w3_encode_Id$ = function (w3_x_c_idType, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$MartinSStewart$elm_uint64$UInt64$w3_encode_UInt64(v0)
			]));
};
var $author$project$Evergreen$V417$Discord$w3_encode_Id = F2($author$project$Evergreen$V417$Discord$w3_encode_Id$);
var $author$project$Evergreen$V417$Discord$w3_encode_UserId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$Id$w3_encode_Viewing_DiscordChannelId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, w3_rec_var0.channelId),
				$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, w3_rec_var0.currentUserId),
				$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, w3_rec_var0.guildId)
			]));
};
var $author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$Id$w3_encode_Viewing_DiscordDmId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId, w3_rec_var0.channelId),
				$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, w3_rec_var0.currentUserId)
			]));
};
var $author$project$Evergreen$V417$Id$w3_encode_DiscordGuildOrDmId = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$Id$w3_encode_Viewing_DiscordDmId(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V417$Id$w3_encode_Viewing_DiscordChannelId(v0)
				]));
	}
};
var $author$project$Evergreen$V417$Id$w3_encode_ChannelId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$Id$w3_encode_GuildId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$Id$w3_encode_Id$ = function (w3_x_c_a, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Evergreen$V417$Id$w3_encode_Id = F2($author$project$Evergreen$V417$Id$w3_encode_Id$);
var $author$project$Evergreen$V417$Id$w3_encode_Viewing_ChannelId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelId, w3_rec_var0.channelId),
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, w3_rec_var0.guildId)
			]));
};
var $author$project$Evergreen$V417$Id$w3_encode_UserId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$Id$w3_encode_Viewing_DmId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, w3_rec_var0.otherUserId)
			]));
};
var $author$project$Evergreen$V417$Id$w3_encode_GuildOrDmId = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$Id$w3_encode_Viewing_DmId(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V417$Id$w3_encode_Viewing_ChannelId(v0)
				]));
	}
};
var $author$project$Evergreen$V417$Slack$w3_encode_ChannelId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$Slack$w3_encode_Id$ = function (w3_x_c_a, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Evergreen$V417$Slack$w3_encode_Id = F2($author$project$Evergreen$V417$Slack$w3_encode_Id$);
var $author$project$Evergreen$V417$Slack$w3_encode_TeamId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$Slack$w3_encode_UserId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$Id$w3_encode_Viewing_SlackChannelId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_ChannelId, w3_rec_var0.channelId),
				$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_UserId, w3_rec_var0.currentUserId),
				$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_TeamId, w3_rec_var0.teamId)
			]));
};
var $author$project$Evergreen$V417$Slack$w3_encode_DmChannelId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$Id$w3_encode_Viewing_SlackDmId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_DmChannelId, w3_rec_var0.channelId),
				$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_UserId, w3_rec_var0.currentUserId)
			]));
};
var $author$project$Evergreen$V417$Id$w3_encode_SlackGuildOrDmId = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$Id$w3_encode_Viewing_SlackDmId(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V417$Id$w3_encode_Viewing_SlackChannelId(v0)
				]));
	}
};
var $author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Id$w3_encode_DiscordGuildOrDmId(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$Id$w3_encode_GuildOrDmId(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$Id$w3_encode_SlackGuildOrDmId(v0)
					]));
	}
};
var $author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$Route$w3_encode_ChannelSidebarMode = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					function (w3_rec_var0) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.offset),
								$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.previousOffset),
								$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.time)
							]));
				}(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					function (w3_rec_var0) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.offset)
							]));
				}(v0)
				]));
	}
};
var $author$project$Evergreen$V417$Types$w3_encode_EditChannelForm = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.deleteConfirmation),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.description),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pressedSubmit),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showDeleteConfirmation)
			]));
};
var $author$project$Evergreen$V417$Types$w3_encode_ImportChannelError = function (w3v) {
	return $elm$bytes$Bytes$Encode$unsignedInt8(0);
};
var $author$project$Evergreen$V417$Types$w3_encode_ImportChannelStatus = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Types$w3_encode_ImportChannelError(v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.encryptedMessages)
								]));
					}(v0)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Evergreen$V417$Types$w3_encode_EditGuildForm = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.deleteConfirmation),
				$author$project$Evergreen$V417$Types$w3_encode_ImportChannelStatus(w3_rec_var0.importChannel),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pressedSubmit),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showDeleteConfirmation),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showLeaveConfirmation)
			]));
};
var $author$project$Evergreen$V417$FileStatus$w3_encode_FileId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$FileStatus$w3_encode_ContentType = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Evergreen$V417$FileStatus$w3_encode_FileHash = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Evergreen$V417$FileStatus$w3_encode_ExposureTime = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.denominator),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.numerator)
			]));
};
var $author$project$Evergreen$V417$SafeFloat$w3_encode_SafeFloat = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(v0)
			]));
};
var $author$project$Evergreen$V417$FileStatus$w3_encode_Location = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$SafeFloat$w3_encode_SafeFloat(w3_rec_var0.lat),
				$author$project$Evergreen$V417$SafeFloat$w3_encode_SafeFloat(w3_rec_var0.lon)
			]));
};
var $author$project$Evergreen$V417$FileStatus$w3_encode_Orientation = function (w3v) {
	switch (w3v) {
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
	}
};
var $author$project$Evergreen$V417$FileStatus$w3_encode_ImageMetadata = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.cameraOwner),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$FileStatus$w3_encode_ExposureTime, w3_rec_var0.exposureTime),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$SafeFloat$w3_encode_SafeFloat, w3_rec_var0.fNumber),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$SafeFloat$w3_encode_SafeFloat, w3_rec_var0.focalLength),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$FileStatus$w3_encode_Location, w3_rec_var0.gpsLocation),
				A2($author$project$Evergreen$V417$Coord$w3_encode_Coord, $author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels, w3_rec_var0.imageSize),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.isoSpeedRating),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.make),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.model),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$FileStatus$w3_encode_Orientation, w3_rec_var0.orientation),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.software),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.userComment)
			]));
};
var $ianmackenzie$elm_units$Duration$w3_encode_Seconds = function (w3v) {
	return $elm$bytes$Bytes$Encode$unsignedInt8(0);
};
var $ianmackenzie$elm_units$Duration$w3_encode_Duration = A2($ianmackenzie$elm_units$Quantity$w3_encode_Quantity, $lamdera$codecs$Lamdera$Wire3$encodeFloat, $ianmackenzie$elm_units$Duration$w3_encode_Seconds);
var $author$project$Evergreen$V417$FileStatus$w3_encode_VideoMetadata = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.codec),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.createdAt),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($ianmackenzie$elm_units$Duration$w3_encode_Duration, w3_rec_var0.duration),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$FileStatus$w3_encode_Location, w3_rec_var0.gpsLocation),
				$author$project$Evergreen$V417$FileStatus$w3_encode_Orientation(w3_rec_var0.orientation),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.title),
				A2($author$project$Evergreen$V417$Coord$w3_encode_Coord, $author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels, w3_rec_var0.videoSize)
			]));
};
var $author$project$Evergreen$V417$FileStatus$w3_encode_FileMetadata = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$FileStatus$w3_encode_ImageMetadata(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V417$FileStatus$w3_encode_VideoMetadata(v0)
				]));
	}
};
var $MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString = function (w3v) {
	var v0 = w3v.a;
	var v1 = w3v.b;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeChar(v0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
			]));
};
var $author$project$Evergreen$V417$FileName$w3_encode_FileName = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v0)
			]));
};
var $lamdera$codecs$Lamdera$Wire3$encodeBytes = function (b) {
	return $elm$bytes$Bytes$Encode$sequence(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(
				$elm$bytes$Bytes$width(b)),
				$elm$bytes$Bytes$Encode$bytes(b)
			]));
};
var $author$project$Evergreen$V417$FileStatus$w3_encode_AesPrivateKey = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeBytes(v0)
			]));
};
var $author$project$Evergreen$V417$FileStatus$w3_encode_EncryptedThumbnail = function (w3v) {
	if (w3v === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$FileStatus$w3_encode_IsEncrypted = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$FileStatus$w3_encode_AesPrivateKey(v0),
					$author$project$Evergreen$V417$FileStatus$w3_encode_EncryptedThumbnail(v1)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$FileStatus$w3_encode_FileData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$FileStatus$w3_encode_ContentType(w3_rec_var0.contentType),
				$author$project$Evergreen$V417$FileStatus$w3_encode_FileHash(w3_rec_var0.fileHash),
				$author$project$Evergreen$V417$FileName$w3_encode_FileName(w3_rec_var0.fileName),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.fileSize),
				$author$project$Evergreen$V417$FileStatus$w3_encode_IsEncrypted(w3_rec_var0.isEncrypted),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$FileStatus$w3_encode_FileMetadata, w3_rec_var0.metadata)
			]));
};
var $author$project$Evergreen$V417$FileStatus$w3_encode_FileStatus = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$FileName$w3_encode_FileName(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1),
						$author$project$Evergreen$V417$FileStatus$w3_encode_ContentType(v2),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v3),
						$author$project$Evergreen$V417$FileStatus$w3_encode_IsEncrypted(v4)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$FileStatus$w3_encode_FileData(v0)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$FileName$w3_encode_FileName(v0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.sent),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.size)
								]));
					}(v1),
						$author$project$Evergreen$V417$FileStatus$w3_encode_ContentType(v2),
						$author$project$Evergreen$V417$FileStatus$w3_encode_IsEncrypted(v3)
					]));
	}
};
var $author$project$Evergreen$V417$Types$w3_encode_EditMessage = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$FileStatus$w3_encode_FileId),
				$author$project$Evergreen$V417$FileStatus$w3_encode_FileStatus,
				w3_rec_var0.attachedFiles),
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, w3_rec_var0.messageIndex),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.text)
			]));
};
var $author$project$Evergreen$V417$Id$w3_encode_QuestionId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$SheepGame$w3_encode_Input = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v0)
					]));
	}
};
var $author$project$Evergreen$V417$Range$w3_encode_Range = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.end),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.start)
			]));
};
var $author$project$Evergreen$V417$SheepGame$w3_encode_ReactionTarget = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0),
					$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v1)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v0)
				]));
	}
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_ReactionTarget = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v0)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v0),
					$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId, v1)
				]));
	}
};
var $author$project$Evergreen$V417$Types$w3_encode_EmojiSelector = function (w3v) {
	switch (w3v.$) {
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						A2($author$project$Evergreen$V417$Coord$w3_encode_Coord, $author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Range$w3_encode_Range, v1)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Range$w3_encode_Range, v0)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V417$SheepGame$w3_encode_Input(v0),
						A2($author$project$Evergreen$V417$Coord$w3_encode_Coord, $author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Range$w3_encode_Range, v2)
					]));
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V417$Id$w3_encode_GuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V417$SheepGame$w3_encode_ReactionTarget(v2)
					]));
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V417$Id$w3_encode_GuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V417$WordSpellingGame$w3_encode_ReactionTarget(v2)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
	}
};
var $author$project$Evergreen$V417$Encryption$w3_encode_DecryptManyRequestId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$Encryption$w3_encode_DecryptRequestId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$Encryption$w3_encode_EncryptFileRequestId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$Encryption$w3_encode_EncryptManyRequestId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$Encryption$w3_encode_EncryptRequestId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$Encryption$w3_encode_BytesHash = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Evergreen$V417$Types$w3_encode_PendingDecryptedManyMessages = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V417$Encryption$w3_encode_BytesHash, w3_rec_var0.messageHashes),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Browser$Dom$w3_encode_HtmlId, w3_rec_var0.shiftScrollFrom)
			]));
};
var $author$project$Evergreen$V417$Message$w3_encode_RepliedToGame = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v1)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
	}
};
var $author$project$Evergreen$V417$Message$w3_encode_RepliedTo$ = function (w3_x_c_messageId, w3v) {
	switch (w3v.$) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v0),
						$author$project$Evergreen$V417$Message$w3_encode_RepliedToGame(v1)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$Id$w3_encode_Id$(w3_x_c_messageId, v0)
					]));
	}
};
var $author$project$Evergreen$V417$Message$w3_encode_RepliedTo = F2($author$project$Evergreen$V417$Message$w3_encode_RepliedTo$);
var $author$project$Evergreen$V417$Message$w3_encode_ThreadRouteWithRepliedTo = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$Message$w3_encode_RepliedTo$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v0)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v0),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId),
					v1)
				]));
	}
};
var $author$project$Evergreen$V417$Types$w3_encode_PendingDecryptedMessage = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Encryption$w3_encode_BytesHash(w3_rec_var0.hash),
				$author$project$Evergreen$V417$Id$w3_encode_Viewing_DmId(w3_rec_var0.id),
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, w3_rec_var0.senderId),
				$author$project$Evergreen$V417$Message$w3_encode_ThreadRouteWithRepliedTo(w3_rec_var0.threadRoute)
			]));
};
var $author$project$Evergreen$V417$Types$w3_encode_PendingDecryptedOldMessages = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Id$w3_encode_Viewing_DmId(w3_rec_var0.id),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage, w3_rec_var0.messages)
			]));
};
var $author$project$Evergreen$V417$Embed$w3_encode_EmbedImageFormat = function (w3v) {
	switch (w3v) {
		case 13:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 12:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 14:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(12);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(14);
	}
};
var $author$project$Evergreen$V417$Embed$w3_encode_EmbedImageData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Embed$w3_encode_EmbedImageFormat, w3_rec_var0.format),
				A2($author$project$Evergreen$V417$Coord$w3_encode_Coord, $author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels, w3_rec_var0.imageSize),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.url)
			]));
};
var $author$project$Evergreen$V417$Embed$w3_encode_EmbedData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.createdAt),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.description),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Embed$w3_encode_EmbedImageData, w3_rec_var0.image),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.title)
			]));
};
var $author$project$Evergreen$V417$Embed$w3_encode_Embed = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$Embed$w3_encode_EmbedData(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$ = function (w3_x_c_a, w3v) {
	var v0 = w3v.a;
	var v1 = w3v.b;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				w3_x_c_a(v0),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(w3_x_c_a, v1)
			]));
};
var $mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty = F2($mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$);
var $author$project$Evergreen$V417$Id$w3_encode_CustomEmojiId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$RichText$w3_encode_EscapedChar = function (w3v) {
	switch (w3v) {
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
	}
};
var $author$project$Evergreen$V417$RichText$w3_encode_HasLeadingLineBreak = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$RichText$w3_encode_HeadingLevel = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Evergreen$V417$RichText$w3_encode_Language = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$Id$w3_encode_StickerId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$TimeInMinutes$w3_encode_TimeInMinutes = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $elm$url$Url$w3_encode_Protocol = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $elm$url$Url$w3_encode_Url = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.fragment),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.host),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.path),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.port_),
				$elm$url$Url$w3_encode_Protocol(w3_rec_var0.protocol),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.query)
			]));
};
var $author$project$Evergreen$V417$RichText$w3_encode_RichText$ = function (w3_x_c_userId, w3_x_c_channelId, w3v) {
	switch (w3v.$) {
		case 14:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$FileStatus$w3_encode_FileId, v0)
					]));
		case 8:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$RichText$w3_encode_HasLeadingLineBreak(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						A2($author$project$Evergreen$V417$RichText$w3_encode_RichText, w3_x_c_userId, w3_x_c_channelId),
						v1)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2($author$project$Evergreen$V417$RichText$w3_encode_RichText, w3_x_c_userId, w3_x_c_channelId),
						v0)
					]));
		case 18:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V417$RichText$w3_encode_HasLeadingLineBreak(v0),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						$lamdera$codecs$Lamdera$Wire3$encodeList(
							A2($author$project$Evergreen$V417$RichText$w3_encode_RichText, w3_x_c_userId, w3_x_c_channelId)),
						v1)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						w3_x_c_channelId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
						v1)
					]));
		case 13:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V417$RichText$w3_encode_Language(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 17:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_CustomEmojiId, v0)
					]));
		case 15:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Evergreen$V417$RichText$w3_encode_EscapedChar(v0)
					]));
		case 9:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Evergreen$V417$RichText$w3_encode_HeadingLevel(v0),
						$author$project$Evergreen$V417$RichText$w3_encode_HasLeadingLineBreak(v1),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2($author$project$Evergreen$V417$RichText$w3_encode_RichText, w3_x_c_userId, w3_x_c_channelId),
						v2)
					]));
		case 10:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$elm$url$Url$w3_encode_Url(v0)
					]));
		case 12:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$lamdera$codecs$Lamdera$Wire3$encodeChar(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2($author$project$Evergreen$V417$RichText$w3_encode_RichText, w3_x_c_userId, w3_x_c_channelId),
						v0)
					]));
		case 11:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v0),
						$elm$url$Url$w3_encode_Url(v1)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$lamdera$codecs$Lamdera$Wire3$encodeChar(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2($author$project$Evergreen$V417$RichText$w3_encode_RichText, w3_x_c_userId, w3_x_c_channelId),
						v0)
					]));
		case 16:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_StickerId, v0)
					]));
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2($author$project$Evergreen$V417$RichText$w3_encode_RichText, w3_x_c_userId, w3_x_c_channelId),
						v0)
					]));
		case 19:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$author$project$Evergreen$V417$TimeInMinutes$w3_encode_TimeInMinutes(v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2($author$project$Evergreen$V417$RichText$w3_encode_RichText, w3_x_c_userId, w3_x_c_channelId),
						v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(19),
						w3_x_c_userId(v0)
					]));
	}
};
var $author$project$Evergreen$V417$RichText$w3_encode_RichText = F3($author$project$Evergreen$V417$RichText$w3_encode_RichText$);
var $author$project$Evergreen$V417$Message$w3_encode_MessageContent$ = function (w3_x_c_userId, w3_x_c_channelId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$containers$SeqDict$encodeDict$(
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$FileStatus$w3_encode_FileId),
					$author$project$Evergreen$V417$FileStatus$w3_encode_FileData,
					w3_rec_var0.attachedFiles),
					$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
					A2($author$project$Evergreen$V417$RichText$w3_encode_RichText, w3_x_c_userId, w3_x_c_channelId),
					w3_rec_var0.content),
					$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Evergreen$V417$Embed$w3_encode_Embed, w3_rec_var0.embeds)
				]));
	};
};
var $author$project$Evergreen$V417$Message$w3_encode_MessageContent = F2($author$project$Evergreen$V417$Message$w3_encode_MessageContent$);
var $author$project$Evergreen$V417$Types$w3_encode_PendingEncryptedEdit = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				A3(
				$author$project$Evergreen$V417$Message$w3_encode_MessageContent,
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId),
				w3_rec_var0.contentAndEmbeds),
				$author$project$Evergreen$V417$Id$w3_encode_Viewing_DmId(w3_rec_var0.id),
				$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(w3_rec_var0.threadRoute)
			]));
};
var $author$project$Evergreen$V417$Id$w3_encode_ThreadRoute = function (w3v) {
	if (!w3v.$) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v0)
				]));
	}
};
var $author$project$Evergreen$V417$Types$w3_encode_PendingEncryptedFile = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$FileStatus$w3_encode_FileId, w3_rec_var0.fileId),
				$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_encode_ThreadRoute, w3_rec_var0.guildOrDmId)
			]));
};
var $author$project$Evergreen$V417$Types$w3_encode_PendingEncryptedManyMessages = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Id$w3_encode_Viewing_DmId(w3_rec_var0.id),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage,
					$author$project$Evergreen$V417$Message$w3_encode_MessageContent$(
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId))),
				w3_rec_var0.messages)
			]));
};
var $author$project$Evergreen$V417$Types$w3_encode_PendingEncryptedMessage = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				A3(
				$author$project$Evergreen$V417$Message$w3_encode_MessageContent,
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId),
				w3_rec_var0.contentAndEmbeds),
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, w3_rec_var0.otherUserId),
				$author$project$Evergreen$V417$Message$w3_encode_ThreadRouteWithRepliedTo(w3_rec_var0.threadRoute)
			]));
};
var $author$project$Evergreen$V417$Types$w3_encode_EncryptionRequests = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Encryption$w3_encode_DecryptManyRequestId, w3_rec_var0.nextDecryptManyRequestId),
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Encryption$w3_encode_DecryptRequestId, w3_rec_var0.nextDecryptionRequestId),
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Encryption$w3_encode_EncryptFileRequestId, w3_rec_var0.nextEncryptFileRequestId),
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Encryption$w3_encode_EncryptManyRequestId, w3_rec_var0.nextEncryptManyRequestId),
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Encryption$w3_encode_EncryptRequestId, w3_rec_var0.nextEncryptionRequestId),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Encryption$w3_encode_DecryptManyRequestId),
				$author$project$Evergreen$V417$Types$w3_encode_PendingDecryptedManyMessages,
				w3_rec_var0.pendingDecryptedManyMessages),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Encryption$w3_encode_DecryptRequestId),
				$author$project$Evergreen$V417$Types$w3_encode_PendingDecryptedMessage,
				w3_rec_var0.pendingDecryptedMessages),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Encryption$w3_encode_DecryptManyRequestId),
				$author$project$Evergreen$V417$Types$w3_encode_PendingDecryptedOldMessages,
				w3_rec_var0.pendingDecryptedOldMessages),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Encryption$w3_encode_EncryptRequestId),
				$author$project$Evergreen$V417$Types$w3_encode_PendingEncryptedEdit,
				w3_rec_var0.pendingEncryptedEdits),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Encryption$w3_encode_EncryptFileRequestId),
				$author$project$Evergreen$V417$Types$w3_encode_PendingEncryptedFile,
				w3_rec_var0.pendingEncryptedFiles),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Encryption$w3_encode_EncryptManyRequestId),
				$author$project$Evergreen$V417$Types$w3_encode_PendingEncryptedManyMessages,
				w3_rec_var0.pendingEncryptedManyMessages),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Encryption$w3_encode_EncryptManyRequestId),
				$author$project$Evergreen$V417$Types$w3_encode_PendingEncryptedMessage,
				w3_rec_var0.pendingEncryptedMessages)
			]));
};
var $author$project$Evergreen$V417$FileStatus$w3_encode_FileDataWithImage = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$FileStatus$w3_encode_ContentType(w3_rec_var0.contentType),
				$author$project$Evergreen$V417$FileStatus$w3_encode_FileHash(w3_rec_var0.fileHash),
				$author$project$Evergreen$V417$FileName$w3_encode_FileName(w3_rec_var0.fileName),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.fileSize),
				$author$project$Evergreen$V417$FileStatus$w3_encode_IsEncrypted(w3_rec_var0.isEncrypted),
				$author$project$Evergreen$V417$FileStatus$w3_encode_FileMetadata(w3_rec_var0.metadata)
			]));
};
var $author$project$Evergreen$V417$OneOrGreater$w3_encode_OneOrGreater = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Evergreen$V417$Types$w3_encode_FileDrag = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
					$author$project$Evergreen$V417$OneOrGreater$w3_encode_OneOrGreater(v1)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, v0)
				]));
	}
};
var $author$project$Evergreen$V417$Local$w3_encode_ChangeId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Evergreen$V417$Local$w3_encode_Local$ = function (w3_x_c_msg, w3_x_c_model, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				function (w3_rec_var0) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$author$project$Evergreen$V417$Local$w3_encode_ChangeId(w3_rec_var0.counter),
							w3_x_c_model(w3_rec_var0.localModel),
							$lamdera$codecs$Lamdera$Wire3$encodeDict$(
							$lamdera$codecs$Lamdera$Wire3$encodeInt,
							function (w3_rec_var1) {
								return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
									_List_fromArray(
										[
											function (t) {
											return $lamdera$codecs$Lamdera$Wire3$encodeInt(
												$elm$time$Time$posixToMillis(t));
										}(w3_rec_var1.createdAt),
											w3_x_c_msg(w3_rec_var1.msg)
										]));
							},
							w3_rec_var0.localMsgs),
							w3_x_c_model(w3_rec_var0.serverModel)
						]));
			}(v0)
			]));
};
var $author$project$Evergreen$V417$Local$w3_encode_Local = F3($author$project$Evergreen$V417$Local$w3_encode_Local$);
var $author$project$Evergreen$V417$GuildName$w3_encode_GuildName = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v0)
			]));
};
var $author$project$Evergreen$V417$LocalState$w3_encode_AdminData_DeletedGuild = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.deletedAt),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.memberCount),
				$author$project$Evergreen$V417$GuildName$w3_encode_GuildName(w3_rec_var0.name),
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, w3_rec_var0.owner)
			]));
};
var $author$project$Evergreen$V417$Message$w3_encode_CallRecordingFile = function (w3_x_c_userId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					function (t) {
					return $lamdera$codecs$Lamdera$Wire3$encodeInt(
						$elm$time$Time$posixToMillis(t));
				}(w3_rec_var0.endedAt),
					$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
					w3_x_c_userId(w3_rec_var0.recordedBy),
					$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.size),
					function (t) {
					return $lamdera$codecs$Lamdera$Wire3$encodeInt(
						$elm$time$Time$posixToMillis(t));
				}(w3_rec_var0.startedAt),
					$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.uploaded)
				]));
	};
};
var $author$project$Evergreen$V417$Message$w3_encode_CallRecordingZip = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.fileCount),
				$author$project$Evergreen$V417$FileStatus$w3_encode_FileHash(w3_rec_var0.fileHash),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.size)
			]));
};
var $author$project$Evergreen$V417$NonemptySet$w3_encode_NonemptySet$ = function (w3_x_c_a, w3v) {
	var v0 = w3v.a;
	var v1 = w3v.b;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				w3_x_c_a(v0),
				$lamdera$containers$SeqSet$encodeSet$(w3_x_c_a, v1)
			]));
};
var $author$project$Evergreen$V417$NonemptySet$w3_encode_NonemptySet = F2($author$project$Evergreen$V417$NonemptySet$w3_encode_NonemptySet$);
var $author$project$Evergreen$V417$Message$w3_encode_CallRecording = function (w3_x_c_userId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$codecs$Lamdera$Wire3$encodeList$(
					$author$project$Evergreen$V417$Message$w3_encode_CallRecordingFile(w3_x_c_userId),
					w3_rec_var0.files),
					$lamdera$containers$SeqSet$encodeSet$(w3_x_c_userId, w3_rec_var0.finishedUploading),
					$author$project$Evergreen$V417$NonemptySet$w3_encode_NonemptySet$(w3_x_c_userId, w3_rec_var0.participants),
					function (t) {
					return $lamdera$codecs$Lamdera$Wire3$encodeInt(
						$elm$time$Time$posixToMillis(t));
				}(w3_rec_var0.startedAt),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Message$w3_encode_CallRecordingZip, w3_rec_var0.zip)
				]));
	};
};
var $author$project$Evergreen$V417$Drawing$w3_encode_Stroke = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Evergreen$V417$SafeFloat$w3_encode_SafeFloat, $author$project$Evergreen$V417$SafeFloat$w3_encode_SafeFloat),
				w3_rec_var0.points)
			]));
};
var $author$project$Evergreen$V417$Drawing$w3_encode_Drawing = function (w3_x_c_userId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$codecs$Lamdera$Wire3$encodeList$(
					function (w3_rec_var1) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									w3_x_c_userId(w3_rec_var1.createdBy),
									$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
									A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Evergreen$V417$SafeFloat$w3_encode_SafeFloat, $author$project$Evergreen$V417$SafeFloat$w3_encode_SafeFloat),
									w3_rec_var1.points)
								]));
					},
					w3_rec_var0.finished),
					$lamdera$containers$SeqDict$encodeDict$(w3_x_c_userId, $author$project$Evergreen$V417$Drawing$w3_encode_Stroke, w3_rec_var0.inProgress),
					$lamdera$containers$SeqDict$encodeDict$(
					w3_x_c_userId,
					$lamdera$codecs$Lamdera$Wire3$encodeList($author$project$Evergreen$V417$Drawing$w3_encode_Stroke),
					w3_rec_var0.undone)
				]));
	};
};
var $author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_CustomEmojiId, v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V417$Emoji$w3_encode_UnicodeEmoji(v0)
				]));
	}
};
var $author$project$Evergreen$V417$Message$w3_encode_CallStartedData = function (w3_x_c_userId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					A2($author$project$Evergreen$V417$Drawing$w3_encode_Drawing, w3_x_c_userId, w3_rec_var0.cardDrawings),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					function (t) {
						return $lamdera$codecs$Lamdera$Wire3$encodeInt(
							$elm$time$Time$posixToMillis(t));
					},
					w3_rec_var0.endedAt),
					$lamdera$containers$SeqSet$encodeSet$(w3_x_c_userId, w3_rec_var0.joinedBy),
					$lamdera$containers$SeqDict$encodeDict$(
					$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji,
					$author$project$Evergreen$V417$NonemptySet$w3_encode_NonemptySet(w3_x_c_userId),
					w3_rec_var0.reactions),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					$author$project$Evergreen$V417$Message$w3_encode_CallRecording(w3_x_c_userId),
					w3_rec_var0.recordings),
					function (t) {
					return $lamdera$codecs$Lamdera$Wire3$encodeInt(
						$elm$time$Time$posixToMillis(t));
				}(w3_rec_var0.startedAt),
					w3_x_c_userId(w3_rec_var0.startedBy),
					A2($author$project$Evergreen$V417$Drawing$w3_encode_Drawing, w3_x_c_userId, w3_rec_var0.timestampDrawings)
				]));
	};
};
var $author$project$Evergreen$V417$Encryption$w3_encode_EncryptedData$ = function (w3_x_c_a, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeBytes(v0)
			]));
};
var $author$project$Evergreen$V417$Encryption$w3_encode_EncryptedData = F2($author$project$Evergreen$V417$Encryption$w3_encode_EncryptedData$);
var $author$project$Evergreen$V417$Message$w3_encode_UserTextMessageDrawings = function (w3_x_c_userId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$containers$SeqDict$encodeDict$(
					$lamdera$codecs$Lamdera$Wire3$encodeInt,
					$author$project$Evergreen$V417$Drawing$w3_encode_Drawing(w3_x_c_userId),
					w3_rec_var0.embedDrawings),
					$lamdera$containers$SeqDict$encodeDict$(
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$FileStatus$w3_encode_FileId),
					$author$project$Evergreen$V417$Drawing$w3_encode_Drawing(w3_x_c_userId),
					w3_rec_var0.imageAttachmentDrawings),
					A2($author$project$Evergreen$V417$Drawing$w3_encode_Drawing, w3_x_c_userId, w3_rec_var0.timestampDrawings),
					A2($author$project$Evergreen$V417$Drawing$w3_encode_Drawing, w3_x_c_userId, w3_rec_var0.userIconDrawings)
				]));
	};
};
var $author$project$Evergreen$V417$Message$w3_encode_EncryptedUserTextMessageData$ = function (w3_x_c_messageId, w3_x_c_userId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$author$project$Evergreen$V417$Encryption$w3_encode_EncryptedData$(
					$author$project$Evergreen$V417$Message$w3_encode_MessageContent$(
						w3_x_c_userId,
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId)),
					w3_rec_var0.content),
					function (t) {
					return $lamdera$codecs$Lamdera$Wire3$encodeInt(
						$elm$time$Time$posixToMillis(t));
				}(w3_rec_var0.createdAt),
					w3_x_c_userId(w3_rec_var0.createdBy),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					$author$project$Evergreen$V417$Message$w3_encode_UserTextMessageDrawings(w3_x_c_userId),
					w3_rec_var0.drawings),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					function (t) {
						return $lamdera$codecs$Lamdera$Wire3$encodeInt(
							$elm$time$Time$posixToMillis(t));
					},
					w3_rec_var0.editedAt),
					$lamdera$containers$SeqSet$encodeSet$($author$project$Evergreen$V417$FileStatus$w3_encode_FileHash, w3_rec_var0.fileHashes),
					$lamdera$containers$SeqDict$encodeDict$(
					$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji,
					$author$project$Evergreen$V417$NonemptySet$w3_encode_NonemptySet(w3_x_c_userId),
					w3_rec_var0.reactions),
					$author$project$Evergreen$V417$Message$w3_encode_RepliedTo$(w3_x_c_messageId, w3_rec_var0.repliedTo)
				]));
	};
};
var $author$project$Evergreen$V417$Message$w3_encode_EncryptedUserTextMessageData = F2($author$project$Evergreen$V417$Message$w3_encode_EncryptedUserTextMessageData$);
var $author$project$Evergreen$V417$Message$w3_encode_GameType = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V417$Message$w3_encode_GameStartedData = function (w3_x_c_userId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					A2($author$project$Evergreen$V417$Drawing$w3_encode_Drawing, w3_x_c_userId, w3_rec_var0.cardDrawings),
					$author$project$Evergreen$V417$Message$w3_encode_GameType(w3_rec_var0.gameType),
					$lamdera$containers$SeqDict$encodeDict$(
					$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji,
					$author$project$Evergreen$V417$NonemptySet$w3_encode_NonemptySet(w3_x_c_userId),
					w3_rec_var0.reactions),
					function (t) {
					return $lamdera$codecs$Lamdera$Wire3$encodeInt(
						$elm$time$Time$posixToMillis(t));
				}(w3_rec_var0.startedAt),
					w3_x_c_userId(w3_rec_var0.startedBy),
					A2($author$project$Evergreen$V417$Drawing$w3_encode_Drawing, w3_x_c_userId, w3_rec_var0.timestampDrawings)
				]));
	};
};
var $author$project$Evergreen$V417$Message$w3_encode_UserTextMessageData$ = function (w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					A3($author$project$Evergreen$V417$Message$w3_encode_MessageContent, w3_x_c_userId, w3_x_c_channelId, w3_rec_var0.content),
					function (t) {
					return $lamdera$codecs$Lamdera$Wire3$encodeInt(
						$elm$time$Time$posixToMillis(t));
				}(w3_rec_var0.createdAt),
					w3_x_c_userId(w3_rec_var0.createdBy),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					$author$project$Evergreen$V417$Message$w3_encode_UserTextMessageDrawings(w3_x_c_userId),
					w3_rec_var0.drawings),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					function (t) {
						return $lamdera$codecs$Lamdera$Wire3$encodeInt(
							$elm$time$Time$posixToMillis(t));
					},
					w3_rec_var0.editedAt),
					$lamdera$containers$SeqDict$encodeDict$(
					$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji,
					$author$project$Evergreen$V417$NonemptySet$w3_encode_NonemptySet(w3_x_c_userId),
					w3_rec_var0.reactions),
					$author$project$Evergreen$V417$Message$w3_encode_RepliedTo$(w3_x_c_messageId, w3_rec_var0.repliedTo)
				]));
	};
};
var $author$project$Evergreen$V417$Message$w3_encode_UserTextMessageData = F3($author$project$Evergreen$V417$Message$w3_encode_UserTextMessageData$);
var $author$project$Evergreen$V417$Message$w3_encode_Message$ = function (w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId, w3v) {
	switch (w3v.$) {
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						A2($author$project$Evergreen$V417$Message$w3_encode_CallStartedData, w3_x_c_userId, v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						function (t) {
						return $lamdera$codecs$Lamdera$Wire3$encodeInt(
							$elm$time$Time$posixToMillis(t));
					}(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						A3($author$project$Evergreen$V417$Message$w3_encode_EncryptedUserTextMessageData, w3_x_c_messageId, w3_x_c_userId, v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						A2($author$project$Evergreen$V417$Message$w3_encode_GameStartedData, w3_x_c_userId, v0)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						function (t) {
						return $lamdera$codecs$Lamdera$Wire3$encodeInt(
							$elm$time$Time$posixToMillis(t));
					}(v0),
						w3_x_c_userId(v1),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji,
						$author$project$Evergreen$V417$NonemptySet$w3_encode_NonemptySet(w3_x_c_userId),
						v2),
						A2($author$project$Evergreen$V417$Drawing$w3_encode_Drawing, w3_x_c_userId, v3)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						A4($author$project$Evergreen$V417$Message$w3_encode_UserTextMessageData, w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId, v0)
					]));
	}
};
var $author$project$Evergreen$V417$Message$w3_encode_Message = F4($author$project$Evergreen$V417$Message$w3_encode_Message$);
var $author$project$Evergreen$V417$LocalState$w3_encode_AdminData_DiscordDmChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				A3(
					$author$project$Evergreen$V417$Message$w3_encode_Message,
					$author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId,
					$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
					$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_ChannelId)),
				w3_rec_var0.firstMessage),
				$author$project$Evergreen$V417$NonemptyDict$w3_encode_NonemptyDict$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.messagesSent)
							]));
				},
				w3_rec_var0.members),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.messageCount)
			]));
};
var $author$project$Evergreen$V417$ChannelName$w3_encode_ChannelName = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v0)
			]));
};
var $author$project$Evergreen$V417$Discord$w3_encode_Permissions = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.addReaction),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.administrator),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.attachFiles),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.banMembers),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.changeNickname),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.connect),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.createEvents),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.createGuildExpressions),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.createInstantInvite),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.createPrivateThreads),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.createPublicThreads),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.deafenMembers),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.embedLinks),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.kickMembers),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.manageChannels),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.manageEvents),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.manageGuild),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.manageGuildExpressions),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.manageMessages),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.manageNicknames),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.manageRoles),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.manageThreads),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.manageWebhooks),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.mentionEveryone),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.moderateMembers),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.moveMembers),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.muteMembers),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.prioritySpeaker),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.readMessageHistory),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.requestToSpeak),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.sendMessages),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.sendMessagesInThreads),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.sendPolls),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.sendVoiceMessages),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.sentTextToSpeechMessages),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.speak),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.stream),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.useApplicationCommands),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.useEmbeddedActivities),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.useExternalApps),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.useExternalEmojis),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.useExternalSounds),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.useExternalStickers),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.useSoundboard),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.useVoiceActivityDetection),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.viewAuditLog),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.viewChannel),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.viewCreatorMontetizationAnalytics),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.viewGuildInsights)
			]));
};
var $author$project$Evergreen$V417$Discord$w3_encode_RoleId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$Discord$w3_encode_RoleOrUserId = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_RoleId, v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0)
				]));
	}
};
var $author$project$Evergreen$V417$Discord$w3_encode_Overwrite = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Discord$w3_encode_Permissions(w3_rec_var0.allow),
				$author$project$Evergreen$V417$Discord$w3_encode_Permissions(w3_rec_var0.deny),
				$author$project$Evergreen$V417$Discord$w3_encode_RoleOrUserId(w3_rec_var0.id)
			]));
};
var $author$project$Evergreen$V417$LocalState$w3_encode_AdminData_DiscordChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				A3(
					$author$project$Evergreen$V417$Message$w3_encode_Message,
					$author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId,
					$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
					$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_ChannelId)),
				w3_rec_var0.firstMessage),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.messageCount),
				$author$project$Evergreen$V417$ChannelName$w3_encode_ChannelName(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V417$Discord$w3_encode_Overwrite, w3_rec_var0.permissionOverwrites),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.threadCount)
			]));
};
var $author$project$Evergreen$V417$LocalState$w3_encode_DiscordRole = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.description),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
				$author$project$Evergreen$V417$Discord$w3_encode_Permissions(w3_rec_var0.permissions)
			]));
};
var $author$project$Evergreen$V417$MembersAndOwner$w3_encode_MembersAndOwner$ = function (w3_x_c_userId, w3_x_c_a, w3v) {
	var v0 = w3v.a;
	var v1 = w3v.b;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$containers$SeqDict$encodeDict$(w3_x_c_userId, w3_x_c_a, v0),
				w3_x_c_userId(v1)
			]));
};
var $author$project$Evergreen$V417$MembersAndOwner$w3_encode_MembersAndOwner = F3($author$project$Evergreen$V417$MembersAndOwner$w3_encode_MembersAndOwner$);
var $author$project$Evergreen$V417$LocalState$w3_encode_AdminData_DiscordGuild = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_ChannelId),
				$author$project$Evergreen$V417$LocalState$w3_encode_AdminData_DiscordChannel,
				w3_rec_var0.channels),
				$author$project$Evergreen$V417$MembersAndOwner$w3_encode_MembersAndOwner$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var1.joinedAt),
								$lamdera$containers$SeqSet$encodeSet$(
								$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_RoleId),
								w3_rec_var1.roles)
							]));
				},
				w3_rec_var0.membersAndOwner),
				$author$project$Evergreen$V417$GuildName$w3_encode_GuildName(w3_rec_var0.name),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_RoleId),
				$author$project$Evergreen$V417$LocalState$w3_encode_DiscordRole,
				w3_rec_var0.roles)
			]));
};
var $author$project$Evergreen$V417$LocalState$w3_encode_AdminData_DmChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.messageCount),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.threadCount)
			]));
};
var $author$project$Evergreen$V417$LocalState$w3_encode_AdminData_GuildChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.messageCount),
				$author$project$Evergreen$V417$ChannelName$w3_encode_ChannelName(w3_rec_var0.name)
			]));
};
var $author$project$Evergreen$V417$LocalState$w3_encode_AdminData_Guild = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId),
				$author$project$Evergreen$V417$LocalState$w3_encode_AdminData_GuildChannel,
				w3_rec_var0.channels),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.memberCount),
				$author$project$Evergreen$V417$GuildName$w3_encode_GuildName(w3_rec_var0.name),
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, w3_rec_var0.owner)
			]));
};
var $author$project$Evergreen$V417$LocalState$w3_encode_AdminData_SlackDmChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				A3(
					$author$project$Evergreen$V417$Message$w3_encode_Message,
					$author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId,
					$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_UserId),
					$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_ChannelId)),
				w3_rec_var0.firstMessage),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_UserId, w3_rec_var1.id),
								$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var1.name)
							]));
				},
				w3_rec_var0.members),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.messageCount),
				$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_TeamId, w3_rec_var0.teamId)
			]));
};
var $author$project$Evergreen$V417$LocalState$w3_encode_AdminData_SlackWorkspace = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_ChannelId),
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
								A3(
									$author$project$Evergreen$V417$Message$w3_encode_Message,
									$author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId,
									$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_UserId),
									$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_ChannelId)),
								w3_rec_var1.firstMessage),
								$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var1.isPrivate),
								$lamdera$containers$SeqSet$encodeSet$(
								$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_UserId),
								w3_rec_var1.linkedMembers),
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.messageCount),
								$author$project$Evergreen$V417$ChannelName$w3_encode_ChannelName(w3_rec_var1.name)
							]));
				},
				w3_rec_var0.channels),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.domain),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_UserId),
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, w3_rec_var1.linkedTo),
								$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var1.name)
							]));
				},
				w3_rec_var0.linkedUsers),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.userCount)
			]));
};
var $author$project$Evergreen$V417$Postmark$w3_encode_ApiKey = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Evergreen$V417$FileStatus$w3_encode_BackendFileData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.fileSize),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V417$Coord$w3_encode_Coord($author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels),
				w3_rec_var0.imageSize)
			]));
};
var $author$project$Evergreen$V417$BackendMsgLog$w3_encode_BackendMsgLog = function (w3v) {
	switch (w3v) {
		case 20:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 91:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 34:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 35:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 54:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 12:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 78:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 16:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		case 15:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 65:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		case 64:
			return $elm$bytes$Bytes$Encode$unsignedInt8(12);
		case 66:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
		case 63:
			return $elm$bytes$Bytes$Encode$unsignedInt8(14);
		case 49:
			return $elm$bytes$Bytes$Encode$unsignedInt8(15);
		case 50:
			return $elm$bytes$Bytes$Encode$unsignedInt8(16);
		case 18:
			return $elm$bytes$Bytes$Encode$unsignedInt8(17);
		case 17:
			return $elm$bytes$Bytes$Encode$unsignedInt8(18);
		case 19:
			return $elm$bytes$Bytes$Encode$unsignedInt8(19);
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(20);
		case 55:
			return $elm$bytes$Bytes$Encode$unsignedInt8(21);
		case 14:
			return $elm$bytes$Bytes$Encode$unsignedInt8(22);
		case 13:
			return $elm$bytes$Bytes$Encode$unsignedInt8(23);
		case 53:
			return $elm$bytes$Bytes$Encode$unsignedInt8(24);
		case 47:
			return $elm$bytes$Bytes$Encode$unsignedInt8(25);
		case 26:
			return $elm$bytes$Bytes$Encode$unsignedInt8(26);
		case 58:
			return $elm$bytes$Bytes$Encode$unsignedInt8(27);
		case 57:
			return $elm$bytes$Bytes$Encode$unsignedInt8(28);
		case 73:
			return $elm$bytes$Bytes$Encode$unsignedInt8(29);
		case 70:
			return $elm$bytes$Bytes$Encode$unsignedInt8(30);
		case 71:
			return $elm$bytes$Bytes$Encode$unsignedInt8(31);
		case 69:
			return $elm$bytes$Bytes$Encode$unsignedInt8(32);
		case 75:
			return $elm$bytes$Bytes$Encode$unsignedInt8(33);
		case 21:
			return $elm$bytes$Bytes$Encode$unsignedInt8(34);
		case 62:
			return $elm$bytes$Bytes$Encode$unsignedInt8(35);
		case 83:
			return $elm$bytes$Bytes$Encode$unsignedInt8(36);
		case 61:
			return $elm$bytes$Bytes$Encode$unsignedInt8(37);
		case 72:
			return $elm$bytes$Bytes$Encode$unsignedInt8(38);
		case 25:
			return $elm$bytes$Bytes$Encode$unsignedInt8(39);
		case 84:
			return $elm$bytes$Bytes$Encode$unsignedInt8(40);
		case 90:
			return $elm$bytes$Bytes$Encode$unsignedInt8(41);
		case 60:
			return $elm$bytes$Bytes$Encode$unsignedInt8(42);
		case 59:
			return $elm$bytes$Bytes$Encode$unsignedInt8(43);
		case 81:
			return $elm$bytes$Bytes$Encode$unsignedInt8(44);
		case 23:
			return $elm$bytes$Bytes$Encode$unsignedInt8(45);
		case 44:
			return $elm$bytes$Bytes$Encode$unsignedInt8(46);
		case 79:
			return $elm$bytes$Bytes$Encode$unsignedInt8(47);
		case 74:
			return $elm$bytes$Bytes$Encode$unsignedInt8(48);
		case 67:
			return $elm$bytes$Bytes$Encode$unsignedInt8(49);
		case 24:
			return $elm$bytes$Bytes$Encode$unsignedInt8(50);
		case 31:
			return $elm$bytes$Bytes$Encode$unsignedInt8(51);
		case 32:
			return $elm$bytes$Bytes$Encode$unsignedInt8(52);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(53);
		case 33:
			return $elm$bytes$Bytes$Encode$unsignedInt8(54);
		case 77:
			return $elm$bytes$Bytes$Encode$unsignedInt8(55);
		case 43:
			return $elm$bytes$Bytes$Encode$unsignedInt8(56);
		case 52:
			return $elm$bytes$Bytes$Encode$unsignedInt8(57);
		case 51:
			return $elm$bytes$Bytes$Encode$unsignedInt8(58);
		case 80:
			return $elm$bytes$Bytes$Encode$unsignedInt8(59);
		case 82:
			return $elm$bytes$Bytes$Encode$unsignedInt8(60);
		case 86:
			return $elm$bytes$Bytes$Encode$unsignedInt8(61);
		case 88:
			return $elm$bytes$Bytes$Encode$unsignedInt8(62);
		case 87:
			return $elm$bytes$Bytes$Encode$unsignedInt8(63);
		case 89:
			return $elm$bytes$Bytes$Encode$unsignedInt8(64);
		case 85:
			return $elm$bytes$Bytes$Encode$unsignedInt8(65);
		case 56:
			return $elm$bytes$Bytes$Encode$unsignedInt8(66);
		case 76:
			return $elm$bytes$Bytes$Encode$unsignedInt8(67);
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(68);
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(69);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(70);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(71);
		case 22:
			return $elm$bytes$Bytes$Encode$unsignedInt8(72);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(73);
		case 37:
			return $elm$bytes$Bytes$Encode$unsignedInt8(74);
		case 27:
			return $elm$bytes$Bytes$Encode$unsignedInt8(75);
		case 28:
			return $elm$bytes$Bytes$Encode$unsignedInt8(76);
		case 29:
			return $elm$bytes$Bytes$Encode$unsignedInt8(77);
		case 36:
			return $elm$bytes$Bytes$Encode$unsignedInt8(78);
		case 30:
			return $elm$bytes$Bytes$Encode$unsignedInt8(79);
		case 39:
			return $elm$bytes$Bytes$Encode$unsignedInt8(80);
		case 38:
			return $elm$bytes$Bytes$Encode$unsignedInt8(81);
		case 40:
			return $elm$bytes$Bytes$Encode$unsignedInt8(82);
		case 42:
			return $elm$bytes$Bytes$Encode$unsignedInt8(83);
		case 41:
			return $elm$bytes$Bytes$Encode$unsignedInt8(84);
		case 68:
			return $elm$bytes$Bytes$Encode$unsignedInt8(85);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(86);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(87);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(88);
		case 46:
			return $elm$bytes$Bytes$Encode$unsignedInt8(89);
		case 45:
			return $elm$bytes$Bytes$Encode$unsignedInt8(90);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(91);
	}
};
var $author$project$Evergreen$V417$BackendMsgLog$w3_encode_BackendMsgLogData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$BackendMsgLog$w3_encode_BackendMsgLog(w3_rec_var0.backendMsgLog),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.endTime),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.startTime)
			]));
};
var $author$project$Evergreen$V417$EmailAddress$w3_encode_EmailAddress = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				function (w3_rec_var0) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.domain),
							$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.localPart),
							$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.tags),
							$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.tld)
						]));
			}(v0)
			]));
};
var $author$project$Evergreen$V417$User$w3_encode_BackendUserStatus = function (w3v) {
	if (!w3v.$) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V417$EmailAddress$w3_encode_EmailAddress(v0)
				]));
	}
};
var $author$project$Evergreen$V417$RichText$w3_encode_Domain = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Evergreen$V417$User$w3_encode_EmailNotifications = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$User$w3_encode_EmbedVisibility = function (w3v) {
	if (w3v === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$Emoji$w3_encode_SkinTone = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
	}
};
var $author$project$Evergreen$V417$Emoji$w3_encode_EmojiConfig = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji, w3_rec_var0.lastUsedEmojis),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Emoji$w3_encode_SkinTone, w3_rec_var0.skinTone)
			]));
};
var $author$project$Evergreen$V417$User$w3_encode_LastDmViewed = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId, v0)
					]));
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRoute(v1)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted = function (w3v) {
	switch (w3v) {
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V417$MuteSettings$w3_encode_MutedChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(w3_rec_var0.mutedChannel),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
				$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted,
				w3_rec_var0.mutedThreads)
			]));
};
var $author$project$Evergreen$V417$MuteSettings$w3_encode_MutedDiscordGuild = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_ChannelId),
				$author$project$Evergreen$V417$MuteSettings$w3_encode_MutedChannel,
				w3_rec_var0.channels),
				$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(w3_rec_var0.mutedGuild)
			]));
};
var $author$project$Evergreen$V417$MuteSettings$w3_encode_MutedGuild = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId),
				$author$project$Evergreen$V417$MuteSettings$w3_encode_MutedChannel,
				w3_rec_var0.channels),
				$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(w3_rec_var0.mutedGuild)
			]));
};
var $author$project$Evergreen$V417$MuteSettings$w3_encode_MutedSlackWorkspace = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_ChannelId),
				$author$project$Evergreen$V417$MuteSettings$w3_encode_MutedChannel,
				w3_rec_var0.channels),
				$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(w3_rec_var0.mutedWorkspace)
			]));
};
var $author$project$Evergreen$V417$MuteSettings$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId),
				$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted,
				w3_rec_var0.mutedDiscordDms),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_GuildId),
				$author$project$Evergreen$V417$MuteSettings$w3_encode_MutedDiscordGuild,
				w3_rec_var0.mutedDiscordGuilds),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				$author$project$Evergreen$V417$MuteSettings$w3_encode_MutedChannel,
				w3_rec_var0.mutedDms),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_GuildId),
				$author$project$Evergreen$V417$MuteSettings$w3_encode_MutedGuild,
				w3_rec_var0.mutedGuilds),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_TeamId),
				$author$project$Evergreen$V417$MuteSettings$w3_encode_MutedSlackWorkspace,
				w3_rec_var0.mutedSlackWorkspaces)
			]));
};
var $author$project$Evergreen$V417$Pagination$w3_encode_PageId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$PersonName$w3_encode_PersonName = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v0)
			]));
};
var $author$project$Evergreen$V417$X25519$w3_encode_Key = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.w0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.w1),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.w2),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.w3),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.w4),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.w5),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.w6),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.w7)
			]));
};
var $author$project$Evergreen$V417$X25519$w3_encode_PublicKey = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$author$project$Evergreen$V417$X25519$w3_encode_Key(v0)
			]));
};
var $author$project$Evergreen$V417$UserColor$w3_encode_UserColor = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Evergreen$V417$User$w3_encode_BackendUser = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_CustomEmojiId),
				w3_rec_var0.availableCustomEmojis),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_StickerId),
				w3_rec_var0.availableStickers),
				$author$project$Evergreen$V417$UserColor$w3_encode_UserColor(w3_rec_var0.color),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.createdAt),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.deleteAccountAt),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_GuildId),
				A2(
					$author$project$Evergreen$V417$NonemptyDict$w3_encode_NonemptyDict,
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRoute),
					$author$project$Evergreen$V417$OneOrGreater$w3_encode_OneOrGreater),
				w3_rec_var0.directMentions),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_GuildId),
				A2(
					$author$project$Evergreen$V417$NonemptyDict$w3_encode_NonemptyDict,
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_ChannelId),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRoute),
					$author$project$Evergreen$V417$OneOrGreater$w3_encode_OneOrGreater),
				w3_rec_var0.discordDirectMentions),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_GuildId),
				w3_rec_var0.discordNotifyOnAllMessages),
				$lamdera$containers$SeqSet$encodeSet$($author$project$Evergreen$V417$RichText$w3_encode_Domain, w3_rec_var0.domainWhitelist),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.e2eeRisksAccepted),
				$author$project$Evergreen$V417$User$w3_encode_BackendUserStatus(w3_rec_var0.email),
				$author$project$Evergreen$V417$User$w3_encode_EmailNotifications(w3_rec_var0.emailNotifications),
				$author$project$Evergreen$V417$User$w3_encode_EmbedVisibility(w3_rec_var0.embedVisibility),
				$author$project$Evergreen$V417$Emoji$w3_encode_EmojiConfig(w3_rec_var0.emojiConfig),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isAdmin),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_GuildId),
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId),
					$author$project$Evergreen$V417$Id$w3_encode_ThreadRoute),
				w3_rec_var0.lastChannelViewed),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_GuildId),
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_ChannelId),
					$author$project$Evergreen$V417$Id$w3_encode_ThreadRoute),
				w3_rec_var0.lastDiscordChannelViewed),
				$author$project$Evergreen$V417$User$w3_encode_LastDmViewed(w3_rec_var0.lastDmViewed),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.lastEmailNotification),
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Pagination$w3_encode_PageId, w3_rec_var0.lastLogPageViewed),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.lastPushNotification),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_TeamId),
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_ChannelId),
					$author$project$Evergreen$V417$Id$w3_encode_ThreadRoute),
				w3_rec_var0.lastSlackChannelViewed),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId,
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
				w3_rec_var0.lastViewedMessage),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId)),
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId),
				w3_rec_var0.lastViewedThreadMessage),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.linkDiscordAcknowledgementIsChecked),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.linkSlackAcknowledgementIsChecked),
				$author$project$Evergreen$V417$MuteSettings$w3_encode_Model(w3_rec_var0.muteSettings),
				$author$project$Evergreen$V417$PersonName$w3_encode_PersonName(w3_rec_var0.name),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_GuildId),
				w3_rec_var0.notifyOnAllMessages),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$X25519$w3_encode_PublicKey, w3_rec_var0.publicKey),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.recentLoginEmails),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_TeamId),
				A2(
					$author$project$Evergreen$V417$NonemptyDict$w3_encode_NonemptyDict,
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_ChannelId),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRoute),
					$author$project$Evergreen$V417$OneOrGreater$w3_encode_OneOrGreater),
				w3_rec_var0.slackDirectMentions),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_TeamId),
				w3_rec_var0.slackNotifyOnAllMessages)
			]));
};
var $author$project$Evergreen$V417$LocalState$w3_encode_DiscordGatewayStatus = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.failedReconnectAttempts),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.websocketIsOpen)
			]));
};
var $author$project$Evergreen$V417$DiscordUserData$w3_encode_DiscordUserLoadingData = function (w3v) {
	switch (w3v.$) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0)
					]));
	}
};
var $author$project$Evergreen$V417$Discord$w3_encode_AvatarHash = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$Discord$w3_encode_ImageHash$ = function (w3_x_c_hashType, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Evergreen$V417$Discord$w3_encode_ImageHash = F2($author$project$Evergreen$V417$Discord$w3_encode_ImageHash$);
var $author$project$Evergreen$V417$Discord$w3_encode_UserDiscriminator = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Evergreen$V417$Discord$w3_encode_PartialUser = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V417$Discord$w3_encode_ImageHash($author$project$Evergreen$V417$Discord$w3_encode_AvatarHash),
				w3_rec_var0.avatar),
				$author$project$Evergreen$V417$Discord$w3_encode_UserDiscriminator(w3_rec_var0.discriminator),
				$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, w3_rec_var0.id),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.username)
			]));
};
var $author$project$Evergreen$V417$Discord$w3_encode_OptionalData$ = function (w3_x_c_a, w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					w3_x_c_a(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$Discord$w3_encode_OptionalData = F2($author$project$Evergreen$V417$Discord$w3_encode_OptionalData$);
var $author$project$Evergreen$V417$Discord$w3_encode_User = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V417$Discord$w3_encode_ImageHash($author$project$Evergreen$V417$Discord$w3_encode_AvatarHash),
				w3_rec_var0.avatar),
				$author$project$Evergreen$V417$Discord$w3_encode_OptionalData$($lamdera$codecs$Lamdera$Wire3$encodeBool, w3_rec_var0.bot),
				$author$project$Evergreen$V417$Discord$w3_encode_UserDiscriminator(w3_rec_var0.discriminator),
				$author$project$Evergreen$V417$Discord$w3_encode_OptionalData$(
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$codecs$Lamdera$Wire3$encodeString),
				w3_rec_var0.email),
				$author$project$Evergreen$V417$Discord$w3_encode_OptionalData$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.flags),
				$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, w3_rec_var0.id),
				$author$project$Evergreen$V417$Discord$w3_encode_OptionalData$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.locale),
				$author$project$Evergreen$V417$Discord$w3_encode_OptionalData$($lamdera$codecs$Lamdera$Wire3$encodeBool, w3_rec_var0.mfaEnabled),
				$author$project$Evergreen$V417$Discord$w3_encode_OptionalData$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.premiumType),
				$author$project$Evergreen$V417$Discord$w3_encode_OptionalData$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.publicFlags),
				$author$project$Evergreen$V417$Discord$w3_encode_OptionalData$($lamdera$codecs$Lamdera$Wire3$encodeBool, w3_rec_var0.system),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.username),
				$author$project$Evergreen$V417$Discord$w3_encode_OptionalData$($lamdera$codecs$Lamdera$Wire3$encodeBool, w3_rec_var0.verified)
			]));
};
var $author$project$Evergreen$V417$LocalState$w3_encode_DiscordUserData_ForAdmin = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
									$author$project$Evergreen$V417$Discord$w3_encode_PartialUser(w3_rec_var0.user)
								]));
					}(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Evergreen$V417$LocalState$w3_encode_DiscordGatewayStatus(w3_rec_var0.gateway),
									$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
									$author$project$Evergreen$V417$DiscordUserData$w3_encode_DiscordUserLoadingData(w3_rec_var0.isLoadingData),
									$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.linkedAt),
									$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, w3_rec_var0.linkedTo),
									$author$project$Evergreen$V417$Discord$w3_encode_User(w3_rec_var0.user)
								]));
					}(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
									$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.linkedAt),
									$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, w3_rec_var0.linkedTo),
									$author$project$Evergreen$V417$Discord$w3_encode_User(w3_rec_var0.user)
								]));
					}(v0)
					]));
	}
};
var $author$project$Evergreen$V417$DmChannelId$w3_encode_DmChannelId = function (w3v) {
	var v0 = w3v.a;
	var v1 = w3v.b;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0),
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v1)
			]));
};
var $author$project$Evergreen$V417$Pages$Admin$w3_encode_EditedBackendUser = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.createdAt),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.deleteAccountAt),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.email),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isAdmin),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name)
			]));
};
var $author$project$Evergreen$V417$Discord$w3_encode_ErrorCode = function (w3v) {
	switch (w3v) {
		case 65:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 24:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 44:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 42:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 58:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 45:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 47:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 46:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 48:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 38:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 43:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		case 41:
			return $elm$bytes$Bytes$Encode$unsignedInt8(12);
		case 63:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
		case 53:
			return $elm$bytes$Bytes$Encode$unsignedInt8(14);
		case 61:
			return $elm$bytes$Bytes$Encode$unsignedInt8(15);
		case 59:
			return $elm$bytes$Bytes$Encode$unsignedInt8(16);
		case 51:
			return $elm$bytes$Bytes$Encode$unsignedInt8(17);
		case 57:
			return $elm$bytes$Bytes$Encode$unsignedInt8(18);
		case 62:
			return $elm$bytes$Bytes$Encode$unsignedInt8(19);
		case 33:
			return $elm$bytes$Bytes$Encode$unsignedInt8(20);
		case 27:
			return $elm$bytes$Bytes$Encode$unsignedInt8(21);
		case 32:
			return $elm$bytes$Bytes$Encode$unsignedInt8(22);
		case 26:
			return $elm$bytes$Bytes$Encode$unsignedInt8(23);
		case 29:
			return $elm$bytes$Bytes$Encode$unsignedInt8(24);
		case 34:
			return $elm$bytes$Bytes$Encode$unsignedInt8(25);
		case 28:
			return $elm$bytes$Bytes$Encode$unsignedInt8(26);
		case 31:
			return $elm$bytes$Bytes$Encode$unsignedInt8(27);
		case 30:
			return $elm$bytes$Bytes$Encode$unsignedInt8(28);
		case 56:
			return $elm$bytes$Bytes$Encode$unsignedInt8(29);
		case 60:
			return $elm$bytes$Bytes$Encode$unsignedInt8(30);
		case 40:
			return $elm$bytes$Bytes$Encode$unsignedInt8(31);
		case 54:
			return $elm$bytes$Bytes$Encode$unsignedInt8(32);
		case 49:
			return $elm$bytes$Bytes$Encode$unsignedInt8(33);
		case 50:
			return $elm$bytes$Bytes$Encode$unsignedInt8(34);
		case 25:
			return $elm$bytes$Bytes$Encode$unsignedInt8(35);
		case 55:
			return $elm$bytes$Bytes$Encode$unsignedInt8(36);
		case 64:
			return $elm$bytes$Bytes$Encode$unsignedInt8(37);
		case 37:
			return $elm$bytes$Bytes$Encode$unsignedInt8(38);
		case 35:
			return $elm$bytes$Bytes$Encode$unsignedInt8(39);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(40);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(41);
		case 16:
			return $elm$bytes$Bytes$Encode$unsignedInt8(42);
		case 22:
			return $elm$bytes$Bytes$Encode$unsignedInt8(43);
		case 20:
			return $elm$bytes$Bytes$Encode$unsignedInt8(44);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(45);
		case 14:
			return $elm$bytes$Bytes$Encode$unsignedInt8(46);
		case 19:
			return $elm$bytes$Bytes$Encode$unsignedInt8(47);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(48);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(49);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(50);
		case 21:
			return $elm$bytes$Bytes$Encode$unsignedInt8(51);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(52);
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(53);
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(54);
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(55);
		case 23:
			return $elm$bytes$Bytes$Encode$unsignedInt8(56);
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(57);
		case 17:
			return $elm$bytes$Bytes$Encode$unsignedInt8(58);
		case 18:
			return $elm$bytes$Bytes$Encode$unsignedInt8(59);
		case 12:
			return $elm$bytes$Bytes$Encode$unsignedInt8(60);
		case 13:
			return $elm$bytes$Bytes$Encode$unsignedInt8(61);
		case 15:
			return $elm$bytes$Bytes$Encode$unsignedInt8(62);
		case 39:
			return $elm$bytes$Bytes$Encode$unsignedInt8(63);
		case 36:
			return $elm$bytes$Bytes$Encode$unsignedInt8(64);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(65);
	}
};
var $author$project$Evergreen$V417$Discord$w3_encode_RateLimit = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isGlobal),
				$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var0.retryAfter)
			]));
};
var $author$project$Evergreen$V417$Discord$w3_encode_HttpError = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Discord$w3_encode_ErrorCode(v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$Discord$w3_encode_ErrorCode(v0)
					]));
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$Discord$w3_encode_ErrorCode(v0)
					]));
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V417$Discord$w3_encode_ErrorCode(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V417$Discord$w3_encode_ErrorCode(v0)
					]));
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Evergreen$V417$Discord$w3_encode_ErrorCode(w3_rec_var0.errorCode),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.statusCode)
								]));
					}(v0)
					]));
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Evergreen$V417$Discord$w3_encode_RateLimit(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V417$Discord$w3_encode_ErrorCode(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
	}
};
var $lamdera$codecs$Lamdera$Wire3$encodeUnit = function (_v0) {
	return $elm$bytes$Bytes$Encode$sequence(_List_Nil);
};
var $author$project$Evergreen$V417$Slack$w3_encode_HttpError = function (w3v) {
	switch (w3v.$) {
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
	}
};
var $author$project$Evergreen$V417$Discord$w3_encode_MessageId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$Postmark$w3_encode_PostmarkSendResponse = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.errorCode),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.message),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V417$EmailAddress$w3_encode_EmailAddress, w3_rec_var0.to)
			]));
};
var $author$project$Evergreen$V417$Postmark$w3_encode_SendEmailError = function (w3v) {
	switch (w3v.$) {
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$Postmark$w3_encode_PostmarkSendResponse(v0)
					]));
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.body),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.statusCode)
								]));
					}(v0)
					]));
	}
};
var $author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMaybeMessage = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
					v0)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v0),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId),
					v1)
				]));
	}
};
var $author$project$Evergreen$V417$Log$w3_encode_Log = function (w3v) {
	switch (w3v.$) {
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0)
					]));
		case 36:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 22:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 11:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_MessageId, v2),
						$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji(v3),
						$author$project$Evergreen$V417$Discord$w3_encode_HttpError(v4)
					]));
		case 10:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v2),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_MessageId, v3),
						$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji(v4),
						$author$project$Evergreen$V417$Discord$w3_encode_HttpError(v5)
					]));
		case 32:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V417$Id$w3_encode_SlackGuildOrDmId(v0),
						$author$project$Evergreen$V417$Slack$w3_encode_HttpError(v1)
					]));
		case 7:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_MessageId, v2),
						$author$project$Evergreen$V417$Discord$w3_encode_HttpError(v3)
					]));
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v2),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_MessageId, v3),
						$author$project$Evergreen$V417$Discord$w3_encode_HttpError(v4)
					]));
		case 28:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v0)
					]));
		case 33:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V417$Id$w3_encode_SlackGuildOrDmId(v0),
						$author$project$Evergreen$V417$Slack$w3_encode_HttpError(v1)
					]));
		case 9:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_MessageId, v2),
						$author$project$Evergreen$V417$Discord$w3_encode_HttpError(v3)
					]));
		case 8:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v2),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_MessageId, v3),
						$author$project$Evergreen$V417$Discord$w3_encode_HttpError(v4)
					]));
		case 34:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$Evergreen$V417$Id$w3_encode_SlackGuildOrDmId(v0),
						$author$project$Evergreen$V417$Slack$w3_encode_HttpError(v1)
					]));
		case 26:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1)
					]));
		case 19:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V417$Discord$w3_encode_HttpError(v2)
					]));
		case 17:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$author$project$Evergreen$V417$Discord$w3_encode_HttpError(v0)
					]));
		case 25:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2(
							$lamdera$codecs$Lamdera$Wire3$encodePair,
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_CustomEmojiId),
							$lamdera$program_test$Effect$Http$w3_encode_Error),
						v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1)
					]));
		case 23:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2(
							$lamdera$codecs$Lamdera$Wire3$encodePair,
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_StickerId),
							$lamdera$program_test$Effect$Http$w3_encode_Error),
						v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1)
					]));
		case 24:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$author$project$Evergreen$V417$Discord$w3_encode_HttpError(v0)
					]));
		case 14:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(19),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_HttpError(v1)
					]));
		case 29:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(20),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_TeamId, v0),
						$author$project$Evergreen$V417$Slack$w3_encode_HttpError(v1)
					]));
		case 30:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(21),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_TeamId, v0),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2(
							$lamdera$codecs$Lamdera$Wire3$encodePair,
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_CustomEmojiId),
							$lamdera$program_test$Effect$Http$w3_encode_Error),
						v1),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v2)
					]));
		case 18:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(22),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 27:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(23),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v0)
					]));
		case 20:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(24),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_HttpError(v1)
					]));
		case 13:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(25),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_MessageId, v2),
						$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji(v3),
						$author$project$Evergreen$V417$Discord$w3_encode_HttpError(v4)
					]));
		case 12:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(26),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v2),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_MessageId, v3),
						$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji(v4),
						$author$project$Evergreen$V417$Discord$w3_encode_HttpError(v5)
					]));
		case 16:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(27),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId, v1),
						$author$project$Evergreen$V417$Discord$w3_encode_HttpError(v2)
					]));
		case 15:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(28),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, v2),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMaybeMessage(v3),
						$author$project$Evergreen$V417$Discord$w3_encode_HttpError(v4)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(29),
						$author$project$Evergreen$V417$Postmark$w3_encode_SendEmailError(v0),
						$author$project$Evergreen$V417$EmailAddress$w3_encode_EmailAddress(v1)
					]));
		case 31:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(30),
						$author$project$Evergreen$V417$Id$w3_encode_SlackGuildOrDmId(v0),
						$author$project$Evergreen$V417$Slack$w3_encode_HttpError(v1)
					]));
		case 21:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(31),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_HttpError(v1)
					]));
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(32),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($author$project$Evergreen$V417$Postmark$w3_encode_SendEmailError, $lamdera$codecs$Lamdera$Wire3$encodeUnit, v0),
						$author$project$Evergreen$V417$EmailAddress$w3_encode_EmailAddress(v1)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(33),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0)
					]));
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(34),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v1)
					]));
		case 35:
			return $elm$bytes$Bytes$Encode$unsignedInt8(35);
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(36),
						$author$project$Evergreen$V417$Postmark$w3_encode_SendEmailError(v0),
						$author$project$Evergreen$V417$EmailAddress$w3_encode_EmailAddress(v1)
					]));
	}
};
var $author$project$Evergreen$V417$LocalState$w3_encode_LogWithTime = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Log$w3_encode_Log(w3_rec_var0.log),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.time)
			]));
};
var $author$project$Evergreen$V417$LocalState$w3_encode_PrivateVapidKey = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Evergreen$V417$Discord$w3_encode_RoleColors = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.primaryColor),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.secondaryColor),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.tertiaryColor)
			]));
};
var $author$project$Evergreen$V417$Discord$w3_encode_RoleIconHash = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$Discord$w3_encode_IntegrationId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$Discord$w3_encode_SubscriptionListingId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$Discord$w3_encode_RoleTags = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.availableForPurchase),
				$author$project$Evergreen$V417$Discord$w3_encode_OptionalData$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
				w3_rec_var0.botId),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.guildConnections),
				$author$project$Evergreen$V417$Discord$w3_encode_OptionalData$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_IntegrationId),
				w3_rec_var0.integrationId),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.premiumSubscriber),
				$author$project$Evergreen$V417$Discord$w3_encode_OptionalData$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_SubscriptionListingId),
				w3_rec_var0.subscriptionListingId)
			]));
};
var $author$project$Evergreen$V417$Discord$w3_encode_Role = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Discord$w3_encode_OptionalData$($author$project$Evergreen$V417$Discord$w3_encode_RoleColors, w3_rec_var0.colors),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.description),
				$author$project$Evergreen$V417$Discord$w3_encode_OptionalData$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.flags),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.hoist),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V417$Discord$w3_encode_ImageHash($author$project$Evergreen$V417$Discord$w3_encode_RoleIconHash),
				w3_rec_var0.icon),
				$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_RoleId, w3_rec_var0.id),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.managed),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.mentionable),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
				$author$project$Evergreen$V417$Discord$w3_encode_Permissions(w3_rec_var0.permissions),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.position),
				$author$project$Evergreen$V417$Discord$w3_encode_OptionalData$($author$project$Evergreen$V417$Discord$w3_encode_RoleTags, w3_rec_var0.tags),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.unicodeEmoji)
			]));
};
var $author$project$Evergreen$V417$SessionIdHash$w3_encode_SessionIdHash = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Evergreen$V417$ToBackendLog$w3_encode_ToBackendLog = function (w3v) {
	switch (w3v) {
		case 15:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 17:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 16:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 18:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		case 12:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 13:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		case 95:
			return $elm$bytes$Bytes$Encode$unsignedInt8(12);
		case 73:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
		case 38:
			return $elm$bytes$Bytes$Encode$unsignedInt8(14);
		case 20:
			return $elm$bytes$Bytes$Encode$unsignedInt8(15);
		case 35:
			return $elm$bytes$Bytes$Encode$unsignedInt8(16);
		case 63:
			return $elm$bytes$Bytes$Encode$unsignedInt8(17);
		case 88:
			return $elm$bytes$Bytes$Encode$unsignedInt8(18);
		case 59:
			return $elm$bytes$Bytes$Encode$unsignedInt8(19);
		case 46:
			return $elm$bytes$Bytes$Encode$unsignedInt8(20);
		case 89:
			return $elm$bytes$Bytes$Encode$unsignedInt8(21);
		case 93:
			return $elm$bytes$Bytes$Encode$unsignedInt8(22);
		case 29:
			return $elm$bytes$Bytes$Encode$unsignedInt8(23);
		case 31:
			return $elm$bytes$Bytes$Encode$unsignedInt8(24);
		case 34:
			return $elm$bytes$Bytes$Encode$unsignedInt8(25);
		case 45:
			return $elm$bytes$Bytes$Encode$unsignedInt8(26);
		case 92:
			return $elm$bytes$Bytes$Encode$unsignedInt8(27);
		case 50:
			return $elm$bytes$Bytes$Encode$unsignedInt8(28);
		case 53:
			return $elm$bytes$Bytes$Encode$unsignedInt8(29);
		case 42:
			return $elm$bytes$Bytes$Encode$unsignedInt8(30);
		case 41:
			return $elm$bytes$Bytes$Encode$unsignedInt8(31);
		case 22:
			return $elm$bytes$Bytes$Encode$unsignedInt8(32);
		case 76:
			return $elm$bytes$Bytes$Encode$unsignedInt8(33);
		case 28:
			return $elm$bytes$Bytes$Encode$unsignedInt8(34);
		case 30:
			return $elm$bytes$Bytes$Encode$unsignedInt8(35);
		case 91:
			return $elm$bytes$Bytes$Encode$unsignedInt8(36);
		case 57:
			return $elm$bytes$Bytes$Encode$unsignedInt8(37);
		case 75:
			return $elm$bytes$Bytes$Encode$unsignedInt8(38);
		case 19:
			return $elm$bytes$Bytes$Encode$unsignedInt8(39);
		case 32:
			return $elm$bytes$Bytes$Encode$unsignedInt8(40);
		case 68:
			return $elm$bytes$Bytes$Encode$unsignedInt8(41);
		case 69:
			return $elm$bytes$Bytes$Encode$unsignedInt8(42);
		case 48:
			return $elm$bytes$Bytes$Encode$unsignedInt8(43);
		case 49:
			return $elm$bytes$Bytes$Encode$unsignedInt8(44);
		case 43:
			return $elm$bytes$Bytes$Encode$unsignedInt8(45);
		case 37:
			return $elm$bytes$Bytes$Encode$unsignedInt8(46);
		case 27:
			return $elm$bytes$Bytes$Encode$unsignedInt8(47);
		case 36:
			return $elm$bytes$Bytes$Encode$unsignedInt8(48);
		case 33:
			return $elm$bytes$Bytes$Encode$unsignedInt8(49);
		case 64:
			return $elm$bytes$Bytes$Encode$unsignedInt8(50);
		case 39:
			return $elm$bytes$Bytes$Encode$unsignedInt8(51);
		case 87:
			return $elm$bytes$Bytes$Encode$unsignedInt8(52);
		case 62:
			return $elm$bytes$Bytes$Encode$unsignedInt8(53);
		case 40:
			return $elm$bytes$Bytes$Encode$unsignedInt8(54);
		case 97:
			return $elm$bytes$Bytes$Encode$unsignedInt8(55);
		case 96:
			return $elm$bytes$Bytes$Encode$unsignedInt8(56);
		case 21:
			return $elm$bytes$Bytes$Encode$unsignedInt8(57);
		case 55:
			return $elm$bytes$Bytes$Encode$unsignedInt8(58);
		case 70:
			return $elm$bytes$Bytes$Encode$unsignedInt8(59);
		case 94:
			return $elm$bytes$Bytes$Encode$unsignedInt8(60);
		case 60:
			return $elm$bytes$Bytes$Encode$unsignedInt8(61);
		case 61:
			return $elm$bytes$Bytes$Encode$unsignedInt8(62);
		case 71:
			return $elm$bytes$Bytes$Encode$unsignedInt8(63);
		case 54:
			return $elm$bytes$Bytes$Encode$unsignedInt8(64);
		case 44:
			return $elm$bytes$Bytes$Encode$unsignedInt8(65);
		case 77:
			return $elm$bytes$Bytes$Encode$unsignedInt8(66);
		case 79:
			return $elm$bytes$Bytes$Encode$unsignedInt8(67);
		case 82:
			return $elm$bytes$Bytes$Encode$unsignedInt8(68);
		case 80:
			return $elm$bytes$Bytes$Encode$unsignedInt8(69);
		case 81:
			return $elm$bytes$Bytes$Encode$unsignedInt8(70);
		case 85:
			return $elm$bytes$Bytes$Encode$unsignedInt8(71);
		case 86:
			return $elm$bytes$Bytes$Encode$unsignedInt8(72);
		case 84:
			return $elm$bytes$Bytes$Encode$unsignedInt8(73);
		case 78:
			return $elm$bytes$Bytes$Encode$unsignedInt8(74);
		case 47:
			return $elm$bytes$Bytes$Encode$unsignedInt8(75);
		case 56:
			return $elm$bytes$Bytes$Encode$unsignedInt8(76);
		case 90:
			return $elm$bytes$Bytes$Encode$unsignedInt8(77);
		case 58:
			return $elm$bytes$Bytes$Encode$unsignedInt8(78);
		case 83:
			return $elm$bytes$Bytes$Encode$unsignedInt8(79);
		case 72:
			return $elm$bytes$Bytes$Encode$unsignedInt8(80);
		case 51:
			return $elm$bytes$Bytes$Encode$unsignedInt8(81);
		case 52:
			return $elm$bytes$Bytes$Encode$unsignedInt8(82);
		case 26:
			return $elm$bytes$Bytes$Encode$unsignedInt8(83);
		case 24:
			return $elm$bytes$Bytes$Encode$unsignedInt8(84);
		case 23:
			return $elm$bytes$Bytes$Encode$unsignedInt8(85);
		case 25:
			return $elm$bytes$Bytes$Encode$unsignedInt8(86);
		case 67:
			return $elm$bytes$Bytes$Encode$unsignedInt8(87);
		case 65:
			return $elm$bytes$Bytes$Encode$unsignedInt8(88);
		case 66:
			return $elm$bytes$Bytes$Encode$unsignedInt8(89);
		case 74:
			return $elm$bytes$Bytes$Encode$unsignedInt8(90);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(91);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(92);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(93);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(94);
		case 14:
			return $elm$bytes$Bytes$Encode$unsignedInt8(95);
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(96);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(97);
	}
};
var $author$project$Evergreen$V417$ToBackendLog$w3_encode_ToBackendLogData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.endTime),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.startTime),
				$author$project$Evergreen$V417$ToBackendLog$w3_encode_ToBackendLog(w3_rec_var0.toBackendLog),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				w3_rec_var0.userId)
			]));
};
var $author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$ = function (w3_x_c_a, w3v) {
	if (!w3v.$) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					w3_x_c_a(v0)
				]));
	}
};
var $author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend = F2($author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$);
var $author$project$Evergreen$V417$IdArray$w3_encode_IdArray$ = function (w3_x_c_k, w3_x_c_v, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeArray$(w3_x_c_v, v0)
			]));
};
var $author$project$Evergreen$V417$IdArray$w3_encode_IdArray = F3($author$project$Evergreen$V417$IdArray$w3_encode_IdArray$);
var $author$project$Evergreen$V417$UserSession$w3_encode_LastViewedGuild = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_TeamId, v0)
					]));
	}
};
var $author$project$Evergreen$V417$UserSession$w3_encode_NotificationMode = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V417$Ports$w3_encode_SubscribeKeys = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.auth),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.p256dh)
			]));
};
var $author$project$Evergreen$V417$Ports$w3_encode_SubscribeData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$url$Url$w3_encode_Url(w3_rec_var0.endpoint),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				function (t) {
					return $lamdera$codecs$Lamdera$Wire3$encodeInt(
						$elm$time$Time$posixToMillis(t));
				},
				w3_rec_var0.expirationTime),
				$author$project$Evergreen$V417$Ports$w3_encode_SubscribeKeys(w3_rec_var0.keys)
			]));
};
var $author$project$Evergreen$V417$UserSession$w3_encode_PushSubscription = function (w3v) {
	switch (w3v.$) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$Ports$w3_encode_SubscribeData(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v1)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$Ports$w3_encode_SubscribeData(v0),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v1)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v1)
					]));
	}
};
var $author$project$Evergreen$V417$UserSession$w3_encode_SheepGameQuestion = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$FileStatus$w3_encode_FileId),
				$author$project$Evergreen$V417$FileStatus$w3_encode_FileStatus,
				w3_rec_var0.attachedFiles),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.text)
			]));
};
var $author$project$Evergreen$V417$UserAgent$w3_encode_Browser = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
	}
};
var $author$project$Evergreen$V417$UserAgent$w3_encode_Device = function (w3v) {
	switch (w3v) {
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
	}
};
var $author$project$Evergreen$V417$UserAgent$w3_encode_UserAgent = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$UserAgent$w3_encode_Browser(w3_rec_var0.browser),
				$author$project$Evergreen$V417$UserAgent$w3_encode_Device(w3_rec_var0.device)
			]));
};
var $author$project$Evergreen$V417$UserSession$w3_encode_UserOptionSection = function (w3v) {
	switch (w3v) {
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
	}
};
var $author$project$Evergreen$V417$UserSession$w3_encode_UserSession = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqSet$encodeSet$($author$project$Evergreen$V417$UserSession$w3_encode_UserOptionSection, w3_rec_var0.expandedUserOptions),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.lastClientDisconnect),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$UserSession$w3_encode_LastViewedGuild, w3_rec_var0.lastViewedGuild),
				$author$project$Evergreen$V417$UserSession$w3_encode_NotificationMode(w3_rec_var0.notificationMode),
				$author$project$Evergreen$V417$UserSession$w3_encode_PushSubscription(w3_rec_var0.pushSubscription),
				$author$project$Evergreen$V417$IdArray$w3_encode_IdArray$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, $author$project$Evergreen$V417$UserSession$w3_encode_SheepGameQuestion, w3_rec_var0.savedSheepGameQuestions),
				$author$project$Evergreen$V417$SessionIdHash$w3_encode_SessionIdHash(w3_rec_var0.sessionIdHash),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.signedInAt),
				$author$project$Evergreen$V417$UserAgent$w3_encode_UserAgent(w3_rec_var0.userAgent),
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, w3_rec_var0.userId)
			]));
};
var $lamdera$program_test$Effect$Websocket$w3_encode_CloseEventCode = function (w3v) {
	switch (w3v.$) {
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 13:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		case 14:
			return $elm$bytes$Bytes$Encode$unsignedInt8(12);
		case 12:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
		case 15:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(15);
	}
};
var $author$project$Evergreen$V417$LocalState$w3_encode_WebsocketClosedEvent = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v1)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v1)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$lamdera$program_test$Effect$Websocket$w3_encode_CloseEventCode(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v2),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v3)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v1)
					]));
	}
};
var $author$project$Evergreen$V417$Pages$Admin$w3_encode_AdminChange = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$containers$SeqDict$encodeDict$(
									$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
									$author$project$Evergreen$V417$Pages$Admin$w3_encode_EditedBackendUser,
									w3_rec_var0.changedUsers),
									$lamdera$containers$SeqSet$encodeSet$(
									$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
									w3_rec_var0.deletedUsers),
									$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Evergreen$V417$Pages$Admin$w3_encode_EditedBackendUser, w3_rec_var0.newUsers),
									$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.time)
								]));
					}(v0)
					]));
		case 28:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId, v0)
					]));
		case 29:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v0)
					]));
		case 32:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0)
					]));
		case 40:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$codecs$Lamdera$Wire3$encodeResult,
							$lamdera$program_test$Effect$Http$w3_encode_Error,
							$lamdera$codecs$Lamdera$Wire3$encodeList($author$project$Evergreen$V417$FileStatus$w3_encode_FileHash)),
						v0)
					]));
		case 38:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V417$SessionIdHash$w3_encode_SessionIdHash(v0)
					]));
		case 31:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_DmChannelId, v0)
					]));
		case 30:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_TeamId, v0)
					]));
		case 37:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Evergreen$V417$SessionIdHash$w3_encode_SessionIdHash(v0),
						$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId(v1)
					]));
		case 15:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						$lamdera$codecs$Lamdera$Wire3$encodeArray($author$project$Evergreen$V417$BackendMsgLog$w3_encode_BackendMsgLogData),
						v0)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_GuildId),
							$author$project$Evergreen$V417$LocalState$w3_encode_AdminData_DeletedGuild),
						v0)
					]));
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId),
							$author$project$Evergreen$V417$LocalState$w3_encode_AdminData_DiscordDmChannel),
						v0)
					]));
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_GuildId),
							$author$project$Evergreen$V417$LocalState$w3_encode_AdminData_DiscordGuild),
						v0)
					]));
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
							$author$project$Evergreen$V417$LocalState$w3_encode_DiscordUserData_ForAdmin),
						v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2($lamdera$containers$SeqDict$encodeDict, $author$project$Evergreen$V417$DmChannelId$w3_encode_DmChannelId, $author$project$Evergreen$V417$LocalState$w3_encode_AdminData_DmChannel),
						v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_GuildId),
							$author$project$Evergreen$V417$LocalState$w3_encode_AdminData_Guild),
						v0)
					]));
		case 13:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2($lamdera$containers$SeqDict$encodeDict, $author$project$Evergreen$V417$FileStatus$w3_encode_FileHash, $author$project$Evergreen$V417$FileStatus$w3_encode_BackendFileData),
						v0)
					]));
		case 11:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2($lamdera$containers$SeqDict$encodeDict, $author$project$Evergreen$V417$SessionIdHash$w3_encode_SessionIdHash, $author$project$Evergreen$V417$UserSession$w3_encode_UserSession),
						v0)
					]));
		case 10:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_DmChannelId),
							$author$project$Evergreen$V417$LocalState$w3_encode_AdminData_SlackDmChannel),
						v0)
					]));
		case 9:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(19),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_TeamId),
							$author$project$Evergreen$V417$LocalState$w3_encode_AdminData_SlackWorkspace),
						v0)
					]));
		case 14:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(20),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						$lamdera$codecs$Lamdera$Wire3$encodeArray($author$project$Evergreen$V417$ToBackendLog$w3_encode_ToBackendLogData),
						v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(21),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$author$project$Evergreen$V417$NonemptyDict$w3_encode_NonemptyDict,
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
							$author$project$Evergreen$V417$User$w3_encode_BackendUser),
						v0)
					]));
		case 12:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(22),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						$lamdera$codecs$Lamdera$Wire3$encodeArray($author$project$Evergreen$V417$LocalState$w3_encode_WebsocketClosedEvent),
						v0)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(23),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Pagination$w3_encode_PageId, v0),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						$lamdera$codecs$Lamdera$Wire3$encodeArray($author$project$Evergreen$V417$LocalState$w3_encode_LogWithTime),
						v1)
					]));
		case 39:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(24),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2($lamdera$codecs$Lamdera$Wire3$encodeResult, $lamdera$program_test$Effect$Http$w3_encode_Error, $lamdera$program_test$Effect$Time$w3_encode_Posix),
						v0)
					]));
		case 36:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(25),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$codecs$Lamdera$Wire3$encodeResult,
							$author$project$Evergreen$V417$Discord$w3_encode_HttpError,
							$lamdera$codecs$Lamdera$Wire3$encodeList($author$project$Evergreen$V417$Discord$w3_encode_Role)),
						v2)
					]));
		case 33:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(26),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0)
					]));
		case 19:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(27),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, v0)
					]));
		case 18:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(28),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 16:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(29),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 26:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(30),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
						v0)
					]));
		case 25:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(31),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v0)
					]));
		case 24:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(32),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v0)
					]));
		case 27:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(33),
						$author$project$Evergreen$V417$Postmark$w3_encode_ApiKey(v0)
					]));
		case 22:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(34),
						$author$project$Evergreen$V417$LocalState$w3_encode_PrivateVapidKey(v0)
					]));
		case 23:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(35),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 17:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(36),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 21:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(37),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, v0)
					]));
		case 20:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(38),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 35:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(39),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v1),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId, v2)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(40),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v1),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v2),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, v3)
					]));
	}
};
var $justinmimbs$date$Date$w3_encode_RataDie = $lamdera$codecs$Lamdera$Wire3$encodeInt;
var $justinmimbs$date$Date$w3_encode_Date = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$justinmimbs$date$Date$w3_encode_RataDie(v0)
			]));
};
var $author$project$Evergreen$V417$Drawing$w3_encode_MessageAnchor = function (w3v) {
	switch (w3v.$) {
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$FileStatus$w3_encode_FileId, v0)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
	}
};
var $author$project$Evergreen$V417$Drawing$w3_encode_AnchorType = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$Id$w3_encode_ThreadRoute(v0),
					$justinmimbs$date$Date$w3_encode_Date(v1)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v0),
					$author$project$Evergreen$V417$Drawing$w3_encode_MessageAnchor(v1)
				]));
	}
};
var $author$project$Evergreen$V417$Types$w3_encode_ChannelDataToDecrypt = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
				$author$project$Evergreen$V417$Encryption$w3_encode_EncryptedData(
					$author$project$Evergreen$V417$Message$w3_encode_MessageContent$(
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId))),
				w3_rec_var0.channel),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
				A2(
					$author$project$Evergreen$V417$NonemptyDict$w3_encode_NonemptyDict,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId),
					$author$project$Evergreen$V417$Encryption$w3_encode_EncryptedData(
						$author$project$Evergreen$V417$Message$w3_encode_MessageContent$(
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId)))),
				w3_rec_var0.threads)
			]));
};
var $author$project$Evergreen$V417$Types$w3_encode_ChannelDataToEncrypt = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
				$author$project$Evergreen$V417$Message$w3_encode_MessageContent$(
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId)),
				w3_rec_var0.channel),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId),
					$author$project$Evergreen$V417$Message$w3_encode_MessageContent$(
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId))),
				w3_rec_var0.threads)
			]));
};
var $author$project$Evergreen$V417$ChannelDescription$w3_encode_ChannelDescription = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Evergreen$V417$Go$w3_encode_Action = function (w3v) {
	switch (w3v.$) {
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
	}
};
var $author$project$Evergreen$V417$Go$w3_encode_ActionWithTime = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Go$w3_encode_Action(w3_rec_var0.change),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.time)
			]));
};
var $author$project$Evergreen$V417$SheepGame$w3_encode_Reactions = A2(
	$lamdera$containers$SeqDict$encodeDict,
	$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji,
	$author$project$Evergreen$V417$NonemptySet$w3_encode_NonemptySet(
		$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId)));
var $author$project$Evergreen$V417$SheepGame$w3_encode_ValidatedInput = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$FileStatus$w3_encode_FileId),
				$author$project$Evergreen$V417$FileStatus$w3_encode_FileData,
				w3_rec_var0.attachedFiles),
				$author$project$Evergreen$V417$SheepGame$w3_encode_Reactions(w3_rec_var0.reactions),
				$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
				A2(
					$author$project$Evergreen$V417$RichText$w3_encode_RichText,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId)),
				w3_rec_var0.text)
			]));
};
var $author$project$Evergreen$V417$SheepGame$w3_encode_Action = function (w3v) {
	switch (w3v.$) {
		case 7:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$SheepGame$w3_encode_ReactionTarget(v0),
						$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji(v1)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v2)
					]));
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$SheepGame$w3_encode_ValidatedInput, v1)
					]));
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v0)
					]));
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 8:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Evergreen$V417$SheepGame$w3_encode_ReactionTarget(v0),
						$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji(v1)
					]));
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$SheepGame$w3_encode_ValidatedInput, v1)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
	}
};
var $author$project$Evergreen$V417$SheepGame$w3_encode_ActionWithTime = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$SheepGame$w3_encode_Action(w3_rec_var0.change),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.time),
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, w3_rec_var0.userId)
			]));
};
var $lamdera$codecs$Lamdera$Wire3$encodeSet$ = function (encVal, s) {
	return $lamdera$codecs$Lamdera$Wire3$encodeList$(
		encVal,
		$elm$core$Set$toList(s));
};
var $lamdera$codecs$Lamdera$Wire3$encodeSet = F2($lamdera$codecs$Lamdera$Wire3$encodeSet$);
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_IsValid = function (w3v) {
	if (w3v.$ === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodeSet$($lamdera$codecs$Lamdera$Wire3$encodeString, v0)
				]));
	}
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_Letter = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeChar(v0)
			]));
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_LetterOrWildcard = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$WordSpellingGame$w3_encode_Letter(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_PlacedWord = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isVertical),
				$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$($author$project$Evergreen$V417$WordSpellingGame$w3_encode_LetterOrWildcard, w3_rec_var0.letters),
				$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.start)
			]));
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_Action = function (w3v) {
	switch (w3v.$) {
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$WordSpellingGame$w3_encode_ReactionTarget(v0),
						$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji(v1)
					]));
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V417$WordSpellingGame$w3_encode_PlacedWord(v0),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$($author$project$Evergreen$V417$WordSpellingGame$w3_encode_IsValid, v1)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V417$WordSpellingGame$w3_encode_PlacedWord(v0),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$($author$project$Evergreen$V417$WordSpellingGame$w3_encode_IsValid, v1)
					]));
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V417$WordSpellingGame$w3_encode_ReactionTarget(v0),
						$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji(v1)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
	}
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_ActionWithTime = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$WordSpellingGame$w3_encode_Action(w3_rec_var0.change),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.time),
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, w3_rec_var0.userId)
			]));
};
var $author$project$Evergreen$V417$SheepGame$w3_encode_Phase = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V417$SheepGame$w3_encode_Shared = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				A2(
					$author$project$Evergreen$V417$IdArray$w3_encode_IdArray,
					$author$project$Evergreen$V417$Id$w3_encode_QuestionId,
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe($author$project$Evergreen$V417$SheepGame$w3_encode_ValidatedInput)),
				w3_rec_var0.answers),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_QuestionId)),
				$lamdera$codecs$Lamdera$Wire3$encodeString,
				w3_rec_var0.groups),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_QuestionId),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe($author$project$Evergreen$V417$SheepGame$w3_encode_ValidatedInput),
				w3_rec_var0.notes),
				$author$project$Evergreen$V417$SheepGame$w3_encode_Phase(w3_rec_var0.phase),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.questionsRevealed)
			]));
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_AnimatedPlacement = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
					$author$project$Evergreen$V417$WordSpellingGame$w3_encode_LetterOrWildcard),
				w3_rec_var0.cells),
				$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$($author$project$Evergreen$V417$WordSpellingGame$w3_encode_IsValid, w3_rec_var0.isValid),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.startTime)
			]));
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_LetterId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_PlacementResult = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
					$author$project$Evergreen$V417$WordSpellingGame$w3_encode_LetterOrWildcard),
				w3_rec_var0.placedCells),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.score),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V417$WordSpellingGame$w3_encode_LetterOrWildcard, w3_rec_var1.letters),
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.placedCount)
							]));
				},
				w3_rec_var0.words)
			]));
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_Player = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				A3($lamdera$codecs$Lamdera$Wire3$encodeTriple, $author$project$Evergreen$V417$WordSpellingGame$w3_encode_PlacedWord, $author$project$Evergreen$V417$WordSpellingGame$w3_encode_PlacementResult, $author$project$Evergreen$V417$WordSpellingGame$w3_encode_IsValid),
				w3_rec_var0.premove),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.score),
				$author$project$Evergreen$V417$IdArray$w3_encode_IdArray$($author$project$Evergreen$V417$WordSpellingGame$w3_encode_LetterId, $author$project$Evergreen$V417$WordSpellingGame$w3_encode_LetterOrWildcard, w3_rec_var0.tray),
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, w3_rec_var0.userId)
			]));
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_Reactions = A2(
	$lamdera$containers$SeqDict$encodeDict,
	$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji,
	$author$project$Evergreen$V417$NonemptySet$w3_encode_NonemptySet(
		$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId)));
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_Shared = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$OneOrGreater$w3_encode_OneOrGreater(w3_rec_var0.attemptsLeft),
				$lamdera$containers$SeqDict$encodeDict$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				$author$project$Evergreen$V417$WordSpellingGame$w3_encode_LetterOrWildcard,
				w3_rec_var0.board),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$WordSpellingGame$w3_encode_AnimatedPlacement, w3_rec_var0.lastPlacement),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.passingStartedAt),
				$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$($author$project$Evergreen$V417$WordSpellingGame$w3_encode_Player, w3_rec_var0.players),
				$lamdera$containers$SeqDict$encodeDict$($author$project$Evergreen$V417$WordSpellingGame$w3_encode_ReactionTarget, $author$project$Evergreen$V417$WordSpellingGame$w3_encode_Reactions, w3_rec_var0.reactions),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.turnCount)
			]));
};
var $author$project$Evergreen$V417$Go$w3_encode_BoardSize = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Evergreen$V417$Go$w3_encode_KomiHalfPoints = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Evergreen$V417$Go$w3_encode_Stone = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$Go$w3_encode_TimeControl = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var0.increment),
				$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var0.mainTime)
			]));
};
var $author$project$Evergreen$V417$Go$w3_encode_ValidatedSetup = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, w3_rec_var0.createdBy),
				$author$project$Evergreen$V417$Go$w3_encode_Stone(w3_rec_var0.gameCreatorPlayingAs),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.handicap),
				$author$project$Evergreen$V417$Go$w3_encode_BoardSize(w3_rec_var0.height),
				$author$project$Evergreen$V417$Go$w3_encode_KomiHalfPoints(w3_rec_var0.komiHalfPoints),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Go$w3_encode_TimeControl, w3_rec_var0.timeControl),
				$author$project$Evergreen$V417$Go$w3_encode_BoardSize(w3_rec_var0.width)
			]));
};
var $author$project$Evergreen$V417$SheepGame$w3_encode_ValidatedSetup = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, w3_rec_var0.createdBy),
				$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$($author$project$Evergreen$V417$SheepGame$w3_encode_ValidatedInput, w3_rec_var0.questions)
			]));
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_Language = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_ValidatedSetup = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, w3_rec_var0.createdBy),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.fullTrayBonus),
				$author$project$Evergreen$V417$WordSpellingGame$w3_encode_Language(w3_rec_var0.language),
				$author$project$Evergreen$V417$NonemptyDict$w3_encode_NonemptyDict$(
				$author$project$Evergreen$V417$WordSpellingGame$w3_encode_LetterOrWildcard,
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$author$project$Evergreen$V417$OneOrGreater$w3_encode_OneOrGreater(w3_rec_var1.count),
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.value)
							]));
				},
				w3_rec_var0.letters),
				$author$project$Evergreen$V417$OneOrGreater$w3_encode_OneOrGreater(w3_rec_var0.placeWordAttempts),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.seed),
				$author$project$Evergreen$V417$Go$w3_encode_TimeControl(w3_rec_var0.timeControls),
				$author$project$Evergreen$V417$OneOrGreater$w3_encode_OneOrGreater(w3_rec_var0.traySize)
			]));
};
var $author$project$Evergreen$V417$Game$w3_encode_BackendGameData = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Go$w3_encode_ValidatedSetup(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Evergreen$V417$Go$w3_encode_ActionWithTime, v1)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$SheepGame$w3_encode_ValidatedSetup(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Evergreen$V417$SheepGame$w3_encode_ActionWithTime, v1),
						$author$project$Evergreen$V417$SheepGame$w3_encode_Shared(v2)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$WordSpellingGame$w3_encode_ValidatedSetup(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Evergreen$V417$WordSpellingGame$w3_encode_ActionWithTime, v1),
						$author$project$Evergreen$V417$WordSpellingGame$w3_encode_Shared(v2)
					]));
	}
};
var $author$project$Evergreen$V417$Id$w3_encode_GamePublicId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$SecretId$w3_encode_SecretId$ = function (w3_x_c_a, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Evergreen$V417$SecretId$w3_encode_SecretId = F2($author$project$Evergreen$V417$SecretId$w3_encode_SecretId$);
var $author$project$Evergreen$V417$Game$w3_encode_LoadedMatch = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Game$w3_encode_BackendGameData(w3_rec_var0.gameData),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V417$SecretId$w3_encode_SecretId($author$project$Evergreen$V417$Id$w3_encode_GamePublicId),
				w3_rec_var0.publicLink)
			]));
};
var $author$project$Evergreen$V417$DmChannel$w3_encode_LoadedMessages = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
				A3(
					$author$project$Evergreen$V417$Message$w3_encode_Message,
					$author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId)),
				w3_rec_var0.messages),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
				$author$project$Evergreen$V417$Game$w3_encode_LoadedMatch,
				w3_rec_var0.repliedToMatches)
			]));
};
var $author$project$Evergreen$V417$Call$w3_encode_RemoteCallData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.audioInputEnabled),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.screenShareEnabled),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.videoInputEnabled)
			]));
};
var $author$project$Evergreen$V417$Call$w3_encode_LocalChange = function (w3v) {
	switch (w3v.$) {
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0)
					]));
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V417$Call$w3_encode_RemoteCallData(v0)
					]));
	}
};
var $author$project$Evergreen$V417$Drawing$w3_encode_LocalChange = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Evergreen$V417$SafeFloat$w3_encode_SafeFloat, $author$project$Evergreen$V417$SafeFloat$w3_encode_SafeFloat),
						v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Evergreen$V417$SafeFloat$w3_encode_SafeFloat, $author$project$Evergreen$V417$SafeFloat$w3_encode_SafeFloat),
						v0)
					]));
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V417$SafeFloat$w3_encode_SafeFloat, $author$project$Evergreen$V417$SafeFloat$w3_encode_SafeFloat, v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
	}
};
var $author$project$Evergreen$V417$Go$w3_encode_LocalChange = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$Go$w3_encode_ActionWithTime(v0)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
					$author$project$Evergreen$V417$Go$w3_encode_ValidatedSetup(v1)
				]));
	}
};
var $author$project$Evergreen$V417$SheepGame$w3_encode_LocalChange = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$SheepGame$w3_encode_ActionWithTime(v0)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
					$author$project$Evergreen$V417$SheepGame$w3_encode_ValidatedSetup(v1)
				]));
	}
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_LocalChange = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$WordSpellingGame$w3_encode_ActionWithTime(v0)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
					$author$project$Evergreen$V417$WordSpellingGame$w3_encode_ValidatedSetup(v1)
				]));
	}
};
var $author$project$Evergreen$V417$Game$w3_encode_LocalChange = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v0),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						$author$project$Evergreen$V417$SecretId$w3_encode_SecretId($author$project$Evergreen$V417$Id$w3_encode_GamePublicId),
						v1)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v0),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$($author$project$Evergreen$V417$Game$w3_encode_LoadedMatch, v1)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v0),
						$author$project$Evergreen$V417$Go$w3_encode_LocalChange(v1)
					]));
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v0),
						$author$project$Evergreen$V417$SheepGame$w3_encode_LocalChange(v1)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v0),
						$author$project$Evergreen$V417$WordSpellingGame$w3_encode_LocalChange(v1)
					]));
	}
};
var $author$project$Evergreen$V417$TextEditor$w3_encode_EditChange = function (w3v) {
	var v0 = w3v.a;
	var v1 = w3v.b;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$author$project$Evergreen$V417$Range$w3_encode_Range(v0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
			]));
};
var $author$project$Evergreen$V417$TextEditor$w3_encode_LocalChange = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$TextEditor$w3_encode_EditChange(v0)
					]));
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Evergreen$V417$User$w3_encode_NotificationLevel = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$VisibleMessages$w3_encode_PageRequest$ = function (w3_x_c_messageId, w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$Id$w3_encode_Id$(w3_x_c_messageId, v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V417$Id$w3_encode_Id$(w3_x_c_messageId, v0)
				]));
	}
};
var $author$project$Evergreen$V417$VisibleMessages$w3_encode_PageRequest = F2($author$project$Evergreen$V417$VisibleMessages$w3_encode_PageRequest$);
var $author$project$Evergreen$V417$Ports$w3_encode_RegisterPushSubscription = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$Ports$w3_encode_SubscribeData(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
				]));
	}
};
var $author$project$Evergreen$V417$UserSession$w3_encode_DiscordFrontendUser = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$UserColor$w3_encode_UserColor(w3_rec_var0.color),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
				$author$project$Evergreen$V417$PersonName$w3_encode_PersonName(w3_rec_var0.name)
			]));
};
var $author$project$Evergreen$V417$UserSession$w3_encode_UnreadOverviewData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
					A3(
						$author$project$Evergreen$V417$Message$w3_encode_Message,
						$author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId,
						$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
						$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_ChannelId))),
				w3_rec_var0.discordDmChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_GuildId),
					$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_ChannelId)),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
					A3(
						$author$project$Evergreen$V417$Message$w3_encode_Message,
						$author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId,
						$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
						$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_ChannelId))),
				w3_rec_var0.discordGuildChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				A3(
					$lamdera$codecs$Lamdera$Wire3$encodeTriple,
					$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_GuildId),
					$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_ChannelId),
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId)),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId),
					A3(
						$author$project$Evergreen$V417$Message$w3_encode_Message,
						$author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId,
						$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
						$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_ChannelId))),
				w3_rec_var0.discordGuildThreads),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
				$author$project$Evergreen$V417$UserSession$w3_encode_DiscordFrontendUser,
				w3_rec_var0.discordUsers),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
					A3(
						$author$project$Evergreen$V417$Message$w3_encode_Message,
						$author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId,
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId))),
				w3_rec_var0.dmChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId)),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId),
					A3(
						$author$project$Evergreen$V417$Message$w3_encode_Message,
						$author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId,
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId))),
				w3_rec_var0.dmThreads),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_GuildId),
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId)),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
					A3(
						$author$project$Evergreen$V417$Message$w3_encode_Message,
						$author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId,
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId))),
				w3_rec_var0.guildChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				A3(
					$lamdera$codecs$Lamdera$Wire3$encodeTriple,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_GuildId),
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId),
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId)),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId),
					A3(
						$author$project$Evergreen$V417$Message$w3_encode_Message,
						$author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId,
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId))),
				w3_rec_var0.guildThreads),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_TeamId),
					$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_ChannelId)),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
					A3(
						$author$project$Evergreen$V417$Message$w3_encode_Message,
						$author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId,
						$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_UserId),
						$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_ChannelId))),
				w3_rec_var0.slackChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_DmChannelId),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
					A3(
						$author$project$Evergreen$V417$Message$w3_encode_Message,
						$author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId,
						$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_UserId),
						$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_ChannelId))),
				w3_rec_var0.slackDmChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_DmChannelId),
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId)),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId),
					A3(
						$author$project$Evergreen$V417$Message$w3_encode_Message,
						$author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId,
						$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_UserId),
						$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_ChannelId))),
				w3_rec_var0.slackDmThreads),
				$lamdera$containers$SeqDict$encodeDict$(
				A3(
					$lamdera$codecs$Lamdera$Wire3$encodeTriple,
					$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_TeamId),
					$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_ChannelId),
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId)),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId),
					A3(
						$author$project$Evergreen$V417$Message$w3_encode_Message,
						$author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId,
						$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_UserId),
						$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_ChannelId))),
				w3_rec_var0.slackThreads)
			]));
};
var $author$project$Evergreen$V417$UserSession$w3_encode_ViewDiscordGuildData = function (w3_x_c_messageId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$containers$SeqDict$encodeDict$(
					$author$project$Evergreen$V417$Id$w3_encode_Id(w3_x_c_messageId),
					A3(
						$author$project$Evergreen$V417$Message$w3_encode_Message,
						w3_x_c_messageId,
						$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
						$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_ChannelId)),
					w3_rec_var0.messages),
					$lamdera$containers$SeqDict$encodeDict$(
					$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
					$author$project$Evergreen$V417$UserSession$w3_encode_DiscordFrontendUser,
					w3_rec_var0.newUsers)
				]));
	};
};
var $author$project$Evergreen$V417$UserSession$w3_encode_ChannelHeaderTab = function (w3v) {
	switch (w3v.$) {
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
						v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Message$w3_encode_RepliedToGame, v1)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Evergreen$V417$UserSession$w3_encode_PreviouslyLastViewedMessage$ = function (w3_x_c_messageId, w3v) {
	if (!w3v.$) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V417$Id$w3_encode_Id$(w3_x_c_messageId, v0)
				]));
	}
};
var $author$project$Evergreen$V417$UserSession$w3_encode_PreviouslyLastViewedMessage = F2($author$project$Evergreen$V417$UserSession$w3_encode_PreviouslyLastViewedMessage$);
var $author$project$Evergreen$V417$UserSession$w3_encode_Viewing_ChannelData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$UserSession$w3_encode_ChannelHeaderTab, w3_rec_var0.channelHeaderTab),
				$author$project$Evergreen$V417$Id$w3_encode_Viewing_ChannelId(w3_rec_var0.id),
				$author$project$Evergreen$V417$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, w3_rec_var0.previouslyLastViewedMessage)
			]));
};
var $author$project$Evergreen$V417$Id$w3_encode_Viewing_ChannelThreadId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelId, w3_rec_var0.channelId),
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, w3_rec_var0.guildId),
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, w3_rec_var0.threadId)
			]));
};
var $author$project$Evergreen$V417$UserSession$w3_encode_Viewing_ChannelThreadData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Id$w3_encode_Viewing_ChannelThreadId(w3_rec_var0.id),
				$author$project$Evergreen$V417$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId, w3_rec_var0.previouslyLastViewedMessage)
			]));
};
var $author$project$Evergreen$V417$UserSession$w3_encode_Viewing_DiscordChannelData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Id$w3_encode_Viewing_DiscordChannelId(w3_rec_var0.id),
				$author$project$Evergreen$V417$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, w3_rec_var0.previouslyLastViewedMessage)
			]));
};
var $author$project$Evergreen$V417$Id$w3_encode_Viewing_DiscordChannelThreadId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, w3_rec_var0.channelId),
				$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, w3_rec_var0.currentUserId),
				$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, w3_rec_var0.guildId),
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, w3_rec_var0.threadId)
			]));
};
var $author$project$Evergreen$V417$UserSession$w3_encode_Viewing_DiscordChannelThreadData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Id$w3_encode_Viewing_DiscordChannelThreadId(w3_rec_var0.id),
				$author$project$Evergreen$V417$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId, w3_rec_var0.previouslyLastViewedMessage)
			]));
};
var $author$project$Evergreen$V417$UserSession$w3_encode_Viewing_DiscordDmData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Id$w3_encode_Viewing_DiscordDmId(w3_rec_var0.id),
				$author$project$Evergreen$V417$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, w3_rec_var0.previouslyLastViewedMessage)
			]));
};
var $author$project$Evergreen$V417$UserSession$w3_encode_Viewing_DmData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$UserSession$w3_encode_ChannelHeaderTab, w3_rec_var0.channelHeaderTab),
				$author$project$Evergreen$V417$Id$w3_encode_Viewing_DmId(w3_rec_var0.id),
				$author$project$Evergreen$V417$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, w3_rec_var0.previouslyLastViewedMessage)
			]));
};
var $author$project$Evergreen$V417$Id$w3_encode_Viewing_DmThreadId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, w3_rec_var0.otherUserId),
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, w3_rec_var0.threadId)
			]));
};
var $author$project$Evergreen$V417$UserSession$w3_encode_Viewing_DmThreadData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Id$w3_encode_Viewing_DmThreadId(w3_rec_var0.id),
				$author$project$Evergreen$V417$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId, w3_rec_var0.previouslyLastViewedMessage)
			]));
};
var $author$project$Evergreen$V417$UserSession$w3_encode_Viewing_SlackChannelData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Id$w3_encode_Viewing_SlackChannelId(w3_rec_var0.id),
				$author$project$Evergreen$V417$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, w3_rec_var0.previouslyLastViewedMessage)
			]));
};
var $author$project$Evergreen$V417$UserSession$w3_encode_Viewing_SlackChannelThreadData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Id$w3_encode_Viewing_SlackChannelId(w3_rec_var0.id),
				$author$project$Evergreen$V417$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId, w3_rec_var0.previouslyLastViewedMessage),
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, w3_rec_var0.threadId)
			]));
};
var $author$project$Evergreen$V417$UserSession$w3_encode_Viewing_SlackDmData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Id$w3_encode_Viewing_SlackDmId(w3_rec_var0.id),
				$author$project$Evergreen$V417$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, w3_rec_var0.previouslyLastViewedMessage)
			]));
};
var $author$project$Evergreen$V417$UserSession$w3_encode_Viewing_SlackDmThreadData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Id$w3_encode_Viewing_SlackDmId(w3_rec_var0.id),
				$author$project$Evergreen$V417$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId, w3_rec_var0.previouslyLastViewedMessage),
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, w3_rec_var0.threadId)
			]));
};
var $author$project$Evergreen$V417$SetViewing$w3_encode_SetViewing = function (w3v) {
	switch (w3v.$) {
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$UserSession$w3_encode_Viewing_ChannelData(v0),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$($author$project$Evergreen$V417$DmChannel$w3_encode_LoadedMessages, v1)
					]));
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$UserSession$w3_encode_Viewing_ChannelThreadData(v0),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId),
							A3(
								$author$project$Evergreen$V417$Message$w3_encode_Message,
								$author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId,
								$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
								$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId))),
						v1)
					]));
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V417$UserSession$w3_encode_Viewing_DiscordChannelData(v0),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						$author$project$Evergreen$V417$UserSession$w3_encode_ViewDiscordGuildData($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
						v1)
					]));
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V417$UserSession$w3_encode_Viewing_DiscordChannelThreadData(v0),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						$author$project$Evergreen$V417$UserSession$w3_encode_ViewDiscordGuildData($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId),
						v1)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V417$UserSession$w3_encode_Viewing_DiscordDmData(v0),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
							A3(
								$author$project$Evergreen$V417$Message$w3_encode_Message,
								$author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId,
								$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
								$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_ChannelId))),
						v1)
					]));
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Evergreen$V417$UserSession$w3_encode_Viewing_DmData(v0),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$($author$project$Evergreen$V417$DmChannel$w3_encode_LoadedMessages, v1)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Evergreen$V417$UserSession$w3_encode_Viewing_DmThreadData(v0),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId),
							A3(
								$author$project$Evergreen$V417$Message$w3_encode_Message,
								$author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId,
								$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
								$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId))),
						v1)
					]));
		case 12:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$($author$project$Evergreen$V417$UserSession$w3_encode_UnreadOverviewData, v0)
					]));
		case 7:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V417$UserSession$w3_encode_Viewing_SlackChannelData(v0),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
							A3(
								$author$project$Evergreen$V417$Message$w3_encode_Message,
								$author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId,
								$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_UserId),
								$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_ChannelId))),
						v1)
					]));
		case 9:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Evergreen$V417$UserSession$w3_encode_Viewing_SlackChannelThreadData(v0),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId),
							A3(
								$author$project$Evergreen$V417$Message$w3_encode_Message,
								$author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId,
								$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_UserId),
								$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_ChannelId))),
						v1)
					]));
		case 8:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$Evergreen$V417$UserSession$w3_encode_Viewing_SlackDmData(v0),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
							A3(
								$author$project$Evergreen$V417$Message$w3_encode_Message,
								$author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId,
								$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_UserId),
								$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_ChannelId))),
						v1)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$Evergreen$V417$UserSession$w3_encode_Viewing_SlackDmThreadData(v0),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId),
							A3(
								$author$project$Evergreen$V417$Message$w3_encode_Message,
								$author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId,
								$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_UserId),
								$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_ChannelId))),
						v1)
					]));
	}
};
var $elm$time$Time$w3_encode_Era = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.offset),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.start)
			]));
};
var $elm$time$Time$w3_encode_Zone = function (w3v) {
	var v0 = w3v.a;
	var v1 = w3v.b;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($elm$time$Time$w3_encode_Era, v1)
			]));
};
var $lamdera$program_test$Effect$Time$w3_encode_Zone = $elm$time$Time$w3_encode_Zone;
var $author$project$Evergreen$V417$Types$w3_encode_LocalChange = function (w3v) {
	switch (w3v.$) {
		case 76:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Id$w3_encode_Viewing_DmId(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v1),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2($lamdera$containers$SeqDict$encodeDict, $author$project$Evergreen$V417$Id$w3_encode_Viewing_DmId, $author$project$Evergreen$V417$Types$w3_encode_ChannelDataToEncrypt),
						v2)
					]));
		case 55:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$NonemptySet$w3_encode_NonemptySet$(
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_CustomEmojiId),
						v0)
					]));
		case 19:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v1),
						$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji(v2)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V417$Pages$Admin$w3_encode_AdminChange(v0)
					]));
		case 16:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v1)
					]));
		case 45:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 40:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Evergreen$V417$UserSession$w3_encode_UserOptionSection(v0)
					]));
		case 27:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.markMessagesAsViewed)
								]));
					}(v0),
						$author$project$Evergreen$V417$SetViewing$w3_encode_SetViewing(v1)
					]));
		case 70:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Evergreen$V417$Id$w3_encode_Viewing_DmId(v0)
					]));
		case 69:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V417$Id$w3_encode_Viewing_DmId(v0)
					]));
		case 74:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Evergreen$V417$Id$w3_encode_Viewing_DmId(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						A2(
							$lamdera$codecs$Lamdera$Wire3$encodePair,
							$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage,
							$author$project$Evergreen$V417$Message$w3_encode_MessageContent$(
								$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
								$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId))),
						v2)
					]));
		case 10:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelId, v1)
					]));
		case 12:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0)
					]));
		case 15:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$SecretId$w3_encode_SecretId$($author$project$Evergreen$V417$Id$w3_encode_InviteLinkId, v1)
					]));
		case 26:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 73:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$author$project$Evergreen$V417$Id$w3_encode_Viewing_DmId(v0),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$($author$project$Evergreen$V417$Types$w3_encode_ChannelDataToDecrypt, v1)
					]));
		case 33:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$author$project$Evergreen$V417$Id$w3_encode_DiscordGuildOrDmId(v0),
						$author$project$Evergreen$V417$VisibleMessages$w3_encode_PageRequest$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
							A3(
								$author$project$Evergreen$V417$Message$w3_encode_Message,
								$author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId,
								$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
								$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_ChannelId))),
						v2)
					]));
		case 34:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$author$project$Evergreen$V417$Id$w3_encode_DiscordGuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V417$VisibleMessages$w3_encode_PageRequest$($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId, v2),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId),
							A3(
								$author$project$Evergreen$V417$Message$w3_encode_Message,
								$author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId,
								$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
								$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_ChannelId))),
						v3)
					]));
		case 23:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Zone(v1),
						$author$project$Evergreen$V417$Id$w3_encode_Viewing_DiscordDmId(v2),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v3),
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v4)
					]));
		case 22:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			var v6 = w3v.g;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(19),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Zone(v1),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v2),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v3),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, v4),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v5),
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v6)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(20),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Zone(v1),
						$author$project$Evergreen$V417$Id$w3_encode_DiscordGuildOrDmId(v2),
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v3),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMaybeMessage(v4),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$FileStatus$w3_encode_FileId),
						$author$project$Evergreen$V417$FileStatus$w3_encode_FileData,
						v5)
					]));
		case 58:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(21),
						$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V417$Drawing$w3_encode_AnchorType(v1),
						$author$project$Evergreen$V417$Drawing$w3_encode_LocalChange(v2)
					]));
		case 9:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(22),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V417$ChannelName$w3_encode_ChannelName(v2),
						$author$project$Evergreen$V417$ChannelDescription$w3_encode_ChannelDescription(v3)
					]));
		case 11:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(23),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$GuildName$w3_encode_GuildName(v1)
					]));
		case 72:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(24),
						$author$project$Evergreen$V417$Id$w3_encode_Viewing_DmId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						A3(
							$lamdera$codecs$Lamdera$Wire3$encodeTriple,
							$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage,
							$lamdera$containers$SeqSet$encodeSet($author$project$Evergreen$V417$FileStatus$w3_encode_FileHash),
							$author$project$Evergreen$V417$Encryption$w3_encode_EncryptedData(
								$author$project$Evergreen$V417$Message$w3_encode_MessageContent$(
									$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
									$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId)))),
						v1)
					]));
		case 39:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(25),
						$author$project$Evergreen$V417$UserSession$w3_encode_UserOptionSection(v0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.collapseOthers)
								]));
					}(v1)
					]));
		case 57:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(26),
						$author$project$Evergreen$V417$Id$w3_encode_GuildOrDmId(v0),
						$author$project$Evergreen$V417$Game$w3_encode_LocalChange(v1)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(27);
		case 13:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(28),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0)
					]));
		case 50:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(29),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 51:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(30),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 29:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(31),
						$author$project$Evergreen$V417$Id$w3_encode_GuildOrDmId(v0),
						$author$project$Evergreen$V417$VisibleMessages$w3_encode_PageRequest$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$($author$project$Evergreen$V417$DmChannel$w3_encode_LoadedMessages, v2)
					]));
		case 30:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(32),
						$author$project$Evergreen$V417$Id$w3_encode_GuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V417$VisibleMessages$w3_encode_PageRequest$($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId, v2),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId),
							A3(
								$author$project$Evergreen$V417$Message$w3_encode_Message,
								$author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId,
								$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
								$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId))),
						v3)
					]));
		case 24:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(33),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId(v1),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v2)
					]));
		case 18:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(34),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_encode_ThreadRoute, v1)
					]));
		case 8:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(35),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v1),
						$author$project$Evergreen$V417$ChannelName$w3_encode_ChannelName(v2),
						$author$project$Evergreen$V417$ChannelDescription$w3_encode_ChannelDescription(v3)
					]));
		case 17:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(36),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$GuildName$w3_encode_GuildName(v1),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_GuildId),
						v2)
					]));
		case 14:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(37),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v1),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						$author$project$Evergreen$V417$SecretId$w3_encode_SecretId($author$project$Evergreen$V417$Id$w3_encode_InviteLinkId),
						v2)
					]));
		case 46:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(38),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Ports$w3_encode_RegisterPushSubscription(v1)
					]));
		case 20:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(39),
						$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v1),
						$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji(v2)
					]));
		case 68:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(40),
						$author$project$Evergreen$V417$Id$w3_encode_Viewing_DmId(v0)
					]));
		case 44:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(41),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0)
					]));
		case 21:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(42),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Zone(v1),
						$author$project$Evergreen$V417$Id$w3_encode_GuildOrDmId(v2),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v3),
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v4),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$FileStatus$w3_encode_FileId),
						$author$project$Evergreen$V417$FileStatus$w3_encode_FileData,
						v5)
					]));
		case 78:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(43),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Id$w3_encode_Viewing_DmId(v1),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v2),
						$lamdera$containers$SeqSet$encodeSet$($author$project$Evergreen$V417$FileStatus$w3_encode_FileHash, v3),
						$author$project$Evergreen$V417$Encryption$w3_encode_EncryptedData$(
						$author$project$Evergreen$V417$Message$w3_encode_MessageContent$(
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId)),
						v4)
					]));
		case 77:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(44),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Id$w3_encode_Viewing_DmId(v1),
						$lamdera$containers$SeqSet$encodeSet$($author$project$Evergreen$V417$FileStatus$w3_encode_FileHash, v2),
						$author$project$Evergreen$V417$Encryption$w3_encode_EncryptedData$(
						$author$project$Evergreen$V417$Message$w3_encode_MessageContent$(
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId)),
						v3),
						$author$project$Evergreen$V417$Encryption$w3_encode_EncryptedData$($lamdera$codecs$Lamdera$Wire3$encodeString, v4),
						$author$project$Evergreen$V417$Message$w3_encode_ThreadRouteWithRepliedTo(v5)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			var v6 = w3v.g;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(45),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Zone(v1),
						$author$project$Evergreen$V417$Id$w3_encode_GuildOrDmId(v2),
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v3),
						$author$project$Evergreen$V417$Message$w3_encode_ThreadRouteWithRepliedTo(v4),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$FileStatus$w3_encode_FileId),
						$author$project$Evergreen$V417$FileStatus$w3_encode_FileData,
						v5),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji, v6)
					]));
		case 36:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(46),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V417$User$w3_encode_NotificationLevel(v2)
					]));
		case 52:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(47),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0),
						$author$project$Evergreen$V417$RichText$w3_encode_Domain(v1)
					]));
		case 75:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(48),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 42:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(49),
						$author$project$Evergreen$V417$User$w3_encode_EmailNotifications(v0)
					]));
		case 43:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(50),
						$author$project$Evergreen$V417$User$w3_encode_EmbedVisibility(v0)
					]));
		case 53:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(51),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Emoji$w3_encode_SkinTone, v0)
					]));
		case 35:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(52),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$User$w3_encode_NotificationLevel(v1)
					]));
		case 25:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(53),
						$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 59:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(54),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(v2)
					]));
		case 61:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(55),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, v2),
						$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(v3)
					]));
		case 64:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(56),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(v2)
					]));
		case 62:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(57),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, v2),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v3),
						$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(v4)
					]));
		case 63:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(58),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(v1)
					]));
		case 66:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(59),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_TeamId, v1),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_ChannelId, v2),
						$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(v3)
					]));
		case 67:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(60),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_TeamId, v1),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_ChannelId, v2),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v3),
						$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(v4)
					]));
		case 65:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(61),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_TeamId, v1),
						$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(v2)
					]));
		case 60:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(62),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v2),
						$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(v3)
					]));
		case 28:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(63),
						$author$project$Evergreen$V417$PersonName$w3_encode_PersonName(v0)
					]));
		case 38:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(64),
						$author$project$Evergreen$V417$UserSession$w3_encode_NotificationMode(v0)
					]));
		case 71:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(65),
						$author$project$Evergreen$V417$X25519$w3_encode_PublicKey(v0),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2($lamdera$containers$SeqDict$encodeDict, $author$project$Evergreen$V417$Id$w3_encode_Viewing_DmId, $author$project$Evergreen$V417$Types$w3_encode_ChannelDataToEncrypt),
						v1)
					]));
		case 41:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(66),
						$author$project$Evergreen$V417$IdArray$w3_encode_IdArray$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, $author$project$Evergreen$V417$UserSession$w3_encode_SheepGameQuestion, v0)
					]));
		case 37:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(67),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_TeamId, v1),
						$author$project$Evergreen$V417$User$w3_encode_NotificationLevel(v2)
					]));
		case 54:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(68),
						$author$project$Evergreen$V417$UserColor$w3_encode_UserColor(v0)
					]));
		case 31:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(69),
						$author$project$Evergreen$V417$Id$w3_encode_SlackGuildOrDmId(v0),
						$author$project$Evergreen$V417$VisibleMessages$w3_encode_PageRequest$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
							A3(
								$author$project$Evergreen$V417$Message$w3_encode_Message,
								$author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId,
								$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_UserId),
								$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_ChannelId))),
						v2)
					]));
		case 32:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(70),
						$author$project$Evergreen$V417$Id$w3_encode_SlackGuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V417$VisibleMessages$w3_encode_PageRequest$($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId, v2),
						$author$project$Evergreen$V417$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId),
							A3(
								$author$project$Evergreen$V417$Message$w3_encode_Message,
								$author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId,
								$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_UserId),
								$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_ChannelId))),
						v3)
					]));
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(71),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_UserId, v0)
					]));
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(72),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Zone(v1),
						$author$project$Evergreen$V417$Id$w3_encode_SlackGuildOrDmId(v2),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v3),
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v4)
					]));
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(73),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Zone(v1),
						$author$project$Evergreen$V417$Id$w3_encode_SlackGuildOrDmId(v2),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRoute(v3),
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v4),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$FileStatus$w3_encode_FileId),
						$author$project$Evergreen$V417$FileStatus$w3_encode_FileData,
						v5)
					]));
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(74),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_UserId, v0)
					]));
		case 49:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(75),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v1)
					]));
		case 47:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(76),
						$author$project$Evergreen$V417$TextEditor$w3_encode_LocalChange(v0)
					]));
		case 48:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(77),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(78),
						$author$project$Evergreen$V417$Call$w3_encode_LocalChange(v0)
					]));
	}
};
var $author$project$Evergreen$V417$CustomEmoji$w3_encode_CustomEmojiUrl = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$FileStatus$w3_encode_FileHash(v0),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					$author$project$Evergreen$V417$Coord$w3_encode_Coord($author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels),
					v1)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$CustomEmoji$w3_encode_EmojiName = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Evergreen$V417$CustomEmoji$w3_encode_CustomEmojiData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isAnimated),
				$author$project$Evergreen$V417$CustomEmoji$w3_encode_EmojiName(w3_rec_var0.name),
				$author$project$Evergreen$V417$CustomEmoji$w3_encode_CustomEmojiUrl(w3_rec_var0.url)
			]));
};
var $author$project$Evergreen$V417$LinkedAndOtherDiscordUsers$w3_encode_DiscordFrontendCurrentUser = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$UserColor$w3_encode_UserColor(w3_rec_var0.color),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$EmailAddress$w3_encode_EmailAddress, w3_rec_var0.email),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
				$author$project$Evergreen$V417$DiscordUserData$w3_encode_DiscordUserLoadingData(w3_rec_var0.isLoadingData),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.linkedAt),
				$author$project$Evergreen$V417$PersonName$w3_encode_PersonName(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.needsAuthAgain)
			]));
};
var $author$project$Evergreen$V417$MessageArray$w3_encode_Run$ = function (w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.start),
					$lamdera$codecs$Lamdera$Wire3$encodeArray$(
					A3($author$project$Evergreen$V417$Message$w3_encode_Message, w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId),
					w3_rec_var0.values)
				]));
	};
};
var $author$project$Evergreen$V417$MessageArray$w3_encode_Run = F3($author$project$Evergreen$V417$MessageArray$w3_encode_Run$);
var $author$project$Evergreen$V417$MessageArray$w3_encode_MessageArray$ = function (w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				function (w3_rec_var0) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.end),
							$lamdera$codecs$Lamdera$Wire3$encodeArray$(
							$author$project$Evergreen$V417$MessageArray$w3_encode_Run$(w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId),
							w3_rec_var0.runs),
							$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.start)
						]));
			}(v0)
			]));
};
var $author$project$Evergreen$V417$MessageArray$w3_encode_MessageArray = F4($author$project$Evergreen$V417$MessageArray$w3_encode_MessageArray$);
var $author$project$Evergreen$V417$VisibleMessages$w3_encode_VisibleMessages = function (w3_x_c_messageId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.count),
					$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.loadingMessages),
					$author$project$Evergreen$V417$Id$w3_encode_Id$(w3_x_c_messageId, w3_rec_var0.oldest)
				]));
	};
};
var $author$project$Evergreen$V417$DmChannel$w3_encode_DiscordFrontendDmChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$justinmimbs$date$Date$w3_encode_Date,
				$author$project$Evergreen$V417$Drawing$w3_encode_Drawing(
					$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId)),
				w3_rec_var0.dateDividerDrawings),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
								$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
								w3_rec_var1.messageIndex),
								$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var1.time)
							]));
				},
				w3_rec_var0.lastTypedAt),
				$author$project$Evergreen$V417$NonemptyDict$w3_encode_NonemptyDict$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.messagesSent)
							]));
				},
				w3_rec_var0.members),
				$author$project$Evergreen$V417$MessageArray$w3_encode_MessageArray$(
				$author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId,
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_ChannelId),
				w3_rec_var0.messages),
				A2($author$project$Evergreen$V417$VisibleMessages$w3_encode_VisibleMessages, $author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, w3_rec_var0.visibleMessages)
			]));
};
var $author$project$Evergreen$V417$Thread$w3_encode_DiscordFrontendThread = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$justinmimbs$date$Date$w3_encode_Date,
				$author$project$Evergreen$V417$Drawing$w3_encode_Drawing(
					$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId)),
				w3_rec_var0.dateDividerDrawings),
				$author$project$Evergreen$V417$MessageArray$w3_encode_MessageArray$(
				$author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId,
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_ChannelId),
				w3_rec_var0.messages),
				A2($author$project$Evergreen$V417$VisibleMessages$w3_encode_VisibleMessages, $author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId, w3_rec_var0.visibleMessages)
			]));
};
var $author$project$Evergreen$V417$LocalState$w3_encode_DiscordFrontendChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$justinmimbs$date$Date$w3_encode_Date,
				$author$project$Evergreen$V417$Drawing$w3_encode_Drawing(
					$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId)),
				w3_rec_var0.dateDividerDrawings),
				$author$project$Evergreen$V417$ChannelDescription$w3_encode_ChannelDescription(w3_rec_var0.description),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isForum),
				$author$project$Evergreen$V417$MessageArray$w3_encode_MessageArray$(
				$author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId,
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_ChannelId),
				w3_rec_var0.messages),
				$author$project$Evergreen$V417$ChannelName$w3_encode_ChannelName(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V417$Discord$w3_encode_Overwrite, w3_rec_var0.permissionOverwrites),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
				$author$project$Evergreen$V417$Thread$w3_encode_DiscordFrontendThread,
				w3_rec_var0.threads),
				A2($author$project$Evergreen$V417$VisibleMessages$w3_encode_VisibleMessages, $author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, w3_rec_var0.visibleMessages)
			]));
};
var $author$project$Evergreen$V417$Thread$w3_encode_LastTypedAt = function (w3_x_c_channelId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					w3_x_c_channelId(w3_rec_var0.channelId),
					$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMaybeMessage(w3_rec_var0.threadRoute),
					$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.time)
				]));
	};
};
var $author$project$Evergreen$V417$LocalState$w3_encode_DiscordFrontendGuild = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_ChannelId),
				$author$project$Evergreen$V417$LocalState$w3_encode_DiscordFrontendChannel,
				w3_rec_var0.channels),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_CustomEmojiId),
				w3_rec_var0.customEmojis),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
				$author$project$Evergreen$V417$Thread$w3_encode_LastTypedAt(
					$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_ChannelId)),
				w3_rec_var0.lastTypedAt),
				$author$project$Evergreen$V417$MembersAndOwner$w3_encode_MembersAndOwner$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var1.joinedAt),
								$lamdera$containers$SeqSet$encodeSet$(
								$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_RoleId),
								w3_rec_var1.roles)
							]));
				},
				w3_rec_var0.membersAndOwner),
				$author$project$Evergreen$V417$GuildName$w3_encode_GuildName(w3_rec_var0.name),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_RoleId),
				$author$project$Evergreen$V417$LocalState$w3_encode_DiscordRole,
				w3_rec_var0.roles),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_StickerId),
				w3_rec_var0.stickers)
			]));
};
var $author$project$Evergreen$V417$LocalState$w3_encode_Archived = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.archivedAt),
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, w3_rec_var0.archivedBy)
			]));
};
var $author$project$Evergreen$V417$Thread$w3_encode_FrontendThread = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$justinmimbs$date$Date$w3_encode_Date,
				$author$project$Evergreen$V417$Drawing$w3_encode_Drawing(
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId)),
				w3_rec_var0.dateDividerDrawings),
				$author$project$Evergreen$V417$MessageArray$w3_encode_MessageArray$(
				$author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId,
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId),
				w3_rec_var0.messages),
				A2($author$project$Evergreen$V417$VisibleMessages$w3_encode_VisibleMessages, $author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId, w3_rec_var0.visibleMessages)
			]));
};
var $author$project$Evergreen$V417$Go$w3_encode_Phase = function (w3v) {
	switch (w3v.$) {
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.previousPlayerPassed)
								]));
					}(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.blackScore),
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.whiteScore)
								]));
					}(v0)
					]));
	}
};
var $author$project$Evergreen$V417$Go$w3_encode_Snapshot = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.blackCaptures),
				$lamdera$codecs$Lamdera$Wire3$encodeDict$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				$author$project$Evergreen$V417$Go$w3_encode_Stone,
				w3_rec_var0.board),
				$author$project$Evergreen$V417$Go$w3_encode_Stone(w3_rec_var0.currentPlayer),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.whiteCaptures)
			]));
};
var $author$project$Evergreen$V417$Go$w3_encode_Shared = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.blackCaptures),
				$lamdera$codecs$Lamdera$Wire3$encodeDict$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				$author$project$Evergreen$V417$Go$w3_encode_Stone,
				w3_rec_var0.board),
				$author$project$Evergreen$V417$Go$w3_encode_Stone(w3_rec_var0.currentPlayer),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V417$Go$w3_encode_Snapshot, w3_rec_var0.history),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				w3_rec_var0.joinedUserId),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.lastAction),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				w3_rec_var0.lastMove),
				$author$project$Evergreen$V417$Go$w3_encode_Phase(w3_rec_var0.phase),
				$lamdera$codecs$Lamdera$Wire3$encodeDict$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				$author$project$Evergreen$V417$Go$w3_encode_Stone,
				w3_rec_var0.territoryMarks),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var1.black),
								$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var1.white)
							]));
				},
				w3_rec_var0.timeLeft),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.turnCount),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.whiteCaptures)
			]));
};
var $author$project$Evergreen$V417$Game$w3_encode_FrontendGameData = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Go$w3_encode_ValidatedSetup(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Evergreen$V417$Go$w3_encode_ActionWithTime, v1),
						$author$project$Evergreen$V417$Go$w3_encode_Shared(v2)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$SheepGame$w3_encode_ValidatedSetup(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Evergreen$V417$SheepGame$w3_encode_ActionWithTime, v1),
						$author$project$Evergreen$V417$SheepGame$w3_encode_Shared(v2)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$WordSpellingGame$w3_encode_ValidatedSetup(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Evergreen$V417$WordSpellingGame$w3_encode_ActionWithTime, v1),
						$author$project$Evergreen$V417$WordSpellingGame$w3_encode_Shared(v2)
					]));
	}
};
var $author$project$Evergreen$V417$Game$w3_encode_MatchData = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					function (w3_rec_var0) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$author$project$Evergreen$V417$Game$w3_encode_FrontendGameData(w3_rec_var0.data),
								$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
								$author$project$Evergreen$V417$SecretId$w3_encode_SecretId($author$project$Evergreen$V417$Id$w3_encode_GamePublicId),
								w3_rec_var0.publicLink)
							]));
				}(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V417$Message$w3_encode_GameType(v0)
				]));
	}
};
var $author$project$Evergreen$V417$LocalState$w3_encode_FrontendChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.createdAt),
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, w3_rec_var0.createdBy),
				$lamdera$containers$SeqDict$encodeDict$(
				$justinmimbs$date$Date$w3_encode_Date,
				$author$project$Evergreen$V417$Drawing$w3_encode_Drawing(
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId)),
				w3_rec_var0.dateDividerDrawings),
				$author$project$Evergreen$V417$ChannelDescription$w3_encode_ChannelDescription(w3_rec_var0.description),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
				$author$project$Evergreen$V417$Game$w3_encode_MatchData,
				w3_rec_var0.games),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$LocalState$w3_encode_Archived, w3_rec_var0.isArchived),
				$author$project$Evergreen$V417$MessageArray$w3_encode_MessageArray$(
				$author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId,
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId),
				w3_rec_var0.messages),
				$author$project$Evergreen$V417$ChannelName$w3_encode_ChannelName(w3_rec_var0.name),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
				$author$project$Evergreen$V417$Thread$w3_encode_FrontendThread,
				w3_rec_var0.threads),
				A2($author$project$Evergreen$V417$VisibleMessages$w3_encode_VisibleMessages, $author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, w3_rec_var0.visibleMessages)
			]));
};
var $author$project$Evergreen$V417$LocalState$w3_encode_GuildMember = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.joinedAt),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.lastPostedAt)
			]));
};
var $author$project$Evergreen$V417$LocalState$w3_encode_FrontendGuild = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId),
				$author$project$Evergreen$V417$LocalState$w3_encode_FrontendChannel,
				w3_rec_var0.channels),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.createdAt),
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, w3_rec_var0.createdBy),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$SecretId$w3_encode_SecretId($author$project$Evergreen$V417$Id$w3_encode_InviteLinkId),
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var1.createdAt),
								$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, w3_rec_var1.createdBy)
							]));
				},
				w3_rec_var0.invites),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				$author$project$Evergreen$V417$Thread$w3_encode_LastTypedAt(
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId)),
				w3_rec_var0.lastTypedAt),
				$author$project$Evergreen$V417$MembersAndOwner$w3_encode_MembersAndOwner$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				$author$project$Evergreen$V417$LocalState$w3_encode_GuildMember,
				w3_rec_var0.membersAndOwner),
				$author$project$Evergreen$V417$GuildName$w3_encode_GuildName(w3_rec_var0.name)
			]));
};
var $author$project$Evergreen$V417$User$w3_encode_FrontendUser = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$UserColor$w3_encode_UserColor(w3_rec_var0.color),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
				$author$project$Evergreen$V417$PersonName$w3_encode_PersonName(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$X25519$w3_encode_PublicKey, w3_rec_var0.publicKey)
			]));
};
var $author$project$Evergreen$V417$UserSession$w3_encode_Viewing = function (w3v) {
	switch (w3v.$) {
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$UserSession$w3_encode_Viewing_ChannelData(v0)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$UserSession$w3_encode_Viewing_ChannelThreadData(v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$UserSession$w3_encode_Viewing_DiscordChannelData(v0)
					]));
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V417$UserSession$w3_encode_Viewing_DiscordChannelThreadData(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V417$UserSession$w3_encode_Viewing_DiscordDmData(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V417$UserSession$w3_encode_Viewing_DmData(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Evergreen$V417$UserSession$w3_encode_Viewing_DmThreadData(v0)
					]));
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 12:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V417$UserSession$w3_encode_Viewing_SlackChannelData(v0)
					]));
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Evergreen$V417$UserSession$w3_encode_Viewing_SlackChannelThreadData(v0)
					]));
		case 9:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$Evergreen$V417$UserSession$w3_encode_Viewing_SlackDmData(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$Evergreen$V417$UserSession$w3_encode_Viewing_SlackDmThreadData(v0)
					]));
	}
};
var $author$project$Evergreen$V417$UserSession$w3_encode_FrontendUserSession = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$($lamdera$program_test$Effect$Lamdera$w3_encode_ClientId, $author$project$Evergreen$V417$UserSession$w3_encode_Viewing, w3_rec_var0.currentlyViewing),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.lastActiveAt),
				$author$project$Evergreen$V417$UserSession$w3_encode_NotificationMode(w3_rec_var0.notificationMode),
				$author$project$Evergreen$V417$UserAgent$w3_encode_UserAgent(w3_rec_var0.userAgent)
			]));
};
var $author$project$Evergreen$V417$Call$w3_encode_CallId = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$Id$w3_encode_Viewing_DmId(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V417$Id$w3_encode_Viewing_ChannelId(v0)
				]));
	}
};
var $author$project$Evergreen$V417$LocalState$w3_encode_CallStatus = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$Call$w3_encode_CallId(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$LocalState$w3_encode_LastRequest = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$program_test$Effect$Time$w3_encode_Posix(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$LocalState$w3_encode_ConnectionData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$LocalState$w3_encode_CallStatus(w3_rec_var0.call),
				$author$project$Evergreen$V417$UserSession$w3_encode_Viewing(w3_rec_var0.currentlyViewing),
				$author$project$Evergreen$V417$LocalState$w3_encode_LastRequest(w3_rec_var0.lastRequest),
				$author$project$Evergreen$V417$Call$w3_encode_RemoteCallData(w3_rec_var0.remoteCallData)
			]));
};
var $author$project$Evergreen$V417$LocalState$w3_encode_BackupContents = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$LocalState$w3_encode_LastBackup = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$LocalState$w3_encode_BackupContents(w3_rec_var0.contents),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.createdAt)
			]));
};
var $author$project$Evergreen$V417$LocalState$w3_encode_LoadingDiscordChannelStep$ = function (w3_x_c_messages, w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						w3_x_c_messages(v1)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$Discord$w3_encode_HttpError(v0)
					]));
	}
};
var $author$project$Evergreen$V417$LocalState$w3_encode_LoadingDiscordChannelStep = F2($author$project$Evergreen$V417$LocalState$w3_encode_LoadingDiscordChannelStep$);
var $author$project$Evergreen$V417$LocalState$w3_encode_LoadingDiscordChannel$ = function (w3_x_c_messages, w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		var v2 = w3v.c;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
					$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId, v1),
					$author$project$Evergreen$V417$LocalState$w3_encode_LoadingDiscordChannelStep$(w3_x_c_messages, v2)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		var v2 = w3v.c;
		var v3 = w3v.d;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
					$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v1),
					$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, v2),
					$author$project$Evergreen$V417$LocalState$w3_encode_LoadingDiscordChannelStep$(w3_x_c_messages, v3)
				]));
	}
};
var $author$project$Evergreen$V417$LocalState$w3_encode_LoadingDiscordChannel = F2($author$project$Evergreen$V417$LocalState$w3_encode_LoadingDiscordChannel$);
var $author$project$Evergreen$V417$Pagination$w3_encode_PageStatus$ = function (w3_x_c_a, w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$codecs$Lamdera$Wire3$encodeArray$(w3_x_c_a, v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$Pagination$w3_encode_PageStatus = F2($author$project$Evergreen$V417$Pagination$w3_encode_PageStatus$);
var $author$project$Evergreen$V417$Pagination$w3_encode_Pagination = function (w3_x_c_a) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Pagination$w3_encode_PageId, w3_rec_var0.currentPage),
					$lamdera$containers$SeqDict$encodeDict$(
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Pagination$w3_encode_PageId),
					$author$project$Evergreen$V417$Pagination$w3_encode_PageStatus(w3_x_c_a),
					w3_rec_var0.pages),
					$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Pagination$w3_encode_PageId, w3_rec_var0.previousPage),
					$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.totalItems)
				]));
	};
};
var $author$project$Evergreen$V417$Pages$Admin$w3_encode_TypeThatIsAlwaysInvalid = function (w3v) {
	return $elm$bytes$Bytes$Encode$unsignedInt8(0);
};
var $author$project$Evergreen$V417$LocalState$w3_encode_WordSpellingGameStatus = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v0)
					]));
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Evergreen$V417$Pages$Admin$w3_encode_InitAdminData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Pages$Admin$w3_encode_TypeThatIsAlwaysInvalid(w3_rec_var0.checkToFrontendValidation),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V417$SessionIdHash$w3_encode_SessionIdHash,
					A2($author$project$Evergreen$V417$NonemptyDict$w3_encode_NonemptyDict, $lamdera$program_test$Effect$Lamdera$w3_encode_ClientId, $author$project$Evergreen$V417$LocalState$w3_encode_ConnectionData)),
				w3_rec_var0.connections),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.discordLinkLimit),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.discordLinkingEnabled),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.emailNotificationsEnabled),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.filesCount),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$LocalState$w3_encode_LastBackup, w3_rec_var0.lastBackup),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
				$author$project$Evergreen$V417$LocalState$w3_encode_LoadingDiscordChannel($lamdera$codecs$Lamdera$Wire3$encodeInt),
				w3_rec_var0.loadingDiscordChannels),
				A2($author$project$Evergreen$V417$Pagination$w3_encode_Pagination, $author$project$Evergreen$V417$LocalState$w3_encode_LogWithTime, w3_rec_var0.logs),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				w3_rec_var0.notifyAdminsBotUserId),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.notifyAdminsToken),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.openRouterKey),
				$author$project$Evergreen$V417$Postmark$w3_encode_ApiKey(w3_rec_var0.postmarkApiKey),
				$author$project$Evergreen$V417$LocalState$w3_encode_PrivateVapidKey(w3_rec_var0.privateVapidKey),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeString, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				w3_rec_var0.seqDictWorks),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.serverSecretRegeneratedAt),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.signupsEnabled),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.slackLinkLimit),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.slackLinkingEnabled),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				$lamdera$program_test$Effect$Time$w3_encode_Posix,
				w3_rec_var0.twoFactorAuthentication),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.vulnerabilityChecks),
				$author$project$Evergreen$V417$LocalState$w3_encode_WordSpellingGameStatus(w3_rec_var0.wordSpellingGameEnglish),
				$author$project$Evergreen$V417$LocalState$w3_encode_WordSpellingGameStatus(w3_rec_var0.wordSpellingGameSwedish)
			]));
};
var $author$project$Evergreen$V417$LocalState$w3_encode_JoinGuildError = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V417$Types$w3_encode_RepliedToData = function (w3v) {
	switch (w3v.$) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$Game$w3_encode_LoadedMatch(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$Message$w3_encode_Message$(
						$author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId,
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId),
						v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V417$Message$w3_encode_Message$(
						$author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId,
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId),
						v0)
					]));
	}
};
var $author$project$Evergreen$V417$Call$w3_encode_ConnectionId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodePair$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId,
				w3_rec_var0.otherClientId),
				$author$project$Evergreen$V417$Call$w3_encode_CallId(w3_rec_var0.roomId)
			]));
};
var $author$project$Evergreen$V417$Call$w3_encode_RecordingStatus = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$containers$SeqSet$encodeSet$(
									$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
									w3_rec_var0.allowedBy),
									$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.requestedAt),
									$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, w3_rec_var0.requestedBy)
								]));
					}(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.declinedAt),
									$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
									$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
									w3_rec_var0.declinedBy),
									$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, w3_rec_var0.requestedBy)
								]));
					}(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0)
					]));
	}
};
var $author$project$Evergreen$V417$Call$w3_encode_ServerChange = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Call$w3_encode_ConnectionId(v1)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Call$w3_encode_ConnectionId(v1)
					]));
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$Call$w3_encode_CallId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Call$w3_encode_RecordingStatus, v1)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V417$Call$w3_encode_ConnectionId(v0),
						$author$project$Evergreen$V417$Call$w3_encode_RemoteCallData(v1)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Call$w3_encode_CallId(v1)
					]));
	}
};
var $author$project$Evergreen$V417$TextEditor$w3_encode_ServerChange = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$TextEditor$w3_encode_EditChange(v1)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0)
					]));
	}
};
var $author$project$Evergreen$V417$Thread$w3_encode_FrontendGenericThread$ = function (w3_x_c_userId, w3_x_c_channelId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$containers$SeqDict$encodeDict$(
					$justinmimbs$date$Date$w3_encode_Date,
					$author$project$Evergreen$V417$Drawing$w3_encode_Drawing(w3_x_c_userId),
					w3_rec_var0.dateDividerDrawings),
					$author$project$Evergreen$V417$MessageArray$w3_encode_MessageArray$($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId, w3_x_c_userId, w3_x_c_channelId, w3_rec_var0.messages),
					A2($author$project$Evergreen$V417$VisibleMessages$w3_encode_VisibleMessages, $author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId, w3_rec_var0.visibleMessages)
				]));
	};
};
var $author$project$Evergreen$V417$Thread$w3_encode_FrontendGenericThread = F2($author$project$Evergreen$V417$Thread$w3_encode_FrontendGenericThread$);
var $author$project$Evergreen$V417$Thread$w3_encode_SlackFrontendThread = $author$project$Evergreen$V417$Thread$w3_encode_FrontendGenericThread$(
	$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_UserId),
	$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_ChannelId));
var $author$project$Evergreen$V417$LocalState$w3_encode_SlackFrontendDmChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$NonemptySet$w3_encode_NonemptySet$(
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_UserId),
				w3_rec_var0.members),
				$author$project$Evergreen$V417$MessageArray$w3_encode_MessageArray$(
				$author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId,
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_UserId),
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_ChannelId),
				w3_rec_var0.messages),
				$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_TeamId, w3_rec_var0.teamId),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
				$author$project$Evergreen$V417$Thread$w3_encode_SlackFrontendThread,
				w3_rec_var0.threads),
				A2($author$project$Evergreen$V417$VisibleMessages$w3_encode_VisibleMessages, $author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, w3_rec_var0.visibleMessages)
			]));
};
var $author$project$Evergreen$V417$UserSession$w3_encode_SlackFrontendUser = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$UserColor$w3_encode_UserColor(w3_rec_var0.color),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
				$author$project$Evergreen$V417$PersonName$w3_encode_PersonName(w3_rec_var0.name),
				$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_TeamId, w3_rec_var0.teamId)
			]));
};
var $author$project$Evergreen$V417$LocalState$w3_encode_SlackFrontendChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isPrivate),
				$author$project$Evergreen$V417$MessageArray$w3_encode_MessageArray$(
				$author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId,
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_UserId),
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_ChannelId),
				w3_rec_var0.messages),
				$author$project$Evergreen$V417$ChannelName$w3_encode_ChannelName(w3_rec_var0.name),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
				$author$project$Evergreen$V417$Thread$w3_encode_SlackFrontendThread,
				w3_rec_var0.threads),
				A2($author$project$Evergreen$V417$VisibleMessages$w3_encode_VisibleMessages, $author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, w3_rec_var0.visibleMessages)
			]));
};
var $author$project$Evergreen$V417$LocalState$w3_encode_SlackFrontendWorkspace = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_ChannelId),
				$author$project$Evergreen$V417$LocalState$w3_encode_SlackFrontendChannel,
				w3_rec_var0.channels),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_CustomEmojiId),
				w3_rec_var0.customEmojis),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name)
			]));
};
var $author$project$Evergreen$V417$Discord$w3_encode_StickerFormatType = function (w3v) {
	switch (w3v) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Evergreen$V417$Discord$w3_encode_StickerId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$Sticker$w3_encode_StickerUrl = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_StickerId, v0)
					]));
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$FileStatus$w3_encode_FileHash(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
						$author$project$Evergreen$V417$Coord$w3_encode_Coord($author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels),
						v1)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V417$Sticker$w3_encode_StickerData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Discord$w3_encode_StickerFormatType(w3_rec_var0.format),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
				$author$project$Evergreen$V417$Sticker$w3_encode_StickerUrl(w3_rec_var0.url)
			]));
};
var $author$project$Evergreen$V417$Types$w3_encode_ServerChange = function (w3v) {
	switch (w3v.$) {
		case 30:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_GuildOrDmId(v1),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v2),
						$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji(v3)
					]));
		case 73:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$LocalState$w3_encode_LastBackup(v0)
					]));
		case 31:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$Id$w3_encode_GuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v1),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v2),
						$author$project$Evergreen$V417$NonemptySet$w3_encode_NonemptySet$(
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
						v3)
					]));
		case 33:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V417$Id$w3_encode_GuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v2)
					]));
		case 32:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V417$Id$w3_encode_GuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v1),
						A2(
						$author$project$Evergreen$V417$Message$w3_encode_CallRecordingFile,
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
						v2)
					]));
		case 34:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V417$Id$w3_encode_GuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V417$Message$w3_encode_CallRecordingZip(v2)
					]));
		case 60:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Evergreen$V417$SessionIdHash$w3_encode_SessionIdHash(v0),
						$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId(v1),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v2)
					]));
		case 59:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Evergreen$V417$SessionIdHash$w3_encode_SessionIdHash(v0),
						$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId(v1),
						$author$project$Evergreen$V417$UserSession$w3_encode_Viewing(v2)
					]));
		case 19:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelId, v1)
					]));
		case 21:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0)
					]));
		case 23:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$SecretId$w3_encode_SecretId$($author$project$Evergreen$V417$Id$w3_encode_InviteLinkId, v1)
					]));
		case 44:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 109:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v1),
						$author$project$Evergreen$V417$Id$w3_encode_Viewing_DmId(v2)
					]));
		case 37:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId, v1),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v2),
						$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji(v3)
					]));
		case 36:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, v2),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v3),
						$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji(v4)
					]));
		case 101:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$UserSession$w3_encode_DiscordFrontendUser(v1)
					]));
		case 64:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v2),
						$author$project$Evergreen$V417$ChannelName$w3_encode_ChannelName(v3),
						$author$project$Evergreen$V417$Discord$w3_encode_OptionalData$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$codecs$Lamdera$Wire3$encodeString),
						v4),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V417$Discord$w3_encode_Overwrite, v5)
					]));
		case 81:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, v1)
					]));
		case 47:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v1)
					]));
		case 45:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(19),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v2)
					]));
		case 65:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(20),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId, v0),
						$author$project$Evergreen$V417$NonemptyDict$w3_encode_NonemptyDict$(
						$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
						function (w3_rec_var0) {
							return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
								_List_fromArray(
									[
										$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.messagesSent)
									]));
						},
						v1)
					]));
		case 66:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(21),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v1)
					]));
		case 29:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(22),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v1),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId, v2)
					]));
		case 46:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(23),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v2)
					]));
		case 78:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(24),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V417$LocalState$w3_encode_DiscordFrontendGuild(v2)
					]));
		case 79:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(25),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v1)
					]));
		case 86:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(26),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, v2),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v3),
						$author$project$Evergreen$V417$PersonName$w3_encode_PersonName(v4),
						$author$project$Evergreen$V417$UserColor$w3_encode_UserColor(v5)
					]));
		case 28:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(27),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v1),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v2),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, v3),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRoute(v4)
					]));
		case 67:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(28),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0)
					]));
		case 39:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(29),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId, v1),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v2),
						$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji(v3)
					]));
		case 38:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(30),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, v2),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v3),
						$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji(v4)
					]));
		case 42:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(31),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Id$w3_encode_Viewing_DiscordDmId(v1),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v2),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2(
							$author$project$Evergreen$V417$RichText$w3_encode_RichText,
							$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
							$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_ChannelId)),
						v3)
					]));
		case 41:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(32),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v1),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v2),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, v3),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v4),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2(
							$author$project$Evergreen$V417$RichText$w3_encode_RichText,
							$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
							$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_ChannelId)),
						v5)
					]));
		case 80:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(33),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V417$Discord$w3_encode_OptionalData$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$codecs$Lamdera$Wire3$encodeString),
						v2),
						$author$project$Evergreen$V417$Discord$w3_encode_OptionalData$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$codecs$Lamdera$Wire3$encodeString),
						v3),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V417$Discord$w3_encode_Overwrite, v4)
					]));
		case 82:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(34),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$GuildName$w3_encode_GuildName(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$FileStatus$w3_encode_FileHash, v2),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_RoleId),
						$author$project$Evergreen$V417$LocalState$w3_encode_DiscordRole,
						v3)
					]));
		case 84:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(35),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v0),
						$lamdera$containers$SeqSet$encodeSet$(
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_CustomEmojiId),
						v1)
					]));
		case 83:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(36),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_RoleId, v1),
						$author$project$Evergreen$V417$LocalState$w3_encode_DiscordRole(v2)
					]));
		case 68:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(37),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$(
						$lamdera$program_test$Effect$Time$w3_encode_Posix,
						function (w3_rec_var0) {
							return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
								_List_fromArray(
									[
										$lamdera$containers$SeqDict$encodeDict$(
										$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId),
										$author$project$Evergreen$V417$DmChannel$w3_encode_DiscordFrontendDmChannel,
										w3_rec_var0.discordDms),
										$lamdera$containers$SeqDict$encodeDict$(
										$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_GuildId),
										$author$project$Evergreen$V417$LocalState$w3_encode_DiscordFrontendGuild,
										w3_rec_var0.discordGuilds),
										$lamdera$containers$SeqDict$encodeDict$(
										$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
										$author$project$Evergreen$V417$UserSession$w3_encode_DiscordFrontendUser,
										w3_rec_var0.discordUsers),
										$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.markEverythingAsViewed)
									]));
						},
						v1)
					]));
		case 15:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			var v6 = w3v.g;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(38),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Id$w3_encode_DiscordGuildOrDmId(v1),
						$author$project$Evergreen$V417$UserSession$w3_encode_DiscordFrontendUser(v2),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2(
							$author$project$Evergreen$V417$RichText$w3_encode_RichText,
							$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
							$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_ChannelId)),
						v3),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMaybeMessage(v4),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$FileStatus$w3_encode_FileId),
						$author$project$Evergreen$V417$FileStatus$w3_encode_FileData,
						v5),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_StickerId),
						$author$project$Evergreen$V417$Sticker$w3_encode_StickerData,
						v6)
					]));
		case 91:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(39),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId(v1),
						$author$project$Evergreen$V417$Drawing$w3_encode_AnchorType(v2),
						$author$project$Evergreen$V417$Drawing$w3_encode_LocalChange(v3)
					]));
		case 105:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(40),
						$author$project$Evergreen$V417$Id$w3_encode_Viewing_DmId(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v1)
					]));
		case 103:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(41),
						$author$project$Evergreen$V417$Id$w3_encode_Viewing_DmId(v0)
					]));
		case 104:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(42),
						$author$project$Evergreen$V417$Id$w3_encode_Viewing_DmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v1)
					]));
		case 102:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(43),
						$author$project$Evergreen$V417$Id$w3_encode_Viewing_DmId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
						$author$project$Evergreen$V417$SessionIdHash$w3_encode_SessionIdHash,
						v1)
					]));
		case 18:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(44),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V417$ChannelName$w3_encode_ChannelName(v2),
						$author$project$Evergreen$V417$ChannelDescription$w3_encode_ChannelDescription(v3)
					]));
		case 20:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(45),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$GuildName$w3_encode_GuildName(v1)
					]));
		case 90:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(46),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_GuildOrDmId(v1),
						$author$project$Evergreen$V417$Game$w3_encode_LocalChange(v2)
					]));
		case 77:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(47),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v1),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$elm$url$Url$w3_encode_Url,
						A2($lamdera$codecs$Lamdera$Wire3$encodeResult, $lamdera$codecs$Lamdera$Wire3$encodeUnit, $author$project$Evergreen$V417$Embed$w3_encode_EmbedData),
						v2)
					]));
		case 76:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(48),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v2),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$elm$url$Url$w3_encode_Url,
						A2($lamdera$codecs$Lamdera$Wire3$encodeResult, $lamdera$codecs$Lamdera$Wire3$encodeUnit, $author$project$Evergreen$V417$Embed$w3_encode_EmbedData),
						v3)
					]));
		case 75:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(49),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v1),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$elm$url$Url$w3_encode_Url,
						A2($lamdera$codecs$Lamdera$Wire3$encodeResult, $lamdera$codecs$Lamdera$Wire3$encodeUnit, $author$project$Evergreen$V417$Embed$w3_encode_EmbedData),
						v2)
					]));
		case 74:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(50),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v2),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$elm$url$Url$w3_encode_Url,
						A2($lamdera$codecs$Lamdera$Wire3$encodeResult, $lamdera$codecs$Lamdera$Wire3$encodeUnit, $author$project$Evergreen$V417$Embed$w3_encode_EmbedData),
						v3)
					]));
		case 17:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(51),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V417$LocalState$w3_encode_FrontendChannel(v2)
					]));
		case 62:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(52),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$LinkedAndOtherDiscordUsers$w3_encode_DiscordFrontendCurrentUser(v1)
					]));
		case 88:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(53),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_CustomEmojiId),
						$author$project$Evergreen$V417$CustomEmoji$w3_encode_CustomEmojiData,
						v0)
					]));
		case 87:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(54),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_StickerId),
						$author$project$Evergreen$V417$Sticker$w3_encode_StickerData,
						v0)
					]));
		case 71:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(55),
						$author$project$Evergreen$V417$Pages$Admin$w3_encode_InitAdminData(v0)
					]));
		case 70:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(56),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
						$author$project$Evergreen$V417$LocalState$w3_encode_LoadingDiscordChannel($lamdera$codecs$Lamdera$Wire3$encodeInt),
						v1)
					]));
		case 58:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(57),
						$author$project$Evergreen$V417$SessionIdHash$w3_encode_SessionIdHash(v0)
					]));
		case 43:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(58),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v1),
						$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId(v2),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v3)
					]));
		case 24:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(59),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v1),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v2),
						$author$project$Evergreen$V417$User$w3_encode_FrontendUser(v3)
					]));
		case 25:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(60),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v1)
					]));
		case 27:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(61),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v1),
						$author$project$Evergreen$V417$Id$w3_encode_GuildOrDmId(v2),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRoute(v3)
					]));
		case 16:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(62),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v1),
						$author$project$Evergreen$V417$ChannelName$w3_encode_ChannelName(v2),
						$author$project$Evergreen$V417$ChannelDescription$w3_encode_ChannelDescription(v3)
					]));
		case 22:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(63),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v1),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v2),
						$author$project$Evergreen$V417$SecretId$w3_encode_SecretId$($author$project$Evergreen$V417$Id$w3_encode_InviteLinkId, v3)
					]));
		case 72:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(64),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Log$w3_encode_Log(v1)
					]));
		case 57:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(65),
						$author$project$Evergreen$V417$SessionIdHash$w3_encode_SessionIdHash(v0),
						$author$project$Evergreen$V417$UserSession$w3_encode_FrontendUserSession(v1)
					]));
		case 56:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(66),
						$author$project$Evergreen$V417$Ports$w3_encode_SubscribeData(v0),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v1)
					]));
		case 52:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(67),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 35:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(68),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_GuildOrDmId(v1),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v2),
						$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji(v3)
					]));
		case 40:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(69),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v1),
						$author$project$Evergreen$V417$Id$w3_encode_GuildOrDmId(v2),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v3),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2(
							$author$project$Evergreen$V417$RichText$w3_encode_RichText,
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId)),
						v4),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$FileStatus$w3_encode_FileId),
						$author$project$Evergreen$V417$FileStatus$w3_encode_FileData,
						v5)
					]));
		case 108:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(70),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v1),
						$author$project$Evergreen$V417$Id$w3_encode_Viewing_DmId(v2),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v3),
						$lamdera$containers$SeqSet$encodeSet$($author$project$Evergreen$V417$FileStatus$w3_encode_FileHash, v4),
						$author$project$Evergreen$V417$Encryption$w3_encode_EncryptedData$(
						$author$project$Evergreen$V417$Message$w3_encode_MessageContent$(
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId)),
						v5)
					]));
		case 107:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(71),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Evergreen$V417$Encryption$w3_encode_EncryptedData$(
									$author$project$Evergreen$V417$Message$w3_encode_MessageContent$(
										$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
										$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId)),
									w3_rec_var0.content),
									$lamdera$containers$SeqSet$encodeSet$($author$project$Evergreen$V417$FileStatus$w3_encode_FileHash, w3_rec_var0.fileHashes),
									$author$project$Evergreen$V417$Id$w3_encode_Viewing_DmId(w3_rec_var0.id),
									$author$project$Evergreen$V417$Types$w3_encode_RepliedToData(w3_rec_var0.repliedToData),
									$author$project$Evergreen$V417$User$w3_encode_FrontendUser(w3_rec_var0.sender),
									$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, w3_rec_var0.senderId),
									$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.sentAt),
									$author$project$Evergreen$V417$Message$w3_encode_ThreadRouteWithRepliedTo(w3_rec_var0.threadRoute)
								]));
					}(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(72),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$containers$SeqDict$encodeDict$(
									$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$FileStatus$w3_encode_FileId),
									$author$project$Evergreen$V417$FileStatus$w3_encode_FileData,
									w3_rec_var0.attachedFiles),
									$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
									A2(
										$author$project$Evergreen$V417$RichText$w3_encode_RichText,
										$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
										$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId)),
									w3_rec_var0.content),
									$author$project$Evergreen$V417$Id$w3_encode_GuildOrDmId(w3_rec_var0.guildOrDmId),
									$author$project$Evergreen$V417$Types$w3_encode_RepliedToData(w3_rec_var0.repliedToData),
									$author$project$Evergreen$V417$User$w3_encode_FrontendUser(w3_rec_var0.sender),
									$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, w3_rec_var0.senderId),
									$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.sentAt),
									$lamdera$containers$SeqDict$encodeDict$(
									$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_StickerId),
									$author$project$Evergreen$V417$Sticker$w3_encode_StickerData,
									w3_rec_var0.stickers),
									$author$project$Evergreen$V417$Message$w3_encode_ThreadRouteWithRepliedTo(w3_rec_var0.threadRoute)
								]));
					}(v0)
					]));
		case 54:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(73),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$User$w3_encode_NotificationLevel(v1)
					]));
		case 51:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(74),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$FileStatus$w3_encode_FileHash, v1)
					]));
		case 53:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(75),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$User$w3_encode_NotificationLevel(v1)
					]));
		case 92:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(76),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(v2)
					]));
		case 94:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(77),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(v2)
					]));
		case 97:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(78),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(v1)
					]));
		case 95:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(79),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v2),
						$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(v3)
					]));
		case 96:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(80),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(v1)
					]));
		case 99:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(81),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_TeamId, v0),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(v2)
					]));
		case 100:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(82),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_TeamId, v0),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v2),
						$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(v3)
					]));
		case 98:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(83),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_TeamId, v0),
						$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(v1)
					]));
		case 93:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(84),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v2),
						$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(v3)
					]));
		case 48:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(85),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$PersonName$w3_encode_PersonName(v1)
					]));
		case 106:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(86),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$X25519$w3_encode_PublicKey(v1)
					]));
		case 55:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(87),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_TeamId, v0),
						$author$project$Evergreen$V417$User$w3_encode_NotificationLevel(v1)
					]));
		case 49:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(88),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$UserColor$w3_encode_UserColor(v1)
					]));
		case 50:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(89),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$FileStatus$w3_encode_FileHash, v1)
					]));
		case 13:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(90),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_SlackGuildOrDmId(v1),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v2),
						$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji(v3)
					]));
		case 7:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(91),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_TeamId, v0),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V417$ChannelName$w3_encode_ChannelName(v2)
					]));
		case 12:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(92),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_TeamId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_CustomEmojiId, v1),
						$author$project$Evergreen$V417$CustomEmoji$w3_encode_CustomEmojiData(v2)
					]));
		case 11:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(93),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_CustomEmojiId),
						$author$project$Evergreen$V417$CustomEmoji$w3_encode_CustomEmojiData,
						v0)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(94),
						$author$project$Evergreen$V417$Id$w3_encode_SlackGuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(95),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_UserId, v1),
						$author$project$Evergreen$V417$Id$w3_encode_SlackGuildOrDmId(v2),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v3),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2(
							$author$project$Evergreen$V417$RichText$w3_encode_RichText,
							$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_UserId),
							$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_ChannelId)),
						v4)
					]));
		case 9:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(96),
						$author$project$Evergreen$V417$Id$w3_encode_SlackGuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v1),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$elm$url$Url$w3_encode_Url,
						A2($lamdera$codecs$Lamdera$Wire3$encodeResult, $lamdera$codecs$Lamdera$Wire3$encodeUnit, $author$project$Evergreen$V417$Embed$w3_encode_EmbedData),
						v2)
					]));
		case 10:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(97),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_TeamId, v1),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$containers$SeqDict$encodeDict$(
									$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_CustomEmojiId),
									$author$project$Evergreen$V417$CustomEmoji$w3_encode_CustomEmojiData,
									w3_rec_var0.customEmojis),
									$lamdera$containers$SeqDict$encodeDict$(
									$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_DmChannelId),
									$author$project$Evergreen$V417$LocalState$w3_encode_SlackFrontendDmChannel,
									w3_rec_var0.dmChannels),
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.markNewDmsAsViewed),
									$lamdera$containers$SeqDict$encodeDict$(
									$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_UserId),
									$author$project$Evergreen$V417$UserSession$w3_encode_SlackFrontendUser,
									w3_rec_var0.users),
									$lamdera$containers$SeqDict$encodeDict$(
									$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_TeamId),
									$author$project$Evergreen$V417$LocalState$w3_encode_SlackFrontendWorkspace,
									w3_rec_var0.workspaces)
								]));
					}(v2)
					]));
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(98),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_UserId, v0)
					]));
		case 14:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(99),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_SlackGuildOrDmId(v1),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v2),
						$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji(v3)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(100),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Id$w3_encode_SlackGuildOrDmId(v1),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRoute(v2),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2(
							$author$project$Evergreen$V417$RichText$w3_encode_RichText,
							$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_UserId),
							$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_ChannelId)),
						v3),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$FileStatus$w3_encode_FileId),
						$author$project$Evergreen$V417$FileStatus$w3_encode_FileData,
						v4),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
						A3(
							$author$project$Evergreen$V417$Message$w3_encode_Message,
							$author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId,
							$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_UserId),
							$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_ChannelId)),
						v5)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(101),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_UserId, v0)
					]));
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(102),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$UserSession$w3_encode_SlackFrontendUser(v1)
					]));
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(103),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_TeamId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 69:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(104),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v1)
					]));
		case 61:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(105),
						$author$project$Evergreen$V417$TextEditor$w3_encode_ServerChange(v0)
					]));
		case 63:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(106),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0)
					]));
		case 85:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(107),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$MembersAndOwner$w3_encode_MembersAndOwner$(
						$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
						function (w3_rec_var0) {
							return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
								_List_fromArray(
									[
										$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.joinedAt),
										$lamdera$containers$SeqSet$encodeSet$(
										$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_RoleId),
										w3_rec_var0.roles)
									]));
						},
						v1)
					]));
		case 89:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(108),
						$author$project$Evergreen$V417$Call$w3_encode_ServerChange(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(109),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$(
						$author$project$Evergreen$V417$LocalState$w3_encode_JoinGuildError,
						function (w3_rec_var0) {
							return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
								_List_fromArray(
									[
										$author$project$Evergreen$V417$LocalState$w3_encode_FrontendGuild(w3_rec_var0.guild),
										$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, w3_rec_var0.guildId),
										$lamdera$containers$SeqDict$encodeDict$(
										$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
										$author$project$Evergreen$V417$User$w3_encode_FrontendUser,
										w3_rec_var0.members),
										$author$project$Evergreen$V417$User$w3_encode_FrontendUser(w3_rec_var0.owner)
									]));
						},
						v0)
					]));
	}
};
var $author$project$Evergreen$V417$Types$w3_encode_LocalMsg = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0),
					$author$project$Evergreen$V417$Types$w3_encode_LocalChange(v1)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V417$Types$w3_encode_ServerChange(v0)
				]));
	}
};
var $author$project$Evergreen$V417$LocalState$w3_encode_AdminDataStatus$ = function (w3_x_c_a, w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						w3_x_c_a(v0)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V417$LocalState$w3_encode_AdminDataStatus = F2($author$project$Evergreen$V417$LocalState$w3_encode_AdminDataStatus$);
var $author$project$Evergreen$V417$LocalState$w3_encode_DeleteOrphanedFilesStatus = function (w3v) {
	switch (w3v.$) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V417$LocalState$w3_encode_ServerSecretStatus = function (w3v) {
	switch (w3v.$) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v0)
					]));
	}
};
var $author$project$Evergreen$V417$LocalState$w3_encode_AdminData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$LocalState$w3_encode_AdminDataStatus$(
				$lamdera$codecs$Lamdera$Wire3$encodeArray($author$project$Evergreen$V417$BackendMsgLog$w3_encode_BackendMsgLogData),
				w3_rec_var0.backendMsgLogs),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V417$SessionIdHash$w3_encode_SessionIdHash,
					A2($author$project$Evergreen$V417$NonemptyDict$w3_encode_NonemptyDict, $lamdera$program_test$Effect$Lamdera$w3_encode_ClientId, $author$project$Evergreen$V417$LocalState$w3_encode_ConnectionData)),
				w3_rec_var0.connections),
				$author$project$Evergreen$V417$LocalState$w3_encode_DeleteOrphanedFilesStatus(w3_rec_var0.deleteOrphanedFiles),
				$author$project$Evergreen$V417$LocalState$w3_encode_AdminDataStatus$(
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_GuildId),
					$author$project$Evergreen$V417$LocalState$w3_encode_AdminData_DeletedGuild),
				w3_rec_var0.deletedGuilds),
				$author$project$Evergreen$V417$LocalState$w3_encode_AdminDataStatus$(
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId),
					$author$project$Evergreen$V417$LocalState$w3_encode_AdminData_DiscordDmChannel),
				w3_rec_var0.discordDmChannels),
				$author$project$Evergreen$V417$LocalState$w3_encode_AdminDataStatus$(
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_GuildId),
					$author$project$Evergreen$V417$LocalState$w3_encode_AdminData_DiscordGuild),
				w3_rec_var0.discordGuilds),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.discordLinkLimit),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.discordLinkingEnabled),
				$author$project$Evergreen$V417$LocalState$w3_encode_AdminDataStatus$(
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
					$author$project$Evergreen$V417$LocalState$w3_encode_DiscordUserData_ForAdmin),
				w3_rec_var0.discordUsers),
				$author$project$Evergreen$V417$LocalState$w3_encode_AdminDataStatus$(
				A2($lamdera$containers$SeqDict$encodeDict, $author$project$Evergreen$V417$DmChannelId$w3_encode_DmChannelId, $author$project$Evergreen$V417$LocalState$w3_encode_AdminData_DmChannel),
				w3_rec_var0.dmChannels),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.emailNotificationsEnabled),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.filesCount),
				$author$project$Evergreen$V417$LocalState$w3_encode_AdminDataStatus$(
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_GuildId),
					$author$project$Evergreen$V417$LocalState$w3_encode_AdminData_Guild),
				w3_rec_var0.guilds),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$LocalState$w3_encode_LastBackup, w3_rec_var0.lastBackup),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
				$author$project$Evergreen$V417$LocalState$w3_encode_LoadingDiscordChannel($lamdera$codecs$Lamdera$Wire3$encodeInt),
				w3_rec_var0.loadingDiscordChannels),
				A2($author$project$Evergreen$V417$Pagination$w3_encode_Pagination, $author$project$Evergreen$V417$LocalState$w3_encode_LogWithTime, w3_rec_var0.logs),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				w3_rec_var0.notifyAdminsBotUserId),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.notifyAdminsToken),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.openRouterKey),
				$author$project$Evergreen$V417$LocalState$w3_encode_AdminDataStatus$(
				A2($lamdera$containers$SeqDict$encodeDict, $author$project$Evergreen$V417$FileStatus$w3_encode_FileHash, $author$project$Evergreen$V417$FileStatus$w3_encode_BackendFileData),
				w3_rec_var0.orphanedFiles),
				$author$project$Evergreen$V417$Postmark$w3_encode_ApiKey(w3_rec_var0.postmarkKey),
				$author$project$Evergreen$V417$LocalState$w3_encode_PrivateVapidKey(w3_rec_var0.privateVapidKey),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeString, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				w3_rec_var0.seqDictWorks),
				$author$project$Evergreen$V417$LocalState$w3_encode_ServerSecretStatus(w3_rec_var0.serverSecretRefreshedAt),
				$author$project$Evergreen$V417$LocalState$w3_encode_AdminDataStatus$(
				A2($lamdera$containers$SeqDict$encodeDict, $author$project$Evergreen$V417$SessionIdHash$w3_encode_SessionIdHash, $author$project$Evergreen$V417$UserSession$w3_encode_UserSession),
				w3_rec_var0.sessions),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.signupsEnabled),
				$author$project$Evergreen$V417$LocalState$w3_encode_AdminDataStatus$(
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_DmChannelId),
					$author$project$Evergreen$V417$LocalState$w3_encode_AdminData_SlackDmChannel),
				w3_rec_var0.slackDmChannels),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.slackLinkLimit),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.slackLinkingEnabled),
				$author$project$Evergreen$V417$LocalState$w3_encode_AdminDataStatus$(
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_TeamId),
					$author$project$Evergreen$V417$LocalState$w3_encode_AdminData_SlackWorkspace),
				w3_rec_var0.slackWorkspaces),
				$author$project$Evergreen$V417$LocalState$w3_encode_AdminDataStatus$(
				$lamdera$codecs$Lamdera$Wire3$encodeArray($author$project$Evergreen$V417$ToBackendLog$w3_encode_ToBackendLogData),
				w3_rec_var0.toBackendLogs),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				$lamdera$program_test$Effect$Time$w3_encode_Posix,
				w3_rec_var0.twoFactorAuthentication),
				$author$project$Evergreen$V417$LocalState$w3_encode_AdminDataStatus$(
				A2(
					$author$project$Evergreen$V417$NonemptyDict$w3_encode_NonemptyDict,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
					$author$project$Evergreen$V417$User$w3_encode_BackendUser),
				w3_rec_var0.users),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.vulnerabilityChecks),
				$author$project$Evergreen$V417$LocalState$w3_encode_AdminDataStatus$(
				$lamdera$codecs$Lamdera$Wire3$encodeArray($author$project$Evergreen$V417$LocalState$w3_encode_WebsocketClosedEvent),
				w3_rec_var0.websocketCloseEvents),
				$author$project$Evergreen$V417$LocalState$w3_encode_WordSpellingGameStatus(w3_rec_var0.wordSpellingGameEnglish),
				$author$project$Evergreen$V417$LocalState$w3_encode_WordSpellingGameStatus(w3_rec_var0.wordSpellingGameSwedish)
			]));
};
var $author$project$Evergreen$V417$LocalState$w3_encode_AdminStatus = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$LocalState$w3_encode_AdminData(v0)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V417$DmChannel$w3_encode_E2eeEnabledData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.enabledAt),
				$lamdera$codecs$Lamdera$Wire3$encodePair$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				$author$project$Evergreen$V417$SessionIdHash$w3_encode_SessionIdHash,
				w3_rec_var0.requestedBy)
			]));
};
var $author$project$Evergreen$V417$DmChannel$w3_encode_E2eeStatus = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
						A2(
							$lamdera$codecs$Lamdera$Wire3$encodePair,
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
							$lamdera$program_test$Effect$Time$w3_encode_Posix),
						v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$DmChannel$w3_encode_E2eeEnabledData(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
						$author$project$Evergreen$V417$SessionIdHash$w3_encode_SessionIdHash,
						v0)
					]));
	}
};
var $author$project$Evergreen$V417$DmChannel$w3_encode_FrontendDmChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$justinmimbs$date$Date$w3_encode_Date,
				$author$project$Evergreen$V417$Drawing$w3_encode_Drawing(
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId)),
				w3_rec_var0.dateDividerDrawings),
				$author$project$Evergreen$V417$DmChannel$w3_encode_E2eeStatus(w3_rec_var0.e2ee),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
				$author$project$Evergreen$V417$Game$w3_encode_MatchData,
				w3_rec_var0.games),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMaybeMessage(w3_rec_var1.threadRoute),
								$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var1.time)
							]));
				},
				w3_rec_var0.lastTypedAt),
				$author$project$Evergreen$V417$MessageArray$w3_encode_MessageArray$(
				$author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId,
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId),
				w3_rec_var0.messages),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
				$author$project$Evergreen$V417$Thread$w3_encode_FrontendThread,
				w3_rec_var0.threads),
				A2($author$project$Evergreen$V417$VisibleMessages$w3_encode_VisibleMessages, $author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, w3_rec_var0.visibleMessages)
			]));
};
var $author$project$Evergreen$V417$Call$w3_encode_Local = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Call$w3_encode_CallId, w3_rec_var0.currentRoom),
				$lamdera$containers$SeqDict$encodeDict$($author$project$Evergreen$V417$Call$w3_encode_CallId, $author$project$Evergreen$V417$Call$w3_encode_RecordingStatus, w3_rec_var0.recordings),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Call$w3_encode_CallId,
				A2(
					$author$project$Evergreen$V417$NonemptyDict$w3_encode_NonemptyDict,
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
						$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId),
					$author$project$Evergreen$V417$Call$w3_encode_RemoteCallData),
				w3_rec_var0.voiceChats)
			]));
};
var $author$project$Evergreen$V417$TextEditor$w3_encode_LocalState = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				$author$project$Evergreen$V417$Range$w3_encode_Range,
				w3_rec_var0.cursorPosition),
				$lamdera$codecs$Lamdera$Wire3$encodeArray$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
					$author$project$Evergreen$V417$TextEditor$w3_encode_EditChange),
				w3_rec_var0.history),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				$lamdera$codecs$Lamdera$Wire3$encodeInt,
				w3_rec_var0.undoPoint)
			]));
};
var $author$project$Evergreen$V417$User$w3_encode_FrontendCurrentUser = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_CustomEmojiId),
				w3_rec_var0.availableCustomEmojis),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_StickerId),
				w3_rec_var0.availableStickers),
				$author$project$Evergreen$V417$UserColor$w3_encode_UserColor(w3_rec_var0.color),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.createdAt),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.deleteAccountAt),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_GuildId),
				A2(
					$author$project$Evergreen$V417$NonemptyDict$w3_encode_NonemptyDict,
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRoute),
					$author$project$Evergreen$V417$OneOrGreater$w3_encode_OneOrGreater),
				w3_rec_var0.directMentions),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_GuildId),
				A2(
					$author$project$Evergreen$V417$NonemptyDict$w3_encode_NonemptyDict,
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_ChannelId),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRoute),
					$author$project$Evergreen$V417$OneOrGreater$w3_encode_OneOrGreater),
				w3_rec_var0.discordDirectMentions),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_GuildId),
				w3_rec_var0.discordNotifyOnAllMessages),
				$lamdera$containers$SeqSet$encodeSet$($author$project$Evergreen$V417$RichText$w3_encode_Domain, w3_rec_var0.domainWhitelist),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.e2eeRisksAccepted),
				$author$project$Evergreen$V417$EmailAddress$w3_encode_EmailAddress(w3_rec_var0.email),
				$author$project$Evergreen$V417$User$w3_encode_EmailNotifications(w3_rec_var0.emailNotifications),
				$author$project$Evergreen$V417$User$w3_encode_EmbedVisibility(w3_rec_var0.embedVisibility),
				$author$project$Evergreen$V417$Emoji$w3_encode_EmojiConfig(w3_rec_var0.emojiConfig),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isAdmin),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_GuildId),
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId),
					$author$project$Evergreen$V417$Id$w3_encode_ThreadRoute),
				w3_rec_var0.lastChannelViewed),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_GuildId),
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_ChannelId),
					$author$project$Evergreen$V417$Id$w3_encode_ThreadRoute),
				w3_rec_var0.lastDiscordChannelViewed),
				$author$project$Evergreen$V417$User$w3_encode_LastDmViewed(w3_rec_var0.lastDmViewed),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.lastEmailNotification),
				$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Pagination$w3_encode_PageId, w3_rec_var0.lastLogPageViewed),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.lastPushNotification),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_TeamId),
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_ChannelId),
					$author$project$Evergreen$V417$Id$w3_encode_ThreadRoute),
				w3_rec_var0.lastSlackChannelViewed),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId,
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
				w3_rec_var0.lastViewedMessage),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId)),
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId),
				w3_rec_var0.lastViewedThreadMessage),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.linkDiscordAcknowledgementIsChecked),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.linkSlackAcknowledgementIsChecked),
				$author$project$Evergreen$V417$MuteSettings$w3_encode_Model(w3_rec_var0.muteSettings),
				$author$project$Evergreen$V417$PersonName$w3_encode_PersonName(w3_rec_var0.name),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_GuildId),
				w3_rec_var0.notifyOnAllMessages),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$X25519$w3_encode_PublicKey, w3_rec_var0.publicKey),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.recentLoginEmails),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_TeamId),
				A2(
					$author$project$Evergreen$V417$NonemptyDict$w3_encode_NonemptyDict,
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_ChannelId),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRoute),
					$author$project$Evergreen$V417$OneOrGreater$w3_encode_OneOrGreater),
				w3_rec_var0.slackDirectMentions),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_TeamId),
				w3_rec_var0.slackNotifyOnAllMessages)
			]));
};
var $author$project$Evergreen$V417$LinkedAndOtherDiscordUsers$w3_encode_LinkedAndOtherDiscordUsers = function (w3v) {
	var v0 = w3v.a;
	var v1 = w3v.b;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
				$author$project$Evergreen$V417$UserSession$w3_encode_DiscordFrontendUser,
				v0),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_UserId),
				$author$project$Evergreen$V417$LinkedAndOtherDiscordUsers$w3_encode_DiscordFrontendCurrentUser,
				v1)
			]));
};
var $author$project$Evergreen$V417$User$w3_encode_LocalUser = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$UserSession$w3_encode_Viewing(w3_rec_var0.currentlyViewing),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_CustomEmojiId),
				$author$project$Evergreen$V417$CustomEmoji$w3_encode_CustomEmojiData,
				w3_rec_var0.customEmojis),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Encryption$w3_encode_BytesHash,
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodeResult,
					$lamdera$codecs$Lamdera$Wire3$encodeUnit,
					$author$project$Evergreen$V417$Message$w3_encode_MessageContent$(
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId))),
				w3_rec_var0.decryptedMessages),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.devicePixelRatio),
				$author$project$Evergreen$V417$LinkedAndOtherDiscordUsers$w3_encode_LinkedAndOtherDiscordUsers(w3_rec_var0.discordUsers),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Emoji$w3_encode_CachedEmojiData, w3_rec_var0.emojiData),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_UserId),
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_TeamId),
				w3_rec_var0.linkedSlackUsers),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				$author$project$Evergreen$V417$User$w3_encode_FrontendUser,
				w3_rec_var0.otherUsers),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.safeAreaInsetBottom),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.safeAreaInsetTop),
				$author$project$Evergreen$V417$UserSession$w3_encode_UserSession(w3_rec_var0.session),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_UserId),
				$author$project$Evergreen$V417$UserSession$w3_encode_SlackFrontendUser,
				w3_rec_var0.slackUsers),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_UserId),
				w3_rec_var0.slackUsersNeedingAuth),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_StickerId),
				$author$project$Evergreen$V417$Sticker$w3_encode_StickerData,
				w3_rec_var0.stickers),
				$lamdera$program_test$Effect$Time$w3_encode_Zone(w3_rec_var0.timezone),
				$author$project$Evergreen$V417$User$w3_encode_FrontendCurrentUser(w3_rec_var0.user),
				$author$project$Evergreen$V417$UserAgent$w3_encode_UserAgent(w3_rec_var0.userAgent)
			]));
};
var $author$project$Evergreen$V417$LocalState$w3_encode_LocalState = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$LocalState$w3_encode_AdminStatus(w3_rec_var0.adminData),
				$author$project$Evergreen$V417$Call$w3_encode_Local(w3_rec_var0.calls),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId),
				$author$project$Evergreen$V417$DmChannel$w3_encode_DiscordFrontendDmChannel,
				w3_rec_var0.discordDmChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_GuildId),
				$author$project$Evergreen$V417$LocalState$w3_encode_DiscordFrontendGuild,
				w3_rec_var0.discordGuilds),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				$author$project$Evergreen$V417$DmChannel$w3_encode_FrontendDmChannel,
				w3_rec_var0.dmChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_GuildId),
				$author$project$Evergreen$V417$LocalState$w3_encode_FrontendGuild,
				w3_rec_var0.guilds),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$LocalState$w3_encode_JoinGuildError, w3_rec_var0.joinGuildError),
				$author$project$Evergreen$V417$User$w3_encode_LocalUser(w3_rec_var0.localUser),
				$lamdera$containers$SeqDict$encodeDict$($author$project$Evergreen$V417$SessionIdHash$w3_encode_SessionIdHash, $author$project$Evergreen$V417$UserSession$w3_encode_FrontendUserSession, w3_rec_var0.otherSessions),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.publicVapidKey),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_DmChannelId),
				$author$project$Evergreen$V417$LocalState$w3_encode_SlackFrontendDmChannel,
				w3_rec_var0.slackDmChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_TeamId),
				$author$project$Evergreen$V417$LocalState$w3_encode_SlackFrontendWorkspace,
				w3_rec_var0.slackWorkspaces),
				$author$project$Evergreen$V417$TextEditor$w3_encode_LocalState(w3_rec_var0.textEditor)
			]));
};
var $author$project$Evergreen$V417$Types$w3_encode_MessageHoverMobileMode = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$ianmackenzie$elm_units$Quantity$w3_encode_Quantity$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Types$w3_encode_EditMessage, v1)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$ianmackenzie$elm_units$Quantity$w3_encode_Quantity$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels, w3_rec_var0.offset),
									$ianmackenzie$elm_units$Quantity$w3_encode_Quantity$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels, w3_rec_var0.previousOffset),
									$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.time)
								]));
					}(v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$ianmackenzie$elm_units$Quantity$w3_encode_Quantity$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels, v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$ianmackenzie$elm_units$Quantity$w3_encode_Quantity$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels, w3_rec_var0.offset),
									$ianmackenzie$elm_units$Quantity$w3_encode_Quantity$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels, w3_rec_var0.targetOffset)
								]));
					}(v0)
					]));
	}
};
var $author$project$Evergreen$V417$Types$w3_encode_MessageMenuExtraOptions = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId(w3_rec_var0.guildOrDmId),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.imageUrl),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isThreadStarter),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.linkUrl),
				$author$project$Evergreen$V417$Types$w3_encode_MessageHoverMobileMode(w3_rec_var0.mobileMode),
				A2($author$project$Evergreen$V417$Coord$w3_encode_Coord, $author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels, w3_rec_var0.position),
				$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(w3_rec_var0.threadRoute)
			]));
};
var $author$project$Evergreen$V417$Types$w3_encode_MessageHover = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$Types$w3_encode_MessageMenuExtraOptions(v0)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v2)
					]));
	}
};
var $author$project$Evergreen$V417$Call$w3_encode_DebugRow = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.label),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.value)
			]));
};
var $author$project$Evergreen$V417$Call$w3_encode_DebugSection = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V417$Call$w3_encode_DebugRow, w3_rec_var0.rows),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.title)
			]));
};
var $author$project$Evergreen$V417$IdString$w3_encode_IdString$ = function (w3_x_c_a, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Evergreen$V417$IdString$w3_encode_IdString = F2($author$project$Evergreen$V417$IdString$w3_encode_IdString$);
var $author$project$Evergreen$V417$Call$w3_encode_LocalOrConnection = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$Call$w3_encode_ConnectionId(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$Call$w3_encode_MediaDeviceId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$Call$w3_encode_DeviceKind = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V417$Call$w3_encode_MediaDevice = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$IdString$w3_encode_IdString$($author$project$Evergreen$V417$Call$w3_encode_MediaDeviceId, w3_rec_var0.deviceId),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.groupId),
				$author$project$Evergreen$V417$Call$w3_encode_DeviceKind(w3_rec_var0.kind),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.label)
			]));
};
var $author$project$Evergreen$V417$Call$w3_encode_MediaDevicesStatus = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V417$Call$w3_encode_MediaDevice, v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V417$Call$w3_encode_VideoTile = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$Call$w3_encode_LocalOrConnection(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V417$Call$w3_encode_LocalOrConnection(v0)
				]));
	}
};
var $author$project$Evergreen$V417$Call$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V417$Call$w3_encode_DebugSection, w3_rec_var0.debugData),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Call$w3_encode_VideoTile, w3_rec_var0.focusedTile),
				$lamdera$containers$SeqSet$encodeSet$($author$project$Evergreen$V417$Call$w3_encode_ConnectionId, w3_rec_var0.isSpeaking),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.localIsSpeaking),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pollDebugData),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.total),
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.uploaded)
							]));
				},
				w3_rec_var0.recordingUpload),
				$author$project$Evergreen$V417$Call$w3_encode_RemoteCallData(w3_rec_var0.remoteCallData),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V417$IdString$w3_encode_IdString($author$project$Evergreen$V417$Call$w3_encode_MediaDeviceId),
				w3_rec_var0.selectedAudioInputDevice),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V417$IdString$w3_encode_IdString($author$project$Evergreen$V417$Call$w3_encode_MediaDeviceId),
				w3_rec_var0.selectedVideoInputDevice),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showDeviceSettings),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.startConnectionError),
				$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $lamdera$codecs$Lamdera$Wire3$encodeFloat, w3_rec_var0.thumbnailPosition),
				$author$project$Evergreen$V417$Call$w3_encode_MediaDevicesStatus(w3_rec_var0.userMediaDevices),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Call$w3_encode_LocalOrConnection, w3_rec_var0.videoHover),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
					$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat,
				w3_rec_var0.volume)
			]));
};
var $author$project$Evergreen$V417$Drawing$w3_encode_ActiveStroke = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Evergreen$V417$SafeFloat$w3_encode_SafeFloat, $author$project$Evergreen$V417$SafeFloat$w3_encode_SafeFloat),
				w3_rec_var0.unsent)
			]));
};
var $author$project$Evergreen$V417$Drawing$w3_encode_SelectedAnchorData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $lamdera$codecs$Lamdera$Wire3$encodeFloat, w3_rec_var0.anchorHalfSize),
				$author$project$Evergreen$V417$Drawing$w3_encode_AnchorType(w3_rec_var0.anchorType),
				$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId(w3_rec_var0.guildOrDmId),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.pointScale),
				A3($author$project$Evergreen$V417$Point2d$w3_encode_Point2d, $author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels, $author$project$Evergreen$V417$Touch$w3_encode_ScreenCoordinate, w3_rec_var0.position),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Drawing$w3_encode_ActiveStroke, w3_rec_var0.stroke),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.zoom),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.height),
								$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.width),
								$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.x),
								$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.y)
							]));
				},
				w3_rec_var0.zoomContainer)
			]));
};
var $author$project$Evergreen$V417$Drawing$w3_encode_Model = function (w3v) {
	if (!w3v.$) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V417$Drawing$w3_encode_SelectedAnchorData(v0)
				]));
	}
};
var $author$project$Evergreen$V417$Emoji$w3_encode_Category = function (w3v) {
	switch (w3v.$) {
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$Emoji$w3_encode_EmojiCategory(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrSticker = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_CustomEmojiId, v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_StickerId, v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$Emoji$w3_encode_UnicodeEmoji(v0)
					]));
	}
};
var $author$project$Evergreen$V417$Emoji$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Emoji$w3_encode_Category(w3_rec_var0.category),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrSticker(w3_rec_var1.emoji),
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.index)
							]));
				},
				w3_rec_var0.emojiHovered),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.searchText)
			]));
};
var $author$project$Evergreen$V417$Scroll$w3_encode_ScrollPosition = function (w3v) {
	switch (w3v) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Evergreen$V417$SheepGame$w3_encode_UnvalidatedInput = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$FileStatus$w3_encode_FileId),
				$author$project$Evergreen$V417$FileStatus$w3_encode_FileStatus,
				w3_rec_var0.attachedFiles),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.text)
			]));
};
var $author$project$Evergreen$V417$SheepGame$w3_encode_GameData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$IdArray$w3_encode_IdArray$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, $author$project$Evergreen$V417$SheepGame$w3_encode_UnvalidatedInput, w3_rec_var0.answerDrafts),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId)),
				w3_rec_var0.gridHovered),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_QuestionId),
				w3_rec_var0.hoveredQuestion),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$SheepGame$w3_encode_ReactionTarget, w3_rec_var0.hoveredResult),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.newQuestionRevealed),
				$author$project$Evergreen$V417$IdArray$w3_encode_IdArray$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, $author$project$Evergreen$V417$SheepGame$w3_encode_UnvalidatedInput, w3_rec_var0.noteDrafts),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.questionsRevealedSeen),
				$author$project$Evergreen$V417$Scroll$w3_encode_ScrollPosition(w3_rec_var0.scrollPosition)
			]));
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_Drag = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_HoveredMove = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeDict$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				$author$project$Evergreen$V417$WordSpellingGame$w3_encode_LetterOrWildcard,
				w3_rec_var0.cells),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.index),
				$author$project$Evergreen$V417$WordSpellingGame$w3_encode_Shared(w3_rec_var0.shared)
			]));
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_TrayIndex = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_TilePosition = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$WordSpellingGame$w3_encode_TrayIndex(v0),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$program_test$Effect$Time$w3_encode_Posix, $lamdera$codecs$Lamdera$Wire3$encodeInt),
					v1)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt, v0),
					$lamdera$program_test$Effect$Time$w3_encode_Posix(v1)
				]));
	}
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_Tile = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.createdAt),
				$author$project$Evergreen$V417$WordSpellingGame$w3_encode_TilePosition(w3_rec_var0.position)
			]));
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_OpenWordDefinition = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.index),
				$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.words)
			]));
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_DictEntry = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.definitions),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.partOfSpeech)
			]));
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_WordDefinitionData = function (w3v) {
	switch (w3v.$) {
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V417$WordSpellingGame$w3_encode_DictEntry, v0)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
	}
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_WordDefinition = function (w3v) {
	if (!w3v.$) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V417$WordSpellingGame$w3_encode_OpenWordDefinition(v0),
					$author$project$Evergreen$V417$WordSpellingGame$w3_encode_WordDefinitionData(v1)
				]));
	}
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_ZoomState = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.amount),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.focusX),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.focusY)
			]));
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_ZoomAnimation = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$WordSpellingGame$w3_encode_ZoomState(w3_rec_var0.from),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.start)
			]));
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_GameData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$WordSpellingGame$w3_encode_Drag(w3_rec_var0.dragging),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				w3_rec_var0.highlightedPlayer),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$WordSpellingGame$w3_encode_HoveredMove, w3_rec_var0.hoveredMove),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.letterCount),
								$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var1.time)
							]));
				},
				w3_rec_var0.lastWordPlaced),
				$author$project$Evergreen$V417$Scroll$w3_encode_ScrollPosition(w3_rec_var0.scrollPosition),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				w3_rec_var0.selectedCell),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showSettings),
				$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Evergreen$V417$WordSpellingGame$w3_encode_Tile, w3_rec_var0.tiles),
				$author$project$Evergreen$V417$WordSpellingGame$w3_encode_WordDefinition(w3_rec_var0.wordDefinition),
				$author$project$Evergreen$V417$WordSpellingGame$w3_encode_ZoomAnimation(w3_rec_var0.zoomAnimation)
			]));
};
var $author$project$Evergreen$V417$Go$w3_encode_GameModel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.lastError),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.lastPlacedStone),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.viewingMovesBack)
			]));
};
var $author$project$Evergreen$V417$Game$w3_encode_Game = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Go$w3_encode_GameModel(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$SheepGame$w3_encode_GameData(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$WordSpellingGame$w3_encode_GameData(v0)
					]));
	}
};
var $author$project$Evergreen$V417$Go$w3_encode_SizeSelection = function (w3v) {
	switch (w3v) {
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Evergreen$V417$Go$w3_encode_SetupModel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.error),
				$author$project$Evergreen$V417$Go$w3_encode_Stone(w3_rec_var0.gameCreatorPlayingAs),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.handicapInput),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.heightInput),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.incrementInput),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.komiInput),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.mainTimeInput),
				$author$project$Evergreen$V417$Go$w3_encode_SizeSelection(w3_rec_var0.sizeSelection),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.widthInput)
			]));
};
var $author$project$Evergreen$V417$SheepGame$w3_encode_SetupModel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.error),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pressedSubmit),
				$author$project$Evergreen$V417$IdArray$w3_encode_IdArray$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, $author$project$Evergreen$V417$SheepGame$w3_encode_UnvalidatedInput, w3_rec_var0.questions)
			]));
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_SetupModel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.advancedSettingsExpanded),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.error),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.fullTrayBonus),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.incrementInput),
				$author$project$Evergreen$V417$WordSpellingGame$w3_encode_Language(w3_rec_var0.language),
				$lamdera$containers$SeqDict$encodeDict$($lamdera$codecs$Lamdera$Wire3$encodeChar, $lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.letterValues),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.letters),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.mainTimeInput),
				$author$project$Evergreen$V417$OneOrGreater$w3_encode_OneOrGreater(w3_rec_var0.placeWordAttempts),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.traySize)
			]));
};
var $author$project$Evergreen$V417$Game$w3_encode_Setup = function (w3v) {
	switch (w3v.$) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$Go$w3_encode_SetupModel(v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$SheepGame$w3_encode_SetupModel(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V417$WordSpellingGame$w3_encode_SetupModel(v0)
					]));
	}
};
var $author$project$Evergreen$V417$Game$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Game$w3_encode_Setup(w3_rec_var0.setup),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.sheepGameQuestionsCounter),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
					$author$project$Evergreen$V417$SheepGame$w3_encode_Input),
				$lamdera$codecs$Lamdera$Wire3$encodeInt,
				w3_rec_var0.sheepGameSaveCounters),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
				$author$project$Evergreen$V417$Game$w3_encode_Game,
				w3_rec_var0.startedGames)
			]));
};
var $author$project$Evergreen$V417$ImageEditor$w3_encode_DragPart = function (w3v) {
	switch (w3v) {
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
	}
};
var $author$project$Evergreen$V417$ImageEditor$w3_encode_DragState = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.currentX),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.currentY),
				$author$project$Evergreen$V417$ImageEditor$w3_encode_DragPart(w3_rec_var0.dragPart),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.startX),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.startY)
			]));
};
var $author$project$Evergreen$V417$ImageEditor$w3_encode_UploadStatus = function (w3v) {
	switch (w3v.$) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$FileStatus$w3_encode_FileHash(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Evergreen$V417$ImageEditor$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$ImageEditor$w3_encode_DragState, w3_rec_var0.dragState),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				w3_rec_var0.imageSize),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.imageUrl),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.size),
				$author$project$Evergreen$V417$ImageEditor$w3_encode_UploadStatus(w3_rec_var0.status),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.x),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.y)
			]));
};
var $author$project$Evergreen$V417$Pages$Admin$w3_encode_AdminUiSection = function (w3v) {
	switch (w3v) {
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 12:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 13:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 17:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(12);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
		case 15:
			return $elm$bytes$Bytes$Encode$unsignedInt8(14);
		case 14:
			return $elm$bytes$Bytes$Encode$unsignedInt8(15);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(16);
		case 16:
			return $elm$bytes$Bytes$Encode$unsignedInt8(17);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(18);
	}
};
var $author$project$Evergreen$V417$Pages$Admin$w3_encode_DownloadingBackup = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeBytes, w3_rec_var0.chunks),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.receivedBytes),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.totalBytes)
			]));
};
var $author$project$Evergreen$V417$Pages$Admin$w3_encode_ExportProgress = function (w3v) {
	switch (w3v.$) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.encoded),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.total)
								]));
					}(v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.channelsRemaining),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.encoded),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.total)
								]));
					}(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.encoded),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.total)
								]));
					}(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.channelsRemaining),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.encoded),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.total)
								]));
					}(v0)
					]));
	}
};
var $author$project$Evergreen$V417$Pages$Admin$w3_encode_ExportSubsetSelection = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId),
				w3_rec_var0.discordDmChannels),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_GuildId),
				w3_rec_var0.discordGuilds),
				$lamdera$containers$SeqSet$encodeSet$($author$project$Evergreen$V417$DmChannelId$w3_encode_DmChannelId, w3_rec_var0.dmChannels),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_GuildId),
				w3_rec_var0.guilds)
			]));
};
var $author$project$Evergreen$V417$Pages$Admin$w3_encode_ImportBackendStatus = function (w3v) {
	switch (w3v.$) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeBytes(w3_rec_var0.remainingBytes),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.sentBytes),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.totalBytes)
								]));
					}(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Evergreen$V417$Pagination$w3_encode_ItemId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V417$Editable$w3_encode_Editing = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$Editable$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Editable$w3_encode_Editing(w3_rec_var0.editing),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pressedSubmit),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showSecret)
			]));
};
var $author$project$Evergreen$V417$Pages$Admin$w3_encode_UserColumn = function (w3v) {
	if (w3v === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$Pages$Admin$w3_encode_UserTableId = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
				]));
	}
};
var $author$project$Evergreen$V417$Pages$Admin$w3_encode_EditingCell = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Pages$Admin$w3_encode_UserColumn(w3_rec_var0.column),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.text),
				$author$project$Evergreen$V417$Pages$Admin$w3_encode_UserTableId(w3_rec_var0.userId)
			]));
};
var $author$project$Evergreen$V417$Table$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.ascendingOrder),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.columnToSortBy),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showAll)
			]));
};
var $author$project$Evergreen$V417$Pages$Admin$w3_encode_UserTable = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				$author$project$Evergreen$V417$Pages$Admin$w3_encode_EditedBackendUser,
				w3_rec_var0.changedUsers),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				w3_rec_var0.deletedUsers),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Pages$Admin$w3_encode_EditingCell, w3_rec_var0.editingCell),
				$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Evergreen$V417$Pages$Admin$w3_encode_EditedBackendUser, w3_rec_var0.newUsers),
				$author$project$Evergreen$V417$Table$w3_encode_Model(w3_rec_var0.table)
			]));
};
var $author$project$Evergreen$V417$Pages$Admin$w3_encode_UsersChangeError = function (w3v) {
	switch (w3v.$) {
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
	}
};
var $author$project$Evergreen$V417$Pages$Admin$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Pagination$w3_encode_ItemId),
				w3_rec_var0.copiedLogLink),
				$author$project$Evergreen$V417$Editable$w3_encode_Model(w3_rec_var0.discordLinkLimit),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Pages$Admin$w3_encode_DownloadingBackup, w3_rec_var0.downloadingBackup),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_GuildId),
				w3_rec_var0.expandedDiscordGuilds),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_GuildId),
				w3_rec_var0.expandedGuilds),
				$lamdera$containers$SeqSet$encodeSet$($author$project$Evergreen$V417$Pages$Admin$w3_encode_AdminUiSection, w3_rec_var0.expandedSections),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_TeamId),
				w3_rec_var0.expandedSlackWorkspaces),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Pages$Admin$w3_encode_ExportProgress, w3_rec_var0.exportProgress),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Pages$Admin$w3_encode_ExportSubsetSelection, w3_rec_var0.exportSubsetSelection),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Pagination$w3_encode_ItemId),
				w3_rec_var0.highlightLog),
				$author$project$Evergreen$V417$Pages$Admin$w3_encode_ImportBackendStatus(w3_rec_var0.importBackendStatus),
				$author$project$Evergreen$V417$Editable$w3_encode_Model(w3_rec_var0.notifyAdminsBotUserId),
				$author$project$Evergreen$V417$Editable$w3_encode_Model(w3_rec_var0.notifyAdminsToken),
				$author$project$Evergreen$V417$Editable$w3_encode_Model(w3_rec_var0.openRouterKey),
				$author$project$Evergreen$V417$Editable$w3_encode_Model(w3_rec_var0.postmarkKey),
				$author$project$Evergreen$V417$Editable$w3_encode_Model(w3_rec_var0.privateVapidKey),
				$author$project$Evergreen$V417$Editable$w3_encode_Model(w3_rec_var0.publicVapidKey),
				$author$project$Evergreen$V417$Editable$w3_encode_Model(w3_rec_var0.slackLinkLimit),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Pages$Admin$w3_encode_UsersChangeError, w3_rec_var0.submitError),
				$author$project$Evergreen$V417$Pages$Admin$w3_encode_UserTable(w3_rec_var0.userTable),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.websocketCloseEventsPage)
			]));
};
var $author$project$Evergreen$V417$TextEditor$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(_List_Nil);
};
var $author$project$Evergreen$V417$Types$w3_encode_NewChannelForm = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.description),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pressedSubmit)
			]));
};
var $author$project$Evergreen$V417$Types$w3_encode_NewGuildForm = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pressedSubmit)
			]));
};
var $author$project$Evergreen$V417$X25519$w3_encode_PrivateKey = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$author$project$Evergreen$V417$X25519$w3_encode_Key(v0)
			]));
};
var $author$project$Evergreen$V417$Types$w3_encode_RevealedSpoilers = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
				$author$project$Evergreen$V417$NonemptySet$w3_encode_NonemptySet($lamdera$codecs$Lamdera$Wire3$encodeInt),
				w3_rec_var0.messages),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId),
					$author$project$Evergreen$V417$NonemptySet$w3_encode_NonemptySet($lamdera$codecs$Lamdera$Wire3$encodeInt)),
				w3_rec_var0.threadMessages)
			]));
};
var $author$project$Evergreen$V417$MessageInput$w3_encode_MentionUserDropdown = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.dropdownIndex),
				function (w3_rec_var1) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.height),
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.width),
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.x),
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.y)
						]));
			}(w3_rec_var0.inputElement)
			]));
};
var $author$project$Evergreen$V417$Range$w3_encode_SelectionDirection = function (w3v) {
	if (w3v === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$MessageInput$w3_encode_TextInputFocus = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Range$w3_encode_SelectionDirection(w3_rec_var0.direction),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$MessageInput$w3_encode_MentionUserDropdown, w3_rec_var0.dropdown),
				$lamdera$program_test$Effect$Browser$Dom$w3_encode_HtmlId(w3_rec_var0.htmlId),
				$author$project$Evergreen$V417$Range$w3_encode_Range(w3_rec_var0.selection)
			]));
};
var $author$project$Evergreen$V417$LoginForm$w3_encode_CodeStatus = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$TwoFactorAuthentication$w3_encode_TwoFactorDisableData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$Evergreen$V417$LoginForm$w3_encode_CodeStatus, w3_rec_var0.attempts),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.code)
			]));
};
var $author$project$Evergreen$V417$TwoFactorAuthentication$w3_encode_TwoFactorSetupData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$Evergreen$V417$LoginForm$w3_encode_CodeStatus, w3_rec_var0.attempts),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.code),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.qrCodeUrl)
			]));
};
var $author$project$Evergreen$V417$TwoFactorAuthentication$w3_encode_TwoFactorState = function (w3v) {
	switch (w3v.$) {
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0)
					]));
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$TwoFactorAuthentication$w3_encode_TwoFactorDisableData(v1)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V417$TwoFactorAuthentication$w3_encode_TwoFactorSetupData(v0)
					]));
	}
};
var $author$project$Evergreen$V417$Types$w3_encode_E2eeKeysValid = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V417$Types$w3_encode_LinkSlackWorkspaceError = function (w3v) {
	if (w3v.$ === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V417$Slack$w3_encode_HttpError(v0)
				]));
	}
};
var $author$project$Evergreen$V417$Types$w3_encode_LinkSlackResult = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
					A2($lamdera$codecs$Lamdera$Wire3$encodeResult, $author$project$Evergreen$V417$Types$w3_encode_LinkSlackWorkspaceError, $lamdera$codecs$Lamdera$Wire3$encodeString),
					v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$UserColor$w3_encode_Selection = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$UserColor$w3_encode_UserColor(w3_rec_var0.lastValid),
				function (w3_rec_var1) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.hue),
							$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.lightness),
							$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.saturation)
						]));
			}(w3_rec_var0.selected)
			]));
};
var $author$project$Evergreen$V417$Types$w3_encode_UserOptionsModel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$UserColor$w3_encode_Selection, w3_rec_var0.color),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var1.data),
								$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var1.loadedAt)
							]));
				},
				w3_rec_var0.debugData),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.domainWhitelistInput),
				$author$project$Evergreen$V417$Types$w3_encode_E2eeKeysValid(w3_rec_var0.e2eeKeysValid),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Types$w3_encode_LinkSlackResult, w3_rec_var0.linkSlackResult),
				$author$project$Evergreen$V417$Editable$w3_encode_Model(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pressedSubmitSlackData),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.privateKeyText),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_TeamId),
				w3_rec_var0.removedSlackTeams),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.slackCookie),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.slackTeamsJson)
			]));
};
var $author$project$Evergreen$V417$Types$w3_encode_LoggedIn2 = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.accountDeletionBannerClosed),
				$author$project$Evergreen$V417$Pages$Admin$w3_encode_Model(w3_rec_var0.admin),
				$author$project$Evergreen$V417$Scroll$w3_encode_ScrollPosition(w3_rec_var0.channelScrollPosition),
				$lamdera$containers$SeqDict$encodeDict$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_encode_ThreadRoute),
				$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString,
				w3_rec_var0.drafts),
				$author$project$Evergreen$V417$Drawing$w3_encode_Model(w3_rec_var0.drawingMode),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.e2eeError),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				w3_rec_var0.e2eeKeysOnThisDevice),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.e2eePrivateKeyText),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				$lamdera$codecs$Lamdera$Wire3$encodeBool,
				w3_rec_var0.e2eeSectionsExpanded),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_GuildId),
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId)),
				$author$project$Evergreen$V417$Types$w3_encode_EditChannelForm,
				w3_rec_var0.editChannelForm),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_GuildId),
				$author$project$Evergreen$V417$Types$w3_encode_EditGuildForm,
				w3_rec_var0.editGuildForm),
				$lamdera$containers$SeqDict$encodeDict$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_encode_ThreadRoute),
				$author$project$Evergreen$V417$Types$w3_encode_EditMessage,
				w3_rec_var0.editMessage),
				$author$project$Evergreen$V417$Emoji$w3_encode_Model(w3_rec_var0.emojiSelector),
				$author$project$Evergreen$V417$Types$w3_encode_EncryptionRequests(w3_rec_var0.encryptionRequests),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($elm$url$Url$w3_encode_Url, w3_rec_var0.externalLinkWarning),
				$author$project$Evergreen$V417$Types$w3_encode_FileDrag(w3_rec_var0.fileDragOverCount),
				$lamdera$containers$SeqDict$encodeDict$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_encode_ThreadRoute),
				A2(
					$author$project$Evergreen$V417$NonemptyDict$w3_encode_NonemptyDict,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$FileStatus$w3_encode_FileId),
					$author$project$Evergreen$V417$FileStatus$w3_encode_FileStatus),
				w3_rec_var0.filesToUpload),
				$lamdera$containers$SeqDict$encodeDict$($author$project$Evergreen$V417$Id$w3_encode_GuildOrDmId, $author$project$Evergreen$V417$Game$w3_encode_Model, w3_rec_var0.games),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_GuildId),
					$author$project$Evergreen$V417$ImageEditor$w3_encode_Model),
				w3_rec_var0.guildIconEditor),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isReloading),
				$author$project$Evergreen$V417$Local$w3_encode_Local$($author$project$Evergreen$V417$Types$w3_encode_LocalMsg, $author$project$Evergreen$V417$LocalState$w3_encode_LocalState, w3_rec_var0.localState),
				$author$project$Evergreen$V417$Types$w3_encode_MessageHover(w3_rec_var0.messageHover),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_GuildId),
				$author$project$Evergreen$V417$Types$w3_encode_NewChannelForm,
				w3_rec_var0.newChannelForm),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Types$w3_encode_NewGuildForm, w3_rec_var0.newGuildForm),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.newMessagesWhileNotScrolledToBottom),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$MessageInput$w3_encode_TextInputFocus, w3_rec_var0.previousTextInputFocus),
				$author$project$Evergreen$V417$ImageEditor$w3_encode_Model(w3_rec_var0.profilePictureEditor),
				$lamdera$containers$SeqDict$encodeDict$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_encode_ThreadRoute),
				$author$project$Evergreen$V417$Message$w3_encode_RepliedTo($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
				w3_rec_var0.replyTo),
				$lamdera$containers$SeqDict$encodeDict$($author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V417$Types$w3_encode_RevealedSpoilers, w3_rec_var0.revealedSpoilers),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.searchOverlayQuery),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.searchOverlaySelection),
				$author$project$Evergreen$V417$Types$w3_encode_EmojiSelector(w3_rec_var0.showEmojiSelector),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$FileStatus$w3_encode_FileDataWithImage, w3_rec_var0.showFileToUploadInfo),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V417$SecretId$w3_encode_SecretId($author$project$Evergreen$V417$Id$w3_encode_InviteLinkId),
				w3_rec_var0.showInviteLinkQrCode),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$X25519$w3_encode_PrivateKey, w3_rec_var0.showNewPrivateKey),
				$author$project$Evergreen$V417$Route$w3_encode_ChannelSidebarMode(w3_rec_var0.sidebarMode),
				$author$project$Evergreen$V417$TextEditor$w3_encode_Model(w3_rec_var0.textEditor),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$MessageInput$w3_encode_TextInputFocus, w3_rec_var0.textInputFocus),
				$author$project$Evergreen$V417$TwoFactorAuthentication$w3_encode_TwoFactorState(w3_rec_var0.twoFactor),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.typedTextCounter),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.typingDebouncer),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Types$w3_encode_UserOptionsModel, w3_rec_var0.userOptions),
				$author$project$Evergreen$V417$Call$w3_encode_Model(w3_rec_var0.voiceChat)
			]));
};
var $author$project$Evergreen$V417$LoginForm$w3_encode_EnterEmail2 = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.email),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pressedSubmitEmail),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.rateLimited),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showSignupsDisabled),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showUserIsDeleted)
			]));
};
var $author$project$Evergreen$V417$LoginForm$w3_encode_EnterLoginCode2 = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$Evergreen$V417$LoginForm$w3_encode_CodeStatus, w3_rec_var0.attempts),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.code),
				$author$project$Evergreen$V417$EmailAddress$w3_encode_EmailAddress(w3_rec_var0.sentTo)
			]));
};
var $author$project$Evergreen$V417$LoginForm$w3_encode_EnterTwoFactorCode2 = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.attemptCount),
				$lamdera$containers$SeqDict$encodeDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$Evergreen$V417$LoginForm$w3_encode_CodeStatus, w3_rec_var0.attempts),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.code)
			]));
};
var $author$project$Evergreen$V417$LoginForm$w3_encode_SubmitStatus = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$LoginForm$w3_encode_EnterUserData2 = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
				$author$project$Evergreen$V417$LoginForm$w3_encode_SubmitStatus(w3_rec_var0.pressedSubmit)
			]));
};
var $author$project$Evergreen$V417$LoginForm$w3_encode_LoginForm = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$LoginForm$w3_encode_EnterEmail2(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$LoginForm$w3_encode_EnterLoginCode2(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$LoginForm$w3_encode_EnterTwoFactorCode2(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V417$LoginForm$w3_encode_EnterUserData2(v0)
					]));
	}
};
var $author$project$Evergreen$V417$RecoveryLogin$w3_encode_SubmitStatus = function (w3v) {
	switch (w3v.$) {
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V417$RecoveryLogin$w3_encode_Model = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				function (w3_rec_var0) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.password),
							$author$project$Evergreen$V417$RecoveryLogin$w3_encode_SubmitStatus(w3_rec_var0.submitStatus)
						]));
			}(v0)
			]));
};
var $author$project$Evergreen$V417$Types$w3_encode_LoginStatus = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$Types$w3_encode_LoggedIn2(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					function (w3_rec_var0) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$LoginForm$w3_encode_LoginForm, w3_rec_var0.loginForm),
								$author$project$Evergreen$V417$RecoveryLogin$w3_encode_Model(w3_rec_var0.recoveryLogin),
								$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
								function (w3_rec_var1) {
									return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
										_List_fromArray(
											[
												$author$project$Evergreen$V417$Range$w3_encode_SelectionDirection(w3_rec_var1.direction),
												$lamdera$program_test$Effect$Browser$Dom$w3_encode_HtmlId(w3_rec_var1.htmlId),
												$author$project$Evergreen$V417$Range$w3_encode_Range(w3_rec_var1.selection)
											]));
								},
								w3_rec_var0.textInputFocus),
								$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
								$author$project$Evergreen$V417$SecretId$w3_encode_SecretId($author$project$Evergreen$V417$Id$w3_encode_InviteLinkId),
								w3_rec_var0.useInviteAfterLoggedIn)
							]));
				}(v0)
				]));
	}
};
var $author$project$Evergreen$V417$Types$w3_encode_LoginType = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$ImageViewer$w3_encode_Interaction = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.offsetStartX),
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.offsetStartY),
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.startX),
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.startY)
								]));
					}(v0)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.prevMidX),
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.prevMidY),
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.startDistance),
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.startScale)
								]));
					}(v0)
					]));
	}
};
var $author$project$Evergreen$V417$ImageViewer$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				A2($author$project$Evergreen$V417$Coord$w3_encode_Coord, $author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels, w3_rec_var0.imageSize),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.imageUrl),
				$author$project$Evergreen$V417$ImageViewer$w3_encode_Interaction(w3_rec_var0.interaction),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.offsetX),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.offsetY),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.prevOffsetX),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.prevOffsetY),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.scale),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.targetScale),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.velocityX),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.velocityY),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.zoomFocusX),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.zoomFocusY)
			]));
};
var $author$project$Evergreen$V417$Go$w3_encode_PublicGoMatchData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Evergreen$V417$Go$w3_encode_ActionWithTime, w3_rec_var0.actions),
				$author$project$Evergreen$V417$Go$w3_encode_Shared(w3_rec_var0.cache),
				$author$project$Evergreen$V417$User$w3_encode_FrontendUser(w3_rec_var0.creatorUser),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$User$w3_encode_FrontendUser, w3_rec_var0.joinedUser),
				$author$project$Evergreen$V417$Go$w3_encode_ValidatedSetup(w3_rec_var0.setup)
			]));
};
var $author$project$Evergreen$V417$Types$w3_encode_PublicGoMatch = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Go$w3_encode_PublicGoMatchData(v0),
						$author$project$Evergreen$V417$Go$w3_encode_GameModel(v1)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Evergreen$V417$Route$w3_encode_ShowChannelSettings = function (w3v) {
	if (w3v === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$Route$w3_encode_ThreadRouteWithFriends = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
					v0),
					$author$project$Evergreen$V417$Route$w3_encode_ShowChannelSettings(v1)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		var v2 = w3v.c;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v0),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId),
					v1),
					$author$project$Evergreen$V417$Route$w3_encode_ShowChannelSettings(v2)
				]));
	}
};
var $author$project$Evergreen$V417$Route$w3_encode_ChannelRoute = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelId, v0),
						$author$project$Evergreen$V417$Route$w3_encode_ThreadRouteWithFriends(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$UserSession$w3_encode_ChannelHeaderTab, v2)
					]));
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$SecretId$w3_encode_SecretId$($author$project$Evergreen$V417$Id$w3_encode_InviteLinkId, v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Evergreen$V417$Route$w3_encode_ChannelsVisibleOnMobile = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$Route$w3_encode_Overlay = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V417$Route$w3_encode_DiscordDmRouteData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId, w3_rec_var0.channelId),
				$author$project$Evergreen$V417$Route$w3_encode_ChannelsVisibleOnMobile(w3_rec_var0.channelsVisible),
				$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, w3_rec_var0.currentDiscordUserId),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Route$w3_encode_Overlay, w3_rec_var0.overlay),
				$author$project$Evergreen$V417$Route$w3_encode_ShowChannelSettings(w3_rec_var0.showMembersTab),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$UserSession$w3_encode_ChannelHeaderTab, w3_rec_var0.tab),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId),
				w3_rec_var0.viewingMessage)
			]));
};
var $author$project$Evergreen$V417$Route$w3_encode_DiscordChannelRoute = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, v0),
						$author$project$Evergreen$V417$Route$w3_encode_ThreadRouteWithFriends(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$UserSession$w3_encode_ChannelHeaderTab, v2)
					]));
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V417$Route$w3_encode_DiscordGuildRouteData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Route$w3_encode_DiscordChannelRoute(w3_rec_var0.channelRoute),
				$author$project$Evergreen$V417$Route$w3_encode_ChannelsVisibleOnMobile(w3_rec_var0.channelsVisible),
				$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, w3_rec_var0.currentDiscordUserId),
				$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, w3_rec_var0.guildId),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Route$w3_encode_Overlay, w3_rec_var0.overlay)
			]));
};
var $author$project$Evergreen$V417$Route$w3_encode_DmRouteData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$DmChannelId$w3_encode_DmChannelId(w3_rec_var0.channelId),
				$author$project$Evergreen$V417$Route$w3_encode_ChannelsVisibleOnMobile(w3_rec_var0.channelsVisible),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Route$w3_encode_Overlay, w3_rec_var0.overlay),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$UserSession$w3_encode_ChannelHeaderTab, w3_rec_var0.tab),
				$author$project$Evergreen$V417$Route$w3_encode_ThreadRouteWithFriends(w3_rec_var0.threadRoute)
			]));
};
var $author$project$Evergreen$V417$Route$w3_encode_LinkDiscordError = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Evergreen$V417$Route$w3_encode_SlackDmRouteData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_DmChannelId, w3_rec_var0.channelId),
				$author$project$Evergreen$V417$Route$w3_encode_ChannelsVisibleOnMobile(w3_rec_var0.channelsVisible),
				$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_UserId, w3_rec_var0.currentSlackUserId),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Route$w3_encode_Overlay, w3_rec_var0.overlay),
				$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMaybeMessage(w3_rec_var0.threadRoute)
			]));
};
var $author$project$Evergreen$V417$Route$w3_encode_SlackChannelRoute = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		var v2 = w3v.c;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_ChannelId, v0),
					$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMaybeMessage(v1),
					$author$project$Evergreen$V417$Route$w3_encode_ShowChannelSettings(v2)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$Route$w3_encode_SlackWorkspaceRouteData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Route$w3_encode_SlackChannelRoute(w3_rec_var0.channelRoute),
				$author$project$Evergreen$V417$Route$w3_encode_ChannelsVisibleOnMobile(w3_rec_var0.channelsVisible),
				$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_UserId, w3_rec_var0.currentSlackUserId),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Route$w3_encode_Overlay, w3_rec_var0.overlay),
				$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_TeamId, w3_rec_var0.teamId)
			]));
};
var $author$project$Evergreen$V417$SafeJson$w3_encode_SafeJson = function (w3v) {
	switch (w3v.$) {
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V417$SafeJson$w3_encode_SafeJson, v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V417$SafeFloat$w3_encode_SafeFloat(v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$lamdera$codecs$Lamdera$Wire3$encodeDict$($lamdera$codecs$Lamdera$Wire3$encodeString, $author$project$Evergreen$V417$SafeJson$w3_encode_SafeJson, v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
	}
};
var $author$project$Evergreen$V417$Discord$w3_encode_UserAuth = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.token),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.userAgent),
				$author$project$Evergreen$V417$SafeJson$w3_encode_SafeJson(w3_rec_var0.xSuperProperties)
			]));
};
var $author$project$Evergreen$V417$Route$w3_encode_Route = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
									$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Pagination$w3_encode_ItemId),
									w3_rec_var0.highlightLog)
								]));
					}(v0)
					]));
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$Route$w3_encode_DiscordDmRouteData(v0)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V417$Route$w3_encode_DiscordGuildRouteData(v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V417$Route$w3_encode_DmRouteData(v0)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Route$w3_encode_ChannelRoute(v1),
						$author$project$Evergreen$V417$Route$w3_encode_ChannelsVisibleOnMobile(v2),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Route$w3_encode_Overlay, v3)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Route$w3_encode_Overlay, v0)
					]));
		case 12:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($author$project$Evergreen$V417$Route$w3_encode_LinkDiscordError, $author$project$Evergreen$V417$Discord$w3_encode_UserAuth, v0)
					]));
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		case 13:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Evergreen$V417$SecretId$w3_encode_SecretId$($author$project$Evergreen$V417$Id$w3_encode_GamePublicId, v0)
					]));
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$Evergreen$V417$Route$w3_encode_SlackDmRouteData(v0)
					]));
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$Evergreen$V417$Route$w3_encode_SlackWorkspaceRouteData(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
	}
};
var $author$project$Evergreen$V417$Audio$w3_encode_BufferId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Evergreen$V417$Audio$w3_encode_Source = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				function (w3_rec_var0) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$author$project$Evergreen$V417$Audio$w3_encode_BufferId(w3_rec_var0.bufferId)
						]));
			}(v0)
			]));
};
var $author$project$Evergreen$V417$Ports$w3_encode_NotificationPermission = function (w3v) {
	switch (w3v) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Evergreen$V417$Ports$w3_encode_PwaStatus = function (w3v) {
	if (w3v === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$Ports$w3_encode_StartupData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.devicePixelRatio),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				w3_rec_var0.e2eeKeys),
				function (t) {
				return $lamdera$codecs$Lamdera$Wire3$encodeInt(
					$elm$time$Time$posixToMillis(t));
			}(w3_rec_var0.loadStartupDataTime),
				$author$project$Evergreen$V417$Ports$w3_encode_NotificationPermission(w3_rec_var0.notificationPermission),
				$author$project$Evergreen$V417$Ports$w3_encode_PwaStatus(w3_rec_var0.pwaStatus),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.randomSeed),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.safeAreaInsetBottom),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.safeAreaInsetTop),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.scrollbarWidth),
				function (t) {
				return $lamdera$codecs$Lamdera$Wire3$encodeInt(
					$elm$time$Time$posixToMillis(t));
			}(w3_rec_var0.timeOrigin),
				$elm$time$Time$w3_encode_Zone(w3_rec_var0.timezone),
				$author$project$Evergreen$V417$UserAgent$w3_encode_UserAgent(w3_rec_var0.userAgent)
			]));
};
var $author$project$Evergreen$V417$Internal$Model2$w3_encode_State = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				function (w3_rec_var0) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$lamdera$codecs$Lamdera$Wire3$encodeSet$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.added),
							$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.keyframes),
							$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.rules)
						]));
			}(v0)
			]));
};
var $author$project$Evergreen$V417$Ui$Anim$w3_encode_State = $author$project$Evergreen$V417$Internal$Model2$w3_encode_State;
var $author$project$Evergreen$V417$Types$w3_encode_LinkDiscordFailure = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$Discord$w3_encode_HttpError(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$Types$w3_encode_AdminStatusLoginData = function (w3v) {
	switch (w3v.$) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$Pages$Admin$w3_encode_InitAdminData(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V417$Types$w3_encode_LoginData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$Types$w3_encode_AdminStatusLoginData(w3_rec_var0.adminData),
				$lamdera$containers$SeqDict$encodeDict$($author$project$Evergreen$V417$Call$w3_encode_CallId, $author$project$Evergreen$V417$Call$w3_encode_RecordingStatus, w3_rec_var0.callRecordings),
				$author$project$Evergreen$V417$UserSession$w3_encode_Viewing(w3_rec_var0.currentlyViewing),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_CustomEmojiId),
				$author$project$Evergreen$V417$CustomEmoji$w3_encode_CustomEmojiData,
				w3_rec_var0.customEmojis),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId),
				$author$project$Evergreen$V417$DmChannel$w3_encode_DiscordFrontendDmChannel,
				w3_rec_var0.discordDmChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Discord$w3_encode_Id($author$project$Evergreen$V417$Discord$w3_encode_GuildId),
				$author$project$Evergreen$V417$LocalState$w3_encode_DiscordFrontendGuild,
				w3_rec_var0.discordGuilds),
				$author$project$Evergreen$V417$LinkedAndOtherDiscordUsers$w3_encode_LinkedAndOtherDiscordUsers(w3_rec_var0.discordUsers),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				$author$project$Evergreen$V417$DmChannel$w3_encode_FrontendDmChannel,
				w3_rec_var0.dmChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_GuildId),
				$author$project$Evergreen$V417$LocalState$w3_encode_FrontendGuild,
				w3_rec_var0.guilds),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_UserId),
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_TeamId),
				w3_rec_var0.linkedSlackUsers),
				$lamdera$containers$SeqDict$encodeDict$($author$project$Evergreen$V417$SessionIdHash$w3_encode_SessionIdHash, $author$project$Evergreen$V417$UserSession$w3_encode_FrontendUserSession, w3_rec_var0.otherSessions),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
				$author$project$Evergreen$V417$User$w3_encode_FrontendUser,
				w3_rec_var0.otherUsers),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.publicVapidKey),
				$author$project$Evergreen$V417$UserSession$w3_encode_UserSession(w3_rec_var0.session),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_DmChannelId),
				$author$project$Evergreen$V417$LocalState$w3_encode_SlackFrontendDmChannel,
				w3_rec_var0.slackDmChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_UserId),
				$author$project$Evergreen$V417$UserSession$w3_encode_SlackFrontendUser,
				w3_rec_var0.slackUsers),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_UserId),
				w3_rec_var0.slackUsersNeedingAuth),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Slack$w3_encode_Id($author$project$Evergreen$V417$Slack$w3_encode_TeamId),
				$author$project$Evergreen$V417$LocalState$w3_encode_SlackFrontendWorkspace,
				w3_rec_var0.slackWorkspaces),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_StickerId),
				$author$project$Evergreen$V417$Sticker$w3_encode_StickerData,
				w3_rec_var0.stickers),
				$author$project$Evergreen$V417$TextEditor$w3_encode_LocalState(w3_rec_var0.textEditor),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.twoFactorAuthenticationEnabled),
				$author$project$Evergreen$V417$User$w3_encode_FrontendCurrentUser(w3_rec_var0.user),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V417$Call$w3_encode_CallId,
				A2(
					$author$project$Evergreen$V417$NonemptyDict$w3_encode_NonemptyDict,
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
						$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId),
					$author$project$Evergreen$V417$Call$w3_encode_RemoteCallData),
				w3_rec_var0.voiceChatPeers)
			]));
};
var $author$project$Evergreen$V417$Types$w3_encode_LoginResult = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Types$w3_encode_LoginData(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
	}
};
var $author$project$Evergreen$V417$Go$w3_encode_PublicGoMatchResponse = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Evergreen$V417$Go$w3_encode_ActionWithTime, w3_rec_var0.actions),
				$author$project$Evergreen$V417$User$w3_encode_FrontendUser(w3_rec_var0.creatorUser),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$User$w3_encode_FrontendUser, w3_rec_var0.joinedUser),
				$author$project$Evergreen$V417$Go$w3_encode_ValidatedSetup(w3_rec_var0.setup)
			]));
};
var $author$project$Evergreen$V417$AiChat$w3_encode_AiResponse = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.content),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeFloat, w3_rec_var0.cost),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.images),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.reasoning)
			]));
};
var $author$project$Evergreen$V417$AiChat$w3_encode_ToFrontend = function (w3v) {
	var v0 = w3v.a;
	var v1 = w3v.b;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$author$project$Evergreen$V417$AiChat$w3_encode_ResponseId(v0),
				$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Http$w3_encode_Error, $author$project$Evergreen$V417$AiChat$w3_encode_AiResponse, v1)
			]));
};
var $author$project$Evergreen$V417$ImageEditor$w3_encode_ToFrontend = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V417$Pages$Admin$w3_encode_ExportSubset = function (w3v) {
	if (w3v.$ === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V417$Pages$Admin$w3_encode_ExportSubsetSelection(v0)
				]));
	}
};
var $author$project$Evergreen$V417$Pages$Admin$w3_encode_ToFrontend = function (w3v) {
	switch (w3v.$) {
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$LocalState$w3_encode_BackupContents(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeBytes(v2)
					]));
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$Pages$Admin$w3_encode_ExportSubset(v0),
						$author$project$Evergreen$V417$Pages$Admin$w3_encode_ExportProgress(v1)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$codecs$Lamdera$Wire3$encodeUnit, $lamdera$codecs$Lamdera$Wire3$encodeUnit, v0)
					]));
	}
};
var $author$project$Evergreen$V417$TwoFactorAuthentication$w3_encode_ToFrontend = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v1)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v1)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.qrCodeUrl)
								]));
					}(v0)
					]));
	}
};
var $author$project$Evergreen$V417$Types$w3_encode_ToFrontend = function (w3v) {
	switch (w3v.$) {
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Pages$Admin$w3_encode_ToFrontend(v0)
					]));
		case 9:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$AiChat$w3_encode_ToFrontend(v0)
					]));
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$Types$w3_encode_LocalMsg(v0)
					]));
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V417$Types$w3_encode_LoginType(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$codecs$Lamdera$Wire3$encodeUnit, $author$project$Evergreen$V417$Types$w3_encode_LoginData, v1)
					]));
		case 16:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.fileName),
									$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.json)
								]));
					}(v0)
					]));
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 15:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$codecs$Lamdera$Wire3$encodeUnit, $author$project$Evergreen$V417$Go$w3_encode_PublicGoMatchResponse, v0)
					]));
		case 17:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$(
						$author$project$Evergreen$V417$Types$w3_encode_ImportChannelError,
						function (w3_rec_var0) {
							return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
								_List_fromArray(
									[
										$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.encryptedMessages)
									]));
						},
						v1)
					]));
		case 12:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($author$project$Evergreen$V417$Types$w3_encode_LinkDiscordFailure, $lamdera$codecs$Lamdera$Wire3$encodeUnit, v0)
					]));
		case 13:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V417$Types$w3_encode_LinkSlackResult(v0)
					]));
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Evergreen$V417$Local$w3_encode_ChangeId(v0),
						$author$project$Evergreen$V417$Types$w3_encode_LocalChange(v1)
					]));
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$Evergreen$V417$Types$w3_encode_LoginResult(v0)
					]));
		case 14:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$author$project$Evergreen$V417$ImageEditor$w3_encode_ToFrontend(v0)
					]));
		case 11:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$codecs$Lamdera$Wire3$encodeUnit, $author$project$Evergreen$V417$Types$w3_encode_LoginData, v0)
					]));
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(15);
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$author$project$Evergreen$V417$TwoFactorAuthentication$w3_encode_ToFrontend(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId(v0)
					]));
	}
};
var $author$project$Evergreen$V417$Types$w3_encode_LoadedFrontend = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$AiChat$w3_encode_FrontendModel(w3_rec_var0.aiChatModel),
				$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId(w3_rec_var0.clientId),
				$author$project$Evergreen$V417$Touch$w3_encode_Drag(w3_rec_var0.drag),
				$author$project$Evergreen$V417$Touch$w3_encode_Drag(w3_rec_var0.dragPrevious),
				$author$project$Evergreen$V417$Ui$Anim$w3_encode_State(w3_rec_var0.elmUiState),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Emoji$w3_encode_CachedEmojiData, w3_rec_var0.emojiData),
				function (w3_rec_var1) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var1.changedAt),
							$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.index),
							$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var1.rotate)
						]));
			}(w3_rec_var0.homePagePreview),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$ImageViewer$w3_encode_Model, w3_rec_var0.imageViewer),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$MyUi$w3_encode_LastCopy, w3_rec_var0.lastCopied),
				$author$project$Evergreen$V417$Types$w3_encode_LoginStatus(w3_rec_var0.loginStatus),
				$author$project$Evergreen$V417$Types$w3_encode_LoginType(w3_rec_var0.loginType),
				$lamdera$program_test$Effect$Browser$Navigation$w3_encode_Key(w3_rec_var0.navigationKey),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pageHasFocus),
				$lamdera$codecs$Lamdera$Wire3$encodeResult$($author$project$Evergreen$V417$Audio$w3_encode_LoadError, $author$project$Evergreen$V417$Audio$w3_encode_Source, w3_rec_var0.popSound),
				$author$project$Evergreen$V417$Types$w3_encode_PublicGoMatch(w3_rec_var0.publicGoMatch),
				$author$project$Evergreen$V417$Route$w3_encode_Route(w3_rec_var0.route),
				$author$project$Evergreen$V417$Ports$w3_encode_StartupData(w3_rec_var0.startupData),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.time),
				$lamdera$program_test$Effect$Time$w3_encode_Zone(w3_rec_var0.timezone),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$lamdera$codecs$Lamdera$Wire3$encodeArray($author$project$Evergreen$V417$Types$w3_encode_ToFrontend),
				w3_rec_var0.toFrontendLogs),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.versionNumber),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.visualViewportHeight),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.visualViewportTop),
				A2($author$project$Evergreen$V417$Coord$w3_encode_Coord, $author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels, w3_rec_var0.windowSize)
			]));
};
var $author$project$Evergreen$V417$Types$w3_encode_LoadStatus = function (w3v) {
	switch (w3v.$) {
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$Types$w3_encode_LoginData(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V417$Types$w3_encode_LoadingFrontend = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Lamdera$w3_encode_ClientId, w3_rec_var0.clientId),
				$author$project$Evergreen$V417$Types$w3_encode_LoadStatus(w3_rec_var0.loginStatus),
				$author$project$Evergreen$V417$Types$w3_encode_LoginType(w3_rec_var0.loginType),
				$lamdera$program_test$Effect$Browser$Navigation$w3_encode_Key(w3_rec_var0.navigationKey),
				$lamdera$codecs$Lamdera$Wire3$encodeResult$($author$project$Evergreen$V417$Audio$w3_encode_LoadError, $author$project$Evergreen$V417$Audio$w3_encode_Source, w3_rec_var0.popSound),
				$author$project$Evergreen$V417$Types$w3_encode_PublicGoMatch(w3_rec_var0.publicGoMatch),
				$author$project$Evergreen$V417$Route$w3_encode_Route(w3_rec_var0.route),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Ports$w3_encode_StartupData, w3_rec_var0.startupData),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.time),
				A2($author$project$Evergreen$V417$Coord$w3_encode_Coord, $author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels, w3_rec_var0.windowSize)
			]));
};
var $author$project$Evergreen$V417$Types$w3_encode_FrontendModel_ = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$Types$w3_encode_LoadedFrontend(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V417$Types$w3_encode_LoadingFrontend(v0)
				]));
	}
};
var $lamdera$program_test$Effect$Browser$Dom$w3_encode_Element = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				function (w3_rec_var1) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.height),
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.width),
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.x),
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.y)
						]));
			}(w3_rec_var0.element),
				function (w3_rec_var1) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.height),
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.width)
						]));
			}(w3_rec_var0.scene),
				function (w3_rec_var1) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.height),
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.width),
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.x),
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.y)
						]));
			}(w3_rec_var0.viewport)
			]));
};
var $lamdera$program_test$Effect$Browser$Dom$w3_encode_Error = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$program_test$Effect$Browser$Dom$w3_encode_HtmlId(v0)
			]));
};
var $author$project$Evergreen$V417$Id$w3_encode_ExportChannelId = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, v2)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId, v1)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelId, v1)
					]));
	}
};
var $lamdera$codecs$Lamdera$Wire3$encodeRef = function (v) {
	return A2(
		$elm$bytes$Bytes$Encode$unsignedInt32,
		$lamdera$codecs$Lamdera$Wire3$endianness,
		_LamderaCodecs_encodeWithRef(v));
};
var $lamdera$program_test$Effect$File$w3_encode_FileUploadContent = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$codecs$Lamdera$Wire3$encodeBytes(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
				]));
	}
};
var $lamdera$program_test$Effect$File$w3_encode_File = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					function (w3_rec_var0) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$program_test$Effect$File$w3_encode_FileUploadContent(w3_rec_var0.content),
								function (t) {
								return $lamdera$codecs$Lamdera$Wire3$encodeInt(
									$elm$time$Time$posixToMillis(t));
							}(w3_rec_var0.lastModified),
								$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.mimeType),
								$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name)
							]));
				}(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodeRef(v0)
				]));
	}
};
var $author$project$Evergreen$V417$Call$w3_encode_FromJs = function (w3v) {
	switch (w3v.$) {
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V417$Call$w3_encode_DebugSection, v0)
					]));
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V417$Call$w3_encode_MediaDevice, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						$author$project$Evergreen$V417$IdString$w3_encode_IdString($author$project$Evergreen$V417$Call$w3_encode_MediaDeviceId),
						v1)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 7:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1)
					]));
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Evergreen$V417$Call$w3_encode_LocalOrConnection(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v1)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
	}
};
var $author$project$Evergreen$V417$FileStatus$w3_encode_MeasuredFile = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					A2($author$project$Evergreen$V417$Coord$w3_encode_Coord, $author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels, v0)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					A2($author$project$Evergreen$V417$Coord$w3_encode_Coord, $author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels, v0),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($ianmackenzie$elm_units$Duration$w3_encode_Duration, v1)
				]));
	}
};
var $author$project$Evergreen$V417$Encryption$w3_encode_FromJs$ = function (w3_x_c_a, w3v) {
	switch (w3v.$) {
		case 10:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Encryption$w3_encode_EncryptFileRequestId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 9:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Encryption$w3_encode_EncryptFileRequestId, v0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeBytes(w3_rec_var0.data),
									$lamdera$codecs$Lamdera$Wire3$encodeBytes(w3_rec_var0.key),
									$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$FileStatus$w3_encode_MeasuredFile, w3_rec_var0.measured),
									$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeBytes, w3_rec_var0.thumbnail)
								]));
					}(v1)
					]));
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Encryption$w3_encode_DecryptManyRequestId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						A2($lamdera$codecs$Lamdera$Wire3$encodeResult, $lamdera$codecs$Lamdera$Wire3$encodeUnit, w3_x_c_a),
						v1)
					]));
		case 8:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Encryption$w3_encode_EncryptManyRequestId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 7:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Encryption$w3_encode_EncryptManyRequestId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						$author$project$Evergreen$V417$Encryption$w3_encode_EncryptedData(w3_x_c_a),
						v1)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Encryption$w3_encode_DecryptRequestId, v0)
					]));
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Encryption$w3_encode_DecryptRequestId, v0),
						w3_x_c_a(v1)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Encryption$w3_encode_EncryptRequestId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Encryption$w3_encode_EncryptRequestId, v0),
						$author$project$Evergreen$V417$Encryption$w3_encode_EncryptedData$(w3_x_c_a, v1)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0)
					]));
	}
};
var $author$project$Evergreen$V417$Encryption$w3_encode_FromJs = F2($author$project$Evergreen$V417$Encryption$w3_encode_FromJs$);
var $author$project$Evergreen$V417$RichText$w3_encode_PressedImageId = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$FileStatus$w3_encode_FileId, v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
				]));
	}
};
var $author$project$Evergreen$V417$RichText$w3_encode_PressedImageData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.displayWidth),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.fileUrl),
				$author$project$Evergreen$V417$RichText$w3_encode_PressedImageId(w3_rec_var0.imageId),
				A2($author$project$Evergreen$V417$Coord$w3_encode_Coord, $author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels, w3_rec_var0.imageSize),
				A3($author$project$Evergreen$V417$Point2d$w3_encode_Point2d, $author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels, $author$project$Evergreen$V417$Touch$w3_encode_ScreenCoordinate, w3_rec_var0.position)
			]));
};
var $author$project$Evergreen$V417$MessageView$w3_encode_MessageViewMsg = function (w3v) {
	switch (w3v.$) {
		case 17:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 18:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 16:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji(v0)
					]));
		case 12:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 13:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0),
						A2($author$project$Evergreen$V417$Coord$w3_encode_Coord, $author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels, v1)
					]));
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v2),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, v3),
						A2($author$project$Evergreen$V417$Coord$w3_encode_Coord, $author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels, v4)
					]));
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		case 15:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 22:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						A3($author$project$Evergreen$V417$Point2d$w3_encode_Point2d, $author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels, $author$project$Evergreen$V417$Touch$w3_encode_ScreenCoordinate, v0),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $lamdera$codecs$Lamdera$Wire3$encodeFloat, v1)
					]));
		case 25:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRoute(v1)
					]));
		case 27:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 21:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$justinmimbs$date$Date$w3_encode_Date(v0),
						A3($author$project$Evergreen$V417$Point2d$w3_encode_Point2d, $author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels, $author$project$Evergreen$V417$Touch$w3_encode_ScreenCoordinate, v1),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $lamdera$codecs$Lamdera$Wire3$encodeFloat, v2)
					]));
		case 26:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRoute(v1)
					]));
		case 24:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$author$project$Evergreen$V417$RichText$w3_encode_PressedImageData(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$elm$url$Url$w3_encode_Url(v0)
					]));
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(19),
						$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji(v0)
					]));
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(20),
						$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji(v0)
					]));
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(21);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(22),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 20:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(23),
						A3($author$project$Evergreen$V417$Point2d$w3_encode_Point2d, $author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels, $author$project$Evergreen$V417$Touch$w3_encode_ScreenCoordinate, v0),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $lamdera$codecs$Lamdera$Wire3$encodeFloat, v1)
					]));
		case 19:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(24),
						A3($author$project$Evergreen$V417$Point2d$w3_encode_Point2d, $author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels, $author$project$Evergreen$V417$Touch$w3_encode_ScreenCoordinate, v0),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $lamdera$codecs$Lamdera$Wire3$encodeFloat, v1)
					]));
		case 23:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(25),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0)
					]));
		case 14:
			return $elm$bytes$Bytes$Encode$unsignedInt8(26);
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(27),
						$ianmackenzie$elm_units$Duration$w3_encode_Duration(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v2),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v3),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, v4),
						$author$project$Evergreen$V417$NonemptyDict$w3_encode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$Evergreen$V417$Touch$w3_encode_Touch, v5)
					]));
	}
};
var $author$project$Evergreen$V417$AiChat$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 13:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 15:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$AiChat$w3_encode_ResponseId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 17:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$(
						$lamdera$program_test$Effect$Http$w3_encode_Error,
						$lamdera$codecs$Lamdera$Wire3$encodeList($author$project$Evergreen$V417$AiChat$w3_encode_AiModel),
						v0)
					]));
		case 14:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 16:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Evergreen$V417$AiChat$w3_encode_ResponseId(v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V417$AiChat$w3_encode_ResponseId(v0)
					]));
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 11:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$Evergreen$V417$AiChat$w3_encode_ResponseId(v0)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
		case 9:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$author$project$Evergreen$V417$AiChat$w3_encode_AiModelName(v1)
					]));
		case 12:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$author$project$Evergreen$V417$AiChat$w3_encode_SendMessageWith(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
	}
};
var $author$project$Evergreen$V417$Call$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 11:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Call$w3_encode_ConnectionId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v1)
					]));
		case 14:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 12:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$Call$w3_encode_LocalOrConnection(v0)
					]));
		case 13:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V417$Call$w3_encode_LocalOrConnection(v0)
					]));
		case 18:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 9:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 10:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Evergreen$V417$Call$w3_encode_CallId(v0)
					]));
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 17:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		case 16:
			return $elm$bytes$Bytes$Encode$unsignedInt8(12);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(14);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(15);
		case 15:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$author$project$Evergreen$V417$Call$w3_encode_VideoTile(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$author$project$Evergreen$V417$IdString$w3_encode_IdString$($author$project$Evergreen$V417$Call$w3_encode_MediaDeviceId, v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$author$project$Evergreen$V417$IdString$w3_encode_IdString$($author$project$Evergreen$V417$Call$w3_encode_MediaDeviceId, v0)
					]));
	}
};
var $author$project$Evergreen$V417$Drawing$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
						function (w3_rec_var0) {
							return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
								_List_fromArray(
									[
										$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.height),
										$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.width),
										$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.x),
										$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.y)
									]));
						},
						v0)
					]));
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v1)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v1)
					]));
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
	}
};
var $author$project$Evergreen$V417$Editable$w3_encode_Msg$ = function (w3_x_c_value, w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$Editable$w3_encode_Model(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					w3_x_c_value(v0)
				]));
	}
};
var $author$project$Evergreen$V417$Editable$w3_encode_Msg = F2($author$project$Evergreen$V417$Editable$w3_encode_Msg$);
var $author$project$Evergreen$V417$Emoji$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrSticker(v1)
					]));
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrSticker(v1)
					]));
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V417$Emoji$w3_encode_Category(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1)
					]));
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrSticker(v0)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Emoji$w3_encode_SkinTone, v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V417$Emoji$w3_encode_Category(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
	}
};
var $author$project$Evergreen$V417$Go$w3_encode_SpectatorMsg = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt, v0)
					]));
	}
};
var $author$project$Evergreen$V417$Go$w3_encode_GameMsg = function (w3v) {
	switch (w3v.$) {
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt, v0)
					]));
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Evergreen$V417$Go$w3_encode_SpectatorMsg(v0)
					]));
	}
};
var $author$project$Evergreen$V417$MessageInput$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 14:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 13:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 9:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$($lamdera$program_test$Effect$File$w3_encode_File, v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.charsLeft)
								]));
					}(v0)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(12);
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$author$project$Evergreen$V417$Range$w3_encode_Range(v0)
					]));
	}
};
var $author$project$Evergreen$V417$FileStatus$w3_encode_UploadResponse = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V417$FileStatus$w3_encode_FileHash(w3_rec_var0.fileHash),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$FileStatus$w3_encode_ImageMetadata, w3_rec_var0.imageMetadata),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$FileStatus$w3_encode_VideoMetadata, w3_rec_var0.videoMetadata)
			]));
};
var $author$project$Evergreen$V417$SheepGame$w3_encode_GameMsg = function (w3v) {
	switch (w3v.$) {
		case 19:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v0)
					]));
		case 21:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
						v0)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$FileStatus$w3_encode_FileId, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Http$w3_encode_Error, $author$project$Evergreen$V417$FileStatus$w3_encode_UploadResponse, v2)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v0),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$($lamdera$program_test$Effect$File$w3_encode_File, v1)
					]));
		case 11:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$FileStatus$w3_encode_FileId, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Http$w3_encode_Error, $author$project$Evergreen$V417$FileStatus$w3_encode_UploadResponse, v2)
					]));
		case 10:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v0),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$($lamdera$program_test$Effect$File$w3_encode_File, v1)
					]));
		case 18:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v0)
					]));
		case 20:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
						v0)
					]));
		case 27:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 25:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$FileStatus$w3_encode_FileId, v1)
					]));
		case 12:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$FileStatus$w3_encode_FileId, v1)
					]));
		case 17:
			return $elm$bytes$Bytes$Encode$unsignedInt8(12);
		case 24:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$author$project$Evergreen$V417$RichText$w3_encode_PressedImageData(v0)
					]));
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(14);
		case 26:
			return $elm$bytes$Bytes$Encode$unsignedInt8(15);
		case 15:
			return $elm$bytes$Bytes$Encode$unsignedInt8(16);
		case 16:
			return $elm$bytes$Bytes$Encode$unsignedInt8(17);
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$FileStatus$w3_encode_FileId, w3_rec_var0.fileId),
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.removeSpoiler)
								]));
					}(v1)
					]));
		case 14:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(19),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$FileStatus$w3_encode_FileId, w3_rec_var0.fileId),
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.removeSpoiler)
								]));
					}(v1)
					]));
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(20);
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(21),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$FileStatus$w3_encode_FileId, v1)
					]));
		case 13:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(22),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$FileStatus$w3_encode_FileId, v1)
					]));
		case 23:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(23),
						$author$project$Evergreen$V417$SheepGame$w3_encode_ReactionTarget(v0),
						$author$project$Evergreen$V417$MessageView$w3_encode_MessageViewMsg(v1)
					]));
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(24),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v0),
						$author$project$Evergreen$V417$MessageInput$w3_encode_Msg(v1)
					]));
		case 8:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(25),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v2)
					]));
		case 9:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(26),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v0),
						$author$project$Evergreen$V417$MessageInput$w3_encode_Msg(v1)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(27),
						$author$project$Evergreen$V417$Scroll$w3_encode_ScrollPosition(v0)
					]));
	}
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_GameMsg = function (w3v) {
	switch (w3v.$) {
		case 16:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$(
						$lamdera$program_test$Effect$Http$w3_encode_Error,
						$lamdera$codecs$Lamdera$Wire3$encodeList($author$project$Evergreen$V417$WordSpellingGame$w3_encode_DictEntry),
						v1)
					]));
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0)
					]));
		case 8:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						A2(
							$lamdera$codecs$Lamdera$Wire3$encodePair,
							A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
							$author$project$Evergreen$V417$WordSpellingGame$w3_encode_LetterOrWildcard),
						v1),
						$author$project$Evergreen$V417$WordSpellingGame$w3_encode_Shared(v2)
					]));
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0)
					]));
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 15:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 14:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0)
					]));
		case 13:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		case 11:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$Evergreen$V417$WordSpellingGame$w3_encode_PlacedWord(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$author$project$Evergreen$V417$WordSpellingGame$w3_encode_PlacedWord(v0)
					]));
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(14);
		case 12:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$($lamdera$codecs$Lamdera$Wire3$encodeString, v0)
					]));
		case 17:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$author$project$Evergreen$V417$WordSpellingGame$w3_encode_ReactionTarget(v0),
						$author$project$Evergreen$V417$MessageView$w3_encode_MessageViewMsg(v1)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$author$project$Evergreen$V417$Scroll$w3_encode_ScrollPosition(v0)
					]));
	}
};
var $author$project$Evergreen$V417$Go$w3_encode_SetupMsg = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Evergreen$V417$Go$w3_encode_Stone(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V417$Go$w3_encode_SizeSelection(v0)
					]));
	}
};
var $author$project$Evergreen$V417$SheepGame$w3_encode_SetupMsg = function (w3v) {
	switch (w3v.$) {
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$FileStatus$w3_encode_FileId, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Http$w3_encode_Error, $author$project$Evergreen$V417$FileStatus$w3_encode_UploadResponse, v2)
					]));
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v0),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$($lamdera$program_test$Effect$File$w3_encode_File, v1)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 7:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$FileStatus$w3_encode_FileId, v1)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v0)
					]));
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 9:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$FileStatus$w3_encode_FileId, w3_rec_var0.fileId),
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.removeSpoiler)
								]));
					}(v1)
					]));
		case 8:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$FileStatus$w3_encode_FileId, v1)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_QuestionId, v0),
						$author$project$Evergreen$V417$MessageInput$w3_encode_Msg(v1)
					]));
	}
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_encode_SetupMsg = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeChar(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V417$OneOrGreater$w3_encode_OneOrGreater(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Evergreen$V417$WordSpellingGame$w3_encode_Language(v0)
					]));
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
	}
};
var $author$project$Evergreen$V417$Game$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Go$w3_encode_GameMsg(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$Go$w3_encode_SetupMsg(v0)
					]));
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 10:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V417$Message$w3_encode_GameType(v0)
					]));
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v0)
					]));
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v0)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Evergreen$V417$SheepGame$w3_encode_GameMsg(v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V417$SheepGame$w3_encode_SetupMsg(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Evergreen$V417$WordSpellingGame$w3_encode_GameMsg(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$Evergreen$V417$WordSpellingGame$w3_encode_SetupMsg(v0)
					]));
	}
};
var $author$project$Evergreen$V417$Ports$w3_encode_CropImageDataResponse = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.croppedImageUrl),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.requestId)
			]));
};
var $author$project$Evergreen$V417$ImageEditor$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 9:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$codecs$Lamdera$Wire3$encodeString, $author$project$Evergreen$V417$Ports$w3_encode_CropImageDataResponse, v0)
					]));
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_encode_Error, $lamdera$program_test$Effect$Browser$Dom$w3_encode_Element, v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v1)
					]));
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v1)
					]));
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$lamdera$program_test$Effect$File$w3_encode_File(v0)
					]));
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Http$w3_encode_Error, $author$project$Evergreen$V417$FileStatus$w3_encode_UploadResponse, v0)
					]));
	}
};
var $author$project$Evergreen$V417$ImageViewer$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 11:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$ianmackenzie$elm_units$Duration$w3_encode_Duration(v0)
					]));
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v1)
					]));
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v1)
					]));
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 9:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeFloat, $lamdera$codecs$Lamdera$Wire3$encodeFloat),
						v0)
					]));
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeFloat, $lamdera$codecs$Lamdera$Wire3$encodeFloat),
						v0)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v2)
					]));
	}
};
var $author$project$Evergreen$V417$LoginForm$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
	}
};
var $author$project$Evergreen$V417$Table$w3_encode_Msg = function (w3v) {
	if (w3v.$ === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
				]));
	}
};
var $author$project$Evergreen$V417$Pages$Admin$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 19:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Editable$w3_encode_Msg$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$codecs$Lamdera$Wire3$encodeInt),
						v0)
					]));
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$Pages$Admin$w3_encode_UserTableId(v0),
						$author$project$Evergreen$V417$Pages$Admin$w3_encode_UserColumn(v1)
					]));
		case 7:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V417$Pages$Admin$w3_encode_UserTableId(v0),
						$author$project$Evergreen$V417$Pages$Admin$w3_encode_UserColumn(v1)
					]));
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 55:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeBytes(v0)
					]));
		case 54:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$lamdera$program_test$Effect$File$w3_encode_File(v0)
					]));
		case 36:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Evergreen$V417$Editable$w3_encode_Msg$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe(
							$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId)),
						v0)
					]));
		case 35:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Evergreen$V417$Editable$w3_encode_Msg$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$codecs$Lamdera$Wire3$encodeString),
						v0)
					]));
		case 34:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V417$Editable$w3_encode_Msg$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$codecs$Lamdera$Wire3$encodeString),
						v0)
					]));
		case 37:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Evergreen$V417$Editable$w3_encode_Msg$($author$project$Evergreen$V417$Postmark$w3_encode_ApiKey, v0)
					]));
		case 12:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		case 52:
			return $elm$bytes$Bytes$Encode$unsignedInt8(12);
		case 51:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Pagination$w3_encode_ItemId, v0)
					]));
		case 42:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 23:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId, v0)
					]));
		case 24:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v0)
					]));
		case 30:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0)
					]));
		case 59:
			return $elm$bytes$Bytes$Encode$unsignedInt8(19);
		case 57:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(20),
						$author$project$Evergreen$V417$SessionIdHash$w3_encode_SessionIdHash(v0)
					]));
		case 28:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(21),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_DmChannelId, v0)
					]));
		case 26:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(22),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_TeamId, v0)
					]));
		case 13:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(23),
						$author$project$Evergreen$V417$Pages$Admin$w3_encode_UserTableId(v0)
					]));
		case 56:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(24),
						$author$project$Evergreen$V417$SessionIdHash$w3_encode_SessionIdHash(v0),
						$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId(v1)
					]));
		case 46:
			return $elm$bytes$Bytes$Encode$unsignedInt8(25);
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(26),
						$author$project$Evergreen$V417$Pages$Admin$w3_encode_UserTableId(v0),
						$author$project$Evergreen$V417$Pages$Admin$w3_encode_UserColumn(v1)
					]));
		case 25:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(27),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v0)
					]));
		case 29:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(28),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(29),
						$author$project$Evergreen$V417$Pages$Admin$w3_encode_AdminUiSection(v0)
					]));
		case 27:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(30),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_TeamId, v0)
					]));
		case 44:
			return $elm$bytes$Bytes$Encode$unsignedInt8(31);
		case 45:
			return $elm$bytes$Bytes$Encode$unsignedInt8(32);
		case 38:
			return $elm$bytes$Bytes$Encode$unsignedInt8(33);
		case 53:
			return $elm$bytes$Bytes$Encode$unsignedInt8(34);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(35),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Pagination$w3_encode_PageId, v0)
					]));
		case 58:
			return $elm$bytes$Bytes$Encode$unsignedInt8(36);
		case 39:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(37),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, v2)
					]));
		case 40:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(38),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId, v1)
					]));
		case 41:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(39),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v1)
					]));
		case 14:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(40),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0)
					]));
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(41);
		case 31:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(42),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0)
					]));
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(43);
		case 61:
			return $elm$bytes$Bytes$Encode$unsignedInt8(44);
		case 60:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(45),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 33:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(46),
						$author$project$Evergreen$V417$Editable$w3_encode_Msg$($author$project$Evergreen$V417$LocalState$w3_encode_PrivateVapidKey, v0)
					]));
		case 32:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(47),
						$author$project$Evergreen$V417$Editable$w3_encode_Msg$($lamdera$codecs$Lamdera$Wire3$encodeString, v0)
					]));
		case 21:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(48),
						$author$project$Evergreen$V417$Editable$w3_encode_Msg$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$codecs$Lamdera$Wire3$encodeInt),
						v0)
					]));
		case 9:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(49),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 22:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(50),
						$author$project$Evergreen$V417$Pages$Admin$w3_encode_UserTableId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v1)
					]));
		case 18:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(51),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 16:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(52),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 50:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(53),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v1)
					]));
		case 49:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(54),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v1)
					]));
		case 48:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(55),
						$author$project$Evergreen$V417$DmChannelId$w3_encode_DmChannelId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v1)
					]));
		case 47:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(56),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v1)
					]));
		case 17:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(57),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 20:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(58),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(59),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 43:
			return $elm$bytes$Bytes$Encode$unsignedInt8(60);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(61),
						$author$project$Evergreen$V417$Table$w3_encode_Msg(v0)
					]));
	}
};
var $author$project$Evergreen$V417$RecoveryLogin$w3_encode_Msg = function (w3v) {
	if (w3v.$ === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
				]));
	}
};
var $author$project$Evergreen$V417$TextEditor$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
	}
};
var $author$project$Evergreen$V417$TwoFactorAuthentication$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
	}
};
var $author$project$Evergreen$V417$Internal$Teleport$w3_encode_CssAnimation = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.hash),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.keyframes),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.keyframesHash),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeString, $lamdera$codecs$Lamdera$Wire3$encodeString),
				w3_rec_var0.props),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.transition),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.trigger)
			]));
};
var $author$project$Evergreen$V417$Internal$Teleport$w3_encode_ParentTriggerDetails = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V417$Internal$Teleport$w3_encode_CssAnimation, w3_rec_var0.children),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.identifierClass),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.trigger)
			]));
};
var $author$project$Evergreen$V417$Internal$Teleport$w3_encode_Data = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$Internal$Teleport$w3_encode_CssAnimation(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V417$Internal$Teleport$w3_encode_ParentTriggerDetails(v0)
				]));
	}
};
var $author$project$Evergreen$V417$Internal$Teleport$w3_encode_Event = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V417$Internal$Teleport$w3_encode_Data, w3_rec_var0.data),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.timestamp)
			]));
};
var $author$project$Evergreen$V417$Internal$Teleport$w3_encode_Trigger = function (w3v) {
	switch (w3v) {
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
	}
};
var $author$project$Evergreen$V417$Internal$Model2$w3_encode_Msg = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$Internal$Teleport$w3_encode_Trigger(v0),
					$author$project$Evergreen$V417$Internal$Teleport$w3_encode_Event(v1)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					function (t) {
					return $lamdera$codecs$Lamdera$Wire3$encodeInt(
						$elm$time$Time$posixToMillis(t));
				}(v0)
				]));
	}
};
var $author$project$Evergreen$V417$Ui$Anim$w3_encode_Msg = $author$project$Evergreen$V417$Internal$Model2$w3_encode_Msg;
var $lamdera$program_test$Effect$Http$w3_encode_Progress = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					function (w3_rec_var0) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.received),
								$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.size)
							]));
				}(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					function (w3_rec_var0) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.sent),
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.size)
							]));
				}(v0)
				]));
	}
};
var $elm$browser$Browser$w3_encode_UrlRequest = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$elm$url$Url$w3_encode_Url(v0)
				]));
	}
};
var $lamdera$program_test$Effect$Browser$Dom$w3_encode_Viewport = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				function (w3_rec_var1) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.height),
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.width)
						]));
			}(w3_rec_var0.scene),
				function (w3_rec_var1) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.height),
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.width),
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.x),
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.y)
						]));
			}(w3_rec_var0.viewport)
			]));
};
var $author$project$Evergreen$V417$Types$w3_encode_FrontendMsg_ = function (w3v) {
	switch (w3v.$) {
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V417$Pages$Admin$w3_encode_Msg(v0)
					]));
		case 76:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V417$AiChat$w3_encode_Msg(v0)
					]));
		case 54:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$ianmackenzie$elm_units$Duration$w3_encode_Duration(v0)
					]));
		case 71:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			var v6 = w3v.g;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId(v1),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v2),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v3),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v4),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v5),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, v6)
					]));
		case 49:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V417$Ports$w3_encode_NotificationPermission(v0)
					]));
		case 79:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V417$Id$w3_encode_GuildOrDmId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1)
					]));
		case 78:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Evergreen$V417$Id$w3_encode_GuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V417$SheepGame$w3_encode_Input(v2),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v3)
					]));
		case 37:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 153:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$program_test$Effect$Browser$Dom$w3_encode_HtmlId),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe(
							A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Evergreen$V417$Range$w3_encode_Range, $author$project$Evergreen$V417$Range$w3_encode_SelectionDirection)),
						v0)
					]));
		case 164:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V417$Drawing$w3_encode_Msg(v0)
					]));
		case 16:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V417$Types$w3_encode_EditChannelForm(v2)
					]));
		case 20:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Types$w3_encode_EditGuildForm(v1)
					]));
		case 94:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_encode_ThreadRoute, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$FileStatus$w3_encode_FileId, v2),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Http$w3_encode_Error, $author$project$Evergreen$V417$FileStatus$w3_encode_UploadResponse, v3)
					]));
		case 146:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRoute(v1),
						$author$project$Evergreen$V417$MessageInput$w3_encode_Msg(v2)
					]));
		case 90:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_encode_ThreadRoute, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$FileStatus$w3_encode_FileId, v1)
					]));
		case 92:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_encode_ThreadRoute, v0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$FileStatus$w3_encode_FileId, w3_rec_var0.fileId),
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.removeSpoiler)
								]));
					}(v1)
					]));
		case 91:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_encode_ThreadRoute, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$FileStatus$w3_encode_FileId, v1)
					]));
		case 93:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_encode_ThreadRoute, v0),
						$lamdera$program_test$Effect$File$w3_encode_File(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$program_test$Effect$File$w3_encode_File, v2)
					]));
		case 10:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$author$project$Evergreen$V417$Ui$Anim$w3_encode_Msg(v0)
					]));
		case 45:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(19),
						$author$project$Evergreen$V417$Emoji$w3_encode_Msg(v0)
					]));
		case 151:
			return $elm$bytes$Bytes$Encode$unsignedInt8(20);
		case 186:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(21),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$(
						$lamdera$codecs$Lamdera$Wire3$encodeString,
						$author$project$Evergreen$V417$Encryption$w3_encode_FromJs(
							$author$project$Evergreen$V417$Message$w3_encode_MessageContent$(
								$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_UserId),
								$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_ChannelId))),
						v0)
					]));
		case 158:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(22),
						$ianmackenzie$elm_units$Duration$w3_encode_Duration(v0)
					]));
		case 159:
			return $elm$bytes$Bytes$Encode$unsignedInt8(23);
		case 160:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(24),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$program_test$Effect$File$w3_encode_File, v0)
					]));
		case 95:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(25),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_encode_ThreadRoute, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$FileStatus$w3_encode_FileId, v1),
						$lamdera$program_test$Effect$Http$w3_encode_Progress(v2)
					]));
		case 32:
			return $elm$bytes$Bytes$Encode$unsignedInt8(26);
		case 77:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(27),
						$author$project$Evergreen$V417$Game$w3_encode_Msg(v0)
					]));
		case 80:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(28),
						$author$project$Evergreen$V417$Go$w3_encode_SpectatorMsg(v0)
					]));
		case 109:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(29),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v0)
					]));
		case 148:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(30),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Http$w3_encode_Error, $author$project$Evergreen$V417$Emoji$w3_encode_CachedEmojiData, v0)
					]));
		case 86:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(31),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_encode_ThreadRoute, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$FileStatus$w3_encode_FileId, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$FileStatus$w3_encode_FileMetadata, v2),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Http$w3_encode_Error, $author$project$Evergreen$V417$FileStatus$w3_encode_UploadResponse, v3)
					]));
		case 85:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(32),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_encode_ThreadRoute, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$FileStatus$w3_encode_FileId, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v2),
						$lamdera$codecs$Lamdera$Wire3$encodeBytes(v3)
					]));
		case 26:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(33),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.fileName),
									$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.json)
								]));
					}(v1)
					]));
		case 38:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(34),
						$lamdera$program_test$Effect$Browser$Dom$w3_encode_HtmlId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_encode_Error, $author$project$Evergreen$V417$MessageInput$w3_encode_MentionUserDropdown, v1)
					]));
		case 149:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(35),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_encode_Error, $lamdera$program_test$Effect$Browser$Dom$w3_encode_Element, v0)
					]));
		case 150:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(36),
						$author$project$Evergreen$V417$SheepGame$w3_encode_Input(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_encode_Error, $lamdera$program_test$Effect$Browser$Dom$w3_encode_Element, v1)
					]));
		case 98:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(37),
						$author$project$Evergreen$V417$Ports$w3_encode_RegisterPushSubscription(v0)
					]));
		case 163:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(38),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 124:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(39),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 108:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(40),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$codecs$Lamdera$Wire3$encodeString, $author$project$Evergreen$V417$Ports$w3_encode_StartupData, v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(41),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0)
					]));
		case 135:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(42),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$codecs$Lamdera$Wire3$encodeUnit, $lamdera$codecs$Lamdera$Wire3$encodeInt, v0)
					]));
		case 155:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(43),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$codecs$Lamdera$Wire3$encodeString, $author$project$Evergreen$V417$Call$w3_encode_FromJs, v0)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(44),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1)
					]));
		case 83:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(45),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$ImageEditor$w3_encode_Msg(v1)
					]));
		case 97:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(46),
						$author$project$Evergreen$V417$ImageViewer$w3_encode_Msg(v0)
					]));
		case 41:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(47),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.ctrlKey),
									$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.key),
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.metaKey),
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.shiftKey)
								]));
					}(v0)
					]));
		case 166:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(48),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($author$project$Evergreen$V417$Audio$w3_encode_LoadError, $author$project$Evergreen$V417$Audio$w3_encode_Source, v0)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(49),
						$author$project$Evergreen$V417$LoginForm$w3_encode_Msg(v0)
					]));
		case 147:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(50),
						$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRoute(v1),
						$author$project$Evergreen$V417$MessageInput$w3_encode_Msg(v2)
					]));
		case 55:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(51),
						$ianmackenzie$elm_units$Duration$w3_encode_Duration(v0)
					]));
		case 64:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(52),
						$author$project$Evergreen$V417$NonemptySet$w3_encode_NonemptySet$(
						$author$project$Evergreen$V417$Id$w3_encode_Id($author$project$Evergreen$V417$Id$w3_encode_CustomEmojiId),
						v0)
					]));
		case 68:
			return $elm$bytes$Bytes$Encode$unsignedInt8(53);
		case 69:
			return $elm$bytes$Bytes$Encode$unsignedInt8(54);
		case 62:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(55),
						$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 44:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(56),
						$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 63:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(57),
						$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 66:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(58),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_PrivateChannelId, v1)
					]));
		case 65:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(59),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0)
					]));
		case 47:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(60),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v0)
					]));
		case 43:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(61),
						$author$project$Evergreen$V417$Emoji$w3_encode_EmojiOrCustomEmoji(v0)
					]));
		case 46:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(62),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v0)
					]));
		case 42:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(63),
						$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v1),
						A2($author$project$Evergreen$V417$Coord$w3_encode_Coord, $author$project$Evergreen$V417$CssPixels$w3_encode_CssPixels, v2)
					]));
		case 96:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(64),
						$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v1),
						$author$project$Evergreen$V417$MessageView$w3_encode_MessageViewMsg(v2)
					]));
		case 14:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(65),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Types$w3_encode_NewChannelForm(v1)
					]));
		case 35:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(66),
						$author$project$Evergreen$V417$Types$w3_encode_NewGuildForm(v0)
					]));
		case 84:
			return $elm$bytes$Bytes$Encode$unsignedInt8(67);
		case 123:
			return $elm$bytes$Bytes$Encode$unsignedInt8(68);
		case 122:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(69),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 154:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(70),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_encode_Error, $lamdera$program_test$Effect$Browser$Dom$w3_encode_Viewport, v0)
					]));
		case 103:
			return $elm$bytes$Bytes$Encode$unsignedInt8(71);
		case 137:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(72),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 113:
			return $elm$bytes$Bytes$Encode$unsignedInt8(73);
		case 30:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(74),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v1)
					]));
		case 61:
			return $elm$bytes$Bytes$Encode$unsignedInt8(75);
		case 118:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(76),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0)
					]));
		case 70:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(77),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_encode_ThreadRoute, v0)
					]));
		case 57:
			return $elm$bytes$Bytes$Encode$unsignedInt8(78);
		case 157:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(79),
						$author$project$Evergreen$V417$UserSession$w3_encode_ChannelHeaderTab(v0)
					]));
		case 104:
			return $elm$bytes$Bytes$Encode$unsignedInt8(80);
		case 136:
			return $elm$bytes$Bytes$Encode$unsignedInt8(81);
		case 110:
			return $elm$bytes$Bytes$Encode$unsignedInt8(82);
		case 114:
			return $elm$bytes$Bytes$Encode$unsignedInt8(83);
		case 73:
			return $elm$bytes$Bytes$Encode$unsignedInt8(84);
		case 48:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(85),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_encode_ThreadRoute, v0)
					]));
		case 145:
			return $elm$bytes$Bytes$Encode$unsignedInt8(86);
		case 34:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(87),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 33:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(88),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 28:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(89),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0)
					]));
		case 120:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(90),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0)
					]));
		case 102:
			return $elm$bytes$Bytes$Encode$unsignedInt8(91);
		case 87:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(92),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_encode_ThreadRoute, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$FileStatus$w3_encode_FileId, v1)
					]));
		case 19:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(93),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelId, v1)
					]));
		case 23:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(94),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0)
					]));
		case 29:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(95),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$SecretId$w3_encode_SecretId$($author$project$Evergreen$V417$Id$w3_encode_InviteLinkId, v1)
					]));
		case 119:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(96),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0)
					]));
		case 129:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(97),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 133:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(98),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, w3_rec_var0.currentUserId),
									$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, w3_rec_var0.otherUserId)
								]));
					}(v0)
					]));
		case 106:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(99),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V417$User$w3_encode_NotificationLevel(v2)
					]));
		case 116:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(100),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 117:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(101),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0)
					]));
		case 74:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(102),
						$author$project$Evergreen$V417$UserSession$w3_encode_UserOptionSection(v0)
					]));
		case 115:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(103),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0)
					]));
		case 112:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(104),
						$author$project$Evergreen$V417$Id$w3_encode_ExportChannelId(v0)
					]));
		case 105:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(105),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$User$w3_encode_NotificationLevel(v1)
					]));
		case 59:
			return $elm$bytes$Bytes$Encode$unsignedInt8(106);
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(107),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 24:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(108),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0)
					]));
		case 27:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(109),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0)
					]));
		case 12:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(110),
						$author$project$Evergreen$V417$Route$w3_encode_Route(v0)
					]));
		case 162:
			return $elm$bytes$Bytes$Encode$unsignedInt8(111);
		case 9:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(112),
						$author$project$Evergreen$V417$SessionIdHash$w3_encode_SessionIdHash(v0)
					]));
		case 177:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(113),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage),
						v0)
					]));
		case 176:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(114),
						$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 111:
			return $elm$bytes$Bytes$Encode$unsignedInt8(115);
		case 172:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(116),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(v2)
					]));
		case 174:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(117),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, v2),
						$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(v3)
					]));
		case 179:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(118),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(v2)
					]));
		case 175:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(119),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_ChannelId, v2),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v3),
						$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(v4)
					]));
		case 178:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(120),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(v1)
					]));
		case 181:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(121),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_TeamId, v1),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_ChannelId, v2),
						$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(v3)
					]));
		case 182:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(122),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_TeamId, v1),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_ChannelId, v2),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v3),
						$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(v4)
					]));
		case 180:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(123),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_TeamId, v1),
						$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(v2)
					]));
		case 173:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(124),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v2),
						$author$project$Evergreen$V417$MuteSettings$w3_encode_IsMuted(v3)
					]));
		case 165:
			return $elm$bytes$Bytes$Encode$unsignedInt8(125);
		case 125:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(126),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 131:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(127),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0)
					]));
		case 192:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(128),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_UserId, v0)
					]));
		case 189:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(129),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_TeamId, v0)
					]));
		case 144:
			return $elm$bytes$Bytes$Encode$unsignedInt8(130);
		case 17:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(131),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelId, v1)
					]));
		case 21:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(132),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0)
					]));
		case 142:
			return $elm$bytes$Bytes$Encode$unsignedInt8(133);
		case 143:
			return $elm$bytes$Bytes$Encode$unsignedInt8(134);
		case 169:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(135),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 170:
			return $elm$bytes$Bytes$Encode$unsignedInt8(136);
		case 171:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(137),
						$author$project$Evergreen$V417$Route$w3_encode_Route(v0)
					]));
		case 139:
			return $elm$bytes$Bytes$Encode$unsignedInt8(138);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(139);
		case 58:
			return $elm$bytes$Bytes$Encode$unsignedInt8(140);
		case 167:
			return $elm$bytes$Bytes$Encode$unsignedInt8(141);
		case 72:
			return $elm$bytes$Bytes$Encode$unsignedInt8(142);
		case 130:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(143),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 107:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(144),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_UserId, v0),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_TeamId, v1),
						$author$project$Evergreen$V417$User$w3_encode_NotificationLevel(v2)
					]));
		case 18:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(145),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V417$Types$w3_encode_EditChannelForm(v2)
					]));
		case 22:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(146),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Types$w3_encode_EditGuildForm(v1)
					]));
		case 15:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(147),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V417$Types$w3_encode_NewChannelForm(v1)
					]));
		case 36:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(148),
						$author$project$Evergreen$V417$Types$w3_encode_NewGuildForm(v0)
					]));
		case 190:
			return $elm$bytes$Bytes$Encode$unsignedInt8(149);
		case 141:
			return $elm$bytes$Bytes$Encode$unsignedInt8(150);
		case 89:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(151),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_encode_ThreadRoute, v0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$FileStatus$w3_encode_FileId, w3_rec_var0.fileId),
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.removeSpoiler)
								]));
					}(v1)
					]));
		case 31:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(152),
						$author$project$Evergreen$V417$SecretId$w3_encode_SecretId$($author$project$Evergreen$V417$Id$w3_encode_InviteLinkId, v0)
					]));
		case 132:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(153),
						$author$project$Evergreen$V417$Discord$w3_encode_Id$($author$project$Evergreen$V417$Discord$w3_encode_UserId, v0)
					]));
		case 191:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(154),
						$author$project$Evergreen$V417$Slack$w3_encode_Id$($author$project$Evergreen$V417$Slack$w3_encode_UserId, v0)
					]));
		case 161:
			return $elm$bytes$Bytes$Encode$unsignedInt8(155);
		case 88:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(156),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_encode_ThreadRoute, v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$FileStatus$w3_encode_FileId, v1)
					]));
		case 82:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(157),
						$author$project$Evergreen$V417$ImageEditor$w3_encode_Msg(v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(158),
						$author$project$Evergreen$V417$RecoveryLogin$w3_encode_Msg(v0)
					]));
		case 40:
			return $elm$bytes$Bytes$Encode$unsignedInt8(159);
		case 127:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(160),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.bottom),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.top)
								]));
					}(v0)
					]));
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(161);
		case 67:
			return $elm$bytes$Bytes$Encode$unsignedInt8(162);
		case 100:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(163),
						$author$project$Evergreen$V417$User$w3_encode_EmailNotifications(v0)
					]));
		case 101:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(164),
						$author$project$Evergreen$V417$User$w3_encode_EmbedVisibility(v0)
					]));
		case 13:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(165),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_encode_ThreadRoute, v0),
						$lamdera$program_test$Effect$File$w3_encode_File(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$program_test$Effect$File$w3_encode_File, v2)
					]));
		case 25:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(166),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_GuildId, v0),
						$lamdera$program_test$Effect$File$w3_encode_File(v1)
					]));
		case 99:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(167),
						$author$project$Evergreen$V417$UserSession$w3_encode_NotificationMode(v0)
					]));
		case 140:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(168),
						$author$project$Evergreen$V417$UserColor$w3_encode_Selection(v0)
					]));
		case 39:
			return $elm$bytes$Bytes$Encode$unsignedInt8(169);
		case 56:
			return $elm$bytes$Bytes$Encode$unsignedInt8(170);
		case 128:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(171),
						$author$project$Evergreen$V417$TextEditor$w3_encode_Msg(v0)
					]));
		case 152:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(172),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$program_test$Effect$Browser$Dom$w3_encode_HtmlId),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe(
							A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Evergreen$V417$Range$w3_encode_Range, $author$project$Evergreen$V417$Range$w3_encode_SelectionDirection)),
						v0)
					]));
		case 53:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(173),
						$ianmackenzie$elm_units$Duration$w3_encode_Duration(v0)
					]));
		case 52:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(174),
						$ianmackenzie$elm_units$Duration$w3_encode_Duration(v0)
					]));
		case 51:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(175),
						$ianmackenzie$elm_units$Duration$w3_encode_Duration(v0),
						$author$project$Evergreen$V417$NonemptyDict$w3_encode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$Evergreen$V417$Touch$w3_encode_Touch, v1)
					]));
		case 50:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(176),
						$ianmackenzie$elm_units$Duration$w3_encode_Duration(v0),
						$author$project$Evergreen$V417$NonemptyDict$w3_encode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$Evergreen$V417$Touch$w3_encode_Touch, v1)
					]));
		case 75:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(177),
						$author$project$Evergreen$V417$TwoFactorAuthentication$w3_encode_Msg(v0)
					]));
		case 134:
			return $elm$bytes$Bytes$Encode$unsignedInt8(178);
		case 138:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(179),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 121:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(180),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_UserId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 168:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(181),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 187:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(182),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 188:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(183),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 183:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(184),
						$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V417$MessageView$w3_encode_MessageViewMsg(v2)
					]));
		case 184:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(185),
						$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V417$Id$w3_encode_Id$($author$project$Evergreen$V417$Id$w3_encode_ThreadMessageId, v2),
						$author$project$Evergreen$V417$MessageView$w3_encode_MessageViewMsg(v3)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(186),
						$elm$url$Url$w3_encode_Url(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(187),
						$elm$browser$Browser$w3_encode_UrlRequest(v0)
					]));
		case 81:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(188),
						$author$project$Evergreen$V417$Editable$w3_encode_Msg$($author$project$Evergreen$V417$PersonName$w3_encode_PersonName, v0)
					]));
		case 60:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(189),
						$author$project$Evergreen$V417$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V417$Id$w3_encode_ThreadRoute(v1),
						$author$project$Evergreen$V417$Scroll$w3_encode_ScrollPosition(v2)
					]));
		case 185:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(190),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0),
						$author$project$Evergreen$V417$Types$w3_encode_E2eeKeysValid(v1)
					]));
		case 126:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(191),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.height),
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.top)
								]));
					}(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(192),
						$author$project$Evergreen$V417$Call$w3_encode_Msg(v0)
					]));
	}
};
var $author$project$Evergreen$V417$Audio$w3_encode_AudioLoadRequest_ = function (w3_x_c_userMsg) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.audioUrl),
					$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						A2($lamdera$codecs$Lamdera$Wire3$encodeResult, $author$project$Evergreen$V417$Audio$w3_encode_LoadError, $author$project$Evergreen$V417$Audio$w3_encode_Source),
						w3_x_c_userMsg),
					w3_rec_var0.userMsg)
				]));
	};
};
var $author$project$Evergreen$V417$Audio$w3_encode_LoopConfig = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var0.loopEnd),
				$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var0.loopStart)
			]));
};
var $author$project$Evergreen$V417$Audio$w3_encode_FlattenedAudio = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V417$Audio$w3_encode_LoopConfig, w3_rec_var0.loop),
				$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var0.offset),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.playbackRate),
				$author$project$Evergreen$V417$Audio$w3_encode_Source(w3_rec_var0.source),
				$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var0.startAt),
				function (t) {
				return $lamdera$codecs$Lamdera$Wire3$encodeInt(
					$elm$time$Time$posixToMillis(t));
			}(w3_rec_var0.startTime),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.volume),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty(
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						function (t) {
							return $lamdera$codecs$Lamdera$Wire3$encodeInt(
								$elm$time$Time$posixToMillis(t));
						},
						$lamdera$codecs$Lamdera$Wire3$encodeFloat)),
				w3_rec_var0.volumeTimelines)
			]));
};
var $author$project$Evergreen$V417$Audio$w3_encode_NodeGroupId = $lamdera$codecs$Lamdera$Wire3$encodeInt;
var $author$project$Evergreen$V417$Audio$w3_encode_SourceData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var0.duration)
			]));
};
var $author$project$Evergreen$V417$Audio$w3_encode_Model_$ = function (w3_x_c_userMsg, w3_x_c_userModel) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$codecs$Lamdera$Wire3$encodeDict$($author$project$Evergreen$V417$Audio$w3_encode_NodeGroupId, $author$project$Evergreen$V417$Audio$w3_encode_FlattenedAudio, w3_rec_var0.audioState),
					$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.nodeGroupIdCounter),
					$lamdera$codecs$Lamdera$Wire3$encodeDict$(
					$lamdera$codecs$Lamdera$Wire3$encodeInt,
					$author$project$Evergreen$V417$Audio$w3_encode_AudioLoadRequest_(w3_x_c_userMsg),
					w3_rec_var0.pendingRequests),
					$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.requestCount),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.samplesPerSecond),
					$lamdera$codecs$Lamdera$Wire3$encodeDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$Evergreen$V417$Audio$w3_encode_SourceData, w3_rec_var0.sourceData),
					w3_x_c_userModel(w3_rec_var0.userModel)
				]));
	};
};
var $author$project$Evergreen$V417$Audio$w3_encode_Model_ = F2($author$project$Evergreen$V417$Audio$w3_encode_Model_$);
var $author$project$Evergreen$V417$Audio$w3_encode_Model$ = function (w3_x_c_userMsg, w3_x_c_userModel, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				A3($author$project$Evergreen$V417$Audio$w3_encode_Model_, w3_x_c_userMsg, w3_x_c_userModel, v0)
			]));
};
var $author$project$Evergreen$V417$Audio$w3_encode_Model = F3($author$project$Evergreen$V417$Audio$w3_encode_Model$);
var $author$project$Evergreen$V417$Types$w3_encode_FrontendModel = A2($author$project$Evergreen$V417$Audio$w3_encode_Model, $author$project$Evergreen$V417$Types$w3_encode_FrontendMsg_, $author$project$Evergreen$V417$Types$w3_encode_FrontendModel_);
var $author$project$Evergreen$V419$Emoji$w3_encode_EmojiArt = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.sequence),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.sprite)
			]));
};
var $author$project$Evergreen$V419$Emoji$w3_encode_EmojiCategory = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
	}
};
var $author$project$Evergreen$V419$Emoji$w3_encode_EmojiData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Emoji$w3_encode_EmojiCategory(w3_rec_var0.category),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.shortNames),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.skinVariations)
			]));
};
var $author$project$Evergreen$V419$Emoji$w3_encode_UnicodeEmoji = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Evergreen$V419$Emoji$w3_encode_CachedEmojiData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeDict$(
				$lamdera$codecs$Lamdera$Wire3$encodeChar,
				$lamdera$codecs$Lamdera$Wire3$encodeArray($author$project$Evergreen$V419$Emoji$w3_encode_EmojiArt),
				w3_rec_var0.art),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Emoji$w3_encode_EmojiCategory,
				$lamdera$codecs$Lamdera$Wire3$encodeList($author$project$Evergreen$V419$Emoji$w3_encode_UnicodeEmoji),
				w3_rec_var0.categories),
				$lamdera$containers$SeqDict$encodeDict$($author$project$Evergreen$V419$Emoji$w3_encode_UnicodeEmoji, $author$project$Evergreen$V419$Emoji$w3_encode_EmojiData, w3_rec_var0.emojis),
				$lamdera$codecs$Lamdera$Wire3$encodeArray$(
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$author$project$Evergreen$V419$Emoji$w3_encode_UnicodeEmoji(w3_rec_var1.emoji),
								$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var1.shortName)
							]));
				},
				w3_rec_var0.shortNames)
			]));
};
var $author$project$Evergreen$V419$Coord$w3_encode_Coord = function (w3_x_c_units) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$encodePair,
		A2($ianmackenzie$elm_units$Quantity$w3_encode_Quantity, $lamdera$codecs$Lamdera$Wire3$encodeInt, w3_x_c_units),
		A2($ianmackenzie$elm_units$Quantity$w3_encode_Quantity, $lamdera$codecs$Lamdera$Wire3$encodeInt, w3_x_c_units));
};
var $author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Touch$w3_encode_DragTarget = function (w3v) {
	switch (w3v) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V419$NonemptyDict$w3_encode_NonemptyDict$ = function (w3_x_c_id, w3_x_c_a, w3v) {
	var v0 = w3v.a;
	var v1 = w3v.b;
	var v2 = w3v.c;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				w3_x_c_id(v0),
				w3_x_c_a(v1),
				$lamdera$containers$SeqDict$encodeDict$(w3_x_c_id, w3_x_c_a, v2)
			]));
};
var $author$project$Evergreen$V419$NonemptyDict$w3_encode_NonemptyDict = F3($author$project$Evergreen$V419$NonemptyDict$w3_encode_NonemptyDict$);
var $author$project$Evergreen$V419$Geometry$Types$w3_encode_Point2d$ = function (w3_x_c_units, w3_x_c_coordinates, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				function (w3_rec_var0) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.x),
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.y)
						]));
			}(v0)
			]));
};
var $author$project$Evergreen$V419$Geometry$Types$w3_encode_Point2d = F3($author$project$Evergreen$V419$Geometry$Types$w3_encode_Point2d$);
var $author$project$Evergreen$V419$Point2d$w3_encode_Point2d$ = function (w3_x_c_units, w3_x_c_coordinates) {
	return A2($author$project$Evergreen$V419$Geometry$Types$w3_encode_Point2d, w3_x_c_units, w3_x_c_coordinates);
};
var $author$project$Evergreen$V419$Point2d$w3_encode_Point2d = F2($author$project$Evergreen$V419$Point2d$w3_encode_Point2d$);
var $author$project$Evergreen$V419$Touch$w3_encode_ScreenCoordinate = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Touch$w3_encode_Touch = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				A3($author$project$Evergreen$V419$Point2d$w3_encode_Point2d, $author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels, $author$project$Evergreen$V419$Touch$w3_encode_ScreenCoordinate, w3_rec_var0.client),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.targetIsTextInput)
			]));
};
var $author$project$Evergreen$V419$Touch$w3_encode_Drag = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$NonemptyDict$w3_encode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$Evergreen$V419$Touch$w3_encode_Touch, v1)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.horizontalStart),
									$author$project$Evergreen$V419$Touch$w3_encode_DragTarget(w3_rec_var0.target),
									$author$project$Evergreen$V419$NonemptyDict$w3_encode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$Evergreen$V419$Touch$w3_encode_Touch, w3_rec_var0.touches)
								]));
					}(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V419$AiChat$w3_encode_AiModelName = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Evergreen$V419$AiChat$w3_encode_AiModel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$AiChat$w3_encode_AiModelName(w3_rec_var0.id),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.inputs)
			]));
};
var $author$project$Evergreen$V419$AiChat$w3_encode_AiModelsStatus = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V419$AiChat$w3_encode_AiModel, v0)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v0)
					]));
	}
};
var $author$project$Evergreen$V419$AiChat$w3_encode_PendingResponse = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$AiChat$w3_encode_AiModelName(v0),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v1)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$AiChat$w3_encode_AiModelName(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v2),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeFloat, v3)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$AiChat$w3_encode_AiModelName(v0)
					]));
	}
};
var $author$project$Evergreen$V419$AiChat$w3_encode_ResponseId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Evergreen$V419$AiChat$w3_encode_SendMessageWith = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$AiChat$w3_encode_FrontendModel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$AiChat$w3_encode_AiModelsStatus(w3_rec_var0.aiModels),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.chatHistory),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.debounceCounter),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.message),
				$lamdera$containers$SeqDict$encodeDict$($author$project$Evergreen$V419$AiChat$w3_encode_ResponseId, $author$project$Evergreen$V419$AiChat$w3_encode_PendingResponse, w3_rec_var0.pendingResponses),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.responseCounter),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V419$AiChat$w3_encode_AiModelName, w3_rec_var0.selectedModels),
				$author$project$Evergreen$V419$AiChat$w3_encode_SendMessageWith(w3_rec_var0.sendMessageWith),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showOptions)
			]));
};
var $author$project$Evergreen$V419$MyUi$w3_encode_Copied = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
				]));
	}
};
var $author$project$Evergreen$V419$MyUi$w3_encode_LastCopy = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$MyUi$w3_encode_Copied(w3_rec_var0.copied),
				function (t) {
				return $lamdera$codecs$Lamdera$Wire3$encodeInt(
					$elm$time$Time$posixToMillis(t));
			}(w3_rec_var0.copiedAt)
			]));
};
var $author$project$Evergreen$V419$Audio$w3_encode_LoadError = function (w3v) {
	switch (w3v) {
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Evergreen$V419$Id$w3_encode_InviteLinkId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Discord$w3_encode_ChannelId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Discord$w3_encode_GuildId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Discord$w3_encode_Id$ = function (w3_x_c_idType, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$MartinSStewart$elm_uint64$UInt64$w3_encode_UInt64(v0)
			]));
};
var $author$project$Evergreen$V419$Discord$w3_encode_Id = F2($author$project$Evergreen$V419$Discord$w3_encode_Id$);
var $author$project$Evergreen$V419$Discord$w3_encode_UserId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Id$w3_encode_Viewing_DiscordChannelId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, w3_rec_var0.channelId),
				$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, w3_rec_var0.currentUserId),
				$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, w3_rec_var0.guildId)
			]));
};
var $author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Id$w3_encode_Viewing_DiscordDmId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId, w3_rec_var0.channelId),
				$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, w3_rec_var0.currentUserId)
			]));
};
var $author$project$Evergreen$V419$Id$w3_encode_DiscordGuildOrDmId = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$Id$w3_encode_Viewing_DiscordDmId(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V419$Id$w3_encode_Viewing_DiscordChannelId(v0)
				]));
	}
};
var $author$project$Evergreen$V419$Id$w3_encode_ChannelId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Id$w3_encode_GuildId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Id$w3_encode_Id$ = function (w3_x_c_a, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Evergreen$V419$Id$w3_encode_Id = F2($author$project$Evergreen$V419$Id$w3_encode_Id$);
var $author$project$Evergreen$V419$Id$w3_encode_Viewing_ChannelId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelId, w3_rec_var0.channelId),
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, w3_rec_var0.guildId)
			]));
};
var $author$project$Evergreen$V419$Id$w3_encode_UserId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Id$w3_encode_Viewing_DmId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, w3_rec_var0.otherUserId)
			]));
};
var $author$project$Evergreen$V419$Id$w3_encode_GuildOrDmId = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$Id$w3_encode_Viewing_DmId(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V419$Id$w3_encode_Viewing_ChannelId(v0)
				]));
	}
};
var $author$project$Evergreen$V419$Slack$w3_encode_ChannelId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Slack$w3_encode_Id$ = function (w3_x_c_a, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Evergreen$V419$Slack$w3_encode_Id = F2($author$project$Evergreen$V419$Slack$w3_encode_Id$);
var $author$project$Evergreen$V419$Slack$w3_encode_TeamId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Slack$w3_encode_UserId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Id$w3_encode_Viewing_SlackChannelId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_ChannelId, w3_rec_var0.channelId),
				$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_UserId, w3_rec_var0.currentUserId),
				$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_TeamId, w3_rec_var0.teamId)
			]));
};
var $author$project$Evergreen$V419$Slack$w3_encode_DmChannelId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Id$w3_encode_Viewing_SlackDmId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_DmChannelId, w3_rec_var0.channelId),
				$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_UserId, w3_rec_var0.currentUserId)
			]));
};
var $author$project$Evergreen$V419$Id$w3_encode_SlackGuildOrDmId = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$Id$w3_encode_Viewing_SlackDmId(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V419$Id$w3_encode_Viewing_SlackChannelId(v0)
				]));
	}
};
var $author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Id$w3_encode_DiscordGuildOrDmId(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$Id$w3_encode_GuildOrDmId(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$Id$w3_encode_SlackGuildOrDmId(v0)
					]));
	}
};
var $author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Route$w3_encode_ChannelSidebarMode = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					function (w3_rec_var0) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.offset),
								$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.previousOffset),
								$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.time)
							]));
				}(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					function (w3_rec_var0) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.offset)
							]));
				}(v0)
				]));
	}
};
var $author$project$Evergreen$V419$Types$w3_encode_EditChannelForm = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.deleteConfirmation),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.description),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pressedSubmit),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showDeleteConfirmation)
			]));
};
var $author$project$Evergreen$V419$Types$w3_encode_ImportChannelError = function (w3v) {
	return $elm$bytes$Bytes$Encode$unsignedInt8(0);
};
var $author$project$Evergreen$V419$Types$w3_encode_ImportChannelStatus = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Types$w3_encode_ImportChannelError(v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.encryptedMessages)
								]));
					}(v0)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Evergreen$V419$Types$w3_encode_EditGuildForm = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.deleteConfirmation),
				$author$project$Evergreen$V419$Types$w3_encode_ImportChannelStatus(w3_rec_var0.importChannel),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pressedSubmit),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showDeleteConfirmation),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showLeaveConfirmation)
			]));
};
var $author$project$Evergreen$V419$FileStatus$w3_encode_FileId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$FileStatus$w3_encode_ContentType = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Evergreen$V419$FileStatus$w3_encode_FileHash = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Evergreen$V419$FileStatus$w3_encode_ExposureTime = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.denominator),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.numerator)
			]));
};
var $author$project$Evergreen$V419$SafeFloat$w3_encode_SafeFloat = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(v0)
			]));
};
var $author$project$Evergreen$V419$FileStatus$w3_encode_Location = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$SafeFloat$w3_encode_SafeFloat(w3_rec_var0.lat),
				$author$project$Evergreen$V419$SafeFloat$w3_encode_SafeFloat(w3_rec_var0.lon)
			]));
};
var $author$project$Evergreen$V419$FileStatus$w3_encode_Orientation = function (w3v) {
	switch (w3v) {
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
	}
};
var $author$project$Evergreen$V419$FileStatus$w3_encode_ImageMetadata = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.cameraOwner),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$FileStatus$w3_encode_ExposureTime, w3_rec_var0.exposureTime),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$SafeFloat$w3_encode_SafeFloat, w3_rec_var0.fNumber),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$SafeFloat$w3_encode_SafeFloat, w3_rec_var0.focalLength),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$FileStatus$w3_encode_Location, w3_rec_var0.gpsLocation),
				A2($author$project$Evergreen$V419$Coord$w3_encode_Coord, $author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels, w3_rec_var0.imageSize),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.isoSpeedRating),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.make),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.model),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$FileStatus$w3_encode_Orientation, w3_rec_var0.orientation),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.software),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.userComment)
			]));
};
var $author$project$Evergreen$V419$FileStatus$w3_encode_VideoMetadata = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.codec),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.createdAt),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($ianmackenzie$elm_units$Duration$w3_encode_Duration, w3_rec_var0.duration),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$FileStatus$w3_encode_Location, w3_rec_var0.gpsLocation),
				$author$project$Evergreen$V419$FileStatus$w3_encode_Orientation(w3_rec_var0.orientation),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.title),
				A2($author$project$Evergreen$V419$Coord$w3_encode_Coord, $author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels, w3_rec_var0.videoSize)
			]));
};
var $author$project$Evergreen$V419$FileStatus$w3_encode_FileMetadata = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$FileStatus$w3_encode_ImageMetadata(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V419$FileStatus$w3_encode_VideoMetadata(v0)
				]));
	}
};
var $author$project$Evergreen$V419$FileName$w3_encode_FileName = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v0)
			]));
};
var $author$project$Evergreen$V419$FileStatus$w3_encode_AesPrivateKey = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeBytes(v0)
			]));
};
var $author$project$Evergreen$V419$FileStatus$w3_encode_EncryptedThumbnail = function (w3v) {
	if (w3v === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$FileStatus$w3_encode_IsEncrypted = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$FileStatus$w3_encode_AesPrivateKey(v0),
					$author$project$Evergreen$V419$FileStatus$w3_encode_EncryptedThumbnail(v1)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$FileStatus$w3_encode_FileData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$FileStatus$w3_encode_ContentType(w3_rec_var0.contentType),
				$author$project$Evergreen$V419$FileStatus$w3_encode_FileHash(w3_rec_var0.fileHash),
				$author$project$Evergreen$V419$FileName$w3_encode_FileName(w3_rec_var0.fileName),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.fileSize),
				$author$project$Evergreen$V419$FileStatus$w3_encode_IsEncrypted(w3_rec_var0.isEncrypted),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$FileStatus$w3_encode_FileMetadata, w3_rec_var0.metadata)
			]));
};
var $author$project$Evergreen$V419$FileStatus$w3_encode_FileStatus = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$FileName$w3_encode_FileName(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1),
						$author$project$Evergreen$V419$FileStatus$w3_encode_ContentType(v2),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v3),
						$author$project$Evergreen$V419$FileStatus$w3_encode_IsEncrypted(v4)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$FileStatus$w3_encode_FileData(v0)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$FileName$w3_encode_FileName(v0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.sent),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.size)
								]));
					}(v1),
						$author$project$Evergreen$V419$FileStatus$w3_encode_ContentType(v2),
						$author$project$Evergreen$V419$FileStatus$w3_encode_IsEncrypted(v3)
					]));
	}
};
var $author$project$Evergreen$V419$Types$w3_encode_EditMessage = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$FileStatus$w3_encode_FileId),
				$author$project$Evergreen$V419$FileStatus$w3_encode_FileStatus,
				w3_rec_var0.attachedFiles),
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, w3_rec_var0.messageIndex),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.text)
			]));
};
var $author$project$Evergreen$V419$Id$w3_encode_QuestionId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$SheepGame$w3_encode_Input = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v0)
					]));
	}
};
var $author$project$Evergreen$V419$Range$w3_encode_Range = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.end),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.start)
			]));
};
var $author$project$Evergreen$V419$SheepGame$w3_encode_ReactionTarget = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0),
					$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v1)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v0)
				]));
	}
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_ReactionTarget = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v0)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v0),
					$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId, v1)
				]));
	}
};
var $author$project$Evergreen$V419$Types$w3_encode_EmojiSelector = function (w3v) {
	switch (w3v.$) {
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						A2($author$project$Evergreen$V419$Coord$w3_encode_Coord, $author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Range$w3_encode_Range, v1)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Range$w3_encode_Range, v0)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V419$SheepGame$w3_encode_Input(v0),
						A2($author$project$Evergreen$V419$Coord$w3_encode_Coord, $author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Range$w3_encode_Range, v2)
					]));
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V419$Id$w3_encode_GuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V419$SheepGame$w3_encode_ReactionTarget(v2)
					]));
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V419$Id$w3_encode_GuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V419$WordSpellingGame$w3_encode_ReactionTarget(v2)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
	}
};
var $author$project$Evergreen$V419$Encryption$w3_encode_DecryptManyRequestId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Encryption$w3_encode_DecryptRequestId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Encryption$w3_encode_EncryptFileRequestId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Encryption$w3_encode_EncryptManyRequestId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Encryption$w3_encode_EncryptRequestId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Encryption$w3_encode_BytesHash = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Evergreen$V419$Types$w3_encode_PendingDecryptedManyMessages = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V419$Encryption$w3_encode_BytesHash, w3_rec_var0.messageHashes),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Browser$Dom$w3_encode_HtmlId, w3_rec_var0.shiftScrollFrom)
			]));
};
var $author$project$Evergreen$V419$Message$w3_encode_RepliedToGame = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v1)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
	}
};
var $author$project$Evergreen$V419$Message$w3_encode_RepliedTo$ = function (w3_x_c_messageId, w3v) {
	switch (w3v.$) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v0),
						$author$project$Evergreen$V419$Message$w3_encode_RepliedToGame(v1)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$Id$w3_encode_Id$(w3_x_c_messageId, v0)
					]));
	}
};
var $author$project$Evergreen$V419$Message$w3_encode_RepliedTo = F2($author$project$Evergreen$V419$Message$w3_encode_RepliedTo$);
var $author$project$Evergreen$V419$Message$w3_encode_ThreadRouteWithRepliedTo = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$Message$w3_encode_RepliedTo$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v0)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v0),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId),
					v1)
				]));
	}
};
var $author$project$Evergreen$V419$Types$w3_encode_PendingDecryptedMessage = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Encryption$w3_encode_BytesHash(w3_rec_var0.hash),
				$author$project$Evergreen$V419$Id$w3_encode_Viewing_DmId(w3_rec_var0.id),
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, w3_rec_var0.senderId),
				$author$project$Evergreen$V419$Message$w3_encode_ThreadRouteWithRepliedTo(w3_rec_var0.threadRoute)
			]));
};
var $author$project$Evergreen$V419$Types$w3_encode_PendingDecryptedOldMessages = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Id$w3_encode_Viewing_DmId(w3_rec_var0.id),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage, w3_rec_var0.messages)
			]));
};
var $author$project$Evergreen$V419$Embed$w3_encode_EmbedImageFormat = function (w3v) {
	switch (w3v) {
		case 13:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 12:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 14:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(12);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(14);
	}
};
var $author$project$Evergreen$V419$Embed$w3_encode_EmbedImageData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Embed$w3_encode_EmbedImageFormat, w3_rec_var0.format),
				A2($author$project$Evergreen$V419$Coord$w3_encode_Coord, $author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels, w3_rec_var0.imageSize),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.url)
			]));
};
var $author$project$Evergreen$V419$Embed$w3_encode_EmbedData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.createdAt),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.description),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Embed$w3_encode_EmbedImageData, w3_rec_var0.image),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.title)
			]));
};
var $author$project$Evergreen$V419$Embed$w3_encode_Embed = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$Embed$w3_encode_EmbedData(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$Id$w3_encode_CustomEmojiId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$RichText$w3_encode_EscapedChar = function (w3v) {
	switch (w3v) {
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
	}
};
var $author$project$Evergreen$V419$RichText$w3_encode_HasLeadingLineBreak = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$RichText$w3_encode_HeadingLevel = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Evergreen$V419$RichText$w3_encode_Language = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$Id$w3_encode_StickerId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$TimeInMinutes$w3_encode_TimeInMinutes = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Evergreen$V419$RichText$w3_encode_RichText$ = function (w3_x_c_userId, w3_x_c_channelId, w3v) {
	switch (w3v.$) {
		case 14:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$FileStatus$w3_encode_FileId, v0)
					]));
		case 8:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$RichText$w3_encode_HasLeadingLineBreak(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						A2($author$project$Evergreen$V419$RichText$w3_encode_RichText, w3_x_c_userId, w3_x_c_channelId),
						v1)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2($author$project$Evergreen$V419$RichText$w3_encode_RichText, w3_x_c_userId, w3_x_c_channelId),
						v0)
					]));
		case 18:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V419$RichText$w3_encode_HasLeadingLineBreak(v0),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						$lamdera$codecs$Lamdera$Wire3$encodeList(
							A2($author$project$Evergreen$V419$RichText$w3_encode_RichText, w3_x_c_userId, w3_x_c_channelId)),
						v1)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						w3_x_c_channelId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
						v1)
					]));
		case 13:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V419$RichText$w3_encode_Language(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 17:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_CustomEmojiId, v0)
					]));
		case 15:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Evergreen$V419$RichText$w3_encode_EscapedChar(v0)
					]));
		case 9:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Evergreen$V419$RichText$w3_encode_HeadingLevel(v0),
						$author$project$Evergreen$V419$RichText$w3_encode_HasLeadingLineBreak(v1),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2($author$project$Evergreen$V419$RichText$w3_encode_RichText, w3_x_c_userId, w3_x_c_channelId),
						v2)
					]));
		case 10:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$elm$url$Url$w3_encode_Url(v0)
					]));
		case 12:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$lamdera$codecs$Lamdera$Wire3$encodeChar(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2($author$project$Evergreen$V419$RichText$w3_encode_RichText, w3_x_c_userId, w3_x_c_channelId),
						v0)
					]));
		case 11:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v0),
						$elm$url$Url$w3_encode_Url(v1)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$lamdera$codecs$Lamdera$Wire3$encodeChar(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2($author$project$Evergreen$V419$RichText$w3_encode_RichText, w3_x_c_userId, w3_x_c_channelId),
						v0)
					]));
		case 16:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_StickerId, v0)
					]));
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2($author$project$Evergreen$V419$RichText$w3_encode_RichText, w3_x_c_userId, w3_x_c_channelId),
						v0)
					]));
		case 19:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$author$project$Evergreen$V419$TimeInMinutes$w3_encode_TimeInMinutes(v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2($author$project$Evergreen$V419$RichText$w3_encode_RichText, w3_x_c_userId, w3_x_c_channelId),
						v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(19),
						w3_x_c_userId(v0)
					]));
	}
};
var $author$project$Evergreen$V419$RichText$w3_encode_RichText = F3($author$project$Evergreen$V419$RichText$w3_encode_RichText$);
var $author$project$Evergreen$V419$Message$w3_encode_MessageContent$ = function (w3_x_c_userId, w3_x_c_channelId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$containers$SeqDict$encodeDict$(
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$FileStatus$w3_encode_FileId),
					$author$project$Evergreen$V419$FileStatus$w3_encode_FileData,
					w3_rec_var0.attachedFiles),
					$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
					A2($author$project$Evergreen$V419$RichText$w3_encode_RichText, w3_x_c_userId, w3_x_c_channelId),
					w3_rec_var0.content),
					$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Evergreen$V419$Embed$w3_encode_Embed, w3_rec_var0.embeds)
				]));
	};
};
var $author$project$Evergreen$V419$Message$w3_encode_MessageContent = F2($author$project$Evergreen$V419$Message$w3_encode_MessageContent$);
var $author$project$Evergreen$V419$Types$w3_encode_PendingEncryptedEdit = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				A3(
				$author$project$Evergreen$V419$Message$w3_encode_MessageContent,
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId),
				w3_rec_var0.contentAndEmbeds),
				$author$project$Evergreen$V419$Id$w3_encode_Viewing_DmId(w3_rec_var0.id),
				$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(w3_rec_var0.threadRoute)
			]));
};
var $author$project$Evergreen$V419$Id$w3_encode_ThreadRoute = function (w3v) {
	if (!w3v.$) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v0)
				]));
	}
};
var $author$project$Evergreen$V419$Types$w3_encode_PendingEncryptedFile = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$FileStatus$w3_encode_FileId, w3_rec_var0.fileId),
				$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_encode_ThreadRoute, w3_rec_var0.guildOrDmId)
			]));
};
var $author$project$Evergreen$V419$Types$w3_encode_PendingEncryptedManyMessages = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Id$w3_encode_Viewing_DmId(w3_rec_var0.id),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage,
					$author$project$Evergreen$V419$Message$w3_encode_MessageContent$(
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId))),
				w3_rec_var0.messages)
			]));
};
var $author$project$Evergreen$V419$Types$w3_encode_PendingEncryptedMessage = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				A3(
				$author$project$Evergreen$V419$Message$w3_encode_MessageContent,
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId),
				w3_rec_var0.contentAndEmbeds),
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, w3_rec_var0.otherUserId),
				$author$project$Evergreen$V419$Message$w3_encode_ThreadRouteWithRepliedTo(w3_rec_var0.threadRoute)
			]));
};
var $author$project$Evergreen$V419$Types$w3_encode_EncryptionRequests = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Encryption$w3_encode_DecryptManyRequestId, w3_rec_var0.nextDecryptManyRequestId),
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Encryption$w3_encode_DecryptRequestId, w3_rec_var0.nextDecryptionRequestId),
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Encryption$w3_encode_EncryptFileRequestId, w3_rec_var0.nextEncryptFileRequestId),
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Encryption$w3_encode_EncryptManyRequestId, w3_rec_var0.nextEncryptManyRequestId),
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Encryption$w3_encode_EncryptRequestId, w3_rec_var0.nextEncryptionRequestId),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Encryption$w3_encode_DecryptManyRequestId),
				$author$project$Evergreen$V419$Types$w3_encode_PendingDecryptedManyMessages,
				w3_rec_var0.pendingDecryptedManyMessages),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Encryption$w3_encode_DecryptRequestId),
				$author$project$Evergreen$V419$Types$w3_encode_PendingDecryptedMessage,
				w3_rec_var0.pendingDecryptedMessages),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Encryption$w3_encode_DecryptManyRequestId),
				$author$project$Evergreen$V419$Types$w3_encode_PendingDecryptedOldMessages,
				w3_rec_var0.pendingDecryptedOldMessages),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Encryption$w3_encode_EncryptRequestId),
				$author$project$Evergreen$V419$Types$w3_encode_PendingEncryptedEdit,
				w3_rec_var0.pendingEncryptedEdits),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Encryption$w3_encode_EncryptFileRequestId),
				$author$project$Evergreen$V419$Types$w3_encode_PendingEncryptedFile,
				w3_rec_var0.pendingEncryptedFiles),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Encryption$w3_encode_EncryptManyRequestId),
				$author$project$Evergreen$V419$Types$w3_encode_PendingEncryptedManyMessages,
				w3_rec_var0.pendingEncryptedManyMessages),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Encryption$w3_encode_EncryptManyRequestId),
				$author$project$Evergreen$V419$Types$w3_encode_PendingEncryptedMessage,
				w3_rec_var0.pendingEncryptedMessages)
			]));
};
var $author$project$Evergreen$V419$FileStatus$w3_encode_FileDataWithImage = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$FileStatus$w3_encode_ContentType(w3_rec_var0.contentType),
				$author$project$Evergreen$V419$FileStatus$w3_encode_FileHash(w3_rec_var0.fileHash),
				$author$project$Evergreen$V419$FileName$w3_encode_FileName(w3_rec_var0.fileName),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.fileSize),
				$author$project$Evergreen$V419$FileStatus$w3_encode_IsEncrypted(w3_rec_var0.isEncrypted),
				$author$project$Evergreen$V419$FileStatus$w3_encode_FileMetadata(w3_rec_var0.metadata)
			]));
};
var $author$project$Evergreen$V419$OneOrGreater$w3_encode_OneOrGreater = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Evergreen$V419$Types$w3_encode_FileDrag = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
					$author$project$Evergreen$V419$OneOrGreater$w3_encode_OneOrGreater(v1)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, v0)
				]));
	}
};
var $author$project$Evergreen$V419$Local$w3_encode_ChangeId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Evergreen$V419$Local$w3_encode_Local$ = function (w3_x_c_msg, w3_x_c_model, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				function (w3_rec_var0) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$author$project$Evergreen$V419$Local$w3_encode_ChangeId(w3_rec_var0.counter),
							w3_x_c_model(w3_rec_var0.localModel),
							$lamdera$codecs$Lamdera$Wire3$encodeDict$(
							$lamdera$codecs$Lamdera$Wire3$encodeInt,
							function (w3_rec_var1) {
								return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
									_List_fromArray(
										[
											function (t) {
											return $lamdera$codecs$Lamdera$Wire3$encodeInt(
												$elm$time$Time$posixToMillis(t));
										}(w3_rec_var1.createdAt),
											w3_x_c_msg(w3_rec_var1.msg)
										]));
							},
							w3_rec_var0.localMsgs),
							w3_x_c_model(w3_rec_var0.serverModel)
						]));
			}(v0)
			]));
};
var $author$project$Evergreen$V419$Local$w3_encode_Local = F3($author$project$Evergreen$V419$Local$w3_encode_Local$);
var $author$project$Evergreen$V419$GuildName$w3_encode_GuildName = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v0)
			]));
};
var $author$project$Evergreen$V419$LocalState$w3_encode_AdminData_DeletedGuild = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.deletedAt),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.memberCount),
				$author$project$Evergreen$V419$GuildName$w3_encode_GuildName(w3_rec_var0.name),
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, w3_rec_var0.owner)
			]));
};
var $author$project$Evergreen$V419$Message$w3_encode_CallRecordingFile = function (w3_x_c_userId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					function (t) {
					return $lamdera$codecs$Lamdera$Wire3$encodeInt(
						$elm$time$Time$posixToMillis(t));
				}(w3_rec_var0.endedAt),
					$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
					w3_x_c_userId(w3_rec_var0.recordedBy),
					$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.size),
					function (t) {
					return $lamdera$codecs$Lamdera$Wire3$encodeInt(
						$elm$time$Time$posixToMillis(t));
				}(w3_rec_var0.startedAt),
					$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.uploaded)
				]));
	};
};
var $author$project$Evergreen$V419$Message$w3_encode_CallRecordingZip = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.fileCount),
				$author$project$Evergreen$V419$FileStatus$w3_encode_FileHash(w3_rec_var0.fileHash),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.size)
			]));
};
var $author$project$Evergreen$V419$NonemptySet$w3_encode_NonemptySet$ = function (w3_x_c_a, w3v) {
	var v0 = w3v.a;
	var v1 = w3v.b;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				w3_x_c_a(v0),
				$lamdera$containers$SeqSet$encodeSet$(w3_x_c_a, v1)
			]));
};
var $author$project$Evergreen$V419$NonemptySet$w3_encode_NonemptySet = F2($author$project$Evergreen$V419$NonemptySet$w3_encode_NonemptySet$);
var $author$project$Evergreen$V419$Message$w3_encode_CallRecording = function (w3_x_c_userId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$codecs$Lamdera$Wire3$encodeList$(
					$author$project$Evergreen$V419$Message$w3_encode_CallRecordingFile(w3_x_c_userId),
					w3_rec_var0.files),
					$lamdera$containers$SeqSet$encodeSet$(w3_x_c_userId, w3_rec_var0.finishedUploading),
					$author$project$Evergreen$V419$NonemptySet$w3_encode_NonemptySet$(w3_x_c_userId, w3_rec_var0.participants),
					function (t) {
					return $lamdera$codecs$Lamdera$Wire3$encodeInt(
						$elm$time$Time$posixToMillis(t));
				}(w3_rec_var0.startedAt),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Message$w3_encode_CallRecordingZip, w3_rec_var0.zip)
				]));
	};
};
var $author$project$Evergreen$V419$Drawing$w3_encode_Stroke = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Evergreen$V419$SafeFloat$w3_encode_SafeFloat, $author$project$Evergreen$V419$SafeFloat$w3_encode_SafeFloat),
				w3_rec_var0.points)
			]));
};
var $author$project$Evergreen$V419$Drawing$w3_encode_Drawing = function (w3_x_c_userId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$codecs$Lamdera$Wire3$encodeList$(
					function (w3_rec_var1) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									w3_x_c_userId(w3_rec_var1.createdBy),
									$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
									A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Evergreen$V419$SafeFloat$w3_encode_SafeFloat, $author$project$Evergreen$V419$SafeFloat$w3_encode_SafeFloat),
									w3_rec_var1.points)
								]));
					},
					w3_rec_var0.finished),
					$lamdera$containers$SeqDict$encodeDict$(w3_x_c_userId, $author$project$Evergreen$V419$Drawing$w3_encode_Stroke, w3_rec_var0.inProgress),
					$lamdera$containers$SeqDict$encodeDict$(
					w3_x_c_userId,
					$lamdera$codecs$Lamdera$Wire3$encodeList($author$project$Evergreen$V419$Drawing$w3_encode_Stroke),
					w3_rec_var0.undone)
				]));
	};
};
var $author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_CustomEmojiId, v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V419$Emoji$w3_encode_UnicodeEmoji(v0)
				]));
	}
};
var $author$project$Evergreen$V419$Message$w3_encode_CallStartedData = function (w3_x_c_userId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					A2($author$project$Evergreen$V419$Drawing$w3_encode_Drawing, w3_x_c_userId, w3_rec_var0.cardDrawings),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					function (t) {
						return $lamdera$codecs$Lamdera$Wire3$encodeInt(
							$elm$time$Time$posixToMillis(t));
					},
					w3_rec_var0.endedAt),
					$lamdera$containers$SeqSet$encodeSet$(w3_x_c_userId, w3_rec_var0.joinedBy),
					$lamdera$containers$SeqDict$encodeDict$(
					$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji,
					$author$project$Evergreen$V419$NonemptySet$w3_encode_NonemptySet(w3_x_c_userId),
					w3_rec_var0.reactions),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					$author$project$Evergreen$V419$Message$w3_encode_CallRecording(w3_x_c_userId),
					w3_rec_var0.recordings),
					function (t) {
					return $lamdera$codecs$Lamdera$Wire3$encodeInt(
						$elm$time$Time$posixToMillis(t));
				}(w3_rec_var0.startedAt),
					w3_x_c_userId(w3_rec_var0.startedBy),
					A2($author$project$Evergreen$V419$Drawing$w3_encode_Drawing, w3_x_c_userId, w3_rec_var0.timestampDrawings)
				]));
	};
};
var $author$project$Evergreen$V419$Encryption$w3_encode_EncryptedData$ = function (w3_x_c_a, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeBytes(v0)
			]));
};
var $author$project$Evergreen$V419$Encryption$w3_encode_EncryptedData = F2($author$project$Evergreen$V419$Encryption$w3_encode_EncryptedData$);
var $author$project$Evergreen$V419$Message$w3_encode_UserTextMessageDrawings = function (w3_x_c_userId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$containers$SeqDict$encodeDict$(
					$lamdera$codecs$Lamdera$Wire3$encodeInt,
					$author$project$Evergreen$V419$Drawing$w3_encode_Drawing(w3_x_c_userId),
					w3_rec_var0.embedDrawings),
					$lamdera$containers$SeqDict$encodeDict$(
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$FileStatus$w3_encode_FileId),
					$author$project$Evergreen$V419$Drawing$w3_encode_Drawing(w3_x_c_userId),
					w3_rec_var0.imageAttachmentDrawings),
					A2($author$project$Evergreen$V419$Drawing$w3_encode_Drawing, w3_x_c_userId, w3_rec_var0.timestampDrawings),
					A2($author$project$Evergreen$V419$Drawing$w3_encode_Drawing, w3_x_c_userId, w3_rec_var0.userIconDrawings)
				]));
	};
};
var $author$project$Evergreen$V419$Message$w3_encode_EncryptedUserTextMessageData$ = function (w3_x_c_messageId, w3_x_c_userId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$author$project$Evergreen$V419$Encryption$w3_encode_EncryptedData$(
					$author$project$Evergreen$V419$Message$w3_encode_MessageContent$(
						w3_x_c_userId,
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId)),
					w3_rec_var0.content),
					function (t) {
					return $lamdera$codecs$Lamdera$Wire3$encodeInt(
						$elm$time$Time$posixToMillis(t));
				}(w3_rec_var0.createdAt),
					w3_x_c_userId(w3_rec_var0.createdBy),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					$author$project$Evergreen$V419$Message$w3_encode_UserTextMessageDrawings(w3_x_c_userId),
					w3_rec_var0.drawings),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					function (t) {
						return $lamdera$codecs$Lamdera$Wire3$encodeInt(
							$elm$time$Time$posixToMillis(t));
					},
					w3_rec_var0.editedAt),
					$lamdera$containers$SeqSet$encodeSet$($author$project$Evergreen$V419$FileStatus$w3_encode_FileHash, w3_rec_var0.fileHashes),
					$lamdera$containers$SeqDict$encodeDict$(
					$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji,
					$author$project$Evergreen$V419$NonemptySet$w3_encode_NonemptySet(w3_x_c_userId),
					w3_rec_var0.reactions),
					$author$project$Evergreen$V419$Message$w3_encode_RepliedTo$(w3_x_c_messageId, w3_rec_var0.repliedTo)
				]));
	};
};
var $author$project$Evergreen$V419$Message$w3_encode_EncryptedUserTextMessageData = F2($author$project$Evergreen$V419$Message$w3_encode_EncryptedUserTextMessageData$);
var $author$project$Evergreen$V419$Message$w3_encode_GameType = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V419$Message$w3_encode_GameStartedData = function (w3_x_c_userId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					A2($author$project$Evergreen$V419$Drawing$w3_encode_Drawing, w3_x_c_userId, w3_rec_var0.cardDrawings),
					$author$project$Evergreen$V419$Message$w3_encode_GameType(w3_rec_var0.gameType),
					$lamdera$containers$SeqDict$encodeDict$(
					$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji,
					$author$project$Evergreen$V419$NonemptySet$w3_encode_NonemptySet(w3_x_c_userId),
					w3_rec_var0.reactions),
					function (t) {
					return $lamdera$codecs$Lamdera$Wire3$encodeInt(
						$elm$time$Time$posixToMillis(t));
				}(w3_rec_var0.startedAt),
					w3_x_c_userId(w3_rec_var0.startedBy),
					A2($author$project$Evergreen$V419$Drawing$w3_encode_Drawing, w3_x_c_userId, w3_rec_var0.timestampDrawings)
				]));
	};
};
var $author$project$Evergreen$V419$Message$w3_encode_UserTextMessageData$ = function (w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					A3($author$project$Evergreen$V419$Message$w3_encode_MessageContent, w3_x_c_userId, w3_x_c_channelId, w3_rec_var0.content),
					function (t) {
					return $lamdera$codecs$Lamdera$Wire3$encodeInt(
						$elm$time$Time$posixToMillis(t));
				}(w3_rec_var0.createdAt),
					w3_x_c_userId(w3_rec_var0.createdBy),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					$author$project$Evergreen$V419$Message$w3_encode_UserTextMessageDrawings(w3_x_c_userId),
					w3_rec_var0.drawings),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					function (t) {
						return $lamdera$codecs$Lamdera$Wire3$encodeInt(
							$elm$time$Time$posixToMillis(t));
					},
					w3_rec_var0.editedAt),
					$lamdera$containers$SeqDict$encodeDict$(
					$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji,
					$author$project$Evergreen$V419$NonemptySet$w3_encode_NonemptySet(w3_x_c_userId),
					w3_rec_var0.reactions),
					$author$project$Evergreen$V419$Message$w3_encode_RepliedTo$(w3_x_c_messageId, w3_rec_var0.repliedTo)
				]));
	};
};
var $author$project$Evergreen$V419$Message$w3_encode_UserTextMessageData = F3($author$project$Evergreen$V419$Message$w3_encode_UserTextMessageData$);
var $author$project$Evergreen$V419$Message$w3_encode_Message$ = function (w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId, w3v) {
	switch (w3v.$) {
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						A2($author$project$Evergreen$V419$Message$w3_encode_CallStartedData, w3_x_c_userId, v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						function (t) {
						return $lamdera$codecs$Lamdera$Wire3$encodeInt(
							$elm$time$Time$posixToMillis(t));
					}(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						A3($author$project$Evergreen$V419$Message$w3_encode_EncryptedUserTextMessageData, w3_x_c_messageId, w3_x_c_userId, v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						A2($author$project$Evergreen$V419$Message$w3_encode_GameStartedData, w3_x_c_userId, v0)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						function (t) {
						return $lamdera$codecs$Lamdera$Wire3$encodeInt(
							$elm$time$Time$posixToMillis(t));
					}(v0),
						w3_x_c_userId(v1),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji,
						$author$project$Evergreen$V419$NonemptySet$w3_encode_NonemptySet(w3_x_c_userId),
						v2),
						A2($author$project$Evergreen$V419$Drawing$w3_encode_Drawing, w3_x_c_userId, v3)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						A4($author$project$Evergreen$V419$Message$w3_encode_UserTextMessageData, w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId, v0)
					]));
	}
};
var $author$project$Evergreen$V419$Message$w3_encode_Message = F4($author$project$Evergreen$V419$Message$w3_encode_Message$);
var $author$project$Evergreen$V419$LocalState$w3_encode_AdminData_DiscordDmChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				A3(
					$author$project$Evergreen$V419$Message$w3_encode_Message,
					$author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId,
					$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
					$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_ChannelId)),
				w3_rec_var0.firstMessage),
				$author$project$Evergreen$V419$NonemptyDict$w3_encode_NonemptyDict$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.messagesSent)
							]));
				},
				w3_rec_var0.members),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.messageCount)
			]));
};
var $author$project$Evergreen$V419$ChannelName$w3_encode_ChannelName = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v0)
			]));
};
var $author$project$Evergreen$V419$Discord$w3_encode_Permissions = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.addReaction),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.administrator),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.attachFiles),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.banMembers),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.changeNickname),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.connect),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.createEvents),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.createGuildExpressions),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.createInstantInvite),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.createPrivateThreads),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.createPublicThreads),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.deafenMembers),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.embedLinks),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.kickMembers),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.manageChannels),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.manageEvents),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.manageGuild),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.manageGuildExpressions),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.manageMessages),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.manageNicknames),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.manageRoles),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.manageThreads),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.manageWebhooks),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.mentionEveryone),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.moderateMembers),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.moveMembers),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.muteMembers),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.prioritySpeaker),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.readMessageHistory),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.requestToSpeak),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.sendMessages),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.sendMessagesInThreads),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.sendPolls),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.sendVoiceMessages),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.sentTextToSpeechMessages),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.speak),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.stream),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.useApplicationCommands),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.useEmbeddedActivities),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.useExternalApps),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.useExternalEmojis),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.useExternalSounds),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.useExternalStickers),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.useSoundboard),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.useVoiceActivityDetection),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.viewAuditLog),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.viewChannel),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.viewCreatorMontetizationAnalytics),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.viewGuildInsights)
			]));
};
var $author$project$Evergreen$V419$Discord$w3_encode_RoleId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Discord$w3_encode_RoleOrUserId = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_RoleId, v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0)
				]));
	}
};
var $author$project$Evergreen$V419$Discord$w3_encode_Overwrite = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Discord$w3_encode_Permissions(w3_rec_var0.allow),
				$author$project$Evergreen$V419$Discord$w3_encode_Permissions(w3_rec_var0.deny),
				$author$project$Evergreen$V419$Discord$w3_encode_RoleOrUserId(w3_rec_var0.id)
			]));
};
var $author$project$Evergreen$V419$LocalState$w3_encode_AdminData_DiscordChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				A3(
					$author$project$Evergreen$V419$Message$w3_encode_Message,
					$author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId,
					$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
					$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_ChannelId)),
				w3_rec_var0.firstMessage),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.messageCount),
				$author$project$Evergreen$V419$ChannelName$w3_encode_ChannelName(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V419$Discord$w3_encode_Overwrite, w3_rec_var0.permissionOverwrites),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.threadCount)
			]));
};
var $author$project$Evergreen$V419$LocalState$w3_encode_DiscordRole = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.description),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
				$author$project$Evergreen$V419$Discord$w3_encode_Permissions(w3_rec_var0.permissions)
			]));
};
var $author$project$Evergreen$V419$MembersAndOwner$w3_encode_MembersAndOwner$ = function (w3_x_c_userId, w3_x_c_a, w3v) {
	var v0 = w3v.a;
	var v1 = w3v.b;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$containers$SeqDict$encodeDict$(w3_x_c_userId, w3_x_c_a, v0),
				w3_x_c_userId(v1)
			]));
};
var $author$project$Evergreen$V419$MembersAndOwner$w3_encode_MembersAndOwner = F3($author$project$Evergreen$V419$MembersAndOwner$w3_encode_MembersAndOwner$);
var $author$project$Evergreen$V419$LocalState$w3_encode_AdminData_DiscordGuild = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_ChannelId),
				$author$project$Evergreen$V419$LocalState$w3_encode_AdminData_DiscordChannel,
				w3_rec_var0.channels),
				$author$project$Evergreen$V419$MembersAndOwner$w3_encode_MembersAndOwner$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var1.joinedAt),
								$lamdera$containers$SeqSet$encodeSet$(
								$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_RoleId),
								w3_rec_var1.roles)
							]));
				},
				w3_rec_var0.membersAndOwner),
				$author$project$Evergreen$V419$GuildName$w3_encode_GuildName(w3_rec_var0.name),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_RoleId),
				$author$project$Evergreen$V419$LocalState$w3_encode_DiscordRole,
				w3_rec_var0.roles)
			]));
};
var $author$project$Evergreen$V419$LocalState$w3_encode_AdminData_DmChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.messageCount),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.threadCount)
			]));
};
var $author$project$Evergreen$V419$LocalState$w3_encode_AdminData_GuildChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.messageCount),
				$author$project$Evergreen$V419$ChannelName$w3_encode_ChannelName(w3_rec_var0.name)
			]));
};
var $author$project$Evergreen$V419$LocalState$w3_encode_AdminData_Guild = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId),
				$author$project$Evergreen$V419$LocalState$w3_encode_AdminData_GuildChannel,
				w3_rec_var0.channels),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.memberCount),
				$author$project$Evergreen$V419$GuildName$w3_encode_GuildName(w3_rec_var0.name),
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, w3_rec_var0.owner)
			]));
};
var $author$project$Evergreen$V419$LocalState$w3_encode_AdminData_SlackDmChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				A3(
					$author$project$Evergreen$V419$Message$w3_encode_Message,
					$author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId,
					$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_UserId),
					$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_ChannelId)),
				w3_rec_var0.firstMessage),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_UserId, w3_rec_var1.id),
								$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var1.name)
							]));
				},
				w3_rec_var0.members),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.messageCount),
				$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_TeamId, w3_rec_var0.teamId)
			]));
};
var $author$project$Evergreen$V419$LocalState$w3_encode_AdminData_SlackWorkspace = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_ChannelId),
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
								A3(
									$author$project$Evergreen$V419$Message$w3_encode_Message,
									$author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId,
									$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_UserId),
									$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_ChannelId)),
								w3_rec_var1.firstMessage),
								$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var1.isPrivate),
								$lamdera$containers$SeqSet$encodeSet$(
								$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_UserId),
								w3_rec_var1.linkedMembers),
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.messageCount),
								$author$project$Evergreen$V419$ChannelName$w3_encode_ChannelName(w3_rec_var1.name)
							]));
				},
				w3_rec_var0.channels),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.domain),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_UserId),
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, w3_rec_var1.linkedTo),
								$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var1.name)
							]));
				},
				w3_rec_var0.linkedUsers),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.userCount)
			]));
};
var $author$project$Evergreen$V419$Postmark$w3_encode_ApiKey = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Evergreen$V419$FileStatus$w3_encode_BackendFileData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.fileSize),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V419$Coord$w3_encode_Coord($author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels),
				w3_rec_var0.imageSize)
			]));
};
var $author$project$Evergreen$V419$BackendMsgLog$w3_encode_BackendMsgLog = function (w3v) {
	switch (w3v) {
		case 20:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 91:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 34:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 35:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 54:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 12:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 78:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 16:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		case 15:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 65:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		case 64:
			return $elm$bytes$Bytes$Encode$unsignedInt8(12);
		case 66:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
		case 63:
			return $elm$bytes$Bytes$Encode$unsignedInt8(14);
		case 49:
			return $elm$bytes$Bytes$Encode$unsignedInt8(15);
		case 50:
			return $elm$bytes$Bytes$Encode$unsignedInt8(16);
		case 18:
			return $elm$bytes$Bytes$Encode$unsignedInt8(17);
		case 17:
			return $elm$bytes$Bytes$Encode$unsignedInt8(18);
		case 19:
			return $elm$bytes$Bytes$Encode$unsignedInt8(19);
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(20);
		case 55:
			return $elm$bytes$Bytes$Encode$unsignedInt8(21);
		case 14:
			return $elm$bytes$Bytes$Encode$unsignedInt8(22);
		case 13:
			return $elm$bytes$Bytes$Encode$unsignedInt8(23);
		case 53:
			return $elm$bytes$Bytes$Encode$unsignedInt8(24);
		case 47:
			return $elm$bytes$Bytes$Encode$unsignedInt8(25);
		case 26:
			return $elm$bytes$Bytes$Encode$unsignedInt8(26);
		case 58:
			return $elm$bytes$Bytes$Encode$unsignedInt8(27);
		case 57:
			return $elm$bytes$Bytes$Encode$unsignedInt8(28);
		case 73:
			return $elm$bytes$Bytes$Encode$unsignedInt8(29);
		case 70:
			return $elm$bytes$Bytes$Encode$unsignedInt8(30);
		case 71:
			return $elm$bytes$Bytes$Encode$unsignedInt8(31);
		case 69:
			return $elm$bytes$Bytes$Encode$unsignedInt8(32);
		case 75:
			return $elm$bytes$Bytes$Encode$unsignedInt8(33);
		case 21:
			return $elm$bytes$Bytes$Encode$unsignedInt8(34);
		case 62:
			return $elm$bytes$Bytes$Encode$unsignedInt8(35);
		case 83:
			return $elm$bytes$Bytes$Encode$unsignedInt8(36);
		case 61:
			return $elm$bytes$Bytes$Encode$unsignedInt8(37);
		case 72:
			return $elm$bytes$Bytes$Encode$unsignedInt8(38);
		case 25:
			return $elm$bytes$Bytes$Encode$unsignedInt8(39);
		case 84:
			return $elm$bytes$Bytes$Encode$unsignedInt8(40);
		case 90:
			return $elm$bytes$Bytes$Encode$unsignedInt8(41);
		case 60:
			return $elm$bytes$Bytes$Encode$unsignedInt8(42);
		case 59:
			return $elm$bytes$Bytes$Encode$unsignedInt8(43);
		case 81:
			return $elm$bytes$Bytes$Encode$unsignedInt8(44);
		case 23:
			return $elm$bytes$Bytes$Encode$unsignedInt8(45);
		case 44:
			return $elm$bytes$Bytes$Encode$unsignedInt8(46);
		case 79:
			return $elm$bytes$Bytes$Encode$unsignedInt8(47);
		case 74:
			return $elm$bytes$Bytes$Encode$unsignedInt8(48);
		case 67:
			return $elm$bytes$Bytes$Encode$unsignedInt8(49);
		case 24:
			return $elm$bytes$Bytes$Encode$unsignedInt8(50);
		case 31:
			return $elm$bytes$Bytes$Encode$unsignedInt8(51);
		case 32:
			return $elm$bytes$Bytes$Encode$unsignedInt8(52);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(53);
		case 33:
			return $elm$bytes$Bytes$Encode$unsignedInt8(54);
		case 77:
			return $elm$bytes$Bytes$Encode$unsignedInt8(55);
		case 43:
			return $elm$bytes$Bytes$Encode$unsignedInt8(56);
		case 52:
			return $elm$bytes$Bytes$Encode$unsignedInt8(57);
		case 51:
			return $elm$bytes$Bytes$Encode$unsignedInt8(58);
		case 80:
			return $elm$bytes$Bytes$Encode$unsignedInt8(59);
		case 82:
			return $elm$bytes$Bytes$Encode$unsignedInt8(60);
		case 86:
			return $elm$bytes$Bytes$Encode$unsignedInt8(61);
		case 88:
			return $elm$bytes$Bytes$Encode$unsignedInt8(62);
		case 87:
			return $elm$bytes$Bytes$Encode$unsignedInt8(63);
		case 89:
			return $elm$bytes$Bytes$Encode$unsignedInt8(64);
		case 85:
			return $elm$bytes$Bytes$Encode$unsignedInt8(65);
		case 56:
			return $elm$bytes$Bytes$Encode$unsignedInt8(66);
		case 76:
			return $elm$bytes$Bytes$Encode$unsignedInt8(67);
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(68);
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(69);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(70);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(71);
		case 22:
			return $elm$bytes$Bytes$Encode$unsignedInt8(72);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(73);
		case 37:
			return $elm$bytes$Bytes$Encode$unsignedInt8(74);
		case 27:
			return $elm$bytes$Bytes$Encode$unsignedInt8(75);
		case 28:
			return $elm$bytes$Bytes$Encode$unsignedInt8(76);
		case 29:
			return $elm$bytes$Bytes$Encode$unsignedInt8(77);
		case 36:
			return $elm$bytes$Bytes$Encode$unsignedInt8(78);
		case 30:
			return $elm$bytes$Bytes$Encode$unsignedInt8(79);
		case 39:
			return $elm$bytes$Bytes$Encode$unsignedInt8(80);
		case 38:
			return $elm$bytes$Bytes$Encode$unsignedInt8(81);
		case 40:
			return $elm$bytes$Bytes$Encode$unsignedInt8(82);
		case 42:
			return $elm$bytes$Bytes$Encode$unsignedInt8(83);
		case 41:
			return $elm$bytes$Bytes$Encode$unsignedInt8(84);
		case 68:
			return $elm$bytes$Bytes$Encode$unsignedInt8(85);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(86);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(87);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(88);
		case 46:
			return $elm$bytes$Bytes$Encode$unsignedInt8(89);
		case 45:
			return $elm$bytes$Bytes$Encode$unsignedInt8(90);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(91);
	}
};
var $author$project$Evergreen$V419$BackendMsgLog$w3_encode_BackendMsgLogData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$BackendMsgLog$w3_encode_BackendMsgLog(w3_rec_var0.backendMsgLog),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.endTime),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.startTime)
			]));
};
var $author$project$Evergreen$V419$EmailAddress$w3_encode_EmailAddress = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				function (w3_rec_var0) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.domain),
							$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.localPart),
							$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.tags),
							$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.tld)
						]));
			}(v0)
			]));
};
var $author$project$Evergreen$V419$User$w3_encode_BackendUserStatus = function (w3v) {
	if (!w3v.$) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V419$EmailAddress$w3_encode_EmailAddress(v0)
				]));
	}
};
var $author$project$Evergreen$V419$RichText$w3_encode_Domain = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Evergreen$V419$User$w3_encode_EmailNotifications = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$User$w3_encode_EmbedVisibility = function (w3v) {
	if (w3v === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$Emoji$w3_encode_SkinTone = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
	}
};
var $author$project$Evergreen$V419$Emoji$w3_encode_EmojiConfig = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji, w3_rec_var0.lastUsedEmojis),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Emoji$w3_encode_SkinTone, w3_rec_var0.skinTone)
			]));
};
var $author$project$Evergreen$V419$User$w3_encode_LastDmViewed = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId, v0)
					]));
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRoute(v1)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted = function (w3v) {
	switch (w3v) {
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V419$MuteSettings$w3_encode_MutedChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(w3_rec_var0.mutedChannel),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
				$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted,
				w3_rec_var0.mutedThreads)
			]));
};
var $author$project$Evergreen$V419$MuteSettings$w3_encode_MutedDiscordGuild = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_ChannelId),
				$author$project$Evergreen$V419$MuteSettings$w3_encode_MutedChannel,
				w3_rec_var0.channels),
				$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(w3_rec_var0.mutedGuild)
			]));
};
var $author$project$Evergreen$V419$MuteSettings$w3_encode_MutedGuild = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId),
				$author$project$Evergreen$V419$MuteSettings$w3_encode_MutedChannel,
				w3_rec_var0.channels),
				$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(w3_rec_var0.mutedGuild)
			]));
};
var $author$project$Evergreen$V419$MuteSettings$w3_encode_MutedSlackWorkspace = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_ChannelId),
				$author$project$Evergreen$V419$MuteSettings$w3_encode_MutedChannel,
				w3_rec_var0.channels),
				$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(w3_rec_var0.mutedWorkspace)
			]));
};
var $author$project$Evergreen$V419$MuteSettings$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId),
				$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted,
				w3_rec_var0.mutedDiscordDms),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_GuildId),
				$author$project$Evergreen$V419$MuteSettings$w3_encode_MutedDiscordGuild,
				w3_rec_var0.mutedDiscordGuilds),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				$author$project$Evergreen$V419$MuteSettings$w3_encode_MutedChannel,
				w3_rec_var0.mutedDms),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_GuildId),
				$author$project$Evergreen$V419$MuteSettings$w3_encode_MutedGuild,
				w3_rec_var0.mutedGuilds),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_TeamId),
				$author$project$Evergreen$V419$MuteSettings$w3_encode_MutedSlackWorkspace,
				w3_rec_var0.mutedSlackWorkspaces)
			]));
};
var $author$project$Evergreen$V419$Pagination$w3_encode_PageId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$PersonName$w3_encode_PersonName = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v0)
			]));
};
var $author$project$Evergreen$V419$X25519$w3_encode_Key = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.w0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.w1),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.w2),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.w3),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.w4),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.w5),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.w6),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.w7)
			]));
};
var $author$project$Evergreen$V419$X25519$w3_encode_PublicKey = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$author$project$Evergreen$V419$X25519$w3_encode_Key(v0)
			]));
};
var $author$project$Evergreen$V419$UserColor$w3_encode_UserColor = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Evergreen$V419$User$w3_encode_BackendUser = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_CustomEmojiId),
				w3_rec_var0.availableCustomEmojis),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_StickerId),
				w3_rec_var0.availableStickers),
				$author$project$Evergreen$V419$UserColor$w3_encode_UserColor(w3_rec_var0.color),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.createdAt),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.deleteAccountAt),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_GuildId),
				A2(
					$author$project$Evergreen$V419$NonemptyDict$w3_encode_NonemptyDict,
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRoute),
					$author$project$Evergreen$V419$OneOrGreater$w3_encode_OneOrGreater),
				w3_rec_var0.directMentions),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_GuildId),
				A2(
					$author$project$Evergreen$V419$NonemptyDict$w3_encode_NonemptyDict,
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_ChannelId),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRoute),
					$author$project$Evergreen$V419$OneOrGreater$w3_encode_OneOrGreater),
				w3_rec_var0.discordDirectMentions),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_GuildId),
				w3_rec_var0.discordNotifyOnAllMessages),
				$lamdera$containers$SeqSet$encodeSet$($author$project$Evergreen$V419$RichText$w3_encode_Domain, w3_rec_var0.domainWhitelist),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.e2eeRisksAccepted),
				$author$project$Evergreen$V419$User$w3_encode_BackendUserStatus(w3_rec_var0.email),
				$author$project$Evergreen$V419$User$w3_encode_EmailNotifications(w3_rec_var0.emailNotifications),
				$author$project$Evergreen$V419$User$w3_encode_EmbedVisibility(w3_rec_var0.embedVisibility),
				$author$project$Evergreen$V419$Emoji$w3_encode_EmojiConfig(w3_rec_var0.emojiConfig),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isAdmin),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_GuildId),
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId),
					$author$project$Evergreen$V419$Id$w3_encode_ThreadRoute),
				w3_rec_var0.lastChannelViewed),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_GuildId),
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_ChannelId),
					$author$project$Evergreen$V419$Id$w3_encode_ThreadRoute),
				w3_rec_var0.lastDiscordChannelViewed),
				$author$project$Evergreen$V419$User$w3_encode_LastDmViewed(w3_rec_var0.lastDmViewed),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.lastEmailNotification),
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Pagination$w3_encode_PageId, w3_rec_var0.lastLogPageViewed),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.lastPushNotification),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_TeamId),
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_ChannelId),
					$author$project$Evergreen$V419$Id$w3_encode_ThreadRoute),
				w3_rec_var0.lastSlackChannelViewed),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId,
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
				w3_rec_var0.lastViewedMessage),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId)),
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId),
				w3_rec_var0.lastViewedThreadMessage),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.linkDiscordAcknowledgementIsChecked),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.linkSlackAcknowledgementIsChecked),
				$author$project$Evergreen$V419$MuteSettings$w3_encode_Model(w3_rec_var0.muteSettings),
				$author$project$Evergreen$V419$PersonName$w3_encode_PersonName(w3_rec_var0.name),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_GuildId),
				w3_rec_var0.notifyOnAllMessages),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$X25519$w3_encode_PublicKey, w3_rec_var0.publicKey),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.recentLoginEmails),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_TeamId),
				A2(
					$author$project$Evergreen$V419$NonemptyDict$w3_encode_NonemptyDict,
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_ChannelId),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRoute),
					$author$project$Evergreen$V419$OneOrGreater$w3_encode_OneOrGreater),
				w3_rec_var0.slackDirectMentions),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_TeamId),
				w3_rec_var0.slackNotifyOnAllMessages)
			]));
};
var $author$project$Evergreen$V419$LocalState$w3_encode_DiscordGatewayStatus = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.failedReconnectAttempts),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.websocketIsOpen)
			]));
};
var $author$project$Evergreen$V419$DiscordUserData$w3_encode_DiscordUserLoadingData = function (w3v) {
	switch (w3v.$) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0)
					]));
	}
};
var $author$project$Evergreen$V419$Discord$w3_encode_AvatarHash = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Discord$w3_encode_ImageHash$ = function (w3_x_c_hashType, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Evergreen$V419$Discord$w3_encode_ImageHash = F2($author$project$Evergreen$V419$Discord$w3_encode_ImageHash$);
var $author$project$Evergreen$V419$Discord$w3_encode_UserDiscriminator = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Evergreen$V419$Discord$w3_encode_PartialUser = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V419$Discord$w3_encode_ImageHash($author$project$Evergreen$V419$Discord$w3_encode_AvatarHash),
				w3_rec_var0.avatar),
				$author$project$Evergreen$V419$Discord$w3_encode_UserDiscriminator(w3_rec_var0.discriminator),
				$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, w3_rec_var0.id),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.username)
			]));
};
var $author$project$Evergreen$V419$Discord$w3_encode_OptionalData$ = function (w3_x_c_a, w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					w3_x_c_a(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$Discord$w3_encode_OptionalData = F2($author$project$Evergreen$V419$Discord$w3_encode_OptionalData$);
var $author$project$Evergreen$V419$Discord$w3_encode_User = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V419$Discord$w3_encode_ImageHash($author$project$Evergreen$V419$Discord$w3_encode_AvatarHash),
				w3_rec_var0.avatar),
				$author$project$Evergreen$V419$Discord$w3_encode_OptionalData$($lamdera$codecs$Lamdera$Wire3$encodeBool, w3_rec_var0.bot),
				$author$project$Evergreen$V419$Discord$w3_encode_UserDiscriminator(w3_rec_var0.discriminator),
				$author$project$Evergreen$V419$Discord$w3_encode_OptionalData$(
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$codecs$Lamdera$Wire3$encodeString),
				w3_rec_var0.email),
				$author$project$Evergreen$V419$Discord$w3_encode_OptionalData$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.flags),
				$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, w3_rec_var0.id),
				$author$project$Evergreen$V419$Discord$w3_encode_OptionalData$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.locale),
				$author$project$Evergreen$V419$Discord$w3_encode_OptionalData$($lamdera$codecs$Lamdera$Wire3$encodeBool, w3_rec_var0.mfaEnabled),
				$author$project$Evergreen$V419$Discord$w3_encode_OptionalData$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.premiumType),
				$author$project$Evergreen$V419$Discord$w3_encode_OptionalData$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.publicFlags),
				$author$project$Evergreen$V419$Discord$w3_encode_OptionalData$($lamdera$codecs$Lamdera$Wire3$encodeBool, w3_rec_var0.system),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.username),
				$author$project$Evergreen$V419$Discord$w3_encode_OptionalData$($lamdera$codecs$Lamdera$Wire3$encodeBool, w3_rec_var0.verified)
			]));
};
var $author$project$Evergreen$V419$LocalState$w3_encode_DiscordUserData_ForAdmin = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
									$author$project$Evergreen$V419$Discord$w3_encode_PartialUser(w3_rec_var0.user)
								]));
					}(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Evergreen$V419$LocalState$w3_encode_DiscordGatewayStatus(w3_rec_var0.gateway),
									$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
									$author$project$Evergreen$V419$DiscordUserData$w3_encode_DiscordUserLoadingData(w3_rec_var0.isLoadingData),
									$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.linkedAt),
									$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, w3_rec_var0.linkedTo),
									$author$project$Evergreen$V419$Discord$w3_encode_User(w3_rec_var0.user)
								]));
					}(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
									$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.linkedAt),
									$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, w3_rec_var0.linkedTo),
									$author$project$Evergreen$V419$Discord$w3_encode_User(w3_rec_var0.user)
								]));
					}(v0)
					]));
	}
};
var $author$project$Evergreen$V419$DmChannelId$w3_encode_DmChannelId = function (w3v) {
	var v0 = w3v.a;
	var v1 = w3v.b;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0),
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v1)
			]));
};
var $author$project$Evergreen$V419$Pages$Admin$w3_encode_EditedBackendUser = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.createdAt),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.deleteAccountAt),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.email),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isAdmin),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name)
			]));
};
var $author$project$Evergreen$V419$Discord$w3_encode_ErrorCode = function (w3v) {
	switch (w3v) {
		case 65:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 24:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 44:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 42:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 58:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 45:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 47:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 46:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 48:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 38:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 43:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		case 41:
			return $elm$bytes$Bytes$Encode$unsignedInt8(12);
		case 63:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
		case 53:
			return $elm$bytes$Bytes$Encode$unsignedInt8(14);
		case 61:
			return $elm$bytes$Bytes$Encode$unsignedInt8(15);
		case 59:
			return $elm$bytes$Bytes$Encode$unsignedInt8(16);
		case 51:
			return $elm$bytes$Bytes$Encode$unsignedInt8(17);
		case 57:
			return $elm$bytes$Bytes$Encode$unsignedInt8(18);
		case 62:
			return $elm$bytes$Bytes$Encode$unsignedInt8(19);
		case 33:
			return $elm$bytes$Bytes$Encode$unsignedInt8(20);
		case 27:
			return $elm$bytes$Bytes$Encode$unsignedInt8(21);
		case 32:
			return $elm$bytes$Bytes$Encode$unsignedInt8(22);
		case 26:
			return $elm$bytes$Bytes$Encode$unsignedInt8(23);
		case 29:
			return $elm$bytes$Bytes$Encode$unsignedInt8(24);
		case 34:
			return $elm$bytes$Bytes$Encode$unsignedInt8(25);
		case 28:
			return $elm$bytes$Bytes$Encode$unsignedInt8(26);
		case 31:
			return $elm$bytes$Bytes$Encode$unsignedInt8(27);
		case 30:
			return $elm$bytes$Bytes$Encode$unsignedInt8(28);
		case 56:
			return $elm$bytes$Bytes$Encode$unsignedInt8(29);
		case 60:
			return $elm$bytes$Bytes$Encode$unsignedInt8(30);
		case 40:
			return $elm$bytes$Bytes$Encode$unsignedInt8(31);
		case 54:
			return $elm$bytes$Bytes$Encode$unsignedInt8(32);
		case 49:
			return $elm$bytes$Bytes$Encode$unsignedInt8(33);
		case 50:
			return $elm$bytes$Bytes$Encode$unsignedInt8(34);
		case 25:
			return $elm$bytes$Bytes$Encode$unsignedInt8(35);
		case 55:
			return $elm$bytes$Bytes$Encode$unsignedInt8(36);
		case 64:
			return $elm$bytes$Bytes$Encode$unsignedInt8(37);
		case 37:
			return $elm$bytes$Bytes$Encode$unsignedInt8(38);
		case 35:
			return $elm$bytes$Bytes$Encode$unsignedInt8(39);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(40);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(41);
		case 16:
			return $elm$bytes$Bytes$Encode$unsignedInt8(42);
		case 22:
			return $elm$bytes$Bytes$Encode$unsignedInt8(43);
		case 20:
			return $elm$bytes$Bytes$Encode$unsignedInt8(44);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(45);
		case 14:
			return $elm$bytes$Bytes$Encode$unsignedInt8(46);
		case 19:
			return $elm$bytes$Bytes$Encode$unsignedInt8(47);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(48);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(49);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(50);
		case 21:
			return $elm$bytes$Bytes$Encode$unsignedInt8(51);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(52);
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(53);
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(54);
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(55);
		case 23:
			return $elm$bytes$Bytes$Encode$unsignedInt8(56);
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(57);
		case 17:
			return $elm$bytes$Bytes$Encode$unsignedInt8(58);
		case 18:
			return $elm$bytes$Bytes$Encode$unsignedInt8(59);
		case 12:
			return $elm$bytes$Bytes$Encode$unsignedInt8(60);
		case 13:
			return $elm$bytes$Bytes$Encode$unsignedInt8(61);
		case 15:
			return $elm$bytes$Bytes$Encode$unsignedInt8(62);
		case 39:
			return $elm$bytes$Bytes$Encode$unsignedInt8(63);
		case 36:
			return $elm$bytes$Bytes$Encode$unsignedInt8(64);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(65);
	}
};
var $author$project$Evergreen$V419$Discord$w3_encode_RateLimit = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isGlobal),
				$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var0.retryAfter)
			]));
};
var $author$project$Evergreen$V419$Discord$w3_encode_HttpError = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Discord$w3_encode_ErrorCode(v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$Discord$w3_encode_ErrorCode(v0)
					]));
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$Discord$w3_encode_ErrorCode(v0)
					]));
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V419$Discord$w3_encode_ErrorCode(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V419$Discord$w3_encode_ErrorCode(v0)
					]));
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Evergreen$V419$Discord$w3_encode_ErrorCode(w3_rec_var0.errorCode),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.statusCode)
								]));
					}(v0)
					]));
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Evergreen$V419$Discord$w3_encode_RateLimit(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V419$Discord$w3_encode_ErrorCode(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
	}
};
var $author$project$Evergreen$V419$Slack$w3_encode_HttpError = function (w3v) {
	switch (w3v.$) {
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
	}
};
var $author$project$Evergreen$V419$Discord$w3_encode_MessageId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Postmark$w3_encode_PostmarkSendResponse = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.errorCode),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.message),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V419$EmailAddress$w3_encode_EmailAddress, w3_rec_var0.to)
			]));
};
var $author$project$Evergreen$V419$Postmark$w3_encode_SendEmailError = function (w3v) {
	switch (w3v.$) {
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$Postmark$w3_encode_PostmarkSendResponse(v0)
					]));
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.body),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.statusCode)
								]));
					}(v0)
					]));
	}
};
var $author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMaybeMessage = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
					v0)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v0),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId),
					v1)
				]));
	}
};
var $author$project$Evergreen$V419$Log$w3_encode_Log = function (w3v) {
	switch (w3v.$) {
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0)
					]));
		case 36:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 22:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 11:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_MessageId, v2),
						$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji(v3),
						$author$project$Evergreen$V419$Discord$w3_encode_HttpError(v4)
					]));
		case 10:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v2),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_MessageId, v3),
						$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji(v4),
						$author$project$Evergreen$V419$Discord$w3_encode_HttpError(v5)
					]));
		case 32:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V419$Id$w3_encode_SlackGuildOrDmId(v0),
						$author$project$Evergreen$V419$Slack$w3_encode_HttpError(v1)
					]));
		case 7:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_MessageId, v2),
						$author$project$Evergreen$V419$Discord$w3_encode_HttpError(v3)
					]));
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v2),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_MessageId, v3),
						$author$project$Evergreen$V419$Discord$w3_encode_HttpError(v4)
					]));
		case 28:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v0)
					]));
		case 33:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V419$Id$w3_encode_SlackGuildOrDmId(v0),
						$author$project$Evergreen$V419$Slack$w3_encode_HttpError(v1)
					]));
		case 9:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_MessageId, v2),
						$author$project$Evergreen$V419$Discord$w3_encode_HttpError(v3)
					]));
		case 8:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v2),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_MessageId, v3),
						$author$project$Evergreen$V419$Discord$w3_encode_HttpError(v4)
					]));
		case 34:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$Evergreen$V419$Id$w3_encode_SlackGuildOrDmId(v0),
						$author$project$Evergreen$V419$Slack$w3_encode_HttpError(v1)
					]));
		case 26:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1)
					]));
		case 19:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V419$Discord$w3_encode_HttpError(v2)
					]));
		case 17:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$author$project$Evergreen$V419$Discord$w3_encode_HttpError(v0)
					]));
		case 25:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2(
							$lamdera$codecs$Lamdera$Wire3$encodePair,
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_CustomEmojiId),
							$lamdera$program_test$Effect$Http$w3_encode_Error),
						v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1)
					]));
		case 23:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2(
							$lamdera$codecs$Lamdera$Wire3$encodePair,
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_StickerId),
							$lamdera$program_test$Effect$Http$w3_encode_Error),
						v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1)
					]));
		case 24:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$author$project$Evergreen$V419$Discord$w3_encode_HttpError(v0)
					]));
		case 14:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(19),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_HttpError(v1)
					]));
		case 29:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(20),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_TeamId, v0),
						$author$project$Evergreen$V419$Slack$w3_encode_HttpError(v1)
					]));
		case 30:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(21),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_TeamId, v0),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2(
							$lamdera$codecs$Lamdera$Wire3$encodePair,
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_CustomEmojiId),
							$lamdera$program_test$Effect$Http$w3_encode_Error),
						v1),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v2)
					]));
		case 18:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(22),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 27:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(23),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v0)
					]));
		case 20:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(24),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_HttpError(v1)
					]));
		case 13:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(25),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_MessageId, v2),
						$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji(v3),
						$author$project$Evergreen$V419$Discord$w3_encode_HttpError(v4)
					]));
		case 12:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(26),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v2),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_MessageId, v3),
						$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji(v4),
						$author$project$Evergreen$V419$Discord$w3_encode_HttpError(v5)
					]));
		case 16:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(27),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId, v1),
						$author$project$Evergreen$V419$Discord$w3_encode_HttpError(v2)
					]));
		case 15:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(28),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, v2),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMaybeMessage(v3),
						$author$project$Evergreen$V419$Discord$w3_encode_HttpError(v4)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(29),
						$author$project$Evergreen$V419$Postmark$w3_encode_SendEmailError(v0),
						$author$project$Evergreen$V419$EmailAddress$w3_encode_EmailAddress(v1)
					]));
		case 31:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(30),
						$author$project$Evergreen$V419$Id$w3_encode_SlackGuildOrDmId(v0),
						$author$project$Evergreen$V419$Slack$w3_encode_HttpError(v1)
					]));
		case 21:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(31),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_HttpError(v1)
					]));
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(32),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($author$project$Evergreen$V419$Postmark$w3_encode_SendEmailError, $lamdera$codecs$Lamdera$Wire3$encodeUnit, v0),
						$author$project$Evergreen$V419$EmailAddress$w3_encode_EmailAddress(v1)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(33),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0)
					]));
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(34),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v1)
					]));
		case 35:
			return $elm$bytes$Bytes$Encode$unsignedInt8(35);
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(36),
						$author$project$Evergreen$V419$Postmark$w3_encode_SendEmailError(v0),
						$author$project$Evergreen$V419$EmailAddress$w3_encode_EmailAddress(v1)
					]));
	}
};
var $author$project$Evergreen$V419$LocalState$w3_encode_LogWithTime = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Log$w3_encode_Log(w3_rec_var0.log),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.time)
			]));
};
var $author$project$Evergreen$V419$LocalState$w3_encode_PrivateVapidKey = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Evergreen$V419$Discord$w3_encode_RoleColors = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.primaryColor),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.secondaryColor),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.tertiaryColor)
			]));
};
var $author$project$Evergreen$V419$Discord$w3_encode_RoleIconHash = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Discord$w3_encode_IntegrationId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Discord$w3_encode_SubscriptionListingId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Discord$w3_encode_RoleTags = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.availableForPurchase),
				$author$project$Evergreen$V419$Discord$w3_encode_OptionalData$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
				w3_rec_var0.botId),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.guildConnections),
				$author$project$Evergreen$V419$Discord$w3_encode_OptionalData$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_IntegrationId),
				w3_rec_var0.integrationId),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.premiumSubscriber),
				$author$project$Evergreen$V419$Discord$w3_encode_OptionalData$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_SubscriptionListingId),
				w3_rec_var0.subscriptionListingId)
			]));
};
var $author$project$Evergreen$V419$Discord$w3_encode_Role = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Discord$w3_encode_OptionalData$($author$project$Evergreen$V419$Discord$w3_encode_RoleColors, w3_rec_var0.colors),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.description),
				$author$project$Evergreen$V419$Discord$w3_encode_OptionalData$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.flags),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.hoist),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V419$Discord$w3_encode_ImageHash($author$project$Evergreen$V419$Discord$w3_encode_RoleIconHash),
				w3_rec_var0.icon),
				$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_RoleId, w3_rec_var0.id),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.managed),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.mentionable),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
				$author$project$Evergreen$V419$Discord$w3_encode_Permissions(w3_rec_var0.permissions),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.position),
				$author$project$Evergreen$V419$Discord$w3_encode_OptionalData$($author$project$Evergreen$V419$Discord$w3_encode_RoleTags, w3_rec_var0.tags),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.unicodeEmoji)
			]));
};
var $author$project$Evergreen$V419$SessionIdHash$w3_encode_SessionIdHash = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Evergreen$V419$ToBackendLog$w3_encode_ToBackendLog = function (w3v) {
	switch (w3v) {
		case 15:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 17:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 16:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 18:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		case 12:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 13:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		case 95:
			return $elm$bytes$Bytes$Encode$unsignedInt8(12);
		case 73:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
		case 38:
			return $elm$bytes$Bytes$Encode$unsignedInt8(14);
		case 20:
			return $elm$bytes$Bytes$Encode$unsignedInt8(15);
		case 35:
			return $elm$bytes$Bytes$Encode$unsignedInt8(16);
		case 63:
			return $elm$bytes$Bytes$Encode$unsignedInt8(17);
		case 88:
			return $elm$bytes$Bytes$Encode$unsignedInt8(18);
		case 59:
			return $elm$bytes$Bytes$Encode$unsignedInt8(19);
		case 46:
			return $elm$bytes$Bytes$Encode$unsignedInt8(20);
		case 89:
			return $elm$bytes$Bytes$Encode$unsignedInt8(21);
		case 93:
			return $elm$bytes$Bytes$Encode$unsignedInt8(22);
		case 29:
			return $elm$bytes$Bytes$Encode$unsignedInt8(23);
		case 31:
			return $elm$bytes$Bytes$Encode$unsignedInt8(24);
		case 34:
			return $elm$bytes$Bytes$Encode$unsignedInt8(25);
		case 45:
			return $elm$bytes$Bytes$Encode$unsignedInt8(26);
		case 92:
			return $elm$bytes$Bytes$Encode$unsignedInt8(27);
		case 50:
			return $elm$bytes$Bytes$Encode$unsignedInt8(28);
		case 53:
			return $elm$bytes$Bytes$Encode$unsignedInt8(29);
		case 42:
			return $elm$bytes$Bytes$Encode$unsignedInt8(30);
		case 41:
			return $elm$bytes$Bytes$Encode$unsignedInt8(31);
		case 22:
			return $elm$bytes$Bytes$Encode$unsignedInt8(32);
		case 76:
			return $elm$bytes$Bytes$Encode$unsignedInt8(33);
		case 28:
			return $elm$bytes$Bytes$Encode$unsignedInt8(34);
		case 30:
			return $elm$bytes$Bytes$Encode$unsignedInt8(35);
		case 91:
			return $elm$bytes$Bytes$Encode$unsignedInt8(36);
		case 57:
			return $elm$bytes$Bytes$Encode$unsignedInt8(37);
		case 75:
			return $elm$bytes$Bytes$Encode$unsignedInt8(38);
		case 19:
			return $elm$bytes$Bytes$Encode$unsignedInt8(39);
		case 32:
			return $elm$bytes$Bytes$Encode$unsignedInt8(40);
		case 68:
			return $elm$bytes$Bytes$Encode$unsignedInt8(41);
		case 69:
			return $elm$bytes$Bytes$Encode$unsignedInt8(42);
		case 48:
			return $elm$bytes$Bytes$Encode$unsignedInt8(43);
		case 49:
			return $elm$bytes$Bytes$Encode$unsignedInt8(44);
		case 43:
			return $elm$bytes$Bytes$Encode$unsignedInt8(45);
		case 37:
			return $elm$bytes$Bytes$Encode$unsignedInt8(46);
		case 27:
			return $elm$bytes$Bytes$Encode$unsignedInt8(47);
		case 36:
			return $elm$bytes$Bytes$Encode$unsignedInt8(48);
		case 33:
			return $elm$bytes$Bytes$Encode$unsignedInt8(49);
		case 64:
			return $elm$bytes$Bytes$Encode$unsignedInt8(50);
		case 39:
			return $elm$bytes$Bytes$Encode$unsignedInt8(51);
		case 87:
			return $elm$bytes$Bytes$Encode$unsignedInt8(52);
		case 62:
			return $elm$bytes$Bytes$Encode$unsignedInt8(53);
		case 40:
			return $elm$bytes$Bytes$Encode$unsignedInt8(54);
		case 97:
			return $elm$bytes$Bytes$Encode$unsignedInt8(55);
		case 96:
			return $elm$bytes$Bytes$Encode$unsignedInt8(56);
		case 21:
			return $elm$bytes$Bytes$Encode$unsignedInt8(57);
		case 55:
			return $elm$bytes$Bytes$Encode$unsignedInt8(58);
		case 70:
			return $elm$bytes$Bytes$Encode$unsignedInt8(59);
		case 94:
			return $elm$bytes$Bytes$Encode$unsignedInt8(60);
		case 60:
			return $elm$bytes$Bytes$Encode$unsignedInt8(61);
		case 61:
			return $elm$bytes$Bytes$Encode$unsignedInt8(62);
		case 71:
			return $elm$bytes$Bytes$Encode$unsignedInt8(63);
		case 54:
			return $elm$bytes$Bytes$Encode$unsignedInt8(64);
		case 44:
			return $elm$bytes$Bytes$Encode$unsignedInt8(65);
		case 77:
			return $elm$bytes$Bytes$Encode$unsignedInt8(66);
		case 79:
			return $elm$bytes$Bytes$Encode$unsignedInt8(67);
		case 82:
			return $elm$bytes$Bytes$Encode$unsignedInt8(68);
		case 80:
			return $elm$bytes$Bytes$Encode$unsignedInt8(69);
		case 81:
			return $elm$bytes$Bytes$Encode$unsignedInt8(70);
		case 85:
			return $elm$bytes$Bytes$Encode$unsignedInt8(71);
		case 86:
			return $elm$bytes$Bytes$Encode$unsignedInt8(72);
		case 84:
			return $elm$bytes$Bytes$Encode$unsignedInt8(73);
		case 78:
			return $elm$bytes$Bytes$Encode$unsignedInt8(74);
		case 47:
			return $elm$bytes$Bytes$Encode$unsignedInt8(75);
		case 56:
			return $elm$bytes$Bytes$Encode$unsignedInt8(76);
		case 90:
			return $elm$bytes$Bytes$Encode$unsignedInt8(77);
		case 58:
			return $elm$bytes$Bytes$Encode$unsignedInt8(78);
		case 83:
			return $elm$bytes$Bytes$Encode$unsignedInt8(79);
		case 72:
			return $elm$bytes$Bytes$Encode$unsignedInt8(80);
		case 51:
			return $elm$bytes$Bytes$Encode$unsignedInt8(81);
		case 52:
			return $elm$bytes$Bytes$Encode$unsignedInt8(82);
		case 26:
			return $elm$bytes$Bytes$Encode$unsignedInt8(83);
		case 24:
			return $elm$bytes$Bytes$Encode$unsignedInt8(84);
		case 23:
			return $elm$bytes$Bytes$Encode$unsignedInt8(85);
		case 25:
			return $elm$bytes$Bytes$Encode$unsignedInt8(86);
		case 67:
			return $elm$bytes$Bytes$Encode$unsignedInt8(87);
		case 65:
			return $elm$bytes$Bytes$Encode$unsignedInt8(88);
		case 66:
			return $elm$bytes$Bytes$Encode$unsignedInt8(89);
		case 74:
			return $elm$bytes$Bytes$Encode$unsignedInt8(90);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(91);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(92);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(93);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(94);
		case 14:
			return $elm$bytes$Bytes$Encode$unsignedInt8(95);
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(96);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(97);
	}
};
var $author$project$Evergreen$V419$ToBackendLog$w3_encode_ToBackendLogData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.endTime),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.startTime),
				$author$project$Evergreen$V419$ToBackendLog$w3_encode_ToBackendLog(w3_rec_var0.toBackendLog),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				w3_rec_var0.userId)
			]));
};
var $author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$ = function (w3_x_c_a, w3v) {
	if (!w3v.$) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					w3_x_c_a(v0)
				]));
	}
};
var $author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend = F2($author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$);
var $author$project$Evergreen$V419$IdArray$w3_encode_IdArray$ = function (w3_x_c_k, w3_x_c_v, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeArray$(w3_x_c_v, v0)
			]));
};
var $author$project$Evergreen$V419$IdArray$w3_encode_IdArray = F3($author$project$Evergreen$V419$IdArray$w3_encode_IdArray$);
var $author$project$Evergreen$V419$UserSession$w3_encode_LastViewedGuild = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_TeamId, v0)
					]));
	}
};
var $author$project$Evergreen$V419$UserSession$w3_encode_NotificationMode = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V419$Ports$w3_encode_SubscribeKeys = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.auth),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.p256dh)
			]));
};
var $author$project$Evergreen$V419$Ports$w3_encode_SubscribeData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$url$Url$w3_encode_Url(w3_rec_var0.endpoint),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				function (t) {
					return $lamdera$codecs$Lamdera$Wire3$encodeInt(
						$elm$time$Time$posixToMillis(t));
				},
				w3_rec_var0.expirationTime),
				$author$project$Evergreen$V419$Ports$w3_encode_SubscribeKeys(w3_rec_var0.keys)
			]));
};
var $author$project$Evergreen$V419$UserSession$w3_encode_PushSubscription = function (w3v) {
	switch (w3v.$) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$Ports$w3_encode_SubscribeData(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v1)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$Ports$w3_encode_SubscribeData(v0),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v1)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v1)
					]));
	}
};
var $author$project$Evergreen$V419$UserSession$w3_encode_SheepGameQuestion = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$FileStatus$w3_encode_FileId),
				$author$project$Evergreen$V419$FileStatus$w3_encode_FileStatus,
				w3_rec_var0.attachedFiles),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.text)
			]));
};
var $author$project$Evergreen$V419$UserAgent$w3_encode_Browser = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
	}
};
var $author$project$Evergreen$V419$UserAgent$w3_encode_Device = function (w3v) {
	switch (w3v) {
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
	}
};
var $author$project$Evergreen$V419$UserAgent$w3_encode_UserAgent = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$UserAgent$w3_encode_Browser(w3_rec_var0.browser),
				$author$project$Evergreen$V419$UserAgent$w3_encode_Device(w3_rec_var0.device)
			]));
};
var $author$project$Evergreen$V419$UserSession$w3_encode_UserOptionSection = function (w3v) {
	switch (w3v) {
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
	}
};
var $author$project$Evergreen$V419$UserSession$w3_encode_UserSession = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqSet$encodeSet$($author$project$Evergreen$V419$UserSession$w3_encode_UserOptionSection, w3_rec_var0.expandedUserOptions),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.lastClientDisconnect),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$UserSession$w3_encode_LastViewedGuild, w3_rec_var0.lastViewedGuild),
				$author$project$Evergreen$V419$UserSession$w3_encode_NotificationMode(w3_rec_var0.notificationMode),
				$author$project$Evergreen$V419$UserSession$w3_encode_PushSubscription(w3_rec_var0.pushSubscription),
				$author$project$Evergreen$V419$IdArray$w3_encode_IdArray$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, $author$project$Evergreen$V419$UserSession$w3_encode_SheepGameQuestion, w3_rec_var0.savedSheepGameQuestions),
				$author$project$Evergreen$V419$SessionIdHash$w3_encode_SessionIdHash(w3_rec_var0.sessionIdHash),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.signedInAt),
				$author$project$Evergreen$V419$UserAgent$w3_encode_UserAgent(w3_rec_var0.userAgent),
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, w3_rec_var0.userId)
			]));
};
var $author$project$Evergreen$V419$LocalState$w3_encode_WebsocketClosedEvent = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v1)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v1)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$lamdera$program_test$Effect$Websocket$w3_encode_CloseEventCode(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v2),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v3)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v1)
					]));
	}
};
var $author$project$Evergreen$V419$Pages$Admin$w3_encode_AdminChange = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$containers$SeqDict$encodeDict$(
									$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
									$author$project$Evergreen$V419$Pages$Admin$w3_encode_EditedBackendUser,
									w3_rec_var0.changedUsers),
									$lamdera$containers$SeqSet$encodeSet$(
									$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
									w3_rec_var0.deletedUsers),
									$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Evergreen$V419$Pages$Admin$w3_encode_EditedBackendUser, w3_rec_var0.newUsers),
									$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.time)
								]));
					}(v0)
					]));
		case 28:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId, v0)
					]));
		case 29:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v0)
					]));
		case 32:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0)
					]));
		case 40:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$codecs$Lamdera$Wire3$encodeResult,
							$lamdera$program_test$Effect$Http$w3_encode_Error,
							$lamdera$codecs$Lamdera$Wire3$encodeList($author$project$Evergreen$V419$FileStatus$w3_encode_FileHash)),
						v0)
					]));
		case 38:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V419$SessionIdHash$w3_encode_SessionIdHash(v0)
					]));
		case 31:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_DmChannelId, v0)
					]));
		case 30:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_TeamId, v0)
					]));
		case 37:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Evergreen$V419$SessionIdHash$w3_encode_SessionIdHash(v0),
						$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId(v1)
					]));
		case 15:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						$lamdera$codecs$Lamdera$Wire3$encodeArray($author$project$Evergreen$V419$BackendMsgLog$w3_encode_BackendMsgLogData),
						v0)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_GuildId),
							$author$project$Evergreen$V419$LocalState$w3_encode_AdminData_DeletedGuild),
						v0)
					]));
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId),
							$author$project$Evergreen$V419$LocalState$w3_encode_AdminData_DiscordDmChannel),
						v0)
					]));
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_GuildId),
							$author$project$Evergreen$V419$LocalState$w3_encode_AdminData_DiscordGuild),
						v0)
					]));
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
							$author$project$Evergreen$V419$LocalState$w3_encode_DiscordUserData_ForAdmin),
						v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2($lamdera$containers$SeqDict$encodeDict, $author$project$Evergreen$V419$DmChannelId$w3_encode_DmChannelId, $author$project$Evergreen$V419$LocalState$w3_encode_AdminData_DmChannel),
						v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_GuildId),
							$author$project$Evergreen$V419$LocalState$w3_encode_AdminData_Guild),
						v0)
					]));
		case 13:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2($lamdera$containers$SeqDict$encodeDict, $author$project$Evergreen$V419$FileStatus$w3_encode_FileHash, $author$project$Evergreen$V419$FileStatus$w3_encode_BackendFileData),
						v0)
					]));
		case 11:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2($lamdera$containers$SeqDict$encodeDict, $author$project$Evergreen$V419$SessionIdHash$w3_encode_SessionIdHash, $author$project$Evergreen$V419$UserSession$w3_encode_UserSession),
						v0)
					]));
		case 10:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_DmChannelId),
							$author$project$Evergreen$V419$LocalState$w3_encode_AdminData_SlackDmChannel),
						v0)
					]));
		case 9:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(19),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_TeamId),
							$author$project$Evergreen$V419$LocalState$w3_encode_AdminData_SlackWorkspace),
						v0)
					]));
		case 14:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(20),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						$lamdera$codecs$Lamdera$Wire3$encodeArray($author$project$Evergreen$V419$ToBackendLog$w3_encode_ToBackendLogData),
						v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(21),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$author$project$Evergreen$V419$NonemptyDict$w3_encode_NonemptyDict,
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
							$author$project$Evergreen$V419$User$w3_encode_BackendUser),
						v0)
					]));
		case 12:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(22),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						$lamdera$codecs$Lamdera$Wire3$encodeArray($author$project$Evergreen$V419$LocalState$w3_encode_WebsocketClosedEvent),
						v0)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(23),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Pagination$w3_encode_PageId, v0),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						$lamdera$codecs$Lamdera$Wire3$encodeArray($author$project$Evergreen$V419$LocalState$w3_encode_LogWithTime),
						v1)
					]));
		case 39:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(24),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2($lamdera$codecs$Lamdera$Wire3$encodeResult, $lamdera$program_test$Effect$Http$w3_encode_Error, $lamdera$program_test$Effect$Time$w3_encode_Posix),
						v0)
					]));
		case 36:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(25),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$codecs$Lamdera$Wire3$encodeResult,
							$author$project$Evergreen$V419$Discord$w3_encode_HttpError,
							$lamdera$codecs$Lamdera$Wire3$encodeList($author$project$Evergreen$V419$Discord$w3_encode_Role)),
						v2)
					]));
		case 33:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(26),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0)
					]));
		case 19:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(27),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, v0)
					]));
		case 18:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(28),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 16:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(29),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 26:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(30),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
						v0)
					]));
		case 25:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(31),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v0)
					]));
		case 24:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(32),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v0)
					]));
		case 27:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(33),
						$author$project$Evergreen$V419$Postmark$w3_encode_ApiKey(v0)
					]));
		case 22:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(34),
						$author$project$Evergreen$V419$LocalState$w3_encode_PrivateVapidKey(v0)
					]));
		case 23:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(35),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 17:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(36),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 21:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(37),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, v0)
					]));
		case 20:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(38),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 35:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(39),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v1),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId, v2)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(40),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v1),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v2),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, v3)
					]));
	}
};
var $author$project$Evergreen$V419$Drawing$w3_encode_MessageAnchor = function (w3v) {
	switch (w3v.$) {
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$FileStatus$w3_encode_FileId, v0)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
	}
};
var $author$project$Evergreen$V419$Drawing$w3_encode_AnchorType = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$Id$w3_encode_ThreadRoute(v0),
					$justinmimbs$date$Date$w3_encode_Date(v1)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v0),
					$author$project$Evergreen$V419$Drawing$w3_encode_MessageAnchor(v1)
				]));
	}
};
var $author$project$Evergreen$V419$Types$w3_encode_ChannelDataToDecrypt = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
				$author$project$Evergreen$V419$Encryption$w3_encode_EncryptedData(
					$author$project$Evergreen$V419$Message$w3_encode_MessageContent$(
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId))),
				w3_rec_var0.channel),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
				A2(
					$author$project$Evergreen$V419$NonemptyDict$w3_encode_NonemptyDict,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId),
					$author$project$Evergreen$V419$Encryption$w3_encode_EncryptedData(
						$author$project$Evergreen$V419$Message$w3_encode_MessageContent$(
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId)))),
				w3_rec_var0.threads)
			]));
};
var $author$project$Evergreen$V419$Types$w3_encode_ChannelDataToEncrypt = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
				$author$project$Evergreen$V419$Message$w3_encode_MessageContent$(
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId)),
				w3_rec_var0.channel),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId),
					$author$project$Evergreen$V419$Message$w3_encode_MessageContent$(
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId))),
				w3_rec_var0.threads)
			]));
};
var $author$project$Evergreen$V419$ChannelDescription$w3_encode_ChannelDescription = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Evergreen$V419$Go$w3_encode_Action = function (w3v) {
	switch (w3v.$) {
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
	}
};
var $author$project$Evergreen$V419$Go$w3_encode_ActionWithTime = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Go$w3_encode_Action(w3_rec_var0.change),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.time)
			]));
};
var $author$project$Evergreen$V419$SheepGame$w3_encode_Reactions = A2(
	$lamdera$containers$SeqDict$encodeDict,
	$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji,
	$author$project$Evergreen$V419$NonemptySet$w3_encode_NonemptySet(
		$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId)));
var $author$project$Evergreen$V419$SheepGame$w3_encode_ValidatedInput = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$FileStatus$w3_encode_FileId),
				$author$project$Evergreen$V419$FileStatus$w3_encode_FileData,
				w3_rec_var0.attachedFiles),
				$author$project$Evergreen$V419$SheepGame$w3_encode_Reactions(w3_rec_var0.reactions),
				$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
				A2(
					$author$project$Evergreen$V419$RichText$w3_encode_RichText,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId)),
				w3_rec_var0.text)
			]));
};
var $author$project$Evergreen$V419$SheepGame$w3_encode_Action = function (w3v) {
	switch (w3v.$) {
		case 7:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$SheepGame$w3_encode_ReactionTarget(v0),
						$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji(v1)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v2)
					]));
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$SheepGame$w3_encode_ValidatedInput, v1)
					]));
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v0)
					]));
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 8:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Evergreen$V419$SheepGame$w3_encode_ReactionTarget(v0),
						$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji(v1)
					]));
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$SheepGame$w3_encode_ValidatedInput, v1)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
	}
};
var $author$project$Evergreen$V419$SheepGame$w3_encode_ActionWithTime = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$SheepGame$w3_encode_Action(w3_rec_var0.change),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.time),
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, w3_rec_var0.userId)
			]));
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_IsValid = function (w3v) {
	if (w3v.$ === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodeSet$($lamdera$codecs$Lamdera$Wire3$encodeString, v0)
				]));
	}
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_Letter = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeChar(v0)
			]));
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_LetterOrWildcard = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$WordSpellingGame$w3_encode_Letter(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_PlacedWord = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isVertical),
				$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$($author$project$Evergreen$V419$WordSpellingGame$w3_encode_LetterOrWildcard, w3_rec_var0.letters),
				$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.start)
			]));
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_Action = function (w3v) {
	switch (w3v.$) {
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$WordSpellingGame$w3_encode_ReactionTarget(v0),
						$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji(v1)
					]));
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V419$WordSpellingGame$w3_encode_PlacedWord(v0),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$($author$project$Evergreen$V419$WordSpellingGame$w3_encode_IsValid, v1)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V419$WordSpellingGame$w3_encode_PlacedWord(v0),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$($author$project$Evergreen$V419$WordSpellingGame$w3_encode_IsValid, v1)
					]));
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V419$WordSpellingGame$w3_encode_ReactionTarget(v0),
						$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji(v1)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
	}
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_ActionWithTime = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$WordSpellingGame$w3_encode_Action(w3_rec_var0.change),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.time),
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, w3_rec_var0.userId)
			]));
};
var $author$project$Evergreen$V419$SheepGame$w3_encode_Phase = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V419$SheepGame$w3_encode_Shared = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				A2(
					$author$project$Evergreen$V419$IdArray$w3_encode_IdArray,
					$author$project$Evergreen$V419$Id$w3_encode_QuestionId,
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe($author$project$Evergreen$V419$SheepGame$w3_encode_ValidatedInput)),
				w3_rec_var0.answers),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_QuestionId)),
				$lamdera$codecs$Lamdera$Wire3$encodeString,
				w3_rec_var0.groups),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_QuestionId),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe($author$project$Evergreen$V419$SheepGame$w3_encode_ValidatedInput),
				w3_rec_var0.notes),
				$author$project$Evergreen$V419$SheepGame$w3_encode_Phase(w3_rec_var0.phase),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.questionsRevealed)
			]));
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_AnimatedPlacement = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
					$author$project$Evergreen$V419$WordSpellingGame$w3_encode_LetterOrWildcard),
				w3_rec_var0.cells),
				$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$($author$project$Evergreen$V419$WordSpellingGame$w3_encode_IsValid, w3_rec_var0.isValid),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.startTime)
			]));
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_LetterId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_PlacementResult = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
					$author$project$Evergreen$V419$WordSpellingGame$w3_encode_LetterOrWildcard),
				w3_rec_var0.placedCells),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.score),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V419$WordSpellingGame$w3_encode_LetterOrWildcard, w3_rec_var1.letters),
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.placedCount)
							]));
				},
				w3_rec_var0.words)
			]));
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_Player = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				A3($lamdera$codecs$Lamdera$Wire3$encodeTriple, $author$project$Evergreen$V419$WordSpellingGame$w3_encode_PlacedWord, $author$project$Evergreen$V419$WordSpellingGame$w3_encode_PlacementResult, $author$project$Evergreen$V419$WordSpellingGame$w3_encode_IsValid),
				w3_rec_var0.premove),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.score),
				$author$project$Evergreen$V419$IdArray$w3_encode_IdArray$($author$project$Evergreen$V419$WordSpellingGame$w3_encode_LetterId, $author$project$Evergreen$V419$WordSpellingGame$w3_encode_LetterOrWildcard, w3_rec_var0.tray),
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, w3_rec_var0.userId)
			]));
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_Reactions = A2(
	$lamdera$containers$SeqDict$encodeDict,
	$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji,
	$author$project$Evergreen$V419$NonemptySet$w3_encode_NonemptySet(
		$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId)));
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_Shared = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$OneOrGreater$w3_encode_OneOrGreater(w3_rec_var0.attemptsLeft),
				$lamdera$containers$SeqDict$encodeDict$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				$author$project$Evergreen$V419$WordSpellingGame$w3_encode_LetterOrWildcard,
				w3_rec_var0.board),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$WordSpellingGame$w3_encode_AnimatedPlacement, w3_rec_var0.lastPlacement),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.passingStartedAt),
				$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$($author$project$Evergreen$V419$WordSpellingGame$w3_encode_Player, w3_rec_var0.players),
				$lamdera$containers$SeqDict$encodeDict$($author$project$Evergreen$V419$WordSpellingGame$w3_encode_ReactionTarget, $author$project$Evergreen$V419$WordSpellingGame$w3_encode_Reactions, w3_rec_var0.reactions),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.turnCount)
			]));
};
var $author$project$Evergreen$V419$Go$w3_encode_BoardSize = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Evergreen$V419$Go$w3_encode_KomiHalfPoints = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Evergreen$V419$Go$w3_encode_Stone = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$Go$w3_encode_TimeControl = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var0.increment),
				$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var0.mainTime)
			]));
};
var $author$project$Evergreen$V419$Go$w3_encode_ValidatedSetup = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, w3_rec_var0.createdBy),
				$author$project$Evergreen$V419$Go$w3_encode_Stone(w3_rec_var0.gameCreatorPlayingAs),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.handicap),
				$author$project$Evergreen$V419$Go$w3_encode_BoardSize(w3_rec_var0.height),
				$author$project$Evergreen$V419$Go$w3_encode_KomiHalfPoints(w3_rec_var0.komiHalfPoints),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Go$w3_encode_TimeControl, w3_rec_var0.timeControl),
				$author$project$Evergreen$V419$Go$w3_encode_BoardSize(w3_rec_var0.width)
			]));
};
var $author$project$Evergreen$V419$SheepGame$w3_encode_ValidatedSetup = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, w3_rec_var0.createdBy),
				$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$($author$project$Evergreen$V419$SheepGame$w3_encode_ValidatedInput, w3_rec_var0.questions)
			]));
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_Language = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_ValidatedSetup = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, w3_rec_var0.createdBy),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.fullTrayBonus),
				$author$project$Evergreen$V419$WordSpellingGame$w3_encode_Language(w3_rec_var0.language),
				$author$project$Evergreen$V419$NonemptyDict$w3_encode_NonemptyDict$(
				$author$project$Evergreen$V419$WordSpellingGame$w3_encode_LetterOrWildcard,
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$author$project$Evergreen$V419$OneOrGreater$w3_encode_OneOrGreater(w3_rec_var1.count),
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.value)
							]));
				},
				w3_rec_var0.letters),
				$author$project$Evergreen$V419$OneOrGreater$w3_encode_OneOrGreater(w3_rec_var0.placeWordAttempts),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.seed),
				$author$project$Evergreen$V419$Go$w3_encode_TimeControl(w3_rec_var0.timeControls),
				$author$project$Evergreen$V419$OneOrGreater$w3_encode_OneOrGreater(w3_rec_var0.traySize)
			]));
};
var $author$project$Evergreen$V419$Game$w3_encode_BackendGameData = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Go$w3_encode_ValidatedSetup(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Evergreen$V419$Go$w3_encode_ActionWithTime, v1)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$SheepGame$w3_encode_ValidatedSetup(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Evergreen$V419$SheepGame$w3_encode_ActionWithTime, v1),
						$author$project$Evergreen$V419$SheepGame$w3_encode_Shared(v2)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$WordSpellingGame$w3_encode_ValidatedSetup(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Evergreen$V419$WordSpellingGame$w3_encode_ActionWithTime, v1),
						$author$project$Evergreen$V419$WordSpellingGame$w3_encode_Shared(v2)
					]));
	}
};
var $author$project$Evergreen$V419$Id$w3_encode_GamePublicId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$SecretId$w3_encode_SecretId$ = function (w3_x_c_a, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Evergreen$V419$SecretId$w3_encode_SecretId = F2($author$project$Evergreen$V419$SecretId$w3_encode_SecretId$);
var $author$project$Evergreen$V419$Game$w3_encode_LoadedMatch = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Game$w3_encode_BackendGameData(w3_rec_var0.gameData),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V419$SecretId$w3_encode_SecretId($author$project$Evergreen$V419$Id$w3_encode_GamePublicId),
				w3_rec_var0.publicLink)
			]));
};
var $author$project$Evergreen$V419$DmChannel$w3_encode_LoadedMessages = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
				A3(
					$author$project$Evergreen$V419$Message$w3_encode_Message,
					$author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId)),
				w3_rec_var0.messages),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
				$author$project$Evergreen$V419$Game$w3_encode_LoadedMatch,
				w3_rec_var0.repliedToMatches)
			]));
};
var $author$project$Evergreen$V419$Call$w3_encode_RemoteCallData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.audioInputEnabled),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.screenShareEnabled),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.videoInputEnabled)
			]));
};
var $author$project$Evergreen$V419$Call$w3_encode_LocalChange = function (w3v) {
	switch (w3v.$) {
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0)
					]));
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V419$Call$w3_encode_RemoteCallData(v0)
					]));
	}
};
var $author$project$Evergreen$V419$Drawing$w3_encode_LocalChange = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Evergreen$V419$SafeFloat$w3_encode_SafeFloat, $author$project$Evergreen$V419$SafeFloat$w3_encode_SafeFloat),
						v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Evergreen$V419$SafeFloat$w3_encode_SafeFloat, $author$project$Evergreen$V419$SafeFloat$w3_encode_SafeFloat),
						v0)
					]));
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V419$SafeFloat$w3_encode_SafeFloat, $author$project$Evergreen$V419$SafeFloat$w3_encode_SafeFloat, v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
	}
};
var $author$project$Evergreen$V419$Go$w3_encode_LocalChange = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$Go$w3_encode_ActionWithTime(v0)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
					$author$project$Evergreen$V419$Go$w3_encode_ValidatedSetup(v1)
				]));
	}
};
var $author$project$Evergreen$V419$SheepGame$w3_encode_LocalChange = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$SheepGame$w3_encode_ActionWithTime(v0)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
					$author$project$Evergreen$V419$SheepGame$w3_encode_ValidatedSetup(v1)
				]));
	}
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_LocalChange = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$WordSpellingGame$w3_encode_ActionWithTime(v0)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
					$author$project$Evergreen$V419$WordSpellingGame$w3_encode_ValidatedSetup(v1)
				]));
	}
};
var $author$project$Evergreen$V419$Game$w3_encode_LocalChange = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v0),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						$author$project$Evergreen$V419$SecretId$w3_encode_SecretId($author$project$Evergreen$V419$Id$w3_encode_GamePublicId),
						v1)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v0),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$($author$project$Evergreen$V419$Game$w3_encode_LoadedMatch, v1)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v0),
						$author$project$Evergreen$V419$Go$w3_encode_LocalChange(v1)
					]));
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v0),
						$author$project$Evergreen$V419$SheepGame$w3_encode_LocalChange(v1)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v0),
						$author$project$Evergreen$V419$WordSpellingGame$w3_encode_LocalChange(v1)
					]));
	}
};
var $author$project$Evergreen$V419$TextEditor$w3_encode_EditChange = function (w3v) {
	var v0 = w3v.a;
	var v1 = w3v.b;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$author$project$Evergreen$V419$Range$w3_encode_Range(v0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
			]));
};
var $author$project$Evergreen$V419$TextEditor$w3_encode_LocalChange = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$TextEditor$w3_encode_EditChange(v0)
					]));
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Evergreen$V419$User$w3_encode_NotificationLevel = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$VisibleMessages$w3_encode_PageRequest$ = function (w3_x_c_messageId, w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$Id$w3_encode_Id$(w3_x_c_messageId, v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V419$Id$w3_encode_Id$(w3_x_c_messageId, v0)
				]));
	}
};
var $author$project$Evergreen$V419$VisibleMessages$w3_encode_PageRequest = F2($author$project$Evergreen$V419$VisibleMessages$w3_encode_PageRequest$);
var $author$project$Evergreen$V419$Ports$w3_encode_RegisterPushSubscription = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$Ports$w3_encode_SubscribeData(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
				]));
	}
};
var $author$project$Evergreen$V419$UserSession$w3_encode_DiscordFrontendUser = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$UserColor$w3_encode_UserColor(w3_rec_var0.color),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
				$author$project$Evergreen$V419$PersonName$w3_encode_PersonName(w3_rec_var0.name)
			]));
};
var $author$project$Evergreen$V419$UserSession$w3_encode_UnreadOverviewData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
					A3(
						$author$project$Evergreen$V419$Message$w3_encode_Message,
						$author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId,
						$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
						$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_ChannelId))),
				w3_rec_var0.discordDmChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_GuildId),
					$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_ChannelId)),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
					A3(
						$author$project$Evergreen$V419$Message$w3_encode_Message,
						$author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId,
						$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
						$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_ChannelId))),
				w3_rec_var0.discordGuildChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				A3(
					$lamdera$codecs$Lamdera$Wire3$encodeTriple,
					$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_GuildId),
					$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_ChannelId),
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId)),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId),
					A3(
						$author$project$Evergreen$V419$Message$w3_encode_Message,
						$author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId,
						$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
						$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_ChannelId))),
				w3_rec_var0.discordGuildThreads),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
				$author$project$Evergreen$V419$UserSession$w3_encode_DiscordFrontendUser,
				w3_rec_var0.discordUsers),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
					A3(
						$author$project$Evergreen$V419$Message$w3_encode_Message,
						$author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId,
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId))),
				w3_rec_var0.dmChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId)),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId),
					A3(
						$author$project$Evergreen$V419$Message$w3_encode_Message,
						$author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId,
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId))),
				w3_rec_var0.dmThreads),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_GuildId),
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId)),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
					A3(
						$author$project$Evergreen$V419$Message$w3_encode_Message,
						$author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId,
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId))),
				w3_rec_var0.guildChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				A3(
					$lamdera$codecs$Lamdera$Wire3$encodeTriple,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_GuildId),
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId),
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId)),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId),
					A3(
						$author$project$Evergreen$V419$Message$w3_encode_Message,
						$author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId,
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId))),
				w3_rec_var0.guildThreads),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_TeamId),
					$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_ChannelId)),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
					A3(
						$author$project$Evergreen$V419$Message$w3_encode_Message,
						$author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId,
						$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_UserId),
						$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_ChannelId))),
				w3_rec_var0.slackChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_DmChannelId),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
					A3(
						$author$project$Evergreen$V419$Message$w3_encode_Message,
						$author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId,
						$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_UserId),
						$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_ChannelId))),
				w3_rec_var0.slackDmChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_DmChannelId),
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId)),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId),
					A3(
						$author$project$Evergreen$V419$Message$w3_encode_Message,
						$author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId,
						$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_UserId),
						$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_ChannelId))),
				w3_rec_var0.slackDmThreads),
				$lamdera$containers$SeqDict$encodeDict$(
				A3(
					$lamdera$codecs$Lamdera$Wire3$encodeTriple,
					$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_TeamId),
					$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_ChannelId),
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId)),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId),
					A3(
						$author$project$Evergreen$V419$Message$w3_encode_Message,
						$author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId,
						$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_UserId),
						$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_ChannelId))),
				w3_rec_var0.slackThreads)
			]));
};
var $author$project$Evergreen$V419$UserSession$w3_encode_ViewDiscordGuildData = function (w3_x_c_messageId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$containers$SeqDict$encodeDict$(
					$author$project$Evergreen$V419$Id$w3_encode_Id(w3_x_c_messageId),
					A3(
						$author$project$Evergreen$V419$Message$w3_encode_Message,
						w3_x_c_messageId,
						$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
						$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_ChannelId)),
					w3_rec_var0.messages),
					$lamdera$containers$SeqDict$encodeDict$(
					$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
					$author$project$Evergreen$V419$UserSession$w3_encode_DiscordFrontendUser,
					w3_rec_var0.newUsers)
				]));
	};
};
var $author$project$Evergreen$V419$UserSession$w3_encode_ChannelHeaderTab = function (w3v) {
	switch (w3v.$) {
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
						v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Message$w3_encode_RepliedToGame, v1)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Evergreen$V419$UserSession$w3_encode_PreviouslyLastViewedMessage$ = function (w3_x_c_messageId, w3v) {
	if (!w3v.$) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V419$Id$w3_encode_Id$(w3_x_c_messageId, v0)
				]));
	}
};
var $author$project$Evergreen$V419$UserSession$w3_encode_PreviouslyLastViewedMessage = F2($author$project$Evergreen$V419$UserSession$w3_encode_PreviouslyLastViewedMessage$);
var $author$project$Evergreen$V419$UserSession$w3_encode_Viewing_ChannelData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$UserSession$w3_encode_ChannelHeaderTab, w3_rec_var0.channelHeaderTab),
				$author$project$Evergreen$V419$Id$w3_encode_Viewing_ChannelId(w3_rec_var0.id),
				$author$project$Evergreen$V419$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, w3_rec_var0.previouslyLastViewedMessage)
			]));
};
var $author$project$Evergreen$V419$Id$w3_encode_Viewing_ChannelThreadId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelId, w3_rec_var0.channelId),
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, w3_rec_var0.guildId),
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, w3_rec_var0.threadId)
			]));
};
var $author$project$Evergreen$V419$UserSession$w3_encode_Viewing_ChannelThreadData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Id$w3_encode_Viewing_ChannelThreadId(w3_rec_var0.id),
				$author$project$Evergreen$V419$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId, w3_rec_var0.previouslyLastViewedMessage)
			]));
};
var $author$project$Evergreen$V419$UserSession$w3_encode_Viewing_DiscordChannelData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Id$w3_encode_Viewing_DiscordChannelId(w3_rec_var0.id),
				$author$project$Evergreen$V419$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, w3_rec_var0.previouslyLastViewedMessage)
			]));
};
var $author$project$Evergreen$V419$Id$w3_encode_Viewing_DiscordChannelThreadId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, w3_rec_var0.channelId),
				$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, w3_rec_var0.currentUserId),
				$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, w3_rec_var0.guildId),
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, w3_rec_var0.threadId)
			]));
};
var $author$project$Evergreen$V419$UserSession$w3_encode_Viewing_DiscordChannelThreadData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Id$w3_encode_Viewing_DiscordChannelThreadId(w3_rec_var0.id),
				$author$project$Evergreen$V419$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId, w3_rec_var0.previouslyLastViewedMessage)
			]));
};
var $author$project$Evergreen$V419$UserSession$w3_encode_Viewing_DiscordDmData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Id$w3_encode_Viewing_DiscordDmId(w3_rec_var0.id),
				$author$project$Evergreen$V419$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, w3_rec_var0.previouslyLastViewedMessage)
			]));
};
var $author$project$Evergreen$V419$UserSession$w3_encode_Viewing_DmData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$UserSession$w3_encode_ChannelHeaderTab, w3_rec_var0.channelHeaderTab),
				$author$project$Evergreen$V419$Id$w3_encode_Viewing_DmId(w3_rec_var0.id),
				$author$project$Evergreen$V419$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, w3_rec_var0.previouslyLastViewedMessage)
			]));
};
var $author$project$Evergreen$V419$Id$w3_encode_Viewing_DmThreadId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, w3_rec_var0.otherUserId),
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, w3_rec_var0.threadId)
			]));
};
var $author$project$Evergreen$V419$UserSession$w3_encode_Viewing_DmThreadData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Id$w3_encode_Viewing_DmThreadId(w3_rec_var0.id),
				$author$project$Evergreen$V419$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId, w3_rec_var0.previouslyLastViewedMessage)
			]));
};
var $author$project$Evergreen$V419$UserSession$w3_encode_Viewing_SlackChannelData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Id$w3_encode_Viewing_SlackChannelId(w3_rec_var0.id),
				$author$project$Evergreen$V419$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, w3_rec_var0.previouslyLastViewedMessage)
			]));
};
var $author$project$Evergreen$V419$UserSession$w3_encode_Viewing_SlackChannelThreadData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Id$w3_encode_Viewing_SlackChannelId(w3_rec_var0.id),
				$author$project$Evergreen$V419$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId, w3_rec_var0.previouslyLastViewedMessage),
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, w3_rec_var0.threadId)
			]));
};
var $author$project$Evergreen$V419$UserSession$w3_encode_Viewing_SlackDmData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Id$w3_encode_Viewing_SlackDmId(w3_rec_var0.id),
				$author$project$Evergreen$V419$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, w3_rec_var0.previouslyLastViewedMessage)
			]));
};
var $author$project$Evergreen$V419$UserSession$w3_encode_Viewing_SlackDmThreadData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Id$w3_encode_Viewing_SlackDmId(w3_rec_var0.id),
				$author$project$Evergreen$V419$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId, w3_rec_var0.previouslyLastViewedMessage),
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, w3_rec_var0.threadId)
			]));
};
var $author$project$Evergreen$V419$SetViewing$w3_encode_SetViewing = function (w3v) {
	switch (w3v.$) {
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$UserSession$w3_encode_Viewing_ChannelData(v0),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$($author$project$Evergreen$V419$DmChannel$w3_encode_LoadedMessages, v1)
					]));
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$UserSession$w3_encode_Viewing_ChannelThreadData(v0),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId),
							A3(
								$author$project$Evergreen$V419$Message$w3_encode_Message,
								$author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId,
								$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
								$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId))),
						v1)
					]));
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V419$UserSession$w3_encode_Viewing_DiscordChannelData(v0),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						$author$project$Evergreen$V419$UserSession$w3_encode_ViewDiscordGuildData($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
						v1)
					]));
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V419$UserSession$w3_encode_Viewing_DiscordChannelThreadData(v0),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						$author$project$Evergreen$V419$UserSession$w3_encode_ViewDiscordGuildData($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId),
						v1)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V419$UserSession$w3_encode_Viewing_DiscordDmData(v0),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
							A3(
								$author$project$Evergreen$V419$Message$w3_encode_Message,
								$author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId,
								$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
								$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_ChannelId))),
						v1)
					]));
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Evergreen$V419$UserSession$w3_encode_Viewing_DmData(v0),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$($author$project$Evergreen$V419$DmChannel$w3_encode_LoadedMessages, v1)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Evergreen$V419$UserSession$w3_encode_Viewing_DmThreadData(v0),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId),
							A3(
								$author$project$Evergreen$V419$Message$w3_encode_Message,
								$author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId,
								$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
								$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId))),
						v1)
					]));
		case 12:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$($author$project$Evergreen$V419$UserSession$w3_encode_UnreadOverviewData, v0)
					]));
		case 7:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V419$UserSession$w3_encode_Viewing_SlackChannelData(v0),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
							A3(
								$author$project$Evergreen$V419$Message$w3_encode_Message,
								$author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId,
								$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_UserId),
								$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_ChannelId))),
						v1)
					]));
		case 9:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Evergreen$V419$UserSession$w3_encode_Viewing_SlackChannelThreadData(v0),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId),
							A3(
								$author$project$Evergreen$V419$Message$w3_encode_Message,
								$author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId,
								$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_UserId),
								$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_ChannelId))),
						v1)
					]));
		case 8:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$Evergreen$V419$UserSession$w3_encode_Viewing_SlackDmData(v0),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
							A3(
								$author$project$Evergreen$V419$Message$w3_encode_Message,
								$author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId,
								$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_UserId),
								$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_ChannelId))),
						v1)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$Evergreen$V419$UserSession$w3_encode_Viewing_SlackDmThreadData(v0),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId),
							A3(
								$author$project$Evergreen$V419$Message$w3_encode_Message,
								$author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId,
								$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_UserId),
								$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_ChannelId))),
						v1)
					]));
	}
};
var $author$project$Evergreen$V419$Types$w3_encode_LocalChange = function (w3v) {
	switch (w3v.$) {
		case 76:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Id$w3_encode_Viewing_DmId(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v1),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2($lamdera$containers$SeqDict$encodeDict, $author$project$Evergreen$V419$Id$w3_encode_Viewing_DmId, $author$project$Evergreen$V419$Types$w3_encode_ChannelDataToEncrypt),
						v2)
					]));
		case 55:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$NonemptySet$w3_encode_NonemptySet$(
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_CustomEmojiId),
						v0)
					]));
		case 19:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v1),
						$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji(v2)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V419$Pages$Admin$w3_encode_AdminChange(v0)
					]));
		case 16:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v1)
					]));
		case 45:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 40:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Evergreen$V419$UserSession$w3_encode_UserOptionSection(v0)
					]));
		case 27:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.markMessagesAsViewed)
								]));
					}(v0),
						$author$project$Evergreen$V419$SetViewing$w3_encode_SetViewing(v1)
					]));
		case 70:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Evergreen$V419$Id$w3_encode_Viewing_DmId(v0)
					]));
		case 69:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V419$Id$w3_encode_Viewing_DmId(v0)
					]));
		case 74:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Evergreen$V419$Id$w3_encode_Viewing_DmId(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						A2(
							$lamdera$codecs$Lamdera$Wire3$encodePair,
							$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage,
							$author$project$Evergreen$V419$Message$w3_encode_MessageContent$(
								$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
								$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId))),
						v2)
					]));
		case 10:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelId, v1)
					]));
		case 12:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0)
					]));
		case 15:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$SecretId$w3_encode_SecretId$($author$project$Evergreen$V419$Id$w3_encode_InviteLinkId, v1)
					]));
		case 26:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 73:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$author$project$Evergreen$V419$Id$w3_encode_Viewing_DmId(v0),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$($author$project$Evergreen$V419$Types$w3_encode_ChannelDataToDecrypt, v1)
					]));
		case 33:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$author$project$Evergreen$V419$Id$w3_encode_DiscordGuildOrDmId(v0),
						$author$project$Evergreen$V419$VisibleMessages$w3_encode_PageRequest$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
							A3(
								$author$project$Evergreen$V419$Message$w3_encode_Message,
								$author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId,
								$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
								$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_ChannelId))),
						v2)
					]));
		case 34:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$author$project$Evergreen$V419$Id$w3_encode_DiscordGuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V419$VisibleMessages$w3_encode_PageRequest$($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId, v2),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId),
							A3(
								$author$project$Evergreen$V419$Message$w3_encode_Message,
								$author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId,
								$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
								$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_ChannelId))),
						v3)
					]));
		case 23:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Zone(v1),
						$author$project$Evergreen$V419$Id$w3_encode_Viewing_DiscordDmId(v2),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v3),
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v4)
					]));
		case 22:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			var v6 = w3v.g;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(19),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Zone(v1),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v2),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v3),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, v4),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v5),
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v6)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(20),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Zone(v1),
						$author$project$Evergreen$V419$Id$w3_encode_DiscordGuildOrDmId(v2),
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v3),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMaybeMessage(v4),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$FileStatus$w3_encode_FileId),
						$author$project$Evergreen$V419$FileStatus$w3_encode_FileData,
						v5)
					]));
		case 58:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(21),
						$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V419$Drawing$w3_encode_AnchorType(v1),
						$author$project$Evergreen$V419$Drawing$w3_encode_LocalChange(v2)
					]));
		case 9:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(22),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V419$ChannelName$w3_encode_ChannelName(v2),
						$author$project$Evergreen$V419$ChannelDescription$w3_encode_ChannelDescription(v3)
					]));
		case 11:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(23),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$GuildName$w3_encode_GuildName(v1)
					]));
		case 72:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(24),
						$author$project$Evergreen$V419$Id$w3_encode_Viewing_DmId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						A3(
							$lamdera$codecs$Lamdera$Wire3$encodeTriple,
							$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage,
							$lamdera$containers$SeqSet$encodeSet($author$project$Evergreen$V419$FileStatus$w3_encode_FileHash),
							$author$project$Evergreen$V419$Encryption$w3_encode_EncryptedData(
								$author$project$Evergreen$V419$Message$w3_encode_MessageContent$(
									$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
									$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId)))),
						v1)
					]));
		case 39:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(25),
						$author$project$Evergreen$V419$UserSession$w3_encode_UserOptionSection(v0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.collapseOthers)
								]));
					}(v1)
					]));
		case 57:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(26),
						$author$project$Evergreen$V419$Id$w3_encode_GuildOrDmId(v0),
						$author$project$Evergreen$V419$Game$w3_encode_LocalChange(v1)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(27);
		case 13:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(28),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0)
					]));
		case 50:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(29),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 51:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(30),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 29:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(31),
						$author$project$Evergreen$V419$Id$w3_encode_GuildOrDmId(v0),
						$author$project$Evergreen$V419$VisibleMessages$w3_encode_PageRequest$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$($author$project$Evergreen$V419$DmChannel$w3_encode_LoadedMessages, v2)
					]));
		case 30:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(32),
						$author$project$Evergreen$V419$Id$w3_encode_GuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V419$VisibleMessages$w3_encode_PageRequest$($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId, v2),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId),
							A3(
								$author$project$Evergreen$V419$Message$w3_encode_Message,
								$author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId,
								$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
								$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId))),
						v3)
					]));
		case 24:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(33),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId(v1),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v2)
					]));
		case 18:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(34),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_encode_ThreadRoute, v1)
					]));
		case 8:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(35),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v1),
						$author$project$Evergreen$V419$ChannelName$w3_encode_ChannelName(v2),
						$author$project$Evergreen$V419$ChannelDescription$w3_encode_ChannelDescription(v3)
					]));
		case 17:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(36),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$GuildName$w3_encode_GuildName(v1),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_GuildId),
						v2)
					]));
		case 14:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(37),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v1),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						$author$project$Evergreen$V419$SecretId$w3_encode_SecretId($author$project$Evergreen$V419$Id$w3_encode_InviteLinkId),
						v2)
					]));
		case 46:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(38),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Ports$w3_encode_RegisterPushSubscription(v1)
					]));
		case 20:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(39),
						$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v1),
						$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji(v2)
					]));
		case 68:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(40),
						$author$project$Evergreen$V419$Id$w3_encode_Viewing_DmId(v0)
					]));
		case 44:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(41),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0)
					]));
		case 21:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(42),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Zone(v1),
						$author$project$Evergreen$V419$Id$w3_encode_GuildOrDmId(v2),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v3),
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v4),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$FileStatus$w3_encode_FileId),
						$author$project$Evergreen$V419$FileStatus$w3_encode_FileData,
						v5)
					]));
		case 78:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(43),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Id$w3_encode_Viewing_DmId(v1),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v2),
						$lamdera$containers$SeqSet$encodeSet$($author$project$Evergreen$V419$FileStatus$w3_encode_FileHash, v3),
						$author$project$Evergreen$V419$Encryption$w3_encode_EncryptedData$(
						$author$project$Evergreen$V419$Message$w3_encode_MessageContent$(
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId)),
						v4)
					]));
		case 77:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(44),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Id$w3_encode_Viewing_DmId(v1),
						$lamdera$containers$SeqSet$encodeSet$($author$project$Evergreen$V419$FileStatus$w3_encode_FileHash, v2),
						$author$project$Evergreen$V419$Encryption$w3_encode_EncryptedData$(
						$author$project$Evergreen$V419$Message$w3_encode_MessageContent$(
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId)),
						v3),
						$author$project$Evergreen$V419$Encryption$w3_encode_EncryptedData$($lamdera$codecs$Lamdera$Wire3$encodeString, v4),
						$author$project$Evergreen$V419$Message$w3_encode_ThreadRouteWithRepliedTo(v5)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			var v6 = w3v.g;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(45),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Zone(v1),
						$author$project$Evergreen$V419$Id$w3_encode_GuildOrDmId(v2),
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v3),
						$author$project$Evergreen$V419$Message$w3_encode_ThreadRouteWithRepliedTo(v4),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$FileStatus$w3_encode_FileId),
						$author$project$Evergreen$V419$FileStatus$w3_encode_FileData,
						v5),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji, v6)
					]));
		case 36:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(46),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V419$User$w3_encode_NotificationLevel(v2)
					]));
		case 52:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(47),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0),
						$author$project$Evergreen$V419$RichText$w3_encode_Domain(v1)
					]));
		case 75:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(48),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 42:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(49),
						$author$project$Evergreen$V419$User$w3_encode_EmailNotifications(v0)
					]));
		case 43:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(50),
						$author$project$Evergreen$V419$User$w3_encode_EmbedVisibility(v0)
					]));
		case 53:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(51),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Emoji$w3_encode_SkinTone, v0)
					]));
		case 35:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(52),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$User$w3_encode_NotificationLevel(v1)
					]));
		case 25:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(53),
						$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 59:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(54),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(v2)
					]));
		case 61:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(55),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, v2),
						$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(v3)
					]));
		case 64:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(56),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(v2)
					]));
		case 62:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(57),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, v2),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v3),
						$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(v4)
					]));
		case 63:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(58),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(v1)
					]));
		case 66:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(59),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_TeamId, v1),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_ChannelId, v2),
						$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(v3)
					]));
		case 67:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(60),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_TeamId, v1),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_ChannelId, v2),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v3),
						$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(v4)
					]));
		case 65:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(61),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_TeamId, v1),
						$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(v2)
					]));
		case 60:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(62),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v2),
						$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(v3)
					]));
		case 28:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(63),
						$author$project$Evergreen$V419$PersonName$w3_encode_PersonName(v0)
					]));
		case 38:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(64),
						$author$project$Evergreen$V419$UserSession$w3_encode_NotificationMode(v0)
					]));
		case 71:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(65),
						$author$project$Evergreen$V419$X25519$w3_encode_PublicKey(v0),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2($lamdera$containers$SeqDict$encodeDict, $author$project$Evergreen$V419$Id$w3_encode_Viewing_DmId, $author$project$Evergreen$V419$Types$w3_encode_ChannelDataToEncrypt),
						v1)
					]));
		case 41:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(66),
						$author$project$Evergreen$V419$IdArray$w3_encode_IdArray$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, $author$project$Evergreen$V419$UserSession$w3_encode_SheepGameQuestion, v0)
					]));
		case 37:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(67),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_TeamId, v1),
						$author$project$Evergreen$V419$User$w3_encode_NotificationLevel(v2)
					]));
		case 54:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(68),
						$author$project$Evergreen$V419$UserColor$w3_encode_UserColor(v0)
					]));
		case 31:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(69),
						$author$project$Evergreen$V419$Id$w3_encode_SlackGuildOrDmId(v0),
						$author$project$Evergreen$V419$VisibleMessages$w3_encode_PageRequest$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
							A3(
								$author$project$Evergreen$V419$Message$w3_encode_Message,
								$author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId,
								$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_UserId),
								$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_ChannelId))),
						v2)
					]));
		case 32:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(70),
						$author$project$Evergreen$V419$Id$w3_encode_SlackGuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V419$VisibleMessages$w3_encode_PageRequest$($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId, v2),
						$author$project$Evergreen$V419$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId),
							A3(
								$author$project$Evergreen$V419$Message$w3_encode_Message,
								$author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId,
								$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_UserId),
								$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_ChannelId))),
						v3)
					]));
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(71),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_UserId, v0)
					]));
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(72),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Zone(v1),
						$author$project$Evergreen$V419$Id$w3_encode_SlackGuildOrDmId(v2),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v3),
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v4)
					]));
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(73),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Zone(v1),
						$author$project$Evergreen$V419$Id$w3_encode_SlackGuildOrDmId(v2),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRoute(v3),
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v4),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$FileStatus$w3_encode_FileId),
						$author$project$Evergreen$V419$FileStatus$w3_encode_FileData,
						v5)
					]));
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(74),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_UserId, v0)
					]));
		case 49:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(75),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v1)
					]));
		case 47:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(76),
						$author$project$Evergreen$V419$TextEditor$w3_encode_LocalChange(v0)
					]));
		case 48:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(77),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(78),
						$author$project$Evergreen$V419$Call$w3_encode_LocalChange(v0)
					]));
	}
};
var $author$project$Evergreen$V419$CustomEmoji$w3_encode_CustomEmojiUrl = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$FileStatus$w3_encode_FileHash(v0),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					$author$project$Evergreen$V419$Coord$w3_encode_Coord($author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels),
					v1)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$CustomEmoji$w3_encode_EmojiName = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Evergreen$V419$CustomEmoji$w3_encode_CustomEmojiData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isAnimated),
				$author$project$Evergreen$V419$CustomEmoji$w3_encode_EmojiName(w3_rec_var0.name),
				$author$project$Evergreen$V419$CustomEmoji$w3_encode_CustomEmojiUrl(w3_rec_var0.url)
			]));
};
var $author$project$Evergreen$V419$LinkedAndOtherDiscordUsers$w3_encode_DiscordFrontendCurrentUser = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$UserColor$w3_encode_UserColor(w3_rec_var0.color),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$EmailAddress$w3_encode_EmailAddress, w3_rec_var0.email),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
				$author$project$Evergreen$V419$DiscordUserData$w3_encode_DiscordUserLoadingData(w3_rec_var0.isLoadingData),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.linkedAt),
				$author$project$Evergreen$V419$PersonName$w3_encode_PersonName(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.needsAuthAgain)
			]));
};
var $author$project$Evergreen$V419$MessageArray$w3_encode_Run$ = function (w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.start),
					$lamdera$codecs$Lamdera$Wire3$encodeArray$(
					A3($author$project$Evergreen$V419$Message$w3_encode_Message, w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId),
					w3_rec_var0.values)
				]));
	};
};
var $author$project$Evergreen$V419$MessageArray$w3_encode_Run = F3($author$project$Evergreen$V419$MessageArray$w3_encode_Run$);
var $author$project$Evergreen$V419$MessageArray$w3_encode_MessageArray$ = function (w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				function (w3_rec_var0) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.end),
							$lamdera$codecs$Lamdera$Wire3$encodeArray$(
							$author$project$Evergreen$V419$MessageArray$w3_encode_Run$(w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId),
							w3_rec_var0.runs),
							$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.start)
						]));
			}(v0)
			]));
};
var $author$project$Evergreen$V419$MessageArray$w3_encode_MessageArray = F4($author$project$Evergreen$V419$MessageArray$w3_encode_MessageArray$);
var $author$project$Evergreen$V419$VisibleMessages$w3_encode_VisibleMessages = function (w3_x_c_messageId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.count),
					$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.loadingMessages),
					$author$project$Evergreen$V419$Id$w3_encode_Id$(w3_x_c_messageId, w3_rec_var0.oldest)
				]));
	};
};
var $author$project$Evergreen$V419$DmChannel$w3_encode_DiscordFrontendDmChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$justinmimbs$date$Date$w3_encode_Date,
				$author$project$Evergreen$V419$Drawing$w3_encode_Drawing(
					$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId)),
				w3_rec_var0.dateDividerDrawings),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
								$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
								w3_rec_var1.messageIndex),
								$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var1.time)
							]));
				},
				w3_rec_var0.lastTypedAt),
				$author$project$Evergreen$V419$NonemptyDict$w3_encode_NonemptyDict$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.messagesSent)
							]));
				},
				w3_rec_var0.members),
				$author$project$Evergreen$V419$MessageArray$w3_encode_MessageArray$(
				$author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId,
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_ChannelId),
				w3_rec_var0.messages),
				A2($author$project$Evergreen$V419$VisibleMessages$w3_encode_VisibleMessages, $author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, w3_rec_var0.visibleMessages)
			]));
};
var $author$project$Evergreen$V419$Thread$w3_encode_DiscordFrontendThread = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$justinmimbs$date$Date$w3_encode_Date,
				$author$project$Evergreen$V419$Drawing$w3_encode_Drawing(
					$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId)),
				w3_rec_var0.dateDividerDrawings),
				$author$project$Evergreen$V419$MessageArray$w3_encode_MessageArray$(
				$author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId,
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_ChannelId),
				w3_rec_var0.messages),
				A2($author$project$Evergreen$V419$VisibleMessages$w3_encode_VisibleMessages, $author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId, w3_rec_var0.visibleMessages)
			]));
};
var $author$project$Evergreen$V419$LocalState$w3_encode_DiscordFrontendChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$justinmimbs$date$Date$w3_encode_Date,
				$author$project$Evergreen$V419$Drawing$w3_encode_Drawing(
					$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId)),
				w3_rec_var0.dateDividerDrawings),
				$author$project$Evergreen$V419$ChannelDescription$w3_encode_ChannelDescription(w3_rec_var0.description),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isForum),
				$author$project$Evergreen$V419$MessageArray$w3_encode_MessageArray$(
				$author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId,
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_ChannelId),
				w3_rec_var0.messages),
				$author$project$Evergreen$V419$ChannelName$w3_encode_ChannelName(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V419$Discord$w3_encode_Overwrite, w3_rec_var0.permissionOverwrites),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
				$author$project$Evergreen$V419$Thread$w3_encode_DiscordFrontendThread,
				w3_rec_var0.threads),
				A2($author$project$Evergreen$V419$VisibleMessages$w3_encode_VisibleMessages, $author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, w3_rec_var0.visibleMessages)
			]));
};
var $author$project$Evergreen$V419$Thread$w3_encode_LastTypedAt = function (w3_x_c_channelId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					w3_x_c_channelId(w3_rec_var0.channelId),
					$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMaybeMessage(w3_rec_var0.threadRoute),
					$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.time)
				]));
	};
};
var $author$project$Evergreen$V419$LocalState$w3_encode_DiscordFrontendGuild = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_ChannelId),
				$author$project$Evergreen$V419$LocalState$w3_encode_DiscordFrontendChannel,
				w3_rec_var0.channels),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_CustomEmojiId),
				w3_rec_var0.customEmojis),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
				$author$project$Evergreen$V419$Thread$w3_encode_LastTypedAt(
					$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_ChannelId)),
				w3_rec_var0.lastTypedAt),
				$author$project$Evergreen$V419$MembersAndOwner$w3_encode_MembersAndOwner$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var1.joinedAt),
								$lamdera$containers$SeqSet$encodeSet$(
								$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_RoleId),
								w3_rec_var1.roles)
							]));
				},
				w3_rec_var0.membersAndOwner),
				$author$project$Evergreen$V419$GuildName$w3_encode_GuildName(w3_rec_var0.name),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_RoleId),
				$author$project$Evergreen$V419$LocalState$w3_encode_DiscordRole,
				w3_rec_var0.roles),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_StickerId),
				w3_rec_var0.stickers)
			]));
};
var $author$project$Evergreen$V419$LocalState$w3_encode_Archived = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.archivedAt),
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, w3_rec_var0.archivedBy)
			]));
};
var $author$project$Evergreen$V419$Thread$w3_encode_FrontendThread = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$justinmimbs$date$Date$w3_encode_Date,
				$author$project$Evergreen$V419$Drawing$w3_encode_Drawing(
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId)),
				w3_rec_var0.dateDividerDrawings),
				$author$project$Evergreen$V419$MessageArray$w3_encode_MessageArray$(
				$author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId,
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId),
				w3_rec_var0.messages),
				A2($author$project$Evergreen$V419$VisibleMessages$w3_encode_VisibleMessages, $author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId, w3_rec_var0.visibleMessages)
			]));
};
var $author$project$Evergreen$V419$Go$w3_encode_Phase = function (w3v) {
	switch (w3v.$) {
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.previousPlayerPassed)
								]));
					}(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.blackScore),
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.whiteScore)
								]));
					}(v0)
					]));
	}
};
var $author$project$Evergreen$V419$Go$w3_encode_Snapshot = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.blackCaptures),
				$lamdera$codecs$Lamdera$Wire3$encodeDict$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				$author$project$Evergreen$V419$Go$w3_encode_Stone,
				w3_rec_var0.board),
				$author$project$Evergreen$V419$Go$w3_encode_Stone(w3_rec_var0.currentPlayer),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.whiteCaptures)
			]));
};
var $author$project$Evergreen$V419$Go$w3_encode_Shared = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.blackCaptures),
				$lamdera$codecs$Lamdera$Wire3$encodeDict$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				$author$project$Evergreen$V419$Go$w3_encode_Stone,
				w3_rec_var0.board),
				$author$project$Evergreen$V419$Go$w3_encode_Stone(w3_rec_var0.currentPlayer),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V419$Go$w3_encode_Snapshot, w3_rec_var0.history),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				w3_rec_var0.joinedUserId),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.lastAction),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				w3_rec_var0.lastMove),
				$author$project$Evergreen$V419$Go$w3_encode_Phase(w3_rec_var0.phase),
				$lamdera$codecs$Lamdera$Wire3$encodeDict$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				$author$project$Evergreen$V419$Go$w3_encode_Stone,
				w3_rec_var0.territoryMarks),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var1.black),
								$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var1.white)
							]));
				},
				w3_rec_var0.timeLeft),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.turnCount),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.whiteCaptures)
			]));
};
var $author$project$Evergreen$V419$Game$w3_encode_FrontendGameData = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Go$w3_encode_ValidatedSetup(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Evergreen$V419$Go$w3_encode_ActionWithTime, v1),
						$author$project$Evergreen$V419$Go$w3_encode_Shared(v2)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$SheepGame$w3_encode_ValidatedSetup(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Evergreen$V419$SheepGame$w3_encode_ActionWithTime, v1),
						$author$project$Evergreen$V419$SheepGame$w3_encode_Shared(v2)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$WordSpellingGame$w3_encode_ValidatedSetup(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Evergreen$V419$WordSpellingGame$w3_encode_ActionWithTime, v1),
						$author$project$Evergreen$V419$WordSpellingGame$w3_encode_Shared(v2)
					]));
	}
};
var $author$project$Evergreen$V419$Game$w3_encode_MatchData = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					function (w3_rec_var0) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$author$project$Evergreen$V419$Game$w3_encode_FrontendGameData(w3_rec_var0.data),
								$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
								$author$project$Evergreen$V419$SecretId$w3_encode_SecretId($author$project$Evergreen$V419$Id$w3_encode_GamePublicId),
								w3_rec_var0.publicLink)
							]));
				}(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V419$Message$w3_encode_GameType(v0)
				]));
	}
};
var $author$project$Evergreen$V419$LocalState$w3_encode_FrontendChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.createdAt),
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, w3_rec_var0.createdBy),
				$lamdera$containers$SeqDict$encodeDict$(
				$justinmimbs$date$Date$w3_encode_Date,
				$author$project$Evergreen$V419$Drawing$w3_encode_Drawing(
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId)),
				w3_rec_var0.dateDividerDrawings),
				$author$project$Evergreen$V419$ChannelDescription$w3_encode_ChannelDescription(w3_rec_var0.description),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
				$author$project$Evergreen$V419$Game$w3_encode_MatchData,
				w3_rec_var0.games),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$LocalState$w3_encode_Archived, w3_rec_var0.isArchived),
				$author$project$Evergreen$V419$MessageArray$w3_encode_MessageArray$(
				$author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId,
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId),
				w3_rec_var0.messages),
				$author$project$Evergreen$V419$ChannelName$w3_encode_ChannelName(w3_rec_var0.name),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
				$author$project$Evergreen$V419$Thread$w3_encode_FrontendThread,
				w3_rec_var0.threads),
				A2($author$project$Evergreen$V419$VisibleMessages$w3_encode_VisibleMessages, $author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, w3_rec_var0.visibleMessages)
			]));
};
var $author$project$Evergreen$V419$LocalState$w3_encode_GuildMember = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.joinedAt),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.lastPostedAt)
			]));
};
var $author$project$Evergreen$V419$LocalState$w3_encode_FrontendGuild = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId),
				$author$project$Evergreen$V419$LocalState$w3_encode_FrontendChannel,
				w3_rec_var0.channels),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.createdAt),
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, w3_rec_var0.createdBy),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$SecretId$w3_encode_SecretId($author$project$Evergreen$V419$Id$w3_encode_InviteLinkId),
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var1.createdAt),
								$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, w3_rec_var1.createdBy)
							]));
				},
				w3_rec_var0.invites),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				$author$project$Evergreen$V419$Thread$w3_encode_LastTypedAt(
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId)),
				w3_rec_var0.lastTypedAt),
				$author$project$Evergreen$V419$MembersAndOwner$w3_encode_MembersAndOwner$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				$author$project$Evergreen$V419$LocalState$w3_encode_GuildMember,
				w3_rec_var0.membersAndOwner),
				$author$project$Evergreen$V419$GuildName$w3_encode_GuildName(w3_rec_var0.name)
			]));
};
var $author$project$Evergreen$V419$User$w3_encode_FrontendUser = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$UserColor$w3_encode_UserColor(w3_rec_var0.color),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
				$author$project$Evergreen$V419$PersonName$w3_encode_PersonName(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$X25519$w3_encode_PublicKey, w3_rec_var0.publicKey)
			]));
};
var $author$project$Evergreen$V419$UserSession$w3_encode_Viewing = function (w3v) {
	switch (w3v.$) {
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$UserSession$w3_encode_Viewing_ChannelData(v0)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$UserSession$w3_encode_Viewing_ChannelThreadData(v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$UserSession$w3_encode_Viewing_DiscordChannelData(v0)
					]));
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V419$UserSession$w3_encode_Viewing_DiscordChannelThreadData(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V419$UserSession$w3_encode_Viewing_DiscordDmData(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V419$UserSession$w3_encode_Viewing_DmData(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Evergreen$V419$UserSession$w3_encode_Viewing_DmThreadData(v0)
					]));
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 12:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V419$UserSession$w3_encode_Viewing_SlackChannelData(v0)
					]));
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Evergreen$V419$UserSession$w3_encode_Viewing_SlackChannelThreadData(v0)
					]));
		case 9:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$Evergreen$V419$UserSession$w3_encode_Viewing_SlackDmData(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$Evergreen$V419$UserSession$w3_encode_Viewing_SlackDmThreadData(v0)
					]));
	}
};
var $author$project$Evergreen$V419$UserSession$w3_encode_FrontendUserSession = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$($lamdera$program_test$Effect$Lamdera$w3_encode_ClientId, $author$project$Evergreen$V419$UserSession$w3_encode_Viewing, w3_rec_var0.currentlyViewing),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.lastActiveAt),
				$author$project$Evergreen$V419$UserSession$w3_encode_NotificationMode(w3_rec_var0.notificationMode),
				$author$project$Evergreen$V419$UserAgent$w3_encode_UserAgent(w3_rec_var0.userAgent)
			]));
};
var $author$project$Evergreen$V419$Call$w3_encode_CallId = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$Id$w3_encode_Viewing_DmId(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V419$Id$w3_encode_Viewing_ChannelId(v0)
				]));
	}
};
var $author$project$Evergreen$V419$LocalState$w3_encode_CallStatus = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$Call$w3_encode_CallId(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$LocalState$w3_encode_LastRequest = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$program_test$Effect$Time$w3_encode_Posix(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$LocalState$w3_encode_ConnectionData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$LocalState$w3_encode_CallStatus(w3_rec_var0.call),
				$author$project$Evergreen$V419$UserSession$w3_encode_Viewing(w3_rec_var0.currentlyViewing),
				$author$project$Evergreen$V419$LocalState$w3_encode_LastRequest(w3_rec_var0.lastRequest),
				$author$project$Evergreen$V419$Call$w3_encode_RemoteCallData(w3_rec_var0.remoteCallData)
			]));
};
var $author$project$Evergreen$V419$LocalState$w3_encode_BackupContents = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$LocalState$w3_encode_LastBackup = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$LocalState$w3_encode_BackupContents(w3_rec_var0.contents),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.createdAt)
			]));
};
var $author$project$Evergreen$V419$LocalState$w3_encode_LoadingDiscordChannelStep$ = function (w3_x_c_messages, w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						w3_x_c_messages(v1)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$Discord$w3_encode_HttpError(v0)
					]));
	}
};
var $author$project$Evergreen$V419$LocalState$w3_encode_LoadingDiscordChannelStep = F2($author$project$Evergreen$V419$LocalState$w3_encode_LoadingDiscordChannelStep$);
var $author$project$Evergreen$V419$LocalState$w3_encode_LoadingDiscordChannel$ = function (w3_x_c_messages, w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		var v2 = w3v.c;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
					$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId, v1),
					$author$project$Evergreen$V419$LocalState$w3_encode_LoadingDiscordChannelStep$(w3_x_c_messages, v2)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		var v2 = w3v.c;
		var v3 = w3v.d;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
					$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v1),
					$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, v2),
					$author$project$Evergreen$V419$LocalState$w3_encode_LoadingDiscordChannelStep$(w3_x_c_messages, v3)
				]));
	}
};
var $author$project$Evergreen$V419$LocalState$w3_encode_LoadingDiscordChannel = F2($author$project$Evergreen$V419$LocalState$w3_encode_LoadingDiscordChannel$);
var $author$project$Evergreen$V419$Pagination$w3_encode_PageStatus$ = function (w3_x_c_a, w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$codecs$Lamdera$Wire3$encodeArray$(w3_x_c_a, v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$Pagination$w3_encode_PageStatus = F2($author$project$Evergreen$V419$Pagination$w3_encode_PageStatus$);
var $author$project$Evergreen$V419$Pagination$w3_encode_Pagination = function (w3_x_c_a) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Pagination$w3_encode_PageId, w3_rec_var0.currentPage),
					$lamdera$containers$SeqDict$encodeDict$(
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Pagination$w3_encode_PageId),
					$author$project$Evergreen$V419$Pagination$w3_encode_PageStatus(w3_x_c_a),
					w3_rec_var0.pages),
					$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Pagination$w3_encode_PageId, w3_rec_var0.previousPage),
					$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.totalItems)
				]));
	};
};
var $author$project$Evergreen$V419$Pages$Admin$w3_encode_TypeThatIsAlwaysInvalid = function (w3v) {
	return $elm$bytes$Bytes$Encode$unsignedInt8(0);
};
var $author$project$Evergreen$V419$LocalState$w3_encode_WordSpellingGameStatus = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v0)
					]));
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Evergreen$V419$Pages$Admin$w3_encode_InitAdminData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Pages$Admin$w3_encode_TypeThatIsAlwaysInvalid(w3_rec_var0.checkToFrontendValidation),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V419$SessionIdHash$w3_encode_SessionIdHash,
					A2($author$project$Evergreen$V419$NonemptyDict$w3_encode_NonemptyDict, $lamdera$program_test$Effect$Lamdera$w3_encode_ClientId, $author$project$Evergreen$V419$LocalState$w3_encode_ConnectionData)),
				w3_rec_var0.connections),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.discordLinkLimit),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.discordLinkingEnabled),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.emailNotificationsEnabled),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.filesCount),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$LocalState$w3_encode_LastBackup, w3_rec_var0.lastBackup),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
				$author$project$Evergreen$V419$LocalState$w3_encode_LoadingDiscordChannel($lamdera$codecs$Lamdera$Wire3$encodeInt),
				w3_rec_var0.loadingDiscordChannels),
				A2($author$project$Evergreen$V419$Pagination$w3_encode_Pagination, $author$project$Evergreen$V419$LocalState$w3_encode_LogWithTime, w3_rec_var0.logs),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				w3_rec_var0.notifyAdminsBotUserId),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.notifyAdminsToken),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.openRouterKey),
				$author$project$Evergreen$V419$Postmark$w3_encode_ApiKey(w3_rec_var0.postmarkApiKey),
				$author$project$Evergreen$V419$LocalState$w3_encode_PrivateVapidKey(w3_rec_var0.privateVapidKey),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeString, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				w3_rec_var0.seqDictWorks),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.serverSecretRegeneratedAt),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.signupsEnabled),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.slackLinkLimit),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.slackLinkingEnabled),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				$lamdera$program_test$Effect$Time$w3_encode_Posix,
				w3_rec_var0.twoFactorAuthentication),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.vulnerabilityChecks),
				$author$project$Evergreen$V419$LocalState$w3_encode_WordSpellingGameStatus(w3_rec_var0.wordSpellingGameEnglish),
				$author$project$Evergreen$V419$LocalState$w3_encode_WordSpellingGameStatus(w3_rec_var0.wordSpellingGameSwedish)
			]));
};
var $author$project$Evergreen$V419$LocalState$w3_encode_JoinGuildError = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V419$Types$w3_encode_RepliedToData = function (w3v) {
	switch (w3v.$) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$Game$w3_encode_LoadedMatch(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$Message$w3_encode_Message$(
						$author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId,
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId),
						v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V419$Message$w3_encode_Message$(
						$author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId,
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId),
						v0)
					]));
	}
};
var $author$project$Evergreen$V419$Call$w3_encode_ConnectionId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodePair$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId,
				w3_rec_var0.otherClientId),
				$author$project$Evergreen$V419$Call$w3_encode_CallId(w3_rec_var0.roomId)
			]));
};
var $author$project$Evergreen$V419$Call$w3_encode_RecordingStatus = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$containers$SeqSet$encodeSet$(
									$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
									w3_rec_var0.allowedBy),
									$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.requestedAt),
									$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, w3_rec_var0.requestedBy)
								]));
					}(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.declinedAt),
									$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
									$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
									w3_rec_var0.declinedBy),
									$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, w3_rec_var0.requestedBy)
								]));
					}(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0)
					]));
	}
};
var $author$project$Evergreen$V419$Call$w3_encode_ServerChange = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Call$w3_encode_ConnectionId(v1)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Call$w3_encode_ConnectionId(v1),
						$author$project$Evergreen$V419$Call$w3_encode_RemoteCallData(v2)
					]));
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$Call$w3_encode_CallId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Call$w3_encode_RecordingStatus, v1)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V419$Call$w3_encode_ConnectionId(v0),
						$author$project$Evergreen$V419$Call$w3_encode_RemoteCallData(v1)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Call$w3_encode_CallId(v1)
					]));
	}
};
var $author$project$Evergreen$V419$TextEditor$w3_encode_ServerChange = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$TextEditor$w3_encode_EditChange(v1)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0)
					]));
	}
};
var $author$project$Evergreen$V419$Thread$w3_encode_FrontendGenericThread$ = function (w3_x_c_userId, w3_x_c_channelId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$containers$SeqDict$encodeDict$(
					$justinmimbs$date$Date$w3_encode_Date,
					$author$project$Evergreen$V419$Drawing$w3_encode_Drawing(w3_x_c_userId),
					w3_rec_var0.dateDividerDrawings),
					$author$project$Evergreen$V419$MessageArray$w3_encode_MessageArray$($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId, w3_x_c_userId, w3_x_c_channelId, w3_rec_var0.messages),
					A2($author$project$Evergreen$V419$VisibleMessages$w3_encode_VisibleMessages, $author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId, w3_rec_var0.visibleMessages)
				]));
	};
};
var $author$project$Evergreen$V419$Thread$w3_encode_FrontendGenericThread = F2($author$project$Evergreen$V419$Thread$w3_encode_FrontendGenericThread$);
var $author$project$Evergreen$V419$Thread$w3_encode_SlackFrontendThread = $author$project$Evergreen$V419$Thread$w3_encode_FrontendGenericThread$(
	$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_UserId),
	$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_ChannelId));
var $author$project$Evergreen$V419$LocalState$w3_encode_SlackFrontendDmChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$NonemptySet$w3_encode_NonemptySet$(
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_UserId),
				w3_rec_var0.members),
				$author$project$Evergreen$V419$MessageArray$w3_encode_MessageArray$(
				$author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId,
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_UserId),
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_ChannelId),
				w3_rec_var0.messages),
				$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_TeamId, w3_rec_var0.teamId),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
				$author$project$Evergreen$V419$Thread$w3_encode_SlackFrontendThread,
				w3_rec_var0.threads),
				A2($author$project$Evergreen$V419$VisibleMessages$w3_encode_VisibleMessages, $author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, w3_rec_var0.visibleMessages)
			]));
};
var $author$project$Evergreen$V419$UserSession$w3_encode_SlackFrontendUser = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$UserColor$w3_encode_UserColor(w3_rec_var0.color),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
				$author$project$Evergreen$V419$PersonName$w3_encode_PersonName(w3_rec_var0.name),
				$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_TeamId, w3_rec_var0.teamId)
			]));
};
var $author$project$Evergreen$V419$LocalState$w3_encode_SlackFrontendChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isPrivate),
				$author$project$Evergreen$V419$MessageArray$w3_encode_MessageArray$(
				$author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId,
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_UserId),
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_ChannelId),
				w3_rec_var0.messages),
				$author$project$Evergreen$V419$ChannelName$w3_encode_ChannelName(w3_rec_var0.name),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
				$author$project$Evergreen$V419$Thread$w3_encode_SlackFrontendThread,
				w3_rec_var0.threads),
				A2($author$project$Evergreen$V419$VisibleMessages$w3_encode_VisibleMessages, $author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, w3_rec_var0.visibleMessages)
			]));
};
var $author$project$Evergreen$V419$LocalState$w3_encode_SlackFrontendWorkspace = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_ChannelId),
				$author$project$Evergreen$V419$LocalState$w3_encode_SlackFrontendChannel,
				w3_rec_var0.channels),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_CustomEmojiId),
				w3_rec_var0.customEmojis),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name)
			]));
};
var $author$project$Evergreen$V419$Discord$w3_encode_StickerFormatType = function (w3v) {
	switch (w3v) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Evergreen$V419$Discord$w3_encode_StickerId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Sticker$w3_encode_StickerUrl = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_StickerId, v0)
					]));
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$FileStatus$w3_encode_FileHash(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
						$author$project$Evergreen$V419$Coord$w3_encode_Coord($author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels),
						v1)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V419$Sticker$w3_encode_StickerData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Discord$w3_encode_StickerFormatType(w3_rec_var0.format),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
				$author$project$Evergreen$V419$Sticker$w3_encode_StickerUrl(w3_rec_var0.url)
			]));
};
var $author$project$Evergreen$V419$Types$w3_encode_ServerChange = function (w3v) {
	switch (w3v.$) {
		case 30:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_GuildOrDmId(v1),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v2),
						$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji(v3)
					]));
		case 73:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$LocalState$w3_encode_LastBackup(v0)
					]));
		case 31:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$Id$w3_encode_GuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v1),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v2),
						$author$project$Evergreen$V419$NonemptySet$w3_encode_NonemptySet$(
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
						v3)
					]));
		case 33:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V419$Id$w3_encode_GuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v2)
					]));
		case 32:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V419$Id$w3_encode_GuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v1),
						A2(
						$author$project$Evergreen$V419$Message$w3_encode_CallRecordingFile,
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
						v2)
					]));
		case 34:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V419$Id$w3_encode_GuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V419$Message$w3_encode_CallRecordingZip(v2)
					]));
		case 60:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Evergreen$V419$SessionIdHash$w3_encode_SessionIdHash(v0),
						$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId(v1),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v2)
					]));
		case 59:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Evergreen$V419$SessionIdHash$w3_encode_SessionIdHash(v0),
						$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId(v1),
						$author$project$Evergreen$V419$UserSession$w3_encode_Viewing(v2)
					]));
		case 19:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelId, v1)
					]));
		case 21:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0)
					]));
		case 23:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$SecretId$w3_encode_SecretId$($author$project$Evergreen$V419$Id$w3_encode_InviteLinkId, v1)
					]));
		case 44:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 109:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v1),
						$author$project$Evergreen$V419$Id$w3_encode_Viewing_DmId(v2)
					]));
		case 37:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId, v1),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v2),
						$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji(v3)
					]));
		case 36:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, v2),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v3),
						$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji(v4)
					]));
		case 101:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$UserSession$w3_encode_DiscordFrontendUser(v1)
					]));
		case 64:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v2),
						$author$project$Evergreen$V419$ChannelName$w3_encode_ChannelName(v3),
						$author$project$Evergreen$V419$Discord$w3_encode_OptionalData$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$codecs$Lamdera$Wire3$encodeString),
						v4),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V419$Discord$w3_encode_Overwrite, v5)
					]));
		case 81:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, v1)
					]));
		case 47:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v1)
					]));
		case 45:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(19),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v2)
					]));
		case 65:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(20),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId, v0),
						$author$project$Evergreen$V419$NonemptyDict$w3_encode_NonemptyDict$(
						$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
						function (w3_rec_var0) {
							return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
								_List_fromArray(
									[
										$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.messagesSent)
									]));
						},
						v1)
					]));
		case 66:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(21),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v1)
					]));
		case 29:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(22),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v1),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId, v2)
					]));
		case 46:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(23),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v2)
					]));
		case 78:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(24),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V419$LocalState$w3_encode_DiscordFrontendGuild(v2)
					]));
		case 79:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(25),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v1)
					]));
		case 86:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(26),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, v2),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v3),
						$author$project$Evergreen$V419$PersonName$w3_encode_PersonName(v4),
						$author$project$Evergreen$V419$UserColor$w3_encode_UserColor(v5)
					]));
		case 28:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(27),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v1),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v2),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, v3),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRoute(v4)
					]));
		case 67:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(28),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0)
					]));
		case 39:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(29),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId, v1),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v2),
						$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji(v3)
					]));
		case 38:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(30),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, v2),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v3),
						$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji(v4)
					]));
		case 42:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(31),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Id$w3_encode_Viewing_DiscordDmId(v1),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v2),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2(
							$author$project$Evergreen$V419$RichText$w3_encode_RichText,
							$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
							$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_ChannelId)),
						v3)
					]));
		case 41:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(32),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v1),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v2),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, v3),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v4),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2(
							$author$project$Evergreen$V419$RichText$w3_encode_RichText,
							$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
							$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_ChannelId)),
						v5)
					]));
		case 80:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(33),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V419$Discord$w3_encode_OptionalData$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$codecs$Lamdera$Wire3$encodeString),
						v2),
						$author$project$Evergreen$V419$Discord$w3_encode_OptionalData$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$codecs$Lamdera$Wire3$encodeString),
						v3),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V419$Discord$w3_encode_Overwrite, v4)
					]));
		case 82:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(34),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$GuildName$w3_encode_GuildName(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$FileStatus$w3_encode_FileHash, v2),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_RoleId),
						$author$project$Evergreen$V419$LocalState$w3_encode_DiscordRole,
						v3)
					]));
		case 84:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(35),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v0),
						$lamdera$containers$SeqSet$encodeSet$(
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_CustomEmojiId),
						v1)
					]));
		case 83:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(36),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_RoleId, v1),
						$author$project$Evergreen$V419$LocalState$w3_encode_DiscordRole(v2)
					]));
		case 68:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(37),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$(
						$lamdera$program_test$Effect$Time$w3_encode_Posix,
						function (w3_rec_var0) {
							return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
								_List_fromArray(
									[
										$lamdera$containers$SeqDict$encodeDict$(
										$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId),
										$author$project$Evergreen$V419$DmChannel$w3_encode_DiscordFrontendDmChannel,
										w3_rec_var0.discordDms),
										$lamdera$containers$SeqDict$encodeDict$(
										$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_GuildId),
										$author$project$Evergreen$V419$LocalState$w3_encode_DiscordFrontendGuild,
										w3_rec_var0.discordGuilds),
										$lamdera$containers$SeqDict$encodeDict$(
										$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
										$author$project$Evergreen$V419$UserSession$w3_encode_DiscordFrontendUser,
										w3_rec_var0.discordUsers),
										$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.markEverythingAsViewed)
									]));
						},
						v1)
					]));
		case 15:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			var v6 = w3v.g;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(38),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Id$w3_encode_DiscordGuildOrDmId(v1),
						$author$project$Evergreen$V419$UserSession$w3_encode_DiscordFrontendUser(v2),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2(
							$author$project$Evergreen$V419$RichText$w3_encode_RichText,
							$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
							$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_ChannelId)),
						v3),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMaybeMessage(v4),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$FileStatus$w3_encode_FileId),
						$author$project$Evergreen$V419$FileStatus$w3_encode_FileData,
						v5),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_StickerId),
						$author$project$Evergreen$V419$Sticker$w3_encode_StickerData,
						v6)
					]));
		case 91:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(39),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId(v1),
						$author$project$Evergreen$V419$Drawing$w3_encode_AnchorType(v2),
						$author$project$Evergreen$V419$Drawing$w3_encode_LocalChange(v3)
					]));
		case 105:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(40),
						$author$project$Evergreen$V419$Id$w3_encode_Viewing_DmId(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v1)
					]));
		case 103:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(41),
						$author$project$Evergreen$V419$Id$w3_encode_Viewing_DmId(v0)
					]));
		case 104:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(42),
						$author$project$Evergreen$V419$Id$w3_encode_Viewing_DmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v1)
					]));
		case 102:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(43),
						$author$project$Evergreen$V419$Id$w3_encode_Viewing_DmId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
						$author$project$Evergreen$V419$SessionIdHash$w3_encode_SessionIdHash,
						v1)
					]));
		case 18:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(44),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V419$ChannelName$w3_encode_ChannelName(v2),
						$author$project$Evergreen$V419$ChannelDescription$w3_encode_ChannelDescription(v3)
					]));
		case 20:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(45),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$GuildName$w3_encode_GuildName(v1)
					]));
		case 90:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(46),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_GuildOrDmId(v1),
						$author$project$Evergreen$V419$Game$w3_encode_LocalChange(v2)
					]));
		case 77:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(47),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v1),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$elm$url$Url$w3_encode_Url,
						A2($lamdera$codecs$Lamdera$Wire3$encodeResult, $lamdera$codecs$Lamdera$Wire3$encodeUnit, $author$project$Evergreen$V419$Embed$w3_encode_EmbedData),
						v2)
					]));
		case 76:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(48),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v2),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$elm$url$Url$w3_encode_Url,
						A2($lamdera$codecs$Lamdera$Wire3$encodeResult, $lamdera$codecs$Lamdera$Wire3$encodeUnit, $author$project$Evergreen$V419$Embed$w3_encode_EmbedData),
						v3)
					]));
		case 75:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(49),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v1),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$elm$url$Url$w3_encode_Url,
						A2($lamdera$codecs$Lamdera$Wire3$encodeResult, $lamdera$codecs$Lamdera$Wire3$encodeUnit, $author$project$Evergreen$V419$Embed$w3_encode_EmbedData),
						v2)
					]));
		case 74:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(50),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v2),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$elm$url$Url$w3_encode_Url,
						A2($lamdera$codecs$Lamdera$Wire3$encodeResult, $lamdera$codecs$Lamdera$Wire3$encodeUnit, $author$project$Evergreen$V419$Embed$w3_encode_EmbedData),
						v3)
					]));
		case 17:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(51),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V419$LocalState$w3_encode_FrontendChannel(v2)
					]));
		case 62:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(52),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$LinkedAndOtherDiscordUsers$w3_encode_DiscordFrontendCurrentUser(v1)
					]));
		case 88:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(53),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_CustomEmojiId),
						$author$project$Evergreen$V419$CustomEmoji$w3_encode_CustomEmojiData,
						v0)
					]));
		case 87:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(54),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_StickerId),
						$author$project$Evergreen$V419$Sticker$w3_encode_StickerData,
						v0)
					]));
		case 71:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(55),
						$author$project$Evergreen$V419$Pages$Admin$w3_encode_InitAdminData(v0)
					]));
		case 70:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(56),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
						$author$project$Evergreen$V419$LocalState$w3_encode_LoadingDiscordChannel($lamdera$codecs$Lamdera$Wire3$encodeInt),
						v1)
					]));
		case 58:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(57),
						$author$project$Evergreen$V419$SessionIdHash$w3_encode_SessionIdHash(v0)
					]));
		case 43:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(58),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v1),
						$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId(v2),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v3)
					]));
		case 24:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(59),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v1),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v2),
						$author$project$Evergreen$V419$User$w3_encode_FrontendUser(v3)
					]));
		case 25:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(60),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v1)
					]));
		case 27:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(61),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v1),
						$author$project$Evergreen$V419$Id$w3_encode_GuildOrDmId(v2),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRoute(v3)
					]));
		case 16:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(62),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v1),
						$author$project$Evergreen$V419$ChannelName$w3_encode_ChannelName(v2),
						$author$project$Evergreen$V419$ChannelDescription$w3_encode_ChannelDescription(v3)
					]));
		case 22:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(63),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v1),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v2),
						$author$project$Evergreen$V419$SecretId$w3_encode_SecretId$($author$project$Evergreen$V419$Id$w3_encode_InviteLinkId, v3)
					]));
		case 72:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(64),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Log$w3_encode_Log(v1)
					]));
		case 57:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(65),
						$author$project$Evergreen$V419$SessionIdHash$w3_encode_SessionIdHash(v0),
						$author$project$Evergreen$V419$UserSession$w3_encode_FrontendUserSession(v1)
					]));
		case 56:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(66),
						$author$project$Evergreen$V419$Ports$w3_encode_SubscribeData(v0),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v1)
					]));
		case 52:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(67),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 35:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(68),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_GuildOrDmId(v1),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v2),
						$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji(v3)
					]));
		case 40:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(69),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v1),
						$author$project$Evergreen$V419$Id$w3_encode_GuildOrDmId(v2),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v3),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2(
							$author$project$Evergreen$V419$RichText$w3_encode_RichText,
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId)),
						v4),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$FileStatus$w3_encode_FileId),
						$author$project$Evergreen$V419$FileStatus$w3_encode_FileData,
						v5)
					]));
		case 108:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(70),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v1),
						$author$project$Evergreen$V419$Id$w3_encode_Viewing_DmId(v2),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v3),
						$lamdera$containers$SeqSet$encodeSet$($author$project$Evergreen$V419$FileStatus$w3_encode_FileHash, v4),
						$author$project$Evergreen$V419$Encryption$w3_encode_EncryptedData$(
						$author$project$Evergreen$V419$Message$w3_encode_MessageContent$(
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId)),
						v5)
					]));
		case 107:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(71),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Evergreen$V419$Encryption$w3_encode_EncryptedData$(
									$author$project$Evergreen$V419$Message$w3_encode_MessageContent$(
										$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
										$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId)),
									w3_rec_var0.content),
									$lamdera$containers$SeqSet$encodeSet$($author$project$Evergreen$V419$FileStatus$w3_encode_FileHash, w3_rec_var0.fileHashes),
									$author$project$Evergreen$V419$Id$w3_encode_Viewing_DmId(w3_rec_var0.id),
									$author$project$Evergreen$V419$Types$w3_encode_RepliedToData(w3_rec_var0.repliedToData),
									$author$project$Evergreen$V419$User$w3_encode_FrontendUser(w3_rec_var0.sender),
									$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, w3_rec_var0.senderId),
									$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.sentAt),
									$author$project$Evergreen$V419$Message$w3_encode_ThreadRouteWithRepliedTo(w3_rec_var0.threadRoute)
								]));
					}(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(72),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$containers$SeqDict$encodeDict$(
									$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$FileStatus$w3_encode_FileId),
									$author$project$Evergreen$V419$FileStatus$w3_encode_FileData,
									w3_rec_var0.attachedFiles),
									$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
									A2(
										$author$project$Evergreen$V419$RichText$w3_encode_RichText,
										$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
										$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId)),
									w3_rec_var0.content),
									$author$project$Evergreen$V419$Id$w3_encode_GuildOrDmId(w3_rec_var0.guildOrDmId),
									$author$project$Evergreen$V419$Types$w3_encode_RepliedToData(w3_rec_var0.repliedToData),
									$author$project$Evergreen$V419$User$w3_encode_FrontendUser(w3_rec_var0.sender),
									$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, w3_rec_var0.senderId),
									$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.sentAt),
									$lamdera$containers$SeqDict$encodeDict$(
									$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_StickerId),
									$author$project$Evergreen$V419$Sticker$w3_encode_StickerData,
									w3_rec_var0.stickers),
									$author$project$Evergreen$V419$Message$w3_encode_ThreadRouteWithRepliedTo(w3_rec_var0.threadRoute)
								]));
					}(v0)
					]));
		case 54:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(73),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$User$w3_encode_NotificationLevel(v1)
					]));
		case 51:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(74),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$FileStatus$w3_encode_FileHash, v1)
					]));
		case 53:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(75),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$User$w3_encode_NotificationLevel(v1)
					]));
		case 92:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(76),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(v2)
					]));
		case 94:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(77),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(v2)
					]));
		case 97:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(78),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(v1)
					]));
		case 95:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(79),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v2),
						$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(v3)
					]));
		case 96:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(80),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(v1)
					]));
		case 99:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(81),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_TeamId, v0),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(v2)
					]));
		case 100:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(82),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_TeamId, v0),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v2),
						$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(v3)
					]));
		case 98:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(83),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_TeamId, v0),
						$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(v1)
					]));
		case 93:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(84),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v2),
						$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(v3)
					]));
		case 48:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(85),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$PersonName$w3_encode_PersonName(v1)
					]));
		case 106:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(86),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$X25519$w3_encode_PublicKey(v1)
					]));
		case 55:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(87),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_TeamId, v0),
						$author$project$Evergreen$V419$User$w3_encode_NotificationLevel(v1)
					]));
		case 49:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(88),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$UserColor$w3_encode_UserColor(v1)
					]));
		case 50:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(89),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$FileStatus$w3_encode_FileHash, v1)
					]));
		case 13:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(90),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_SlackGuildOrDmId(v1),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v2),
						$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji(v3)
					]));
		case 7:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(91),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_TeamId, v0),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V419$ChannelName$w3_encode_ChannelName(v2)
					]));
		case 12:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(92),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_TeamId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_CustomEmojiId, v1),
						$author$project$Evergreen$V419$CustomEmoji$w3_encode_CustomEmojiData(v2)
					]));
		case 11:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(93),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_CustomEmojiId),
						$author$project$Evergreen$V419$CustomEmoji$w3_encode_CustomEmojiData,
						v0)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(94),
						$author$project$Evergreen$V419$Id$w3_encode_SlackGuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(95),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_UserId, v1),
						$author$project$Evergreen$V419$Id$w3_encode_SlackGuildOrDmId(v2),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v3),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2(
							$author$project$Evergreen$V419$RichText$w3_encode_RichText,
							$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_UserId),
							$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_ChannelId)),
						v4)
					]));
		case 9:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(96),
						$author$project$Evergreen$V419$Id$w3_encode_SlackGuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v1),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$elm$url$Url$w3_encode_Url,
						A2($lamdera$codecs$Lamdera$Wire3$encodeResult, $lamdera$codecs$Lamdera$Wire3$encodeUnit, $author$project$Evergreen$V419$Embed$w3_encode_EmbedData),
						v2)
					]));
		case 10:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(97),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_TeamId, v1),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$containers$SeqDict$encodeDict$(
									$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_CustomEmojiId),
									$author$project$Evergreen$V419$CustomEmoji$w3_encode_CustomEmojiData,
									w3_rec_var0.customEmojis),
									$lamdera$containers$SeqDict$encodeDict$(
									$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_DmChannelId),
									$author$project$Evergreen$V419$LocalState$w3_encode_SlackFrontendDmChannel,
									w3_rec_var0.dmChannels),
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.markNewDmsAsViewed),
									$lamdera$containers$SeqDict$encodeDict$(
									$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_UserId),
									$author$project$Evergreen$V419$UserSession$w3_encode_SlackFrontendUser,
									w3_rec_var0.users),
									$lamdera$containers$SeqDict$encodeDict$(
									$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_TeamId),
									$author$project$Evergreen$V419$LocalState$w3_encode_SlackFrontendWorkspace,
									w3_rec_var0.workspaces)
								]));
					}(v2)
					]));
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(98),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_UserId, v0)
					]));
		case 14:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(99),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_SlackGuildOrDmId(v1),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v2),
						$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji(v3)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(100),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Id$w3_encode_SlackGuildOrDmId(v1),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRoute(v2),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2(
							$author$project$Evergreen$V419$RichText$w3_encode_RichText,
							$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_UserId),
							$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_ChannelId)),
						v3),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$FileStatus$w3_encode_FileId),
						$author$project$Evergreen$V419$FileStatus$w3_encode_FileData,
						v4),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
						A3(
							$author$project$Evergreen$V419$Message$w3_encode_Message,
							$author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId,
							$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_UserId),
							$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_ChannelId)),
						v5)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(101),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_UserId, v0)
					]));
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(102),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$UserSession$w3_encode_SlackFrontendUser(v1)
					]));
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(103),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_TeamId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 69:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(104),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v1)
					]));
		case 61:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(105),
						$author$project$Evergreen$V419$TextEditor$w3_encode_ServerChange(v0)
					]));
		case 63:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(106),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0)
					]));
		case 85:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(107),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$MembersAndOwner$w3_encode_MembersAndOwner$(
						$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
						function (w3_rec_var0) {
							return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
								_List_fromArray(
									[
										$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.joinedAt),
										$lamdera$containers$SeqSet$encodeSet$(
										$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_RoleId),
										w3_rec_var0.roles)
									]));
						},
						v1)
					]));
		case 89:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(108),
						$author$project$Evergreen$V419$Call$w3_encode_ServerChange(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(109),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$(
						$author$project$Evergreen$V419$LocalState$w3_encode_JoinGuildError,
						function (w3_rec_var0) {
							return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
								_List_fromArray(
									[
										$author$project$Evergreen$V419$LocalState$w3_encode_FrontendGuild(w3_rec_var0.guild),
										$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, w3_rec_var0.guildId),
										$lamdera$containers$SeqDict$encodeDict$(
										$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
										$author$project$Evergreen$V419$User$w3_encode_FrontendUser,
										w3_rec_var0.members),
										$author$project$Evergreen$V419$User$w3_encode_FrontendUser(w3_rec_var0.owner)
									]));
						},
						v0)
					]));
	}
};
var $author$project$Evergreen$V419$Types$w3_encode_LocalMsg = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0),
					$author$project$Evergreen$V419$Types$w3_encode_LocalChange(v1)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V419$Types$w3_encode_ServerChange(v0)
				]));
	}
};
var $author$project$Evergreen$V419$LocalState$w3_encode_AdminDataStatus$ = function (w3_x_c_a, w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						w3_x_c_a(v0)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V419$LocalState$w3_encode_AdminDataStatus = F2($author$project$Evergreen$V419$LocalState$w3_encode_AdminDataStatus$);
var $author$project$Evergreen$V419$LocalState$w3_encode_DeleteOrphanedFilesStatus = function (w3v) {
	switch (w3v.$) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V419$LocalState$w3_encode_ServerSecretStatus = function (w3v) {
	switch (w3v.$) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v0)
					]));
	}
};
var $author$project$Evergreen$V419$LocalState$w3_encode_AdminData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$LocalState$w3_encode_AdminDataStatus$(
				$lamdera$codecs$Lamdera$Wire3$encodeArray($author$project$Evergreen$V419$BackendMsgLog$w3_encode_BackendMsgLogData),
				w3_rec_var0.backendMsgLogs),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V419$SessionIdHash$w3_encode_SessionIdHash,
					A2($author$project$Evergreen$V419$NonemptyDict$w3_encode_NonemptyDict, $lamdera$program_test$Effect$Lamdera$w3_encode_ClientId, $author$project$Evergreen$V419$LocalState$w3_encode_ConnectionData)),
				w3_rec_var0.connections),
				$author$project$Evergreen$V419$LocalState$w3_encode_DeleteOrphanedFilesStatus(w3_rec_var0.deleteOrphanedFiles),
				$author$project$Evergreen$V419$LocalState$w3_encode_AdminDataStatus$(
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_GuildId),
					$author$project$Evergreen$V419$LocalState$w3_encode_AdminData_DeletedGuild),
				w3_rec_var0.deletedGuilds),
				$author$project$Evergreen$V419$LocalState$w3_encode_AdminDataStatus$(
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId),
					$author$project$Evergreen$V419$LocalState$w3_encode_AdminData_DiscordDmChannel),
				w3_rec_var0.discordDmChannels),
				$author$project$Evergreen$V419$LocalState$w3_encode_AdminDataStatus$(
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_GuildId),
					$author$project$Evergreen$V419$LocalState$w3_encode_AdminData_DiscordGuild),
				w3_rec_var0.discordGuilds),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.discordLinkLimit),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.discordLinkingEnabled),
				$author$project$Evergreen$V419$LocalState$w3_encode_AdminDataStatus$(
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
					$author$project$Evergreen$V419$LocalState$w3_encode_DiscordUserData_ForAdmin),
				w3_rec_var0.discordUsers),
				$author$project$Evergreen$V419$LocalState$w3_encode_AdminDataStatus$(
				A2($lamdera$containers$SeqDict$encodeDict, $author$project$Evergreen$V419$DmChannelId$w3_encode_DmChannelId, $author$project$Evergreen$V419$LocalState$w3_encode_AdminData_DmChannel),
				w3_rec_var0.dmChannels),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.emailNotificationsEnabled),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.filesCount),
				$author$project$Evergreen$V419$LocalState$w3_encode_AdminDataStatus$(
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_GuildId),
					$author$project$Evergreen$V419$LocalState$w3_encode_AdminData_Guild),
				w3_rec_var0.guilds),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$LocalState$w3_encode_LastBackup, w3_rec_var0.lastBackup),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
				$author$project$Evergreen$V419$LocalState$w3_encode_LoadingDiscordChannel($lamdera$codecs$Lamdera$Wire3$encodeInt),
				w3_rec_var0.loadingDiscordChannels),
				A2($author$project$Evergreen$V419$Pagination$w3_encode_Pagination, $author$project$Evergreen$V419$LocalState$w3_encode_LogWithTime, w3_rec_var0.logs),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				w3_rec_var0.notifyAdminsBotUserId),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.notifyAdminsToken),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.openRouterKey),
				$author$project$Evergreen$V419$LocalState$w3_encode_AdminDataStatus$(
				A2($lamdera$containers$SeqDict$encodeDict, $author$project$Evergreen$V419$FileStatus$w3_encode_FileHash, $author$project$Evergreen$V419$FileStatus$w3_encode_BackendFileData),
				w3_rec_var0.orphanedFiles),
				$author$project$Evergreen$V419$Postmark$w3_encode_ApiKey(w3_rec_var0.postmarkKey),
				$author$project$Evergreen$V419$LocalState$w3_encode_PrivateVapidKey(w3_rec_var0.privateVapidKey),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeString, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				w3_rec_var0.seqDictWorks),
				$author$project$Evergreen$V419$LocalState$w3_encode_ServerSecretStatus(w3_rec_var0.serverSecretRefreshedAt),
				$author$project$Evergreen$V419$LocalState$w3_encode_AdminDataStatus$(
				A2($lamdera$containers$SeqDict$encodeDict, $author$project$Evergreen$V419$SessionIdHash$w3_encode_SessionIdHash, $author$project$Evergreen$V419$UserSession$w3_encode_UserSession),
				w3_rec_var0.sessions),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.signupsEnabled),
				$author$project$Evergreen$V419$LocalState$w3_encode_AdminDataStatus$(
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_DmChannelId),
					$author$project$Evergreen$V419$LocalState$w3_encode_AdminData_SlackDmChannel),
				w3_rec_var0.slackDmChannels),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.slackLinkLimit),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.slackLinkingEnabled),
				$author$project$Evergreen$V419$LocalState$w3_encode_AdminDataStatus$(
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_TeamId),
					$author$project$Evergreen$V419$LocalState$w3_encode_AdminData_SlackWorkspace),
				w3_rec_var0.slackWorkspaces),
				$author$project$Evergreen$V419$LocalState$w3_encode_AdminDataStatus$(
				$lamdera$codecs$Lamdera$Wire3$encodeArray($author$project$Evergreen$V419$ToBackendLog$w3_encode_ToBackendLogData),
				w3_rec_var0.toBackendLogs),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				$lamdera$program_test$Effect$Time$w3_encode_Posix,
				w3_rec_var0.twoFactorAuthentication),
				$author$project$Evergreen$V419$LocalState$w3_encode_AdminDataStatus$(
				A2(
					$author$project$Evergreen$V419$NonemptyDict$w3_encode_NonemptyDict,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
					$author$project$Evergreen$V419$User$w3_encode_BackendUser),
				w3_rec_var0.users),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.vulnerabilityChecks),
				$author$project$Evergreen$V419$LocalState$w3_encode_AdminDataStatus$(
				$lamdera$codecs$Lamdera$Wire3$encodeArray($author$project$Evergreen$V419$LocalState$w3_encode_WebsocketClosedEvent),
				w3_rec_var0.websocketCloseEvents),
				$author$project$Evergreen$V419$LocalState$w3_encode_WordSpellingGameStatus(w3_rec_var0.wordSpellingGameEnglish),
				$author$project$Evergreen$V419$LocalState$w3_encode_WordSpellingGameStatus(w3_rec_var0.wordSpellingGameSwedish)
			]));
};
var $author$project$Evergreen$V419$LocalState$w3_encode_AdminStatus = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$LocalState$w3_encode_AdminData(v0)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V419$DmChannel$w3_encode_E2eeEnabledData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.enabledAt),
				$lamdera$codecs$Lamdera$Wire3$encodePair$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				$author$project$Evergreen$V419$SessionIdHash$w3_encode_SessionIdHash,
				w3_rec_var0.requestedBy)
			]));
};
var $author$project$Evergreen$V419$DmChannel$w3_encode_E2eeStatus = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
						A2(
							$lamdera$codecs$Lamdera$Wire3$encodePair,
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
							$lamdera$program_test$Effect$Time$w3_encode_Posix),
						v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$DmChannel$w3_encode_E2eeEnabledData(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
						$author$project$Evergreen$V419$SessionIdHash$w3_encode_SessionIdHash,
						v0)
					]));
	}
};
var $author$project$Evergreen$V419$DmChannel$w3_encode_FrontendDmChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$justinmimbs$date$Date$w3_encode_Date,
				$author$project$Evergreen$V419$Drawing$w3_encode_Drawing(
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId)),
				w3_rec_var0.dateDividerDrawings),
				$author$project$Evergreen$V419$DmChannel$w3_encode_E2eeStatus(w3_rec_var0.e2ee),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
				$author$project$Evergreen$V419$Game$w3_encode_MatchData,
				w3_rec_var0.games),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMaybeMessage(w3_rec_var1.threadRoute),
								$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var1.time)
							]));
				},
				w3_rec_var0.lastTypedAt),
				$author$project$Evergreen$V419$MessageArray$w3_encode_MessageArray$(
				$author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId,
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId),
				w3_rec_var0.messages),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
				$author$project$Evergreen$V419$Thread$w3_encode_FrontendThread,
				w3_rec_var0.threads),
				A2($author$project$Evergreen$V419$VisibleMessages$w3_encode_VisibleMessages, $author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, w3_rec_var0.visibleMessages)
			]));
};
var $author$project$Evergreen$V419$Call$w3_encode_Local = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Call$w3_encode_CallId, w3_rec_var0.currentRoom),
				$lamdera$containers$SeqDict$encodeDict$($author$project$Evergreen$V419$Call$w3_encode_CallId, $author$project$Evergreen$V419$Call$w3_encode_RecordingStatus, w3_rec_var0.recordings),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Call$w3_encode_CallId,
				A2(
					$author$project$Evergreen$V419$NonemptyDict$w3_encode_NonemptyDict,
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
						$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId),
					$author$project$Evergreen$V419$Call$w3_encode_RemoteCallData),
				w3_rec_var0.voiceChats)
			]));
};
var $author$project$Evergreen$V419$TextEditor$w3_encode_LocalState = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				$author$project$Evergreen$V419$Range$w3_encode_Range,
				w3_rec_var0.cursorPosition),
				$lamdera$codecs$Lamdera$Wire3$encodeArray$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
					$author$project$Evergreen$V419$TextEditor$w3_encode_EditChange),
				w3_rec_var0.history),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				$lamdera$codecs$Lamdera$Wire3$encodeInt,
				w3_rec_var0.undoPoint)
			]));
};
var $author$project$Evergreen$V419$User$w3_encode_FrontendCurrentUser = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_CustomEmojiId),
				w3_rec_var0.availableCustomEmojis),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_StickerId),
				w3_rec_var0.availableStickers),
				$author$project$Evergreen$V419$UserColor$w3_encode_UserColor(w3_rec_var0.color),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.createdAt),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.deleteAccountAt),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_GuildId),
				A2(
					$author$project$Evergreen$V419$NonemptyDict$w3_encode_NonemptyDict,
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRoute),
					$author$project$Evergreen$V419$OneOrGreater$w3_encode_OneOrGreater),
				w3_rec_var0.directMentions),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_GuildId),
				A2(
					$author$project$Evergreen$V419$NonemptyDict$w3_encode_NonemptyDict,
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_ChannelId),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRoute),
					$author$project$Evergreen$V419$OneOrGreater$w3_encode_OneOrGreater),
				w3_rec_var0.discordDirectMentions),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_GuildId),
				w3_rec_var0.discordNotifyOnAllMessages),
				$lamdera$containers$SeqSet$encodeSet$($author$project$Evergreen$V419$RichText$w3_encode_Domain, w3_rec_var0.domainWhitelist),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.e2eeRisksAccepted),
				$author$project$Evergreen$V419$EmailAddress$w3_encode_EmailAddress(w3_rec_var0.email),
				$author$project$Evergreen$V419$User$w3_encode_EmailNotifications(w3_rec_var0.emailNotifications),
				$author$project$Evergreen$V419$User$w3_encode_EmbedVisibility(w3_rec_var0.embedVisibility),
				$author$project$Evergreen$V419$Emoji$w3_encode_EmojiConfig(w3_rec_var0.emojiConfig),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isAdmin),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_GuildId),
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId),
					$author$project$Evergreen$V419$Id$w3_encode_ThreadRoute),
				w3_rec_var0.lastChannelViewed),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_GuildId),
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_ChannelId),
					$author$project$Evergreen$V419$Id$w3_encode_ThreadRoute),
				w3_rec_var0.lastDiscordChannelViewed),
				$author$project$Evergreen$V419$User$w3_encode_LastDmViewed(w3_rec_var0.lastDmViewed),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.lastEmailNotification),
				$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Pagination$w3_encode_PageId, w3_rec_var0.lastLogPageViewed),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.lastPushNotification),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_TeamId),
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_ChannelId),
					$author$project$Evergreen$V419$Id$w3_encode_ThreadRoute),
				w3_rec_var0.lastSlackChannelViewed),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId,
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
				w3_rec_var0.lastViewedMessage),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId)),
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId),
				w3_rec_var0.lastViewedThreadMessage),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.linkDiscordAcknowledgementIsChecked),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.linkSlackAcknowledgementIsChecked),
				$author$project$Evergreen$V419$MuteSettings$w3_encode_Model(w3_rec_var0.muteSettings),
				$author$project$Evergreen$V419$PersonName$w3_encode_PersonName(w3_rec_var0.name),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_GuildId),
				w3_rec_var0.notifyOnAllMessages),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$X25519$w3_encode_PublicKey, w3_rec_var0.publicKey),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.recentLoginEmails),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_TeamId),
				A2(
					$author$project$Evergreen$V419$NonemptyDict$w3_encode_NonemptyDict,
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_ChannelId),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRoute),
					$author$project$Evergreen$V419$OneOrGreater$w3_encode_OneOrGreater),
				w3_rec_var0.slackDirectMentions),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_TeamId),
				w3_rec_var0.slackNotifyOnAllMessages)
			]));
};
var $author$project$Evergreen$V419$LinkedAndOtherDiscordUsers$w3_encode_LinkedAndOtherDiscordUsers = function (w3v) {
	var v0 = w3v.a;
	var v1 = w3v.b;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
				$author$project$Evergreen$V419$UserSession$w3_encode_DiscordFrontendUser,
				v0),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_UserId),
				$author$project$Evergreen$V419$LinkedAndOtherDiscordUsers$w3_encode_DiscordFrontendCurrentUser,
				v1)
			]));
};
var $author$project$Evergreen$V419$User$w3_encode_LocalUser = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$UserSession$w3_encode_Viewing(w3_rec_var0.currentlyViewing),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_CustomEmojiId),
				$author$project$Evergreen$V419$CustomEmoji$w3_encode_CustomEmojiData,
				w3_rec_var0.customEmojis),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Encryption$w3_encode_BytesHash,
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodeResult,
					$lamdera$codecs$Lamdera$Wire3$encodeUnit,
					$author$project$Evergreen$V419$Message$w3_encode_MessageContent$(
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId))),
				w3_rec_var0.decryptedMessages),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.devicePixelRatio),
				$author$project$Evergreen$V419$LinkedAndOtherDiscordUsers$w3_encode_LinkedAndOtherDiscordUsers(w3_rec_var0.discordUsers),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Emoji$w3_encode_CachedEmojiData, w3_rec_var0.emojiData),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_UserId),
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_TeamId),
				w3_rec_var0.linkedSlackUsers),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				$author$project$Evergreen$V419$User$w3_encode_FrontendUser,
				w3_rec_var0.otherUsers),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.safeAreaInsetBottom),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.safeAreaInsetTop),
				$author$project$Evergreen$V419$UserSession$w3_encode_UserSession(w3_rec_var0.session),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_UserId),
				$author$project$Evergreen$V419$UserSession$w3_encode_SlackFrontendUser,
				w3_rec_var0.slackUsers),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_UserId),
				w3_rec_var0.slackUsersNeedingAuth),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_StickerId),
				$author$project$Evergreen$V419$Sticker$w3_encode_StickerData,
				w3_rec_var0.stickers),
				$lamdera$program_test$Effect$Time$w3_encode_Zone(w3_rec_var0.timezone),
				$author$project$Evergreen$V419$User$w3_encode_FrontendCurrentUser(w3_rec_var0.user),
				$author$project$Evergreen$V419$UserAgent$w3_encode_UserAgent(w3_rec_var0.userAgent)
			]));
};
var $author$project$Evergreen$V419$LocalState$w3_encode_LocalState = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$LocalState$w3_encode_AdminStatus(w3_rec_var0.adminData),
				$author$project$Evergreen$V419$Call$w3_encode_Local(w3_rec_var0.calls),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId),
				$author$project$Evergreen$V419$DmChannel$w3_encode_DiscordFrontendDmChannel,
				w3_rec_var0.discordDmChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_GuildId),
				$author$project$Evergreen$V419$LocalState$w3_encode_DiscordFrontendGuild,
				w3_rec_var0.discordGuilds),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				$author$project$Evergreen$V419$DmChannel$w3_encode_FrontendDmChannel,
				w3_rec_var0.dmChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_GuildId),
				$author$project$Evergreen$V419$LocalState$w3_encode_FrontendGuild,
				w3_rec_var0.guilds),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$LocalState$w3_encode_JoinGuildError, w3_rec_var0.joinGuildError),
				$author$project$Evergreen$V419$User$w3_encode_LocalUser(w3_rec_var0.localUser),
				$lamdera$containers$SeqDict$encodeDict$($author$project$Evergreen$V419$SessionIdHash$w3_encode_SessionIdHash, $author$project$Evergreen$V419$UserSession$w3_encode_FrontendUserSession, w3_rec_var0.otherSessions),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.publicVapidKey),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_DmChannelId),
				$author$project$Evergreen$V419$LocalState$w3_encode_SlackFrontendDmChannel,
				w3_rec_var0.slackDmChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_TeamId),
				$author$project$Evergreen$V419$LocalState$w3_encode_SlackFrontendWorkspace,
				w3_rec_var0.slackWorkspaces),
				$author$project$Evergreen$V419$TextEditor$w3_encode_LocalState(w3_rec_var0.textEditor)
			]));
};
var $author$project$Evergreen$V419$Types$w3_encode_MessageHoverMobileMode = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$ianmackenzie$elm_units$Quantity$w3_encode_Quantity$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Types$w3_encode_EditMessage, v1)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$ianmackenzie$elm_units$Quantity$w3_encode_Quantity$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels, w3_rec_var0.offset),
									$ianmackenzie$elm_units$Quantity$w3_encode_Quantity$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels, w3_rec_var0.previousOffset),
									$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.time)
								]));
					}(v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$ianmackenzie$elm_units$Quantity$w3_encode_Quantity$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels, v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$ianmackenzie$elm_units$Quantity$w3_encode_Quantity$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels, w3_rec_var0.offset),
									$ianmackenzie$elm_units$Quantity$w3_encode_Quantity$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels, w3_rec_var0.targetOffset)
								]));
					}(v0)
					]));
	}
};
var $author$project$Evergreen$V419$Types$w3_encode_MessageMenuExtraOptions = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId(w3_rec_var0.guildOrDmId),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.imageUrl),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isThreadStarter),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.linkUrl),
				$author$project$Evergreen$V419$Types$w3_encode_MessageHoverMobileMode(w3_rec_var0.mobileMode),
				A2($author$project$Evergreen$V419$Coord$w3_encode_Coord, $author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels, w3_rec_var0.position),
				$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(w3_rec_var0.threadRoute)
			]));
};
var $author$project$Evergreen$V419$Types$w3_encode_MessageHover = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$Types$w3_encode_MessageMenuExtraOptions(v0)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v2)
					]));
	}
};
var $author$project$Evergreen$V419$Call$w3_encode_DebugRow = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.label),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.value)
			]));
};
var $author$project$Evergreen$V419$Call$w3_encode_DebugSection = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V419$Call$w3_encode_DebugRow, w3_rec_var0.rows),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.title)
			]));
};
var $author$project$Evergreen$V419$IdString$w3_encode_IdString$ = function (w3_x_c_a, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Evergreen$V419$IdString$w3_encode_IdString = F2($author$project$Evergreen$V419$IdString$w3_encode_IdString$);
var $author$project$Evergreen$V419$Call$w3_encode_LocalOrConnection = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$Call$w3_encode_ConnectionId(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$Call$w3_encode_MediaDeviceId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Call$w3_encode_DeviceKind = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V419$Call$w3_encode_MediaDevice = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$IdString$w3_encode_IdString$($author$project$Evergreen$V419$Call$w3_encode_MediaDeviceId, w3_rec_var0.deviceId),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.groupId),
				$author$project$Evergreen$V419$Call$w3_encode_DeviceKind(w3_rec_var0.kind),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.label)
			]));
};
var $author$project$Evergreen$V419$Call$w3_encode_MediaDevicesStatus = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V419$Call$w3_encode_MediaDevice, v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V419$Call$w3_encode_VideoTile = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$Call$w3_encode_LocalOrConnection(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V419$Call$w3_encode_LocalOrConnection(v0)
				]));
	}
};
var $author$project$Evergreen$V419$Call$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V419$Call$w3_encode_DebugSection, w3_rec_var0.debugData),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Call$w3_encode_VideoTile, w3_rec_var0.focusedTile),
				$lamdera$containers$SeqSet$encodeSet$($author$project$Evergreen$V419$Call$w3_encode_ConnectionId, w3_rec_var0.isSpeaking),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.localIsSpeaking),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pollDebugData),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.total),
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.uploaded)
							]));
				},
				w3_rec_var0.recordingUpload),
				$author$project$Evergreen$V419$Call$w3_encode_RemoteCallData(w3_rec_var0.remoteCallData),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V419$IdString$w3_encode_IdString($author$project$Evergreen$V419$Call$w3_encode_MediaDeviceId),
				w3_rec_var0.selectedAudioInputDevice),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V419$IdString$w3_encode_IdString($author$project$Evergreen$V419$Call$w3_encode_MediaDeviceId),
				w3_rec_var0.selectedVideoInputDevice),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showDeviceSettings),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.startConnectionError),
				$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $lamdera$codecs$Lamdera$Wire3$encodeFloat, w3_rec_var0.thumbnailPosition),
				$author$project$Evergreen$V419$Call$w3_encode_MediaDevicesStatus(w3_rec_var0.userMediaDevices),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Call$w3_encode_LocalOrConnection, w3_rec_var0.videoHover),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
					$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat,
				w3_rec_var0.volume)
			]));
};
var $author$project$Evergreen$V419$Drawing$w3_encode_ActiveStroke = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Evergreen$V419$SafeFloat$w3_encode_SafeFloat, $author$project$Evergreen$V419$SafeFloat$w3_encode_SafeFloat),
				w3_rec_var0.unsent)
			]));
};
var $author$project$Evergreen$V419$Drawing$w3_encode_SelectedAnchorData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $lamdera$codecs$Lamdera$Wire3$encodeFloat, w3_rec_var0.anchorHalfSize),
				$author$project$Evergreen$V419$Drawing$w3_encode_AnchorType(w3_rec_var0.anchorType),
				$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId(w3_rec_var0.guildOrDmId),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.pointScale),
				A3($author$project$Evergreen$V419$Point2d$w3_encode_Point2d, $author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels, $author$project$Evergreen$V419$Touch$w3_encode_ScreenCoordinate, w3_rec_var0.position),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Drawing$w3_encode_ActiveStroke, w3_rec_var0.stroke),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.zoom),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.height),
								$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.width),
								$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.x),
								$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.y)
							]));
				},
				w3_rec_var0.zoomContainer)
			]));
};
var $author$project$Evergreen$V419$Drawing$w3_encode_Model = function (w3v) {
	if (!w3v.$) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V419$Drawing$w3_encode_SelectedAnchorData(v0)
				]));
	}
};
var $author$project$Evergreen$V419$Emoji$w3_encode_Category = function (w3v) {
	switch (w3v.$) {
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$Emoji$w3_encode_EmojiCategory(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrSticker = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_CustomEmojiId, v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_StickerId, v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$Emoji$w3_encode_UnicodeEmoji(v0)
					]));
	}
};
var $author$project$Evergreen$V419$Emoji$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Emoji$w3_encode_Category(w3_rec_var0.category),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrSticker(w3_rec_var1.emoji),
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.index)
							]));
				},
				w3_rec_var0.emojiHovered),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.searchText)
			]));
};
var $author$project$Evergreen$V419$Scroll$w3_encode_ScrollPosition = function (w3v) {
	switch (w3v) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Evergreen$V419$SheepGame$w3_encode_UnvalidatedInput = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$FileStatus$w3_encode_FileId),
				$author$project$Evergreen$V419$FileStatus$w3_encode_FileStatus,
				w3_rec_var0.attachedFiles),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.text)
			]));
};
var $author$project$Evergreen$V419$SheepGame$w3_encode_GameData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$IdArray$w3_encode_IdArray$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, $author$project$Evergreen$V419$SheepGame$w3_encode_UnvalidatedInput, w3_rec_var0.answerDrafts),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId)),
				w3_rec_var0.gridHovered),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_QuestionId),
				w3_rec_var0.hoveredQuestion),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$SheepGame$w3_encode_ReactionTarget, w3_rec_var0.hoveredResult),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.newQuestionRevealed),
				$author$project$Evergreen$V419$IdArray$w3_encode_IdArray$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, $author$project$Evergreen$V419$SheepGame$w3_encode_UnvalidatedInput, w3_rec_var0.noteDrafts),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.questionsRevealedSeen),
				$author$project$Evergreen$V419$Scroll$w3_encode_ScrollPosition(w3_rec_var0.scrollPosition)
			]));
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_Drag = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_HoveredMove = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeDict$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				$author$project$Evergreen$V419$WordSpellingGame$w3_encode_LetterOrWildcard,
				w3_rec_var0.cells),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.index),
				$author$project$Evergreen$V419$WordSpellingGame$w3_encode_Shared(w3_rec_var0.shared)
			]));
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_TrayIndex = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_TilePosition = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$WordSpellingGame$w3_encode_TrayIndex(v0),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$program_test$Effect$Time$w3_encode_Posix, $lamdera$codecs$Lamdera$Wire3$encodeInt),
					v1)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt, v0),
					$lamdera$program_test$Effect$Time$w3_encode_Posix(v1)
				]));
	}
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_Tile = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.createdAt),
				$author$project$Evergreen$V419$WordSpellingGame$w3_encode_TilePosition(w3_rec_var0.position)
			]));
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_OpenWordDefinition = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.index),
				$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.words)
			]));
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_DictEntry = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.definitions),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.partOfSpeech)
			]));
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_WordDefinitionData = function (w3v) {
	switch (w3v.$) {
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V419$WordSpellingGame$w3_encode_DictEntry, v0)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
	}
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_WordDefinition = function (w3v) {
	if (!w3v.$) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V419$WordSpellingGame$w3_encode_OpenWordDefinition(v0),
					$author$project$Evergreen$V419$WordSpellingGame$w3_encode_WordDefinitionData(v1)
				]));
	}
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_ZoomState = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.amount),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.focusX),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.focusY)
			]));
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_ZoomAnimation = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$WordSpellingGame$w3_encode_ZoomState(w3_rec_var0.from),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.start)
			]));
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_GameData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$WordSpellingGame$w3_encode_Drag(w3_rec_var0.dragging),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				w3_rec_var0.highlightedPlayer),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$WordSpellingGame$w3_encode_HoveredMove, w3_rec_var0.hoveredMove),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.letterCount),
								$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var1.time)
							]));
				},
				w3_rec_var0.lastWordPlaced),
				$author$project$Evergreen$V419$Scroll$w3_encode_ScrollPosition(w3_rec_var0.scrollPosition),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				w3_rec_var0.selectedCell),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showSettings),
				$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Evergreen$V419$WordSpellingGame$w3_encode_Tile, w3_rec_var0.tiles),
				$author$project$Evergreen$V419$WordSpellingGame$w3_encode_WordDefinition(w3_rec_var0.wordDefinition),
				$author$project$Evergreen$V419$WordSpellingGame$w3_encode_ZoomAnimation(w3_rec_var0.zoomAnimation)
			]));
};
var $author$project$Evergreen$V419$Go$w3_encode_GameModel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.lastError),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.lastPlacedStone),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.viewingMovesBack)
			]));
};
var $author$project$Evergreen$V419$Game$w3_encode_Game = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Go$w3_encode_GameModel(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$SheepGame$w3_encode_GameData(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$WordSpellingGame$w3_encode_GameData(v0)
					]));
	}
};
var $author$project$Evergreen$V419$Go$w3_encode_SizeSelection = function (w3v) {
	switch (w3v) {
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Evergreen$V419$Go$w3_encode_SetupModel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.error),
				$author$project$Evergreen$V419$Go$w3_encode_Stone(w3_rec_var0.gameCreatorPlayingAs),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.handicapInput),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.heightInput),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.incrementInput),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.komiInput),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.mainTimeInput),
				$author$project$Evergreen$V419$Go$w3_encode_SizeSelection(w3_rec_var0.sizeSelection),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.widthInput)
			]));
};
var $author$project$Evergreen$V419$SheepGame$w3_encode_SetupModel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.error),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pressedSubmit),
				$author$project$Evergreen$V419$IdArray$w3_encode_IdArray$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, $author$project$Evergreen$V419$SheepGame$w3_encode_UnvalidatedInput, w3_rec_var0.questions)
			]));
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_SetupModel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.advancedSettingsExpanded),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.error),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.fullTrayBonus),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.incrementInput),
				$author$project$Evergreen$V419$WordSpellingGame$w3_encode_Language(w3_rec_var0.language),
				$lamdera$containers$SeqDict$encodeDict$($lamdera$codecs$Lamdera$Wire3$encodeChar, $lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.letterValues),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.letters),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.mainTimeInput),
				$author$project$Evergreen$V419$OneOrGreater$w3_encode_OneOrGreater(w3_rec_var0.placeWordAttempts),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.traySize)
			]));
};
var $author$project$Evergreen$V419$Game$w3_encode_Setup = function (w3v) {
	switch (w3v.$) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$Go$w3_encode_SetupModel(v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$SheepGame$w3_encode_SetupModel(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V419$WordSpellingGame$w3_encode_SetupModel(v0)
					]));
	}
};
var $author$project$Evergreen$V419$Game$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Game$w3_encode_Setup(w3_rec_var0.setup),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.sheepGameQuestionsCounter),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
					$author$project$Evergreen$V419$SheepGame$w3_encode_Input),
				$lamdera$codecs$Lamdera$Wire3$encodeInt,
				w3_rec_var0.sheepGameSaveCounters),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
				$author$project$Evergreen$V419$Game$w3_encode_Game,
				w3_rec_var0.startedGames)
			]));
};
var $author$project$Evergreen$V419$ImageEditor$w3_encode_DragPart = function (w3v) {
	switch (w3v) {
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
	}
};
var $author$project$Evergreen$V419$ImageEditor$w3_encode_DragState = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.currentX),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.currentY),
				$author$project$Evergreen$V419$ImageEditor$w3_encode_DragPart(w3_rec_var0.dragPart),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.startX),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.startY)
			]));
};
var $author$project$Evergreen$V419$ImageEditor$w3_encode_UploadStatus = function (w3v) {
	switch (w3v.$) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$FileStatus$w3_encode_FileHash(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Evergreen$V419$ImageEditor$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$ImageEditor$w3_encode_DragState, w3_rec_var0.dragState),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				w3_rec_var0.imageSize),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.imageUrl),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.size),
				$author$project$Evergreen$V419$ImageEditor$w3_encode_UploadStatus(w3_rec_var0.status),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.x),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.y)
			]));
};
var $author$project$Evergreen$V419$Pages$Admin$w3_encode_AdminUiSection = function (w3v) {
	switch (w3v) {
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 12:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 13:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 17:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(12);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
		case 15:
			return $elm$bytes$Bytes$Encode$unsignedInt8(14);
		case 14:
			return $elm$bytes$Bytes$Encode$unsignedInt8(15);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(16);
		case 16:
			return $elm$bytes$Bytes$Encode$unsignedInt8(17);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(18);
	}
};
var $author$project$Evergreen$V419$Pages$Admin$w3_encode_DownloadingBackup = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeBytes, w3_rec_var0.chunks),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.receivedBytes),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.totalBytes)
			]));
};
var $author$project$Evergreen$V419$Pages$Admin$w3_encode_ExportProgress = function (w3v) {
	switch (w3v.$) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.encoded),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.total)
								]));
					}(v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.channelsRemaining),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.encoded),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.total)
								]));
					}(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.encoded),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.total)
								]));
					}(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.channelsRemaining),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.encoded),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.total)
								]));
					}(v0)
					]));
	}
};
var $author$project$Evergreen$V419$Pages$Admin$w3_encode_ExportSubsetSelection = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId),
				w3_rec_var0.discordDmChannels),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_GuildId),
				w3_rec_var0.discordGuilds),
				$lamdera$containers$SeqSet$encodeSet$($author$project$Evergreen$V419$DmChannelId$w3_encode_DmChannelId, w3_rec_var0.dmChannels),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_GuildId),
				w3_rec_var0.guilds)
			]));
};
var $author$project$Evergreen$V419$Pages$Admin$w3_encode_ImportBackendStatus = function (w3v) {
	switch (w3v.$) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeBytes(w3_rec_var0.remainingBytes),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.sentBytes),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.totalBytes)
								]));
					}(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Evergreen$V419$Pagination$w3_encode_ItemId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Evergreen$V419$Editable$w3_encode_Editing = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$Editable$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Editable$w3_encode_Editing(w3_rec_var0.editing),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pressedSubmit),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showSecret)
			]));
};
var $author$project$Evergreen$V419$Pages$Admin$w3_encode_UserColumn = function (w3v) {
	if (w3v === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$Pages$Admin$w3_encode_UserTableId = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
				]));
	}
};
var $author$project$Evergreen$V419$Pages$Admin$w3_encode_EditingCell = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Pages$Admin$w3_encode_UserColumn(w3_rec_var0.column),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.text),
				$author$project$Evergreen$V419$Pages$Admin$w3_encode_UserTableId(w3_rec_var0.userId)
			]));
};
var $author$project$Evergreen$V419$Table$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.ascendingOrder),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.columnToSortBy),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showAll)
			]));
};
var $author$project$Evergreen$V419$Pages$Admin$w3_encode_UserTable = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				$author$project$Evergreen$V419$Pages$Admin$w3_encode_EditedBackendUser,
				w3_rec_var0.changedUsers),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				w3_rec_var0.deletedUsers),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Pages$Admin$w3_encode_EditingCell, w3_rec_var0.editingCell),
				$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Evergreen$V419$Pages$Admin$w3_encode_EditedBackendUser, w3_rec_var0.newUsers),
				$author$project$Evergreen$V419$Table$w3_encode_Model(w3_rec_var0.table)
			]));
};
var $author$project$Evergreen$V419$Pages$Admin$w3_encode_UsersChangeError = function (w3v) {
	switch (w3v.$) {
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
	}
};
var $author$project$Evergreen$V419$Pages$Admin$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Pagination$w3_encode_ItemId),
				w3_rec_var0.copiedLogLink),
				$author$project$Evergreen$V419$Editable$w3_encode_Model(w3_rec_var0.discordLinkLimit),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Pages$Admin$w3_encode_DownloadingBackup, w3_rec_var0.downloadingBackup),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_GuildId),
				w3_rec_var0.expandedDiscordGuilds),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_GuildId),
				w3_rec_var0.expandedGuilds),
				$lamdera$containers$SeqSet$encodeSet$($author$project$Evergreen$V419$Pages$Admin$w3_encode_AdminUiSection, w3_rec_var0.expandedSections),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_TeamId),
				w3_rec_var0.expandedSlackWorkspaces),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Pages$Admin$w3_encode_ExportProgress, w3_rec_var0.exportProgress),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Pages$Admin$w3_encode_ExportSubsetSelection, w3_rec_var0.exportSubsetSelection),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Pagination$w3_encode_ItemId),
				w3_rec_var0.highlightLog),
				$author$project$Evergreen$V419$Pages$Admin$w3_encode_ImportBackendStatus(w3_rec_var0.importBackendStatus),
				$author$project$Evergreen$V419$Editable$w3_encode_Model(w3_rec_var0.notifyAdminsBotUserId),
				$author$project$Evergreen$V419$Editable$w3_encode_Model(w3_rec_var0.notifyAdminsToken),
				$author$project$Evergreen$V419$Editable$w3_encode_Model(w3_rec_var0.openRouterKey),
				$author$project$Evergreen$V419$Editable$w3_encode_Model(w3_rec_var0.postmarkKey),
				$author$project$Evergreen$V419$Editable$w3_encode_Model(w3_rec_var0.privateVapidKey),
				$author$project$Evergreen$V419$Editable$w3_encode_Model(w3_rec_var0.publicVapidKey),
				$author$project$Evergreen$V419$Editable$w3_encode_Model(w3_rec_var0.slackLinkLimit),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Pages$Admin$w3_encode_UsersChangeError, w3_rec_var0.submitError),
				$author$project$Evergreen$V419$Pages$Admin$w3_encode_UserTable(w3_rec_var0.userTable),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.websocketCloseEventsPage)
			]));
};
var $author$project$Evergreen$V419$TextEditor$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(_List_Nil);
};
var $author$project$Evergreen$V419$Types$w3_encode_NewChannelForm = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.description),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pressedSubmit)
			]));
};
var $author$project$Evergreen$V419$Types$w3_encode_NewGuildForm = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pressedSubmit)
			]));
};
var $author$project$Evergreen$V419$X25519$w3_encode_PrivateKey = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$author$project$Evergreen$V419$X25519$w3_encode_Key(v0)
			]));
};
var $author$project$Evergreen$V419$Types$w3_encode_RevealedSpoilers = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
				$author$project$Evergreen$V419$NonemptySet$w3_encode_NonemptySet($lamdera$codecs$Lamdera$Wire3$encodeInt),
				w3_rec_var0.messages),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId),
					$author$project$Evergreen$V419$NonemptySet$w3_encode_NonemptySet($lamdera$codecs$Lamdera$Wire3$encodeInt)),
				w3_rec_var0.threadMessages)
			]));
};
var $author$project$Evergreen$V419$MessageInput$w3_encode_MentionUserDropdown = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.dropdownIndex),
				function (w3_rec_var1) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.height),
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.width),
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.x),
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.y)
						]));
			}(w3_rec_var0.inputElement)
			]));
};
var $author$project$Evergreen$V419$Range$w3_encode_SelectionDirection = function (w3v) {
	if (w3v === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$MessageInput$w3_encode_TextInputFocus = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Range$w3_encode_SelectionDirection(w3_rec_var0.direction),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$MessageInput$w3_encode_MentionUserDropdown, w3_rec_var0.dropdown),
				$lamdera$program_test$Effect$Browser$Dom$w3_encode_HtmlId(w3_rec_var0.htmlId),
				$author$project$Evergreen$V419$Range$w3_encode_Range(w3_rec_var0.selection)
			]));
};
var $author$project$Evergreen$V419$LoginForm$w3_encode_CodeStatus = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$TwoFactorAuthentication$w3_encode_TwoFactorDisableData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$Evergreen$V419$LoginForm$w3_encode_CodeStatus, w3_rec_var0.attempts),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.code)
			]));
};
var $author$project$Evergreen$V419$TwoFactorAuthentication$w3_encode_TwoFactorSetupData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$Evergreen$V419$LoginForm$w3_encode_CodeStatus, w3_rec_var0.attempts),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.code),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.qrCodeUrl)
			]));
};
var $author$project$Evergreen$V419$TwoFactorAuthentication$w3_encode_TwoFactorState = function (w3v) {
	switch (w3v.$) {
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0)
					]));
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$TwoFactorAuthentication$w3_encode_TwoFactorDisableData(v1)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V419$TwoFactorAuthentication$w3_encode_TwoFactorSetupData(v0)
					]));
	}
};
var $author$project$Evergreen$V419$Types$w3_encode_E2eeKeysValid = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V419$Types$w3_encode_LinkSlackWorkspaceError = function (w3v) {
	if (w3v.$ === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V419$Slack$w3_encode_HttpError(v0)
				]));
	}
};
var $author$project$Evergreen$V419$Types$w3_encode_LinkSlackResult = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
					A2($lamdera$codecs$Lamdera$Wire3$encodeResult, $author$project$Evergreen$V419$Types$w3_encode_LinkSlackWorkspaceError, $lamdera$codecs$Lamdera$Wire3$encodeString),
					v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$UserColor$w3_encode_Selection = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$UserColor$w3_encode_UserColor(w3_rec_var0.lastValid),
				function (w3_rec_var1) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.hue),
							$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.lightness),
							$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.saturation)
						]));
			}(w3_rec_var0.selected)
			]));
};
var $author$project$Evergreen$V419$Types$w3_encode_UserOptionsModel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$UserColor$w3_encode_Selection, w3_rec_var0.color),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var1.data),
								$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var1.loadedAt)
							]));
				},
				w3_rec_var0.debugData),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.domainWhitelistInput),
				$author$project$Evergreen$V419$Types$w3_encode_E2eeKeysValid(w3_rec_var0.e2eeKeysValid),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Types$w3_encode_LinkSlackResult, w3_rec_var0.linkSlackResult),
				$author$project$Evergreen$V419$Editable$w3_encode_Model(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pressedSubmitSlackData),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.privateKeyText),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_TeamId),
				w3_rec_var0.removedSlackTeams),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.slackCookie),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.slackTeamsJson)
			]));
};
var $author$project$Evergreen$V419$Types$w3_encode_LoggedIn2 = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.accountDeletionBannerClosed),
				$author$project$Evergreen$V419$Pages$Admin$w3_encode_Model(w3_rec_var0.admin),
				$author$project$Evergreen$V419$Scroll$w3_encode_ScrollPosition(w3_rec_var0.channelScrollPosition),
				$lamdera$containers$SeqDict$encodeDict$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_encode_ThreadRoute),
				$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString,
				w3_rec_var0.drafts),
				$author$project$Evergreen$V419$Drawing$w3_encode_Model(w3_rec_var0.drawingMode),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.e2eeError),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				w3_rec_var0.e2eeKeysOnThisDevice),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.e2eePrivateKeyText),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				$lamdera$codecs$Lamdera$Wire3$encodeBool,
				w3_rec_var0.e2eeSectionsExpanded),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_GuildId),
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId)),
				$author$project$Evergreen$V419$Types$w3_encode_EditChannelForm,
				w3_rec_var0.editChannelForm),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_GuildId),
				$author$project$Evergreen$V419$Types$w3_encode_EditGuildForm,
				w3_rec_var0.editGuildForm),
				$lamdera$containers$SeqDict$encodeDict$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_encode_ThreadRoute),
				$author$project$Evergreen$V419$Types$w3_encode_EditMessage,
				w3_rec_var0.editMessage),
				$author$project$Evergreen$V419$Emoji$w3_encode_Model(w3_rec_var0.emojiSelector),
				$author$project$Evergreen$V419$Types$w3_encode_EncryptionRequests(w3_rec_var0.encryptionRequests),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($elm$url$Url$w3_encode_Url, w3_rec_var0.externalLinkWarning),
				$author$project$Evergreen$V419$Types$w3_encode_FileDrag(w3_rec_var0.fileDragOverCount),
				$lamdera$containers$SeqDict$encodeDict$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_encode_ThreadRoute),
				A2(
					$author$project$Evergreen$V419$NonemptyDict$w3_encode_NonemptyDict,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$FileStatus$w3_encode_FileId),
					$author$project$Evergreen$V419$FileStatus$w3_encode_FileStatus),
				w3_rec_var0.filesToUpload),
				$lamdera$containers$SeqDict$encodeDict$($author$project$Evergreen$V419$Id$w3_encode_GuildOrDmId, $author$project$Evergreen$V419$Game$w3_encode_Model, w3_rec_var0.games),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_GuildId),
					$author$project$Evergreen$V419$ImageEditor$w3_encode_Model),
				w3_rec_var0.guildIconEditor),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isReloading),
				$author$project$Evergreen$V419$Local$w3_encode_Local$($author$project$Evergreen$V419$Types$w3_encode_LocalMsg, $author$project$Evergreen$V419$LocalState$w3_encode_LocalState, w3_rec_var0.localState),
				$author$project$Evergreen$V419$Types$w3_encode_MessageHover(w3_rec_var0.messageHover),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_GuildId),
				$author$project$Evergreen$V419$Types$w3_encode_NewChannelForm,
				w3_rec_var0.newChannelForm),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Types$w3_encode_NewGuildForm, w3_rec_var0.newGuildForm),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.newMessagesWhileNotScrolledToBottom),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$MessageInput$w3_encode_TextInputFocus, w3_rec_var0.previousTextInputFocus),
				$author$project$Evergreen$V419$ImageEditor$w3_encode_Model(w3_rec_var0.profilePictureEditor),
				$lamdera$containers$SeqDict$encodeDict$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_encode_ThreadRoute),
				$author$project$Evergreen$V419$Message$w3_encode_RepliedTo($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
				w3_rec_var0.replyTo),
				$lamdera$containers$SeqDict$encodeDict$($author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V419$Types$w3_encode_RevealedSpoilers, w3_rec_var0.revealedSpoilers),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.searchOverlayQuery),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.searchOverlaySelection),
				$author$project$Evergreen$V419$Types$w3_encode_EmojiSelector(w3_rec_var0.showEmojiSelector),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$FileStatus$w3_encode_FileDataWithImage, w3_rec_var0.showFileToUploadInfo),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V419$SecretId$w3_encode_SecretId($author$project$Evergreen$V419$Id$w3_encode_InviteLinkId),
				w3_rec_var0.showInviteLinkQrCode),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$X25519$w3_encode_PrivateKey, w3_rec_var0.showNewPrivateKey),
				$author$project$Evergreen$V419$Route$w3_encode_ChannelSidebarMode(w3_rec_var0.sidebarMode),
				$author$project$Evergreen$V419$TextEditor$w3_encode_Model(w3_rec_var0.textEditor),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$MessageInput$w3_encode_TextInputFocus, w3_rec_var0.textInputFocus),
				$author$project$Evergreen$V419$TwoFactorAuthentication$w3_encode_TwoFactorState(w3_rec_var0.twoFactor),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.typedTextCounter),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.typingDebouncer),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Types$w3_encode_UserOptionsModel, w3_rec_var0.userOptions),
				$author$project$Evergreen$V419$Call$w3_encode_Model(w3_rec_var0.voiceChat)
			]));
};
var $author$project$Evergreen$V419$LoginForm$w3_encode_EnterEmail2 = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.email),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pressedSubmitEmail),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.rateLimited),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showSignupsDisabled),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showUserIsDeleted)
			]));
};
var $author$project$Evergreen$V419$LoginForm$w3_encode_EnterLoginCode2 = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$Evergreen$V419$LoginForm$w3_encode_CodeStatus, w3_rec_var0.attempts),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.code),
				$author$project$Evergreen$V419$EmailAddress$w3_encode_EmailAddress(w3_rec_var0.sentTo)
			]));
};
var $author$project$Evergreen$V419$LoginForm$w3_encode_EnterTwoFactorCode2 = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.attemptCount),
				$lamdera$containers$SeqDict$encodeDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$Evergreen$V419$LoginForm$w3_encode_CodeStatus, w3_rec_var0.attempts),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.code)
			]));
};
var $author$project$Evergreen$V419$LoginForm$w3_encode_SubmitStatus = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$LoginForm$w3_encode_EnterUserData2 = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
				$author$project$Evergreen$V419$LoginForm$w3_encode_SubmitStatus(w3_rec_var0.pressedSubmit)
			]));
};
var $author$project$Evergreen$V419$LoginForm$w3_encode_LoginForm = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$LoginForm$w3_encode_EnterEmail2(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$LoginForm$w3_encode_EnterLoginCode2(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$LoginForm$w3_encode_EnterTwoFactorCode2(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V419$LoginForm$w3_encode_EnterUserData2(v0)
					]));
	}
};
var $author$project$Evergreen$V419$RecoveryLogin$w3_encode_SubmitStatus = function (w3v) {
	switch (w3v.$) {
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V419$RecoveryLogin$w3_encode_Model = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				function (w3_rec_var0) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.password),
							$author$project$Evergreen$V419$RecoveryLogin$w3_encode_SubmitStatus(w3_rec_var0.submitStatus)
						]));
			}(v0)
			]));
};
var $author$project$Evergreen$V419$Types$w3_encode_LoginStatus = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$Types$w3_encode_LoggedIn2(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					function (w3_rec_var0) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$LoginForm$w3_encode_LoginForm, w3_rec_var0.loginForm),
								$author$project$Evergreen$V419$RecoveryLogin$w3_encode_Model(w3_rec_var0.recoveryLogin),
								$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
								function (w3_rec_var1) {
									return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
										_List_fromArray(
											[
												$author$project$Evergreen$V419$Range$w3_encode_SelectionDirection(w3_rec_var1.direction),
												$lamdera$program_test$Effect$Browser$Dom$w3_encode_HtmlId(w3_rec_var1.htmlId),
												$author$project$Evergreen$V419$Range$w3_encode_Range(w3_rec_var1.selection)
											]));
								},
								w3_rec_var0.textInputFocus),
								$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
								$author$project$Evergreen$V419$SecretId$w3_encode_SecretId($author$project$Evergreen$V419$Id$w3_encode_InviteLinkId),
								w3_rec_var0.useInviteAfterLoggedIn)
							]));
				}(v0)
				]));
	}
};
var $author$project$Evergreen$V419$Types$w3_encode_LoginType = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$ImageViewer$w3_encode_Interaction = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.offsetStartX),
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.offsetStartY),
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.startX),
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.startY)
								]));
					}(v0)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.prevMidX),
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.prevMidY),
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.startDistance),
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.startScale)
								]));
					}(v0)
					]));
	}
};
var $author$project$Evergreen$V419$ImageViewer$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				A2($author$project$Evergreen$V419$Coord$w3_encode_Coord, $author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels, w3_rec_var0.imageSize),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.imageUrl),
				$author$project$Evergreen$V419$ImageViewer$w3_encode_Interaction(w3_rec_var0.interaction),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.offsetX),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.offsetY),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.prevOffsetX),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.prevOffsetY),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.scale),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.targetScale),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.velocityX),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.velocityY),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.zoomFocusX),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.zoomFocusY)
			]));
};
var $author$project$Evergreen$V419$Go$w3_encode_PublicGoMatchData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Evergreen$V419$Go$w3_encode_ActionWithTime, w3_rec_var0.actions),
				$author$project$Evergreen$V419$Go$w3_encode_Shared(w3_rec_var0.cache),
				$author$project$Evergreen$V419$User$w3_encode_FrontendUser(w3_rec_var0.creatorUser),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$User$w3_encode_FrontendUser, w3_rec_var0.joinedUser),
				$author$project$Evergreen$V419$Go$w3_encode_ValidatedSetup(w3_rec_var0.setup)
			]));
};
var $author$project$Evergreen$V419$Types$w3_encode_PublicGoMatch = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Go$w3_encode_PublicGoMatchData(v0),
						$author$project$Evergreen$V419$Go$w3_encode_GameModel(v1)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Evergreen$V419$Route$w3_encode_ShowChannelSettings = function (w3v) {
	if (w3v === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$Route$w3_encode_ThreadRouteWithFriends = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
					v0),
					$author$project$Evergreen$V419$Route$w3_encode_ShowChannelSettings(v1)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		var v2 = w3v.c;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v0),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId),
					v1),
					$author$project$Evergreen$V419$Route$w3_encode_ShowChannelSettings(v2)
				]));
	}
};
var $author$project$Evergreen$V419$Route$w3_encode_ChannelRoute = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelId, v0),
						$author$project$Evergreen$V419$Route$w3_encode_ThreadRouteWithFriends(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$UserSession$w3_encode_ChannelHeaderTab, v2)
					]));
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$SecretId$w3_encode_SecretId$($author$project$Evergreen$V419$Id$w3_encode_InviteLinkId, v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Evergreen$V419$Route$w3_encode_ChannelsVisibleOnMobile = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$Route$w3_encode_Overlay = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V419$Route$w3_encode_DiscordDmRouteData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId, w3_rec_var0.channelId),
				$author$project$Evergreen$V419$Route$w3_encode_ChannelsVisibleOnMobile(w3_rec_var0.channelsVisible),
				$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, w3_rec_var0.currentDiscordUserId),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Route$w3_encode_Overlay, w3_rec_var0.overlay),
				$author$project$Evergreen$V419$Route$w3_encode_ShowChannelSettings(w3_rec_var0.showMembersTab),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$UserSession$w3_encode_ChannelHeaderTab, w3_rec_var0.tab),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId),
				w3_rec_var0.viewingMessage)
			]));
};
var $author$project$Evergreen$V419$Route$w3_encode_DiscordChannelRoute = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, v0),
						$author$project$Evergreen$V419$Route$w3_encode_ThreadRouteWithFriends(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$UserSession$w3_encode_ChannelHeaderTab, v2)
					]));
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V419$Route$w3_encode_DiscordGuildRouteData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Route$w3_encode_DiscordChannelRoute(w3_rec_var0.channelRoute),
				$author$project$Evergreen$V419$Route$w3_encode_ChannelsVisibleOnMobile(w3_rec_var0.channelsVisible),
				$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, w3_rec_var0.currentDiscordUserId),
				$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, w3_rec_var0.guildId),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Route$w3_encode_Overlay, w3_rec_var0.overlay)
			]));
};
var $author$project$Evergreen$V419$Route$w3_encode_DmRouteData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$DmChannelId$w3_encode_DmChannelId(w3_rec_var0.channelId),
				$author$project$Evergreen$V419$Route$w3_encode_ChannelsVisibleOnMobile(w3_rec_var0.channelsVisible),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Route$w3_encode_Overlay, w3_rec_var0.overlay),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$UserSession$w3_encode_ChannelHeaderTab, w3_rec_var0.tab),
				$author$project$Evergreen$V419$Route$w3_encode_ThreadRouteWithFriends(w3_rec_var0.threadRoute)
			]));
};
var $author$project$Evergreen$V419$Route$w3_encode_LinkDiscordError = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Evergreen$V419$Route$w3_encode_SlackDmRouteData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_DmChannelId, w3_rec_var0.channelId),
				$author$project$Evergreen$V419$Route$w3_encode_ChannelsVisibleOnMobile(w3_rec_var0.channelsVisible),
				$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_UserId, w3_rec_var0.currentSlackUserId),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Route$w3_encode_Overlay, w3_rec_var0.overlay),
				$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMaybeMessage(w3_rec_var0.threadRoute)
			]));
};
var $author$project$Evergreen$V419$Route$w3_encode_SlackChannelRoute = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		var v2 = w3v.c;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_ChannelId, v0),
					$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMaybeMessage(v1),
					$author$project$Evergreen$V419$Route$w3_encode_ShowChannelSettings(v2)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$Route$w3_encode_SlackWorkspaceRouteData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Route$w3_encode_SlackChannelRoute(w3_rec_var0.channelRoute),
				$author$project$Evergreen$V419$Route$w3_encode_ChannelsVisibleOnMobile(w3_rec_var0.channelsVisible),
				$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_UserId, w3_rec_var0.currentSlackUserId),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Route$w3_encode_Overlay, w3_rec_var0.overlay),
				$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_TeamId, w3_rec_var0.teamId)
			]));
};
var $author$project$Evergreen$V419$SafeJson$w3_encode_SafeJson = function (w3v) {
	switch (w3v.$) {
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V419$SafeJson$w3_encode_SafeJson, v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V419$SafeFloat$w3_encode_SafeFloat(v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$lamdera$codecs$Lamdera$Wire3$encodeDict$($lamdera$codecs$Lamdera$Wire3$encodeString, $author$project$Evergreen$V419$SafeJson$w3_encode_SafeJson, v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
	}
};
var $author$project$Evergreen$V419$Discord$w3_encode_UserAuth = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.token),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.userAgent),
				$author$project$Evergreen$V419$SafeJson$w3_encode_SafeJson(w3_rec_var0.xSuperProperties)
			]));
};
var $author$project$Evergreen$V419$Route$w3_encode_Route = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
									$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Pagination$w3_encode_ItemId),
									w3_rec_var0.highlightLog)
								]));
					}(v0)
					]));
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$Route$w3_encode_DiscordDmRouteData(v0)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V419$Route$w3_encode_DiscordGuildRouteData(v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V419$Route$w3_encode_DmRouteData(v0)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Route$w3_encode_ChannelRoute(v1),
						$author$project$Evergreen$V419$Route$w3_encode_ChannelsVisibleOnMobile(v2),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Route$w3_encode_Overlay, v3)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Route$w3_encode_Overlay, v0)
					]));
		case 12:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($author$project$Evergreen$V419$Route$w3_encode_LinkDiscordError, $author$project$Evergreen$V419$Discord$w3_encode_UserAuth, v0)
					]));
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		case 13:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Evergreen$V419$SecretId$w3_encode_SecretId$($author$project$Evergreen$V419$Id$w3_encode_GamePublicId, v0)
					]));
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$Evergreen$V419$Route$w3_encode_SlackDmRouteData(v0)
					]));
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$Evergreen$V419$Route$w3_encode_SlackWorkspaceRouteData(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
	}
};
var $author$project$Evergreen$V419$Audio$w3_encode_BufferId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Evergreen$V419$Audio$w3_encode_Source = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				function (w3_rec_var0) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$author$project$Evergreen$V419$Audio$w3_encode_BufferId(w3_rec_var0.bufferId)
						]));
			}(v0)
			]));
};
var $author$project$Evergreen$V419$Ports$w3_encode_NotificationPermission = function (w3v) {
	switch (w3v) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Evergreen$V419$Ports$w3_encode_PwaStatus = function (w3v) {
	if (w3v === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$Ports$w3_encode_StartupData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.devicePixelRatio),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				w3_rec_var0.e2eeKeys),
				function (t) {
				return $lamdera$codecs$Lamdera$Wire3$encodeInt(
					$elm$time$Time$posixToMillis(t));
			}(w3_rec_var0.loadStartupDataTime),
				$author$project$Evergreen$V419$Ports$w3_encode_NotificationPermission(w3_rec_var0.notificationPermission),
				$author$project$Evergreen$V419$Ports$w3_encode_PwaStatus(w3_rec_var0.pwaStatus),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.randomSeed),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.safeAreaInsetBottom),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.safeAreaInsetTop),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.scrollbarWidth),
				function (t) {
				return $lamdera$codecs$Lamdera$Wire3$encodeInt(
					$elm$time$Time$posixToMillis(t));
			}(w3_rec_var0.timeOrigin),
				$elm$time$Time$w3_encode_Zone(w3_rec_var0.timezone),
				$author$project$Evergreen$V419$UserAgent$w3_encode_UserAgent(w3_rec_var0.userAgent)
			]));
};
var $author$project$Evergreen$V419$Internal$Model2$w3_encode_State = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				function (w3_rec_var0) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$lamdera$codecs$Lamdera$Wire3$encodeSet$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.added),
							$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.keyframes),
							$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.rules)
						]));
			}(v0)
			]));
};
var $author$project$Evergreen$V419$Ui$Anim$w3_encode_State = $author$project$Evergreen$V419$Internal$Model2$w3_encode_State;
var $author$project$Evergreen$V419$Types$w3_encode_LinkDiscordFailure = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$Discord$w3_encode_HttpError(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$Types$w3_encode_AdminStatusLoginData = function (w3v) {
	switch (w3v.$) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$Pages$Admin$w3_encode_InitAdminData(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V419$Types$w3_encode_LoginData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$Types$w3_encode_AdminStatusLoginData(w3_rec_var0.adminData),
				$lamdera$containers$SeqDict$encodeDict$($author$project$Evergreen$V419$Call$w3_encode_CallId, $author$project$Evergreen$V419$Call$w3_encode_RecordingStatus, w3_rec_var0.callRecordings),
				$author$project$Evergreen$V419$UserSession$w3_encode_Viewing(w3_rec_var0.currentlyViewing),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_CustomEmojiId),
				$author$project$Evergreen$V419$CustomEmoji$w3_encode_CustomEmojiData,
				w3_rec_var0.customEmojis),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId),
				$author$project$Evergreen$V419$DmChannel$w3_encode_DiscordFrontendDmChannel,
				w3_rec_var0.discordDmChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Discord$w3_encode_Id($author$project$Evergreen$V419$Discord$w3_encode_GuildId),
				$author$project$Evergreen$V419$LocalState$w3_encode_DiscordFrontendGuild,
				w3_rec_var0.discordGuilds),
				$author$project$Evergreen$V419$LinkedAndOtherDiscordUsers$w3_encode_LinkedAndOtherDiscordUsers(w3_rec_var0.discordUsers),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				$author$project$Evergreen$V419$DmChannel$w3_encode_FrontendDmChannel,
				w3_rec_var0.dmChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_GuildId),
				$author$project$Evergreen$V419$LocalState$w3_encode_FrontendGuild,
				w3_rec_var0.guilds),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_UserId),
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_TeamId),
				w3_rec_var0.linkedSlackUsers),
				$lamdera$containers$SeqDict$encodeDict$($author$project$Evergreen$V419$SessionIdHash$w3_encode_SessionIdHash, $author$project$Evergreen$V419$UserSession$w3_encode_FrontendUserSession, w3_rec_var0.otherSessions),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
				$author$project$Evergreen$V419$User$w3_encode_FrontendUser,
				w3_rec_var0.otherUsers),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.publicVapidKey),
				$author$project$Evergreen$V419$UserSession$w3_encode_UserSession(w3_rec_var0.session),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_DmChannelId),
				$author$project$Evergreen$V419$LocalState$w3_encode_SlackFrontendDmChannel,
				w3_rec_var0.slackDmChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_UserId),
				$author$project$Evergreen$V419$UserSession$w3_encode_SlackFrontendUser,
				w3_rec_var0.slackUsers),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_UserId),
				w3_rec_var0.slackUsersNeedingAuth),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Slack$w3_encode_Id($author$project$Evergreen$V419$Slack$w3_encode_TeamId),
				$author$project$Evergreen$V419$LocalState$w3_encode_SlackFrontendWorkspace,
				w3_rec_var0.slackWorkspaces),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_StickerId),
				$author$project$Evergreen$V419$Sticker$w3_encode_StickerData,
				w3_rec_var0.stickers),
				$author$project$Evergreen$V419$TextEditor$w3_encode_LocalState(w3_rec_var0.textEditor),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.twoFactorAuthenticationEnabled),
				$author$project$Evergreen$V419$User$w3_encode_FrontendCurrentUser(w3_rec_var0.user),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Evergreen$V419$Call$w3_encode_CallId,
				A2(
					$author$project$Evergreen$V419$NonemptyDict$w3_encode_NonemptyDict,
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
						$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId),
					$author$project$Evergreen$V419$Call$w3_encode_RemoteCallData),
				w3_rec_var0.voiceChatPeers)
			]));
};
var $author$project$Evergreen$V419$Types$w3_encode_LoginResult = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Types$w3_encode_LoginData(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
	}
};
var $author$project$Evergreen$V419$Go$w3_encode_PublicGoMatchResponse = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Evergreen$V419$Go$w3_encode_ActionWithTime, w3_rec_var0.actions),
				$author$project$Evergreen$V419$User$w3_encode_FrontendUser(w3_rec_var0.creatorUser),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$User$w3_encode_FrontendUser, w3_rec_var0.joinedUser),
				$author$project$Evergreen$V419$Go$w3_encode_ValidatedSetup(w3_rec_var0.setup)
			]));
};
var $author$project$Evergreen$V419$AiChat$w3_encode_AiResponse = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.content),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeFloat, w3_rec_var0.cost),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.images),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.reasoning)
			]));
};
var $author$project$Evergreen$V419$AiChat$w3_encode_ToFrontend = function (w3v) {
	var v0 = w3v.a;
	var v1 = w3v.b;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$author$project$Evergreen$V419$AiChat$w3_encode_ResponseId(v0),
				$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Http$w3_encode_Error, $author$project$Evergreen$V419$AiChat$w3_encode_AiResponse, v1)
			]));
};
var $author$project$Evergreen$V419$ImageEditor$w3_encode_ToFrontend = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Evergreen$V419$Pages$Admin$w3_encode_ExportSubset = function (w3v) {
	if (w3v.$ === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V419$Pages$Admin$w3_encode_ExportSubsetSelection(v0)
				]));
	}
};
var $author$project$Evergreen$V419$Pages$Admin$w3_encode_ToFrontend = function (w3v) {
	switch (w3v.$) {
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$LocalState$w3_encode_BackupContents(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeBytes(v2)
					]));
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$Pages$Admin$w3_encode_ExportSubset(v0),
						$author$project$Evergreen$V419$Pages$Admin$w3_encode_ExportProgress(v1)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$codecs$Lamdera$Wire3$encodeUnit, $lamdera$codecs$Lamdera$Wire3$encodeUnit, v0)
					]));
	}
};
var $author$project$Evergreen$V419$TwoFactorAuthentication$w3_encode_ToFrontend = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v1)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v1)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.qrCodeUrl)
								]));
					}(v0)
					]));
	}
};
var $author$project$Evergreen$V419$Types$w3_encode_ToFrontend = function (w3v) {
	switch (w3v.$) {
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Pages$Admin$w3_encode_ToFrontend(v0)
					]));
		case 9:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$AiChat$w3_encode_ToFrontend(v0)
					]));
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$Types$w3_encode_LocalMsg(v0)
					]));
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V419$Types$w3_encode_LoginType(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$codecs$Lamdera$Wire3$encodeUnit, $author$project$Evergreen$V419$Types$w3_encode_LoginData, v1)
					]));
		case 16:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.fileName),
									$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.json)
								]));
					}(v0)
					]));
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 15:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$codecs$Lamdera$Wire3$encodeUnit, $author$project$Evergreen$V419$Go$w3_encode_PublicGoMatchResponse, v0)
					]));
		case 17:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$(
						$author$project$Evergreen$V419$Types$w3_encode_ImportChannelError,
						function (w3_rec_var0) {
							return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
								_List_fromArray(
									[
										$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.encryptedMessages)
									]));
						},
						v1)
					]));
		case 12:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($author$project$Evergreen$V419$Types$w3_encode_LinkDiscordFailure, $lamdera$codecs$Lamdera$Wire3$encodeUnit, v0)
					]));
		case 13:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V419$Types$w3_encode_LinkSlackResult(v0)
					]));
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Evergreen$V419$Local$w3_encode_ChangeId(v0),
						$author$project$Evergreen$V419$Types$w3_encode_LocalChange(v1)
					]));
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$Evergreen$V419$Types$w3_encode_LoginResult(v0)
					]));
		case 14:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$author$project$Evergreen$V419$ImageEditor$w3_encode_ToFrontend(v0)
					]));
		case 11:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$codecs$Lamdera$Wire3$encodeUnit, $author$project$Evergreen$V419$Types$w3_encode_LoginData, v0)
					]));
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(15);
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$author$project$Evergreen$V419$TwoFactorAuthentication$w3_encode_ToFrontend(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId(v0)
					]));
	}
};
var $author$project$Evergreen$V419$Types$w3_encode_LoadedFrontend = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$AiChat$w3_encode_FrontendModel(w3_rec_var0.aiChatModel),
				$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId(w3_rec_var0.clientId),
				$author$project$Evergreen$V419$Touch$w3_encode_Drag(w3_rec_var0.drag),
				$author$project$Evergreen$V419$Touch$w3_encode_Drag(w3_rec_var0.dragPrevious),
				$author$project$Evergreen$V419$Ui$Anim$w3_encode_State(w3_rec_var0.elmUiState),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Emoji$w3_encode_CachedEmojiData, w3_rec_var0.emojiData),
				function (w3_rec_var1) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var1.changedAt),
							$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.index),
							$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var1.rotate)
						]));
			}(w3_rec_var0.homePagePreview),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$ImageViewer$w3_encode_Model, w3_rec_var0.imageViewer),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$MyUi$w3_encode_LastCopy, w3_rec_var0.lastCopied),
				$author$project$Evergreen$V419$Types$w3_encode_LoginStatus(w3_rec_var0.loginStatus),
				$author$project$Evergreen$V419$Types$w3_encode_LoginType(w3_rec_var0.loginType),
				$lamdera$program_test$Effect$Browser$Navigation$w3_encode_Key(w3_rec_var0.navigationKey),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pageHasFocus),
				$lamdera$codecs$Lamdera$Wire3$encodeResult$($author$project$Evergreen$V419$Audio$w3_encode_LoadError, $author$project$Evergreen$V419$Audio$w3_encode_Source, w3_rec_var0.popSound),
				$author$project$Evergreen$V419$Types$w3_encode_PublicGoMatch(w3_rec_var0.publicGoMatch),
				$author$project$Evergreen$V419$Route$w3_encode_Route(w3_rec_var0.route),
				$author$project$Evergreen$V419$Ports$w3_encode_StartupData(w3_rec_var0.startupData),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.time),
				$lamdera$program_test$Effect$Time$w3_encode_Zone(w3_rec_var0.timezone),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$lamdera$codecs$Lamdera$Wire3$encodeArray($author$project$Evergreen$V419$Types$w3_encode_ToFrontend),
				w3_rec_var0.toFrontendLogs),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.versionNumber),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.visualViewportHeight),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.visualViewportTop),
				A2($author$project$Evergreen$V419$Coord$w3_encode_Coord, $author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels, w3_rec_var0.windowSize)
			]));
};
var $author$project$Evergreen$V419$Types$w3_encode_LoadStatus = function (w3v) {
	switch (w3v.$) {
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$Types$w3_encode_LoginData(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Evergreen$V419$Types$w3_encode_LoadingFrontend = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Lamdera$w3_encode_ClientId, w3_rec_var0.clientId),
				$author$project$Evergreen$V419$Types$w3_encode_LoadStatus(w3_rec_var0.loginStatus),
				$author$project$Evergreen$V419$Types$w3_encode_LoginType(w3_rec_var0.loginType),
				$lamdera$program_test$Effect$Browser$Navigation$w3_encode_Key(w3_rec_var0.navigationKey),
				$lamdera$codecs$Lamdera$Wire3$encodeResult$($author$project$Evergreen$V419$Audio$w3_encode_LoadError, $author$project$Evergreen$V419$Audio$w3_encode_Source, w3_rec_var0.popSound),
				$author$project$Evergreen$V419$Types$w3_encode_PublicGoMatch(w3_rec_var0.publicGoMatch),
				$author$project$Evergreen$V419$Route$w3_encode_Route(w3_rec_var0.route),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Ports$w3_encode_StartupData, w3_rec_var0.startupData),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.time),
				A2($author$project$Evergreen$V419$Coord$w3_encode_Coord, $author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels, w3_rec_var0.windowSize)
			]));
};
var $author$project$Evergreen$V419$Types$w3_encode_FrontendModel_ = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$Types$w3_encode_LoadedFrontend(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V419$Types$w3_encode_LoadingFrontend(v0)
				]));
	}
};
var $author$project$Evergreen$V419$Id$w3_encode_ExportChannelId = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, v2)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId, v1)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelId, v1)
					]));
	}
};
var $author$project$Evergreen$V419$Call$w3_encode_FromJs = function (w3v) {
	switch (w3v.$) {
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V419$Call$w3_encode_DebugSection, v0)
					]));
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V419$Call$w3_encode_MediaDevice, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						$author$project$Evergreen$V419$IdString$w3_encode_IdString($author$project$Evergreen$V419$Call$w3_encode_MediaDeviceId),
						v1)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 7:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1)
					]));
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Evergreen$V419$Call$w3_encode_LocalOrConnection(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v1)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
	}
};
var $author$project$Evergreen$V419$FileStatus$w3_encode_MeasuredFile = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					A2($author$project$Evergreen$V419$Coord$w3_encode_Coord, $author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels, v0)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					A2($author$project$Evergreen$V419$Coord$w3_encode_Coord, $author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels, v0),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($ianmackenzie$elm_units$Duration$w3_encode_Duration, v1)
				]));
	}
};
var $author$project$Evergreen$V419$Encryption$w3_encode_FromJs$ = function (w3_x_c_a, w3v) {
	switch (w3v.$) {
		case 10:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Encryption$w3_encode_EncryptFileRequestId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 9:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Encryption$w3_encode_EncryptFileRequestId, v0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeBytes(w3_rec_var0.data),
									$lamdera$codecs$Lamdera$Wire3$encodeBytes(w3_rec_var0.key),
									$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$FileStatus$w3_encode_MeasuredFile, w3_rec_var0.measured),
									$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeBytes, w3_rec_var0.thumbnail)
								]));
					}(v1)
					]));
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Encryption$w3_encode_DecryptManyRequestId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						A2($lamdera$codecs$Lamdera$Wire3$encodeResult, $lamdera$codecs$Lamdera$Wire3$encodeUnit, w3_x_c_a),
						v1)
					]));
		case 8:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Encryption$w3_encode_EncryptManyRequestId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 7:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Encryption$w3_encode_EncryptManyRequestId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						$author$project$Evergreen$V419$Encryption$w3_encode_EncryptedData(w3_x_c_a),
						v1)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Encryption$w3_encode_DecryptRequestId, v0)
					]));
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Encryption$w3_encode_DecryptRequestId, v0),
						w3_x_c_a(v1)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Encryption$w3_encode_EncryptRequestId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Encryption$w3_encode_EncryptRequestId, v0),
						$author$project$Evergreen$V419$Encryption$w3_encode_EncryptedData$(w3_x_c_a, v1)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0)
					]));
	}
};
var $author$project$Evergreen$V419$Encryption$w3_encode_FromJs = F2($author$project$Evergreen$V419$Encryption$w3_encode_FromJs$);
var $author$project$Evergreen$V419$RichText$w3_encode_PressedImageId = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$FileStatus$w3_encode_FileId, v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
				]));
	}
};
var $author$project$Evergreen$V419$RichText$w3_encode_PressedImageData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.displayWidth),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.fileUrl),
				$author$project$Evergreen$V419$RichText$w3_encode_PressedImageId(w3_rec_var0.imageId),
				A2($author$project$Evergreen$V419$Coord$w3_encode_Coord, $author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels, w3_rec_var0.imageSize),
				A3($author$project$Evergreen$V419$Point2d$w3_encode_Point2d, $author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels, $author$project$Evergreen$V419$Touch$w3_encode_ScreenCoordinate, w3_rec_var0.position)
			]));
};
var $author$project$Evergreen$V419$MessageView$w3_encode_MessageViewMsg = function (w3v) {
	switch (w3v.$) {
		case 17:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 18:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 16:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji(v0)
					]));
		case 12:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 13:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0),
						A2($author$project$Evergreen$V419$Coord$w3_encode_Coord, $author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels, v1)
					]));
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v2),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, v3),
						A2($author$project$Evergreen$V419$Coord$w3_encode_Coord, $author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels, v4)
					]));
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		case 15:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 22:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						A3($author$project$Evergreen$V419$Point2d$w3_encode_Point2d, $author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels, $author$project$Evergreen$V419$Touch$w3_encode_ScreenCoordinate, v0),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $lamdera$codecs$Lamdera$Wire3$encodeFloat, v1)
					]));
		case 25:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRoute(v1)
					]));
		case 27:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 21:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$justinmimbs$date$Date$w3_encode_Date(v0),
						A3($author$project$Evergreen$V419$Point2d$w3_encode_Point2d, $author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels, $author$project$Evergreen$V419$Touch$w3_encode_ScreenCoordinate, v1),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $lamdera$codecs$Lamdera$Wire3$encodeFloat, v2)
					]));
		case 26:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRoute(v1)
					]));
		case 24:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$author$project$Evergreen$V419$RichText$w3_encode_PressedImageData(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$elm$url$Url$w3_encode_Url(v0)
					]));
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(19),
						$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji(v0)
					]));
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(20),
						$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji(v0)
					]));
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(21);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(22),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 20:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(23),
						A3($author$project$Evergreen$V419$Point2d$w3_encode_Point2d, $author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels, $author$project$Evergreen$V419$Touch$w3_encode_ScreenCoordinate, v0),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $lamdera$codecs$Lamdera$Wire3$encodeFloat, v1)
					]));
		case 19:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(24),
						A3($author$project$Evergreen$V419$Point2d$w3_encode_Point2d, $author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels, $author$project$Evergreen$V419$Touch$w3_encode_ScreenCoordinate, v0),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $lamdera$codecs$Lamdera$Wire3$encodeFloat, v1)
					]));
		case 23:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(25),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0)
					]));
		case 14:
			return $elm$bytes$Bytes$Encode$unsignedInt8(26);
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(27),
						$ianmackenzie$elm_units$Duration$w3_encode_Duration(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v2),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v3),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, v4),
						$author$project$Evergreen$V419$NonemptyDict$w3_encode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$Evergreen$V419$Touch$w3_encode_Touch, v5)
					]));
	}
};
var $author$project$Evergreen$V419$AiChat$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 13:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 15:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$AiChat$w3_encode_ResponseId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 17:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$(
						$lamdera$program_test$Effect$Http$w3_encode_Error,
						$lamdera$codecs$Lamdera$Wire3$encodeList($author$project$Evergreen$V419$AiChat$w3_encode_AiModel),
						v0)
					]));
		case 14:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 16:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Evergreen$V419$AiChat$w3_encode_ResponseId(v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V419$AiChat$w3_encode_ResponseId(v0)
					]));
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 11:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$Evergreen$V419$AiChat$w3_encode_ResponseId(v0)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
		case 9:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$author$project$Evergreen$V419$AiChat$w3_encode_AiModelName(v1)
					]));
		case 12:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$author$project$Evergreen$V419$AiChat$w3_encode_SendMessageWith(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
	}
};
var $author$project$Evergreen$V419$Call$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 11:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Call$w3_encode_ConnectionId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v1)
					]));
		case 14:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 12:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$Call$w3_encode_LocalOrConnection(v0)
					]));
		case 13:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V419$Call$w3_encode_LocalOrConnection(v0)
					]));
		case 18:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 9:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 10:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Evergreen$V419$Call$w3_encode_CallId(v0)
					]));
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 17:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		case 16:
			return $elm$bytes$Bytes$Encode$unsignedInt8(12);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(14);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(15);
		case 15:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$author$project$Evergreen$V419$Call$w3_encode_VideoTile(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$author$project$Evergreen$V419$IdString$w3_encode_IdString$($author$project$Evergreen$V419$Call$w3_encode_MediaDeviceId, v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$author$project$Evergreen$V419$IdString$w3_encode_IdString$($author$project$Evergreen$V419$Call$w3_encode_MediaDeviceId, v0)
					]));
	}
};
var $author$project$Evergreen$V419$Drawing$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
						function (w3_rec_var0) {
							return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
								_List_fromArray(
									[
										$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.height),
										$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.width),
										$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.x),
										$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.y)
									]));
						},
						v0)
					]));
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v1)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v1)
					]));
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
	}
};
var $author$project$Evergreen$V419$Editable$w3_encode_Msg$ = function (w3_x_c_value, w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$Editable$w3_encode_Model(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					w3_x_c_value(v0)
				]));
	}
};
var $author$project$Evergreen$V419$Editable$w3_encode_Msg = F2($author$project$Evergreen$V419$Editable$w3_encode_Msg$);
var $author$project$Evergreen$V419$Emoji$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrSticker(v1)
					]));
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrSticker(v1)
					]));
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V419$Emoji$w3_encode_Category(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1)
					]));
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrSticker(v0)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Emoji$w3_encode_SkinTone, v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V419$Emoji$w3_encode_Category(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
	}
};
var $author$project$Evergreen$V419$Go$w3_encode_SpectatorMsg = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt, v0)
					]));
	}
};
var $author$project$Evergreen$V419$Go$w3_encode_GameMsg = function (w3v) {
	switch (w3v.$) {
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt, v0)
					]));
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Evergreen$V419$Go$w3_encode_SpectatorMsg(v0)
					]));
	}
};
var $author$project$Evergreen$V419$MessageInput$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 14:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 13:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 9:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$($lamdera$program_test$Effect$File$w3_encode_File, v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.charsLeft)
								]));
					}(v0)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(12);
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$author$project$Evergreen$V419$Range$w3_encode_Range(v0)
					]));
	}
};
var $author$project$Evergreen$V419$FileStatus$w3_encode_UploadResponse = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Evergreen$V419$FileStatus$w3_encode_FileHash(w3_rec_var0.fileHash),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$FileStatus$w3_encode_ImageMetadata, w3_rec_var0.imageMetadata),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$FileStatus$w3_encode_VideoMetadata, w3_rec_var0.videoMetadata)
			]));
};
var $author$project$Evergreen$V419$SheepGame$w3_encode_GameMsg = function (w3v) {
	switch (w3v.$) {
		case 19:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v0)
					]));
		case 21:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
						v0)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$FileStatus$w3_encode_FileId, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Http$w3_encode_Error, $author$project$Evergreen$V419$FileStatus$w3_encode_UploadResponse, v2)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v0),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$($lamdera$program_test$Effect$File$w3_encode_File, v1)
					]));
		case 11:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$FileStatus$w3_encode_FileId, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Http$w3_encode_Error, $author$project$Evergreen$V419$FileStatus$w3_encode_UploadResponse, v2)
					]));
		case 10:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v0),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$($lamdera$program_test$Effect$File$w3_encode_File, v1)
					]));
		case 18:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v0)
					]));
		case 20:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
						v0)
					]));
		case 27:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 25:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$FileStatus$w3_encode_FileId, v1)
					]));
		case 12:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$FileStatus$w3_encode_FileId, v1)
					]));
		case 17:
			return $elm$bytes$Bytes$Encode$unsignedInt8(12);
		case 24:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$author$project$Evergreen$V419$RichText$w3_encode_PressedImageData(v0)
					]));
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(14);
		case 26:
			return $elm$bytes$Bytes$Encode$unsignedInt8(15);
		case 15:
			return $elm$bytes$Bytes$Encode$unsignedInt8(16);
		case 16:
			return $elm$bytes$Bytes$Encode$unsignedInt8(17);
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$FileStatus$w3_encode_FileId, w3_rec_var0.fileId),
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.removeSpoiler)
								]));
					}(v1)
					]));
		case 14:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(19),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$FileStatus$w3_encode_FileId, w3_rec_var0.fileId),
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.removeSpoiler)
								]));
					}(v1)
					]));
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(20);
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(21),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$FileStatus$w3_encode_FileId, v1)
					]));
		case 13:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(22),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$FileStatus$w3_encode_FileId, v1)
					]));
		case 23:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(23),
						$author$project$Evergreen$V419$SheepGame$w3_encode_ReactionTarget(v0),
						$author$project$Evergreen$V419$MessageView$w3_encode_MessageViewMsg(v1)
					]));
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(24),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v0),
						$author$project$Evergreen$V419$MessageInput$w3_encode_Msg(v1)
					]));
		case 8:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(25),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v2)
					]));
		case 9:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(26),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v0),
						$author$project$Evergreen$V419$MessageInput$w3_encode_Msg(v1)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(27),
						$author$project$Evergreen$V419$Scroll$w3_encode_ScrollPosition(v0)
					]));
	}
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_GameMsg = function (w3v) {
	switch (w3v.$) {
		case 16:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$(
						$lamdera$program_test$Effect$Http$w3_encode_Error,
						$lamdera$codecs$Lamdera$Wire3$encodeList($author$project$Evergreen$V419$WordSpellingGame$w3_encode_DictEntry),
						v1)
					]));
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0)
					]));
		case 8:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						A2(
							$lamdera$codecs$Lamdera$Wire3$encodePair,
							A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
							$author$project$Evergreen$V419$WordSpellingGame$w3_encode_LetterOrWildcard),
						v1),
						$author$project$Evergreen$V419$WordSpellingGame$w3_encode_Shared(v2)
					]));
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0)
					]));
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 15:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 14:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0)
					]));
		case 13:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		case 11:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$Evergreen$V419$WordSpellingGame$w3_encode_PlacedWord(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$author$project$Evergreen$V419$WordSpellingGame$w3_encode_PlacedWord(v0)
					]));
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(14);
		case 12:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$($lamdera$codecs$Lamdera$Wire3$encodeString, v0)
					]));
		case 17:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$author$project$Evergreen$V419$WordSpellingGame$w3_encode_ReactionTarget(v0),
						$author$project$Evergreen$V419$MessageView$w3_encode_MessageViewMsg(v1)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$author$project$Evergreen$V419$Scroll$w3_encode_ScrollPosition(v0)
					]));
	}
};
var $author$project$Evergreen$V419$Go$w3_encode_SetupMsg = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Evergreen$V419$Go$w3_encode_Stone(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V419$Go$w3_encode_SizeSelection(v0)
					]));
	}
};
var $author$project$Evergreen$V419$SheepGame$w3_encode_SetupMsg = function (w3v) {
	switch (w3v.$) {
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$FileStatus$w3_encode_FileId, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Http$w3_encode_Error, $author$project$Evergreen$V419$FileStatus$w3_encode_UploadResponse, v2)
					]));
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v0),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$($lamdera$program_test$Effect$File$w3_encode_File, v1)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 7:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$FileStatus$w3_encode_FileId, v1)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v0)
					]));
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 9:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$FileStatus$w3_encode_FileId, w3_rec_var0.fileId),
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.removeSpoiler)
								]));
					}(v1)
					]));
		case 8:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$FileStatus$w3_encode_FileId, v1)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_QuestionId, v0),
						$author$project$Evergreen$V419$MessageInput$w3_encode_Msg(v1)
					]));
	}
};
var $author$project$Evergreen$V419$WordSpellingGame$w3_encode_SetupMsg = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeChar(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Evergreen$V419$OneOrGreater$w3_encode_OneOrGreater(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Evergreen$V419$WordSpellingGame$w3_encode_Language(v0)
					]));
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
	}
};
var $author$project$Evergreen$V419$Game$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Go$w3_encode_GameMsg(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$Go$w3_encode_SetupMsg(v0)
					]));
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 10:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V419$Message$w3_encode_GameType(v0)
					]));
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v0)
					]));
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v0)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Evergreen$V419$SheepGame$w3_encode_GameMsg(v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V419$SheepGame$w3_encode_SetupMsg(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Evergreen$V419$WordSpellingGame$w3_encode_GameMsg(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$Evergreen$V419$WordSpellingGame$w3_encode_SetupMsg(v0)
					]));
	}
};
var $author$project$Evergreen$V419$Ports$w3_encode_CropImageDataResponse = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.croppedImageUrl),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.requestId)
			]));
};
var $author$project$Evergreen$V419$ImageEditor$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 9:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$codecs$Lamdera$Wire3$encodeString, $author$project$Evergreen$V419$Ports$w3_encode_CropImageDataResponse, v0)
					]));
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_encode_Error, $lamdera$program_test$Effect$Browser$Dom$w3_encode_Element, v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v1)
					]));
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v1)
					]));
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$lamdera$program_test$Effect$File$w3_encode_File(v0)
					]));
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Http$w3_encode_Error, $author$project$Evergreen$V419$FileStatus$w3_encode_UploadResponse, v0)
					]));
	}
};
var $author$project$Evergreen$V419$ImageViewer$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 11:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$ianmackenzie$elm_units$Duration$w3_encode_Duration(v0)
					]));
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v1)
					]));
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v1)
					]));
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 9:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeFloat, $lamdera$codecs$Lamdera$Wire3$encodeFloat),
						v0)
					]));
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeFloat, $lamdera$codecs$Lamdera$Wire3$encodeFloat),
						v0)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v2)
					]));
	}
};
var $author$project$Evergreen$V419$LoginForm$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
	}
};
var $author$project$Evergreen$V419$Table$w3_encode_Msg = function (w3v) {
	if (w3v.$ === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
				]));
	}
};
var $author$project$Evergreen$V419$Pages$Admin$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 19:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Editable$w3_encode_Msg$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$codecs$Lamdera$Wire3$encodeInt),
						v0)
					]));
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$Pages$Admin$w3_encode_UserTableId(v0),
						$author$project$Evergreen$V419$Pages$Admin$w3_encode_UserColumn(v1)
					]));
		case 7:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Evergreen$V419$Pages$Admin$w3_encode_UserTableId(v0),
						$author$project$Evergreen$V419$Pages$Admin$w3_encode_UserColumn(v1)
					]));
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 55:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeBytes(v0)
					]));
		case 54:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$lamdera$program_test$Effect$File$w3_encode_File(v0)
					]));
		case 36:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Evergreen$V419$Editable$w3_encode_Msg$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe(
							$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId)),
						v0)
					]));
		case 35:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Evergreen$V419$Editable$w3_encode_Msg$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$codecs$Lamdera$Wire3$encodeString),
						v0)
					]));
		case 34:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V419$Editable$w3_encode_Msg$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$codecs$Lamdera$Wire3$encodeString),
						v0)
					]));
		case 37:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Evergreen$V419$Editable$w3_encode_Msg$($author$project$Evergreen$V419$Postmark$w3_encode_ApiKey, v0)
					]));
		case 12:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		case 52:
			return $elm$bytes$Bytes$Encode$unsignedInt8(12);
		case 51:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Pagination$w3_encode_ItemId, v0)
					]));
		case 42:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 23:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId, v0)
					]));
		case 24:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v0)
					]));
		case 30:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0)
					]));
		case 59:
			return $elm$bytes$Bytes$Encode$unsignedInt8(19);
		case 57:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(20),
						$author$project$Evergreen$V419$SessionIdHash$w3_encode_SessionIdHash(v0)
					]));
		case 28:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(21),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_DmChannelId, v0)
					]));
		case 26:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(22),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_TeamId, v0)
					]));
		case 13:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(23),
						$author$project$Evergreen$V419$Pages$Admin$w3_encode_UserTableId(v0)
					]));
		case 56:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(24),
						$author$project$Evergreen$V419$SessionIdHash$w3_encode_SessionIdHash(v0),
						$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId(v1)
					]));
		case 46:
			return $elm$bytes$Bytes$Encode$unsignedInt8(25);
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(26),
						$author$project$Evergreen$V419$Pages$Admin$w3_encode_UserTableId(v0),
						$author$project$Evergreen$V419$Pages$Admin$w3_encode_UserColumn(v1)
					]));
		case 25:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(27),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v0)
					]));
		case 29:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(28),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(29),
						$author$project$Evergreen$V419$Pages$Admin$w3_encode_AdminUiSection(v0)
					]));
		case 27:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(30),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_TeamId, v0)
					]));
		case 44:
			return $elm$bytes$Bytes$Encode$unsignedInt8(31);
		case 45:
			return $elm$bytes$Bytes$Encode$unsignedInt8(32);
		case 38:
			return $elm$bytes$Bytes$Encode$unsignedInt8(33);
		case 53:
			return $elm$bytes$Bytes$Encode$unsignedInt8(34);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(35),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Pagination$w3_encode_PageId, v0)
					]));
		case 58:
			return $elm$bytes$Bytes$Encode$unsignedInt8(36);
		case 39:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(37),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, v2)
					]));
		case 40:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(38),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId, v1)
					]));
		case 41:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(39),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v1)
					]));
		case 14:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(40),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0)
					]));
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(41);
		case 31:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(42),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0)
					]));
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(43);
		case 61:
			return $elm$bytes$Bytes$Encode$unsignedInt8(44);
		case 60:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(45),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 33:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(46),
						$author$project$Evergreen$V419$Editable$w3_encode_Msg$($author$project$Evergreen$V419$LocalState$w3_encode_PrivateVapidKey, v0)
					]));
		case 32:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(47),
						$author$project$Evergreen$V419$Editable$w3_encode_Msg$($lamdera$codecs$Lamdera$Wire3$encodeString, v0)
					]));
		case 21:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(48),
						$author$project$Evergreen$V419$Editable$w3_encode_Msg$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$codecs$Lamdera$Wire3$encodeInt),
						v0)
					]));
		case 9:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(49),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 22:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(50),
						$author$project$Evergreen$V419$Pages$Admin$w3_encode_UserTableId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v1)
					]));
		case 18:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(51),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 16:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(52),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 50:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(53),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v1)
					]));
		case 49:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(54),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v1)
					]));
		case 48:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(55),
						$author$project$Evergreen$V419$DmChannelId$w3_encode_DmChannelId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v1)
					]));
		case 47:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(56),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v1)
					]));
		case 17:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(57),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 20:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(58),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(59),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 43:
			return $elm$bytes$Bytes$Encode$unsignedInt8(60);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(61),
						$author$project$Evergreen$V419$Table$w3_encode_Msg(v0)
					]));
	}
};
var $author$project$Evergreen$V419$RecoveryLogin$w3_encode_Msg = function (w3v) {
	if (w3v.$ === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
				]));
	}
};
var $author$project$Evergreen$V419$TextEditor$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
	}
};
var $author$project$Evergreen$V419$TwoFactorAuthentication$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
	}
};
var $author$project$Evergreen$V419$Internal$Teleport$w3_encode_CssAnimation = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.hash),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.keyframes),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.keyframesHash),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeString, $lamdera$codecs$Lamdera$Wire3$encodeString),
				w3_rec_var0.props),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.transition),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.trigger)
			]));
};
var $author$project$Evergreen$V419$Internal$Teleport$w3_encode_ParentTriggerDetails = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V419$Internal$Teleport$w3_encode_CssAnimation, w3_rec_var0.children),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.identifierClass),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.trigger)
			]));
};
var $author$project$Evergreen$V419$Internal$Teleport$w3_encode_Data = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$Internal$Teleport$w3_encode_CssAnimation(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Evergreen$V419$Internal$Teleport$w3_encode_ParentTriggerDetails(v0)
				]));
	}
};
var $author$project$Evergreen$V419$Internal$Teleport$w3_encode_Event = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Evergreen$V419$Internal$Teleport$w3_encode_Data, w3_rec_var0.data),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.timestamp)
			]));
};
var $author$project$Evergreen$V419$Internal$Teleport$w3_encode_Trigger = function (w3v) {
	switch (w3v) {
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
	}
};
var $author$project$Evergreen$V419$Internal$Model2$w3_encode_Msg = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$Internal$Teleport$w3_encode_Trigger(v0),
					$author$project$Evergreen$V419$Internal$Teleport$w3_encode_Event(v1)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					function (t) {
					return $lamdera$codecs$Lamdera$Wire3$encodeInt(
						$elm$time$Time$posixToMillis(t));
				}(v0)
				]));
	}
};
var $author$project$Evergreen$V419$Ui$Anim$w3_encode_Msg = $author$project$Evergreen$V419$Internal$Model2$w3_encode_Msg;
var $author$project$Evergreen$V419$Types$w3_encode_FrontendMsg_ = function (w3v) {
	switch (w3v.$) {
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Evergreen$V419$Pages$Admin$w3_encode_Msg(v0)
					]));
		case 76:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Evergreen$V419$AiChat$w3_encode_Msg(v0)
					]));
		case 54:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$ianmackenzie$elm_units$Duration$w3_encode_Duration(v0)
					]));
		case 71:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			var v6 = w3v.g;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId(v1),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v2),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v3),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v4),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v5),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, v6)
					]));
		case 49:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Evergreen$V419$Ports$w3_encode_NotificationPermission(v0)
					]));
		case 79:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Evergreen$V419$Id$w3_encode_GuildOrDmId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1)
					]));
		case 78:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Evergreen$V419$Id$w3_encode_GuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V419$SheepGame$w3_encode_Input(v2),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v3)
					]));
		case 37:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 153:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$program_test$Effect$Browser$Dom$w3_encode_HtmlId),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe(
							A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Evergreen$V419$Range$w3_encode_Range, $author$project$Evergreen$V419$Range$w3_encode_SelectionDirection)),
						v0)
					]));
		case 164:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Evergreen$V419$Drawing$w3_encode_Msg(v0)
					]));
		case 16:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V419$Types$w3_encode_EditChannelForm(v2)
					]));
		case 20:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Types$w3_encode_EditGuildForm(v1)
					]));
		case 94:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_encode_ThreadRoute, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$FileStatus$w3_encode_FileId, v2),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Http$w3_encode_Error, $author$project$Evergreen$V419$FileStatus$w3_encode_UploadResponse, v3)
					]));
		case 146:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRoute(v1),
						$author$project$Evergreen$V419$MessageInput$w3_encode_Msg(v2)
					]));
		case 90:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_encode_ThreadRoute, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$FileStatus$w3_encode_FileId, v1)
					]));
		case 92:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_encode_ThreadRoute, v0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$FileStatus$w3_encode_FileId, w3_rec_var0.fileId),
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.removeSpoiler)
								]));
					}(v1)
					]));
		case 91:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_encode_ThreadRoute, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$FileStatus$w3_encode_FileId, v1)
					]));
		case 93:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_encode_ThreadRoute, v0),
						$lamdera$program_test$Effect$File$w3_encode_File(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$program_test$Effect$File$w3_encode_File, v2)
					]));
		case 10:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$author$project$Evergreen$V419$Ui$Anim$w3_encode_Msg(v0)
					]));
		case 45:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(19),
						$author$project$Evergreen$V419$Emoji$w3_encode_Msg(v0)
					]));
		case 151:
			return $elm$bytes$Bytes$Encode$unsignedInt8(20);
		case 186:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(21),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$(
						$lamdera$codecs$Lamdera$Wire3$encodeString,
						$author$project$Evergreen$V419$Encryption$w3_encode_FromJs(
							$author$project$Evergreen$V419$Message$w3_encode_MessageContent$(
								$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_UserId),
								$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_ChannelId))),
						v0)
					]));
		case 158:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(22),
						$ianmackenzie$elm_units$Duration$w3_encode_Duration(v0)
					]));
		case 159:
			return $elm$bytes$Bytes$Encode$unsignedInt8(23);
		case 160:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(24),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$program_test$Effect$File$w3_encode_File, v0)
					]));
		case 95:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(25),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_encode_ThreadRoute, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$FileStatus$w3_encode_FileId, v1),
						$lamdera$program_test$Effect$Http$w3_encode_Progress(v2)
					]));
		case 32:
			return $elm$bytes$Bytes$Encode$unsignedInt8(26);
		case 77:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(27),
						$author$project$Evergreen$V419$Game$w3_encode_Msg(v0)
					]));
		case 80:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(28),
						$author$project$Evergreen$V419$Go$w3_encode_SpectatorMsg(v0)
					]));
		case 109:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(29),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v0)
					]));
		case 148:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(30),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Http$w3_encode_Error, $author$project$Evergreen$V419$Emoji$w3_encode_CachedEmojiData, v0)
					]));
		case 86:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(31),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_encode_ThreadRoute, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$FileStatus$w3_encode_FileId, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$FileStatus$w3_encode_FileMetadata, v2),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Http$w3_encode_Error, $author$project$Evergreen$V419$FileStatus$w3_encode_UploadResponse, v3)
					]));
		case 85:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(32),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_encode_ThreadRoute, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$FileStatus$w3_encode_FileId, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v2),
						$lamdera$codecs$Lamdera$Wire3$encodeBytes(v3)
					]));
		case 26:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(33),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.fileName),
									$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.json)
								]));
					}(v1)
					]));
		case 38:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(34),
						$lamdera$program_test$Effect$Browser$Dom$w3_encode_HtmlId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_encode_Error, $author$project$Evergreen$V419$MessageInput$w3_encode_MentionUserDropdown, v1)
					]));
		case 149:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(35),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_encode_Error, $lamdera$program_test$Effect$Browser$Dom$w3_encode_Element, v0)
					]));
		case 150:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(36),
						$author$project$Evergreen$V419$SheepGame$w3_encode_Input(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_encode_Error, $lamdera$program_test$Effect$Browser$Dom$w3_encode_Element, v1)
					]));
		case 98:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(37),
						$author$project$Evergreen$V419$Ports$w3_encode_RegisterPushSubscription(v0)
					]));
		case 163:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(38),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 124:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(39),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 108:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(40),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$codecs$Lamdera$Wire3$encodeString, $author$project$Evergreen$V419$Ports$w3_encode_StartupData, v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(41),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0)
					]));
		case 135:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(42),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$codecs$Lamdera$Wire3$encodeUnit, $lamdera$codecs$Lamdera$Wire3$encodeInt, v0)
					]));
		case 155:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(43),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$codecs$Lamdera$Wire3$encodeString, $author$project$Evergreen$V419$Call$w3_encode_FromJs, v0)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(44),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1)
					]));
		case 83:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(45),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$ImageEditor$w3_encode_Msg(v1)
					]));
		case 97:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(46),
						$author$project$Evergreen$V419$ImageViewer$w3_encode_Msg(v0)
					]));
		case 41:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(47),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.ctrlKey),
									$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.key),
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.metaKey),
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.shiftKey)
								]));
					}(v0)
					]));
		case 166:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(48),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($author$project$Evergreen$V419$Audio$w3_encode_LoadError, $author$project$Evergreen$V419$Audio$w3_encode_Source, v0)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(49),
						$author$project$Evergreen$V419$LoginForm$w3_encode_Msg(v0)
					]));
		case 147:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(50),
						$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRoute(v1),
						$author$project$Evergreen$V419$MessageInput$w3_encode_Msg(v2)
					]));
		case 55:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(51),
						$ianmackenzie$elm_units$Duration$w3_encode_Duration(v0)
					]));
		case 64:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(52),
						$author$project$Evergreen$V419$NonemptySet$w3_encode_NonemptySet$(
						$author$project$Evergreen$V419$Id$w3_encode_Id($author$project$Evergreen$V419$Id$w3_encode_CustomEmojiId),
						v0)
					]));
		case 68:
			return $elm$bytes$Bytes$Encode$unsignedInt8(53);
		case 69:
			return $elm$bytes$Bytes$Encode$unsignedInt8(54);
		case 62:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(55),
						$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 44:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(56),
						$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 63:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(57),
						$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 66:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(58),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_PrivateChannelId, v1)
					]));
		case 65:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(59),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0)
					]));
		case 47:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(60),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v0)
					]));
		case 43:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(61),
						$author$project$Evergreen$V419$Emoji$w3_encode_EmojiOrCustomEmoji(v0)
					]));
		case 46:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(62),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v0)
					]));
		case 42:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(63),
						$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v1),
						A2($author$project$Evergreen$V419$Coord$w3_encode_Coord, $author$project$Evergreen$V419$CssPixels$w3_encode_CssPixels, v2)
					]));
		case 96:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(64),
						$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v1),
						$author$project$Evergreen$V419$MessageView$w3_encode_MessageViewMsg(v2)
					]));
		case 14:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(65),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Types$w3_encode_NewChannelForm(v1)
					]));
		case 35:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(66),
						$author$project$Evergreen$V419$Types$w3_encode_NewGuildForm(v0)
					]));
		case 84:
			return $elm$bytes$Bytes$Encode$unsignedInt8(67);
		case 123:
			return $elm$bytes$Bytes$Encode$unsignedInt8(68);
		case 122:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(69),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 154:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(70),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_encode_Error, $lamdera$program_test$Effect$Browser$Dom$w3_encode_Viewport, v0)
					]));
		case 103:
			return $elm$bytes$Bytes$Encode$unsignedInt8(71);
		case 137:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(72),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 113:
			return $elm$bytes$Bytes$Encode$unsignedInt8(73);
		case 30:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(74),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v1)
					]));
		case 61:
			return $elm$bytes$Bytes$Encode$unsignedInt8(75);
		case 118:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(76),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0)
					]));
		case 70:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(77),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_encode_ThreadRoute, v0)
					]));
		case 57:
			return $elm$bytes$Bytes$Encode$unsignedInt8(78);
		case 157:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(79),
						$author$project$Evergreen$V419$UserSession$w3_encode_ChannelHeaderTab(v0)
					]));
		case 104:
			return $elm$bytes$Bytes$Encode$unsignedInt8(80);
		case 136:
			return $elm$bytes$Bytes$Encode$unsignedInt8(81);
		case 110:
			return $elm$bytes$Bytes$Encode$unsignedInt8(82);
		case 114:
			return $elm$bytes$Bytes$Encode$unsignedInt8(83);
		case 73:
			return $elm$bytes$Bytes$Encode$unsignedInt8(84);
		case 48:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(85),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_encode_ThreadRoute, v0)
					]));
		case 145:
			return $elm$bytes$Bytes$Encode$unsignedInt8(86);
		case 34:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(87),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 33:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(88),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 28:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(89),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0)
					]));
		case 120:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(90),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0)
					]));
		case 102:
			return $elm$bytes$Bytes$Encode$unsignedInt8(91);
		case 87:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(92),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_encode_ThreadRoute, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$FileStatus$w3_encode_FileId, v1)
					]));
		case 19:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(93),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelId, v1)
					]));
		case 23:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(94),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0)
					]));
		case 29:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(95),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$SecretId$w3_encode_SecretId$($author$project$Evergreen$V419$Id$w3_encode_InviteLinkId, v1)
					]));
		case 119:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(96),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0)
					]));
		case 129:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(97),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 133:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(98),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, w3_rec_var0.currentUserId),
									$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, w3_rec_var0.otherUserId)
								]));
					}(v0)
					]));
		case 106:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(99),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V419$User$w3_encode_NotificationLevel(v2)
					]));
		case 116:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(100),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 117:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(101),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0)
					]));
		case 74:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(102),
						$author$project$Evergreen$V419$UserSession$w3_encode_UserOptionSection(v0)
					]));
		case 115:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(103),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0)
					]));
		case 112:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(104),
						$author$project$Evergreen$V419$Id$w3_encode_ExportChannelId(v0)
					]));
		case 105:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(105),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$User$w3_encode_NotificationLevel(v1)
					]));
		case 59:
			return $elm$bytes$Bytes$Encode$unsignedInt8(106);
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(107),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 24:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(108),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0)
					]));
		case 27:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(109),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0)
					]));
		case 12:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(110),
						$author$project$Evergreen$V419$Route$w3_encode_Route(v0)
					]));
		case 162:
			return $elm$bytes$Bytes$Encode$unsignedInt8(111);
		case 9:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(112),
						$author$project$Evergreen$V419$SessionIdHash$w3_encode_SessionIdHash(v0)
					]));
		case 177:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(113),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage),
						v0)
					]));
		case 176:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(114),
						$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 111:
			return $elm$bytes$Bytes$Encode$unsignedInt8(115);
		case 172:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(116),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(v2)
					]));
		case 174:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(117),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, v2),
						$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(v3)
					]));
		case 179:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(118),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(v2)
					]));
		case 175:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(119),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_GuildId, v1),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_ChannelId, v2),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v3),
						$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(v4)
					]));
		case 178:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(120),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(v1)
					]));
		case 181:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(121),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_TeamId, v1),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_ChannelId, v2),
						$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(v3)
					]));
		case 182:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(122),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_TeamId, v1),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_ChannelId, v2),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v3),
						$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(v4)
					]));
		case 180:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(123),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_TeamId, v1),
						$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(v2)
					]));
		case 173:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(124),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v2),
						$author$project$Evergreen$V419$MuteSettings$w3_encode_IsMuted(v3)
					]));
		case 165:
			return $elm$bytes$Bytes$Encode$unsignedInt8(125);
		case 125:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(126),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 131:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(127),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0)
					]));
		case 192:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(128),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_UserId, v0)
					]));
		case 189:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(129),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_TeamId, v0)
					]));
		case 144:
			return $elm$bytes$Bytes$Encode$unsignedInt8(130);
		case 17:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(131),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelId, v1)
					]));
		case 21:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(132),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0)
					]));
		case 142:
			return $elm$bytes$Bytes$Encode$unsignedInt8(133);
		case 143:
			return $elm$bytes$Bytes$Encode$unsignedInt8(134);
		case 169:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(135),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 170:
			return $elm$bytes$Bytes$Encode$unsignedInt8(136);
		case 171:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(137),
						$author$project$Evergreen$V419$Route$w3_encode_Route(v0)
					]));
		case 139:
			return $elm$bytes$Bytes$Encode$unsignedInt8(138);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(139);
		case 58:
			return $elm$bytes$Bytes$Encode$unsignedInt8(140);
		case 167:
			return $elm$bytes$Bytes$Encode$unsignedInt8(141);
		case 72:
			return $elm$bytes$Bytes$Encode$unsignedInt8(142);
		case 130:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(143),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 107:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(144),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_UserId, v0),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_TeamId, v1),
						$author$project$Evergreen$V419$User$w3_encode_NotificationLevel(v2)
					]));
		case 18:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(145),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelId, v1),
						$author$project$Evergreen$V419$Types$w3_encode_EditChannelForm(v2)
					]));
		case 22:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(146),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Types$w3_encode_EditGuildForm(v1)
					]));
		case 15:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(147),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$author$project$Evergreen$V419$Types$w3_encode_NewChannelForm(v1)
					]));
		case 36:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(148),
						$author$project$Evergreen$V419$Types$w3_encode_NewGuildForm(v0)
					]));
		case 190:
			return $elm$bytes$Bytes$Encode$unsignedInt8(149);
		case 141:
			return $elm$bytes$Bytes$Encode$unsignedInt8(150);
		case 89:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(151),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_encode_ThreadRoute, v0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$FileStatus$w3_encode_FileId, w3_rec_var0.fileId),
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.removeSpoiler)
								]));
					}(v1)
					]));
		case 31:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(152),
						$author$project$Evergreen$V419$SecretId$w3_encode_SecretId$($author$project$Evergreen$V419$Id$w3_encode_InviteLinkId, v0)
					]));
		case 132:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(153),
						$author$project$Evergreen$V419$Discord$w3_encode_Id$($author$project$Evergreen$V419$Discord$w3_encode_UserId, v0)
					]));
		case 191:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(154),
						$author$project$Evergreen$V419$Slack$w3_encode_Id$($author$project$Evergreen$V419$Slack$w3_encode_UserId, v0)
					]));
		case 161:
			return $elm$bytes$Bytes$Encode$unsignedInt8(155);
		case 88:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(156),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_encode_ThreadRoute, v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$FileStatus$w3_encode_FileId, v1)
					]));
		case 82:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(157),
						$author$project$Evergreen$V419$ImageEditor$w3_encode_Msg(v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(158),
						$author$project$Evergreen$V419$RecoveryLogin$w3_encode_Msg(v0)
					]));
		case 40:
			return $elm$bytes$Bytes$Encode$unsignedInt8(159);
		case 127:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(160),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.bottom),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.top)
								]));
					}(v0)
					]));
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(161);
		case 67:
			return $elm$bytes$Bytes$Encode$unsignedInt8(162);
		case 100:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(163),
						$author$project$Evergreen$V419$User$w3_encode_EmailNotifications(v0)
					]));
		case 101:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(164),
						$author$project$Evergreen$V419$User$w3_encode_EmbedVisibility(v0)
					]));
		case 13:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(165),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_encode_ThreadRoute, v0),
						$lamdera$program_test$Effect$File$w3_encode_File(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$program_test$Effect$File$w3_encode_File, v2)
					]));
		case 25:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(166),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_GuildId, v0),
						$lamdera$program_test$Effect$File$w3_encode_File(v1)
					]));
		case 99:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(167),
						$author$project$Evergreen$V419$UserSession$w3_encode_NotificationMode(v0)
					]));
		case 140:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(168),
						$author$project$Evergreen$V419$UserColor$w3_encode_Selection(v0)
					]));
		case 39:
			return $elm$bytes$Bytes$Encode$unsignedInt8(169);
		case 56:
			return $elm$bytes$Bytes$Encode$unsignedInt8(170);
		case 128:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(171),
						$author$project$Evergreen$V419$TextEditor$w3_encode_Msg(v0)
					]));
		case 152:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(172),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$program_test$Effect$Browser$Dom$w3_encode_HtmlId),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe(
							A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Evergreen$V419$Range$w3_encode_Range, $author$project$Evergreen$V419$Range$w3_encode_SelectionDirection)),
						v0)
					]));
		case 53:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(173),
						$ianmackenzie$elm_units$Duration$w3_encode_Duration(v0)
					]));
		case 52:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(174),
						$ianmackenzie$elm_units$Duration$w3_encode_Duration(v0)
					]));
		case 51:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(175),
						$ianmackenzie$elm_units$Duration$w3_encode_Duration(v0),
						$author$project$Evergreen$V419$NonemptyDict$w3_encode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$Evergreen$V419$Touch$w3_encode_Touch, v1)
					]));
		case 50:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(176),
						$ianmackenzie$elm_units$Duration$w3_encode_Duration(v0),
						$author$project$Evergreen$V419$NonemptyDict$w3_encode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$Evergreen$V419$Touch$w3_encode_Touch, v1)
					]));
		case 75:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(177),
						$author$project$Evergreen$V419$TwoFactorAuthentication$w3_encode_Msg(v0)
					]));
		case 134:
			return $elm$bytes$Bytes$Encode$unsignedInt8(178);
		case 138:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(179),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 121:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(180),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_UserId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 168:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(181),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 187:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(182),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 188:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(183),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 183:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(184),
						$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V419$MessageView$w3_encode_MessageViewMsg(v2)
					]));
		case 184:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(185),
						$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Evergreen$V419$Id$w3_encode_Id$($author$project$Evergreen$V419$Id$w3_encode_ThreadMessageId, v2),
						$author$project$Evergreen$V419$MessageView$w3_encode_MessageViewMsg(v3)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(186),
						$elm$url$Url$w3_encode_Url(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(187),
						$elm$browser$Browser$w3_encode_UrlRequest(v0)
					]));
		case 81:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(188),
						$author$project$Evergreen$V419$Editable$w3_encode_Msg$($author$project$Evergreen$V419$PersonName$w3_encode_PersonName, v0)
					]));
		case 60:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(189),
						$author$project$Evergreen$V419$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Evergreen$V419$Id$w3_encode_ThreadRoute(v1),
						$author$project$Evergreen$V419$Scroll$w3_encode_ScrollPosition(v2)
					]));
		case 185:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(190),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0),
						$author$project$Evergreen$V419$Types$w3_encode_E2eeKeysValid(v1)
					]));
		case 126:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(191),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.height),
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.top)
								]));
					}(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(192),
						$author$project$Evergreen$V419$Call$w3_encode_Msg(v0)
					]));
	}
};
var $author$project$Evergreen$V419$Audio$w3_encode_AudioLoadRequest_ = function (w3_x_c_userMsg) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.audioUrl),
					$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						A2($lamdera$codecs$Lamdera$Wire3$encodeResult, $author$project$Evergreen$V419$Audio$w3_encode_LoadError, $author$project$Evergreen$V419$Audio$w3_encode_Source),
						w3_x_c_userMsg),
					w3_rec_var0.userMsg)
				]));
	};
};
var $author$project$Evergreen$V419$Audio$w3_encode_LoopConfig = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var0.loopEnd),
				$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var0.loopStart)
			]));
};
var $author$project$Evergreen$V419$Audio$w3_encode_FlattenedAudio = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Evergreen$V419$Audio$w3_encode_LoopConfig, w3_rec_var0.loop),
				$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var0.offset),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.playbackRate),
				$author$project$Evergreen$V419$Audio$w3_encode_Source(w3_rec_var0.source),
				$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var0.startAt),
				function (t) {
				return $lamdera$codecs$Lamdera$Wire3$encodeInt(
					$elm$time$Time$posixToMillis(t));
			}(w3_rec_var0.startTime),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.volume),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty(
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						function (t) {
							return $lamdera$codecs$Lamdera$Wire3$encodeInt(
								$elm$time$Time$posixToMillis(t));
						},
						$lamdera$codecs$Lamdera$Wire3$encodeFloat)),
				w3_rec_var0.volumeTimelines)
			]));
};
var $author$project$Evergreen$V419$Audio$w3_encode_NodeGroupId = $lamdera$codecs$Lamdera$Wire3$encodeInt;
var $author$project$Evergreen$V419$Audio$w3_encode_SourceData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var0.duration)
			]));
};
var $author$project$Evergreen$V419$Audio$w3_encode_Model_$ = function (w3_x_c_userMsg, w3_x_c_userModel) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$codecs$Lamdera$Wire3$encodeDict$($author$project$Evergreen$V419$Audio$w3_encode_NodeGroupId, $author$project$Evergreen$V419$Audio$w3_encode_FlattenedAudio, w3_rec_var0.audioState),
					$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.nodeGroupIdCounter),
					$lamdera$codecs$Lamdera$Wire3$encodeDict$(
					$lamdera$codecs$Lamdera$Wire3$encodeInt,
					$author$project$Evergreen$V419$Audio$w3_encode_AudioLoadRequest_(w3_x_c_userMsg),
					w3_rec_var0.pendingRequests),
					$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.requestCount),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.samplesPerSecond),
					$lamdera$codecs$Lamdera$Wire3$encodeDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$Evergreen$V419$Audio$w3_encode_SourceData, w3_rec_var0.sourceData),
					w3_x_c_userModel(w3_rec_var0.userModel)
				]));
	};
};
var $author$project$Evergreen$V419$Audio$w3_encode_Model_ = F2($author$project$Evergreen$V419$Audio$w3_encode_Model_$);
var $author$project$Evergreen$V419$Audio$w3_encode_Model$ = function (w3_x_c_userMsg, w3_x_c_userModel, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				A3($author$project$Evergreen$V419$Audio$w3_encode_Model_, w3_x_c_userMsg, w3_x_c_userModel, v0)
			]));
};
var $author$project$Evergreen$V419$Audio$w3_encode_Model = F3($author$project$Evergreen$V419$Audio$w3_encode_Model$);
var $author$project$Evergreen$V419$Types$w3_encode_FrontendModel = A2($author$project$Evergreen$V419$Audio$w3_encode_Model, $author$project$Evergreen$V419$Types$w3_encode_FrontendMsg_, $author$project$Evergreen$V419$Types$w3_encode_FrontendModel_);
var $author$project$Evergreen$V417$Types$Loaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Types$Loading = function (a) {
	return {$: 0, a: a};
};
var $lamdera$codecs$Lamdera$Wire3$andThenDecode = $elm$bytes$Bytes$Decode$andThen;
var $lamdera$codecs$Lamdera$Wire3$failDecode = $elm$bytes$Bytes$Decode$fail;
var $lamdera$codecs$Lamdera$Wire3$decodeList = function (decoder) {
	var listStep = function (_v0) {
		var n = _v0.a;
		var xs = _v0.b;
		return (n <= 0) ? $elm$bytes$Bytes$Decode$succeed(
			$elm$bytes$Bytes$Decode$Done(xs)) : $elm$bytes$Bytes$Decode$map$(
			function (x) {
				return $elm$bytes$Bytes$Decode$Loop(
					_Utils_Tuple2(
						n - 1,
						A2($elm$core$List$cons, x, xs)));
			},
			decoder);
	};
	return $elm$bytes$Bytes$Decode$andThen$(
		function (len) {
			return $elm$bytes$Bytes$Decode$map$(
				$elm$core$List$reverse,
				$elm$bytes$Bytes$Decode$loop$(
					_Utils_Tuple2(len, _List_Nil),
					listStep));
		},
		$lamdera$codecs$Lamdera$Wire3$decodeInt64);
};
var $lamdera$codecs$Lamdera$Wire3$decodeArray = function (a) {
	return $elm$bytes$Bytes$Decode$map$(
		$elm$core$Array$fromList,
		$lamdera$codecs$Lamdera$Wire3$decodeList(a));
};
var $lamdera$codecs$Lamdera$Wire3$decodeBool = $elm$bytes$Bytes$Decode$andThen$(
	function (s) {
		switch (s) {
			case 0:
				return $elm$bytes$Bytes$Decode$succeed(false);
			case 1:
				return $elm$bytes$Bytes$Decode$succeed(true);
			default:
				return $elm$bytes$Bytes$Decode$fail;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $lamdera$codecs$Lamdera$Wire3$decodeMaybe = function (decVal) {
	return $elm$bytes$Bytes$Decode$andThen$(
		function (c) {
			switch (c) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Maybe$Nothing);
				case 1:
					return $elm$bytes$Bytes$Decode$map$($elm$core$Maybe$Just, decVal);
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $lamdera$codecs$Lamdera$Wire3$decodeResult$ = function (decErr, decVal) {
	return $elm$bytes$Bytes$Decode$andThen$(
		function (c) {
			switch (c) {
				case 0:
					return $elm$bytes$Bytes$Decode$map$($elm$core$Result$Ok, decVal);
				case 1:
					return $elm$bytes$Bytes$Decode$map$($elm$core$Result$Err, decErr);
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $lamdera$codecs$Lamdera$Wire3$decodeResult = F2($lamdera$codecs$Lamdera$Wire3$decodeResult$);
var $lamdera$codecs$Lamdera$Wire3$decodeChar = $elm$bytes$Bytes$Decode$map$($elm$core$Char$fromCode, $lamdera$codecs$Lamdera$Wire3$decodeInt64);
var $lamdera$codecs$Lamdera$Wire3$decodePair$ = function (c_a, c_b) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		c_b,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			c_a,
			$elm$bytes$Bytes$Decode$succeed(
				F2(
					function (a, b) {
						return _Utils_Tuple2(a, b);
					}))));
};
var $lamdera$codecs$Lamdera$Wire3$decodePair = F2($lamdera$codecs$Lamdera$Wire3$decodePair$);
var $lamdera$codecs$Lamdera$Wire3$decodeDict$ = function (decKey, decValue) {
	return $elm$bytes$Bytes$Decode$map$(
		$elm$core$Dict$fromList,
		$lamdera$codecs$Lamdera$Wire3$decodeList(
			$lamdera$codecs$Lamdera$Wire3$decodePair$(decKey, decValue)));
};
var $lamdera$codecs$Lamdera$Wire3$decodeDict = F2($lamdera$codecs$Lamdera$Wire3$decodeDict$);
var $lamdera$containers$SeqDict$decodeDict$ = function (decKey, decValue) {
	return $elm$bytes$Bytes$Decode$map$(
		$lamdera$containers$SeqDict$fromList,
		$lamdera$codecs$Lamdera$Wire3$decodeList(
			$lamdera$codecs$Lamdera$Wire3$decodePair$(decKey, decValue)));
};
var $lamdera$containers$SeqDict$decodeDict = F2($lamdera$containers$SeqDict$decodeDict$);
var $lamdera$codecs$Lamdera$Wire3$decodeString = $elm$bytes$Bytes$Decode$andThen$($elm$bytes$Bytes$Decode$string, $lamdera$codecs$Lamdera$Wire3$decodeInt64);
var $author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiArt = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (sequence0, sprite0) {
					return {sequence: sequence0, sprite: sprite0};
				}))));
var $author$project$Evergreen$V417$Emoji$Activities = 0;
var $author$project$Evergreen$V417$Emoji$AnimalsAndNature = 1;
var $author$project$Evergreen$V417$Emoji$Components = 2;
var $author$project$Evergreen$V417$Emoji$Flags = 3;
var $author$project$Evergreen$V417$Emoji$FoodAndDrink = 4;
var $author$project$Evergreen$V417$Emoji$Objects = 5;
var $author$project$Evergreen$V417$Emoji$PeopleAndBody = 6;
var $author$project$Evergreen$V417$Emoji$SmileysAndEmotion = 7;
var $author$project$Evergreen$V417$Emoji$Symbols = 8;
var $author$project$Evergreen$V417$Emoji$TravelAndPlaces = 9;
var $author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiCategory = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(8);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(9);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeString),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiCategory,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (category0, shortNames0, skinVariations0) {
						return {category: category0, shortNames: shortNames0, skinVariations: skinVariations0};
					})))));
var $author$project$Evergreen$V417$Emoji$UnicodeEmoji = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Emoji$w3_unsafe_decode_UnicodeEmoji = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Emoji$w3_unsafe_decode_CachedEmojiData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeArray(
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_UnicodeEmoji,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F2(
						function (emoji0, shortName0) {
							return {emoji: emoji0, shortName: shortName0};
						}))))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V417$Emoji$w3_unsafe_decode_UnicodeEmoji, $author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiData),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiCategory,
				$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V417$Emoji$w3_unsafe_decode_UnicodeEmoji)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeDict$(
					$lamdera$codecs$Lamdera$Wire3$decodeChar,
					$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiArt)),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (art0, categories0, emojis0, shortNames0) {
							return {art: art0, categories: categories0, emojis: emojis0, shortNames: shortNames0};
						}))))));
var $lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $ianmackenzie$elm_units$Quantity$w3_unsafe_decode_Quantity$ = function (w3_x_c_number, w3_x_c_units) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					w3_x_c_number,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $ianmackenzie$elm_units$Quantity$w3_unsafe_decode_Quantity = F2($ianmackenzie$elm_units$Quantity$w3_unsafe_decode_Quantity$);
var $author$project$Evergreen$V417$Coord$w3_unsafe_decode_Coord = function (w3_x_c_units) {
	return $lamdera$codecs$Lamdera$Wire3$decodePair$(
		$ianmackenzie$elm_units$Quantity$w3_unsafe_decode_Quantity$($lamdera$codecs$Lamdera$Wire3$decodeInt, w3_x_c_units),
		$ianmackenzie$elm_units$Quantity$w3_unsafe_decode_Quantity$($lamdera$codecs$Lamdera$Wire3$decodeInt, w3_x_c_units));
};
var $author$project$Evergreen$V417$CssPixels$CssPixels = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Touch$DragStart$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V417$Touch$DragStart = F2($author$project$Evergreen$V417$Touch$DragStart$);
var $author$project$Evergreen$V417$Touch$Dragging = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$Touch$NoDrag = {$: 0};
var $author$project$Evergreen$V417$Touch$Drag_CallThumbnail = 1;
var $author$project$Evergreen$V417$Touch$Drag_Channel = 0;
var $author$project$Evergreen$V417$Touch$Drag_Game = 2;
var $author$project$Evergreen$V417$Touch$w3_unsafe_decode_DragTarget = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$NonemptyDict$NonemptyDict$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$NonemptyDict$NonemptyDict = F3($author$project$Evergreen$V417$NonemptyDict$NonemptyDict$);
var $author$project$Evergreen$V417$NonemptyDict$w3_unsafe_decode_NonemptyDict$ = function (w3_x_c_id, w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(w3_x_c_id, w3_x_c_a),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_a,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							w3_x_c_id,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$NonemptyDict$NonemptyDict))));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$NonemptyDict$w3_unsafe_decode_NonemptyDict = F2($author$project$Evergreen$V417$NonemptyDict$w3_unsafe_decode_NonemptyDict$);
var $lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (t) {
		return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
			$elm$time$Time$millisToPosix(t));
	},
	$lamdera$codecs$Lamdera$Wire3$decodeInt);
var $author$project$Evergreen$V417$Geometry$Types$Point2d = $elm$core$Basics$identity;
var $lamdera$codecs$Lamdera$Wire3$decodeFloat = $lamdera$codecs$Lamdera$Wire3$decodeFloat64;
var $author$project$Evergreen$V417$Geometry$Types$w3_unsafe_decode_Point2d$ = function (w3_x_c_units, w3_x_c_coordinates) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeFloat,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (x0, y0) {
										return {x: x0, y: y0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$Geometry$Types$w3_unsafe_decode_Point2d = F2($author$project$Evergreen$V417$Geometry$Types$w3_unsafe_decode_Point2d$);
var $author$project$Evergreen$V417$Point2d$w3_unsafe_decode_Point2d$ = function (w3_x_c_units, w3_x_c_coordinates) {
	return $author$project$Evergreen$V417$Geometry$Types$w3_unsafe_decode_Point2d$(w3_x_c_units, w3_x_c_coordinates);
};
var $author$project$Evergreen$V417$Point2d$w3_unsafe_decode_Point2d = F2($author$project$Evergreen$V417$Point2d$w3_unsafe_decode_Point2d$);
var $author$project$Evergreen$V417$Touch$ScreenCoordinate = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Touch$w3_unsafe_decode_ScreenCoordinate = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Touch$w3_unsafe_decode_Touch = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Point2d$w3_unsafe_decode_Point2d$($author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels, $author$project$Evergreen$V417$Touch$w3_unsafe_decode_ScreenCoordinate),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (client0, targetIsTextInput0) {
					return {client: client0, targetIsTextInput: targetIsTextInput0};
				}))));
var $author$project$Evergreen$V417$Touch$w3_unsafe_decode_Drag = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$NonemptyDict$w3_unsafe_decode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$Evergreen$V417$Touch$w3_unsafe_decode_Touch),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Touch$DragStart)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$NonemptyDict$w3_unsafe_decode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$Evergreen$V417$Touch$w3_unsafe_decode_Touch),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Touch$w3_unsafe_decode_DragTarget,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeBool,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (horizontalStart0, target0, touches0) {
											return {horizontalStart: horizontalStart0, target: target0, touches: touches0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Touch$Dragging));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Touch$NoDrag);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$AiChat$AiModelName = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$AiChat$w3_unsafe_decode_AiModelName = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$AiChat$LoadedAiModels = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$AiChat$LoadingAiModels = {$: 0};
var $author$project$Evergreen$V417$AiChat$LoadingFailed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$AiChat$w3_unsafe_decode_AiModel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeString),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$AiChat$w3_unsafe_decode_AiModelName,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, inputs0) {
					return {id: id0, inputs: inputs0};
				}))));
var $lamdera$program_test$Effect$Http$w3_unsafe_decode_Error = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($lamdera$program_test$Effect$Http$BadBody));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($lamdera$program_test$Effect$Http$BadStatus));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($lamdera$program_test$Effect$Http$BadUrl));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($lamdera$program_test$Effect$Http$NetworkError);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($lamdera$program_test$Effect$Http$Timeout);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$AiChat$w3_unsafe_decode_AiModelsStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V417$AiChat$w3_unsafe_decode_AiModel),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$AiChat$LoadedAiModels));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$AiChat$LoadingAiModels);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$AiChat$LoadingFailed));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$AiChat$GotError$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V417$AiChat$GotError = F2($author$project$Evergreen$V417$AiChat$GotError$);
var $author$project$Evergreen$V417$AiChat$GotResponse$ = function (a, b, c, d) {
	return {$: 1, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$AiChat$GotResponse = F4($author$project$Evergreen$V417$AiChat$GotResponse$);
var $author$project$Evergreen$V417$AiChat$Pending = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$AiChat$w3_unsafe_decode_PendingResponse = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$AiChat$w3_unsafe_decode_AiModelName,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$AiChat$GotError)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeFloat),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeString,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$AiChat$w3_unsafe_decode_AiModelName,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$AiChat$GotResponse)))));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$AiChat$w3_unsafe_decode_AiModelName,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$AiChat$Pending));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$AiChat$RespondId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$AiChat$w3_unsafe_decode_ResponseId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$AiChat$SendWithEnter = 0;
var $author$project$Evergreen$V417$AiChat$SendWithShiftEnter = 1;
var $author$project$Evergreen$V417$AiChat$w3_unsafe_decode_SendMessageWith = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$AiChat$w3_unsafe_decode_FrontendModel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$AiChat$w3_unsafe_decode_SendMessageWith,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V417$AiChat$w3_unsafe_decode_AiModelName),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V417$AiChat$w3_unsafe_decode_ResponseId, $author$project$Evergreen$V417$AiChat$w3_unsafe_decode_PendingResponse),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeString,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$AiChat$w3_unsafe_decode_AiModelsStatus,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F9(
											function (aiModels0, chatHistory0, debounceCounter0, message0, pendingResponses0, responseCounter0, selectedModels0, sendMessageWith0, showOptions0) {
												return {aiModels: aiModels0, chatHistory: chatHistory0, debounceCounter: debounceCounter0, message: message0, pendingResponses: pendingResponses0, responseCounter: responseCounter0, selectedModels: selectedModels0, sendMessageWith: sendMessageWith0, showOptions: showOptions0};
											})))))))))));
var $elm$browser$Browser$Navigation$Key = 0;
var $elm$browser$Browser$Navigation$w3_unsafe_decode_Key = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $lamdera$program_test$Effect$Browser$Navigation$w3_unsafe_decode_Key = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($lamdera$program_test$Effect$Browser$Navigation$MockNavigationKey);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$elm$browser$Browser$Navigation$w3_unsafe_decode_Key,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($lamdera$program_test$Effect$Browser$Navigation$RealNavigationKey));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$MyUi$CopiedImage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$MyUi$CopiedText = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$MyUi$w3_unsafe_decode_Copied = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MyUi$CopiedImage));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MyUi$CopiedText));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$MyUi$w3_unsafe_decode_LastCopy = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (t) {
			return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
				$elm$time$Time$millisToPosix(t));
		},
		$lamdera$codecs$Lamdera$Wire3$decodeInt),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$MyUi$w3_unsafe_decode_Copied,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (copied0, copiedAt0) {
					return {copied: copied0, copiedAt: copiedAt0};
				}))));
var $author$project$Evergreen$V417$Audio$ErrorThatHappensWhenYouLoadMoreThan1000SoundsDueToHackyWorkAroundToMakeThisPackageBehaveMoreLikeAnEffectPackage = 3;
var $author$project$Evergreen$V417$Audio$FailedToDecode = 0;
var $author$project$Evergreen$V417$Audio$NetworkError = 1;
var $author$project$Evergreen$V417$Audio$UnknownError = 2;
var $author$project$Evergreen$V417$Audio$w3_unsafe_decode_LoadError = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Types$LoggedIn = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Types$NotLoggedIn = function (a) {
	return {$: 1, a: a};
};
var $lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_HtmlId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Id$InviteLinkId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Id$w3_unsafe_decode_InviteLinkId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $lamdera$containers$SeqSet$decodeSet = function (decVal) {
	return $elm$bytes$Bytes$Decode$map$(
		$lamdera$containers$SeqSet$fromList,
		$lamdera$codecs$Lamdera$Wire3$decodeList(decVal));
};
var $author$project$Evergreen$V417$Id$DiscordGuildOrDmId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Id$GuildOrDmId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Id$SlackGuildOrDmId = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$Id$DiscordGuildOrDmId_Dm = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Id$DiscordGuildOrDmId_Guild = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Discord$ChannelId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Discord$GuildId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Discord$Id = $elm$core$Basics$identity;
var $lamdera$codecs$Lamdera$Wire3$decodeTriple$ = function (c_a, c_b, c_c) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		c_c,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			c_b,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				c_a,
				$elm$bytes$Bytes$Decode$succeed(
					F3(
						function (a, b, c) {
							return _Utils_Tuple3(a, b, c);
						})))));
};
var $lamdera$codecs$Lamdera$Wire3$decodeTriple = F3($lamdera$codecs$Lamdera$Wire3$decodeTriple$);
var $MartinSStewart$elm_uint64$UInt64$w3_unsafe_decode_UInt16 = $lamdera$codecs$Lamdera$Wire3$decodeInt;
var $MartinSStewart$elm_uint64$UInt64$w3_unsafe_decode_UInt24 = $lamdera$codecs$Lamdera$Wire3$decodeInt;
var $MartinSStewart$elm_uint64$UInt64$w3_unsafe_decode_UInt64 = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeTriple$($MartinSStewart$elm_uint64$UInt64$w3_unsafe_decode_UInt16, $MartinSStewart$elm_uint64$UInt64$w3_unsafe_decode_UInt24, $MartinSStewart$elm_uint64$UInt64$w3_unsafe_decode_UInt24),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id = function (w3_x_c_idType) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$MartinSStewart$elm_uint64$UInt64$w3_unsafe_decode_UInt64,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$Discord$UserId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DiscordChannelId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (channelId0, currentUserId0, guildId0) {
						return {channelId: channelId0, currentUserId: currentUserId0, guildId: guildId0};
					})))));
var $author$project$Evergreen$V417$Discord$PrivateChannelId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DiscordDmId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (channelId0, currentUserId0) {
					return {channelId: channelId0, currentUserId: currentUserId0};
				}))));
var $author$project$Evergreen$V417$Id$w3_unsafe_decode_DiscordGuildOrDmId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DiscordDmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Id$DiscordGuildOrDmId_Dm));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DiscordChannelId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Id$DiscordGuildOrDmId_Guild));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Id$GuildOrDmId_Dm = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Id$GuildOrDmId_Guild = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Id$ChannelId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Id$GuildId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Id$Id = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Id$w3_unsafe_decode_Id = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_ChannelId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (channelId0, guildId0) {
					return {channelId: channelId0, guildId: guildId0};
				}))));
var $author$project$Evergreen$V417$Id$UserId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DmId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$succeedDecode(
		function (otherUserId0) {
			return {otherUserId: otherUserId0};
		}));
var $author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildOrDmId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Id$GuildOrDmId_Dm));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_ChannelId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Id$GuildOrDmId_Guild));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Id$SlackGuildOrDmId_Dm = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Id$SlackGuildOrDmId_Workspace = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Slack$ChannelId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Slack$Id = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$Slack$TeamId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Slack$UserId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_SlackChannelId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (channelId0, currentUserId0, teamId0) {
						return {channelId: channelId0, currentUserId: currentUserId0, teamId: teamId0};
					})))));
var $author$project$Evergreen$V417$Slack$DmChannelId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Slack$w3_unsafe_decode_DmChannelId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_SlackDmId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_DmChannelId),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (channelId0, currentUserId0) {
					return {channelId: channelId0, currentUserId: currentUserId0};
				}))));
var $author$project$Evergreen$V417$Id$w3_unsafe_decode_SlackGuildOrDmId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_SlackDmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Id$SlackGuildOrDmId_Dm));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_SlackChannelId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Id$SlackGuildOrDmId_Workspace));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_DiscordGuildOrDmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Id$DiscordGuildOrDmId));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildOrDmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Id$GuildOrDmId));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_SlackGuildOrDmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Id$SlackGuildOrDmId));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Id$ChannelMessageId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Route$ChannelSidebarDragging = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Route$ChannelSidebarNotDragging = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Route$w3_unsafe_decode_ChannelSidebarMode = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeFloat,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeFloat,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (offset0, previousOffset0, time0) {
											return {offset: offset0, previousOffset: previousOffset0, time: time0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Route$ChannelSidebarDragging));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							function (offset0) {
								return {offset: offset0};
							})),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Route$ChannelSidebarNotDragging));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_EditChannelForm = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (deleteConfirmation0, description0, name0, pressedSubmit0, showDeleteConfirmation0) {
								return {deleteConfirmation: deleteConfirmation0, description: description0, name: name0, pressedSubmit: pressedSubmit0, showDeleteConfirmation: showDeleteConfirmation0};
							})))))));
var $author$project$Evergreen$V417$Types$ImportChannelFailed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$Types$ImportedChannel = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V417$Types$ImportingChannel = {$: 1};
var $author$project$Evergreen$V417$Types$NotImportingChannel = {$: 0};
var $author$project$Evergreen$V417$Types$NotAChannelExport = 0;
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_ImportChannelError = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_ImportChannelStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Types$w3_unsafe_decode_ImportChannelError,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$ImportChannelFailed));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							function (encryptedMessages0) {
								return {encryptedMessages: encryptedMessages0};
							})),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$ImportedChannel));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$ImportingChannel);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$NotImportingChannel);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_EditGuildForm = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeBool,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Types$w3_unsafe_decode_ImportChannelStatus,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F6(
								function (deleteConfirmation0, importChannel0, name0, pressedSubmit0, showDeleteConfirmation0, showLeaveConfirmation0) {
									return {deleteConfirmation: deleteConfirmation0, importChannel: importChannel0, name: name0, pressedSubmit: pressedSubmit0, showDeleteConfirmation: showDeleteConfirmation0, showLeaveConfirmation: showLeaveConfirmation0};
								}))))))));
var $author$project$Evergreen$V417$FileStatus$FileId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$FileStatus$FileError$ = function (a, b, c, d, e) {
	return {$: 2, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V417$FileStatus$FileError = F5($author$project$Evergreen$V417$FileStatus$FileError$);
var $author$project$Evergreen$V417$FileStatus$FileUploaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$FileStatus$FileUploading$ = function (a, b, c, d) {
	return {$: 0, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$FileStatus$FileUploading = F4($author$project$Evergreen$V417$FileStatus$FileUploading$);
var $author$project$Evergreen$V417$FileStatus$ContentType = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_ContentType = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$FileStatus$FileHash = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$FileStatus$FileMetadata_Image = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$FileStatus$FileMetadata_Video = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_ExposureTime = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (denominator0, numerator0) {
					return {denominator: denominator0, numerator: numerator0};
				}))));
var $author$project$Evergreen$V417$SafeFloat$SafeFloat = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$SafeFloat$w3_unsafe_decode_SafeFloat = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeFloat,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_Location = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$SafeFloat$w3_unsafe_decode_SafeFloat,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$SafeFloat$w3_unsafe_decode_SafeFloat,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (lat0, lon0) {
					return {lat: lat0, lon: lon0};
				}))));
var $author$project$Evergreen$V417$FileStatus$Mirrored = 4;
var $author$project$Evergreen$V417$FileStatus$MirroredRotation180 = 6;
var $author$project$Evergreen$V417$FileStatus$MirroredRotation270 = 7;
var $author$project$Evergreen$V417$FileStatus$MirroredRotation90 = 5;
var $author$project$Evergreen$V417$FileStatus$NoChange = 0;
var $author$project$Evergreen$V417$FileStatus$Rotation180 = 2;
var $author$project$Evergreen$V417$FileStatus$Rotation270 = 3;
var $author$project$Evergreen$V417$FileStatus$Rotation90 = 1;
var $author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_Orientation = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_ImageMetadata = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_Orientation),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_Location),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$SafeFloat$w3_unsafe_decode_SafeFloat),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$SafeFloat$w3_unsafe_decode_SafeFloat),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_ExposureTime),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
												$lamdera$codecs$Lamdera$Wire3$succeedDecode(
													function (cameraOwner0) {
														return function (exposureTime0) {
															return function (fNumber0) {
																return function (focalLength0) {
																	return function (gpsLocation0) {
																		return function (imageSize0) {
																			return function (isoSpeedRating0) {
																				return function (make0) {
																					return function (model0) {
																						return function (orientation0) {
																							return function (software0) {
																								return function (userComment0) {
																									return {cameraOwner: cameraOwner0, exposureTime: exposureTime0, fNumber: fNumber0, focalLength: focalLength0, gpsLocation: gpsLocation0, imageSize: imageSize0, isoSpeedRating: isoSpeedRating0, make: make0, model: model0, orientation: orientation0, software: software0, userComment: userComment0};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													})))))))))))));
var $ianmackenzie$elm_units$Duration$Seconds = 0;
var $ianmackenzie$elm_units$Duration$w3_unsafe_decode_Seconds = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration = $ianmackenzie$elm_units$Quantity$w3_unsafe_decode_Quantity$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $ianmackenzie$elm_units$Duration$w3_unsafe_decode_Seconds);
var $author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_VideoMetadata = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_Orientation,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_Location),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F7(
									function (codec0, createdAt0, duration0, gpsLocation0, orientation0, title0, videoSize0) {
										return {codec: codec0, createdAt: createdAt0, duration: duration0, gpsLocation: gpsLocation0, orientation: orientation0, title: title0, videoSize: videoSize0};
									})))))))));
var $author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileMetadata = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_ImageMetadata,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$FileStatus$FileMetadata_Image));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_VideoMetadata,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$FileStatus$FileMetadata_Video));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$FileName$FileName = $elm$core$Basics$identity;
var $MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeChar,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($MartinSStewart$elm_nonempty_string$String$Nonempty$NonemptyString)));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$FileName$w3_unsafe_decode_FileName = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$FileStatus$IsEncrypted$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V417$FileStatus$IsEncrypted = F2($author$project$Evergreen$V417$FileStatus$IsEncrypted$);
var $author$project$Evergreen$V417$FileStatus$IsNotEncrypted = {$: 0};
var $author$project$Evergreen$V417$FileStatus$AesPrivateKey = $elm$core$Basics$identity;
var $lamdera$codecs$Lamdera$Wire3$decodeBytes = $elm$bytes$Bytes$Decode$andThen$($elm$bytes$Bytes$Decode$bytes, $lamdera$codecs$Lamdera$Wire3$decodeInt);
var $author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_AesPrivateKey = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeBytes,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$FileStatus$HasEncryptedThumbnail = 1;
var $author$project$Evergreen$V417$FileStatus$NoEncryptedThumbnail = 0;
var $author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_EncryptedThumbnail = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_IsEncrypted = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_EncryptedThumbnail,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_AesPrivateKey,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$FileStatus$IsEncrypted)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$FileStatus$IsNotEncrypted);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileMetadata),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_IsEncrypted,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$FileName$w3_unsafe_decode_FileName,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_ContentType,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F6(
								function (contentType0, fileHash0, fileName0, fileSize0, isEncrypted0, metadata0) {
									return {contentType: contentType0, fileHash: fileHash0, fileName: fileName0, fileSize: fileSize0, isEncrypted: isEncrypted0, metadata: metadata0};
								}))))))));
var $author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_IsEncrypted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_ContentType,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$FileName$w3_unsafe_decode_FileName,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$FileStatus$FileError))))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$FileStatus$FileUploaded));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_IsEncrypted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_ContentType,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeInt,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F2(
											function (sent0, size0) {
												return {sent: sent0, size: size0};
											})))),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$FileName$w3_unsafe_decode_FileName,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$FileStatus$FileUploading)))));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_EditMessage = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
				$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileStatus),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (attachedFiles0, messageIndex0, text0) {
						return {attachedFiles: attachedFiles0, messageIndex: messageIndex0, text: text0};
					})))));
var $author$project$Evergreen$V417$Types$EmojiSelectorForEditMessage$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$EmojiSelectorForEditMessage = F2($author$project$Evergreen$V417$Types$EmojiSelectorForEditMessage$);
var $author$project$Evergreen$V417$Types$EmojiSelectorForMessage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$Types$EmojiSelectorForReaction$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$EmojiSelectorForReaction = F2($author$project$Evergreen$V417$Types$EmojiSelectorForReaction$);
var $author$project$Evergreen$V417$Types$EmojiSelectorForSheepGameInput$ = function (a, b, c) {
	return {$: 4, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$EmojiSelectorForSheepGameInput = F3($author$project$Evergreen$V417$Types$EmojiSelectorForSheepGameInput$);
var $author$project$Evergreen$V417$Types$EmojiSelectorForSheepGameReaction$ = function (a, b, c) {
	return {$: 5, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$EmojiSelectorForSheepGameReaction = F3($author$project$Evergreen$V417$Types$EmojiSelectorForSheepGameReaction$);
var $author$project$Evergreen$V417$Types$EmojiSelectorForWordSpellingGameReaction$ = function (a, b, c) {
	return {$: 6, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$EmojiSelectorForWordSpellingGameReaction = F3($author$project$Evergreen$V417$Types$EmojiSelectorForWordSpellingGameReaction$);
var $author$project$Evergreen$V417$Types$EmojiSelectorHidden = {$: 0};
var $author$project$Evergreen$V417$SheepGame$AnswerInput = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$SheepGame$NotesInput = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$SheepGame$QuestionInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Id$QuestionId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_Input = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$AnswerInput));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$NotesInput));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$QuestionInput));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Range$w3_unsafe_decode_Range = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (end0, start0) {
					return {end: end0, start: start0};
				}))));
var $author$project$Evergreen$V417$SheepGame$AnswerReaction$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$SheepGame$AnswerReaction = F2($author$project$Evergreen$V417$SheepGame$AnswerReaction$);
var $author$project$Evergreen$V417$SheepGame$NotesReaction = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_ReactionTarget = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$AnswerReaction)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$NotesReaction));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$WordSpellingGame$MoveReaction = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_ReactionTarget = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Id$NoThreadWithMessage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Id$ViewThreadWithMessage$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V417$Id$ViewThreadWithMessage = F2($author$project$Evergreen$V417$Id$ViewThreadWithMessage$);
var $author$project$Evergreen$V417$Id$ThreadMessageId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Id$NoThreadWithMessage));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Id$ViewThreadWithMessage)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_EmojiSelector = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Range$w3_unsafe_decode_Range),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$EmojiSelectorForEditMessage)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Range$w3_unsafe_decode_Range),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$EmojiSelectorForMessage));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$EmojiSelectorForReaction)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Range$w3_unsafe_decode_Range),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_Input,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$EmojiSelectorForSheepGameInput))));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_ReactionTarget,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$EmojiSelectorForSheepGameReaction))));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_ReactionTarget,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$EmojiSelectorForWordSpellingGameReaction))));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$EmojiSelectorHidden);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Encryption$DecryptManyRequestId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Encryption$w3_unsafe_decode_DecryptManyRequestId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Encryption$DecryptRequestId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Encryption$w3_unsafe_decode_DecryptRequestId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Encryption$EncryptFileRequestId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Encryption$w3_unsafe_decode_EncryptFileRequestId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Encryption$EncryptManyRequestId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Encryption$w3_unsafe_decode_EncryptManyRequestId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Encryption$EncryptRequestId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Encryption$w3_unsafe_decode_EncryptRequestId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Encryption$BytesHash = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Encryption$w3_unsafe_decode_BytesHash = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_PendingDecryptedManyMessages = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_HtmlId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V417$Encryption$w3_unsafe_decode_BytesHash),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (messageHashes0, shiftScrollFrom0) {
					return {messageHashes: messageHashes0, shiftScrollFrom: shiftScrollFrom0};
				}))));
var $author$project$Evergreen$V417$Message$NoThreadWithRepliedTo = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Message$ViewThreadWithRepliedTo$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V417$Message$ViewThreadWithRepliedTo = F2($author$project$Evergreen$V417$Message$ViewThreadWithRepliedTo$);
var $author$project$Evergreen$V417$Message$NoReply = {$: 0};
var $author$project$Evergreen$V417$Message$RepliedToGame$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V417$Message$RepliedToGame = F2($author$project$Evergreen$V417$Message$RepliedToGame$);
var $author$project$Evergreen$V417$Message$RepliedToMessage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Message$RepliedTo_SheepGameAnswer$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V417$Message$RepliedTo_SheepGameAnswer = F2($author$project$Evergreen$V417$Message$RepliedTo_SheepGameAnswer$);
var $author$project$Evergreen$V417$Message$RepliedTo_SheepGameNotes = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$Message$RepliedTo_WordSpellingGameMove = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Message$w3_unsafe_decode_RepliedToGame = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Message$RepliedTo_SheepGameAnswer)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Message$RepliedTo_SheepGameNotes));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Message$RepliedTo_WordSpellingGameMove));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Message$w3_unsafe_decode_RepliedTo = function (w3_x_c_messageId) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Message$NoReply);
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Message$w3_unsafe_decode_RepliedToGame,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Message$RepliedToGame)));
				case 2:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id(w3_x_c_messageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Message$RepliedToMessage));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$Message$w3_unsafe_decode_ThreadRouteWithRepliedTo = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Message$w3_unsafe_decode_RepliedTo($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Message$NoThreadWithRepliedTo));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Message$ViewThreadWithRepliedTo)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_PendingDecryptedMessage = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Message$w3_unsafe_decode_ThreadRouteWithRepliedTo,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DmId,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$Encryption$w3_unsafe_decode_BytesHash,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (hash0, id0, senderId0, threadRoute0) {
							return {hash: hash0, id: id0, senderId: senderId0, threadRoute: threadRoute0};
						}))))));
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_PendingDecryptedOldMessages = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DmId,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, messages0) {
					return {id: id0, messages: messages0};
				}))));
var $author$project$Evergreen$V417$Embed$EmbedLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Embed$EmbedLoading = {$: 0};
var $author$project$Evergreen$V417$Embed$Avif = 13;
var $author$project$Evergreen$V417$Embed$Bmp = 8;
var $author$project$Evergreen$V417$Embed$Dds = 7;
var $author$project$Evergreen$V417$Embed$Farbfeld = 12;
var $author$project$Evergreen$V417$Embed$Gif = 2;
var $author$project$Evergreen$V417$Embed$Hdr = 10;
var $author$project$Evergreen$V417$Embed$Ico = 9;
var $author$project$Evergreen$V417$Embed$Jpeg = 1;
var $author$project$Evergreen$V417$Embed$OpenExr = 11;
var $author$project$Evergreen$V417$Embed$Png = 0;
var $author$project$Evergreen$V417$Embed$Pnm = 4;
var $author$project$Evergreen$V417$Embed$Qoi = 14;
var $author$project$Evergreen$V417$Embed$Tga = 6;
var $author$project$Evergreen$V417$Embed$Tiff = 5;
var $author$project$Evergreen$V417$Embed$WebP = 3;
var $author$project$Evergreen$V417$Embed$w3_unsafe_decode_EmbedImageFormat = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(13);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(8);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(12);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(10);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(9);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(11);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(14);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Embed$w3_unsafe_decode_EmbedImageData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Embed$w3_unsafe_decode_EmbedImageFormat),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (format0, imageSize0, url0) {
						return {format: format0, imageSize: imageSize0, url: url0};
					})))));
var $author$project$Evergreen$V417$Embed$w3_unsafe_decode_EmbedData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Embed$w3_unsafe_decode_EmbedImageData),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (createdAt0, description0, image0, title0) {
							return {createdAt: createdAt0, description: description0, image: image0, title: title0};
						}))))));
var $author$project$Evergreen$V417$Embed$w3_unsafe_decode_Embed = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Embed$w3_unsafe_decode_EmbedData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Embed$EmbedLoaded));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Embed$EmbedLoading);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList(w3_x_c_a),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_a,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($mgold$elm_nonempty_list$List$Nonempty$Nonempty)));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$RichText$AttachedFile = function (a) {
	return {$: 14, a: a};
};
var $author$project$Evergreen$V417$RichText$BlockQuote$ = function (a, b) {
	return {$: 8, a: a, b: b};
};
var $author$project$Evergreen$V417$RichText$BlockQuote = F2($author$project$Evergreen$V417$RichText$BlockQuote$);
var $author$project$Evergreen$V417$RichText$Bold = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V417$RichText$BulletPoint$ = function (a, b) {
	return {$: 18, a: a, b: b};
};
var $author$project$Evergreen$V417$RichText$BulletPoint = F2($author$project$Evergreen$V417$RichText$BulletPoint$);
var $author$project$Evergreen$V417$RichText$ChannelMention$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V417$RichText$ChannelMention = F2($author$project$Evergreen$V417$RichText$ChannelMention$);
var $author$project$Evergreen$V417$RichText$CodeBlock$ = function (a, b) {
	return {$: 13, a: a, b: b};
};
var $author$project$Evergreen$V417$RichText$CodeBlock = F2($author$project$Evergreen$V417$RichText$CodeBlock$);
var $author$project$Evergreen$V417$RichText$CustomEmoji = function (a) {
	return {$: 17, a: a};
};
var $author$project$Evergreen$V417$RichText$EscapedChar = function (a) {
	return {$: 15, a: a};
};
var $author$project$Evergreen$V417$RichText$Heading$ = function (a, b, c) {
	return {$: 9, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$RichText$Heading = F3($author$project$Evergreen$V417$RichText$Heading$);
var $author$project$Evergreen$V417$RichText$Hyperlink = function (a) {
	return {$: 10, a: a};
};
var $author$project$Evergreen$V417$RichText$InlineCode$ = function (a, b) {
	return {$: 12, a: a, b: b};
};
var $author$project$Evergreen$V417$RichText$InlineCode = F2($author$project$Evergreen$V417$RichText$InlineCode$);
var $author$project$Evergreen$V417$RichText$Italic = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V417$RichText$MarkdownLink$ = function (a, b) {
	return {$: 11, a: a, b: b};
};
var $author$project$Evergreen$V417$RichText$MarkdownLink = F2($author$project$Evergreen$V417$RichText$MarkdownLink$);
var $author$project$Evergreen$V417$RichText$NormalText$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V417$RichText$NormalText = F2($author$project$Evergreen$V417$RichText$NormalText$);
var $author$project$Evergreen$V417$RichText$Spoiler = function (a) {
	return {$: 7, a: a};
};
var $author$project$Evergreen$V417$RichText$Sticker = function (a) {
	return {$: 16, a: a};
};
var $author$project$Evergreen$V417$RichText$Strikethrough = function (a) {
	return {$: 6, a: a};
};
var $author$project$Evergreen$V417$RichText$Timestamp = function (a) {
	return {$: 19, a: a};
};
var $author$project$Evergreen$V417$RichText$Underline = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V417$RichText$UserMention = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Id$CustomEmojiId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Id$w3_unsafe_decode_CustomEmojiId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$RichText$EscapedAtSymbol = 3;
var $author$project$Evergreen$V417$RichText$EscapedBackslash = 1;
var $author$project$Evergreen$V417$RichText$EscapedBacktick = 2;
var $author$project$Evergreen$V417$RichText$EscapedBold = 4;
var $author$project$Evergreen$V417$RichText$EscapedItalic = 5;
var $author$project$Evergreen$V417$RichText$EscapedSpoilered = 7;
var $author$project$Evergreen$V417$RichText$EscapedSquareBracket = 0;
var $author$project$Evergreen$V417$RichText$EscapedStrikethrough = 6;
var $author$project$Evergreen$V417$RichText$w3_unsafe_decode_EscapedChar = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$RichText$HasLeadingLineBreak = 0;
var $author$project$Evergreen$V417$RichText$NoLeadingLineBreak = 1;
var $author$project$Evergreen$V417$RichText$w3_unsafe_decode_HasLeadingLineBreak = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$RichText$H1 = 0;
var $author$project$Evergreen$V417$RichText$H2 = 1;
var $author$project$Evergreen$V417$RichText$H3 = 2;
var $author$project$Evergreen$V417$RichText$Small = 3;
var $author$project$Evergreen$V417$RichText$w3_unsafe_decode_HeadingLevel = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$RichText$Language = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$RichText$NoLanguage = {$: 1};
var $author$project$Evergreen$V417$RichText$w3_unsafe_decode_Language = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$RichText$Language));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$RichText$NoLanguage);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Id$StickerId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Id$w3_unsafe_decode_StickerId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$TimeInMinutes$TimeInMinutes = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$TimeInMinutes$w3_unsafe_decode_TimeInMinutes = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $elm$url$Url$w3_unsafe_decode_Protocol = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $elm$url$Url$w3_unsafe_decode_Url = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$elm$url$Url$w3_unsafe_decode_Protocol,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F6(
								function (fragment0, host0, path0, port_0, protocol0, query0) {
									return {fragment: fragment0, host: host0, path: path0, port_: port_0, protocol: protocol0, query: query0};
								}))))))));
var $author$project$Evergreen$V417$RichText$w3_unsafe_decode_RichText$ = function (w3_x_c_userId, w3_x_c_channelId) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$RichText$AttachedFile));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeList(
							$author$project$Evergreen$V417$RichText$w3_unsafe_decode_RichText$(w3_x_c_userId, w3_x_c_channelId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$RichText$w3_unsafe_decode_HasLeadingLineBreak,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$RichText$BlockQuote)));
				case 2:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$author$project$Evergreen$V417$RichText$w3_unsafe_decode_RichText$(w3_x_c_userId, w3_x_c_channelId)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$RichText$Bold));
				case 3:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$lamdera$codecs$Lamdera$Wire3$decodeList(
								$author$project$Evergreen$V417$RichText$w3_unsafe_decode_RichText$(w3_x_c_userId, w3_x_c_channelId))),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$RichText$w3_unsafe_decode_HasLeadingLineBreak,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$RichText$BulletPoint)));
				case 4:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							w3_x_c_channelId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$RichText$ChannelMention)));
				case 5:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$RichText$w3_unsafe_decode_Language,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$RichText$CodeBlock)));
				case 6:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_CustomEmojiId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$RichText$CustomEmoji));
				case 7:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$RichText$w3_unsafe_decode_EscapedChar,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$RichText$EscapedChar));
				case 8:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$author$project$Evergreen$V417$RichText$w3_unsafe_decode_RichText$(w3_x_c_userId, w3_x_c_channelId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$RichText$w3_unsafe_decode_HasLeadingLineBreak,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$RichText$w3_unsafe_decode_HeadingLevel,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$RichText$Heading))));
				case 9:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$elm$url$Url$w3_unsafe_decode_Url,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$RichText$Hyperlink));
				case 10:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeChar,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$RichText$InlineCode)));
				case 11:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$author$project$Evergreen$V417$RichText$w3_unsafe_decode_RichText$(w3_x_c_userId, w3_x_c_channelId)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$RichText$Italic));
				case 12:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$elm$url$Url$w3_unsafe_decode_Url,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$RichText$MarkdownLink)));
				case 13:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeChar,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$RichText$NormalText)));
				case 14:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$author$project$Evergreen$V417$RichText$w3_unsafe_decode_RichText$(w3_x_c_userId, w3_x_c_channelId)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$RichText$Spoiler));
				case 15:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_StickerId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$RichText$Sticker));
				case 16:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$author$project$Evergreen$V417$RichText$w3_unsafe_decode_RichText$(w3_x_c_userId, w3_x_c_channelId)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$RichText$Strikethrough));
				case 17:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$TimeInMinutes$w3_unsafe_decode_TimeInMinutes,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$RichText$Timestamp));
				case 18:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$author$project$Evergreen$V417$RichText$w3_unsafe_decode_RichText$(w3_x_c_userId, w3_x_c_channelId)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$RichText$Underline));
				case 19:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_userId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$RichText$UserMention));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$RichText$w3_unsafe_decode_RichText = F2($author$project$Evergreen$V417$RichText$w3_unsafe_decode_RichText$);
var $author$project$Evergreen$V417$Message$w3_unsafe_decode_MessageContent$ = function (w3_x_c_userId, w3_x_c_channelId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V417$Embed$w3_unsafe_decode_Embed),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
				$author$project$Evergreen$V417$RichText$w3_unsafe_decode_RichText$(w3_x_c_userId, w3_x_c_channelId)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
					$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileData),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F3(
						function (attachedFiles0, content0, embeds0) {
							return {attachedFiles: attachedFiles0, content: content0, embeds: embeds0};
						})))));
};
var $author$project$Evergreen$V417$Message$w3_unsafe_decode_MessageContent = F2($author$project$Evergreen$V417$Message$w3_unsafe_decode_MessageContent$);
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_PendingEncryptedEdit = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DmId,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$Message$w3_unsafe_decode_MessageContent$(
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId)),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (contentAndEmbeds0, id0, threadRoute0) {
						return {contentAndEmbeds: contentAndEmbeds0, id: id0, threadRoute: threadRoute0};
					})))));
var $author$project$Evergreen$V417$Id$NoThread = {$: 0};
var $author$project$Evergreen$V417$Id$ViewThread = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Id$NoThread);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Id$ViewThread));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_PendingEncryptedFile = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (fileId0, guildOrDmId0) {
					return {fileId: fileId0, guildOrDmId: guildOrDmId0};
				}))));
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_PendingEncryptedManyMessages = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeList(
		$lamdera$codecs$Lamdera$Wire3$decodePair$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
			$author$project$Evergreen$V417$Message$w3_unsafe_decode_MessageContent$(
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId)))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DmId,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, messages0) {
					return {id: id0, messages: messages0};
				}))));
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_PendingEncryptedMessage = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Message$w3_unsafe_decode_ThreadRouteWithRepliedTo,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$Message$w3_unsafe_decode_MessageContent$(
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId)),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (contentAndEmbeds0, otherUserId0, threadRoute0) {
						return {contentAndEmbeds: contentAndEmbeds0, otherUserId: otherUserId0, threadRoute: threadRoute0};
					})))));
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_EncryptionRequests = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Encryption$w3_unsafe_decode_EncryptManyRequestId),
		$author$project$Evergreen$V417$Types$w3_unsafe_decode_PendingEncryptedMessage),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Encryption$w3_unsafe_decode_EncryptManyRequestId),
			$author$project$Evergreen$V417$Types$w3_unsafe_decode_PendingEncryptedManyMessages),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Encryption$w3_unsafe_decode_EncryptFileRequestId),
				$author$project$Evergreen$V417$Types$w3_unsafe_decode_PendingEncryptedFile),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Encryption$w3_unsafe_decode_EncryptRequestId),
					$author$project$Evergreen$V417$Types$w3_unsafe_decode_PendingEncryptedEdit),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Encryption$w3_unsafe_decode_DecryptManyRequestId),
						$author$project$Evergreen$V417$Types$w3_unsafe_decode_PendingDecryptedOldMessages),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Encryption$w3_unsafe_decode_DecryptRequestId),
							$author$project$Evergreen$V417$Types$w3_unsafe_decode_PendingDecryptedMessage),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqDict$decodeDict$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Encryption$w3_unsafe_decode_DecryptManyRequestId),
								$author$project$Evergreen$V417$Types$w3_unsafe_decode_PendingDecryptedManyMessages),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Encryption$w3_unsafe_decode_EncryptRequestId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Encryption$w3_unsafe_decode_EncryptManyRequestId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Encryption$w3_unsafe_decode_EncryptFileRequestId),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Encryption$w3_unsafe_decode_DecryptRequestId),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Encryption$w3_unsafe_decode_DecryptManyRequestId),
												$lamdera$codecs$Lamdera$Wire3$succeedDecode(
													function (nextDecryptManyRequestId0) {
														return function (nextDecryptionRequestId0) {
															return function (nextEncryptFileRequestId0) {
																return function (nextEncryptManyRequestId0) {
																	return function (nextEncryptionRequestId0) {
																		return function (pendingDecryptedManyMessages0) {
																			return function (pendingDecryptedMessages0) {
																				return function (pendingDecryptedOldMessages0) {
																					return function (pendingEncryptedEdits0) {
																						return function (pendingEncryptedFiles0) {
																							return function (pendingEncryptedManyMessages0) {
																								return function (pendingEncryptedMessages0) {
																									return {nextDecryptManyRequestId: nextDecryptManyRequestId0, nextDecryptionRequestId: nextDecryptionRequestId0, nextEncryptFileRequestId: nextEncryptFileRequestId0, nextEncryptManyRequestId: nextEncryptManyRequestId0, nextEncryptionRequestId: nextEncryptionRequestId0, pendingDecryptedManyMessages: pendingDecryptedManyMessages0, pendingDecryptedMessages: pendingDecryptedMessages0, pendingDecryptedOldMessages: pendingDecryptedOldMessages0, pendingEncryptedEdits: pendingEncryptedEdits0, pendingEncryptedFiles: pendingEncryptedFiles0, pendingEncryptedManyMessages: pendingEncryptedManyMessages0, pendingEncryptedMessages: pendingEncryptedMessages0};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													})))))))))))));
var $author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileDataWithImage = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileMetadata,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_IsEncrypted,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$FileName$w3_unsafe_decode_FileName,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_ContentType,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F6(
								function (contentType0, fileHash0, fileName0, fileSize0, isEncrypted0, metadata0) {
									return {contentType: contentType0, fileHash: fileHash0, fileName: fileName0, fileSize: fileSize0, isEncrypted: isEncrypted0, metadata: metadata0};
								}))))))));
var $author$project$Evergreen$V417$Types$FileDragging$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$FileDragging = F2($author$project$Evergreen$V417$Types$FileDragging$);
var $author$project$Evergreen$V417$Types$NoFileDrag = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$OneOrGreater$OneOrGreater = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$OneOrGreater$w3_unsafe_decode_OneOrGreater = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_FileDrag = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$OneOrGreater$w3_unsafe_decode_OneOrGreater,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$FileDragging)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$NoFileDrag));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Local$Local = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Local$ChangeId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Local$w3_unsafe_decode_ChangeId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Local$w3_unsafe_decode_Local$ = function (w3_x_c_msg, w3_x_c_model) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_model,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeDict$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									w3_x_c_msg,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										A2(
											$lamdera$codecs$Lamdera$Wire3$andThenDecode,
											function (t) {
												return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
													$elm$time$Time$millisToPosix(t));
											},
											$lamdera$codecs$Lamdera$Wire3$decodeInt),
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											F2(
												function (createdAt0, msg0) {
													return {createdAt: createdAt0, msg: msg0};
												}))))),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								w3_x_c_model,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Local$w3_unsafe_decode_ChangeId,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F4(
											function (counter0, localModel0, localMsgs0, serverModel0) {
												return {counter: counter0, localModel: localModel0, localMsgs: localMsgs0, serverModel: serverModel0};
											})))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$Local$w3_unsafe_decode_Local = F2($author$project$Evergreen$V417$Local$w3_unsafe_decode_Local$);
var $author$project$Evergreen$V417$Types$LocalChange$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$LocalChange = F2($author$project$Evergreen$V417$Types$LocalChange$);
var $author$project$Evergreen$V417$Types$ServerChange = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Types$Local_AcceptE2ee$ = function (a, b, c) {
	return {$: 76, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Local_AcceptE2ee = F3($author$project$Evergreen$V417$Types$Local_AcceptE2ee$);
var $author$project$Evergreen$V417$Types$Local_AddCustomEmojisToUser = function (a) {
	return {$: 55, a: a};
};
var $author$project$Evergreen$V417$Types$Local_AddReactionEmoji$ = function (a, b, c) {
	return {$: 19, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Local_AddReactionEmoji = F3($author$project$Evergreen$V417$Types$Local_AddReactionEmoji$);
var $author$project$Evergreen$V417$Types$Local_Admin = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Types$Local_BanMember$ = function (a, b) {
	return {$: 16, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Local_BanMember = F2($author$project$Evergreen$V417$Types$Local_BanMember$);
var $author$project$Evergreen$V417$Types$Local_CancelAccountDeletion = {$: 45};
var $author$project$Evergreen$V417$Types$Local_CollapseUserOptionSection = function (a) {
	return {$: 40, a: a};
};
var $author$project$Evergreen$V417$Types$Local_CurrentlyViewing$ = function (a, b) {
	return {$: 27, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Local_CurrentlyViewing = F2($author$project$Evergreen$V417$Types$Local_CurrentlyViewing$);
var $author$project$Evergreen$V417$Types$Local_DeclineE2eeRequest = function (a) {
	return {$: 70, a: a};
};
var $author$project$Evergreen$V417$Types$Local_DeclineE2eeRequestAsInitiator = function (a) {
	return {$: 69, a: a};
};
var $author$project$Evergreen$V417$Types$Local_DecryptOldMessages$ = function (a, b, c) {
	return {$: 74, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Local_DecryptOldMessages = F3($author$project$Evergreen$V417$Types$Local_DecryptOldMessages$);
var $author$project$Evergreen$V417$Types$Local_DeleteChannel$ = function (a, b) {
	return {$: 10, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Local_DeleteChannel = F2($author$project$Evergreen$V417$Types$Local_DeleteChannel$);
var $author$project$Evergreen$V417$Types$Local_DeleteGuild = function (a) {
	return {$: 12, a: a};
};
var $author$project$Evergreen$V417$Types$Local_DeleteInviteLink$ = function (a, b) {
	return {$: 15, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Local_DeleteInviteLink = F2($author$project$Evergreen$V417$Types$Local_DeleteInviteLink$);
var $author$project$Evergreen$V417$Types$Local_DeleteMessage$ = function (a, b) {
	return {$: 26, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Local_DeleteMessage = F2($author$project$Evergreen$V417$Types$Local_DeleteMessage$);
var $author$project$Evergreen$V417$Types$Local_DisableE2ee$ = function (a, b) {
	return {$: 73, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Local_DisableE2ee = F2($author$project$Evergreen$V417$Types$Local_DisableE2ee$);
var $author$project$Evergreen$V417$Types$Local_Discord_LoadChannelMessages$ = function (a, b, c) {
	return {$: 33, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Local_Discord_LoadChannelMessages = F3($author$project$Evergreen$V417$Types$Local_Discord_LoadChannelMessages$);
var $author$project$Evergreen$V417$Types$Local_Discord_LoadThreadMessages$ = function (a, b, c, d) {
	return {$: 34, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$Local_Discord_LoadThreadMessages = F4($author$project$Evergreen$V417$Types$Local_Discord_LoadThreadMessages$);
var $author$project$Evergreen$V417$Types$Local_Discord_SendEditDmMessage$ = function (a, b, c, d, e) {
	return {$: 23, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V417$Types$Local_Discord_SendEditDmMessage = F5($author$project$Evergreen$V417$Types$Local_Discord_SendEditDmMessage$);
var $author$project$Evergreen$V417$Types$Local_Discord_SendEditGuildMessage$ = function (a, b, c, d, e, f, g) {
	return {$: 22, a: a, b: b, c: c, d: d, e: e, f: f, g: g};
};
var $author$project$Evergreen$V417$Types$Local_Discord_SendEditGuildMessage = F7($author$project$Evergreen$V417$Types$Local_Discord_SendEditGuildMessage$);
var $author$project$Evergreen$V417$Types$Local_Discord_SendMessage$ = function (a, b, c, d, e, f) {
	return {$: 3, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Evergreen$V417$Types$Local_Discord_SendMessage = F6($author$project$Evergreen$V417$Types$Local_Discord_SendMessage$);
var $author$project$Evergreen$V417$Types$Local_Drawing$ = function (a, b, c) {
	return {$: 58, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Local_Drawing = F3($author$project$Evergreen$V417$Types$Local_Drawing$);
var $author$project$Evergreen$V417$Types$Local_EditChannel$ = function (a, b, c, d) {
	return {$: 9, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$Local_EditChannel = F4($author$project$Evergreen$V417$Types$Local_EditChannel$);
var $author$project$Evergreen$V417$Types$Local_EditGuildName$ = function (a, b) {
	return {$: 11, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Local_EditGuildName = F2($author$project$Evergreen$V417$Types$Local_EditGuildName$);
var $author$project$Evergreen$V417$Types$Local_EncryptOldMessages$ = function (a, b) {
	return {$: 72, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Local_EncryptOldMessages = F2($author$project$Evergreen$V417$Types$Local_EncryptOldMessages$);
var $author$project$Evergreen$V417$Types$Local_ExpandUserOptionSection$ = function (a, b) {
	return {$: 39, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Local_ExpandUserOptionSection = F2($author$project$Evergreen$V417$Types$Local_ExpandUserOptionSection$);
var $author$project$Evergreen$V417$Types$Local_Game$ = function (a, b) {
	return {$: 57, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Local_Game = F2($author$project$Evergreen$V417$Types$Local_Game$);
var $author$project$Evergreen$V417$Types$Local_Invalid = {$: 0};
var $author$project$Evergreen$V417$Types$Local_LeaveGuild = function (a) {
	return {$: 13, a: a};
};
var $author$project$Evergreen$V417$Types$Local_LinkDiscordAcknowledgementIsChecked = function (a) {
	return {$: 50, a: a};
};
var $author$project$Evergreen$V417$Types$Local_LinkSlackAcknowledgementIsChecked = function (a) {
	return {$: 51, a: a};
};
var $author$project$Evergreen$V417$Types$Local_LoadChannelMessages$ = function (a, b, c) {
	return {$: 29, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Local_LoadChannelMessages = F3($author$project$Evergreen$V417$Types$Local_LoadChannelMessages$);
var $author$project$Evergreen$V417$Types$Local_LoadThreadMessages$ = function (a, b, c, d) {
	return {$: 30, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$Local_LoadThreadMessages = F4($author$project$Evergreen$V417$Types$Local_LoadThreadMessages$);
var $author$project$Evergreen$V417$Types$Local_MemberEditTyping$ = function (a, b, c) {
	return {$: 24, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Local_MemberEditTyping = F3($author$project$Evergreen$V417$Types$Local_MemberEditTyping$);
var $author$project$Evergreen$V417$Types$Local_MemberTyping$ = function (a, b) {
	return {$: 18, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Local_MemberTyping = F2($author$project$Evergreen$V417$Types$Local_MemberTyping$);
var $author$project$Evergreen$V417$Types$Local_NewChannel$ = function (a, b, c, d) {
	return {$: 8, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$Local_NewChannel = F4($author$project$Evergreen$V417$Types$Local_NewChannel$);
var $author$project$Evergreen$V417$Types$Local_NewGuild$ = function (a, b, c) {
	return {$: 17, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Local_NewGuild = F3($author$project$Evergreen$V417$Types$Local_NewGuild$);
var $author$project$Evergreen$V417$Types$Local_NewInviteLink$ = function (a, b, c) {
	return {$: 14, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Local_NewInviteLink = F3($author$project$Evergreen$V417$Types$Local_NewInviteLink$);
var $author$project$Evergreen$V417$Types$Local_RegisterPushSubscription$ = function (a, b) {
	return {$: 46, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Local_RegisterPushSubscription = F2($author$project$Evergreen$V417$Types$Local_RegisterPushSubscription$);
var $author$project$Evergreen$V417$Types$Local_RemoveReactionEmoji$ = function (a, b, c) {
	return {$: 20, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Local_RemoveReactionEmoji = F3($author$project$Evergreen$V417$Types$Local_RemoveReactionEmoji$);
var $author$project$Evergreen$V417$Types$Local_RequestE2ee = function (a) {
	return {$: 68, a: a};
};
var $author$project$Evergreen$V417$Types$Local_ScheduleAccountDeletion = function (a) {
	return {$: 44, a: a};
};
var $author$project$Evergreen$V417$Types$Local_SendEditMessage$ = function (a, b, c, d, e, f) {
	return {$: 21, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Evergreen$V417$Types$Local_SendEditMessage = F6($author$project$Evergreen$V417$Types$Local_SendEditMessage$);
var $author$project$Evergreen$V417$Types$Local_SendEncryptedEditMessage$ = function (a, b, c, d, e) {
	return {$: 78, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V417$Types$Local_SendEncryptedEditMessage = F5($author$project$Evergreen$V417$Types$Local_SendEncryptedEditMessage$);
var $author$project$Evergreen$V417$Types$Local_SendEncryptedMessage$ = function (a, b, c, d, e, f) {
	return {$: 77, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Evergreen$V417$Types$Local_SendEncryptedMessage = F6($author$project$Evergreen$V417$Types$Local_SendEncryptedMessage$);
var $author$project$Evergreen$V417$Types$Local_SendMessage$ = function (a, b, c, d, e, f, g) {
	return {$: 2, a: a, b: b, c: c, d: d, e: e, f: f, g: g};
};
var $author$project$Evergreen$V417$Types$Local_SendMessage = F7($author$project$Evergreen$V417$Types$Local_SendMessage$);
var $author$project$Evergreen$V417$Types$Local_SetDiscordGuildNotificationLevel$ = function (a, b, c) {
	return {$: 36, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Local_SetDiscordGuildNotificationLevel = F3($author$project$Evergreen$V417$Types$Local_SetDiscordGuildNotificationLevel$);
var $author$project$Evergreen$V417$Types$Local_SetDomainWhitelist$ = function (a, b) {
	return {$: 52, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Local_SetDomainWhitelist = F2($author$project$Evergreen$V417$Types$Local_SetDomainWhitelist$);
var $author$project$Evergreen$V417$Types$Local_SetE2eeRisksAccepted = function (a) {
	return {$: 75, a: a};
};
var $author$project$Evergreen$V417$Types$Local_SetEmailNotifications = function (a) {
	return {$: 42, a: a};
};
var $author$project$Evergreen$V417$Types$Local_SetEmbedVisibility = function (a) {
	return {$: 43, a: a};
};
var $author$project$Evergreen$V417$Types$Local_SetEmojiSkinTone = function (a) {
	return {$: 53, a: a};
};
var $author$project$Evergreen$V417$Types$Local_SetGuildNotificationLevel$ = function (a, b) {
	return {$: 35, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Local_SetGuildNotificationLevel = F2($author$project$Evergreen$V417$Types$Local_SetGuildNotificationLevel$);
var $author$project$Evergreen$V417$Types$Local_SetLastViewed$ = function (a, b) {
	return {$: 25, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Local_SetLastViewed = F2($author$project$Evergreen$V417$Types$Local_SetLastViewed$);
var $author$project$Evergreen$V417$Types$Local_SetMuteChannel$ = function (a, b, c) {
	return {$: 59, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Local_SetMuteChannel = F3($author$project$Evergreen$V417$Types$Local_SetMuteChannel$);
var $author$project$Evergreen$V417$Types$Local_SetMuteDiscordChannel$ = function (a, b, c, d) {
	return {$: 61, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$Local_SetMuteDiscordChannel = F4($author$project$Evergreen$V417$Types$Local_SetMuteDiscordChannel$);
var $author$project$Evergreen$V417$Types$Local_SetMuteDiscordGuild$ = function (a, b, c) {
	return {$: 64, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Local_SetMuteDiscordGuild = F3($author$project$Evergreen$V417$Types$Local_SetMuteDiscordGuild$);
var $author$project$Evergreen$V417$Types$Local_SetMuteDiscordThread$ = function (a, b, c, d, e) {
	return {$: 62, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V417$Types$Local_SetMuteDiscordThread = F5($author$project$Evergreen$V417$Types$Local_SetMuteDiscordThread$);
var $author$project$Evergreen$V417$Types$Local_SetMuteGuild$ = function (a, b) {
	return {$: 63, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Local_SetMuteGuild = F2($author$project$Evergreen$V417$Types$Local_SetMuteGuild$);
var $author$project$Evergreen$V417$Types$Local_SetMuteSlackChannel$ = function (a, b, c, d) {
	return {$: 66, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$Local_SetMuteSlackChannel = F4($author$project$Evergreen$V417$Types$Local_SetMuteSlackChannel$);
var $author$project$Evergreen$V417$Types$Local_SetMuteSlackThread$ = function (a, b, c, d, e) {
	return {$: 67, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V417$Types$Local_SetMuteSlackThread = F5($author$project$Evergreen$V417$Types$Local_SetMuteSlackThread$);
var $author$project$Evergreen$V417$Types$Local_SetMuteSlackWorkspace$ = function (a, b, c) {
	return {$: 65, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Local_SetMuteSlackWorkspace = F3($author$project$Evergreen$V417$Types$Local_SetMuteSlackWorkspace$);
var $author$project$Evergreen$V417$Types$Local_SetMuteThread$ = function (a, b, c, d) {
	return {$: 60, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$Local_SetMuteThread = F4($author$project$Evergreen$V417$Types$Local_SetMuteThread$);
var $author$project$Evergreen$V417$Types$Local_SetName = function (a) {
	return {$: 28, a: a};
};
var $author$project$Evergreen$V417$Types$Local_SetNotificationMode = function (a) {
	return {$: 38, a: a};
};
var $author$project$Evergreen$V417$Types$Local_SetPublicKey$ = function (a, b) {
	return {$: 71, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Local_SetPublicKey = F2($author$project$Evergreen$V417$Types$Local_SetPublicKey$);
var $author$project$Evergreen$V417$Types$Local_SetSheepGameQuestions = function (a) {
	return {$: 41, a: a};
};
var $author$project$Evergreen$V417$Types$Local_SetSlackWorkspaceNotificationLevel$ = function (a, b, c) {
	return {$: 37, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Local_SetSlackWorkspaceNotificationLevel = F3($author$project$Evergreen$V417$Types$Local_SetSlackWorkspaceNotificationLevel$);
var $author$project$Evergreen$V417$Types$Local_SetUserColor = function (a) {
	return {$: 54, a: a};
};
var $author$project$Evergreen$V417$Types$Local_Slack_LoadChannelMessages$ = function (a, b, c) {
	return {$: 31, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Local_Slack_LoadChannelMessages = F3($author$project$Evergreen$V417$Types$Local_Slack_LoadChannelMessages$);
var $author$project$Evergreen$V417$Types$Local_Slack_LoadThreadMessages$ = function (a, b, c, d) {
	return {$: 32, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$Local_Slack_LoadThreadMessages = F4($author$project$Evergreen$V417$Types$Local_Slack_LoadThreadMessages$);
var $author$project$Evergreen$V417$Types$Local_Slack_ReloadUser = function (a) {
	return {$: 7, a: a};
};
var $author$project$Evergreen$V417$Types$Local_Slack_SendEditMessage$ = function (a, b, c, d, e) {
	return {$: 5, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V417$Types$Local_Slack_SendEditMessage = F5($author$project$Evergreen$V417$Types$Local_Slack_SendEditMessage$);
var $author$project$Evergreen$V417$Types$Local_Slack_SendMessage$ = function (a, b, c, d, e, f) {
	return {$: 4, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Evergreen$V417$Types$Local_Slack_SendMessage = F6($author$project$Evergreen$V417$Types$Local_Slack_SendMessage$);
var $author$project$Evergreen$V417$Types$Local_Slack_UnlinkUser = function (a) {
	return {$: 6, a: a};
};
var $author$project$Evergreen$V417$Types$Local_StartReloadingDiscordUser$ = function (a, b) {
	return {$: 49, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Local_StartReloadingDiscordUser = F2($author$project$Evergreen$V417$Types$Local_StartReloadingDiscordUser$);
var $author$project$Evergreen$V417$Types$Local_TextEditor = function (a) {
	return {$: 47, a: a};
};
var $author$project$Evergreen$V417$Types$Local_UnlinkDiscordUser = function (a) {
	return {$: 48, a: a};
};
var $author$project$Evergreen$V417$Types$Local_VoiceChatChange = function (a) {
	return {$: 56, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$ChangeUsers = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$DeleteDiscordDmChannel = function (a) {
	return {$: 28, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$DeleteDiscordGuild = function (a) {
	return {$: 29, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$DeleteGuild = function (a) {
	return {$: 32, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$DeleteOrphanedFiles = function (a) {
	return {$: 40, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$DeleteSession = function (a) {
	return {$: 38, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$DeleteSlackDmChannel = function (a) {
	return {$: 31, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$DeleteSlackWorkspace = function (a) {
	return {$: 30, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$DisconnectClient$ = function (a, b) {
	return {$: 37, a: a, b: b};
};
var $author$project$Evergreen$V417$Pages$Admin$DisconnectClient = F2($author$project$Evergreen$V417$Pages$Admin$DisconnectClient$);
var $author$project$Evergreen$V417$Pages$Admin$LoadBackendMsgLogs = function (a) {
	return {$: 15, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$LoadDeletedGuilds = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$LoadDiscordDmChannels = function (a) {
	return {$: 7, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$LoadDiscordGuilds = function (a) {
	return {$: 6, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$LoadDiscordUsers = function (a) {
	return {$: 8, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$LoadDmChannels = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$LoadGuilds = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$LoadOrphanedFiles = function (a) {
	return {$: 13, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$LoadSessions = function (a) {
	return {$: 11, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$LoadSlackDmChannels = function (a) {
	return {$: 10, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$LoadSlackWorkspaces = function (a) {
	return {$: 9, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$LoadToBackendLogs = function (a) {
	return {$: 14, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$LoadUsers = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$LoadWebsocketCloseEvents = function (a) {
	return {$: 12, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$LogPageChanged$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V417$Pages$Admin$LogPageChanged = F2($author$project$Evergreen$V417$Pages$Admin$LogPageChanged$);
var $author$project$Evergreen$V417$Pages$Admin$RegenerateServerSecret = function (a) {
	return {$: 39, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$ReloadDiscordGuild$ = function (a, b, c) {
	return {$: 36, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Pages$Admin$ReloadDiscordGuild = F3($author$project$Evergreen$V417$Pages$Admin$ReloadDiscordGuild$);
var $author$project$Evergreen$V417$Pages$Admin$RestoreGuild = function (a) {
	return {$: 33, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$SetDiscordLinkLimit = function (a) {
	return {$: 19, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$SetDiscordLinkingEnabled = function (a) {
	return {$: 18, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$SetEmailNotificationsEnabled = function (a) {
	return {$: 16, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$SetNotifyAdminsBotUserId = function (a) {
	return {$: 26, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$SetNotifyAdminsToken = function (a) {
	return {$: 25, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$SetOpenRouterKey = function (a) {
	return {$: 24, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$SetPostmarkKey = function (a) {
	return {$: 27, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$SetPrivateVapidKey = function (a) {
	return {$: 22, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$SetPublicVapidKey = function (a) {
	return {$: 23, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$SetSignupsEnabled = function (a) {
	return {$: 17, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$SetSlackLinkLimit = function (a) {
	return {$: 21, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$SetSlackLinkingEnabled = function (a) {
	return {$: 20, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$StartReloadingDiscordDmChannel$ = function (a, b, c) {
	return {$: 35, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Pages$Admin$StartReloadingDiscordDmChannel = F3($author$project$Evergreen$V417$Pages$Admin$StartReloadingDiscordDmChannel$);
var $author$project$Evergreen$V417$Pages$Admin$StartReloadingDiscordGuildChannel$ = function (a, b, c, d) {
	return {$: 34, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Pages$Admin$StartReloadingDiscordGuildChannel = F4($author$project$Evergreen$V417$Pages$Admin$StartReloadingDiscordGuildChannel$);
var $author$project$Evergreen$V417$GuildName$GuildName = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$GuildName$w3_unsafe_decode_GuildName = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminData_DeletedGuild = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$GuildName$w3_unsafe_decode_GuildName,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (deletedAt0, memberCount0, name0, owner0) {
							return {deletedAt: deletedAt0, memberCount: memberCount0, name: name0, owner: owner0};
						}))))));
var $author$project$Evergreen$V417$Message$CallStarted = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V417$Message$DeletedMessage = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V417$Message$EncryptedUserTextMessage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Message$GameStarted = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V417$Message$UserJoinedMessage$ = function (a, b, c, d) {
	return {$: 2, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Message$UserJoinedMessage = F4($author$project$Evergreen$V417$Message$UserJoinedMessage$);
var $author$project$Evergreen$V417$Message$UserTextMessage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Message$w3_unsafe_decode_CallRecordingFile = function (w3_x_c_userId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			A2(
				$lamdera$codecs$Lamdera$Wire3$andThenDecode,
				function (t) {
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
						$elm$time$Time$millisToPosix(t));
				},
				$lamdera$codecs$Lamdera$Wire3$decodeInt),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					w3_x_c_userId,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							A2(
								$lamdera$codecs$Lamdera$Wire3$andThenDecode,
								function (t) {
									return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
										$elm$time$Time$millisToPosix(t));
								},
								$lamdera$codecs$Lamdera$Wire3$decodeInt),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F6(
									function (endedAt0, name0, recordedBy0, size0, startedAt0, uploaded0) {
										return {endedAt: endedAt0, name: name0, recordedBy: recordedBy0, size: size0, startedAt: startedAt0, uploaded: uploaded0};
									}))))))));
};
var $author$project$Evergreen$V417$Message$w3_unsafe_decode_CallRecordingZip = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (fileCount0, fileHash0, size0) {
						return {fileCount: fileCount0, fileHash: fileHash0, size: size0};
					})))));
var $author$project$Evergreen$V417$NonemptySet$NonemptySet$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$NonemptySet$NonemptySet = F2($author$project$Evergreen$V417$NonemptySet$NonemptySet$);
var $author$project$Evergreen$V417$NonemptySet$w3_unsafe_decode_NonemptySet = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqSet$decodeSet(w3_x_c_a),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_a,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$NonemptySet$NonemptySet)));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$Message$w3_unsafe_decode_CallRecording = function (w3_x_c_userId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Message$w3_unsafe_decode_CallRecordingZip),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			A2(
				$lamdera$codecs$Lamdera$Wire3$andThenDecode,
				function (t) {
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
						$elm$time$Time$millisToPosix(t));
				},
				$lamdera$codecs$Lamdera$Wire3$decodeInt),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$NonemptySet$w3_unsafe_decode_NonemptySet(w3_x_c_userId),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqSet$decodeSet(w3_x_c_userId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeList(
							$author$project$Evergreen$V417$Message$w3_unsafe_decode_CallRecordingFile(w3_x_c_userId)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F5(
								function (files0, finishedUploading0, participants0, startedAt0, zip0) {
									return {files: files0, finishedUploading: finishedUploading0, participants: participants0, startedAt: startedAt0, zip: zip0};
								})))))));
};
var $author$project$Evergreen$V417$Drawing$w3_unsafe_decode_Stroke = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
		$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V417$SafeFloat$w3_unsafe_decode_SafeFloat, $author$project$Evergreen$V417$SafeFloat$w3_unsafe_decode_SafeFloat)),
	$lamdera$codecs$Lamdera$Wire3$succeedDecode(
		function (points0) {
			return {points: points0};
		}));
var $author$project$Evergreen$V417$Drawing$w3_unsafe_decode_Drawing = function (w3_x_c_userId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			w3_x_c_userId,
			$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V417$Drawing$w3_unsafe_decode_Stroke)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(w3_x_c_userId, $author$project$Evergreen$V417$Drawing$w3_unsafe_decode_Stroke),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeList(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V417$SafeFloat$w3_unsafe_decode_SafeFloat, $author$project$Evergreen$V417$SafeFloat$w3_unsafe_decode_SafeFloat)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							w3_x_c_userId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (createdBy0, points0) {
										return {createdBy: createdBy0, points: points0};
									}))))),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F3(
						function (finished0, inProgress0, undone0) {
							return {finished: finished0, inProgress: inProgress0, undone: undone0};
						})))));
};
var $author$project$Evergreen$V417$Emoji$EmojiOrCustomEmoji_CustomEmoji = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Emoji$EmojiOrCustomEmoji_Emoji = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_CustomEmojiId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Emoji$EmojiOrCustomEmoji_CustomEmoji));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_UnicodeEmoji,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Emoji$EmojiOrCustomEmoji_Emoji));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Message$w3_unsafe_decode_CallStartedData = function (w3_x_c_userId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			w3_x_c_userId,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$andThenDecode,
					function (t) {
						return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
							$elm$time$Time$millisToPosix(t));
					},
					$lamdera$codecs$Lamdera$Wire3$decodeInt),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Evergreen$V417$Message$w3_unsafe_decode_CallRecording(w3_x_c_userId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
							$author$project$Evergreen$V417$NonemptySet$w3_unsafe_decode_NonemptySet(w3_x_c_userId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqSet$decodeSet(w3_x_c_userId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
									A2(
										$lamdera$codecs$Lamdera$Wire3$andThenDecode,
										function (t) {
											return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
												$elm$time$Time$millisToPosix(t));
										},
										$lamdera$codecs$Lamdera$Wire3$decodeInt)),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F8(
											function (cardDrawings0, endedAt0, joinedBy0, reactions0, recordings0, startedAt0, startedBy0, timestampDrawings0) {
												return {cardDrawings: cardDrawings0, endedAt: endedAt0, joinedBy: joinedBy0, reactions: reactions0, recordings: recordings0, startedAt: startedAt0, startedBy: startedBy0, timestampDrawings: timestampDrawings0};
											}))))))))));
};
var $author$project$Evergreen$V417$Encryption$EncryptedData = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Encryption$w3_unsafe_decode_EncryptedData = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBytes,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$Message$w3_unsafe_decode_UserTextMessageDrawings = function (w3_x_c_userId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
					$author$project$Evergreen$V417$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId)),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$author$project$Evergreen$V417$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F4(
							function (embedDrawings0, imageAttachmentDrawings0, timestampDrawings0, userIconDrawings0) {
								return {embedDrawings: embedDrawings0, imageAttachmentDrawings: imageAttachmentDrawings0, timestampDrawings: timestampDrawings0, userIconDrawings: userIconDrawings0};
							}))))));
};
var $author$project$Evergreen$V417$Message$w3_unsafe_decode_EncryptedUserTextMessageData$ = function (w3_x_c_messageId, w3_x_c_userId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Message$w3_unsafe_decode_RepliedTo(w3_x_c_messageId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
				$author$project$Evergreen$V417$NonemptySet$w3_unsafe_decode_NonemptySet(w3_x_c_userId)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqSet$decodeSet($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						A2(
							$lamdera$codecs$Lamdera$Wire3$andThenDecode,
							function (t) {
								return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
									$elm$time$Time$millisToPosix(t));
							},
							$lamdera$codecs$Lamdera$Wire3$decodeInt)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$Evergreen$V417$Message$w3_unsafe_decode_UserTextMessageDrawings(w3_x_c_userId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							w3_x_c_userId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								A2(
									$lamdera$codecs$Lamdera$Wire3$andThenDecode,
									function (t) {
										return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
											$elm$time$Time$millisToPosix(t));
									},
									$lamdera$codecs$Lamdera$Wire3$decodeInt),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Encryption$w3_unsafe_decode_EncryptedData(
										$author$project$Evergreen$V417$Message$w3_unsafe_decode_MessageContent$(
											w3_x_c_userId,
											$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId))),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F8(
											function (content0, createdAt0, createdBy0, drawings0, editedAt0, fileHashes0, reactions0, repliedTo0) {
												return {content: content0, createdAt: createdAt0, createdBy: createdBy0, drawings: drawings0, editedAt: editedAt0, fileHashes: fileHashes0, reactions: reactions0, repliedTo: repliedTo0};
											}))))))))));
};
var $author$project$Evergreen$V417$Message$w3_unsafe_decode_EncryptedUserTextMessageData = F2($author$project$Evergreen$V417$Message$w3_unsafe_decode_EncryptedUserTextMessageData$);
var $author$project$Evergreen$V417$Message$GameType_Go = 0;
var $author$project$Evergreen$V417$Message$GameType_SheepGame = 2;
var $author$project$Evergreen$V417$Message$GameType_WordSpellingGame = 1;
var $author$project$Evergreen$V417$Message$w3_unsafe_decode_GameType = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Message$w3_unsafe_decode_GameStartedData = function (w3_x_c_userId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			w3_x_c_userId,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$andThenDecode,
					function (t) {
						return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
							$elm$time$Time$millisToPosix(t));
					},
					$lamdera$codecs$Lamdera$Wire3$decodeInt),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
						$author$project$Evergreen$V417$NonemptySet$w3_unsafe_decode_NonemptySet(w3_x_c_userId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Message$w3_unsafe_decode_GameType,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F6(
									function (cardDrawings0, gameType0, reactions0, startedAt0, startedBy0, timestampDrawings0) {
										return {cardDrawings: cardDrawings0, gameType: gameType0, reactions: reactions0, startedAt: startedAt0, startedBy: startedBy0, timestampDrawings: timestampDrawings0};
									}))))))));
};
var $author$project$Evergreen$V417$Message$w3_unsafe_decode_UserTextMessageData$ = function (w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Message$w3_unsafe_decode_RepliedTo(w3_x_c_messageId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
				$author$project$Evergreen$V417$NonemptySet$w3_unsafe_decode_NonemptySet(w3_x_c_userId)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
					A2(
						$lamdera$codecs$Lamdera$Wire3$andThenDecode,
						function (t) {
							return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
								$elm$time$Time$millisToPosix(t));
						},
						$lamdera$codecs$Lamdera$Wire3$decodeInt)),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Evergreen$V417$Message$w3_unsafe_decode_UserTextMessageDrawings(w3_x_c_userId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_userId,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							A2(
								$lamdera$codecs$Lamdera$Wire3$andThenDecode,
								function (t) {
									return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
										$elm$time$Time$millisToPosix(t));
								},
								$lamdera$codecs$Lamdera$Wire3$decodeInt),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Message$w3_unsafe_decode_MessageContent$(w3_x_c_userId, w3_x_c_channelId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F7(
										function (content0, createdAt0, createdBy0, drawings0, editedAt0, reactions0, repliedTo0) {
											return {content: content0, createdAt: createdAt0, createdBy: createdBy0, drawings: drawings0, editedAt: editedAt0, reactions: reactions0, repliedTo: repliedTo0};
										})))))))));
};
var $author$project$Evergreen$V417$Message$w3_unsafe_decode_UserTextMessageData = F3($author$project$Evergreen$V417$Message$w3_unsafe_decode_UserTextMessageData$);
var $author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$ = function (w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Message$w3_unsafe_decode_CallStartedData(w3_x_c_userId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Message$CallStarted));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						A2(
							$lamdera$codecs$Lamdera$Wire3$andThenDecode,
							function (t) {
								return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
									$elm$time$Time$millisToPosix(t));
							},
							$lamdera$codecs$Lamdera$Wire3$decodeInt),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Message$DeletedMessage));
				case 2:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Message$w3_unsafe_decode_EncryptedUserTextMessageData$(w3_x_c_messageId, w3_x_c_userId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Message$EncryptedUserTextMessage));
				case 3:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Message$w3_unsafe_decode_GameStartedData(w3_x_c_userId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Message$GameStarted));
				case 4:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqDict$decodeDict$(
								$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
								$author$project$Evergreen$V417$NonemptySet$w3_unsafe_decode_NonemptySet(w3_x_c_userId)),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								w3_x_c_userId,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									A2(
										$lamdera$codecs$Lamdera$Wire3$andThenDecode,
										function (t) {
											return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
												$elm$time$Time$millisToPosix(t));
										},
										$lamdera$codecs$Lamdera$Wire3$decodeInt),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Message$UserJoinedMessage)))));
				case 5:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Message$w3_unsafe_decode_UserTextMessageData$(w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Message$UserTextMessage));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$Message$w3_unsafe_decode_Message = F3($author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$);
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminData_DiscordDmChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
			$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					function (messagesSent0) {
						return {messagesSent: messagesSent0};
					}))),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
				$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId,
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId))),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (firstMessage0, members0, messageCount0) {
						return {firstMessage: firstMessage0, members: members0, messageCount: messageCount0};
					})))));
var $author$project$Evergreen$V417$ChannelName$ChannelName = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$ChannelName$w3_unsafe_decode_ChannelName = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Discord$w3_unsafe_decode_Permissions = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeBool,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeBool,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeBool,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeBool,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeBool,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeBool,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeBool,
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeBool,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$codecs$Lamdera$Wire3$decodeBool,
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$lamdera$codecs$Lamdera$Wire3$decodeBool,
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$lamdera$codecs$Lamdera$Wire3$decodeBool,
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$lamdera$codecs$Lamdera$Wire3$decodeBool,
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$lamdera$codecs$Lamdera$Wire3$decodeBool,
																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																		$lamdera$codecs$Lamdera$Wire3$decodeBool,
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$codecs$Lamdera$Wire3$decodeBool,
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$lamdera$codecs$Lamdera$Wire3$decodeBool,
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$lamdera$codecs$Lamdera$Wire3$decodeBool,
																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																						$lamdera$codecs$Lamdera$Wire3$decodeBool,
																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																							$lamdera$codecs$Lamdera$Wire3$decodeBool,
																							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																								$lamdera$codecs$Lamdera$Wire3$decodeBool,
																								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																									$lamdera$codecs$Lamdera$Wire3$decodeBool,
																									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																										$lamdera$codecs$Lamdera$Wire3$decodeBool,
																										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																											$lamdera$codecs$Lamdera$Wire3$decodeBool,
																											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																												$lamdera$codecs$Lamdera$Wire3$decodeBool,
																												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																													$lamdera$codecs$Lamdera$Wire3$decodeBool,
																													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																														$lamdera$codecs$Lamdera$Wire3$decodeBool,
																														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																															$lamdera$codecs$Lamdera$Wire3$decodeBool,
																															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																	$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																		$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																			$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																				$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																					$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																						$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																							$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																								$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																									$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																										$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																											$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																												$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																													$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																														$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																															$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																																$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																																	$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																																	$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																																																		function (addReaction0) {
																																																			return function (administrator0) {
																																																				return function (attachFiles0) {
																																																					return function (banMembers0) {
																																																						return function (changeNickname0) {
																																																							return function (connect0) {
																																																								return function (createEvents0) {
																																																									return function (createGuildExpressions0) {
																																																										return function (createInstantInvite0) {
																																																											return function (createPrivateThreads0) {
																																																												return function (createPublicThreads0) {
																																																													return function (deafenMembers0) {
																																																														return function (embedLinks0) {
																																																															return function (kickMembers0) {
																																																																return function (manageChannels0) {
																																																																	return function (manageEvents0) {
																																																																		return function (manageGuild0) {
																																																																			return function (manageGuildExpressions0) {
																																																																				return function (manageMessages0) {
																																																																					return function (manageNicknames0) {
																																																																						return function (manageRoles0) {
																																																																							return function (manageThreads0) {
																																																																								return function (manageWebhooks0) {
																																																																									return function (mentionEveryone0) {
																																																																										return function (moderateMembers0) {
																																																																											return function (moveMembers0) {
																																																																												return function (muteMembers0) {
																																																																													return function (prioritySpeaker0) {
																																																																														return function (readMessageHistory0) {
																																																																															return function (requestToSpeak0) {
																																																																																return function (sendMessages0) {
																																																																																	return function (sendMessagesInThreads0) {
																																																																																		return function (sendPolls0) {
																																																																																			return function (sendVoiceMessages0) {
																																																																																				return function (sentTextToSpeechMessages0) {
																																																																																					return function (speak0) {
																																																																																						return function (stream0) {
																																																																																							return function (useApplicationCommands0) {
																																																																																								return function (useEmbeddedActivities0) {
																																																																																									return function (useExternalApps0) {
																																																																																										return function (useExternalEmojis0) {
																																																																																											return function (useExternalSounds0) {
																																																																																												return function (useExternalStickers0) {
																																																																																													return function (useSoundboard0) {
																																																																																														return function (useVoiceActivityDetection0) {
																																																																																															return function (viewAuditLog0) {
																																																																																																return function (viewChannel0) {
																																																																																																	return function (viewCreatorMontetizationAnalytics0) {
																																																																																																		return function (viewGuildInsights0) {
																																																																																																			return {addReaction: addReaction0, administrator: administrator0, attachFiles: attachFiles0, banMembers: banMembers0, changeNickname: changeNickname0, connect: connect0, createEvents: createEvents0, createGuildExpressions: createGuildExpressions0, createInstantInvite: createInstantInvite0, createPrivateThreads: createPrivateThreads0, createPublicThreads: createPublicThreads0, deafenMembers: deafenMembers0, embedLinks: embedLinks0, kickMembers: kickMembers0, manageChannels: manageChannels0, manageEvents: manageEvents0, manageGuild: manageGuild0, manageGuildExpressions: manageGuildExpressions0, manageMessages: manageMessages0, manageNicknames: manageNicknames0, manageRoles: manageRoles0, manageThreads: manageThreads0, manageWebhooks: manageWebhooks0, mentionEveryone: mentionEveryone0, moderateMembers: moderateMembers0, moveMembers: moveMembers0, muteMembers: muteMembers0, prioritySpeaker: prioritySpeaker0, readMessageHistory: readMessageHistory0, requestToSpeak: requestToSpeak0, sendMessages: sendMessages0, sendMessagesInThreads: sendMessagesInThreads0, sendPolls: sendPolls0, sendVoiceMessages: sendVoiceMessages0, sentTextToSpeechMessages: sentTextToSpeechMessages0, speak: speak0, stream: stream0, useApplicationCommands: useApplicationCommands0, useEmbeddedActivities: useEmbeddedActivities0, useExternalApps: useExternalApps0, useExternalEmojis: useExternalEmojis0, useExternalSounds: useExternalSounds0, useExternalStickers: useExternalStickers0, useSoundboard: useSoundboard0, useVoiceActivityDetection: useVoiceActivityDetection0, viewAuditLog: viewAuditLog0, viewChannel: viewChannel0, viewCreatorMontetizationAnalytics: viewCreatorMontetizationAnalytics0, viewGuildInsights: viewGuildInsights0};
																																																																																																		};
																																																																																																	};
																																																																																																};
																																																																																															};
																																																																																														};
																																																																																													};
																																																																																												};
																																																																																											};
																																																																																										};
																																																																																									};
																																																																																								};
																																																																																							};
																																																																																						};
																																																																																					};
																																																																																				};
																																																																																			};
																																																																																		};
																																																																																	};
																																																																																};
																																																																															};
																																																																														};
																																																																													};
																																																																												};
																																																																											};
																																																																										};
																																																																									};
																																																																								};
																																																																							};
																																																																						};
																																																																					};
																																																																				};
																																																																			};
																																																																		};
																																																																	};
																																																																};
																																																															};
																																																														};
																																																													};
																																																												};
																																																											};
																																																										};
																																																									};
																																																								};
																																																							};
																																																						};
																																																					};
																																																				};
																																																			};
																																																		}))))))))))))))))))))))))))))))))))))))))))))))))));
var $author$project$Evergreen$V417$Discord$RoleOrUserId_RoleId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Discord$RoleOrUserId_UserId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Discord$RoleId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Discord$w3_unsafe_decode_RoleId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Discord$w3_unsafe_decode_RoleOrUserId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_RoleId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Discord$RoleOrUserId_RoleId));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Discord$RoleOrUserId_UserId));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Discord$w3_unsafe_decode_Overwrite = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Discord$w3_unsafe_decode_RoleOrUserId,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Permissions,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Permissions,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (allow0, deny0, id0) {
						return {allow: allow0, deny: deny0, id: id0};
					})))));
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminData_DiscordChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V417$Discord$w3_unsafe_decode_Overwrite),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$ChannelName$w3_unsafe_decode_ChannelName,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId,
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (firstMessage0, messageCount0, name0, permissionOverwrites0, threadCount0) {
								return {firstMessage: firstMessage0, messageCount: messageCount0, name: name0, permissionOverwrites: permissionOverwrites0, threadCount: threadCount0};
							})))))));
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_DiscordRole = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Permissions,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (description0, name0, permissions0) {
						return {description: description0, name: name0, permissions: permissions0};
					})))));
var $author$project$Evergreen$V417$MembersAndOwner$MembersAndOwner$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$MembersAndOwner$MembersAndOwner = F2($author$project$Evergreen$V417$MembersAndOwner$MembersAndOwner$);
var $author$project$Evergreen$V417$MembersAndOwner$w3_unsafe_decode_MembersAndOwner$ = function (w3_x_c_userId, w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					w3_x_c_userId,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(w3_x_c_userId, w3_x_c_a),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MembersAndOwner$MembersAndOwner)));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$MembersAndOwner$w3_unsafe_decode_MembersAndOwner = F2($author$project$Evergreen$V417$MembersAndOwner$w3_unsafe_decode_MembersAndOwner$);
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminData_DiscordGuild = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_RoleId),
		$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_DiscordRole),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$GuildName$w3_unsafe_decode_GuildName,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$MembersAndOwner$w3_unsafe_decode_MembersAndOwner$(
				$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqSet$decodeSet(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_RoleId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F2(
								function (joinedAt0, roles0) {
									return {joinedAt: joinedAt0, roles: roles0};
								}))))),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
					$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminData_DiscordChannel),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (channels0, membersAndOwner0, name0, roles0) {
							return {channels: channels0, membersAndOwner: membersAndOwner0, name: name0, roles: roles0};
						}))))));
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminData_DmChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (messageCount0, threadCount0) {
					return {messageCount: messageCount0, threadCount: threadCount0};
				}))));
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminData_GuildChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$ChannelName$w3_unsafe_decode_ChannelName,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (messageCount0, name0) {
					return {messageCount: messageCount0, name: name0};
				}))));
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminData_Guild = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$GuildName$w3_unsafe_decode_GuildName,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId),
					$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminData_GuildChannel),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (channels0, memberCount0, name0, owner0) {
							return {channels: channels0, memberCount: memberCount0, name: name0, owner: owner0};
						}))))));
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminData_SlackDmChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList(
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F2(
								function (id0, name0) {
									return {id: id0, name: name0};
								}))))),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
					$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId,
						$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
						$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId))),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (firstMessage0, members0, messageCount0, teamId0) {
							return {firstMessage: firstMessage0, members: members0, messageCount: messageCount0, teamId: teamId0};
						}))))));
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminData_SlackWorkspace = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F2(
								function (linkedTo0, name0) {
									return {linkedTo: linkedTo0, name: name0};
								}))))),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$ChannelName$w3_unsafe_decode_ChannelName,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$containers$SeqSet$decodeSet(
										$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId)),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeBool,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
												$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
													$author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId,
													$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
													$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId))),
											$lamdera$codecs$Lamdera$Wire3$succeedDecode(
												F5(
													function (firstMessage0, isPrivate0, linkedMembers0, messageCount0, name0) {
														return {firstMessage: firstMessage0, isPrivate: isPrivate0, linkedMembers: linkedMembers0, messageCount: messageCount0, name: name0};
													})))))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (channels0, domain0, linkedUsers0, name0, userCount0) {
								return {channels: channels0, domain: domain0, linkedUsers: linkedUsers0, name: name0, userCount: userCount0};
							})))))));
var $author$project$Evergreen$V417$Postmark$ApiKey = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Postmark$w3_unsafe_decode_ApiKey = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_BackendFileData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
		$author$project$Evergreen$V417$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (fileSize0, imageSize0) {
					return {fileSize: fileSize0, imageSize: imageSize0};
				}))));
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_AiChatBackendMsg = 20;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_BackendGotTime = 5;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_BackendMsgCompleted = 91;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_CaughtUpSlackMessages = 34;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_CheckedSlackAuth = 35;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_CountToFrontendStep = 54;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_DeletedDiscordDmMessage = 12;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_DeletedDiscordGuildMessage = 11;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_DeletedOrphanedFiles = 78;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_DiscordAddedReactionToDmMessage = 16;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_DiscordAddedReactionToGuildMessage = 15;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_DiscordGotDataForJoinedOrCreatedGuild = 65;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_DiscordGotDmMessageEmbed = 64;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_DiscordGotGuildIcon = 66;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_DiscordGotGuildMessageEmbed = 63;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_DiscordMessageCreate_AttachmentsUploaded = 49;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_DiscordMessageUpdate_AttachmentsUploaded = 50;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_DiscordRemovedReactionToDmMessage = 18;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_DiscordRemovedReactionToGuildMessage = 17;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_DiscordTypingIndicatorSent = 19;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_DiscordUserWebsocketMsg = 8;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_DownloadBackupChunkStep = 55;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_EditedDiscordDmMessage = 14;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_EditedDiscordGuildMessage = 13;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_ExportBackendStep = 53;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_GatewayReconnectTick = 47;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_GotChangedSlackUser = 26;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_GotDiscordDmChannelMessages = 58;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_GotDiscordGuildChannelMessages = 57;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_GotDiscordMessageCustomEmojis = 73;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_GotDiscordMessageStickers = 70;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_GotDiscordReadyDataCustomEmojis = 71;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_GotDiscordReadyDataStickers = 69;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_GotDiscordStandardStickerPacks = 75;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_GotDiscordUserAvatars = 21;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_GotDmMessageEmbed = 62;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_GotEnglishWordList = 83;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_GotGuildMessageEmbed = 61;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_GotSlackCustomEmojis = 72;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_GotSlackUser = 25;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_GotSwedishWordList = 84;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_GotTimeForBackendMsg = 90;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_GotTimeForDiscordForumPostRenamed = 60;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_GotTimeForFailedToParseDiscordWebsocket = 59;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_GotTimeForWebsocketListenClose = 81;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_GotVapidKeys = 23;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_HandleReadyDataStep2 = 44;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_HourlyDeletedOrphanedFiles = 79;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_HourlyUpdate = 74;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_JoinedDiscordThread = 67;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_LinkDiscordUserStep1 = 24;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_LinkSlackUserStep1 = 31;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_LinkSlackUserStep2 = 32;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_RecordingRequestTick = 4;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_RefreshedSlackConversations = 33;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_RegeneratedServerSecret = 77;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_ReloadDiscordUserStep1 = 43;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_ReloadedDiscordDmChannel = 52;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_ReloadedDiscordGuildChannel = 51;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_ReloadedDiscordGuildForAdmin = 80;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_Rpc_GotFileUpload = 82;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_Rpc_NotifyAdmins = 86;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_Rpc_RecordingUploadFinished = 88;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_Rpc_RecordingUploadProgress = 87;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_Rpc_RecordingZipBuilt = 89;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_Rpc_UserJoinedCall = 85;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_ScheduledExportBackendStep = 56;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_ScheduledExportUploadResult = 76;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_SentDiscordDmMessage = 10;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_SentDiscordGuildMessage = 9;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_SentLogErrorEmail = 6;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_SentLoginEmail = 0;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_SentNotification = 22;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_SentNotificationEmail = 7;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_SentSlackMessage = 37;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_SlackChangedReaction = 27;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_SlackDeletedMessage = 28;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_SlackEditedMessage = 29;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_SlackGotMessageEmbed = 36;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_SlackMessageFilesUploaded = 30;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_SlackWebsocketClosedByBackend = 39;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_SlackWebsocketCreatedHandle = 38;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_SlackWebsocketMsg = 40;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_SlackWebsocketReconnectTick = 42;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_SlackWebsocketSentData = 41;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_ToBackendCompleted = 68;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_UserConnected = 1;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_UserDisconnected = 2;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_UserDisconnectedWithTime = 3;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_WebsocketClosedByBackendForUser = 46;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_WebsocketCreatedHandleForUser = 45;
var $author$project$Evergreen$V417$BackendMsgLog$BackendMsgLog_WebsocketSentDataForUser = 48;
var $author$project$Evergreen$V417$BackendMsgLog$w3_unsafe_decode_BackendMsgLog = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(20);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(91);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(34);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(35);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(54);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(12);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(11);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(78);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(16);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(15);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(65);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(64);
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(66);
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(63);
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(49);
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(50);
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(18);
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(17);
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(19);
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(8);
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(55);
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(14);
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(13);
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(53);
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(47);
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(26);
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(58);
			case 28:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(57);
			case 29:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(73);
			case 30:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(70);
			case 31:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(71);
			case 32:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(69);
			case 33:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(75);
			case 34:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(21);
			case 35:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(62);
			case 36:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(83);
			case 37:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(61);
			case 38:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(72);
			case 39:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(25);
			case 40:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(84);
			case 41:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(90);
			case 42:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(60);
			case 43:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(59);
			case 44:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(81);
			case 45:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(23);
			case 46:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(44);
			case 47:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(79);
			case 48:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(74);
			case 49:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(67);
			case 50:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(24);
			case 51:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(31);
			case 52:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(32);
			case 53:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 54:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(33);
			case 55:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(77);
			case 56:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(43);
			case 57:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(52);
			case 58:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(51);
			case 59:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(80);
			case 60:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(82);
			case 61:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(86);
			case 62:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(88);
			case 63:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(87);
			case 64:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(89);
			case 65:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(85);
			case 66:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(56);
			case 67:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(76);
			case 68:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(10);
			case 69:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(9);
			case 70:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			case 71:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 72:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(22);
			case 73:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			case 74:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(37);
			case 75:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(27);
			case 76:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(28);
			case 77:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(29);
			case 78:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(36);
			case 79:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(30);
			case 80:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(39);
			case 81:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(38);
			case 82:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(40);
			case 83:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(42);
			case 84:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(41);
			case 85:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(68);
			case 86:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 87:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 88:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 89:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(46);
			case 90:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(45);
			case 91:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(48);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$BackendMsgLog$w3_unsafe_decode_BackendMsgLogData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$BackendMsgLog$w3_unsafe_decode_BackendMsgLog,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (backendMsgLog0, endTime0, startTime0) {
						return {backendMsgLog: backendMsgLog0, endTime: endTime0, startTime: startTime0};
					})))));
var $author$project$Evergreen$V417$User$DeletedUser = {$: 0};
var $author$project$Evergreen$V417$User$UserHasEmail = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$EmailAddress$EmailAddress = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$EmailAddress$w3_unsafe_decode_EmailAddress = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeString),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeString,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeString,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F4(
										function (domain0, localPart0, tags0, tld0) {
											return {domain: domain0, localPart: localPart0, tags: tags0, tld: tld0};
										})))))),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$User$w3_unsafe_decode_BackendUserStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$User$DeletedUser);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$EmailAddress$w3_unsafe_decode_EmailAddress,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$User$UserHasEmail));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$RichText$Domain = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$RichText$w3_unsafe_decode_Domain = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$User$NeverNotifyMe = 0;
var $author$project$Evergreen$V417$User$NotifyMeWhenMentioned = 1;
var $author$project$Evergreen$V417$User$w3_unsafe_decode_EmailNotifications = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$User$HideEmbeds = 1;
var $author$project$Evergreen$V417$User$ShowEmbeds = 0;
var $author$project$Evergreen$V417$User$w3_unsafe_decode_EmbedVisibility = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Emoji$SkinTone1 = 0;
var $author$project$Evergreen$V417$Emoji$SkinTone2 = 1;
var $author$project$Evergreen$V417$Emoji$SkinTone3 = 2;
var $author$project$Evergreen$V417$Emoji$SkinTone4 = 3;
var $author$project$Evergreen$V417$Emoji$SkinTone5 = 4;
var $author$project$Evergreen$V417$Emoji$w3_unsafe_decode_SkinTone = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiConfig = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Emoji$w3_unsafe_decode_SkinTone),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (lastUsedEmojis0, skinTone0) {
					return {lastUsedEmojis: lastUsedEmojis0, skinTone: skinTone0};
				}))));
var $author$project$Evergreen$V417$User$DiscordDmChannelLastViewed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$User$DmChannelLastViewed$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$User$DmChannelLastViewed = F2($author$project$Evergreen$V417$User$DmChannelLastViewed$);
var $author$project$Evergreen$V417$User$NoLastDmViewed = {$: 2};
var $author$project$Evergreen$V417$User$w3_unsafe_decode_LastDmViewed = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$User$DiscordDmChannelLastViewed));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$User$DmChannelLastViewed)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$User$NoLastDmViewed);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$MuteSettings$IsFullyMuted = 2;
var $author$project$Evergreen$V417$MuteSettings$IsNotMuted = 0;
var $author$project$Evergreen$V417$MuteSettings$IsPartiallyMuted = 1;
var $author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_MutedChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
		$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (mutedChannel0, mutedThreads0) {
					return {mutedChannel: mutedChannel0, mutedThreads: mutedThreads0};
				}))));
var $author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_MutedDiscordGuild = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
			$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_MutedChannel),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (channels0, mutedGuild0) {
					return {channels: channels0, mutedGuild: mutedGuild0};
				}))));
var $author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_MutedGuild = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId),
			$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_MutedChannel),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (channels0, mutedGuild0) {
					return {channels: channels0, mutedGuild: mutedGuild0};
				}))));
var $author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_MutedSlackWorkspace = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId),
			$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_MutedChannel),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (channels0, mutedWorkspace0) {
					return {channels: channels0, mutedWorkspace: mutedWorkspace0};
				}))));
var $author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
		$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_MutedSlackWorkspace),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
			$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_MutedGuild),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
				$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_MutedChannel),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
					$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_MutedDiscordGuild),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
						$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (mutedDiscordDms0, mutedDiscordGuilds0, mutedDms0, mutedGuilds0, mutedSlackWorkspaces0) {
								return {mutedDiscordDms: mutedDiscordDms0, mutedDiscordGuilds: mutedDiscordGuilds0, mutedDms: mutedDms0, mutedGuilds: mutedGuilds0, mutedSlackWorkspaces: mutedSlackWorkspaces0};
							})))))));
var $author$project$Evergreen$V417$Pagination$PageId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Pagination$w3_unsafe_decode_PageId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$PersonName$PersonName = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$PersonName$w3_unsafe_decode_PersonName = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$X25519$PublicKey = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$X25519$w3_unsafe_decode_Key = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F8(
										function (w00, w10, w20, w30, w40, w50, w60, w70) {
											return {w0: w00, w1: w10, w2: w20, w3: w30, w4: w40, w5: w50, w6: w60, w7: w70};
										}))))))))));
var $author$project$Evergreen$V417$X25519$w3_unsafe_decode_PublicKey = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$X25519$w3_unsafe_decode_Key,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$UserColor$UserColor = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$UserColor$w3_unsafe_decode_UserColor = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$User$w3_unsafe_decode_BackendUser = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqSet$decodeSet(
		$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
			$author$project$Evergreen$V417$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
				$lamdera$codecs$Lamdera$Wire3$decodePair$(
					$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId),
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute),
				$author$project$Evergreen$V417$OneOrGreater$w3_unsafe_decode_OneOrGreater)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$X25519$w3_unsafe_decode_PublicKey),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqSet$decodeSet(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$PersonName$w3_unsafe_decode_PersonName,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_Model,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeBool,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeBool,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$containers$SeqDict$decodeDict$(
											$lamdera$codecs$Lamdera$Wire3$decodePair$(
												$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
												$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId)),
											$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId)),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$containers$SeqDict$decodeDict$(
												$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
												$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId)),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$containers$SeqDict$decodeDict$(
													$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
													$lamdera$codecs$Lamdera$Wire3$decodePair$(
														$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId),
														$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute)),
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Pagination$w3_unsafe_decode_PageId),
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$author$project$Evergreen$V417$User$w3_unsafe_decode_LastDmViewed,
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$lamdera$containers$SeqDict$decodeDict$(
																		$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
																		$lamdera$codecs$Lamdera$Wire3$decodePair$(
																			$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
																			$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute)),
																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																		$lamdera$containers$SeqDict$decodeDict$(
																			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
																			$lamdera$codecs$Lamdera$Wire3$decodePair$(
																				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId),
																				$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute)),
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$codecs$Lamdera$Wire3$decodeBool,
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash),
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiConfig,
																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																						$author$project$Evergreen$V417$User$w3_unsafe_decode_EmbedVisibility,
																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																							$author$project$Evergreen$V417$User$w3_unsafe_decode_EmailNotifications,
																							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																								$author$project$Evergreen$V417$User$w3_unsafe_decode_BackendUserStatus,
																								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																									$lamdera$codecs$Lamdera$Wire3$decodeBool,
																									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																										$lamdera$containers$SeqSet$decodeSet($author$project$Evergreen$V417$RichText$w3_unsafe_decode_Domain),
																										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																											$lamdera$containers$SeqSet$decodeSet(
																												$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId)),
																											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																												$lamdera$containers$SeqDict$decodeDict$(
																													$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
																													$author$project$Evergreen$V417$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
																														$lamdera$codecs$Lamdera$Wire3$decodePair$(
																															$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
																															$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute),
																														$author$project$Evergreen$V417$OneOrGreater$w3_unsafe_decode_OneOrGreater)),
																												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																													$lamdera$containers$SeqDict$decodeDict$(
																														$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
																														$author$project$Evergreen$V417$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
																															$lamdera$codecs$Lamdera$Wire3$decodePair$(
																																$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId),
																																$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute),
																															$author$project$Evergreen$V417$OneOrGreater$w3_unsafe_decode_OneOrGreater)),
																													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																														$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
																														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																															$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
																															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																$author$project$Evergreen$V417$UserColor$w3_unsafe_decode_UserColor,
																																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																	$lamdera$containers$SeqSet$decodeSet(
																																		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_StickerId)),
																																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																		$lamdera$containers$SeqSet$decodeSet(
																																			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_CustomEmojiId)),
																																		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																																			function (availableCustomEmojis0) {
																																				return function (availableStickers0) {
																																					return function (color0) {
																																						return function (createdAt0) {
																																							return function (deleteAccountAt0) {
																																								return function (directMentions0) {
																																									return function (discordDirectMentions0) {
																																										return function (discordNotifyOnAllMessages0) {
																																											return function (domainWhitelist0) {
																																												return function (e2eeRisksAccepted0) {
																																													return function (email0) {
																																														return function (emailNotifications0) {
																																															return function (embedVisibility0) {
																																																return function (emojiConfig0) {
																																																	return function (icon0) {
																																																		return function (isAdmin0) {
																																																			return function (lastChannelViewed0) {
																																																				return function (lastDiscordChannelViewed0) {
																																																					return function (lastDmViewed0) {
																																																						return function (lastEmailNotification0) {
																																																							return function (lastLogPageViewed0) {
																																																								return function (lastPushNotification0) {
																																																									return function (lastSlackChannelViewed0) {
																																																										return function (lastViewedMessage0) {
																																																											return function (lastViewedThreadMessage0) {
																																																												return function (linkDiscordAcknowledgementIsChecked0) {
																																																													return function (linkSlackAcknowledgementIsChecked0) {
																																																														return function (muteSettings0) {
																																																															return function (name0) {
																																																																return function (notifyOnAllMessages0) {
																																																																	return function (publicKey0) {
																																																																		return function (recentLoginEmails0) {
																																																																			return function (slackDirectMentions0) {
																																																																				return function (slackNotifyOnAllMessages0) {
																																																																					return {availableCustomEmojis: availableCustomEmojis0, availableStickers: availableStickers0, color: color0, createdAt: createdAt0, deleteAccountAt: deleteAccountAt0, directMentions: directMentions0, discordDirectMentions: discordDirectMentions0, discordNotifyOnAllMessages: discordNotifyOnAllMessages0, domainWhitelist: domainWhitelist0, e2eeRisksAccepted: e2eeRisksAccepted0, email: email0, emailNotifications: emailNotifications0, embedVisibility: embedVisibility0, emojiConfig: emojiConfig0, icon: icon0, isAdmin: isAdmin0, lastChannelViewed: lastChannelViewed0, lastDiscordChannelViewed: lastDiscordChannelViewed0, lastDmViewed: lastDmViewed0, lastEmailNotification: lastEmailNotification0, lastLogPageViewed: lastLogPageViewed0, lastPushNotification: lastPushNotification0, lastSlackChannelViewed: lastSlackChannelViewed0, lastViewedMessage: lastViewedMessage0, lastViewedThreadMessage: lastViewedThreadMessage0, linkDiscordAcknowledgementIsChecked: linkDiscordAcknowledgementIsChecked0, linkSlackAcknowledgementIsChecked: linkSlackAcknowledgementIsChecked0, muteSettings: muteSettings0, name: name0, notifyOnAllMessages: notifyOnAllMessages0, publicKey: publicKey0, recentLoginEmails: recentLoginEmails0, slackDirectMentions: slackDirectMentions0, slackNotifyOnAllMessages: slackNotifyOnAllMessages0};
																																																																				};
																																																																			};
																																																																		};
																																																																	};
																																																																};
																																																															};
																																																														};
																																																													};
																																																												};
																																																											};
																																																										};
																																																									};
																																																								};
																																																							};
																																																						};
																																																					};
																																																				};
																																																			};
																																																		};
																																																	};
																																																};
																																															};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			})))))))))))))))))))))))))))))))))));
var $author$project$Evergreen$V417$LocalState$BasicData_ForAdmin = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$LocalState$FullData_ForAdmin = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$LocalState$NeedsAuthAgain_ForAdmin = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_DiscordGatewayStatus = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (failedReconnectAttempts0, websocketIsOpen0) {
					return {failedReconnectAttempts: failedReconnectAttempts0, websocketIsOpen: websocketIsOpen0};
				}))));
var $author$project$Evergreen$V417$DiscordUserData$DiscordUserLoadedSuccessfully = {$: 0};
var $author$project$Evergreen$V417$DiscordUserData$DiscordUserLoadingData = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$DiscordUserData$DiscordUserLoadingFailed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$DiscordUserData$w3_unsafe_decode_DiscordUserLoadingData = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$DiscordUserData$DiscordUserLoadedSuccessfully);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$DiscordUserData$DiscordUserLoadingData));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$DiscordUserData$DiscordUserLoadingFailed));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Discord$AvatarHash = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Discord$w3_unsafe_decode_AvatarHash = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Discord$ImageHash = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Discord$w3_unsafe_decode_ImageHash = function (w3_x_c_hashType) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$Discord$UserDiscriminator = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserDiscriminator = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Discord$w3_unsafe_decode_PartialUser = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserDiscriminator,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_ImageHash($author$project$Evergreen$V417$Discord$w3_unsafe_decode_AvatarHash)),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (avatar0, discriminator0, id0, username0) {
							return {avatar: avatar0, discriminator: discriminator0, id: id0, username: username0};
						}))))));
var $author$project$Evergreen$V417$Discord$Included = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Discord$Missing = {$: 1};
var $author$project$Evergreen$V417$Discord$w3_unsafe_decode_OptionalData = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_a,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Discord$Included));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Discord$Missing);
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$Discord$w3_unsafe_decode_User = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Discord$w3_unsafe_decode_OptionalData($lamdera$codecs$Lamdera$Wire3$decodeBool),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$Discord$w3_unsafe_decode_OptionalData($lamdera$codecs$Lamdera$Wire3$decodeBool),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$Discord$w3_unsafe_decode_OptionalData($lamdera$codecs$Lamdera$Wire3$decodeInt),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_OptionalData($lamdera$codecs$Lamdera$Wire3$decodeInt),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_OptionalData($lamdera$codecs$Lamdera$Wire3$decodeBool),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_OptionalData($lamdera$codecs$Lamdera$Wire3$decodeString),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Discord$w3_unsafe_decode_OptionalData($lamdera$codecs$Lamdera$Wire3$decodeInt),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V417$Discord$w3_unsafe_decode_OptionalData(
											$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString)),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserDiscriminator,
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$author$project$Evergreen$V417$Discord$w3_unsafe_decode_OptionalData($lamdera$codecs$Lamdera$Wire3$decodeBool),
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
														$author$project$Evergreen$V417$Discord$w3_unsafe_decode_ImageHash($author$project$Evergreen$V417$Discord$w3_unsafe_decode_AvatarHash)),
													$lamdera$codecs$Lamdera$Wire3$succeedDecode(
														function (avatar0) {
															return function (bot0) {
																return function (discriminator0) {
																	return function (email0) {
																		return function (flags0) {
																			return function (id0) {
																				return function (locale0) {
																					return function (mfaEnabled0) {
																						return function (premiumType0) {
																							return function (publicFlags0) {
																								return function (system0) {
																									return function (username0) {
																										return function (verified0) {
																											return {avatar: avatar0, bot: bot0, discriminator: discriminator0, email: email0, flags: flags0, id: id0, locale: locale0, mfaEnabled: mfaEnabled0, premiumType: premiumType0, publicFlags: publicFlags0, system: system0, username: username0, verified: verified0};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														}))))))))))))));
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_DiscordUserData_ForAdmin = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_PartialUser,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (icon0, user0) {
										return {icon: icon0, user: user0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$BasicData_ForAdmin));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_User,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$DiscordUserData$w3_unsafe_decode_DiscordUserLoadingData,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_DiscordGatewayStatus,
											$lamdera$codecs$Lamdera$Wire3$succeedDecode(
												F6(
													function (gateway0, icon0, isLoadingData0, linkedAt0, linkedTo0, user0) {
														return {gateway: gateway0, icon: icon0, isLoadingData: isLoadingData0, linkedAt: linkedAt0, linkedTo: linkedTo0, user: user0};
													})))))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$FullData_ForAdmin));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_User,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F4(
											function (icon0, linkedAt0, linkedTo0, user0) {
												return {icon: icon0, linkedAt: linkedAt0, linkedTo: linkedTo0, user: user0};
											})))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$NeedsAuthAgain_ForAdmin));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$DmChannelId$DmChannelId$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$DmChannelId$DmChannelId = F2($author$project$Evergreen$V417$DmChannelId$DmChannelId$);
var $author$project$Evergreen$V417$DmChannelId$w3_unsafe_decode_DmChannelId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$DmChannelId$DmChannelId)));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_EditedBackendUser = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (createdAt0, deleteAccountAt0, email0, isAdmin0, name0) {
								return {createdAt: createdAt0, deleteAccountAt: deleteAccountAt0, email: email0, isAdmin: isAdmin0, name: name0};
							})))))));
var $author$project$Evergreen$V417$Discord$BadRequest400 = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Discord$Forbidden403 = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V417$Discord$GatewayUnavailable502 = function (a) {
	return {$: 6, a: a};
};
var $author$project$Evergreen$V417$Discord$NetworkError = {$: 8};
var $author$project$Evergreen$V417$Discord$NotFound404 = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V417$Discord$NotModified304 = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Discord$ServerError5xx = function (a) {
	return {$: 7, a: a};
};
var $author$project$Evergreen$V417$Discord$Timeout = {$: 9};
var $author$project$Evergreen$V417$Discord$TooManyRequests429 = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V417$Discord$Unauthorized401 = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$Discord$UnexpectedError = function (a) {
	return {$: 10, a: a};
};
var $author$project$Evergreen$V417$Discord$ApiIsCurrentlyOverloaded130000 = 65;
var $author$project$Evergreen$V417$Discord$BotsCannotUseThisEndpoint20001 = 24;
var $author$project$Evergreen$V417$Discord$CannotEditAMessageAuthoredByAnotherUser50005 = 44;
var $author$project$Evergreen$V417$Discord$CannotExecuteActionOnADmChannel50003 = 42;
var $author$project$Evergreen$V417$Discord$CannotExecuteActionOnASystemMessage50021 = 58;
var $author$project$Evergreen$V417$Discord$CannotSendAnEmptyMessage50006 = 45;
var $author$project$Evergreen$V417$Discord$CannotSendMessagesInAVoiceChannel50008 = 47;
var $author$project$Evergreen$V417$Discord$CannotSendMessagesToThisUser50007 = 46;
var $author$project$Evergreen$V417$Discord$ChannelVerificationLevelTooHigh50009 = 48;
var $author$project$Evergreen$V417$Discord$FeatureTemporarilyDisabledServerSide40006 = 38;
var $author$project$Evergreen$V417$Discord$GeneralError0 = 0;
var $author$project$Evergreen$V417$Discord$GuildWidgetDisabled50004 = 43;
var $author$project$Evergreen$V417$Discord$InvalidAccountType50002 = 41;
var $author$project$Evergreen$V417$Discord$InvalidApiVersionProvided50041 = 63;
var $author$project$Evergreen$V417$Discord$InvalidAuthenticationTokenProvided50014 = 53;
var $author$project$Evergreen$V417$Discord$InvalidFormBody50035 = 61;
var $author$project$Evergreen$V417$Discord$InvalidOAuth2AccessTokenProvided50025 = 59;
var $author$project$Evergreen$V417$Discord$InvalidOAuth2State50012 = 51;
var $author$project$Evergreen$V417$Discord$InviteCodeWasEitherInvalidOrTaken50020 = 57;
var $author$project$Evergreen$V417$Discord$InviteWasAcceptedToAGuildTheAppsBotIsNotIn50036 = 62;
var $author$project$Evergreen$V417$Discord$MaxNumberOfAttachmentsInAMessage30015 = 33;
var $author$project$Evergreen$V417$Discord$MaxNumberOfFriends30002 = 27;
var $author$project$Evergreen$V417$Discord$MaxNumberOfGuildChannels30013 = 32;
var $author$project$Evergreen$V417$Discord$MaxNumberOfGuilds30001 = 26;
var $author$project$Evergreen$V417$Discord$MaxNumberOfGuildsRoles30005 = 29;
var $author$project$Evergreen$V417$Discord$MaxNumberOfInvitesReached30016 = 34;
var $author$project$Evergreen$V417$Discord$MaxNumberOfPinsForChannel30003 = 28;
var $author$project$Evergreen$V417$Discord$MaxNumberOfReactions30010 = 31;
var $author$project$Evergreen$V417$Discord$MaxNumberOfWebhooks30007 = 30;
var $author$project$Evergreen$V417$Discord$MessageCanOnlyBePinnedToChannelItIsIn50019 = 56;
var $author$project$Evergreen$V417$Discord$MessageProvidedWasTooOldToBulkDelete50034 = 60;
var $author$project$Evergreen$V417$Discord$MissingAccess50001 = 40;
var $author$project$Evergreen$V417$Discord$NoteWasTooLong50015 = 54;
var $author$project$Evergreen$V417$Discord$OAuth2AppDoesNotHaveABot50010 = 49;
var $author$project$Evergreen$V417$Discord$OAuth2AppLimitReached50011 = 50;
var $author$project$Evergreen$V417$Discord$OnlyBotsCanUseThisEndpoint20002 = 25;
var $author$project$Evergreen$V417$Discord$ProvidedTooFewOrTooManyMessagesToDelete50016 = 55;
var $author$project$Evergreen$V417$Discord$ReactionWasBlocked90001 = 64;
var $author$project$Evergreen$V417$Discord$RequestEntityTooLarge40005 = 37;
var $author$project$Evergreen$V417$Discord$UnauthorizedProvideAValidTokenAndTryAgain40001 = 35;
var $author$project$Evergreen$V417$Discord$UnknownAccount10001 = 1;
var $author$project$Evergreen$V417$Discord$UnknownApp10002 = 2;
var $author$project$Evergreen$V417$Discord$UnknownBan10026 = 16;
var $author$project$Evergreen$V417$Discord$UnknownBranch10032 = 22;
var $author$project$Evergreen$V417$Discord$UnknownBuild10030 = 20;
var $author$project$Evergreen$V417$Discord$UnknownChannel10003 = 3;
var $author$project$Evergreen$V417$Discord$UnknownEmoji10014 = 14;
var $author$project$Evergreen$V417$Discord$UnknownEntitlement10029 = 19;
var $author$project$Evergreen$V417$Discord$UnknownGuild10004 = 4;
var $author$project$Evergreen$V417$Discord$UnknownIntegration1005 = 5;
var $author$project$Evergreen$V417$Discord$UnknownInvite10006 = 6;
var $author$project$Evergreen$V417$Discord$UnknownLobby10031 = 21;
var $author$project$Evergreen$V417$Discord$UnknownMember10007 = 7;
var $author$project$Evergreen$V417$Discord$UnknownMessage10008 = 8;
var $author$project$Evergreen$V417$Discord$UnknownPermissionOverwrite10009 = 9;
var $author$project$Evergreen$V417$Discord$UnknownProvider10010 = 10;
var $author$project$Evergreen$V417$Discord$UnknownRedistributable10036 = 23;
var $author$project$Evergreen$V417$Discord$UnknownRole10011 = 11;
var $author$project$Evergreen$V417$Discord$UnknownSku10027 = 17;
var $author$project$Evergreen$V417$Discord$UnknownStoreListing10028 = 18;
var $author$project$Evergreen$V417$Discord$UnknownToken10012 = 12;
var $author$project$Evergreen$V417$Discord$UnknownUser10013 = 13;
var $author$project$Evergreen$V417$Discord$UnknownWebhook10015 = 15;
var $author$project$Evergreen$V417$Discord$UserIsBannedFromThisGuild40007 = 39;
var $author$project$Evergreen$V417$Discord$VerifyYourAccount40002 = 36;
var $author$project$Evergreen$V417$Discord$YouLackPermissionsToPerformThatAction50013 = 52;
var $author$project$Evergreen$V417$Discord$w3_unsafe_decode_ErrorCode = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(65);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(24);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(44);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(42);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(58);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(45);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(47);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(46);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(48);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(38);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(43);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(41);
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(63);
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(53);
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(61);
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(59);
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(51);
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(57);
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(62);
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(33);
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(27);
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(32);
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(26);
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(29);
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(34);
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(28);
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(31);
			case 28:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(30);
			case 29:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(56);
			case 30:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(60);
			case 31:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(40);
			case 32:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(54);
			case 33:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(49);
			case 34:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(50);
			case 35:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(25);
			case 36:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(55);
			case 37:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(64);
			case 38:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(37);
			case 39:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(35);
			case 40:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 41:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 42:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(16);
			case 43:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(22);
			case 44:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(20);
			case 45:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 46:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(14);
			case 47:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(19);
			case 48:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 49:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 50:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			case 51:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(21);
			case 52:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			case 53:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(8);
			case 54:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(9);
			case 55:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(10);
			case 56:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(23);
			case 57:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(11);
			case 58:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(17);
			case 59:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(18);
			case 60:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(12);
			case 61:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(13);
			case 62:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(15);
			case 63:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(39);
			case 64:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(36);
			case 65:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(52);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Discord$w3_unsafe_decode_RateLimit = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (isGlobal0, retryAfter0) {
					return {isGlobal: isGlobal0, retryAfter: retryAfter0};
				}))));
var $author$project$Evergreen$V417$Discord$w3_unsafe_decode_HttpError = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_ErrorCode,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Discord$BadRequest400));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_ErrorCode,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Discord$Forbidden403));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_ErrorCode,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Discord$GatewayUnavailable502));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Discord$NetworkError);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_ErrorCode,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Discord$NotFound404));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_ErrorCode,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Discord$NotModified304));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_ErrorCode,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (errorCode0, statusCode0) {
										return {errorCode: errorCode0, statusCode: statusCode0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Discord$ServerError5xx));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Discord$Timeout);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_RateLimit,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Discord$TooManyRequests429));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_ErrorCode,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Discord$Unauthorized401));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Discord$UnexpectedError));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Log$ChangedUsers = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V417$Log$DeletedLog = {$: 36};
var $author$project$Evergreen$V417$Log$EmptyDiscordMessage = function (a) {
	return {$: 22, a: a};
};
var $author$project$Evergreen$V417$Log$FailedToAddReactionToDiscordDmMessage$ = function (a, b, c, d, e) {
	return {$: 11, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V417$Log$FailedToAddReactionToDiscordDmMessage = F5($author$project$Evergreen$V417$Log$FailedToAddReactionToDiscordDmMessage$);
var $author$project$Evergreen$V417$Log$FailedToAddReactionToDiscordGuildMessage$ = function (a, b, c, d, e, f) {
	return {$: 10, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Evergreen$V417$Log$FailedToAddReactionToDiscordGuildMessage = F6($author$project$Evergreen$V417$Log$FailedToAddReactionToDiscordGuildMessage$);
var $author$project$Evergreen$V417$Log$FailedToChangeSlackReaction$ = function (a, b) {
	return {$: 32, a: a, b: b};
};
var $author$project$Evergreen$V417$Log$FailedToChangeSlackReaction = F2($author$project$Evergreen$V417$Log$FailedToChangeSlackReaction$);
var $author$project$Evergreen$V417$Log$FailedToDeleteDiscordDmMessage$ = function (a, b, c, d) {
	return {$: 7, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Log$FailedToDeleteDiscordDmMessage = F4($author$project$Evergreen$V417$Log$FailedToDeleteDiscordDmMessage$);
var $author$project$Evergreen$V417$Log$FailedToDeleteDiscordGuildMessage$ = function (a, b, c, d, e) {
	return {$: 6, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V417$Log$FailedToDeleteDiscordGuildMessage = F5($author$project$Evergreen$V417$Log$FailedToDeleteDiscordGuildMessage$);
var $author$project$Evergreen$V417$Log$FailedToDeleteOrphanedFiles = function (a) {
	return {$: 28, a: a};
};
var $author$project$Evergreen$V417$Log$FailedToDeleteSlackMessage$ = function (a, b) {
	return {$: 33, a: a, b: b};
};
var $author$project$Evergreen$V417$Log$FailedToDeleteSlackMessage = F2($author$project$Evergreen$V417$Log$FailedToDeleteSlackMessage$);
var $author$project$Evergreen$V417$Log$FailedToEditDiscordDmMessage$ = function (a, b, c, d) {
	return {$: 9, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Log$FailedToEditDiscordDmMessage = F4($author$project$Evergreen$V417$Log$FailedToEditDiscordDmMessage$);
var $author$project$Evergreen$V417$Log$FailedToEditDiscordGuildMessage$ = function (a, b, c, d, e) {
	return {$: 8, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V417$Log$FailedToEditDiscordGuildMessage = F5($author$project$Evergreen$V417$Log$FailedToEditDiscordGuildMessage$);
var $author$project$Evergreen$V417$Log$FailedToEditSlackMessage$ = function (a, b) {
	return {$: 34, a: a, b: b};
};
var $author$project$Evergreen$V417$Log$FailedToEditSlackMessage = F2($author$project$Evergreen$V417$Log$FailedToEditSlackMessage$);
var $author$project$Evergreen$V417$Log$FailedToGenerateScheduledBackup$ = function (a, b) {
	return {$: 26, a: a, b: b};
};
var $author$project$Evergreen$V417$Log$FailedToGenerateScheduledBackup = F2($author$project$Evergreen$V417$Log$FailedToGenerateScheduledBackup$);
var $author$project$Evergreen$V417$Log$FailedToGetDataForJoinedOrCreatedDiscordGuild$ = function (a, b, c) {
	return {$: 19, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Log$FailedToGetDataForJoinedOrCreatedDiscordGuild = F3($author$project$Evergreen$V417$Log$FailedToGetDataForJoinedOrCreatedDiscordGuild$);
var $author$project$Evergreen$V417$Log$FailedToGetDiscordUserAvatars = function (a) {
	return {$: 17, a: a};
};
var $author$project$Evergreen$V417$Log$FailedToLoadDiscordGuildCustomEmojis$ = function (a, b) {
	return {$: 25, a: a, b: b};
};
var $author$project$Evergreen$V417$Log$FailedToLoadDiscordGuildCustomEmojis = F2($author$project$Evergreen$V417$Log$FailedToLoadDiscordGuildCustomEmojis$);
var $author$project$Evergreen$V417$Log$FailedToLoadDiscordGuildStickers$ = function (a, b) {
	return {$: 23, a: a, b: b};
};
var $author$project$Evergreen$V417$Log$FailedToLoadDiscordGuildStickers = F2($author$project$Evergreen$V417$Log$FailedToLoadDiscordGuildStickers$);
var $author$project$Evergreen$V417$Log$FailedToLoadDiscordStandardStickerPacks = function (a) {
	return {$: 24, a: a};
};
var $author$project$Evergreen$V417$Log$FailedToLoadDiscordUserData$ = function (a, b) {
	return {$: 14, a: a, b: b};
};
var $author$project$Evergreen$V417$Log$FailedToLoadDiscordUserData = F2($author$project$Evergreen$V417$Log$FailedToLoadDiscordUserData$);
var $author$project$Evergreen$V417$Log$FailedToLoadSlackConversations$ = function (a, b) {
	return {$: 29, a: a, b: b};
};
var $author$project$Evergreen$V417$Log$FailedToLoadSlackConversations = F2($author$project$Evergreen$V417$Log$FailedToLoadSlackConversations$);
var $author$project$Evergreen$V417$Log$FailedToLoadSlackCustomEmojis$ = function (a, b, c) {
	return {$: 30, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Log$FailedToLoadSlackCustomEmojis = F3($author$project$Evergreen$V417$Log$FailedToLoadSlackCustomEmojis$);
var $author$project$Evergreen$V417$Log$FailedToParseDiscordWebsocket$ = function (a, b) {
	return {$: 18, a: a, b: b};
};
var $author$project$Evergreen$V417$Log$FailedToParseDiscordWebsocket = F2($author$project$Evergreen$V417$Log$FailedToParseDiscordWebsocket$);
var $author$project$Evergreen$V417$Log$FailedToRegenerateServerSecret = function (a) {
	return {$: 27, a: a};
};
var $author$project$Evergreen$V417$Log$FailedToReloadDiscordGuild$ = function (a, b) {
	return {$: 20, a: a, b: b};
};
var $author$project$Evergreen$V417$Log$FailedToReloadDiscordGuild = F2($author$project$Evergreen$V417$Log$FailedToReloadDiscordGuild$);
var $author$project$Evergreen$V417$Log$FailedToRemoveReactionToDiscordDmMessage$ = function (a, b, c, d, e) {
	return {$: 13, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V417$Log$FailedToRemoveReactionToDiscordDmMessage = F5($author$project$Evergreen$V417$Log$FailedToRemoveReactionToDiscordDmMessage$);
var $author$project$Evergreen$V417$Log$FailedToRemoveReactionToDiscordGuildMessage$ = function (a, b, c, d, e, f) {
	return {$: 12, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Evergreen$V417$Log$FailedToRemoveReactionToDiscordGuildMessage = F6($author$project$Evergreen$V417$Log$FailedToRemoveReactionToDiscordGuildMessage$);
var $author$project$Evergreen$V417$Log$FailedToSendDiscordDmMessage$ = function (a, b, c) {
	return {$: 16, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Log$FailedToSendDiscordDmMessage = F3($author$project$Evergreen$V417$Log$FailedToSendDiscordDmMessage$);
var $author$project$Evergreen$V417$Log$FailedToSendDiscordGuildMessage$ = function (a, b, c, d, e) {
	return {$: 15, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V417$Log$FailedToSendDiscordGuildMessage = F5($author$project$Evergreen$V417$Log$FailedToSendDiscordGuildMessage$);
var $author$project$Evergreen$V417$Log$FailedToSendNotificationEmail$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V417$Log$FailedToSendNotificationEmail = F2($author$project$Evergreen$V417$Log$FailedToSendNotificationEmail$);
var $author$project$Evergreen$V417$Log$FailedToSendSlackMessage$ = function (a, b) {
	return {$: 31, a: a, b: b};
};
var $author$project$Evergreen$V417$Log$FailedToSendSlackMessage = F2($author$project$Evergreen$V417$Log$FailedToSendSlackMessage$);
var $author$project$Evergreen$V417$Log$JoinedDiscordThreadFailed$ = function (a, b) {
	return {$: 21, a: a, b: b};
};
var $author$project$Evergreen$V417$Log$JoinedDiscordThreadFailed = F2($author$project$Evergreen$V417$Log$JoinedDiscordThreadFailed$);
var $author$project$Evergreen$V417$Log$LoginEmail$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$Log$LoginEmail = F2($author$project$Evergreen$V417$Log$LoginEmail$);
var $author$project$Evergreen$V417$Log$LoginsRateLimited = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$Log$PushNotificationError$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$Evergreen$V417$Log$PushNotificationError = F2($author$project$Evergreen$V417$Log$PushNotificationError$);
var $author$project$Evergreen$V417$Log$ReceivedTypeThatIsAlwaysInvalid = {$: 35};
var $author$project$Evergreen$V417$Log$SendLogErrorEmailFailed$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $author$project$Evergreen$V417$Log$SendLogErrorEmailFailed = F2($author$project$Evergreen$V417$Log$SendLogErrorEmailFailed$);
var $lamdera$codecs$Lamdera$Wire3$decodeUnit = $elm$bytes$Bytes$Decode$succeed(0);
var $author$project$Evergreen$V417$Slack$BadBody = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V417$Slack$BadStatus$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V417$Slack$BadStatus = F2($author$project$Evergreen$V417$Slack$BadStatus$);
var $author$project$Evergreen$V417$Slack$BadUrl = function (a) {
	return {$: 6, a: a};
};
var $author$project$Evergreen$V417$Slack$NetworkError = {$: 5};
var $author$project$Evergreen$V417$Slack$RateLimited = {$: 1};
var $author$project$Evergreen$V417$Slack$SlackError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Slack$Timeout = {$: 4};
var $author$project$Evergreen$V417$Slack$w3_unsafe_decode_HttpError = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Slack$BadBody));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Slack$BadStatus)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Slack$BadUrl));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Slack$NetworkError);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Slack$RateLimited);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Slack$SlackError));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Slack$Timeout);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Discord$MessageId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Discord$w3_unsafe_decode_MessageId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Postmark$BadUrl = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V417$Postmark$NetworkError = {$: 2};
var $author$project$Evergreen$V417$Postmark$PostmarkError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Postmark$Timeout = {$: 3};
var $author$project$Evergreen$V417$Postmark$UnknownError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Postmark$w3_unsafe_decode_PostmarkSendResponse = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V417$EmailAddress$w3_unsafe_decode_EmailAddress),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (errorCode0, message0, to0) {
						return {errorCode: errorCode0, message: message0, to: to0};
					})))));
var $author$project$Evergreen$V417$Postmark$w3_unsafe_decode_SendEmailError = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Postmark$BadUrl));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Postmark$NetworkError);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Postmark$w3_unsafe_decode_PostmarkSendResponse,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Postmark$PostmarkError));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Postmark$Timeout);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeString,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (body0, statusCode0) {
										return {body: body0, statusCode: statusCode0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Postmark$UnknownError));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Id$NoThreadWithMaybeMessage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Id$ViewThreadWithMaybeMessage$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V417$Id$ViewThreadWithMaybeMessage = F2($author$project$Evergreen$V417$Id$ViewThreadWithMaybeMessage$);
var $author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMaybeMessage = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Id$NoThreadWithMaybeMessage));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Id$ViewThreadWithMaybeMessage)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Log$w3_unsafe_decode_Log = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$ChangedUsers));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$DeletedLog);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$EmptyDiscordMessage));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_MessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$FailedToAddReactionToDiscordDmMessage))))));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_MessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$FailedToAddReactionToDiscordGuildMessage)))))));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Slack$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_SlackGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$FailedToChangeSlackReaction)));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_MessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$FailedToDeleteDiscordDmMessage)))));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_MessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$FailedToDeleteDiscordGuildMessage))))));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$FailedToDeleteOrphanedFiles));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Slack$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_SlackGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$FailedToDeleteSlackMessage)));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_MessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$FailedToEditDiscordDmMessage)))));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_MessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$FailedToEditDiscordGuildMessage))))));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Slack$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_SlackGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$FailedToEditSlackMessage)));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$FailedToGenerateScheduledBackup)));
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$FailedToGetDataForJoinedOrCreatedDiscordGuild))));
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$FailedToGetDiscordUserAvatars));
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$lamdera$codecs$Lamdera$Wire3$decodePair$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_CustomEmojiId),
								$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$FailedToLoadDiscordGuildCustomEmojis)));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$lamdera$codecs$Lamdera$Wire3$decodePair$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_StickerId),
								$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$FailedToLoadDiscordGuildStickers)));
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$FailedToLoadDiscordStandardStickerPacks));
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$FailedToLoadDiscordUserData)));
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Slack$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$FailedToLoadSlackConversations)));
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$lamdera$codecs$Lamdera$Wire3$decodePair$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_CustomEmojiId),
								$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$FailedToLoadSlackCustomEmojis))));
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$FailedToParseDiscordWebsocket)));
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$FailedToRegenerateServerSecret));
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$FailedToReloadDiscordGuild)));
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_MessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$FailedToRemoveReactionToDiscordDmMessage))))));
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_MessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$FailedToRemoveReactionToDiscordGuildMessage)))))));
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$FailedToSendDiscordDmMessage))));
			case 28:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMaybeMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$FailedToSendDiscordGuildMessage))))));
			case 29:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$EmailAddress$w3_unsafe_decode_EmailAddress,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Postmark$w3_unsafe_decode_SendEmailError,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$FailedToSendNotificationEmail)));
			case 30:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Slack$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_SlackGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$FailedToSendSlackMessage)));
			case 31:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$JoinedDiscordThreadFailed)));
			case 32:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$EmailAddress$w3_unsafe_decode_EmailAddress,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeResult$($author$project$Evergreen$V417$Postmark$w3_unsafe_decode_SendEmailError, $lamdera$codecs$Lamdera$Wire3$decodeUnit),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$LoginEmail)));
			case 33:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$LoginsRateLimited));
			case 34:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$PushNotificationError)));
			case 35:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$ReceivedTypeThatIsAlwaysInvalid);
			case 36:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$EmailAddress$w3_unsafe_decode_EmailAddress,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Postmark$w3_unsafe_decode_SendEmailError,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Log$SendLogErrorEmailFailed)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_LogWithTime = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Log$w3_unsafe_decode_Log,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (log0, time0) {
					return {log: log0, time: time0};
				}))));
var $author$project$Evergreen$V417$LocalState$PrivateVapidKey = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_PrivateVapidKey = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Discord$w3_unsafe_decode_RoleColors = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (primaryColor0, secondaryColor0, tertiaryColor0) {
						return {primaryColor: primaryColor0, secondaryColor: secondaryColor0, tertiaryColor: tertiaryColor0};
					})))));
var $author$project$Evergreen$V417$Discord$RoleIconHash = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Discord$w3_unsafe_decode_RoleIconHash = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Discord$IntegrationId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Discord$w3_unsafe_decode_IntegrationId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Discord$SubscriptionListingId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Discord$w3_unsafe_decode_SubscriptionListingId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Discord$w3_unsafe_decode_RoleTags = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Discord$w3_unsafe_decode_OptionalData(
		$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_SubscriptionListingId)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$Discord$w3_unsafe_decode_OptionalData(
				$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_IntegrationId)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeBool,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_OptionalData(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F6(
								function (availableForPurchase0, botId0, guildConnections0, integrationId0, premiumSubscriber0, subscriptionListingId0) {
									return {availableForPurchase: availableForPurchase0, botId: botId0, guildConnections: guildConnections0, integrationId: integrationId0, premiumSubscriber: premiumSubscriber0, subscriptionListingId: subscriptionListingId0};
								}))))))));
var $author$project$Evergreen$V417$Discord$w3_unsafe_decode_Role = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Discord$w3_unsafe_decode_OptionalData($author$project$Evergreen$V417$Discord$w3_unsafe_decode_RoleTags),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Permissions,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeBool,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_RoleId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
										$author$project$Evergreen$V417$Discord$w3_unsafe_decode_ImageHash($author$project$Evergreen$V417$Discord$w3_unsafe_decode_RoleIconHash)),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeBool,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Evergreen$V417$Discord$w3_unsafe_decode_OptionalData($lamdera$codecs$Lamdera$Wire3$decodeInt),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$author$project$Evergreen$V417$Discord$w3_unsafe_decode_OptionalData($author$project$Evergreen$V417$Discord$w3_unsafe_decode_RoleColors),
													$lamdera$codecs$Lamdera$Wire3$succeedDecode(
														function (colors0) {
															return function (description0) {
																return function (flags0) {
																	return function (hoist0) {
																		return function (icon0) {
																			return function (id0) {
																				return function (managed0) {
																					return function (mentionable0) {
																						return function (name0) {
																							return function (permissions0) {
																								return function (position0) {
																									return function (tags0) {
																										return function (unicodeEmoji0) {
																											return {colors: colors0, description: description0, flags: flags0, hoist: hoist0, icon: icon0, id: id0, managed: managed0, mentionable: mentionable0, name: name0, permissions: permissions0, position: position0, tags: tags0, unicodeEmoji: unicodeEmoji0};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														}))))))))))))));
var $author$project$Evergreen$V417$SessionIdHash$SessionIdHash = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$SessionIdHash$w3_unsafe_decode_SessionIdHash = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_AdminDataRequest = 15;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_AdminToBackend = 5;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_AiChatToBackend = 10;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_CheckLoginRequest = 0;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_ExportChannelRequest = 17;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_FinishUserCreationRequest = 9;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_GetLoginTokenRequest = 4;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_GetPublicGoMatchRequest = 16;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_ImportChannelRequest = 18;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_JoinGuildByInviteRequest = 8;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_LinkDiscordRequest = 12;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_LinkSlackRequest = 13;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_AcceptE2ee = 95;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_AddCustomEmojisToUser = 73;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_AddReactionEmoji = 38;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_Admin = 20;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_BanMember = 35;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_CancelAccountDeletion = 63;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_CancelE2eeRequest = 88;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_CollapseUserOptionSection = 59;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_CurrentlyViewing = 46;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_DeclineE2eeRequest = 89;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_DecryptOldMessages = 93;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_DeleteChannel = 29;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_DeleteGuild = 31;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_DeleteInviteLink = 34;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_DeleteMessage = 45;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_DisableE2ee = 92;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_Discord_LoadChannelMessages = 50;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_Discord_LoadThreadMessages = 53;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_Discord_SendEditDmMessage = 42;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_Discord_SendEditGuildMessage = 41;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_Discord_SendMessage = 22;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_Drawing = 76;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_EditChannel = 28;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_EditGuildName = 30;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_EncryptOldMessages = 91;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_ExpandUserOptionSection = 57;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_Game = 75;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_Invalid = 19;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_LeaveGuild = 32;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_LinkDiscordAcknowledgementIsChecked = 68;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_LinkSlackAcknowledgementIsChecked = 69;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_LoadChannelMessages = 48;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_LoadThreadMessages = 49;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_MemberEditTyping = 43;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_MemberTyping = 37;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_NewChannel = 27;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_NewGuild = 36;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_NewInviteLink = 33;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_RegisterPushSubscription = 64;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_RemoveReactionEmoji = 39;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_RequestE2ee = 87;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_ScheduleAccountDeletion = 62;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_SendEditMessage = 40;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_SendEncryptedEditMessage = 97;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_SendEncryptedMessage = 96;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_SendMessage = 21;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_SetDiscordGuildNotificationLevel = 55;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_SetDomainWhitelist = 70;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_SetE2eeRisksAccepted = 94;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_SetEmailNotifications = 60;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_SetEmbedVisibility = 61;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_SetEmojiSkinTone = 71;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_SetGuildNotificationLevel = 54;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_SetLastViewed = 44;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_SetMuteChannel = 77;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_SetMuteDiscordChannel = 79;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_SetMuteDiscordGuild = 82;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_SetMuteDiscordThread = 80;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_SetMuteGuild = 81;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_SetMuteSlackChannel = 85;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_SetMuteSlackThread = 86;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_SetMuteSlackWorkspace = 84;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_SetMuteThread = 78;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_SetName = 47;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_SetNotificationMode = 56;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_SetPublicKey = 90;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_SetSheepGameQuestions = 58;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_SetSlackWorkspaceNotificationLevel = 83;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_SetUserColor = 72;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_Slack_LoadChannelMessages = 51;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_Slack_LoadThreadMessages = 52;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_Slack_ReloadUser = 26;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_Slack_SendEditMessage = 24;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_Slack_SendMessage = 23;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_Slack_UnlinkUser = 25;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_StartReloadingDiscordUser = 67;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_TextEditor = 65;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_UnlinkDiscordUser = 66;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_Local_VoiceChatChange = 74;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_LogOutRequest = 6;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_LoginWithRecoveryPasswordRequest = 3;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_LoginWithTokenRequest = 1;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_LoginWithTwoFactorRequest = 2;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_ProfilePictureEditorToBackend = 14;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_ReloadDataRequest = 11;
var $author$project$Evergreen$V417$ToBackendLog$ToBackendLog_TwoFactorToBackend = 7;
var $author$project$Evergreen$V417$ToBackendLog$w3_unsafe_decode_ToBackendLog = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(15);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(10);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(17);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(9);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(16);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(18);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(8);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(12);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(13);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(95);
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(73);
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(38);
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(20);
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(35);
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(63);
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(88);
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(59);
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(46);
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(89);
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(93);
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(29);
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(31);
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(34);
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(45);
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(92);
			case 28:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(50);
			case 29:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(53);
			case 30:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(42);
			case 31:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(41);
			case 32:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(22);
			case 33:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(76);
			case 34:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(28);
			case 35:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(30);
			case 36:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(91);
			case 37:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(57);
			case 38:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(75);
			case 39:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(19);
			case 40:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(32);
			case 41:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(68);
			case 42:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(69);
			case 43:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(48);
			case 44:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(49);
			case 45:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(43);
			case 46:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(37);
			case 47:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(27);
			case 48:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(36);
			case 49:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(33);
			case 50:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(64);
			case 51:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(39);
			case 52:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(87);
			case 53:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(62);
			case 54:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(40);
			case 55:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(97);
			case 56:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(96);
			case 57:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(21);
			case 58:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(55);
			case 59:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(70);
			case 60:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(94);
			case 61:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(60);
			case 62:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(61);
			case 63:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(71);
			case 64:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(54);
			case 65:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(44);
			case 66:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(77);
			case 67:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(79);
			case 68:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(82);
			case 69:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(80);
			case 70:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(81);
			case 71:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(85);
			case 72:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(86);
			case 73:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(84);
			case 74:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(78);
			case 75:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(47);
			case 76:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(56);
			case 77:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(90);
			case 78:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(58);
			case 79:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(83);
			case 80:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(72);
			case 81:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(51);
			case 82:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(52);
			case 83:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(26);
			case 84:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(24);
			case 85:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(23);
			case 86:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(25);
			case 87:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(67);
			case 88:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(65);
			case 89:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(66);
			case 90:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(74);
			case 91:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			case 92:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 93:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 94:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 95:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(14);
			case 96:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(11);
			case 97:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$ToBackendLog$w3_unsafe_decode_ToBackendLogData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$ToBackendLog$w3_unsafe_decode_ToBackendLog,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (endTime0, startTime0, toBackendLog0, userId0) {
							return {endTime: endTime0, startTime: startTime0, toBackendLog: toBackendLog0, userId: userId0};
						}))))));
var $author$project$Evergreen$V417$UserSession$EmptyPlaceholder = {$: 0};
var $author$project$Evergreen$V417$UserSession$FilledInByBackend = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$UserSession$EmptyPlaceholder);
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_a,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$UserSession$FilledInByBackend));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$IdArray$IdArray = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$IdArray$w3_unsafe_decode_IdArray$ = function (w3_x_c_k, w3_x_c_v) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeArray(w3_x_c_v),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$IdArray$w3_unsafe_decode_IdArray = F2($author$project$Evergreen$V417$IdArray$w3_unsafe_decode_IdArray$);
var $author$project$Evergreen$V417$UserSession$LastViewedDiscordGuild = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$UserSession$LastViewedGuild = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$UserSession$LastViewedSlackWorkspace = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_LastViewedGuild = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$UserSession$LastViewedDiscordGuild));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$UserSession$LastViewedGuild));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$UserSession$LastViewedSlackWorkspace));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$UserSession$NoNotifications = 0;
var $author$project$Evergreen$V417$UserSession$NotifyWhenRunning = 1;
var $author$project$Evergreen$V417$UserSession$PushNotifications = 2;
var $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_NotificationMode = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$UserSession$NotSubscribed = {$: 0};
var $author$project$Evergreen$V417$UserSession$Subscribed$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V417$UserSession$Subscribed = F2($author$project$Evergreen$V417$UserSession$Subscribed$);
var $author$project$Evergreen$V417$UserSession$SubscriptionError$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V417$UserSession$SubscriptionError = F2($author$project$Evergreen$V417$UserSession$SubscriptionError$);
var $author$project$Evergreen$V417$UserSession$SubscriptionJsException$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Evergreen$V417$UserSession$SubscriptionJsException = F2($author$project$Evergreen$V417$UserSession$SubscriptionJsException$);
var $author$project$Evergreen$V417$Ports$w3_unsafe_decode_SubscribeKeys = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (auth0, p256dh0) {
					return {auth: auth0, p256dh: p256dh0};
				}))));
var $author$project$Evergreen$V417$Ports$w3_unsafe_decode_SubscribeData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Ports$w3_unsafe_decode_SubscribeKeys,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
			A2(
				$lamdera$codecs$Lamdera$Wire3$andThenDecode,
				function (t) {
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
						$elm$time$Time$millisToPosix(t));
				},
				$lamdera$codecs$Lamdera$Wire3$decodeInt)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$elm$url$Url$w3_unsafe_decode_Url,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (endpoint0, expirationTime0, keys0) {
						return {endpoint: endpoint0, expirationTime: expirationTime0, keys: keys0};
					})))));
var $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_PushSubscription = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$UserSession$NotSubscribed);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Ports$w3_unsafe_decode_SubscribeData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$UserSession$Subscribed)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Ports$w3_unsafe_decode_SubscribeData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$UserSession$SubscriptionError)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$UserSession$SubscriptionJsException)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_SheepGameQuestion = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
			$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileStatus),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (attachedFiles0, text0) {
					return {attachedFiles: attachedFiles0, text: text0};
				}))));
var $author$project$Evergreen$V417$UserAgent$Chrome = 0;
var $author$project$Evergreen$V417$UserAgent$Edge = 3;
var $author$project$Evergreen$V417$UserAgent$Firefox = 1;
var $author$project$Evergreen$V417$UserAgent$Opera = 4;
var $author$project$Evergreen$V417$UserAgent$Safari = 2;
var $author$project$Evergreen$V417$UserAgent$UnknownBrowser = 5;
var $author$project$Evergreen$V417$UserAgent$w3_unsafe_decode_Browser = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$UserAgent$AndroidPhone = 2;
var $author$project$Evergreen$V417$UserAgent$AndroidTablet = 3;
var $author$project$Evergreen$V417$UserAgent$ChromeOS = 6;
var $author$project$Evergreen$V417$UserAgent$Desktop = 10;
var $author$project$Evergreen$V417$UserAgent$IPad = 1;
var $author$project$Evergreen$V417$UserAgent$IPhone = 0;
var $author$project$Evergreen$V417$UserAgent$Linux = 7;
var $author$project$Evergreen$V417$UserAgent$MacOS = 5;
var $author$project$Evergreen$V417$UserAgent$Mobile = 8;
var $author$project$Evergreen$V417$UserAgent$Tablet = 9;
var $author$project$Evergreen$V417$UserAgent$Windows = 4;
var $author$project$Evergreen$V417$UserAgent$w3_unsafe_decode_Device = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(10);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(8);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(9);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$UserAgent$w3_unsafe_decode_UserAgent = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$UserAgent$w3_unsafe_decode_Device,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$UserAgent$w3_unsafe_decode_Browser,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (browser0, device0) {
					return {browser: browser0, device: device0};
				}))));
var $author$project$Evergreen$V417$UserSession$UserOption_ConnectedDevices = 5;
var $author$project$Evergreen$V417$UserSession$UserOption_Debug = 6;
var $author$project$Evergreen$V417$UserSession$UserOption_Discord = 4;
var $author$project$Evergreen$V417$UserSession$UserOption_E2ee = 3;
var $author$project$Evergreen$V417$UserSession$UserOption_Privacy = 7;
var $author$project$Evergreen$V417$UserSession$UserOption_Settings = 1;
var $author$project$Evergreen$V417$UserSession$UserOption_Slack = 8;
var $author$project$Evergreen$V417$UserSession$UserOption_TwoFactorAuthentication = 0;
var $author$project$Evergreen$V417$UserSession$UserOption_WhitelistedDomains = 2;
var $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_UserOptionSection = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(8);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_UserSession = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$UserAgent$w3_unsafe_decode_UserAgent,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$SessionIdHash$w3_unsafe_decode_SessionIdHash,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$IdArray$w3_unsafe_decode_IdArray$($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId, $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_SheepGameQuestion),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_PushSubscription,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_NotificationMode,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$UserSession$w3_unsafe_decode_LastViewedGuild),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$containers$SeqSet$decodeSet($author$project$Evergreen$V417$UserSession$w3_unsafe_decode_UserOptionSection),
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											function (expandedUserOptions0) {
												return function (lastClientDisconnect0) {
													return function (lastViewedGuild0) {
														return function (notificationMode0) {
															return function (pushSubscription0) {
																return function (savedSheepGameQuestions0) {
																	return function (sessionIdHash0) {
																		return function (signedInAt0) {
																			return function (userAgent0) {
																				return function (userId0) {
																					return {expandedUserOptions: expandedUserOptions0, lastClientDisconnect: lastClientDisconnect0, lastViewedGuild: lastViewedGuild0, notificationMode: notificationMode0, pushSubscription: pushSubscription0, savedSheepGameQuestions: savedSheepGameQuestions0, sessionIdHash: sessionIdHash0, signedInAt: signedInAt0, userAgent: userAgent0, userId: userId0};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											})))))))))));
var $author$project$Evergreen$V417$LocalState$WebsocketClosed_CloseAndReopenForUser$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$LocalState$WebsocketClosed_CloseAndReopenForUser = F2($author$project$Evergreen$V417$LocalState$WebsocketClosed_CloseAndReopenForUser$);
var $author$project$Evergreen$V417$LocalState$WebsocketClosed_ClosedByBackendForUser$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V417$LocalState$WebsocketClosed_ClosedByBackendForUser = F2($author$project$Evergreen$V417$LocalState$WebsocketClosed_ClosedByBackendForUser$);
var $author$project$Evergreen$V417$LocalState$WebsocketClosed_ListenCloseEvent$ = function (a, b, c, d) {
	return {$: 3, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$LocalState$WebsocketClosed_ListenCloseEvent = F4($author$project$Evergreen$V417$LocalState$WebsocketClosed_ListenCloseEvent$);
var $author$project$Evergreen$V417$LocalState$WebsocketClosed_UnlinkDiscordUser$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V417$LocalState$WebsocketClosed_UnlinkDiscordUser = F2($author$project$Evergreen$V417$LocalState$WebsocketClosed_UnlinkDiscordUser$);
var $lamdera$program_test$Effect$Websocket$AbnormalClosure = {$: 5};
var $lamdera$program_test$Effect$Websocket$BadGateway = {$: 13};
var $lamdera$program_test$Effect$Websocket$GoingAway = {$: 1};
var $lamdera$program_test$Effect$Websocket$InternalError = {$: 10};
var $lamdera$program_test$Effect$Websocket$InvalidFramePayloadData = {$: 6};
var $lamdera$program_test$Effect$Websocket$MessageTooBig = {$: 8};
var $lamdera$program_test$Effect$Websocket$MissingExtension = {$: 9};
var $lamdera$program_test$Effect$Websocket$NoStatusReceived = {$: 4};
var $lamdera$program_test$Effect$Websocket$NormalClosure = {$: 0};
var $lamdera$program_test$Effect$Websocket$PolicyViolation = {$: 7};
var $lamdera$program_test$Effect$Websocket$ProtocolError = {$: 2};
var $lamdera$program_test$Effect$Websocket$ServiceRestart = {$: 11};
var $lamdera$program_test$Effect$Websocket$TlsHandshake = {$: 14};
var $lamdera$program_test$Effect$Websocket$TryAgainLater = {$: 12};
var $lamdera$program_test$Effect$Websocket$UnknownCode = function (a) {
	return {$: 15, a: a};
};
var $lamdera$program_test$Effect$Websocket$UnsupportedData = {$: 3};
var $lamdera$program_test$Effect$Websocket$w3_unsafe_decode_CloseEventCode = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($lamdera$program_test$Effect$Websocket$AbnormalClosure);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($lamdera$program_test$Effect$Websocket$BadGateway);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($lamdera$program_test$Effect$Websocket$GoingAway);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($lamdera$program_test$Effect$Websocket$InternalError);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($lamdera$program_test$Effect$Websocket$InvalidFramePayloadData);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($lamdera$program_test$Effect$Websocket$MessageTooBig);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($lamdera$program_test$Effect$Websocket$MissingExtension);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($lamdera$program_test$Effect$Websocket$NoStatusReceived);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($lamdera$program_test$Effect$Websocket$NormalClosure);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($lamdera$program_test$Effect$Websocket$PolicyViolation);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($lamdera$program_test$Effect$Websocket$ProtocolError);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($lamdera$program_test$Effect$Websocket$ServiceRestart);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($lamdera$program_test$Effect$Websocket$TlsHandshake);
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($lamdera$program_test$Effect$Websocket$TryAgainLater);
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($lamdera$program_test$Effect$Websocket$UnknownCode));
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($lamdera$program_test$Effect$Websocket$UnsupportedData);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_WebsocketClosedEvent = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$WebsocketClosed_CloseAndReopenForUser)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$WebsocketClosed_ClosedByBackendForUser)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Websocket$w3_unsafe_decode_CloseEventCode,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$WebsocketClosed_ListenCloseEvent)))));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$WebsocketClosed_UnlinkDiscordUser)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_AdminChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_EditedBackendUser),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqSet$decodeSet(
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId)),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$containers$SeqDict$decodeDict$(
										$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
										$author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_EditedBackendUser),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F4(
											function (changedUsers0, deletedUsers0, newUsers0, time0) {
												return {changedUsers: changedUsers0, deletedUsers: deletedUsers0, newUsers: newUsers0, time: time0};
											})))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$ChangeUsers));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$DeleteDiscordDmChannel));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$DeleteDiscordGuild));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$DeleteGuild));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$codecs$Lamdera$Wire3$decodeResult$(
							$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
							$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$DeleteOrphanedFiles));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$SessionIdHash$w3_unsafe_decode_SessionIdHash,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$DeleteSession));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_DmChannelId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$DeleteSlackDmChannel));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$DeleteSlackWorkspace));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$SessionIdHash$w3_unsafe_decode_SessionIdHash,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$DisconnectClient)));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V417$BackendMsgLog$w3_unsafe_decode_BackendMsgLogData)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$LoadBackendMsgLogs));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
							$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminData_DeletedGuild)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$LoadDeletedGuilds));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
							$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminData_DiscordDmChannel)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$LoadDiscordDmChannels));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
							$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminData_DiscordGuild)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$LoadDiscordGuilds));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
							$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_DiscordUserData_ForAdmin)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$LoadDiscordUsers));
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V417$DmChannelId$w3_unsafe_decode_DmChannelId, $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminData_DmChannel)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$LoadDmChannels));
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
							$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminData_Guild)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$LoadGuilds));
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash, $author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_BackendFileData)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$LoadOrphanedFiles));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V417$SessionIdHash$w3_unsafe_decode_SessionIdHash, $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_UserSession)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$LoadSessions));
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_DmChannelId),
							$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminData_SlackDmChannel)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$LoadSlackDmChannels));
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
							$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminData_SlackWorkspace)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$LoadSlackWorkspaces));
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V417$ToBackendLog$w3_unsafe_decode_ToBackendLogData)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$LoadToBackendLogs));
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$author$project$Evergreen$V417$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
							$author$project$Evergreen$V417$User$w3_unsafe_decode_BackendUser)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$LoadUsers));
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V417$LocalState$w3_unsafe_decode_WebsocketClosedEvent)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$LoadWebsocketCloseEvents));
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V417$LocalState$w3_unsafe_decode_LogWithTime)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Pagination$w3_unsafe_decode_PageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$LogPageChanged)));
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Http$w3_unsafe_decode_Error, $lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$RegenerateServerSecret));
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$codecs$Lamdera$Wire3$decodeResult$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_HttpError,
							$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V417$Discord$w3_unsafe_decode_Role))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$ReloadDiscordGuild))));
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$RestoreGuild));
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$SetDiscordLinkLimit));
			case 28:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$SetDiscordLinkingEnabled));
			case 29:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$SetEmailNotificationsEnabled));
			case 30:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$SetNotifyAdminsBotUserId));
			case 31:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$SetNotifyAdminsToken));
			case 32:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$SetOpenRouterKey));
			case 33:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Postmark$w3_unsafe_decode_ApiKey,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$SetPostmarkKey));
			case 34:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_PrivateVapidKey,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$SetPrivateVapidKey));
			case 35:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$SetPublicVapidKey));
			case 36:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$SetSignupsEnabled));
			case 37:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$SetSlackLinkLimit));
			case 38:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$SetSlackLinkingEnabled));
			case 39:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$StartReloadingDiscordDmChannel))));
			case 40:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$StartReloadingDiscordGuildChannel)))));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Drawing$DateDividerAnchor$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V417$Drawing$DateDividerAnchor = F2($author$project$Evergreen$V417$Drawing$DateDividerAnchor$);
var $author$project$Evergreen$V417$Drawing$MessageAnchor$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$Drawing$MessageAnchor = F2($author$project$Evergreen$V417$Drawing$MessageAnchor$);
var $justinmimbs$date$Date$w3_unsafe_decode_RataDie = $lamdera$codecs$Lamdera$Wire3$decodeInt;
var $justinmimbs$date$Date$w3_unsafe_decode_Date = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$justinmimbs$date$Date$w3_unsafe_decode_RataDie,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Drawing$CardAnchor = {$: 4};
var $author$project$Evergreen$V417$Drawing$EmbedImageAnchor = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V417$Drawing$ImageAttachmentAnchor = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$Drawing$TimestampAnchor = {$: 1};
var $author$project$Evergreen$V417$Drawing$UserIconAnchor = {$: 0};
var $author$project$Evergreen$V417$Drawing$w3_unsafe_decode_MessageAnchor = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Drawing$CardAnchor);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Drawing$EmbedImageAnchor));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Drawing$ImageAttachmentAnchor));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Drawing$TimestampAnchor);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Drawing$UserIconAnchor);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Drawing$w3_unsafe_decode_AnchorType = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$justinmimbs$date$Date$w3_unsafe_decode_Date,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Drawing$DateDividerAnchor)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Drawing$w3_unsafe_decode_MessageAnchor,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Drawing$MessageAnchor)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_ChannelDataToDecrypt = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
		$author$project$Evergreen$V417$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId),
			$author$project$Evergreen$V417$Encryption$w3_unsafe_decode_EncryptedData(
				$author$project$Evergreen$V417$Message$w3_unsafe_decode_MessageContent$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId))))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
			$author$project$Evergreen$V417$Encryption$w3_unsafe_decode_EncryptedData(
				$author$project$Evergreen$V417$Message$w3_unsafe_decode_MessageContent$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId)))),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (channel0, threads0) {
					return {channel: channel0, threads: threads0};
				}))));
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_ChannelDataToEncrypt = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId),
			$author$project$Evergreen$V417$Message$w3_unsafe_decode_MessageContent$(
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId)))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
			$author$project$Evergreen$V417$Message$w3_unsafe_decode_MessageContent$(
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId))),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (channel0, threads0) {
					return {channel: channel0, threads: threads0};
				}))));
var $author$project$Evergreen$V417$ChannelDescription$ChannelDescription = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$ChannelDescription$w3_unsafe_decode_ChannelDescription = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Game$GameData_Go$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$Game$GameData_Go = F2($author$project$Evergreen$V417$Game$GameData_Go$);
var $author$project$Evergreen$V417$Game$GameData_SheepGame$ = function (a, b, c) {
	return {$: 2, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Game$GameData_SheepGame = F3($author$project$Evergreen$V417$Game$GameData_SheepGame$);
var $author$project$Evergreen$V417$Game$GameData_WordSpellingGame$ = function (a, b, c) {
	return {$: 1, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Game$GameData_WordSpellingGame = F3($author$project$Evergreen$V417$Game$GameData_WordSpellingGame$);
var $author$project$Evergreen$V417$Go$AcceptTerritory = {$: 4};
var $author$project$Evergreen$V417$Go$FinishedMarking = {$: 3};
var $author$project$Evergreen$V417$Go$Joined = function (a) {
	return {$: 6, a: a};
};
var $author$project$Evergreen$V417$Go$MarkTerritory$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V417$Go$MarkTerritory = F2($author$project$Evergreen$V417$Go$MarkTerritory$);
var $author$project$Evergreen$V417$Go$PassTurn = {$: 1};
var $author$project$Evergreen$V417$Go$PlaceStone$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$Go$PlaceStone = F2($author$project$Evergreen$V417$Go$PlaceStone$);
var $author$project$Evergreen$V417$Go$RejectTerritory = {$: 5};
var $author$project$Evergreen$V417$Go$w3_unsafe_decode_Action = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$AcceptTerritory);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$FinishedMarking);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$Joined));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$MarkTerritory)));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$PassTurn);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$PlaceStone)));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$RejectTerritory);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Go$w3_unsafe_decode_ActionWithTime = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Go$w3_unsafe_decode_Action,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (change0, time0) {
					return {change: change0, time: time0};
				}))));
var $author$project$Evergreen$V417$SheepGame$AddedReaction$ = function (a, b) {
	return {$: 7, a: a, b: b};
};
var $author$project$Evergreen$V417$SheepGame$AddedReaction = F2($author$project$Evergreen$V417$SheepGame$AddedReaction$);
var $author$project$Evergreen$V417$SheepGame$ChangedGroup$ = function (a, b, c) {
	return {$: 3, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$SheepGame$ChangedGroup = F3($author$project$Evergreen$V417$SheepGame$ChangedGroup$);
var $author$project$Evergreen$V417$SheepGame$ChangedNotes$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $author$project$Evergreen$V417$SheepGame$ChangedNotes = F2($author$project$Evergreen$V417$SheepGame$ChangedNotes$);
var $author$project$Evergreen$V417$SheepGame$ChangedQuestionsRevealed = function (a) {
	return {$: 6, a: a};
};
var $author$project$Evergreen$V417$SheepGame$FinishedGrouping = {$: 5};
var $author$project$Evergreen$V417$SheepGame$LockedAnswers = {$: 1};
var $author$project$Evergreen$V417$SheepGame$RemovedReaction$ = function (a, b) {
	return {$: 8, a: a, b: b};
};
var $author$project$Evergreen$V417$SheepGame$RemovedReaction = F2($author$project$Evergreen$V417$SheepGame$RemovedReaction$);
var $author$project$Evergreen$V417$SheepGame$SubmittedAnswer$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$SheepGame$SubmittedAnswer = F2($author$project$Evergreen$V417$SheepGame$SubmittedAnswer$);
var $author$project$Evergreen$V417$SheepGame$UnlockedAnswers = {$: 2};
var $author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_Reactions = $lamdera$containers$SeqDict$decodeDict$(
	$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
	$author$project$Evergreen$V417$NonemptySet$w3_unsafe_decode_NonemptySet(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId)));
var $author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_ValidatedInput = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
		$author$project$Evergreen$V417$RichText$w3_unsafe_decode_RichText$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_Reactions,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
				$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileData),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (attachedFiles0, reactions0, text0) {
						return {attachedFiles: attachedFiles0, reactions: reactions0, text: text0};
					})))));
var $author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_Action = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_ReactionTarget,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$AddedReaction)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$ChangedGroup))));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_ValidatedInput),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$ChangedNotes)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$ChangedQuestionsRevealed));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$FinishedGrouping);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$LockedAnswers);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_ReactionTarget,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$RemovedReaction)));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_ValidatedInput),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$SubmittedAnswer)));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$UnlockedAnswers);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_ActionWithTime = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_Action,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (change0, time0, userId0) {
						return {change: change0, time: time0, userId: userId0};
					})))));
var $author$project$Evergreen$V417$WordSpellingGame$AddedReaction$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$Evergreen$V417$WordSpellingGame$AddedReaction = F2($author$project$Evergreen$V417$WordSpellingGame$AddedReaction$);
var $author$project$Evergreen$V417$WordSpellingGame$CancelPremove = {$: 4};
var $author$project$Evergreen$V417$WordSpellingGame$JoinGame = {$: 2};
var $author$project$Evergreen$V417$WordSpellingGame$PlaceWord$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$WordSpellingGame$PlaceWord = F2($author$project$Evergreen$V417$WordSpellingGame$PlaceWord$);
var $author$project$Evergreen$V417$WordSpellingGame$Premove$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Evergreen$V417$WordSpellingGame$Premove = F2($author$project$Evergreen$V417$WordSpellingGame$Premove$);
var $author$project$Evergreen$V417$WordSpellingGame$RemovedReaction$ = function (a, b) {
	return {$: 6, a: a, b: b};
};
var $author$project$Evergreen$V417$WordSpellingGame$RemovedReaction = F2($author$project$Evergreen$V417$WordSpellingGame$RemovedReaction$);
var $author$project$Evergreen$V417$WordSpellingGame$ReplaceTrayOrPass = {$: 1};
var $author$project$Evergreen$V417$WordSpellingGame$IsNotValid = {$: 1};
var $author$project$Evergreen$V417$WordSpellingGame$IsValid = function (a) {
	return {$: 0, a: a};
};
var $lamdera$codecs$Lamdera$Wire3$decodeSet = function (decVal) {
	return $elm$bytes$Bytes$Decode$map$(
		$elm$core$Set$fromList,
		$lamdera$codecs$Lamdera$Wire3$decodeList(decVal));
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_IsValid = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$IsNotValid);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeSet($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$IsValid));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$WordSpellingGame$Letter = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$WordSpellingGame$Wildcard = {$: 1};
var $author$project$Evergreen$V417$WordSpellingGame$LetterChar = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_Letter = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeChar,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_Letter,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$Letter));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$Wildcard);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_PlacedWord = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty($author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeBool,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (isVertical0, letters0, start0) {
						return {isVertical: isVertical0, letters: letters0, start: start0};
					})))));
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_Action = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_ReactionTarget,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$AddedReaction)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$CancelPremove);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$JoinGame);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend($author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_IsValid),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_PlacedWord,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$PlaceWord)));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend($author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_IsValid),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_PlacedWord,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$Premove)));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_ReactionTarget,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$RemovedReaction)));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$ReplaceTrayOrPass);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_ActionWithTime = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_Action,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (change0, time0, userId0) {
						return {change: change0, time: time0, userId: userId0};
					})))));
var $author$project$Evergreen$V417$SheepGame$Answering = 0;
var $author$project$Evergreen$V417$SheepGame$Grouping = 1;
var $author$project$Evergreen$V417$SheepGame$Revealing = 2;
var $author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_Phase = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_Shared = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_Phase,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_ValidatedInput)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId)),
					$lamdera$codecs$Lamdera$Wire3$decodeString),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
						$author$project$Evergreen$V417$IdArray$w3_unsafe_decode_IdArray$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId,
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_ValidatedInput))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (answers0, groups0, notes0, phase0, questionsRevealed0) {
								return {answers: answers0, groups: groups0, notes: notes0, phase: phase0, questionsRevealed: questionsRevealed0};
							})))))));
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_AnimatedPlacement = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend($author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_IsValid),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList(
				$lamdera$codecs$Lamdera$Wire3$decodePair$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
					$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard)),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (cells0, isValid0, startTime0) {
						return {cells: cells0, isValid: isValid0, startTime: startTime0};
					})))));
var $author$project$Evergreen$V417$WordSpellingGame$LetterId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_LetterId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_PlacementResult = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeList(
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F2(
						function (letters0, placedCount0) {
							return {letters: letters0, placedCount: placedCount0};
						}))))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList(
				$lamdera$codecs$Lamdera$Wire3$decodePair$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
					$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard)),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (placedCells0, score0, words0) {
						return {placedCells: placedCells0, score: score0, words: words0};
					})))));
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_Player = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$IdArray$w3_unsafe_decode_IdArray$($author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_LetterId, $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
					$lamdera$codecs$Lamdera$Wire3$decodeTriple$($author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_PlacedWord, $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_PlacementResult, $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_IsValid)),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (premove0, score0, tray0, userId0) {
							return {premove: premove0, score: score0, tray: tray0, userId: userId0};
						}))))));
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_Reactions = $lamdera$containers$SeqDict$decodeDict$(
	$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
	$author$project$Evergreen$V417$NonemptySet$w3_unsafe_decode_NonemptySet(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId)));
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_Shared = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_ReactionTarget, $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_Reactions),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty($author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_Player),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_AnimatedPlacement),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
							$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$OneOrGreater$w3_unsafe_decode_OneOrGreater,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F7(
									function (attemptsLeft0, board0, lastPlacement0, passingStartedAt0, players0, reactions0, turnCount0) {
										return {attemptsLeft: attemptsLeft0, board: board0, lastPlacement: lastPlacement0, passingStartedAt: passingStartedAt0, players: players0, reactions: reactions0, turnCount: turnCount0};
									})))))))));
var $author$project$Evergreen$V417$Go$BoardSize = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Go$w3_unsafe_decode_BoardSize = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Go$KomiHalfPoints = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Go$w3_unsafe_decode_KomiHalfPoints = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Go$Black = 0;
var $author$project$Evergreen$V417$Go$White = 1;
var $author$project$Evergreen$V417$Go$w3_unsafe_decode_Stone = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Go$w3_unsafe_decode_TimeControl = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (increment0, mainTime0) {
					return {increment: increment0, mainTime: mainTime0};
				}))));
var $author$project$Evergreen$V417$Go$w3_unsafe_decode_ValidatedSetup = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Go$w3_unsafe_decode_BoardSize,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Go$w3_unsafe_decode_TimeControl),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$Go$w3_unsafe_decode_KomiHalfPoints,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$Go$w3_unsafe_decode_BoardSize,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Go$w3_unsafe_decode_Stone,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F7(
									function (createdBy0, gameCreatorPlayingAs0, handicap0, height0, komiHalfPoints0, timeControl0, width0) {
										return {createdBy: createdBy0, gameCreatorPlayingAs: gameCreatorPlayingAs0, handicap: handicap0, height: height0, komiHalfPoints: komiHalfPoints0, timeControl: timeControl0, width: width0};
									})))))))));
var $author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_ValidatedSetup = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty($author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_ValidatedInput),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (createdBy0, questions0) {
					return {createdBy: createdBy0, questions: questions0};
				}))));
var $author$project$Evergreen$V417$WordSpellingGame$English = 0;
var $author$project$Evergreen$V417$WordSpellingGame$Swedish = 1;
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_Language = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_ValidatedSetup = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$OneOrGreater$w3_unsafe_decode_OneOrGreater,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Go$w3_unsafe_decode_TimeControl,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$OneOrGreater$w3_unsafe_decode_OneOrGreater,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
						$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$OneOrGreater$w3_unsafe_decode_OneOrGreater,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F2(
										function (count0, value0) {
											return {count: count0, value: value0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_Language,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F8(
										function (createdBy0, fullTrayBonus0, language0, letters0, placeWordAttempts0, seed0, timeControls0, traySize0) {
											return {createdBy: createdBy0, fullTrayBonus: fullTrayBonus0, language: language0, letters: letters0, placeWordAttempts: placeWordAttempts0, seed: seed0, timeControls: timeControls0, traySize: traySize0};
										}))))))))));
var $author$project$Evergreen$V417$Game$w3_unsafe_decode_BackendGameData = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V417$Go$w3_unsafe_decode_ActionWithTime),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Go$w3_unsafe_decode_ValidatedSetup,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$GameData_Go)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_Shared,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_ActionWithTime),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_ValidatedSetup,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$GameData_SheepGame))));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_Shared,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_ActionWithTime),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_ValidatedSetup,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$GameData_WordSpellingGame))));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Id$GoMatchPublicId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Id$w3_unsafe_decode_GamePublicId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$SecretId$SecretId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$SecretId$w3_unsafe_decode_SecretId = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$Game$w3_unsafe_decode_LoadedMatch = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
		$author$project$Evergreen$V417$SecretId$w3_unsafe_decode_SecretId($author$project$Evergreen$V417$Id$w3_unsafe_decode_GamePublicId)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Game$w3_unsafe_decode_BackendGameData,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (gameData0, publicLink0) {
					return {gameData: gameData0, publicLink: publicLink0};
				}))));
var $author$project$Evergreen$V417$DmChannel$w3_unsafe_decode_LoadedMessages = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
		$author$project$Evergreen$V417$Game$w3_unsafe_decode_LoadedMatch),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
			$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId,
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId))),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (messages0, repliedToMatches0) {
					return {messages: messages0, repliedToMatches: repliedToMatches0};
				}))));
var $author$project$Evergreen$V417$Call$Local_AnswerRecording = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V417$Call$Local_CancelRecording = {$: 4};
var $author$project$Evergreen$V417$Call$Local_Leave = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Call$Local_RequestRecording = {$: 2};
var $author$project$Evergreen$V417$Call$Local_SetRemoteCallData = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Call$w3_unsafe_decode_RemoteCallData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeBool,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (audioInputEnabled0, screenShareEnabled0, videoInputEnabled0) {
						return {audioInputEnabled: audioInputEnabled0, screenShareEnabled: screenShareEnabled0, videoInputEnabled: videoInputEnabled0};
					})))));
var $author$project$Evergreen$V417$Call$w3_unsafe_decode_LocalChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$Local_AnswerRecording));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$Local_CancelRecording);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$Local_Leave));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$Local_RequestRecording);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Call$w3_unsafe_decode_RemoteCallData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$Local_SetRemoteCallData));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Drawing$ContinueStroke = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Drawing$EndStroke = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$Drawing$RedoStroke = {$: 4};
var $author$project$Evergreen$V417$Drawing$StartStroke = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Drawing$UndoStroke = {$: 3};
var $author$project$Evergreen$V417$Drawing$w3_unsafe_decode_LocalChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V417$SafeFloat$w3_unsafe_decode_SafeFloat, $author$project$Evergreen$V417$SafeFloat$w3_unsafe_decode_SafeFloat)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Drawing$ContinueStroke));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V417$SafeFloat$w3_unsafe_decode_SafeFloat, $author$project$Evergreen$V417$SafeFloat$w3_unsafe_decode_SafeFloat)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Drawing$EndStroke));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Drawing$RedoStroke);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V417$SafeFloat$w3_unsafe_decode_SafeFloat, $author$project$Evergreen$V417$SafeFloat$w3_unsafe_decode_SafeFloat),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Drawing$StartStroke));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Drawing$UndoStroke);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Game$CreatePublicLink$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$Game$CreatePublicLink = F2($author$project$Evergreen$V417$Game$CreatePublicLink$);
var $author$project$Evergreen$V417$Game$LoadMatch$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V417$Game$LoadMatch = F2($author$project$Evergreen$V417$Game$LoadMatch$);
var $author$project$Evergreen$V417$Game$LocalChange_Go$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V417$Game$LocalChange_Go = F2($author$project$Evergreen$V417$Game$LocalChange_Go$);
var $author$project$Evergreen$V417$Game$LocalChange_SheepGame$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $author$project$Evergreen$V417$Game$LocalChange_SheepGame = F2($author$project$Evergreen$V417$Game$LocalChange_SheepGame$);
var $author$project$Evergreen$V417$Game$LocalChange_WordSpellingGame$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Evergreen$V417$Game$LocalChange_WordSpellingGame = F2($author$project$Evergreen$V417$Game$LocalChange_WordSpellingGame$);
var $author$project$Evergreen$V417$Go$Action = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Go$StartMatch$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$Go$StartMatch = F2($author$project$Evergreen$V417$Go$StartMatch$);
var $author$project$Evergreen$V417$Go$w3_unsafe_decode_LocalChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Go$w3_unsafe_decode_ActionWithTime,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$Action));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Go$w3_unsafe_decode_ValidatedSetup,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$StartMatch)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$SheepGame$Action = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$SheepGame$StartMatch$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$SheepGame$StartMatch = F2($author$project$Evergreen$V417$SheepGame$StartMatch$);
var $author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_LocalChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_ActionWithTime,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$Action));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_ValidatedSetup,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$StartMatch)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$WordSpellingGame$Action = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$WordSpellingGame$StartMatch$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$WordSpellingGame$StartMatch = F2($author$project$Evergreen$V417$WordSpellingGame$StartMatch$);
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_LocalChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_ActionWithTime,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$Action));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_ValidatedSetup,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$StartMatch)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Game$w3_unsafe_decode_LocalChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$author$project$Evergreen$V417$SecretId$w3_unsafe_decode_SecretId($author$project$Evergreen$V417$Id$w3_unsafe_decode_GamePublicId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$CreatePublicLink)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend($author$project$Evergreen$V417$Game$w3_unsafe_decode_LoadedMatch),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$LoadMatch)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Go$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$LocalChange_Go)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$LocalChange_SheepGame)));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$LocalChange_WordSpellingGame)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$TextEditor$Local_EditChange = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$TextEditor$Local_Redo = {$: 3};
var $author$project$Evergreen$V417$TextEditor$Local_Reset = {$: 1};
var $author$project$Evergreen$V417$TextEditor$Local_Undo = {$: 2};
var $author$project$Evergreen$V417$TextEditor$Edit_TypedText$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$TextEditor$Edit_TypedText = F2($author$project$Evergreen$V417$TextEditor$Edit_TypedText$);
var $author$project$Evergreen$V417$TextEditor$w3_unsafe_decode_EditChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Range$w3_unsafe_decode_Range,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$TextEditor$Edit_TypedText)));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$TextEditor$w3_unsafe_decode_LocalChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$TextEditor$w3_unsafe_decode_EditChange,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$TextEditor$Local_EditChange));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$TextEditor$Local_Redo);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$TextEditor$Local_Reset);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$TextEditor$Local_Undo);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$User$NotifyOnEveryMessage = 0;
var $author$project$Evergreen$V417$User$NotifyOnMention = 1;
var $author$project$Evergreen$V417$User$w3_unsafe_decode_NotificationLevel = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$VisibleMessages$PageBefore = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$VisibleMessages$PageFrom = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$VisibleMessages$w3_unsafe_decode_PageRequest = function (w3_x_c_messageId) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id(w3_x_c_messageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$VisibleMessages$PageBefore));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id(w3_x_c_messageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$VisibleMessages$PageFrom));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$Ports$GotSubscribeData = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Ports$SubscribeJsException = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Ports$w3_unsafe_decode_RegisterPushSubscription = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Ports$w3_unsafe_decode_SubscribeData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Ports$GotSubscribeData));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Ports$SubscribeJsException));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$SetViewing$StopViewingChannel = {$: 11};
var $author$project$Evergreen$V417$SetViewing$ViewChannel$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Evergreen$V417$SetViewing$ViewChannel = F2($author$project$Evergreen$V417$SetViewing$ViewChannel$);
var $author$project$Evergreen$V417$SetViewing$ViewChannelThread$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $author$project$Evergreen$V417$SetViewing$ViewChannelThread = F2($author$project$Evergreen$V417$SetViewing$ViewChannelThread$);
var $author$project$Evergreen$V417$SetViewing$ViewDiscordChannel$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$Evergreen$V417$SetViewing$ViewDiscordChannel = F2($author$project$Evergreen$V417$SetViewing$ViewDiscordChannel$);
var $author$project$Evergreen$V417$SetViewing$ViewDiscordChannelThread$ = function (a, b) {
	return {$: 6, a: a, b: b};
};
var $author$project$Evergreen$V417$SetViewing$ViewDiscordChannelThread = F2($author$project$Evergreen$V417$SetViewing$ViewDiscordChannelThread$);
var $author$project$Evergreen$V417$SetViewing$ViewDiscordDm$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V417$SetViewing$ViewDiscordDm = F2($author$project$Evergreen$V417$SetViewing$ViewDiscordDm$);
var $author$project$Evergreen$V417$SetViewing$ViewDm$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$SetViewing$ViewDm = F2($author$project$Evergreen$V417$SetViewing$ViewDm$);
var $author$project$Evergreen$V417$SetViewing$ViewDmThread$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V417$SetViewing$ViewDmThread = F2($author$project$Evergreen$V417$SetViewing$ViewDmThread$);
var $author$project$Evergreen$V417$SetViewing$ViewOverview = function (a) {
	return {$: 12, a: a};
};
var $author$project$Evergreen$V417$SetViewing$ViewSlackChannel$ = function (a, b) {
	return {$: 7, a: a, b: b};
};
var $author$project$Evergreen$V417$SetViewing$ViewSlackChannel = F2($author$project$Evergreen$V417$SetViewing$ViewSlackChannel$);
var $author$project$Evergreen$V417$SetViewing$ViewSlackChannelThread$ = function (a, b) {
	return {$: 9, a: a, b: b};
};
var $author$project$Evergreen$V417$SetViewing$ViewSlackChannelThread = F2($author$project$Evergreen$V417$SetViewing$ViewSlackChannelThread$);
var $author$project$Evergreen$V417$SetViewing$ViewSlackDm$ = function (a, b) {
	return {$: 8, a: a, b: b};
};
var $author$project$Evergreen$V417$SetViewing$ViewSlackDm = F2($author$project$Evergreen$V417$SetViewing$ViewSlackDm$);
var $author$project$Evergreen$V417$SetViewing$ViewSlackDmThread$ = function (a, b) {
	return {$: 10, a: a, b: b};
};
var $author$project$Evergreen$V417$SetViewing$ViewSlackDmThread = F2($author$project$Evergreen$V417$SetViewing$ViewSlackDmThread$);
var $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_DiscordFrontendUser = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$PersonName$w3_unsafe_decode_PersonName,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$UserColor$w3_unsafe_decode_UserColor,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (color0, icon0, name0) {
						return {color: color0, icon: icon0, name: name0};
					})))));
var $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_UnreadOverviewData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$lamdera$codecs$Lamdera$Wire3$decodeTriple$(
			$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
			$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId),
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId)),
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId),
			$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId,
				$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
				$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId)))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$lamdera$codecs$Lamdera$Wire3$decodePair$(
				$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_DmChannelId),
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId)),
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId),
				$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId,
					$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
					$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId)))),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_DmChannelId),
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
					$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId,
						$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
						$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId)))),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
						$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId)),
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId,
							$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
							$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId)))),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$lamdera$codecs$Lamdera$Wire3$decodeTriple$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId),
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId)),
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId),
							$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId,
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$lamdera$codecs$Lamdera$Wire3$decodePair$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId)),
							$lamdera$containers$SeqDict$decodeDict$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
								$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId,
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId)))),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqDict$decodeDict$(
								$lamdera$codecs$Lamdera$Wire3$decodePair$(
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId)),
								$lamdera$containers$SeqDict$decodeDict$(
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId),
									$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
										$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId,
										$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
										$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId)))),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqDict$decodeDict$(
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
									$lamdera$containers$SeqDict$decodeDict$(
										$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
										$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
											$author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId,
											$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
											$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId)))),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$containers$SeqDict$decodeDict$(
										$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
										$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_DiscordFrontendUser),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$containers$SeqDict$decodeDict$(
											$lamdera$codecs$Lamdera$Wire3$decodeTriple$(
												$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
												$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
												$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId)),
											$lamdera$containers$SeqDict$decodeDict$(
												$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId),
												$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
													$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId,
													$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
													$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId)))),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$containers$SeqDict$decodeDict$(
												$lamdera$codecs$Lamdera$Wire3$decodePair$(
													$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
													$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId)),
												$lamdera$containers$SeqDict$decodeDict$(
													$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
													$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
														$author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId,
														$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
														$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId)))),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$containers$SeqDict$decodeDict$(
													$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
													$lamdera$containers$SeqDict$decodeDict$(
														$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
														$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
															$author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId,
															$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
															$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId)))),
												$lamdera$codecs$Lamdera$Wire3$succeedDecode(
													function (discordDmChannels0) {
														return function (discordGuildChannels0) {
															return function (discordGuildThreads0) {
																return function (discordUsers0) {
																	return function (dmChannels0) {
																		return function (dmThreads0) {
																			return function (guildChannels0) {
																				return function (guildThreads0) {
																					return function (slackChannels0) {
																						return function (slackDmChannels0) {
																							return function (slackDmThreads0) {
																								return function (slackThreads0) {
																									return {discordDmChannels: discordDmChannels0, discordGuildChannels: discordGuildChannels0, discordGuildThreads: discordGuildThreads0, discordUsers: discordUsers0, dmChannels: dmChannels0, dmThreads: dmThreads0, guildChannels: guildChannels0, guildThreads: guildThreads0, slackChannels: slackChannels0, slackDmChannels: slackDmChannels0, slackDmThreads: slackDmThreads0, slackThreads: slackThreads0};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													})))))))))))));
var $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ViewDiscordGuildData = function (w3_x_c_messageId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
			$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_DiscordFrontendUser),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id(w3_x_c_messageId),
				$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
					w3_x_c_messageId,
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId))),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F2(
					function (messages0, newUsers0) {
						return {messages: messages0, newUsers: newUsers0};
					}))));
};
var $author$project$Evergreen$V417$UserSession$ChannelHeaderTab_ChannelDescription = {$: 2};
var $author$project$Evergreen$V417$UserSession$ChannelHeaderTab_Draw = {$: 3};
var $author$project$Evergreen$V417$UserSession$ChannelHeaderTab_Games$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V417$UserSession$ChannelHeaderTab_Games = F2($author$project$Evergreen$V417$UserSession$ChannelHeaderTab_Games$);
var $author$project$Evergreen$V417$UserSession$ChannelHeaderTab_VoiceChat = {$: 0};
var $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ChannelHeaderTab = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$UserSession$ChannelHeaderTab_ChannelDescription);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$UserSession$ChannelHeaderTab_Draw);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Message$w3_unsafe_decode_RepliedToGame),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$UserSession$ChannelHeaderTab_Games)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$UserSession$ChannelHeaderTab_VoiceChat);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$UserSession$DontCare = {$: 0};
var $author$project$Evergreen$V417$UserSession$PreviouslyLastViewedMessage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage = function (w3_x_c_messageId) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$UserSession$DontCare);
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id(w3_x_c_messageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$UserSession$PreviouslyLastViewedMessage));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_ChannelData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_ChannelId,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ChannelHeaderTab),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (channelHeaderTab0, id0, previouslyLastViewedMessage0) {
						return {channelHeaderTab: channelHeaderTab0, id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0};
					})))));
var $author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_ChannelThreadId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (channelId0, guildId0, threadId0) {
						return {channelId: channelId0, guildId: guildId0, threadId: threadId0};
					})))));
var $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_ChannelThreadData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_ChannelThreadId,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, previouslyLastViewedMessage0) {
					return {id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0};
				}))));
var $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_DiscordChannelData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DiscordChannelId,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, previouslyLastViewedMessage0) {
					return {id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0};
				}))));
var $author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DiscordChannelThreadId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (channelId0, currentUserId0, guildId0, threadId0) {
							return {channelId: channelId0, currentUserId: currentUserId0, guildId: guildId0, threadId: threadId0};
						}))))));
var $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_DiscordChannelThreadData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DiscordChannelThreadId,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, previouslyLastViewedMessage0) {
					return {id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0};
				}))));
var $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_DiscordDmData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DiscordDmId,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, previouslyLastViewedMessage0) {
					return {id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0};
				}))));
var $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_DmData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DmId,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ChannelHeaderTab),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (channelHeaderTab0, id0, previouslyLastViewedMessage0) {
						return {channelHeaderTab: channelHeaderTab0, id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0};
					})))));
var $author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DmThreadId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (otherUserId0, threadId0) {
					return {otherUserId: otherUserId0, threadId: threadId0};
				}))));
var $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_DmThreadData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DmThreadId,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, previouslyLastViewedMessage0) {
					return {id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0};
				}))));
var $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_SlackChannelData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_SlackChannelId,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, previouslyLastViewedMessage0) {
					return {id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0};
				}))));
var $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_SlackChannelThreadData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_SlackChannelId,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (id0, previouslyLastViewedMessage0, threadId0) {
						return {id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0, threadId: threadId0};
					})))));
var $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_SlackDmData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_SlackDmId,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, previouslyLastViewedMessage0) {
					return {id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0};
				}))));
var $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_SlackDmThreadData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_SlackDmId,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (id0, previouslyLastViewedMessage0, threadId0) {
						return {id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0, threadId: threadId0};
					})))));
var $author$project$Evergreen$V417$SetViewing$w3_unsafe_decode_SetViewing = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SetViewing$StopViewingChannel);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend($author$project$Evergreen$V417$DmChannel$w3_unsafe_decode_LoadedMessages),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_ChannelData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SetViewing$ViewChannel)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId),
							$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId,
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_ChannelThreadData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SetViewing$ViewChannelThread)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ViewDiscordGuildData($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_DiscordChannelData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SetViewing$ViewDiscordChannel)));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ViewDiscordGuildData($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_DiscordChannelThreadData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SetViewing$ViewDiscordChannelThread)));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
							$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId,
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_DiscordDmData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SetViewing$ViewDiscordDm)));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend($author$project$Evergreen$V417$DmChannel$w3_unsafe_decode_LoadedMessages),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_DmData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SetViewing$ViewDm)));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId),
							$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId,
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_DmThreadData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SetViewing$ViewDmThread)));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend($author$project$Evergreen$V417$UserSession$w3_unsafe_decode_UnreadOverviewData),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SetViewing$ViewOverview));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
							$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId,
								$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_SlackChannelData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SetViewing$ViewSlackChannel)));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId),
							$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId,
								$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_SlackChannelThreadData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SetViewing$ViewSlackChannelThread)));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
							$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId,
								$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_SlackDmData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SetViewing$ViewSlackDm)));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId),
							$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId,
								$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_SlackDmThreadData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SetViewing$ViewSlackDmThread)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $elm$time$Time$w3_unsafe_decode_Era = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (offset0, start0) {
					return {offset: offset0, start: start0};
				}))));
var $elm$time$Time$w3_unsafe_decode_Zone = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeList($elm$time$Time$w3_unsafe_decode_Era),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$time$Time$Zone)));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $lamdera$program_test$Effect$Time$w3_unsafe_decode_Zone = $elm$time$Time$w3_unsafe_decode_Zone;
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_LocalChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DmId, $author$project$Evergreen$V417$Types$w3_unsafe_decode_ChannelDataToEncrypt)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_AcceptE2ee))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$NonemptySet$w3_unsafe_decode_NonemptySet(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_CustomEmojiId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_AddCustomEmojisToUser));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_AddReactionEmoji))));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_AdminChange,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_Admin));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_BanMember)));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_CancelAccountDeletion);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_UserOptionSection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_CollapseUserOptionSection));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$SetViewing$w3_unsafe_decode_SetViewing,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeBool,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								function (markMessagesAsViewed0) {
									return {markMessagesAsViewed: markMessagesAsViewed0};
								})),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_CurrentlyViewing)));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_DeclineE2eeRequest));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_DeclineE2eeRequestAsInitiator));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList(
						$lamdera$codecs$Lamdera$Wire3$decodePair$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
							$author$project$Evergreen$V417$Message$w3_unsafe_decode_MessageContent$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_DecryptOldMessages))));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_DeleteChannel)));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_DeleteGuild));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$SecretId$w3_unsafe_decode_SecretId($author$project$Evergreen$V417$Id$w3_unsafe_decode_InviteLinkId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_DeleteInviteLink)));
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_DeleteMessage)));
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend($author$project$Evergreen$V417$Types$w3_unsafe_decode_ChannelDataToDecrypt),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_DisableE2ee)));
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
							$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId,
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$VisibleMessages$w3_unsafe_decode_PageRequest($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_DiscordGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_Discord_LoadChannelMessages))));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId),
							$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId,
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$VisibleMessages$w3_unsafe_decode_PageRequest($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_DiscordGuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_Discord_LoadThreadMessages)))));
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DiscordDmId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Zone,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_Discord_SendEditDmMessage))))));
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Zone,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
											$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_Discord_SendEditGuildMessage))))))));
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
						$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileData),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMaybeMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_DiscordGuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Zone,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_Discord_SendMessage)))))));
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Drawing$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Drawing$w3_unsafe_decode_AnchorType,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_Drawing))));
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$ChannelDescription$w3_unsafe_decode_ChannelDescription,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$ChannelName$w3_unsafe_decode_ChannelName,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_EditChannel)))));
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$GuildName$w3_unsafe_decode_GuildName,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_EditGuildName)));
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList(
						$lamdera$codecs$Lamdera$Wire3$decodeTriple$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
							$lamdera$containers$SeqSet$decodeSet($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash),
							$author$project$Evergreen$V417$Encryption$w3_unsafe_decode_EncryptedData(
								$author$project$Evergreen$V417$Message$w3_unsafe_decode_MessageContent$(
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId))))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_EncryptOldMessages)));
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							function (collapseOthers0) {
								return {collapseOthers: collapseOthers0};
							})),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_UserOptionSection,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_ExpandUserOptionSection)));
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Game$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_Game)));
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_Invalid);
			case 28:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_LeaveGuild));
			case 29:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_LinkDiscordAcknowledgementIsChecked));
			case 30:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_LinkSlackAcknowledgementIsChecked));
			case 31:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend($author$project$Evergreen$V417$DmChannel$w3_unsafe_decode_LoadedMessages),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$VisibleMessages$w3_unsafe_decode_PageRequest($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_LoadChannelMessages))));
			case 32:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId),
							$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId,
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$VisibleMessages$w3_unsafe_decode_PageRequest($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_LoadThreadMessages)))));
			case 33:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_MemberEditTyping))));
			case 34:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_MemberTyping)));
			case 35:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$ChannelDescription$w3_unsafe_decode_ChannelDescription,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$ChannelName$w3_unsafe_decode_ChannelName,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_NewChannel)))));
			case 36:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$GuildName$w3_unsafe_decode_GuildName,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_NewGuild))));
			case 37:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$author$project$Evergreen$V417$SecretId$w3_unsafe_decode_SecretId($author$project$Evergreen$V417$Id$w3_unsafe_decode_InviteLinkId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_NewInviteLink))));
			case 38:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Ports$w3_unsafe_decode_RegisterPushSubscription,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_RegisterPushSubscription)));
			case 39:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_RemoveReactionEmoji))));
			case 40:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_RequestE2ee));
			case 41:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_ScheduleAccountDeletion));
			case 42:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
						$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileData),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Zone,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_SendEditMessage)))))));
			case 43:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Encryption$w3_unsafe_decode_EncryptedData(
						$author$project$Evergreen$V417$Message$w3_unsafe_decode_MessageContent$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqSet$decodeSet($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DmId,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_SendEncryptedEditMessage))))));
			case 44:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Message$w3_unsafe_decode_ThreadRouteWithRepliedTo,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Encryption$w3_unsafe_decode_EncryptedData($lamdera$codecs$Lamdera$Wire3$decodeString),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Encryption$w3_unsafe_decode_EncryptedData(
								$author$project$Evergreen$V417$Message$w3_unsafe_decode_MessageContent$(
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId))),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqSet$decodeSet($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DmId,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_SendEncryptedMessage)))))));
			case 45:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
							$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileData),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Message$w3_unsafe_decode_ThreadRouteWithRepliedTo,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildOrDmId,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Zone,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
											$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_SendMessage))))))));
			case 46:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$User$w3_unsafe_decode_NotificationLevel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_SetDiscordGuildNotificationLevel))));
			case 47:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$RichText$w3_unsafe_decode_Domain,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_SetDomainWhitelist)));
			case 48:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_SetE2eeRisksAccepted));
			case 49:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$User$w3_unsafe_decode_EmailNotifications,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_SetEmailNotifications));
			case 50:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$User$w3_unsafe_decode_EmbedVisibility,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_SetEmbedVisibility));
			case 51:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Emoji$w3_unsafe_decode_SkinTone),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_SetEmojiSkinTone));
			case 52:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$User$w3_unsafe_decode_NotificationLevel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_SetGuildNotificationLevel)));
			case 53:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_SetLastViewed)));
			case 54:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_SetMuteChannel))));
			case 55:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_SetMuteDiscordChannel)))));
			case 56:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_SetMuteDiscordGuild))));
			case 57:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_SetMuteDiscordThread))))));
			case 58:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_SetMuteGuild)));
			case 59:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_SetMuteSlackChannel)))));
			case 60:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_SetMuteSlackThread))))));
			case 61:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_SetMuteSlackWorkspace))));
			case 62:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_SetMuteThread)))));
			case 63:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$PersonName$w3_unsafe_decode_PersonName,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_SetName));
			case 64:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_NotificationMode,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_SetNotificationMode));
			case 65:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DmId, $author$project$Evergreen$V417$Types$w3_unsafe_decode_ChannelDataToEncrypt)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$X25519$w3_unsafe_decode_PublicKey,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_SetPublicKey)));
			case 66:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$IdArray$w3_unsafe_decode_IdArray$($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId, $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_SheepGameQuestion),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_SetSheepGameQuestions));
			case 67:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$User$w3_unsafe_decode_NotificationLevel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_SetSlackWorkspaceNotificationLevel))));
			case 68:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserColor$w3_unsafe_decode_UserColor,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_SetUserColor));
			case 69:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
							$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId,
								$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$VisibleMessages$w3_unsafe_decode_PageRequest($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_SlackGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_Slack_LoadChannelMessages))));
			case 70:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId),
							$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId,
								$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$VisibleMessages$w3_unsafe_decode_PageRequest($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_SlackGuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_Slack_LoadThreadMessages)))));
			case 71:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_Slack_ReloadUser));
			case 72:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_SlackGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Zone,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_Slack_SendEditMessage))))));
			case 73:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
						$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileData),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_SlackGuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Zone,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_Slack_SendMessage)))))));
			case 74:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_Slack_UnlinkUser));
			case 75:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_StartReloadingDiscordUser)));
			case 76:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$TextEditor$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_TextEditor));
			case 77:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_UnlinkDiscordUser));
			case 78:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Call$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Local_VoiceChatChange));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Types$Server_AddReactionEmoji$ = function (a, b, c, d) {
	return {$: 30, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$Server_AddReactionEmoji = F4($author$project$Evergreen$V417$Types$Server_AddReactionEmoji$);
var $author$project$Evergreen$V417$Types$Server_BackupGenerated = function (a) {
	return {$: 73, a: a};
};
var $author$project$Evergreen$V417$Types$Server_CallRecordingStarted$ = function (a, b, c, d) {
	return {$: 31, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$Server_CallRecordingStarted = F4($author$project$Evergreen$V417$Types$Server_CallRecordingStarted$);
var $author$project$Evergreen$V417$Types$Server_CallRecordingUploadFinished$ = function (a, b, c) {
	return {$: 33, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Server_CallRecordingUploadFinished = F3($author$project$Evergreen$V417$Types$Server_CallRecordingUploadFinished$);
var $author$project$Evergreen$V417$Types$Server_CallRecordingUploadProgress$ = function (a, b, c) {
	return {$: 32, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Server_CallRecordingUploadProgress = F3($author$project$Evergreen$V417$Types$Server_CallRecordingUploadProgress$);
var $author$project$Evergreen$V417$Types$Server_CallRecordingZipBuilt$ = function (a, b, c) {
	return {$: 34, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Server_CallRecordingZipBuilt = F3($author$project$Evergreen$V417$Types$Server_CallRecordingZipBuilt$);
var $author$project$Evergreen$V417$Types$Server_ClientDisconnected$ = function (a, b, c) {
	return {$: 60, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Server_ClientDisconnected = F3($author$project$Evergreen$V417$Types$Server_ClientDisconnected$);
var $author$project$Evergreen$V417$Types$Server_CurrentlyViewing$ = function (a, b, c) {
	return {$: 59, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Server_CurrentlyViewing = F3($author$project$Evergreen$V417$Types$Server_CurrentlyViewing$);
var $author$project$Evergreen$V417$Types$Server_DeleteChannel$ = function (a, b) {
	return {$: 19, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_DeleteChannel = F2($author$project$Evergreen$V417$Types$Server_DeleteChannel$);
var $author$project$Evergreen$V417$Types$Server_DeleteGuild = function (a) {
	return {$: 21, a: a};
};
var $author$project$Evergreen$V417$Types$Server_DeleteInviteLink$ = function (a, b) {
	return {$: 23, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_DeleteInviteLink = F2($author$project$Evergreen$V417$Types$Server_DeleteInviteLink$);
var $author$project$Evergreen$V417$Types$Server_DeleteMessage$ = function (a, b) {
	return {$: 44, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_DeleteMessage = F2($author$project$Evergreen$V417$Types$Server_DeleteMessage$);
var $author$project$Evergreen$V417$Types$Server_DisableE2ee$ = function (a, b, c) {
	return {$: 109, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Server_DisableE2ee = F3($author$project$Evergreen$V417$Types$Server_DisableE2ee$);
var $author$project$Evergreen$V417$Types$Server_DiscordAddReactionDmEmoji$ = function (a, b, c, d) {
	return {$: 37, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$Server_DiscordAddReactionDmEmoji = F4($author$project$Evergreen$V417$Types$Server_DiscordAddReactionDmEmoji$);
var $author$project$Evergreen$V417$Types$Server_DiscordAddReactionGuildEmoji$ = function (a, b, c, d, e) {
	return {$: 36, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V417$Types$Server_DiscordAddReactionGuildEmoji = F5($author$project$Evergreen$V417$Types$Server_DiscordAddReactionGuildEmoji$);
var $author$project$Evergreen$V417$Types$Server_DiscordAvatarsLoaded$ = function (a, b) {
	return {$: 101, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_DiscordAvatarsLoaded = F2($author$project$Evergreen$V417$Types$Server_DiscordAvatarsLoaded$);
var $author$project$Evergreen$V417$Types$Server_DiscordChannelCreated$ = function (a, b, c, d, e, f) {
	return {$: 64, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Evergreen$V417$Types$Server_DiscordChannelCreated = F6($author$project$Evergreen$V417$Types$Server_DiscordChannelCreated$);
var $author$project$Evergreen$V417$Types$Server_DiscordChannelDeleted$ = function (a, b) {
	return {$: 81, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_DiscordChannelDeleted = F2($author$project$Evergreen$V417$Types$Server_DiscordChannelDeleted$);
var $author$project$Evergreen$V417$Types$Server_DiscordDeleteDmMessage$ = function (a, b) {
	return {$: 47, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_DiscordDeleteDmMessage = F2($author$project$Evergreen$V417$Types$Server_DiscordDeleteDmMessage$);
var $author$project$Evergreen$V417$Types$Server_DiscordDeleteGuildMessage$ = function (a, b, c) {
	return {$: 45, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Server_DiscordDeleteGuildMessage = F3($author$project$Evergreen$V417$Types$Server_DiscordDeleteGuildMessage$);
var $author$project$Evergreen$V417$Types$Server_DiscordDmChannelCreated$ = function (a, b) {
	return {$: 65, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_DiscordDmChannelCreated = F2($author$project$Evergreen$V417$Types$Server_DiscordDmChannelCreated$);
var $author$project$Evergreen$V417$Types$Server_DiscordDmChannelRecipientRemoved$ = function (a, b) {
	return {$: 66, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_DiscordDmChannelRecipientRemoved = F2($author$project$Evergreen$V417$Types$Server_DiscordDmChannelRecipientRemoved$);
var $author$project$Evergreen$V417$Types$Server_DiscordDmMemberTyping$ = function (a, b, c) {
	return {$: 29, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Server_DiscordDmMemberTyping = F3($author$project$Evergreen$V417$Types$Server_DiscordDmMemberTyping$);
var $author$project$Evergreen$V417$Types$Server_DiscordForumPostDeleted$ = function (a, b, c) {
	return {$: 46, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Server_DiscordForumPostDeleted = F3($author$project$Evergreen$V417$Types$Server_DiscordForumPostDeleted$);
var $author$project$Evergreen$V417$Types$Server_DiscordGuildJoinedOrCreated$ = function (a, b, c) {
	return {$: 78, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Server_DiscordGuildJoinedOrCreated = F3($author$project$Evergreen$V417$Types$Server_DiscordGuildJoinedOrCreated$);
var $author$project$Evergreen$V417$Types$Server_DiscordGuildLeftOrDeleted$ = function (a, b) {
	return {$: 79, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_DiscordGuildLeftOrDeleted = F2($author$project$Evergreen$V417$Types$Server_DiscordGuildLeftOrDeleted$);
var $author$project$Evergreen$V417$Types$Server_DiscordGuildMemberJoined$ = function (a, b, c, d, e, f) {
	return {$: 86, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Evergreen$V417$Types$Server_DiscordGuildMemberJoined = F6($author$project$Evergreen$V417$Types$Server_DiscordGuildMemberJoined$);
var $author$project$Evergreen$V417$Types$Server_DiscordGuildMemberTyping$ = function (a, b, c, d, e) {
	return {$: 28, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V417$Types$Server_DiscordGuildMemberTyping = F5($author$project$Evergreen$V417$Types$Server_DiscordGuildMemberTyping$);
var $author$project$Evergreen$V417$Types$Server_DiscordNeedsAuthAgain = function (a) {
	return {$: 67, a: a};
};
var $author$project$Evergreen$V417$Types$Server_DiscordRemoveReactionDmEmoji$ = function (a, b, c, d) {
	return {$: 39, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$Server_DiscordRemoveReactionDmEmoji = F4($author$project$Evergreen$V417$Types$Server_DiscordRemoveReactionDmEmoji$);
var $author$project$Evergreen$V417$Types$Server_DiscordRemoveReactionGuildEmoji$ = function (a, b, c, d, e) {
	return {$: 38, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V417$Types$Server_DiscordRemoveReactionGuildEmoji = F5($author$project$Evergreen$V417$Types$Server_DiscordRemoveReactionGuildEmoji$);
var $author$project$Evergreen$V417$Types$Server_DiscordSendEditDmMessage$ = function (a, b, c, d) {
	return {$: 42, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$Server_DiscordSendEditDmMessage = F4($author$project$Evergreen$V417$Types$Server_DiscordSendEditDmMessage$);
var $author$project$Evergreen$V417$Types$Server_DiscordSendEditGuildMessage$ = function (a, b, c, d, e, f) {
	return {$: 41, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Evergreen$V417$Types$Server_DiscordSendEditGuildMessage = F6($author$project$Evergreen$V417$Types$Server_DiscordSendEditGuildMessage$);
var $author$project$Evergreen$V417$Types$Server_DiscordUpdateChannel$ = function (a, b, c, d, e) {
	return {$: 80, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V417$Types$Server_DiscordUpdateChannel = F5($author$project$Evergreen$V417$Types$Server_DiscordUpdateChannel$);
var $author$project$Evergreen$V417$Types$Server_DiscordUpdateGuild$ = function (a, b, c, d) {
	return {$: 82, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$Server_DiscordUpdateGuild = F4($author$project$Evergreen$V417$Types$Server_DiscordUpdateGuild$);
var $author$project$Evergreen$V417$Types$Server_DiscordUpdateGuildCustomEmojis$ = function (a, b) {
	return {$: 84, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_DiscordUpdateGuildCustomEmojis = F2($author$project$Evergreen$V417$Types$Server_DiscordUpdateGuildCustomEmojis$);
var $author$project$Evergreen$V417$Types$Server_DiscordUpdateRole$ = function (a, b, c) {
	return {$: 83, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Server_DiscordUpdateRole = F3($author$project$Evergreen$V417$Types$Server_DiscordUpdateRole$);
var $author$project$Evergreen$V417$Types$Server_DiscordUserLoadingDataIsDone$ = function (a, b) {
	return {$: 68, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_DiscordUserLoadingDataIsDone = F2($author$project$Evergreen$V417$Types$Server_DiscordUserLoadingDataIsDone$);
var $author$project$Evergreen$V417$Types$Server_Discord_SendMessage$ = function (a, b, c, d, e, f, g) {
	return {$: 15, a: a, b: b, c: c, d: d, e: e, f: f, g: g};
};
var $author$project$Evergreen$V417$Types$Server_Discord_SendMessage = F7($author$project$Evergreen$V417$Types$Server_Discord_SendMessage$);
var $author$project$Evergreen$V417$Types$Server_Drawing$ = function (a, b, c, d) {
	return {$: 91, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$Server_Drawing = F4($author$project$Evergreen$V417$Types$Server_Drawing$);
var $author$project$Evergreen$V417$Types$Server_E2eeAccepted$ = function (a, b) {
	return {$: 105, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_E2eeAccepted = F2($author$project$Evergreen$V417$Types$Server_E2eeAccepted$);
var $author$project$Evergreen$V417$Types$Server_E2eeRequestCancelled = function (a) {
	return {$: 103, a: a};
};
var $author$project$Evergreen$V417$Types$Server_E2eeRequestDeclined$ = function (a, b) {
	return {$: 104, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_E2eeRequestDeclined = F2($author$project$Evergreen$V417$Types$Server_E2eeRequestDeclined$);
var $author$project$Evergreen$V417$Types$Server_E2eeRequested$ = function (a, b) {
	return {$: 102, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_E2eeRequested = F2($author$project$Evergreen$V417$Types$Server_E2eeRequested$);
var $author$project$Evergreen$V417$Types$Server_EditChannel$ = function (a, b, c, d) {
	return {$: 18, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$Server_EditChannel = F4($author$project$Evergreen$V417$Types$Server_EditChannel$);
var $author$project$Evergreen$V417$Types$Server_EditGuildName$ = function (a, b) {
	return {$: 20, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_EditGuildName = F2($author$project$Evergreen$V417$Types$Server_EditGuildName$);
var $author$project$Evergreen$V417$Types$Server_Game$ = function (a, b, c) {
	return {$: 90, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Server_Game = F3($author$project$Evergreen$V417$Types$Server_Game$);
var $author$project$Evergreen$V417$Types$Server_GotDiscordDmMessageEmbed$ = function (a, b, c) {
	return {$: 77, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Server_GotDiscordDmMessageEmbed = F3($author$project$Evergreen$V417$Types$Server_GotDiscordDmMessageEmbed$);
var $author$project$Evergreen$V417$Types$Server_GotDiscordGuildMessageEmbed$ = function (a, b, c, d) {
	return {$: 76, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$Server_GotDiscordGuildMessageEmbed = F4($author$project$Evergreen$V417$Types$Server_GotDiscordGuildMessageEmbed$);
var $author$project$Evergreen$V417$Types$Server_GotDmMessageEmbed$ = function (a, b, c) {
	return {$: 75, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Server_GotDmMessageEmbed = F3($author$project$Evergreen$V417$Types$Server_GotDmMessageEmbed$);
var $author$project$Evergreen$V417$Types$Server_GotGuildMessageEmbed$ = function (a, b, c, d) {
	return {$: 74, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$Server_GotGuildMessageEmbed = F4($author$project$Evergreen$V417$Types$Server_GotGuildMessageEmbed$);
var $author$project$Evergreen$V417$Types$Server_ImportedChannel$ = function (a, b, c) {
	return {$: 17, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Server_ImportedChannel = F3($author$project$Evergreen$V417$Types$Server_ImportedChannel$);
var $author$project$Evergreen$V417$Types$Server_LinkDiscordUser$ = function (a, b) {
	return {$: 62, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_LinkDiscordUser = F2($author$project$Evergreen$V417$Types$Server_LinkDiscordUser$);
var $author$project$Evergreen$V417$Types$Server_LinkedDiscordUserCustomEmojisLoaded = function (a) {
	return {$: 88, a: a};
};
var $author$project$Evergreen$V417$Types$Server_LinkedDiscordUserStickersLoaded = function (a) {
	return {$: 87, a: a};
};
var $author$project$Evergreen$V417$Types$Server_LoadAdminData = function (a) {
	return {$: 71, a: a};
};
var $author$project$Evergreen$V417$Types$Server_LoadingDiscordChannelChanged$ = function (a, b) {
	return {$: 70, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_LoadingDiscordChannelChanged = F2($author$project$Evergreen$V417$Types$Server_LoadingDiscordChannelChanged$);
var $author$project$Evergreen$V417$Types$Server_LoggedOut = function (a) {
	return {$: 58, a: a};
};
var $author$project$Evergreen$V417$Types$Server_MemberEditTyping$ = function (a, b, c, d) {
	return {$: 43, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$Server_MemberEditTyping = F4($author$project$Evergreen$V417$Types$Server_MemberEditTyping$);
var $author$project$Evergreen$V417$Types$Server_MemberJoined$ = function (a, b, c, d) {
	return {$: 24, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$Server_MemberJoined = F4($author$project$Evergreen$V417$Types$Server_MemberJoined$);
var $author$project$Evergreen$V417$Types$Server_MemberLeft$ = function (a, b) {
	return {$: 25, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_MemberLeft = F2($author$project$Evergreen$V417$Types$Server_MemberLeft$);
var $author$project$Evergreen$V417$Types$Server_MemberTyping$ = function (a, b, c, d) {
	return {$: 27, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$Server_MemberTyping = F4($author$project$Evergreen$V417$Types$Server_MemberTyping$);
var $author$project$Evergreen$V417$Types$Server_NewChannel$ = function (a, b, c, d) {
	return {$: 16, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$Server_NewChannel = F4($author$project$Evergreen$V417$Types$Server_NewChannel$);
var $author$project$Evergreen$V417$Types$Server_NewInviteLink$ = function (a, b, c, d) {
	return {$: 22, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$Server_NewInviteLink = F4($author$project$Evergreen$V417$Types$Server_NewInviteLink$);
var $author$project$Evergreen$V417$Types$Server_NewLog$ = function (a, b) {
	return {$: 72, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_NewLog = F2($author$project$Evergreen$V417$Types$Server_NewLog$);
var $author$project$Evergreen$V417$Types$Server_NewSession$ = function (a, b) {
	return {$: 57, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_NewSession = F2($author$project$Evergreen$V417$Types$Server_NewSession$);
var $author$project$Evergreen$V417$Types$Server_PushNotificationFailed$ = function (a, b) {
	return {$: 56, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_PushNotificationFailed = F2($author$project$Evergreen$V417$Types$Server_PushNotificationFailed$);
var $author$project$Evergreen$V417$Types$Server_PushNotificationsReset = function (a) {
	return {$: 52, a: a};
};
var $author$project$Evergreen$V417$Types$Server_RemoveReactionEmoji$ = function (a, b, c, d) {
	return {$: 35, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$Server_RemoveReactionEmoji = F4($author$project$Evergreen$V417$Types$Server_RemoveReactionEmoji$);
var $author$project$Evergreen$V417$Types$Server_SendEditMessage$ = function (a, b, c, d, e, f) {
	return {$: 40, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Evergreen$V417$Types$Server_SendEditMessage = F6($author$project$Evergreen$V417$Types$Server_SendEditMessage$);
var $author$project$Evergreen$V417$Types$Server_SendEncryptedEditMessage$ = function (a, b, c, d, e, f) {
	return {$: 108, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Evergreen$V417$Types$Server_SendEncryptedEditMessage = F6($author$project$Evergreen$V417$Types$Server_SendEncryptedEditMessage$);
var $author$project$Evergreen$V417$Types$Server_SendEncryptedMessage = function (a) {
	return {$: 107, a: a};
};
var $author$project$Evergreen$V417$Types$Server_SendMessage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Types$Server_SetDiscordGuildNotificationLevel$ = function (a, b) {
	return {$: 54, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_SetDiscordGuildNotificationLevel = F2($author$project$Evergreen$V417$Types$Server_SetDiscordGuildNotificationLevel$);
var $author$project$Evergreen$V417$Types$Server_SetGuildIcon$ = function (a, b) {
	return {$: 51, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_SetGuildIcon = F2($author$project$Evergreen$V417$Types$Server_SetGuildIcon$);
var $author$project$Evergreen$V417$Types$Server_SetGuildNotificationLevel$ = function (a, b) {
	return {$: 53, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_SetGuildNotificationLevel = F2($author$project$Evergreen$V417$Types$Server_SetGuildNotificationLevel$);
var $author$project$Evergreen$V417$Types$Server_SetMuteChannel$ = function (a, b, c) {
	return {$: 92, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Server_SetMuteChannel = F3($author$project$Evergreen$V417$Types$Server_SetMuteChannel$);
var $author$project$Evergreen$V417$Types$Server_SetMuteDiscordChannel$ = function (a, b, c) {
	return {$: 94, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Server_SetMuteDiscordChannel = F3($author$project$Evergreen$V417$Types$Server_SetMuteDiscordChannel$);
var $author$project$Evergreen$V417$Types$Server_SetMuteDiscordGuild$ = function (a, b) {
	return {$: 97, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_SetMuteDiscordGuild = F2($author$project$Evergreen$V417$Types$Server_SetMuteDiscordGuild$);
var $author$project$Evergreen$V417$Types$Server_SetMuteDiscordThread$ = function (a, b, c, d) {
	return {$: 95, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$Server_SetMuteDiscordThread = F4($author$project$Evergreen$V417$Types$Server_SetMuteDiscordThread$);
var $author$project$Evergreen$V417$Types$Server_SetMuteGuild$ = function (a, b) {
	return {$: 96, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_SetMuteGuild = F2($author$project$Evergreen$V417$Types$Server_SetMuteGuild$);
var $author$project$Evergreen$V417$Types$Server_SetMuteSlackChannel$ = function (a, b, c) {
	return {$: 99, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Server_SetMuteSlackChannel = F3($author$project$Evergreen$V417$Types$Server_SetMuteSlackChannel$);
var $author$project$Evergreen$V417$Types$Server_SetMuteSlackThread$ = function (a, b, c, d) {
	return {$: 100, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$Server_SetMuteSlackThread = F4($author$project$Evergreen$V417$Types$Server_SetMuteSlackThread$);
var $author$project$Evergreen$V417$Types$Server_SetMuteSlackWorkspace$ = function (a, b) {
	return {$: 98, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_SetMuteSlackWorkspace = F2($author$project$Evergreen$V417$Types$Server_SetMuteSlackWorkspace$);
var $author$project$Evergreen$V417$Types$Server_SetMuteThread$ = function (a, b, c, d) {
	return {$: 93, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$Server_SetMuteThread = F4($author$project$Evergreen$V417$Types$Server_SetMuteThread$);
var $author$project$Evergreen$V417$Types$Server_SetName$ = function (a, b) {
	return {$: 48, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_SetName = F2($author$project$Evergreen$V417$Types$Server_SetName$);
var $author$project$Evergreen$V417$Types$Server_SetPublicKey$ = function (a, b) {
	return {$: 106, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_SetPublicKey = F2($author$project$Evergreen$V417$Types$Server_SetPublicKey$);
var $author$project$Evergreen$V417$Types$Server_SetSlackWorkspaceNotificationLevel$ = function (a, b) {
	return {$: 55, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_SetSlackWorkspaceNotificationLevel = F2($author$project$Evergreen$V417$Types$Server_SetSlackWorkspaceNotificationLevel$);
var $author$project$Evergreen$V417$Types$Server_SetUserColor$ = function (a, b) {
	return {$: 49, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_SetUserColor = F2($author$project$Evergreen$V417$Types$Server_SetUserColor$);
var $author$project$Evergreen$V417$Types$Server_SetUserIcon$ = function (a, b) {
	return {$: 50, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_SetUserIcon = F2($author$project$Evergreen$V417$Types$Server_SetUserIcon$);
var $author$project$Evergreen$V417$Types$Server_Slack_AddReactionEmoji$ = function (a, b, c, d) {
	return {$: 13, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$Server_Slack_AddReactionEmoji = F4($author$project$Evergreen$V417$Types$Server_Slack_AddReactionEmoji$);
var $author$project$Evergreen$V417$Types$Server_Slack_ChannelRenamed$ = function (a, b, c) {
	return {$: 7, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Server_Slack_ChannelRenamed = F3($author$project$Evergreen$V417$Types$Server_Slack_ChannelRenamed$);
var $author$project$Evergreen$V417$Types$Server_Slack_CustomEmojiAdded$ = function (a, b, c) {
	return {$: 12, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Server_Slack_CustomEmojiAdded = F3($author$project$Evergreen$V417$Types$Server_Slack_CustomEmojiAdded$);
var $author$project$Evergreen$V417$Types$Server_Slack_CustomEmojisLoaded = function (a) {
	return {$: 11, a: a};
};
var $author$project$Evergreen$V417$Types$Server_Slack_DeleteMessage$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_Slack_DeleteMessage = F2($author$project$Evergreen$V417$Types$Server_Slack_DeleteMessage$);
var $author$project$Evergreen$V417$Types$Server_Slack_EditMessage$ = function (a, b, c, d, e) {
	return {$: 2, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V417$Types$Server_Slack_EditMessage = F5($author$project$Evergreen$V417$Types$Server_Slack_EditMessage$);
var $author$project$Evergreen$V417$Types$Server_Slack_GotMessageEmbed$ = function (a, b, c) {
	return {$: 9, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Server_Slack_GotMessageEmbed = F3($author$project$Evergreen$V417$Types$Server_Slack_GotMessageEmbed$);
var $author$project$Evergreen$V417$Types$Server_Slack_LinkedUserLoaded$ = function (a, b, c) {
	return {$: 10, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$Server_Slack_LinkedUserLoaded = F3($author$project$Evergreen$V417$Types$Server_Slack_LinkedUserLoaded$);
var $author$project$Evergreen$V417$Types$Server_Slack_NeedsAuthAgain = function (a) {
	return {$: 8, a: a};
};
var $author$project$Evergreen$V417$Types$Server_Slack_RemoveReactionEmoji$ = function (a, b, c, d) {
	return {$: 14, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$Server_Slack_RemoveReactionEmoji = F4($author$project$Evergreen$V417$Types$Server_Slack_RemoveReactionEmoji$);
var $author$project$Evergreen$V417$Types$Server_Slack_SendMessage$ = function (a, b, c, d, e, f) {
	return {$: 1, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Evergreen$V417$Types$Server_Slack_SendMessage = F6($author$project$Evergreen$V417$Types$Server_Slack_SendMessage$);
var $author$project$Evergreen$V417$Types$Server_Slack_UnlinkUser = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V417$Types$Server_Slack_UserLoaded$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_Slack_UserLoaded = F2($author$project$Evergreen$V417$Types$Server_Slack_UserLoaded$);
var $author$project$Evergreen$V417$Types$Server_Slack_WorkspaceRenamed$ = function (a, b) {
	return {$: 6, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_Slack_WorkspaceRenamed = F2($author$project$Evergreen$V417$Types$Server_Slack_WorkspaceRenamed$);
var $author$project$Evergreen$V417$Types$Server_StartReloadingDiscordUser$ = function (a, b) {
	return {$: 69, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_StartReloadingDiscordUser = F2($author$project$Evergreen$V417$Types$Server_StartReloadingDiscordUser$);
var $author$project$Evergreen$V417$Types$Server_TextEditor = function (a) {
	return {$: 61, a: a};
};
var $author$project$Evergreen$V417$Types$Server_UnlinkDiscordUser = function (a) {
	return {$: 63, a: a};
};
var $author$project$Evergreen$V417$Types$Server_UpdateDiscordMembers$ = function (a, b) {
	return {$: 85, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$Server_UpdateDiscordMembers = F2($author$project$Evergreen$V417$Types$Server_UpdateDiscordMembers$);
var $author$project$Evergreen$V417$Types$Server_VoiceChatChange = function (a) {
	return {$: 89, a: a};
};
var $author$project$Evergreen$V417$Types$Server_YouJoinedGuildByInvite = function (a) {
	return {$: 26, a: a};
};
var $author$project$Evergreen$V417$CustomEmoji$CustomEmojiInternal$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$CustomEmoji$CustomEmojiInternal = F2($author$project$Evergreen$V417$CustomEmoji$CustomEmojiInternal$);
var $author$project$Evergreen$V417$CustomEmoji$CustomEmojiLoading = {$: 1};
var $author$project$Evergreen$V417$CustomEmoji$w3_unsafe_decode_CustomEmojiUrl = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Evergreen$V417$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$CustomEmoji$CustomEmojiInternal)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$CustomEmoji$CustomEmojiLoading);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$CustomEmoji$EmojiName = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$CustomEmoji$w3_unsafe_decode_EmojiName = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$CustomEmoji$w3_unsafe_decode_CustomEmojiData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$CustomEmoji$w3_unsafe_decode_CustomEmojiUrl,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$CustomEmoji$w3_unsafe_decode_EmojiName,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeBool,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (isAnimated0, name0, url0) {
						return {isAnimated: isAnimated0, name: name0, url: url0};
					})))));
var $author$project$Evergreen$V417$LinkedAndOtherDiscordUsers$w3_unsafe_decode_DiscordFrontendCurrentUser = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$PersonName$w3_unsafe_decode_PersonName,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$DiscordUserData$w3_unsafe_decode_DiscordUserLoadingData,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$EmailAddress$w3_unsafe_decode_EmailAddress),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$UserColor$w3_unsafe_decode_UserColor,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F7(
									function (color0, email0, icon0, isLoadingData0, linkedAt0, name0, needsAuthAgain0) {
										return {color: color0, email: email0, icon: icon0, isLoadingData: isLoadingData0, linkedAt: linkedAt0, name: name0, needsAuthAgain: needsAuthAgain0};
									})))))))));
var $author$project$Evergreen$V417$MessageArray$MessageArray = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$MessageArray$w3_unsafe_decode_Run$ = function (w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeArray(
			$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F2(
					function (start0, values0) {
						return {start: start0, values: values0};
					}))));
};
var $author$project$Evergreen$V417$MessageArray$w3_unsafe_decode_Run = F3($author$project$Evergreen$V417$MessageArray$w3_unsafe_decode_Run$);
var $author$project$Evergreen$V417$MessageArray$w3_unsafe_decode_MessageArray$ = function (w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeArray(
								$author$project$Evergreen$V417$MessageArray$w3_unsafe_decode_Run$(w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId)),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (end0, runs0, start0) {
											return {end: end0, runs: runs0, start: start0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$MessageArray$w3_unsafe_decode_MessageArray = F3($author$project$Evergreen$V417$MessageArray$w3_unsafe_decode_MessageArray$);
var $author$project$Evergreen$V417$VisibleMessages$w3_unsafe_decode_VisibleMessages = function (w3_x_c_messageId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id(w3_x_c_messageId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeBool,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F3(
						function (count0, loadingMessages0, oldest0) {
							return {count: count0, loadingMessages: loadingMessages0, oldest: oldest0};
						})))));
};
var $author$project$Evergreen$V417$DmChannel$w3_unsafe_decode_DiscordFrontendDmChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$VisibleMessages$w3_unsafe_decode_VisibleMessages($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$MessageArray$w3_unsafe_decode_MessageArray$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId,
			$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
			$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
				$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						function (messagesSent0) {
							return {messagesSent: messagesSent0};
						}))),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId)),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (messageIndex0, time0) {
										return {messageIndex: messageIndex0, time: time0};
									}))))),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$justinmimbs$date$Date$w3_unsafe_decode_Date,
						$author$project$Evergreen$V417$Drawing$w3_unsafe_decode_Drawing(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (dateDividerDrawings0, lastTypedAt0, members0, messages0, visibleMessages0) {
								return {dateDividerDrawings: dateDividerDrawings0, lastTypedAt: lastTypedAt0, members: members0, messages: messages0, visibleMessages: visibleMessages0};
							})))))));
var $author$project$Evergreen$V417$Thread$w3_unsafe_decode_DiscordFrontendThread = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$VisibleMessages$w3_unsafe_decode_VisibleMessages($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$MessageArray$w3_unsafe_decode_MessageArray$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId,
			$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
			$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$justinmimbs$date$Date$w3_unsafe_decode_Date,
				$author$project$Evergreen$V417$Drawing$w3_unsafe_decode_Drawing(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId))),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (dateDividerDrawings0, messages0, visibleMessages0) {
						return {dateDividerDrawings: dateDividerDrawings0, messages: messages0, visibleMessages: visibleMessages0};
					})))));
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_DiscordFrontendChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$VisibleMessages$w3_unsafe_decode_VisibleMessages($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
			$author$project$Evergreen$V417$Thread$w3_unsafe_decode_DiscordFrontendThread),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V417$Discord$w3_unsafe_decode_Overwrite),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$ChannelName$w3_unsafe_decode_ChannelName,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MessageArray$w3_unsafe_decode_MessageArray$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId,
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$ChannelDescription$w3_unsafe_decode_ChannelDescription,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqDict$decodeDict$(
									$justinmimbs$date$Date$w3_unsafe_decode_Date,
									$author$project$Evergreen$V417$Drawing$w3_unsafe_decode_Drawing(
										$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId))),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F8(
										function (dateDividerDrawings0, description0, isForum0, messages0, name0, permissionOverwrites0, threads0, visibleMessages0) {
											return {dateDividerDrawings: dateDividerDrawings0, description: description0, isForum: isForum0, messages: messages0, name: name0, permissionOverwrites: permissionOverwrites0, threads: threads0, visibleMessages: visibleMessages0};
										}))))))))));
var $author$project$Evergreen$V417$Thread$w3_unsafe_decode_LastTypedAt = function (w3_x_c_channelId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMaybeMessage,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				w3_x_c_channelId,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F3(
						function (channelId0, threadRoute0, time0) {
							return {channelId: channelId0, threadRoute: threadRoute0, time: time0};
						})))));
};
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_DiscordFrontendGuild = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqSet$decodeSet(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_StickerId)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_RoleId),
			$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_DiscordRole),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$GuildName$w3_unsafe_decode_GuildName,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$MembersAndOwner$w3_unsafe_decode_MembersAndOwner$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqSet$decodeSet(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_RoleId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (joinedAt0, roles0) {
										return {joinedAt: joinedAt0, roles: roles0};
									}))))),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
						$author$project$Evergreen$V417$Thread$w3_unsafe_decode_LastTypedAt(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqSet$decodeSet(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_CustomEmojiId)),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqDict$decodeDict$(
									$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
									$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_DiscordFrontendChannel),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F8(
										function (channels0, customEmojis0, icon0, lastTypedAt0, membersAndOwner0, name0, roles0, stickers0) {
											return {channels: channels0, customEmojis: customEmojis0, icon: icon0, lastTypedAt: lastTypedAt0, membersAndOwner: membersAndOwner0, name: name0, roles: roles0, stickers: stickers0};
										}))))))))));
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_Archived = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (archivedAt0, archivedBy0) {
					return {archivedAt: archivedAt0, archivedBy: archivedBy0};
				}))));
var $author$project$Evergreen$V417$Thread$w3_unsafe_decode_FrontendThread = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$VisibleMessages$w3_unsafe_decode_VisibleMessages($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$MessageArray$w3_unsafe_decode_MessageArray$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId,
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$justinmimbs$date$Date$w3_unsafe_decode_Date,
				$author$project$Evergreen$V417$Drawing$w3_unsafe_decode_Drawing(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId))),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (dateDividerDrawings0, messages0, visibleMessages0) {
						return {dateDividerDrawings: dateDividerDrawings0, messages: messages0, visibleMessages: visibleMessages0};
					})))));
var $author$project$Evergreen$V417$Game$MatchData = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Game$MatchNotLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Game$FrontendGameData_Go$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Game$FrontendGameData_Go = F3($author$project$Evergreen$V417$Game$FrontendGameData_Go$);
var $author$project$Evergreen$V417$Game$FrontendGameData_SheepGame$ = function (a, b, c) {
	return {$: 2, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Game$FrontendGameData_SheepGame = F3($author$project$Evergreen$V417$Game$FrontendGameData_SheepGame$);
var $author$project$Evergreen$V417$Game$FrontendGameData_WordSpellingGame$ = function (a, b, c) {
	return {$: 1, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Game$FrontendGameData_WordSpellingGame = F3($author$project$Evergreen$V417$Game$FrontendGameData_WordSpellingGame$);
var $author$project$Evergreen$V417$Go$Confirming = {$: 2};
var $author$project$Evergreen$V417$Go$Marking = {$: 1};
var $author$project$Evergreen$V417$Go$Playing = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Go$Scored = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V417$Go$w3_unsafe_decode_Phase = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$Confirming);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$Marking);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							function (previousPlayerPassed0) {
								return {previousPlayerPassed: previousPlayerPassed0};
							})),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$Playing));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeFloat,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (blackScore0, whiteScore0) {
										return {blackScore: blackScore0, whiteScore: whiteScore0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$Scored));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Go$w3_unsafe_decode_Snapshot = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Go$w3_unsafe_decode_Stone,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeDict$(
				$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
				$author$project$Evergreen$V417$Go$w3_unsafe_decode_Stone),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (blackCaptures0, board0, currentPlayer0, whiteCaptures0) {
							return {blackCaptures: blackCaptures0, board: board0, currentPlayer: currentPlayer0, whiteCaptures: whiteCaptures0};
						}))))));
var $author$project$Evergreen$V417$Go$w3_unsafe_decode_Shared = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F2(
								function (black0, white0) {
									return {black: black0, white: white0};
								}))))),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeDict$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
					$author$project$Evergreen$V417$Go$w3_unsafe_decode_Stone),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Go$w3_unsafe_decode_Phase,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId)),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V417$Go$w3_unsafe_decode_Snapshot),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V417$Go$w3_unsafe_decode_Stone,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeDict$(
												$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
												$author$project$Evergreen$V417$Go$w3_unsafe_decode_Stone),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeInt,
												$lamdera$codecs$Lamdera$Wire3$succeedDecode(
													function (blackCaptures0) {
														return function (board0) {
															return function (currentPlayer0) {
																return function (history0) {
																	return function (joinedUserId0) {
																		return function (lastAction0) {
																			return function (lastMove0) {
																				return function (phase0) {
																					return function (territoryMarks0) {
																						return function (timeLeft0) {
																							return function (turnCount0) {
																								return function (whiteCaptures0) {
																									return {blackCaptures: blackCaptures0, board: board0, currentPlayer: currentPlayer0, history: history0, joinedUserId: joinedUserId0, lastAction: lastAction0, lastMove: lastMove0, phase: phase0, territoryMarks: territoryMarks0, timeLeft: timeLeft0, turnCount: turnCount0, whiteCaptures: whiteCaptures0};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													})))))))))))));
var $author$project$Evergreen$V417$Game$w3_unsafe_decode_FrontendGameData = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Go$w3_unsafe_decode_Shared,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V417$Go$w3_unsafe_decode_ActionWithTime),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Go$w3_unsafe_decode_ValidatedSetup,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$FrontendGameData_Go))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_Shared,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_ActionWithTime),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_ValidatedSetup,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$FrontendGameData_SheepGame))));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_Shared,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_ActionWithTime),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_ValidatedSetup,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$FrontendGameData_WordSpellingGame))));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Game$w3_unsafe_decode_MatchData = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$Evergreen$V417$SecretId$w3_unsafe_decode_SecretId($author$project$Evergreen$V417$Id$w3_unsafe_decode_GamePublicId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Game$w3_unsafe_decode_FrontendGameData,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (data0, publicLink0) {
										return {data: data0, publicLink: publicLink0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$MatchData));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Message$w3_unsafe_decode_GameType,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$MatchNotLoaded));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_FrontendChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$VisibleMessages$w3_unsafe_decode_VisibleMessages($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
			$author$project$Evergreen$V417$Thread$w3_unsafe_decode_FrontendThread),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$ChannelName$w3_unsafe_decode_ChannelName,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$MessageArray$w3_unsafe_decode_MessageArray$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId,
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId)),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$LocalState$w3_unsafe_decode_Archived),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
							$author$project$Evergreen$V417$Game$w3_unsafe_decode_MatchData),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$ChannelDescription$w3_unsafe_decode_ChannelDescription,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqDict$decodeDict$(
									$justinmimbs$date$Date$w3_unsafe_decode_Date,
									$author$project$Evergreen$V417$Drawing$w3_unsafe_decode_Drawing(
										$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId))),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											function (createdAt0) {
												return function (createdBy0) {
													return function (dateDividerDrawings0) {
														return function (description0) {
															return function (games0) {
																return function (isArchived0) {
																	return function (messages0) {
																		return function (name0) {
																			return function (threads0) {
																				return function (visibleMessages0) {
																					return {createdAt: createdAt0, createdBy: createdBy0, dateDividerDrawings: dateDividerDrawings0, description: description0, games: games0, isArchived: isArchived0, messages: messages0, name: name0, threads: threads0, visibleMessages: visibleMessages0};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											})))))))))));
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_GuildMember = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (joinedAt0, lastPostedAt0) {
					return {joinedAt: joinedAt0, lastPostedAt: lastPostedAt0};
				}))));
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_FrontendGuild = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$GuildName$w3_unsafe_decode_GuildName,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$MembersAndOwner$w3_unsafe_decode_MembersAndOwner$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
			$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_GuildMember),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
				$author$project$Evergreen$V417$Thread$w3_unsafe_decode_LastTypedAt(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId))),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V417$SecretId$w3_unsafe_decode_SecretId($author$project$Evergreen$V417$Id$w3_unsafe_decode_InviteLinkId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (createdAt0, createdBy0) {
										return {createdAt: createdAt0, createdBy: createdBy0};
									}))))),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqDict$decodeDict$(
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId),
									$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_FrontendChannel),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F8(
										function (channels0, createdAt0, createdBy0, icon0, invites0, lastTypedAt0, membersAndOwner0, name0) {
											return {channels: channels0, createdAt: createdAt0, createdBy: createdBy0, icon: icon0, invites: invites0, lastTypedAt: lastTypedAt0, membersAndOwner: membersAndOwner0, name: name0};
										}))))))))));
var $author$project$Evergreen$V417$User$w3_unsafe_decode_FrontendUser = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$X25519$w3_unsafe_decode_PublicKey),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$PersonName$w3_unsafe_decode_PersonName,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$UserColor$w3_unsafe_decode_UserColor,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (color0, icon0, name0, publicKey0) {
							return {color: color0, icon: icon0, name: name0, publicKey: publicKey0};
						}))))));
var $author$project$Evergreen$V417$UserSession$Viewing_Channel = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V417$UserSession$Viewing_ChannelThread = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V417$UserSession$Viewing_DiscordChannel = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V417$UserSession$Viewing_DiscordChannelThread = function (a) {
	return {$: 6, a: a};
};
var $author$project$Evergreen$V417$UserSession$Viewing_DiscordDm = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$UserSession$Viewing_Dm = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$UserSession$Viewing_DmThread = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$UserSession$Viewing_None = {$: 11};
var $author$project$Evergreen$V417$UserSession$Viewing_Overview = {$: 12};
var $author$project$Evergreen$V417$UserSession$Viewing_SlackChannel = function (a) {
	return {$: 7, a: a};
};
var $author$project$Evergreen$V417$UserSession$Viewing_SlackChannelThread = function (a) {
	return {$: 8, a: a};
};
var $author$project$Evergreen$V417$UserSession$Viewing_SlackDm = function (a) {
	return {$: 9, a: a};
};
var $author$project$Evergreen$V417$UserSession$Viewing_SlackDmThread = function (a) {
	return {$: 10, a: a};
};
var $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_ChannelData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$UserSession$Viewing_Channel));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_ChannelThreadData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$UserSession$Viewing_ChannelThread));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_DiscordChannelData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$UserSession$Viewing_DiscordChannel));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_DiscordChannelThreadData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$UserSession$Viewing_DiscordChannelThread));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_DiscordDmData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$UserSession$Viewing_DiscordDm));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_DmData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$UserSession$Viewing_Dm));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_DmThreadData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$UserSession$Viewing_DmThread));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$UserSession$Viewing_None);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$UserSession$Viewing_Overview);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_SlackChannelData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$UserSession$Viewing_SlackChannel));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_SlackChannelThreadData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$UserSession$Viewing_SlackChannelThread));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_SlackDmData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$UserSession$Viewing_SlackDm));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing_SlackDmThreadData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$UserSession$Viewing_SlackDmThread));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_FrontendUserSession = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$UserAgent$w3_unsafe_decode_UserAgent,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_NotificationMode,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$($lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId, $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (currentlyViewing0, lastActiveAt0, notificationMode0, userAgent0) {
							return {currentlyViewing: currentlyViewing0, lastActiveAt: lastActiveAt0, notificationMode: notificationMode0, userAgent: userAgent0};
						}))))));
var $author$project$Evergreen$V417$LocalState$ConnectedToCall = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$LocalState$NotInCall = {$: 0};
var $author$project$Evergreen$V417$Call$DmRoomId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Call$GuildRoomId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Call$w3_unsafe_decode_CallId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$DmRoomId));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_ChannelId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$GuildRoomId));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_CallStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Call$w3_unsafe_decode_CallId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$ConnectedToCall));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$NotInCall);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$LocalState$LastRequest = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$LocalState$NoRequestsMade = {$: 0};
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_LastRequest = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$LastRequest));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$NoRequestsMade);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_ConnectionData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Call$w3_unsafe_decode_RemoteCallData,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_LastRequest,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_CallStatus,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (call0, currentlyViewing0, lastRequest0, remoteCallData0) {
							return {call: call0, currentlyViewing: currentlyViewing0, lastRequest: lastRequest0, remoteCallData: remoteCallData0};
						}))))));
var $author$project$Evergreen$V417$LocalState$FullBackup = 0;
var $author$project$Evergreen$V417$LocalState$SubsetBackup = 1;
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_BackupContents = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_LastBackup = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_BackupContents,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (contents0, createdAt0) {
					return {contents: contents0, createdAt: createdAt0};
				}))));
var $author$project$Evergreen$V417$LocalState$LoadingDiscordDmChannel$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$LocalState$LoadingDiscordDmChannel = F3($author$project$Evergreen$V417$LocalState$LoadingDiscordDmChannel$);
var $author$project$Evergreen$V417$LocalState$LoadingDiscordGuildChannel$ = function (a, b, c, d) {
	return {$: 1, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$LocalState$LoadingDiscordGuildChannel = F4($author$project$Evergreen$V417$LocalState$LoadingDiscordGuildChannel$);
var $author$project$Evergreen$V417$LocalState$LoadingDiscordChannelAttachments$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V417$LocalState$LoadingDiscordChannelAttachments = F2($author$project$Evergreen$V417$LocalState$LoadingDiscordChannelAttachments$);
var $author$project$Evergreen$V417$LocalState$LoadingDiscordChannelMessages = {$: 0};
var $author$project$Evergreen$V417$LocalState$LoadingDiscordChannelMessagesFailed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_LoadingDiscordChannelStep = function (w3_x_c_messages) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_messages,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$LoadingDiscordChannelAttachments)));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$LoadingDiscordChannelMessages);
				case 2:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_HttpError,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$LoadingDiscordChannelMessagesFailed));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_LoadingDiscordChannel = function (w3_x_c_messages) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_LoadingDiscordChannelStep(w3_x_c_messages),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$LoadingDiscordDmChannel))));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_LoadingDiscordChannelStep(w3_x_c_messages),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$LoadingDiscordGuildChannel)))));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$Pagination$PageLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Pagination$PageLoading = {$: 0};
var $author$project$Evergreen$V417$Pagination$w3_unsafe_decode_PageStatus = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeArray(w3_x_c_a),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pagination$PageLoaded));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pagination$PageLoading);
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$Pagination$w3_unsafe_decode_Pagination = function (w3_x_c_a) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Pagination$w3_unsafe_decode_PageId),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Pagination$w3_unsafe_decode_PageId),
					$author$project$Evergreen$V417$Pagination$w3_unsafe_decode_PageStatus(w3_x_c_a)),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Pagination$w3_unsafe_decode_PageId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F4(
							function (currentPage0, pages0, previousPage0, totalItems0) {
								return {currentPage: currentPage0, pages: pages0, previousPage: previousPage0, totalItems: totalItems0};
							}))))));
};
var $author$project$Evergreen$V417$Pages$Admin$TypeThatIsAlwaysInvalid = 0;
var $author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_TypeThatIsAlwaysInvalid = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$LocalState$WordSpellingGameStatus_Error = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$LocalState$WordSpellingGameStatus_Loaded = {$: 3};
var $author$project$Evergreen$V417$LocalState$WordSpellingGameStatus_Loading = {$: 1};
var $author$project$Evergreen$V417$LocalState$WordSpellingGameStatus_NotLoaded = {$: 0};
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_WordSpellingGameStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$WordSpellingGameStatus_Error));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$WordSpellingGameStatus_Loaded);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$WordSpellingGameStatus_Loading);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$WordSpellingGameStatus_NotLoaded);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_InitAdminData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_WordSpellingGameStatus,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_WordSpellingGameStatus,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeBool,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeList(
										$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeString, $lamdera$codecs$Lamdera$Wire3$decodeInt)),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_PrivateVapidKey,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Evergreen$V417$Postmark$w3_unsafe_decode_ApiKey,
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
															$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId)),
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$author$project$Evergreen$V417$Pagination$w3_unsafe_decode_Pagination($author$project$Evergreen$V417$LocalState$w3_unsafe_decode_LogWithTime),
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$lamdera$containers$SeqDict$decodeDict$(
																	$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
																	$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_LoadingDiscordChannel($lamdera$codecs$Lamdera$Wire3$decodeInt)),
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$LocalState$w3_unsafe_decode_LastBackup),
																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																		$lamdera$codecs$Lamdera$Wire3$decodeInt,
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$codecs$Lamdera$Wire3$decodeBool,
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$lamdera$codecs$Lamdera$Wire3$decodeBool,
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																						$lamdera$codecs$Lamdera$Wire3$decodeList(
																							$lamdera$codecs$Lamdera$Wire3$decodePair$(
																								$author$project$Evergreen$V417$SessionIdHash$w3_unsafe_decode_SessionIdHash,
																								$author$project$Evergreen$V417$NonemptyDict$w3_unsafe_decode_NonemptyDict$($lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId, $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_ConnectionData))),
																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																							$author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_TypeThatIsAlwaysInvalid,
																							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																								function (checkToFrontendValidation0) {
																									return function (connections0) {
																										return function (discordLinkLimit0) {
																											return function (discordLinkingEnabled0) {
																												return function (emailNotificationsEnabled0) {
																													return function (filesCount0) {
																														return function (lastBackup0) {
																															return function (loadingDiscordChannels0) {
																																return function (logs0) {
																																	return function (notifyAdminsBotUserId0) {
																																		return function (notifyAdminsToken0) {
																																			return function (openRouterKey0) {
																																				return function (postmarkApiKey0) {
																																					return function (privateVapidKey0) {
																																						return function (seqDictWorks0) {
																																							return function (serverSecretRegeneratedAt0) {
																																								return function (signupsEnabled0) {
																																									return function (slackLinkLimit0) {
																																										return function (slackLinkingEnabled0) {
																																											return function (twoFactorAuthentication0) {
																																												return function (vulnerabilityChecks0) {
																																													return function (wordSpellingGameEnglish0) {
																																														return function (wordSpellingGameSwedish0) {
																																															return {checkToFrontendValidation: checkToFrontendValidation0, connections: connections0, discordLinkLimit: discordLinkLimit0, discordLinkingEnabled: discordLinkingEnabled0, emailNotificationsEnabled: emailNotificationsEnabled0, filesCount: filesCount0, lastBackup: lastBackup0, loadingDiscordChannels: loadingDiscordChannels0, logs: logs0, notifyAdminsBotUserId: notifyAdminsBotUserId0, notifyAdminsToken: notifyAdminsToken0, openRouterKey: openRouterKey0, postmarkApiKey: postmarkApiKey0, privateVapidKey: privateVapidKey0, seqDictWorks: seqDictWorks0, serverSecretRegeneratedAt: serverSecretRegeneratedAt0, signupsEnabled: signupsEnabled0, slackLinkLimit: slackLinkLimit0, slackLinkingEnabled: slackLinkingEnabled0, twoFactorAuthentication: twoFactorAuthentication0, vulnerabilityChecks: vulnerabilityChecks0, wordSpellingGameEnglish: wordSpellingGameEnglish0, wordSpellingGameSwedish: wordSpellingGameSwedish0};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								}))))))))))))))))))))))));
var $author$project$Evergreen$V417$LocalState$AlreadyJoined = 0;
var $author$project$Evergreen$V417$LocalState$InviteIsInvalid = 1;
var $author$project$Evergreen$V417$LocalState$YouAreBanned = 2;
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_JoinGuildError = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Types$NoReplyData = {$: 0};
var $author$project$Evergreen$V417$Types$RepliedToGame = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V417$Types$RepliedToMessage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Types$RepliedToThreadMessage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_RepliedToData = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$NoReplyData);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Game$w3_unsafe_decode_LoadedMatch,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$RepliedToGame));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId,
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$RepliedToMessage));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId,
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$RepliedToThreadMessage));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Call$Server_Left$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V417$Call$Server_Left = F2($author$project$Evergreen$V417$Call$Server_Left$);
var $author$project$Evergreen$V417$Call$Server_OtherJoined$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V417$Call$Server_OtherJoined = F2($author$project$Evergreen$V417$Call$Server_OtherJoined$);
var $author$project$Evergreen$V417$Call$Server_RecordingChanged$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $author$project$Evergreen$V417$Call$Server_RecordingChanged = F2($author$project$Evergreen$V417$Call$Server_RecordingChanged$);
var $author$project$Evergreen$V417$Call$Server_SetRemoteCallData$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Evergreen$V417$Call$Server_SetRemoteCallData = F2($author$project$Evergreen$V417$Call$Server_SetRemoteCallData$);
var $author$project$Evergreen$V417$Call$Server_YouJoined$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$Call$Server_YouJoined = F2($author$project$Evergreen$V417$Call$Server_YouJoined$);
var $author$project$Evergreen$V417$Call$w3_unsafe_decode_ConnectionId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Call$w3_unsafe_decode_CallId,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodePair$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
			$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (otherClientId0, roomId0) {
					return {otherClientId: otherClientId0, roomId: roomId0};
				}))));
var $author$project$Evergreen$V417$Call$AskingToRecord = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Call$RecordingDeclined = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Call$RecordingSince = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$Call$w3_unsafe_decode_RecordingStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqSet$decodeSet(
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId)),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (allowedBy0, requestedAt0, requestedBy0) {
											return {allowedBy: allowedBy0, requestedAt: requestedAt0, requestedBy: requestedBy0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$AskingToRecord));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId)),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (declinedAt0, declinedBy0, requestedBy0) {
											return {declinedAt: declinedAt0, declinedBy: declinedBy0, requestedBy: requestedBy0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$RecordingDeclined));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$RecordingSince));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Call$w3_unsafe_decode_ServerChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Call$w3_unsafe_decode_ConnectionId,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$Server_Left)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Call$w3_unsafe_decode_ConnectionId,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$Server_OtherJoined)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Call$w3_unsafe_decode_RecordingStatus),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Call$w3_unsafe_decode_CallId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$Server_RecordingChanged)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Call$w3_unsafe_decode_RemoteCallData,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Call$w3_unsafe_decode_ConnectionId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$Server_SetRemoteCallData)));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Call$w3_unsafe_decode_CallId,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$Server_YouJoined)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$TextEditor$Server_EditChange$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$TextEditor$Server_EditChange = F2($author$project$Evergreen$V417$TextEditor$Server_EditChange$);
var $author$project$Evergreen$V417$TextEditor$Server_Redo = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V417$TextEditor$Server_Reset = {$: 1};
var $author$project$Evergreen$V417$TextEditor$Server_Undo = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$TextEditor$w3_unsafe_decode_ServerChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$TextEditor$w3_unsafe_decode_EditChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$TextEditor$Server_EditChange)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$TextEditor$Server_Redo));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$TextEditor$Server_Reset);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$TextEditor$Server_Undo));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Thread$w3_unsafe_decode_FrontendGenericThread$ = function (w3_x_c_userId, w3_x_c_channelId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$VisibleMessages$w3_unsafe_decode_VisibleMessages($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$MessageArray$w3_unsafe_decode_MessageArray$($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId, w3_x_c_userId, w3_x_c_channelId),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$justinmimbs$date$Date$w3_unsafe_decode_Date,
					$author$project$Evergreen$V417$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId)),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F3(
						function (dateDividerDrawings0, messages0, visibleMessages0) {
							return {dateDividerDrawings: dateDividerDrawings0, messages: messages0, visibleMessages: visibleMessages0};
						})))));
};
var $author$project$Evergreen$V417$Thread$w3_unsafe_decode_FrontendGenericThread = F2($author$project$Evergreen$V417$Thread$w3_unsafe_decode_FrontendGenericThread$);
var $author$project$Evergreen$V417$Thread$w3_unsafe_decode_SlackFrontendThread = $author$project$Evergreen$V417$Thread$w3_unsafe_decode_FrontendGenericThread$(
	$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
	$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId));
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_SlackFrontendDmChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$VisibleMessages$w3_unsafe_decode_VisibleMessages($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
			$author$project$Evergreen$V417$Thread$w3_unsafe_decode_SlackFrontendThread),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$MessageArray$w3_unsafe_decode_MessageArray$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId,
					$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
					$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId)),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$NonemptySet$w3_unsafe_decode_NonemptySet(
						$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (members0, messages0, teamId0, threads0, visibleMessages0) {
								return {members: members0, messages: messages0, teamId: teamId0, threads: threads0, visibleMessages: visibleMessages0};
							})))))));
var $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_SlackFrontendUser = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$PersonName$w3_unsafe_decode_PersonName,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$UserColor$w3_unsafe_decode_UserColor,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (color0, icon0, name0, teamId0) {
							return {color: color0, icon: icon0, name: name0, teamId: teamId0};
						}))))));
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_SlackFrontendChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$VisibleMessages$w3_unsafe_decode_VisibleMessages($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
			$author$project$Evergreen$V417$Thread$w3_unsafe_decode_SlackFrontendThread),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$ChannelName$w3_unsafe_decode_ChannelName,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$MessageArray$w3_unsafe_decode_MessageArray$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId,
					$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
					$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId)),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (isPrivate0, messages0, name0, threads0, visibleMessages0) {
								return {isPrivate: isPrivate0, messages: messages0, name: name0, threads: threads0, visibleMessages: visibleMessages0};
							})))))));
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_SlackFrontendWorkspace = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqSet$decodeSet(
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_CustomEmojiId)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId),
					$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_SlackFrontendChannel),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (channels0, customEmojis0, icon0, name0) {
							return {channels: channels0, customEmojis: customEmojis0, icon: icon0, name: name0};
						}))))));
var $author$project$Evergreen$V417$Discord$ApngFormat = 1;
var $author$project$Evergreen$V417$Discord$GifFormat = 3;
var $author$project$Evergreen$V417$Discord$LottieFormat = 2;
var $author$project$Evergreen$V417$Discord$PngFormat = 0;
var $author$project$Evergreen$V417$Discord$w3_unsafe_decode_StickerFormatType = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Sticker$DiscordStandardSticker = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Sticker$StickerInternal$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$Sticker$StickerInternal = F2($author$project$Evergreen$V417$Sticker$StickerInternal$);
var $author$project$Evergreen$V417$Sticker$StickerLoading = {$: 2};
var $author$project$Evergreen$V417$Discord$StickerId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Discord$w3_unsafe_decode_StickerId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Sticker$w3_unsafe_decode_StickerUrl = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_StickerId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Sticker$DiscordStandardSticker));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Evergreen$V417$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Sticker$StickerInternal)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Sticker$StickerLoading);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Sticker$w3_unsafe_decode_StickerData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Sticker$w3_unsafe_decode_StickerUrl,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$Discord$w3_unsafe_decode_StickerFormatType,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (format0, name0, url0) {
						return {format: format0, name: name0, url: url0};
					})))));
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_ServerChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_AddReactionEmoji)))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_LastBackup,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_BackupGenerated));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$NonemptySet$w3_unsafe_decode_NonemptySet(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_CallRecordingStarted)))));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_CallRecordingUploadFinished))));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Message$w3_unsafe_decode_CallRecordingFile(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_CallRecordingUploadProgress))));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Message$w3_unsafe_decode_CallRecordingZip,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_CallRecordingZipBuilt))));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$SessionIdHash$w3_unsafe_decode_SessionIdHash,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_ClientDisconnected))));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$SessionIdHash$w3_unsafe_decode_SessionIdHash,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_CurrentlyViewing))));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DeleteChannel)));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DeleteGuild));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$SecretId$w3_unsafe_decode_SecretId($author$project$Evergreen$V417$Id$w3_unsafe_decode_InviteLinkId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DeleteInviteLink)));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DeleteMessage)));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DmId,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DisableE2ee))));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DiscordAddReactionDmEmoji)))));
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DiscordAddReactionGuildEmoji))))));
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_DiscordFrontendUser,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DiscordAvatarsLoaded)));
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V417$Discord$w3_unsafe_decode_Overwrite),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_OptionalData(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$ChannelName$w3_unsafe_decode_ChannelName,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeBool,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DiscordChannelCreated)))))));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DiscordChannelDeleted)));
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DiscordDeleteDmMessage)));
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DiscordDeleteGuildMessage))));
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								function (messagesSent0) {
									return {messagesSent: messagesSent0};
								}))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DiscordDmChannelCreated)));
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DiscordDmChannelRecipientRemoved)));
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DiscordDmMemberTyping))));
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DiscordForumPostDeleted))));
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_DiscordFrontendGuild,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DiscordGuildJoinedOrCreated))));
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DiscordGuildLeftOrDeleted)));
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserColor$w3_unsafe_decode_UserColor,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$PersonName$w3_unsafe_decode_PersonName,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DiscordGuildMemberJoined)))))));
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DiscordGuildMemberTyping))))));
			case 28:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DiscordNeedsAuthAgain));
			case 29:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DiscordRemoveReactionDmEmoji)))));
			case 30:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DiscordRemoveReactionGuildEmoji))))));
			case 31:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
						$author$project$Evergreen$V417$RichText$w3_unsafe_decode_RichText$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DiscordDmId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DiscordSendEditDmMessage)))));
			case 32:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
						$author$project$Evergreen$V417$RichText$w3_unsafe_decode_RichText$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DiscordSendEditGuildMessage)))))));
			case 33:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V417$Discord$w3_unsafe_decode_Overwrite),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_OptionalData(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_OptionalData(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString)),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DiscordUpdateChannel))))));
			case 34:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_RoleId),
						$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_DiscordRole),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$GuildName$w3_unsafe_decode_GuildName,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DiscordUpdateGuild)))));
			case 35:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqSet$decodeSet(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_CustomEmojiId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DiscordUpdateGuildCustomEmojis)));
			case 36:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_DiscordRole,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_RoleId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DiscordUpdateRole))));
			case 37:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeBool,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqDict$decodeDict$(
									$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
									$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_DiscordFrontendUser),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$containers$SeqDict$decodeDict$(
										$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
										$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_DiscordFrontendGuild),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$containers$SeqDict$decodeDict$(
											$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
											$author$project$Evergreen$V417$DmChannel$w3_unsafe_decode_DiscordFrontendDmChannel),
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											F4(
												function (discordDms0, discordGuilds0, discordUsers0, markEverythingAsViewed0) {
													return {discordDms: discordDms0, discordGuilds: discordGuilds0, discordUsers: discordUsers0, markEverythingAsViewed: markEverythingAsViewed0};
												}))))))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_DiscordUserLoadingDataIsDone)));
			case 38:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_StickerId),
						$author$project$Evergreen$V417$Sticker$w3_unsafe_decode_StickerData),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
							$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileData),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMaybeMessage,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
									$author$project$Evergreen$V417$RichText$w3_unsafe_decode_RichText$(
										$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
										$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId))),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_DiscordFrontendUser,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V417$Id$w3_unsafe_decode_DiscordGuildOrDmId,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
											$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_Discord_SendMessage))))))));
			case 39:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Drawing$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Drawing$w3_unsafe_decode_AnchorType,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_Drawing)))));
			case 40:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_E2eeAccepted)));
			case 41:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_E2eeRequestCancelled));
			case 42:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_E2eeRequestDeclined)));
			case 43:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
						$author$project$Evergreen$V417$SessionIdHash$w3_unsafe_decode_SessionIdHash),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_E2eeRequested)));
			case 44:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$ChannelDescription$w3_unsafe_decode_ChannelDescription,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$ChannelName$w3_unsafe_decode_ChannelName,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_EditChannel)))));
			case 45:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$GuildName$w3_unsafe_decode_GuildName,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_EditGuildName)));
			case 46:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Game$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_Game))));
			case 47:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$elm$url$Url$w3_unsafe_decode_Url,
						$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $author$project$Evergreen$V417$Embed$w3_unsafe_decode_EmbedData)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_GotDiscordDmMessageEmbed))));
			case 48:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$elm$url$Url$w3_unsafe_decode_Url,
						$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $author$project$Evergreen$V417$Embed$w3_unsafe_decode_EmbedData)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_GotDiscordGuildMessageEmbed)))));
			case 49:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$elm$url$Url$w3_unsafe_decode_Url,
						$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $author$project$Evergreen$V417$Embed$w3_unsafe_decode_EmbedData)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_GotDmMessageEmbed))));
			case 50:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$elm$url$Url$w3_unsafe_decode_Url,
						$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $author$project$Evergreen$V417$Embed$w3_unsafe_decode_EmbedData)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_GotGuildMessageEmbed)))));
			case 51:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_FrontendChannel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_ImportedChannel))));
			case 52:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$LinkedAndOtherDiscordUsers$w3_unsafe_decode_DiscordFrontendCurrentUser,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_LinkDiscordUser)));
			case 53:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_CustomEmojiId),
						$author$project$Evergreen$V417$CustomEmoji$w3_unsafe_decode_CustomEmojiData),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_LinkedDiscordUserCustomEmojisLoaded));
			case 54:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_StickerId),
						$author$project$Evergreen$V417$Sticker$w3_unsafe_decode_StickerData),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_LinkedDiscordUserStickersLoaded));
			case 55:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_InitAdminData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_LoadAdminData));
			case 56:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_LoadingDiscordChannel($lamdera$codecs$Lamdera$Wire3$decodeInt)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_LoadingDiscordChannelChanged)));
			case 57:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$SessionIdHash$w3_unsafe_decode_SessionIdHash,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_LoggedOut));
			case 58:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_MemberEditTyping)))));
			case 59:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$User$w3_unsafe_decode_FrontendUser,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_MemberJoined)))));
			case 60:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_MemberLeft)));
			case 61:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_MemberTyping)))));
			case 62:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$ChannelDescription$w3_unsafe_decode_ChannelDescription,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$ChannelName$w3_unsafe_decode_ChannelName,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_NewChannel)))));
			case 63:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$SecretId$w3_unsafe_decode_SecretId($author$project$Evergreen$V417$Id$w3_unsafe_decode_InviteLinkId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_NewInviteLink)))));
			case 64:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Log$w3_unsafe_decode_Log,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_NewLog)));
			case 65:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_FrontendUserSession,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$SessionIdHash$w3_unsafe_decode_SessionIdHash,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_NewSession)));
			case 66:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Ports$w3_unsafe_decode_SubscribeData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_PushNotificationFailed)));
			case 67:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_PushNotificationsReset));
			case 68:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_RemoveReactionEmoji)))));
			case 69:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
						$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileData),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$author$project$Evergreen$V417$RichText$w3_unsafe_decode_RichText$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId))),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_SendEditMessage)))))));
			case 70:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Encryption$w3_unsafe_decode_EncryptedData(
						$author$project$Evergreen$V417$Message$w3_unsafe_decode_MessageContent$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqSet$decodeSet($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DmId,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_SendEncryptedEditMessage)))))));
			case 71:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Message$w3_unsafe_decode_ThreadRouteWithRepliedTo,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$User$w3_unsafe_decode_FrontendUser,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V417$Types$w3_unsafe_decode_RepliedToData,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Evergreen$V417$Id$w3_unsafe_decode_Viewing_DmId,
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$containers$SeqSet$decodeSet($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash),
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$author$project$Evergreen$V417$Encryption$w3_unsafe_decode_EncryptedData(
														$author$project$Evergreen$V417$Message$w3_unsafe_decode_MessageContent$(
															$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
															$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId))),
													$lamdera$codecs$Lamdera$Wire3$succeedDecode(
														F8(
															function (content0, fileHashes0, id0, repliedToData0, sender0, senderId0, sentAt0, threadRoute0) {
																return {content: content0, fileHashes: fileHashes0, id: id0, repliedToData: repliedToData0, sender: sender0, senderId: senderId0, sentAt: sentAt0, threadRoute: threadRoute0};
															})))))))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_SendEncryptedMessage));
			case 72:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Message$w3_unsafe_decode_ThreadRouteWithRepliedTo,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqDict$decodeDict$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_StickerId),
								$author$project$Evergreen$V417$Sticker$w3_unsafe_decode_StickerData),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V417$User$w3_unsafe_decode_FrontendUser,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Evergreen$V417$Types$w3_unsafe_decode_RepliedToData,
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildOrDmId,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
														$author$project$Evergreen$V417$RichText$w3_unsafe_decode_RichText$(
															$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
															$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId))),
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$lamdera$containers$SeqDict$decodeDict$(
															$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
															$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileData),
														$lamdera$codecs$Lamdera$Wire3$succeedDecode(
															F9(
																function (attachedFiles0, content0, guildOrDmId0, repliedToData0, sender0, senderId0, sentAt0, stickers0, threadRoute0) {
																	return {attachedFiles: attachedFiles0, content: content0, guildOrDmId: guildOrDmId0, repliedToData: repliedToData0, sender: sender0, senderId: senderId0, sentAt: sentAt0, stickers: stickers0, threadRoute: threadRoute0};
																}))))))))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_SendMessage));
			case 73:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$User$w3_unsafe_decode_NotificationLevel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_SetDiscordGuildNotificationLevel)));
			case 74:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_SetGuildIcon)));
			case 75:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$User$w3_unsafe_decode_NotificationLevel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_SetGuildNotificationLevel)));
			case 76:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_SetMuteChannel))));
			case 77:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_SetMuteDiscordChannel))));
			case 78:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_SetMuteDiscordGuild)));
			case 79:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_SetMuteDiscordThread)))));
			case 80:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_SetMuteGuild)));
			case 81:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_SetMuteSlackChannel))));
			case 82:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_SetMuteSlackThread)))));
			case 83:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_SetMuteSlackWorkspace)));
			case 84:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_SetMuteThread)))));
			case 85:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$PersonName$w3_unsafe_decode_PersonName,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_SetName)));
			case 86:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$X25519$w3_unsafe_decode_PublicKey,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_SetPublicKey)));
			case 87:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$User$w3_unsafe_decode_NotificationLevel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_SetSlackWorkspaceNotificationLevel)));
			case 88:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserColor$w3_unsafe_decode_UserColor,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_SetUserColor)));
			case 89:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_SetUserIcon)));
			case 90:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_SlackGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_Slack_AddReactionEmoji)))));
			case 91:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$ChannelName$w3_unsafe_decode_ChannelName,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_Slack_ChannelRenamed))));
			case 92:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$CustomEmoji$w3_unsafe_decode_CustomEmojiData,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_CustomEmojiId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_Slack_CustomEmojiAdded))));
			case 93:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_CustomEmojiId),
						$author$project$Evergreen$V417$CustomEmoji$w3_unsafe_decode_CustomEmojiData),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_Slack_CustomEmojisLoaded));
			case 94:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_SlackGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_Slack_DeleteMessage)));
			case 95:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
						$author$project$Evergreen$V417$RichText$w3_unsafe_decode_RichText$(
							$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
							$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_SlackGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_Slack_EditMessage))))));
			case 96:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$elm$url$Url$w3_unsafe_decode_Url,
						$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $author$project$Evergreen$V417$Embed$w3_unsafe_decode_EmbedData)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_SlackGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_Slack_GotMessageEmbed))));
			case 97:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
							$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_SlackFrontendWorkspace),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqDict$decodeDict$(
								$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_SlackFrontendUser),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeBool,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$containers$SeqDict$decodeDict$(
										$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_DmChannelId),
										$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_SlackFrontendDmChannel),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$containers$SeqDict$decodeDict$(
											$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_CustomEmojiId),
											$author$project$Evergreen$V417$CustomEmoji$w3_unsafe_decode_CustomEmojiData),
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											F5(
												function (customEmojis0, dmChannels0, markNewDmsAsViewed0, users0, workspaces0) {
													return {customEmojis: customEmojis0, dmChannels: dmChannels0, markNewDmsAsViewed: markNewDmsAsViewed0, users: users0, workspaces: workspaces0};
												}))))))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_Slack_LinkedUserLoaded))));
			case 98:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_Slack_NeedsAuthAgain));
			case 99:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_SlackGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_Slack_RemoveReactionEmoji)))));
			case 100:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Evergreen$V417$Message$w3_unsafe_decode_Message$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId,
							$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
							$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
							$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileData),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
								$author$project$Evergreen$V417$RichText$w3_unsafe_decode_RichText$(
									$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
									$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId))),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_SlackGuildOrDmId,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_Slack_SendMessage)))))));
			case 101:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_Slack_UnlinkUser));
			case 102:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_SlackFrontendUser,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_Slack_UserLoaded)));
			case 103:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_Slack_WorkspaceRenamed)));
			case 104:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_StartReloadingDiscordUser)));
			case 105:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$TextEditor$w3_unsafe_decode_ServerChange,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_TextEditor));
			case 106:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_UnlinkDiscordUser));
			case 107:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MembersAndOwner$w3_unsafe_decode_MembersAndOwner$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqSet$decodeSet(
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_RoleId)),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F2(
										function (joinedAt0, roles0) {
											return {joinedAt: joinedAt0, roles: roles0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_UpdateDiscordMembers)));
			case 108:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Call$w3_unsafe_decode_ServerChange,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_VoiceChatChange));
			case 109:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$(
						$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_JoinGuildError,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$User$w3_unsafe_decode_FrontendUser,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqDict$decodeDict$(
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
									$author$project$Evergreen$V417$User$w3_unsafe_decode_FrontendUser),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_FrontendGuild,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											F4(
												function (guild0, guildId0, members0, owner0) {
													return {guild: guild0, guildId: guildId0, members: members0, owner: owner0};
												}))))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Server_YouJoinedGuildByInvite));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_LocalMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Types$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$LocalChange)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Types$w3_unsafe_decode_ServerChange,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$ServerChange));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$LocalState$IsAdmin = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$LocalState$IsAdminButDataNotLoaded = {$: 1};
var $author$project$Evergreen$V417$LocalState$IsNotAdmin = {$: 2};
var $author$project$Evergreen$V417$LocalState$AdminDataLoaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$LocalState$AdminDataLoading = {$: 1};
var $author$project$Evergreen$V417$LocalState$AdminDataNotLoaded = {$: 0};
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminDataStatus = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_a,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$AdminDataLoaded));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$AdminDataLoading);
				case 2:
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$AdminDataNotLoaded);
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$LocalState$DeletingOrphanedFiles = {$: 1};
var $author$project$Evergreen$V417$LocalState$DeletingOrphanedFilesFailed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$LocalState$NotDeletingOrphanedFiles = {$: 0};
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_DeleteOrphanedFilesStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$DeletingOrphanedFiles);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$DeletingOrphanedFilesFailed));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$NotDeletingOrphanedFiles);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$LocalState$BeingRegenerated = {$: 1};
var $author$project$Evergreen$V417$LocalState$NotBeingRegenerated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$LocalState$RegenerationFailed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_ServerSecretStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$BeingRegenerated);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$NotBeingRegenerated));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$RegenerationFailed));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_WordSpellingGameStatus,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_WordSpellingGameStatus,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminDataStatus(
				$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V417$LocalState$w3_unsafe_decode_WebsocketClosedEvent)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminDataStatus(
						$author$project$Evergreen$V417$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
							$author$project$Evergreen$V417$User$w3_unsafe_decode_BackendUser)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminDataStatus(
								$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V417$ToBackendLog$w3_unsafe_decode_ToBackendLogData)),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminDataStatus(
									$lamdera$containers$SeqDict$decodeDict$(
										$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
										$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminData_SlackWorkspace)),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeBool,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminDataStatus(
												$lamdera$containers$SeqDict$decodeDict$(
													$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_DmChannelId),
													$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminData_SlackDmChannel)),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeBool,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminDataStatus(
														$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V417$SessionIdHash$w3_unsafe_decode_SessionIdHash, $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_UserSession)),
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_ServerSecretStatus,
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$lamdera$codecs$Lamdera$Wire3$decodeList(
																$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeString, $lamdera$codecs$Lamdera$Wire3$decodeInt)),
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_PrivateVapidKey,
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$author$project$Evergreen$V417$Postmark$w3_unsafe_decode_ApiKey,
																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																		$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminDataStatus(
																			$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash, $author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_BackendFileData)),
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
																						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId)),
																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																						$author$project$Evergreen$V417$Pagination$w3_unsafe_decode_Pagination($author$project$Evergreen$V417$LocalState$w3_unsafe_decode_LogWithTime),
																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																							$lamdera$containers$SeqDict$decodeDict$(
																								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
																								$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_LoadingDiscordChannel($lamdera$codecs$Lamdera$Wire3$decodeInt)),
																							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$LocalState$w3_unsafe_decode_LastBackup),
																								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																									$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminDataStatus(
																										$lamdera$containers$SeqDict$decodeDict$(
																											$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
																											$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminData_Guild)),
																									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																										$lamdera$codecs$Lamdera$Wire3$decodeInt,
																										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																											$lamdera$codecs$Lamdera$Wire3$decodeBool,
																											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																												$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminDataStatus(
																													$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V417$DmChannelId$w3_unsafe_decode_DmChannelId, $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminData_DmChannel)),
																												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																													$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminDataStatus(
																														$lamdera$containers$SeqDict$decodeDict$(
																															$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
																															$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_DiscordUserData_ForAdmin)),
																													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																														$lamdera$codecs$Lamdera$Wire3$decodeBool,
																														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																															$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
																															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminDataStatus(
																																	$lamdera$containers$SeqDict$decodeDict$(
																																		$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
																																		$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminData_DiscordGuild)),
																																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																	$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminDataStatus(
																																		$lamdera$containers$SeqDict$decodeDict$(
																																			$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
																																			$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminData_DiscordDmChannel)),
																																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																		$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminDataStatus(
																																			$lamdera$containers$SeqDict$decodeDict$(
																																				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
																																				$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminData_DeletedGuild)),
																																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																			$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_DeleteOrphanedFilesStatus,
																																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																				$lamdera$codecs$Lamdera$Wire3$decodeList(
																																					$lamdera$codecs$Lamdera$Wire3$decodePair$(
																																						$author$project$Evergreen$V417$SessionIdHash$w3_unsafe_decode_SessionIdHash,
																																						$author$project$Evergreen$V417$NonemptyDict$w3_unsafe_decode_NonemptyDict$($lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId, $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_ConnectionData))),
																																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																					$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminDataStatus(
																																						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V417$BackendMsgLog$w3_unsafe_decode_BackendMsgLogData)),
																																					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																																						function (backendMsgLogs0) {
																																							return function (connections0) {
																																								return function (deleteOrphanedFiles0) {
																																									return function (deletedGuilds0) {
																																										return function (discordDmChannels0) {
																																											return function (discordGuilds0) {
																																												return function (discordLinkLimit0) {
																																													return function (discordLinkingEnabled0) {
																																														return function (discordUsers0) {
																																															return function (dmChannels0) {
																																																return function (emailNotificationsEnabled0) {
																																																	return function (filesCount0) {
																																																		return function (guilds0) {
																																																			return function (lastBackup0) {
																																																				return function (loadingDiscordChannels0) {
																																																					return function (logs0) {
																																																						return function (notifyAdminsBotUserId0) {
																																																							return function (notifyAdminsToken0) {
																																																								return function (openRouterKey0) {
																																																									return function (orphanedFiles0) {
																																																										return function (postmarkKey0) {
																																																											return function (privateVapidKey0) {
																																																												return function (seqDictWorks0) {
																																																													return function (serverSecretRefreshedAt0) {
																																																														return function (sessions0) {
																																																															return function (signupsEnabled0) {
																																																																return function (slackDmChannels0) {
																																																																	return function (slackLinkLimit0) {
																																																																		return function (slackLinkingEnabled0) {
																																																																			return function (slackWorkspaces0) {
																																																																				return function (toBackendLogs0) {
																																																																					return function (twoFactorAuthentication0) {
																																																																						return function (users0) {
																																																																							return function (vulnerabilityChecks0) {
																																																																								return function (websocketCloseEvents0) {
																																																																									return function (wordSpellingGameEnglish0) {
																																																																										return function (wordSpellingGameSwedish0) {
																																																																											return {backendMsgLogs: backendMsgLogs0, connections: connections0, deleteOrphanedFiles: deleteOrphanedFiles0, deletedGuilds: deletedGuilds0, discordDmChannels: discordDmChannels0, discordGuilds: discordGuilds0, discordLinkLimit: discordLinkLimit0, discordLinkingEnabled: discordLinkingEnabled0, discordUsers: discordUsers0, dmChannels: dmChannels0, emailNotificationsEnabled: emailNotificationsEnabled0, filesCount: filesCount0, guilds: guilds0, lastBackup: lastBackup0, loadingDiscordChannels: loadingDiscordChannels0, logs: logs0, notifyAdminsBotUserId: notifyAdminsBotUserId0, notifyAdminsToken: notifyAdminsToken0, openRouterKey: openRouterKey0, orphanedFiles: orphanedFiles0, postmarkKey: postmarkKey0, privateVapidKey: privateVapidKey0, seqDictWorks: seqDictWorks0, serverSecretRefreshedAt: serverSecretRefreshedAt0, sessions: sessions0, signupsEnabled: signupsEnabled0, slackDmChannels: slackDmChannels0, slackLinkLimit: slackLinkLimit0, slackLinkingEnabled: slackLinkingEnabled0, slackWorkspaces: slackWorkspaces0, toBackendLogs: toBackendLogs0, twoFactorAuthentication: twoFactorAuthentication0, users: users0, vulnerabilityChecks: vulnerabilityChecks0, websocketCloseEvents: websocketCloseEvents0, wordSpellingGameEnglish: wordSpellingGameEnglish0, wordSpellingGameSwedish: wordSpellingGameSwedish0};
																																																																										};
																																																																									};
																																																																								};
																																																																							};
																																																																						};
																																																																					};
																																																																				};
																																																																			};
																																																																		};
																																																																	};
																																																																};
																																																															};
																																																														};
																																																													};
																																																												};
																																																											};
																																																										};
																																																									};
																																																								};
																																																							};
																																																						};
																																																					};
																																																				};
																																																			};
																																																		};
																																																	};
																																																};
																																															};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						}))))))))))))))))))))))))))))))))))))));
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$IsAdmin));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$IsAdminButDataNotLoaded);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LocalState$IsNotAdmin);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$DmChannel$E2eeDeclinedBy = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$DmChannel$E2eeDisabled = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$DmChannel$E2eeEnabled = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V417$DmChannel$E2eeRequestedBy = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$DmChannel$w3_unsafe_decode_E2eeEnabledData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodePair$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
		$author$project$Evergreen$V417$SessionIdHash$w3_unsafe_decode_SessionIdHash),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (enabledAt0, requestedBy0) {
					return {enabledAt: enabledAt0, requestedBy: requestedBy0};
				}))));
var $author$project$Evergreen$V417$DmChannel$w3_unsafe_decode_E2eeStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$DmChannel$E2eeDeclinedBy));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$lamdera$codecs$Lamdera$Wire3$decodePair$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$DmChannel$E2eeDisabled));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$DmChannel$w3_unsafe_decode_E2eeEnabledData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$DmChannel$E2eeEnabled));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
						$author$project$Evergreen$V417$SessionIdHash$w3_unsafe_decode_SessionIdHash),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$DmChannel$E2eeRequestedBy));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$DmChannel$w3_unsafe_decode_FrontendDmChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$VisibleMessages$w3_unsafe_decode_VisibleMessages($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
			$author$project$Evergreen$V417$Thread$w3_unsafe_decode_FrontendThread),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$MessageArray$w3_unsafe_decode_MessageArray$(
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId,
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMaybeMessage,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (threadRoute0, time0) {
										return {threadRoute: threadRoute0, time: time0};
									}))))),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$author$project$Evergreen$V417$Game$w3_unsafe_decode_MatchData),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$DmChannel$w3_unsafe_decode_E2eeStatus,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqDict$decodeDict$(
								$justinmimbs$date$Date$w3_unsafe_decode_Date,
								$author$project$Evergreen$V417$Drawing$w3_unsafe_decode_Drawing(
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId))),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F7(
									function (dateDividerDrawings0, e2ee0, games0, lastTypedAt0, messages0, threads0, visibleMessages0) {
										return {dateDividerDrawings: dateDividerDrawings0, e2ee: e2ee0, games: games0, lastTypedAt: lastTypedAt0, messages: messages0, threads: threads0, visibleMessages: visibleMessages0};
									})))))))));
var $author$project$Evergreen$V417$Call$w3_unsafe_decode_Local = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Evergreen$V417$Call$w3_unsafe_decode_CallId,
		$author$project$Evergreen$V417$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
			$lamdera$codecs$Lamdera$Wire3$decodePair$(
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
				$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId),
			$author$project$Evergreen$V417$Call$w3_unsafe_decode_RemoteCallData)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V417$Call$w3_unsafe_decode_CallId, $author$project$Evergreen$V417$Call$w3_unsafe_decode_RecordingStatus),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Call$w3_unsafe_decode_CallId),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (currentRoom0, recordings0, voiceChats0) {
						return {currentRoom: currentRoom0, recordings: recordings0, voiceChats: voiceChats0};
					})))));
var $author$project$Evergreen$V417$TextEditor$w3_unsafe_decode_LocalState = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
		$lamdera$codecs$Lamdera$Wire3$decodeInt),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeArray(
			$lamdera$codecs$Lamdera$Wire3$decodePair$(
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
				$author$project$Evergreen$V417$TextEditor$w3_unsafe_decode_EditChange)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
				$author$project$Evergreen$V417$Range$w3_unsafe_decode_Range),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (cursorPosition0, history0, undoPoint0) {
						return {cursorPosition: cursorPosition0, history: history0, undoPoint: undoPoint0};
					})))));
var $author$project$Evergreen$V417$User$w3_unsafe_decode_FrontendCurrentUser = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqSet$decodeSet(
		$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
			$author$project$Evergreen$V417$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
				$lamdera$codecs$Lamdera$Wire3$decodePair$(
					$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId),
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute),
				$author$project$Evergreen$V417$OneOrGreater$w3_unsafe_decode_OneOrGreater)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$X25519$w3_unsafe_decode_PublicKey),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqSet$decodeSet(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$PersonName$w3_unsafe_decode_PersonName,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_Model,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeBool,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeBool,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$containers$SeqDict$decodeDict$(
											$lamdera$codecs$Lamdera$Wire3$decodePair$(
												$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
												$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId)),
											$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId)),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$containers$SeqDict$decodeDict$(
												$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
												$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId)),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$containers$SeqDict$decodeDict$(
													$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
													$lamdera$codecs$Lamdera$Wire3$decodePair$(
														$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId),
														$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute)),
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Pagination$w3_unsafe_decode_PageId),
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$author$project$Evergreen$V417$User$w3_unsafe_decode_LastDmViewed,
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$lamdera$containers$SeqDict$decodeDict$(
																		$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
																		$lamdera$codecs$Lamdera$Wire3$decodePair$(
																			$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
																			$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute)),
																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																		$lamdera$containers$SeqDict$decodeDict$(
																			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
																			$lamdera$codecs$Lamdera$Wire3$decodePair$(
																				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId),
																				$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute)),
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$codecs$Lamdera$Wire3$decodeBool,
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash),
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiConfig,
																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																						$author$project$Evergreen$V417$User$w3_unsafe_decode_EmbedVisibility,
																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																							$author$project$Evergreen$V417$User$w3_unsafe_decode_EmailNotifications,
																							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																								$author$project$Evergreen$V417$EmailAddress$w3_unsafe_decode_EmailAddress,
																								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																									$lamdera$codecs$Lamdera$Wire3$decodeBool,
																									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																										$lamdera$containers$SeqSet$decodeSet($author$project$Evergreen$V417$RichText$w3_unsafe_decode_Domain),
																										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																											$lamdera$containers$SeqSet$decodeSet(
																												$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId)),
																											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																												$lamdera$containers$SeqDict$decodeDict$(
																													$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
																													$author$project$Evergreen$V417$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
																														$lamdera$codecs$Lamdera$Wire3$decodePair$(
																															$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
																															$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute),
																														$author$project$Evergreen$V417$OneOrGreater$w3_unsafe_decode_OneOrGreater)),
																												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																													$lamdera$containers$SeqDict$decodeDict$(
																														$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
																														$author$project$Evergreen$V417$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
																															$lamdera$codecs$Lamdera$Wire3$decodePair$(
																																$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId),
																																$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute),
																															$author$project$Evergreen$V417$OneOrGreater$w3_unsafe_decode_OneOrGreater)),
																													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																														$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
																														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																															$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
																															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																$author$project$Evergreen$V417$UserColor$w3_unsafe_decode_UserColor,
																																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																	$lamdera$containers$SeqSet$decodeSet(
																																		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_StickerId)),
																																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																		$lamdera$containers$SeqSet$decodeSet(
																																			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_CustomEmojiId)),
																																		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																																			function (availableCustomEmojis0) {
																																				return function (availableStickers0) {
																																					return function (color0) {
																																						return function (createdAt0) {
																																							return function (deleteAccountAt0) {
																																								return function (directMentions0) {
																																									return function (discordDirectMentions0) {
																																										return function (discordNotifyOnAllMessages0) {
																																											return function (domainWhitelist0) {
																																												return function (e2eeRisksAccepted0) {
																																													return function (email0) {
																																														return function (emailNotifications0) {
																																															return function (embedVisibility0) {
																																																return function (emojiConfig0) {
																																																	return function (icon0) {
																																																		return function (isAdmin0) {
																																																			return function (lastChannelViewed0) {
																																																				return function (lastDiscordChannelViewed0) {
																																																					return function (lastDmViewed0) {
																																																						return function (lastEmailNotification0) {
																																																							return function (lastLogPageViewed0) {
																																																								return function (lastPushNotification0) {
																																																									return function (lastSlackChannelViewed0) {
																																																										return function (lastViewedMessage0) {
																																																											return function (lastViewedThreadMessage0) {
																																																												return function (linkDiscordAcknowledgementIsChecked0) {
																																																													return function (linkSlackAcknowledgementIsChecked0) {
																																																														return function (muteSettings0) {
																																																															return function (name0) {
																																																																return function (notifyOnAllMessages0) {
																																																																	return function (publicKey0) {
																																																																		return function (recentLoginEmails0) {
																																																																			return function (slackDirectMentions0) {
																																																																				return function (slackNotifyOnAllMessages0) {
																																																																					return {availableCustomEmojis: availableCustomEmojis0, availableStickers: availableStickers0, color: color0, createdAt: createdAt0, deleteAccountAt: deleteAccountAt0, directMentions: directMentions0, discordDirectMentions: discordDirectMentions0, discordNotifyOnAllMessages: discordNotifyOnAllMessages0, domainWhitelist: domainWhitelist0, e2eeRisksAccepted: e2eeRisksAccepted0, email: email0, emailNotifications: emailNotifications0, embedVisibility: embedVisibility0, emojiConfig: emojiConfig0, icon: icon0, isAdmin: isAdmin0, lastChannelViewed: lastChannelViewed0, lastDiscordChannelViewed: lastDiscordChannelViewed0, lastDmViewed: lastDmViewed0, lastEmailNotification: lastEmailNotification0, lastLogPageViewed: lastLogPageViewed0, lastPushNotification: lastPushNotification0, lastSlackChannelViewed: lastSlackChannelViewed0, lastViewedMessage: lastViewedMessage0, lastViewedThreadMessage: lastViewedThreadMessage0, linkDiscordAcknowledgementIsChecked: linkDiscordAcknowledgementIsChecked0, linkSlackAcknowledgementIsChecked: linkSlackAcknowledgementIsChecked0, muteSettings: muteSettings0, name: name0, notifyOnAllMessages: notifyOnAllMessages0, publicKey: publicKey0, recentLoginEmails: recentLoginEmails0, slackDirectMentions: slackDirectMentions0, slackNotifyOnAllMessages: slackNotifyOnAllMessages0};
																																																																				};
																																																																			};
																																																																		};
																																																																	};
																																																																};
																																																															};
																																																														};
																																																													};
																																																												};
																																																											};
																																																										};
																																																									};
																																																								};
																																																							};
																																																						};
																																																					};
																																																				};
																																																			};
																																																		};
																																																	};
																																																};
																																															};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			})))))))))))))))))))))))))))))))))));
var $author$project$Evergreen$V417$LinkedAndOtherDiscordUsers$LinkedAndOtherDiscordUsers$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$LinkedAndOtherDiscordUsers$LinkedAndOtherDiscordUsers = F2($author$project$Evergreen$V417$LinkedAndOtherDiscordUsers$LinkedAndOtherDiscordUsers$);
var $author$project$Evergreen$V417$LinkedAndOtherDiscordUsers$w3_unsafe_decode_LinkedAndOtherDiscordUsers = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
					$author$project$Evergreen$V417$LinkedAndOtherDiscordUsers$w3_unsafe_decode_DiscordFrontendCurrentUser),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
						$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_DiscordFrontendUser),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LinkedAndOtherDiscordUsers$LinkedAndOtherDiscordUsers)));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$User$w3_unsafe_decode_LocalUser = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$UserAgent$w3_unsafe_decode_UserAgent,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$User$w3_unsafe_decode_FrontendCurrentUser,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$program_test$Effect$Time$w3_unsafe_decode_Zone,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_StickerId),
					$author$project$Evergreen$V417$Sticker$w3_unsafe_decode_StickerData),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqSet$decodeSet(
						$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
							$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_SlackFrontendUser),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_UserSession,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeInt,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$containers$SeqDict$decodeDict$(
											$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
											$author$project$Evergreen$V417$User$w3_unsafe_decode_FrontendUser),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$containers$SeqDict$decodeDict$(
												$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
												$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId)),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Emoji$w3_unsafe_decode_CachedEmojiData),
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$author$project$Evergreen$V417$LinkedAndOtherDiscordUsers$w3_unsafe_decode_LinkedAndOtherDiscordUsers,
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$lamdera$codecs$Lamdera$Wire3$decodeFloat,
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$lamdera$containers$SeqDict$decodeDict$(
																$author$project$Evergreen$V417$Encryption$w3_unsafe_decode_BytesHash,
																$lamdera$codecs$Lamdera$Wire3$decodeResult$(
																	$lamdera$codecs$Lamdera$Wire3$decodeUnit,
																	$author$project$Evergreen$V417$Message$w3_unsafe_decode_MessageContent$(
																		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
																		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId)))),
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$lamdera$containers$SeqDict$decodeDict$(
																	$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_CustomEmojiId),
																	$author$project$Evergreen$V417$CustomEmoji$w3_unsafe_decode_CustomEmojiData),
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing,
																	$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																		function (currentlyViewing0) {
																			return function (customEmojis0) {
																				return function (decryptedMessages0) {
																					return function (devicePixelRatio0) {
																						return function (discordUsers0) {
																							return function (emojiData0) {
																								return function (linkedSlackUsers0) {
																									return function (otherUsers0) {
																										return function (safeAreaInsetBottom0) {
																											return function (safeAreaInsetTop0) {
																												return function (session0) {
																													return function (slackUsers0) {
																														return function (slackUsersNeedingAuth0) {
																															return function (stickers0) {
																																return function (timezone0) {
																																	return function (user0) {
																																		return function (userAgent0) {
																																			return {currentlyViewing: currentlyViewing0, customEmojis: customEmojis0, decryptedMessages: decryptedMessages0, devicePixelRatio: devicePixelRatio0, discordUsers: discordUsers0, emojiData: emojiData0, linkedSlackUsers: linkedSlackUsers0, otherUsers: otherUsers0, safeAreaInsetBottom: safeAreaInsetBottom0, safeAreaInsetTop: safeAreaInsetTop0, session: session0, slackUsers: slackUsers0, slackUsersNeedingAuth: slackUsersNeedingAuth0, stickers: stickers0, timezone: timezone0, user: user0, userAgent: userAgent0};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		}))))))))))))))))));
var $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_LocalState = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$TextEditor$w3_unsafe_decode_LocalState,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
			$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_SlackFrontendWorkspace),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_DmChannelId),
				$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_SlackFrontendDmChannel),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V417$SessionIdHash$w3_unsafe_decode_SessionIdHash, $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_FrontendUserSession),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$User$w3_unsafe_decode_LocalUser,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$LocalState$w3_unsafe_decode_JoinGuildError),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqDict$decodeDict$(
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
									$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_FrontendGuild),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$containers$SeqDict$decodeDict$(
										$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
										$author$project$Evergreen$V417$DmChannel$w3_unsafe_decode_FrontendDmChannel),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$containers$SeqDict$decodeDict$(
											$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
											$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_DiscordFrontendGuild),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$containers$SeqDict$decodeDict$(
												$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
												$author$project$Evergreen$V417$DmChannel$w3_unsafe_decode_DiscordFrontendDmChannel),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$author$project$Evergreen$V417$Call$w3_unsafe_decode_Local,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_AdminStatus,
													$lamdera$codecs$Lamdera$Wire3$succeedDecode(
														function (adminData0) {
															return function (calls0) {
																return function (discordDmChannels0) {
																	return function (discordGuilds0) {
																		return function (dmChannels0) {
																			return function (guilds0) {
																				return function (joinGuildError0) {
																					return function (localUser0) {
																						return function (otherSessions0) {
																							return function (publicVapidKey0) {
																								return function (slackDmChannels0) {
																									return function (slackWorkspaces0) {
																										return function (textEditor0) {
																											return {adminData: adminData0, calls: calls0, discordDmChannels: discordDmChannels0, discordGuilds: discordGuilds0, dmChannels: dmChannels0, guilds: guilds0, joinGuildError: joinGuildError0, localUser: localUser0, otherSessions: otherSessions0, publicVapidKey: publicVapidKey0, slackDmChannels: slackDmChannels0, slackWorkspaces: slackWorkspaces0, textEditor: textEditor0};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														}))))))))))))));
var $author$project$Evergreen$V417$Types$MessageHover$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$MessageHover = F2($author$project$Evergreen$V417$Types$MessageHover$);
var $author$project$Evergreen$V417$Types$MessageMenu = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$Types$NoMessageHover = {$: 0};
var $author$project$Evergreen$V417$Types$ReactionPopup$ = function (a, b, c) {
	return {$: 3, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$ReactionPopup = F3($author$project$Evergreen$V417$Types$ReactionPopup$);
var $author$project$Evergreen$V417$Types$MessageMenuClosing$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$MessageMenuClosing = F2($author$project$Evergreen$V417$Types$MessageMenuClosing$);
var $author$project$Evergreen$V417$Types$MessageMenuDragging = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$Types$MessageMenuFixed = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V417$Types$MessageMenuOpening = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_MessageHoverMobileMode = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Types$w3_unsafe_decode_EditMessage),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$ianmackenzie$elm_units$Quantity$w3_unsafe_decode_Quantity$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$MessageMenuClosing)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$ianmackenzie$elm_units$Quantity$w3_unsafe_decode_Quantity$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$ianmackenzie$elm_units$Quantity$w3_unsafe_decode_Quantity$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (offset0, previousOffset0, time0) {
											return {offset: offset0, previousOffset: previousOffset0, time: time0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$MessageMenuDragging));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$ianmackenzie$elm_units$Quantity$w3_unsafe_decode_Quantity$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$MessageMenuFixed));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$ianmackenzie$elm_units$Quantity$w3_unsafe_decode_Quantity$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$ianmackenzie$elm_units$Quantity$w3_unsafe_decode_Quantity$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (offset0, targetOffset0) {
										return {offset: offset0, targetOffset: targetOffset0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$MessageMenuOpening));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_MessageMenuExtraOptions = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$Types$w3_unsafe_decode_MessageHoverMobileMode,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F7(
									function (guildOrDmId0, imageUrl0, isThreadStarter0, linkUrl0, mobileMode0, position0, threadRoute0) {
										return {guildOrDmId: guildOrDmId0, imageUrl: imageUrl0, isThreadStarter: isThreadStarter0, linkUrl: linkUrl0, mobileMode: mobileMode0, position: position0, threadRoute: threadRoute0};
									})))))))));
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_MessageHover = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$MessageHover)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Types$w3_unsafe_decode_MessageMenuExtraOptions,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$MessageMenu));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$NoMessageHover);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$ReactionPopup))));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Call$w3_unsafe_decode_DebugRow = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (label0, value0) {
					return {label: label0, value: value0};
				}))));
var $author$project$Evergreen$V417$Call$w3_unsafe_decode_DebugSection = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V417$Call$w3_unsafe_decode_DebugRow),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (rows0, title0) {
					return {rows: rows0, title: title0};
				}))));
var $author$project$Evergreen$V417$IdString$IdString = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$IdString$w3_unsafe_decode_IdString = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$Call$IsConnection = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Call$IsLocal = {$: 0};
var $author$project$Evergreen$V417$Call$w3_unsafe_decode_LocalOrConnection = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Call$w3_unsafe_decode_ConnectionId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$IsConnection));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$IsLocal);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Call$MediaDeviceId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Call$w3_unsafe_decode_MediaDeviceId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Call$FailedToGetMediaDevices = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$Call$HasMediaDevices = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Call$MediaDevicesNotLoaded = {$: 0};
var $author$project$Evergreen$V417$Call$AudioInput = 0;
var $author$project$Evergreen$V417$Call$AudioOutput = 2;
var $author$project$Evergreen$V417$Call$VideoInput = 1;
var $author$project$Evergreen$V417$Call$w3_unsafe_decode_DeviceKind = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Call$w3_unsafe_decode_MediaDevice = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Call$w3_unsafe_decode_DeviceKind,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$IdString$w3_unsafe_decode_IdString($author$project$Evergreen$V417$Call$w3_unsafe_decode_MediaDeviceId),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (deviceId0, groupId0, kind0, label0) {
							return {deviceId: deviceId0, groupId: groupId0, kind: kind0, label: label0};
						}))))));
var $author$project$Evergreen$V417$Call$w3_unsafe_decode_MediaDevicesStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$FailedToGetMediaDevices));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V417$Call$w3_unsafe_decode_MediaDevice),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$HasMediaDevices));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$MediaDevicesNotLoaded);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Call$CameraTile = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Call$ScreenShareTile = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Call$w3_unsafe_decode_VideoTile = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Call$w3_unsafe_decode_LocalOrConnection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$CameraTile));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Call$w3_unsafe_decode_LocalOrConnection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$ScreenShareTile));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Call$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$lamdera$codecs$Lamdera$Wire3$decodePair$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
			$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId),
		$lamdera$codecs$Lamdera$Wire3$decodeFloat),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Call$w3_unsafe_decode_LocalOrConnection),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$Call$w3_unsafe_decode_MediaDevicesStatus,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $lamdera$codecs$Lamdera$Wire3$decodeFloat),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
								$author$project$Evergreen$V417$IdString$w3_unsafe_decode_IdString($author$project$Evergreen$V417$Call$w3_unsafe_decode_MediaDeviceId)),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
									$author$project$Evergreen$V417$IdString$w3_unsafe_decode_IdString($author$project$Evergreen$V417$Call$w3_unsafe_decode_MediaDeviceId)),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Call$w3_unsafe_decode_RemoteCallData,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeInt,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$codecs$Lamdera$Wire3$decodeInt,
													$lamdera$codecs$Lamdera$Wire3$succeedDecode(
														F2(
															function (total0, uploaded0) {
																return {total: total0, uploaded: uploaded0};
															}))))),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeBool,
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeBool,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$containers$SeqSet$decodeSet($author$project$Evergreen$V417$Call$w3_unsafe_decode_ConnectionId),
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Call$w3_unsafe_decode_VideoTile),
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V417$Call$w3_unsafe_decode_DebugSection),
															$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																function (debugData0) {
																	return function (focusedTile0) {
																		return function (isSpeaking0) {
																			return function (localIsSpeaking0) {
																				return function (pollDebugData0) {
																					return function (recordingUpload0) {
																						return function (remoteCallData0) {
																							return function (selectedAudioInputDevice0) {
																								return function (selectedVideoInputDevice0) {
																									return function (showDeviceSettings0) {
																										return function (startConnectionError0) {
																											return function (thumbnailPosition0) {
																												return function (userMediaDevices0) {
																													return function (videoHover0) {
																														return function (volume0) {
																															return {debugData: debugData0, focusedTile: focusedTile0, isSpeaking: isSpeaking0, localIsSpeaking: localIsSpeaking0, pollDebugData: pollDebugData0, recordingUpload: recordingUpload0, remoteCallData: remoteCallData0, selectedAudioInputDevice: selectedAudioInputDevice0, selectedVideoInputDevice: selectedVideoInputDevice0, showDeviceSettings: showDeviceSettings0, startConnectionError: startConnectionError0, thumbnailPosition: thumbnailPosition0, userMediaDevices: userMediaDevices0, videoHover: videoHover0, volume: volume0};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																}))))))))))))))));
var $author$project$Evergreen$V417$Drawing$NoSelectedAnchor = {$: 0};
var $author$project$Evergreen$V417$Drawing$SelectedAnchor = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Drawing$w3_unsafe_decode_ActiveStroke = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeList(
		$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V417$SafeFloat$w3_unsafe_decode_SafeFloat, $author$project$Evergreen$V417$SafeFloat$w3_unsafe_decode_SafeFloat)),
	$lamdera$codecs$Lamdera$Wire3$succeedDecode(
		function (unsent0) {
			return {unsent: unsent0};
		}));
var $author$project$Evergreen$V417$Drawing$w3_unsafe_decode_SelectedAnchorData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeFloat,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeFloat,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F4(
								function (height0, width0, x0, y0) {
									return {height: height0, width: width0, x: x0, y: y0};
								}))))))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeFloat,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Drawing$w3_unsafe_decode_ActiveStroke),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$Point2d$w3_unsafe_decode_Point2d$($author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels, $author$project$Evergreen$V417$Touch$w3_unsafe_decode_ScreenCoordinate),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Drawing$w3_unsafe_decode_AnchorType,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $lamdera$codecs$Lamdera$Wire3$decodeFloat),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F8(
										function (anchorHalfSize0, anchorType0, guildOrDmId0, pointScale0, position0, stroke0, zoom0, zoomContainer0) {
											return {anchorHalfSize: anchorHalfSize0, anchorType: anchorType0, guildOrDmId: guildOrDmId0, pointScale: pointScale0, position: position0, stroke: stroke0, zoom: zoom0, zoomContainer: zoomContainer0};
										}))))))))));
var $author$project$Evergreen$V417$Drawing$w3_unsafe_decode_Model = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Drawing$NoSelectedAnchor);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Drawing$w3_unsafe_decode_SelectedAnchorData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Drawing$SelectedAnchor));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Emoji$CustomEmojiCategory = {$: 2};
var $author$project$Evergreen$V417$Emoji$EmojiCategory = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Emoji$StickerCategory = {$: 1};
var $author$project$Evergreen$V417$Emoji$w3_unsafe_decode_Category = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Emoji$CustomEmojiCategory);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiCategory,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Emoji$EmojiCategory));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Emoji$StickerCategory);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Emoji$EmojiOrSticker_CustomEmoji = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$Emoji$EmojiOrSticker_Sticker = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Emoji$EmojiOrSticker_UnicodeEmoji = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrSticker = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_CustomEmojiId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Emoji$EmojiOrSticker_CustomEmoji));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_StickerId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Emoji$EmojiOrSticker_Sticker));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_UnicodeEmoji,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Emoji$EmojiOrSticker_UnicodeEmoji));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Emoji$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrSticker,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F2(
							function (emoji0, index0) {
								return {emoji: emoji0, index: index0};
							}))))),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_Category,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (category0, emojiHovered0, searchText0) {
						return {category: category0, emojiHovered: emojiHovered0, searchText: searchText0};
					})))));
var $author$project$Evergreen$V417$Game$GoModel_Game = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Game$SheepGame_Game = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$Game$WordSpellingGame_Game = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Scroll$ScrolledCloseToBottom = 1;
var $author$project$Evergreen$V417$Scroll$ScrolledToBottom = 0;
var $author$project$Evergreen$V417$Scroll$ScrolledToMiddle = 3;
var $author$project$Evergreen$V417$Scroll$ScrolledToTop = 2;
var $author$project$Evergreen$V417$Scroll$w3_unsafe_decode_ScrollPosition = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_UnvalidatedInput = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
			$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileStatus),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (attachedFiles0, text0) {
					return {attachedFiles: attachedFiles0, text: text0};
				}))));
var $author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_GameData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Scroll$w3_unsafe_decode_ScrollPosition,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$IdArray$w3_unsafe_decode_IdArray$($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId, $author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_UnvalidatedInput),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeBool,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_ReactionTarget),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
								$lamdera$codecs$Lamdera$Wire3$decodePair$(
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId))),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$IdArray$w3_unsafe_decode_IdArray$($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId, $author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_UnvalidatedInput),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F8(
										function (answerDrafts0, gridHovered0, hoveredQuestion0, hoveredResult0, newQuestionRevealed0, noteDrafts0, questionsRevealedSeen0, scrollPosition0) {
											return {answerDrafts: answerDrafts0, gridHovered: gridHovered0, hoveredQuestion: hoveredQuestion0, hoveredResult: hoveredResult0, newQuestionRevealed: newQuestionRevealed0, noteDrafts: noteDrafts0, questionsRevealedSeen: questionsRevealedSeen0, scrollPosition: scrollPosition0};
										}))))))))));
var $author$project$Evergreen$V417$WordSpellingGame$Dragging = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$WordSpellingGame$NotDragging = {$: 1};
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_Drag = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$Dragging));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$NotDragging);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_HoveredMove = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_Shared,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeDict$(
				$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
				$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (cells0, index0, shared0) {
						return {cells: cells0, index: index0, shared: shared0};
					})))));
var $author$project$Evergreen$V417$WordSpellingGame$TileInTray$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$WordSpellingGame$TileInTray = F2($author$project$Evergreen$V417$WordSpellingGame$TileInTray$);
var $author$project$Evergreen$V417$WordSpellingGame$TileOnBoard$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V417$WordSpellingGame$TileOnBoard = F2($author$project$Evergreen$V417$WordSpellingGame$TileOnBoard$);
var $author$project$Evergreen$V417$WordSpellingGame$TrayIndex = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_TrayIndex = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_TilePosition = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix, $lamdera$codecs$Lamdera$Wire3$decodeInt)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_TrayIndex,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$TileInTray)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$TileOnBoard)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_Tile = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_TilePosition,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (createdAt0, position0) {
					return {createdAt: createdAt0, position: position0};
				}))));
var $author$project$Evergreen$V417$WordSpellingGame$WordDefinition_None = {$: 0};
var $author$project$Evergreen$V417$WordSpellingGame$WordDefinition_Open$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V417$WordSpellingGame$WordDefinition_Open = F2($author$project$Evergreen$V417$WordSpellingGame$WordDefinition_Open$);
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_OpenWordDefinition = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty($lamdera$codecs$Lamdera$Wire3$decodeString),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (index0, words0) {
					return {index: index0, words: words0};
				}))));
var $author$project$Evergreen$V417$WordSpellingGame$WordDefinition_Failed = {$: 3};
var $author$project$Evergreen$V417$WordSpellingGame$WordDefinition_Loaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V417$WordSpellingGame$WordDefinition_Loading = {$: 0};
var $author$project$Evergreen$V417$WordSpellingGame$WordDefinition_NotFound = {$: 2};
var $author$project$Evergreen$V417$WordSpellingGame$WordDefinition_SwedishUnsupported = {$: 1};
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_DictEntry = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeString),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (definitions0, partOfSpeech0) {
					return {definitions: definitions0, partOfSpeech: partOfSpeech0};
				}))));
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_WordDefinitionData = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$WordDefinition_Failed);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_DictEntry),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$WordDefinition_Loaded));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$WordDefinition_Loading);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$WordDefinition_NotFound);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$WordDefinition_SwedishUnsupported);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_WordDefinition = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$WordDefinition_None);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_WordDefinitionData,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_OpenWordDefinition,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$WordDefinition_Open)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_ZoomState = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeFloat,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeFloat,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeFloat,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (amount0, focusX0, focusY0) {
						return {amount: amount0, focusX: focusX0, focusY: focusY0};
					})))));
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_ZoomAnimation = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_ZoomState,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (from0, start0) {
					return {from: from0, start: start0};
				}))));
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_GameData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_ZoomAnimation,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_WordDefinition,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_Tile),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeBool,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Scroll$w3_unsafe_decode_ScrollPosition,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeInt,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											F2(
												function (letterCount0, time0) {
													return {letterCount: letterCount0, time: time0};
												}))))),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_HoveredMove),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
										$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId)),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_Drag,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											function (dragging0) {
												return function (highlightedPlayer0) {
													return function (hoveredMove0) {
														return function (lastWordPlaced0) {
															return function (scrollPosition0) {
																return function (selectedCell0) {
																	return function (showSettings0) {
																		return function (tiles0) {
																			return function (wordDefinition0) {
																				return function (zoomAnimation0) {
																					return {dragging: dragging0, highlightedPlayer: highlightedPlayer0, hoveredMove: hoveredMove0, lastWordPlaced: lastWordPlaced0, scrollPosition: scrollPosition0, selectedCell: selectedCell0, showSettings: showSettings0, tiles: tiles0, wordDefinition: wordDefinition0, zoomAnimation: zoomAnimation0};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											})))))))))));
var $author$project$Evergreen$V417$Go$w3_unsafe_decode_GameModel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (lastError0, lastPlacedStone0, viewingMovesBack0) {
						return {lastError: lastError0, lastPlacedStone: lastPlacedStone0, viewingMovesBack: viewingMovesBack0};
					})))));
var $author$project$Evergreen$V417$Game$w3_unsafe_decode_Game = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Go$w3_unsafe_decode_GameModel,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$GoModel_Game));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_GameData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$SheepGame_Game));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_GameData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$WordSpellingGame_Game));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Game$GameSelect = {$: 0};
var $author$project$Evergreen$V417$Game$GoModel_Setup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Game$SheepGame_Setup = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V417$Game$WordSpellingGame_Setup = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$Go$CustomSize = 3;
var $author$project$Evergreen$V417$Go$Standard13 = 1;
var $author$project$Evergreen$V417$Go$Standard19 = 2;
var $author$project$Evergreen$V417$Go$Standard9 = 0;
var $author$project$Evergreen$V417$Go$w3_unsafe_decode_SizeSelection = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Go$w3_unsafe_decode_SetupModel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Go$w3_unsafe_decode_SizeSelection,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeString,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Go$w3_unsafe_decode_Stone,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F9(
											function (error0, gameCreatorPlayingAs0, handicapInput0, heightInput0, incrementInput0, komiInput0, mainTimeInput0, sizeSelection0, widthInput0) {
												return {error: error0, gameCreatorPlayingAs: gameCreatorPlayingAs0, handicapInput: handicapInput0, heightInput: heightInput0, incrementInput: incrementInput0, komiInput: komiInput0, mainTimeInput: mainTimeInput0, sizeSelection: sizeSelection0, widthInput: widthInput0};
											})))))))))));
var $author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_SetupModel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$IdArray$w3_unsafe_decode_IdArray$($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId, $author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_UnvalidatedInput),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (error0, pressedSubmit0, questions0) {
						return {error: error0, pressedSubmit: pressedSubmit0, questions: questions0};
					})))));
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_SetupModel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$OneOrGreater$w3_unsafe_decode_OneOrGreater,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$($lamdera$codecs$Lamdera$Wire3$decodeChar, $lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_Language,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeString,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeBool,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											function (advancedSettingsExpanded0) {
												return function (error0) {
													return function (fullTrayBonus0) {
														return function (incrementInput0) {
															return function (language0) {
																return function (letterValues0) {
																	return function (letters0) {
																		return function (mainTimeInput0) {
																			return function (placeWordAttempts0) {
																				return function (traySize0) {
																					return {advancedSettingsExpanded: advancedSettingsExpanded0, error: error0, fullTrayBonus: fullTrayBonus0, incrementInput: incrementInput0, language: language0, letterValues: letterValues0, letters: letters0, mainTimeInput: mainTimeInput0, placeWordAttempts: placeWordAttempts0, traySize: traySize0};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											})))))))))));
var $author$project$Evergreen$V417$Game$w3_unsafe_decode_Setup = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$GameSelect);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Go$w3_unsafe_decode_SetupModel,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$GoModel_Setup));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_SetupModel,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$SheepGame_Setup));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_SetupModel,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$WordSpellingGame_Setup));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Game$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
		$author$project$Evergreen$V417$Game$w3_unsafe_decode_Game),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$lamdera$codecs$Lamdera$Wire3$decodePair$(
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
				$author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_Input),
			$lamdera$codecs$Lamdera$Wire3$decodeInt),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$Game$w3_unsafe_decode_Setup,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (setup0, sheepGameQuestionsCounter0, sheepGameSaveCounters0, startedGames0) {
							return {setup: setup0, sheepGameQuestionsCounter: sheepGameQuestionsCounter0, sheepGameSaveCounters: sheepGameSaveCounters0, startedGames: startedGames0};
						}))))));
var $author$project$Evergreen$V417$ImageEditor$BottomLeft = 2;
var $author$project$Evergreen$V417$ImageEditor$BottomRight = 3;
var $author$project$Evergreen$V417$ImageEditor$Center = 4;
var $author$project$Evergreen$V417$ImageEditor$TopLeft = 0;
var $author$project$Evergreen$V417$ImageEditor$TopRight = 1;
var $author$project$Evergreen$V417$ImageEditor$w3_unsafe_decode_DragPart = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$ImageEditor$w3_unsafe_decode_DragState = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeFloat,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeFloat,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$ImageEditor$w3_unsafe_decode_DragPart,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeFloat,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (currentX0, currentY0, dragPart0, startX0, startY0) {
								return {currentX: currentX0, currentY: currentY0, dragPart: dragPart0, startX: startX0, startY: startY0};
							})))))));
var $author$project$Evergreen$V417$ImageEditor$Cropping = {$: 1};
var $author$project$Evergreen$V417$ImageEditor$NotUploaded = {$: 0};
var $author$project$Evergreen$V417$ImageEditor$Uploading = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$ImageEditor$UploadingError = {$: 3};
var $author$project$Evergreen$V417$ImageEditor$w3_unsafe_decode_UploadStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageEditor$Cropping);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageEditor$NotUploaded);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageEditor$Uploading));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageEditor$UploadingError);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$ImageEditor$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeFloat,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeFloat,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$ImageEditor$w3_unsafe_decode_UploadStatus,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeFloat,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$ImageEditor$w3_unsafe_decode_DragState),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F7(
									function (dragState0, imageSize0, imageUrl0, size0, status0, x0, y0) {
										return {dragState: dragState0, imageSize: imageSize0, imageUrl: imageUrl0, size: size0, status: status0, x: x0, y: y0};
									})))))))));
var $author$project$Evergreen$V417$Pages$Admin$ApiKeysSection = 10;
var $author$project$Evergreen$V417$Pages$Admin$ConnectionsSection = 12;
var $author$project$Evergreen$V417$Pages$Admin$DeletedGuildsSection = 9;
var $author$project$Evergreen$V417$Pages$Admin$DiscordDmChannelsSection = 3;
var $author$project$Evergreen$V417$Pages$Admin$DiscordGuildsSection = 5;
var $author$project$Evergreen$V417$Pages$Admin$DiscordUsersSection = 4;
var $author$project$Evergreen$V417$Pages$Admin$DmChannelsSection = 2;
var $author$project$Evergreen$V417$Pages$Admin$ExportSection = 11;
var $author$project$Evergreen$V417$Pages$Admin$FilesSection = 13;
var $author$project$Evergreen$V417$Pages$Admin$GuildsSection = 8;
var $author$project$Evergreen$V417$Pages$Admin$LogSection = 1;
var $author$project$Evergreen$V417$Pages$Admin$SessionsSection = 17;
var $author$project$Evergreen$V417$Pages$Admin$SlackDmChannelsSection = 7;
var $author$project$Evergreen$V417$Pages$Admin$SlackWorkspacesSection = 6;
var $author$project$Evergreen$V417$Pages$Admin$StickersAndEmojisSection = 15;
var $author$project$Evergreen$V417$Pages$Admin$UpdateLogsSection = 14;
var $author$project$Evergreen$V417$Pages$Admin$UsersSection = 0;
var $author$project$Evergreen$V417$Pages$Admin$WebsocketCloseEventsSection = 16;
var $author$project$Evergreen$V417$Pages$Admin$WordSpellingGameSwedishSection = 18;
var $author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_AdminUiSection = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(10);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(12);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(9);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(11);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(13);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(8);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(17);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(15);
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(14);
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(16);
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(18);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_DownloadingBackup = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeBytes),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (chunks0, receivedBytes0, totalBytes0) {
						return {chunks: chunks0, receivedBytes: receivedBytes0, totalBytes: totalBytes0};
					})))));
var $author$project$Evergreen$V417$Pages$Admin$ExportStarting = {$: 0};
var $author$project$Evergreen$V417$Pages$Admin$ExportingDiscordDmChannels = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$ExportingDiscordGuilds = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$ExportingDmChannels = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$ExportingGuilds = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_ExportProgress = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$ExportStarting);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (encoded0, total0) {
										return {encoded: encoded0, total: total0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$ExportingDiscordDmChannels));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (channelsRemaining0, encoded0, total0) {
											return {channelsRemaining: channelsRemaining0, encoded: encoded0, total: total0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$ExportingDiscordGuilds));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (encoded0, total0) {
										return {encoded: encoded0, total: total0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$ExportingDmChannels));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (channelsRemaining0, encoded0, total0) {
											return {channelsRemaining: channelsRemaining0, encoded: encoded0, total: total0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$ExportingGuilds));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_ExportSubsetSelection = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqSet$decodeSet(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqSet$decodeSet($author$project$Evergreen$V417$DmChannelId$w3_unsafe_decode_DmChannelId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqSet$decodeSet(
				$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqSet$decodeSet(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId)),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (discordDmChannels0, discordGuilds0, dmChannels0, guilds0) {
							return {discordDmChannels: discordDmChannels0, discordGuilds: discordGuilds0, dmChannels: dmChannels0, guilds: guilds0};
						}))))));
var $author$project$Evergreen$V417$Pages$Admin$ImportBackendFailed = {$: 1};
var $author$project$Evergreen$V417$Pages$Admin$ImportedBackendSuccessfully = {$: 3};
var $author$project$Evergreen$V417$Pages$Admin$ImportingBackend = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$NotImportingBackend = {$: 0};
var $author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_ImportBackendStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$ImportBackendFailed);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$ImportedBackendSuccessfully);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeBytes,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (remainingBytes0, sentBytes0, totalBytes0) {
											return {remainingBytes: remainingBytes0, sentBytes: sentBytes0, totalBytes: totalBytes0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$ImportingBackend));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$NotImportingBackend);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Pagination$ItemId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Pagination$w3_unsafe_decode_ItemId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Editable$Editing = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Editable$NotEditing = {$: 0};
var $author$project$Evergreen$V417$Editable$w3_unsafe_decode_Editing = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Editable$Editing));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Editable$NotEditing);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Editable$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$Editable$w3_unsafe_decode_Editing,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (editing0, pressedSubmit0, showSecret0) {
						return {editing: editing0, pressedSubmit: pressedSubmit0, showSecret: showSecret0};
					})))));
var $author$project$Evergreen$V417$Pages$Admin$EmailAddressColumn = 1;
var $author$project$Evergreen$V417$Pages$Admin$NameColumn = 0;
var $author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_UserColumn = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Pages$Admin$ExistingUserId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$NewUserId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_UserTableId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$ExistingUserId));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$NewUserId));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_EditingCell = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_UserTableId,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_UserColumn,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (column0, text0, userId0) {
						return {column: column0, text: text0, userId: userId0};
					})))));
var $author$project$Evergreen$V417$Table$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeBool,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (ascendingOrder0, columnToSortBy0, showAll0) {
						return {ascendingOrder: ascendingOrder0, columnToSortBy: columnToSortBy0, showAll: showAll0};
					})))));
var $author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_UserTable = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Table$w3_unsafe_decode_Model,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_EditedBackendUser),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_EditingCell),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqSet$decodeSet(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId)),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
						$author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_EditedBackendUser),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (changedUsers0, deletedUsers0, editingCell0, newUsers0, table0) {
								return {changedUsers: changedUsers0, deletedUsers: deletedUsers0, editingCell: editingCell0, newUsers: newUsers0, table: table0};
							})))))));
var $author$project$Evergreen$V417$Pages$Admin$CantDeleteYourself = {$: 4};
var $author$project$Evergreen$V417$Pages$Admin$CantRemoveAdminRoleFromYourself = {$: 3};
var $author$project$Evergreen$V417$Pages$Admin$ChangesAppliedToNonExistentUser = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$EmailAddressesAreNotUnique = {$: 0};
var $author$project$Evergreen$V417$Pages$Admin$InvalidChangesToUser = {$: 1};
var $author$project$Evergreen$V417$Pages$Admin$InvalidNewUser = {$: 5};
var $author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_UsersChangeError = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$CantDeleteYourself);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$CantRemoveAdminRoleFromYourself);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$ChangesAppliedToNonExistentUser));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$EmailAddressesAreNotUnique);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$InvalidChangesToUser);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$InvalidNewUser);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_UserTable,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_UsersChangeError),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$Editable$w3_unsafe_decode_Model,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Editable$w3_unsafe_decode_Model,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Editable$w3_unsafe_decode_Model,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Editable$w3_unsafe_decode_Model,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Editable$w3_unsafe_decode_Model,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Editable$w3_unsafe_decode_Model,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V417$Editable$w3_unsafe_decode_Model,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_ImportBackendStatus,
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
													$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Pagination$w3_unsafe_decode_ItemId)),
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_ExportSubsetSelection),
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_ExportProgress),
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$lamdera$containers$SeqSet$decodeSet(
																$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId)),
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$lamdera$containers$SeqSet$decodeSet($author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_AdminUiSection),
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$lamdera$containers$SeqSet$decodeSet(
																		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId)),
																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																		$lamdera$containers$SeqSet$decodeSet(
																			$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId)),
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_DownloadingBackup),
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$author$project$Evergreen$V417$Editable$w3_unsafe_decode_Model,
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
																						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Pagination$w3_unsafe_decode_ItemId)),
																					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																						function (copiedLogLink0) {
																							return function (discordLinkLimit0) {
																								return function (downloadingBackup0) {
																									return function (expandedDiscordGuilds0) {
																										return function (expandedGuilds0) {
																											return function (expandedSections0) {
																												return function (expandedSlackWorkspaces0) {
																													return function (exportProgress0) {
																														return function (exportSubsetSelection0) {
																															return function (highlightLog0) {
																																return function (importBackendStatus0) {
																																	return function (notifyAdminsBotUserId0) {
																																		return function (notifyAdminsToken0) {
																																			return function (openRouterKey0) {
																																				return function (postmarkKey0) {
																																					return function (privateVapidKey0) {
																																						return function (publicVapidKey0) {
																																							return function (slackLinkLimit0) {
																																								return function (submitError0) {
																																									return function (userTable0) {
																																										return function (websocketCloseEventsPage0) {
																																											return {copiedLogLink: copiedLogLink0, discordLinkLimit: discordLinkLimit0, downloadingBackup: downloadingBackup0, expandedDiscordGuilds: expandedDiscordGuilds0, expandedGuilds: expandedGuilds0, expandedSections: expandedSections0, expandedSlackWorkspaces: expandedSlackWorkspaces0, exportProgress: exportProgress0, exportSubsetSelection: exportSubsetSelection0, highlightLog: highlightLog0, importBackendStatus: importBackendStatus0, notifyAdminsBotUserId: notifyAdminsBotUserId0, notifyAdminsToken: notifyAdminsToken0, openRouterKey: openRouterKey0, postmarkKey: postmarkKey0, privateVapidKey: privateVapidKey0, publicVapidKey: publicVapidKey0, slackLinkLimit: slackLinkLimit0, submitError: submitError0, userTable: userTable0, websocketCloseEventsPage: websocketCloseEventsPage0};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						}))))))))))))))))))))));
var $author$project$Evergreen$V417$TextEditor$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$succeedDecode(
	{});
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_NewChannelForm = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (description0, name0, pressedSubmit0) {
						return {description: description0, name: name0, pressedSubmit: pressedSubmit0};
					})))));
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_NewGuildForm = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (name0, pressedSubmit0) {
					return {name: name0, pressedSubmit: pressedSubmit0};
				}))));
var $author$project$Evergreen$V417$X25519$PrivateKey = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$X25519$w3_unsafe_decode_PrivateKey = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$X25519$w3_unsafe_decode_Key,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_RevealedSpoilers = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId),
			$author$project$Evergreen$V417$NonemptySet$w3_unsafe_decode_NonemptySet($lamdera$codecs$Lamdera$Wire3$decodeInt))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
			$author$project$Evergreen$V417$NonemptySet$w3_unsafe_decode_NonemptySet($lamdera$codecs$Lamdera$Wire3$decodeInt)),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (messages0, threadMessages0) {
					return {messages: messages0, threadMessages: threadMessages0};
				}))));
var $author$project$Evergreen$V417$MessageInput$w3_unsafe_decode_MentionUserDropdown = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeFloat,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeFloat,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeFloat,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F4(
							function (height0, width0, x0, y0) {
								return {height: height0, width: width0, x: x0, y: y0};
							})))))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (dropdownIndex0, inputElement0) {
					return {dropdownIndex: dropdownIndex0, inputElement: inputElement0};
				}))));
var $author$project$Evergreen$V417$Range$SelectBackward = 1;
var $author$project$Evergreen$V417$Range$SelectForward = 0;
var $author$project$Evergreen$V417$Range$w3_unsafe_decode_SelectionDirection = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$MessageInput$w3_unsafe_decode_TextInputFocus = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Range$w3_unsafe_decode_Range,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_HtmlId,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$MessageInput$w3_unsafe_decode_MentionUserDropdown),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$Range$w3_unsafe_decode_SelectionDirection,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (direction0, dropdown0, htmlId0, selection0) {
							return {direction: direction0, dropdown: dropdown0, htmlId: htmlId0, selection: selection0};
						}))))));
var $author$project$Evergreen$V417$TwoFactorAuthentication$TwoFactorAlreadyComplete = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V417$TwoFactorAuthentication$TwoFactorComplete = {$: 3};
var $author$project$Evergreen$V417$TwoFactorAuthentication$TwoFactorDisable$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$Evergreen$V417$TwoFactorAuthentication$TwoFactorDisable = F2($author$project$Evergreen$V417$TwoFactorAuthentication$TwoFactorDisable$);
var $author$project$Evergreen$V417$TwoFactorAuthentication$TwoFactorLoading = {$: 1};
var $author$project$Evergreen$V417$TwoFactorAuthentication$TwoFactorNotStarted = {$: 0};
var $author$project$Evergreen$V417$TwoFactorAuthentication$TwoFactorSetup = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$LoginForm$Checking = 0;
var $author$project$Evergreen$V417$LoginForm$NotValid = 1;
var $author$project$Evergreen$V417$LoginForm$w3_unsafe_decode_CodeStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$TwoFactorAuthentication$w3_unsafe_decode_TwoFactorDisableData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$Evergreen$V417$LoginForm$w3_unsafe_decode_CodeStatus),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (attempts0, code0) {
					return {attempts: attempts0, code: code0};
				}))));
var $author$project$Evergreen$V417$TwoFactorAuthentication$w3_unsafe_decode_TwoFactorSetupData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$Evergreen$V417$LoginForm$w3_unsafe_decode_CodeStatus),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (attempts0, code0, qrCodeUrl0) {
						return {attempts: attempts0, code: code0, qrCodeUrl: qrCodeUrl0};
					})))));
var $author$project$Evergreen$V417$TwoFactorAuthentication$w3_unsafe_decode_TwoFactorState = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$TwoFactorAuthentication$TwoFactorAlreadyComplete));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$TwoFactorAuthentication$TwoFactorComplete);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$TwoFactorAuthentication$w3_unsafe_decode_TwoFactorDisableData,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$TwoFactorAuthentication$TwoFactorDisable)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$TwoFactorAuthentication$TwoFactorLoading);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$TwoFactorAuthentication$TwoFactorNotStarted);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$TwoFactorAuthentication$w3_unsafe_decode_TwoFactorSetupData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$TwoFactorAuthentication$TwoFactorSetup));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Types$E2eeKeys_Error = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Types$E2eeKeys_NotChecked = {$: 0};
var $author$project$Evergreen$V417$Types$E2eeKeys_Valid = {$: 2};
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_E2eeKeysValid = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$E2eeKeys_Error));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$E2eeKeys_NotChecked);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$E2eeKeys_Valid);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Types$LoadedSlackWorkspaces = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Types$SlackLinkingDisabled = {$: 0};
var $author$project$Evergreen$V417$Types$SlackLinkLimitReached = {$: 1};
var $author$project$Evergreen$V417$Types$SlackWorkspaceHttpError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_LinkSlackWorkspaceError = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$SlackLinkLimitReached);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Slack$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$SlackWorkspaceHttpError));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_LinkSlackResult = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
						$lamdera$codecs$Lamdera$Wire3$decodeResult$($author$project$Evergreen$V417$Types$w3_unsafe_decode_LinkSlackWorkspaceError, $lamdera$codecs$Lamdera$Wire3$decodeString)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$LoadedSlackWorkspaces));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$SlackLinkingDisabled);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$UserColor$w3_unsafe_decode_Selection = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F3(
						function (hue0, lightness0, saturation0) {
							return {hue: hue0, lightness: lightness0, saturation: saturation0};
						}))))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$UserColor$w3_unsafe_decode_UserColor,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (lastValid0, selected0) {
					return {lastValid: lastValid0, selected: selected0};
				}))));
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_UserOptionsModel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqSet$decodeSet(
				$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Editable$w3_unsafe_decode_Model,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Types$w3_unsafe_decode_LinkSlackResult),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Types$w3_unsafe_decode_E2eeKeysValid,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeString,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$codecs$Lamdera$Wire3$decodeString,
													$lamdera$codecs$Lamdera$Wire3$succeedDecode(
														F2(
															function (data0, loadedAt0) {
																return {data: data0, loadedAt: loadedAt0};
															}))))),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$UserColor$w3_unsafe_decode_Selection),
											$lamdera$codecs$Lamdera$Wire3$succeedDecode(
												function (color0) {
													return function (debugData0) {
														return function (domainWhitelistInput0) {
															return function (e2eeKeysValid0) {
																return function (linkSlackResult0) {
																	return function (name0) {
																		return function (pressedSubmitSlackData0) {
																			return function (privateKeyText0) {
																				return function (removedSlackTeams0) {
																					return function (slackCookie0) {
																						return function (slackTeamsJson0) {
																							return {color: color0, debugData: debugData0, domainWhitelistInput: domainWhitelistInput0, e2eeKeysValid: e2eeKeysValid0, linkSlackResult: linkSlackResult0, name: name0, pressedSubmitSlackData: pressedSubmitSlackData0, privateKeyText: privateKeyText0, removedSlackTeams: removedSlackTeams0, slackCookie: slackCookie0, slackTeamsJson: slackTeamsJson0};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												}))))))))))));
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_LoggedIn2 = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Call$w3_unsafe_decode_Model,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Types$w3_unsafe_decode_UserOptionsModel),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeBool,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$TwoFactorAuthentication$w3_unsafe_decode_TwoFactorState,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$MessageInput$w3_unsafe_decode_TextInputFocus),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$TextEditor$w3_unsafe_decode_Model,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Route$w3_unsafe_decode_ChannelSidebarMode,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$X25519$w3_unsafe_decode_PrivateKey),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
											$author$project$Evergreen$V417$SecretId$w3_unsafe_decode_SecretId($author$project$Evergreen$V417$Id$w3_unsafe_decode_InviteLinkId)),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileDataWithImage),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$author$project$Evergreen$V417$Types$w3_unsafe_decode_EmojiSelector,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$codecs$Lamdera$Wire3$decodeInt,
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$lamdera$codecs$Lamdera$Wire3$decodeString,
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V417$Types$w3_unsafe_decode_RevealedSpoilers),
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$lamdera$containers$SeqDict$decodeDict$(
																	$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute),
																	$author$project$Evergreen$V417$Message$w3_unsafe_decode_RepliedTo($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId)),
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$author$project$Evergreen$V417$ImageEditor$w3_unsafe_decode_Model,
																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$MessageInput$w3_unsafe_decode_TextInputFocus),
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$codecs$Lamdera$Wire3$decodeInt,
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Types$w3_unsafe_decode_NewGuildForm),
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$lamdera$containers$SeqDict$decodeDict$(
																						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
																						$author$project$Evergreen$V417$Types$w3_unsafe_decode_NewChannelForm),
																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																						$author$project$Evergreen$V417$Types$w3_unsafe_decode_MessageHover,
																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																							$author$project$Evergreen$V417$Local$w3_unsafe_decode_Local$($author$project$Evergreen$V417$Types$w3_unsafe_decode_LocalMsg, $author$project$Evergreen$V417$LocalState$w3_unsafe_decode_LocalState),
																							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																								$lamdera$codecs$Lamdera$Wire3$decodeBool,
																								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																									$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
																										$lamdera$codecs$Lamdera$Wire3$decodePair$(
																											$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
																											$author$project$Evergreen$V417$ImageEditor$w3_unsafe_decode_Model)),
																									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																										$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildOrDmId, $author$project$Evergreen$V417$Game$w3_unsafe_decode_Model),
																										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																											$lamdera$containers$SeqDict$decodeDict$(
																												$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute),
																												$author$project$Evergreen$V417$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
																													$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
																													$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileStatus)),
																											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																												$author$project$Evergreen$V417$Types$w3_unsafe_decode_FileDrag,
																												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																													$lamdera$codecs$Lamdera$Wire3$decodeMaybe($elm$url$Url$w3_unsafe_decode_Url),
																													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																														$author$project$Evergreen$V417$Types$w3_unsafe_decode_EncryptionRequests,
																														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																															$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_Model,
																															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																$lamdera$containers$SeqDict$decodeDict$(
																																	$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute),
																																	$author$project$Evergreen$V417$Types$w3_unsafe_decode_EditMessage),
																																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																	$lamdera$containers$SeqDict$decodeDict$(
																																		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
																																		$author$project$Evergreen$V417$Types$w3_unsafe_decode_EditGuildForm),
																																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																		$lamdera$containers$SeqDict$decodeDict$(
																																			$lamdera$codecs$Lamdera$Wire3$decodePair$(
																																				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
																																				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId)),
																																			$author$project$Evergreen$V417$Types$w3_unsafe_decode_EditChannelForm),
																																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																			$lamdera$containers$SeqDict$decodeDict$(
																																				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
																																				$lamdera$codecs$Lamdera$Wire3$decodeBool),
																																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																				$lamdera$codecs$Lamdera$Wire3$decodeString,
																																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																					$lamdera$containers$SeqSet$decodeSet(
																																						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId)),
																																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
																																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																							$author$project$Evergreen$V417$Drawing$w3_unsafe_decode_Model,
																																							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																								$lamdera$containers$SeqDict$decodeDict$(
																																									$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute),
																																									$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString),
																																								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																									$author$project$Evergreen$V417$Scroll$w3_unsafe_decode_ScrollPosition,
																																									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																										$author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_Model,
																																										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																											$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																											$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																																												function (accountDeletionBannerClosed0) {
																																													return function (admin0) {
																																														return function (channelScrollPosition0) {
																																															return function (drafts0) {
																																																return function (drawingMode0) {
																																																	return function (e2eeError0) {
																																																		return function (e2eeKeysOnThisDevice0) {
																																																			return function (e2eePrivateKeyText0) {
																																																				return function (e2eeSectionsExpanded0) {
																																																					return function (editChannelForm0) {
																																																						return function (editGuildForm0) {
																																																							return function (editMessage0) {
																																																								return function (emojiSelector0) {
																																																									return function (encryptionRequests0) {
																																																										return function (externalLinkWarning0) {
																																																											return function (fileDragOverCount0) {
																																																												return function (filesToUpload0) {
																																																													return function (games0) {
																																																														return function (guildIconEditor0) {
																																																															return function (isReloading0) {
																																																																return function (localState0) {
																																																																	return function (messageHover0) {
																																																																		return function (newChannelForm0) {
																																																																			return function (newGuildForm0) {
																																																																				return function (newMessagesWhileNotScrolledToBottom0) {
																																																																					return function (previousTextInputFocus0) {
																																																																						return function (profilePictureEditor0) {
																																																																							return function (replyTo0) {
																																																																								return function (revealedSpoilers0) {
																																																																									return function (searchOverlayQuery0) {
																																																																										return function (searchOverlaySelection0) {
																																																																											return function (showEmojiSelector0) {
																																																																												return function (showFileToUploadInfo0) {
																																																																													return function (showInviteLinkQrCode0) {
																																																																														return function (showNewPrivateKey0) {
																																																																															return function (sidebarMode0) {
																																																																																return function (textEditor0) {
																																																																																	return function (textInputFocus0) {
																																																																																		return function (twoFactor0) {
																																																																																			return function (typedTextCounter0) {
																																																																																				return function (typingDebouncer0) {
																																																																																					return function (userOptions0) {
																																																																																						return function (voiceChat0) {
																																																																																							return {accountDeletionBannerClosed: accountDeletionBannerClosed0, admin: admin0, channelScrollPosition: channelScrollPosition0, drafts: drafts0, drawingMode: drawingMode0, e2eeError: e2eeError0, e2eeKeysOnThisDevice: e2eeKeysOnThisDevice0, e2eePrivateKeyText: e2eePrivateKeyText0, e2eeSectionsExpanded: e2eeSectionsExpanded0, editChannelForm: editChannelForm0, editGuildForm: editGuildForm0, editMessage: editMessage0, emojiSelector: emojiSelector0, encryptionRequests: encryptionRequests0, externalLinkWarning: externalLinkWarning0, fileDragOverCount: fileDragOverCount0, filesToUpload: filesToUpload0, games: games0, guildIconEditor: guildIconEditor0, isReloading: isReloading0, localState: localState0, messageHover: messageHover0, newChannelForm: newChannelForm0, newGuildForm: newGuildForm0, newMessagesWhileNotScrolledToBottom: newMessagesWhileNotScrolledToBottom0, previousTextInputFocus: previousTextInputFocus0, profilePictureEditor: profilePictureEditor0, replyTo: replyTo0, revealedSpoilers: revealedSpoilers0, searchOverlayQuery: searchOverlayQuery0, searchOverlaySelection: searchOverlaySelection0, showEmojiSelector: showEmojiSelector0, showFileToUploadInfo: showFileToUploadInfo0, showInviteLinkQrCode: showInviteLinkQrCode0, showNewPrivateKey: showNewPrivateKey0, sidebarMode: sidebarMode0, textEditor: textEditor0, textInputFocus: textInputFocus0, twoFactor: twoFactor0, typedTextCounter: typedTextCounter0, typingDebouncer: typingDebouncer0, userOptions: userOptions0, voiceChat: voiceChat0};
																																																																																						};
																																																																																					};
																																																																																				};
																																																																																			};
																																																																																		};
																																																																																	};
																																																																																};
																																																																															};
																																																																														};
																																																																													};
																																																																												};
																																																																											};
																																																																										};
																																																																									};
																																																																								};
																																																																							};
																																																																						};
																																																																					};
																																																																				};
																																																																			};
																																																																		};
																																																																	};
																																																																};
																																																															};
																																																														};
																																																													};
																																																												};
																																																											};
																																																										};
																																																									};
																																																								};
																																																							};
																																																						};
																																																					};
																																																				};
																																																			};
																																																		};
																																																	};
																																																};
																																															};
																																														};
																																													};
																																												}))))))))))))))))))))))))))))))))))))))))))));
var $author$project$Evergreen$V417$LoginForm$EnterEmail = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$LoginForm$EnterLoginCode = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$LoginForm$EnterTwoFactorCode = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$LoginForm$EnterUserData = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V417$LoginForm$w3_unsafe_decode_EnterEmail2 = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeBool,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeBool,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (email0, pressedSubmitEmail0, rateLimited0, showSignupsDisabled0, showUserIsDeleted0) {
								return {email: email0, pressedSubmitEmail: pressedSubmitEmail0, rateLimited: rateLimited0, showSignupsDisabled: showSignupsDisabled0, showUserIsDeleted: showUserIsDeleted0};
							})))))));
var $author$project$Evergreen$V417$LoginForm$w3_unsafe_decode_EnterLoginCode2 = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$EmailAddress$w3_unsafe_decode_EmailAddress,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$Evergreen$V417$LoginForm$w3_unsafe_decode_CodeStatus),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (attempts0, code0, sentTo0) {
						return {attempts: attempts0, code: code0, sentTo: sentTo0};
					})))));
var $author$project$Evergreen$V417$LoginForm$w3_unsafe_decode_EnterTwoFactorCode2 = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$Evergreen$V417$LoginForm$w3_unsafe_decode_CodeStatus),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (attemptCount0, attempts0, code0) {
						return {attemptCount: attemptCount0, attempts: attempts0, code: code0};
					})))));
var $author$project$Evergreen$V417$LoginForm$NotSubmitted = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$LoginForm$Submitting = {$: 1};
var $author$project$Evergreen$V417$LoginForm$w3_unsafe_decode_SubmitStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LoginForm$NotSubmitted));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LoginForm$Submitting);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$LoginForm$w3_unsafe_decode_EnterUserData2 = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$LoginForm$w3_unsafe_decode_SubmitStatus,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (name0, pressedSubmit0) {
					return {name: name0, pressedSubmit: pressedSubmit0};
				}))));
var $author$project$Evergreen$V417$LoginForm$w3_unsafe_decode_LoginForm = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$LoginForm$w3_unsafe_decode_EnterEmail2,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LoginForm$EnterEmail));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$LoginForm$w3_unsafe_decode_EnterLoginCode2,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LoginForm$EnterLoginCode));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$LoginForm$w3_unsafe_decode_EnterTwoFactorCode2,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LoginForm$EnterTwoFactorCode));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$LoginForm$w3_unsafe_decode_EnterUserData2,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LoginForm$EnterUserData));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$RecoveryLogin$Model = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$RecoveryLogin$IncorrectPassword = {$: 2};
var $author$project$Evergreen$V417$RecoveryLogin$NotSubmitted = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$RecoveryLogin$Submitting = {$: 1};
var $author$project$Evergreen$V417$RecoveryLogin$w3_unsafe_decode_SubmitStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$RecoveryLogin$IncorrectPassword);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$RecoveryLogin$NotSubmitted));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$RecoveryLogin$Submitting);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$RecoveryLogin$w3_unsafe_decode_Model = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$RecoveryLogin$w3_unsafe_decode_SubmitStatus,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F2(
								function (password0, submitStatus0) {
									return {password: password0, submitStatus: submitStatus0};
								})))),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_LoginStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Types$w3_unsafe_decode_LoggedIn2,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$LoggedIn));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$Evergreen$V417$SecretId$w3_unsafe_decode_SecretId($author$project$Evergreen$V417$Id$w3_unsafe_decode_InviteLinkId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Range$w3_unsafe_decode_Range,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_HtmlId,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Evergreen$V417$Range$w3_unsafe_decode_SelectionDirection,
											$lamdera$codecs$Lamdera$Wire3$succeedDecode(
												F3(
													function (direction0, htmlId0, selection0) {
														return {direction: direction0, htmlId: htmlId0, selection: selection0};
													})))))),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$RecoveryLogin$w3_unsafe_decode_Model,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$LoginForm$w3_unsafe_decode_LoginForm),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F4(
											function (loginForm0, recoveryLogin0, textInputFocus0, useInviteAfterLoggedIn0) {
												return {loginForm: loginForm0, recoveryLogin: recoveryLogin0, textInputFocus: textInputFocus0, useInviteAfterLoggedIn: useInviteAfterLoggedIn0};
											})))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$NotLoggedIn));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Types$LoginWithEmail = 0;
var $author$project$Evergreen$V417$Types$LoginWithRecoveryPassword = 1;
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_LoginType = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$ImageViewer$Dragging = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$ImageViewer$NoInteraction = {$: 0};
var $author$project$Evergreen$V417$ImageViewer$Pinching = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$ImageViewer$w3_unsafe_decode_Interaction = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeFloat,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeFloat,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeFloat,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F4(
											function (offsetStartX0, offsetStartY0, startX0, startY0) {
												return {offsetStartX: offsetStartX0, offsetStartY: offsetStartY0, startX: startX0, startY: startY0};
											})))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageViewer$Dragging));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageViewer$NoInteraction);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeFloat,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeFloat,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeFloat,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F4(
											function (prevMidX0, prevMidY0, startDistance0, startScale0) {
												return {prevMidX: prevMidX0, prevMidY: prevMidY0, startDistance: startDistance0, startScale: startScale0};
											})))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageViewer$Pinching));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$ImageViewer$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeFloat,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeFloat,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeFloat,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeFloat,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeFloat,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeFloat,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeFloat,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeFloat,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Evergreen$V417$ImageViewer$w3_unsafe_decode_Interaction,
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeString,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$author$project$Evergreen$V417$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels),
													$lamdera$codecs$Lamdera$Wire3$succeedDecode(
														function (imageSize0) {
															return function (imageUrl0) {
																return function (interaction0) {
																	return function (offsetX0) {
																		return function (offsetY0) {
																			return function (prevOffsetX0) {
																				return function (prevOffsetY0) {
																					return function (scale0) {
																						return function (targetScale0) {
																							return function (velocityX0) {
																								return function (velocityY0) {
																									return function (zoomFocusX0) {
																										return function (zoomFocusY0) {
																											return {imageSize: imageSize0, imageUrl: imageUrl0, interaction: interaction0, offsetX: offsetX0, offsetY: offsetY0, prevOffsetX: prevOffsetX0, prevOffsetY: prevOffsetY0, scale: scale0, targetScale: targetScale0, velocityX: velocityX0, velocityY: velocityY0, zoomFocusX: zoomFocusX0, zoomFocusY: zoomFocusY0};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														}))))))))))))));
var $author$project$Evergreen$V417$Types$PublicGoMatch_Loaded$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$PublicGoMatch_Loaded = F2($author$project$Evergreen$V417$Types$PublicGoMatch_Loaded$);
var $author$project$Evergreen$V417$Types$PublicGoMatch_Loading = {$: 1};
var $author$project$Evergreen$V417$Types$PublicGoMatch_Missing = {$: 3};
var $author$project$Evergreen$V417$Types$PublicGoMatch_NotLoaded = {$: 0};
var $author$project$Evergreen$V417$Go$w3_unsafe_decode_PublicGoMatchData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Go$w3_unsafe_decode_ValidatedSetup,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$User$w3_unsafe_decode_FrontendUser),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$User$w3_unsafe_decode_FrontendUser,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$Go$w3_unsafe_decode_Shared,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V417$Go$w3_unsafe_decode_ActionWithTime),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (actions0, cache0, creatorUser0, joinedUser0, setup0) {
								return {actions: actions0, cache: cache0, creatorUser: creatorUser0, joinedUser: joinedUser0, setup: setup0};
							})))))));
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_PublicGoMatch = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Go$w3_unsafe_decode_GameModel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Go$w3_unsafe_decode_PublicGoMatchData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PublicGoMatch_Loaded)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PublicGoMatch_Loading);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PublicGoMatch_Missing);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PublicGoMatch_NotLoaded);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Route$AdminRoute = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Route$AiChatRoute = {$: 9};
var $author$project$Evergreen$V417$Route$DiscordDmRoute = function (a) {
	return {$: 6, a: a};
};
var $author$project$Evergreen$V417$Route$DiscordGuildRoute = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V417$Route$DmRoute = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V417$Route$GuildRoute$ = function (a, b, c, d) {
	return {$: 3, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Route$GuildRoute = F4($author$project$Evergreen$V417$Route$GuildRoute$);
var $author$project$Evergreen$V417$Route$HomePageRoute = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Route$LinkDiscord = function (a) {
	return {$: 12, a: a};
};
var $author$project$Evergreen$V417$Route$NewGuildRoute = {$: 2};
var $author$project$Evergreen$V417$Route$PrivacyRoute = {$: 11};
var $author$project$Evergreen$V417$Route$PublicGoMatchRoute = function (a) {
	return {$: 13, a: a};
};
var $author$project$Evergreen$V417$Route$SlackDmRoute = function (a) {
	return {$: 8, a: a};
};
var $author$project$Evergreen$V417$Route$SlackWorkspaceRoute = function (a) {
	return {$: 7, a: a};
};
var $author$project$Evergreen$V417$Route$TextEditorRoute = {$: 10};
var $author$project$Evergreen$V417$Route$ChannelRoute$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Route$ChannelRoute = F3($author$project$Evergreen$V417$Route$ChannelRoute$);
var $author$project$Evergreen$V417$Route$GuildSettingsRoute = {$: 2};
var $author$project$Evergreen$V417$Route$JoinRoute = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V417$Route$NewChannelRoute = {$: 1};
var $author$project$Evergreen$V417$Route$NoThreadWithFriends$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$Route$NoThreadWithFriends = F2($author$project$Evergreen$V417$Route$NoThreadWithFriends$);
var $author$project$Evergreen$V417$Route$ViewThreadWithFriends$ = function (a, b, c) {
	return {$: 1, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Route$ViewThreadWithFriends = F3($author$project$Evergreen$V417$Route$ViewThreadWithFriends$);
var $author$project$Evergreen$V417$Route$HideChannelSettings = 1;
var $author$project$Evergreen$V417$Route$ShowChannelSettings = 0;
var $author$project$Evergreen$V417$Route$w3_unsafe_decode_ShowChannelSettings = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Route$w3_unsafe_decode_ThreadRouteWithFriends = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Route$w3_unsafe_decode_ShowChannelSettings,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Route$NoThreadWithFriends)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Route$w3_unsafe_decode_ShowChannelSettings,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Route$ViewThreadWithFriends))));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Route$w3_unsafe_decode_ChannelRoute = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ChannelHeaderTab),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Route$w3_unsafe_decode_ThreadRouteWithFriends,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Route$ChannelRoute))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Route$GuildSettingsRoute);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$SecretId$w3_unsafe_decode_SecretId($author$project$Evergreen$V417$Id$w3_unsafe_decode_InviteLinkId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Route$JoinRoute));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Route$NewChannelRoute);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Route$ChannelsHiddenOnMobile = 0;
var $author$project$Evergreen$V417$Route$ChannelsVisibleOnMobile = 1;
var $author$project$Evergreen$V417$Route$w3_unsafe_decode_ChannelsVisibleOnMobile = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Route$E2eeInfoOverlay = 0;
var $author$project$Evergreen$V417$Route$SearchOverlay = 2;
var $author$project$Evergreen$V417$Route$UserOptionsOverlay = 1;
var $author$project$Evergreen$V417$Route$w3_unsafe_decode_Overlay = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Route$w3_unsafe_decode_DiscordDmRouteData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
		$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ChannelHeaderTab),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$Route$w3_unsafe_decode_ShowChannelSettings,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Route$w3_unsafe_decode_Overlay),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Route$w3_unsafe_decode_ChannelsVisibleOnMobile,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F7(
									function (channelId0, channelsVisible0, currentDiscordUserId0, overlay0, showMembersTab0, tab0, viewingMessage0) {
										return {channelId: channelId0, channelsVisible: channelsVisible0, currentDiscordUserId: currentDiscordUserId0, overlay: overlay0, showMembersTab: showMembersTab0, tab: tab0, viewingMessage: viewingMessage0};
									})))))))));
var $author$project$Evergreen$V417$Route$DiscordChannel_ChannelRoute$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Route$DiscordChannel_ChannelRoute = F3($author$project$Evergreen$V417$Route$DiscordChannel_ChannelRoute$);
var $author$project$Evergreen$V417$Route$DiscordChannel_GuildSettingsRoute = {$: 2};
var $author$project$Evergreen$V417$Route$DiscordChannel_NewChannelRoute = {$: 1};
var $author$project$Evergreen$V417$Route$w3_unsafe_decode_DiscordChannelRoute = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ChannelHeaderTab),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Route$w3_unsafe_decode_ThreadRouteWithFriends,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Route$DiscordChannel_ChannelRoute))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Route$DiscordChannel_GuildSettingsRoute);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Route$DiscordChannel_NewChannelRoute);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Route$w3_unsafe_decode_DiscordGuildRouteData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Route$w3_unsafe_decode_Overlay),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$Route$w3_unsafe_decode_ChannelsVisibleOnMobile,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Route$w3_unsafe_decode_DiscordChannelRoute,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (channelRoute0, channelsVisible0, currentDiscordUserId0, guildId0, overlay0) {
								return {channelRoute: channelRoute0, channelsVisible: channelsVisible0, currentDiscordUserId: currentDiscordUserId0, guildId: guildId0, overlay: overlay0};
							})))))));
var $author$project$Evergreen$V417$Route$w3_unsafe_decode_DmRouteData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Route$w3_unsafe_decode_ThreadRouteWithFriends,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ChannelHeaderTab),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Route$w3_unsafe_decode_Overlay),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$Route$w3_unsafe_decode_ChannelsVisibleOnMobile,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$DmChannelId$w3_unsafe_decode_DmChannelId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (channelId0, channelsVisible0, overlay0, tab0, threadRoute0) {
								return {channelId: channelId0, channelsVisible: channelsVisible0, overlay: overlay0, tab: tab0, threadRoute: threadRoute0};
							})))))));
var $author$project$Evergreen$V417$Route$LinkDiscordExpired = 0;
var $author$project$Evergreen$V417$Route$LinkDiscordInvalidData = 2;
var $author$project$Evergreen$V417$Route$LinkDiscordLimitReachedError = 3;
var $author$project$Evergreen$V417$Route$LinkDiscordServerError = 1;
var $author$project$Evergreen$V417$Route$w3_unsafe_decode_LinkDiscordError = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Route$w3_unsafe_decode_SlackDmRouteData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMaybeMessage,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Route$w3_unsafe_decode_Overlay),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$Route$w3_unsafe_decode_ChannelsVisibleOnMobile,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_DmChannelId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (channelId0, channelsVisible0, currentSlackUserId0, overlay0, threadRoute0) {
								return {channelId: channelId0, channelsVisible: channelsVisible0, currentSlackUserId: currentSlackUserId0, overlay: overlay0, threadRoute: threadRoute0};
							})))))));
var $author$project$Evergreen$V417$Route$SlackChannel_ChannelRoute$ = function (a, b, c) {
	return {$: 0, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Route$SlackChannel_ChannelRoute = F3($author$project$Evergreen$V417$Route$SlackChannel_ChannelRoute$);
var $author$project$Evergreen$V417$Route$SlackChannel_WorkspaceSettingsRoute = {$: 1};
var $author$project$Evergreen$V417$Route$w3_unsafe_decode_SlackChannelRoute = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Route$w3_unsafe_decode_ShowChannelSettings,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMaybeMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Route$SlackChannel_ChannelRoute))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Route$SlackChannel_WorkspaceSettingsRoute);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Route$w3_unsafe_decode_SlackWorkspaceRouteData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Route$w3_unsafe_decode_Overlay),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$Route$w3_unsafe_decode_ChannelsVisibleOnMobile,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Route$w3_unsafe_decode_SlackChannelRoute,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (channelRoute0, channelsVisible0, currentSlackUserId0, overlay0, teamId0) {
								return {channelRoute: channelRoute0, channelsVisible: channelsVisible0, currentSlackUserId: currentSlackUserId0, overlay: overlay0, teamId: teamId0};
							})))))));
var $author$project$Evergreen$V417$SafeJson$JsonArray = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V417$SafeJson$JsonBool = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$SafeJson$JsonNull = {$: 5};
var $author$project$Evergreen$V417$SafeJson$JsonNumber = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$SafeJson$JsonObject = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V417$SafeJson$JsonString = function (a) {
	return {$: 0, a: a};
};
function $author$project$Evergreen$V417$SafeJson$cyclic$w3_unsafe_decode_SafeJson() {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeList(
							$author$project$Evergreen$V417$SafeJson$cyclic$w3_unsafe_decode_SafeJson()),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SafeJson$JsonArray));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SafeJson$JsonBool));
				case 2:
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SafeJson$JsonNull);
				case 3:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$SafeFloat$w3_unsafe_decode_SafeFloat,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SafeJson$JsonNumber));
				case 4:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeDict$(
							$lamdera$codecs$Lamdera$Wire3$decodeString,
							$author$project$Evergreen$V417$SafeJson$cyclic$w3_unsafe_decode_SafeJson()),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SafeJson$JsonObject));
				case 5:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SafeJson$JsonString));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
}
var $author$project$Evergreen$V417$SafeJson$w3_unsafe_decode_SafeJson = $author$project$Evergreen$V417$SafeJson$cyclic$w3_unsafe_decode_SafeJson();
$author$project$Evergreen$V417$SafeJson$cyclic$w3_unsafe_decode_SafeJson = function () {
	return $author$project$Evergreen$V417$SafeJson$w3_unsafe_decode_SafeJson;
};
var $author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserAuth = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$SafeJson$w3_unsafe_decode_SafeJson,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (token0, userAgent0, xSuperProperties0) {
						return {token: token0, userAgent: userAgent0, xSuperProperties: xSuperProperties0};
					})))));
var $author$project$Evergreen$V417$Route$w3_unsafe_decode_Route = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Pagination$w3_unsafe_decode_ItemId)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							function (highlightLog0) {
								return {highlightLog: highlightLog0};
							})),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Route$AdminRoute));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Route$AiChatRoute);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Route$w3_unsafe_decode_DiscordDmRouteData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Route$DiscordDmRoute));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Route$w3_unsafe_decode_DiscordGuildRouteData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Route$DiscordGuildRoute));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Route$w3_unsafe_decode_DmRouteData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Route$DmRoute));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Route$w3_unsafe_decode_Overlay),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Route$w3_unsafe_decode_ChannelsVisibleOnMobile,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Route$w3_unsafe_decode_ChannelRoute,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Route$GuildRoute)))));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Route$w3_unsafe_decode_Overlay),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Route$HomePageRoute));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($author$project$Evergreen$V417$Route$w3_unsafe_decode_LinkDiscordError, $author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserAuth),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Route$LinkDiscord));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Route$NewGuildRoute);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Route$PrivacyRoute);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$SecretId$w3_unsafe_decode_SecretId($author$project$Evergreen$V417$Id$w3_unsafe_decode_GamePublicId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Route$PublicGoMatchRoute));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Route$w3_unsafe_decode_SlackDmRouteData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Route$SlackDmRoute));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Route$w3_unsafe_decode_SlackWorkspaceRouteData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Route$SlackWorkspaceRoute));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Route$TextEditorRoute);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Audio$File = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Audio$BufferId = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Audio$w3_unsafe_decode_BufferId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Audio$w3_unsafe_decode_Source = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Audio$w3_unsafe_decode_BufferId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						function (bufferId0) {
							return {bufferId: bufferId0};
						})),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Ports$Denied = 1;
var $author$project$Evergreen$V417$Ports$Granted = 2;
var $author$project$Evergreen$V417$Ports$NotAsked = 0;
var $author$project$Evergreen$V417$Ports$Unsupported = 3;
var $author$project$Evergreen$V417$Ports$w3_unsafe_decode_NotificationPermission = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Ports$BrowserView = 1;
var $author$project$Evergreen$V417$Ports$InstalledPwa = 0;
var $author$project$Evergreen$V417$Ports$w3_unsafe_decode_PwaStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Ports$w3_unsafe_decode_StartupData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$UserAgent$w3_unsafe_decode_UserAgent,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$elm$time$Time$w3_unsafe_decode_Zone,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			A2(
				$lamdera$codecs$Lamdera$Wire3$andThenDecode,
				function (t) {
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
						$elm$time$Time$millisToPosix(t));
				},
				$lamdera$codecs$Lamdera$Wire3$decodeInt),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeInt),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Ports$w3_unsafe_decode_PwaStatus,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Ports$w3_unsafe_decode_NotificationPermission,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										A2(
											$lamdera$codecs$Lamdera$Wire3$andThenDecode,
											function (t) {
												return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
													$elm$time$Time$millisToPosix(t));
											},
											$lamdera$codecs$Lamdera$Wire3$decodeInt),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeList(
												$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId)),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeFloat,
												$lamdera$codecs$Lamdera$Wire3$succeedDecode(
													function (devicePixelRatio0) {
														return function (e2eeKeys0) {
															return function (loadStartupDataTime0) {
																return function (notificationPermission0) {
																	return function (pwaStatus0) {
																		return function (randomSeed0) {
																			return function (safeAreaInsetBottom0) {
																				return function (safeAreaInsetTop0) {
																					return function (scrollbarWidth0) {
																						return function (timeOrigin0) {
																							return function (timezone0) {
																								return function (userAgent0) {
																									return {devicePixelRatio: devicePixelRatio0, e2eeKeys: e2eeKeys0, loadStartupDataTime: loadStartupDataTime0, notificationPermission: notificationPermission0, pwaStatus: pwaStatus0, randomSeed: randomSeed0, safeAreaInsetBottom: safeAreaInsetBottom0, safeAreaInsetTop: safeAreaInsetTop0, scrollbarWidth: scrollbarWidth0, timeOrigin: timeOrigin0, timezone: timezone0, userAgent: userAgent0};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													})))))))))))));
var $author$project$Evergreen$V417$Internal$Model2$State = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Internal$Model2$w3_unsafe_decode_State = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeString),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeSet($lamdera$codecs$Lamdera$Wire3$decodeString),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F3(
									function (added0, keyframes0, rules0) {
										return {added: added0, keyframes: keyframes0, rules: rules0};
									}))))),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Ui$Anim$w3_unsafe_decode_State = $author$project$Evergreen$V417$Internal$Model2$w3_unsafe_decode_State;
var $author$project$Evergreen$V417$Types$AdminToFrontend = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V417$Types$AiChatToFrontend = function (a) {
	return {$: 9, a: a};
};
var $author$project$Evergreen$V417$Types$ChangeBroadcast = function (a) {
	return {$: 7, a: a};
};
var $author$project$Evergreen$V417$Types$CheckLoginResponse$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$CheckLoginResponse = F2($author$project$Evergreen$V417$Types$CheckLoginResponse$);
var $author$project$Evergreen$V417$Types$ExportChannelResponse = function (a) {
	return {$: 16, a: a};
};
var $author$project$Evergreen$V417$Types$GetLoginTokenRateLimited = {$: 2};
var $author$project$Evergreen$V417$Types$GetPublicGoMatchResponse = function (a) {
	return {$: 15, a: a};
};
var $author$project$Evergreen$V417$Types$ImportChannelResponse$ = function (a, b) {
	return {$: 17, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$ImportChannelResponse = F2($author$project$Evergreen$V417$Types$ImportChannelResponse$);
var $author$project$Evergreen$V417$Types$LinkDiscordResponse = function (a) {
	return {$: 12, a: a};
};
var $author$project$Evergreen$V417$Types$LinkSlackResponse = function (a) {
	return {$: 13, a: a};
};
var $author$project$Evergreen$V417$Types$LocalChangeResponse$ = function (a, b) {
	return {$: 6, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$LocalChangeResponse = F2($author$project$Evergreen$V417$Types$LocalChangeResponse$);
var $author$project$Evergreen$V417$Types$LoggedOutSession = {$: 4};
var $author$project$Evergreen$V417$Types$LoginWithTokenResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Types$ProfilePictureEditorToFrontend = function (a) {
	return {$: 14, a: a};
};
var $author$project$Evergreen$V417$Types$ReloadDataResponse = function (a) {
	return {$: 11, a: a};
};
var $author$project$Evergreen$V417$Types$SignupsDisabledResponse = {$: 3};
var $author$project$Evergreen$V417$Types$TwoFactorAuthenticationToFrontend = function (a) {
	return {$: 8, a: a};
};
var $author$project$Evergreen$V417$Types$YouConnected = function (a) {
	return {$: 10, a: a};
};
var $author$project$Evergreen$V417$Types$LinkDiscordHttpError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Types$LinkDiscordLimitReached = {$: 1};
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_LinkDiscordFailure = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$LinkDiscordHttpError));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$LinkDiscordLimitReached);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Types$IsAdminButNoData = {$: 1};
var $author$project$Evergreen$V417$Types$IsAdminLoginData = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Types$IsNotAdminLoginData = {$: 2};
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_AdminStatusLoginData = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$IsAdminButNoData);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_InitAdminData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$IsAdminLoginData));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$IsNotAdminLoginData);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_LoginData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Evergreen$V417$Call$w3_unsafe_decode_CallId,
		$author$project$Evergreen$V417$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
			$lamdera$codecs$Lamdera$Wire3$decodePair$(
				$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
				$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId),
			$author$project$Evergreen$V417$Call$w3_unsafe_decode_RemoteCallData)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$User$w3_unsafe_decode_FrontendCurrentUser,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$TextEditor$w3_unsafe_decode_LocalState,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_StickerId),
						$author$project$Evergreen$V417$Sticker$w3_unsafe_decode_StickerData),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
							$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_SlackFrontendWorkspace),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqSet$decodeSet(
								$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId)),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqDict$decodeDict$(
									$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
									$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_SlackFrontendUser),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$containers$SeqDict$decodeDict$(
										$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_DmChannelId),
										$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_SlackFrontendDmChannel),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_UserSession,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeString,
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$containers$SeqDict$decodeDict$(
													$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
													$author$project$Evergreen$V417$User$w3_unsafe_decode_FrontendUser),
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V417$SessionIdHash$w3_unsafe_decode_SessionIdHash, $author$project$Evergreen$V417$UserSession$w3_unsafe_decode_FrontendUserSession),
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$lamdera$containers$SeqDict$decodeDict$(
															$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
															$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId)),
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$lamdera$containers$SeqDict$decodeDict$(
																$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
																$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_FrontendGuild),
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$lamdera$containers$SeqDict$decodeDict$(
																	$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
																	$author$project$Evergreen$V417$DmChannel$w3_unsafe_decode_FrontendDmChannel),
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$author$project$Evergreen$V417$LinkedAndOtherDiscordUsers$w3_unsafe_decode_LinkedAndOtherDiscordUsers,
																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																		$lamdera$containers$SeqDict$decodeDict$(
																			$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
																			$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_DiscordFrontendGuild),
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$containers$SeqDict$decodeDict$(
																				$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
																				$author$project$Evergreen$V417$DmChannel$w3_unsafe_decode_DiscordFrontendDmChannel),
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$lamdera$containers$SeqDict$decodeDict$(
																					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_CustomEmojiId),
																					$author$project$Evergreen$V417$CustomEmoji$w3_unsafe_decode_CustomEmojiData),
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_Viewing,
																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																						$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V417$Call$w3_unsafe_decode_CallId, $author$project$Evergreen$V417$Call$w3_unsafe_decode_RecordingStatus),
																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																							$author$project$Evergreen$V417$Types$w3_unsafe_decode_AdminStatusLoginData,
																							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																								function (adminData0) {
																									return function (callRecordings0) {
																										return function (currentlyViewing0) {
																											return function (customEmojis0) {
																												return function (discordDmChannels0) {
																													return function (discordGuilds0) {
																														return function (discordUsers0) {
																															return function (dmChannels0) {
																																return function (guilds0) {
																																	return function (linkedSlackUsers0) {
																																		return function (otherSessions0) {
																																			return function (otherUsers0) {
																																				return function (publicVapidKey0) {
																																					return function (session0) {
																																						return function (slackDmChannels0) {
																																							return function (slackUsers0) {
																																								return function (slackUsersNeedingAuth0) {
																																									return function (slackWorkspaces0) {
																																										return function (stickers0) {
																																											return function (textEditor0) {
																																												return function (twoFactorAuthenticationEnabled0) {
																																													return function (user0) {
																																														return function (voiceChatPeers0) {
																																															return {adminData: adminData0, callRecordings: callRecordings0, currentlyViewing: currentlyViewing0, customEmojis: customEmojis0, discordDmChannels: discordDmChannels0, discordGuilds: discordGuilds0, discordUsers: discordUsers0, dmChannels: dmChannels0, guilds: guilds0, linkedSlackUsers: linkedSlackUsers0, otherSessions: otherSessions0, otherUsers: otherUsers0, publicVapidKey: publicVapidKey0, session: session0, slackDmChannels: slackDmChannels0, slackUsers: slackUsers0, slackUsersNeedingAuth: slackUsersNeedingAuth0, slackWorkspaces: slackWorkspaces0, stickers: stickers0, textEditor: textEditor0, twoFactorAuthenticationEnabled: twoFactorAuthenticationEnabled0, user: user0, voiceChatPeers: voiceChatPeers0};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								}))))))))))))))))))))))));
var $author$project$Evergreen$V417$Types$LoginSuccess = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Types$LoginTokenInvalid = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Types$NeedsAccountSetup = {$: 3};
var $author$project$Evergreen$V417$Types$NeedsTwoFactorToken = {$: 2};
var $author$project$Evergreen$V417$Types$RecoveryPasswordInvalid = {$: 4};
var $author$project$Evergreen$V417$Types$UserIsDeleted = {$: 5};
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_LoginResult = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Types$w3_unsafe_decode_LoginData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$LoginSuccess));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$LoginTokenInvalid));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$NeedsAccountSetup);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$NeedsTwoFactorToken);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$RecoveryPasswordInvalid);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$UserIsDeleted);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Go$w3_unsafe_decode_PublicGoMatchResponse = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Go$w3_unsafe_decode_ValidatedSetup,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$User$w3_unsafe_decode_FrontendUser),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$User$w3_unsafe_decode_FrontendUser,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V417$Go$w3_unsafe_decode_ActionWithTime),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (actions0, creatorUser0, joinedUser0, setup0) {
							return {actions: actions0, creatorUser: creatorUser0, joinedUser: joinedUser0, setup: setup0};
						}))))));
var $author$project$Evergreen$V417$AiChat$AiMessageResponse$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$AiChat$AiMessageResponse = F2($author$project$Evergreen$V417$AiChat$AiMessageResponse$);
var $author$project$Evergreen$V417$AiChat$w3_unsafe_decode_AiResponse = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeString),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeFloat),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (content0, cost0, images0, reasoning0) {
							return {content: content0, cost: cost0, images: images0, reasoning: reasoning0};
						}))))));
var $author$project$Evergreen$V417$AiChat$w3_unsafe_decode_ToFrontend = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Http$w3_unsafe_decode_Error, $author$project$Evergreen$V417$AiChat$w3_unsafe_decode_AiResponse),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$AiChat$w3_unsafe_decode_ResponseId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$AiChat$AiMessageResponse)));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$ImageEditor$ChangeGuildIconResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$ImageEditor$ChangeUserAvatarResponse = {$: 0};
var $author$project$Evergreen$V417$ImageEditor$w3_unsafe_decode_ToFrontend = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageEditor$ChangeGuildIconResponse));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageEditor$ChangeUserAvatarResponse);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Pages$Admin$DownloadLastBackupChunk$ = function (a, b, c) {
	return {$: 4, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Pages$Admin$DownloadLastBackupChunk = F3($author$project$Evergreen$V417$Pages$Admin$DownloadLastBackupChunk$);
var $author$project$Evergreen$V417$Pages$Admin$ExportBackendFinished = {$: 3};
var $author$project$Evergreen$V417$Pages$Admin$ExportBackendProgress$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V417$Pages$Admin$ExportBackendProgress = F2($author$project$Evergreen$V417$Pages$Admin$ExportBackendProgress$);
var $author$project$Evergreen$V417$Pages$Admin$ImportBackendChunkReceived = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$ImportBackendResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$ExportAll = {$: 1};
var $author$project$Evergreen$V417$Pages$Admin$ExportSubset = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_ExportSubset = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$ExportAll);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_ExportSubsetSelection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$ExportSubset));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_ToFrontend = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBytes,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$LocalState$w3_unsafe_decode_BackupContents,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$DownloadLastBackupChunk))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$ExportBackendFinished);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_ExportProgress,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_ExportSubset,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$ExportBackendProgress)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$ImportBackendChunkReceived));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $lamdera$codecs$Lamdera$Wire3$decodeUnit),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$ImportBackendResponse));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$TwoFactorAuthentication$ConfirmTwoFactorAuthenticationResponse$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V417$TwoFactorAuthentication$ConfirmTwoFactorAuthenticationResponse = F2($author$project$Evergreen$V417$TwoFactorAuthentication$ConfirmTwoFactorAuthenticationResponse$);
var $author$project$Evergreen$V417$TwoFactorAuthentication$DisableTwoFactorAuthenticationResponse$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V417$TwoFactorAuthentication$DisableTwoFactorAuthenticationResponse = F2($author$project$Evergreen$V417$TwoFactorAuthentication$DisableTwoFactorAuthenticationResponse$);
var $author$project$Evergreen$V417$TwoFactorAuthentication$EnableTwoFactorAuthenticationResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$TwoFactorAuthentication$w3_unsafe_decode_ToFrontend = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$TwoFactorAuthentication$ConfirmTwoFactorAuthenticationResponse)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$TwoFactorAuthentication$DisableTwoFactorAuthenticationResponse)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							function (qrCodeUrl0) {
								return {qrCodeUrl: qrCodeUrl0};
							})),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$TwoFactorAuthentication$EnableTwoFactorAuthenticationResponse));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_ToFrontend = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_ToFrontend,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$AdminToFrontend));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$AiChat$w3_unsafe_decode_ToFrontend,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$AiChatToFrontend));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Types$w3_unsafe_decode_LocalMsg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$ChangeBroadcast));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $author$project$Evergreen$V417$Types$w3_unsafe_decode_LoginData),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Types$w3_unsafe_decode_LoginType,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$CheckLoginResponse)));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeString,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (fileName0, json0) {
										return {fileName: fileName0, json: json0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$ExportChannelResponse));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$GetLoginTokenRateLimited);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $author$project$Evergreen$V417$Go$w3_unsafe_decode_PublicGoMatchResponse),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$GetPublicGoMatchResponse));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$(
						$author$project$Evergreen$V417$Types$w3_unsafe_decode_ImportChannelError,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								function (encryptedMessages0) {
									return {encryptedMessages: encryptedMessages0};
								}))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$ImportChannelResponse)));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($author$project$Evergreen$V417$Types$w3_unsafe_decode_LinkDiscordFailure, $lamdera$codecs$Lamdera$Wire3$decodeUnit),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$LinkDiscordResponse));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Types$w3_unsafe_decode_LinkSlackResult,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$LinkSlackResponse));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Types$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Local$w3_unsafe_decode_ChangeId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$LocalChangeResponse)));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$LoggedOutSession);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Types$w3_unsafe_decode_LoginResult,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$LoginWithTokenResponse));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$ImageEditor$w3_unsafe_decode_ToFrontend,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$ProfilePictureEditorToFrontend));
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $author$project$Evergreen$V417$Types$w3_unsafe_decode_LoginData),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$ReloadDataResponse));
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$SignupsDisabledResponse);
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$TwoFactorAuthentication$w3_unsafe_decode_ToFrontend,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$TwoFactorAuthenticationToFrontend));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$YouConnected));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_LoadedFrontend = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V417$Types$w3_unsafe_decode_ToFrontend)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Zone,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Ports$w3_unsafe_decode_StartupData,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Route$w3_unsafe_decode_Route,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V417$Types$w3_unsafe_decode_PublicGoMatch,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeResult$($author$project$Evergreen$V417$Audio$w3_unsafe_decode_LoadError, $author$project$Evergreen$V417$Audio$w3_unsafe_decode_Source),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeBool,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$program_test$Effect$Browser$Navigation$w3_unsafe_decode_Key,
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$author$project$Evergreen$V417$Types$w3_unsafe_decode_LoginType,
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$author$project$Evergreen$V417$Types$w3_unsafe_decode_LoginStatus,
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$MyUi$w3_unsafe_decode_LastCopy),
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$ImageViewer$w3_unsafe_decode_Model),
																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$codecs$Lamdera$Wire3$decodeBool,
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$lamdera$codecs$Lamdera$Wire3$decodeInt,
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
																					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																						F3(
																							function (changedAt0, index0, rotate0) {
																								return {changedAt: changedAt0, index: index0, rotate: rotate0};
																							}))))),
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Emoji$w3_unsafe_decode_CachedEmojiData),
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$author$project$Evergreen$V417$Ui$Anim$w3_unsafe_decode_State,
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$author$project$Evergreen$V417$Touch$w3_unsafe_decode_Drag,
																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																						$author$project$Evergreen$V417$Touch$w3_unsafe_decode_Drag,
																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																							$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId,
																							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																								$author$project$Evergreen$V417$AiChat$w3_unsafe_decode_FrontendModel,
																								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																									function (aiChatModel0) {
																										return function (clientId0) {
																											return function (drag0) {
																												return function (dragPrevious0) {
																													return function (elmUiState0) {
																														return function (emojiData0) {
																															return function (homePagePreview0) {
																																return function (imageViewer0) {
																																	return function (lastCopied0) {
																																		return function (loginStatus0) {
																																			return function (loginType0) {
																																				return function (navigationKey0) {
																																					return function (pageHasFocus0) {
																																						return function (popSound0) {
																																							return function (publicGoMatch0) {
																																								return function (route0) {
																																									return function (startupData0) {
																																										return function (time0) {
																																											return function (timezone0) {
																																												return function (toFrontendLogs0) {
																																													return function (versionNumber0) {
																																														return function (visualViewportHeight0) {
																																															return function (visualViewportTop0) {
																																																return function (windowSize0) {
																																																	return {aiChatModel: aiChatModel0, clientId: clientId0, drag: drag0, dragPrevious: dragPrevious0, elmUiState: elmUiState0, emojiData: emojiData0, homePagePreview: homePagePreview0, imageViewer: imageViewer0, lastCopied: lastCopied0, loginStatus: loginStatus0, loginType: loginType0, navigationKey: navigationKey0, pageHasFocus: pageHasFocus0, popSound: popSound0, publicGoMatch: publicGoMatch0, route: route0, startupData: startupData0, time: time0, timezone: timezone0, toFrontendLogs: toFrontendLogs0, versionNumber: versionNumber0, visualViewportHeight: visualViewportHeight0, visualViewportTop: visualViewportTop0, windowSize: windowSize0};
																																																};
																																															};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									})))))))))))))))))))))))));
var $author$project$Evergreen$V417$Types$LoadError = {$: 2};
var $author$project$Evergreen$V417$Types$LoadSuccess = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Types$LoadingData = {$: 0};
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_LoadStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$LoadError);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Types$w3_unsafe_decode_LoginData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$LoadSuccess));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$LoadingData);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_LoadingFrontend = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Ports$w3_unsafe_decode_StartupData),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V417$Route$w3_unsafe_decode_Route,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Types$w3_unsafe_decode_PublicGoMatch,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeResult$($author$project$Evergreen$V417$Audio$w3_unsafe_decode_LoadError, $author$project$Evergreen$V417$Audio$w3_unsafe_decode_Source),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Browser$Navigation$w3_unsafe_decode_Key,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Types$w3_unsafe_decode_LoginType,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Types$w3_unsafe_decode_LoadStatus,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId),
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											function (clientId0) {
												return function (loginStatus0) {
													return function (loginType0) {
														return function (navigationKey0) {
															return function (popSound0) {
																return function (publicGoMatch0) {
																	return function (route0) {
																		return function (startupData0) {
																			return function (time0) {
																				return function (windowSize0) {
																					return {clientId: clientId0, loginStatus: loginStatus0, loginType: loginType0, navigationKey: navigationKey0, popSound: popSound0, publicGoMatch: publicGoMatch0, route: route0, startupData: startupData0, time: time0, windowSize: windowSize0};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											})))))))))));
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_FrontendModel_ = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Types$w3_unsafe_decode_LoadedFrontend,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Loaded));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Types$w3_unsafe_decode_LoadingFrontend,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$Loading));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Types$AdminPageMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Evergreen$V417$Types$AiChatMsg = function (a) {
	return {$: 76, a: a};
};
var $author$project$Evergreen$V417$Types$ChannelSidebarAnimated = function (a) {
	return {$: 54, a: a};
};
var $author$project$Evergreen$V417$Types$CheckMessageAltPress$ = function (a, b, c, d, e, f, g) {
	return {$: 71, a: a, b: b, c: c, d: d, e: e, f: f, g: g};
};
var $author$project$Evergreen$V417$Types$CheckMessageAltPress = F7($author$project$Evergreen$V417$Types$CheckMessageAltPress$);
var $author$project$Evergreen$V417$Types$CheckedNotificationPermission = function (a) {
	return {$: 49, a: a};
};
var $author$project$Evergreen$V417$Types$CheckedSheepGameQuestionsDebounce$ = function (a, b) {
	return {$: 79, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$CheckedSheepGameQuestionsDebounce = F2($author$project$Evergreen$V417$Types$CheckedSheepGameQuestionsDebounce$);
var $author$project$Evergreen$V417$Types$CheckedSheepGameSaveDebounce$ = function (a, b, c, d) {
	return {$: 78, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$CheckedSheepGameSaveDebounce = F4($author$project$Evergreen$V417$Types$CheckedSheepGameSaveDebounce$);
var $author$project$Evergreen$V417$Types$DebouncedTyping = {$: 37};
var $author$project$Evergreen$V417$Types$DomFocusChanged = function (a) {
	return {$: 153, a: a};
};
var $author$project$Evergreen$V417$Types$DrawingMsg = function (a) {
	return {$: 164, a: a};
};
var $author$project$Evergreen$V417$Types$EditChannelFormChanged$ = function (a, b, c) {
	return {$: 16, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$EditChannelFormChanged = F3($author$project$Evergreen$V417$Types$EditChannelFormChanged$);
var $author$project$Evergreen$V417$Types$EditGuildFormChanged$ = function (a, b) {
	return {$: 20, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$EditGuildFormChanged = F2($author$project$Evergreen$V417$Types$EditGuildFormChanged$);
var $author$project$Evergreen$V417$Types$EditMessage_GotFileHashName$ = function (a, b, c, d) {
	return {$: 94, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$EditMessage_GotFileHashName = F4($author$project$Evergreen$V417$Types$EditMessage_GotFileHashName$);
var $author$project$Evergreen$V417$Types$EditMessage_MessageInputMsg$ = function (a, b, c) {
	return {$: 146, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$EditMessage_MessageInputMsg = F3($author$project$Evergreen$V417$Types$EditMessage_MessageInputMsg$);
var $author$project$Evergreen$V417$Types$EditMessage_PressedDeleteAttachedFile$ = function (a, b) {
	return {$: 90, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$EditMessage_PressedDeleteAttachedFile = F2($author$project$Evergreen$V417$Types$EditMessage_PressedDeleteAttachedFile$);
var $author$project$Evergreen$V417$Types$EditMessage_PressedToggleAttachedFileSpoiler$ = function (a, b) {
	return {$: 92, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$EditMessage_PressedToggleAttachedFileSpoiler = F2($author$project$Evergreen$V417$Types$EditMessage_PressedToggleAttachedFileSpoiler$);
var $author$project$Evergreen$V417$Types$EditMessage_PressedViewAttachedFileInfo$ = function (a, b) {
	return {$: 91, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$EditMessage_PressedViewAttachedFileInfo = F2($author$project$Evergreen$V417$Types$EditMessage_PressedViewAttachedFileInfo$);
var $author$project$Evergreen$V417$Types$EditMessage_SelectedFilesToAttach$ = function (a, b, c) {
	return {$: 93, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$EditMessage_SelectedFilesToAttach = F3($author$project$Evergreen$V417$Types$EditMessage_SelectedFilesToAttach$);
var $author$project$Evergreen$V417$Types$ElmUiMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Evergreen$V417$Types$EmojiSelectorMsg = function (a) {
	return {$: 45, a: a};
};
var $author$project$Evergreen$V417$Types$EnableToFrontendLogging = {$: 151};
var $author$project$Evergreen$V417$Types$EncryptionFromJs = function (a) {
	return {$: 186, a: a};
};
var $author$project$Evergreen$V417$Types$FileDragEnter = function (a) {
	return {$: 158, a: a};
};
var $author$project$Evergreen$V417$Types$FileDragLeave = {$: 159};
var $author$project$Evergreen$V417$Types$FileDropped = function (a) {
	return {$: 160, a: a};
};
var $author$project$Evergreen$V417$Types$FileUploadProgress$ = function (a, b, c) {
	return {$: 95, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$FileUploadProgress = F3($author$project$Evergreen$V417$Types$FileUploadProgress$);
var $author$project$Evergreen$V417$Types$FrontendNoOp = {$: 32};
var $author$project$Evergreen$V417$Types$GameMsg = function (a) {
	return {$: 77, a: a};
};
var $author$project$Evergreen$V417$Types$GoSpectatorMsg = function (a) {
	return {$: 80, a: a};
};
var $author$project$Evergreen$V417$Types$GotDevicePixelRatio = function (a) {
	return {$: 109, a: a};
};
var $author$project$Evergreen$V417$Types$GotEmojiData = function (a) {
	return {$: 148, a: a};
};
var $author$project$Evergreen$V417$Types$GotFileHashName$ = function (a, b, c, d) {
	return {$: 86, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$GotFileHashName = F4($author$project$Evergreen$V417$Types$GotFileHashName$);
var $author$project$Evergreen$V417$Types$GotFileToEncrypt$ = function (a, b, c, d) {
	return {$: 85, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$GotFileToEncrypt = F4($author$project$Evergreen$V417$Types$GotFileToEncrypt$);
var $author$project$Evergreen$V417$Types$GotImportChannelFile$ = function (a, b) {
	return {$: 26, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$GotImportChannelFile = F2($author$project$Evergreen$V417$Types$GotImportChannelFile$);
var $author$project$Evergreen$V417$Types$GotPingUserPosition$ = function (a, b) {
	return {$: 38, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$GotPingUserPosition = F2($author$project$Evergreen$V417$Types$GotPingUserPosition$);
var $author$project$Evergreen$V417$Types$GotPositionForEmojiSelector_EditMessage = function (a) {
	return {$: 149, a: a};
};
var $author$project$Evergreen$V417$Types$GotPositionForEmojiSelector_SheepGameInput$ = function (a, b) {
	return {$: 150, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$GotPositionForEmojiSelector_SheepGameInput = F2($author$project$Evergreen$V417$Types$GotPositionForEmojiSelector_SheepGameInput$);
var $author$project$Evergreen$V417$Types$GotRegisterPushSubscription = function (a) {
	return {$: 98, a: a};
};
var $author$project$Evergreen$V417$Types$GotServiceWorkerData = function (a) {
	return {$: 163, a: a};
};
var $author$project$Evergreen$V417$Types$GotServiceWorkerMessage = function (a) {
	return {$: 124, a: a};
};
var $author$project$Evergreen$V417$Types$GotStartupData = function (a) {
	return {$: 108, a: a};
};
var $author$project$Evergreen$V417$Types$GotTime = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$Types$GotVersionNumber = function (a) {
	return {$: 135, a: a};
};
var $author$project$Evergreen$V417$Types$GotVoiceChatSignalFromJs = function (a) {
	return {$: 155, a: a};
};
var $author$project$Evergreen$V417$Types$GotWindowSize$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$GotWindowSize = F2($author$project$Evergreen$V417$Types$GotWindowSize$);
var $author$project$Evergreen$V417$Types$GuildIconEditorMsg$ = function (a, b) {
	return {$: 83, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$GuildIconEditorMsg = F2($author$project$Evergreen$V417$Types$GuildIconEditorMsg$);
var $author$project$Evergreen$V417$Types$ImageViewerMsg = function (a) {
	return {$: 97, a: a};
};
var $author$project$Evergreen$V417$Types$KeyDown = function (a) {
	return {$: 41, a: a};
};
var $author$project$Evergreen$V417$Types$LoadedPopSound = function (a) {
	return {$: 166, a: a};
};
var $author$project$Evergreen$V417$Types$LoginFormMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V417$Types$MessageInputMsg$ = function (a, b, c) {
	return {$: 147, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$MessageInputMsg = F3($author$project$Evergreen$V417$Types$MessageInputMsg$);
var $author$project$Evergreen$V417$Types$MessageMenuAnimated = function (a) {
	return {$: 55, a: a};
};
var $author$project$Evergreen$V417$Types$MessageMenu_PressedAddCustomEmojisToUser = function (a) {
	return {$: 64, a: a};
};
var $author$project$Evergreen$V417$Types$MessageMenu_PressedClose = {$: 68};
var $author$project$Evergreen$V417$Types$MessageMenu_PressedContainer = {$: 69};
var $author$project$Evergreen$V417$Types$MessageMenu_PressedDeleteMessage$ = function (a, b) {
	return {$: 62, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$MessageMenu_PressedDeleteMessage = F2($author$project$Evergreen$V417$Types$MessageMenu_PressedDeleteMessage$);
var $author$project$Evergreen$V417$Types$MessageMenu_PressedEditMessage$ = function (a, b) {
	return {$: 44, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$MessageMenu_PressedEditMessage = F2($author$project$Evergreen$V417$Types$MessageMenu_PressedEditMessage$);
var $author$project$Evergreen$V417$Types$MessageMenu_PressedMarkAsUnread$ = function (a, b) {
	return {$: 63, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$MessageMenu_PressedMarkAsUnread = F2($author$project$Evergreen$V417$Types$MessageMenu_PressedMarkAsUnread$);
var $author$project$Evergreen$V417$Types$MessageMenu_PressedOpenDiscordDm$ = function (a, b) {
	return {$: 66, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$MessageMenu_PressedOpenDiscordDm = F2($author$project$Evergreen$V417$Types$MessageMenu_PressedOpenDiscordDm$);
var $author$project$Evergreen$V417$Types$MessageMenu_PressedOpenDm = function (a) {
	return {$: 65, a: a};
};
var $author$project$Evergreen$V417$Types$MessageMenu_PressedOpenThread = function (a) {
	return {$: 47, a: a};
};
var $author$project$Evergreen$V417$Types$MessageMenu_PressedReactionEmoji = function (a) {
	return {$: 43, a: a};
};
var $author$project$Evergreen$V417$Types$MessageMenu_PressedReply = function (a) {
	return {$: 46, a: a};
};
var $author$project$Evergreen$V417$Types$MessageMenu_PressedShowReactionEmojiSelector$ = function (a, b, c) {
	return {$: 42, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$MessageMenu_PressedShowReactionEmojiSelector = F3($author$project$Evergreen$V417$Types$MessageMenu_PressedShowReactionEmojiSelector$);
var $author$project$Evergreen$V417$Types$MessageViewMsg$ = function (a, b, c) {
	return {$: 96, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$MessageViewMsg = F3($author$project$Evergreen$V417$Types$MessageViewMsg$);
var $author$project$Evergreen$V417$Types$NewChannelFormChanged$ = function (a, b) {
	return {$: 14, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$NewChannelFormChanged = F2($author$project$Evergreen$V417$Types$NewChannelFormChanged$);
var $author$project$Evergreen$V417$Types$NewGuildFormChanged = function (a) {
	return {$: 35, a: a};
};
var $author$project$Evergreen$V417$Types$OneFrameAfterDragEnd = {$: 84};
var $author$project$Evergreen$V417$Types$PageFocusSettled = {$: 123};
var $author$project$Evergreen$V417$Types$PageHasFocusChanged = function (a) {
	return {$: 122, a: a};
};
var $author$project$Evergreen$V417$Types$PageUpGotViewport = function (a) {
	return {$: 154, a: a};
};
var $author$project$Evergreen$V417$Types$PressedAccountDeletionBanner = {$: 103};
var $author$project$Evergreen$V417$Types$PressedAddDomainToWhitelist = function (a) {
	return {$: 137, a: a};
};
var $author$project$Evergreen$V417$Types$PressedAddPrivateKeyToAccount = {$: 113};
var $author$project$Evergreen$V417$Types$PressedBanMember$ = function (a, b) {
	return {$: 30, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$PressedBanMember = F2($author$project$Evergreen$V417$Types$PressedBanMember$);
var $author$project$Evergreen$V417$Types$PressedBody = {$: 61};
var $author$project$Evergreen$V417$Types$PressedCancelE2eeRequest = function (a) {
	return {$: 118, a: a};
};
var $author$project$Evergreen$V417$Types$PressedCancelMessageEdit = function (a) {
	return {$: 70, a: a};
};
var $author$project$Evergreen$V417$Types$PressedChannelHeaderBackButton = {$: 57};
var $author$project$Evergreen$V417$Types$PressedChannelHeaderTab = function (a) {
	return {$: 157, a: a};
};
var $author$project$Evergreen$V417$Types$PressedCloseAccountDeletionBanner = {$: 104};
var $author$project$Evergreen$V417$Types$PressedCloseExternalLinkWarning = {$: 136};
var $author$project$Evergreen$V417$Types$PressedCloseImageInfo = {$: 110};
var $author$project$Evergreen$V417$Types$PressedCloseNewPrivateKey = {$: 114};
var $author$project$Evergreen$V417$Types$PressedCloseOverlay = {$: 73};
var $author$project$Evergreen$V417$Types$PressedCloseReplyTo = function (a) {
	return {$: 48, a: a};
};
var $author$project$Evergreen$V417$Types$PressedContinueToSite = {$: 145};
var $author$project$Evergreen$V417$Types$PressedCopyImage = function (a) {
	return {$: 34, a: a};
};
var $author$project$Evergreen$V417$Types$PressedCopyText = function (a) {
	return {$: 33, a: a};
};
var $author$project$Evergreen$V417$Types$PressedCreateInviteLink = function (a) {
	return {$: 28, a: a};
};
var $author$project$Evergreen$V417$Types$PressedDeclineE2eeRequest = function (a) {
	return {$: 120, a: a};
};
var $author$project$Evergreen$V417$Types$PressedDeleteAccount = {$: 102};
var $author$project$Evergreen$V417$Types$PressedDeleteAttachedFile$ = function (a, b) {
	return {$: 87, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$PressedDeleteAttachedFile = F2($author$project$Evergreen$V417$Types$PressedDeleteAttachedFile$);
var $author$project$Evergreen$V417$Types$PressedDeleteChannel$ = function (a, b) {
	return {$: 19, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$PressedDeleteChannel = F2($author$project$Evergreen$V417$Types$PressedDeleteChannel$);
var $author$project$Evergreen$V417$Types$PressedDeleteGuild = function (a) {
	return {$: 23, a: a};
};
var $author$project$Evergreen$V417$Types$PressedDeleteInviteLink$ = function (a, b) {
	return {$: 29, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$PressedDeleteInviteLink = F2($author$project$Evergreen$V417$Types$PressedDeleteInviteLink$);
var $author$project$Evergreen$V417$Types$PressedDisableE2ee = function (a) {
	return {$: 119, a: a};
};
var $author$project$Evergreen$V417$Types$PressedDiscordAcknowledgment = function (a) {
	return {$: 129, a: a};
};
var $author$project$Evergreen$V417$Types$PressedDiscordGuildMemberLabel = function (a) {
	return {$: 133, a: a};
};
var $author$project$Evergreen$V417$Types$PressedDiscordGuildNotificationLevel$ = function (a, b, c) {
	return {$: 106, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$PressedDiscordGuildNotificationLevel = F3($author$project$Evergreen$V417$Types$PressedDiscordGuildNotificationLevel$);
var $author$project$Evergreen$V417$Types$PressedE2eeRisksAccepted = function (a) {
	return {$: 116, a: a};
};
var $author$project$Evergreen$V417$Types$PressedEnableE2ee = function (a) {
	return {$: 117, a: a};
};
var $author$project$Evergreen$V417$Types$PressedExpandContainer = function (a) {
	return {$: 74, a: a};
};
var $author$project$Evergreen$V417$Types$PressedExpandE2eeSection = function (a) {
	return {$: 115, a: a};
};
var $author$project$Evergreen$V417$Types$PressedExportChannel = function (a) {
	return {$: 112, a: a};
};
var $author$project$Evergreen$V417$Types$PressedGuildNotificationLevel$ = function (a, b) {
	return {$: 105, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$PressedGuildNotificationLevel = F2($author$project$Evergreen$V417$Types$PressedGuildNotificationLevel$);
var $author$project$Evergreen$V417$Types$PressedHideMembers = {$: 59};
var $author$project$Evergreen$V417$Types$PressedHomePagePreview = function (a) {
	return {$: 7, a: a};
};
var $author$project$Evergreen$V417$Types$PressedImportChannel = function (a) {
	return {$: 24, a: a};
};
var $author$project$Evergreen$V417$Types$PressedLeaveGuild = function (a) {
	return {$: 27, a: a};
};
var $author$project$Evergreen$V417$Types$PressedLink = function (a) {
	return {$: 12, a: a};
};
var $author$project$Evergreen$V417$Types$PressedLoadDebugData = {$: 162};
var $author$project$Evergreen$V417$Types$PressedLogOut = function (a) {
	return {$: 9, a: a};
};
var $author$project$Evergreen$V417$Types$PressedMarkAllChannelsAsRead = function (a) {
	return {$: 177, a: a};
};
var $author$project$Evergreen$V417$Types$PressedMarkChannelAsRead$ = function (a, b) {
	return {$: 176, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$PressedMarkChannelAsRead = F2($author$project$Evergreen$V417$Types$PressedMarkChannelAsRead$);
var $author$project$Evergreen$V417$Types$PressedMemberListBack = {$: 111};
var $author$project$Evergreen$V417$Types$PressedMuteChannel$ = function (a, b, c) {
	return {$: 172, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$PressedMuteChannel = F3($author$project$Evergreen$V417$Types$PressedMuteChannel$);
var $author$project$Evergreen$V417$Types$PressedMuteDiscordChannel$ = function (a, b, c, d) {
	return {$: 174, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$PressedMuteDiscordChannel = F4($author$project$Evergreen$V417$Types$PressedMuteDiscordChannel$);
var $author$project$Evergreen$V417$Types$PressedMuteDiscordGuild$ = function (a, b, c) {
	return {$: 179, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$PressedMuteDiscordGuild = F3($author$project$Evergreen$V417$Types$PressedMuteDiscordGuild$);
var $author$project$Evergreen$V417$Types$PressedMuteDiscordThread$ = function (a, b, c, d, e) {
	return {$: 175, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V417$Types$PressedMuteDiscordThread = F5($author$project$Evergreen$V417$Types$PressedMuteDiscordThread$);
var $author$project$Evergreen$V417$Types$PressedMuteGuild$ = function (a, b) {
	return {$: 178, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$PressedMuteGuild = F2($author$project$Evergreen$V417$Types$PressedMuteGuild$);
var $author$project$Evergreen$V417$Types$PressedMuteSlackChannel$ = function (a, b, c, d) {
	return {$: 181, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$PressedMuteSlackChannel = F4($author$project$Evergreen$V417$Types$PressedMuteSlackChannel$);
var $author$project$Evergreen$V417$Types$PressedMuteSlackThread$ = function (a, b, c, d, e) {
	return {$: 182, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V417$Types$PressedMuteSlackThread = F5($author$project$Evergreen$V417$Types$PressedMuteSlackThread$);
var $author$project$Evergreen$V417$Types$PressedMuteSlackWorkspace$ = function (a, b, c) {
	return {$: 180, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$PressedMuteSlackWorkspace = F3($author$project$Evergreen$V417$Types$PressedMuteSlackWorkspace$);
var $author$project$Evergreen$V417$Types$PressedMuteThread$ = function (a, b, c, d) {
	return {$: 173, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$PressedMuteThread = F4($author$project$Evergreen$V417$Types$PressedMuteThread$);
var $author$project$Evergreen$V417$Types$PressedNewMessagesWarning = {$: 165};
var $author$project$Evergreen$V417$Types$PressedNotification = function (a) {
	return {$: 125, a: a};
};
var $author$project$Evergreen$V417$Types$PressedReloadDiscordUser = function (a) {
	return {$: 131, a: a};
};
var $author$project$Evergreen$V417$Types$PressedReloadSlackUser = function (a) {
	return {$: 192, a: a};
};
var $author$project$Evergreen$V417$Types$PressedRemoveSlackTeam = function (a) {
	return {$: 189, a: a};
};
var $author$project$Evergreen$V417$Types$PressedResetDomainWhitelist = {$: 144};
var $author$project$Evergreen$V417$Types$PressedResetEditChannelChanges$ = function (a, b) {
	return {$: 17, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$PressedResetEditChannelChanges = F2($author$project$Evergreen$V417$Types$PressedResetEditChannelChanges$);
var $author$project$Evergreen$V417$Types$PressedResetEditGuildChanges = function (a) {
	return {$: 21, a: a};
};
var $author$project$Evergreen$V417$Types$PressedResetUserColor = {$: 142};
var $author$project$Evergreen$V417$Types$PressedSaveDomainWhitelist = {$: 143};
var $author$project$Evergreen$V417$Types$PressedSearchOverlayArrowKey = function (a) {
	return {$: 169, a: a};
};
var $author$project$Evergreen$V417$Types$PressedSearchOverlayEnter = {$: 170};
var $author$project$Evergreen$V417$Types$PressedSearchOverlayResult = function (a) {
	return {$: 171, a: a};
};
var $author$project$Evergreen$V417$Types$PressedSelectNewColor = {$: 139};
var $author$project$Evergreen$V417$Types$PressedShowLogin = {$: 6};
var $author$project$Evergreen$V417$Types$PressedShowMembers = {$: 58};
var $author$project$Evergreen$V417$Types$PressedShowSearchOverlay = {$: 167};
var $author$project$Evergreen$V417$Types$PressedShowUserOption = {$: 72};
var $author$project$Evergreen$V417$Types$PressedSlackAcknowledgment = function (a) {
	return {$: 130, a: a};
};
var $author$project$Evergreen$V417$Types$PressedSlackWorkspaceNotificationLevel$ = function (a, b, c) {
	return {$: 107, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$PressedSlackWorkspaceNotificationLevel = F3($author$project$Evergreen$V417$Types$PressedSlackWorkspaceNotificationLevel$);
var $author$project$Evergreen$V417$Types$PressedSubmitEditChannelChanges$ = function (a, b, c) {
	return {$: 18, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$PressedSubmitEditChannelChanges = F3($author$project$Evergreen$V417$Types$PressedSubmitEditChannelChanges$);
var $author$project$Evergreen$V417$Types$PressedSubmitEditGuildChanges$ = function (a, b) {
	return {$: 22, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$PressedSubmitEditGuildChanges = F2($author$project$Evergreen$V417$Types$PressedSubmitEditGuildChanges$);
var $author$project$Evergreen$V417$Types$PressedSubmitNewChannel$ = function (a, b) {
	return {$: 15, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$PressedSubmitNewChannel = F2($author$project$Evergreen$V417$Types$PressedSubmitNewChannel$);
var $author$project$Evergreen$V417$Types$PressedSubmitNewGuild = function (a) {
	return {$: 36, a: a};
};
var $author$project$Evergreen$V417$Types$PressedSubmitSlackData = {$: 190};
var $author$project$Evergreen$V417$Types$PressedSubmitUserColor = {$: 141};
var $author$project$Evergreen$V417$Types$PressedToggleAttachedFileSpoiler$ = function (a, b) {
	return {$: 89, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$PressedToggleAttachedFileSpoiler = F2($author$project$Evergreen$V417$Types$PressedToggleAttachedFileSpoiler$);
var $author$project$Evergreen$V417$Types$PressedToggleInviteLinkQrCode = function (a) {
	return {$: 31, a: a};
};
var $author$project$Evergreen$V417$Types$PressedUnlinkDiscordUser = function (a) {
	return {$: 132, a: a};
};
var $author$project$Evergreen$V417$Types$PressedUnlinkSlackUser = function (a) {
	return {$: 191, a: a};
};
var $author$project$Evergreen$V417$Types$PressedUnregisterServiceWorkers = {$: 161};
var $author$project$Evergreen$V417$Types$PressedViewAttachedFileInfo$ = function (a, b) {
	return {$: 88, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$PressedViewAttachedFileInfo = F2($author$project$Evergreen$V417$Types$PressedViewAttachedFileInfo$);
var $author$project$Evergreen$V417$Types$ProfilePictureEditorMsg = function (a) {
	return {$: 82, a: a};
};
var $author$project$Evergreen$V417$Types$RecoveryLoginMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V417$Types$RemoveFocus = {$: 40};
var $author$project$Evergreen$V417$Types$SafeAreaInsetsChanged = function (a) {
	return {$: 127, a: a};
};
var $author$project$Evergreen$V417$Types$ScrolledToLogSection = {$: 11};
var $author$project$Evergreen$V417$Types$ScrolledToMessage = {$: 67};
var $author$project$Evergreen$V417$Types$SelectedEmailNotifications = function (a) {
	return {$: 100, a: a};
};
var $author$project$Evergreen$V417$Types$SelectedEmbedVisibility = function (a) {
	return {$: 101, a: a};
};
var $author$project$Evergreen$V417$Types$SelectedFilesToAttach$ = function (a, b, c) {
	return {$: 13, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$SelectedFilesToAttach = F3($author$project$Evergreen$V417$Types$SelectedFilesToAttach$);
var $author$project$Evergreen$V417$Types$SelectedImportChannelFile$ = function (a, b) {
	return {$: 25, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$SelectedImportChannelFile = F2($author$project$Evergreen$V417$Types$SelectedImportChannelFile$);
var $author$project$Evergreen$V417$Types$SelectedNotificationMode = function (a) {
	return {$: 99, a: a};
};
var $author$project$Evergreen$V417$Types$SelectedUserColor = function (a) {
	return {$: 140, a: a};
};
var $author$project$Evergreen$V417$Types$SetFocus = {$: 39};
var $author$project$Evergreen$V417$Types$SetScrollToBottom = {$: 56};
var $author$project$Evergreen$V417$Types$TextEditorMsg = function (a) {
	return {$: 128, a: a};
};
var $author$project$Evergreen$V417$Types$TextSelectionChanged = function (a) {
	return {$: 152, a: a};
};
var $author$project$Evergreen$V417$Types$TouchCancel = function (a) {
	return {$: 53, a: a};
};
var $author$project$Evergreen$V417$Types$TouchEnd = function (a) {
	return {$: 52, a: a};
};
var $author$project$Evergreen$V417$Types$TouchMoved$ = function (a, b) {
	return {$: 51, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$TouchMoved = F2($author$project$Evergreen$V417$Types$TouchMoved$);
var $author$project$Evergreen$V417$Types$TouchStart$ = function (a, b) {
	return {$: 50, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$TouchStart = F2($author$project$Evergreen$V417$Types$TouchStart$);
var $author$project$Evergreen$V417$Types$TwoFactorMsg = function (a) {
	return {$: 75, a: a};
};
var $author$project$Evergreen$V417$Types$TypedDiscordLinkBookmarklet = {$: 134};
var $author$project$Evergreen$V417$Types$TypedDomainWhitelist = function (a) {
	return {$: 138, a: a};
};
var $author$project$Evergreen$V417$Types$TypedPrivateKey$ = function (a, b) {
	return {$: 121, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$TypedPrivateKey = F2($author$project$Evergreen$V417$Types$TypedPrivateKey$);
var $author$project$Evergreen$V417$Types$TypedSearchOverlay = function (a) {
	return {$: 168, a: a};
};
var $author$project$Evergreen$V417$Types$TypedSlackCookie = function (a) {
	return {$: 187, a: a};
};
var $author$project$Evergreen$V417$Types$TypedSlackTeamsJson = function (a) {
	return {$: 188, a: a};
};
var $author$project$Evergreen$V417$Types$UnreadOverviewChannelMsg$ = function (a, b, c) {
	return {$: 183, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$UnreadOverviewChannelMsg = F3($author$project$Evergreen$V417$Types$UnreadOverviewChannelMsg$);
var $author$project$Evergreen$V417$Types$UnreadOverviewThreadMsg$ = function (a, b, c, d) {
	return {$: 184, a: a, b: b, c: c, d: d};
};
var $author$project$Evergreen$V417$Types$UnreadOverviewThreadMsg = F4($author$project$Evergreen$V417$Types$UnreadOverviewThreadMsg$);
var $author$project$Evergreen$V417$Types$UrlChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Types$UrlClicked = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Types$UserNameEditableMsg = function (a) {
	return {$: 81, a: a};
};
var $author$project$Evergreen$V417$Types$UserScrolled$ = function (a, b, c) {
	return {$: 60, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Types$UserScrolled = F3($author$project$Evergreen$V417$Types$UserScrolled$);
var $author$project$Evergreen$V417$Types$ValidatedE2eePrivateKey$ = function (a, b) {
	return {$: 185, a: a, b: b};
};
var $author$project$Evergreen$V417$Types$ValidatedE2eePrivateKey = F2($author$project$Evergreen$V417$Types$ValidatedE2eePrivateKey$);
var $author$project$Evergreen$V417$Types$VisualViewportChanged = function (a) {
	return {$: 126, a: a};
};
var $author$project$Evergreen$V417$Types$VoiceChatMsg = function (a) {
	return {$: 156, a: a};
};
var $lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Element = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeFloat,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeFloat,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeFloat,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F4(
							function (height0, width0, x0, y0) {
								return {height: height0, width: width0, x: x0, y: y0};
							})))))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeFloat,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeFloat,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F2(
						function (height0, width0) {
							return {height: height0, width: width0};
						})))),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeFloat,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeFloat,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F4(
									function (height0, width0, x0, y0) {
										return {height: height0, width: width0, x: x0, y: y0};
									})))))),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (element0, scene0, viewport0) {
						return {element: element0, scene: scene0, viewport: viewport0};
					})))));
var $lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Error = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_HtmlId,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Id$ExportChannel_Discord$ = function (a, b, c) {
	return {$: 1, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Id$ExportChannel_Discord = F3($author$project$Evergreen$V417$Id$ExportChannel_Discord$);
var $author$project$Evergreen$V417$Id$ExportChannel_DiscordDm$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Evergreen$V417$Id$ExportChannel_DiscordDm = F2($author$project$Evergreen$V417$Id$ExportChannel_DiscordDm$);
var $author$project$Evergreen$V417$Id$ExportChannel_Dm = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$Id$ExportChannel_Guild$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$Id$ExportChannel_Guild = F2($author$project$Evergreen$V417$Id$ExportChannel_Guild$);
var $author$project$Evergreen$V417$Id$w3_unsafe_decode_ExportChannelId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Id$ExportChannel_Discord))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Id$ExportChannel_DiscordDm)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Id$ExportChannel_Dm));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Id$ExportChannel_Guild)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $lamdera$codecs$Lamdera$Wire3$decodeRef = $elm$bytes$Bytes$Decode$andThen$(
	function (ref) {
		return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
			_LamderaCodecs_decodeWithRef(ref));
	},
	$elm$bytes$Bytes$Decode$unsignedInt32($lamdera$codecs$Lamdera$Wire3$endianness));
var $lamdera$program_test$Effect$File$w3_unsafe_decode_FileUploadContent = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBytes,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($lamdera$program_test$Effect$File$BytesFile));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($lamdera$program_test$Effect$File$StringFile));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $lamdera$program_test$Effect$File$w3_unsafe_decode_File = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeString,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								A2(
									$lamdera$codecs$Lamdera$Wire3$andThenDecode,
									function (t) {
										return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
											$elm$time$Time$millisToPosix(t));
									},
									$lamdera$codecs$Lamdera$Wire3$decodeInt),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$File$w3_unsafe_decode_FileUploadContent,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F4(
											function (content0, lastModified0, mimeType0, name0) {
												return {content: content0, lastModified: lastModified0, mimeType: mimeType0, name: name0};
											})))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($lamdera$program_test$Effect$File$MockFile));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeRef,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($lamdera$program_test$Effect$File$RealFile));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Call$FromJs_DebugData = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V417$Call$FromJs_GotUserMediaDevices$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$Call$FromJs_GotUserMediaDevices = F2($author$project$Evergreen$V417$Call$FromJs_GotUserMediaDevices$);
var $author$project$Evergreen$V417$Call$FromJs_GotUserMediaDevicesError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Call$FromJs_RecordingUploadProgress$ = function (a, b) {
	return {$: 7, a: a, b: b};
};
var $author$project$Evergreen$V417$Call$FromJs_RecordingUploadProgress = F2($author$project$Evergreen$V417$Call$FromJs_RecordingUploadProgress$);
var $author$project$Evergreen$V417$Call$FromJs_RecordingUploadsStopped = {$: 8};
var $author$project$Evergreen$V417$Call$FromJs_ScreenShareStarted = {$: 5};
var $author$project$Evergreen$V417$Call$FromJs_ScreenShareStopped = {$: 6};
var $author$project$Evergreen$V417$Call$FromJs_SpeakingChanged$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V417$Call$FromJs_SpeakingChanged = F2($author$project$Evergreen$V417$Call$FromJs_SpeakingChanged$);
var $author$project$Evergreen$V417$Call$FromJs_StartConnectionError = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V417$Call$w3_unsafe_decode_FromJs = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V417$Call$w3_unsafe_decode_DebugSection),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$FromJs_DebugData));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList(
						$author$project$Evergreen$V417$IdString$w3_unsafe_decode_IdString($author$project$Evergreen$V417$Call$w3_unsafe_decode_MediaDeviceId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V417$Call$w3_unsafe_decode_MediaDevice),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$FromJs_GotUserMediaDevices)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$FromJs_GotUserMediaDevicesError));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$FromJs_RecordingUploadProgress)));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$FromJs_RecordingUploadsStopped);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$FromJs_ScreenShareStarted);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$FromJs_ScreenShareStopped);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Call$w3_unsafe_decode_LocalOrConnection,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$FromJs_SpeakingChanged)));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$FromJs_StartConnectionError));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Encryption$FromJs_FileEncryptFailed$ = function (a, b) {
	return {$: 10, a: a, b: b};
};
var $author$project$Evergreen$V417$Encryption$FromJs_FileEncryptFailed = F2($author$project$Evergreen$V417$Encryption$FromJs_FileEncryptFailed$);
var $author$project$Evergreen$V417$Encryption$FromJs_FileEncrypted$ = function (a, b) {
	return {$: 9, a: a, b: b};
};
var $author$project$Evergreen$V417$Encryption$FromJs_FileEncrypted = F2($author$project$Evergreen$V417$Encryption$FromJs_FileEncrypted$);
var $author$project$Evergreen$V417$Encryption$FromJs_ManyMessagesDecrypted$ = function (a, b) {
	return {$: 6, a: a, b: b};
};
var $author$project$Evergreen$V417$Encryption$FromJs_ManyMessagesDecrypted = F2($author$project$Evergreen$V417$Encryption$FromJs_ManyMessagesDecrypted$);
var $author$project$Evergreen$V417$Encryption$FromJs_ManyMessagesEncryptFailed$ = function (a, b) {
	return {$: 8, a: a, b: b};
};
var $author$project$Evergreen$V417$Encryption$FromJs_ManyMessagesEncryptFailed = F2($author$project$Evergreen$V417$Encryption$FromJs_ManyMessagesEncryptFailed$);
var $author$project$Evergreen$V417$Encryption$FromJs_ManyMessagesEncrypted$ = function (a, b) {
	return {$: 7, a: a, b: b};
};
var $author$project$Evergreen$V417$Encryption$FromJs_ManyMessagesEncrypted = F2($author$project$Evergreen$V417$Encryption$FromJs_ManyMessagesEncrypted$);
var $author$project$Evergreen$V417$Encryption$FromJs_NewMessageDecryptFailed = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V417$Encryption$FromJs_NewMessageDecrypted$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $author$project$Evergreen$V417$Encryption$FromJs_NewMessageDecrypted = F2($author$project$Evergreen$V417$Encryption$FromJs_NewMessageDecrypted$);
var $author$project$Evergreen$V417$Encryption$FromJs_NewMessageEncryptFailed$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Evergreen$V417$Encryption$FromJs_NewMessageEncryptFailed = F2($author$project$Evergreen$V417$Encryption$FromJs_NewMessageEncryptFailed$);
var $author$project$Evergreen$V417$Encryption$FromJs_NewMessageEncrypted$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Evergreen$V417$Encryption$FromJs_NewMessageEncrypted = F2($author$project$Evergreen$V417$Encryption$FromJs_NewMessageEncrypted$);
var $author$project$Evergreen$V417$Encryption$FromJs_SharedSecretFailed$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V417$Encryption$FromJs_SharedSecretFailed = F2($author$project$Evergreen$V417$Encryption$FromJs_SharedSecretFailed$);
var $author$project$Evergreen$V417$Encryption$FromJs_SharedSecretStored = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$FileStatus$MeasuredImage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$FileStatus$MeasuredVideo$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V417$FileStatus$MeasuredVideo = F2($author$project$Evergreen$V417$FileStatus$MeasuredVideo$);
var $author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_MeasuredFile = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$FileStatus$MeasuredImage));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$FileStatus$MeasuredVideo)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Encryption$w3_unsafe_decode_FromJs = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Encryption$w3_unsafe_decode_EncryptFileRequestId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Encryption$FromJs_FileEncryptFailed)));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeBytes),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_MeasuredFile),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeBytes,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeBytes,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											F4(
												function (data0, key0, measured0, thumbnail0) {
													return {data: data0, key: key0, measured: measured0, thumbnail: thumbnail0};
												})))))),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Encryption$w3_unsafe_decode_EncryptFileRequestId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Encryption$FromJs_FileEncrypted)));
				case 2:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeList(
							$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, w3_x_c_a)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Encryption$w3_unsafe_decode_DecryptManyRequestId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Encryption$FromJs_ManyMessagesDecrypted)));
				case 3:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Encryption$w3_unsafe_decode_EncryptManyRequestId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Encryption$FromJs_ManyMessagesEncryptFailed)));
				case 4:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeList(
							$author$project$Evergreen$V417$Encryption$w3_unsafe_decode_EncryptedData(w3_x_c_a)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Encryption$w3_unsafe_decode_EncryptManyRequestId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Encryption$FromJs_ManyMessagesEncrypted)));
				case 5:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Encryption$w3_unsafe_decode_DecryptRequestId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Encryption$FromJs_NewMessageDecryptFailed));
				case 6:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_a,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Encryption$w3_unsafe_decode_DecryptRequestId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Encryption$FromJs_NewMessageDecrypted)));
				case 7:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Encryption$w3_unsafe_decode_EncryptRequestId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Encryption$FromJs_NewMessageEncryptFailed)));
				case 8:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Encryption$w3_unsafe_decode_EncryptedData(w3_x_c_a),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Encryption$w3_unsafe_decode_EncryptRequestId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Encryption$FromJs_NewMessageEncrypted)));
				case 9:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Encryption$FromJs_SharedSecretFailed)));
				case 10:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Encryption$FromJs_SharedSecretStored));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$MessageView$MessageViewMsg_PressedCallStartedCard = {$: 17};
var $author$project$Evergreen$V417$MessageView$MessageViewMsg_PressedEditMessage = {$: 11};
var $author$project$Evergreen$V417$MessageView$MessageViewMsg_PressedGameStartedCard = {$: 18};
var $author$project$Evergreen$V417$MessageView$MessageViewMsg_PressedReactionEmoji = function (a) {
	return {$: 16, a: a};
};
var $author$project$Evergreen$V417$MessageView$MessageViewMsg_PressedReply = {$: 12};
var $author$project$Evergreen$V417$MessageView$MessageViewMsg_PressedShowFullMenu$ = function (a, b) {
	return {$: 13, a: a, b: b};
};
var $author$project$Evergreen$V417$MessageView$MessageViewMsg_PressedShowFullMenu = F2($author$project$Evergreen$V417$MessageView$MessageViewMsg_PressedShowFullMenu$);
var $author$project$Evergreen$V417$MessageView$MessageViewMsg_PressedShowReactionEmojiSelector = {$: 10};
var $author$project$Evergreen$V417$MessageView$MessageView_AltPressedMessage$ = function (a, b, c, d, e) {
	return {$: 6, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Evergreen$V417$MessageView$MessageView_AltPressedMessage = F5($author$project$Evergreen$V417$MessageView$MessageView_AltPressedMessage$);
var $author$project$Evergreen$V417$MessageView$MessageView_MouseEnteredMessage = {$: 3};
var $author$project$Evergreen$V417$MessageView$MessageView_MouseExitedMessage = {$: 4};
var $author$project$Evergreen$V417$MessageView$MessageView_NoOp = {$: 15};
var $author$project$Evergreen$V417$MessageView$MessageView_PressedCardAnchor$ = function (a, b) {
	return {$: 22, a: a, b: b};
};
var $author$project$Evergreen$V417$MessageView$MessageView_PressedCardAnchor = F2($author$project$Evergreen$V417$MessageView$MessageView_PressedCardAnchor$);
var $author$project$Evergreen$V417$MessageView$MessageView_PressedChannelMention$ = function (a, b) {
	return {$: 25, a: a, b: b};
};
var $author$project$Evergreen$V417$MessageView$MessageView_PressedChannelMention = F2($author$project$Evergreen$V417$MessageView$MessageView_PressedChannelMention$);
var $author$project$Evergreen$V417$MessageView$MessageView_PressedCopyCode = function (a) {
	return {$: 27, a: a};
};
var $author$project$Evergreen$V417$MessageView$MessageView_PressedDateDivider$ = function (a, b, c) {
	return {$: 21, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$MessageView$MessageView_PressedDateDivider = F3($author$project$Evergreen$V417$MessageView$MessageView_PressedDateDivider$);
var $author$project$Evergreen$V417$MessageView$MessageView_PressedDiscordChannelMention$ = function (a, b) {
	return {$: 26, a: a, b: b};
};
var $author$project$Evergreen$V417$MessageView$MessageView_PressedDiscordChannelMention = F2($author$project$Evergreen$V417$MessageView$MessageView_PressedDiscordChannelMention$);
var $author$project$Evergreen$V417$MessageView$MessageView_PressedDiscordUserIconButton = function (a) {
	return {$: 24, a: a};
};
var $author$project$Evergreen$V417$MessageView$MessageView_PressedImage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$MessageView$MessageView_PressedNonWhitelistLink = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$MessageView$MessageView_PressedReactionEmoji_Add = function (a) {
	return {$: 8, a: a};
};
var $author$project$Evergreen$V417$MessageView$MessageView_PressedReactionEmoji_Remove = function (a) {
	return {$: 7, a: a};
};
var $author$project$Evergreen$V417$MessageView$MessageView_PressedReplyLink = {$: 9};
var $author$project$Evergreen$V417$MessageView$MessageView_PressedSpoiler = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$MessageView$MessageView_PressedTimestamp$ = function (a, b) {
	return {$: 20, a: a, b: b};
};
var $author$project$Evergreen$V417$MessageView$MessageView_PressedTimestamp = F2($author$project$Evergreen$V417$MessageView$MessageView_PressedTimestamp$);
var $author$project$Evergreen$V417$MessageView$MessageView_PressedUserIconAnchor$ = function (a, b) {
	return {$: 19, a: a, b: b};
};
var $author$project$Evergreen$V417$MessageView$MessageView_PressedUserIconAnchor = F2($author$project$Evergreen$V417$MessageView$MessageView_PressedUserIconAnchor$);
var $author$project$Evergreen$V417$MessageView$MessageView_PressedUserIconButton = function (a) {
	return {$: 23, a: a};
};
var $author$project$Evergreen$V417$MessageView$MessageView_PressedViewThreadLink = {$: 14};
var $author$project$Evergreen$V417$MessageView$MessageView_TouchStart$ = function (a, b, c, d, e, f) {
	return {$: 5, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Evergreen$V417$MessageView$MessageView_TouchStart = F6($author$project$Evergreen$V417$MessageView$MessageView_TouchStart$);
var $author$project$Evergreen$V417$RichText$PressedAttachedFileImage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$RichText$PressedEmbedImage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$RichText$w3_unsafe_decode_PressedImageId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$RichText$PressedAttachedFileImage));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$RichText$PressedEmbedImage));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$RichText$w3_unsafe_decode_PressedImageData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V417$Point2d$w3_unsafe_decode_Point2d$($author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels, $author$project$Evergreen$V417$Touch$w3_unsafe_decode_ScreenCoordinate),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V417$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$RichText$w3_unsafe_decode_PressedImageId,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (displayWidth0, fileUrl0, imageId0, imageSize0, position0) {
								return {displayWidth: displayWidth0, fileUrl: fileUrl0, imageId: imageId0, imageSize: imageSize0, position: position0};
							})))))));
var $author$project$Evergreen$V417$MessageView$w3_unsafe_decode_MessageViewMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageView$MessageViewMsg_PressedCallStartedCard);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageView$MessageViewMsg_PressedEditMessage);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageView$MessageViewMsg_PressedGameStartedCard);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageView$MessageViewMsg_PressedReactionEmoji));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageView$MessageViewMsg_PressedReply);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageView$MessageViewMsg_PressedShowFullMenu)));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageView$MessageViewMsg_PressedShowReactionEmojiSelector);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeBool,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageView$MessageView_AltPressedMessage))))));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageView$MessageView_MouseEnteredMessage);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageView$MessageView_MouseExitedMessage);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageView$MessageView_NoOp);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $lamdera$codecs$Lamdera$Wire3$decodeFloat),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Point2d$w3_unsafe_decode_Point2d$($author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels, $author$project$Evergreen$V417$Touch$w3_unsafe_decode_ScreenCoordinate),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageView$MessageView_PressedCardAnchor)));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageView$MessageView_PressedChannelMention)));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageView$MessageView_PressedCopyCode));
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $lamdera$codecs$Lamdera$Wire3$decodeFloat),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Point2d$w3_unsafe_decode_Point2d$($author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels, $author$project$Evergreen$V417$Touch$w3_unsafe_decode_ScreenCoordinate),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$justinmimbs$date$Date$w3_unsafe_decode_Date,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageView$MessageView_PressedDateDivider))));
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageView$MessageView_PressedDiscordChannelMention)));
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageView$MessageView_PressedDiscordUserIconButton));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$RichText$w3_unsafe_decode_PressedImageData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageView$MessageView_PressedImage));
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$elm$url$Url$w3_unsafe_decode_Url,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageView$MessageView_PressedNonWhitelistLink));
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageView$MessageView_PressedReactionEmoji_Add));
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageView$MessageView_PressedReactionEmoji_Remove));
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageView$MessageView_PressedReplyLink);
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageView$MessageView_PressedSpoiler));
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $lamdera$codecs$Lamdera$Wire3$decodeFloat),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Point2d$w3_unsafe_decode_Point2d$($author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels, $author$project$Evergreen$V417$Touch$w3_unsafe_decode_ScreenCoordinate),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageView$MessageView_PressedTimestamp)));
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $lamdera$codecs$Lamdera$Wire3$decodeFloat),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Point2d$w3_unsafe_decode_Point2d$($author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels, $author$project$Evergreen$V417$Touch$w3_unsafe_decode_ScreenCoordinate),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageView$MessageView_PressedUserIconAnchor)));
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageView$MessageView_PressedUserIconButton));
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageView$MessageView_PressedViewThreadLink);
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$NonemptyDict$w3_unsafe_decode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$Evergreen$V417$Touch$w3_unsafe_decode_Touch),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeBool,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageView$MessageView_TouchStart)))))));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$AiChat$CheckDebounce = function (a) {
	return {$: 13, a: a};
};
var $author$project$Evergreen$V417$AiChat$EditedResponse$ = function (a, b) {
	return {$: 15, a: a, b: b};
};
var $author$project$Evergreen$V417$AiChat$EditedResponse = F2($author$project$Evergreen$V417$AiChat$EditedResponse$);
var $author$project$Evergreen$V417$AiChat$GotAiModels = function (a) {
	return {$: 17, a: a};
};
var $author$project$Evergreen$V417$AiChat$GotLocalStorage = function (a) {
	return {$: 14, a: a};
};
var $author$project$Evergreen$V417$AiChat$NoOp = {$: 16};
var $author$project$Evergreen$V417$AiChat$PressedAddModel = {$: 10};
var $author$project$Evergreen$V417$AiChat$PressedChatHistoryContainer = {$: 6};
var $author$project$Evergreen$V417$AiChat$PressedClearChatHistory = {$: 7};
var $author$project$Evergreen$V417$AiChat$PressedDelete = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V417$AiChat$PressedKeep = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V417$AiChat$PressedOptionsButton = {$: 8};
var $author$project$Evergreen$V417$AiChat$PressedRemoveModel = function (a) {
	return {$: 11, a: a};
};
var $author$project$Evergreen$V417$AiChat$PressedRetry = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V417$AiChat$PressedSend = {$: 1};
var $author$project$Evergreen$V417$AiChat$SelectedAiModel$ = function (a, b) {
	return {$: 9, a: a, b: b};
};
var $author$project$Evergreen$V417$AiChat$SelectedAiModel = F2($author$project$Evergreen$V417$AiChat$SelectedAiModel$);
var $author$project$Evergreen$V417$AiChat$SelectedSendMessageWith = function (a) {
	return {$: 12, a: a};
};
var $author$project$Evergreen$V417$AiChat$TypedChatHistory = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$AiChat$TypedMessage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$AiChat$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$AiChat$CheckDebounce));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$AiChat$w3_unsafe_decode_ResponseId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$AiChat$EditedResponse)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$(
						$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
						$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V417$AiChat$w3_unsafe_decode_AiModel)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$AiChat$GotAiModels));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$AiChat$GotLocalStorage));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$AiChat$NoOp);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$AiChat$PressedAddModel);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$AiChat$PressedChatHistoryContainer);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$AiChat$PressedClearChatHistory);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$AiChat$w3_unsafe_decode_ResponseId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$AiChat$PressedDelete));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$AiChat$w3_unsafe_decode_ResponseId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$AiChat$PressedKeep));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$AiChat$PressedOptionsButton);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$AiChat$PressedRemoveModel));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$AiChat$w3_unsafe_decode_ResponseId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$AiChat$PressedRetry));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$AiChat$PressedSend);
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$AiChat$w3_unsafe_decode_AiModelName,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$AiChat$SelectedAiModel)));
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$AiChat$w3_unsafe_decode_SendMessageWith,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$AiChat$SelectedSendMessageWith));
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$AiChat$TypedChatHistory));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$AiChat$TypedMessage));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Call$ChangedVolume$ = function (a, b) {
	return {$: 11, a: a, b: b};
};
var $author$project$Evergreen$V417$Call$ChangedVolume = F2($author$project$Evergreen$V417$Call$ChangedVolume$);
var $author$project$Evergreen$V417$Call$DoubleClickedVideoNode = {$: 14};
var $author$project$Evergreen$V417$Call$MouseEnterVideoNode = function (a) {
	return {$: 12, a: a};
};
var $author$project$Evergreen$V417$Call$MouseExitVideoNode = function (a) {
	return {$: 13, a: a};
};
var $author$project$Evergreen$V417$Call$PolledDebugData = {$: 18};
var $author$project$Evergreen$V417$Call$PressedAnswerRecording = function (a) {
	return {$: 9, a: a};
};
var $author$project$Evergreen$V417$Call$PressedCancelRecording = {$: 8};
var $author$project$Evergreen$V417$Call$PressedCopyError = function (a) {
	return {$: 10, a: a};
};
var $author$project$Evergreen$V417$Call$PressedJoinCall = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V417$Call$PressedLeaveCall = {$: 6};
var $author$project$Evergreen$V417$Call$PressedRecord = {$: 7};
var $author$project$Evergreen$V417$Call$PressedToggleDebugData = {$: 17};
var $author$project$Evergreen$V417$Call$PressedToggleDeviceSettings = {$: 16};
var $author$project$Evergreen$V417$Call$PressedToggleMute = {$: 2};
var $author$project$Evergreen$V417$Call$PressedTogglePauseVideo = {$: 3};
var $author$project$Evergreen$V417$Call$PressedToggleScreenShare = {$: 4};
var $author$project$Evergreen$V417$Call$PressedVideoTile = function (a) {
	return {$: 15, a: a};
};
var $author$project$Evergreen$V417$Call$SelectedAudioInputDevice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Call$SelectedVideoInputDevice = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Call$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Call$w3_unsafe_decode_ConnectionId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$ChangedVolume)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$DoubleClickedVideoNode);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Call$w3_unsafe_decode_LocalOrConnection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$MouseEnterVideoNode));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Call$w3_unsafe_decode_LocalOrConnection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$MouseExitVideoNode));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$PolledDebugData);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$PressedAnswerRecording));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$PressedCancelRecording);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$PressedCopyError));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Call$w3_unsafe_decode_CallId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$PressedJoinCall));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$PressedLeaveCall);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$PressedRecord);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$PressedToggleDebugData);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$PressedToggleDeviceSettings);
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$PressedToggleMute);
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$PressedTogglePauseVideo);
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$PressedToggleScreenShare);
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Call$w3_unsafe_decode_VideoTile,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$PressedVideoTile));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$IdString$w3_unsafe_decode_IdString($author$project$Evergreen$V417$Call$w3_unsafe_decode_MediaDeviceId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$SelectedAudioInputDevice));
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$IdString$w3_unsafe_decode_IdString($author$project$Evergreen$V417$Call$w3_unsafe_decode_MediaDeviceId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Call$SelectedVideoInputDevice));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Drawing$GotZoomContainer = function (a) {
	return {$: 6, a: a};
};
var $author$project$Evergreen$V417$Drawing$PointerDown$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$Drawing$PointerDown = F2($author$project$Evergreen$V417$Drawing$PointerDown$);
var $author$project$Evergreen$V417$Drawing$PointerMoved$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V417$Drawing$PointerMoved = F2($author$project$Evergreen$V417$Drawing$PointerMoved$);
var $author$project$Evergreen$V417$Drawing$PointerUp = {$: 2};
var $author$project$Evergreen$V417$Drawing$PressedDone = {$: 7};
var $author$project$Evergreen$V417$Drawing$PressedRedo = {$: 4};
var $author$project$Evergreen$V417$Drawing$PressedUndo = {$: 3};
var $author$project$Evergreen$V417$Drawing$PressedZoom = {$: 5};
var $author$project$Evergreen$V417$Drawing$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeFloat,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeFloat,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeFloat,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeFloat,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											F4(
												function (height0, width0, x0, y0) {
													return {height: height0, width: width0, x: x0, y: y0};
												}))))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Drawing$GotZoomContainer));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Drawing$PointerDown)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Drawing$PointerMoved)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Drawing$PointerUp);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Drawing$PressedDone);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Drawing$PressedRedo);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Drawing$PressedUndo);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Drawing$PressedZoom);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Editable$Edit = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Editable$PressedAcceptEdit = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Editable$w3_unsafe_decode_Msg = function (w3_x_c_value) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Editable$w3_unsafe_decode_Model,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Editable$Edit));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_value,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Editable$PressedAcceptEdit));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$Emoji$ClearEmojiHover = {$: 7};
var $author$project$Evergreen$V417$Emoji$KeyboardMovedHover$ = function (a, b) {
	return {$: 6, a: a, b: b};
};
var $author$project$Evergreen$V417$Emoji$KeyboardMovedHover = F2($author$project$Evergreen$V417$Emoji$KeyboardMovedHover$);
var $author$project$Evergreen$V417$Emoji$MouseEnteredEmoji$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$Evergreen$V417$Emoji$MouseEnteredEmoji = F2($author$project$Evergreen$V417$Emoji$MouseEnteredEmoji$);
var $author$project$Evergreen$V417$Emoji$NoOp = {$: 10};
var $author$project$Evergreen$V417$Emoji$PressedCategory$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V417$Emoji$PressedCategory = F2($author$project$Evergreen$V417$Emoji$PressedCategory$);
var $author$project$Evergreen$V417$Emoji$PressedClearSearch = {$: 9};
var $author$project$Evergreen$V417$Emoji$PressedContainer = {$: 0};
var $author$project$Evergreen$V417$Emoji$PressedSelectEmoji = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V417$Emoji$PressedSkinTone = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V417$Emoji$ScrolledToCategory = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$Emoji$TypedSearchText = function (a) {
	return {$: 8, a: a};
};
var $author$project$Evergreen$V417$Emoji$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Emoji$ClearEmojiHover);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrSticker,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Emoji$KeyboardMovedHover)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrSticker,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Emoji$MouseEnteredEmoji)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Emoji$NoOp);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_Category,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Emoji$PressedCategory)));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Emoji$PressedClearSearch);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Emoji$PressedContainer);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrSticker,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Emoji$PressedSelectEmoji));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Emoji$w3_unsafe_decode_SkinTone),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Emoji$PressedSkinTone));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_Category,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Emoji$ScrolledToCategory));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Emoji$TypedSearchText));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Game$GoGameMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Game$GoSetupMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Game$NoOpMsg = {$: 11};
var $author$project$Evergreen$V417$Game$PressedCopyLink = function (a) {
	return {$: 7, a: a};
};
var $author$project$Evergreen$V417$Game$PressedReset = {$: 9};
var $author$project$Evergreen$V417$Game$PressedSelectGame = function (a) {
	return {$: 10, a: a};
};
var $author$project$Evergreen$V417$Game$PressedShareMatch = function (a) {
	return {$: 6, a: a};
};
var $author$project$Evergreen$V417$Game$SelectedMatch = function (a) {
	return {$: 8, a: a};
};
var $author$project$Evergreen$V417$Game$SheepGameMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V417$Game$SheepSetupMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V417$Game$WordSpellingGameMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$Game$WordSpellingSetupMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V417$Go$PressedAgree = {$: 3};
var $author$project$Evergreen$V417$Go$PressedCell = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Go$PressedDisagree = {$: 4};
var $author$project$Evergreen$V417$Go$PressedDoneMarking = {$: 2};
var $author$project$Evergreen$V417$Go$PressedJoinGame = {$: 5};
var $author$project$Evergreen$V417$Go$PressedPass = {$: 1};
var $author$project$Evergreen$V417$Go$SpectatorMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Evergreen$V417$Go$ChangedViewingMove = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$Go$PressedArrowLeft = {$: 0};
var $author$project$Evergreen$V417$Go$PressedArrowRight = {$: 1};
var $author$project$Evergreen$V417$Go$Spectator_PressedCell = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V417$Go$w3_unsafe_decode_SpectatorMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$ChangedViewingMove));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$PressedArrowLeft);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$PressedArrowRight);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$Spectator_PressedCell));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Go$w3_unsafe_decode_GameMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$PressedAgree);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$PressedCell));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$PressedDisagree);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$PressedDoneMarking);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$PressedJoinGame);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$PressedPass);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Go$w3_unsafe_decode_SpectatorMsg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$SpectatorMsg));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$SheepGame$ExitedQuestion = function (a) {
	return {$: 19, a: a};
};
var $author$project$Evergreen$V417$SheepGame$ExitedResultsGrid = function (a) {
	return {$: 21, a: a};
};
var $author$project$Evergreen$V417$SheepGame$GotAnswerFileUpload$ = function (a, b, c) {
	return {$: 2, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$SheepGame$GotAnswerFileUpload = F3($author$project$Evergreen$V417$SheepGame$GotAnswerFileUpload$);
var $author$project$Evergreen$V417$SheepGame$GotAnswerFiles$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V417$SheepGame$GotAnswerFiles = F2($author$project$Evergreen$V417$SheepGame$GotAnswerFiles$);
var $author$project$Evergreen$V417$SheepGame$GotNotesFileUpload$ = function (a, b, c) {
	return {$: 11, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$SheepGame$GotNotesFileUpload = F3($author$project$Evergreen$V417$SheepGame$GotNotesFileUpload$);
var $author$project$Evergreen$V417$SheepGame$GotNotesFiles$ = function (a, b) {
	return {$: 10, a: a, b: b};
};
var $author$project$Evergreen$V417$SheepGame$GotNotesFiles = F2($author$project$Evergreen$V417$SheepGame$GotNotesFiles$);
var $author$project$Evergreen$V417$SheepGame$HoveredQuestion = function (a) {
	return {$: 18, a: a};
};
var $author$project$Evergreen$V417$SheepGame$HoveredResultsGrid = function (a) {
	return {$: 20, a: a};
};
var $author$project$Evergreen$V417$SheepGame$NoOp = {$: 27};
var $author$project$Evergreen$V417$SheepGame$PressedCopyCode = function (a) {
	return {$: 25, a: a};
};
var $author$project$Evergreen$V417$SheepGame$PressedDeleteAnswerFile$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Evergreen$V417$SheepGame$PressedDeleteAnswerFile = F2($author$project$Evergreen$V417$SheepGame$PressedDeleteAnswerFile$);
var $author$project$Evergreen$V417$SheepGame$PressedDeleteNotesFile$ = function (a, b) {
	return {$: 12, a: a, b: b};
};
var $author$project$Evergreen$V417$SheepGame$PressedDeleteNotesFile = F2($author$project$Evergreen$V417$SheepGame$PressedDeleteNotesFile$);
var $author$project$Evergreen$V417$SheepGame$PressedHidePreviousQuestion = {$: 17};
var $author$project$Evergreen$V417$SheepGame$PressedImage = function (a) {
	return {$: 24, a: a};
};
var $author$project$Evergreen$V417$SheepGame$PressedLockAnswers = {$: 6};
var $author$project$Evergreen$V417$SheepGame$PressedNewQuestionRevealed = {$: 26};
var $author$project$Evergreen$V417$SheepGame$PressedRevealScores = {$: 15};
var $author$project$Evergreen$V417$SheepGame$PressedShowNextQuestion = {$: 16};
var $author$project$Evergreen$V417$SheepGame$PressedToggleAnswerFileSpoiler$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$Evergreen$V417$SheepGame$PressedToggleAnswerFileSpoiler = F2($author$project$Evergreen$V417$SheepGame$PressedToggleAnswerFileSpoiler$);
var $author$project$Evergreen$V417$SheepGame$PressedToggleNotesFileSpoiler$ = function (a, b) {
	return {$: 14, a: a, b: b};
};
var $author$project$Evergreen$V417$SheepGame$PressedToggleNotesFileSpoiler = F2($author$project$Evergreen$V417$SheepGame$PressedToggleNotesFileSpoiler$);
var $author$project$Evergreen$V417$SheepGame$PressedUnlockAnswers = {$: 7};
var $author$project$Evergreen$V417$SheepGame$PressedViewAnswerFileInfo$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $author$project$Evergreen$V417$SheepGame$PressedViewAnswerFileInfo = F2($author$project$Evergreen$V417$SheepGame$PressedViewAnswerFileInfo$);
var $author$project$Evergreen$V417$SheepGame$PressedViewNotesFileInfo$ = function (a, b) {
	return {$: 13, a: a, b: b};
};
var $author$project$Evergreen$V417$SheepGame$PressedViewNotesFileInfo = F2($author$project$Evergreen$V417$SheepGame$PressedViewNotesFileInfo$);
var $author$project$Evergreen$V417$SheepGame$ReactionMsg$ = function (a, b) {
	return {$: 23, a: a, b: b};
};
var $author$project$Evergreen$V417$SheepGame$ReactionMsg = F2($author$project$Evergreen$V417$SheepGame$ReactionMsg$);
var $author$project$Evergreen$V417$SheepGame$TypedAnswer$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$SheepGame$TypedAnswer = F2($author$project$Evergreen$V417$SheepGame$TypedAnswer$);
var $author$project$Evergreen$V417$SheepGame$TypedGroup$ = function (a, b, c) {
	return {$: 8, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$SheepGame$TypedGroup = F3($author$project$Evergreen$V417$SheepGame$TypedGroup$);
var $author$project$Evergreen$V417$SheepGame$TypedNotes$ = function (a, b) {
	return {$: 9, a: a, b: b};
};
var $author$project$Evergreen$V417$SheepGame$TypedNotes = F2($author$project$Evergreen$V417$SheepGame$TypedNotes$);
var $author$project$Evergreen$V417$SheepGame$UserScrolledResults = function (a) {
	return {$: 22, a: a};
};
var $author$project$Evergreen$V417$MessageInput$IgnoreTouchStart = {$: 14};
var $author$project$Evergreen$V417$MessageInput$IgnoredKeyPress = {$: 13};
var $author$project$Evergreen$V417$MessageInput$OnPasteFiles = function (a) {
	return {$: 9, a: a};
};
var $author$project$Evergreen$V417$MessageInput$PressedDropdownItem = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V417$MessageInput$PressedOpenEmojiSelector = {$: 8};
var $author$project$Evergreen$V417$MessageInput$PressedPingDropdownContainer = {$: 6};
var $author$project$Evergreen$V417$MessageInput$PressedSendMessage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$MessageInput$PressedTextInput = {$: 0};
var $author$project$Evergreen$V417$MessageInput$PressedUploadFile = {$: 7};
var $author$project$Evergreen$V417$MessageInput$TypedArrowInDropdown = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V417$MessageInput$TypedArrowUpInEmptyInput = {$: 4};
var $author$project$Evergreen$V417$MessageInput$TypedMessage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$MessageInput$TypedPageDown = {$: 11};
var $author$project$Evergreen$V417$MessageInput$TypedPageUp = {$: 10};
var $author$project$Evergreen$V417$MessageInput$TypedTabInCodeBlock = function (a) {
	return {$: 12, a: a};
};
var $author$project$Evergreen$V417$MessageInput$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageInput$IgnoreTouchStart);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageInput$IgnoredKeyPress);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty($lamdera$program_test$Effect$File$w3_unsafe_decode_File),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageInput$OnPasteFiles));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageInput$PressedDropdownItem));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageInput$PressedOpenEmojiSelector);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageInput$PressedPingDropdownContainer);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							function (charsLeft0) {
								return {charsLeft: charsLeft0};
							})),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageInput$PressedSendMessage));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageInput$PressedTextInput);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageInput$PressedUploadFile);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageInput$TypedArrowInDropdown));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageInput$TypedArrowUpInEmptyInput);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageInput$TypedMessage));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageInput$TypedPageDown);
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageInput$TypedPageUp);
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Range$w3_unsafe_decode_Range,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$MessageInput$TypedTabInCodeBlock));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_UploadResponse = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_VideoMetadata),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_ImageMetadata),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileHash,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (fileHash0, imageMetadata0, videoMetadata0) {
						return {fileHash: fileHash0, imageMetadata: imageMetadata0, videoMetadata: videoMetadata0};
					})))));
var $author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_GameMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$ExitedQuestion));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$ExitedResultsGrid));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Http$w3_unsafe_decode_Error, $author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_UploadResponse),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$GotAnswerFileUpload))));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty($lamdera$program_test$Effect$File$w3_unsafe_decode_File),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$GotAnswerFiles)));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Http$w3_unsafe_decode_Error, $author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_UploadResponse),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$GotNotesFileUpload))));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty($lamdera$program_test$Effect$File$w3_unsafe_decode_File),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$GotNotesFiles)));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$HoveredQuestion));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$HoveredResultsGrid));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$NoOp);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$PressedCopyCode));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$PressedDeleteAnswerFile)));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$PressedDeleteNotesFile)));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$PressedHidePreviousQuestion);
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$RichText$w3_unsafe_decode_PressedImageData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$PressedImage));
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$PressedLockAnswers);
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$PressedNewQuestionRevealed);
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$PressedRevealScores);
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$PressedShowNextQuestion);
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (fileId0, removeSpoiler0) {
										return {fileId: fileId0, removeSpoiler: removeSpoiler0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$PressedToggleAnswerFileSpoiler)));
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (fileId0, removeSpoiler0) {
										return {fileId: fileId0, removeSpoiler: removeSpoiler0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$PressedToggleNotesFileSpoiler)));
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$PressedUnlockAnswers);
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$PressedViewAnswerFileInfo)));
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$PressedViewNotesFileInfo)));
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MessageView$w3_unsafe_decode_MessageViewMsg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_ReactionTarget,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$ReactionMsg)));
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MessageInput$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$TypedAnswer)));
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$TypedGroup))));
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MessageInput$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$TypedNotes)));
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Scroll$w3_unsafe_decode_ScrollPosition,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$UserScrolledResults));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$WordSpellingGame$GotWordDefinition$ = function (a, b) {
	return {$: 16, a: a, b: b};
};
var $author$project$Evergreen$V417$WordSpellingGame$GotWordDefinition = F2($author$project$Evergreen$V417$WordSpellingGame$GotWordDefinition$);
var $author$project$Evergreen$V417$WordSpellingGame$MouseEnterPlayerRow = function (a) {
	return {$: 6, a: a};
};
var $author$project$Evergreen$V417$WordSpellingGame$MouseEnterWord$ = function (a, b, c) {
	return {$: 8, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$WordSpellingGame$MouseEnterWord = F3($author$project$Evergreen$V417$WordSpellingGame$MouseEnterWord$);
var $author$project$Evergreen$V417$WordSpellingGame$MouseExitPlayerRow = function (a) {
	return {$: 7, a: a};
};
var $author$project$Evergreen$V417$WordSpellingGame$MouseExitWord = {$: 9};
var $author$project$Evergreen$V417$WordSpellingGame$PressedClearBoard = {$: 3};
var $author$project$Evergreen$V417$WordSpellingGame$PressedCloseWordDefinition = {$: 15};
var $author$project$Evergreen$V417$WordSpellingGame$PressedJoinGame = {$: 1};
var $author$project$Evergreen$V417$WordSpellingGame$PressedNextWordDefinition = {$: 14};
var $author$project$Evergreen$V417$WordSpellingGame$PressedPlayerRow = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V417$WordSpellingGame$PressedPreviousWordDefinition = {$: 13};
var $author$project$Evergreen$V417$WordSpellingGame$PressedReplaceTrayOrPass = {$: 2};
var $author$project$Evergreen$V417$WordSpellingGame$PressedSubmitPremove = function (a) {
	return {$: 11, a: a};
};
var $author$project$Evergreen$V417$WordSpellingGame$PressedSubmitWord = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$WordSpellingGame$PressedToggleSettings = {$: 4};
var $author$project$Evergreen$V417$WordSpellingGame$PressedWordDefinition = function (a) {
	return {$: 12, a: a};
};
var $author$project$Evergreen$V417$WordSpellingGame$ReactionMsg$ = function (a, b) {
	return {$: 17, a: a, b: b};
};
var $author$project$Evergreen$V417$WordSpellingGame$ReactionMsg = F2($author$project$Evergreen$V417$WordSpellingGame$ReactionMsg$);
var $author$project$Evergreen$V417$WordSpellingGame$UserScrolledPastMoves = function (a) {
	return {$: 10, a: a};
};
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_GameMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$(
						$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
						$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_DictEntry)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$GotWordDefinition)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$MouseEnterPlayerRow));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_Shared,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeList(
							$lamdera$codecs$Lamdera$Wire3$decodePair$(
								$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
								$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$MouseEnterWord))));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$MouseExitPlayerRow));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$MouseExitWord);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$PressedClearBoard);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$PressedCloseWordDefinition);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$PressedJoinGame);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$PressedNextWordDefinition);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$PressedPlayerRow));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$PressedPreviousWordDefinition);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$PressedReplaceTrayOrPass);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_PlacedWord,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$PressedSubmitPremove));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_PlacedWord,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$PressedSubmitWord));
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$PressedToggleSettings);
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$PressedWordDefinition));
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MessageView$w3_unsafe_decode_MessageViewMsg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_ReactionTarget,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$ReactionMsg)));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Scroll$w3_unsafe_decode_ScrollPosition,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$UserScrolledPastMoves));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Go$ChangedHandicapInput = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$Go$ChangedHeightInput = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Go$ChangedIncrementInput = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V417$Go$ChangedKomiInput = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V417$Go$ChangedMainTimeInput = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V417$Go$ChangedWidthInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Go$PressedCancel = {$: 9};
var $author$project$Evergreen$V417$Go$PressedStartGame = {$: 8};
var $author$project$Evergreen$V417$Go$SelectedPlayingAs = function (a) {
	return {$: 7, a: a};
};
var $author$project$Evergreen$V417$Go$SelectedSize = function (a) {
	return {$: 6, a: a};
};
var $author$project$Evergreen$V417$Go$w3_unsafe_decode_SetupMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$ChangedHandicapInput));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$ChangedHeightInput));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$ChangedIncrementInput));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$ChangedKomiInput));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$ChangedMainTimeInput));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$ChangedWidthInput));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$PressedCancel);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$PressedStartGame);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Go$w3_unsafe_decode_Stone,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$SelectedPlayingAs));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Go$w3_unsafe_decode_SizeSelection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Go$SelectedSize));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$SheepGame$GotAttachedFileUpload$ = function (a, b, c) {
	return {$: 6, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$SheepGame$GotAttachedFileUpload = F3($author$project$Evergreen$V417$SheepGame$GotAttachedFileUpload$);
var $author$project$Evergreen$V417$SheepGame$GotFilesToAttach$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$Evergreen$V417$SheepGame$GotFilesToAttach = F2($author$project$Evergreen$V417$SheepGame$GotFilesToAttach$);
var $author$project$Evergreen$V417$SheepGame$PressedAddQuestion = {$: 1};
var $author$project$Evergreen$V417$SheepGame$PressedCancel = {$: 4};
var $author$project$Evergreen$V417$SheepGame$PressedDeleteAttachedFile$ = function (a, b) {
	return {$: 7, a: a, b: b};
};
var $author$project$Evergreen$V417$SheepGame$PressedDeleteAttachedFile = F2($author$project$Evergreen$V417$SheepGame$PressedDeleteAttachedFile$);
var $author$project$Evergreen$V417$SheepGame$PressedRemoveQuestion = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$SheepGame$PressedStartGame = {$: 3};
var $author$project$Evergreen$V417$SheepGame$PressedToggleAttachedFileSpoiler$ = function (a, b) {
	return {$: 9, a: a, b: b};
};
var $author$project$Evergreen$V417$SheepGame$PressedToggleAttachedFileSpoiler = F2($author$project$Evergreen$V417$SheepGame$PressedToggleAttachedFileSpoiler$);
var $author$project$Evergreen$V417$SheepGame$PressedViewAttachedFileInfo$ = function (a, b) {
	return {$: 8, a: a, b: b};
};
var $author$project$Evergreen$V417$SheepGame$PressedViewAttachedFileInfo = F2($author$project$Evergreen$V417$SheepGame$PressedViewAttachedFileInfo$);
var $author$project$Evergreen$V417$SheepGame$TypedQuestion$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Evergreen$V417$SheepGame$TypedQuestion = F2($author$project$Evergreen$V417$SheepGame$TypedQuestion$);
var $author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_SetupMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Http$w3_unsafe_decode_Error, $author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_UploadResponse),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$GotAttachedFileUpload))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty($lamdera$program_test$Effect$File$w3_unsafe_decode_File),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$GotFilesToAttach)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$PressedAddQuestion);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$PressedCancel);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$PressedDeleteAttachedFile)));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$PressedRemoveQuestion));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$PressedStartGame);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (fileId0, removeSpoiler0) {
										return {fileId: fileId0, removeSpoiler: removeSpoiler0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$PressedToggleAttachedFileSpoiler)));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$PressedViewAttachedFileInfo)));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MessageInput$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$SheepGame$TypedQuestion)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$WordSpellingGame$ChangedFullTrayBonusInput = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$WordSpellingGame$ChangedLetterValue$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Evergreen$V417$WordSpellingGame$ChangedLetterValue = F2($author$project$Evergreen$V417$WordSpellingGame$ChangedLetterValue$);
var $author$project$Evergreen$V417$WordSpellingGame$ChangedLettersInput = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$WordSpellingGame$ChangedPlaceWordAttempts = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V417$WordSpellingGame$ChangedTraySizeInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$WordSpellingGame$PressedCancel = {$: 7};
var $author$project$Evergreen$V417$WordSpellingGame$PressedExpandAdvancedSettings = {$: 9};
var $author$project$Evergreen$V417$WordSpellingGame$PressedLanguage = function (a) {
	return {$: 8, a: a};
};
var $author$project$Evergreen$V417$WordSpellingGame$PressedResetLetters = {$: 5};
var $author$project$Evergreen$V417$WordSpellingGame$PressedStartGame = {$: 6};
var $author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_SetupMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$ChangedFullTrayBonusInput));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeChar,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$ChangedLetterValue)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$ChangedLettersInput));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$OneOrGreater$w3_unsafe_decode_OneOrGreater,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$ChangedPlaceWordAttempts));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$ChangedTraySizeInput));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$PressedCancel);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$PressedExpandAdvancedSettings);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_Language,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$PressedLanguage));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$PressedResetLetters);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$WordSpellingGame$PressedStartGame);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Game$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Go$w3_unsafe_decode_GameMsg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$GoGameMsg));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Go$w3_unsafe_decode_SetupMsg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$GoSetupMsg));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$NoOpMsg);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$PressedCopyLink));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$PressedReset);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Message$w3_unsafe_decode_GameType,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$PressedSelectGame));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$PressedShareMatch));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$SelectedMatch));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_GameMsg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$SheepGameMsg));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_SetupMsg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$SheepSetupMsg));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_GameMsg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$WordSpellingGameMsg));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$WordSpellingGame$w3_unsafe_decode_SetupMsg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Game$WordSpellingSetupMsg));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$ImageEditor$CroppedImage = function (a) {
	return {$: 9, a: a};
};
var $author$project$Evergreen$V417$ImageEditor$GotImageSize = function (a) {
	return {$: 8, a: a};
};
var $author$project$Evergreen$V417$ImageEditor$GotImageUrl = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$ImageEditor$MouseDownImageEditor$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Evergreen$V417$ImageEditor$MouseDownImageEditor = F2($author$project$Evergreen$V417$ImageEditor$MouseDownImageEditor$);
var $author$project$Evergreen$V417$ImageEditor$MouseUpImageEditor = {$: 4};
var $author$project$Evergreen$V417$ImageEditor$MovedImageEditor$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$Evergreen$V417$ImageEditor$MovedImageEditor = F2($author$project$Evergreen$V417$ImageEditor$MovedImageEditor$);
var $author$project$Evergreen$V417$ImageEditor$PressedCancel = {$: 10};
var $author$project$Evergreen$V417$ImageEditor$PressedConfirmImage = {$: 7};
var $author$project$Evergreen$V417$ImageEditor$PressedProfileImage = {$: 0};
var $author$project$Evergreen$V417$ImageEditor$PressedRemoveImage = {$: 11};
var $author$project$Evergreen$V417$ImageEditor$SelectedImage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$ImageEditor$TouchEndImageEditor = {$: 6};
var $author$project$Evergreen$V417$ImageEditor$UploadedImage = function (a) {
	return {$: 12, a: a};
};
var $author$project$Evergreen$V417$Ports$w3_unsafe_decode_CropImageDataResponse = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (croppedImageUrl0, requestId0) {
					return {croppedImageUrl: croppedImageUrl0, requestId: requestId0};
				}))));
var $author$project$Evergreen$V417$ImageEditor$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeString, $author$project$Evergreen$V417$Ports$w3_unsafe_decode_CropImageDataResponse),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageEditor$CroppedImage));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Error, $lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Element),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageEditor$GotImageSize));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageEditor$GotImageUrl));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageEditor$MouseDownImageEditor)));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageEditor$MouseUpImageEditor);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageEditor$MovedImageEditor)));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageEditor$PressedCancel);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageEditor$PressedConfirmImage);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageEditor$PressedProfileImage);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageEditor$PressedRemoveImage);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$File$w3_unsafe_decode_File,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageEditor$SelectedImage));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageEditor$TouchEndImageEditor);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Http$w3_unsafe_decode_Error, $author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_UploadResponse),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageEditor$UploadedImage));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$ImageViewer$AnimationFrame = function (a) {
	return {$: 11, a: a};
};
var $author$project$Evergreen$V417$ImageViewer$MouseDown$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $author$project$Evergreen$V417$ImageViewer$MouseDown = F2($author$project$Evergreen$V417$ImageViewer$MouseDown$);
var $author$project$Evergreen$V417$ImageViewer$MouseMove$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$Evergreen$V417$ImageViewer$MouseMove = F2($author$project$Evergreen$V417$ImageViewer$MouseMove$);
var $author$project$Evergreen$V417$ImageViewer$MouseUp = {$: 6};
var $author$project$Evergreen$V417$ImageViewer$PressStartedOnButton = {$: 3};
var $author$project$Evergreen$V417$ImageViewer$PressedClose = {$: 0};
var $author$project$Evergreen$V417$ImageViewer$PressedZoomIn = {$: 1};
var $author$project$Evergreen$V417$ImageViewer$PressedZoomOut = {$: 2};
var $author$project$Evergreen$V417$ImageViewer$TouchEnd = {$: 10};
var $author$project$Evergreen$V417$ImageViewer$TouchMove = function (a) {
	return {$: 9, a: a};
};
var $author$project$Evergreen$V417$ImageViewer$TouchStart = function (a) {
	return {$: 8, a: a};
};
var $author$project$Evergreen$V417$ImageViewer$Wheeled$ = function (a, b, c) {
	return {$: 7, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$ImageViewer$Wheeled = F3($author$project$Evergreen$V417$ImageViewer$Wheeled$);
var $author$project$Evergreen$V417$ImageViewer$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageViewer$AnimationFrame));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageViewer$MouseDown)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageViewer$MouseMove)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageViewer$MouseUp);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageViewer$PressStartedOnButton);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageViewer$PressedClose);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageViewer$PressedZoomIn);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageViewer$PressedZoomOut);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageViewer$TouchEnd);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $lamdera$codecs$Lamdera$Wire3$decodeFloat)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageViewer$TouchMove));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $lamdera$codecs$Lamdera$Wire3$decodeFloat)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageViewer$TouchStart));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeFloat,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$ImageViewer$Wheeled))));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$LoginForm$PressedCancelLogin = {$: 1};
var $author$project$Evergreen$V417$LoginForm$PressedSubmitEmail = {$: 0};
var $author$project$Evergreen$V417$LoginForm$PressedSubmitUserData = {$: 6};
var $author$project$Evergreen$V417$LoginForm$TypedLoginCode = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V417$LoginForm$TypedLoginFormEmail = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$LoginForm$TypedName = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V417$LoginForm$TypedTwoFactorCode = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V417$LoginForm$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LoginForm$PressedCancelLogin);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LoginForm$PressedSubmitEmail);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LoginForm$PressedSubmitUserData);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LoginForm$TypedLoginCode));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LoginForm$TypedLoginFormEmail));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LoginForm$TypedName));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$LoginForm$TypedTwoFactorCode));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Pages$Admin$DiscordLinkLimitEditableMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$EditCellLostFocus$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$Evergreen$V417$Pages$Admin$EditCellLostFocus = F2($author$project$Evergreen$V417$Pages$Admin$EditCellLostFocus$);
var $author$project$Evergreen$V417$Pages$Admin$EnterKeyInEditCell$ = function (a, b) {
	return {$: 7, a: a, b: b};
};
var $author$project$Evergreen$V417$Pages$Admin$EnterKeyInEditCell = F2($author$project$Evergreen$V417$Pages$Admin$EnterKeyInEditCell$);
var $author$project$Evergreen$V417$Pages$Admin$EscapeKeyInEditCell = {$: 11};
var $author$project$Evergreen$V417$Pages$Admin$FocusedOnEditCell = {$: 6};
var $author$project$Evergreen$V417$Pages$Admin$GotImportBackendFileContent = function (a) {
	return {$: 55, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$ImportBackendFileSelected = function (a) {
	return {$: 54, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$NotifyAdminsBotUserIdEditableMsg = function (a) {
	return {$: 36, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$NotifyAdminsTokenEditableMsg = function (a) {
	return {$: 35, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$OpenRouterKeyEditableMsg = function (a) {
	return {$: 34, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$PostmarkKeyEditableMsg = function (a) {
	return {$: 37, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$PressedAddUserRow = {$: 12};
var $author$project$Evergreen$V417$Pages$Admin$PressedCancelExportSubset = {$: 52};
var $author$project$Evergreen$V417$Pages$Admin$PressedConfirmExportSubset = {$: 51};
var $author$project$Evergreen$V417$Pages$Admin$PressedCopyLogLink = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$PressedCopyText = function (a) {
	return {$: 42, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$PressedDeleteDiscordDmChannel = function (a) {
	return {$: 23, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$PressedDeleteDiscordGuild = function (a) {
	return {$: 24, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$PressedDeleteGuild = function (a) {
	return {$: 30, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$PressedDeleteOrphanedFiles = {$: 59};
var $author$project$Evergreen$V417$Pages$Admin$PressedDeleteSession = function (a) {
	return {$: 57, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$PressedDeleteSlackDmChannel = function (a) {
	return {$: 28, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$PressedDeleteSlackWorkspace = function (a) {
	return {$: 26, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$PressedDeleteUser = function (a) {
	return {$: 13, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$PressedDisconnectClient$ = function (a, b) {
	return {$: 56, a: a, b: b};
};
var $author$project$Evergreen$V417$Pages$Admin$PressedDisconnectClient = F2($author$project$Evergreen$V417$Pages$Admin$PressedDisconnectClient$);
var $author$project$Evergreen$V417$Pages$Admin$PressedDownloadLastBackup = {$: 46};
var $author$project$Evergreen$V417$Pages$Admin$PressedEditCell$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Evergreen$V417$Pages$Admin$PressedEditCell = F2($author$project$Evergreen$V417$Pages$Admin$PressedEditCell$);
var $author$project$Evergreen$V417$Pages$Admin$PressedExpandDiscordGuild = function (a) {
	return {$: 25, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$PressedExpandGuild = function (a) {
	return {$: 29, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$PressedExpandSection = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$PressedExpandSlackWorkspace = function (a) {
	return {$: 27, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$PressedExportBackend = {$: 44};
var $author$project$Evergreen$V417$Pages$Admin$PressedExportSubsetBackend = {$: 45};
var $author$project$Evergreen$V417$Pages$Admin$PressedHomepageLink = {$: 38};
var $author$project$Evergreen$V417$Pages$Admin$PressedImportBackend = {$: 53};
var $author$project$Evergreen$V417$Pages$Admin$PressedLogPage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$PressedRegenerateServerSecret = {$: 58};
var $author$project$Evergreen$V417$Pages$Admin$PressedReloadDiscordChannel$ = function (a, b, c) {
	return {$: 39, a: a, b: b, c: c};
};
var $author$project$Evergreen$V417$Pages$Admin$PressedReloadDiscordChannel = F3($author$project$Evergreen$V417$Pages$Admin$PressedReloadDiscordChannel$);
var $author$project$Evergreen$V417$Pages$Admin$PressedReloadDiscordDmChannel$ = function (a, b) {
	return {$: 40, a: a, b: b};
};
var $author$project$Evergreen$V417$Pages$Admin$PressedReloadDiscordDmChannel = F2($author$project$Evergreen$V417$Pages$Admin$PressedReloadDiscordDmChannel$);
var $author$project$Evergreen$V417$Pages$Admin$PressedReloadDiscordGuild$ = function (a, b) {
	return {$: 41, a: a, b: b};
};
var $author$project$Evergreen$V417$Pages$Admin$PressedReloadDiscordGuild = F2($author$project$Evergreen$V417$Pages$Admin$PressedReloadDiscordGuild$);
var $author$project$Evergreen$V417$Pages$Admin$PressedResetUser = function (a) {
	return {$: 14, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$PressedResetUserChanges = {$: 10};
var $author$project$Evergreen$V417$Pages$Admin$PressedRestoreGuild = function (a) {
	return {$: 31, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$PressedSaveUserChanges = {$: 8};
var $author$project$Evergreen$V417$Pages$Admin$PressedSendTypeThatIsAlwaysInvalid = {$: 61};
var $author$project$Evergreen$V417$Pages$Admin$PressedWebsocketCloseEventsPage = function (a) {
	return {$: 60, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$PrivateVapidKeyEditableMsg = function (a) {
	return {$: 33, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$PublicVapidKeyEditableMsg = function (a) {
	return {$: 32, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$SlackLinkLimitEditableMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$TabKeyInEditCell = function (a) {
	return {$: 9, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$ToggleIsAdmin$ = function (a, b) {
	return {$: 22, a: a, b: b};
};
var $author$project$Evergreen$V417$Pages$Admin$ToggleIsAdmin = F2($author$project$Evergreen$V417$Pages$Admin$ToggleIsAdmin$);
var $author$project$Evergreen$V417$Pages$Admin$ToggledDiscordLinkingEnabled = function (a) {
	return {$: 18, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$ToggledEmailNotifications = function (a) {
	return {$: 16, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$ToggledExportSubsetDiscordDmChannel$ = function (a, b) {
	return {$: 50, a: a, b: b};
};
var $author$project$Evergreen$V417$Pages$Admin$ToggledExportSubsetDiscordDmChannel = F2($author$project$Evergreen$V417$Pages$Admin$ToggledExportSubsetDiscordDmChannel$);
var $author$project$Evergreen$V417$Pages$Admin$ToggledExportSubsetDiscordGuild$ = function (a, b) {
	return {$: 49, a: a, b: b};
};
var $author$project$Evergreen$V417$Pages$Admin$ToggledExportSubsetDiscordGuild = F2($author$project$Evergreen$V417$Pages$Admin$ToggledExportSubsetDiscordGuild$);
var $author$project$Evergreen$V417$Pages$Admin$ToggledExportSubsetDmChannel$ = function (a, b) {
	return {$: 48, a: a, b: b};
};
var $author$project$Evergreen$V417$Pages$Admin$ToggledExportSubsetDmChannel = F2($author$project$Evergreen$V417$Pages$Admin$ToggledExportSubsetDmChannel$);
var $author$project$Evergreen$V417$Pages$Admin$ToggledExportSubsetGuild$ = function (a, b) {
	return {$: 47, a: a, b: b};
};
var $author$project$Evergreen$V417$Pages$Admin$ToggledExportSubsetGuild = F2($author$project$Evergreen$V417$Pages$Admin$ToggledExportSubsetGuild$);
var $author$project$Evergreen$V417$Pages$Admin$ToggledSignupsEnabled = function (a) {
	return {$: 17, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$ToggledSlackLinkingEnabled = function (a) {
	return {$: 20, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$TypedEditCell = function (a) {
	return {$: 4, a: a};
};
var $author$project$Evergreen$V417$Pages$Admin$TypedInReadOnlyTextInput = {$: 43};
var $author$project$Evergreen$V417$Pages$Admin$UserTableMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Evergreen$V417$Table$PressedShowAll = {$: 1};
var $author$project$Evergreen$V417$Table$PressedSortBy = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Table$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Table$PressedShowAll);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Table$PressedSortBy));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Editable$w3_unsafe_decode_Msg(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$DiscordLinkLimitEditableMsg));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_UserColumn,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_UserTableId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$EditCellLostFocus)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_UserColumn,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_UserTableId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$EnterKeyInEditCell)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$EscapeKeyInEditCell);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$FocusedOnEditCell);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBytes,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$GotImportBackendFileContent));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$File$w3_unsafe_decode_File,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$ImportBackendFileSelected));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Editable$w3_unsafe_decode_Msg(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$NotifyAdminsBotUserIdEditableMsg));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Editable$w3_unsafe_decode_Msg(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$NotifyAdminsTokenEditableMsg));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Editable$w3_unsafe_decode_Msg(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$OpenRouterKeyEditableMsg));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Editable$w3_unsafe_decode_Msg($author$project$Evergreen$V417$Postmark$w3_unsafe_decode_ApiKey),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PostmarkKeyEditableMsg));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedAddUserRow);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedCancelExportSubset);
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedConfirmExportSubset);
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Pagination$w3_unsafe_decode_ItemId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedCopyLogLink));
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedCopyText));
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedDeleteDiscordDmChannel));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedDeleteDiscordGuild));
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedDeleteGuild));
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedDeleteOrphanedFiles);
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$SessionIdHash$w3_unsafe_decode_SessionIdHash,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedDeleteSession));
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_DmChannelId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedDeleteSlackDmChannel));
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedDeleteSlackWorkspace));
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_UserTableId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedDeleteUser));
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$SessionIdHash$w3_unsafe_decode_SessionIdHash,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedDisconnectClient)));
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedDownloadLastBackup);
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_UserColumn,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_UserTableId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedEditCell)));
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedExpandDiscordGuild));
			case 28:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedExpandGuild));
			case 29:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_AdminUiSection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedExpandSection));
			case 30:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedExpandSlackWorkspace));
			case 31:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedExportBackend);
			case 32:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedExportSubsetBackend);
			case 33:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedHomepageLink);
			case 34:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedImportBackend);
			case 35:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Pagination$w3_unsafe_decode_PageId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedLogPage));
			case 36:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedRegenerateServerSecret);
			case 37:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedReloadDiscordChannel))));
			case 38:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedReloadDiscordDmChannel)));
			case 39:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedReloadDiscordGuild)));
			case 40:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedResetUser));
			case 41:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedResetUserChanges);
			case 42:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedRestoreGuild));
			case 43:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedSaveUserChanges);
			case 44:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedSendTypeThatIsAlwaysInvalid);
			case 45:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PressedWebsocketCloseEventsPage));
			case 46:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Editable$w3_unsafe_decode_Msg($author$project$Evergreen$V417$LocalState$w3_unsafe_decode_PrivateVapidKey),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PrivateVapidKeyEditableMsg));
			case 47:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Editable$w3_unsafe_decode_Msg($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$PublicVapidKeyEditableMsg));
			case 48:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Editable$w3_unsafe_decode_Msg(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$SlackLinkLimitEditableMsg));
			case 49:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$TabKeyInEditCell));
			case 50:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_UserTableId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$ToggleIsAdmin)));
			case 51:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$ToggledDiscordLinkingEnabled));
			case 52:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$ToggledEmailNotifications));
			case 53:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$ToggledExportSubsetDiscordDmChannel)));
			case 54:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$ToggledExportSubsetDiscordGuild)));
			case 55:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$DmChannelId$w3_unsafe_decode_DmChannelId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$ToggledExportSubsetDmChannel)));
			case 56:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$ToggledExportSubsetGuild)));
			case 57:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$ToggledSignupsEnabled));
			case 58:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$ToggledSlackLinkingEnabled));
			case 59:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$TypedEditCell));
			case 60:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$TypedInReadOnlyTextInput);
			case 61:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Table$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Pages$Admin$UserTableMsg));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$RecoveryLogin$PressedSubmit = {$: 1};
var $author$project$Evergreen$V417$RecoveryLogin$TypedPassword = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$RecoveryLogin$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$RecoveryLogin$PressedSubmit);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$RecoveryLogin$TypedPassword));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$TextEditor$PressedBack = {$: 4};
var $author$project$Evergreen$V417$TextEditor$PressedReset = {$: 1};
var $author$project$Evergreen$V417$TextEditor$RedoChange = {$: 3};
var $author$project$Evergreen$V417$TextEditor$TypedText = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$TextEditor$UndoChange = {$: 2};
var $author$project$Evergreen$V417$TextEditor$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$TextEditor$PressedBack);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$TextEditor$PressedReset);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$TextEditor$RedoChange);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$TextEditor$TypedText));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$TextEditor$UndoChange);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$TwoFactorAuthentication$PressedCancelDisable2Fa = {$: 4};
var $author$project$Evergreen$V417$TwoFactorAuthentication$PressedCopy = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$TwoFactorAuthentication$PressedStart2FaSetup = {$: 0};
var $author$project$Evergreen$V417$TwoFactorAuthentication$PressedStartDisable2Fa = {$: 3};
var $author$project$Evergreen$V417$TwoFactorAuthentication$TypedDisableTwoFactorCode = function (a) {
	return {$: 5, a: a};
};
var $author$project$Evergreen$V417$TwoFactorAuthentication$TypedTwoFactorCode = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$TwoFactorAuthentication$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$TwoFactorAuthentication$PressedCancelDisable2Fa);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$TwoFactorAuthentication$PressedCopy));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$TwoFactorAuthentication$PressedStart2FaSetup);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$TwoFactorAuthentication$PressedStartDisable2Fa);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$TwoFactorAuthentication$TypedDisableTwoFactorCode));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$TwoFactorAuthentication$TypedTwoFactorCode));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Internal$Model2$Teleported$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Evergreen$V417$Internal$Model2$Teleported = F2($author$project$Evergreen$V417$Internal$Model2$Teleported$);
var $author$project$Evergreen$V417$Internal$Model2$Tick = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Internal$Teleport$Css = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Internal$Teleport$ParentTrigger = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Internal$Teleport$w3_unsafe_decode_CssAnimation = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList(
				$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeString, $lamdera$codecs$Lamdera$Wire3$decodeString)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F6(
								function (hash0, keyframes0, keyframesHash0, props0, transition0, trigger0) {
									return {hash: hash0, keyframes: keyframes0, keyframesHash: keyframesHash0, props: props0, transition: transition0, trigger: trigger0};
								}))))))));
var $author$project$Evergreen$V417$Internal$Teleport$w3_unsafe_decode_ParentTriggerDetails = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V417$Internal$Teleport$w3_unsafe_decode_CssAnimation),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (children0, identifierClass0, trigger0) {
						return {children: children0, identifierClass: identifierClass0, trigger: trigger0};
					})))));
var $author$project$Evergreen$V417$Internal$Teleport$w3_unsafe_decode_Data = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Internal$Teleport$w3_unsafe_decode_CssAnimation,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Internal$Teleport$Css));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Internal$Teleport$w3_unsafe_decode_ParentTriggerDetails,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Internal$Teleport$ParentTrigger));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Internal$Teleport$w3_unsafe_decode_Event = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeFloat,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V417$Internal$Teleport$w3_unsafe_decode_Data),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (data0, timestamp0) {
					return {data: data0, timestamp: timestamp0};
				}))));
var $author$project$Evergreen$V417$Internal$Teleport$OnActive = 4;
var $author$project$Evergreen$V417$Internal$Teleport$OnDismount = 5;
var $author$project$Evergreen$V417$Internal$Teleport$OnFocus = 2;
var $author$project$Evergreen$V417$Internal$Teleport$OnFocusWithin = 3;
var $author$project$Evergreen$V417$Internal$Teleport$OnHover = 0;
var $author$project$Evergreen$V417$Internal$Teleport$OnRender = 1;
var $author$project$Evergreen$V417$Internal$Teleport$w3_unsafe_decode_Trigger = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Internal$Model2$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Internal$Teleport$w3_unsafe_decode_Event,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Internal$Teleport$w3_unsafe_decode_Trigger,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Internal$Model2$Teleported)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					A2(
						$lamdera$codecs$Lamdera$Wire3$andThenDecode,
						function (t) {
							return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
								$elm$time$Time$millisToPosix(t));
						},
						$lamdera$codecs$Lamdera$Wire3$decodeInt),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Internal$Model2$Tick));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Ui$Anim$w3_unsafe_decode_Msg = $author$project$Evergreen$V417$Internal$Model2$w3_unsafe_decode_Msg;
var $lamdera$program_test$Effect$Http$w3_unsafe_decode_Progress = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (received0, size0) {
										return {received: received0, size: size0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($lamdera$program_test$Effect$Http$Receiving));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (sent0, size0) {
										return {sent: sent0, size: size0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($lamdera$program_test$Effect$Http$Sending));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $elm$browser$Browser$w3_unsafe_decode_UrlRequest = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$browser$Browser$External));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$elm$url$Url$w3_unsafe_decode_Url,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$browser$Browser$Internal));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Viewport = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeFloat,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeFloat,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeFloat,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F4(
							function (height0, width0, x0, y0) {
								return {height: height0, width: width0, x: x0, y: y0};
							})))))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeFloat,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeFloat,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F2(
						function (height0, width0) {
							return {height: height0, width: width0};
						})))),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (scene0, viewport0) {
					return {scene: scene0, viewport: viewport0};
				}))));
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_FrontendMsg_ = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Pages$Admin$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$AdminPageMsg));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$AiChat$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$AiChatMsg));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$ChannelSidebarAnimated));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeBool,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
											$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$CheckMessageAltPress))))))));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Ports$w3_unsafe_decode_NotificationPermission,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$CheckedNotificationPermission));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$CheckedSheepGameQuestionsDebounce)));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_Input,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$CheckedSheepGameSaveDebounce)))));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$DebouncedTyping);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_HtmlId),
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V417$Range$w3_unsafe_decode_Range, $author$project$Evergreen$V417$Range$w3_unsafe_decode_SelectionDirection))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$DomFocusChanged));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Drawing$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$DrawingMsg));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Types$w3_unsafe_decode_EditChannelForm,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$EditChannelFormChanged))));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Types$w3_unsafe_decode_EditGuildForm,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$EditGuildFormChanged)));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Http$w3_unsafe_decode_Error, $author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_UploadResponse),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$EditMessage_GotFileHashName)))));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MessageInput$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$EditMessage_MessageInputMsg))));
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$EditMessage_PressedDeleteAttachedFile)));
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (fileId0, removeSpoiler0) {
										return {fileId: fileId0, removeSpoiler: removeSpoiler0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$EditMessage_PressedToggleAttachedFileSpoiler)));
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$EditMessage_PressedViewAttachedFileInfo)));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$program_test$Effect$File$w3_unsafe_decode_File),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$File$w3_unsafe_decode_File,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$EditMessage_SelectedFilesToAttach))));
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Ui$Anim$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$ElmUiMsg));
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$EmojiSelectorMsg));
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$EnableToFrontendLogging);
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$author$project$Evergreen$V417$Encryption$w3_unsafe_decode_FromJs(
							$author$project$Evergreen$V417$Message$w3_unsafe_decode_MessageContent$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$EncryptionFromJs));
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$FileDragEnter));
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$FileDragLeave);
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$program_test$Effect$File$w3_unsafe_decode_File),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$FileDropped));
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Progress,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$FileUploadProgress))));
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$FrontendNoOp);
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Game$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$GameMsg));
			case 28:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Go$w3_unsafe_decode_SpectatorMsg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$GoSpectatorMsg));
			case 29:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$GotDevicePixelRatio));
			case 30:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Http$w3_unsafe_decode_Error, $author$project$Evergreen$V417$Emoji$w3_unsafe_decode_CachedEmojiData),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$GotEmojiData));
			case 31:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Http$w3_unsafe_decode_Error, $author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_UploadResponse),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileMetadata),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$GotFileHashName)))));
			case 32:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBytes,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$GotFileToEncrypt)))));
			case 33:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeString,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (fileName0, json0) {
										return {fileName: fileName0, json: json0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$GotImportChannelFile)));
			case 34:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Error, $author$project$Evergreen$V417$MessageInput$w3_unsafe_decode_MentionUserDropdown),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_HtmlId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$GotPingUserPosition)));
			case 35:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Error, $lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Element),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$GotPositionForEmojiSelector_EditMessage));
			case 36:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Error, $lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Element),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$SheepGame$w3_unsafe_decode_Input,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$GotPositionForEmojiSelector_SheepGameInput)));
			case 37:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Ports$w3_unsafe_decode_RegisterPushSubscription,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$GotRegisterPushSubscription));
			case 38:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$GotServiceWorkerData));
			case 39:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$GotServiceWorkerMessage));
			case 40:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeString, $author$project$Evergreen$V417$Ports$w3_unsafe_decode_StartupData),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$GotStartupData));
			case 41:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$GotTime));
			case 42:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $lamdera$codecs$Lamdera$Wire3$decodeInt),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$GotVersionNumber));
			case 43:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeString, $author$project$Evergreen$V417$Call$w3_unsafe_decode_FromJs),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$GotVoiceChatSignalFromJs));
			case 44:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$GotWindowSize)));
			case 45:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$ImageEditor$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$GuildIconEditorMsg)));
			case 46:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$ImageViewer$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$ImageViewerMsg));
			case 47:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeBool,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeString,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeBool,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F4(
											function (ctrlKey0, key0, metaKey0, shiftKey0) {
												return {ctrlKey: ctrlKey0, key: key0, metaKey: metaKey0, shiftKey: shiftKey0};
											})))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$KeyDown));
			case 48:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($author$project$Evergreen$V417$Audio$w3_unsafe_decode_LoadError, $author$project$Evergreen$V417$Audio$w3_unsafe_decode_Source),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$LoadedPopSound));
			case 49:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$LoginForm$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$LoginFormMsg));
			case 50:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MessageInput$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$MessageInputMsg))));
			case 51:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$MessageMenuAnimated));
			case 52:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$NonemptySet$w3_unsafe_decode_NonemptySet(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_CustomEmojiId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$MessageMenu_PressedAddCustomEmojisToUser));
			case 53:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$MessageMenu_PressedClose);
			case 54:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$MessageMenu_PressedContainer);
			case 55:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$MessageMenu_PressedDeleteMessage)));
			case 56:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$MessageMenu_PressedEditMessage)));
			case 57:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$MessageMenu_PressedMarkAsUnread)));
			case 58:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_PrivateChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$MessageMenu_PressedOpenDiscordDm)));
			case 59:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$MessageMenu_PressedOpenDm));
			case 60:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$MessageMenu_PressedOpenThread));
			case 61:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$MessageMenu_PressedReactionEmoji));
			case 62:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$MessageMenu_PressedReply));
			case 63:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V417$CssPixels$w3_unsafe_decode_CssPixels),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$MessageMenu_PressedShowReactionEmojiSelector))));
			case 64:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MessageView$w3_unsafe_decode_MessageViewMsg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$MessageViewMsg))));
			case 65:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Types$w3_unsafe_decode_NewChannelForm,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$NewChannelFormChanged)));
			case 66:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Types$w3_unsafe_decode_NewGuildForm,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$NewGuildFormChanged));
			case 67:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$OneFrameAfterDragEnd);
			case 68:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PageFocusSettled);
			case 69:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PageHasFocusChanged));
			case 70:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Error, $lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Viewport),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PageUpGotViewport));
			case 71:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedAccountDeletionBanner);
			case 72:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedAddDomainToWhitelist));
			case 73:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedAddPrivateKeyToAccount);
			case 74:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedBanMember)));
			case 75:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedBody);
			case 76:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedCancelE2eeRequest));
			case 77:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedCancelMessageEdit));
			case 78:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedChannelHeaderBackButton);
			case 79:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_ChannelHeaderTab,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedChannelHeaderTab));
			case 80:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedCloseAccountDeletionBanner);
			case 81:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedCloseExternalLinkWarning);
			case 82:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedCloseImageInfo);
			case 83:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedCloseNewPrivateKey);
			case 84:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedCloseOverlay);
			case 85:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedCloseReplyTo));
			case 86:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedContinueToSite);
			case 87:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedCopyImage));
			case 88:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedCopyText));
			case 89:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedCreateInviteLink));
			case 90:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedDeclineE2eeRequest));
			case 91:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedDeleteAccount);
			case 92:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedDeleteAttachedFile)));
			case 93:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedDeleteChannel)));
			case 94:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedDeleteGuild));
			case 95:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$SecretId$w3_unsafe_decode_SecretId($author$project$Evergreen$V417$Id$w3_unsafe_decode_InviteLinkId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedDeleteInviteLink)));
			case 96:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedDisableE2ee));
			case 97:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedDiscordAcknowledgment));
			case 98:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (currentUserId0, otherUserId0) {
										return {currentUserId: currentUserId0, otherUserId: otherUserId0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedDiscordGuildMemberLabel));
			case 99:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$User$w3_unsafe_decode_NotificationLevel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedDiscordGuildNotificationLevel))));
			case 100:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedE2eeRisksAccepted));
			case 101:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedEnableE2ee));
			case 102:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_UserOptionSection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedExpandContainer));
			case 103:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedExpandE2eeSection));
			case 104:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_ExportChannelId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedExportChannel));
			case 105:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$User$w3_unsafe_decode_NotificationLevel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedGuildNotificationLevel)));
			case 106:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedHideMembers);
			case 107:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedHomePagePreview));
			case 108:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedImportChannel));
			case 109:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedLeaveGuild));
			case 110:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Route$w3_unsafe_decode_Route,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedLink));
			case 111:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedLoadDebugData);
			case 112:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$SessionIdHash$w3_unsafe_decode_SessionIdHash,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedLogOut));
			case 113:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedMarkAllChannelsAsRead));
			case 114:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedMarkChannelAsRead)));
			case 115:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedMemberListBack);
			case 116:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedMuteChannel))));
			case 117:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedMuteDiscordChannel)))));
			case 118:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedMuteDiscordGuild))));
			case 119:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedMuteDiscordThread))))));
			case 120:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedMuteGuild)));
			case 121:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedMuteSlackChannel)))));
			case 122:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedMuteSlackThread))))));
			case 123:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedMuteSlackWorkspace))));
			case 124:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedMuteThread)))));
			case 125:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedNewMessagesWarning);
			case 126:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedNotification));
			case 127:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedReloadDiscordUser));
			case 128:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedReloadSlackUser));
			case 129:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedRemoveSlackTeam));
			case 130:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedResetDomainWhitelist);
			case 131:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedResetEditChannelChanges)));
			case 132:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedResetEditGuildChanges));
			case 133:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedResetUserColor);
			case 134:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedSaveDomainWhitelist);
			case 135:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedSearchOverlayArrowKey));
			case 136:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedSearchOverlayEnter);
			case 137:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Route$w3_unsafe_decode_Route,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedSearchOverlayResult));
			case 138:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedSelectNewColor);
			case 139:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedShowLogin);
			case 140:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedShowMembers);
			case 141:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedShowSearchOverlay);
			case 142:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedShowUserOption);
			case 143:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedSlackAcknowledgment));
			case 144:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$User$w3_unsafe_decode_NotificationLevel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_TeamId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedSlackWorkspaceNotificationLevel))));
			case 145:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Types$w3_unsafe_decode_EditChannelForm,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedSubmitEditChannelChanges))));
			case 146:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Types$w3_unsafe_decode_EditGuildForm,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedSubmitEditGuildChanges)));
			case 147:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Types$w3_unsafe_decode_NewChannelForm,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedSubmitNewChannel)));
			case 148:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Types$w3_unsafe_decode_NewGuildForm,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedSubmitNewGuild));
			case 149:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedSubmitSlackData);
			case 150:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedSubmitUserColor);
			case 151:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (fileId0, removeSpoiler0) {
										return {fileId: fileId0, removeSpoiler: removeSpoiler0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedToggleAttachedFileSpoiler)));
			case 152:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$SecretId$w3_unsafe_decode_SecretId($author$project$Evergreen$V417$Id$w3_unsafe_decode_InviteLinkId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedToggleInviteLinkQrCode));
			case 153:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V417$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedUnlinkDiscordUser));
			case 154:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V417$Slack$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedUnlinkSlackUser));
			case 155:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedUnregisterServiceWorkers);
			case 156:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$PressedViewAttachedFileInfo)));
			case 157:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$ImageEditor$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$ProfilePictureEditorMsg));
			case 158:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$RecoveryLogin$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$RecoveryLoginMsg));
			case 159:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$RemoveFocus);
			case 160:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (bottom0, top0) {
										return {bottom: bottom0, top: top0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$SafeAreaInsetsChanged));
			case 161:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$ScrolledToLogSection);
			case 162:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$ScrolledToMessage);
			case 163:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$User$w3_unsafe_decode_EmailNotifications,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$SelectedEmailNotifications));
			case 164:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$User$w3_unsafe_decode_EmbedVisibility,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$SelectedEmbedVisibility));
			case 165:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$program_test$Effect$File$w3_unsafe_decode_File),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$File$w3_unsafe_decode_File,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$SelectedFilesToAttach))));
			case 166:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$File$w3_unsafe_decode_File,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$SelectedImportChannelFile)));
			case 167:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserSession$w3_unsafe_decode_NotificationMode,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$SelectedNotificationMode));
			case 168:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$UserColor$w3_unsafe_decode_Selection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$SelectedUserColor));
			case 169:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$SetFocus);
			case 170:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$SetScrollToBottom);
			case 171:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$TextEditor$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$TextEditorMsg));
			case 172:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_HtmlId),
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V417$Range$w3_unsafe_decode_Range, $author$project$Evergreen$V417$Range$w3_unsafe_decode_SelectionDirection))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$TextSelectionChanged));
			case 173:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$TouchCancel));
			case 174:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$TouchEnd));
			case 175:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$NonemptyDict$w3_unsafe_decode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$Evergreen$V417$Touch$w3_unsafe_decode_Touch),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$TouchMoved)));
			case 176:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$NonemptyDict$w3_unsafe_decode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$Evergreen$V417$Touch$w3_unsafe_decode_Touch),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$TouchStart)));
			case 177:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$TwoFactorAuthentication$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$TwoFactorMsg));
			case 178:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$TypedDiscordLinkBookmarklet);
			case 179:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$TypedDomainWhitelist));
			case 180:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$TypedPrivateKey)));
			case 181:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$TypedSearchOverlay));
			case 182:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$TypedSlackCookie));
			case 183:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$TypedSlackTeamsJson));
			case 184:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MessageView$w3_unsafe_decode_MessageViewMsg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$UnreadOverviewChannelMsg))));
			case 185:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$MessageView$w3_unsafe_decode_MessageViewMsg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_Id($author$project$Evergreen$V417$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$UnreadOverviewThreadMsg)))));
			case 186:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$elm$url$Url$w3_unsafe_decode_Url,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$UrlChanged));
			case 187:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$elm$browser$Browser$w3_unsafe_decode_UrlRequest,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$UrlClicked));
			case 188:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Editable$w3_unsafe_decode_Msg($author$project$Evergreen$V417$PersonName$w3_unsafe_decode_PersonName),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$UserNameEditableMsg));
			case 189:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Scroll$w3_unsafe_decode_ScrollPosition,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Id$w3_unsafe_decode_ThreadRoute,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$UserScrolled))));
			case 190:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Types$w3_unsafe_decode_E2eeKeysValid,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$ValidatedE2eePrivateKey)));
			case 191:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeFloat,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (height0, top0) {
										return {height: height0, top: top0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$VisualViewportChanged));
			case 192:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Call$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Types$VoiceChatMsg));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Audio$Model = $elm$core$Basics$identity;
var $author$project$Evergreen$V417$Audio$w3_unsafe_decode_AudioLoadRequest_ = function (w3_x_c_userMsg) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
			$lamdera$codecs$Lamdera$Wire3$decodePair$(
				$lamdera$codecs$Lamdera$Wire3$decodeResult$($author$project$Evergreen$V417$Audio$w3_unsafe_decode_LoadError, $author$project$Evergreen$V417$Audio$w3_unsafe_decode_Source),
				w3_x_c_userMsg)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F2(
					function (audioUrl0, userMsg0) {
						return {audioUrl: audioUrl0, userMsg: userMsg0};
					}))));
};
var $author$project$Evergreen$V417$Audio$w3_unsafe_decode_LoopConfig = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (loopEnd0, loopStart0) {
					return {loopEnd: loopEnd0, loopStart: loopStart0};
				}))));
var $author$project$Evergreen$V417$Audio$w3_unsafe_decode_FlattenedAudio = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeList(
		$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
			$lamdera$codecs$Lamdera$Wire3$decodePair$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$andThenDecode,
					function (t) {
						return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
							$elm$time$Time$millisToPosix(t));
					},
					$lamdera$codecs$Lamdera$Wire3$decodeInt),
				$lamdera$codecs$Lamdera$Wire3$decodeFloat))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeFloat,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			A2(
				$lamdera$codecs$Lamdera$Wire3$andThenDecode,
				function (t) {
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
						$elm$time$Time$millisToPosix(t));
				},
				$lamdera$codecs$Lamdera$Wire3$decodeInt),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Audio$w3_unsafe_decode_Source,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V417$Audio$w3_unsafe_decode_LoopConfig),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F8(
										function (loop0, offset0, playbackRate0, source0, startAt0, startTime0, volume0, volumeTimelines0) {
											return {loop: loop0, offset: offset0, playbackRate: playbackRate0, source: source0, startAt: startAt0, startTime: startTime0, volume: volume0, volumeTimelines: volumeTimelines0};
										}))))))))));
var $author$project$Evergreen$V417$Audio$w3_unsafe_decode_NodeGroupId = $lamdera$codecs$Lamdera$Wire3$decodeInt;
var $author$project$Evergreen$V417$Audio$w3_unsafe_decode_SourceData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
	$lamdera$codecs$Lamdera$Wire3$succeedDecode(
		function (duration0) {
			return {duration: duration0};
		}));
var $author$project$Evergreen$V417$Audio$w3_unsafe_decode_Model_$ = function (w3_x_c_userMsg, w3_x_c_userModel) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		w3_x_c_userModel,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$Evergreen$V417$Audio$w3_unsafe_decode_SourceData),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeDict$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$author$project$Evergreen$V417$Audio$w3_unsafe_decode_AudioLoadRequest_(w3_x_c_userMsg)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeDict$($author$project$Evergreen$V417$Audio$w3_unsafe_decode_NodeGroupId, $author$project$Evergreen$V417$Audio$w3_unsafe_decode_FlattenedAudio),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F7(
										function (audioState0, nodeGroupIdCounter0, pendingRequests0, requestCount0, samplesPerSecond0, sourceData0, userModel0) {
											return {audioState: audioState0, nodeGroupIdCounter: nodeGroupIdCounter0, pendingRequests: pendingRequests0, requestCount: requestCount0, samplesPerSecond: samplesPerSecond0, sourceData: sourceData0, userModel: userModel0};
										})))))))));
};
var $author$project$Evergreen$V417$Audio$w3_unsafe_decode_Model_ = F2($author$project$Evergreen$V417$Audio$w3_unsafe_decode_Model_$);
var $author$project$Evergreen$V417$Audio$w3_unsafe_decode_Model$ = function (w3_x_c_userMsg, w3_x_c_userModel) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V417$Audio$w3_unsafe_decode_Model_$(w3_x_c_userMsg, w3_x_c_userModel),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$Audio$w3_unsafe_decode_Model = F2($author$project$Evergreen$V417$Audio$w3_unsafe_decode_Model$);
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_FrontendModel = $author$project$Evergreen$V417$Audio$w3_unsafe_decode_Model$($author$project$Evergreen$V417$Types$w3_unsafe_decode_FrontendMsg_, $author$project$Evergreen$V417$Types$w3_unsafe_decode_FrontendModel_);
var $author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiArt = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (sequence0, sprite0) {
					return {sequence: sequence0, sprite: sprite0};
				}))));
var $author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiCategory = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(8);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(9);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeString),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiCategory,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (category0, shortNames0, skinVariations0) {
						return {category: category0, shortNames: shortNames0, skinVariations: skinVariations0};
					})))));
var $author$project$Evergreen$V419$Emoji$w3_unsafe_decode_UnicodeEmoji = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Emoji$w3_unsafe_decode_CachedEmojiData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeArray(
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_UnicodeEmoji,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F2(
						function (emoji0, shortName0) {
							return {emoji: emoji0, shortName: shortName0};
						}))))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V419$Emoji$w3_unsafe_decode_UnicodeEmoji, $author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiData),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiCategory,
				$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V419$Emoji$w3_unsafe_decode_UnicodeEmoji)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeDict$(
					$lamdera$codecs$Lamdera$Wire3$decodeChar,
					$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiArt)),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (art0, categories0, emojis0, shortNames0) {
							return {art: art0, categories: categories0, emojis: emojis0, shortNames: shortNames0};
						}))))));
var $author$project$Evergreen$V419$Coord$w3_unsafe_decode_Coord = function (w3_x_c_units) {
	return $lamdera$codecs$Lamdera$Wire3$decodePair$(
		$ianmackenzie$elm_units$Quantity$w3_unsafe_decode_Quantity$($lamdera$codecs$Lamdera$Wire3$decodeInt, w3_x_c_units),
		$ianmackenzie$elm_units$Quantity$w3_unsafe_decode_Quantity$($lamdera$codecs$Lamdera$Wire3$decodeInt, w3_x_c_units));
};
var $author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Touch$w3_unsafe_decode_DragTarget = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$NonemptyDict$w3_unsafe_decode_NonemptyDict$ = function (w3_x_c_id, w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(w3_x_c_id, w3_x_c_a),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_a,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							w3_x_c_id,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$NonemptyDict$NonemptyDict))));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V419$NonemptyDict$w3_unsafe_decode_NonemptyDict = F2($author$project$Evergreen$V419$NonemptyDict$w3_unsafe_decode_NonemptyDict$);
var $author$project$Evergreen$V419$Geometry$Types$w3_unsafe_decode_Point2d$ = function (w3_x_c_units, w3_x_c_coordinates) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeFloat,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (x0, y0) {
										return {x: x0, y: y0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V419$Geometry$Types$w3_unsafe_decode_Point2d = F2($author$project$Evergreen$V419$Geometry$Types$w3_unsafe_decode_Point2d$);
var $author$project$Evergreen$V419$Point2d$w3_unsafe_decode_Point2d$ = function (w3_x_c_units, w3_x_c_coordinates) {
	return $author$project$Evergreen$V419$Geometry$Types$w3_unsafe_decode_Point2d$(w3_x_c_units, w3_x_c_coordinates);
};
var $author$project$Evergreen$V419$Point2d$w3_unsafe_decode_Point2d = F2($author$project$Evergreen$V419$Point2d$w3_unsafe_decode_Point2d$);
var $author$project$Evergreen$V419$Touch$w3_unsafe_decode_ScreenCoordinate = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Touch$w3_unsafe_decode_Touch = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Point2d$w3_unsafe_decode_Point2d$($author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels, $author$project$Evergreen$V419$Touch$w3_unsafe_decode_ScreenCoordinate),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (client0, targetIsTextInput0) {
					return {client: client0, targetIsTextInput: targetIsTextInput0};
				}))));
var $author$project$Evergreen$V419$Touch$w3_unsafe_decode_Drag = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$NonemptyDict$w3_unsafe_decode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$Evergreen$V419$Touch$w3_unsafe_decode_Touch),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Touch$DragStart)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$NonemptyDict$w3_unsafe_decode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$Evergreen$V419$Touch$w3_unsafe_decode_Touch),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Touch$w3_unsafe_decode_DragTarget,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeBool,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (horizontalStart0, target0, touches0) {
											return {horizontalStart: horizontalStart0, target: target0, touches: touches0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Touch$Dragging));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Touch$NoDrag);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$AiChat$w3_unsafe_decode_AiModelName = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$AiChat$w3_unsafe_decode_AiModel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeString),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$AiChat$w3_unsafe_decode_AiModelName,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, inputs0) {
					return {id: id0, inputs: inputs0};
				}))));
var $author$project$Evergreen$V419$AiChat$w3_unsafe_decode_AiModelsStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V419$AiChat$w3_unsafe_decode_AiModel),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$AiChat$LoadedAiModels));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$AiChat$LoadingAiModels);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$AiChat$LoadingFailed));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$AiChat$w3_unsafe_decode_PendingResponse = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$AiChat$w3_unsafe_decode_AiModelName,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$AiChat$GotError)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeFloat),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeString,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$AiChat$w3_unsafe_decode_AiModelName,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$AiChat$GotResponse)))));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$AiChat$w3_unsafe_decode_AiModelName,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$AiChat$Pending));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$AiChat$w3_unsafe_decode_ResponseId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$AiChat$w3_unsafe_decode_SendMessageWith = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$AiChat$w3_unsafe_decode_FrontendModel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$AiChat$w3_unsafe_decode_SendMessageWith,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V419$AiChat$w3_unsafe_decode_AiModelName),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V419$AiChat$w3_unsafe_decode_ResponseId, $author$project$Evergreen$V419$AiChat$w3_unsafe_decode_PendingResponse),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeString,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$AiChat$w3_unsafe_decode_AiModelsStatus,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F9(
											function (aiModels0, chatHistory0, debounceCounter0, message0, pendingResponses0, responseCounter0, selectedModels0, sendMessageWith0, showOptions0) {
												return {aiModels: aiModels0, chatHistory: chatHistory0, debounceCounter: debounceCounter0, message: message0, pendingResponses: pendingResponses0, responseCounter: responseCounter0, selectedModels: selectedModels0, sendMessageWith: sendMessageWith0, showOptions: showOptions0};
											})))))))))));
var $author$project$Evergreen$V419$MyUi$w3_unsafe_decode_Copied = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MyUi$CopiedImage));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MyUi$CopiedText));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$MyUi$w3_unsafe_decode_LastCopy = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (t) {
			return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
				$elm$time$Time$millisToPosix(t));
		},
		$lamdera$codecs$Lamdera$Wire3$decodeInt),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$MyUi$w3_unsafe_decode_Copied,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (copied0, copiedAt0) {
					return {copied: copied0, copiedAt: copiedAt0};
				}))));
var $author$project$Evergreen$V419$Audio$w3_unsafe_decode_LoadError = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Id$InviteLinkId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Id$w3_unsafe_decode_InviteLinkId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Discord$ChannelId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Discord$GuildId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id = function (w3_x_c_idType) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$MartinSStewart$elm_uint64$UInt64$w3_unsafe_decode_UInt64,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V419$Discord$UserId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DiscordChannelId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (channelId0, currentUserId0, guildId0) {
						return {channelId: channelId0, currentUserId: currentUserId0, guildId: guildId0};
					})))));
var $author$project$Evergreen$V419$Discord$PrivateChannelId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DiscordDmId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (channelId0, currentUserId0) {
					return {channelId: channelId0, currentUserId: currentUserId0};
				}))));
var $author$project$Evergreen$V419$Id$w3_unsafe_decode_DiscordGuildOrDmId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DiscordDmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Id$DiscordGuildOrDmId_Dm));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DiscordChannelId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Id$DiscordGuildOrDmId_Guild));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Id$ChannelId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Id$GuildId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Id$w3_unsafe_decode_Id = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_ChannelId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (channelId0, guildId0) {
					return {channelId: channelId0, guildId: guildId0};
				}))));
var $author$project$Evergreen$V419$Id$UserId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DmId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$succeedDecode(
		function (otherUserId0) {
			return {otherUserId: otherUserId0};
		}));
var $author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildOrDmId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Id$GuildOrDmId_Dm));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_ChannelId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Id$GuildOrDmId_Guild));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Slack$ChannelId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V419$Slack$TeamId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Slack$UserId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_SlackChannelId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (channelId0, currentUserId0, teamId0) {
						return {channelId: channelId0, currentUserId: currentUserId0, teamId: teamId0};
					})))));
var $author$project$Evergreen$V419$Slack$DmChannelId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Slack$w3_unsafe_decode_DmChannelId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_SlackDmId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_DmChannelId),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (channelId0, currentUserId0) {
					return {channelId: channelId0, currentUserId: currentUserId0};
				}))));
var $author$project$Evergreen$V419$Id$w3_unsafe_decode_SlackGuildOrDmId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_SlackDmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Id$SlackGuildOrDmId_Dm));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_SlackChannelId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Id$SlackGuildOrDmId_Workspace));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_DiscordGuildOrDmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Id$DiscordGuildOrDmId));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildOrDmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Id$GuildOrDmId));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_SlackGuildOrDmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Id$SlackGuildOrDmId));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Route$w3_unsafe_decode_ChannelSidebarMode = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeFloat,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeFloat,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (offset0, previousOffset0, time0) {
											return {offset: offset0, previousOffset: previousOffset0, time: time0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Route$ChannelSidebarDragging));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							function (offset0) {
								return {offset: offset0};
							})),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Route$ChannelSidebarNotDragging));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_EditChannelForm = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (deleteConfirmation0, description0, name0, pressedSubmit0, showDeleteConfirmation0) {
								return {deleteConfirmation: deleteConfirmation0, description: description0, name: name0, pressedSubmit: pressedSubmit0, showDeleteConfirmation: showDeleteConfirmation0};
							})))))));
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_ImportChannelError = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_ImportChannelStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Types$w3_unsafe_decode_ImportChannelError,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$ImportChannelFailed));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							function (encryptedMessages0) {
								return {encryptedMessages: encryptedMessages0};
							})),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$ImportedChannel));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$ImportingChannel);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$NotImportingChannel);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_EditGuildForm = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeBool,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Types$w3_unsafe_decode_ImportChannelStatus,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F6(
								function (deleteConfirmation0, importChannel0, name0, pressedSubmit0, showDeleteConfirmation0, showLeaveConfirmation0) {
									return {deleteConfirmation: deleteConfirmation0, importChannel: importChannel0, name: name0, pressedSubmit: pressedSubmit0, showDeleteConfirmation: showDeleteConfirmation0, showLeaveConfirmation: showLeaveConfirmation0};
								}))))))));
var $author$project$Evergreen$V419$FileStatus$FileId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_ContentType = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_ExposureTime = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (denominator0, numerator0) {
					return {denominator: denominator0, numerator: numerator0};
				}))));
var $author$project$Evergreen$V419$SafeFloat$w3_unsafe_decode_SafeFloat = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeFloat,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_Location = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$SafeFloat$w3_unsafe_decode_SafeFloat,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$SafeFloat$w3_unsafe_decode_SafeFloat,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (lat0, lon0) {
					return {lat: lat0, lon: lon0};
				}))));
var $author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_Orientation = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_ImageMetadata = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_Orientation),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_Location),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$SafeFloat$w3_unsafe_decode_SafeFloat),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$SafeFloat$w3_unsafe_decode_SafeFloat),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_ExposureTime),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
												$lamdera$codecs$Lamdera$Wire3$succeedDecode(
													function (cameraOwner0) {
														return function (exposureTime0) {
															return function (fNumber0) {
																return function (focalLength0) {
																	return function (gpsLocation0) {
																		return function (imageSize0) {
																			return function (isoSpeedRating0) {
																				return function (make0) {
																					return function (model0) {
																						return function (orientation0) {
																							return function (software0) {
																								return function (userComment0) {
																									return {cameraOwner: cameraOwner0, exposureTime: exposureTime0, fNumber: fNumber0, focalLength: focalLength0, gpsLocation: gpsLocation0, imageSize: imageSize0, isoSpeedRating: isoSpeedRating0, make: make0, model: model0, orientation: orientation0, software: software0, userComment: userComment0};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													})))))))))))));
var $author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_VideoMetadata = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_Orientation,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_Location),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F7(
									function (codec0, createdAt0, duration0, gpsLocation0, orientation0, title0, videoSize0) {
										return {codec: codec0, createdAt: createdAt0, duration: duration0, gpsLocation: gpsLocation0, orientation: orientation0, title: title0, videoSize: videoSize0};
									})))))))));
var $author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileMetadata = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_ImageMetadata,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$FileStatus$FileMetadata_Image));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_VideoMetadata,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$FileStatus$FileMetadata_Video));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$FileName$w3_unsafe_decode_FileName = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_AesPrivateKey = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeBytes,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_EncryptedThumbnail = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_IsEncrypted = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_EncryptedThumbnail,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_AesPrivateKey,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$FileStatus$IsEncrypted)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$FileStatus$IsNotEncrypted);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileMetadata),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_IsEncrypted,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$FileName$w3_unsafe_decode_FileName,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_ContentType,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F6(
								function (contentType0, fileHash0, fileName0, fileSize0, isEncrypted0, metadata0) {
									return {contentType: contentType0, fileHash: fileHash0, fileName: fileName0, fileSize: fileSize0, isEncrypted: isEncrypted0, metadata: metadata0};
								}))))))));
var $author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_IsEncrypted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_ContentType,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$FileName$w3_unsafe_decode_FileName,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$FileStatus$FileError))))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$FileStatus$FileUploaded));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_IsEncrypted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_ContentType,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeInt,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F2(
											function (sent0, size0) {
												return {sent: sent0, size: size0};
											})))),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$FileName$w3_unsafe_decode_FileName,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$FileStatus$FileUploading)))));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_EditMessage = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
				$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileStatus),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (attachedFiles0, messageIndex0, text0) {
						return {attachedFiles: attachedFiles0, messageIndex: messageIndex0, text: text0};
					})))));
var $author$project$Evergreen$V419$Id$QuestionId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_Input = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$AnswerInput));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$NotesInput));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$QuestionInput));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Range$w3_unsafe_decode_Range = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (end0, start0) {
					return {end: end0, start: start0};
				}))));
var $author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_ReactionTarget = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$AnswerReaction)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$NotesReaction));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_ReactionTarget = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Id$NoThreadWithMessage));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Id$ViewThreadWithMessage)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_EmojiSelector = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Range$w3_unsafe_decode_Range),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$EmojiSelectorForEditMessage)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Range$w3_unsafe_decode_Range),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$EmojiSelectorForMessage));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$EmojiSelectorForReaction)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Range$w3_unsafe_decode_Range),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_Input,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$EmojiSelectorForSheepGameInput))));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_ReactionTarget,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$EmojiSelectorForSheepGameReaction))));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_ReactionTarget,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$EmojiSelectorForWordSpellingGameReaction))));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$EmojiSelectorHidden);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Encryption$DecryptManyRequestId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Encryption$w3_unsafe_decode_DecryptManyRequestId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Encryption$DecryptRequestId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Encryption$w3_unsafe_decode_DecryptRequestId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Encryption$EncryptFileRequestId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Encryption$w3_unsafe_decode_EncryptFileRequestId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Encryption$EncryptManyRequestId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Encryption$w3_unsafe_decode_EncryptManyRequestId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Encryption$EncryptRequestId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Encryption$w3_unsafe_decode_EncryptRequestId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Encryption$w3_unsafe_decode_BytesHash = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_PendingDecryptedManyMessages = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_HtmlId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V419$Encryption$w3_unsafe_decode_BytesHash),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (messageHashes0, shiftScrollFrom0) {
					return {messageHashes: messageHashes0, shiftScrollFrom: shiftScrollFrom0};
				}))));
var $author$project$Evergreen$V419$Message$w3_unsafe_decode_RepliedToGame = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Message$RepliedTo_SheepGameAnswer)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Message$RepliedTo_SheepGameNotes));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Message$RepliedTo_WordSpellingGameMove));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Message$w3_unsafe_decode_RepliedTo = function (w3_x_c_messageId) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Message$NoReply);
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Message$w3_unsafe_decode_RepliedToGame,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Message$RepliedToGame)));
				case 2:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id(w3_x_c_messageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Message$RepliedToMessage));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V419$Message$w3_unsafe_decode_ThreadRouteWithRepliedTo = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Message$w3_unsafe_decode_RepliedTo($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Message$NoThreadWithRepliedTo));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Message$ViewThreadWithRepliedTo)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_PendingDecryptedMessage = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Message$w3_unsafe_decode_ThreadRouteWithRepliedTo,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DmId,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$Encryption$w3_unsafe_decode_BytesHash,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (hash0, id0, senderId0, threadRoute0) {
							return {hash: hash0, id: id0, senderId: senderId0, threadRoute: threadRoute0};
						}))))));
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_PendingDecryptedOldMessages = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DmId,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, messages0) {
					return {id: id0, messages: messages0};
				}))));
var $author$project$Evergreen$V419$Embed$w3_unsafe_decode_EmbedImageFormat = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(13);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(8);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(12);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(10);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(9);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(11);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(14);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Embed$w3_unsafe_decode_EmbedImageData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Embed$w3_unsafe_decode_EmbedImageFormat),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (format0, imageSize0, url0) {
						return {format: format0, imageSize: imageSize0, url: url0};
					})))));
var $author$project$Evergreen$V419$Embed$w3_unsafe_decode_EmbedData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Embed$w3_unsafe_decode_EmbedImageData),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (createdAt0, description0, image0, title0) {
							return {createdAt: createdAt0, description: description0, image: image0, title: title0};
						}))))));
var $author$project$Evergreen$V419$Embed$w3_unsafe_decode_Embed = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Embed$w3_unsafe_decode_EmbedData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Embed$EmbedLoaded));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Embed$EmbedLoading);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Id$CustomEmojiId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Id$w3_unsafe_decode_CustomEmojiId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$RichText$w3_unsafe_decode_EscapedChar = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$RichText$w3_unsafe_decode_HasLeadingLineBreak = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$RichText$w3_unsafe_decode_HeadingLevel = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$RichText$w3_unsafe_decode_Language = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$RichText$Language));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$RichText$NoLanguage);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Id$StickerId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Id$w3_unsafe_decode_StickerId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$TimeInMinutes$w3_unsafe_decode_TimeInMinutes = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$RichText$w3_unsafe_decode_RichText$ = function (w3_x_c_userId, w3_x_c_channelId) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$RichText$AttachedFile));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeList(
							$author$project$Evergreen$V419$RichText$w3_unsafe_decode_RichText$(w3_x_c_userId, w3_x_c_channelId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$RichText$w3_unsafe_decode_HasLeadingLineBreak,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$RichText$BlockQuote)));
				case 2:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$author$project$Evergreen$V419$RichText$w3_unsafe_decode_RichText$(w3_x_c_userId, w3_x_c_channelId)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$RichText$Bold));
				case 3:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$lamdera$codecs$Lamdera$Wire3$decodeList(
								$author$project$Evergreen$V419$RichText$w3_unsafe_decode_RichText$(w3_x_c_userId, w3_x_c_channelId))),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$RichText$w3_unsafe_decode_HasLeadingLineBreak,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$RichText$BulletPoint)));
				case 4:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							w3_x_c_channelId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$RichText$ChannelMention)));
				case 5:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$RichText$w3_unsafe_decode_Language,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$RichText$CodeBlock)));
				case 6:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_CustomEmojiId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$RichText$CustomEmoji));
				case 7:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$RichText$w3_unsafe_decode_EscapedChar,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$RichText$EscapedChar));
				case 8:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$author$project$Evergreen$V419$RichText$w3_unsafe_decode_RichText$(w3_x_c_userId, w3_x_c_channelId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$RichText$w3_unsafe_decode_HasLeadingLineBreak,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$RichText$w3_unsafe_decode_HeadingLevel,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$RichText$Heading))));
				case 9:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$elm$url$Url$w3_unsafe_decode_Url,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$RichText$Hyperlink));
				case 10:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeChar,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$RichText$InlineCode)));
				case 11:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$author$project$Evergreen$V419$RichText$w3_unsafe_decode_RichText$(w3_x_c_userId, w3_x_c_channelId)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$RichText$Italic));
				case 12:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$elm$url$Url$w3_unsafe_decode_Url,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$RichText$MarkdownLink)));
				case 13:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeChar,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$RichText$NormalText)));
				case 14:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$author$project$Evergreen$V419$RichText$w3_unsafe_decode_RichText$(w3_x_c_userId, w3_x_c_channelId)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$RichText$Spoiler));
				case 15:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_StickerId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$RichText$Sticker));
				case 16:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$author$project$Evergreen$V419$RichText$w3_unsafe_decode_RichText$(w3_x_c_userId, w3_x_c_channelId)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$RichText$Strikethrough));
				case 17:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$TimeInMinutes$w3_unsafe_decode_TimeInMinutes,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$RichText$Timestamp));
				case 18:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$author$project$Evergreen$V419$RichText$w3_unsafe_decode_RichText$(w3_x_c_userId, w3_x_c_channelId)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$RichText$Underline));
				case 19:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_userId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$RichText$UserMention));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V419$RichText$w3_unsafe_decode_RichText = F2($author$project$Evergreen$V419$RichText$w3_unsafe_decode_RichText$);
var $author$project$Evergreen$V419$Message$w3_unsafe_decode_MessageContent$ = function (w3_x_c_userId, w3_x_c_channelId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V419$Embed$w3_unsafe_decode_Embed),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
				$author$project$Evergreen$V419$RichText$w3_unsafe_decode_RichText$(w3_x_c_userId, w3_x_c_channelId)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
					$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileData),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F3(
						function (attachedFiles0, content0, embeds0) {
							return {attachedFiles: attachedFiles0, content: content0, embeds: embeds0};
						})))));
};
var $author$project$Evergreen$V419$Message$w3_unsafe_decode_MessageContent = F2($author$project$Evergreen$V419$Message$w3_unsafe_decode_MessageContent$);
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_PendingEncryptedEdit = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DmId,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$Message$w3_unsafe_decode_MessageContent$(
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId)),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (contentAndEmbeds0, id0, threadRoute0) {
						return {contentAndEmbeds: contentAndEmbeds0, id: id0, threadRoute: threadRoute0};
					})))));
var $author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Id$NoThread);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Id$ViewThread));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_PendingEncryptedFile = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (fileId0, guildOrDmId0) {
					return {fileId: fileId0, guildOrDmId: guildOrDmId0};
				}))));
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_PendingEncryptedManyMessages = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeList(
		$lamdera$codecs$Lamdera$Wire3$decodePair$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
			$author$project$Evergreen$V419$Message$w3_unsafe_decode_MessageContent$(
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId)))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DmId,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, messages0) {
					return {id: id0, messages: messages0};
				}))));
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_PendingEncryptedMessage = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Message$w3_unsafe_decode_ThreadRouteWithRepliedTo,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$Message$w3_unsafe_decode_MessageContent$(
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId)),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (contentAndEmbeds0, otherUserId0, threadRoute0) {
						return {contentAndEmbeds: contentAndEmbeds0, otherUserId: otherUserId0, threadRoute: threadRoute0};
					})))));
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_EncryptionRequests = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Encryption$w3_unsafe_decode_EncryptManyRequestId),
		$author$project$Evergreen$V419$Types$w3_unsafe_decode_PendingEncryptedMessage),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Encryption$w3_unsafe_decode_EncryptManyRequestId),
			$author$project$Evergreen$V419$Types$w3_unsafe_decode_PendingEncryptedManyMessages),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Encryption$w3_unsafe_decode_EncryptFileRequestId),
				$author$project$Evergreen$V419$Types$w3_unsafe_decode_PendingEncryptedFile),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Encryption$w3_unsafe_decode_EncryptRequestId),
					$author$project$Evergreen$V419$Types$w3_unsafe_decode_PendingEncryptedEdit),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Encryption$w3_unsafe_decode_DecryptManyRequestId),
						$author$project$Evergreen$V419$Types$w3_unsafe_decode_PendingDecryptedOldMessages),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Encryption$w3_unsafe_decode_DecryptRequestId),
							$author$project$Evergreen$V419$Types$w3_unsafe_decode_PendingDecryptedMessage),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqDict$decodeDict$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Encryption$w3_unsafe_decode_DecryptManyRequestId),
								$author$project$Evergreen$V419$Types$w3_unsafe_decode_PendingDecryptedManyMessages),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Encryption$w3_unsafe_decode_EncryptRequestId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Encryption$w3_unsafe_decode_EncryptManyRequestId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Encryption$w3_unsafe_decode_EncryptFileRequestId),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Encryption$w3_unsafe_decode_DecryptRequestId),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Encryption$w3_unsafe_decode_DecryptManyRequestId),
												$lamdera$codecs$Lamdera$Wire3$succeedDecode(
													function (nextDecryptManyRequestId0) {
														return function (nextDecryptionRequestId0) {
															return function (nextEncryptFileRequestId0) {
																return function (nextEncryptManyRequestId0) {
																	return function (nextEncryptionRequestId0) {
																		return function (pendingDecryptedManyMessages0) {
																			return function (pendingDecryptedMessages0) {
																				return function (pendingDecryptedOldMessages0) {
																					return function (pendingEncryptedEdits0) {
																						return function (pendingEncryptedFiles0) {
																							return function (pendingEncryptedManyMessages0) {
																								return function (pendingEncryptedMessages0) {
																									return {nextDecryptManyRequestId: nextDecryptManyRequestId0, nextDecryptionRequestId: nextDecryptionRequestId0, nextEncryptFileRequestId: nextEncryptFileRequestId0, nextEncryptManyRequestId: nextEncryptManyRequestId0, nextEncryptionRequestId: nextEncryptionRequestId0, pendingDecryptedManyMessages: pendingDecryptedManyMessages0, pendingDecryptedMessages: pendingDecryptedMessages0, pendingDecryptedOldMessages: pendingDecryptedOldMessages0, pendingEncryptedEdits: pendingEncryptedEdits0, pendingEncryptedFiles: pendingEncryptedFiles0, pendingEncryptedManyMessages: pendingEncryptedManyMessages0, pendingEncryptedMessages: pendingEncryptedMessages0};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													})))))))))))));
var $author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileDataWithImage = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileMetadata,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_IsEncrypted,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$FileName$w3_unsafe_decode_FileName,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_ContentType,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F6(
								function (contentType0, fileHash0, fileName0, fileSize0, isEncrypted0, metadata0) {
									return {contentType: contentType0, fileHash: fileHash0, fileName: fileName0, fileSize: fileSize0, isEncrypted: isEncrypted0, metadata: metadata0};
								}))))))));
var $author$project$Evergreen$V419$OneOrGreater$w3_unsafe_decode_OneOrGreater = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_FileDrag = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$OneOrGreater$w3_unsafe_decode_OneOrGreater,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$FileDragging)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$NoFileDrag));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Local$w3_unsafe_decode_ChangeId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Local$w3_unsafe_decode_Local$ = function (w3_x_c_msg, w3_x_c_model) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_model,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeDict$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									w3_x_c_msg,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										A2(
											$lamdera$codecs$Lamdera$Wire3$andThenDecode,
											function (t) {
												return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
													$elm$time$Time$millisToPosix(t));
											},
											$lamdera$codecs$Lamdera$Wire3$decodeInt),
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											F2(
												function (createdAt0, msg0) {
													return {createdAt: createdAt0, msg: msg0};
												}))))),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								w3_x_c_model,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Local$w3_unsafe_decode_ChangeId,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F4(
											function (counter0, localModel0, localMsgs0, serverModel0) {
												return {counter: counter0, localModel: localModel0, localMsgs: localMsgs0, serverModel: serverModel0};
											})))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V419$Local$w3_unsafe_decode_Local = F2($author$project$Evergreen$V419$Local$w3_unsafe_decode_Local$);
var $author$project$Evergreen$V419$GuildName$w3_unsafe_decode_GuildName = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminData_DeletedGuild = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$GuildName$w3_unsafe_decode_GuildName,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (deletedAt0, memberCount0, name0, owner0) {
							return {deletedAt: deletedAt0, memberCount: memberCount0, name: name0, owner: owner0};
						}))))));
var $author$project$Evergreen$V419$Message$w3_unsafe_decode_CallRecordingFile = function (w3_x_c_userId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			A2(
				$lamdera$codecs$Lamdera$Wire3$andThenDecode,
				function (t) {
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
						$elm$time$Time$millisToPosix(t));
				},
				$lamdera$codecs$Lamdera$Wire3$decodeInt),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					w3_x_c_userId,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							A2(
								$lamdera$codecs$Lamdera$Wire3$andThenDecode,
								function (t) {
									return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
										$elm$time$Time$millisToPosix(t));
								},
								$lamdera$codecs$Lamdera$Wire3$decodeInt),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F6(
									function (endedAt0, name0, recordedBy0, size0, startedAt0, uploaded0) {
										return {endedAt: endedAt0, name: name0, recordedBy: recordedBy0, size: size0, startedAt: startedAt0, uploaded: uploaded0};
									}))))))));
};
var $author$project$Evergreen$V419$Message$w3_unsafe_decode_CallRecordingZip = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (fileCount0, fileHash0, size0) {
						return {fileCount: fileCount0, fileHash: fileHash0, size: size0};
					})))));
var $author$project$Evergreen$V419$NonemptySet$w3_unsafe_decode_NonemptySet = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqSet$decodeSet(w3_x_c_a),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_a,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$NonemptySet$NonemptySet)));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V419$Message$w3_unsafe_decode_CallRecording = function (w3_x_c_userId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Message$w3_unsafe_decode_CallRecordingZip),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			A2(
				$lamdera$codecs$Lamdera$Wire3$andThenDecode,
				function (t) {
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
						$elm$time$Time$millisToPosix(t));
				},
				$lamdera$codecs$Lamdera$Wire3$decodeInt),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$NonemptySet$w3_unsafe_decode_NonemptySet(w3_x_c_userId),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqSet$decodeSet(w3_x_c_userId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeList(
							$author$project$Evergreen$V419$Message$w3_unsafe_decode_CallRecordingFile(w3_x_c_userId)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F5(
								function (files0, finishedUploading0, participants0, startedAt0, zip0) {
									return {files: files0, finishedUploading: finishedUploading0, participants: participants0, startedAt: startedAt0, zip: zip0};
								})))))));
};
var $author$project$Evergreen$V419$Drawing$w3_unsafe_decode_Stroke = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
		$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V419$SafeFloat$w3_unsafe_decode_SafeFloat, $author$project$Evergreen$V419$SafeFloat$w3_unsafe_decode_SafeFloat)),
	$lamdera$codecs$Lamdera$Wire3$succeedDecode(
		function (points0) {
			return {points: points0};
		}));
var $author$project$Evergreen$V419$Drawing$w3_unsafe_decode_Drawing = function (w3_x_c_userId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			w3_x_c_userId,
			$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V419$Drawing$w3_unsafe_decode_Stroke)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(w3_x_c_userId, $author$project$Evergreen$V419$Drawing$w3_unsafe_decode_Stroke),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeList(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V419$SafeFloat$w3_unsafe_decode_SafeFloat, $author$project$Evergreen$V419$SafeFloat$w3_unsafe_decode_SafeFloat)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							w3_x_c_userId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (createdBy0, points0) {
										return {createdBy: createdBy0, points: points0};
									}))))),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F3(
						function (finished0, inProgress0, undone0) {
							return {finished: finished0, inProgress: inProgress0, undone: undone0};
						})))));
};
var $author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_CustomEmojiId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Emoji$EmojiOrCustomEmoji_CustomEmoji));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_UnicodeEmoji,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Emoji$EmojiOrCustomEmoji_Emoji));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Message$w3_unsafe_decode_CallStartedData = function (w3_x_c_userId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			w3_x_c_userId,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$andThenDecode,
					function (t) {
						return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
							$elm$time$Time$millisToPosix(t));
					},
					$lamdera$codecs$Lamdera$Wire3$decodeInt),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Evergreen$V419$Message$w3_unsafe_decode_CallRecording(w3_x_c_userId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
							$author$project$Evergreen$V419$NonemptySet$w3_unsafe_decode_NonemptySet(w3_x_c_userId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqSet$decodeSet(w3_x_c_userId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
									A2(
										$lamdera$codecs$Lamdera$Wire3$andThenDecode,
										function (t) {
											return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
												$elm$time$Time$millisToPosix(t));
										},
										$lamdera$codecs$Lamdera$Wire3$decodeInt)),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F8(
											function (cardDrawings0, endedAt0, joinedBy0, reactions0, recordings0, startedAt0, startedBy0, timestampDrawings0) {
												return {cardDrawings: cardDrawings0, endedAt: endedAt0, joinedBy: joinedBy0, reactions: reactions0, recordings: recordings0, startedAt: startedAt0, startedBy: startedBy0, timestampDrawings: timestampDrawings0};
											}))))))))));
};
var $author$project$Evergreen$V419$Encryption$w3_unsafe_decode_EncryptedData = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBytes,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V419$Message$w3_unsafe_decode_UserTextMessageDrawings = function (w3_x_c_userId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
					$author$project$Evergreen$V419$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId)),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$author$project$Evergreen$V419$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F4(
							function (embedDrawings0, imageAttachmentDrawings0, timestampDrawings0, userIconDrawings0) {
								return {embedDrawings: embedDrawings0, imageAttachmentDrawings: imageAttachmentDrawings0, timestampDrawings: timestampDrawings0, userIconDrawings: userIconDrawings0};
							}))))));
};
var $author$project$Evergreen$V419$Message$w3_unsafe_decode_EncryptedUserTextMessageData$ = function (w3_x_c_messageId, w3_x_c_userId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Message$w3_unsafe_decode_RepliedTo(w3_x_c_messageId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
				$author$project$Evergreen$V419$NonemptySet$w3_unsafe_decode_NonemptySet(w3_x_c_userId)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqSet$decodeSet($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						A2(
							$lamdera$codecs$Lamdera$Wire3$andThenDecode,
							function (t) {
								return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
									$elm$time$Time$millisToPosix(t));
							},
							$lamdera$codecs$Lamdera$Wire3$decodeInt)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$Evergreen$V419$Message$w3_unsafe_decode_UserTextMessageDrawings(w3_x_c_userId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							w3_x_c_userId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								A2(
									$lamdera$codecs$Lamdera$Wire3$andThenDecode,
									function (t) {
										return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
											$elm$time$Time$millisToPosix(t));
									},
									$lamdera$codecs$Lamdera$Wire3$decodeInt),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Encryption$w3_unsafe_decode_EncryptedData(
										$author$project$Evergreen$V419$Message$w3_unsafe_decode_MessageContent$(
											w3_x_c_userId,
											$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId))),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F8(
											function (content0, createdAt0, createdBy0, drawings0, editedAt0, fileHashes0, reactions0, repliedTo0) {
												return {content: content0, createdAt: createdAt0, createdBy: createdBy0, drawings: drawings0, editedAt: editedAt0, fileHashes: fileHashes0, reactions: reactions0, repliedTo: repliedTo0};
											}))))))))));
};
var $author$project$Evergreen$V419$Message$w3_unsafe_decode_EncryptedUserTextMessageData = F2($author$project$Evergreen$V419$Message$w3_unsafe_decode_EncryptedUserTextMessageData$);
var $author$project$Evergreen$V419$Message$w3_unsafe_decode_GameType = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Message$w3_unsafe_decode_GameStartedData = function (w3_x_c_userId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			w3_x_c_userId,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$andThenDecode,
					function (t) {
						return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
							$elm$time$Time$millisToPosix(t));
					},
					$lamdera$codecs$Lamdera$Wire3$decodeInt),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
						$author$project$Evergreen$V419$NonemptySet$w3_unsafe_decode_NonemptySet(w3_x_c_userId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Message$w3_unsafe_decode_GameType,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F6(
									function (cardDrawings0, gameType0, reactions0, startedAt0, startedBy0, timestampDrawings0) {
										return {cardDrawings: cardDrawings0, gameType: gameType0, reactions: reactions0, startedAt: startedAt0, startedBy: startedBy0, timestampDrawings: timestampDrawings0};
									}))))))));
};
var $author$project$Evergreen$V419$Message$w3_unsafe_decode_UserTextMessageData$ = function (w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Message$w3_unsafe_decode_RepliedTo(w3_x_c_messageId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
				$author$project$Evergreen$V419$NonemptySet$w3_unsafe_decode_NonemptySet(w3_x_c_userId)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
					A2(
						$lamdera$codecs$Lamdera$Wire3$andThenDecode,
						function (t) {
							return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
								$elm$time$Time$millisToPosix(t));
						},
						$lamdera$codecs$Lamdera$Wire3$decodeInt)),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Evergreen$V419$Message$w3_unsafe_decode_UserTextMessageDrawings(w3_x_c_userId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_userId,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							A2(
								$lamdera$codecs$Lamdera$Wire3$andThenDecode,
								function (t) {
									return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
										$elm$time$Time$millisToPosix(t));
								},
								$lamdera$codecs$Lamdera$Wire3$decodeInt),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Message$w3_unsafe_decode_MessageContent$(w3_x_c_userId, w3_x_c_channelId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F7(
										function (content0, createdAt0, createdBy0, drawings0, editedAt0, reactions0, repliedTo0) {
											return {content: content0, createdAt: createdAt0, createdBy: createdBy0, drawings: drawings0, editedAt: editedAt0, reactions: reactions0, repliedTo: repliedTo0};
										})))))))));
};
var $author$project$Evergreen$V419$Message$w3_unsafe_decode_UserTextMessageData = F3($author$project$Evergreen$V419$Message$w3_unsafe_decode_UserTextMessageData$);
var $author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$ = function (w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Message$w3_unsafe_decode_CallStartedData(w3_x_c_userId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Message$CallStarted));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						A2(
							$lamdera$codecs$Lamdera$Wire3$andThenDecode,
							function (t) {
								return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
									$elm$time$Time$millisToPosix(t));
							},
							$lamdera$codecs$Lamdera$Wire3$decodeInt),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Message$DeletedMessage));
				case 2:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Message$w3_unsafe_decode_EncryptedUserTextMessageData$(w3_x_c_messageId, w3_x_c_userId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Message$EncryptedUserTextMessage));
				case 3:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Message$w3_unsafe_decode_GameStartedData(w3_x_c_userId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Message$GameStarted));
				case 4:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqDict$decodeDict$(
								$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
								$author$project$Evergreen$V419$NonemptySet$w3_unsafe_decode_NonemptySet(w3_x_c_userId)),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								w3_x_c_userId,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									A2(
										$lamdera$codecs$Lamdera$Wire3$andThenDecode,
										function (t) {
											return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
												$elm$time$Time$millisToPosix(t));
										},
										$lamdera$codecs$Lamdera$Wire3$decodeInt),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Message$UserJoinedMessage)))));
				case 5:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Message$w3_unsafe_decode_UserTextMessageData$(w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Message$UserTextMessage));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V419$Message$w3_unsafe_decode_Message = F3($author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$);
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminData_DiscordDmChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
			$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					function (messagesSent0) {
						return {messagesSent: messagesSent0};
					}))),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
				$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId,
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId))),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (firstMessage0, members0, messageCount0) {
						return {firstMessage: firstMessage0, members: members0, messageCount: messageCount0};
					})))));
var $author$project$Evergreen$V419$ChannelName$w3_unsafe_decode_ChannelName = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Discord$w3_unsafe_decode_Permissions = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeBool,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeBool,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeBool,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeBool,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeBool,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeBool,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeBool,
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeBool,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$codecs$Lamdera$Wire3$decodeBool,
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$lamdera$codecs$Lamdera$Wire3$decodeBool,
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$lamdera$codecs$Lamdera$Wire3$decodeBool,
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$lamdera$codecs$Lamdera$Wire3$decodeBool,
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$lamdera$codecs$Lamdera$Wire3$decodeBool,
																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																		$lamdera$codecs$Lamdera$Wire3$decodeBool,
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$codecs$Lamdera$Wire3$decodeBool,
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$lamdera$codecs$Lamdera$Wire3$decodeBool,
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$lamdera$codecs$Lamdera$Wire3$decodeBool,
																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																						$lamdera$codecs$Lamdera$Wire3$decodeBool,
																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																							$lamdera$codecs$Lamdera$Wire3$decodeBool,
																							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																								$lamdera$codecs$Lamdera$Wire3$decodeBool,
																								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																									$lamdera$codecs$Lamdera$Wire3$decodeBool,
																									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																										$lamdera$codecs$Lamdera$Wire3$decodeBool,
																										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																											$lamdera$codecs$Lamdera$Wire3$decodeBool,
																											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																												$lamdera$codecs$Lamdera$Wire3$decodeBool,
																												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																													$lamdera$codecs$Lamdera$Wire3$decodeBool,
																													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																														$lamdera$codecs$Lamdera$Wire3$decodeBool,
																														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																															$lamdera$codecs$Lamdera$Wire3$decodeBool,
																															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																	$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																		$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																			$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																				$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																					$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																						$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																							$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																								$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																									$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																										$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																											$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																												$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																													$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																														$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																															$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																																$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																																	$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																																	$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																																																		function (addReaction0) {
																																																			return function (administrator0) {
																																																				return function (attachFiles0) {
																																																					return function (banMembers0) {
																																																						return function (changeNickname0) {
																																																							return function (connect0) {
																																																								return function (createEvents0) {
																																																									return function (createGuildExpressions0) {
																																																										return function (createInstantInvite0) {
																																																											return function (createPrivateThreads0) {
																																																												return function (createPublicThreads0) {
																																																													return function (deafenMembers0) {
																																																														return function (embedLinks0) {
																																																															return function (kickMembers0) {
																																																																return function (manageChannels0) {
																																																																	return function (manageEvents0) {
																																																																		return function (manageGuild0) {
																																																																			return function (manageGuildExpressions0) {
																																																																				return function (manageMessages0) {
																																																																					return function (manageNicknames0) {
																																																																						return function (manageRoles0) {
																																																																							return function (manageThreads0) {
																																																																								return function (manageWebhooks0) {
																																																																									return function (mentionEveryone0) {
																																																																										return function (moderateMembers0) {
																																																																											return function (moveMembers0) {
																																																																												return function (muteMembers0) {
																																																																													return function (prioritySpeaker0) {
																																																																														return function (readMessageHistory0) {
																																																																															return function (requestToSpeak0) {
																																																																																return function (sendMessages0) {
																																																																																	return function (sendMessagesInThreads0) {
																																																																																		return function (sendPolls0) {
																																																																																			return function (sendVoiceMessages0) {
																																																																																				return function (sentTextToSpeechMessages0) {
																																																																																					return function (speak0) {
																																																																																						return function (stream0) {
																																																																																							return function (useApplicationCommands0) {
																																																																																								return function (useEmbeddedActivities0) {
																																																																																									return function (useExternalApps0) {
																																																																																										return function (useExternalEmojis0) {
																																																																																											return function (useExternalSounds0) {
																																																																																												return function (useExternalStickers0) {
																																																																																													return function (useSoundboard0) {
																																																																																														return function (useVoiceActivityDetection0) {
																																																																																															return function (viewAuditLog0) {
																																																																																																return function (viewChannel0) {
																																																																																																	return function (viewCreatorMontetizationAnalytics0) {
																																																																																																		return function (viewGuildInsights0) {
																																																																																																			return {addReaction: addReaction0, administrator: administrator0, attachFiles: attachFiles0, banMembers: banMembers0, changeNickname: changeNickname0, connect: connect0, createEvents: createEvents0, createGuildExpressions: createGuildExpressions0, createInstantInvite: createInstantInvite0, createPrivateThreads: createPrivateThreads0, createPublicThreads: createPublicThreads0, deafenMembers: deafenMembers0, embedLinks: embedLinks0, kickMembers: kickMembers0, manageChannels: manageChannels0, manageEvents: manageEvents0, manageGuild: manageGuild0, manageGuildExpressions: manageGuildExpressions0, manageMessages: manageMessages0, manageNicknames: manageNicknames0, manageRoles: manageRoles0, manageThreads: manageThreads0, manageWebhooks: manageWebhooks0, mentionEveryone: mentionEveryone0, moderateMembers: moderateMembers0, moveMembers: moveMembers0, muteMembers: muteMembers0, prioritySpeaker: prioritySpeaker0, readMessageHistory: readMessageHistory0, requestToSpeak: requestToSpeak0, sendMessages: sendMessages0, sendMessagesInThreads: sendMessagesInThreads0, sendPolls: sendPolls0, sendVoiceMessages: sendVoiceMessages0, sentTextToSpeechMessages: sentTextToSpeechMessages0, speak: speak0, stream: stream0, useApplicationCommands: useApplicationCommands0, useEmbeddedActivities: useEmbeddedActivities0, useExternalApps: useExternalApps0, useExternalEmojis: useExternalEmojis0, useExternalSounds: useExternalSounds0, useExternalStickers: useExternalStickers0, useSoundboard: useSoundboard0, useVoiceActivityDetection: useVoiceActivityDetection0, viewAuditLog: viewAuditLog0, viewChannel: viewChannel0, viewCreatorMontetizationAnalytics: viewCreatorMontetizationAnalytics0, viewGuildInsights: viewGuildInsights0};
																																																																																																		};
																																																																																																	};
																																																																																																};
																																																																																															};
																																																																																														};
																																																																																													};
																																																																																												};
																																																																																											};
																																																																																										};
																																																																																									};
																																																																																								};
																																																																																							};
																																																																																						};
																																																																																					};
																																																																																				};
																																																																																			};
																																																																																		};
																																																																																	};
																																																																																};
																																																																															};
																																																																														};
																																																																													};
																																																																												};
																																																																											};
																																																																										};
																																																																									};
																																																																								};
																																																																							};
																																																																						};
																																																																					};
																																																																				};
																																																																			};
																																																																		};
																																																																	};
																																																																};
																																																															};
																																																														};
																																																													};
																																																												};
																																																											};
																																																										};
																																																									};
																																																								};
																																																							};
																																																						};
																																																					};
																																																				};
																																																			};
																																																		}))))))))))))))))))))))))))))))))))))))))))))))))));
var $author$project$Evergreen$V419$Discord$RoleId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Discord$w3_unsafe_decode_RoleId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Discord$w3_unsafe_decode_RoleOrUserId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_RoleId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Discord$RoleOrUserId_RoleId));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Discord$RoleOrUserId_UserId));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Discord$w3_unsafe_decode_Overwrite = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Discord$w3_unsafe_decode_RoleOrUserId,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Permissions,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Permissions,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (allow0, deny0, id0) {
						return {allow: allow0, deny: deny0, id: id0};
					})))));
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminData_DiscordChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V419$Discord$w3_unsafe_decode_Overwrite),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$ChannelName$w3_unsafe_decode_ChannelName,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId,
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (firstMessage0, messageCount0, name0, permissionOverwrites0, threadCount0) {
								return {firstMessage: firstMessage0, messageCount: messageCount0, name: name0, permissionOverwrites: permissionOverwrites0, threadCount: threadCount0};
							})))))));
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_DiscordRole = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Permissions,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (description0, name0, permissions0) {
						return {description: description0, name: name0, permissions: permissions0};
					})))));
var $author$project$Evergreen$V419$MembersAndOwner$w3_unsafe_decode_MembersAndOwner$ = function (w3_x_c_userId, w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					w3_x_c_userId,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(w3_x_c_userId, w3_x_c_a),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MembersAndOwner$MembersAndOwner)));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V419$MembersAndOwner$w3_unsafe_decode_MembersAndOwner = F2($author$project$Evergreen$V419$MembersAndOwner$w3_unsafe_decode_MembersAndOwner$);
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminData_DiscordGuild = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_RoleId),
		$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_DiscordRole),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$GuildName$w3_unsafe_decode_GuildName,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$MembersAndOwner$w3_unsafe_decode_MembersAndOwner$(
				$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqSet$decodeSet(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_RoleId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F2(
								function (joinedAt0, roles0) {
									return {joinedAt: joinedAt0, roles: roles0};
								}))))),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
					$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminData_DiscordChannel),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (channels0, membersAndOwner0, name0, roles0) {
							return {channels: channels0, membersAndOwner: membersAndOwner0, name: name0, roles: roles0};
						}))))));
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminData_DmChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (messageCount0, threadCount0) {
					return {messageCount: messageCount0, threadCount: threadCount0};
				}))));
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminData_GuildChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$ChannelName$w3_unsafe_decode_ChannelName,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (messageCount0, name0) {
					return {messageCount: messageCount0, name: name0};
				}))));
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminData_Guild = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$GuildName$w3_unsafe_decode_GuildName,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId),
					$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminData_GuildChannel),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (channels0, memberCount0, name0, owner0) {
							return {channels: channels0, memberCount: memberCount0, name: name0, owner: owner0};
						}))))));
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminData_SlackDmChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList(
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F2(
								function (id0, name0) {
									return {id: id0, name: name0};
								}))))),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
					$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId,
						$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
						$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId))),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (firstMessage0, members0, messageCount0, teamId0) {
							return {firstMessage: firstMessage0, members: members0, messageCount: messageCount0, teamId: teamId0};
						}))))));
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminData_SlackWorkspace = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F2(
								function (linkedTo0, name0) {
									return {linkedTo: linkedTo0, name: name0};
								}))))),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$ChannelName$w3_unsafe_decode_ChannelName,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$containers$SeqSet$decodeSet(
										$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId)),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeBool,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
												$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
													$author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId,
													$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
													$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId))),
											$lamdera$codecs$Lamdera$Wire3$succeedDecode(
												F5(
													function (firstMessage0, isPrivate0, linkedMembers0, messageCount0, name0) {
														return {firstMessage: firstMessage0, isPrivate: isPrivate0, linkedMembers: linkedMembers0, messageCount: messageCount0, name: name0};
													})))))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (channels0, domain0, linkedUsers0, name0, userCount0) {
								return {channels: channels0, domain: domain0, linkedUsers: linkedUsers0, name: name0, userCount: userCount0};
							})))))));
var $author$project$Evergreen$V419$Postmark$w3_unsafe_decode_ApiKey = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_BackendFileData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
		$author$project$Evergreen$V419$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (fileSize0, imageSize0) {
					return {fileSize: fileSize0, imageSize: imageSize0};
				}))));
var $author$project$Evergreen$V419$BackendMsgLog$w3_unsafe_decode_BackendMsgLog = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(20);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(91);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(34);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(35);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(54);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(12);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(11);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(78);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(16);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(15);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(65);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(64);
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(66);
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(63);
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(49);
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(50);
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(18);
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(17);
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(19);
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(8);
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(55);
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(14);
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(13);
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(53);
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(47);
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(26);
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(58);
			case 28:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(57);
			case 29:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(73);
			case 30:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(70);
			case 31:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(71);
			case 32:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(69);
			case 33:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(75);
			case 34:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(21);
			case 35:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(62);
			case 36:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(83);
			case 37:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(61);
			case 38:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(72);
			case 39:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(25);
			case 40:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(84);
			case 41:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(90);
			case 42:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(60);
			case 43:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(59);
			case 44:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(81);
			case 45:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(23);
			case 46:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(44);
			case 47:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(79);
			case 48:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(74);
			case 49:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(67);
			case 50:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(24);
			case 51:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(31);
			case 52:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(32);
			case 53:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 54:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(33);
			case 55:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(77);
			case 56:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(43);
			case 57:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(52);
			case 58:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(51);
			case 59:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(80);
			case 60:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(82);
			case 61:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(86);
			case 62:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(88);
			case 63:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(87);
			case 64:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(89);
			case 65:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(85);
			case 66:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(56);
			case 67:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(76);
			case 68:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(10);
			case 69:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(9);
			case 70:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			case 71:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 72:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(22);
			case 73:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			case 74:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(37);
			case 75:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(27);
			case 76:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(28);
			case 77:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(29);
			case 78:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(36);
			case 79:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(30);
			case 80:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(39);
			case 81:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(38);
			case 82:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(40);
			case 83:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(42);
			case 84:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(41);
			case 85:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(68);
			case 86:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 87:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 88:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 89:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(46);
			case 90:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(45);
			case 91:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(48);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$BackendMsgLog$w3_unsafe_decode_BackendMsgLogData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$BackendMsgLog$w3_unsafe_decode_BackendMsgLog,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (backendMsgLog0, endTime0, startTime0) {
						return {backendMsgLog: backendMsgLog0, endTime: endTime0, startTime: startTime0};
					})))));
var $author$project$Evergreen$V419$EmailAddress$w3_unsafe_decode_EmailAddress = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeString),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeString,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeString,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F4(
										function (domain0, localPart0, tags0, tld0) {
											return {domain: domain0, localPart: localPart0, tags: tags0, tld: tld0};
										})))))),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$User$w3_unsafe_decode_BackendUserStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$User$DeletedUser);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$EmailAddress$w3_unsafe_decode_EmailAddress,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$User$UserHasEmail));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$RichText$w3_unsafe_decode_Domain = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$User$w3_unsafe_decode_EmailNotifications = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$User$w3_unsafe_decode_EmbedVisibility = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Emoji$w3_unsafe_decode_SkinTone = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiConfig = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Emoji$w3_unsafe_decode_SkinTone),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (lastUsedEmojis0, skinTone0) {
					return {lastUsedEmojis: lastUsedEmojis0, skinTone: skinTone0};
				}))));
var $author$project$Evergreen$V419$User$w3_unsafe_decode_LastDmViewed = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$User$DiscordDmChannelLastViewed));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$User$DmChannelLastViewed)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$User$NoLastDmViewed);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_MutedChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
		$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (mutedChannel0, mutedThreads0) {
					return {mutedChannel: mutedChannel0, mutedThreads: mutedThreads0};
				}))));
var $author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_MutedDiscordGuild = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
			$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_MutedChannel),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (channels0, mutedGuild0) {
					return {channels: channels0, mutedGuild: mutedGuild0};
				}))));
var $author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_MutedGuild = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId),
			$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_MutedChannel),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (channels0, mutedGuild0) {
					return {channels: channels0, mutedGuild: mutedGuild0};
				}))));
var $author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_MutedSlackWorkspace = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId),
			$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_MutedChannel),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (channels0, mutedWorkspace0) {
					return {channels: channels0, mutedWorkspace: mutedWorkspace0};
				}))));
var $author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
		$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_MutedSlackWorkspace),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
			$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_MutedGuild),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
				$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_MutedChannel),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
					$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_MutedDiscordGuild),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
						$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (mutedDiscordDms0, mutedDiscordGuilds0, mutedDms0, mutedGuilds0, mutedSlackWorkspaces0) {
								return {mutedDiscordDms: mutedDiscordDms0, mutedDiscordGuilds: mutedDiscordGuilds0, mutedDms: mutedDms0, mutedGuilds: mutedGuilds0, mutedSlackWorkspaces: mutedSlackWorkspaces0};
							})))))));
var $author$project$Evergreen$V419$Pagination$PageId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Pagination$w3_unsafe_decode_PageId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$PersonName$w3_unsafe_decode_PersonName = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$X25519$w3_unsafe_decode_Key = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F8(
										function (w00, w10, w20, w30, w40, w50, w60, w70) {
											return {w0: w00, w1: w10, w2: w20, w3: w30, w4: w40, w5: w50, w6: w60, w7: w70};
										}))))))))));
var $author$project$Evergreen$V419$X25519$w3_unsafe_decode_PublicKey = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$X25519$w3_unsafe_decode_Key,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$UserColor$w3_unsafe_decode_UserColor = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$User$w3_unsafe_decode_BackendUser = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqSet$decodeSet(
		$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
			$author$project$Evergreen$V419$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
				$lamdera$codecs$Lamdera$Wire3$decodePair$(
					$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId),
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute),
				$author$project$Evergreen$V419$OneOrGreater$w3_unsafe_decode_OneOrGreater)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$X25519$w3_unsafe_decode_PublicKey),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqSet$decodeSet(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$PersonName$w3_unsafe_decode_PersonName,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_Model,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeBool,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeBool,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$containers$SeqDict$decodeDict$(
											$lamdera$codecs$Lamdera$Wire3$decodePair$(
												$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
												$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId)),
											$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId)),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$containers$SeqDict$decodeDict$(
												$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
												$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId)),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$containers$SeqDict$decodeDict$(
													$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
													$lamdera$codecs$Lamdera$Wire3$decodePair$(
														$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId),
														$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute)),
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Pagination$w3_unsafe_decode_PageId),
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$author$project$Evergreen$V419$User$w3_unsafe_decode_LastDmViewed,
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$lamdera$containers$SeqDict$decodeDict$(
																		$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
																		$lamdera$codecs$Lamdera$Wire3$decodePair$(
																			$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
																			$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute)),
																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																		$lamdera$containers$SeqDict$decodeDict$(
																			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
																			$lamdera$codecs$Lamdera$Wire3$decodePair$(
																				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId),
																				$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute)),
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$codecs$Lamdera$Wire3$decodeBool,
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash),
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiConfig,
																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																						$author$project$Evergreen$V419$User$w3_unsafe_decode_EmbedVisibility,
																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																							$author$project$Evergreen$V419$User$w3_unsafe_decode_EmailNotifications,
																							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																								$author$project$Evergreen$V419$User$w3_unsafe_decode_BackendUserStatus,
																								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																									$lamdera$codecs$Lamdera$Wire3$decodeBool,
																									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																										$lamdera$containers$SeqSet$decodeSet($author$project$Evergreen$V419$RichText$w3_unsafe_decode_Domain),
																										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																											$lamdera$containers$SeqSet$decodeSet(
																												$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId)),
																											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																												$lamdera$containers$SeqDict$decodeDict$(
																													$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
																													$author$project$Evergreen$V419$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
																														$lamdera$codecs$Lamdera$Wire3$decodePair$(
																															$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
																															$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute),
																														$author$project$Evergreen$V419$OneOrGreater$w3_unsafe_decode_OneOrGreater)),
																												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																													$lamdera$containers$SeqDict$decodeDict$(
																														$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
																														$author$project$Evergreen$V419$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
																															$lamdera$codecs$Lamdera$Wire3$decodePair$(
																																$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId),
																																$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute),
																															$author$project$Evergreen$V419$OneOrGreater$w3_unsafe_decode_OneOrGreater)),
																													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																														$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
																														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																															$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
																															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																$author$project$Evergreen$V419$UserColor$w3_unsafe_decode_UserColor,
																																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																	$lamdera$containers$SeqSet$decodeSet(
																																		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_StickerId)),
																																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																		$lamdera$containers$SeqSet$decodeSet(
																																			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_CustomEmojiId)),
																																		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																																			function (availableCustomEmojis0) {
																																				return function (availableStickers0) {
																																					return function (color0) {
																																						return function (createdAt0) {
																																							return function (deleteAccountAt0) {
																																								return function (directMentions0) {
																																									return function (discordDirectMentions0) {
																																										return function (discordNotifyOnAllMessages0) {
																																											return function (domainWhitelist0) {
																																												return function (e2eeRisksAccepted0) {
																																													return function (email0) {
																																														return function (emailNotifications0) {
																																															return function (embedVisibility0) {
																																																return function (emojiConfig0) {
																																																	return function (icon0) {
																																																		return function (isAdmin0) {
																																																			return function (lastChannelViewed0) {
																																																				return function (lastDiscordChannelViewed0) {
																																																					return function (lastDmViewed0) {
																																																						return function (lastEmailNotification0) {
																																																							return function (lastLogPageViewed0) {
																																																								return function (lastPushNotification0) {
																																																									return function (lastSlackChannelViewed0) {
																																																										return function (lastViewedMessage0) {
																																																											return function (lastViewedThreadMessage0) {
																																																												return function (linkDiscordAcknowledgementIsChecked0) {
																																																													return function (linkSlackAcknowledgementIsChecked0) {
																																																														return function (muteSettings0) {
																																																															return function (name0) {
																																																																return function (notifyOnAllMessages0) {
																																																																	return function (publicKey0) {
																																																																		return function (recentLoginEmails0) {
																																																																			return function (slackDirectMentions0) {
																																																																				return function (slackNotifyOnAllMessages0) {
																																																																					return {availableCustomEmojis: availableCustomEmojis0, availableStickers: availableStickers0, color: color0, createdAt: createdAt0, deleteAccountAt: deleteAccountAt0, directMentions: directMentions0, discordDirectMentions: discordDirectMentions0, discordNotifyOnAllMessages: discordNotifyOnAllMessages0, domainWhitelist: domainWhitelist0, e2eeRisksAccepted: e2eeRisksAccepted0, email: email0, emailNotifications: emailNotifications0, embedVisibility: embedVisibility0, emojiConfig: emojiConfig0, icon: icon0, isAdmin: isAdmin0, lastChannelViewed: lastChannelViewed0, lastDiscordChannelViewed: lastDiscordChannelViewed0, lastDmViewed: lastDmViewed0, lastEmailNotification: lastEmailNotification0, lastLogPageViewed: lastLogPageViewed0, lastPushNotification: lastPushNotification0, lastSlackChannelViewed: lastSlackChannelViewed0, lastViewedMessage: lastViewedMessage0, lastViewedThreadMessage: lastViewedThreadMessage0, linkDiscordAcknowledgementIsChecked: linkDiscordAcknowledgementIsChecked0, linkSlackAcknowledgementIsChecked: linkSlackAcknowledgementIsChecked0, muteSettings: muteSettings0, name: name0, notifyOnAllMessages: notifyOnAllMessages0, publicKey: publicKey0, recentLoginEmails: recentLoginEmails0, slackDirectMentions: slackDirectMentions0, slackNotifyOnAllMessages: slackNotifyOnAllMessages0};
																																																																				};
																																																																			};
																																																																		};
																																																																	};
																																																																};
																																																															};
																																																														};
																																																													};
																																																												};
																																																											};
																																																										};
																																																									};
																																																								};
																																																							};
																																																						};
																																																					};
																																																				};
																																																			};
																																																		};
																																																	};
																																																};
																																															};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			})))))))))))))))))))))))))))))))))));
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_DiscordGatewayStatus = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (failedReconnectAttempts0, websocketIsOpen0) {
					return {failedReconnectAttempts: failedReconnectAttempts0, websocketIsOpen: websocketIsOpen0};
				}))));
var $author$project$Evergreen$V419$DiscordUserData$w3_unsafe_decode_DiscordUserLoadingData = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$DiscordUserData$DiscordUserLoadedSuccessfully);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$DiscordUserData$DiscordUserLoadingData));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$DiscordUserData$DiscordUserLoadingFailed));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Discord$AvatarHash = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Discord$w3_unsafe_decode_AvatarHash = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Discord$w3_unsafe_decode_ImageHash = function (w3_x_c_hashType) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserDiscriminator = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Discord$w3_unsafe_decode_PartialUser = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserDiscriminator,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_ImageHash($author$project$Evergreen$V419$Discord$w3_unsafe_decode_AvatarHash)),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (avatar0, discriminator0, id0, username0) {
							return {avatar: avatar0, discriminator: discriminator0, id: id0, username: username0};
						}))))));
var $author$project$Evergreen$V419$Discord$w3_unsafe_decode_OptionalData = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_a,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Discord$Included));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Discord$Missing);
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V419$Discord$w3_unsafe_decode_User = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Discord$w3_unsafe_decode_OptionalData($lamdera$codecs$Lamdera$Wire3$decodeBool),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$Discord$w3_unsafe_decode_OptionalData($lamdera$codecs$Lamdera$Wire3$decodeBool),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$Discord$w3_unsafe_decode_OptionalData($lamdera$codecs$Lamdera$Wire3$decodeInt),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_OptionalData($lamdera$codecs$Lamdera$Wire3$decodeInt),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_OptionalData($lamdera$codecs$Lamdera$Wire3$decodeBool),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_OptionalData($lamdera$codecs$Lamdera$Wire3$decodeString),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Discord$w3_unsafe_decode_OptionalData($lamdera$codecs$Lamdera$Wire3$decodeInt),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V419$Discord$w3_unsafe_decode_OptionalData(
											$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString)),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserDiscriminator,
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$author$project$Evergreen$V419$Discord$w3_unsafe_decode_OptionalData($lamdera$codecs$Lamdera$Wire3$decodeBool),
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
														$author$project$Evergreen$V419$Discord$w3_unsafe_decode_ImageHash($author$project$Evergreen$V419$Discord$w3_unsafe_decode_AvatarHash)),
													$lamdera$codecs$Lamdera$Wire3$succeedDecode(
														function (avatar0) {
															return function (bot0) {
																return function (discriminator0) {
																	return function (email0) {
																		return function (flags0) {
																			return function (id0) {
																				return function (locale0) {
																					return function (mfaEnabled0) {
																						return function (premiumType0) {
																							return function (publicFlags0) {
																								return function (system0) {
																									return function (username0) {
																										return function (verified0) {
																											return {avatar: avatar0, bot: bot0, discriminator: discriminator0, email: email0, flags: flags0, id: id0, locale: locale0, mfaEnabled: mfaEnabled0, premiumType: premiumType0, publicFlags: publicFlags0, system: system0, username: username0, verified: verified0};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														}))))))))))))));
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_DiscordUserData_ForAdmin = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_PartialUser,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (icon0, user0) {
										return {icon: icon0, user: user0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$BasicData_ForAdmin));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_User,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$DiscordUserData$w3_unsafe_decode_DiscordUserLoadingData,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_DiscordGatewayStatus,
											$lamdera$codecs$Lamdera$Wire3$succeedDecode(
												F6(
													function (gateway0, icon0, isLoadingData0, linkedAt0, linkedTo0, user0) {
														return {gateway: gateway0, icon: icon0, isLoadingData: isLoadingData0, linkedAt: linkedAt0, linkedTo: linkedTo0, user: user0};
													})))))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$FullData_ForAdmin));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_User,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F4(
											function (icon0, linkedAt0, linkedTo0, user0) {
												return {icon: icon0, linkedAt: linkedAt0, linkedTo: linkedTo0, user: user0};
											})))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$NeedsAuthAgain_ForAdmin));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$DmChannelId$w3_unsafe_decode_DmChannelId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$DmChannelId$DmChannelId)));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_EditedBackendUser = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (createdAt0, deleteAccountAt0, email0, isAdmin0, name0) {
								return {createdAt: createdAt0, deleteAccountAt: deleteAccountAt0, email: email0, isAdmin: isAdmin0, name: name0};
							})))))));
var $author$project$Evergreen$V419$Discord$w3_unsafe_decode_ErrorCode = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(65);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(24);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(44);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(42);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(58);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(45);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(47);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(46);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(48);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(38);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(43);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(41);
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(63);
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(53);
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(61);
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(59);
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(51);
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(57);
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(62);
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(33);
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(27);
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(32);
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(26);
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(29);
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(34);
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(28);
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(31);
			case 28:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(30);
			case 29:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(56);
			case 30:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(60);
			case 31:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(40);
			case 32:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(54);
			case 33:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(49);
			case 34:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(50);
			case 35:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(25);
			case 36:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(55);
			case 37:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(64);
			case 38:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(37);
			case 39:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(35);
			case 40:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 41:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 42:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(16);
			case 43:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(22);
			case 44:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(20);
			case 45:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 46:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(14);
			case 47:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(19);
			case 48:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 49:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 50:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			case 51:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(21);
			case 52:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			case 53:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(8);
			case 54:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(9);
			case 55:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(10);
			case 56:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(23);
			case 57:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(11);
			case 58:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(17);
			case 59:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(18);
			case 60:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(12);
			case 61:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(13);
			case 62:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(15);
			case 63:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(39);
			case 64:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(36);
			case 65:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(52);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Discord$w3_unsafe_decode_RateLimit = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (isGlobal0, retryAfter0) {
					return {isGlobal: isGlobal0, retryAfter: retryAfter0};
				}))));
var $author$project$Evergreen$V419$Discord$w3_unsafe_decode_HttpError = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_ErrorCode,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Discord$BadRequest400));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_ErrorCode,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Discord$Forbidden403));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_ErrorCode,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Discord$GatewayUnavailable502));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Discord$NetworkError);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_ErrorCode,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Discord$NotFound404));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_ErrorCode,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Discord$NotModified304));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_ErrorCode,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (errorCode0, statusCode0) {
										return {errorCode: errorCode0, statusCode: statusCode0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Discord$ServerError5xx));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Discord$Timeout);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_RateLimit,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Discord$TooManyRequests429));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_ErrorCode,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Discord$Unauthorized401));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Discord$UnexpectedError));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Slack$w3_unsafe_decode_HttpError = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Slack$BadBody));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Slack$BadStatus)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Slack$BadUrl));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Slack$NetworkError);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Slack$RateLimited);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Slack$SlackError));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Slack$Timeout);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Discord$MessageId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Discord$w3_unsafe_decode_MessageId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Postmark$w3_unsafe_decode_PostmarkSendResponse = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V419$EmailAddress$w3_unsafe_decode_EmailAddress),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (errorCode0, message0, to0) {
						return {errorCode: errorCode0, message: message0, to: to0};
					})))));
var $author$project$Evergreen$V419$Postmark$w3_unsafe_decode_SendEmailError = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Postmark$BadUrl));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Postmark$NetworkError);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Postmark$w3_unsafe_decode_PostmarkSendResponse,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Postmark$PostmarkError));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Postmark$Timeout);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeString,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (body0, statusCode0) {
										return {body: body0, statusCode: statusCode0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Postmark$UnknownError));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMaybeMessage = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Id$NoThreadWithMaybeMessage));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Id$ViewThreadWithMaybeMessage)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Log$w3_unsafe_decode_Log = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$ChangedUsers));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$DeletedLog);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$EmptyDiscordMessage));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_MessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$FailedToAddReactionToDiscordDmMessage))))));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_MessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$FailedToAddReactionToDiscordGuildMessage)))))));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Slack$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_SlackGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$FailedToChangeSlackReaction)));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_MessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$FailedToDeleteDiscordDmMessage)))));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_MessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$FailedToDeleteDiscordGuildMessage))))));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$FailedToDeleteOrphanedFiles));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Slack$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_SlackGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$FailedToDeleteSlackMessage)));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_MessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$FailedToEditDiscordDmMessage)))));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_MessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$FailedToEditDiscordGuildMessage))))));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Slack$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_SlackGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$FailedToEditSlackMessage)));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$FailedToGenerateScheduledBackup)));
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$FailedToGetDataForJoinedOrCreatedDiscordGuild))));
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$FailedToGetDiscordUserAvatars));
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$lamdera$codecs$Lamdera$Wire3$decodePair$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_CustomEmojiId),
								$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$FailedToLoadDiscordGuildCustomEmojis)));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$lamdera$codecs$Lamdera$Wire3$decodePair$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_StickerId),
								$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$FailedToLoadDiscordGuildStickers)));
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$FailedToLoadDiscordStandardStickerPacks));
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$FailedToLoadDiscordUserData)));
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Slack$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$FailedToLoadSlackConversations)));
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$lamdera$codecs$Lamdera$Wire3$decodePair$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_CustomEmojiId),
								$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$FailedToLoadSlackCustomEmojis))));
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$FailedToParseDiscordWebsocket)));
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$FailedToRegenerateServerSecret));
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$FailedToReloadDiscordGuild)));
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_MessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$FailedToRemoveReactionToDiscordDmMessage))))));
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_MessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$FailedToRemoveReactionToDiscordGuildMessage)))))));
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$FailedToSendDiscordDmMessage))));
			case 28:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMaybeMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$FailedToSendDiscordGuildMessage))))));
			case 29:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$EmailAddress$w3_unsafe_decode_EmailAddress,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Postmark$w3_unsafe_decode_SendEmailError,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$FailedToSendNotificationEmail)));
			case 30:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Slack$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_SlackGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$FailedToSendSlackMessage)));
			case 31:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$JoinedDiscordThreadFailed)));
			case 32:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$EmailAddress$w3_unsafe_decode_EmailAddress,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeResult$($author$project$Evergreen$V419$Postmark$w3_unsafe_decode_SendEmailError, $lamdera$codecs$Lamdera$Wire3$decodeUnit),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$LoginEmail)));
			case 33:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$LoginsRateLimited));
			case 34:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$PushNotificationError)));
			case 35:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$ReceivedTypeThatIsAlwaysInvalid);
			case 36:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$EmailAddress$w3_unsafe_decode_EmailAddress,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Postmark$w3_unsafe_decode_SendEmailError,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Log$SendLogErrorEmailFailed)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_LogWithTime = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Log$w3_unsafe_decode_Log,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (log0, time0) {
					return {log: log0, time: time0};
				}))));
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_PrivateVapidKey = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Discord$w3_unsafe_decode_RoleColors = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (primaryColor0, secondaryColor0, tertiaryColor0) {
						return {primaryColor: primaryColor0, secondaryColor: secondaryColor0, tertiaryColor: tertiaryColor0};
					})))));
var $author$project$Evergreen$V419$Discord$RoleIconHash = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Discord$w3_unsafe_decode_RoleIconHash = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Discord$IntegrationId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Discord$w3_unsafe_decode_IntegrationId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Discord$SubscriptionListingId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Discord$w3_unsafe_decode_SubscriptionListingId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Discord$w3_unsafe_decode_RoleTags = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Discord$w3_unsafe_decode_OptionalData(
		$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_SubscriptionListingId)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$Discord$w3_unsafe_decode_OptionalData(
				$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_IntegrationId)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeBool,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_OptionalData(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F6(
								function (availableForPurchase0, botId0, guildConnections0, integrationId0, premiumSubscriber0, subscriptionListingId0) {
									return {availableForPurchase: availableForPurchase0, botId: botId0, guildConnections: guildConnections0, integrationId: integrationId0, premiumSubscriber: premiumSubscriber0, subscriptionListingId: subscriptionListingId0};
								}))))))));
var $author$project$Evergreen$V419$Discord$w3_unsafe_decode_Role = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Discord$w3_unsafe_decode_OptionalData($author$project$Evergreen$V419$Discord$w3_unsafe_decode_RoleTags),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Permissions,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeBool,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_RoleId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
										$author$project$Evergreen$V419$Discord$w3_unsafe_decode_ImageHash($author$project$Evergreen$V419$Discord$w3_unsafe_decode_RoleIconHash)),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeBool,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Evergreen$V419$Discord$w3_unsafe_decode_OptionalData($lamdera$codecs$Lamdera$Wire3$decodeInt),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$author$project$Evergreen$V419$Discord$w3_unsafe_decode_OptionalData($author$project$Evergreen$V419$Discord$w3_unsafe_decode_RoleColors),
													$lamdera$codecs$Lamdera$Wire3$succeedDecode(
														function (colors0) {
															return function (description0) {
																return function (flags0) {
																	return function (hoist0) {
																		return function (icon0) {
																			return function (id0) {
																				return function (managed0) {
																					return function (mentionable0) {
																						return function (name0) {
																							return function (permissions0) {
																								return function (position0) {
																									return function (tags0) {
																										return function (unicodeEmoji0) {
																											return {colors: colors0, description: description0, flags: flags0, hoist: hoist0, icon: icon0, id: id0, managed: managed0, mentionable: mentionable0, name: name0, permissions: permissions0, position: position0, tags: tags0, unicodeEmoji: unicodeEmoji0};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														}))))))))))))));
var $author$project$Evergreen$V419$SessionIdHash$w3_unsafe_decode_SessionIdHash = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$ToBackendLog$w3_unsafe_decode_ToBackendLog = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(15);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(10);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(17);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(9);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(16);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(18);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(8);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(12);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(13);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(95);
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(73);
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(38);
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(20);
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(35);
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(63);
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(88);
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(59);
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(46);
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(89);
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(93);
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(29);
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(31);
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(34);
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(45);
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(92);
			case 28:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(50);
			case 29:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(53);
			case 30:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(42);
			case 31:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(41);
			case 32:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(22);
			case 33:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(76);
			case 34:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(28);
			case 35:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(30);
			case 36:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(91);
			case 37:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(57);
			case 38:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(75);
			case 39:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(19);
			case 40:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(32);
			case 41:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(68);
			case 42:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(69);
			case 43:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(48);
			case 44:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(49);
			case 45:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(43);
			case 46:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(37);
			case 47:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(27);
			case 48:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(36);
			case 49:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(33);
			case 50:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(64);
			case 51:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(39);
			case 52:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(87);
			case 53:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(62);
			case 54:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(40);
			case 55:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(97);
			case 56:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(96);
			case 57:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(21);
			case 58:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(55);
			case 59:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(70);
			case 60:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(94);
			case 61:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(60);
			case 62:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(61);
			case 63:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(71);
			case 64:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(54);
			case 65:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(44);
			case 66:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(77);
			case 67:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(79);
			case 68:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(82);
			case 69:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(80);
			case 70:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(81);
			case 71:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(85);
			case 72:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(86);
			case 73:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(84);
			case 74:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(78);
			case 75:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(47);
			case 76:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(56);
			case 77:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(90);
			case 78:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(58);
			case 79:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(83);
			case 80:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(72);
			case 81:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(51);
			case 82:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(52);
			case 83:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(26);
			case 84:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(24);
			case 85:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(23);
			case 86:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(25);
			case 87:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(67);
			case 88:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(65);
			case 89:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(66);
			case 90:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(74);
			case 91:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			case 92:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 93:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 94:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 95:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(14);
			case 96:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(11);
			case 97:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$ToBackendLog$w3_unsafe_decode_ToBackendLogData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$ToBackendLog$w3_unsafe_decode_ToBackendLog,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (endTime0, startTime0, toBackendLog0, userId0) {
							return {endTime: endTime0, startTime: startTime0, toBackendLog: toBackendLog0, userId: userId0};
						}))))));
var $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$UserSession$EmptyPlaceholder);
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_a,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$UserSession$FilledInByBackend));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V419$IdArray$w3_unsafe_decode_IdArray$ = function (w3_x_c_k, w3_x_c_v) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeArray(w3_x_c_v),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V419$IdArray$w3_unsafe_decode_IdArray = F2($author$project$Evergreen$V419$IdArray$w3_unsafe_decode_IdArray$);
var $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_LastViewedGuild = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$UserSession$LastViewedDiscordGuild));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$UserSession$LastViewedGuild));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$UserSession$LastViewedSlackWorkspace));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_NotificationMode = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Ports$w3_unsafe_decode_SubscribeKeys = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (auth0, p256dh0) {
					return {auth: auth0, p256dh: p256dh0};
				}))));
var $author$project$Evergreen$V419$Ports$w3_unsafe_decode_SubscribeData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Ports$w3_unsafe_decode_SubscribeKeys,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
			A2(
				$lamdera$codecs$Lamdera$Wire3$andThenDecode,
				function (t) {
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
						$elm$time$Time$millisToPosix(t));
				},
				$lamdera$codecs$Lamdera$Wire3$decodeInt)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$elm$url$Url$w3_unsafe_decode_Url,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (endpoint0, expirationTime0, keys0) {
						return {endpoint: endpoint0, expirationTime: expirationTime0, keys: keys0};
					})))));
var $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_PushSubscription = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$UserSession$NotSubscribed);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Ports$w3_unsafe_decode_SubscribeData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$UserSession$Subscribed)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Ports$w3_unsafe_decode_SubscribeData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$UserSession$SubscriptionError)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$UserSession$SubscriptionJsException)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_SheepGameQuestion = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
			$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileStatus),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (attachedFiles0, text0) {
					return {attachedFiles: attachedFiles0, text: text0};
				}))));
var $author$project$Evergreen$V419$UserAgent$w3_unsafe_decode_Browser = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$UserAgent$w3_unsafe_decode_Device = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(10);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(8);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(9);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$UserAgent$w3_unsafe_decode_UserAgent = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$UserAgent$w3_unsafe_decode_Device,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$UserAgent$w3_unsafe_decode_Browser,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (browser0, device0) {
					return {browser: browser0, device: device0};
				}))));
var $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_UserOptionSection = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(8);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_UserSession = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$UserAgent$w3_unsafe_decode_UserAgent,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$SessionIdHash$w3_unsafe_decode_SessionIdHash,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$IdArray$w3_unsafe_decode_IdArray$($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId, $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_SheepGameQuestion),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_PushSubscription,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_NotificationMode,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$UserSession$w3_unsafe_decode_LastViewedGuild),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$containers$SeqSet$decodeSet($author$project$Evergreen$V419$UserSession$w3_unsafe_decode_UserOptionSection),
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											function (expandedUserOptions0) {
												return function (lastClientDisconnect0) {
													return function (lastViewedGuild0) {
														return function (notificationMode0) {
															return function (pushSubscription0) {
																return function (savedSheepGameQuestions0) {
																	return function (sessionIdHash0) {
																		return function (signedInAt0) {
																			return function (userAgent0) {
																				return function (userId0) {
																					return {expandedUserOptions: expandedUserOptions0, lastClientDisconnect: lastClientDisconnect0, lastViewedGuild: lastViewedGuild0, notificationMode: notificationMode0, pushSubscription: pushSubscription0, savedSheepGameQuestions: savedSheepGameQuestions0, sessionIdHash: sessionIdHash0, signedInAt: signedInAt0, userAgent: userAgent0, userId: userId0};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											})))))))))));
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_WebsocketClosedEvent = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$WebsocketClosed_CloseAndReopenForUser)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$WebsocketClosed_ClosedByBackendForUser)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Websocket$w3_unsafe_decode_CloseEventCode,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$WebsocketClosed_ListenCloseEvent)))));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$WebsocketClosed_UnlinkDiscordUser)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_AdminChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_EditedBackendUser),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqSet$decodeSet(
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId)),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$containers$SeqDict$decodeDict$(
										$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
										$author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_EditedBackendUser),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F4(
											function (changedUsers0, deletedUsers0, newUsers0, time0) {
												return {changedUsers: changedUsers0, deletedUsers: deletedUsers0, newUsers: newUsers0, time: time0};
											})))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$ChangeUsers));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$DeleteDiscordDmChannel));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$DeleteDiscordGuild));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$DeleteGuild));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$codecs$Lamdera$Wire3$decodeResult$(
							$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
							$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$DeleteOrphanedFiles));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$SessionIdHash$w3_unsafe_decode_SessionIdHash,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$DeleteSession));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_DmChannelId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$DeleteSlackDmChannel));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$DeleteSlackWorkspace));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$SessionIdHash$w3_unsafe_decode_SessionIdHash,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$DisconnectClient)));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V419$BackendMsgLog$w3_unsafe_decode_BackendMsgLogData)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$LoadBackendMsgLogs));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
							$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminData_DeletedGuild)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$LoadDeletedGuilds));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
							$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminData_DiscordDmChannel)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$LoadDiscordDmChannels));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
							$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminData_DiscordGuild)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$LoadDiscordGuilds));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
							$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_DiscordUserData_ForAdmin)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$LoadDiscordUsers));
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V419$DmChannelId$w3_unsafe_decode_DmChannelId, $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminData_DmChannel)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$LoadDmChannels));
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
							$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminData_Guild)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$LoadGuilds));
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash, $author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_BackendFileData)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$LoadOrphanedFiles));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V419$SessionIdHash$w3_unsafe_decode_SessionIdHash, $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_UserSession)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$LoadSessions));
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_DmChannelId),
							$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminData_SlackDmChannel)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$LoadSlackDmChannels));
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
							$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminData_SlackWorkspace)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$LoadSlackWorkspaces));
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V419$ToBackendLog$w3_unsafe_decode_ToBackendLogData)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$LoadToBackendLogs));
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$author$project$Evergreen$V419$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
							$author$project$Evergreen$V419$User$w3_unsafe_decode_BackendUser)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$LoadUsers));
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V419$LocalState$w3_unsafe_decode_WebsocketClosedEvent)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$LoadWebsocketCloseEvents));
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V419$LocalState$w3_unsafe_decode_LogWithTime)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Pagination$w3_unsafe_decode_PageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$LogPageChanged)));
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Http$w3_unsafe_decode_Error, $lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$RegenerateServerSecret));
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$codecs$Lamdera$Wire3$decodeResult$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_HttpError,
							$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V419$Discord$w3_unsafe_decode_Role))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$ReloadDiscordGuild))));
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$RestoreGuild));
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$SetDiscordLinkLimit));
			case 28:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$SetDiscordLinkingEnabled));
			case 29:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$SetEmailNotificationsEnabled));
			case 30:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$SetNotifyAdminsBotUserId));
			case 31:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$SetNotifyAdminsToken));
			case 32:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$SetOpenRouterKey));
			case 33:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Postmark$w3_unsafe_decode_ApiKey,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$SetPostmarkKey));
			case 34:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_PrivateVapidKey,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$SetPrivateVapidKey));
			case 35:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$SetPublicVapidKey));
			case 36:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$SetSignupsEnabled));
			case 37:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$SetSlackLinkLimit));
			case 38:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$SetSlackLinkingEnabled));
			case 39:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$StartReloadingDiscordDmChannel))));
			case 40:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$StartReloadingDiscordGuildChannel)))));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Drawing$w3_unsafe_decode_MessageAnchor = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Drawing$CardAnchor);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Drawing$EmbedImageAnchor));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Drawing$ImageAttachmentAnchor));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Drawing$TimestampAnchor);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Drawing$UserIconAnchor);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Drawing$w3_unsafe_decode_AnchorType = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$justinmimbs$date$Date$w3_unsafe_decode_Date,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Drawing$DateDividerAnchor)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Drawing$w3_unsafe_decode_MessageAnchor,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Drawing$MessageAnchor)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_ChannelDataToDecrypt = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
		$author$project$Evergreen$V419$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId),
			$author$project$Evergreen$V419$Encryption$w3_unsafe_decode_EncryptedData(
				$author$project$Evergreen$V419$Message$w3_unsafe_decode_MessageContent$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId))))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
			$author$project$Evergreen$V419$Encryption$w3_unsafe_decode_EncryptedData(
				$author$project$Evergreen$V419$Message$w3_unsafe_decode_MessageContent$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId)))),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (channel0, threads0) {
					return {channel: channel0, threads: threads0};
				}))));
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_ChannelDataToEncrypt = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId),
			$author$project$Evergreen$V419$Message$w3_unsafe_decode_MessageContent$(
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId)))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
			$author$project$Evergreen$V419$Message$w3_unsafe_decode_MessageContent$(
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId))),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (channel0, threads0) {
					return {channel: channel0, threads: threads0};
				}))));
var $author$project$Evergreen$V419$ChannelDescription$w3_unsafe_decode_ChannelDescription = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Go$w3_unsafe_decode_Action = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$AcceptTerritory);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$FinishedMarking);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$Joined));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$MarkTerritory)));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$PassTurn);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$PlaceStone)));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$RejectTerritory);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Go$w3_unsafe_decode_ActionWithTime = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Go$w3_unsafe_decode_Action,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (change0, time0) {
					return {change: change0, time: time0};
				}))));
var $author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_Reactions = $lamdera$containers$SeqDict$decodeDict$(
	$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
	$author$project$Evergreen$V419$NonemptySet$w3_unsafe_decode_NonemptySet(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId)));
var $author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_ValidatedInput = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
		$author$project$Evergreen$V419$RichText$w3_unsafe_decode_RichText$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_Reactions,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
				$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileData),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (attachedFiles0, reactions0, text0) {
						return {attachedFiles: attachedFiles0, reactions: reactions0, text: text0};
					})))));
var $author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_Action = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_ReactionTarget,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$AddedReaction)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$ChangedGroup))));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_ValidatedInput),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$ChangedNotes)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$ChangedQuestionsRevealed));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$FinishedGrouping);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$LockedAnswers);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_ReactionTarget,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$RemovedReaction)));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_ValidatedInput),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$SubmittedAnswer)));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$UnlockedAnswers);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_ActionWithTime = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_Action,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (change0, time0, userId0) {
						return {change: change0, time: time0, userId: userId0};
					})))));
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_IsValid = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$IsNotValid);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeSet($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$IsValid));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_Letter = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeChar,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_Letter,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$Letter));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$Wildcard);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_PlacedWord = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty($author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeBool,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (isVertical0, letters0, start0) {
						return {isVertical: isVertical0, letters: letters0, start: start0};
					})))));
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_Action = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_ReactionTarget,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$AddedReaction)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$CancelPremove);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$JoinGame);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend($author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_IsValid),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_PlacedWord,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$PlaceWord)));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend($author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_IsValid),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_PlacedWord,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$Premove)));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_ReactionTarget,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$RemovedReaction)));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$ReplaceTrayOrPass);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_ActionWithTime = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_Action,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (change0, time0, userId0) {
						return {change: change0, time: time0, userId: userId0};
					})))));
var $author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_Phase = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_Shared = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_Phase,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_ValidatedInput)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId)),
					$lamdera$codecs$Lamdera$Wire3$decodeString),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
						$author$project$Evergreen$V419$IdArray$w3_unsafe_decode_IdArray$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId,
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_ValidatedInput))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (answers0, groups0, notes0, phase0, questionsRevealed0) {
								return {answers: answers0, groups: groups0, notes: notes0, phase: phase0, questionsRevealed: questionsRevealed0};
							})))))));
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_AnimatedPlacement = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend($author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_IsValid),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList(
				$lamdera$codecs$Lamdera$Wire3$decodePair$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
					$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard)),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (cells0, isValid0, startTime0) {
						return {cells: cells0, isValid: isValid0, startTime: startTime0};
					})))));
var $author$project$Evergreen$V419$WordSpellingGame$LetterId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_LetterId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_PlacementResult = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeList(
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F2(
						function (letters0, placedCount0) {
							return {letters: letters0, placedCount: placedCount0};
						}))))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList(
				$lamdera$codecs$Lamdera$Wire3$decodePair$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
					$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard)),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (placedCells0, score0, words0) {
						return {placedCells: placedCells0, score: score0, words: words0};
					})))));
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_Player = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$IdArray$w3_unsafe_decode_IdArray$($author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_LetterId, $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
					$lamdera$codecs$Lamdera$Wire3$decodeTriple$($author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_PlacedWord, $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_PlacementResult, $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_IsValid)),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (premove0, score0, tray0, userId0) {
							return {premove: premove0, score: score0, tray: tray0, userId: userId0};
						}))))));
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_Reactions = $lamdera$containers$SeqDict$decodeDict$(
	$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
	$author$project$Evergreen$V419$NonemptySet$w3_unsafe_decode_NonemptySet(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId)));
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_Shared = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_ReactionTarget, $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_Reactions),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty($author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_Player),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_AnimatedPlacement),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
							$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$OneOrGreater$w3_unsafe_decode_OneOrGreater,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F7(
									function (attemptsLeft0, board0, lastPlacement0, passingStartedAt0, players0, reactions0, turnCount0) {
										return {attemptsLeft: attemptsLeft0, board: board0, lastPlacement: lastPlacement0, passingStartedAt: passingStartedAt0, players: players0, reactions: reactions0, turnCount: turnCount0};
									})))))))));
var $author$project$Evergreen$V419$Go$w3_unsafe_decode_BoardSize = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Go$w3_unsafe_decode_KomiHalfPoints = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Go$w3_unsafe_decode_Stone = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Go$w3_unsafe_decode_TimeControl = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (increment0, mainTime0) {
					return {increment: increment0, mainTime: mainTime0};
				}))));
var $author$project$Evergreen$V419$Go$w3_unsafe_decode_ValidatedSetup = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Go$w3_unsafe_decode_BoardSize,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Go$w3_unsafe_decode_TimeControl),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$Go$w3_unsafe_decode_KomiHalfPoints,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$Go$w3_unsafe_decode_BoardSize,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Go$w3_unsafe_decode_Stone,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F7(
									function (createdBy0, gameCreatorPlayingAs0, handicap0, height0, komiHalfPoints0, timeControl0, width0) {
										return {createdBy: createdBy0, gameCreatorPlayingAs: gameCreatorPlayingAs0, handicap: handicap0, height: height0, komiHalfPoints: komiHalfPoints0, timeControl: timeControl0, width: width0};
									})))))))));
var $author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_ValidatedSetup = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty($author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_ValidatedInput),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (createdBy0, questions0) {
					return {createdBy: createdBy0, questions: questions0};
				}))));
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_Language = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_ValidatedSetup = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$OneOrGreater$w3_unsafe_decode_OneOrGreater,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Go$w3_unsafe_decode_TimeControl,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$OneOrGreater$w3_unsafe_decode_OneOrGreater,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
						$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$OneOrGreater$w3_unsafe_decode_OneOrGreater,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F2(
										function (count0, value0) {
											return {count: count0, value: value0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_Language,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F8(
										function (createdBy0, fullTrayBonus0, language0, letters0, placeWordAttempts0, seed0, timeControls0, traySize0) {
											return {createdBy: createdBy0, fullTrayBonus: fullTrayBonus0, language: language0, letters: letters0, placeWordAttempts: placeWordAttempts0, seed: seed0, timeControls: timeControls0, traySize: traySize0};
										}))))))))));
var $author$project$Evergreen$V419$Game$w3_unsafe_decode_BackendGameData = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V419$Go$w3_unsafe_decode_ActionWithTime),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Go$w3_unsafe_decode_ValidatedSetup,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$GameData_Go)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_Shared,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_ActionWithTime),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_ValidatedSetup,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$GameData_SheepGame))));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_Shared,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_ActionWithTime),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_ValidatedSetup,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$GameData_WordSpellingGame))));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Id$GoMatchPublicId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Id$w3_unsafe_decode_GamePublicId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$SecretId$w3_unsafe_decode_SecretId = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V419$Game$w3_unsafe_decode_LoadedMatch = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
		$author$project$Evergreen$V419$SecretId$w3_unsafe_decode_SecretId($author$project$Evergreen$V419$Id$w3_unsafe_decode_GamePublicId)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Game$w3_unsafe_decode_BackendGameData,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (gameData0, publicLink0) {
					return {gameData: gameData0, publicLink: publicLink0};
				}))));
var $author$project$Evergreen$V419$DmChannel$w3_unsafe_decode_LoadedMessages = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
		$author$project$Evergreen$V419$Game$w3_unsafe_decode_LoadedMatch),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
			$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId,
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId))),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (messages0, repliedToMatches0) {
					return {messages: messages0, repliedToMatches: repliedToMatches0};
				}))));
var $author$project$Evergreen$V419$Call$w3_unsafe_decode_RemoteCallData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeBool,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (audioInputEnabled0, screenShareEnabled0, videoInputEnabled0) {
						return {audioInputEnabled: audioInputEnabled0, screenShareEnabled: screenShareEnabled0, videoInputEnabled: videoInputEnabled0};
					})))));
var $author$project$Evergreen$V419$Call$w3_unsafe_decode_LocalChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$Local_AnswerRecording));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$Local_CancelRecording);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$Local_Leave));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$Local_RequestRecording);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Call$w3_unsafe_decode_RemoteCallData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$Local_SetRemoteCallData));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Drawing$w3_unsafe_decode_LocalChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V419$SafeFloat$w3_unsafe_decode_SafeFloat, $author$project$Evergreen$V419$SafeFloat$w3_unsafe_decode_SafeFloat)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Drawing$ContinueStroke));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V419$SafeFloat$w3_unsafe_decode_SafeFloat, $author$project$Evergreen$V419$SafeFloat$w3_unsafe_decode_SafeFloat)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Drawing$EndStroke));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Drawing$RedoStroke);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V419$SafeFloat$w3_unsafe_decode_SafeFloat, $author$project$Evergreen$V419$SafeFloat$w3_unsafe_decode_SafeFloat),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Drawing$StartStroke));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Drawing$UndoStroke);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Go$w3_unsafe_decode_LocalChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Go$w3_unsafe_decode_ActionWithTime,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$Action));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Go$w3_unsafe_decode_ValidatedSetup,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$StartMatch)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_LocalChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_ActionWithTime,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$Action));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_ValidatedSetup,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$StartMatch)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_LocalChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_ActionWithTime,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$Action));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_ValidatedSetup,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$StartMatch)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Game$w3_unsafe_decode_LocalChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$author$project$Evergreen$V419$SecretId$w3_unsafe_decode_SecretId($author$project$Evergreen$V419$Id$w3_unsafe_decode_GamePublicId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$CreatePublicLink)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend($author$project$Evergreen$V419$Game$w3_unsafe_decode_LoadedMatch),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$LoadMatch)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Go$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$LocalChange_Go)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$LocalChange_SheepGame)));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$LocalChange_WordSpellingGame)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$TextEditor$w3_unsafe_decode_EditChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Range$w3_unsafe_decode_Range,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$TextEditor$Edit_TypedText)));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$TextEditor$w3_unsafe_decode_LocalChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$TextEditor$w3_unsafe_decode_EditChange,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$TextEditor$Local_EditChange));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$TextEditor$Local_Redo);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$TextEditor$Local_Reset);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$TextEditor$Local_Undo);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$User$w3_unsafe_decode_NotificationLevel = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$VisibleMessages$w3_unsafe_decode_PageRequest = function (w3_x_c_messageId) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id(w3_x_c_messageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$VisibleMessages$PageBefore));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id(w3_x_c_messageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$VisibleMessages$PageFrom));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V419$Ports$w3_unsafe_decode_RegisterPushSubscription = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Ports$w3_unsafe_decode_SubscribeData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Ports$GotSubscribeData));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Ports$SubscribeJsException));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_DiscordFrontendUser = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$PersonName$w3_unsafe_decode_PersonName,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$UserColor$w3_unsafe_decode_UserColor,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (color0, icon0, name0) {
						return {color: color0, icon: icon0, name: name0};
					})))));
var $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_UnreadOverviewData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$lamdera$codecs$Lamdera$Wire3$decodeTriple$(
			$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
			$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId),
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId)),
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId),
			$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId,
				$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
				$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId)))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$lamdera$codecs$Lamdera$Wire3$decodePair$(
				$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_DmChannelId),
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId)),
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId),
				$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId,
					$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
					$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId)))),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_DmChannelId),
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
					$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId,
						$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
						$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId)))),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
						$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId)),
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId,
							$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
							$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId)))),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$lamdera$codecs$Lamdera$Wire3$decodeTriple$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId),
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId)),
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId),
							$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId,
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$lamdera$codecs$Lamdera$Wire3$decodePair$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId)),
							$lamdera$containers$SeqDict$decodeDict$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
								$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId,
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId)))),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqDict$decodeDict$(
								$lamdera$codecs$Lamdera$Wire3$decodePair$(
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId)),
								$lamdera$containers$SeqDict$decodeDict$(
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId),
									$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
										$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId,
										$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
										$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId)))),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqDict$decodeDict$(
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
									$lamdera$containers$SeqDict$decodeDict$(
										$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
										$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
											$author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId,
											$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
											$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId)))),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$containers$SeqDict$decodeDict$(
										$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
										$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_DiscordFrontendUser),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$containers$SeqDict$decodeDict$(
											$lamdera$codecs$Lamdera$Wire3$decodeTriple$(
												$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
												$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
												$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId)),
											$lamdera$containers$SeqDict$decodeDict$(
												$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId),
												$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
													$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId,
													$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
													$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId)))),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$containers$SeqDict$decodeDict$(
												$lamdera$codecs$Lamdera$Wire3$decodePair$(
													$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
													$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId)),
												$lamdera$containers$SeqDict$decodeDict$(
													$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
													$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
														$author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId,
														$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
														$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId)))),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$containers$SeqDict$decodeDict$(
													$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
													$lamdera$containers$SeqDict$decodeDict$(
														$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
														$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
															$author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId,
															$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
															$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId)))),
												$lamdera$codecs$Lamdera$Wire3$succeedDecode(
													function (discordDmChannels0) {
														return function (discordGuildChannels0) {
															return function (discordGuildThreads0) {
																return function (discordUsers0) {
																	return function (dmChannels0) {
																		return function (dmThreads0) {
																			return function (guildChannels0) {
																				return function (guildThreads0) {
																					return function (slackChannels0) {
																						return function (slackDmChannels0) {
																							return function (slackDmThreads0) {
																								return function (slackThreads0) {
																									return {discordDmChannels: discordDmChannels0, discordGuildChannels: discordGuildChannels0, discordGuildThreads: discordGuildThreads0, discordUsers: discordUsers0, dmChannels: dmChannels0, dmThreads: dmThreads0, guildChannels: guildChannels0, guildThreads: guildThreads0, slackChannels: slackChannels0, slackDmChannels: slackDmChannels0, slackDmThreads: slackDmThreads0, slackThreads: slackThreads0};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													})))))))))))));
var $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ViewDiscordGuildData = function (w3_x_c_messageId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
			$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_DiscordFrontendUser),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id(w3_x_c_messageId),
				$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
					w3_x_c_messageId,
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId))),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F2(
					function (messages0, newUsers0) {
						return {messages: messages0, newUsers: newUsers0};
					}))));
};
var $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ChannelHeaderTab = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$UserSession$ChannelHeaderTab_ChannelDescription);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$UserSession$ChannelHeaderTab_Draw);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Message$w3_unsafe_decode_RepliedToGame),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$UserSession$ChannelHeaderTab_Games)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$UserSession$ChannelHeaderTab_VoiceChat);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage = function (w3_x_c_messageId) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$UserSession$DontCare);
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id(w3_x_c_messageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$UserSession$PreviouslyLastViewedMessage));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_ChannelData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_ChannelId,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ChannelHeaderTab),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (channelHeaderTab0, id0, previouslyLastViewedMessage0) {
						return {channelHeaderTab: channelHeaderTab0, id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0};
					})))));
var $author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_ChannelThreadId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (channelId0, guildId0, threadId0) {
						return {channelId: channelId0, guildId: guildId0, threadId: threadId0};
					})))));
var $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_ChannelThreadData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_ChannelThreadId,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, previouslyLastViewedMessage0) {
					return {id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0};
				}))));
var $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_DiscordChannelData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DiscordChannelId,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, previouslyLastViewedMessage0) {
					return {id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0};
				}))));
var $author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DiscordChannelThreadId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (channelId0, currentUserId0, guildId0, threadId0) {
							return {channelId: channelId0, currentUserId: currentUserId0, guildId: guildId0, threadId: threadId0};
						}))))));
var $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_DiscordChannelThreadData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DiscordChannelThreadId,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, previouslyLastViewedMessage0) {
					return {id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0};
				}))));
var $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_DiscordDmData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DiscordDmId,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, previouslyLastViewedMessage0) {
					return {id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0};
				}))));
var $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_DmData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DmId,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ChannelHeaderTab),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (channelHeaderTab0, id0, previouslyLastViewedMessage0) {
						return {channelHeaderTab: channelHeaderTab0, id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0};
					})))));
var $author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DmThreadId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (otherUserId0, threadId0) {
					return {otherUserId: otherUserId0, threadId: threadId0};
				}))));
var $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_DmThreadData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DmThreadId,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, previouslyLastViewedMessage0) {
					return {id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0};
				}))));
var $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_SlackChannelData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_SlackChannelId,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, previouslyLastViewedMessage0) {
					return {id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0};
				}))));
var $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_SlackChannelThreadData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_SlackChannelId,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (id0, previouslyLastViewedMessage0, threadId0) {
						return {id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0, threadId: threadId0};
					})))));
var $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_SlackDmData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_SlackDmId,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, previouslyLastViewedMessage0) {
					return {id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0};
				}))));
var $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_SlackDmThreadData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_SlackDmId,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (id0, previouslyLastViewedMessage0, threadId0) {
						return {id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0, threadId: threadId0};
					})))));
var $author$project$Evergreen$V419$SetViewing$w3_unsafe_decode_SetViewing = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SetViewing$StopViewingChannel);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend($author$project$Evergreen$V419$DmChannel$w3_unsafe_decode_LoadedMessages),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_ChannelData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SetViewing$ViewChannel)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId),
							$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId,
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_ChannelThreadData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SetViewing$ViewChannelThread)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ViewDiscordGuildData($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_DiscordChannelData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SetViewing$ViewDiscordChannel)));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ViewDiscordGuildData($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_DiscordChannelThreadData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SetViewing$ViewDiscordChannelThread)));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
							$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId,
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_DiscordDmData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SetViewing$ViewDiscordDm)));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend($author$project$Evergreen$V419$DmChannel$w3_unsafe_decode_LoadedMessages),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_DmData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SetViewing$ViewDm)));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId),
							$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId,
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_DmThreadData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SetViewing$ViewDmThread)));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend($author$project$Evergreen$V419$UserSession$w3_unsafe_decode_UnreadOverviewData),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SetViewing$ViewOverview));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
							$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId,
								$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_SlackChannelData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SetViewing$ViewSlackChannel)));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId),
							$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId,
								$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_SlackChannelThreadData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SetViewing$ViewSlackChannelThread)));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
							$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId,
								$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_SlackDmData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SetViewing$ViewSlackDm)));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId),
							$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId,
								$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_SlackDmThreadData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SetViewing$ViewSlackDmThread)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_LocalChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DmId, $author$project$Evergreen$V419$Types$w3_unsafe_decode_ChannelDataToEncrypt)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_AcceptE2ee))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$NonemptySet$w3_unsafe_decode_NonemptySet(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_CustomEmojiId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_AddCustomEmojisToUser));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_AddReactionEmoji))));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_AdminChange,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_Admin));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_BanMember)));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_CancelAccountDeletion);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_UserOptionSection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_CollapseUserOptionSection));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$SetViewing$w3_unsafe_decode_SetViewing,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeBool,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								function (markMessagesAsViewed0) {
									return {markMessagesAsViewed: markMessagesAsViewed0};
								})),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_CurrentlyViewing)));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_DeclineE2eeRequest));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_DeclineE2eeRequestAsInitiator));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList(
						$lamdera$codecs$Lamdera$Wire3$decodePair$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
							$author$project$Evergreen$V419$Message$w3_unsafe_decode_MessageContent$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_DecryptOldMessages))));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_DeleteChannel)));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_DeleteGuild));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$SecretId$w3_unsafe_decode_SecretId($author$project$Evergreen$V419$Id$w3_unsafe_decode_InviteLinkId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_DeleteInviteLink)));
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_DeleteMessage)));
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend($author$project$Evergreen$V419$Types$w3_unsafe_decode_ChannelDataToDecrypt),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_DisableE2ee)));
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
							$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId,
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$VisibleMessages$w3_unsafe_decode_PageRequest($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_DiscordGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_Discord_LoadChannelMessages))));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId),
							$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId,
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$VisibleMessages$w3_unsafe_decode_PageRequest($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_DiscordGuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_Discord_LoadThreadMessages)))));
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DiscordDmId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Zone,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_Discord_SendEditDmMessage))))));
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Zone,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
											$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_Discord_SendEditGuildMessage))))))));
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
						$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileData),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMaybeMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_DiscordGuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Zone,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_Discord_SendMessage)))))));
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Drawing$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Drawing$w3_unsafe_decode_AnchorType,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_Drawing))));
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$ChannelDescription$w3_unsafe_decode_ChannelDescription,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$ChannelName$w3_unsafe_decode_ChannelName,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_EditChannel)))));
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$GuildName$w3_unsafe_decode_GuildName,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_EditGuildName)));
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList(
						$lamdera$codecs$Lamdera$Wire3$decodeTriple$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
							$lamdera$containers$SeqSet$decodeSet($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash),
							$author$project$Evergreen$V419$Encryption$w3_unsafe_decode_EncryptedData(
								$author$project$Evergreen$V419$Message$w3_unsafe_decode_MessageContent$(
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId))))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_EncryptOldMessages)));
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							function (collapseOthers0) {
								return {collapseOthers: collapseOthers0};
							})),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_UserOptionSection,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_ExpandUserOptionSection)));
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Game$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_Game)));
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_Invalid);
			case 28:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_LeaveGuild));
			case 29:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_LinkDiscordAcknowledgementIsChecked));
			case 30:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_LinkSlackAcknowledgementIsChecked));
			case 31:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend($author$project$Evergreen$V419$DmChannel$w3_unsafe_decode_LoadedMessages),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$VisibleMessages$w3_unsafe_decode_PageRequest($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_LoadChannelMessages))));
			case 32:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId),
							$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId,
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$VisibleMessages$w3_unsafe_decode_PageRequest($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_LoadThreadMessages)))));
			case 33:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_MemberEditTyping))));
			case 34:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_MemberTyping)));
			case 35:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$ChannelDescription$w3_unsafe_decode_ChannelDescription,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$ChannelName$w3_unsafe_decode_ChannelName,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_NewChannel)))));
			case 36:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$GuildName$w3_unsafe_decode_GuildName,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_NewGuild))));
			case 37:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$author$project$Evergreen$V419$SecretId$w3_unsafe_decode_SecretId($author$project$Evergreen$V419$Id$w3_unsafe_decode_InviteLinkId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_NewInviteLink))));
			case 38:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Ports$w3_unsafe_decode_RegisterPushSubscription,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_RegisterPushSubscription)));
			case 39:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_RemoveReactionEmoji))));
			case 40:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_RequestE2ee));
			case 41:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_ScheduleAccountDeletion));
			case 42:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
						$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileData),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Zone,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_SendEditMessage)))))));
			case 43:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Encryption$w3_unsafe_decode_EncryptedData(
						$author$project$Evergreen$V419$Message$w3_unsafe_decode_MessageContent$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqSet$decodeSet($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DmId,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_SendEncryptedEditMessage))))));
			case 44:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Message$w3_unsafe_decode_ThreadRouteWithRepliedTo,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Encryption$w3_unsafe_decode_EncryptedData($lamdera$codecs$Lamdera$Wire3$decodeString),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Encryption$w3_unsafe_decode_EncryptedData(
								$author$project$Evergreen$V419$Message$w3_unsafe_decode_MessageContent$(
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId))),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqSet$decodeSet($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DmId,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_SendEncryptedMessage)))))));
			case 45:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
							$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileData),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Message$w3_unsafe_decode_ThreadRouteWithRepliedTo,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildOrDmId,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Zone,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
											$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_SendMessage))))))));
			case 46:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$User$w3_unsafe_decode_NotificationLevel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_SetDiscordGuildNotificationLevel))));
			case 47:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$RichText$w3_unsafe_decode_Domain,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_SetDomainWhitelist)));
			case 48:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_SetE2eeRisksAccepted));
			case 49:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$User$w3_unsafe_decode_EmailNotifications,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_SetEmailNotifications));
			case 50:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$User$w3_unsafe_decode_EmbedVisibility,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_SetEmbedVisibility));
			case 51:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Emoji$w3_unsafe_decode_SkinTone),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_SetEmojiSkinTone));
			case 52:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$User$w3_unsafe_decode_NotificationLevel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_SetGuildNotificationLevel)));
			case 53:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_SetLastViewed)));
			case 54:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_SetMuteChannel))));
			case 55:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_SetMuteDiscordChannel)))));
			case 56:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_SetMuteDiscordGuild))));
			case 57:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_SetMuteDiscordThread))))));
			case 58:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_SetMuteGuild)));
			case 59:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_SetMuteSlackChannel)))));
			case 60:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_SetMuteSlackThread))))));
			case 61:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_SetMuteSlackWorkspace))));
			case 62:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_SetMuteThread)))));
			case 63:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$PersonName$w3_unsafe_decode_PersonName,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_SetName));
			case 64:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_NotificationMode,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_SetNotificationMode));
			case 65:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DmId, $author$project$Evergreen$V419$Types$w3_unsafe_decode_ChannelDataToEncrypt)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$X25519$w3_unsafe_decode_PublicKey,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_SetPublicKey)));
			case 66:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$IdArray$w3_unsafe_decode_IdArray$($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId, $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_SheepGameQuestion),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_SetSheepGameQuestions));
			case 67:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$User$w3_unsafe_decode_NotificationLevel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_SetSlackWorkspaceNotificationLevel))));
			case 68:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserColor$w3_unsafe_decode_UserColor,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_SetUserColor));
			case 69:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
							$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId,
								$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$VisibleMessages$w3_unsafe_decode_PageRequest($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_SlackGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_Slack_LoadChannelMessages))));
			case 70:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId),
							$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId,
								$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$VisibleMessages$w3_unsafe_decode_PageRequest($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_SlackGuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_Slack_LoadThreadMessages)))));
			case 71:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_Slack_ReloadUser));
			case 72:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_SlackGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Zone,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_Slack_SendEditMessage))))));
			case 73:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
						$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileData),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_SlackGuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Zone,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_Slack_SendMessage)))))));
			case 74:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_Slack_UnlinkUser));
			case 75:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_StartReloadingDiscordUser)));
			case 76:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$TextEditor$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_TextEditor));
			case 77:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_UnlinkDiscordUser));
			case 78:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Call$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Local_VoiceChatChange));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$CustomEmoji$w3_unsafe_decode_CustomEmojiUrl = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Evergreen$V419$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$CustomEmoji$CustomEmojiInternal)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$CustomEmoji$CustomEmojiLoading);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$CustomEmoji$w3_unsafe_decode_EmojiName = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$CustomEmoji$w3_unsafe_decode_CustomEmojiData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$CustomEmoji$w3_unsafe_decode_CustomEmojiUrl,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$CustomEmoji$w3_unsafe_decode_EmojiName,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeBool,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (isAnimated0, name0, url0) {
						return {isAnimated: isAnimated0, name: name0, url: url0};
					})))));
var $author$project$Evergreen$V419$LinkedAndOtherDiscordUsers$w3_unsafe_decode_DiscordFrontendCurrentUser = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$PersonName$w3_unsafe_decode_PersonName,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$DiscordUserData$w3_unsafe_decode_DiscordUserLoadingData,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$EmailAddress$w3_unsafe_decode_EmailAddress),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$UserColor$w3_unsafe_decode_UserColor,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F7(
									function (color0, email0, icon0, isLoadingData0, linkedAt0, name0, needsAuthAgain0) {
										return {color: color0, email: email0, icon: icon0, isLoadingData: isLoadingData0, linkedAt: linkedAt0, name: name0, needsAuthAgain: needsAuthAgain0};
									})))))))));
var $author$project$Evergreen$V419$MessageArray$w3_unsafe_decode_Run$ = function (w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeArray(
			$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F2(
					function (start0, values0) {
						return {start: start0, values: values0};
					}))));
};
var $author$project$Evergreen$V419$MessageArray$w3_unsafe_decode_Run = F3($author$project$Evergreen$V419$MessageArray$w3_unsafe_decode_Run$);
var $author$project$Evergreen$V419$MessageArray$w3_unsafe_decode_MessageArray$ = function (w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeArray(
								$author$project$Evergreen$V419$MessageArray$w3_unsafe_decode_Run$(w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId)),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (end0, runs0, start0) {
											return {end: end0, runs: runs0, start: start0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V419$MessageArray$w3_unsafe_decode_MessageArray = F3($author$project$Evergreen$V419$MessageArray$w3_unsafe_decode_MessageArray$);
var $author$project$Evergreen$V419$VisibleMessages$w3_unsafe_decode_VisibleMessages = function (w3_x_c_messageId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id(w3_x_c_messageId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeBool,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F3(
						function (count0, loadingMessages0, oldest0) {
							return {count: count0, loadingMessages: loadingMessages0, oldest: oldest0};
						})))));
};
var $author$project$Evergreen$V419$DmChannel$w3_unsafe_decode_DiscordFrontendDmChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$VisibleMessages$w3_unsafe_decode_VisibleMessages($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$MessageArray$w3_unsafe_decode_MessageArray$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId,
			$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
			$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
				$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						function (messagesSent0) {
							return {messagesSent: messagesSent0};
						}))),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId)),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (messageIndex0, time0) {
										return {messageIndex: messageIndex0, time: time0};
									}))))),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$justinmimbs$date$Date$w3_unsafe_decode_Date,
						$author$project$Evergreen$V419$Drawing$w3_unsafe_decode_Drawing(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (dateDividerDrawings0, lastTypedAt0, members0, messages0, visibleMessages0) {
								return {dateDividerDrawings: dateDividerDrawings0, lastTypedAt: lastTypedAt0, members: members0, messages: messages0, visibleMessages: visibleMessages0};
							})))))));
var $author$project$Evergreen$V419$Thread$w3_unsafe_decode_DiscordFrontendThread = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$VisibleMessages$w3_unsafe_decode_VisibleMessages($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$MessageArray$w3_unsafe_decode_MessageArray$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId,
			$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
			$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$justinmimbs$date$Date$w3_unsafe_decode_Date,
				$author$project$Evergreen$V419$Drawing$w3_unsafe_decode_Drawing(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId))),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (dateDividerDrawings0, messages0, visibleMessages0) {
						return {dateDividerDrawings: dateDividerDrawings0, messages: messages0, visibleMessages: visibleMessages0};
					})))));
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_DiscordFrontendChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$VisibleMessages$w3_unsafe_decode_VisibleMessages($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
			$author$project$Evergreen$V419$Thread$w3_unsafe_decode_DiscordFrontendThread),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V419$Discord$w3_unsafe_decode_Overwrite),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$ChannelName$w3_unsafe_decode_ChannelName,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MessageArray$w3_unsafe_decode_MessageArray$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId,
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$ChannelDescription$w3_unsafe_decode_ChannelDescription,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqDict$decodeDict$(
									$justinmimbs$date$Date$w3_unsafe_decode_Date,
									$author$project$Evergreen$V419$Drawing$w3_unsafe_decode_Drawing(
										$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId))),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F8(
										function (dateDividerDrawings0, description0, isForum0, messages0, name0, permissionOverwrites0, threads0, visibleMessages0) {
											return {dateDividerDrawings: dateDividerDrawings0, description: description0, isForum: isForum0, messages: messages0, name: name0, permissionOverwrites: permissionOverwrites0, threads: threads0, visibleMessages: visibleMessages0};
										}))))))))));
var $author$project$Evergreen$V419$Thread$w3_unsafe_decode_LastTypedAt = function (w3_x_c_channelId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMaybeMessage,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				w3_x_c_channelId,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F3(
						function (channelId0, threadRoute0, time0) {
							return {channelId: channelId0, threadRoute: threadRoute0, time: time0};
						})))));
};
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_DiscordFrontendGuild = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqSet$decodeSet(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_StickerId)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_RoleId),
			$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_DiscordRole),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$GuildName$w3_unsafe_decode_GuildName,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$MembersAndOwner$w3_unsafe_decode_MembersAndOwner$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqSet$decodeSet(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_RoleId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (joinedAt0, roles0) {
										return {joinedAt: joinedAt0, roles: roles0};
									}))))),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
						$author$project$Evergreen$V419$Thread$w3_unsafe_decode_LastTypedAt(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqSet$decodeSet(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_CustomEmojiId)),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqDict$decodeDict$(
									$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
									$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_DiscordFrontendChannel),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F8(
										function (channels0, customEmojis0, icon0, lastTypedAt0, membersAndOwner0, name0, roles0, stickers0) {
											return {channels: channels0, customEmojis: customEmojis0, icon: icon0, lastTypedAt: lastTypedAt0, membersAndOwner: membersAndOwner0, name: name0, roles: roles0, stickers: stickers0};
										}))))))))));
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_Archived = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (archivedAt0, archivedBy0) {
					return {archivedAt: archivedAt0, archivedBy: archivedBy0};
				}))));
var $author$project$Evergreen$V419$Thread$w3_unsafe_decode_FrontendThread = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$VisibleMessages$w3_unsafe_decode_VisibleMessages($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$MessageArray$w3_unsafe_decode_MessageArray$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId,
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$justinmimbs$date$Date$w3_unsafe_decode_Date,
				$author$project$Evergreen$V419$Drawing$w3_unsafe_decode_Drawing(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId))),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (dateDividerDrawings0, messages0, visibleMessages0) {
						return {dateDividerDrawings: dateDividerDrawings0, messages: messages0, visibleMessages: visibleMessages0};
					})))));
var $author$project$Evergreen$V419$Go$w3_unsafe_decode_Phase = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$Confirming);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$Marking);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							function (previousPlayerPassed0) {
								return {previousPlayerPassed: previousPlayerPassed0};
							})),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$Playing));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeFloat,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (blackScore0, whiteScore0) {
										return {blackScore: blackScore0, whiteScore: whiteScore0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$Scored));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Go$w3_unsafe_decode_Snapshot = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Go$w3_unsafe_decode_Stone,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeDict$(
				$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
				$author$project$Evergreen$V419$Go$w3_unsafe_decode_Stone),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (blackCaptures0, board0, currentPlayer0, whiteCaptures0) {
							return {blackCaptures: blackCaptures0, board: board0, currentPlayer: currentPlayer0, whiteCaptures: whiteCaptures0};
						}))))));
var $author$project$Evergreen$V419$Go$w3_unsafe_decode_Shared = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F2(
								function (black0, white0) {
									return {black: black0, white: white0};
								}))))),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeDict$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
					$author$project$Evergreen$V419$Go$w3_unsafe_decode_Stone),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Go$w3_unsafe_decode_Phase,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId)),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V419$Go$w3_unsafe_decode_Snapshot),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V419$Go$w3_unsafe_decode_Stone,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeDict$(
												$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
												$author$project$Evergreen$V419$Go$w3_unsafe_decode_Stone),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeInt,
												$lamdera$codecs$Lamdera$Wire3$succeedDecode(
													function (blackCaptures0) {
														return function (board0) {
															return function (currentPlayer0) {
																return function (history0) {
																	return function (joinedUserId0) {
																		return function (lastAction0) {
																			return function (lastMove0) {
																				return function (phase0) {
																					return function (territoryMarks0) {
																						return function (timeLeft0) {
																							return function (turnCount0) {
																								return function (whiteCaptures0) {
																									return {blackCaptures: blackCaptures0, board: board0, currentPlayer: currentPlayer0, history: history0, joinedUserId: joinedUserId0, lastAction: lastAction0, lastMove: lastMove0, phase: phase0, territoryMarks: territoryMarks0, timeLeft: timeLeft0, turnCount: turnCount0, whiteCaptures: whiteCaptures0};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													})))))))))))));
var $author$project$Evergreen$V419$Game$w3_unsafe_decode_FrontendGameData = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Go$w3_unsafe_decode_Shared,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V419$Go$w3_unsafe_decode_ActionWithTime),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Go$w3_unsafe_decode_ValidatedSetup,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$FrontendGameData_Go))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_Shared,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_ActionWithTime),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_ValidatedSetup,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$FrontendGameData_SheepGame))));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_Shared,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_ActionWithTime),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_ValidatedSetup,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$FrontendGameData_WordSpellingGame))));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Game$w3_unsafe_decode_MatchData = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$Evergreen$V419$SecretId$w3_unsafe_decode_SecretId($author$project$Evergreen$V419$Id$w3_unsafe_decode_GamePublicId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Game$w3_unsafe_decode_FrontendGameData,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (data0, publicLink0) {
										return {data: data0, publicLink: publicLink0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$MatchData));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Message$w3_unsafe_decode_GameType,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$MatchNotLoaded));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_FrontendChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$VisibleMessages$w3_unsafe_decode_VisibleMessages($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
			$author$project$Evergreen$V419$Thread$w3_unsafe_decode_FrontendThread),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$ChannelName$w3_unsafe_decode_ChannelName,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$MessageArray$w3_unsafe_decode_MessageArray$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId,
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId)),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$LocalState$w3_unsafe_decode_Archived),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
							$author$project$Evergreen$V419$Game$w3_unsafe_decode_MatchData),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$ChannelDescription$w3_unsafe_decode_ChannelDescription,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqDict$decodeDict$(
									$justinmimbs$date$Date$w3_unsafe_decode_Date,
									$author$project$Evergreen$V419$Drawing$w3_unsafe_decode_Drawing(
										$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId))),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											function (createdAt0) {
												return function (createdBy0) {
													return function (dateDividerDrawings0) {
														return function (description0) {
															return function (games0) {
																return function (isArchived0) {
																	return function (messages0) {
																		return function (name0) {
																			return function (threads0) {
																				return function (visibleMessages0) {
																					return {createdAt: createdAt0, createdBy: createdBy0, dateDividerDrawings: dateDividerDrawings0, description: description0, games: games0, isArchived: isArchived0, messages: messages0, name: name0, threads: threads0, visibleMessages: visibleMessages0};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											})))))))))));
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_GuildMember = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (joinedAt0, lastPostedAt0) {
					return {joinedAt: joinedAt0, lastPostedAt: lastPostedAt0};
				}))));
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_FrontendGuild = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$GuildName$w3_unsafe_decode_GuildName,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$MembersAndOwner$w3_unsafe_decode_MembersAndOwner$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
			$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_GuildMember),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
				$author$project$Evergreen$V419$Thread$w3_unsafe_decode_LastTypedAt(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId))),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V419$SecretId$w3_unsafe_decode_SecretId($author$project$Evergreen$V419$Id$w3_unsafe_decode_InviteLinkId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (createdAt0, createdBy0) {
										return {createdAt: createdAt0, createdBy: createdBy0};
									}))))),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqDict$decodeDict$(
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId),
									$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_FrontendChannel),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F8(
										function (channels0, createdAt0, createdBy0, icon0, invites0, lastTypedAt0, membersAndOwner0, name0) {
											return {channels: channels0, createdAt: createdAt0, createdBy: createdBy0, icon: icon0, invites: invites0, lastTypedAt: lastTypedAt0, membersAndOwner: membersAndOwner0, name: name0};
										}))))))))));
var $author$project$Evergreen$V419$User$w3_unsafe_decode_FrontendUser = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$X25519$w3_unsafe_decode_PublicKey),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$PersonName$w3_unsafe_decode_PersonName,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$UserColor$w3_unsafe_decode_UserColor,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (color0, icon0, name0, publicKey0) {
							return {color: color0, icon: icon0, name: name0, publicKey: publicKey0};
						}))))));
var $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_ChannelData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$UserSession$Viewing_Channel));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_ChannelThreadData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$UserSession$Viewing_ChannelThread));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_DiscordChannelData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$UserSession$Viewing_DiscordChannel));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_DiscordChannelThreadData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$UserSession$Viewing_DiscordChannelThread));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_DiscordDmData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$UserSession$Viewing_DiscordDm));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_DmData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$UserSession$Viewing_Dm));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_DmThreadData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$UserSession$Viewing_DmThread));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$UserSession$Viewing_None);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$UserSession$Viewing_Overview);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_SlackChannelData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$UserSession$Viewing_SlackChannel));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_SlackChannelThreadData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$UserSession$Viewing_SlackChannelThread));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_SlackDmData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$UserSession$Viewing_SlackDm));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing_SlackDmThreadData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$UserSession$Viewing_SlackDmThread));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_FrontendUserSession = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$UserAgent$w3_unsafe_decode_UserAgent,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_NotificationMode,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$($lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId, $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (currentlyViewing0, lastActiveAt0, notificationMode0, userAgent0) {
							return {currentlyViewing: currentlyViewing0, lastActiveAt: lastActiveAt0, notificationMode: notificationMode0, userAgent: userAgent0};
						}))))));
var $author$project$Evergreen$V419$Call$w3_unsafe_decode_CallId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$DmRoomId));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_ChannelId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$GuildRoomId));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_CallStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Call$w3_unsafe_decode_CallId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$ConnectedToCall));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$NotInCall);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_LastRequest = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$LastRequest));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$NoRequestsMade);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_ConnectionData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Call$w3_unsafe_decode_RemoteCallData,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_LastRequest,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_CallStatus,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (call0, currentlyViewing0, lastRequest0, remoteCallData0) {
							return {call: call0, currentlyViewing: currentlyViewing0, lastRequest: lastRequest0, remoteCallData: remoteCallData0};
						}))))));
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_BackupContents = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_LastBackup = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_BackupContents,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (contents0, createdAt0) {
					return {contents: contents0, createdAt: createdAt0};
				}))));
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_LoadingDiscordChannelStep = function (w3_x_c_messages) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_messages,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$LoadingDiscordChannelAttachments)));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$LoadingDiscordChannelMessages);
				case 2:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_HttpError,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$LoadingDiscordChannelMessagesFailed));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_LoadingDiscordChannel = function (w3_x_c_messages) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_LoadingDiscordChannelStep(w3_x_c_messages),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$LoadingDiscordDmChannel))));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_LoadingDiscordChannelStep(w3_x_c_messages),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$LoadingDiscordGuildChannel)))));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V419$Pagination$w3_unsafe_decode_PageStatus = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeArray(w3_x_c_a),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pagination$PageLoaded));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pagination$PageLoading);
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V419$Pagination$w3_unsafe_decode_Pagination = function (w3_x_c_a) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Pagination$w3_unsafe_decode_PageId),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Pagination$w3_unsafe_decode_PageId),
					$author$project$Evergreen$V419$Pagination$w3_unsafe_decode_PageStatus(w3_x_c_a)),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Pagination$w3_unsafe_decode_PageId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F4(
							function (currentPage0, pages0, previousPage0, totalItems0) {
								return {currentPage: currentPage0, pages: pages0, previousPage: previousPage0, totalItems: totalItems0};
							}))))));
};
var $author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_TypeThatIsAlwaysInvalid = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_WordSpellingGameStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$WordSpellingGameStatus_Error));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$WordSpellingGameStatus_Loaded);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$WordSpellingGameStatus_Loading);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$WordSpellingGameStatus_NotLoaded);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_InitAdminData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_WordSpellingGameStatus,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_WordSpellingGameStatus,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeBool,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeList(
										$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeString, $lamdera$codecs$Lamdera$Wire3$decodeInt)),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_PrivateVapidKey,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Evergreen$V419$Postmark$w3_unsafe_decode_ApiKey,
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
															$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId)),
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$author$project$Evergreen$V419$Pagination$w3_unsafe_decode_Pagination($author$project$Evergreen$V419$LocalState$w3_unsafe_decode_LogWithTime),
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$lamdera$containers$SeqDict$decodeDict$(
																	$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
																	$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_LoadingDiscordChannel($lamdera$codecs$Lamdera$Wire3$decodeInt)),
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$LocalState$w3_unsafe_decode_LastBackup),
																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																		$lamdera$codecs$Lamdera$Wire3$decodeInt,
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$codecs$Lamdera$Wire3$decodeBool,
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$lamdera$codecs$Lamdera$Wire3$decodeBool,
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																						$lamdera$codecs$Lamdera$Wire3$decodeList(
																							$lamdera$codecs$Lamdera$Wire3$decodePair$(
																								$author$project$Evergreen$V419$SessionIdHash$w3_unsafe_decode_SessionIdHash,
																								$author$project$Evergreen$V419$NonemptyDict$w3_unsafe_decode_NonemptyDict$($lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId, $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_ConnectionData))),
																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																							$author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_TypeThatIsAlwaysInvalid,
																							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																								function (checkToFrontendValidation0) {
																									return function (connections0) {
																										return function (discordLinkLimit0) {
																											return function (discordLinkingEnabled0) {
																												return function (emailNotificationsEnabled0) {
																													return function (filesCount0) {
																														return function (lastBackup0) {
																															return function (loadingDiscordChannels0) {
																																return function (logs0) {
																																	return function (notifyAdminsBotUserId0) {
																																		return function (notifyAdminsToken0) {
																																			return function (openRouterKey0) {
																																				return function (postmarkApiKey0) {
																																					return function (privateVapidKey0) {
																																						return function (seqDictWorks0) {
																																							return function (serverSecretRegeneratedAt0) {
																																								return function (signupsEnabled0) {
																																									return function (slackLinkLimit0) {
																																										return function (slackLinkingEnabled0) {
																																											return function (twoFactorAuthentication0) {
																																												return function (vulnerabilityChecks0) {
																																													return function (wordSpellingGameEnglish0) {
																																														return function (wordSpellingGameSwedish0) {
																																															return {checkToFrontendValidation: checkToFrontendValidation0, connections: connections0, discordLinkLimit: discordLinkLimit0, discordLinkingEnabled: discordLinkingEnabled0, emailNotificationsEnabled: emailNotificationsEnabled0, filesCount: filesCount0, lastBackup: lastBackup0, loadingDiscordChannels: loadingDiscordChannels0, logs: logs0, notifyAdminsBotUserId: notifyAdminsBotUserId0, notifyAdminsToken: notifyAdminsToken0, openRouterKey: openRouterKey0, postmarkApiKey: postmarkApiKey0, privateVapidKey: privateVapidKey0, seqDictWorks: seqDictWorks0, serverSecretRegeneratedAt: serverSecretRegeneratedAt0, signupsEnabled: signupsEnabled0, slackLinkLimit: slackLinkLimit0, slackLinkingEnabled: slackLinkingEnabled0, twoFactorAuthentication: twoFactorAuthentication0, vulnerabilityChecks: vulnerabilityChecks0, wordSpellingGameEnglish: wordSpellingGameEnglish0, wordSpellingGameSwedish: wordSpellingGameSwedish0};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								}))))))))))))))))))))))));
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_JoinGuildError = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_RepliedToData = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$NoReplyData);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Game$w3_unsafe_decode_LoadedMatch,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$RepliedToGame));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId,
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$RepliedToMessage));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId,
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$RepliedToThreadMessage));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Call$w3_unsafe_decode_ConnectionId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Call$w3_unsafe_decode_CallId,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodePair$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
			$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (otherClientId0, roomId0) {
					return {otherClientId: otherClientId0, roomId: roomId0};
				}))));
var $author$project$Evergreen$V419$Call$w3_unsafe_decode_RecordingStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqSet$decodeSet(
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId)),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (allowedBy0, requestedAt0, requestedBy0) {
											return {allowedBy: allowedBy0, requestedAt: requestedAt0, requestedBy: requestedBy0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$AskingToRecord));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId)),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (declinedAt0, declinedBy0, requestedBy0) {
											return {declinedAt: declinedAt0, declinedBy: declinedBy0, requestedBy: requestedBy0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$RecordingDeclined));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$RecordingSince));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Call$w3_unsafe_decode_ServerChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Call$w3_unsafe_decode_ConnectionId,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$Server_Left)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Call$w3_unsafe_decode_RemoteCallData,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Call$w3_unsafe_decode_ConnectionId,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$Server_OtherJoined))));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Call$w3_unsafe_decode_RecordingStatus),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Call$w3_unsafe_decode_CallId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$Server_RecordingChanged)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Call$w3_unsafe_decode_RemoteCallData,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Call$w3_unsafe_decode_ConnectionId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$Server_SetRemoteCallData)));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Call$w3_unsafe_decode_CallId,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$Server_YouJoined)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$TextEditor$w3_unsafe_decode_ServerChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$TextEditor$w3_unsafe_decode_EditChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$TextEditor$Server_EditChange)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$TextEditor$Server_Redo));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$TextEditor$Server_Reset);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$TextEditor$Server_Undo));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Thread$w3_unsafe_decode_FrontendGenericThread$ = function (w3_x_c_userId, w3_x_c_channelId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$VisibleMessages$w3_unsafe_decode_VisibleMessages($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$MessageArray$w3_unsafe_decode_MessageArray$($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId, w3_x_c_userId, w3_x_c_channelId),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$justinmimbs$date$Date$w3_unsafe_decode_Date,
					$author$project$Evergreen$V419$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId)),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F3(
						function (dateDividerDrawings0, messages0, visibleMessages0) {
							return {dateDividerDrawings: dateDividerDrawings0, messages: messages0, visibleMessages: visibleMessages0};
						})))));
};
var $author$project$Evergreen$V419$Thread$w3_unsafe_decode_FrontendGenericThread = F2($author$project$Evergreen$V419$Thread$w3_unsafe_decode_FrontendGenericThread$);
var $author$project$Evergreen$V419$Thread$w3_unsafe_decode_SlackFrontendThread = $author$project$Evergreen$V419$Thread$w3_unsafe_decode_FrontendGenericThread$(
	$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
	$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId));
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_SlackFrontendDmChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$VisibleMessages$w3_unsafe_decode_VisibleMessages($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
			$author$project$Evergreen$V419$Thread$w3_unsafe_decode_SlackFrontendThread),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$MessageArray$w3_unsafe_decode_MessageArray$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId,
					$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
					$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId)),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$NonemptySet$w3_unsafe_decode_NonemptySet(
						$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (members0, messages0, teamId0, threads0, visibleMessages0) {
								return {members: members0, messages: messages0, teamId: teamId0, threads: threads0, visibleMessages: visibleMessages0};
							})))))));
var $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_SlackFrontendUser = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$PersonName$w3_unsafe_decode_PersonName,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$UserColor$w3_unsafe_decode_UserColor,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (color0, icon0, name0, teamId0) {
							return {color: color0, icon: icon0, name: name0, teamId: teamId0};
						}))))));
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_SlackFrontendChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$VisibleMessages$w3_unsafe_decode_VisibleMessages($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
			$author$project$Evergreen$V419$Thread$w3_unsafe_decode_SlackFrontendThread),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$ChannelName$w3_unsafe_decode_ChannelName,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$MessageArray$w3_unsafe_decode_MessageArray$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId,
					$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
					$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId)),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (isPrivate0, messages0, name0, threads0, visibleMessages0) {
								return {isPrivate: isPrivate0, messages: messages0, name: name0, threads: threads0, visibleMessages: visibleMessages0};
							})))))));
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_SlackFrontendWorkspace = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqSet$decodeSet(
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_CustomEmojiId)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId),
					$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_SlackFrontendChannel),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (channels0, customEmojis0, icon0, name0) {
							return {channels: channels0, customEmojis: customEmojis0, icon: icon0, name: name0};
						}))))));
var $author$project$Evergreen$V419$Discord$w3_unsafe_decode_StickerFormatType = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Discord$StickerId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Discord$w3_unsafe_decode_StickerId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Sticker$w3_unsafe_decode_StickerUrl = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_StickerId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Sticker$DiscordStandardSticker));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Evergreen$V419$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Sticker$StickerInternal)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Sticker$StickerLoading);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Sticker$w3_unsafe_decode_StickerData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Sticker$w3_unsafe_decode_StickerUrl,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$Discord$w3_unsafe_decode_StickerFormatType,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (format0, name0, url0) {
						return {format: format0, name: name0, url: url0};
					})))));
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_ServerChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_AddReactionEmoji)))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_LastBackup,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_BackupGenerated));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$NonemptySet$w3_unsafe_decode_NonemptySet(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_CallRecordingStarted)))));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_CallRecordingUploadFinished))));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Message$w3_unsafe_decode_CallRecordingFile(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_CallRecordingUploadProgress))));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Message$w3_unsafe_decode_CallRecordingZip,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_CallRecordingZipBuilt))));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$SessionIdHash$w3_unsafe_decode_SessionIdHash,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_ClientDisconnected))));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$SessionIdHash$w3_unsafe_decode_SessionIdHash,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_CurrentlyViewing))));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DeleteChannel)));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DeleteGuild));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$SecretId$w3_unsafe_decode_SecretId($author$project$Evergreen$V419$Id$w3_unsafe_decode_InviteLinkId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DeleteInviteLink)));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DeleteMessage)));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DmId,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DisableE2ee))));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DiscordAddReactionDmEmoji)))));
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DiscordAddReactionGuildEmoji))))));
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_DiscordFrontendUser,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DiscordAvatarsLoaded)));
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V419$Discord$w3_unsafe_decode_Overwrite),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_OptionalData(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$ChannelName$w3_unsafe_decode_ChannelName,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeBool,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DiscordChannelCreated)))))));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DiscordChannelDeleted)));
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DiscordDeleteDmMessage)));
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DiscordDeleteGuildMessage))));
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								function (messagesSent0) {
									return {messagesSent: messagesSent0};
								}))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DiscordDmChannelCreated)));
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DiscordDmChannelRecipientRemoved)));
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DiscordDmMemberTyping))));
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DiscordForumPostDeleted))));
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_DiscordFrontendGuild,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DiscordGuildJoinedOrCreated))));
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DiscordGuildLeftOrDeleted)));
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserColor$w3_unsafe_decode_UserColor,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$PersonName$w3_unsafe_decode_PersonName,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DiscordGuildMemberJoined)))))));
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DiscordGuildMemberTyping))))));
			case 28:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DiscordNeedsAuthAgain));
			case 29:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DiscordRemoveReactionDmEmoji)))));
			case 30:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DiscordRemoveReactionGuildEmoji))))));
			case 31:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
						$author$project$Evergreen$V419$RichText$w3_unsafe_decode_RichText$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DiscordDmId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DiscordSendEditDmMessage)))));
			case 32:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
						$author$project$Evergreen$V419$RichText$w3_unsafe_decode_RichText$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DiscordSendEditGuildMessage)))))));
			case 33:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V419$Discord$w3_unsafe_decode_Overwrite),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_OptionalData(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_OptionalData(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString)),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DiscordUpdateChannel))))));
			case 34:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_RoleId),
						$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_DiscordRole),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$GuildName$w3_unsafe_decode_GuildName,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DiscordUpdateGuild)))));
			case 35:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqSet$decodeSet(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_CustomEmojiId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DiscordUpdateGuildCustomEmojis)));
			case 36:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_DiscordRole,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_RoleId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DiscordUpdateRole))));
			case 37:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeBool,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqDict$decodeDict$(
									$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
									$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_DiscordFrontendUser),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$containers$SeqDict$decodeDict$(
										$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
										$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_DiscordFrontendGuild),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$containers$SeqDict$decodeDict$(
											$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
											$author$project$Evergreen$V419$DmChannel$w3_unsafe_decode_DiscordFrontendDmChannel),
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											F4(
												function (discordDms0, discordGuilds0, discordUsers0, markEverythingAsViewed0) {
													return {discordDms: discordDms0, discordGuilds: discordGuilds0, discordUsers: discordUsers0, markEverythingAsViewed: markEverythingAsViewed0};
												}))))))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_DiscordUserLoadingDataIsDone)));
			case 38:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_StickerId),
						$author$project$Evergreen$V419$Sticker$w3_unsafe_decode_StickerData),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
							$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileData),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMaybeMessage,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
									$author$project$Evergreen$V419$RichText$w3_unsafe_decode_RichText$(
										$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
										$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId))),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_DiscordFrontendUser,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V419$Id$w3_unsafe_decode_DiscordGuildOrDmId,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
											$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_Discord_SendMessage))))))));
			case 39:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Drawing$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Drawing$w3_unsafe_decode_AnchorType,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_Drawing)))));
			case 40:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_E2eeAccepted)));
			case 41:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_E2eeRequestCancelled));
			case 42:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_E2eeRequestDeclined)));
			case 43:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
						$author$project$Evergreen$V419$SessionIdHash$w3_unsafe_decode_SessionIdHash),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_E2eeRequested)));
			case 44:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$ChannelDescription$w3_unsafe_decode_ChannelDescription,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$ChannelName$w3_unsafe_decode_ChannelName,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_EditChannel)))));
			case 45:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$GuildName$w3_unsafe_decode_GuildName,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_EditGuildName)));
			case 46:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Game$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_Game))));
			case 47:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$elm$url$Url$w3_unsafe_decode_Url,
						$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $author$project$Evergreen$V419$Embed$w3_unsafe_decode_EmbedData)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_GotDiscordDmMessageEmbed))));
			case 48:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$elm$url$Url$w3_unsafe_decode_Url,
						$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $author$project$Evergreen$V419$Embed$w3_unsafe_decode_EmbedData)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_GotDiscordGuildMessageEmbed)))));
			case 49:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$elm$url$Url$w3_unsafe_decode_Url,
						$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $author$project$Evergreen$V419$Embed$w3_unsafe_decode_EmbedData)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_GotDmMessageEmbed))));
			case 50:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$elm$url$Url$w3_unsafe_decode_Url,
						$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $author$project$Evergreen$V419$Embed$w3_unsafe_decode_EmbedData)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_GotGuildMessageEmbed)))));
			case 51:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_FrontendChannel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_ImportedChannel))));
			case 52:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$LinkedAndOtherDiscordUsers$w3_unsafe_decode_DiscordFrontendCurrentUser,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_LinkDiscordUser)));
			case 53:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_CustomEmojiId),
						$author$project$Evergreen$V419$CustomEmoji$w3_unsafe_decode_CustomEmojiData),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_LinkedDiscordUserCustomEmojisLoaded));
			case 54:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_StickerId),
						$author$project$Evergreen$V419$Sticker$w3_unsafe_decode_StickerData),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_LinkedDiscordUserStickersLoaded));
			case 55:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_InitAdminData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_LoadAdminData));
			case 56:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_LoadingDiscordChannel($lamdera$codecs$Lamdera$Wire3$decodeInt)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_LoadingDiscordChannelChanged)));
			case 57:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$SessionIdHash$w3_unsafe_decode_SessionIdHash,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_LoggedOut));
			case 58:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_MemberEditTyping)))));
			case 59:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$User$w3_unsafe_decode_FrontendUser,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_MemberJoined)))));
			case 60:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_MemberLeft)));
			case 61:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_MemberTyping)))));
			case 62:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$ChannelDescription$w3_unsafe_decode_ChannelDescription,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$ChannelName$w3_unsafe_decode_ChannelName,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_NewChannel)))));
			case 63:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$SecretId$w3_unsafe_decode_SecretId($author$project$Evergreen$V419$Id$w3_unsafe_decode_InviteLinkId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_NewInviteLink)))));
			case 64:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Log$w3_unsafe_decode_Log,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_NewLog)));
			case 65:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_FrontendUserSession,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$SessionIdHash$w3_unsafe_decode_SessionIdHash,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_NewSession)));
			case 66:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Ports$w3_unsafe_decode_SubscribeData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_PushNotificationFailed)));
			case 67:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_PushNotificationsReset));
			case 68:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_RemoveReactionEmoji)))));
			case 69:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
						$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileData),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$author$project$Evergreen$V419$RichText$w3_unsafe_decode_RichText$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId))),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_SendEditMessage)))))));
			case 70:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Encryption$w3_unsafe_decode_EncryptedData(
						$author$project$Evergreen$V419$Message$w3_unsafe_decode_MessageContent$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqSet$decodeSet($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DmId,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_SendEncryptedEditMessage)))))));
			case 71:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Message$w3_unsafe_decode_ThreadRouteWithRepliedTo,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$User$w3_unsafe_decode_FrontendUser,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V419$Types$w3_unsafe_decode_RepliedToData,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Evergreen$V419$Id$w3_unsafe_decode_Viewing_DmId,
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$containers$SeqSet$decodeSet($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash),
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$author$project$Evergreen$V419$Encryption$w3_unsafe_decode_EncryptedData(
														$author$project$Evergreen$V419$Message$w3_unsafe_decode_MessageContent$(
															$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
															$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId))),
													$lamdera$codecs$Lamdera$Wire3$succeedDecode(
														F8(
															function (content0, fileHashes0, id0, repliedToData0, sender0, senderId0, sentAt0, threadRoute0) {
																return {content: content0, fileHashes: fileHashes0, id: id0, repliedToData: repliedToData0, sender: sender0, senderId: senderId0, sentAt: sentAt0, threadRoute: threadRoute0};
															})))))))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_SendEncryptedMessage));
			case 72:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Message$w3_unsafe_decode_ThreadRouteWithRepliedTo,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqDict$decodeDict$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_StickerId),
								$author$project$Evergreen$V419$Sticker$w3_unsafe_decode_StickerData),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V419$User$w3_unsafe_decode_FrontendUser,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Evergreen$V419$Types$w3_unsafe_decode_RepliedToData,
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildOrDmId,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
														$author$project$Evergreen$V419$RichText$w3_unsafe_decode_RichText$(
															$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
															$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId))),
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$lamdera$containers$SeqDict$decodeDict$(
															$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
															$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileData),
														$lamdera$codecs$Lamdera$Wire3$succeedDecode(
															F9(
																function (attachedFiles0, content0, guildOrDmId0, repliedToData0, sender0, senderId0, sentAt0, stickers0, threadRoute0) {
																	return {attachedFiles: attachedFiles0, content: content0, guildOrDmId: guildOrDmId0, repliedToData: repliedToData0, sender: sender0, senderId: senderId0, sentAt: sentAt0, stickers: stickers0, threadRoute: threadRoute0};
																}))))))))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_SendMessage));
			case 73:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$User$w3_unsafe_decode_NotificationLevel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_SetDiscordGuildNotificationLevel)));
			case 74:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_SetGuildIcon)));
			case 75:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$User$w3_unsafe_decode_NotificationLevel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_SetGuildNotificationLevel)));
			case 76:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_SetMuteChannel))));
			case 77:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_SetMuteDiscordChannel))));
			case 78:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_SetMuteDiscordGuild)));
			case 79:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_SetMuteDiscordThread)))));
			case 80:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_SetMuteGuild)));
			case 81:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_SetMuteSlackChannel))));
			case 82:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_SetMuteSlackThread)))));
			case 83:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_SetMuteSlackWorkspace)));
			case 84:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_SetMuteThread)))));
			case 85:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$PersonName$w3_unsafe_decode_PersonName,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_SetName)));
			case 86:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$X25519$w3_unsafe_decode_PublicKey,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_SetPublicKey)));
			case 87:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$User$w3_unsafe_decode_NotificationLevel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_SetSlackWorkspaceNotificationLevel)));
			case 88:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserColor$w3_unsafe_decode_UserColor,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_SetUserColor)));
			case 89:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_SetUserIcon)));
			case 90:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_SlackGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_Slack_AddReactionEmoji)))));
			case 91:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$ChannelName$w3_unsafe_decode_ChannelName,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_Slack_ChannelRenamed))));
			case 92:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$CustomEmoji$w3_unsafe_decode_CustomEmojiData,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_CustomEmojiId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_Slack_CustomEmojiAdded))));
			case 93:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_CustomEmojiId),
						$author$project$Evergreen$V419$CustomEmoji$w3_unsafe_decode_CustomEmojiData),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_Slack_CustomEmojisLoaded));
			case 94:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_SlackGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_Slack_DeleteMessage)));
			case 95:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
						$author$project$Evergreen$V419$RichText$w3_unsafe_decode_RichText$(
							$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
							$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_SlackGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_Slack_EditMessage))))));
			case 96:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$elm$url$Url$w3_unsafe_decode_Url,
						$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $author$project$Evergreen$V419$Embed$w3_unsafe_decode_EmbedData)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_SlackGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_Slack_GotMessageEmbed))));
			case 97:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
							$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_SlackFrontendWorkspace),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqDict$decodeDict$(
								$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_SlackFrontendUser),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeBool,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$containers$SeqDict$decodeDict$(
										$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_DmChannelId),
										$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_SlackFrontendDmChannel),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$containers$SeqDict$decodeDict$(
											$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_CustomEmojiId),
											$author$project$Evergreen$V419$CustomEmoji$w3_unsafe_decode_CustomEmojiData),
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											F5(
												function (customEmojis0, dmChannels0, markNewDmsAsViewed0, users0, workspaces0) {
													return {customEmojis: customEmojis0, dmChannels: dmChannels0, markNewDmsAsViewed: markNewDmsAsViewed0, users: users0, workspaces: workspaces0};
												}))))))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_Slack_LinkedUserLoaded))));
			case 98:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_Slack_NeedsAuthAgain));
			case 99:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_SlackGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_Slack_RemoveReactionEmoji)))));
			case 100:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Evergreen$V419$Message$w3_unsafe_decode_Message$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId,
							$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
							$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
							$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileData),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
								$author$project$Evergreen$V419$RichText$w3_unsafe_decode_RichText$(
									$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
									$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId))),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_SlackGuildOrDmId,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_Slack_SendMessage)))))));
			case 101:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_Slack_UnlinkUser));
			case 102:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_SlackFrontendUser,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_Slack_UserLoaded)));
			case 103:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_Slack_WorkspaceRenamed)));
			case 104:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_StartReloadingDiscordUser)));
			case 105:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$TextEditor$w3_unsafe_decode_ServerChange,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_TextEditor));
			case 106:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_UnlinkDiscordUser));
			case 107:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MembersAndOwner$w3_unsafe_decode_MembersAndOwner$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqSet$decodeSet(
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_RoleId)),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F2(
										function (joinedAt0, roles0) {
											return {joinedAt: joinedAt0, roles: roles0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_UpdateDiscordMembers)));
			case 108:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Call$w3_unsafe_decode_ServerChange,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_VoiceChatChange));
			case 109:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$(
						$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_JoinGuildError,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$User$w3_unsafe_decode_FrontendUser,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqDict$decodeDict$(
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
									$author$project$Evergreen$V419$User$w3_unsafe_decode_FrontendUser),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_FrontendGuild,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											F4(
												function (guild0, guildId0, members0, owner0) {
													return {guild: guild0, guildId: guildId0, members: members0, owner: owner0};
												}))))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Server_YouJoinedGuildByInvite));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_LocalMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Types$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$LocalChange)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Types$w3_unsafe_decode_ServerChange,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$ServerChange));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminDataStatus = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_a,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$AdminDataLoaded));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$AdminDataLoading);
				case 2:
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$AdminDataNotLoaded);
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_DeleteOrphanedFilesStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$DeletingOrphanedFiles);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$DeletingOrphanedFilesFailed));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$NotDeletingOrphanedFiles);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_ServerSecretStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$BeingRegenerated);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$NotBeingRegenerated));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$RegenerationFailed));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_WordSpellingGameStatus,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_WordSpellingGameStatus,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminDataStatus(
				$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V419$LocalState$w3_unsafe_decode_WebsocketClosedEvent)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminDataStatus(
						$author$project$Evergreen$V419$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
							$author$project$Evergreen$V419$User$w3_unsafe_decode_BackendUser)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminDataStatus(
								$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V419$ToBackendLog$w3_unsafe_decode_ToBackendLogData)),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminDataStatus(
									$lamdera$containers$SeqDict$decodeDict$(
										$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
										$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminData_SlackWorkspace)),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeBool,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminDataStatus(
												$lamdera$containers$SeqDict$decodeDict$(
													$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_DmChannelId),
													$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminData_SlackDmChannel)),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeBool,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminDataStatus(
														$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V419$SessionIdHash$w3_unsafe_decode_SessionIdHash, $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_UserSession)),
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_ServerSecretStatus,
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$lamdera$codecs$Lamdera$Wire3$decodeList(
																$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeString, $lamdera$codecs$Lamdera$Wire3$decodeInt)),
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_PrivateVapidKey,
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$author$project$Evergreen$V419$Postmark$w3_unsafe_decode_ApiKey,
																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																		$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminDataStatus(
																			$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash, $author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_BackendFileData)),
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
																						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId)),
																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																						$author$project$Evergreen$V419$Pagination$w3_unsafe_decode_Pagination($author$project$Evergreen$V419$LocalState$w3_unsafe_decode_LogWithTime),
																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																							$lamdera$containers$SeqDict$decodeDict$(
																								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
																								$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_LoadingDiscordChannel($lamdera$codecs$Lamdera$Wire3$decodeInt)),
																							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$LocalState$w3_unsafe_decode_LastBackup),
																								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																									$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminDataStatus(
																										$lamdera$containers$SeqDict$decodeDict$(
																											$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
																											$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminData_Guild)),
																									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																										$lamdera$codecs$Lamdera$Wire3$decodeInt,
																										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																											$lamdera$codecs$Lamdera$Wire3$decodeBool,
																											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																												$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminDataStatus(
																													$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V419$DmChannelId$w3_unsafe_decode_DmChannelId, $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminData_DmChannel)),
																												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																													$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminDataStatus(
																														$lamdera$containers$SeqDict$decodeDict$(
																															$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
																															$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_DiscordUserData_ForAdmin)),
																													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																														$lamdera$codecs$Lamdera$Wire3$decodeBool,
																														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																															$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
																															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminDataStatus(
																																	$lamdera$containers$SeqDict$decodeDict$(
																																		$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
																																		$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminData_DiscordGuild)),
																																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																	$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminDataStatus(
																																		$lamdera$containers$SeqDict$decodeDict$(
																																			$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
																																			$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminData_DiscordDmChannel)),
																																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																		$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminDataStatus(
																																			$lamdera$containers$SeqDict$decodeDict$(
																																				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
																																				$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminData_DeletedGuild)),
																																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																			$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_DeleteOrphanedFilesStatus,
																																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																				$lamdera$codecs$Lamdera$Wire3$decodeList(
																																					$lamdera$codecs$Lamdera$Wire3$decodePair$(
																																						$author$project$Evergreen$V419$SessionIdHash$w3_unsafe_decode_SessionIdHash,
																																						$author$project$Evergreen$V419$NonemptyDict$w3_unsafe_decode_NonemptyDict$($lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId, $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_ConnectionData))),
																																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																					$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminDataStatus(
																																						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V419$BackendMsgLog$w3_unsafe_decode_BackendMsgLogData)),
																																					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																																						function (backendMsgLogs0) {
																																							return function (connections0) {
																																								return function (deleteOrphanedFiles0) {
																																									return function (deletedGuilds0) {
																																										return function (discordDmChannels0) {
																																											return function (discordGuilds0) {
																																												return function (discordLinkLimit0) {
																																													return function (discordLinkingEnabled0) {
																																														return function (discordUsers0) {
																																															return function (dmChannels0) {
																																																return function (emailNotificationsEnabled0) {
																																																	return function (filesCount0) {
																																																		return function (guilds0) {
																																																			return function (lastBackup0) {
																																																				return function (loadingDiscordChannels0) {
																																																					return function (logs0) {
																																																						return function (notifyAdminsBotUserId0) {
																																																							return function (notifyAdminsToken0) {
																																																								return function (openRouterKey0) {
																																																									return function (orphanedFiles0) {
																																																										return function (postmarkKey0) {
																																																											return function (privateVapidKey0) {
																																																												return function (seqDictWorks0) {
																																																													return function (serverSecretRefreshedAt0) {
																																																														return function (sessions0) {
																																																															return function (signupsEnabled0) {
																																																																return function (slackDmChannels0) {
																																																																	return function (slackLinkLimit0) {
																																																																		return function (slackLinkingEnabled0) {
																																																																			return function (slackWorkspaces0) {
																																																																				return function (toBackendLogs0) {
																																																																					return function (twoFactorAuthentication0) {
																																																																						return function (users0) {
																																																																							return function (vulnerabilityChecks0) {
																																																																								return function (websocketCloseEvents0) {
																																																																									return function (wordSpellingGameEnglish0) {
																																																																										return function (wordSpellingGameSwedish0) {
																																																																											return {backendMsgLogs: backendMsgLogs0, connections: connections0, deleteOrphanedFiles: deleteOrphanedFiles0, deletedGuilds: deletedGuilds0, discordDmChannels: discordDmChannels0, discordGuilds: discordGuilds0, discordLinkLimit: discordLinkLimit0, discordLinkingEnabled: discordLinkingEnabled0, discordUsers: discordUsers0, dmChannels: dmChannels0, emailNotificationsEnabled: emailNotificationsEnabled0, filesCount: filesCount0, guilds: guilds0, lastBackup: lastBackup0, loadingDiscordChannels: loadingDiscordChannels0, logs: logs0, notifyAdminsBotUserId: notifyAdminsBotUserId0, notifyAdminsToken: notifyAdminsToken0, openRouterKey: openRouterKey0, orphanedFiles: orphanedFiles0, postmarkKey: postmarkKey0, privateVapidKey: privateVapidKey0, seqDictWorks: seqDictWorks0, serverSecretRefreshedAt: serverSecretRefreshedAt0, sessions: sessions0, signupsEnabled: signupsEnabled0, slackDmChannels: slackDmChannels0, slackLinkLimit: slackLinkLimit0, slackLinkingEnabled: slackLinkingEnabled0, slackWorkspaces: slackWorkspaces0, toBackendLogs: toBackendLogs0, twoFactorAuthentication: twoFactorAuthentication0, users: users0, vulnerabilityChecks: vulnerabilityChecks0, websocketCloseEvents: websocketCloseEvents0, wordSpellingGameEnglish: wordSpellingGameEnglish0, wordSpellingGameSwedish: wordSpellingGameSwedish0};
																																																																										};
																																																																									};
																																																																								};
																																																																							};
																																																																						};
																																																																					};
																																																																				};
																																																																			};
																																																																		};
																																																																	};
																																																																};
																																																															};
																																																														};
																																																													};
																																																												};
																																																											};
																																																										};
																																																									};
																																																								};
																																																							};
																																																						};
																																																					};
																																																				};
																																																			};
																																																		};
																																																	};
																																																};
																																															};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						}))))))))))))))))))))))))))))))))))))));
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$IsAdmin));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$IsAdminButDataNotLoaded);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LocalState$IsNotAdmin);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$DmChannel$w3_unsafe_decode_E2eeEnabledData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodePair$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
		$author$project$Evergreen$V419$SessionIdHash$w3_unsafe_decode_SessionIdHash),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (enabledAt0, requestedBy0) {
					return {enabledAt: enabledAt0, requestedBy: requestedBy0};
				}))));
var $author$project$Evergreen$V419$DmChannel$w3_unsafe_decode_E2eeStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$DmChannel$E2eeDeclinedBy));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$lamdera$codecs$Lamdera$Wire3$decodePair$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$DmChannel$E2eeDisabled));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$DmChannel$w3_unsafe_decode_E2eeEnabledData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$DmChannel$E2eeEnabled));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
						$author$project$Evergreen$V419$SessionIdHash$w3_unsafe_decode_SessionIdHash),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$DmChannel$E2eeRequestedBy));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$DmChannel$w3_unsafe_decode_FrontendDmChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$VisibleMessages$w3_unsafe_decode_VisibleMessages($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
			$author$project$Evergreen$V419$Thread$w3_unsafe_decode_FrontendThread),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$MessageArray$w3_unsafe_decode_MessageArray$(
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId,
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMaybeMessage,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (threadRoute0, time0) {
										return {threadRoute: threadRoute0, time: time0};
									}))))),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$author$project$Evergreen$V419$Game$w3_unsafe_decode_MatchData),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$DmChannel$w3_unsafe_decode_E2eeStatus,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqDict$decodeDict$(
								$justinmimbs$date$Date$w3_unsafe_decode_Date,
								$author$project$Evergreen$V419$Drawing$w3_unsafe_decode_Drawing(
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId))),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F7(
									function (dateDividerDrawings0, e2ee0, games0, lastTypedAt0, messages0, threads0, visibleMessages0) {
										return {dateDividerDrawings: dateDividerDrawings0, e2ee: e2ee0, games: games0, lastTypedAt: lastTypedAt0, messages: messages0, threads: threads0, visibleMessages: visibleMessages0};
									})))))))));
var $author$project$Evergreen$V419$Call$w3_unsafe_decode_Local = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Evergreen$V419$Call$w3_unsafe_decode_CallId,
		$author$project$Evergreen$V419$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
			$lamdera$codecs$Lamdera$Wire3$decodePair$(
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
				$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId),
			$author$project$Evergreen$V419$Call$w3_unsafe_decode_RemoteCallData)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V419$Call$w3_unsafe_decode_CallId, $author$project$Evergreen$V419$Call$w3_unsafe_decode_RecordingStatus),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Call$w3_unsafe_decode_CallId),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (currentRoom0, recordings0, voiceChats0) {
						return {currentRoom: currentRoom0, recordings: recordings0, voiceChats: voiceChats0};
					})))));
var $author$project$Evergreen$V419$TextEditor$w3_unsafe_decode_LocalState = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
		$lamdera$codecs$Lamdera$Wire3$decodeInt),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeArray(
			$lamdera$codecs$Lamdera$Wire3$decodePair$(
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
				$author$project$Evergreen$V419$TextEditor$w3_unsafe_decode_EditChange)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
				$author$project$Evergreen$V419$Range$w3_unsafe_decode_Range),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (cursorPosition0, history0, undoPoint0) {
						return {cursorPosition: cursorPosition0, history: history0, undoPoint: undoPoint0};
					})))));
var $author$project$Evergreen$V419$User$w3_unsafe_decode_FrontendCurrentUser = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqSet$decodeSet(
		$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
			$author$project$Evergreen$V419$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
				$lamdera$codecs$Lamdera$Wire3$decodePair$(
					$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId),
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute),
				$author$project$Evergreen$V419$OneOrGreater$w3_unsafe_decode_OneOrGreater)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$X25519$w3_unsafe_decode_PublicKey),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqSet$decodeSet(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$PersonName$w3_unsafe_decode_PersonName,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_Model,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeBool,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeBool,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$containers$SeqDict$decodeDict$(
											$lamdera$codecs$Lamdera$Wire3$decodePair$(
												$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
												$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId)),
											$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId)),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$containers$SeqDict$decodeDict$(
												$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
												$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId)),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$containers$SeqDict$decodeDict$(
													$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
													$lamdera$codecs$Lamdera$Wire3$decodePair$(
														$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId),
														$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute)),
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Pagination$w3_unsafe_decode_PageId),
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$author$project$Evergreen$V419$User$w3_unsafe_decode_LastDmViewed,
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$lamdera$containers$SeqDict$decodeDict$(
																		$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
																		$lamdera$codecs$Lamdera$Wire3$decodePair$(
																			$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
																			$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute)),
																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																		$lamdera$containers$SeqDict$decodeDict$(
																			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
																			$lamdera$codecs$Lamdera$Wire3$decodePair$(
																				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId),
																				$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute)),
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$codecs$Lamdera$Wire3$decodeBool,
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash),
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiConfig,
																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																						$author$project$Evergreen$V419$User$w3_unsafe_decode_EmbedVisibility,
																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																							$author$project$Evergreen$V419$User$w3_unsafe_decode_EmailNotifications,
																							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																								$author$project$Evergreen$V419$EmailAddress$w3_unsafe_decode_EmailAddress,
																								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																									$lamdera$codecs$Lamdera$Wire3$decodeBool,
																									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																										$lamdera$containers$SeqSet$decodeSet($author$project$Evergreen$V419$RichText$w3_unsafe_decode_Domain),
																										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																											$lamdera$containers$SeqSet$decodeSet(
																												$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId)),
																											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																												$lamdera$containers$SeqDict$decodeDict$(
																													$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
																													$author$project$Evergreen$V419$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
																														$lamdera$codecs$Lamdera$Wire3$decodePair$(
																															$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
																															$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute),
																														$author$project$Evergreen$V419$OneOrGreater$w3_unsafe_decode_OneOrGreater)),
																												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																													$lamdera$containers$SeqDict$decodeDict$(
																														$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
																														$author$project$Evergreen$V419$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
																															$lamdera$codecs$Lamdera$Wire3$decodePair$(
																																$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId),
																																$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute),
																															$author$project$Evergreen$V419$OneOrGreater$w3_unsafe_decode_OneOrGreater)),
																													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																														$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
																														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																															$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
																															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																$author$project$Evergreen$V419$UserColor$w3_unsafe_decode_UserColor,
																																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																	$lamdera$containers$SeqSet$decodeSet(
																																		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_StickerId)),
																																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																		$lamdera$containers$SeqSet$decodeSet(
																																			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_CustomEmojiId)),
																																		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																																			function (availableCustomEmojis0) {
																																				return function (availableStickers0) {
																																					return function (color0) {
																																						return function (createdAt0) {
																																							return function (deleteAccountAt0) {
																																								return function (directMentions0) {
																																									return function (discordDirectMentions0) {
																																										return function (discordNotifyOnAllMessages0) {
																																											return function (domainWhitelist0) {
																																												return function (e2eeRisksAccepted0) {
																																													return function (email0) {
																																														return function (emailNotifications0) {
																																															return function (embedVisibility0) {
																																																return function (emojiConfig0) {
																																																	return function (icon0) {
																																																		return function (isAdmin0) {
																																																			return function (lastChannelViewed0) {
																																																				return function (lastDiscordChannelViewed0) {
																																																					return function (lastDmViewed0) {
																																																						return function (lastEmailNotification0) {
																																																							return function (lastLogPageViewed0) {
																																																								return function (lastPushNotification0) {
																																																									return function (lastSlackChannelViewed0) {
																																																										return function (lastViewedMessage0) {
																																																											return function (lastViewedThreadMessage0) {
																																																												return function (linkDiscordAcknowledgementIsChecked0) {
																																																													return function (linkSlackAcknowledgementIsChecked0) {
																																																														return function (muteSettings0) {
																																																															return function (name0) {
																																																																return function (notifyOnAllMessages0) {
																																																																	return function (publicKey0) {
																																																																		return function (recentLoginEmails0) {
																																																																			return function (slackDirectMentions0) {
																																																																				return function (slackNotifyOnAllMessages0) {
																																																																					return {availableCustomEmojis: availableCustomEmojis0, availableStickers: availableStickers0, color: color0, createdAt: createdAt0, deleteAccountAt: deleteAccountAt0, directMentions: directMentions0, discordDirectMentions: discordDirectMentions0, discordNotifyOnAllMessages: discordNotifyOnAllMessages0, domainWhitelist: domainWhitelist0, e2eeRisksAccepted: e2eeRisksAccepted0, email: email0, emailNotifications: emailNotifications0, embedVisibility: embedVisibility0, emojiConfig: emojiConfig0, icon: icon0, isAdmin: isAdmin0, lastChannelViewed: lastChannelViewed0, lastDiscordChannelViewed: lastDiscordChannelViewed0, lastDmViewed: lastDmViewed0, lastEmailNotification: lastEmailNotification0, lastLogPageViewed: lastLogPageViewed0, lastPushNotification: lastPushNotification0, lastSlackChannelViewed: lastSlackChannelViewed0, lastViewedMessage: lastViewedMessage0, lastViewedThreadMessage: lastViewedThreadMessage0, linkDiscordAcknowledgementIsChecked: linkDiscordAcknowledgementIsChecked0, linkSlackAcknowledgementIsChecked: linkSlackAcknowledgementIsChecked0, muteSettings: muteSettings0, name: name0, notifyOnAllMessages: notifyOnAllMessages0, publicKey: publicKey0, recentLoginEmails: recentLoginEmails0, slackDirectMentions: slackDirectMentions0, slackNotifyOnAllMessages: slackNotifyOnAllMessages0};
																																																																				};
																																																																			};
																																																																		};
																																																																	};
																																																																};
																																																															};
																																																														};
																																																													};
																																																												};
																																																											};
																																																										};
																																																									};
																																																								};
																																																							};
																																																						};
																																																					};
																																																				};
																																																			};
																																																		};
																																																	};
																																																};
																																															};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			})))))))))))))))))))))))))))))))))));
var $author$project$Evergreen$V419$LinkedAndOtherDiscordUsers$w3_unsafe_decode_LinkedAndOtherDiscordUsers = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
					$author$project$Evergreen$V419$LinkedAndOtherDiscordUsers$w3_unsafe_decode_DiscordFrontendCurrentUser),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
						$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_DiscordFrontendUser),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LinkedAndOtherDiscordUsers$LinkedAndOtherDiscordUsers)));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$User$w3_unsafe_decode_LocalUser = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$UserAgent$w3_unsafe_decode_UserAgent,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$User$w3_unsafe_decode_FrontendCurrentUser,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$program_test$Effect$Time$w3_unsafe_decode_Zone,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_StickerId),
					$author$project$Evergreen$V419$Sticker$w3_unsafe_decode_StickerData),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqSet$decodeSet(
						$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
							$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_SlackFrontendUser),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_UserSession,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeInt,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$containers$SeqDict$decodeDict$(
											$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
											$author$project$Evergreen$V419$User$w3_unsafe_decode_FrontendUser),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$containers$SeqDict$decodeDict$(
												$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
												$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId)),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Emoji$w3_unsafe_decode_CachedEmojiData),
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$author$project$Evergreen$V419$LinkedAndOtherDiscordUsers$w3_unsafe_decode_LinkedAndOtherDiscordUsers,
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$lamdera$codecs$Lamdera$Wire3$decodeFloat,
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$lamdera$containers$SeqDict$decodeDict$(
																$author$project$Evergreen$V419$Encryption$w3_unsafe_decode_BytesHash,
																$lamdera$codecs$Lamdera$Wire3$decodeResult$(
																	$lamdera$codecs$Lamdera$Wire3$decodeUnit,
																	$author$project$Evergreen$V419$Message$w3_unsafe_decode_MessageContent$(
																		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
																		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId)))),
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$lamdera$containers$SeqDict$decodeDict$(
																	$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_CustomEmojiId),
																	$author$project$Evergreen$V419$CustomEmoji$w3_unsafe_decode_CustomEmojiData),
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing,
																	$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																		function (currentlyViewing0) {
																			return function (customEmojis0) {
																				return function (decryptedMessages0) {
																					return function (devicePixelRatio0) {
																						return function (discordUsers0) {
																							return function (emojiData0) {
																								return function (linkedSlackUsers0) {
																									return function (otherUsers0) {
																										return function (safeAreaInsetBottom0) {
																											return function (safeAreaInsetTop0) {
																												return function (session0) {
																													return function (slackUsers0) {
																														return function (slackUsersNeedingAuth0) {
																															return function (stickers0) {
																																return function (timezone0) {
																																	return function (user0) {
																																		return function (userAgent0) {
																																			return {currentlyViewing: currentlyViewing0, customEmojis: customEmojis0, decryptedMessages: decryptedMessages0, devicePixelRatio: devicePixelRatio0, discordUsers: discordUsers0, emojiData: emojiData0, linkedSlackUsers: linkedSlackUsers0, otherUsers: otherUsers0, safeAreaInsetBottom: safeAreaInsetBottom0, safeAreaInsetTop: safeAreaInsetTop0, session: session0, slackUsers: slackUsers0, slackUsersNeedingAuth: slackUsersNeedingAuth0, stickers: stickers0, timezone: timezone0, user: user0, userAgent: userAgent0};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		}))))))))))))))))));
var $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_LocalState = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$TextEditor$w3_unsafe_decode_LocalState,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
			$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_SlackFrontendWorkspace),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_DmChannelId),
				$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_SlackFrontendDmChannel),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V419$SessionIdHash$w3_unsafe_decode_SessionIdHash, $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_FrontendUserSession),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$User$w3_unsafe_decode_LocalUser,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$LocalState$w3_unsafe_decode_JoinGuildError),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqDict$decodeDict$(
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
									$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_FrontendGuild),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$containers$SeqDict$decodeDict$(
										$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
										$author$project$Evergreen$V419$DmChannel$w3_unsafe_decode_FrontendDmChannel),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$containers$SeqDict$decodeDict$(
											$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
											$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_DiscordFrontendGuild),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$containers$SeqDict$decodeDict$(
												$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
												$author$project$Evergreen$V419$DmChannel$w3_unsafe_decode_DiscordFrontendDmChannel),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$author$project$Evergreen$V419$Call$w3_unsafe_decode_Local,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_AdminStatus,
													$lamdera$codecs$Lamdera$Wire3$succeedDecode(
														function (adminData0) {
															return function (calls0) {
																return function (discordDmChannels0) {
																	return function (discordGuilds0) {
																		return function (dmChannels0) {
																			return function (guilds0) {
																				return function (joinGuildError0) {
																					return function (localUser0) {
																						return function (otherSessions0) {
																							return function (publicVapidKey0) {
																								return function (slackDmChannels0) {
																									return function (slackWorkspaces0) {
																										return function (textEditor0) {
																											return {adminData: adminData0, calls: calls0, discordDmChannels: discordDmChannels0, discordGuilds: discordGuilds0, dmChannels: dmChannels0, guilds: guilds0, joinGuildError: joinGuildError0, localUser: localUser0, otherSessions: otherSessions0, publicVapidKey: publicVapidKey0, slackDmChannels: slackDmChannels0, slackWorkspaces: slackWorkspaces0, textEditor: textEditor0};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														}))))))))))))));
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_MessageHoverMobileMode = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Types$w3_unsafe_decode_EditMessage),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$ianmackenzie$elm_units$Quantity$w3_unsafe_decode_Quantity$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$MessageMenuClosing)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$ianmackenzie$elm_units$Quantity$w3_unsafe_decode_Quantity$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$ianmackenzie$elm_units$Quantity$w3_unsafe_decode_Quantity$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (offset0, previousOffset0, time0) {
											return {offset: offset0, previousOffset: previousOffset0, time: time0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$MessageMenuDragging));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$ianmackenzie$elm_units$Quantity$w3_unsafe_decode_Quantity$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$MessageMenuFixed));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$ianmackenzie$elm_units$Quantity$w3_unsafe_decode_Quantity$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$ianmackenzie$elm_units$Quantity$w3_unsafe_decode_Quantity$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (offset0, targetOffset0) {
										return {offset: offset0, targetOffset: targetOffset0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$MessageMenuOpening));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_MessageMenuExtraOptions = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$Types$w3_unsafe_decode_MessageHoverMobileMode,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F7(
									function (guildOrDmId0, imageUrl0, isThreadStarter0, linkUrl0, mobileMode0, position0, threadRoute0) {
										return {guildOrDmId: guildOrDmId0, imageUrl: imageUrl0, isThreadStarter: isThreadStarter0, linkUrl: linkUrl0, mobileMode: mobileMode0, position: position0, threadRoute: threadRoute0};
									})))))))));
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_MessageHover = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$MessageHover)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Types$w3_unsafe_decode_MessageMenuExtraOptions,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$MessageMenu));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$NoMessageHover);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$ReactionPopup))));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Call$w3_unsafe_decode_DebugRow = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (label0, value0) {
					return {label: label0, value: value0};
				}))));
var $author$project$Evergreen$V419$Call$w3_unsafe_decode_DebugSection = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V419$Call$w3_unsafe_decode_DebugRow),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (rows0, title0) {
					return {rows: rows0, title: title0};
				}))));
var $author$project$Evergreen$V419$IdString$w3_unsafe_decode_IdString = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V419$Call$w3_unsafe_decode_LocalOrConnection = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Call$w3_unsafe_decode_ConnectionId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$IsConnection));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$IsLocal);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Call$MediaDeviceId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Call$w3_unsafe_decode_MediaDeviceId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Call$w3_unsafe_decode_DeviceKind = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Call$w3_unsafe_decode_MediaDevice = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Call$w3_unsafe_decode_DeviceKind,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$IdString$w3_unsafe_decode_IdString($author$project$Evergreen$V419$Call$w3_unsafe_decode_MediaDeviceId),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (deviceId0, groupId0, kind0, label0) {
							return {deviceId: deviceId0, groupId: groupId0, kind: kind0, label: label0};
						}))))));
var $author$project$Evergreen$V419$Call$w3_unsafe_decode_MediaDevicesStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$FailedToGetMediaDevices));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V419$Call$w3_unsafe_decode_MediaDevice),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$HasMediaDevices));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$MediaDevicesNotLoaded);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Call$w3_unsafe_decode_VideoTile = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Call$w3_unsafe_decode_LocalOrConnection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$CameraTile));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Call$w3_unsafe_decode_LocalOrConnection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$ScreenShareTile));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Call$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$lamdera$codecs$Lamdera$Wire3$decodePair$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
			$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId),
		$lamdera$codecs$Lamdera$Wire3$decodeFloat),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Call$w3_unsafe_decode_LocalOrConnection),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$Call$w3_unsafe_decode_MediaDevicesStatus,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $lamdera$codecs$Lamdera$Wire3$decodeFloat),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
								$author$project$Evergreen$V419$IdString$w3_unsafe_decode_IdString($author$project$Evergreen$V419$Call$w3_unsafe_decode_MediaDeviceId)),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
									$author$project$Evergreen$V419$IdString$w3_unsafe_decode_IdString($author$project$Evergreen$V419$Call$w3_unsafe_decode_MediaDeviceId)),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Call$w3_unsafe_decode_RemoteCallData,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeInt,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$codecs$Lamdera$Wire3$decodeInt,
													$lamdera$codecs$Lamdera$Wire3$succeedDecode(
														F2(
															function (total0, uploaded0) {
																return {total: total0, uploaded: uploaded0};
															}))))),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeBool,
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeBool,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$containers$SeqSet$decodeSet($author$project$Evergreen$V419$Call$w3_unsafe_decode_ConnectionId),
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Call$w3_unsafe_decode_VideoTile),
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V419$Call$w3_unsafe_decode_DebugSection),
															$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																function (debugData0) {
																	return function (focusedTile0) {
																		return function (isSpeaking0) {
																			return function (localIsSpeaking0) {
																				return function (pollDebugData0) {
																					return function (recordingUpload0) {
																						return function (remoteCallData0) {
																							return function (selectedAudioInputDevice0) {
																								return function (selectedVideoInputDevice0) {
																									return function (showDeviceSettings0) {
																										return function (startConnectionError0) {
																											return function (thumbnailPosition0) {
																												return function (userMediaDevices0) {
																													return function (videoHover0) {
																														return function (volume0) {
																															return {debugData: debugData0, focusedTile: focusedTile0, isSpeaking: isSpeaking0, localIsSpeaking: localIsSpeaking0, pollDebugData: pollDebugData0, recordingUpload: recordingUpload0, remoteCallData: remoteCallData0, selectedAudioInputDevice: selectedAudioInputDevice0, selectedVideoInputDevice: selectedVideoInputDevice0, showDeviceSettings: showDeviceSettings0, startConnectionError: startConnectionError0, thumbnailPosition: thumbnailPosition0, userMediaDevices: userMediaDevices0, videoHover: videoHover0, volume: volume0};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																}))))))))))))))));
var $author$project$Evergreen$V419$Drawing$w3_unsafe_decode_ActiveStroke = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeList(
		$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V419$SafeFloat$w3_unsafe_decode_SafeFloat, $author$project$Evergreen$V419$SafeFloat$w3_unsafe_decode_SafeFloat)),
	$lamdera$codecs$Lamdera$Wire3$succeedDecode(
		function (unsent0) {
			return {unsent: unsent0};
		}));
var $author$project$Evergreen$V419$Drawing$w3_unsafe_decode_SelectedAnchorData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeFloat,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeFloat,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F4(
								function (height0, width0, x0, y0) {
									return {height: height0, width: width0, x: x0, y: y0};
								}))))))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeFloat,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Drawing$w3_unsafe_decode_ActiveStroke),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$Point2d$w3_unsafe_decode_Point2d$($author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels, $author$project$Evergreen$V419$Touch$w3_unsafe_decode_ScreenCoordinate),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Drawing$w3_unsafe_decode_AnchorType,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $lamdera$codecs$Lamdera$Wire3$decodeFloat),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F8(
										function (anchorHalfSize0, anchorType0, guildOrDmId0, pointScale0, position0, stroke0, zoom0, zoomContainer0) {
											return {anchorHalfSize: anchorHalfSize0, anchorType: anchorType0, guildOrDmId: guildOrDmId0, pointScale: pointScale0, position: position0, stroke: stroke0, zoom: zoom0, zoomContainer: zoomContainer0};
										}))))))))));
var $author$project$Evergreen$V419$Drawing$w3_unsafe_decode_Model = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Drawing$NoSelectedAnchor);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Drawing$w3_unsafe_decode_SelectedAnchorData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Drawing$SelectedAnchor));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Emoji$w3_unsafe_decode_Category = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Emoji$CustomEmojiCategory);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiCategory,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Emoji$EmojiCategory));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Emoji$StickerCategory);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrSticker = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_CustomEmojiId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Emoji$EmojiOrSticker_CustomEmoji));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_StickerId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Emoji$EmojiOrSticker_Sticker));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_UnicodeEmoji,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Emoji$EmojiOrSticker_UnicodeEmoji));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Emoji$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrSticker,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F2(
							function (emoji0, index0) {
								return {emoji: emoji0, index: index0};
							}))))),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_Category,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (category0, emojiHovered0, searchText0) {
						return {category: category0, emojiHovered: emojiHovered0, searchText: searchText0};
					})))));
var $author$project$Evergreen$V419$Scroll$w3_unsafe_decode_ScrollPosition = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_UnvalidatedInput = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
			$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileStatus),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (attachedFiles0, text0) {
					return {attachedFiles: attachedFiles0, text: text0};
				}))));
var $author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_GameData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Scroll$w3_unsafe_decode_ScrollPosition,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$IdArray$w3_unsafe_decode_IdArray$($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId, $author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_UnvalidatedInput),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeBool,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_ReactionTarget),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
								$lamdera$codecs$Lamdera$Wire3$decodePair$(
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId))),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$IdArray$w3_unsafe_decode_IdArray$($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId, $author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_UnvalidatedInput),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F8(
										function (answerDrafts0, gridHovered0, hoveredQuestion0, hoveredResult0, newQuestionRevealed0, noteDrafts0, questionsRevealedSeen0, scrollPosition0) {
											return {answerDrafts: answerDrafts0, gridHovered: gridHovered0, hoveredQuestion: hoveredQuestion0, hoveredResult: hoveredResult0, newQuestionRevealed: newQuestionRevealed0, noteDrafts: noteDrafts0, questionsRevealedSeen: questionsRevealedSeen0, scrollPosition: scrollPosition0};
										}))))))))));
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_Drag = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$Dragging));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$NotDragging);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_HoveredMove = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_Shared,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeDict$(
				$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
				$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (cells0, index0, shared0) {
						return {cells: cells0, index: index0, shared: shared0};
					})))));
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_TrayIndex = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_TilePosition = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix, $lamdera$codecs$Lamdera$Wire3$decodeInt)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_TrayIndex,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$TileInTray)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$TileOnBoard)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_Tile = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_TilePosition,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (createdAt0, position0) {
					return {createdAt: createdAt0, position: position0};
				}))));
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_OpenWordDefinition = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty($lamdera$codecs$Lamdera$Wire3$decodeString),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (index0, words0) {
					return {index: index0, words: words0};
				}))));
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_DictEntry = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeString),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (definitions0, partOfSpeech0) {
					return {definitions: definitions0, partOfSpeech: partOfSpeech0};
				}))));
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_WordDefinitionData = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$WordDefinition_Failed);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_DictEntry),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$WordDefinition_Loaded));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$WordDefinition_Loading);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$WordDefinition_NotFound);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$WordDefinition_SwedishUnsupported);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_WordDefinition = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$WordDefinition_None);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_WordDefinitionData,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_OpenWordDefinition,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$WordDefinition_Open)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_ZoomState = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeFloat,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeFloat,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeFloat,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (amount0, focusX0, focusY0) {
						return {amount: amount0, focusX: focusX0, focusY: focusY0};
					})))));
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_ZoomAnimation = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_ZoomState,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (from0, start0) {
					return {from: from0, start: start0};
				}))));
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_GameData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_ZoomAnimation,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_WordDefinition,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_Tile),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeBool,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Scroll$w3_unsafe_decode_ScrollPosition,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeInt,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											F2(
												function (letterCount0, time0) {
													return {letterCount: letterCount0, time: time0};
												}))))),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_HoveredMove),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
										$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId)),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_Drag,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											function (dragging0) {
												return function (highlightedPlayer0) {
													return function (hoveredMove0) {
														return function (lastWordPlaced0) {
															return function (scrollPosition0) {
																return function (selectedCell0) {
																	return function (showSettings0) {
																		return function (tiles0) {
																			return function (wordDefinition0) {
																				return function (zoomAnimation0) {
																					return {dragging: dragging0, highlightedPlayer: highlightedPlayer0, hoveredMove: hoveredMove0, lastWordPlaced: lastWordPlaced0, scrollPosition: scrollPosition0, selectedCell: selectedCell0, showSettings: showSettings0, tiles: tiles0, wordDefinition: wordDefinition0, zoomAnimation: zoomAnimation0};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											})))))))))));
var $author$project$Evergreen$V419$Go$w3_unsafe_decode_GameModel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (lastError0, lastPlacedStone0, viewingMovesBack0) {
						return {lastError: lastError0, lastPlacedStone: lastPlacedStone0, viewingMovesBack: viewingMovesBack0};
					})))));
var $author$project$Evergreen$V419$Game$w3_unsafe_decode_Game = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Go$w3_unsafe_decode_GameModel,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$GoModel_Game));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_GameData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$SheepGame_Game));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_GameData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$WordSpellingGame_Game));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Go$w3_unsafe_decode_SizeSelection = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Go$w3_unsafe_decode_SetupModel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Go$w3_unsafe_decode_SizeSelection,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeString,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Go$w3_unsafe_decode_Stone,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F9(
											function (error0, gameCreatorPlayingAs0, handicapInput0, heightInput0, incrementInput0, komiInput0, mainTimeInput0, sizeSelection0, widthInput0) {
												return {error: error0, gameCreatorPlayingAs: gameCreatorPlayingAs0, handicapInput: handicapInput0, heightInput: heightInput0, incrementInput: incrementInput0, komiInput: komiInput0, mainTimeInput: mainTimeInput0, sizeSelection: sizeSelection0, widthInput: widthInput0};
											})))))))))));
var $author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_SetupModel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$IdArray$w3_unsafe_decode_IdArray$($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId, $author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_UnvalidatedInput),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (error0, pressedSubmit0, questions0) {
						return {error: error0, pressedSubmit: pressedSubmit0, questions: questions0};
					})))));
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_SetupModel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$OneOrGreater$w3_unsafe_decode_OneOrGreater,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$($lamdera$codecs$Lamdera$Wire3$decodeChar, $lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_Language,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeString,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeBool,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											function (advancedSettingsExpanded0) {
												return function (error0) {
													return function (fullTrayBonus0) {
														return function (incrementInput0) {
															return function (language0) {
																return function (letterValues0) {
																	return function (letters0) {
																		return function (mainTimeInput0) {
																			return function (placeWordAttempts0) {
																				return function (traySize0) {
																					return {advancedSettingsExpanded: advancedSettingsExpanded0, error: error0, fullTrayBonus: fullTrayBonus0, incrementInput: incrementInput0, language: language0, letterValues: letterValues0, letters: letters0, mainTimeInput: mainTimeInput0, placeWordAttempts: placeWordAttempts0, traySize: traySize0};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											})))))))))));
var $author$project$Evergreen$V419$Game$w3_unsafe_decode_Setup = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$GameSelect);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Go$w3_unsafe_decode_SetupModel,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$GoModel_Setup));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_SetupModel,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$SheepGame_Setup));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_SetupModel,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$WordSpellingGame_Setup));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Game$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
		$author$project$Evergreen$V419$Game$w3_unsafe_decode_Game),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$lamdera$codecs$Lamdera$Wire3$decodePair$(
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
				$author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_Input),
			$lamdera$codecs$Lamdera$Wire3$decodeInt),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$Game$w3_unsafe_decode_Setup,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (setup0, sheepGameQuestionsCounter0, sheepGameSaveCounters0, startedGames0) {
							return {setup: setup0, sheepGameQuestionsCounter: sheepGameQuestionsCounter0, sheepGameSaveCounters: sheepGameSaveCounters0, startedGames: startedGames0};
						}))))));
var $author$project$Evergreen$V419$ImageEditor$w3_unsafe_decode_DragPart = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$ImageEditor$w3_unsafe_decode_DragState = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeFloat,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeFloat,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$ImageEditor$w3_unsafe_decode_DragPart,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeFloat,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (currentX0, currentY0, dragPart0, startX0, startY0) {
								return {currentX: currentX0, currentY: currentY0, dragPart: dragPart0, startX: startX0, startY: startY0};
							})))))));
var $author$project$Evergreen$V419$ImageEditor$w3_unsafe_decode_UploadStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageEditor$Cropping);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageEditor$NotUploaded);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageEditor$Uploading));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageEditor$UploadingError);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$ImageEditor$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeFloat,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeFloat,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$ImageEditor$w3_unsafe_decode_UploadStatus,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeFloat,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$ImageEditor$w3_unsafe_decode_DragState),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F7(
									function (dragState0, imageSize0, imageUrl0, size0, status0, x0, y0) {
										return {dragState: dragState0, imageSize: imageSize0, imageUrl: imageUrl0, size: size0, status: status0, x: x0, y: y0};
									})))))))));
var $author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_AdminUiSection = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(10);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(12);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(9);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(11);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(13);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(8);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(17);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(15);
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(14);
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(16);
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(18);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_DownloadingBackup = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeBytes),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (chunks0, receivedBytes0, totalBytes0) {
						return {chunks: chunks0, receivedBytes: receivedBytes0, totalBytes: totalBytes0};
					})))));
var $author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_ExportProgress = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$ExportStarting);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (encoded0, total0) {
										return {encoded: encoded0, total: total0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$ExportingDiscordDmChannels));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (channelsRemaining0, encoded0, total0) {
											return {channelsRemaining: channelsRemaining0, encoded: encoded0, total: total0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$ExportingDiscordGuilds));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (encoded0, total0) {
										return {encoded: encoded0, total: total0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$ExportingDmChannels));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (channelsRemaining0, encoded0, total0) {
											return {channelsRemaining: channelsRemaining0, encoded: encoded0, total: total0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$ExportingGuilds));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_ExportSubsetSelection = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqSet$decodeSet(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqSet$decodeSet($author$project$Evergreen$V419$DmChannelId$w3_unsafe_decode_DmChannelId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqSet$decodeSet(
				$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqSet$decodeSet(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId)),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (discordDmChannels0, discordGuilds0, dmChannels0, guilds0) {
							return {discordDmChannels: discordDmChannels0, discordGuilds: discordGuilds0, dmChannels: dmChannels0, guilds: guilds0};
						}))))));
var $author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_ImportBackendStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$ImportBackendFailed);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$ImportedBackendSuccessfully);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeBytes,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (remainingBytes0, sentBytes0, totalBytes0) {
											return {remainingBytes: remainingBytes0, sentBytes: sentBytes0, totalBytes: totalBytes0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$ImportingBackend));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$NotImportingBackend);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Pagination$ItemId = $elm$core$Basics$identity;
var $author$project$Evergreen$V419$Pagination$w3_unsafe_decode_ItemId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Editable$w3_unsafe_decode_Editing = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Editable$Editing));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Editable$NotEditing);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Editable$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$Editable$w3_unsafe_decode_Editing,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (editing0, pressedSubmit0, showSecret0) {
						return {editing: editing0, pressedSubmit: pressedSubmit0, showSecret: showSecret0};
					})))));
var $author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_UserColumn = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_UserTableId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$ExistingUserId));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$NewUserId));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_EditingCell = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_UserTableId,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_UserColumn,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (column0, text0, userId0) {
						return {column: column0, text: text0, userId: userId0};
					})))));
var $author$project$Evergreen$V419$Table$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeBool,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (ascendingOrder0, columnToSortBy0, showAll0) {
						return {ascendingOrder: ascendingOrder0, columnToSortBy: columnToSortBy0, showAll: showAll0};
					})))));
var $author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_UserTable = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Table$w3_unsafe_decode_Model,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_EditedBackendUser),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_EditingCell),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqSet$decodeSet(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId)),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
						$author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_EditedBackendUser),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (changedUsers0, deletedUsers0, editingCell0, newUsers0, table0) {
								return {changedUsers: changedUsers0, deletedUsers: deletedUsers0, editingCell: editingCell0, newUsers: newUsers0, table: table0};
							})))))));
var $author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_UsersChangeError = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$CantDeleteYourself);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$CantRemoveAdminRoleFromYourself);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$ChangesAppliedToNonExistentUser));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$EmailAddressesAreNotUnique);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$InvalidChangesToUser);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$InvalidNewUser);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_UserTable,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_UsersChangeError),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$Editable$w3_unsafe_decode_Model,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Editable$w3_unsafe_decode_Model,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Editable$w3_unsafe_decode_Model,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Editable$w3_unsafe_decode_Model,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Editable$w3_unsafe_decode_Model,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Editable$w3_unsafe_decode_Model,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V419$Editable$w3_unsafe_decode_Model,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_ImportBackendStatus,
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
													$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Pagination$w3_unsafe_decode_ItemId)),
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_ExportSubsetSelection),
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_ExportProgress),
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$lamdera$containers$SeqSet$decodeSet(
																$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId)),
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$lamdera$containers$SeqSet$decodeSet($author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_AdminUiSection),
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$lamdera$containers$SeqSet$decodeSet(
																		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId)),
																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																		$lamdera$containers$SeqSet$decodeSet(
																			$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId)),
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_DownloadingBackup),
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$author$project$Evergreen$V419$Editable$w3_unsafe_decode_Model,
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
																						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Pagination$w3_unsafe_decode_ItemId)),
																					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																						function (copiedLogLink0) {
																							return function (discordLinkLimit0) {
																								return function (downloadingBackup0) {
																									return function (expandedDiscordGuilds0) {
																										return function (expandedGuilds0) {
																											return function (expandedSections0) {
																												return function (expandedSlackWorkspaces0) {
																													return function (exportProgress0) {
																														return function (exportSubsetSelection0) {
																															return function (highlightLog0) {
																																return function (importBackendStatus0) {
																																	return function (notifyAdminsBotUserId0) {
																																		return function (notifyAdminsToken0) {
																																			return function (openRouterKey0) {
																																				return function (postmarkKey0) {
																																					return function (privateVapidKey0) {
																																						return function (publicVapidKey0) {
																																							return function (slackLinkLimit0) {
																																								return function (submitError0) {
																																									return function (userTable0) {
																																										return function (websocketCloseEventsPage0) {
																																											return {copiedLogLink: copiedLogLink0, discordLinkLimit: discordLinkLimit0, downloadingBackup: downloadingBackup0, expandedDiscordGuilds: expandedDiscordGuilds0, expandedGuilds: expandedGuilds0, expandedSections: expandedSections0, expandedSlackWorkspaces: expandedSlackWorkspaces0, exportProgress: exportProgress0, exportSubsetSelection: exportSubsetSelection0, highlightLog: highlightLog0, importBackendStatus: importBackendStatus0, notifyAdminsBotUserId: notifyAdminsBotUserId0, notifyAdminsToken: notifyAdminsToken0, openRouterKey: openRouterKey0, postmarkKey: postmarkKey0, privateVapidKey: privateVapidKey0, publicVapidKey: publicVapidKey0, slackLinkLimit: slackLinkLimit0, submitError: submitError0, userTable: userTable0, websocketCloseEventsPage: websocketCloseEventsPage0};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						}))))))))))))))))))))));
var $author$project$Evergreen$V419$TextEditor$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$succeedDecode(
	{});
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_NewChannelForm = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (description0, name0, pressedSubmit0) {
						return {description: description0, name: name0, pressedSubmit: pressedSubmit0};
					})))));
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_NewGuildForm = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (name0, pressedSubmit0) {
					return {name: name0, pressedSubmit: pressedSubmit0};
				}))));
var $author$project$Evergreen$V419$X25519$w3_unsafe_decode_PrivateKey = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$X25519$w3_unsafe_decode_Key,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_RevealedSpoilers = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId),
			$author$project$Evergreen$V419$NonemptySet$w3_unsafe_decode_NonemptySet($lamdera$codecs$Lamdera$Wire3$decodeInt))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
			$author$project$Evergreen$V419$NonemptySet$w3_unsafe_decode_NonemptySet($lamdera$codecs$Lamdera$Wire3$decodeInt)),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (messages0, threadMessages0) {
					return {messages: messages0, threadMessages: threadMessages0};
				}))));
var $author$project$Evergreen$V419$MessageInput$w3_unsafe_decode_MentionUserDropdown = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeFloat,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeFloat,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeFloat,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F4(
							function (height0, width0, x0, y0) {
								return {height: height0, width: width0, x: x0, y: y0};
							})))))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (dropdownIndex0, inputElement0) {
					return {dropdownIndex: dropdownIndex0, inputElement: inputElement0};
				}))));
var $author$project$Evergreen$V419$Range$w3_unsafe_decode_SelectionDirection = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$MessageInput$w3_unsafe_decode_TextInputFocus = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Range$w3_unsafe_decode_Range,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_HtmlId,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$MessageInput$w3_unsafe_decode_MentionUserDropdown),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$Range$w3_unsafe_decode_SelectionDirection,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (direction0, dropdown0, htmlId0, selection0) {
							return {direction: direction0, dropdown: dropdown0, htmlId: htmlId0, selection: selection0};
						}))))));
var $author$project$Evergreen$V419$LoginForm$w3_unsafe_decode_CodeStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$TwoFactorAuthentication$w3_unsafe_decode_TwoFactorDisableData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$Evergreen$V419$LoginForm$w3_unsafe_decode_CodeStatus),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (attempts0, code0) {
					return {attempts: attempts0, code: code0};
				}))));
var $author$project$Evergreen$V419$TwoFactorAuthentication$w3_unsafe_decode_TwoFactorSetupData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$Evergreen$V419$LoginForm$w3_unsafe_decode_CodeStatus),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (attempts0, code0, qrCodeUrl0) {
						return {attempts: attempts0, code: code0, qrCodeUrl: qrCodeUrl0};
					})))));
var $author$project$Evergreen$V419$TwoFactorAuthentication$w3_unsafe_decode_TwoFactorState = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$TwoFactorAuthentication$TwoFactorAlreadyComplete));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$TwoFactorAuthentication$TwoFactorComplete);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$TwoFactorAuthentication$w3_unsafe_decode_TwoFactorDisableData,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$TwoFactorAuthentication$TwoFactorDisable)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$TwoFactorAuthentication$TwoFactorLoading);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$TwoFactorAuthentication$TwoFactorNotStarted);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$TwoFactorAuthentication$w3_unsafe_decode_TwoFactorSetupData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$TwoFactorAuthentication$TwoFactorSetup));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_E2eeKeysValid = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$E2eeKeys_Error));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$E2eeKeys_NotChecked);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$E2eeKeys_Valid);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_LinkSlackWorkspaceError = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$SlackLinkLimitReached);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Slack$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$SlackWorkspaceHttpError));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_LinkSlackResult = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
						$lamdera$codecs$Lamdera$Wire3$decodeResult$($author$project$Evergreen$V419$Types$w3_unsafe_decode_LinkSlackWorkspaceError, $lamdera$codecs$Lamdera$Wire3$decodeString)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$LoadedSlackWorkspaces));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$SlackLinkingDisabled);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$UserColor$w3_unsafe_decode_Selection = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F3(
						function (hue0, lightness0, saturation0) {
							return {hue: hue0, lightness: lightness0, saturation: saturation0};
						}))))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$UserColor$w3_unsafe_decode_UserColor,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (lastValid0, selected0) {
					return {lastValid: lastValid0, selected: selected0};
				}))));
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_UserOptionsModel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqSet$decodeSet(
				$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Editable$w3_unsafe_decode_Model,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Types$w3_unsafe_decode_LinkSlackResult),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Types$w3_unsafe_decode_E2eeKeysValid,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeString,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$codecs$Lamdera$Wire3$decodeString,
													$lamdera$codecs$Lamdera$Wire3$succeedDecode(
														F2(
															function (data0, loadedAt0) {
																return {data: data0, loadedAt: loadedAt0};
															}))))),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$UserColor$w3_unsafe_decode_Selection),
											$lamdera$codecs$Lamdera$Wire3$succeedDecode(
												function (color0) {
													return function (debugData0) {
														return function (domainWhitelistInput0) {
															return function (e2eeKeysValid0) {
																return function (linkSlackResult0) {
																	return function (name0) {
																		return function (pressedSubmitSlackData0) {
																			return function (privateKeyText0) {
																				return function (removedSlackTeams0) {
																					return function (slackCookie0) {
																						return function (slackTeamsJson0) {
																							return {color: color0, debugData: debugData0, domainWhitelistInput: domainWhitelistInput0, e2eeKeysValid: e2eeKeysValid0, linkSlackResult: linkSlackResult0, name: name0, pressedSubmitSlackData: pressedSubmitSlackData0, privateKeyText: privateKeyText0, removedSlackTeams: removedSlackTeams0, slackCookie: slackCookie0, slackTeamsJson: slackTeamsJson0};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												}))))))))))));
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_LoggedIn2 = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Call$w3_unsafe_decode_Model,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Types$w3_unsafe_decode_UserOptionsModel),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeBool,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$TwoFactorAuthentication$w3_unsafe_decode_TwoFactorState,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$MessageInput$w3_unsafe_decode_TextInputFocus),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$TextEditor$w3_unsafe_decode_Model,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Route$w3_unsafe_decode_ChannelSidebarMode,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$X25519$w3_unsafe_decode_PrivateKey),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
											$author$project$Evergreen$V419$SecretId$w3_unsafe_decode_SecretId($author$project$Evergreen$V419$Id$w3_unsafe_decode_InviteLinkId)),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileDataWithImage),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$author$project$Evergreen$V419$Types$w3_unsafe_decode_EmojiSelector,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$codecs$Lamdera$Wire3$decodeInt,
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$lamdera$codecs$Lamdera$Wire3$decodeString,
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V419$Types$w3_unsafe_decode_RevealedSpoilers),
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$lamdera$containers$SeqDict$decodeDict$(
																	$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute),
																	$author$project$Evergreen$V419$Message$w3_unsafe_decode_RepliedTo($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId)),
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$author$project$Evergreen$V419$ImageEditor$w3_unsafe_decode_Model,
																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$MessageInput$w3_unsafe_decode_TextInputFocus),
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$codecs$Lamdera$Wire3$decodeInt,
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Types$w3_unsafe_decode_NewGuildForm),
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$lamdera$containers$SeqDict$decodeDict$(
																						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
																						$author$project$Evergreen$V419$Types$w3_unsafe_decode_NewChannelForm),
																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																						$author$project$Evergreen$V419$Types$w3_unsafe_decode_MessageHover,
																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																							$author$project$Evergreen$V419$Local$w3_unsafe_decode_Local$($author$project$Evergreen$V419$Types$w3_unsafe_decode_LocalMsg, $author$project$Evergreen$V419$LocalState$w3_unsafe_decode_LocalState),
																							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																								$lamdera$codecs$Lamdera$Wire3$decodeBool,
																								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																									$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
																										$lamdera$codecs$Lamdera$Wire3$decodePair$(
																											$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
																											$author$project$Evergreen$V419$ImageEditor$w3_unsafe_decode_Model)),
																									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																										$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildOrDmId, $author$project$Evergreen$V419$Game$w3_unsafe_decode_Model),
																										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																											$lamdera$containers$SeqDict$decodeDict$(
																												$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute),
																												$author$project$Evergreen$V419$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
																													$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
																													$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileStatus)),
																											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																												$author$project$Evergreen$V419$Types$w3_unsafe_decode_FileDrag,
																												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																													$lamdera$codecs$Lamdera$Wire3$decodeMaybe($elm$url$Url$w3_unsafe_decode_Url),
																													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																														$author$project$Evergreen$V419$Types$w3_unsafe_decode_EncryptionRequests,
																														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																															$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_Model,
																															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																$lamdera$containers$SeqDict$decodeDict$(
																																	$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute),
																																	$author$project$Evergreen$V419$Types$w3_unsafe_decode_EditMessage),
																																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																	$lamdera$containers$SeqDict$decodeDict$(
																																		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
																																		$author$project$Evergreen$V419$Types$w3_unsafe_decode_EditGuildForm),
																																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																		$lamdera$containers$SeqDict$decodeDict$(
																																			$lamdera$codecs$Lamdera$Wire3$decodePair$(
																																				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
																																				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId)),
																																			$author$project$Evergreen$V419$Types$w3_unsafe_decode_EditChannelForm),
																																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																			$lamdera$containers$SeqDict$decodeDict$(
																																				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
																																				$lamdera$codecs$Lamdera$Wire3$decodeBool),
																																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																				$lamdera$codecs$Lamdera$Wire3$decodeString,
																																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																					$lamdera$containers$SeqSet$decodeSet(
																																						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId)),
																																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
																																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																							$author$project$Evergreen$V419$Drawing$w3_unsafe_decode_Model,
																																							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																								$lamdera$containers$SeqDict$decodeDict$(
																																									$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute),
																																									$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString),
																																								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																									$author$project$Evergreen$V419$Scroll$w3_unsafe_decode_ScrollPosition,
																																									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																										$author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_Model,
																																										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																											$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																											$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																																												function (accountDeletionBannerClosed0) {
																																													return function (admin0) {
																																														return function (channelScrollPosition0) {
																																															return function (drafts0) {
																																																return function (drawingMode0) {
																																																	return function (e2eeError0) {
																																																		return function (e2eeKeysOnThisDevice0) {
																																																			return function (e2eePrivateKeyText0) {
																																																				return function (e2eeSectionsExpanded0) {
																																																					return function (editChannelForm0) {
																																																						return function (editGuildForm0) {
																																																							return function (editMessage0) {
																																																								return function (emojiSelector0) {
																																																									return function (encryptionRequests0) {
																																																										return function (externalLinkWarning0) {
																																																											return function (fileDragOverCount0) {
																																																												return function (filesToUpload0) {
																																																													return function (games0) {
																																																														return function (guildIconEditor0) {
																																																															return function (isReloading0) {
																																																																return function (localState0) {
																																																																	return function (messageHover0) {
																																																																		return function (newChannelForm0) {
																																																																			return function (newGuildForm0) {
																																																																				return function (newMessagesWhileNotScrolledToBottom0) {
																																																																					return function (previousTextInputFocus0) {
																																																																						return function (profilePictureEditor0) {
																																																																							return function (replyTo0) {
																																																																								return function (revealedSpoilers0) {
																																																																									return function (searchOverlayQuery0) {
																																																																										return function (searchOverlaySelection0) {
																																																																											return function (showEmojiSelector0) {
																																																																												return function (showFileToUploadInfo0) {
																																																																													return function (showInviteLinkQrCode0) {
																																																																														return function (showNewPrivateKey0) {
																																																																															return function (sidebarMode0) {
																																																																																return function (textEditor0) {
																																																																																	return function (textInputFocus0) {
																																																																																		return function (twoFactor0) {
																																																																																			return function (typedTextCounter0) {
																																																																																				return function (typingDebouncer0) {
																																																																																					return function (userOptions0) {
																																																																																						return function (voiceChat0) {
																																																																																							return {accountDeletionBannerClosed: accountDeletionBannerClosed0, admin: admin0, channelScrollPosition: channelScrollPosition0, drafts: drafts0, drawingMode: drawingMode0, e2eeError: e2eeError0, e2eeKeysOnThisDevice: e2eeKeysOnThisDevice0, e2eePrivateKeyText: e2eePrivateKeyText0, e2eeSectionsExpanded: e2eeSectionsExpanded0, editChannelForm: editChannelForm0, editGuildForm: editGuildForm0, editMessage: editMessage0, emojiSelector: emojiSelector0, encryptionRequests: encryptionRequests0, externalLinkWarning: externalLinkWarning0, fileDragOverCount: fileDragOverCount0, filesToUpload: filesToUpload0, games: games0, guildIconEditor: guildIconEditor0, isReloading: isReloading0, localState: localState0, messageHover: messageHover0, newChannelForm: newChannelForm0, newGuildForm: newGuildForm0, newMessagesWhileNotScrolledToBottom: newMessagesWhileNotScrolledToBottom0, previousTextInputFocus: previousTextInputFocus0, profilePictureEditor: profilePictureEditor0, replyTo: replyTo0, revealedSpoilers: revealedSpoilers0, searchOverlayQuery: searchOverlayQuery0, searchOverlaySelection: searchOverlaySelection0, showEmojiSelector: showEmojiSelector0, showFileToUploadInfo: showFileToUploadInfo0, showInviteLinkQrCode: showInviteLinkQrCode0, showNewPrivateKey: showNewPrivateKey0, sidebarMode: sidebarMode0, textEditor: textEditor0, textInputFocus: textInputFocus0, twoFactor: twoFactor0, typedTextCounter: typedTextCounter0, typingDebouncer: typingDebouncer0, userOptions: userOptions0, voiceChat: voiceChat0};
																																																																																						};
																																																																																					};
																																																																																				};
																																																																																			};
																																																																																		};
																																																																																	};
																																																																																};
																																																																															};
																																																																														};
																																																																													};
																																																																												};
																																																																											};
																																																																										};
																																																																									};
																																																																								};
																																																																							};
																																																																						};
																																																																					};
																																																																				};
																																																																			};
																																																																		};
																																																																	};
																																																																};
																																																															};
																																																														};
																																																													};
																																																												};
																																																											};
																																																										};
																																																									};
																																																								};
																																																							};
																																																						};
																																																					};
																																																				};
																																																			};
																																																		};
																																																	};
																																																};
																																															};
																																														};
																																													};
																																												}))))))))))))))))))))))))))))))))))))))))))));
var $author$project$Evergreen$V419$LoginForm$w3_unsafe_decode_EnterEmail2 = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeBool,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeBool,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (email0, pressedSubmitEmail0, rateLimited0, showSignupsDisabled0, showUserIsDeleted0) {
								return {email: email0, pressedSubmitEmail: pressedSubmitEmail0, rateLimited: rateLimited0, showSignupsDisabled: showSignupsDisabled0, showUserIsDeleted: showUserIsDeleted0};
							})))))));
var $author$project$Evergreen$V419$LoginForm$w3_unsafe_decode_EnterLoginCode2 = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$EmailAddress$w3_unsafe_decode_EmailAddress,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$Evergreen$V419$LoginForm$w3_unsafe_decode_CodeStatus),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (attempts0, code0, sentTo0) {
						return {attempts: attempts0, code: code0, sentTo: sentTo0};
					})))));
var $author$project$Evergreen$V419$LoginForm$w3_unsafe_decode_EnterTwoFactorCode2 = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$Evergreen$V419$LoginForm$w3_unsafe_decode_CodeStatus),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (attemptCount0, attempts0, code0) {
						return {attemptCount: attemptCount0, attempts: attempts0, code: code0};
					})))));
var $author$project$Evergreen$V419$LoginForm$w3_unsafe_decode_SubmitStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LoginForm$NotSubmitted));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LoginForm$Submitting);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$LoginForm$w3_unsafe_decode_EnterUserData2 = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$LoginForm$w3_unsafe_decode_SubmitStatus,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (name0, pressedSubmit0) {
					return {name: name0, pressedSubmit: pressedSubmit0};
				}))));
var $author$project$Evergreen$V419$LoginForm$w3_unsafe_decode_LoginForm = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$LoginForm$w3_unsafe_decode_EnterEmail2,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LoginForm$EnterEmail));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$LoginForm$w3_unsafe_decode_EnterLoginCode2,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LoginForm$EnterLoginCode));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$LoginForm$w3_unsafe_decode_EnterTwoFactorCode2,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LoginForm$EnterTwoFactorCode));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$LoginForm$w3_unsafe_decode_EnterUserData2,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LoginForm$EnterUserData));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$RecoveryLogin$w3_unsafe_decode_SubmitStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$RecoveryLogin$IncorrectPassword);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$RecoveryLogin$NotSubmitted));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$RecoveryLogin$Submitting);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$RecoveryLogin$w3_unsafe_decode_Model = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$RecoveryLogin$w3_unsafe_decode_SubmitStatus,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F2(
								function (password0, submitStatus0) {
									return {password: password0, submitStatus: submitStatus0};
								})))),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_LoginStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Types$w3_unsafe_decode_LoggedIn2,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$LoggedIn));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$Evergreen$V419$SecretId$w3_unsafe_decode_SecretId($author$project$Evergreen$V419$Id$w3_unsafe_decode_InviteLinkId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Range$w3_unsafe_decode_Range,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_HtmlId,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Evergreen$V419$Range$w3_unsafe_decode_SelectionDirection,
											$lamdera$codecs$Lamdera$Wire3$succeedDecode(
												F3(
													function (direction0, htmlId0, selection0) {
														return {direction: direction0, htmlId: htmlId0, selection: selection0};
													})))))),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$RecoveryLogin$w3_unsafe_decode_Model,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$LoginForm$w3_unsafe_decode_LoginForm),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F4(
											function (loginForm0, recoveryLogin0, textInputFocus0, useInviteAfterLoggedIn0) {
												return {loginForm: loginForm0, recoveryLogin: recoveryLogin0, textInputFocus: textInputFocus0, useInviteAfterLoggedIn: useInviteAfterLoggedIn0};
											})))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$NotLoggedIn));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_LoginType = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$ImageViewer$w3_unsafe_decode_Interaction = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeFloat,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeFloat,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeFloat,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F4(
											function (offsetStartX0, offsetStartY0, startX0, startY0) {
												return {offsetStartX: offsetStartX0, offsetStartY: offsetStartY0, startX: startX0, startY: startY0};
											})))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageViewer$Dragging));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageViewer$NoInteraction);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeFloat,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeFloat,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeFloat,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F4(
											function (prevMidX0, prevMidY0, startDistance0, startScale0) {
												return {prevMidX: prevMidX0, prevMidY: prevMidY0, startDistance: startDistance0, startScale: startScale0};
											})))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageViewer$Pinching));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$ImageViewer$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeFloat,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeFloat,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeFloat,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeFloat,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeFloat,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeFloat,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeFloat,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeFloat,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Evergreen$V419$ImageViewer$w3_unsafe_decode_Interaction,
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeString,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$author$project$Evergreen$V419$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels),
													$lamdera$codecs$Lamdera$Wire3$succeedDecode(
														function (imageSize0) {
															return function (imageUrl0) {
																return function (interaction0) {
																	return function (offsetX0) {
																		return function (offsetY0) {
																			return function (prevOffsetX0) {
																				return function (prevOffsetY0) {
																					return function (scale0) {
																						return function (targetScale0) {
																							return function (velocityX0) {
																								return function (velocityY0) {
																									return function (zoomFocusX0) {
																										return function (zoomFocusY0) {
																											return {imageSize: imageSize0, imageUrl: imageUrl0, interaction: interaction0, offsetX: offsetX0, offsetY: offsetY0, prevOffsetX: prevOffsetX0, prevOffsetY: prevOffsetY0, scale: scale0, targetScale: targetScale0, velocityX: velocityX0, velocityY: velocityY0, zoomFocusX: zoomFocusX0, zoomFocusY: zoomFocusY0};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														}))))))))))))));
var $author$project$Evergreen$V419$Go$w3_unsafe_decode_PublicGoMatchData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Go$w3_unsafe_decode_ValidatedSetup,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$User$w3_unsafe_decode_FrontendUser),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$User$w3_unsafe_decode_FrontendUser,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$Go$w3_unsafe_decode_Shared,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V419$Go$w3_unsafe_decode_ActionWithTime),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (actions0, cache0, creatorUser0, joinedUser0, setup0) {
								return {actions: actions0, cache: cache0, creatorUser: creatorUser0, joinedUser: joinedUser0, setup: setup0};
							})))))));
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_PublicGoMatch = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Go$w3_unsafe_decode_GameModel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Go$w3_unsafe_decode_PublicGoMatchData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PublicGoMatch_Loaded)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PublicGoMatch_Loading);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PublicGoMatch_Missing);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PublicGoMatch_NotLoaded);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Route$w3_unsafe_decode_ShowChannelSettings = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Route$w3_unsafe_decode_ThreadRouteWithFriends = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Route$w3_unsafe_decode_ShowChannelSettings,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Route$NoThreadWithFriends)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Route$w3_unsafe_decode_ShowChannelSettings,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Route$ViewThreadWithFriends))));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Route$w3_unsafe_decode_ChannelRoute = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ChannelHeaderTab),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Route$w3_unsafe_decode_ThreadRouteWithFriends,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Route$ChannelRoute))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Route$GuildSettingsRoute);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$SecretId$w3_unsafe_decode_SecretId($author$project$Evergreen$V419$Id$w3_unsafe_decode_InviteLinkId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Route$JoinRoute));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Route$NewChannelRoute);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Route$w3_unsafe_decode_ChannelsVisibleOnMobile = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Route$w3_unsafe_decode_Overlay = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Route$w3_unsafe_decode_DiscordDmRouteData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
		$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ChannelHeaderTab),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$Route$w3_unsafe_decode_ShowChannelSettings,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Route$w3_unsafe_decode_Overlay),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Route$w3_unsafe_decode_ChannelsVisibleOnMobile,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F7(
									function (channelId0, channelsVisible0, currentDiscordUserId0, overlay0, showMembersTab0, tab0, viewingMessage0) {
										return {channelId: channelId0, channelsVisible: channelsVisible0, currentDiscordUserId: currentDiscordUserId0, overlay: overlay0, showMembersTab: showMembersTab0, tab: tab0, viewingMessage: viewingMessage0};
									})))))))));
var $author$project$Evergreen$V419$Route$w3_unsafe_decode_DiscordChannelRoute = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ChannelHeaderTab),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Route$w3_unsafe_decode_ThreadRouteWithFriends,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Route$DiscordChannel_ChannelRoute))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Route$DiscordChannel_GuildSettingsRoute);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Route$DiscordChannel_NewChannelRoute);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Route$w3_unsafe_decode_DiscordGuildRouteData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Route$w3_unsafe_decode_Overlay),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$Route$w3_unsafe_decode_ChannelsVisibleOnMobile,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Route$w3_unsafe_decode_DiscordChannelRoute,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (channelRoute0, channelsVisible0, currentDiscordUserId0, guildId0, overlay0) {
								return {channelRoute: channelRoute0, channelsVisible: channelsVisible0, currentDiscordUserId: currentDiscordUserId0, guildId: guildId0, overlay: overlay0};
							})))))));
var $author$project$Evergreen$V419$Route$w3_unsafe_decode_DmRouteData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Route$w3_unsafe_decode_ThreadRouteWithFriends,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ChannelHeaderTab),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Route$w3_unsafe_decode_Overlay),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$Route$w3_unsafe_decode_ChannelsVisibleOnMobile,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$DmChannelId$w3_unsafe_decode_DmChannelId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (channelId0, channelsVisible0, overlay0, tab0, threadRoute0) {
								return {channelId: channelId0, channelsVisible: channelsVisible0, overlay: overlay0, tab: tab0, threadRoute: threadRoute0};
							})))))));
var $author$project$Evergreen$V419$Route$w3_unsafe_decode_LinkDiscordError = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Route$w3_unsafe_decode_SlackDmRouteData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMaybeMessage,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Route$w3_unsafe_decode_Overlay),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$Route$w3_unsafe_decode_ChannelsVisibleOnMobile,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_DmChannelId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (channelId0, channelsVisible0, currentSlackUserId0, overlay0, threadRoute0) {
								return {channelId: channelId0, channelsVisible: channelsVisible0, currentSlackUserId: currentSlackUserId0, overlay: overlay0, threadRoute: threadRoute0};
							})))))));
var $author$project$Evergreen$V419$Route$w3_unsafe_decode_SlackChannelRoute = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Route$w3_unsafe_decode_ShowChannelSettings,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMaybeMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Route$SlackChannel_ChannelRoute))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Route$SlackChannel_WorkspaceSettingsRoute);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Route$w3_unsafe_decode_SlackWorkspaceRouteData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Route$w3_unsafe_decode_Overlay),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$Route$w3_unsafe_decode_ChannelsVisibleOnMobile,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Route$w3_unsafe_decode_SlackChannelRoute,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (channelRoute0, channelsVisible0, currentSlackUserId0, overlay0, teamId0) {
								return {channelRoute: channelRoute0, channelsVisible: channelsVisible0, currentSlackUserId: currentSlackUserId0, overlay: overlay0, teamId: teamId0};
							})))))));
function $author$project$Evergreen$V419$SafeJson$cyclic$w3_unsafe_decode_SafeJson() {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeList(
							$author$project$Evergreen$V419$SafeJson$cyclic$w3_unsafe_decode_SafeJson()),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SafeJson$JsonArray));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SafeJson$JsonBool));
				case 2:
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SafeJson$JsonNull);
				case 3:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$SafeFloat$w3_unsafe_decode_SafeFloat,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SafeJson$JsonNumber));
				case 4:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeDict$(
							$lamdera$codecs$Lamdera$Wire3$decodeString,
							$author$project$Evergreen$V419$SafeJson$cyclic$w3_unsafe_decode_SafeJson()),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SafeJson$JsonObject));
				case 5:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SafeJson$JsonString));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
}
var $author$project$Evergreen$V419$SafeJson$w3_unsafe_decode_SafeJson = $author$project$Evergreen$V419$SafeJson$cyclic$w3_unsafe_decode_SafeJson();
$author$project$Evergreen$V419$SafeJson$cyclic$w3_unsafe_decode_SafeJson = function () {
	return $author$project$Evergreen$V419$SafeJson$w3_unsafe_decode_SafeJson;
};
var $author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserAuth = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$SafeJson$w3_unsafe_decode_SafeJson,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (token0, userAgent0, xSuperProperties0) {
						return {token: token0, userAgent: userAgent0, xSuperProperties: xSuperProperties0};
					})))));
var $author$project$Evergreen$V419$Route$w3_unsafe_decode_Route = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Pagination$w3_unsafe_decode_ItemId)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							function (highlightLog0) {
								return {highlightLog: highlightLog0};
							})),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Route$AdminRoute));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Route$AiChatRoute);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Route$w3_unsafe_decode_DiscordDmRouteData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Route$DiscordDmRoute));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Route$w3_unsafe_decode_DiscordGuildRouteData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Route$DiscordGuildRoute));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Route$w3_unsafe_decode_DmRouteData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Route$DmRoute));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Route$w3_unsafe_decode_Overlay),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Route$w3_unsafe_decode_ChannelsVisibleOnMobile,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Route$w3_unsafe_decode_ChannelRoute,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Route$GuildRoute)))));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Route$w3_unsafe_decode_Overlay),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Route$HomePageRoute));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($author$project$Evergreen$V419$Route$w3_unsafe_decode_LinkDiscordError, $author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserAuth),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Route$LinkDiscord));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Route$NewGuildRoute);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Route$PrivacyRoute);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$SecretId$w3_unsafe_decode_SecretId($author$project$Evergreen$V419$Id$w3_unsafe_decode_GamePublicId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Route$PublicGoMatchRoute));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Route$w3_unsafe_decode_SlackDmRouteData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Route$SlackDmRoute));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Route$w3_unsafe_decode_SlackWorkspaceRouteData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Route$SlackWorkspaceRoute));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Route$TextEditorRoute);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Audio$w3_unsafe_decode_BufferId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Audio$w3_unsafe_decode_Source = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Audio$w3_unsafe_decode_BufferId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						function (bufferId0) {
							return {bufferId: bufferId0};
						})),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Ports$w3_unsafe_decode_NotificationPermission = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Ports$w3_unsafe_decode_PwaStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Ports$w3_unsafe_decode_StartupData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$UserAgent$w3_unsafe_decode_UserAgent,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$elm$time$Time$w3_unsafe_decode_Zone,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			A2(
				$lamdera$codecs$Lamdera$Wire3$andThenDecode,
				function (t) {
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
						$elm$time$Time$millisToPosix(t));
				},
				$lamdera$codecs$Lamdera$Wire3$decodeInt),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeInt),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Ports$w3_unsafe_decode_PwaStatus,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Ports$w3_unsafe_decode_NotificationPermission,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										A2(
											$lamdera$codecs$Lamdera$Wire3$andThenDecode,
											function (t) {
												return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
													$elm$time$Time$millisToPosix(t));
											},
											$lamdera$codecs$Lamdera$Wire3$decodeInt),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeList(
												$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId)),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeFloat,
												$lamdera$codecs$Lamdera$Wire3$succeedDecode(
													function (devicePixelRatio0) {
														return function (e2eeKeys0) {
															return function (loadStartupDataTime0) {
																return function (notificationPermission0) {
																	return function (pwaStatus0) {
																		return function (randomSeed0) {
																			return function (safeAreaInsetBottom0) {
																				return function (safeAreaInsetTop0) {
																					return function (scrollbarWidth0) {
																						return function (timeOrigin0) {
																							return function (timezone0) {
																								return function (userAgent0) {
																									return {devicePixelRatio: devicePixelRatio0, e2eeKeys: e2eeKeys0, loadStartupDataTime: loadStartupDataTime0, notificationPermission: notificationPermission0, pwaStatus: pwaStatus0, randomSeed: randomSeed0, safeAreaInsetBottom: safeAreaInsetBottom0, safeAreaInsetTop: safeAreaInsetTop0, scrollbarWidth: scrollbarWidth0, timeOrigin: timeOrigin0, timezone: timezone0, userAgent: userAgent0};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													})))))))))))));
var $author$project$Evergreen$V419$Internal$Model2$w3_unsafe_decode_State = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeString),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeSet($lamdera$codecs$Lamdera$Wire3$decodeString),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F3(
									function (added0, keyframes0, rules0) {
										return {added: added0, keyframes: keyframes0, rules: rules0};
									}))))),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Ui$Anim$w3_unsafe_decode_State = $author$project$Evergreen$V419$Internal$Model2$w3_unsafe_decode_State;
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_LinkDiscordFailure = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$LinkDiscordHttpError));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$LinkDiscordLimitReached);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_AdminStatusLoginData = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$IsAdminButNoData);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_InitAdminData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$IsAdminLoginData));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$IsNotAdminLoginData);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_LoginData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Evergreen$V419$Call$w3_unsafe_decode_CallId,
		$author$project$Evergreen$V419$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
			$lamdera$codecs$Lamdera$Wire3$decodePair$(
				$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
				$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId),
			$author$project$Evergreen$V419$Call$w3_unsafe_decode_RemoteCallData)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$User$w3_unsafe_decode_FrontendCurrentUser,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$TextEditor$w3_unsafe_decode_LocalState,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_StickerId),
						$author$project$Evergreen$V419$Sticker$w3_unsafe_decode_StickerData),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
							$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_SlackFrontendWorkspace),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqSet$decodeSet(
								$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId)),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqDict$decodeDict$(
									$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
									$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_SlackFrontendUser),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$containers$SeqDict$decodeDict$(
										$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_DmChannelId),
										$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_SlackFrontendDmChannel),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_UserSession,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeString,
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$containers$SeqDict$decodeDict$(
													$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
													$author$project$Evergreen$V419$User$w3_unsafe_decode_FrontendUser),
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V419$SessionIdHash$w3_unsafe_decode_SessionIdHash, $author$project$Evergreen$V419$UserSession$w3_unsafe_decode_FrontendUserSession),
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$lamdera$containers$SeqDict$decodeDict$(
															$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
															$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId)),
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$lamdera$containers$SeqDict$decodeDict$(
																$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
																$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_FrontendGuild),
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$lamdera$containers$SeqDict$decodeDict$(
																	$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
																	$author$project$Evergreen$V419$DmChannel$w3_unsafe_decode_FrontendDmChannel),
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$author$project$Evergreen$V419$LinkedAndOtherDiscordUsers$w3_unsafe_decode_LinkedAndOtherDiscordUsers,
																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																		$lamdera$containers$SeqDict$decodeDict$(
																			$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
																			$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_DiscordFrontendGuild),
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$containers$SeqDict$decodeDict$(
																				$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
																				$author$project$Evergreen$V419$DmChannel$w3_unsafe_decode_DiscordFrontendDmChannel),
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$lamdera$containers$SeqDict$decodeDict$(
																					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_CustomEmojiId),
																					$author$project$Evergreen$V419$CustomEmoji$w3_unsafe_decode_CustomEmojiData),
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_Viewing,
																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																						$lamdera$containers$SeqDict$decodeDict$($author$project$Evergreen$V419$Call$w3_unsafe_decode_CallId, $author$project$Evergreen$V419$Call$w3_unsafe_decode_RecordingStatus),
																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																							$author$project$Evergreen$V419$Types$w3_unsafe_decode_AdminStatusLoginData,
																							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																								function (adminData0) {
																									return function (callRecordings0) {
																										return function (currentlyViewing0) {
																											return function (customEmojis0) {
																												return function (discordDmChannels0) {
																													return function (discordGuilds0) {
																														return function (discordUsers0) {
																															return function (dmChannels0) {
																																return function (guilds0) {
																																	return function (linkedSlackUsers0) {
																																		return function (otherSessions0) {
																																			return function (otherUsers0) {
																																				return function (publicVapidKey0) {
																																					return function (session0) {
																																						return function (slackDmChannels0) {
																																							return function (slackUsers0) {
																																								return function (slackUsersNeedingAuth0) {
																																									return function (slackWorkspaces0) {
																																										return function (stickers0) {
																																											return function (textEditor0) {
																																												return function (twoFactorAuthenticationEnabled0) {
																																													return function (user0) {
																																														return function (voiceChatPeers0) {
																																															return {adminData: adminData0, callRecordings: callRecordings0, currentlyViewing: currentlyViewing0, customEmojis: customEmojis0, discordDmChannels: discordDmChannels0, discordGuilds: discordGuilds0, discordUsers: discordUsers0, dmChannels: dmChannels0, guilds: guilds0, linkedSlackUsers: linkedSlackUsers0, otherSessions: otherSessions0, otherUsers: otherUsers0, publicVapidKey: publicVapidKey0, session: session0, slackDmChannels: slackDmChannels0, slackUsers: slackUsers0, slackUsersNeedingAuth: slackUsersNeedingAuth0, slackWorkspaces: slackWorkspaces0, stickers: stickers0, textEditor: textEditor0, twoFactorAuthenticationEnabled: twoFactorAuthenticationEnabled0, user: user0, voiceChatPeers: voiceChatPeers0};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								}))))))))))))))))))))))));
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_LoginResult = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Types$w3_unsafe_decode_LoginData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$LoginSuccess));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$LoginTokenInvalid));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$NeedsAccountSetup);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$NeedsTwoFactorToken);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$RecoveryPasswordInvalid);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$UserIsDeleted);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Go$w3_unsafe_decode_PublicGoMatchResponse = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Go$w3_unsafe_decode_ValidatedSetup,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$User$w3_unsafe_decode_FrontendUser),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$User$w3_unsafe_decode_FrontendUser,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V419$Go$w3_unsafe_decode_ActionWithTime),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (actions0, creatorUser0, joinedUser0, setup0) {
							return {actions: actions0, creatorUser: creatorUser0, joinedUser: joinedUser0, setup: setup0};
						}))))));
var $author$project$Evergreen$V419$AiChat$w3_unsafe_decode_AiResponse = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeString),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeFloat),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (content0, cost0, images0, reasoning0) {
							return {content: content0, cost: cost0, images: images0, reasoning: reasoning0};
						}))))));
var $author$project$Evergreen$V419$AiChat$w3_unsafe_decode_ToFrontend = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Http$w3_unsafe_decode_Error, $author$project$Evergreen$V419$AiChat$w3_unsafe_decode_AiResponse),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$AiChat$w3_unsafe_decode_ResponseId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$AiChat$AiMessageResponse)));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$ImageEditor$w3_unsafe_decode_ToFrontend = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageEditor$ChangeGuildIconResponse));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageEditor$ChangeUserAvatarResponse);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_ExportSubset = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$ExportAll);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_ExportSubsetSelection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$ExportSubset));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_ToFrontend = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBytes,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$LocalState$w3_unsafe_decode_BackupContents,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$DownloadLastBackupChunk))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$ExportBackendFinished);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_ExportProgress,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_ExportSubset,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$ExportBackendProgress)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$ImportBackendChunkReceived));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $lamdera$codecs$Lamdera$Wire3$decodeUnit),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$ImportBackendResponse));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$TwoFactorAuthentication$w3_unsafe_decode_ToFrontend = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$TwoFactorAuthentication$ConfirmTwoFactorAuthenticationResponse)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$TwoFactorAuthentication$DisableTwoFactorAuthenticationResponse)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							function (qrCodeUrl0) {
								return {qrCodeUrl: qrCodeUrl0};
							})),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$TwoFactorAuthentication$EnableTwoFactorAuthenticationResponse));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_ToFrontend = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_ToFrontend,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$AdminToFrontend));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$AiChat$w3_unsafe_decode_ToFrontend,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$AiChatToFrontend));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Types$w3_unsafe_decode_LocalMsg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$ChangeBroadcast));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $author$project$Evergreen$V419$Types$w3_unsafe_decode_LoginData),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Types$w3_unsafe_decode_LoginType,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$CheckLoginResponse)));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeString,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (fileName0, json0) {
										return {fileName: fileName0, json: json0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$ExportChannelResponse));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$GetLoginTokenRateLimited);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $author$project$Evergreen$V419$Go$w3_unsafe_decode_PublicGoMatchResponse),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$GetPublicGoMatchResponse));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$(
						$author$project$Evergreen$V419$Types$w3_unsafe_decode_ImportChannelError,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								function (encryptedMessages0) {
									return {encryptedMessages: encryptedMessages0};
								}))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$ImportChannelResponse)));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($author$project$Evergreen$V419$Types$w3_unsafe_decode_LinkDiscordFailure, $lamdera$codecs$Lamdera$Wire3$decodeUnit),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$LinkDiscordResponse));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Types$w3_unsafe_decode_LinkSlackResult,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$LinkSlackResponse));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Types$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Local$w3_unsafe_decode_ChangeId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$LocalChangeResponse)));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$LoggedOutSession);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Types$w3_unsafe_decode_LoginResult,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$LoginWithTokenResponse));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$ImageEditor$w3_unsafe_decode_ToFrontend,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$ProfilePictureEditorToFrontend));
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $author$project$Evergreen$V419$Types$w3_unsafe_decode_LoginData),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$ReloadDataResponse));
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$SignupsDisabledResponse);
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$TwoFactorAuthentication$w3_unsafe_decode_ToFrontend,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$TwoFactorAuthenticationToFrontend));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$YouConnected));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_LoadedFrontend = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Evergreen$V419$Types$w3_unsafe_decode_ToFrontend)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Zone,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Ports$w3_unsafe_decode_StartupData,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Route$w3_unsafe_decode_Route,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V419$Types$w3_unsafe_decode_PublicGoMatch,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeResult$($author$project$Evergreen$V419$Audio$w3_unsafe_decode_LoadError, $author$project$Evergreen$V419$Audio$w3_unsafe_decode_Source),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeBool,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$program_test$Effect$Browser$Navigation$w3_unsafe_decode_Key,
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$author$project$Evergreen$V419$Types$w3_unsafe_decode_LoginType,
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$author$project$Evergreen$V419$Types$w3_unsafe_decode_LoginStatus,
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$MyUi$w3_unsafe_decode_LastCopy),
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$ImageViewer$w3_unsafe_decode_Model),
																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$codecs$Lamdera$Wire3$decodeBool,
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$lamdera$codecs$Lamdera$Wire3$decodeInt,
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
																					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																						F3(
																							function (changedAt0, index0, rotate0) {
																								return {changedAt: changedAt0, index: index0, rotate: rotate0};
																							}))))),
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Emoji$w3_unsafe_decode_CachedEmojiData),
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$author$project$Evergreen$V419$Ui$Anim$w3_unsafe_decode_State,
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$author$project$Evergreen$V419$Touch$w3_unsafe_decode_Drag,
																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																						$author$project$Evergreen$V419$Touch$w3_unsafe_decode_Drag,
																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																							$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId,
																							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																								$author$project$Evergreen$V419$AiChat$w3_unsafe_decode_FrontendModel,
																								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																									function (aiChatModel0) {
																										return function (clientId0) {
																											return function (drag0) {
																												return function (dragPrevious0) {
																													return function (elmUiState0) {
																														return function (emojiData0) {
																															return function (homePagePreview0) {
																																return function (imageViewer0) {
																																	return function (lastCopied0) {
																																		return function (loginStatus0) {
																																			return function (loginType0) {
																																				return function (navigationKey0) {
																																					return function (pageHasFocus0) {
																																						return function (popSound0) {
																																							return function (publicGoMatch0) {
																																								return function (route0) {
																																									return function (startupData0) {
																																										return function (time0) {
																																											return function (timezone0) {
																																												return function (toFrontendLogs0) {
																																													return function (versionNumber0) {
																																														return function (visualViewportHeight0) {
																																															return function (visualViewportTop0) {
																																																return function (windowSize0) {
																																																	return {aiChatModel: aiChatModel0, clientId: clientId0, drag: drag0, dragPrevious: dragPrevious0, elmUiState: elmUiState0, emojiData: emojiData0, homePagePreview: homePagePreview0, imageViewer: imageViewer0, lastCopied: lastCopied0, loginStatus: loginStatus0, loginType: loginType0, navigationKey: navigationKey0, pageHasFocus: pageHasFocus0, popSound: popSound0, publicGoMatch: publicGoMatch0, route: route0, startupData: startupData0, time: time0, timezone: timezone0, toFrontendLogs: toFrontendLogs0, versionNumber: versionNumber0, visualViewportHeight: visualViewportHeight0, visualViewportTop: visualViewportTop0, windowSize: windowSize0};
																																																};
																																															};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									})))))))))))))))))))))))));
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_LoadStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$LoadError);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Types$w3_unsafe_decode_LoginData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$LoadSuccess));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$LoadingData);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_LoadingFrontend = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Ports$w3_unsafe_decode_StartupData),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Evergreen$V419$Route$w3_unsafe_decode_Route,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Types$w3_unsafe_decode_PublicGoMatch,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeResult$($author$project$Evergreen$V419$Audio$w3_unsafe_decode_LoadError, $author$project$Evergreen$V419$Audio$w3_unsafe_decode_Source),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Browser$Navigation$w3_unsafe_decode_Key,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Types$w3_unsafe_decode_LoginType,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Types$w3_unsafe_decode_LoadStatus,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId),
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											function (clientId0) {
												return function (loginStatus0) {
													return function (loginType0) {
														return function (navigationKey0) {
															return function (popSound0) {
																return function (publicGoMatch0) {
																	return function (route0) {
																		return function (startupData0) {
																			return function (time0) {
																				return function (windowSize0) {
																					return {clientId: clientId0, loginStatus: loginStatus0, loginType: loginType0, navigationKey: navigationKey0, popSound: popSound0, publicGoMatch: publicGoMatch0, route: route0, startupData: startupData0, time: time0, windowSize: windowSize0};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											})))))))))));
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_FrontendModel_ = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Types$w3_unsafe_decode_LoadedFrontend,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Loaded));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Types$w3_unsafe_decode_LoadingFrontend,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$Loading));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Id$w3_unsafe_decode_ExportChannelId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Id$ExportChannel_Discord))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Id$ExportChannel_DiscordDm)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Id$ExportChannel_Dm));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Id$ExportChannel_Guild)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Call$w3_unsafe_decode_FromJs = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V419$Call$w3_unsafe_decode_DebugSection),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$FromJs_DebugData));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList(
						$author$project$Evergreen$V419$IdString$w3_unsafe_decode_IdString($author$project$Evergreen$V419$Call$w3_unsafe_decode_MediaDeviceId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V419$Call$w3_unsafe_decode_MediaDevice),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$FromJs_GotUserMediaDevices)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$FromJs_GotUserMediaDevicesError));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$FromJs_RecordingUploadProgress)));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$FromJs_RecordingUploadsStopped);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$FromJs_ScreenShareStarted);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$FromJs_ScreenShareStopped);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Call$w3_unsafe_decode_LocalOrConnection,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$FromJs_SpeakingChanged)));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$FromJs_StartConnectionError));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_MeasuredFile = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$FileStatus$MeasuredImage));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$FileStatus$MeasuredVideo)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Encryption$w3_unsafe_decode_FromJs = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Encryption$w3_unsafe_decode_EncryptFileRequestId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Encryption$FromJs_FileEncryptFailed)));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeBytes),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_MeasuredFile),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeBytes,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeBytes,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											F4(
												function (data0, key0, measured0, thumbnail0) {
													return {data: data0, key: key0, measured: measured0, thumbnail: thumbnail0};
												})))))),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Encryption$w3_unsafe_decode_EncryptFileRequestId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Encryption$FromJs_FileEncrypted)));
				case 2:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeList(
							$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, w3_x_c_a)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Encryption$w3_unsafe_decode_DecryptManyRequestId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Encryption$FromJs_ManyMessagesDecrypted)));
				case 3:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Encryption$w3_unsafe_decode_EncryptManyRequestId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Encryption$FromJs_ManyMessagesEncryptFailed)));
				case 4:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeList(
							$author$project$Evergreen$V419$Encryption$w3_unsafe_decode_EncryptedData(w3_x_c_a)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Encryption$w3_unsafe_decode_EncryptManyRequestId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Encryption$FromJs_ManyMessagesEncrypted)));
				case 5:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Encryption$w3_unsafe_decode_DecryptRequestId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Encryption$FromJs_NewMessageDecryptFailed));
				case 6:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_a,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Encryption$w3_unsafe_decode_DecryptRequestId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Encryption$FromJs_NewMessageDecrypted)));
				case 7:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Encryption$w3_unsafe_decode_EncryptRequestId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Encryption$FromJs_NewMessageEncryptFailed)));
				case 8:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Encryption$w3_unsafe_decode_EncryptedData(w3_x_c_a),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Encryption$w3_unsafe_decode_EncryptRequestId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Encryption$FromJs_NewMessageEncrypted)));
				case 9:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Encryption$FromJs_SharedSecretFailed)));
				case 10:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Encryption$FromJs_SharedSecretStored));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V419$RichText$w3_unsafe_decode_PressedImageId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$RichText$PressedAttachedFileImage));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$RichText$PressedEmbedImage));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$RichText$w3_unsafe_decode_PressedImageData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Evergreen$V419$Point2d$w3_unsafe_decode_Point2d$($author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels, $author$project$Evergreen$V419$Touch$w3_unsafe_decode_ScreenCoordinate),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Evergreen$V419$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$RichText$w3_unsafe_decode_PressedImageId,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (displayWidth0, fileUrl0, imageId0, imageSize0, position0) {
								return {displayWidth: displayWidth0, fileUrl: fileUrl0, imageId: imageId0, imageSize: imageSize0, position: position0};
							})))))));
var $author$project$Evergreen$V419$MessageView$w3_unsafe_decode_MessageViewMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageView$MessageViewMsg_PressedCallStartedCard);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageView$MessageViewMsg_PressedEditMessage);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageView$MessageViewMsg_PressedGameStartedCard);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageView$MessageViewMsg_PressedReactionEmoji));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageView$MessageViewMsg_PressedReply);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageView$MessageViewMsg_PressedShowFullMenu)));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageView$MessageViewMsg_PressedShowReactionEmojiSelector);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeBool,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageView$MessageView_AltPressedMessage))))));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageView$MessageView_MouseEnteredMessage);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageView$MessageView_MouseExitedMessage);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageView$MessageView_NoOp);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $lamdera$codecs$Lamdera$Wire3$decodeFloat),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Point2d$w3_unsafe_decode_Point2d$($author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels, $author$project$Evergreen$V419$Touch$w3_unsafe_decode_ScreenCoordinate),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageView$MessageView_PressedCardAnchor)));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageView$MessageView_PressedChannelMention)));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageView$MessageView_PressedCopyCode));
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $lamdera$codecs$Lamdera$Wire3$decodeFloat),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Point2d$w3_unsafe_decode_Point2d$($author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels, $author$project$Evergreen$V419$Touch$w3_unsafe_decode_ScreenCoordinate),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$justinmimbs$date$Date$w3_unsafe_decode_Date,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageView$MessageView_PressedDateDivider))));
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageView$MessageView_PressedDiscordChannelMention)));
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageView$MessageView_PressedDiscordUserIconButton));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$RichText$w3_unsafe_decode_PressedImageData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageView$MessageView_PressedImage));
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$elm$url$Url$w3_unsafe_decode_Url,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageView$MessageView_PressedNonWhitelistLink));
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageView$MessageView_PressedReactionEmoji_Add));
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageView$MessageView_PressedReactionEmoji_Remove));
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageView$MessageView_PressedReplyLink);
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageView$MessageView_PressedSpoiler));
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $lamdera$codecs$Lamdera$Wire3$decodeFloat),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Point2d$w3_unsafe_decode_Point2d$($author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels, $author$project$Evergreen$V419$Touch$w3_unsafe_decode_ScreenCoordinate),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageView$MessageView_PressedTimestamp)));
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $lamdera$codecs$Lamdera$Wire3$decodeFloat),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Point2d$w3_unsafe_decode_Point2d$($author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels, $author$project$Evergreen$V419$Touch$w3_unsafe_decode_ScreenCoordinate),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageView$MessageView_PressedUserIconAnchor)));
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageView$MessageView_PressedUserIconButton));
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageView$MessageView_PressedViewThreadLink);
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$NonemptyDict$w3_unsafe_decode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$Evergreen$V419$Touch$w3_unsafe_decode_Touch),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeBool,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageView$MessageView_TouchStart)))))));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$AiChat$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$AiChat$CheckDebounce));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$AiChat$w3_unsafe_decode_ResponseId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$AiChat$EditedResponse)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$(
						$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
						$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V419$AiChat$w3_unsafe_decode_AiModel)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$AiChat$GotAiModels));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$AiChat$GotLocalStorage));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$AiChat$NoOp);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$AiChat$PressedAddModel);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$AiChat$PressedChatHistoryContainer);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$AiChat$PressedClearChatHistory);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$AiChat$w3_unsafe_decode_ResponseId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$AiChat$PressedDelete));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$AiChat$w3_unsafe_decode_ResponseId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$AiChat$PressedKeep));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$AiChat$PressedOptionsButton);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$AiChat$PressedRemoveModel));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$AiChat$w3_unsafe_decode_ResponseId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$AiChat$PressedRetry));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$AiChat$PressedSend);
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$AiChat$w3_unsafe_decode_AiModelName,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$AiChat$SelectedAiModel)));
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$AiChat$w3_unsafe_decode_SendMessageWith,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$AiChat$SelectedSendMessageWith));
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$AiChat$TypedChatHistory));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$AiChat$TypedMessage));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Call$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Call$w3_unsafe_decode_ConnectionId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$ChangedVolume)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$DoubleClickedVideoNode);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Call$w3_unsafe_decode_LocalOrConnection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$MouseEnterVideoNode));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Call$w3_unsafe_decode_LocalOrConnection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$MouseExitVideoNode));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$PolledDebugData);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$PressedAnswerRecording));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$PressedCancelRecording);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$PressedCopyError));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Call$w3_unsafe_decode_CallId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$PressedJoinCall));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$PressedLeaveCall);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$PressedRecord);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$PressedToggleDebugData);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$PressedToggleDeviceSettings);
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$PressedToggleMute);
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$PressedTogglePauseVideo);
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$PressedToggleScreenShare);
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Call$w3_unsafe_decode_VideoTile,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$PressedVideoTile));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$IdString$w3_unsafe_decode_IdString($author$project$Evergreen$V419$Call$w3_unsafe_decode_MediaDeviceId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$SelectedAudioInputDevice));
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$IdString$w3_unsafe_decode_IdString($author$project$Evergreen$V419$Call$w3_unsafe_decode_MediaDeviceId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Call$SelectedVideoInputDevice));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Drawing$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeFloat,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeFloat,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeFloat,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeFloat,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											F4(
												function (height0, width0, x0, y0) {
													return {height: height0, width: width0, x: x0, y: y0};
												}))))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Drawing$GotZoomContainer));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Drawing$PointerDown)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Drawing$PointerMoved)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Drawing$PointerUp);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Drawing$PressedDone);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Drawing$PressedRedo);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Drawing$PressedUndo);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Drawing$PressedZoom);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Editable$w3_unsafe_decode_Msg = function (w3_x_c_value) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Editable$w3_unsafe_decode_Model,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Editable$Edit));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_value,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Editable$PressedAcceptEdit));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V419$Emoji$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Emoji$ClearEmojiHover);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrSticker,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Emoji$KeyboardMovedHover)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrSticker,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Emoji$MouseEnteredEmoji)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Emoji$NoOp);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_Category,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Emoji$PressedCategory)));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Emoji$PressedClearSearch);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Emoji$PressedContainer);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrSticker,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Emoji$PressedSelectEmoji));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Emoji$w3_unsafe_decode_SkinTone),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Emoji$PressedSkinTone));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_Category,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Emoji$ScrolledToCategory));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Emoji$TypedSearchText));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Go$w3_unsafe_decode_SpectatorMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$ChangedViewingMove));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$PressedArrowLeft);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$PressedArrowRight);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$Spectator_PressedCell));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Go$w3_unsafe_decode_GameMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$PressedAgree);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$PressedCell));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$PressedDisagree);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$PressedDoneMarking);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$PressedJoinGame);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$PressedPass);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Go$w3_unsafe_decode_SpectatorMsg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$SpectatorMsg));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$MessageInput$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageInput$IgnoreTouchStart);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageInput$IgnoredKeyPress);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty($lamdera$program_test$Effect$File$w3_unsafe_decode_File),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageInput$OnPasteFiles));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageInput$PressedDropdownItem));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageInput$PressedOpenEmojiSelector);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageInput$PressedPingDropdownContainer);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							function (charsLeft0) {
								return {charsLeft: charsLeft0};
							})),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageInput$PressedSendMessage));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageInput$PressedTextInput);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageInput$PressedUploadFile);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageInput$TypedArrowInDropdown));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageInput$TypedArrowUpInEmptyInput);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageInput$TypedMessage));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageInput$TypedPageDown);
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageInput$TypedPageUp);
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Range$w3_unsafe_decode_Range,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$MessageInput$TypedTabInCodeBlock));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_UploadResponse = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_VideoMetadata),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_ImageMetadata),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileHash,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (fileHash0, imageMetadata0, videoMetadata0) {
						return {fileHash: fileHash0, imageMetadata: imageMetadata0, videoMetadata: videoMetadata0};
					})))));
var $author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_GameMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$ExitedQuestion));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$ExitedResultsGrid));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Http$w3_unsafe_decode_Error, $author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_UploadResponse),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$GotAnswerFileUpload))));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty($lamdera$program_test$Effect$File$w3_unsafe_decode_File),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$GotAnswerFiles)));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Http$w3_unsafe_decode_Error, $author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_UploadResponse),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$GotNotesFileUpload))));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty($lamdera$program_test$Effect$File$w3_unsafe_decode_File),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$GotNotesFiles)));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$HoveredQuestion));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$HoveredResultsGrid));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$NoOp);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$PressedCopyCode));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$PressedDeleteAnswerFile)));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$PressedDeleteNotesFile)));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$PressedHidePreviousQuestion);
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$RichText$w3_unsafe_decode_PressedImageData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$PressedImage));
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$PressedLockAnswers);
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$PressedNewQuestionRevealed);
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$PressedRevealScores);
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$PressedShowNextQuestion);
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (fileId0, removeSpoiler0) {
										return {fileId: fileId0, removeSpoiler: removeSpoiler0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$PressedToggleAnswerFileSpoiler)));
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (fileId0, removeSpoiler0) {
										return {fileId: fileId0, removeSpoiler: removeSpoiler0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$PressedToggleNotesFileSpoiler)));
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$PressedUnlockAnswers);
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$PressedViewAnswerFileInfo)));
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$PressedViewNotesFileInfo)));
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MessageView$w3_unsafe_decode_MessageViewMsg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_ReactionTarget,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$ReactionMsg)));
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MessageInput$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$TypedAnswer)));
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$TypedGroup))));
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MessageInput$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$TypedNotes)));
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Scroll$w3_unsafe_decode_ScrollPosition,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$UserScrolledResults));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_GameMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$(
						$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
						$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_DictEntry)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$GotWordDefinition)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$MouseEnterPlayerRow));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_Shared,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeList(
							$lamdera$codecs$Lamdera$Wire3$decodePair$(
								$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
								$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$MouseEnterWord))));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$MouseExitPlayerRow));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$MouseExitWord);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$PressedClearBoard);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$PressedCloseWordDefinition);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$PressedJoinGame);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$PressedNextWordDefinition);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$PressedPlayerRow));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$PressedPreviousWordDefinition);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$PressedReplaceTrayOrPass);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_PlacedWord,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$PressedSubmitPremove));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_PlacedWord,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$PressedSubmitWord));
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$PressedToggleSettings);
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$PressedWordDefinition));
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MessageView$w3_unsafe_decode_MessageViewMsg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_ReactionTarget,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$ReactionMsg)));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Scroll$w3_unsafe_decode_ScrollPosition,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$UserScrolledPastMoves));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Go$w3_unsafe_decode_SetupMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$ChangedHandicapInput));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$ChangedHeightInput));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$ChangedIncrementInput));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$ChangedKomiInput));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$ChangedMainTimeInput));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$ChangedWidthInput));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$PressedCancel);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$PressedStartGame);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Go$w3_unsafe_decode_Stone,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$SelectedPlayingAs));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Go$w3_unsafe_decode_SizeSelection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Go$SelectedSize));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_SetupMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Http$w3_unsafe_decode_Error, $author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_UploadResponse),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$GotAttachedFileUpload))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty($lamdera$program_test$Effect$File$w3_unsafe_decode_File),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$GotFilesToAttach)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$PressedAddQuestion);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$PressedCancel);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$PressedDeleteAttachedFile)));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$PressedRemoveQuestion));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$PressedStartGame);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (fileId0, removeSpoiler0) {
										return {fileId: fileId0, removeSpoiler: removeSpoiler0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$PressedToggleAttachedFileSpoiler)));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$PressedViewAttachedFileInfo)));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MessageInput$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$SheepGame$TypedQuestion)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_SetupMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$ChangedFullTrayBonusInput));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeChar,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$ChangedLetterValue)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$ChangedLettersInput));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$OneOrGreater$w3_unsafe_decode_OneOrGreater,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$ChangedPlaceWordAttempts));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$ChangedTraySizeInput));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$PressedCancel);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$PressedExpandAdvancedSettings);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_Language,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$PressedLanguage));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$PressedResetLetters);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$WordSpellingGame$PressedStartGame);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Game$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Go$w3_unsafe_decode_GameMsg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$GoGameMsg));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Go$w3_unsafe_decode_SetupMsg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$GoSetupMsg));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$NoOpMsg);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$PressedCopyLink));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$PressedReset);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Message$w3_unsafe_decode_GameType,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$PressedSelectGame));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$PressedShareMatch));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$SelectedMatch));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_GameMsg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$SheepGameMsg));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_SetupMsg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$SheepSetupMsg));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_GameMsg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$WordSpellingGameMsg));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$WordSpellingGame$w3_unsafe_decode_SetupMsg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Game$WordSpellingSetupMsg));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Ports$w3_unsafe_decode_CropImageDataResponse = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (croppedImageUrl0, requestId0) {
					return {croppedImageUrl: croppedImageUrl0, requestId: requestId0};
				}))));
var $author$project$Evergreen$V419$ImageEditor$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeString, $author$project$Evergreen$V419$Ports$w3_unsafe_decode_CropImageDataResponse),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageEditor$CroppedImage));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Error, $lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Element),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageEditor$GotImageSize));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageEditor$GotImageUrl));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageEditor$MouseDownImageEditor)));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageEditor$MouseUpImageEditor);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageEditor$MovedImageEditor)));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageEditor$PressedCancel);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageEditor$PressedConfirmImage);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageEditor$PressedProfileImage);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageEditor$PressedRemoveImage);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$File$w3_unsafe_decode_File,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageEditor$SelectedImage));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageEditor$TouchEndImageEditor);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Http$w3_unsafe_decode_Error, $author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_UploadResponse),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageEditor$UploadedImage));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$ImageViewer$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageViewer$AnimationFrame));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageViewer$MouseDown)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageViewer$MouseMove)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageViewer$MouseUp);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageViewer$PressStartedOnButton);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageViewer$PressedClose);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageViewer$PressedZoomIn);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageViewer$PressedZoomOut);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageViewer$TouchEnd);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $lamdera$codecs$Lamdera$Wire3$decodeFloat)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageViewer$TouchMove));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $lamdera$codecs$Lamdera$Wire3$decodeFloat)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageViewer$TouchStart));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeFloat,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$ImageViewer$Wheeled))));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$LoginForm$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LoginForm$PressedCancelLogin);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LoginForm$PressedSubmitEmail);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LoginForm$PressedSubmitUserData);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LoginForm$TypedLoginCode));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LoginForm$TypedLoginFormEmail));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LoginForm$TypedName));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$LoginForm$TypedTwoFactorCode));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Table$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Table$PressedShowAll);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Table$PressedSortBy));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Editable$w3_unsafe_decode_Msg(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$DiscordLinkLimitEditableMsg));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_UserColumn,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_UserTableId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$EditCellLostFocus)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_UserColumn,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_UserTableId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$EnterKeyInEditCell)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$EscapeKeyInEditCell);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$FocusedOnEditCell);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBytes,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$GotImportBackendFileContent));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$File$w3_unsafe_decode_File,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$ImportBackendFileSelected));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Editable$w3_unsafe_decode_Msg(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$NotifyAdminsBotUserIdEditableMsg));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Editable$w3_unsafe_decode_Msg(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$NotifyAdminsTokenEditableMsg));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Editable$w3_unsafe_decode_Msg(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$OpenRouterKeyEditableMsg));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Editable$w3_unsafe_decode_Msg($author$project$Evergreen$V419$Postmark$w3_unsafe_decode_ApiKey),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PostmarkKeyEditableMsg));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedAddUserRow);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedCancelExportSubset);
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedConfirmExportSubset);
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Pagination$w3_unsafe_decode_ItemId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedCopyLogLink));
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedCopyText));
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedDeleteDiscordDmChannel));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedDeleteDiscordGuild));
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedDeleteGuild));
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedDeleteOrphanedFiles);
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$SessionIdHash$w3_unsafe_decode_SessionIdHash,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedDeleteSession));
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_DmChannelId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedDeleteSlackDmChannel));
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedDeleteSlackWorkspace));
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_UserTableId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedDeleteUser));
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$SessionIdHash$w3_unsafe_decode_SessionIdHash,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedDisconnectClient)));
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedDownloadLastBackup);
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_UserColumn,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_UserTableId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedEditCell)));
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedExpandDiscordGuild));
			case 28:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedExpandGuild));
			case 29:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_AdminUiSection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedExpandSection));
			case 30:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedExpandSlackWorkspace));
			case 31:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedExportBackend);
			case 32:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedExportSubsetBackend);
			case 33:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedHomepageLink);
			case 34:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedImportBackend);
			case 35:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Pagination$w3_unsafe_decode_PageId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedLogPage));
			case 36:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedRegenerateServerSecret);
			case 37:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedReloadDiscordChannel))));
			case 38:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedReloadDiscordDmChannel)));
			case 39:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedReloadDiscordGuild)));
			case 40:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedResetUser));
			case 41:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedResetUserChanges);
			case 42:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedRestoreGuild));
			case 43:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedSaveUserChanges);
			case 44:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedSendTypeThatIsAlwaysInvalid);
			case 45:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PressedWebsocketCloseEventsPage));
			case 46:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Editable$w3_unsafe_decode_Msg($author$project$Evergreen$V419$LocalState$w3_unsafe_decode_PrivateVapidKey),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PrivateVapidKeyEditableMsg));
			case 47:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Editable$w3_unsafe_decode_Msg($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$PublicVapidKeyEditableMsg));
			case 48:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Editable$w3_unsafe_decode_Msg(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$SlackLinkLimitEditableMsg));
			case 49:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$TabKeyInEditCell));
			case 50:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_UserTableId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$ToggleIsAdmin)));
			case 51:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$ToggledDiscordLinkingEnabled));
			case 52:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$ToggledEmailNotifications));
			case 53:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$ToggledExportSubsetDiscordDmChannel)));
			case 54:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$ToggledExportSubsetDiscordGuild)));
			case 55:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$DmChannelId$w3_unsafe_decode_DmChannelId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$ToggledExportSubsetDmChannel)));
			case 56:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$ToggledExportSubsetGuild)));
			case 57:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$ToggledSignupsEnabled));
			case 58:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$ToggledSlackLinkingEnabled));
			case 59:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$TypedEditCell));
			case 60:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$TypedInReadOnlyTextInput);
			case 61:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Table$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Pages$Admin$UserTableMsg));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$RecoveryLogin$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$RecoveryLogin$PressedSubmit);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$RecoveryLogin$TypedPassword));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$TextEditor$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$TextEditor$PressedBack);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$TextEditor$PressedReset);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$TextEditor$RedoChange);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$TextEditor$TypedText));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$TextEditor$UndoChange);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$TwoFactorAuthentication$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$TwoFactorAuthentication$PressedCancelDisable2Fa);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$TwoFactorAuthentication$PressedCopy));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$TwoFactorAuthentication$PressedStart2FaSetup);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$TwoFactorAuthentication$PressedStartDisable2Fa);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$TwoFactorAuthentication$TypedDisableTwoFactorCode));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$TwoFactorAuthentication$TypedTwoFactorCode));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Internal$Teleport$w3_unsafe_decode_CssAnimation = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList(
				$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeString, $lamdera$codecs$Lamdera$Wire3$decodeString)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F6(
								function (hash0, keyframes0, keyframesHash0, props0, transition0, trigger0) {
									return {hash: hash0, keyframes: keyframes0, keyframesHash: keyframesHash0, props: props0, transition: transition0, trigger: trigger0};
								}))))))));
var $author$project$Evergreen$V419$Internal$Teleport$w3_unsafe_decode_ParentTriggerDetails = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V419$Internal$Teleport$w3_unsafe_decode_CssAnimation),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (children0, identifierClass0, trigger0) {
						return {children: children0, identifierClass: identifierClass0, trigger: trigger0};
					})))));
var $author$project$Evergreen$V419$Internal$Teleport$w3_unsafe_decode_Data = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Internal$Teleport$w3_unsafe_decode_CssAnimation,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Internal$Teleport$Css));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Internal$Teleport$w3_unsafe_decode_ParentTriggerDetails,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Internal$Teleport$ParentTrigger));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Internal$Teleport$w3_unsafe_decode_Event = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeFloat,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Evergreen$V419$Internal$Teleport$w3_unsafe_decode_Data),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (data0, timestamp0) {
					return {data: data0, timestamp: timestamp0};
				}))));
var $author$project$Evergreen$V419$Internal$Teleport$w3_unsafe_decode_Trigger = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Internal$Model2$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Internal$Teleport$w3_unsafe_decode_Event,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Internal$Teleport$w3_unsafe_decode_Trigger,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Internal$Model2$Teleported)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					A2(
						$lamdera$codecs$Lamdera$Wire3$andThenDecode,
						function (t) {
							return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
								$elm$time$Time$millisToPosix(t));
						},
						$lamdera$codecs$Lamdera$Wire3$decodeInt),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Internal$Model2$Tick));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Ui$Anim$w3_unsafe_decode_Msg = $author$project$Evergreen$V419$Internal$Model2$w3_unsafe_decode_Msg;
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_FrontendMsg_ = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Pages$Admin$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$AdminPageMsg));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$AiChat$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$AiChatMsg));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$ChannelSidebarAnimated));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeBool,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
											$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$CheckMessageAltPress))))))));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Ports$w3_unsafe_decode_NotificationPermission,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$CheckedNotificationPermission));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$CheckedSheepGameQuestionsDebounce)));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_Input,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$CheckedSheepGameSaveDebounce)))));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$DebouncedTyping);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_HtmlId),
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V419$Range$w3_unsafe_decode_Range, $author$project$Evergreen$V419$Range$w3_unsafe_decode_SelectionDirection))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$DomFocusChanged));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Drawing$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$DrawingMsg));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Types$w3_unsafe_decode_EditChannelForm,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$EditChannelFormChanged))));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Types$w3_unsafe_decode_EditGuildForm,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$EditGuildFormChanged)));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Http$w3_unsafe_decode_Error, $author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_UploadResponse),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$EditMessage_GotFileHashName)))));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MessageInput$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$EditMessage_MessageInputMsg))));
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$EditMessage_PressedDeleteAttachedFile)));
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (fileId0, removeSpoiler0) {
										return {fileId: fileId0, removeSpoiler: removeSpoiler0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$EditMessage_PressedToggleAttachedFileSpoiler)));
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$EditMessage_PressedViewAttachedFileInfo)));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$program_test$Effect$File$w3_unsafe_decode_File),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$File$w3_unsafe_decode_File,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$EditMessage_SelectedFilesToAttach))));
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Ui$Anim$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$ElmUiMsg));
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$EmojiSelectorMsg));
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$EnableToFrontendLogging);
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$author$project$Evergreen$V419$Encryption$w3_unsafe_decode_FromJs(
							$author$project$Evergreen$V419$Message$w3_unsafe_decode_MessageContent$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$EncryptionFromJs));
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$FileDragEnter));
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$FileDragLeave);
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$program_test$Effect$File$w3_unsafe_decode_File),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$FileDropped));
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Progress,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$FileUploadProgress))));
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$FrontendNoOp);
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Game$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$GameMsg));
			case 28:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Go$w3_unsafe_decode_SpectatorMsg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$GoSpectatorMsg));
			case 29:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$GotDevicePixelRatio));
			case 30:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Http$w3_unsafe_decode_Error, $author$project$Evergreen$V419$Emoji$w3_unsafe_decode_CachedEmojiData),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$GotEmojiData));
			case 31:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Http$w3_unsafe_decode_Error, $author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_UploadResponse),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileMetadata),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$GotFileHashName)))));
			case 32:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBytes,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$GotFileToEncrypt)))));
			case 33:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeString,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (fileName0, json0) {
										return {fileName: fileName0, json: json0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$GotImportChannelFile)));
			case 34:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Error, $author$project$Evergreen$V419$MessageInput$w3_unsafe_decode_MentionUserDropdown),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_HtmlId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$GotPingUserPosition)));
			case 35:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Error, $lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Element),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$GotPositionForEmojiSelector_EditMessage));
			case 36:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Error, $lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Element),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$SheepGame$w3_unsafe_decode_Input,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$GotPositionForEmojiSelector_SheepGameInput)));
			case 37:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Ports$w3_unsafe_decode_RegisterPushSubscription,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$GotRegisterPushSubscription));
			case 38:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$GotServiceWorkerData));
			case 39:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$GotServiceWorkerMessage));
			case 40:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeString, $author$project$Evergreen$V419$Ports$w3_unsafe_decode_StartupData),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$GotStartupData));
			case 41:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$GotTime));
			case 42:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $lamdera$codecs$Lamdera$Wire3$decodeInt),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$GotVersionNumber));
			case 43:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeString, $author$project$Evergreen$V419$Call$w3_unsafe_decode_FromJs),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$GotVoiceChatSignalFromJs));
			case 44:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$GotWindowSize)));
			case 45:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$ImageEditor$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$GuildIconEditorMsg)));
			case 46:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$ImageViewer$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$ImageViewerMsg));
			case 47:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeBool,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeString,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeBool,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F4(
											function (ctrlKey0, key0, metaKey0, shiftKey0) {
												return {ctrlKey: ctrlKey0, key: key0, metaKey: metaKey0, shiftKey: shiftKey0};
											})))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$KeyDown));
			case 48:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($author$project$Evergreen$V419$Audio$w3_unsafe_decode_LoadError, $author$project$Evergreen$V419$Audio$w3_unsafe_decode_Source),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$LoadedPopSound));
			case 49:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$LoginForm$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$LoginFormMsg));
			case 50:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MessageInput$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$MessageInputMsg))));
			case 51:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$MessageMenuAnimated));
			case 52:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$NonemptySet$w3_unsafe_decode_NonemptySet(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_CustomEmojiId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$MessageMenu_PressedAddCustomEmojisToUser));
			case 53:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$MessageMenu_PressedClose);
			case 54:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$MessageMenu_PressedContainer);
			case 55:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$MessageMenu_PressedDeleteMessage)));
			case 56:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$MessageMenu_PressedEditMessage)));
			case 57:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$MessageMenu_PressedMarkAsUnread)));
			case 58:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_PrivateChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$MessageMenu_PressedOpenDiscordDm)));
			case 59:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$MessageMenu_PressedOpenDm));
			case 60:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$MessageMenu_PressedOpenThread));
			case 61:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$MessageMenu_PressedReactionEmoji));
			case 62:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$MessageMenu_PressedReply));
			case 63:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Coord$w3_unsafe_decode_Coord($author$project$Evergreen$V419$CssPixels$w3_unsafe_decode_CssPixels),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$MessageMenu_PressedShowReactionEmojiSelector))));
			case 64:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MessageView$w3_unsafe_decode_MessageViewMsg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$MessageViewMsg))));
			case 65:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Types$w3_unsafe_decode_NewChannelForm,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$NewChannelFormChanged)));
			case 66:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Types$w3_unsafe_decode_NewGuildForm,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$NewGuildFormChanged));
			case 67:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$OneFrameAfterDragEnd);
			case 68:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PageFocusSettled);
			case 69:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PageHasFocusChanged));
			case 70:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Error, $lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Viewport),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PageUpGotViewport));
			case 71:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedAccountDeletionBanner);
			case 72:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedAddDomainToWhitelist));
			case 73:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedAddPrivateKeyToAccount);
			case 74:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedBanMember)));
			case 75:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedBody);
			case 76:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedCancelE2eeRequest));
			case 77:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedCancelMessageEdit));
			case 78:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedChannelHeaderBackButton);
			case 79:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_ChannelHeaderTab,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedChannelHeaderTab));
			case 80:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedCloseAccountDeletionBanner);
			case 81:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedCloseExternalLinkWarning);
			case 82:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedCloseImageInfo);
			case 83:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedCloseNewPrivateKey);
			case 84:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedCloseOverlay);
			case 85:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedCloseReplyTo));
			case 86:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedContinueToSite);
			case 87:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedCopyImage));
			case 88:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedCopyText));
			case 89:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedCreateInviteLink));
			case 90:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedDeclineE2eeRequest));
			case 91:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedDeleteAccount);
			case 92:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedDeleteAttachedFile)));
			case 93:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedDeleteChannel)));
			case 94:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedDeleteGuild));
			case 95:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$SecretId$w3_unsafe_decode_SecretId($author$project$Evergreen$V419$Id$w3_unsafe_decode_InviteLinkId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedDeleteInviteLink)));
			case 96:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedDisableE2ee));
			case 97:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedDiscordAcknowledgment));
			case 98:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (currentUserId0, otherUserId0) {
										return {currentUserId: currentUserId0, otherUserId: otherUserId0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedDiscordGuildMemberLabel));
			case 99:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$User$w3_unsafe_decode_NotificationLevel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedDiscordGuildNotificationLevel))));
			case 100:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedE2eeRisksAccepted));
			case 101:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedEnableE2ee));
			case 102:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_UserOptionSection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedExpandContainer));
			case 103:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedExpandE2eeSection));
			case 104:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_ExportChannelId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedExportChannel));
			case 105:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$User$w3_unsafe_decode_NotificationLevel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedGuildNotificationLevel)));
			case 106:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedHideMembers);
			case 107:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedHomePagePreview));
			case 108:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedImportChannel));
			case 109:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedLeaveGuild));
			case 110:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Route$w3_unsafe_decode_Route,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedLink));
			case 111:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedLoadDebugData);
			case 112:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$SessionIdHash$w3_unsafe_decode_SessionIdHash,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedLogOut));
			case 113:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedMarkAllChannelsAsRead));
			case 114:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedMarkChannelAsRead)));
			case 115:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedMemberListBack);
			case 116:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedMuteChannel))));
			case 117:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedMuteDiscordChannel)))));
			case 118:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedMuteDiscordGuild))));
			case 119:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedMuteDiscordThread))))));
			case 120:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedMuteGuild)));
			case 121:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedMuteSlackChannel)))));
			case 122:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedMuteSlackThread))))));
			case 123:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedMuteSlackWorkspace))));
			case 124:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedMuteThread)))));
			case 125:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedNewMessagesWarning);
			case 126:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedNotification));
			case 127:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedReloadDiscordUser));
			case 128:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedReloadSlackUser));
			case 129:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedRemoveSlackTeam));
			case 130:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedResetDomainWhitelist);
			case 131:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedResetEditChannelChanges)));
			case 132:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedResetEditGuildChanges));
			case 133:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedResetUserColor);
			case 134:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedSaveDomainWhitelist);
			case 135:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedSearchOverlayArrowKey));
			case 136:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedSearchOverlayEnter);
			case 137:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Route$w3_unsafe_decode_Route,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedSearchOverlayResult));
			case 138:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedSelectNewColor);
			case 139:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedShowLogin);
			case 140:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedShowMembers);
			case 141:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedShowSearchOverlay);
			case 142:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedShowUserOption);
			case 143:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedSlackAcknowledgment));
			case 144:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$User$w3_unsafe_decode_NotificationLevel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_TeamId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedSlackWorkspaceNotificationLevel))));
			case 145:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Types$w3_unsafe_decode_EditChannelForm,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedSubmitEditChannelChanges))));
			case 146:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Types$w3_unsafe_decode_EditGuildForm,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedSubmitEditGuildChanges)));
			case 147:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Types$w3_unsafe_decode_NewChannelForm,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedSubmitNewChannel)));
			case 148:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Types$w3_unsafe_decode_NewGuildForm,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedSubmitNewGuild));
			case 149:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedSubmitSlackData);
			case 150:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedSubmitUserColor);
			case 151:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (fileId0, removeSpoiler0) {
										return {fileId: fileId0, removeSpoiler: removeSpoiler0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedToggleAttachedFileSpoiler)));
			case 152:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$SecretId$w3_unsafe_decode_SecretId($author$project$Evergreen$V419$Id$w3_unsafe_decode_InviteLinkId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedToggleInviteLinkQrCode));
			case 153:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Discord$w3_unsafe_decode_Id($author$project$Evergreen$V419$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedUnlinkDiscordUser));
			case 154:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Slack$w3_unsafe_decode_Id($author$project$Evergreen$V419$Slack$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedUnlinkSlackUser));
			case 155:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedUnregisterServiceWorkers);
			case 156:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$PressedViewAttachedFileInfo)));
			case 157:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$ImageEditor$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$ProfilePictureEditorMsg));
			case 158:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$RecoveryLogin$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$RecoveryLoginMsg));
			case 159:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$RemoveFocus);
			case 160:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (bottom0, top0) {
										return {bottom: bottom0, top: top0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$SafeAreaInsetsChanged));
			case 161:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$ScrolledToLogSection);
			case 162:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$ScrolledToMessage);
			case 163:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$User$w3_unsafe_decode_EmailNotifications,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$SelectedEmailNotifications));
			case 164:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$User$w3_unsafe_decode_EmbedVisibility,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$SelectedEmbedVisibility));
			case 165:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$program_test$Effect$File$w3_unsafe_decode_File),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$File$w3_unsafe_decode_File,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$SelectedFilesToAttach))));
			case 166:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$File$w3_unsafe_decode_File,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$SelectedImportChannelFile)));
			case 167:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserSession$w3_unsafe_decode_NotificationMode,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$SelectedNotificationMode));
			case 168:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$UserColor$w3_unsafe_decode_Selection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$SelectedUserColor));
			case 169:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$SetFocus);
			case 170:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$SetScrollToBottom);
			case 171:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$TextEditor$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$TextEditorMsg));
			case 172:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_HtmlId),
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Evergreen$V419$Range$w3_unsafe_decode_Range, $author$project$Evergreen$V419$Range$w3_unsafe_decode_SelectionDirection))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$TextSelectionChanged));
			case 173:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$TouchCancel));
			case 174:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$TouchEnd));
			case 175:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$NonemptyDict$w3_unsafe_decode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$Evergreen$V419$Touch$w3_unsafe_decode_Touch),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$TouchMoved)));
			case 176:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$NonemptyDict$w3_unsafe_decode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$Evergreen$V419$Touch$w3_unsafe_decode_Touch),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$TouchStart)));
			case 177:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$TwoFactorAuthentication$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$TwoFactorMsg));
			case 178:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$TypedDiscordLinkBookmarklet);
			case 179:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$TypedDomainWhitelist));
			case 180:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$TypedPrivateKey)));
			case 181:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$TypedSearchOverlay));
			case 182:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$TypedSlackCookie));
			case 183:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$TypedSlackTeamsJson));
			case 184:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MessageView$w3_unsafe_decode_MessageViewMsg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$UnreadOverviewChannelMsg))));
			case 185:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$MessageView$w3_unsafe_decode_MessageViewMsg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_Id($author$project$Evergreen$V419$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$UnreadOverviewThreadMsg)))));
			case 186:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$elm$url$Url$w3_unsafe_decode_Url,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$UrlChanged));
			case 187:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$elm$browser$Browser$w3_unsafe_decode_UrlRequest,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$UrlClicked));
			case 188:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Editable$w3_unsafe_decode_Msg($author$project$Evergreen$V419$PersonName$w3_unsafe_decode_PersonName),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$UserNameEditableMsg));
			case 189:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Scroll$w3_unsafe_decode_ScrollPosition,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Id$w3_unsafe_decode_ThreadRoute,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$UserScrolled))));
			case 190:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Types$w3_unsafe_decode_E2eeKeysValid,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$ValidatedE2eePrivateKey)));
			case 191:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeFloat,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (height0, top0) {
										return {height: height0, top: top0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$VisualViewportChanged));
			case 192:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Call$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Types$VoiceChatMsg));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Audio$w3_unsafe_decode_AudioLoadRequest_ = function (w3_x_c_userMsg) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
			$lamdera$codecs$Lamdera$Wire3$decodePair$(
				$lamdera$codecs$Lamdera$Wire3$decodeResult$($author$project$Evergreen$V419$Audio$w3_unsafe_decode_LoadError, $author$project$Evergreen$V419$Audio$w3_unsafe_decode_Source),
				w3_x_c_userMsg)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F2(
					function (audioUrl0, userMsg0) {
						return {audioUrl: audioUrl0, userMsg: userMsg0};
					}))));
};
var $author$project$Evergreen$V419$Audio$w3_unsafe_decode_LoopConfig = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (loopEnd0, loopStart0) {
					return {loopEnd: loopEnd0, loopStart: loopStart0};
				}))));
var $author$project$Evergreen$V419$Audio$w3_unsafe_decode_FlattenedAudio = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeList(
		$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
			$lamdera$codecs$Lamdera$Wire3$decodePair$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$andThenDecode,
					function (t) {
						return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
							$elm$time$Time$millisToPosix(t));
					},
					$lamdera$codecs$Lamdera$Wire3$decodeInt),
				$lamdera$codecs$Lamdera$Wire3$decodeFloat))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeFloat,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			A2(
				$lamdera$codecs$Lamdera$Wire3$andThenDecode,
				function (t) {
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
						$elm$time$Time$millisToPosix(t));
				},
				$lamdera$codecs$Lamdera$Wire3$decodeInt),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Audio$w3_unsafe_decode_Source,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Evergreen$V419$Audio$w3_unsafe_decode_LoopConfig),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F8(
										function (loop0, offset0, playbackRate0, source0, startAt0, startTime0, volume0, volumeTimelines0) {
											return {loop: loop0, offset: offset0, playbackRate: playbackRate0, source: source0, startAt: startAt0, startTime: startTime0, volume: volume0, volumeTimelines: volumeTimelines0};
										}))))))))));
var $author$project$Evergreen$V419$Audio$w3_unsafe_decode_NodeGroupId = $lamdera$codecs$Lamdera$Wire3$decodeInt;
var $author$project$Evergreen$V419$Audio$w3_unsafe_decode_SourceData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
	$lamdera$codecs$Lamdera$Wire3$succeedDecode(
		function (duration0) {
			return {duration: duration0};
		}));
var $author$project$Evergreen$V419$Audio$w3_unsafe_decode_Model_$ = function (w3_x_c_userMsg, w3_x_c_userModel) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		w3_x_c_userModel,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$Evergreen$V419$Audio$w3_unsafe_decode_SourceData),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeDict$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$author$project$Evergreen$V419$Audio$w3_unsafe_decode_AudioLoadRequest_(w3_x_c_userMsg)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeDict$($author$project$Evergreen$V419$Audio$w3_unsafe_decode_NodeGroupId, $author$project$Evergreen$V419$Audio$w3_unsafe_decode_FlattenedAudio),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F7(
										function (audioState0, nodeGroupIdCounter0, pendingRequests0, requestCount0, samplesPerSecond0, sourceData0, userModel0) {
											return {audioState: audioState0, nodeGroupIdCounter: nodeGroupIdCounter0, pendingRequests: pendingRequests0, requestCount: requestCount0, samplesPerSecond: samplesPerSecond0, sourceData: sourceData0, userModel: userModel0};
										})))))))));
};
var $author$project$Evergreen$V419$Audio$w3_unsafe_decode_Model_ = F2($author$project$Evergreen$V419$Audio$w3_unsafe_decode_Model_$);
var $author$project$Evergreen$V419$Audio$w3_unsafe_decode_Model$ = function (w3_x_c_userMsg, w3_x_c_userModel) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Evergreen$V419$Audio$w3_unsafe_decode_Model_$(w3_x_c_userMsg, w3_x_c_userModel),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V419$Audio$w3_unsafe_decode_Model = F2($author$project$Evergreen$V419$Audio$w3_unsafe_decode_Model$);
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_FrontendModel = $author$project$Evergreen$V419$Audio$w3_unsafe_decode_Model$($author$project$Evergreen$V419$Types$w3_unsafe_decode_FrontendMsg_, $author$project$Evergreen$V419$Types$w3_unsafe_decode_FrontendModel_);
var $author$project$Emoji$w3_unsafe_decode_EmojiArt = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (sequence0, sprite0) {
					return {sequence: sequence0, sprite: sprite0};
				}))));
var $author$project$Emoji$w3_unsafe_decode_EmojiCategory = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(8);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(9);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Emoji$w3_unsafe_decode_EmojiData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeString),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Emoji$w3_unsafe_decode_EmojiCategory,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (category0, shortNames0, skinVariations0) {
						return {category: category0, shortNames: shortNames0, skinVariations: skinVariations0};
					})))));
var $author$project$Emoji$w3_unsafe_decode_UnicodeEmoji = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Emoji$w3_unsafe_decode_CachedEmojiData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeArray(
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Emoji$w3_unsafe_decode_UnicodeEmoji,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F2(
						function (emoji0, shortName0) {
							return {emoji: emoji0, shortName: shortName0};
						}))))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$($author$project$Emoji$w3_unsafe_decode_UnicodeEmoji, $author$project$Emoji$w3_unsafe_decode_EmojiData),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Emoji$w3_unsafe_decode_EmojiCategory,
				$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Emoji$w3_unsafe_decode_UnicodeEmoji)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeDict$(
					$lamdera$codecs$Lamdera$Wire3$decodeChar,
					$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Emoji$w3_unsafe_decode_EmojiArt)),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (art0, categories0, emojis0, shortNames0) {
							return {art: art0, categories: categories0, emojis: emojis0, shortNames: shortNames0};
						}))))));
var $author$project$Coord$w3_unsafe_decode_Coord = function (w3_x_c_units) {
	return $lamdera$codecs$Lamdera$Wire3$decodePair$(
		$ianmackenzie$elm_units$Quantity$w3_unsafe_decode_Quantity$($lamdera$codecs$Lamdera$Wire3$decodeInt, w3_x_c_units),
		$ianmackenzie$elm_units$Quantity$w3_unsafe_decode_Quantity$($lamdera$codecs$Lamdera$Wire3$decodeInt, w3_x_c_units));
};
var $author$project$CssPixels$CssPixels = $elm$core$Basics$identity;
var $author$project$CssPixels$w3_unsafe_decode_CssPixels = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Touch$w3_unsafe_decode_DragTarget = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$NonemptyDict$w3_unsafe_decode_NonemptyDict$ = function (w3_x_c_id, w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(w3_x_c_id, w3_x_c_a),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_a,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							w3_x_c_id,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$NonemptyDict$NonemptyDict))));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$NonemptyDict$w3_unsafe_decode_NonemptyDict = F2($author$project$NonemptyDict$w3_unsafe_decode_NonemptyDict$);
var $author$project$Geometry$Types$w3_unsafe_decode_Point2d$ = function (w3_x_c_units, w3_x_c_coordinates) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeFloat,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (x0, y0) {
										return {x: x0, y: y0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Geometry$Types$w3_unsafe_decode_Point2d = F2($author$project$Geometry$Types$w3_unsafe_decode_Point2d$);
var $author$project$Point2d$w3_unsafe_decode_Point2d$ = function (w3_x_c_units, w3_x_c_coordinates) {
	return $author$project$Geometry$Types$w3_unsafe_decode_Point2d$(w3_x_c_units, w3_x_c_coordinates);
};
var $author$project$Point2d$w3_unsafe_decode_Point2d = F2($author$project$Point2d$w3_unsafe_decode_Point2d$);
var $author$project$Touch$ScreenCoordinate = $elm$core$Basics$identity;
var $author$project$Touch$w3_unsafe_decode_ScreenCoordinate = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Touch$w3_unsafe_decode_Touch = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Point2d$w3_unsafe_decode_Point2d$($author$project$CssPixels$w3_unsafe_decode_CssPixels, $author$project$Touch$w3_unsafe_decode_ScreenCoordinate),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (client0, targetIsTextInput0) {
					return {client: client0, targetIsTextInput: targetIsTextInput0};
				}))));
var $author$project$Touch$w3_unsafe_decode_Drag = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$NonemptyDict$w3_unsafe_decode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$Touch$w3_unsafe_decode_Touch),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Touch$DragStart)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$NonemptyDict$w3_unsafe_decode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$Touch$w3_unsafe_decode_Touch),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Touch$w3_unsafe_decode_DragTarget,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeBool,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (horizontalStart0, target0, touches0) {
											return {horizontalStart: horizontalStart0, target: target0, touches: touches0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Touch$Dragging));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Touch$NoDrag);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$AiChat$w3_unsafe_decode_AiModelName = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$AiChat$w3_unsafe_decode_AiModel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeString),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$AiChat$w3_unsafe_decode_AiModelName,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, inputs0) {
					return {id: id0, inputs: inputs0};
				}))));
var $author$project$AiChat$w3_unsafe_decode_AiModelsStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$AiChat$w3_unsafe_decode_AiModel),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$AiChat$LoadedAiModels));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$AiChat$LoadingAiModels);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$AiChat$LoadingFailed));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$AiChat$w3_unsafe_decode_PendingResponse = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$AiChat$w3_unsafe_decode_AiModelName,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$AiChat$GotError)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeFloat),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeString,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$AiChat$w3_unsafe_decode_AiModelName,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$AiChat$GotResponse)))));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$AiChat$w3_unsafe_decode_AiModelName,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$AiChat$Pending));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$AiChat$w3_unsafe_decode_ResponseId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$AiChat$w3_unsafe_decode_SendMessageWith = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$AiChat$w3_unsafe_decode_FrontendModel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$AiChat$w3_unsafe_decode_SendMessageWith,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$AiChat$w3_unsafe_decode_AiModelName),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$($author$project$AiChat$w3_unsafe_decode_ResponseId, $author$project$AiChat$w3_unsafe_decode_PendingResponse),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeString,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$AiChat$w3_unsafe_decode_AiModelsStatus,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F9(
											function (aiModels0, chatHistory0, debounceCounter0, message0, pendingResponses0, responseCounter0, selectedModels0, sendMessageWith0, showOptions0) {
												return {aiModels: aiModels0, chatHistory: chatHistory0, debounceCounter: debounceCounter0, message: message0, pendingResponses: pendingResponses0, responseCounter: responseCounter0, selectedModels: selectedModels0, sendMessageWith: sendMessageWith0, showOptions: showOptions0};
											})))))))))));
var $author$project$MyUi$w3_unsafe_decode_Copied = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MyUi$CopiedImage));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MyUi$CopiedText));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$MyUi$w3_unsafe_decode_LastCopy = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (t) {
			return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
				$elm$time$Time$millisToPosix(t));
		},
		$lamdera$codecs$Lamdera$Wire3$decodeInt),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$MyUi$w3_unsafe_decode_Copied,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (copied0, copiedAt0) {
					return {copied: copied0, copiedAt: copiedAt0};
				}))));
var $author$project$Audio$w3_unsafe_decode_LoadError = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Id$InviteLinkId = $elm$core$Basics$identity;
var $author$project$Id$w3_unsafe_decode_InviteLinkId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Discord$ChannelId = $elm$core$Basics$identity;
var $author$project$Discord$w3_unsafe_decode_ChannelId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Discord$GuildId = $elm$core$Basics$identity;
var $author$project$Discord$w3_unsafe_decode_GuildId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Discord$w3_unsafe_decode_Id = function (w3_x_c_idType) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$MartinSStewart$elm_uint64$UInt64$w3_unsafe_decode_UInt64,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Discord$UserId = $elm$core$Basics$identity;
var $author$project$Discord$w3_unsafe_decode_UserId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Id$w3_unsafe_decode_Viewing_DiscordChannelId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (channelId0, currentUserId0, guildId0) {
						return {channelId: channelId0, currentUserId: currentUserId0, guildId: guildId0};
					})))));
var $author$project$Discord$PrivateChannelId = $elm$core$Basics$identity;
var $author$project$Discord$w3_unsafe_decode_PrivateChannelId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Id$w3_unsafe_decode_Viewing_DiscordDmId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (channelId0, currentUserId0) {
					return {channelId: channelId0, currentUserId: currentUserId0};
				}))));
var $author$project$Id$w3_unsafe_decode_DiscordGuildOrDmId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Viewing_DiscordDmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Id$DiscordGuildOrDmId_Dm));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Viewing_DiscordChannelId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Id$DiscordGuildOrDmId_Guild));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Id$ChannelId = $elm$core$Basics$identity;
var $author$project$Id$w3_unsafe_decode_ChannelId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Id$GuildId = $elm$core$Basics$identity;
var $author$project$Id$w3_unsafe_decode_GuildId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Id$w3_unsafe_decode_Id = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Id$w3_unsafe_decode_Viewing_ChannelId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (channelId0, guildId0) {
					return {channelId: channelId0, guildId: guildId0};
				}))));
var $author$project$Id$UserId = $elm$core$Basics$identity;
var $author$project$Id$w3_unsafe_decode_UserId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Id$w3_unsafe_decode_Viewing_DmId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$succeedDecode(
		function (otherUserId0) {
			return {otherUserId: otherUserId0};
		}));
var $author$project$Id$w3_unsafe_decode_GuildOrDmId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Viewing_DmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Id$GuildOrDmId_Dm));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Viewing_ChannelId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Id$GuildOrDmId_Guild));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Slack$ChannelId = $elm$core$Basics$identity;
var $author$project$Slack$w3_unsafe_decode_ChannelId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Slack$w3_unsafe_decode_Id = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Slack$TeamId = $elm$core$Basics$identity;
var $author$project$Slack$w3_unsafe_decode_TeamId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Slack$UserId = $elm$core$Basics$identity;
var $author$project$Slack$w3_unsafe_decode_UserId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Id$w3_unsafe_decode_Viewing_SlackChannelId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (channelId0, currentUserId0, teamId0) {
						return {channelId: channelId0, currentUserId: currentUserId0, teamId: teamId0};
					})))));
var $author$project$Slack$DmChannelId = $elm$core$Basics$identity;
var $author$project$Slack$w3_unsafe_decode_DmChannelId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Id$w3_unsafe_decode_Viewing_SlackDmId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_DmChannelId),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (channelId0, currentUserId0) {
					return {channelId: channelId0, currentUserId: currentUserId0};
				}))));
var $author$project$Id$w3_unsafe_decode_SlackGuildOrDmId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Viewing_SlackDmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Id$SlackGuildOrDmId_Dm));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Viewing_SlackChannelId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Id$SlackGuildOrDmId_Workspace));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Id$w3_unsafe_decode_AnyGuildOrDmId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_DiscordGuildOrDmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Id$DiscordGuildOrDmId));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_GuildOrDmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Id$GuildOrDmId));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_SlackGuildOrDmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Id$SlackGuildOrDmId));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Id$ChannelMessageId = $elm$core$Basics$identity;
var $author$project$Id$w3_unsafe_decode_ChannelMessageId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Route$w3_unsafe_decode_ChannelSidebarMode = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeFloat,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeFloat,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (offset0, previousOffset0, time0) {
											return {offset: offset0, previousOffset: previousOffset0, time: time0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Route$ChannelSidebarDragging));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							function (offset0) {
								return {offset: offset0};
							})),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Route$ChannelSidebarNotDragging));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Types$w3_unsafe_decode_EditChannelForm = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (deleteConfirmation0, description0, name0, pressedSubmit0, showDeleteConfirmation0) {
								return {deleteConfirmation: deleteConfirmation0, description: description0, name: name0, pressedSubmit: pressedSubmit0, showDeleteConfirmation: showDeleteConfirmation0};
							})))))));
var $author$project$Types$NotAChannelExport = 0;
var $author$project$Types$w3_unsafe_decode_ImportChannelError = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Types$w3_unsafe_decode_ImportChannelStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Types$w3_unsafe_decode_ImportChannelError,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$ImportChannelFailed));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							function (encryptedMessages0) {
								return {encryptedMessages: encryptedMessages0};
							})),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$ImportedChannel));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$ImportingChannel);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$NotImportingChannel);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Types$w3_unsafe_decode_EditGuildForm = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeBool,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Types$w3_unsafe_decode_ImportChannelStatus,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F6(
								function (deleteConfirmation0, importChannel0, name0, pressedSubmit0, showDeleteConfirmation0, showLeaveConfirmation0) {
									return {deleteConfirmation: deleteConfirmation0, importChannel: importChannel0, name: name0, pressedSubmit: pressedSubmit0, showDeleteConfirmation: showDeleteConfirmation0, showLeaveConfirmation: showLeaveConfirmation0};
								}))))))));
var $author$project$FileStatus$FileId = $elm$core$Basics$identity;
var $author$project$FileStatus$w3_unsafe_decode_FileId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$FileStatus$w3_unsafe_decode_ContentType = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$FileStatus$w3_unsafe_decode_FileHash = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$FileStatus$w3_unsafe_decode_ExposureTime = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (denominator0, numerator0) {
					return {denominator: denominator0, numerator: numerator0};
				}))));
var $author$project$SafeFloat$w3_unsafe_decode_SafeFloat = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeFloat,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$FileStatus$w3_unsafe_decode_Location = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$SafeFloat$w3_unsafe_decode_SafeFloat,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$SafeFloat$w3_unsafe_decode_SafeFloat,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (lat0, lon0) {
					return {lat: lat0, lon: lon0};
				}))));
var $author$project$FileStatus$w3_unsafe_decode_Orientation = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$FileStatus$w3_unsafe_decode_ImageMetadata = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$FileStatus$w3_unsafe_decode_Orientation),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Coord$w3_unsafe_decode_Coord($author$project$CssPixels$w3_unsafe_decode_CssPixels),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$FileStatus$w3_unsafe_decode_Location),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$SafeFloat$w3_unsafe_decode_SafeFloat),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$SafeFloat$w3_unsafe_decode_SafeFloat),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$FileStatus$w3_unsafe_decode_ExposureTime),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
												$lamdera$codecs$Lamdera$Wire3$succeedDecode(
													function (cameraOwner0) {
														return function (exposureTime0) {
															return function (fNumber0) {
																return function (focalLength0) {
																	return function (gpsLocation0) {
																		return function (imageSize0) {
																			return function (isoSpeedRating0) {
																				return function (make0) {
																					return function (model0) {
																						return function (orientation0) {
																							return function (software0) {
																								return function (userComment0) {
																									return {cameraOwner: cameraOwner0, exposureTime: exposureTime0, fNumber: fNumber0, focalLength: focalLength0, gpsLocation: gpsLocation0, imageSize: imageSize0, isoSpeedRating: isoSpeedRating0, make: make0, model: model0, orientation: orientation0, software: software0, userComment: userComment0};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													})))))))))))));
var $author$project$FileStatus$w3_unsafe_decode_VideoMetadata = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Coord$w3_unsafe_decode_Coord($author$project$CssPixels$w3_unsafe_decode_CssPixels),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$FileStatus$w3_unsafe_decode_Orientation,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$FileStatus$w3_unsafe_decode_Location),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F7(
									function (codec0, createdAt0, duration0, gpsLocation0, orientation0, title0, videoSize0) {
										return {codec: codec0, createdAt: createdAt0, duration: duration0, gpsLocation: gpsLocation0, orientation: orientation0, title: title0, videoSize: videoSize0};
									})))))))));
var $author$project$FileStatus$w3_unsafe_decode_FileMetadata = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$FileStatus$w3_unsafe_decode_ImageMetadata,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$FileStatus$FileMetadata_Image));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$FileStatus$w3_unsafe_decode_VideoMetadata,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$FileStatus$FileMetadata_Video));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$FileName$w3_unsafe_decode_FileName = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$FileStatus$w3_unsafe_decode_AesPrivateKey = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeBytes,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$FileStatus$w3_unsafe_decode_EncryptedThumbnail = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$FileStatus$w3_unsafe_decode_IsEncrypted = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$FileStatus$w3_unsafe_decode_EncryptedThumbnail,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$FileStatus$w3_unsafe_decode_AesPrivateKey,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$FileStatus$IsEncrypted)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$FileStatus$IsNotEncrypted);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$FileStatus$w3_unsafe_decode_FileData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$FileStatus$w3_unsafe_decode_FileMetadata),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$FileStatus$w3_unsafe_decode_IsEncrypted,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$FileName$w3_unsafe_decode_FileName,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$FileStatus$w3_unsafe_decode_FileHash,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$FileStatus$w3_unsafe_decode_ContentType,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F6(
								function (contentType0, fileHash0, fileName0, fileSize0, isEncrypted0, metadata0) {
									return {contentType: contentType0, fileHash: fileHash0, fileName: fileName0, fileSize: fileSize0, isEncrypted: isEncrypted0, metadata: metadata0};
								}))))))));
var $author$project$FileStatus$w3_unsafe_decode_FileStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$FileStatus$w3_unsafe_decode_IsEncrypted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$FileStatus$w3_unsafe_decode_ContentType,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$FileName$w3_unsafe_decode_FileName,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$FileStatus$FileError))))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$FileStatus$w3_unsafe_decode_FileData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$FileStatus$FileUploaded));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$FileStatus$w3_unsafe_decode_IsEncrypted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$FileStatus$w3_unsafe_decode_ContentType,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeInt,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F2(
											function (sent0, size0) {
												return {sent: sent0, size: size0};
											})))),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$FileName$w3_unsafe_decode_FileName,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$FileStatus$FileUploading)))));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Types$w3_unsafe_decode_EditMessage = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
				$author$project$FileStatus$w3_unsafe_decode_FileStatus),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (attachedFiles0, messageIndex0, text0) {
						return {attachedFiles: attachedFiles0, messageIndex: messageIndex0, text: text0};
					})))));
var $author$project$Id$QuestionId = $elm$core$Basics$identity;
var $author$project$Id$w3_unsafe_decode_QuestionId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$SheepGame$w3_unsafe_decode_Input = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$AnswerInput));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$NotesInput));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$QuestionInput));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Range$w3_unsafe_decode_Range = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (end0, start0) {
					return {end: end0, start: start0};
				}))));
var $author$project$SheepGame$w3_unsafe_decode_ReactionTarget = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$AnswerReaction)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$NotesReaction));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$WordSpellingGame$w3_unsafe_decode_ReactionTarget = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Id$ThreadMessageId = $elm$core$Basics$identity;
var $author$project$Id$w3_unsafe_decode_ThreadMessageId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Id$NoThreadWithMessage));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ThreadMessageId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Id$ViewThreadWithMessage)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Types$w3_unsafe_decode_EmojiSelector = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Range$w3_unsafe_decode_Range),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Coord$w3_unsafe_decode_Coord($author$project$CssPixels$w3_unsafe_decode_CssPixels),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$EmojiSelectorForEditMessage)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Range$w3_unsafe_decode_Range),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$EmojiSelectorForMessage));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$EmojiSelectorForReaction)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Range$w3_unsafe_decode_Range),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Coord$w3_unsafe_decode_Coord($author$project$CssPixels$w3_unsafe_decode_CssPixels),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$SheepGame$w3_unsafe_decode_Input,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$EmojiSelectorForSheepGameInput))));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$SheepGame$w3_unsafe_decode_ReactionTarget,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_GuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$EmojiSelectorForSheepGameReaction))));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$WordSpellingGame$w3_unsafe_decode_ReactionTarget,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_GuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$EmojiSelectorForWordSpellingGameReaction))));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$EmojiSelectorHidden);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Encryption$DecryptManyRequestId = $elm$core$Basics$identity;
var $author$project$Encryption$w3_unsafe_decode_DecryptManyRequestId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Encryption$DecryptRequestId = $elm$core$Basics$identity;
var $author$project$Encryption$w3_unsafe_decode_DecryptRequestId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Encryption$EncryptFileRequestId = $elm$core$Basics$identity;
var $author$project$Encryption$w3_unsafe_decode_EncryptFileRequestId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Encryption$EncryptManyRequestId = $elm$core$Basics$identity;
var $author$project$Encryption$w3_unsafe_decode_EncryptManyRequestId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Encryption$EncryptRequestId = $elm$core$Basics$identity;
var $author$project$Encryption$w3_unsafe_decode_EncryptRequestId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Encryption$w3_unsafe_decode_BytesHash = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Types$w3_unsafe_decode_PendingDecryptedManyMessages = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_HtmlId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Encryption$w3_unsafe_decode_BytesHash),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (messageHashes0, shiftScrollFrom0) {
					return {messageHashes: messageHashes0, shiftScrollFrom: shiftScrollFrom0};
				}))));
var $author$project$Message$w3_unsafe_decode_RepliedToGame = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Message$RepliedTo_SheepGameAnswer)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Message$RepliedTo_SheepGameNotes));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Message$RepliedTo_WordSpellingGameMove));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Message$w3_unsafe_decode_RepliedTo = function (w3_x_c_messageId) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Message$NoReply);
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Message$w3_unsafe_decode_RepliedToGame,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Message$RepliedToGame)));
				case 2:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id(w3_x_c_messageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Message$RepliedToMessage));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Message$w3_unsafe_decode_ThreadRouteWithRepliedTo = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Message$w3_unsafe_decode_RepliedTo($author$project$Id$w3_unsafe_decode_ChannelMessageId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Message$NoThreadWithRepliedTo));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ThreadMessageId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Message$ViewThreadWithRepliedTo)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Types$w3_unsafe_decode_PendingDecryptedMessage = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Message$w3_unsafe_decode_ThreadRouteWithRepliedTo,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Id$w3_unsafe_decode_Viewing_DmId,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Encryption$w3_unsafe_decode_BytesHash,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (hash0, id0, senderId0, threadRoute0) {
							return {hash: hash0, id: id0, senderId: senderId0, threadRoute: threadRoute0};
						}))))));
var $author$project$Types$w3_unsafe_decode_PendingDecryptedOldMessages = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Id$w3_unsafe_decode_Viewing_DmId,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, messages0) {
					return {id: id0, messages: messages0};
				}))));
var $author$project$Embed$w3_unsafe_decode_EmbedImageFormat = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(13);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(8);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(12);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(10);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(9);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(11);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(14);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Embed$w3_unsafe_decode_EmbedImageData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Coord$w3_unsafe_decode_Coord($author$project$CssPixels$w3_unsafe_decode_CssPixels),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Embed$w3_unsafe_decode_EmbedImageFormat),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (format0, imageSize0, url0) {
						return {format: format0, imageSize: imageSize0, url: url0};
					})))));
var $author$project$Embed$w3_unsafe_decode_EmbedData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Embed$w3_unsafe_decode_EmbedImageData),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (createdAt0, description0, image0, title0) {
							return {createdAt: createdAt0, description: description0, image: image0, title: title0};
						}))))));
var $author$project$Embed$w3_unsafe_decode_Embed = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Embed$w3_unsafe_decode_EmbedData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Embed$EmbedLoaded));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Embed$EmbedLoading);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Id$CustomEmojiId = $elm$core$Basics$identity;
var $author$project$Id$w3_unsafe_decode_CustomEmojiId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$RichText$w3_unsafe_decode_EscapedChar = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$RichText$w3_unsafe_decode_HasLeadingLineBreak = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$RichText$w3_unsafe_decode_HeadingLevel = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$RichText$w3_unsafe_decode_Language = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$RichText$Language));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$RichText$NoLanguage);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Id$StickerId = $elm$core$Basics$identity;
var $author$project$Id$w3_unsafe_decode_StickerId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$TimeInMinutes$w3_unsafe_decode_TimeInMinutes = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$RichText$w3_unsafe_decode_RichText$ = function (w3_x_c_userId, w3_x_c_channelId) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$RichText$AttachedFile));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeList(
							$author$project$RichText$w3_unsafe_decode_RichText$(w3_x_c_userId, w3_x_c_channelId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$RichText$w3_unsafe_decode_HasLeadingLineBreak,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$RichText$BlockQuote)));
				case 2:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$author$project$RichText$w3_unsafe_decode_RichText$(w3_x_c_userId, w3_x_c_channelId)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$RichText$Bold));
				case 3:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$lamdera$codecs$Lamdera$Wire3$decodeList(
								$author$project$RichText$w3_unsafe_decode_RichText$(w3_x_c_userId, w3_x_c_channelId))),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$RichText$w3_unsafe_decode_HasLeadingLineBreak,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$RichText$BulletPoint)));
				case 4:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							w3_x_c_channelId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$RichText$ChannelMention)));
				case 5:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$RichText$w3_unsafe_decode_Language,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$RichText$CodeBlock)));
				case 6:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_CustomEmojiId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$RichText$CustomEmoji));
				case 7:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$RichText$w3_unsafe_decode_EscapedChar,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$RichText$EscapedChar));
				case 8:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$author$project$RichText$w3_unsafe_decode_RichText$(w3_x_c_userId, w3_x_c_channelId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$RichText$w3_unsafe_decode_HasLeadingLineBreak,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$RichText$w3_unsafe_decode_HeadingLevel,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$RichText$Heading))));
				case 9:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$elm$url$Url$w3_unsafe_decode_Url,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$RichText$Hyperlink));
				case 10:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeChar,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$RichText$InlineCode)));
				case 11:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$author$project$RichText$w3_unsafe_decode_RichText$(w3_x_c_userId, w3_x_c_channelId)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$RichText$Italic));
				case 12:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$elm$url$Url$w3_unsafe_decode_Url,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$RichText$MarkdownLink)));
				case 13:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeChar,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$RichText$NormalText)));
				case 14:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$author$project$RichText$w3_unsafe_decode_RichText$(w3_x_c_userId, w3_x_c_channelId)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$RichText$Spoiler));
				case 15:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_StickerId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$RichText$Sticker));
				case 16:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$author$project$RichText$w3_unsafe_decode_RichText$(w3_x_c_userId, w3_x_c_channelId)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$RichText$Strikethrough));
				case 17:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$TimeInMinutes$w3_unsafe_decode_TimeInMinutes,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$RichText$Timestamp));
				case 18:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$author$project$RichText$w3_unsafe_decode_RichText$(w3_x_c_userId, w3_x_c_channelId)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$RichText$Underline));
				case 19:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_userId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$RichText$UserMention));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$RichText$w3_unsafe_decode_RichText = F2($author$project$RichText$w3_unsafe_decode_RichText$);
var $author$project$Message$w3_unsafe_decode_MessageContent$ = function (w3_x_c_userId, w3_x_c_channelId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Embed$w3_unsafe_decode_Embed),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
				$author$project$RichText$w3_unsafe_decode_RichText$(w3_x_c_userId, w3_x_c_channelId)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
					$author$project$FileStatus$w3_unsafe_decode_FileData),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F3(
						function (attachedFiles0, content0, embeds0) {
							return {attachedFiles: attachedFiles0, content: content0, embeds: embeds0};
						})))));
};
var $author$project$Message$w3_unsafe_decode_MessageContent = F2($author$project$Message$w3_unsafe_decode_MessageContent$);
var $author$project$Types$w3_unsafe_decode_PendingEncryptedEdit = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Id$w3_unsafe_decode_Viewing_DmId,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Message$w3_unsafe_decode_MessageContent$(
				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId)),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (contentAndEmbeds0, id0, threadRoute0) {
						return {contentAndEmbeds: contentAndEmbeds0, id: id0, threadRoute: threadRoute0};
					})))));
var $author$project$Id$w3_unsafe_decode_ThreadRoute = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Id$NoThread);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Id$ViewThread));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Types$w3_unsafe_decode_PendingEncryptedFile = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Id$w3_unsafe_decode_ThreadRoute),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (fileId0, guildOrDmId0) {
					return {fileId: fileId0, guildOrDmId: guildOrDmId0};
				}))));
var $author$project$Types$w3_unsafe_decode_PendingEncryptedManyMessages = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeList(
		$lamdera$codecs$Lamdera$Wire3$decodePair$(
			$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
			$author$project$Message$w3_unsafe_decode_MessageContent$(
				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId)))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Id$w3_unsafe_decode_Viewing_DmId,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, messages0) {
					return {id: id0, messages: messages0};
				}))));
var $author$project$Types$w3_unsafe_decode_PendingEncryptedMessage = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Message$w3_unsafe_decode_ThreadRouteWithRepliedTo,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Message$w3_unsafe_decode_MessageContent$(
				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId)),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (contentAndEmbeds0, otherUserId0, threadRoute0) {
						return {contentAndEmbeds: contentAndEmbeds0, otherUserId: otherUserId0, threadRoute: threadRoute0};
					})))));
var $author$project$Types$w3_unsafe_decode_EncryptionRequests = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Id$w3_unsafe_decode_Id($author$project$Encryption$w3_unsafe_decode_EncryptManyRequestId),
		$author$project$Types$w3_unsafe_decode_PendingEncryptedMessage),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Id$w3_unsafe_decode_Id($author$project$Encryption$w3_unsafe_decode_EncryptManyRequestId),
			$author$project$Types$w3_unsafe_decode_PendingEncryptedManyMessages),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Id$w3_unsafe_decode_Id($author$project$Encryption$w3_unsafe_decode_EncryptFileRequestId),
				$author$project$Types$w3_unsafe_decode_PendingEncryptedFile),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Encryption$w3_unsafe_decode_EncryptRequestId),
					$author$project$Types$w3_unsafe_decode_PendingEncryptedEdit),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Encryption$w3_unsafe_decode_DecryptManyRequestId),
						$author$project$Types$w3_unsafe_decode_PendingDecryptedOldMessages),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Encryption$w3_unsafe_decode_DecryptRequestId),
							$author$project$Types$w3_unsafe_decode_PendingDecryptedMessage),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqDict$decodeDict$(
								$author$project$Id$w3_unsafe_decode_Id($author$project$Encryption$w3_unsafe_decode_DecryptManyRequestId),
								$author$project$Types$w3_unsafe_decode_PendingDecryptedManyMessages),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_Id($author$project$Encryption$w3_unsafe_decode_EncryptRequestId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Id$w3_unsafe_decode_Id($author$project$Encryption$w3_unsafe_decode_EncryptManyRequestId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Id$w3_unsafe_decode_Id($author$project$Encryption$w3_unsafe_decode_EncryptFileRequestId),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Id$w3_unsafe_decode_Id($author$project$Encryption$w3_unsafe_decode_DecryptRequestId),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$author$project$Id$w3_unsafe_decode_Id($author$project$Encryption$w3_unsafe_decode_DecryptManyRequestId),
												$lamdera$codecs$Lamdera$Wire3$succeedDecode(
													function (nextDecryptManyRequestId0) {
														return function (nextDecryptionRequestId0) {
															return function (nextEncryptFileRequestId0) {
																return function (nextEncryptManyRequestId0) {
																	return function (nextEncryptionRequestId0) {
																		return function (pendingDecryptedManyMessages0) {
																			return function (pendingDecryptedMessages0) {
																				return function (pendingDecryptedOldMessages0) {
																					return function (pendingEncryptedEdits0) {
																						return function (pendingEncryptedFiles0) {
																							return function (pendingEncryptedManyMessages0) {
																								return function (pendingEncryptedMessages0) {
																									return {nextDecryptManyRequestId: nextDecryptManyRequestId0, nextDecryptionRequestId: nextDecryptionRequestId0, nextEncryptFileRequestId: nextEncryptFileRequestId0, nextEncryptManyRequestId: nextEncryptManyRequestId0, nextEncryptionRequestId: nextEncryptionRequestId0, pendingDecryptedManyMessages: pendingDecryptedManyMessages0, pendingDecryptedMessages: pendingDecryptedMessages0, pendingDecryptedOldMessages: pendingDecryptedOldMessages0, pendingEncryptedEdits: pendingEncryptedEdits0, pendingEncryptedFiles: pendingEncryptedFiles0, pendingEncryptedManyMessages: pendingEncryptedManyMessages0, pendingEncryptedMessages: pendingEncryptedMessages0};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													})))))))))))));
var $author$project$FileStatus$w3_unsafe_decode_FileDataWithImage = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$FileStatus$w3_unsafe_decode_FileMetadata,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$FileStatus$w3_unsafe_decode_IsEncrypted,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$FileName$w3_unsafe_decode_FileName,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$FileStatus$w3_unsafe_decode_FileHash,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$FileStatus$w3_unsafe_decode_ContentType,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F6(
								function (contentType0, fileHash0, fileName0, fileSize0, isEncrypted0, metadata0) {
									return {contentType: contentType0, fileHash: fileHash0, fileName: fileName0, fileSize: fileSize0, isEncrypted: isEncrypted0, metadata: metadata0};
								}))))))));
var $author$project$OneOrGreater$w3_unsafe_decode_OneOrGreater = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Types$w3_unsafe_decode_FileDrag = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$OneOrGreater$w3_unsafe_decode_OneOrGreater,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$FileDragging)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$NoFileDrag));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Local$w3_unsafe_decode_ChangeId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Local$w3_unsafe_decode_Local$ = function (w3_x_c_msg, w3_x_c_model) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_model,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeDict$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									w3_x_c_msg,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										A2(
											$lamdera$codecs$Lamdera$Wire3$andThenDecode,
											function (t) {
												return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
													$elm$time$Time$millisToPosix(t));
											},
											$lamdera$codecs$Lamdera$Wire3$decodeInt),
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											F2(
												function (createdAt0, msg0) {
													return {createdAt: createdAt0, msg: msg0};
												}))))),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								w3_x_c_model,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Local$w3_unsafe_decode_ChangeId,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F4(
											function (counter0, localModel0, localMsgs0, serverModel0) {
												return {counter: counter0, localModel: localModel0, localMsgs: localMsgs0, serverModel: serverModel0};
											})))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Local$w3_unsafe_decode_Local = F2($author$project$Local$w3_unsafe_decode_Local$);
var $author$project$Types$ServerChange = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$Local_Invalid = {$: 0};
var $author$project$GuildName$w3_unsafe_decode_GuildName = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$LocalState$w3_unsafe_decode_AdminData_DeletedGuild = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$GuildName$w3_unsafe_decode_GuildName,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (deletedAt0, memberCount0, name0, owner0) {
							return {deletedAt: deletedAt0, memberCount: memberCount0, name: name0, owner: owner0};
						}))))));
var $author$project$Message$w3_unsafe_decode_CallRecordingFile = function (w3_x_c_userId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			A2(
				$lamdera$codecs$Lamdera$Wire3$andThenDecode,
				function (t) {
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
						$elm$time$Time$millisToPosix(t));
				},
				$lamdera$codecs$Lamdera$Wire3$decodeInt),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					w3_x_c_userId,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							A2(
								$lamdera$codecs$Lamdera$Wire3$andThenDecode,
								function (t) {
									return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
										$elm$time$Time$millisToPosix(t));
								},
								$lamdera$codecs$Lamdera$Wire3$decodeInt),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F6(
									function (endedAt0, name0, recordedBy0, size0, startedAt0, uploaded0) {
										return {endedAt: endedAt0, name: name0, recordedBy: recordedBy0, size: size0, startedAt: startedAt0, uploaded: uploaded0};
									}))))))));
};
var $author$project$Message$w3_unsafe_decode_CallRecordingZip = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$FileStatus$w3_unsafe_decode_FileHash,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (fileCount0, fileHash0, size0) {
						return {fileCount: fileCount0, fileHash: fileHash0, size: size0};
					})))));
var $author$project$NonemptySet$w3_unsafe_decode_NonemptySet = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqSet$decodeSet(w3_x_c_a),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_a,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$NonemptySet$NonemptySet)));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Message$w3_unsafe_decode_CallRecording = function (w3_x_c_userId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Message$w3_unsafe_decode_CallRecordingZip),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			A2(
				$lamdera$codecs$Lamdera$Wire3$andThenDecode,
				function (t) {
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
						$elm$time$Time$millisToPosix(t));
				},
				$lamdera$codecs$Lamdera$Wire3$decodeInt),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$NonemptySet$w3_unsafe_decode_NonemptySet(w3_x_c_userId),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqSet$decodeSet(w3_x_c_userId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeList(
							$author$project$Message$w3_unsafe_decode_CallRecordingFile(w3_x_c_userId)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F5(
								function (files0, finishedUploading0, participants0, startedAt0, zip0) {
									return {files: files0, finishedUploading: finishedUploading0, participants: participants0, startedAt: startedAt0, zip: zip0};
								})))))));
};
var $author$project$Drawing$w3_unsafe_decode_Stroke = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
		$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$SafeFloat$w3_unsafe_decode_SafeFloat, $author$project$SafeFloat$w3_unsafe_decode_SafeFloat)),
	$lamdera$codecs$Lamdera$Wire3$succeedDecode(
		function (points0) {
			return {points: points0};
		}));
var $author$project$Drawing$w3_unsafe_decode_Drawing = function (w3_x_c_userId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			w3_x_c_userId,
			$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Drawing$w3_unsafe_decode_Stroke)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(w3_x_c_userId, $author$project$Drawing$w3_unsafe_decode_Stroke),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeList(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$SafeFloat$w3_unsafe_decode_SafeFloat, $author$project$SafeFloat$w3_unsafe_decode_SafeFloat)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							w3_x_c_userId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (createdBy0, points0) {
										return {createdBy: createdBy0, points: points0};
									}))))),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F3(
						function (finished0, inProgress0, undone0) {
							return {finished: finished0, inProgress: inProgress0, undone: undone0};
						})))));
};
var $author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_CustomEmojiId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Emoji$EmojiOrCustomEmoji_CustomEmoji));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Emoji$w3_unsafe_decode_UnicodeEmoji,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Emoji$EmojiOrCustomEmoji_Emoji));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Message$w3_unsafe_decode_CallStartedData = function (w3_x_c_userId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			w3_x_c_userId,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$andThenDecode,
					function (t) {
						return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
							$elm$time$Time$millisToPosix(t));
					},
					$lamdera$codecs$Lamdera$Wire3$decodeInt),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Message$w3_unsafe_decode_CallRecording(w3_x_c_userId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
							$author$project$NonemptySet$w3_unsafe_decode_NonemptySet(w3_x_c_userId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqSet$decodeSet(w3_x_c_userId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
									A2(
										$lamdera$codecs$Lamdera$Wire3$andThenDecode,
										function (t) {
											return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
												$elm$time$Time$millisToPosix(t));
										},
										$lamdera$codecs$Lamdera$Wire3$decodeInt)),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F8(
											function (cardDrawings0, endedAt0, joinedBy0, reactions0, recordings0, startedAt0, startedBy0, timestampDrawings0) {
												return {cardDrawings: cardDrawings0, endedAt: endedAt0, joinedBy: joinedBy0, reactions: reactions0, recordings: recordings0, startedAt: startedAt0, startedBy: startedBy0, timestampDrawings: timestampDrawings0};
											}))))))))));
};
var $author$project$Encryption$w3_unsafe_decode_EncryptedData = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBytes,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Message$w3_unsafe_decode_UserTextMessageDrawings = function (w3_x_c_userId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
					$author$project$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId)),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$author$project$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F4(
							function (embedDrawings0, imageAttachmentDrawings0, timestampDrawings0, userIconDrawings0) {
								return {embedDrawings: embedDrawings0, imageAttachmentDrawings: imageAttachmentDrawings0, timestampDrawings: timestampDrawings0, userIconDrawings: userIconDrawings0};
							}))))));
};
var $author$project$Message$w3_unsafe_decode_EncryptedUserTextMessageData$ = function (w3_x_c_messageId, w3_x_c_userId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Message$w3_unsafe_decode_RepliedTo(w3_x_c_messageId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
				$author$project$NonemptySet$w3_unsafe_decode_NonemptySet(w3_x_c_userId)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqSet$decodeSet($author$project$FileStatus$w3_unsafe_decode_FileHash),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						A2(
							$lamdera$codecs$Lamdera$Wire3$andThenDecode,
							function (t) {
								return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
									$elm$time$Time$millisToPosix(t));
							},
							$lamdera$codecs$Lamdera$Wire3$decodeInt)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$Message$w3_unsafe_decode_UserTextMessageDrawings(w3_x_c_userId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							w3_x_c_userId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								A2(
									$lamdera$codecs$Lamdera$Wire3$andThenDecode,
									function (t) {
										return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
											$elm$time$Time$millisToPosix(t));
									},
									$lamdera$codecs$Lamdera$Wire3$decodeInt),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Encryption$w3_unsafe_decode_EncryptedData(
										$author$project$Message$w3_unsafe_decode_MessageContent$(
											w3_x_c_userId,
											$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId))),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F8(
											function (content0, createdAt0, createdBy0, drawings0, editedAt0, fileHashes0, reactions0, repliedTo0) {
												return {content: content0, createdAt: createdAt0, createdBy: createdBy0, drawings: drawings0, editedAt: editedAt0, fileHashes: fileHashes0, reactions: reactions0, repliedTo: repliedTo0};
											}))))))))));
};
var $author$project$Message$w3_unsafe_decode_EncryptedUserTextMessageData = F2($author$project$Message$w3_unsafe_decode_EncryptedUserTextMessageData$);
var $author$project$Message$w3_unsafe_decode_GameType = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Message$w3_unsafe_decode_GameStartedData = function (w3_x_c_userId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			w3_x_c_userId,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$andThenDecode,
					function (t) {
						return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
							$elm$time$Time$millisToPosix(t));
					},
					$lamdera$codecs$Lamdera$Wire3$decodeInt),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
						$author$project$NonemptySet$w3_unsafe_decode_NonemptySet(w3_x_c_userId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Message$w3_unsafe_decode_GameType,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F6(
									function (cardDrawings0, gameType0, reactions0, startedAt0, startedBy0, timestampDrawings0) {
										return {cardDrawings: cardDrawings0, gameType: gameType0, reactions: reactions0, startedAt: startedAt0, startedBy: startedBy0, timestampDrawings: timestampDrawings0};
									}))))))));
};
var $author$project$Message$w3_unsafe_decode_UserTextMessageData$ = function (w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Message$w3_unsafe_decode_RepliedTo(w3_x_c_messageId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
				$author$project$NonemptySet$w3_unsafe_decode_NonemptySet(w3_x_c_userId)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
					A2(
						$lamdera$codecs$Lamdera$Wire3$andThenDecode,
						function (t) {
							return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
								$elm$time$Time$millisToPosix(t));
						},
						$lamdera$codecs$Lamdera$Wire3$decodeInt)),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Message$w3_unsafe_decode_UserTextMessageDrawings(w3_x_c_userId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_userId,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							A2(
								$lamdera$codecs$Lamdera$Wire3$andThenDecode,
								function (t) {
									return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
										$elm$time$Time$millisToPosix(t));
								},
								$lamdera$codecs$Lamdera$Wire3$decodeInt),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Message$w3_unsafe_decode_MessageContent$(w3_x_c_userId, w3_x_c_channelId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F7(
										function (content0, createdAt0, createdBy0, drawings0, editedAt0, reactions0, repliedTo0) {
											return {content: content0, createdAt: createdAt0, createdBy: createdBy0, drawings: drawings0, editedAt: editedAt0, reactions: reactions0, repliedTo: repliedTo0};
										})))))))));
};
var $author$project$Message$w3_unsafe_decode_UserTextMessageData = F3($author$project$Message$w3_unsafe_decode_UserTextMessageData$);
var $author$project$Message$w3_unsafe_decode_Message$ = function (w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Message$w3_unsafe_decode_CallStartedData(w3_x_c_userId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Message$CallStarted));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						A2(
							$lamdera$codecs$Lamdera$Wire3$andThenDecode,
							function (t) {
								return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
									$elm$time$Time$millisToPosix(t));
							},
							$lamdera$codecs$Lamdera$Wire3$decodeInt),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Message$DeletedMessage));
				case 2:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Message$w3_unsafe_decode_EncryptedUserTextMessageData$(w3_x_c_messageId, w3_x_c_userId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Message$EncryptedUserTextMessage));
				case 3:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Message$w3_unsafe_decode_GameStartedData(w3_x_c_userId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Message$GameStarted));
				case 4:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqDict$decodeDict$(
								$author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
								$author$project$NonemptySet$w3_unsafe_decode_NonemptySet(w3_x_c_userId)),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								w3_x_c_userId,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									A2(
										$lamdera$codecs$Lamdera$Wire3$andThenDecode,
										function (t) {
											return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
												$elm$time$Time$millisToPosix(t));
										},
										$lamdera$codecs$Lamdera$Wire3$decodeInt),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Message$UserJoinedMessage)))));
				case 5:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Message$w3_unsafe_decode_UserTextMessageData$(w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Message$UserTextMessage));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Message$w3_unsafe_decode_Message = F3($author$project$Message$w3_unsafe_decode_Message$);
var $author$project$LocalState$w3_unsafe_decode_AdminData_DiscordDmChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
			$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					function (messagesSent0) {
						return {messagesSent: messagesSent0};
					}))),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
				$author$project$Message$w3_unsafe_decode_Message$(
					$author$project$Id$w3_unsafe_decode_ChannelMessageId,
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId))),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (firstMessage0, members0, messageCount0) {
						return {firstMessage: firstMessage0, members: members0, messageCount: messageCount0};
					})))));
var $author$project$ChannelName$w3_unsafe_decode_ChannelName = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Discord$w3_unsafe_decode_Permissions = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeBool,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeBool,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeBool,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeBool,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeBool,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeBool,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeBool,
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeBool,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$codecs$Lamdera$Wire3$decodeBool,
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$lamdera$codecs$Lamdera$Wire3$decodeBool,
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$lamdera$codecs$Lamdera$Wire3$decodeBool,
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$lamdera$codecs$Lamdera$Wire3$decodeBool,
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$lamdera$codecs$Lamdera$Wire3$decodeBool,
																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																		$lamdera$codecs$Lamdera$Wire3$decodeBool,
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$codecs$Lamdera$Wire3$decodeBool,
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$lamdera$codecs$Lamdera$Wire3$decodeBool,
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$lamdera$codecs$Lamdera$Wire3$decodeBool,
																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																						$lamdera$codecs$Lamdera$Wire3$decodeBool,
																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																							$lamdera$codecs$Lamdera$Wire3$decodeBool,
																							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																								$lamdera$codecs$Lamdera$Wire3$decodeBool,
																								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																									$lamdera$codecs$Lamdera$Wire3$decodeBool,
																									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																										$lamdera$codecs$Lamdera$Wire3$decodeBool,
																										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																											$lamdera$codecs$Lamdera$Wire3$decodeBool,
																											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																												$lamdera$codecs$Lamdera$Wire3$decodeBool,
																												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																													$lamdera$codecs$Lamdera$Wire3$decodeBool,
																													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																														$lamdera$codecs$Lamdera$Wire3$decodeBool,
																														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																															$lamdera$codecs$Lamdera$Wire3$decodeBool,
																															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																	$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																		$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																			$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																				$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																					$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																						$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																							$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																								$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																									$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																										$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																											$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																												$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																													$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																														$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																															$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																																$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																																	$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																																	$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																																																		function (addReaction0) {
																																																			return function (administrator0) {
																																																				return function (attachFiles0) {
																																																					return function (banMembers0) {
																																																						return function (changeNickname0) {
																																																							return function (connect0) {
																																																								return function (createEvents0) {
																																																									return function (createGuildExpressions0) {
																																																										return function (createInstantInvite0) {
																																																											return function (createPrivateThreads0) {
																																																												return function (createPublicThreads0) {
																																																													return function (deafenMembers0) {
																																																														return function (embedLinks0) {
																																																															return function (kickMembers0) {
																																																																return function (manageChannels0) {
																																																																	return function (manageEvents0) {
																																																																		return function (manageGuild0) {
																																																																			return function (manageGuildExpressions0) {
																																																																				return function (manageMessages0) {
																																																																					return function (manageNicknames0) {
																																																																						return function (manageRoles0) {
																																																																							return function (manageThreads0) {
																																																																								return function (manageWebhooks0) {
																																																																									return function (mentionEveryone0) {
																																																																										return function (moderateMembers0) {
																																																																											return function (moveMembers0) {
																																																																												return function (muteMembers0) {
																																																																													return function (prioritySpeaker0) {
																																																																														return function (readMessageHistory0) {
																																																																															return function (requestToSpeak0) {
																																																																																return function (sendMessages0) {
																																																																																	return function (sendMessagesInThreads0) {
																																																																																		return function (sendPolls0) {
																																																																																			return function (sendVoiceMessages0) {
																																																																																				return function (sentTextToSpeechMessages0) {
																																																																																					return function (speak0) {
																																																																																						return function (stream0) {
																																																																																							return function (useApplicationCommands0) {
																																																																																								return function (useEmbeddedActivities0) {
																																																																																									return function (useExternalApps0) {
																																																																																										return function (useExternalEmojis0) {
																																																																																											return function (useExternalSounds0) {
																																																																																												return function (useExternalStickers0) {
																																																																																													return function (useSoundboard0) {
																																																																																														return function (useVoiceActivityDetection0) {
																																																																																															return function (viewAuditLog0) {
																																																																																																return function (viewChannel0) {
																																																																																																	return function (viewCreatorMontetizationAnalytics0) {
																																																																																																		return function (viewGuildInsights0) {
																																																																																																			return {addReaction: addReaction0, administrator: administrator0, attachFiles: attachFiles0, banMembers: banMembers0, changeNickname: changeNickname0, connect: connect0, createEvents: createEvents0, createGuildExpressions: createGuildExpressions0, createInstantInvite: createInstantInvite0, createPrivateThreads: createPrivateThreads0, createPublicThreads: createPublicThreads0, deafenMembers: deafenMembers0, embedLinks: embedLinks0, kickMembers: kickMembers0, manageChannels: manageChannels0, manageEvents: manageEvents0, manageGuild: manageGuild0, manageGuildExpressions: manageGuildExpressions0, manageMessages: manageMessages0, manageNicknames: manageNicknames0, manageRoles: manageRoles0, manageThreads: manageThreads0, manageWebhooks: manageWebhooks0, mentionEveryone: mentionEveryone0, moderateMembers: moderateMembers0, moveMembers: moveMembers0, muteMembers: muteMembers0, prioritySpeaker: prioritySpeaker0, readMessageHistory: readMessageHistory0, requestToSpeak: requestToSpeak0, sendMessages: sendMessages0, sendMessagesInThreads: sendMessagesInThreads0, sendPolls: sendPolls0, sendVoiceMessages: sendVoiceMessages0, sentTextToSpeechMessages: sentTextToSpeechMessages0, speak: speak0, stream: stream0, useApplicationCommands: useApplicationCommands0, useEmbeddedActivities: useEmbeddedActivities0, useExternalApps: useExternalApps0, useExternalEmojis: useExternalEmojis0, useExternalSounds: useExternalSounds0, useExternalStickers: useExternalStickers0, useSoundboard: useSoundboard0, useVoiceActivityDetection: useVoiceActivityDetection0, viewAuditLog: viewAuditLog0, viewChannel: viewChannel0, viewCreatorMontetizationAnalytics: viewCreatorMontetizationAnalytics0, viewGuildInsights: viewGuildInsights0};
																																																																																																		};
																																																																																																	};
																																																																																																};
																																																																																															};
																																																																																														};
																																																																																													};
																																																																																												};
																																																																																											};
																																																																																										};
																																																																																									};
																																																																																								};
																																																																																							};
																																																																																						};
																																																																																					};
																																																																																				};
																																																																																			};
																																																																																		};
																																																																																	};
																																																																																};
																																																																															};
																																																																														};
																																																																													};
																																																																												};
																																																																											};
																																																																										};
																																																																									};
																																																																								};
																																																																							};
																																																																						};
																																																																					};
																																																																				};
																																																																			};
																																																																		};
																																																																	};
																																																																};
																																																															};
																																																														};
																																																													};
																																																												};
																																																											};
																																																										};
																																																									};
																																																								};
																																																							};
																																																						};
																																																					};
																																																				};
																																																			};
																																																		}))))))))))))))))))))))))))))))))))))))))))))))))));
var $author$project$Discord$RoleId = $elm$core$Basics$identity;
var $author$project$Discord$w3_unsafe_decode_RoleId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Discord$w3_unsafe_decode_RoleOrUserId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_RoleId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Discord$RoleOrUserId_RoleId));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Discord$RoleOrUserId_UserId));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Discord$w3_unsafe_decode_Overwrite = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Discord$w3_unsafe_decode_RoleOrUserId,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Discord$w3_unsafe_decode_Permissions,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Discord$w3_unsafe_decode_Permissions,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (allow0, deny0, id0) {
						return {allow: allow0, deny: deny0, id: id0};
					})))));
var $author$project$LocalState$w3_unsafe_decode_AdminData_DiscordChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Discord$w3_unsafe_decode_Overwrite),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$ChannelName$w3_unsafe_decode_ChannelName,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Message$w3_unsafe_decode_Message$(
							$author$project$Id$w3_unsafe_decode_ChannelMessageId,
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (firstMessage0, messageCount0, name0, permissionOverwrites0, threadCount0) {
								return {firstMessage: firstMessage0, messageCount: messageCount0, name: name0, permissionOverwrites: permissionOverwrites0, threadCount: threadCount0};
							})))))));
var $author$project$LocalState$w3_unsafe_decode_DiscordRole = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Discord$w3_unsafe_decode_Permissions,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (description0, name0, permissions0) {
						return {description: description0, name: name0, permissions: permissions0};
					})))));
var $author$project$MembersAndOwner$w3_unsafe_decode_MembersAndOwner$ = function (w3_x_c_userId, w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					w3_x_c_userId,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(w3_x_c_userId, w3_x_c_a),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MembersAndOwner$MembersAndOwner)));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$MembersAndOwner$w3_unsafe_decode_MembersAndOwner = F2($author$project$MembersAndOwner$w3_unsafe_decode_MembersAndOwner$);
var $author$project$LocalState$w3_unsafe_decode_AdminData_DiscordGuild = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_RoleId),
		$author$project$LocalState$w3_unsafe_decode_DiscordRole),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$GuildName$w3_unsafe_decode_GuildName,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$MembersAndOwner$w3_unsafe_decode_MembersAndOwner$(
				$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqSet$decodeSet(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_RoleId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F2(
								function (joinedAt0, roles0) {
									return {joinedAt: joinedAt0, roles: roles0};
								}))))),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
					$author$project$LocalState$w3_unsafe_decode_AdminData_DiscordChannel),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (channels0, membersAndOwner0, name0, roles0) {
							return {channels: channels0, membersAndOwner: membersAndOwner0, name: name0, roles: roles0};
						}))))));
var $author$project$LocalState$w3_unsafe_decode_AdminData_DmChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (messageCount0, threadCount0) {
					return {messageCount: messageCount0, threadCount: threadCount0};
				}))));
var $author$project$LocalState$w3_unsafe_decode_AdminData_GuildChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$ChannelName$w3_unsafe_decode_ChannelName,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (messageCount0, name0) {
					return {messageCount: messageCount0, name: name0};
				}))));
var $author$project$LocalState$w3_unsafe_decode_AdminData_Guild = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$GuildName$w3_unsafe_decode_GuildName,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
					$author$project$LocalState$w3_unsafe_decode_AdminData_GuildChannel),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (channels0, memberCount0, name0, owner0) {
							return {channels: channels0, memberCount: memberCount0, name: name0, owner: owner0};
						}))))));
var $author$project$LocalState$w3_unsafe_decode_AdminData_SlackDmChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList(
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F2(
								function (id0, name0) {
									return {id: id0, name: name0};
								}))))),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
					$author$project$Message$w3_unsafe_decode_Message$(
						$author$project$Id$w3_unsafe_decode_ChannelMessageId,
						$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
						$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId))),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (firstMessage0, members0, messageCount0, teamId0) {
							return {firstMessage: firstMessage0, members: members0, messageCount: messageCount0, teamId: teamId0};
						}))))));
var $author$project$LocalState$w3_unsafe_decode_AdminData_SlackWorkspace = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F2(
								function (linkedTo0, name0) {
									return {linkedTo: linkedTo0, name: name0};
								}))))),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$ChannelName$w3_unsafe_decode_ChannelName,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$containers$SeqSet$decodeSet(
										$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId)),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeBool,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
												$author$project$Message$w3_unsafe_decode_Message$(
													$author$project$Id$w3_unsafe_decode_ChannelMessageId,
													$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
													$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId))),
											$lamdera$codecs$Lamdera$Wire3$succeedDecode(
												F5(
													function (firstMessage0, isPrivate0, linkedMembers0, messageCount0, name0) {
														return {firstMessage: firstMessage0, isPrivate: isPrivate0, linkedMembers: linkedMembers0, messageCount: messageCount0, name: name0};
													})))))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (channels0, domain0, linkedUsers0, name0, userCount0) {
								return {channels: channels0, domain: domain0, linkedUsers: linkedUsers0, name: name0, userCount: userCount0};
							})))))));
var $author$project$Postmark$w3_unsafe_decode_ApiKey = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$FileStatus$w3_unsafe_decode_BackendFileData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
		$author$project$Coord$w3_unsafe_decode_Coord($author$project$CssPixels$w3_unsafe_decode_CssPixels)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (fileSize0, imageSize0) {
					return {fileSize: fileSize0, imageSize: imageSize0};
				}))));
var $author$project$BackendMsgLog$BackendMsgLog_AiChatBackendMsg = 20;
var $author$project$BackendMsgLog$BackendMsgLog_BackendGotTime = 5;
var $author$project$BackendMsgLog$BackendMsgLog_BackendMsgCompleted = 91;
var $author$project$BackendMsgLog$BackendMsgLog_CaughtUpSlackMessages = 34;
var $author$project$BackendMsgLog$BackendMsgLog_CheckedSlackAuth = 35;
var $author$project$BackendMsgLog$BackendMsgLog_CountToFrontendStep = 54;
var $author$project$BackendMsgLog$BackendMsgLog_DeletedDiscordDmMessage = 12;
var $author$project$BackendMsgLog$BackendMsgLog_DeletedDiscordGuildMessage = 11;
var $author$project$BackendMsgLog$BackendMsgLog_DeletedOrphanedFiles = 78;
var $author$project$BackendMsgLog$BackendMsgLog_DiscordAddedReactionToDmMessage = 16;
var $author$project$BackendMsgLog$BackendMsgLog_DiscordAddedReactionToGuildMessage = 15;
var $author$project$BackendMsgLog$BackendMsgLog_DiscordGotDataForJoinedOrCreatedGuild = 65;
var $author$project$BackendMsgLog$BackendMsgLog_DiscordGotDmMessageEmbed = 64;
var $author$project$BackendMsgLog$BackendMsgLog_DiscordGotGuildIcon = 66;
var $author$project$BackendMsgLog$BackendMsgLog_DiscordGotGuildMessageEmbed = 63;
var $author$project$BackendMsgLog$BackendMsgLog_DiscordMessageCreate_AttachmentsUploaded = 49;
var $author$project$BackendMsgLog$BackendMsgLog_DiscordMessageUpdate_AttachmentsUploaded = 50;
var $author$project$BackendMsgLog$BackendMsgLog_DiscordRemovedReactionToDmMessage = 18;
var $author$project$BackendMsgLog$BackendMsgLog_DiscordRemovedReactionToGuildMessage = 17;
var $author$project$BackendMsgLog$BackendMsgLog_DiscordTypingIndicatorSent = 19;
var $author$project$BackendMsgLog$BackendMsgLog_DiscordUserWebsocketMsg = 8;
var $author$project$BackendMsgLog$BackendMsgLog_DownloadBackupChunkStep = 55;
var $author$project$BackendMsgLog$BackendMsgLog_EditedDiscordDmMessage = 14;
var $author$project$BackendMsgLog$BackendMsgLog_EditedDiscordGuildMessage = 13;
var $author$project$BackendMsgLog$BackendMsgLog_ExportBackendStep = 53;
var $author$project$BackendMsgLog$BackendMsgLog_GatewayReconnectTick = 47;
var $author$project$BackendMsgLog$BackendMsgLog_GotChangedSlackUser = 26;
var $author$project$BackendMsgLog$BackendMsgLog_GotDiscordDmChannelMessages = 58;
var $author$project$BackendMsgLog$BackendMsgLog_GotDiscordGuildChannelMessages = 57;
var $author$project$BackendMsgLog$BackendMsgLog_GotDiscordMessageCustomEmojis = 73;
var $author$project$BackendMsgLog$BackendMsgLog_GotDiscordMessageStickers = 70;
var $author$project$BackendMsgLog$BackendMsgLog_GotDiscordReadyDataCustomEmojis = 71;
var $author$project$BackendMsgLog$BackendMsgLog_GotDiscordReadyDataStickers = 69;
var $author$project$BackendMsgLog$BackendMsgLog_GotDiscordStandardStickerPacks = 75;
var $author$project$BackendMsgLog$BackendMsgLog_GotDiscordUserAvatars = 21;
var $author$project$BackendMsgLog$BackendMsgLog_GotDmMessageEmbed = 62;
var $author$project$BackendMsgLog$BackendMsgLog_GotEnglishWordList = 83;
var $author$project$BackendMsgLog$BackendMsgLog_GotGuildMessageEmbed = 61;
var $author$project$BackendMsgLog$BackendMsgLog_GotSlackCustomEmojis = 72;
var $author$project$BackendMsgLog$BackendMsgLog_GotSlackUser = 25;
var $author$project$BackendMsgLog$BackendMsgLog_GotSwedishWordList = 84;
var $author$project$BackendMsgLog$BackendMsgLog_GotTimeForBackendMsg = 90;
var $author$project$BackendMsgLog$BackendMsgLog_GotTimeForDiscordForumPostRenamed = 60;
var $author$project$BackendMsgLog$BackendMsgLog_GotTimeForFailedToParseDiscordWebsocket = 59;
var $author$project$BackendMsgLog$BackendMsgLog_GotTimeForWebsocketListenClose = 81;
var $author$project$BackendMsgLog$BackendMsgLog_GotVapidKeys = 23;
var $author$project$BackendMsgLog$BackendMsgLog_HandleReadyDataStep2 = 44;
var $author$project$BackendMsgLog$BackendMsgLog_HourlyDeletedOrphanedFiles = 79;
var $author$project$BackendMsgLog$BackendMsgLog_HourlyUpdate = 74;
var $author$project$BackendMsgLog$BackendMsgLog_JoinedDiscordThread = 67;
var $author$project$BackendMsgLog$BackendMsgLog_LinkDiscordUserStep1 = 24;
var $author$project$BackendMsgLog$BackendMsgLog_LinkSlackUserStep1 = 31;
var $author$project$BackendMsgLog$BackendMsgLog_LinkSlackUserStep2 = 32;
var $author$project$BackendMsgLog$BackendMsgLog_RecordingRequestTick = 4;
var $author$project$BackendMsgLog$BackendMsgLog_RefreshedSlackConversations = 33;
var $author$project$BackendMsgLog$BackendMsgLog_RegeneratedServerSecret = 77;
var $author$project$BackendMsgLog$BackendMsgLog_ReloadDiscordUserStep1 = 43;
var $author$project$BackendMsgLog$BackendMsgLog_ReloadedDiscordDmChannel = 52;
var $author$project$BackendMsgLog$BackendMsgLog_ReloadedDiscordGuildChannel = 51;
var $author$project$BackendMsgLog$BackendMsgLog_ReloadedDiscordGuildForAdmin = 80;
var $author$project$BackendMsgLog$BackendMsgLog_Rpc_GotFileUpload = 82;
var $author$project$BackendMsgLog$BackendMsgLog_Rpc_NotifyAdmins = 86;
var $author$project$BackendMsgLog$BackendMsgLog_Rpc_RecordingUploadFinished = 88;
var $author$project$BackendMsgLog$BackendMsgLog_Rpc_RecordingUploadProgress = 87;
var $author$project$BackendMsgLog$BackendMsgLog_Rpc_RecordingZipBuilt = 89;
var $author$project$BackendMsgLog$BackendMsgLog_Rpc_UserJoinedCall = 85;
var $author$project$BackendMsgLog$BackendMsgLog_ScheduledExportBackendStep = 56;
var $author$project$BackendMsgLog$BackendMsgLog_ScheduledExportUploadResult = 76;
var $author$project$BackendMsgLog$BackendMsgLog_SentDiscordDmMessage = 10;
var $author$project$BackendMsgLog$BackendMsgLog_SentDiscordGuildMessage = 9;
var $author$project$BackendMsgLog$BackendMsgLog_SentLogErrorEmail = 6;
var $author$project$BackendMsgLog$BackendMsgLog_SentLoginEmail = 0;
var $author$project$BackendMsgLog$BackendMsgLog_SentNotification = 22;
var $author$project$BackendMsgLog$BackendMsgLog_SentNotificationEmail = 7;
var $author$project$BackendMsgLog$BackendMsgLog_SentSlackMessage = 37;
var $author$project$BackendMsgLog$BackendMsgLog_SlackChangedReaction = 27;
var $author$project$BackendMsgLog$BackendMsgLog_SlackDeletedMessage = 28;
var $author$project$BackendMsgLog$BackendMsgLog_SlackEditedMessage = 29;
var $author$project$BackendMsgLog$BackendMsgLog_SlackGotMessageEmbed = 36;
var $author$project$BackendMsgLog$BackendMsgLog_SlackMessageFilesUploaded = 30;
var $author$project$BackendMsgLog$BackendMsgLog_SlackWebsocketClosedByBackend = 39;
var $author$project$BackendMsgLog$BackendMsgLog_SlackWebsocketCreatedHandle = 38;
var $author$project$BackendMsgLog$BackendMsgLog_SlackWebsocketMsg = 40;
var $author$project$BackendMsgLog$BackendMsgLog_SlackWebsocketReconnectTick = 42;
var $author$project$BackendMsgLog$BackendMsgLog_SlackWebsocketSentData = 41;
var $author$project$BackendMsgLog$BackendMsgLog_ToBackendCompleted = 68;
var $author$project$BackendMsgLog$BackendMsgLog_UserConnected = 1;
var $author$project$BackendMsgLog$BackendMsgLog_UserDisconnected = 2;
var $author$project$BackendMsgLog$BackendMsgLog_UserDisconnectedWithTime = 3;
var $author$project$BackendMsgLog$BackendMsgLog_WebsocketClosedByBackendForUser = 46;
var $author$project$BackendMsgLog$BackendMsgLog_WebsocketCreatedHandleForUser = 45;
var $author$project$BackendMsgLog$BackendMsgLog_WebsocketSentDataForUser = 48;
var $author$project$BackendMsgLog$w3_unsafe_decode_BackendMsgLog = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(20);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(91);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(34);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(35);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(54);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(12);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(11);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(78);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(16);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(15);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(65);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(64);
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(66);
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(63);
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(49);
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(50);
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(18);
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(17);
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(19);
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(8);
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(55);
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(14);
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(13);
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(53);
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(47);
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(26);
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(58);
			case 28:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(57);
			case 29:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(73);
			case 30:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(70);
			case 31:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(71);
			case 32:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(69);
			case 33:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(75);
			case 34:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(21);
			case 35:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(62);
			case 36:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(83);
			case 37:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(61);
			case 38:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(72);
			case 39:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(25);
			case 40:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(84);
			case 41:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(90);
			case 42:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(60);
			case 43:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(59);
			case 44:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(81);
			case 45:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(23);
			case 46:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(44);
			case 47:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(79);
			case 48:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(74);
			case 49:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(67);
			case 50:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(24);
			case 51:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(31);
			case 52:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(32);
			case 53:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 54:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(33);
			case 55:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(77);
			case 56:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(43);
			case 57:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(52);
			case 58:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(51);
			case 59:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(80);
			case 60:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(82);
			case 61:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(86);
			case 62:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(88);
			case 63:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(87);
			case 64:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(89);
			case 65:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(85);
			case 66:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(56);
			case 67:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(76);
			case 68:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(10);
			case 69:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(9);
			case 70:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			case 71:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 72:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(22);
			case 73:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			case 74:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(37);
			case 75:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(27);
			case 76:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(28);
			case 77:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(29);
			case 78:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(36);
			case 79:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(30);
			case 80:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(39);
			case 81:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(38);
			case 82:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(40);
			case 83:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(42);
			case 84:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(41);
			case 85:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(68);
			case 86:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 87:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 88:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 89:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(46);
			case 90:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(45);
			case 91:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(48);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$BackendMsgLog$w3_unsafe_decode_BackendMsgLogData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$BackendMsgLog$w3_unsafe_decode_BackendMsgLog,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (backendMsgLog0, endTime0, startTime0) {
						return {backendMsgLog: backendMsgLog0, endTime: endTime0, startTime: startTime0};
					})))));
var $author$project$User$DeletedUser = {$: 0};
var $author$project$EmailAddress$w3_unsafe_decode_EmailAddress = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeString),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeString,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeString,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F4(
										function (domain0, localPart0, tags0, tld0) {
											return {domain: domain0, localPart: localPart0, tags: tags0, tld: tld0};
										})))))),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$User$w3_unsafe_decode_BackendUserStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$User$DeletedUser);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$EmailAddress$w3_unsafe_decode_EmailAddress,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$User$UserHasEmail));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$RichText$w3_unsafe_decode_Domain = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$User$w3_unsafe_decode_EmailNotifications = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$User$w3_unsafe_decode_EmbedVisibility = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Emoji$w3_unsafe_decode_SkinTone = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Emoji$w3_unsafe_decode_EmojiConfig = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Emoji$w3_unsafe_decode_SkinTone),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (lastUsedEmojis0, skinTone0) {
					return {lastUsedEmojis: lastUsedEmojis0, skinTone: skinTone0};
				}))));
var $author$project$User$w3_unsafe_decode_LastDmViewed = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$User$DiscordDmChannelLastViewed));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_ThreadRoute,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$User$DmChannelLastViewed)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$User$NoLastDmViewed);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$MuteSettings$w3_unsafe_decode_IsMuted = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$MuteSettings$w3_unsafe_decode_MutedChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
		$author$project$MuteSettings$w3_unsafe_decode_IsMuted),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (mutedChannel0, mutedThreads0) {
					return {mutedChannel: mutedChannel0, mutedThreads: mutedThreads0};
				}))));
var $author$project$MuteSettings$w3_unsafe_decode_MutedDiscordGuild = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
			$author$project$MuteSettings$w3_unsafe_decode_MutedChannel),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (channels0, mutedGuild0) {
					return {channels: channels0, mutedGuild: mutedGuild0};
				}))));
var $author$project$MuteSettings$w3_unsafe_decode_MutedGuild = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
			$author$project$MuteSettings$w3_unsafe_decode_MutedChannel),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (channels0, mutedGuild0) {
					return {channels: channels0, mutedGuild: mutedGuild0};
				}))));
var $author$project$MuteSettings$w3_unsafe_decode_MutedSlackWorkspace = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId),
			$author$project$MuteSettings$w3_unsafe_decode_MutedChannel),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (channels0, mutedWorkspace0) {
					return {channels: channels0, mutedWorkspace: mutedWorkspace0};
				}))));
var $author$project$MuteSettings$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
		$author$project$MuteSettings$w3_unsafe_decode_MutedSlackWorkspace),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
			$author$project$MuteSettings$w3_unsafe_decode_MutedGuild),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
				$author$project$MuteSettings$w3_unsafe_decode_MutedChannel),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
					$author$project$MuteSettings$w3_unsafe_decode_MutedDiscordGuild),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
						$author$project$MuteSettings$w3_unsafe_decode_IsMuted),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (mutedDiscordDms0, mutedDiscordGuilds0, mutedDms0, mutedGuilds0, mutedSlackWorkspaces0) {
								return {mutedDiscordDms: mutedDiscordDms0, mutedDiscordGuilds: mutedDiscordGuilds0, mutedDms: mutedDms0, mutedGuilds: mutedGuilds0, mutedSlackWorkspaces: mutedSlackWorkspaces0};
							})))))));
var $author$project$Pagination$PageId = $elm$core$Basics$identity;
var $author$project$Pagination$w3_unsafe_decode_PageId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$PersonName$w3_unsafe_decode_PersonName = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$X25519$w3_unsafe_decode_Key = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F8(
										function (w00, w10, w20, w30, w40, w50, w60, w70) {
											return {w0: w00, w1: w10, w2: w20, w3: w30, w4: w40, w5: w50, w6: w60, w7: w70};
										}))))))))));
var $author$project$X25519$w3_unsafe_decode_PublicKey = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$X25519$w3_unsafe_decode_Key,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$UserColor$w3_unsafe_decode_UserColor = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$User$w3_unsafe_decode_BackendUser = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqSet$decodeSet(
		$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
			$author$project$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
				$lamdera$codecs$Lamdera$Wire3$decodePair$(
					$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId),
					$author$project$Id$w3_unsafe_decode_ThreadRoute),
				$author$project$OneOrGreater$w3_unsafe_decode_OneOrGreater)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$X25519$w3_unsafe_decode_PublicKey),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqSet$decodeSet(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$PersonName$w3_unsafe_decode_PersonName,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$MuteSettings$w3_unsafe_decode_Model,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeBool,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeBool,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$containers$SeqDict$decodeDict$(
											$lamdera$codecs$Lamdera$Wire3$decodePair$(
												$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
												$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId)),
											$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ThreadMessageId)),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$containers$SeqDict$decodeDict$(
												$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
												$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId)),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$containers$SeqDict$decodeDict$(
													$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
													$lamdera$codecs$Lamdera$Wire3$decodePair$(
														$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId),
														$author$project$Id$w3_unsafe_decode_ThreadRoute)),
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$author$project$Id$w3_unsafe_decode_Id($author$project$Pagination$w3_unsafe_decode_PageId),
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$author$project$User$w3_unsafe_decode_LastDmViewed,
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$lamdera$containers$SeqDict$decodeDict$(
																		$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
																		$lamdera$codecs$Lamdera$Wire3$decodePair$(
																			$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
																			$author$project$Id$w3_unsafe_decode_ThreadRoute)),
																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																		$lamdera$containers$SeqDict$decodeDict$(
																			$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
																			$lamdera$codecs$Lamdera$Wire3$decodePair$(
																				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
																				$author$project$Id$w3_unsafe_decode_ThreadRoute)),
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$codecs$Lamdera$Wire3$decodeBool,
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$FileStatus$w3_unsafe_decode_FileHash),
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$author$project$Emoji$w3_unsafe_decode_EmojiConfig,
																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																						$author$project$User$w3_unsafe_decode_EmbedVisibility,
																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																							$author$project$User$w3_unsafe_decode_EmailNotifications,
																							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																								$author$project$User$w3_unsafe_decode_BackendUserStatus,
																								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																									$lamdera$codecs$Lamdera$Wire3$decodeBool,
																									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																										$lamdera$containers$SeqSet$decodeSet($author$project$RichText$w3_unsafe_decode_Domain),
																										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																											$lamdera$containers$SeqSet$decodeSet(
																												$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId)),
																											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																												$lamdera$containers$SeqDict$decodeDict$(
																													$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
																													$author$project$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
																														$lamdera$codecs$Lamdera$Wire3$decodePair$(
																															$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
																															$author$project$Id$w3_unsafe_decode_ThreadRoute),
																														$author$project$OneOrGreater$w3_unsafe_decode_OneOrGreater)),
																												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																													$lamdera$containers$SeqDict$decodeDict$(
																														$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
																														$author$project$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
																															$lamdera$codecs$Lamdera$Wire3$decodePair$(
																																$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
																																$author$project$Id$w3_unsafe_decode_ThreadRoute),
																															$author$project$OneOrGreater$w3_unsafe_decode_OneOrGreater)),
																													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																														$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
																														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																															$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
																															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																$author$project$UserColor$w3_unsafe_decode_UserColor,
																																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																	$lamdera$containers$SeqSet$decodeSet(
																																		$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_StickerId)),
																																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																		$lamdera$containers$SeqSet$decodeSet(
																																			$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_CustomEmojiId)),
																																		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																																			function (availableCustomEmojis0) {
																																				return function (availableStickers0) {
																																					return function (color0) {
																																						return function (createdAt0) {
																																							return function (deleteAccountAt0) {
																																								return function (directMentions0) {
																																									return function (discordDirectMentions0) {
																																										return function (discordNotifyOnAllMessages0) {
																																											return function (domainWhitelist0) {
																																												return function (e2eeRisksAccepted0) {
																																													return function (email0) {
																																														return function (emailNotifications0) {
																																															return function (embedVisibility0) {
																																																return function (emojiConfig0) {
																																																	return function (icon0) {
																																																		return function (isAdmin0) {
																																																			return function (lastChannelViewed0) {
																																																				return function (lastDiscordChannelViewed0) {
																																																					return function (lastDmViewed0) {
																																																						return function (lastEmailNotification0) {
																																																							return function (lastLogPageViewed0) {
																																																								return function (lastPushNotification0) {
																																																									return function (lastSlackChannelViewed0) {
																																																										return function (lastViewedMessage0) {
																																																											return function (lastViewedThreadMessage0) {
																																																												return function (linkDiscordAcknowledgementIsChecked0) {
																																																													return function (linkSlackAcknowledgementIsChecked0) {
																																																														return function (muteSettings0) {
																																																															return function (name0) {
																																																																return function (notifyOnAllMessages0) {
																																																																	return function (publicKey0) {
																																																																		return function (recentLoginEmails0) {
																																																																			return function (slackDirectMentions0) {
																																																																				return function (slackNotifyOnAllMessages0) {
																																																																					return {availableCustomEmojis: availableCustomEmojis0, availableStickers: availableStickers0, color: color0, createdAt: createdAt0, deleteAccountAt: deleteAccountAt0, directMentions: directMentions0, discordDirectMentions: discordDirectMentions0, discordNotifyOnAllMessages: discordNotifyOnAllMessages0, domainWhitelist: domainWhitelist0, e2eeRisksAccepted: e2eeRisksAccepted0, email: email0, emailNotifications: emailNotifications0, embedVisibility: embedVisibility0, emojiConfig: emojiConfig0, icon: icon0, isAdmin: isAdmin0, lastChannelViewed: lastChannelViewed0, lastDiscordChannelViewed: lastDiscordChannelViewed0, lastDmViewed: lastDmViewed0, lastEmailNotification: lastEmailNotification0, lastLogPageViewed: lastLogPageViewed0, lastPushNotification: lastPushNotification0, lastSlackChannelViewed: lastSlackChannelViewed0, lastViewedMessage: lastViewedMessage0, lastViewedThreadMessage: lastViewedThreadMessage0, linkDiscordAcknowledgementIsChecked: linkDiscordAcknowledgementIsChecked0, linkSlackAcknowledgementIsChecked: linkSlackAcknowledgementIsChecked0, muteSettings: muteSettings0, name: name0, notifyOnAllMessages: notifyOnAllMessages0, publicKey: publicKey0, recentLoginEmails: recentLoginEmails0, slackDirectMentions: slackDirectMentions0, slackNotifyOnAllMessages: slackNotifyOnAllMessages0};
																																																																				};
																																																																			};
																																																																		};
																																																																	};
																																																																};
																																																															};
																																																														};
																																																													};
																																																												};
																																																											};
																																																										};
																																																									};
																																																								};
																																																							};
																																																						};
																																																					};
																																																				};
																																																			};
																																																		};
																																																	};
																																																};
																																															};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			})))))))))))))))))))))))))))))))))));
var $author$project$LocalState$BasicData_ForAdmin = function (a) {
	return {$: 0, a: a};
};
var $author$project$LocalState$FullData_ForAdmin = function (a) {
	return {$: 1, a: a};
};
var $author$project$LocalState$NeedsAuthAgain_ForAdmin = function (a) {
	return {$: 2, a: a};
};
var $author$project$LocalState$w3_unsafe_decode_DiscordGatewayStatus = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (failedReconnectAttempts0, websocketIsOpen0) {
					return {failedReconnectAttempts: failedReconnectAttempts0, websocketIsOpen: websocketIsOpen0};
				}))));
var $author$project$DiscordUserData$w3_unsafe_decode_DiscordUserLoadingData = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$DiscordUserData$DiscordUserLoadedSuccessfully);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$DiscordUserData$DiscordUserLoadingData));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$DiscordUserData$DiscordUserLoadingFailed));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Discord$AvatarHash = $elm$core$Basics$identity;
var $author$project$Discord$w3_unsafe_decode_AvatarHash = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Discord$ImageHash = $elm$core$Basics$identity;
var $author$project$Discord$w3_unsafe_decode_ImageHash = function (w3_x_c_hashType) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Discord$UserDiscriminator = $elm$core$Basics$identity;
var $author$project$Discord$w3_unsafe_decode_UserDiscriminator = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Discord$w3_unsafe_decode_PartialUser = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Discord$w3_unsafe_decode_UserDiscriminator,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
					$author$project$Discord$w3_unsafe_decode_ImageHash($author$project$Discord$w3_unsafe_decode_AvatarHash)),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (avatar0, discriminator0, id0, username0) {
							return {avatar: avatar0, discriminator: discriminator0, id: id0, username: username0};
						}))))));
var $author$project$Discord$Included = function (a) {
	return {$: 0, a: a};
};
var $author$project$Discord$Missing = {$: 1};
var $author$project$Discord$w3_unsafe_decode_OptionalData = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_a,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Discord$Included));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Discord$Missing);
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Discord$w3_unsafe_decode_User = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Discord$w3_unsafe_decode_OptionalData($lamdera$codecs$Lamdera$Wire3$decodeBool),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Discord$w3_unsafe_decode_OptionalData($lamdera$codecs$Lamdera$Wire3$decodeBool),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Discord$w3_unsafe_decode_OptionalData($lamdera$codecs$Lamdera$Wire3$decodeInt),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_OptionalData($lamdera$codecs$Lamdera$Wire3$decodeInt),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_OptionalData($lamdera$codecs$Lamdera$Wire3$decodeBool),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_OptionalData($lamdera$codecs$Lamdera$Wire3$decodeString),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Discord$w3_unsafe_decode_OptionalData($lamdera$codecs$Lamdera$Wire3$decodeInt),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Discord$w3_unsafe_decode_OptionalData(
											$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString)),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Discord$w3_unsafe_decode_UserDiscriminator,
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$author$project$Discord$w3_unsafe_decode_OptionalData($lamdera$codecs$Lamdera$Wire3$decodeBool),
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
														$author$project$Discord$w3_unsafe_decode_ImageHash($author$project$Discord$w3_unsafe_decode_AvatarHash)),
													$lamdera$codecs$Lamdera$Wire3$succeedDecode(
														function (avatar0) {
															return function (bot0) {
																return function (discriminator0) {
																	return function (email0) {
																		return function (flags0) {
																			return function (id0) {
																				return function (locale0) {
																					return function (mfaEnabled0) {
																						return function (premiumType0) {
																							return function (publicFlags0) {
																								return function (system0) {
																									return function (username0) {
																										return function (verified0) {
																											return {avatar: avatar0, bot: bot0, discriminator: discriminator0, email: email0, flags: flags0, id: id0, locale: locale0, mfaEnabled: mfaEnabled0, premiumType: premiumType0, publicFlags: publicFlags0, system: system0, username: username0, verified: verified0};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														}))))))))))))));
var $author$project$LocalState$w3_unsafe_decode_DiscordUserData_ForAdmin = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_PartialUser,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$FileStatus$w3_unsafe_decode_FileHash),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (icon0, user0) {
										return {icon: icon0, user: user0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$BasicData_ForAdmin));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_User,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$DiscordUserData$w3_unsafe_decode_DiscordUserLoadingData,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$FileStatus$w3_unsafe_decode_FileHash),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$LocalState$w3_unsafe_decode_DiscordGatewayStatus,
											$lamdera$codecs$Lamdera$Wire3$succeedDecode(
												F6(
													function (gateway0, icon0, isLoadingData0, linkedAt0, linkedTo0, user0) {
														return {gateway: gateway0, icon: icon0, isLoadingData: isLoadingData0, linkedAt: linkedAt0, linkedTo: linkedTo0, user: user0};
													})))))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$FullData_ForAdmin));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_User,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$FileStatus$w3_unsafe_decode_FileHash),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F4(
											function (icon0, linkedAt0, linkedTo0, user0) {
												return {icon: icon0, linkedAt: linkedAt0, linkedTo: linkedTo0, user: user0};
											})))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$NeedsAuthAgain_ForAdmin));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$DmChannelId$w3_unsafe_decode_DmChannelId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$DmChannelId$DmChannelId)));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Pages$Admin$w3_unsafe_decode_EditedBackendUser = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (createdAt0, deleteAccountAt0, email0, isAdmin0, name0) {
								return {createdAt: createdAt0, deleteAccountAt: deleteAccountAt0, email: email0, isAdmin: isAdmin0, name: name0};
							})))))));
var $author$project$Discord$BadRequest400 = function (a) {
	return {$: 1, a: a};
};
var $author$project$Discord$Forbidden403 = function (a) {
	return {$: 3, a: a};
};
var $author$project$Discord$GatewayUnavailable502 = function (a) {
	return {$: 6, a: a};
};
var $author$project$Discord$NetworkError = {$: 8};
var $author$project$Discord$NotFound404 = function (a) {
	return {$: 4, a: a};
};
var $author$project$Discord$NotModified304 = function (a) {
	return {$: 0, a: a};
};
var $author$project$Discord$ServerError5xx = function (a) {
	return {$: 7, a: a};
};
var $author$project$Discord$Timeout = {$: 9};
var $author$project$Discord$TooManyRequests429 = function (a) {
	return {$: 5, a: a};
};
var $author$project$Discord$Unauthorized401 = function (a) {
	return {$: 2, a: a};
};
var $author$project$Discord$UnexpectedError = function (a) {
	return {$: 10, a: a};
};
var $author$project$Discord$ApiIsCurrentlyOverloaded130000 = 65;
var $author$project$Discord$BotsCannotUseThisEndpoint20001 = 24;
var $author$project$Discord$CannotEditAMessageAuthoredByAnotherUser50005 = 44;
var $author$project$Discord$CannotExecuteActionOnADmChannel50003 = 42;
var $author$project$Discord$CannotExecuteActionOnASystemMessage50021 = 58;
var $author$project$Discord$CannotSendAnEmptyMessage50006 = 45;
var $author$project$Discord$CannotSendMessagesInAVoiceChannel50008 = 47;
var $author$project$Discord$CannotSendMessagesToThisUser50007 = 46;
var $author$project$Discord$ChannelVerificationLevelTooHigh50009 = 48;
var $author$project$Discord$FeatureTemporarilyDisabledServerSide40006 = 38;
var $author$project$Discord$GeneralError0 = 0;
var $author$project$Discord$GuildWidgetDisabled50004 = 43;
var $author$project$Discord$InvalidAccountType50002 = 41;
var $author$project$Discord$InvalidApiVersionProvided50041 = 63;
var $author$project$Discord$InvalidAuthenticationTokenProvided50014 = 53;
var $author$project$Discord$InvalidFormBody50035 = 61;
var $author$project$Discord$InvalidOAuth2AccessTokenProvided50025 = 59;
var $author$project$Discord$InvalidOAuth2State50012 = 51;
var $author$project$Discord$InviteCodeWasEitherInvalidOrTaken50020 = 57;
var $author$project$Discord$InviteWasAcceptedToAGuildTheAppsBotIsNotIn50036 = 62;
var $author$project$Discord$MaxNumberOfAttachmentsInAMessage30015 = 33;
var $author$project$Discord$MaxNumberOfFriends30002 = 27;
var $author$project$Discord$MaxNumberOfGuildChannels30013 = 32;
var $author$project$Discord$MaxNumberOfGuilds30001 = 26;
var $author$project$Discord$MaxNumberOfGuildsRoles30005 = 29;
var $author$project$Discord$MaxNumberOfInvitesReached30016 = 34;
var $author$project$Discord$MaxNumberOfPinsForChannel30003 = 28;
var $author$project$Discord$MaxNumberOfReactions30010 = 31;
var $author$project$Discord$MaxNumberOfWebhooks30007 = 30;
var $author$project$Discord$MessageCanOnlyBePinnedToChannelItIsIn50019 = 56;
var $author$project$Discord$MessageProvidedWasTooOldToBulkDelete50034 = 60;
var $author$project$Discord$MissingAccess50001 = 40;
var $author$project$Discord$NoteWasTooLong50015 = 54;
var $author$project$Discord$OAuth2AppDoesNotHaveABot50010 = 49;
var $author$project$Discord$OAuth2AppLimitReached50011 = 50;
var $author$project$Discord$OnlyBotsCanUseThisEndpoint20002 = 25;
var $author$project$Discord$ProvidedTooFewOrTooManyMessagesToDelete50016 = 55;
var $author$project$Discord$ReactionWasBlocked90001 = 64;
var $author$project$Discord$RequestEntityTooLarge40005 = 37;
var $author$project$Discord$UnauthorizedProvideAValidTokenAndTryAgain40001 = 35;
var $author$project$Discord$UnknownAccount10001 = 1;
var $author$project$Discord$UnknownApp10002 = 2;
var $author$project$Discord$UnknownBan10026 = 16;
var $author$project$Discord$UnknownBranch10032 = 22;
var $author$project$Discord$UnknownBuild10030 = 20;
var $author$project$Discord$UnknownChannel10003 = 3;
var $author$project$Discord$UnknownEmoji10014 = 14;
var $author$project$Discord$UnknownEntitlement10029 = 19;
var $author$project$Discord$UnknownGuild10004 = 4;
var $author$project$Discord$UnknownIntegration1005 = 5;
var $author$project$Discord$UnknownInvite10006 = 6;
var $author$project$Discord$UnknownLobby10031 = 21;
var $author$project$Discord$UnknownMember10007 = 7;
var $author$project$Discord$UnknownMessage10008 = 8;
var $author$project$Discord$UnknownPermissionOverwrite10009 = 9;
var $author$project$Discord$UnknownProvider10010 = 10;
var $author$project$Discord$UnknownRedistributable10036 = 23;
var $author$project$Discord$UnknownRole10011 = 11;
var $author$project$Discord$UnknownSku10027 = 17;
var $author$project$Discord$UnknownStoreListing10028 = 18;
var $author$project$Discord$UnknownToken10012 = 12;
var $author$project$Discord$UnknownUser10013 = 13;
var $author$project$Discord$UnknownWebhook10015 = 15;
var $author$project$Discord$UserIsBannedFromThisGuild40007 = 39;
var $author$project$Discord$VerifyYourAccount40002 = 36;
var $author$project$Discord$YouLackPermissionsToPerformThatAction50013 = 52;
var $author$project$Discord$w3_unsafe_decode_ErrorCode = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(65);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(24);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(44);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(42);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(58);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(45);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(47);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(46);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(48);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(38);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(43);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(41);
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(63);
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(53);
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(61);
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(59);
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(51);
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(57);
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(62);
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(33);
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(27);
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(32);
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(26);
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(29);
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(34);
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(28);
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(31);
			case 28:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(30);
			case 29:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(56);
			case 30:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(60);
			case 31:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(40);
			case 32:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(54);
			case 33:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(49);
			case 34:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(50);
			case 35:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(25);
			case 36:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(55);
			case 37:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(64);
			case 38:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(37);
			case 39:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(35);
			case 40:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 41:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 42:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(16);
			case 43:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(22);
			case 44:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(20);
			case 45:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 46:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(14);
			case 47:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(19);
			case 48:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 49:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 50:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			case 51:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(21);
			case 52:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			case 53:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(8);
			case 54:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(9);
			case 55:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(10);
			case 56:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(23);
			case 57:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(11);
			case 58:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(17);
			case 59:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(18);
			case 60:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(12);
			case 61:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(13);
			case 62:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(15);
			case 63:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(39);
			case 64:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(36);
			case 65:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(52);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Discord$w3_unsafe_decode_RateLimit = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (isGlobal0, retryAfter0) {
					return {isGlobal: isGlobal0, retryAfter: retryAfter0};
				}))));
var $author$project$Discord$w3_unsafe_decode_HttpError = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_ErrorCode,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Discord$BadRequest400));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_ErrorCode,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Discord$Forbidden403));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_ErrorCode,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Discord$GatewayUnavailable502));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Discord$NetworkError);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_ErrorCode,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Discord$NotFound404));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_ErrorCode,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Discord$NotModified304));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_ErrorCode,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (errorCode0, statusCode0) {
										return {errorCode: errorCode0, statusCode: statusCode0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Discord$ServerError5xx));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Discord$Timeout);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_RateLimit,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Discord$TooManyRequests429));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_ErrorCode,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Discord$Unauthorized401));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Discord$UnexpectedError));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Log$ChangedUsers = function (a) {
	return {$: 3, a: a};
};
var $author$project$Log$DeletedLog = {$: 36};
var $author$project$Log$EmptyDiscordMessage = function (a) {
	return {$: 22, a: a};
};
var $author$project$Log$FailedToAddReactionToDiscordDmMessage$ = function (a, b, c, d, e) {
	return {$: 11, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Log$FailedToAddReactionToDiscordDmMessage = F5($author$project$Log$FailedToAddReactionToDiscordDmMessage$);
var $author$project$Log$FailedToAddReactionToDiscordGuildMessage$ = function (a, b, c, d, e, f) {
	return {$: 10, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Log$FailedToAddReactionToDiscordGuildMessage = F6($author$project$Log$FailedToAddReactionToDiscordGuildMessage$);
var $author$project$Log$FailedToChangeSlackReaction$ = function (a, b) {
	return {$: 32, a: a, b: b};
};
var $author$project$Log$FailedToChangeSlackReaction = F2($author$project$Log$FailedToChangeSlackReaction$);
var $author$project$Log$FailedToDeleteDiscordDmMessage$ = function (a, b, c, d) {
	return {$: 7, a: a, b: b, c: c, d: d};
};
var $author$project$Log$FailedToDeleteDiscordDmMessage = F4($author$project$Log$FailedToDeleteDiscordDmMessage$);
var $author$project$Log$FailedToDeleteDiscordGuildMessage$ = function (a, b, c, d, e) {
	return {$: 6, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Log$FailedToDeleteDiscordGuildMessage = F5($author$project$Log$FailedToDeleteDiscordGuildMessage$);
var $author$project$Log$FailedToDeleteOrphanedFiles = function (a) {
	return {$: 28, a: a};
};
var $author$project$Log$FailedToDeleteSlackMessage$ = function (a, b) {
	return {$: 33, a: a, b: b};
};
var $author$project$Log$FailedToDeleteSlackMessage = F2($author$project$Log$FailedToDeleteSlackMessage$);
var $author$project$Log$FailedToEditDiscordDmMessage$ = function (a, b, c, d) {
	return {$: 9, a: a, b: b, c: c, d: d};
};
var $author$project$Log$FailedToEditDiscordDmMessage = F4($author$project$Log$FailedToEditDiscordDmMessage$);
var $author$project$Log$FailedToEditDiscordGuildMessage$ = function (a, b, c, d, e) {
	return {$: 8, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Log$FailedToEditDiscordGuildMessage = F5($author$project$Log$FailedToEditDiscordGuildMessage$);
var $author$project$Log$FailedToEditSlackMessage$ = function (a, b) {
	return {$: 34, a: a, b: b};
};
var $author$project$Log$FailedToEditSlackMessage = F2($author$project$Log$FailedToEditSlackMessage$);
var $author$project$Log$FailedToGenerateScheduledBackup$ = function (a, b) {
	return {$: 26, a: a, b: b};
};
var $author$project$Log$FailedToGenerateScheduledBackup = F2($author$project$Log$FailedToGenerateScheduledBackup$);
var $author$project$Log$FailedToGetDataForJoinedOrCreatedDiscordGuild$ = function (a, b, c) {
	return {$: 19, a: a, b: b, c: c};
};
var $author$project$Log$FailedToGetDataForJoinedOrCreatedDiscordGuild = F3($author$project$Log$FailedToGetDataForJoinedOrCreatedDiscordGuild$);
var $author$project$Log$FailedToGetDiscordUserAvatars = function (a) {
	return {$: 17, a: a};
};
var $author$project$Log$FailedToLoadDiscordGuildCustomEmojis$ = function (a, b) {
	return {$: 25, a: a, b: b};
};
var $author$project$Log$FailedToLoadDiscordGuildCustomEmojis = F2($author$project$Log$FailedToLoadDiscordGuildCustomEmojis$);
var $author$project$Log$FailedToLoadDiscordGuildStickers$ = function (a, b) {
	return {$: 23, a: a, b: b};
};
var $author$project$Log$FailedToLoadDiscordGuildStickers = F2($author$project$Log$FailedToLoadDiscordGuildStickers$);
var $author$project$Log$FailedToLoadDiscordStandardStickerPacks = function (a) {
	return {$: 24, a: a};
};
var $author$project$Log$FailedToLoadDiscordUserData$ = function (a, b) {
	return {$: 14, a: a, b: b};
};
var $author$project$Log$FailedToLoadDiscordUserData = F2($author$project$Log$FailedToLoadDiscordUserData$);
var $author$project$Log$FailedToLoadSlackConversations$ = function (a, b) {
	return {$: 29, a: a, b: b};
};
var $author$project$Log$FailedToLoadSlackConversations = F2($author$project$Log$FailedToLoadSlackConversations$);
var $author$project$Log$FailedToLoadSlackCustomEmojis$ = function (a, b, c) {
	return {$: 30, a: a, b: b, c: c};
};
var $author$project$Log$FailedToLoadSlackCustomEmojis = F3($author$project$Log$FailedToLoadSlackCustomEmojis$);
var $author$project$Log$FailedToParseDiscordWebsocket$ = function (a, b) {
	return {$: 18, a: a, b: b};
};
var $author$project$Log$FailedToParseDiscordWebsocket = F2($author$project$Log$FailedToParseDiscordWebsocket$);
var $author$project$Log$FailedToRegenerateServerSecret = function (a) {
	return {$: 27, a: a};
};
var $author$project$Log$FailedToReloadDiscordGuild$ = function (a, b) {
	return {$: 20, a: a, b: b};
};
var $author$project$Log$FailedToReloadDiscordGuild = F2($author$project$Log$FailedToReloadDiscordGuild$);
var $author$project$Log$FailedToRemoveReactionToDiscordDmMessage$ = function (a, b, c, d, e) {
	return {$: 13, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Log$FailedToRemoveReactionToDiscordDmMessage = F5($author$project$Log$FailedToRemoveReactionToDiscordDmMessage$);
var $author$project$Log$FailedToRemoveReactionToDiscordGuildMessage$ = function (a, b, c, d, e, f) {
	return {$: 12, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Log$FailedToRemoveReactionToDiscordGuildMessage = F6($author$project$Log$FailedToRemoveReactionToDiscordGuildMessage$);
var $author$project$Log$FailedToSendDiscordDmMessage$ = function (a, b, c) {
	return {$: 16, a: a, b: b, c: c};
};
var $author$project$Log$FailedToSendDiscordDmMessage = F3($author$project$Log$FailedToSendDiscordDmMessage$);
var $author$project$Log$FailedToSendDiscordGuildMessage$ = function (a, b, c, d, e) {
	return {$: 15, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Log$FailedToSendDiscordGuildMessage = F5($author$project$Log$FailedToSendDiscordGuildMessage$);
var $author$project$Log$FailedToSendNotificationEmail$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$Log$FailedToSendNotificationEmail = F2($author$project$Log$FailedToSendNotificationEmail$);
var $author$project$Log$FailedToSendSlackMessage$ = function (a, b) {
	return {$: 31, a: a, b: b};
};
var $author$project$Log$FailedToSendSlackMessage = F2($author$project$Log$FailedToSendSlackMessage$);
var $author$project$Log$JoinedDiscordThreadFailed$ = function (a, b) {
	return {$: 21, a: a, b: b};
};
var $author$project$Log$JoinedDiscordThreadFailed = F2($author$project$Log$JoinedDiscordThreadFailed$);
var $author$project$Log$LoginEmail$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Log$LoginEmail = F2($author$project$Log$LoginEmail$);
var $author$project$Log$LoginsRateLimited = function (a) {
	return {$: 2, a: a};
};
var $author$project$Log$PushNotificationError$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$Log$PushNotificationError = F2($author$project$Log$PushNotificationError$);
var $author$project$Log$ReceivedTypeThatIsAlwaysInvalid = {$: 35};
var $author$project$Log$SendLogErrorEmailFailed$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $author$project$Log$SendLogErrorEmailFailed = F2($author$project$Log$SendLogErrorEmailFailed$);
var $author$project$Slack$BadBody = function (a) {
	return {$: 3, a: a};
};
var $author$project$Slack$BadStatus$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Slack$BadStatus = F2($author$project$Slack$BadStatus$);
var $author$project$Slack$BadUrl = function (a) {
	return {$: 6, a: a};
};
var $author$project$Slack$NetworkError = {$: 5};
var $author$project$Slack$RateLimited = {$: 1};
var $author$project$Slack$SlackError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Slack$Timeout = {$: 4};
var $author$project$Slack$w3_unsafe_decode_HttpError = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Slack$BadBody));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Slack$BadStatus)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Slack$BadUrl));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Slack$NetworkError);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Slack$RateLimited);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Slack$SlackError));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Slack$Timeout);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Discord$MessageId = $elm$core$Basics$identity;
var $author$project$Discord$w3_unsafe_decode_MessageId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Postmark$BadUrl = function (a) {
	return {$: 4, a: a};
};
var $author$project$Postmark$NetworkError = {$: 2};
var $author$project$Postmark$PostmarkError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Postmark$Timeout = {$: 3};
var $author$project$Postmark$UnknownError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Postmark$w3_unsafe_decode_PostmarkSendResponse = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$EmailAddress$w3_unsafe_decode_EmailAddress),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (errorCode0, message0, to0) {
						return {errorCode: errorCode0, message: message0, to: to0};
					})))));
var $author$project$Postmark$w3_unsafe_decode_SendEmailError = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Postmark$BadUrl));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Postmark$NetworkError);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Postmark$w3_unsafe_decode_PostmarkSendResponse,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Postmark$PostmarkError));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Postmark$Timeout);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeString,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (body0, statusCode0) {
										return {body: body0, statusCode: statusCode0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Postmark$UnknownError));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Id$w3_unsafe_decode_ThreadRouteWithMaybeMessage = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Id$NoThreadWithMaybeMessage));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ThreadMessageId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Id$ViewThreadWithMaybeMessage)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Log$w3_unsafe_decode_Log = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$ChangedUsers));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$DeletedLog);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$EmptyDiscordMessage));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_MessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$FailedToAddReactionToDiscordDmMessage))))));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_MessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$FailedToAddReactionToDiscordGuildMessage)))))));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Slack$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_SlackGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$FailedToChangeSlackReaction)));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_MessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$FailedToDeleteDiscordDmMessage)))));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_MessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$FailedToDeleteDiscordGuildMessage))))));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$FailedToDeleteOrphanedFiles));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Slack$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_SlackGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$FailedToDeleteSlackMessage)));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_MessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$FailedToEditDiscordDmMessage)))));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_MessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$FailedToEditDiscordGuildMessage))))));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Slack$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_SlackGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$FailedToEditSlackMessage)));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$FailedToGenerateScheduledBackup)));
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$FailedToGetDataForJoinedOrCreatedDiscordGuild))));
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$FailedToGetDiscordUserAvatars));
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$lamdera$codecs$Lamdera$Wire3$decodePair$(
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_CustomEmojiId),
								$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$FailedToLoadDiscordGuildCustomEmojis)));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$lamdera$codecs$Lamdera$Wire3$decodePair$(
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_StickerId),
								$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$FailedToLoadDiscordGuildStickers)));
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$FailedToLoadDiscordStandardStickerPacks));
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$FailedToLoadDiscordUserData)));
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Slack$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$FailedToLoadSlackConversations)));
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$lamdera$codecs$Lamdera$Wire3$decodePair$(
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_CustomEmojiId),
								$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$FailedToLoadSlackCustomEmojis))));
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$FailedToParseDiscordWebsocket)));
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$FailedToRegenerateServerSecret));
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$FailedToReloadDiscordGuild)));
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_MessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$FailedToRemoveReactionToDiscordDmMessage))))));
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_MessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$FailedToRemoveReactionToDiscordGuildMessage)))))));
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$FailedToSendDiscordDmMessage))));
			case 28:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_ThreadRouteWithMaybeMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$FailedToSendDiscordGuildMessage))))));
			case 29:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$EmailAddress$w3_unsafe_decode_EmailAddress,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Postmark$w3_unsafe_decode_SendEmailError,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$FailedToSendNotificationEmail)));
			case 30:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Slack$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_SlackGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$FailedToSendSlackMessage)));
			case 31:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$JoinedDiscordThreadFailed)));
			case 32:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$EmailAddress$w3_unsafe_decode_EmailAddress,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeResult$($author$project$Postmark$w3_unsafe_decode_SendEmailError, $lamdera$codecs$Lamdera$Wire3$decodeUnit),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$LoginEmail)));
			case 33:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$LoginsRateLimited));
			case 34:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$PushNotificationError)));
			case 35:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$ReceivedTypeThatIsAlwaysInvalid);
			case 36:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$EmailAddress$w3_unsafe_decode_EmailAddress,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Postmark$w3_unsafe_decode_SendEmailError,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Log$SendLogErrorEmailFailed)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$LocalState$w3_unsafe_decode_LogWithTime = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Log$w3_unsafe_decode_Log,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (log0, time0) {
					return {log: log0, time: time0};
				}))));
var $author$project$LocalState$w3_unsafe_decode_PrivateVapidKey = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Discord$w3_unsafe_decode_RoleColors = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (primaryColor0, secondaryColor0, tertiaryColor0) {
						return {primaryColor: primaryColor0, secondaryColor: secondaryColor0, tertiaryColor: tertiaryColor0};
					})))));
var $author$project$Discord$RoleIconHash = $elm$core$Basics$identity;
var $author$project$Discord$w3_unsafe_decode_RoleIconHash = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Discord$IntegrationId = $elm$core$Basics$identity;
var $author$project$Discord$w3_unsafe_decode_IntegrationId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Discord$SubscriptionListingId = $elm$core$Basics$identity;
var $author$project$Discord$w3_unsafe_decode_SubscriptionListingId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Discord$w3_unsafe_decode_RoleTags = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Discord$w3_unsafe_decode_OptionalData(
		$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_SubscriptionListingId)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Discord$w3_unsafe_decode_OptionalData(
				$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_IntegrationId)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeBool,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_OptionalData(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F6(
								function (availableForPurchase0, botId0, guildConnections0, integrationId0, premiumSubscriber0, subscriptionListingId0) {
									return {availableForPurchase: availableForPurchase0, botId: botId0, guildConnections: guildConnections0, integrationId: integrationId0, premiumSubscriber: premiumSubscriber0, subscriptionListingId: subscriptionListingId0};
								}))))))));
var $author$project$Discord$w3_unsafe_decode_Role = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Discord$w3_unsafe_decode_OptionalData($author$project$Discord$w3_unsafe_decode_RoleTags),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Discord$w3_unsafe_decode_Permissions,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeBool,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_RoleId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
										$author$project$Discord$w3_unsafe_decode_ImageHash($author$project$Discord$w3_unsafe_decode_RoleIconHash)),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeBool,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Discord$w3_unsafe_decode_OptionalData($lamdera$codecs$Lamdera$Wire3$decodeInt),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$author$project$Discord$w3_unsafe_decode_OptionalData($author$project$Discord$w3_unsafe_decode_RoleColors),
													$lamdera$codecs$Lamdera$Wire3$succeedDecode(
														function (colors0) {
															return function (description0) {
																return function (flags0) {
																	return function (hoist0) {
																		return function (icon0) {
																			return function (id0) {
																				return function (managed0) {
																					return function (mentionable0) {
																						return function (name0) {
																							return function (permissions0) {
																								return function (position0) {
																									return function (tags0) {
																										return function (unicodeEmoji0) {
																											return {colors: colors0, description: description0, flags: flags0, hoist: hoist0, icon: icon0, id: id0, managed: managed0, mentionable: mentionable0, name: name0, permissions: permissions0, position: position0, tags: tags0, unicodeEmoji: unicodeEmoji0};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														}))))))))))))));
var $author$project$SessionIdHash$w3_unsafe_decode_SessionIdHash = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$ToBackendLog$ToBackendLog_AdminDataRequest = 15;
var $author$project$ToBackendLog$ToBackendLog_AdminToBackend = 5;
var $author$project$ToBackendLog$ToBackendLog_AiChatToBackend = 10;
var $author$project$ToBackendLog$ToBackendLog_CheckLoginRequest = 0;
var $author$project$ToBackendLog$ToBackendLog_ExportChannelRequest = 17;
var $author$project$ToBackendLog$ToBackendLog_FinishUserCreationRequest = 9;
var $author$project$ToBackendLog$ToBackendLog_GetLoginTokenRequest = 4;
var $author$project$ToBackendLog$ToBackendLog_GetPublicGoMatchRequest = 16;
var $author$project$ToBackendLog$ToBackendLog_ImportChannelRequest = 18;
var $author$project$ToBackendLog$ToBackendLog_JoinGuildByInviteRequest = 8;
var $author$project$ToBackendLog$ToBackendLog_LinkDiscordRequest = 12;
var $author$project$ToBackendLog$ToBackendLog_LinkSlackRequest = 13;
var $author$project$ToBackendLog$ToBackendLog_Local_AcceptE2ee = 95;
var $author$project$ToBackendLog$ToBackendLog_Local_AddCustomEmojisToUser = 73;
var $author$project$ToBackendLog$ToBackendLog_Local_AddReactionEmoji = 38;
var $author$project$ToBackendLog$ToBackendLog_Local_Admin = 20;
var $author$project$ToBackendLog$ToBackendLog_Local_BanMember = 35;
var $author$project$ToBackendLog$ToBackendLog_Local_CancelAccountDeletion = 63;
var $author$project$ToBackendLog$ToBackendLog_Local_CancelE2eeRequest = 88;
var $author$project$ToBackendLog$ToBackendLog_Local_CollapseUserOptionSection = 59;
var $author$project$ToBackendLog$ToBackendLog_Local_CurrentlyViewing = 46;
var $author$project$ToBackendLog$ToBackendLog_Local_DeclineE2eeRequest = 89;
var $author$project$ToBackendLog$ToBackendLog_Local_DecryptOldMessages = 93;
var $author$project$ToBackendLog$ToBackendLog_Local_DeleteChannel = 29;
var $author$project$ToBackendLog$ToBackendLog_Local_DeleteGuild = 31;
var $author$project$ToBackendLog$ToBackendLog_Local_DeleteInviteLink = 34;
var $author$project$ToBackendLog$ToBackendLog_Local_DeleteMessage = 45;
var $author$project$ToBackendLog$ToBackendLog_Local_DisableE2ee = 92;
var $author$project$ToBackendLog$ToBackendLog_Local_Discord_LoadChannelMessages = 50;
var $author$project$ToBackendLog$ToBackendLog_Local_Discord_LoadThreadMessages = 53;
var $author$project$ToBackendLog$ToBackendLog_Local_Discord_SendEditDmMessage = 42;
var $author$project$ToBackendLog$ToBackendLog_Local_Discord_SendEditGuildMessage = 41;
var $author$project$ToBackendLog$ToBackendLog_Local_Discord_SendMessage = 22;
var $author$project$ToBackendLog$ToBackendLog_Local_Drawing = 76;
var $author$project$ToBackendLog$ToBackendLog_Local_EditChannel = 28;
var $author$project$ToBackendLog$ToBackendLog_Local_EditGuildName = 30;
var $author$project$ToBackendLog$ToBackendLog_Local_EncryptOldMessages = 91;
var $author$project$ToBackendLog$ToBackendLog_Local_ExpandUserOptionSection = 57;
var $author$project$ToBackendLog$ToBackendLog_Local_Game = 75;
var $author$project$ToBackendLog$ToBackendLog_Local_Invalid = 19;
var $author$project$ToBackendLog$ToBackendLog_Local_LeaveGuild = 32;
var $author$project$ToBackendLog$ToBackendLog_Local_LinkDiscordAcknowledgementIsChecked = 68;
var $author$project$ToBackendLog$ToBackendLog_Local_LinkSlackAcknowledgementIsChecked = 69;
var $author$project$ToBackendLog$ToBackendLog_Local_LoadChannelMessages = 48;
var $author$project$ToBackendLog$ToBackendLog_Local_LoadThreadMessages = 49;
var $author$project$ToBackendLog$ToBackendLog_Local_MemberEditTyping = 43;
var $author$project$ToBackendLog$ToBackendLog_Local_MemberTyping = 37;
var $author$project$ToBackendLog$ToBackendLog_Local_NewChannel = 27;
var $author$project$ToBackendLog$ToBackendLog_Local_NewGuild = 36;
var $author$project$ToBackendLog$ToBackendLog_Local_NewInviteLink = 33;
var $author$project$ToBackendLog$ToBackendLog_Local_RegisterPushSubscription = 64;
var $author$project$ToBackendLog$ToBackendLog_Local_RemoveReactionEmoji = 39;
var $author$project$ToBackendLog$ToBackendLog_Local_RequestE2ee = 87;
var $author$project$ToBackendLog$ToBackendLog_Local_ScheduleAccountDeletion = 62;
var $author$project$ToBackendLog$ToBackendLog_Local_SendEditMessage = 40;
var $author$project$ToBackendLog$ToBackendLog_Local_SendEncryptedEditMessage = 97;
var $author$project$ToBackendLog$ToBackendLog_Local_SendEncryptedMessage = 96;
var $author$project$ToBackendLog$ToBackendLog_Local_SendMessage = 21;
var $author$project$ToBackendLog$ToBackendLog_Local_SetDiscordGuildNotificationLevel = 55;
var $author$project$ToBackendLog$ToBackendLog_Local_SetDomainWhitelist = 70;
var $author$project$ToBackendLog$ToBackendLog_Local_SetE2eeRisksAccepted = 94;
var $author$project$ToBackendLog$ToBackendLog_Local_SetEmailNotifications = 60;
var $author$project$ToBackendLog$ToBackendLog_Local_SetEmbedVisibility = 61;
var $author$project$ToBackendLog$ToBackendLog_Local_SetEmojiSkinTone = 71;
var $author$project$ToBackendLog$ToBackendLog_Local_SetGuildNotificationLevel = 54;
var $author$project$ToBackendLog$ToBackendLog_Local_SetLastViewed = 44;
var $author$project$ToBackendLog$ToBackendLog_Local_SetMuteChannel = 77;
var $author$project$ToBackendLog$ToBackendLog_Local_SetMuteDiscordChannel = 79;
var $author$project$ToBackendLog$ToBackendLog_Local_SetMuteDiscordGuild = 82;
var $author$project$ToBackendLog$ToBackendLog_Local_SetMuteDiscordThread = 80;
var $author$project$ToBackendLog$ToBackendLog_Local_SetMuteGuild = 81;
var $author$project$ToBackendLog$ToBackendLog_Local_SetMuteSlackChannel = 85;
var $author$project$ToBackendLog$ToBackendLog_Local_SetMuteSlackThread = 86;
var $author$project$ToBackendLog$ToBackendLog_Local_SetMuteSlackWorkspace = 84;
var $author$project$ToBackendLog$ToBackendLog_Local_SetMuteThread = 78;
var $author$project$ToBackendLog$ToBackendLog_Local_SetName = 47;
var $author$project$ToBackendLog$ToBackendLog_Local_SetNotificationMode = 56;
var $author$project$ToBackendLog$ToBackendLog_Local_SetPublicKey = 90;
var $author$project$ToBackendLog$ToBackendLog_Local_SetSheepGameQuestions = 58;
var $author$project$ToBackendLog$ToBackendLog_Local_SetSlackWorkspaceNotificationLevel = 83;
var $author$project$ToBackendLog$ToBackendLog_Local_SetUserColor = 72;
var $author$project$ToBackendLog$ToBackendLog_Local_Slack_LoadChannelMessages = 51;
var $author$project$ToBackendLog$ToBackendLog_Local_Slack_LoadThreadMessages = 52;
var $author$project$ToBackendLog$ToBackendLog_Local_Slack_ReloadUser = 26;
var $author$project$ToBackendLog$ToBackendLog_Local_Slack_SendEditMessage = 24;
var $author$project$ToBackendLog$ToBackendLog_Local_Slack_SendMessage = 23;
var $author$project$ToBackendLog$ToBackendLog_Local_Slack_UnlinkUser = 25;
var $author$project$ToBackendLog$ToBackendLog_Local_StartReloadingDiscordUser = 67;
var $author$project$ToBackendLog$ToBackendLog_Local_TextEditor = 65;
var $author$project$ToBackendLog$ToBackendLog_Local_UnlinkDiscordUser = 66;
var $author$project$ToBackendLog$ToBackendLog_Local_VoiceChatChange = 74;
var $author$project$ToBackendLog$ToBackendLog_LogOutRequest = 6;
var $author$project$ToBackendLog$ToBackendLog_LoginWithRecoveryPasswordRequest = 3;
var $author$project$ToBackendLog$ToBackendLog_LoginWithTokenRequest = 1;
var $author$project$ToBackendLog$ToBackendLog_LoginWithTwoFactorRequest = 2;
var $author$project$ToBackendLog$ToBackendLog_ProfilePictureEditorToBackend = 14;
var $author$project$ToBackendLog$ToBackendLog_ReloadDataRequest = 11;
var $author$project$ToBackendLog$ToBackendLog_TwoFactorToBackend = 7;
var $author$project$ToBackendLog$w3_unsafe_decode_ToBackendLog = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(15);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(10);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(17);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(9);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(16);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(18);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(8);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(12);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(13);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(95);
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(73);
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(38);
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(20);
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(35);
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(63);
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(88);
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(59);
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(46);
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(89);
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(93);
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(29);
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(31);
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(34);
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(45);
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(92);
			case 28:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(50);
			case 29:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(53);
			case 30:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(42);
			case 31:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(41);
			case 32:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(22);
			case 33:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(76);
			case 34:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(28);
			case 35:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(30);
			case 36:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(91);
			case 37:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(57);
			case 38:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(75);
			case 39:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(19);
			case 40:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(32);
			case 41:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(68);
			case 42:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(69);
			case 43:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(48);
			case 44:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(49);
			case 45:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(43);
			case 46:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(37);
			case 47:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(27);
			case 48:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(36);
			case 49:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(33);
			case 50:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(64);
			case 51:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(39);
			case 52:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(87);
			case 53:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(62);
			case 54:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(40);
			case 55:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(97);
			case 56:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(96);
			case 57:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(21);
			case 58:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(55);
			case 59:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(70);
			case 60:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(94);
			case 61:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(60);
			case 62:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(61);
			case 63:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(71);
			case 64:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(54);
			case 65:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(44);
			case 66:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(77);
			case 67:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(79);
			case 68:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(82);
			case 69:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(80);
			case 70:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(81);
			case 71:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(85);
			case 72:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(86);
			case 73:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(84);
			case 74:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(78);
			case 75:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(47);
			case 76:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(56);
			case 77:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(90);
			case 78:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(58);
			case 79:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(83);
			case 80:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(72);
			case 81:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(51);
			case 82:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(52);
			case 83:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(26);
			case 84:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(24);
			case 85:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(23);
			case 86:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(25);
			case 87:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(67);
			case 88:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(65);
			case 89:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(66);
			case 90:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(74);
			case 91:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			case 92:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 93:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 94:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 95:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(14);
			case 96:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(11);
			case 97:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$ToBackendLog$w3_unsafe_decode_ToBackendLogData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
		$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$ToBackendLog$w3_unsafe_decode_ToBackendLog,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (endTime0, startTime0, toBackendLog0, userId0) {
							return {endTime: endTime0, startTime: startTime0, toBackendLog: toBackendLog0, userId: userId0};
						}))))));
var $author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$UserSession$EmptyPlaceholder);
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_a,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$UserSession$FilledInByBackend));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$IdArray$w3_unsafe_decode_IdArray$ = function (w3_x_c_k, w3_x_c_v) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeArray(w3_x_c_v),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$IdArray$w3_unsafe_decode_IdArray = F2($author$project$IdArray$w3_unsafe_decode_IdArray$);
var $author$project$UserSession$w3_unsafe_decode_LastViewedGuild = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$UserSession$LastViewedDiscordGuild));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$UserSession$LastViewedGuild));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$UserSession$LastViewedSlackWorkspace));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$UserSession$w3_unsafe_decode_NotificationMode = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Ports$w3_unsafe_decode_SubscribeKeys = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (auth0, p256dh0) {
					return {auth: auth0, p256dh: p256dh0};
				}))));
var $author$project$Ports$w3_unsafe_decode_SubscribeData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Ports$w3_unsafe_decode_SubscribeKeys,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
			A2(
				$lamdera$codecs$Lamdera$Wire3$andThenDecode,
				function (t) {
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
						$elm$time$Time$millisToPosix(t));
				},
				$lamdera$codecs$Lamdera$Wire3$decodeInt)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$elm$url$Url$w3_unsafe_decode_Url,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (endpoint0, expirationTime0, keys0) {
						return {endpoint: endpoint0, expirationTime: expirationTime0, keys: keys0};
					})))));
var $author$project$UserSession$w3_unsafe_decode_PushSubscription = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$UserSession$NotSubscribed);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Ports$w3_unsafe_decode_SubscribeData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$UserSession$Subscribed)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Ports$w3_unsafe_decode_SubscribeData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$UserSession$SubscriptionError)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$UserSession$SubscriptionJsException)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$UserSession$w3_unsafe_decode_SheepGameQuestion = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
			$author$project$FileStatus$w3_unsafe_decode_FileStatus),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (attachedFiles0, text0) {
					return {attachedFiles: attachedFiles0, text: text0};
				}))));
var $author$project$UserAgent$w3_unsafe_decode_Browser = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$UserAgent$w3_unsafe_decode_Device = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(10);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(8);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(9);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$UserAgent$w3_unsafe_decode_UserAgent = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$UserAgent$w3_unsafe_decode_Device,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$UserAgent$w3_unsafe_decode_Browser,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (browser0, device0) {
					return {browser: browser0, device: device0};
				}))));
var $author$project$UserSession$w3_unsafe_decode_UserOptionSection = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(8);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$UserSession$w3_unsafe_decode_UserSession = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$UserAgent$w3_unsafe_decode_UserAgent,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$SessionIdHash$w3_unsafe_decode_SessionIdHash,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$IdArray$w3_unsafe_decode_IdArray$($author$project$Id$w3_unsafe_decode_QuestionId, $author$project$UserSession$w3_unsafe_decode_SheepGameQuestion),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$UserSession$w3_unsafe_decode_PushSubscription,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$UserSession$w3_unsafe_decode_NotificationMode,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$UserSession$w3_unsafe_decode_LastViewedGuild),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$containers$SeqSet$decodeSet($author$project$UserSession$w3_unsafe_decode_UserOptionSection),
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											function (expandedUserOptions0) {
												return function (lastClientDisconnect0) {
													return function (lastViewedGuild0) {
														return function (notificationMode0) {
															return function (pushSubscription0) {
																return function (savedSheepGameQuestions0) {
																	return function (sessionIdHash0) {
																		return function (signedInAt0) {
																			return function (userAgent0) {
																				return function (userId0) {
																					return {expandedUserOptions: expandedUserOptions0, lastClientDisconnect: lastClientDisconnect0, lastViewedGuild: lastViewedGuild0, notificationMode: notificationMode0, pushSubscription: pushSubscription0, savedSheepGameQuestions: savedSheepGameQuestions0, sessionIdHash: sessionIdHash0, signedInAt: signedInAt0, userAgent: userAgent0, userId: userId0};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											})))))))))));
var $author$project$LocalState$WebsocketClosed_CloseAndReopenForUser$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$LocalState$WebsocketClosed_CloseAndReopenForUser = F2($author$project$LocalState$WebsocketClosed_CloseAndReopenForUser$);
var $author$project$LocalState$WebsocketClosed_ClosedByBackendForUser$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$LocalState$WebsocketClosed_ClosedByBackendForUser = F2($author$project$LocalState$WebsocketClosed_ClosedByBackendForUser$);
var $author$project$LocalState$WebsocketClosed_ListenCloseEvent$ = function (a, b, c, d) {
	return {$: 3, a: a, b: b, c: c, d: d};
};
var $author$project$LocalState$WebsocketClosed_ListenCloseEvent = F4($author$project$LocalState$WebsocketClosed_ListenCloseEvent$);
var $author$project$LocalState$WebsocketClosed_UnlinkDiscordUser$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$LocalState$WebsocketClosed_UnlinkDiscordUser = F2($author$project$LocalState$WebsocketClosed_UnlinkDiscordUser$);
var $author$project$LocalState$w3_unsafe_decode_WebsocketClosedEvent = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$WebsocketClosed_CloseAndReopenForUser)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$WebsocketClosed_ClosedByBackendForUser)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Websocket$w3_unsafe_decode_CloseEventCode,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$WebsocketClosed_ListenCloseEvent)))));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$WebsocketClosed_UnlinkDiscordUser)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Pages$Admin$w3_unsafe_decode_AdminChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Pages$Admin$w3_unsafe_decode_EditedBackendUser),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqSet$decodeSet(
									$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId)),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$containers$SeqDict$decodeDict$(
										$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
										$author$project$Pages$Admin$w3_unsafe_decode_EditedBackendUser),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F4(
											function (changedUsers0, deletedUsers0, newUsers0, time0) {
												return {changedUsers: changedUsers0, deletedUsers: deletedUsers0, newUsers: newUsers0, time: time0};
											})))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ChangeUsers));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$DeleteDiscordDmChannel));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$DeleteDiscordGuild));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$DeleteGuild));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$codecs$Lamdera$Wire3$decodeResult$(
							$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
							$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$FileStatus$w3_unsafe_decode_FileHash))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$DeleteOrphanedFiles));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$SessionIdHash$w3_unsafe_decode_SessionIdHash,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$DeleteSession));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_DmChannelId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$DeleteSlackDmChannel));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$DeleteSlackWorkspace));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$SessionIdHash$w3_unsafe_decode_SessionIdHash,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$DisconnectClient)));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$BackendMsgLog$w3_unsafe_decode_BackendMsgLogData)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$LoadBackendMsgLogs));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
							$author$project$LocalState$w3_unsafe_decode_AdminData_DeletedGuild)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$LoadDeletedGuilds));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
							$author$project$LocalState$w3_unsafe_decode_AdminData_DiscordDmChannel)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$LoadDiscordDmChannels));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
							$author$project$LocalState$w3_unsafe_decode_AdminData_DiscordGuild)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$LoadDiscordGuilds));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
							$author$project$LocalState$w3_unsafe_decode_DiscordUserData_ForAdmin)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$LoadDiscordUsers));
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$($author$project$DmChannelId$w3_unsafe_decode_DmChannelId, $author$project$LocalState$w3_unsafe_decode_AdminData_DmChannel)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$LoadDmChannels));
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
							$author$project$LocalState$w3_unsafe_decode_AdminData_Guild)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$LoadGuilds));
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$($author$project$FileStatus$w3_unsafe_decode_FileHash, $author$project$FileStatus$w3_unsafe_decode_BackendFileData)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$LoadOrphanedFiles));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$($author$project$SessionIdHash$w3_unsafe_decode_SessionIdHash, $author$project$UserSession$w3_unsafe_decode_UserSession)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$LoadSessions));
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_DmChannelId),
							$author$project$LocalState$w3_unsafe_decode_AdminData_SlackDmChannel)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$LoadSlackDmChannels));
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
							$author$project$LocalState$w3_unsafe_decode_AdminData_SlackWorkspace)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$LoadSlackWorkspaces));
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$ToBackendLog$w3_unsafe_decode_ToBackendLogData)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$LoadToBackendLogs));
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$author$project$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
							$author$project$User$w3_unsafe_decode_BackendUser)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$LoadUsers));
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$LocalState$w3_unsafe_decode_WebsocketClosedEvent)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$LoadWebsocketCloseEvents));
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$LocalState$w3_unsafe_decode_LogWithTime)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Pagination$w3_unsafe_decode_PageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$LogPageChanged)));
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Http$w3_unsafe_decode_Error, $lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$RegenerateServerSecret));
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$codecs$Lamdera$Wire3$decodeResult$(
							$author$project$Discord$w3_unsafe_decode_HttpError,
							$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Discord$w3_unsafe_decode_Role))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ReloadDiscordGuild))));
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$RestoreGuild));
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$SetDiscordLinkLimit));
			case 28:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$SetDiscordLinkingEnabled));
			case 29:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$SetEmailNotificationsEnabled));
			case 30:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$SetNotifyAdminsBotUserId));
			case 31:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$SetNotifyAdminsToken));
			case 32:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$SetOpenRouterKey));
			case 33:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Postmark$w3_unsafe_decode_ApiKey,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$SetPostmarkKey));
			case 34:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$LocalState$w3_unsafe_decode_PrivateVapidKey,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$SetPrivateVapidKey));
			case 35:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$SetPublicVapidKey));
			case 36:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$SetSignupsEnabled));
			case 37:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$SetSlackLinkLimit));
			case 38:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$SetSlackLinkingEnabled));
			case 39:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$StartReloadingDiscordDmChannel))));
			case 40:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$StartReloadingDiscordGuildChannel)))));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Drawing$w3_unsafe_decode_MessageAnchor = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Drawing$CardAnchor);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Drawing$EmbedImageAnchor));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Drawing$ImageAttachmentAnchor));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Drawing$TimestampAnchor);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Drawing$UserIconAnchor);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Drawing$w3_unsafe_decode_AnchorType = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$justinmimbs$date$Date$w3_unsafe_decode_Date,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_ThreadRoute,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Drawing$DateDividerAnchor)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Drawing$w3_unsafe_decode_MessageAnchor,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Drawing$MessageAnchor)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Types$w3_unsafe_decode_ChannelDataToDecrypt = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
		$author$project$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
			$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ThreadMessageId),
			$author$project$Encryption$w3_unsafe_decode_EncryptedData(
				$author$project$Message$w3_unsafe_decode_MessageContent$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId))))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
			$author$project$Encryption$w3_unsafe_decode_EncryptedData(
				$author$project$Message$w3_unsafe_decode_MessageContent$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId)))),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (channel0, threads0) {
					return {channel: channel0, threads: threads0};
				}))));
var $author$project$Types$w3_unsafe_decode_ChannelDataToEncrypt = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ThreadMessageId),
			$author$project$Message$w3_unsafe_decode_MessageContent$(
				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId)))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
			$author$project$Message$w3_unsafe_decode_MessageContent$(
				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId))),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (channel0, threads0) {
					return {channel: channel0, threads: threads0};
				}))));
var $author$project$ChannelDescription$w3_unsafe_decode_ChannelDescription = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Go$w3_unsafe_decode_Action = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$AcceptTerritory);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$FinishedMarking);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$Joined));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$MarkTerritory)));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$PassTurn);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$PlaceStone)));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$RejectTerritory);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Go$w3_unsafe_decode_ActionWithTime = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Go$w3_unsafe_decode_Action,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (change0, time0) {
					return {change: change0, time: time0};
				}))));
var $author$project$SheepGame$w3_unsafe_decode_Reactions = $lamdera$containers$SeqDict$decodeDict$(
	$author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
	$author$project$NonemptySet$w3_unsafe_decode_NonemptySet(
		$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId)));
var $author$project$SheepGame$w3_unsafe_decode_ValidatedInput = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
		$author$project$RichText$w3_unsafe_decode_RichText$(
			$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
			$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$SheepGame$w3_unsafe_decode_Reactions,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
				$author$project$FileStatus$w3_unsafe_decode_FileData),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (attachedFiles0, reactions0, text0) {
						return {attachedFiles: attachedFiles0, reactions: reactions0, text: text0};
					})))));
var $author$project$SheepGame$w3_unsafe_decode_Action = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$SheepGame$w3_unsafe_decode_ReactionTarget,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$AddedReaction)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$ChangedGroup))));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$SheepGame$w3_unsafe_decode_ValidatedInput),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$ChangedNotes)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$ChangedQuestionsRevealed));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$FinishedGrouping);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$LockedAnswers);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$SheepGame$w3_unsafe_decode_ReactionTarget,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$RemovedReaction)));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$SheepGame$w3_unsafe_decode_ValidatedInput),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$SubmittedAnswer)));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$UnlockedAnswers);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$SheepGame$w3_unsafe_decode_ActionWithTime = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$SheepGame$w3_unsafe_decode_Action,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (change0, time0, userId0) {
						return {change: change0, time: time0, userId: userId0};
					})))));
var $author$project$WordSpellingGame$w3_unsafe_decode_IsValid = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$IsNotValid);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeSet($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$IsValid));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$WordSpellingGame$w3_unsafe_decode_Letter = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeChar,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$WordSpellingGame$w3_unsafe_decode_Letter,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$Letter));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$Wildcard);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$WordSpellingGame$w3_unsafe_decode_PlacedWord = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty($author$project$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeBool,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (isVertical0, letters0, start0) {
						return {isVertical: isVertical0, letters: letters0, start: start0};
					})))));
var $author$project$WordSpellingGame$w3_unsafe_decode_Action = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$WordSpellingGame$w3_unsafe_decode_ReactionTarget,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$AddedReaction)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$CancelPremove);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$JoinGame);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend($author$project$WordSpellingGame$w3_unsafe_decode_IsValid),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$WordSpellingGame$w3_unsafe_decode_PlacedWord,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$PlaceWord)));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend($author$project$WordSpellingGame$w3_unsafe_decode_IsValid),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$WordSpellingGame$w3_unsafe_decode_PlacedWord,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$Premove)));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$WordSpellingGame$w3_unsafe_decode_ReactionTarget,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$RemovedReaction)));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$ReplaceTrayOrPass);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$WordSpellingGame$w3_unsafe_decode_ActionWithTime = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$WordSpellingGame$w3_unsafe_decode_Action,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (change0, time0, userId0) {
						return {change: change0, time: time0, userId: userId0};
					})))));
var $author$project$SheepGame$w3_unsafe_decode_Phase = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$SheepGame$w3_unsafe_decode_Shared = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$SheepGame$w3_unsafe_decode_Phase,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$SheepGame$w3_unsafe_decode_ValidatedInput)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId)),
					$lamdera$codecs$Lamdera$Wire3$decodeString),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
						$author$project$IdArray$w3_unsafe_decode_IdArray$(
							$author$project$Id$w3_unsafe_decode_QuestionId,
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$SheepGame$w3_unsafe_decode_ValidatedInput))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (answers0, groups0, notes0, phase0, questionsRevealed0) {
								return {answers: answers0, groups: groups0, notes: notes0, phase: phase0, questionsRevealed: questionsRevealed0};
							})))))));
var $author$project$WordSpellingGame$w3_unsafe_decode_AnimatedPlacement = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend($author$project$WordSpellingGame$w3_unsafe_decode_IsValid),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList(
				$lamdera$codecs$Lamdera$Wire3$decodePair$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
					$author$project$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard)),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (cells0, isValid0, startTime0) {
						return {cells: cells0, isValid: isValid0, startTime: startTime0};
					})))));
var $author$project$WordSpellingGame$LetterId = $elm$core$Basics$identity;
var $author$project$WordSpellingGame$w3_unsafe_decode_LetterId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$WordSpellingGame$w3_unsafe_decode_PlacementResult = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeList(
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F2(
						function (letters0, placedCount0) {
							return {letters: letters0, placedCount: placedCount0};
						}))))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList(
				$lamdera$codecs$Lamdera$Wire3$decodePair$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
					$author$project$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard)),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (placedCells0, score0, words0) {
						return {placedCells: placedCells0, score: score0, words: words0};
					})))));
var $author$project$WordSpellingGame$w3_unsafe_decode_Player = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$IdArray$w3_unsafe_decode_IdArray$($author$project$WordSpellingGame$w3_unsafe_decode_LetterId, $author$project$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
					$lamdera$codecs$Lamdera$Wire3$decodeTriple$($author$project$WordSpellingGame$w3_unsafe_decode_PlacedWord, $author$project$WordSpellingGame$w3_unsafe_decode_PlacementResult, $author$project$WordSpellingGame$w3_unsafe_decode_IsValid)),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (premove0, score0, tray0, userId0) {
							return {premove: premove0, score: score0, tray: tray0, userId: userId0};
						}))))));
var $author$project$WordSpellingGame$w3_unsafe_decode_Reactions = $lamdera$containers$SeqDict$decodeDict$(
	$author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
	$author$project$NonemptySet$w3_unsafe_decode_NonemptySet(
		$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId)));
var $author$project$WordSpellingGame$w3_unsafe_decode_Shared = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$($author$project$WordSpellingGame$w3_unsafe_decode_ReactionTarget, $author$project$WordSpellingGame$w3_unsafe_decode_Reactions),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty($author$project$WordSpellingGame$w3_unsafe_decode_Player),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$WordSpellingGame$w3_unsafe_decode_AnimatedPlacement),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
							$author$project$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$OneOrGreater$w3_unsafe_decode_OneOrGreater,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F7(
									function (attemptsLeft0, board0, lastPlacement0, passingStartedAt0, players0, reactions0, turnCount0) {
										return {attemptsLeft: attemptsLeft0, board: board0, lastPlacement: lastPlacement0, passingStartedAt: passingStartedAt0, players: players0, reactions: reactions0, turnCount: turnCount0};
									})))))))));
var $author$project$Go$w3_unsafe_decode_BoardSize = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Go$w3_unsafe_decode_KomiHalfPoints = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Go$w3_unsafe_decode_Stone = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Go$w3_unsafe_decode_TimeControl = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (increment0, mainTime0) {
					return {increment: increment0, mainTime: mainTime0};
				}))));
var $author$project$Go$w3_unsafe_decode_ValidatedSetup = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Go$w3_unsafe_decode_BoardSize,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Go$w3_unsafe_decode_TimeControl),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Go$w3_unsafe_decode_KomiHalfPoints,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Go$w3_unsafe_decode_BoardSize,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Go$w3_unsafe_decode_Stone,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F7(
									function (createdBy0, gameCreatorPlayingAs0, handicap0, height0, komiHalfPoints0, timeControl0, width0) {
										return {createdBy: createdBy0, gameCreatorPlayingAs: gameCreatorPlayingAs0, handicap: handicap0, height: height0, komiHalfPoints: komiHalfPoints0, timeControl: timeControl0, width: width0};
									})))))))));
var $author$project$SheepGame$w3_unsafe_decode_ValidatedSetup = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty($author$project$SheepGame$w3_unsafe_decode_ValidatedInput),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (createdBy0, questions0) {
					return {createdBy: createdBy0, questions: questions0};
				}))));
var $author$project$WordSpellingGame$w3_unsafe_decode_Language = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$WordSpellingGame$w3_unsafe_decode_ValidatedSetup = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$OneOrGreater$w3_unsafe_decode_OneOrGreater,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Go$w3_unsafe_decode_TimeControl,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$OneOrGreater$w3_unsafe_decode_OneOrGreater,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
						$author$project$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$OneOrGreater$w3_unsafe_decode_OneOrGreater,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F2(
										function (count0, value0) {
											return {count: count0, value: value0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$WordSpellingGame$w3_unsafe_decode_Language,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F8(
										function (createdBy0, fullTrayBonus0, language0, letters0, placeWordAttempts0, seed0, timeControls0, traySize0) {
											return {createdBy: createdBy0, fullTrayBonus: fullTrayBonus0, language: language0, letters: letters0, placeWordAttempts: placeWordAttempts0, seed: seed0, timeControls: timeControls0, traySize: traySize0};
										}))))))))));
var $author$project$Game$w3_unsafe_decode_BackendGameData = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Go$w3_unsafe_decode_ActionWithTime),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Go$w3_unsafe_decode_ValidatedSetup,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$GameData_Go)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$SheepGame$w3_unsafe_decode_Shared,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$SheepGame$w3_unsafe_decode_ActionWithTime),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$SheepGame$w3_unsafe_decode_ValidatedSetup,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$GameData_SheepGame))));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$WordSpellingGame$w3_unsafe_decode_Shared,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$WordSpellingGame$w3_unsafe_decode_ActionWithTime),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$WordSpellingGame$w3_unsafe_decode_ValidatedSetup,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$GameData_WordSpellingGame))));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Id$GoMatchPublicId = $elm$core$Basics$identity;
var $author$project$Id$w3_unsafe_decode_GamePublicId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$SecretId$w3_unsafe_decode_SecretId = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Game$w3_unsafe_decode_LoadedMatch = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
		$author$project$SecretId$w3_unsafe_decode_SecretId($author$project$Id$w3_unsafe_decode_GamePublicId)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Game$w3_unsafe_decode_BackendGameData,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (gameData0, publicLink0) {
					return {gameData: gameData0, publicLink: publicLink0};
				}))));
var $author$project$DmChannel$w3_unsafe_decode_LoadedMessages = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
		$author$project$Game$w3_unsafe_decode_LoadedMatch),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
			$author$project$Message$w3_unsafe_decode_Message$(
				$author$project$Id$w3_unsafe_decode_ChannelMessageId,
				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId))),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (messages0, repliedToMatches0) {
					return {messages: messages0, repliedToMatches: repliedToMatches0};
				}))));
var $author$project$Call$w3_unsafe_decode_RemoteCallData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeBool,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (audioInputEnabled0, screenShareEnabled0, videoInputEnabled0) {
						return {audioInputEnabled: audioInputEnabled0, screenShareEnabled: screenShareEnabled0, videoInputEnabled: videoInputEnabled0};
					})))));
var $author$project$Call$w3_unsafe_decode_LocalChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$Local_AnswerRecording));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$Local_CancelRecording);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$Local_Leave));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$Local_RequestRecording);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Call$w3_unsafe_decode_RemoteCallData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$Local_SetRemoteCallData));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Drawing$w3_unsafe_decode_LocalChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$SafeFloat$w3_unsafe_decode_SafeFloat, $author$project$SafeFloat$w3_unsafe_decode_SafeFloat)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Drawing$ContinueStroke));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$SafeFloat$w3_unsafe_decode_SafeFloat, $author$project$SafeFloat$w3_unsafe_decode_SafeFloat)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Drawing$EndStroke));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Drawing$RedoStroke);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$SafeFloat$w3_unsafe_decode_SafeFloat, $author$project$SafeFloat$w3_unsafe_decode_SafeFloat),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Drawing$StartStroke));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Drawing$UndoStroke);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Go$w3_unsafe_decode_LocalChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Go$w3_unsafe_decode_ActionWithTime,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$Action));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Go$w3_unsafe_decode_ValidatedSetup,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$StartMatch)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$SheepGame$w3_unsafe_decode_LocalChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$SheepGame$w3_unsafe_decode_ActionWithTime,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$Action));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$SheepGame$w3_unsafe_decode_ValidatedSetup,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$StartMatch)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$WordSpellingGame$w3_unsafe_decode_LocalChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$WordSpellingGame$w3_unsafe_decode_ActionWithTime,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$Action));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$WordSpellingGame$w3_unsafe_decode_ValidatedSetup,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$StartMatch)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Game$w3_unsafe_decode_LocalChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$author$project$SecretId$w3_unsafe_decode_SecretId($author$project$Id$w3_unsafe_decode_GamePublicId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$CreatePublicLink)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend($author$project$Game$w3_unsafe_decode_LoadedMatch),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$LoadMatch)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Go$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$LocalChange_Go)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$SheepGame$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$LocalChange_SheepGame)));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$WordSpellingGame$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$LocalChange_WordSpellingGame)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$TextEditor$w3_unsafe_decode_EditChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Range$w3_unsafe_decode_Range,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TextEditor$Edit_TypedText)));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$TextEditor$w3_unsafe_decode_LocalChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$TextEditor$w3_unsafe_decode_EditChange,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TextEditor$Local_EditChange));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TextEditor$Local_Redo);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TextEditor$Local_Reset);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TextEditor$Local_Undo);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$User$w3_unsafe_decode_NotificationLevel = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$VisibleMessages$w3_unsafe_decode_PageRequest = function (w3_x_c_messageId) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id(w3_x_c_messageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$VisibleMessages$PageBefore));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id(w3_x_c_messageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$VisibleMessages$PageFrom));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Ports$w3_unsafe_decode_RegisterPushSubscription = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Ports$w3_unsafe_decode_SubscribeData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Ports$GotSubscribeData));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Ports$SubscribeJsException));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$UserSession$w3_unsafe_decode_DiscordFrontendUser = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$PersonName$w3_unsafe_decode_PersonName,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$FileStatus$w3_unsafe_decode_FileHash),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$UserColor$w3_unsafe_decode_UserColor,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (color0, icon0, name0) {
						return {color: color0, icon: icon0, name: name0};
					})))));
var $author$project$UserSession$w3_unsafe_decode_UnreadOverviewData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$lamdera$codecs$Lamdera$Wire3$decodeTriple$(
			$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
			$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId),
			$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId)),
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ThreadMessageId),
			$author$project$Message$w3_unsafe_decode_Message$(
				$author$project$Id$w3_unsafe_decode_ThreadMessageId,
				$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
				$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId)))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$lamdera$codecs$Lamdera$Wire3$decodePair$(
				$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_DmChannelId),
				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId)),
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ThreadMessageId),
				$author$project$Message$w3_unsafe_decode_Message$(
					$author$project$Id$w3_unsafe_decode_ThreadMessageId,
					$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
					$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId)))),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_DmChannelId),
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
					$author$project$Message$w3_unsafe_decode_Message$(
						$author$project$Id$w3_unsafe_decode_ChannelMessageId,
						$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
						$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId)))),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
						$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId)),
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$author$project$Message$w3_unsafe_decode_Message$(
							$author$project$Id$w3_unsafe_decode_ChannelMessageId,
							$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
							$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId)))),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$lamdera$codecs$Lamdera$Wire3$decodeTriple$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId)),
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ThreadMessageId),
							$author$project$Message$w3_unsafe_decode_Message$(
								$author$project$Id$w3_unsafe_decode_ThreadMessageId,
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$lamdera$codecs$Lamdera$Wire3$decodePair$(
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId)),
							$lamdera$containers$SeqDict$decodeDict$(
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
								$author$project$Message$w3_unsafe_decode_Message$(
									$author$project$Id$w3_unsafe_decode_ChannelMessageId,
									$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
									$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId)))),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqDict$decodeDict$(
								$lamdera$codecs$Lamdera$Wire3$decodePair$(
									$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
									$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId)),
								$lamdera$containers$SeqDict$decodeDict$(
									$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ThreadMessageId),
									$author$project$Message$w3_unsafe_decode_Message$(
										$author$project$Id$w3_unsafe_decode_ThreadMessageId,
										$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
										$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId)))),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqDict$decodeDict$(
									$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
									$lamdera$containers$SeqDict$decodeDict$(
										$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
										$author$project$Message$w3_unsafe_decode_Message$(
											$author$project$Id$w3_unsafe_decode_ChannelMessageId,
											$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
											$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId)))),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$containers$SeqDict$decodeDict$(
										$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
										$author$project$UserSession$w3_unsafe_decode_DiscordFrontendUser),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$containers$SeqDict$decodeDict$(
											$lamdera$codecs$Lamdera$Wire3$decodeTriple$(
												$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
												$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
												$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId)),
											$lamdera$containers$SeqDict$decodeDict$(
												$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ThreadMessageId),
												$author$project$Message$w3_unsafe_decode_Message$(
													$author$project$Id$w3_unsafe_decode_ThreadMessageId,
													$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
													$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId)))),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$containers$SeqDict$decodeDict$(
												$lamdera$codecs$Lamdera$Wire3$decodePair$(
													$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
													$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId)),
												$lamdera$containers$SeqDict$decodeDict$(
													$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
													$author$project$Message$w3_unsafe_decode_Message$(
														$author$project$Id$w3_unsafe_decode_ChannelMessageId,
														$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
														$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId)))),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$containers$SeqDict$decodeDict$(
													$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
													$lamdera$containers$SeqDict$decodeDict$(
														$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
														$author$project$Message$w3_unsafe_decode_Message$(
															$author$project$Id$w3_unsafe_decode_ChannelMessageId,
															$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
															$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId)))),
												$lamdera$codecs$Lamdera$Wire3$succeedDecode(
													function (discordDmChannels0) {
														return function (discordGuildChannels0) {
															return function (discordGuildThreads0) {
																return function (discordUsers0) {
																	return function (dmChannels0) {
																		return function (dmThreads0) {
																			return function (guildChannels0) {
																				return function (guildThreads0) {
																					return function (slackChannels0) {
																						return function (slackDmChannels0) {
																							return function (slackDmThreads0) {
																								return function (slackThreads0) {
																									return {discordDmChannels: discordDmChannels0, discordGuildChannels: discordGuildChannels0, discordGuildThreads: discordGuildThreads0, discordUsers: discordUsers0, dmChannels: dmChannels0, dmThreads: dmThreads0, guildChannels: guildChannels0, guildThreads: guildThreads0, slackChannels: slackChannels0, slackDmChannels: slackDmChannels0, slackDmThreads: slackDmThreads0, slackThreads: slackThreads0};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													})))))))))))));
var $author$project$UserSession$w3_unsafe_decode_ViewDiscordGuildData = function (w3_x_c_messageId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
			$author$project$UserSession$w3_unsafe_decode_DiscordFrontendUser),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Id$w3_unsafe_decode_Id(w3_x_c_messageId),
				$author$project$Message$w3_unsafe_decode_Message$(
					w3_x_c_messageId,
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId))),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F2(
					function (messages0, newUsers0) {
						return {messages: messages0, newUsers: newUsers0};
					}))));
};
var $author$project$UserSession$w3_unsafe_decode_ChannelHeaderTab = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$UserSession$ChannelHeaderTab_ChannelDescription);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$UserSession$ChannelHeaderTab_Draw);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Message$w3_unsafe_decode_RepliedToGame),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$UserSession$ChannelHeaderTab_Games)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$UserSession$ChannelHeaderTab_VoiceChat);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$UserSession$DontCare = {$: 0};
var $author$project$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage = function (w3_x_c_messageId) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$UserSession$DontCare);
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id(w3_x_c_messageId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$UserSession$PreviouslyLastViewedMessage));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$UserSession$w3_unsafe_decode_Viewing_ChannelData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Id$w3_unsafe_decode_Viewing_ChannelId,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$UserSession$w3_unsafe_decode_ChannelHeaderTab),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (channelHeaderTab0, id0, previouslyLastViewedMessage0) {
						return {channelHeaderTab: channelHeaderTab0, id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0};
					})))));
var $author$project$Id$w3_unsafe_decode_Viewing_ChannelThreadId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (channelId0, guildId0, threadId0) {
						return {channelId: channelId0, guildId: guildId0, threadId: threadId0};
					})))));
var $author$project$UserSession$w3_unsafe_decode_Viewing_ChannelThreadData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Id$w3_unsafe_decode_ThreadMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Id$w3_unsafe_decode_Viewing_ChannelThreadId,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, previouslyLastViewedMessage0) {
					return {id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0};
				}))));
var $author$project$UserSession$w3_unsafe_decode_Viewing_DiscordChannelData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Id$w3_unsafe_decode_Viewing_DiscordChannelId,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, previouslyLastViewedMessage0) {
					return {id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0};
				}))));
var $author$project$Id$w3_unsafe_decode_Viewing_DiscordChannelThreadId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (channelId0, currentUserId0, guildId0, threadId0) {
							return {channelId: channelId0, currentUserId: currentUserId0, guildId: guildId0, threadId: threadId0};
						}))))));
var $author$project$UserSession$w3_unsafe_decode_Viewing_DiscordChannelThreadData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Id$w3_unsafe_decode_ThreadMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Id$w3_unsafe_decode_Viewing_DiscordChannelThreadId,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, previouslyLastViewedMessage0) {
					return {id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0};
				}))));
var $author$project$UserSession$w3_unsafe_decode_Viewing_DiscordDmData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Id$w3_unsafe_decode_Viewing_DiscordDmId,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, previouslyLastViewedMessage0) {
					return {id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0};
				}))));
var $author$project$UserSession$w3_unsafe_decode_Viewing_DmData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Id$w3_unsafe_decode_Viewing_DmId,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$UserSession$w3_unsafe_decode_ChannelHeaderTab),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (channelHeaderTab0, id0, previouslyLastViewedMessage0) {
						return {channelHeaderTab: channelHeaderTab0, id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0};
					})))));
var $author$project$Id$w3_unsafe_decode_Viewing_DmThreadId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (otherUserId0, threadId0) {
					return {otherUserId: otherUserId0, threadId: threadId0};
				}))));
var $author$project$UserSession$w3_unsafe_decode_Viewing_DmThreadData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Id$w3_unsafe_decode_ThreadMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Id$w3_unsafe_decode_Viewing_DmThreadId,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, previouslyLastViewedMessage0) {
					return {id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0};
				}))));
var $author$project$UserSession$w3_unsafe_decode_Viewing_SlackChannelData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Id$w3_unsafe_decode_Viewing_SlackChannelId,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, previouslyLastViewedMessage0) {
					return {id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0};
				}))));
var $author$project$UserSession$w3_unsafe_decode_Viewing_SlackChannelThreadData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Id$w3_unsafe_decode_ThreadMessageId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Id$w3_unsafe_decode_Viewing_SlackChannelId,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (id0, previouslyLastViewedMessage0, threadId0) {
						return {id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0, threadId: threadId0};
					})))));
var $author$project$UserSession$w3_unsafe_decode_Viewing_SlackDmData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Id$w3_unsafe_decode_Viewing_SlackDmId,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (id0, previouslyLastViewedMessage0) {
					return {id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0};
				}))));
var $author$project$UserSession$w3_unsafe_decode_Viewing_SlackDmThreadData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$UserSession$w3_unsafe_decode_PreviouslyLastViewedMessage($author$project$Id$w3_unsafe_decode_ThreadMessageId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Id$w3_unsafe_decode_Viewing_SlackDmId,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (id0, previouslyLastViewedMessage0, threadId0) {
						return {id: id0, previouslyLastViewedMessage: previouslyLastViewedMessage0, threadId: threadId0};
					})))));
var $author$project$SetViewing$w3_unsafe_decode_SetViewing = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SetViewing$StopViewingChannel);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend($author$project$DmChannel$w3_unsafe_decode_LoadedMessages),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$UserSession$w3_unsafe_decode_Viewing_ChannelData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SetViewing$ViewChannel)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ThreadMessageId),
							$author$project$Message$w3_unsafe_decode_Message$(
								$author$project$Id$w3_unsafe_decode_ThreadMessageId,
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$UserSession$w3_unsafe_decode_Viewing_ChannelThreadData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SetViewing$ViewChannelThread)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$author$project$UserSession$w3_unsafe_decode_ViewDiscordGuildData($author$project$Id$w3_unsafe_decode_ChannelMessageId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$UserSession$w3_unsafe_decode_Viewing_DiscordChannelData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SetViewing$ViewDiscordChannel)));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$author$project$UserSession$w3_unsafe_decode_ViewDiscordGuildData($author$project$Id$w3_unsafe_decode_ThreadMessageId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$UserSession$w3_unsafe_decode_Viewing_DiscordChannelThreadData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SetViewing$ViewDiscordChannelThread)));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
							$author$project$Message$w3_unsafe_decode_Message$(
								$author$project$Id$w3_unsafe_decode_ChannelMessageId,
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$UserSession$w3_unsafe_decode_Viewing_DiscordDmData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SetViewing$ViewDiscordDm)));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend($author$project$DmChannel$w3_unsafe_decode_LoadedMessages),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$UserSession$w3_unsafe_decode_Viewing_DmData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SetViewing$ViewDm)));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ThreadMessageId),
							$author$project$Message$w3_unsafe_decode_Message$(
								$author$project$Id$w3_unsafe_decode_ThreadMessageId,
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$UserSession$w3_unsafe_decode_Viewing_DmThreadData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SetViewing$ViewDmThread)));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend($author$project$UserSession$w3_unsafe_decode_UnreadOverviewData),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SetViewing$ViewOverview));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
							$author$project$Message$w3_unsafe_decode_Message$(
								$author$project$Id$w3_unsafe_decode_ChannelMessageId,
								$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
								$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$UserSession$w3_unsafe_decode_Viewing_SlackChannelData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SetViewing$ViewSlackChannel)));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ThreadMessageId),
							$author$project$Message$w3_unsafe_decode_Message$(
								$author$project$Id$w3_unsafe_decode_ThreadMessageId,
								$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
								$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$UserSession$w3_unsafe_decode_Viewing_SlackChannelThreadData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SetViewing$ViewSlackChannelThread)));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
							$author$project$Message$w3_unsafe_decode_Message$(
								$author$project$Id$w3_unsafe_decode_ChannelMessageId,
								$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
								$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$UserSession$w3_unsafe_decode_Viewing_SlackDmData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SetViewing$ViewSlackDm)));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ThreadMessageId),
							$author$project$Message$w3_unsafe_decode_Message$(
								$author$project$Id$w3_unsafe_decode_ThreadMessageId,
								$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
								$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$UserSession$w3_unsafe_decode_Viewing_SlackDmThreadData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SetViewing$ViewSlackDmThread)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Types$w3_unsafe_decode_LocalChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$($author$project$Id$w3_unsafe_decode_Viewing_DmId, $author$project$Types$w3_unsafe_decode_ChannelDataToEncrypt)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Viewing_DmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_AcceptE2ee))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$NonemptySet$w3_unsafe_decode_NonemptySet(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_CustomEmojiId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_AddCustomEmojisToUser));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_AddReactionEmoji))));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Pages$Admin$w3_unsafe_decode_AdminChange,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_Admin));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_BanMember)));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_CancelAccountDeletion);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_UserOptionSection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_CollapseUserOptionSection));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$SetViewing$w3_unsafe_decode_SetViewing,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeBool,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								function (markMessagesAsViewed0) {
									return {markMessagesAsViewed: markMessagesAsViewed0};
								})),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_CurrentlyViewing)));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Viewing_DmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_DeclineE2eeRequest));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Viewing_DmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_DeclineE2eeRequestAsInitiator));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList(
						$lamdera$codecs$Lamdera$Wire3$decodePair$(
							$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
							$author$project$Message$w3_unsafe_decode_MessageContent$(
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Viewing_DmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_DecryptOldMessages))));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_DeleteChannel)));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_DeleteGuild));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$SecretId$w3_unsafe_decode_SecretId($author$project$Id$w3_unsafe_decode_InviteLinkId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_DeleteInviteLink)));
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_DeleteMessage)));
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend($author$project$Types$w3_unsafe_decode_ChannelDataToDecrypt),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Viewing_DmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_DisableE2ee)));
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
							$author$project$Message$w3_unsafe_decode_Message$(
								$author$project$Id$w3_unsafe_decode_ChannelMessageId,
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$VisibleMessages$w3_unsafe_decode_PageRequest($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_DiscordGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_Discord_LoadChannelMessages))));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ThreadMessageId),
							$author$project$Message$w3_unsafe_decode_Message$(
								$author$project$Id$w3_unsafe_decode_ThreadMessageId,
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$VisibleMessages$w3_unsafe_decode_PageRequest($author$project$Id$w3_unsafe_decode_ThreadMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_DiscordGuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_Discord_LoadThreadMessages)))));
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Viewing_DiscordDmId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Zone,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_Discord_SendEditDmMessage))))));
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Zone,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
											$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_Discord_SendEditGuildMessage))))))));
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
						$author$project$FileStatus$w3_unsafe_decode_FileData),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_ThreadRouteWithMaybeMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_DiscordGuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Zone,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_Discord_SendMessage)))))));
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Drawing$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Drawing$w3_unsafe_decode_AnchorType,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_Drawing))));
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$ChannelDescription$w3_unsafe_decode_ChannelDescription,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$ChannelName$w3_unsafe_decode_ChannelName,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_EditChannel)))));
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$GuildName$w3_unsafe_decode_GuildName,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_EditGuildName)));
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList(
						$lamdera$codecs$Lamdera$Wire3$decodeTriple$(
							$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
							$lamdera$containers$SeqSet$decodeSet($author$project$FileStatus$w3_unsafe_decode_FileHash),
							$author$project$Encryption$w3_unsafe_decode_EncryptedData(
								$author$project$Message$w3_unsafe_decode_MessageContent$(
									$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
									$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId))))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Viewing_DmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_EncryptOldMessages)));
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							function (collapseOthers0) {
								return {collapseOthers: collapseOthers0};
							})),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$UserSession$w3_unsafe_decode_UserOptionSection,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_ExpandUserOptionSection)));
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Game$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_GuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_Game)));
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_Invalid);
			case 28:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_LeaveGuild));
			case 29:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_LinkDiscordAcknowledgementIsChecked));
			case 30:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_LinkSlackAcknowledgementIsChecked));
			case 31:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend($author$project$DmChannel$w3_unsafe_decode_LoadedMessages),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$VisibleMessages$w3_unsafe_decode_PageRequest($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_GuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_LoadChannelMessages))));
			case 32:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ThreadMessageId),
							$author$project$Message$w3_unsafe_decode_Message$(
								$author$project$Id$w3_unsafe_decode_ThreadMessageId,
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$VisibleMessages$w3_unsafe_decode_PageRequest($author$project$Id$w3_unsafe_decode_ThreadMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_GuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_LoadThreadMessages)))));
			case 33:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_MemberEditTyping))));
			case 34:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Id$w3_unsafe_decode_ThreadRoute),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_MemberTyping)));
			case 35:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$ChannelDescription$w3_unsafe_decode_ChannelDescription,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$ChannelName$w3_unsafe_decode_ChannelName,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_NewChannel)))));
			case 36:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$GuildName$w3_unsafe_decode_GuildName,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_NewGuild))));
			case 37:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$author$project$SecretId$w3_unsafe_decode_SecretId($author$project$Id$w3_unsafe_decode_InviteLinkId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_NewInviteLink))));
			case 38:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Ports$w3_unsafe_decode_RegisterPushSubscription,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_RegisterPushSubscription)));
			case 39:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_RemoveReactionEmoji))));
			case 40:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Viewing_DmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_RequestE2ee));
			case 41:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_ScheduleAccountDeletion));
			case 42:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
						$author$project$FileStatus$w3_unsafe_decode_FileData),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_GuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Zone,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_SendEditMessage)))))));
			case 43:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Encryption$w3_unsafe_decode_EncryptedData(
						$author$project$Message$w3_unsafe_decode_MessageContent$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqSet$decodeSet($author$project$FileStatus$w3_unsafe_decode_FileHash),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_Viewing_DmId,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_SendEncryptedEditMessage))))));
			case 44:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Message$w3_unsafe_decode_ThreadRouteWithRepliedTo,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Encryption$w3_unsafe_decode_EncryptedData($lamdera$codecs$Lamdera$Wire3$decodeString),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Encryption$w3_unsafe_decode_EncryptedData(
								$author$project$Message$w3_unsafe_decode_MessageContent$(
									$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
									$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId))),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqSet$decodeSet($author$project$FileStatus$w3_unsafe_decode_FileHash),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Id$w3_unsafe_decode_Viewing_DmId,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_SendEncryptedMessage)))))));
			case 45:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
							$author$project$FileStatus$w3_unsafe_decode_FileData),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Message$w3_unsafe_decode_ThreadRouteWithRepliedTo,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Id$w3_unsafe_decode_GuildOrDmId,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Zone,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
											$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_SendMessage))))))));
			case 46:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$User$w3_unsafe_decode_NotificationLevel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_SetDiscordGuildNotificationLevel))));
			case 47:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$RichText$w3_unsafe_decode_Domain,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_SetDomainWhitelist)));
			case 48:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_SetE2eeRisksAccepted));
			case 49:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$User$w3_unsafe_decode_EmailNotifications,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_SetEmailNotifications));
			case 50:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$User$w3_unsafe_decode_EmbedVisibility,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_SetEmbedVisibility));
			case 51:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Emoji$w3_unsafe_decode_SkinTone),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_SetEmojiSkinTone));
			case 52:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$User$w3_unsafe_decode_NotificationLevel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_SetGuildNotificationLevel)));
			case 53:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_SetLastViewed)));
			case 54:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_SetMuteChannel))));
			case 55:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_SetMuteDiscordChannel)))));
			case 56:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_SetMuteDiscordGuild))));
			case 57:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_SetMuteDiscordThread))))));
			case 58:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_SetMuteGuild)));
			case 59:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_SetMuteSlackChannel)))));
			case 60:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_SetMuteSlackThread))))));
			case 61:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_SetMuteSlackWorkspace))));
			case 62:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_SetMuteThread)))));
			case 63:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$PersonName$w3_unsafe_decode_PersonName,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_SetName));
			case 64:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_NotificationMode,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_SetNotificationMode));
			case 65:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$($author$project$Id$w3_unsafe_decode_Viewing_DmId, $author$project$Types$w3_unsafe_decode_ChannelDataToEncrypt)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$X25519$w3_unsafe_decode_PublicKey,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_SetPublicKey)));
			case 66:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$IdArray$w3_unsafe_decode_IdArray$($author$project$Id$w3_unsafe_decode_QuestionId, $author$project$UserSession$w3_unsafe_decode_SheepGameQuestion),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_SetSheepGameQuestions));
			case 67:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$User$w3_unsafe_decode_NotificationLevel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_SetSlackWorkspaceNotificationLevel))));
			case 68:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserColor$w3_unsafe_decode_UserColor,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_SetUserColor));
			case 69:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
							$author$project$Message$w3_unsafe_decode_Message$(
								$author$project$Id$w3_unsafe_decode_ChannelMessageId,
								$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
								$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$VisibleMessages$w3_unsafe_decode_PageRequest($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_SlackGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_Slack_LoadChannelMessages))));
			case 70:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ToBeFilledInByBackend(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ThreadMessageId),
							$author$project$Message$w3_unsafe_decode_Message$(
								$author$project$Id$w3_unsafe_decode_ThreadMessageId,
								$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
								$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$VisibleMessages$w3_unsafe_decode_PageRequest($author$project$Id$w3_unsafe_decode_ThreadMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_SlackGuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_Slack_LoadThreadMessages)))));
			case 71:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_Slack_ReloadUser));
			case 72:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_SlackGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Zone,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_Slack_SendEditMessage))))));
			case 73:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
						$author$project$FileStatus$w3_unsafe_decode_FileData),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_ThreadRoute,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_SlackGuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Zone,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_Slack_SendMessage)))))));
			case 74:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_Slack_UnlinkUser));
			case 75:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_StartReloadingDiscordUser)));
			case 76:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$TextEditor$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_TextEditor));
			case 77:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_UnlinkDiscordUser));
			case 78:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Call$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Local_VoiceChatChange));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Types$Server_AddReactionEmoji$ = function (a, b, c, d) {
	return {$: 30, a: a, b: b, c: c, d: d};
};
var $author$project$Types$Server_AddReactionEmoji = F4($author$project$Types$Server_AddReactionEmoji$);
var $author$project$Types$Server_BackupGenerated = function (a) {
	return {$: 73, a: a};
};
var $author$project$Types$Server_CallRecordingStarted$ = function (a, b, c, d) {
	return {$: 31, a: a, b: b, c: c, d: d};
};
var $author$project$Types$Server_CallRecordingStarted = F4($author$project$Types$Server_CallRecordingStarted$);
var $author$project$Types$Server_CallRecordingUploadFinished$ = function (a, b, c) {
	return {$: 33, a: a, b: b, c: c};
};
var $author$project$Types$Server_CallRecordingUploadFinished = F3($author$project$Types$Server_CallRecordingUploadFinished$);
var $author$project$Types$Server_CallRecordingUploadProgress$ = function (a, b, c) {
	return {$: 32, a: a, b: b, c: c};
};
var $author$project$Types$Server_CallRecordingUploadProgress = F3($author$project$Types$Server_CallRecordingUploadProgress$);
var $author$project$Types$Server_CallRecordingZipBuilt$ = function (a, b, c) {
	return {$: 34, a: a, b: b, c: c};
};
var $author$project$Types$Server_CallRecordingZipBuilt = F3($author$project$Types$Server_CallRecordingZipBuilt$);
var $author$project$Types$Server_ClientDisconnected$ = function (a, b, c) {
	return {$: 60, a: a, b: b, c: c};
};
var $author$project$Types$Server_ClientDisconnected = F3($author$project$Types$Server_ClientDisconnected$);
var $author$project$Types$Server_CurrentlyViewing$ = function (a, b, c) {
	return {$: 59, a: a, b: b, c: c};
};
var $author$project$Types$Server_CurrentlyViewing = F3($author$project$Types$Server_CurrentlyViewing$);
var $author$project$Types$Server_DeleteChannel$ = function (a, b) {
	return {$: 19, a: a, b: b};
};
var $author$project$Types$Server_DeleteChannel = F2($author$project$Types$Server_DeleteChannel$);
var $author$project$Types$Server_DeleteGuild = function (a) {
	return {$: 21, a: a};
};
var $author$project$Types$Server_DeleteInviteLink$ = function (a, b) {
	return {$: 23, a: a, b: b};
};
var $author$project$Types$Server_DeleteInviteLink = F2($author$project$Types$Server_DeleteInviteLink$);
var $author$project$Types$Server_DeleteMessage$ = function (a, b) {
	return {$: 44, a: a, b: b};
};
var $author$project$Types$Server_DeleteMessage = F2($author$project$Types$Server_DeleteMessage$);
var $author$project$Types$Server_DisableE2ee$ = function (a, b, c) {
	return {$: 109, a: a, b: b, c: c};
};
var $author$project$Types$Server_DisableE2ee = F3($author$project$Types$Server_DisableE2ee$);
var $author$project$Types$Server_DiscordAddReactionDmEmoji$ = function (a, b, c, d) {
	return {$: 37, a: a, b: b, c: c, d: d};
};
var $author$project$Types$Server_DiscordAddReactionDmEmoji = F4($author$project$Types$Server_DiscordAddReactionDmEmoji$);
var $author$project$Types$Server_DiscordAddReactionGuildEmoji$ = function (a, b, c, d, e) {
	return {$: 36, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Types$Server_DiscordAddReactionGuildEmoji = F5($author$project$Types$Server_DiscordAddReactionGuildEmoji$);
var $author$project$Types$Server_DiscordAvatarsLoaded$ = function (a, b) {
	return {$: 101, a: a, b: b};
};
var $author$project$Types$Server_DiscordAvatarsLoaded = F2($author$project$Types$Server_DiscordAvatarsLoaded$);
var $author$project$Types$Server_DiscordChannelCreated$ = function (a, b, c, d, e, f) {
	return {$: 64, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Types$Server_DiscordChannelCreated = F6($author$project$Types$Server_DiscordChannelCreated$);
var $author$project$Types$Server_DiscordChannelDeleted$ = function (a, b) {
	return {$: 81, a: a, b: b};
};
var $author$project$Types$Server_DiscordChannelDeleted = F2($author$project$Types$Server_DiscordChannelDeleted$);
var $author$project$Types$Server_DiscordDeleteDmMessage$ = function (a, b) {
	return {$: 47, a: a, b: b};
};
var $author$project$Types$Server_DiscordDeleteDmMessage = F2($author$project$Types$Server_DiscordDeleteDmMessage$);
var $author$project$Types$Server_DiscordDeleteGuildMessage$ = function (a, b, c) {
	return {$: 45, a: a, b: b, c: c};
};
var $author$project$Types$Server_DiscordDeleteGuildMessage = F3($author$project$Types$Server_DiscordDeleteGuildMessage$);
var $author$project$Types$Server_DiscordDmChannelCreated$ = function (a, b) {
	return {$: 65, a: a, b: b};
};
var $author$project$Types$Server_DiscordDmChannelCreated = F2($author$project$Types$Server_DiscordDmChannelCreated$);
var $author$project$Types$Server_DiscordDmChannelRecipientRemoved$ = function (a, b) {
	return {$: 66, a: a, b: b};
};
var $author$project$Types$Server_DiscordDmChannelRecipientRemoved = F2($author$project$Types$Server_DiscordDmChannelRecipientRemoved$);
var $author$project$Types$Server_DiscordDmMemberTyping$ = function (a, b, c) {
	return {$: 29, a: a, b: b, c: c};
};
var $author$project$Types$Server_DiscordDmMemberTyping = F3($author$project$Types$Server_DiscordDmMemberTyping$);
var $author$project$Types$Server_DiscordForumPostDeleted$ = function (a, b, c) {
	return {$: 46, a: a, b: b, c: c};
};
var $author$project$Types$Server_DiscordForumPostDeleted = F3($author$project$Types$Server_DiscordForumPostDeleted$);
var $author$project$Types$Server_DiscordGuildJoinedOrCreated$ = function (a, b, c) {
	return {$: 78, a: a, b: b, c: c};
};
var $author$project$Types$Server_DiscordGuildJoinedOrCreated = F3($author$project$Types$Server_DiscordGuildJoinedOrCreated$);
var $author$project$Types$Server_DiscordGuildLeftOrDeleted$ = function (a, b) {
	return {$: 79, a: a, b: b};
};
var $author$project$Types$Server_DiscordGuildLeftOrDeleted = F2($author$project$Types$Server_DiscordGuildLeftOrDeleted$);
var $author$project$Types$Server_DiscordGuildMemberJoined$ = function (a, b, c, d, e, f) {
	return {$: 86, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Types$Server_DiscordGuildMemberJoined = F6($author$project$Types$Server_DiscordGuildMemberJoined$);
var $author$project$Types$Server_DiscordGuildMemberTyping$ = function (a, b, c, d, e) {
	return {$: 28, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Types$Server_DiscordGuildMemberTyping = F5($author$project$Types$Server_DiscordGuildMemberTyping$);
var $author$project$Types$Server_DiscordNeedsAuthAgain = function (a) {
	return {$: 67, a: a};
};
var $author$project$Types$Server_DiscordRemoveReactionDmEmoji$ = function (a, b, c, d) {
	return {$: 39, a: a, b: b, c: c, d: d};
};
var $author$project$Types$Server_DiscordRemoveReactionDmEmoji = F4($author$project$Types$Server_DiscordRemoveReactionDmEmoji$);
var $author$project$Types$Server_DiscordRemoveReactionGuildEmoji$ = function (a, b, c, d, e) {
	return {$: 38, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Types$Server_DiscordRemoveReactionGuildEmoji = F5($author$project$Types$Server_DiscordRemoveReactionGuildEmoji$);
var $author$project$Types$Server_DiscordSendEditDmMessage$ = function (a, b, c, d) {
	return {$: 42, a: a, b: b, c: c, d: d};
};
var $author$project$Types$Server_DiscordSendEditDmMessage = F4($author$project$Types$Server_DiscordSendEditDmMessage$);
var $author$project$Types$Server_DiscordSendEditGuildMessage$ = function (a, b, c, d, e, f) {
	return {$: 41, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Types$Server_DiscordSendEditGuildMessage = F6($author$project$Types$Server_DiscordSendEditGuildMessage$);
var $author$project$Types$Server_DiscordUpdateChannel$ = function (a, b, c, d, e) {
	return {$: 80, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Types$Server_DiscordUpdateChannel = F5($author$project$Types$Server_DiscordUpdateChannel$);
var $author$project$Types$Server_DiscordUpdateGuild$ = function (a, b, c, d) {
	return {$: 82, a: a, b: b, c: c, d: d};
};
var $author$project$Types$Server_DiscordUpdateGuild = F4($author$project$Types$Server_DiscordUpdateGuild$);
var $author$project$Types$Server_DiscordUpdateGuildCustomEmojis$ = function (a, b) {
	return {$: 84, a: a, b: b};
};
var $author$project$Types$Server_DiscordUpdateGuildCustomEmojis = F2($author$project$Types$Server_DiscordUpdateGuildCustomEmojis$);
var $author$project$Types$Server_DiscordUpdateRole$ = function (a, b, c) {
	return {$: 83, a: a, b: b, c: c};
};
var $author$project$Types$Server_DiscordUpdateRole = F3($author$project$Types$Server_DiscordUpdateRole$);
var $author$project$Types$Server_DiscordUserLoadingDataIsDone$ = function (a, b) {
	return {$: 68, a: a, b: b};
};
var $author$project$Types$Server_DiscordUserLoadingDataIsDone = F2($author$project$Types$Server_DiscordUserLoadingDataIsDone$);
var $author$project$Types$Server_Discord_SendMessage$ = function (a, b, c, d, e, f, g) {
	return {$: 15, a: a, b: b, c: c, d: d, e: e, f: f, g: g};
};
var $author$project$Types$Server_Discord_SendMessage = F7($author$project$Types$Server_Discord_SendMessage$);
var $author$project$Types$Server_Drawing$ = function (a, b, c, d) {
	return {$: 91, a: a, b: b, c: c, d: d};
};
var $author$project$Types$Server_Drawing = F4($author$project$Types$Server_Drawing$);
var $author$project$Types$Server_E2eeAccepted$ = function (a, b) {
	return {$: 105, a: a, b: b};
};
var $author$project$Types$Server_E2eeAccepted = F2($author$project$Types$Server_E2eeAccepted$);
var $author$project$Types$Server_E2eeRequestCancelled = function (a) {
	return {$: 103, a: a};
};
var $author$project$Types$Server_E2eeRequestDeclined$ = function (a, b) {
	return {$: 104, a: a, b: b};
};
var $author$project$Types$Server_E2eeRequestDeclined = F2($author$project$Types$Server_E2eeRequestDeclined$);
var $author$project$Types$Server_E2eeRequested$ = function (a, b) {
	return {$: 102, a: a, b: b};
};
var $author$project$Types$Server_E2eeRequested = F2($author$project$Types$Server_E2eeRequested$);
var $author$project$Types$Server_EditChannel$ = function (a, b, c, d) {
	return {$: 18, a: a, b: b, c: c, d: d};
};
var $author$project$Types$Server_EditChannel = F4($author$project$Types$Server_EditChannel$);
var $author$project$Types$Server_EditGuildName$ = function (a, b) {
	return {$: 20, a: a, b: b};
};
var $author$project$Types$Server_EditGuildName = F2($author$project$Types$Server_EditGuildName$);
var $author$project$Types$Server_Game$ = function (a, b, c) {
	return {$: 90, a: a, b: b, c: c};
};
var $author$project$Types$Server_Game = F3($author$project$Types$Server_Game$);
var $author$project$Types$Server_GotDiscordDmMessageEmbed$ = function (a, b, c) {
	return {$: 77, a: a, b: b, c: c};
};
var $author$project$Types$Server_GotDiscordDmMessageEmbed = F3($author$project$Types$Server_GotDiscordDmMessageEmbed$);
var $author$project$Types$Server_GotDiscordGuildMessageEmbed$ = function (a, b, c, d) {
	return {$: 76, a: a, b: b, c: c, d: d};
};
var $author$project$Types$Server_GotDiscordGuildMessageEmbed = F4($author$project$Types$Server_GotDiscordGuildMessageEmbed$);
var $author$project$Types$Server_GotDmMessageEmbed$ = function (a, b, c) {
	return {$: 75, a: a, b: b, c: c};
};
var $author$project$Types$Server_GotDmMessageEmbed = F3($author$project$Types$Server_GotDmMessageEmbed$);
var $author$project$Types$Server_GotGuildMessageEmbed$ = function (a, b, c, d) {
	return {$: 74, a: a, b: b, c: c, d: d};
};
var $author$project$Types$Server_GotGuildMessageEmbed = F4($author$project$Types$Server_GotGuildMessageEmbed$);
var $author$project$Types$Server_ImportedChannel$ = function (a, b, c) {
	return {$: 17, a: a, b: b, c: c};
};
var $author$project$Types$Server_ImportedChannel = F3($author$project$Types$Server_ImportedChannel$);
var $author$project$Types$Server_LinkDiscordUser$ = function (a, b) {
	return {$: 62, a: a, b: b};
};
var $author$project$Types$Server_LinkDiscordUser = F2($author$project$Types$Server_LinkDiscordUser$);
var $author$project$Types$Server_LinkedDiscordUserCustomEmojisLoaded = function (a) {
	return {$: 88, a: a};
};
var $author$project$Types$Server_LinkedDiscordUserStickersLoaded = function (a) {
	return {$: 87, a: a};
};
var $author$project$Types$Server_LoadAdminData = function (a) {
	return {$: 71, a: a};
};
var $author$project$Types$Server_LoadingDiscordChannelChanged$ = function (a, b) {
	return {$: 70, a: a, b: b};
};
var $author$project$Types$Server_LoadingDiscordChannelChanged = F2($author$project$Types$Server_LoadingDiscordChannelChanged$);
var $author$project$Types$Server_LoggedOut = function (a) {
	return {$: 58, a: a};
};
var $author$project$Types$Server_MemberEditTyping$ = function (a, b, c, d) {
	return {$: 43, a: a, b: b, c: c, d: d};
};
var $author$project$Types$Server_MemberEditTyping = F4($author$project$Types$Server_MemberEditTyping$);
var $author$project$Types$Server_MemberJoined$ = function (a, b, c, d) {
	return {$: 24, a: a, b: b, c: c, d: d};
};
var $author$project$Types$Server_MemberJoined = F4($author$project$Types$Server_MemberJoined$);
var $author$project$Types$Server_MemberLeft$ = function (a, b) {
	return {$: 25, a: a, b: b};
};
var $author$project$Types$Server_MemberLeft = F2($author$project$Types$Server_MemberLeft$);
var $author$project$Types$Server_MemberTyping$ = function (a, b, c, d) {
	return {$: 27, a: a, b: b, c: c, d: d};
};
var $author$project$Types$Server_MemberTyping = F4($author$project$Types$Server_MemberTyping$);
var $author$project$Types$Server_NewChannel$ = function (a, b, c, d) {
	return {$: 16, a: a, b: b, c: c, d: d};
};
var $author$project$Types$Server_NewChannel = F4($author$project$Types$Server_NewChannel$);
var $author$project$Types$Server_NewInviteLink$ = function (a, b, c, d) {
	return {$: 22, a: a, b: b, c: c, d: d};
};
var $author$project$Types$Server_NewInviteLink = F4($author$project$Types$Server_NewInviteLink$);
var $author$project$Types$Server_NewLog$ = function (a, b) {
	return {$: 72, a: a, b: b};
};
var $author$project$Types$Server_NewLog = F2($author$project$Types$Server_NewLog$);
var $author$project$Types$Server_NewSession$ = function (a, b) {
	return {$: 57, a: a, b: b};
};
var $author$project$Types$Server_NewSession = F2($author$project$Types$Server_NewSession$);
var $author$project$Types$Server_PushNotificationFailed$ = function (a, b) {
	return {$: 56, a: a, b: b};
};
var $author$project$Types$Server_PushNotificationFailed = F2($author$project$Types$Server_PushNotificationFailed$);
var $author$project$Types$Server_PushNotificationsReset = function (a) {
	return {$: 52, a: a};
};
var $author$project$Types$Server_RemoveReactionEmoji$ = function (a, b, c, d) {
	return {$: 35, a: a, b: b, c: c, d: d};
};
var $author$project$Types$Server_RemoveReactionEmoji = F4($author$project$Types$Server_RemoveReactionEmoji$);
var $author$project$Types$Server_SendEditMessage$ = function (a, b, c, d, e, f) {
	return {$: 40, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Types$Server_SendEditMessage = F6($author$project$Types$Server_SendEditMessage$);
var $author$project$Types$Server_SendEncryptedEditMessage$ = function (a, b, c, d, e, f) {
	return {$: 108, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Types$Server_SendEncryptedEditMessage = F6($author$project$Types$Server_SendEncryptedEditMessage$);
var $author$project$Types$Server_SendEncryptedMessage = function (a) {
	return {$: 107, a: a};
};
var $author$project$Types$Server_SendMessage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$Server_SetDiscordGuildNotificationLevel$ = function (a, b) {
	return {$: 54, a: a, b: b};
};
var $author$project$Types$Server_SetDiscordGuildNotificationLevel = F2($author$project$Types$Server_SetDiscordGuildNotificationLevel$);
var $author$project$Types$Server_SetGuildIcon$ = function (a, b) {
	return {$: 51, a: a, b: b};
};
var $author$project$Types$Server_SetGuildIcon = F2($author$project$Types$Server_SetGuildIcon$);
var $author$project$Types$Server_SetGuildNotificationLevel$ = function (a, b) {
	return {$: 53, a: a, b: b};
};
var $author$project$Types$Server_SetGuildNotificationLevel = F2($author$project$Types$Server_SetGuildNotificationLevel$);
var $author$project$Types$Server_SetMuteChannel$ = function (a, b, c) {
	return {$: 92, a: a, b: b, c: c};
};
var $author$project$Types$Server_SetMuteChannel = F3($author$project$Types$Server_SetMuteChannel$);
var $author$project$Types$Server_SetMuteDiscordChannel$ = function (a, b, c) {
	return {$: 94, a: a, b: b, c: c};
};
var $author$project$Types$Server_SetMuteDiscordChannel = F3($author$project$Types$Server_SetMuteDiscordChannel$);
var $author$project$Types$Server_SetMuteDiscordGuild$ = function (a, b) {
	return {$: 97, a: a, b: b};
};
var $author$project$Types$Server_SetMuteDiscordGuild = F2($author$project$Types$Server_SetMuteDiscordGuild$);
var $author$project$Types$Server_SetMuteDiscordThread$ = function (a, b, c, d) {
	return {$: 95, a: a, b: b, c: c, d: d};
};
var $author$project$Types$Server_SetMuteDiscordThread = F4($author$project$Types$Server_SetMuteDiscordThread$);
var $author$project$Types$Server_SetMuteGuild$ = function (a, b) {
	return {$: 96, a: a, b: b};
};
var $author$project$Types$Server_SetMuteGuild = F2($author$project$Types$Server_SetMuteGuild$);
var $author$project$Types$Server_SetMuteSlackChannel$ = function (a, b, c) {
	return {$: 99, a: a, b: b, c: c};
};
var $author$project$Types$Server_SetMuteSlackChannel = F3($author$project$Types$Server_SetMuteSlackChannel$);
var $author$project$Types$Server_SetMuteSlackThread$ = function (a, b, c, d) {
	return {$: 100, a: a, b: b, c: c, d: d};
};
var $author$project$Types$Server_SetMuteSlackThread = F4($author$project$Types$Server_SetMuteSlackThread$);
var $author$project$Types$Server_SetMuteSlackWorkspace$ = function (a, b) {
	return {$: 98, a: a, b: b};
};
var $author$project$Types$Server_SetMuteSlackWorkspace = F2($author$project$Types$Server_SetMuteSlackWorkspace$);
var $author$project$Types$Server_SetMuteThread$ = function (a, b, c, d) {
	return {$: 93, a: a, b: b, c: c, d: d};
};
var $author$project$Types$Server_SetMuteThread = F4($author$project$Types$Server_SetMuteThread$);
var $author$project$Types$Server_SetName$ = function (a, b) {
	return {$: 48, a: a, b: b};
};
var $author$project$Types$Server_SetName = F2($author$project$Types$Server_SetName$);
var $author$project$Types$Server_SetPublicKey$ = function (a, b) {
	return {$: 106, a: a, b: b};
};
var $author$project$Types$Server_SetPublicKey = F2($author$project$Types$Server_SetPublicKey$);
var $author$project$Types$Server_SetSlackWorkspaceNotificationLevel$ = function (a, b) {
	return {$: 55, a: a, b: b};
};
var $author$project$Types$Server_SetSlackWorkspaceNotificationLevel = F2($author$project$Types$Server_SetSlackWorkspaceNotificationLevel$);
var $author$project$Types$Server_SetUserColor$ = function (a, b) {
	return {$: 49, a: a, b: b};
};
var $author$project$Types$Server_SetUserColor = F2($author$project$Types$Server_SetUserColor$);
var $author$project$Types$Server_SetUserIcon$ = function (a, b) {
	return {$: 50, a: a, b: b};
};
var $author$project$Types$Server_SetUserIcon = F2($author$project$Types$Server_SetUserIcon$);
var $author$project$Types$Server_Slack_AddReactionEmoji$ = function (a, b, c, d) {
	return {$: 13, a: a, b: b, c: c, d: d};
};
var $author$project$Types$Server_Slack_AddReactionEmoji = F4($author$project$Types$Server_Slack_AddReactionEmoji$);
var $author$project$Types$Server_Slack_ChannelRenamed$ = function (a, b, c) {
	return {$: 7, a: a, b: b, c: c};
};
var $author$project$Types$Server_Slack_ChannelRenamed = F3($author$project$Types$Server_Slack_ChannelRenamed$);
var $author$project$Types$Server_Slack_CustomEmojiAdded$ = function (a, b, c) {
	return {$: 12, a: a, b: b, c: c};
};
var $author$project$Types$Server_Slack_CustomEmojiAdded = F3($author$project$Types$Server_Slack_CustomEmojiAdded$);
var $author$project$Types$Server_Slack_CustomEmojisLoaded = function (a) {
	return {$: 11, a: a};
};
var $author$project$Types$Server_Slack_DeleteMessage$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Types$Server_Slack_DeleteMessage = F2($author$project$Types$Server_Slack_DeleteMessage$);
var $author$project$Types$Server_Slack_EditMessage$ = function (a, b, c, d, e) {
	return {$: 2, a: a, b: b, c: c, d: d, e: e};
};
var $author$project$Types$Server_Slack_EditMessage = F5($author$project$Types$Server_Slack_EditMessage$);
var $author$project$Types$Server_Slack_GotMessageEmbed$ = function (a, b, c) {
	return {$: 9, a: a, b: b, c: c};
};
var $author$project$Types$Server_Slack_GotMessageEmbed = F3($author$project$Types$Server_Slack_GotMessageEmbed$);
var $author$project$Types$Server_Slack_LinkedUserLoaded$ = function (a, b, c) {
	return {$: 10, a: a, b: b, c: c};
};
var $author$project$Types$Server_Slack_LinkedUserLoaded = F3($author$project$Types$Server_Slack_LinkedUserLoaded$);
var $author$project$Types$Server_Slack_NeedsAuthAgain = function (a) {
	return {$: 8, a: a};
};
var $author$project$Types$Server_Slack_RemoveReactionEmoji$ = function (a, b, c, d) {
	return {$: 14, a: a, b: b, c: c, d: d};
};
var $author$project$Types$Server_Slack_RemoveReactionEmoji = F4($author$project$Types$Server_Slack_RemoveReactionEmoji$);
var $author$project$Types$Server_Slack_SendMessage$ = function (a, b, c, d, e, f) {
	return {$: 1, a: a, b: b, c: c, d: d, e: e, f: f};
};
var $author$project$Types$Server_Slack_SendMessage = F6($author$project$Types$Server_Slack_SendMessage$);
var $author$project$Types$Server_Slack_UnlinkUser = function (a) {
	return {$: 4, a: a};
};
var $author$project$Types$Server_Slack_UserLoaded$ = function (a, b) {
	return {$: 5, a: a, b: b};
};
var $author$project$Types$Server_Slack_UserLoaded = F2($author$project$Types$Server_Slack_UserLoaded$);
var $author$project$Types$Server_Slack_WorkspaceRenamed$ = function (a, b) {
	return {$: 6, a: a, b: b};
};
var $author$project$Types$Server_Slack_WorkspaceRenamed = F2($author$project$Types$Server_Slack_WorkspaceRenamed$);
var $author$project$Types$Server_StartReloadingDiscordUser$ = function (a, b) {
	return {$: 69, a: a, b: b};
};
var $author$project$Types$Server_StartReloadingDiscordUser = F2($author$project$Types$Server_StartReloadingDiscordUser$);
var $author$project$Types$Server_TextEditor = function (a) {
	return {$: 61, a: a};
};
var $author$project$Types$Server_UnlinkDiscordUser = function (a) {
	return {$: 63, a: a};
};
var $author$project$Types$Server_UpdateDiscordMembers$ = function (a, b) {
	return {$: 85, a: a, b: b};
};
var $author$project$Types$Server_UpdateDiscordMembers = F2($author$project$Types$Server_UpdateDiscordMembers$);
var $author$project$Types$Server_VoiceChatChange = function (a) {
	return {$: 89, a: a};
};
var $author$project$Types$Server_YouJoinedGuildByInvite = function (a) {
	return {$: 26, a: a};
};
var $author$project$CustomEmoji$CustomEmojiInternal$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$CustomEmoji$CustomEmojiInternal = F2($author$project$CustomEmoji$CustomEmojiInternal$);
var $author$project$CustomEmoji$CustomEmojiLoading = {$: 1};
var $author$project$CustomEmoji$w3_unsafe_decode_CustomEmojiUrl = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Coord$w3_unsafe_decode_Coord($author$project$CssPixels$w3_unsafe_decode_CssPixels)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$FileStatus$w3_unsafe_decode_FileHash,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$CustomEmoji$CustomEmojiInternal)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$CustomEmoji$CustomEmojiLoading);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$CustomEmoji$EmojiName = $elm$core$Basics$identity;
var $author$project$CustomEmoji$w3_unsafe_decode_EmojiName = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$CustomEmoji$w3_unsafe_decode_CustomEmojiData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$CustomEmoji$w3_unsafe_decode_CustomEmojiUrl,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$CustomEmoji$w3_unsafe_decode_EmojiName,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeBool,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (isAnimated0, name0, url0) {
						return {isAnimated: isAnimated0, name: name0, url: url0};
					})))));
var $author$project$LinkedAndOtherDiscordUsers$w3_unsafe_decode_DiscordFrontendCurrentUser = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$PersonName$w3_unsafe_decode_PersonName,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$DiscordUserData$w3_unsafe_decode_DiscordUserLoadingData,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$FileStatus$w3_unsafe_decode_FileHash),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$EmailAddress$w3_unsafe_decode_EmailAddress),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$UserColor$w3_unsafe_decode_UserColor,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F7(
									function (color0, email0, icon0, isLoadingData0, linkedAt0, name0, needsAuthAgain0) {
										return {color: color0, email: email0, icon: icon0, isLoadingData: isLoadingData0, linkedAt: linkedAt0, name: name0, needsAuthAgain: needsAuthAgain0};
									})))))))));
var $author$project$MessageArray$w3_unsafe_decode_Run$ = function (w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeArray(
			$author$project$Message$w3_unsafe_decode_Message$(w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F2(
					function (start0, values0) {
						return {start: start0, values: values0};
					}))));
};
var $author$project$MessageArray$w3_unsafe_decode_Run = F3($author$project$MessageArray$w3_unsafe_decode_Run$);
var $author$project$MessageArray$w3_unsafe_decode_MessageArray$ = function (w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeArray(
								$author$project$MessageArray$w3_unsafe_decode_Run$(w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId)),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (end0, runs0, start0) {
											return {end: end0, runs: runs0, start: start0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$MessageArray$w3_unsafe_decode_MessageArray = F3($author$project$MessageArray$w3_unsafe_decode_MessageArray$);
var $author$project$VisibleMessages$w3_unsafe_decode_VisibleMessages = function (w3_x_c_messageId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Id$w3_unsafe_decode_Id(w3_x_c_messageId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeBool,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F3(
						function (count0, loadingMessages0, oldest0) {
							return {count: count0, loadingMessages: loadingMessages0, oldest: oldest0};
						})))));
};
var $author$project$DmChannel$w3_unsafe_decode_DiscordFrontendDmChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$VisibleMessages$w3_unsafe_decode_VisibleMessages($author$project$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$MessageArray$w3_unsafe_decode_MessageArray$(
			$author$project$Id$w3_unsafe_decode_ChannelMessageId,
			$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
			$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
				$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						function (messagesSent0) {
							return {messagesSent: messagesSent0};
						}))),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId)),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (messageIndex0, time0) {
										return {messageIndex: messageIndex0, time: time0};
									}))))),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$justinmimbs$date$Date$w3_unsafe_decode_Date,
						$author$project$Drawing$w3_unsafe_decode_Drawing(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (dateDividerDrawings0, lastTypedAt0, members0, messages0, visibleMessages0) {
								return {dateDividerDrawings: dateDividerDrawings0, lastTypedAt: lastTypedAt0, members: members0, messages: messages0, visibleMessages: visibleMessages0};
							})))))));
var $author$project$Thread$w3_unsafe_decode_DiscordFrontendThread = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$VisibleMessages$w3_unsafe_decode_VisibleMessages($author$project$Id$w3_unsafe_decode_ThreadMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$MessageArray$w3_unsafe_decode_MessageArray$(
			$author$project$Id$w3_unsafe_decode_ThreadMessageId,
			$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
			$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$justinmimbs$date$Date$w3_unsafe_decode_Date,
				$author$project$Drawing$w3_unsafe_decode_Drawing(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId))),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (dateDividerDrawings0, messages0, visibleMessages0) {
						return {dateDividerDrawings: dateDividerDrawings0, messages: messages0, visibleMessages: visibleMessages0};
					})))));
var $author$project$LocalState$w3_unsafe_decode_DiscordFrontendChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$VisibleMessages$w3_unsafe_decode_VisibleMessages($author$project$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
			$author$project$Thread$w3_unsafe_decode_DiscordFrontendThread),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Discord$w3_unsafe_decode_Overwrite),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$ChannelName$w3_unsafe_decode_ChannelName,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MessageArray$w3_unsafe_decode_MessageArray$(
						$author$project$Id$w3_unsafe_decode_ChannelMessageId,
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$ChannelDescription$w3_unsafe_decode_ChannelDescription,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqDict$decodeDict$(
									$justinmimbs$date$Date$w3_unsafe_decode_Date,
									$author$project$Drawing$w3_unsafe_decode_Drawing(
										$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId))),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F8(
										function (dateDividerDrawings0, description0, isForum0, messages0, name0, permissionOverwrites0, threads0, visibleMessages0) {
											return {dateDividerDrawings: dateDividerDrawings0, description: description0, isForum: isForum0, messages: messages0, name: name0, permissionOverwrites: permissionOverwrites0, threads: threads0, visibleMessages: visibleMessages0};
										}))))))))));
var $author$project$Thread$w3_unsafe_decode_LastTypedAt = function (w3_x_c_channelId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Id$w3_unsafe_decode_ThreadRouteWithMaybeMessage,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				w3_x_c_channelId,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F3(
						function (channelId0, threadRoute0, time0) {
							return {channelId: channelId0, threadRoute: threadRoute0, time: time0};
						})))));
};
var $author$project$LocalState$w3_unsafe_decode_DiscordFrontendGuild = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqSet$decodeSet(
		$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_StickerId)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_RoleId),
			$author$project$LocalState$w3_unsafe_decode_DiscordRole),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$GuildName$w3_unsafe_decode_GuildName,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$MembersAndOwner$w3_unsafe_decode_MembersAndOwner$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqSet$decodeSet(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_RoleId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (joinedAt0, roles0) {
										return {joinedAt: joinedAt0, roles: roles0};
									}))))),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
						$author$project$Thread$w3_unsafe_decode_LastTypedAt(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$FileStatus$w3_unsafe_decode_FileHash),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqSet$decodeSet(
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_CustomEmojiId)),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqDict$decodeDict$(
									$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
									$author$project$LocalState$w3_unsafe_decode_DiscordFrontendChannel),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F8(
										function (channels0, customEmojis0, icon0, lastTypedAt0, membersAndOwner0, name0, roles0, stickers0) {
											return {channels: channels0, customEmojis: customEmojis0, icon: icon0, lastTypedAt: lastTypedAt0, membersAndOwner: membersAndOwner0, name: name0, roles: roles0, stickers: stickers0};
										}))))))))));
var $author$project$LocalState$w3_unsafe_decode_Archived = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (archivedAt0, archivedBy0) {
					return {archivedAt: archivedAt0, archivedBy: archivedBy0};
				}))));
var $author$project$Thread$w3_unsafe_decode_FrontendThread = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$VisibleMessages$w3_unsafe_decode_VisibleMessages($author$project$Id$w3_unsafe_decode_ThreadMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$MessageArray$w3_unsafe_decode_MessageArray$(
			$author$project$Id$w3_unsafe_decode_ThreadMessageId,
			$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
			$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$justinmimbs$date$Date$w3_unsafe_decode_Date,
				$author$project$Drawing$w3_unsafe_decode_Drawing(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId))),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (dateDividerDrawings0, messages0, visibleMessages0) {
						return {dateDividerDrawings: dateDividerDrawings0, messages: messages0, visibleMessages: visibleMessages0};
					})))));
var $author$project$Go$w3_unsafe_decode_Phase = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$Confirming);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$Marking);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							function (previousPlayerPassed0) {
								return {previousPlayerPassed: previousPlayerPassed0};
							})),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$Playing));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeFloat,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (blackScore0, whiteScore0) {
										return {blackScore: blackScore0, whiteScore: whiteScore0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$Scored));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Go$w3_unsafe_decode_Snapshot = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Go$w3_unsafe_decode_Stone,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeDict$(
				$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
				$author$project$Go$w3_unsafe_decode_Stone),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (blackCaptures0, board0, currentPlayer0, whiteCaptures0) {
							return {blackCaptures: blackCaptures0, board: board0, currentPlayer: currentPlayer0, whiteCaptures: whiteCaptures0};
						}))))));
var $author$project$Go$w3_unsafe_decode_Shared = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F2(
								function (black0, white0) {
									return {black: black0, white: white0};
								}))))),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeDict$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
					$author$project$Go$w3_unsafe_decode_Stone),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Go$w3_unsafe_decode_Phase,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
									$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId)),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Go$w3_unsafe_decode_Snapshot),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Go$w3_unsafe_decode_Stone,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeDict$(
												$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
												$author$project$Go$w3_unsafe_decode_Stone),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeInt,
												$lamdera$codecs$Lamdera$Wire3$succeedDecode(
													function (blackCaptures0) {
														return function (board0) {
															return function (currentPlayer0) {
																return function (history0) {
																	return function (joinedUserId0) {
																		return function (lastAction0) {
																			return function (lastMove0) {
																				return function (phase0) {
																					return function (territoryMarks0) {
																						return function (timeLeft0) {
																							return function (turnCount0) {
																								return function (whiteCaptures0) {
																									return {blackCaptures: blackCaptures0, board: board0, currentPlayer: currentPlayer0, history: history0, joinedUserId: joinedUserId0, lastAction: lastAction0, lastMove: lastMove0, phase: phase0, territoryMarks: territoryMarks0, timeLeft: timeLeft0, turnCount: turnCount0, whiteCaptures: whiteCaptures0};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													})))))))))))));
var $author$project$Game$w3_unsafe_decode_FrontendGameData = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Go$w3_unsafe_decode_Shared,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Go$w3_unsafe_decode_ActionWithTime),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Go$w3_unsafe_decode_ValidatedSetup,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$FrontendGameData_Go))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$SheepGame$w3_unsafe_decode_Shared,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$SheepGame$w3_unsafe_decode_ActionWithTime),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$SheepGame$w3_unsafe_decode_ValidatedSetup,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$FrontendGameData_SheepGame))));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$WordSpellingGame$w3_unsafe_decode_Shared,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$WordSpellingGame$w3_unsafe_decode_ActionWithTime),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$WordSpellingGame$w3_unsafe_decode_ValidatedSetup,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$FrontendGameData_WordSpellingGame))));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Game$w3_unsafe_decode_MatchData = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$SecretId$w3_unsafe_decode_SecretId($author$project$Id$w3_unsafe_decode_GamePublicId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Game$w3_unsafe_decode_FrontendGameData,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (data0, publicLink0) {
										return {data: data0, publicLink: publicLink0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$MatchData));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Message$w3_unsafe_decode_GameType,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$MatchNotLoaded));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$LocalState$w3_unsafe_decode_FrontendChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$VisibleMessages$w3_unsafe_decode_VisibleMessages($author$project$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
			$author$project$Thread$w3_unsafe_decode_FrontendThread),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$ChannelName$w3_unsafe_decode_ChannelName,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$MessageArray$w3_unsafe_decode_MessageArray$(
					$author$project$Id$w3_unsafe_decode_ChannelMessageId,
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId)),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$LocalState$w3_unsafe_decode_Archived),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
							$author$project$Game$w3_unsafe_decode_MatchData),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$ChannelDescription$w3_unsafe_decode_ChannelDescription,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqDict$decodeDict$(
									$justinmimbs$date$Date$w3_unsafe_decode_Date,
									$author$project$Drawing$w3_unsafe_decode_Drawing(
										$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId))),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											function (createdAt0) {
												return function (createdBy0) {
													return function (dateDividerDrawings0) {
														return function (description0) {
															return function (games0) {
																return function (isArchived0) {
																	return function (messages0) {
																		return function (name0) {
																			return function (threads0) {
																				return function (visibleMessages0) {
																					return {createdAt: createdAt0, createdBy: createdBy0, dateDividerDrawings: dateDividerDrawings0, description: description0, games: games0, isArchived: isArchived0, messages: messages0, name: name0, threads: threads0, visibleMessages: visibleMessages0};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											})))))))))));
var $author$project$LocalState$w3_unsafe_decode_GuildMember = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (joinedAt0, lastPostedAt0) {
					return {joinedAt: joinedAt0, lastPostedAt: lastPostedAt0};
				}))));
var $author$project$LocalState$w3_unsafe_decode_FrontendGuild = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$GuildName$w3_unsafe_decode_GuildName,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$MembersAndOwner$w3_unsafe_decode_MembersAndOwner$(
			$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
			$author$project$LocalState$w3_unsafe_decode_GuildMember),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
				$author$project$Thread$w3_unsafe_decode_LastTypedAt(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId))),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$SecretId$w3_unsafe_decode_SecretId($author$project$Id$w3_unsafe_decode_InviteLinkId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (createdAt0, createdBy0) {
										return {createdAt: createdAt0, createdBy: createdBy0};
									}))))),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$FileStatus$w3_unsafe_decode_FileHash),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqDict$decodeDict$(
									$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
									$author$project$LocalState$w3_unsafe_decode_FrontendChannel),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F8(
										function (channels0, createdAt0, createdBy0, icon0, invites0, lastTypedAt0, membersAndOwner0, name0) {
											return {channels: channels0, createdAt: createdAt0, createdBy: createdBy0, icon: icon0, invites: invites0, lastTypedAt: lastTypedAt0, membersAndOwner: membersAndOwner0, name: name0};
										}))))))))));
var $author$project$User$w3_unsafe_decode_FrontendUser = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$X25519$w3_unsafe_decode_PublicKey),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$PersonName$w3_unsafe_decode_PersonName,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$FileStatus$w3_unsafe_decode_FileHash),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$UserColor$w3_unsafe_decode_UserColor,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (color0, icon0, name0, publicKey0) {
							return {color: color0, icon: icon0, name: name0, publicKey: publicKey0};
						}))))));
var $author$project$UserSession$w3_unsafe_decode_Viewing = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_Viewing_ChannelData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$UserSession$Viewing_Channel));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_Viewing_ChannelThreadData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$UserSession$Viewing_ChannelThread));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_Viewing_DiscordChannelData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$UserSession$Viewing_DiscordChannel));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_Viewing_DiscordChannelThreadData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$UserSession$Viewing_DiscordChannelThread));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_Viewing_DiscordDmData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$UserSession$Viewing_DiscordDm));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_Viewing_DmData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$UserSession$Viewing_Dm));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_Viewing_DmThreadData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$UserSession$Viewing_DmThread));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$UserSession$Viewing_None);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$UserSession$Viewing_Overview);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_Viewing_SlackChannelData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$UserSession$Viewing_SlackChannel));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_Viewing_SlackChannelThreadData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$UserSession$Viewing_SlackChannelThread));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_Viewing_SlackDmData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$UserSession$Viewing_SlackDm));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_Viewing_SlackDmThreadData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$UserSession$Viewing_SlackDmThread));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$UserSession$w3_unsafe_decode_FrontendUserSession = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$UserAgent$w3_unsafe_decode_UserAgent,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$UserSession$w3_unsafe_decode_NotificationMode,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$($lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId, $author$project$UserSession$w3_unsafe_decode_Viewing),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (currentlyViewing0, lastActiveAt0, notificationMode0, userAgent0) {
							return {currentlyViewing: currentlyViewing0, lastActiveAt: lastActiveAt0, notificationMode: notificationMode0, userAgent: userAgent0};
						}))))));
var $author$project$LocalState$ConnectedToCall = function (a) {
	return {$: 1, a: a};
};
var $author$project$LocalState$NotInCall = {$: 0};
var $author$project$Call$w3_unsafe_decode_CallId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Viewing_DmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$DmRoomId));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Viewing_ChannelId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$GuildRoomId));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$LocalState$w3_unsafe_decode_CallStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Call$w3_unsafe_decode_CallId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$ConnectedToCall));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$NotInCall);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$LocalState$LastRequest = function (a) {
	return {$: 1, a: a};
};
var $author$project$LocalState$NoRequestsMade = {$: 0};
var $author$project$LocalState$w3_unsafe_decode_LastRequest = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$LastRequest));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$NoRequestsMade);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$LocalState$w3_unsafe_decode_ConnectionData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Call$w3_unsafe_decode_RemoteCallData,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$LocalState$w3_unsafe_decode_LastRequest,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$UserSession$w3_unsafe_decode_Viewing,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$LocalState$w3_unsafe_decode_CallStatus,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (call0, currentlyViewing0, lastRequest0, remoteCallData0) {
							return {call: call0, currentlyViewing: currentlyViewing0, lastRequest: lastRequest0, remoteCallData: remoteCallData0};
						}))))));
var $author$project$LocalState$FullBackup = 0;
var $author$project$LocalState$SubsetBackup = 1;
var $author$project$LocalState$w3_unsafe_decode_BackupContents = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$LocalState$w3_unsafe_decode_LastBackup = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$LocalState$w3_unsafe_decode_BackupContents,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (contents0, createdAt0) {
					return {contents: contents0, createdAt: createdAt0};
				}))));
var $author$project$LocalState$LoadingDiscordChannelAttachments$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$LocalState$LoadingDiscordChannelAttachments = F2($author$project$LocalState$LoadingDiscordChannelAttachments$);
var $author$project$LocalState$LoadingDiscordChannelMessagesFailed = function (a) {
	return {$: 1, a: a};
};
var $author$project$LocalState$w3_unsafe_decode_LoadingDiscordChannelStep = function (w3_x_c_messages) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_messages,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$LoadingDiscordChannelAttachments)));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$LoadingDiscordChannelMessages);
				case 2:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_HttpError,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$LoadingDiscordChannelMessagesFailed));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$LocalState$w3_unsafe_decode_LoadingDiscordChannel = function (w3_x_c_messages) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$LocalState$w3_unsafe_decode_LoadingDiscordChannelStep(w3_x_c_messages),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$LoadingDiscordDmChannel))));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$LocalState$w3_unsafe_decode_LoadingDiscordChannelStep(w3_x_c_messages),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$LoadingDiscordGuildChannel)))));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Pagination$w3_unsafe_decode_PageStatus = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeArray(w3_x_c_a),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pagination$PageLoaded));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pagination$PageLoading);
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Pagination$w3_unsafe_decode_Pagination = function (w3_x_c_a) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Id$w3_unsafe_decode_Id($author$project$Pagination$w3_unsafe_decode_PageId),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Pagination$w3_unsafe_decode_PageId),
					$author$project$Pagination$w3_unsafe_decode_PageStatus(w3_x_c_a)),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Pagination$w3_unsafe_decode_PageId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F4(
							function (currentPage0, pages0, previousPage0, totalItems0) {
								return {currentPage: currentPage0, pages: pages0, previousPage: previousPage0, totalItems: totalItems0};
							}))))));
};
var $author$project$Pages$Admin$w3_unsafe_decode_TypeThatIsAlwaysInvalid = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$LocalState$WordSpellingGameStatus_Error = function (a) {
	return {$: 2, a: a};
};
var $author$project$LocalState$WordSpellingGameStatus_Loaded = {$: 3};
var $author$project$LocalState$WordSpellingGameStatus_Loading = {$: 1};
var $author$project$LocalState$WordSpellingGameStatus_NotLoaded = {$: 0};
var $author$project$LocalState$w3_unsafe_decode_WordSpellingGameStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$WordSpellingGameStatus_Error));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$WordSpellingGameStatus_Loaded);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$WordSpellingGameStatus_Loading);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$WordSpellingGameStatus_NotLoaded);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Pages$Admin$w3_unsafe_decode_InitAdminData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$LocalState$w3_unsafe_decode_WordSpellingGameStatus,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$LocalState$w3_unsafe_decode_WordSpellingGameStatus,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeBool,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeList(
										$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeString, $lamdera$codecs$Lamdera$Wire3$decodeInt)),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$LocalState$w3_unsafe_decode_PrivateVapidKey,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Postmark$w3_unsafe_decode_ApiKey,
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
															$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId)),
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$author$project$Pagination$w3_unsafe_decode_Pagination($author$project$LocalState$w3_unsafe_decode_LogWithTime),
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$lamdera$containers$SeqDict$decodeDict$(
																	$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
																	$author$project$LocalState$w3_unsafe_decode_LoadingDiscordChannel($lamdera$codecs$Lamdera$Wire3$decodeInt)),
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$LocalState$w3_unsafe_decode_LastBackup),
																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																		$lamdera$codecs$Lamdera$Wire3$decodeInt,
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$codecs$Lamdera$Wire3$decodeBool,
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$lamdera$codecs$Lamdera$Wire3$decodeBool,
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																						$lamdera$codecs$Lamdera$Wire3$decodeList(
																							$lamdera$codecs$Lamdera$Wire3$decodePair$(
																								$author$project$SessionIdHash$w3_unsafe_decode_SessionIdHash,
																								$author$project$NonemptyDict$w3_unsafe_decode_NonemptyDict$($lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId, $author$project$LocalState$w3_unsafe_decode_ConnectionData))),
																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																							$author$project$Pages$Admin$w3_unsafe_decode_TypeThatIsAlwaysInvalid,
																							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																								function (checkToFrontendValidation0) {
																									return function (connections0) {
																										return function (discordLinkLimit0) {
																											return function (discordLinkingEnabled0) {
																												return function (emailNotificationsEnabled0) {
																													return function (filesCount0) {
																														return function (lastBackup0) {
																															return function (loadingDiscordChannels0) {
																																return function (logs0) {
																																	return function (notifyAdminsBotUserId0) {
																																		return function (notifyAdminsToken0) {
																																			return function (openRouterKey0) {
																																				return function (postmarkApiKey0) {
																																					return function (privateVapidKey0) {
																																						return function (seqDictWorks0) {
																																							return function (serverSecretRegeneratedAt0) {
																																								return function (signupsEnabled0) {
																																									return function (slackLinkLimit0) {
																																										return function (slackLinkingEnabled0) {
																																											return function (twoFactorAuthentication0) {
																																												return function (vulnerabilityChecks0) {
																																													return function (wordSpellingGameEnglish0) {
																																														return function (wordSpellingGameSwedish0) {
																																															return {checkToFrontendValidation: checkToFrontendValidation0, connections: connections0, discordLinkLimit: discordLinkLimit0, discordLinkingEnabled: discordLinkingEnabled0, emailNotificationsEnabled: emailNotificationsEnabled0, filesCount: filesCount0, lastBackup: lastBackup0, loadingDiscordChannels: loadingDiscordChannels0, logs: logs0, notifyAdminsBotUserId: notifyAdminsBotUserId0, notifyAdminsToken: notifyAdminsToken0, openRouterKey: openRouterKey0, postmarkApiKey: postmarkApiKey0, privateVapidKey: privateVapidKey0, seqDictWorks: seqDictWorks0, serverSecretRegeneratedAt: serverSecretRegeneratedAt0, signupsEnabled: signupsEnabled0, slackLinkLimit: slackLinkLimit0, slackLinkingEnabled: slackLinkingEnabled0, twoFactorAuthentication: twoFactorAuthentication0, vulnerabilityChecks: vulnerabilityChecks0, wordSpellingGameEnglish: wordSpellingGameEnglish0, wordSpellingGameSwedish: wordSpellingGameSwedish0};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								}))))))))))))))))))))))));
var $author$project$LocalState$AlreadyJoined = 0;
var $author$project$LocalState$InviteIsInvalid = 1;
var $author$project$LocalState$YouAreBanned = 2;
var $author$project$LocalState$w3_unsafe_decode_JoinGuildError = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Types$NoReplyData = {$: 0};
var $author$project$Types$RepliedToGame = function (a) {
	return {$: 3, a: a};
};
var $author$project$Types$RepliedToMessage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$RepliedToThreadMessage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$w3_unsafe_decode_RepliedToData = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$NoReplyData);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Game$w3_unsafe_decode_LoadedMatch,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$RepliedToGame));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Message$w3_unsafe_decode_Message$(
						$author$project$Id$w3_unsafe_decode_ChannelMessageId,
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$RepliedToMessage));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Message$w3_unsafe_decode_Message$(
						$author$project$Id$w3_unsafe_decode_ThreadMessageId,
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$RepliedToThreadMessage));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Call$Server_Left$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Call$Server_Left = F2($author$project$Call$Server_Left$);
var $author$project$Call$Server_OtherJoined$ = function (a, b, c) {
	return {$: 1, a: a, b: b, c: c};
};
var $author$project$Call$Server_OtherJoined = F3($author$project$Call$Server_OtherJoined$);
var $author$project$Call$Server_RecordingChanged$ = function (a, b) {
	return {$: 4, a: a, b: b};
};
var $author$project$Call$Server_RecordingChanged = F2($author$project$Call$Server_RecordingChanged$);
var $author$project$Call$Server_SetRemoteCallData$ = function (a, b) {
	return {$: 3, a: a, b: b};
};
var $author$project$Call$Server_SetRemoteCallData = F2($author$project$Call$Server_SetRemoteCallData$);
var $author$project$Call$Server_YouJoined$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Call$Server_YouJoined = F2($author$project$Call$Server_YouJoined$);
var $author$project$Call$w3_unsafe_decode_ConnectionId = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Call$w3_unsafe_decode_CallId,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodePair$(
			$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
			$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (otherClientId0, roomId0) {
					return {otherClientId: otherClientId0, roomId: roomId0};
				}))));
var $author$project$Call$AskingToRecord = function (a) {
	return {$: 0, a: a};
};
var $author$project$Call$RecordingDeclined = function (a) {
	return {$: 1, a: a};
};
var $author$project$Call$RecordingSince = function (a) {
	return {$: 2, a: a};
};
var $author$project$Call$w3_unsafe_decode_RecordingStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqSet$decodeSet(
									$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId)),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (allowedBy0, requestedAt0, requestedBy0) {
											return {allowedBy: allowedBy0, requestedAt: requestedAt0, requestedBy: requestedBy0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$AskingToRecord));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId)),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (declinedAt0, declinedBy0, requestedBy0) {
											return {declinedAt: declinedAt0, declinedBy: declinedBy0, requestedBy: requestedBy0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$RecordingDeclined));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$RecordingSince));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Call$w3_unsafe_decode_ServerChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Call$w3_unsafe_decode_ConnectionId,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$Server_Left)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Call$w3_unsafe_decode_RemoteCallData,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Call$w3_unsafe_decode_ConnectionId,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$Server_OtherJoined))));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Call$w3_unsafe_decode_RecordingStatus),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Call$w3_unsafe_decode_CallId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$Server_RecordingChanged)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Call$w3_unsafe_decode_RemoteCallData,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Call$w3_unsafe_decode_ConnectionId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$Server_SetRemoteCallData)));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Call$w3_unsafe_decode_CallId,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$Server_YouJoined)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$TextEditor$Server_EditChange$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$TextEditor$Server_EditChange = F2($author$project$TextEditor$Server_EditChange$);
var $author$project$TextEditor$Server_Redo = function (a) {
	return {$: 3, a: a};
};
var $author$project$TextEditor$Server_Reset = {$: 1};
var $author$project$TextEditor$Server_Undo = function (a) {
	return {$: 2, a: a};
};
var $author$project$TextEditor$w3_unsafe_decode_ServerChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$TextEditor$w3_unsafe_decode_EditChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TextEditor$Server_EditChange)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TextEditor$Server_Redo));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TextEditor$Server_Reset);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TextEditor$Server_Undo));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Thread$w3_unsafe_decode_FrontendGenericThread$ = function (w3_x_c_userId, w3_x_c_channelId) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$VisibleMessages$w3_unsafe_decode_VisibleMessages($author$project$Id$w3_unsafe_decode_ThreadMessageId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$MessageArray$w3_unsafe_decode_MessageArray$($author$project$Id$w3_unsafe_decode_ThreadMessageId, w3_x_c_userId, w3_x_c_channelId),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$justinmimbs$date$Date$w3_unsafe_decode_Date,
					$author$project$Drawing$w3_unsafe_decode_Drawing(w3_x_c_userId)),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F3(
						function (dateDividerDrawings0, messages0, visibleMessages0) {
							return {dateDividerDrawings: dateDividerDrawings0, messages: messages0, visibleMessages: visibleMessages0};
						})))));
};
var $author$project$Thread$w3_unsafe_decode_FrontendGenericThread = F2($author$project$Thread$w3_unsafe_decode_FrontendGenericThread$);
var $author$project$Thread$w3_unsafe_decode_SlackFrontendThread = $author$project$Thread$w3_unsafe_decode_FrontendGenericThread$(
	$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
	$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId));
var $author$project$LocalState$w3_unsafe_decode_SlackFrontendDmChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$VisibleMessages$w3_unsafe_decode_VisibleMessages($author$project$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
			$author$project$Thread$w3_unsafe_decode_SlackFrontendThread),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$MessageArray$w3_unsafe_decode_MessageArray$(
					$author$project$Id$w3_unsafe_decode_ChannelMessageId,
					$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
					$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId)),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$NonemptySet$w3_unsafe_decode_NonemptySet(
						$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (members0, messages0, teamId0, threads0, visibleMessages0) {
								return {members: members0, messages: messages0, teamId: teamId0, threads: threads0, visibleMessages: visibleMessages0};
							})))))));
var $author$project$UserSession$w3_unsafe_decode_SlackFrontendUser = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$PersonName$w3_unsafe_decode_PersonName,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$FileStatus$w3_unsafe_decode_FileHash),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$UserColor$w3_unsafe_decode_UserColor,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (color0, icon0, name0, teamId0) {
							return {color: color0, icon: icon0, name: name0, teamId: teamId0};
						}))))));
var $author$project$LocalState$w3_unsafe_decode_SlackFrontendChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$VisibleMessages$w3_unsafe_decode_VisibleMessages($author$project$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
			$author$project$Thread$w3_unsafe_decode_SlackFrontendThread),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$ChannelName$w3_unsafe_decode_ChannelName,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$MessageArray$w3_unsafe_decode_MessageArray$(
					$author$project$Id$w3_unsafe_decode_ChannelMessageId,
					$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
					$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId)),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (isPrivate0, messages0, name0, threads0, visibleMessages0) {
								return {isPrivate: isPrivate0, messages: messages0, name: name0, threads: threads0, visibleMessages: visibleMessages0};
							})))))));
var $author$project$LocalState$w3_unsafe_decode_SlackFrontendWorkspace = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$FileStatus$w3_unsafe_decode_FileHash),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqSet$decodeSet(
				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_CustomEmojiId)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId),
					$author$project$LocalState$w3_unsafe_decode_SlackFrontendChannel),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (channels0, customEmojis0, icon0, name0) {
							return {channels: channels0, customEmojis: customEmojis0, icon: icon0, name: name0};
						}))))));
var $author$project$Discord$ApngFormat = 1;
var $author$project$Discord$GifFormat = 3;
var $author$project$Discord$LottieFormat = 2;
var $author$project$Discord$PngFormat = 0;
var $author$project$Discord$w3_unsafe_decode_StickerFormatType = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Sticker$DiscordStandardSticker = function (a) {
	return {$: 1, a: a};
};
var $author$project$Sticker$StickerInternal$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Sticker$StickerInternal = F2($author$project$Sticker$StickerInternal$);
var $author$project$Sticker$StickerLoading = {$: 2};
var $author$project$Discord$StickerId = $elm$core$Basics$identity;
var $author$project$Discord$w3_unsafe_decode_StickerId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Sticker$w3_unsafe_decode_StickerUrl = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_StickerId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Sticker$DiscordStandardSticker));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Coord$w3_unsafe_decode_Coord($author$project$CssPixels$w3_unsafe_decode_CssPixels)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$FileStatus$w3_unsafe_decode_FileHash,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Sticker$StickerInternal)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Sticker$StickerLoading);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Sticker$w3_unsafe_decode_StickerData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Sticker$w3_unsafe_decode_StickerUrl,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Discord$w3_unsafe_decode_StickerFormatType,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (format0, name0, url0) {
						return {format: format0, name: name0, url: url0};
					})))));
var $author$project$Types$w3_unsafe_decode_ServerChange = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_GuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_AddReactionEmoji)))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$LocalState$w3_unsafe_decode_LastBackup,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_BackupGenerated));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$NonemptySet$w3_unsafe_decode_NonemptySet(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_GuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_CallRecordingStarted)))));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_GuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_CallRecordingUploadFinished))));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Message$w3_unsafe_decode_CallRecordingFile(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_GuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_CallRecordingUploadProgress))));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Message$w3_unsafe_decode_CallRecordingZip,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_GuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_CallRecordingZipBuilt))));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$SessionIdHash$w3_unsafe_decode_SessionIdHash,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_ClientDisconnected))));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_Viewing,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$SessionIdHash$w3_unsafe_decode_SessionIdHash,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_CurrentlyViewing))));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DeleteChannel)));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DeleteGuild));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$SecretId$w3_unsafe_decode_SecretId($author$project$Id$w3_unsafe_decode_InviteLinkId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DeleteInviteLink)));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DeleteMessage)));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Viewing_DmId,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DisableE2ee))));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DiscordAddReactionDmEmoji)))));
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DiscordAddReactionGuildEmoji))))));
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_DiscordFrontendUser,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DiscordAvatarsLoaded)));
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Discord$w3_unsafe_decode_Overwrite),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_OptionalData(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$ChannelName$w3_unsafe_decode_ChannelName,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeBool,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DiscordChannelCreated)))))));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DiscordChannelDeleted)));
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DiscordDeleteDmMessage)));
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DiscordDeleteGuildMessage))));
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								function (messagesSent0) {
									return {messagesSent: messagesSent0};
								}))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DiscordDmChannelCreated)));
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DiscordDmChannelRecipientRemoved)));
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DiscordDmMemberTyping))));
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DiscordForumPostDeleted))));
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$LocalState$w3_unsafe_decode_DiscordFrontendGuild,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DiscordGuildJoinedOrCreated))));
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DiscordGuildLeftOrDeleted)));
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserColor$w3_unsafe_decode_UserColor,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$PersonName$w3_unsafe_decode_PersonName,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DiscordGuildMemberJoined)))))));
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_ThreadRoute,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DiscordGuildMemberTyping))))));
			case 28:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DiscordNeedsAuthAgain));
			case 29:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DiscordRemoveReactionDmEmoji)))));
			case 30:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DiscordRemoveReactionGuildEmoji))))));
			case 31:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
						$author$project$RichText$w3_unsafe_decode_RichText$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Viewing_DiscordDmId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DiscordSendEditDmMessage)))));
			case 32:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
						$author$project$RichText$w3_unsafe_decode_RichText$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DiscordSendEditGuildMessage)))))));
			case 33:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Discord$w3_unsafe_decode_Overwrite),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_OptionalData(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_OptionalData(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString)),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DiscordUpdateChannel))))));
			case 34:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_RoleId),
						$author$project$LocalState$w3_unsafe_decode_DiscordRole),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$FileStatus$w3_unsafe_decode_FileHash),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$GuildName$w3_unsafe_decode_GuildName,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DiscordUpdateGuild)))));
			case 35:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqSet$decodeSet(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_CustomEmojiId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DiscordUpdateGuildCustomEmojis)));
			case 36:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$LocalState$w3_unsafe_decode_DiscordRole,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_RoleId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DiscordUpdateRole))));
			case 37:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeBool,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqDict$decodeDict$(
									$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
									$author$project$UserSession$w3_unsafe_decode_DiscordFrontendUser),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$containers$SeqDict$decodeDict$(
										$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
										$author$project$LocalState$w3_unsafe_decode_DiscordFrontendGuild),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$containers$SeqDict$decodeDict$(
											$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
											$author$project$DmChannel$w3_unsafe_decode_DiscordFrontendDmChannel),
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											F4(
												function (discordDms0, discordGuilds0, discordUsers0, markEverythingAsViewed0) {
													return {discordDms: discordDms0, discordGuilds: discordGuilds0, discordUsers: discordUsers0, markEverythingAsViewed: markEverythingAsViewed0};
												}))))))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_DiscordUserLoadingDataIsDone)));
			case 38:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_StickerId),
						$author$project$Sticker$w3_unsafe_decode_StickerData),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
							$author$project$FileStatus$w3_unsafe_decode_FileData),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_ThreadRouteWithMaybeMessage,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
									$author$project$RichText$w3_unsafe_decode_RichText$(
										$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
										$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId))),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$UserSession$w3_unsafe_decode_DiscordFrontendUser,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Id$w3_unsafe_decode_DiscordGuildOrDmId,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
											$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_Discord_SendMessage))))))));
			case 39:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Drawing$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Drawing$w3_unsafe_decode_AnchorType,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_Drawing)))));
			case 40:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Viewing_DmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_E2eeAccepted)));
			case 41:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Viewing_DmId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_E2eeRequestCancelled));
			case 42:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Viewing_DmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_E2eeRequestDeclined)));
			case 43:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
						$author$project$SessionIdHash$w3_unsafe_decode_SessionIdHash),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Viewing_DmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_E2eeRequested)));
			case 44:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$ChannelDescription$w3_unsafe_decode_ChannelDescription,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$ChannelName$w3_unsafe_decode_ChannelName,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_EditChannel)))));
			case 45:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$GuildName$w3_unsafe_decode_GuildName,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_EditGuildName)));
			case 46:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Game$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_GuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_Game))));
			case 47:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$elm$url$Url$w3_unsafe_decode_Url,
						$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $author$project$Embed$w3_unsafe_decode_EmbedData)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_GotDiscordDmMessageEmbed))));
			case 48:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$elm$url$Url$w3_unsafe_decode_Url,
						$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $author$project$Embed$w3_unsafe_decode_EmbedData)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_GotDiscordGuildMessageEmbed)))));
			case 49:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$elm$url$Url$w3_unsafe_decode_Url,
						$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $author$project$Embed$w3_unsafe_decode_EmbedData)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_GotDmMessageEmbed))));
			case 50:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$elm$url$Url$w3_unsafe_decode_Url,
						$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $author$project$Embed$w3_unsafe_decode_EmbedData)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_GotGuildMessageEmbed)))));
			case 51:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$LocalState$w3_unsafe_decode_FrontendChannel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_ImportedChannel))));
			case 52:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$LinkedAndOtherDiscordUsers$w3_unsafe_decode_DiscordFrontendCurrentUser,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_LinkDiscordUser)));
			case 53:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_CustomEmojiId),
						$author$project$CustomEmoji$w3_unsafe_decode_CustomEmojiData),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_LinkedDiscordUserCustomEmojisLoaded));
			case 54:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_StickerId),
						$author$project$Sticker$w3_unsafe_decode_StickerData),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_LinkedDiscordUserStickersLoaded));
			case 55:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Pages$Admin$w3_unsafe_decode_InitAdminData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_LoadAdminData));
			case 56:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$LocalState$w3_unsafe_decode_LoadingDiscordChannel($lamdera$codecs$Lamdera$Wire3$decodeInt)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_LoadingDiscordChannelChanged)));
			case 57:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$SessionIdHash$w3_unsafe_decode_SessionIdHash,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_LoggedOut));
			case 58:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_MemberEditTyping)))));
			case 59:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$User$w3_unsafe_decode_FrontendUser,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_MemberJoined)))));
			case 60:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_MemberLeft)));
			case 61:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_ThreadRoute,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_GuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_MemberTyping)))));
			case 62:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$ChannelDescription$w3_unsafe_decode_ChannelDescription,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$ChannelName$w3_unsafe_decode_ChannelName,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_NewChannel)))));
			case 63:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$SecretId$w3_unsafe_decode_SecretId($author$project$Id$w3_unsafe_decode_InviteLinkId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_NewInviteLink)))));
			case 64:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Log$w3_unsafe_decode_Log,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_NewLog)));
			case 65:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_FrontendUserSession,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$SessionIdHash$w3_unsafe_decode_SessionIdHash,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_NewSession)));
			case 66:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Ports$w3_unsafe_decode_SubscribeData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_PushNotificationFailed)));
			case 67:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_PushNotificationsReset));
			case 68:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_GuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_RemoveReactionEmoji)))));
			case 69:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
						$author$project$FileStatus$w3_unsafe_decode_FileData),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
							$author$project$RichText$w3_unsafe_decode_RichText$(
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId))),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_GuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_SendEditMessage)))))));
			case 70:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Encryption$w3_unsafe_decode_EncryptedData(
						$author$project$Message$w3_unsafe_decode_MessageContent$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqSet$decodeSet($author$project$FileStatus$w3_unsafe_decode_FileHash),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_Viewing_DmId,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_SendEncryptedEditMessage)))))));
			case 71:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Message$w3_unsafe_decode_ThreadRouteWithRepliedTo,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$User$w3_unsafe_decode_FrontendUser,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Types$w3_unsafe_decode_RepliedToData,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Id$w3_unsafe_decode_Viewing_DmId,
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$containers$SeqSet$decodeSet($author$project$FileStatus$w3_unsafe_decode_FileHash),
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$author$project$Encryption$w3_unsafe_decode_EncryptedData(
														$author$project$Message$w3_unsafe_decode_MessageContent$(
															$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
															$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId))),
													$lamdera$codecs$Lamdera$Wire3$succeedDecode(
														F8(
															function (content0, fileHashes0, id0, repliedToData0, sender0, senderId0, sentAt0, threadRoute0) {
																return {content: content0, fileHashes: fileHashes0, id: id0, repliedToData: repliedToData0, sender: sender0, senderId: senderId0, sentAt: sentAt0, threadRoute: threadRoute0};
															})))))))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_SendEncryptedMessage));
			case 72:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Message$w3_unsafe_decode_ThreadRouteWithRepliedTo,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqDict$decodeDict$(
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_StickerId),
								$author$project$Sticker$w3_unsafe_decode_StickerData),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$User$w3_unsafe_decode_FrontendUser,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Types$w3_unsafe_decode_RepliedToData,
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$author$project$Id$w3_unsafe_decode_GuildOrDmId,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
														$author$project$RichText$w3_unsafe_decode_RichText$(
															$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
															$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId))),
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$lamdera$containers$SeqDict$decodeDict$(
															$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
															$author$project$FileStatus$w3_unsafe_decode_FileData),
														$lamdera$codecs$Lamdera$Wire3$succeedDecode(
															F9(
																function (attachedFiles0, content0, guildOrDmId0, repliedToData0, sender0, senderId0, sentAt0, stickers0, threadRoute0) {
																	return {attachedFiles: attachedFiles0, content: content0, guildOrDmId: guildOrDmId0, repliedToData: repliedToData0, sender: sender0, senderId: senderId0, sentAt: sentAt0, stickers: stickers0, threadRoute: threadRoute0};
																}))))))))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_SendMessage));
			case 73:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$User$w3_unsafe_decode_NotificationLevel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_SetDiscordGuildNotificationLevel)));
			case 74:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$FileStatus$w3_unsafe_decode_FileHash),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_SetGuildIcon)));
			case 75:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$User$w3_unsafe_decode_NotificationLevel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_SetGuildNotificationLevel)));
			case 76:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_SetMuteChannel))));
			case 77:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_SetMuteDiscordChannel))));
			case 78:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_SetMuteDiscordGuild)));
			case 79:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_SetMuteDiscordThread)))));
			case 80:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_SetMuteGuild)));
			case 81:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_SetMuteSlackChannel))));
			case 82:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_SetMuteSlackThread)))));
			case 83:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_SetMuteSlackWorkspace)));
			case 84:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_SetMuteThread)))));
			case 85:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$PersonName$w3_unsafe_decode_PersonName,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_SetName)));
			case 86:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$X25519$w3_unsafe_decode_PublicKey,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_SetPublicKey)));
			case 87:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$User$w3_unsafe_decode_NotificationLevel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_SetSlackWorkspaceNotificationLevel)));
			case 88:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserColor$w3_unsafe_decode_UserColor,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_SetUserColor)));
			case 89:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$FileStatus$w3_unsafe_decode_FileHash),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_SetUserIcon)));
			case 90:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_SlackGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_Slack_AddReactionEmoji)))));
			case 91:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$ChannelName$w3_unsafe_decode_ChannelName,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_Slack_ChannelRenamed))));
			case 92:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$CustomEmoji$w3_unsafe_decode_CustomEmojiData,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_CustomEmojiId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_Slack_CustomEmojiAdded))));
			case 93:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_CustomEmojiId),
						$author$project$CustomEmoji$w3_unsafe_decode_CustomEmojiData),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_Slack_CustomEmojisLoaded));
			case 94:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_SlackGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_Slack_DeleteMessage)));
			case 95:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
						$author$project$RichText$w3_unsafe_decode_RichText$(
							$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
							$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_SlackGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_Slack_EditMessage))))));
			case 96:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$elm$url$Url$w3_unsafe_decode_Url,
						$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $author$project$Embed$w3_unsafe_decode_EmbedData)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_SlackGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_Slack_GotMessageEmbed))));
			case 97:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
							$author$project$LocalState$w3_unsafe_decode_SlackFrontendWorkspace),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqDict$decodeDict$(
								$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
								$author$project$UserSession$w3_unsafe_decode_SlackFrontendUser),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeBool,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$containers$SeqDict$decodeDict$(
										$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_DmChannelId),
										$author$project$LocalState$w3_unsafe_decode_SlackFrontendDmChannel),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$containers$SeqDict$decodeDict$(
											$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_CustomEmojiId),
											$author$project$CustomEmoji$w3_unsafe_decode_CustomEmojiData),
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											F5(
												function (customEmojis0, dmChannels0, markNewDmsAsViewed0, users0, workspaces0) {
													return {customEmojis: customEmojis0, dmChannels: dmChannels0, markNewDmsAsViewed: markNewDmsAsViewed0, users: users0, workspaces: workspaces0};
												}))))))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_Slack_LinkedUserLoaded))));
			case 98:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_Slack_NeedsAuthAgain));
			case 99:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_SlackGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_Slack_RemoveReactionEmoji)))));
			case 100:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Message$w3_unsafe_decode_Message$(
							$author$project$Id$w3_unsafe_decode_ChannelMessageId,
							$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
							$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
							$author$project$FileStatus$w3_unsafe_decode_FileData),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
								$author$project$RichText$w3_unsafe_decode_RichText$(
									$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
									$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId))),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_ThreadRoute,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Id$w3_unsafe_decode_SlackGuildOrDmId,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_Slack_SendMessage)))))));
			case 101:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_Slack_UnlinkUser));
			case 102:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_SlackFrontendUser,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_Slack_UserLoaded)));
			case 103:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_Slack_WorkspaceRenamed)));
			case 104:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_StartReloadingDiscordUser)));
			case 105:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$TextEditor$w3_unsafe_decode_ServerChange,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_TextEditor));
			case 106:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_UnlinkDiscordUser));
			case 107:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MembersAndOwner$w3_unsafe_decode_MembersAndOwner$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqSet$decodeSet(
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_RoleId)),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F2(
										function (joinedAt0, roles0) {
											return {joinedAt: joinedAt0, roles: roles0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_UpdateDiscordMembers)));
			case 108:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Call$w3_unsafe_decode_ServerChange,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_VoiceChatChange));
			case 109:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$(
						$author$project$LocalState$w3_unsafe_decode_JoinGuildError,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$User$w3_unsafe_decode_FrontendUser,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqDict$decodeDict$(
									$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
									$author$project$User$w3_unsafe_decode_FrontendUser),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$LocalState$w3_unsafe_decode_FrontendGuild,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											F4(
												function (guild0, guildId0, members0, owner0) {
													return {guild: guild0, guildId: guildId0, members: members0, owner: owner0};
												}))))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Server_YouJoinedGuildByInvite));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Types$w3_unsafe_decode_LocalMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Types$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$LocalChange)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Types$w3_unsafe_decode_ServerChange,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$ServerChange));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$LocalState$w3_unsafe_decode_AdminDataStatus = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_a,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$AdminDataLoaded));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$AdminDataLoading);
				case 2:
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$AdminDataNotLoaded);
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$LocalState$w3_unsafe_decode_DeleteOrphanedFilesStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$DeletingOrphanedFiles);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$DeletingOrphanedFilesFailed));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$NotDeletingOrphanedFiles);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$LocalState$w3_unsafe_decode_ServerSecretStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$BeingRegenerated);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$NotBeingRegenerated));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$RegenerationFailed));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$LocalState$w3_unsafe_decode_AdminData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$LocalState$w3_unsafe_decode_WordSpellingGameStatus,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$LocalState$w3_unsafe_decode_WordSpellingGameStatus,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$LocalState$w3_unsafe_decode_AdminDataStatus(
				$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$LocalState$w3_unsafe_decode_WebsocketClosedEvent)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$LocalState$w3_unsafe_decode_AdminDataStatus(
						$author$project$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
							$author$project$User$w3_unsafe_decode_BackendUser)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$LocalState$w3_unsafe_decode_AdminDataStatus(
								$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$ToBackendLog$w3_unsafe_decode_ToBackendLogData)),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$LocalState$w3_unsafe_decode_AdminDataStatus(
									$lamdera$containers$SeqDict$decodeDict$(
										$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
										$author$project$LocalState$w3_unsafe_decode_AdminData_SlackWorkspace)),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeBool,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$LocalState$w3_unsafe_decode_AdminDataStatus(
												$lamdera$containers$SeqDict$decodeDict$(
													$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_DmChannelId),
													$author$project$LocalState$w3_unsafe_decode_AdminData_SlackDmChannel)),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeBool,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$author$project$LocalState$w3_unsafe_decode_AdminDataStatus(
														$lamdera$containers$SeqDict$decodeDict$($author$project$SessionIdHash$w3_unsafe_decode_SessionIdHash, $author$project$UserSession$w3_unsafe_decode_UserSession)),
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$author$project$LocalState$w3_unsafe_decode_ServerSecretStatus,
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$lamdera$codecs$Lamdera$Wire3$decodeList(
																$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeString, $lamdera$codecs$Lamdera$Wire3$decodeInt)),
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$author$project$LocalState$w3_unsafe_decode_PrivateVapidKey,
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$author$project$Postmark$w3_unsafe_decode_ApiKey,
																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																		$author$project$LocalState$w3_unsafe_decode_AdminDataStatus(
																			$lamdera$containers$SeqDict$decodeDict$($author$project$FileStatus$w3_unsafe_decode_FileHash, $author$project$FileStatus$w3_unsafe_decode_BackendFileData)),
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
																						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId)),
																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																						$author$project$Pagination$w3_unsafe_decode_Pagination($author$project$LocalState$w3_unsafe_decode_LogWithTime),
																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																							$lamdera$containers$SeqDict$decodeDict$(
																								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
																								$author$project$LocalState$w3_unsafe_decode_LoadingDiscordChannel($lamdera$codecs$Lamdera$Wire3$decodeInt)),
																							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$LocalState$w3_unsafe_decode_LastBackup),
																								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																									$author$project$LocalState$w3_unsafe_decode_AdminDataStatus(
																										$lamdera$containers$SeqDict$decodeDict$(
																											$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
																											$author$project$LocalState$w3_unsafe_decode_AdminData_Guild)),
																									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																										$lamdera$codecs$Lamdera$Wire3$decodeInt,
																										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																											$lamdera$codecs$Lamdera$Wire3$decodeBool,
																											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																												$author$project$LocalState$w3_unsafe_decode_AdminDataStatus(
																													$lamdera$containers$SeqDict$decodeDict$($author$project$DmChannelId$w3_unsafe_decode_DmChannelId, $author$project$LocalState$w3_unsafe_decode_AdminData_DmChannel)),
																												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																													$author$project$LocalState$w3_unsafe_decode_AdminDataStatus(
																														$lamdera$containers$SeqDict$decodeDict$(
																															$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
																															$author$project$LocalState$w3_unsafe_decode_DiscordUserData_ForAdmin)),
																													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																														$lamdera$codecs$Lamdera$Wire3$decodeBool,
																														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																															$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
																															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																$author$project$LocalState$w3_unsafe_decode_AdminDataStatus(
																																	$lamdera$containers$SeqDict$decodeDict$(
																																		$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
																																		$author$project$LocalState$w3_unsafe_decode_AdminData_DiscordGuild)),
																																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																	$author$project$LocalState$w3_unsafe_decode_AdminDataStatus(
																																		$lamdera$containers$SeqDict$decodeDict$(
																																			$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
																																			$author$project$LocalState$w3_unsafe_decode_AdminData_DiscordDmChannel)),
																																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																		$author$project$LocalState$w3_unsafe_decode_AdminDataStatus(
																																			$lamdera$containers$SeqDict$decodeDict$(
																																				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
																																				$author$project$LocalState$w3_unsafe_decode_AdminData_DeletedGuild)),
																																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																			$author$project$LocalState$w3_unsafe_decode_DeleteOrphanedFilesStatus,
																																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																				$lamdera$codecs$Lamdera$Wire3$decodeList(
																																					$lamdera$codecs$Lamdera$Wire3$decodePair$(
																																						$author$project$SessionIdHash$w3_unsafe_decode_SessionIdHash,
																																						$author$project$NonemptyDict$w3_unsafe_decode_NonemptyDict$($lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId, $author$project$LocalState$w3_unsafe_decode_ConnectionData))),
																																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																					$author$project$LocalState$w3_unsafe_decode_AdminDataStatus(
																																						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$BackendMsgLog$w3_unsafe_decode_BackendMsgLogData)),
																																					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																																						function (backendMsgLogs0) {
																																							return function (connections0) {
																																								return function (deleteOrphanedFiles0) {
																																									return function (deletedGuilds0) {
																																										return function (discordDmChannels0) {
																																											return function (discordGuilds0) {
																																												return function (discordLinkLimit0) {
																																													return function (discordLinkingEnabled0) {
																																														return function (discordUsers0) {
																																															return function (dmChannels0) {
																																																return function (emailNotificationsEnabled0) {
																																																	return function (filesCount0) {
																																																		return function (guilds0) {
																																																			return function (lastBackup0) {
																																																				return function (loadingDiscordChannels0) {
																																																					return function (logs0) {
																																																						return function (notifyAdminsBotUserId0) {
																																																							return function (notifyAdminsToken0) {
																																																								return function (openRouterKey0) {
																																																									return function (orphanedFiles0) {
																																																										return function (postmarkKey0) {
																																																											return function (privateVapidKey0) {
																																																												return function (seqDictWorks0) {
																																																													return function (serverSecretRefreshedAt0) {
																																																														return function (sessions0) {
																																																															return function (signupsEnabled0) {
																																																																return function (slackDmChannels0) {
																																																																	return function (slackLinkLimit0) {
																																																																		return function (slackLinkingEnabled0) {
																																																																			return function (slackWorkspaces0) {
																																																																				return function (toBackendLogs0) {
																																																																					return function (twoFactorAuthentication0) {
																																																																						return function (users0) {
																																																																							return function (vulnerabilityChecks0) {
																																																																								return function (websocketCloseEvents0) {
																																																																									return function (wordSpellingGameEnglish0) {
																																																																										return function (wordSpellingGameSwedish0) {
																																																																											return {backendMsgLogs: backendMsgLogs0, connections: connections0, deleteOrphanedFiles: deleteOrphanedFiles0, deletedGuilds: deletedGuilds0, discordDmChannels: discordDmChannels0, discordGuilds: discordGuilds0, discordLinkLimit: discordLinkLimit0, discordLinkingEnabled: discordLinkingEnabled0, discordUsers: discordUsers0, dmChannels: dmChannels0, emailNotificationsEnabled: emailNotificationsEnabled0, filesCount: filesCount0, guilds: guilds0, lastBackup: lastBackup0, loadingDiscordChannels: loadingDiscordChannels0, logs: logs0, notifyAdminsBotUserId: notifyAdminsBotUserId0, notifyAdminsToken: notifyAdminsToken0, openRouterKey: openRouterKey0, orphanedFiles: orphanedFiles0, postmarkKey: postmarkKey0, privateVapidKey: privateVapidKey0, seqDictWorks: seqDictWorks0, serverSecretRefreshedAt: serverSecretRefreshedAt0, sessions: sessions0, signupsEnabled: signupsEnabled0, slackDmChannels: slackDmChannels0, slackLinkLimit: slackLinkLimit0, slackLinkingEnabled: slackLinkingEnabled0, slackWorkspaces: slackWorkspaces0, toBackendLogs: toBackendLogs0, twoFactorAuthentication: twoFactorAuthentication0, users: users0, vulnerabilityChecks: vulnerabilityChecks0, websocketCloseEvents: websocketCloseEvents0, wordSpellingGameEnglish: wordSpellingGameEnglish0, wordSpellingGameSwedish: wordSpellingGameSwedish0};
																																																																										};
																																																																									};
																																																																								};
																																																																							};
																																																																						};
																																																																					};
																																																																				};
																																																																			};
																																																																		};
																																																																	};
																																																																};
																																																															};
																																																														};
																																																													};
																																																												};
																																																											};
																																																										};
																																																									};
																																																								};
																																																							};
																																																						};
																																																					};
																																																				};
																																																			};
																																																		};
																																																	};
																																																};
																																															};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						}))))))))))))))))))))))))))))))))))))));
var $author$project$LocalState$w3_unsafe_decode_AdminStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$LocalState$w3_unsafe_decode_AdminData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$IsAdmin));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$IsAdminButDataNotLoaded);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LocalState$IsNotAdmin);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$DmChannel$w3_unsafe_decode_E2eeEnabledData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodePair$(
		$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
		$author$project$SessionIdHash$w3_unsafe_decode_SessionIdHash),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (enabledAt0, requestedBy0) {
					return {enabledAt: enabledAt0, requestedBy: requestedBy0};
				}))));
var $author$project$DmChannel$w3_unsafe_decode_E2eeStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$DmChannel$E2eeDeclinedBy));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$lamdera$codecs$Lamdera$Wire3$decodePair$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$DmChannel$E2eeDisabled));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$DmChannel$w3_unsafe_decode_E2eeEnabledData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$DmChannel$E2eeEnabled));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
						$author$project$SessionIdHash$w3_unsafe_decode_SessionIdHash),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$DmChannel$E2eeRequestedBy));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$DmChannel$w3_unsafe_decode_FrontendDmChannel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$VisibleMessages$w3_unsafe_decode_VisibleMessages($author$project$Id$w3_unsafe_decode_ChannelMessageId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
			$author$project$Thread$w3_unsafe_decode_FrontendThread),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$MessageArray$w3_unsafe_decode_MessageArray$(
				$author$project$Id$w3_unsafe_decode_ChannelMessageId,
				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_ThreadRouteWithMaybeMessage,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (threadRoute0, time0) {
										return {threadRoute: threadRoute0, time: time0};
									}))))),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$author$project$Game$w3_unsafe_decode_MatchData),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$DmChannel$w3_unsafe_decode_E2eeStatus,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqDict$decodeDict$(
								$justinmimbs$date$Date$w3_unsafe_decode_Date,
								$author$project$Drawing$w3_unsafe_decode_Drawing(
									$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId))),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F7(
									function (dateDividerDrawings0, e2ee0, games0, lastTypedAt0, messages0, threads0, visibleMessages0) {
										return {dateDividerDrawings: dateDividerDrawings0, e2ee: e2ee0, games: games0, lastTypedAt: lastTypedAt0, messages: messages0, threads: threads0, visibleMessages: visibleMessages0};
									})))))))));
var $author$project$Call$w3_unsafe_decode_Local = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Call$w3_unsafe_decode_CallId,
		$author$project$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
			$lamdera$codecs$Lamdera$Wire3$decodePair$(
				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
				$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId),
			$author$project$Call$w3_unsafe_decode_RemoteCallData)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$($author$project$Call$w3_unsafe_decode_CallId, $author$project$Call$w3_unsafe_decode_RecordingStatus),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Call$w3_unsafe_decode_CallId),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (currentRoom0, recordings0, voiceChats0) {
						return {currentRoom: currentRoom0, recordings: recordings0, voiceChats: voiceChats0};
					})))));
var $author$project$TextEditor$w3_unsafe_decode_LocalState = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
		$lamdera$codecs$Lamdera$Wire3$decodeInt),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeArray(
			$lamdera$codecs$Lamdera$Wire3$decodePair$(
				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
				$author$project$TextEditor$w3_unsafe_decode_EditChange)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
				$author$project$Range$w3_unsafe_decode_Range),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (cursorPosition0, history0, undoPoint0) {
						return {cursorPosition: cursorPosition0, history: history0, undoPoint: undoPoint0};
					})))));
var $author$project$User$w3_unsafe_decode_FrontendCurrentUser = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqSet$decodeSet(
		$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
			$author$project$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
				$lamdera$codecs$Lamdera$Wire3$decodePair$(
					$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId),
					$author$project$Id$w3_unsafe_decode_ThreadRoute),
				$author$project$OneOrGreater$w3_unsafe_decode_OneOrGreater)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$X25519$w3_unsafe_decode_PublicKey),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqSet$decodeSet(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$PersonName$w3_unsafe_decode_PersonName,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$MuteSettings$w3_unsafe_decode_Model,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeBool,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeBool,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$containers$SeqDict$decodeDict$(
											$lamdera$codecs$Lamdera$Wire3$decodePair$(
												$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
												$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId)),
											$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ThreadMessageId)),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$containers$SeqDict$decodeDict$(
												$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
												$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId)),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$containers$SeqDict$decodeDict$(
													$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
													$lamdera$codecs$Lamdera$Wire3$decodePair$(
														$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId),
														$author$project$Id$w3_unsafe_decode_ThreadRoute)),
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$author$project$Id$w3_unsafe_decode_Id($author$project$Pagination$w3_unsafe_decode_PageId),
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$author$project$User$w3_unsafe_decode_LastDmViewed,
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$lamdera$containers$SeqDict$decodeDict$(
																		$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
																		$lamdera$codecs$Lamdera$Wire3$decodePair$(
																			$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
																			$author$project$Id$w3_unsafe_decode_ThreadRoute)),
																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																		$lamdera$containers$SeqDict$decodeDict$(
																			$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
																			$lamdera$codecs$Lamdera$Wire3$decodePair$(
																				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
																				$author$project$Id$w3_unsafe_decode_ThreadRoute)),
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$codecs$Lamdera$Wire3$decodeBool,
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$FileStatus$w3_unsafe_decode_FileHash),
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$author$project$Emoji$w3_unsafe_decode_EmojiConfig,
																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																						$author$project$User$w3_unsafe_decode_EmbedVisibility,
																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																							$author$project$User$w3_unsafe_decode_EmailNotifications,
																							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																								$author$project$EmailAddress$w3_unsafe_decode_EmailAddress,
																								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																									$lamdera$codecs$Lamdera$Wire3$decodeBool,
																									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																										$lamdera$containers$SeqSet$decodeSet($author$project$RichText$w3_unsafe_decode_Domain),
																										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																											$lamdera$containers$SeqSet$decodeSet(
																												$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId)),
																											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																												$lamdera$containers$SeqDict$decodeDict$(
																													$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
																													$author$project$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
																														$lamdera$codecs$Lamdera$Wire3$decodePair$(
																															$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
																															$author$project$Id$w3_unsafe_decode_ThreadRoute),
																														$author$project$OneOrGreater$w3_unsafe_decode_OneOrGreater)),
																												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																													$lamdera$containers$SeqDict$decodeDict$(
																														$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
																														$author$project$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
																															$lamdera$codecs$Lamdera$Wire3$decodePair$(
																																$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
																																$author$project$Id$w3_unsafe_decode_ThreadRoute),
																															$author$project$OneOrGreater$w3_unsafe_decode_OneOrGreater)),
																													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																														$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
																														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																															$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
																															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																$author$project$UserColor$w3_unsafe_decode_UserColor,
																																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																	$lamdera$containers$SeqSet$decodeSet(
																																		$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_StickerId)),
																																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																		$lamdera$containers$SeqSet$decodeSet(
																																			$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_CustomEmojiId)),
																																		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																																			function (availableCustomEmojis0) {
																																				return function (availableStickers0) {
																																					return function (color0) {
																																						return function (createdAt0) {
																																							return function (deleteAccountAt0) {
																																								return function (directMentions0) {
																																									return function (discordDirectMentions0) {
																																										return function (discordNotifyOnAllMessages0) {
																																											return function (domainWhitelist0) {
																																												return function (e2eeRisksAccepted0) {
																																													return function (email0) {
																																														return function (emailNotifications0) {
																																															return function (embedVisibility0) {
																																																return function (emojiConfig0) {
																																																	return function (icon0) {
																																																		return function (isAdmin0) {
																																																			return function (lastChannelViewed0) {
																																																				return function (lastDiscordChannelViewed0) {
																																																					return function (lastDmViewed0) {
																																																						return function (lastEmailNotification0) {
																																																							return function (lastLogPageViewed0) {
																																																								return function (lastPushNotification0) {
																																																									return function (lastSlackChannelViewed0) {
																																																										return function (lastViewedMessage0) {
																																																											return function (lastViewedThreadMessage0) {
																																																												return function (linkDiscordAcknowledgementIsChecked0) {
																																																													return function (linkSlackAcknowledgementIsChecked0) {
																																																														return function (muteSettings0) {
																																																															return function (name0) {
																																																																return function (notifyOnAllMessages0) {
																																																																	return function (publicKey0) {
																																																																		return function (recentLoginEmails0) {
																																																																			return function (slackDirectMentions0) {
																																																																				return function (slackNotifyOnAllMessages0) {
																																																																					return {availableCustomEmojis: availableCustomEmojis0, availableStickers: availableStickers0, color: color0, createdAt: createdAt0, deleteAccountAt: deleteAccountAt0, directMentions: directMentions0, discordDirectMentions: discordDirectMentions0, discordNotifyOnAllMessages: discordNotifyOnAllMessages0, domainWhitelist: domainWhitelist0, e2eeRisksAccepted: e2eeRisksAccepted0, email: email0, emailNotifications: emailNotifications0, embedVisibility: embedVisibility0, emojiConfig: emojiConfig0, icon: icon0, isAdmin: isAdmin0, lastChannelViewed: lastChannelViewed0, lastDiscordChannelViewed: lastDiscordChannelViewed0, lastDmViewed: lastDmViewed0, lastEmailNotification: lastEmailNotification0, lastLogPageViewed: lastLogPageViewed0, lastPushNotification: lastPushNotification0, lastSlackChannelViewed: lastSlackChannelViewed0, lastViewedMessage: lastViewedMessage0, lastViewedThreadMessage: lastViewedThreadMessage0, linkDiscordAcknowledgementIsChecked: linkDiscordAcknowledgementIsChecked0, linkSlackAcknowledgementIsChecked: linkSlackAcknowledgementIsChecked0, muteSettings: muteSettings0, name: name0, notifyOnAllMessages: notifyOnAllMessages0, publicKey: publicKey0, recentLoginEmails: recentLoginEmails0, slackDirectMentions: slackDirectMentions0, slackNotifyOnAllMessages: slackNotifyOnAllMessages0};
																																																																				};
																																																																			};
																																																																		};
																																																																	};
																																																																};
																																																															};
																																																														};
																																																													};
																																																												};
																																																											};
																																																										};
																																																									};
																																																								};
																																																							};
																																																						};
																																																					};
																																																				};
																																																			};
																																																		};
																																																	};
																																																};
																																															};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			})))))))))))))))))))))))))))))))))));
var $author$project$LinkedAndOtherDiscordUsers$w3_unsafe_decode_LinkedAndOtherDiscordUsers = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
					$author$project$LinkedAndOtherDiscordUsers$w3_unsafe_decode_DiscordFrontendCurrentUser),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
						$author$project$UserSession$w3_unsafe_decode_DiscordFrontendUser),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LinkedAndOtherDiscordUsers$LinkedAndOtherDiscordUsers)));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$User$w3_unsafe_decode_LocalUser = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$UserAgent$w3_unsafe_decode_UserAgent,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$User$w3_unsafe_decode_FrontendCurrentUser,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$program_test$Effect$Time$w3_unsafe_decode_Zone,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqDict$decodeDict$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_StickerId),
					$author$project$Sticker$w3_unsafe_decode_StickerData),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqSet$decodeSet(
						$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
							$author$project$UserSession$w3_unsafe_decode_SlackFrontendUser),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$UserSession$w3_unsafe_decode_UserSession,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeInt,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$containers$SeqDict$decodeDict$(
											$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
											$author$project$User$w3_unsafe_decode_FrontendUser),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$containers$SeqDict$decodeDict$(
												$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
												$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId)),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Emoji$w3_unsafe_decode_CachedEmojiData),
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$author$project$LinkedAndOtherDiscordUsers$w3_unsafe_decode_LinkedAndOtherDiscordUsers,
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$lamdera$codecs$Lamdera$Wire3$decodeFloat,
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$lamdera$containers$SeqDict$decodeDict$(
																$author$project$Encryption$w3_unsafe_decode_BytesHash,
																$lamdera$codecs$Lamdera$Wire3$decodeResult$(
																	$lamdera$codecs$Lamdera$Wire3$decodeUnit,
																	$author$project$Message$w3_unsafe_decode_MessageContent$(
																		$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
																		$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId)))),
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$lamdera$containers$SeqDict$decodeDict$(
																	$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_CustomEmojiId),
																	$author$project$CustomEmoji$w3_unsafe_decode_CustomEmojiData),
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$author$project$UserSession$w3_unsafe_decode_Viewing,
																	$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																		function (currentlyViewing0) {
																			return function (customEmojis0) {
																				return function (decryptedMessages0) {
																					return function (devicePixelRatio0) {
																						return function (discordUsers0) {
																							return function (emojiData0) {
																								return function (linkedSlackUsers0) {
																									return function (otherUsers0) {
																										return function (safeAreaInsetBottom0) {
																											return function (safeAreaInsetTop0) {
																												return function (session0) {
																													return function (slackUsers0) {
																														return function (slackUsersNeedingAuth0) {
																															return function (stickers0) {
																																return function (timezone0) {
																																	return function (user0) {
																																		return function (userAgent0) {
																																			return {currentlyViewing: currentlyViewing0, customEmojis: customEmojis0, decryptedMessages: decryptedMessages0, devicePixelRatio: devicePixelRatio0, discordUsers: discordUsers0, emojiData: emojiData0, linkedSlackUsers: linkedSlackUsers0, otherUsers: otherUsers0, safeAreaInsetBottom: safeAreaInsetBottom0, safeAreaInsetTop: safeAreaInsetTop0, session: session0, slackUsers: slackUsers0, slackUsersNeedingAuth: slackUsersNeedingAuth0, stickers: stickers0, timezone: timezone0, user: user0, userAgent: userAgent0};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		}))))))))))))))))));
var $author$project$LocalState$w3_unsafe_decode_LocalState = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$TextEditor$w3_unsafe_decode_LocalState,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
			$author$project$LocalState$w3_unsafe_decode_SlackFrontendWorkspace),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$(
				$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_DmChannelId),
				$author$project$LocalState$w3_unsafe_decode_SlackFrontendDmChannel),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$($author$project$SessionIdHash$w3_unsafe_decode_SessionIdHash, $author$project$UserSession$w3_unsafe_decode_FrontendUserSession),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$User$w3_unsafe_decode_LocalUser,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$LocalState$w3_unsafe_decode_JoinGuildError),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqDict$decodeDict$(
									$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
									$author$project$LocalState$w3_unsafe_decode_FrontendGuild),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$containers$SeqDict$decodeDict$(
										$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
										$author$project$DmChannel$w3_unsafe_decode_FrontendDmChannel),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$containers$SeqDict$decodeDict$(
											$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
											$author$project$LocalState$w3_unsafe_decode_DiscordFrontendGuild),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$containers$SeqDict$decodeDict$(
												$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
												$author$project$DmChannel$w3_unsafe_decode_DiscordFrontendDmChannel),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$author$project$Call$w3_unsafe_decode_Local,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$author$project$LocalState$w3_unsafe_decode_AdminStatus,
													$lamdera$codecs$Lamdera$Wire3$succeedDecode(
														function (adminData0) {
															return function (calls0) {
																return function (discordDmChannels0) {
																	return function (discordGuilds0) {
																		return function (dmChannels0) {
																			return function (guilds0) {
																				return function (joinGuildError0) {
																					return function (localUser0) {
																						return function (otherSessions0) {
																							return function (publicVapidKey0) {
																								return function (slackDmChannels0) {
																									return function (slackWorkspaces0) {
																										return function (textEditor0) {
																											return {adminData: adminData0, calls: calls0, discordDmChannels: discordDmChannels0, discordGuilds: discordGuilds0, dmChannels: dmChannels0, guilds: guilds0, joinGuildError: joinGuildError0, localUser: localUser0, otherSessions: otherSessions0, publicVapidKey: publicVapidKey0, slackDmChannels: slackDmChannels0, slackWorkspaces: slackWorkspaces0, textEditor: textEditor0};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														}))))))))))))));
var $author$project$Types$w3_unsafe_decode_MessageHoverMobileMode = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Types$w3_unsafe_decode_EditMessage),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$ianmackenzie$elm_units$Quantity$w3_unsafe_decode_Quantity$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $author$project$CssPixels$w3_unsafe_decode_CssPixels),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$MessageMenuClosing)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$ianmackenzie$elm_units$Quantity$w3_unsafe_decode_Quantity$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $author$project$CssPixels$w3_unsafe_decode_CssPixels),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$ianmackenzie$elm_units$Quantity$w3_unsafe_decode_Quantity$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $author$project$CssPixels$w3_unsafe_decode_CssPixels),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (offset0, previousOffset0, time0) {
											return {offset: offset0, previousOffset: previousOffset0, time: time0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$MessageMenuDragging));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$ianmackenzie$elm_units$Quantity$w3_unsafe_decode_Quantity$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $author$project$CssPixels$w3_unsafe_decode_CssPixels),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$MessageMenuFixed));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$ianmackenzie$elm_units$Quantity$w3_unsafe_decode_Quantity$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $author$project$CssPixels$w3_unsafe_decode_CssPixels),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$ianmackenzie$elm_units$Quantity$w3_unsafe_decode_Quantity$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $author$project$CssPixels$w3_unsafe_decode_CssPixels),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (offset0, targetOffset0) {
										return {offset: offset0, targetOffset: targetOffset0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$MessageMenuOpening));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Types$w3_unsafe_decode_MessageMenuExtraOptions = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Coord$w3_unsafe_decode_Coord($author$project$CssPixels$w3_unsafe_decode_CssPixels),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Types$w3_unsafe_decode_MessageHoverMobileMode,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F7(
									function (guildOrDmId0, imageUrl0, isThreadStarter0, linkUrl0, mobileMode0, position0, threadRoute0) {
										return {guildOrDmId: guildOrDmId0, imageUrl: imageUrl0, isThreadStarter: isThreadStarter0, linkUrl: linkUrl0, mobileMode: mobileMode0, position: position0, threadRoute: threadRoute0};
									})))))))));
var $author$project$Types$w3_unsafe_decode_MessageHover = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$MessageHover)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Types$w3_unsafe_decode_MessageMenuExtraOptions,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$MessageMenu));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$NoMessageHover);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$ReactionPopup))));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Call$w3_unsafe_decode_DebugRow = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (label0, value0) {
					return {label: label0, value: value0};
				}))));
var $author$project$Call$w3_unsafe_decode_DebugSection = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Call$w3_unsafe_decode_DebugRow),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (rows0, title0) {
					return {rows: rows0, title: title0};
				}))));
var $author$project$IdString$w3_unsafe_decode_IdString = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Call$w3_unsafe_decode_LocalOrConnection = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Call$w3_unsafe_decode_ConnectionId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$IsConnection));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$IsLocal);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Call$MediaDeviceId = $elm$core$Basics$identity;
var $author$project$Call$w3_unsafe_decode_MediaDeviceId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Call$w3_unsafe_decode_DeviceKind = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Call$w3_unsafe_decode_MediaDevice = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Call$w3_unsafe_decode_DeviceKind,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$IdString$w3_unsafe_decode_IdString($author$project$Call$w3_unsafe_decode_MediaDeviceId),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (deviceId0, groupId0, kind0, label0) {
							return {deviceId: deviceId0, groupId: groupId0, kind: kind0, label: label0};
						}))))));
var $author$project$Call$w3_unsafe_decode_MediaDevicesStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$FailedToGetMediaDevices));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Call$w3_unsafe_decode_MediaDevice),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$HasMediaDevices));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$MediaDevicesNotLoaded);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Call$w3_unsafe_decode_VideoTile = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Call$w3_unsafe_decode_LocalOrConnection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$CameraTile));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Call$w3_unsafe_decode_LocalOrConnection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$ScreenShareTile));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Call$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$lamdera$codecs$Lamdera$Wire3$decodePair$(
			$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
			$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId),
		$lamdera$codecs$Lamdera$Wire3$decodeFloat),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Call$w3_unsafe_decode_LocalOrConnection),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Call$w3_unsafe_decode_MediaDevicesStatus,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $lamdera$codecs$Lamdera$Wire3$decodeFloat),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
								$author$project$IdString$w3_unsafe_decode_IdString($author$project$Call$w3_unsafe_decode_MediaDeviceId)),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
									$author$project$IdString$w3_unsafe_decode_IdString($author$project$Call$w3_unsafe_decode_MediaDeviceId)),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Call$w3_unsafe_decode_RemoteCallData,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeInt,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$codecs$Lamdera$Wire3$decodeInt,
													$lamdera$codecs$Lamdera$Wire3$succeedDecode(
														F2(
															function (total0, uploaded0) {
																return {total: total0, uploaded: uploaded0};
															}))))),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeBool,
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeBool,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$containers$SeqSet$decodeSet($author$project$Call$w3_unsafe_decode_ConnectionId),
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Call$w3_unsafe_decode_VideoTile),
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Call$w3_unsafe_decode_DebugSection),
															$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																function (debugData0) {
																	return function (focusedTile0) {
																		return function (isSpeaking0) {
																			return function (localIsSpeaking0) {
																				return function (pollDebugData0) {
																					return function (recordingUpload0) {
																						return function (remoteCallData0) {
																							return function (selectedAudioInputDevice0) {
																								return function (selectedVideoInputDevice0) {
																									return function (showDeviceSettings0) {
																										return function (startConnectionError0) {
																											return function (thumbnailPosition0) {
																												return function (userMediaDevices0) {
																													return function (videoHover0) {
																														return function (volume0) {
																															return {debugData: debugData0, focusedTile: focusedTile0, isSpeaking: isSpeaking0, localIsSpeaking: localIsSpeaking0, pollDebugData: pollDebugData0, recordingUpload: recordingUpload0, remoteCallData: remoteCallData0, selectedAudioInputDevice: selectedAudioInputDevice0, selectedVideoInputDevice: selectedVideoInputDevice0, showDeviceSettings: showDeviceSettings0, startConnectionError: startConnectionError0, thumbnailPosition: thumbnailPosition0, userMediaDevices: userMediaDevices0, videoHover: videoHover0, volume: volume0};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																}))))))))))))))));
var $author$project$Drawing$w3_unsafe_decode_ActiveStroke = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeList(
		$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$SafeFloat$w3_unsafe_decode_SafeFloat, $author$project$SafeFloat$w3_unsafe_decode_SafeFloat)),
	$lamdera$codecs$Lamdera$Wire3$succeedDecode(
		function (unsent0) {
			return {unsent: unsent0};
		}));
var $author$project$Drawing$w3_unsafe_decode_SelectedAnchorData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeFloat,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeFloat,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F4(
								function (height0, width0, x0, y0) {
									return {height: height0, width: width0, x: x0, y: y0};
								}))))))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeFloat,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Drawing$w3_unsafe_decode_ActiveStroke),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Point2d$w3_unsafe_decode_Point2d$($author$project$CssPixels$w3_unsafe_decode_CssPixels, $author$project$Touch$w3_unsafe_decode_ScreenCoordinate),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Drawing$w3_unsafe_decode_AnchorType,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $lamdera$codecs$Lamdera$Wire3$decodeFloat),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F8(
										function (anchorHalfSize0, anchorType0, guildOrDmId0, pointScale0, position0, stroke0, zoom0, zoomContainer0) {
											return {anchorHalfSize: anchorHalfSize0, anchorType: anchorType0, guildOrDmId: guildOrDmId0, pointScale: pointScale0, position: position0, stroke: stroke0, zoom: zoom0, zoomContainer: zoomContainer0};
										}))))))))));
var $author$project$Drawing$w3_unsafe_decode_Model = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Drawing$NoSelectedAnchor);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Drawing$w3_unsafe_decode_SelectedAnchorData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Drawing$SelectedAnchor));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Emoji$w3_unsafe_decode_Category = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Emoji$CustomEmojiCategory);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Emoji$w3_unsafe_decode_EmojiCategory,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Emoji$EmojiCategory));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Emoji$StickerCategory);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Emoji$w3_unsafe_decode_EmojiOrSticker = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_CustomEmojiId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Emoji$EmojiOrSticker_CustomEmoji));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_StickerId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Emoji$EmojiOrSticker_Sticker));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Emoji$w3_unsafe_decode_UnicodeEmoji,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Emoji$EmojiOrSticker_UnicodeEmoji));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Emoji$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Emoji$w3_unsafe_decode_EmojiOrSticker,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F2(
							function (emoji0, index0) {
								return {emoji: emoji0, index: index0};
							}))))),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Emoji$w3_unsafe_decode_Category,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (category0, emojiHovered0, searchText0) {
						return {category: category0, emojiHovered: emojiHovered0, searchText: searchText0};
					})))));
var $author$project$Scroll$w3_unsafe_decode_ScrollPosition = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$SheepGame$w3_unsafe_decode_UnvalidatedInput = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
			$author$project$FileStatus$w3_unsafe_decode_FileStatus),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (attachedFiles0, text0) {
					return {attachedFiles: attachedFiles0, text: text0};
				}))));
var $author$project$SheepGame$w3_unsafe_decode_GameData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Scroll$w3_unsafe_decode_ScrollPosition,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$IdArray$w3_unsafe_decode_IdArray$($author$project$Id$w3_unsafe_decode_QuestionId, $author$project$SheepGame$w3_unsafe_decode_UnvalidatedInput),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeBool,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$SheepGame$w3_unsafe_decode_ReactionTarget),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
								$lamdera$codecs$Lamdera$Wire3$decodePair$(
									$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
									$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId))),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$IdArray$w3_unsafe_decode_IdArray$($author$project$Id$w3_unsafe_decode_QuestionId, $author$project$SheepGame$w3_unsafe_decode_UnvalidatedInput),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F8(
										function (answerDrafts0, gridHovered0, hoveredQuestion0, hoveredResult0, newQuestionRevealed0, noteDrafts0, questionsRevealedSeen0, scrollPosition0) {
											return {answerDrafts: answerDrafts0, gridHovered: gridHovered0, hoveredQuestion: hoveredQuestion0, hoveredResult: hoveredResult0, newQuestionRevealed: newQuestionRevealed0, noteDrafts: noteDrafts0, questionsRevealedSeen: questionsRevealedSeen0, scrollPosition: scrollPosition0};
										}))))))))));
var $author$project$WordSpellingGame$w3_unsafe_decode_Drag = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$Dragging));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$NotDragging);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$WordSpellingGame$w3_unsafe_decode_HoveredMove = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$WordSpellingGame$w3_unsafe_decode_Shared,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeDict$(
				$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
				$author$project$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (cells0, index0, shared0) {
						return {cells: cells0, index: index0, shared: shared0};
					})))));
var $author$project$WordSpellingGame$w3_unsafe_decode_TrayIndex = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$WordSpellingGame$w3_unsafe_decode_TilePosition = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix, $lamdera$codecs$Lamdera$Wire3$decodeInt)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$WordSpellingGame$w3_unsafe_decode_TrayIndex,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$TileInTray)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$TileOnBoard)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$WordSpellingGame$w3_unsafe_decode_Tile = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$WordSpellingGame$w3_unsafe_decode_TilePosition,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (createdAt0, position0) {
					return {createdAt: createdAt0, position: position0};
				}))));
var $author$project$WordSpellingGame$w3_unsafe_decode_OpenWordDefinition = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty($lamdera$codecs$Lamdera$Wire3$decodeString),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (index0, words0) {
					return {index: index0, words: words0};
				}))));
var $author$project$WordSpellingGame$w3_unsafe_decode_DictEntry = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeString),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (definitions0, partOfSpeech0) {
					return {definitions: definitions0, partOfSpeech: partOfSpeech0};
				}))));
var $author$project$WordSpellingGame$w3_unsafe_decode_WordDefinitionData = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$WordDefinition_Failed);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$WordSpellingGame$w3_unsafe_decode_DictEntry),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$WordDefinition_Loaded));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$WordDefinition_Loading);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$WordDefinition_NotFound);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$WordDefinition_SwedishUnsupported);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$WordSpellingGame$w3_unsafe_decode_WordDefinition = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$WordDefinition_None);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$WordSpellingGame$w3_unsafe_decode_WordDefinitionData,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$WordSpellingGame$w3_unsafe_decode_OpenWordDefinition,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$WordDefinition_Open)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$WordSpellingGame$w3_unsafe_decode_ZoomState = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeFloat,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeFloat,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeFloat,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (amount0, focusX0, focusY0) {
						return {amount: amount0, focusX: focusX0, focusY: focusY0};
					})))));
var $author$project$WordSpellingGame$w3_unsafe_decode_ZoomAnimation = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$WordSpellingGame$w3_unsafe_decode_ZoomState,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (from0, start0) {
					return {from: from0, start: start0};
				}))));
var $author$project$WordSpellingGame$w3_unsafe_decode_GameData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$WordSpellingGame$w3_unsafe_decode_ZoomAnimation,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$WordSpellingGame$w3_unsafe_decode_WordDefinition,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$WordSpellingGame$w3_unsafe_decode_Tile),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeBool,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Scroll$w3_unsafe_decode_ScrollPosition,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeInt,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											F2(
												function (letterCount0, time0) {
													return {letterCount: letterCount0, time: time0};
												}))))),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$WordSpellingGame$w3_unsafe_decode_HoveredMove),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
										$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId)),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$WordSpellingGame$w3_unsafe_decode_Drag,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											function (dragging0) {
												return function (highlightedPlayer0) {
													return function (hoveredMove0) {
														return function (lastWordPlaced0) {
															return function (scrollPosition0) {
																return function (selectedCell0) {
																	return function (showSettings0) {
																		return function (tiles0) {
																			return function (wordDefinition0) {
																				return function (zoomAnimation0) {
																					return {dragging: dragging0, highlightedPlayer: highlightedPlayer0, hoveredMove: hoveredMove0, lastWordPlaced: lastWordPlaced0, scrollPosition: scrollPosition0, selectedCell: selectedCell0, showSettings: showSettings0, tiles: tiles0, wordDefinition: wordDefinition0, zoomAnimation: zoomAnimation0};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											})))))))))));
var $author$project$Go$w3_unsafe_decode_GameModel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (lastError0, lastPlacedStone0, viewingMovesBack0) {
						return {lastError: lastError0, lastPlacedStone: lastPlacedStone0, viewingMovesBack: viewingMovesBack0};
					})))));
var $author$project$Game$w3_unsafe_decode_Game = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Go$w3_unsafe_decode_GameModel,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$GoModel_Game));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$SheepGame$w3_unsafe_decode_GameData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$SheepGame_Game));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$WordSpellingGame$w3_unsafe_decode_GameData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$WordSpellingGame_Game));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Go$w3_unsafe_decode_SizeSelection = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Go$w3_unsafe_decode_SetupModel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Go$w3_unsafe_decode_SizeSelection,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeString,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Go$w3_unsafe_decode_Stone,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F9(
											function (error0, gameCreatorPlayingAs0, handicapInput0, heightInput0, incrementInput0, komiInput0, mainTimeInput0, sizeSelection0, widthInput0) {
												return {error: error0, gameCreatorPlayingAs: gameCreatorPlayingAs0, handicapInput: handicapInput0, heightInput: heightInput0, incrementInput: incrementInput0, komiInput: komiInput0, mainTimeInput: mainTimeInput0, sizeSelection: sizeSelection0, widthInput: widthInput0};
											})))))))))));
var $author$project$SheepGame$w3_unsafe_decode_SetupModel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$IdArray$w3_unsafe_decode_IdArray$($author$project$Id$w3_unsafe_decode_QuestionId, $author$project$SheepGame$w3_unsafe_decode_UnvalidatedInput),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (error0, pressedSubmit0, questions0) {
						return {error: error0, pressedSubmit: pressedSubmit0, questions: questions0};
					})))));
var $author$project$WordSpellingGame$w3_unsafe_decode_SetupModel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$OneOrGreater$w3_unsafe_decode_OneOrGreater,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$($lamdera$codecs$Lamdera$Wire3$decodeChar, $lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$WordSpellingGame$w3_unsafe_decode_Language,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeString,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeBool,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											function (advancedSettingsExpanded0) {
												return function (error0) {
													return function (fullTrayBonus0) {
														return function (incrementInput0) {
															return function (language0) {
																return function (letterValues0) {
																	return function (letters0) {
																		return function (mainTimeInput0) {
																			return function (placeWordAttempts0) {
																				return function (traySize0) {
																					return {advancedSettingsExpanded: advancedSettingsExpanded0, error: error0, fullTrayBonus: fullTrayBonus0, incrementInput: incrementInput0, language: language0, letterValues: letterValues0, letters: letters0, mainTimeInput: mainTimeInput0, placeWordAttempts: placeWordAttempts0, traySize: traySize0};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											})))))))))));
var $author$project$Game$w3_unsafe_decode_Setup = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$GameSelect);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Go$w3_unsafe_decode_SetupModel,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$GoModel_Setup));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$SheepGame$w3_unsafe_decode_SetupModel,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$SheepGame_Setup));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$WordSpellingGame$w3_unsafe_decode_SetupModel,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$WordSpellingGame_Setup));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Game$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
		$author$project$Game$w3_unsafe_decode_Game),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$lamdera$codecs$Lamdera$Wire3$decodePair$(
				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
				$author$project$SheepGame$w3_unsafe_decode_Input),
			$lamdera$codecs$Lamdera$Wire3$decodeInt),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Game$w3_unsafe_decode_Setup,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (setup0, sheepGameQuestionsCounter0, sheepGameSaveCounters0, startedGames0) {
							return {setup: setup0, sheepGameQuestionsCounter: sheepGameQuestionsCounter0, sheepGameSaveCounters: sheepGameSaveCounters0, startedGames: startedGames0};
						}))))));
var $author$project$ImageEditor$w3_unsafe_decode_DragPart = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$ImageEditor$w3_unsafe_decode_DragState = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeFloat,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeFloat,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$ImageEditor$w3_unsafe_decode_DragPart,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeFloat,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (currentX0, currentY0, dragPart0, startX0, startY0) {
								return {currentX: currentX0, currentY: currentY0, dragPart: dragPart0, startX: startX0, startY: startY0};
							})))))));
var $author$project$ImageEditor$w3_unsafe_decode_UploadStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageEditor$Cropping);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageEditor$NotUploaded);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$FileStatus$w3_unsafe_decode_FileHash,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageEditor$Uploading));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageEditor$UploadingError);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$ImageEditor$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeFloat,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeFloat,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$ImageEditor$w3_unsafe_decode_UploadStatus,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeFloat,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$ImageEditor$w3_unsafe_decode_DragState),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F7(
									function (dragState0, imageSize0, imageUrl0, size0, status0, x0, y0) {
										return {dragState: dragState0, imageSize: imageSize0, imageUrl: imageUrl0, size: size0, status: status0, x: x0, y: y0};
									})))))))));
var $author$project$Pages$Admin$w3_unsafe_decode_AdminUiSection = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(10);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(12);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(9);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(11);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(13);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(8);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(17);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(7);
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(6);
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(15);
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(14);
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(16);
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(18);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Pages$Admin$w3_unsafe_decode_DownloadingBackup = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeBytes),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (chunks0, receivedBytes0, totalBytes0) {
						return {chunks: chunks0, receivedBytes: receivedBytes0, totalBytes: totalBytes0};
					})))));
var $author$project$Pages$Admin$ExportingDiscordDmChannels = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$ExportingDiscordGuilds = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$ExportingDmChannels = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$ExportingGuilds = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$w3_unsafe_decode_ExportProgress = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ExportStarting);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (encoded0, total0) {
										return {encoded: encoded0, total: total0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ExportingDiscordDmChannels));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (channelsRemaining0, encoded0, total0) {
											return {channelsRemaining: channelsRemaining0, encoded: encoded0, total: total0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ExportingDiscordGuilds));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (encoded0, total0) {
										return {encoded: encoded0, total: total0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ExportingDmChannels));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (channelsRemaining0, encoded0, total0) {
											return {channelsRemaining: channelsRemaining0, encoded: encoded0, total: total0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ExportingGuilds));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Pages$Admin$w3_unsafe_decode_ExportSubsetSelection = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqSet$decodeSet(
		$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqSet$decodeSet($author$project$DmChannelId$w3_unsafe_decode_DmChannelId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqSet$decodeSet(
				$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqSet$decodeSet(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId)),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (discordDmChannels0, discordGuilds0, dmChannels0, guilds0) {
							return {discordDmChannels: discordDmChannels0, discordGuilds: discordGuilds0, dmChannels: dmChannels0, guilds: guilds0};
						}))))));
var $author$project$Pages$Admin$w3_unsafe_decode_ImportBackendStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ImportBackendFailed);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ImportedBackendSuccessfully);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeBytes,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (remainingBytes0, sentBytes0, totalBytes0) {
											return {remainingBytes: remainingBytes0, sentBytes: sentBytes0, totalBytes: totalBytes0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ImportingBackend));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$NotImportingBackend);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Pagination$ItemId = $elm$core$Basics$identity;
var $author$project$Pagination$w3_unsafe_decode_ItemId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$failDecode,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Editable$w3_unsafe_decode_Editing = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Editable$Editing));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Editable$NotEditing);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Editable$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Editable$w3_unsafe_decode_Editing,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (editing0, pressedSubmit0, showSecret0) {
						return {editing: editing0, pressedSubmit: pressedSubmit0, showSecret: showSecret0};
					})))));
var $author$project$Pages$Admin$w3_unsafe_decode_UserColumn = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Pages$Admin$w3_unsafe_decode_UserTableId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ExistingUserId));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$NewUserId));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Pages$Admin$w3_unsafe_decode_EditingCell = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Pages$Admin$w3_unsafe_decode_UserTableId,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Pages$Admin$w3_unsafe_decode_UserColumn,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (column0, text0, userId0) {
						return {column: column0, text: text0, userId: userId0};
					})))));
var $author$project$Table$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeBool,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (ascendingOrder0, columnToSortBy0, showAll0) {
						return {ascendingOrder: ascendingOrder0, columnToSortBy: columnToSortBy0, showAll: showAll0};
					})))));
var $author$project$Pages$Admin$w3_unsafe_decode_UserTable = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Table$w3_unsafe_decode_Model,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Pages$Admin$w3_unsafe_decode_EditedBackendUser),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Pages$Admin$w3_unsafe_decode_EditingCell),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$containers$SeqSet$decodeSet(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId)),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
						$author$project$Pages$Admin$w3_unsafe_decode_EditedBackendUser),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (changedUsers0, deletedUsers0, editingCell0, newUsers0, table0) {
								return {changedUsers: changedUsers0, deletedUsers: deletedUsers0, editingCell: editingCell0, newUsers: newUsers0, table: table0};
							})))))));
var $author$project$Pages$Admin$w3_unsafe_decode_UsersChangeError = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$CantDeleteYourself);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$CantRemoveAdminRoleFromYourself);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ChangesAppliedToNonExistentUser));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$EmailAddressesAreNotUnique);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$InvalidChangesToUser);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$InvalidNewUser);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Pages$Admin$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Pages$Admin$w3_unsafe_decode_UserTable,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Pages$Admin$w3_unsafe_decode_UsersChangeError),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Editable$w3_unsafe_decode_Model,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Editable$w3_unsafe_decode_Model,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Editable$w3_unsafe_decode_Model,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Editable$w3_unsafe_decode_Model,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Editable$w3_unsafe_decode_Model,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Editable$w3_unsafe_decode_Model,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Editable$w3_unsafe_decode_Model,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Pages$Admin$w3_unsafe_decode_ImportBackendStatus,
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
													$author$project$Id$w3_unsafe_decode_Id($author$project$Pagination$w3_unsafe_decode_ItemId)),
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Pages$Admin$w3_unsafe_decode_ExportSubsetSelection),
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Pages$Admin$w3_unsafe_decode_ExportProgress),
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$lamdera$containers$SeqSet$decodeSet(
																$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId)),
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$lamdera$containers$SeqSet$decodeSet($author$project$Pages$Admin$w3_unsafe_decode_AdminUiSection),
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$lamdera$containers$SeqSet$decodeSet(
																		$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId)),
																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																		$lamdera$containers$SeqSet$decodeSet(
																			$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId)),
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Pages$Admin$w3_unsafe_decode_DownloadingBackup),
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$author$project$Editable$w3_unsafe_decode_Model,
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
																						$author$project$Id$w3_unsafe_decode_Id($author$project$Pagination$w3_unsafe_decode_ItemId)),
																					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																						function (copiedLogLink0) {
																							return function (discordLinkLimit0) {
																								return function (downloadingBackup0) {
																									return function (expandedDiscordGuilds0) {
																										return function (expandedGuilds0) {
																											return function (expandedSections0) {
																												return function (expandedSlackWorkspaces0) {
																													return function (exportProgress0) {
																														return function (exportSubsetSelection0) {
																															return function (highlightLog0) {
																																return function (importBackendStatus0) {
																																	return function (notifyAdminsBotUserId0) {
																																		return function (notifyAdminsToken0) {
																																			return function (openRouterKey0) {
																																				return function (postmarkKey0) {
																																					return function (privateVapidKey0) {
																																						return function (publicVapidKey0) {
																																							return function (slackLinkLimit0) {
																																								return function (submitError0) {
																																									return function (userTable0) {
																																										return function (websocketCloseEventsPage0) {
																																											return {copiedLogLink: copiedLogLink0, discordLinkLimit: discordLinkLimit0, downloadingBackup: downloadingBackup0, expandedDiscordGuilds: expandedDiscordGuilds0, expandedGuilds: expandedGuilds0, expandedSections: expandedSections0, expandedSlackWorkspaces: expandedSlackWorkspaces0, exportProgress: exportProgress0, exportSubsetSelection: exportSubsetSelection0, highlightLog: highlightLog0, importBackendStatus: importBackendStatus0, notifyAdminsBotUserId: notifyAdminsBotUserId0, notifyAdminsToken: notifyAdminsToken0, openRouterKey: openRouterKey0, postmarkKey: postmarkKey0, privateVapidKey: privateVapidKey0, publicVapidKey: publicVapidKey0, slackLinkLimit: slackLinkLimit0, submitError: submitError0, userTable: userTable0, websocketCloseEventsPage: websocketCloseEventsPage0};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						}))))))))))))))))))))));
var $author$project$TextEditor$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$succeedDecode(
	{});
var $author$project$Types$w3_unsafe_decode_NewChannelForm = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (description0, name0, pressedSubmit0) {
						return {description: description0, name: name0, pressedSubmit: pressedSubmit0};
					})))));
var $author$project$Types$w3_unsafe_decode_NewGuildForm = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (name0, pressedSubmit0) {
					return {name: name0, pressedSubmit: pressedSubmit0};
				}))));
var $author$project$X25519$w3_unsafe_decode_PrivateKey = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$X25519$w3_unsafe_decode_Key,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Types$w3_unsafe_decode_RevealedSpoilers = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ThreadMessageId),
			$author$project$NonemptySet$w3_unsafe_decode_NonemptySet($lamdera$codecs$Lamdera$Wire3$decodeInt))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$(
			$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
			$author$project$NonemptySet$w3_unsafe_decode_NonemptySet($lamdera$codecs$Lamdera$Wire3$decodeInt)),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (messages0, threadMessages0) {
					return {messages: messages0, threadMessages: threadMessages0};
				}))));
var $author$project$MessageInput$w3_unsafe_decode_MentionUserDropdown = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeFloat,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeFloat,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeFloat,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F4(
							function (height0, width0, x0, y0) {
								return {height: height0, width: width0, x: x0, y: y0};
							})))))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (dropdownIndex0, inputElement0) {
					return {dropdownIndex: dropdownIndex0, inputElement: inputElement0};
				}))));
var $author$project$Range$w3_unsafe_decode_SelectionDirection = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$MessageInput$w3_unsafe_decode_TextInputFocus = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Range$w3_unsafe_decode_Range,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_HtmlId,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$MessageInput$w3_unsafe_decode_MentionUserDropdown),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Range$w3_unsafe_decode_SelectionDirection,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (direction0, dropdown0, htmlId0, selection0) {
							return {direction: direction0, dropdown: dropdown0, htmlId: htmlId0, selection: selection0};
						}))))));
var $author$project$LoginForm$w3_unsafe_decode_CodeStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$TwoFactorAuthentication$w3_unsafe_decode_TwoFactorDisableData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$LoginForm$w3_unsafe_decode_CodeStatus),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (attempts0, code0) {
					return {attempts: attempts0, code: code0};
				}))));
var $author$project$TwoFactorAuthentication$w3_unsafe_decode_TwoFactorSetupData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$LoginForm$w3_unsafe_decode_CodeStatus),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (attempts0, code0, qrCodeUrl0) {
						return {attempts: attempts0, code: code0, qrCodeUrl: qrCodeUrl0};
					})))));
var $author$project$TwoFactorAuthentication$w3_unsafe_decode_TwoFactorState = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TwoFactorAuthentication$TwoFactorAlreadyComplete));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TwoFactorAuthentication$TwoFactorComplete);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$TwoFactorAuthentication$w3_unsafe_decode_TwoFactorDisableData,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TwoFactorAuthentication$TwoFactorDisable)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TwoFactorAuthentication$TwoFactorLoading);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TwoFactorAuthentication$TwoFactorNotStarted);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$TwoFactorAuthentication$w3_unsafe_decode_TwoFactorSetupData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TwoFactorAuthentication$TwoFactorSetup));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Types$w3_unsafe_decode_E2eeKeysValid = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$E2eeKeys_Error));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$E2eeKeys_NotChecked);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$E2eeKeys_Valid);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Types$LoadedSlackWorkspaces = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$SlackLinkingDisabled = {$: 0};
var $author$project$Types$SlackLinkLimitReached = {$: 1};
var $author$project$Types$SlackWorkspaceHttpError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$w3_unsafe_decode_LinkSlackWorkspaceError = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$SlackLinkLimitReached);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Slack$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$SlackWorkspaceHttpError));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Types$w3_unsafe_decode_LinkSlackResult = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
						$lamdera$codecs$Lamdera$Wire3$decodeResult$($author$project$Types$w3_unsafe_decode_LinkSlackWorkspaceError, $lamdera$codecs$Lamdera$Wire3$decodeString)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$LoadedSlackWorkspaces));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$SlackLinkingDisabled);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$UserColor$w3_unsafe_decode_Selection = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F3(
						function (hue0, lightness0, saturation0) {
							return {hue: hue0, lightness: lightness0, saturation: saturation0};
						}))))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$UserColor$w3_unsafe_decode_UserColor,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (lastValid0, selected0) {
					return {lastValid: lastValid0, selected: selected0};
				}))));
var $author$project$Types$w3_unsafe_decode_UserOptionsModel = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqSet$decodeSet(
				$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Editable$w3_unsafe_decode_Model,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Types$w3_unsafe_decode_LinkSlackResult),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Types$w3_unsafe_decode_E2eeKeysValid,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeString,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$codecs$Lamdera$Wire3$decodeString,
													$lamdera$codecs$Lamdera$Wire3$succeedDecode(
														F2(
															function (data0, loadedAt0) {
																return {data: data0, loadedAt: loadedAt0};
															}))))),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$UserColor$w3_unsafe_decode_Selection),
											$lamdera$codecs$Lamdera$Wire3$succeedDecode(
												function (color0) {
													return function (debugData0) {
														return function (domainWhitelistInput0) {
															return function (e2eeKeysValid0) {
																return function (linkSlackResult0) {
																	return function (name0) {
																		return function (pressedSubmitSlackData0) {
																			return function (privateKeyText0) {
																				return function (removedSlackTeams0) {
																					return function (slackCookie0) {
																						return function (slackTeamsJson0) {
																							return {color: color0, debugData: debugData0, domainWhitelistInput: domainWhitelistInput0, e2eeKeysValid: e2eeKeysValid0, linkSlackResult: linkSlackResult0, name: name0, pressedSubmitSlackData: pressedSubmitSlackData0, privateKeyText: privateKeyText0, removedSlackTeams: removedSlackTeams0, slackCookie: slackCookie0, slackTeamsJson: slackTeamsJson0};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												}))))))))))));
var $author$project$Types$w3_unsafe_decode_LoggedIn2 = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Call$w3_unsafe_decode_Model,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Types$w3_unsafe_decode_UserOptionsModel),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeBool,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$TwoFactorAuthentication$w3_unsafe_decode_TwoFactorState,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$MessageInput$w3_unsafe_decode_TextInputFocus),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$TextEditor$w3_unsafe_decode_Model,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Route$w3_unsafe_decode_ChannelSidebarMode,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$X25519$w3_unsafe_decode_PrivateKey),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
											$author$project$SecretId$w3_unsafe_decode_SecretId($author$project$Id$w3_unsafe_decode_InviteLinkId)),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$FileStatus$w3_unsafe_decode_FileDataWithImage),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$author$project$Types$w3_unsafe_decode_EmojiSelector,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$codecs$Lamdera$Wire3$decodeInt,
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$lamdera$codecs$Lamdera$Wire3$decodeString,
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$lamdera$containers$SeqDict$decodeDict$($author$project$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Types$w3_unsafe_decode_RevealedSpoilers),
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$lamdera$containers$SeqDict$decodeDict$(
																	$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Id$w3_unsafe_decode_ThreadRoute),
																	$author$project$Message$w3_unsafe_decode_RepliedTo($author$project$Id$w3_unsafe_decode_ChannelMessageId)),
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$author$project$ImageEditor$w3_unsafe_decode_Model,
																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$MessageInput$w3_unsafe_decode_TextInputFocus),
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$codecs$Lamdera$Wire3$decodeInt,
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Types$w3_unsafe_decode_NewGuildForm),
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$lamdera$containers$SeqDict$decodeDict$(
																						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
																						$author$project$Types$w3_unsafe_decode_NewChannelForm),
																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																						$author$project$Types$w3_unsafe_decode_MessageHover,
																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																							$author$project$Local$w3_unsafe_decode_Local$($author$project$Types$w3_unsafe_decode_LocalMsg, $author$project$LocalState$w3_unsafe_decode_LocalState),
																							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																								$lamdera$codecs$Lamdera$Wire3$decodeBool,
																								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																									$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
																										$lamdera$codecs$Lamdera$Wire3$decodePair$(
																											$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
																											$author$project$ImageEditor$w3_unsafe_decode_Model)),
																									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																										$lamdera$containers$SeqDict$decodeDict$($author$project$Id$w3_unsafe_decode_GuildOrDmId, $author$project$Game$w3_unsafe_decode_Model),
																										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																											$lamdera$containers$SeqDict$decodeDict$(
																												$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Id$w3_unsafe_decode_ThreadRoute),
																												$author$project$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
																													$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
																													$author$project$FileStatus$w3_unsafe_decode_FileStatus)),
																											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																												$author$project$Types$w3_unsafe_decode_FileDrag,
																												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																													$lamdera$codecs$Lamdera$Wire3$decodeMaybe($elm$url$Url$w3_unsafe_decode_Url),
																													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																														$author$project$Types$w3_unsafe_decode_EncryptionRequests,
																														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																															$author$project$Emoji$w3_unsafe_decode_Model,
																															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																$lamdera$containers$SeqDict$decodeDict$(
																																	$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Id$w3_unsafe_decode_ThreadRoute),
																																	$author$project$Types$w3_unsafe_decode_EditMessage),
																																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																	$lamdera$containers$SeqDict$decodeDict$(
																																		$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
																																		$author$project$Types$w3_unsafe_decode_EditGuildForm),
																																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																		$lamdera$containers$SeqDict$decodeDict$(
																																			$lamdera$codecs$Lamdera$Wire3$decodePair$(
																																				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
																																				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId)),
																																			$author$project$Types$w3_unsafe_decode_EditChannelForm),
																																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																			$lamdera$containers$SeqDict$decodeDict$(
																																				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
																																				$lamdera$codecs$Lamdera$Wire3$decodeBool),
																																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																				$lamdera$codecs$Lamdera$Wire3$decodeString,
																																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																					$lamdera$containers$SeqSet$decodeSet(
																																						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId)),
																																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
																																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																							$author$project$Drawing$w3_unsafe_decode_Model,
																																							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																								$lamdera$containers$SeqDict$decodeDict$(
																																									$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Id$w3_unsafe_decode_ThreadRoute),
																																									$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_unsafe_decode_NonemptyString),
																																								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																									$author$project$Scroll$w3_unsafe_decode_ScrollPosition,
																																									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																										$author$project$Pages$Admin$w3_unsafe_decode_Model,
																																										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																																											$lamdera$codecs$Lamdera$Wire3$decodeBool,
																																											$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																																												function (accountDeletionBannerClosed0) {
																																													return function (admin0) {
																																														return function (channelScrollPosition0) {
																																															return function (drafts0) {
																																																return function (drawingMode0) {
																																																	return function (e2eeError0) {
																																																		return function (e2eeKeysOnThisDevice0) {
																																																			return function (e2eePrivateKeyText0) {
																																																				return function (e2eeSectionsExpanded0) {
																																																					return function (editChannelForm0) {
																																																						return function (editGuildForm0) {
																																																							return function (editMessage0) {
																																																								return function (emojiSelector0) {
																																																									return function (encryptionRequests0) {
																																																										return function (externalLinkWarning0) {
																																																											return function (fileDragOverCount0) {
																																																												return function (filesToUpload0) {
																																																													return function (games0) {
																																																														return function (guildIconEditor0) {
																																																															return function (isReloading0) {
																																																																return function (localState0) {
																																																																	return function (messageHover0) {
																																																																		return function (newChannelForm0) {
																																																																			return function (newGuildForm0) {
																																																																				return function (newMessagesWhileNotScrolledToBottom0) {
																																																																					return function (previousTextInputFocus0) {
																																																																						return function (profilePictureEditor0) {
																																																																							return function (replyTo0) {
																																																																								return function (revealedSpoilers0) {
																																																																									return function (searchOverlayQuery0) {
																																																																										return function (searchOverlaySelection0) {
																																																																											return function (showEmojiSelector0) {
																																																																												return function (showFileToUploadInfo0) {
																																																																													return function (showInviteLinkQrCode0) {
																																																																														return function (showNewPrivateKey0) {
																																																																															return function (sidebarMode0) {
																																																																																return function (textEditor0) {
																																																																																	return function (textInputFocus0) {
																																																																																		return function (twoFactor0) {
																																																																																			return function (typedTextCounter0) {
																																																																																				return function (typingDebouncer0) {
																																																																																					return function (userOptions0) {
																																																																																						return function (voiceChat0) {
																																																																																							return {accountDeletionBannerClosed: accountDeletionBannerClosed0, admin: admin0, channelScrollPosition: channelScrollPosition0, drafts: drafts0, drawingMode: drawingMode0, e2eeError: e2eeError0, e2eeKeysOnThisDevice: e2eeKeysOnThisDevice0, e2eePrivateKeyText: e2eePrivateKeyText0, e2eeSectionsExpanded: e2eeSectionsExpanded0, editChannelForm: editChannelForm0, editGuildForm: editGuildForm0, editMessage: editMessage0, emojiSelector: emojiSelector0, encryptionRequests: encryptionRequests0, externalLinkWarning: externalLinkWarning0, fileDragOverCount: fileDragOverCount0, filesToUpload: filesToUpload0, games: games0, guildIconEditor: guildIconEditor0, isReloading: isReloading0, localState: localState0, messageHover: messageHover0, newChannelForm: newChannelForm0, newGuildForm: newGuildForm0, newMessagesWhileNotScrolledToBottom: newMessagesWhileNotScrolledToBottom0, previousTextInputFocus: previousTextInputFocus0, profilePictureEditor: profilePictureEditor0, replyTo: replyTo0, revealedSpoilers: revealedSpoilers0, searchOverlayQuery: searchOverlayQuery0, searchOverlaySelection: searchOverlaySelection0, showEmojiSelector: showEmojiSelector0, showFileToUploadInfo: showFileToUploadInfo0, showInviteLinkQrCode: showInviteLinkQrCode0, showNewPrivateKey: showNewPrivateKey0, sidebarMode: sidebarMode0, textEditor: textEditor0, textInputFocus: textInputFocus0, twoFactor: twoFactor0, typedTextCounter: typedTextCounter0, typingDebouncer: typingDebouncer0, userOptions: userOptions0, voiceChat: voiceChat0};
																																																																																						};
																																																																																					};
																																																																																				};
																																																																																			};
																																																																																		};
																																																																																	};
																																																																																};
																																																																															};
																																																																														};
																																																																													};
																																																																												};
																																																																											};
																																																																										};
																																																																									};
																																																																								};
																																																																							};
																																																																						};
																																																																					};
																																																																				};
																																																																			};
																																																																		};
																																																																	};
																																																																};
																																																															};
																																																														};
																																																													};
																																																												};
																																																											};
																																																										};
																																																									};
																																																								};
																																																							};
																																																						};
																																																					};
																																																				};
																																																			};
																																																		};
																																																	};
																																																};
																																															};
																																														};
																																													};
																																												}))))))))))))))))))))))))))))))))))))))))))));
var $author$project$LoginForm$w3_unsafe_decode_EnterEmail2 = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeBool,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeBool,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeBool,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeBool,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (email0, pressedSubmitEmail0, rateLimited0, showSignupsDisabled0, showUserIsDeleted0) {
								return {email: email0, pressedSubmitEmail: pressedSubmitEmail0, rateLimited: rateLimited0, showSignupsDisabled: showSignupsDisabled0, showUserIsDeleted: showUserIsDeleted0};
							})))))));
var $author$project$LoginForm$w3_unsafe_decode_EnterLoginCode2 = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$EmailAddress$w3_unsafe_decode_EmailAddress,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$containers$SeqDict$decodeDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$LoginForm$w3_unsafe_decode_CodeStatus),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (attempts0, code0, sentTo0) {
						return {attempts: attempts0, code: code0, sentTo: sentTo0};
					})))));
var $author$project$LoginForm$w3_unsafe_decode_EnterTwoFactorCode2 = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$containers$SeqDict$decodeDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$LoginForm$w3_unsafe_decode_CodeStatus),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (attemptCount0, attempts0, code0) {
						return {attemptCount: attemptCount0, attempts: attempts0, code: code0};
					})))));
var $author$project$LoginForm$w3_unsafe_decode_SubmitStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LoginForm$NotSubmitted));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LoginForm$Submitting);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$LoginForm$w3_unsafe_decode_EnterUserData2 = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$LoginForm$w3_unsafe_decode_SubmitStatus,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (name0, pressedSubmit0) {
					return {name: name0, pressedSubmit: pressedSubmit0};
				}))));
var $author$project$LoginForm$w3_unsafe_decode_LoginForm = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$LoginForm$w3_unsafe_decode_EnterEmail2,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LoginForm$EnterEmail));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$LoginForm$w3_unsafe_decode_EnterLoginCode2,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LoginForm$EnterLoginCode));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$LoginForm$w3_unsafe_decode_EnterTwoFactorCode2,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LoginForm$EnterTwoFactorCode));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$LoginForm$w3_unsafe_decode_EnterUserData2,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LoginForm$EnterUserData));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$RecoveryLogin$w3_unsafe_decode_SubmitStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$RecoveryLogin$IncorrectPassword);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$RecoveryLogin$NotSubmitted));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$RecoveryLogin$Submitting);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$RecoveryLogin$w3_unsafe_decode_Model = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$RecoveryLogin$w3_unsafe_decode_SubmitStatus,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F2(
								function (password0, submitStatus0) {
									return {password: password0, submitStatus: submitStatus0};
								})))),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Types$w3_unsafe_decode_LoginStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Types$w3_unsafe_decode_LoggedIn2,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$LoggedIn));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$SecretId$w3_unsafe_decode_SecretId($author$project$Id$w3_unsafe_decode_InviteLinkId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Range$w3_unsafe_decode_Range,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_HtmlId,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$Range$w3_unsafe_decode_SelectionDirection,
											$lamdera$codecs$Lamdera$Wire3$succeedDecode(
												F3(
													function (direction0, htmlId0, selection0) {
														return {direction: direction0, htmlId: htmlId0, selection: selection0};
													})))))),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$RecoveryLogin$w3_unsafe_decode_Model,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$LoginForm$w3_unsafe_decode_LoginForm),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F4(
											function (loginForm0, recoveryLogin0, textInputFocus0, useInviteAfterLoggedIn0) {
												return {loginForm: loginForm0, recoveryLogin: recoveryLogin0, textInputFocus: textInputFocus0, useInviteAfterLoggedIn: useInviteAfterLoggedIn0};
											})))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$NotLoggedIn));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Types$LoginWithRecoveryPassword = 1;
var $author$project$Types$w3_unsafe_decode_LoginType = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$ImageViewer$w3_unsafe_decode_Interaction = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeFloat,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeFloat,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeFloat,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F4(
											function (offsetStartX0, offsetStartY0, startX0, startY0) {
												return {offsetStartX: offsetStartX0, offsetStartY: offsetStartY0, startX: startX0, startY: startY0};
											})))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageViewer$Dragging));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageViewer$NoInteraction);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeFloat,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeFloat,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeFloat,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F4(
											function (prevMidX0, prevMidY0, startDistance0, startScale0) {
												return {prevMidX: prevMidX0, prevMidY: prevMidY0, startDistance: startDistance0, startScale: startScale0};
											})))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageViewer$Pinching));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$ImageViewer$w3_unsafe_decode_Model = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeFloat,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeFloat,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeFloat,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeFloat,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeFloat,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeFloat,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeFloat,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeFloat,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$author$project$ImageViewer$w3_unsafe_decode_Interaction,
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeString,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$author$project$Coord$w3_unsafe_decode_Coord($author$project$CssPixels$w3_unsafe_decode_CssPixels),
													$lamdera$codecs$Lamdera$Wire3$succeedDecode(
														function (imageSize0) {
															return function (imageUrl0) {
																return function (interaction0) {
																	return function (offsetX0) {
																		return function (offsetY0) {
																			return function (prevOffsetX0) {
																				return function (prevOffsetY0) {
																					return function (scale0) {
																						return function (targetScale0) {
																							return function (velocityX0) {
																								return function (velocityY0) {
																									return function (zoomFocusX0) {
																										return function (zoomFocusY0) {
																											return {imageSize: imageSize0, imageUrl: imageUrl0, interaction: interaction0, offsetX: offsetX0, offsetY: offsetY0, prevOffsetX: prevOffsetX0, prevOffsetY: prevOffsetY0, scale: scale0, targetScale: targetScale0, velocityX: velocityX0, velocityY: velocityY0, zoomFocusX: zoomFocusX0, zoomFocusY: zoomFocusY0};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														}))))))))))))));
var $author$project$Go$w3_unsafe_decode_PublicGoMatchData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Go$w3_unsafe_decode_ValidatedSetup,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$User$w3_unsafe_decode_FrontendUser),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$User$w3_unsafe_decode_FrontendUser,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Go$w3_unsafe_decode_Shared,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Go$w3_unsafe_decode_ActionWithTime),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (actions0, cache0, creatorUser0, joinedUser0, setup0) {
								return {actions: actions0, cache: cache0, creatorUser: creatorUser0, joinedUser: joinedUser0, setup: setup0};
							})))))));
var $author$project$Types$w3_unsafe_decode_PublicGoMatch = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Go$w3_unsafe_decode_GameModel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Go$w3_unsafe_decode_PublicGoMatchData,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PublicGoMatch_Loaded)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PublicGoMatch_Loading);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PublicGoMatch_Missing);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PublicGoMatch_NotLoaded);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Route$w3_unsafe_decode_ShowChannelSettings = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Route$w3_unsafe_decode_ThreadRouteWithFriends = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Route$w3_unsafe_decode_ShowChannelSettings,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Route$NoThreadWithFriends)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Route$w3_unsafe_decode_ShowChannelSettings,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ThreadMessageId)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Route$ViewThreadWithFriends))));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Route$w3_unsafe_decode_ChannelRoute = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$UserSession$w3_unsafe_decode_ChannelHeaderTab),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Route$w3_unsafe_decode_ThreadRouteWithFriends,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Route$ChannelRoute))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Route$GuildSettingsRoute);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$SecretId$w3_unsafe_decode_SecretId($author$project$Id$w3_unsafe_decode_InviteLinkId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Route$JoinRoute));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Route$NewChannelRoute);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Route$w3_unsafe_decode_ChannelsVisibleOnMobile = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Route$w3_unsafe_decode_Overlay = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Route$w3_unsafe_decode_DiscordDmRouteData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
		$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$UserSession$w3_unsafe_decode_ChannelHeaderTab),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Route$w3_unsafe_decode_ShowChannelSettings,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Route$w3_unsafe_decode_Overlay),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Route$w3_unsafe_decode_ChannelsVisibleOnMobile,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F7(
									function (channelId0, channelsVisible0, currentDiscordUserId0, overlay0, showMembersTab0, tab0, viewingMessage0) {
										return {channelId: channelId0, channelsVisible: channelsVisible0, currentDiscordUserId: currentDiscordUserId0, overlay: overlay0, showMembersTab: showMembersTab0, tab: tab0, viewingMessage: viewingMessage0};
									})))))))));
var $author$project$Route$w3_unsafe_decode_DiscordChannelRoute = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$UserSession$w3_unsafe_decode_ChannelHeaderTab),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Route$w3_unsafe_decode_ThreadRouteWithFriends,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Route$DiscordChannel_ChannelRoute))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Route$DiscordChannel_GuildSettingsRoute);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Route$DiscordChannel_NewChannelRoute);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Route$w3_unsafe_decode_DiscordGuildRouteData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Route$w3_unsafe_decode_Overlay),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Route$w3_unsafe_decode_ChannelsVisibleOnMobile,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Route$w3_unsafe_decode_DiscordChannelRoute,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (channelRoute0, channelsVisible0, currentDiscordUserId0, guildId0, overlay0) {
								return {channelRoute: channelRoute0, channelsVisible: channelsVisible0, currentDiscordUserId: currentDiscordUserId0, guildId: guildId0, overlay: overlay0};
							})))))));
var $author$project$Route$w3_unsafe_decode_DmRouteData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Route$w3_unsafe_decode_ThreadRouteWithFriends,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$UserSession$w3_unsafe_decode_ChannelHeaderTab),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Route$w3_unsafe_decode_Overlay),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Route$w3_unsafe_decode_ChannelsVisibleOnMobile,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$DmChannelId$w3_unsafe_decode_DmChannelId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (channelId0, channelsVisible0, overlay0, tab0, threadRoute0) {
								return {channelId: channelId0, channelsVisible: channelsVisible0, overlay: overlay0, tab: tab0, threadRoute: threadRoute0};
							})))))));
var $author$project$Route$w3_unsafe_decode_LinkDiscordError = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Route$w3_unsafe_decode_SlackDmRouteData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Id$w3_unsafe_decode_ThreadRouteWithMaybeMessage,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Route$w3_unsafe_decode_Overlay),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Route$w3_unsafe_decode_ChannelsVisibleOnMobile,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_DmChannelId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (channelId0, channelsVisible0, currentSlackUserId0, overlay0, threadRoute0) {
								return {channelId: channelId0, channelsVisible: channelsVisible0, currentSlackUserId: currentSlackUserId0, overlay: overlay0, threadRoute: threadRoute0};
							})))))));
var $author$project$Route$w3_unsafe_decode_SlackChannelRoute = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Route$w3_unsafe_decode_ShowChannelSettings,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_ThreadRouteWithMaybeMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Route$SlackChannel_ChannelRoute))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Route$SlackChannel_WorkspaceSettingsRoute);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Route$w3_unsafe_decode_SlackWorkspaceRouteData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Route$w3_unsafe_decode_Overlay),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Route$w3_unsafe_decode_ChannelsVisibleOnMobile,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Route$w3_unsafe_decode_SlackChannelRoute,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (channelRoute0, channelsVisible0, currentSlackUserId0, overlay0, teamId0) {
								return {channelRoute: channelRoute0, channelsVisible: channelsVisible0, currentSlackUserId: currentSlackUserId0, overlay: overlay0, teamId: teamId0};
							})))))));
function $author$project$SafeJson$cyclic$w3_unsafe_decode_SafeJson() {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeList(
							$author$project$SafeJson$cyclic$w3_unsafe_decode_SafeJson()),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SafeJson$JsonArray));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SafeJson$JsonBool));
				case 2:
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SafeJson$JsonNull);
				case 3:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$SafeFloat$w3_unsafe_decode_SafeFloat,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SafeJson$JsonNumber));
				case 4:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeDict$(
							$lamdera$codecs$Lamdera$Wire3$decodeString,
							$author$project$SafeJson$cyclic$w3_unsafe_decode_SafeJson()),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SafeJson$JsonObject));
				case 5:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SafeJson$JsonString));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
}
var $author$project$SafeJson$w3_unsafe_decode_SafeJson = $author$project$SafeJson$cyclic$w3_unsafe_decode_SafeJson();
$author$project$SafeJson$cyclic$w3_unsafe_decode_SafeJson = function () {
	return $author$project$SafeJson$w3_unsafe_decode_SafeJson;
};
var $author$project$Discord$w3_unsafe_decode_UserAuth = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$SafeJson$w3_unsafe_decode_SafeJson,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (token0, userAgent0, xSuperProperties0) {
						return {token: token0, userAgent: userAgent0, xSuperProperties: xSuperProperties0};
					})))));
var $author$project$Route$w3_unsafe_decode_Route = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Pagination$w3_unsafe_decode_ItemId)),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							function (highlightLog0) {
								return {highlightLog: highlightLog0};
							})),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Route$AdminRoute));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Route$AiChatRoute);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Route$w3_unsafe_decode_DiscordDmRouteData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Route$DiscordDmRoute));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Route$w3_unsafe_decode_DiscordGuildRouteData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Route$DiscordGuildRoute));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Route$w3_unsafe_decode_DmRouteData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Route$DmRoute));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Route$w3_unsafe_decode_Overlay),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Route$w3_unsafe_decode_ChannelsVisibleOnMobile,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Route$w3_unsafe_decode_ChannelRoute,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Route$GuildRoute)))));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Route$w3_unsafe_decode_Overlay),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Route$HomePageRoute));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($author$project$Route$w3_unsafe_decode_LinkDiscordError, $author$project$Discord$w3_unsafe_decode_UserAuth),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Route$LinkDiscord));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Route$NewGuildRoute);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Route$PrivacyRoute);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$SecretId$w3_unsafe_decode_SecretId($author$project$Id$w3_unsafe_decode_GamePublicId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Route$PublicGoMatchRoute));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Route$w3_unsafe_decode_SlackDmRouteData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Route$SlackDmRoute));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Route$w3_unsafe_decode_SlackWorkspaceRouteData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Route$SlackWorkspaceRoute));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Route$TextEditorRoute);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Audio$w3_unsafe_decode_BufferId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Audio$w3_unsafe_decode_Source = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Audio$w3_unsafe_decode_BufferId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						function (bufferId0) {
							return {bufferId: bufferId0};
						})),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Ports$w3_unsafe_decode_NotificationPermission = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Ports$w3_unsafe_decode_PwaStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Ports$w3_unsafe_decode_StartupData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$UserAgent$w3_unsafe_decode_UserAgent,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$elm$time$Time$w3_unsafe_decode_Zone,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			A2(
				$lamdera$codecs$Lamdera$Wire3$andThenDecode,
				function (t) {
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
						$elm$time$Time$millisToPosix(t));
				},
				$lamdera$codecs$Lamdera$Wire3$decodeInt),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeInt,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeInt),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Ports$w3_unsafe_decode_PwaStatus,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Ports$w3_unsafe_decode_NotificationPermission,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										A2(
											$lamdera$codecs$Lamdera$Wire3$andThenDecode,
											function (t) {
												return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
													$elm$time$Time$millisToPosix(t));
											},
											$lamdera$codecs$Lamdera$Wire3$decodeInt),
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeList(
												$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId)),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeFloat,
												$lamdera$codecs$Lamdera$Wire3$succeedDecode(
													function (devicePixelRatio0) {
														return function (e2eeKeys0) {
															return function (loadStartupDataTime0) {
																return function (notificationPermission0) {
																	return function (pwaStatus0) {
																		return function (randomSeed0) {
																			return function (safeAreaInsetBottom0) {
																				return function (safeAreaInsetTop0) {
																					return function (scrollbarWidth0) {
																						return function (timeOrigin0) {
																							return function (timezone0) {
																								return function (userAgent0) {
																									return {devicePixelRatio: devicePixelRatio0, e2eeKeys: e2eeKeys0, loadStartupDataTime: loadStartupDataTime0, notificationPermission: notificationPermission0, pwaStatus: pwaStatus0, randomSeed: randomSeed0, safeAreaInsetBottom: safeAreaInsetBottom0, safeAreaInsetTop: safeAreaInsetTop0, scrollbarWidth: scrollbarWidth0, timeOrigin: timeOrigin0, timezone: timezone0, userAgent: userAgent0};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													})))))))))))));
var $author$project$Internal$Model2$w3_unsafe_decode_State = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeString),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeSet($lamdera$codecs$Lamdera$Wire3$decodeString),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F3(
									function (added0, keyframes0, rules0) {
										return {added: added0, keyframes: keyframes0, rules: rules0};
									}))))),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Ui$Anim$w3_unsafe_decode_State = $author$project$Internal$Model2$w3_unsafe_decode_State;
var $author$project$Types$AdminToFrontend = function (a) {
	return {$: 5, a: a};
};
var $author$project$Types$AiChatToFrontend = function (a) {
	return {$: 9, a: a};
};
var $author$project$Types$ChangeBroadcast = function (a) {
	return {$: 7, a: a};
};
var $author$project$Types$CheckLoginResponse$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$Types$CheckLoginResponse = F2($author$project$Types$CheckLoginResponse$);
var $author$project$Types$ExportChannelResponse = function (a) {
	return {$: 16, a: a};
};
var $author$project$Types$GetLoginTokenRateLimited = {$: 2};
var $author$project$Types$GetPublicGoMatchResponse = function (a) {
	return {$: 15, a: a};
};
var $author$project$Types$ImportChannelResponse$ = function (a, b) {
	return {$: 17, a: a, b: b};
};
var $author$project$Types$ImportChannelResponse = F2($author$project$Types$ImportChannelResponse$);
var $author$project$Types$LinkDiscordResponse = function (a) {
	return {$: 12, a: a};
};
var $author$project$Types$LinkSlackResponse = function (a) {
	return {$: 13, a: a};
};
var $author$project$Types$LocalChangeResponse$ = function (a, b) {
	return {$: 6, a: a, b: b};
};
var $author$project$Types$LocalChangeResponse = F2($author$project$Types$LocalChangeResponse$);
var $author$project$Types$LoggedOutSession = {$: 4};
var $author$project$Types$LoginWithTokenResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$ProfilePictureEditorToFrontend = function (a) {
	return {$: 14, a: a};
};
var $author$project$Types$ReloadDataResponse = function (a) {
	return {$: 11, a: a};
};
var $author$project$Types$SignupsDisabledResponse = {$: 3};
var $author$project$Types$TwoFactorAuthenticationToFrontend = function (a) {
	return {$: 8, a: a};
};
var $author$project$Types$YouConnected = function (a) {
	return {$: 10, a: a};
};
var $author$project$Types$LinkDiscordHttpError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$LinkDiscordLimitReached = {$: 1};
var $author$project$Types$w3_unsafe_decode_LinkDiscordFailure = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_HttpError,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$LinkDiscordHttpError));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$LinkDiscordLimitReached);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Types$IsAdminButNoData = {$: 1};
var $author$project$Types$IsAdminLoginData = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$w3_unsafe_decode_AdminStatusLoginData = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$IsAdminButNoData);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Pages$Admin$w3_unsafe_decode_InitAdminData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$IsAdminLoginData));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$IsNotAdminLoginData);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Types$w3_unsafe_decode_LoginData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$containers$SeqDict$decodeDict$(
		$author$project$Call$w3_unsafe_decode_CallId,
		$author$project$NonemptyDict$w3_unsafe_decode_NonemptyDict$(
			$lamdera$codecs$Lamdera$Wire3$decodePair$(
				$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
				$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId),
			$author$project$Call$w3_unsafe_decode_RemoteCallData)),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$User$w3_unsafe_decode_FrontendCurrentUser,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$TextEditor$w3_unsafe_decode_LocalState,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$containers$SeqDict$decodeDict$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_StickerId),
						$author$project$Sticker$w3_unsafe_decode_StickerData),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$containers$SeqDict$decodeDict$(
							$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
							$author$project$LocalState$w3_unsafe_decode_SlackFrontendWorkspace),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$containers$SeqSet$decodeSet(
								$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId)),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$containers$SeqDict$decodeDict$(
									$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
									$author$project$UserSession$w3_unsafe_decode_SlackFrontendUser),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$containers$SeqDict$decodeDict$(
										$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_DmChannelId),
										$author$project$LocalState$w3_unsafe_decode_SlackFrontendDmChannel),
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$UserSession$w3_unsafe_decode_UserSession,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeString,
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$containers$SeqDict$decodeDict$(
													$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
													$author$project$User$w3_unsafe_decode_FrontendUser),
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$containers$SeqDict$decodeDict$($author$project$SessionIdHash$w3_unsafe_decode_SessionIdHash, $author$project$UserSession$w3_unsafe_decode_FrontendUserSession),
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$lamdera$containers$SeqDict$decodeDict$(
															$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
															$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId)),
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$lamdera$containers$SeqDict$decodeDict$(
																$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
																$author$project$LocalState$w3_unsafe_decode_FrontendGuild),
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$lamdera$containers$SeqDict$decodeDict$(
																	$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
																	$author$project$DmChannel$w3_unsafe_decode_FrontendDmChannel),
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$author$project$LinkedAndOtherDiscordUsers$w3_unsafe_decode_LinkedAndOtherDiscordUsers,
																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																		$lamdera$containers$SeqDict$decodeDict$(
																			$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
																			$author$project$LocalState$w3_unsafe_decode_DiscordFrontendGuild),
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$containers$SeqDict$decodeDict$(
																				$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
																				$author$project$DmChannel$w3_unsafe_decode_DiscordFrontendDmChannel),
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$lamdera$containers$SeqDict$decodeDict$(
																					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_CustomEmojiId),
																					$author$project$CustomEmoji$w3_unsafe_decode_CustomEmojiData),
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$author$project$UserSession$w3_unsafe_decode_Viewing,
																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																						$lamdera$containers$SeqDict$decodeDict$($author$project$Call$w3_unsafe_decode_CallId, $author$project$Call$w3_unsafe_decode_RecordingStatus),
																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																							$author$project$Types$w3_unsafe_decode_AdminStatusLoginData,
																							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																								function (adminData0) {
																									return function (callRecordings0) {
																										return function (currentlyViewing0) {
																											return function (customEmojis0) {
																												return function (discordDmChannels0) {
																													return function (discordGuilds0) {
																														return function (discordUsers0) {
																															return function (dmChannels0) {
																																return function (guilds0) {
																																	return function (linkedSlackUsers0) {
																																		return function (otherSessions0) {
																																			return function (otherUsers0) {
																																				return function (publicVapidKey0) {
																																					return function (session0) {
																																						return function (slackDmChannels0) {
																																							return function (slackUsers0) {
																																								return function (slackUsersNeedingAuth0) {
																																									return function (slackWorkspaces0) {
																																										return function (stickers0) {
																																											return function (textEditor0) {
																																												return function (twoFactorAuthenticationEnabled0) {
																																													return function (user0) {
																																														return function (voiceChatPeers0) {
																																															return {adminData: adminData0, callRecordings: callRecordings0, currentlyViewing: currentlyViewing0, customEmojis: customEmojis0, discordDmChannels: discordDmChannels0, discordGuilds: discordGuilds0, discordUsers: discordUsers0, dmChannels: dmChannels0, guilds: guilds0, linkedSlackUsers: linkedSlackUsers0, otherSessions: otherSessions0, otherUsers: otherUsers0, publicVapidKey: publicVapidKey0, session: session0, slackDmChannels: slackDmChannels0, slackUsers: slackUsers0, slackUsersNeedingAuth: slackUsersNeedingAuth0, slackWorkspaces: slackWorkspaces0, stickers: stickers0, textEditor: textEditor0, twoFactorAuthenticationEnabled: twoFactorAuthenticationEnabled0, user: user0, voiceChatPeers: voiceChatPeers0};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								}))))))))))))))))))))))));
var $author$project$Types$LoginSuccess = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$LoginTokenInvalid = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$NeedsAccountSetup = {$: 3};
var $author$project$Types$NeedsTwoFactorToken = {$: 2};
var $author$project$Types$RecoveryPasswordInvalid = {$: 4};
var $author$project$Types$UserIsDeleted = {$: 5};
var $author$project$Types$w3_unsafe_decode_LoginResult = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Types$w3_unsafe_decode_LoginData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$LoginSuccess));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$LoginTokenInvalid));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$NeedsAccountSetup);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$NeedsTwoFactorToken);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$RecoveryPasswordInvalid);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$UserIsDeleted);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Go$w3_unsafe_decode_PublicGoMatchResponse = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Go$w3_unsafe_decode_ValidatedSetup,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$User$w3_unsafe_decode_FrontendUser),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$User$w3_unsafe_decode_FrontendUser,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Go$w3_unsafe_decode_ActionWithTime),
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (actions0, creatorUser0, joinedUser0, setup0) {
							return {actions: actions0, creatorUser: creatorUser0, joinedUser: joinedUser0, setup: setup0};
						}))))));
var $author$project$AiChat$AiMessageResponse$ = function (a, b) {
	return {$: 0, a: a, b: b};
};
var $author$project$AiChat$AiMessageResponse = F2($author$project$AiChat$AiMessageResponse$);
var $author$project$AiChat$w3_unsafe_decode_AiResponse = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$codecs$Lamdera$Wire3$decodeString),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeFloat),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode(
					F4(
						function (content0, cost0, images0, reasoning0) {
							return {content: content0, cost: cost0, images: images0, reasoning: reasoning0};
						}))))));
var $author$project$AiChat$w3_unsafe_decode_ToFrontend = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Http$w3_unsafe_decode_Error, $author$project$AiChat$w3_unsafe_decode_AiResponse),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$AiChat$w3_unsafe_decode_ResponseId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$AiChat$AiMessageResponse)));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$ImageEditor$ChangeGuildIconResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$ImageEditor$ChangeUserAvatarResponse = {$: 0};
var $author$project$ImageEditor$w3_unsafe_decode_ToFrontend = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageEditor$ChangeGuildIconResponse));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageEditor$ChangeUserAvatarResponse);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Pages$Admin$DownloadLastBackupChunk$ = function (a, b, c) {
	return {$: 4, a: a, b: b, c: c};
};
var $author$project$Pages$Admin$DownloadLastBackupChunk = F3($author$project$Pages$Admin$DownloadLastBackupChunk$);
var $author$project$Pages$Admin$ExportBackendFinished = {$: 3};
var $author$project$Pages$Admin$ExportBackendProgress$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$Pages$Admin$ExportBackendProgress = F2($author$project$Pages$Admin$ExportBackendProgress$);
var $author$project$Pages$Admin$ImportBackendChunkReceived = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$ImportBackendResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$w3_unsafe_decode_ExportSubset = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ExportAll);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Pages$Admin$w3_unsafe_decode_ExportSubsetSelection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ExportSubset));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Pages$Admin$w3_unsafe_decode_ToFrontend = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBytes,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$LocalState$w3_unsafe_decode_BackupContents,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$DownloadLastBackupChunk))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ExportBackendFinished);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Pages$Admin$w3_unsafe_decode_ExportProgress,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Pages$Admin$w3_unsafe_decode_ExportSubset,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ExportBackendProgress)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ImportBackendChunkReceived));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $lamdera$codecs$Lamdera$Wire3$decodeUnit),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ImportBackendResponse));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$TwoFactorAuthentication$ConfirmTwoFactorAuthenticationResponse$ = function (a, b) {
	return {$: 1, a: a, b: b};
};
var $author$project$TwoFactorAuthentication$ConfirmTwoFactorAuthenticationResponse = F2($author$project$TwoFactorAuthentication$ConfirmTwoFactorAuthenticationResponse$);
var $author$project$TwoFactorAuthentication$DisableTwoFactorAuthenticationResponse$ = function (a, b) {
	return {$: 2, a: a, b: b};
};
var $author$project$TwoFactorAuthentication$DisableTwoFactorAuthenticationResponse = F2($author$project$TwoFactorAuthentication$DisableTwoFactorAuthenticationResponse$);
var $author$project$TwoFactorAuthentication$EnableTwoFactorAuthenticationResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$TwoFactorAuthentication$w3_unsafe_decode_ToFrontend = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TwoFactorAuthentication$ConfirmTwoFactorAuthenticationResponse)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TwoFactorAuthentication$DisableTwoFactorAuthenticationResponse)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							function (qrCodeUrl0) {
								return {qrCodeUrl: qrCodeUrl0};
							})),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TwoFactorAuthentication$EnableTwoFactorAuthenticationResponse));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Types$w3_unsafe_decode_ToFrontend = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Pages$Admin$w3_unsafe_decode_ToFrontend,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$AdminToFrontend));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$AiChat$w3_unsafe_decode_ToFrontend,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$AiChatToFrontend));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Types$w3_unsafe_decode_LocalMsg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$ChangeBroadcast));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $author$project$Types$w3_unsafe_decode_LoginData),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Types$w3_unsafe_decode_LoginType,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$CheckLoginResponse)));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeString,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (fileName0, json0) {
										return {fileName: fileName0, json: json0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$ExportChannelResponse));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$GetLoginTokenRateLimited);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $author$project$Go$w3_unsafe_decode_PublicGoMatchResponse),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$GetPublicGoMatchResponse));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$(
						$author$project$Types$w3_unsafe_decode_ImportChannelError,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								function (encryptedMessages0) {
									return {encryptedMessages: encryptedMessages0};
								}))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$ImportChannelResponse)));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($author$project$Types$w3_unsafe_decode_LinkDiscordFailure, $lamdera$codecs$Lamdera$Wire3$decodeUnit),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$LinkDiscordResponse));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Types$w3_unsafe_decode_LinkSlackResult,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$LinkSlackResponse));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Types$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Local$w3_unsafe_decode_ChangeId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$LocalChangeResponse)));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$LoggedOutSession);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Types$w3_unsafe_decode_LoginResult,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$LoginWithTokenResponse));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$ImageEditor$w3_unsafe_decode_ToFrontend,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$ProfilePictureEditorToFrontend));
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $author$project$Types$w3_unsafe_decode_LoginData),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$ReloadDataResponse));
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$SignupsDisabledResponse);
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$TwoFactorAuthentication$w3_unsafe_decode_ToFrontend,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$TwoFactorAuthenticationToFrontend));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$YouConnected));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Types$w3_unsafe_decode_LoadedFrontend = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Coord$w3_unsafe_decode_Coord($author$project$CssPixels$w3_unsafe_decode_CssPixels),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeInt,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeInt,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$lamdera$codecs$Lamdera$Wire3$decodeArray($author$project$Types$w3_unsafe_decode_ToFrontend)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Time$w3_unsafe_decode_Zone,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Ports$w3_unsafe_decode_StartupData,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Route$w3_unsafe_decode_Route,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Types$w3_unsafe_decode_PublicGoMatch,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$codecs$Lamdera$Wire3$decodeResult$($author$project$Audio$w3_unsafe_decode_LoadError, $author$project$Audio$w3_unsafe_decode_Source),
											$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
												$lamdera$codecs$Lamdera$Wire3$decodeBool,
												$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
													$lamdera$program_test$Effect$Browser$Navigation$w3_unsafe_decode_Key,
													$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
														$author$project$Types$w3_unsafe_decode_LoginType,
														$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
															$author$project$Types$w3_unsafe_decode_LoginStatus,
															$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$MyUi$w3_unsafe_decode_LastCopy),
																$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$ImageViewer$w3_unsafe_decode_Model),
																	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$codecs$Lamdera$Wire3$decodeBool,
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$lamdera$codecs$Lamdera$Wire3$decodeInt,
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
																					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																						F3(
																							function (changedAt0, index0, rotate0) {
																								return {changedAt: changedAt0, index: index0, rotate: rotate0};
																							}))))),
																		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Emoji$w3_unsafe_decode_CachedEmojiData),
																			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																				$author$project$Ui$Anim$w3_unsafe_decode_State,
																				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																					$author$project$Touch$w3_unsafe_decode_Drag,
																					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																						$author$project$Touch$w3_unsafe_decode_Drag,
																						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																							$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId,
																							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
																								$author$project$AiChat$w3_unsafe_decode_FrontendModel,
																								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
																									function (aiChatModel0) {
																										return function (clientId0) {
																											return function (drag0) {
																												return function (dragPrevious0) {
																													return function (elmUiState0) {
																														return function (emojiData0) {
																															return function (homePagePreview0) {
																																return function (imageViewer0) {
																																	return function (lastCopied0) {
																																		return function (loginStatus0) {
																																			return function (loginType0) {
																																				return function (navigationKey0) {
																																					return function (pageHasFocus0) {
																																						return function (popSound0) {
																																							return function (publicGoMatch0) {
																																								return function (route0) {
																																									return function (startupData0) {
																																										return function (time0) {
																																											return function (timezone0) {
																																												return function (toFrontendLogs0) {
																																													return function (versionNumber0) {
																																														return function (visualViewportHeight0) {
																																															return function (visualViewportTop0) {
																																																return function (windowSize0) {
																																																	return {aiChatModel: aiChatModel0, clientId: clientId0, drag: drag0, dragPrevious: dragPrevious0, elmUiState: elmUiState0, emojiData: emojiData0, homePagePreview: homePagePreview0, imageViewer: imageViewer0, lastCopied: lastCopied0, loginStatus: loginStatus0, loginType: loginType0, navigationKey: navigationKey0, pageHasFocus: pageHasFocus0, popSound: popSound0, publicGoMatch: publicGoMatch0, route: route0, startupData: startupData0, time: time0, timezone: timezone0, toFrontendLogs: toFrontendLogs0, versionNumber: versionNumber0, visualViewportHeight: visualViewportHeight0, visualViewportTop: visualViewportTop0, windowSize: windowSize0};
																																																};
																																															};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									})))))))))))))))))))))))));
var $author$project$Types$w3_unsafe_decode_LoadStatus = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$LoadError);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Types$w3_unsafe_decode_LoginData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$LoadSuccess));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$LoadingData);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Types$w3_unsafe_decode_LoadingFrontend = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Coord$w3_unsafe_decode_Coord($author$project$CssPixels$w3_unsafe_decode_CssPixels),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Ports$w3_unsafe_decode_StartupData),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$author$project$Route$w3_unsafe_decode_Route,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Types$w3_unsafe_decode_PublicGoMatch,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeResult$($author$project$Audio$w3_unsafe_decode_LoadError, $author$project$Audio$w3_unsafe_decode_Source),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$program_test$Effect$Browser$Navigation$w3_unsafe_decode_Key,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Types$w3_unsafe_decode_LoginType,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Types$w3_unsafe_decode_LoadStatus,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId),
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											function (clientId0) {
												return function (loginStatus0) {
													return function (loginType0) {
														return function (navigationKey0) {
															return function (popSound0) {
																return function (publicGoMatch0) {
																	return function (route0) {
																		return function (startupData0) {
																			return function (time0) {
																				return function (windowSize0) {
																					return {clientId: clientId0, loginStatus: loginStatus0, loginType: loginType0, navigationKey: navigationKey0, popSound: popSound0, publicGoMatch: publicGoMatch0, route: route0, startupData: startupData0, time: time0, windowSize: windowSize0};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											})))))))))));
var $author$project$Types$w3_unsafe_decode_FrontendModel_ = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Types$w3_unsafe_decode_LoadedFrontend,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Loaded));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Types$w3_unsafe_decode_LoadingFrontend,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$Loading));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Types$EnableToFrontendLogging = {$: 151};
var $author$project$Id$w3_unsafe_decode_ExportChannelId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Id$ExportChannel_Discord))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Id$ExportChannel_DiscordDm)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Id$ExportChannel_Dm));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Id$ExportChannel_Guild)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Call$w3_unsafe_decode_FromJs = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Call$w3_unsafe_decode_DebugSection),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$FromJs_DebugData));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList(
						$author$project$IdString$w3_unsafe_decode_IdString($author$project$Call$w3_unsafe_decode_MediaDeviceId)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Call$w3_unsafe_decode_MediaDevice),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$FromJs_GotUserMediaDevices)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$FromJs_GotUserMediaDevicesError));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$FromJs_RecordingUploadProgress)));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$FromJs_RecordingUploadsStopped);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$FromJs_ScreenShareStarted);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$FromJs_ScreenShareStopped);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Call$w3_unsafe_decode_LocalOrConnection,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$FromJs_SpeakingChanged)));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$FromJs_StartConnectionError));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$FileStatus$w3_unsafe_decode_MeasuredFile = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Coord$w3_unsafe_decode_Coord($author$project$CssPixels$w3_unsafe_decode_CssPixels),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$FileStatus$MeasuredImage));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Coord$w3_unsafe_decode_Coord($author$project$CssPixels$w3_unsafe_decode_CssPixels),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$FileStatus$MeasuredVideo)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Encryption$w3_unsafe_decode_FromJs = function (w3_x_c_a) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Encryption$w3_unsafe_decode_EncryptFileRequestId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Encryption$FromJs_FileEncryptFailed)));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeBytes),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$FileStatus$w3_unsafe_decode_MeasuredFile),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeBytes,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeBytes,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											F4(
												function (data0, key0, measured0, thumbnail0) {
													return {data: data0, key: key0, measured: measured0, thumbnail: thumbnail0};
												})))))),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Encryption$w3_unsafe_decode_EncryptFileRequestId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Encryption$FromJs_FileEncrypted)));
				case 2:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeList(
							$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, w3_x_c_a)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Encryption$w3_unsafe_decode_DecryptManyRequestId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Encryption$FromJs_ManyMessagesDecrypted)));
				case 3:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Encryption$w3_unsafe_decode_EncryptManyRequestId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Encryption$FromJs_ManyMessagesEncryptFailed)));
				case 4:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeList(
							$author$project$Encryption$w3_unsafe_decode_EncryptedData(w3_x_c_a)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Encryption$w3_unsafe_decode_EncryptManyRequestId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Encryption$FromJs_ManyMessagesEncrypted)));
				case 5:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Encryption$w3_unsafe_decode_DecryptRequestId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Encryption$FromJs_NewMessageDecryptFailed));
				case 6:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_a,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Encryption$w3_unsafe_decode_DecryptRequestId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Encryption$FromJs_NewMessageDecrypted)));
				case 7:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Encryption$w3_unsafe_decode_EncryptRequestId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Encryption$FromJs_NewMessageEncryptFailed)));
				case 8:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Encryption$w3_unsafe_decode_EncryptedData(w3_x_c_a),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Encryption$w3_unsafe_decode_EncryptRequestId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Encryption$FromJs_NewMessageEncrypted)));
				case 9:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Encryption$FromJs_SharedSecretFailed)));
				case 10:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Encryption$FromJs_SharedSecretStored));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$RichText$w3_unsafe_decode_PressedImageId = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$RichText$PressedAttachedFileImage));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$RichText$PressedEmbedImage));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$RichText$w3_unsafe_decode_PressedImageData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$author$project$Point2d$w3_unsafe_decode_Point2d$($author$project$CssPixels$w3_unsafe_decode_CssPixels, $author$project$Touch$w3_unsafe_decode_ScreenCoordinate),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Coord$w3_unsafe_decode_Coord($author$project$CssPixels$w3_unsafe_decode_CssPixels),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$RichText$w3_unsafe_decode_PressedImageId,
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode(
						F5(
							function (displayWidth0, fileUrl0, imageId0, imageSize0, position0) {
								return {displayWidth: displayWidth0, fileUrl: fileUrl0, imageId: imageId0, imageSize: imageSize0, position: position0};
							})))))));
var $author$project$MessageView$w3_unsafe_decode_MessageViewMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageView$MessageViewMsg_PressedCallStartedCard);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageView$MessageViewMsg_PressedEditMessage);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageView$MessageViewMsg_PressedGameStartedCard);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageView$MessageViewMsg_PressedReactionEmoji));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageView$MessageViewMsg_PressedReply);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Coord$w3_unsafe_decode_Coord($author$project$CssPixels$w3_unsafe_decode_CssPixels),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageView$MessageViewMsg_PressedShowFullMenu)));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageView$MessageViewMsg_PressedShowReactionEmojiSelector);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Coord$w3_unsafe_decode_Coord($author$project$CssPixels$w3_unsafe_decode_CssPixels),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeBool,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageView$MessageView_AltPressedMessage))))));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageView$MessageView_MouseEnteredMessage);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageView$MessageView_MouseExitedMessage);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageView$MessageView_NoOp);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $lamdera$codecs$Lamdera$Wire3$decodeFloat),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Point2d$w3_unsafe_decode_Point2d$($author$project$CssPixels$w3_unsafe_decode_CssPixels, $author$project$Touch$w3_unsafe_decode_ScreenCoordinate),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageView$MessageView_PressedCardAnchor)));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_ThreadRoute,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageView$MessageView_PressedChannelMention)));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageView$MessageView_PressedCopyCode));
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $lamdera$codecs$Lamdera$Wire3$decodeFloat),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Point2d$w3_unsafe_decode_Point2d$($author$project$CssPixels$w3_unsafe_decode_CssPixels, $author$project$Touch$w3_unsafe_decode_ScreenCoordinate),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$justinmimbs$date$Date$w3_unsafe_decode_Date,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageView$MessageView_PressedDateDivider))));
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_ThreadRoute,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageView$MessageView_PressedDiscordChannelMention)));
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageView$MessageView_PressedDiscordUserIconButton));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$RichText$w3_unsafe_decode_PressedImageData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageView$MessageView_PressedImage));
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$elm$url$Url$w3_unsafe_decode_Url,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageView$MessageView_PressedNonWhitelistLink));
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageView$MessageView_PressedReactionEmoji_Add));
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageView$MessageView_PressedReactionEmoji_Remove));
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageView$MessageView_PressedReplyLink);
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageView$MessageView_PressedSpoiler));
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $lamdera$codecs$Lamdera$Wire3$decodeFloat),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Point2d$w3_unsafe_decode_Point2d$($author$project$CssPixels$w3_unsafe_decode_CssPixels, $author$project$Touch$w3_unsafe_decode_ScreenCoordinate),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageView$MessageView_PressedTimestamp)));
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $lamdera$codecs$Lamdera$Wire3$decodeFloat),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Point2d$w3_unsafe_decode_Point2d$($author$project$CssPixels$w3_unsafe_decode_CssPixels, $author$project$Touch$w3_unsafe_decode_ScreenCoordinate),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageView$MessageView_PressedUserIconAnchor)));
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageView$MessageView_PressedUserIconButton));
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageView$MessageView_PressedViewThreadLink);
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$NonemptyDict$w3_unsafe_decode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$Touch$w3_unsafe_decode_Touch),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeBool,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageView$MessageView_TouchStart)))))));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$AiChat$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$AiChat$CheckDebounce));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$AiChat$w3_unsafe_decode_ResponseId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$AiChat$EditedResponse)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$(
						$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
						$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$AiChat$w3_unsafe_decode_AiModel)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$AiChat$GotAiModels));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$AiChat$GotLocalStorage));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$AiChat$NoOp);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$AiChat$PressedAddModel);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$AiChat$PressedChatHistoryContainer);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$AiChat$PressedClearChatHistory);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$AiChat$w3_unsafe_decode_ResponseId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$AiChat$PressedDelete));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$AiChat$w3_unsafe_decode_ResponseId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$AiChat$PressedKeep));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$AiChat$PressedOptionsButton);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$AiChat$PressedRemoveModel));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$AiChat$w3_unsafe_decode_ResponseId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$AiChat$PressedRetry));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$AiChat$PressedSend);
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$AiChat$w3_unsafe_decode_AiModelName,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$AiChat$SelectedAiModel)));
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$AiChat$w3_unsafe_decode_SendMessageWith,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$AiChat$SelectedSendMessageWith));
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$AiChat$TypedChatHistory));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$AiChat$TypedMessage));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Call$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Call$w3_unsafe_decode_ConnectionId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$ChangedVolume)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$DoubleClickedVideoNode);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Call$w3_unsafe_decode_LocalOrConnection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$MouseEnterVideoNode));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Call$w3_unsafe_decode_LocalOrConnection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$MouseExitVideoNode));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$PolledDebugData);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$PressedAnswerRecording));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$PressedCancelRecording);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$PressedCopyError));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Call$w3_unsafe_decode_CallId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$PressedJoinCall));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$PressedLeaveCall);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$PressedRecord);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$PressedToggleDebugData);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$PressedToggleDeviceSettings);
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$PressedToggleMute);
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$PressedTogglePauseVideo);
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$PressedToggleScreenShare);
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Call$w3_unsafe_decode_VideoTile,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$PressedVideoTile));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$IdString$w3_unsafe_decode_IdString($author$project$Call$w3_unsafe_decode_MediaDeviceId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$SelectedAudioInputDevice));
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$IdString$w3_unsafe_decode_IdString($author$project$Call$w3_unsafe_decode_MediaDeviceId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Call$SelectedVideoInputDevice));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Drawing$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeFloat,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeFloat,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeFloat,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$lamdera$codecs$Lamdera$Wire3$decodeFloat,
										$lamdera$codecs$Lamdera$Wire3$succeedDecode(
											F4(
												function (height0, width0, x0, y0) {
													return {height: height0, width: width0, x: x0, y: y0};
												}))))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Drawing$GotZoomContainer));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Drawing$PointerDown)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Drawing$PointerMoved)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Drawing$PointerUp);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Drawing$PressedDone);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Drawing$PressedRedo);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Drawing$PressedUndo);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Drawing$PressedZoom);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Editable$w3_unsafe_decode_Msg = function (w3_x_c_value) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Editable$w3_unsafe_decode_Model,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Editable$Edit));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_value,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Editable$PressedAcceptEdit));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Emoji$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Emoji$ClearEmojiHover);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Emoji$w3_unsafe_decode_EmojiOrSticker,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Emoji$KeyboardMovedHover)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Emoji$w3_unsafe_decode_EmojiOrSticker,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Emoji$MouseEnteredEmoji)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Emoji$NoOp);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Emoji$w3_unsafe_decode_Category,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Emoji$PressedCategory)));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Emoji$PressedClearSearch);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Emoji$PressedContainer);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Emoji$w3_unsafe_decode_EmojiOrSticker,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Emoji$PressedSelectEmoji));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Emoji$w3_unsafe_decode_SkinTone),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Emoji$PressedSkinTone));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Emoji$w3_unsafe_decode_Category,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Emoji$ScrolledToCategory));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Emoji$TypedSearchText));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Go$w3_unsafe_decode_SpectatorMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$ChangedViewingMove));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$PressedArrowLeft);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$PressedArrowRight);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$Spectator_PressedCell));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Go$w3_unsafe_decode_GameMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$PressedAgree);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$PressedCell));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$PressedDisagree);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$PressedDoneMarking);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$PressedJoinGame);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$PressedPass);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Go$w3_unsafe_decode_SpectatorMsg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$SpectatorMsg));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$MessageInput$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageInput$IgnoreTouchStart);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageInput$IgnoredKeyPress);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty($lamdera$program_test$Effect$File$w3_unsafe_decode_File),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageInput$OnPasteFiles));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageInput$PressedDropdownItem));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageInput$PressedOpenEmojiSelector);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageInput$PressedPingDropdownContainer);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							function (charsLeft0) {
								return {charsLeft: charsLeft0};
							})),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageInput$PressedSendMessage));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageInput$PressedTextInput);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageInput$PressedUploadFile);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageInput$TypedArrowInDropdown));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageInput$TypedArrowUpInEmptyInput);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageInput$TypedMessage));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageInput$TypedPageDown);
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageInput$TypedPageUp);
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Range$w3_unsafe_decode_Range,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$MessageInput$TypedTabInCodeBlock));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$FileStatus$w3_unsafe_decode_UploadResponse = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$FileStatus$w3_unsafe_decode_VideoMetadata),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$FileStatus$w3_unsafe_decode_ImageMetadata),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$author$project$FileStatus$w3_unsafe_decode_FileHash,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (fileHash0, imageMetadata0, videoMetadata0) {
						return {fileHash: fileHash0, imageMetadata: imageMetadata0, videoMetadata: videoMetadata0};
					})))));
var $author$project$SheepGame$w3_unsafe_decode_GameMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$ExitedQuestion));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$ExitedResultsGrid));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Http$w3_unsafe_decode_Error, $author$project$FileStatus$w3_unsafe_decode_UploadResponse),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$GotAnswerFileUpload))));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty($lamdera$program_test$Effect$File$w3_unsafe_decode_File),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$GotAnswerFiles)));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Http$w3_unsafe_decode_Error, $author$project$FileStatus$w3_unsafe_decode_UploadResponse),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$GotNotesFileUpload))));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty($lamdera$program_test$Effect$File$w3_unsafe_decode_File),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$GotNotesFiles)));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$HoveredQuestion));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$HoveredResultsGrid));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$NoOp);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$PressedCopyCode));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$PressedDeleteAnswerFile)));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$PressedDeleteNotesFile)));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$PressedHidePreviousQuestion);
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$RichText$w3_unsafe_decode_PressedImageData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$PressedImage));
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$PressedLockAnswers);
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$PressedNewQuestionRevealed);
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$PressedRevealScores);
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$PressedShowNextQuestion);
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (fileId0, removeSpoiler0) {
										return {fileId: fileId0, removeSpoiler: removeSpoiler0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$PressedToggleAnswerFileSpoiler)));
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (fileId0, removeSpoiler0) {
										return {fileId: fileId0, removeSpoiler: removeSpoiler0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$PressedToggleNotesFileSpoiler)));
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$PressedUnlockAnswers);
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$PressedViewAnswerFileInfo)));
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$PressedViewNotesFileInfo)));
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MessageView$w3_unsafe_decode_MessageViewMsg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$SheepGame$w3_unsafe_decode_ReactionTarget,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$ReactionMsg)));
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MessageInput$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$TypedAnswer)));
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$TypedGroup))));
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MessageInput$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$TypedNotes)));
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Scroll$w3_unsafe_decode_ScrollPosition,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$UserScrolledResults));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$WordSpellingGame$w3_unsafe_decode_GameMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$(
						$lamdera$program_test$Effect$Http$w3_unsafe_decode_Error,
						$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$WordSpellingGame$w3_unsafe_decode_DictEntry)),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$GotWordDefinition)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$MouseEnterPlayerRow));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$WordSpellingGame$w3_unsafe_decode_Shared,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeList(
							$lamdera$codecs$Lamdera$Wire3$decodePair$(
								$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeInt, $lamdera$codecs$Lamdera$Wire3$decodeInt),
								$author$project$WordSpellingGame$w3_unsafe_decode_LetterOrWildcard)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$MouseEnterWord))));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$MouseExitPlayerRow));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$MouseExitWord);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$PressedClearBoard);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$PressedCloseWordDefinition);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$PressedJoinGame);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$PressedNextWordDefinition);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$PressedPlayerRow));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$PressedPreviousWordDefinition);
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$PressedReplaceTrayOrPass);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$WordSpellingGame$w3_unsafe_decode_PlacedWord,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$PressedSubmitPremove));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$WordSpellingGame$w3_unsafe_decode_PlacedWord,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$PressedSubmitWord));
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$PressedToggleSettings);
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$PressedWordDefinition));
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MessageView$w3_unsafe_decode_MessageViewMsg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$WordSpellingGame$w3_unsafe_decode_ReactionTarget,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$ReactionMsg)));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Scroll$w3_unsafe_decode_ScrollPosition,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$UserScrolledPastMoves));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Go$w3_unsafe_decode_SetupMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$ChangedHandicapInput));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$ChangedHeightInput));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$ChangedIncrementInput));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$ChangedKomiInput));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$ChangedMainTimeInput));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$ChangedWidthInput));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$PressedCancel);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$PressedStartGame);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Go$w3_unsafe_decode_Stone,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$SelectedPlayingAs));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Go$w3_unsafe_decode_SizeSelection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Go$SelectedSize));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$SheepGame$w3_unsafe_decode_SetupMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Http$w3_unsafe_decode_Error, $author$project$FileStatus$w3_unsafe_decode_UploadResponse),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$GotAttachedFileUpload))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty($lamdera$program_test$Effect$File$w3_unsafe_decode_File),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$GotFilesToAttach)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$PressedAddQuestion);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$PressedCancel);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$PressedDeleteAttachedFile)));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$PressedRemoveQuestion));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$PressedStartGame);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (fileId0, removeSpoiler0) {
										return {fileId: fileId0, removeSpoiler: removeSpoiler0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$PressedToggleAttachedFileSpoiler)));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$PressedViewAttachedFileInfo)));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MessageInput$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_QuestionId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$SheepGame$TypedQuestion)));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$WordSpellingGame$w3_unsafe_decode_SetupMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$ChangedFullTrayBonusInput));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeChar,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$ChangedLetterValue)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$ChangedLettersInput));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$OneOrGreater$w3_unsafe_decode_OneOrGreater,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$ChangedPlaceWordAttempts));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$ChangedTraySizeInput));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$PressedCancel);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$PressedExpandAdvancedSettings);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$WordSpellingGame$w3_unsafe_decode_Language,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$PressedLanguage));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$PressedResetLetters);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$WordSpellingGame$PressedStartGame);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Game$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Go$w3_unsafe_decode_GameMsg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$GoGameMsg));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Go$w3_unsafe_decode_SetupMsg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$GoSetupMsg));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$NoOpMsg);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$PressedCopyLink));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$PressedReset);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Message$w3_unsafe_decode_GameType,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$PressedSelectGame));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$PressedShareMatch));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$SelectedMatch));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$SheepGame$w3_unsafe_decode_GameMsg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$SheepGameMsg));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$SheepGame$w3_unsafe_decode_SetupMsg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$SheepSetupMsg));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$WordSpellingGame$w3_unsafe_decode_GameMsg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$WordSpellingGameMsg));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$WordSpellingGame$w3_unsafe_decode_SetupMsg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Game$WordSpellingSetupMsg));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Ports$w3_unsafe_decode_CropImageDataResponse = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeInt,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (croppedImageUrl0, requestId0) {
					return {croppedImageUrl: croppedImageUrl0, requestId: requestId0};
				}))));
var $author$project$ImageEditor$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeString, $author$project$Ports$w3_unsafe_decode_CropImageDataResponse),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageEditor$CroppedImage));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Error, $lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Element),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageEditor$GotImageSize));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageEditor$GotImageUrl));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageEditor$MouseDownImageEditor)));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageEditor$MouseUpImageEditor);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageEditor$MovedImageEditor)));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageEditor$PressedCancel);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageEditor$PressedConfirmImage);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageEditor$PressedProfileImage);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageEditor$PressedRemoveImage);
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$File$w3_unsafe_decode_File,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageEditor$SelectedImage));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageEditor$TouchEndImageEditor);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Http$w3_unsafe_decode_Error, $author$project$FileStatus$w3_unsafe_decode_UploadResponse),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageEditor$UploadedImage));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$ImageViewer$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageViewer$AnimationFrame));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageViewer$MouseDown)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageViewer$MouseMove)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageViewer$MouseUp);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageViewer$PressStartedOnButton);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageViewer$PressedClose);
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageViewer$PressedZoomIn);
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageViewer$PressedZoomOut);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageViewer$TouchEnd);
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $lamdera$codecs$Lamdera$Wire3$decodeFloat)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageViewer$TouchMove));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeFloat, $lamdera$codecs$Lamdera$Wire3$decodeFloat)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageViewer$TouchStart));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeFloat,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageViewer$Wheeled))));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$LoginForm$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LoginForm$PressedCancelLogin);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LoginForm$PressedSubmitEmail);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LoginForm$PressedSubmitUserData);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LoginForm$TypedLoginCode));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LoginForm$TypedLoginFormEmail));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LoginForm$TypedName));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$LoginForm$TypedTwoFactorCode));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Table$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Table$PressedShowAll);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Table$PressedSortBy));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Pages$Admin$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Editable$w3_unsafe_decode_Msg(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$DiscordLinkLimitEditableMsg));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Pages$Admin$w3_unsafe_decode_UserColumn,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Pages$Admin$w3_unsafe_decode_UserTableId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$EditCellLostFocus)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Pages$Admin$w3_unsafe_decode_UserColumn,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Pages$Admin$w3_unsafe_decode_UserTableId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$EnterKeyInEditCell)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$EscapeKeyInEditCell);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$FocusedOnEditCell);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBytes,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$GotImportBackendFileContent));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$File$w3_unsafe_decode_File,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ImportBackendFileSelected));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Editable$w3_unsafe_decode_Msg(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$NotifyAdminsBotUserIdEditableMsg));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Editable$w3_unsafe_decode_Msg(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$NotifyAdminsTokenEditableMsg));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Editable$w3_unsafe_decode_Msg(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$OpenRouterKeyEditableMsg));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Editable$w3_unsafe_decode_Msg($author$project$Postmark$w3_unsafe_decode_ApiKey),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PostmarkKeyEditableMsg));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedAddUserRow);
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedCancelExportSubset);
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedConfirmExportSubset);
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Pagination$w3_unsafe_decode_ItemId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedCopyLogLink));
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedCopyText));
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedDeleteDiscordDmChannel));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedDeleteDiscordGuild));
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedDeleteGuild));
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedDeleteOrphanedFiles);
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$SessionIdHash$w3_unsafe_decode_SessionIdHash,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedDeleteSession));
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_DmChannelId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedDeleteSlackDmChannel));
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedDeleteSlackWorkspace));
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Pages$Admin$w3_unsafe_decode_UserTableId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedDeleteUser));
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Lamdera$w3_unsafe_decode_ClientId,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$SessionIdHash$w3_unsafe_decode_SessionIdHash,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedDisconnectClient)));
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedDownloadLastBackup);
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Pages$Admin$w3_unsafe_decode_UserColumn,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Pages$Admin$w3_unsafe_decode_UserTableId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedEditCell)));
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedExpandDiscordGuild));
			case 28:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedExpandGuild));
			case 29:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Pages$Admin$w3_unsafe_decode_AdminUiSection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedExpandSection));
			case 30:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedExpandSlackWorkspace));
			case 31:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedExportBackend);
			case 32:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedExportSubsetBackend);
			case 33:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedHomepageLink);
			case 34:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedImportBackend);
			case 35:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Pagination$w3_unsafe_decode_PageId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedLogPage));
			case 36:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedRegenerateServerSecret);
			case 37:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedReloadDiscordChannel))));
			case 38:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedReloadDiscordDmChannel)));
			case 39:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedReloadDiscordGuild)));
			case 40:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedResetUser));
			case 41:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedResetUserChanges);
			case 42:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedRestoreGuild));
			case 43:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedSaveUserChanges);
			case 44:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedSendTypeThatIsAlwaysInvalid);
			case 45:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PressedWebsocketCloseEventsPage));
			case 46:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Editable$w3_unsafe_decode_Msg($author$project$LocalState$w3_unsafe_decode_PrivateVapidKey),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PrivateVapidKeyEditableMsg));
			case 47:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Editable$w3_unsafe_decode_Msg($lamdera$codecs$Lamdera$Wire3$decodeString),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$PublicVapidKeyEditableMsg));
			case 48:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Editable$w3_unsafe_decode_Msg(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$SlackLinkLimitEditableMsg));
			case 49:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$TabKeyInEditCell));
			case 50:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Pages$Admin$w3_unsafe_decode_UserTableId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ToggleIsAdmin)));
			case 51:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ToggledDiscordLinkingEnabled));
			case 52:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ToggledEmailNotifications));
			case 53:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ToggledExportSubsetDiscordDmChannel)));
			case 54:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ToggledExportSubsetDiscordGuild)));
			case 55:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$DmChannelId$w3_unsafe_decode_DmChannelId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ToggledExportSubsetDmChannel)));
			case 56:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ToggledExportSubsetGuild)));
			case 57:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ToggledSignupsEnabled));
			case 58:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ToggledSlackLinkingEnabled));
			case 59:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$TypedEditCell));
			case 60:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$TypedInReadOnlyTextInput);
			case 61:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Table$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$UserTableMsg));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$RecoveryLogin$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$RecoveryLogin$PressedSubmit);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$RecoveryLogin$TypedPassword));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$TextEditor$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TextEditor$PressedBack);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TextEditor$PressedReset);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TextEditor$RedoChange);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TextEditor$TypedText));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TextEditor$UndoChange);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$TwoFactorAuthentication$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TwoFactorAuthentication$PressedCancelDisable2Fa);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TwoFactorAuthentication$PressedCopy));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TwoFactorAuthentication$PressedStart2FaSetup);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TwoFactorAuthentication$PressedStartDisable2Fa);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TwoFactorAuthentication$TypedDisableTwoFactorCode));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TwoFactorAuthentication$TypedTwoFactorCode));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Internal$Model2$Tick = function (a) {
	return {$: 0, a: a};
};
var $author$project$Internal$Teleport$w3_unsafe_decode_CssAnimation = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList(
				$lamdera$codecs$Lamdera$Wire3$decodePair$($lamdera$codecs$Lamdera$Wire3$decodeString, $lamdera$codecs$Lamdera$Wire3$decodeString)),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							F6(
								function (hash0, keyframes0, keyframesHash0, props0, transition0, trigger0) {
									return {hash: hash0, keyframes: keyframes0, keyframesHash: keyframesHash0, props: props0, transition: transition0, trigger: trigger0};
								}))))))));
var $author$project$Internal$Teleport$w3_unsafe_decode_ParentTriggerDetails = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeString,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeString,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Internal$Teleport$w3_unsafe_decode_CssAnimation),
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F3(
					function (children0, identifierClass0, trigger0) {
						return {children: children0, identifierClass: identifierClass0, trigger: trigger0};
					})))));
var $author$project$Internal$Teleport$w3_unsafe_decode_Data = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Internal$Teleport$w3_unsafe_decode_CssAnimation,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Internal$Teleport$Css));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Internal$Teleport$w3_unsafe_decode_ParentTriggerDetails,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Internal$Teleport$ParentTrigger));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Internal$Teleport$w3_unsafe_decode_Event = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeFloat,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$Internal$Teleport$w3_unsafe_decode_Data),
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (data0, timestamp0) {
					return {data: data0, timestamp: timestamp0};
				}))));
var $author$project$Internal$Teleport$OnActive = 4;
var $author$project$Internal$Teleport$OnFocus = 2;
var $author$project$Internal$Teleport$w3_unsafe_decode_Trigger = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(4);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(5);
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(2);
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(3);
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(0);
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode(1);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Internal$Model2$w3_unsafe_decode_Msg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Internal$Teleport$w3_unsafe_decode_Event,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Internal$Teleport$w3_unsafe_decode_Trigger,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Internal$Model2$Teleported)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					A2(
						$lamdera$codecs$Lamdera$Wire3$andThenDecode,
						function (t) {
							return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
								$elm$time$Time$millisToPosix(t));
						},
						$lamdera$codecs$Lamdera$Wire3$decodeInt),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Internal$Model2$Tick));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Ui$Anim$w3_unsafe_decode_Msg = $author$project$Internal$Model2$w3_unsafe_decode_Msg;
var $author$project$Types$w3_unsafe_decode_FrontendMsg_ = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Pages$Admin$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$AdminPageMsg));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$AiChat$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$AiChatMsg));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$ChannelSidebarAnimated));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeString),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeBool,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
									$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
										$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
										$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
											$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
											$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$CheckMessageAltPress))))))));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Ports$w3_unsafe_decode_NotificationPermission,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$CheckedNotificationPermission));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_GuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$CheckedSheepGameQuestionsDebounce)));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$SheepGame$w3_unsafe_decode_Input,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_GuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$CheckedSheepGameSaveDebounce)))));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$DebouncedTyping);
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_HtmlId),
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Range$w3_unsafe_decode_Range, $author$project$Range$w3_unsafe_decode_SelectionDirection))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$DomFocusChanged));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Drawing$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$DrawingMsg));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Types$w3_unsafe_decode_EditChannelForm,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$EditChannelFormChanged))));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Types$w3_unsafe_decode_EditGuildForm,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$EditGuildFormChanged)));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Http$w3_unsafe_decode_Error, $author$project$FileStatus$w3_unsafe_decode_UploadResponse),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Id$w3_unsafe_decode_ThreadRoute),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$EditMessage_GotFileHashName)))));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MessageInput$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_ThreadRoute,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$EditMessage_MessageInputMsg))));
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Id$w3_unsafe_decode_ThreadRoute),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$EditMessage_PressedDeleteAttachedFile)));
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (fileId0, removeSpoiler0) {
										return {fileId: fileId0, removeSpoiler: removeSpoiler0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Id$w3_unsafe_decode_ThreadRoute),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$EditMessage_PressedToggleAttachedFileSpoiler)));
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Id$w3_unsafe_decode_ThreadRoute),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$EditMessage_PressedViewAttachedFileInfo)));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$program_test$Effect$File$w3_unsafe_decode_File),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$File$w3_unsafe_decode_File,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Id$w3_unsafe_decode_ThreadRoute),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$EditMessage_SelectedFilesToAttach))));
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Ui$Anim$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$ElmUiMsg));
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Emoji$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$EmojiSelectorMsg));
			case 20:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$EnableToFrontendLogging);
			case 21:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$author$project$Encryption$w3_unsafe_decode_FromJs(
							$author$project$Message$w3_unsafe_decode_MessageContent$(
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId)))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$EncryptionFromJs));
			case 22:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$FileDragEnter));
			case 23:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$FileDragLeave);
			case 24:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$program_test$Effect$File$w3_unsafe_decode_File),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$FileDropped));
			case 25:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Http$w3_unsafe_decode_Progress,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Id$w3_unsafe_decode_ThreadRoute),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$FileUploadProgress))));
			case 26:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$FrontendNoOp);
			case 27:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Game$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$GameMsg));
			case 28:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Go$w3_unsafe_decode_SpectatorMsg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$GoSpectatorMsg));
			case 29:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeFloat,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$GotDevicePixelRatio));
			case 30:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Http$w3_unsafe_decode_Error, $author$project$Emoji$w3_unsafe_decode_CachedEmojiData),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$GotEmojiData));
			case 31:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Http$w3_unsafe_decode_Error, $author$project$FileStatus$w3_unsafe_decode_UploadResponse),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$FileStatus$w3_unsafe_decode_FileMetadata),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Id$w3_unsafe_decode_ThreadRoute),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$GotFileHashName)))));
			case 32:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBytes,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Id$w3_unsafe_decode_ThreadRoute),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$GotFileToEncrypt)))));
			case 33:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeString,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (fileName0, json0) {
										return {fileName: fileName0, json: json0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$GotImportChannelFile)));
			case 34:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Error, $author$project$MessageInput$w3_unsafe_decode_MentionUserDropdown),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_HtmlId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$GotPingUserPosition)));
			case 35:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Error, $lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Element),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$GotPositionForEmojiSelector_EditMessage));
			case 36:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Error, $lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Element),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$SheepGame$w3_unsafe_decode_Input,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$GotPositionForEmojiSelector_SheepGameInput)));
			case 37:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Ports$w3_unsafe_decode_RegisterPushSubscription,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$GotRegisterPushSubscription));
			case 38:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$GotServiceWorkerData));
			case 39:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$GotServiceWorkerMessage));
			case 40:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeString, $author$project$Ports$w3_unsafe_decode_StartupData),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$GotStartupData));
			case 41:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$Time$w3_unsafe_decode_Posix,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$GotTime));
			case 42:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeUnit, $lamdera$codecs$Lamdera$Wire3$decodeInt),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$GotVersionNumber));
			case 43:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$codecs$Lamdera$Wire3$decodeString, $author$project$Call$w3_unsafe_decode_FromJs),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$GotVoiceChatSignalFromJs));
			case 44:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$GotWindowSize)));
			case 45:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$ImageEditor$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$GuildIconEditorMsg)));
			case 46:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$ImageViewer$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$ImageViewerMsg));
			case 47:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeBool,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeString,
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$lamdera$codecs$Lamdera$Wire3$decodeBool,
									$lamdera$codecs$Lamdera$Wire3$succeedDecode(
										F4(
											function (ctrlKey0, key0, metaKey0, shiftKey0) {
												return {ctrlKey: ctrlKey0, key: key0, metaKey: metaKey0, shiftKey: shiftKey0};
											})))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$KeyDown));
			case 48:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($author$project$Audio$w3_unsafe_decode_LoadError, $author$project$Audio$w3_unsafe_decode_Source),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$LoadedPopSound));
			case 49:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$LoginForm$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$LoginFormMsg));
			case 50:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MessageInput$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_ThreadRoute,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$MessageInputMsg))));
			case 51:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$MessageMenuAnimated));
			case 52:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$NonemptySet$w3_unsafe_decode_NonemptySet(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_CustomEmojiId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$MessageMenu_PressedAddCustomEmojisToUser));
			case 53:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$MessageMenu_PressedClose);
			case 54:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$MessageMenu_PressedContainer);
			case 55:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$MessageMenu_PressedDeleteMessage)));
			case 56:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$MessageMenu_PressedEditMessage)));
			case 57:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$MessageMenu_PressedMarkAsUnread)));
			case 58:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$MessageMenu_PressedOpenDiscordDm)));
			case 59:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$MessageMenu_PressedOpenDm));
			case 60:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$MessageMenu_PressedOpenThread));
			case 61:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Emoji$w3_unsafe_decode_EmojiOrCustomEmoji,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$MessageMenu_PressedReactionEmoji));
			case 62:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$MessageMenu_PressedReply));
			case 63:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Coord$w3_unsafe_decode_Coord($author$project$CssPixels$w3_unsafe_decode_CssPixels),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$MessageMenu_PressedShowReactionEmojiSelector))));
			case 64:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MessageView$w3_unsafe_decode_MessageViewMsg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$MessageViewMsg))));
			case 65:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Types$w3_unsafe_decode_NewChannelForm,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$NewChannelFormChanged)));
			case 66:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Types$w3_unsafe_decode_NewGuildForm,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$NewGuildFormChanged));
			case 67:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$OneFrameAfterDragEnd);
			case 68:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PageFocusSettled);
			case 69:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PageHasFocusChanged));
			case 70:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Error, $lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_Viewport),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PageUpGotViewport));
			case 71:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedAccountDeletionBanner);
			case 72:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedAddDomainToWhitelist));
			case 73:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedAddPrivateKeyToAccount);
			case 74:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedBanMember)));
			case 75:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedBody);
			case 76:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedCancelE2eeRequest));
			case 77:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Id$w3_unsafe_decode_ThreadRoute),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedCancelMessageEdit));
			case 78:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedChannelHeaderBackButton);
			case 79:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_ChannelHeaderTab,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedChannelHeaderTab));
			case 80:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedCloseAccountDeletionBanner);
			case 81:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedCloseExternalLinkWarning);
			case 82:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedCloseImageInfo);
			case 83:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedCloseNewPrivateKey);
			case 84:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedCloseOverlay);
			case 85:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Id$w3_unsafe_decode_ThreadRoute),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedCloseReplyTo));
			case 86:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedContinueToSite);
			case 87:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedCopyImage));
			case 88:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedCopyText));
			case 89:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedCreateInviteLink));
			case 90:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedDeclineE2eeRequest));
			case 91:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedDeleteAccount);
			case 92:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Id$w3_unsafe_decode_ThreadRoute),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedDeleteAttachedFile)));
			case 93:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedDeleteChannel)));
			case 94:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedDeleteGuild));
			case 95:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$SecretId$w3_unsafe_decode_SecretId($author$project$Id$w3_unsafe_decode_InviteLinkId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedDeleteInviteLink)));
			case 96:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedDisableE2ee));
			case 97:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedDiscordAcknowledgment));
			case 98:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (currentUserId0, otherUserId0) {
										return {currentUserId: currentUserId0, otherUserId: otherUserId0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedDiscordGuildMemberLabel));
			case 99:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$User$w3_unsafe_decode_NotificationLevel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedDiscordGuildNotificationLevel))));
			case 100:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedE2eeRisksAccepted));
			case 101:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedEnableE2ee));
			case 102:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_UserOptionSection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedExpandContainer));
			case 103:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedExpandE2eeSection));
			case 104:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_ExportChannelId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedExportChannel));
			case 105:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$User$w3_unsafe_decode_NotificationLevel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedGuildNotificationLevel)));
			case 106:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedHideMembers);
			case 107:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedHomePagePreview));
			case 108:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedImportChannel));
			case 109:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedLeaveGuild));
			case 110:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Route$w3_unsafe_decode_Route,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedLink));
			case 111:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedLoadDebugData);
			case 112:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$SessionIdHash$w3_unsafe_decode_SessionIdHash,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedLogOut));
			case 113:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedMarkAllChannelsAsRead));
			case 114:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_ThreadRouteWithMessage,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedMarkChannelAsRead)));
			case 115:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedMemberListBack);
			case 116:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedMuteChannel))));
			case 117:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedMuteDiscordChannel)))));
			case 118:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedMuteDiscordGuild))));
			case 119:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedMuteDiscordThread))))));
			case 120:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedMuteGuild)));
			case 121:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedMuteSlackChannel)))));
			case 122:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
								$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
									$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
									$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedMuteSlackThread))))));
			case 123:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedMuteSlackWorkspace))));
			case 124:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MuteSettings$w3_unsafe_decode_IsMuted,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedMuteThread)))));
			case 125:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedNewMessagesWarning);
			case 126:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedNotification));
			case 127:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedReloadDiscordUser));
			case 128:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedReloadSlackUser));
			case 129:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedRemoveSlackTeam));
			case 130:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedResetDomainWhitelist);
			case 131:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedResetEditChannelChanges)));
			case 132:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedResetEditGuildChanges));
			case 133:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedResetUserColor);
			case 134:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedSaveDomainWhitelist);
			case 135:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedSearchOverlayArrowKey));
			case 136:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedSearchOverlayEnter);
			case 137:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Route$w3_unsafe_decode_Route,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedSearchOverlayResult));
			case 138:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedSelectNewColor);
			case 139:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedShowLogin);
			case 140:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedShowMembers);
			case 141:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedShowSearchOverlay);
			case 142:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedShowUserOption);
			case 143:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBool,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedSlackAcknowledgment));
			case 144:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$User$w3_unsafe_decode_NotificationLevel,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_TeamId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedSlackWorkspaceNotificationLevel))));
			case 145:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Types$w3_unsafe_decode_EditChannelForm,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedSubmitEditChannelChanges))));
			case 146:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Types$w3_unsafe_decode_EditGuildForm,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedSubmitEditGuildChanges)));
			case 147:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Types$w3_unsafe_decode_NewChannelForm,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedSubmitNewChannel)));
			case 148:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Types$w3_unsafe_decode_NewGuildForm,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedSubmitNewGuild));
			case 149:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedSubmitSlackData);
			case 150:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedSubmitUserColor);
			case 151:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeBool,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (fileId0, removeSpoiler0) {
										return {fileId: fileId0, removeSpoiler: removeSpoiler0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Id$w3_unsafe_decode_ThreadRoute),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedToggleAttachedFileSpoiler)));
			case 152:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$SecretId$w3_unsafe_decode_SecretId($author$project$Id$w3_unsafe_decode_InviteLinkId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedToggleInviteLinkQrCode));
			case 153:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedUnlinkDiscordUser));
			case 154:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Slack$w3_unsafe_decode_Id($author$project$Slack$w3_unsafe_decode_UserId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedUnlinkSlackUser));
			case 155:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedUnregisterServiceWorkers);
			case 156:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_Id($author$project$FileStatus$w3_unsafe_decode_FileId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Id$w3_unsafe_decode_ThreadRoute),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$PressedViewAttachedFileInfo)));
			case 157:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$ImageEditor$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$ProfilePictureEditorMsg));
			case 158:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$RecoveryLogin$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$RecoveryLoginMsg));
			case 159:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$RemoveFocus);
			case 160:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (bottom0, top0) {
										return {bottom: bottom0, top: top0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$SafeAreaInsetsChanged));
			case 161:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$ScrolledToLogSection);
			case 162:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$ScrolledToMessage);
			case 163:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$User$w3_unsafe_decode_EmailNotifications,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$SelectedEmailNotifications));
			case 164:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$User$w3_unsafe_decode_EmbedVisibility,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$SelectedEmbedVisibility));
			case 165:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($lamdera$program_test$Effect$File$w3_unsafe_decode_File),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$program_test$Effect$File$w3_unsafe_decode_File,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Id$w3_unsafe_decode_AnyGuildOrDmId, $author$project$Id$w3_unsafe_decode_ThreadRoute),
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$SelectedFilesToAttach))));
			case 166:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$program_test$Effect$File$w3_unsafe_decode_File,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$SelectedImportChannelFile)));
			case 167:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserSession$w3_unsafe_decode_NotificationMode,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$SelectedNotificationMode));
			case 168:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserColor$w3_unsafe_decode_Selection,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$SelectedUserColor));
			case 169:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$SetFocus);
			case 170:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$SetScrollToBottom);
			case 171:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$TextEditor$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$TextEditorMsg));
			case 172:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodePair$(
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$program_test$Effect$Browser$Dom$w3_unsafe_decode_HtmlId),
						$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
							$lamdera$codecs$Lamdera$Wire3$decodePair$($author$project$Range$w3_unsafe_decode_Range, $author$project$Range$w3_unsafe_decode_SelectionDirection))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$TextSelectionChanged));
			case 173:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$TouchCancel));
			case 174:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$TouchEnd));
			case 175:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$NonemptyDict$w3_unsafe_decode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$Touch$w3_unsafe_decode_Touch),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$TouchMoved)));
			case 176:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$NonemptyDict$w3_unsafe_decode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$Touch$w3_unsafe_decode_Touch),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$TouchStart)));
			case 177:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$TwoFactorAuthentication$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$TwoFactorMsg));
			case 178:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$TypedDiscordLinkBookmarklet);
			case 179:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$TypedDomainWhitelist));
			case 180:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$TypedPrivateKey)));
			case 181:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$TypedSearchOverlay));
			case 182:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$TypedSlackCookie));
			case 183:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$TypedSlackTeamsJson));
			case 184:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MessageView$w3_unsafe_decode_MessageViewMsg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$UnreadOverviewChannelMsg))));
			case 185:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$MessageView$w3_unsafe_decode_MessageViewMsg,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ThreadMessageId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelMessageId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$UnreadOverviewThreadMsg)))));
			case 186:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$elm$url$Url$w3_unsafe_decode_Url,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$UrlChanged));
			case 187:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$elm$browser$Browser$w3_unsafe_decode_UrlRequest,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$UrlClicked));
			case 188:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Editable$w3_unsafe_decode_Msg($author$project$PersonName$w3_unsafe_decode_PersonName),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$UserNameEditableMsg));
			case 189:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Scroll$w3_unsafe_decode_ScrollPosition,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_ThreadRoute,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_AnyGuildOrDmId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$UserScrolled))));
			case 190:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Types$w3_unsafe_decode_E2eeKeysValid,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$ValidatedE2eePrivateKey)));
			case 191:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeFloat,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (height0, top0) {
										return {height: height0, top: top0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$VisualViewportChanged));
			case 192:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Call$w3_unsafe_decode_Msg,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$VoiceChatMsg));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Audio$w3_unsafe_decode_AudioLoadRequest_ = function (w3_x_c_userMsg) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
			$lamdera$codecs$Lamdera$Wire3$decodePair$(
				$lamdera$codecs$Lamdera$Wire3$decodeResult$($author$project$Audio$w3_unsafe_decode_LoadError, $author$project$Audio$w3_unsafe_decode_Source),
				w3_x_c_userMsg)),
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeString,
			$lamdera$codecs$Lamdera$Wire3$succeedDecode(
				F2(
					function (audioUrl0, userMsg0) {
						return {audioUrl: audioUrl0, userMsg: userMsg0};
					}))));
};
var $author$project$Audio$w3_unsafe_decode_LoopConfig = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (loopEnd0, loopStart0) {
					return {loopEnd: loopEnd0, loopStart: loopStart0};
				}))));
var $author$project$Audio$w3_unsafe_decode_FlattenedAudio = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$lamdera$codecs$Lamdera$Wire3$decodeList(
		$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty(
			$lamdera$codecs$Lamdera$Wire3$decodePair$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$andThenDecode,
					function (t) {
						return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
							$elm$time$Time$millisToPosix(t));
					},
					$lamdera$codecs$Lamdera$Wire3$decodeInt),
				$lamdera$codecs$Lamdera$Wire3$decodeFloat))),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$lamdera$codecs$Lamdera$Wire3$decodeFloat,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			A2(
				$lamdera$codecs$Lamdera$Wire3$andThenDecode,
				function (t) {
					return $lamdera$codecs$Lamdera$Wire3$succeedDecode(
						$elm$time$Time$millisToPosix(t));
				},
				$lamdera$codecs$Lamdera$Wire3$decodeInt),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Audio$w3_unsafe_decode_Source,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeFloat,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$Audio$w3_unsafe_decode_LoopConfig),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F8(
										function (loop0, offset0, playbackRate0, source0, startAt0, startTime0, volume0, volumeTimelines0) {
											return {loop: loop0, offset: offset0, playbackRate: playbackRate0, source: source0, startAt: startAt0, startTime: startTime0, volume: volume0, volumeTimelines: volumeTimelines0};
										}))))))))));
var $author$project$Audio$w3_unsafe_decode_NodeGroupId = $lamdera$codecs$Lamdera$Wire3$decodeInt;
var $author$project$Audio$w3_unsafe_decode_SourceData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
	$lamdera$codecs$Lamdera$Wire3$succeedDecode(
		function (duration0) {
			return {duration: duration0};
		}));
var $author$project$Audio$w3_unsafe_decode_Model_$ = function (w3_x_c_userMsg, w3_x_c_userModel) {
	return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		w3_x_c_userModel,
		$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
			$lamdera$codecs$Lamdera$Wire3$decodeDict$($lamdera$codecs$Lamdera$Wire3$decodeInt, $author$project$Audio$w3_unsafe_decode_SourceData),
			$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeMaybe($lamdera$codecs$Lamdera$Wire3$decodeInt),
				$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeDict$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$author$project$Audio$w3_unsafe_decode_AudioLoadRequest_(w3_x_c_userMsg)),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeDict$($author$project$Audio$w3_unsafe_decode_NodeGroupId, $author$project$Audio$w3_unsafe_decode_FlattenedAudio),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F7(
										function (audioState0, nodeGroupIdCounter0, pendingRequests0, requestCount0, samplesPerSecond0, sourceData0, userModel0) {
											return {audioState: audioState0, nodeGroupIdCounter: nodeGroupIdCounter0, pendingRequests: pendingRequests0, requestCount: requestCount0, samplesPerSecond: samplesPerSecond0, sourceData: sourceData0, userModel: userModel0};
										})))))))));
};
var $author$project$Audio$w3_unsafe_decode_Model_ = F2($author$project$Audio$w3_unsafe_decode_Model_$);
var $author$project$Audio$w3_unsafe_decode_Model$ = function (w3_x_c_userMsg, w3_x_c_userModel) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			if (!w3v) {
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Audio$w3_unsafe_decode_Model_$(w3_x_c_userMsg, w3_x_c_userModel),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
			} else {
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Audio$w3_unsafe_decode_Model = F2($author$project$Audio$w3_unsafe_decode_Model$);
var $author$project$Types$w3_unsafe_decode_FrontendModel = $author$project$Audio$w3_unsafe_decode_Model$($author$project$Types$w3_unsafe_decode_FrontendMsg_, $author$project$Types$w3_unsafe_decode_FrontendModel_);
var $author$project$LamderaGenerated$decodeAndUpgradeFrontendModel$ = function (version, bytes) {
	switch (version) {
		case 418:
			return $author$project$LamderaHelpers$otherwiseError(
				$author$project$LamderaHelpers$upgradeSucceeds(
					$author$project$LamderaHelpers$thenMigrateModel$(
						4,
						$elm$core$Basics$always($lamdera$codecs$Lamdera$Migrations$ModelUnchanged),
						$author$project$Evergreen$V419$Types$w3_encode_FrontendModel,
						$author$project$Types$w3_unsafe_decode_FrontendModel,
						420,
						$author$project$LamderaHelpers$thenMigrateModel$(
							4,
							$author$project$Evergreen$Migrate$V419$frontendModel,
							$author$project$Evergreen$V417$Types$w3_encode_FrontendModel,
							$author$project$Evergreen$V419$Types$w3_unsafe_decode_FrontendModel,
							419,
							$author$project$LamderaHelpers$decodeType$(4, 417, bytes, $author$project$Evergreen$V417$Types$w3_unsafe_decode_FrontendModel)))));
		case 419:
			return $author$project$LamderaHelpers$otherwiseError(
				$author$project$LamderaHelpers$upgradeSucceeds(
					$author$project$LamderaHelpers$decodeType$(4, 420, bytes, $author$project$Types$w3_unsafe_decode_FrontendModel)));
		case 420:
			return $author$project$LamderaHelpers$otherwiseError(
				$author$project$LamderaHelpers$upgradeIsCurrent(
					$author$project$LamderaHelpers$decodeType$(4, version, bytes, $author$project$Types$w3_unsafe_decode_FrontendModel)));
		default:
			return $author$project$LamderaHelpers$UnknownVersion(
				_Utils_Tuple3(version, 'FrontendModel', bytes));
	}
};
var $author$project$LamderaGenerated$decodeAndUpgradeFrontendModel = F2($author$project$LamderaGenerated$decodeAndUpgradeFrontendModel$);
var $lamdera$codecs$Lamdera$Migrations$MsgUnchanged = {$: 0};
var $author$project$Evergreen$Migrate$V419$frontendMsg = function (old) {
	return $lamdera$codecs$Lamdera$Migrations$MsgUnchanged;
};
var $author$project$LamderaHelpers$migrateMsgValue$ = function (tipe, migrationFn, oldValue, oldEncoder, newDecoder, newVersion) {
	var _v0 = migrationFn(oldValue);
	switch (_v0.$) {
		case 1:
			var _v1 = _v0.a;
			var newValue = _v1.a;
			var cmds = _v1.b;
			return $elm$core$Result$Ok(
				_Utils_Tuple2(newValue, cmds));
		case 0:
			return function (bytes) {
				return $author$project$LamderaHelpers$decodeType$(tipe, newVersion, bytes, newDecoder);
			}(
				$lamdera$codecs$Lamdera$Wire3$bytesEncode(
					oldEncoder(oldValue)));
		default:
			return $elm$core$Result$Err(
				'Migration for ' + ($author$project$LamderaHelpers$tipeIntToString(tipe) + ('.' + ($elm$core$String$fromInt(newVersion - 1) + ('->' + ($elm$core$String$fromInt(newVersion) + ' ignores old values'))))));
	}
};
var $author$project$LamderaHelpers$migrateMsgValue = F6($author$project$LamderaHelpers$migrateMsgValue$);
var $author$project$LamderaHelpers$thenMigrateMsg$ = function (tipe, migrationFn, oldEncoder, newDecoder, newVersion, priorResult) {
	return $elm$core$Result$andThen$(
		function (_v0) {
			var oldValue = _v0.a;
			return $author$project$LamderaHelpers$migrateMsgValue$(tipe, migrationFn, oldValue, oldEncoder, newDecoder, newVersion);
		},
		priorResult);
};
var $author$project$LamderaHelpers$thenMigrateMsg = F6($author$project$LamderaHelpers$thenMigrateMsg$);
var $author$project$Evergreen$V417$Audio$w3_encode_FromJSMsg = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Evergreen$V417$Audio$w3_encode_LoadError(w3_rec_var0.error),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.requestId)
								]));
					}(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Evergreen$V417$Audio$w3_encode_BufferId(w3_rec_var0.bufferId),
									$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var0.duration),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.requestId)
								]));
					}(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.samplesPerSecond)
								]));
					}(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.error)
								]));
					}(v0)
					]));
	}
};
var $author$project$Evergreen$V417$Audio$w3_encode_Msg$ = function (w3_x_c_userMsg, w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V417$Audio$w3_encode_FromJSMsg(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					w3_x_c_userMsg(v0)
				]));
	}
};
var $author$project$Evergreen$V417$Audio$w3_encode_Msg = F2($author$project$Evergreen$V417$Audio$w3_encode_Msg$);
var $author$project$Evergreen$V417$Types$w3_encode_FrontendMsg = $author$project$Evergreen$V417$Audio$w3_encode_Msg($author$project$Evergreen$V417$Types$w3_encode_FrontendMsg_);
var $author$project$Evergreen$V419$Audio$w3_encode_FromJSMsg = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Evergreen$V419$Audio$w3_encode_LoadError(w3_rec_var0.error),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.requestId)
								]));
					}(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Evergreen$V419$Audio$w3_encode_BufferId(w3_rec_var0.bufferId),
									$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var0.duration),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.requestId)
								]));
					}(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.samplesPerSecond)
								]));
					}(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.error)
								]));
					}(v0)
					]));
	}
};
var $author$project$Evergreen$V419$Audio$w3_encode_Msg$ = function (w3_x_c_userMsg, w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Evergreen$V419$Audio$w3_encode_FromJSMsg(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					w3_x_c_userMsg(v0)
				]));
	}
};
var $author$project$Evergreen$V419$Audio$w3_encode_Msg = F2($author$project$Evergreen$V419$Audio$w3_encode_Msg$);
var $author$project$Evergreen$V419$Types$w3_encode_FrontendMsg = $author$project$Evergreen$V419$Audio$w3_encode_Msg($author$project$Evergreen$V419$Types$w3_encode_FrontendMsg_);
var $author$project$Evergreen$V417$Audio$FromJSMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Audio$UserMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Audio$AudioLoadFailed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V417$Audio$AudioLoadSuccess = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V417$Audio$InitAudioContext = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V417$Audio$JsonParseError = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V417$Audio$w3_unsafe_decode_FromJSMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V417$Audio$w3_unsafe_decode_LoadError,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (error0, requestId0) {
										return {error: error0, requestId: requestId0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Audio$AudioLoadFailed));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V417$Audio$w3_unsafe_decode_BufferId,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (bufferId0, duration0, requestId0) {
											return {bufferId: bufferId0, duration: duration0, requestId: requestId0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Audio$AudioLoadSuccess));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							function (samplesPerSecond0) {
								return {samplesPerSecond: samplesPerSecond0};
							})),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Audio$InitAudioContext));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							function (error0) {
								return {error: error0};
							})),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Audio$JsonParseError));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V417$Audio$w3_unsafe_decode_Msg = function (w3_x_c_userMsg) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V417$Audio$w3_unsafe_decode_FromJSMsg,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Audio$FromJSMsg));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_userMsg,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V417$Audio$UserMsg));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V417$Types$w3_unsafe_decode_FrontendMsg = $author$project$Evergreen$V417$Audio$w3_unsafe_decode_Msg($author$project$Evergreen$V417$Types$w3_unsafe_decode_FrontendMsg_);
var $author$project$Evergreen$V419$Audio$FromJSMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Audio$UserMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Audio$AudioLoadFailed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$V419$Audio$AudioLoadSuccess = function (a) {
	return {$: 0, a: a};
};
var $author$project$Evergreen$V419$Audio$InitAudioContext = function (a) {
	return {$: 2, a: a};
};
var $author$project$Evergreen$V419$Audio$JsonParseError = function (a) {
	return {$: 3, a: a};
};
var $author$project$Evergreen$V419$Audio$w3_unsafe_decode_FromJSMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Evergreen$V419$Audio$w3_unsafe_decode_LoadError,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (error0, requestId0) {
										return {error: error0, requestId: requestId0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Audio$AudioLoadFailed));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Evergreen$V419$Audio$w3_unsafe_decode_BufferId,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (bufferId0, duration0, requestId0) {
											return {bufferId: bufferId0, duration: duration0, requestId: requestId0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Audio$AudioLoadSuccess));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							function (samplesPerSecond0) {
								return {samplesPerSecond: samplesPerSecond0};
							})),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Audio$InitAudioContext));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							function (error0) {
								return {error: error0};
							})),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Audio$JsonParseError));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Evergreen$V419$Audio$w3_unsafe_decode_Msg = function (w3_x_c_userMsg) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Evergreen$V419$Audio$w3_unsafe_decode_FromJSMsg,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Audio$FromJSMsg));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_userMsg,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Evergreen$V419$Audio$UserMsg));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Evergreen$V419$Types$w3_unsafe_decode_FrontendMsg = $author$project$Evergreen$V419$Audio$w3_unsafe_decode_Msg($author$project$Evergreen$V419$Types$w3_unsafe_decode_FrontendMsg_);
var $author$project$Audio$w3_unsafe_decode_FromJSMsg = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Audio$w3_unsafe_decode_LoadError,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (error0, requestId0) {
										return {error: error0, requestId: requestId0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Audio$AudioLoadFailed));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$ianmackenzie$elm_units$Duration$w3_unsafe_decode_Duration,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Audio$w3_unsafe_decode_BufferId,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F3(
										function (bufferId0, duration0, requestId0) {
											return {bufferId: bufferId0, duration: duration0, requestId: requestId0};
										}))))),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Audio$AudioLoadSuccess));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							function (samplesPerSecond0) {
								return {samplesPerSecond: samplesPerSecond0};
							})),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Audio$InitAudioContext));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode(
							function (error0) {
								return {error: error0};
							})),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Audio$JsonParseError));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Audio$w3_unsafe_decode_Msg = function (w3_x_c_userMsg) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$andThenDecode,
		function (w3v) {
			switch (w3v) {
				case 0:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Audio$w3_unsafe_decode_FromJSMsg,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Audio$FromJSMsg));
				case 1:
					return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						w3_x_c_userMsg,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Audio$UserMsg));
				default:
					return $lamdera$codecs$Lamdera$Wire3$failDecode;
			}
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $author$project$Types$w3_unsafe_decode_FrontendMsg = $author$project$Audio$w3_unsafe_decode_Msg($author$project$Types$w3_unsafe_decode_FrontendMsg_);
var $author$project$LamderaGenerated$decodeAndUpgradeFrontendMsg$ = function (version, bytes) {
	switch (version) {
		case 418:
			return $author$project$LamderaHelpers$otherwiseError(
				$author$project$LamderaHelpers$upgradeSucceeds(
					$author$project$LamderaHelpers$thenMigrateMsg$(
						0,
						$elm$core$Basics$always($lamdera$codecs$Lamdera$Migrations$MsgUnchanged),
						$author$project$Evergreen$V419$Types$w3_encode_FrontendMsg,
						$author$project$Types$w3_unsafe_decode_FrontendMsg,
						420,
						$author$project$LamderaHelpers$thenMigrateMsg$(
							0,
							$author$project$Evergreen$Migrate$V419$frontendMsg,
							$author$project$Evergreen$V417$Types$w3_encode_FrontendMsg,
							$author$project$Evergreen$V419$Types$w3_unsafe_decode_FrontendMsg,
							419,
							$author$project$LamderaHelpers$decodeType$(0, 417, bytes, $author$project$Evergreen$V417$Types$w3_unsafe_decode_FrontendMsg)))));
		case 419:
			return $author$project$LamderaHelpers$otherwiseError(
				$author$project$LamderaHelpers$upgradeSucceeds(
					$author$project$LamderaHelpers$decodeType$(0, 420, bytes, $author$project$Types$w3_unsafe_decode_FrontendMsg)));
		case 420:
			return $author$project$LamderaHelpers$otherwiseError(
				$author$project$LamderaHelpers$upgradeIsCurrent(
					$author$project$LamderaHelpers$decodeType$(0, version, bytes, $author$project$Types$w3_unsafe_decode_FrontendMsg)));
		default:
			return $author$project$LamderaHelpers$UnknownVersion(
				_Utils_Tuple3(version, 'FrontendMsg', bytes));
	}
};
var $author$project$LamderaGenerated$decodeAndUpgradeFrontendMsg = F2($author$project$LamderaGenerated$decodeAndUpgradeFrontendMsg$);
var $lamdera$codecs$Lamdera$Migrations$MsgMigrated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Evergreen$Migrate$V419$toFrontend = function (old) {
	return $lamdera$codecs$Lamdera$Migrations$MsgMigrated(
		_Utils_Tuple2(
			$author$project$Evergreen$Migrate$V419$migrate_Types_ToFrontend(old),
			$elm$core$Platform$Cmd$none));
};
var $author$project$LamderaGenerated$decodeAndUpgradeToFrontend$ = function (version, bytes) {
	switch (version) {
		case 418:
			return $author$project$LamderaHelpers$otherwiseError(
				$author$project$LamderaHelpers$upgradeSucceeds(
					$author$project$LamderaHelpers$thenMigrateMsg$(
						3,
						$elm$core$Basics$always($lamdera$codecs$Lamdera$Migrations$MsgUnchanged),
						$author$project$Evergreen$V419$Types$w3_encode_ToFrontend,
						$author$project$Types$w3_unsafe_decode_ToFrontend,
						420,
						$author$project$LamderaHelpers$thenMigrateMsg$(
							3,
							$author$project$Evergreen$Migrate$V419$toFrontend,
							$author$project$Evergreen$V417$Types$w3_encode_ToFrontend,
							$author$project$Evergreen$V419$Types$w3_unsafe_decode_ToFrontend,
							419,
							$author$project$LamderaHelpers$decodeType$(3, 417, bytes, $author$project$Evergreen$V417$Types$w3_unsafe_decode_ToFrontend)))));
		case 419:
			return $author$project$LamderaHelpers$otherwiseError(
				$author$project$LamderaHelpers$upgradeSucceeds(
					$author$project$LamderaHelpers$decodeType$(3, 420, bytes, $author$project$Types$w3_unsafe_decode_ToFrontend)));
		case 420:
			return $author$project$LamderaHelpers$otherwiseError(
				$author$project$LamderaHelpers$upgradeIsCurrent(
					$author$project$LamderaHelpers$decodeType$(3, version, bytes, $author$project$Types$w3_unsafe_decode_ToFrontend)));
		default:
			return $author$project$LamderaHelpers$UnknownVersion(
				_Utils_Tuple3(version, 'ToFrontend', bytes));
	}
};
var $author$project$LamderaGenerated$decodeAndUpgradeToFrontend = F2($author$project$LamderaGenerated$decodeAndUpgradeToFrontend$);
var $author$project$LFR$fecfs = _Platform_outgoingPort('fecfs', $lamdera$codecs$Lamdera$Wire3$encodeBytes_);
var $author$project$LFR$feeum = _Platform_incomingPort(
	'feeum',
	$elm$json$Json$Decode$null(0));
var $author$project$LFR$rfb = _Platform_incomingPort('rfb', $lamdera$codecs$Lamdera$Wire3$decodeBytes_);
var $author$project$LFR$rm = _Platform_outgoingPort(
	'rm',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'b',
					$lamdera$codecs$Lamdera$Wire3$encodeBytes_($.b)),
					_Utils_Tuple2(
					't',
					$elm$json$Json$Encode$int($.t)),
					_Utils_Tuple2(
					'v',
					$elm$json$Json$Encode$int($.v))
				]));
	});
var $author$project$LFR$rrm = _Platform_incomingPort(
	'rrm',
	A2(
		$elm$json$Json$Decode$andThen,
		function (v) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (t) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (b) {
							return $elm$json$Json$Decode$succeed(
								{b: b, t: t, v: v});
						},
						A2($elm$json$Json$Decode$field, 'b', $lamdera$codecs$Lamdera$Wire3$decodeBytes_));
				},
				A2($elm$json$Json$Decode$field, 't', $elm$json$Json$Decode$int));
		},
		A2($elm$json$Json$Decode$field, 'v', $elm$json$Json$Decode$int)));
var $author$project$LFR$stb = _Platform_outgoingPort('stb', $lamdera$codecs$Lamdera$Wire3$encodeBytes_);
var $author$project$Emoji$w3_encode_EmojiArt = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.sequence),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.sprite)
			]));
};
var $author$project$Emoji$w3_encode_EmojiCategory = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
	}
};
var $author$project$Emoji$w3_encode_EmojiData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Emoji$w3_encode_EmojiCategory(w3_rec_var0.category),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.shortNames),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.skinVariations)
			]));
};
var $author$project$Emoji$w3_encode_UnicodeEmoji = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Emoji$w3_encode_CachedEmojiData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeDict$(
				$lamdera$codecs$Lamdera$Wire3$encodeChar,
				$lamdera$codecs$Lamdera$Wire3$encodeArray($author$project$Emoji$w3_encode_EmojiArt),
				w3_rec_var0.art),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Emoji$w3_encode_EmojiCategory,
				$lamdera$codecs$Lamdera$Wire3$encodeList($author$project$Emoji$w3_encode_UnicodeEmoji),
				w3_rec_var0.categories),
				$lamdera$containers$SeqDict$encodeDict$($author$project$Emoji$w3_encode_UnicodeEmoji, $author$project$Emoji$w3_encode_EmojiData, w3_rec_var0.emojis),
				$lamdera$codecs$Lamdera$Wire3$encodeArray$(
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$author$project$Emoji$w3_encode_UnicodeEmoji(w3_rec_var1.emoji),
								$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var1.shortName)
							]));
				},
				w3_rec_var0.shortNames)
			]));
};
var $author$project$Coord$w3_encode_Coord = function (w3_x_c_units) {
	return A2(
		$lamdera$codecs$Lamdera$Wire3$encodePair,
		A2($ianmackenzie$elm_units$Quantity$w3_encode_Quantity, $lamdera$codecs$Lamdera$Wire3$encodeInt, w3_x_c_units),
		A2($ianmackenzie$elm_units$Quantity$w3_encode_Quantity, $lamdera$codecs$Lamdera$Wire3$encodeInt, w3_x_c_units));
};
var $author$project$CssPixels$w3_encode_CssPixels = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Touch$w3_encode_DragTarget = function (w3v) {
	switch (w3v) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$NonemptyDict$w3_encode_NonemptyDict$ = function (w3_x_c_id, w3_x_c_a, w3v) {
	var v0 = w3v.a;
	var v1 = w3v.b;
	var v2 = w3v.c;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				w3_x_c_id(v0),
				w3_x_c_a(v1),
				$lamdera$containers$SeqDict$encodeDict$(w3_x_c_id, w3_x_c_a, v2)
			]));
};
var $author$project$NonemptyDict$w3_encode_NonemptyDict = F3($author$project$NonemptyDict$w3_encode_NonemptyDict$);
var $author$project$Geometry$Types$w3_encode_Point2d$ = function (w3_x_c_units, w3_x_c_coordinates, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				function (w3_rec_var0) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.x),
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.y)
						]));
			}(v0)
			]));
};
var $author$project$Geometry$Types$w3_encode_Point2d = F3($author$project$Geometry$Types$w3_encode_Point2d$);
var $author$project$Point2d$w3_encode_Point2d$ = function (w3_x_c_units, w3_x_c_coordinates) {
	return A2($author$project$Geometry$Types$w3_encode_Point2d, w3_x_c_units, w3_x_c_coordinates);
};
var $author$project$Point2d$w3_encode_Point2d = F2($author$project$Point2d$w3_encode_Point2d$);
var $author$project$Touch$w3_encode_ScreenCoordinate = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Touch$w3_encode_Touch = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				A3($author$project$Point2d$w3_encode_Point2d, $author$project$CssPixels$w3_encode_CssPixels, $author$project$Touch$w3_encode_ScreenCoordinate, w3_rec_var0.client),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.targetIsTextInput)
			]));
};
var $author$project$Touch$w3_encode_Drag = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$NonemptyDict$w3_encode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$Touch$w3_encode_Touch, v1)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.horizontalStart),
									$author$project$Touch$w3_encode_DragTarget(w3_rec_var0.target),
									$author$project$NonemptyDict$w3_encode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$Touch$w3_encode_Touch, w3_rec_var0.touches)
								]));
					}(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$AiChat$w3_encode_AiModelName = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$AiChat$w3_encode_AiModel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$AiChat$w3_encode_AiModelName(w3_rec_var0.id),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.inputs)
			]));
};
var $author$project$AiChat$w3_encode_AiModelsStatus = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$AiChat$w3_encode_AiModel, v0)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v0)
					]));
	}
};
var $author$project$AiChat$w3_encode_PendingResponse = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$AiChat$w3_encode_AiModelName(v0),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v1)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$AiChat$w3_encode_AiModelName(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v2),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeFloat, v3)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$AiChat$w3_encode_AiModelName(v0)
					]));
	}
};
var $author$project$AiChat$w3_encode_ResponseId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$AiChat$w3_encode_SendMessageWith = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$AiChat$w3_encode_FrontendModel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$AiChat$w3_encode_AiModelsStatus(w3_rec_var0.aiModels),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.chatHistory),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.debounceCounter),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.message),
				$lamdera$containers$SeqDict$encodeDict$($author$project$AiChat$w3_encode_ResponseId, $author$project$AiChat$w3_encode_PendingResponse, w3_rec_var0.pendingResponses),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.responseCounter),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$AiChat$w3_encode_AiModelName, w3_rec_var0.selectedModels),
				$author$project$AiChat$w3_encode_SendMessageWith(w3_rec_var0.sendMessageWith),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showOptions)
			]));
};
var $author$project$MyUi$w3_encode_Copied = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
				]));
	}
};
var $author$project$MyUi$w3_encode_LastCopy = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$MyUi$w3_encode_Copied(w3_rec_var0.copied),
				function (t) {
				return $lamdera$codecs$Lamdera$Wire3$encodeInt(
					$elm$time$Time$posixToMillis(t));
			}(w3_rec_var0.copiedAt)
			]));
};
var $author$project$Audio$w3_encode_LoadError = function (w3v) {
	switch (w3v) {
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Id$w3_encode_InviteLinkId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Discord$w3_encode_ChannelId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Discord$w3_encode_GuildId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Discord$w3_encode_Id$ = function (w3_x_c_idType, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$MartinSStewart$elm_uint64$UInt64$w3_encode_UInt64(v0)
			]));
};
var $author$project$Discord$w3_encode_Id = F2($author$project$Discord$w3_encode_Id$);
var $author$project$Discord$w3_encode_UserId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Id$w3_encode_Viewing_DiscordChannelId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, w3_rec_var0.channelId),
				$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, w3_rec_var0.currentUserId),
				$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, w3_rec_var0.guildId)
			]));
};
var $author$project$Discord$w3_encode_PrivateChannelId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Id$w3_encode_Viewing_DiscordDmId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_PrivateChannelId, w3_rec_var0.channelId),
				$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, w3_rec_var0.currentUserId)
			]));
};
var $author$project$Id$w3_encode_DiscordGuildOrDmId = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Id$w3_encode_Viewing_DiscordDmId(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Id$w3_encode_Viewing_DiscordChannelId(v0)
				]));
	}
};
var $author$project$Id$w3_encode_ChannelId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Id$w3_encode_GuildId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Id$w3_encode_Id$ = function (w3_x_c_a, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Id$w3_encode_Id = F2($author$project$Id$w3_encode_Id$);
var $author$project$Id$w3_encode_Viewing_ChannelId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelId, w3_rec_var0.channelId),
				$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, w3_rec_var0.guildId)
			]));
};
var $author$project$Id$w3_encode_UserId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Id$w3_encode_Viewing_DmId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, w3_rec_var0.otherUserId)
			]));
};
var $author$project$Id$w3_encode_GuildOrDmId = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Id$w3_encode_Viewing_DmId(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Id$w3_encode_Viewing_ChannelId(v0)
				]));
	}
};
var $author$project$Slack$w3_encode_ChannelId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Slack$w3_encode_Id$ = function (w3_x_c_a, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Slack$w3_encode_Id = F2($author$project$Slack$w3_encode_Id$);
var $author$project$Slack$w3_encode_TeamId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Slack$w3_encode_UserId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Id$w3_encode_Viewing_SlackChannelId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_ChannelId, w3_rec_var0.channelId),
				$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_UserId, w3_rec_var0.currentUserId),
				$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_TeamId, w3_rec_var0.teamId)
			]));
};
var $author$project$Slack$w3_encode_DmChannelId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Id$w3_encode_Viewing_SlackDmId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_DmChannelId, w3_rec_var0.channelId),
				$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_UserId, w3_rec_var0.currentUserId)
			]));
};
var $author$project$Id$w3_encode_SlackGuildOrDmId = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Id$w3_encode_Viewing_SlackDmId(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Id$w3_encode_Viewing_SlackChannelId(v0)
				]));
	}
};
var $author$project$Id$w3_encode_AnyGuildOrDmId = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Id$w3_encode_DiscordGuildOrDmId(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Id$w3_encode_GuildOrDmId(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Id$w3_encode_SlackGuildOrDmId(v0)
					]));
	}
};
var $author$project$Id$w3_encode_ChannelMessageId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Route$w3_encode_ChannelSidebarMode = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					function (w3_rec_var0) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.offset),
								$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.previousOffset),
								$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.time)
							]));
				}(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					function (w3_rec_var0) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.offset)
							]));
				}(v0)
				]));
	}
};
var $author$project$Types$w3_encode_EditChannelForm = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.deleteConfirmation),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.description),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pressedSubmit),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showDeleteConfirmation)
			]));
};
var $author$project$Types$w3_encode_ImportChannelError = function (w3v) {
	return $elm$bytes$Bytes$Encode$unsignedInt8(0);
};
var $author$project$Types$w3_encode_ImportChannelStatus = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Types$w3_encode_ImportChannelError(v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.encryptedMessages)
								]));
					}(v0)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Types$w3_encode_EditGuildForm = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.deleteConfirmation),
				$author$project$Types$w3_encode_ImportChannelStatus(w3_rec_var0.importChannel),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pressedSubmit),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showDeleteConfirmation),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showLeaveConfirmation)
			]));
};
var $author$project$FileStatus$w3_encode_FileId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$FileStatus$w3_encode_ContentType = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$FileStatus$w3_encode_FileHash = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$FileStatus$w3_encode_ExposureTime = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.denominator),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.numerator)
			]));
};
var $author$project$SafeFloat$w3_encode_SafeFloat = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(v0)
			]));
};
var $author$project$FileStatus$w3_encode_Location = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$SafeFloat$w3_encode_SafeFloat(w3_rec_var0.lat),
				$author$project$SafeFloat$w3_encode_SafeFloat(w3_rec_var0.lon)
			]));
};
var $author$project$FileStatus$w3_encode_Orientation = function (w3v) {
	switch (w3v) {
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
	}
};
var $author$project$FileStatus$w3_encode_ImageMetadata = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.cameraOwner),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$FileStatus$w3_encode_ExposureTime, w3_rec_var0.exposureTime),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$SafeFloat$w3_encode_SafeFloat, w3_rec_var0.fNumber),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$SafeFloat$w3_encode_SafeFloat, w3_rec_var0.focalLength),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$FileStatus$w3_encode_Location, w3_rec_var0.gpsLocation),
				A2($author$project$Coord$w3_encode_Coord, $author$project$CssPixels$w3_encode_CssPixels, w3_rec_var0.imageSize),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.isoSpeedRating),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.make),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.model),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$FileStatus$w3_encode_Orientation, w3_rec_var0.orientation),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.software),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.userComment)
			]));
};
var $author$project$FileStatus$w3_encode_VideoMetadata = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.codec),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.createdAt),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($ianmackenzie$elm_units$Duration$w3_encode_Duration, w3_rec_var0.duration),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$FileStatus$w3_encode_Location, w3_rec_var0.gpsLocation),
				$author$project$FileStatus$w3_encode_Orientation(w3_rec_var0.orientation),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.title),
				A2($author$project$Coord$w3_encode_Coord, $author$project$CssPixels$w3_encode_CssPixels, w3_rec_var0.videoSize)
			]));
};
var $author$project$FileStatus$w3_encode_FileMetadata = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$FileStatus$w3_encode_ImageMetadata(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$FileStatus$w3_encode_VideoMetadata(v0)
				]));
	}
};
var $author$project$FileName$w3_encode_FileName = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v0)
			]));
};
var $author$project$FileStatus$w3_encode_AesPrivateKey = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeBytes(v0)
			]));
};
var $author$project$FileStatus$w3_encode_EncryptedThumbnail = function (w3v) {
	if (w3v === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$FileStatus$w3_encode_IsEncrypted = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$FileStatus$w3_encode_AesPrivateKey(v0),
					$author$project$FileStatus$w3_encode_EncryptedThumbnail(v1)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$FileStatus$w3_encode_FileData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$FileStatus$w3_encode_ContentType(w3_rec_var0.contentType),
				$author$project$FileStatus$w3_encode_FileHash(w3_rec_var0.fileHash),
				$author$project$FileName$w3_encode_FileName(w3_rec_var0.fileName),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.fileSize),
				$author$project$FileStatus$w3_encode_IsEncrypted(w3_rec_var0.isEncrypted),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$FileStatus$w3_encode_FileMetadata, w3_rec_var0.metadata)
			]));
};
var $author$project$FileStatus$w3_encode_FileStatus = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$FileName$w3_encode_FileName(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1),
						$author$project$FileStatus$w3_encode_ContentType(v2),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v3),
						$author$project$FileStatus$w3_encode_IsEncrypted(v4)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$FileStatus$w3_encode_FileData(v0)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$FileName$w3_encode_FileName(v0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.sent),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.size)
								]));
					}(v1),
						$author$project$FileStatus$w3_encode_ContentType(v2),
						$author$project$FileStatus$w3_encode_IsEncrypted(v3)
					]));
	}
};
var $author$project$Types$w3_encode_EditMessage = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$FileStatus$w3_encode_FileId),
				$author$project$FileStatus$w3_encode_FileStatus,
				w3_rec_var0.attachedFiles),
				$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, w3_rec_var0.messageIndex),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.text)
			]));
};
var $author$project$Id$w3_encode_QuestionId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$SheepGame$w3_encode_Input = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v0)
					]));
	}
};
var $author$project$Range$w3_encode_Range = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.end),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.start)
			]));
};
var $author$project$SheepGame$w3_encode_ReactionTarget = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0),
					$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v1)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v0)
				]));
	}
};
var $author$project$WordSpellingGame$w3_encode_ReactionTarget = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Id$w3_encode_ThreadMessageId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Id$w3_encode_ThreadRouteWithMessage = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v0)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v0),
					$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ThreadMessageId, v1)
				]));
	}
};
var $author$project$Types$w3_encode_EmojiSelector = function (w3v) {
	switch (w3v.$) {
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						A2($author$project$Coord$w3_encode_Coord, $author$project$CssPixels$w3_encode_CssPixels, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Range$w3_encode_Range, v1)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Range$w3_encode_Range, v0)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$SheepGame$w3_encode_Input(v0),
						A2($author$project$Coord$w3_encode_Coord, $author$project$CssPixels$w3_encode_CssPixels, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Range$w3_encode_Range, v2)
					]));
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Id$w3_encode_GuildOrDmId(v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v1),
						$author$project$SheepGame$w3_encode_ReactionTarget(v2)
					]));
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Id$w3_encode_GuildOrDmId(v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v1),
						$author$project$WordSpellingGame$w3_encode_ReactionTarget(v2)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
	}
};
var $author$project$Encryption$w3_encode_DecryptManyRequestId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Encryption$w3_encode_DecryptRequestId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Encryption$w3_encode_EncryptFileRequestId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Encryption$w3_encode_EncryptManyRequestId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Encryption$w3_encode_EncryptRequestId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Encryption$w3_encode_BytesHash = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Types$w3_encode_PendingDecryptedManyMessages = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Encryption$w3_encode_BytesHash, w3_rec_var0.messageHashes),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Browser$Dom$w3_encode_HtmlId, w3_rec_var0.shiftScrollFrom)
			]));
};
var $author$project$Message$w3_encode_RepliedToGame = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v1)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
	}
};
var $author$project$Message$w3_encode_RepliedTo$ = function (w3_x_c_messageId, w3v) {
	switch (w3v.$) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v0),
						$author$project$Message$w3_encode_RepliedToGame(v1)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Id$w3_encode_Id$(w3_x_c_messageId, v0)
					]));
	}
};
var $author$project$Message$w3_encode_RepliedTo = F2($author$project$Message$w3_encode_RepliedTo$);
var $author$project$Message$w3_encode_ThreadRouteWithRepliedTo = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Message$w3_encode_RepliedTo$($author$project$Id$w3_encode_ChannelMessageId, v0)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v0),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ThreadMessageId),
					v1)
				]));
	}
};
var $author$project$Types$w3_encode_PendingDecryptedMessage = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Encryption$w3_encode_BytesHash(w3_rec_var0.hash),
				$author$project$Id$w3_encode_Viewing_DmId(w3_rec_var0.id),
				$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, w3_rec_var0.senderId),
				$author$project$Message$w3_encode_ThreadRouteWithRepliedTo(w3_rec_var0.threadRoute)
			]));
};
var $author$project$Types$w3_encode_PendingDecryptedOldMessages = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Id$w3_encode_Viewing_DmId(w3_rec_var0.id),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Id$w3_encode_ThreadRouteWithMessage, w3_rec_var0.messages)
			]));
};
var $author$project$Embed$w3_encode_EmbedImageFormat = function (w3v) {
	switch (w3v) {
		case 13:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 12:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 14:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(12);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(14);
	}
};
var $author$project$Embed$w3_encode_EmbedImageData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Embed$w3_encode_EmbedImageFormat, w3_rec_var0.format),
				A2($author$project$Coord$w3_encode_Coord, $author$project$CssPixels$w3_encode_CssPixels, w3_rec_var0.imageSize),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.url)
			]));
};
var $author$project$Embed$w3_encode_EmbedData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.createdAt),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.description),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Embed$w3_encode_EmbedImageData, w3_rec_var0.image),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.title)
			]));
};
var $author$project$Embed$w3_encode_Embed = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Embed$w3_encode_EmbedData(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Id$w3_encode_CustomEmojiId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$RichText$w3_encode_EscapedChar = function (w3v) {
	switch (w3v) {
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
	}
};
var $author$project$RichText$w3_encode_HasLeadingLineBreak = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$RichText$w3_encode_HeadingLevel = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$RichText$w3_encode_Language = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Id$w3_encode_StickerId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$TimeInMinutes$w3_encode_TimeInMinutes = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$RichText$w3_encode_RichText$ = function (w3_x_c_userId, w3_x_c_channelId, w3v) {
	switch (w3v.$) {
		case 14:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Id$w3_encode_Id$($author$project$FileStatus$w3_encode_FileId, v0)
					]));
		case 8:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$RichText$w3_encode_HasLeadingLineBreak(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						A2($author$project$RichText$w3_encode_RichText, w3_x_c_userId, w3_x_c_channelId),
						v1)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2($author$project$RichText$w3_encode_RichText, w3_x_c_userId, w3_x_c_channelId),
						v0)
					]));
		case 18:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$RichText$w3_encode_HasLeadingLineBreak(v0),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						$lamdera$codecs$Lamdera$Wire3$encodeList(
							A2($author$project$RichText$w3_encode_RichText, w3_x_c_userId, w3_x_c_channelId)),
						v1)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						w3_x_c_channelId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
						v1)
					]));
		case 13:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$RichText$w3_encode_Language(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 17:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_CustomEmojiId, v0)
					]));
		case 15:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$RichText$w3_encode_EscapedChar(v0)
					]));
		case 9:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$RichText$w3_encode_HeadingLevel(v0),
						$author$project$RichText$w3_encode_HasLeadingLineBreak(v1),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2($author$project$RichText$w3_encode_RichText, w3_x_c_userId, w3_x_c_channelId),
						v2)
					]));
		case 10:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$elm$url$Url$w3_encode_Url(v0)
					]));
		case 12:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$lamdera$codecs$Lamdera$Wire3$encodeChar(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2($author$project$RichText$w3_encode_RichText, w3_x_c_userId, w3_x_c_channelId),
						v0)
					]));
		case 11:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v0),
						$elm$url$Url$w3_encode_Url(v1)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$lamdera$codecs$Lamdera$Wire3$encodeChar(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2($author$project$RichText$w3_encode_RichText, w3_x_c_userId, w3_x_c_channelId),
						v0)
					]));
		case 16:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_StickerId, v0)
					]));
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2($author$project$RichText$w3_encode_RichText, w3_x_c_userId, w3_x_c_channelId),
						v0)
					]));
		case 19:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$author$project$TimeInMinutes$w3_encode_TimeInMinutes(v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2($author$project$RichText$w3_encode_RichText, w3_x_c_userId, w3_x_c_channelId),
						v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(19),
						w3_x_c_userId(v0)
					]));
	}
};
var $author$project$RichText$w3_encode_RichText = F3($author$project$RichText$w3_encode_RichText$);
var $author$project$Message$w3_encode_MessageContent$ = function (w3_x_c_userId, w3_x_c_channelId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$containers$SeqDict$encodeDict$(
					$author$project$Id$w3_encode_Id($author$project$FileStatus$w3_encode_FileId),
					$author$project$FileStatus$w3_encode_FileData,
					w3_rec_var0.attachedFiles),
					$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
					A2($author$project$RichText$w3_encode_RichText, w3_x_c_userId, w3_x_c_channelId),
					w3_rec_var0.content),
					$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Embed$w3_encode_Embed, w3_rec_var0.embeds)
				]));
	};
};
var $author$project$Message$w3_encode_MessageContent = F2($author$project$Message$w3_encode_MessageContent$);
var $author$project$Types$w3_encode_PendingEncryptedEdit = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				A3(
				$author$project$Message$w3_encode_MessageContent,
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId),
				w3_rec_var0.contentAndEmbeds),
				$author$project$Id$w3_encode_Viewing_DmId(w3_rec_var0.id),
				$author$project$Id$w3_encode_ThreadRouteWithMessage(w3_rec_var0.threadRoute)
			]));
};
var $author$project$Id$w3_encode_ThreadRoute = function (w3v) {
	if (!w3v.$) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v0)
				]));
	}
};
var $author$project$Types$w3_encode_PendingEncryptedFile = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Id$w3_encode_Id$($author$project$FileStatus$w3_encode_FileId, w3_rec_var0.fileId),
				$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Id$w3_encode_AnyGuildOrDmId, $author$project$Id$w3_encode_ThreadRoute, w3_rec_var0.guildOrDmId)
			]));
};
var $author$project$Types$w3_encode_PendingEncryptedManyMessages = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Id$w3_encode_Viewing_DmId(w3_rec_var0.id),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Id$w3_encode_ThreadRouteWithMessage,
					$author$project$Message$w3_encode_MessageContent$(
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId))),
				w3_rec_var0.messages)
			]));
};
var $author$project$Types$w3_encode_PendingEncryptedMessage = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				A3(
				$author$project$Message$w3_encode_MessageContent,
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId),
				w3_rec_var0.contentAndEmbeds),
				$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, w3_rec_var0.otherUserId),
				$author$project$Message$w3_encode_ThreadRouteWithRepliedTo(w3_rec_var0.threadRoute)
			]));
};
var $author$project$Types$w3_encode_EncryptionRequests = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Id$w3_encode_Id$($author$project$Encryption$w3_encode_DecryptManyRequestId, w3_rec_var0.nextDecryptManyRequestId),
				$author$project$Id$w3_encode_Id$($author$project$Encryption$w3_encode_DecryptRequestId, w3_rec_var0.nextDecryptionRequestId),
				$author$project$Id$w3_encode_Id$($author$project$Encryption$w3_encode_EncryptFileRequestId, w3_rec_var0.nextEncryptFileRequestId),
				$author$project$Id$w3_encode_Id$($author$project$Encryption$w3_encode_EncryptManyRequestId, w3_rec_var0.nextEncryptManyRequestId),
				$author$project$Id$w3_encode_Id$($author$project$Encryption$w3_encode_EncryptRequestId, w3_rec_var0.nextEncryptionRequestId),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Encryption$w3_encode_DecryptManyRequestId),
				$author$project$Types$w3_encode_PendingDecryptedManyMessages,
				w3_rec_var0.pendingDecryptedManyMessages),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Encryption$w3_encode_DecryptRequestId),
				$author$project$Types$w3_encode_PendingDecryptedMessage,
				w3_rec_var0.pendingDecryptedMessages),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Encryption$w3_encode_DecryptManyRequestId),
				$author$project$Types$w3_encode_PendingDecryptedOldMessages,
				w3_rec_var0.pendingDecryptedOldMessages),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Encryption$w3_encode_EncryptRequestId),
				$author$project$Types$w3_encode_PendingEncryptedEdit,
				w3_rec_var0.pendingEncryptedEdits),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Encryption$w3_encode_EncryptFileRequestId),
				$author$project$Types$w3_encode_PendingEncryptedFile,
				w3_rec_var0.pendingEncryptedFiles),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Encryption$w3_encode_EncryptManyRequestId),
				$author$project$Types$w3_encode_PendingEncryptedManyMessages,
				w3_rec_var0.pendingEncryptedManyMessages),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Encryption$w3_encode_EncryptManyRequestId),
				$author$project$Types$w3_encode_PendingEncryptedMessage,
				w3_rec_var0.pendingEncryptedMessages)
			]));
};
var $author$project$FileStatus$w3_encode_FileDataWithImage = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$FileStatus$w3_encode_ContentType(w3_rec_var0.contentType),
				$author$project$FileStatus$w3_encode_FileHash(w3_rec_var0.fileHash),
				$author$project$FileName$w3_encode_FileName(w3_rec_var0.fileName),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.fileSize),
				$author$project$FileStatus$w3_encode_IsEncrypted(w3_rec_var0.isEncrypted),
				$author$project$FileStatus$w3_encode_FileMetadata(w3_rec_var0.metadata)
			]));
};
var $author$project$OneOrGreater$w3_encode_OneOrGreater = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Types$w3_encode_FileDrag = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
					$author$project$OneOrGreater$w3_encode_OneOrGreater(v1)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, v0)
				]));
	}
};
var $author$project$Local$w3_encode_ChangeId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Local$w3_encode_Local$ = function (w3_x_c_msg, w3_x_c_model, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				function (w3_rec_var0) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$author$project$Local$w3_encode_ChangeId(w3_rec_var0.counter),
							w3_x_c_model(w3_rec_var0.localModel),
							$lamdera$codecs$Lamdera$Wire3$encodeDict$(
							$lamdera$codecs$Lamdera$Wire3$encodeInt,
							function (w3_rec_var1) {
								return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
									_List_fromArray(
										[
											function (t) {
											return $lamdera$codecs$Lamdera$Wire3$encodeInt(
												$elm$time$Time$posixToMillis(t));
										}(w3_rec_var1.createdAt),
											w3_x_c_msg(w3_rec_var1.msg)
										]));
							},
							w3_rec_var0.localMsgs),
							w3_x_c_model(w3_rec_var0.serverModel)
						]));
			}(v0)
			]));
};
var $author$project$Local$w3_encode_Local = F3($author$project$Local$w3_encode_Local$);
var $author$project$GuildName$w3_encode_GuildName = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v0)
			]));
};
var $author$project$LocalState$w3_encode_AdminData_DeletedGuild = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.deletedAt),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.memberCount),
				$author$project$GuildName$w3_encode_GuildName(w3_rec_var0.name),
				$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, w3_rec_var0.owner)
			]));
};
var $author$project$Message$w3_encode_CallRecordingFile = function (w3_x_c_userId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					function (t) {
					return $lamdera$codecs$Lamdera$Wire3$encodeInt(
						$elm$time$Time$posixToMillis(t));
				}(w3_rec_var0.endedAt),
					$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
					w3_x_c_userId(w3_rec_var0.recordedBy),
					$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.size),
					function (t) {
					return $lamdera$codecs$Lamdera$Wire3$encodeInt(
						$elm$time$Time$posixToMillis(t));
				}(w3_rec_var0.startedAt),
					$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.uploaded)
				]));
	};
};
var $author$project$Message$w3_encode_CallRecordingZip = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.fileCount),
				$author$project$FileStatus$w3_encode_FileHash(w3_rec_var0.fileHash),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.size)
			]));
};
var $author$project$NonemptySet$w3_encode_NonemptySet$ = function (w3_x_c_a, w3v) {
	var v0 = w3v.a;
	var v1 = w3v.b;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				w3_x_c_a(v0),
				$lamdera$containers$SeqSet$encodeSet$(w3_x_c_a, v1)
			]));
};
var $author$project$NonemptySet$w3_encode_NonemptySet = F2($author$project$NonemptySet$w3_encode_NonemptySet$);
var $author$project$Message$w3_encode_CallRecording = function (w3_x_c_userId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$codecs$Lamdera$Wire3$encodeList$(
					$author$project$Message$w3_encode_CallRecordingFile(w3_x_c_userId),
					w3_rec_var0.files),
					$lamdera$containers$SeqSet$encodeSet$(w3_x_c_userId, w3_rec_var0.finishedUploading),
					$author$project$NonemptySet$w3_encode_NonemptySet$(w3_x_c_userId, w3_rec_var0.participants),
					function (t) {
					return $lamdera$codecs$Lamdera$Wire3$encodeInt(
						$elm$time$Time$posixToMillis(t));
				}(w3_rec_var0.startedAt),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Message$w3_encode_CallRecordingZip, w3_rec_var0.zip)
				]));
	};
};
var $author$project$Drawing$w3_encode_Stroke = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$SafeFloat$w3_encode_SafeFloat, $author$project$SafeFloat$w3_encode_SafeFloat),
				w3_rec_var0.points)
			]));
};
var $author$project$Drawing$w3_encode_Drawing = function (w3_x_c_userId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$codecs$Lamdera$Wire3$encodeList$(
					function (w3_rec_var1) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									w3_x_c_userId(w3_rec_var1.createdBy),
									$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
									A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$SafeFloat$w3_encode_SafeFloat, $author$project$SafeFloat$w3_encode_SafeFloat),
									w3_rec_var1.points)
								]));
					},
					w3_rec_var0.finished),
					$lamdera$containers$SeqDict$encodeDict$(w3_x_c_userId, $author$project$Drawing$w3_encode_Stroke, w3_rec_var0.inProgress),
					$lamdera$containers$SeqDict$encodeDict$(
					w3_x_c_userId,
					$lamdera$codecs$Lamdera$Wire3$encodeList($author$project$Drawing$w3_encode_Stroke),
					w3_rec_var0.undone)
				]));
	};
};
var $author$project$Emoji$w3_encode_EmojiOrCustomEmoji = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_CustomEmojiId, v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Emoji$w3_encode_UnicodeEmoji(v0)
				]));
	}
};
var $author$project$Message$w3_encode_CallStartedData = function (w3_x_c_userId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					A2($author$project$Drawing$w3_encode_Drawing, w3_x_c_userId, w3_rec_var0.cardDrawings),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					function (t) {
						return $lamdera$codecs$Lamdera$Wire3$encodeInt(
							$elm$time$Time$posixToMillis(t));
					},
					w3_rec_var0.endedAt),
					$lamdera$containers$SeqSet$encodeSet$(w3_x_c_userId, w3_rec_var0.joinedBy),
					$lamdera$containers$SeqDict$encodeDict$(
					$author$project$Emoji$w3_encode_EmojiOrCustomEmoji,
					$author$project$NonemptySet$w3_encode_NonemptySet(w3_x_c_userId),
					w3_rec_var0.reactions),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					$author$project$Message$w3_encode_CallRecording(w3_x_c_userId),
					w3_rec_var0.recordings),
					function (t) {
					return $lamdera$codecs$Lamdera$Wire3$encodeInt(
						$elm$time$Time$posixToMillis(t));
				}(w3_rec_var0.startedAt),
					w3_x_c_userId(w3_rec_var0.startedBy),
					A2($author$project$Drawing$w3_encode_Drawing, w3_x_c_userId, w3_rec_var0.timestampDrawings)
				]));
	};
};
var $author$project$Encryption$w3_encode_EncryptedData$ = function (w3_x_c_a, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeBytes(v0)
			]));
};
var $author$project$Encryption$w3_encode_EncryptedData = F2($author$project$Encryption$w3_encode_EncryptedData$);
var $author$project$Message$w3_encode_UserTextMessageDrawings = function (w3_x_c_userId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$containers$SeqDict$encodeDict$(
					$lamdera$codecs$Lamdera$Wire3$encodeInt,
					$author$project$Drawing$w3_encode_Drawing(w3_x_c_userId),
					w3_rec_var0.embedDrawings),
					$lamdera$containers$SeqDict$encodeDict$(
					$author$project$Id$w3_encode_Id($author$project$FileStatus$w3_encode_FileId),
					$author$project$Drawing$w3_encode_Drawing(w3_x_c_userId),
					w3_rec_var0.imageAttachmentDrawings),
					A2($author$project$Drawing$w3_encode_Drawing, w3_x_c_userId, w3_rec_var0.timestampDrawings),
					A2($author$project$Drawing$w3_encode_Drawing, w3_x_c_userId, w3_rec_var0.userIconDrawings)
				]));
	};
};
var $author$project$Message$w3_encode_EncryptedUserTextMessageData$ = function (w3_x_c_messageId, w3_x_c_userId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$author$project$Encryption$w3_encode_EncryptedData$(
					$author$project$Message$w3_encode_MessageContent$(
						w3_x_c_userId,
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId)),
					w3_rec_var0.content),
					function (t) {
					return $lamdera$codecs$Lamdera$Wire3$encodeInt(
						$elm$time$Time$posixToMillis(t));
				}(w3_rec_var0.createdAt),
					w3_x_c_userId(w3_rec_var0.createdBy),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					$author$project$Message$w3_encode_UserTextMessageDrawings(w3_x_c_userId),
					w3_rec_var0.drawings),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					function (t) {
						return $lamdera$codecs$Lamdera$Wire3$encodeInt(
							$elm$time$Time$posixToMillis(t));
					},
					w3_rec_var0.editedAt),
					$lamdera$containers$SeqSet$encodeSet$($author$project$FileStatus$w3_encode_FileHash, w3_rec_var0.fileHashes),
					$lamdera$containers$SeqDict$encodeDict$(
					$author$project$Emoji$w3_encode_EmojiOrCustomEmoji,
					$author$project$NonemptySet$w3_encode_NonemptySet(w3_x_c_userId),
					w3_rec_var0.reactions),
					$author$project$Message$w3_encode_RepliedTo$(w3_x_c_messageId, w3_rec_var0.repliedTo)
				]));
	};
};
var $author$project$Message$w3_encode_EncryptedUserTextMessageData = F2($author$project$Message$w3_encode_EncryptedUserTextMessageData$);
var $author$project$Message$w3_encode_GameType = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Message$w3_encode_GameStartedData = function (w3_x_c_userId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					A2($author$project$Drawing$w3_encode_Drawing, w3_x_c_userId, w3_rec_var0.cardDrawings),
					$author$project$Message$w3_encode_GameType(w3_rec_var0.gameType),
					$lamdera$containers$SeqDict$encodeDict$(
					$author$project$Emoji$w3_encode_EmojiOrCustomEmoji,
					$author$project$NonemptySet$w3_encode_NonemptySet(w3_x_c_userId),
					w3_rec_var0.reactions),
					function (t) {
					return $lamdera$codecs$Lamdera$Wire3$encodeInt(
						$elm$time$Time$posixToMillis(t));
				}(w3_rec_var0.startedAt),
					w3_x_c_userId(w3_rec_var0.startedBy),
					A2($author$project$Drawing$w3_encode_Drawing, w3_x_c_userId, w3_rec_var0.timestampDrawings)
				]));
	};
};
var $author$project$Message$w3_encode_UserTextMessageData$ = function (w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					A3($author$project$Message$w3_encode_MessageContent, w3_x_c_userId, w3_x_c_channelId, w3_rec_var0.content),
					function (t) {
					return $lamdera$codecs$Lamdera$Wire3$encodeInt(
						$elm$time$Time$posixToMillis(t));
				}(w3_rec_var0.createdAt),
					w3_x_c_userId(w3_rec_var0.createdBy),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					$author$project$Message$w3_encode_UserTextMessageDrawings(w3_x_c_userId),
					w3_rec_var0.drawings),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					function (t) {
						return $lamdera$codecs$Lamdera$Wire3$encodeInt(
							$elm$time$Time$posixToMillis(t));
					},
					w3_rec_var0.editedAt),
					$lamdera$containers$SeqDict$encodeDict$(
					$author$project$Emoji$w3_encode_EmojiOrCustomEmoji,
					$author$project$NonemptySet$w3_encode_NonemptySet(w3_x_c_userId),
					w3_rec_var0.reactions),
					$author$project$Message$w3_encode_RepliedTo$(w3_x_c_messageId, w3_rec_var0.repliedTo)
				]));
	};
};
var $author$project$Message$w3_encode_UserTextMessageData = F3($author$project$Message$w3_encode_UserTextMessageData$);
var $author$project$Message$w3_encode_Message$ = function (w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId, w3v) {
	switch (w3v.$) {
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						A2($author$project$Message$w3_encode_CallStartedData, w3_x_c_userId, v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						function (t) {
						return $lamdera$codecs$Lamdera$Wire3$encodeInt(
							$elm$time$Time$posixToMillis(t));
					}(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						A3($author$project$Message$w3_encode_EncryptedUserTextMessageData, w3_x_c_messageId, w3_x_c_userId, v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						A2($author$project$Message$w3_encode_GameStartedData, w3_x_c_userId, v0)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						function (t) {
						return $lamdera$codecs$Lamdera$Wire3$encodeInt(
							$elm$time$Time$posixToMillis(t));
					}(v0),
						w3_x_c_userId(v1),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Emoji$w3_encode_EmojiOrCustomEmoji,
						$author$project$NonemptySet$w3_encode_NonemptySet(w3_x_c_userId),
						v2),
						A2($author$project$Drawing$w3_encode_Drawing, w3_x_c_userId, v3)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						A4($author$project$Message$w3_encode_UserTextMessageData, w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId, v0)
					]));
	}
};
var $author$project$Message$w3_encode_Message = F4($author$project$Message$w3_encode_Message$);
var $author$project$LocalState$w3_encode_AdminData_DiscordDmChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				A3(
					$author$project$Message$w3_encode_Message,
					$author$project$Id$w3_encode_ChannelMessageId,
					$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
					$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_ChannelId)),
				w3_rec_var0.firstMessage),
				$author$project$NonemptyDict$w3_encode_NonemptyDict$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.messagesSent)
							]));
				},
				w3_rec_var0.members),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.messageCount)
			]));
};
var $author$project$ChannelName$w3_encode_ChannelName = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v0)
			]));
};
var $author$project$Discord$w3_encode_Permissions = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.addReaction),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.administrator),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.attachFiles),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.banMembers),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.changeNickname),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.connect),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.createEvents),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.createGuildExpressions),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.createInstantInvite),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.createPrivateThreads),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.createPublicThreads),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.deafenMembers),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.embedLinks),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.kickMembers),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.manageChannels),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.manageEvents),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.manageGuild),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.manageGuildExpressions),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.manageMessages),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.manageNicknames),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.manageRoles),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.manageThreads),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.manageWebhooks),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.mentionEveryone),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.moderateMembers),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.moveMembers),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.muteMembers),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.prioritySpeaker),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.readMessageHistory),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.requestToSpeak),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.sendMessages),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.sendMessagesInThreads),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.sendPolls),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.sendVoiceMessages),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.sentTextToSpeechMessages),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.speak),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.stream),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.useApplicationCommands),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.useEmbeddedActivities),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.useExternalApps),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.useExternalEmojis),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.useExternalSounds),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.useExternalStickers),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.useSoundboard),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.useVoiceActivityDetection),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.viewAuditLog),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.viewChannel),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.viewCreatorMontetizationAnalytics),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.viewGuildInsights)
			]));
};
var $author$project$Discord$w3_encode_RoleId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Discord$w3_encode_RoleOrUserId = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_RoleId, v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0)
				]));
	}
};
var $author$project$Discord$w3_encode_Overwrite = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Discord$w3_encode_Permissions(w3_rec_var0.allow),
				$author$project$Discord$w3_encode_Permissions(w3_rec_var0.deny),
				$author$project$Discord$w3_encode_RoleOrUserId(w3_rec_var0.id)
			]));
};
var $author$project$LocalState$w3_encode_AdminData_DiscordChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				A3(
					$author$project$Message$w3_encode_Message,
					$author$project$Id$w3_encode_ChannelMessageId,
					$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
					$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_ChannelId)),
				w3_rec_var0.firstMessage),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.messageCount),
				$author$project$ChannelName$w3_encode_ChannelName(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Discord$w3_encode_Overwrite, w3_rec_var0.permissionOverwrites),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.threadCount)
			]));
};
var $author$project$LocalState$w3_encode_DiscordRole = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.description),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
				$author$project$Discord$w3_encode_Permissions(w3_rec_var0.permissions)
			]));
};
var $author$project$MembersAndOwner$w3_encode_MembersAndOwner$ = function (w3_x_c_userId, w3_x_c_a, w3v) {
	var v0 = w3v.a;
	var v1 = w3v.b;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$containers$SeqDict$encodeDict$(w3_x_c_userId, w3_x_c_a, v0),
				w3_x_c_userId(v1)
			]));
};
var $author$project$MembersAndOwner$w3_encode_MembersAndOwner = F3($author$project$MembersAndOwner$w3_encode_MembersAndOwner$);
var $author$project$LocalState$w3_encode_AdminData_DiscordGuild = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_ChannelId),
				$author$project$LocalState$w3_encode_AdminData_DiscordChannel,
				w3_rec_var0.channels),
				$author$project$MembersAndOwner$w3_encode_MembersAndOwner$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var1.joinedAt),
								$lamdera$containers$SeqSet$encodeSet$(
								$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_RoleId),
								w3_rec_var1.roles)
							]));
				},
				w3_rec_var0.membersAndOwner),
				$author$project$GuildName$w3_encode_GuildName(w3_rec_var0.name),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_RoleId),
				$author$project$LocalState$w3_encode_DiscordRole,
				w3_rec_var0.roles)
			]));
};
var $author$project$LocalState$w3_encode_AdminData_DmChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.messageCount),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.threadCount)
			]));
};
var $author$project$LocalState$w3_encode_AdminData_GuildChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.messageCount),
				$author$project$ChannelName$w3_encode_ChannelName(w3_rec_var0.name)
			]));
};
var $author$project$LocalState$w3_encode_AdminData_Guild = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId),
				$author$project$LocalState$w3_encode_AdminData_GuildChannel,
				w3_rec_var0.channels),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.memberCount),
				$author$project$GuildName$w3_encode_GuildName(w3_rec_var0.name),
				$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, w3_rec_var0.owner)
			]));
};
var $author$project$LocalState$w3_encode_AdminData_SlackDmChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				A3(
					$author$project$Message$w3_encode_Message,
					$author$project$Id$w3_encode_ChannelMessageId,
					$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_UserId),
					$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_ChannelId)),
				w3_rec_var0.firstMessage),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_UserId, w3_rec_var1.id),
								$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var1.name)
							]));
				},
				w3_rec_var0.members),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.messageCount),
				$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_TeamId, w3_rec_var0.teamId)
			]));
};
var $author$project$LocalState$w3_encode_AdminData_SlackWorkspace = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_ChannelId),
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
								A3(
									$author$project$Message$w3_encode_Message,
									$author$project$Id$w3_encode_ChannelMessageId,
									$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_UserId),
									$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_ChannelId)),
								w3_rec_var1.firstMessage),
								$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var1.isPrivate),
								$lamdera$containers$SeqSet$encodeSet$(
								$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_UserId),
								w3_rec_var1.linkedMembers),
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.messageCount),
								$author$project$ChannelName$w3_encode_ChannelName(w3_rec_var1.name)
							]));
				},
				w3_rec_var0.channels),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.domain),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_UserId),
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, w3_rec_var1.linkedTo),
								$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var1.name)
							]));
				},
				w3_rec_var0.linkedUsers),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.userCount)
			]));
};
var $author$project$Postmark$w3_encode_ApiKey = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$FileStatus$w3_encode_BackendFileData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.fileSize),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Coord$w3_encode_Coord($author$project$CssPixels$w3_encode_CssPixels),
				w3_rec_var0.imageSize)
			]));
};
var $author$project$BackendMsgLog$w3_encode_BackendMsgLog = function (w3v) {
	switch (w3v) {
		case 20:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 91:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 34:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 35:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 54:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 12:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 78:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 16:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		case 15:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 65:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		case 64:
			return $elm$bytes$Bytes$Encode$unsignedInt8(12);
		case 66:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
		case 63:
			return $elm$bytes$Bytes$Encode$unsignedInt8(14);
		case 49:
			return $elm$bytes$Bytes$Encode$unsignedInt8(15);
		case 50:
			return $elm$bytes$Bytes$Encode$unsignedInt8(16);
		case 18:
			return $elm$bytes$Bytes$Encode$unsignedInt8(17);
		case 17:
			return $elm$bytes$Bytes$Encode$unsignedInt8(18);
		case 19:
			return $elm$bytes$Bytes$Encode$unsignedInt8(19);
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(20);
		case 55:
			return $elm$bytes$Bytes$Encode$unsignedInt8(21);
		case 14:
			return $elm$bytes$Bytes$Encode$unsignedInt8(22);
		case 13:
			return $elm$bytes$Bytes$Encode$unsignedInt8(23);
		case 53:
			return $elm$bytes$Bytes$Encode$unsignedInt8(24);
		case 47:
			return $elm$bytes$Bytes$Encode$unsignedInt8(25);
		case 26:
			return $elm$bytes$Bytes$Encode$unsignedInt8(26);
		case 58:
			return $elm$bytes$Bytes$Encode$unsignedInt8(27);
		case 57:
			return $elm$bytes$Bytes$Encode$unsignedInt8(28);
		case 73:
			return $elm$bytes$Bytes$Encode$unsignedInt8(29);
		case 70:
			return $elm$bytes$Bytes$Encode$unsignedInt8(30);
		case 71:
			return $elm$bytes$Bytes$Encode$unsignedInt8(31);
		case 69:
			return $elm$bytes$Bytes$Encode$unsignedInt8(32);
		case 75:
			return $elm$bytes$Bytes$Encode$unsignedInt8(33);
		case 21:
			return $elm$bytes$Bytes$Encode$unsignedInt8(34);
		case 62:
			return $elm$bytes$Bytes$Encode$unsignedInt8(35);
		case 83:
			return $elm$bytes$Bytes$Encode$unsignedInt8(36);
		case 61:
			return $elm$bytes$Bytes$Encode$unsignedInt8(37);
		case 72:
			return $elm$bytes$Bytes$Encode$unsignedInt8(38);
		case 25:
			return $elm$bytes$Bytes$Encode$unsignedInt8(39);
		case 84:
			return $elm$bytes$Bytes$Encode$unsignedInt8(40);
		case 90:
			return $elm$bytes$Bytes$Encode$unsignedInt8(41);
		case 60:
			return $elm$bytes$Bytes$Encode$unsignedInt8(42);
		case 59:
			return $elm$bytes$Bytes$Encode$unsignedInt8(43);
		case 81:
			return $elm$bytes$Bytes$Encode$unsignedInt8(44);
		case 23:
			return $elm$bytes$Bytes$Encode$unsignedInt8(45);
		case 44:
			return $elm$bytes$Bytes$Encode$unsignedInt8(46);
		case 79:
			return $elm$bytes$Bytes$Encode$unsignedInt8(47);
		case 74:
			return $elm$bytes$Bytes$Encode$unsignedInt8(48);
		case 67:
			return $elm$bytes$Bytes$Encode$unsignedInt8(49);
		case 24:
			return $elm$bytes$Bytes$Encode$unsignedInt8(50);
		case 31:
			return $elm$bytes$Bytes$Encode$unsignedInt8(51);
		case 32:
			return $elm$bytes$Bytes$Encode$unsignedInt8(52);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(53);
		case 33:
			return $elm$bytes$Bytes$Encode$unsignedInt8(54);
		case 77:
			return $elm$bytes$Bytes$Encode$unsignedInt8(55);
		case 43:
			return $elm$bytes$Bytes$Encode$unsignedInt8(56);
		case 52:
			return $elm$bytes$Bytes$Encode$unsignedInt8(57);
		case 51:
			return $elm$bytes$Bytes$Encode$unsignedInt8(58);
		case 80:
			return $elm$bytes$Bytes$Encode$unsignedInt8(59);
		case 82:
			return $elm$bytes$Bytes$Encode$unsignedInt8(60);
		case 86:
			return $elm$bytes$Bytes$Encode$unsignedInt8(61);
		case 88:
			return $elm$bytes$Bytes$Encode$unsignedInt8(62);
		case 87:
			return $elm$bytes$Bytes$Encode$unsignedInt8(63);
		case 89:
			return $elm$bytes$Bytes$Encode$unsignedInt8(64);
		case 85:
			return $elm$bytes$Bytes$Encode$unsignedInt8(65);
		case 56:
			return $elm$bytes$Bytes$Encode$unsignedInt8(66);
		case 76:
			return $elm$bytes$Bytes$Encode$unsignedInt8(67);
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(68);
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(69);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(70);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(71);
		case 22:
			return $elm$bytes$Bytes$Encode$unsignedInt8(72);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(73);
		case 37:
			return $elm$bytes$Bytes$Encode$unsignedInt8(74);
		case 27:
			return $elm$bytes$Bytes$Encode$unsignedInt8(75);
		case 28:
			return $elm$bytes$Bytes$Encode$unsignedInt8(76);
		case 29:
			return $elm$bytes$Bytes$Encode$unsignedInt8(77);
		case 36:
			return $elm$bytes$Bytes$Encode$unsignedInt8(78);
		case 30:
			return $elm$bytes$Bytes$Encode$unsignedInt8(79);
		case 39:
			return $elm$bytes$Bytes$Encode$unsignedInt8(80);
		case 38:
			return $elm$bytes$Bytes$Encode$unsignedInt8(81);
		case 40:
			return $elm$bytes$Bytes$Encode$unsignedInt8(82);
		case 42:
			return $elm$bytes$Bytes$Encode$unsignedInt8(83);
		case 41:
			return $elm$bytes$Bytes$Encode$unsignedInt8(84);
		case 68:
			return $elm$bytes$Bytes$Encode$unsignedInt8(85);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(86);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(87);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(88);
		case 46:
			return $elm$bytes$Bytes$Encode$unsignedInt8(89);
		case 45:
			return $elm$bytes$Bytes$Encode$unsignedInt8(90);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(91);
	}
};
var $author$project$BackendMsgLog$w3_encode_BackendMsgLogData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$BackendMsgLog$w3_encode_BackendMsgLog(w3_rec_var0.backendMsgLog),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.endTime),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.startTime)
			]));
};
var $author$project$EmailAddress$w3_encode_EmailAddress = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				function (w3_rec_var0) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.domain),
							$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.localPart),
							$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.tags),
							$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.tld)
						]));
			}(v0)
			]));
};
var $author$project$User$w3_encode_BackendUserStatus = function (w3v) {
	if (!w3v.$) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$EmailAddress$w3_encode_EmailAddress(v0)
				]));
	}
};
var $author$project$RichText$w3_encode_Domain = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$User$w3_encode_EmailNotifications = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$User$w3_encode_EmbedVisibility = function (w3v) {
	if (w3v === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Emoji$w3_encode_SkinTone = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
	}
};
var $author$project$Emoji$w3_encode_EmojiConfig = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Emoji$w3_encode_EmojiOrCustomEmoji, w3_rec_var0.lastUsedEmojis),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Emoji$w3_encode_SkinTone, w3_rec_var0.skinTone)
			]));
};
var $author$project$User$w3_encode_LastDmViewed = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_PrivateChannelId, v0)
					]));
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0),
						$author$project$Id$w3_encode_ThreadRoute(v1)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$MuteSettings$w3_encode_IsMuted = function (w3v) {
	switch (w3v) {
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$MuteSettings$w3_encode_MutedChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$MuteSettings$w3_encode_IsMuted(w3_rec_var0.mutedChannel),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
				$author$project$MuteSettings$w3_encode_IsMuted,
				w3_rec_var0.mutedThreads)
			]));
};
var $author$project$MuteSettings$w3_encode_MutedDiscordGuild = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_ChannelId),
				$author$project$MuteSettings$w3_encode_MutedChannel,
				w3_rec_var0.channels),
				$author$project$MuteSettings$w3_encode_IsMuted(w3_rec_var0.mutedGuild)
			]));
};
var $author$project$MuteSettings$w3_encode_MutedGuild = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId),
				$author$project$MuteSettings$w3_encode_MutedChannel,
				w3_rec_var0.channels),
				$author$project$MuteSettings$w3_encode_IsMuted(w3_rec_var0.mutedGuild)
			]));
};
var $author$project$MuteSettings$w3_encode_MutedSlackWorkspace = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_ChannelId),
				$author$project$MuteSettings$w3_encode_MutedChannel,
				w3_rec_var0.channels),
				$author$project$MuteSettings$w3_encode_IsMuted(w3_rec_var0.mutedWorkspace)
			]));
};
var $author$project$MuteSettings$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_PrivateChannelId),
				$author$project$MuteSettings$w3_encode_IsMuted,
				w3_rec_var0.mutedDiscordDms),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_GuildId),
				$author$project$MuteSettings$w3_encode_MutedDiscordGuild,
				w3_rec_var0.mutedDiscordGuilds),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				$author$project$MuteSettings$w3_encode_MutedChannel,
				w3_rec_var0.mutedDms),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_GuildId),
				$author$project$MuteSettings$w3_encode_MutedGuild,
				w3_rec_var0.mutedGuilds),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_TeamId),
				$author$project$MuteSettings$w3_encode_MutedSlackWorkspace,
				w3_rec_var0.mutedSlackWorkspaces)
			]));
};
var $author$project$Pagination$w3_encode_PageId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$PersonName$w3_encode_PersonName = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v0)
			]));
};
var $author$project$X25519$w3_encode_Key = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.w0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.w1),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.w2),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.w3),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.w4),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.w5),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.w6),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.w7)
			]));
};
var $author$project$X25519$w3_encode_PublicKey = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$author$project$X25519$w3_encode_Key(v0)
			]));
};
var $author$project$UserColor$w3_encode_UserColor = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$User$w3_encode_BackendUser = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_CustomEmojiId),
				w3_rec_var0.availableCustomEmojis),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_StickerId),
				w3_rec_var0.availableStickers),
				$author$project$UserColor$w3_encode_UserColor(w3_rec_var0.color),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.createdAt),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.deleteAccountAt),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_GuildId),
				A2(
					$author$project$NonemptyDict$w3_encode_NonemptyDict,
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId),
						$author$project$Id$w3_encode_ThreadRoute),
					$author$project$OneOrGreater$w3_encode_OneOrGreater),
				w3_rec_var0.directMentions),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_GuildId),
				A2(
					$author$project$NonemptyDict$w3_encode_NonemptyDict,
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_ChannelId),
						$author$project$Id$w3_encode_ThreadRoute),
					$author$project$OneOrGreater$w3_encode_OneOrGreater),
				w3_rec_var0.discordDirectMentions),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_GuildId),
				w3_rec_var0.discordNotifyOnAllMessages),
				$lamdera$containers$SeqSet$encodeSet$($author$project$RichText$w3_encode_Domain, w3_rec_var0.domainWhitelist),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.e2eeRisksAccepted),
				$author$project$User$w3_encode_BackendUserStatus(w3_rec_var0.email),
				$author$project$User$w3_encode_EmailNotifications(w3_rec_var0.emailNotifications),
				$author$project$User$w3_encode_EmbedVisibility(w3_rec_var0.embedVisibility),
				$author$project$Emoji$w3_encode_EmojiConfig(w3_rec_var0.emojiConfig),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isAdmin),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_GuildId),
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId),
					$author$project$Id$w3_encode_ThreadRoute),
				w3_rec_var0.lastChannelViewed),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_GuildId),
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_ChannelId),
					$author$project$Id$w3_encode_ThreadRoute),
				w3_rec_var0.lastDiscordChannelViewed),
				$author$project$User$w3_encode_LastDmViewed(w3_rec_var0.lastDmViewed),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.lastEmailNotification),
				$author$project$Id$w3_encode_Id$($author$project$Pagination$w3_encode_PageId, w3_rec_var0.lastLogPageViewed),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.lastPushNotification),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_TeamId),
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_ChannelId),
					$author$project$Id$w3_encode_ThreadRoute),
				w3_rec_var0.lastSlackChannelViewed),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_AnyGuildOrDmId,
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
				w3_rec_var0.lastViewedMessage),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Id$w3_encode_AnyGuildOrDmId,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId)),
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ThreadMessageId),
				w3_rec_var0.lastViewedThreadMessage),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.linkDiscordAcknowledgementIsChecked),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.linkSlackAcknowledgementIsChecked),
				$author$project$MuteSettings$w3_encode_Model(w3_rec_var0.muteSettings),
				$author$project$PersonName$w3_encode_PersonName(w3_rec_var0.name),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_GuildId),
				w3_rec_var0.notifyOnAllMessages),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$X25519$w3_encode_PublicKey, w3_rec_var0.publicKey),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.recentLoginEmails),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_TeamId),
				A2(
					$author$project$NonemptyDict$w3_encode_NonemptyDict,
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_ChannelId),
						$author$project$Id$w3_encode_ThreadRoute),
					$author$project$OneOrGreater$w3_encode_OneOrGreater),
				w3_rec_var0.slackDirectMentions),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_TeamId),
				w3_rec_var0.slackNotifyOnAllMessages)
			]));
};
var $author$project$LocalState$w3_encode_DiscordGatewayStatus = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.failedReconnectAttempts),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.websocketIsOpen)
			]));
};
var $author$project$DiscordUserData$w3_encode_DiscordUserLoadingData = function (w3v) {
	switch (w3v.$) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0)
					]));
	}
};
var $author$project$Discord$w3_encode_AvatarHash = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Discord$w3_encode_ImageHash$ = function (w3_x_c_hashType, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Discord$w3_encode_ImageHash = F2($author$project$Discord$w3_encode_ImageHash$);
var $author$project$Discord$w3_encode_UserDiscriminator = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Discord$w3_encode_PartialUser = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Discord$w3_encode_ImageHash($author$project$Discord$w3_encode_AvatarHash),
				w3_rec_var0.avatar),
				$author$project$Discord$w3_encode_UserDiscriminator(w3_rec_var0.discriminator),
				$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, w3_rec_var0.id),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.username)
			]));
};
var $author$project$Discord$w3_encode_OptionalData$ = function (w3_x_c_a, w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					w3_x_c_a(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Discord$w3_encode_OptionalData = F2($author$project$Discord$w3_encode_OptionalData$);
var $author$project$Discord$w3_encode_User = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Discord$w3_encode_ImageHash($author$project$Discord$w3_encode_AvatarHash),
				w3_rec_var0.avatar),
				$author$project$Discord$w3_encode_OptionalData$($lamdera$codecs$Lamdera$Wire3$encodeBool, w3_rec_var0.bot),
				$author$project$Discord$w3_encode_UserDiscriminator(w3_rec_var0.discriminator),
				$author$project$Discord$w3_encode_OptionalData$(
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$codecs$Lamdera$Wire3$encodeString),
				w3_rec_var0.email),
				$author$project$Discord$w3_encode_OptionalData$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.flags),
				$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, w3_rec_var0.id),
				$author$project$Discord$w3_encode_OptionalData$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.locale),
				$author$project$Discord$w3_encode_OptionalData$($lamdera$codecs$Lamdera$Wire3$encodeBool, w3_rec_var0.mfaEnabled),
				$author$project$Discord$w3_encode_OptionalData$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.premiumType),
				$author$project$Discord$w3_encode_OptionalData$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.publicFlags),
				$author$project$Discord$w3_encode_OptionalData$($lamdera$codecs$Lamdera$Wire3$encodeBool, w3_rec_var0.system),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.username),
				$author$project$Discord$w3_encode_OptionalData$($lamdera$codecs$Lamdera$Wire3$encodeBool, w3_rec_var0.verified)
			]));
};
var $author$project$LocalState$w3_encode_DiscordUserData_ForAdmin = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
									$author$project$Discord$w3_encode_PartialUser(w3_rec_var0.user)
								]));
					}(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$LocalState$w3_encode_DiscordGatewayStatus(w3_rec_var0.gateway),
									$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
									$author$project$DiscordUserData$w3_encode_DiscordUserLoadingData(w3_rec_var0.isLoadingData),
									$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.linkedAt),
									$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, w3_rec_var0.linkedTo),
									$author$project$Discord$w3_encode_User(w3_rec_var0.user)
								]));
					}(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
									$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.linkedAt),
									$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, w3_rec_var0.linkedTo),
									$author$project$Discord$w3_encode_User(w3_rec_var0.user)
								]));
					}(v0)
					]));
	}
};
var $author$project$DmChannelId$w3_encode_DmChannelId = function (w3v) {
	var v0 = w3v.a;
	var v1 = w3v.b;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0),
				$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v1)
			]));
};
var $author$project$Pages$Admin$w3_encode_EditedBackendUser = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.createdAt),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.deleteAccountAt),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.email),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isAdmin),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name)
			]));
};
var $author$project$Discord$w3_encode_ErrorCode = function (w3v) {
	switch (w3v) {
		case 65:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 24:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 44:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 42:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 58:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 45:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 47:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 46:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 48:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 38:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 43:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		case 41:
			return $elm$bytes$Bytes$Encode$unsignedInt8(12);
		case 63:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
		case 53:
			return $elm$bytes$Bytes$Encode$unsignedInt8(14);
		case 61:
			return $elm$bytes$Bytes$Encode$unsignedInt8(15);
		case 59:
			return $elm$bytes$Bytes$Encode$unsignedInt8(16);
		case 51:
			return $elm$bytes$Bytes$Encode$unsignedInt8(17);
		case 57:
			return $elm$bytes$Bytes$Encode$unsignedInt8(18);
		case 62:
			return $elm$bytes$Bytes$Encode$unsignedInt8(19);
		case 33:
			return $elm$bytes$Bytes$Encode$unsignedInt8(20);
		case 27:
			return $elm$bytes$Bytes$Encode$unsignedInt8(21);
		case 32:
			return $elm$bytes$Bytes$Encode$unsignedInt8(22);
		case 26:
			return $elm$bytes$Bytes$Encode$unsignedInt8(23);
		case 29:
			return $elm$bytes$Bytes$Encode$unsignedInt8(24);
		case 34:
			return $elm$bytes$Bytes$Encode$unsignedInt8(25);
		case 28:
			return $elm$bytes$Bytes$Encode$unsignedInt8(26);
		case 31:
			return $elm$bytes$Bytes$Encode$unsignedInt8(27);
		case 30:
			return $elm$bytes$Bytes$Encode$unsignedInt8(28);
		case 56:
			return $elm$bytes$Bytes$Encode$unsignedInt8(29);
		case 60:
			return $elm$bytes$Bytes$Encode$unsignedInt8(30);
		case 40:
			return $elm$bytes$Bytes$Encode$unsignedInt8(31);
		case 54:
			return $elm$bytes$Bytes$Encode$unsignedInt8(32);
		case 49:
			return $elm$bytes$Bytes$Encode$unsignedInt8(33);
		case 50:
			return $elm$bytes$Bytes$Encode$unsignedInt8(34);
		case 25:
			return $elm$bytes$Bytes$Encode$unsignedInt8(35);
		case 55:
			return $elm$bytes$Bytes$Encode$unsignedInt8(36);
		case 64:
			return $elm$bytes$Bytes$Encode$unsignedInt8(37);
		case 37:
			return $elm$bytes$Bytes$Encode$unsignedInt8(38);
		case 35:
			return $elm$bytes$Bytes$Encode$unsignedInt8(39);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(40);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(41);
		case 16:
			return $elm$bytes$Bytes$Encode$unsignedInt8(42);
		case 22:
			return $elm$bytes$Bytes$Encode$unsignedInt8(43);
		case 20:
			return $elm$bytes$Bytes$Encode$unsignedInt8(44);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(45);
		case 14:
			return $elm$bytes$Bytes$Encode$unsignedInt8(46);
		case 19:
			return $elm$bytes$Bytes$Encode$unsignedInt8(47);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(48);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(49);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(50);
		case 21:
			return $elm$bytes$Bytes$Encode$unsignedInt8(51);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(52);
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(53);
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(54);
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(55);
		case 23:
			return $elm$bytes$Bytes$Encode$unsignedInt8(56);
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(57);
		case 17:
			return $elm$bytes$Bytes$Encode$unsignedInt8(58);
		case 18:
			return $elm$bytes$Bytes$Encode$unsignedInt8(59);
		case 12:
			return $elm$bytes$Bytes$Encode$unsignedInt8(60);
		case 13:
			return $elm$bytes$Bytes$Encode$unsignedInt8(61);
		case 15:
			return $elm$bytes$Bytes$Encode$unsignedInt8(62);
		case 39:
			return $elm$bytes$Bytes$Encode$unsignedInt8(63);
		case 36:
			return $elm$bytes$Bytes$Encode$unsignedInt8(64);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(65);
	}
};
var $author$project$Discord$w3_encode_RateLimit = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isGlobal),
				$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var0.retryAfter)
			]));
};
var $author$project$Discord$w3_encode_HttpError = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Discord$w3_encode_ErrorCode(v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Discord$w3_encode_ErrorCode(v0)
					]));
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Discord$w3_encode_ErrorCode(v0)
					]));
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Discord$w3_encode_ErrorCode(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Discord$w3_encode_ErrorCode(v0)
					]));
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Discord$w3_encode_ErrorCode(w3_rec_var0.errorCode),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.statusCode)
								]));
					}(v0)
					]));
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Discord$w3_encode_RateLimit(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Discord$w3_encode_ErrorCode(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
	}
};
var $author$project$Slack$w3_encode_HttpError = function (w3v) {
	switch (w3v.$) {
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
	}
};
var $author$project$Discord$w3_encode_MessageId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Postmark$w3_encode_PostmarkSendResponse = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.errorCode),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.message),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$EmailAddress$w3_encode_EmailAddress, w3_rec_var0.to)
			]));
};
var $author$project$Postmark$w3_encode_SendEmailError = function (w3v) {
	switch (w3v.$) {
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Postmark$w3_encode_PostmarkSendResponse(v0)
					]));
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.body),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.statusCode)
								]));
					}(v0)
					]));
	}
};
var $author$project$Id$w3_encode_ThreadRouteWithMaybeMessage = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
					v0)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v0),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ThreadMessageId),
					v1)
				]));
	}
};
var $author$project$Log$w3_encode_Log = function (w3v) {
	switch (w3v.$) {
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0)
					]));
		case 36:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 22:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 11:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_PrivateChannelId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_MessageId, v2),
						$author$project$Emoji$w3_encode_EmojiOrCustomEmoji(v3),
						$author$project$Discord$w3_encode_HttpError(v4)
					]));
		case 10:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v1),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v2),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_MessageId, v3),
						$author$project$Emoji$w3_encode_EmojiOrCustomEmoji(v4),
						$author$project$Discord$w3_encode_HttpError(v5)
					]));
		case 32:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Id$w3_encode_SlackGuildOrDmId(v0),
						$author$project$Slack$w3_encode_HttpError(v1)
					]));
		case 7:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_PrivateChannelId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_MessageId, v2),
						$author$project$Discord$w3_encode_HttpError(v3)
					]));
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v1),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v2),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_MessageId, v3),
						$author$project$Discord$w3_encode_HttpError(v4)
					]));
		case 28:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v0)
					]));
		case 33:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Id$w3_encode_SlackGuildOrDmId(v0),
						$author$project$Slack$w3_encode_HttpError(v1)
					]));
		case 9:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_PrivateChannelId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_MessageId, v2),
						$author$project$Discord$w3_encode_HttpError(v3)
					]));
		case 8:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v1),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v2),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_MessageId, v3),
						$author$project$Discord$w3_encode_HttpError(v4)
					]));
		case 34:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$Id$w3_encode_SlackGuildOrDmId(v0),
						$author$project$Slack$w3_encode_HttpError(v1)
					]));
		case 26:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1)
					]));
		case 19:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v1),
						$author$project$Discord$w3_encode_HttpError(v2)
					]));
		case 17:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$author$project$Discord$w3_encode_HttpError(v0)
					]));
		case 25:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2(
							$lamdera$codecs$Lamdera$Wire3$encodePair,
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_CustomEmojiId),
							$lamdera$program_test$Effect$Http$w3_encode_Error),
						v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1)
					]));
		case 23:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2(
							$lamdera$codecs$Lamdera$Wire3$encodePair,
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_StickerId),
							$lamdera$program_test$Effect$Http$w3_encode_Error),
						v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1)
					]));
		case 24:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$author$project$Discord$w3_encode_HttpError(v0)
					]));
		case 14:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(19),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$author$project$Discord$w3_encode_HttpError(v1)
					]));
		case 29:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(20),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_TeamId, v0),
						$author$project$Slack$w3_encode_HttpError(v1)
					]));
		case 30:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(21),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_TeamId, v0),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2(
							$lamdera$codecs$Lamdera$Wire3$encodePair,
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_CustomEmojiId),
							$lamdera$program_test$Effect$Http$w3_encode_Error),
						v1),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v2)
					]));
		case 18:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(22),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 27:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(23),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v0)
					]));
		case 20:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(24),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v0),
						$author$project$Discord$w3_encode_HttpError(v1)
					]));
		case 13:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(25),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_PrivateChannelId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_MessageId, v2),
						$author$project$Emoji$w3_encode_EmojiOrCustomEmoji(v3),
						$author$project$Discord$w3_encode_HttpError(v4)
					]));
		case 12:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(26),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v1),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v2),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_MessageId, v3),
						$author$project$Emoji$w3_encode_EmojiOrCustomEmoji(v4),
						$author$project$Discord$w3_encode_HttpError(v5)
					]));
		case 16:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(27),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_PrivateChannelId, v1),
						$author$project$Discord$w3_encode_HttpError(v2)
					]));
		case 15:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(28),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v1),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v2),
						$author$project$Id$w3_encode_ThreadRouteWithMaybeMessage(v3),
						$author$project$Discord$w3_encode_HttpError(v4)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(29),
						$author$project$Postmark$w3_encode_SendEmailError(v0),
						$author$project$EmailAddress$w3_encode_EmailAddress(v1)
					]));
		case 31:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(30),
						$author$project$Id$w3_encode_SlackGuildOrDmId(v0),
						$author$project$Slack$w3_encode_HttpError(v1)
					]));
		case 21:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(31),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v0),
						$author$project$Discord$w3_encode_HttpError(v1)
					]));
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(32),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($author$project$Postmark$w3_encode_SendEmailError, $lamdera$codecs$Lamdera$Wire3$encodeUnit, v0),
						$author$project$EmailAddress$w3_encode_EmailAddress(v1)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(33),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0)
					]));
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(34),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v1)
					]));
		case 35:
			return $elm$bytes$Bytes$Encode$unsignedInt8(35);
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(36),
						$author$project$Postmark$w3_encode_SendEmailError(v0),
						$author$project$EmailAddress$w3_encode_EmailAddress(v1)
					]));
	}
};
var $author$project$LocalState$w3_encode_LogWithTime = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Log$w3_encode_Log(w3_rec_var0.log),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.time)
			]));
};
var $author$project$LocalState$w3_encode_PrivateVapidKey = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Discord$w3_encode_RoleColors = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.primaryColor),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.secondaryColor),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.tertiaryColor)
			]));
};
var $author$project$Discord$w3_encode_RoleIconHash = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Discord$w3_encode_IntegrationId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Discord$w3_encode_SubscriptionListingId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Discord$w3_encode_RoleTags = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.availableForPurchase),
				$author$project$Discord$w3_encode_OptionalData$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
				w3_rec_var0.botId),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.guildConnections),
				$author$project$Discord$w3_encode_OptionalData$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_IntegrationId),
				w3_rec_var0.integrationId),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.premiumSubscriber),
				$author$project$Discord$w3_encode_OptionalData$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_SubscriptionListingId),
				w3_rec_var0.subscriptionListingId)
			]));
};
var $author$project$Discord$w3_encode_Role = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Discord$w3_encode_OptionalData$($author$project$Discord$w3_encode_RoleColors, w3_rec_var0.colors),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.description),
				$author$project$Discord$w3_encode_OptionalData$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.flags),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.hoist),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Discord$w3_encode_ImageHash($author$project$Discord$w3_encode_RoleIconHash),
				w3_rec_var0.icon),
				$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_RoleId, w3_rec_var0.id),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.managed),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.mentionable),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
				$author$project$Discord$w3_encode_Permissions(w3_rec_var0.permissions),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.position),
				$author$project$Discord$w3_encode_OptionalData$($author$project$Discord$w3_encode_RoleTags, w3_rec_var0.tags),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.unicodeEmoji)
			]));
};
var $author$project$SessionIdHash$w3_encode_SessionIdHash = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$ToBackendLog$w3_encode_ToBackendLog = function (w3v) {
	switch (w3v) {
		case 15:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 17:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 16:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 18:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		case 12:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 13:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		case 95:
			return $elm$bytes$Bytes$Encode$unsignedInt8(12);
		case 73:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
		case 38:
			return $elm$bytes$Bytes$Encode$unsignedInt8(14);
		case 20:
			return $elm$bytes$Bytes$Encode$unsignedInt8(15);
		case 35:
			return $elm$bytes$Bytes$Encode$unsignedInt8(16);
		case 63:
			return $elm$bytes$Bytes$Encode$unsignedInt8(17);
		case 88:
			return $elm$bytes$Bytes$Encode$unsignedInt8(18);
		case 59:
			return $elm$bytes$Bytes$Encode$unsignedInt8(19);
		case 46:
			return $elm$bytes$Bytes$Encode$unsignedInt8(20);
		case 89:
			return $elm$bytes$Bytes$Encode$unsignedInt8(21);
		case 93:
			return $elm$bytes$Bytes$Encode$unsignedInt8(22);
		case 29:
			return $elm$bytes$Bytes$Encode$unsignedInt8(23);
		case 31:
			return $elm$bytes$Bytes$Encode$unsignedInt8(24);
		case 34:
			return $elm$bytes$Bytes$Encode$unsignedInt8(25);
		case 45:
			return $elm$bytes$Bytes$Encode$unsignedInt8(26);
		case 92:
			return $elm$bytes$Bytes$Encode$unsignedInt8(27);
		case 50:
			return $elm$bytes$Bytes$Encode$unsignedInt8(28);
		case 53:
			return $elm$bytes$Bytes$Encode$unsignedInt8(29);
		case 42:
			return $elm$bytes$Bytes$Encode$unsignedInt8(30);
		case 41:
			return $elm$bytes$Bytes$Encode$unsignedInt8(31);
		case 22:
			return $elm$bytes$Bytes$Encode$unsignedInt8(32);
		case 76:
			return $elm$bytes$Bytes$Encode$unsignedInt8(33);
		case 28:
			return $elm$bytes$Bytes$Encode$unsignedInt8(34);
		case 30:
			return $elm$bytes$Bytes$Encode$unsignedInt8(35);
		case 91:
			return $elm$bytes$Bytes$Encode$unsignedInt8(36);
		case 57:
			return $elm$bytes$Bytes$Encode$unsignedInt8(37);
		case 75:
			return $elm$bytes$Bytes$Encode$unsignedInt8(38);
		case 19:
			return $elm$bytes$Bytes$Encode$unsignedInt8(39);
		case 32:
			return $elm$bytes$Bytes$Encode$unsignedInt8(40);
		case 68:
			return $elm$bytes$Bytes$Encode$unsignedInt8(41);
		case 69:
			return $elm$bytes$Bytes$Encode$unsignedInt8(42);
		case 48:
			return $elm$bytes$Bytes$Encode$unsignedInt8(43);
		case 49:
			return $elm$bytes$Bytes$Encode$unsignedInt8(44);
		case 43:
			return $elm$bytes$Bytes$Encode$unsignedInt8(45);
		case 37:
			return $elm$bytes$Bytes$Encode$unsignedInt8(46);
		case 27:
			return $elm$bytes$Bytes$Encode$unsignedInt8(47);
		case 36:
			return $elm$bytes$Bytes$Encode$unsignedInt8(48);
		case 33:
			return $elm$bytes$Bytes$Encode$unsignedInt8(49);
		case 64:
			return $elm$bytes$Bytes$Encode$unsignedInt8(50);
		case 39:
			return $elm$bytes$Bytes$Encode$unsignedInt8(51);
		case 87:
			return $elm$bytes$Bytes$Encode$unsignedInt8(52);
		case 62:
			return $elm$bytes$Bytes$Encode$unsignedInt8(53);
		case 40:
			return $elm$bytes$Bytes$Encode$unsignedInt8(54);
		case 97:
			return $elm$bytes$Bytes$Encode$unsignedInt8(55);
		case 96:
			return $elm$bytes$Bytes$Encode$unsignedInt8(56);
		case 21:
			return $elm$bytes$Bytes$Encode$unsignedInt8(57);
		case 55:
			return $elm$bytes$Bytes$Encode$unsignedInt8(58);
		case 70:
			return $elm$bytes$Bytes$Encode$unsignedInt8(59);
		case 94:
			return $elm$bytes$Bytes$Encode$unsignedInt8(60);
		case 60:
			return $elm$bytes$Bytes$Encode$unsignedInt8(61);
		case 61:
			return $elm$bytes$Bytes$Encode$unsignedInt8(62);
		case 71:
			return $elm$bytes$Bytes$Encode$unsignedInt8(63);
		case 54:
			return $elm$bytes$Bytes$Encode$unsignedInt8(64);
		case 44:
			return $elm$bytes$Bytes$Encode$unsignedInt8(65);
		case 77:
			return $elm$bytes$Bytes$Encode$unsignedInt8(66);
		case 79:
			return $elm$bytes$Bytes$Encode$unsignedInt8(67);
		case 82:
			return $elm$bytes$Bytes$Encode$unsignedInt8(68);
		case 80:
			return $elm$bytes$Bytes$Encode$unsignedInt8(69);
		case 81:
			return $elm$bytes$Bytes$Encode$unsignedInt8(70);
		case 85:
			return $elm$bytes$Bytes$Encode$unsignedInt8(71);
		case 86:
			return $elm$bytes$Bytes$Encode$unsignedInt8(72);
		case 84:
			return $elm$bytes$Bytes$Encode$unsignedInt8(73);
		case 78:
			return $elm$bytes$Bytes$Encode$unsignedInt8(74);
		case 47:
			return $elm$bytes$Bytes$Encode$unsignedInt8(75);
		case 56:
			return $elm$bytes$Bytes$Encode$unsignedInt8(76);
		case 90:
			return $elm$bytes$Bytes$Encode$unsignedInt8(77);
		case 58:
			return $elm$bytes$Bytes$Encode$unsignedInt8(78);
		case 83:
			return $elm$bytes$Bytes$Encode$unsignedInt8(79);
		case 72:
			return $elm$bytes$Bytes$Encode$unsignedInt8(80);
		case 51:
			return $elm$bytes$Bytes$Encode$unsignedInt8(81);
		case 52:
			return $elm$bytes$Bytes$Encode$unsignedInt8(82);
		case 26:
			return $elm$bytes$Bytes$Encode$unsignedInt8(83);
		case 24:
			return $elm$bytes$Bytes$Encode$unsignedInt8(84);
		case 23:
			return $elm$bytes$Bytes$Encode$unsignedInt8(85);
		case 25:
			return $elm$bytes$Bytes$Encode$unsignedInt8(86);
		case 67:
			return $elm$bytes$Bytes$Encode$unsignedInt8(87);
		case 65:
			return $elm$bytes$Bytes$Encode$unsignedInt8(88);
		case 66:
			return $elm$bytes$Bytes$Encode$unsignedInt8(89);
		case 74:
			return $elm$bytes$Bytes$Encode$unsignedInt8(90);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(91);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(92);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(93);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(94);
		case 14:
			return $elm$bytes$Bytes$Encode$unsignedInt8(95);
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(96);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(97);
	}
};
var $author$project$ToBackendLog$w3_encode_ToBackendLogData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.endTime),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.startTime),
				$author$project$ToBackendLog$w3_encode_ToBackendLog(w3_rec_var0.toBackendLog),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				w3_rec_var0.userId)
			]));
};
var $author$project$UserSession$w3_encode_ToBeFilledInByBackend$ = function (w3_x_c_a, w3v) {
	if (!w3v.$) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					w3_x_c_a(v0)
				]));
	}
};
var $author$project$UserSession$w3_encode_ToBeFilledInByBackend = F2($author$project$UserSession$w3_encode_ToBeFilledInByBackend$);
var $author$project$IdArray$w3_encode_IdArray$ = function (w3_x_c_k, w3_x_c_v, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeArray$(w3_x_c_v, v0)
			]));
};
var $author$project$IdArray$w3_encode_IdArray = F3($author$project$IdArray$w3_encode_IdArray$);
var $author$project$UserSession$w3_encode_LastViewedGuild = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_TeamId, v0)
					]));
	}
};
var $author$project$UserSession$w3_encode_NotificationMode = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Ports$w3_encode_SubscribeKeys = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.auth),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.p256dh)
			]));
};
var $author$project$Ports$w3_encode_SubscribeData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$url$Url$w3_encode_Url(w3_rec_var0.endpoint),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				function (t) {
					return $lamdera$codecs$Lamdera$Wire3$encodeInt(
						$elm$time$Time$posixToMillis(t));
				},
				w3_rec_var0.expirationTime),
				$author$project$Ports$w3_encode_SubscribeKeys(w3_rec_var0.keys)
			]));
};
var $author$project$UserSession$w3_encode_PushSubscription = function (w3v) {
	switch (w3v.$) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Ports$w3_encode_SubscribeData(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v1)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Ports$w3_encode_SubscribeData(v0),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v1)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v1)
					]));
	}
};
var $author$project$UserSession$w3_encode_SheepGameQuestion = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$FileStatus$w3_encode_FileId),
				$author$project$FileStatus$w3_encode_FileStatus,
				w3_rec_var0.attachedFiles),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.text)
			]));
};
var $author$project$UserAgent$w3_encode_Browser = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
	}
};
var $author$project$UserAgent$w3_encode_Device = function (w3v) {
	switch (w3v) {
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
	}
};
var $author$project$UserAgent$w3_encode_UserAgent = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$UserAgent$w3_encode_Browser(w3_rec_var0.browser),
				$author$project$UserAgent$w3_encode_Device(w3_rec_var0.device)
			]));
};
var $author$project$UserSession$w3_encode_UserOptionSection = function (w3v) {
	switch (w3v) {
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
	}
};
var $author$project$UserSession$w3_encode_UserSession = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqSet$encodeSet$($author$project$UserSession$w3_encode_UserOptionSection, w3_rec_var0.expandedUserOptions),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.lastClientDisconnect),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$UserSession$w3_encode_LastViewedGuild, w3_rec_var0.lastViewedGuild),
				$author$project$UserSession$w3_encode_NotificationMode(w3_rec_var0.notificationMode),
				$author$project$UserSession$w3_encode_PushSubscription(w3_rec_var0.pushSubscription),
				$author$project$IdArray$w3_encode_IdArray$($author$project$Id$w3_encode_QuestionId, $author$project$UserSession$w3_encode_SheepGameQuestion, w3_rec_var0.savedSheepGameQuestions),
				$author$project$SessionIdHash$w3_encode_SessionIdHash(w3_rec_var0.sessionIdHash),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.signedInAt),
				$author$project$UserAgent$w3_encode_UserAgent(w3_rec_var0.userAgent),
				$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, w3_rec_var0.userId)
			]));
};
var $author$project$LocalState$w3_encode_WebsocketClosedEvent = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v1)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v1)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$lamdera$program_test$Effect$Websocket$w3_encode_CloseEventCode(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v2),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v3)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v1)
					]));
	}
};
var $author$project$Pages$Admin$w3_encode_AdminChange = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$containers$SeqDict$encodeDict$(
									$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
									$author$project$Pages$Admin$w3_encode_EditedBackendUser,
									w3_rec_var0.changedUsers),
									$lamdera$containers$SeqSet$encodeSet$(
									$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
									w3_rec_var0.deletedUsers),
									$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Pages$Admin$w3_encode_EditedBackendUser, w3_rec_var0.newUsers),
									$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.time)
								]));
					}(v0)
					]));
		case 28:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_PrivateChannelId, v0)
					]));
		case 29:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v0)
					]));
		case 32:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0)
					]));
		case 40:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$codecs$Lamdera$Wire3$encodeResult,
							$lamdera$program_test$Effect$Http$w3_encode_Error,
							$lamdera$codecs$Lamdera$Wire3$encodeList($author$project$FileStatus$w3_encode_FileHash)),
						v0)
					]));
		case 38:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$SessionIdHash$w3_encode_SessionIdHash(v0)
					]));
		case 31:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_DmChannelId, v0)
					]));
		case 30:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_TeamId, v0)
					]));
		case 37:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$SessionIdHash$w3_encode_SessionIdHash(v0),
						$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId(v1)
					]));
		case 15:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						$lamdera$codecs$Lamdera$Wire3$encodeArray($author$project$BackendMsgLog$w3_encode_BackendMsgLogData),
						v0)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_GuildId),
							$author$project$LocalState$w3_encode_AdminData_DeletedGuild),
						v0)
					]));
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_PrivateChannelId),
							$author$project$LocalState$w3_encode_AdminData_DiscordDmChannel),
						v0)
					]));
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_GuildId),
							$author$project$LocalState$w3_encode_AdminData_DiscordGuild),
						v0)
					]));
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
							$author$project$LocalState$w3_encode_DiscordUserData_ForAdmin),
						v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2($lamdera$containers$SeqDict$encodeDict, $author$project$DmChannelId$w3_encode_DmChannelId, $author$project$LocalState$w3_encode_AdminData_DmChannel),
						v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_GuildId),
							$author$project$LocalState$w3_encode_AdminData_Guild),
						v0)
					]));
		case 13:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2($lamdera$containers$SeqDict$encodeDict, $author$project$FileStatus$w3_encode_FileHash, $author$project$FileStatus$w3_encode_BackendFileData),
						v0)
					]));
		case 11:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2($lamdera$containers$SeqDict$encodeDict, $author$project$SessionIdHash$w3_encode_SessionIdHash, $author$project$UserSession$w3_encode_UserSession),
						v0)
					]));
		case 10:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_DmChannelId),
							$author$project$LocalState$w3_encode_AdminData_SlackDmChannel),
						v0)
					]));
		case 9:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(19),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_TeamId),
							$author$project$LocalState$w3_encode_AdminData_SlackWorkspace),
						v0)
					]));
		case 14:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(20),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						$lamdera$codecs$Lamdera$Wire3$encodeArray($author$project$ToBackendLog$w3_encode_ToBackendLogData),
						v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(21),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$author$project$NonemptyDict$w3_encode_NonemptyDict,
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
							$author$project$User$w3_encode_BackendUser),
						v0)
					]));
		case 12:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(22),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						$lamdera$codecs$Lamdera$Wire3$encodeArray($author$project$LocalState$w3_encode_WebsocketClosedEvent),
						v0)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(23),
						$author$project$Id$w3_encode_Id$($author$project$Pagination$w3_encode_PageId, v0),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						$lamdera$codecs$Lamdera$Wire3$encodeArray($author$project$LocalState$w3_encode_LogWithTime),
						v1)
					]));
		case 39:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(24),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2($lamdera$codecs$Lamdera$Wire3$encodeResult, $lamdera$program_test$Effect$Http$w3_encode_Error, $lamdera$program_test$Effect$Time$w3_encode_Posix),
						v0)
					]));
		case 36:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(25),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v1),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$codecs$Lamdera$Wire3$encodeResult,
							$author$project$Discord$w3_encode_HttpError,
							$lamdera$codecs$Lamdera$Wire3$encodeList($author$project$Discord$w3_encode_Role)),
						v2)
					]));
		case 33:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(26),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0)
					]));
		case 19:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(27),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, v0)
					]));
		case 18:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(28),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 16:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(29),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 26:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(30),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
						v0)
					]));
		case 25:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(31),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v0)
					]));
		case 24:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(32),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v0)
					]));
		case 27:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(33),
						$author$project$Postmark$w3_encode_ApiKey(v0)
					]));
		case 22:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(34),
						$author$project$LocalState$w3_encode_PrivateVapidKey(v0)
					]));
		case 23:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(35),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 17:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(36),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 21:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(37),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, v0)
					]));
		case 20:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(38),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 35:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(39),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v1),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_PrivateChannelId, v2)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(40),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v1),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v2),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v3)
					]));
	}
};
var $author$project$Drawing$w3_encode_MessageAnchor = function (w3v) {
	switch (w3v.$) {
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Id$w3_encode_Id$($author$project$FileStatus$w3_encode_FileId, v0)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
	}
};
var $author$project$Drawing$w3_encode_AnchorType = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Id$w3_encode_ThreadRoute(v0),
					$justinmimbs$date$Date$w3_encode_Date(v1)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Id$w3_encode_ThreadRouteWithMessage(v0),
					$author$project$Drawing$w3_encode_MessageAnchor(v1)
				]));
	}
};
var $author$project$Types$w3_encode_ChannelDataToDecrypt = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
				$author$project$Encryption$w3_encode_EncryptedData(
					$author$project$Message$w3_encode_MessageContent$(
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId))),
				w3_rec_var0.channel),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
				A2(
					$author$project$NonemptyDict$w3_encode_NonemptyDict,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ThreadMessageId),
					$author$project$Encryption$w3_encode_EncryptedData(
						$author$project$Message$w3_encode_MessageContent$(
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId)))),
				w3_rec_var0.threads)
			]));
};
var $author$project$Types$w3_encode_ChannelDataToEncrypt = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
				$author$project$Message$w3_encode_MessageContent$(
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId)),
				w3_rec_var0.channel),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ThreadMessageId),
					$author$project$Message$w3_encode_MessageContent$(
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId))),
				w3_rec_var0.threads)
			]));
};
var $author$project$ChannelDescription$w3_encode_ChannelDescription = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Go$w3_encode_Action = function (w3v) {
	switch (w3v.$) {
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
	}
};
var $author$project$Go$w3_encode_ActionWithTime = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Go$w3_encode_Action(w3_rec_var0.change),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.time)
			]));
};
var $author$project$SheepGame$w3_encode_Reactions = A2(
	$lamdera$containers$SeqDict$encodeDict,
	$author$project$Emoji$w3_encode_EmojiOrCustomEmoji,
	$author$project$NonemptySet$w3_encode_NonemptySet(
		$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId)));
var $author$project$SheepGame$w3_encode_ValidatedInput = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$FileStatus$w3_encode_FileId),
				$author$project$FileStatus$w3_encode_FileData,
				w3_rec_var0.attachedFiles),
				$author$project$SheepGame$w3_encode_Reactions(w3_rec_var0.reactions),
				$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
				A2(
					$author$project$RichText$w3_encode_RichText,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId)),
				w3_rec_var0.text)
			]));
};
var $author$project$SheepGame$w3_encode_Action = function (w3v) {
	switch (w3v.$) {
		case 7:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$SheepGame$w3_encode_ReactionTarget(v0),
						$author$project$Emoji$w3_encode_EmojiOrCustomEmoji(v1)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v2)
					]));
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$SheepGame$w3_encode_ValidatedInput, v1)
					]));
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v0)
					]));
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 8:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$SheepGame$w3_encode_ReactionTarget(v0),
						$author$project$Emoji$w3_encode_EmojiOrCustomEmoji(v1)
					]));
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$SheepGame$w3_encode_ValidatedInput, v1)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
	}
};
var $author$project$SheepGame$w3_encode_ActionWithTime = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$SheepGame$w3_encode_Action(w3_rec_var0.change),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.time),
				$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, w3_rec_var0.userId)
			]));
};
var $author$project$WordSpellingGame$w3_encode_IsValid = function (w3v) {
	if (w3v.$ === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodeSet$($lamdera$codecs$Lamdera$Wire3$encodeString, v0)
				]));
	}
};
var $author$project$WordSpellingGame$w3_encode_Letter = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeChar(v0)
			]));
};
var $author$project$WordSpellingGame$w3_encode_LetterOrWildcard = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$WordSpellingGame$w3_encode_Letter(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$WordSpellingGame$w3_encode_PlacedWord = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isVertical),
				$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$($author$project$WordSpellingGame$w3_encode_LetterOrWildcard, w3_rec_var0.letters),
				$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.start)
			]));
};
var $author$project$WordSpellingGame$w3_encode_Action = function (w3v) {
	switch (w3v.$) {
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$WordSpellingGame$w3_encode_ReactionTarget(v0),
						$author$project$Emoji$w3_encode_EmojiOrCustomEmoji(v1)
					]));
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$WordSpellingGame$w3_encode_PlacedWord(v0),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$($author$project$WordSpellingGame$w3_encode_IsValid, v1)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$WordSpellingGame$w3_encode_PlacedWord(v0),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$($author$project$WordSpellingGame$w3_encode_IsValid, v1)
					]));
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$WordSpellingGame$w3_encode_ReactionTarget(v0),
						$author$project$Emoji$w3_encode_EmojiOrCustomEmoji(v1)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
	}
};
var $author$project$WordSpellingGame$w3_encode_ActionWithTime = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$WordSpellingGame$w3_encode_Action(w3_rec_var0.change),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.time),
				$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, w3_rec_var0.userId)
			]));
};
var $author$project$SheepGame$w3_encode_Phase = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$SheepGame$w3_encode_Shared = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				A2(
					$author$project$IdArray$w3_encode_IdArray,
					$author$project$Id$w3_encode_QuestionId,
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe($author$project$SheepGame$w3_encode_ValidatedInput)),
				w3_rec_var0.answers),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_QuestionId)),
				$lamdera$codecs$Lamdera$Wire3$encodeString,
				w3_rec_var0.groups),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_QuestionId),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe($author$project$SheepGame$w3_encode_ValidatedInput),
				w3_rec_var0.notes),
				$author$project$SheepGame$w3_encode_Phase(w3_rec_var0.phase),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.questionsRevealed)
			]));
};
var $author$project$WordSpellingGame$w3_encode_AnimatedPlacement = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
					$author$project$WordSpellingGame$w3_encode_LetterOrWildcard),
				w3_rec_var0.cells),
				$author$project$UserSession$w3_encode_ToBeFilledInByBackend$($author$project$WordSpellingGame$w3_encode_IsValid, w3_rec_var0.isValid),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.startTime)
			]));
};
var $author$project$WordSpellingGame$w3_encode_LetterId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$WordSpellingGame$w3_encode_PlacementResult = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
					$author$project$WordSpellingGame$w3_encode_LetterOrWildcard),
				w3_rec_var0.placedCells),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.score),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$WordSpellingGame$w3_encode_LetterOrWildcard, w3_rec_var1.letters),
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.placedCount)
							]));
				},
				w3_rec_var0.words)
			]));
};
var $author$project$WordSpellingGame$w3_encode_Player = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				A3($lamdera$codecs$Lamdera$Wire3$encodeTriple, $author$project$WordSpellingGame$w3_encode_PlacedWord, $author$project$WordSpellingGame$w3_encode_PlacementResult, $author$project$WordSpellingGame$w3_encode_IsValid),
				w3_rec_var0.premove),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.score),
				$author$project$IdArray$w3_encode_IdArray$($author$project$WordSpellingGame$w3_encode_LetterId, $author$project$WordSpellingGame$w3_encode_LetterOrWildcard, w3_rec_var0.tray),
				$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, w3_rec_var0.userId)
			]));
};
var $author$project$WordSpellingGame$w3_encode_Reactions = A2(
	$lamdera$containers$SeqDict$encodeDict,
	$author$project$Emoji$w3_encode_EmojiOrCustomEmoji,
	$author$project$NonemptySet$w3_encode_NonemptySet(
		$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId)));
var $author$project$WordSpellingGame$w3_encode_Shared = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$OneOrGreater$w3_encode_OneOrGreater(w3_rec_var0.attemptsLeft),
				$lamdera$containers$SeqDict$encodeDict$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				$author$project$WordSpellingGame$w3_encode_LetterOrWildcard,
				w3_rec_var0.board),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$WordSpellingGame$w3_encode_AnimatedPlacement, w3_rec_var0.lastPlacement),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.passingStartedAt),
				$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$($author$project$WordSpellingGame$w3_encode_Player, w3_rec_var0.players),
				$lamdera$containers$SeqDict$encodeDict$($author$project$WordSpellingGame$w3_encode_ReactionTarget, $author$project$WordSpellingGame$w3_encode_Reactions, w3_rec_var0.reactions),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.turnCount)
			]));
};
var $author$project$Go$w3_encode_BoardSize = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Go$w3_encode_KomiHalfPoints = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Go$w3_encode_Stone = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Go$w3_encode_TimeControl = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var0.increment),
				$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var0.mainTime)
			]));
};
var $author$project$Go$w3_encode_ValidatedSetup = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, w3_rec_var0.createdBy),
				$author$project$Go$w3_encode_Stone(w3_rec_var0.gameCreatorPlayingAs),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.handicap),
				$author$project$Go$w3_encode_BoardSize(w3_rec_var0.height),
				$author$project$Go$w3_encode_KomiHalfPoints(w3_rec_var0.komiHalfPoints),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Go$w3_encode_TimeControl, w3_rec_var0.timeControl),
				$author$project$Go$w3_encode_BoardSize(w3_rec_var0.width)
			]));
};
var $author$project$SheepGame$w3_encode_ValidatedSetup = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, w3_rec_var0.createdBy),
				$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$($author$project$SheepGame$w3_encode_ValidatedInput, w3_rec_var0.questions)
			]));
};
var $author$project$WordSpellingGame$w3_encode_Language = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$WordSpellingGame$w3_encode_ValidatedSetup = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, w3_rec_var0.createdBy),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.fullTrayBonus),
				$author$project$WordSpellingGame$w3_encode_Language(w3_rec_var0.language),
				$author$project$NonemptyDict$w3_encode_NonemptyDict$(
				$author$project$WordSpellingGame$w3_encode_LetterOrWildcard,
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$author$project$OneOrGreater$w3_encode_OneOrGreater(w3_rec_var1.count),
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.value)
							]));
				},
				w3_rec_var0.letters),
				$author$project$OneOrGreater$w3_encode_OneOrGreater(w3_rec_var0.placeWordAttempts),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.seed),
				$author$project$Go$w3_encode_TimeControl(w3_rec_var0.timeControls),
				$author$project$OneOrGreater$w3_encode_OneOrGreater(w3_rec_var0.traySize)
			]));
};
var $author$project$Game$w3_encode_BackendGameData = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Go$w3_encode_ValidatedSetup(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Go$w3_encode_ActionWithTime, v1)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$SheepGame$w3_encode_ValidatedSetup(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$SheepGame$w3_encode_ActionWithTime, v1),
						$author$project$SheepGame$w3_encode_Shared(v2)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$WordSpellingGame$w3_encode_ValidatedSetup(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$WordSpellingGame$w3_encode_ActionWithTime, v1),
						$author$project$WordSpellingGame$w3_encode_Shared(v2)
					]));
	}
};
var $author$project$Id$w3_encode_GamePublicId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$SecretId$w3_encode_SecretId$ = function (w3_x_c_a, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$SecretId$w3_encode_SecretId = F2($author$project$SecretId$w3_encode_SecretId$);
var $author$project$Game$w3_encode_LoadedMatch = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Game$w3_encode_BackendGameData(w3_rec_var0.gameData),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$SecretId$w3_encode_SecretId($author$project$Id$w3_encode_GamePublicId),
				w3_rec_var0.publicLink)
			]));
};
var $author$project$DmChannel$w3_encode_LoadedMessages = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
				A3(
					$author$project$Message$w3_encode_Message,
					$author$project$Id$w3_encode_ChannelMessageId,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId)),
				w3_rec_var0.messages),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
				$author$project$Game$w3_encode_LoadedMatch,
				w3_rec_var0.repliedToMatches)
			]));
};
var $author$project$Call$w3_encode_RemoteCallData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.audioInputEnabled),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.screenShareEnabled),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.videoInputEnabled)
			]));
};
var $author$project$Call$w3_encode_LocalChange = function (w3v) {
	switch (w3v.$) {
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0)
					]));
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Call$w3_encode_RemoteCallData(v0)
					]));
	}
};
var $author$project$Drawing$w3_encode_LocalChange = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$SafeFloat$w3_encode_SafeFloat, $author$project$SafeFloat$w3_encode_SafeFloat),
						v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$SafeFloat$w3_encode_SafeFloat, $author$project$SafeFloat$w3_encode_SafeFloat),
						v0)
					]));
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$SafeFloat$w3_encode_SafeFloat, $author$project$SafeFloat$w3_encode_SafeFloat, v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
	}
};
var $author$project$Go$w3_encode_LocalChange = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Go$w3_encode_ActionWithTime(v0)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
					$author$project$Go$w3_encode_ValidatedSetup(v1)
				]));
	}
};
var $author$project$SheepGame$w3_encode_LocalChange = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$SheepGame$w3_encode_ActionWithTime(v0)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
					$author$project$SheepGame$w3_encode_ValidatedSetup(v1)
				]));
	}
};
var $author$project$WordSpellingGame$w3_encode_LocalChange = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$WordSpellingGame$w3_encode_ActionWithTime(v0)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
					$author$project$WordSpellingGame$w3_encode_ValidatedSetup(v1)
				]));
	}
};
var $author$project$Game$w3_encode_LocalChange = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v0),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						$author$project$SecretId$w3_encode_SecretId($author$project$Id$w3_encode_GamePublicId),
						v1)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v0),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$($author$project$Game$w3_encode_LoadedMatch, v1)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v0),
						$author$project$Go$w3_encode_LocalChange(v1)
					]));
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v0),
						$author$project$SheepGame$w3_encode_LocalChange(v1)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v0),
						$author$project$WordSpellingGame$w3_encode_LocalChange(v1)
					]));
	}
};
var $author$project$TextEditor$w3_encode_EditChange = function (w3v) {
	var v0 = w3v.a;
	var v1 = w3v.b;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$author$project$Range$w3_encode_Range(v0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
			]));
};
var $author$project$TextEditor$w3_encode_LocalChange = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$TextEditor$w3_encode_EditChange(v0)
					]));
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$User$w3_encode_NotificationLevel = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$VisibleMessages$w3_encode_PageRequest$ = function (w3_x_c_messageId, w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Id$w3_encode_Id$(w3_x_c_messageId, v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Id$w3_encode_Id$(w3_x_c_messageId, v0)
				]));
	}
};
var $author$project$VisibleMessages$w3_encode_PageRequest = F2($author$project$VisibleMessages$w3_encode_PageRequest$);
var $author$project$Ports$w3_encode_RegisterPushSubscription = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Ports$w3_encode_SubscribeData(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
				]));
	}
};
var $author$project$UserSession$w3_encode_DiscordFrontendUser = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$UserColor$w3_encode_UserColor(w3_rec_var0.color),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
				$author$project$PersonName$w3_encode_PersonName(w3_rec_var0.name)
			]));
};
var $author$project$UserSession$w3_encode_UnreadOverviewData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_PrivateChannelId),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
					A3(
						$author$project$Message$w3_encode_Message,
						$author$project$Id$w3_encode_ChannelMessageId,
						$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
						$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_ChannelId))),
				w3_rec_var0.discordDmChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_GuildId),
					$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_ChannelId)),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
					A3(
						$author$project$Message$w3_encode_Message,
						$author$project$Id$w3_encode_ChannelMessageId,
						$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
						$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_ChannelId))),
				w3_rec_var0.discordGuildChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				A3(
					$lamdera$codecs$Lamdera$Wire3$encodeTriple,
					$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_GuildId),
					$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_ChannelId),
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId)),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ThreadMessageId),
					A3(
						$author$project$Message$w3_encode_Message,
						$author$project$Id$w3_encode_ThreadMessageId,
						$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
						$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_ChannelId))),
				w3_rec_var0.discordGuildThreads),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
				$author$project$UserSession$w3_encode_DiscordFrontendUser,
				w3_rec_var0.discordUsers),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
					A3(
						$author$project$Message$w3_encode_Message,
						$author$project$Id$w3_encode_ChannelMessageId,
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId))),
				w3_rec_var0.dmChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId)),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ThreadMessageId),
					A3(
						$author$project$Message$w3_encode_Message,
						$author$project$Id$w3_encode_ThreadMessageId,
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId))),
				w3_rec_var0.dmThreads),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_GuildId),
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId)),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
					A3(
						$author$project$Message$w3_encode_Message,
						$author$project$Id$w3_encode_ChannelMessageId,
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId))),
				w3_rec_var0.guildChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				A3(
					$lamdera$codecs$Lamdera$Wire3$encodeTriple,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_GuildId),
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId),
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId)),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ThreadMessageId),
					A3(
						$author$project$Message$w3_encode_Message,
						$author$project$Id$w3_encode_ThreadMessageId,
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId))),
				w3_rec_var0.guildThreads),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_TeamId),
					$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_ChannelId)),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
					A3(
						$author$project$Message$w3_encode_Message,
						$author$project$Id$w3_encode_ChannelMessageId,
						$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_UserId),
						$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_ChannelId))),
				w3_rec_var0.slackChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_DmChannelId),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
					A3(
						$author$project$Message$w3_encode_Message,
						$author$project$Id$w3_encode_ChannelMessageId,
						$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_UserId),
						$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_ChannelId))),
				w3_rec_var0.slackDmChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_DmChannelId),
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId)),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ThreadMessageId),
					A3(
						$author$project$Message$w3_encode_Message,
						$author$project$Id$w3_encode_ThreadMessageId,
						$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_UserId),
						$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_ChannelId))),
				w3_rec_var0.slackDmThreads),
				$lamdera$containers$SeqDict$encodeDict$(
				A3(
					$lamdera$codecs$Lamdera$Wire3$encodeTriple,
					$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_TeamId),
					$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_ChannelId),
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId)),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ThreadMessageId),
					A3(
						$author$project$Message$w3_encode_Message,
						$author$project$Id$w3_encode_ThreadMessageId,
						$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_UserId),
						$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_ChannelId))),
				w3_rec_var0.slackThreads)
			]));
};
var $author$project$UserSession$w3_encode_ViewDiscordGuildData = function (w3_x_c_messageId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$containers$SeqDict$encodeDict$(
					$author$project$Id$w3_encode_Id(w3_x_c_messageId),
					A3(
						$author$project$Message$w3_encode_Message,
						w3_x_c_messageId,
						$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
						$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_ChannelId)),
					w3_rec_var0.messages),
					$lamdera$containers$SeqDict$encodeDict$(
					$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
					$author$project$UserSession$w3_encode_DiscordFrontendUser,
					w3_rec_var0.newUsers)
				]));
	};
};
var $author$project$UserSession$w3_encode_ChannelHeaderTab = function (w3v) {
	switch (w3v.$) {
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
						v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Message$w3_encode_RepliedToGame, v1)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$UserSession$w3_encode_PreviouslyLastViewedMessage$ = function (w3_x_c_messageId, w3v) {
	if (!w3v.$) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Id$w3_encode_Id$(w3_x_c_messageId, v0)
				]));
	}
};
var $author$project$UserSession$w3_encode_PreviouslyLastViewedMessage = F2($author$project$UserSession$w3_encode_PreviouslyLastViewedMessage$);
var $author$project$UserSession$w3_encode_Viewing_ChannelData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$UserSession$w3_encode_ChannelHeaderTab, w3_rec_var0.channelHeaderTab),
				$author$project$Id$w3_encode_Viewing_ChannelId(w3_rec_var0.id),
				$author$project$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Id$w3_encode_ChannelMessageId, w3_rec_var0.previouslyLastViewedMessage)
			]));
};
var $author$project$Id$w3_encode_Viewing_ChannelThreadId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelId, w3_rec_var0.channelId),
				$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, w3_rec_var0.guildId),
				$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, w3_rec_var0.threadId)
			]));
};
var $author$project$UserSession$w3_encode_Viewing_ChannelThreadData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Id$w3_encode_Viewing_ChannelThreadId(w3_rec_var0.id),
				$author$project$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Id$w3_encode_ThreadMessageId, w3_rec_var0.previouslyLastViewedMessage)
			]));
};
var $author$project$UserSession$w3_encode_Viewing_DiscordChannelData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Id$w3_encode_Viewing_DiscordChannelId(w3_rec_var0.id),
				$author$project$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Id$w3_encode_ChannelMessageId, w3_rec_var0.previouslyLastViewedMessage)
			]));
};
var $author$project$Id$w3_encode_Viewing_DiscordChannelThreadId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, w3_rec_var0.channelId),
				$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, w3_rec_var0.currentUserId),
				$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, w3_rec_var0.guildId),
				$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, w3_rec_var0.threadId)
			]));
};
var $author$project$UserSession$w3_encode_Viewing_DiscordChannelThreadData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Id$w3_encode_Viewing_DiscordChannelThreadId(w3_rec_var0.id),
				$author$project$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Id$w3_encode_ThreadMessageId, w3_rec_var0.previouslyLastViewedMessage)
			]));
};
var $author$project$UserSession$w3_encode_Viewing_DiscordDmData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Id$w3_encode_Viewing_DiscordDmId(w3_rec_var0.id),
				$author$project$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Id$w3_encode_ChannelMessageId, w3_rec_var0.previouslyLastViewedMessage)
			]));
};
var $author$project$UserSession$w3_encode_Viewing_DmData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$UserSession$w3_encode_ChannelHeaderTab, w3_rec_var0.channelHeaderTab),
				$author$project$Id$w3_encode_Viewing_DmId(w3_rec_var0.id),
				$author$project$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Id$w3_encode_ChannelMessageId, w3_rec_var0.previouslyLastViewedMessage)
			]));
};
var $author$project$Id$w3_encode_Viewing_DmThreadId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, w3_rec_var0.otherUserId),
				$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, w3_rec_var0.threadId)
			]));
};
var $author$project$UserSession$w3_encode_Viewing_DmThreadData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Id$w3_encode_Viewing_DmThreadId(w3_rec_var0.id),
				$author$project$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Id$w3_encode_ThreadMessageId, w3_rec_var0.previouslyLastViewedMessage)
			]));
};
var $author$project$UserSession$w3_encode_Viewing_SlackChannelData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Id$w3_encode_Viewing_SlackChannelId(w3_rec_var0.id),
				$author$project$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Id$w3_encode_ChannelMessageId, w3_rec_var0.previouslyLastViewedMessage)
			]));
};
var $author$project$UserSession$w3_encode_Viewing_SlackChannelThreadData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Id$w3_encode_Viewing_SlackChannelId(w3_rec_var0.id),
				$author$project$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Id$w3_encode_ThreadMessageId, w3_rec_var0.previouslyLastViewedMessage),
				$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, w3_rec_var0.threadId)
			]));
};
var $author$project$UserSession$w3_encode_Viewing_SlackDmData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Id$w3_encode_Viewing_SlackDmId(w3_rec_var0.id),
				$author$project$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Id$w3_encode_ChannelMessageId, w3_rec_var0.previouslyLastViewedMessage)
			]));
};
var $author$project$UserSession$w3_encode_Viewing_SlackDmThreadData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Id$w3_encode_Viewing_SlackDmId(w3_rec_var0.id),
				$author$project$UserSession$w3_encode_PreviouslyLastViewedMessage$($author$project$Id$w3_encode_ThreadMessageId, w3_rec_var0.previouslyLastViewedMessage),
				$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, w3_rec_var0.threadId)
			]));
};
var $author$project$SetViewing$w3_encode_SetViewing = function (w3v) {
	switch (w3v.$) {
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$UserSession$w3_encode_Viewing_ChannelData(v0),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$($author$project$DmChannel$w3_encode_LoadedMessages, v1)
					]));
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$UserSession$w3_encode_Viewing_ChannelThreadData(v0),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ThreadMessageId),
							A3(
								$author$project$Message$w3_encode_Message,
								$author$project$Id$w3_encode_ThreadMessageId,
								$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
								$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId))),
						v1)
					]));
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$UserSession$w3_encode_Viewing_DiscordChannelData(v0),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						$author$project$UserSession$w3_encode_ViewDiscordGuildData($author$project$Id$w3_encode_ChannelMessageId),
						v1)
					]));
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$UserSession$w3_encode_Viewing_DiscordChannelThreadData(v0),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						$author$project$UserSession$w3_encode_ViewDiscordGuildData($author$project$Id$w3_encode_ThreadMessageId),
						v1)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$UserSession$w3_encode_Viewing_DiscordDmData(v0),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
							A3(
								$author$project$Message$w3_encode_Message,
								$author$project$Id$w3_encode_ChannelMessageId,
								$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
								$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_ChannelId))),
						v1)
					]));
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$UserSession$w3_encode_Viewing_DmData(v0),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$($author$project$DmChannel$w3_encode_LoadedMessages, v1)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$UserSession$w3_encode_Viewing_DmThreadData(v0),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ThreadMessageId),
							A3(
								$author$project$Message$w3_encode_Message,
								$author$project$Id$w3_encode_ThreadMessageId,
								$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
								$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId))),
						v1)
					]));
		case 12:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$($author$project$UserSession$w3_encode_UnreadOverviewData, v0)
					]));
		case 7:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$UserSession$w3_encode_Viewing_SlackChannelData(v0),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
							A3(
								$author$project$Message$w3_encode_Message,
								$author$project$Id$w3_encode_ChannelMessageId,
								$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_UserId),
								$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_ChannelId))),
						v1)
					]));
		case 9:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$UserSession$w3_encode_Viewing_SlackChannelThreadData(v0),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ThreadMessageId),
							A3(
								$author$project$Message$w3_encode_Message,
								$author$project$Id$w3_encode_ThreadMessageId,
								$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_UserId),
								$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_ChannelId))),
						v1)
					]));
		case 8:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$UserSession$w3_encode_Viewing_SlackDmData(v0),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
							A3(
								$author$project$Message$w3_encode_Message,
								$author$project$Id$w3_encode_ChannelMessageId,
								$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_UserId),
								$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_ChannelId))),
						v1)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$UserSession$w3_encode_Viewing_SlackDmThreadData(v0),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ThreadMessageId),
							A3(
								$author$project$Message$w3_encode_Message,
								$author$project$Id$w3_encode_ThreadMessageId,
								$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_UserId),
								$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_ChannelId))),
						v1)
					]));
	}
};
var $author$project$Types$w3_encode_LocalChange = function (w3v) {
	switch (w3v.$) {
		case 76:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Id$w3_encode_Viewing_DmId(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v1),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2($lamdera$containers$SeqDict$encodeDict, $author$project$Id$w3_encode_Viewing_DmId, $author$project$Types$w3_encode_ChannelDataToEncrypt),
						v2)
					]));
		case 55:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$NonemptySet$w3_encode_NonemptySet$(
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_CustomEmojiId),
						v0)
					]));
		case 19:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v1),
						$author$project$Emoji$w3_encode_EmojiOrCustomEmoji(v2)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Pages$Admin$w3_encode_AdminChange(v0)
					]));
		case 16:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v1)
					]));
		case 45:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 40:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$UserSession$w3_encode_UserOptionSection(v0)
					]));
		case 27:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.markMessagesAsViewed)
								]));
					}(v0),
						$author$project$SetViewing$w3_encode_SetViewing(v1)
					]));
		case 70:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Id$w3_encode_Viewing_DmId(v0)
					]));
		case 69:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Id$w3_encode_Viewing_DmId(v0)
					]));
		case 74:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Id$w3_encode_Viewing_DmId(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						A2(
							$lamdera$codecs$Lamdera$Wire3$encodePair,
							$author$project$Id$w3_encode_ThreadRouteWithMessage,
							$author$project$Message$w3_encode_MessageContent$(
								$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
								$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId))),
						v2)
					]));
		case 10:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelId, v1)
					]));
		case 12:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0)
					]));
		case 15:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$SecretId$w3_encode_SecretId$($author$project$Id$w3_encode_InviteLinkId, v1)
					]));
		case 26:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$author$project$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 73:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$author$project$Id$w3_encode_Viewing_DmId(v0),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$($author$project$Types$w3_encode_ChannelDataToDecrypt, v1)
					]));
		case 33:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$author$project$Id$w3_encode_DiscordGuildOrDmId(v0),
						$author$project$VisibleMessages$w3_encode_PageRequest$($author$project$Id$w3_encode_ChannelMessageId, v1),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
							A3(
								$author$project$Message$w3_encode_Message,
								$author$project$Id$w3_encode_ChannelMessageId,
								$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
								$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_ChannelId))),
						v2)
					]));
		case 34:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$author$project$Id$w3_encode_DiscordGuildOrDmId(v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v1),
						$author$project$VisibleMessages$w3_encode_PageRequest$($author$project$Id$w3_encode_ThreadMessageId, v2),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ThreadMessageId),
							A3(
								$author$project$Message$w3_encode_Message,
								$author$project$Id$w3_encode_ThreadMessageId,
								$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
								$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_ChannelId))),
						v3)
					]));
		case 23:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Zone(v1),
						$author$project$Id$w3_encode_Viewing_DiscordDmId(v2),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v3),
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v4)
					]));
		case 22:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			var v6 = w3v.g;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(19),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Zone(v1),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v2),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v3),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v4),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v5),
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v6)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(20),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Zone(v1),
						$author$project$Id$w3_encode_DiscordGuildOrDmId(v2),
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v3),
						$author$project$Id$w3_encode_ThreadRouteWithMaybeMessage(v4),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Id$w3_encode_Id($author$project$FileStatus$w3_encode_FileId),
						$author$project$FileStatus$w3_encode_FileData,
						v5)
					]));
		case 58:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(21),
						$author$project$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Drawing$w3_encode_AnchorType(v1),
						$author$project$Drawing$w3_encode_LocalChange(v2)
					]));
		case 9:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(22),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelId, v1),
						$author$project$ChannelName$w3_encode_ChannelName(v2),
						$author$project$ChannelDescription$w3_encode_ChannelDescription(v3)
					]));
		case 11:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(23),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$GuildName$w3_encode_GuildName(v1)
					]));
		case 72:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(24),
						$author$project$Id$w3_encode_Viewing_DmId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						A3(
							$lamdera$codecs$Lamdera$Wire3$encodeTriple,
							$author$project$Id$w3_encode_ThreadRouteWithMessage,
							$lamdera$containers$SeqSet$encodeSet($author$project$FileStatus$w3_encode_FileHash),
							$author$project$Encryption$w3_encode_EncryptedData(
								$author$project$Message$w3_encode_MessageContent$(
									$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
									$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId)))),
						v1)
					]));
		case 39:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(25),
						$author$project$UserSession$w3_encode_UserOptionSection(v0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.collapseOthers)
								]));
					}(v1)
					]));
		case 57:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(26),
						$author$project$Id$w3_encode_GuildOrDmId(v0),
						$author$project$Game$w3_encode_LocalChange(v1)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(27);
		case 13:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(28),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0)
					]));
		case 50:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(29),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 51:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(30),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 29:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(31),
						$author$project$Id$w3_encode_GuildOrDmId(v0),
						$author$project$VisibleMessages$w3_encode_PageRequest$($author$project$Id$w3_encode_ChannelMessageId, v1),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$($author$project$DmChannel$w3_encode_LoadedMessages, v2)
					]));
		case 30:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(32),
						$author$project$Id$w3_encode_GuildOrDmId(v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v1),
						$author$project$VisibleMessages$w3_encode_PageRequest$($author$project$Id$w3_encode_ThreadMessageId, v2),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ThreadMessageId),
							A3(
								$author$project$Message$w3_encode_Message,
								$author$project$Id$w3_encode_ThreadMessageId,
								$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
								$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId))),
						v3)
					]));
		case 24:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(33),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Id$w3_encode_AnyGuildOrDmId(v1),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v2)
					]));
		case 18:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(34),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Id$w3_encode_AnyGuildOrDmId, $author$project$Id$w3_encode_ThreadRoute, v1)
					]));
		case 8:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(35),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v1),
						$author$project$ChannelName$w3_encode_ChannelName(v2),
						$author$project$ChannelDescription$w3_encode_ChannelDescription(v3)
					]));
		case 17:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(36),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$GuildName$w3_encode_GuildName(v1),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_GuildId),
						v2)
					]));
		case 14:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(37),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v1),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						$author$project$SecretId$w3_encode_SecretId($author$project$Id$w3_encode_InviteLinkId),
						v2)
					]));
		case 46:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(38),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Ports$w3_encode_RegisterPushSubscription(v1)
					]));
		case 20:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(39),
						$author$project$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v1),
						$author$project$Emoji$w3_encode_EmojiOrCustomEmoji(v2)
					]));
		case 68:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(40),
						$author$project$Id$w3_encode_Viewing_DmId(v0)
					]));
		case 44:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(41),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0)
					]));
		case 21:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(42),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Zone(v1),
						$author$project$Id$w3_encode_GuildOrDmId(v2),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v3),
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v4),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Id$w3_encode_Id($author$project$FileStatus$w3_encode_FileId),
						$author$project$FileStatus$w3_encode_FileData,
						v5)
					]));
		case 78:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(43),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Id$w3_encode_Viewing_DmId(v1),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v2),
						$lamdera$containers$SeqSet$encodeSet$($author$project$FileStatus$w3_encode_FileHash, v3),
						$author$project$Encryption$w3_encode_EncryptedData$(
						$author$project$Message$w3_encode_MessageContent$(
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId)),
						v4)
					]));
		case 77:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(44),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Id$w3_encode_Viewing_DmId(v1),
						$lamdera$containers$SeqSet$encodeSet$($author$project$FileStatus$w3_encode_FileHash, v2),
						$author$project$Encryption$w3_encode_EncryptedData$(
						$author$project$Message$w3_encode_MessageContent$(
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId)),
						v3),
						$author$project$Encryption$w3_encode_EncryptedData$($lamdera$codecs$Lamdera$Wire3$encodeString, v4),
						$author$project$Message$w3_encode_ThreadRouteWithRepliedTo(v5)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			var v6 = w3v.g;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(45),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Zone(v1),
						$author$project$Id$w3_encode_GuildOrDmId(v2),
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v3),
						$author$project$Message$w3_encode_ThreadRouteWithRepliedTo(v4),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Id$w3_encode_Id($author$project$FileStatus$w3_encode_FileId),
						$author$project$FileStatus$w3_encode_FileData,
						v5),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Emoji$w3_encode_EmojiOrCustomEmoji, v6)
					]));
		case 36:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(46),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v1),
						$author$project$User$w3_encode_NotificationLevel(v2)
					]));
		case 52:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(47),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0),
						$author$project$RichText$w3_encode_Domain(v1)
					]));
		case 75:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(48),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 42:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(49),
						$author$project$User$w3_encode_EmailNotifications(v0)
					]));
		case 43:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(50),
						$author$project$User$w3_encode_EmbedVisibility(v0)
					]));
		case 53:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(51),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Emoji$w3_encode_SkinTone, v0)
					]));
		case 35:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(52),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$User$w3_encode_NotificationLevel(v1)
					]));
		case 25:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(53),
						$author$project$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 59:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(54),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelId, v1),
						$author$project$MuteSettings$w3_encode_IsMuted(v2)
					]));
		case 61:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(55),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v1),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v2),
						$author$project$MuteSettings$w3_encode_IsMuted(v3)
					]));
		case 64:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(56),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v1),
						$author$project$MuteSettings$w3_encode_IsMuted(v2)
					]));
		case 62:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(57),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v1),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v2),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v3),
						$author$project$MuteSettings$w3_encode_IsMuted(v4)
					]));
		case 63:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(58),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$MuteSettings$w3_encode_IsMuted(v1)
					]));
		case 66:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(59),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_UserId, v0),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_TeamId, v1),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_ChannelId, v2),
						$author$project$MuteSettings$w3_encode_IsMuted(v3)
					]));
		case 67:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(60),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_UserId, v0),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_TeamId, v1),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_ChannelId, v2),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v3),
						$author$project$MuteSettings$w3_encode_IsMuted(v4)
					]));
		case 65:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(61),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_UserId, v0),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_TeamId, v1),
						$author$project$MuteSettings$w3_encode_IsMuted(v2)
					]));
		case 60:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(62),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelId, v1),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v2),
						$author$project$MuteSettings$w3_encode_IsMuted(v3)
					]));
		case 28:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(63),
						$author$project$PersonName$w3_encode_PersonName(v0)
					]));
		case 38:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(64),
						$author$project$UserSession$w3_encode_NotificationMode(v0)
					]));
		case 71:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(65),
						$author$project$X25519$w3_encode_PublicKey(v0),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2($lamdera$containers$SeqDict$encodeDict, $author$project$Id$w3_encode_Viewing_DmId, $author$project$Types$w3_encode_ChannelDataToEncrypt),
						v1)
					]));
		case 41:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(66),
						$author$project$IdArray$w3_encode_IdArray$($author$project$Id$w3_encode_QuestionId, $author$project$UserSession$w3_encode_SheepGameQuestion, v0)
					]));
		case 37:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(67),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_UserId, v0),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_TeamId, v1),
						$author$project$User$w3_encode_NotificationLevel(v2)
					]));
		case 54:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(68),
						$author$project$UserColor$w3_encode_UserColor(v0)
					]));
		case 31:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(69),
						$author$project$Id$w3_encode_SlackGuildOrDmId(v0),
						$author$project$VisibleMessages$w3_encode_PageRequest$($author$project$Id$w3_encode_ChannelMessageId, v1),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
							A3(
								$author$project$Message$w3_encode_Message,
								$author$project$Id$w3_encode_ChannelMessageId,
								$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_UserId),
								$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_ChannelId))),
						v2)
					]));
		case 32:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(70),
						$author$project$Id$w3_encode_SlackGuildOrDmId(v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v1),
						$author$project$VisibleMessages$w3_encode_PageRequest$($author$project$Id$w3_encode_ThreadMessageId, v2),
						$author$project$UserSession$w3_encode_ToBeFilledInByBackend$(
						A2(
							$lamdera$containers$SeqDict$encodeDict,
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ThreadMessageId),
							A3(
								$author$project$Message$w3_encode_Message,
								$author$project$Id$w3_encode_ThreadMessageId,
								$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_UserId),
								$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_ChannelId))),
						v3)
					]));
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(71),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_UserId, v0)
					]));
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(72),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Zone(v1),
						$author$project$Id$w3_encode_SlackGuildOrDmId(v2),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v3),
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v4)
					]));
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(73),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Zone(v1),
						$author$project$Id$w3_encode_SlackGuildOrDmId(v2),
						$author$project$Id$w3_encode_ThreadRoute(v3),
						$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString(v4),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Id$w3_encode_Id($author$project$FileStatus$w3_encode_FileId),
						$author$project$FileStatus$w3_encode_FileData,
						v5)
					]));
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(74),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_UserId, v0)
					]));
		case 49:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(75),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v1)
					]));
		case 47:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(76),
						$author$project$TextEditor$w3_encode_LocalChange(v0)
					]));
		case 48:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(77),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(78),
						$author$project$Call$w3_encode_LocalChange(v0)
					]));
	}
};
var $author$project$CustomEmoji$w3_encode_CustomEmojiUrl = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$FileStatus$w3_encode_FileHash(v0),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					$author$project$Coord$w3_encode_Coord($author$project$CssPixels$w3_encode_CssPixels),
					v1)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$CustomEmoji$w3_encode_EmojiName = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$CustomEmoji$w3_encode_CustomEmojiData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isAnimated),
				$author$project$CustomEmoji$w3_encode_EmojiName(w3_rec_var0.name),
				$author$project$CustomEmoji$w3_encode_CustomEmojiUrl(w3_rec_var0.url)
			]));
};
var $author$project$LinkedAndOtherDiscordUsers$w3_encode_DiscordFrontendCurrentUser = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$UserColor$w3_encode_UserColor(w3_rec_var0.color),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$EmailAddress$w3_encode_EmailAddress, w3_rec_var0.email),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
				$author$project$DiscordUserData$w3_encode_DiscordUserLoadingData(w3_rec_var0.isLoadingData),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.linkedAt),
				$author$project$PersonName$w3_encode_PersonName(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.needsAuthAgain)
			]));
};
var $author$project$MessageArray$w3_encode_Run$ = function (w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.start),
					$lamdera$codecs$Lamdera$Wire3$encodeArray$(
					A3($author$project$Message$w3_encode_Message, w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId),
					w3_rec_var0.values)
				]));
	};
};
var $author$project$MessageArray$w3_encode_Run = F3($author$project$MessageArray$w3_encode_Run$);
var $author$project$MessageArray$w3_encode_MessageArray$ = function (w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				function (w3_rec_var0) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.end),
							$lamdera$codecs$Lamdera$Wire3$encodeArray$(
							$author$project$MessageArray$w3_encode_Run$(w3_x_c_messageId, w3_x_c_userId, w3_x_c_channelId),
							w3_rec_var0.runs),
							$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.start)
						]));
			}(v0)
			]));
};
var $author$project$MessageArray$w3_encode_MessageArray = F4($author$project$MessageArray$w3_encode_MessageArray$);
var $author$project$VisibleMessages$w3_encode_VisibleMessages = function (w3_x_c_messageId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.count),
					$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.loadingMessages),
					$author$project$Id$w3_encode_Id$(w3_x_c_messageId, w3_rec_var0.oldest)
				]));
	};
};
var $author$project$DmChannel$w3_encode_DiscordFrontendDmChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$justinmimbs$date$Date$w3_encode_Date,
				$author$project$Drawing$w3_encode_Drawing(
					$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId)),
				w3_rec_var0.dateDividerDrawings),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
								$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
								w3_rec_var1.messageIndex),
								$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var1.time)
							]));
				},
				w3_rec_var0.lastTypedAt),
				$author$project$NonemptyDict$w3_encode_NonemptyDict$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.messagesSent)
							]));
				},
				w3_rec_var0.members),
				$author$project$MessageArray$w3_encode_MessageArray$(
				$author$project$Id$w3_encode_ChannelMessageId,
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_ChannelId),
				w3_rec_var0.messages),
				A2($author$project$VisibleMessages$w3_encode_VisibleMessages, $author$project$Id$w3_encode_ChannelMessageId, w3_rec_var0.visibleMessages)
			]));
};
var $author$project$Thread$w3_encode_DiscordFrontendThread = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$justinmimbs$date$Date$w3_encode_Date,
				$author$project$Drawing$w3_encode_Drawing(
					$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId)),
				w3_rec_var0.dateDividerDrawings),
				$author$project$MessageArray$w3_encode_MessageArray$(
				$author$project$Id$w3_encode_ThreadMessageId,
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_ChannelId),
				w3_rec_var0.messages),
				A2($author$project$VisibleMessages$w3_encode_VisibleMessages, $author$project$Id$w3_encode_ThreadMessageId, w3_rec_var0.visibleMessages)
			]));
};
var $author$project$LocalState$w3_encode_DiscordFrontendChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$justinmimbs$date$Date$w3_encode_Date,
				$author$project$Drawing$w3_encode_Drawing(
					$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId)),
				w3_rec_var0.dateDividerDrawings),
				$author$project$ChannelDescription$w3_encode_ChannelDescription(w3_rec_var0.description),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isForum),
				$author$project$MessageArray$w3_encode_MessageArray$(
				$author$project$Id$w3_encode_ChannelMessageId,
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_ChannelId),
				w3_rec_var0.messages),
				$author$project$ChannelName$w3_encode_ChannelName(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Discord$w3_encode_Overwrite, w3_rec_var0.permissionOverwrites),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
				$author$project$Thread$w3_encode_DiscordFrontendThread,
				w3_rec_var0.threads),
				A2($author$project$VisibleMessages$w3_encode_VisibleMessages, $author$project$Id$w3_encode_ChannelMessageId, w3_rec_var0.visibleMessages)
			]));
};
var $author$project$Thread$w3_encode_LastTypedAt = function (w3_x_c_channelId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					w3_x_c_channelId(w3_rec_var0.channelId),
					$author$project$Id$w3_encode_ThreadRouteWithMaybeMessage(w3_rec_var0.threadRoute),
					$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.time)
				]));
	};
};
var $author$project$LocalState$w3_encode_DiscordFrontendGuild = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_ChannelId),
				$author$project$LocalState$w3_encode_DiscordFrontendChannel,
				w3_rec_var0.channels),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_CustomEmojiId),
				w3_rec_var0.customEmojis),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
				$author$project$Thread$w3_encode_LastTypedAt(
					$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_ChannelId)),
				w3_rec_var0.lastTypedAt),
				$author$project$MembersAndOwner$w3_encode_MembersAndOwner$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var1.joinedAt),
								$lamdera$containers$SeqSet$encodeSet$(
								$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_RoleId),
								w3_rec_var1.roles)
							]));
				},
				w3_rec_var0.membersAndOwner),
				$author$project$GuildName$w3_encode_GuildName(w3_rec_var0.name),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_RoleId),
				$author$project$LocalState$w3_encode_DiscordRole,
				w3_rec_var0.roles),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_StickerId),
				w3_rec_var0.stickers)
			]));
};
var $author$project$LocalState$w3_encode_Archived = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.archivedAt),
				$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, w3_rec_var0.archivedBy)
			]));
};
var $author$project$Thread$w3_encode_FrontendThread = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$justinmimbs$date$Date$w3_encode_Date,
				$author$project$Drawing$w3_encode_Drawing(
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId)),
				w3_rec_var0.dateDividerDrawings),
				$author$project$MessageArray$w3_encode_MessageArray$(
				$author$project$Id$w3_encode_ThreadMessageId,
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId),
				w3_rec_var0.messages),
				A2($author$project$VisibleMessages$w3_encode_VisibleMessages, $author$project$Id$w3_encode_ThreadMessageId, w3_rec_var0.visibleMessages)
			]));
};
var $author$project$Go$w3_encode_Phase = function (w3v) {
	switch (w3v.$) {
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.previousPlayerPassed)
								]));
					}(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.blackScore),
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.whiteScore)
								]));
					}(v0)
					]));
	}
};
var $author$project$Go$w3_encode_Snapshot = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.blackCaptures),
				$lamdera$codecs$Lamdera$Wire3$encodeDict$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				$author$project$Go$w3_encode_Stone,
				w3_rec_var0.board),
				$author$project$Go$w3_encode_Stone(w3_rec_var0.currentPlayer),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.whiteCaptures)
			]));
};
var $author$project$Go$w3_encode_Shared = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.blackCaptures),
				$lamdera$codecs$Lamdera$Wire3$encodeDict$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				$author$project$Go$w3_encode_Stone,
				w3_rec_var0.board),
				$author$project$Go$w3_encode_Stone(w3_rec_var0.currentPlayer),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Go$w3_encode_Snapshot, w3_rec_var0.history),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				w3_rec_var0.joinedUserId),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.lastAction),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				w3_rec_var0.lastMove),
				$author$project$Go$w3_encode_Phase(w3_rec_var0.phase),
				$lamdera$codecs$Lamdera$Wire3$encodeDict$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				$author$project$Go$w3_encode_Stone,
				w3_rec_var0.territoryMarks),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var1.black),
								$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var1.white)
							]));
				},
				w3_rec_var0.timeLeft),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.turnCount),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.whiteCaptures)
			]));
};
var $author$project$Game$w3_encode_FrontendGameData = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Go$w3_encode_ValidatedSetup(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Go$w3_encode_ActionWithTime, v1),
						$author$project$Go$w3_encode_Shared(v2)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$SheepGame$w3_encode_ValidatedSetup(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$SheepGame$w3_encode_ActionWithTime, v1),
						$author$project$SheepGame$w3_encode_Shared(v2)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$WordSpellingGame$w3_encode_ValidatedSetup(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$WordSpellingGame$w3_encode_ActionWithTime, v1),
						$author$project$WordSpellingGame$w3_encode_Shared(v2)
					]));
	}
};
var $author$project$Game$w3_encode_MatchData = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					function (w3_rec_var0) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$author$project$Game$w3_encode_FrontendGameData(w3_rec_var0.data),
								$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
								$author$project$SecretId$w3_encode_SecretId($author$project$Id$w3_encode_GamePublicId),
								w3_rec_var0.publicLink)
							]));
				}(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Message$w3_encode_GameType(v0)
				]));
	}
};
var $author$project$LocalState$w3_encode_FrontendChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.createdAt),
				$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, w3_rec_var0.createdBy),
				$lamdera$containers$SeqDict$encodeDict$(
				$justinmimbs$date$Date$w3_encode_Date,
				$author$project$Drawing$w3_encode_Drawing(
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId)),
				w3_rec_var0.dateDividerDrawings),
				$author$project$ChannelDescription$w3_encode_ChannelDescription(w3_rec_var0.description),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
				$author$project$Game$w3_encode_MatchData,
				w3_rec_var0.games),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$LocalState$w3_encode_Archived, w3_rec_var0.isArchived),
				$author$project$MessageArray$w3_encode_MessageArray$(
				$author$project$Id$w3_encode_ChannelMessageId,
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId),
				w3_rec_var0.messages),
				$author$project$ChannelName$w3_encode_ChannelName(w3_rec_var0.name),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
				$author$project$Thread$w3_encode_FrontendThread,
				w3_rec_var0.threads),
				A2($author$project$VisibleMessages$w3_encode_VisibleMessages, $author$project$Id$w3_encode_ChannelMessageId, w3_rec_var0.visibleMessages)
			]));
};
var $author$project$LocalState$w3_encode_GuildMember = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.joinedAt),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.lastPostedAt)
			]));
};
var $author$project$LocalState$w3_encode_FrontendGuild = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId),
				$author$project$LocalState$w3_encode_FrontendChannel,
				w3_rec_var0.channels),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.createdAt),
				$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, w3_rec_var0.createdBy),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$SecretId$w3_encode_SecretId($author$project$Id$w3_encode_InviteLinkId),
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var1.createdAt),
								$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, w3_rec_var1.createdBy)
							]));
				},
				w3_rec_var0.invites),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				$author$project$Thread$w3_encode_LastTypedAt(
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId)),
				w3_rec_var0.lastTypedAt),
				$author$project$MembersAndOwner$w3_encode_MembersAndOwner$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				$author$project$LocalState$w3_encode_GuildMember,
				w3_rec_var0.membersAndOwner),
				$author$project$GuildName$w3_encode_GuildName(w3_rec_var0.name)
			]));
};
var $author$project$User$w3_encode_FrontendUser = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$UserColor$w3_encode_UserColor(w3_rec_var0.color),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
				$author$project$PersonName$w3_encode_PersonName(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$X25519$w3_encode_PublicKey, w3_rec_var0.publicKey)
			]));
};
var $author$project$UserSession$w3_encode_Viewing = function (w3v) {
	switch (w3v.$) {
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$UserSession$w3_encode_Viewing_ChannelData(v0)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$UserSession$w3_encode_Viewing_ChannelThreadData(v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$UserSession$w3_encode_Viewing_DiscordChannelData(v0)
					]));
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$UserSession$w3_encode_Viewing_DiscordChannelThreadData(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$UserSession$w3_encode_Viewing_DiscordDmData(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$UserSession$w3_encode_Viewing_DmData(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$UserSession$w3_encode_Viewing_DmThreadData(v0)
					]));
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 12:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$UserSession$w3_encode_Viewing_SlackChannelData(v0)
					]));
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$UserSession$w3_encode_Viewing_SlackChannelThreadData(v0)
					]));
		case 9:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$UserSession$w3_encode_Viewing_SlackDmData(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$UserSession$w3_encode_Viewing_SlackDmThreadData(v0)
					]));
	}
};
var $author$project$UserSession$w3_encode_FrontendUserSession = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$($lamdera$program_test$Effect$Lamdera$w3_encode_ClientId, $author$project$UserSession$w3_encode_Viewing, w3_rec_var0.currentlyViewing),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.lastActiveAt),
				$author$project$UserSession$w3_encode_NotificationMode(w3_rec_var0.notificationMode),
				$author$project$UserAgent$w3_encode_UserAgent(w3_rec_var0.userAgent)
			]));
};
var $author$project$Call$w3_encode_CallId = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Id$w3_encode_Viewing_DmId(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Id$w3_encode_Viewing_ChannelId(v0)
				]));
	}
};
var $author$project$LocalState$w3_encode_CallStatus = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Call$w3_encode_CallId(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$LocalState$w3_encode_LastRequest = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$program_test$Effect$Time$w3_encode_Posix(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$LocalState$w3_encode_ConnectionData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$LocalState$w3_encode_CallStatus(w3_rec_var0.call),
				$author$project$UserSession$w3_encode_Viewing(w3_rec_var0.currentlyViewing),
				$author$project$LocalState$w3_encode_LastRequest(w3_rec_var0.lastRequest),
				$author$project$Call$w3_encode_RemoteCallData(w3_rec_var0.remoteCallData)
			]));
};
var $author$project$LocalState$w3_encode_BackupContents = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$LocalState$w3_encode_LastBackup = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$LocalState$w3_encode_BackupContents(w3_rec_var0.contents),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.createdAt)
			]));
};
var $author$project$LocalState$w3_encode_LoadingDiscordChannelStep$ = function (w3_x_c_messages, w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						w3_x_c_messages(v1)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Discord$w3_encode_HttpError(v0)
					]));
	}
};
var $author$project$LocalState$w3_encode_LoadingDiscordChannelStep = F2($author$project$LocalState$w3_encode_LoadingDiscordChannelStep$);
var $author$project$LocalState$w3_encode_LoadingDiscordChannel$ = function (w3_x_c_messages, w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		var v2 = w3v.c;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
					$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_PrivateChannelId, v1),
					$author$project$LocalState$w3_encode_LoadingDiscordChannelStep$(w3_x_c_messages, v2)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		var v2 = w3v.c;
		var v3 = w3v.d;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
					$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v1),
					$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v2),
					$author$project$LocalState$w3_encode_LoadingDiscordChannelStep$(w3_x_c_messages, v3)
				]));
	}
};
var $author$project$LocalState$w3_encode_LoadingDiscordChannel = F2($author$project$LocalState$w3_encode_LoadingDiscordChannel$);
var $author$project$Pagination$w3_encode_PageStatus$ = function (w3_x_c_a, w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$codecs$Lamdera$Wire3$encodeArray$(w3_x_c_a, v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Pagination$w3_encode_PageStatus = F2($author$project$Pagination$w3_encode_PageStatus$);
var $author$project$Pagination$w3_encode_Pagination = function (w3_x_c_a) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$author$project$Id$w3_encode_Id$($author$project$Pagination$w3_encode_PageId, w3_rec_var0.currentPage),
					$lamdera$containers$SeqDict$encodeDict$(
					$author$project$Id$w3_encode_Id($author$project$Pagination$w3_encode_PageId),
					$author$project$Pagination$w3_encode_PageStatus(w3_x_c_a),
					w3_rec_var0.pages),
					$author$project$Id$w3_encode_Id$($author$project$Pagination$w3_encode_PageId, w3_rec_var0.previousPage),
					$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.totalItems)
				]));
	};
};
var $author$project$Pages$Admin$w3_encode_TypeThatIsAlwaysInvalid = function (w3v) {
	return $elm$bytes$Bytes$Encode$unsignedInt8(0);
};
var $author$project$LocalState$w3_encode_WordSpellingGameStatus = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v0)
					]));
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Pages$Admin$w3_encode_InitAdminData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Pages$Admin$w3_encode_TypeThatIsAlwaysInvalid(w3_rec_var0.checkToFrontendValidation),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$SessionIdHash$w3_encode_SessionIdHash,
					A2($author$project$NonemptyDict$w3_encode_NonemptyDict, $lamdera$program_test$Effect$Lamdera$w3_encode_ClientId, $author$project$LocalState$w3_encode_ConnectionData)),
				w3_rec_var0.connections),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.discordLinkLimit),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.discordLinkingEnabled),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.emailNotificationsEnabled),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.filesCount),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$LocalState$w3_encode_LastBackup, w3_rec_var0.lastBackup),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
				$author$project$LocalState$w3_encode_LoadingDiscordChannel($lamdera$codecs$Lamdera$Wire3$encodeInt),
				w3_rec_var0.loadingDiscordChannels),
				A2($author$project$Pagination$w3_encode_Pagination, $author$project$LocalState$w3_encode_LogWithTime, w3_rec_var0.logs),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				w3_rec_var0.notifyAdminsBotUserId),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.notifyAdminsToken),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.openRouterKey),
				$author$project$Postmark$w3_encode_ApiKey(w3_rec_var0.postmarkApiKey),
				$author$project$LocalState$w3_encode_PrivateVapidKey(w3_rec_var0.privateVapidKey),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeString, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				w3_rec_var0.seqDictWorks),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.serverSecretRegeneratedAt),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.signupsEnabled),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.slackLinkLimit),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.slackLinkingEnabled),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				$lamdera$program_test$Effect$Time$w3_encode_Posix,
				w3_rec_var0.twoFactorAuthentication),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.vulnerabilityChecks),
				$author$project$LocalState$w3_encode_WordSpellingGameStatus(w3_rec_var0.wordSpellingGameEnglish),
				$author$project$LocalState$w3_encode_WordSpellingGameStatus(w3_rec_var0.wordSpellingGameSwedish)
			]));
};
var $author$project$LocalState$w3_encode_JoinGuildError = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Types$w3_encode_RepliedToData = function (w3v) {
	switch (w3v.$) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Game$w3_encode_LoadedMatch(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Message$w3_encode_Message$(
						$author$project$Id$w3_encode_ChannelMessageId,
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId),
						v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Message$w3_encode_Message$(
						$author$project$Id$w3_encode_ThreadMessageId,
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId),
						v0)
					]));
	}
};
var $author$project$Call$w3_encode_ConnectionId = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodePair$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId,
				w3_rec_var0.otherClientId),
				$author$project$Call$w3_encode_CallId(w3_rec_var0.roomId)
			]));
};
var $author$project$Call$w3_encode_RecordingStatus = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$containers$SeqSet$encodeSet$(
									$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
									w3_rec_var0.allowedBy),
									$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.requestedAt),
									$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, w3_rec_var0.requestedBy)
								]));
					}(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.declinedAt),
									$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
									$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
									w3_rec_var0.declinedBy),
									$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, w3_rec_var0.requestedBy)
								]));
					}(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0)
					]));
	}
};
var $author$project$Call$w3_encode_ServerChange = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Call$w3_encode_ConnectionId(v1)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Call$w3_encode_ConnectionId(v1),
						$author$project$Call$w3_encode_RemoteCallData(v2)
					]));
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Call$w3_encode_CallId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Call$w3_encode_RecordingStatus, v1)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Call$w3_encode_ConnectionId(v0),
						$author$project$Call$w3_encode_RemoteCallData(v1)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Call$w3_encode_CallId(v1)
					]));
	}
};
var $author$project$TextEditor$w3_encode_ServerChange = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0),
						$author$project$TextEditor$w3_encode_EditChange(v1)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0)
					]));
	}
};
var $author$project$Thread$w3_encode_FrontendGenericThread$ = function (w3_x_c_userId, w3_x_c_channelId) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$containers$SeqDict$encodeDict$(
					$justinmimbs$date$Date$w3_encode_Date,
					$author$project$Drawing$w3_encode_Drawing(w3_x_c_userId),
					w3_rec_var0.dateDividerDrawings),
					$author$project$MessageArray$w3_encode_MessageArray$($author$project$Id$w3_encode_ThreadMessageId, w3_x_c_userId, w3_x_c_channelId, w3_rec_var0.messages),
					A2($author$project$VisibleMessages$w3_encode_VisibleMessages, $author$project$Id$w3_encode_ThreadMessageId, w3_rec_var0.visibleMessages)
				]));
	};
};
var $author$project$Thread$w3_encode_FrontendGenericThread = F2($author$project$Thread$w3_encode_FrontendGenericThread$);
var $author$project$Thread$w3_encode_SlackFrontendThread = $author$project$Thread$w3_encode_FrontendGenericThread$(
	$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_UserId),
	$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_ChannelId));
var $author$project$LocalState$w3_encode_SlackFrontendDmChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$NonemptySet$w3_encode_NonemptySet$(
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_UserId),
				w3_rec_var0.members),
				$author$project$MessageArray$w3_encode_MessageArray$(
				$author$project$Id$w3_encode_ChannelMessageId,
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_UserId),
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_ChannelId),
				w3_rec_var0.messages),
				$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_TeamId, w3_rec_var0.teamId),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
				$author$project$Thread$w3_encode_SlackFrontendThread,
				w3_rec_var0.threads),
				A2($author$project$VisibleMessages$w3_encode_VisibleMessages, $author$project$Id$w3_encode_ChannelMessageId, w3_rec_var0.visibleMessages)
			]));
};
var $author$project$UserSession$w3_encode_SlackFrontendUser = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$UserColor$w3_encode_UserColor(w3_rec_var0.color),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
				$author$project$PersonName$w3_encode_PersonName(w3_rec_var0.name),
				$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_TeamId, w3_rec_var0.teamId)
			]));
};
var $author$project$LocalState$w3_encode_SlackFrontendChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isPrivate),
				$author$project$MessageArray$w3_encode_MessageArray$(
				$author$project$Id$w3_encode_ChannelMessageId,
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_UserId),
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_ChannelId),
				w3_rec_var0.messages),
				$author$project$ChannelName$w3_encode_ChannelName(w3_rec_var0.name),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
				$author$project$Thread$w3_encode_SlackFrontendThread,
				w3_rec_var0.threads),
				A2($author$project$VisibleMessages$w3_encode_VisibleMessages, $author$project$Id$w3_encode_ChannelMessageId, w3_rec_var0.visibleMessages)
			]));
};
var $author$project$LocalState$w3_encode_SlackFrontendWorkspace = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_ChannelId),
				$author$project$LocalState$w3_encode_SlackFrontendChannel,
				w3_rec_var0.channels),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_CustomEmojiId),
				w3_rec_var0.customEmojis),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name)
			]));
};
var $author$project$Discord$w3_encode_StickerFormatType = function (w3v) {
	switch (w3v) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Discord$w3_encode_StickerId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Sticker$w3_encode_StickerUrl = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_StickerId, v0)
					]));
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$FileStatus$w3_encode_FileHash(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
						$author$project$Coord$w3_encode_Coord($author$project$CssPixels$w3_encode_CssPixels),
						v1)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Sticker$w3_encode_StickerData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Discord$w3_encode_StickerFormatType(w3_rec_var0.format),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
				$author$project$Sticker$w3_encode_StickerUrl(w3_rec_var0.url)
			]));
};
var $author$project$Types$w3_encode_ServerChange = function (w3v) {
	switch (w3v.$) {
		case 30:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0),
						$author$project$Id$w3_encode_GuildOrDmId(v1),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v2),
						$author$project$Emoji$w3_encode_EmojiOrCustomEmoji(v3)
					]));
		case 73:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$LocalState$w3_encode_LastBackup(v0)
					]));
		case 31:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Id$w3_encode_GuildOrDmId(v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v1),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v2),
						$author$project$NonemptySet$w3_encode_NonemptySet$(
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
						v3)
					]));
		case 33:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Id$w3_encode_GuildOrDmId(v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v2)
					]));
		case 32:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Id$w3_encode_GuildOrDmId(v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v1),
						A2(
						$author$project$Message$w3_encode_CallRecordingFile,
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
						v2)
					]));
		case 34:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Id$w3_encode_GuildOrDmId(v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Message$w3_encode_CallRecordingZip(v2)
					]));
		case 60:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$SessionIdHash$w3_encode_SessionIdHash(v0),
						$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId(v1),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v2)
					]));
		case 59:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$SessionIdHash$w3_encode_SessionIdHash(v0),
						$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId(v1),
						$author$project$UserSession$w3_encode_Viewing(v2)
					]));
		case 19:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelId, v1)
					]));
		case 21:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0)
					]));
		case 23:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$SecretId$w3_encode_SecretId$($author$project$Id$w3_encode_InviteLinkId, v1)
					]));
		case 44:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 109:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v1),
						$author$project$Id$w3_encode_Viewing_DmId(v2)
					]));
		case 37:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_PrivateChannelId, v1),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v2),
						$author$project$Emoji$w3_encode_EmojiOrCustomEmoji(v3)
					]));
		case 36:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v1),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v2),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v3),
						$author$project$Emoji$w3_encode_EmojiOrCustomEmoji(v4)
					]));
		case 101:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$author$project$UserSession$w3_encode_DiscordFrontendUser(v1)
					]));
		case 64:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v2),
						$author$project$ChannelName$w3_encode_ChannelName(v3),
						$author$project$Discord$w3_encode_OptionalData$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$codecs$Lamdera$Wire3$encodeString),
						v4),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Discord$w3_encode_Overwrite, v5)
					]));
		case 81:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v1)
					]));
		case 47:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_PrivateChannelId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v1)
					]));
		case 45:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(19),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v1),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v2)
					]));
		case 65:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(20),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_PrivateChannelId, v0),
						$author$project$NonemptyDict$w3_encode_NonemptyDict$(
						$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
						function (w3_rec_var0) {
							return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
								_List_fromArray(
									[
										$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.messagesSent)
									]));
						},
						v1)
					]));
		case 66:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(21),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_PrivateChannelId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v1)
					]));
		case 29:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(22),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v1),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_PrivateChannelId, v2)
					]));
		case 46:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(23),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v1),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v2)
					]));
		case 78:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(24),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v1),
						$author$project$LocalState$w3_encode_DiscordFrontendGuild(v2)
					]));
		case 79:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(25),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v1)
					]));
		case 86:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(26),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v1),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v2),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v3),
						$author$project$PersonName$w3_encode_PersonName(v4),
						$author$project$UserColor$w3_encode_UserColor(v5)
					]));
		case 28:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(27),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v1),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v2),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v3),
						$author$project$Id$w3_encode_ThreadRoute(v4)
					]));
		case 67:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(28),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0)
					]));
		case 39:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(29),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_PrivateChannelId, v1),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v2),
						$author$project$Emoji$w3_encode_EmojiOrCustomEmoji(v3)
					]));
		case 38:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(30),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v1),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v2),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v3),
						$author$project$Emoji$w3_encode_EmojiOrCustomEmoji(v4)
					]));
		case 42:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(31),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Id$w3_encode_Viewing_DiscordDmId(v1),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v2),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2(
							$author$project$RichText$w3_encode_RichText,
							$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
							$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_ChannelId)),
						v3)
					]));
		case 41:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(32),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v1),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v2),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v3),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v4),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2(
							$author$project$RichText$w3_encode_RichText,
							$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
							$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_ChannelId)),
						v5)
					]));
		case 80:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(33),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v1),
						$author$project$Discord$w3_encode_OptionalData$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$codecs$Lamdera$Wire3$encodeString),
						v2),
						$author$project$Discord$w3_encode_OptionalData$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$codecs$Lamdera$Wire3$encodeString),
						v3),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Discord$w3_encode_Overwrite, v4)
					]));
		case 82:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(34),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v0),
						$author$project$GuildName$w3_encode_GuildName(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$FileStatus$w3_encode_FileHash, v2),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_RoleId),
						$author$project$LocalState$w3_encode_DiscordRole,
						v3)
					]));
		case 84:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(35),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v0),
						$lamdera$containers$SeqSet$encodeSet$(
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_CustomEmojiId),
						v1)
					]));
		case 83:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(36),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_RoleId, v1),
						$author$project$LocalState$w3_encode_DiscordRole(v2)
					]));
		case 68:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(37),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$(
						$lamdera$program_test$Effect$Time$w3_encode_Posix,
						function (w3_rec_var0) {
							return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
								_List_fromArray(
									[
										$lamdera$containers$SeqDict$encodeDict$(
										$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_PrivateChannelId),
										$author$project$DmChannel$w3_encode_DiscordFrontendDmChannel,
										w3_rec_var0.discordDms),
										$lamdera$containers$SeqDict$encodeDict$(
										$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_GuildId),
										$author$project$LocalState$w3_encode_DiscordFrontendGuild,
										w3_rec_var0.discordGuilds),
										$lamdera$containers$SeqDict$encodeDict$(
										$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
										$author$project$UserSession$w3_encode_DiscordFrontendUser,
										w3_rec_var0.discordUsers),
										$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.markEverythingAsViewed)
									]));
						},
						v1)
					]));
		case 15:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			var v6 = w3v.g;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(38),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Id$w3_encode_DiscordGuildOrDmId(v1),
						$author$project$UserSession$w3_encode_DiscordFrontendUser(v2),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2(
							$author$project$RichText$w3_encode_RichText,
							$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
							$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_ChannelId)),
						v3),
						$author$project$Id$w3_encode_ThreadRouteWithMaybeMessage(v4),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Id$w3_encode_Id($author$project$FileStatus$w3_encode_FileId),
						$author$project$FileStatus$w3_encode_FileData,
						v5),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_StickerId),
						$author$project$Sticker$w3_encode_StickerData,
						v6)
					]));
		case 91:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(39),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0),
						$author$project$Id$w3_encode_AnyGuildOrDmId(v1),
						$author$project$Drawing$w3_encode_AnchorType(v2),
						$author$project$Drawing$w3_encode_LocalChange(v3)
					]));
		case 105:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(40),
						$author$project$Id$w3_encode_Viewing_DmId(v0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v1)
					]));
		case 103:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(41),
						$author$project$Id$w3_encode_Viewing_DmId(v0)
					]));
		case 104:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(42),
						$author$project$Id$w3_encode_Viewing_DmId(v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v1)
					]));
		case 102:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(43),
						$author$project$Id$w3_encode_Viewing_DmId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
						$author$project$SessionIdHash$w3_encode_SessionIdHash,
						v1)
					]));
		case 18:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(44),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelId, v1),
						$author$project$ChannelName$w3_encode_ChannelName(v2),
						$author$project$ChannelDescription$w3_encode_ChannelDescription(v3)
					]));
		case 20:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(45),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$GuildName$w3_encode_GuildName(v1)
					]));
		case 90:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(46),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0),
						$author$project$Id$w3_encode_GuildOrDmId(v1),
						$author$project$Game$w3_encode_LocalChange(v2)
					]));
		case 77:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(47),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_PrivateChannelId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v1),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$elm$url$Url$w3_encode_Url,
						A2($lamdera$codecs$Lamdera$Wire3$encodeResult, $lamdera$codecs$Lamdera$Wire3$encodeUnit, $author$project$Embed$w3_encode_EmbedData),
						v2)
					]));
		case 76:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(48),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v1),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v2),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$elm$url$Url$w3_encode_Url,
						A2($lamdera$codecs$Lamdera$Wire3$encodeResult, $lamdera$codecs$Lamdera$Wire3$encodeUnit, $author$project$Embed$w3_encode_EmbedData),
						v3)
					]));
		case 75:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(49),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v1),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$elm$url$Url$w3_encode_Url,
						A2($lamdera$codecs$Lamdera$Wire3$encodeResult, $lamdera$codecs$Lamdera$Wire3$encodeUnit, $author$project$Embed$w3_encode_EmbedData),
						v2)
					]));
		case 74:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(50),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelId, v1),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v2),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$elm$url$Url$w3_encode_Url,
						A2($lamdera$codecs$Lamdera$Wire3$encodeResult, $lamdera$codecs$Lamdera$Wire3$encodeUnit, $author$project$Embed$w3_encode_EmbedData),
						v3)
					]));
		case 17:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(51),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelId, v1),
						$author$project$LocalState$w3_encode_FrontendChannel(v2)
					]));
		case 62:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(52),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$author$project$LinkedAndOtherDiscordUsers$w3_encode_DiscordFrontendCurrentUser(v1)
					]));
		case 88:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(53),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_CustomEmojiId),
						$author$project$CustomEmoji$w3_encode_CustomEmojiData,
						v0)
					]));
		case 87:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(54),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_StickerId),
						$author$project$Sticker$w3_encode_StickerData,
						v0)
					]));
		case 71:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(55),
						$author$project$Pages$Admin$w3_encode_InitAdminData(v0)
					]));
		case 70:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(56),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
						$author$project$LocalState$w3_encode_LoadingDiscordChannel($lamdera$codecs$Lamdera$Wire3$encodeInt),
						v1)
					]));
		case 58:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(57),
						$author$project$SessionIdHash$w3_encode_SessionIdHash(v0)
					]));
		case 43:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(58),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v1),
						$author$project$Id$w3_encode_AnyGuildOrDmId(v2),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v3)
					]));
		case 24:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(59),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v1),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v2),
						$author$project$User$w3_encode_FrontendUser(v3)
					]));
		case 25:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(60),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v1)
					]));
		case 27:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(61),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v1),
						$author$project$Id$w3_encode_GuildOrDmId(v2),
						$author$project$Id$w3_encode_ThreadRoute(v3)
					]));
		case 16:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(62),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v1),
						$author$project$ChannelName$w3_encode_ChannelName(v2),
						$author$project$ChannelDescription$w3_encode_ChannelDescription(v3)
					]));
		case 22:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(63),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v1),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v2),
						$author$project$SecretId$w3_encode_SecretId$($author$project$Id$w3_encode_InviteLinkId, v3)
					]));
		case 72:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(64),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Log$w3_encode_Log(v1)
					]));
		case 57:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(65),
						$author$project$SessionIdHash$w3_encode_SessionIdHash(v0),
						$author$project$UserSession$w3_encode_FrontendUserSession(v1)
					]));
		case 56:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(66),
						$author$project$Ports$w3_encode_SubscribeData(v0),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v1)
					]));
		case 52:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(67),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 35:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(68),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0),
						$author$project$Id$w3_encode_GuildOrDmId(v1),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v2),
						$author$project$Emoji$w3_encode_EmojiOrCustomEmoji(v3)
					]));
		case 40:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(69),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v1),
						$author$project$Id$w3_encode_GuildOrDmId(v2),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v3),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2(
							$author$project$RichText$w3_encode_RichText,
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId)),
						v4),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Id$w3_encode_Id($author$project$FileStatus$w3_encode_FileId),
						$author$project$FileStatus$w3_encode_FileData,
						v5)
					]));
		case 108:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(70),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v1),
						$author$project$Id$w3_encode_Viewing_DmId(v2),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v3),
						$lamdera$containers$SeqSet$encodeSet$($author$project$FileStatus$w3_encode_FileHash, v4),
						$author$project$Encryption$w3_encode_EncryptedData$(
						$author$project$Message$w3_encode_MessageContent$(
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId)),
						v5)
					]));
		case 107:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(71),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Encryption$w3_encode_EncryptedData$(
									$author$project$Message$w3_encode_MessageContent$(
										$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
										$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId)),
									w3_rec_var0.content),
									$lamdera$containers$SeqSet$encodeSet$($author$project$FileStatus$w3_encode_FileHash, w3_rec_var0.fileHashes),
									$author$project$Id$w3_encode_Viewing_DmId(w3_rec_var0.id),
									$author$project$Types$w3_encode_RepliedToData(w3_rec_var0.repliedToData),
									$author$project$User$w3_encode_FrontendUser(w3_rec_var0.sender),
									$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, w3_rec_var0.senderId),
									$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.sentAt),
									$author$project$Message$w3_encode_ThreadRouteWithRepliedTo(w3_rec_var0.threadRoute)
								]));
					}(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(72),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$containers$SeqDict$encodeDict$(
									$author$project$Id$w3_encode_Id($author$project$FileStatus$w3_encode_FileId),
									$author$project$FileStatus$w3_encode_FileData,
									w3_rec_var0.attachedFiles),
									$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
									A2(
										$author$project$RichText$w3_encode_RichText,
										$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
										$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId)),
									w3_rec_var0.content),
									$author$project$Id$w3_encode_GuildOrDmId(w3_rec_var0.guildOrDmId),
									$author$project$Types$w3_encode_RepliedToData(w3_rec_var0.repliedToData),
									$author$project$User$w3_encode_FrontendUser(w3_rec_var0.sender),
									$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, w3_rec_var0.senderId),
									$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.sentAt),
									$lamdera$containers$SeqDict$encodeDict$(
									$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_StickerId),
									$author$project$Sticker$w3_encode_StickerData,
									w3_rec_var0.stickers),
									$author$project$Message$w3_encode_ThreadRouteWithRepliedTo(w3_rec_var0.threadRoute)
								]));
					}(v0)
					]));
		case 54:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(73),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v0),
						$author$project$User$w3_encode_NotificationLevel(v1)
					]));
		case 51:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(74),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$FileStatus$w3_encode_FileHash, v1)
					]));
		case 53:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(75),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$User$w3_encode_NotificationLevel(v1)
					]));
		case 92:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(76),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelId, v1),
						$author$project$MuteSettings$w3_encode_IsMuted(v2)
					]));
		case 94:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(77),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v1),
						$author$project$MuteSettings$w3_encode_IsMuted(v2)
					]));
		case 97:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(78),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v0),
						$author$project$MuteSettings$w3_encode_IsMuted(v1)
					]));
		case 95:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(79),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v1),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v2),
						$author$project$MuteSettings$w3_encode_IsMuted(v3)
					]));
		case 96:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(80),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$MuteSettings$w3_encode_IsMuted(v1)
					]));
		case 99:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(81),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_TeamId, v0),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_ChannelId, v1),
						$author$project$MuteSettings$w3_encode_IsMuted(v2)
					]));
		case 100:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(82),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_TeamId, v0),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_ChannelId, v1),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v2),
						$author$project$MuteSettings$w3_encode_IsMuted(v3)
					]));
		case 98:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(83),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_TeamId, v0),
						$author$project$MuteSettings$w3_encode_IsMuted(v1)
					]));
		case 93:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(84),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelId, v1),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v2),
						$author$project$MuteSettings$w3_encode_IsMuted(v3)
					]));
		case 48:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(85),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0),
						$author$project$PersonName$w3_encode_PersonName(v1)
					]));
		case 106:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(86),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0),
						$author$project$X25519$w3_encode_PublicKey(v1)
					]));
		case 55:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(87),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_TeamId, v0),
						$author$project$User$w3_encode_NotificationLevel(v1)
					]));
		case 49:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(88),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0),
						$author$project$UserColor$w3_encode_UserColor(v1)
					]));
		case 50:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(89),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$FileStatus$w3_encode_FileHash, v1)
					]));
		case 13:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(90),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_UserId, v0),
						$author$project$Id$w3_encode_SlackGuildOrDmId(v1),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v2),
						$author$project$Emoji$w3_encode_EmojiOrCustomEmoji(v3)
					]));
		case 7:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(91),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_TeamId, v0),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_ChannelId, v1),
						$author$project$ChannelName$w3_encode_ChannelName(v2)
					]));
		case 12:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(92),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_TeamId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_CustomEmojiId, v1),
						$author$project$CustomEmoji$w3_encode_CustomEmojiData(v2)
					]));
		case 11:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(93),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_CustomEmojiId),
						$author$project$CustomEmoji$w3_encode_CustomEmojiData,
						v0)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(94),
						$author$project$Id$w3_encode_SlackGuildOrDmId(v0),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(95),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_UserId, v1),
						$author$project$Id$w3_encode_SlackGuildOrDmId(v2),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v3),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2(
							$author$project$RichText$w3_encode_RichText,
							$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_UserId),
							$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_ChannelId)),
						v4)
					]));
		case 9:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(96),
						$author$project$Id$w3_encode_SlackGuildOrDmId(v0),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v1),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$elm$url$Url$w3_encode_Url,
						A2($lamdera$codecs$Lamdera$Wire3$encodeResult, $lamdera$codecs$Lamdera$Wire3$encodeUnit, $author$project$Embed$w3_encode_EmbedData),
						v2)
					]));
		case 10:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(97),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_UserId, v0),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_TeamId, v1),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$containers$SeqDict$encodeDict$(
									$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_CustomEmojiId),
									$author$project$CustomEmoji$w3_encode_CustomEmojiData,
									w3_rec_var0.customEmojis),
									$lamdera$containers$SeqDict$encodeDict$(
									$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_DmChannelId),
									$author$project$LocalState$w3_encode_SlackFrontendDmChannel,
									w3_rec_var0.dmChannels),
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.markNewDmsAsViewed),
									$lamdera$containers$SeqDict$encodeDict$(
									$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_UserId),
									$author$project$UserSession$w3_encode_SlackFrontendUser,
									w3_rec_var0.users),
									$lamdera$containers$SeqDict$encodeDict$(
									$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_TeamId),
									$author$project$LocalState$w3_encode_SlackFrontendWorkspace,
									w3_rec_var0.workspaces)
								]));
					}(v2)
					]));
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(98),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_UserId, v0)
					]));
		case 14:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(99),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_UserId, v0),
						$author$project$Id$w3_encode_SlackGuildOrDmId(v1),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v2),
						$author$project$Emoji$w3_encode_EmojiOrCustomEmoji(v3)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(100),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Id$w3_encode_SlackGuildOrDmId(v1),
						$author$project$Id$w3_encode_ThreadRoute(v2),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
						A2(
							$author$project$RichText$w3_encode_RichText,
							$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_UserId),
							$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_ChannelId)),
						v3),
						$lamdera$containers$SeqDict$encodeDict$(
						$author$project$Id$w3_encode_Id($author$project$FileStatus$w3_encode_FileId),
						$author$project$FileStatus$w3_encode_FileData,
						v4),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
						A3(
							$author$project$Message$w3_encode_Message,
							$author$project$Id$w3_encode_ChannelMessageId,
							$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_UserId),
							$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_ChannelId)),
						v5)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(101),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_UserId, v0)
					]));
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(102),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_UserId, v0),
						$author$project$UserSession$w3_encode_SlackFrontendUser(v1)
					]));
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(103),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_TeamId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 69:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(104),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v1)
					]));
		case 61:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(105),
						$author$project$TextEditor$w3_encode_ServerChange(v0)
					]));
		case 63:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(106),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0)
					]));
		case 85:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(107),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v0),
						$author$project$MembersAndOwner$w3_encode_MembersAndOwner$(
						$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
						function (w3_rec_var0) {
							return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
								_List_fromArray(
									[
										$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.joinedAt),
										$lamdera$containers$SeqSet$encodeSet$(
										$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_RoleId),
										w3_rec_var0.roles)
									]));
						},
						v1)
					]));
		case 89:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(108),
						$author$project$Call$w3_encode_ServerChange(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(109),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$(
						$author$project$LocalState$w3_encode_JoinGuildError,
						function (w3_rec_var0) {
							return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
								_List_fromArray(
									[
										$author$project$LocalState$w3_encode_FrontendGuild(w3_rec_var0.guild),
										$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, w3_rec_var0.guildId),
										$lamdera$containers$SeqDict$encodeDict$(
										$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
										$author$project$User$w3_encode_FrontendUser,
										w3_rec_var0.members),
										$author$project$User$w3_encode_FrontendUser(w3_rec_var0.owner)
									]));
						},
						v0)
					]));
	}
};
var $author$project$Types$w3_encode_LocalMsg = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0),
					$author$project$Types$w3_encode_LocalChange(v1)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Types$w3_encode_ServerChange(v0)
				]));
	}
};
var $author$project$LocalState$w3_encode_AdminDataStatus$ = function (w3_x_c_a, w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						w3_x_c_a(v0)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$LocalState$w3_encode_AdminDataStatus = F2($author$project$LocalState$w3_encode_AdminDataStatus$);
var $author$project$LocalState$w3_encode_DeleteOrphanedFilesStatus = function (w3v) {
	switch (w3v.$) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$LocalState$w3_encode_ServerSecretStatus = function (w3v) {
	switch (w3v.$) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$program_test$Effect$Http$w3_encode_Error(v0)
					]));
	}
};
var $author$project$LocalState$w3_encode_AdminData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$LocalState$w3_encode_AdminDataStatus$(
				$lamdera$codecs$Lamdera$Wire3$encodeArray($author$project$BackendMsgLog$w3_encode_BackendMsgLogData),
				w3_rec_var0.backendMsgLogs),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$SessionIdHash$w3_encode_SessionIdHash,
					A2($author$project$NonemptyDict$w3_encode_NonemptyDict, $lamdera$program_test$Effect$Lamdera$w3_encode_ClientId, $author$project$LocalState$w3_encode_ConnectionData)),
				w3_rec_var0.connections),
				$author$project$LocalState$w3_encode_DeleteOrphanedFilesStatus(w3_rec_var0.deleteOrphanedFiles),
				$author$project$LocalState$w3_encode_AdminDataStatus$(
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_GuildId),
					$author$project$LocalState$w3_encode_AdminData_DeletedGuild),
				w3_rec_var0.deletedGuilds),
				$author$project$LocalState$w3_encode_AdminDataStatus$(
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_PrivateChannelId),
					$author$project$LocalState$w3_encode_AdminData_DiscordDmChannel),
				w3_rec_var0.discordDmChannels),
				$author$project$LocalState$w3_encode_AdminDataStatus$(
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_GuildId),
					$author$project$LocalState$w3_encode_AdminData_DiscordGuild),
				w3_rec_var0.discordGuilds),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.discordLinkLimit),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.discordLinkingEnabled),
				$author$project$LocalState$w3_encode_AdminDataStatus$(
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
					$author$project$LocalState$w3_encode_DiscordUserData_ForAdmin),
				w3_rec_var0.discordUsers),
				$author$project$LocalState$w3_encode_AdminDataStatus$(
				A2($lamdera$containers$SeqDict$encodeDict, $author$project$DmChannelId$w3_encode_DmChannelId, $author$project$LocalState$w3_encode_AdminData_DmChannel),
				w3_rec_var0.dmChannels),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.emailNotificationsEnabled),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.filesCount),
				$author$project$LocalState$w3_encode_AdminDataStatus$(
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_GuildId),
					$author$project$LocalState$w3_encode_AdminData_Guild),
				w3_rec_var0.guilds),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$LocalState$w3_encode_LastBackup, w3_rec_var0.lastBackup),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
				$author$project$LocalState$w3_encode_LoadingDiscordChannel($lamdera$codecs$Lamdera$Wire3$encodeInt),
				w3_rec_var0.loadingDiscordChannels),
				A2($author$project$Pagination$w3_encode_Pagination, $author$project$LocalState$w3_encode_LogWithTime, w3_rec_var0.logs),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				w3_rec_var0.notifyAdminsBotUserId),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.notifyAdminsToken),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.openRouterKey),
				$author$project$LocalState$w3_encode_AdminDataStatus$(
				A2($lamdera$containers$SeqDict$encodeDict, $author$project$FileStatus$w3_encode_FileHash, $author$project$FileStatus$w3_encode_BackendFileData),
				w3_rec_var0.orphanedFiles),
				$author$project$Postmark$w3_encode_ApiKey(w3_rec_var0.postmarkKey),
				$author$project$LocalState$w3_encode_PrivateVapidKey(w3_rec_var0.privateVapidKey),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeString, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				w3_rec_var0.seqDictWorks),
				$author$project$LocalState$w3_encode_ServerSecretStatus(w3_rec_var0.serverSecretRefreshedAt),
				$author$project$LocalState$w3_encode_AdminDataStatus$(
				A2($lamdera$containers$SeqDict$encodeDict, $author$project$SessionIdHash$w3_encode_SessionIdHash, $author$project$UserSession$w3_encode_UserSession),
				w3_rec_var0.sessions),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.signupsEnabled),
				$author$project$LocalState$w3_encode_AdminDataStatus$(
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_DmChannelId),
					$author$project$LocalState$w3_encode_AdminData_SlackDmChannel),
				w3_rec_var0.slackDmChannels),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.slackLinkLimit),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.slackLinkingEnabled),
				$author$project$LocalState$w3_encode_AdminDataStatus$(
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_TeamId),
					$author$project$LocalState$w3_encode_AdminData_SlackWorkspace),
				w3_rec_var0.slackWorkspaces),
				$author$project$LocalState$w3_encode_AdminDataStatus$(
				$lamdera$codecs$Lamdera$Wire3$encodeArray($author$project$ToBackendLog$w3_encode_ToBackendLogData),
				w3_rec_var0.toBackendLogs),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				$lamdera$program_test$Effect$Time$w3_encode_Posix,
				w3_rec_var0.twoFactorAuthentication),
				$author$project$LocalState$w3_encode_AdminDataStatus$(
				A2(
					$author$project$NonemptyDict$w3_encode_NonemptyDict,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
					$author$project$User$w3_encode_BackendUser),
				w3_rec_var0.users),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.vulnerabilityChecks),
				$author$project$LocalState$w3_encode_AdminDataStatus$(
				$lamdera$codecs$Lamdera$Wire3$encodeArray($author$project$LocalState$w3_encode_WebsocketClosedEvent),
				w3_rec_var0.websocketCloseEvents),
				$author$project$LocalState$w3_encode_WordSpellingGameStatus(w3_rec_var0.wordSpellingGameEnglish),
				$author$project$LocalState$w3_encode_WordSpellingGameStatus(w3_rec_var0.wordSpellingGameSwedish)
			]));
};
var $author$project$LocalState$w3_encode_AdminStatus = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$LocalState$w3_encode_AdminData(v0)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$DmChannel$w3_encode_E2eeEnabledData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.enabledAt),
				$lamdera$codecs$Lamdera$Wire3$encodePair$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				$author$project$SessionIdHash$w3_encode_SessionIdHash,
				w3_rec_var0.requestedBy)
			]));
};
var $author$project$DmChannel$w3_encode_E2eeStatus = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
						A2(
							$lamdera$codecs$Lamdera$Wire3$encodePair,
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
							$lamdera$program_test$Effect$Time$w3_encode_Posix),
						v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$DmChannel$w3_encode_E2eeEnabledData(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
						$author$project$SessionIdHash$w3_encode_SessionIdHash,
						v0)
					]));
	}
};
var $author$project$DmChannel$w3_encode_FrontendDmChannel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$justinmimbs$date$Date$w3_encode_Date,
				$author$project$Drawing$w3_encode_Drawing(
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId)),
				w3_rec_var0.dateDividerDrawings),
				$author$project$DmChannel$w3_encode_E2eeStatus(w3_rec_var0.e2ee),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
				$author$project$Game$w3_encode_MatchData,
				w3_rec_var0.games),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$author$project$Id$w3_encode_ThreadRouteWithMaybeMessage(w3_rec_var1.threadRoute),
								$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var1.time)
							]));
				},
				w3_rec_var0.lastTypedAt),
				$author$project$MessageArray$w3_encode_MessageArray$(
				$author$project$Id$w3_encode_ChannelMessageId,
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId),
				w3_rec_var0.messages),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
				$author$project$Thread$w3_encode_FrontendThread,
				w3_rec_var0.threads),
				A2($author$project$VisibleMessages$w3_encode_VisibleMessages, $author$project$Id$w3_encode_ChannelMessageId, w3_rec_var0.visibleMessages)
			]));
};
var $author$project$Call$w3_encode_Local = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Call$w3_encode_CallId, w3_rec_var0.currentRoom),
				$lamdera$containers$SeqDict$encodeDict$($author$project$Call$w3_encode_CallId, $author$project$Call$w3_encode_RecordingStatus, w3_rec_var0.recordings),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Call$w3_encode_CallId,
				A2(
					$author$project$NonemptyDict$w3_encode_NonemptyDict,
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
						$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId),
					$author$project$Call$w3_encode_RemoteCallData),
				w3_rec_var0.voiceChats)
			]));
};
var $author$project$TextEditor$w3_encode_LocalState = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				$author$project$Range$w3_encode_Range,
				w3_rec_var0.cursorPosition),
				$lamdera$codecs$Lamdera$Wire3$encodeArray$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
					$author$project$TextEditor$w3_encode_EditChange),
				w3_rec_var0.history),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				$lamdera$codecs$Lamdera$Wire3$encodeInt,
				w3_rec_var0.undoPoint)
			]));
};
var $author$project$User$w3_encode_FrontendCurrentUser = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_CustomEmojiId),
				w3_rec_var0.availableCustomEmojis),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_StickerId),
				w3_rec_var0.availableStickers),
				$author$project$UserColor$w3_encode_UserColor(w3_rec_var0.color),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.createdAt),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.deleteAccountAt),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_GuildId),
				A2(
					$author$project$NonemptyDict$w3_encode_NonemptyDict,
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId),
						$author$project$Id$w3_encode_ThreadRoute),
					$author$project$OneOrGreater$w3_encode_OneOrGreater),
				w3_rec_var0.directMentions),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_GuildId),
				A2(
					$author$project$NonemptyDict$w3_encode_NonemptyDict,
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_ChannelId),
						$author$project$Id$w3_encode_ThreadRoute),
					$author$project$OneOrGreater$w3_encode_OneOrGreater),
				w3_rec_var0.discordDirectMentions),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_GuildId),
				w3_rec_var0.discordNotifyOnAllMessages),
				$lamdera$containers$SeqSet$encodeSet$($author$project$RichText$w3_encode_Domain, w3_rec_var0.domainWhitelist),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.e2eeRisksAccepted),
				$author$project$EmailAddress$w3_encode_EmailAddress(w3_rec_var0.email),
				$author$project$User$w3_encode_EmailNotifications(w3_rec_var0.emailNotifications),
				$author$project$User$w3_encode_EmbedVisibility(w3_rec_var0.embedVisibility),
				$author$project$Emoji$w3_encode_EmojiConfig(w3_rec_var0.emojiConfig),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$FileStatus$w3_encode_FileHash, w3_rec_var0.icon),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isAdmin),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_GuildId),
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId),
					$author$project$Id$w3_encode_ThreadRoute),
				w3_rec_var0.lastChannelViewed),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_GuildId),
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_ChannelId),
					$author$project$Id$w3_encode_ThreadRoute),
				w3_rec_var0.lastDiscordChannelViewed),
				$author$project$User$w3_encode_LastDmViewed(w3_rec_var0.lastDmViewed),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.lastEmailNotification),
				$author$project$Id$w3_encode_Id$($author$project$Pagination$w3_encode_PageId, w3_rec_var0.lastLogPageViewed),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.lastPushNotification),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_TeamId),
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_ChannelId),
					$author$project$Id$w3_encode_ThreadRoute),
				w3_rec_var0.lastSlackChannelViewed),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_AnyGuildOrDmId,
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
				w3_rec_var0.lastViewedMessage),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Id$w3_encode_AnyGuildOrDmId,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId)),
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ThreadMessageId),
				w3_rec_var0.lastViewedThreadMessage),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.linkDiscordAcknowledgementIsChecked),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.linkSlackAcknowledgementIsChecked),
				$author$project$MuteSettings$w3_encode_Model(w3_rec_var0.muteSettings),
				$author$project$PersonName$w3_encode_PersonName(w3_rec_var0.name),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_GuildId),
				w3_rec_var0.notifyOnAllMessages),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$X25519$w3_encode_PublicKey, w3_rec_var0.publicKey),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.recentLoginEmails),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_TeamId),
				A2(
					$author$project$NonemptyDict$w3_encode_NonemptyDict,
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_ChannelId),
						$author$project$Id$w3_encode_ThreadRoute),
					$author$project$OneOrGreater$w3_encode_OneOrGreater),
				w3_rec_var0.slackDirectMentions),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_TeamId),
				w3_rec_var0.slackNotifyOnAllMessages)
			]));
};
var $author$project$LinkedAndOtherDiscordUsers$w3_encode_LinkedAndOtherDiscordUsers = function (w3v) {
	var v0 = w3v.a;
	var v1 = w3v.b;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
				$author$project$UserSession$w3_encode_DiscordFrontendUser,
				v0),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_UserId),
				$author$project$LinkedAndOtherDiscordUsers$w3_encode_DiscordFrontendCurrentUser,
				v1)
			]));
};
var $author$project$User$w3_encode_LocalUser = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$UserSession$w3_encode_Viewing(w3_rec_var0.currentlyViewing),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_CustomEmojiId),
				$author$project$CustomEmoji$w3_encode_CustomEmojiData,
				w3_rec_var0.customEmojis),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Encryption$w3_encode_BytesHash,
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodeResult,
					$lamdera$codecs$Lamdera$Wire3$encodeUnit,
					$author$project$Message$w3_encode_MessageContent$(
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId))),
				w3_rec_var0.decryptedMessages),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.devicePixelRatio),
				$author$project$LinkedAndOtherDiscordUsers$w3_encode_LinkedAndOtherDiscordUsers(w3_rec_var0.discordUsers),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Emoji$w3_encode_CachedEmojiData, w3_rec_var0.emojiData),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_UserId),
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_TeamId),
				w3_rec_var0.linkedSlackUsers),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				$author$project$User$w3_encode_FrontendUser,
				w3_rec_var0.otherUsers),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.safeAreaInsetBottom),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.safeAreaInsetTop),
				$author$project$UserSession$w3_encode_UserSession(w3_rec_var0.session),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_UserId),
				$author$project$UserSession$w3_encode_SlackFrontendUser,
				w3_rec_var0.slackUsers),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_UserId),
				w3_rec_var0.slackUsersNeedingAuth),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_StickerId),
				$author$project$Sticker$w3_encode_StickerData,
				w3_rec_var0.stickers),
				$lamdera$program_test$Effect$Time$w3_encode_Zone(w3_rec_var0.timezone),
				$author$project$User$w3_encode_FrontendCurrentUser(w3_rec_var0.user),
				$author$project$UserAgent$w3_encode_UserAgent(w3_rec_var0.userAgent)
			]));
};
var $author$project$LocalState$w3_encode_LocalState = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$LocalState$w3_encode_AdminStatus(w3_rec_var0.adminData),
				$author$project$Call$w3_encode_Local(w3_rec_var0.calls),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_PrivateChannelId),
				$author$project$DmChannel$w3_encode_DiscordFrontendDmChannel,
				w3_rec_var0.discordDmChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_GuildId),
				$author$project$LocalState$w3_encode_DiscordFrontendGuild,
				w3_rec_var0.discordGuilds),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				$author$project$DmChannel$w3_encode_FrontendDmChannel,
				w3_rec_var0.dmChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_GuildId),
				$author$project$LocalState$w3_encode_FrontendGuild,
				w3_rec_var0.guilds),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$LocalState$w3_encode_JoinGuildError, w3_rec_var0.joinGuildError),
				$author$project$User$w3_encode_LocalUser(w3_rec_var0.localUser),
				$lamdera$containers$SeqDict$encodeDict$($author$project$SessionIdHash$w3_encode_SessionIdHash, $author$project$UserSession$w3_encode_FrontendUserSession, w3_rec_var0.otherSessions),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.publicVapidKey),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_DmChannelId),
				$author$project$LocalState$w3_encode_SlackFrontendDmChannel,
				w3_rec_var0.slackDmChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_TeamId),
				$author$project$LocalState$w3_encode_SlackFrontendWorkspace,
				w3_rec_var0.slackWorkspaces),
				$author$project$TextEditor$w3_encode_LocalState(w3_rec_var0.textEditor)
			]));
};
var $author$project$Types$w3_encode_MessageHoverMobileMode = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$ianmackenzie$elm_units$Quantity$w3_encode_Quantity$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $author$project$CssPixels$w3_encode_CssPixels, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Types$w3_encode_EditMessage, v1)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$ianmackenzie$elm_units$Quantity$w3_encode_Quantity$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $author$project$CssPixels$w3_encode_CssPixels, w3_rec_var0.offset),
									$ianmackenzie$elm_units$Quantity$w3_encode_Quantity$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $author$project$CssPixels$w3_encode_CssPixels, w3_rec_var0.previousOffset),
									$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.time)
								]));
					}(v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$ianmackenzie$elm_units$Quantity$w3_encode_Quantity$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $author$project$CssPixels$w3_encode_CssPixels, v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$ianmackenzie$elm_units$Quantity$w3_encode_Quantity$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $author$project$CssPixels$w3_encode_CssPixels, w3_rec_var0.offset),
									$ianmackenzie$elm_units$Quantity$w3_encode_Quantity$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $author$project$CssPixels$w3_encode_CssPixels, w3_rec_var0.targetOffset)
								]));
					}(v0)
					]));
	}
};
var $author$project$Types$w3_encode_MessageMenuExtraOptions = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Id$w3_encode_AnyGuildOrDmId(w3_rec_var0.guildOrDmId),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.imageUrl),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isThreadStarter),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.linkUrl),
				$author$project$Types$w3_encode_MessageHoverMobileMode(w3_rec_var0.mobileMode),
				A2($author$project$Coord$w3_encode_Coord, $author$project$CssPixels$w3_encode_CssPixels, w3_rec_var0.position),
				$author$project$Id$w3_encode_ThreadRouteWithMessage(w3_rec_var0.threadRoute)
			]));
};
var $author$project$Types$w3_encode_MessageHover = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Types$w3_encode_MessageMenuExtraOptions(v0)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v2)
					]));
	}
};
var $author$project$Call$w3_encode_DebugRow = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.label),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.value)
			]));
};
var $author$project$Call$w3_encode_DebugSection = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Call$w3_encode_DebugRow, w3_rec_var0.rows),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.title)
			]));
};
var $author$project$IdString$w3_encode_IdString$ = function (w3_x_c_a, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$IdString$w3_encode_IdString = F2($author$project$IdString$w3_encode_IdString$);
var $author$project$Call$w3_encode_LocalOrConnection = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Call$w3_encode_ConnectionId(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Call$w3_encode_MediaDeviceId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Call$w3_encode_DeviceKind = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Call$w3_encode_MediaDevice = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$IdString$w3_encode_IdString$($author$project$Call$w3_encode_MediaDeviceId, w3_rec_var0.deviceId),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.groupId),
				$author$project$Call$w3_encode_DeviceKind(w3_rec_var0.kind),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.label)
			]));
};
var $author$project$Call$w3_encode_MediaDevicesStatus = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Call$w3_encode_MediaDevice, v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Call$w3_encode_VideoTile = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Call$w3_encode_LocalOrConnection(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Call$w3_encode_LocalOrConnection(v0)
				]));
	}
};
var $author$project$Call$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Call$w3_encode_DebugSection, w3_rec_var0.debugData),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Call$w3_encode_VideoTile, w3_rec_var0.focusedTile),
				$lamdera$containers$SeqSet$encodeSet$($author$project$Call$w3_encode_ConnectionId, w3_rec_var0.isSpeaking),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.localIsSpeaking),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pollDebugData),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.total),
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.uploaded)
							]));
				},
				w3_rec_var0.recordingUpload),
				$author$project$Call$w3_encode_RemoteCallData(w3_rec_var0.remoteCallData),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$IdString$w3_encode_IdString($author$project$Call$w3_encode_MediaDeviceId),
				w3_rec_var0.selectedAudioInputDevice),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$IdString$w3_encode_IdString($author$project$Call$w3_encode_MediaDeviceId),
				w3_rec_var0.selectedVideoInputDevice),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showDeviceSettings),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.startConnectionError),
				$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $lamdera$codecs$Lamdera$Wire3$encodeFloat, w3_rec_var0.thumbnailPosition),
				$author$project$Call$w3_encode_MediaDevicesStatus(w3_rec_var0.userMediaDevices),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Call$w3_encode_LocalOrConnection, w3_rec_var0.videoHover),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
					$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat,
				w3_rec_var0.volume)
			]));
};
var $author$project$Drawing$w3_encode_ActiveStroke = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$SafeFloat$w3_encode_SafeFloat, $author$project$SafeFloat$w3_encode_SafeFloat),
				w3_rec_var0.unsent)
			]));
};
var $author$project$Drawing$w3_encode_SelectedAnchorData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $lamdera$codecs$Lamdera$Wire3$encodeFloat, w3_rec_var0.anchorHalfSize),
				$author$project$Drawing$w3_encode_AnchorType(w3_rec_var0.anchorType),
				$author$project$Id$w3_encode_AnyGuildOrDmId(w3_rec_var0.guildOrDmId),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.pointScale),
				A3($author$project$Point2d$w3_encode_Point2d, $author$project$CssPixels$w3_encode_CssPixels, $author$project$Touch$w3_encode_ScreenCoordinate, w3_rec_var0.position),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Drawing$w3_encode_ActiveStroke, w3_rec_var0.stroke),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.zoom),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.height),
								$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.width),
								$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.x),
								$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.y)
							]));
				},
				w3_rec_var0.zoomContainer)
			]));
};
var $author$project$Drawing$w3_encode_Model = function (w3v) {
	if (!w3v.$) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Drawing$w3_encode_SelectedAnchorData(v0)
				]));
	}
};
var $author$project$Emoji$w3_encode_Category = function (w3v) {
	switch (w3v.$) {
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Emoji$w3_encode_EmojiCategory(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Emoji$w3_encode_EmojiOrSticker = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_CustomEmojiId, v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_StickerId, v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Emoji$w3_encode_UnicodeEmoji(v0)
					]));
	}
};
var $author$project$Emoji$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Emoji$w3_encode_Category(w3_rec_var0.category),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$author$project$Emoji$w3_encode_EmojiOrSticker(w3_rec_var1.emoji),
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.index)
							]));
				},
				w3_rec_var0.emojiHovered),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.searchText)
			]));
};
var $author$project$Scroll$w3_encode_ScrollPosition = function (w3v) {
	switch (w3v) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$SheepGame$w3_encode_UnvalidatedInput = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$FileStatus$w3_encode_FileId),
				$author$project$FileStatus$w3_encode_FileStatus,
				w3_rec_var0.attachedFiles),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.text)
			]));
};
var $author$project$SheepGame$w3_encode_GameData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$IdArray$w3_encode_IdArray$($author$project$Id$w3_encode_QuestionId, $author$project$SheepGame$w3_encode_UnvalidatedInput, w3_rec_var0.answerDrafts),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId)),
				w3_rec_var0.gridHovered),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_QuestionId),
				w3_rec_var0.hoveredQuestion),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$SheepGame$w3_encode_ReactionTarget, w3_rec_var0.hoveredResult),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.newQuestionRevealed),
				$author$project$IdArray$w3_encode_IdArray$($author$project$Id$w3_encode_QuestionId, $author$project$SheepGame$w3_encode_UnvalidatedInput, w3_rec_var0.noteDrafts),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.questionsRevealedSeen),
				$author$project$Scroll$w3_encode_ScrollPosition(w3_rec_var0.scrollPosition)
			]));
};
var $author$project$WordSpellingGame$w3_encode_Drag = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$WordSpellingGame$w3_encode_HoveredMove = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeDict$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				$author$project$WordSpellingGame$w3_encode_LetterOrWildcard,
				w3_rec_var0.cells),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.index),
				$author$project$WordSpellingGame$w3_encode_Shared(w3_rec_var0.shared)
			]));
};
var $author$project$WordSpellingGame$w3_encode_TrayIndex = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$WordSpellingGame$w3_encode_TilePosition = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$WordSpellingGame$w3_encode_TrayIndex(v0),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$program_test$Effect$Time$w3_encode_Posix, $lamdera$codecs$Lamdera$Wire3$encodeInt),
					v1)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt, v0),
					$lamdera$program_test$Effect$Time$w3_encode_Posix(v1)
				]));
	}
};
var $author$project$WordSpellingGame$w3_encode_Tile = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.createdAt),
				$author$project$WordSpellingGame$w3_encode_TilePosition(w3_rec_var0.position)
			]));
};
var $author$project$WordSpellingGame$w3_encode_OpenWordDefinition = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.index),
				$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.words)
			]));
};
var $author$project$WordSpellingGame$w3_encode_DictEntry = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.definitions),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.partOfSpeech)
			]));
};
var $author$project$WordSpellingGame$w3_encode_WordDefinitionData = function (w3v) {
	switch (w3v.$) {
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$WordSpellingGame$w3_encode_DictEntry, v0)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
	}
};
var $author$project$WordSpellingGame$w3_encode_WordDefinition = function (w3v) {
	if (!w3v.$) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$WordSpellingGame$w3_encode_OpenWordDefinition(v0),
					$author$project$WordSpellingGame$w3_encode_WordDefinitionData(v1)
				]));
	}
};
var $author$project$WordSpellingGame$w3_encode_ZoomState = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.amount),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.focusX),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.focusY)
			]));
};
var $author$project$WordSpellingGame$w3_encode_ZoomAnimation = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$WordSpellingGame$w3_encode_ZoomState(w3_rec_var0.from),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.start)
			]));
};
var $author$project$WordSpellingGame$w3_encode_GameData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$WordSpellingGame$w3_encode_Drag(w3_rec_var0.dragging),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				w3_rec_var0.highlightedPlayer),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$WordSpellingGame$w3_encode_HoveredMove, w3_rec_var0.hoveredMove),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.letterCount),
								$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var1.time)
							]));
				},
				w3_rec_var0.lastWordPlaced),
				$author$project$Scroll$w3_encode_ScrollPosition(w3_rec_var0.scrollPosition),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				w3_rec_var0.selectedCell),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showSettings),
				$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$WordSpellingGame$w3_encode_Tile, w3_rec_var0.tiles),
				$author$project$WordSpellingGame$w3_encode_WordDefinition(w3_rec_var0.wordDefinition),
				$author$project$WordSpellingGame$w3_encode_ZoomAnimation(w3_rec_var0.zoomAnimation)
			]));
};
var $author$project$Go$w3_encode_GameModel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.lastError),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.lastPlacedStone),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.viewingMovesBack)
			]));
};
var $author$project$Game$w3_encode_Game = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Go$w3_encode_GameModel(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$SheepGame$w3_encode_GameData(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$WordSpellingGame$w3_encode_GameData(v0)
					]));
	}
};
var $author$project$Go$w3_encode_SizeSelection = function (w3v) {
	switch (w3v) {
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Go$w3_encode_SetupModel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.error),
				$author$project$Go$w3_encode_Stone(w3_rec_var0.gameCreatorPlayingAs),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.handicapInput),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.heightInput),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.incrementInput),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.komiInput),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.mainTimeInput),
				$author$project$Go$w3_encode_SizeSelection(w3_rec_var0.sizeSelection),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.widthInput)
			]));
};
var $author$project$SheepGame$w3_encode_SetupModel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.error),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pressedSubmit),
				$author$project$IdArray$w3_encode_IdArray$($author$project$Id$w3_encode_QuestionId, $author$project$SheepGame$w3_encode_UnvalidatedInput, w3_rec_var0.questions)
			]));
};
var $author$project$WordSpellingGame$w3_encode_SetupModel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.advancedSettingsExpanded),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.error),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.fullTrayBonus),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.incrementInput),
				$author$project$WordSpellingGame$w3_encode_Language(w3_rec_var0.language),
				$lamdera$containers$SeqDict$encodeDict$($lamdera$codecs$Lamdera$Wire3$encodeChar, $lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.letterValues),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.letters),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.mainTimeInput),
				$author$project$OneOrGreater$w3_encode_OneOrGreater(w3_rec_var0.placeWordAttempts),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.traySize)
			]));
};
var $author$project$Game$w3_encode_Setup = function (w3v) {
	switch (w3v.$) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Go$w3_encode_SetupModel(v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$SheepGame$w3_encode_SetupModel(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$WordSpellingGame$w3_encode_SetupModel(v0)
					]));
	}
};
var $author$project$Game$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Game$w3_encode_Setup(w3_rec_var0.setup),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.sheepGameQuestionsCounter),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
					$author$project$SheepGame$w3_encode_Input),
				$lamdera$codecs$Lamdera$Wire3$encodeInt,
				w3_rec_var0.sheepGameSaveCounters),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
				$author$project$Game$w3_encode_Game,
				w3_rec_var0.startedGames)
			]));
};
var $author$project$ImageEditor$w3_encode_DragPart = function (w3v) {
	switch (w3v) {
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
	}
};
var $author$project$ImageEditor$w3_encode_DragState = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.currentX),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.currentY),
				$author$project$ImageEditor$w3_encode_DragPart(w3_rec_var0.dragPart),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.startX),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.startY)
			]));
};
var $author$project$ImageEditor$w3_encode_UploadStatus = function (w3v) {
	switch (w3v.$) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$FileStatus$w3_encode_FileHash(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$ImageEditor$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$ImageEditor$w3_encode_DragState, w3_rec_var0.dragState),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
				w3_rec_var0.imageSize),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.imageUrl),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.size),
				$author$project$ImageEditor$w3_encode_UploadStatus(w3_rec_var0.status),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.x),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.y)
			]));
};
var $author$project$Pages$Admin$w3_encode_AdminUiSection = function (w3v) {
	switch (w3v) {
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 12:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 13:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 17:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(12);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
		case 15:
			return $elm$bytes$Bytes$Encode$unsignedInt8(14);
		case 14:
			return $elm$bytes$Bytes$Encode$unsignedInt8(15);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(16);
		case 16:
			return $elm$bytes$Bytes$Encode$unsignedInt8(17);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(18);
	}
};
var $author$project$Pages$Admin$w3_encode_DownloadingBackup = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeBytes, w3_rec_var0.chunks),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.receivedBytes),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.totalBytes)
			]));
};
var $author$project$Pages$Admin$w3_encode_ExportProgress = function (w3v) {
	switch (w3v.$) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.encoded),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.total)
								]));
					}(v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.channelsRemaining),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.encoded),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.total)
								]));
					}(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.encoded),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.total)
								]));
					}(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.channelsRemaining),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.encoded),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.total)
								]));
					}(v0)
					]));
	}
};
var $author$project$Pages$Admin$w3_encode_ExportSubsetSelection = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_PrivateChannelId),
				w3_rec_var0.discordDmChannels),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_GuildId),
				w3_rec_var0.discordGuilds),
				$lamdera$containers$SeqSet$encodeSet$($author$project$DmChannelId$w3_encode_DmChannelId, w3_rec_var0.dmChannels),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_GuildId),
				w3_rec_var0.guilds)
			]));
};
var $author$project$Pages$Admin$w3_encode_ImportBackendStatus = function (w3v) {
	switch (w3v.$) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeBytes(w3_rec_var0.remainingBytes),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.sentBytes),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.totalBytes)
								]));
					}(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Pagination$w3_encode_ItemId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$failEncode(v0)
			]));
};
var $author$project$Editable$w3_encode_Editing = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Editable$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Editable$w3_encode_Editing(w3_rec_var0.editing),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pressedSubmit),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showSecret)
			]));
};
var $author$project$Pages$Admin$w3_encode_UserColumn = function (w3v) {
	if (w3v === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Pages$Admin$w3_encode_UserTableId = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
				]));
	}
};
var $author$project$Pages$Admin$w3_encode_EditingCell = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Pages$Admin$w3_encode_UserColumn(w3_rec_var0.column),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.text),
				$author$project$Pages$Admin$w3_encode_UserTableId(w3_rec_var0.userId)
			]));
};
var $author$project$Table$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.ascendingOrder),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.columnToSortBy),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showAll)
			]));
};
var $author$project$Pages$Admin$w3_encode_UserTable = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				$author$project$Pages$Admin$w3_encode_EditedBackendUser,
				w3_rec_var0.changedUsers),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				w3_rec_var0.deletedUsers),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Pages$Admin$w3_encode_EditingCell, w3_rec_var0.editingCell),
				$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Pages$Admin$w3_encode_EditedBackendUser, w3_rec_var0.newUsers),
				$author$project$Table$w3_encode_Model(w3_rec_var0.table)
			]));
};
var $author$project$Pages$Admin$w3_encode_UsersChangeError = function (w3v) {
	switch (w3v.$) {
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
	}
};
var $author$project$Pages$Admin$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Id$w3_encode_Id($author$project$Pagination$w3_encode_ItemId),
				w3_rec_var0.copiedLogLink),
				$author$project$Editable$w3_encode_Model(w3_rec_var0.discordLinkLimit),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Pages$Admin$w3_encode_DownloadingBackup, w3_rec_var0.downloadingBackup),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_GuildId),
				w3_rec_var0.expandedDiscordGuilds),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_GuildId),
				w3_rec_var0.expandedGuilds),
				$lamdera$containers$SeqSet$encodeSet$($author$project$Pages$Admin$w3_encode_AdminUiSection, w3_rec_var0.expandedSections),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_TeamId),
				w3_rec_var0.expandedSlackWorkspaces),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Pages$Admin$w3_encode_ExportProgress, w3_rec_var0.exportProgress),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Pages$Admin$w3_encode_ExportSubsetSelection, w3_rec_var0.exportSubsetSelection),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Id$w3_encode_Id($author$project$Pagination$w3_encode_ItemId),
				w3_rec_var0.highlightLog),
				$author$project$Pages$Admin$w3_encode_ImportBackendStatus(w3_rec_var0.importBackendStatus),
				$author$project$Editable$w3_encode_Model(w3_rec_var0.notifyAdminsBotUserId),
				$author$project$Editable$w3_encode_Model(w3_rec_var0.notifyAdminsToken),
				$author$project$Editable$w3_encode_Model(w3_rec_var0.openRouterKey),
				$author$project$Editable$w3_encode_Model(w3_rec_var0.postmarkKey),
				$author$project$Editable$w3_encode_Model(w3_rec_var0.privateVapidKey),
				$author$project$Editable$w3_encode_Model(w3_rec_var0.publicVapidKey),
				$author$project$Editable$w3_encode_Model(w3_rec_var0.slackLinkLimit),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Pages$Admin$w3_encode_UsersChangeError, w3_rec_var0.submitError),
				$author$project$Pages$Admin$w3_encode_UserTable(w3_rec_var0.userTable),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.websocketCloseEventsPage)
			]));
};
var $author$project$TextEditor$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(_List_Nil);
};
var $author$project$Types$w3_encode_NewChannelForm = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.description),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pressedSubmit)
			]));
};
var $author$project$Types$w3_encode_NewGuildForm = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pressedSubmit)
			]));
};
var $author$project$X25519$w3_encode_PrivateKey = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$author$project$X25519$w3_encode_Key(v0)
			]));
};
var $author$project$Types$w3_encode_RevealedSpoilers = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
				$author$project$NonemptySet$w3_encode_NonemptySet($lamdera$codecs$Lamdera$Wire3$encodeInt),
				w3_rec_var0.messages),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
				A2(
					$lamdera$containers$SeqDict$encodeDict,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ThreadMessageId),
					$author$project$NonemptySet$w3_encode_NonemptySet($lamdera$codecs$Lamdera$Wire3$encodeInt)),
				w3_rec_var0.threadMessages)
			]));
};
var $author$project$MessageInput$w3_encode_MentionUserDropdown = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.dropdownIndex),
				function (w3_rec_var1) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.height),
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.width),
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.x),
							$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var1.y)
						]));
			}(w3_rec_var0.inputElement)
			]));
};
var $author$project$Range$w3_encode_SelectionDirection = function (w3v) {
	if (w3v === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$MessageInput$w3_encode_TextInputFocus = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Range$w3_encode_SelectionDirection(w3_rec_var0.direction),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$MessageInput$w3_encode_MentionUserDropdown, w3_rec_var0.dropdown),
				$lamdera$program_test$Effect$Browser$Dom$w3_encode_HtmlId(w3_rec_var0.htmlId),
				$author$project$Range$w3_encode_Range(w3_rec_var0.selection)
			]));
};
var $author$project$LoginForm$w3_encode_CodeStatus = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$TwoFactorAuthentication$w3_encode_TwoFactorDisableData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$LoginForm$w3_encode_CodeStatus, w3_rec_var0.attempts),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.code)
			]));
};
var $author$project$TwoFactorAuthentication$w3_encode_TwoFactorSetupData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$LoginForm$w3_encode_CodeStatus, w3_rec_var0.attempts),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.code),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.qrCodeUrl)
			]));
};
var $author$project$TwoFactorAuthentication$w3_encode_TwoFactorState = function (w3v) {
	switch (w3v.$) {
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0)
					]));
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$TwoFactorAuthentication$w3_encode_TwoFactorDisableData(v1)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$TwoFactorAuthentication$w3_encode_TwoFactorSetupData(v0)
					]));
	}
};
var $author$project$Types$w3_encode_E2eeKeysValid = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Types$w3_encode_LinkSlackWorkspaceError = function (w3v) {
	if (w3v.$ === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Slack$w3_encode_HttpError(v0)
				]));
	}
};
var $author$project$Types$w3_encode_LinkSlackResult = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
					A2($lamdera$codecs$Lamdera$Wire3$encodeResult, $author$project$Types$w3_encode_LinkSlackWorkspaceError, $lamdera$codecs$Lamdera$Wire3$encodeString),
					v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$UserColor$w3_encode_Selection = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$UserColor$w3_encode_UserColor(w3_rec_var0.lastValid),
				function (w3_rec_var1) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.hue),
							$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.lightness),
							$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.saturation)
						]));
			}(w3_rec_var0.selected)
			]));
};
var $author$project$Types$w3_encode_UserOptionsModel = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$UserColor$w3_encode_Selection, w3_rec_var0.color),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				function (w3_rec_var1) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var1.data),
								$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var1.loadedAt)
							]));
				},
				w3_rec_var0.debugData),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.domainWhitelistInput),
				$author$project$Types$w3_encode_E2eeKeysValid(w3_rec_var0.e2eeKeysValid),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Types$w3_encode_LinkSlackResult, w3_rec_var0.linkSlackResult),
				$author$project$Editable$w3_encode_Model(w3_rec_var0.name),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pressedSubmitSlackData),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.privateKeyText),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_TeamId),
				w3_rec_var0.removedSlackTeams),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.slackCookie),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.slackTeamsJson)
			]));
};
var $author$project$Types$w3_encode_LoggedIn2 = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.accountDeletionBannerClosed),
				$author$project$Pages$Admin$w3_encode_Model(w3_rec_var0.admin),
				$author$project$Scroll$w3_encode_ScrollPosition(w3_rec_var0.channelScrollPosition),
				$lamdera$containers$SeqDict$encodeDict$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Id$w3_encode_AnyGuildOrDmId, $author$project$Id$w3_encode_ThreadRoute),
				$MartinSStewart$elm_nonempty_string$String$Nonempty$w3_encode_NonemptyString,
				w3_rec_var0.drafts),
				$author$project$Drawing$w3_encode_Model(w3_rec_var0.drawingMode),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.e2eeError),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				w3_rec_var0.e2eeKeysOnThisDevice),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.e2eePrivateKeyText),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				$lamdera$codecs$Lamdera$Wire3$encodeBool,
				w3_rec_var0.e2eeSectionsExpanded),
				$lamdera$containers$SeqDict$encodeDict$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_GuildId),
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId)),
				$author$project$Types$w3_encode_EditChannelForm,
				w3_rec_var0.editChannelForm),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_GuildId),
				$author$project$Types$w3_encode_EditGuildForm,
				w3_rec_var0.editGuildForm),
				$lamdera$containers$SeqDict$encodeDict$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Id$w3_encode_AnyGuildOrDmId, $author$project$Id$w3_encode_ThreadRoute),
				$author$project$Types$w3_encode_EditMessage,
				w3_rec_var0.editMessage),
				$author$project$Emoji$w3_encode_Model(w3_rec_var0.emojiSelector),
				$author$project$Types$w3_encode_EncryptionRequests(w3_rec_var0.encryptionRequests),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($elm$url$Url$w3_encode_Url, w3_rec_var0.externalLinkWarning),
				$author$project$Types$w3_encode_FileDrag(w3_rec_var0.fileDragOverCount),
				$lamdera$containers$SeqDict$encodeDict$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Id$w3_encode_AnyGuildOrDmId, $author$project$Id$w3_encode_ThreadRoute),
				A2(
					$author$project$NonemptyDict$w3_encode_NonemptyDict,
					$author$project$Id$w3_encode_Id($author$project$FileStatus$w3_encode_FileId),
					$author$project$FileStatus$w3_encode_FileStatus),
				w3_rec_var0.filesToUpload),
				$lamdera$containers$SeqDict$encodeDict$($author$project$Id$w3_encode_GuildOrDmId, $author$project$Game$w3_encode_Model, w3_rec_var0.games),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				A2(
					$lamdera$codecs$Lamdera$Wire3$encodePair,
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_GuildId),
					$author$project$ImageEditor$w3_encode_Model),
				w3_rec_var0.guildIconEditor),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.isReloading),
				$author$project$Local$w3_encode_Local$($author$project$Types$w3_encode_LocalMsg, $author$project$LocalState$w3_encode_LocalState, w3_rec_var0.localState),
				$author$project$Types$w3_encode_MessageHover(w3_rec_var0.messageHover),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_GuildId),
				$author$project$Types$w3_encode_NewChannelForm,
				w3_rec_var0.newChannelForm),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Types$w3_encode_NewGuildForm, w3_rec_var0.newGuildForm),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.newMessagesWhileNotScrolledToBottom),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$MessageInput$w3_encode_TextInputFocus, w3_rec_var0.previousTextInputFocus),
				$author$project$ImageEditor$w3_encode_Model(w3_rec_var0.profilePictureEditor),
				$lamdera$containers$SeqDict$encodeDict$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Id$w3_encode_AnyGuildOrDmId, $author$project$Id$w3_encode_ThreadRoute),
				$author$project$Message$w3_encode_RepliedTo($author$project$Id$w3_encode_ChannelMessageId),
				w3_rec_var0.replyTo),
				$lamdera$containers$SeqDict$encodeDict$($author$project$Id$w3_encode_AnyGuildOrDmId, $author$project$Types$w3_encode_RevealedSpoilers, w3_rec_var0.revealedSpoilers),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.searchOverlayQuery),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.searchOverlaySelection),
				$author$project$Types$w3_encode_EmojiSelector(w3_rec_var0.showEmojiSelector),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$FileStatus$w3_encode_FileDataWithImage, w3_rec_var0.showFileToUploadInfo),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$SecretId$w3_encode_SecretId($author$project$Id$w3_encode_InviteLinkId),
				w3_rec_var0.showInviteLinkQrCode),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$X25519$w3_encode_PrivateKey, w3_rec_var0.showNewPrivateKey),
				$author$project$Route$w3_encode_ChannelSidebarMode(w3_rec_var0.sidebarMode),
				$author$project$TextEditor$w3_encode_Model(w3_rec_var0.textEditor),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$MessageInput$w3_encode_TextInputFocus, w3_rec_var0.textInputFocus),
				$author$project$TwoFactorAuthentication$w3_encode_TwoFactorState(w3_rec_var0.twoFactor),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.typedTextCounter),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.typingDebouncer),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Types$w3_encode_UserOptionsModel, w3_rec_var0.userOptions),
				$author$project$Call$w3_encode_Model(w3_rec_var0.voiceChat)
			]));
};
var $author$project$LoginForm$w3_encode_EnterEmail2 = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.email),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pressedSubmitEmail),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.rateLimited),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showSignupsDisabled),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.showUserIsDeleted)
			]));
};
var $author$project$LoginForm$w3_encode_EnterLoginCode2 = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$containers$SeqDict$encodeDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$LoginForm$w3_encode_CodeStatus, w3_rec_var0.attempts),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.code),
				$author$project$EmailAddress$w3_encode_EmailAddress(w3_rec_var0.sentTo)
			]));
};
var $author$project$LoginForm$w3_encode_EnterTwoFactorCode2 = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.attemptCount),
				$lamdera$containers$SeqDict$encodeDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$LoginForm$w3_encode_CodeStatus, w3_rec_var0.attempts),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.code)
			]));
};
var $author$project$LoginForm$w3_encode_SubmitStatus = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$LoginForm$w3_encode_EnterUserData2 = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.name),
				$author$project$LoginForm$w3_encode_SubmitStatus(w3_rec_var0.pressedSubmit)
			]));
};
var $author$project$LoginForm$w3_encode_LoginForm = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$LoginForm$w3_encode_EnterEmail2(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$LoginForm$w3_encode_EnterLoginCode2(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$LoginForm$w3_encode_EnterTwoFactorCode2(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$LoginForm$w3_encode_EnterUserData2(v0)
					]));
	}
};
var $author$project$RecoveryLogin$w3_encode_SubmitStatus = function (w3v) {
	switch (w3v.$) {
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$RecoveryLogin$w3_encode_Model = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				function (w3_rec_var0) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.password),
							$author$project$RecoveryLogin$w3_encode_SubmitStatus(w3_rec_var0.submitStatus)
						]));
			}(v0)
			]));
};
var $author$project$Types$w3_encode_LoginStatus = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Types$w3_encode_LoggedIn2(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					function (w3_rec_var0) {
					return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
						_List_fromArray(
							[
								$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$LoginForm$w3_encode_LoginForm, w3_rec_var0.loginForm),
								$author$project$RecoveryLogin$w3_encode_Model(w3_rec_var0.recoveryLogin),
								$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
								function (w3_rec_var1) {
									return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
										_List_fromArray(
											[
												$author$project$Range$w3_encode_SelectionDirection(w3_rec_var1.direction),
												$lamdera$program_test$Effect$Browser$Dom$w3_encode_HtmlId(w3_rec_var1.htmlId),
												$author$project$Range$w3_encode_Range(w3_rec_var1.selection)
											]));
								},
								w3_rec_var0.textInputFocus),
								$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
								$author$project$SecretId$w3_encode_SecretId($author$project$Id$w3_encode_InviteLinkId),
								w3_rec_var0.useInviteAfterLoggedIn)
							]));
				}(v0)
				]));
	}
};
var $author$project$Types$w3_encode_LoginType = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$ImageViewer$w3_encode_Interaction = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.offsetStartX),
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.offsetStartY),
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.startX),
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.startY)
								]));
					}(v0)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.prevMidX),
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.prevMidY),
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.startDistance),
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.startScale)
								]));
					}(v0)
					]));
	}
};
var $author$project$ImageViewer$w3_encode_Model = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				A2($author$project$Coord$w3_encode_Coord, $author$project$CssPixels$w3_encode_CssPixels, w3_rec_var0.imageSize),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.imageUrl),
				$author$project$ImageViewer$w3_encode_Interaction(w3_rec_var0.interaction),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.offsetX),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.offsetY),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.prevOffsetX),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.prevOffsetY),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.scale),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.targetScale),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.velocityX),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.velocityY),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.zoomFocusX),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.zoomFocusY)
			]));
};
var $author$project$Go$w3_encode_PublicGoMatchData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Go$w3_encode_ActionWithTime, w3_rec_var0.actions),
				$author$project$Go$w3_encode_Shared(w3_rec_var0.cache),
				$author$project$User$w3_encode_FrontendUser(w3_rec_var0.creatorUser),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$User$w3_encode_FrontendUser, w3_rec_var0.joinedUser),
				$author$project$Go$w3_encode_ValidatedSetup(w3_rec_var0.setup)
			]));
};
var $author$project$Types$w3_encode_PublicGoMatch = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Go$w3_encode_PublicGoMatchData(v0),
						$author$project$Go$w3_encode_GameModel(v1)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Route$w3_encode_ShowChannelSettings = function (w3v) {
	if (w3v === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Route$w3_encode_ThreadRouteWithFriends = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
					v0),
					$author$project$Route$w3_encode_ShowChannelSettings(v1)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		var v2 = w3v.c;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v0),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
					$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ThreadMessageId),
					v1),
					$author$project$Route$w3_encode_ShowChannelSettings(v2)
				]));
	}
};
var $author$project$Route$w3_encode_ChannelRoute = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelId, v0),
						$author$project$Route$w3_encode_ThreadRouteWithFriends(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$UserSession$w3_encode_ChannelHeaderTab, v2)
					]));
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$SecretId$w3_encode_SecretId$($author$project$Id$w3_encode_InviteLinkId, v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Route$w3_encode_ChannelsVisibleOnMobile = function (w3v) {
	if (!w3v) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Route$w3_encode_Overlay = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Route$w3_encode_DiscordDmRouteData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_PrivateChannelId, w3_rec_var0.channelId),
				$author$project$Route$w3_encode_ChannelsVisibleOnMobile(w3_rec_var0.channelsVisible),
				$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, w3_rec_var0.currentDiscordUserId),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Route$w3_encode_Overlay, w3_rec_var0.overlay),
				$author$project$Route$w3_encode_ShowChannelSettings(w3_rec_var0.showMembersTab),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$UserSession$w3_encode_ChannelHeaderTab, w3_rec_var0.tab),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelMessageId),
				w3_rec_var0.viewingMessage)
			]));
};
var $author$project$Route$w3_encode_DiscordChannelRoute = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v0),
						$author$project$Route$w3_encode_ThreadRouteWithFriends(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$UserSession$w3_encode_ChannelHeaderTab, v2)
					]));
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Route$w3_encode_DiscordGuildRouteData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Route$w3_encode_DiscordChannelRoute(w3_rec_var0.channelRoute),
				$author$project$Route$w3_encode_ChannelsVisibleOnMobile(w3_rec_var0.channelsVisible),
				$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, w3_rec_var0.currentDiscordUserId),
				$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, w3_rec_var0.guildId),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Route$w3_encode_Overlay, w3_rec_var0.overlay)
			]));
};
var $author$project$Route$w3_encode_DmRouteData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$DmChannelId$w3_encode_DmChannelId(w3_rec_var0.channelId),
				$author$project$Route$w3_encode_ChannelsVisibleOnMobile(w3_rec_var0.channelsVisible),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Route$w3_encode_Overlay, w3_rec_var0.overlay),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$UserSession$w3_encode_ChannelHeaderTab, w3_rec_var0.tab),
				$author$project$Route$w3_encode_ThreadRouteWithFriends(w3_rec_var0.threadRoute)
			]));
};
var $author$project$Route$w3_encode_LinkDiscordError = function (w3v) {
	switch (w3v) {
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Route$w3_encode_SlackDmRouteData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_DmChannelId, w3_rec_var0.channelId),
				$author$project$Route$w3_encode_ChannelsVisibleOnMobile(w3_rec_var0.channelsVisible),
				$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_UserId, w3_rec_var0.currentSlackUserId),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Route$w3_encode_Overlay, w3_rec_var0.overlay),
				$author$project$Id$w3_encode_ThreadRouteWithMaybeMessage(w3_rec_var0.threadRoute)
			]));
};
var $author$project$Route$w3_encode_SlackChannelRoute = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		var v2 = w3v.c;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_ChannelId, v0),
					$author$project$Id$w3_encode_ThreadRouteWithMaybeMessage(v1),
					$author$project$Route$w3_encode_ShowChannelSettings(v2)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Route$w3_encode_SlackWorkspaceRouteData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Route$w3_encode_SlackChannelRoute(w3_rec_var0.channelRoute),
				$author$project$Route$w3_encode_ChannelsVisibleOnMobile(w3_rec_var0.channelsVisible),
				$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_UserId, w3_rec_var0.currentSlackUserId),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Route$w3_encode_Overlay, w3_rec_var0.overlay),
				$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_TeamId, w3_rec_var0.teamId)
			]));
};
var $author$project$SafeJson$w3_encode_SafeJson = function (w3v) {
	switch (w3v.$) {
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$SafeJson$w3_encode_SafeJson, v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$SafeFloat$w3_encode_SafeFloat(v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$lamdera$codecs$Lamdera$Wire3$encodeDict$($lamdera$codecs$Lamdera$Wire3$encodeString, $author$project$SafeJson$w3_encode_SafeJson, v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
	}
};
var $author$project$Discord$w3_encode_UserAuth = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.token),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.userAgent),
				$author$project$SafeJson$w3_encode_SafeJson(w3_rec_var0.xSuperProperties)
			]));
};
var $author$project$Route$w3_encode_Route = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
									$author$project$Id$w3_encode_Id($author$project$Pagination$w3_encode_ItemId),
									w3_rec_var0.highlightLog)
								]));
					}(v0)
					]));
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Route$w3_encode_DiscordDmRouteData(v0)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Route$w3_encode_DiscordGuildRouteData(v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Route$w3_encode_DmRouteData(v0)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$Route$w3_encode_ChannelRoute(v1),
						$author$project$Route$w3_encode_ChannelsVisibleOnMobile(v2),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Route$w3_encode_Overlay, v3)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Route$w3_encode_Overlay, v0)
					]));
		case 12:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($author$project$Route$w3_encode_LinkDiscordError, $author$project$Discord$w3_encode_UserAuth, v0)
					]));
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		case 13:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$SecretId$w3_encode_SecretId$($author$project$Id$w3_encode_GamePublicId, v0)
					]));
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$Route$w3_encode_SlackDmRouteData(v0)
					]));
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$Route$w3_encode_SlackWorkspaceRouteData(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
	}
};
var $author$project$Audio$w3_encode_BufferId = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
			]));
};
var $author$project$Audio$w3_encode_Source = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				function (w3_rec_var0) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$author$project$Audio$w3_encode_BufferId(w3_rec_var0.bufferId)
						]));
			}(v0)
			]));
};
var $author$project$Ports$w3_encode_NotificationPermission = function (w3v) {
	switch (w3v) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
	}
};
var $author$project$Ports$w3_encode_PwaStatus = function (w3v) {
	if (w3v === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Ports$w3_encode_StartupData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.devicePixelRatio),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				w3_rec_var0.e2eeKeys),
				function (t) {
				return $lamdera$codecs$Lamdera$Wire3$encodeInt(
					$elm$time$Time$posixToMillis(t));
			}(w3_rec_var0.loadStartupDataTime),
				$author$project$Ports$w3_encode_NotificationPermission(w3_rec_var0.notificationPermission),
				$author$project$Ports$w3_encode_PwaStatus(w3_rec_var0.pwaStatus),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.randomSeed),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.safeAreaInsetBottom),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.safeAreaInsetTop),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.scrollbarWidth),
				function (t) {
				return $lamdera$codecs$Lamdera$Wire3$encodeInt(
					$elm$time$Time$posixToMillis(t));
			}(w3_rec_var0.timeOrigin),
				$elm$time$Time$w3_encode_Zone(w3_rec_var0.timezone),
				$author$project$UserAgent$w3_encode_UserAgent(w3_rec_var0.userAgent)
			]));
};
var $author$project$Internal$Model2$w3_encode_State = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				function (w3_rec_var0) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$lamdera$codecs$Lamdera$Wire3$encodeSet$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.added),
							$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.keyframes),
							$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.rules)
						]));
			}(v0)
			]));
};
var $author$project$Ui$Anim$w3_encode_State = $author$project$Internal$Model2$w3_encode_State;
var $author$project$Types$w3_encode_LinkDiscordFailure = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Discord$w3_encode_HttpError(v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Types$w3_encode_AdminStatusLoginData = function (w3v) {
	switch (w3v.$) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Pages$Admin$w3_encode_InitAdminData(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Types$w3_encode_LoginData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Types$w3_encode_AdminStatusLoginData(w3_rec_var0.adminData),
				$lamdera$containers$SeqDict$encodeDict$($author$project$Call$w3_encode_CallId, $author$project$Call$w3_encode_RecordingStatus, w3_rec_var0.callRecordings),
				$author$project$UserSession$w3_encode_Viewing(w3_rec_var0.currentlyViewing),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_CustomEmojiId),
				$author$project$CustomEmoji$w3_encode_CustomEmojiData,
				w3_rec_var0.customEmojis),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_PrivateChannelId),
				$author$project$DmChannel$w3_encode_DiscordFrontendDmChannel,
				w3_rec_var0.discordDmChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Discord$w3_encode_Id($author$project$Discord$w3_encode_GuildId),
				$author$project$LocalState$w3_encode_DiscordFrontendGuild,
				w3_rec_var0.discordGuilds),
				$author$project$LinkedAndOtherDiscordUsers$w3_encode_LinkedAndOtherDiscordUsers(w3_rec_var0.discordUsers),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				$author$project$DmChannel$w3_encode_FrontendDmChannel,
				w3_rec_var0.dmChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_GuildId),
				$author$project$LocalState$w3_encode_FrontendGuild,
				w3_rec_var0.guilds),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_UserId),
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_TeamId),
				w3_rec_var0.linkedSlackUsers),
				$lamdera$containers$SeqDict$encodeDict$($author$project$SessionIdHash$w3_encode_SessionIdHash, $author$project$UserSession$w3_encode_FrontendUserSession, w3_rec_var0.otherSessions),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
				$author$project$User$w3_encode_FrontendUser,
				w3_rec_var0.otherUsers),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.publicVapidKey),
				$author$project$UserSession$w3_encode_UserSession(w3_rec_var0.session),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_DmChannelId),
				$author$project$LocalState$w3_encode_SlackFrontendDmChannel,
				w3_rec_var0.slackDmChannels),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_UserId),
				$author$project$UserSession$w3_encode_SlackFrontendUser,
				w3_rec_var0.slackUsers),
				$lamdera$containers$SeqSet$encodeSet$(
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_UserId),
				w3_rec_var0.slackUsersNeedingAuth),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Slack$w3_encode_Id($author$project$Slack$w3_encode_TeamId),
				$author$project$LocalState$w3_encode_SlackFrontendWorkspace,
				w3_rec_var0.slackWorkspaces),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_StickerId),
				$author$project$Sticker$w3_encode_StickerData,
				w3_rec_var0.stickers),
				$author$project$TextEditor$w3_encode_LocalState(w3_rec_var0.textEditor),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.twoFactorAuthenticationEnabled),
				$author$project$User$w3_encode_FrontendCurrentUser(w3_rec_var0.user),
				$lamdera$containers$SeqDict$encodeDict$(
				$author$project$Call$w3_encode_CallId,
				A2(
					$author$project$NonemptyDict$w3_encode_NonemptyDict,
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
						$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId),
					$author$project$Call$w3_encode_RemoteCallData),
				w3_rec_var0.voiceChatPeers)
			]));
};
var $author$project$Types$w3_encode_LoginResult = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Types$w3_encode_LoginData(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
	}
};
var $author$project$Go$w3_encode_PublicGoMatchResponse = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeArray$($author$project$Go$w3_encode_ActionWithTime, w3_rec_var0.actions),
				$author$project$User$w3_encode_FrontendUser(w3_rec_var0.creatorUser),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$User$w3_encode_FrontendUser, w3_rec_var0.joinedUser),
				$author$project$Go$w3_encode_ValidatedSetup(w3_rec_var0.setup)
			]));
};
var $author$project$AiChat$w3_encode_AiResponse = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.content),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeFloat, w3_rec_var0.cost),
				$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.images),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, w3_rec_var0.reasoning)
			]));
};
var $author$project$AiChat$w3_encode_ToFrontend = function (w3v) {
	var v0 = w3v.a;
	var v1 = w3v.b;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$author$project$AiChat$w3_encode_ResponseId(v0),
				$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Http$w3_encode_Error, $author$project$AiChat$w3_encode_AiResponse, v1)
			]));
};
var $author$project$ImageEditor$w3_encode_ToFrontend = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0)
				]));
	} else {
		return $elm$bytes$Bytes$Encode$unsignedInt8(1);
	}
};
var $author$project$Pages$Admin$w3_encode_ExportSubset = function (w3v) {
	if (w3v.$ === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Pages$Admin$w3_encode_ExportSubsetSelection(v0)
				]));
	}
};
var $author$project$Pages$Admin$w3_encode_ToFrontend = function (w3v) {
	switch (w3v.$) {
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$LocalState$w3_encode_BackupContents(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeBytes(v2)
					]));
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Pages$Admin$w3_encode_ExportSubset(v0),
						$author$project$Pages$Admin$w3_encode_ExportProgress(v1)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$codecs$Lamdera$Wire3$encodeUnit, $lamdera$codecs$Lamdera$Wire3$encodeUnit, v0)
					]));
	}
};
var $author$project$TwoFactorAuthentication$w3_encode_ToFrontend = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v1)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v1)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.qrCodeUrl)
								]));
					}(v0)
					]));
	}
};
var $author$project$Types$w3_encode_ToFrontend = function (w3v) {
	switch (w3v.$) {
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Pages$Admin$w3_encode_ToFrontend(v0)
					]));
		case 9:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$AiChat$w3_encode_ToFrontend(v0)
					]));
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Types$w3_encode_LocalMsg(v0)
					]));
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Types$w3_encode_LoginType(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$codecs$Lamdera$Wire3$encodeUnit, $author$project$Types$w3_encode_LoginData, v1)
					]));
		case 16:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.fileName),
									$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.json)
								]));
					}(v0)
					]));
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 15:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$codecs$Lamdera$Wire3$encodeUnit, $author$project$Go$w3_encode_PublicGoMatchResponse, v0)
					]));
		case 17:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$(
						$author$project$Types$w3_encode_ImportChannelError,
						function (w3_rec_var0) {
							return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
								_List_fromArray(
									[
										$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.encryptedMessages)
									]));
						},
						v1)
					]));
		case 12:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($author$project$Types$w3_encode_LinkDiscordFailure, $lamdera$codecs$Lamdera$Wire3$encodeUnit, v0)
					]));
		case 13:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Types$w3_encode_LinkSlackResult(v0)
					]));
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Local$w3_encode_ChangeId(v0),
						$author$project$Types$w3_encode_LocalChange(v1)
					]));
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$Types$w3_encode_LoginResult(v0)
					]));
		case 14:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$author$project$ImageEditor$w3_encode_ToFrontend(v0)
					]));
		case 11:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$codecs$Lamdera$Wire3$encodeUnit, $author$project$Types$w3_encode_LoginData, v0)
					]));
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(15);
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$author$project$TwoFactorAuthentication$w3_encode_ToFrontend(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId(v0)
					]));
	}
};
var $author$project$Types$w3_encode_LoadedFrontend = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$AiChat$w3_encode_FrontendModel(w3_rec_var0.aiChatModel),
				$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId(w3_rec_var0.clientId),
				$author$project$Touch$w3_encode_Drag(w3_rec_var0.drag),
				$author$project$Touch$w3_encode_Drag(w3_rec_var0.dragPrevious),
				$author$project$Ui$Anim$w3_encode_State(w3_rec_var0.elmUiState),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Emoji$w3_encode_CachedEmojiData, w3_rec_var0.emojiData),
				function (w3_rec_var1) {
				return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
					_List_fromArray(
						[
							$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var1.changedAt),
							$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var1.index),
							$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var1.rotate)
						]));
			}(w3_rec_var0.homePagePreview),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$ImageViewer$w3_encode_Model, w3_rec_var0.imageViewer),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$MyUi$w3_encode_LastCopy, w3_rec_var0.lastCopied),
				$author$project$Types$w3_encode_LoginStatus(w3_rec_var0.loginStatus),
				$author$project$Types$w3_encode_LoginType(w3_rec_var0.loginType),
				$lamdera$program_test$Effect$Browser$Navigation$w3_encode_Key(w3_rec_var0.navigationKey),
				$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.pageHasFocus),
				$lamdera$codecs$Lamdera$Wire3$encodeResult$($author$project$Audio$w3_encode_LoadError, $author$project$Audio$w3_encode_Source, w3_rec_var0.popSound),
				$author$project$Types$w3_encode_PublicGoMatch(w3_rec_var0.publicGoMatch),
				$author$project$Route$w3_encode_Route(w3_rec_var0.route),
				$author$project$Ports$w3_encode_StartupData(w3_rec_var0.startupData),
				$lamdera$program_test$Effect$Time$w3_encode_Posix(w3_rec_var0.time),
				$lamdera$program_test$Effect$Time$w3_encode_Zone(w3_rec_var0.timezone),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
				$lamdera$codecs$Lamdera$Wire3$encodeArray($author$project$Types$w3_encode_ToFrontend),
				w3_rec_var0.toFrontendLogs),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.versionNumber),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.visualViewportHeight),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.visualViewportTop),
				A2($author$project$Coord$w3_encode_Coord, $author$project$CssPixels$w3_encode_CssPixels, w3_rec_var0.windowSize)
			]));
};
var $author$project$Types$w3_encode_LoadStatus = function (w3v) {
	switch (w3v.$) {
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Types$w3_encode_LoginData(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Types$w3_encode_LoadingFrontend = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Lamdera$w3_encode_ClientId, w3_rec_var0.clientId),
				$author$project$Types$w3_encode_LoadStatus(w3_rec_var0.loginStatus),
				$author$project$Types$w3_encode_LoginType(w3_rec_var0.loginType),
				$lamdera$program_test$Effect$Browser$Navigation$w3_encode_Key(w3_rec_var0.navigationKey),
				$lamdera$codecs$Lamdera$Wire3$encodeResult$($author$project$Audio$w3_encode_LoadError, $author$project$Audio$w3_encode_Source, w3_rec_var0.popSound),
				$author$project$Types$w3_encode_PublicGoMatch(w3_rec_var0.publicGoMatch),
				$author$project$Route$w3_encode_Route(w3_rec_var0.route),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Ports$w3_encode_StartupData, w3_rec_var0.startupData),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$program_test$Effect$Time$w3_encode_Posix, w3_rec_var0.time),
				A2($author$project$Coord$w3_encode_Coord, $author$project$CssPixels$w3_encode_CssPixels, w3_rec_var0.windowSize)
			]));
};
var $author$project$Types$w3_encode_FrontendModel_ = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Types$w3_encode_LoadedFrontend(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Types$w3_encode_LoadingFrontend(v0)
				]));
	}
};
var $author$project$Id$w3_encode_ExportChannelId = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v1),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v2)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_PrivateChannelId, v1)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelId, v1)
					]));
	}
};
var $author$project$Call$w3_encode_FromJs = function (w3v) {
	switch (w3v.$) {
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Call$w3_encode_DebugSection, v0)
					]));
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Call$w3_encode_MediaDevice, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						$author$project$IdString$w3_encode_IdString($author$project$Call$w3_encode_MediaDeviceId),
						v1)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 7:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1)
					]));
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Call$w3_encode_LocalOrConnection(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v1)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
	}
};
var $author$project$FileStatus$w3_encode_MeasuredFile = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					A2($author$project$Coord$w3_encode_Coord, $author$project$CssPixels$w3_encode_CssPixels, v0)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					A2($author$project$Coord$w3_encode_Coord, $author$project$CssPixels$w3_encode_CssPixels, v0),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($ianmackenzie$elm_units$Duration$w3_encode_Duration, v1)
				]));
	}
};
var $author$project$Encryption$w3_encode_FromJs$ = function (w3_x_c_a, w3v) {
	switch (w3v.$) {
		case 10:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Id$w3_encode_Id$($author$project$Encryption$w3_encode_EncryptFileRequestId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 9:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Id$w3_encode_Id$($author$project$Encryption$w3_encode_EncryptFileRequestId, v0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeBytes(w3_rec_var0.data),
									$lamdera$codecs$Lamdera$Wire3$encodeBytes(w3_rec_var0.key),
									$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$FileStatus$w3_encode_MeasuredFile, w3_rec_var0.measured),
									$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeBytes, w3_rec_var0.thumbnail)
								]));
					}(v1)
					]));
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Id$w3_encode_Id$($author$project$Encryption$w3_encode_DecryptManyRequestId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						A2($lamdera$codecs$Lamdera$Wire3$encodeResult, $lamdera$codecs$Lamdera$Wire3$encodeUnit, w3_x_c_a),
						v1)
					]));
		case 8:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Id$w3_encode_Id$($author$project$Encryption$w3_encode_EncryptManyRequestId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 7:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Id$w3_encode_Id$($author$project$Encryption$w3_encode_EncryptManyRequestId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						$author$project$Encryption$w3_encode_EncryptedData(w3_x_c_a),
						v1)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Id$w3_encode_Id$($author$project$Encryption$w3_encode_DecryptRequestId, v0)
					]));
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Id$w3_encode_Id$($author$project$Encryption$w3_encode_DecryptRequestId, v0),
						w3_x_c_a(v1)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Id$w3_encode_Id$($author$project$Encryption$w3_encode_EncryptRequestId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Id$w3_encode_Id$($author$project$Encryption$w3_encode_EncryptRequestId, v0),
						$author$project$Encryption$w3_encode_EncryptedData$(w3_x_c_a, v1)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0)
					]));
	}
};
var $author$project$Encryption$w3_encode_FromJs = F2($author$project$Encryption$w3_encode_FromJs$);
var $author$project$RichText$w3_encode_PressedImageId = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Id$w3_encode_Id$($author$project$FileStatus$w3_encode_FileId, v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
				]));
	}
};
var $author$project$RichText$w3_encode_PressedImageData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.displayWidth),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.fileUrl),
				$author$project$RichText$w3_encode_PressedImageId(w3_rec_var0.imageId),
				A2($author$project$Coord$w3_encode_Coord, $author$project$CssPixels$w3_encode_CssPixels, w3_rec_var0.imageSize),
				A3($author$project$Point2d$w3_encode_Point2d, $author$project$CssPixels$w3_encode_CssPixels, $author$project$Touch$w3_encode_ScreenCoordinate, w3_rec_var0.position)
			]));
};
var $author$project$MessageView$w3_encode_MessageViewMsg = function (w3v) {
	switch (w3v.$) {
		case 17:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 18:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 16:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Emoji$w3_encode_EmojiOrCustomEmoji(v0)
					]));
		case 12:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 13:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0),
						A2($author$project$Coord$w3_encode_Coord, $author$project$CssPixels$w3_encode_CssPixels, v1)
					]));
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v2),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, v3),
						A2($author$project$Coord$w3_encode_Coord, $author$project$CssPixels$w3_encode_CssPixels, v4)
					]));
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		case 15:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 22:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						A3($author$project$Point2d$w3_encode_Point2d, $author$project$CssPixels$w3_encode_CssPixels, $author$project$Touch$w3_encode_ScreenCoordinate, v0),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $lamdera$codecs$Lamdera$Wire3$encodeFloat, v1)
					]));
		case 25:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelId, v0),
						$author$project$Id$w3_encode_ThreadRoute(v1)
					]));
		case 27:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 21:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$justinmimbs$date$Date$w3_encode_Date(v0),
						A3($author$project$Point2d$w3_encode_Point2d, $author$project$CssPixels$w3_encode_CssPixels, $author$project$Touch$w3_encode_ScreenCoordinate, v1),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $lamdera$codecs$Lamdera$Wire3$encodeFloat, v2)
					]));
		case 26:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v0),
						$author$project$Id$w3_encode_ThreadRoute(v1)
					]));
		case 24:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$author$project$RichText$w3_encode_PressedImageData(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$elm$url$Url$w3_encode_Url(v0)
					]));
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(19),
						$author$project$Emoji$w3_encode_EmojiOrCustomEmoji(v0)
					]));
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(20),
						$author$project$Emoji$w3_encode_EmojiOrCustomEmoji(v0)
					]));
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(21);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(22),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 20:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(23),
						A3($author$project$Point2d$w3_encode_Point2d, $author$project$CssPixels$w3_encode_CssPixels, $author$project$Touch$w3_encode_ScreenCoordinate, v0),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $lamdera$codecs$Lamdera$Wire3$encodeFloat, v1)
					]));
		case 19:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(24),
						A3($author$project$Point2d$w3_encode_Point2d, $author$project$CssPixels$w3_encode_CssPixels, $author$project$Touch$w3_encode_ScreenCoordinate, v0),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeFloat, $lamdera$codecs$Lamdera$Wire3$encodeFloat, v1)
					]));
		case 23:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(25),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0)
					]));
		case 14:
			return $elm$bytes$Bytes$Encode$unsignedInt8(26);
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(27),
						$ianmackenzie$elm_units$Duration$w3_encode_Duration(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v2),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v3),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, v4),
						$author$project$NonemptyDict$w3_encode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$Touch$w3_encode_Touch, v5)
					]));
	}
};
var $author$project$AiChat$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 13:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 15:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$AiChat$w3_encode_ResponseId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 17:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$(
						$lamdera$program_test$Effect$Http$w3_encode_Error,
						$lamdera$codecs$Lamdera$Wire3$encodeList($author$project$AiChat$w3_encode_AiModel),
						v0)
					]));
		case 14:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 16:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$AiChat$w3_encode_ResponseId(v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$AiChat$w3_encode_ResponseId(v0)
					]));
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 11:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$AiChat$w3_encode_ResponseId(v0)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
		case 9:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$author$project$AiChat$w3_encode_AiModelName(v1)
					]));
		case 12:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$author$project$AiChat$w3_encode_SendMessageWith(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
	}
};
var $author$project$Call$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 11:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Call$w3_encode_ConnectionId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v1)
					]));
		case 14:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 12:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Call$w3_encode_LocalOrConnection(v0)
					]));
		case 13:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Call$w3_encode_LocalOrConnection(v0)
					]));
		case 18:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 9:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 10:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Call$w3_encode_CallId(v0)
					]));
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 17:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		case 16:
			return $elm$bytes$Bytes$Encode$unsignedInt8(12);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(14);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(15);
		case 15:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$author$project$Call$w3_encode_VideoTile(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$author$project$IdString$w3_encode_IdString$($author$project$Call$w3_encode_MediaDeviceId, v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$author$project$IdString$w3_encode_IdString$($author$project$Call$w3_encode_MediaDeviceId, v0)
					]));
	}
};
var $author$project$Drawing$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
						function (w3_rec_var0) {
							return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
								_List_fromArray(
									[
										$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.height),
										$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.width),
										$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.x),
										$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.y)
									]));
						},
						v0)
					]));
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v1)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v1)
					]));
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
	}
};
var $author$project$Editable$w3_encode_Msg$ = function (w3_x_c_value, w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Editable$w3_encode_Model(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					w3_x_c_value(v0)
				]));
	}
};
var $author$project$Editable$w3_encode_Msg = F2($author$project$Editable$w3_encode_Msg$);
var $author$project$Emoji$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$author$project$Emoji$w3_encode_EmojiOrSticker(v1)
					]));
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$author$project$Emoji$w3_encode_EmojiOrSticker(v1)
					]));
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Emoji$w3_encode_Category(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1)
					]));
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Emoji$w3_encode_EmojiOrSticker(v0)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Emoji$w3_encode_SkinTone, v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Emoji$w3_encode_Category(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
	}
};
var $author$project$Go$w3_encode_SpectatorMsg = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt, v0)
					]));
	}
};
var $author$project$Go$w3_encode_GameMsg = function (w3v) {
	switch (w3v.$) {
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt, v0)
					]));
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Go$w3_encode_SpectatorMsg(v0)
					]));
	}
};
var $author$project$MessageInput$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 14:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 13:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 9:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$($lamdera$program_test$Effect$File$w3_encode_File, v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.charsLeft)
								]));
					}(v0)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(12);
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$author$project$Range$w3_encode_Range(v0)
					]));
	}
};
var $author$project$FileStatus$w3_encode_UploadResponse = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$FileStatus$w3_encode_FileHash(w3_rec_var0.fileHash),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$FileStatus$w3_encode_ImageMetadata, w3_rec_var0.imageMetadata),
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$FileStatus$w3_encode_VideoMetadata, w3_rec_var0.videoMetadata)
			]));
};
var $author$project$SheepGame$w3_encode_GameMsg = function (w3v) {
	switch (w3v.$) {
		case 19:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v0)
					]));
		case 21:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
						v0)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v0),
						$author$project$Id$w3_encode_Id$($author$project$FileStatus$w3_encode_FileId, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Http$w3_encode_Error, $author$project$FileStatus$w3_encode_UploadResponse, v2)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v0),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$($lamdera$program_test$Effect$File$w3_encode_File, v1)
					]));
		case 11:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v0),
						$author$project$Id$w3_encode_Id$($author$project$FileStatus$w3_encode_FileId, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Http$w3_encode_Error, $author$project$FileStatus$w3_encode_UploadResponse, v2)
					]));
		case 10:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v0),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$($lamdera$program_test$Effect$File$w3_encode_File, v1)
					]));
		case 18:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v0)
					]));
		case 20:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
						v0)
					]));
		case 27:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 25:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v0),
						$author$project$Id$w3_encode_Id$($author$project$FileStatus$w3_encode_FileId, v1)
					]));
		case 12:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v0),
						$author$project$Id$w3_encode_Id$($author$project$FileStatus$w3_encode_FileId, v1)
					]));
		case 17:
			return $elm$bytes$Bytes$Encode$unsignedInt8(12);
		case 24:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$author$project$RichText$w3_encode_PressedImageData(v0)
					]));
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(14);
		case 26:
			return $elm$bytes$Bytes$Encode$unsignedInt8(15);
		case 15:
			return $elm$bytes$Bytes$Encode$unsignedInt8(16);
		case 16:
			return $elm$bytes$Bytes$Encode$unsignedInt8(17);
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Id$w3_encode_Id$($author$project$FileStatus$w3_encode_FileId, w3_rec_var0.fileId),
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.removeSpoiler)
								]));
					}(v1)
					]));
		case 14:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(19),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Id$w3_encode_Id$($author$project$FileStatus$w3_encode_FileId, w3_rec_var0.fileId),
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.removeSpoiler)
								]));
					}(v1)
					]));
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(20);
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(21),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v0),
						$author$project$Id$w3_encode_Id$($author$project$FileStatus$w3_encode_FileId, v1)
					]));
		case 13:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(22),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v0),
						$author$project$Id$w3_encode_Id$($author$project$FileStatus$w3_encode_FileId, v1)
					]));
		case 23:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(23),
						$author$project$SheepGame$w3_encode_ReactionTarget(v0),
						$author$project$MessageView$w3_encode_MessageViewMsg(v1)
					]));
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(24),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v0),
						$author$project$MessageInput$w3_encode_Msg(v1)
					]));
		case 8:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(25),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v2)
					]));
		case 9:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(26),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v0),
						$author$project$MessageInput$w3_encode_Msg(v1)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(27),
						$author$project$Scroll$w3_encode_ScrollPosition(v0)
					]));
	}
};
var $author$project$WordSpellingGame$w3_encode_GameMsg = function (w3v) {
	switch (w3v.$) {
		case 16:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$(
						$lamdera$program_test$Effect$Http$w3_encode_Error,
						$lamdera$codecs$Lamdera$Wire3$encodeList($author$project$WordSpellingGame$w3_encode_DictEntry),
						v1)
					]));
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0)
					]));
		case 8:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						A2(
							$lamdera$codecs$Lamdera$Wire3$encodePair,
							A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeInt, $lamdera$codecs$Lamdera$Wire3$encodeInt),
							$author$project$WordSpellingGame$w3_encode_LetterOrWildcard),
						v1),
						$author$project$WordSpellingGame$w3_encode_Shared(v2)
					]));
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0)
					]));
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 15:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 14:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0)
					]));
		case 13:
			return $elm$bytes$Bytes$Encode$unsignedInt8(10);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		case 11:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$WordSpellingGame$w3_encode_PlacedWord(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$author$project$WordSpellingGame$w3_encode_PlacedWord(v0)
					]));
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(14);
		case 12:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$($lamdera$codecs$Lamdera$Wire3$encodeString, v0)
					]));
		case 17:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$author$project$WordSpellingGame$w3_encode_ReactionTarget(v0),
						$author$project$MessageView$w3_encode_MessageViewMsg(v1)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$author$project$Scroll$w3_encode_ScrollPosition(v0)
					]));
	}
};
var $author$project$Go$w3_encode_SetupMsg = function (w3v) {
	switch (w3v.$) {
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Go$w3_encode_Stone(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Go$w3_encode_SizeSelection(v0)
					]));
	}
};
var $author$project$SheepGame$w3_encode_SetupMsg = function (w3v) {
	switch (w3v.$) {
		case 6:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v0),
						$author$project$Id$w3_encode_Id$($author$project$FileStatus$w3_encode_FileId, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Http$w3_encode_Error, $author$project$FileStatus$w3_encode_UploadResponse, v2)
					]));
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v0),
						$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$($lamdera$program_test$Effect$File$w3_encode_File, v1)
					]));
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 7:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v0),
						$author$project$Id$w3_encode_Id$($author$project$FileStatus$w3_encode_FileId, v1)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v0)
					]));
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 9:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Id$w3_encode_Id$($author$project$FileStatus$w3_encode_FileId, w3_rec_var0.fileId),
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.removeSpoiler)
								]));
					}(v1)
					]));
		case 8:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v0),
						$author$project$Id$w3_encode_Id$($author$project$FileStatus$w3_encode_FileId, v1)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_QuestionId, v0),
						$author$project$MessageInput$w3_encode_Msg(v1)
					]));
	}
};
var $author$project$WordSpellingGame$w3_encode_SetupMsg = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeChar(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$OneOrGreater$w3_encode_OneOrGreater(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$WordSpellingGame$w3_encode_Language(v0)
					]));
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
	}
};
var $author$project$Game$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Go$w3_encode_GameMsg(v0)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Go$w3_encode_SetupMsg(v0)
					]));
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 9:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 10:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Message$w3_encode_GameType(v0)
					]));
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v0)
					]));
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v0)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$SheepGame$w3_encode_GameMsg(v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$SheepGame$w3_encode_SetupMsg(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$WordSpellingGame$w3_encode_GameMsg(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$WordSpellingGame$w3_encode_SetupMsg(v0)
					]));
	}
};
var $author$project$Ports$w3_encode_CropImageDataResponse = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.croppedImageUrl),
				$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.requestId)
			]));
};
var $author$project$ImageEditor$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 9:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$codecs$Lamdera$Wire3$encodeString, $author$project$Ports$w3_encode_CropImageDataResponse, v0)
					]));
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_encode_Error, $lamdera$program_test$Effect$Browser$Dom$w3_encode_Element, v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v1)
					]));
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v1)
					]));
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 7:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(9);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$lamdera$program_test$Effect$File$w3_encode_File(v0)
					]));
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Http$w3_encode_Error, $author$project$FileStatus$w3_encode_UploadResponse, v0)
					]));
	}
};
var $author$project$ImageViewer$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 11:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$ianmackenzie$elm_units$Duration$w3_encode_Duration(v0)
					]));
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v1)
					]));
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v1)
					]));
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(6);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(8);
		case 9:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeFloat, $lamdera$codecs$Lamdera$Wire3$encodeFloat),
						v0)
					]));
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeFloat, $lamdera$codecs$Lamdera$Wire3$encodeFloat),
						v0)
					]));
		default:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v2)
					]));
	}
};
var $author$project$LoginForm$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
	}
};
var $author$project$Table$w3_encode_Msg = function (w3v) {
	if (w3v.$ === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
				]));
	}
};
var $author$project$Pages$Admin$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 19:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Editable$w3_encode_Msg$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$codecs$Lamdera$Wire3$encodeInt),
						v0)
					]));
		case 5:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Pages$Admin$w3_encode_UserTableId(v0),
						$author$project$Pages$Admin$w3_encode_UserColumn(v1)
					]));
		case 7:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Pages$Admin$w3_encode_UserTableId(v0),
						$author$project$Pages$Admin$w3_encode_UserColumn(v1)
					]));
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		case 55:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeBytes(v0)
					]));
		case 54:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$lamdera$program_test$Effect$File$w3_encode_File(v0)
					]));
		case 36:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$Editable$w3_encode_Msg$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe(
							$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId)),
						v0)
					]));
		case 35:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Editable$w3_encode_Msg$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$codecs$Lamdera$Wire3$encodeString),
						v0)
					]));
		case 34:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Editable$w3_encode_Msg$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$codecs$Lamdera$Wire3$encodeString),
						v0)
					]));
		case 37:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Editable$w3_encode_Msg$($author$project$Postmark$w3_encode_ApiKey, v0)
					]));
		case 12:
			return $elm$bytes$Bytes$Encode$unsignedInt8(11);
		case 52:
			return $elm$bytes$Bytes$Encode$unsignedInt8(12);
		case 51:
			return $elm$bytes$Bytes$Encode$unsignedInt8(13);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$author$project$Id$w3_encode_Id$($author$project$Pagination$w3_encode_ItemId, v0)
					]));
		case 42:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 23:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_PrivateChannelId, v0)
					]));
		case 24:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v0)
					]));
		case 30:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0)
					]));
		case 59:
			return $elm$bytes$Bytes$Encode$unsignedInt8(19);
		case 57:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(20),
						$author$project$SessionIdHash$w3_encode_SessionIdHash(v0)
					]));
		case 28:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(21),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_DmChannelId, v0)
					]));
		case 26:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(22),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_TeamId, v0)
					]));
		case 13:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(23),
						$author$project$Pages$Admin$w3_encode_UserTableId(v0)
					]));
		case 56:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(24),
						$author$project$SessionIdHash$w3_encode_SessionIdHash(v0),
						$lamdera$program_test$Effect$Lamdera$w3_encode_ClientId(v1)
					]));
		case 46:
			return $elm$bytes$Bytes$Encode$unsignedInt8(25);
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(26),
						$author$project$Pages$Admin$w3_encode_UserTableId(v0),
						$author$project$Pages$Admin$w3_encode_UserColumn(v1)
					]));
		case 25:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(27),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v0)
					]));
		case 29:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(28),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(29),
						$author$project$Pages$Admin$w3_encode_AdminUiSection(v0)
					]));
		case 27:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(30),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_TeamId, v0)
					]));
		case 44:
			return $elm$bytes$Bytes$Encode$unsignedInt8(31);
		case 45:
			return $elm$bytes$Bytes$Encode$unsignedInt8(32);
		case 38:
			return $elm$bytes$Bytes$Encode$unsignedInt8(33);
		case 53:
			return $elm$bytes$Bytes$Encode$unsignedInt8(34);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(35),
						$author$project$Id$w3_encode_Id$($author$project$Pagination$w3_encode_PageId, v0)
					]));
		case 58:
			return $elm$bytes$Bytes$Encode$unsignedInt8(36);
		case 39:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(37),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v1),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v2)
					]));
		case 40:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(38),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_PrivateChannelId, v1)
					]));
		case 41:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(39),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v1)
					]));
		case 14:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(40),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0)
					]));
		case 10:
			return $elm$bytes$Bytes$Encode$unsignedInt8(41);
		case 31:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(42),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0)
					]));
		case 8:
			return $elm$bytes$Bytes$Encode$unsignedInt8(43);
		case 61:
			return $elm$bytes$Bytes$Encode$unsignedInt8(44);
		case 60:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(45),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 33:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(46),
						$author$project$Editable$w3_encode_Msg$($author$project$LocalState$w3_encode_PrivateVapidKey, v0)
					]));
		case 32:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(47),
						$author$project$Editable$w3_encode_Msg$($lamdera$codecs$Lamdera$Wire3$encodeString, v0)
					]));
		case 21:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(48),
						$author$project$Editable$w3_encode_Msg$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$codecs$Lamdera$Wire3$encodeInt),
						v0)
					]));
		case 9:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(49),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 22:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(50),
						$author$project$Pages$Admin$w3_encode_UserTableId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v1)
					]));
		case 18:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(51),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 16:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(52),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 50:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(53),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_PrivateChannelId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v1)
					]));
		case 49:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(54),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v1)
					]));
		case 48:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(55),
						$author$project$DmChannelId$w3_encode_DmChannelId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v1)
					]));
		case 47:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(56),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v1)
					]));
		case 17:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(57),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 20:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(58),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(59),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 43:
			return $elm$bytes$Bytes$Encode$unsignedInt8(60);
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(61),
						$author$project$Table$w3_encode_Msg(v0)
					]));
	}
};
var $author$project$RecoveryLogin$w3_encode_Msg = function (w3v) {
	if (w3v.$ === 1) {
		return $elm$bytes$Bytes$Encode$unsignedInt8(0);
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
				]));
	}
};
var $author$project$TextEditor$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
	}
};
var $author$project$TwoFactorAuthentication$w3_encode_Msg = function (w3v) {
	switch (w3v.$) {
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
	}
};
var $author$project$Internal$Teleport$w3_encode_CssAnimation = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.hash),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.keyframes),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.keyframesHash),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				A2($lamdera$codecs$Lamdera$Wire3$encodePair, $lamdera$codecs$Lamdera$Wire3$encodeString, $lamdera$codecs$Lamdera$Wire3$encodeString),
				w3_rec_var0.props),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.transition),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.trigger)
			]));
};
var $author$project$Internal$Teleport$w3_encode_ParentTriggerDetails = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Internal$Teleport$w3_encode_CssAnimation, w3_rec_var0.children),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.identifierClass),
				$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.trigger)
			]));
};
var $author$project$Internal$Teleport$w3_encode_Data = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Internal$Teleport$w3_encode_CssAnimation(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$Internal$Teleport$w3_encode_ParentTriggerDetails(v0)
				]));
	}
};
var $author$project$Internal$Teleport$w3_encode_Event = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$Internal$Teleport$w3_encode_Data, w3_rec_var0.data),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.timestamp)
			]));
};
var $author$project$Internal$Teleport$w3_encode_Trigger = function (w3v) {
	switch (w3v) {
		case 4:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 5:
			return $elm$bytes$Bytes$Encode$unsignedInt8(1);
		case 2:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
		case 3:
			return $elm$bytes$Bytes$Encode$unsignedInt8(3);
		case 0:
			return $elm$bytes$Bytes$Encode$unsignedInt8(4);
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
	}
};
var $author$project$Internal$Model2$w3_encode_Msg = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Internal$Teleport$w3_encode_Trigger(v0),
					$author$project$Internal$Teleport$w3_encode_Event(v1)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					function (t) {
					return $lamdera$codecs$Lamdera$Wire3$encodeInt(
						$elm$time$Time$posixToMillis(t));
				}(v0)
				]));
	}
};
var $author$project$Ui$Anim$w3_encode_Msg = $author$project$Internal$Model2$w3_encode_Msg;
var $author$project$Types$w3_encode_FrontendMsg_ = function (w3v) {
	switch (w3v.$) {
		case 8:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$author$project$Pages$Admin$w3_encode_Msg(v0)
					]));
		case 76:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$AiChat$w3_encode_Msg(v0)
					]));
		case 54:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$ianmackenzie$elm_units$Duration$w3_encode_Duration(v0)
					]));
		case 71:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			var v5 = w3v.f;
			var v6 = w3v.g;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0),
						$author$project$Id$w3_encode_AnyGuildOrDmId(v1),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v2),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v3),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v4),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeString, v5),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, v6)
					]));
		case 49:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Ports$w3_encode_NotificationPermission(v0)
					]));
		case 79:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Id$w3_encode_GuildOrDmId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1)
					]));
		case 78:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$Id$w3_encode_GuildOrDmId(v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v1),
						$author$project$SheepGame$w3_encode_Input(v2),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v3)
					]));
		case 37:
			return $elm$bytes$Bytes$Encode$unsignedInt8(7);
		case 153:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$program_test$Effect$Browser$Dom$w3_encode_HtmlId),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe(
							A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Range$w3_encode_Range, $author$project$Range$w3_encode_SelectionDirection)),
						v0)
					]));
		case 164:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Drawing$w3_encode_Msg(v0)
					]));
		case 16:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelId, v1),
						$author$project$Types$w3_encode_EditChannelForm(v2)
					]));
		case 20:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$Types$w3_encode_EditGuildForm(v1)
					]));
		case 94:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Id$w3_encode_AnyGuildOrDmId, $author$project$Id$w3_encode_ThreadRoute, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Id$w3_encode_Id$($author$project$FileStatus$w3_encode_FileId, v2),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Http$w3_encode_Error, $author$project$FileStatus$w3_encode_UploadResponse, v3)
					]));
		case 146:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$author$project$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Id$w3_encode_ThreadRoute(v1),
						$author$project$MessageInput$w3_encode_Msg(v2)
					]));
		case 90:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Id$w3_encode_AnyGuildOrDmId, $author$project$Id$w3_encode_ThreadRoute, v0),
						$author$project$Id$w3_encode_Id$($author$project$FileStatus$w3_encode_FileId, v1)
					]));
		case 92:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Id$w3_encode_AnyGuildOrDmId, $author$project$Id$w3_encode_ThreadRoute, v0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Id$w3_encode_Id$($author$project$FileStatus$w3_encode_FileId, w3_rec_var0.fileId),
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.removeSpoiler)
								]));
					}(v1)
					]));
		case 91:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Id$w3_encode_AnyGuildOrDmId, $author$project$Id$w3_encode_ThreadRoute, v0),
						$author$project$Id$w3_encode_Id$($author$project$FileStatus$w3_encode_FileId, v1)
					]));
		case 93:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Id$w3_encode_AnyGuildOrDmId, $author$project$Id$w3_encode_ThreadRoute, v0),
						$lamdera$program_test$Effect$File$w3_encode_File(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$program_test$Effect$File$w3_encode_File, v2)
					]));
		case 10:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$author$project$Ui$Anim$w3_encode_Msg(v0)
					]));
		case 45:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(19),
						$author$project$Emoji$w3_encode_Msg(v0)
					]));
		case 151:
			return $elm$bytes$Bytes$Encode$unsignedInt8(20);
		case 186:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(21),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$(
						$lamdera$codecs$Lamdera$Wire3$encodeString,
						$author$project$Encryption$w3_encode_FromJs(
							$author$project$Message$w3_encode_MessageContent$(
								$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_UserId),
								$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_ChannelId))),
						v0)
					]));
		case 158:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(22),
						$ianmackenzie$elm_units$Duration$w3_encode_Duration(v0)
					]));
		case 159:
			return $elm$bytes$Bytes$Encode$unsignedInt8(23);
		case 160:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(24),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$program_test$Effect$File$w3_encode_File, v0)
					]));
		case 95:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(25),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Id$w3_encode_AnyGuildOrDmId, $author$project$Id$w3_encode_ThreadRoute, v0),
						$author$project$Id$w3_encode_Id$($author$project$FileStatus$w3_encode_FileId, v1),
						$lamdera$program_test$Effect$Http$w3_encode_Progress(v2)
					]));
		case 32:
			return $elm$bytes$Bytes$Encode$unsignedInt8(26);
		case 77:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(27),
						$author$project$Game$w3_encode_Msg(v0)
					]));
		case 80:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(28),
						$author$project$Go$w3_encode_SpectatorMsg(v0)
					]));
		case 109:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(29),
						$lamdera$codecs$Lamdera$Wire3$encodeFloat(v0)
					]));
		case 148:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(30),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Http$w3_encode_Error, $author$project$Emoji$w3_encode_CachedEmojiData, v0)
					]));
		case 86:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(31),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Id$w3_encode_AnyGuildOrDmId, $author$project$Id$w3_encode_ThreadRoute, v0),
						$author$project$Id$w3_encode_Id$($author$project$FileStatus$w3_encode_FileId, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$FileStatus$w3_encode_FileMetadata, v2),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Http$w3_encode_Error, $author$project$FileStatus$w3_encode_UploadResponse, v3)
					]));
		case 85:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(32),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Id$w3_encode_AnyGuildOrDmId, $author$project$Id$w3_encode_ThreadRoute, v0),
						$author$project$Id$w3_encode_Id$($author$project$FileStatus$w3_encode_FileId, v1),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v2),
						$lamdera$codecs$Lamdera$Wire3$encodeBytes(v3)
					]));
		case 26:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(33),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.fileName),
									$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.json)
								]));
					}(v1)
					]));
		case 38:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(34),
						$lamdera$program_test$Effect$Browser$Dom$w3_encode_HtmlId(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_encode_Error, $author$project$MessageInput$w3_encode_MentionUserDropdown, v1)
					]));
		case 149:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(35),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_encode_Error, $lamdera$program_test$Effect$Browser$Dom$w3_encode_Element, v0)
					]));
		case 150:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(36),
						$author$project$SheepGame$w3_encode_Input(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_encode_Error, $lamdera$program_test$Effect$Browser$Dom$w3_encode_Element, v1)
					]));
		case 98:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(37),
						$author$project$Ports$w3_encode_RegisterPushSubscription(v0)
					]));
		case 163:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(38),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 124:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(39),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 108:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(40),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$codecs$Lamdera$Wire3$encodeString, $author$project$Ports$w3_encode_StartupData, v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(41),
						$lamdera$program_test$Effect$Time$w3_encode_Posix(v0)
					]));
		case 135:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(42),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$codecs$Lamdera$Wire3$encodeUnit, $lamdera$codecs$Lamdera$Wire3$encodeInt, v0)
					]));
		case 155:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(43),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$codecs$Lamdera$Wire3$encodeString, $author$project$Call$w3_encode_FromJs, v0)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(44),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1)
					]));
		case 83:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(45),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$ImageEditor$w3_encode_Msg(v1)
					]));
		case 97:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(46),
						$author$project$ImageViewer$w3_encode_Msg(v0)
					]));
		case 41:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(47),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.ctrlKey),
									$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.key),
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.metaKey),
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.shiftKey)
								]));
					}(v0)
					]));
		case 166:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(48),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($author$project$Audio$w3_encode_LoadError, $author$project$Audio$w3_encode_Source, v0)
					]));
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(49),
						$author$project$LoginForm$w3_encode_Msg(v0)
					]));
		case 147:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(50),
						$author$project$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Id$w3_encode_ThreadRoute(v1),
						$author$project$MessageInput$w3_encode_Msg(v2)
					]));
		case 55:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(51),
						$ianmackenzie$elm_units$Duration$w3_encode_Duration(v0)
					]));
		case 64:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(52),
						$author$project$NonemptySet$w3_encode_NonemptySet$(
						$author$project$Id$w3_encode_Id($author$project$Id$w3_encode_CustomEmojiId),
						v0)
					]));
		case 68:
			return $elm$bytes$Bytes$Encode$unsignedInt8(53);
		case 69:
			return $elm$bytes$Bytes$Encode$unsignedInt8(54);
		case 62:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(55),
						$author$project$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 44:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(56),
						$author$project$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 63:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(57),
						$author$project$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 66:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(58),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_PrivateChannelId, v1)
					]));
		case 65:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(59),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0)
					]));
		case 47:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(60),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v0)
					]));
		case 43:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(61),
						$author$project$Emoji$w3_encode_EmojiOrCustomEmoji(v0)
					]));
		case 46:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(62),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v0)
					]));
		case 42:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(63),
						$author$project$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v1),
						A2($author$project$Coord$w3_encode_Coord, $author$project$CssPixels$w3_encode_CssPixels, v2)
					]));
		case 96:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(64),
						$author$project$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v1),
						$author$project$MessageView$w3_encode_MessageViewMsg(v2)
					]));
		case 14:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(65),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$Types$w3_encode_NewChannelForm(v1)
					]));
		case 35:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(66),
						$author$project$Types$w3_encode_NewGuildForm(v0)
					]));
		case 84:
			return $elm$bytes$Bytes$Encode$unsignedInt8(67);
		case 123:
			return $elm$bytes$Bytes$Encode$unsignedInt8(68);
		case 122:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(69),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 154:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(70),
						$lamdera$codecs$Lamdera$Wire3$encodeResult$($lamdera$program_test$Effect$Browser$Dom$w3_encode_Error, $lamdera$program_test$Effect$Browser$Dom$w3_encode_Viewport, v0)
					]));
		case 103:
			return $elm$bytes$Bytes$Encode$unsignedInt8(71);
		case 137:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(72),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 113:
			return $elm$bytes$Bytes$Encode$unsignedInt8(73);
		case 30:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(74),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v1)
					]));
		case 61:
			return $elm$bytes$Bytes$Encode$unsignedInt8(75);
		case 118:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(76),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0)
					]));
		case 70:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(77),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Id$w3_encode_AnyGuildOrDmId, $author$project$Id$w3_encode_ThreadRoute, v0)
					]));
		case 57:
			return $elm$bytes$Bytes$Encode$unsignedInt8(78);
		case 157:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(79),
						$author$project$UserSession$w3_encode_ChannelHeaderTab(v0)
					]));
		case 104:
			return $elm$bytes$Bytes$Encode$unsignedInt8(80);
		case 136:
			return $elm$bytes$Bytes$Encode$unsignedInt8(81);
		case 110:
			return $elm$bytes$Bytes$Encode$unsignedInt8(82);
		case 114:
			return $elm$bytes$Bytes$Encode$unsignedInt8(83);
		case 73:
			return $elm$bytes$Bytes$Encode$unsignedInt8(84);
		case 48:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(85),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Id$w3_encode_AnyGuildOrDmId, $author$project$Id$w3_encode_ThreadRoute, v0)
					]));
		case 145:
			return $elm$bytes$Bytes$Encode$unsignedInt8(86);
		case 34:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(87),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 33:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(88),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 28:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(89),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0)
					]));
		case 120:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(90),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0)
					]));
		case 102:
			return $elm$bytes$Bytes$Encode$unsignedInt8(91);
		case 87:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(92),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Id$w3_encode_AnyGuildOrDmId, $author$project$Id$w3_encode_ThreadRoute, v0),
						$author$project$Id$w3_encode_Id$($author$project$FileStatus$w3_encode_FileId, v1)
					]));
		case 19:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(93),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelId, v1)
					]));
		case 23:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(94),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0)
					]));
		case 29:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(95),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$SecretId$w3_encode_SecretId$($author$project$Id$w3_encode_InviteLinkId, v1)
					]));
		case 119:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(96),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0)
					]));
		case 129:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(97),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 133:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(98),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, w3_rec_var0.currentUserId),
									$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, w3_rec_var0.otherUserId)
								]));
					}(v0)
					]));
		case 106:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(99),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v1),
						$author$project$User$w3_encode_NotificationLevel(v2)
					]));
		case 116:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(100),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 117:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(101),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0)
					]));
		case 74:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(102),
						$author$project$UserSession$w3_encode_UserOptionSection(v0)
					]));
		case 115:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(103),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0)
					]));
		case 112:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(104),
						$author$project$Id$w3_encode_ExportChannelId(v0)
					]));
		case 105:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(105),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$User$w3_encode_NotificationLevel(v1)
					]));
		case 59:
			return $elm$bytes$Bytes$Encode$unsignedInt8(106);
		case 7:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(107),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 24:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(108),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0)
					]));
		case 27:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(109),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0)
					]));
		case 12:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(110),
						$author$project$Route$w3_encode_Route(v0)
					]));
		case 162:
			return $elm$bytes$Bytes$Encode$unsignedInt8(111);
		case 9:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(112),
						$author$project$SessionIdHash$w3_encode_SessionIdHash(v0)
					]));
		case 177:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(113),
						$lamdera$codecs$Lamdera$Wire3$encodeList$(
						A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Id$w3_encode_AnyGuildOrDmId, $author$project$Id$w3_encode_ThreadRouteWithMessage),
						v0)
					]));
		case 176:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(114),
						$author$project$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Id$w3_encode_ThreadRouteWithMessage(v1)
					]));
		case 111:
			return $elm$bytes$Bytes$Encode$unsignedInt8(115);
		case 172:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(116),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelId, v1),
						$author$project$MuteSettings$w3_encode_IsMuted(v2)
					]));
		case 174:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(117),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v1),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v2),
						$author$project$MuteSettings$w3_encode_IsMuted(v3)
					]));
		case 179:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(118),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v1),
						$author$project$MuteSettings$w3_encode_IsMuted(v2)
					]));
		case 175:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(119),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v1),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v2),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v3),
						$author$project$MuteSettings$w3_encode_IsMuted(v4)
					]));
		case 178:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(120),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$MuteSettings$w3_encode_IsMuted(v1)
					]));
		case 181:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(121),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_UserId, v0),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_TeamId, v1),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_ChannelId, v2),
						$author$project$MuteSettings$w3_encode_IsMuted(v3)
					]));
		case 182:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			var v4 = w3v.e;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(122),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_UserId, v0),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_TeamId, v1),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_ChannelId, v2),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v3),
						$author$project$MuteSettings$w3_encode_IsMuted(v4)
					]));
		case 180:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(123),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_UserId, v0),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_TeamId, v1),
						$author$project$MuteSettings$w3_encode_IsMuted(v2)
					]));
		case 173:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(124),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelId, v1),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v2),
						$author$project$MuteSettings$w3_encode_IsMuted(v3)
					]));
		case 165:
			return $elm$bytes$Bytes$Encode$unsignedInt8(125);
		case 125:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(126),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 131:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(127),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0)
					]));
		case 192:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(128),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_UserId, v0)
					]));
		case 189:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(129),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_TeamId, v0)
					]));
		case 144:
			return $elm$bytes$Bytes$Encode$unsignedInt8(130);
		case 17:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(131),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelId, v1)
					]));
		case 21:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(132),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0)
					]));
		case 142:
			return $elm$bytes$Bytes$Encode$unsignedInt8(133);
		case 143:
			return $elm$bytes$Bytes$Encode$unsignedInt8(134);
		case 169:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(135),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 170:
			return $elm$bytes$Bytes$Encode$unsignedInt8(136);
		case 171:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(137),
						$author$project$Route$w3_encode_Route(v0)
					]));
		case 139:
			return $elm$bytes$Bytes$Encode$unsignedInt8(138);
		case 6:
			return $elm$bytes$Bytes$Encode$unsignedInt8(139);
		case 58:
			return $elm$bytes$Bytes$Encode$unsignedInt8(140);
		case 167:
			return $elm$bytes$Bytes$Encode$unsignedInt8(141);
		case 72:
			return $elm$bytes$Bytes$Encode$unsignedInt8(142);
		case 130:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(143),
						$lamdera$codecs$Lamdera$Wire3$encodeBool(v0)
					]));
		case 107:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(144),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_UserId, v0),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_TeamId, v1),
						$author$project$User$w3_encode_NotificationLevel(v2)
					]));
		case 18:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(145),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelId, v1),
						$author$project$Types$w3_encode_EditChannelForm(v2)
					]));
		case 22:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(146),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$Types$w3_encode_EditGuildForm(v1)
					]));
		case 15:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(147),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$Types$w3_encode_NewChannelForm(v1)
					]));
		case 36:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(148),
						$author$project$Types$w3_encode_NewGuildForm(v0)
					]));
		case 190:
			return $elm$bytes$Bytes$Encode$unsignedInt8(149);
		case 141:
			return $elm$bytes$Bytes$Encode$unsignedInt8(150);
		case 89:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(151),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Id$w3_encode_AnyGuildOrDmId, $author$project$Id$w3_encode_ThreadRoute, v0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Id$w3_encode_Id$($author$project$FileStatus$w3_encode_FileId, w3_rec_var0.fileId),
									$lamdera$codecs$Lamdera$Wire3$encodeBool(w3_rec_var0.removeSpoiler)
								]));
					}(v1)
					]));
		case 31:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(152),
						$author$project$SecretId$w3_encode_SecretId$($author$project$Id$w3_encode_InviteLinkId, v0)
					]));
		case 132:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(153),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0)
					]));
		case 191:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(154),
						$author$project$Slack$w3_encode_Id$($author$project$Slack$w3_encode_UserId, v0)
					]));
		case 161:
			return $elm$bytes$Bytes$Encode$unsignedInt8(155);
		case 88:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(156),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Id$w3_encode_AnyGuildOrDmId, $author$project$Id$w3_encode_ThreadRoute, v0),
						$author$project$Id$w3_encode_Id$($author$project$FileStatus$w3_encode_FileId, v1)
					]));
		case 82:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(157),
						$author$project$ImageEditor$w3_encode_Msg(v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(158),
						$author$project$RecoveryLogin$w3_encode_Msg(v0)
					]));
		case 40:
			return $elm$bytes$Bytes$Encode$unsignedInt8(159);
		case 127:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(160),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.bottom),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.top)
								]));
					}(v0)
					]));
		case 11:
			return $elm$bytes$Bytes$Encode$unsignedInt8(161);
		case 67:
			return $elm$bytes$Bytes$Encode$unsignedInt8(162);
		case 100:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(163),
						$author$project$User$w3_encode_EmailNotifications(v0)
					]));
		case 101:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(164),
						$author$project$User$w3_encode_EmbedVisibility(v0)
					]));
		case 13:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(165),
						$lamdera$codecs$Lamdera$Wire3$encodePair$($author$project$Id$w3_encode_AnyGuildOrDmId, $author$project$Id$w3_encode_ThreadRoute, v0),
						$lamdera$program_test$Effect$File$w3_encode_File(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeList$($lamdera$program_test$Effect$File$w3_encode_File, v2)
					]));
		case 25:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(166),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$lamdera$program_test$Effect$File$w3_encode_File(v1)
					]));
		case 99:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(167),
						$author$project$UserSession$w3_encode_NotificationMode(v0)
					]));
		case 140:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(168),
						$author$project$UserColor$w3_encode_Selection(v0)
					]));
		case 39:
			return $elm$bytes$Bytes$Encode$unsignedInt8(169);
		case 56:
			return $elm$bytes$Bytes$Encode$unsignedInt8(170);
		case 128:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(171),
						$author$project$TextEditor$w3_encode_Msg(v0)
					]));
		case 152:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(172),
						$lamdera$codecs$Lamdera$Wire3$encodePair$(
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe($lamdera$program_test$Effect$Browser$Dom$w3_encode_HtmlId),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe(
							A2($lamdera$codecs$Lamdera$Wire3$encodePair, $author$project$Range$w3_encode_Range, $author$project$Range$w3_encode_SelectionDirection)),
						v0)
					]));
		case 53:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(173),
						$ianmackenzie$elm_units$Duration$w3_encode_Duration(v0)
					]));
		case 52:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(174),
						$ianmackenzie$elm_units$Duration$w3_encode_Duration(v0)
					]));
		case 51:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(175),
						$ianmackenzie$elm_units$Duration$w3_encode_Duration(v0),
						$author$project$NonemptyDict$w3_encode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$Touch$w3_encode_Touch, v1)
					]));
		case 50:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(176),
						$ianmackenzie$elm_units$Duration$w3_encode_Duration(v0),
						$author$project$NonemptyDict$w3_encode_NonemptyDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$Touch$w3_encode_Touch, v1)
					]));
		case 75:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(177),
						$author$project$TwoFactorAuthentication$w3_encode_Msg(v0)
					]));
		case 134:
			return $elm$bytes$Bytes$Encode$unsignedInt8(178);
		case 138:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(179),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 121:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(180),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_UserId, v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1)
					]));
		case 168:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(181),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 187:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(182),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 188:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(183),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
					]));
		case 183:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(184),
						$author$project$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v1),
						$author$project$MessageView$w3_encode_MessageViewMsg(v2)
					]));
		case 184:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(185),
						$author$project$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelMessageId, v1),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ThreadMessageId, v2),
						$author$project$MessageView$w3_encode_MessageViewMsg(v3)
					]));
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(186),
						$elm$url$Url$w3_encode_Url(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(187),
						$elm$browser$Browser$w3_encode_UrlRequest(v0)
					]));
		case 81:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(188),
						$author$project$Editable$w3_encode_Msg$($author$project$PersonName$w3_encode_PersonName, v0)
					]));
		case 60:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(189),
						$author$project$Id$w3_encode_AnyGuildOrDmId(v0),
						$author$project$Id$w3_encode_ThreadRoute(v1),
						$author$project$Scroll$w3_encode_ScrollPosition(v2)
					]));
		case 185:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(190),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v0),
						$author$project$Types$w3_encode_E2eeKeysValid(v1)
					]));
		case 126:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(191),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.height),
									$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.top)
								]));
					}(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(192),
						$author$project$Call$w3_encode_Msg(v0)
					]));
	}
};
var $author$project$Audio$w3_encode_AudioLoadRequest_ = function (w3_x_c_userMsg) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.audioUrl),
					$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$(
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						A2($lamdera$codecs$Lamdera$Wire3$encodeResult, $author$project$Audio$w3_encode_LoadError, $author$project$Audio$w3_encode_Source),
						w3_x_c_userMsg),
					w3_rec_var0.userMsg)
				]));
	};
};
var $author$project$Audio$w3_encode_LoopConfig = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var0.loopEnd),
				$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var0.loopStart)
			]));
};
var $author$project$Audio$w3_encode_FlattenedAudio = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$Audio$w3_encode_LoopConfig, w3_rec_var0.loop),
				$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var0.offset),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.playbackRate),
				$author$project$Audio$w3_encode_Source(w3_rec_var0.source),
				$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var0.startAt),
				function (t) {
				return $lamdera$codecs$Lamdera$Wire3$encodeInt(
					$elm$time$Time$posixToMillis(t));
			}(w3_rec_var0.startTime),
				$lamdera$codecs$Lamdera$Wire3$encodeFloat(w3_rec_var0.volume),
				$lamdera$codecs$Lamdera$Wire3$encodeList$(
				$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty(
					A2(
						$lamdera$codecs$Lamdera$Wire3$encodePair,
						function (t) {
							return $lamdera$codecs$Lamdera$Wire3$encodeInt(
								$elm$time$Time$posixToMillis(t));
						},
						$lamdera$codecs$Lamdera$Wire3$encodeFloat)),
				w3_rec_var0.volumeTimelines)
			]));
};
var $author$project$Audio$w3_encode_NodeGroupId = $lamdera$codecs$Lamdera$Wire3$encodeInt;
var $author$project$Audio$w3_encode_SourceData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var0.duration)
			]));
};
var $author$project$Audio$w3_encode_Model_$ = function (w3_x_c_userMsg, w3_x_c_userModel) {
	return function (w3_rec_var0) {
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$lamdera$codecs$Lamdera$Wire3$encodeDict$($author$project$Audio$w3_encode_NodeGroupId, $author$project$Audio$w3_encode_FlattenedAudio, w3_rec_var0.audioState),
					$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.nodeGroupIdCounter),
					$lamdera$codecs$Lamdera$Wire3$encodeDict$(
					$lamdera$codecs$Lamdera$Wire3$encodeInt,
					$author$project$Audio$w3_encode_AudioLoadRequest_(w3_x_c_userMsg),
					w3_rec_var0.pendingRequests),
					$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.requestCount),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($lamdera$codecs$Lamdera$Wire3$encodeInt, w3_rec_var0.samplesPerSecond),
					$lamdera$codecs$Lamdera$Wire3$encodeDict$($lamdera$codecs$Lamdera$Wire3$encodeInt, $author$project$Audio$w3_encode_SourceData, w3_rec_var0.sourceData),
					w3_x_c_userModel(w3_rec_var0.userModel)
				]));
	};
};
var $author$project$Audio$w3_encode_Model_ = F2($author$project$Audio$w3_encode_Model_$);
var $author$project$Audio$w3_encode_Model$ = function (w3_x_c_userMsg, w3_x_c_userModel, w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				A3($author$project$Audio$w3_encode_Model_, w3_x_c_userMsg, w3_x_c_userModel, v0)
			]));
};
var $author$project$Audio$w3_encode_Model = F3($author$project$Audio$w3_encode_Model$);
var $author$project$Types$w3_encode_FrontendModel = A2($author$project$Audio$w3_encode_Model, $author$project$Types$w3_encode_FrontendMsg_, $author$project$Types$w3_encode_FrontendModel_);
var $author$project$Audio$w3_encode_FromJSMsg = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Audio$w3_encode_LoadError(w3_rec_var0.error),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.requestId)
								]));
					}(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$author$project$Audio$w3_encode_BufferId(w3_rec_var0.bufferId),
									$ianmackenzie$elm_units$Duration$w3_encode_Duration(w3_rec_var0.duration),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.requestId)
								]));
					}(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.samplesPerSecond)
								]));
					}(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.error)
								]));
					}(v0)
					]));
	}
};
var $author$project$Audio$w3_encode_Msg$ = function (w3_x_c_userMsg, w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Audio$w3_encode_FromJSMsg(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					w3_x_c_userMsg(v0)
				]));
	}
};
var $author$project$Audio$w3_encode_Msg = F2($author$project$Audio$w3_encode_Msg$);
var $author$project$Types$w3_encode_FrontendMsg = $author$project$Audio$w3_encode_Msg($author$project$Types$w3_encode_FrontendMsg_);
var $author$project$Types$w3_encode_InitialLoadRequest = function (w3v) {
	switch (w3v.$) {
		case 4:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
						$author$project$Id$w3_encode_Id($author$project$Pagination$w3_encode_PageId),
						v0)
					]));
		case 3:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_PrivateChannelId, v1)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_UserId, v0),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_GuildId, v1),
						$author$project$Discord$w3_encode_Id$($author$project$Discord$w3_encode_ChannelId, v2),
						$author$project$Id$w3_encode_ThreadRoute(v3)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$DmChannelId$w3_encode_DmChannelId(v0),
						$author$project$Id$w3_encode_ThreadRoute(v1),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$UserSession$w3_encode_ChannelHeaderTab, v2)
					]));
		case 0:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			var v3 = w3v.d;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_ChannelId, v1),
						$author$project$Id$w3_encode_ThreadRoute(v2),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$UserSession$w3_encode_ChannelHeaderTab, v3)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(5);
	}
};
var $author$project$Slack$w3_encode_SlackCookie = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Slack$w3_encode_SlackToken = function (w3v) {
	var v0 = w3v;
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$elm$bytes$Bytes$Encode$unsignedInt8(0),
				$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
			]));
};
var $author$project$Slack$w3_encode_SlackData = function (w3_rec_var0) {
	return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
		_List_fromArray(
			[
				$author$project$Slack$w3_encode_SlackCookie(w3_rec_var0.cookie),
				$mgold$elm_nonempty_list$List$Nonempty$w3_encode_Nonempty$($author$project$Slack$w3_encode_SlackToken, w3_rec_var0.tokens)
			]));
};
var $author$project$AiChat$w3_encode_Message = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodeString(v0)
				]));
	}
};
var $author$project$AiChat$w3_encode_ToBackend = function (w3v) {
	if (!w3v.$) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		var v2 = w3v.c;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$AiChat$w3_encode_AiModelName(v0),
					$author$project$AiChat$w3_encode_ResponseId(v1),
					$lamdera$codecs$Lamdera$Wire3$encodeList$($author$project$AiChat$w3_encode_Message, v2)
				]));
	} else {
		var v0 = w3v.a;
		var v1 = w3v.b;
		var v2 = w3v.c;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$author$project$AiChat$w3_encode_AiModelName(v0),
					$author$project$AiChat$w3_encode_ResponseId(v1),
					$lamdera$codecs$Lamdera$Wire3$encodeString(v2)
				]));
	}
};
var $author$project$ImageEditor$w3_encode_ToBackend = function (w3v) {
	if (w3v.$ === 1) {
		var v0 = w3v.a;
		var v1 = w3v.b;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(0),
					$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$FileStatus$w3_encode_FileHash, v1)
				]));
	} else {
		var v0 = w3v.a;
		return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
			_List_fromArray(
				[
					$elm$bytes$Bytes$Encode$unsignedInt8(1),
					$lamdera$codecs$Lamdera$Wire3$encodeMaybe$($author$project$FileStatus$w3_encode_FileHash, v0)
				]));
	}
};
var $author$project$Pages$Admin$w3_encode_ToBackend = function (w3v) {
	switch (w3v.$) {
		case 1:
			return $elm$bytes$Bytes$Encode$unsignedInt8(0);
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Pages$Admin$w3_encode_ExportSubset(v0)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.offset),
									$lamdera$codecs$Lamdera$Wire3$encodeInt(w3_rec_var0.totalBytes)
								]));
					}(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeBytes(v1)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Pages$Admin$w3_encode_TypeThatIsAlwaysInvalid(v0)
					]));
	}
};
var $author$project$TwoFactorAuthentication$w3_encode_ToBackend = function (w3v) {
	switch (w3v.$) {
		case 1:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		case 2:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v0)
					]));
		default:
			return $elm$bytes$Bytes$Encode$unsignedInt8(2);
	}
};
var $author$project$Types$w3_encode_ToBackend = function (w3v) {
	switch (w3v.$) {
		case 16:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(0),
						$lamdera$codecs$Lamdera$Wire3$encodeMaybe$(
						$author$project$Id$w3_encode_Id($author$project$Pagination$w3_encode_PageId),
						v0)
					]));
		case 5:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(1),
						$author$project$Pages$Admin$w3_encode_ToBackend(v0)
					]));
		case 11:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(2),
						$author$project$AiChat$w3_encode_ToBackend(v0)
					]));
		case 0:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(3),
						$author$project$Types$w3_encode_InitialLoadRequest(v0)
					]));
		case 18:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(4),
						$author$project$Id$w3_encode_ExportChannelId(v0)
					]));
		case 10:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(5),
						$author$project$Types$w3_encode_InitialLoadRequest(v0),
						$author$project$PersonName$w3_encode_PersonName(v1),
						$author$project$UserAgent$w3_encode_UserAgent(v2)
					]));
		case 3:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(6),
						$author$project$EmailAddress$w3_encode_EmailAddress(v0)
					]));
		case 17:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(7),
						$author$project$SecretId$w3_encode_SecretId$($author$project$Id$w3_encode_GamePublicId, v0)
					]));
		case 19:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(8),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						function (w3_rec_var0) {
						return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
							_List_fromArray(
								[
									$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.fileName),
									$lamdera$codecs$Lamdera$Wire3$encodeString(w3_rec_var0.json)
								]));
					}(v1)
					]));
		case 9:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(9),
						$author$project$Id$w3_encode_Id$($author$project$Id$w3_encode_GuildId, v0),
						$author$project$SecretId$w3_encode_SecretId$($author$project$Id$w3_encode_InviteLinkId, v1)
					]));
		case 13:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(10),
						$author$project$Discord$w3_encode_UserAuth(v0)
					]));
		case 14:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(11),
						$author$project$Slack$w3_encode_SlackData(v0)
					]));
		case 7:
			var v0 = w3v.a;
			var v1 = w3v.b;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(12),
						$author$project$Local$w3_encode_ChangeId(v0),
						$author$project$Types$w3_encode_LocalChange(v1)
					]));
		case 6:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(13),
						$author$project$SessionIdHash$w3_encode_SessionIdHash(v0)
					]));
		case 4:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(14),
						$author$project$Types$w3_encode_InitialLoadRequest(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeString(v1),
						$author$project$UserAgent$w3_encode_UserAgent(v2)
					]));
		case 1:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(15),
						$author$project$Types$w3_encode_InitialLoadRequest(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1),
						$author$project$UserAgent$w3_encode_UserAgent(v2)
					]));
		case 2:
			var v0 = w3v.a;
			var v1 = w3v.b;
			var v2 = w3v.c;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(16),
						$author$project$Types$w3_encode_InitialLoadRequest(v0),
						$lamdera$codecs$Lamdera$Wire3$encodeInt(v1),
						$author$project$UserAgent$w3_encode_UserAgent(v2)
					]));
		case 15:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(17),
						$author$project$ImageEditor$w3_encode_ToBackend(v0)
					]));
		case 12:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(18),
						$author$project$Types$w3_encode_InitialLoadRequest(v0)
					]));
		default:
			var v0 = w3v.a;
			return $lamdera$codecs$Lamdera$Wire3$encodeSequenceWithoutLength(
				_List_fromArray(
					[
						$elm$bytes$Bytes$Encode$unsignedInt8(19),
						$author$project$TwoFactorAuthentication$w3_encode_ToBackend(v0)
					]));
	}
};
var $author$project$Types$w3_unsafe_decode_InitialLoadRequest = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Pagination$w3_unsafe_decode_PageId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$InitialLoadRequested_Admin));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_PrivateChannelId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$InitialLoadRequested_DiscordDm)));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_ThreadRoute,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_ChannelId),
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_GuildId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Discord$w3_unsafe_decode_Id($author$project$Discord$w3_unsafe_decode_UserId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$InitialLoadRequested_DiscordGuild)))));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$UserSession$w3_unsafe_decode_ChannelHeaderTab),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_ThreadRoute,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$DmChannelId$w3_unsafe_decode_DmChannelId,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$InitialLoadRequested_Dm))));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$UserSession$w3_unsafe_decode_ChannelHeaderTab),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_ThreadRoute,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_ChannelId),
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
								$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$InitialLoadRequested_Guild)))));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$InitialLoadRequested_None);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Slack$w3_unsafe_decode_SlackCookie = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Slack$w3_unsafe_decode_SlackToken = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		if (!w3v) {
			return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
				$lamdera$codecs$Lamdera$Wire3$decodeString,
				$lamdera$codecs$Lamdera$Wire3$succeedDecode($elm$core$Basics$identity));
		} else {
			return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Slack$w3_unsafe_decode_SlackData = $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
	$mgold$elm_nonempty_list$List$Nonempty$w3_unsafe_decode_Nonempty($author$project$Slack$w3_unsafe_decode_SlackToken),
	$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
		$author$project$Slack$w3_unsafe_decode_SlackCookie,
		$lamdera$codecs$Lamdera$Wire3$succeedDecode(
			F2(
				function (cookie0, tokens0) {
					return {cookie: cookie0, tokens: tokens0};
				}))));
var $author$project$AiChat$w3_unsafe_decode_Message = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$AiChat$ImageUrlMessage));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$AiChat$TextMessage));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$AiChat$w3_unsafe_decode_ToBackend = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeList($author$project$AiChat$w3_unsafe_decode_Message),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$AiChat$w3_unsafe_decode_ResponseId,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$AiChat$w3_unsafe_decode_AiModelName,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$AiChat$AiMessageRequest))));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeString,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$AiChat$w3_unsafe_decode_ResponseId,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$AiChat$w3_unsafe_decode_AiModelName,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$AiChat$AiMessageRequestSimple))));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$ImageEditor$w3_unsafe_decode_ToBackend = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$FileStatus$w3_unsafe_decode_FileHash),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageEditor$ChangeGuildIconRequest)));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe($author$project$FileStatus$w3_unsafe_decode_FileHash),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$ImageEditor$ChangeUserAvatarRequest));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Pages$Admin$w3_unsafe_decode_ToBackend = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$DownloadLastBackupRequest);
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Pages$Admin$w3_unsafe_decode_ExportSubset,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ExportBackendRequest));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeBytes,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeInt,
							$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
								$lamdera$codecs$Lamdera$Wire3$decodeInt,
								$lamdera$codecs$Lamdera$Wire3$succeedDecode(
									F2(
										function (offset0, totalBytes0) {
											return {offset: offset0, totalBytes: totalBytes0};
										})))),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$ImportBackendChunkRequest)));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Pages$Admin$w3_unsafe_decode_TypeThatIsAlwaysInvalid,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Pages$Admin$TypeThatIsAlwaysInvalidRequest));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$TwoFactorAuthentication$w3_unsafe_decode_ToBackend = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TwoFactorAuthentication$ConfirmTwoFactorAuthenticationRequest));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeInt,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TwoFactorAuthentication$DisableTwoFactorAuthenticationRequest));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$TwoFactorAuthentication$EnableTwoFactorAuthenticationRequest);
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$Types$w3_unsafe_decode_ToBackend = A2(
	$lamdera$codecs$Lamdera$Wire3$andThenDecode,
	function (w3v) {
		switch (w3v) {
			case 0:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$decodeMaybe(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Pagination$w3_unsafe_decode_PageId)),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$AdminDataRequest));
			case 1:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Pages$Admin$w3_unsafe_decode_ToBackend,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$AdminToBackend));
			case 2:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$AiChat$w3_unsafe_decode_ToBackend,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$AiChatToBackend));
			case 3:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Types$w3_unsafe_decode_InitialLoadRequest,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$CheckLoginRequest));
			case 4:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Id$w3_unsafe_decode_ExportChannelId,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$ExportChannelRequest));
			case 5:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserAgent$w3_unsafe_decode_UserAgent,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$PersonName$w3_unsafe_decode_PersonName,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Types$w3_unsafe_decode_InitialLoadRequest,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$FinishUserCreationRequest))));
			case 6:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$EmailAddress$w3_unsafe_decode_EmailAddress,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$GetLoginTokenRequest));
			case 7:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$SecretId$w3_unsafe_decode_SecretId($author$project$Id$w3_unsafe_decode_GamePublicId),
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$GetPublicGoMatchRequest));
			case 8:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$lamdera$codecs$Lamdera$Wire3$decodeString,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode(
								F2(
									function (fileName0, json0) {
										return {fileName: fileName0, json: json0};
									})))),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$ImportChannelRequest)));
			case 9:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$SecretId$w3_unsafe_decode_SecretId($author$project$Id$w3_unsafe_decode_InviteLinkId),
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Id$w3_unsafe_decode_Id($author$project$Id$w3_unsafe_decode_GuildId),
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$JoinGuildByInviteRequest)));
			case 10:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Discord$w3_unsafe_decode_UserAuth,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$LinkDiscordRequest));
			case 11:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Slack$w3_unsafe_decode_SlackData,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$LinkSlackRequest));
			case 12:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Types$w3_unsafe_decode_LocalChange,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$author$project$Local$w3_unsafe_decode_ChangeId,
						$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$LocalModelChangeRequest)));
			case 13:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$SessionIdHash$w3_unsafe_decode_SessionIdHash,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$LogOutRequest));
			case 14:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserAgent$w3_unsafe_decode_UserAgent,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeString,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Types$w3_unsafe_decode_InitialLoadRequest,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$LoginWithRecoveryPasswordRequest))));
			case 15:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserAgent$w3_unsafe_decode_UserAgent,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Types$w3_unsafe_decode_InitialLoadRequest,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$LoginWithTokenRequest))));
			case 16:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$UserAgent$w3_unsafe_decode_UserAgent,
					$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
						$lamdera$codecs$Lamdera$Wire3$decodeInt,
						$lamdera$codecs$Lamdera$Wire3$andMapDecode$(
							$author$project$Types$w3_unsafe_decode_InitialLoadRequest,
							$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$LoginWithTwoFactorRequest))));
			case 17:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$ImageEditor$w3_unsafe_decode_ToBackend,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$ProfilePictureEditorToBackend));
			case 18:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$Types$w3_unsafe_decode_InitialLoadRequest,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$ReloadDataRequest));
			case 19:
				return $lamdera$codecs$Lamdera$Wire3$andMapDecode$(
					$author$project$TwoFactorAuthentication$w3_unsafe_decode_ToBackend,
					$lamdera$codecs$Lamdera$Wire3$succeedDecode($author$project$Types$TwoFactorToBackend));
			default:
				return $lamdera$codecs$Lamdera$Wire3$failDecode;
		}
	},
	$elm$bytes$Bytes$Decode$unsignedInt8);
var $author$project$LFR$main = $author$project$LFR$application$(
	$author$project$Frontend$app,
	{createFinalSnapshot: $author$project$LFR$fecfs, decodeAndUpgradeFrontendModel: $author$project$LamderaGenerated$decodeAndUpgradeFrontendModel, decodeAndUpgradeFrontendMsg: $author$project$LamderaGenerated$decodeAndUpgradeFrontendMsg, decodeAndUpgradeToFrontend: $author$project$LamderaGenerated$decodeAndUpgradeToFrontend, decodeFrontendModel: $author$project$Types$w3_unsafe_decode_FrontendModel, decodeToBackend: $author$project$Types$w3_unsafe_decode_ToBackend, decodeToFrontend: $author$project$Types$w3_unsafe_decode_ToFrontend, encodeFrontendModel: $author$project$Types$w3_encode_FrontendModel, encodeFrontendMsg: $author$project$Types$w3_encode_FrontendMsg, encodeToBackend: $author$project$Types$w3_encode_ToBackend, encodeToFrontend: $author$project$Types$w3_encode_ToFrontend, enterUpgradeMode: $author$project$LFR$feeum, receiveRedirectMsg: $author$project$LFR$rrm, received_ToFrontend: $author$project$LFR$rfb, redirectMsg: $author$project$LFR$rm, sendToBackend: $author$project$LFR$stb, version: $author$project$LamderaGenerated$currentVersion});
_Platform_export({'LFR':{'init':$author$project$LFR$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (bv) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (b) {
					return $elm$json$Json$Decode$succeed(
						{b: b, bv: bv});
				},
				A2(
					$elm$json$Json$Decode$field,
					'b',
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $lamdera$codecs$Lamdera$Wire3$decodeBytes_)
							]))));
		},
		A2($elm$json$Json$Decode$field, 'bv', $elm$json$Json$Decode$int)))(0)}});function _Lamdera_inject(app) {
  app.die = app.stop;
}}(this));

